'use strict';
import * as $i_$0040codemirror$002fcommands from "@codemirror/commands";
import * as $i_$0040codemirror$002fstate from "@codemirror/state";
import * as $i_$0040codemirror$002fview from "@codemirror/view";
import * as $i_$0040viz$002djs$002flang$002ddot from "@viz-js/lang-dot";
import * as $i_$0040viz$002djs$002fviz from "@viz-js/viz";
import * as $i_codemirror from "codemirror";
import * as $i_mermaid from "mermaid";
import * as $i_three from "three";
import * as $i_three$002faddons$002fgeometries$002fConvexGeometry$002ejs from "three/addons/geometries/ConvexGeometry.js";
import * as $i_uuid from "uuid";
var $p;
var $fileLevelThis = this;
var $getOwnPropertyDescriptors = (Object.getOwnPropertyDescriptors || (() => {
  var ownKeysFun;
  if ((((typeof Reflect) !== "undefined") && Reflect.ownKeys)) {
    ownKeysFun = Reflect.ownKeys;
  } else {
    var getOwnPropertySymbols = (Object.getOwnPropertySymbols || ((o) => []));
    ownKeysFun = ((o) => Object.getOwnPropertyNames(o).concat(getOwnPropertySymbols(o)));
  }
  return ((o) => {
    var ownKeys = ownKeysFun(o);
    var descriptors = ({});
    var len = (ownKeys.length | 0);
    var i = 0;
    while ((i !== len)) {
      var key = ownKeys[i];
      Object.defineProperty(descriptors, key, ({
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": Object.getOwnPropertyDescriptor(o, key)
      }));
      i = ((i + 1) | 0);
    }
    return descriptors;
  });
})());
function $Char(c) {
  this.c = c;
}
$p = $Char.prototype;
$p.toString = (function() {
  return String.fromCharCode(this.c);
});
function $Long(lo, hi) {
  this.l = lo;
  this.h = hi;
}
$p = $Long.prototype;
$p.toString = (function() {
  return $s_RTLong__toString__I__I__T(this.l, this.h);
});
function $noIsInstance(arg0) {
  throw new TypeError("Cannot call isInstance() on a Class representing a JS trait/object");
}
function $objectClone(arg0) {
  return Object.create(Object.getPrototypeOf(arg0), $getOwnPropertyDescriptors(arg0));
}
function $objectOrArrayClone(arg0) {
  return (arg0.$classData.Z ? arg0.ae() : $objectClone(arg0));
}
function $objectGetClass(arg0) {
  switch ((typeof arg0)) {
    case "string": {
      return $d_T.l();
    }
    case "number": {
      if ($isInt(arg0)) {
        if ((((arg0 << 24) >> 24) === arg0)) {
          return $d_jl_Byte.l();
        } else if ((((arg0 << 16) >> 16) === arg0)) {
          return $d_jl_Short.l();
        } else {
          return $d_jl_Integer.l();
        }
      } else if ($isFloat(arg0)) {
        return $d_jl_Float.l();
      } else {
        return $d_jl_Double.l();
      }
    }
    case "boolean": {
      return $d_jl_Boolean.l();
    }
    case "undefined": {
      return $d_jl_Void.l();
    }
    default: {
      if ((arg0 instanceof $Long)) {
        return $d_jl_Long.l();
      } else if ((arg0 instanceof $Char)) {
        return $d_jl_Character.l();
      } else if ((!(!(arg0 && arg0.$classData)))) {
        return arg0.$classData.l();
      } else {
        return null;
      }
    }
  }
}
function $objectClassName(arg0) {
  switch ((typeof arg0)) {
    case "string": {
      return "java.lang.String";
    }
    case "number": {
      if ($isInt(arg0)) {
        if ((((arg0 << 24) >> 24) === arg0)) {
          return "java.lang.Byte";
        } else if ((((arg0 << 16) >> 16) === arg0)) {
          return "java.lang.Short";
        } else {
          return "java.lang.Integer";
        }
      } else if ($isFloat(arg0)) {
        return "java.lang.Float";
      } else {
        return "java.lang.Double";
      }
    }
    case "boolean": {
      return "java.lang.Boolean";
    }
    case "undefined": {
      return "java.lang.Void";
    }
    default: {
      if ((arg0 instanceof $Long)) {
        return "java.lang.Long";
      } else if ((arg0 instanceof $Char)) {
        return "java.lang.Character";
      } else if ((!(!(arg0 && arg0.$classData)))) {
        return arg0.$classData.N;
      } else {
        return null.bdc();
      }
    }
  }
}
function $dp_charAt__I__C(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__charAt__I__C(instance, x0);
  } else {
    return instance.y1(x0);
  }
}
function $dp_codePointAt__I__I(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__codePointAt__I__I(instance, x0);
  } else {
    return instance.bd6(x0);
  }
}
function $dp_compareTo__O__I(instance, x0) {
  switch ((typeof instance)) {
    case "string": {
      return $f_T__compareTo__O__I(instance, x0);
    }
    case "number": {
      return $f_jl_Double__compareTo__O__I(instance, x0);
    }
    case "boolean": {
      return $f_jl_Boolean__compareTo__O__I(instance, x0);
    }
    default: {
      if ((instance instanceof $Long)) {
        return $f_jl_Long__compareTo__O__I(instance.l, instance.h, x0);
      } else if ((instance instanceof $Char)) {
        return $f_jl_Character__compareTo__O__I(instance.c, x0);
      } else {
        return instance.pp(x0);
      }
    }
  }
}
function $dp_compareTo__T__I(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__compareTo__T__I(instance, x0);
  } else {
    return instance.bd7(x0);
  }
}
function $dp_compareToIgnoreCase__T__I(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__compareToIgnoreCase__T__I(instance, x0);
  } else {
    return instance.bd8(x0);
  }
}
function $dp_equals__O__Z(instance, x0) {
  switch ((typeof instance)) {
    case "string": {
      return $f_T__equals__O__Z(instance, x0);
    }
    case "number": {
      return $f_jl_Double__equals__O__Z(instance, x0);
    }
    case "boolean": {
      return $f_jl_Boolean__equals__O__Z(instance, x0);
    }
    case "undefined": {
      return $f_jl_Void__equals__O__Z(instance, x0);
    }
    default: {
      if (((!(!(instance && instance.$classData))) || (instance === null))) {
        return instance.e(x0);
      } else if ((instance instanceof $Long)) {
        return $f_jl_Long__equals__O__Z(instance.l, instance.h, x0);
      } else if ((instance instanceof $Char)) {
        return $f_jl_Character__equals__O__Z(instance.c, x0);
      } else {
        return $c_O.prototype.e.call(instance, x0);
      }
    }
  }
}
function $dp_getBytes__Ljava_nio_charset_Charset__AB(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__getBytes__Ljava_nio_charset_Charset__AB(instance, x0);
  } else {
    return instance.bdb(x0);
  }
}
function $dp_getChars__I__I__AC__I__V(instance, x0, x1, x2, x3) {
  if (((typeof instance) === "string")) {
    return $f_T__getChars__I__I__AC__I__V(instance, x0, x1, x2, x3);
  } else {
    return instance.aOP(x0, x1, x2, x3);
  }
}
function $dp_hashCode__I(instance) {
  switch ((typeof instance)) {
    case "string": {
      return $f_T__hashCode__I(instance);
    }
    case "number": {
      return $f_jl_Double__hashCode__I(instance);
    }
    case "boolean": {
      return $f_jl_Boolean__hashCode__I(instance);
    }
    case "undefined": {
      return $f_jl_Void__hashCode__I(instance);
    }
    default: {
      if (((!(!(instance && instance.$classData))) || (instance === null))) {
        return instance.x();
      } else if ((instance instanceof $Long)) {
        return $f_jl_Long__hashCode__I(instance.l, instance.h);
      } else if ((instance instanceof $Char)) {
        return $f_jl_Character__hashCode__I(instance.c);
      } else {
        return $c_O.prototype.x.call(instance);
      }
    }
  }
}
function $dp_indexOf__I__I(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__indexOf__I__I(instance, x0);
  } else {
    return instance.bde(x0);
  }
}
function $dp_indexOf__I__I__I(instance, x0, x1) {
  if (((typeof instance) === "string")) {
    return $f_T__indexOf__I__I__I(instance, x0, x1);
  } else {
    return instance.bdd(x0, x1);
  }
}
function $dp_length__I(instance) {
  if (((typeof instance) === "string")) {
    return $f_T__length__I(instance);
  } else {
    return instance.C();
  }
}
function $dp_repeat__I__T(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__repeat__I__T(instance, x0);
  } else {
    return instance.bdf(x0);
  }
}
function $dp_replaceAll__T__T__T(instance, x0, x1) {
  if (((typeof instance) === "string")) {
    return $f_T__replaceAll__T__T__T(instance, x0, x1);
  } else {
    return instance.bdg(x0, x1);
  }
}
function $dp_replaceFirst__T__T__T(instance, x0, x1) {
  if (((typeof instance) === "string")) {
    return $f_T__replaceFirst__T__T__T(instance, x0, x1);
  } else {
    return instance.bdh(x0, x1);
  }
}
function $dp_split__T__I__AT(instance, x0, x1) {
  if (((typeof instance) === "string")) {
    return $f_T__split__T__I__AT(instance, x0, x1);
  } else {
    return instance.bdi(x0, x1);
  }
}
function $dp_subSequence__I__I__jl_CharSequence(instance, x0, x1) {
  if (((typeof instance) === "string")) {
    return $f_T__subSequence__I__I__jl_CharSequence(instance, x0, x1);
  } else {
    return instance.Jp(x0, x1);
  }
}
function $dp_toCharArray__AC(instance) {
  if (((typeof instance) === "string")) {
    return $f_T__toCharArray__AC(instance);
  } else {
    return instance.aSS();
  }
}
function $dp_toString__T(instance) {
  return ((instance === (void 0)) ? "undefined" : instance.toString());
}
function $dp_trim__T(instance) {
  if (((typeof instance) === "string")) {
    return $f_T__trim__T(instance);
  } else {
    return instance.bdk();
  }
}
function $checkIntDivisor(arg0) {
  if ((arg0 === 0)) {
    throw new $c_jl_ArithmeticException("/ by zero");
  } else {
    return arg0;
  }
}
function $doubleToInt(arg0) {
  return ((arg0 > 2147483647) ? 2147483647 : ((arg0 < (-2147483648)) ? (-2147483648) : (arg0 | 0)));
}
function $cToS(arg0) {
  return String.fromCharCode(arg0);
}
var $fpBitsDataView = new DataView(new ArrayBuffer(8));
function $floatToBits(arg0) {
  var dataView = $fpBitsDataView;
  dataView.setFloat32(0, arg0, true);
  return dataView.getInt32(0, true);
}
function $floatFromBits(arg0) {
  var dataView = $fpBitsDataView;
  dataView.setInt32(0, arg0, true);
  return dataView.getFloat32(0, true);
}
function $doubleToBits(arg0) {
  var dataView = $fpBitsDataView;
  return $s_RTLong__fromDoubleBits__D__O__J(arg0, dataView);
}
function $doubleFromBits(arg0) {
  var dataView = $fpBitsDataView;
  return $s_RTLong__bitsToDouble__I__I__O__D(arg0.l, arg0.h, dataView);
}
function $resolveSuperRef(arg0, arg1) {
  var getPrototypeOf = Object.getPrototyeOf;
  var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  var superProto = arg0.prototype;
  while ((superProto !== null)) {
    var desc = getOwnPropertyDescriptor(superProto, arg1);
    if ((desc !== (void 0))) {
      return desc;
    }
    superProto = getPrototypeOf(superProto);
  }
}
function $superGet(arg0, arg1, arg2) {
  var desc = $resolveSuperRef(arg0, arg2);
  if ((desc !== (void 0))) {
    var getter = desc.get;
    return ((getter !== (void 0)) ? getter.call(arg1) : getter.value);
  }
}
function $superSet(arg0, arg1, arg2, arg3) {
  var desc = $resolveSuperRef(arg0, arg2);
  if ((desc !== (void 0))) {
    var setter = desc.set;
    if ((setter !== (void 0))) {
      setter.call(arg1, arg3);
      return (void 0);
    }
  }
  throw new TypeError((("super has no setter '" + arg2) + "'."));
}
function $arraycopyGeneric(arg0, arg1, arg2, arg3, arg4) {
  if (((arg0 !== arg2) || (((arg3 - arg1) >>> 0) > (arg4 >>> 0)))) {
    for (var i = 0; (i < arg4); i = ((i + 1) | 0)) {
      arg2[((arg3 + i) | 0)] = arg0[((arg1 + i) | 0)];
    }
  } else {
    for (var i = ((arg4 - 1) | 0); (i >= 0); i = ((i - 1) | 0)) {
      arg2[((arg3 + i) | 0)] = arg0[((arg1 + i) | 0)];
    }
  }
}
var $lastIDHash = 0;
var $idHashCodeMap = new WeakMap();
function $systemIdentityHashCode(obj) {
  switch ((typeof obj)) {
    case "string": {
      return $f_T__hashCode__I(obj);
    }
    case "number": {
      return $f_jl_Double__hashCode__I(obj);
    }
    case "bigint": {
      var biHash = 0;
      if ((obj < BigInt(0))) {
        obj = (~obj);
      }
      while ((obj !== BigInt(0))) {
        biHash = (biHash ^ Number(BigInt.asIntN(32, obj)));
        obj = (obj >> BigInt(32));
      }
      return biHash;
    }
    case "boolean": {
      return (obj ? 1231 : 1237);
    }
    case "undefined": {
      return 0;
    }
    case "symbol": {
      var description = obj.description;
      return ((description === (void 0)) ? 0 : $f_T__hashCode__I(description));
    }
    default: {
      if ((obj === null)) {
        return 0;
      } else {
        var hash = $idHashCodeMap.get(obj);
        if ((hash === (void 0))) {
          hash = (($lastIDHash + 1) | 0);
          $lastIDHash = hash;
          $idHashCodeMap.set(obj, hash);
        }
        return hash;
      }
    }
  }
}
function $isByte(arg0) {
  return ((((typeof arg0) === "number") && (((arg0 << 24) >> 24) === arg0)) && ((1 / arg0) !== (1 / (-0))));
}
function $isShort(arg0) {
  return ((((typeof arg0) === "number") && (((arg0 << 16) >> 16) === arg0)) && ((1 / arg0) !== (1 / (-0))));
}
function $isInt(arg0) {
  return ((((typeof arg0) === "number") && ((arg0 | 0) === arg0)) && ((1 / arg0) !== (1 / (-0))));
}
function $isFloat(arg0) {
  return (((typeof arg0) === "number") && ((arg0 !== arg0) || (Math.fround(arg0) === arg0)));
}
function $bC(arg0) {
  return new $Char(arg0);
}
var $bC0 = $bC(0);
function $bL(arg0, arg1) {
  return new $Long(arg0, arg1);
}
var $bL0 = $bL(0, 0);
function $uC(arg0) {
  return ((arg0 === null) ? 0 : arg0.c);
}
function $uJ(arg0) {
  return ((arg0 === null) ? $bL0 : arg0);
}
function $ct_O__($thiz) {
  return $thiz;
}
/** @constructor */
function $c_O() {
}
$p = $c_O.prototype;
$p.constructor = $c_O;
/** @constructor */
function $h_O() {
}
$h_O.prototype = $p;
$p.x = (function() {
  return $systemIdentityHashCode(this);
});
$p.e = (function(that) {
  return (this === that);
});
$p.m = (function() {
  var i = this.x();
  return (($objectClassName(this) + "@") + (i >>> 0.0).toString(16));
});
$p.toString = (function() {
  return this.m();
});
function $ac_O(arg) {
  if (((typeof arg) === "number")) {
    this.a = new Array(arg);
    for (var i = 0; (i < arg); (i++)) {
      this.a[i] = null;
    }
  } else {
    this.a = arg;
  }
}
$p = $ac_O.prototype = new $h_O();
$p.constructor = $ac_O;
$p.av = (function(srcPos, dest, destPos, length) {
  $arraycopyGeneric(this.a, srcPos, dest.a, destPos, length);
});
$p.ae = (function() {
  return new $ac_O(this.a.slice());
});
function $ah_O() {
}
$ah_O.prototype = $p;
function $ac_Z(arg) {
  if (((typeof arg) === "number")) {
    this.a = new Array(arg);
    for (var i = 0; (i < arg); (i++)) {
      this.a[i] = false;
    }
  } else {
    this.a = arg;
  }
}
$p = $ac_Z.prototype = new $h_O();
$p.constructor = $ac_Z;
$p.av = (function(srcPos, dest, destPos, length) {
  $arraycopyGeneric(this.a, srcPos, dest.a, destPos, length);
});
$p.ae = (function() {
  return new $ac_Z(this.a.slice());
});
function $ac_C(arg) {
  if (((typeof arg) === "number")) {
    this.a = new Uint16Array(arg);
  } else {
    this.a = arg;
  }
}
$p = $ac_C.prototype = new $h_O();
$p.constructor = $ac_C;
$p.av = (function(srcPos, dest, destPos, length) {
  dest.a.set(this.a.subarray(srcPos, ((srcPos + length) | 0)), destPos);
});
$p.ae = (function() {
  return new $ac_C(this.a.slice());
});
function $ac_B(arg) {
  if (((typeof arg) === "number")) {
    this.a = new Int8Array(arg);
  } else {
    this.a = arg;
  }
}
$p = $ac_B.prototype = new $h_O();
$p.constructor = $ac_B;
$p.av = (function(srcPos, dest, destPos, length) {
  dest.a.set(this.a.subarray(srcPos, ((srcPos + length) | 0)), destPos);
});
$p.ae = (function() {
  return new $ac_B(this.a.slice());
});
function $ac_S(arg) {
  if (((typeof arg) === "number")) {
    this.a = new Int16Array(arg);
  } else {
    this.a = arg;
  }
}
$p = $ac_S.prototype = new $h_O();
$p.constructor = $ac_S;
$p.av = (function(srcPos, dest, destPos, length) {
  dest.a.set(this.a.subarray(srcPos, ((srcPos + length) | 0)), destPos);
});
$p.ae = (function() {
  return new $ac_S(this.a.slice());
});
function $ac_I(arg) {
  if (((typeof arg) === "number")) {
    this.a = new Int32Array(arg);
  } else {
    this.a = arg;
  }
}
$p = $ac_I.prototype = new $h_O();
$p.constructor = $ac_I;
$p.av = (function(srcPos, dest, destPos, length) {
  dest.a.set(this.a.subarray(srcPos, ((srcPos + length) | 0)), destPos);
});
$p.ae = (function() {
  return new $ac_I(this.a.slice());
});
function $ac_J(arg) {
  if (((typeof arg) === "number")) {
    arg = (arg << 1);
    this.a = new Int32Array(arg);
  } else {
    this.a = arg;
  }
}
$p = $ac_J.prototype = new $h_O();
$p.constructor = $ac_J;
$p.av = (function(srcPos, dest, destPos, length) {
  dest.a.set(this.a.subarray((srcPos << 1), (((srcPos + length) | 0) << 1)), (destPos << 1));
});
$p.ae = (function() {
  return new $ac_J(this.a.slice());
});
function $ac_F(arg) {
  if (((typeof arg) === "number")) {
    this.a = new Float32Array(arg);
  } else {
    this.a = arg;
  }
}
$p = $ac_F.prototype = new $h_O();
$p.constructor = $ac_F;
$p.av = (function(srcPos, dest, destPos, length) {
  dest.a.set(this.a.subarray(srcPos, ((srcPos + length) | 0)), destPos);
});
$p.ae = (function() {
  return new $ac_F(this.a.slice());
});
function $ac_D(arg) {
  if (((typeof arg) === "number")) {
    this.a = new Float64Array(arg);
  } else {
    this.a = arg;
  }
}
$p = $ac_D.prototype = new $h_O();
$p.constructor = $ac_D;
$p.av = (function(srcPos, dest, destPos, length) {
  dest.a.set(this.a.subarray(srcPos, ((srcPos + length) | 0)), destPos);
});
$p.ae = (function() {
  return new $ac_D(this.a.slice());
});
function $TypeData() {
  this.C = (void 0);
  this.n = null;
  this.O = null;
  this.B = null;
  this.D = 0;
  this.z = null;
  this.E = "";
  this.L = (void 0);
  this.A = (void 0);
  this.F = (void 0);
  this.w = (void 0);
  this.J = false;
  this.N = "";
  this.X = false;
  this.Y = false;
  this.Z = false;
  this.I = (void 0);
}
$p = $TypeData.prototype;
$p.p = (function(zero, arrayEncodedName, displayName, arrayClass, typedArrayClass) {
  this.n = ({});
  this.z = zero;
  this.E = arrayEncodedName;
  var self = this;
  this.F = ((that) => (that === self));
  this.N = displayName;
  this.X = true;
  this.I = ((obj) => false);
  if ((arrayClass !== (void 0))) {
    this.A = new $TypeData().y(this, arrayClass, typedArrayClass, (arrayEncodedName === "J"));
  }
  return this;
});
$p.i = (function(kindOrCtor, fullName, ancestors, isInstance) {
  var internalName = Object.getOwnPropertyNames(ancestors)[0];
  this.n = ancestors;
  this.E = (("L" + fullName) + ";");
  this.F = ((that) => (!(!that.n[internalName])));
  this.J = (kindOrCtor === 2);
  this.N = fullName;
  this.Y = (kindOrCtor === 1);
  this.I = (isInstance || ((obj) => (!(!((obj && obj.$classData) && obj.$classData.n[internalName])))));
  if (((typeof kindOrCtor) !== "number")) {
    kindOrCtor.prototype.$classData = this;
  }
  return this;
});
$p.y = (function(componentData, arrayClass, typedArrayClass, isLongArray, isAssignableFromFun) {
  arrayClass.prototype.$classData = this;
  var name = ("[" + componentData.E);
  this.C = arrayClass;
  this.n = ({
    W: 1,
    a: 1
  });
  this.O = componentData;
  this.B = componentData;
  this.D = 1;
  this.E = name;
  this.N = name;
  this.Z = true;
  var self = this;
  this.F = (isAssignableFromFun || ((that) => (self === that)));
  this.w = (isLongArray ? ((array) => {
    var len = (array.length | 0);
    var result = new arrayClass(len);
    var u = result.a;
    for (var i = 0; (i < len); i = ((i + 1) | 0)) {
      var srcElem = array[i];
      u[(i << 1)] = srcElem.l;
      u[(((i << 1) + 1) | 0)] = srcElem.h;
    }
    return result;
  }) : (typedArrayClass ? ((array) => new arrayClass(new typedArrayClass(array))) : ((array) => new arrayClass(array))));
  this.I = ((obj) => (obj instanceof arrayClass));
  return this;
});
$p.a = (function(componentData) {
  function ArrayClass(arg) {
    if (((typeof arg) === "number")) {
      this.a = new Array(arg);
      for (var i = 0; (i < arg); (i++)) {
        this.a[i] = null;
      }
    } else {
      this.a = arg;
    }
  }
  var $p = ArrayClass.prototype = new $ah_O();
  $p.constructor = ArrayClass;
  $p.av = (function(srcPos, dest, destPos, length) {
    $arraycopyGeneric(this.a, srcPos, dest.a, destPos, length);
  });
  $p.ae = (function() {
    return new ArrayClass(this.a.slice());
  });
  $p.$classData = this;
  var arrayBase = (componentData.B || componentData);
  var arrayDepth = (componentData.D + 1);
  var name = ("[" + componentData.E);
  this.C = ArrayClass;
  this.n = ({
    W: 1,
    a: 1
  });
  this.O = componentData;
  this.B = arrayBase;
  this.D = arrayDepth;
  this.E = name;
  this.N = name;
  this.Z = true;
  var isAssignableFromFun = ((that) => {
    var thatDepth = that.D;
    return ((thatDepth === arrayDepth) ? arrayBase.F(that.B) : ((thatDepth > arrayDepth) && (arrayBase === $d_O)));
  });
  this.F = isAssignableFromFun;
  this.w = ((array) => new ArrayClass(array));
  var self = this;
  this.I = ((obj) => {
    var data = (obj && obj.$classData);
    return ((!(!data)) && ((data === self) || isAssignableFromFun(data)));
  });
  return this;
});
$p.r = (function() {
  if ((!this.A)) {
    this.A = new $TypeData().a(this);
  }
  return this.A;
});
$p.l = (function() {
  if ((!this.L)) {
    this.L = new $c_jl_Class(this);
  }
  return this.L;
});
$p.R = (function(that) {
  return ((this === that) || this.F(that));
});
$p.S = (function() {
  return (this.P ? this.P.l() : null);
});
$p.Q = (function() {
  return (this.O ? this.O.l() : null);
});
$p.U = (function(length) {
  if ((this === $d_V)) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  }
  return new (this.r().C)(length);
});
function $isArrayOf_O(obj, depth) {
  var data = (obj && obj.$classData);
  if ((!data)) {
    return false;
  } else {
    var arrayDepth = data.D;
    return ((arrayDepth === depth) ? (!data.B.X) : (arrayDepth > depth));
  }
}
function $isArrayOf_Z(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && (obj.$classData.B === $d_Z))));
}
function $isArrayOf_C(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && (obj.$classData.B === $d_C))));
}
function $isArrayOf_B(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && (obj.$classData.B === $d_B))));
}
function $isArrayOf_S(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && (obj.$classData.B === $d_S))));
}
function $isArrayOf_I(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && (obj.$classData.B === $d_I))));
}
function $isArrayOf_J(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && (obj.$classData.B === $d_J))));
}
function $isArrayOf_F(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && (obj.$classData.B === $d_F))));
}
function $isArrayOf_D(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && (obj.$classData.B === $d_D))));
}
var $d_O = new $TypeData();
$d_O.n = ({});
$d_O.E = "Ljava.lang.Object;";
$d_O.F = ((that) => (!that.X));
$d_O.N = "java.lang.Object";
$d_O.I = ((obj) => (obj !== null));
$d_O.A = new $TypeData().y($d_O, $ac_O, (void 0), false, ((that) => {
  var thatDepth = that.D;
  return ((thatDepth === 1) ? (!that.B.X) : (thatDepth > 1));
}));
$c_O.prototype.$classData = $d_O;
var $d_V = new $TypeData().p((void 0), "V", "void", (void 0), (void 0));
var $d_Z = new $TypeData().p(false, "Z", "boolean", $ac_Z, (void 0));
var $d_C = new $TypeData().p(0, "C", "char", $ac_C, Uint16Array);
var $d_B = new $TypeData().p(0, "B", "byte", $ac_B, Int8Array);
var $d_S = new $TypeData().p(0, "S", "short", $ac_S, Int16Array);
var $d_I = new $TypeData().p(0, "I", "int", $ac_I, Int32Array);
var $d_J = new $TypeData().p($bL0, "J", "long", $ac_J, Int32Array);
var $d_F = new $TypeData().p(0.0, "F", "float", $ac_F, Float32Array);
var $d_D = new $TypeData().p(0.0, "D", "double", $ac_D, Float64Array);
var $typedArraysAreBigEndian = (new Int8Array(new Int32Array([1]).buffer)[0] === 0);
function $constArrayBuffer_B(len, encoded) {
  var buf = new ArrayBuffer(len);
  var view = new DataView(buf);
  var regularChunksEnd = ((encoded.length - 4) | 0);
  var i = 0;
  var j = 0;
  var chunk = 0;
  while (true) {
    chunk = (((encoded.charCodeAt(i) | (encoded.charCodeAt(((i + 1) | 0)) << 8)) | (encoded.charCodeAt(((i + 2) | 0)) << 16)) | (encoded.charCodeAt(((i + 3) | 0)) << 24));
    chunk = ((((chunk - 808464432) | 0) - ((chunk & 1616928864) >>> 3)) | 0);
    chunk = (((chunk & 1056980736) >>> 2) | (chunk & 4128831));
    chunk = (((chunk & 268369920) >>> 4) | (chunk & 4095));
    if ((i === regularChunksEnd)) {
      break;
    }
    view.setUint32(j, chunk, true);
    i = ((i + 4) | 0);
    j = ((j + 3) | 0);
  }
  var trailing = ((len - j) | 0);
  view.setUint8(j, chunk);
  if ((trailing !== 1)) {
    view.setUint8(((j + 1) | 0), (chunk >>> 8));
    if ((trailing === 3)) {
      view.setUint8(((j + 2) | 0), (chunk >>> 16));
    }
  }
  return buf;
}
function $constArrayBuffer_S(len, encoded) {
  var buf = $constArrayBuffer_B((len << 1), encoded);
  if ($typedArraysAreBigEndian) {
    var view = new DataView(buf);
    var i = 0;
    while ((i !== len)) {
      view.putInt16(i, view.getInt16(i, true), false);
      i = ((i + 2) | 0);
    }
  }
  return buf;
}
function $constArrayBuffer_I(len, encoded) {
  var buf = $constArrayBuffer_B((len << 2), encoded);
  if ($typedArraysAreBigEndian) {
    var view = new DataView(buf);
    var i = 0;
    while ((i !== len)) {
      view.putInt32(i, view.getInt32(i, true), false);
      i = ((i + 4) | 0);
    }
  }
  return buf;
}
function $constArrayBuffer_J(len, encoded) {
  return $constArrayBuffer_I((len << 1), encoded);
}
function $constTypedArrayU_I(len, encoded, prevMask) {
  var buf = new Int32Array(len);
  var inLen = (encoded.length | 0);
  var prev = 0;
  var i = 0;
  var j = 0;
  var v = 0;
  while ((i !== inLen)) {
    var c = encoded.charCodeAt(i);
    if ((c < 80)) {
      v = ((v | (c - 48)) << 5);
    } else {
      v = (v | (c - 93));
      prev = (((prev & prevMask) + v) | 0);
      buf[j] = prev;
      j = ((j + 1) | 0);
      v = 0;
    }
    i = ((i + 1) | 0);
  }
  return buf;
}
function $constTypedArrayS_I(len, encoded, prevMask) {
  var buf = new Int32Array(len);
  var inLen = (encoded.length | 0);
  var prev = 0;
  var i = 0;
  var j = 0;
  var v = 0;
  var first = true;
  while ((i !== inLen)) {
    var c = encoded.charCodeAt(i);
    if ((c < 80)) {
      if (first) {
        v = (((c - 48) << 27) >> 22);
        first = false;
      } else {
        v = ((v | (c - 48)) << 5);
      }
    } else {
      if (first) {
        v = (((c - 93) << 27) >> 27);
      } else {
        v = (v | (c - 93));
        first = true;
      }
      prev = (((prev & prevMask) + v) | 0);
      buf[j] = prev;
      j = ((j + 1) | 0);
    }
    i = ((i + 1) | 0);
  }
  return buf;
}
function $constArrRaw_B(len, encoded) {
  return new $ac_B(new Int8Array($constArrayBuffer_B(len, encoded)));
}
function $constArrRaw_S(len, encoded) {
  return new $ac_S(new Int16Array($constArrayBuffer_S(len, encoded)));
}
function $constArrRaw_C(len, encoded) {
  return new $ac_C(new Uint16Array($constArrayBuffer_S(len, encoded)));
}
function $constArrRaw_I(len, encoded) {
  return new $ac_I(new Int32Array($constArrayBuffer_I(len, encoded)));
}
function $constArrRaw_J(len, encoded) {
  return new $ac_J(new Int32Array($constArrayBuffer_J(len, encoded)));
}
function $constArrUVals_I(len, encoded) {
  return new $ac_I($constTypedArrayU_I(len, encoded, 0));
}
function $constArrUDiffs_I(len, encoded) {
  return new $ac_I($constTypedArrayU_I(len, encoded, (-1)));
}
function $constArrSVals_I(len, encoded) {
  return new $ac_I($constTypedArrayS_I(len, encoded, 0));
}
function $constArrSDiffs_I(len, encoded) {
  return new $ac_I($constTypedArrayS_I(len, encoded, (-1)));
}
function $constArrUVals_J(len, encoded) {
  return new $ac_J($constTypedArrayU_I((len << 1), encoded, 0));
}
function $constArrUDiffs_J(len, encoded) {
  return new $ac_J($constTypedArrayU_I((len << 1), encoded, (-1)));
}
function $constArrSVals_J(len, encoded) {
  return new $ac_J($constTypedArrayS_I((len << 1), encoded, 0));
}
function $constArrSDiffs_J(len, encoded) {
  return new $ac_J($constTypedArrayS_I((len << 1), encoded, (-1)));
}
/** @constructor */
function $c_Lapp_tulz_tuplez_Composition() {
}
$p = $c_Lapp_tulz_tuplez_Composition.prototype = new $h_O();
$p.constructor = $c_Lapp_tulz_tuplez_Composition;
/** @constructor */
function $h_Lapp_tulz_tuplez_Composition() {
}
$h_Lapp_tulz_tuplez_Composition.prototype = $p;
/** @constructor */
function $c_Lcom_raquo_airstream_combine_CombineObservable$() {
}
$p = $c_Lcom_raquo_airstream_combine_CombineObservable$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_combine_CombineObservable$;
/** @constructor */
function $h_Lcom_raquo_airstream_combine_CombineObservable$() {
}
$h_Lcom_raquo_airstream_combine_CombineObservable$.prototype = $p;
$p.aPB = (function(trys, combinator) {
  var elem = false;
  elem = true;
  var i = 0;
  var len = (trys.length | 0);
  while ((i < len)) {
    if (trys[i].a3R()) {
      var ev$6 = false;
      elem = ev$6;
    }
    i = ((1 + i) | 0);
  }
  if (elem) {
    var values = trys.map(((_$3) => _$3.d()));
    return new $c_s_util_Success(combinator.i(values));
  } else {
    var arr = trys.map(((x$1) => ((x$1 instanceof $c_s_util_Failure) ? new $c_s_Some(x$1.le) : $m_s_None$())));
    return new $c_s_util_Failure(new $c_Lcom_raquo_airstream_core_AirstreamError$CombinedError($m_sci_IndexedSeq$().WW($ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), arr))));
  }
});
var $d_Lcom_raquo_airstream_combine_CombineObservable$ = new $TypeData().i($c_Lcom_raquo_airstream_combine_CombineObservable$, "com.raquo.airstream.combine.CombineObservable$", ({
  nz: 1
}));
var $n_Lcom_raquo_airstream_combine_CombineObservable$;
function $m_Lcom_raquo_airstream_combine_CombineObservable$() {
  if ((!$n_Lcom_raquo_airstream_combine_CombineObservable$)) {
    $n_Lcom_raquo_airstream_combine_CombineObservable$ = new $c_Lcom_raquo_airstream_combine_CombineObservable$();
  }
  return $n_Lcom_raquo_airstream_combine_CombineObservable$;
}
/** @constructor */
function $c_Lcom_raquo_airstream_combine_generated_CombinableSignal$() {
}
$p = $c_Lcom_raquo_airstream_combine_generated_CombinableSignal$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_combine_generated_CombinableSignal$;
/** @constructor */
function $h_Lcom_raquo_airstream_combine_generated_CombinableSignal$() {
}
$h_Lcom_raquo_airstream_combine_generated_CombinableSignal$.prototype = $p;
$p.vV = (function(this$, s1, c) {
  return $m_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$().li(this$, s1, new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((a, v1) => c.a2X(a, v1))));
});
var $d_Lcom_raquo_airstream_combine_generated_CombinableSignal$ = new $TypeData().i($c_Lcom_raquo_airstream_combine_generated_CombinableSignal$, "com.raquo.airstream.combine.generated.CombinableSignal$", ({
  nC: 1
}));
var $n_Lcom_raquo_airstream_combine_generated_CombinableSignal$;
function $m_Lcom_raquo_airstream_combine_generated_CombinableSignal$() {
  if ((!$n_Lcom_raquo_airstream_combine_generated_CombinableSignal$)) {
    $n_Lcom_raquo_airstream_combine_generated_CombinableSignal$ = new $c_Lcom_raquo_airstream_combine_generated_CombinableSignal$();
  }
  return $n_Lcom_raquo_airstream_combine_generated_CombinableSignal$;
}
/** @constructor */
function $c_Lcom_raquo_airstream_combine_generated_CombinableStream$() {
}
$p = $c_Lcom_raquo_airstream_combine_generated_CombinableStream$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_combine_generated_CombinableStream$;
/** @constructor */
function $h_Lcom_raquo_airstream_combine_generated_CombinableStream$() {
}
$h_Lcom_raquo_airstream_combine_generated_CombinableStream$.prototype = $p;
$p.aTt = (function(this$, s1, c) {
  var combinator = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((arr) => c.a2X(arr[0], arr[1])));
  return new $c_Lcom_raquo_airstream_combine_SampleCombineStreamN(this$, $m_Lcom_raquo_ew_JsArray$().fu($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_airstream_core_Signal.r().C)([s1.dP()]))), combinator);
});
$p.XV = (function(this$, s1) {
  var combinator = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((arr) => arr[1]));
  return new $c_Lcom_raquo_airstream_combine_SampleCombineStreamN(this$, $m_Lcom_raquo_ew_JsArray$().fu($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_airstream_core_Signal.r().C)([s1.dP()]))), combinator);
});
var $d_Lcom_raquo_airstream_combine_generated_CombinableStream$ = new $TypeData().i($c_Lcom_raquo_airstream_combine_generated_CombinableStream$, "com.raquo.airstream.combine.generated.CombinableStream$", ({
  nD: 1
}));
var $n_Lcom_raquo_airstream_combine_generated_CombinableStream$;
function $m_Lcom_raquo_airstream_combine_generated_CombinableStream$() {
  if ((!$n_Lcom_raquo_airstream_combine_generated_CombinableStream$)) {
    $n_Lcom_raquo_airstream_combine_generated_CombinableStream$ = new $c_Lcom_raquo_airstream_combine_generated_CombinableStream$();
  }
  return $n_Lcom_raquo_airstream_combine_generated_CombinableStream$;
}
/** @constructor */
function $c_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$() {
}
$p = $c_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$;
/** @constructor */
function $h_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$() {
}
$h_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$.prototype = $p;
$p.li = (function(s1, s2, combinator) {
  return new $c_Lcom_raquo_airstream_combine_CombineSignalN($m_Lcom_raquo_ew_JsArray$().fu($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_airstream_core_Signal.r().C)([s1.dP(), s2.dP()]))), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((arr) => combinator.R(arr[0], arr[1]))));
});
$p.aMQ = (function(s1, s2, s3, combinator) {
  return new $c_Lcom_raquo_airstream_combine_CombineSignalN($m_Lcom_raquo_ew_JsArray$().fu($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_airstream_core_Signal.r().C)([s1.dP(), s2.dP(), s3.dP()]))), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((arr) => combinator.DH(arr[0], arr[1], arr[2]))));
});
$p.aYI = (function(s1, s2, s3, s4, combinator) {
  return new $c_Lcom_raquo_airstream_combine_CombineSignalN($m_Lcom_raquo_ew_JsArray$().fu($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_airstream_core_Signal.r().C)([s1.dP(), s2.dP(), s3.dP(), s4.dP()]))), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((arr) => combinator.a2I(arr[0], arr[1], arr[2], arr[3]))));
});
$p.aMP = (function(s1, s2, s3, s4, s5, combinator) {
  return new $c_Lcom_raquo_airstream_combine_CombineSignalN($m_Lcom_raquo_ew_JsArray$().fu($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_airstream_core_Signal.r().C)([s1.dP(), s2.dP(), s3.dP(), s4.dP(), s5.dP()]))), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((arr) => combinator.aXh(arr[0], arr[1], arr[2], arr[3], arr[4]))));
});
$p.aYC = (function(s1, s2, s3, s4, s5, s6) {
  return this.aMO(s1, s2, s3, s4, s5, s6, new $c_sjsr_AnonFunction6_$$Lambda$39017dae4a967fbe8fca0cd4c8f04f299a6cfb7e(((_1, _2, _3, _4, _5, _6) => new $c_T6(_1, _2, _3, _4, _5, _6))));
});
$p.aMO = (function(s1, s2, s3, s4, s5, s6, combinator) {
  return new $c_Lcom_raquo_airstream_combine_CombineSignalN($m_Lcom_raquo_ew_JsArray$().fu($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_airstream_core_Signal.r().C)([s1.dP(), s2.dP(), s3.dP(), s4.dP(), s5.dP(), s6.dP()]))), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((arr) => combinator.aM6(arr[0], arr[1], arr[2], arr[3], arr[4], arr[5]))));
});
$p.aYB = (function(s1, s2, s3, s4, s5, s6, s7, s8, s9) {
  return this.aYH(s1, s2, s3, s4, s5, s6, s7, s8, s9, new $c_sjsr_AnonFunction9_$$Lambda$bec0fa2ea8c2338588bd1e26523619ac4d96b108(((_1, _2, _3, _4, _5, _6, _7, _8, _9) => new $c_T9(_1, _2, _3, _4, _5, _6, _7, _8, _9))));
});
$p.aYH = (function(s1, s2, s3, s4, s5, s6, s7, s8, s9, combinator) {
  return new $c_Lcom_raquo_airstream_combine_CombineSignalN($m_Lcom_raquo_ew_JsArray$().fu($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_airstream_core_Signal.r().C)([s1.dP(), s2.dP(), s3.dP(), s4.dP(), s5.dP(), s6.dP(), s7.dP(), s8.dP(), s9.dP()]))), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((arr) => combinator.aXg(arr[0], arr[1], arr[2], arr[3], arr[4], arr[5], arr[6], arr[7], arr[8]))));
});
var $d_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$ = new $TypeData().i($c_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$, "com.raquo.airstream.combine.generated.StaticSignalCombineOps$", ({
  nE: 1
}));
var $n_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$;
function $m_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$() {
  if ((!$n_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$)) {
    $n_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$ = new $c_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$();
  }
  return $n_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$;
}
/** @constructor */
function $c_Lcom_raquo_airstream_common_InternalParentObserver$() {
}
$p = $c_Lcom_raquo_airstream_common_InternalParentObserver$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_common_InternalParentObserver$;
/** @constructor */
function $h_Lcom_raquo_airstream_common_InternalParentObserver$() {
}
$h_Lcom_raquo_airstream_common_InternalParentObserver$.prototype = $p;
$p.ag9 = (function(parent, onTry) {
  return new $c_Lcom_raquo_airstream_common_InternalParentObserver$$anon$2(parent, onTry, this);
});
var $d_Lcom_raquo_airstream_common_InternalParentObserver$ = new $TypeData().i($c_Lcom_raquo_airstream_common_InternalParentObserver$, "com.raquo.airstream.common.InternalParentObserver$", ({
  nF: 1
}));
var $n_Lcom_raquo_airstream_common_InternalParentObserver$;
function $m_Lcom_raquo_airstream_common_InternalParentObserver$() {
  if ((!$n_Lcom_raquo_airstream_common_InternalParentObserver$)) {
    $n_Lcom_raquo_airstream_common_InternalParentObserver$ = new $c_Lcom_raquo_airstream_common_InternalParentObserver$();
  }
  return $n_Lcom_raquo_airstream_common_InternalParentObserver$;
}
/** @constructor */
function $c_Lcom_raquo_airstream_core_EventStream$() {
  this.Qr = null;
  $n_Lcom_raquo_airstream_core_EventStream$ = this;
  this.Qr = this.aOA(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$10) => false)), new $c_sjsr_AnonFunction4_$$Lambda$120c664e6fb20e1c3552e9e8baf775b7682c102c(((_$11, _$12, _$13, _$14) => (void 0))), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((v1) => (void 0))));
}
$p = $c_Lcom_raquo_airstream_core_EventStream$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_core_EventStream$;
/** @constructor */
function $h_Lcom_raquo_airstream_core_EventStream$() {
}
$h_Lcom_raquo_airstream_core_EventStream$.prototype = $p;
$p.a3x = (function(event, emitOnce) {
  return this.aOA(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((startIndex) => {
    var startIndex$1 = (startIndex | 0);
    return ((!emitOnce) || (startIndex$1 === 1));
  })), new $c_sjsr_AnonFunction4_$$Lambda$120c664e6fb20e1c3552e9e8baf775b7682c102c(((fireEvent, _$20, _$21, _$22) => {
    fireEvent.i(event);
  })), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((v1) => (void 0))));
});
$p.aOB = (function(future, emitOnce, ec) {
  return new $c_Lcom_raquo_airstream_timing_JsPromiseStream($m_sjs_js_JSConverters$JSRichFuture$().aST(future, ec), emitOnce);
});
$p.aOA = (function(shouldStart, start, stop) {
  return new $c_Lcom_raquo_airstream_custom_CustomStreamSource(new $c_sjsr_AnonFunction4_$$Lambda$120c664e6fb20e1c3552e9e8baf775b7682c102c(((fireValue, fireError, getStartIndex, getIsStarted) => $m_Lcom_raquo_airstream_custom_CustomSource$Config$().aM8(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d(((fireValue$2, fireError$2, getStartIndex$2, getIsStarted$2) => (() => {
    start.a2I(fireValue$2, fireError$2, getStartIndex$2, getIsStarted$2);
  }))(fireValue, fireError, getStartIndex, getIsStarted)), new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d(((getStartIndex$3) => (() => {
    stop.i(getStartIndex$3.a3());
  }))(getStartIndex))).bbS(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d(((getStartIndex$4) => (() => (!(!shouldStart.i(getStartIndex$4.a3())))))(getStartIndex))))));
});
$p.aZI = (function(ms, event, emitOnce) {
  return new $c_Lcom_raquo_airstream_timing_DelayStream($m_Lcom_raquo_airstream_core_EventStream$().a3x(event, emitOnce), ms);
});
var $d_Lcom_raquo_airstream_core_EventStream$ = new $TypeData().i($c_Lcom_raquo_airstream_core_EventStream$, "com.raquo.airstream.core.EventStream$", ({
  nK: 1
}));
var $n_Lcom_raquo_airstream_core_EventStream$;
function $m_Lcom_raquo_airstream_core_EventStream$() {
  if ((!$n_Lcom_raquo_airstream_core_EventStream$)) {
    $n_Lcom_raquo_airstream_core_EventStream$ = new $c_Lcom_raquo_airstream_core_EventStream$();
  }
  return $n_Lcom_raquo_airstream_core_EventStream$;
}
var $d_Lcom_raquo_airstream_core_InternalObserver = new $TypeData().i(1, "com.raquo.airstream.core.InternalObserver", ({
  a3: 1
}));
/** @constructor */
function $c_Lcom_raquo_airstream_core_InternalObserver$() {
  this.Qs = null;
  $n_Lcom_raquo_airstream_core_InternalObserver$ = this;
  this.Qs = new $c_Lcom_raquo_airstream_core_InternalObserver$$anon$1();
}
$p = $c_Lcom_raquo_airstream_core_InternalObserver$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_core_InternalObserver$;
/** @constructor */
function $h_Lcom_raquo_airstream_core_InternalObserver$() {
}
$h_Lcom_raquo_airstream_core_InternalObserver$.prototype = $p;
$p.aMa = (function(onNext, onError) {
  return new $c_Lcom_raquo_airstream_core_InternalObserver$$anon$2(onNext, onError, this);
});
$p.aOI = (function(onTry) {
  return new $c_Lcom_raquo_airstream_core_InternalObserver$$anon$3(onTry, this);
});
var $d_Lcom_raquo_airstream_core_InternalObserver$ = new $TypeData().i($c_Lcom_raquo_airstream_core_InternalObserver$, "com.raquo.airstream.core.InternalObserver$", ({
  nL: 1
}));
var $n_Lcom_raquo_airstream_core_InternalObserver$;
function $m_Lcom_raquo_airstream_core_InternalObserver$() {
  if ((!$n_Lcom_raquo_airstream_core_InternalObserver$)) {
    $n_Lcom_raquo_airstream_core_InternalObserver$ = new $c_Lcom_raquo_airstream_core_InternalObserver$();
  }
  return $n_Lcom_raquo_airstream_core_InternalObserver$;
}
function $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T($thiz) {
  return (($objectGetClass($thiz).a3F() + "@") + $thiz.x());
}
function $f_Lcom_raquo_airstream_core_Named__displayName__T($thiz) {
  var x = $thiz.fx();
  return ((x === (void 0)) ? $thiz.eU() : x);
}
/** @constructor */
function $c_Lcom_raquo_airstream_core_Observer$() {
  this.m5 = null;
  $n_Lcom_raquo_airstream_core_Observer$ = this;
  this.m5 = $m_Lcom_raquo_airstream_core_Observer$().wo(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => (void 0))), $m_s_PartialFunction$().gt, true);
}
$p = $c_Lcom_raquo_airstream_core_Observer$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_core_Observer$;
/** @constructor */
function $h_Lcom_raquo_airstream_core_Observer$() {
}
$h_Lcom_raquo_airstream_core_Observer$.prototype = $p;
$p.wo = (function(onNext, onError, handleObserverErrors) {
  return new $c_Lcom_raquo_airstream_core_Observer$$anon$8(onNext, handleObserverErrors, onError, this);
});
$p.b1V = (function(onTry, handleObserverErrors) {
  return new $c_Lcom_raquo_airstream_core_Observer$$anon$9(onTry, handleObserverErrors, this);
});
var $d_Lcom_raquo_airstream_core_Observer$ = new $TypeData().i($c_Lcom_raquo_airstream_core_Observer$, "com.raquo.airstream.core.Observer$", ({
  nS: 1
}));
var $n_Lcom_raquo_airstream_core_Observer$;
function $m_Lcom_raquo_airstream_core_Observer$() {
  if ((!$n_Lcom_raquo_airstream_core_Observer$)) {
    $n_Lcom_raquo_airstream_core_Observer$ = new $c_Lcom_raquo_airstream_core_Observer$();
  }
  return $n_Lcom_raquo_airstream_core_Observer$;
}
/** @constructor */
function $c_Lcom_raquo_airstream_core_ObserverList$() {
}
$p = $c_Lcom_raquo_airstream_core_ObserverList$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_core_ObserverList$;
/** @constructor */
function $h_Lcom_raquo_airstream_core_ObserverList$() {
}
$h_Lcom_raquo_airstream_core_ObserverList$.prototype = $p;
$p.aRx = (function(this$, observer) {
  var index = (this$.indexOf(observer) | 0);
  var shouldRemove = (index !== (-1));
  if (shouldRemove) {
    this$.splice(index, 1);
  }
  return shouldRemove;
});
var $d_Lcom_raquo_airstream_core_ObserverList$ = new $TypeData().i($c_Lcom_raquo_airstream_core_ObserverList$, "com.raquo.airstream.core.ObserverList$", ({
  nX: 1
}));
var $n_Lcom_raquo_airstream_core_ObserverList$;
function $m_Lcom_raquo_airstream_core_ObserverList$() {
  if ((!$n_Lcom_raquo_airstream_core_ObserverList$)) {
    $n_Lcom_raquo_airstream_core_ObserverList$ = new $c_Lcom_raquo_airstream_core_ObserverList$();
  }
  return $n_Lcom_raquo_airstream_core_ObserverList$;
}
/** @constructor */
function $c_Lcom_raquo_airstream_core_Protected() {
}
$p = $c_Lcom_raquo_airstream_core_Protected.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_core_Protected;
/** @constructor */
function $h_Lcom_raquo_airstream_core_Protected() {
}
$h_Lcom_raquo_airstream_core_Protected.prototype = $p;
var $d_Lcom_raquo_airstream_core_Protected = new $TypeData().i($c_Lcom_raquo_airstream_core_Protected, "com.raquo.airstream.core.Protected", ({
  nY: 1
}));
/** @constructor */
function $c_Lcom_raquo_airstream_core_Protected$() {
  this.aTx = null;
  $n_Lcom_raquo_airstream_core_Protected$ = this;
  this.aTx = new $c_Lcom_raquo_airstream_core_Protected();
}
$p = $c_Lcom_raquo_airstream_core_Protected$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_core_Protected$;
/** @constructor */
function $h_Lcom_raquo_airstream_core_Protected$() {
}
$h_Lcom_raquo_airstream_core_Protected$.prototype = $p;
$p.b4n = (function(observable, observables) {
  return this.aQe(observable.eB(), observables);
});
$p.aQe = (function(minRank, observables) {
  var elem = 0;
  elem = minRank;
  var i = 0;
  var len = (observables.length | 0);
  while ((i < len)) {
    var observable = observables[i];
    var rank = observable.eB();
    if ((rank > elem)) {
      var ev$2 = rank;
      elem = ev$2;
    }
    i = ((1 + i) | 0);
  }
  return elem;
});
var $d_Lcom_raquo_airstream_core_Protected$ = new $TypeData().i($c_Lcom_raquo_airstream_core_Protected$, "com.raquo.airstream.core.Protected$", ({
  nZ: 1
}));
var $n_Lcom_raquo_airstream_core_Protected$;
function $m_Lcom_raquo_airstream_core_Protected$() {
  if ((!$n_Lcom_raquo_airstream_core_Protected$)) {
    $n_Lcom_raquo_airstream_core_Protected$ = new $c_Lcom_raquo_airstream_core_Protected$();
  }
  return $n_Lcom_raquo_airstream_core_Protected$;
}
/** @constructor */
function $c_Lcom_raquo_airstream_core_Signal$() {
  this.JO = 0;
  this.JO = 0;
}
$p = $c_Lcom_raquo_airstream_core_Signal$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_core_Signal$;
/** @constructor */
function $h_Lcom_raquo_airstream_core_Signal$() {
}
$h_Lcom_raquo_airstream_core_Signal$.prototype = $p;
$p.b1L = (function(future, ec) {
  return new $c_Lcom_raquo_airstream_timing_JsPromiseSignal($m_sjs_js_JSConverters$JSRichFuture$().aST(future, ec));
});
$p.b8w = (function(signals) {
  return new $c_Lcom_raquo_airstream_combine_CombineSignalN($m_Lcom_raquo_ew_JsArray$().fu(signals), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$3) => $m_sci_IndexedSeq$().WW($ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), _$3)))));
});
$p.aQs = (function() {
  if ((this.JO === 2147483647)) {
    this.JO = 1;
  } else {
    this.JO = ((1 + this.JO) | 0);
  }
  return this.JO;
});
var $d_Lcom_raquo_airstream_core_Signal$ = new $TypeData().i($c_Lcom_raquo_airstream_core_Signal$, "com.raquo.airstream.core.Signal$", ({
  o0: 1
}));
var $n_Lcom_raquo_airstream_core_Signal$;
function $m_Lcom_raquo_airstream_core_Signal$() {
  if ((!$n_Lcom_raquo_airstream_core_Signal$)) {
    $n_Lcom_raquo_airstream_core_Signal$ = new $c_Lcom_raquo_airstream_core_Signal$();
  }
  return $n_Lcom_raquo_airstream_core_Signal$;
}
/** @constructor */
function $c_Lcom_raquo_airstream_core_Transaction(code) {
  this.a5u = null;
  this.Qt = null;
  this.a5v = 0;
  this.a5u = code;
  this.Qt = (void 0);
  var x = $m_Lcom_raquo_airstream_core_Transaction$pendingTransactions$().XJ();
  this.a5v = ((x === (void 0)) ? 1 : ((1 + x.a5v) | 0));
  if ((($m_Lcom_raquo_airstream_core_Transaction$().Yl === (-1)) || (this.a5v > $m_Lcom_raquo_airstream_core_Transaction$().Yl))) {
    $m_Lcom_raquo_airstream_core_AirstreamError$().rc(new $c_Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded(this, $m_Lcom_raquo_airstream_core_Transaction$().Yl));
  } else if ($m_Lcom_raquo_airstream_core_Transaction$onStart$().ky) {
    ($m_Lcom_raquo_airstream_core_Transaction$onStart$().Et.push(this) | 0);
  } else {
    $m_Lcom_raquo_airstream_core_Transaction$pendingTransactions$().aex(this);
  }
}
$p = $c_Lcom_raquo_airstream_core_Transaction.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_core_Transaction;
/** @constructor */
function $h_Lcom_raquo_airstream_core_Transaction() {
}
$h_Lcom_raquo_airstream_core_Transaction.prototype = $p;
$p.aZ4 = (function(observable) {
  var x = this.Qt;
  var x$1 = ((x === (void 0)) ? (void 0) : x.E(observable));
  return ((x$1 === (void 0)) ? false : x$1);
});
$p.b0E = (function(observable) {
  var x = this.Qt;
  if ((x === (void 0))) {
    var newQueue = new $c_Lcom_raquo_airstream_util_JsPriorityQueue(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((observable$1) => observable$1.eB())));
    this.Qt = newQueue;
    var $x_1 = newQueue;
  } else {
    var $x_1 = x;
  }
  $x_1.b0D(observable);
});
var $d_Lcom_raquo_airstream_core_Transaction = new $TypeData().i($c_Lcom_raquo_airstream_core_Transaction, "com.raquo.airstream.core.Transaction", ({
  o1: 1
}));
/** @constructor */
function $c_Lcom_raquo_airstream_core_Transaction$() {
  this.Yl = 0;
  this.ajg = null;
  $n_Lcom_raquo_airstream_core_Transaction$ = this;
  this.Yl = 1000;
  this.ajg = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((trx) => {
    throw $ct_jl_Exception__T__(new $c_jl_Exception(), (("Attempted to run Transaction " + trx) + " after it was already executed."));
  }));
}
$p = $c_Lcom_raquo_airstream_core_Transaction$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_core_Transaction$;
/** @constructor */
function $h_Lcom_raquo_airstream_core_Transaction$() {
}
$h_Lcom_raquo_airstream_core_Transaction$.prototype = $p;
$p.aML = (function(transaction) {
  try {
    transaction.a5u.i(transaction);
    var x = transaction.Qt;
    if ((x !== (void 0))) {
      while (((x.AQ.length | 0) !== 0)) {
        if (((x.AQ.length | 0) === 0)) {
          throw $ct_jl_Exception__T__(new $c_jl_Exception(), "Unable to dequeue an empty JsPriorityQueue");
        }
        x.AQ.shift().aSF(transaction);
      }
    }
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    $m_Lcom_raquo_airstream_core_AirstreamError$().rc(e$2);
  }
});
var $d_Lcom_raquo_airstream_core_Transaction$ = new $TypeData().i($c_Lcom_raquo_airstream_core_Transaction$, "com.raquo.airstream.core.Transaction$", ({
  o2: 1
}));
var $n_Lcom_raquo_airstream_core_Transaction$;
function $m_Lcom_raquo_airstream_core_Transaction$() {
  if ((!$n_Lcom_raquo_airstream_core_Transaction$)) {
    $n_Lcom_raquo_airstream_core_Transaction$ = new $c_Lcom_raquo_airstream_core_Transaction$();
  }
  return $n_Lcom_raquo_airstream_core_Transaction$;
}
function $p_Lcom_raquo_airstream_core_Transaction$onStart$__resolve__V($thiz) {
  if ((($thiz.Qu.length | 0) === 0)) {
    if ((($thiz.Et.length | 0) > 0)) {
      new $c_Lcom_raquo_airstream_core_Transaction(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$3) => {
        while ((($thiz.Et.length | 0) > 0)) {
          $m_Lcom_raquo_airstream_core_Transaction$pendingTransactions$().aex($thiz.Et.shift());
        }
      })));
    }
  } else {
    new $c_Lcom_raquo_airstream_core_Transaction(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((trx) => {
      while ((($thiz.Qu.length | 0) > 0)) {
        var callback = $thiz.Qu.shift();
        try {
          callback.i(trx);
        } catch (e) {
          var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
          $m_Lcom_raquo_airstream_core_AirstreamError$().rc(e$2);
        }
      }
      while ((($thiz.Et.length | 0) > 0)) {
        var _trx = $thiz.Et.shift();
        $m_Lcom_raquo_airstream_core_Transaction$pendingTransactions$().aex(_trx);
      }
    })));
  }
}
/** @constructor */
function $c_Lcom_raquo_airstream_core_Transaction$onStart$() {
  this.ky = false;
  this.Qu = null;
  this.Et = null;
  $n_Lcom_raquo_airstream_core_Transaction$onStart$ = this;
  this.ky = false;
  this.Qu = $m_Lcom_raquo_ew_JsArray$().fu($m_sr_ScalaRunTime$().f(new ($d_F1.r().C)([])));
  this.Et = $m_Lcom_raquo_ew_JsArray$().fu($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_airstream_core_Transaction.r().C)([])));
}
$p = $c_Lcom_raquo_airstream_core_Transaction$onStart$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_core_Transaction$onStart$;
/** @constructor */
function $h_Lcom_raquo_airstream_core_Transaction$onStart$() {
}
$h_Lcom_raquo_airstream_core_Transaction$onStart$.prototype = $p;
$p.aWy = (function(callback) {
  this.Qu.push(callback);
});
var $d_Lcom_raquo_airstream_core_Transaction$onStart$ = new $TypeData().i($c_Lcom_raquo_airstream_core_Transaction$onStart$, "com.raquo.airstream.core.Transaction$onStart$", ({
  o3: 1
}));
var $n_Lcom_raquo_airstream_core_Transaction$onStart$;
function $m_Lcom_raquo_airstream_core_Transaction$onStart$() {
  if ((!$n_Lcom_raquo_airstream_core_Transaction$onStart$)) {
    $n_Lcom_raquo_airstream_core_Transaction$onStart$ = new $c_Lcom_raquo_airstream_core_Transaction$onStart$();
  }
  return $n_Lcom_raquo_airstream_core_Transaction$onStart$;
}
function $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__maybeChildrenFor__Lcom_raquo_airstream_core_Transaction__O($thiz, transaction) {
  return $thiz.Eu.get(transaction);
}
function $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__pushToStack__Lcom_raquo_airstream_core_Transaction__V($thiz, transaction) {
  $thiz.Ym.unshift(transaction);
}
function $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__popStack__O($thiz) {
  return $thiz.Ym.shift();
}
function $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__enqueueChild__Lcom_raquo_airstream_core_Transaction__Lcom_raquo_airstream_core_Transaction__V($thiz, parent, newChild) {
  var maybeChildren = $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__maybeChildrenFor__Lcom_raquo_airstream_core_Transaction__O($thiz, parent);
  var noChildrenFound = (maybeChildren === (void 0));
  var newChildren = ((maybeChildren === (void 0)) ? $m_Lcom_raquo_ew_JsArray$().fu($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_airstream_core_Transaction.r().C)([]))) : maybeChildren);
  newChildren.push(newChild);
  if (noChildrenFound) {
    $thiz.Eu.set(parent, newChildren);
  }
}
function $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__dequeueChild__Lcom_raquo_airstream_core_Transaction__O($thiz, parent) {
  var maybeParentChildren = $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__maybeChildrenFor__Lcom_raquo_airstream_core_Transaction__O($thiz, parent);
  var x = (((maybeParentChildren === (void 0)) || ((maybeParentChildren.length | 0) > 0)) ? maybeParentChildren : (void 0));
  if ((x === (void 0))) {
    return (void 0);
  } else {
    var nextChild = x.shift();
    if (((x.length | 0) === 0)) {
      (!(!$thiz.Eu.delete(parent)));
    }
    return nextChild;
  }
}
/** @constructor */
function $c_Lcom_raquo_airstream_core_Transaction$pendingTransactions$() {
  this.Ym = null;
  this.Eu = null;
  $n_Lcom_raquo_airstream_core_Transaction$pendingTransactions$ = this;
  this.Ym = $m_Lcom_raquo_ew_JsArray$().fu($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_airstream_core_Transaction.r().C)([])));
  this.Eu = new Map();
}
$p = $c_Lcom_raquo_airstream_core_Transaction$pendingTransactions$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_core_Transaction$pendingTransactions$;
/** @constructor */
function $h_Lcom_raquo_airstream_core_Transaction$pendingTransactions$() {
}
$h_Lcom_raquo_airstream_core_Transaction$pendingTransactions$.prototype = $p;
$p.aex = (function(newTransaction) {
  var x = this.XJ();
  if ((x === (void 0))) {
    $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__pushToStack__Lcom_raquo_airstream_core_Transaction__V(this, newTransaction);
    $m_Lcom_raquo_airstream_core_Transaction$().aML(newTransaction);
    this.b06(newTransaction);
  } else {
    $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__enqueueChild__Lcom_raquo_airstream_core_Transaction__Lcom_raquo_airstream_core_Transaction__V(this, x, newTransaction);
  }
});
$p.b06 = (function(transaction) {
  var transaction$tailLocal1 = transaction;
  while (true) {
    var x = this.XJ();
    var elem = transaction$tailLocal1;
    if ((!((x !== (void 0)) && $m_sr_BoxesRunTime$().Q(elem, x)))) {
      throw $ct_jl_Exception__T__(new $c_jl_Exception(), "Transaction queue error: Completed transaction is not the first in stack. This is a bug in Airstream.");
    }
    this.b75(transaction$tailLocal1);
    transaction$tailLocal1.a5u = $m_Lcom_raquo_airstream_core_Transaction$().ajg;
    var maybeNextTransaction = this.XJ();
    if ($m_sr_BoxesRunTime$().Q(maybeNextTransaction, (void 0))) {
      if (((this.Eu.size | 0) > 0)) {
        var numChildren = new $c_sr_IntRef(0);
        this.Eu.forEach(((numChildren) => ((transactions, _$4) => {
          var ev$12 = ((numChildren.an + (transactions.length | 0)) | 0);
          numChildren.an = ev$12;
        }))(numChildren));
        throw $ct_jl_Exception__T__(new $c_jl_Exception(), (((("Transaction queue error: Stack cleared, but a total of " + numChildren.an) + " children for ") + (this.Eu.size | 0)) + " transactions remain. This is a bug in Airstream."));
      } else {
        return (void 0);
      }
    } else {
      $m_Lcom_raquo_airstream_core_Transaction$().aML(maybeNextTransaction);
      transaction$tailLocal1 = maybeNextTransaction;
    }
  }
});
$p.b75 = (function(doneTransaction) {
  var doneTransaction$tailLocal1 = doneTransaction;
  while (true) {
    var maybeNextChildTrx = $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__dequeueChild__Lcom_raquo_airstream_core_Transaction__O(this, doneTransaction$tailLocal1);
    if ($m_sr_BoxesRunTime$().Q(maybeNextChildTrx, (void 0))) {
      $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__popStack__O(this);
      var maybeParentTransaction = this.XJ();
      if ((!$m_sr_BoxesRunTime$().Q(maybeParentTransaction, (void 0)))) {
        doneTransaction$tailLocal1 = maybeParentTransaction;
      } else {
        return (void 0);
      }
    } else {
      $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__pushToStack__Lcom_raquo_airstream_core_Transaction__V(this, maybeNextChildTrx);
      return (void 0);
    }
  }
});
$p.XJ = (function() {
  return this.Ym[0];
});
var $d_Lcom_raquo_airstream_core_Transaction$pendingTransactions$ = new $TypeData().i($c_Lcom_raquo_airstream_core_Transaction$pendingTransactions$, "com.raquo.airstream.core.Transaction$pendingTransactions$", ({
  o4: 1
}));
var $n_Lcom_raquo_airstream_core_Transaction$pendingTransactions$;
function $m_Lcom_raquo_airstream_core_Transaction$pendingTransactions$() {
  if ((!$n_Lcom_raquo_airstream_core_Transaction$pendingTransactions$)) {
    $n_Lcom_raquo_airstream_core_Transaction$pendingTransactions$ = new $c_Lcom_raquo_airstream_core_Transaction$pendingTransactions$();
  }
  return $n_Lcom_raquo_airstream_core_Transaction$pendingTransactions$;
}
/** @constructor */
function $c_Lcom_raquo_airstream_custom_CustomSource$Config(onWillStart, onStart, onStop) {
  this.a5y = null;
  this.a5w = null;
  this.a5x = null;
  this.a5y = onWillStart;
  this.a5w = onStart;
  this.a5x = onStop;
}
$p = $c_Lcom_raquo_airstream_custom_CustomSource$Config.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_custom_CustomSource$Config;
/** @constructor */
function $h_Lcom_raquo_airstream_custom_CustomSource$Config() {
}
$h_Lcom_raquo_airstream_custom_CustomSource$Config.prototype = $p;
$p.bbS = (function(passes) {
  var passed = new $c_sr_BooleanRef(false);
  return new $c_Lcom_raquo_airstream_custom_CustomSource$Config(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
    var ev$1 = (!(!passes.a3()));
    passed.dy = ev$1;
    if (passed.dy) {
      this.a5y.a3();
    }
  })), new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
    if (passed.dy) {
      this.a5w.a3();
    }
  })), new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
    if (passed.dy) {
      this.a5x.a3();
    }
    var ev$2 = false;
    passed.dy = ev$2;
  })));
});
var $d_Lcom_raquo_airstream_custom_CustomSource$Config = new $TypeData().i($c_Lcom_raquo_airstream_custom_CustomSource$Config, "com.raquo.airstream.custom.CustomSource$Config", ({
  o7: 1
}));
/** @constructor */
function $c_Lcom_raquo_airstream_custom_CustomSource$Config$() {
}
$p = $c_Lcom_raquo_airstream_custom_CustomSource$Config$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_custom_CustomSource$Config$;
/** @constructor */
function $h_Lcom_raquo_airstream_custom_CustomSource$Config$() {
}
$h_Lcom_raquo_airstream_custom_CustomSource$Config$.prototype = $p;
$p.aM8 = (function(onStart, onStop) {
  return new $c_Lcom_raquo_airstream_custom_CustomSource$Config(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => (void 0))), onStart, onStop);
});
var $d_Lcom_raquo_airstream_custom_CustomSource$Config$ = new $TypeData().i($c_Lcom_raquo_airstream_custom_CustomSource$Config$, "com.raquo.airstream.custom.CustomSource$Config$", ({
  o8: 1
}));
var $n_Lcom_raquo_airstream_custom_CustomSource$Config$;
function $m_Lcom_raquo_airstream_custom_CustomSource$Config$() {
  if ((!$n_Lcom_raquo_airstream_custom_CustomSource$Config$)) {
    $n_Lcom_raquo_airstream_custom_CustomSource$Config$ = new $c_Lcom_raquo_airstream_custom_CustomSource$Config$();
  }
  return $n_Lcom_raquo_airstream_custom_CustomSource$Config$;
}
/** @constructor */
function $c_Lcom_raquo_airstream_eventbus_EventBus$() {
}
$p = $c_Lcom_raquo_airstream_eventbus_EventBus$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_eventbus_EventBus$;
/** @constructor */
function $h_Lcom_raquo_airstream_eventbus_EventBus$() {
}
$h_Lcom_raquo_airstream_eventbus_EventBus$.prototype = $p;
var $d_Lcom_raquo_airstream_eventbus_EventBus$ = new $TypeData().i($c_Lcom_raquo_airstream_eventbus_EventBus$, "com.raquo.airstream.eventbus.EventBus$", ({
  od: 1
}));
var $n_Lcom_raquo_airstream_eventbus_EventBus$;
function $m_Lcom_raquo_airstream_eventbus_EventBus$() {
  if ((!$n_Lcom_raquo_airstream_eventbus_EventBus$)) {
    $n_Lcom_raquo_airstream_eventbus_EventBus$ = new $c_Lcom_raquo_airstream_eventbus_EventBus$();
  }
  return $n_Lcom_raquo_airstream_eventbus_EventBus$;
}
/** @constructor */
function $c_Lcom_raquo_airstream_extensions_BooleanObservable$() {
}
$p = $c_Lcom_raquo_airstream_extensions_BooleanObservable$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_extensions_BooleanObservable$;
/** @constructor */
function $h_Lcom_raquo_airstream_extensions_BooleanObservable$() {
}
$h_Lcom_raquo_airstream_extensions_BooleanObservable$.prototype = $p;
$p.r1 = (function(this$) {
  return this$.fQ(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => (!(!(!_$2))))));
});
var $d_Lcom_raquo_airstream_extensions_BooleanObservable$ = new $TypeData().i($c_Lcom_raquo_airstream_extensions_BooleanObservable$, "com.raquo.airstream.extensions.BooleanObservable$", ({
  og: 1
}));
var $n_Lcom_raquo_airstream_extensions_BooleanObservable$;
function $m_Lcom_raquo_airstream_extensions_BooleanObservable$() {
  if ((!$n_Lcom_raquo_airstream_extensions_BooleanObservable$)) {
    $n_Lcom_raquo_airstream_extensions_BooleanObservable$ = new $c_Lcom_raquo_airstream_extensions_BooleanObservable$();
  }
  return $n_Lcom_raquo_airstream_extensions_BooleanObservable$;
}
function $p_Lcom_raquo_airstream_ownership_DynamicOwner__removeSubscriptionNow__Lcom_raquo_airstream_ownership_DynamicSubscription__V($thiz, subscription) {
  var index = ($thiz.AO.indexOf(subscription) | 0);
  if ((index !== (-1))) {
    $thiz.AO.splice(index, 1);
    if ((!$thiz.oJ.c())) {
      subscription.aQH();
    }
  } else {
    throw $ct_jl_Exception__T__(new $c_jl_Exception(), "Can not remove DynamicSubscription from DynamicOwner: subscription not found. Did you already kill it?");
  }
}
function $p_Lcom_raquo_airstream_ownership_DynamicOwner__removePendingSubscriptionsNow__V($thiz) {
  while ((($thiz.YH.length | 0) > 0)) {
    $p_Lcom_raquo_airstream_ownership_DynamicOwner__removeSubscriptionNow__Lcom_raquo_airstream_ownership_DynamicSubscription__V($thiz, $thiz.YH.shift());
  }
}
/** @constructor */
function $c_Lcom_raquo_airstream_ownership_DynamicOwner(onAccessAfterKilled) {
  this.ale = null;
  this.AO = null;
  this.JR = false;
  this.YH = null;
  this.oJ = null;
  this.JS = 0;
  this.ale = onAccessAfterKilled;
  this.AO = $m_Lcom_raquo_ew_JsArray$().fu($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_airstream_ownership_DynamicSubscription.r().C)([])));
  this.JR = true;
  this.YH = $m_Lcom_raquo_ew_JsArray$().fu($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_airstream_ownership_DynamicSubscription.r().C)([])));
  this.oJ = $m_s_None$();
  this.JS = 0;
}
$p = $c_Lcom_raquo_airstream_ownership_DynamicOwner.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_ownership_DynamicOwner;
/** @constructor */
function $h_Lcom_raquo_airstream_ownership_DynamicOwner() {
}
$h_Lcom_raquo_airstream_ownership_DynamicOwner.prototype = $p;
$p.aLK = (function() {
  if ((!(!this.oJ.c()))) {
    var this$4 = $m_Lcom_raquo_airstream_core_Transaction$onStart$();
    var f = (() => {
      var newOwner = new $c_Lcom_raquo_airstream_ownership_OneTimeOwner(this.ale);
      this.oJ = new $c_s_Some(newOwner);
      this.JR = false;
      this.JS = 0;
      var i = 0;
      var originalNumSubs = (this.AO.length | 0);
      while ((i < originalNumSubs)) {
        var ix = ((i + this.JS) | 0);
        this.AO[ix].aQD(newOwner);
        i = ((1 + i) | 0);
      }
      $p_Lcom_raquo_airstream_ownership_DynamicOwner__removePendingSubscriptionsNow__V(this);
      this.JR = true;
      this.JS = 0;
    });
    $m_Lcom_raquo_airstream_core_Transaction$onStart$();
    var when = true;
    if ((this$4.ky || (!when))) {
      f();
    } else {
      this$4.ky = true;
      try {
        f();
      } finally {
        this$4.ky = false;
        $p_Lcom_raquo_airstream_core_Transaction$onStart$__resolve__V(this$4);
      }
    }
  } else {
    throw $ct_jl_Exception__T__(new $c_jl_Exception(), (("Can not activate " + this) + ": it is already active"));
  }
});
$p.aZx = (function() {
  if ((!this.oJ.c())) {
    this.JR = false;
    var arr = this.AO;
    var i = 0;
    var len = (arr.length | 0);
    while ((i < len)) {
      arr[i].aQH();
      i = ((1 + i) | 0);
    }
    $p_Lcom_raquo_airstream_ownership_DynamicOwner__removePendingSubscriptionsNow__V(this);
    var this$4 = this.oJ;
    if ((!this$4.c())) {
      this$4.d().agM();
    }
    $p_Lcom_raquo_airstream_ownership_DynamicOwner__removePendingSubscriptionsNow__V(this);
    this.JR = true;
    this.oJ = $m_s_None$();
  } else {
    throw $ct_jl_Exception__T__(new $c_jl_Exception(), "Can not deactivate DynamicOwner: it is not active");
  }
});
$p.aWR = (function(subscription, prepend) {
  if (prepend) {
    this.JS = ((1 + this.JS) | 0);
    this.AO.unshift(subscription);
  } else {
    this.AO.push(subscription);
  }
  var this$1 = this.oJ;
  if ((!this$1.c())) {
    var x0 = this$1.d();
    subscription.aQD(x0);
  }
});
$p.b7w = (function(subscription) {
  if (this.JR) {
    $p_Lcom_raquo_airstream_ownership_DynamicOwner__removeSubscriptionNow__Lcom_raquo_airstream_ownership_DynamicSubscription__V(this, subscription);
  } else {
    this.YH.push(subscription);
  }
});
var $d_Lcom_raquo_airstream_ownership_DynamicOwner = new $TypeData().i($c_Lcom_raquo_airstream_ownership_DynamicOwner, "com.raquo.airstream.ownership.DynamicOwner", ({
  ou: 1
}));
/** @constructor */
function $c_Lcom_raquo_airstream_ownership_DynamicSubscription(dynamicOwner, activate, prepend) {
  this.YI = null;
  this.alf = null;
  this.YJ = null;
  this.YI = dynamicOwner;
  this.alf = activate;
  this.YJ = $m_s_None$();
  dynamicOwner.aWR(this, prepend);
}
$p = $c_Lcom_raquo_airstream_ownership_DynamicSubscription.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_ownership_DynamicSubscription;
/** @constructor */
function $h_Lcom_raquo_airstream_ownership_DynamicSubscription() {
}
$h_Lcom_raquo_airstream_ownership_DynamicSubscription.prototype = $p;
$p.Xo = (function() {
  this.YI.b7w(this);
});
$p.aQD = (function(owner) {
  var this$2 = $m_Lcom_raquo_airstream_core_Transaction$onStart$();
  var f = (() => {
    this.YJ = this.alf.i(owner);
  });
  $m_Lcom_raquo_airstream_core_Transaction$onStart$();
  var when = true;
  if ((this$2.ky || (!when))) {
    f();
  } else {
    this$2.ky = true;
    try {
      f();
    } finally {
      this$2.ky = false;
      $p_Lcom_raquo_airstream_core_Transaction$onStart$__resolve__V(this$2);
    }
  }
});
$p.aQH = (function() {
  var this$1 = this.YJ;
  if ((!this$1.c())) {
    this$1.d().Xo();
    this.YJ = $m_s_None$();
  }
});
var $d_Lcom_raquo_airstream_ownership_DynamicSubscription = new $TypeData().i($c_Lcom_raquo_airstream_ownership_DynamicSubscription, "com.raquo.airstream.ownership.DynamicSubscription", ({
  ov: 1
}));
/** @constructor */
function $c_Lcom_raquo_airstream_ownership_DynamicSubscription$() {
}
$p = $c_Lcom_raquo_airstream_ownership_DynamicSubscription$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_ownership_DynamicSubscription$;
/** @constructor */
function $h_Lcom_raquo_airstream_ownership_DynamicSubscription$() {
}
$h_Lcom_raquo_airstream_ownership_DynamicSubscription$.prototype = $p;
$p.AI = (function(dynamicOwner, activate, prepend) {
  return new $c_Lcom_raquo_airstream_ownership_DynamicSubscription(dynamicOwner, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((owner) => new $c_s_Some(activate.i(owner)))), prepend);
});
$p.aSz = (function(dynamicOwner, activate, prepend) {
  return new $c_Lcom_raquo_airstream_ownership_DynamicSubscription(dynamicOwner, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((owner) => {
    activate.i(owner);
    return $m_s_None$();
  })), prepend);
});
$p.aSA = (function(dynamicOwner, observable, sink) {
  return $m_Lcom_raquo_airstream_ownership_DynamicSubscription$().AI(dynamicOwner, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((owner) => $f_Lcom_raquo_airstream_core_WritableObservable__addObserver__Lcom_raquo_airstream_core_Observer__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription(observable, sink.Ek(), owner))), false);
});
$p.a4O = (function(dynamicOwner, observable, onNext) {
  return $m_Lcom_raquo_airstream_ownership_DynamicSubscription$().AI(dynamicOwner, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((owner) => $f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription(observable, onNext, owner))), false);
});
var $d_Lcom_raquo_airstream_ownership_DynamicSubscription$ = new $TypeData().i($c_Lcom_raquo_airstream_ownership_DynamicSubscription$, "com.raquo.airstream.ownership.DynamicSubscription$", ({
  ow: 1
}));
var $n_Lcom_raquo_airstream_ownership_DynamicSubscription$;
function $m_Lcom_raquo_airstream_ownership_DynamicSubscription$() {
  if ((!$n_Lcom_raquo_airstream_ownership_DynamicSubscription$)) {
    $n_Lcom_raquo_airstream_ownership_DynamicSubscription$ = new $c_Lcom_raquo_airstream_ownership_DynamicSubscription$();
  }
  return $n_Lcom_raquo_airstream_ownership_DynamicSubscription$;
}
function $f_Lcom_raquo_airstream_ownership_Owner__$init$__V($thiz) {
  $thiz.af1($m_Lcom_raquo_ew_JsArray$().fu($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_airstream_ownership_Subscription.r().C)([]))));
}
function $f_Lcom_raquo_airstream_ownership_Owner__killSubscriptions__V($thiz) {
  var arr = $thiz.Jq();
  var i = 0;
  var len = (arr.length | 0);
  while ((i < len)) {
    $p_Lcom_raquo_airstream_ownership_Subscription__safeCleanup__V(arr[i]);
    i = ((1 + i) | 0);
  }
  $thiz.Jq().length = 0;
}
function $f_Lcom_raquo_airstream_ownership_Owner__onKilledExternally__Lcom_raquo_airstream_ownership_Subscription__V($thiz, subscription) {
  var index = ($thiz.Jq().indexOf(subscription) | 0);
  if ((index !== (-1))) {
    $thiz.Jq().splice(index, 1);
  } else {
    throw $ct_jl_Exception__T__(new $c_jl_Exception(), "Can not remove Subscription from Owner: subscription not found.");
  }
}
function $f_Lcom_raquo_airstream_ownership_Owner__own__Lcom_raquo_airstream_ownership_Subscription__V($thiz, subscription) {
  $thiz.Jq().push(subscription);
}
function $p_Lcom_raquo_airstream_ownership_Subscription__safeCleanup__V($thiz) {
  if ((!$thiz.a5W)) {
    $thiz.alj.a3();
    $thiz.a5W = true;
  } else {
    throw $ct_jl_Exception__T__(new $c_jl_Exception(), "Can not kill Subscription: it was already killed.");
  }
}
/** @constructor */
function $c_Lcom_raquo_airstream_ownership_Subscription(owner, cleanup) {
  this.alk = null;
  this.alj = null;
  this.a5W = false;
  this.alk = owner;
  this.alj = cleanup;
  this.a5W = false;
  owner.ahm(this);
}
$p = $c_Lcom_raquo_airstream_ownership_Subscription.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_ownership_Subscription;
/** @constructor */
function $h_Lcom_raquo_airstream_ownership_Subscription() {
}
$h_Lcom_raquo_airstream_ownership_Subscription.prototype = $p;
$p.Xo = (function() {
  $p_Lcom_raquo_airstream_ownership_Subscription__safeCleanup__V(this);
  $f_Lcom_raquo_airstream_ownership_Owner__onKilledExternally__Lcom_raquo_airstream_ownership_Subscription__V(this.alk, this);
});
var $d_Lcom_raquo_airstream_ownership_Subscription = new $TypeData().i($c_Lcom_raquo_airstream_ownership_Subscription, "com.raquo.airstream.ownership.Subscription", ({
  oz: 1
}));
/** @constructor */
function $c_Lcom_raquo_airstream_ownership_TransferableSubscription(activate, deactivate) {
  this.all = null;
  this.alm = null;
  this.AP = null;
  this.EA = false;
  this.all = activate;
  this.alm = deactivate;
  this.AP = $m_s_None$();
  this.EA = false;
}
$p = $c_Lcom_raquo_airstream_ownership_TransferableSubscription.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_ownership_TransferableSubscription;
/** @constructor */
function $h_Lcom_raquo_airstream_ownership_TransferableSubscription() {
}
$h_Lcom_raquo_airstream_ownership_TransferableSubscription.prototype = $p;
$p.b36 = (function() {
  var this$1 = this.AP;
  return ((!this$1.c()) && (!this$1.d().YI.oJ.c()));
});
$p.b8H = (function(nextOwner) {
  if (this.EA) {
    throw $ct_jl_Exception__T__(new $c_jl_Exception(), "Unable to set owner on DynamicTransferableSubscription while a transfer on this subscription is already in progress.");
  }
  var this$1 = this.AP;
  if ((!this$1.c())) {
    var x0 = this$1.d();
    var x$2 = x0.YI;
    var $x_1 = ((nextOwner === null) ? (x$2 === null) : (nextOwner === x$2));
  } else {
    var $x_1 = false;
  }
  if ((!$x_1)) {
    if ((this.b36() && (!nextOwner.oJ.c()))) {
      this.EA = true;
    }
    var this$3 = this.AP;
    if ((!this$3.c())) {
      this$3.d().Xo();
      this.AP = $m_s_None$();
    }
    var newPilotSubscription = $m_Lcom_raquo_airstream_ownership_DynamicSubscription$().AI(nextOwner, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((parentOwner) => {
      if ((!this.EA)) {
        this.all.a3();
      }
      return new $c_Lcom_raquo_airstream_ownership_Subscription(parentOwner, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
        if ((!this.EA)) {
          this.alm.a3();
        }
      })));
    })), false);
    this.AP = new $c_s_Some(newPilotSubscription);
    this.EA = false;
  }
});
$p.aYn = (function() {
  if (this.EA) {
    throw $ct_jl_Exception__T__(new $c_jl_Exception(), "Unable to clear owner on DynamicTransferableSubscription while a transfer on this subscription is already in progress.");
  }
  var this$1 = this.AP;
  if ((!this$1.c())) {
    this$1.d().Xo();
  }
  this.AP = $m_s_None$();
});
var $d_Lcom_raquo_airstream_ownership_TransferableSubscription = new $TypeData().i($c_Lcom_raquo_airstream_ownership_TransferableSubscription, "com.raquo.airstream.ownership.TransferableSubscription", ({
  oA: 1
}));
/** @constructor */
function $c_Lcom_raquo_airstream_state_Val$() {
}
$p = $c_Lcom_raquo_airstream_state_Val$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_state_Val$;
/** @constructor */
function $h_Lcom_raquo_airstream_state_Val$() {
}
$h_Lcom_raquo_airstream_state_Val$.prototype = $p;
$p.iT = (function(value) {
  return new $c_Lcom_raquo_airstream_state_Val(new $c_s_util_Success(value));
});
var $d_Lcom_raquo_airstream_state_Val$ = new $TypeData().i($c_Lcom_raquo_airstream_state_Val$, "com.raquo.airstream.state.Val$", ({
  oI: 1
}));
var $n_Lcom_raquo_airstream_state_Val$;
function $m_Lcom_raquo_airstream_state_Val$() {
  if ((!$n_Lcom_raquo_airstream_state_Val$)) {
    $n_Lcom_raquo_airstream_state_Val$ = new $c_Lcom_raquo_airstream_state_Val$();
  }
  return $n_Lcom_raquo_airstream_state_Val$;
}
function $p_Lcom_raquo_airstream_state_Var$__hasDuplicateVars__sci_Seq__Z($thiz, tuples) {
  return $m_Lcom_raquo_airstream_util_package$().b2q(tuples.L(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((t) => new $c_T2(t.g().Ya(), t.Pb())))));
}
/** @constructor */
function $c_Lcom_raquo_airstream_state_Var$() {
}
$p = $c_Lcom_raquo_airstream_state_Var$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_state_Var$;
/** @constructor */
function $h_Lcom_raquo_airstream_state_Var$() {
}
$h_Lcom_raquo_airstream_state_Var$.prototype = $p;
$p.bx = (function(initial) {
  return new $c_Lcom_raquo_airstream_state_SourceVar(new $c_s_util_Success(initial));
});
$p.Y1 = (function(values) {
  this.b8O(values.L(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((v1) => {
    var t = ((v1 === null) ? null : v1.QI);
    return new $c_Lcom_raquo_airstream_state_Var$VarTryTuple(new $c_T2(t.g(), new $c_s_util_Success(t.h())));
  }))));
});
$p.b8O = (function(values) {
  new $c_Lcom_raquo_airstream_core_Transaction(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((trx) => {
    if ($p_Lcom_raquo_airstream_state_Var$__hasDuplicateVars__sci_Seq__Z(this, values.L(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$10) => ((_$10 === null) ? null : _$10.EC)))))) {
      throw new $c_Lcom_raquo_airstream_core_AirstreamError$VarError("Unable to Var.{set,setTry}: the provided list of vars has duplicates. You can't make an observable emit more than one event per transaction.", $m_s_None$());
    }
    values.F(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((trx$2) => ((v1) => {
      var _$11 = ((v1 === null) ? null : v1.EC);
      _$11.g().Eh(_$11.h(), trx$2);
    }))(trx)));
  })));
});
$p.aTb = (function(mods) {
  new $c_Lcom_raquo_airstream_core_Transaction(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((trx) => {
    if ($p_Lcom_raquo_airstream_state_Var$__hasDuplicateVars__sci_Seq__Z(this, mods.L(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$12) => ((_$12 === null) ? null : _$12.EB)))))) {
      throw new $c_Lcom_raquo_airstream_core_AirstreamError$VarError("Unable to Var.update: the provided list of vars has duplicates. You can't make an observable emit more than one event per transaction.", $m_s_None$());
    }
    var tryMods = mods.L(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((v1) => {
      var t = ((v1 === null) ? null : v1.EB);
      return new $c_Lcom_raquo_airstream_state_Var$VarTryModTuple(new $c_T2(t.g(), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((t$1) => t$1.ua(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((curr) => t.h().i(curr))))))));
    })));
    var vars = mods.L(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$13) => ((_$13 === null) ? null : _$13.EB).g())));
    try {
      vars.F(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$14) => _$14.P().aq().d())));
    } catch (e) {
      throw new $c_Lcom_raquo_airstream_core_AirstreamError$VarError("Unable to Var.update a failed Var. Consider Var.tryUpdate instead.", new $c_s_Some(((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e))));
    }
    tryMods.L(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((v1$2) => {
      var t$2 = ((v1$2 === null) ? null : v1$2.QH);
      return new $c_Lcom_raquo_airstream_state_Var$VarTryTuple(new $c_T2(t$2.g(), t$2.h().i(t$2.g().P().aq())));
    }))).F(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((trx$2) => ((v1$3) => {
      var _$15 = ((v1$3 === null) ? null : v1$3.EC);
      _$15.g().Eh(_$15.h(), trx$2);
    }))(trx)));
  })));
});
var $d_Lcom_raquo_airstream_state_Var$ = new $TypeData().i($c_Lcom_raquo_airstream_state_Var$, "com.raquo.airstream.state.Var$", ({
  oJ: 1
}));
var $n_Lcom_raquo_airstream_state_Var$;
function $m_Lcom_raquo_airstream_state_Var$() {
  if ((!$n_Lcom_raquo_airstream_state_Var$)) {
    $n_Lcom_raquo_airstream_state_Var$ = new $c_Lcom_raquo_airstream_state_Var$();
  }
  return $n_Lcom_raquo_airstream_state_Var$;
}
/** @constructor */
function $c_Lcom_raquo_airstream_state_Var$VarModTuple(tuple) {
  this.EB = null;
  this.EB = tuple;
}
$p = $c_Lcom_raquo_airstream_state_Var$VarModTuple.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_state_Var$VarModTuple;
/** @constructor */
function $h_Lcom_raquo_airstream_state_Var$VarModTuple() {
}
$h_Lcom_raquo_airstream_state_Var$VarModTuple.prototype = $p;
$p.x = (function() {
  var this$ = this.EB;
  return $m_s_util_hashing_MurmurHash3$().ab(this$, (-116390334), true);
});
$p.e = (function(x$0) {
  return $m_Lcom_raquo_airstream_state_Var$VarModTuple$().IR(this.EB, x$0);
});
function $isArrayOf_Lcom_raquo_airstream_state_Var$VarModTuple(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eg)));
}
var $d_Lcom_raquo_airstream_state_Var$VarModTuple = new $TypeData().i($c_Lcom_raquo_airstream_state_Var$VarModTuple, "com.raquo.airstream.state.Var$VarModTuple", ({
  eg: 1
}));
/** @constructor */
function $c_Lcom_raquo_airstream_state_Var$VarModTuple$() {
}
$p = $c_Lcom_raquo_airstream_state_Var$VarModTuple$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_state_Var$VarModTuple$;
/** @constructor */
function $h_Lcom_raquo_airstream_state_Var$VarModTuple$() {
}
$h_Lcom_raquo_airstream_state_Var$VarModTuple$.prototype = $p;
$p.IR = (function(this$, x$0) {
  if ((x$0 instanceof $c_Lcom_raquo_airstream_state_Var$VarModTuple)) {
    var x$0$2 = ((x$0 === null) ? null : x$0.EB);
    return ((this$ === null) ? (x$0$2 === null) : this$.e(x$0$2));
  } else {
    return false;
  }
});
var $d_Lcom_raquo_airstream_state_Var$VarModTuple$ = new $TypeData().i($c_Lcom_raquo_airstream_state_Var$VarModTuple$, "com.raquo.airstream.state.Var$VarModTuple$", ({
  oL: 1
}));
var $n_Lcom_raquo_airstream_state_Var$VarModTuple$;
function $m_Lcom_raquo_airstream_state_Var$VarModTuple$() {
  if ((!$n_Lcom_raquo_airstream_state_Var$VarModTuple$)) {
    $n_Lcom_raquo_airstream_state_Var$VarModTuple$ = new $c_Lcom_raquo_airstream_state_Var$VarModTuple$();
  }
  return $n_Lcom_raquo_airstream_state_Var$VarModTuple$;
}
/** @constructor */
function $c_Lcom_raquo_airstream_state_Var$VarTryModTuple(tuple) {
  this.QH = null;
  this.QH = tuple;
}
$p = $c_Lcom_raquo_airstream_state_Var$VarTryModTuple.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_state_Var$VarTryModTuple;
/** @constructor */
function $h_Lcom_raquo_airstream_state_Var$VarTryModTuple() {
}
$h_Lcom_raquo_airstream_state_Var$VarTryModTuple.prototype = $p;
$p.x = (function() {
  var this$ = this.QH;
  return $m_s_util_hashing_MurmurHash3$().ab(this$, (-116390334), true);
});
$p.e = (function(x$0) {
  return $m_Lcom_raquo_airstream_state_Var$VarTryModTuple$().IR(this.QH, x$0);
});
function $isArrayOf_Lcom_raquo_airstream_state_Var$VarTryModTuple(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eh)));
}
var $d_Lcom_raquo_airstream_state_Var$VarTryModTuple = new $TypeData().i($c_Lcom_raquo_airstream_state_Var$VarTryModTuple, "com.raquo.airstream.state.Var$VarTryModTuple", ({
  eh: 1
}));
/** @constructor */
function $c_Lcom_raquo_airstream_state_Var$VarTryModTuple$() {
}
$p = $c_Lcom_raquo_airstream_state_Var$VarTryModTuple$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_state_Var$VarTryModTuple$;
/** @constructor */
function $h_Lcom_raquo_airstream_state_Var$VarTryModTuple$() {
}
$h_Lcom_raquo_airstream_state_Var$VarTryModTuple$.prototype = $p;
$p.IR = (function(this$, x$0) {
  if ((x$0 instanceof $c_Lcom_raquo_airstream_state_Var$VarTryModTuple)) {
    var x$0$2 = ((x$0 === null) ? null : x$0.QH);
    return ((this$ === null) ? (x$0$2 === null) : this$.e(x$0$2));
  } else {
    return false;
  }
});
var $d_Lcom_raquo_airstream_state_Var$VarTryModTuple$ = new $TypeData().i($c_Lcom_raquo_airstream_state_Var$VarTryModTuple$, "com.raquo.airstream.state.Var$VarTryModTuple$", ({
  oM: 1
}));
var $n_Lcom_raquo_airstream_state_Var$VarTryModTuple$;
function $m_Lcom_raquo_airstream_state_Var$VarTryModTuple$() {
  if ((!$n_Lcom_raquo_airstream_state_Var$VarTryModTuple$)) {
    $n_Lcom_raquo_airstream_state_Var$VarTryModTuple$ = new $c_Lcom_raquo_airstream_state_Var$VarTryModTuple$();
  }
  return $n_Lcom_raquo_airstream_state_Var$VarTryModTuple$;
}
/** @constructor */
function $c_Lcom_raquo_airstream_state_Var$VarTryTuple(tuple) {
  this.EC = null;
  this.EC = tuple;
}
$p = $c_Lcom_raquo_airstream_state_Var$VarTryTuple.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_state_Var$VarTryTuple;
/** @constructor */
function $h_Lcom_raquo_airstream_state_Var$VarTryTuple() {
}
$h_Lcom_raquo_airstream_state_Var$VarTryTuple.prototype = $p;
$p.x = (function() {
  var this$ = this.EC;
  return $m_s_util_hashing_MurmurHash3$().ab(this$, (-116390334), true);
});
$p.e = (function(x$0) {
  return $m_Lcom_raquo_airstream_state_Var$VarTryTuple$().IR(this.EC, x$0);
});
function $isArrayOf_Lcom_raquo_airstream_state_Var$VarTryTuple(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ei)));
}
var $d_Lcom_raquo_airstream_state_Var$VarTryTuple = new $TypeData().i($c_Lcom_raquo_airstream_state_Var$VarTryTuple, "com.raquo.airstream.state.Var$VarTryTuple", ({
  ei: 1
}));
/** @constructor */
function $c_Lcom_raquo_airstream_state_Var$VarTryTuple$() {
}
$p = $c_Lcom_raquo_airstream_state_Var$VarTryTuple$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_state_Var$VarTryTuple$;
/** @constructor */
function $h_Lcom_raquo_airstream_state_Var$VarTryTuple$() {
}
$h_Lcom_raquo_airstream_state_Var$VarTryTuple$.prototype = $p;
$p.IR = (function(this$, x$0) {
  if ((x$0 instanceof $c_Lcom_raquo_airstream_state_Var$VarTryTuple)) {
    var x$0$2 = ((x$0 === null) ? null : x$0.EC);
    return ((this$ === null) ? (x$0$2 === null) : this$.e(x$0$2));
  } else {
    return false;
  }
});
var $d_Lcom_raquo_airstream_state_Var$VarTryTuple$ = new $TypeData().i($c_Lcom_raquo_airstream_state_Var$VarTryTuple$, "com.raquo.airstream.state.Var$VarTryTuple$", ({
  oN: 1
}));
var $n_Lcom_raquo_airstream_state_Var$VarTryTuple$;
function $m_Lcom_raquo_airstream_state_Var$VarTryTuple$() {
  if ((!$n_Lcom_raquo_airstream_state_Var$VarTryTuple$)) {
    $n_Lcom_raquo_airstream_state_Var$VarTryTuple$ = new $c_Lcom_raquo_airstream_state_Var$VarTryTuple$();
  }
  return $n_Lcom_raquo_airstream_state_Var$VarTryTuple$;
}
/** @constructor */
function $c_Lcom_raquo_airstream_state_Var$VarTuple(tuple) {
  this.QI = null;
  this.QI = tuple;
}
$p = $c_Lcom_raquo_airstream_state_Var$VarTuple.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_state_Var$VarTuple;
/** @constructor */
function $h_Lcom_raquo_airstream_state_Var$VarTuple() {
}
$h_Lcom_raquo_airstream_state_Var$VarTuple.prototype = $p;
$p.x = (function() {
  var this$ = this.QI;
  return $m_s_util_hashing_MurmurHash3$().ab(this$, (-116390334), true);
});
$p.e = (function(x$0) {
  return $m_Lcom_raquo_airstream_state_Var$VarTuple$().IR(this.QI, x$0);
});
function $isArrayOf_Lcom_raquo_airstream_state_Var$VarTuple(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ej)));
}
var $d_Lcom_raquo_airstream_state_Var$VarTuple = new $TypeData().i($c_Lcom_raquo_airstream_state_Var$VarTuple, "com.raquo.airstream.state.Var$VarTuple", ({
  ej: 1
}));
/** @constructor */
function $c_Lcom_raquo_airstream_state_Var$VarTuple$() {
}
$p = $c_Lcom_raquo_airstream_state_Var$VarTuple$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_state_Var$VarTuple$;
/** @constructor */
function $h_Lcom_raquo_airstream_state_Var$VarTuple$() {
}
$h_Lcom_raquo_airstream_state_Var$VarTuple$.prototype = $p;
$p.IR = (function(this$, x$0) {
  if ((x$0 instanceof $c_Lcom_raquo_airstream_state_Var$VarTuple)) {
    var x$0$2 = ((x$0 === null) ? null : x$0.QI);
    return ((this$ === null) ? (x$0$2 === null) : this$.e(x$0$2));
  } else {
    return false;
  }
});
var $d_Lcom_raquo_airstream_state_Var$VarTuple$ = new $TypeData().i($c_Lcom_raquo_airstream_state_Var$VarTuple$, "com.raquo.airstream.state.Var$VarTuple$", ({
  oO: 1
}));
var $n_Lcom_raquo_airstream_state_Var$VarTuple$;
function $m_Lcom_raquo_airstream_state_Var$VarTuple$() {
  if ((!$n_Lcom_raquo_airstream_state_Var$VarTuple$)) {
    $n_Lcom_raquo_airstream_state_Var$VarTuple$ = new $c_Lcom_raquo_airstream_state_Var$VarTuple$();
  }
  return $n_Lcom_raquo_airstream_state_Var$VarTuple$;
}
/** @constructor */
function $c_Lcom_raquo_airstream_util_JsPriorityQueue(getRank) {
  this.a6g = null;
  this.AQ = null;
  this.a6g = getRank;
  this.AQ = $m_Lcom_raquo_ew_JsArray$().fu($m_sr_ScalaRunTime$().hP(new $ac_O([])));
}
$p = $c_Lcom_raquo_airstream_util_JsPriorityQueue.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_util_JsPriorityQueue;
/** @constructor */
function $h_Lcom_raquo_airstream_util_JsPriorityQueue() {
}
$h_Lcom_raquo_airstream_util_JsPriorityQueue.prototype = $p;
$p.b0D = (function(item) {
  var itemRank = (this.a6g.i(item) | 0);
  var insertAtIndex = 0;
  var foundHigherRank = false;
  while (((insertAtIndex < (this.AQ.length | 0)) && (!foundHigherRank))) {
    if (((this.a6g.i(this.AQ[insertAtIndex]) | 0) > itemRank)) {
      foundHigherRank = true;
    } else {
      insertAtIndex = ((1 + insertAtIndex) | 0);
    }
  }
  this.AQ.splice(insertAtIndex, 0, item);
});
$p.E = (function(item) {
  return ((this.AQ.indexOf(item) | 0) !== (-1));
});
var $d_Lcom_raquo_airstream_util_JsPriorityQueue = new $TypeData().i($c_Lcom_raquo_airstream_util_JsPriorityQueue, "com.raquo.airstream.util.JsPriorityQueue", ({
  oV: 1
}));
/** @constructor */
function $c_Lcom_raquo_airstream_util_package$() {
}
$p = $c_Lcom_raquo_airstream_util_package$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_util_package$;
/** @constructor */
function $h_Lcom_raquo_airstream_util_package$() {
}
$h_Lcom_raquo_airstream_util_package$.prototype = $p;
$p.b2q = (function(tuples) {
  return (tuples.C() !== $m_sci_Set$().af(tuples.L(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => _$2.g())))).aa());
});
var $d_Lcom_raquo_airstream_util_package$ = new $TypeData().i($c_Lcom_raquo_airstream_util_package$, "com.raquo.airstream.util.package$", ({
  oW: 1
}));
var $n_Lcom_raquo_airstream_util_package$;
function $m_Lcom_raquo_airstream_util_package$() {
  if ((!$n_Lcom_raquo_airstream_util_package$)) {
    $n_Lcom_raquo_airstream_util_package$ = new $c_Lcom_raquo_airstream_util_package$();
  }
  return $n_Lcom_raquo_airstream_util_package$;
}
/** @constructor */
function $c_Lcom_raquo_airstream_web_DomEventStream$() {
}
$p = $c_Lcom_raquo_airstream_web_DomEventStream$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_web_DomEventStream$;
/** @constructor */
function $h_Lcom_raquo_airstream_web_DomEventStream$() {
}
$h_Lcom_raquo_airstream_web_DomEventStream$.prototype = $p;
$p.IC = (function(eventTarget, eventKey, useCapture) {
  return new $c_Lcom_raquo_airstream_custom_CustomStreamSource(new $c_sjsr_AnonFunction4_$$Lambda$120c664e6fb20e1c3552e9e8baf775b7682c102c(((fireValue, _$1, _$2, _$3) => {
    var eventHandler = $m_sjs_js_Any$().Pn(fireValue);
    return $m_Lcom_raquo_airstream_custom_CustomSource$Config$().aM8(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
      eventTarget.addEventListener(eventKey, eventHandler, useCapture);
    })), new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
      eventTarget.removeEventListener(eventKey, eventHandler, useCapture);
    })));
  })));
});
var $d_Lcom_raquo_airstream_web_DomEventStream$ = new $TypeData().i($c_Lcom_raquo_airstream_web_DomEventStream$, "com.raquo.airstream.web.DomEventStream$", ({
  oX: 1
}));
var $n_Lcom_raquo_airstream_web_DomEventStream$;
function $m_Lcom_raquo_airstream_web_DomEventStream$() {
  if ((!$n_Lcom_raquo_airstream_web_DomEventStream$)) {
    $n_Lcom_raquo_airstream_web_DomEventStream$ = new $c_Lcom_raquo_airstream_web_DomEventStream$();
  }
  return $n_Lcom_raquo_airstream_web_DomEventStream$;
}
function $ct_Lcom_raquo_airstream_web_FetchBuilder__F1__F1__($thiz, encodeRequest, decodeResponse) {
  $thiz.a6i = encodeRequest;
  $thiz.a6h = decodeResponse;
  return $thiz;
}
/** @constructor */
function $c_Lcom_raquo_airstream_web_FetchBuilder() {
  this.a6i = null;
  this.a6h = null;
}
$p = $c_Lcom_raquo_airstream_web_FetchBuilder.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_web_FetchBuilder;
/** @constructor */
function $h_Lcom_raquo_airstream_web_FetchBuilder() {
}
$h_Lcom_raquo_airstream_web_FetchBuilder.prototype = $p;
$p.aOL = (function(url, setOptions) {
  var options = new $c_Lcom_raquo_airstream_web_FetchOptions(this.a6i);
  setOptions.F(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((setOption) => {
    setOption.i(options);
  })));
  options.a6j.method = "GET";
  var _1 = options.a6j;
  var _2 = options.amq;
  var _3 = options.amr;
  var _4 = options.ams;
  var _5 = options.amt;
  var this$5 = new $c_Lcom_raquo_airstream_web_FetchStream(url, _1, _2, _3, _4, _5);
  var project$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((promise) => {
    $m_Lcom_raquo_airstream_core_EventStream$();
    var this$4 = new $c_Lcom_raquo_airstream_timing_JsPromiseStream(promise, ($m_Lcom_raquo_airstream_core_EventStream$(), false));
    var project = this.a6h;
    return $m_Lcom_raquo_airstream_core_Observable$().AM.mK(new $c_Lcom_raquo_airstream_misc_MapStream(this$4, project, $m_s_None$()));
  }));
  return $m_Lcom_raquo_airstream_core_Observable$().AM.mK(new $c_Lcom_raquo_airstream_misc_MapStream(this$5, project$1, $m_s_None$()));
});
/** @constructor */
function $c_Lcom_raquo_airstream_web_FetchOptions(encodeRequest) {
  this.a6j = null;
  this.amq = null;
  this.amr = null;
  this.ams = false;
  this.amt = false;
  this.a6j = (() => (({})))();
  this.amq = (void 0);
  this.amr = (void 0);
  this.ams = false;
  this.amt = false;
}
$p = $c_Lcom_raquo_airstream_web_FetchOptions.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_web_FetchOptions;
/** @constructor */
function $h_Lcom_raquo_airstream_web_FetchOptions() {
}
$h_Lcom_raquo_airstream_web_FetchOptions.prototype = $p;
var $d_Lcom_raquo_airstream_web_FetchOptions = new $TypeData().i($c_Lcom_raquo_airstream_web_FetchOptions, "com.raquo.airstream.web.FetchOptions", ({
  oZ: 1
}));
/** @constructor */
function $c_Lcom_raquo_ew_JsArray$() {
}
$p = $c_Lcom_raquo_ew_JsArray$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_ew_JsArray$;
/** @constructor */
function $h_Lcom_raquo_ew_JsArray$() {
}
$h_Lcom_raquo_ew_JsArray$.prototype = $p;
$p.fu = (function(items) {
  return [...$m_sjsr_Compat$().Y8(items)];
});
var $d_Lcom_raquo_ew_JsArray$ = new $TypeData().i($c_Lcom_raquo_ew_JsArray$, "com.raquo.ew.JsArray$", ({
  p2: 1
}));
var $n_Lcom_raquo_ew_JsArray$;
function $m_Lcom_raquo_ew_JsArray$() {
  if ((!$n_Lcom_raquo_ew_JsArray$)) {
    $n_Lcom_raquo_ew_JsArray$ = new $c_Lcom_raquo_ew_JsArray$();
  }
  return $n_Lcom_raquo_ew_JsArray$;
}
/** @constructor */
function $c_Lcom_raquo_ew_JsArray$RichJsArray$() {
}
$p = $c_Lcom_raquo_ew_JsArray$RichJsArray$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_ew_JsArray$RichJsArray$;
/** @constructor */
function $h_Lcom_raquo_ew_JsArray$RichJsArray$() {
}
$h_Lcom_raquo_ew_JsArray$RichJsArray$.prototype = $p;
$p.agu = (function(this$, item, fromIndex) {
  return ((this$.indexOf(item, fromIndex) | 0) !== (-1));
});
$p.b1u = (function(this$, cb) {
  var i = 0;
  var len = (this$.length | 0);
  while ((i < len)) {
    cb(this$[i]);
    i = ((1 + i) | 0);
  }
});
var $d_Lcom_raquo_ew_JsArray$RichJsArray$ = new $TypeData().i($c_Lcom_raquo_ew_JsArray$RichJsArray$, "com.raquo.ew.JsArray$RichJsArray$", ({
  p3: 1
}));
var $n_Lcom_raquo_ew_JsArray$RichJsArray$;
function $m_Lcom_raquo_ew_JsArray$RichJsArray$() {
  if ((!$n_Lcom_raquo_ew_JsArray$RichJsArray$)) {
    $n_Lcom_raquo_ew_JsArray$RichJsArray$ = new $c_Lcom_raquo_ew_JsArray$RichJsArray$();
  }
  return $n_Lcom_raquo_ew_JsArray$RichJsArray$;
}
/** @constructor */
function $c_Lcom_raquo_laminar_DomApi$() {
  this.YO = null;
  this.amI = null;
  $n_Lcom_raquo_laminar_DomApi$ = this;
  document.createElement("template");
  this.YO = this.aNd($m_Lcom_raquo_laminar_api_package$().b.j().bo());
  this.amI = new RegExp(" ", "g");
}
$p = $c_Lcom_raquo_laminar_DomApi$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_DomApi$;
/** @constructor */
function $h_Lcom_raquo_laminar_DomApi$() {
}
$h_Lcom_raquo_laminar_DomApi$.prototype = $p;
$p.aX4 = (function(parent, child) {
  try {
    parent.appendChild(child);
    return true;
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if (((e$2 instanceof $c_sjs_js_JavaScriptException) && (!(!(e$2.bf instanceof DOMException))))) {
      return false;
    }
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
  }
});
$p.b7t = (function(parent, child) {
  try {
    parent.removeChild(child);
    return true;
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if (((e$2 instanceof $c_sjs_js_JavaScriptException) && (!(!(e$2.bf instanceof DOMException))))) {
      return false;
    }
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
  }
});
$p.b2T = (function(parent, newChild, referenceChild) {
  try {
    parent.insertBefore(newChild, referenceChild);
    return true;
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if (((e$2 instanceof $c_sjs_js_JavaScriptException) && (!(!(e$2.bf instanceof DOMException))))) {
      return false;
    }
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
  }
});
$p.b2S = (function(parent, newChild, referenceChild) {
  try {
    parent.insertBefore(newChild, referenceChild.nextSibling);
    return true;
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if (((e$2 instanceof $c_sjs_js_JavaScriptException) && (!(!(e$2.bf instanceof DOMException))))) {
      return false;
    }
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
  }
});
$p.b7E = (function(parent, newChild, oldChild) {
  try {
    parent.replaceChild(newChild, oldChild);
    return true;
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if (((e$2 instanceof $c_sjs_js_JavaScriptException) && (!(!(e$2.bf instanceof DOMException))))) {
      return false;
    }
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
  }
});
$p.b3h = (function(node, ancestor) {
  var node$tailLocal1 = node;
  while (true) {
    if ((node$tailLocal1.parentNode !== null)) {
      var effectiveParentNode = node$tailLocal1.parentNode;
    } else {
      var maybeShadowHost = node$tailLocal1.host;
      var effectiveParentNode = ((maybeShadowHost === (void 0)) ? null : maybeShadowHost);
    }
    if ((effectiveParentNode === null)) {
      return false;
    }
    if ($m_sr_BoxesRunTime$().Q(ancestor, effectiveParentNode)) {
      return true;
    }
    node$tailLocal1 = effectiveParentNode;
  }
});
$p.aLQ = (function(element, listener) {
  element.addEventListener(listener.uo.j1.m8, listener.a6C, listener.a6D);
});
$p.aRw = (function(element, listener) {
  element.removeEventListener(listener.uo.j1.m8, listener.a6C, listener.a6D);
});
$p.aZs = (function(tag) {
  return document.createElement(tag.Z0);
});
$p.b24 = (function(element, attr) {
  var x = this.aOS(element, attr);
  return ((x === (void 0)) ? (void 0) : attr.a6y.a37(x));
});
$p.aOS = (function(element, attr) {
  var domValue = element.en.getAttributeNS(null, attr.QO);
  return ((domValue !== null) ? domValue : (void 0));
});
$p.ahZ = (function(element, attr, value) {
  this.b8E(element, attr, attr.a6y.IQ(value));
});
$p.b8E = (function(element, attr, domValue) {
  if ((domValue === null)) {
    this.b7u(element, attr);
  } else {
    element.en.setAttribute(attr.QO, domValue);
  }
});
$p.b7u = (function(element, attr) {
  element.en.removeAttribute(attr.QO);
});
$p.b25 = (function(element, prop) {
  return element.en[prop.oK];
});
$p.aS6 = (function(element, prop, value) {
  this.aS7(element, prop, prop.a6z.IQ(value));
});
$p.aS7 = (function(element, prop, value) {
  element.en[prop.oK] = value;
});
$p.aNd = (function(tag) {
  return document.createElementNS("http://www.w3.org/2000/svg", tag.Z1);
});
$p.b2a = (function(element, attr) {
  var x = this.b2b(element, attr);
  return ((x === (void 0)) ? (void 0) : attr.a6A.a37(x));
});
$p.b2b = (function(element, attr) {
  var $x_2 = element.e8;
  var this$2 = attr.YV;
  var $x_1 = $x_2.getAttributeNS((this$2.c() ? null : this$2.d()), attr.a6B);
  var domValue = $x_1;
  return ((domValue !== null) ? domValue : (void 0));
});
$p.ai0 = (function(element, attr, value) {
  this.b8M(element, attr, attr.a6A.IQ(value));
});
$p.b8M = (function(element, attr, domValue) {
  if ((domValue === null)) {
    this.b7x(element, attr);
  } else {
    var this$1 = attr.YV;
    if (this$1.c()) {
      element.e8.setAttribute(attr.QP, domValue);
    } else {
      var x0 = this$1.d();
      element.e8.setAttributeNS(x0, attr.QP, domValue);
    }
  }
});
$p.b7x = (function(element, attr) {
  var $x_1 = element.e8;
  var this$2 = attr.YV;
  $x_1.removeAttributeNS((this$2.c() ? null : this$2.d()), attr.a6B);
});
$p.b8z = (function(element, attr, value) {
  this.b8A(element, attr, attr.arr.IQ(value));
});
$p.b8A = (function(element, attr, domValue) {
  if ((domValue === null)) {
    this.b7r(element, attr);
  } else {
    element.ed().setAttribute(attr.a6v, domValue);
  }
});
$p.b7r = (function(element, attr) {
  element.ed().removeAttribute(attr.a6v);
});
$p.aZp = (function(text) {
  return document.createComment(text);
});
$p.aZt = (function(text) {
  return document.createTextNode(text);
});
$p.J4 = (function(element) {
  return $m_sc_StringOps$().IJ(element.tagName, 45);
});
$p.aOQ = (function(element) {
  if ((!(!(element instanceof HTMLInputElement)))) {
    if (((element.type === "checkbox") || (element.type === "radio"))) {
      return (!(!element.checked));
    }
  }
  if (this.J4(element)) {
    var x = element.checked;
    new $c_Lcom_raquo_laminar_DomApi$$anon$1(this);
    return ((x === (void 0)) ? (void 0) : (((typeof x) === "boolean") ? (!(!x)) : (void 0)));
  }
});
$p.b8C = (function(element, checked) {
  if ((!(!(element instanceof HTMLInputElement)))) {
    if (((element.type === "checkbox") || (element.type === "radio"))) {
      element.checked = checked;
      return true;
    }
  }
  if (this.J4(element)) {
    element.checked = checked;
    return true;
  }
  return false;
});
$p.age = (function(element) {
  if ((!(!(element instanceof HTMLInputElement)))) {
    return element.value;
  } else if ((!(!(element instanceof HTMLTextAreaElement)))) {
    return element.value;
  } else if ((!(!(element instanceof HTMLSelectElement)))) {
    return element.value;
  } else if ((!(!(element instanceof HTMLButtonElement)))) {
    return element.value;
  } else if ((!(!(element instanceof HTMLOptionElement)))) {
    return element.value;
  } else if (this.J4(element)) {
    var x = element.value;
    new $c_Lcom_raquo_laminar_DomApi$$anon$2(this);
    return ((x === (void 0)) ? (void 0) : (((typeof x) === "string") ? x : (void 0)));
  } else {
    return (void 0);
  }
});
$p.aS8 = (function(element, value) {
  if ((!(!(element instanceof HTMLInputElement)))) {
    element.value = value;
    return true;
  } else if ((!(!(element instanceof HTMLTextAreaElement)))) {
    element.value = value;
    return true;
  } else if ((!(!(element instanceof HTMLSelectElement)))) {
    element.value = value;
    return true;
  } else if ((!(!(element instanceof HTMLButtonElement)))) {
    element.value = value;
    return true;
  } else if ((!(!(element instanceof HTMLOptionElement)))) {
    element.value = value;
    return true;
  } else if (this.J4(element)) {
    element.value = value;
    return true;
  } else {
    return false;
  }
});
$p.baJ = (function(dangerousSvgString) {
  return this.aXL(this.aXK(this.baK(dangerousSvgString), "Error parsing SVG string"), "Error parsing SVG string");
});
$p.baK = (function(dangerousSvgString) {
  this.YO.innerHTML = dangerousSvgString;
  var iterable = this.YO.childNodes;
  var arr = Array.from(iterable);
  this.YO.innerHTML = "";
  return arr;
});
$p.aXK = (function(nodes, clue) {
  if (((nodes.length | 0) !== 1)) {
    throw $ct_jl_Exception__T__(new $c_jl_Exception(), ((clue + ": expected exactly 1 element, got ") + (nodes.length | 0)));
  }
  return nodes[0];
});
$p.aXL = (function(node, clue) {
  if ((!(!(node instanceof SVGElement)))) {
    return node;
  }
  throw $ct_jl_Exception__T__(new $c_jl_Exception(), ((clue + ": expected SVG element, got non-element node: ") + node.nodeName));
});
$p.aXM = (function(tag, node, clue) {
  if ((!(!(node instanceof Element)))) {
    if ((!$m_sr_BoxesRunTime$().Q(tag.bE().toLowerCase(), node.tagName.toLowerCase()))) {
      throw $ct_jl_Exception__T__(new $c_jl_Exception(), (((((clue + ": expected tag name `") + tag.bE()) + "`, got `") + node.tagName) + "`"));
    } else {
      return node;
    }
  }
  throw $ct_jl_Exception__T__(new $c_jl_Exception(), ((clue + ": expected element, got non-element node: ") + node.nodeName));
});
$p.aZz = (function(element, initial) {
  var initial$tailLocal1 = initial;
  var element$tailLocal1 = element;
  while (true) {
    if ((element$tailLocal1 === null)) {
      return initial$tailLocal1;
    }
    var element$tailLocal1$tmp1 = element$tailLocal1.parentNode;
    var initial$tailLocal1$tmp1 = new $c_sci_$colon$colon(this.afg(element$tailLocal1), initial$tailLocal1);
    element$tailLocal1 = element$tailLocal1$tmp1;
    initial$tailLocal1 = initial$tailLocal1$tmp1;
  }
});
$p.afg = (function(node) {
  if ((!(!(node instanceof HTMLElement)))) {
    var id = node.id;
    if ((id !== "")) {
      var suffixStr = ("#" + id);
    } else {
      var classes = node.className;
      var suffixStr = ((classes !== "") ? ("." + classes.replace(this.amI, ".")) : "");
    }
    return (node.tagName.toLowerCase() + suffixStr);
  } else {
    return node.nodeName;
  }
});
$p.aZy = (function(node) {
  return ((!(!(node instanceof Element))) ? node.outerHTML : ((!(!(node instanceof Text))) ? (("Text(" + node.textContent) + ")") : ((!(!(node instanceof Comment))) ? (("Comment(" + node.textContent) + ")") : ((node === null) ? "<null>" : (("OtherNode(" + $dp_toString__T(node)) + ")")))));
});
var $d_Lcom_raquo_laminar_DomApi$ = new $TypeData().i($c_Lcom_raquo_laminar_DomApi$, "com.raquo.laminar.DomApi$", ({
  p4: 1
}));
var $n_Lcom_raquo_laminar_DomApi$;
function $m_Lcom_raquo_laminar_DomApi$() {
  if ((!$n_Lcom_raquo_laminar_DomApi$)) {
    $n_Lcom_raquo_laminar_DomApi$ = new $c_Lcom_raquo_laminar_DomApi$();
  }
  return $n_Lcom_raquo_laminar_DomApi$;
}
/** @constructor */
function $c_Lcom_raquo_laminar_Seq(seq, scalaArray, jsArray) {
  this.a6m = null;
  this.amJ = null;
  this.a6l = null;
  this.a6m = seq;
  this.amJ = scalaArray;
  this.a6l = jsArray;
}
$p = $c_Lcom_raquo_laminar_Seq.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_Seq;
/** @constructor */
function $h_Lcom_raquo_laminar_Seq() {
}
$h_Lcom_raquo_laminar_Seq.prototype = $p;
$p.F = (function(f) {
  if ((this.a6m !== null)) {
    this.a6m.F(f);
  } else if ((this.a6l !== null)) {
    $m_Lcom_raquo_ew_JsArray$RichJsArray$().b1u(this.a6l, $m_sjs_js_Any$().Pn(f));
  } else {
    $m_sc_ArrayOps$().aOh(this.amJ, f);
  }
});
var $d_Lcom_raquo_laminar_Seq = new $TypeData().i($c_Lcom_raquo_laminar_Seq, "com.raquo.laminar.Seq", ({
  p7: 1
}));
/** @constructor */
function $c_Lcom_raquo_laminar_Seq$() {
  this.amK = null;
  $n_Lcom_raquo_laminar_Seq$ = this;
  this.amK = new $c_Lcom_raquo_laminar_Seq($m_sci_Nil$(), null, null);
}
$p = $c_Lcom_raquo_laminar_Seq$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_Seq$;
/** @constructor */
function $h_Lcom_raquo_laminar_Seq$() {
}
$h_Lcom_raquo_laminar_Seq$.prototype = $p;
var $d_Lcom_raquo_laminar_Seq$ = new $TypeData().i($c_Lcom_raquo_laminar_Seq$, "com.raquo.laminar.Seq$", ({
  p8: 1
}));
var $n_Lcom_raquo_laminar_Seq$;
function $m_Lcom_raquo_laminar_Seq$() {
  if ((!$n_Lcom_raquo_laminar_Seq$)) {
    $n_Lcom_raquo_laminar_Seq$ = new $c_Lcom_raquo_laminar_Seq$();
  }
  return $n_Lcom_raquo_laminar_Seq$;
}
function $f_Lcom_raquo_laminar_api_AirstreamAliases__$init$__V($thiz) {
  $thiz.ED = $m_Lcom_raquo_airstream_core_Observer$();
  $thiz.aoM = $m_Lcom_raquo_airstream_core_AirstreamError$();
  $thiz.aTy = $m_Lcom_raquo_airstream_eventbus_EventBus$();
  $thiz.ff = $m_Lcom_raquo_airstream_state_Var$();
}
/** @constructor */
function $c_Lcom_raquo_laminar_api_Implicits$RichSource$() {
}
$p = $c_Lcom_raquo_laminar_api_Implicits$RichSource$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_api_Implicits$RichSource$;
/** @constructor */
function $h_Lcom_raquo_laminar_api_Implicits$RichSource$() {
}
$h_Lcom_raquo_laminar_api_Implicits$RichSource$.prototype = $p;
$p.Dz = (function(this$, sink) {
  return new $c_Lcom_raquo_laminar_modifiers_Binder$$anon$1(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$10) => {
    var observable = this$.dM();
    return $m_Lcom_raquo_airstream_ownership_DynamicSubscription$().aSA(_$10.kq(), observable, sink);
  })), $m_Lcom_raquo_laminar_modifiers_Binder$());
});
$p.ft = (function(this$, onNext) {
  return new $c_Lcom_raquo_laminar_modifiers_Binder$$anon$1(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$11) => {
    var observable = this$.dM();
    return $m_Lcom_raquo_airstream_ownership_DynamicSubscription$().a4O(_$11.kq(), observable, onNext);
  })), $m_Lcom_raquo_laminar_modifiers_Binder$());
});
$p.aVx = (function(this$, onNext, evidence) {
  return new $c_Lcom_raquo_laminar_modifiers_Binder$$anon$1(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$12) => {
    var observable = this$.dM();
    var onNext$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$13) => {
      onNext.a3();
    }));
    return $m_Lcom_raquo_airstream_ownership_DynamicSubscription$().a4O(_$12.kq(), observable, onNext$1);
  })), $m_Lcom_raquo_laminar_modifiers_Binder$());
});
var $d_Lcom_raquo_laminar_api_Implicits$RichSource$ = new $TypeData().i($c_Lcom_raquo_laminar_api_Implicits$RichSource$, "com.raquo.laminar.api.Implicits$RichSource$", ({
  pa: 1
}));
var $n_Lcom_raquo_laminar_api_Implicits$RichSource$;
function $m_Lcom_raquo_laminar_api_Implicits$RichSource$() {
  if ((!$n_Lcom_raquo_laminar_api_Implicits$RichSource$)) {
    $n_Lcom_raquo_laminar_api_Implicits$RichSource$ = new $c_Lcom_raquo_laminar_api_Implicits$RichSource$();
  }
  return $n_Lcom_raquo_laminar_api_Implicits$RichSource$;
}
function $f_Lcom_raquo_laminar_api_LaminarAliases__$init$__V($thiz) {
  $thiz.a6o = $m_Lcom_raquo_laminar_modifiers_Modifier$();
}
function $f_Lcom_raquo_laminar_api_MountHooks__$init$__V($thiz) {
  $thiz.AR = $f_Lcom_raquo_laminar_api_MountHooks__onMountCallback__F1__Lcom_raquo_laminar_modifiers_Modifier($thiz, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => {
    _$1.JW.en.focus();
  })));
}
function $f_Lcom_raquo_laminar_api_MountHooks__onMountCallback__F1__Lcom_raquo_laminar_modifiers_Modifier($thiz, fn) {
  return new $c_Lcom_raquo_laminar_modifiers_Modifier$$anon$2(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((element) => {
    var ignoreNextActivation = new $c_sr_BooleanRef((!element.kq().oJ.c()));
    var activate = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((c) => {
      if (ignoreNextActivation.dy) {
        var ev$5 = false;
        ignoreNextActivation.dy = ev$5;
      } else {
        fn.i(c);
      }
    }));
    $m_Lcom_raquo_airstream_ownership_DynamicSubscription$().aSz(element.kq(), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((element$2) => ((owner) => {
      activate.i(new $c_Lcom_raquo_laminar_lifecycle_MountContext(element$2, owner));
    }))(element)), false);
  })), $m_Lcom_raquo_laminar_modifiers_Modifier$());
}
function $f_Lcom_raquo_laminar_api_MountHooks__onUnmountCallback__F1__Lcom_raquo_laminar_modifiers_Modifier($thiz, fn) {
  return new $c_Lcom_raquo_laminar_modifiers_Modifier$$anon$2(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((element) => {
    var subscribe = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((element$2) => ((c) => new $c_Lcom_raquo_airstream_ownership_Subscription(c.rj, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
      fn.i(element$2);
    })))))(element));
    $m_Lcom_raquo_airstream_ownership_DynamicSubscription$().AI(element.kq(), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((element$2$1) => ((owner) => subscribe.i(new $c_Lcom_raquo_laminar_lifecycle_MountContext(element$2$1, owner))))(element)), false);
  })), $m_Lcom_raquo_laminar_modifiers_Modifier$());
}
function $f_Lcom_raquo_laminar_api_MountHooks__onMountUnmountCallback__F1__F1__Lcom_raquo_laminar_modifiers_Modifier($thiz, mount, unmount) {
  return $f_Lcom_raquo_laminar_api_MountHooks__onMountUnmountCallbackWithState__F1__F2__Lcom_raquo_laminar_modifiers_Modifier($thiz, mount, new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((el, _$6) => {
    unmount.i(el);
  })));
}
function $f_Lcom_raquo_laminar_api_MountHooks__onMountUnmountCallbackWithState__F1__F2__Lcom_raquo_laminar_modifiers_Modifier($thiz, mount, unmount) {
  return new $c_Lcom_raquo_laminar_modifiers_Modifier$$anon$2(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((element) => {
    var ignoreNextActivation = new $c_sr_BooleanRef((!element.kq().oJ.c()));
    var state = new $c_sr_ObjectRef($m_s_None$());
    var subscribe = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((element$2) => ((c) => {
      if (ignoreNextActivation.dy) {
        var ev$6 = false;
        ignoreNextActivation.dy = ev$6;
      } else {
        var ev$7 = new $c_s_Some(mount.i(c));
        state.aD = ev$7;
        ev$7 = null;
      }
      return new $c_Lcom_raquo_airstream_ownership_Subscription(c.rj, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
        unmount.R(element$2, state.aD);
        var ev$8 = $m_s_None$();
        state.aD = ev$8;
        ev$8 = null;
      })));
    }))(element));
    $m_Lcom_raquo_airstream_ownership_DynamicSubscription$().AI(element.kq(), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((element$2$1) => ((owner) => subscribe.i(new $c_Lcom_raquo_laminar_lifecycle_MountContext(element$2$1, owner))))(element)), false);
  })), $m_Lcom_raquo_laminar_modifiers_Modifier$());
}
/** @constructor */
function $c_Lcom_raquo_laminar_api_package$features$() {
  this.arf = null;
  this.arg = false;
}
$p = $c_Lcom_raquo_laminar_api_package$features$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_api_package$features$;
/** @constructor */
function $h_Lcom_raquo_laminar_api_package$features$() {
}
$h_Lcom_raquo_laminar_api_package$features$.prototype = $p;
$p.cz = (function() {
  if ((!this.arg)) {
    this.arf = new $c_Lcom_raquo_laminar_api_package$features$$anon$3(this);
    this.arg = true;
  }
  return this.arf;
});
var $d_Lcom_raquo_laminar_api_package$features$ = new $TypeData().i($c_Lcom_raquo_laminar_api_package$features$, "com.raquo.laminar.api.package$features$", ({
  pm: 1
}));
var $n_Lcom_raquo_laminar_api_package$features$;
function $m_Lcom_raquo_laminar_api_package$features$() {
  if ((!$n_Lcom_raquo_laminar_api_package$features$)) {
    $n_Lcom_raquo_laminar_api_package$features$ = new $c_Lcom_raquo_laminar_api_package$features$();
  }
  return $n_Lcom_raquo_laminar_api_package$features$;
}
/** @constructor */
function $c_Lcom_raquo_laminar_codecs_package$() {
  this.bW = null;
  this.a6r = null;
  this.QN = null;
  this.arh = null;
  $n_Lcom_raquo_laminar_codecs_package$ = this;
  this.bW = new $c_Lcom_raquo_laminar_codecs_package$$anon$2($m_Lcom_raquo_laminar_codecs_package$());
  this.a6r = new $c_Lcom_raquo_laminar_codecs_package$$anon$2($m_Lcom_raquo_laminar_codecs_package$());
  this.QN = new $c_Lcom_raquo_laminar_codecs_package$$anon$2($m_Lcom_raquo_laminar_codecs_package$());
  this.arh = new $c_Lcom_raquo_laminar_codecs_package$$anon$1();
}
$p = $c_Lcom_raquo_laminar_codecs_package$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_codecs_package$;
/** @constructor */
function $h_Lcom_raquo_laminar_codecs_package$() {
}
$h_Lcom_raquo_laminar_codecs_package$.prototype = $p;
var $d_Lcom_raquo_laminar_codecs_package$ = new $TypeData().i($c_Lcom_raquo_laminar_codecs_package$, "com.raquo.laminar.codecs.package$", ({
  po: 1
}));
var $n_Lcom_raquo_laminar_codecs_package$;
function $m_Lcom_raquo_laminar_codecs_package$() {
  if ((!$n_Lcom_raquo_laminar_codecs_package$)) {
    $n_Lcom_raquo_laminar_codecs_package$ = new $c_Lcom_raquo_laminar_codecs_package$();
  }
  return $n_Lcom_raquo_laminar_codecs_package$;
}
function $f_Lcom_raquo_laminar_defs_complex_ComplexHtmlKeys__$init$__V($thiz) {
  $thiz.ap3 = $f_Lcom_raquo_laminar_defs_complex_ComplexHtmlKeys__stringCompositeHtmlAttr__T__T__Lcom_raquo_laminar_keys_CompositeKey($thiz, "class", " ");
  $thiz.y = $thiz.ap3;
}
function $f_Lcom_raquo_laminar_defs_complex_ComplexHtmlKeys__dataAttr__T__Lcom_raquo_laminar_keys_HtmlAttr($thiz, suffix) {
  return new $c_Lcom_raquo_laminar_keys_HtmlAttr(("data-" + suffix), $m_Lcom_raquo_laminar_codecs_package$().bW);
}
function $f_Lcom_raquo_laminar_defs_complex_ComplexHtmlKeys__stringCompositeHtmlAttr__T__T__Lcom_raquo_laminar_keys_CompositeKey($thiz, name, separator) {
  var attr = new $c_Lcom_raquo_laminar_keys_HtmlAttr(name, $m_Lcom_raquo_laminar_codecs_package$().bW);
  return new $c_Lcom_raquo_laminar_keys_CompositeKey(attr.QO, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((el) => {
    var x = $m_Lcom_raquo_laminar_DomApi$().b24(el, attr);
    return ((x === (void 0)) ? "" : x);
  })), new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((el$2, value) => {
    $m_Lcom_raquo_laminar_DomApi$().ahZ(el$2, attr, value);
  })), separator);
}
function $f_Lcom_raquo_laminar_defs_complex_ComplexSvgKeys__$init$__V($thiz) {
  $thiz.a6n = $f_Lcom_raquo_laminar_defs_complex_ComplexSvgKeys__stringCompositeSvgAttr__T__T__Lcom_raquo_laminar_keys_CompositeKey($thiz, "class", " ");
  $thiz.ar = $thiz.a6n;
}
function $f_Lcom_raquo_laminar_defs_complex_ComplexSvgKeys__stringCompositeSvgAttr__T__T__Lcom_raquo_laminar_keys_CompositeKey($thiz, name, separator) {
  var attr = new $c_Lcom_raquo_laminar_keys_SvgAttr(name, $m_Lcom_raquo_laminar_codecs_package$().bW, $m_s_None$());
  return new $c_Lcom_raquo_laminar_keys_CompositeKey(attr.QP, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((el) => {
    var x = $m_Lcom_raquo_laminar_DomApi$().b2a(el, attr);
    return ((x === (void 0)) ? "" : x);
  })), new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((el$2, value) => {
    $m_Lcom_raquo_laminar_DomApi$().ai0(el$2, attr, value);
  })), separator);
}
function $p_Lcom_raquo_laminar_inputs_InputController__setValue__O__Z__V($thiz, nextValue, force) {
  if ((force || (!$m_sr_BoxesRunTime$().Q(nextValue, $thiz.JV.arm.i($thiz.kz))))) {
    $thiz.JV.arn.R($thiz.kz, nextValue);
  }
  $thiz.YP = nextValue;
}
function $p_Lcom_raquo_laminar_inputs_InputController__combinedObserver__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_core_Observer($thiz, owner) {
  var latestSourceValue = new $c_sr_ObjectRef($m_s_None$());
  $f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription($thiz.YQ.a6E, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((sourceValue) => {
    var ev$21 = new $c_s_Some(sourceValue);
    latestSourceValue.aD = ev$21;
    ev$21 = null;
    $p_Lcom_raquo_laminar_inputs_InputController__setValue__O__Z__V($thiz, sourceValue, false);
  })), owner);
  var resetObserver = $m_Lcom_raquo_airstream_core_Observer$().wo(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => {
    var this$4 = latestSourceValue.aD;
    $p_Lcom_raquo_laminar_inputs_InputController__setValue__O__Z__V($thiz, (this$4.c() ? $thiz.YP : this$4.d()), false);
  })), $m_s_PartialFunction$().gt, true);
  var this$7 = $m_Lcom_raquo_airstream_core_Observer$();
  return new $c_Lcom_raquo_airstream_core_Observer$$anon$10($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_airstream_core_Observer.r().C)([$m_Lcom_raquo_airstream_core_Observer$().wo($thiz.a6s.arx, $m_s_PartialFunction$().gt, true), resetObserver])), this$7);
}
function $p_Lcom_raquo_laminar_inputs_InputController__checkControllerCompatibility__V($thiz) {
  if ($thiz.kz.b2r($thiz)) {
    var propDomName$1 = $thiz.oF();
    var eventPropName$1 = $thiz.DV();
    throw $ct_jl_Exception__T__(new $c_jl_Exception(), $m_Lcom_raquo_laminar_inputs_InputController$().y2(propDomName$1, eventPropName$1, $thiz.kz, (("Element already has a `" + $thiz.oF()) + "` controller."), ($m_Lcom_raquo_laminar_inputs_InputController$(), "")));
  }
  if ($thiz.kz.b2p($thiz.oF())) {
    var propDomName$2 = $thiz.oF();
    var eventPropName$2 = $thiz.DV();
    throw $ct_jl_Exception__T__(new $c_jl_Exception(), $m_Lcom_raquo_laminar_inputs_InputController$().y2(propDomName$2, eventPropName$2, $thiz.kz, (("Element already has an uncontrolled `" + $thiz.oF()) + " <-- ???` binder."), ($m_Lcom_raquo_laminar_inputs_InputController$(), "")));
  }
  if ($m_Lcom_raquo_laminar_DomApi$().J4($thiz.kz.en)) {
    matchResult1: {
      var x1 = $thiz.kz.QT;
      if (false) {
        var maybeAllowedConfigs = x1.bd5($thiz.kz.en);
        if ((maybeAllowedConfigs === (void 0))) {
          var $x_1 = true;
        } else {
          if ((maybeAllowedConfigs === (void 0))) {
            throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "undefined.get");
          }
          var $x_2 = maybeAllowedConfigs.length;
          var $x_1 = (($x_2 | 0) === 0);
        }
        if ($x_1) {
          var propDomName$3 = $thiz.oF();
          var eventPropName$3 = $thiz.DV();
          throw $ct_jl_Exception__T__(new $c_jl_Exception(), $m_Lcom_raquo_laminar_inputs_InputController$().y2(propDomName$3, eventPropName$3, $thiz.kz, "This element does not support any controlled props.", ($m_Lcom_raquo_laminar_inputs_InputController$(), "")));
        } else {
          if ((maybeAllowedConfigs === (void 0))) {
            var maybeMatchingPropConfig = (void 0);
          } else {
            _return: {
              var len = (maybeAllowedConfigs.length | 0);
              var i = 0;
              while ((i < len)) {
                var x0 = maybeAllowedConfigs[i];
                var x = x0.YT;
                var x$2 = $thiz.YQ.EF;
                if (((x === null) ? (x$2 === null) : (x === x$2))) {
                  var idx = i;
                  break _return;
                }
                i = ((1 + i) | 0);
              }
              var idx = (-1);
            }
            var opt = ((idx === (-1)) ? $m_s_None$() : new $c_s_Some(maybeAllowedConfigs[idx]));
            var maybeMatchingPropConfig = (opt.c() ? (void 0) : opt.d());
          }
          if ((maybeMatchingPropConfig === (void 0))) {
            if ((maybeAllowedConfigs === (void 0))) {
              var $x_5;
              throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "undefined.get");
            } else {
              var $x_5 = maybeAllowedConfigs;
            }
            var $x_4 = $x_5.map(((_$5) => _$5.YT.oK));
            var $x_3 = $x_4.join("` or `");
            var expectedPropNames = (("`" + $x_3) + "`");
            throw $ct_jl_Exception__T__(new $c_jl_Exception(), $m_Lcom_raquo_laminar_inputs_InputController$().y2($thiz.oF(), $thiz.DV(), $thiz.kz, (("This element does not support `" + $thiz.oF()) + "` controlled property"), (("Use " + expectedPropNames) + " controlled property instead")));
          } else {
            $p_Lcom_raquo_laminar_inputs_InputController__checkEventPropCompatibility__Lcom_raquo_ew_JsArray__V($thiz, maybeMatchingPropConfig.YS);
            break matchResult1;
          }
        }
      }
    }
  } else {
    var expectedPropName = $thiz.JV.YT.oK;
    if (($thiz.oF() !== expectedPropName)) {
      throw $ct_jl_Exception__T__(new $c_jl_Exception(), $m_Lcom_raquo_laminar_inputs_InputController$().y2($thiz.oF(), $thiz.DV(), $thiz.kz, (("This element does not support `" + $thiz.oF()) + "` controlled property"), (("Use `" + expectedPropName) + "` controlled property instead")));
    } else {
      $p_Lcom_raquo_laminar_inputs_InputController__checkEventPropCompatibility__Lcom_raquo_ew_JsArray__V($thiz, $thiz.JV.YS);
    }
  }
}
function $p_Lcom_raquo_laminar_inputs_InputController__checkEventPropCompatibility__Lcom_raquo_ew_JsArray__V($thiz, expectedEventProps) {
  var expectedEventProps$2 = $thiz.JV.YS;
  _return: {
    var len = (expectedEventProps$2.length | 0);
    var i = 0;
    while ((i < len)) {
      if ((expectedEventProps$2[i].m8 === $thiz.DV())) {
        var $x_1 = i;
        break _return;
      }
      i = ((1 + i) | 0);
    }
    var $x_1 = (-1);
  }
  if (($x_1 < 0)) {
    var expectedEventPropNames = (("`" + expectedEventProps$2.map(((_$7) => _$7.m8)).join("` or `")) + "`");
    throw $ct_jl_Exception__T__(new $c_jl_Exception(), $m_Lcom_raquo_laminar_inputs_InputController$().y2($thiz.oF(), $thiz.DV(), $thiz.kz, (("This element does not support `" + $thiz.DV()) + "` event for controlled inputs"), (("Use " + expectedEventPropNames) + " event instead")));
  }
}
/** @constructor */
function $c_Lcom_raquo_laminar_inputs_InputController(config, element, updater, listener) {
  this.JV = null;
  this.kz = null;
  this.YQ = null;
  this.a6s = null;
  this.YP = null;
  this.ari = null;
  this.JV = config;
  this.kz = element;
  this.YQ = updater;
  this.a6s = listener;
  this.YP = config.a6t;
  this.ari = listener.uo.b5l(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => {
    $p_Lcom_raquo_laminar_inputs_InputController__setValue__O__Z__V(this, this.YP, false);
  })));
  $p_Lcom_raquo_laminar_inputs_InputController__setValue__O__Z__V(this, config.a6t, true);
}
$p = $c_Lcom_raquo_laminar_inputs_InputController.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_inputs_InputController;
/** @constructor */
function $h_Lcom_raquo_laminar_inputs_InputController() {
}
$h_Lcom_raquo_laminar_inputs_InputController.prototype = $p;
$p.oF = (function() {
  return this.YQ.EF.oK;
});
$p.DV = (function() {
  return this.a6s.uo.j1.m8;
});
$p.aXZ = (function() {
  var element = this.kz;
  var subscribe = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((ctx) => {
    $p_Lcom_raquo_laminar_inputs_InputController__checkControllerCompatibility__V(this);
    var this$2 = this.kz;
    var x = this$2.YW;
    if ((x !== (void 0))) {
      var i = 0;
      var len = (x.length | 0);
      while ((i < len)) {
        var arg1$2 = x[i];
        $m_Lcom_raquo_laminar_DomApi$().aRw(this.kz.en, arg1$2);
        i = ((1 + i) | 0);
      }
    }
    var dynSub = new $c_Lcom_raquo_laminar_modifiers_EventListener(this.ari, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((sink) => ((_$1) => {
      sink.bA(_$1);
    }))($p_Lcom_raquo_laminar_inputs_InputController__combinedObserver__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_core_Observer(this, ctx.rj)))).aeT(this.kz, true);
    var this$12 = this.kz;
    var x$1 = this$12.YW;
    if ((x$1 !== (void 0))) {
      var i$1 = 0;
      var len$1 = (x$1.length | 0);
      while ((i$1 < len$1)) {
        var arg1$2$1 = x$1[i$1];
        $m_Lcom_raquo_laminar_DomApi$().aLQ(this.kz.en, arg1$2$1);
        i$1 = ((1 + i$1) | 0);
      }
    }
    return new $c_Lcom_raquo_airstream_ownership_Subscription(ctx.rj, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
      dynSub.Xo();
    })));
  }));
  return $m_Lcom_raquo_airstream_ownership_DynamicSubscription$().AI(element.YY, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((owner) => subscribe.i(new $c_Lcom_raquo_laminar_lifecycle_MountContext(element, owner)))), false);
});
var $d_Lcom_raquo_laminar_inputs_InputController = new $TypeData().i($c_Lcom_raquo_laminar_inputs_InputController, "com.raquo.laminar.inputs.InputController", ({
  pC: 1
}));
function $p_Lcom_raquo_laminar_inputs_InputController$__nodeDescription__Lcom_raquo_laminar_nodes_ReactiveHtmlElement__T($thiz, element) {
  var maybeTyp = $m_Lcom_raquo_laminar_DomApi$().aOS(element, $m_Lcom_raquo_laminar_api_package$().b.wl());
  var x = ((maybeTyp === (void 0)) ? (void 0) : ((" [type=" + maybeTyp) + "]"));
  var typSuffix = ((x === (void 0)) ? "" : x);
  return (("" + $m_Lcom_raquo_laminar_DomApi$().afg(element.en)) + typSuffix);
}
/** @constructor */
function $c_Lcom_raquo_laminar_inputs_InputController$() {
  this.YR = null;
  this.arl = null;
  this.arj = null;
  this.ark = null;
  $n_Lcom_raquo_laminar_inputs_InputController$ = this;
  this.YR = new $c_Lcom_raquo_laminar_inputs_InputController$InputControllerConfig("", $m_Lcom_raquo_laminar_api_package$().b.jx(), $m_Lcom_raquo_ew_JsArray$().fu($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_keys_EventProp.r().C)([$m_Lcom_raquo_laminar_api_package$().b.oE()]))), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((el) => {
    var x = $m_Lcom_raquo_laminar_DomApi$().age(el.en);
    return ((x === (void 0)) ? "" : x);
  })), new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((el$2, v) => {
    $m_Lcom_raquo_laminar_DomApi$().aS8(el$2.en, v);
  })));
  this.arl = new $c_Lcom_raquo_laminar_inputs_InputController$InputControllerConfig("", $m_Lcom_raquo_laminar_api_package$().b.jx(), $m_Lcom_raquo_ew_JsArray$().fu($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_keys_EventProp.r().C)([$m_Lcom_raquo_laminar_api_package$().b.oE(), $m_Lcom_raquo_laminar_api_package$().b.Eb()]))), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((el$3) => {
    var x$1 = $m_Lcom_raquo_laminar_DomApi$().age(el$3.en);
    return ((x$1 === (void 0)) ? "" : x$1);
  })), new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((el$4, v$2) => {
    $m_Lcom_raquo_laminar_DomApi$().aS8(el$4.en, v$2);
  })));
  this.arj = new $c_Lcom_raquo_laminar_inputs_InputController$InputControllerConfig(false, $m_Lcom_raquo_laminar_api_package$().b.Wr(), $m_Lcom_raquo_ew_JsArray$().fu($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_keys_EventProp.r().C)([$m_Lcom_raquo_laminar_api_package$().b.oE(), $m_Lcom_raquo_laminar_api_package$().b.bR()]))), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((el$5) => {
    var x$2 = $m_Lcom_raquo_laminar_DomApi$().aOQ(el$5.en);
    return (!(!((x$2 === (void 0)) ? false : x$2)));
  })), new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((v1, v2) => {
    var v$1 = (!(!v2));
    $m_Lcom_raquo_laminar_DomApi$().b8C(v1.en, v$1);
  })));
  this.ark = $m_Lcom_raquo_ew_JsArray$().fu($m_sr_ScalaRunTime$().f(new ($d_T.r().C)(["value", "checked"])));
}
$p = $c_Lcom_raquo_laminar_inputs_InputController$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_inputs_InputController$;
/** @constructor */
function $h_Lcom_raquo_laminar_inputs_InputController$() {
}
$h_Lcom_raquo_laminar_inputs_InputController$.prototype = $p;
$p.qU = (function(listener, updater) {
  return new $c_Lcom_raquo_laminar_modifiers_Binder$$anon$1(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((element) => {
    var propDomName = updater.EF.oK;
    var maybeControllableProps = element.aN0();
    if (((maybeControllableProps !== (void 0)) && $m_Lcom_raquo_ew_JsArray$RichJsArray$().agu(maybeControllableProps, propDomName, 0))) {
      if ($m_Lcom_raquo_laminar_DomApi$().J4(element.en)) {
        matchResult2: {
          var controller;
          var x3 = element.QT;
          if (false) {
            var x = x3.bd4(updater.EF);
            if ((x === (void 0))) {
              var eventPropName = listener.uo.j1.m8;
              throw $ct_jl_Exception__T__(new $c_jl_Exception(), this.y2(updater.EF.oK, eventPropName, element, (("This element does not support `" + propDomName) + "` controlled property in its current configuration"), "Make sure you passed the right props / attributes, such as `type` for HTML inputs."));
            }
            var controller = new $c_Lcom_raquo_laminar_inputs_InputController(x, element, updater, listener);
            break matchResult2;
          }
          throw $ct_jl_Exception__T__(new $c_jl_Exception(), (("Custom element `" + $p_Lcom_raquo_laminar_inputs_InputController$__nodeDescription__Lcom_raquo_laminar_nodes_ReactiveHtmlElement__T(this, element)) + "` must use CustomHtmlTag in order to support `controlled` inputs."));
        }
      } else {
        var x$1 = this.aWV(element.en);
        if ((x$1 === (void 0))) {
          throw $ct_jl_Exception__T__(new $c_jl_Exception(), this.y2(propDomName, listener.uo.j1.m8, element, "This element does not support any controlled input props.", ""));
        }
        var controller = new $c_Lcom_raquo_laminar_inputs_InputController(x$1, element, updater, listener);
      }
      return element.aY0(controller);
    } else {
      var eventPropName$2 = listener.uo.j1.m8;
      if ((maybeControllableProps === (void 0))) {
        throw $ct_jl_Exception__T__(new $c_jl_Exception(), this.y2(propDomName, eventPropName$2, element, "This element does not support any controlled input props.", ""));
      }
      throw $ct_jl_Exception__T__(new $c_jl_Exception(), this.y2(propDomName, eventPropName$2, element, (("This element does not support `" + propDomName) + "` controlled property"), (("Use `" + maybeControllableProps.join("` or `")) + "` controlled property instead")));
    }
  })), $m_Lcom_raquo_laminar_modifiers_Binder$());
});
$p.aWV = (function(element) {
  if ((!(!(element instanceof HTMLInputElement)))) {
    switch (element.type) {
      case "text": {
        return this.YR;
        break;
      }
      case "checkbox":
      case "radio": {
        return this.arj;
        break;
      }
      case "file": {
        return (void 0);
        break;
      }
      default: {
        return this.YR;
      }
    }
  } else {
    return ((!(!(element instanceof HTMLTextAreaElement))) ? this.YR : ((!(!(element instanceof HTMLSelectElement))) ? this.arl : (void 0)));
  }
});
$p.y2 = (function(propDomName, eventPropName, element, reason, suggestion) {
  return $m_Lcom_raquo_ew_JsArray$().fu($m_sr_ScalaRunTime$().f(new ($d_T.r().C)([(((((("Can not add input controller (prop: `" + propDomName) + "` + event: `") + eventPropName) + "`) to element `") + $p_Lcom_raquo_laminar_inputs_InputController$__nodeDescription__Lcom_raquo_laminar_nodes_ReactiveHtmlElement__T($m_Lcom_raquo_laminar_inputs_InputController$(), element)) + "`"), ((reason !== "") ? ("- Cause: " + reason) : ""), ((suggestion !== "") ? ("- Suggestion: " + suggestion) : "")]))).filter(((_$9) => (_$9 !== ""))).join("\n");
});
var $d_Lcom_raquo_laminar_inputs_InputController$ = new $TypeData().i($c_Lcom_raquo_laminar_inputs_InputController$, "com.raquo.laminar.inputs.InputController$", ({
  pD: 1
}));
var $n_Lcom_raquo_laminar_inputs_InputController$;
function $m_Lcom_raquo_laminar_inputs_InputController$() {
  if ((!$n_Lcom_raquo_laminar_inputs_InputController$)) {
    $n_Lcom_raquo_laminar_inputs_InputController$ = new $c_Lcom_raquo_laminar_inputs_InputController$();
  }
  return $n_Lcom_raquo_laminar_inputs_InputController$;
}
/** @constructor */
function $c_Lcom_raquo_laminar_inputs_InputController$InputControllerConfig(initialValue, prop, allowedEventProps, getDomValue, setDomValue) {
  this.a6t = null;
  this.YT = null;
  this.YS = null;
  this.arm = null;
  this.arn = null;
  this.a6t = initialValue;
  this.YT = prop;
  this.YS = allowedEventProps;
  this.arm = getDomValue;
  this.arn = setDomValue;
}
$p = $c_Lcom_raquo_laminar_inputs_InputController$InputControllerConfig.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_inputs_InputController$InputControllerConfig;
/** @constructor */
function $h_Lcom_raquo_laminar_inputs_InputController$InputControllerConfig() {
}
$h_Lcom_raquo_laminar_inputs_InputController$InputControllerConfig.prototype = $p;
var $d_Lcom_raquo_laminar_inputs_InputController$InputControllerConfig = new $TypeData().i($c_Lcom_raquo_laminar_inputs_InputController$InputControllerConfig, "com.raquo.laminar.inputs.InputController$InputControllerConfig", ({
  pE: 1
}));
/** @constructor */
function $c_Lcom_raquo_laminar_inserters_ChildInserter$() {
}
$p = $c_Lcom_raquo_laminar_inserters_ChildInserter$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_inserters_ChildInserter$;
/** @constructor */
function $h_Lcom_raquo_laminar_inserters_ChildInserter$() {
}
$h_Lcom_raquo_laminar_inserters_ChildInserter$.prototype = $p;
$p.nv = (function(childSource, renderable, initialHooks) {
  return new $c_Lcom_raquo_laminar_inserters_DynamicInserter($m_s_None$(), true, new $c_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96(((ctx, owner, hooks) => {
    if ((!ctx.yw)) {
      ctx.a3q();
    }
    return $f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription(childSource, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((ctx$2, maybeLastSeenChild) => ((newComponent) => {
      this.b9B(maybeLastSeenChild.aD, newComponent, ctx$2, hooks);
      var ev$3 = newComponent;
      maybeLastSeenChild.aD = ev$3;
      ev$3 = null;
    }))(ctx, new $c_sr_ObjectRef((void 0)))), owner);
  })), initialHooks);
});
$p.b9B = (function(maybeLastSeenChild, newChildNode, ctx, hooks) {
  if ((!ctx.yw)) {
    ctx.a3q();
  }
  var elem = ctx.yu;
  var elem$1 = 0;
  elem$1 = elem;
  var x$1 = (((maybeLastSeenChild === (void 0)) || $m_sr_BoxesRunTime$().Q(maybeLastSeenChild.ed(), ctx.yv.ed().nextSibling)) ? maybeLastSeenChild : (void 0));
  if ((x$1 === (void 0))) {
    $m_Lcom_raquo_laminar_nodes_ParentNode$().a3N(ctx.AS, newChildNode, ctx.yv, hooks);
  } else if (($m_Lcom_raquo_laminar_nodes_ParentNode$().aRH(ctx.AS, x$1, newChildNode, hooks) || (x$1 === newChildNode))) {
    var ev$4 = ((elem$1 - 1) | 0);
    elem$1 = ev$4;
  }
  ctx.aRy(newChildNode);
  ctx.wp.clear();
  ctx.wp.set(newChildNode.ed(), newChildNode);
  ctx.yu = 1;
});
var $d_Lcom_raquo_laminar_inserters_ChildInserter$ = new $TypeData().i($c_Lcom_raquo_laminar_inserters_ChildInserter$, "com.raquo.laminar.inserters.ChildInserter$", ({
  pF: 1
}));
var $n_Lcom_raquo_laminar_inserters_ChildInserter$;
function $m_Lcom_raquo_laminar_inserters_ChildInserter$() {
  if ((!$n_Lcom_raquo_laminar_inserters_ChildInserter$)) {
    $n_Lcom_raquo_laminar_inserters_ChildInserter$ = new $c_Lcom_raquo_laminar_inserters_ChildInserter$();
  }
  return $n_Lcom_raquo_laminar_inserters_ChildInserter$;
}
/** @constructor */
function $c_Lcom_raquo_laminar_inserters_ChildTextInserter$() {
}
$p = $c_Lcom_raquo_laminar_inserters_ChildTextInserter$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_inserters_ChildTextInserter$;
/** @constructor */
function $h_Lcom_raquo_laminar_inserters_ChildTextInserter$() {
}
$h_Lcom_raquo_laminar_inserters_ChildTextInserter$.prototype = $p;
$p.DG = (function(textSource, renderable) {
  return new $c_Lcom_raquo_laminar_inserters_DynamicInserter($m_s_None$(), false, new $c_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96(((ctx, owner, _$1) => $f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription(textSource, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((ctx$2, maybeTextNode) => ((newValue) => {
    var x = maybeTextNode.aD;
    if ((x === (void 0))) {
      var newTextNode = new $c_Lcom_raquo_laminar_nodes_TextNode(renderable.aeP(newValue));
      this.b9E(newTextNode, ctx$2);
      var ev$2 = newTextNode;
      maybeTextNode.aD = ev$2;
      ev$2 = null;
    } else {
      x.YZ.textContent = renderable.aeP(newValue);
    }
  }))(ctx, new $c_sr_ObjectRef((void 0)))), owner))), (void 0));
});
$p.b9E = (function(newTextNode, ctx) {
  $m_Lcom_raquo_laminar_nodes_ParentNode$().aRH(ctx.AS, ctx.yv, newTextNode, (void 0));
  ctx.yv = newTextNode;
  if (ctx.yw) {
    ctx.yw = false;
    ctx.aRy(newTextNode);
    ctx.wp.clear();
    ctx.yu = 0;
  }
});
var $d_Lcom_raquo_laminar_inserters_ChildTextInserter$ = new $TypeData().i($c_Lcom_raquo_laminar_inserters_ChildTextInserter$, "com.raquo.laminar.inserters.ChildTextInserter$", ({
  pG: 1
}));
var $n_Lcom_raquo_laminar_inserters_ChildTextInserter$;
function $m_Lcom_raquo_laminar_inserters_ChildTextInserter$() {
  if ((!$n_Lcom_raquo_laminar_inserters_ChildTextInserter$)) {
    $n_Lcom_raquo_laminar_inserters_ChildTextInserter$ = new $c_Lcom_raquo_laminar_inserters_ChildTextInserter$();
  }
  return $n_Lcom_raquo_laminar_inserters_ChildTextInserter$;
}
function $p_Lcom_raquo_laminar_inserters_ChildrenInserter$__updateChildren__Lcom_raquo_ew_JsMap__Lcom_raquo_laminar_Seq__Lcom_raquo_ew_JsMap__Lcom_raquo_laminar_nodes_ReactiveElement__Lcom_raquo_laminar_nodes_ChildNode__I__O__I($thiz, prevChildren, nextChildren, nextChildrenMap, parentNode, sentinelNode, prevChildrenCount, hooks) {
  var index = new $c_sr_IntRef(0);
  var currentChildrenCount = new $c_sr_IntRef(prevChildrenCount);
  var prevChildRef = new $c_sr_ObjectRef(sentinelNode.ed().nextSibling);
  var lastIndexChild = new $c_sr_ObjectRef(sentinelNode);
  nextChildren.F(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((nextChild) => {
    if ((currentChildrenCount.an <= index.an)) {
      $m_Lcom_raquo_laminar_nodes_ParentNode$().a3N(parentNode, nextChild, lastIndexChild.aD, hooks);
      var ev$2 = nextChild.ed();
      prevChildRef.aD = ev$2;
      ev$2 = null;
      var ev$3 = ((1 + currentChildrenCount.an) | 0);
      currentChildrenCount.an = ev$3;
    } else if ((!$m_sr_BoxesRunTime$().Q(nextChild.ed(), prevChildRef.aD))) {
      if ((!(!(!prevChildren.has(nextChild.ed()))))) {
        $m_Lcom_raquo_laminar_nodes_ParentNode$().a3N(parentNode, nextChild, lastIndexChild.aD, hooks);
        var ev$4 = nextChild.ed();
        prevChildRef.aD = ev$4;
        ev$4 = null;
        var ev$5 = ((1 + currentChildrenCount.an) | 0);
        currentChildrenCount.an = ev$5;
      } else {
        while (((!$m_sr_BoxesRunTime$().Q(nextChild.ed(), prevChildRef.aD)) && (!$p_Lcom_raquo_laminar_inserters_ChildrenInserter$__containsRef__Lcom_raquo_ew_JsMap__Lorg_scalajs_dom_Node__Z($thiz, nextChildrenMap, prevChildRef.aD)))) {
          var nextPrevChildRef = prevChildRef.aD.nextSibling;
          $m_Lcom_raquo_laminar_nodes_ParentNode$().ahB(parentNode, $p_Lcom_raquo_laminar_inserters_ChildrenInserter$__prevChildFromRef__Lcom_raquo_ew_JsMap__Lorg_scalajs_dom_Node__Lcom_raquo_laminar_nodes_ChildNode($thiz, prevChildren, prevChildRef.aD));
          var ev$6 = nextPrevChildRef;
          prevChildRef.aD = ev$6;
          ev$6 = null;
          var ev$7 = ((currentChildrenCount.an - 1) | 0);
          currentChildrenCount.an = ev$7;
        }
        if ((!$m_sr_BoxesRunTime$().Q(nextChild.ed(), prevChildRef.aD))) {
          $m_Lcom_raquo_laminar_nodes_ParentNode$().a3N(parentNode, nextChild, lastIndexChild.aD, hooks);
          var ev$8 = nextChild.ed();
          prevChildRef.aD = ev$8;
          ev$8 = null;
        }
      }
    }
    if ((prevChildRef.aD.nextSibling === null)) {
      var ev$9 = ((1 + index.an) | 0);
      currentChildrenCount.an = ev$9;
    } else {
      var ev$10 = prevChildRef.aD.nextSibling;
      prevChildRef.aD = ev$10;
      ev$10 = null;
    }
    var ev$11 = nextChild;
    lastIndexChild.aD = ev$11;
    ev$11 = null;
    var ev$12 = ((1 + index.an) | 0);
    index.an = ev$12;
  })));
  while ((index.an < currentChildrenCount.an)) {
    var nextPrevChildRef$1 = prevChildRef.aD.nextSibling;
    $m_Lcom_raquo_laminar_nodes_ParentNode$().ahB(parentNode, $p_Lcom_raquo_laminar_inserters_ChildrenInserter$__prevChildFromRef__Lcom_raquo_ew_JsMap__Lorg_scalajs_dom_Node__Lcom_raquo_laminar_nodes_ChildNode($thiz, prevChildren, prevChildRef.aD));
    var ev$13 = nextPrevChildRef$1;
    prevChildRef.aD = ev$13;
    ev$13 = null;
    var ev$14 = ((currentChildrenCount.an - 1) | 0);
    currentChildrenCount.an = ev$14;
  }
  return currentChildrenCount.an;
}
function $p_Lcom_raquo_laminar_inserters_ChildrenInserter$__containsRef__Lcom_raquo_ew_JsMap__Lorg_scalajs_dom_Node__Z($thiz, nextChildrenMap, ref) {
  return (!(!nextChildrenMap.has(ref)));
}
function $p_Lcom_raquo_laminar_inserters_ChildrenInserter$__prevChildFromRef__Lcom_raquo_ew_JsMap__Lorg_scalajs_dom_Node__Lcom_raquo_laminar_nodes_ChildNode($thiz, prevChildren, ref) {
  var x = prevChildren.get(ref);
  if ((x === (void 0))) {
    throw $ct_jl_Exception__T__(new $c_jl_Exception(), ("prevChildFromRef[children]: not found for " + ref));
  }
  return x;
}
/** @constructor */
function $c_Lcom_raquo_laminar_inserters_ChildrenInserter$() {
}
$p = $c_Lcom_raquo_laminar_inserters_ChildrenInserter$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_inserters_ChildrenInserter$;
/** @constructor */
function $h_Lcom_raquo_laminar_inserters_ChildrenInserter$() {
}
$h_Lcom_raquo_laminar_inserters_ChildrenInserter$.prototype = $p;
$p.IB = (function(childrenSource, renderableSeq, renderableNode, initialHooks) {
  return new $c_Lcom_raquo_laminar_inserters_DynamicInserter($m_s_None$(), true, new $c_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96(((ctx, owner, hooks) => {
    if ((!ctx.yw)) {
      ctx.a3q();
    }
    return $f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription(childrenSource, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((ctx$2) => ((components) => {
      this.b9C(renderableSeq.Q3(components), ctx$2, hooks);
    }))(ctx)), owner);
  })), initialHooks);
});
$p.b9C = (function(newChildren, ctx, hooks) {
  if ((!ctx.yw)) {
    ctx.a3q();
  }
  var newChildrenMap = $m_Lcom_raquo_laminar_inserters_InsertContext$().b57(newChildren);
  ctx.yu = $p_Lcom_raquo_laminar_inserters_ChildrenInserter$__updateChildren__Lcom_raquo_ew_JsMap__Lcom_raquo_laminar_Seq__Lcom_raquo_ew_JsMap__Lcom_raquo_laminar_nodes_ReactiveElement__Lcom_raquo_laminar_nodes_ChildNode__I__O__I(this, ctx.wp, newChildren, newChildrenMap, ctx.AS, ctx.yv, ctx.yu, hooks);
  ctx.wp = newChildrenMap;
});
var $d_Lcom_raquo_laminar_inserters_ChildrenInserter$ = new $TypeData().i($c_Lcom_raquo_laminar_inserters_ChildrenInserter$, "com.raquo.laminar.inserters.ChildrenInserter$", ({
  pH: 1
}));
var $n_Lcom_raquo_laminar_inserters_ChildrenInserter$;
function $m_Lcom_raquo_laminar_inserters_ChildrenInserter$() {
  if ((!$n_Lcom_raquo_laminar_inserters_ChildrenInserter$)) {
    $n_Lcom_raquo_laminar_inserters_ChildrenInserter$ = new $c_Lcom_raquo_laminar_inserters_ChildrenInserter$();
  }
  return $n_Lcom_raquo_laminar_inserters_ChildrenInserter$;
}
/** @constructor */
function $c_Lcom_raquo_laminar_inserters_InsertContext(parentNode, sentinelNode, strictMode, extraNodeCount, extraNodesMap) {
  this.AS = null;
  this.yv = null;
  this.yw = false;
  this.yu = 0;
  this.wp = null;
  this.AS = parentNode;
  this.yv = sentinelNode;
  this.yw = strictMode;
  this.yu = extraNodeCount;
  this.wp = extraNodesMap;
}
$p = $c_Lcom_raquo_laminar_inserters_InsertContext.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_inserters_InsertContext;
/** @constructor */
function $h_Lcom_raquo_laminar_inserters_InsertContext() {
}
$h_Lcom_raquo_laminar_inserters_InsertContext.prototype = $p;
$p.a3q = (function() {
  if ((this.yw || (this.yu !== 0))) {
    throw $ct_jl_Exception__T__(new $c_jl_Exception(), ("forceSetStrictMode invoked when not allowed, inside parent = " + $m_Lcom_raquo_laminar_DomApi$().aZy(this.AS.ed())));
  }
  if ((this.wp === null)) {
    this.wp = new Map();
  }
  if ((!(!(!(this.yv.ed() instanceof Comment))))) {
    var contentNode = this.yv;
    var newSentinelNode = new $c_Lcom_raquo_laminar_nodes_CommentNode("");
    $m_Lcom_raquo_laminar_DomApi$().b2T(this.AS.ed(), newSentinelNode.a6G, contentNode.ed());
    this.yv = newSentinelNode;
    this.yu = 1;
    this.wp.set(contentNode.ed(), contentNode);
  }
  this.yw = true;
});
$p.aRy = (function(after) {
  var elem = this.yu;
  var elem$1 = 0;
  elem$1 = elem;
  while ((elem$1 > 0)) {
    var prevChildRef = after.ed().nextSibling;
    if ((prevChildRef === null)) {
      var ev$3 = 0;
      elem$1 = ev$3;
    } else {
      var maybePrevChild = this.wp.get(prevChildRef);
      if ((maybePrevChild === (void 0))) {
        var ev$4 = 0;
        elem$1 = ev$4;
      } else if ((maybePrevChild !== (void 0))) {
        $m_Lcom_raquo_laminar_nodes_ParentNode$().ahB(this.AS, maybePrevChild);
        var ev$5 = ((elem$1 - 1) | 0);
        elem$1 = ev$5;
      }
    }
  }
});
var $d_Lcom_raquo_laminar_inserters_InsertContext = new $TypeData().i($c_Lcom_raquo_laminar_inserters_InsertContext, "com.raquo.laminar.inserters.InsertContext", ({
  pK: 1
}));
/** @constructor */
function $c_Lcom_raquo_laminar_inserters_InsertContext$() {
}
$p = $c_Lcom_raquo_laminar_inserters_InsertContext$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_inserters_InsertContext$;
/** @constructor */
function $h_Lcom_raquo_laminar_inserters_InsertContext$() {
}
$h_Lcom_raquo_laminar_inserters_InsertContext$.prototype = $p;
$p.b7G = (function(parentNode, strictMode, hooks) {
  var sentinelNode = new $c_Lcom_raquo_laminar_nodes_CommentNode("");
  $m_Lcom_raquo_laminar_nodes_ParentNode$().DF(parentNode, sentinelNode, hooks);
  return this.baI(parentNode, sentinelNode, strictMode);
});
$p.baI = (function(parentNode, sentinelNode, strictMode) {
  return new $c_Lcom_raquo_laminar_inserters_InsertContext(parentNode, sentinelNode, strictMode, 0, (strictMode ? new Map() : null));
});
$p.b57 = (function(nodes) {
  var acc = new Map();
  nodes.F(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((node) => {
    acc.set(node.ed(), node);
  })));
  return acc;
});
var $d_Lcom_raquo_laminar_inserters_InsertContext$ = new $TypeData().i($c_Lcom_raquo_laminar_inserters_InsertContext$, "com.raquo.laminar.inserters.InsertContext$", ({
  pL: 1
}));
var $n_Lcom_raquo_laminar_inserters_InsertContext$;
function $m_Lcom_raquo_laminar_inserters_InsertContext$() {
  if ((!$n_Lcom_raquo_laminar_inserters_InsertContext$)) {
    $n_Lcom_raquo_laminar_inserters_InsertContext$ = new $c_Lcom_raquo_laminar_inserters_InsertContext$();
  }
  return $n_Lcom_raquo_laminar_inserters_InsertContext$;
}
/** @constructor */
function $c_Lcom_raquo_laminar_keys_CompositeKey$() {
}
$p = $c_Lcom_raquo_laminar_keys_CompositeKey$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_keys_CompositeKey$;
/** @constructor */
function $h_Lcom_raquo_laminar_keys_CompositeKey$() {
}
$h_Lcom_raquo_laminar_keys_CompositeKey$.prototype = $p;
$p.a4g = (function(items, separator) {
  return ((items === "") ? $m_sci_Nil$() : $m_sci_Nil$().b6($ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), items.split(separator).filter(((_$1) => (_$1 !== ""))))));
});
var $d_Lcom_raquo_laminar_keys_CompositeKey$ = new $TypeData().i($c_Lcom_raquo_laminar_keys_CompositeKey$, "com.raquo.laminar.keys.CompositeKey$", ({
  pP: 1
}));
var $n_Lcom_raquo_laminar_keys_CompositeKey$;
function $m_Lcom_raquo_laminar_keys_CompositeKey$() {
  if ((!$n_Lcom_raquo_laminar_keys_CompositeKey$)) {
    $n_Lcom_raquo_laminar_keys_CompositeKey$ = new $c_Lcom_raquo_laminar_keys_CompositeKey$();
  }
  return $n_Lcom_raquo_laminar_keys_CompositeKey$;
}
/** @constructor */
function $c_Lcom_raquo_laminar_keys_EventProcessor(eventProp, shouldUseCapture, shouldBePassive, processor) {
  this.j1 = null;
  this.m7 = false;
  this.wq = false;
  this.m6 = null;
  this.j1 = eventProp;
  this.m7 = shouldUseCapture;
  this.wq = shouldBePassive;
  this.m6 = processor;
}
$p = $c_Lcom_raquo_laminar_keys_EventProcessor.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_keys_EventProcessor;
/** @constructor */
function $h_Lcom_raquo_laminar_keys_EventProcessor() {
}
$h_Lcom_raquo_laminar_keys_EventProcessor.prototype = $p;
$p.jY = (function() {
  var newProcessor = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((ev) => {
    var this$2 = this.m6.i(ev);
    if (this$2.c()) {
      return $m_s_None$();
    } else {
      var x0 = this$2.d();
      ev.preventDefault();
      return new $c_s_Some(x0);
    }
  }));
  return new $c_Lcom_raquo_laminar_keys_EventProcessor(this.j1, this.m7, this.wq, newProcessor);
});
$p.AG = (function() {
  var newProcessor = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((ev) => {
    var this$2 = this.m6.i(ev);
    if (this$2.c()) {
      return $m_s_None$();
    } else {
      var x0 = this$2.d();
      ev.stopPropagation();
      return new $c_s_Some(x0);
    }
  }));
  return new $c_Lcom_raquo_laminar_keys_EventProcessor(this.j1, this.m7, this.wq, newProcessor);
});
$p.pt = (function(passes) {
  var newProcessor = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((ev) => {
    var this$2 = this.m6.i(ev);
    return ((this$2.c() || (!(!passes.i(this$2.d())))) ? this$2 : $m_s_None$());
  }));
  return new $c_Lcom_raquo_laminar_keys_EventProcessor(this.j1, this.m7, this.wq, newProcessor);
});
$p.E9 = (function(project) {
  var newProcessor = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((ev) => {
    var this$2 = this.m6.i(ev);
    return (this$2.c() ? $m_s_None$() : new $c_s_Some(project.i(this$2.d())));
  }));
  return new $c_Lcom_raquo_laminar_keys_EventProcessor(this.j1, this.m7, this.wq, newProcessor);
});
$p.Xv = (function(value) {
  var newProcessor = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((ev) => {
    var this$2 = this.m6.i(ev);
    return (this$2.c() ? $m_s_None$() : new $c_s_Some((this$2.d(), value.a3())));
  }));
  return new $c_Lcom_raquo_laminar_keys_EventProcessor(this.j1, this.m7, this.wq, newProcessor);
});
$p.nC = (function() {
  var newProcessor = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((ev) => {
    var this$2 = this.m6.i(ev);
    if (this$2.c()) {
      return $m_s_None$();
    } else {
      this$2.d();
      var x = $m_Lcom_raquo_laminar_DomApi$().age(ev.target);
      return new $c_s_Some(((x === (void 0)) ? "" : x));
    }
  }));
  return new $c_Lcom_raquo_laminar_keys_EventProcessor(this.j1, this.m7, this.wq, newProcessor);
});
$p.agZ = (function() {
  var newProcessor = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((ev) => {
    var this$2 = this.m6.i(ev);
    if (this$2.c()) {
      return $m_s_None$();
    } else {
      this$2.d();
      var x = $m_Lcom_raquo_laminar_DomApi$().aOQ(ev.target);
      return new $c_s_Some((!(!((x === (void 0)) ? false : x))));
    }
  }));
  return new $c_Lcom_raquo_laminar_keys_EventProcessor(this.j1, this.m7, this.wq, newProcessor);
});
$p.b5l = (function(f) {
  var newProcessor = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((ev) => {
    var result = this.m6.i(ev);
    if (result.c()) {
      f.i(ev);
    }
    return result;
  }));
  return new $c_Lcom_raquo_laminar_keys_EventProcessor(this.j1, this.m7, this.wq, newProcessor);
});
var $d_Lcom_raquo_laminar_keys_EventProcessor = new $TypeData().i($c_Lcom_raquo_laminar_keys_EventProcessor, "com.raquo.laminar.keys.EventProcessor", ({
  pT: 1
}));
/** @constructor */
function $c_Lcom_raquo_laminar_keys_EventProcessor$() {
}
$p = $c_Lcom_raquo_laminar_keys_EventProcessor$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_keys_EventProcessor$;
/** @constructor */
function $h_Lcom_raquo_laminar_keys_EventProcessor$() {
}
$h_Lcom_raquo_laminar_keys_EventProcessor$.prototype = $p;
$p.az = (function(eventProp, shouldUseCapture, shouldBePassive) {
  return new $c_Lcom_raquo_laminar_keys_EventProcessor(eventProp, shouldUseCapture, shouldBePassive, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$14) => new $c_s_Some(_$14))));
});
var $d_Lcom_raquo_laminar_keys_EventProcessor$ = new $TypeData().i($c_Lcom_raquo_laminar_keys_EventProcessor$, "com.raquo.laminar.keys.EventProcessor$", ({
  pU: 1
}));
var $n_Lcom_raquo_laminar_keys_EventProcessor$;
function $m_Lcom_raquo_laminar_keys_EventProcessor$() {
  if ((!$n_Lcom_raquo_laminar_keys_EventProcessor$)) {
    $n_Lcom_raquo_laminar_keys_EventProcessor$ = new $c_Lcom_raquo_laminar_keys_EventProcessor$();
  }
  return $n_Lcom_raquo_laminar_keys_EventProcessor$;
}
/** @constructor */
function $c_Lcom_raquo_laminar_keys_Key() {
}
$p = $c_Lcom_raquo_laminar_keys_Key.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_keys_Key;
/** @constructor */
function $h_Lcom_raquo_laminar_keys_Key() {
}
$h_Lcom_raquo_laminar_keys_Key.prototype = $p;
/** @constructor */
function $c_Lcom_raquo_laminar_keys_LockedEventKey(eventProcessor, composer) {
  this.arv = null;
  this.aru = null;
  this.arv = eventProcessor;
  this.aru = composer;
}
$p = $c_Lcom_raquo_laminar_keys_LockedEventKey.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_keys_LockedEventKey;
/** @constructor */
function $h_Lcom_raquo_laminar_keys_LockedEventKey() {
}
$h_Lcom_raquo_laminar_keys_LockedEventKey.prototype = $p;
$p.Iv = (function(sink) {
  return new $c_Lcom_raquo_laminar_modifiers_Binder$$anon$1(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((el) => {
    var observable = this.aru.i($f_Lcom_raquo_laminar_nodes_ReactiveElement__events__Lcom_raquo_laminar_keys_EventProcessor__Lcom_raquo_airstream_core_EventStream(el, this.arv));
    return $m_Lcom_raquo_airstream_ownership_DynamicSubscription$().aSA(el.kq(), observable, sink);
  })), $m_Lcom_raquo_laminar_modifiers_Binder$());
});
var $d_Lcom_raquo_laminar_keys_LockedEventKey = new $TypeData().i($c_Lcom_raquo_laminar_keys_LockedEventKey, "com.raquo.laminar.keys.LockedEventKey", ({
  pX: 1
}));
/** @constructor */
function $c_Lcom_raquo_laminar_keys_SvgAttr$() {
  this.aTB = null;
  this.aTC = null;
  this.aTD = null;
  this.aTE = null;
  this.aTB = "http://www.w3.org/2000/svg";
  this.aTC = "http://www.w3.org/1999/xlink";
  this.aTD = "http://www.w3.org/XML/1998/namespace";
  this.aTE = "http://www.w3.org/2000/xmlns/";
}
$p = $c_Lcom_raquo_laminar_keys_SvgAttr$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_keys_SvgAttr$;
/** @constructor */
function $h_Lcom_raquo_laminar_keys_SvgAttr$() {
}
$h_Lcom_raquo_laminar_keys_SvgAttr$.prototype = $p;
$p.b4J = (function(namespace) {
  switch (namespace) {
    case "svg": {
      return "http://www.w3.org/2000/svg";
      break;
    }
    case "xlink": {
      return "http://www.w3.org/1999/xlink";
      break;
    }
    case "xml": {
      return "http://www.w3.org/XML/1998/namespace";
      break;
    }
    case "xmlns": {
      return "http://www.w3.org/2000/xmlns/";
      break;
    }
    default: {
      throw new $c_s_MatchError(namespace);
    }
  }
});
var $d_Lcom_raquo_laminar_keys_SvgAttr$ = new $TypeData().i($c_Lcom_raquo_laminar_keys_SvgAttr$, "com.raquo.laminar.keys.SvgAttr$", ({
  pZ: 1
}));
var $n_Lcom_raquo_laminar_keys_SvgAttr$;
function $m_Lcom_raquo_laminar_keys_SvgAttr$() {
  if ((!$n_Lcom_raquo_laminar_keys_SvgAttr$)) {
    $n_Lcom_raquo_laminar_keys_SvgAttr$ = new $c_Lcom_raquo_laminar_keys_SvgAttr$();
  }
  return $n_Lcom_raquo_laminar_keys_SvgAttr$;
}
/** @constructor */
function $c_Lcom_raquo_laminar_lifecycle_MountContext(thisNode, owner) {
  this.JW = null;
  this.rj = null;
  this.JW = thisNode;
  this.rj = owner;
}
$p = $c_Lcom_raquo_laminar_lifecycle_MountContext.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_lifecycle_MountContext;
/** @constructor */
function $h_Lcom_raquo_laminar_lifecycle_MountContext() {
}
$h_Lcom_raquo_laminar_lifecycle_MountContext.prototype = $p;
var $d_Lcom_raquo_laminar_lifecycle_MountContext = new $TypeData().i($c_Lcom_raquo_laminar_lifecycle_MountContext, "com.raquo.laminar.lifecycle.MountContext", ({
  q0: 1
}));
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_Binder$() {
}
$p = $c_Lcom_raquo_laminar_modifiers_Binder$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_modifiers_Binder$;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_Binder$() {
}
$h_Lcom_raquo_laminar_modifiers_Binder$.prototype = $p;
var $d_Lcom_raquo_laminar_modifiers_Binder$ = new $TypeData().i($c_Lcom_raquo_laminar_modifiers_Binder$, "com.raquo.laminar.modifiers.Binder$", ({
  q1: 1
}));
var $n_Lcom_raquo_laminar_modifiers_Binder$;
function $m_Lcom_raquo_laminar_modifiers_Binder$() {
  if ((!$n_Lcom_raquo_laminar_modifiers_Binder$)) {
    $n_Lcom_raquo_laminar_modifiers_Binder$ = new $c_Lcom_raquo_laminar_modifiers_Binder$();
  }
  return $n_Lcom_raquo_laminar_modifiers_Binder$;
}
function $is_Lcom_raquo_laminar_modifiers_Modifier(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.ar)));
}
function $isArrayOf_Lcom_raquo_laminar_modifiers_Modifier(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ar)));
}
var $d_Lcom_raquo_laminar_modifiers_Modifier = new $TypeData().i(1, "com.raquo.laminar.modifiers.Modifier", ({
  ar: 1
}));
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_Modifier$() {
  this.arC = null;
  $n_Lcom_raquo_laminar_modifiers_Modifier$ = this;
  this.arC = new $c_Lcom_raquo_laminar_modifiers_Modifier$$anon$1();
}
$p = $c_Lcom_raquo_laminar_modifiers_Modifier$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_modifiers_Modifier$;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_Modifier$() {
}
$h_Lcom_raquo_laminar_modifiers_Modifier$.prototype = $p;
var $d_Lcom_raquo_laminar_modifiers_Modifier$ = new $TypeData().i($c_Lcom_raquo_laminar_modifiers_Modifier$, "com.raquo.laminar.modifiers.Modifier$", ({
  q7: 1
}));
var $n_Lcom_raquo_laminar_modifiers_Modifier$;
function $m_Lcom_raquo_laminar_modifiers_Modifier$() {
  if ((!$n_Lcom_raquo_laminar_modifiers_Modifier$)) {
    $n_Lcom_raquo_laminar_modifiers_Modifier$ = new $c_Lcom_raquo_laminar_modifiers_Modifier$();
  }
  return $n_Lcom_raquo_laminar_modifiers_Modifier$;
}
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_RenderableNode$() {
  this.ht = null;
  $n_Lcom_raquo_laminar_modifiers_RenderableNode$ = this;
  this.ht = new $c_Lcom_raquo_laminar_modifiers_RenderableNode$$anon$1();
}
$p = $c_Lcom_raquo_laminar_modifiers_RenderableNode$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_modifiers_RenderableNode$;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_RenderableNode$() {
}
$h_Lcom_raquo_laminar_modifiers_RenderableNode$.prototype = $p;
var $d_Lcom_raquo_laminar_modifiers_RenderableNode$ = new $TypeData().i($c_Lcom_raquo_laminar_modifiers_RenderableNode$, "com.raquo.laminar.modifiers.RenderableNode$", ({
  qb: 1
}));
var $n_Lcom_raquo_laminar_modifiers_RenderableNode$;
function $m_Lcom_raquo_laminar_modifiers_RenderableNode$() {
  if ((!$n_Lcom_raquo_laminar_modifiers_RenderableNode$)) {
    $n_Lcom_raquo_laminar_modifiers_RenderableNode$ = new $c_Lcom_raquo_laminar_modifiers_RenderableNode$();
  }
  return $n_Lcom_raquo_laminar_modifiers_RenderableNode$;
}
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_RenderableText$() {
  this.a7 = null;
  $n_Lcom_raquo_laminar_modifiers_RenderableText$ = this;
  this.a7 = new $c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x) => x)), $m_Lcom_raquo_laminar_modifiers_RenderableText$());
  new $c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => ("" + (_$1 | 0)))), $m_Lcom_raquo_laminar_modifiers_RenderableText$());
  new $c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => ("" + (+_$2)))), $m_Lcom_raquo_laminar_modifiers_RenderableText$());
  new $c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$3) => ("" + (!(!_$3))))), $m_Lcom_raquo_laminar_modifiers_RenderableText$());
  new $c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$4) => _$4.b9S())), $m_Lcom_raquo_laminar_modifiers_RenderableText$());
}
$p = $c_Lcom_raquo_laminar_modifiers_RenderableText$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_modifiers_RenderableText$;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_RenderableText$() {
}
$h_Lcom_raquo_laminar_modifiers_RenderableText$.prototype = $p;
var $d_Lcom_raquo_laminar_modifiers_RenderableText$ = new $TypeData().i($c_Lcom_raquo_laminar_modifiers_RenderableText$, "com.raquo.laminar.modifiers.RenderableText$", ({
  qg: 1
}));
var $n_Lcom_raquo_laminar_modifiers_RenderableText$;
function $m_Lcom_raquo_laminar_modifiers_RenderableText$() {
  if ((!$n_Lcom_raquo_laminar_modifiers_RenderableText$)) {
    $n_Lcom_raquo_laminar_modifiers_RenderableText$ = new $c_Lcom_raquo_laminar_modifiers_RenderableText$();
  }
  return $n_Lcom_raquo_laminar_modifiers_RenderableText$;
}
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_Setter$() {
}
$p = $c_Lcom_raquo_laminar_modifiers_Setter$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_modifiers_Setter$;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_Setter$() {
}
$h_Lcom_raquo_laminar_modifiers_Setter$.prototype = $p;
var $d_Lcom_raquo_laminar_modifiers_Setter$ = new $TypeData().i($c_Lcom_raquo_laminar_modifiers_Setter$, "com.raquo.laminar.modifiers.Setter$", ({
  qi: 1
}));
var $n_Lcom_raquo_laminar_modifiers_Setter$;
function $m_Lcom_raquo_laminar_modifiers_Setter$() {
  if ((!$n_Lcom_raquo_laminar_modifiers_Setter$)) {
    $n_Lcom_raquo_laminar_modifiers_Setter$ = new $c_Lcom_raquo_laminar_modifiers_Setter$();
  }
  return $n_Lcom_raquo_laminar_modifiers_Setter$;
}
/** @constructor */
function $c_Lcom_raquo_laminar_nodes_ParentNode$() {
}
$p = $c_Lcom_raquo_laminar_nodes_ParentNode$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_nodes_ParentNode$;
/** @constructor */
function $h_Lcom_raquo_laminar_nodes_ParentNode$() {
}
$h_Lcom_raquo_laminar_nodes_ParentNode$.prototype = $p;
$p.DF = (function(parent, child, hooks) {
  var nextParent = new $c_s_Some(parent);
  child.Ep(nextParent);
  if ((hooks !== (void 0))) {
    hooks.aQK(parent, child);
  }
  var appended = $m_Lcom_raquo_laminar_DomApi$().aX4(parent.ed(), child.ed());
  if (appended) {
    child.Ei(nextParent);
  }
  return appended;
});
$p.ahB = (function(parent, child) {
  var removed = false;
  if ($m_sr_BoxesRunTime$().Q(child.ed().parentNode, parent.ed())) {
    child.Ep($m_s_None$());
    removed = $m_Lcom_raquo_laminar_DomApi$().b7t(parent.ed(), child.ed());
    child.Ei($m_s_None$());
  }
  return removed;
});
$p.a3N = (function(parent, newChild, referenceChild, hooks) {
  var nextParent = new $c_s_Some(parent);
  newChild.Ep(nextParent);
  if ((hooks !== (void 0))) {
    hooks.aQK(parent, newChild);
  }
  var inserted = $m_Lcom_raquo_laminar_DomApi$().b2S(parent.ed(), newChild.ed(), referenceChild.ed());
  newChild.Ei(nextParent);
  return inserted;
});
$p.aRH = (function(parent, oldChild, newChild, hooks) {
  var replaced = false;
  if ((oldChild !== newChild)) {
    if (oldChild.P7().E(parent)) {
      var newChildNextParent = new $c_s_Some(parent);
      oldChild.Ep($m_s_None$());
      newChild.Ep(newChildNextParent);
      if ((hooks !== (void 0))) {
        hooks.aQK(parent, newChild);
      }
      replaced = $m_Lcom_raquo_laminar_DomApi$().b7E(parent.ed(), newChild.ed(), oldChild.ed());
      if (replaced) {
        oldChild.Ei($m_s_None$());
        newChild.Ei(newChildNextParent);
      }
    }
  }
  return replaced;
});
var $d_Lcom_raquo_laminar_nodes_ParentNode$ = new $TypeData().i($c_Lcom_raquo_laminar_nodes_ParentNode$, "com.raquo.laminar.nodes.ParentNode$", ({
  ql: 1
}));
var $n_Lcom_raquo_laminar_nodes_ParentNode$;
function $m_Lcom_raquo_laminar_nodes_ParentNode$() {
  if ((!$n_Lcom_raquo_laminar_nodes_ParentNode$)) {
    $n_Lcom_raquo_laminar_nodes_ParentNode$ = new $c_Lcom_raquo_laminar_nodes_ParentNode$();
  }
  return $n_Lcom_raquo_laminar_nodes_ParentNode$;
}
/** @constructor */
function $c_Lcom_raquo_laminar_nodes_ReactiveElement$() {
}
$p = $c_Lcom_raquo_laminar_nodes_ReactiveElement$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_nodes_ReactiveElement$;
/** @constructor */
function $h_Lcom_raquo_laminar_nodes_ReactiveElement$() {
}
$h_Lcom_raquo_laminar_nodes_ReactiveElement$.prototype = $p;
$p.baH = (function(element, subscribe) {
  return $m_Lcom_raquo_airstream_ownership_DynamicSubscription$().AI(element.kq(), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((owner) => subscribe.i(new $c_Lcom_raquo_laminar_lifecycle_MountContext(element, owner)))), true);
});
$p.b5a = (function(element) {
  var rawTagName = element.tagName;
  return (((rawTagName.indexOf("-") | 0) !== (-1)) ? rawTagName : rawTagName.toLowerCase());
});
var $d_Lcom_raquo_laminar_nodes_ReactiveElement$ = new $TypeData().i($c_Lcom_raquo_laminar_nodes_ReactiveElement$, "com.raquo.laminar.nodes.ReactiveElement$", ({
  qm: 1
}));
var $n_Lcom_raquo_laminar_nodes_ReactiveElement$;
function $m_Lcom_raquo_laminar_nodes_ReactiveElement$() {
  if ((!$n_Lcom_raquo_laminar_nodes_ReactiveElement$)) {
    $n_Lcom_raquo_laminar_nodes_ReactiveElement$ = new $c_Lcom_raquo_laminar_nodes_ReactiveElement$();
  }
  return $n_Lcom_raquo_laminar_nodes_ReactiveElement$;
}
function $p_Lcom_raquo_laminar_receivers_ChildOptionReceiver$__emptyNode$lzyINIT1$1__sr_LazyRef__Lcom_raquo_laminar_nodes_CommentNode($thiz, emptyNode$lzy1$1) {
  if ((emptyNode$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return (emptyNode$lzy1$1.ci ? emptyNode$lzy1$1.cj : emptyNode$lzy1$1.h3(new $c_Lcom_raquo_laminar_nodes_CommentNode("")));
}
function $p_Lcom_raquo_laminar_receivers_ChildOptionReceiver$__emptyNode$1__sr_LazyRef__Lcom_raquo_laminar_nodes_CommentNode($thiz, emptyNode$lzy1$2) {
  return (emptyNode$lzy1$2.ci ? emptyNode$lzy1$2.cj : $p_Lcom_raquo_laminar_receivers_ChildOptionReceiver$__emptyNode$lzyINIT1$1__sr_LazyRef__Lcom_raquo_laminar_nodes_CommentNode($thiz, emptyNode$lzy1$2));
}
/** @constructor */
function $c_Lcom_raquo_laminar_receivers_ChildOptionReceiver$() {
}
$p = $c_Lcom_raquo_laminar_receivers_ChildOptionReceiver$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_receivers_ChildOptionReceiver$;
/** @constructor */
function $h_Lcom_raquo_laminar_receivers_ChildOptionReceiver$() {
}
$h_Lcom_raquo_laminar_receivers_ChildOptionReceiver$.prototype = $p;
$p.gR = (function(maybeChildSource) {
  var emptyNode$lzy1 = new $c_sr_LazyRef();
  $m_Lcom_raquo_laminar_api_package$();
  return $m_Lcom_raquo_laminar_inserters_ChildInserter$().nv(maybeChildSource.dM().fQ(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((emptyNode$lzy1$2) => ((_$1) => (_$1.c() ? $p_Lcom_raquo_laminar_receivers_ChildOptionReceiver$__emptyNode$1__sr_LazyRef__Lcom_raquo_laminar_nodes_CommentNode(this, emptyNode$lzy1$2) : _$1.d())))(emptyNode$lzy1))).dM(), $m_Lcom_raquo_laminar_modifiers_RenderableNode$().ht, (void 0));
});
var $d_Lcom_raquo_laminar_receivers_ChildOptionReceiver$ = new $TypeData().i($c_Lcom_raquo_laminar_receivers_ChildOptionReceiver$, "com.raquo.laminar.receivers.ChildOptionReceiver$", ({
  qr: 1
}));
var $n_Lcom_raquo_laminar_receivers_ChildOptionReceiver$;
function $m_Lcom_raquo_laminar_receivers_ChildOptionReceiver$() {
  if ((!$n_Lcom_raquo_laminar_receivers_ChildOptionReceiver$)) {
    $n_Lcom_raquo_laminar_receivers_ChildOptionReceiver$ = new $c_Lcom_raquo_laminar_receivers_ChildOptionReceiver$();
  }
  return $n_Lcom_raquo_laminar_receivers_ChildOptionReceiver$;
}
/** @constructor */
function $c_Lcom_raquo_laminar_receivers_ChildReceiver$() {
  this.aTF = null;
  this.aTG = null;
  $n_Lcom_raquo_laminar_receivers_ChildReceiver$ = this;
  this.aTF = $m_Lcom_raquo_laminar_receivers_ChildOptionReceiver$();
  this.aTG = $m_Lcom_raquo_laminar_receivers_ChildTextReceiver$();
}
$p = $c_Lcom_raquo_laminar_receivers_ChildReceiver$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_receivers_ChildReceiver$;
/** @constructor */
function $h_Lcom_raquo_laminar_receivers_ChildReceiver$() {
}
$h_Lcom_raquo_laminar_receivers_ChildReceiver$.prototype = $p;
var $d_Lcom_raquo_laminar_receivers_ChildReceiver$ = new $TypeData().i($c_Lcom_raquo_laminar_receivers_ChildReceiver$, "com.raquo.laminar.receivers.ChildReceiver$", ({
  qs: 1
}));
var $n_Lcom_raquo_laminar_receivers_ChildReceiver$;
function $m_Lcom_raquo_laminar_receivers_ChildReceiver$() {
  if ((!$n_Lcom_raquo_laminar_receivers_ChildReceiver$)) {
    $n_Lcom_raquo_laminar_receivers_ChildReceiver$ = new $c_Lcom_raquo_laminar_receivers_ChildReceiver$();
  }
  return $n_Lcom_raquo_laminar_receivers_ChildReceiver$;
}
/** @constructor */
function $c_Lcom_raquo_laminar_receivers_ChildTextReceiver$() {
}
$p = $c_Lcom_raquo_laminar_receivers_ChildTextReceiver$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_receivers_ChildTextReceiver$;
/** @constructor */
function $h_Lcom_raquo_laminar_receivers_ChildTextReceiver$() {
}
$h_Lcom_raquo_laminar_receivers_ChildTextReceiver$.prototype = $p;
var $d_Lcom_raquo_laminar_receivers_ChildTextReceiver$ = new $TypeData().i($c_Lcom_raquo_laminar_receivers_ChildTextReceiver$, "com.raquo.laminar.receivers.ChildTextReceiver$", ({
  qt: 1
}));
var $n_Lcom_raquo_laminar_receivers_ChildTextReceiver$;
function $m_Lcom_raquo_laminar_receivers_ChildTextReceiver$() {
  if ((!$n_Lcom_raquo_laminar_receivers_ChildTextReceiver$)) {
    $n_Lcom_raquo_laminar_receivers_ChildTextReceiver$ = new $c_Lcom_raquo_laminar_receivers_ChildTextReceiver$();
  }
  return $n_Lcom_raquo_laminar_receivers_ChildTextReceiver$;
}
/** @constructor */
function $c_Lcom_raquo_laminar_receivers_ChildrenReceiver$() {
}
$p = $c_Lcom_raquo_laminar_receivers_ChildrenReceiver$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_receivers_ChildrenReceiver$;
/** @constructor */
function $h_Lcom_raquo_laminar_receivers_ChildrenReceiver$() {
}
$h_Lcom_raquo_laminar_receivers_ChildrenReceiver$.prototype = $p;
var $d_Lcom_raquo_laminar_receivers_ChildrenReceiver$ = new $TypeData().i($c_Lcom_raquo_laminar_receivers_ChildrenReceiver$, "com.raquo.laminar.receivers.ChildrenReceiver$", ({
  qu: 1
}));
var $n_Lcom_raquo_laminar_receivers_ChildrenReceiver$;
function $m_Lcom_raquo_laminar_receivers_ChildrenReceiver$() {
  if ((!$n_Lcom_raquo_laminar_receivers_ChildrenReceiver$)) {
    $n_Lcom_raquo_laminar_receivers_ChildrenReceiver$ = new $c_Lcom_raquo_laminar_receivers_ChildrenReceiver$();
  }
  return $n_Lcom_raquo_laminar_receivers_ChildrenReceiver$;
}
/** @constructor */
function $c_Lcom_raquo_laminar_receivers_ChildrenReceiver$RichChildrenReceiver$() {
}
$p = $c_Lcom_raquo_laminar_receivers_ChildrenReceiver$RichChildrenReceiver$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_receivers_ChildrenReceiver$RichChildrenReceiver$;
/** @constructor */
function $h_Lcom_raquo_laminar_receivers_ChildrenReceiver$RichChildrenReceiver$() {
}
$h_Lcom_raquo_laminar_receivers_ChildrenReceiver$RichChildrenReceiver$.prototype = $p;
$p.aMb = (function(this$, components, renderableNode, renderableSeq) {
  return new $c_Lcom_raquo_laminar_receivers_LockedChildrenReceiver(renderableSeq.Q3(components));
});
var $d_Lcom_raquo_laminar_receivers_ChildrenReceiver$RichChildrenReceiver$ = new $TypeData().i($c_Lcom_raquo_laminar_receivers_ChildrenReceiver$RichChildrenReceiver$, "com.raquo.laminar.receivers.ChildrenReceiver$RichChildrenReceiver$", ({
  qv: 1
}));
var $n_Lcom_raquo_laminar_receivers_ChildrenReceiver$RichChildrenReceiver$;
function $m_Lcom_raquo_laminar_receivers_ChildrenReceiver$RichChildrenReceiver$() {
  if ((!$n_Lcom_raquo_laminar_receivers_ChildrenReceiver$RichChildrenReceiver$)) {
    $n_Lcom_raquo_laminar_receivers_ChildrenReceiver$RichChildrenReceiver$ = new $c_Lcom_raquo_laminar_receivers_ChildrenReceiver$RichChildrenReceiver$();
  }
  return $n_Lcom_raquo_laminar_receivers_ChildrenReceiver$RichChildrenReceiver$;
}
/** @constructor */
function $c_Lcom_raquo_laminar_receivers_FocusReceiver$() {
}
$p = $c_Lcom_raquo_laminar_receivers_FocusReceiver$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_receivers_FocusReceiver$;
/** @constructor */
function $h_Lcom_raquo_laminar_receivers_FocusReceiver$() {
}
$h_Lcom_raquo_laminar_receivers_FocusReceiver$.prototype = $p;
$p.aLi = (function(isFocused) {
  return new $c_Lcom_raquo_laminar_modifiers_Binder$$anon$1(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((element) => {
    var observable = isFocused.mY();
    var onNext = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((element$2) => ((v1) => {
      if ((!(!v1))) {
        element$2.en.focus();
      } else {
        element$2.en.blur();
      }
    }))(element));
    return $m_Lcom_raquo_airstream_ownership_DynamicSubscription$().a4O(element.YY, observable, onNext);
  })), $m_Lcom_raquo_laminar_modifiers_Binder$());
});
var $d_Lcom_raquo_laminar_receivers_FocusReceiver$ = new $TypeData().i($c_Lcom_raquo_laminar_receivers_FocusReceiver$, "com.raquo.laminar.receivers.FocusReceiver$", ({
  qw: 1
}));
var $n_Lcom_raquo_laminar_receivers_FocusReceiver$;
function $m_Lcom_raquo_laminar_receivers_FocusReceiver$() {
  if ((!$n_Lcom_raquo_laminar_receivers_FocusReceiver$)) {
    $n_Lcom_raquo_laminar_receivers_FocusReceiver$ = new $c_Lcom_raquo_laminar_receivers_FocusReceiver$();
  }
  return $n_Lcom_raquo_laminar_receivers_FocusReceiver$;
}
function $ps_Lcom_raquo_laminar_receivers_LockedChildReceiver__emptyNode$lzyINIT1$1__sr_LazyRef__Lcom_raquo_laminar_nodes_CommentNode(emptyNode$lzy1$1) {
  if ((emptyNode$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return (emptyNode$lzy1$1.ci ? emptyNode$lzy1$1.cj : emptyNode$lzy1$1.h3(new $c_Lcom_raquo_laminar_nodes_CommentNode("")));
}
function $ps_Lcom_raquo_laminar_receivers_LockedChildReceiver__emptyNode$1__sr_LazyRef__Lcom_raquo_laminar_nodes_CommentNode(emptyNode$lzy1$2) {
  return (emptyNode$lzy1$2.ci ? emptyNode$lzy1$2.cj : $ps_Lcom_raquo_laminar_receivers_LockedChildReceiver__emptyNode$lzyINIT1$1__sr_LazyRef__Lcom_raquo_laminar_nodes_CommentNode(emptyNode$lzy1$2));
}
/** @constructor */
function $c_Lcom_raquo_laminar_receivers_LockedChildReceiver(node) {
  this.arP = null;
  this.arP = node;
}
$p = $c_Lcom_raquo_laminar_receivers_LockedChildReceiver.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_receivers_LockedChildReceiver;
/** @constructor */
function $h_Lcom_raquo_laminar_receivers_LockedChildReceiver() {
}
$h_Lcom_raquo_laminar_receivers_LockedChildReceiver.prototype = $p;
$p.gR = (function(includeSource) {
  var emptyNode$lzy1 = new $c_sr_LazyRef();
  $m_Lcom_raquo_laminar_api_package$();
  return $m_Lcom_raquo_laminar_inserters_ChildInserter$().nv(includeSource.dM().fQ(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((emptyNode$lzy1$2) => ((_$1) => ((!(!_$1)) ? this.arP : $ps_Lcom_raquo_laminar_receivers_LockedChildReceiver__emptyNode$1__sr_LazyRef__Lcom_raquo_laminar_nodes_CommentNode(emptyNode$lzy1$2))))(emptyNode$lzy1))).dM(), $m_Lcom_raquo_laminar_modifiers_RenderableNode$().ht, (void 0));
});
var $d_Lcom_raquo_laminar_receivers_LockedChildReceiver = new $TypeData().i($c_Lcom_raquo_laminar_receivers_LockedChildReceiver, "com.raquo.laminar.receivers.LockedChildReceiver", ({
  qx: 1
}));
/** @constructor */
function $c_Lcom_raquo_laminar_receivers_LockedChildrenReceiver(nodes) {
  this.arQ = null;
  this.arQ = nodes;
}
$p = $c_Lcom_raquo_laminar_receivers_LockedChildrenReceiver.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_receivers_LockedChildrenReceiver;
/** @constructor */
function $h_Lcom_raquo_laminar_receivers_LockedChildrenReceiver() {
}
$h_Lcom_raquo_laminar_receivers_LockedChildrenReceiver.prototype = $p;
$p.gR = (function(includeSource) {
  $m_Lcom_raquo_laminar_api_package$();
  var childrenSource = includeSource.dM().fQ(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => ((!(!_$1)) ? this.arQ : $m_Lcom_raquo_laminar_Seq$().amK))));
  var renderableNode = $m_Lcom_raquo_laminar_modifiers_RenderableNode$().ht;
  var renderableSeq = $m_Lcom_raquo_laminar_modifiers_RenderableSeq$laminarSeqRenderable$();
  return $m_Lcom_raquo_laminar_inserters_ChildrenInserter$().IB(childrenSource.dM(), renderableSeq, renderableNode, (void 0));
});
var $d_Lcom_raquo_laminar_receivers_LockedChildrenReceiver = new $TypeData().i($c_Lcom_raquo_laminar_receivers_LockedChildrenReceiver, "com.raquo.laminar.receivers.LockedChildrenReceiver", ({
  qy: 1
}));
function $f_Lcom_softwaremill_quicklens_package$QuicklensFunctor__eachWhere__O__F1__F1__O($thiz, fa, f, cond) {
  var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x) => ((!(!cond.i(x))) ? f.i(x) : x)));
  return fa.L(f$1);
}
/** @constructor */
function $c_Lfansi_Attr$() {
  this.arR = null;
  this.a6M = null;
  $n_Lfansi_Attr$ = this;
  this.arR = new $c_Lfansi_EscapeAttr("\u001b[0m", 2147483647, 0, 0, 0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Reset")));
  this.a6M = $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lfansi_Category.r().C)([$m_Lfansi_Color$(), $m_Lfansi_Back$(), $m_Lfansi_Bold$(), $m_Lfansi_Underlined$(), $m_Lfansi_Reversed$()])));
}
$p = $c_Lfansi_Attr$.prototype = new $h_O();
$p.constructor = $c_Lfansi_Attr$;
/** @constructor */
function $h_Lfansi_Attr$() {
}
$h_Lfansi_Attr$.prototype = $p;
var $d_Lfansi_Attr$ = new $TypeData().i($c_Lfansi_Attr$, "fansi.Attr$", ({
  qE: 1
}));
var $n_Lfansi_Attr$;
function $m_Lfansi_Attr$() {
  if ((!$n_Lfansi_Attr$)) {
    $n_Lfansi_Attr$ = new $c_Lfansi_Attr$();
  }
  return $n_Lfansi_Attr$;
}
function $f_Lfansi_Attrs__transform__J__J($thiz, state_$_lo, state_$_hi) {
  var $x_1 = $thiz.XT();
  var x_$_lo = $x_1.l;
  var x_$_hi = $x_1.h;
  var lo = (~x_$_lo);
  var hi = (~x_$_hi);
  var lo$1 = (state_$_lo & lo);
  var hi$1 = (state_$_hi & hi);
  var $x_2 = $thiz.OY();
  var x$1_$_lo = $x_2.l;
  var x$1_$_hi = $x_2.h;
  var lo$2 = (lo$1 | x$1_$_lo);
  var hi$2 = (hi$1 | x$1_$_hi);
  return $bL(lo$2, hi$2);
}
/** @constructor */
function $c_Lfansi_Attrs$() {
  $n_Lfansi_Attrs$ = this;
  $m_Lfansi_Attrs$().aXs($m_sr_ScalaRunTime$().f(new ($d_Lfansi_Attr.r().C)([])));
}
$p = $c_Lfansi_Attrs$.prototype = new $h_O();
$p.constructor = $c_Lfansi_Attrs$;
/** @constructor */
function $h_Lfansi_Attrs$() {
}
$h_Lfansi_Attrs$.prototype = $p;
$p.aNF = (function(currentState_$_lo, currentState_$_hi, nextState_$_lo, nextState_$_hi, output, categoryArray) {
  if ((((currentState_$_lo ^ nextState_$_lo) | (currentState_$_hi ^ nextState_$_hi)) !== 0)) {
    var hardOffMask = $m_Lfansi_Bold$().Ja();
    var lo = (~nextState_$_lo);
    var hi = (~nextState_$_hi);
    if (((((currentState_$_lo & lo) & hardOffMask) | ((currentState_$_hi & hi) & (hardOffMask >> 31))) !== 0)) {
      output.ei("\u001b[0m");
      var currentState2_$_lo = 0;
      var currentState2_$_hi = 0;
    } else {
      var currentState2_$_lo = currentState_$_lo;
      var currentState2_$_hi = currentState_$_hi;
    }
    var categoryIndex = 0;
    while ((categoryIndex < categoryArray.a.length)) {
      var cat = categoryArray.a[categoryIndex];
      var value = cat.Ja();
      var hi$4 = (value >> 31);
      var lo$3 = (value & currentState2_$_lo);
      var hi$5 = (hi$4 & currentState2_$_hi);
      var value$1 = cat.Ja();
      if ((((lo$3 ^ (value$1 & nextState_$_lo)) | (hi$5 ^ ((value$1 >> 31) & nextState_$_hi))) !== 0)) {
        var value$2 = cat.Ja();
        var hi$8 = (value$2 >> 31);
        var lo$5 = (nextState_$_lo & value$2);
        var hi$9 = (nextState_$_hi & hi$8);
        var escape = cat.agX(lo$5, hi$9);
        output.ei(escape);
      }
      categoryIndex = ((1 + categoryIndex) | 0);
    }
  }
});
$p.aXs = (function(attrs) {
  var elem = $m_sci_Nil$();
  var elem$1 = null;
  elem$1 = elem;
  var elem$2_$_lo = 0;
  var elem$2_$_hi = 0;
  elem$2_$_lo = 0;
  elem$2_$_hi = 0;
  var elem$3_$_lo = 0;
  var elem$3_$_hi = 0;
  elem$3_$_lo = 0;
  elem$3_$_hi = 0;
  var this$5 = attrs.cx();
  while (this$5.p()) {
    var x0 = this$5.q();
    var $x_1 = x0.XT();
    var x$1_$_lo = $x_1.l;
    var x$1_$_hi = $x_1.h;
    var x_$_lo = elem$2_$_lo;
    var x_$_hi = elem$2_$_hi;
    var lo = (~x_$_lo);
    var hi = (~x_$_hi);
    if ((((x$1_$_lo & lo) | (x$1_$_hi & hi)) !== 0)) {
      var $x_2 = x0.OY();
      var x$2_$_lo = $x_2.l;
      var x$2_$_hi = $x_2.h;
      var x$3_$_lo = elem$2_$_lo;
      var x$3_$_hi = elem$2_$_hi;
      if ((((x$2_$_lo & x$3_$_lo) | (x$2_$_hi & x$3_$_hi)) === 0)) {
        var x$4_$_lo = elem$3_$_lo;
        var x$4_$_hi = elem$3_$_hi;
        var $x_3 = x0.OY();
        var x$5_$_lo = $x_3.l;
        var x$5_$_hi = $x_3.h;
        var lo$3 = (x$4_$_lo | x$5_$_lo);
        var hi$3 = (x$4_$_hi | x$5_$_hi);
        var ev$18_$_lo = lo$3;
        var ev$18_$_hi = hi$3;
        elem$3_$_lo = ev$18_$_lo;
        elem$3_$_hi = ev$18_$_hi;
      }
      var x$6_$_lo = elem$2_$_lo;
      var x$6_$_hi = elem$2_$_hi;
      var $x_4 = x0.XT();
      var x$7_$_lo = $x_4.l;
      var x$7_$_hi = $x_4.h;
      var lo$4 = (x$6_$_lo | x$7_$_lo);
      var hi$4 = (x$6_$_hi | x$7_$_hi);
      var ev$19_$_lo = lo$4;
      var ev$19_$_hi = hi$4;
      elem$2_$_lo = ev$19_$_lo;
      elem$2_$_hi = ev$19_$_hi;
      var ev$20 = new $c_sci_$colon$colon(x0, elem$1);
      elem$1 = ev$20;
      ev$20 = null;
    }
  }
  if ((elem$1.C() === 1)) {
    return elem$1.t();
  } else {
    var $x_7_$_lo = elem$2_$_lo;
    var $x_7_$_hi = elem$2_$_hi;
    var $x_6_$_lo = elem$3_$_lo;
    var $x_6_$_hi = elem$3_$_hi;
    var $x_5 = $m_sr_ScalaRunTime$();
    var this$15 = elem$1;
    if ((this$15.V() >= 0)) {
      var destination = new ($d_Lfansi_Attr.r().C)(this$15.V());
      $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$15, destination, 0, 2147483647);
      var xs = destination;
    } else {
      var capacity = 0;
      var size = 0;
      var jsElems = null;
      capacity = 0;
      size = 0;
      jsElems = [];
      var it = this$15.o();
      while (it.p()) {
        var elem$4 = it.q();
        var unboxedElem = ((elem$4 === null) ? null : elem$4);
        jsElems.push(unboxedElem);
      }
      var xs = new ($d_Lfansi_Attr.r().C)(jsElems);
    }
    var len$1 = xs.a.length;
    var res = new ($d_Lfansi_Attr.r().C)(len$1);
    var i = 0;
    while ((i < len$1)) {
      res.a[((((len$1 - i) | 0) - 1) | 0)] = xs.a[i];
      i = ((1 + i) | 0);
    }
    return new $c_Lfansi_Attrs$Multiple($x_7_$_lo, $x_7_$_hi, $x_6_$_lo, $x_6_$_hi, $x_5.f(res));
  }
});
var $d_Lfansi_Attrs$ = new $TypeData().i($c_Lfansi_Attrs$, "fansi.Attrs$", ({
  qF: 1
}));
var $n_Lfansi_Attrs$;
function $m_Lfansi_Attrs$() {
  if ((!$n_Lfansi_Attrs$)) {
    $n_Lfansi_Attrs$ = new $c_Lfansi_Attrs$();
  }
  return $n_Lfansi_Attrs$;
}
function $ct_Lfansi_Category__I__I__Lsourcecode_Name__($thiz, offset, width, catName) {
  $thiz.pK = offset;
  $thiz.yz = width;
  $thiz.yy = catName;
  return $thiz;
}
/** @constructor */
function $c_Lfansi_Category() {
  this.pK = 0;
  this.yz = 0;
  this.yy = null;
  this.AT = null;
  this.AU = false;
}
$p = $c_Lfansi_Category.prototype = new $h_O();
$p.constructor = $c_Lfansi_Category;
/** @constructor */
function $h_Lfansi_Category() {
}
$h_Lfansi_Category.prototype = $p;
$p.Ja = (function() {
  return ((((1 << this.yz) - 1) | 0) << this.pK);
});
$p.agX = (function(applyState_$_lo, applyState_$_hi) {
  var escapeOpt = this.aQ1(applyState_$_lo, applyState_$_hi).afy();
  return ((!escapeOpt.c()) ? escapeOpt.d() : "");
});
$p.aQ1 = (function(applyState_$_lo, applyState_$_hi) {
  var $x_1 = this.aQ2();
  var n = this.pK;
  return $x_1.a[(((32 & n) === 0) ? (((applyState_$_lo >>> n) | 0) | ((applyState_$_hi << 1) << (~n))) : (applyState_$_hi >> n))];
});
$p.aQ3 = (function() {
  return (1 << this.yz);
});
$p.aQ2 = (function() {
  if ((!this.AU)) {
    var arr = $m_jl_reflect_Array$().m0($d_Lfansi_Attr.l(), new $ac_I(new Int32Array([this.aQ3()])));
    this.OW().F(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((attr) => {
      var $x_1 = attr.OY();
      var x_$_lo = $x_1.l;
      var x_$_hi = $x_1.h;
      var n = this.pK;
      arr.a[(((32 & n) === 0) ? (((x_$_lo >>> n) | 0) | ((x_$_hi << 1) << (~n))) : (x_$_hi >> n))] = attr;
    })));
    this.AT = arr;
    this.AU = true;
  }
  return this.AT;
});
$p.dV = (function(s, applyValue_$_lo, applyValue_$_hi, name) {
  var x = this.Ja();
  var hi = (x >> 31);
  var n = this.pK;
  var lo = (((32 & n) === 0) ? (applyValue_$_lo << n) : 0);
  var hi$1 = (((32 & n) === 0) ? (((((applyValue_$_lo >>> 1) | 0) >>> (~n)) | 0) | (applyValue_$_hi << n)) : (applyValue_$_lo << n));
  return new $c_Lfansi_EscapeAttr(s, x, hi, lo, hi$1, $m_Lsourcecode_Name$().a5h(((this.yy.aE + ".") + name.aE)));
});
$p.b4e = (function(applyValue_$_lo, applyValue_$_hi, name) {
  var x = this.Ja();
  var hi = (x >> 31);
  var n = this.pK;
  var lo = (((32 & n) === 0) ? (applyValue_$_lo << n) : 0);
  var hi$1 = (((32 & n) === 0) ? (((((applyValue_$_lo >>> 1) | 0) >>> (~n)) | 0) | (applyValue_$_hi << n)) : (applyValue_$_lo << n));
  return new $c_Lfansi_ResetAttr(x, hi, lo, hi$1, $m_Lsourcecode_Name$().a5h(((this.yy.aE + ".") + name.aE)));
});
var $d_Lfansi_Category = new $TypeData().i(0, "fansi.Category", ({
  by: 1
}));
/** @constructor */
function $c_Lfansi_Str(chars, colors) {
  this.fC = null;
  this.nJ = null;
  this.asy = null;
  this.asz = false;
  this.fC = chars;
  this.nJ = colors;
  $m_s_Predef$().PQ((chars.a.length === ((colors.a.length >>> 1) | 0)));
}
$p = $c_Lfansi_Str.prototype = new $h_O();
$p.constructor = $c_Lfansi_Str;
/** @constructor */
function $h_Lfansi_Str() {
}
$h_Lfansi_Str.prototype = $p;
$p.x = (function() {
  return (($m_ju_Arrays$().b2u(this.fC) + $m_ju_Arrays$().b2v(this.nJ)) | 0);
});
$p.e = (function(other) {
  return ((other instanceof $c_Lfansi_Str) && ($m_ju_Arrays$().afv(this.fC, other.fC) && $m_ju_Arrays$().afw(this.nJ, other.nJ)));
});
$p.a4P = (function(start, end) {
  if ((!((start >= 0) && (start <= this.fC.a.length)))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("requirement failed: " + (("substring start parameter [" + start) + "] must be between 0 and length:")) + this.fC.a.length));
  }
  if ((!((end >= start) && (end <= this.fC.a.length)))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("requirement failed: " + (((("substring end parameter [" + end) + "] must be between start ") + start) + " and length:")) + this.fC.a.length));
  }
  return new $c_Lfansi_Str($m_ju_Arrays$().afd(this.fC, start, end), $m_ju_Arrays$().afe(this.nJ, start, end));
});
$p.m = (function() {
  return this.aRE();
});
$p.b6H = (function() {
  if ((!this.asz)) {
    var value = this.fC;
    this.asy = $m_jl_String$().kS(value, 0, value.a.length);
    this.asz = true;
  }
  return this.asy;
});
$p.b22 = (function(i) {
  var $x_1 = this.nJ.a;
  var $x_2 = (i << 1);
  return $bL($x_1[$x_2], $x_1[(($x_2 + 1) | 0)]);
});
$p.aOO = (function(i) {
  return this.fC.a[i];
});
$p.aRE = (function() {
  var output = $ct_scm_StringBuilder__I__(new $c_scm_StringBuilder(), ((this.fC.a.length + Math.imul(5, ((this.nJ.a.length >>> 1) | 0))) | 0));
  var currentState_$_lo = 0;
  var currentState_$_hi = 0;
  var this$2 = $m_Lfansi_Attr$().a6M;
  if ((this$2.C() >= 0)) {
    var destination = new ($d_Lfansi_Category.r().C)(this$2.C());
    this$2.o().cR(destination, 0, 2147483647);
    var categoryArray = destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = this$2.o();
    while (it.p()) {
      var elem = it.q();
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem);
    }
    var categoryArray = new ($d_Lfansi_Category.r().C)(jsElems);
  }
  var i = 0;
  while ((i < ((this.nJ.a.length >>> 1) | 0))) {
    var $x_1 = this.nJ.a;
    var $x_2 = (i << 1);
    var x_$_lo = $x_1[$x_2];
    var x_$_hi = $x_1[(($x_2 + 1) | 0)];
    var x$1_$_lo = currentState_$_lo;
    var x$1_$_hi = currentState_$_hi;
    if ((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) !== 0)) {
      var $x_7 = $m_Lfansi_Attrs$();
      var $x_6_$_lo = currentState_$_lo;
      var $x_6_$_hi = currentState_$_hi;
      var $x_4 = this.nJ.a;
      var $x_5 = (i << 1);
      var $x_3_$_lo = $x_4[$x_5];
      var $x_3_$_hi = $x_4[(($x_5 + 1) | 0)];
      $x_7.aNF($x_6_$_lo, $x_6_$_hi, $x_3_$_lo, $x_3_$_hi, output, categoryArray);
      var $x_8 = this.nJ.a;
      var $x_9 = (i << 1);
      currentState_$_lo = $x_8[$x_9];
      currentState_$_hi = $x_8[(($x_9 + 1) | 0)];
    }
    output.jl(this.fC.a[i]);
    i = ((1 + i) | 0);
  }
  $m_Lfansi_Attrs$().aNF(currentState_$_lo, currentState_$_hi, 0, 0, output, categoryArray);
  return output.bP.ah;
});
$p.PG = (function(attrs, start, end) {
  return this.b6g($m_sci_Seq$().kM($m_sr_ScalaRunTime$().f(new ($d_T3.r().C)([new $c_T3(attrs, start, end)]))));
});
$p.b6g = (function(overlays) {
  var this$1 = this.nJ;
  var colorsOut = this$1.ae();
  overlays.un(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => ((x$1 !== null) && true)))).F(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$2) => {
    matchResult3: {
      if ((x$1$2 !== null)) {
        var attrs$1 = x$1$2.bH;
        var start$1 = (x$1$2.bU | 0);
        var end$1 = (x$1$2.c3 | 0);
        if ((!(end$1 >= start$1))) {
          throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("requirement failed: " + ((("end:" + end$1) + " must be greater than start:") + end$1)) + " in fansiStr#overlay call"));
        }
        if ((!(start$1 >= 0))) {
          throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("requirement failed: " + ("start:" + start$1)) + " must be greater than or equal to 0"));
        }
        if ((!(end$1 <= ((this.nJ.a.length >>> 1) | 0)))) {
          throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("requirement failed: " + (("end:" + end$1) + " must be less than or equal to length:")) + ((this.nJ.a.length >>> 1) | 0)));
        }
        var i = start$1;
        while ((i < end$1)) {
          var $x_5 = i;
          var $x_3 = colorsOut.a;
          var $x_4 = (i << 1);
          var $x_2_$_lo = $x_3[$x_4];
          var $x_2_$_hi = $x_3[(($x_4 + 1) | 0)];
          var $x_1 = $f_Lfansi_Attrs__transform__J__J(attrs$1, $x_2_$_lo, $x_2_$_hi);
          var $x_6 = colorsOut.a;
          var $x_7 = ($x_5 << 1);
          $x_6[$x_7] = $x_1.l;
          $x_6[(($x_7 + 1) | 0)] = $x_1.h;
          i = ((1 + i) | 0);
        }
        break matchResult3;
      }
      throw new $c_s_MatchError(x$1$2);
    }
  })));
  return new $c_Lfansi_Str(this.fC, colorsOut);
});
function $isArrayOf_Lfansi_Str(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ey)));
}
var $d_Lfansi_Str = new $TypeData().i($c_Lfansi_Str, "fansi.Str", ({
  ey: 1
}));
function $p_Lfansi_Str$__isDigit$1__jl_CharSequence__I__Z($thiz, raw$1, index) {
  return (((index < $dp_length__I(raw$1)) && ($dp_charAt__I__C(raw$1, index) >= 48)) && ($dp_charAt__I__C(raw$1, index) <= 57));
}
function $p_Lfansi_Str$__checkChar$1__jl_CharSequence__I__C__Z($thiz, raw$2, index, char) {
  return ((index < $dp_length__I(raw$2)) && ($dp_charAt__I__C(raw$2, index) === char));
}
/** @constructor */
function $c_Lfansi_Str$() {
  this.asB = null;
  this.asA = null;
  $n_Lfansi_Str$ = this;
  this.asB = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "(\u009b|\u001b\\[)[0-?]*[ -\\/]*[@-~]", $m_sci_Nil$()).A8;
  var this$3 = $m_Lfansi_Attr$().a6M;
  $m_sci_Vector$();
  var b = new $c_sci_VectorBuilder();
  var it = this$3.o();
  while (it.p()) {
    var x0 = it.q();
    var this$5 = x0.OW();
    $m_sci_Vector$();
    var b$1 = new $c_sci_VectorBuilder();
    var it$1 = this$5.o();
    while (it$1.p()) {
      var x0$1 = it$1.q();
      var this$7 = x0$1.afy();
      b$1.fO((this$7.c() ? $m_s_None$() : new $c_s_Some(new $c_T2(this$7.d(), new $c_s_util_Left(x0$1)))));
    }
    b.fO(b$1.bY());
  }
  var pairs = b.bY();
  var reset = $m_sci_Seq$().kM($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("\u001b[0m", new $c_s_util_Left($m_Lfansi_Attr$().arR))])));
  var trueColors = $m_sci_Seq$().kM($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("\u001b[38;2;", new $c_s_util_Right($m_Lfansi_Color$())), new $c_T2("\u001b[48;2;", new $c_s_util_Right($m_Lfansi_Back$()))])));
  this.asA = new $c_Lfansi_Trie(pairs.iR(reset).iR(trueColors));
}
$p = $c_Lfansi_Str$.prototype = new $h_O();
$p.constructor = $c_Lfansi_Str$;
/** @constructor */
function $h_Lfansi_Str$() {
}
$h_Lfansi_Str$.prototype = $p;
$p.iS = (function(raw, errorMode) {
  var chars = $m_jl_reflect_Array$().m0($d_C.l(), new $ac_I(new Int32Array([$dp_length__I(raw)])));
  var colors = $m_jl_reflect_Array$().m0($d_J.l(), new $ac_I(new Int32Array([$dp_length__I(raw)])));
  var currentColor_$_lo = 0;
  var currentColor_$_hi = 0;
  var elem = 0;
  elem = 0;
  var destIndex = 0;
  var length = $dp_length__I(raw);
  while ((elem < length)) {
    var char = $dp_charAt__I__C(raw, elem);
    if (((char === 27) || (char === 155))) {
      var escapeStartSourceIndex = elem;
      matchResult5: {
        var x20 = $ps_Lfansi_Trie__rec$1__jl_CharSequence__I__I__Lfansi_Trie__s_Option(raw, escapeStartSourceIndex, escapeStartSourceIndex, this.asA);
        if (($m_s_None$() === x20)) {
          var ev$7 = errorMode.Pr(elem, raw);
          elem = ev$7;
          break matchResult5;
        }
        if ((x20 instanceof $c_s_Some)) {
          var tuple = x20.J;
          if ((tuple !== null)) {
            var x16 = (tuple.g() | 0);
            var x17 = tuple.h();
            if ((x17 instanceof $c_s_util_Left)) {
              var color = x17.lP;
              var $x_1 = $f_Lfansi_Attrs__transform__J__J(color, currentColor_$_lo, currentColor_$_hi);
              currentColor_$_lo = $x_1.l;
              currentColor_$_hi = $x_1.h;
              var ev$8 = ((elem + x16) | 0);
              elem = ev$8;
              break matchResult5;
            }
            if ((x17 instanceof $c_s_util_Right)) {
              var category = x17.hm;
              var ev$9 = ((elem + x16) | 0);
              elem = ev$9;
              if ((!$p_Lfansi_Str$__isDigit$1__jl_CharSequence__I__Z(this, raw, elem))) {
                var ev$10 = errorMode.Pr(escapeStartSourceIndex, raw);
                elem = ev$10;
                break matchResult5;
              } else {
                var value = 0;
                var count = 0;
                while (($p_Lfansi_Str$__isDigit$1__jl_CharSequence__I__Z(this, raw, elem) && (count < 3))) {
                  value = ((Math.imul(10, value) + (($dp_charAt__I__C(raw, elem) - 48) | 0)) | 0);
                  var ev$11 = ((1 + elem) | 0);
                  elem = ev$11;
                  count = ((1 + count) | 0);
                }
                var r = value;
                if (((!$p_Lfansi_Str$__checkChar$1__jl_CharSequence__I__C__Z(this, raw, elem, 59)) || (!$p_Lfansi_Str$__isDigit$1__jl_CharSequence__I__Z(this, raw, ((1 + elem) | 0))))) {
                  var ev$10$1 = errorMode.Pr(escapeStartSourceIndex, raw);
                  elem = ev$10$1;
                  break matchResult5;
                } else {
                  var ev$12 = ((1 + elem) | 0);
                  elem = ev$12;
                  var value$1 = 0;
                  var count$1 = 0;
                  while (($p_Lfansi_Str$__isDigit$1__jl_CharSequence__I__Z(this, raw, elem) && (count$1 < 3))) {
                    value$1 = ((Math.imul(10, value$1) + (($dp_charAt__I__C(raw, elem) - 48) | 0)) | 0);
                    var ev$11$1 = ((1 + elem) | 0);
                    elem = ev$11$1;
                    count$1 = ((1 + count$1) | 0);
                  }
                  var g = value$1;
                  if (((!$p_Lfansi_Str$__checkChar$1__jl_CharSequence__I__C__Z(this, raw, elem, 59)) || (!$p_Lfansi_Str$__isDigit$1__jl_CharSequence__I__Z(this, raw, ((1 + elem) | 0))))) {
                    var ev$10$2 = errorMode.Pr(escapeStartSourceIndex, raw);
                    elem = ev$10$2;
                    break matchResult5;
                  } else {
                    var ev$13 = ((1 + elem) | 0);
                    elem = ev$13;
                    var value$2 = 0;
                    var count$2 = 0;
                    while (($p_Lfansi_Str$__isDigit$1__jl_CharSequence__I__Z(this, raw, elem) && (count$2 < 3))) {
                      value$2 = ((Math.imul(10, value$2) + (($dp_charAt__I__C(raw, elem) - 48) | 0)) | 0);
                      var ev$11$2 = ((1 + elem) | 0);
                      elem = ev$11$2;
                      count$2 = ((1 + count$2) | 0);
                    }
                    var b = value$2;
                    if ((!$p_Lfansi_Str$__checkChar$1__jl_CharSequence__I__C__Z(this, raw, elem, 109))) {
                      var ev$10$3 = errorMode.Pr(escapeStartSourceIndex, raw);
                      elem = ev$10$3;
                      break matchResult5;
                    } else {
                      var ev$14 = ((1 + elem) | 0);
                      elem = ev$14;
                      if ((!((((((r >>> 0) <= 255) && (g >= 0)) && (g < 256)) && (b >= 0)) && (b < 256)))) {
                        var ev$10$4 = errorMode.Pr(escapeStartSourceIndex, raw);
                        elem = ev$10$4;
                        break matchResult5;
                      } else {
                        var x$1_$_lo = currentColor_$_lo;
                        var x$1_$_hi = currentColor_$_hi;
                        var value$3 = (~category.Ja());
                        var hi = (value$3 >> 31);
                        var lo = (x$1_$_lo & value$3);
                        var hi$1 = (x$1_$_hi & hi);
                        var value$4 = (((273 + category.bax(r, g, b)) | 0) << category.pK);
                        var hi$2 = (value$4 >> 31);
                        var lo$1 = (lo | value$4);
                        var hi$3 = (hi$1 | hi$2);
                        currentColor_$_lo = lo$1;
                        currentColor_$_hi = hi$3;
                        break matchResult5;
                      }
                    }
                  }
                }
              }
            }
          }
          throw new $c_s_MatchError(tuple);
        }
        throw new $c_s_MatchError(x20);
      }
    } else {
      var $x_2 = colors.a;
      var $x_3 = (destIndex << 1);
      $x_2[$x_3] = currentColor_$_lo;
      $x_2[(($x_3 + 1) | 0)] = currentColor_$_hi;
      chars.a[destIndex] = char;
      var ev$15 = ((1 + elem) | 0);
      elem = ev$15;
      destIndex = ((1 + destIndex) | 0);
    }
  }
  return new $c_Lfansi_Str($m_ju_Arrays$().afd(chars, 0, destIndex), $m_ju_Arrays$().afe(colors, 0, destIndex));
});
$p.b3R = (function(args, sep) {
  var length = ((($f_sc_IterableOnceOps__sum__s_math_Numeric__O(new $c_sc_Iterator$$anon$9(args.o(), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => ((_$1.fC.a.length + sep.fC.a.length) | 0)))), $m_s_math_Numeric$IntIsIntegral$()) | 0) - sep.fC.a.length) | 0);
  var chars = $m_jl_reflect_Array$().m0($d_C.l(), new $ac_I(new Int32Array([length])));
  var colors = $m_jl_reflect_Array$().m0($d_J.l(), new $ac_I(new Int32Array([length])));
  var j = new $c_sr_IntRef(0);
  args.F(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((arg) => {
    if ((j.an !== 0)) {
      var k = 0;
      while ((k < sep.fC.a.length)) {
        chars.a[j.an] = sep.aOO(k);
        var $x_4 = j.an;
        var $x_2 = sep.nJ.ae().a;
        var $x_3 = (k << 1);
        var $x_1_$_lo = $x_2[$x_3];
        var $x_1_$_hi = $x_2[(($x_3 + 1) | 0)];
        var $x_5 = colors.a;
        var $x_6 = ($x_4 << 1);
        $x_5[$x_6] = $x_1_$_lo;
        $x_5[(($x_6 + 1) | 0)] = $x_1_$_hi;
        var ev$16 = ((1 + j.an) | 0);
        j.an = ev$16;
        k = ((1 + k) | 0);
      }
    }
    var i = 0;
    while ((i < arg.fC.a.length)) {
      chars.a[j.an] = arg.aOO(i);
      var $x_8 = j.an;
      var $x_7 = arg.b22(i);
      var $x_9 = colors.a;
      var $x_10 = ($x_8 << 1);
      $x_9[$x_10] = $x_7.l;
      $x_9[(($x_10 + 1) | 0)] = $x_7.h;
      i = ((1 + i) | 0);
      var ev$17 = ((1 + j.an) | 0);
      j.an = ev$17;
    }
  })));
  return new $c_Lfansi_Str(chars.ae(), colors.ae());
});
var $d_Lfansi_Str$ = new $TypeData().i($c_Lfansi_Str$, "fansi.Str$", ({
  qM: 1
}));
var $n_Lfansi_Str$;
function $m_Lfansi_Str$() {
  if ((!$n_Lfansi_Str$)) {
    $n_Lfansi_Str$ = new $c_Lfansi_Str$();
  }
  return $n_Lfansi_Str$;
}
function $ps_Lfansi_Trie__rec$1__jl_CharSequence__I__I__Lfansi_Trie__s_Option(input$1, index$2, offset, currentNode) {
  var currentNode$tailLocal1 = currentNode;
  var offset$tailLocal1 = offset;
  while (true) {
    if ((!currentNode$tailLocal1.a6Q.c())) {
      var this$2 = currentNode$tailLocal1.a6Q;
      var offset$tailLocal1$2 = offset$tailLocal1;
      return (this$2.c() ? $m_s_None$() : new $c_s_Some(new $c_T2(((offset$tailLocal1$2 - index$2) | 0), this$2.d())));
    } else if ((offset$tailLocal1 >= $dp_length__I(input$1))) {
      return $m_s_None$();
    } else {
      var char = $dp_charAt__I__C(input$1, offset$tailLocal1);
      var next = currentNode$tailLocal1.aXb(char);
      if ((next === null)) {
        return $m_s_None$();
      } else {
        var offset$tailLocal1$tmp1 = ((1 + offset$tailLocal1) | 0);
        offset$tailLocal1 = offset$tailLocal1$tmp1;
        currentNode$tailLocal1 = next;
      }
    }
  }
}
/** @constructor */
function $c_Lfansi_Trie(strings) {
  this.a6P = 0;
  this.asD = 0;
  this.asC = null;
  this.a6Q = null;
  matchResult24: {
    var x79___1;
    var x79___2;
    var x79___3;
    var x79___4;
    var x70 = strings.ju(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => (_$2.g() === ""))));
    if ((x70 !== null)) {
      var x77 = x70.g();
      var x78 = x70.h();
      if ($m_sci_Nil$().e(x77)) {
        var allChildChars = x78.L(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$3) => $bC(_$3.g().charCodeAt(0)))));
        var min = $uC(allChildChars.lr($m_s_math_Ordering$Char$()));
        var max = $uC(allChildChars.lq($m_s_math_Ordering$Char$()));
        var arr = $m_jl_reflect_Array$().m0($d_Lfansi_Trie.l(), new $ac_I(new Int32Array([((1 + ((max - min) | 0)) | 0)])));
        var m = $m_scm_Map$().aO();
        var it = x78.o();
        while (it.p()) {
          var elem = it.q();
          var x$2 = elem.g();
          var key = x$2.charCodeAt(0);
          m.ec($bC(key), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((this$7) => (() => this$7.fS()))(x78))).Y(elem);
        }
        var result = $m_sci_HashMap$().fk;
        var mapIt = m.o();
        while (mapIt.p()) {
          var x1 = mapIt.q();
          if ((x1 === null)) {
            throw new $c_s_MatchError(x1);
          }
          var k = x1.g();
          var v = x1.h();
          result = result.hq(k, v.aR());
        }
        var this$12 = new $c_sc_MapOps$WithFilter(result, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$1) => ((x$1$1 !== null) && ($uC(x$1$1.g()), x$1$1.h(), true)))));
        var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$2) => {
          matchResult23: {
            if ((x$1$2 !== null)) {
              var char$1 = $uC(x$1$2.g());
              var ss$1 = x$1$2.h();
              arr.a[((char$1 - min) | 0)] = new $c_Lfansi_Trie(ss$1.L(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$2$1) => {
                if ((x$1$2$1 !== null)) {
                  var k$1 = x$1$2$1.g();
                  var v$1 = x$1$2$1.h();
                  return new $c_T2($m_sc_StringOps$().b9I(k$1), v$1);
                }
                throw new $c_s_MatchError(x$1$2$1);
              }))));
              break matchResult23;
            }
            throw new $c_s_MatchError(x$1$2);
          }
        }));
        this$12.qY().F(f);
        var x79___1 = $bC(min);
        var x79___2 = $bC(max);
        var x79___3 = arr;
        var x79___4 = $m_s_None$();
        break matchResult24;
      }
      if ((x77 !== null)) {
        if ((x77.bL(1) === 0)) {
          var x74 = x77.l(0);
          if ((x74 !== null)) {
            var terminalValue = x74.h();
            if ($m_sci_Nil$().e(x78)) {
              var x79___1 = $bC(0);
              var x79___2 = $bC(0);
              var x79___3 = $m_jl_reflect_Array$().m0($d_Lfansi_Trie.l(), new $ac_I(new Int32Array([0])));
              var x79___4 = new $c_s_Some(terminalValue);
              break matchResult24;
            }
          }
        }
      }
    }
    throw new $c_s_NotImplementedError();
  }
  var \u03b41$___1 = $bC($uC(x79___1));
  var \u03b41$___2 = $bC($uC(x79___2));
  var \u03b41$___3 = x79___3;
  var \u03b41$___4 = x79___4;
  this.a6P = $uC(\u03b41$___1);
  this.asD = $uC(\u03b41$___2);
  this.asC = \u03b41$___3;
  this.a6Q = \u03b41$___4;
}
$p = $c_Lfansi_Trie.prototype = new $h_O();
$p.constructor = $c_Lfansi_Trie;
/** @constructor */
function $h_Lfansi_Trie() {
}
$h_Lfansi_Trie.prototype = $p;
$p.aXb = (function(c) {
  return (((c > this.asD) || (c < this.a6P)) ? null : this.asC.a[((c - this.a6P) | 0)]);
});
var $d_Lfansi_Trie = new $TypeData().i($c_Lfansi_Trie, "fansi.Trie", ({
  qN: 1
}));
function $f_Lfastparse_LowestPriSequencer__Sequencer1__O($thiz) {
  return new $c_Lfastparse_Implicits$Sequencer$NarySequencer(new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((x$1, x$2) => new $c_T2(x$1, x$2))));
}
function $ct_Lfastparse_Parsed__Z__($thiz, isSuccess) {
  return $thiz;
}
/** @constructor */
function $c_Lfastparse_Parsed() {
}
$p = $c_Lfastparse_Parsed.prototype = new $h_O();
$p.constructor = $c_Lfastparse_Parsed;
/** @constructor */
function $h_Lfastparse_Parsed() {
}
$h_Lfastparse_Parsed.prototype = $p;
/** @constructor */
function $c_Lfastparse_Parsed$() {
}
$p = $c_Lfastparse_Parsed$.prototype = new $h_O();
$p.constructor = $c_Lfastparse_Parsed$;
/** @constructor */
function $h_Lfastparse_Parsed$() {
}
$h_Lfastparse_Parsed$.prototype = $p;
$p.aOC = (function(p) {
  if (p.K) {
    return new $c_Lfastparse_Parsed$Success(p.aB, p.G);
  } else {
    var this$2 = $m_s_Option$().as(p.K0);
    return new $c_Lfastparse_Parsed$Failure((this$2.c() ? "" : $m_Lfastparse_internal_Util$().pA(this$2.d().j3)), p.G, new $c_Lfastparse_Parsed$Extra(p.b0, p.asX, p.G, p.asW, p.cf));
  }
});
var $d_Lfastparse_Parsed$ = new $TypeData().i($c_Lfastparse_Parsed$, "fastparse.Parsed$", ({
  r4: 1
}));
var $n_Lfastparse_Parsed$;
function $m_Lfastparse_Parsed$() {
  if ((!$n_Lfastparse_Parsed$)) {
    $n_Lfastparse_Parsed$ = new $c_Lfastparse_Parsed$();
  }
  return $n_Lfastparse_Parsed$;
}
/** @constructor */
function $c_Lfastparse_Parsed$Extra(input, startIndex, index, originalParser, stack) {
  this.JY = null;
  this.asT = 0;
  this.asR = 0;
  this.asS = null;
  this.a6S = null;
  this.JY = input;
  this.asT = startIndex;
  this.asR = index;
  this.asS = originalParser;
  this.a6S = stack;
}
$p = $c_Lfastparse_Parsed$Extra.prototype = new $h_O();
$p.constructor = $c_Lfastparse_Parsed$Extra;
/** @constructor */
function $h_Lfastparse_Parsed$Extra() {
}
$h_Lfastparse_Parsed$Extra.prototype = $p;
$p.bap = (function(enableLogging) {
  return $m_Lfastparse_Parsed$TracedFailure$().b1R($f_Lfastparse_SharedPackageDefs__parseInputRaw__Lfastparse_ParserInput__F1__Z__I__I__Lfastparse_internal_Instrument__Z__Lfastparse_ParsingRun($m_Lfastparse_package$(), this.JY, this.asS, true, this.asT, this.asR, null, enableLogging));
});
var $d_Lfastparse_Parsed$Extra = new $TypeData().i($c_Lfastparse_Parsed$Extra, "fastparse.Parsed$Extra", ({
  r5: 1
}));
/** @constructor */
function $c_Lfastparse_Parsed$Failure$() {
}
$p = $c_Lfastparse_Parsed$Failure$.prototype = new $h_O();
$p.constructor = $c_Lfastparse_Parsed$Failure$;
/** @constructor */
function $h_Lfastparse_Parsed$Failure$() {
}
$h_Lfastparse_Parsed$Failure$.prototype = $p;
$p.aOm = (function(input, stack, index) {
  return ((("Expected " + $m_Lfastparse_Parsed$Failure$().b1F(input, stack)) + ", found ") + $m_Lfastparse_Parsed$Failure$().aOn(input, index));
});
$p.b1F = (function(input, stack) {
  var f = ((x$1) => {
    if ((x$1 !== null)) {
      var s = x$1.g();
      var i = (x$1.h() | 0);
      return ((s + ":") + input.aR7(i));
    }
    throw new $c_s_MatchError(x$1);
  });
  if ((stack === $m_sci_Nil$())) {
    var $x_1 = $m_sci_Nil$();
  } else {
    var x0 = stack.t();
    var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
    var t = h;
    var rest = stack.v();
    while ((rest !== $m_sci_Nil$())) {
      var x0$1 = rest.t();
      var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
      t.U = nx;
      t = nx;
      rest = rest.v();
    }
    var $x_1 = h;
  }
  return $f_sc_IterableOnceOps__mkString__T__T__T__T($x_1, "", " / ", "");
});
$p.aOn = (function(input, index) {
  return $m_Lfastparse_internal_Util$().a47($m_s_Predef$().JL(input.PV(index, ((10 + index) | 0))), false);
});
var $d_Lfastparse_Parsed$Failure$ = new $TypeData().i($c_Lfastparse_Parsed$Failure$, "fastparse.Parsed$Failure$", ({
  r6: 1
}));
var $n_Lfastparse_Parsed$Failure$;
function $m_Lfastparse_Parsed$Failure$() {
  if ((!$n_Lfastparse_Parsed$Failure$)) {
    $n_Lfastparse_Parsed$Failure$ = new $c_Lfastparse_Parsed$Failure$();
  }
  return $n_Lfastparse_Parsed$Failure$;
}
/** @constructor */
function $c_Lfastparse_ParsingRun(input, startIndex, originalParser, traceIndex, instrument, terminalMsgs, aggregateMsgs, shortMsg, lastFailureMsg, failureStack, isSuccess, logDepth, index, cut, successValue, verboseFailures, noDropBuffer, misc) {
  this.b0 = null;
  this.asX = 0;
  this.asW = null;
  this.bq = 0;
  this.bk = null;
  this.K1 = null;
  this.a0 = null;
  this.am = null;
  this.K0 = null;
  this.cf = null;
  this.K = false;
  this.G = 0;
  this.N = false;
  this.aB = null;
  this.aj = false;
  this.j2 = false;
  this.b0 = input;
  this.asX = startIndex;
  this.asW = originalParser;
  this.bq = traceIndex;
  this.bk = instrument;
  this.K1 = terminalMsgs;
  this.a0 = aggregateMsgs;
  this.am = shortMsg;
  this.K0 = lastFailureMsg;
  this.cf = failureStack;
  this.K = isSuccess;
  this.G = index;
  this.N = cut;
  this.aB = successValue;
  this.aj = verboseFailures;
  this.j2 = noDropBuffer;
}
$p = $c_Lfastparse_ParsingRun.prototype = new $h_O();
$p.constructor = $c_Lfastparse_ParsingRun;
/** @constructor */
function $h_Lfastparse_ParsingRun() {
}
$h_Lfastparse_ParsingRun.prototype = $p;
$p.aG = (function(newshortMsg, newAggregateMsgs, forceAggregate) {
  this.aRJ(newshortMsg, newAggregateMsgs, forceAggregate, (!newAggregateMsgs.j3.c()));
});
$p.de = (function(startIndex, newshortMsg) {
  if (((!this.K) && (this.G === this.bq))) {
    this.K1 = this.K1.bl(newshortMsg);
  }
  this.aRJ(((startIndex >= this.bq) ? newshortMsg : $m_Lfastparse_internal_Msgs$().yA), ((startIndex >= this.bq) ? newshortMsg : $m_Lfastparse_internal_Msgs$().yA), false, (startIndex >= this.bq));
});
$p.aRJ = (function(newshortMsg, newAggregateMsgs, forceAggregate, setShortMsg) {
  if (((!this.K) && (this.K0 === null))) {
    this.K0 = newshortMsg;
  }
  this.am = (setShortMsg ? newshortMsg : $m_Lfastparse_internal_Msgs$().yA);
  this.a0 = (forceAggregate ? newAggregateMsgs : ((((!this.N) && (!this.K)) && (this.bq <= this.G)) ? this.am : newAggregateMsgs));
});
$p.u2 = (function(value) {
  this.K = true;
  this.aB = value;
  return this;
});
$p.afZ = (function() {
  this.K = true;
  this.aB = (void 0);
  return this;
});
$p.dl = (function(index) {
  this.K = true;
  this.aB = (void 0);
  this.G = index;
  return this;
});
$p.cI = (function(value, index) {
  this.K = true;
  this.aB = value;
  this.G = index;
  return this;
});
$p.u1 = (function(value, index, cut) {
  this.K = true;
  this.aB = value;
  this.G = index;
  this.N = cut;
  return this;
});
$p.dB = (function() {
  if (this.aj) {
    this.K0 = null;
    this.cf = $m_sci_Nil$();
  }
  this.K = false;
  return this;
});
$p.ll = (function(startPos) {
  if (this.aj) {
    this.K0 = null;
    this.cf = $m_sci_Nil$();
  }
  this.K = false;
  this.G = startPos;
  return this;
});
$p.tT = (function(index, cut) {
  this.G = index;
  this.N = cut;
  return this;
});
$p.b7 = (function() {
  return ((!this.j2) && this.N);
});
var $d_Lfastparse_ParsingRun = new $TypeData().i($c_Lfastparse_ParsingRun, "fastparse.ParsingRun", ({
  rb: 1
}));
function $f_Lfastparse_SharedPackageDefs__parse__Lfastparse_ParserInputSource__F1__Z__I__Lfastparse_internal_Instrument__Lfastparse_Parsed($thiz, input, parser, verboseFailures, startIndex, instrument) {
  return $m_Lfastparse_Parsed$().aOC($f_Lfastparse_SharedPackageDefs__parseInputRaw__Lfastparse_ParserInput__F1__Z__I__I__Lfastparse_internal_Instrument__Z__Lfastparse_ParsingRun($thiz, input.asU.i(input.asV), parser, verboseFailures, startIndex, (-1), instrument, true));
}
function $f_Lfastparse_SharedPackageDefs__parseInputRaw__Lfastparse_ParserInput__F1__Z__I__I__Lfastparse_internal_Instrument__Z__Lfastparse_ParsingRun($thiz, input, parser, verboseFailures, startIndex, traceIndex, instrument, enableLogging) {
  return parser.i(new $c_Lfastparse_ParsingRun(input, startIndex, parser, traceIndex, instrument, $m_Lfastparse_internal_Msgs$().yA, $m_Lfastparse_internal_Msgs$().yA, $m_Lfastparse_internal_Msgs$().yA, null, $m_sci_Nil$(), true, (enableLogging ? 0 : (-1)), startIndex, true, (void 0), verboseFailures, false, $m_scm_Map$().aO()));
}
function $f_Lfastparse_SharedPackageDefs__IgnoreCase__T__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, s, ctx) {
  var startIndex = ctx.G;
  var this$1 = $m_Lfastparse_internal_Util$();
  var src = ctx.b0;
  if ($p_Lfastparse_internal_Util$__rec$2__sci_IndexedSeq__Lfastparse_ParserInput__I__I__Z(this$1, $m_s_Predef$().JL(s), src, ctx.G, 0)) {
    var res = ctx.dl(((ctx.G + s.length) | 0));
  } else {
    var res = ctx.dB();
  }
  if (ctx.aj) {
    ctx.de(startIndex, $m_Lfastparse_internal_Msgs$().bn(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $m_Lfastparse_internal_Util$().a47($m_s_Predef$().JL(s), false)))));
  }
  return res;
}
function $f_Lfastparse_SharedPackageDefs__End__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, ctx) {
  var startIndex = ctx.G;
  var res = ((!ctx.b0.bc(startIndex)) ? ctx.afZ() : ctx.dB());
  if (ctx.aj) {
    ctx.de(startIndex, $m_Lfastparse_internal_Msgs$().bn(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => "end-of-input"))));
  }
  return res;
}
function $f_Lfastparse_SharedPackageDefs__Start__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, ctx) {
  var startIndex = ctx.G;
  var res = ((startIndex === 0) ? ctx.afZ() : ctx.dB());
  if (ctx.aj) {
    ctx.de(startIndex, $m_Lfastparse_internal_Msgs$().bn(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => "start-of-input"))));
  }
  return res;
}
function $f_Lfastparse_SharedPackageDefs__Pass__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, ctx) {
  var res = ctx.afZ();
  if (ctx.aj) {
    ctx.de(ctx.G, $m_Lfastparse_internal_Msgs$().yA);
  }
  return res;
}
function $f_Lfastparse_SharedPackageDefs__AnyChar__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, ctx) {
  var startIndex = ctx.G;
  var res = ((!ctx.b0.bc(ctx.G)) ? ctx.dB() : ctx.dl(((1 + ctx.G) | 0)));
  if (ctx.aj) {
    ctx.de(startIndex, $m_Lfastparse_internal_Msgs$().bn(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => "any-char"))));
  }
  return res;
}
/** @constructor */
function $c_Lfastparse_internal_Lazy(calc0) {
  this.a6U = null;
  this.asY = null;
  this.asZ = false;
  this.a6U = calc0;
}
$p = $c_Lfastparse_internal_Lazy.prototype = new $h_O();
$p.constructor = $c_Lfastparse_internal_Lazy;
/** @constructor */
function $h_Lfastparse_internal_Lazy() {
}
$h_Lfastparse_internal_Lazy.prototype = $p;
$p.b1y = (function() {
  if ((!this.asZ)) {
    this.asY = this.a6U.a3();
    this.asZ = true;
    this.a6U = null;
  }
  return this.asY;
});
var $d_Lfastparse_internal_Lazy = new $TypeData().i($c_Lfastparse_internal_Lazy, "fastparse.internal.Lazy", ({
  rf: 1
}));
function $p_Lfastparse_internal_Util$__rec$2__sci_IndexedSeq__Lfastparse_ParserInput__I__I__Z($thiz, prefix$2, src$2, offset$2, i) {
  var i$tailLocal2 = i;
  while (true) {
    if ((i$tailLocal2 >= prefix$2.C())) {
      return true;
    } else if (src$2.bc(((i$tailLocal2 + offset$2) | 0))) {
      var index = ((i$tailLocal2 + offset$2) | 0);
      var this$1 = src$2.cA;
      var c1 = this$1.charCodeAt(index);
      var c2 = $uC(prefix$2.l(i$tailLocal2));
      if ((!((c1 !== c2) && ($m_jl_Character$().aSU(c1) !== $m_jl_Character$().aSU(c2))))) {
        i$tailLocal2 = ((1 + i$tailLocal2) | 0);
        continue;
      }
      return false;
    } else {
      return false;
    }
  }
}
/** @constructor */
function $c_Lfastparse_internal_Util$() {
}
$p = $c_Lfastparse_internal_Util$.prototype = new $h_O();
$p.constructor = $c_Lfastparse_internal_Util$;
/** @constructor */
function $h_Lfastparse_internal_Util$() {
}
$h_Lfastparse_internal_Util$.prototype = $p;
$p.pA = (function(fs) {
  var x1 = $m_sci_Seq$().fw(new $c_sc_Iterator$$anon$9($f_sc_IterableOnceOps__reversed__sc_Iterable(fs).o(), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => _$1.b1y())))).nz();
  if ((x1 !== null)) {
    if ((x1.bL(1) === 0)) {
      return x1.l(0);
    }
  }
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(x1, "(", " | ", ")");
});
$p.dc = (function(lhs, rhs) {
  return (lhs.j3.c() ? rhs : (rhs.j3.c() ? lhs : $m_Lfastparse_internal_Msgs$().bn(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => (($m_Lfastparse_internal_Util$().pA(lhs.j3) + " ~ ") + $m_Lfastparse_internal_Util$().pA(rhs.j3)))))));
});
$p.dJ = (function(whitespace, ctx) {
  var oldCapturing = ctx.j2;
  ctx.j2 = true;
  whitespace.aXf(ctx);
  ctx.j2 = oldCapturing;
});
$p.b45 = (function(data) {
  var lineStarts = $m_scm_ArrayBuffer$().y9($m_sr_ScalaRunTime$().a5i(new $ac_I(new Int32Array([0]))));
  var i = 0;
  var col = 1;
  var state = 0;
  while ((i < data.length)) {
    var i$1 = i;
    var char = data.charCodeAt(i$1);
    if (((((13 ^ char) | (10 ^ state)) === 0) || (((10 ^ char) | (13 ^ state)) === 0))) {
      col = ((1 + col) | 0);
      state = (-1);
    } else if ((((state === 10) || (state === 13)) || (state === (-1)))) {
      lineStarts.aw(i);
      col = 1;
      state = char;
    } else {
      col = ((1 + col) | 0);
      state = char;
    }
    i = ((1 + i) | 0);
  }
  if ((((state === 10) || (state === 13)) || (state === (-1)))) {
    lineStarts.aw(i);
  }
  if ((lineStarts.a1 >= 0)) {
    var destination = new $ac_I(lineStarts.a1);
    lineStarts.cR(destination, 0, 2147483647);
    return destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = lineStarts.bB().o();
    while (it.p()) {
      var elem$2 = it.q();
      var unboxedElem = ((elem$2 === null) ? 0 : elem$2);
      jsElems.push(unboxedElem);
    }
    return new $ac_I(new Int32Array(jsElems));
  }
});
$p.a47 = (function(s, unicode) {
  var sb = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  sb.jl(34);
  var i = 0;
  var len = s.C();
  while ((i < len)) {
    var x4 = $uC(s.l(i));
    switch (x4) {
      case 34: {
        sb.ei("\\\"");
        break;
      }
      case 92: {
        sb.ei("\\\\");
        break;
      }
      case 8: {
        sb.ei("\\b");
        break;
      }
      case 12: {
        sb.ei("\\f");
        break;
      }
      case 10: {
        sb.ei("\\n");
        break;
      }
      case 13: {
        sb.ei("\\r");
        break;
      }
      case 9: {
        sb.ei("\\t");
        break;
      }
      default: {
        if (((x4 < 32) || ((x4 > 126) && unicode))) {
          sb.ei($m_sc_StringOps$().u0("\\u%04x", $m_sr_ScalaRunTime$().hP(new $ac_O([x4]))));
        } else {
          sb.jl(x4);
        }
      }
    }
    i = ((1 + i) | 0);
  }
  sb.jl(34);
  return sb.bP.ah;
});
$p.uf = (function(startIndex, min, ctx, sepMsg, parsedMsg, lastAgg, precut) {
  var newAgg = (((sepMsg === null) || precut) ? ctx.a0 : $m_Lfastparse_internal_Util$().dc(sepMsg, parsedMsg));
  ctx.aG($m_Lfastparse_internal_Msgs$().bn(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => (($m_Lfastparse_internal_Util$().pA(parsedMsg.j3) + ".rep") + ((min === 0) ? "" : (("(" + min) + ")")))))), ((lastAgg === null) ? newAgg : lastAgg.bl(newAgg)), false);
});
var $d_Lfastparse_internal_Util$ = new $TypeData().i($c_Lfastparse_internal_Util$, "fastparse.internal.Util$", ({
  rh: 1
}));
var $n_Lfastparse_internal_Util$;
function $m_Lfastparse_internal_Util$() {
  if ((!$n_Lfastparse_internal_Util$)) {
    $n_Lfastparse_internal_Util$ = new $c_Lfastparse_internal_Util$();
  }
  return $n_Lfastparse_internal_Util$;
}
/** @constructor */
function $c_Lio_laminext_core_BrowserUtils$() {
  this.a6V = false;
  $n_Lio_laminext_core_BrowserUtils$ = this;
  try {
    var $x_1 = new $c_s_util_Success(window.localStorage);
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    matchEnd8: {
      var $x_1;
      if ($m_s_util_control_NonFatal$().ew(e$2)) {
        var $x_1 = new $c_s_util_Failure(e$2);
        break matchEnd8;
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
    }
  }
  this.a6V = (!(!$x_1.kO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => {
    console.debug("window.localStorage is not accessible.");
    return false;
  })), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => true)))));
}
$p = $c_Lio_laminext_core_BrowserUtils$.prototype = new $h_O();
$p.constructor = $c_Lio_laminext_core_BrowserUtils$;
/** @constructor */
function $h_Lio_laminext_core_BrowserUtils$() {
}
$h_Lio_laminext_core_BrowserUtils$.prototype = $p;
var $d_Lio_laminext_core_BrowserUtils$ = new $TypeData().i($c_Lio_laminext_core_BrowserUtils$, "io.laminext.core.BrowserUtils$", ({
  rj: 1
}));
var $n_Lio_laminext_core_BrowserUtils$;
function $m_Lio_laminext_core_BrowserUtils$() {
  if ((!$n_Lio_laminext_core_BrowserUtils$)) {
    $n_Lio_laminext_core_BrowserUtils$ = new $c_Lio_laminext_core_BrowserUtils$();
  }
  return $n_Lio_laminext_core_BrowserUtils$;
}
/** @constructor */
function $c_Lio_laminext_core_StoredString(name, initial) {
  this.a6W = null;
  this.a6X = null;
  this.K2 = null;
  this.a6W = ("[StoredString]" + name);
  this.a6X = new $c_Lcom_raquo_airstream_eventbus_EventBus();
  var $x_2 = this.a6X.k5;
  if ($m_Lio_laminext_core_BrowserUtils$().a6V) {
    var this$1 = $m_s_Option$().as(window.localStorage.getItem(this.a6W));
    var $x_1 = (this$1.c() ? initial : this$1.d());
  } else {
    var $x_1 = initial;
  }
  this.K2 = $f_Lcom_raquo_airstream_core_EventStream__scanLeft__O__F2__Lcom_raquo_airstream_core_Signal($x_2, $x_1, new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((x$1, x$2) => {
    var newValue = x$2.i(x$1);
    if ($m_Lio_laminext_core_BrowserUtils$().a6V) {
      window.localStorage.setItem(this.a6W, newValue);
    }
    return newValue;
  })));
}
$p = $c_Lio_laminext_core_StoredString.prototype = new $h_O();
$p.constructor = $c_Lio_laminext_core_StoredString;
/** @constructor */
function $h_Lio_laminext_core_StoredString() {
}
$h_Lio_laminext_core_StoredString.prototype = $p;
$p.Y0 = (function(newValue) {
  this.a6X.dn.bA(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => newValue)));
});
var $d_Lio_laminext_core_StoredString = new $TypeData().i($c_Lio_laminext_core_StoredString, "io.laminext.core.StoredString", ({
  rk: 1
}));
/** @constructor */
function $c_Lio_laminext_core_ops_signal_SignalOfBooleanOps(underlying) {
  this.wr = null;
  this.wr = underlying;
}
$p = $c_Lio_laminext_core_ops_signal_SignalOfBooleanOps.prototype = new $h_O();
$p.constructor = $c_Lio_laminext_core_ops_signal_SignalOfBooleanOps;
/** @constructor */
function $h_Lio_laminext_core_ops_signal_SignalOfBooleanOps() {
}
$h_Lio_laminext_core_ops_signal_SignalOfBooleanOps.prototype = $p;
var $d_Lio_laminext_core_ops_signal_SignalOfBooleanOps = new $TypeData().i($c_Lio_laminext_core_ops_signal_SignalOfBooleanOps, "io.laminext.core.ops.signal.SignalOfBooleanOps", ({
  rl: 1
}));
function $f_Lio_laminext_syntax_ReceiversSyntax__$init$__V($thiz) {
}
/** @constructor */
function $c_jl_BoundsChecks$() {
}
$p = $c_jl_BoundsChecks$.prototype = new $h_O();
$p.constructor = $c_jl_BoundsChecks$;
/** @constructor */
function $h_jl_BoundsChecks$() {
}
$h_jl_BoundsChecks$.prototype = $p;
$p.agF = (function(capacity) {
  throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Illegal capacity: " + capacity));
});
$p.aPu = (function(index, length) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((("Index " + index) + " out of bounds [0, ") + length) + ")"));
});
$p.b3D = (function(index, length) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((("Index " + index) + " out of bounds [0, ") + length) + "]"));
});
$p.aPv = (function(start, end, length) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((((("Range [" + start) + ", ") + end) + ") out of bounds [0, ") + length) + ")"));
});
$p.r5 = (function(offset, count, length) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((((((("Range [" + offset) + ", ") + offset) + " + ") + count) + ") out of bounds [0, ") + length) + ")"));
});
var $d_jl_BoundsChecks$ = new $TypeData().i($c_jl_BoundsChecks$, "java.lang.BoundsChecks$", ({
  rX: 1
}));
var $n_jl_BoundsChecks$;
function $m_jl_BoundsChecks$() {
  if ((!$n_jl_BoundsChecks$)) {
    $n_jl_BoundsChecks$ = new $c_jl_BoundsChecks$();
  }
  return $n_jl_BoundsChecks$;
}
function $is_jl_CharSequence(obj) {
  return ((!(!((obj && obj.$classData) && obj.$classData.n.aX))) || ((typeof obj) === "string"));
}
function $isArrayOf_jl_CharSequence(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.aX)));
}
/** @constructor */
function $c_jl_Long$StringRadixInfo(chunkLength, radixPowLength, mHat, paddingZeros, overflowBarrier_$_lo, overflowBarrier_$_hi) {
  this.at1 = 0;
  this.Za = 0;
  this.a75 = 0.0;
  this.a76 = null;
  this.aLe = 0;
  this.aLf = 0;
  this.at1 = chunkLength;
  this.Za = radixPowLength;
  this.a75 = mHat;
  this.a76 = paddingZeros;
  this.aLe = overflowBarrier_$_lo;
  this.aLf = overflowBarrier_$_hi;
}
$p = $c_jl_Long$StringRadixInfo.prototype = new $h_O();
$p.constructor = $c_jl_Long$StringRadixInfo;
/** @constructor */
function $h_jl_Long$StringRadixInfo() {
}
$h_jl_Long$StringRadixInfo.prototype = $p;
var $d_jl_Long$StringRadixInfo = new $TypeData().i($c_jl_Long$StringRadixInfo, "java.lang.Long$StringRadixInfo", ({
  s8: 1
}));
/** @constructor */
function $c_jl_Math$() {
}
$p = $c_jl_Math$.prototype = new $h_O();
$p.constructor = $c_jl_Math$;
/** @constructor */
function $h_jl_Math$() {
}
$h_jl_Math$.prototype = $p;
$p.b7X = (function(a) {
  return ((a > 0.0) ? ((a >= 4.503599627370496E15) ? a : ((4.503599627370496E15 + a) - 4.503599627370496E15)) : ((a < 0.0) ? ((a <= (-4.503599627370496E15)) ? a : (-((4.503599627370496E15 - a) - 4.503599627370496E15))) : a));
});
$p.a2R = (function(a) {
  return (+Math.cbrt(a));
});
$p.b53 = (function(a) {
  var bits = $floatToBits(a);
  var x = (bits >> 31);
  var y = (1 | x);
  var newBits = ((bits + y) | 0);
  return (((2139095040 & (newBits | ((bits ^ newBits) >> 8))) !== 2139095040) ? $floatFromBits(newBits) : Math.fround((Math.fround((a + a)) + 1.401298464324817E-45)));
});
$p.b51 = (function(a) {
  var bits = $floatToBits(a);
  var x = (bits >> 31);
  var y = (1 | x);
  var newBits = ((bits - y) | 0);
  return (((2139095040 & (newBits | ((bits ^ newBits) >> 8))) !== 2139095040) ? $floatFromBits(newBits) : Math.fround((Math.fround((a + a)) - 1.401298464324817E-45)));
});
$p.b8e = (function(d, scaleFactor) {
  var fpBitsDataView = $fpBitsDataView;
  fpBitsDataView.setFloat64(0, d, true);
  var lo = (fpBitsDataView.getInt32(0, true) | 0);
  var hi = (fpBitsDataView.getInt32(4, true) | 0);
  var e = (2047 & ((hi >>> 20) | 0));
  var newE = ((e + scaleFactor) | 0);
  var hi$1 = ((-2146435073) & hi);
  var java$lang$IntFloatBits$Int64Box$$value_$_lo = 0;
  var java$lang$IntFloatBits$Int64Box$$value_$_hi = 0;
  java$lang$IntFloatBits$Int64Box$$value_$_lo = lo;
  java$lang$IntFloatBits$Int64Box$$value_$_hi = hi$1;
  if ((!((((e - 1) | 0) >>> 0) <= 2045))) {
    var hi$2 = (2147483647 & hi);
    if ((((lo | hi$2) === 0) || (hi$2 >= 2146435072))) {
      return d;
    }
    var hi$3 = (1048575 & hi);
    var clz = ((hi$3 !== 0) ? Math.clz32(hi$3) : ((32 + Math.clz32(lo)) | 0));
    newE = ((newE - ((clz - 12) | 0)) | 0);
    var hi$4 = ((-2147483648) & hi);
    var y = ((clz - 11) | 0);
    var lo$2 = (((32 & y) === 0) ? (lo << y) : 0);
    var hi$5 = (((32 & y) === 0) ? (((((lo >>> 1) | 0) >>> (~y)) | 0) | (hi << y)) : (lo << y));
    var hi$6 = (1048575 & hi$5);
    var hi$7 = (hi$4 | hi$6);
    java$lang$IntFloatBits$Int64Box$$value_$_lo = lo$2;
    java$lang$IntFloatBits$Int64Box$$value_$_hi = hi$7;
  }
  if (((((newE - 1) | 0) >>> 0) <= 2045)) {
    var finalNewE = newE;
    var finalSignAndMantissa_$_lo = java$lang$IntFloatBits$Int64Box$$value_$_lo;
    var finalSignAndMantissa_$_hi = java$lang$IntFloatBits$Int64Box$$value_$_hi;
    var hi$8 = (finalNewE << 20);
    var hi$9 = (hi$8 | finalSignAndMantissa_$_hi);
    var fpBitsDataView$1 = $fpBitsDataView;
    fpBitsDataView$1.setInt32(0, finalSignAndMantissa_$_lo, true);
    fpBitsDataView$1.setInt32(4, hi$9, true);
    return (+fpBitsDataView$1.getFloat64(0, true));
  } else if (((((53 + newE) | 0) >>> 0) <= 53)) {
    var finalNewE$1 = ((54 + newE) | 0);
    var finalSignAndMantissa$1_$_lo = java$lang$IntFloatBits$Int64Box$$value_$_lo;
    var finalSignAndMantissa$1_$_hi = java$lang$IntFloatBits$Int64Box$$value_$_hi;
    var hi$10 = (finalNewE$1 << 20);
    var hi$11 = (hi$10 | finalSignAndMantissa$1_$_hi);
    var fpBitsDataView$2 = $fpBitsDataView;
    fpBitsDataView$2.setInt32(0, finalSignAndMantissa$1_$_lo, true);
    fpBitsDataView$2.setInt32(4, hi$11, true);
    return (5.551115123125783E-17 * (+fpBitsDataView$2.getFloat64(0, true)));
  } else {
    var finalNewE$2 = (2047 & (~(scaleFactor >> 31)));
    var hi$12 = ((-2147483648) & hi);
    var hi$13 = (finalNewE$2 << 20);
    var hi$14 = (hi$13 | hi$12);
    var fpBitsDataView$3 = $fpBitsDataView;
    fpBitsDataView$3.setInt32(0, 0, true);
    fpBitsDataView$3.setInt32(4, hi$14, true);
    return (+fpBitsDataView$3.getFloat64(0, true));
  }
});
$p.ga = (function(a, b) {
  return (+Math.hypot(a, b));
});
var $d_jl_Math$ = new $TypeData().i($c_jl_Math$, "java.lang.Math$", ({
  s9: 1
}));
var $n_jl_Math$;
function $m_jl_Math$() {
  if ((!$n_jl_Math$)) {
    $n_jl_Math$ = new $c_jl_Math$();
  }
  return $n_jl_Math$;
}
var $d_jl_Runnable = new $TypeData().i(1, "java.lang.Runnable", ({
  dc: 1
}));
function $p_jl_StackTrace$__normalizedLinesToStackTrace__O__Ajl_StackTraceElement($thiz, lines) {
  var NormalizedFrameLine = $m_jl_StackTrace$StringRE$().wc("^([^@]*)@(.*?):([0-9]+)(?::([0-9]+))?$");
  var trace = [];
  var i = 0;
  while ((i < (lines.length | 0))) {
    var line = lines[i];
    if ((line !== "")) {
      var mtch = NormalizedFrameLine.exec(line);
      if ((mtch !== null)) {
        var classAndMethodName = $p_jl_StackTrace$__extractClassMethod__T__O($thiz, mtch[1]);
        var $x_5 = classAndMethodName[0];
        var $x_4 = classAndMethodName[1];
        var $x_3 = mtch[2];
        var x$2 = mtch[3];
        var $x_2 = parseInt(x$2);
        var x$3 = mtch[4];
        var $x_1 = trace.push(new $c_jl_StackTraceElement($x_5, $x_4, $x_3, ($x_2 | 0), ((x$3 !== (void 0)) ? (parseInt(x$3) | 0) : (-1))));
      } else {
        (trace.push(new $c_jl_StackTraceElement("<jscode>", line, null, (-1), (-1))) | 0);
      }
    }
    i = ((1 + i) | 0);
  }
  var len = (trace.length | 0);
  var result = new ($d_jl_StackTraceElement.r().C)(len);
  i = 0;
  while ((i < len)) {
    result.a[i] = trace[i];
    i = ((1 + i) | 0);
  }
  return result;
}
function $p_jl_StackTrace$__extractClassMethod__T__O($thiz, functionName) {
  var PatBC = $m_jl_StackTrace$StringRE$().wc("^(?:Object\\.|\\[object Object\\]\\.|Module\\.)?\\$[bc]_([^\\.]+)(?:\\.prototype)?\\.([^\\.]+)$");
  var PatS = $m_jl_StackTrace$StringRE$().wc("^(?:Object\\.|\\[object Object\\]\\.|Module\\.)?\\$(?:ps?|s|f)_((?:_[^_]|[^_])+)__([^\\.]+)$");
  var PatCT = $m_jl_StackTrace$StringRE$().wc("^(?:Object\\.|\\[object Object\\]\\.|Module\\.)?\\$ct_((?:_[^_]|[^_])+)__([^\\.]*)$");
  var PatN = $m_jl_StackTrace$StringRE$().wc("^new (?:Object\\.|\\[object Object\\]\\.|Module\\.)?\\$c_([^\\.]+)$");
  var PatM = $m_jl_StackTrace$StringRE$().wc("^(?:Object\\.|\\[object Object\\]\\.|Module\\.)?\\$m_([^\\.]+)$");
  var matchBC = PatBC.exec(functionName);
  var matchBCOrS = ((matchBC !== null) ? matchBC : PatS.exec(functionName));
  if ((matchBCOrS !== null)) {
    return [$p_jl_StackTrace$__decodeClassName__T__T($thiz, matchBCOrS[1]), $p_jl_StackTrace$__decodeMethodName__T__T($thiz, matchBCOrS[2])];
  } else {
    var matchCT = PatCT.exec(functionName);
    var matchCTOrN = ((matchCT !== null) ? matchCT : PatN.exec(functionName));
    if ((matchCTOrN !== null)) {
      return [$p_jl_StackTrace$__decodeClassName__T__T($thiz, matchCTOrN[1]), "<init>"];
    } else {
      var matchM = PatM.exec(functionName);
      return ((matchM !== null) ? [$p_jl_StackTrace$__decodeClassName__T__T($thiz, matchM[1]), "<clinit>"] : ["<jscode>", functionName]);
    }
  }
}
function $p_jl_StackTrace$__decodeClassName__T__T($thiz, encodedName) {
  var dict = $p_jl_StackTrace$__decompressedClasses__O($thiz);
  if ((!(!$m_jl_Utils$Cache$().K8.call(dict, encodedName)))) {
    var dict$1 = $p_jl_StackTrace$__decompressedClasses__O($thiz);
    var base = dict$1[encodedName];
  } else {
    var base = $p_jl_StackTrace$__loop$1__I__T__T($thiz, 0, encodedName);
  }
  var this$3 = base.split("_").join(".");
  return this$3.split("\uff3f").join("_");
}
function $p_jl_StackTrace$__decompressedClasses$lzycompute__O($thiz) {
  if (((((1 & $thiz.rk) << 24) >> 24) === 0)) {
    var dict = ({});
    dict.O = "java_lang_Object";
    dict.T = "java_lang_String";
    var index = 0;
    while ((index <= 22)) {
      if ((index >= 2)) {
        var key = ("T" + index);
        var value = ("scala_Tuple" + index);
        dict[key] = value;
      }
      var key$1 = ("F" + index);
      var value$1 = ("scala_Function" + index);
      dict[key$1] = value$1;
      index = ((1 + index) | 0);
    }
    $thiz.a78 = dict;
    $thiz.rk = (((1 | $thiz.rk) << 24) >> 24);
  }
  return $thiz.a78;
}
function $p_jl_StackTrace$__decompressedClasses__O($thiz) {
  return (((((1 & $thiz.rk) << 24) >> 24) === 0) ? $p_jl_StackTrace$__decompressedClasses$lzycompute__O($thiz) : $thiz.a78);
}
function $p_jl_StackTrace$__decompressedPrefixes$lzycompute__O($thiz) {
  if (((((2 & $thiz.rk) << 24) >> 24) === 0)) {
    var dict = ({});
    dict.sjsr_ = "scala_scalajs_runtime_";
    dict.sjs_ = "scala_scalajs_";
    dict.sci_ = "scala_collection_immutable_";
    dict.scm_ = "scala_collection_mutable_";
    dict.scg_ = "scala_collection_generic_";
    dict.sc_ = "scala_collection_";
    dict.sr_ = "scala_runtime_";
    dict.s_ = "scala_";
    dict.jl_ = "java_lang_";
    dict.ju_ = "java_util_";
    $thiz.a79 = dict;
    $thiz.rk = (((2 | $thiz.rk) << 24) >> 24);
  }
  return $thiz.a79;
}
function $p_jl_StackTrace$__decompressedPrefixes__O($thiz) {
  return (((((2 & $thiz.rk) << 24) >> 24) === 0) ? $p_jl_StackTrace$__decompressedPrefixes$lzycompute__O($thiz) : $thiz.a79);
}
function $p_jl_StackTrace$__compressedPrefixes$lzycompute__O($thiz) {
  if (((((4 & $thiz.rk) << 24) >> 24) === 0)) {
    $thiz.a77 = Object.keys($p_jl_StackTrace$__decompressedPrefixes__O($thiz));
    $thiz.rk = (((4 | $thiz.rk) << 24) >> 24);
  }
  return $thiz.a77;
}
function $p_jl_StackTrace$__compressedPrefixes__O($thiz) {
  return (((((4 & $thiz.rk) << 24) >> 24) === 0) ? $p_jl_StackTrace$__compressedPrefixes$lzycompute__O($thiz) : $thiz.a77);
}
function $p_jl_StackTrace$__decodeMethodName__T__T($thiz, encodedName) {
  if ((!(!encodedName.startsWith("init___")))) {
    return "<init>";
  } else {
    var methodNameLen = (encodedName.indexOf("__") | 0);
    return ((methodNameLen < 0) ? encodedName : encodedName.substring(0, methodNameLen));
  }
}
function $p_jl_StackTrace$__normalizeStackTraceLines__O__O($thiz, e) {
  return ((!(!(!(!(!e))))) ? [] : ((!(!(!(!(e.arguments && e.stack))))) ? $p_jl_StackTrace$__extractChrome__O__O($thiz, e) : ((!(!(!(!(e.stack && e.sourceURL))))) ? $p_jl_StackTrace$__extractSafari__O__O($thiz, e) : ((!(!(!(!(e.stack && e.number))))) ? $p_jl_StackTrace$__extractIE__O__O($thiz, e) : ((!(!(!(!(e.stack && e.fileName))))) ? $p_jl_StackTrace$__extractFirefox__O__O($thiz, e) : ((!(!(!(!(e.message && e["opera#sourceloc"]))))) ? ((!(!(!(!(!e.stacktrace))))) ? $p_jl_StackTrace$__extractOpera9__O__O($thiz, e) : ((!(!(!(!((e.message.indexOf("\n") > (-1.0)) && (e.message.split("\n").length > e.stacktrace.split("\n").length)))))) ? $p_jl_StackTrace$__extractOpera9__O__O($thiz, e) : $p_jl_StackTrace$__extractOpera10a__O__O($thiz, e))) : ((!(!(!(!((e.message && e.stack) && e.stacktrace))))) ? ((!(!(!(!(e.stacktrace.indexOf("called from line") < 0.0))))) ? $p_jl_StackTrace$__extractOpera10b__O__O($thiz, e) : $p_jl_StackTrace$__extractOpera11__O__O($thiz, e)) : ((!(!(!(!(e.stack && (!e.fileName)))))) ? $p_jl_StackTrace$__extractChrome__O__O($thiz, e) : $p_jl_StackTrace$__extractOther__O__O($thiz, e)))))))));
}
function $p_jl_StackTrace$__extractChrome__O__O($thiz, e) {
  return (e.stack + "\n").replace($m_jl_StackTrace$StringRE$().wc("^[\\s\\S]+?\\s+at\\s+"), " at ").replace($m_jl_StackTrace$StringRE$().pE("^\\s+(at eval )?at\\s+", "gm"), "").replace($m_jl_StackTrace$StringRE$().pE("^([^\\(]+?)([\\n])", "gm"), "{anonymous}() ($1)$2").replace($m_jl_StackTrace$StringRE$().pE("^Object.<anonymous>\\s*\\(([^\\)]+)\\)", "gm"), "{anonymous}() ($1)").replace($m_jl_StackTrace$StringRE$().pE("^([^\\(]+|\\{anonymous\\}\\(\\)) \\((.+)\\)$", "gm"), "$1@$2").split("\n").slice(0, (-1));
}
function $p_jl_StackTrace$__extractFirefox__O__O($thiz, e) {
  return e.stack.replace($m_jl_StackTrace$StringRE$().pE("(?:\\n@:0)?\\s+$", "m"), "").replace($m_jl_StackTrace$StringRE$().pE("^(?:\\((\\S*)\\))?@", "gm"), "{anonymous}($1)@").split("\n");
}
function $p_jl_StackTrace$__extractIE__O__O($thiz, e) {
  var qual$1 = e.stack.replace($m_jl_StackTrace$StringRE$().pE("^\\s*at\\s+(.*)$", "gm"), "$1").replace($m_jl_StackTrace$StringRE$().pE("^Anonymous function\\s+", "gm"), "{anonymous}() ").replace($m_jl_StackTrace$StringRE$().pE("^([^\\(]+|\\{anonymous\\}\\(\\))\\s+\\((.+)\\)$", "gm"), "$1@$2").split("\n");
  return qual$1.slice(1);
}
function $p_jl_StackTrace$__extractSafari__O__O($thiz, e) {
  return e.stack.replace($m_jl_StackTrace$StringRE$().pE("\\[native code\\]\\n", "m"), "").replace($m_jl_StackTrace$StringRE$().pE("^(?=\\w+Error\\:).*$\\n", "m"), "").replace($m_jl_StackTrace$StringRE$().pE("^@", "gm"), "{anonymous}()@").split("\n");
}
function $p_jl_StackTrace$__extractOpera9__O__O($thiz, e) {
  var lineRE = $m_jl_StackTrace$StringRE$().pE("Line (\\d+).*script (?:in )?(\\S+)", "i");
  var lines = e.message.split("\n");
  var result = [];
  var i = 2;
  var len = (lines.length | 0);
  while ((i < len)) {
    var mtch = lineRE.exec(lines[i]);
    if ((mtch !== null)) {
      (result.push(((("{anonymous}()@" + mtch[2]) + ":") + mtch[1])) | 0);
    }
    i = ((2 + i) | 0);
  }
  return result;
}
function $p_jl_StackTrace$__extractOpera10a__O__O($thiz, e) {
  var lineRE = $m_jl_StackTrace$StringRE$().pE("Line (\\d+).*script (?:in )?(\\S+)(?:: In function (\\S+))?$", "i");
  var lines = e.stacktrace.split("\n");
  var result = [];
  var i = 0;
  var len = (lines.length | 0);
  while ((i < len)) {
    var mtch = lineRE.exec(lines[i]);
    if ((mtch !== null)) {
      var x = mtch[3];
      var fnName = ((x !== (void 0)) ? x : "{anonymous}");
      (result.push(((((fnName + "()@") + mtch[2]) + ":") + mtch[1])) | 0);
    }
    i = ((2 + i) | 0);
  }
  return result;
}
function $p_jl_StackTrace$__extractOpera10b__O__O($thiz, e) {
  var lineRE = $m_jl_StackTrace$StringRE$().wc("^(.*)@(.+):(\\d+)$");
  var lines = e.stacktrace.split("\n");
  var result = [];
  var i = 0;
  var len = (lines.length | 0);
  while ((i < len)) {
    var mtch = lineRE.exec(lines[i]);
    if ((mtch !== null)) {
      var x = mtch[1];
      var fnName = ((x !== (void 0)) ? (x + "()") : "global code");
      (result.push(((((fnName + "@") + mtch[2]) + ":") + mtch[3])) | 0);
    }
    i = ((1 + i) | 0);
  }
  return result;
}
function $p_jl_StackTrace$__extractOpera11__O__O($thiz, e) {
  var lineRE = $m_jl_StackTrace$StringRE$().wc("^.*line (\\d+), column (\\d+)(?: in (.+))? in (\\S+):$");
  var lines = e.stacktrace.split("\n");
  var result = [];
  var i = 0;
  var len = (lines.length | 0);
  while ((i < len)) {
    var mtch = lineRE.exec(lines[i]);
    if ((mtch !== null)) {
      var location = ((((mtch[4] + ":") + mtch[1]) + ":") + mtch[2]);
      var x$3 = mtch[2];
      var fnName0 = ((x$3 !== (void 0)) ? x$3 : "global code");
      var fnName = fnName0.replace($m_jl_StackTrace$StringRE$().wc("<anonymous function: (\\S+)>"), "$1").replace($m_jl_StackTrace$StringRE$().wc("<anonymous function>"), "{anonymous}");
      (result.push(((fnName + "@") + location)) | 0);
    }
    i = ((2 + i) | 0);
  }
  return result;
}
function $p_jl_StackTrace$__extractOther__O__O($thiz, e) {
  return [];
}
function $p_jl_StackTrace$__loop$1__I__T__T($thiz, i, encodedName$1) {
  while (true) {
    if ((i < ($p_jl_StackTrace$__compressedPrefixes__O($thiz).length | 0))) {
      var prefix = $p_jl_StackTrace$__compressedPrefixes__O($thiz)[i];
      if ((!(!encodedName$1.startsWith(prefix)))) {
        var dict = $p_jl_StackTrace$__decompressedPrefixes__O($thiz);
        return (("" + dict[prefix]) + encodedName$1.substring(prefix.length));
      } else {
        i = ((1 + i) | 0);
      }
    } else {
      return ((!(!encodedName$1.startsWith("L"))) ? encodedName$1.substring(1) : encodedName$1);
    }
  }
}
/** @constructor */
function $c_jl_StackTrace$() {
  this.a78 = null;
  this.a79 = null;
  this.a77 = null;
  this.rk = 0;
}
$p = $c_jl_StackTrace$.prototype = new $h_O();
$p.constructor = $c_jl_StackTrace$;
/** @constructor */
function $h_jl_StackTrace$() {
}
$h_jl_StackTrace$.prototype = $p;
$p.b11 = (function(jsError) {
  return $p_jl_StackTrace$__normalizedLinesToStackTrace__O__Ajl_StackTraceElement(this, $p_jl_StackTrace$__normalizeStackTraceLines__O__O(this, jsError));
});
var $d_jl_StackTrace$ = new $TypeData().i($c_jl_StackTrace$, "java.lang.StackTrace$", ({
  sd: 1
}));
var $n_jl_StackTrace$;
function $m_jl_StackTrace$() {
  if ((!$n_jl_StackTrace$)) {
    $n_jl_StackTrace$ = new $c_jl_StackTrace$();
  }
  return $n_jl_StackTrace$;
}
/** @constructor */
function $c_jl_StackTrace$StringRE$() {
}
$p = $c_jl_StackTrace$StringRE$.prototype = new $h_O();
$p.constructor = $c_jl_StackTrace$StringRE$;
/** @constructor */
function $h_jl_StackTrace$StringRE$() {
}
$h_jl_StackTrace$StringRE$.prototype = $p;
$p.wc = (function(this$) {
  return new RegExp(this$);
});
$p.pE = (function(this$, mods) {
  return new RegExp(this$, mods);
});
var $d_jl_StackTrace$StringRE$ = new $TypeData().i($c_jl_StackTrace$StringRE$, "java.lang.StackTrace$StringRE$", ({
  se: 1
}));
var $n_jl_StackTrace$StringRE$;
function $m_jl_StackTrace$StringRE$() {
  if ((!$n_jl_StackTrace$StringRE$)) {
    $n_jl_StackTrace$StringRE$ = new $c_jl_StackTrace$StringRE$();
  }
  return $n_jl_StackTrace$StringRE$;
}
/** @constructor */
function $c_jl_System$Streams$() {
  this.at2 = null;
  this.K7 = null;
  $n_jl_System$Streams$ = this;
  this.at2 = new $c_jl_JSConsoleBasedPrintStream(false);
  this.K7 = new $c_jl_JSConsoleBasedPrintStream(true);
}
$p = $c_jl_System$Streams$.prototype = new $h_O();
$p.constructor = $c_jl_System$Streams$;
/** @constructor */
function $h_jl_System$Streams$() {
}
$h_jl_System$Streams$.prototype = $p;
var $d_jl_System$Streams$ = new $TypeData().i($c_jl_System$Streams$, "java.lang.System$Streams$", ({
  si: 1
}));
var $n_jl_System$Streams$;
function $m_jl_System$Streams$() {
  if ((!$n_jl_System$Streams$)) {
    $n_jl_System$Streams$ = new $c_jl_System$Streams$();
  }
  return $n_jl_System$Streams$;
}
function $p_jl_System$SystemProperties$__loadSystemProperties__O($thiz) {
  var result = ({});
  result["java.version"] = "1.8";
  result["java.vm.specification.version"] = "1.8";
  result["java.vm.specification.vendor"] = "Oracle Corporation";
  result["java.vm.specification.name"] = "Java Virtual Machine Specification";
  result["java.vm.name"] = "Scala.js";
  result["java.vm.version"] = "1.22.0";
  result["java.specification.version"] = "1.8";
  result["java.specification.vendor"] = "Oracle Corporation";
  result["java.specification.name"] = "Java Platform API Specification";
  result["file.separator"] = "/";
  result["path.separator"] = ":";
  result["line.separator"] = "\n";
  return result;
}
/** @constructor */
function $c_jl_System$SystemProperties$() {
  this.a7a = null;
  this.at3 = null;
  $n_jl_System$SystemProperties$ = this;
  this.a7a = $p_jl_System$SystemProperties$__loadSystemProperties__O(this);
  this.at3 = null;
}
$p = $c_jl_System$SystemProperties$.prototype = new $h_O();
$p.constructor = $c_jl_System$SystemProperties$;
/** @constructor */
function $h_jl_System$SystemProperties$() {
}
$h_jl_System$SystemProperties$.prototype = $p;
$p.agd = (function(key, default$1) {
  if ((this.a7a !== null)) {
    var dict = this.a7a;
    return ((!(!$m_jl_Utils$Cache$().K8.call(dict, key))) ? dict[key] : default$1);
  } else {
    return this.at3.agd(key, default$1);
  }
});
var $d_jl_System$SystemProperties$ = new $TypeData().i($c_jl_System$SystemProperties$, "java.lang.System$SystemProperties$", ({
  sj: 1
}));
var $n_jl_System$SystemProperties$;
function $m_jl_System$SystemProperties$() {
  if ((!$n_jl_System$SystemProperties$)) {
    $n_jl_System$SystemProperties$ = new $c_jl_System$SystemProperties$();
  }
  return $n_jl_System$SystemProperties$;
}
/** @constructor */
function $c_jl_ThreadLocal() {
  this.a7b = false;
  this.at4 = null;
  this.a7b = false;
}
$p = $c_jl_ThreadLocal.prototype = new $h_O();
$p.constructor = $c_jl_ThreadLocal;
/** @constructor */
function $h_jl_ThreadLocal() {
}
$h_jl_ThreadLocal.prototype = $p;
$p.d = (function() {
  if ((!this.a7b)) {
    this.XZ(null);
  }
  return this.at4;
});
$p.XZ = (function(o) {
  this.at4 = o;
  this.a7b = true;
});
var $d_jl_ThreadLocal = new $TypeData().i($c_jl_ThreadLocal, "java.lang.ThreadLocal", ({
  sl: 1
}));
/** @constructor */
function $c_jl_UnicodeData$() {
  this.at9 = null;
  this.at8 = null;
  $n_jl_UnicodeData$ = this;
  this.at9 = $constArrSDiffs_I(161, "8l]]]]]]]]L]]]]]4]]]]]]]]]]]]]]L]]]]zLi]]_{]]z^_^|ya]n]]]]]]]]]l]^]]|]Of]]]]]]]]]]]]]]]]]]]]]]]]]0q`{byaOd]]]]]]]]]]]]]]]]]]]]]]]]]0paz`7s]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]Gz");
  this.at8 = $constArrUDiffs_I(2891, "D4u4_@_4|7^80003f3H0004u3y3t4i3|4^3z3o8m3d4s100004]300004`3m80003w3H0004v3j<j3f2Lu3eL^30t3f10|70^23|60^G]7|9]@^:|8^7|A^7|;]8^;|9^7|L^?|@^:|9^?|7^4`4y7^8`?y4_4|7^4{7_4|23|2<^7^4{?]9]7;^G|9^7|8^>|=]13^8@`3z8003<_3H0014]8000L]3H0008t?f1@t8001Gf3H000DtKf4t3f4t23h8008D]3H0004]58x?`4t4c6|80008a3H0003{<s3f3|@x7c100004t300003f;|4^3|4^9^6|1O|4^14^4=]7|7]8^<|2O^@|7u4f;|8^6|68^60|47x3gD^8w6L^1G|<2|4^4G|8a4qGg54s3y3i8y7{3c4c3N]1Fk5o2o5k6o5k6o5k1w10b3;x@b@p7e1<mHf;|8_3{8a9g1:o3u4e;j3O|4^1:^1B]6]J`18l?j:^1|<<p3j6^Jg4i3g:]={:_6s3g>]1|8a17y<t7f4p1Ge4m3r6^1|3J^1N]1;w8b;6^19|3x1Hf17y44^13{8u3y;i3y8c4q7h2J^6]7{6_11{6_9{6_>]3w8u1Ke4b34^;w8u3e4b1;xDb30s3gGx4m7mHcO|53|4_1:]1>]8g5sJ]J]2<_1z6J^4_2{9_;{10_={6_6z7^>]9|1:^6o7n18l3i4^1N^4_5u4bOx8b7x8b2Gx4bKx4b3x<b?x9c9_;{=w:e5u:e6z6x12e1u@b7x4b>^5w8f17y8r7nHn3{3h4p3k3w:c8_1u4bGx@b7x8b2Gx4bKx4b7x4b7x4b7x8c3w6e;{5wBc5w:c6]3w>c1wLb?x4b3xLf19z5|>^2o3e1:c8_1u4b13x4b;x4b2Gx4bKx4b7x4bCx9c9_;{Aw6c8_1u6e5{3w8b3x1Lb:^5w8f18l4_3cLb6^:];w6c4_5u4bOx8b7x8b2Gx4bKx4b7x4bCx9c9_3{4_3{=w:e5u:e5{3wLc6]4_1u@b7x4b>^5w8f18p3f4cGr1:c1|3x4bGx<b;x4b?x<b7x4b3x4b7x<b7x<b;x<b1?xBe7{4_5u>e9u6e9{3w8b3xJe1u1Hf18_<nG{4_3aFc4_;{1|Ox4b;x4b2Kx4b1Ox9c9]<_=u6c9w6c:]3wNc5w4b;x8b3x8b:^5w8f17tLu3pLn3f6^4_6m3jOx4b;x4b2Kx4b17x4bCx9c9_3{4_Au6c4_5u6e7{2]3wNe5uHb7x4b:^5w8f17t4b:`1u1Bc8_5z13x4b;x4b54^7|6`;{=w6e9u6e:z7t3a@b>`2`Kw>^5w8f18_14n3fGx6c4_5u4b27x<b2Ox4b13x4b3x8bKx<c3wBe;{9w6c1w6eMuHf17t:e6m3e1@b62^1|:^Iw@w3hG|4_J]2]4o3n18l7e4Db7x4b3x4bCx4b2Ox4b3x4b1:^1|:^F]6]5|3x8bCx4a3y4cF]2]3w4f17t8b?x40b4t;y1La3y4a;g8sGj18_18n3g4s3g4s3g5l>p7zOx4b4?xBc1H_3{>]4o3k7|F^19w6c4=w4yOg4sGa4y7yDa?y7e4Db5>`7{@_3{B]6_1{:_7{5|4a18lGjJ`7{5|B^9|6`9z:`Iz>^=|1F^4_7{8_G{1|6`2^19|;{2s7b4G|4^3|D^3|8_5<s80003i3H0003{<`193x4b?x8bKx4b3x4b?x8b53x4b?x8b43x4b?x8bKx4b3x4b?x8b1Kx4b73x4b?x8b8;x8c<o100013p300014]1;r<b20t17aH^:G|8_G{8q3n2=@t3y3j24d3v39n6g<b9<p;o;xOxLb2:^6]4_3u14b2>^6_4m7e14b2:^5w1@b1Cx4b;x6c5w1@b6@^:_3{L_O{4_5{1<o;i4q<_4h6x8f17tHh17rHuGy4a?k<g3s4`17tHb4;|4^6CxLb20000F^200005|4:^1|3xDb8Gx18b3Kx6c<_?{8_9uBe7{4_E{;w@y3a<u7n17y3Gx8bCx1<b5?x@b37xHf100018_300003r<y47f2N^8_7{1w8u7j6F`3{4_3{Iw4c6_3{4_7{10_G{6]Ow8c4`17tHf17tHuKi4qGe8c1H^5|6]1>]9w66c@_1z5L^6_3{D_3{4_C{4_2]3zOx<f18lLa17g14s13y7e6c8_1z3J`3{@_7{6_3{6]5|8a17y5@^6_3{8_;{4_3{:_7u10u?j4B`O{10_7{2]3w<uCn17t<b<a17y3G|Hq7g13{L^5;|8^<tOe10c<o3k1D_3{K|A]7]E^6|4`3{7|3xD_8005@_3H007K{8001D_3H0003{80048_3H004D_4N]1F]1<xBG^10|<7^O|10^G{8^G|8_O|10^O|10^G{8^G|8_O{4^3|4^3|4^3|5_7]K|10^1G{8_10^O|10^O|10^O|C{4_7|@_4u3d4v;d;{4_7|@_4u;d?{8_7|?|4x;dO|Dw;b8_;{4_7|@_4u7b4i1<aDaHa9b6u4e8^3t4e3x10r7`Cy4i15c6w?|8^<^4z7_1<^3|3|4^17q4aCm4m17x80003v3H0003y8hHk<z80006k3H0004d18k<z6g80004a3H001Cy<w43c1Lc1D^?|4^;|1?w1Ly7b4x?b4x8c6|8^7|<^4w3b4x200007z200003eDxGb4x3b4x3b4x3b20000@x200004b7]<^4`?z4w7c7|8uDf7]<w3z4`7c4w3l@001O|3H0020]3H0020]<u7e@^4n7a@vD`Cz8`?z4`7z4`7z4`Kz4`3Kz8`7z4`3z4`3Kz11@`10v?d2?z8`Lw7c:3z4`3Gz34`4OzH`8Ca34y1;a2Dh7@n@0038]3H0038]3H0037l2HnFKz4`13z4`6Gz10`=Kz4`O0v1Fs3Hn5?zDz7`3Ly17a20`OOz@<z2G`7Ly?a40y7a108`5Oz2D`7zH`4Ka8y3Oa4y=3b60^60|;]8^9]J|=]<^;]8000D_3H0007z=]<;^4wHc?a<x6|Du?p4j7g4G{4_3{D_3{8b6OxLa4q3e1Ib7]2Gx14bKx4bKx4bKx4bKx4bKx4bKx4bKx4bKx6c3No9b>x=c6w5b6x13y4a7y4a5b6x9b7uO`Ci4q17y8a?y4a3z4`1Da7y<{N{3i48y37a4y;3a1@yJGa38y1?a@i4i<a3e4^4b5h17d8vN|5_7]4c3k13y@_8i3mDu7k;w4^4p4a7a4b:Gx8c200008r200007f8^4l3n;8p3i<^3xDb5;x4b;Gx4y7l@n17f40t4?a1@b20t3Ka4h18n3Gl10n3l1Ln3Ol18n4Kl1Ln17OfIH0t7Of2B2C|4^4>Kx<y6Ka14b4O|Hq7j11?|4q;j20a17y7x2A^5Ha7_<n5kN]8o3i4z8003?`3H000:_5|8Hb17y8oGe10x2Kf14t8c1G^8|8007G`3H0003{11]C|17`4t8d?`4y?^8|2C]A]7]A]1O]=^:{E^6|4_3{5^B|80030a3H000<{7`80003|3H0007{4`N^1|=^6|>^1|2N`7{8_2q?g3w<hHn7{4_3aHb6@p?e12e5z6:`1M{6]1w10u7n17tHc27|Hp;j4p3j:^2`17y3B^B]<o7j2N^1<_2]3u1<u3j3Cx>c<_1z5L^6_7{@_7{8_6]4m1Ce4a4b17t@u7jF^1{4^14a17yCx4b56^H_7{8_7{5w14b>^1|12^4_1u8f17t8u?j1O|4^Ht;f6`3{4_1z6:^1|6^9|:^5|F^2|>x30b7|4q7j1>`3{8_6m7j3|:a1{3w18bGx8bGx8bGx14bKx4bKx4_5<v80003f3H000?{80014_3H0004t7b@_:0`4>`7{4_7{4_6m3m3{3w8f17tHb1;D?x1@b2Kx@b63x@p7OO|HOOp1=Gx8b=7x4H_K{1@_C{Db6^1|18q3i1Cx4bCx4b3x4b7x4b7x4b=@s23b20b1==n7c1Of7Ox8b6GxLy3a40b1@r4_;g20oL{7_3eHc20o3y8`8|1O_8{7_?|<^;e4u?y5_G_<^3x4b;d4u4_3{7e@bCx4b@Kx8m3m4u<_3{<z7`4^3|3y4a7n18l8^;|7f38q4`3{4b3y4a3d38p4a3z4`4z7_4z7`7j17|4^5C|8^3Kx<bGx8bGx8bGx8b;x<w7|4_4^3{7c4y3z@`7a18m<i7a8b1?x4b37x4b2;x4b7x4b1Kx8b1Gx48b?;xDu;e@h5Cr<y13k6D^@n23l8n;a4y1Ca<y3a5Ly5Cg3w@8b3Cx<b63x1Lc4b3;r@b40c?r14b2@b3x10b3sDb4J^AwDb3Gx4u3j4?x@b10p3oCs58^50^50`9Gx8f17tH^4?|@_4?{@b4Ox10b6?x1<u3f1;|4^1K|4^K|4^7|4_1;{4_1K{4_K{4_7{8<b16Kx14b2Gx18bOx80030a3H0004]80008]3H000;y80004a3H0057y80004a3H0013y8DbGx8b3x4b5?x4b7x<b3x8b2Kx4u3pOw2Lt7lKw3Kx10h13r60b2;x4b7xDhCw2HcGr<u3j37xDu3e80b6Ox@h7w8c1Or8h5Gw6^9w6c5wFc=|?x4b;x4b3Cx8c;w@c4b13rLu13eLb3Dc8j3j3Dc;r40b10t3f3@^7w@hDjKe14b6Gx<uKj2Gx8hOw2;xDhOw27xLu?e1@hKr:0b93x6L^6;|1D_6;{LhGw4B^=w10f17t14Hh3Kr4b57x6c6k3i8b7x9<c;|3Dc17w3x10b2H^1<b@jCe2Hb28^@o?e4Hb2DcKr2@b2Kx16e3{4_1z6F^1F]4oKe@h2?{18z6|6^5|3x14c6]8_1z5F`;{@_5{8o7u4eAk1w18m3m8b33xLf17tJc9|4B^D_3{F]7w4f18l?j6`5z3x10b4<^4o7j3x16c8_1z62`;{14_2]3z@p?k@o5m3{2`17y4p3j4p;e4h2?r1<b27x4b36`;{<_7{2_3{6]2oIk1|:^1w7HbKx4b3x4b?x4b1Kx4b18p3eHb5N^4_;{F]7wDf17tJc8_5u4bOx8b7x8b2Gx4bKx4b7x4bCx4c7|6`7{4_=u:e5u:e6]3u8b3xJe1uDbF`5u8cKw<cCwA<b6F`;{10_5{6]8_2{6|<pCn18l7e4u4k6|7x3Hb62`;{H_3{4_?{8_1{7|8p3j3x10f17tDHb5N`;{=w:e?{8_1{8o2KjB^5w48b62`;{10_7{4_1{6]2o;j3x1<f17tHu1Ce2<b5>^4_3{4_7{F_4z7p3eHf17t6Hb3;x:c<_7{@_3{>]3w@f18_8j<a3fKxG4b5B`;{14_1{8o3e<@^40^40d18_13r1@bOx8b3x8bOx4b7x4b32`Eu6e5u:c6_4{9_1z6`1{4o;e14f17t8HbOx8b4N`;{=w:c8_>{7o3j6`1u3<b6^15|50^:]@_1z6^>oOk3w10b6^H_7{9|5J^1D_1{8o;j4pCe1Db93xLu17eNHb13x4b4F`3{Iw6cH_2z7pCe18f18_2;r<u7j3Gx:c2Ew6e3{L_3{8_3{5w94bKx4b7x4b4J^Ew>c1w6c5w6c:]6]2]7|6^1w10f17tHbGx4b7x4b42`Au6c5w6e7{4_2z6xLf17t16Hb2>^8_6m7eNc5|6`1z1Cx4b4:`7{Aw>e7{2_3{4o1Cn17t:Hb3x1Lh2DnO{@_23a1Du3j3C7x<Hg=Ks4uCe1<bH?x:9@b<4p7e1Db460h20s6|D^1Kw?E8b28Kx11G4b273xLb3Kx4f17t@u7j9Kx4f17tHb3Gx8cDo3e18b60^LoDa?e@q4a3a18f17t4hKr4b2CxDb2;x2F0^40^40f2Lj?e<Db9;xBc1|6`6IuNc={1Cy80a8q3i4_3w1>e5u1HbGNOx10b4JGx58b13x12LLa?y4aKy4a7y4b14;x1Lb3x3Db;x8b3x1Hb?x10b1A?x90@b=;xDb1Cx<b13xLb17x8y3g6]2o3u?mB;@c5Gw8c2Kw14y>?a7@yNGa18y4Ka8y7?i7{<s;iHeOs10s7gLs3Gg@s7Ca2Dy87g<s3a?8h2?r1@h2?r1@y:Ka14h33r@L^38^37|38^K{4_27|38^37|3|4^7|8^3|8^7|8^?|4^10^?{4_3{4_K{4_1;|38^37|7|4^?|8^O|4^K|4_37|7|4^?|4^C|4^3|<^K|4_37|38^37|38^37|38^37|38^37|38^37|38^3?{8^34u3f34t3fG|34u3f34t3fG|34u3f34t3fG|34u3f34t3fG|34u3f34t3fH|6|8f68p1OOg6Ls?g68sOg4s1Gg4s7yCe1LcCw4c1Kw4:0_18`3z2?{H_G{JFcIw6c21w:cIw6c5w6cAw8000Da3H007Gy46c1w>0b5Cx<cK{Ky8f17t@b4t3a180b3H^3w24b5@^@`17tDw3c1J0b3;|4_@`17t2LHbKx4b?x4b7x4b1Kx4bHCx8h13xKw54^48^48a>]2];{3y@f17t@u7e324h7<n3l<l3n?r9@h5Dn3l1KrH8b?x4b3;x4b7x4b3x8b3x4b17x4b?x4b3x4b3xHb3x@b3x4b3x4b3x4b;x4b7x4b3x8b3x4b3x4b3x4b3x4b3x4b7x4b3x8b?x4bKx4b?x4b?x4b3x4b17x4b23xDb;x4bCx4b23x6@v7d11Hy5?a@y<?a1@y1Ka8y1Ka4y1Ka4y4Ca18h1Dn@004<]3@0038]@000H]3@0038]@000H]3@0038]4?a70y3Ca1Dy5?a@y13aLy7a1HyGaC8yO;|D^2JOa@y23a<y1Ca<y>Ka@y;KaHy1?a@y3a1Ly1?a@y6Oa10y17aHy4Oa10y3Ga8y7a9Hy1:?a1@y1Ga8y1Ca<y13aLy5Ga4yKa10y1Ga@y13aLy13aLyB;a4y6Ka4Df17t40Hb56KOx40b@77xHbKGx8bF@7x1HbM63x<3Lb23Gx5L8bC9;xDb@;Ox2FL:4m3m3Hm;Om@0cMOw7N20o7OOGk8o7OOGk");
}
$p = $c_jl_UnicodeData$.prototype = new $h_O();
$p.constructor = $c_jl_UnicodeData$;
/** @constructor */
function $h_jl_UnicodeData$() {
}
$h_jl_UnicodeData$.prototype = $p;
$p.Xj = (function(cp) {
  if (((cp >>> 0) > 1114111)) {
    return 0;
  } else {
    var shiftedCP = (cp << 7);
    var dataRanges = this.at8;
    var low = 0;
    var high = 2891;
    while ((((1 + low) | 0) !== high)) {
      var mid = ((((low + high) | 0) >>> 1) | 0);
      if (((shiftedCP >>> 0) < ((268435328 & dataRanges.a[mid]) >>> 0))) {
        high = mid;
      } else {
        low = mid;
      }
    }
    var data = dataRanges.a[low];
    var parityBit = ((1 & cp) & ((data >>> 5) | 0));
    return ((((-268435329) & data) ^ parityBit) ^ (parityBit << 1));
  }
});
$p.Ao = (function(cp) {
  if (((cp >>> 0) < 161)) {
    return ((((cp - 65) | 0) >>> 0) <= 25);
  } else {
    var data = this.Xj(cp);
    return (((2 & (1 << data)) | (536870912 & data)) !== 0);
  }
});
$p.b3i = (function(cp) {
  return (((cp >>> 0) < 161) ? ((((cp - 48) | 0) >>> 0) <= 9) : ((31 & this.Xj(cp)) === 9));
});
$p.a3S = (function(cp) {
  return (((cp >>> 0) < 161) ? (((((32 | cp) - 97) | 0) >>> 0) <= 25) : ((62 & (1 << this.Xj(cp))) !== 0));
});
$p.E5 = (function(cp) {
  return (((cp >>> 0) < 161) ? ((((((32 | cp) - 97) | 0) >>> 0) <= 25) || ((((cp - 48) | 0) >>> 0) <= 9)) : ((574 & (1 << this.Xj(cp))) !== 0));
});
$p.E7 = (function(cp) {
  return (((cp >>> 0) < 161) ? ((128 & this.at9.a[cp]) !== 0) : ((((28672 & (1 << this.Xj(cp))) !== 0) && (cp !== 8199)) && (cp !== 8239)));
});
var $d_jl_UnicodeData$ = new $TypeData().i($c_jl_UnicodeData$, "java.lang.UnicodeData$", ({
  sm: 1
}));
var $n_jl_UnicodeData$;
function $m_jl_UnicodeData$() {
  if ((!$n_jl_UnicodeData$)) {
    $n_jl_UnicodeData$ = new $c_jl_UnicodeData$();
  }
  return $n_jl_UnicodeData$;
}
/** @constructor */
function $c_jl_Utils$Cache$() {
  this.K8 = null;
  $n_jl_Utils$Cache$ = this;
  this.K8 = Object.prototype.hasOwnProperty;
}
$p = $c_jl_Utils$Cache$.prototype = new $h_O();
$p.constructor = $c_jl_Utils$Cache$;
/** @constructor */
function $h_jl_Utils$Cache$() {
}
$h_jl_Utils$Cache$.prototype = $p;
var $d_jl_Utils$Cache$ = new $TypeData().i($c_jl_Utils$Cache$, "java.lang.Utils$Cache$", ({
  sn: 1
}));
var $n_jl_Utils$Cache$;
function $m_jl_Utils$Cache$() {
  if ((!$n_jl_Utils$Cache$)) {
    $n_jl_Utils$Cache$ = new $c_jl_Utils$Cache$();
  }
  return $n_jl_Utils$Cache$;
}
function $f_jl_Void__equals__O__Z($thiz, that) {
  return ($thiz === that);
}
function $f_jl_Void__hashCode__I($thiz) {
  return 0;
}
function $f_jl_Void__toString__T($thiz) {
  return "undefined";
}
function $isArrayOf_jl_Void(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.f0)));
}
var $d_jl_Void = new $TypeData().i(0, "java.lang.Void", ({
  f0: 1
}), ((x) => (x === (void 0))));
function $p_jl_reflect_Array$__mismatch__O__E($thiz, array) {
  throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "argument type mismatch");
}
function $p_jl_reflect_Array$__rec$1__jl_Class__I__AI__O($thiz, componentType, offset, dimensions$1) {
  var length = dimensions$1.a[offset];
  var result = componentType.ba.U(length);
  var innerOffset = ((1 + offset) | 0);
  if ((innerOffset < dimensions$1.a.length)) {
    var innerComponentType = componentType.ba.Q();
    var i = 0;
    while ((i !== length)) {
      result.a[i] = $p_jl_reflect_Array$__rec$1__jl_Class__I__AI__O($thiz, innerComponentType, innerOffset, dimensions$1);
      i = ((1 + i) | 0);
    }
  }
  return result;
}
/** @constructor */
function $c_jl_reflect_Array$() {
}
$p = $c_jl_reflect_Array$.prototype = new $h_O();
$p.constructor = $c_jl_reflect_Array$;
/** @constructor */
function $h_jl_reflect_Array$() {
}
$h_jl_reflect_Array$.prototype = $p;
$p.m0 = (function(componentType, dimensions) {
  var len = dimensions.a.length;
  if ((len === 0)) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  }
  var outermostComponentType = componentType;
  var i = 1;
  while ((i !== len)) {
    outermostComponentType = $objectGetClass(outermostComponentType.ba.U(0));
    i = ((1 + i) | 0);
  }
  return $p_jl_reflect_Array$__rec$1__jl_Class__I__AI__O(this, outermostComponentType, 0, dimensions);
});
$p.c6 = (function(array) {
  if ((array instanceof $ac_O)) {
    return array.a.length;
  } else if ((array instanceof $ac_Z)) {
    return array.a.length;
  } else if ((array instanceof $ac_C)) {
    return array.a.length;
  } else if ((array instanceof $ac_B)) {
    return array.a.length;
  } else if ((array instanceof $ac_S)) {
    return array.a.length;
  } else if ((array instanceof $ac_I)) {
    return array.a.length;
  } else if ((array instanceof $ac_J)) {
    return ((array.a.length >>> 1) | 0);
  } else if ((array instanceof $ac_F)) {
    return array.a.length;
  } else {
    if ((!(array instanceof $ac_D))) {
      $p_jl_reflect_Array$__mismatch__O__E(this, array);
    }
    return array.a.length;
  }
});
var $d_jl_reflect_Array$ = new $TypeData().i($c_jl_reflect_Array$, "java.lang.reflect.Array$", ({
  so: 1
}));
var $n_jl_reflect_Array$;
function $m_jl_reflect_Array$() {
  if ((!$n_jl_reflect_Array$)) {
    $n_jl_reflect_Array$ = new $c_jl_reflect_Array$();
  }
  return $n_jl_reflect_Array$;
}
/** @constructor */
function $c_Ljava_math_BigInteger$QuotAndRem(quot, rem) {
  this.yD = null;
  this.Kb = null;
  this.yD = quot;
  this.Kb = rem;
}
$p = $c_Ljava_math_BigInteger$QuotAndRem.prototype = new $h_O();
$p.constructor = $c_Ljava_math_BigInteger$QuotAndRem;
/** @constructor */
function $h_Ljava_math_BigInteger$QuotAndRem() {
}
$h_Ljava_math_BigInteger$QuotAndRem.prototype = $p;
$p.b9Y = (function() {
  return new ($d_Ljava_math_BigInteger.r().C)([this.yD, this.Kb]);
});
var $d_Ljava_math_BigInteger$QuotAndRem = new $TypeData().i($c_Ljava_math_BigInteger$QuotAndRem, "java.math.BigInteger$QuotAndRem", ({
  sr: 1
}));
/** @constructor */
function $c_Ljava_math_BitLevel$() {
}
$p = $c_Ljava_math_BitLevel$.prototype = new $h_O();
$p.constructor = $c_Ljava_math_BitLevel$;
/** @constructor */
function $h_Ljava_math_BitLevel$() {
}
$h_Ljava_math_BitLevel$.prototype = $p;
$p.DM = (function(bi) {
  if ((bi.bS === 0)) {
    return 0;
  } else {
    var bLength = (bi.cp << 5);
    var highDigit = bi.bC.a[((bi.cp - 1) | 0)];
    if ((bi.bS < 0)) {
      if ((bi.a3A() === ((bi.cp - 1) | 0))) {
        highDigit = ((highDigit - 1) | 0);
      }
    }
    bLength = ((bLength - Math.clz32(highDigit)) | 0);
    return bLength;
  }
});
$p.aS9 = (function(source, count) {
  var intCount = ((count >>> 5) | 0);
  var andCount = (31 & count);
  var offset = ((andCount !== 0) | 0);
  var resLength = ((((source.cp + intCount) | 0) + offset) | 0);
  $m_Ljava_math_BigInteger$().aYi(resLength);
  var resDigits = new $ac_I(resLength);
  this.ai1(resDigits, source.bC, intCount, andCount);
  var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), source.bS, resLength, resDigits);
  result.pq();
  return result;
});
$p.ai1 = (function(result, source, intCount, count) {
  if ((count === 0)) {
    var x4 = ((result.a.length - intCount) | 0);
    source.av(0, result, intCount, x4);
  } else {
    var rightShiftCount = ((32 - count) | 0);
    result.a[((result.a.length - 1) | 0)] = 0;
    var i = ((result.a.length - 1) | 0);
    while ((i > intCount)) {
      var ev$1 = i;
      result.a[ev$1] = (result.a[ev$1] | ((source.a[((((i - intCount) | 0) - 1) | 0)] >>> rightShiftCount) | 0));
      result.a[((i - 1) | 0)] = (source.a[((((i - intCount) | 0) - 1) | 0)] << count);
      i = ((i - 1) | 0);
    }
  }
  var i$1 = 0;
  while ((i$1 < intCount)) {
    var value = i$1;
    result.a[value] = 0;
    i$1 = ((1 + i$1) | 0);
  }
});
$p.b8P = (function(source) {
  var srcLen = source.cp;
  var resLen = ((1 + srcLen) | 0);
  var resDigits = new $ac_I(resLen);
  this.aSa(resDigits, source.bC, srcLen);
  var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), source.bS, resLen, resDigits);
  result.pq();
  return result;
});
$p.aSa = (function(result, source, srcLen) {
  var elem = 0;
  elem = 0;
  var i = 0;
  while ((i < srcLen)) {
    var value = i;
    var iVal = source.a[value];
    result.a[value] = ((iVal << 1) | elem);
    elem = ((iVal >>> 31) | 0);
    i = ((1 + i) | 0);
  }
  if ((elem !== 0)) {
    result.a[srcLen] = elem;
  }
});
$p.aSc = (function(source, count) {
  var intCount = ((count >>> 5) | 0);
  var andCount = (31 & count);
  if ((intCount >= source.cp)) {
    return ((source.bS < 0) ? $m_Ljava_math_BigInteger$().Zc : $m_Ljava_math_BigInteger$().ws);
  } else {
    var resLength = ((source.cp - intCount) | 0);
    var resDigits = new $ac_I(((1 + resLength) | 0));
    this.aSd(resDigits, resLength, source.bC, intCount, andCount);
    if ((source.bS < 0)) {
      var i = 0;
      while (((i < intCount) && (source.bC.a[i] === 0))) {
        i = ((1 + i) | 0);
      }
      var cmp = ((source.bC.a[i] << ((-andCount) | 0)) !== 0);
      if (((i < intCount) || ((andCount > 0) && cmp))) {
        i = 0;
        while (((i < resLength) && (resDigits.a[i] === (-1)))) {
          resDigits.a[i] = 0;
          i = ((1 + i) | 0);
        }
        if ((i === resLength)) {
          resLength = ((1 + resLength) | 0);
        }
        var ev$1 = i;
        resDigits.a[ev$1] = ((1 + resDigits.a[ev$1]) | 0);
      }
    }
    var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), source.bS, resLength, resDigits);
    result.pq();
    return result;
  }
});
$p.aSd = (function(result, resultLen, source, intCount, count) {
  var i = 0;
  var allZero = true;
  while ((i < intCount)) {
    allZero = (!(!(allZero & (source.a[i] === 0))));
    i = ((1 + i) | 0);
  }
  if ((count === 0)) {
    source.av(intCount, result, 0, resultLen);
  } else {
    var leftShiftCount = ((32 - count) | 0);
    allZero = (!(!(allZero & ((source.a[i] << leftShiftCount) === 0))));
    i = 0;
    while ((i < ((resultLen - 1) | 0))) {
      result.a[i] = (((source.a[((i + intCount) | 0)] >>> count) | 0) | (source.a[((1 + ((i + intCount) | 0)) | 0)] << leftShiftCount));
      i = ((1 + i) | 0);
    }
    result.a[i] = ((source.a[((i + intCount) | 0)] >>> count) | 0);
    i = ((1 + i) | 0);
  }
  return allZero;
});
var $d_Ljava_math_BitLevel$ = new $TypeData().i($c_Ljava_math_BitLevel$, "java.math.BitLevel$", ({
  ss: 1
}));
var $n_Ljava_math_BitLevel$;
function $m_Ljava_math_BitLevel$() {
  if ((!$n_Ljava_math_BitLevel$)) {
    $n_Ljava_math_BitLevel$ = new $c_Ljava_math_BitLevel$();
  }
  return $n_Ljava_math_BitLevel$;
}
function $p_Ljava_math_Conversion$__dropLeadingZeros__T__T($thiz, s) {
  var zeroPrefixLength = 0;
  var len = s.length;
  while (((zeroPrefixLength < len) && (s.charCodeAt(zeroPrefixLength) === 48))) {
    zeroPrefixLength = ((1 + zeroPrefixLength) | 0);
  }
  var beginIndex = zeroPrefixLength;
  return s.substring(beginIndex);
}
/** @constructor */
function $c_Ljava_math_Conversion$() {
  this.a7g = null;
  this.a7f = null;
  $n_Ljava_math_Conversion$ = this;
  this.a7g = $constArrSDiffs_I(37, "|]1]qy{{]||]|]]]|]]]]]]|]]]]]]]]]]]]]|");
  this.a7f = $constArrRaw_I(35, "44444jyh:M84444HMFcl@54rWNmaTjUU44444aL`OT54BguFYiimD444YbI@HxAD48hyOyr:kd444448mMLUP4@kyInVbULE44pJDqYSRi:HB@h5m`ip@444`iHLBqd74uRRJ`L`OT54H`C;QZ8U[48foiJHwPFE444449DGvo8HPG5OQLS`i54eRF44");
}
$p = $c_Ljava_math_Conversion$.prototype = new $h_O();
$p.constructor = $c_Ljava_math_Conversion$;
/** @constructor */
function $h_Ljava_math_Conversion$() {
}
$h_Ljava_math_Conversion$.prototype = $p;
$p.aXX = (function(bi, radix) {
  var sign = bi.bS;
  var numberLength = bi.cp;
  var digits = bi.bC;
  if ((sign === 0)) {
    return "0";
  } else if ((numberLength === 1)) {
    var highDigit = digits.a[((numberLength - 1) | 0)];
    var v_$_lo = highDigit;
    var v_$_hi = 0;
    if ((sign < 0)) {
      var x_$_lo = v_$_lo;
      var x_$_hi = v_$_hi;
      var lo = ((-x_$_lo) | 0);
      var hi$1 = ((((-x_$_hi) | 0) - ((lo !== 0) | 0)) | 0);
      v_$_lo = lo;
      v_$_hi = hi$1;
    }
    var this$4 = $m_jl_Long$();
    var i_$_lo = v_$_lo;
    var i_$_hi = v_$_hi;
    return (((radix === 10) || ((((radix - 2) | 0) >>> 0) > 34)) ? $m_RTLong$().kY(i_$_lo, i_$_hi) : this$4.b3F(i_$_lo, i_$_hi, radix));
  } else if (((radix === 10) || ((((radix - 2) | 0) >>> 0) > 34))) {
    return $m_Ljava_math_Conversion$().yn(bi);
  } else {
    var bitsForRadixDigit = 0.0;
    var a = radix;
    bitsForRadixDigit = ((+Math.log(a)) / (+Math.log(2.0)));
    var addForSign = ((sign < 0) | 0);
    var biAbsLen = $m_Ljava_math_BitLevel$().DM(bi.a2A());
    var resLenInChars = ((1 + $doubleToInt(((biAbsLen / bitsForRadixDigit) + addForSign))) | 0);
    var elem = null;
    elem = "";
    var elem$1 = 0;
    elem$1 = resLenInChars;
    var elem$2 = 0;
    elem$2 = 0;
    if ((radix !== 16)) {
      var temp = new $ac_I(numberLength);
      digits.av(0, temp, 0, numberLength);
      var elem$3 = 0;
      elem$3 = numberLength;
      var charsPerInt = this.a7g.a[radix];
      var bigRadix = this.a7f.a[((radix - 2) | 0)];
      while (true) {
        elem$2 = $m_Ljava_math_Division$().afn(temp, temp, elem$3, bigRadix);
        var previous = elem$1;
        while (true) {
          elem$1 = ((elem$1 - 1) | 0);
          elem = (("" + $cToS($m_jl_Character$().b1t(((elem$2 % $checkIntDivisor(radix)) | 0), radix))) + elem);
          elem$2 = ((elem$2 / $checkIntDivisor(radix)) | 0);
          if (((elem$2 !== 0) && (elem$1 !== 0))) {
            continue;
          }
          break;
        }
        var delta = ((((charsPerInt - previous) | 0) + elem$1) | 0);
        var i$1 = 0;
        while (((i$1 < delta) && (elem$1 > 0))) {
          elem$1 = ((elem$1 - 1) | 0);
          elem = ("0" + elem);
          i$1 = ((1 + i$1) | 0);
        }
        i$1 = ((elem$3 - 1) | 0);
        while (((i$1 > 0) && (temp.a[i$1] === 0))) {
          i$1 = ((i$1 - 1) | 0);
        }
        elem$3 = ((1 + i$1) | 0);
        if ((!((elem$3 === 1) && (temp.a[0] === 0)))) {
          continue;
        }
        break;
      }
    } else {
      var i$2 = 0;
      while ((i$2 < numberLength)) {
        var value = i$2;
        var j = 0;
        while (((j < 8) && (elem$1 > 0))) {
          elem$2 = (15 & (digits.a[value] >> (j << 2)));
          elem$1 = ((elem$1 - 1) | 0);
          var i$3 = elem$2;
          elem = (("" + (i$3 >>> 0.0).toString(16)) + elem);
          j = ((1 + j) | 0);
        }
        i$2 = ((1 + i$2) | 0);
      }
    }
    var dropLen = 0;
    while ((elem.charCodeAt(dropLen) === 48)) {
      dropLen = ((1 + dropLen) | 0);
    }
    if ((dropLen !== 0)) {
      var this$22 = elem;
      var beginIndex = dropLen;
      elem = this$22.substring(beginIndex);
    }
    return ((sign === (-1)) ? ("-" + elem) : elem);
  }
});
$p.yn = (function(bi) {
  var sign = bi.bS;
  var numberLength = bi.cp;
  var digits = bi.bC;
  if ((sign === 0)) {
    return "0";
  } else if ((numberLength === 1)) {
    var i = digits.a[0];
    var absStr = (i >>> 0.0).toString(10);
    return ((sign < 0) ? ("-" + absStr) : absStr);
  } else {
    var result = "";
    var temp = new $ac_I(numberLength);
    var tempLen = numberLength;
    var x4 = tempLen;
    digits.av(0, temp, 0, x4);
    while (true) {
      var rem = 0;
      var i$1 = ((tempLen - 1) | 0);
      while ((i$1 >= 0)) {
        var value = rem;
        var value$1 = temp.a[i$1];
        var aHat = ((4.294967296E9 * (value >>> 0.0)) + (value$1 >>> 0.0));
        var x = (1.0000000000000017E-9 * aHat);
        var lo = (x | 0.0);
        var hi$2 = ((2.3283064365386963E-10 * x) | 0.0);
        var rHat = ((value$1 - Math.imul(1000000000, lo)) | 0);
        if ((rHat < 0)) {
          var lo$1 = ((lo - 1) | 0);
          var hi$3 = ((((hi$2 - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
          var x$2_$_lo = lo$1;
          var x$2_$_hi = hi$3;
        } else {
          var x$2_$_lo = lo;
          var x$2_$_hi = hi$2;
        }
        temp.a[i$1] = x$2_$_lo;
        var b0 = (65535 & x$2_$_lo);
        rem = ((value$1 - ((Math.imul(51712, b0) + (((Math.imul(15258, b0) + Math.imul(51712, ((x$2_$_lo >>> 16) | 0))) | 0) << 16)) | 0)) | 0);
        i$1 = ((i$1 - 1) | 0);
      }
      var this$22 = rem;
      var remStr = ("" + this$22);
      var beginIndex = remStr.length;
      var padding = "000000000".substring(beginIndex);
      result = ((padding + remStr) + result);
      while (((tempLen !== 0) && (temp.a[((tempLen - 1) | 0)] === 0))) {
        tempLen = ((tempLen - 1) | 0);
      }
      if ((tempLen !== 0)) {
      } else {
        break;
      }
    }
    result = $p_Ljava_math_Conversion$__dropLeadingZeros__T__T(this, result);
    return ((sign < 0) ? ("-" + result) : result);
  }
});
$p.ba5 = (function(value_$_lo, value_$_hi, scale) {
  if (((value_$_lo | value_$_hi) === 0)) {
    switch (scale) {
      case 0: {
        return "0";
        break;
      }
      case 1: {
        return "0.0";
        break;
      }
      case 2: {
        return "0.00";
        break;
      }
      case 3: {
        return "0.000";
        break;
      }
      case 4: {
        return "0.0000";
        break;
      }
      case 5: {
        return "0.00000";
        break;
      }
      case 6: {
        return "0.000000";
        break;
      }
      default: {
        var scaleVal = ((scale === (-2147483648)) ? "2147483648" : ("" + ((-scale) | 0)));
        return (((scale < 0) ? "0E+" : "0E") + scaleVal);
      }
    }
  } else {
    var negNumber = (value_$_hi < 0);
    var elem = null;
    elem = "";
    var currentChar = 18;
    if (negNumber) {
      var lo = ((-value_$_lo) | 0);
      var hi = ((((-value_$_hi) | 0) - ((lo !== 0) | 0)) | 0);
      var v_$_lo = lo;
      var v_$_hi = hi;
    } else {
      var v_$_lo = value_$_lo;
      var v_$_hi = value_$_hi;
    }
    while (true) {
      var prev_$_lo = v_$_lo;
      var prev_$_hi = v_$_hi;
      var num_$_lo = v_$_lo;
      var num_$_hi = v_$_hi;
      var sign = (num_$_hi >> 31);
      var xlo = (num_$_lo ^ sign);
      var rlo = ((xlo - sign) | 0);
      var rhi = (((num_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
      var quotHi = (((rhi >>> 0) / 10) | 0);
      var k = ((rhi - Math.imul(10, quotHi)) | 0);
      var quotLo = ((0.10000000000000005 * ((4.294967296E9 * k) + (rlo >>> 0.0))) | 0.0);
      if ((num_$_hi < 0)) {
        var lo$1 = ((-quotLo) | 0);
        var hi$1 = ((((-quotHi) | 0) - ((lo$1 !== 0) | 0)) | 0);
        v_$_lo = lo$1;
        v_$_hi = hi$1;
      } else {
        v_$_lo = quotLo;
        v_$_hi = quotHi;
      }
      currentChar = ((currentChar - 1) | 0);
      var x$1_$_lo = v_$_lo;
      var x$1_$_hi = v_$_hi;
      elem = (("" + ((prev_$_lo - ((Math.imul(10, (65535 & x$1_$_lo)) + (Math.imul(10, ((x$1_$_lo >>> 16) | 0)) << 16)) | 0)) | 0)) + elem);
      var x$2_$_lo = v_$_lo;
      var x$2_$_hi = v_$_hi;
      if (((x$2_$_lo | x$2_$_hi) !== 0)) {
      } else {
        break;
      }
    }
    var value$1 = ((18 - currentChar) | 0);
    var hi$4 = (value$1 >> 31);
    var hi$5 = (scale >> 31);
    var lo$4 = ((value$1 - scale) | 0);
    var hi$6 = ((((hi$4 - hi$5) | 0) - (((lo$4 >>> 0) > (value$1 >>> 0)) | 0)) | 0);
    var lo$5 = ((lo$4 - 1) | 0);
    var hi$7 = ((((hi$6 - 1) | 0) + ((lo$5 !== (-1)) | 0)) | 0);
    if (((scale > 0) && ((hi$7 === (-1)) ? ((lo$5 >>> 0) >= 4294967290) : (hi$7 > (-1))))) {
      var index = ((1 + lo$5) | 0);
      if ((index > 0)) {
        var this$27 = elem;
        var $x_1 = this$27.substring(0, index);
        var this$29 = elem;
        elem = (($x_1 + ".") + this$29.substring(index));
      } else {
        var end = ((-index) | 0);
        var i$1 = 0;
        while ((i$1 < end)) {
          elem = ("0" + elem);
          i$1 = ((1 + i$1) | 0);
        }
        elem = ("0." + elem);
      }
    } else if ((scale !== 0)) {
      var exponentStr = (((hi$7 === 0) ? (lo$5 !== 0) : (hi$7 > 0)) ? ("E+" + $s_RTLong__toString__I__I__T(lo$5, hi$7)) : ("E" + $s_RTLong__toString__I__I__T(lo$5, hi$7)));
      if ((((18 - currentChar) | 0) > 1)) {
        var this$35 = elem;
        var $x_2 = this$35.substring(0, 1);
        var this$37 = elem;
        elem = ((($x_2 + ".") + this$37.substring(1)) + exponentStr);
      } else {
        elem = (elem + exponentStr);
      }
    }
    return (negNumber ? ("-" + elem) : elem);
  }
});
var $d_Ljava_math_Conversion$ = new $TypeData().i($c_Ljava_math_Conversion$, "java.math.Conversion$", ({
  st: 1
}));
var $n_Ljava_math_Conversion$;
function $m_Ljava_math_Conversion$() {
  if ((!$n_Ljava_math_Conversion$)) {
    $n_Ljava_math_Conversion$ = new $c_Ljava_math_Conversion$();
  }
  return $n_Ljava_math_Conversion$;
}
/** @constructor */
function $c_Ljava_math_Division$() {
}
$p = $c_Ljava_math_Division$.prototype = new $h_O();
$p.constructor = $c_Ljava_math_Division$;
/** @constructor */
function $h_Ljava_math_Division$() {
}
$h_Ljava_math_Division$.prototype = $p;
$p.aNx = (function(quot, quotLength, a, aLength, b, bLength) {
  var normA = new $ac_I(((1 + aLength) | 0));
  var normB = new $ac_I(((1 + bLength) | 0));
  var i = b.a[((bLength - 1) | 0)];
  var divisorShift = Math.clz32(i);
  if ((divisorShift !== 0)) {
    $m_Ljava_math_BitLevel$().ai1(normB, b, 0, divisorShift);
    $m_Ljava_math_BitLevel$().ai1(normA, a, 0, divisorShift);
  } else {
    a.av(0, normA, 0, aLength);
    b.av(0, normB, 0, bLength);
  }
  var firstDivisorDigit = normB.a[((bLength - 1) | 0)];
  var i$1 = ((quotLength - 1) | 0);
  var elem = 0;
  elem = aLength;
  while ((i$1 >= 0)) {
    var elem$1 = 0;
    elem$1 = 0;
    if ((normA.a[elem] === firstDivisorDigit)) {
      elem$1 = (-1);
    } else {
      var value = normA.a[elem];
      var value$1 = normA.a[((elem - 1) | 0)];
      var $x_1 = $m_RTLong$().a38(value$1, value, firstDivisorDigit, 0);
      var quotient_$_lo = $x_1.l;
      var quotient_$_hi = $x_1.h;
      elem$1 = quotient_$_lo;
      var a0 = (65535 & quotient_$_lo);
      var a1 = ((quotient_$_lo >>> 16) | 0);
      var b0 = (65535 & firstDivisorDigit);
      var b1 = ((firstDivisorDigit >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var lo$1 = ((value$1 - lo) | 0);
      var elem$2 = 0;
      elem$2 = lo$1;
      if ((elem$1 !== 0)) {
        elem$1 = ((1 + elem$1) | 0);
        while (true) {
          elem$1 = ((elem$1 - 1) | 0);
          var value$2 = elem$1;
          var value$3 = normB.a[((bLength - 2) | 0)];
          var a0$1 = (65535 & value$2);
          var a1$1 = ((value$2 >>> 16) | 0);
          var b0$1 = (65535 & value$3);
          var b1$1 = ((value$3 >>> 16) | 0);
          var a0b0$1 = Math.imul(a0$1, b0$1);
          var a1b0$1 = Math.imul(a1$1, b0$1);
          var a0b1$1 = Math.imul(a0$1, b1$1);
          var lo$2 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
          var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
          var hi$7 = ((((Math.imul(a1$1, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
          var value$4 = elem$2;
          var value$5 = normA.a[((elem - 2) | 0)];
          var value$6 = elem$2;
          var lo$3 = ((value$6 + firstDivisorDigit) | 0);
          if (((((lo$3 >>> 0) < (value$6 >>> 0)) | 0) === 0)) {
            elem$2 = lo$3;
            if (((hi$7 === value$4) ? ((lo$2 >>> 0) > (value$5 >>> 0)) : ((hi$7 >>> 0) > (value$4 >>> 0)))) {
              continue;
            }
          }
          break;
        }
      }
    }
    if ((elem$1 !== 0)) {
      if (($m_Ljava_math_Division$().b4D(normA, ((elem - bLength) | 0), normB, bLength, elem$1) !== 0)) {
        elem$1 = ((elem$1 - 1) | 0);
        var elem$3_$_lo = 0;
        var elem$3_$_hi = 0;
        elem$3_$_lo = 0;
        elem$3_$_hi = 0;
        var i$2 = 0;
        while ((i$2 < bLength)) {
          var value$7 = i$2;
          var x_$_lo = elem$3_$_lo;
          var x_$_hi = elem$3_$_hi;
          var value$8 = normA.a[((((elem - bLength) | 0) + value$7) | 0)];
          var value$9 = normB.a[value$7];
          var lo$4 = ((value$8 + value$9) | 0);
          var hi$15 = (((lo$4 >>> 0) < (value$8 >>> 0)) | 0);
          var lo$5 = ((x_$_lo + lo$4) | 0);
          var hi$16 = ((((x_$_hi + hi$15) | 0) + (((lo$5 >>> 0) < (x_$_lo >>> 0)) | 0)) | 0);
          elem$3_$_lo = lo$5;
          elem$3_$_hi = hi$16;
          normA.a[((((elem - bLength) | 0) + value$7) | 0)] = elem$3_$_lo;
          var x$2_$_lo = elem$3_$_lo;
          var x$2_$_hi = elem$3_$_hi;
          elem$3_$_lo = x$2_$_hi;
          elem$3_$_hi = 0;
          i$2 = ((1 + i$2) | 0);
        }
      }
    }
    if ((quot !== null)) {
      quot.a[i$1] = elem$1;
    }
    elem = ((elem - 1) | 0);
    i$1 = ((i$1 - 1) | 0);
  }
  if ((divisorShift !== 0)) {
    $m_Ljava_math_BitLevel$().aSd(normB, bLength, normA, 0, divisorShift);
    return normB;
  } else {
    normA.av(0, normB, 0, bLength);
    return normA;
  }
});
$p.b03 = (function(bi, divisor, divisorSign) {
  var valDigits = bi.bC;
  var valLen = bi.cp;
  var valSign = bi.bS;
  if ((valLen === 1)) {
    var valDigit = valDigits.a[0];
    var value = (((valDigit >>> 0) / ($checkIntDivisor(divisor) >>> 0)) | 0);
    var quo_$_lo = value;
    var quo_$_hi = 0;
    var value$1 = (((valDigit >>> 0) % ($checkIntDivisor(divisor) >>> 0)) | 0);
    var rem_$_lo = value$1;
    var rem_$_hi = 0;
    if ((valSign !== divisorSign)) {
      var x_$_lo = quo_$_lo;
      var x_$_hi = quo_$_hi;
      var lo = ((-x_$_lo) | 0);
      var hi$2 = ((((-x_$_hi) | 0) - ((lo !== 0) | 0)) | 0);
      quo_$_lo = lo;
      quo_$_hi = hi$2;
    }
    if ((valSign < 0)) {
      var x$1_$_lo = rem_$_lo;
      var x$1_$_hi = rem_$_hi;
      var lo$1 = ((-x$1_$_lo) | 0);
      var hi$3 = ((((-x$1_$_hi) | 0) - ((lo$1 !== 0) | 0)) | 0);
      rem_$_lo = lo$1;
      rem_$_hi = hi$3;
    }
    return new $c_Ljava_math_BigInteger$QuotAndRem($m_Ljava_math_BigInteger$().oI(quo_$_lo, quo_$_hi), $m_Ljava_math_BigInteger$().oI(rem_$_lo, rem_$_hi));
  } else {
    var quotientSign = ((valSign === divisorSign) ? 1 : (-1));
    var quotientDigits = new $ac_I(valLen);
    var div = this.afn(quotientDigits, valDigits, valLen, divisor);
    var remainderDigits = new $ac_I(new Int32Array([div]));
    var result0 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), quotientSign, valLen, quotientDigits);
    var result1 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), valSign, 1, remainderDigits);
    result0.pq();
    result1.pq();
    return new $c_Ljava_math_BigInteger$QuotAndRem(result0, result1);
  }
});
$p.afn = (function(dest, src, srcLength, divisor) {
  var rem = 0;
  var i = ((srcLength - 1) | 0);
  while ((i >= 0)) {
    var value = rem;
    var value$1 = src.a[i];
    var $x_1 = $m_RTLong$().a38(value$1, value, divisor, 0);
    var quot_$_lo = $x_1.l;
    var quot_$_hi = $x_1.h;
    var a0 = (65535 & quot_$_lo);
    var a1 = ((quot_$_lo >>> 16) | 0);
    var b0 = (65535 & divisor);
    rem = ((value$1 - ((Math.imul(a0, b0) + (((Math.imul(a1, b0) + Math.imul(a0, ((divisor >>> 16) | 0))) | 0) << 16)) | 0)) | 0);
    dest.a[i] = quot_$_lo;
    i = ((i - 1) | 0);
  }
  return rem;
});
$p.b4D = (function(a, start, b, bLen, c) {
  var elem = 0;
  elem = 0;
  var elem$1 = 0;
  elem$1 = 0;
  var i = 0;
  while ((i < bLen)) {
    var value = i;
    $m_Ljava_math_Multiplication$();
    var a$1 = b.a[value];
    var c$1 = elem;
    var a0 = (65535 & a$1);
    var a1 = ((a$1 >>> 16) | 0);
    var b0 = (65535 & c);
    var b1 = ((c >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var lo$1 = ((lo + c$1) | 0);
    var hi$4 = ((hi$2 + (((lo$1 >>> 0) < (lo >>> 0)) | 0)) | 0);
    var value$1 = a.a[((start + value) | 0)];
    var lo$2 = ((value$1 - lo$1) | 0);
    var hi$6 = ((-(((lo$2 >>> 0) > (value$1 >>> 0)) | 0)) | 0);
    var value$2 = elem$1;
    var hi$7 = (value$2 >> 31);
    var lo$3 = ((lo$2 + value$2) | 0);
    var hi$8 = ((((hi$6 + hi$7) | 0) + (((lo$3 >>> 0) < (lo$2 >>> 0)) | 0)) | 0);
    a.a[((start + value) | 0)] = lo$3;
    elem$1 = hi$8;
    elem = hi$4;
    i = ((1 + i) | 0);
  }
  var value$3 = a.a[((start + bLen) | 0)];
  var value$4 = elem;
  var lo$4 = ((value$3 - value$4) | 0);
  var hi$13 = ((-(((lo$4 >>> 0) > (value$3 >>> 0)) | 0)) | 0);
  var value$5 = elem$1;
  var hi$14 = (value$5 >> 31);
  var lo$5 = ((lo$4 + value$5) | 0);
  var hi$15 = ((((hi$13 + hi$14) | 0) + (((lo$5 >>> 0) < (lo$4 >>> 0)) | 0)) | 0);
  a.a[((start + bLen) | 0)] = lo$5;
  return hi$15;
});
var $d_Ljava_math_Division$ = new $TypeData().i($c_Ljava_math_Division$, "java.math.Division$", ({
  su: 1
}));
var $n_Ljava_math_Division$;
function $m_Ljava_math_Division$() {
  if ((!$n_Ljava_math_Division$)) {
    $n_Ljava_math_Division$ = new $c_Ljava_math_Division$();
  }
  return $n_Ljava_math_Division$;
}
function $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI($thiz, a, aSize, b, bSize) {
  var res = new $ac_I(((1 + aSize) | 0));
  $p_Ljava_math_Elementary$__add__AI__AI__I__AI__I__V($thiz, res, a, aSize, b, bSize);
  return res;
}
function $p_Ljava_math_Elementary$__add__AI__AI__I__AI__I__V($thiz, res, a, aSize, b, bSize) {
  var i = 1;
  var value = a.a[0];
  var value$1 = b.a[0];
  var lo = ((value + value$1) | 0);
  var hi$2 = (((lo >>> 0) < (value >>> 0)) | 0);
  res.a[0] = lo;
  var carry = hi$2;
  if ((aSize >= bSize)) {
    while ((i < bSize)) {
      var value$2 = a.a[i];
      var value$3 = b.a[i];
      var lo$1 = ((value$2 + value$3) | 0);
      var hi$6 = (((lo$1 >>> 0) < (value$2 >>> 0)) | 0);
      var value$4 = carry;
      var lo$2 = ((lo$1 + value$4) | 0);
      var hi$8 = ((hi$6 + (((lo$2 >>> 0) < (lo$1 >>> 0)) | 0)) | 0);
      res.a[i] = lo$2;
      carry = hi$8;
      i = ((1 + i) | 0);
    }
    while ((i < aSize)) {
      var value$5 = a.a[i];
      var value$6 = carry;
      var lo$3 = ((value$5 + value$6) | 0);
      var hi$12 = (((lo$3 >>> 0) < (value$5 >>> 0)) | 0);
      res.a[i] = lo$3;
      carry = hi$12;
      i = ((1 + i) | 0);
    }
  } else {
    while ((i < aSize)) {
      var value$7 = a.a[i];
      var value$8 = b.a[i];
      var lo$4 = ((value$7 + value$8) | 0);
      var hi$16 = (((lo$4 >>> 0) < (value$7 >>> 0)) | 0);
      var value$9 = carry;
      var lo$5 = ((lo$4 + value$9) | 0);
      var hi$18 = ((hi$16 + (((lo$5 >>> 0) < (lo$4 >>> 0)) | 0)) | 0);
      res.a[i] = lo$5;
      carry = hi$18;
      i = ((1 + i) | 0);
    }
    while ((i < bSize)) {
      var value$10 = b.a[i];
      var value$11 = carry;
      var lo$6 = ((value$10 + value$11) | 0);
      var hi$22 = (((lo$6 >>> 0) < (value$10 >>> 0)) | 0);
      res.a[i] = lo$6;
      carry = hi$22;
      i = ((1 + i) | 0);
    }
  }
  if ((carry !== 0)) {
    res.a[i] = carry;
  }
}
function $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI($thiz, a, aSize, b, bSize) {
  var res = new $ac_I(aSize);
  $p_Ljava_math_Elementary$__subtract__AI__AI__I__AI__I__V($thiz, res, a, aSize, b, bSize);
  return res;
}
function $p_Ljava_math_Elementary$__subtract__AI__AI__I__AI__I__V($thiz, res, a, aSize, b, bSize) {
  var i = 0;
  var borrow = 0;
  while ((i < bSize)) {
    var value = a.a[i];
    var value$1 = b.a[i];
    var lo = ((value - value$1) | 0);
    var hi$2 = ((-(((lo >>> 0) > (value >>> 0)) | 0)) | 0);
    var value$2 = borrow;
    var hi$3 = (value$2 >> 31);
    var lo$1 = ((lo + value$2) | 0);
    var hi$4 = ((((hi$2 + hi$3) | 0) + (((lo$1 >>> 0) < (lo >>> 0)) | 0)) | 0);
    res.a[i] = lo$1;
    borrow = hi$4;
    i = ((1 + i) | 0);
  }
  while ((i < aSize)) {
    var value$3 = a.a[i];
    var value$4 = borrow;
    var hi$7 = (value$4 >> 31);
    var lo$2 = ((value$3 + value$4) | 0);
    var hi$8 = ((hi$7 + (((lo$2 >>> 0) < (value$3 >>> 0)) | 0)) | 0);
    res.a[i] = lo$2;
    borrow = hi$8;
    i = ((1 + i) | 0);
  }
}
/** @constructor */
function $c_Ljava_math_Elementary$() {
}
$p = $c_Ljava_math_Elementary$.prototype = new $h_O();
$p.constructor = $c_Ljava_math_Elementary$;
/** @constructor */
function $h_Ljava_math_Elementary$() {
}
$h_Ljava_math_Elementary$.prototype = $p;
$p.OT = (function(op1, op2) {
  var op1Sign = op1.bS;
  var op2Sign = op2.bS;
  var op1Len = op1.cp;
  var op2Len = op2.cp;
  if ((op1Sign === 0)) {
    return op2;
  } else if ((op2Sign === 0)) {
    return op1;
  } else if ((((op1Len + op2Len) | 0) === 2)) {
    var value = op1.bC.a[0];
    var value$1 = op2.bC.a[0];
    if ((op1Sign === op2Sign)) {
      var lo = ((value + value$1) | 0);
      var hi$2 = (((lo >>> 0) < (value >>> 0)) | 0);
      return ((hi$2 === 0) ? $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), op1Sign, lo) : $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), op1Sign, 2, new $ac_I(new Int32Array([lo, hi$2]))));
    } else {
      var $x_2 = $m_Ljava_math_BigInteger$();
      if ((op1Sign < 0)) {
        var lo$1 = ((value$1 - value) | 0);
        var hi$3 = ((-(((lo$1 >>> 0) > (value$1 >>> 0)) | 0)) | 0);
        var $x_1_$_lo = lo$1;
        var $x_1_$_hi = hi$3;
      } else {
        var lo$2 = ((value - value$1) | 0);
        var hi$4 = ((-(((lo$2 >>> 0) > (value >>> 0)) | 0)) | 0);
        var $x_1_$_lo = lo$2;
        var $x_1_$_hi = hi$4;
      }
      return $x_2.oI($x_1_$_lo, $x_1_$_hi);
    }
  } else {
    if ((op1Sign === op2Sign)) {
      var x1___1 = op1Sign;
      var x1___2 = ((op1Len >= op2Len) ? $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI(this, op1.bC, op1Len, op2.bC, op2Len) : $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI(this, op2.bC, op2Len, op1.bC, op1Len));
    } else {
      var cmp = ((op1Len !== op2Len) ? ((op1Len > op2Len) ? 1 : (-1)) : this.Ww(op1.bC, op2.bC, op1Len));
      if ((cmp === 0)) {
        return $m_Ljava_math_BigInteger$().ws;
      }
      if ((cmp === 1)) {
        var x1___1 = op1Sign;
        var x1___2 = $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI(this, op1.bC, op1Len, op2.bC, op2Len);
      } else {
        var x1___1 = op2Sign;
        var x1___2 = $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI(this, op2.bC, op2Len, op1.bC, op1Len);
      }
    }
    var resSign = (x1___1 | 0);
    var resDigits = x1___2;
    var res$3 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, resDigits.a.length, resDigits);
    res$3.pq();
    return res$3;
  }
});
$p.Ww = (function(a, b, size) {
  var i = ((size - 1) | 0);
  while (((i >= 0) && (a.a[i] === b.a[i]))) {
    i = ((i - 1) | 0);
  }
  return ((i < 0) ? 0 : (((a.a[i] >>> 0) < (b.a[i] >>> 0)) ? (-1) : 1));
});
$p.b2R = (function(a, aSize, addend) {
  var carry = addend;
  var i = 0;
  while (((carry !== 0) && (i < aSize))) {
    var value = carry;
    var value$1 = a.a[i];
    var lo = ((value + value$1) | 0);
    var hi$2 = (((lo >>> 0) < (value >>> 0)) | 0);
    a.a[i] = lo;
    carry = hi$2;
    i = ((1 + i) | 0);
  }
  return carry;
});
$p.a4Q = (function(op1, op2) {
  var op1Sign = op1.bS;
  var op2Sign = op2.bS;
  var op1Len = op1.cp;
  var op2Len = op2.cp;
  if ((op2Sign === 0)) {
    return op1;
  } else if ((op1Sign === 0)) {
    return op2.aQn();
  } else if ((((op1Len + op2Len) | 0) === 2)) {
    var value = op1.bC.a[0];
    var a_$_lo = value;
    var a_$_hi = 0;
    var value$1 = op2.bC.a[0];
    var b_$_lo = value$1;
    var b_$_hi = 0;
    if ((op1Sign < 0)) {
      var x_$_lo = a_$_lo;
      var x_$_hi = a_$_hi;
      var lo = ((-x_$_lo) | 0);
      var hi$2 = ((((-x_$_hi) | 0) - ((lo !== 0) | 0)) | 0);
      a_$_lo = lo;
      a_$_hi = hi$2;
    }
    if ((op2Sign < 0)) {
      var x$1_$_lo = b_$_lo;
      var x$1_$_hi = b_$_hi;
      var lo$1 = ((-x$1_$_lo) | 0);
      var hi$3 = ((((-x$1_$_hi) | 0) - ((lo$1 !== 0) | 0)) | 0);
      b_$_lo = lo$1;
      b_$_hi = hi$3;
    }
    var $x_1 = $m_Ljava_math_BigInteger$();
    var x$2_$_lo = a_$_lo;
    var x$2_$_hi = a_$_hi;
    var x$3_$_lo = b_$_lo;
    var x$3_$_hi = b_$_hi;
    var lo$2 = ((x$2_$_lo - x$3_$_lo) | 0);
    var hi$4 = ((((x$2_$_hi - x$3_$_hi) | 0) - (((lo$2 >>> 0) > (x$2_$_lo >>> 0)) | 0)) | 0);
    return $x_1.oI(lo$2, hi$4);
  } else {
    var cmp = ((op1Len !== op2Len) ? ((op1Len > op2Len) ? 1 : (-1)) : $m_Ljava_math_Elementary$().Ww(op1.bC, op2.bC, op1Len));
    if ((((op1Sign ^ op2Sign) | cmp) === 0)) {
      return $m_Ljava_math_BigInteger$().ws;
    }
    if ((cmp === (-1))) {
      var x1___1 = ((-op2Sign) | 0);
      var x1___2 = ((op1Sign === op2Sign) ? $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI(this, op2.bC, op2Len, op1.bC, op1Len) : $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI(this, op2.bC, op2Len, op1.bC, op1Len));
    } else if ((op1Sign === op2Sign)) {
      var x1___1 = op1Sign;
      var x1___2 = $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI(this, op1.bC, op1Len, op2.bC, op2Len);
    } else {
      var x1___1 = op1Sign;
      var x1___2 = $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI(this, op1.bC, op1Len, op2.bC, op2Len);
    }
    var resSign = (x1___1 | 0);
    var resDigits = x1___2;
    var res$2 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, resDigits.a.length, resDigits);
    res$2.pq();
    return res$2;
  }
});
var $d_Ljava_math_Elementary$ = new $TypeData().i($c_Ljava_math_Elementary$, "java.math.Elementary$", ({
  sv: 1
}));
var $n_Ljava_math_Elementary$;
function $m_Ljava_math_Elementary$() {
  if ((!$n_Ljava_math_Elementary$)) {
    $n_Ljava_math_Elementary$ = new $c_Ljava_math_Elementary$();
  }
  return $n_Ljava_math_Elementary$;
}
/** @constructor */
function $c_Ljava_math_MathContext(setPrecision, setRoundingMode) {
  this.yE = 0;
  this.EL = null;
  if ((setPrecision < 0)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Negative precision: " + setPrecision));
  }
  this.yE = setPrecision;
  this.EL = setRoundingMode;
}
$p = $c_Ljava_math_MathContext.prototype = new $h_O();
$p.constructor = $c_Ljava_math_MathContext;
/** @constructor */
function $h_Ljava_math_MathContext() {
}
$h_Ljava_math_MathContext.prototype = $p;
$p.e = (function(x) {
  if ((x instanceof $c_Ljava_math_MathContext)) {
    if ((this.yE === x.yE)) {
      var x$2 = this.EL;
      var x$3 = x.EL;
      return ((x$2 === null) ? (x$3 === null) : (x$2 === x$3));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.x = (function() {
  return ((this.yE << 3) | this.EL.k6);
});
$p.m = (function() {
  return ((("precision=" + this.yE) + " roundingMode=") + this.EL);
});
function $isArrayOf_Ljava_math_MathContext(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.f3)));
}
var $d_Ljava_math_MathContext = new $TypeData().i($c_Ljava_math_MathContext, "java.math.MathContext", ({
  f3: 1
}));
/** @constructor */
function $c_Ljava_math_MathContext$() {
  this.ate = null;
  $n_Ljava_math_MathContext$ = this;
  this.ate = new $c_Ljava_math_MathContext(34, $m_Ljava_math_RoundingMode$().B2);
  new $c_Ljava_math_MathContext(7, $m_Ljava_math_RoundingMode$().B2);
  new $c_Ljava_math_MathContext(16, $m_Ljava_math_RoundingMode$().B2);
  new $c_Ljava_math_MathContext(0, $m_Ljava_math_RoundingMode$().R0);
}
$p = $c_Ljava_math_MathContext$.prototype = new $h_O();
$p.constructor = $c_Ljava_math_MathContext$;
/** @constructor */
function $h_Ljava_math_MathContext$() {
}
$h_Ljava_math_MathContext$.prototype = $p;
var $d_Ljava_math_MathContext$ = new $TypeData().i($c_Ljava_math_MathContext$, "java.math.MathContext$", ({
  sw: 1
}));
var $n_Ljava_math_MathContext$;
function $m_Ljava_math_MathContext$() {
  if ((!$n_Ljava_math_MathContext$)) {
    $n_Ljava_math_MathContext$ = new $c_Ljava_math_MathContext$();
  }
  return $n_Ljava_math_MathContext$;
}
function $p_Ljava_math_Multiplication$__initialiseArrays__V($thiz) {
  var elem_$_lo = 0;
  var elem_$_hi = 0;
  elem_$_lo = 1;
  elem_$_hi = 0;
  var i = 0;
  while ((i < 32)) {
    var value = i;
    if ((value <= 18)) {
      $m_Ljava_math_Multiplication$().B0.a[value] = $m_Ljava_math_BigInteger$().oI(elem_$_lo, elem_$_hi);
      var $x_2 = $m_Ljava_math_Multiplication$().B1;
      var $x_1 = $m_Ljava_math_BigInteger$();
      var x_$_lo = elem_$_lo;
      var x_$_hi = elem_$_hi;
      var lo = (((32 & value) === 0) ? (x_$_lo << value) : 0);
      var hi = (((32 & value) === 0) ? (((((x_$_lo >>> 1) | 0) >>> (~value)) | 0) | (x_$_hi << value)) : (x_$_lo << value));
      $x_2.a[value] = $x_1.oI(lo, hi);
      var x$1_$_lo = elem_$_lo;
      var x$1_$_hi = elem_$_hi;
      var b0 = (65535 & x$1_$_lo);
      var b1 = ((x$1_$_lo >>> 16) | 0);
      var a0b0 = Math.imul(5, b0);
      var a0b1 = Math.imul(5, b1);
      var lo$1 = ((a0b0 + (a0b1 << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$1 = ((Math.imul(5, x$1_$_hi) + ((c1part >>> 16) | 0)) | 0);
      elem_$_lo = lo$1;
      elem_$_hi = hi$1;
    } else {
      $m_Ljava_math_Multiplication$().B0.a[value] = $m_Ljava_math_Multiplication$().B0.a[((value - 1) | 0)].mR($m_Ljava_math_Multiplication$().B0.a[1]);
      $m_Ljava_math_Multiplication$().B1.a[value] = $m_Ljava_math_Multiplication$().B1.a[((value - 1) | 0)].mR($m_Ljava_math_BigInteger$().yC);
    }
    i = ((1 + i) | 0);
  }
}
function $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I($thiz, res, a, aSize, factor) {
  var elem = 0;
  elem = 0;
  var i = 0;
  while ((i < aSize)) {
    var value = i;
    $m_Ljava_math_Multiplication$();
    var a$1 = a.a[value];
    var c = elem;
    var a0 = (65535 & a$1);
    var a1 = ((a$1 >>> 16) | 0);
    var b0 = (65535 & factor);
    var b1 = ((factor >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var lo$1 = ((lo + c) | 0);
    var hi$4 = ((hi$2 + (((lo$1 >>> 0) < (lo >>> 0)) | 0)) | 0);
    res.a[value] = lo$1;
    elem = hi$4;
    i = ((1 + i) | 0);
  }
  return elem;
}
function $p_Ljava_math_Multiplication$__multPAP__AI__AI__AI__I__I__V($thiz, a, b, t, aLen, bLen) {
  if (((a === b) && (aLen === bLen))) {
    $thiz.aSl(a, aLen, t);
  } else {
    var i = 0;
    while ((i < aLen)) {
      var value = i;
      var elem = 0;
      elem = 0;
      var aI = a.a[value];
      var i$1 = 0;
      while ((i$1 < bLen)) {
        var value$1 = i$1;
        $m_Ljava_math_Multiplication$();
        var b$1 = b.a[value$1];
        var c = t.a[((value + value$1) | 0)];
        var d = elem;
        var a0 = (65535 & aI);
        var a1 = ((aI >>> 16) | 0);
        var b0 = (65535 & b$1);
        var b1 = ((b$1 >>> 16) | 0);
        var a0b0 = Math.imul(a0, b0);
        var a1b0 = Math.imul(a1, b0);
        var a0b1 = Math.imul(a0, b1);
        var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
        var lo$1 = ((lo + c) | 0);
        var hi$4 = ((hi$2 + (((lo$1 >>> 0) < (lo >>> 0)) | 0)) | 0);
        var lo$2 = ((lo$1 + d) | 0);
        var hi$6 = ((hi$4 + (((lo$2 >>> 0) < (lo$1 >>> 0)) | 0)) | 0);
        t.a[((value + value$1) | 0)] = lo$2;
        elem = hi$6;
        i$1 = ((1 + i$1) | 0);
      }
      t.a[((value + bLen) | 0)] = elem;
      i = ((1 + i) | 0);
    }
  }
}
function $p_Ljava_math_Multiplication$__newArrayOfPows__I__I__AI($thiz, len, pow) {
  var result = new $ac_I(len);
  result.a[0] = 1;
  var i = 1;
  while ((i < len)) {
    var value = i;
    result.a[value] = Math.imul(result.a[((value - 1) | 0)], pow);
    i = ((1 + i) | 0);
  }
  return result;
}
/** @constructor */
function $c_Ljava_math_Multiplication$() {
  this.a7h = null;
  this.B1 = null;
  this.B0 = null;
  $n_Ljava_math_Multiplication$ = this;
  this.a7h = $p_Ljava_math_Multiplication$__newArrayOfPows__I__I__AI(this, 10, 10);
  $p_Ljava_math_Multiplication$__newArrayOfPows__I__I__AI(this, 14, 5);
  this.B1 = new ($d_Ljava_math_BigInteger.r().C)(32);
  this.B0 = new ($d_Ljava_math_BigInteger.r().C)(32);
  $p_Ljava_math_Multiplication$__initialiseArrays__V(this);
}
$p = $c_Ljava_math_Multiplication$.prototype = new $h_O();
$p.constructor = $c_Ljava_math_Multiplication$;
/** @constructor */
function $h_Ljava_math_Multiplication$() {
}
$h_Ljava_math_Multiplication$.prototype = $p;
$p.b4E = (function(bi, factor) {
  var resSign = bi.bS;
  var aNumberLength = bi.cp;
  var aDigits = bi.bC;
  if ((resSign === 0)) {
    return $m_Ljava_math_BigInteger$().ws;
  } else if ((aNumberLength === 1)) {
    var a = aDigits.a[0];
    var a0 = (65535 & a);
    var a1 = ((a >>> 16) | 0);
    var b0 = (65535 & factor);
    var b1 = ((factor >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    return ((hi$2 === 0) ? $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), resSign, lo) : $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, 2, new $ac_I(new Int32Array([lo, hi$2]))));
  } else {
    var resLength = ((1 + aNumberLength) | 0);
    var resDigits = new $ac_I(resLength);
    resDigits.a[aNumberLength] = $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I(this, resDigits, aDigits, aNumberLength, factor);
    var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, resLength, resDigits);
    result.pq();
    return result;
  }
});
$p.b4F = (function(bi, exp_$_lo, exp_$_hi) {
  var value = this.a7h.a.length;
  var hi = (value >> 31);
  if (((exp_$_hi === hi) ? ((exp_$_lo >>> 0) < (value >>> 0)) : (exp_$_hi < hi))) {
    return this.b4E(bi, this.a7h.a[exp_$_lo]);
  } else {
    return bi.mR(this.yi(exp_$_lo, exp_$_hi));
  }
});
$p.aSl = (function(a, aLen, res) {
  var elem = 0;
  elem = 0;
  var i = 0;
  while ((i < aLen)) {
    var value = i;
    elem = 0;
    var _\uff3fself = ((1 + value) | 0);
    var i$1 = _\uff3fself;
    while ((i$1 < aLen)) {
      var value$1 = i$1;
      $m_Ljava_math_Multiplication$();
      var a$1 = a.a[value];
      var b = a.a[value$1];
      var c = res.a[((value + value$1) | 0)];
      var d = elem;
      var a0 = (65535 & a$1);
      var a1 = ((a$1 >>> 16) | 0);
      var b0 = (65535 & b);
      var b1 = ((b >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      var lo$1 = ((lo + c) | 0);
      var hi$4 = ((hi$2 + (((lo$1 >>> 0) < (lo >>> 0)) | 0)) | 0);
      var lo$2 = ((lo$1 + d) | 0);
      var hi$6 = ((hi$4 + (((lo$2 >>> 0) < (lo$1 >>> 0)) | 0)) | 0);
      res.a[((value + value$1) | 0)] = lo$2;
      elem = hi$6;
      i$1 = ((1 + i$1) | 0);
    }
    res.a[((value + aLen) | 0)] = elem;
    i = ((1 + i) | 0);
  }
  $m_Ljava_math_BitLevel$().aSa(res, res, (aLen << 1));
  elem = 0;
  var i$2 = 0;
  var index = 0;
  while ((i$2 < aLen)) {
    var a$2 = a.a[i$2];
    var b$1 = a.a[i$2];
    var c$1 = res.a[index];
    var d$1 = elem;
    var a0$1 = (65535 & a$2);
    var a1$1 = ((a$2 >>> 16) | 0);
    var b0$1 = (65535 & b$1);
    var b1$1 = ((b$1 >>> 16) | 0);
    var a0b0$1 = Math.imul(a0$1, b0$1);
    var a1b0$1 = Math.imul(a1$1, b0$1);
    var a0b1$1 = Math.imul(a0$1, b1$1);
    var lo$3 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
    var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
    var hi$9 = ((((Math.imul(a1$1, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
    var lo$4 = ((lo$3 + c$1) | 0);
    var hi$11 = ((hi$9 + (((lo$4 >>> 0) < (lo$3 >>> 0)) | 0)) | 0);
    var lo$5 = ((lo$4 + d$1) | 0);
    var hi$13 = ((hi$11 + (((lo$5 >>> 0) < (lo$4 >>> 0)) | 0)) | 0);
    res.a[index] = lo$5;
    index = ((1 + index) | 0);
    var value$2 = res.a[index];
    var lo$6 = ((hi$13 + value$2) | 0);
    var hi$15 = (((lo$6 >>> 0) < (hi$13 >>> 0)) | 0);
    res.a[index] = lo$6;
    elem = hi$15;
    i$2 = ((1 + i$2) | 0);
    index = ((1 + index) | 0);
  }
  return res;
});
$p.a40 = (function(val1, val2) {
  if ((val2.cp > val1.cp)) {
    var x1___1 = val2;
    var x1___2 = val1;
  } else {
    var x1___1 = val1;
    var x1___2 = val2;
  }
  var op1 = x1___1;
  var op2 = x1___2;
  if ((op2.cp < 63)) {
    return this.b4G(op1, op2);
  } else {
    var ndiv2 = (((-2) & op1.cp) << 4);
    var upperOp1 = op1.a4I(ndiv2);
    var upperOp2 = op2.a4I(ndiv2);
    var lowerOp1 = $m_Ljava_math_Elementary$().a4Q(op1, upperOp1.uh(ndiv2));
    var lowerOp2 = $m_Ljava_math_Elementary$().a4Q(op2, upperOp2.uh(ndiv2));
    var upper = this.a40(upperOp1, upperOp2);
    var lower = this.a40(lowerOp1, lowerOp2);
    var middle = this.a40($m_Ljava_math_Elementary$().a4Q(upperOp1, lowerOp1), $m_Ljava_math_Elementary$().a4Q(lowerOp2, upperOp2));
    middle = $m_Ljava_math_Elementary$().OT($m_Ljava_math_Elementary$().OT(middle, upper), lower);
    middle = middle.uh(ndiv2);
    upper = upper.uh((ndiv2 << 1));
    return $m_Ljava_math_Elementary$().OT($m_Ljava_math_Elementary$().OT(upper, middle), lower);
  }
});
$p.b4C = (function(aDigits, aLen, bDigits, bLen, resDigits) {
  if ((!((aLen === 0) || (bLen === 0)))) {
    if ((aLen === 1)) {
      resDigits.a[bLen] = $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I(this, resDigits, bDigits, bLen, aDigits.a[0]);
    } else if ((bLen === 1)) {
      resDigits.a[aLen] = $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I(this, resDigits, aDigits, aLen, bDigits.a[0]);
    } else {
      $p_Ljava_math_Multiplication$__multPAP__AI__AI__AI__I__I__V(this, aDigits, bDigits, resDigits, aLen, bLen);
    }
  }
});
$p.b4G = (function(a, b) {
  var aLen = a.cp;
  var bLen = b.cp;
  var resLength = ((aLen + bLen) | 0);
  var resSign = ((a.bS !== b.bS) ? (-1) : 1);
  if ((resLength === 2)) {
    var a$1 = a.bC.a[0];
    var b$1 = b.bC.a[0];
    var a0 = (65535 & a$1);
    var a1 = ((a$1 >>> 16) | 0);
    var b0 = (65535 & b$1);
    var b1 = ((b$1 >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    return ((hi$2 === 0) ? $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), resSign, lo) : $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, 2, new $ac_I(new Int32Array([lo, hi$2]))));
  } else {
    var aDigits = a.bC;
    var bDigits = b.bC;
    var resDigits = new $ac_I(resLength);
    this.b4C(aDigits, aLen, bDigits, bLen, resDigits);
    var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, resLength, resDigits);
    result.pq();
    return result;
  }
});
$p.b6L = (function(base, exponent) {
  var exp = exponent;
  var res = $m_Ljava_math_BigInteger$().Ka;
  var acc = base;
  while ((exp > 1)) {
    var res2 = (((1 & exp) !== 0) ? res.mR(acc) : res);
    if ((acc.cp === 1)) {
      var acc2 = acc.mR(acc);
    } else {
      var a = new $ac_I((acc.cp << 1));
      var acc2 = $ct_Ljava_math_BigInteger__I__AI__(new $c_Ljava_math_BigInteger(), 1, this.aSl(acc.bC, acc.cp, a));
    }
    var temp$exp = (exp >> 1);
    exp = temp$exp;
    res = res2;
    acc = acc2;
  }
  return res.mR(acc);
});
$p.yi = (function(exp_$_lo, exp_$_hi) {
  var value = this.B1.a.length;
  var hi = (value >> 31);
  if (((exp_$_hi === hi) ? ((exp_$_lo >>> 0) < (value >>> 0)) : (exp_$_hi < hi))) {
    return this.B1.a[exp_$_lo];
  } else if (((exp_$_hi === 0) ? ((exp_$_lo >>> 0) <= 50) : (exp_$_hi < 0))) {
    return $m_Ljava_math_BigInteger$().yC.AA(exp_$_lo);
  } else if (((exp_$_hi === 0) ? ((exp_$_lo >>> 0) <= 2147483647) : (exp_$_hi < 0))) {
    return this.B0.a[1].AA(exp_$_lo).uh(exp_$_lo);
  } else {
    var powerOfFive = this.B0.a[1].AA(2147483647);
    var res = powerOfFive;
    var lo = ((exp_$_lo - 2147483647) | 0);
    var hi$1 = ((((exp_$_hi - 1) | 0) + (((lo >>> 0) < 2147483649) | 0)) | 0);
    var longExp_$_lo = lo;
    var longExp_$_hi = hi$1;
    var sign = (exp_$_hi >> 31);
    var xlo = (exp_$_lo ^ sign);
    var rlo = ((xlo - sign) | 0);
    var rhi = (((exp_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
    var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
    var x = (4.656612875245805E-10 * aHat);
    var lo$1 = (x | 0.0);
    ((2.3283064365386963E-10 * x) | 0.0);
    var rHat = ((rlo - Math.imul(2147483647, lo$1)) | 0);
    if ((rHat < 0)) {
      var lo$2 = ((2147483647 + rHat) | 0);
      var absR_$_lo = lo$2;
      var absR_$_hi = 0;
    } else {
      var absR_$_lo = rHat;
      var absR_$_hi = 0;
    }
    if ((exp_$_hi < 0)) {
      var lo$3 = ((-absR_$_lo) | 0);
      var hi$3 = ((((-absR_$_hi) | 0) - ((lo$3 !== 0) | 0)) | 0);
      var x$2_$_lo = lo$3;
      var x$2_$_hi = hi$3;
    } else {
      var x$2_$_lo = absR_$_lo;
      var x$2_$_hi = absR_$_hi;
    }
    while (true) {
      var x$3_$_lo = longExp_$_lo;
      var x$3_$_hi = longExp_$_hi;
      if (((x$3_$_hi === 0) ? ((x$3_$_lo >>> 0) > 2147483647) : (x$3_$_hi > 0))) {
        res = res.mR(powerOfFive);
        var x$4_$_lo = longExp_$_lo;
        var x$4_$_hi = longExp_$_hi;
        var lo$4 = ((x$4_$_lo - 2147483647) | 0);
        var hi$4 = ((((x$4_$_hi - 1) | 0) + (((lo$4 >>> 0) < 2147483649) | 0)) | 0);
        longExp_$_lo = lo$4;
        longExp_$_hi = hi$4;
      } else {
        break;
      }
    }
    res = res.mR(this.B0.a[1].AA(x$2_$_lo));
    res = res.uh(2147483647);
    var lo$5 = ((exp_$_lo - 2147483647) | 0);
    var hi$5 = ((((exp_$_hi - 1) | 0) + (((lo$5 >>> 0) < 2147483649) | 0)) | 0);
    longExp_$_lo = lo$5;
    longExp_$_hi = hi$5;
    while (true) {
      var x$5_$_lo = longExp_$_lo;
      var x$5_$_hi = longExp_$_hi;
      if (((x$5_$_hi === 0) ? ((x$5_$_lo >>> 0) > 2147483647) : (x$5_$_hi > 0))) {
        res = res.uh(2147483647);
        var x$6_$_lo = longExp_$_lo;
        var x$6_$_hi = longExp_$_hi;
        var lo$6 = ((x$6_$_lo - 2147483647) | 0);
        var hi$6 = ((((x$6_$_hi - 1) | 0) + (((lo$6 >>> 0) < 2147483649) | 0)) | 0);
        longExp_$_lo = lo$6;
        longExp_$_hi = hi$6;
      } else {
        break;
      }
    }
    return res.uh(x$2_$_lo);
  }
});
var $d_Ljava_math_Multiplication$ = new $TypeData().i($c_Ljava_math_Multiplication$, "java.math.Multiplication$", ({
  sx: 1
}));
var $n_Ljava_math_Multiplication$;
function $m_Ljava_math_Multiplication$() {
  if ((!$n_Ljava_math_Multiplication$)) {
    $n_Ljava_math_Multiplication$ = new $c_Ljava_math_Multiplication$();
  }
  return $n_Ljava_math_Multiplication$;
}
function $ct_Ljava_nio_Buffer__I__($thiz, _capacity) {
  $thiz.nK = _capacity;
  $thiz.c2 = $thiz.nK;
  $thiz.b3 = 0;
  $thiz.ur = (-1);
  return $thiz;
}
/** @constructor */
function $c_Ljava_nio_Buffer() {
  this.nK = 0;
  this.c2 = 0;
  this.b3 = 0;
  this.ur = 0;
}
$p = $c_Ljava_nio_Buffer.prototype = new $h_O();
$p.constructor = $c_Ljava_nio_Buffer;
/** @constructor */
function $h_Ljava_nio_Buffer() {
}
$h_Ljava_nio_Buffer.prototype = $p;
$p.cX = (function(newPosition) {
  if (((newPosition >>> 0) > (this.c2 >>> 0))) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  }
  this.b3 = newPosition;
  if ((this.ur > newPosition)) {
    this.ur = (-1);
  }
  return this;
});
$p.agT = (function(newLimit) {
  if (((newLimit >>> 0) > (this.nK >>> 0))) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  }
  this.c2 = newLimit;
  if ((this.b3 > newLimit)) {
    this.b3 = newLimit;
    if ((this.ur > newLimit)) {
      this.ur = (-1);
    }
  }
  return this;
});
$p.a3p = (function() {
  this.ur = (-1);
  this.c2 = this.b3;
  this.b3 = 0;
  return this;
});
$p.m = (function() {
  return ((((((($objectClassName(this) + "[pos=") + this.b3) + " lim=") + this.c2) + " cap=") + this.nK) + "]");
});
/** @constructor */
function $c_Ljava_nio_ByteBuffer$() {
}
$p = $c_Ljava_nio_ByteBuffer$.prototype = new $h_O();
$p.constructor = $c_Ljava_nio_ByteBuffer$;
/** @constructor */
function $h_Ljava_nio_ByteBuffer$() {
}
$h_Ljava_nio_ByteBuffer$.prototype = $p;
$p.a2H = (function(capacity) {
  if ((capacity < 0)) {
    $m_jl_BoundsChecks$().agF(capacity);
  }
  var array = new $ac_B(capacity);
  return $m_Ljava_nio_HeapByteBuffer$().aiD(array, 0, array.a.length, 0, array.a.length, false);
});
var $d_Ljava_nio_ByteBuffer$ = new $TypeData().i($c_Ljava_nio_ByteBuffer$, "java.nio.ByteBuffer$", ({
  sA: 1
}));
var $n_Ljava_nio_ByteBuffer$;
function $m_Ljava_nio_ByteBuffer$() {
  if ((!$n_Ljava_nio_ByteBuffer$)) {
    $n_Ljava_nio_ByteBuffer$ = new $c_Ljava_nio_ByteBuffer$();
  }
  return $n_Ljava_nio_ByteBuffer$;
}
/** @constructor */
function $c_Ljava_nio_CharBuffer$() {
}
$p = $c_Ljava_nio_CharBuffer$.prototype = new $h_O();
$p.constructor = $c_Ljava_nio_CharBuffer$;
/** @constructor */
function $h_Ljava_nio_CharBuffer$() {
}
$h_Ljava_nio_CharBuffer$.prototype = $p;
$p.aeG = (function(capacity) {
  if ((capacity < 0)) {
    $m_jl_BoundsChecks$().agF(capacity);
  }
  var array = new $ac_C(capacity);
  var length = array.a.length;
  var capacity$1 = array.a.length;
  var length$1 = array.a.length;
  if ((((capacity$1 | capacity$1) | ((length$1 - capacity$1) | 0)) < 0)) {
    $m_jl_BoundsChecks$().r5(0, capacity$1, length$1);
  }
  if ((((length | length) | ((capacity$1 - length) | 0)) < 0)) {
    $m_jl_BoundsChecks$().r5(0, length, capacity$1);
  }
  return new $c_Ljava_nio_HeapCharBuffer(capacity$1, array, 0, 0, length, false);
});
$p.aTv = (function(csq, start, end) {
  return $m_Ljava_nio_StringCharBuffer$().bc0(csq, 0, $dp_length__I(csq), start, ((end - start) | 0));
});
var $d_Ljava_nio_CharBuffer$ = new $TypeData().i($c_Ljava_nio_CharBuffer$, "java.nio.CharBuffer$", ({
  sB: 1
}));
var $n_Ljava_nio_CharBuffer$;
function $m_Ljava_nio_CharBuffer$() {
  if ((!$n_Ljava_nio_CharBuffer$)) {
    $n_Ljava_nio_CharBuffer$ = new $c_Ljava_nio_CharBuffer$();
  }
  return $n_Ljava_nio_CharBuffer$;
}
/** @constructor */
function $c_Ljava_nio_HeapByteBuffer$() {
}
$p = $c_Ljava_nio_HeapByteBuffer$.prototype = new $h_O();
$p.constructor = $c_Ljava_nio_HeapByteBuffer$;
/** @constructor */
function $h_Ljava_nio_HeapByteBuffer$() {
}
$h_Ljava_nio_HeapByteBuffer$.prototype = $p;
$p.aiD = (function(array, arrayOffset, capacity, initialPosition, initialLength, isReadOnly) {
  var length = array.a.length;
  var endOffset = ((arrayOffset + capacity) | 0);
  if (((((arrayOffset | capacity) | endOffset) | ((length - endOffset) | 0)) < 0)) {
    $m_jl_BoundsChecks$().r5(arrayOffset, capacity, length);
  }
  var endOffset$1 = ((initialPosition + initialLength) | 0);
  if (((((initialPosition | initialLength) | endOffset$1) | ((capacity - endOffset$1) | 0)) < 0)) {
    $m_jl_BoundsChecks$().r5(initialPosition, initialLength, capacity);
  }
  return new $c_Ljava_nio_HeapByteBuffer(capacity, array, arrayOffset, initialPosition, endOffset$1, isReadOnly, false);
});
var $d_Ljava_nio_HeapByteBuffer$ = new $TypeData().i($c_Ljava_nio_HeapByteBuffer$, "java.nio.HeapByteBuffer$", ({
  sD: 1
}));
var $n_Ljava_nio_HeapByteBuffer$;
function $m_Ljava_nio_HeapByteBuffer$() {
  if ((!$n_Ljava_nio_HeapByteBuffer$)) {
    $n_Ljava_nio_HeapByteBuffer$ = new $c_Ljava_nio_HeapByteBuffer$();
  }
  return $n_Ljava_nio_HeapByteBuffer$;
}
/** @constructor */
function $c_Ljava_nio_StringCharBuffer$() {
}
$p = $c_Ljava_nio_StringCharBuffer$.prototype = new $h_O();
$p.constructor = $c_Ljava_nio_StringCharBuffer$;
/** @constructor */
function $h_Ljava_nio_StringCharBuffer$() {
}
$h_Ljava_nio_StringCharBuffer$.prototype = $p;
$p.bc0 = (function(csq, csqOffset, capacity, initialPosition, initialLength) {
  var length = $dp_length__I(csq);
  var endOffset = ((csqOffset + capacity) | 0);
  if (((((csqOffset | capacity) | endOffset) | ((length - endOffset) | 0)) < 0)) {
    $m_jl_BoundsChecks$().r5(csqOffset, capacity, length);
  }
  var endOffset$1 = ((initialPosition + initialLength) | 0);
  if (((((initialPosition | initialLength) | endOffset$1) | ((capacity - endOffset$1) | 0)) < 0)) {
    $m_jl_BoundsChecks$().r5(initialPosition, initialLength, capacity);
  }
  return new $c_Ljava_nio_StringCharBuffer(capacity, csq, csqOffset, initialPosition, endOffset$1);
});
var $d_Ljava_nio_StringCharBuffer$ = new $TypeData().i($c_Ljava_nio_StringCharBuffer$, "java.nio.StringCharBuffer$", ({
  sH: 1
}));
var $n_Ljava_nio_StringCharBuffer$;
function $m_Ljava_nio_StringCharBuffer$() {
  if ((!$n_Ljava_nio_StringCharBuffer$)) {
    $n_Ljava_nio_StringCharBuffer$ = new $c_Ljava_nio_StringCharBuffer$();
  }
  return $n_Ljava_nio_StringCharBuffer$;
}
function $ps_Ljava_nio_charset_CharsetDecoder__grow$1__Ljava_nio_CharBuffer__Ljava_nio_CharBuffer(out) {
  if ((out.nK === 0)) {
    return $m_Ljava_nio_CharBuffer$().aeG(1);
  } else {
    var result = $m_Ljava_nio_CharBuffer$().aeG((out.nK << 1));
    $c_Ljava_nio_Buffer.prototype.a3p.call(out);
    result.aRh(out);
    return result;
  }
}
function $ct_Ljava_nio_charset_CharsetDecoder__Ljava_nio_charset_Charset__F__F__($thiz, cs, _averageCharsPerByte, _maxCharsPerByte) {
  $thiz.a7i = _averageCharsPerByte;
  $thiz.Zn = "\ufffd";
  $thiz.Zm = $m_Ljava_nio_charset_CodingErrorAction$().ER;
  $thiz.Zo = $m_Ljava_nio_charset_CodingErrorAction$().ER;
  $thiz.B4 = 1;
  return $thiz;
}
/** @constructor */
function $c_Ljava_nio_charset_CharsetDecoder() {
  this.a7i = 0.0;
  this.Zn = null;
  this.Zm = null;
  this.Zo = null;
  this.B4 = 0;
}
$p = $c_Ljava_nio_charset_CharsetDecoder.prototype = new $h_O();
$p.constructor = $c_Ljava_nio_charset_CharsetDecoder;
/** @constructor */
function $h_Ljava_nio_charset_CharsetDecoder() {
}
$h_Ljava_nio_charset_CharsetDecoder.prototype = $p;
$p.b5d = (function(newAction) {
  if ((newAction === null)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "null CodingErrorAction");
  }
  this.Zm = newAction;
  return this;
});
$p.b5g = (function(newAction) {
  if ((newAction === null)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "null CodingErrorAction");
  }
  this.Zo = newAction;
  return this;
});
$p.aZE = (function(in$1, out, endOfInput) {
  if (((this.B4 === 4) || ((!endOfInput) && (this.B4 === 3)))) {
    throw $ct_jl_IllegalStateException__(new $c_jl_IllegalStateException());
  }
  this.B4 = (endOfInput ? 3 : 2);
  while (true) {
    try {
      var result1 = this.aZG(in$1, out);
    } catch (e) {
      var result1;
      if ((e instanceof $c_Ljava_nio_BufferOverflowException)) {
        throw new $c_Ljava_nio_charset_CoderMalfunctionError(e);
      } else if ((e instanceof $c_Ljava_nio_BufferUnderflowException)) {
        throw new $c_Ljava_nio_charset_CoderMalfunctionError(e);
      } else {
        throw e;
      }
    }
    if ((result1.kA === 0)) {
      var remaining = ((in$1.c2 - in$1.b3) | 0);
      if ((endOfInput && (remaining > 0))) {
        var this$1 = $m_Ljava_nio_charset_CoderResult$();
        switch (remaining) {
          case 1: {
            var result2 = this$1.mc;
            break;
          }
          case 2: {
            var result2 = this$1.R1;
            break;
          }
          case 3: {
            var result2 = this$1.EP;
            break;
          }
          case 4: {
            var result2 = this$1.a7k;
            break;
          }
          default: {
            var result2 = this$1.aPy(remaining);
          }
        }
      } else {
        var result2 = result1;
      }
    } else {
      var result2 = result1;
    }
    if (((result2.kA === 0) || (result2.kA === 1))) {
      return result2;
    } else {
      var action = ((result2.kA === 3) ? this.Zo : this.Zm);
      var x = $m_Ljava_nio_charset_CodingErrorAction$().EQ;
      if (((x === null) ? (action === null) : (x === action))) {
        if ((((out.c2 - out.b3) | 0) < this.Zn.length)) {
          return $m_Ljava_nio_charset_CoderResult$().ma;
        } else {
          var src = this.Zn;
          out.aRg(src, 0, src.length);
          var $x_1 = in$1.b3;
          var l = result2.EO;
          if ((l < 0)) {
            throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
          }
          $c_Ljava_nio_Buffer.prototype.cX.call(in$1, (($x_1 + l) | 0));
        }
      } else {
        var x$3 = $m_Ljava_nio_charset_CodingErrorAction$().ER;
        if (((x$3 === null) ? (action === null) : (x$3 === action))) {
          return result2;
        } else {
          var x$5 = $m_Ljava_nio_charset_CodingErrorAction$().a7m;
          if (((x$5 === null) ? (action === null) : (x$5 === action))) {
            var $x_2 = in$1.b3;
            var l$1 = result2.EO;
            if ((l$1 < 0)) {
              throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
            }
            $c_Ljava_nio_Buffer.prototype.cX.call(in$1, (($x_2 + l$1) | 0));
          } else {
            throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), action);
          }
        }
      }
    }
  }
});
$p.b1s = (function(out) {
  switch (this.B4) {
    case 3: {
      var result = $m_Ljava_nio_charset_CoderResult$().mb;
      if ((result.kA === 0)) {
        this.B4 = 4;
      }
      return result;
      break;
    }
    case 4: {
      return $m_Ljava_nio_charset_CoderResult$().mb;
      break;
    }
    default: {
      throw $ct_jl_IllegalStateException__(new $c_jl_IllegalStateException());
    }
  }
});
$p.b7H = (function() {
  this.B4 = 1;
  return this;
});
$p.aNl = (function(in$1) {
  this.b7H();
  var initLength = $doubleToInt((((in$1.c2 - in$1.b3) | 0) * this.a7i));
  var out = $m_Ljava_nio_CharBuffer$().aeG(initLength);
  var out$1;
  while (true) {
    var result = this.aZE(in$1, out, true);
    if ((result.kA !== 0)) {
      if ((result.kA === 1)) {
        out = $ps_Ljava_nio_charset_CharsetDecoder__grow$1__Ljava_nio_CharBuffer__Ljava_nio_CharBuffer(out);
        continue;
      }
      result.a4Y();
      throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "should not get here");
    }
    if ((in$1.b3 !== in$1.c2)) {
      throw $ct_jl_AssertionError__(new $c_jl_AssertionError());
    }
    var out$1 = out;
    break;
  }
  var out$2;
  while (true) {
    var result$1 = this.b1s(out$1);
    if ((result$1.kA !== 0)) {
      if ((result$1.kA === 1)) {
        out$1 = $ps_Ljava_nio_charset_CharsetDecoder__grow$1__Ljava_nio_CharBuffer__Ljava_nio_CharBuffer(out$1);
        continue;
      }
      result$1.a4Y();
      throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "should not get here");
    }
    var out$2 = out$1;
    break;
  }
  $c_Ljava_nio_Buffer.prototype.a3p.call(out$2);
  return out$2;
});
function $ps_Ljava_nio_charset_CharsetEncoder__grow$1__Ljava_nio_ByteBuffer__Ljava_nio_ByteBuffer(out) {
  if ((out.nK === 0)) {
    return $m_Ljava_nio_ByteBuffer$().a2H(1);
  } else {
    var result = $m_Ljava_nio_ByteBuffer$().a2H((out.nK << 1));
    $c_Ljava_nio_Buffer.prototype.a3p.call(out);
    result.b71(out);
    return result;
  }
}
function $ct_Ljava_nio_charset_CharsetEncoder__Ljava_nio_charset_Charset__F__F__AB__($thiz, cs, _averageBytesPerChar, _maxBytesPerChar, _replacement) {
  $thiz.a7j = _averageBytesPerChar;
  $thiz.Zq = _replacement;
  $thiz.Zp = $m_Ljava_nio_charset_CodingErrorAction$().ER;
  $thiz.Zr = $m_Ljava_nio_charset_CodingErrorAction$().ER;
  $thiz.B5 = 0;
  return $thiz;
}
function $ct_Ljava_nio_charset_CharsetEncoder__Ljava_nio_charset_Charset__F__F__($thiz, cs, _averageBytesPerChar, _maxBytesPerChar) {
  $ct_Ljava_nio_charset_CharsetEncoder__Ljava_nio_charset_Charset__F__F__AB__($thiz, cs, _averageBytesPerChar, _maxBytesPerChar, new $ac_B(new Int8Array([63])));
  return $thiz;
}
/** @constructor */
function $c_Ljava_nio_charset_CharsetEncoder() {
  this.a7j = 0.0;
  this.Zq = null;
  this.Zp = null;
  this.Zr = null;
  this.B5 = 0;
}
$p = $c_Ljava_nio_charset_CharsetEncoder.prototype = new $h_O();
$p.constructor = $c_Ljava_nio_charset_CharsetEncoder;
/** @constructor */
function $h_Ljava_nio_charset_CharsetEncoder() {
}
$h_Ljava_nio_charset_CharsetEncoder.prototype = $p;
$p.b5e = (function(newAction) {
  if ((newAction === null)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "null CodingErrorAction");
  }
  this.Zp = newAction;
  return this;
});
$p.b5h = (function(newAction) {
  if ((newAction === null)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "null CodingErrorAction");
  }
  this.Zr = newAction;
  return this;
});
$p.b0A = (function(in$1, out, endOfInput) {
  if (((this.B5 === 3) || ((!endOfInput) && (this.B5 === 2)))) {
    throw $ct_jl_IllegalStateException__(new $c_jl_IllegalStateException());
  }
  this.B5 = (endOfInput ? 2 : 1);
  while (true) {
    try {
      var result1 = this.b0C(in$1, out);
    } catch (e) {
      var result1;
      if ((e instanceof $c_Ljava_nio_BufferOverflowException)) {
        throw new $c_Ljava_nio_charset_CoderMalfunctionError(e);
      } else if ((e instanceof $c_Ljava_nio_BufferUnderflowException)) {
        throw new $c_Ljava_nio_charset_CoderMalfunctionError(e);
      } else {
        throw e;
      }
    }
    if ((result1.kA === 0)) {
      var remaining = ((in$1.c2 - in$1.b3) | 0);
      if ((endOfInput && (remaining > 0))) {
        var this$1 = $m_Ljava_nio_charset_CoderResult$();
        switch (remaining) {
          case 1: {
            var result2 = this$1.mc;
            break;
          }
          case 2: {
            var result2 = this$1.R1;
            break;
          }
          case 3: {
            var result2 = this$1.EP;
            break;
          }
          case 4: {
            var result2 = this$1.a7k;
            break;
          }
          default: {
            var result2 = this$1.aPy(remaining);
          }
        }
      } else {
        var result2 = result1;
      }
    } else {
      var result2 = result1;
    }
    if (((result2.kA === 0) || (result2.kA === 1))) {
      return result2;
    } else {
      var action = ((result2.kA === 3) ? this.Zr : this.Zp);
      var x = $m_Ljava_nio_charset_CodingErrorAction$().EQ;
      if (((x === null) ? (action === null) : (x === action))) {
        if ((((out.c2 - out.b3) | 0) < this.Zq.a.length)) {
          return $m_Ljava_nio_charset_CoderResult$().ma;
        } else {
          var src = this.Zq;
          out.b74(src, 0, src.a.length);
          var $x_1 = in$1.b3;
          var l = result2.EO;
          if ((l < 0)) {
            throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
          }
          $c_Ljava_nio_Buffer.prototype.cX.call(in$1, (($x_1 + l) | 0));
        }
      } else {
        var x$3 = $m_Ljava_nio_charset_CodingErrorAction$().ER;
        if (((x$3 === null) ? (action === null) : (x$3 === action))) {
          return result2;
        } else {
          var x$5 = $m_Ljava_nio_charset_CodingErrorAction$().a7m;
          if (((x$5 === null) ? (action === null) : (x$5 === action))) {
            var $x_2 = in$1.b3;
            var l$1 = result2.EO;
            if ((l$1 < 0)) {
              throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
            }
            $c_Ljava_nio_Buffer.prototype.cX.call(in$1, (($x_2 + l$1) | 0));
          } else {
            throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), action);
          }
        }
      }
    }
  }
});
$p.b1r = (function(out) {
  switch (this.B5) {
    case 2: {
      var result = $m_Ljava_nio_charset_CoderResult$().mb;
      if ((result.kA === 0)) {
        this.B5 = 3;
      }
      return result;
      break;
    }
    case 3: {
      return $m_Ljava_nio_charset_CoderResult$().mb;
      break;
    }
    default: {
      throw $ct_jl_IllegalStateException__(new $c_jl_IllegalStateException());
    }
  }
});
$p.b7I = (function() {
  this.B5 = 0;
  return this;
});
$p.b0B = (function(in$1) {
  if ((((in$1.c2 - in$1.b3) | 0) === 0)) {
    return $m_Ljava_nio_ByteBuffer$().a2H(0);
  } else {
    this.b7I();
    var initLength = $doubleToInt(Math.fround((Math.fround(((in$1.c2 - in$1.b3) | 0)) * this.a7j)));
    var out = $m_Ljava_nio_ByteBuffer$().a2H(initLength);
    var out$1;
    while (true) {
      var result = this.b0A(in$1, out, true);
      if ((result.kA !== 0)) {
        if ((result.kA === 1)) {
          out = $ps_Ljava_nio_charset_CharsetEncoder__grow$1__Ljava_nio_ByteBuffer__Ljava_nio_ByteBuffer(out);
          continue;
        }
        result.a4Y();
        throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "should not get here");
      }
      if ((in$1.b3 !== in$1.c2)) {
        throw $ct_jl_AssertionError__(new $c_jl_AssertionError());
      }
      var out$1 = out;
      break;
    }
    var out$2;
    while (true) {
      var result$1 = this.b1r(out$1);
      if ((result$1.kA !== 0)) {
        if ((result$1.kA === 1)) {
          out$1 = $ps_Ljava_nio_charset_CharsetEncoder__grow$1__Ljava_nio_ByteBuffer__Ljava_nio_ByteBuffer(out$1);
          continue;
        }
        result$1.a4Y();
        throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "should not get here");
      }
      var out$2 = out$1;
      break;
    }
    $c_Ljava_nio_Buffer.prototype.a3p.call(out$2);
    return out$2;
  }
});
/** @constructor */
function $c_Ljava_nio_charset_CoderResult(kind, _length) {
  this.kA = 0;
  this.EO = 0;
  this.kA = kind;
  this.EO = _length;
}
$p = $c_Ljava_nio_charset_CoderResult.prototype = new $h_O();
$p.constructor = $c_Ljava_nio_charset_CoderResult;
/** @constructor */
function $h_Ljava_nio_charset_CoderResult() {
}
$h_Ljava_nio_charset_CoderResult.prototype = $p;
$p.a4Y = (function() {
  var x1 = this.kA;
  switch (x1) {
    case 1: {
      throw new $c_Ljava_nio_BufferOverflowException();
      break;
    }
    case 0: {
      throw new $c_Ljava_nio_BufferUnderflowException();
      break;
    }
    case 2: {
      throw new $c_Ljava_nio_charset_MalformedInputException(this.EO);
      break;
    }
    case 3: {
      throw new $c_Ljava_nio_charset_UnmappableCharacterException(this.EO);
      break;
    }
    default: {
      throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), x1);
    }
  }
});
var $d_Ljava_nio_charset_CoderResult = new $TypeData().i($c_Ljava_nio_charset_CoderResult, "java.nio.charset.CoderResult", ({
  sL: 1
}));
/** @constructor */
function $c_Ljava_nio_charset_CoderResult$() {
  this.ma = null;
  this.mb = null;
  this.mc = null;
  this.R1 = null;
  this.EP = null;
  this.a7k = null;
  this.a7l = null;
  $n_Ljava_nio_charset_CoderResult$ = this;
  this.ma = new $c_Ljava_nio_charset_CoderResult(1, (-1));
  this.mb = new $c_Ljava_nio_charset_CoderResult(0, (-1));
  this.mc = new $c_Ljava_nio_charset_CoderResult(2, 1);
  this.R1 = new $c_Ljava_nio_charset_CoderResult(2, 2);
  this.EP = new $c_Ljava_nio_charset_CoderResult(2, 3);
  this.a7k = new $c_Ljava_nio_charset_CoderResult(2, 4);
  this.a7l = [];
}
$p = $c_Ljava_nio_charset_CoderResult$.prototype = new $h_O();
$p.constructor = $c_Ljava_nio_charset_CoderResult$;
/** @constructor */
function $h_Ljava_nio_charset_CoderResult$() {
}
$h_Ljava_nio_charset_CoderResult$.prototype = $p;
$p.aPy = (function(length) {
  var x = this.a7l[length];
  if ((x !== (void 0))) {
    return x;
  } else {
    var result = new $c_Ljava_nio_charset_CoderResult(2, length);
    $m_Ljava_nio_charset_CoderResult$().a7l[length] = result;
    return result;
  }
});
var $d_Ljava_nio_charset_CoderResult$ = new $TypeData().i($c_Ljava_nio_charset_CoderResult$, "java.nio.charset.CoderResult$", ({
  sM: 1
}));
var $n_Ljava_nio_charset_CoderResult$;
function $m_Ljava_nio_charset_CoderResult$() {
  if ((!$n_Ljava_nio_charset_CoderResult$)) {
    $n_Ljava_nio_charset_CoderResult$ = new $c_Ljava_nio_charset_CoderResult$();
  }
  return $n_Ljava_nio_charset_CoderResult$;
}
/** @constructor */
function $c_Ljava_nio_charset_CodingErrorAction(name) {
  this.atf = null;
  this.atf = name;
}
$p = $c_Ljava_nio_charset_CodingErrorAction.prototype = new $h_O();
$p.constructor = $c_Ljava_nio_charset_CodingErrorAction;
/** @constructor */
function $h_Ljava_nio_charset_CodingErrorAction() {
}
$h_Ljava_nio_charset_CodingErrorAction.prototype = $p;
$p.m = (function() {
  return this.atf;
});
var $d_Ljava_nio_charset_CodingErrorAction = new $TypeData().i($c_Ljava_nio_charset_CodingErrorAction, "java.nio.charset.CodingErrorAction", ({
  sN: 1
}));
/** @constructor */
function $c_Ljava_nio_charset_CodingErrorAction$() {
  this.a7m = null;
  this.EQ = null;
  this.ER = null;
  $n_Ljava_nio_charset_CodingErrorAction$ = this;
  this.a7m = new $c_Ljava_nio_charset_CodingErrorAction("IGNORE");
  this.EQ = new $c_Ljava_nio_charset_CodingErrorAction("REPLACE");
  this.ER = new $c_Ljava_nio_charset_CodingErrorAction("REPORT");
}
$p = $c_Ljava_nio_charset_CodingErrorAction$.prototype = new $h_O();
$p.constructor = $c_Ljava_nio_charset_CodingErrorAction$;
/** @constructor */
function $h_Ljava_nio_charset_CodingErrorAction$() {
}
$h_Ljava_nio_charset_CodingErrorAction$.prototype = $p;
var $d_Ljava_nio_charset_CodingErrorAction$ = new $TypeData().i($c_Ljava_nio_charset_CodingErrorAction$, "java.nio.charset.CodingErrorAction$", ({
  sO: 1
}));
var $n_Ljava_nio_charset_CodingErrorAction$;
function $m_Ljava_nio_charset_CodingErrorAction$() {
  if ((!$n_Ljava_nio_charset_CodingErrorAction$)) {
    $n_Ljava_nio_charset_CodingErrorAction$ = new $c_Ljava_nio_charset_CodingErrorAction$();
  }
  return $n_Ljava_nio_charset_CodingErrorAction$;
}
/** @constructor */
function $c_ju_Arrays$() {
}
$p = $c_ju_Arrays$.prototype = new $h_O();
$p.constructor = $c_ju_Arrays$;
/** @constructor */
function $h_ju_Arrays$() {
}
$h_ju_Arrays$.prototype = $p;
$p.aSh = (function(a) {
  var comparator = $m_ju_internal_GenericArrayOps$IntArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$IntArrayOps$();
  var end = a.a.length;
  if ((end > 16)) {
    this.py(a, new $ac_I(a.a.length), 0, end, comparator, ops);
  } else {
    this.r6(a, 0, end, comparator, ops);
  }
});
$p.b97 = (function(a, fromIndex, toIndex) {
  var comparator = $m_ju_internal_GenericArrayOps$IntArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$IntArrayOps$();
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"));
  }
  if ((((toIndex - fromIndex) | 0) > 16)) {
    this.py(a, new $ac_I(a.a.length), fromIndex, toIndex, comparator, ops);
  } else {
    this.r6(a, fromIndex, toIndex, comparator, ops);
  }
});
$p.aSi = (function(a) {
  var comparator = $m_ju_internal_GenericArrayOps$LongArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$LongArrayOps$();
  var end = ((a.a.length >>> 1) | 0);
  if ((end > 16)) {
    this.py(a, new $ac_J(((a.a.length >>> 1) | 0)), 0, end, comparator, ops);
  } else {
    this.r6(a, 0, end, comparator, ops);
  }
});
$p.b98 = (function(a, fromIndex, toIndex) {
  var comparator = $m_ju_internal_GenericArrayOps$LongArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$LongArrayOps$();
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"));
  }
  if ((((toIndex - fromIndex) | 0) > 16)) {
    this.py(a, new $ac_J(((a.a.length >>> 1) | 0)), fromIndex, toIndex, comparator, ops);
  } else {
    this.r6(a, fromIndex, toIndex, comparator, ops);
  }
});
$p.aSj = (function(a) {
  var comparator = $m_ju_internal_GenericArrayOps$ShortArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$ShortArrayOps$();
  var end = a.a.length;
  if ((end > 16)) {
    this.py(a, new $ac_S(a.a.length), 0, end, comparator, ops);
  } else {
    this.r6(a, 0, end, comparator, ops);
  }
});
$p.b99 = (function(a, fromIndex, toIndex) {
  var comparator = $m_ju_internal_GenericArrayOps$ShortArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$ShortArrayOps$();
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"));
  }
  if ((((toIndex - fromIndex) | 0) > 16)) {
    this.py(a, new $ac_S(a.a.length), fromIndex, toIndex, comparator, ops);
  } else {
    this.r6(a, fromIndex, toIndex, comparator, ops);
  }
});
$p.aSg = (function(a) {
  var comparator = $m_ju_internal_GenericArrayOps$CharArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$CharArrayOps$();
  var end = a.a.length;
  if ((end > 16)) {
    this.py(a, new $ac_C(a.a.length), 0, end, comparator, ops);
  } else {
    this.r6(a, 0, end, comparator, ops);
  }
});
$p.b96 = (function(a, fromIndex, toIndex) {
  var comparator = $m_ju_internal_GenericArrayOps$CharArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$CharArrayOps$();
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"));
  }
  if ((((toIndex - fromIndex) | 0) > 16)) {
    this.py(a, new $ac_C(a.a.length), fromIndex, toIndex, comparator, ops);
  } else {
    this.r6(a, fromIndex, toIndex, comparator, ops);
  }
});
$p.aSf = (function(a) {
  var comparator = $m_ju_internal_GenericArrayOps$ByteArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$ByteArrayOps$();
  var end = a.a.length;
  if ((end > 16)) {
    this.py(a, new $ac_B(a.a.length), 0, end, comparator, ops);
  } else {
    this.r6(a, 0, end, comparator, ops);
  }
});
$p.b95 = (function(a, fromIndex, toIndex) {
  var comparator = $m_ju_internal_GenericArrayOps$ByteArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$ByteArrayOps$();
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"));
  }
  if ((((toIndex - fromIndex) | 0) > 16)) {
    this.py(a, new $ac_B(a.a.length), fromIndex, toIndex, comparator, ops);
  } else {
    this.r6(a, fromIndex, toIndex, comparator, ops);
  }
});
$p.Jn = (function(array, comparator) {
  var comparator$1 = ((comparator === null) ? $m_ju_Arrays$NaturalComparator$() : comparator);
  var ops = $m_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$();
  var end = array.a.length;
  if ((end > 16)) {
    this.py(array, $objectGetClass(array).ba.Q().ba.U(array.a.length), 0, end, comparator$1, ops);
  } else {
    this.r6(array, 0, end, comparator$1, ops);
  }
});
$p.b9a = (function(array, fromIndex, toIndex, comparator) {
  var comparator$1 = ((comparator === null) ? $m_ju_Arrays$NaturalComparator$() : comparator);
  var ops = $m_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$();
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"));
  }
  if ((((toIndex - fromIndex) | 0) > 16)) {
    this.py(array, $objectGetClass(array).ba.Q().ba.U(array.a.length), fromIndex, toIndex, comparator$1, ops);
  } else {
    this.r6(array, fromIndex, toIndex, comparator$1, ops);
  }
});
$p.py = (function(a, temp, start, end, comparator, ops) {
  var length = ((end - start) | 0);
  if ((length > 16)) {
    var middle = ((start + (((length + ((length >>> 31) | 0)) | 0) >> 1)) | 0);
    this.py(a, temp, start, middle, comparator, ops);
    this.py(a, temp, middle, end, comparator, ops);
    var outIndex = start;
    var leftInIndex = start;
    var rightInIndex = middle;
    while ((outIndex < end)) {
      if (((leftInIndex < middle) && ((rightInIndex >= end) || (comparator.dA(ops.nA(a, leftInIndex), ops.nA(a, rightInIndex)) <= 0)))) {
        ops.wf(temp, outIndex, ops.nA(a, leftInIndex));
        leftInIndex = ((1 + leftInIndex) | 0);
      } else {
        ops.wf(temp, outIndex, ops.nA(a, rightInIndex));
        rightInIndex = ((1 + rightInIndex) | 0);
      }
      outIndex = ((1 + outIndex) | 0);
    }
    temp.av(start, a, start, length);
  } else {
    this.r6(a, start, end, comparator, ops);
  }
});
$p.r6 = (function(a, start, end, comparator, ops) {
  var n = ((end - start) | 0);
  if ((n >= 2)) {
    var aStart = ops.nA(a, start);
    var aStartPlusOne = ops.nA(a, ((1 + start) | 0));
    if ((comparator.dA(aStart, aStartPlusOne) > 0)) {
      ops.wf(a, start, aStartPlusOne);
      ops.wf(a, ((1 + start) | 0), aStart);
    }
    var m = 2;
    while ((m < n)) {
      var next = ops.nA(a, ((start + m) | 0));
      if ((comparator.dA(next, ops.nA(a, ((((start + m) | 0) - 1) | 0))) < 0)) {
        var iA = start;
        var iB = ((((start + m) | 0) - 1) | 0);
        while ((((iB - iA) | 0) > 1)) {
          var ix = ((((iA + iB) | 0) >>> 1) | 0);
          if ((comparator.dA(next, ops.nA(a, ix)) < 0)) {
            iB = ix;
          } else {
            iA = ix;
          }
        }
        var ix$2 = ((iA + ((comparator.dA(next, ops.nA(a, iA)) >= 0) | 0)) | 0);
        var i = ((start + m) | 0);
        while ((i > ix$2)) {
          ops.wf(a, i, ops.nA(a, ((i - 1) | 0)));
          i = ((i - 1) | 0);
        }
        ops.wf(a, ix$2, next);
      }
      m = ((1 + m) | 0);
    }
  }
});
$p.aXY = (function(a, key_$_lo, key_$_hi) {
  var startIndex = 0;
  var endIndex = ((a.a.length >>> 1) | 0);
  while (true) {
    if ((startIndex === endIndex)) {
      return (~startIndex);
    } else {
      var mid = ((((startIndex + endIndex) | 0) >>> 1) | 0);
      var $x_1 = a.a;
      var $x_2 = (mid << 1);
      var elem_$_lo = $x_1[$x_2];
      var elem_$_hi = $x_1[(($x_2 + 1) | 0)];
      var cmp = ((key_$_hi === elem_$_hi) ? ((key_$_lo === elem_$_lo) ? 0 : (((key_$_lo >>> 0) < (elem_$_lo >>> 0)) ? (-1) : 1)) : ((key_$_hi < elem_$_hi) ? (-1) : 1));
      if ((cmp < 0)) {
        endIndex = mid;
        continue;
      }
      if ((cmp !== 0)) {
        startIndex = ((1 + mid) | 0);
        continue;
      }
      return mid;
    }
  }
});
$p.aMv = (function(a, key) {
  var startIndex = 0;
  var endIndex = a.a.length;
  while (true) {
    if ((startIndex === endIndex)) {
      return (~startIndex);
    } else {
      var mid = ((((startIndex + endIndex) | 0) >>> 1) | 0);
      var elem = a.a[mid];
      var cmp = ((key === elem) ? 0 : ((key < elem) ? (-1) : 1));
      if ((cmp < 0)) {
        endIndex = mid;
        continue;
      }
      if ((cmp !== 0)) {
        startIndex = ((1 + mid) | 0);
        continue;
      }
      return mid;
    }
  }
});
$p.afw = (function(a, b) {
  if ((a === b)) {
    return true;
  }
  if (((a === null) || (b === null))) {
    return false;
  }
  var len = ((a.a.length >>> 1) | 0);
  if ((((b.a.length >>> 1) | 0) !== len)) {
    return false;
  }
  var i = 0;
  while ((i !== len)) {
    var i$1 = i;
    var $x_1 = a.a;
    var $x_2 = (i$1 << 1);
    var a$1_$_lo = $x_1[$x_2];
    var a$1_$_hi = $x_1[(($x_2 + 1) | 0)];
    var i$2 = i;
    var $x_3 = b.a;
    var $x_4 = (i$2 << 1);
    var b$1_$_lo = $x_3[$x_4];
    var b$1_$_hi = $x_3[(($x_4 + 1) | 0)];
    if ((!(((a$1_$_lo ^ b$1_$_lo) | (a$1_$_hi ^ b$1_$_hi)) === 0))) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
$p.a3h = (function(a, b) {
  if ((a === b)) {
    return true;
  }
  if (((a === null) || (b === null))) {
    return false;
  }
  var len = a.a.length;
  if ((b.a.length !== len)) {
    return false;
  }
  var i = 0;
  while ((i !== len)) {
    var i$1 = i;
    var $x_1 = a.a[i$1];
    var i$2 = i;
    if ((!($x_1 === b.a[i$2]))) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
$p.aNM = (function(a, b) {
  if ((a === b)) {
    return true;
  }
  if (((a === null) || (b === null))) {
    return false;
  }
  var len = a.a.length;
  if ((b.a.length !== len)) {
    return false;
  }
  var i = 0;
  while ((i !== len)) {
    var i$1 = i;
    var $x_1 = a.a[i$1];
    var i$2 = i;
    if ((!($x_1 === b.a[i$2]))) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
$p.afv = (function(a, b) {
  if ((a === b)) {
    return true;
  }
  if (((a === null) || (b === null))) {
    return false;
  }
  var len = a.a.length;
  if ((b.a.length !== len)) {
    return false;
  }
  var i = 0;
  while ((i !== len)) {
    var i$1 = i;
    var $x_1 = a.a[i$1];
    var i$2 = i;
    if ((!($x_1 === b.a[i$2]))) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
$p.aNL = (function(a, b) {
  if ((a === b)) {
    return true;
  }
  if (((a === null) || (b === null))) {
    return false;
  }
  var len = a.a.length;
  if ((b.a.length !== len)) {
    return false;
  }
  var i = 0;
  while ((i !== len)) {
    var i$1 = i;
    var $x_1 = a.a[i$1];
    var i$2 = i;
    if ((!($x_1 === b.a[i$2]))) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
$p.aNN = (function(a, b) {
  if ((a === b)) {
    return true;
  }
  if (((a === null) || (b === null))) {
    return false;
  }
  var len = a.a.length;
  if ((b.a.length !== len)) {
    return false;
  }
  var i = 0;
  while ((i !== len)) {
    var i$1 = i;
    var $x_1 = a.a[i$1];
    var i$2 = i;
    if ((!($x_1 === b.a[i$2]))) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
$p.WM = (function(a, value) {
  var toIndex = a.a.length;
  var i = 0;
  while ((i !== toIndex)) {
    var i$1 = i;
    a.a[i$1] = value;
    i = ((1 + i) | 0);
  }
});
$p.b1c = (function(a, fromIndex, toIndex, value) {
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"));
  }
  var i$1 = fromIndex;
  while ((i$1 !== toIndex)) {
    var i$2 = i$1;
    a.a[i$2] = value;
    i$1 = ((1 + i$1) | 0);
  }
});
$p.ex = (function(original, newLength) {
  var b = original.a.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = $objectGetClass(original).ba.Q().ba.U(newLength);
  original.av(0, ret, 0, copyLength);
  return ret;
});
$p.WA = (function(original, newLength, newType) {
  var b = original.a.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = newType.ba.Q().ba.U(newLength);
  original.av(0, ret, 0, copyLength);
  return ret;
});
$p.aN8 = (function(original, newLength) {
  var b = original.a.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_B(newLength);
  original.av(0, ret, 0, copyLength);
  return ret;
});
$p.aNb = (function(original, newLength) {
  var b = original.a.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_S(newLength);
  original.av(0, ret, 0, copyLength);
  return ret;
});
$p.aN9 = (function(original, newLength) {
  var b = original.a.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_I(newLength);
  original.av(0, ret, 0, copyLength);
  return ret;
});
$p.aNa = (function(original, newLength) {
  var b = ((original.a.length >>> 1) | 0);
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_J(newLength);
  original.av(0, ret, 0, copyLength);
  return ret;
});
$p.a31 = (function(original, newLength) {
  var b = original.a.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_C(newLength);
  original.av(0, ret, 0, copyLength);
  return ret;
});
$p.aZi = (function(original, newLength) {
  var b = original.a.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_F(newLength);
  original.av(0, ret, 0, copyLength);
  return ret;
});
$p.aZh = (function(original, newLength) {
  var b = original.a.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_D(newLength);
  original.av(0, ret, 0, copyLength);
  return ret;
});
$p.aNc = (function(original, newLength) {
  var b = original.a.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_Z(newLength);
  original.av(0, ret, 0, copyLength);
  return ret;
});
$p.d7 = (function(original, from, to) {
  if ((from > to)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((from + " > ") + to));
  }
  var len = original.a.length;
  var retLength = ((to - from) | 0);
  var b = ((len - from) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = $objectGetClass(original).ba.Q().ba.U(retLength);
  original.av(from, ret, 0, copyLength);
  return ret;
});
$p.aZj = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end));
  }
  var len = original.a.length;
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_B(retLength);
  original.av(start, ret, 0, copyLength);
  return ret;
});
$p.aZn = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end));
  }
  var len = original.a.length;
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_S(retLength);
  original.av(start, ret, 0, copyLength);
  return ret;
});
$p.aZm = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end));
  }
  var len = original.a.length;
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_I(retLength);
  original.av(start, ret, 0, copyLength);
  return ret;
});
$p.afe = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end));
  }
  var len = ((original.a.length >>> 1) | 0);
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_J(retLength);
  original.av(start, ret, 0, copyLength);
  return ret;
});
$p.afd = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end));
  }
  var len = original.a.length;
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_C(retLength);
  original.av(start, ret, 0, copyLength);
  return ret;
});
$p.aZl = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end));
  }
  var len = original.a.length;
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_F(retLength);
  original.av(start, ret, 0, copyLength);
  return ret;
});
$p.aZk = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end));
  }
  var len = original.a.length;
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_D(retLength);
  original.av(start, ret, 0, copyLength);
  return ret;
});
$p.aZo = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end));
  }
  var len = original.a.length;
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_Z(retLength);
  original.av(start, ret, 0, copyLength);
  return ret;
});
$p.b2v = (function(a) {
  if ((a === null)) {
    return 0;
  } else {
    var acc = 1;
    var len = ((a.a.length >>> 1) | 0);
    var i = 0;
    while ((i !== len)) {
      var $x_3 = acc;
      var i$1 = i;
      var $x_1 = a.a;
      var $x_2 = (i$1 << 1);
      var o_$_lo = $x_1[$x_2];
      var o_$_hi = $x_1[(($x_2 + 1) | 0)];
      acc = ((Math.imul(31, $x_3) + (o_$_lo ^ o_$_hi)) | 0);
      i = ((1 + i) | 0);
    }
    return acc;
  }
});
$p.b2u = (function(a) {
  if ((a === null)) {
    return 0;
  } else {
    var acc = 1;
    var len = a.a.length;
    var i = 0;
    while ((i !== len)) {
      var $x_1 = acc;
      var i$1 = i;
      acc = ((Math.imul(31, $x_1) + a.a[i$1]) | 0);
      i = ((1 + i) | 0);
    }
    return acc;
  }
});
var $d_ju_Arrays$ = new $TypeData().i($c_ju_Arrays$, "java.util.Arrays$", ({
  sU: 1
}));
var $n_ju_Arrays$;
function $m_ju_Arrays$() {
  if ((!$n_ju_Arrays$)) {
    $n_ju_Arrays$ = new $c_ju_Arrays$();
  }
  return $n_ju_Arrays$;
}
function $p_ju_Collections$__EMPTY_SET$lzycompute__ju_Set($thiz) {
  if (((((1 & $thiz.B6) << 24) >> 24) === 0)) {
    $thiz.a7p = new $c_ju_Collections$ImmutableSet(new $c_ju_Collections$$anon$1());
    $thiz.B6 = (((1 | $thiz.B6) << 24) >> 24);
  }
  return $thiz.a7p;
}
function $p_ju_Collections$__EMPTY_ITERATOR$lzycompute__ju_Iterator($thiz) {
  if (((((8 & $thiz.B6) << 24) >> 24) === 0)) {
    $thiz.a7o = new $c_ju_Collections$EmptyIterator();
    $thiz.B6 = (((8 | $thiz.B6) << 24) >> 24);
  }
  return $thiz.a7o;
}
function $p_ju_Collections$__EMPTY_ITERATOR__ju_Iterator($thiz) {
  return (((((8 & $thiz.B6) << 24) >> 24) === 0) ? $p_ju_Collections$__EMPTY_ITERATOR$lzycompute__ju_Iterator($thiz) : $thiz.a7o);
}
/** @constructor */
function $c_ju_Collections$() {
  this.a7p = null;
  this.a7o = null;
  this.B6 = 0;
}
$p = $c_ju_Collections$.prototype = new $h_O();
$p.constructor = $c_ju_Collections$;
/** @constructor */
function $h_ju_Collections$() {
}
$h_ju_Collections$.prototype = $p;
$p.aVR = (function() {
  return (((((1 & this.B6) << 24) >> 24) === 0) ? $p_ju_Collections$__EMPTY_SET$lzycompute__ju_Set(this) : this.a7p);
});
var $d_ju_Collections$ = new $TypeData().i($c_ju_Collections$, "java.util.Collections$", ({
  sW: 1
}));
var $n_ju_Collections$;
function $m_ju_Collections$() {
  if ((!$n_ju_Collections$)) {
    $n_ju_Collections$ = new $c_ju_Collections$();
  }
  return $n_ju_Collections$;
}
function $is_ju_Formattable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.fa)));
}
function $isArrayOf_ju_Formattable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fa)));
}
/** @constructor */
function $c_ju_Formatter$() {
  this.atn = null;
  this.atm = null;
  $n_ju_Formatter$ = this;
  this.atn = new RegExp("(?:(\\d+)\\$)?([-#+ 0,\\(<]*)(\\d+)?(?:\\.(\\d+))?[%A-Za-z]", "g");
  this.atm = $constArrSVals_I(26, "3]3{0C{0H_1]8]_3{||||||0I]|||3y||||0A]||");
}
$p = $c_ju_Formatter$.prototype = new $h_O();
$p.constructor = $c_ju_Formatter$;
/** @constructor */
function $h_ju_Formatter$() {
}
$h_ju_Formatter$.prototype = $p;
$p.agI = (function(count) {
  if ((count <= 20)) {
    return "00000000000000000000".substring(0, count);
  } else {
    var result = "";
    var remaining = count;
    while ((remaining > 20)) {
      result = (result + "00000000000000000000");
      remaining = ((remaining - 20) | 0);
    }
    var $x_1 = result;
    var endIndex = remaining;
    return (("" + $x_1) + "00000000000000000000".substring(0, endIndex));
  }
});
$p.b3M = (function(x) {
  if ((x === 0.0)) {
    return new $c_ju_Formatter$Decimal(((1.0 / x) < 0.0), "0", 0);
  } else {
    var negative$2 = (x < 0.0);
    var d = (negative$2 ? (-x) : x);
    var s = ("" + d);
    var ePos = $f_T__indexOf__I__I(s, 101);
    if ((ePos < 0)) {
      var e = 0;
    } else {
      var $x_2 = parseInt;
      var beginIndex = ((1 + ePos) | 0);
      var $x_1 = $x_2(s.substring(beginIndex));
      var e = ($x_1 | 0);
    }
    var significandEnd = ((ePos < 0) ? s.length : ePos);
    var dotPos = $f_T__indexOf__I__I(s, 46);
    if ((dotPos < 0)) {
      return new $c_ju_Formatter$Decimal(negative$2, s.substring(0, significandEnd), ((-e) | 0));
    } else {
      var $x_3 = s.substring(0, dotPos);
      var beginIndex$1 = ((1 + dotPos) | 0);
      var digits = (("" + $x_3) + s.substring(beginIndex$1, significandEnd));
      var digitsLen = digits.length;
      var i = 0;
      while (((i < digitsLen) && (digits.charCodeAt(i) === 48))) {
        i = ((1 + i) | 0);
      }
      var beginIndex$2 = i;
      return new $c_ju_Formatter$Decimal(negative$2, digits.substring(beginIndex$2), ((((-e) | 0) + ((significandEnd - ((1 + dotPos) | 0)) | 0)) | 0));
    }
  }
});
$p.b3L = (function(x) {
  var unscaledValueWithSign = $m_Ljava_math_Conversion$().yn(x.jU());
  if ((unscaledValueWithSign === "0")) {
    return new $c_ju_Formatter$Decimal(false, "0", 0);
  } else {
    var negative = (unscaledValueWithSign.charCodeAt(0) === 45);
    return new $c_ju_Formatter$Decimal(negative, (negative ? unscaledValueWithSign.substring(1) : unscaledValueWithSign), x.c9);
  }
});
var $d_ju_Formatter$ = new $TypeData().i($c_ju_Formatter$, "java.util.Formatter$", ({
  tb: 1
}));
var $n_ju_Formatter$;
function $m_ju_Formatter$() {
  if ((!$n_ju_Formatter$)) {
    $n_ju_Formatter$ = new $c_ju_Formatter$();
  }
  return $n_ju_Formatter$;
}
function $p_ju_Formatter$Decimal__roundAtPos__I__ju_Formatter$Decimal($thiz, roundingPos) {
  var digits = $thiz.yH;
  var digitsLen = digits.length;
  if ((roundingPos < 0)) {
    return new $c_ju_Formatter$Decimal($thiz.yG, "0", 0);
  } else if ((roundingPos >= digitsLen)) {
    return $thiz;
  } else if ((digits.charCodeAt(roundingPos) < 53)) {
    return ((roundingPos === 0) ? new $c_ju_Formatter$Decimal($thiz.yG, "0", 0) : new $c_ju_Formatter$Decimal($thiz.yG, digits.substring(0, roundingPos), (($thiz.wu - ((digitsLen - roundingPos) | 0)) | 0)));
  } else {
    var lastNonNinePos = ((roundingPos - 1) | 0);
    while (((lastNonNinePos >= 0) && (digits.charCodeAt(lastNonNinePos) === 57))) {
      lastNonNinePos = ((lastNonNinePos - 1) | 0);
    }
    if ((lastNonNinePos < 0)) {
      var newUnscaledValue = "1";
    } else {
      var endIndex = lastNonNinePos;
      var newUnscaledValue = (digits.substring(0, endIndex) + $cToS((65535 & ((1 + digits.charCodeAt(lastNonNinePos)) | 0))));
    }
    var pos = ((1 + lastNonNinePos) | 0);
    var newScale = (($thiz.wu - ((digitsLen - pos) | 0)) | 0);
    return new $c_ju_Formatter$Decimal($thiz.yG, newUnscaledValue, newScale);
  }
}
/** @constructor */
function $c_ju_Formatter$Decimal(negative, unscaledValue, scale) {
  this.yG = false;
  this.yH = null;
  this.wu = 0;
  this.yG = negative;
  this.yH = unscaledValue;
  this.wu = scale;
}
$p = $c_ju_Formatter$Decimal.prototype = new $h_O();
$p.constructor = $c_ju_Formatter$Decimal;
/** @constructor */
function $h_ju_Formatter$Decimal() {
}
$h_ju_Formatter$Decimal.prototype = $p;
$p.aPs = (function() {
  return (this.yH === "0");
});
$p.aRN = (function(precision) {
  $m_ju_Formatter$();
  if ((!(precision > 0))) {
    throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "Decimal.round() called with non-positive precision");
  }
  return $p_ju_Formatter$Decimal__roundAtPos__I__ju_Formatter$Decimal(this, precision);
});
$p.b8K = (function(newScale) {
  var roundingPos = ((((this.yH.length + newScale) | 0) - this.wu) | 0);
  var rounded = $p_ju_Formatter$Decimal__roundAtPos__I__ju_Formatter$Decimal(this, roundingPos);
  $m_ju_Formatter$();
  if ((!(rounded.aPs() || (rounded.wu <= newScale)))) {
    throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "roundAtPos returned a non-zero value with a scale too large");
  }
  return ((rounded.aPs() || (rounded.wu === newScale)) ? rounded : new $c_ju_Formatter$Decimal(this.yG, (("" + rounded.yH) + $m_ju_Formatter$().agI(((newScale - rounded.wu) | 0))), newScale));
});
$p.m = (function() {
  return (((((("Decimal(" + this.yG) + ", ") + this.yH) + ", ") + this.wu) + ")");
});
var $d_ju_Formatter$Decimal = new $TypeData().i($c_ju_Formatter$Decimal, "java.util.Formatter$Decimal", ({
  tc: 1
}));
/** @constructor */
function $c_ju_Formatter$LocaleInfo() {
}
$p = $c_ju_Formatter$LocaleInfo.prototype = new $h_O();
$p.constructor = $c_ju_Formatter$LocaleInfo;
/** @constructor */
function $h_ju_Formatter$LocaleInfo() {
}
$h_ju_Formatter$LocaleInfo.prototype = $p;
function $is_ju_Map(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.cn)));
}
function $isArrayOf_ju_Map(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.cn)));
}
function $is_ju_Map$Entry(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.co)));
}
function $isArrayOf_ju_Map$Entry(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.co)));
}
/** @constructor */
function $c_ju_internal_MurmurHash3$() {
}
$p = $c_ju_internal_MurmurHash3$.prototype = new $h_O();
$p.constructor = $c_ju_internal_MurmurHash3$;
/** @constructor */
function $h_ju_internal_MurmurHash3$() {
}
$h_ju_internal_MurmurHash3$.prototype = $p;
$p.k = (function(hash, data) {
  var h = this.r8(hash, data);
  var i = h;
  h = ((i << 13) | ((i >>> 19) | 0));
  return ((Math.imul(5, h) - 430675100) | 0);
});
$p.r8 = (function(hash, data) {
  var k = data;
  k = Math.imul((-862048943), k);
  var i = k;
  k = ((i << 15) | ((i >>> 17) | 0));
  k = Math.imul(461845907, k);
  return (hash ^ k);
});
$p.Z = (function(hash, length) {
  var hash$1 = (hash ^ length);
  var h = hash$1;
  h = (h ^ ((h >>> 16) | 0));
  h = Math.imul((-2048144789), h);
  h = (h ^ ((h >>> 13) | 0));
  h = Math.imul((-1028477387), h);
  h = (h ^ ((h >>> 16) | 0));
  return h;
});
var $d_ju_internal_MurmurHash3$ = new $TypeData().i($c_ju_internal_MurmurHash3$, "java.util.internal.MurmurHash3$", ({
  tO: 1
}));
var $n_ju_internal_MurmurHash3$;
function $m_ju_internal_MurmurHash3$() {
  if ((!$n_ju_internal_MurmurHash3$)) {
    $n_ju_internal_MurmurHash3$ = new $c_ju_internal_MurmurHash3$();
  }
  return $n_ju_internal_MurmurHash3$;
}
/** @constructor */
function $c_ju_regex_IndicesBuilder(pattern, flags, node, groupCount, jsRegExpForFind, jsRegExpForMatches) {
  this.atE = null;
  this.atz = null;
  this.atD = null;
  this.atA = 0;
  this.atB = null;
  this.atC = null;
  this.atE = pattern;
  this.atz = flags;
  this.atD = node;
  this.atA = groupCount;
  this.atB = jsRegExpForFind;
  this.atC = jsRegExpForMatches;
}
$p = $c_ju_regex_IndicesBuilder.prototype = new $h_O();
$p.constructor = $c_ju_regex_IndicesBuilder;
/** @constructor */
function $h_ju_regex_IndicesBuilder() {
}
$h_ju_regex_IndicesBuilder.prototype = $p;
$p.aXd = (function(forMatches, string, index) {
  var regExp = (forMatches ? this.atC : this.atB);
  regExp.lastIndex = index;
  var allMatchResult = regExp.exec(string);
  if (((allMatchResult === null) || ((allMatchResult.index | 0) !== index))) {
    throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), (((((("[Internal error] Executed '" + regExp) + "' on ") + ((("'" + string) + "' at position ") + index)) + ", got an error.\n") + ((("Original pattern '" + this.atE) + "' with flags '") + this.atz)) + "' did match however."));
  }
  var end = ((index + allMatchResult[0].length) | 0);
  var len = ((1 + this.atA) | 0);
  var indices = new Array(len);
  indices[0] = [index, end];
  var i = 1;
  while ((i !== len)) {
    indices[i] = (void 0);
    i = ((1 + i) | 0);
  }
  this.atD.wb(allMatchResult, indices, index, end);
  return indices;
});
var $d_ju_regex_IndicesBuilder = new $TypeData().i($c_ju_regex_IndicesBuilder, "java.util.regex.IndicesBuilder", ({
  tP: 1
}));
/** @constructor */
function $c_ju_regex_IndicesBuilder$() {
}
$p = $c_ju_regex_IndicesBuilder$.prototype = new $h_O();
$p.constructor = $c_ju_regex_IndicesBuilder$;
/** @constructor */
function $h_ju_regex_IndicesBuilder$() {
}
$h_ju_regex_IndicesBuilder$.prototype = $p;
$p.aXk = (function(pattern, flags) {
  var parser = new $c_ju_regex_IndicesBuilder$Parser(pattern);
  var node = $p_ju_regex_IndicesBuilder$Parser__parseInsideParensAndClosingParen__ju_regex_IndicesBuilder$Node(parser);
  node.nD(1);
  var allMatchingPattern = node.tU(parser.Kd);
  var jsRegExpForFind = new RegExp(allMatchingPattern, (flags + "g"));
  var jsRegExpForMatches = new RegExp((("^(?:" + allMatchingPattern) + ")$"), flags);
  return new $c_ju_regex_IndicesBuilder(pattern, flags, node, parser.b6F(), jsRegExpForFind, jsRegExpForMatches);
});
var $d_ju_regex_IndicesBuilder$ = new $TypeData().i($c_ju_regex_IndicesBuilder$, "java.util.regex.IndicesBuilder$", ({
  tQ: 1
}));
var $n_ju_regex_IndicesBuilder$;
function $m_ju_regex_IndicesBuilder$() {
  if ((!$n_ju_regex_IndicesBuilder$)) {
    $n_ju_regex_IndicesBuilder$ = new $c_ju_regex_IndicesBuilder$();
  }
  return $n_ju_regex_IndicesBuilder$;
}
/** @constructor */
function $c_ju_regex_IndicesBuilder$Node() {
  this.rn = 0;
}
$p = $c_ju_regex_IndicesBuilder$Node.prototype = new $h_O();
$p.constructor = $c_ju_regex_IndicesBuilder$Node;
/** @constructor */
function $h_ju_regex_IndicesBuilder$Node() {
}
$h_ju_regex_IndicesBuilder$Node.prototype = $p;
$p.nD = (function(newGroupIndex) {
  this.rn = newGroupIndex;
  return ((1 + newGroupIndex) | 0);
});
$p.aRd = (function(matchResult, indices, end) {
  var x = matchResult[this.rn];
  this.wb(matchResult, indices, ((x !== (void 0)) ? ((end - x.length) | 0) : (-1)), end);
});
$p.aRe = (function(matchResult, indices, start) {
  var x = matchResult[this.rn];
  var end = ((x !== (void 0)) ? ((start + x.length) | 0) : (-1));
  this.wb(matchResult, indices, start, end);
  return end;
});
function $p_ju_regex_IndicesBuilder$Parser__parseInsideParensAndClosingParen__ju_regex_IndicesBuilder$Node($thiz) {
  var alternatives = [];
  var sequence = [];
  while (true) {
    var dispatchCP = $f_T__codePointAt__I__I($thiz.ly, $thiz.cO);
    switch (dispatchCP) {
      case 124: {
        alternatives.push($ps_ju_regex_IndicesBuilder$Parser__completeSequence$1__O__ju_regex_IndicesBuilder$Node(sequence));
        sequence = [];
        $thiz.cO = ((1 + $thiz.cO) | 0);
        var baseNode = null;
        break;
      }
      case 41: {
        var baseNode;
        $thiz.cO = ((1 + $thiz.cO) | 0);
        var lastAlternative = $ps_ju_regex_IndicesBuilder$Parser__completeSequence$1__O__ju_regex_IndicesBuilder$Node(sequence);
        if (((alternatives.length | 0) === 0)) {
          return lastAlternative;
        } else {
          alternatives.push(lastAlternative);
          return new $c_ju_regex_IndicesBuilder$AlternativesNode(alternatives);
        }
        break;
      }
      case 40: {
        var indicator = $thiz.ly.substring(((1 + $thiz.cO) | 0), ((3 + $thiz.cO) | 0));
        if (((indicator === "?=") || (indicator === "?!"))) {
          $thiz.cO = ((3 + $thiz.cO) | 0);
          var baseNode = new $c_ju_regex_IndicesBuilder$LookAroundNode(false, indicator, $p_ju_regex_IndicesBuilder$Parser__parseInsideParensAndClosingParen__ju_regex_IndicesBuilder$Node($thiz));
        } else if ((indicator === "?<")) {
          var fullIndicator = $thiz.ly.substring(((1 + $thiz.cO) | 0), ((4 + $thiz.cO) | 0));
          $thiz.cO = ((4 + $thiz.cO) | 0);
          var baseNode = new $c_ju_regex_IndicesBuilder$LookAroundNode(true, fullIndicator, $p_ju_regex_IndicesBuilder$Parser__parseInsideParensAndClosingParen__ju_regex_IndicesBuilder$Node($thiz));
        } else if ((indicator === "?:")) {
          $thiz.cO = ((3 + $thiz.cO) | 0);
          var inner$3 = $p_ju_regex_IndicesBuilder$Parser__parseInsideParensAndClosingParen__ju_regex_IndicesBuilder$Node($thiz);
          var baseNode = ((inner$3 instanceof $c_ju_regex_IndicesBuilder$LeafRegexNode) ? new $c_ju_regex_IndicesBuilder$SequenceNode([inner$3]) : inner$3);
        } else {
          $thiz.cO = ((1 + $thiz.cO) | 0);
          var groupIndex = ($thiz.Kd.length | 0);
          $thiz.Kd.push(null);
          var inner$4 = $p_ju_regex_IndicesBuilder$Parser__parseInsideParensAndClosingParen__ju_regex_IndicesBuilder$Node($thiz);
          var groupNode = new $c_ju_regex_IndicesBuilder$GroupNode(groupIndex, inner$4);
          $thiz.Kd[groupIndex] = groupNode;
          var baseNode = groupNode;
        }
        break;
      }
      case 92: {
        var startIndex = $thiz.cO;
        var this$2 = $thiz.ly;
        var index = ((1 + startIndex) | 0);
        var c = this$2.charCodeAt(index);
        $thiz.cO = ((2 + $thiz.cO) | 0);
        if (((((c - 48) | 0) >>> 0) <= 9)) {
          while ((((($thiz.ly.charCodeAt($thiz.cO) - 48) | 0) >>> 0) <= 9)) {
            $thiz.cO = ((1 + $thiz.cO) | 0);
          }
          var baseNode = new $c_ju_regex_IndicesBuilder$BackReferenceNode($m_jl_Integer$().gc($thiz.ly.substring(((1 + startIndex) | 0), $thiz.cO), 10, 214748364));
        } else {
          if (((c === 80) || (c === 112))) {
            while (($thiz.ly.charCodeAt($thiz.cO) !== 125)) {
              $thiz.cO = ((1 + $thiz.cO) | 0);
            }
            $thiz.cO = ((1 + $thiz.cO) | 0);
          }
          var baseNode = new $c_ju_regex_IndicesBuilder$LeafRegexNode($thiz.ly.substring(startIndex, $thiz.cO));
        }
        break;
      }
      case 91: {
        var startIndex$2 = $thiz.cO;
        $thiz.cO = $p_ju_regex_IndicesBuilder$Parser__loop$1__I__I($thiz, ((1 + startIndex$2) | 0));
        var baseNode = new $c_ju_regex_IndicesBuilder$LeafRegexNode($thiz.ly.substring(startIndex$2, $thiz.cO));
        break;
      }
      default: {
        var start = $thiz.cO;
        $thiz.cO = (($thiz.cO + ((dispatchCP >= 65536) ? 2 : 1)) | 0);
        var baseNode = new $c_ju_regex_IndicesBuilder$LeafRegexNode($thiz.ly.substring(start, $thiz.cO));
      }
    }
    if ((baseNode !== null)) {
      switch ($thiz.ly.charCodeAt($thiz.cO)) {
        case 43:
        case 42:
        case 63: {
          var startIndex$3 = $thiz.cO;
          if (($thiz.ly.charCodeAt(((1 + startIndex$3) | 0)) === 63)) {
            $thiz.cO = ((2 + $thiz.cO) | 0);
          } else {
            $thiz.cO = ((1 + $thiz.cO) | 0);
          }
          var repeater = $thiz.ly.substring(startIndex$3, $thiz.cO);
          (sequence.push(new $c_ju_regex_IndicesBuilder$RepeatedNode(baseNode, repeater)) | 0);
          break;
        }
        case 123: {
          var startIndex$4 = $thiz.cO;
          var this$9 = $thiz.ly;
          var fromIndex = ((1 + startIndex$4) | 0);
          $thiz.cO = ((1 + (this$9.indexOf("}", fromIndex) | 0)) | 0);
          if (($thiz.ly.charCodeAt($thiz.cO) === 63)) {
            $thiz.cO = ((1 + $thiz.cO) | 0);
          }
          var repeater$2 = $thiz.ly.substring(startIndex$4, $thiz.cO);
          (sequence.push(new $c_ju_regex_IndicesBuilder$RepeatedNode(baseNode, repeater$2)) | 0);
          break;
        }
        default: {
          var sequenceLen = (sequence.length | 0);
          if ((((sequenceLen !== 0) && (baseNode instanceof $c_ju_regex_IndicesBuilder$LeafRegexNode)) && (sequence[((sequenceLen - 1) | 0)] instanceof $c_ju_regex_IndicesBuilder$LeafRegexNode))) {
            var fused = new $c_ju_regex_IndicesBuilder$LeafRegexNode((("" + sequence[((sequenceLen - 1) | 0)].ZA) + baseNode.ZA));
            sequence[((sequenceLen - 1) | 0)] = fused;
          } else {
            (sequence.push(baseNode) | 0);
          }
        }
      }
    }
  }
}
function $ps_ju_regex_IndicesBuilder$Parser__completeSequence$1__O__ju_regex_IndicesBuilder$Node(sequence) {
  switch ((sequence.length | 0)) {
    case 0: {
      return new $c_ju_regex_IndicesBuilder$LeafRegexNode("");
      break;
    }
    case 1: {
      return sequence[0];
      break;
    }
    default: {
      return new $c_ju_regex_IndicesBuilder$SequenceNode(sequence);
    }
  }
}
function $p_ju_regex_IndicesBuilder$Parser__loop$1__I__I($thiz, pIndex) {
  while (true) {
    switch ($thiz.ly.charCodeAt(pIndex)) {
      case 92: {
        pIndex = ((2 + pIndex) | 0);
        break;
      }
      case 93: {
        return ((1 + pIndex) | 0);
        break;
      }
      default: {
        pIndex = ((1 + pIndex) | 0);
      }
    }
  }
}
/** @constructor */
function $c_ju_regex_IndicesBuilder$Parser(pattern0) {
  this.ly = null;
  this.cO = 0;
  this.Kd = null;
  this.ly = (pattern0 + ")");
  this.cO = 0;
  this.Kd = [null];
}
$p = $c_ju_regex_IndicesBuilder$Parser.prototype = new $h_O();
$p.constructor = $c_ju_regex_IndicesBuilder$Parser;
/** @constructor */
function $h_ju_regex_IndicesBuilder$Parser() {
}
$h_ju_regex_IndicesBuilder$Parser.prototype = $p;
$p.b6F = (function() {
  return (((this.Kd.length | 0) - 1) | 0);
});
var $d_ju_regex_IndicesBuilder$Parser = new $TypeData().i($c_ju_regex_IndicesBuilder$Parser, "java.util.regex.IndicesBuilder$Parser", ({
  tV: 1
}));
function $p_ju_regex_PatternCompiler__parseError__T__E($thiz, desc) {
  throw new $c_ju_regex_PatternSyntaxException(desc, $thiz.k7, $thiz.a4);
}
function $p_ju_regex_PatternCompiler__processLeadingEmbeddedFlags__V($thiz) {
  var m = $m_ju_regex_PatternCompiler$().atQ.exec($thiz.k7);
  if ((m !== null)) {
    var x = m[1];
    if ((x !== (void 0))) {
      var end = x.length;
      var i = 0;
      while ((i < end)) {
        var value = i;
        $thiz.fT = ($thiz.fT | $m_ju_regex_PatternCompiler$().aPA(x.charCodeAt(value)));
        i = ((1 + i) | 0);
      }
    }
    if (((256 & $thiz.fT) !== 0)) {
      $thiz.fT = (64 | $thiz.fT);
    }
    var x$1 = m[2];
    if ((x$1 !== (void 0))) {
      var end$1 = x$1.length;
      var i$1 = 0;
      while ((i$1 < end$1)) {
        var value$1 = i$1;
        $thiz.fT = ($thiz.fT & (~$m_ju_regex_PatternCompiler$().aPA(x$1.charCodeAt(value$1))));
        i$1 = ((1 + i$1) | 0);
      }
    }
    $thiz.a4 = (($thiz.a4 + m[0].length) | 0);
  }
}
function $p_ju_regex_PatternCompiler__literal__T__T($thiz, s) {
  var result = "";
  var len = s.length;
  var i = 0;
  while ((i !== len)) {
    var cp = $f_T__codePointAt__I__I(s, i);
    result = (("" + result) + $p_ju_regex_PatternCompiler__literal__I__T($thiz, cp));
    i = ((i + ((cp >= 65536) ? 2 : 1)) | 0);
  }
  return result;
}
function $p_ju_regex_PatternCompiler__literal__I__T($thiz, cp) {
  var s = $m_ju_regex_PatternCompiler$().J7(cp);
  if ((cp < 128)) {
    switch (cp) {
      case 94:
      case 36:
      case 92:
      case 46:
      case 42:
      case 43:
      case 63:
      case 40:
      case 41:
      case 91:
      case 93:
      case 123:
      case 125:
      case 124: {
        return ("\\" + s);
        break;
      }
      default: {
        return (((66 & $thiz.fT) !== 2) ? s : (((((cp - 65) | 0) >>> 0) <= 25) ? ((("[" + s) + $m_ju_regex_PatternCompiler$().J7(((32 + cp) | 0))) + "]") : (((((cp - 97) | 0) >>> 0) <= 25) ? ((("[" + $m_ju_regex_PatternCompiler$().J7(((cp - 32) | 0))) + s) + "]") : s)));
      }
    }
  } else {
    return ((((-1024) & cp) === 56320) ? (("(?:" + s) + ")") : s);
  }
}
function $p_ju_regex_PatternCompiler__skipComments__V($thiz) {
  var pattern = $thiz.k7;
  var len = pattern.length;
  while (true) {
    if (($thiz.a4 !== len)) {
      switch (pattern.charCodeAt($thiz.a4)) {
        case 32:
        case 9:
        case 10:
        case 11:
        case 12:
        case 13: {
          $thiz.a4 = ((1 + $thiz.a4) | 0);
          continue;
          break;
        }
        case 35: {
          $thiz.agL();
          continue;
          break;
        }
      }
    }
    break;
  }
}
function $p_ju_regex_PatternCompiler__compileRepeater__I__T__T($thiz, compiledGroupCountBeforeThisToken, compiledToken) {
  var pattern = $thiz.k7;
  var len = pattern.length;
  var startOfRepeater = $thiz.a4;
  var repeaterDispatchChar = ((startOfRepeater === len) ? 46 : pattern.charCodeAt(startOfRepeater));
  if (((((repeaterDispatchChar === 42) || (repeaterDispatchChar === 63)) || (repeaterDispatchChar === 43)) || (repeaterDispatchChar === 123))) {
    switch (compiledToken.charCodeAt(0)) {
      case 94:
      case 36: {
        var isTokenAnAssertion = true;
        break;
      }
      case 40: {
        var isTokenAnAssertion = ((compiledToken.charCodeAt(1) === 63) && (compiledToken.charCodeAt(2) !== 58));
        break;
      }
      case 92: {
        var c = compiledToken.charCodeAt(1);
        var isTokenAnAssertion = ((c === 66) || (c === 98));
        break;
      }
      default: {
        var isTokenAnAssertion = false;
      }
    }
    var wrappedToken = (isTokenAnAssertion ? (("(?:" + compiledToken) + ")") : compiledToken);
    var baseRepeater = $p_ju_regex_PatternCompiler__parseBaseRepeater__C__T($thiz, repeaterDispatchChar);
    if (($thiz.a4 !== len)) {
      switch (pattern.charCodeAt($thiz.a4)) {
        case 43: {
          $thiz.a4 = ((1 + $thiz.a4) | 0);
          return $p_ju_regex_PatternCompiler__buildPossessiveQuantifier__I__T__T__T($thiz, compiledGroupCountBeforeThisToken, wrappedToken, baseRepeater);
          break;
        }
        case 63: {
          $thiz.a4 = ((1 + $thiz.a4) | 0);
          return ((("" + wrappedToken) + baseRepeater) + "?");
          break;
        }
        default: {
          return (("" + wrappedToken) + baseRepeater);
        }
      }
    } else {
      return (("" + wrappedToken) + baseRepeater);
    }
  } else {
    return compiledToken;
  }
}
function $p_ju_regex_PatternCompiler__parseBaseRepeater__C__T($thiz, repeaterDispatchChar) {
  var pattern = $thiz.k7;
  var startOfRepeater = $thiz.a4;
  $thiz.a4 = ((1 + $thiz.a4) | 0);
  if ((repeaterDispatchChar === 123)) {
    var len = pattern.length;
    if ((($thiz.a4 === len) || (!((((pattern.charCodeAt($thiz.a4) - 48) | 0) >>> 0) <= 9)))) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal repetition");
    }
    while ((($thiz.a4 !== len) && ((((pattern.charCodeAt($thiz.a4) - 48) | 0) >>> 0) <= 9))) {
      $thiz.a4 = ((1 + $thiz.a4) | 0);
    }
    if (($thiz.a4 === len)) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal repetition");
    }
    if ((pattern.charCodeAt($thiz.a4) === 44)) {
      $thiz.a4 = ((1 + $thiz.a4) | 0);
      while ((($thiz.a4 !== len) && ((((pattern.charCodeAt($thiz.a4) - 48) | 0) >>> 0) <= 9))) {
        $thiz.a4 = ((1 + $thiz.a4) | 0);
      }
    }
    if ((($thiz.a4 === len) || (pattern.charCodeAt($thiz.a4) !== 125))) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal repetition");
    }
    $thiz.a4 = ((1 + $thiz.a4) | 0);
  }
  return pattern.substring(startOfRepeater, $thiz.a4);
}
function $p_ju_regex_PatternCompiler__buildPossessiveQuantifier__I__T__T__T($thiz, compiledGroupCountBeforeThisToken, compiledToken, baseRepeater) {
  var end = ($thiz.pM.length | 0);
  var i = 0;
  while ((i < end)) {
    var value = i;
    var mapped = ($thiz.pM[value] | 0);
    if ((mapped > compiledGroupCountBeforeThisToken)) {
      $thiz.pM[value] = ((1 + mapped) | 0);
    }
    i = ((1 + i) | 0);
  }
  var amendedToken = compiledToken.replace($m_ju_regex_PatternCompiler$().atR, ((arg1$2, arg2$2, arg3$2) => {
    var num = arg2$2.length;
    var t = ((num >>> 31) | 0);
    if (((((1 & ((num + t) | 0)) - t) | 0) === 0)) {
      return arg1$2;
    } else {
      var groupNumber = (parseInt(arg3$2, 10) | 0);
      return ((groupNumber > compiledGroupCountBeforeThisToken) ? (("" + arg2$2) + ((1 + groupNumber) | 0)) : arg1$2);
    }
  }));
  $thiz.pL = ((1 + $thiz.pL) | 0);
  var myGroupNumber = ((1 + compiledGroupCountBeforeThisToken) | 0);
  return ((((("(?:(?=(" + amendedToken) + baseRepeater) + "))\\") + myGroupNumber) + ")");
}
function $p_ju_regex_PatternCompiler__compileEscape__T($thiz) {
  var pattern = $thiz.k7;
  var len = pattern.length;
  if ((((1 + $thiz.a4) | 0) === len)) {
    $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\ at end of pattern");
  }
  $thiz.a4 = ((1 + $thiz.a4) | 0);
  var index = $thiz.a4;
  var dispatchChar = pattern.charCodeAt(index);
  switch (dispatchChar) {
    case 100:
    case 68:
    case 104:
    case 72:
    case 115:
    case 83:
    case 118:
    case 86:
    case 119:
    case 87:
    case 112:
    case 80: {
      var cls = $p_ju_regex_PatternCompiler__parsePredefinedCharacterClass__C__ju_regex_PatternCompiler$CompiledCharClass($thiz, dispatchChar);
      var x1$2 = cls.ZF;
      switch (x1$2) {
        case 0: {
          return (("\\p{" + cls.wv) + "}");
          break;
        }
        case 1: {
          return (("\\P{" + cls.wv) + "}");
          break;
        }
        case 2: {
          return (("[" + cls.wv) + "]");
          break;
        }
        case 3: {
          return $m_ju_regex_PatternCompiler$().a3Z(cls.wv);
          break;
        }
        default: {
          throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), x1$2);
        }
      }
      break;
    }
    case 98: {
      if ((pattern.substring($thiz.a4, ((4 + $thiz.a4) | 0)) === "b{g}")) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\b{g} is not supported");
      } else if (((320 & $thiz.fT) !== 0)) {
        $thiz.PB("\\b with UNICODE_CASE", "2018");
      } else {
        $thiz.a4 = ((1 + $thiz.a4) | 0);
        return "\\b";
      }
      break;
    }
    case 66: {
      if (((320 & $thiz.fT) !== 0)) {
        $thiz.PB("\\B with UNICODE_CASE", "2018");
      } else {
        $thiz.a4 = ((1 + $thiz.a4) | 0);
        return "\\B";
      }
      break;
    }
    case 65: {
      $thiz.a4 = ((1 + $thiz.a4) | 0);
      return "^";
      break;
    }
    case 71: {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\G in the middle of a pattern is not supported");
      break;
    }
    case 90: {
      $thiz.a4 = ((1 + $thiz.a4) | 0);
      return (("(?=" + (((1 & $thiz.fT) !== 0) ? "\n" : "(?:\r\n?|[\n\u0085\u2028\u2029])")) + "?$)");
      break;
    }
    case 122: {
      $thiz.a4 = ((1 + $thiz.a4) | 0);
      return "$";
      break;
    }
    case 82: {
      $thiz.a4 = ((1 + $thiz.a4) | 0);
      return "(?:\r\n|[\n-\r\u0085\u2028\u2029])";
      break;
    }
    case 88: {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\X is not supported");
      break;
    }
    case 49:
    case 50:
    case 51:
    case 52:
    case 53:
    case 54:
    case 55:
    case 56:
    case 57: {
      var start = $thiz.a4;
      var end = ((1 + start) | 0);
      while (true) {
        if (((end !== len) && ((((pattern.charCodeAt(end) - 48) | 0) >>> 0) <= 9))) {
          var s = pattern.substring(start, ((1 + end) | 0));
          var $x_1 = ((parseInt(s, 10) | 0) <= ((($thiz.pM.length | 0) - 1) | 0));
        } else {
          var $x_1 = false;
        }
        if ($x_1) {
          end = ((1 + end) | 0);
        } else {
          break;
        }
      }
      var groupString = pattern.substring(start, end);
      var groupNumber = (parseInt(groupString, 10) | 0);
      if ((groupNumber > ((($thiz.pM.length | 0) - 1) | 0))) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, (("numbered capturing group <" + groupNumber) + "> does not exist"));
      }
      var compiledGroupNumber = ($thiz.pM[groupNumber] | 0);
      $thiz.a4 = end;
      return (("(?:\\" + compiledGroupNumber) + ")");
      break;
    }
    case 107: {
      $thiz.a4 = ((1 + $thiz.a4) | 0);
      if ((($thiz.a4 === len) || (pattern.charCodeAt($thiz.a4) !== 60))) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\k is not followed by '<' for named capturing group");
      }
      $thiz.a4 = ((1 + $thiz.a4) | 0);
      var groupName = $p_ju_regex_PatternCompiler__parseGroupName__T($thiz);
      var dict = $thiz.Ra;
      if ((!(!(!$m_jl_Utils$Cache$().K8.call(dict, groupName))))) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, (("named capturing group <" + groupName) + "> does not exit"));
      }
      var groupNumber$2 = (dict[groupName] | 0);
      var compiledGroupNumber$2 = ($thiz.pM[groupNumber$2] | 0);
      $thiz.a4 = ((1 + $thiz.a4) | 0);
      return (("(?:\\" + compiledGroupNumber$2) + ")");
      break;
    }
    case 81: {
      var start$2 = ((1 + $thiz.a4) | 0);
      var end$2 = (pattern.indexOf("\\E", start$2) | 0);
      if ((end$2 < 0)) {
        $thiz.a4 = pattern.length;
        return $p_ju_regex_PatternCompiler__literal__T__T($thiz, pattern.substring(start$2));
      } else {
        $thiz.a4 = ((2 + end$2) | 0);
        return $p_ju_regex_PatternCompiler__literal__T__T($thiz, pattern.substring(start$2, end$2));
      }
      break;
    }
    default: {
      return $p_ju_regex_PatternCompiler__literal__I__T($thiz, $p_ju_regex_PatternCompiler__parseSingleCodePointEscape__I($thiz));
    }
  }
}
function $p_ju_regex_PatternCompiler__parseSingleCodePointEscape__I($thiz) {
  var pattern = $thiz.k7;
  var x1 = $f_T__codePointAt__I__I(pattern, $thiz.a4);
  switch (x1) {
    case 48: {
      return $p_ju_regex_PatternCompiler__parseOctalEscape__I($thiz);
      break;
    }
    case 120: {
      return $p_ju_regex_PatternCompiler__parseHexEscape__I($thiz);
      break;
    }
    case 117: {
      return $p_ju_regex_PatternCompiler__parseUnicodeHexEscape__I($thiz);
      break;
    }
    case 78: {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\N is not supported");
      break;
    }
    case 97: {
      $thiz.a4 = ((1 + $thiz.a4) | 0);
      return 7;
      break;
    }
    case 116: {
      $thiz.a4 = ((1 + $thiz.a4) | 0);
      return 9;
      break;
    }
    case 110: {
      $thiz.a4 = ((1 + $thiz.a4) | 0);
      return 10;
      break;
    }
    case 102: {
      $thiz.a4 = ((1 + $thiz.a4) | 0);
      return 12;
      break;
    }
    case 114: {
      $thiz.a4 = ((1 + $thiz.a4) | 0);
      return 13;
      break;
    }
    case 101: {
      $thiz.a4 = ((1 + $thiz.a4) | 0);
      return 27;
      break;
    }
    case 99: {
      $thiz.a4 = ((1 + $thiz.a4) | 0);
      if (($thiz.a4 === pattern.length)) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal control escape sequence");
      }
      var cp = $f_T__codePointAt__I__I(pattern, $thiz.a4);
      $thiz.a4 = (($thiz.a4 + ((cp >= 65536) ? 2 : 1)) | 0);
      return (64 ^ cp);
      break;
    }
    default: {
      if ((((((x1 - 65) | 0) >>> 0) <= 25) || ((((x1 - 97) | 0) >>> 0) <= 25))) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal/unsupported escape sequence");
      }
      $thiz.a4 = (($thiz.a4 + ((x1 >= 65536) ? 2 : 1)) | 0);
      return x1;
    }
  }
}
function $p_ju_regex_PatternCompiler__parseOctalEscape__I($thiz) {
  var pattern = $thiz.k7;
  var len = pattern.length;
  var start = $thiz.a4;
  var d1 = ((((1 + start) | 0) < len) ? ((pattern.charCodeAt(((1 + start) | 0)) - 48) | 0) : (-1));
  if (((d1 >>> 0) > 7)) {
    $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal octal escape sequence");
  }
  var d2 = ((((2 + start) | 0) < len) ? ((pattern.charCodeAt(((2 + start) | 0)) - 48) | 0) : (-1));
  if (((d2 >>> 0) > 7)) {
    $thiz.a4 = ((2 + $thiz.a4) | 0);
    return d1;
  } else if ((d1 > 3)) {
    $thiz.a4 = ((3 + $thiz.a4) | 0);
    return (((d1 << 3) + d2) | 0);
  } else {
    var d3 = ((((3 + start) | 0) < len) ? ((pattern.charCodeAt(((3 + start) | 0)) - 48) | 0) : (-1));
    if (((d3 >>> 0) > 7)) {
      $thiz.a4 = ((3 + $thiz.a4) | 0);
      return (((d1 << 3) + d2) | 0);
    } else {
      $thiz.a4 = ((4 + $thiz.a4) | 0);
      return (((((d1 << 6) + (d2 << 3)) | 0) + d3) | 0);
    }
  }
}
function $p_ju_regex_PatternCompiler__parseHexEscape__I($thiz) {
  var pattern = $thiz.k7;
  var len = pattern.length;
  var start = ((1 + $thiz.a4) | 0);
  if (((start !== len) && (pattern.charCodeAt(start) === 123))) {
    var innerStart = ((1 + start) | 0);
    var innerEnd = (pattern.indexOf("}", innerStart) | 0);
    if ((innerEnd < 0)) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed hexadecimal escape sequence");
    }
    var cp = $p_ju_regex_PatternCompiler__parseHexCodePoint__I__I__T__I($thiz, innerStart, innerEnd, "hexadecimal");
    $thiz.a4 = ((1 + innerEnd) | 0);
    return cp;
  } else {
    var cp$2 = $p_ju_regex_PatternCompiler__parseHexCodePoint__I__I__T__I($thiz, start, ((2 + start) | 0), "hexadecimal");
    $thiz.a4 = ((2 + start) | 0);
    return cp$2;
  }
}
function $p_ju_regex_PatternCompiler__parseUnicodeHexEscape__I($thiz) {
  var pattern = $thiz.k7;
  var start = ((1 + $thiz.a4) | 0);
  var end = ((4 + start) | 0);
  var codeUnit = $p_ju_regex_PatternCompiler__parseHexCodePoint__I__I__T__I($thiz, start, end, "Unicode");
  $thiz.a4 = end;
  var lowStart = ((2 + end) | 0);
  var lowEnd = ((4 + lowStart) | 0);
  if (((((-1024) & codeUnit) === 55296) && (pattern.substring(end, lowStart) === "\\u"))) {
    var low = $p_ju_regex_PatternCompiler__parseHexCodePoint__I__I__T__I($thiz, lowStart, lowEnd, "Unicode");
    if ((((-1024) & low) === 56320)) {
      $thiz.a4 = lowEnd;
      return ((((64 + (1023 & codeUnit)) | 0) << 10) | (1023 & low));
    } else {
      return codeUnit;
    }
  } else {
    return codeUnit;
  }
}
function $p_ju_regex_PatternCompiler__parseHexCodePoint__I__I__T__I($thiz, start, end, nameForError) {
  var pattern = $thiz.k7;
  var len = pattern.length;
  if (((end === start) || (end > len))) {
    $p_ju_regex_PatternCompiler__parseError__T__E($thiz, (("Illegal " + nameForError) + " escape sequence"));
  }
  var i = start;
  while ((i < end)) {
    var value = i;
    var c = pattern.charCodeAt(value);
    if ((!((((((c - 48) | 0) >>> 0) <= 9) || ((((c - 65) | 0) >>> 0) <= 5)) || ((((c - 97) | 0) >>> 0) <= 5)))) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, (("Illegal " + nameForError) + " escape sequence"));
    }
    i = ((1 + i) | 0);
  }
  if ((((end - start) | 0) > 6)) {
    var cp = 1114112;
  } else {
    var s = pattern.substring(start, end);
    var cp = (parseInt(s, 16) | 0);
  }
  if ((cp > 1114111)) {
    $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Hexadecimal codepoint is too big");
  }
  return cp;
}
function $p_ju_regex_PatternCompiler__parsePredefinedCharacterClass__C__ju_regex_PatternCompiler$CompiledCharClass($thiz, dispatchChar) {
  $thiz.a4 = ((1 + $thiz.a4) | 0);
  switch (dispatchChar) {
    case 100:
    case 68: {
      var positive = $m_ju_regex_PatternCompiler$().atK;
      break;
    }
    case 104:
    case 72: {
      var positive = $m_ju_regex_PatternCompiler$().atN;
      break;
    }
    case 115:
    case 83: {
      var positive = $m_ju_regex_PatternCompiler$().atL;
      break;
    }
    case 118:
    case 86: {
      var positive = $m_ju_regex_PatternCompiler$().atO;
      break;
    }
    case 119:
    case 87: {
      var positive = $m_ju_regex_PatternCompiler$().atM;
      break;
    }
    case 112:
    case 80: {
      var positive = $p_ju_regex_PatternCompiler__parsePCharacterClass__ju_regex_PatternCompiler$CompiledCharClass($thiz);
      break;
    }
    default: {
      var positive;
      throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), $bC(dispatchChar));
    }
  }
  return ((dispatchChar >= 97) ? positive : positive.b4M());
}
function $p_ju_regex_PatternCompiler__parsePCharacterClass__ju_regex_PatternCompiler$CompiledCharClass($thiz) {
  var pattern = $thiz.k7;
  var len = pattern.length;
  var start = $thiz.a4;
  if ((start === len)) {
    var property = "?";
  } else if ((pattern.charCodeAt(start) === 123)) {
    var innerStart = ((1 + start) | 0);
    var innerEnd = (pattern.indexOf("}", innerStart) | 0);
    if ((innerEnd < 0)) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed character family");
    }
    $thiz.a4 = innerEnd;
    var property = pattern.substring(innerStart, innerEnd);
  } else {
    var property = pattern.substring(start, ((1 + start) | 0));
  }
  var dict = $m_ju_regex_PatternCompiler$().a7H;
  if ((!(!(!$m_jl_Utils$Cache$().K8.call(dict, property))))) {
    $thiz.PB("Unicode character family", "2018");
  }
  var property2 = ((((66 & $thiz.fT) === 2) && ((property === "Lower") || (property === "Upper"))) ? "Alpha" : property);
  var dict$1 = $m_ju_regex_PatternCompiler$().a7H;
  var result = dict$1[property2];
  $thiz.a4 = ((1 + $thiz.a4) | 0);
  return result;
}
function $p_ju_regex_PatternCompiler__compileCharacterClass__T($thiz) {
  var pattern = $thiz.k7;
  var len = pattern.length;
  $thiz.a4 = ((1 + $thiz.a4) | 0);
  var isNegated = (($thiz.a4 !== len) && (pattern.charCodeAt($thiz.a4) === 94));
  if (isNegated) {
    $thiz.a4 = ((1 + $thiz.a4) | 0);
  }
  var builder = new $c_ju_regex_PatternCompiler$CharacterClassBuilder(((66 & $thiz.fT) === 2), isNegated);
  while (($thiz.a4 !== len)) {
    var x1 = $f_T__codePointAt__I__I(pattern, $thiz.a4);
    matchResult: {
      switch (x1) {
        case 93: {
          $thiz.a4 = ((1 + $thiz.a4) | 0);
          return builder.b1n();
          break;
        }
        case 38: {
          $thiz.a4 = ((1 + $thiz.a4) | 0);
          if ((($thiz.a4 !== len) && (pattern.charCodeAt($thiz.a4) === 38))) {
            $thiz.a4 = ((1 + $thiz.a4) | 0);
            builder.b9m();
            break matchResult;
          } else {
            $p_ju_regex_PatternCompiler__processRangeOrSingleCodePoint$1__I__I__T__ju_regex_PatternCompiler$CharacterClassBuilder__V($thiz, 38, len, pattern, builder);
            break matchResult;
          }
          break;
        }
        case 91: {
          $p_ju_regex_PatternCompiler$CharacterClassBuilder__addAlternative__T__V(builder, $p_ju_regex_PatternCompiler__compileCharacterClass__T($thiz));
          break matchResult;
          break;
        }
        case 92: {
          $thiz.a4 = ((1 + $thiz.a4) | 0);
          if (($thiz.a4 === len)) {
            $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal escape sequence");
          }
          var index$2 = $thiz.a4;
          var c2 = pattern.charCodeAt(index$2);
          switch (c2) {
            case 100:
            case 68:
            case 104:
            case 72:
            case 115:
            case 83:
            case 118:
            case 86:
            case 119:
            case 87:
            case 112:
            case 80: {
              builder.aWC($p_ju_regex_PatternCompiler__parsePredefinedCharacterClass__C__ju_regex_PatternCompiler$CompiledCharClass($thiz, c2));
              break matchResult;
              break;
            }
            case 81: {
              $thiz.a4 = ((1 + $thiz.a4) | 0);
              var fromIndex = $thiz.a4;
              var end = (pattern.indexOf("\\E", fromIndex) | 0);
              if ((end < 0)) {
                $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed character class");
              }
              builder.aWE(pattern, $thiz.a4, end);
              $thiz.a4 = ((2 + end) | 0);
              break matchResult;
              break;
            }
            default: {
              $p_ju_regex_PatternCompiler__processRangeOrSingleCodePoint$1__I__I__T__ju_regex_PatternCompiler$CharacterClassBuilder__V($thiz, $p_ju_regex_PatternCompiler__parseSingleCodePointEscape__I($thiz), len, pattern, builder);
              break matchResult;
            }
          }
          break;
        }
        case 32:
        case 9:
        case 10:
        case 11:
        case 12:
        case 13: {
          if (((4 & $thiz.fT) !== 0)) {
            $thiz.a4 = ((1 + $thiz.a4) | 0);
            break matchResult;
          }
          break;
        }
        case 35: {
          if (((4 & $thiz.fT) !== 0)) {
            $thiz.agL();
            break matchResult;
          }
          break;
        }
      }
      $thiz.a4 = (($thiz.a4 + ((x1 >= 65536) ? 2 : 1)) | 0);
      $p_ju_regex_PatternCompiler__processRangeOrSingleCodePoint$1__I__I__T__ju_regex_PatternCompiler$CharacterClassBuilder__V($thiz, x1, len, pattern, builder);
    }
  }
  $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed character class");
}
function $p_ju_regex_PatternCompiler__compileGroup__T($thiz) {
  var pattern = $thiz.k7;
  var len = pattern.length;
  var start = $thiz.a4;
  if (((((1 + start) | 0) === len) || (pattern.charCodeAt(((1 + start) | 0)) !== 63))) {
    $thiz.a4 = ((1 + start) | 0);
    $thiz.pL = ((1 + $thiz.pL) | 0);
    $thiz.pM.push($thiz.pL);
    return (("(" + $thiz.Xn(true)) + ")");
  } else {
    if ((((2 + start) | 0) === len)) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed group");
    }
    var index$1 = ((2 + start) | 0);
    var c1 = pattern.charCodeAt(index$1);
    if ((((c1 === 58) || (c1 === 61)) || (c1 === 33))) {
      $thiz.a4 = ((3 + start) | 0);
      return ((("" + pattern.substring(start, ((3 + start) | 0))) + $thiz.Xn(true)) + ")");
    } else if ((c1 === 60)) {
      if ((((3 + start) | 0) === len)) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed group");
      }
      var index$2 = ((3 + start) | 0);
      var c2 = pattern.charCodeAt(index$2);
      if ((((((c2 - 65) | 0) >>> 0) <= 25) || ((((c2 - 97) | 0) >>> 0) <= 25))) {
        $thiz.a4 = ((3 + start) | 0);
        var name = $p_ju_regex_PatternCompiler__parseGroupName__T($thiz);
        var dict = $thiz.Ra;
        if ((!(!$m_jl_Utils$Cache$().K8.call(dict, name)))) {
          $p_ju_regex_PatternCompiler__parseError__T__E($thiz, (("named capturing group <" + name) + "> is already defined"));
        }
        $thiz.pL = ((1 + $thiz.pL) | 0);
        $thiz.pM.push($thiz.pL);
        var dict$1 = $thiz.Ra;
        var value = ((($thiz.pM.length | 0) - 1) | 0);
        dict$1[name] = value;
        $thiz.a4 = ((1 + $thiz.a4) | 0);
        return (("(" + $thiz.Xn(true)) + ")");
      } else {
        if (((c2 !== 33) && (c2 !== 61))) {
          $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unknown look-behind group");
        }
        $thiz.PB("Look-behind group", "2018");
      }
    } else if ((c1 === 62)) {
      $thiz.a4 = ((3 + start) | 0);
      $thiz.pL = ((1 + $thiz.pL) | 0);
      var groupNumber = $thiz.pL;
      return (((("(?:(?=(" + $thiz.Xn(true)) + "))\\") + groupNumber) + ")");
    } else {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Embedded flag expression in the middle of a pattern is not supported");
    }
  }
}
function $p_ju_regex_PatternCompiler__parseGroupName__T($thiz) {
  var pattern = $thiz.k7;
  var len = pattern.length;
  var start = $thiz.a4;
  while (true) {
    if (($thiz.a4 !== len)) {
      var index = $thiz.a4;
      var c = pattern.charCodeAt(index);
      var $x_1 = ((((((c - 65) | 0) >>> 0) <= 25) || ((((c - 97) | 0) >>> 0) <= 25)) || ((((c - 48) | 0) >>> 0) <= 9));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $thiz.a4 = ((1 + $thiz.a4) | 0);
    } else {
      break;
    }
  }
  if ((($thiz.a4 === len) || (pattern.charCodeAt($thiz.a4) !== 62))) {
    $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "named capturing group is missing trailing '>'");
  }
  return pattern.substring(start, $thiz.a4);
}
function $p_ju_regex_PatternCompiler__processRangeOrSingleCodePoint$1__I__I__T__ju_regex_PatternCompiler$CharacterClassBuilder__V($thiz, startCodePoint, len$2, pattern$3, builder$1) {
  if (((4 & $thiz.fT) !== 0)) {
    $p_ju_regex_PatternCompiler__skipComments__V($thiz);
  }
  if ((($thiz.a4 !== len$2) && (pattern$3.charCodeAt($thiz.a4) === 45))) {
    $thiz.a4 = ((1 + $thiz.a4) | 0);
    if (((4 & $thiz.fT) !== 0)) {
      $p_ju_regex_PatternCompiler__skipComments__V($thiz);
    }
    if (($thiz.a4 === len$2)) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed character class");
    }
    var cpEnd = $f_T__codePointAt__I__I(pattern$3, $thiz.a4);
    if (((cpEnd === 91) || (cpEnd === 93))) {
      builder$1.a2G(startCodePoint);
      builder$1.a2G(45);
    } else {
      $thiz.a4 = (($thiz.a4 + ((cpEnd >= 65536) ? 2 : 1)) | 0);
      var endCodePoint = ((cpEnd === 92) ? $p_ju_regex_PatternCompiler__parseSingleCodePointEscape__I($thiz) : cpEnd);
      if ((endCodePoint < startCodePoint)) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal character range");
      }
      builder$1.aWD(startCodePoint, endCodePoint);
    }
  } else {
    builder$1.a2G(startCodePoint);
  }
}
/** @constructor */
function $c_ju_regex_PatternCompiler(pattern, flags) {
  this.k7 = null;
  this.fT = 0;
  this.ZE = false;
  this.a4 = 0;
  this.pL = 0;
  this.pM = null;
  this.Ra = null;
  this.k7 = pattern;
  this.fT = flags;
  this.ZE = false;
  this.a4 = 0;
  this.pL = 0;
  this.pM = [0];
  this.Ra = ({});
}
$p = $c_ju_regex_PatternCompiler.prototype = new $h_O();
$p.constructor = $c_ju_regex_PatternCompiler;
/** @constructor */
function $h_ju_regex_PatternCompiler() {
}
$h_ju_regex_PatternCompiler.prototype = $p;
$p.aYQ = (function() {
  if (((256 & this.fT) !== 0)) {
    this.fT = (64 | this.fT);
  }
  var isLiteral = ((16 & this.fT) !== 0);
  if ((!isLiteral)) {
    $p_ju_regex_PatternCompiler__processLeadingEmbeddedFlags__V(this);
  }
  if (((128 & this.fT) !== 0)) {
    $p_ju_regex_PatternCompiler__parseError__T__E(this, "CANON_EQ is not supported");
  }
  if (((8 & this.fT) !== 0)) {
    this.PB("MULTILINE", "2018");
  }
  if (((256 & this.fT) !== 0)) {
    this.PB("UNICODE_CHARACTER_CLASS", "2018");
  }
  if (isLiteral) {
    var jsPattern = $p_ju_regex_PatternCompiler__literal__T__T(this, this.k7);
  } else {
    if ((this.k7.substring(this.a4, ((2 + this.a4) | 0)) === "\\G")) {
      this.ZE = true;
      this.a4 = ((2 + this.a4) | 0);
    }
    var jsPattern = this.Xn(false);
  }
  var baseJSFlags = ($m_ju_regex_PatternCompiler$().a7G ? "us" : "u");
  var jsFlags = (((66 & this.fT) === 66) ? (baseJSFlags + "i") : baseJSFlags);
  return new $c_ju_regex_Pattern(this.k7, this.fT, jsPattern, jsFlags, this.ZE, (((this.pM.length | 0) - 1) | 0), this.pM, this.Ra);
});
$p.PB = (function(purpose, es) {
  $p_ju_regex_PatternCompiler__parseError__T__E(this, (((((((purpose + " is not supported because it requires RegExp features of ECMAScript ") + es) + ".\n") + ((("If you only target environments with ES" + es) + "+, you can enable ES") + es)) + " features with\n") + ("  scalaJSLinkerConfig ~= { _.withESFeatures(_.withESVersion(ESVersion.ES" + es)) + ")) }\nor an equivalent configuration depending on your build tool."));
});
$p.Xn = (function(insideGroup) {
  var pattern = this.k7;
  var len = pattern.length;
  var result = "";
  while ((this.a4 !== len)) {
    var dispatchCP = $f_T__codePointAt__I__I(pattern, this.a4);
    matchResult: {
      switch (dispatchCP) {
        case 41: {
          if ((!insideGroup)) {
            $p_ju_regex_PatternCompiler__parseError__T__E(this, "Unmatched closing ')'");
          }
          this.a4 = ((1 + this.a4) | 0);
          return result;
          break;
        }
        case 124: {
          if ((this.ZE && (!insideGroup))) {
            $p_ju_regex_PatternCompiler__parseError__T__E(this, "\\G is not supported when there is an alternative at the top level");
          }
          this.a4 = ((1 + this.a4) | 0);
          result = (result + "|");
          break matchResult;
          break;
        }
        case 32:
        case 9:
        case 10:
        case 11:
        case 12:
        case 13: {
          if (((4 & this.fT) !== 0)) {
            this.a4 = ((1 + this.a4) | 0);
            break matchResult;
          }
          break;
        }
        case 35: {
          if (((4 & this.fT) !== 0)) {
            this.agL();
            break matchResult;
          }
          break;
        }
        case 63:
        case 42:
        case 43:
        case 123: {
          $p_ju_regex_PatternCompiler__parseError__T__E(this, (("Dangling meta character '" + $m_ju_regex_PatternCompiler$().J7(dispatchCP)) + "'"));
          break;
        }
      }
      var compiledGroupCountBeforeThisToken = this.pL;
      switch (dispatchCP) {
        case 92: {
          var compiledToken = $p_ju_regex_PatternCompiler__compileEscape__T(this);
          break;
        }
        case 91: {
          var compiledToken = $p_ju_regex_PatternCompiler__compileCharacterClass__T(this);
          break;
        }
        case 40: {
          var compiledToken = $p_ju_regex_PatternCompiler__compileGroup__T(this);
          break;
        }
        case 94: {
          this.a4 = ((1 + this.a4) | 0);
          var compiledToken = "^";
          break;
        }
        case 36: {
          this.a4 = ((1 + this.a4) | 0);
          var compiledToken = "$";
          break;
        }
        case 46: {
          this.a4 = ((1 + this.a4) | 0);
          var rejected = (((32 & this.fT) !== 0) ? "" : (((1 & this.fT) !== 0) ? "\n" : "\n\r\u0085\u2028\u2029"));
          var compiledToken = $m_ju_regex_PatternCompiler$().a3Z(rejected);
          break;
        }
        default: {
          this.a4 = ((this.a4 + ((dispatchCP >= 65536) ? 2 : 1)) | 0);
          var compiledToken = $p_ju_regex_PatternCompiler__literal__I__T(this, dispatchCP);
        }
      }
      result = (("" + result) + $p_ju_regex_PatternCompiler__compileRepeater__I__T__T(this, compiledGroupCountBeforeThisToken, compiledToken));
    }
  }
  if (insideGroup) {
    $p_ju_regex_PatternCompiler__parseError__T__E(this, "Unclosed group");
  }
  return result;
});
$p.agL = (function() {
  var pattern = this.k7;
  var len = pattern.length;
  while (true) {
    if ((this.a4 !== len)) {
      var index = this.a4;
      var c = pattern.charCodeAt(index);
      var $x_1 = (!(((((c === 10) || (c === 13)) || (c === 133)) || (c === 8232)) || (c === 8233)));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      this.a4 = ((1 + this.a4) | 0);
    } else {
      break;
    }
  }
});
var $d_ju_regex_PatternCompiler = new $TypeData().i($c_ju_regex_PatternCompiler, "java.util.regex.PatternCompiler", ({
  u2: 1
}));
function $p_ju_regex_PatternCompiler$__featureTest__T__Z($thiz, flags) {
  try {
    new RegExp("", flags);
    return true;
  } catch (e) {
    return false;
  }
}
/** @constructor */
function $c_ju_regex_PatternCompiler$() {
  this.atQ = null;
  this.atR = null;
  this.aTL = false;
  this.aTK = false;
  this.a7G = false;
  this.atP = false;
  this.atK = null;
  this.aTH = null;
  this.atN = null;
  this.atL = null;
  this.aTI = null;
  this.atO = null;
  this.atM = null;
  this.aTJ = null;
  this.a7H = null;
  this.aTM = null;
  $n_ju_regex_PatternCompiler$ = this;
  this.atQ = new RegExp("^\\(\\?([idmsuxU]*)(?:-([idmsuxU]*))?\\)");
  this.atR = new RegExp("(\\\\+)(\\d+)", "g");
  this.aTL = true;
  this.aTK = true;
  this.a7G = $p_ju_regex_PatternCompiler$__featureTest__T__Z(this, "us");
  this.atP = $p_ju_regex_PatternCompiler$__featureTest__T__Z(this, "d");
  this.atK = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "0-9");
  this.aTH = new $c_ju_regex_PatternCompiler$CompiledCharClass(0, "Nd");
  this.atN = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\t \u00a0\u1680\u180e\u2000-\u200a\u202f\u205f\u3000");
  this.atL = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\t-\r ");
  this.aTI = new $c_ju_regex_PatternCompiler$CompiledCharClass(0, "White_Space");
  this.atO = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\n-\r\u0085\u2028\u2029");
  this.atM = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "a-zA-Z_0-9");
  this.aTJ = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\\p{Alphabetic}\\p{Mn}\\p{Me}\\p{Mc}\\p{Nd}\\p{Pc}\\p{Join_Control}");
  var r = ({});
  var value = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "a-z");
  r.Lower = value;
  var value$1 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "A-Z");
  r.Upper = value$1;
  var value$2 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\u0000-\u007f");
  r.ASCII = value$2;
  var value$3 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "A-Za-z");
  r.Alpha = value$3;
  var value$4 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "0-9");
  r.Digit = value$4;
  var value$5 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "0-9A-Za-z");
  r.Alnum = value$5;
  var value$6 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "!-/:-@[-`{-~");
  r.Punct = value$6;
  var value$7 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "!-~");
  r.Graph = value$7;
  var value$8 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, " -~");
  r.Print = value$8;
  var value$9 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\t ");
  r.Blank = value$9;
  var value$10 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\u0000-\u001f\u007f");
  r.Cntrl = value$10;
  var value$11 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "0-9A-Fa-f");
  r.XDigit = value$11;
  var value$12 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\t-\r ");
  r.Space = value$12;
  this.a7H = r;
  this.aTM = new RegExp("(?:^|_)[a-z]", "g");
}
$p = $c_ju_regex_PatternCompiler$.prototype = new $h_O();
$p.constructor = $c_ju_regex_PatternCompiler$;
/** @constructor */
function $h_ju_regex_PatternCompiler$() {
}
$h_ju_regex_PatternCompiler$.prototype = $p;
$p.Wy = (function(regex, flags) {
  return new $c_ju_regex_PatternCompiler(regex, flags).aYQ();
});
$p.aPA = (function(c) {
  switch (c) {
    case 105: {
      return 2;
      break;
    }
    case 100: {
      return 1;
      break;
    }
    case 109: {
      return 8;
      break;
    }
    case 115: {
      return 32;
      break;
    }
    case 117: {
      return 64;
      break;
    }
    case 120: {
      return 4;
      break;
    }
    case 85: {
      return 256;
      break;
    }
    default: {
      throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "bad in-pattern flag");
    }
  }
});
$p.a3Z = (function(characters) {
  return ((characters !== "") ? (("[^" + characters) + "]") : ($m_ju_regex_PatternCompiler$().a7G ? "." : "[\\d\\D]"));
});
$p.J7 = (function(codePoint) {
  return String.fromCodePoint(codePoint);
});
var $d_ju_regex_PatternCompiler$ = new $TypeData().i($c_ju_regex_PatternCompiler$, "java.util.regex.PatternCompiler$", ({
  u3: 1
}));
var $n_ju_regex_PatternCompiler$;
function $m_ju_regex_PatternCompiler$() {
  if ((!$n_ju_regex_PatternCompiler$)) {
    $n_ju_regex_PatternCompiler$ = new $c_ju_regex_PatternCompiler$();
  }
  return $n_ju_regex_PatternCompiler$;
}
function $p_ju_regex_PatternCompiler$CharacterClassBuilder__addAlternative__T__V($thiz, alt) {
  if (($thiz.ro === "")) {
    $thiz.ro = alt;
  } else {
    $thiz.ro = (($thiz.ro + "|") + alt);
  }
}
function $p_ju_regex_PatternCompiler$CharacterClassBuilder__conjunctResult__T($thiz) {
  if ($thiz.a7J) {
    var negThisSegment = $m_ju_regex_PatternCompiler$().a3Z($thiz.gD);
    return (($thiz.ro === "") ? negThisSegment : (((("(?:(?!" + $thiz.ro) + ")") + negThisSegment) + ")"));
  } else {
    return (($thiz.gD === "") ? (($thiz.ro === "") ? "[^\\d\\D]" : (("(?:" + $thiz.ro) + ")")) : (($thiz.ro === "") ? (("[" + $thiz.gD) + "]") : (((("(?:" + $thiz.ro) + "|[") + $thiz.gD) + "])")));
  }
}
function $p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T($thiz, codePoint) {
  var s = $m_ju_regex_PatternCompiler$().J7(codePoint);
  return (((((((codePoint - 92) | 0) >>> 0) <= 1) || (codePoint === 45)) || (codePoint === 94)) ? ("\\" + s) : s);
}
/** @constructor */
function $c_ju_regex_PatternCompiler$CharacterClassBuilder(asciiCaseInsensitive, isNegated) {
  this.a7I = false;
  this.a7J = false;
  this.Rb = null;
  this.ro = null;
  this.gD = null;
  this.a7I = asciiCaseInsensitive;
  this.a7J = isNegated;
  this.Rb = "";
  this.ro = "";
  this.gD = "";
}
$p = $c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype = new $h_O();
$p.constructor = $c_ju_regex_PatternCompiler$CharacterClassBuilder;
/** @constructor */
function $h_ju_regex_PatternCompiler$CharacterClassBuilder() {
}
$h_ju_regex_PatternCompiler$CharacterClassBuilder.prototype = $p;
$p.b1n = (function() {
  var conjunct = $p_ju_regex_PatternCompiler$CharacterClassBuilder__conjunctResult__T(this);
  return ((this.Rb === "") ? conjunct : ((("(?:" + this.Rb) + conjunct) + ")"));
});
$p.b9m = (function() {
  var conjunct = $p_ju_regex_PatternCompiler$CharacterClassBuilder__conjunctResult__T(this);
  this.Rb = (this.Rb + (this.a7J ? (conjunct + "|") : (("(?=" + conjunct) + ")")));
  this.ro = "";
  this.gD = "";
});
$p.aWC = (function(cls) {
  var x1 = cls.ZF;
  switch (x1) {
    case 0: {
      this.gD = ((this.gD + ("\\p{" + cls.wv)) + "}");
      break;
    }
    case 1: {
      this.gD = ((this.gD + ("\\P{" + cls.wv)) + "}");
      break;
    }
    case 2: {
      this.gD = (("" + this.gD) + cls.wv);
      break;
    }
    case 3: {
      $p_ju_regex_PatternCompiler$CharacterClassBuilder__addAlternative__T__V(this, $m_ju_regex_PatternCompiler$().a3Z(cls.wv));
      break;
    }
    default: {
      throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), x1);
    }
  }
});
$p.aWE = (function(str, start, end) {
  var i = start;
  while ((i !== end)) {
    var codePoint = $f_T__codePointAt__I__I(str, i);
    this.a2G(codePoint);
    i = ((i + ((codePoint >= 65536) ? 2 : 1)) | 0);
  }
});
$p.a2G = (function(codePoint) {
  var s = $p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, codePoint);
  if ((((-1024) & codePoint) === 56320)) {
    this.gD = (("" + s) + this.gD);
  } else {
    this.gD = (("" + this.gD) + s);
  }
  if (this.a7I) {
    if (((((codePoint - 65) | 0) >>> 0) <= 25)) {
      this.gD = (("" + this.gD) + $m_ju_regex_PatternCompiler$().J7(((32 + codePoint) | 0)));
    } else if (((((codePoint - 97) | 0) >>> 0) <= 25)) {
      this.gD = (("" + this.gD) + $m_ju_regex_PatternCompiler$().J7(((codePoint - 32) | 0)));
    }
  }
});
$p.aWD = (function(startCodePoint, endCodePoint) {
  var s = (($p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, startCodePoint) + "-") + $p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, endCodePoint));
  if ((((-1024) & startCodePoint) === 56320)) {
    this.gD = (s + this.gD);
  } else {
    this.gD = (this.gD + s);
  }
  if (this.a7I) {
    var start = ((startCodePoint > 65) ? startCodePoint : 65);
    var end = ((endCodePoint < 90) ? endCodePoint : 90);
    if ((start <= end)) {
      var $x_1 = this.gD;
      var start$1 = ((32 + start) | 0);
      var end$1 = ((32 + end) | 0);
      this.gD = ($x_1 + (($p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, start$1) + "-") + $p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, end$1)));
    }
    var start$2 = ((startCodePoint > 97) ? startCodePoint : 97);
    var end$2 = ((endCodePoint < 122) ? endCodePoint : 122);
    if ((start$2 <= end$2)) {
      var $x_2 = this.gD;
      var start$3 = ((start$2 - 32) | 0);
      var end$3 = ((end$2 - 32) | 0);
      this.gD = ($x_2 + (($p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, start$3) + "-") + $p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, end$3)));
    }
  }
});
var $d_ju_regex_PatternCompiler$CharacterClassBuilder = new $TypeData().i($c_ju_regex_PatternCompiler$CharacterClassBuilder, "java.util.regex.PatternCompiler$CharacterClassBuilder", ({
  u4: 1
}));
function $p_ju_regex_PatternCompiler$CompiledCharClass__negated$lzycompute__ju_regex_PatternCompiler$CompiledCharClass($thiz) {
  if ((!$thiz.a7K)) {
    $thiz.a7L = new $c_ju_regex_PatternCompiler$CompiledCharClass((1 ^ $thiz.ZF), $thiz.wv);
    $thiz.a7K = true;
  }
  return $thiz.a7L;
}
/** @constructor */
function $c_ju_regex_PatternCompiler$CompiledCharClass(kind, data) {
  this.a7L = null;
  this.ZF = 0;
  this.wv = null;
  this.a7K = false;
  this.ZF = kind;
  this.wv = data;
}
$p = $c_ju_regex_PatternCompiler$CompiledCharClass.prototype = new $h_O();
$p.constructor = $c_ju_regex_PatternCompiler$CompiledCharClass;
/** @constructor */
function $h_ju_regex_PatternCompiler$CompiledCharClass() {
}
$h_ju_regex_PatternCompiler$CompiledCharClass.prototype = $p;
$p.b4M = (function() {
  return ((!this.a7K) ? $p_ju_regex_PatternCompiler$CompiledCharClass__negated$lzycompute__ju_regex_PatternCompiler$CompiledCharClass(this) : this.a7L);
});
var $d_ju_regex_PatternCompiler$CompiledCharClass = new $TypeData().i($c_ju_regex_PatternCompiler$CompiledCharClass, "java.util.regex.PatternCompiler$CompiledCharClass", ({
  u5: 1
}));
function $p_Lorg_jpablo_graphexplorer_graphviz_EngineRouting$__blankComments__T__T($thiz, s) {
  var b = $ct_scm_StringBuilder__T__(new $c_scm_StringBuilder(), s);
  var i = 0;
  var inStr = false;
  var atLineStart = true;
  while ((i < s.length)) {
    var index = i;
    var c = s.charCodeAt(index);
    if (inStr) {
      if (((c === 92) && (((1 + i) | 0) < s.length))) {
        i = ((2 + i) | 0);
      } else {
        if ((c === 34)) {
          inStr = false;
        }
        i = ((1 + i) | 0);
      }
    } else if ((c === 34)) {
      inStr = true;
      atLineStart = false;
      i = ((1 + i) | 0);
    } else if ((((c === 47) && (((1 + i) | 0) < s.length)) && (s.charCodeAt(((1 + i) | 0)) === 47))) {
      while (((i < s.length) && (s.charCodeAt(i) !== 10))) {
        b.Y2(i, 32);
        i = ((1 + i) | 0);
      }
    } else if ((((c === 47) && (((1 + i) | 0) < s.length)) && (s.charCodeAt(((1 + i) | 0)) === 42))) {
      var closed = false;
      while (((i < s.length) && (!closed))) {
        if ((((s.charCodeAt(i) === 42) && (((1 + i) | 0) < s.length)) && (s.charCodeAt(((1 + i) | 0)) === 47))) {
          b.Y2(i, 32);
          b.Y2(((1 + i) | 0), 32);
          i = ((2 + i) | 0);
          closed = true;
        } else {
          b.Y2(i, 32);
          i = ((1 + i) | 0);
        }
      }
    } else if (((c === 35) && atLineStart)) {
      while (((i < s.length) && (s.charCodeAt(i) !== 10))) {
        b.Y2(i, 32);
        i = ((1 + i) | 0);
      }
    } else {
      if ((c === 10)) {
        atLineStart = true;
      } else if ((!$m_jl_UnicodeData$().E7(c))) {
        atLineStart = false;
      }
      i = ((1 + i) | 0);
    }
  }
  return b.bP.ah;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_EngineRouting$__insideString$1__sci_Vector__I__Z($thiz, strSpans$1, i) {
  var res = false;
  var it = strSpans$1.o();
  while (((!res) && it.p())) {
    var x0 = it.q();
    var s = (x0.g() | 0);
    var e = (x0.h() | 0);
    res = ((i > s) && (i < e));
  }
  return res;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_EngineRouting$() {
  this.atV = null;
  this.atW = null;
  $n_Lorg_jpablo_graphexplorer_graphviz_EngineRouting$ = this;
  this.atV = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "(?i)\\blayout\\b\\s*=\\s*\"?\\s*([A-Za-z]+)", $m_sci_Nil$());
  this.atW = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "(?s)\"(?:[^\"\\\\]|\\\\.)*\"", $m_sci_Nil$());
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_EngineRouting$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_EngineRouting$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_EngineRouting$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_EngineRouting$.prototype = $p;
$p.baX = (function(dot) {
  var t = $p_Lorg_jpablo_graphexplorer_graphviz_EngineRouting$__blankComments__T__T(this, dot);
  var this$3 = new $c_sc_Iterator$$anon$9(this.atW.afQ(t), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((m) => new $c_T2(m.VA, m.HL))));
  var strSpans = $m_sci_Vector$().X(this$3);
  var this$4 = this.atV.afQ(t);
  _return: {
    while (this$4.p()) {
      var a = this$4.q();
      if ((!$p_Lorg_jpablo_graphexplorer_graphviz_EngineRouting$__insideString$1__sci_Vector__I__Z(this, strSpans, a.VA))) {
        var this$5 = new $c_s_Some(a);
        break _return;
      }
    }
    var this$5 = $m_s_None$();
  }
  if (this$5.c()) {
    var x1 = $m_s_None$();
  } else {
    var x0 = this$5.d();
    var this$6 = $f_s_util_matching_Regex$MatchData__group__I__T(x0, 1);
    var x1 = new $c_s_Some(this$6.toLowerCase());
  }
  if ((x1 instanceof $c_s_Some)) {
    return (x1.J === "dot");
  }
  if (($m_s_None$() === x1)) {
    return true;
  }
  throw new $c_s_MatchError(x1);
});
var $d_Lorg_jpablo_graphexplorer_graphviz_EngineRouting$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_EngineRouting$, "org.jpablo.graphexplorer.graphviz.EngineRouting$", ({
  u7: 1
}));
var $n_Lorg_jpablo_graphexplorer_graphviz_EngineRouting$;
function $m_Lorg_jpablo_graphexplorer_graphviz_EngineRouting$() {
  if ((!$n_Lorg_jpablo_graphexplorer_graphviz_EngineRouting$)) {
    $n_Lorg_jpablo_graphexplorer_graphviz_EngineRouting$ = new $c_Lorg_jpablo_graphexplorer_graphviz_EngineRouting$();
  }
  return $n_Lorg_jpablo_graphexplorer_graphviz_EngineRouting$;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_Graphviz$__failure__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_Graphviz$MultipleRenderResult($thiz, errors) {
  return new $c_Lorg_jpablo_graphexplorer_graphviz_Graphviz$MultipleRenderResult($s_Lorg_jpablo_graphexplorer_graphviz_RenderStatus$__Failure__Lorg_jpablo_graphexplorer_graphviz_RenderStatus().Re, $m_sci_Map$EmptyMap$(), errors);
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_Graphviz$() {
  $n_Lorg_jpablo_graphexplorer_graphviz_Graphviz$ = this;
  $m_Lorg_jpablo_graphexplorer_graphviz_Format$();
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_Graphviz$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_Graphviz$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_Graphviz$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_Graphviz$.prototype = $p;
$p.b5n = (function(f, g) {
  var x = $s_Lorg_jpablo_graphexplorer_graphviz_Format$__DotJson__Lorg_jpablo_graphexplorer_graphviz_Format();
  if (((x === null) ? (f === null) : (x === f))) {
    return $m_Lorg_jpablo_graphexplorer_graphviz_output_Output$().b07(g);
  }
  var x$3 = $s_Lorg_jpablo_graphexplorer_graphviz_Format$__Json0__Lorg_jpablo_graphexplorer_graphviz_Format();
  if (((x$3 === null) ? (f === null) : (x$3 === f))) {
    return $m_Lorg_jpablo_graphexplorer_graphviz_output_Output$().b3S(g);
  }
  var x$5 = $s_Lorg_jpablo_graphexplorer_graphviz_Format$__Svg__Lorg_jpablo_graphexplorer_graphviz_Format();
  if (((x$5 === null) ? (f === null) : (x$5 === f))) {
    return $m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$().b9y(g);
  }
  throw new $c_s_MatchError(f);
});
$p.aRF = (function(dot, formats) {
  var x31 = $m_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$().PH(dot);
  if ((x31 instanceof $c_s_util_Left)) {
    var err = x31.lP;
    return $p_Lorg_jpablo_graphexplorer_graphviz_Graphviz$__failure__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_Graphviz$MultipleRenderResult(this, $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_Graphviz$RenderError.r().C)([new $c_Lorg_jpablo_graphexplorer_graphviz_Graphviz$RenderError(new $c_s_Some("error"), err)]))));
  }
  if ((x31 instanceof $c_s_util_Right)) {
    var ast = x31.hm;
    var parsed = formats.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((name) => new $c_T2(name, $m_Lorg_jpablo_graphexplorer_graphviz_Format$().b1P(name)))));
    var unsupported = parsed.ct(new $c_Lorg_jpablo_graphexplorer_graphviz_Graphviz$$anon$1());
    if ((!unsupported.c())) {
      return $p_Lorg_jpablo_graphexplorer_graphviz_Graphviz$__failure__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_Graphviz$MultipleRenderResult(this, unsupported.d2().L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((f) => new $c_Lorg_jpablo_graphexplorer_graphviz_Graphviz$RenderError(new $c_s_Some("error"), ("unsupported format: " + f))))));
    } else {
      try {
        var g = $m_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$().b7O(ast);
        var out = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$7(parsed.o(), new $c_Lorg_jpablo_graphexplorer_graphviz_Graphviz$$anon$2(g)));
        return new $c_Lorg_jpablo_graphexplorer_graphviz_Graphviz$MultipleRenderResult($s_Lorg_jpablo_graphexplorer_graphviz_RenderStatus$__Success__Lorg_jpablo_graphexplorer_graphviz_RenderStatus().Re, out, ($m_sci_Vector$(), $m_sci_Vector0$()));
      } catch (e) {
        var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
        var $x_3 = $m_sci_Vector$();
        var $x_2 = $m_sr_ScalaRunTime$();
        var $x_1 = new $c_s_Some("error");
        var this$14 = $m_s_Option$().as(e$2.e3());
        return $p_Lorg_jpablo_graphexplorer_graphviz_Graphviz$__failure__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_Graphviz$MultipleRenderResult(this, $x_3.X($x_2.f(new ($d_Lorg_jpablo_graphexplorer_graphviz_Graphviz$RenderError.r().C)([new $c_Lorg_jpablo_graphexplorer_graphviz_Graphviz$RenderError($x_1, (this$14.c() ? e$2.m() : this$14.d()))]))));
      } finally {
        $m_Lorg_jpablo_graphexplorer_graphviz_layout_GraphMemo$().aYl();
      }
    }
  }
  throw new $c_s_MatchError(x31);
});
var $d_Lorg_jpablo_graphexplorer_graphviz_Graphviz$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_Graphviz$, "org.jpablo.graphexplorer.graphviz.Graphviz$", ({
  uc: 1
}));
var $n_Lorg_jpablo_graphexplorer_graphviz_Graphviz$;
function $m_Lorg_jpablo_graphexplorer_graphviz_Graphviz$() {
  if ((!$n_Lorg_jpablo_graphexplorer_graphviz_Graphviz$)) {
    $n_Lorg_jpablo_graphexplorer_graphviz_Graphviz$ = new $c_Lorg_jpablo_graphexplorer_graphviz_Graphviz$();
  }
  return $n_Lorg_jpablo_graphexplorer_graphviz_Graphviz$;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__isIdStart__C__Z($thiz, c) {
  return (((c === 95) || $m_jl_UnicodeData$().a3S(c)) || (c >= 128));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__isIdChar__C__Z($thiz, c) {
  return (((c === 95) || $m_jl_UnicodeData$().E5(c)) || (c >= 128));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__kw__T__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, s, evidence$1) {
  $m_Lsourcecode_Name$();
  var name$proxy1 = new $c_Lsourcecode_Name("kw");
  var startIndex = evidence$1.G;
  var instrument = (evidence$1.bk !== null);
  if (instrument) {
    evidence$1.bk.hL(name$proxy1.aE, startIndex);
  }
  $m_Lfastparse_Implicits$Sequencer$();
  var preLhsIndex = evidence$1.G;
  var input = evidence$1.b0;
  $f_Lfastparse_SharedPackageDefs__IgnoreCase__T__Lfastparse_ParsingRun__Lfastparse_ParsingRun($m_Lfastparse_package$(), s, evidence$1);
  if ((!evidence$1.K)) {
    var ctx0 = evidence$1;
  } else {
    var postLhsIndex = evidence$1.G;
    var lhsAggregate = evidence$1.a0;
    var lhsMsg = evidence$1.am;
    if ((postLhsIndex > preLhsIndex)) {
      evidence$1.b7();
    }
    if (((!evidence$1.K) && evidence$1.N)) {
      var ctx0 = evidence$1;
    } else {
      var preRhsIndex = evidence$1.G;
      var startPos = evidence$1.G;
      var startCut = evidence$1.N;
      var oldNoCut = evidence$1.j2;
      evidence$1.j2 = true;
      var startTerminals = evidence$1.K1;
      var startIndex$2 = evidence$1.G;
      if (evidence$1.b0.bc(evidence$1.G)) {
        var this$4 = evidence$1.b0;
        var index = evidence$1.G;
        var $x_1 = $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__isIdChar__C__Z($thiz, this$4.cA.charCodeAt(index));
      } else {
        var $x_1 = false;
      }
      if ((!$x_1)) {
        evidence$1.dB();
      } else {
        evidence$1.dl(((1 + evidence$1.G) | 0));
      }
      if (evidence$1.aj) {
        evidence$1.de(startIndex$2, $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => (("char-pred(" + new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((c$1) => $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__isIdChar__C__Z($m_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$(), $uC(c$1))))) + ")")))));
      }
      evidence$1.j2 = oldNoCut;
      var res$2 = (evidence$1.K ? evidence$1.ll(startPos) : evidence$1.dl(startPos));
      if (evidence$1.aj) {
        evidence$1.K1 = startTerminals;
        evidence$1.de(startPos, $m_Lfastparse_internal_Msgs$().yA);
      }
      res$2.N = startCut;
      var rhsAggregate = evidence$1.a0;
      var rhsMsg = evidence$1.am;
      if ((!evidence$1.K)) {
        var res$3 = evidence$1;
      } else {
        var postRhsIndex = evidence$1.G;
        var rhsMadeProgress = (postRhsIndex > preRhsIndex);
        var nextIndex = (((!rhsMadeProgress) && input.bc(postRhsIndex)) ? postLhsIndex : postRhsIndex);
        if (rhsMadeProgress) {
          evidence$1.b7();
        }
        var res$3 = evidence$1.cI((void 0), nextIndex);
      }
      if (evidence$1.aj) {
        evidence$1.aG($m_Lfastparse_internal_Util$().dc(lhsMsg, rhsMsg), lhsAggregate.bl(rhsAggregate), (preRhsIndex === evidence$1.bq));
      }
      var ctx0 = res$3;
    }
  }
  if (instrument) {
    evidence$1.bk.hI(name$proxy1.aE, ctx0.G, ctx0.K);
  }
  if (ctx0.aj) {
    var newshortMsg = $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => name$proxy1.aE)));
    var forceAggregate = (startIndex < ctx0.bq);
    ctx0.aG(newshortMsg, ctx0.a0, forceAggregate);
    if ((!ctx0.K)) {
      ctx0.cf = new $c_sci_$colon$colon(new $c_T2(name$proxy1.aE, startIndex), ctx0.cf);
    }
  }
  return ctx0;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__idName__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1) {
  $m_Lsourcecode_Name$();
  var name$proxy2 = new $c_Lsourcecode_Name("idName");
  var startIndex = evidence$1.G;
  var instrument = (evidence$1.bk !== null);
  if (instrument) {
    evidence$1.bk.hL(name$proxy2.aE, startIndex);
  }
  var startPos = evidence$1.G;
  var oldCapturing = evidence$1.j2;
  evidence$1.j2 = true;
  $m_Lfastparse_Implicits$Sequencer$();
  var preLhsIndex = evidence$1.G;
  var input = evidence$1.b0;
  var startIndex$2 = evidence$1.G;
  if (evidence$1.b0.bc(evidence$1.G)) {
    var this$3 = evidence$1.b0;
    var index = evidence$1.G;
    var $x_1 = $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__isIdStart__C__Z($thiz, this$3.cA.charCodeAt(index));
  } else {
    var $x_1 = false;
  }
  if ((!$x_1)) {
    evidence$1.dB();
  } else {
    evidence$1.dl(((1 + evidence$1.G) | 0));
  }
  if (evidence$1.aj) {
    evidence$1.de(startIndex$2, $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => (("char-pred(" + new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((c$1) => $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__isIdStart__C__Z($m_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$(), $uC(c$1))))) + ")")))));
  }
  if (evidence$1.K) {
    var postLhsIndex = evidence$1.G;
    var lhsAggregate = evidence$1.a0;
    var lhsMsg = evidence$1.am;
    if ((postLhsIndex > preLhsIndex)) {
      evidence$1.b7();
    }
    if ((!((!evidence$1.K) && evidence$1.N))) {
      var preRhsIndex = evidence$1.G;
      var index$1 = evidence$1.G;
      var input$2 = evidence$1.b0;
      var start = index$1;
      while (true) {
        if (input$2.bc(index$1)) {
          var index$2 = index$1;
          var $x_2 = $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__isIdChar__C__Z($thiz, input$2.cA.charCodeAt(index$2));
        } else {
          var $x_2 = false;
        }
        if ($x_2) {
          index$1 = ((1 + index$1) | 0);
        } else {
          break;
        }
      }
      if ((index$1 >= start)) {
        evidence$1.dl(index$1);
      } else {
        evidence$1.dB();
      }
      if (evidence$1.aj) {
        evidence$1.de(start, $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => (("chars-while(" + new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((c$3) => $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__isIdChar__C__Z($m_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$(), $uC(c$3))))) + ", 0)")))));
      }
      var rhsAggregate = evidence$1.a0;
      var rhsMsg = evidence$1.am;
      if (evidence$1.K) {
        var postRhsIndex = evidence$1.G;
        var rhsMadeProgress = (postRhsIndex > preRhsIndex);
        var nextIndex = (((!rhsMadeProgress) && input.bc(postRhsIndex)) ? postLhsIndex : postRhsIndex);
        if (rhsMadeProgress) {
          evidence$1.b7();
        }
        evidence$1.cI((void 0), nextIndex);
      }
      if (evidence$1.aj) {
        evidence$1.aG($m_Lfastparse_internal_Util$().dc(lhsMsg, rhsMsg), lhsAggregate.bl(rhsAggregate), (preRhsIndex === evidence$1.bq));
      }
    }
  }
  evidence$1.j2 = oldCapturing;
  var ctx0 = ((!evidence$1.K) ? evidence$1 : evidence$1.u2(evidence$1.b0.PV(startPos, evidence$1.G)));
  if (instrument) {
    evidence$1.bk.hI(name$proxy2.aE, ctx0.G, ctx0.K);
  }
  if (ctx0.aj) {
    var newshortMsg = $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => name$proxy2.aE)));
    var forceAggregate = (startIndex < ctx0.bq);
    ctx0.aG(newshortMsg, ctx0.a0, forceAggregate);
    if ((!ctx0.K)) {
      ctx0.cf = new $c_sci_$colon$colon(new $c_T2(name$proxy2.aE, startIndex), ctx0.cf);
    }
  }
  if ((!ctx0.K)) {
    return ctx0;
  } else {
    ctx0.aB = new $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Id(ctx0.aB, false);
    return ctx0;
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__idNumeral__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1) {
  $m_Lsourcecode_Name$();
  var name$proxy3 = new $c_Lsourcecode_Name("idNumeral");
  var startIndex = evidence$1.G;
  var instrument = (evidence$1.bk !== null);
  if (instrument) {
    evidence$1.bk.hL(name$proxy3.aE, startIndex);
  }
  var startPos = evidence$1.G;
  var oldCapturing = evidence$1.j2;
  evidence$1.j2 = true;
  $m_Lfastparse_Implicits$Sequencer$();
  var preLhsIndex = evidence$1.G;
  var input = evidence$1.b0;
  var startPos$2 = evidence$1.G;
  var startCut = evidence$1.N;
  evidence$1.N = false;
  var input$2 = evidence$1.b0;
  var index = evidence$1.G;
  if ((input$2.bc(index) && (input$2.cA.charCodeAt(index) === 45))) {
    evidence$1.dl(((1 + index) | 0));
  } else {
    evidence$1.dB();
  }
  if (evidence$1.aj) {
    evidence$1.de(index, $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => "\"-\""))));
  }
  var postSuccess = evidence$1.K;
  if (postSuccess) {
    var res$2 = evidence$1.u2((void 0));
    res$2.N = (!(!(res$2.N | startCut)));
  } else if ((!evidence$1.N)) {
    var res$3 = evidence$1.cI((void 0), startPos$2);
    res$3.N = (!(!(res$3.N | startCut)));
  }
  if (evidence$1.aj) {
    var msg = evidence$1.am;
    if ((!postSuccess)) {
      evidence$1.aG($m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => ($m_Lfastparse_internal_Util$().pA(msg.j3) + ".?")))), evidence$1.a0, false);
    }
  }
  if (evidence$1.K) {
    var postLhsIndex = evidence$1.G;
    var lhsAggregate = evidence$1.a0;
    var lhsMsg = evidence$1.am;
    if ((postLhsIndex > preLhsIndex)) {
      evidence$1.b7();
    }
    if ((!((!evidence$1.K) && evidence$1.N))) {
      var preRhsIndex = evidence$1.G;
      var oldCut = evidence$1.N;
      evidence$1.N = false;
      var startPos$3 = evidence$1.G;
      $m_Lfastparse_Implicits$Sequencer$();
      var preLhsIndex$2 = evidence$1.G;
      var input$3 = evidence$1.b0;
      var input$4 = evidence$1.b0;
      var index$2 = evidence$1.G;
      if ((input$4.bc(index$2) && (input$4.cA.charCodeAt(index$2) === 46))) {
        evidence$1.dl(((1 + index$2) | 0));
      } else {
        evidence$1.dB();
      }
      if (evidence$1.aj) {
        evidence$1.de(index$2, $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => "\".\""))));
      }
      if (evidence$1.K) {
        var postLhsIndex$2 = evidence$1.G;
        var lhsAggregate$2 = evidence$1.a0;
        var lhsMsg$2 = evidence$1.am;
        if ((postLhsIndex$2 > preLhsIndex$2)) {
          evidence$1.b7();
        }
        if ((!((!evidence$1.K) && evidence$1.N))) {
          var preRhsIndex$2 = evidence$1.G;
          var index$3 = evidence$1.G;
          var input$5 = evidence$1.b0;
          var start = index$3;
          var goal = ((1 + start) | 0);
          while (true) {
            if (input$5.bc(index$3)) {
              var index$1 = index$3;
              var $x_1;
              var $x_1 = ((((input$5.cA.charCodeAt(index$1) - 48) | 0) >>> 0) <= 9);
            } else {
              var $x_1 = false;
            }
            if ($x_1) {
              index$3 = ((1 + index$3) | 0);
            } else {
              break;
            }
          }
          if ((index$3 >= goal)) {
            evidence$1.dl(index$3);
          } else {
            evidence$1.dB();
          }
          if (evidence$1.aj) {
            evidence$1.de(start, $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => "[0-9]"))));
          }
          var rhsAggregate = evidence$1.a0;
          var rhsMsg = evidence$1.am;
          if (evidence$1.K) {
            var postRhsIndex = evidence$1.G;
            var rhsMadeProgress = (postRhsIndex > preRhsIndex$2);
            var nextIndex = (((!rhsMadeProgress) && input$3.bc(postRhsIndex)) ? postLhsIndex$2 : postRhsIndex);
            if (rhsMadeProgress) {
              evidence$1.b7();
            }
            evidence$1.cI((void 0), nextIndex);
          }
          if (evidence$1.aj) {
            evidence$1.aG($m_Lfastparse_internal_Util$().dc(lhsMsg$2, rhsMsg), lhsAggregate$2.bl(rhsAggregate), (preRhsIndex$2 === evidence$1.bq));
          }
        }
      }
      var lhsMsg$3 = evidence$1.am;
      var lhsAggregate$3 = evidence$1.a0;
      if (evidence$1.K) {
        evidence$1.N = (!(!(evidence$1.N | oldCut)));
      } else if ((!evidence$1.N)) {
        var verboseFailures = evidence$1.aj;
        evidence$1.G = startPos$3;
        if (verboseFailures) {
          evidence$1.aG(lhsMsg$3, evidence$1.a0, false);
        }
        evidence$1.N = false;
        $m_Lfastparse_Implicits$Sequencer$();
        var preLhsIndex$3 = evidence$1.G;
        var input$6 = evidence$1.b0;
        var index$4 = evidence$1.G;
        var input$7 = evidence$1.b0;
        var start$2 = index$4;
        var goal$2 = ((1 + start$2) | 0);
        while (true) {
          if (input$7.bc(index$4)) {
            var index$5 = index$4;
            var $x_2;
            var $x_2 = ((((input$7.cA.charCodeAt(index$5) - 48) | 0) >>> 0) <= 9);
          } else {
            var $x_2 = false;
          }
          if ($x_2) {
            index$4 = ((1 + index$4) | 0);
          } else {
            break;
          }
        }
        if ((index$4 >= goal$2)) {
          evidence$1.dl(index$4);
        } else {
          evidence$1.dB();
        }
        if (evidence$1.aj) {
          evidence$1.de(start$2, $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => "[0-9]"))));
        }
        if (evidence$1.K) {
          var postLhsIndex$3 = evidence$1.G;
          var lhsAggregate$4 = evidence$1.a0;
          var lhsMsg$4 = evidence$1.am;
          if ((postLhsIndex$3 > preLhsIndex$3)) {
            evidence$1.b7();
          }
          if ((!((!evidence$1.K) && evidence$1.N))) {
            var preRhsIndex$3 = evidence$1.G;
            var startPos$4 = evidence$1.G;
            var startCut$2 = evidence$1.N;
            evidence$1.N = false;
            $m_Lfastparse_Implicits$Sequencer$();
            var preLhsIndex$4 = evidence$1.G;
            var input$8 = evidence$1.b0;
            var input$9 = evidence$1.b0;
            var index$5$1 = evidence$1.G;
            if ((input$9.bc(index$5$1) && (input$9.cA.charCodeAt(index$5$1) === 46))) {
              evidence$1.dl(((1 + index$5$1) | 0));
            } else {
              evidence$1.dB();
            }
            if (evidence$1.aj) {
              evidence$1.de(index$5$1, $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => "\".\""))));
            }
            if (evidence$1.K) {
              var postLhsIndex$4 = evidence$1.G;
              var lhsAggregate$5 = evidence$1.a0;
              var lhsMsg$5 = evidence$1.am;
              if ((postLhsIndex$4 > preLhsIndex$4)) {
                evidence$1.b7();
              }
              if ((!((!evidence$1.K) && evidence$1.N))) {
                var preRhsIndex$4 = evidence$1.G;
                var index$6 = evidence$1.G;
                var input$10 = evidence$1.b0;
                var start$3 = index$6;
                while (true) {
                  if (input$10.bc(index$6)) {
                    var index$7 = index$6;
                    var $x_3;
                    var $x_3 = ((((input$10.cA.charCodeAt(index$7) - 48) | 0) >>> 0) <= 9);
                  } else {
                    var $x_3 = false;
                  }
                  if ($x_3) {
                    index$6 = ((1 + index$6) | 0);
                  } else {
                    break;
                  }
                }
                if ((index$6 >= start$3)) {
                  evidence$1.dl(index$6);
                } else {
                  evidence$1.dB();
                }
                if (evidence$1.aj) {
                  evidence$1.de(start$3, $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => "[0-9]"))));
                }
                var rhsAggregate$2 = evidence$1.a0;
                var rhsMsg$2 = evidence$1.am;
                if (evidence$1.K) {
                  var postRhsIndex$2 = evidence$1.G;
                  var rhsMadeProgress$2 = (postRhsIndex$2 > preRhsIndex$4);
                  var nextIndex$2 = (((!rhsMadeProgress$2) && input$8.bc(postRhsIndex$2)) ? postLhsIndex$4 : postRhsIndex$2);
                  if (rhsMadeProgress$2) {
                    evidence$1.b7();
                  }
                  evidence$1.cI((void 0), nextIndex$2);
                }
                if (evidence$1.aj) {
                  evidence$1.aG($m_Lfastparse_internal_Util$().dc(lhsMsg$5, rhsMsg$2), lhsAggregate$5.bl(rhsAggregate$2), (preRhsIndex$4 === evidence$1.bq));
                }
              }
            }
            var postSuccess$2 = evidence$1.K;
            if (postSuccess$2) {
              var res$12 = evidence$1.u2((void 0));
              res$12.N = (!(!(res$12.N | startCut$2)));
            } else if ((!evidence$1.N)) {
              var res$13 = evidence$1.cI((void 0), startPos$4);
              res$13.N = (!(!(res$13.N | startCut$2)));
            }
            if (evidence$1.aj) {
              var msg$3 = evidence$1.am;
              if ((!postSuccess$2)) {
                evidence$1.aG($m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => ($m_Lfastparse_internal_Util$().pA(msg$3.j3) + ".?")))), evidence$1.a0, false);
              }
            }
            var rhsAggregate$3 = evidence$1.a0;
            var rhsMsg$3 = evidence$1.am;
            if (evidence$1.K) {
              var postRhsIndex$3 = evidence$1.G;
              var rhsMadeProgress$3 = (postRhsIndex$3 > preRhsIndex$3);
              var nextIndex$3 = (((!rhsMadeProgress$3) && input$6.bc(postRhsIndex$3)) ? postLhsIndex$3 : postRhsIndex$3);
              if (rhsMadeProgress$3) {
                evidence$1.b7();
              }
              evidence$1.cI((void 0), nextIndex$3);
            }
            if (evidence$1.aj) {
              evidence$1.aG($m_Lfastparse_internal_Util$().dc(lhsMsg$4, rhsMsg$3), lhsAggregate$4.bl(rhsAggregate$3), (preRhsIndex$3 === evidence$1.bq));
            }
          }
        }
        var rhsMsg$4 = evidence$1.am;
        var rhsCut = evidence$1.N;
        var endCut = (!(!(rhsCut | oldCut)));
        if (((!evidence$1.K) && (!rhsCut))) {
          evidence$1.ll(startPos$3);
        }
        evidence$1.N = endCut;
        if (verboseFailures) {
          var $x_4 = lhsMsg$3.bl(rhsMsg$4);
          var other$1 = evidence$1.a0;
          evidence$1.aG($x_4, lhsAggregate$3.bl(other$1), false);
        }
      }
      var rhsAggregate$4 = evidence$1.a0;
      var rhsMsg$5 = evidence$1.am;
      if (evidence$1.K) {
        var postRhsIndex$4 = evidence$1.G;
        var rhsMadeProgress$4 = (postRhsIndex$4 > preRhsIndex);
        var nextIndex$4 = (((!rhsMadeProgress$4) && input.bc(postRhsIndex$4)) ? postLhsIndex : postRhsIndex$4);
        if (rhsMadeProgress$4) {
          evidence$1.b7();
        }
        evidence$1.cI((void 0), nextIndex$4);
      }
      if (evidence$1.aj) {
        evidence$1.aG($m_Lfastparse_internal_Util$().dc(lhsMsg, rhsMsg$5), lhsAggregate.bl(rhsAggregate$4), (preRhsIndex === evidence$1.bq));
      }
    }
  }
  evidence$1.j2 = oldCapturing;
  var ctx0 = ((!evidence$1.K) ? evidence$1 : evidence$1.u2(evidence$1.b0.PV(startPos, evidence$1.G)));
  if (instrument) {
    evidence$1.bk.hI(name$proxy3.aE, ctx0.G, ctx0.K);
  }
  if (ctx0.aj) {
    var newshortMsg$3 = $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => name$proxy3.aE)));
    var forceAggregate = (startIndex < ctx0.bq);
    ctx0.aG(newshortMsg$3, ctx0.a0, forceAggregate);
    if ((!ctx0.K)) {
      ctx0.cf = new $c_sci_$colon$colon(new $c_T2(name$proxy3.aE, startIndex), ctx0.cf);
    }
  }
  if ((!ctx0.K)) {
    return ctx0;
  } else {
    ctx0.aB = new $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Id(ctx0.aB, false);
    return ctx0;
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__quotedChar__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1) {
  $m_Lsourcecode_Name$();
  var name$proxy4 = new $c_Lsourcecode_Name("quotedChar");
  var startIndex = evidence$1.G;
  var instrument = (evidence$1.bk !== null);
  if (instrument) {
    evidence$1.bk.hL(name$proxy4.aE, startIndex);
  }
  var oldCut = evidence$1.N;
  evidence$1.N = false;
  var startPos = evidence$1.G;
  var oldCut$2 = evidence$1.N;
  evidence$1.N = false;
  var startPos$2 = evidence$1.G;
  var oldCut$3 = evidence$1.N;
  evidence$1.N = false;
  var startPos$3 = evidence$1.G;
  var oldCut$4 = evidence$1.N;
  evidence$1.N = false;
  var startPos$4 = evidence$1.G;
  var index = evidence$1.G;
  var end = ((2 + index) | 0);
  var input = evidence$1.b0;
  if (input.bc(((end - 1) | 0))) {
    if ((input.cA.charCodeAt(index) === 92)) {
      var index$1 = ((1 + index) | 0);
      var $x_1 = (input.cA.charCodeAt(index$1) === 34);
    } else {
      var $x_1 = false;
    }
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    var res = evidence$1.dl(end);
  } else {
    var res = evidence$1.dB();
  }
  if (evidence$1.aj) {
    evidence$1.de(index, $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => "\"\\\\\\\"\""))));
  }
  var lhs$proxy3 = res;
  if (lhs$proxy3.K) {
    lhs$proxy3.aB = "\"";
  }
  var lhsMsg = evidence$1.am;
  var lhsAggregate = evidence$1.a0;
  if (evidence$1.K) {
    evidence$1.N = (!(!(evidence$1.N | oldCut$4)));
  } else if ((!evidence$1.N)) {
    var verboseFailures = evidence$1.aj;
    evidence$1.G = startPos$4;
    if (verboseFailures) {
      evidence$1.aG(lhsMsg, evidence$1.a0, false);
    }
    evidence$1.N = false;
    var index$2 = evidence$1.G;
    var end$2 = ((3 + index$2) | 0);
    var input$2 = evidence$1.b0;
    if (input$2.bc(((end$2 - 1) | 0))) {
      if ((input$2.cA.charCodeAt(index$2) === 92)) {
        var index$3 = ((1 + index$2) | 0);
        var $x_3 = (input$2.cA.charCodeAt(index$3) === 13);
      } else {
        var $x_3 = false;
      }
      if ($x_3) {
        var index$4 = ((2 + index$2) | 0);
        var $x_2 = (input$2.cA.charCodeAt(index$4) === 10);
      } else {
        var $x_2 = false;
      }
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var res$2 = evidence$1.dl(end$2);
    } else {
      var res$2 = evidence$1.dB();
    }
    if (evidence$1.aj) {
      evidence$1.de(index$2, $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => "\"\\\\\\r\\n\""))));
    }
    var lhs$proxy4 = res$2;
    if (lhs$proxy4.K) {
      lhs$proxy4.aB = "";
    }
    var rhsMsg = evidence$1.am;
    var rhsCut = evidence$1.N;
    var endCut = (!(!(rhsCut | oldCut$4)));
    if (((!evidence$1.K) && (!rhsCut))) {
      evidence$1.ll(startPos$4);
    }
    evidence$1.N = endCut;
    if (verboseFailures) {
      var $x_4 = lhsMsg.bl(rhsMsg);
      var other$1 = evidence$1.a0;
      evidence$1.aG($x_4, lhsAggregate.bl(other$1), false);
    }
  }
  var lhsMsg$2 = evidence$1.am;
  var lhsAggregate$2 = evidence$1.a0;
  if (evidence$1.K) {
    evidence$1.N = (!(!(evidence$1.N | oldCut$3)));
  } else if ((!evidence$1.N)) {
    var verboseFailures$2 = evidence$1.aj;
    evidence$1.G = startPos$3;
    if (verboseFailures$2) {
      evidence$1.aG(lhsMsg$2, evidence$1.a0, false);
    }
    evidence$1.N = false;
    var index$3$1 = evidence$1.G;
    var end$3 = ((2 + index$3$1) | 0);
    var input$3 = evidence$1.b0;
    if (input$3.bc(((end$3 - 1) | 0))) {
      if ((input$3.cA.charCodeAt(index$3$1) === 92)) {
        var index$5 = ((1 + index$3$1) | 0);
        var $x_5 = (input$3.cA.charCodeAt(index$5) === 10);
      } else {
        var $x_5 = false;
      }
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var res$3 = evidence$1.dl(end$3);
    } else {
      var res$3 = evidence$1.dB();
    }
    if (evidence$1.aj) {
      evidence$1.de(index$3$1, $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => "\"\\\\\\n\""))));
    }
    var lhs$proxy5 = res$3;
    if (lhs$proxy5.K) {
      lhs$proxy5.aB = "";
    }
    var rhsMsg$2 = evidence$1.am;
    var rhsCut$2 = evidence$1.N;
    var endCut$2 = (!(!(rhsCut$2 | oldCut$3)));
    if (((!evidence$1.K) && (!rhsCut$2))) {
      evidence$1.ll(startPos$3);
    }
    evidence$1.N = endCut$2;
    if (verboseFailures$2) {
      var $x_6 = lhsMsg$2.bl(rhsMsg$2);
      var other$1$2 = evidence$1.a0;
      evidence$1.aG($x_6, lhsAggregate$2.bl(other$1$2), false);
    }
  }
  var lhsMsg$3 = evidence$1.am;
  var lhsAggregate$3 = evidence$1.a0;
  if (evidence$1.K) {
    evidence$1.N = (!(!(evidence$1.N | oldCut$2)));
  } else if ((!evidence$1.N)) {
    var verboseFailures$3 = evidence$1.aj;
    evidence$1.G = startPos$2;
    if (verboseFailures$3) {
      evidence$1.aG(lhsMsg$3, evidence$1.a0, false);
    }
    evidence$1.N = false;
    $m_Lfastparse_Implicits$Sequencer$();
    var preLhsIndex = evidence$1.G;
    var input$4 = evidence$1.b0;
    var input$5 = evidence$1.b0;
    var index$4$1 = evidence$1.G;
    if ((input$5.bc(index$4$1) && (input$5.cA.charCodeAt(index$4$1) === 92))) {
      evidence$1.dl(((1 + index$4$1) | 0));
    } else {
      evidence$1.dB();
    }
    if (evidence$1.aj) {
      evidence$1.de(index$4$1, $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => "\"\\\\\""))));
    }
    if ((!evidence$1.K)) {
      var lhs$proxy6 = evidence$1;
    } else {
      var postLhsIndex = evidence$1.G;
      var lhsAggregate$4 = evidence$1.a0;
      var lhsMsg$4 = evidence$1.am;
      if ((postLhsIndex > preLhsIndex)) {
        evidence$1.b7();
      }
      if (((!evidence$1.K) && evidence$1.N)) {
        var lhs$proxy6 = evidence$1;
      } else {
        var preRhsIndex = evidence$1.G;
        var startPos$5 = evidence$1.G;
        var oldCapturing = evidence$1.j2;
        evidence$1.j2 = true;
        $f_Lfastparse_SharedPackageDefs__AnyChar__Lfastparse_ParsingRun__Lfastparse_ParsingRun($m_Lfastparse_package$(), evidence$1);
        evidence$1.j2 = oldCapturing;
        if (evidence$1.K) {
          evidence$1.u2(evidence$1.b0.PV(startPos$5, evidence$1.G));
        }
        var rhsAggregate = evidence$1.a0;
        var rhsMsg$3 = evidence$1.am;
        if ((!evidence$1.K)) {
          var res$5 = evidence$1;
        } else {
          var postRhsIndex = evidence$1.G;
          var rhsMadeProgress = (postRhsIndex > preRhsIndex);
          var nextIndex = (((!rhsMadeProgress) && input$4.bc(postRhsIndex)) ? postLhsIndex : postRhsIndex);
          if (rhsMadeProgress) {
            evidence$1.b7();
          }
          var res$5 = evidence$1.cI(evidence$1.aB, nextIndex);
        }
        if (evidence$1.aj) {
          evidence$1.aG($m_Lfastparse_internal_Util$().dc(lhsMsg$4, rhsMsg$3), lhsAggregate$4.bl(rhsAggregate), (preRhsIndex === evidence$1.bq));
        }
        var lhs$proxy6 = res$5;
      }
    }
    if (lhs$proxy6.K) {
      lhs$proxy6.aB = ("\\" + lhs$proxy6.aB);
    }
    var rhsMsg$4 = evidence$1.am;
    var rhsCut$3 = evidence$1.N;
    var endCut$3 = (!(!(rhsCut$3 | oldCut$2)));
    if (((!evidence$1.K) && (!rhsCut$3))) {
      evidence$1.ll(startPos$2);
    }
    evidence$1.N = endCut$3;
    if (verboseFailures$3) {
      var $x_7 = lhsMsg$3.bl(rhsMsg$4);
      var other$1$3 = evidence$1.a0;
      evidence$1.aG($x_7, lhsAggregate$3.bl(other$1$3), false);
    }
  }
  var lhsMsg$5 = evidence$1.am;
  var lhsAggregate$5 = evidence$1.a0;
  if (evidence$1.K) {
    evidence$1.N = (!(!(evidence$1.N | oldCut)));
    var ctx0 = evidence$1;
  } else if (evidence$1.N) {
    var ctx0 = evidence$1;
  } else {
    var verboseFailures$4 = evidence$1.aj;
    evidence$1.G = startPos;
    if (verboseFailures$4) {
      evidence$1.aG(lhsMsg$5, evidence$1.a0, false);
    }
    evidence$1.N = false;
    var startPos$6 = evidence$1.G;
    var oldCapturing$2 = evidence$1.j2;
    evidence$1.j2 = true;
    var index$5$1 = evidence$1.G;
    var input$6 = evidence$1.b0;
    var start = index$5$1;
    var goal = ((1 + start) | 0);
    while (true) {
      if (input$6.bc(index$5$1)) {
        var index$6 = index$5$1;
        var this$12 = input$6.cA;
        var c = this$12.charCodeAt(index$6);
        var $x_8 = ((c !== 34) && (c !== 92));
      } else {
        var $x_8 = false;
      }
      if ($x_8) {
        index$5$1 = ((1 + index$5$1) | 0);
      } else {
        break;
      }
    }
    if ((index$5$1 >= goal)) {
      evidence$1.dl(index$5$1);
    } else {
      evidence$1.dB();
    }
    if (evidence$1.aj) {
      evidence$1.de(start, $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => (("chars-while(" + new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((c$1) => {
        var c$2 = $uC(c$1);
        return ((c$2 !== 34) && (c$2 !== 92));
      }))) + ", 1)")))));
    }
    evidence$1.j2 = oldCapturing$2;
    if (evidence$1.K) {
      evidence$1.u2(evidence$1.b0.PV(startPos$6, evidence$1.G));
    }
    var rhsMsg$5 = evidence$1.am;
    var rhsCut$4 = evidence$1.N;
    var endCut$4 = (!(!(rhsCut$4 | oldCut)));
    if (((!evidence$1.K) && (!rhsCut$4))) {
      evidence$1.ll(startPos);
    }
    evidence$1.N = endCut$4;
    if (verboseFailures$4) {
      var $x_9 = lhsMsg$5.bl(rhsMsg$5);
      var other$1$4 = evidence$1.a0;
      evidence$1.aG($x_9, lhsAggregate$5.bl(other$1$4), false);
    }
    var ctx0 = evidence$1;
  }
  if (instrument) {
    evidence$1.bk.hI(name$proxy4.aE, ctx0.G, ctx0.K);
  }
  if (ctx0.aj) {
    var newshortMsg$4 = $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => name$proxy4.aE)));
    var forceAggregate = (startIndex < ctx0.bq);
    ctx0.aG(newshortMsg$4, ctx0.a0, forceAggregate);
    if ((!ctx0.K)) {
      ctx0.cf = new $c_sci_$colon$colon(new $c_T2(name$proxy4.aE, startIndex), ctx0.cf);
    }
  }
  return ctx0;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__quotedRaw__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1) {
  $m_Lsourcecode_Name$();
  var name$proxy5 = new $c_Lsourcecode_Name("quotedRaw");
  var startIndex = evidence$1.G;
  var instrument = (evidence$1.bk !== null);
  if (instrument) {
    evidence$1.bk.hL(name$proxy5.aE, startIndex);
  }
  $m_Lfastparse_Implicits$Sequencer$().qP();
  var preLhsIndex = evidence$1.G;
  var input = evidence$1.b0;
  $m_Lfastparse_Implicits$Sequencer$();
  var preLhsIndex$2 = evidence$1.G;
  var input$2 = evidence$1.b0;
  var input$3 = evidence$1.b0;
  var index = evidence$1.G;
  if ((input$3.bc(index) && (input$3.cA.charCodeAt(index) === 34))) {
    evidence$1.dl(((1 + index) | 0));
  } else {
    evidence$1.dB();
  }
  if (evidence$1.aj) {
    evidence$1.de(index, $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => "\"\\\"\""))));
  }
  if (evidence$1.K) {
    var postLhsIndex = evidence$1.G;
    var lhsAggregate = evidence$1.a0;
    var lhsMsg = evidence$1.am;
    if ((postLhsIndex > preLhsIndex$2)) {
      evidence$1.b7();
    }
    if ((!((!evidence$1.K) && evidence$1.N))) {
      var preRhsIndex = evidence$1.G;
      $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__rec$2__Lfastparse_ParsingRun__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__I__I__Z__Z__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_ParsingRun($thiz, evidence$1, 0, evidence$1, $m_Lfastparse_Implicits$Repeater$().Ad(), $m_scm_Buffer$().f7(), evidence$1.G, 0, false, evidence$1.N, null, null);
      var rhsAggregate = evidence$1.a0;
      var rhsMsg = evidence$1.am;
      if (evidence$1.K) {
        var postRhsIndex = evidence$1.G;
        var rhsMadeProgress = (postRhsIndex > preRhsIndex);
        var nextIndex = (((!rhsMadeProgress) && input$2.bc(postRhsIndex)) ? postLhsIndex : postRhsIndex);
        if (rhsMadeProgress) {
          evidence$1.b7();
        }
        evidence$1.cI(evidence$1.aB, nextIndex);
      }
      if (evidence$1.aj) {
        evidence$1.aG($m_Lfastparse_internal_Util$().dc(lhsMsg, rhsMsg), lhsAggregate.bl(rhsAggregate), (preRhsIndex === evidence$1.bq));
      }
    }
  }
  if ((!evidence$1.K)) {
    var ctx0 = evidence$1;
  } else {
    var postLhsIndex$2 = evidence$1.G;
    var lhsAggregate$2 = evidence$1.a0;
    var lhsMsg$2 = evidence$1.am;
    if ((postLhsIndex$2 > preLhsIndex)) {
      evidence$1.b7();
    }
    var lhsValue$2 = evidence$1.aB;
    if (((!evidence$1.K) && evidence$1.N)) {
      var ctx0 = evidence$1;
    } else {
      var preRhsIndex$2 = evidence$1.G;
      var input$4 = evidence$1.b0;
      var index$2 = evidence$1.G;
      if ((input$4.bc(index$2) && (input$4.cA.charCodeAt(index$2) === 34))) {
        evidence$1.dl(((1 + index$2) | 0));
      } else {
        evidence$1.dB();
      }
      if (evidence$1.aj) {
        evidence$1.de(index$2, $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => "\"\\\"\""))));
      }
      var rhsAggregate$2 = evidence$1.a0;
      var rhsMsg$2 = evidence$1.am;
      if ((!evidence$1.K)) {
        var res$4 = evidence$1;
      } else {
        var postRhsIndex$2 = evidence$1.G;
        var rhsMadeProgress$2 = (postRhsIndex$2 > preRhsIndex$2);
        var nextIndex$2 = (((!rhsMadeProgress$2) && input.bc(postRhsIndex$2)) ? postLhsIndex$2 : postRhsIndex$2);
        if (rhsMadeProgress$2) {
          evidence$1.b7();
        }
        var res$4 = evidence$1.cI(lhsValue$2, nextIndex$2);
      }
      if (evidence$1.aj) {
        evidence$1.aG($m_Lfastparse_internal_Util$().dc(lhsMsg$2, rhsMsg$2), lhsAggregate$2.bl(rhsAggregate$2), (preRhsIndex$2 === evidence$1.bq));
      }
      var ctx0 = res$4;
    }
  }
  if (instrument) {
    evidence$1.bk.hI(name$proxy5.aE, ctx0.G, ctx0.K);
  }
  if (ctx0.aj) {
    var newshortMsg = $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => name$proxy5.aE)));
    var forceAggregate = (startIndex < ctx0.bq);
    ctx0.aG(newshortMsg, ctx0.a0, forceAggregate);
    if ((!ctx0.K)) {
      ctx0.cf = new $c_sci_$colon$colon(new $c_T2(name$proxy5.aE, startIndex), ctx0.cf);
    }
  }
  if ((!ctx0.K)) {
    return ctx0;
  } else {
    ctx0.aB = $f_sc_IterableOnceOps__mkString__T__T__T__T(ctx0.aB, "", "", "");
    return ctx0;
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__idQuoted__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1) {
  $m_Lsourcecode_Name$();
  var name$proxy6 = new $c_Lsourcecode_Name("idQuoted");
  var startIndex = evidence$1.G;
  var instrument = (evidence$1.bk !== null);
  if (instrument) {
    evidence$1.bk.hL(name$proxy6.aE, startIndex);
  }
  var s$proxy11 = $f_Lfastparse_LowestPriSequencer__Sequencer1__O($m_Lfastparse_Implicits$Sequencer$());
  var preLhsIndex = evidence$1.G;
  var input = evidence$1.b0;
  $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__quotedRaw__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1);
  if ((!evidence$1.K)) {
    var ctx0 = evidence$1;
  } else {
    var postLhsIndex = evidence$1.G;
    var lhsAggregate = evidence$1.a0;
    var lhsMsg = evidence$1.am;
    if ((postLhsIndex > preLhsIndex)) {
      evidence$1.b7();
    }
    var lhsValue = evidence$1.aB;
    $m_Lfastparse_internal_Util$().dJ($thiz.dK(), evidence$1);
    if (evidence$1.K) {
      if (((!evidence$1.K) && evidence$1.N)) {
        var ctx0 = evidence$1;
      } else {
        var preRhsIndex = evidence$1.G;
        $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__rec$3__Lfastparse_ParsingRun__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__I__I__Z__Z__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_ParsingRun($thiz, evidence$1, 0, evidence$1, $m_Lfastparse_Implicits$Repeater$().Ad(), $m_scm_Buffer$().f7(), evidence$1.G, 0, false, evidence$1.N, null, null);
        var rhsAggregate = evidence$1.a0;
        var rhsMsg = evidence$1.am;
        if ((!evidence$1.K)) {
          var res = evidence$1;
        } else {
          var postRhsIndex = evidence$1.G;
          var rhsMadeProgress = (postRhsIndex > preRhsIndex);
          var nextIndex = (((!rhsMadeProgress) && input.bc(postRhsIndex)) ? postLhsIndex : postRhsIndex);
          if (rhsMadeProgress) {
            evidence$1.b7();
          }
          var res = evidence$1.cI(s$proxy11.R(lhsValue, evidence$1.aB), nextIndex);
        }
        if (evidence$1.aj) {
          evidence$1.aG($m_Lfastparse_internal_Util$().dc(lhsMsg, rhsMsg), lhsAggregate.bl(rhsAggregate), (preRhsIndex === evidence$1.bq));
        }
        var ctx0 = res;
      }
    } else {
      var ctx0 = evidence$1;
    }
  }
  if (instrument) {
    evidence$1.bk.hI(name$proxy6.aE, ctx0.G, ctx0.K);
  }
  if (ctx0.aj) {
    var newshortMsg = $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => name$proxy6.aE)));
    var forceAggregate = (startIndex < ctx0.bq);
    ctx0.aG(newshortMsg, ctx0.a0, forceAggregate);
    if ((!ctx0.K)) {
      ctx0.cf = new $c_sci_$colon$colon(new $c_T2(name$proxy6.aE, startIndex), ctx0.cf);
    }
  }
  if ((!ctx0.K)) {
    return ctx0;
  } else {
    var x$1 = ctx0.aB;
    matchResult21: {
      var $x_1;
      if ((x$1 !== null)) {
        var h = x$1.g();
        var $x_1 = new $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Id($f_sc_IterableOnceOps__mkString__T__T__T__T(x$1.h().kv(h), "", "", ""), false);
        break matchResult21;
      }
      throw new $c_s_MatchError(x$1);
    }
    ctx0.aB = $x_1;
    return ctx0;
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__htmlBody__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1) {
  $m_Lsourcecode_Name$();
  var name$proxy7 = new $c_Lsourcecode_Name("htmlBody");
  var startIndex = evidence$1.G;
  var instrument = (evidence$1.bk !== null);
  if (instrument) {
    evidence$1.bk.hL(name$proxy7.aE, startIndex);
  }
  var ctx0 = $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__rec$4__Lfastparse_ParsingRun__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__I__I__Z__Z__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_ParsingRun($thiz, evidence$1, 0, evidence$1, $m_Lfastparse_Implicits$Repeater$UnitRepeater$(), (void 0), evidence$1.G, 0, false, evidence$1.N, null, null);
  if (instrument) {
    evidence$1.bk.hI(name$proxy7.aE, ctx0.G, ctx0.K);
  }
  if (ctx0.aj) {
    var newshortMsg = $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => name$proxy7.aE)));
    var forceAggregate = (startIndex < ctx0.bq);
    ctx0.aG(newshortMsg, ctx0.a0, forceAggregate);
    if ((!ctx0.K)) {
      ctx0.cf = new $c_sci_$colon$colon(new $c_T2(name$proxy7.aE, startIndex), ctx0.cf);
    }
  }
  return ctx0;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__idHtml__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1) {
  $m_Lsourcecode_Name$();
  var name$proxy8 = new $c_Lsourcecode_Name("idHtml");
  var startIndex = evidence$1.G;
  var instrument = (evidence$1.bk !== null);
  if (instrument) {
    evidence$1.bk.hL(name$proxy8.aE, startIndex);
  }
  $m_Lfastparse_Implicits$Sequencer$().qP();
  var preLhsIndex = evidence$1.G;
  var input = evidence$1.b0;
  $m_Lfastparse_Implicits$Sequencer$();
  var preLhsIndex$2 = evidence$1.G;
  var input$2 = evidence$1.b0;
  var input$3 = evidence$1.b0;
  var index = evidence$1.G;
  if ((input$3.bc(index) && (input$3.cA.charCodeAt(index) === 60))) {
    evidence$1.dl(((1 + index) | 0));
  } else {
    evidence$1.dB();
  }
  if (evidence$1.aj) {
    evidence$1.de(index, $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => "\"<\""))));
  }
  if (evidence$1.K) {
    var postLhsIndex = evidence$1.G;
    var lhsAggregate = evidence$1.a0;
    var lhsMsg = evidence$1.am;
    if ((postLhsIndex > preLhsIndex$2)) {
      evidence$1.b7();
    }
    if ((!((!evidence$1.K) && evidence$1.N))) {
      var preRhsIndex = evidence$1.G;
      var startPos = evidence$1.G;
      var oldCapturing = evidence$1.j2;
      evidence$1.j2 = true;
      $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__htmlBody__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1);
      evidence$1.j2 = oldCapturing;
      if (evidence$1.K) {
        evidence$1.u2(evidence$1.b0.PV(startPos, evidence$1.G));
      }
      var rhsAggregate = evidence$1.a0;
      var rhsMsg = evidence$1.am;
      if (evidence$1.K) {
        var postRhsIndex = evidence$1.G;
        var rhsMadeProgress = (postRhsIndex > preRhsIndex);
        var nextIndex = (((!rhsMadeProgress) && input$2.bc(postRhsIndex)) ? postLhsIndex : postRhsIndex);
        if (rhsMadeProgress) {
          evidence$1.b7();
        }
        evidence$1.cI(evidence$1.aB, nextIndex);
      }
      if (evidence$1.aj) {
        evidence$1.aG($m_Lfastparse_internal_Util$().dc(lhsMsg, rhsMsg), lhsAggregate.bl(rhsAggregate), (preRhsIndex === evidence$1.bq));
      }
    }
  }
  if ((!evidence$1.K)) {
    var ctx0 = evidence$1;
  } else {
    var postLhsIndex$2 = evidence$1.G;
    var lhsAggregate$2 = evidence$1.a0;
    var lhsMsg$2 = evidence$1.am;
    if ((postLhsIndex$2 > preLhsIndex)) {
      evidence$1.b7();
    }
    var lhsValue$2 = evidence$1.aB;
    if (((!evidence$1.K) && evidence$1.N)) {
      var ctx0 = evidence$1;
    } else {
      var preRhsIndex$2 = evidence$1.G;
      var input$4 = evidence$1.b0;
      var index$2 = evidence$1.G;
      if ((input$4.bc(index$2) && (input$4.cA.charCodeAt(index$2) === 62))) {
        evidence$1.dl(((1 + index$2) | 0));
      } else {
        evidence$1.dB();
      }
      if (evidence$1.aj) {
        evidence$1.de(index$2, $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => "\">\""))));
      }
      var rhsAggregate$2 = evidence$1.a0;
      var rhsMsg$2 = evidence$1.am;
      if ((!evidence$1.K)) {
        var res$4 = evidence$1;
      } else {
        var postRhsIndex$2 = evidence$1.G;
        var rhsMadeProgress$2 = (postRhsIndex$2 > preRhsIndex$2);
        var nextIndex$2 = (((!rhsMadeProgress$2) && input.bc(postRhsIndex$2)) ? postLhsIndex$2 : postRhsIndex$2);
        if (rhsMadeProgress$2) {
          evidence$1.b7();
        }
        var res$4 = evidence$1.cI(lhsValue$2, nextIndex$2);
      }
      if (evidence$1.aj) {
        evidence$1.aG($m_Lfastparse_internal_Util$().dc(lhsMsg$2, rhsMsg$2), lhsAggregate$2.bl(rhsAggregate$2), (preRhsIndex$2 === evidence$1.bq));
      }
      var ctx0 = res$4;
    }
  }
  if (instrument) {
    evidence$1.bk.hI(name$proxy8.aE, ctx0.G, ctx0.K);
  }
  if (ctx0.aj) {
    var newshortMsg = $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => name$proxy8.aE)));
    var forceAggregate = (startIndex < ctx0.bq);
    ctx0.aG(newshortMsg, ctx0.a0, forceAggregate);
    if ((!ctx0.K)) {
      ctx0.cf = new $c_sci_$colon$colon(new $c_T2(name$proxy8.aE, startIndex), ctx0.cf);
    }
  }
  if ((!ctx0.K)) {
    return ctx0;
  } else {
    ctx0.aB = new $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Id(ctx0.aB, true);
    return ctx0;
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__id__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1) {
  $m_Lsourcecode_Name$();
  var name$proxy9 = new $c_Lsourcecode_Name("id");
  var startIndex = evidence$1.G;
  var instrument = (evidence$1.bk !== null);
  if (instrument) {
    evidence$1.bk.hL(name$proxy9.aE, startIndex);
  }
  var oldCut = evidence$1.N;
  evidence$1.N = false;
  var startPos = evidence$1.G;
  var oldCut$2 = evidence$1.N;
  evidence$1.N = false;
  var startPos$2 = evidence$1.G;
  var oldCut$3 = evidence$1.N;
  evidence$1.N = false;
  var startPos$3 = evidence$1.G;
  $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__idHtml__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1);
  var lhsMsg = evidence$1.am;
  var lhsAggregate = evidence$1.a0;
  if (evidence$1.K) {
    evidence$1.N = (!(!(evidence$1.N | oldCut$3)));
  } else if ((!evidence$1.N)) {
    var verboseFailures = evidence$1.aj;
    evidence$1.G = startPos$3;
    if (verboseFailures) {
      evidence$1.aG(lhsMsg, evidence$1.a0, false);
    }
    evidence$1.N = false;
    $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__idQuoted__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1);
    var rhsMsg = evidence$1.am;
    var rhsCut = evidence$1.N;
    var endCut = (!(!(rhsCut | oldCut$3)));
    if (((!evidence$1.K) && (!rhsCut))) {
      evidence$1.ll(startPos$3);
    }
    evidence$1.N = endCut;
    if (verboseFailures) {
      var $x_1 = lhsMsg.bl(rhsMsg);
      var other$1 = evidence$1.a0;
      evidence$1.aG($x_1, lhsAggregate.bl(other$1), false);
    }
  }
  var lhsMsg$2 = evidence$1.am;
  var lhsAggregate$2 = evidence$1.a0;
  if (evidence$1.K) {
    evidence$1.N = (!(!(evidence$1.N | oldCut$2)));
  } else if ((!evidence$1.N)) {
    var verboseFailures$2 = evidence$1.aj;
    evidence$1.G = startPos$2;
    if (verboseFailures$2) {
      evidence$1.aG(lhsMsg$2, evidence$1.a0, false);
    }
    evidence$1.N = false;
    $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__idNumeral__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1);
    var rhsMsg$2 = evidence$1.am;
    var rhsCut$2 = evidence$1.N;
    var endCut$2 = (!(!(rhsCut$2 | oldCut$2)));
    if (((!evidence$1.K) && (!rhsCut$2))) {
      evidence$1.ll(startPos$2);
    }
    evidence$1.N = endCut$2;
    if (verboseFailures$2) {
      var $x_2 = lhsMsg$2.bl(rhsMsg$2);
      var other$1$2 = evidence$1.a0;
      evidence$1.aG($x_2, lhsAggregate$2.bl(other$1$2), false);
    }
  }
  var lhsMsg$3 = evidence$1.am;
  var lhsAggregate$3 = evidence$1.a0;
  if (evidence$1.K) {
    evidence$1.N = (!(!(evidence$1.N | oldCut)));
    var ctx0 = evidence$1;
  } else if (evidence$1.N) {
    var ctx0 = evidence$1;
  } else {
    var verboseFailures$3 = evidence$1.aj;
    evidence$1.G = startPos;
    if (verboseFailures$3) {
      evidence$1.aG(lhsMsg$3, evidence$1.a0, false);
    }
    evidence$1.N = false;
    $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__idName__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1);
    var rhsMsg$3 = evidence$1.am;
    var rhsCut$3 = evidence$1.N;
    var endCut$3 = (!(!(rhsCut$3 | oldCut)));
    if (((!evidence$1.K) && (!rhsCut$3))) {
      evidence$1.ll(startPos);
    }
    evidence$1.N = endCut$3;
    if (verboseFailures$3) {
      var $x_3 = lhsMsg$3.bl(rhsMsg$3);
      var other$1$3 = evidence$1.a0;
      evidence$1.aG($x_3, lhsAggregate$3.bl(other$1$3), false);
    }
    var ctx0 = evidence$1;
  }
  if (instrument) {
    evidence$1.bk.hI(name$proxy9.aE, ctx0.G, ctx0.K);
  }
  if (ctx0.aj) {
    var newshortMsg$3 = $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => name$proxy9.aE)));
    var forceAggregate = (startIndex < ctx0.bq);
    ctx0.aG(newshortMsg$3, ctx0.a0, forceAggregate);
    if ((!ctx0.K)) {
      ctx0.cf = new $c_sci_$colon$colon(new $c_T2(name$proxy9.aE, startIndex), ctx0.cf);
    }
  }
  return ctx0;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__semiOpt__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1) {
  $m_Lsourcecode_Name$();
  var name$proxy10 = new $c_Lsourcecode_Name("semiOpt");
  var startIndex = evidence$1.G;
  var instrument = (evidence$1.bk !== null);
  if (instrument) {
    evidence$1.bk.hL(name$proxy10.aE, startIndex);
  }
  var ctx0 = $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__rec$5__Lfastparse_ParsingRun__I__Lfastparse_Implicits$Repeater__O__I__Lfastparse_ParsingRun__I__I__Z__Z__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_ParsingRun($thiz, evidence$1, 0, $m_Lfastparse_Implicits$Repeater$UnitRepeater$(), (void 0), 1, evidence$1, evidence$1.G, 0, false, evidence$1.N, null, null);
  if (instrument) {
    evidence$1.bk.hI(name$proxy10.aE, ctx0.G, ctx0.K);
  }
  if (ctx0.aj) {
    var newshortMsg = $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => name$proxy10.aE)));
    var forceAggregate = (startIndex < ctx0.bq);
    ctx0.aG(newshortMsg, ctx0.a0, forceAggregate);
    if ((!ctx0.K)) {
      ctx0.cf = new $c_sci_$colon$colon(new $c_T2(name$proxy10.aE, startIndex), ctx0.cf);
    }
  }
  return ctx0;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__attrSepOpt__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1) {
  $m_Lsourcecode_Name$();
  var name$proxy11 = new $c_Lsourcecode_Name("attrSepOpt");
  var startIndex = evidence$1.G;
  var instrument = (evidence$1.bk !== null);
  if (instrument) {
    evidence$1.bk.hL(name$proxy11.aE, startIndex);
  }
  var ctx0 = $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__rec$6__Lfastparse_ParsingRun__I__Lfastparse_Implicits$Repeater__O__I__Lfastparse_ParsingRun__I__I__Z__Z__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_ParsingRun($thiz, evidence$1, 0, $m_Lfastparse_Implicits$Repeater$UnitRepeater$(), (void 0), 1, evidence$1, evidence$1.G, 0, false, evidence$1.N, null, null);
  if (instrument) {
    evidence$1.bk.hI(name$proxy11.aE, ctx0.G, ctx0.K);
  }
  if (ctx0.aj) {
    var newshortMsg = $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => name$proxy11.aE)));
    var forceAggregate = (startIndex < ctx0.bq);
    ctx0.aG(newshortMsg, ctx0.a0, forceAggregate);
    if ((!ctx0.K)) {
      ctx0.cf = new $c_sci_$colon$colon(new $c_T2(name$proxy11.aE, startIndex), ctx0.cf);
    }
  }
  return ctx0;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__port__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1) {
  $m_Lsourcecode_Name$();
  var name$proxy12 = new $c_Lsourcecode_Name("port");
  var startIndex = evidence$1.G;
  var instrument = (evidence$1.bk !== null);
  if (instrument) {
    evidence$1.bk.hL(name$proxy12.aE, startIndex);
  }
  var s$proxy19 = $f_Lfastparse_LowestPriSequencer__Sequencer1__O($m_Lfastparse_Implicits$Sequencer$());
  var preLhsIndex = evidence$1.G;
  var input = evidence$1.b0;
  $m_Lfastparse_Implicits$Sequencer$();
  var preLhsIndex$2 = evidence$1.G;
  var input$2 = evidence$1.b0;
  var input$3 = evidence$1.b0;
  var index = evidence$1.G;
  if ((input$3.bc(index) && (input$3.cA.charCodeAt(index) === 58))) {
    evidence$1.dl(((1 + index) | 0));
  } else {
    evidence$1.dB();
  }
  if (evidence$1.aj) {
    evidence$1.de(index, $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => "\":\""))));
  }
  if (evidence$1.K) {
    var postLhsIndex = evidence$1.G;
    var lhsAggregate = evidence$1.a0;
    var lhsMsg = evidence$1.am;
    if ((postLhsIndex > preLhsIndex$2)) {
      evidence$1.b7();
    }
    $m_Lfastparse_internal_Util$().dJ($thiz.dK(), evidence$1);
    if (evidence$1.K) {
      if ((!((!evidence$1.K) && evidence$1.N))) {
        var preRhsIndex = evidence$1.G;
        $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__id__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1);
        var rhsAggregate = evidence$1.a0;
        var rhsMsg = evidence$1.am;
        if (evidence$1.K) {
          var postRhsIndex = evidence$1.G;
          var rhsMadeProgress = (postRhsIndex > preRhsIndex);
          var nextIndex = (((!rhsMadeProgress) && input$2.bc(postRhsIndex)) ? postLhsIndex : postRhsIndex);
          if (rhsMadeProgress) {
            evidence$1.b7();
          }
          evidence$1.cI(evidence$1.aB, nextIndex);
        }
        if (evidence$1.aj) {
          evidence$1.aG($m_Lfastparse_internal_Util$().dc(lhsMsg, rhsMsg), lhsAggregate.bl(rhsAggregate), (preRhsIndex === evidence$1.bq));
        }
      }
    }
  }
  if ((!evidence$1.K)) {
    var ctx0 = evidence$1;
  } else {
    var postLhsIndex$2 = evidence$1.G;
    var lhsAggregate$2 = evidence$1.a0;
    var lhsMsg$2 = evidence$1.am;
    if ((postLhsIndex$2 > preLhsIndex)) {
      evidence$1.b7();
    }
    var lhsValue$2 = evidence$1.aB;
    $m_Lfastparse_internal_Util$().dJ($thiz.dK(), evidence$1);
    if (evidence$1.K) {
      if (((!evidence$1.K) && evidence$1.N)) {
        var ctx0 = evidence$1;
      } else {
        var preRhsIndex$2 = evidence$1.G;
        $m_Lfastparse_Implicits$Optioner$().W7();
        var startPos = evidence$1.G;
        var startCut = evidence$1.N;
        evidence$1.N = false;
        $m_Lfastparse_Implicits$Sequencer$();
        var preLhsIndex$3 = evidence$1.G;
        var input$4 = evidence$1.b0;
        var input$5 = evidence$1.b0;
        var index$2 = evidence$1.G;
        if ((input$5.bc(index$2) && (input$5.cA.charCodeAt(index$2) === 58))) {
          evidence$1.dl(((1 + index$2) | 0));
        } else {
          evidence$1.dB();
        }
        if (evidence$1.aj) {
          evidence$1.de(index$2, $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => "\":\""))));
        }
        if (evidence$1.K) {
          var postLhsIndex$3 = evidence$1.G;
          var lhsAggregate$3 = evidence$1.a0;
          var lhsMsg$3 = evidence$1.am;
          if ((postLhsIndex$3 > preLhsIndex$3)) {
            evidence$1.b7();
          }
          $m_Lfastparse_internal_Util$().dJ($thiz.dK(), evidence$1);
          if (evidence$1.K) {
            if ((!((!evidence$1.K) && evidence$1.N))) {
              var preRhsIndex$3 = evidence$1.G;
              $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__idName__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1);
              var rhsAggregate$2 = evidence$1.a0;
              var rhsMsg$2 = evidence$1.am;
              if (evidence$1.K) {
                var postRhsIndex$2 = evidence$1.G;
                var rhsMadeProgress$2 = (postRhsIndex$2 > preRhsIndex$3);
                var nextIndex$2 = (((!rhsMadeProgress$2) && input$4.bc(postRhsIndex$2)) ? postLhsIndex$3 : postRhsIndex$2);
                if (rhsMadeProgress$2) {
                  evidence$1.b7();
                }
                evidence$1.cI(evidence$1.aB, nextIndex$2);
              }
              if (evidence$1.aj) {
                evidence$1.aG($m_Lfastparse_internal_Util$().dc(lhsMsg$3, rhsMsg$2), lhsAggregate$3.bl(rhsAggregate$2), (preRhsIndex$3 === evidence$1.bq));
              }
            }
          }
        }
        var postSuccess = evidence$1.K;
        if (postSuccess) {
          var res$5 = evidence$1.u2(new $c_s_Some(evidence$1.aB));
          res$5.N = (!(!(res$5.N | startCut)));
        } else if ((!evidence$1.N)) {
          var res$6 = evidence$1.cI($m_s_None$(), startPos);
          res$6.N = (!(!(res$6.N | startCut)));
        }
        if (evidence$1.aj) {
          var msg = evidence$1.am;
          if ((!postSuccess)) {
            evidence$1.aG($m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => ($m_Lfastparse_internal_Util$().pA(msg.j3) + ".?")))), evidence$1.a0, false);
          }
        }
        var rhsAggregate$3 = evidence$1.a0;
        var rhsMsg$3 = evidence$1.am;
        if ((!evidence$1.K)) {
          var res$8 = evidence$1;
        } else {
          var postRhsIndex$3 = evidence$1.G;
          var rhsMadeProgress$3 = (postRhsIndex$3 > preRhsIndex$2);
          var nextIndex$3 = (((!rhsMadeProgress$3) && input.bc(postRhsIndex$3)) ? postLhsIndex$2 : postRhsIndex$3);
          if (rhsMadeProgress$3) {
            evidence$1.b7();
          }
          var res$8 = evidence$1.cI(s$proxy19.R(lhsValue$2, evidence$1.aB), nextIndex$3);
        }
        if (evidence$1.aj) {
          evidence$1.aG($m_Lfastparse_internal_Util$().dc(lhsMsg$2, rhsMsg$3), lhsAggregate$2.bl(rhsAggregate$3), (preRhsIndex$2 === evidence$1.bq));
        }
        var ctx0 = res$8;
      }
    } else {
      var ctx0 = evidence$1;
    }
  }
  if (instrument) {
    evidence$1.bk.hI(name$proxy12.aE, ctx0.G, ctx0.K);
  }
  if (ctx0.aj) {
    var newshortMsg$1 = $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => name$proxy12.aE)));
    var forceAggregate = (startIndex < ctx0.bq);
    ctx0.aG(newshortMsg$1, ctx0.a0, forceAggregate);
    if ((!ctx0.K)) {
      ctx0.cf = new $c_sci_$colon$colon(new $c_T2(name$proxy12.aE, startIndex), ctx0.cf);
    }
  }
  if ((!ctx0.K)) {
    return ctx0;
  } else {
    var x$1 = ctx0.aB;
    matchResult33: {
      var $x_1;
      if ((x$1 !== null)) {
        var x40 = x$1.g();
        var x41 = x$1.h();
        if ((x41 instanceof $c_s_Some)) {
          var second = x41.J;
          var $x_1 = new $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Port(new $c_s_Some(x40), $m_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$().Pm(second.fU));
          break matchResult33;
        }
        if (($m_s_None$() === x41)) {
          var x34 = $m_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$().Pm(x40.fU);
          if ((x34 instanceof $c_s_Some)) {
            var $x_1 = new $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Port($m_s_None$(), new $c_s_Some(x34.J));
            break matchResult33;
          }
          if (($m_s_None$() === x34)) {
            var $x_1 = new $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Port(new $c_s_Some(x40), $m_s_None$());
            break matchResult33;
          }
          throw new $c_s_MatchError(x34);
        }
      }
      throw new $c_s_MatchError(x$1);
    }
    ctx0.aB = $x_1;
    return ctx0;
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__nodeId__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1) {
  $m_Lsourcecode_Name$();
  var name$proxy13 = new $c_Lsourcecode_Name("nodeId");
  var startIndex = evidence$1.G;
  var instrument = (evidence$1.bk !== null);
  if (instrument) {
    evidence$1.bk.hL(name$proxy13.aE, startIndex);
  }
  var s$proxy20 = $f_Lfastparse_LowestPriSequencer__Sequencer1__O($m_Lfastparse_Implicits$Sequencer$());
  var preLhsIndex = evidence$1.G;
  var input = evidence$1.b0;
  $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__id__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1);
  if ((!evidence$1.K)) {
    var ctx0 = evidence$1;
  } else {
    var postLhsIndex = evidence$1.G;
    var lhsAggregate = evidence$1.a0;
    var lhsMsg = evidence$1.am;
    if ((postLhsIndex > preLhsIndex)) {
      evidence$1.b7();
    }
    var lhsValue = evidence$1.aB;
    $m_Lfastparse_internal_Util$().dJ($thiz.dK(), evidence$1);
    if (evidence$1.K) {
      if (((!evidence$1.K) && evidence$1.N)) {
        var ctx0 = evidence$1;
      } else {
        var preRhsIndex = evidence$1.G;
        $m_Lfastparse_Implicits$Optioner$().W7();
        var startPos = evidence$1.G;
        var startCut = evidence$1.N;
        evidence$1.N = false;
        $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__port__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1);
        var postSuccess = evidence$1.K;
        if (postSuccess) {
          var res = evidence$1.u2(new $c_s_Some(evidence$1.aB));
          res.N = (!(!(res.N | startCut)));
        } else if ((!evidence$1.N)) {
          var res$2 = evidence$1.cI($m_s_None$(), startPos);
          res$2.N = (!(!(res$2.N | startCut)));
        }
        if (evidence$1.aj) {
          var msg = evidence$1.am;
          if ((!postSuccess)) {
            evidence$1.aG($m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => ($m_Lfastparse_internal_Util$().pA(msg.j3) + ".?")))), evidence$1.a0, false);
          }
        }
        var rhsAggregate = evidence$1.a0;
        var rhsMsg = evidence$1.am;
        if ((!evidence$1.K)) {
          var res$4 = evidence$1;
        } else {
          var postRhsIndex = evidence$1.G;
          var rhsMadeProgress = (postRhsIndex > preRhsIndex);
          var nextIndex = (((!rhsMadeProgress) && input.bc(postRhsIndex)) ? postLhsIndex : postRhsIndex);
          if (rhsMadeProgress) {
            evidence$1.b7();
          }
          var res$4 = evidence$1.cI(s$proxy20.R(lhsValue, evidence$1.aB), nextIndex);
        }
        if (evidence$1.aj) {
          evidence$1.aG($m_Lfastparse_internal_Util$().dc(lhsMsg, rhsMsg), lhsAggregate.bl(rhsAggregate), (preRhsIndex === evidence$1.bq));
        }
        var ctx0 = res$4;
      }
    } else {
      var ctx0 = evidence$1;
    }
  }
  if (instrument) {
    evidence$1.bk.hI(name$proxy13.aE, ctx0.G, ctx0.K);
  }
  if (ctx0.aj) {
    var newshortMsg$1 = $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => name$proxy13.aE)));
    var forceAggregate = (startIndex < ctx0.bq);
    ctx0.aG(newshortMsg$1, ctx0.a0, forceAggregate);
    if ((!ctx0.K)) {
      ctx0.cf = new $c_sci_$colon$colon(new $c_T2(name$proxy13.aE, startIndex), ctx0.cf);
    }
  }
  if ((!ctx0.K)) {
    return ctx0;
  } else {
    var x$1 = ctx0.aB;
    matchResult34: {
      var $x_1;
      if ((x$1 !== null)) {
        var $x_1 = new $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_NodeId(x$1.g(), x$1.h());
        break matchResult34;
      }
      throw new $c_s_MatchError(x$1);
    }
    ctx0.aB = $x_1;
    return ctx0;
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__attrPair__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1) {
  $m_Lsourcecode_Name$();
  var name$proxy14 = new $c_Lsourcecode_Name("attrPair");
  var startIndex = evidence$1.G;
  var instrument = (evidence$1.bk !== null);
  if (instrument) {
    evidence$1.bk.hL(name$proxy14.aE, startIndex);
  }
  $m_Lfastparse_Implicits$Sequencer$().qP();
  var preLhsIndex = evidence$1.G;
  var input = evidence$1.b0;
  var s$proxy22 = $f_Lfastparse_LowestPriSequencer__Sequencer1__O($m_Lfastparse_Implicits$Sequencer$());
  var preLhsIndex$2 = evidence$1.G;
  var input$2 = evidence$1.b0;
  $m_Lfastparse_Implicits$Sequencer$().qP();
  var preLhsIndex$3 = evidence$1.G;
  var input$3 = evidence$1.b0;
  $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__id__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1);
  if (evidence$1.K) {
    var postLhsIndex = evidence$1.G;
    var lhsAggregate = evidence$1.a0;
    var lhsMsg = evidence$1.am;
    if ((postLhsIndex > preLhsIndex$3)) {
      evidence$1.b7();
    }
    var lhsValue = evidence$1.aB;
    $m_Lfastparse_internal_Util$().dJ($thiz.dK(), evidence$1);
    if (evidence$1.K) {
      if ((!((!evidence$1.K) && evidence$1.N))) {
        var preRhsIndex = evidence$1.G;
        var input$4 = evidence$1.b0;
        var index = evidence$1.G;
        if ((input$4.bc(index) && (input$4.cA.charCodeAt(index) === 61))) {
          evidence$1.dl(((1 + index) | 0));
        } else {
          evidence$1.dB();
        }
        if (evidence$1.aj) {
          evidence$1.de(index, $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => "\"=\""))));
        }
        var rhsAggregate = evidence$1.a0;
        var rhsMsg = evidence$1.am;
        if (evidence$1.K) {
          var postRhsIndex = evidence$1.G;
          var rhsMadeProgress = (postRhsIndex > preRhsIndex);
          var nextIndex = (((!rhsMadeProgress) && input$3.bc(postRhsIndex)) ? postLhsIndex : postRhsIndex);
          if (rhsMadeProgress) {
            evidence$1.b7();
          }
          evidence$1.cI(lhsValue, nextIndex);
        }
        if (evidence$1.aj) {
          evidence$1.aG($m_Lfastparse_internal_Util$().dc(lhsMsg, rhsMsg), lhsAggregate.bl(rhsAggregate), (preRhsIndex === evidence$1.bq));
        }
      }
    }
  }
  if (evidence$1.K) {
    var postLhsIndex$2 = evidence$1.G;
    var lhsAggregate$2 = evidence$1.a0;
    var lhsMsg$2 = evidence$1.am;
    if ((postLhsIndex$2 > preLhsIndex$2)) {
      evidence$1.b7();
    }
    var lhsValue$2 = evidence$1.aB;
    $m_Lfastparse_internal_Util$().dJ($thiz.dK(), evidence$1);
    if (evidence$1.K) {
      if ((!((!evidence$1.K) && evidence$1.N))) {
        var preRhsIndex$2 = evidence$1.G;
        $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__id__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1);
        var rhsAggregate$2 = evidence$1.a0;
        var rhsMsg$2 = evidence$1.am;
        if (evidence$1.K) {
          var postRhsIndex$2 = evidence$1.G;
          var rhsMadeProgress$2 = (postRhsIndex$2 > preRhsIndex$2);
          var nextIndex$2 = (((!rhsMadeProgress$2) && input$2.bc(postRhsIndex$2)) ? postLhsIndex$2 : postRhsIndex$2);
          if (rhsMadeProgress$2) {
            evidence$1.b7();
          }
          evidence$1.cI(s$proxy22.R(lhsValue$2, evidence$1.aB), nextIndex$2);
        }
        if (evidence$1.aj) {
          evidence$1.aG($m_Lfastparse_internal_Util$().dc(lhsMsg$2, rhsMsg$2), lhsAggregate$2.bl(rhsAggregate$2), (preRhsIndex$2 === evidence$1.bq));
        }
      }
    }
  }
  if ((!evidence$1.K)) {
    var ctx0 = evidence$1;
  } else {
    var postLhsIndex$3 = evidence$1.G;
    var lhsAggregate$3 = evidence$1.a0;
    var lhsMsg$3 = evidence$1.am;
    if ((postLhsIndex$3 > preLhsIndex)) {
      evidence$1.b7();
    }
    var lhsValue$3 = evidence$1.aB;
    $m_Lfastparse_internal_Util$().dJ($thiz.dK(), evidence$1);
    if (evidence$1.K) {
      if (((!evidence$1.K) && evidence$1.N)) {
        var ctx0 = evidence$1;
      } else {
        var preRhsIndex$3 = evidence$1.G;
        $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__attrSepOpt__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1);
        var rhsAggregate$3 = evidence$1.a0;
        var rhsMsg$3 = evidence$1.am;
        if ((!evidence$1.K)) {
          var res$4 = evidence$1;
        } else {
          var postRhsIndex$3 = evidence$1.G;
          var rhsMadeProgress$3 = (postRhsIndex$3 > preRhsIndex$3);
          var nextIndex$3 = (((!rhsMadeProgress$3) && input.bc(postRhsIndex$3)) ? postLhsIndex$3 : postRhsIndex$3);
          if (rhsMadeProgress$3) {
            evidence$1.b7();
          }
          var res$4 = evidence$1.cI(lhsValue$3, nextIndex$3);
        }
        if (evidence$1.aj) {
          evidence$1.aG($m_Lfastparse_internal_Util$().dc(lhsMsg$3, rhsMsg$3), lhsAggregate$3.bl(rhsAggregate$3), (preRhsIndex$3 === evidence$1.bq));
        }
        var ctx0 = res$4;
      }
    } else {
      var ctx0 = evidence$1;
    }
  }
  if (instrument) {
    evidence$1.bk.hI(name$proxy14.aE, ctx0.G, ctx0.K);
  }
  if (ctx0.aj) {
    var newshortMsg = $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => name$proxy14.aE)));
    var forceAggregate = (startIndex < ctx0.bq);
    ctx0.aG(newshortMsg, ctx0.a0, forceAggregate);
    if ((!ctx0.K)) {
      ctx0.cf = new $c_sci_$colon$colon(new $c_T2(name$proxy14.aE, startIndex), ctx0.cf);
    }
  }
  if ((!ctx0.K)) {
    return ctx0;
  } else {
    var x$1 = ctx0.aB;
    matchResult36$1: {
      var $x_1;
      if ((x$1 !== null)) {
        var $x_1 = new $c_T2(x$1.g(), x$1.h());
        break matchResult36$1;
      }
      throw new $c_s_MatchError(x$1);
    }
    ctx0.aB = $x_1;
    return ctx0;
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__attrGroups__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1) {
  $m_Lsourcecode_Name$();
  var name$proxy15 = new $c_Lsourcecode_Name("attrGroups");
  var startIndex = evidence$1.G;
  var instrument = (evidence$1.bk !== null);
  if (instrument) {
    evidence$1.bk.hL(name$proxy15.aE, startIndex);
  }
  var ctx0 = $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__rec$7__Lfastparse_ParsingRun__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__I__I__Z__Z__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_ParsingRun($thiz, evidence$1, 0, evidence$1, $m_Lfastparse_Implicits$Repeater$().Ad(), $m_scm_Buffer$().f7(), evidence$1.G, 0, false, evidence$1.N, null, null);
  if (instrument) {
    evidence$1.bk.hI(name$proxy15.aE, ctx0.G, ctx0.K);
  }
  if (ctx0.aj) {
    var newshortMsg = $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => name$proxy15.aE)));
    var forceAggregate = (startIndex < ctx0.bq);
    ctx0.aG(newshortMsg, ctx0.a0, forceAggregate);
    if ((!ctx0.K)) {
      ctx0.cf = new $c_sci_$colon$colon(new $c_T2(name$proxy15.aE, startIndex), ctx0.cf);
    }
  }
  if ((!ctx0.K)) {
    return ctx0;
  } else {
    ctx0.aB = ctx0.aB.dk($m_s_$less$colon$less$().b1).bM();
    return ctx0;
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__attrGroups1__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1) {
  $m_Lsourcecode_Name$();
  var name$proxy16 = new $c_Lsourcecode_Name("attrGroups1");
  var startIndex = evidence$1.G;
  var instrument = (evidence$1.bk !== null);
  if (instrument) {
    evidence$1.bk.hL(name$proxy16.aE, startIndex);
  }
  var ctx0 = $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__rec$10__Lfastparse_ParsingRun__I__Lfastparse_Implicits$Repeater__O__Lfastparse_ParsingRun__I__I__Z__Z__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_ParsingRun($thiz, evidence$1, 1, $m_Lfastparse_Implicits$Repeater$().Ad(), $m_scm_Buffer$().f7(), evidence$1, evidence$1.G, 0, false, evidence$1.N, null, null);
  if (instrument) {
    evidence$1.bk.hI(name$proxy16.aE, ctx0.G, ctx0.K);
  }
  if (ctx0.aj) {
    var newshortMsg = $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => name$proxy16.aE)));
    var forceAggregate = (startIndex < ctx0.bq);
    ctx0.aG(newshortMsg, ctx0.a0, forceAggregate);
    if ((!ctx0.K)) {
      ctx0.cf = new $c_sci_$colon$colon(new $c_T2(name$proxy16.aE, startIndex), ctx0.cf);
    }
  }
  if ((!ctx0.K)) {
    return ctx0;
  } else {
    ctx0.aB = ctx0.aB.dk($m_s_$less$colon$less$().b1).bM();
    return ctx0;
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__attrTarget__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1) {
  $m_Lsourcecode_Name$();
  var name$proxy17 = new $c_Lsourcecode_Name("attrTarget");
  var startIndex = evidence$1.G;
  var instrument = (evidence$1.bk !== null);
  if (instrument) {
    evidence$1.bk.hL(name$proxy17.aE, startIndex);
  }
  var oldCut = evidence$1.N;
  evidence$1.N = false;
  var startPos = evidence$1.G;
  var oldCut$2 = evidence$1.N;
  evidence$1.N = false;
  var startPos$2 = evidence$1.G;
  var lhs$proxy15 = $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__kw__T__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, "graph", evidence$1);
  if (lhs$proxy15.K) {
    lhs$proxy15.aB = $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$__Graph__Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget();
  }
  var lhsMsg = evidence$1.am;
  var lhsAggregate = evidence$1.a0;
  if (evidence$1.K) {
    evidence$1.N = (!(!(evidence$1.N | oldCut$2)));
  } else if ((!evidence$1.N)) {
    var verboseFailures = evidence$1.aj;
    evidence$1.G = startPos$2;
    if (verboseFailures) {
      evidence$1.aG(lhsMsg, evidence$1.a0, false);
    }
    evidence$1.N = false;
    var lhs$proxy16 = $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__kw__T__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, "node", evidence$1);
    if (lhs$proxy16.K) {
      lhs$proxy16.aB = $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$__Node__Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget();
    }
    var rhsMsg = evidence$1.am;
    var rhsCut = evidence$1.N;
    var endCut = (!(!(rhsCut | oldCut$2)));
    if (((!evidence$1.K) && (!rhsCut))) {
      evidence$1.ll(startPos$2);
    }
    evidence$1.N = endCut;
    if (verboseFailures) {
      var $x_1 = lhsMsg.bl(rhsMsg);
      var other$1 = evidence$1.a0;
      evidence$1.aG($x_1, lhsAggregate.bl(other$1), false);
    }
  }
  var lhsMsg$2 = evidence$1.am;
  var lhsAggregate$2 = evidence$1.a0;
  if (evidence$1.K) {
    evidence$1.N = (!(!(evidence$1.N | oldCut)));
    var ctx0 = evidence$1;
  } else if (evidence$1.N) {
    var ctx0 = evidence$1;
  } else {
    var verboseFailures$2 = evidence$1.aj;
    evidence$1.G = startPos;
    if (verboseFailures$2) {
      evidence$1.aG(lhsMsg$2, evidence$1.a0, false);
    }
    evidence$1.N = false;
    var lhs$proxy17 = $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__kw__T__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, "edge", evidence$1);
    if (lhs$proxy17.K) {
      lhs$proxy17.aB = $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$__Edge__Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget();
    }
    var rhsMsg$2 = evidence$1.am;
    var rhsCut$2 = evidence$1.N;
    var endCut$2 = (!(!(rhsCut$2 | oldCut)));
    if (((!evidence$1.K) && (!rhsCut$2))) {
      evidence$1.ll(startPos);
    }
    evidence$1.N = endCut$2;
    if (verboseFailures$2) {
      var $x_2 = lhsMsg$2.bl(rhsMsg$2);
      var other$1$2 = evidence$1.a0;
      evidence$1.aG($x_2, lhsAggregate$2.bl(other$1$2), false);
    }
    var ctx0 = evidence$1;
  }
  if (instrument) {
    evidence$1.bk.hI(name$proxy17.aE, ctx0.G, ctx0.K);
  }
  if (ctx0.aj) {
    var newshortMsg$2 = $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => name$proxy17.aE)));
    var forceAggregate = (startIndex < ctx0.bq);
    ctx0.aG(newshortMsg$2, ctx0.a0, forceAggregate);
    if ((!ctx0.K)) {
      ctx0.cf = new $c_sci_$colon$colon(new $c_T2(name$proxy17.aE, startIndex), ctx0.cf);
    }
  }
  return ctx0;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__subgraph__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1) {
  $m_Lsourcecode_Name$();
  var name$proxy18 = new $c_Lsourcecode_Name("subgraph");
  var startIndex = evidence$1.G;
  var instrument = (evidence$1.bk !== null);
  if (instrument) {
    evidence$1.bk.hL(name$proxy18.aE, startIndex);
  }
  $m_Lfastparse_Implicits$Sequencer$().qP();
  var preLhsIndex = evidence$1.G;
  var input = evidence$1.b0;
  var s$proxy30 = $f_Lfastparse_LowestPriSequencer__Sequencer1__O($m_Lfastparse_Implicits$Sequencer$());
  var preLhsIndex$2 = evidence$1.G;
  var input$2 = evidence$1.b0;
  $m_Lfastparse_Implicits$Sequencer$().qP();
  var preLhsIndex$3 = evidence$1.G;
  var input$3 = evidence$1.b0;
  $m_Lfastparse_Implicits$Optioner$().W7();
  var startPos = evidence$1.G;
  var startCut = evidence$1.N;
  evidence$1.N = false;
  $m_Lfastparse_Implicits$Sequencer$();
  var preLhsIndex$4 = evidence$1.G;
  var input$4 = evidence$1.b0;
  $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__kw__T__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, "subgraph", evidence$1);
  if (evidence$1.K) {
    var postLhsIndex = evidence$1.G;
    var lhsAggregate = evidence$1.a0;
    var lhsMsg = evidence$1.am;
    if ((postLhsIndex > preLhsIndex$4)) {
      evidence$1.b7();
    }
    $m_Lfastparse_internal_Util$().dJ($thiz.dK(), evidence$1);
    if (evidence$1.K) {
      if ((!((!evidence$1.K) && evidence$1.N))) {
        var preRhsIndex = evidence$1.G;
        $m_Lfastparse_Implicits$Optioner$().W7();
        var startPos$2 = evidence$1.G;
        var startCut$2 = evidence$1.N;
        evidence$1.N = false;
        $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__id__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1);
        var postSuccess = evidence$1.K;
        if (postSuccess) {
          var res = evidence$1.u2(new $c_s_Some(evidence$1.aB));
          res.N = (!(!(res.N | startCut$2)));
        } else if ((!evidence$1.N)) {
          var res$2 = evidence$1.cI($m_s_None$(), startPos$2);
          res$2.N = (!(!(res$2.N | startCut$2)));
        }
        if (evidence$1.aj) {
          var msg = evidence$1.am;
          if ((!postSuccess)) {
            evidence$1.aG($m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => ($m_Lfastparse_internal_Util$().pA(msg.j3) + ".?")))), evidence$1.a0, false);
          }
        }
        var rhsAggregate = evidence$1.a0;
        var rhsMsg = evidence$1.am;
        if (evidence$1.K) {
          var postRhsIndex = evidence$1.G;
          var rhsMadeProgress = (postRhsIndex > preRhsIndex);
          var nextIndex = (((!rhsMadeProgress) && input$4.bc(postRhsIndex)) ? postLhsIndex : postRhsIndex);
          if (rhsMadeProgress) {
            evidence$1.b7();
          }
          evidence$1.cI(evidence$1.aB, nextIndex);
        }
        if (evidence$1.aj) {
          evidence$1.aG($m_Lfastparse_internal_Util$().dc(lhsMsg, rhsMsg), lhsAggregate.bl(rhsAggregate), (preRhsIndex === evidence$1.bq));
        }
      }
    }
  }
  var postSuccess$2 = evidence$1.K;
  if (postSuccess$2) {
    var res$5 = evidence$1.u2(new $c_s_Some(evidence$1.aB));
    res$5.N = (!(!(res$5.N | startCut)));
  } else if ((!evidence$1.N)) {
    var res$6 = evidence$1.cI($m_s_None$(), startPos);
    res$6.N = (!(!(res$6.N | startCut)));
  }
  if (evidence$1.aj) {
    var msg$3 = evidence$1.am;
    if ((!postSuccess$2)) {
      evidence$1.aG($m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => ($m_Lfastparse_internal_Util$().pA(msg$3.j3) + ".?")))), evidence$1.a0, false);
    }
  }
  if (evidence$1.K) {
    var postLhsIndex$2 = evidence$1.G;
    var lhsAggregate$2 = evidence$1.a0;
    var lhsMsg$2 = evidence$1.am;
    if ((postLhsIndex$2 > preLhsIndex$3)) {
      evidence$1.b7();
    }
    var lhsValue$2 = evidence$1.aB;
    $m_Lfastparse_internal_Util$().dJ($thiz.dK(), evidence$1);
    if (evidence$1.K) {
      if ((!((!evidence$1.K) && evidence$1.N))) {
        var preRhsIndex$2 = evidence$1.G;
        var input$5 = evidence$1.b0;
        var index = evidence$1.G;
        if ((input$5.bc(index) && (input$5.cA.charCodeAt(index) === 123))) {
          evidence$1.dl(((1 + index) | 0));
        } else {
          evidence$1.dB();
        }
        if (evidence$1.aj) {
          evidence$1.de(index, $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => "\"{\""))));
        }
        var rhsAggregate$2 = evidence$1.a0;
        var rhsMsg$2 = evidence$1.am;
        if (evidence$1.K) {
          var postRhsIndex$2 = evidence$1.G;
          var rhsMadeProgress$2 = (postRhsIndex$2 > preRhsIndex$2);
          var nextIndex$2 = (((!rhsMadeProgress$2) && input$3.bc(postRhsIndex$2)) ? postLhsIndex$2 : postRhsIndex$2);
          if (rhsMadeProgress$2) {
            evidence$1.b7();
          }
          evidence$1.cI(lhsValue$2, nextIndex$2);
        }
        if (evidence$1.aj) {
          evidence$1.aG($m_Lfastparse_internal_Util$().dc(lhsMsg$2, rhsMsg$2), lhsAggregate$2.bl(rhsAggregate$2), (preRhsIndex$2 === evidence$1.bq));
        }
      }
    }
  }
  if (evidence$1.K) {
    var postLhsIndex$3 = evidence$1.G;
    var lhsAggregate$3 = evidence$1.a0;
    var lhsMsg$3 = evidence$1.am;
    if ((postLhsIndex$3 > preLhsIndex$2)) {
      evidence$1.b7();
    }
    var lhsValue$3 = evidence$1.aB;
    $m_Lfastparse_internal_Util$().dJ($thiz.dK(), evidence$1);
    if (evidence$1.K) {
      if ((!((!evidence$1.K) && evidence$1.N))) {
        var preRhsIndex$3 = evidence$1.G;
        $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__stmtList__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1);
        var rhsAggregate$3 = evidence$1.a0;
        var rhsMsg$3 = evidence$1.am;
        if (evidence$1.K) {
          var postRhsIndex$3 = evidence$1.G;
          var rhsMadeProgress$3 = (postRhsIndex$3 > preRhsIndex$3);
          var nextIndex$3 = (((!rhsMadeProgress$3) && input$2.bc(postRhsIndex$3)) ? postLhsIndex$3 : postRhsIndex$3);
          if (rhsMadeProgress$3) {
            evidence$1.b7();
          }
          evidence$1.cI(s$proxy30.R(lhsValue$3, evidence$1.aB), nextIndex$3);
        }
        if (evidence$1.aj) {
          evidence$1.aG($m_Lfastparse_internal_Util$().dc(lhsMsg$3, rhsMsg$3), lhsAggregate$3.bl(rhsAggregate$3), (preRhsIndex$3 === evidence$1.bq));
        }
      }
    }
  }
  if ((!evidence$1.K)) {
    var ctx0 = evidence$1;
  } else {
    var postLhsIndex$4 = evidence$1.G;
    var lhsAggregate$4 = evidence$1.a0;
    var lhsMsg$4 = evidence$1.am;
    if ((postLhsIndex$4 > preLhsIndex)) {
      evidence$1.b7();
    }
    var lhsValue$4 = evidence$1.aB;
    $m_Lfastparse_internal_Util$().dJ($thiz.dK(), evidence$1);
    if (evidence$1.K) {
      if (((!evidence$1.K) && evidence$1.N)) {
        var ctx0 = evidence$1;
      } else {
        var preRhsIndex$4 = evidence$1.G;
        var input$6 = evidence$1.b0;
        var index$2 = evidence$1.G;
        if ((input$6.bc(index$2) && (input$6.cA.charCodeAt(index$2) === 125))) {
          evidence$1.dl(((1 + index$2) | 0));
        } else {
          evidence$1.dB();
        }
        if (evidence$1.aj) {
          evidence$1.de(index$2, $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => "\"}\""))));
        }
        var rhsAggregate$4 = evidence$1.a0;
        var rhsMsg$4 = evidence$1.am;
        if ((!evidence$1.K)) {
          var res$12 = evidence$1;
        } else {
          var postRhsIndex$4 = evidence$1.G;
          var rhsMadeProgress$4 = (postRhsIndex$4 > preRhsIndex$4);
          var nextIndex$4 = (((!rhsMadeProgress$4) && input.bc(postRhsIndex$4)) ? postLhsIndex$4 : postRhsIndex$4);
          if (rhsMadeProgress$4) {
            evidence$1.b7();
          }
          var res$12 = evidence$1.cI(lhsValue$4, nextIndex$4);
        }
        if (evidence$1.aj) {
          evidence$1.aG($m_Lfastparse_internal_Util$().dc(lhsMsg$4, rhsMsg$4), lhsAggregate$4.bl(rhsAggregate$4), (preRhsIndex$4 === evidence$1.bq));
        }
        var ctx0 = res$12;
      }
    } else {
      var ctx0 = evidence$1;
    }
  }
  if (instrument) {
    evidence$1.bk.hI(name$proxy18.aE, ctx0.G, ctx0.K);
  }
  if (ctx0.aj) {
    var newshortMsg$2 = $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => name$proxy18.aE)));
    var forceAggregate = (startIndex < ctx0.bq);
    ctx0.aG(newshortMsg$2, ctx0.a0, forceAggregate);
    if ((!ctx0.K)) {
      ctx0.cf = new $c_sci_$colon$colon(new $c_T2(name$proxy18.aE, startIndex), ctx0.cf);
    }
  }
  if ((!ctx0.K)) {
    return ctx0;
  } else {
    var x$1 = ctx0.aB;
    matchResult43: {
      var $x_1;
      if ((x$1 !== null)) {
        var pfx = x$1.g();
        var stmts = x$1.h();
        var $x_1 = new $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Subgraph(pfx.WS($m_s_$less$colon$less$().b1), stmts);
        break matchResult43;
      }
      throw new $c_s_MatchError(x$1);
    }
    ctx0.aB = $x_1;
    return ctx0;
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__nodeList__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1) {
  $m_Lsourcecode_Name$();
  var name$proxy19 = new $c_Lsourcecode_Name("nodeList");
  var startIndex = evidence$1.G;
  var instrument = (evidence$1.bk !== null);
  if (instrument) {
    evidence$1.bk.hL(name$proxy19.aE, startIndex);
  }
  var s$proxy33 = $f_Lfastparse_LowestPriSequencer__Sequencer1__O($m_Lfastparse_Implicits$Sequencer$());
  var preLhsIndex = evidence$1.G;
  var input = evidence$1.b0;
  $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__nodeId__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1);
  if ((!evidence$1.K)) {
    var ctx0 = evidence$1;
  } else {
    var postLhsIndex = evidence$1.G;
    var lhsAggregate = evidence$1.a0;
    var lhsMsg = evidence$1.am;
    if ((postLhsIndex > preLhsIndex)) {
      evidence$1.b7();
    }
    var lhsValue = evidence$1.aB;
    $m_Lfastparse_internal_Util$().dJ($thiz.dK(), evidence$1);
    if (evidence$1.K) {
      if (((!evidence$1.K) && evidence$1.N)) {
        var ctx0 = evidence$1;
      } else {
        var preRhsIndex = evidence$1.G;
        $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__rec$11__Lfastparse_ParsingRun__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__I__I__Z__Z__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_ParsingRun($thiz, evidence$1, 0, evidence$1, $m_Lfastparse_Implicits$Repeater$().Ad(), $m_scm_Buffer$().f7(), evidence$1.G, 0, false, evidence$1.N, null, null);
        var rhsAggregate = evidence$1.a0;
        var rhsMsg = evidence$1.am;
        if ((!evidence$1.K)) {
          var res = evidence$1;
        } else {
          var postRhsIndex = evidence$1.G;
          var rhsMadeProgress = (postRhsIndex > preRhsIndex);
          var nextIndex = (((!rhsMadeProgress) && input.bc(postRhsIndex)) ? postLhsIndex : postRhsIndex);
          if (rhsMadeProgress) {
            evidence$1.b7();
          }
          var res = evidence$1.cI(s$proxy33.R(lhsValue, evidence$1.aB), nextIndex);
        }
        if (evidence$1.aj) {
          evidence$1.aG($m_Lfastparse_internal_Util$().dc(lhsMsg, rhsMsg), lhsAggregate.bl(rhsAggregate), (preRhsIndex === evidence$1.bq));
        }
        var ctx0 = res;
      }
    } else {
      var ctx0 = evidence$1;
    }
  }
  if (instrument) {
    evidence$1.bk.hI(name$proxy19.aE, ctx0.G, ctx0.K);
  }
  if (ctx0.aj) {
    var newshortMsg = $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => name$proxy19.aE)));
    var forceAggregate = (startIndex < ctx0.bq);
    ctx0.aG(newshortMsg, ctx0.a0, forceAggregate);
    if ((!ctx0.K)) {
      ctx0.cf = new $c_sci_$colon$colon(new $c_T2(name$proxy19.aE, startIndex), ctx0.cf);
    }
  }
  if ((!ctx0.K)) {
    return ctx0;
  } else {
    var x$1 = ctx0.aB;
    ctx0.aB = new $c_sci_$colon$colon(x$1.g(), x$1.h().bM());
    return ctx0;
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__rawEnd__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1) {
  $m_Lsourcecode_Name$();
  var name$proxy20 = new $c_Lsourcecode_Name("rawEnd");
  var startIndex = evidence$1.G;
  var instrument = (evidence$1.bk !== null);
  if (instrument) {
    evidence$1.bk.hL(name$proxy20.aE, startIndex);
  }
  var oldCut = evidence$1.N;
  evidence$1.N = false;
  var startPos = evidence$1.G;
  var lhs$proxy20 = $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__subgraph__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1);
  if (lhs$proxy20.K) {
    lhs$proxy20.aB = new $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$RawEnd$Sub(lhs$proxy20.aB);
  }
  var lhsMsg = evidence$1.am;
  var lhsAggregate = evidence$1.a0;
  if (evidence$1.K) {
    evidence$1.N = (!(!(evidence$1.N | oldCut)));
    var ctx0 = evidence$1;
  } else if (evidence$1.N) {
    var ctx0 = evidence$1;
  } else {
    var verboseFailures = evidence$1.aj;
    evidence$1.G = startPos;
    if (verboseFailures) {
      evidence$1.aG(lhsMsg, evidence$1.a0, false);
    }
    evidence$1.N = false;
    var lhs$proxy21 = $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__nodeList__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1);
    if (lhs$proxy21.K) {
      lhs$proxy21.aB = new $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$RawEnd$Nodes(lhs$proxy21.aB);
    }
    var rhsMsg = evidence$1.am;
    var rhsCut = evidence$1.N;
    var endCut = (!(!(rhsCut | oldCut)));
    if (((!evidence$1.K) && (!rhsCut))) {
      evidence$1.ll(startPos);
    }
    evidence$1.N = endCut;
    if (verboseFailures) {
      var $x_1 = lhsMsg.bl(rhsMsg);
      var other$1 = evidence$1.a0;
      evidence$1.aG($x_1, lhsAggregate.bl(other$1), false);
    }
    var ctx0 = evidence$1;
  }
  if (instrument) {
    evidence$1.bk.hI(name$proxy20.aE, ctx0.G, ctx0.K);
  }
  if (ctx0.aj) {
    var newshortMsg$1 = $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => name$proxy20.aE)));
    var forceAggregate = (startIndex < ctx0.bq);
    ctx0.aG(newshortMsg$1, ctx0.a0, forceAggregate);
    if ((!ctx0.K)) {
      ctx0.cf = new $c_sci_$colon$colon(new $c_T2(name$proxy20.aE, startIndex), ctx0.cf);
    }
  }
  return ctx0;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__toEdgeEnd__Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$RawEnd__Lorg_jpablo_graphexplorer_graphviz_dotlang_EdgeEnd($thiz, e) {
  if ((e instanceof $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$RawEnd$Nodes)) {
    var x78 = e.Ki;
    if ((x78 !== null)) {
      if ((x78.bL(1) === 0)) {
        return new $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_EdgeEnd$Node($f_sc_LinearSeqOps__apply__I__O(x78, 0));
      }
    }
    var id = $m_s_None$();
    var f = ((_$12) => new $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$NodeStmt(_$12, $m_sci_Nil$()));
    if ((x78 === $m_sci_Nil$())) {
      var $x_1 = $m_sci_Nil$();
    } else {
      var x0 = x78.t();
      var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
      var t = h;
      var rest = x78.v();
      while ((rest !== $m_sci_Nil$())) {
        var x0$1 = rest.t();
        var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
        t.U = nx;
        t = nx;
        rest = rest.v();
      }
      var $x_1 = h;
    }
    return new $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_EdgeEnd$Sub(new $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Subgraph(id, $x_1));
  }
  if ((e instanceof $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$RawEnd$Sub)) {
    return new $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_EdgeEnd$Sub(e.Kj);
  }
  throw new $c_s_MatchError(e);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__edgeOp__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1) {
  $m_Lsourcecode_Name$();
  var name$proxy21 = new $c_Lsourcecode_Name("edgeOp");
  var startIndex = evidence$1.G;
  var instrument = (evidence$1.bk !== null);
  if (instrument) {
    evidence$1.bk.hL(name$proxy21.aE, startIndex);
  }
  var oldCut = evidence$1.N;
  evidence$1.N = false;
  var startPos = evidence$1.G;
  var index = evidence$1.G;
  var end = ((2 + index) | 0);
  var input = evidence$1.b0;
  if (input.bc(((end - 1) | 0))) {
    if ((input.cA.charCodeAt(index) === 45)) {
      var index$1 = ((1 + index) | 0);
      var $x_1 = (input.cA.charCodeAt(index$1) === 62);
    } else {
      var $x_1 = false;
    }
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    evidence$1.dl(end);
  } else {
    evidence$1.dB();
  }
  if (evidence$1.aj) {
    evidence$1.de(index, $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => "\"->\""))));
  }
  var lhsMsg = evidence$1.am;
  var lhsAggregate = evidence$1.a0;
  if (evidence$1.K) {
    evidence$1.N = (!(!(evidence$1.N | oldCut)));
    var ctx0 = evidence$1;
  } else if (evidence$1.N) {
    var ctx0 = evidence$1;
  } else {
    var verboseFailures = evidence$1.aj;
    evidence$1.G = startPos;
    if (verboseFailures) {
      evidence$1.aG(lhsMsg, evidence$1.a0, false);
    }
    evidence$1.N = false;
    var index$2 = evidence$1.G;
    var end$2 = ((2 + index$2) | 0);
    var input$2 = evidence$1.b0;
    if (input$2.bc(((end$2 - 1) | 0))) {
      if ((input$2.cA.charCodeAt(index$2) === 45)) {
        var index$3 = ((1 + index$2) | 0);
        var $x_2 = (input$2.cA.charCodeAt(index$3) === 45);
      } else {
        var $x_2 = false;
      }
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      evidence$1.dl(end$2);
    } else {
      evidence$1.dB();
    }
    if (evidence$1.aj) {
      evidence$1.de(index$2, $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => "\"--\""))));
    }
    var rhsMsg = evidence$1.am;
    var rhsCut = evidence$1.N;
    var endCut = (!(!(rhsCut | oldCut)));
    if (((!evidence$1.K) && (!rhsCut))) {
      evidence$1.ll(startPos);
    }
    evidence$1.N = endCut;
    if (verboseFailures) {
      var $x_3 = lhsMsg.bl(rhsMsg);
      var other$1 = evidence$1.a0;
      evidence$1.aG($x_3, lhsAggregate.bl(other$1), false);
    }
    var ctx0 = evidence$1;
  }
  if (instrument) {
    evidence$1.bk.hI(name$proxy21.aE, ctx0.G, ctx0.K);
  }
  if (ctx0.aj) {
    var newshortMsg$1 = $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => name$proxy21.aE)));
    var forceAggregate = (startIndex < ctx0.bq);
    ctx0.aG(newshortMsg$1, ctx0.a0, forceAggregate);
    if ((!ctx0.K)) {
      ctx0.cf = new $c_sci_$colon$colon(new $c_T2(name$proxy21.aE, startIndex), ctx0.cf);
    }
  }
  return ctx0;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__attrStmt__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1) {
  $m_Lsourcecode_Name$();
  var name$proxy22 = new $c_Lsourcecode_Name("attrStmt");
  var startIndex = evidence$1.G;
  var instrument = (evidence$1.bk !== null);
  if (instrument) {
    evidence$1.bk.hL(name$proxy22.aE, startIndex);
  }
  var s$proxy34 = $f_Lfastparse_LowestPriSequencer__Sequencer1__O($m_Lfastparse_Implicits$Sequencer$());
  var preLhsIndex = evidence$1.G;
  var input = evidence$1.b0;
  $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__attrTarget__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1);
  if ((!evidence$1.K)) {
    var ctx0 = evidence$1;
  } else {
    var postLhsIndex = evidence$1.G;
    var lhsAggregate = evidence$1.a0;
    var lhsMsg = evidence$1.am;
    if ((postLhsIndex > preLhsIndex)) {
      evidence$1.b7();
    }
    var lhsValue = evidence$1.aB;
    $m_Lfastparse_internal_Util$().dJ($thiz.dK(), evidence$1);
    if (evidence$1.K) {
      if (((!evidence$1.K) && evidence$1.N)) {
        var ctx0 = evidence$1;
      } else {
        var preRhsIndex = evidence$1.G;
        $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__attrGroups1__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1);
        var rhsAggregate = evidence$1.a0;
        var rhsMsg = evidence$1.am;
        if ((!evidence$1.K)) {
          var res = evidence$1;
        } else {
          var postRhsIndex = evidence$1.G;
          var rhsMadeProgress = (postRhsIndex > preRhsIndex);
          var nextIndex = (((!rhsMadeProgress) && input.bc(postRhsIndex)) ? postLhsIndex : postRhsIndex);
          if (rhsMadeProgress) {
            evidence$1.b7();
          }
          var res = evidence$1.cI(s$proxy34.R(lhsValue, evidence$1.aB), nextIndex);
        }
        if (evidence$1.aj) {
          evidence$1.aG($m_Lfastparse_internal_Util$().dc(lhsMsg, rhsMsg), lhsAggregate.bl(rhsAggregate), (preRhsIndex === evidence$1.bq));
        }
        var ctx0 = res;
      }
    } else {
      var ctx0 = evidence$1;
    }
  }
  if (instrument) {
    evidence$1.bk.hI(name$proxy22.aE, ctx0.G, ctx0.K);
  }
  if (ctx0.aj) {
    var newshortMsg = $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => name$proxy22.aE)));
    var forceAggregate = (startIndex < ctx0.bq);
    ctx0.aG(newshortMsg, ctx0.a0, forceAggregate);
    if ((!ctx0.K)) {
      ctx0.cf = new $c_sci_$colon$colon(new $c_T2(name$proxy22.aE, startIndex), ctx0.cf);
    }
  }
  if ((!ctx0.K)) {
    return ctx0;
  } else {
    var x$1 = ctx0.aB;
    matchResult54: {
      var $x_1;
      if ((x$1 !== null)) {
        var $x_1 = new $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$AttrStmt(x$1.g(), x$1.h());
        break matchResult54;
      }
      throw new $c_s_MatchError(x$1);
    }
    ctx0.aB = $x_1;
    return ctx0;
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__assignStmt__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1) {
  $m_Lsourcecode_Name$();
  var name$proxy23 = new $c_Lsourcecode_Name("assignStmt");
  var startIndex = evidence$1.G;
  var instrument = (evidence$1.bk !== null);
  if (instrument) {
    evidence$1.bk.hL(name$proxy23.aE, startIndex);
  }
  var s$proxy36 = $f_Lfastparse_LowestPriSequencer__Sequencer1__O($m_Lfastparse_Implicits$Sequencer$());
  var preLhsIndex = evidence$1.G;
  var input = evidence$1.b0;
  $m_Lfastparse_Implicits$Sequencer$().qP();
  var preLhsIndex$2 = evidence$1.G;
  var input$2 = evidence$1.b0;
  $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__id__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1);
  if (evidence$1.K) {
    var postLhsIndex = evidence$1.G;
    var lhsAggregate = evidence$1.a0;
    var lhsMsg = evidence$1.am;
    if ((postLhsIndex > preLhsIndex$2)) {
      evidence$1.b7();
    }
    var lhsValue = evidence$1.aB;
    $m_Lfastparse_internal_Util$().dJ($thiz.dK(), evidence$1);
    if (evidence$1.K) {
      if ((!((!evidence$1.K) && evidence$1.N))) {
        var preRhsIndex = evidence$1.G;
        var input$3 = evidence$1.b0;
        var index = evidence$1.G;
        if ((input$3.bc(index) && (input$3.cA.charCodeAt(index) === 61))) {
          evidence$1.dl(((1 + index) | 0));
        } else {
          evidence$1.dB();
        }
        if (evidence$1.aj) {
          evidence$1.de(index, $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => "\"=\""))));
        }
        var rhsAggregate = evidence$1.a0;
        var rhsMsg = evidence$1.am;
        if (evidence$1.K) {
          var postRhsIndex = evidence$1.G;
          var rhsMadeProgress = (postRhsIndex > preRhsIndex);
          var nextIndex = (((!rhsMadeProgress) && input$2.bc(postRhsIndex)) ? postLhsIndex : postRhsIndex);
          if (rhsMadeProgress) {
            evidence$1.b7();
          }
          evidence$1.cI(lhsValue, nextIndex);
        }
        if (evidence$1.aj) {
          evidence$1.aG($m_Lfastparse_internal_Util$().dc(lhsMsg, rhsMsg), lhsAggregate.bl(rhsAggregate), (preRhsIndex === evidence$1.bq));
        }
      }
    }
  }
  if ((!evidence$1.K)) {
    var ctx0 = evidence$1;
  } else {
    var postLhsIndex$2 = evidence$1.G;
    var lhsAggregate$2 = evidence$1.a0;
    var lhsMsg$2 = evidence$1.am;
    if ((postLhsIndex$2 > preLhsIndex)) {
      evidence$1.b7();
    }
    var lhsValue$2 = evidence$1.aB;
    $m_Lfastparse_internal_Util$().dJ($thiz.dK(), evidence$1);
    if (evidence$1.K) {
      if (((!evidence$1.K) && evidence$1.N)) {
        var ctx0 = evidence$1;
      } else {
        var preRhsIndex$2 = evidence$1.G;
        $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__id__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1);
        var rhsAggregate$2 = evidence$1.a0;
        var rhsMsg$2 = evidence$1.am;
        if ((!evidence$1.K)) {
          var res$3 = evidence$1;
        } else {
          var postRhsIndex$2 = evidence$1.G;
          var rhsMadeProgress$2 = (postRhsIndex$2 > preRhsIndex$2);
          var nextIndex$2 = (((!rhsMadeProgress$2) && input.bc(postRhsIndex$2)) ? postLhsIndex$2 : postRhsIndex$2);
          if (rhsMadeProgress$2) {
            evidence$1.b7();
          }
          var res$3 = evidence$1.cI(s$proxy36.R(lhsValue$2, evidence$1.aB), nextIndex$2);
        }
        if (evidence$1.aj) {
          evidence$1.aG($m_Lfastparse_internal_Util$().dc(lhsMsg$2, rhsMsg$2), lhsAggregate$2.bl(rhsAggregate$2), (preRhsIndex$2 === evidence$1.bq));
        }
        var ctx0 = res$3;
      }
    } else {
      var ctx0 = evidence$1;
    }
  }
  if (instrument) {
    evidence$1.bk.hI(name$proxy23.aE, ctx0.G, ctx0.K);
  }
  if (ctx0.aj) {
    var newshortMsg = $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => name$proxy23.aE)));
    var forceAggregate = (startIndex < ctx0.bq);
    ctx0.aG(newshortMsg, ctx0.a0, forceAggregate);
    if ((!ctx0.K)) {
      ctx0.cf = new $c_sci_$colon$colon(new $c_T2(name$proxy23.aE, startIndex), ctx0.cf);
    }
  }
  if ((!ctx0.K)) {
    return ctx0;
  } else {
    var x$1 = ctx0.aB;
    matchResult56: {
      var $x_1;
      if ((x$1 !== null)) {
        var $x_1 = new $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$Assign(x$1.g(), x$1.h());
        break matchResult56;
      }
      throw new $c_s_MatchError(x$1);
    }
    ctx0.aB = $x_1;
    return ctx0;
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__edgeOrNodeStmt__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1) {
  $m_Lsourcecode_Name$();
  var name$proxy24 = new $c_Lsourcecode_Name("edgeOrNodeStmt");
  var startIndex = evidence$1.G;
  var instrument = (evidence$1.bk !== null);
  if (instrument) {
    evidence$1.bk.hL(name$proxy24.aE, startIndex);
  }
  var s$proxy39 = $m_Lfastparse_Implicits$Sequencer$().a6R;
  var preLhsIndex = evidence$1.G;
  var input = evidence$1.b0;
  var s$proxy38 = $f_Lfastparse_LowestPriSequencer__Sequencer1__O($m_Lfastparse_Implicits$Sequencer$());
  var preLhsIndex$2 = evidence$1.G;
  var input$2 = evidence$1.b0;
  $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__rawEnd__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1);
  if (evidence$1.K) {
    var postLhsIndex = evidence$1.G;
    var lhsAggregate = evidence$1.a0;
    var lhsMsg = evidence$1.am;
    if ((postLhsIndex > preLhsIndex$2)) {
      evidence$1.b7();
    }
    var lhsValue = evidence$1.aB;
    $m_Lfastparse_internal_Util$().dJ($thiz.dK(), evidence$1);
    if (evidence$1.K) {
      if ((!((!evidence$1.K) && evidence$1.N))) {
        var preRhsIndex = evidence$1.G;
        $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__rec$12__Lfastparse_ParsingRun__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__I__I__Z__Z__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_ParsingRun($thiz, evidence$1, 0, evidence$1, $m_Lfastparse_Implicits$Repeater$().Ad(), $m_scm_Buffer$().f7(), evidence$1.G, 0, false, evidence$1.N, null, null);
        var rhsAggregate = evidence$1.a0;
        var rhsMsg = evidence$1.am;
        if (evidence$1.K) {
          var postRhsIndex = evidence$1.G;
          var rhsMadeProgress = (postRhsIndex > preRhsIndex);
          var nextIndex = (((!rhsMadeProgress) && input$2.bc(postRhsIndex)) ? postLhsIndex : postRhsIndex);
          if (rhsMadeProgress) {
            evidence$1.b7();
          }
          evidence$1.cI(s$proxy38.R(lhsValue, evidence$1.aB), nextIndex);
        }
        if (evidence$1.aj) {
          evidence$1.aG($m_Lfastparse_internal_Util$().dc(lhsMsg, rhsMsg), lhsAggregate.bl(rhsAggregate), (preRhsIndex === evidence$1.bq));
        }
      }
    }
  }
  if ((!evidence$1.K)) {
    var ctx0 = evidence$1;
  } else {
    var postLhsIndex$2 = evidence$1.G;
    var lhsAggregate$2 = evidence$1.a0;
    var lhsMsg$2 = evidence$1.am;
    if ((postLhsIndex$2 > preLhsIndex)) {
      evidence$1.b7();
    }
    var lhsValue$2 = evidence$1.aB;
    $m_Lfastparse_internal_Util$().dJ($thiz.dK(), evidence$1);
    if (evidence$1.K) {
      if (((!evidence$1.K) && evidence$1.N)) {
        var ctx0 = evidence$1;
      } else {
        var preRhsIndex$2 = evidence$1.G;
        $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__attrGroups__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1);
        var rhsAggregate$2 = evidence$1.a0;
        var rhsMsg$2 = evidence$1.am;
        if ((!evidence$1.K)) {
          var res$2 = evidence$1;
        } else {
          var postRhsIndex$2 = evidence$1.G;
          var rhsMadeProgress$2 = (postRhsIndex$2 > preRhsIndex$2);
          var nextIndex$2 = (((!rhsMadeProgress$2) && input.bc(postRhsIndex$2)) ? postLhsIndex$2 : postRhsIndex$2);
          if (rhsMadeProgress$2) {
            evidence$1.b7();
          }
          var res$2 = evidence$1.cI(s$proxy39.R(lhsValue$2, evidence$1.aB), nextIndex$2);
        }
        if (evidence$1.aj) {
          evidence$1.aG($m_Lfastparse_internal_Util$().dc(lhsMsg$2, rhsMsg$2), lhsAggregate$2.bl(rhsAggregate$2), (preRhsIndex$2 === evidence$1.bq));
        }
        var ctx0 = res$2;
      }
    } else {
      var ctx0 = evidence$1;
    }
  }
  if (instrument) {
    evidence$1.bk.hI(name$proxy24.aE, ctx0.G, ctx0.K);
  }
  if (ctx0.aj) {
    var newshortMsg = $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => name$proxy24.aE)));
    var forceAggregate = (startIndex < ctx0.bq);
    ctx0.aG(newshortMsg, ctx0.a0, forceAggregate);
    if ((!ctx0.K)) {
      ctx0.cf = new $c_sci_$colon$colon(new $c_T2(name$proxy24.aE, startIndex), ctx0.cf);
    }
  }
  if ((!ctx0.K)) {
    return ctx0;
  } else {
    var x$1 = ctx0.aB;
    matchResult57: {
      var $x_1;
      if ((x$1 !== null)) {
        var x103 = x$1.bH;
        var x105 = x$1.c3;
        var rest = x$1.bU;
        if ((!rest.c())) {
          var $x_1 = new $c_sci_$colon$colon(new $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$EdgeStmt(new $c_sci_$colon$colon($p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__toEdgeEnd__Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$RawEnd__Lorg_jpablo_graphexplorer_graphviz_dotlang_EdgeEnd($thiz, x103), $m_sci_Nil$().b6(new $c_sc_Iterator$$anon$9(rest.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e) => $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__toEdgeEnd__Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$RawEnd__Lorg_jpablo_graphexplorer_graphviz_dotlang_EdgeEnd($m_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$(), e)))))), x105), $m_sci_Nil$());
          break matchResult57;
        }
        if ((x103 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$RawEnd$Nodes)) {
          var x102 = x103.Ki;
          var f$1 = ((_$13) => new $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$NodeStmt(_$13, x105));
          if ((x102 === $m_sci_Nil$())) {
            var $x_1 = $m_sci_Nil$();
            break matchResult57;
          } else {
            var x0 = x102.t();
            var h = new $c_sci_$colon$colon(f$1(x0), $m_sci_Nil$());
            var t = h;
            var rest$1 = x102.v();
            while ((rest$1 !== $m_sci_Nil$())) {
              var x0$1 = rest$1.t();
              var nx = new $c_sci_$colon$colon(f$1(x0$1), $m_sci_Nil$());
              t.U = nx;
              t = nx;
              rest$1 = rest$1.v();
            }
            var $x_1 = h;
            break matchResult57;
          }
        }
        if ((x103 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$RawEnd$Sub)) {
          var $x_1 = new $c_sci_$colon$colon(new $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$SubStmt(x103.Kj), $m_sci_Nil$());
          break matchResult57;
        }
      }
      throw new $c_s_MatchError(x$1);
    }
    ctx0.aB = $x_1;
    return ctx0;
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__stmt__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1) {
  $m_Lsourcecode_Name$();
  var name$proxy25 = new $c_Lsourcecode_Name("stmt");
  var startIndex = evidence$1.G;
  var instrument = (evidence$1.bk !== null);
  if (instrument) {
    evidence$1.bk.hL(name$proxy25.aE, startIndex);
  }
  var oldCut = evidence$1.N;
  evidence$1.N = false;
  var startPos = evidence$1.G;
  var oldCut$2 = evidence$1.N;
  evidence$1.N = false;
  var startPos$2 = evidence$1.G;
  var lhs$proxy25 = $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__attrStmt__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1);
  if (lhs$proxy25.K) {
    lhs$proxy25.aB = new $c_sci_$colon$colon(lhs$proxy25.aB, $m_sci_Nil$());
  }
  var lhsMsg = evidence$1.am;
  var lhsAggregate = evidence$1.a0;
  if (evidence$1.K) {
    evidence$1.N = (!(!(evidence$1.N | oldCut$2)));
  } else if ((!evidence$1.N)) {
    var verboseFailures = evidence$1.aj;
    evidence$1.G = startPos$2;
    if (verboseFailures) {
      evidence$1.aG(lhsMsg, evidence$1.a0, false);
    }
    evidence$1.N = false;
    var lhs$proxy26 = $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__assignStmt__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1);
    if (lhs$proxy26.K) {
      lhs$proxy26.aB = new $c_sci_$colon$colon(lhs$proxy26.aB, $m_sci_Nil$());
    }
    var rhsMsg = evidence$1.am;
    var rhsCut = evidence$1.N;
    var endCut = (!(!(rhsCut | oldCut$2)));
    if (((!evidence$1.K) && (!rhsCut))) {
      evidence$1.ll(startPos$2);
    }
    evidence$1.N = endCut;
    if (verboseFailures) {
      var $x_1 = lhsMsg.bl(rhsMsg);
      var other$1 = evidence$1.a0;
      evidence$1.aG($x_1, lhsAggregate.bl(other$1), false);
    }
  }
  var lhsMsg$2 = evidence$1.am;
  var lhsAggregate$2 = evidence$1.a0;
  if (evidence$1.K) {
    evidence$1.N = (!(!(evidence$1.N | oldCut)));
    var ctx0 = evidence$1;
  } else if (evidence$1.N) {
    var ctx0 = evidence$1;
  } else {
    var verboseFailures$2 = evidence$1.aj;
    evidence$1.G = startPos;
    if (verboseFailures$2) {
      evidence$1.aG(lhsMsg$2, evidence$1.a0, false);
    }
    evidence$1.N = false;
    $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__edgeOrNodeStmt__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1);
    var rhsMsg$2 = evidence$1.am;
    var rhsCut$2 = evidence$1.N;
    var endCut$2 = (!(!(rhsCut$2 | oldCut)));
    if (((!evidence$1.K) && (!rhsCut$2))) {
      evidence$1.ll(startPos);
    }
    evidence$1.N = endCut$2;
    if (verboseFailures$2) {
      var $x_2 = lhsMsg$2.bl(rhsMsg$2);
      var other$1$2 = evidence$1.a0;
      evidence$1.aG($x_2, lhsAggregate$2.bl(other$1$2), false);
    }
    var ctx0 = evidence$1;
  }
  if (instrument) {
    evidence$1.bk.hI(name$proxy25.aE, ctx0.G, ctx0.K);
  }
  if (ctx0.aj) {
    var newshortMsg$2 = $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => name$proxy25.aE)));
    var forceAggregate = (startIndex < ctx0.bq);
    ctx0.aG(newshortMsg$2, ctx0.a0, forceAggregate);
    if ((!ctx0.K)) {
      ctx0.cf = new $c_sci_$colon$colon(new $c_T2(name$proxy25.aE, startIndex), ctx0.cf);
    }
  }
  return ctx0;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__stmtList__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1) {
  $m_Lsourcecode_Name$();
  var name$proxy26 = new $c_Lsourcecode_Name("stmtList");
  var startIndex = evidence$1.G;
  var instrument = (evidence$1.bk !== null);
  if (instrument) {
    evidence$1.bk.hL(name$proxy26.aE, startIndex);
  }
  var ctx0 = $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__rec$13__Lfastparse_ParsingRun__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__I__I__Z__Z__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_ParsingRun($thiz, evidence$1, 0, evidence$1, $m_Lfastparse_Implicits$Repeater$().Ad(), $m_scm_Buffer$().f7(), evidence$1.G, 0, false, evidence$1.N, null, null);
  if (instrument) {
    evidence$1.bk.hI(name$proxy26.aE, ctx0.G, ctx0.K);
  }
  if (ctx0.aj) {
    var newshortMsg = $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => name$proxy26.aE)));
    var forceAggregate = (startIndex < ctx0.bq);
    ctx0.aG(newshortMsg, ctx0.a0, forceAggregate);
    if ((!ctx0.K)) {
      ctx0.cf = new $c_sci_$colon$colon(new $c_T2(name$proxy26.aE, startIndex), ctx0.cf);
    }
  }
  if ((!ctx0.K)) {
    return ctx0;
  } else {
    ctx0.aB = ctx0.aB.dk($m_s_$less$colon$less$().b1).bM();
    return ctx0;
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__graphP__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1) {
  $m_Lsourcecode_Name$();
  var name$proxy27 = new $c_Lsourcecode_Name("graphP");
  var startIndex = evidence$1.G;
  var instrument = (evidence$1.bk !== null);
  if (instrument) {
    evidence$1.bk.hL(name$proxy27.aE, startIndex);
  }
  $m_Lfastparse_Implicits$Sequencer$().qP();
  var preLhsIndex = evidence$1.G;
  var input = evidence$1.b0;
  $m_Lfastparse_Implicits$Sequencer$().qP();
  var preLhsIndex$2 = evidence$1.G;
  var input$2 = evidence$1.b0;
  var s$proxy45 = $m_Lfastparse_Implicits$Sequencer$().asL;
  var preLhsIndex$3 = evidence$1.G;
  var input$3 = evidence$1.b0;
  $m_Lfastparse_Implicits$Sequencer$().qP();
  var preLhsIndex$4 = evidence$1.G;
  var input$4 = evidence$1.b0;
  var s$proxy43 = $m_Lfastparse_Implicits$Sequencer$().a6R;
  var preLhsIndex$5 = evidence$1.G;
  var input$5 = evidence$1.b0;
  var s$proxy42 = $f_Lfastparse_LowestPriSequencer__Sequencer1__O($m_Lfastparse_Implicits$Sequencer$());
  var preLhsIndex$6 = evidence$1.G;
  var input$6 = evidence$1.b0;
  $m_Lfastparse_Implicits$Sequencer$();
  var preLhsIndex$7 = evidence$1.G;
  var input$7 = evidence$1.b0;
  $f_Lfastparse_SharedPackageDefs__Start__Lfastparse_ParsingRun__Lfastparse_ParsingRun($m_Lfastparse_package$(), evidence$1);
  if (evidence$1.K) {
    var postLhsIndex = evidence$1.G;
    var lhsAggregate = evidence$1.a0;
    var lhsMsg = evidence$1.am;
    if ((postLhsIndex > preLhsIndex$7)) {
      evidence$1.b7();
    }
    $m_Lfastparse_internal_Util$().dJ($thiz.dK(), evidence$1);
    if (evidence$1.K) {
      if ((!((!evidence$1.K) && evidence$1.N))) {
        var preRhsIndex = evidence$1.G;
        var oldCut = evidence$1.N;
        evidence$1.N = false;
        var startPos = evidence$1.G;
        var lhs$proxy28 = $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__kw__T__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, "strict", evidence$1);
        if (lhs$proxy28.K) {
          lhs$proxy28.aB = true;
        }
        var lhsMsg$2 = evidence$1.am;
        var lhsAggregate$2 = evidence$1.a0;
        if (evidence$1.K) {
          evidence$1.N = (!(!(evidence$1.N | oldCut)));
        } else if ((!evidence$1.N)) {
          var verboseFailures = evidence$1.aj;
          evidence$1.G = startPos;
          if (verboseFailures) {
            evidence$1.aG(lhsMsg$2, evidence$1.a0, false);
          }
          evidence$1.N = false;
          var lhs$proxy29 = $f_Lfastparse_SharedPackageDefs__Pass__Lfastparse_ParsingRun__Lfastparse_ParsingRun($m_Lfastparse_package$(), evidence$1);
          if (lhs$proxy29.K) {
            lhs$proxy29.aB = false;
          }
          var rhsMsg = evidence$1.am;
          var rhsCut = evidence$1.N;
          var endCut = (!(!(rhsCut | oldCut)));
          if (((!evidence$1.K) && (!rhsCut))) {
            evidence$1.ll(startPos);
          }
          evidence$1.N = endCut;
          if (verboseFailures) {
            var $x_1 = lhsMsg$2.bl(rhsMsg);
            var other$1 = evidence$1.a0;
            evidence$1.aG($x_1, lhsAggregate$2.bl(other$1), false);
          }
        }
        var rhsAggregate = evidence$1.a0;
        var rhsMsg$2 = evidence$1.am;
        if (evidence$1.K) {
          var postRhsIndex = evidence$1.G;
          var rhsMadeProgress = (postRhsIndex > preRhsIndex);
          var nextIndex = (((!rhsMadeProgress) && input$7.bc(postRhsIndex)) ? postLhsIndex : postRhsIndex);
          if (rhsMadeProgress) {
            evidence$1.b7();
          }
          evidence$1.cI((!(!evidence$1.aB)), nextIndex);
        }
        if (evidence$1.aj) {
          evidence$1.aG($m_Lfastparse_internal_Util$().dc(lhsMsg, rhsMsg$2), lhsAggregate.bl(rhsAggregate), (preRhsIndex === evidence$1.bq));
        }
      }
    }
  }
  if (evidence$1.K) {
    var postLhsIndex$2 = evidence$1.G;
    var lhsAggregate$3 = evidence$1.a0;
    var lhsMsg$3 = evidence$1.am;
    if ((postLhsIndex$2 > preLhsIndex$6)) {
      evidence$1.b7();
    }
    var lhsValue$2 = evidence$1.aB;
    $m_Lfastparse_internal_Util$().dJ($thiz.dK(), evidence$1);
    if (evidence$1.K) {
      if ((!((!evidence$1.K) && evidence$1.N))) {
        var preRhsIndex$2 = evidence$1.G;
        var oldCut$2 = evidence$1.N;
        evidence$1.N = false;
        var startPos$2 = evidence$1.G;
        var lhs$proxy30 = $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__kw__T__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, "digraph", evidence$1);
        if (lhs$proxy30.K) {
          lhs$proxy30.aB = true;
        }
        var lhsMsg$4 = evidence$1.am;
        var lhsAggregate$4 = evidence$1.a0;
        if (evidence$1.K) {
          evidence$1.N = (!(!(evidence$1.N | oldCut$2)));
        } else if ((!evidence$1.N)) {
          var verboseFailures$2 = evidence$1.aj;
          evidence$1.G = startPos$2;
          if (verboseFailures$2) {
            evidence$1.aG(lhsMsg$4, evidence$1.a0, false);
          }
          evidence$1.N = false;
          var lhs$proxy31 = $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__kw__T__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, "graph", evidence$1);
          if (lhs$proxy31.K) {
            lhs$proxy31.aB = false;
          }
          var rhsMsg$3 = evidence$1.am;
          var rhsCut$2 = evidence$1.N;
          var endCut$2 = (!(!(rhsCut$2 | oldCut$2)));
          if (((!evidence$1.K) && (!rhsCut$2))) {
            evidence$1.ll(startPos$2);
          }
          evidence$1.N = endCut$2;
          if (verboseFailures$2) {
            var $x_2 = lhsMsg$4.bl(rhsMsg$3);
            var other$1$2 = evidence$1.a0;
            evidence$1.aG($x_2, lhsAggregate$4.bl(other$1$2), false);
          }
        }
        var rhsAggregate$2 = evidence$1.a0;
        var rhsMsg$4 = evidence$1.am;
        if (evidence$1.K) {
          var postRhsIndex$2 = evidence$1.G;
          var rhsMadeProgress$2 = (postRhsIndex$2 > preRhsIndex$2);
          var nextIndex$2 = (((!rhsMadeProgress$2) && input$6.bc(postRhsIndex$2)) ? postLhsIndex$2 : postRhsIndex$2);
          if (rhsMadeProgress$2) {
            evidence$1.b7();
          }
          evidence$1.cI(s$proxy42.R((!(!lhsValue$2)), (!(!evidence$1.aB))), nextIndex$2);
        }
        if (evidence$1.aj) {
          evidence$1.aG($m_Lfastparse_internal_Util$().dc(lhsMsg$3, rhsMsg$4), lhsAggregate$3.bl(rhsAggregate$2), (preRhsIndex$2 === evidence$1.bq));
        }
      }
    }
  }
  if (evidence$1.K) {
    var postLhsIndex$3 = evidence$1.G;
    var lhsAggregate$5 = evidence$1.a0;
    var lhsMsg$5 = evidence$1.am;
    if ((postLhsIndex$3 > preLhsIndex$5)) {
      evidence$1.b7();
    }
    var lhsValue$3 = evidence$1.aB;
    $m_Lfastparse_internal_Util$().dJ($thiz.dK(), evidence$1);
    if (evidence$1.K) {
      if ((!((!evidence$1.K) && evidence$1.N))) {
        var preRhsIndex$3 = evidence$1.G;
        $m_Lfastparse_Implicits$Optioner$().W7();
        var startPos$3 = evidence$1.G;
        var startCut = evidence$1.N;
        evidence$1.N = false;
        $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__id__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1);
        var postSuccess = evidence$1.K;
        if (postSuccess) {
          var res$3 = evidence$1.u2(new $c_s_Some(evidence$1.aB));
          res$3.N = (!(!(res$3.N | startCut)));
        } else if ((!evidence$1.N)) {
          var res$4 = evidence$1.cI($m_s_None$(), startPos$3);
          res$4.N = (!(!(res$4.N | startCut)));
        }
        if (evidence$1.aj) {
          var msg = evidence$1.am;
          if ((!postSuccess)) {
            evidence$1.aG($m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => ($m_Lfastparse_internal_Util$().pA(msg.j3) + ".?")))), evidence$1.a0, false);
          }
        }
        var rhsAggregate$3 = evidence$1.a0;
        var rhsMsg$5 = evidence$1.am;
        if (evidence$1.K) {
          var postRhsIndex$3 = evidence$1.G;
          var rhsMadeProgress$3 = (postRhsIndex$3 > preRhsIndex$3);
          var nextIndex$3 = (((!rhsMadeProgress$3) && input$5.bc(postRhsIndex$3)) ? postLhsIndex$3 : postRhsIndex$3);
          if (rhsMadeProgress$3) {
            evidence$1.b7();
          }
          evidence$1.cI(s$proxy43.R(lhsValue$3, evidence$1.aB), nextIndex$3);
        }
        if (evidence$1.aj) {
          evidence$1.aG($m_Lfastparse_internal_Util$().dc(lhsMsg$5, rhsMsg$5), lhsAggregate$5.bl(rhsAggregate$3), (preRhsIndex$3 === evidence$1.bq));
        }
      }
    }
  }
  if (evidence$1.K) {
    var postLhsIndex$4 = evidence$1.G;
    var lhsAggregate$6 = evidence$1.a0;
    var lhsMsg$6 = evidence$1.am;
    if ((postLhsIndex$4 > preLhsIndex$4)) {
      evidence$1.b7();
    }
    var lhsValue$4 = evidence$1.aB;
    $m_Lfastparse_internal_Util$().dJ($thiz.dK(), evidence$1);
    if (evidence$1.K) {
      if ((!((!evidence$1.K) && evidence$1.N))) {
        var preRhsIndex$4 = evidence$1.G;
        var input$8 = evidence$1.b0;
        var index = evidence$1.G;
        if ((input$8.bc(index) && (input$8.cA.charCodeAt(index) === 123))) {
          evidence$1.dl(((1 + index) | 0));
        } else {
          evidence$1.dB();
        }
        if (evidence$1.aj) {
          evidence$1.de(index, $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => "\"{\""))));
        }
        var rhsAggregate$4 = evidence$1.a0;
        var rhsMsg$6 = evidence$1.am;
        if (evidence$1.K) {
          var postRhsIndex$4 = evidence$1.G;
          var rhsMadeProgress$4 = (postRhsIndex$4 > preRhsIndex$4);
          var nextIndex$4 = (((!rhsMadeProgress$4) && input$4.bc(postRhsIndex$4)) ? postLhsIndex$4 : postRhsIndex$4);
          if (rhsMadeProgress$4) {
            evidence$1.b7();
          }
          evidence$1.cI(lhsValue$4, nextIndex$4);
        }
        if (evidence$1.aj) {
          evidence$1.aG($m_Lfastparse_internal_Util$().dc(lhsMsg$6, rhsMsg$6), lhsAggregate$6.bl(rhsAggregate$4), (preRhsIndex$4 === evidence$1.bq));
        }
      }
    }
  }
  if (evidence$1.K) {
    var postLhsIndex$5 = evidence$1.G;
    var lhsAggregate$7 = evidence$1.a0;
    var lhsMsg$7 = evidence$1.am;
    if ((postLhsIndex$5 > preLhsIndex$3)) {
      evidence$1.b7();
    }
    var lhsValue$5 = evidence$1.aB;
    $m_Lfastparse_internal_Util$().dJ($thiz.dK(), evidence$1);
    if (evidence$1.K) {
      if ((!((!evidence$1.K) && evidence$1.N))) {
        var preRhsIndex$5 = evidence$1.G;
        $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__stmtList__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1);
        var rhsAggregate$5 = evidence$1.a0;
        var rhsMsg$7 = evidence$1.am;
        if (evidence$1.K) {
          var postRhsIndex$5 = evidence$1.G;
          var rhsMadeProgress$5 = (postRhsIndex$5 > preRhsIndex$5);
          var nextIndex$5 = (((!rhsMadeProgress$5) && input$3.bc(postRhsIndex$5)) ? postLhsIndex$5 : postRhsIndex$5);
          if (rhsMadeProgress$5) {
            evidence$1.b7();
          }
          evidence$1.cI(s$proxy45.R(lhsValue$5, evidence$1.aB), nextIndex$5);
        }
        if (evidence$1.aj) {
          evidence$1.aG($m_Lfastparse_internal_Util$().dc(lhsMsg$7, rhsMsg$7), lhsAggregate$7.bl(rhsAggregate$5), (preRhsIndex$5 === evidence$1.bq));
        }
      }
    }
  }
  if (evidence$1.K) {
    var postLhsIndex$6 = evidence$1.G;
    var lhsAggregate$8 = evidence$1.a0;
    var lhsMsg$8 = evidence$1.am;
    if ((postLhsIndex$6 > preLhsIndex$2)) {
      evidence$1.b7();
    }
    var lhsValue$6 = evidence$1.aB;
    $m_Lfastparse_internal_Util$().dJ($thiz.dK(), evidence$1);
    if (evidence$1.K) {
      if ((!((!evidence$1.K) && evidence$1.N))) {
        var preRhsIndex$6 = evidence$1.G;
        var input$9 = evidence$1.b0;
        var index$2 = evidence$1.G;
        if ((input$9.bc(index$2) && (input$9.cA.charCodeAt(index$2) === 125))) {
          evidence$1.dl(((1 + index$2) | 0));
        } else {
          evidence$1.dB();
        }
        if (evidence$1.aj) {
          evidence$1.de(index$2, $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => "\"}\""))));
        }
        var rhsAggregate$6 = evidence$1.a0;
        var rhsMsg$8 = evidence$1.am;
        if (evidence$1.K) {
          var postRhsIndex$6 = evidence$1.G;
          var rhsMadeProgress$6 = (postRhsIndex$6 > preRhsIndex$6);
          var nextIndex$6 = (((!rhsMadeProgress$6) && input$2.bc(postRhsIndex$6)) ? postLhsIndex$6 : postRhsIndex$6);
          if (rhsMadeProgress$6) {
            evidence$1.b7();
          }
          evidence$1.cI(lhsValue$6, nextIndex$6);
        }
        if (evidence$1.aj) {
          evidence$1.aG($m_Lfastparse_internal_Util$().dc(lhsMsg$8, rhsMsg$8), lhsAggregate$8.bl(rhsAggregate$6), (preRhsIndex$6 === evidence$1.bq));
        }
      }
    }
  }
  if ((!evidence$1.K)) {
    var ctx0 = evidence$1;
  } else {
    var postLhsIndex$7 = evidence$1.G;
    var lhsAggregate$9 = evidence$1.a0;
    var lhsMsg$9 = evidence$1.am;
    if ((postLhsIndex$7 > preLhsIndex)) {
      evidence$1.b7();
    }
    var lhsValue$7 = evidence$1.aB;
    $m_Lfastparse_internal_Util$().dJ($thiz.dK(), evidence$1);
    if (evidence$1.K) {
      if (((!evidence$1.K) && evidence$1.N)) {
        var ctx0 = evidence$1;
      } else {
        var preRhsIndex$7 = evidence$1.G;
        $f_Lfastparse_SharedPackageDefs__End__Lfastparse_ParsingRun__Lfastparse_ParsingRun($m_Lfastparse_package$(), evidence$1);
        var rhsAggregate$7 = evidence$1.a0;
        var rhsMsg$9 = evidence$1.am;
        if ((!evidence$1.K)) {
          var res$12 = evidence$1;
        } else {
          var postRhsIndex$7 = evidence$1.G;
          var rhsMadeProgress$7 = (postRhsIndex$7 > preRhsIndex$7);
          var nextIndex$7 = (((!rhsMadeProgress$7) && input.bc(postRhsIndex$7)) ? postLhsIndex$7 : postRhsIndex$7);
          if (rhsMadeProgress$7) {
            evidence$1.b7();
          }
          var res$12 = evidence$1.cI(lhsValue$7, nextIndex$7);
        }
        if (evidence$1.aj) {
          evidence$1.aG($m_Lfastparse_internal_Util$().dc(lhsMsg$9, rhsMsg$9), lhsAggregate$9.bl(rhsAggregate$7), (preRhsIndex$7 === evidence$1.bq));
        }
        var ctx0 = res$12;
      }
    } else {
      var ctx0 = evidence$1;
    }
  }
  if (instrument) {
    evidence$1.bk.hI(name$proxy27.aE, ctx0.G, ctx0.K);
  }
  if (ctx0.aj) {
    var newshortMsg$3 = $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => name$proxy27.aE)));
    var forceAggregate = (startIndex < ctx0.bq);
    ctx0.aG(newshortMsg$3, ctx0.a0, forceAggregate);
    if ((!ctx0.K)) {
      ctx0.cf = new $c_sci_$colon$colon(new $c_T2(name$proxy27.aE, startIndex), ctx0.cf);
    }
  }
  if ((!ctx0.K)) {
    return ctx0;
  } else {
    var x$1 = ctx0.aB;
    matchResult60: {
      var $x_3;
      if ((x$1 !== null)) {
        var $x_3 = new $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Graph((!(!x$1.bO)), (!(!x$1.bs)), x$1.ch, x$1.ca);
        break matchResult60;
      }
      throw new $c_s_MatchError(x$1);
    }
    ctx0.aB = $x_3;
    return ctx0;
  }
}
function $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__org$jpablo$graphexplorer$graphviz$dotlang$DotParser$$anon$1$$_$rec$1__Lfastparse_ParserInput__Lfastparse_ParsingRun__I__I__Lfastparse_ParsingRun(input$1, ctx$1, current, state) {
  var state$tailLocal1 = state;
  var current$tailLocal1 = current;
  while (true) {
    if ((!input$1.bc(current$tailLocal1))) {
      return (((state$tailLocal1 >>> 0) <= 1) ? ctx$1.dl(current$tailLocal1) : ((state$tailLocal1 === 2) ? ctx$1.dl(((current$tailLocal1 - 1) | 0)) : ctx$1.ll(current$tailLocal1)));
    } else {
      var index = current$tailLocal1;
      var this$1 = input$1.cA;
      var c = this$1.charCodeAt(index);
      var x4 = state$tailLocal1;
      switch (x4) {
        case 0: {
          switch (c) {
            case 32:
            case 9:
            case 10:
            case 13: {
              var current$tailLocal1$tmp1 = ((1 + current$tailLocal1) | 0);
              current$tailLocal1 = current$tailLocal1$tmp1;
              state$tailLocal1 = 0;
              break;
            }
            case 35: {
              var current$tailLocal1$tmp2 = ((1 + current$tailLocal1) | 0);
              current$tailLocal1 = current$tailLocal1$tmp2;
              state$tailLocal1 = 1;
              break;
            }
            case 47: {
              var current$tailLocal1$tmp3 = ((1 + current$tailLocal1) | 0);
              current$tailLocal1 = current$tailLocal1$tmp3;
              state$tailLocal1 = 2;
              break;
            }
            default: {
              return ctx$1.dl(current$tailLocal1);
            }
          }
          break;
        }
        case 1: {
          var current$tailLocal1$tmp4 = ((1 + current$tailLocal1) | 0);
          var state$tailLocal1$tmp4 = ((c !== 10) | 0);
          current$tailLocal1 = current$tailLocal1$tmp4;
          state$tailLocal1 = state$tailLocal1$tmp4;
          break;
        }
        case 2: {
          if ((c === 47)) {
            var current$tailLocal1$tmp5 = ((1 + current$tailLocal1) | 0);
            current$tailLocal1 = current$tailLocal1$tmp5;
            state$tailLocal1 = 1;
            break;
          }
          if ((c === 42)) {
            var current$tailLocal1$tmp6 = ((1 + current$tailLocal1) | 0);
            current$tailLocal1 = current$tailLocal1$tmp6;
            state$tailLocal1 = 3;
            break;
          }
          return ctx$1.dl(((current$tailLocal1 - 1) | 0));
          break;
        }
        case 3: {
          var current$tailLocal1$tmp7 = ((1 + current$tailLocal1) | 0);
          var state$tailLocal1$tmp7 = ((c === 42) ? 4 : 3);
          current$tailLocal1 = current$tailLocal1$tmp7;
          state$tailLocal1 = state$tailLocal1$tmp7;
          break;
        }
        case 4: {
          if ((c === 47)) {
            var current$tailLocal1$tmp8 = ((1 + current$tailLocal1) | 0);
            current$tailLocal1 = current$tailLocal1$tmp8;
            state$tailLocal1 = 0;
            break;
          }
          if ((c === 42)) {
            var current$tailLocal1$tmp9 = ((1 + current$tailLocal1) | 0);
            current$tailLocal1 = current$tailLocal1$tmp9;
            state$tailLocal1 = 4;
            break;
          }
          var current$tailLocal1$tmp10 = ((1 + current$tailLocal1) | 0);
          current$tailLocal1 = current$tailLocal1$tmp10;
          state$tailLocal1 = 3;
          break;
        }
        default: {
          throw new $c_s_MatchError(x4);
        }
      }
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__end$1__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__I__I__I__Z__Lfastparse_ParsingRun($thiz, actualMin$1, ctx$2, repeater$1, acc$1, successIndex, index, count, endCut) {
  return ((count < actualMin$1) ? ctx$2.tT(index, endCut) : ctx$2.u1(repeater$1.ra(acc$1), successIndex, endCut));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__rec$2__Lfastparse_ParsingRun__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__I__I__Z__Z__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_ParsingRun($thiz, ctx$3, actualMin$2, evidence$1$1, repeater$2, acc$2, startIndex, count, precut, outerCut, sepMsg, lastAgg) {
  var lastAgg$tailLocal1 = lastAgg;
  var sepMsg$tailLocal1 = sepMsg;
  var outerCut$tailLocal1 = outerCut;
  var precut$tailLocal1 = precut;
  var count$tailLocal1 = count;
  var startIndex$tailLocal1 = startIndex;
  while (true) {
    ctx$3.N = (!(!(precut$tailLocal1 | ((count$tailLocal1 < actualMin$2) && outerCut$tailLocal1))));
    $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__quotedChar__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1$1);
    var parsedMsg = ctx$3.am;
    var parsedAgg = ctx$3.a0;
    var postCut = ctx$3.N;
    var verboseFailures = ctx$3.aj;
    if ((!ctx$3.K)) {
      var res = (postCut ? ctx$3 : $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__end$1__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__I__I__I__Z__Lfastparse_ParsingRun($thiz, actualMin$2, ctx$3, repeater$2, acc$2, startIndex$tailLocal1, startIndex$tailLocal1, count$tailLocal1, (!(!(outerCut$tailLocal1 | postCut)))));
      if (verboseFailures) {
        $m_Lfastparse_internal_Util$().uf(startIndex$tailLocal1, actualMin$2, ctx$3, sepMsg$tailLocal1, parsedMsg, lastAgg$tailLocal1, (precut$tailLocal1 || postCut));
      }
      return res;
    } else {
      var beforeSepIndex = ctx$3.G;
      repeater$2.qQ(ctx$3.aB, acc$2);
      var nextCount = ((1 + count$tailLocal1) | 0);
      ctx$3.N = false;
      var outerCut$tailLocal1$tmp1 = (!(!(outerCut$tailLocal1 | postCut)));
      startIndex$tailLocal1 = beforeSepIndex;
      count$tailLocal1 = nextCount;
      precut$tailLocal1 = false;
      outerCut$tailLocal1 = outerCut$tailLocal1$tmp1;
      sepMsg$tailLocal1 = null;
      lastAgg$tailLocal1 = parsedAgg;
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__end$2__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__I__I__I__Z__Lfastparse_ParsingRun($thiz, actualMin$3, ctx$4, repeater$3, acc$3, successIndex, index, count, endCut) {
  return ((count < actualMin$3) ? ctx$4.tT(index, endCut) : ctx$4.u1(repeater$3.ra(acc$3), successIndex, endCut));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__rec$3__Lfastparse_ParsingRun__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__I__I__Z__Z__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_ParsingRun($thiz, ctx$5, actualMin$4, evidence$1$2, repeater$4, acc$4, startIndex, count, precut, outerCut, sepMsg, lastAgg) {
  var lastAgg$tailLocal2 = lastAgg;
  var sepMsg$tailLocal2 = sepMsg;
  var outerCut$tailLocal2 = outerCut;
  var precut$tailLocal2 = precut;
  var count$tailLocal2 = count;
  var startIndex$tailLocal2 = startIndex;
  while (true) {
    ctx$5.N = (!(!(precut$tailLocal2 | ((count$tailLocal2 < actualMin$4) && outerCut$tailLocal2))));
    $m_Lfastparse_Implicits$Sequencer$();
    var preLhsIndex = evidence$1$2.G;
    var input = evidence$1$2.b0;
    var input$2 = evidence$1$2.b0;
    var index = evidence$1$2.G;
    if ((input$2.bc(index) && (input$2.cA.charCodeAt(index) === 43))) {
      evidence$1$2.dl(((1 + index) | 0));
    } else {
      evidence$1$2.dB();
    }
    if (evidence$1$2.aj) {
      evidence$1$2.de(index, $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => "\"+\""))));
    }
    if (evidence$1$2.K) {
      var postLhsIndex = evidence$1$2.G;
      var lhsAggregate = evidence$1$2.a0;
      var lhsMsg = evidence$1$2.am;
      if ((postLhsIndex > preLhsIndex)) {
        evidence$1$2.b7();
      }
      $m_Lfastparse_internal_Util$().dJ($thiz.dK(), evidence$1$2);
      if (evidence$1$2.K) {
        if ((!((!evidence$1$2.K) && evidence$1$2.N))) {
          var preRhsIndex = evidence$1$2.G;
          $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__quotedRaw__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1$2);
          var rhsAggregate = evidence$1$2.a0;
          var rhsMsg = evidence$1$2.am;
          if (evidence$1$2.K) {
            var postRhsIndex = evidence$1$2.G;
            var rhsMadeProgress = (postRhsIndex > preRhsIndex);
            var nextIndex = (((!rhsMadeProgress) && input.bc(postRhsIndex)) ? postLhsIndex : postRhsIndex);
            if (rhsMadeProgress) {
              evidence$1$2.b7();
            }
            evidence$1$2.cI(evidence$1$2.aB, nextIndex);
          }
          if (evidence$1$2.aj) {
            evidence$1$2.aG($m_Lfastparse_internal_Util$().dc(lhsMsg, rhsMsg), lhsAggregate.bl(rhsAggregate), (preRhsIndex === evidence$1$2.bq));
          }
        }
      }
    }
    var parsedMsg = ctx$5.am;
    var parsedAgg = ctx$5.a0;
    var postCut = ctx$5.N;
    var verboseFailures = ctx$5.aj;
    if ((!ctx$5.K)) {
      var res$3 = (postCut ? ctx$5 : $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__end$2__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__I__I__I__Z__Lfastparse_ParsingRun($thiz, actualMin$4, ctx$5, repeater$4, acc$4, startIndex$tailLocal2, startIndex$tailLocal2, count$tailLocal2, (!(!(outerCut$tailLocal2 | postCut)))));
      if (verboseFailures) {
        $m_Lfastparse_internal_Util$().uf(startIndex$tailLocal2, actualMin$4, ctx$5, sepMsg$tailLocal2, parsedMsg, lastAgg$tailLocal2, (precut$tailLocal2 || postCut));
      }
      return res$3;
    } else {
      var beforeSepIndex = ctx$5.G;
      repeater$4.qQ(ctx$5.aB, acc$4);
      var nextCount = ((1 + count$tailLocal2) | 0);
      $m_Lfastparse_internal_Util$().dJ($thiz.dK(), ctx$5);
      if (((!ctx$5.K) && ctx$5.N)) {
        return ctx$5;
      } else {
        ctx$5.N = false;
        var outerCut$tailLocal2$tmp1 = (!(!(outerCut$tailLocal2 | postCut)));
        startIndex$tailLocal2 = beforeSepIndex;
        count$tailLocal2 = nextCount;
        precut$tailLocal2 = false;
        outerCut$tailLocal2 = outerCut$tailLocal2$tmp1;
        sepMsg$tailLocal2 = null;
        lastAgg$tailLocal2 = parsedAgg;
      }
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__end$3__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__I__I__I__Z__Lfastparse_ParsingRun($thiz, actualMin$5, ctx$6, repeater$5, acc$5, successIndex, index, count, endCut) {
  return ((count < actualMin$5) ? ctx$6.tT(index, endCut) : ctx$6.u1(repeater$5.ra(acc$5), successIndex, endCut));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__rec$4__Lfastparse_ParsingRun__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__I__I__Z__Z__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_ParsingRun($thiz, ctx$7, actualMin$6, evidence$1$3, repeater$6, acc$6, startIndex, count, precut, outerCut, sepMsg, lastAgg) {
  var lastAgg$tailLocal3 = lastAgg;
  var sepMsg$tailLocal3 = sepMsg;
  var outerCut$tailLocal3 = outerCut;
  var precut$tailLocal3 = precut;
  var count$tailLocal3 = count;
  var startIndex$tailLocal3 = startIndex;
  while (true) {
    ctx$7.N = (!(!(precut$tailLocal3 | ((count$tailLocal3 < actualMin$6) && outerCut$tailLocal3))));
    var oldCut = evidence$1$3.N;
    evidence$1$3.N = false;
    var startPos = evidence$1$3.G;
    var index = evidence$1$3.G;
    var input = evidence$1$3.b0;
    var start = index;
    var goal = ((1 + start) | 0);
    while (true) {
      if (input.bc(index)) {
        var index$1 = index;
        var this$1 = input.cA;
        var c = this$1.charCodeAt(index$1);
        var $x_1 = ((c !== 60) && (c !== 62));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        index = ((1 + index) | 0);
      } else {
        break;
      }
    }
    if ((index >= goal)) {
      evidence$1$3.dl(index);
    } else {
      evidence$1$3.dB();
    }
    if (evidence$1$3.aj) {
      evidence$1$3.de(start, $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => (("chars-while(" + new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((c$1) => {
        var c$2 = $uC(c$1);
        return ((c$2 !== 60) && (c$2 !== 62));
      }))) + ", 1)")))));
    }
    var lhsMsg = evidence$1$3.am;
    var lhsAggregate = evidence$1$3.a0;
    if (evidence$1$3.K) {
      evidence$1$3.N = (!(!(evidence$1$3.N | oldCut)));
    } else if ((!evidence$1$3.N)) {
      var verboseFailures = evidence$1$3.aj;
      evidence$1$3.G = startPos;
      if (verboseFailures) {
        evidence$1$3.aG(lhsMsg, evidence$1$3.a0, false);
      }
      evidence$1$3.N = false;
      $m_Lfastparse_Implicits$Sequencer$();
      var preLhsIndex = evidence$1$3.G;
      var input$2 = evidence$1$3.b0;
      $m_Lfastparse_Implicits$Sequencer$();
      var preLhsIndex$2 = evidence$1$3.G;
      var input$3 = evidence$1$3.b0;
      var input$4 = evidence$1$3.b0;
      var index$2 = evidence$1$3.G;
      if ((input$4.bc(index$2) && (input$4.cA.charCodeAt(index$2) === 60))) {
        evidence$1$3.dl(((1 + index$2) | 0));
      } else {
        evidence$1$3.dB();
      }
      if (evidence$1$3.aj) {
        evidence$1$3.de(index$2, $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => "\"<\""))));
      }
      if (evidence$1$3.K) {
        var postLhsIndex = evidence$1$3.G;
        var lhsAggregate$2 = evidence$1$3.a0;
        var lhsMsg$2 = evidence$1$3.am;
        if ((postLhsIndex > preLhsIndex$2)) {
          evidence$1$3.b7();
        }
        if ((!((!evidence$1$3.K) && evidence$1$3.N))) {
          var preRhsIndex = evidence$1$3.G;
          $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__htmlBody__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1$3);
          var rhsAggregate = evidence$1$3.a0;
          var rhsMsg = evidence$1$3.am;
          if (evidence$1$3.K) {
            var postRhsIndex = evidence$1$3.G;
            var rhsMadeProgress = (postRhsIndex > preRhsIndex);
            var nextIndex = (((!rhsMadeProgress) && input$3.bc(postRhsIndex)) ? postLhsIndex : postRhsIndex);
            if (rhsMadeProgress) {
              evidence$1$3.b7();
            }
            evidence$1$3.cI((void 0), nextIndex);
          }
          if (evidence$1$3.aj) {
            evidence$1$3.aG($m_Lfastparse_internal_Util$().dc(lhsMsg$2, rhsMsg), lhsAggregate$2.bl(rhsAggregate), (preRhsIndex === evidence$1$3.bq));
          }
        }
      }
      if (evidence$1$3.K) {
        var postLhsIndex$2 = evidence$1$3.G;
        var lhsAggregate$3 = evidence$1$3.a0;
        var lhsMsg$3 = evidence$1$3.am;
        if ((postLhsIndex$2 > preLhsIndex)) {
          evidence$1$3.b7();
        }
        if ((!((!evidence$1$3.K) && evidence$1$3.N))) {
          var preRhsIndex$2 = evidence$1$3.G;
          var input$5 = evidence$1$3.b0;
          var index$3 = evidence$1$3.G;
          if ((input$5.bc(index$3) && (input$5.cA.charCodeAt(index$3) === 62))) {
            evidence$1$3.dl(((1 + index$3) | 0));
          } else {
            evidence$1$3.dB();
          }
          if (evidence$1$3.aj) {
            evidence$1$3.de(index$3, $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => "\">\""))));
          }
          var rhsAggregate$2 = evidence$1$3.a0;
          var rhsMsg$2 = evidence$1$3.am;
          if (evidence$1$3.K) {
            var postRhsIndex$2 = evidence$1$3.G;
            var rhsMadeProgress$2 = (postRhsIndex$2 > preRhsIndex$2);
            var nextIndex$2 = (((!rhsMadeProgress$2) && input$2.bc(postRhsIndex$2)) ? postLhsIndex$2 : postRhsIndex$2);
            if (rhsMadeProgress$2) {
              evidence$1$3.b7();
            }
            evidence$1$3.cI((void 0), nextIndex$2);
          }
          if (evidence$1$3.aj) {
            evidence$1$3.aG($m_Lfastparse_internal_Util$().dc(lhsMsg$3, rhsMsg$2), lhsAggregate$3.bl(rhsAggregate$2), (preRhsIndex$2 === evidence$1$3.bq));
          }
        }
      }
      var rhsMsg$3 = evidence$1$3.am;
      var rhsCut = evidence$1$3.N;
      var endCut = (!(!(rhsCut | oldCut)));
      if (((!evidence$1$3.K) && (!rhsCut))) {
        evidence$1$3.ll(startPos);
      }
      evidence$1$3.N = endCut;
      if (verboseFailures) {
        var $x_2 = lhsMsg.bl(rhsMsg$3);
        var other$1 = evidence$1$3.a0;
        evidence$1$3.aG($x_2, lhsAggregate.bl(other$1), false);
      }
    }
    var parsedMsg = ctx$7.am;
    var parsedAgg = ctx$7.a0;
    var postCut = ctx$7.N;
    var verboseFailures$2 = ctx$7.aj;
    if ((!ctx$7.K)) {
      var res$6 = (postCut ? ctx$7 : $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__end$3__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__I__I__I__Z__Lfastparse_ParsingRun($thiz, actualMin$6, ctx$7, repeater$6, acc$6, startIndex$tailLocal3, startIndex$tailLocal3, count$tailLocal3, (!(!(outerCut$tailLocal3 | postCut)))));
      if (verboseFailures$2) {
        $m_Lfastparse_internal_Util$().uf(startIndex$tailLocal3, actualMin$6, ctx$7, sepMsg$tailLocal3, parsedMsg, lastAgg$tailLocal3, (precut$tailLocal3 || postCut));
      }
      return res$6;
    } else {
      var beforeSepIndex = ctx$7.G;
      repeater$6.qQ((void 0), acc$6);
      var nextCount = ((1 + count$tailLocal3) | 0);
      ctx$7.N = false;
      var outerCut$tailLocal3$tmp1 = (!(!(outerCut$tailLocal3 | postCut)));
      startIndex$tailLocal3 = beforeSepIndex;
      count$tailLocal3 = nextCount;
      precut$tailLocal3 = false;
      outerCut$tailLocal3 = outerCut$tailLocal3$tmp1;
      sepMsg$tailLocal3 = null;
      lastAgg$tailLocal3 = parsedAgg;
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__parse0$1$1__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1$4) {
  var input = evidence$1$4.b0;
  var index = evidence$1$4.G;
  var res = ((input.bc(index) && (input.cA.charCodeAt(index) === 59)) ? evidence$1$4.dl(((1 + index) | 0)) : evidence$1$4.dB());
  if (evidence$1$4.aj) {
    evidence$1$4.de(index, $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => "\";\""))));
  }
  return res;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__end$4__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__I__I__I__Z__Lfastparse_ParsingRun($thiz, actualMin$7, ctx$8, repeater$7, acc$7, successIndex, index, count, endCut) {
  return ((count < actualMin$7) ? ctx$8.tT(index, endCut) : ctx$8.u1(repeater$7.ra(acc$7), successIndex, endCut));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__rec$5__Lfastparse_ParsingRun__I__Lfastparse_Implicits$Repeater__O__I__Lfastparse_ParsingRun__I__I__Z__Z__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_ParsingRun($thiz, ctx$9, actualMin$8, repeater$8, acc$8, actualMax$1, evidence$1$5, startIndex, count, precut, outerCut, sepMsg, lastAgg) {
  var lastAgg$tailLocal4 = lastAgg;
  var sepMsg$tailLocal4 = sepMsg;
  var outerCut$tailLocal4 = outerCut;
  var precut$tailLocal4 = precut;
  var count$tailLocal4 = count;
  var startIndex$tailLocal4 = startIndex;
  while (true) {
    ctx$9.N = (!(!(precut$tailLocal4 | ((count$tailLocal4 < actualMin$8) && outerCut$tailLocal4))));
    $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__parse0$1$1__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1$5);
    var parsedMsg = ctx$9.am;
    var parsedAgg = ctx$9.a0;
    var postCut = ctx$9.N;
    var verboseFailures = ctx$9.aj;
    if ((!ctx$9.K)) {
      var res = (postCut ? ctx$9 : $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__end$4__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__I__I__I__Z__Lfastparse_ParsingRun($thiz, actualMin$8, ctx$9, repeater$8, acc$8, startIndex$tailLocal4, startIndex$tailLocal4, count$tailLocal4, (!(!(outerCut$tailLocal4 | postCut)))));
      if (verboseFailures) {
        $m_Lfastparse_internal_Util$().uf(startIndex$tailLocal4, actualMin$8, ctx$9, sepMsg$tailLocal4, parsedMsg, lastAgg$tailLocal4, (precut$tailLocal4 || postCut));
      }
      return res;
    } else {
      var beforeSepIndex = ctx$9.G;
      repeater$8.qQ((void 0), acc$8);
      var nextCount = ((1 + count$tailLocal4) | 0);
      if ((nextCount === actualMax$1)) {
        var res$2 = $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__end$4__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__I__I__I__Z__Lfastparse_ParsingRun($thiz, actualMin$8, ctx$9, repeater$8, acc$8, beforeSepIndex, beforeSepIndex, nextCount, (!(!(outerCut$tailLocal4 | postCut))));
        if (verboseFailures) {
          ctx$9.de(startIndex$tailLocal4, $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((parsedMsg, actualMin$8) => (() => (($m_Lfastparse_internal_Util$().pA(parsedMsg.j3) + ".rep") + ((actualMin$8 === 0) ? "" : (("(" + actualMin$8) + ")")))))(parsedMsg, actualMin$8))));
        }
        return res$2;
      } else {
        $m_Lfastparse_internal_Util$().dJ($thiz.dK(), ctx$9);
        if (((!ctx$9.K) && ctx$9.N)) {
          return ctx$9;
        } else {
          ctx$9.N = false;
          var outerCut$tailLocal4$tmp1 = (!(!(outerCut$tailLocal4 | postCut)));
          startIndex$tailLocal4 = beforeSepIndex;
          count$tailLocal4 = nextCount;
          precut$tailLocal4 = false;
          outerCut$tailLocal4 = outerCut$tailLocal4$tmp1;
          sepMsg$tailLocal4 = null;
          lastAgg$tailLocal4 = parsedAgg;
        }
      }
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__parse0$2$1__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1$6) {
  var index = evidence$1$6.G;
  if ((!evidence$1$6.b0.bc(index))) {
    var res = evidence$1$6.dB();
  } else {
    matchResult28: {
      var res;
      var this$1 = evidence$1$6.b0;
      var index$1 = evidence$1$6.G;
      var this$2 = this$1.cA;
      var charIn = this$2.charCodeAt(index$1);
      var x30 = ((charIn === 59) || ((charIn === 44) || false));
      if (x30) {
        var res = evidence$1$6.dl(((1 + index) | 0));
        break matchResult28;
      }
      if ((!x30)) {
        var res = evidence$1$6.dB();
        break matchResult28;
      }
      throw new $c_s_MatchError(x30);
    }
  }
  if (evidence$1$6.aj) {
    evidence$1$6.de(index, $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => "[;,]"))));
  }
  return res;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__end$5__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__I__I__I__Z__Lfastparse_ParsingRun($thiz, actualMin$10, ctx$10, repeater$9, acc$9, successIndex, index, count, endCut) {
  return ((count < actualMin$10) ? ctx$10.tT(index, endCut) : ctx$10.u1(repeater$9.ra(acc$9), successIndex, endCut));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__rec$6__Lfastparse_ParsingRun__I__Lfastparse_Implicits$Repeater__O__I__Lfastparse_ParsingRun__I__I__Z__Z__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_ParsingRun($thiz, ctx$11, actualMin$11, repeater$10, acc$10, actualMax$2, evidence$1$7, startIndex, count, precut, outerCut, sepMsg, lastAgg) {
  var lastAgg$tailLocal5 = lastAgg;
  var sepMsg$tailLocal5 = sepMsg;
  var outerCut$tailLocal5 = outerCut;
  var precut$tailLocal5 = precut;
  var count$tailLocal5 = count;
  var startIndex$tailLocal5 = startIndex;
  while (true) {
    ctx$11.N = (!(!(precut$tailLocal5 | ((count$tailLocal5 < actualMin$11) && outerCut$tailLocal5))));
    $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__parse0$2$1__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1$7);
    var parsedMsg = ctx$11.am;
    var parsedAgg = ctx$11.a0;
    var postCut = ctx$11.N;
    var verboseFailures = ctx$11.aj;
    if ((!ctx$11.K)) {
      var res = (postCut ? ctx$11 : $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__end$5__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__I__I__I__Z__Lfastparse_ParsingRun($thiz, actualMin$11, ctx$11, repeater$10, acc$10, startIndex$tailLocal5, startIndex$tailLocal5, count$tailLocal5, (!(!(outerCut$tailLocal5 | postCut)))));
      if (verboseFailures) {
        $m_Lfastparse_internal_Util$().uf(startIndex$tailLocal5, actualMin$11, ctx$11, sepMsg$tailLocal5, parsedMsg, lastAgg$tailLocal5, (precut$tailLocal5 || postCut));
      }
      return res;
    } else {
      var beforeSepIndex = ctx$11.G;
      repeater$10.qQ((void 0), acc$10);
      var nextCount = ((1 + count$tailLocal5) | 0);
      if ((nextCount === actualMax$2)) {
        var res$2 = $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__end$5__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__I__I__I__Z__Lfastparse_ParsingRun($thiz, actualMin$11, ctx$11, repeater$10, acc$10, beforeSepIndex, beforeSepIndex, nextCount, (!(!(outerCut$tailLocal5 | postCut))));
        if (verboseFailures) {
          ctx$11.de(startIndex$tailLocal5, $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((parsedMsg, actualMin$11) => (() => (($m_Lfastparse_internal_Util$().pA(parsedMsg.j3) + ".rep") + ((actualMin$11 === 0) ? "" : (("(" + actualMin$11) + ")")))))(parsedMsg, actualMin$11))));
        }
        return res$2;
      } else {
        $m_Lfastparse_internal_Util$().dJ($thiz.dK(), ctx$11);
        if (((!ctx$11.K) && ctx$11.N)) {
          return ctx$11;
        } else {
          ctx$11.N = false;
          var outerCut$tailLocal5$tmp1 = (!(!(outerCut$tailLocal5 | postCut)));
          startIndex$tailLocal5 = beforeSepIndex;
          count$tailLocal5 = nextCount;
          precut$tailLocal5 = false;
          outerCut$tailLocal5 = outerCut$tailLocal5$tmp1;
          sepMsg$tailLocal5 = null;
          lastAgg$tailLocal5 = parsedAgg;
        }
      }
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__end$6__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__I__I__I__Z__Lfastparse_ParsingRun($thiz, actualMin$13, ctx$12, repeater$11, acc$11, successIndex, index, count, endCut) {
  return ((count < actualMin$13) ? ctx$12.tT(index, endCut) : ctx$12.u1(repeater$11.ra(acc$11), successIndex, endCut));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__end$7__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__I__I__I__Z__Lfastparse_ParsingRun($thiz, actualMin$15, ctx$14, repeater$13, acc$13, successIndex, index, count, endCut) {
  return ((count < actualMin$15) ? ctx$14.tT(index, endCut) : ctx$14.u1(repeater$13.ra(acc$13), successIndex, endCut));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__rec$8__Lfastparse_ParsingRun__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__I__I__Z__Z__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_ParsingRun($thiz, ctx$15, actualMin$16, evidence$1$9, repeater$14, acc$14, startIndex, count, precut, outerCut, sepMsg, lastAgg) {
  var lastAgg$tailLocal6 = lastAgg;
  var sepMsg$tailLocal6 = sepMsg;
  var outerCut$tailLocal6 = outerCut;
  var precut$tailLocal6 = precut;
  var count$tailLocal6 = count;
  var startIndex$tailLocal6 = startIndex;
  while (true) {
    ctx$15.N = (!(!(precut$tailLocal6 | ((count$tailLocal6 < actualMin$16) && outerCut$tailLocal6))));
    $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__attrPair__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1$9);
    var parsedMsg = ctx$15.am;
    var parsedAgg = ctx$15.a0;
    var postCut = ctx$15.N;
    var verboseFailures = ctx$15.aj;
    if ((!ctx$15.K)) {
      var res = (postCut ? ctx$15 : $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__end$7__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__I__I__I__Z__Lfastparse_ParsingRun($thiz, actualMin$16, ctx$15, repeater$14, acc$14, startIndex$tailLocal6, startIndex$tailLocal6, count$tailLocal6, (!(!(outerCut$tailLocal6 | postCut)))));
      if (verboseFailures) {
        $m_Lfastparse_internal_Util$().uf(startIndex$tailLocal6, actualMin$16, ctx$15, sepMsg$tailLocal6, parsedMsg, lastAgg$tailLocal6, (precut$tailLocal6 || postCut));
      }
      return res;
    } else {
      var beforeSepIndex = ctx$15.G;
      repeater$14.qQ(ctx$15.aB, acc$14);
      var nextCount = ((1 + count$tailLocal6) | 0);
      $m_Lfastparse_internal_Util$().dJ($thiz.dK(), ctx$15);
      if (((!ctx$15.K) && ctx$15.N)) {
        return ctx$15;
      } else {
        ctx$15.N = false;
        var outerCut$tailLocal6$tmp1 = (!(!(outerCut$tailLocal6 | postCut)));
        startIndex$tailLocal6 = beforeSepIndex;
        count$tailLocal6 = nextCount;
        precut$tailLocal6 = false;
        outerCut$tailLocal6 = outerCut$tailLocal6$tmp1;
        sepMsg$tailLocal6 = null;
        lastAgg$tailLocal6 = parsedAgg;
      }
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__rec$7__Lfastparse_ParsingRun__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__I__I__Z__Z__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_ParsingRun($thiz, ctx$13, actualMin$14, evidence$1$8, repeater$12, acc$12, startIndex, count, precut, outerCut, sepMsg, lastAgg) {
  var lastAgg$tailLocal7 = lastAgg;
  var sepMsg$tailLocal7 = sepMsg;
  var outerCut$tailLocal7 = outerCut;
  var precut$tailLocal7 = precut;
  var count$tailLocal7 = count;
  var startIndex$tailLocal7 = startIndex;
  while (true) {
    ctx$13.N = (!(!(precut$tailLocal7 | ((count$tailLocal7 < actualMin$14) && outerCut$tailLocal7))));
    $m_Lfastparse_Implicits$Sequencer$().qP();
    var preLhsIndex = evidence$1$8.G;
    var input = evidence$1$8.b0;
    $m_Lfastparse_Implicits$Sequencer$();
    var preLhsIndex$2 = evidence$1$8.G;
    var input$2 = evidence$1$8.b0;
    var input$3 = evidence$1$8.b0;
    var index = evidence$1$8.G;
    if ((input$3.bc(index) && (input$3.cA.charCodeAt(index) === 91))) {
      evidence$1$8.dl(((1 + index) | 0));
    } else {
      evidence$1$8.dB();
    }
    if (evidence$1$8.aj) {
      evidence$1$8.de(index, $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => "\"[\""))));
    }
    if (evidence$1$8.K) {
      var postLhsIndex = evidence$1$8.G;
      var lhsAggregate = evidence$1$8.a0;
      var lhsMsg = evidence$1$8.am;
      if ((postLhsIndex > preLhsIndex$2)) {
        evidence$1$8.b7();
      }
      $m_Lfastparse_internal_Util$().dJ($thiz.dK(), evidence$1$8);
      if (evidence$1$8.K) {
        if ((!((!evidence$1$8.K) && evidence$1$8.N))) {
          var preRhsIndex = evidence$1$8.G;
          $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__rec$8__Lfastparse_ParsingRun__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__I__I__Z__Z__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_ParsingRun($thiz, evidence$1$8, 0, evidence$1$8, $m_Lfastparse_Implicits$Repeater$().Ad(), $m_scm_Buffer$().f7(), evidence$1$8.G, 0, false, evidence$1$8.N, null, null);
          var rhsAggregate = evidence$1$8.a0;
          var rhsMsg = evidence$1$8.am;
          if (evidence$1$8.K) {
            var postRhsIndex = evidence$1$8.G;
            var rhsMadeProgress = (postRhsIndex > preRhsIndex);
            var nextIndex = (((!rhsMadeProgress) && input$2.bc(postRhsIndex)) ? postLhsIndex : postRhsIndex);
            if (rhsMadeProgress) {
              evidence$1$8.b7();
            }
            evidence$1$8.cI(evidence$1$8.aB, nextIndex);
          }
          if (evidence$1$8.aj) {
            evidence$1$8.aG($m_Lfastparse_internal_Util$().dc(lhsMsg, rhsMsg), lhsAggregate.bl(rhsAggregate), (preRhsIndex === evidence$1$8.bq));
          }
        }
      }
    }
    if (evidence$1$8.K) {
      var postLhsIndex$2 = evidence$1$8.G;
      var lhsAggregate$2 = evidence$1$8.a0;
      var lhsMsg$2 = evidence$1$8.am;
      if ((postLhsIndex$2 > preLhsIndex)) {
        evidence$1$8.b7();
      }
      var lhsValue$2 = evidence$1$8.aB;
      $m_Lfastparse_internal_Util$().dJ($thiz.dK(), evidence$1$8);
      if (evidence$1$8.K) {
        if ((!((!evidence$1$8.K) && evidence$1$8.N))) {
          var preRhsIndex$2 = evidence$1$8.G;
          var input$4 = evidence$1$8.b0;
          var index$2 = evidence$1$8.G;
          if ((input$4.bc(index$2) && (input$4.cA.charCodeAt(index$2) === 93))) {
            evidence$1$8.dl(((1 + index$2) | 0));
          } else {
            evidence$1$8.dB();
          }
          if (evidence$1$8.aj) {
            evidence$1$8.de(index$2, $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => "\"]\""))));
          }
          var rhsAggregate$2 = evidence$1$8.a0;
          var rhsMsg$2 = evidence$1$8.am;
          if (evidence$1$8.K) {
            var postRhsIndex$2 = evidence$1$8.G;
            var rhsMadeProgress$2 = (postRhsIndex$2 > preRhsIndex$2);
            var nextIndex$2 = (((!rhsMadeProgress$2) && input.bc(postRhsIndex$2)) ? postLhsIndex$2 : postRhsIndex$2);
            if (rhsMadeProgress$2) {
              evidence$1$8.b7();
            }
            evidence$1$8.cI(lhsValue$2, nextIndex$2);
          }
          if (evidence$1$8.aj) {
            evidence$1$8.aG($m_Lfastparse_internal_Util$().dc(lhsMsg$2, rhsMsg$2), lhsAggregate$2.bl(rhsAggregate$2), (preRhsIndex$2 === evidence$1$8.bq));
          }
        }
      }
    }
    var parsedMsg = ctx$13.am;
    var parsedAgg = ctx$13.a0;
    var postCut = ctx$13.N;
    var verboseFailures = ctx$13.aj;
    if ((!ctx$13.K)) {
      var res$5 = (postCut ? ctx$13 : $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__end$6__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__I__I__I__Z__Lfastparse_ParsingRun($thiz, actualMin$14, ctx$13, repeater$12, acc$12, startIndex$tailLocal7, startIndex$tailLocal7, count$tailLocal7, (!(!(outerCut$tailLocal7 | postCut)))));
      if (verboseFailures) {
        $m_Lfastparse_internal_Util$().uf(startIndex$tailLocal7, actualMin$14, ctx$13, sepMsg$tailLocal7, parsedMsg, lastAgg$tailLocal7, (precut$tailLocal7 || postCut));
      }
      return res$5;
    } else {
      var beforeSepIndex = ctx$13.G;
      repeater$12.qQ(ctx$13.aB, acc$12);
      var nextCount = ((1 + count$tailLocal7) | 0);
      $m_Lfastparse_internal_Util$().dJ($thiz.dK(), ctx$13);
      if (((!ctx$13.K) && ctx$13.N)) {
        return ctx$13;
      } else {
        ctx$13.N = false;
        var outerCut$tailLocal7$tmp1 = (!(!(outerCut$tailLocal7 | postCut)));
        startIndex$tailLocal7 = beforeSepIndex;
        count$tailLocal7 = nextCount;
        precut$tailLocal7 = false;
        outerCut$tailLocal7 = outerCut$tailLocal7$tmp1;
        sepMsg$tailLocal7 = null;
        lastAgg$tailLocal7 = parsedAgg;
      }
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__end$8__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__I__I__I__Z__Lfastparse_ParsingRun($thiz, actualMin$17, ctx$16, repeater$15, acc$15, successIndex, index, count, endCut) {
  return ((count < actualMin$17) ? ctx$16.tT(index, endCut) : ctx$16.u1(repeater$15.ra(acc$15), successIndex, endCut));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__rec$9__Lfastparse_ParsingRun__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__I__I__Z__Z__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_ParsingRun($thiz, ctx$17, actualMin$18, evidence$1$11, repeater$16, acc$16, startIndex, count, precut, outerCut, sepMsg, lastAgg) {
  var lastAgg$tailLocal8 = lastAgg;
  var sepMsg$tailLocal8 = sepMsg;
  var outerCut$tailLocal8 = outerCut;
  var precut$tailLocal8 = precut;
  var count$tailLocal8 = count;
  var startIndex$tailLocal8 = startIndex;
  while (true) {
    ctx$17.N = (!(!(precut$tailLocal8 | ((count$tailLocal8 < actualMin$18) && outerCut$tailLocal8))));
    $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__attrPair__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1$11);
    var parsedMsg = ctx$17.am;
    var parsedAgg = ctx$17.a0;
    var postCut = ctx$17.N;
    var verboseFailures = ctx$17.aj;
    if ((!ctx$17.K)) {
      var res = (postCut ? ctx$17 : $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__end$8__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__I__I__I__Z__Lfastparse_ParsingRun($thiz, actualMin$18, ctx$17, repeater$16, acc$16, startIndex$tailLocal8, startIndex$tailLocal8, count$tailLocal8, (!(!(outerCut$tailLocal8 | postCut)))));
      if (verboseFailures) {
        $m_Lfastparse_internal_Util$().uf(startIndex$tailLocal8, actualMin$18, ctx$17, sepMsg$tailLocal8, parsedMsg, lastAgg$tailLocal8, (precut$tailLocal8 || postCut));
      }
      return res;
    } else {
      var beforeSepIndex = ctx$17.G;
      repeater$16.qQ(ctx$17.aB, acc$16);
      var nextCount = ((1 + count$tailLocal8) | 0);
      $m_Lfastparse_internal_Util$().dJ($thiz.dK(), ctx$17);
      if (((!ctx$17.K) && ctx$17.N)) {
        return ctx$17;
      } else {
        ctx$17.N = false;
        var outerCut$tailLocal8$tmp1 = (!(!(outerCut$tailLocal8 | postCut)));
        startIndex$tailLocal8 = beforeSepIndex;
        count$tailLocal8 = nextCount;
        precut$tailLocal8 = false;
        outerCut$tailLocal8 = outerCut$tailLocal8$tmp1;
        sepMsg$tailLocal8 = null;
        lastAgg$tailLocal8 = parsedAgg;
      }
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__parse0$3$1__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1$10) {
  $m_Lfastparse_Implicits$Sequencer$().qP();
  var preLhsIndex = evidence$1$10.G;
  var input = evidence$1$10.b0;
  $m_Lfastparse_Implicits$Sequencer$();
  var preLhsIndex$2 = evidence$1$10.G;
  var input$2 = evidence$1$10.b0;
  var input$3 = evidence$1$10.b0;
  var index = evidence$1$10.G;
  if ((input$3.bc(index) && (input$3.cA.charCodeAt(index) === 91))) {
    evidence$1$10.dl(((1 + index) | 0));
  } else {
    evidence$1$10.dB();
  }
  if (evidence$1$10.aj) {
    evidence$1$10.de(index, $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => "\"[\""))));
  }
  if (evidence$1$10.K) {
    var postLhsIndex = evidence$1$10.G;
    var lhsAggregate = evidence$1$10.a0;
    var lhsMsg = evidence$1$10.am;
    if ((postLhsIndex > preLhsIndex$2)) {
      evidence$1$10.b7();
    }
    $m_Lfastparse_internal_Util$().dJ($thiz.dK(), evidence$1$10);
    if (evidence$1$10.K) {
      if ((!((!evidence$1$10.K) && evidence$1$10.N))) {
        var preRhsIndex = evidence$1$10.G;
        $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__rec$9__Lfastparse_ParsingRun__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__I__I__Z__Z__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_ParsingRun($thiz, evidence$1$10, 0, evidence$1$10, $m_Lfastparse_Implicits$Repeater$().Ad(), $m_scm_Buffer$().f7(), evidence$1$10.G, 0, false, evidence$1$10.N, null, null);
        var rhsAggregate = evidence$1$10.a0;
        var rhsMsg = evidence$1$10.am;
        if (evidence$1$10.K) {
          var postRhsIndex = evidence$1$10.G;
          var rhsMadeProgress = (postRhsIndex > preRhsIndex);
          var nextIndex = (((!rhsMadeProgress) && input$2.bc(postRhsIndex)) ? postLhsIndex : postRhsIndex);
          if (rhsMadeProgress) {
            evidence$1$10.b7();
          }
          evidence$1$10.cI(evidence$1$10.aB, nextIndex);
        }
        if (evidence$1$10.aj) {
          evidence$1$10.aG($m_Lfastparse_internal_Util$().dc(lhsMsg, rhsMsg), lhsAggregate.bl(rhsAggregate), (preRhsIndex === evidence$1$10.bq));
        }
      }
    }
  }
  if ((!evidence$1$10.K)) {
    return evidence$1$10;
  } else {
    var postLhsIndex$2 = evidence$1$10.G;
    var lhsAggregate$2 = evidence$1$10.a0;
    var lhsMsg$2 = evidence$1$10.am;
    if ((postLhsIndex$2 > preLhsIndex)) {
      evidence$1$10.b7();
    }
    var lhsValue$2 = evidence$1$10.aB;
    $m_Lfastparse_internal_Util$().dJ($thiz.dK(), evidence$1$10);
    if (evidence$1$10.K) {
      if (((!evidence$1$10.K) && evidence$1$10.N)) {
        return evidence$1$10;
      } else {
        var preRhsIndex$2 = evidence$1$10.G;
        var input$4 = evidence$1$10.b0;
        var index$2 = evidence$1$10.G;
        if ((input$4.bc(index$2) && (input$4.cA.charCodeAt(index$2) === 93))) {
          evidence$1$10.dl(((1 + index$2) | 0));
        } else {
          evidence$1$10.dB();
        }
        if (evidence$1$10.aj) {
          evidence$1$10.de(index$2, $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => "\"]\""))));
        }
        var rhsAggregate$2 = evidence$1$10.a0;
        var rhsMsg$2 = evidence$1$10.am;
        if ((!evidence$1$10.K)) {
          var res$4 = evidence$1$10;
        } else {
          var postRhsIndex$2 = evidence$1$10.G;
          var rhsMadeProgress$2 = (postRhsIndex$2 > preRhsIndex$2);
          var nextIndex$2 = (((!rhsMadeProgress$2) && input.bc(postRhsIndex$2)) ? postLhsIndex$2 : postRhsIndex$2);
          if (rhsMadeProgress$2) {
            evidence$1$10.b7();
          }
          var res$4 = evidence$1$10.cI(lhsValue$2, nextIndex$2);
        }
        if (evidence$1$10.aj) {
          evidence$1$10.aG($m_Lfastparse_internal_Util$().dc(lhsMsg$2, rhsMsg$2), lhsAggregate$2.bl(rhsAggregate$2), (preRhsIndex$2 === evidence$1$10.bq));
        }
        return res$4;
      }
    } else {
      return evidence$1$10;
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__end$9__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__I__I__I__Z__Lfastparse_ParsingRun($thiz, actualMin$19, ctx$18, repeater$17, acc$17, successIndex, index, count, endCut) {
  return ((count < actualMin$19) ? ctx$18.tT(index, endCut) : ctx$18.u1(repeater$17.ra(acc$17), successIndex, endCut));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__rec$10__Lfastparse_ParsingRun__I__Lfastparse_Implicits$Repeater__O__Lfastparse_ParsingRun__I__I__Z__Z__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_ParsingRun($thiz, ctx$19, actualMin$20, repeater$18, acc$18, evidence$1$12, startIndex, count, precut, outerCut, sepMsg, lastAgg) {
  var lastAgg$tailLocal9 = lastAgg;
  var sepMsg$tailLocal9 = sepMsg;
  var outerCut$tailLocal9 = outerCut;
  var precut$tailLocal9 = precut;
  var count$tailLocal9 = count;
  var startIndex$tailLocal9 = startIndex;
  while (true) {
    ctx$19.N = (!(!(precut$tailLocal9 | ((count$tailLocal9 < actualMin$20) && outerCut$tailLocal9))));
    $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__parse0$3$1__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1$12);
    var parsedMsg = ctx$19.am;
    var parsedAgg = ctx$19.a0;
    var postCut = ctx$19.N;
    var verboseFailures = ctx$19.aj;
    if ((!ctx$19.K)) {
      var res = (postCut ? ctx$19 : $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__end$9__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__I__I__I__Z__Lfastparse_ParsingRun($thiz, actualMin$20, ctx$19, repeater$18, acc$18, startIndex$tailLocal9, startIndex$tailLocal9, count$tailLocal9, (!(!(outerCut$tailLocal9 | postCut)))));
      if (verboseFailures) {
        $m_Lfastparse_internal_Util$().uf(startIndex$tailLocal9, actualMin$20, ctx$19, sepMsg$tailLocal9, parsedMsg, lastAgg$tailLocal9, (precut$tailLocal9 || postCut));
      }
      return res;
    } else {
      var beforeSepIndex = ctx$19.G;
      repeater$18.qQ(ctx$19.aB, acc$18);
      var nextCount = ((1 + count$tailLocal9) | 0);
      $m_Lfastparse_internal_Util$().dJ($thiz.dK(), ctx$19);
      if (((!ctx$19.K) && ctx$19.N)) {
        return ctx$19;
      } else {
        ctx$19.N = false;
        var outerCut$tailLocal9$tmp1 = (!(!(outerCut$tailLocal9 | postCut)));
        startIndex$tailLocal9 = beforeSepIndex;
        count$tailLocal9 = nextCount;
        precut$tailLocal9 = false;
        outerCut$tailLocal9 = outerCut$tailLocal9$tmp1;
        sepMsg$tailLocal9 = null;
        lastAgg$tailLocal9 = parsedAgg;
      }
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__end$10__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__I__I__I__Z__Lfastparse_ParsingRun($thiz, actualMin$21, ctx$20, repeater$19, acc$19, successIndex, index, count, endCut) {
  return ((count < actualMin$21) ? ctx$20.tT(index, endCut) : ctx$20.u1(repeater$19.ra(acc$19), successIndex, endCut));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__rec$11__Lfastparse_ParsingRun__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__I__I__Z__Z__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_ParsingRun($thiz, ctx$21, actualMin$22, evidence$1$13, repeater$20, acc$20, startIndex, count, precut, outerCut, sepMsg, lastAgg) {
  var lastAgg$tailLocal10 = lastAgg;
  var sepMsg$tailLocal10 = sepMsg;
  var outerCut$tailLocal10 = outerCut;
  var precut$tailLocal10 = precut;
  var count$tailLocal10 = count;
  var startIndex$tailLocal10 = startIndex;
  while (true) {
    ctx$21.N = (!(!(precut$tailLocal10 | ((count$tailLocal10 < actualMin$22) && outerCut$tailLocal10))));
    $m_Lfastparse_Implicits$Sequencer$();
    var preLhsIndex = evidence$1$13.G;
    var input = evidence$1$13.b0;
    var input$2 = evidence$1$13.b0;
    var index = evidence$1$13.G;
    if ((input$2.bc(index) && (input$2.cA.charCodeAt(index) === 44))) {
      evidence$1$13.dl(((1 + index) | 0));
    } else {
      evidence$1$13.dB();
    }
    if (evidence$1$13.aj) {
      evidence$1$13.de(index, $m_Lfastparse_internal_Msgs$().bn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => "\",\""))));
    }
    if (evidence$1$13.K) {
      var postLhsIndex = evidence$1$13.G;
      var lhsAggregate = evidence$1$13.a0;
      var lhsMsg = evidence$1$13.am;
      if ((postLhsIndex > preLhsIndex)) {
        evidence$1$13.b7();
      }
      $m_Lfastparse_internal_Util$().dJ($thiz.dK(), evidence$1$13);
      if (evidence$1$13.K) {
        if ((!((!evidence$1$13.K) && evidence$1$13.N))) {
          var preRhsIndex = evidence$1$13.G;
          $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__nodeId__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1$13);
          var rhsAggregate = evidence$1$13.a0;
          var rhsMsg = evidence$1$13.am;
          if (evidence$1$13.K) {
            var postRhsIndex = evidence$1$13.G;
            var rhsMadeProgress = (postRhsIndex > preRhsIndex);
            var nextIndex = (((!rhsMadeProgress) && input.bc(postRhsIndex)) ? postLhsIndex : postRhsIndex);
            if (rhsMadeProgress) {
              evidence$1$13.b7();
            }
            evidence$1$13.cI(evidence$1$13.aB, nextIndex);
          }
          if (evidence$1$13.aj) {
            evidence$1$13.aG($m_Lfastparse_internal_Util$().dc(lhsMsg, rhsMsg), lhsAggregate.bl(rhsAggregate), (preRhsIndex === evidence$1$13.bq));
          }
        }
      }
    }
    var parsedMsg = ctx$21.am;
    var parsedAgg = ctx$21.a0;
    var postCut = ctx$21.N;
    var verboseFailures = ctx$21.aj;
    if ((!ctx$21.K)) {
      var res$3 = (postCut ? ctx$21 : $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__end$10__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__I__I__I__Z__Lfastparse_ParsingRun($thiz, actualMin$22, ctx$21, repeater$20, acc$20, startIndex$tailLocal10, startIndex$tailLocal10, count$tailLocal10, (!(!(outerCut$tailLocal10 | postCut)))));
      if (verboseFailures) {
        $m_Lfastparse_internal_Util$().uf(startIndex$tailLocal10, actualMin$22, ctx$21, sepMsg$tailLocal10, parsedMsg, lastAgg$tailLocal10, (precut$tailLocal10 || postCut));
      }
      return res$3;
    } else {
      var beforeSepIndex = ctx$21.G;
      repeater$20.qQ(ctx$21.aB, acc$20);
      var nextCount = ((1 + count$tailLocal10) | 0);
      $m_Lfastparse_internal_Util$().dJ($thiz.dK(), ctx$21);
      if (((!ctx$21.K) && ctx$21.N)) {
        return ctx$21;
      } else {
        ctx$21.N = false;
        var outerCut$tailLocal10$tmp1 = (!(!(outerCut$tailLocal10 | postCut)));
        startIndex$tailLocal10 = beforeSepIndex;
        count$tailLocal10 = nextCount;
        precut$tailLocal10 = false;
        outerCut$tailLocal10 = outerCut$tailLocal10$tmp1;
        sepMsg$tailLocal10 = null;
        lastAgg$tailLocal10 = parsedAgg;
      }
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__end$11__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__I__I__I__Z__Lfastparse_ParsingRun($thiz, actualMin$23, ctx$22, repeater$21, acc$21, successIndex, index, count, endCut) {
  return ((count < actualMin$23) ? ctx$22.tT(index, endCut) : ctx$22.u1(repeater$21.ra(acc$21), successIndex, endCut));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__rec$12__Lfastparse_ParsingRun__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__I__I__Z__Z__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_ParsingRun($thiz, ctx$23, actualMin$24, evidence$1$14, repeater$22, acc$22, startIndex, count, precut, outerCut, sepMsg, lastAgg) {
  var lastAgg$tailLocal11 = lastAgg;
  var sepMsg$tailLocal11 = sepMsg;
  var outerCut$tailLocal11 = outerCut;
  var precut$tailLocal11 = precut;
  var count$tailLocal11 = count;
  var startIndex$tailLocal11 = startIndex;
  while (true) {
    ctx$23.N = (!(!(precut$tailLocal11 | ((count$tailLocal11 < actualMin$24) && outerCut$tailLocal11))));
    $m_Lfastparse_Implicits$Sequencer$();
    var preLhsIndex = evidence$1$14.G;
    var input = evidence$1$14.b0;
    $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__edgeOp__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1$14);
    if (evidence$1$14.K) {
      var postLhsIndex = evidence$1$14.G;
      var lhsAggregate = evidence$1$14.a0;
      var lhsMsg = evidence$1$14.am;
      if ((postLhsIndex > preLhsIndex)) {
        evidence$1$14.b7();
      }
      $m_Lfastparse_internal_Util$().dJ($thiz.dK(), evidence$1$14);
      if (evidence$1$14.K) {
        if ((!((!evidence$1$14.K) && evidence$1$14.N))) {
          var preRhsIndex = evidence$1$14.G;
          $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__rawEnd__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1$14);
          var rhsAggregate = evidence$1$14.a0;
          var rhsMsg = evidence$1$14.am;
          if (evidence$1$14.K) {
            var postRhsIndex = evidence$1$14.G;
            var rhsMadeProgress = (postRhsIndex > preRhsIndex);
            var nextIndex = (((!rhsMadeProgress) && input.bc(postRhsIndex)) ? postLhsIndex : postRhsIndex);
            if (rhsMadeProgress) {
              evidence$1$14.b7();
            }
            evidence$1$14.cI(evidence$1$14.aB, nextIndex);
          }
          if (evidence$1$14.aj) {
            evidence$1$14.aG($m_Lfastparse_internal_Util$().dc(lhsMsg, rhsMsg), lhsAggregate.bl(rhsAggregate), (preRhsIndex === evidence$1$14.bq));
          }
        }
      }
    }
    var parsedMsg = ctx$23.am;
    var parsedAgg = ctx$23.a0;
    var postCut = ctx$23.N;
    var verboseFailures = ctx$23.aj;
    if ((!ctx$23.K)) {
      var res$2 = (postCut ? ctx$23 : $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__end$11__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__I__I__I__Z__Lfastparse_ParsingRun($thiz, actualMin$24, ctx$23, repeater$22, acc$22, startIndex$tailLocal11, startIndex$tailLocal11, count$tailLocal11, (!(!(outerCut$tailLocal11 | postCut)))));
      if (verboseFailures) {
        $m_Lfastparse_internal_Util$().uf(startIndex$tailLocal11, actualMin$24, ctx$23, sepMsg$tailLocal11, parsedMsg, lastAgg$tailLocal11, (precut$tailLocal11 || postCut));
      }
      return res$2;
    } else {
      var beforeSepIndex = ctx$23.G;
      repeater$22.qQ(ctx$23.aB, acc$22);
      var nextCount = ((1 + count$tailLocal11) | 0);
      $m_Lfastparse_internal_Util$().dJ($thiz.dK(), ctx$23);
      if (((!ctx$23.K) && ctx$23.N)) {
        return ctx$23;
      } else {
        ctx$23.N = false;
        var outerCut$tailLocal11$tmp1 = (!(!(outerCut$tailLocal11 | postCut)));
        startIndex$tailLocal11 = beforeSepIndex;
        count$tailLocal11 = nextCount;
        precut$tailLocal11 = false;
        outerCut$tailLocal11 = outerCut$tailLocal11$tmp1;
        sepMsg$tailLocal11 = null;
        lastAgg$tailLocal11 = parsedAgg;
      }
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__end$12__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__I__I__I__Z__Lfastparse_ParsingRun($thiz, actualMin$25, ctx$24, repeater$23, acc$23, successIndex, index, count, endCut) {
  return ((count < actualMin$25) ? ctx$24.tT(index, endCut) : ctx$24.u1(repeater$23.ra(acc$23), successIndex, endCut));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__rec$13__Lfastparse_ParsingRun__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__I__I__Z__Z__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_ParsingRun($thiz, ctx$25, actualMin$26, evidence$1$15, repeater$24, acc$24, startIndex, count, precut, outerCut, sepMsg, lastAgg) {
  var lastAgg$tailLocal12 = lastAgg;
  var sepMsg$tailLocal12 = sepMsg;
  var outerCut$tailLocal12 = outerCut;
  var precut$tailLocal12 = precut;
  var count$tailLocal12 = count;
  var startIndex$tailLocal12 = startIndex;
  while (true) {
    ctx$25.N = (!(!(precut$tailLocal12 | ((count$tailLocal12 < actualMin$26) && outerCut$tailLocal12))));
    $m_Lfastparse_Implicits$Sequencer$().qP();
    var preLhsIndex = evidence$1$15.G;
    var input = evidence$1$15.b0;
    $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__stmt__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1$15);
    if (evidence$1$15.K) {
      var postLhsIndex = evidence$1$15.G;
      var lhsAggregate = evidence$1$15.a0;
      var lhsMsg = evidence$1$15.am;
      if ((postLhsIndex > preLhsIndex)) {
        evidence$1$15.b7();
      }
      var lhsValue = evidence$1$15.aB;
      $m_Lfastparse_internal_Util$().dJ($thiz.dK(), evidence$1$15);
      if (evidence$1$15.K) {
        if ((!((!evidence$1$15.K) && evidence$1$15.N))) {
          var preRhsIndex = evidence$1$15.G;
          $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__semiOpt__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1$15);
          var rhsAggregate = evidence$1$15.a0;
          var rhsMsg = evidence$1$15.am;
          if (evidence$1$15.K) {
            var postRhsIndex = evidence$1$15.G;
            var rhsMadeProgress = (postRhsIndex > preRhsIndex);
            var nextIndex = (((!rhsMadeProgress) && input.bc(postRhsIndex)) ? postLhsIndex : postRhsIndex);
            if (rhsMadeProgress) {
              evidence$1$15.b7();
            }
            evidence$1$15.cI(lhsValue, nextIndex);
          }
          if (evidence$1$15.aj) {
            evidence$1$15.aG($m_Lfastparse_internal_Util$().dc(lhsMsg, rhsMsg), lhsAggregate.bl(rhsAggregate), (preRhsIndex === evidence$1$15.bq));
          }
        }
      }
    }
    var parsedMsg = ctx$25.am;
    var parsedAgg = ctx$25.a0;
    var postCut = ctx$25.N;
    var verboseFailures = ctx$25.aj;
    if ((!ctx$25.K)) {
      var res$2 = (postCut ? ctx$25 : $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__end$12__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__I__I__I__Z__Lfastparse_ParsingRun($thiz, actualMin$26, ctx$25, repeater$24, acc$24, startIndex$tailLocal12, startIndex$tailLocal12, count$tailLocal12, (!(!(outerCut$tailLocal12 | postCut)))));
      if (verboseFailures) {
        $m_Lfastparse_internal_Util$().uf(startIndex$tailLocal12, actualMin$26, ctx$25, sepMsg$tailLocal12, parsedMsg, lastAgg$tailLocal12, (precut$tailLocal12 || postCut));
      }
      return res$2;
    } else {
      var beforeSepIndex = ctx$25.G;
      repeater$24.qQ(ctx$25.aB, acc$24);
      var nextCount = ((1 + count$tailLocal12) | 0);
      $m_Lfastparse_internal_Util$().dJ($thiz.dK(), ctx$25);
      if (((!ctx$25.K) && ctx$25.N)) {
        return ctx$25;
      } else {
        ctx$25.N = false;
        var outerCut$tailLocal12$tmp1 = (!(!(outerCut$tailLocal12 | postCut)));
        startIndex$tailLocal12 = beforeSepIndex;
        count$tailLocal12 = nextCount;
        precut$tailLocal12 = false;
        outerCut$tailLocal12 = outerCut$tailLocal12$tmp1;
        sepMsg$tailLocal12 = null;
        lastAgg$tailLocal12 = parsedAgg;
      }
    }
  }
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$() {
  this.atZ = null;
  this.au0 = false;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$.prototype = $p;
$p.dK = (function() {
  if ((!this.au0)) {
    this.atZ = new $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$$anon$1();
    this.au0 = true;
  }
  return this.atZ;
});
$p.PH = (function(input) {
  var x113 = $f_Lfastparse_SharedPackageDefs__parse__Lfastparse_ParserInputSource__F1__Z__I__Lfastparse_internal_Instrument__Lfastparse_Parsed($m_Lfastparse_package$(), new $c_Lfastparse_ParserInputSource$fromParserInput(input, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((s) => new $c_Lfastparse_IndexedParserInput(s)))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$21) => $p_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__graphP__Lfastparse_ParsingRun__Lfastparse_ParsingRun($m_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$(), _$21))), false, 0, null);
  if ((x113 instanceof $c_Lfastparse_Parsed$Success)) {
    return new $c_s_util_Right(x113.EH);
  }
  if ((x113 instanceof $c_Lfastparse_Parsed$Failure)) {
    return new $c_s_util_Left(x113.AV.bap(false).QW.b4a());
  }
  throw new $c_s_MatchError(x113);
});
var $d_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$, "org.jpablo.graphexplorer.graphviz.dotlang.DotParser$", ({
  un: 1
}));
var $n_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$;
function $m_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$() {
  if ((!$n_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$)) {
    $n_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$ = new $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$();
  }
  return $n_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_html_Entities$() {
  this.au1 = null;
  $n_Lorg_jpablo_graphexplorer_graphviz_html_Entities$ = this;
  this.au1 = $m_sci_Map$().ao($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("AElig", 198), new $c_T2("Aacute", 193), new $c_T2("Acirc", 194), new $c_T2("Agrave", 192), new $c_T2("Alpha", 913), new $c_T2("Aring", 197), new $c_T2("Atilde", 195), new $c_T2("Auml", 196), new $c_T2("Beta", 914), new $c_T2("Ccedil", 199), new $c_T2("Chi", 935), new $c_T2("Dagger", 8225), new $c_T2("Delta", 916), new $c_T2("ETH", 208), new $c_T2("Eacute", 201), new $c_T2("Ecirc", 202), new $c_T2("Egrave", 200), new $c_T2("Epsilon", 917), new $c_T2("Eta", 919), new $c_T2("Euml", 203), new $c_T2("Gamma", 915), new $c_T2("Iacute", 205), new $c_T2("Icirc", 206), new $c_T2("Igrave", 204), new $c_T2("Iota", 921), new $c_T2("Iuml", 207), new $c_T2("Kappa", 922), new $c_T2("Lambda", 923), new $c_T2("Mu", 924), new $c_T2("Ntilde", 209), new $c_T2("Nu", 925), new $c_T2("OElig", 338), new $c_T2("Oacute", 211), new $c_T2("Ocirc", 212), new $c_T2("Ograve", 210), new $c_T2("Omega", 937), new $c_T2("Omicron", 927), new $c_T2("Oslash", 216), new $c_T2("Otilde", 213), new $c_T2("Ouml", 214), new $c_T2("Phi", 934), new $c_T2("Pi", 928), new $c_T2("Prime", 8243), new $c_T2("Psi", 936), new $c_T2("Rho", 929), new $c_T2("Scaron", 352), new $c_T2("Sigma", 931), new $c_T2("THORN", 222), new $c_T2("Tau", 932), new $c_T2("Theta", 920), new $c_T2("Uacute", 218), new $c_T2("Ucirc", 219), new $c_T2("Ugrave", 217), new $c_T2("Upsilon", 933), new $c_T2("Uuml", 220), new $c_T2("Xi", 926), new $c_T2("Yacute", 221), new $c_T2("Yuml", 376), new $c_T2("Zeta", 918), new $c_T2("aacute", 225), new $c_T2("acirc", 226), new $c_T2("acute", 180), new $c_T2("aelig", 230), new $c_T2("agrave", 224), new $c_T2("alefsym", 8501), new $c_T2("alpha", 945), new $c_T2("amp", 38), new $c_T2("and", 8743), new $c_T2("ang", 8736), new $c_T2("aring", 229), new $c_T2("asymp", 8776), new $c_T2("atilde", 227), new $c_T2("auml", 228), new $c_T2("bdquo", 8222), new $c_T2("beta", 946), new $c_T2("brvbar", 166), new $c_T2("bull", 8226), new $c_T2("cap", 8745), new $c_T2("ccedil", 231), new $c_T2("cedil", 184), new $c_T2("cent", 162), new $c_T2("chi", 967), new $c_T2("circ", 710), new $c_T2("clubs", 9827), new $c_T2("cong", 8773), new $c_T2("copy", 169), new $c_T2("crarr", 8629), new $c_T2("cup", 8746), new $c_T2("curren", 164), new $c_T2("dArr", 8659), new $c_T2("dagger", 8224), new $c_T2("darr", 8595), new $c_T2("deg", 176), new $c_T2("delta", 948), new $c_T2("diams", 9830), new $c_T2("divide", 247), new $c_T2("eacute", 233), new $c_T2("ecirc", 234), new $c_T2("egrave", 232), new $c_T2("empty", 8709), new $c_T2("emsp", 8195), new $c_T2("ensp", 8194), new $c_T2("epsilon", 949), new $c_T2("equiv", 8801), new $c_T2("eta", 951), new $c_T2("eth", 240), new $c_T2("euml", 235), new $c_T2("euro", 8364), new $c_T2("exist", 8707), new $c_T2("fnof", 402), new $c_T2("forall", 8704), new $c_T2("frac12", 189), new $c_T2("frac14", 188), new $c_T2("frac34", 190), new $c_T2("frasl", 8260), new $c_T2("gamma", 947), new $c_T2("ge", 8805), new $c_T2("gt", 62), new $c_T2("hArr", 8660), new $c_T2("harr", 8596), new $c_T2("hearts", 9829), new $c_T2("hellip", 8230), new $c_T2("iacute", 237), new $c_T2("icirc", 238), new $c_T2("iexcl", 161), new $c_T2("igrave", 236), new $c_T2("image", 8465), new $c_T2("infin", 8734), new $c_T2("int", 8747), new $c_T2("iota", 953), new $c_T2("iquest", 191), new $c_T2("isin", 8712), new $c_T2("iuml", 239), new $c_T2("kappa", 954), new $c_T2("lArr", 8656), new $c_T2("lambda", 955), new $c_T2("lang", 9001), new $c_T2("laquo", 171), new $c_T2("larr", 8592), new $c_T2("lceil", 8968), new $c_T2("ldquo", 8220), new $c_T2("le", 8804), new $c_T2("lfloor", 8970), new $c_T2("lowast", 8727), new $c_T2("loz", 9674), new $c_T2("lrm", 8206), new $c_T2("lsaquo", 8249), new $c_T2("lsquo", 8216), new $c_T2("lt", 60), new $c_T2("macr", 175), new $c_T2("mdash", 8212), new $c_T2("micro", 181), new $c_T2("middot", 183), new $c_T2("minus", 8722), new $c_T2("mu", 956), new $c_T2("nabla", 8711), new $c_T2("nbsp", 160), new $c_T2("ndash", 8211), new $c_T2("ne", 8800), new $c_T2("ni", 8715), new $c_T2("not", 172), new $c_T2("notin", 8713), new $c_T2("nsub", 8836), new $c_T2("ntilde", 241), new $c_T2("nu", 957), new $c_T2("oacute", 243), new $c_T2("ocirc", 244), new $c_T2("oelig", 339), new $c_T2("ograve", 242), new $c_T2("oline", 8254), new $c_T2("omega", 969), new $c_T2("omicron", 959), new $c_T2("oplus", 8853), new $c_T2("or", 8744), new $c_T2("ordf", 170), new $c_T2("ordm", 186), new $c_T2("oslash", 248), new $c_T2("otilde", 245), new $c_T2("otimes", 8855), new $c_T2("ouml", 246), new $c_T2("para", 182), new $c_T2("part", 8706), new $c_T2("permil", 8240), new $c_T2("perp", 8869), new $c_T2("phi", 966), new $c_T2("pi", 960), new $c_T2("piv", 982), new $c_T2("plusmn", 177), new $c_T2("pound", 163), new $c_T2("prime", 8242), new $c_T2("prod", 8719), new $c_T2("prop", 8733), new $c_T2("psi", 968), new $c_T2("quot", 34), new $c_T2("rArr", 8658), new $c_T2("radic", 8730), new $c_T2("rang", 9002), new $c_T2("raquo", 187), new $c_T2("rarr", 8594), new $c_T2("rceil", 8969), new $c_T2("rdquo", 8221), new $c_T2("real", 8476), new $c_T2("reg", 174), new $c_T2("rfloor", 8971), new $c_T2("rho", 961), new $c_T2("rlm", 8207), new $c_T2("rsaquo", 8250), new $c_T2("rsquo", 8217), new $c_T2("sbquo", 8218), new $c_T2("scaron", 353), new $c_T2("sdot", 8901), new $c_T2("sect", 167), new $c_T2("shy", 173), new $c_T2("sigma", 963), new $c_T2("sigmaf", 962), new $c_T2("sim", 8764), new $c_T2("spades", 9824), new $c_T2("sub", 8834), new $c_T2("sube", 8838), new $c_T2("sum", 8721), new $c_T2("sup", 8835), new $c_T2("sup1", 185), new $c_T2("sup2", 178), new $c_T2("sup3", 179), new $c_T2("supe", 8839), new $c_T2("szlig", 223), new $c_T2("tau", 964), new $c_T2("there4", 8756), new $c_T2("theta", 952), new $c_T2("thetasym", 977), new $c_T2("thinsp", 8201), new $c_T2("thorn", 254), new $c_T2("tilde", 732), new $c_T2("times", 215), new $c_T2("trade", 8482), new $c_T2("uArr", 8657), new $c_T2("uacute", 250), new $c_T2("uarr", 8593), new $c_T2("ucirc", 251), new $c_T2("ugrave", 249), new $c_T2("uml", 168), new $c_T2("upsih", 978), new $c_T2("upsilon", 965), new $c_T2("uuml", 252), new $c_T2("weierp", 8472), new $c_T2("xi", 958), new $c_T2("yacute", 253), new $c_T2("yen", 165), new $c_T2("yuml", 255), new $c_T2("zeta", 950), new $c_T2("zwj", 8205), new $c_T2("zwnj", 8204)])));
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_html_Entities$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_html_Entities$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_html_Entities$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_html_Entities$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_graphviz_html_Entities$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_html_Entities$, "org.jpablo.graphexplorer.graphviz.html.Entities$", ({
  up: 1
}));
var $n_Lorg_jpablo_graphexplorer_graphviz_html_Entities$;
function $m_Lorg_jpablo_graphexplorer_graphviz_html_Entities$() {
  if ((!$n_Lorg_jpablo_graphexplorer_graphviz_html_Entities$)) {
    $n_Lorg_jpablo_graphexplorer_graphviz_html_Entities$ = new $c_Lorg_jpablo_graphexplorer_graphviz_html_Entities$();
  }
  return $n_Lorg_jpablo_graphexplorer_graphviz_html_Entities$;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$__flagged$1__Lorg_jpablo_graphexplorer_graphviz_html_HtmlFont__Z($thiz, f) {
  return (((((f.nP || f.nQ) || f.oP) || f.pN) || f.oN) || f.oO);
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$() {
  this.aTO = 0.0;
  this.aTO = 1.2;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$.prototype = $p;
$p.aPt = (function(it, baseSize, baseName) {
  var this$1 = it.hb.kZ;
  var sz = (+(this$1.c() ? baseSize : this$1.d()));
  var this$2 = it.hb.n1;
  var nm = (this$2.c() ? baseName : this$2.d());
  var low = nm.toLowerCase();
  var bld = (it.hb.nP || ((low.indexOf("bold") | 0) !== (-1)));
  var itl = ((it.hb.nQ || ((low.indexOf("italic") | 0) !== (-1))) || ((low.indexOf("oblique") | 0) !== (-1)));
  return (sz * $m_Lorg_jpablo_graphexplorer_graphviz_metrics_FontMetrics$().WI(nm, it.pO, bld, itl));
});
$p.aSJ = (function(block, baseSize, baseName) {
  var spans = block.oW;
  var rest = spans;
  var h = null;
  var t = null;
  while ((rest !== $m_sci_Nil$())) {
    var it = rest.t().lz.o();
    while (it.p()) {
      var nx = new $c_sci_$colon$colon(it.q(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        t.U = nx;
      }
      t = nx;
    }
    rest = rest.v();
  }
  var allItems = ((h === null) ? $m_sci_Nil$() : h);
  _return: {
    var these = spans;
    while ((!these.c())) {
      if ((!(these.t().lz.bL(1) <= 0))) {
        var $x_2 = false;
        break _return;
      }
      these = these.v();
    }
    var $x_2 = true;
  }
  if ($x_2) {
    _return$1: {
      var these$1 = allItems;
      while ((!these$1.c())) {
        if ((!(!$p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$__flagged$1__Lorg_jpablo_graphexplorer_graphviz_html_HtmlFont__Z(this, these$1.t().hb)))) {
          var $x_1 = false;
          break _return$1;
        }
        these$1 = these$1.v();
      }
      var $x_1 = true;
    }
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    var f = ((it$2) => {
      var this$3 = it$2.hb.kZ;
      var _1 = (this$3.c() ? baseSize : this$3.d());
      var this$4 = it$2.hb.n1;
      return new $c_T2(_1, (this$4.c() ? baseName : this$4.d()));
    });
    if ((allItems === $m_sci_Nil$())) {
      var $x_3 = $m_sci_Nil$();
    } else {
      var x0$3 = allItems.t();
      var h$1 = new $c_sci_$colon$colon(f(x0$3), $m_sci_Nil$());
      var t$1 = h$1;
      var rest$1 = allItems.v();
      while ((rest$1 !== $m_sci_Nil$())) {
        var x0$4 = rest$1.t();
        var nx$1 = new $c_sci_$colon$colon(f(x0$4), $m_sci_Nil$());
        t$1.U = nx$1;
        t$1 = nx$1;
        rest$1 = rest$1.v();
      }
      var $x_3 = h$1;
    }
    var simple = ($f_sc_SeqOps__distinct__O($x_3).nE(1) <= 0);
  } else {
    var simple = false;
  }
  var elem = 0.0;
  elem = 0.0;
  var elem$1 = 0.0;
  elem$1 = 0.0;
  var elem$2 = 0.0;
  elem$2 = 0.0;
  var elem$3 = 0.0;
  elem$3 = 0.0;
  $m_sci_Vector$();
  var lines = new $c_sci_VectorBuilder();
  var this$13 = $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(spans);
  var these$2 = this$13;
  while ((!these$2.c())) {
    var x0$5 = these$2.t();
    var sp = x0$5.g();
    var i = (x0$5.h() | 0);
    var this$14 = sp.lz;
    var f$1 = ((baseSize, baseName) => ((_$5) => $m_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$().aPt(_$5, baseSize, baseName)))(baseSize, baseName);
    if ((this$14 === $m_sci_Nil$())) {
      var $x_4 = $m_sci_Nil$();
    } else {
      var x0$6 = this$14.t();
      var h$2 = new $c_sci_$colon$colon(f$1(x0$6), $m_sci_Nil$());
      var t$2 = h$2;
      var rest$2 = this$14.v();
      while ((rest$2 !== $m_sci_Nil$())) {
        var x0$7 = rest$2.t();
        var nx$2 = new $c_sci_$colon$colon(f$1(x0$7), $m_sci_Nil$());
        t$2.U = nx$2;
        t$2 = nx$2;
        rest$2 = rest$2.v();
      }
      var $x_4 = h$2;
    }
    var width = (+$f_sc_IterableOnceOps__sum__s_math_Numeric__O($x_4, $m_s_math_Numeric$DoubleIsFractional$()));
    var this$17 = sp.lz;
    var f$2 = ((baseSize) => ((it$1) => {
      var this$16 = it$1.hb.kZ;
      return (+(this$16.c() ? baseSize : this$16.d()));
    }))(baseSize);
    if ((this$17 === $m_sci_Nil$())) {
      var $x_5 = $m_sci_Nil$();
    } else {
      var x0$8 = this$17.t();
      var h$3 = new $c_sci_$colon$colon(f$2(x0$8), $m_sci_Nil$());
      var t$3 = h$3;
      var rest$3 = this$17.v();
      while ((rest$3 !== $m_sci_Nil$())) {
        var x0$9 = rest$3.t();
        var nx$3 = new $c_sci_$colon$colon(f$2(x0$9), $m_sci_Nil$());
        t$3.U = nx$3;
        t$3 = nx$3;
        rest$3 = rest$3.v();
      }
      var $x_5 = h$3;
    }
    var this$19 = $f_sc_IterableOnceOps__maxOption__s_math_Ordering__s_Option($x_5, $m_s_math_Ordering$DeprecatedDoubleOrdering$());
    var mxfsize = (+(this$19.c() ? 0.0 : this$19.d()));
    var this$21 = sp.lz;
    var f$3 = ((baseSize) => ((it$2$1) => {
      var this$20 = it$2$1.hb.kZ;
      return (1.2 * (+(this$20.c() ? baseSize : this$20.d())));
    }))(baseSize);
    if ((this$21 === $m_sci_Nil$())) {
      var $x_6 = $m_sci_Nil$();
    } else {
      var x0$10 = this$21.t();
      var h$4 = new $c_sci_$colon$colon(f$3(x0$10), $m_sci_Nil$());
      var t$4 = h$4;
      var rest$4 = this$21.v();
      while ((rest$4 !== $m_sci_Nil$())) {
        var x0$11 = rest$4.t();
        var nx$4 = new $c_sci_$colon$colon(f$3(x0$11), $m_sci_Nil$());
        t$4.U = nx$4;
        t$4 = nx$4;
        rest$4 = rest$4.v();
      }
      var $x_6 = h$4;
    }
    var this$23 = $f_sc_IterableOnceOps__maxOption__s_math_Ordering__s_Option($x_6, $m_s_math_Ordering$DeprecatedDoubleOrdering$());
    var mxysize = (+(this$23.c() ? 0.0 : this$23.d()));
    var this$25 = sp.lz;
    var f$4 = ((baseSize) => ((it$3) => {
      var this$24 = it$3.hb.kZ;
      return (0.1 * (+(this$24.c() ? baseSize : this$24.d())));
    }))(baseSize);
    if ((this$25 === $m_sci_Nil$())) {
      var $x_7 = $m_sci_Nil$();
    } else {
      var x0$12 = this$25.t();
      var h$5 = new $c_sci_$colon$colon(f$4(x0$12), $m_sci_Nil$());
      var t$5 = h$5;
      var rest$5 = this$25.v();
      while ((rest$5 !== $m_sci_Nil$())) {
        var x0$13 = rest$5.t();
        var nx$5 = new $c_sci_$colon$colon(f$4(x0$13), $m_sci_Nil$());
        t$5.U = nx$5;
        t$5 = nx$5;
        rest$5 = rest$5.v();
      }
      var $x_7 = h$5;
    }
    var this$27 = $f_sc_IterableOnceOps__maxOption__s_math_Ordering__s_Option($x_7, $m_s_math_Ordering$DeprecatedDoubleOrdering$());
    var maxoffset = (+(this$27.c() ? 0.0 : this$27.d()));
    if ((i === 0)) {
      elem$3 = mxysize;
    }
    if (simple) {
      var \u03b41$___1 = mxysize;
      var \u03b41$___2 = ((i === 0) ? mxfsize : mxysize);
    } else {
      var \u03b41$___1 = mxfsize;
      var \u03b41$___2 = ((i === 0) ? (mxfsize - maxoffset) : (((mxfsize + elem) - elem$1) - maxoffset));
    }
    var lsize = (+\u03b41$___1);
    var lfsize = (+\u03b41$___2);
    elem$1 = (elem$1 + lfsize);
    elem = (elem + lsize);
    var x = elem$2;
    elem$2 = (+Math.max(x, width));
    lines.ck(new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$HtmlLine(width, lsize, lfsize));
    these$2 = these$2.v();
  }
  return new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$HtmlTextLayout(elem$2, ((spans.C() === 1) ? elem$3 : elem), simple, lines.bY());
});
$p.a4W = (function(block, baseSize, baseName) {
  var t = this.aSJ(block, baseSize, baseName);
  return new $c_T2(t.Kq, t.F1);
});
$p.PU = (function(label, baseSize, baseName, imgs) {
  if ((label instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Text)) {
    return this.a4W(label.oQ, baseSize, baseName);
  }
  if ((label instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Table)) {
    return $m_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$().b8U(label.k8, baseSize, baseName, imgs);
  }
  if ((label instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Image)) {
    var x12 = label.wy;
    var this$4 = imgs.r(x12);
    var this$5 = (this$4.c() ? $m_s_None$() : new $c_s_Some(this$4.d().aNz()));
    return (this$5.c() ? new $c_T2(0.0, 0.0) : this$5.d());
  }
  throw new $c_s_MatchError(label);
});
var $d_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$, "org.jpablo.graphexplorer.graphviz.html.HtmlLayout$", ({
  ut: 1
}));
var $n_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$;
function $m_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$() {
  if ((!$n_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$)) {
    $n_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$ = new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$();
  }
  return $n_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$__decodeEntities__T__T($thiz, s) {
  if (($f_T__indexOf__I__I(s, 38) < 0)) {
    return s;
  } else {
    var sb = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
    var i = 0;
    while ((i < s.length)) {
      var index = i;
      var c = s.charCodeAt(index);
      if ((c === 38)) {
        var semi = $f_T__indexOf__I__I__I(s, 59, i);
        if ((semi > i)) {
          var beginIndex = ((1 + i) | 0);
          var ent = s.substring(beginIndex, semi);
          var $x_1;
          switch (ent) {
            case "lt": {
              var $x_1 = "<";
              break;
            }
            case "gt": {
              var $x_1 = ">";
              break;
            }
            case "amp": {
              var $x_1 = "&";
              break;
            }
            case "quot": {
              var $x_1 = "\"";
              break;
            }
            case "apos": {
              var $x_1 = "'";
              break;
            }
            case "nbsp": {
              var $x_1 = "\u00a0";
              break;
            }
            default: {
              if (((!(!ent.startsWith("#x"))) || (!(!ent.startsWith("#X"))))) {
                try {
                  var $x_2 = new $c_s_util_Success($m_jl_Integer$().gc($m_sc_StringOps$().kp(ent, 2), 16, 134217728));
                } catch (e) {
                  var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
                  matchEnd8: {
                    var $x_2;
                    if ($m_s_util_control_NonFatal$().ew(e$2)) {
                      var $x_2 = new $c_s_util_Failure(e$2);
                      break matchEnd8;
                    }
                    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
                  }
                }
                var this$6 = $x_2.rg();
                var this$9 = (this$6.c() ? $m_s_None$() : new $c_s_Some(("" + $cToS((65535 & (this$6.d() | 0))))));
                var $x_1 = (this$9.c() ? (("&" + ent) + ";") : this$9.d());
                break;
              }
              if ((!(!ent.startsWith("#")))) {
                var this$13 = $m_sc_StringParsers$().hT($m_sc_StringOps$().kp(ent, 1));
                var this$16 = (this$13.c() ? $m_s_None$() : new $c_s_Some(("" + $cToS((65535 & (this$13.d() | 0))))));
                var $x_1 = (this$16.c() ? (("&" + ent) + ";") : this$16.d());
                break;
              }
              var this$17 = $m_Lorg_jpablo_graphexplorer_graphviz_html_Entities$().au1.r(ent);
              var this$18 = (this$17.c() ? $m_s_None$() : new $c_s_Some($m_jl_Character$().Q4((this$17.d() | 0))));
              var $x_1 = (this$18.c() ? (("&" + ent) + ";") : this$18.d());
            }
          }
          sb.ei($x_1);
          i = ((1 + semi) | 0);
        } else {
          sb.jl(c);
          i = ((1 + i) | 0);
        }
      } else {
        sb.jl(c);
        i = ((1 + i) | 0);
      }
    }
    return sb.bP.ah;
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$__stripControl__T__T($thiz, s) {
  _return: {
    var i = 0;
    var len = s.length;
    while ((i < len)) {
      if ((!(s.charCodeAt(i) >= 32))) {
        var $x_1 = false;
        break _return;
      }
      i = ((1 + i) | 0);
    }
    var $x_1 = true;
  }
  if ($x_1) {
    return s;
  } else {
    var len$1 = s.length;
    var sb = $ct_jl_StringBuilder__I__(new $c_jl_StringBuilder(), len$1);
    var i$1 = 0;
    while ((i$1 < len$1)) {
      var index$1 = i$1;
      var x = s.charCodeAt(index$1);
      if ((x >= 32)) {
        var str = ("" + $cToS(x));
        sb.ah = (sb.ah + str);
      }
      i$1 = ((1 + i$1) | 0);
    }
    return ((len$1 === sb.C()) ? s : sb.ah);
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$__tokenize__T__s_Option($thiz, src) {
  var out = new $c_scm_ListBuffer();
  var i = 0;
  var n = src.length;
  while ((i < n)) {
    if ((src.charCodeAt(i) === 60)) {
      var toffset = i;
      if (((!((toffset >>> 0) > (src.length >>> 0))) && (!(!src.startsWith("<!--", toffset))))) {
        var fromIndex = i;
        var end = (src.indexOf("-->", fromIndex) | 0);
        if ((end < 0)) {
          return $m_s_None$();
        } else {
          i = ((3 + end) | 0);
        }
      } else {
        var gt = $f_T__indexOf__I__I__I(src, 62, i);
        if ((gt < 0)) {
          return $m_s_None$();
        }
        var beginIndex = ((1 + i) | 0);
        var raw = $f_T__trim__T(src.substring(beginIndex, gt));
        if ((raw === "")) {
          return $m_s_None$();
        }
        if ((!(!raw.startsWith("/")))) {
          var this$6 = $f_T__trim__T($m_sc_StringOps$().kp(raw, 1));
          out.bb(new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Close(this$6.toLowerCase()));
        } else {
          var selfClose = (!(!raw.endsWith("/")));
          var body = $f_T__trim__T((selfClose ? $m_sc_StringOps$().WF(raw, 1) : raw));
          matchResult11: {
            var x14 = $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$__parseTag__T__s_Option($thiz, body);
            if ((x14 instanceof $c_s_Some)) {
              var x16 = x14.J;
              if ((x16 !== null)) {
                out.bb(new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Open(x16.g(), x16.h(), selfClose));
                break matchResult11;
              }
            }
            if (($m_s_None$() === x14)) {
              return $m_s_None$();
            }
            throw new $c_s_MatchError(x14);
          }
        }
        i = ((1 + gt) | 0);
      }
    } else {
      var lt = $f_T__indexOf__I__I__I(src, 60, i);
      var end$2 = ((lt < 0) ? n : lt);
      var beginIndex$1 = i;
      var txt = $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$__stripControl__T__T($thiz, $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$__decodeEntities__T__T($thiz, src.substring(beginIndex$1, end$2)));
      if ((txt !== "")) {
        out.bb(new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Chars(txt));
      }
      i = end$2;
    }
  }
  return new $c_s_Some(out.bM());
}
function $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$__parseTag__T__s_Option($thiz, body) {
  _return: {
    var len = body.length;
    var i = 0;
    while ((i < len)) {
      if ($m_jl_UnicodeData$().E7(body.charCodeAt(i))) {
        var sp = i;
        break _return;
      }
      i = ((1 + i) | 0);
    }
    var sp = (-1);
  }
  if ((sp < 0)) {
    return new $c_s_Some(new $c_T2(body.toLowerCase(), $m_sci_Map$EmptyMap$()));
  } else {
    var this$10 = body.substring(0, sp);
    var name = this$10.toLowerCase();
    var beginIndex = ((1 + sp) | 0);
    var rest = body.substring(beginIndex);
    var attrs = new $c_scm_LinkedHashMap();
    var i$1 = 0;
    var n = rest.length;
    while ((i$1 < n)) {
      while (((i$1 < n) && $m_jl_UnicodeData$().E7(rest.charCodeAt(i$1)))) {
        i$1 = ((1 + i$1) | 0);
      }
      var eq = $f_T__indexOf__I__I__I(rest, 61, i$1);
      if ((eq < 0)) {
        i$1 = n;
      } else {
        var beginIndex$1 = i$1;
        var this$18 = $f_T__trim__T(rest.substring(beginIndex$1, eq));
        var key = this$18.toLowerCase();
        var j = ((1 + eq) | 0);
        while (((j < n) && $m_jl_UnicodeData$().E7(rest.charCodeAt(j)))) {
          j = ((1 + j) | 0);
        }
        if (((j < n) && ((rest.charCodeAt(j) === 34) || (rest.charCodeAt(j) === 39)))) {
          var index$5 = j;
          var q = rest.charCodeAt(index$5);
          var end = $f_T__indexOf__I__I__I(rest, q, ((1 + j) | 0));
          if ((end < 0)) {
            i$1 = n;
          } else {
            var beginIndex$2 = ((1 + j) | 0);
            $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(attrs, key, $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$__decodeEntities__T__T($thiz, rest.substring(beginIndex$2, end)), false);
            i$1 = ((1 + end) | 0);
          }
        } else {
          var k = j;
          while (((k < n) && (!$m_jl_UnicodeData$().E7(rest.charCodeAt(k))))) {
            k = ((1 + k) | 0);
          }
          var beginIndex$3 = j;
          var endIndex = k;
          $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(attrs, key, $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$__decodeEntities__T__T($thiz, rest.substring(beginIndex$3, endIndex)), false);
          i$1 = k;
        }
      }
    }
    return new $c_s_Some(new $c_T2(name, $m_sci_Map$().ao(attrs)));
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$__applyFont__Lorg_jpablo_graphexplorer_graphviz_html_HtmlFont__T__sci_Map__Lorg_jpablo_graphexplorer_graphviz_html_HtmlFont($thiz, f, name, a) {
  switch (name) {
    case "b": {
      return new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlFont(f.kZ, f.n1, f.oM, true, f.nQ, f.oP, f.pN, f.oN, f.oO);
      break;
    }
    case "i": {
      return new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlFont(f.kZ, f.n1, f.oM, f.nP, true, f.oP, f.pN, f.oN, f.oO);
      break;
    }
    case "u": {
      return new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlFont(f.kZ, f.n1, f.oM, f.nP, f.nQ, true, f.pN, f.oN, f.oO);
      break;
    }
    case "s": {
      return new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlFont(f.kZ, f.n1, f.oM, f.nP, f.nQ, f.oP, true, f.oN, f.oO);
      break;
    }
    case "sub": {
      return new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlFont(f.kZ, f.n1, f.oM, f.nP, f.nQ, f.oP, f.pN, true, f.oO);
      break;
    }
    case "sup": {
      return new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlFont(f.kZ, f.n1, f.oM, f.nP, f.nQ, f.oP, f.pN, f.oN, true);
      break;
    }
    case "font": {
      var this$1 = a.r("point-size");
      if (this$1.c()) {
        var this$5 = $m_s_None$();
      } else {
        var x0 = this$1.d();
        var this$5 = ($m_sc_StringParsers$().c1(x0) ? new $c_s_Some($m_jl_Double$().bd(x0)) : $m_s_None$());
      }
      var size$6 = (this$5.c() ? f.kZ : this$5);
      var this$6 = a.r("face");
      var name$7 = (this$6.c() ? f.n1 : this$6);
      var this$7 = a.r("color");
      return new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlFont(size$6, name$7, (this$7.c() ? f.oM : this$7), f.nP, f.nQ, f.oP, f.pN, f.oN, f.oO);
      break;
    }
    default: {
      return f;
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$__parseText__sci_List__s_Option($thiz, toks) {
  var spans = new $c_scm_ListBuffer();
  var cur = new $c_scm_ListBuffer();
  var elems = $m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_html_HtmlFont.r().C)([new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlFont($m_s_None$(), $m_s_None$(), $m_s_None$(), false, false, false, false, false, false)]));
  var stack = $ct_scm_Stack__I__(new $c_scm_Stack(), 16).kl(elems);
  var ok = true;
  var it = toks.o();
  while ((it.p() && ok)) {
    var x49 = it.q();
    if ((x49 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Chars)) {
      cur.bb(new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlItem(x49.Kr, $f_sc_IndexedSeqOps__head__O(stack)));
      continue;
    }
    if ((x49 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Open)) {
      var x68 = x49.md;
      var x69 = x49.yL;
      var x70 = x49.F2;
      if ((x68 === "br")) {
        $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$__flush$1__scm_ListBuffer__scm_ListBuffer__s_Option__V($thiz, spans, cur, $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$__alignOf__sci_Map__s_Option($thiz, x69));
        continue;
      }
      if ($thiz.a7P.E(x68)) {
        if ((!x70)) {
          stack.gm($p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$__applyFont__Lorg_jpablo_graphexplorer_graphviz_html_HtmlFont__T__sci_Map__Lorg_jpablo_graphexplorer_graphviz_html_HtmlFont($thiz, $f_sc_IndexedSeqOps__head__O(stack), x68, x69));
          continue;
        } else {
          continue;
        }
      }
    }
    if ((x49 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Close)) {
      var x60 = x49.wz;
      if ($thiz.a7P.E(x60)) {
        var idx = stack.bF;
        if (((((stack.d5 - idx) | 0) & ((stack.aL.a.length - 1) | 0)) > 1)) {
          stack.h7(false);
          continue;
        } else {
          continue;
        }
      }
    }
    if ((x49 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Open)) {
      if ((x49.md === "img")) {
        continue;
      }
    }
    if ((x49 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Close)) {
      if ((x49.wz === "img")) {
        continue;
      }
    }
    ok = false;
  }
  if ((!ok)) {
    return $m_s_None$();
  } else {
    if (((!cur.c()) || spans.c())) {
      $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$__flush$1__scm_ListBuffer__scm_ListBuffer__s_Option__V($thiz, spans, cur, $m_s_None$());
    }
    return new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlText(spans.bM()));
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$__alignOf__sci_Map__s_Option($thiz, a) {
  var this$1 = a.r("align");
  if (this$1.c()) {
    var this$2 = $m_s_None$();
  } else {
    var x0 = this$1.d();
    var this$2 = new $c_s_Some(x0.toLowerCase());
  }
  var pf = new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$$anon$3();
  return ((!this$2.c()) ? new $c_s_PartialFunction$Lifted(pf).as(this$2.d()) : $m_s_None$());
}
function $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$__parseTable__sci_List__s_Option($thiz, toks) {
  if ((toks.V() >= 0)) {
    var destination = new ($d_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok.r().C)(toks.V());
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(toks, destination, 0, 2147483647);
    var arr = destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = toks.o();
    while (it.p()) {
      var elem = it.q();
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem);
    }
    var arr = new ($d_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok.r().C)(jsElems);
  }
  var i = 0;
  while (((i < arr.a.length) && (!(arr.a[i] instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Open)))) {
    i = ((1 + i) | 0);
  }
  var x110 = new $c_s_PartialFunction$Lifted($m_s_Predef$().fB(arr)).as(i);
  if ((x110 instanceof $c_s_Some)) {
    var x112 = x110.J;
    if ((x112 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Open)) {
      var x115 = x112.md;
      var x116 = x112.yL;
      if ((x115 === "table")) {
        i = ((1 + i) | 0);
        var rows = new $c_scm_ListBuffer();
        var hrs = $m_scm_Set$().aO();
        var vrs = $m_scm_Set$().aO();
        var ok = true;
        while (((i < arr.a.length) && ok)) {
          var x96 = arr.a[i];
          if ((x96 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Open)) {
            var x107 = x96.md;
            if ((x107 === "tr")) {
              i = ((1 + i) | 0);
              var cells = new $c_scm_ListBuffer();
              while ((((i < arr.a.length) && (!$p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$__isClose__Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok__T__Z($thiz, arr.a[i], "tr"))) && ok)) {
                var x82 = arr.a[i];
                if ((x82 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Open)) {
                  var x93 = x82.md;
                  var x94 = x82.yL;
                  if ((x93 === "td")) {
                    matchResult21: {
                      var \u03b42$___1;
                      var \u03b42$___2;
                      var x76 = $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$__parseCell__ALorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok__I__sci_Map__T2($thiz, arr, ((1 + i) | 0), x94);
                      if ((x76 !== null)) {
                        var \u03b42$___1 = x76.g();
                        var \u03b42$___2 = (x76.h() | 0);
                        break matchResult21;
                      }
                      throw new $c_s_MatchError(x76);
                    }
                    var cell$2 = \u03b42$___1;
                    var next$2 = (\u03b42$___2 | 0);
                    if ((cell$2 instanceof $c_s_Some)) {
                      cells.bb(cell$2.J);
                      i = next$2;
                      continue;
                    }
                    if (($m_s_None$() === cell$2)) {
                      ok = false;
                      continue;
                    }
                    throw new $c_s_MatchError(cell$2);
                  }
                  if ((x93 === "vr")) {
                    vrs.Y(cells.eb);
                    i = ((1 + i) | 0);
                    continue;
                  }
                }
                if ((x82 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Close)) {
                  if ((x82.wz === "tr")) {
                    continue;
                  }
                }
                i = ((1 + i) | 0);
              }
              if (((i < arr.a.length) && $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$__isClose__Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok__T__Z($thiz, arr.a[i], "tr"))) {
                i = ((1 + i) | 0);
              }
              rows.bb(cells.bM());
              continue;
            }
            if ((x107 === "hr")) {
              hrs.Y(rows.eb);
              i = ((1 + i) | 0);
              continue;
            }
          }
          if ((x96 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Close)) {
            if ((x96.wz === "table")) {
              i = arr.a.length;
              continue;
            }
          }
          i = ((1 + i) | 0);
        }
        return ((!ok) ? $m_s_None$() : new $c_s_Some($p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$__mkTable__sci_List__sci_Map__sci_Set__sci_Set__Lorg_jpablo_graphexplorer_graphviz_html_HtmlTable($thiz, rows.bM(), x116, $m_sci_Set$().af(hrs), $m_sci_Set$().af(vrs))));
      }
    }
  }
  return $m_s_None$();
}
function $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$__isClose__Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok__T__Z($thiz, t, name) {
  return ((t instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Close) && (t.wz === name));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$__parseCell__ALorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok__I__sci_Map__T2($thiz, arr, start, attrs) {
  var depth = 1;
  var i = start;
  var body = new $c_scm_ListBuffer();
  while (((i < arr.a.length) && (depth > 0))) {
    var x122 = arr.a[i];
    if ((x122 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Open)) {
      var x128 = x122.md;
      var x130 = x122.F2;
      if (((x128 === "td") && (!x130))) {
        depth = ((1 + depth) | 0);
        body.bb(arr.a[i]);
        i = ((1 + i) | 0);
        continue;
      }
    }
    if ((x122 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Close)) {
      if ((x122.wz === "td")) {
        depth = ((depth - 1) | 0);
        if ((depth > 0)) {
          body.bb(arr.a[i]);
        }
        i = ((1 + i) | 0);
        continue;
      }
    }
    body.bb(x122);
    i = ((1 + i) | 0);
  }
  var res = false;
  var it = body.o();
  while (((!res) && it.p())) {
    var x0 = it.q();
    matchResult28: {
      if ((x0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Open)) {
        if ((x0.md === "table")) {
          res = true;
          break matchResult28;
        }
      }
      res = false;
    }
  }
  var hasTable = res;
  var res$1 = false;
  var it$1 = body.o();
  while (((!res$1) && it$1.p())) {
    var x0$1 = it$1.q();
    res$1 = ((x0$1 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Chars) && ($f_T__trim__T(x0$1.Kr) !== ""));
  }
  var hasText = res$1;
  var imgTok = $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(body, new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$$anon$4());
  if (hasTable) {
    var this$8 = $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$__parseTable__sci_List__s_Option($thiz, body.bM());
    var content = (this$8.c() ? $m_s_None$() : new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Table(this$8.d())));
  } else if (((!imgTok.c()) && (!hasText))) {
    var content = $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(body.bM(), new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$$anon$2());
  } else {
    var this$10 = $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$__parseText__sci_List__s_Option($thiz, body.bM());
    var content = (this$10.c() ? $m_s_None$() : new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Text(this$10.d())));
  }
  return new $c_T2((content.c() ? $m_s_None$() : new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlCell(content.d(), attrs))), i);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$__mkTable__sci_List__sci_Map__sci_Set__sci_Set__Lorg_jpablo_graphexplorer_graphviz_html_HtmlTable($thiz, rows, a, hrAfter, vrAfter) {
  var border = $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$__int$1__sci_Map__T__I__I($thiz, a, "border", 1);
  var this$1 = a.r("cellborder");
  var $x_3 = (this$1.c() ? $m_s_None$() : $m_sc_StringParsers$().hT(this$1.d()));
  var $x_2 = $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$__int$1__sci_Map__T__I__I($thiz, a, "cellspacing", 2);
  var $x_1 = $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$__int$1__sci_Map__T__I__I($thiz, a, "cellpadding", 2);
  var this$4 = $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$__alignOf__sci_Map__s_Option($thiz, a);
  return new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTable(rows, border, $x_3, $x_2, $x_1, (this$4.c() ? $s_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$__Center__Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign() : this$4.d()), a, hrAfter, vrAfter);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$__flush$1__scm_ListBuffer__scm_ListBuffer__s_Option__V($thiz, spans$1, cur$1, align) {
  spans$1.bb(new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlSpan(cur$1.bM(), align));
  cur$1.ie();
}
function $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$__int$1__sci_Map__T__I__I($thiz, a$1, k, d) {
  var this$1 = a$1.r(k);
  var this$4 = (this$1.c() ? $m_s_None$() : $m_sc_StringParsers$().hT(this$1.d()));
  return ((this$4.c() ? d : this$4.d()) | 0);
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$() {
  this.a7P = null;
  $n_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$ = this;
  this.a7P = $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_T.r().C)(["b", "i", "u", "s", "sub", "sup", "o", "font"])));
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$.prototype = $p;
$p.mU = (function(markup) {
  var this$1 = $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$__tokenize__T__s_Option(this, markup);
  if (this$1.c()) {
    return $m_s_None$();
  } else {
    var x0 = this$1.d();
    var firstOpen = $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(x0, new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$$anon$1());
    if ((firstOpen instanceof $c_s_Some)) {
      var x35 = firstOpen.J;
      if ((x35 === "table")) {
        var this$2 = $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$__parseTable__sci_List__s_Option(this, x0);
        return (this$2.c() ? $m_s_None$() : new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Table(this$2.d())));
      }
      if ((x35 === "img")) {
        return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(x0, new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$$anon$2());
      }
    }
    var this$4 = $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$__parseText__sci_List__s_Option(this, x0);
    return (this$4.c() ? $m_s_None$() : new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Text(this$4.d())));
  }
});
var $d_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$, "org.jpablo.graphexplorer.graphviz.html.HtmlParser$", ({
  uu: 1
}));
var $n_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$;
function $m_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$() {
  if ((!$n_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$)) {
    $n_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$ = new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$();
  }
  return $n_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$__rec$1__D__T__sci_Map__I__I__I__I__T__Lorg_jpablo_graphexplorer_graphviz_html_HtmlTable__D__D__I__s_Option__s_Option($thiz, baseSize$1, baseName$1, imgs$1, sLeft$1, sTop$1, sRight$1, sBottom$1, port$1, t, ox, oy, sides, fit) {
  var laid = $thiz.a46(t, baseSize$1, baseName$1, imgs$1, fit);
  return $f_sc_Iterator__nextOption__s_Option(new $c_sc_Iterator$$anon$10(laid.Be.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((pc) => {
    var mask = 0;
    if ((sides !== 0)) {
      if ((pc.F8 === 0)) {
        mask = (mask | sLeft$1);
      }
      if ((pc.F9 === 0)) {
        mask = (mask | sTop$1);
      }
      if ((((pc.F8 + pc.Kw) | 0) === laid.Kt)) {
        mask = (mask | sRight$1);
      }
      if ((((pc.F9 + pc.Kx) | 0) === laid.Ku)) {
        mask = (mask | sBottom$1);
      }
    }
    var cellSides = (sides & mask);
    if (pc.oV.gE.r("port").E(port$1)) {
      return new $c_s_Some(new $c_T2(new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$BoxLocal((pc.nS.lA + ox), (pc.nS.me + oy), (pc.nS.lB + ox), (pc.nS.mf + oy)), cellSides));
    } else {
      var x13 = pc.oV.oL;
      if ((x13 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Table)) {
        var x16 = x13.k8;
        var cw = (pc.hW.lB - pc.hW.lA);
        var ch = (pc.hW.mf - pc.hW.me);
        return $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$__rec$1__D__T__sci_Map__I__I__I__I__T__Lorg_jpablo_graphexplorer_graphviz_html_HtmlTable__D__D__I__s_Option__s_Option($thiz, baseSize$1, baseName$1, imgs$1, sLeft$1, sTop$1, sRight$1, sBottom$1, port$1, x16, (ox + pc.hW.aNj()), (oy + pc.hW.aff()), cellSides, new $c_s_Some(new $c_T2(cw, ch)));
      }
      return $m_s_None$();
    }
  }))));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$__borderOf$1__Lorg_jpablo_graphexplorer_graphviz_html_HtmlTable__I__Lorg_jpablo_graphexplorer_graphviz_html_HtmlCell__I($thiz, tbl$1, tblBorder$1, cell) {
  var this$1 = cell.gE.r("border");
  var this$4 = (this$1.c() ? $m_s_None$() : $m_sc_StringParsers$().hT(this$1.d()));
  var this$5 = ((this$4.c() || (((this$4.d() | 0) >>> 0) <= 255)) ? this$4 : $m_s_None$());
  if (this$5.c()) {
    var this$6 = tbl$1.F4;
    var $x_1 = ((this$6.c() ? tblBorder$1 : this$6.d()) | 0);
  } else {
    var $x_1 = this$5.d();
  }
  return ($x_1 | 0);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$__padOf$1__I__Lorg_jpablo_graphexplorer_graphviz_html_HtmlCell__I($thiz, pad$1, cell) {
  var this$1 = cell.gE.r("cellpadding");
  var this$4 = (this$1.c() ? $m_s_None$() : $m_sc_StringParsers$().hT(this$1.d()));
  var this$5 = ((this$4.c() || (((this$4.d() | 0) >>> 0) <= 255)) ? this$4 : $m_s_None$());
  return ((this$5.c() ? pad$1 : this$5.d()) | 0);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$__Info$lzyINIT1$1__sr_LazyRef__Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$Info$3$($thiz, Info$lzy1$1) {
  return (Info$lzy1$1.ci ? Info$lzy1$1.cj : Info$lzy1$1.h3(new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$Info$3$()));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$__Info$2__sr_LazyRef__Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$Info$3$($thiz, Info$lzy1$2) {
  return (Info$lzy1$2.ci ? Info$lzy1$2.cj : $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$__Info$lzyINIT1$1__sr_LazyRef__Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$Info$3$($thiz, Info$lzy1$2));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$__spanOf$1__Lorg_jpablo_graphexplorer_graphviz_html_HtmlCell__T__I($thiz, cell, key) {
  var this$1 = cell.gE.r(key);
  var this$4 = (this$1.c() ? $m_s_None$() : $m_sc_StringParsers$().hT(this$1.d()));
  var this$5 = ((this$4.c() || ((this$4.d() | 0) >= 1)) ? this$4 : $m_s_None$());
  return ((this$5.c() ? 1 : this$5.d()) | 0);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$__findCol$1__scm_HashSet__I__I__I__I($thiz, occupied$1, row, colHint, colspan) {
  var col = colHint;
  var searching = true;
  while (searching) {
    var lastc = ((((col + colspan) | 0) - 1) | 0);
    var c = lastc;
    while (((c >= col) && (!occupied$1.E(new $c_T2(c, row))))) {
      c = ((c - 1) | 0);
    }
    if ((c >= col)) {
      col = ((1 + c) | 0);
    } else {
      searching = false;
    }
  }
  return col;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$__cRound$1__D__I($thiz, v) {
  return ((v >= 0.0) ? $doubleToInt((v + 0.5)) : $doubleToInt((v - 0.5)));
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$() {
  this.aTQ = 0;
  this.aTP = 0;
  this.aTQ = 2;
  this.aTP = 2;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$.prototype = $p;
$p.b8U = (function(tbl, baseSize, baseName, imgs) {
  var laid = this.a46(tbl, baseSize, baseName, imgs, $m_s_None$());
  return new $c_T2(laid.wB, laid.wA);
});
$p.aYf = (function(tbl, port, baseSize, baseName, imgs) {
  var this$1 = this.aMF(tbl, port, baseSize, baseName, imgs);
  return (this$1.c() ? $m_s_None$() : new $c_s_Some(this$1.d().g()));
});
$p.aMF = (function(tbl, port, baseSize, baseName, imgs) {
  return $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$__rec$1__D__T__sci_Map__I__I__I__I__T__Lorg_jpablo_graphexplorer_graphviz_html_HtmlTable__D__D__I__s_Option__s_Option(this, baseSize, baseName, imgs, 8, 4, 2, 1, port, tbl, 0.0, 0.0, 15, $m_s_None$());
});
$p.a46 = (function(tbl, baseSize, baseName, imgs, fit) {
  var Info$lzy1 = new $c_sr_LazyRef();
  var space = ((tbl.Bb >= 0) ? tbl.Bb : 2);
  var tblBorder = tbl.F3;
  var pad = ((tbl.F5 >= 0) ? tbl.F5 : 2);
  var occupied = $ct_scm_HashSet__(new $c_scm_HashSet());
  $m_scm_ArrayBuffer$();
  var infos = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  var ncols = new $c_sr_IntRef(0);
  var nrows = new $c_sr_IntRef(0);
  var this$6 = $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(tbl.fg);
  var Info$lzy1$2 = Info$lzy1;
  var these = this$6;
  while ((!these.c())) {
    var x0 = these.t();
    var row = x0.g();
    var r = (x0.h() | 0);
    var elem = 0;
    elem = 0;
    var these$1 = row;
    while ((!these$1.c())) {
      var x0$1 = these$1.t();
      var cs = $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$__spanOf$1__Lorg_jpablo_graphexplorer_graphviz_html_HtmlCell__T__I(this, x0$1, "colspan");
      var rs = $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$__spanOf$1__Lorg_jpablo_graphexplorer_graphviz_html_HtmlCell__T__I(this, x0$1, "rowspan");
      elem = $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$__findCol$1__scm_HashSet__I__I__I__I(this, occupied, r, elem, cs);
      var x = elem;
      var end = ((elem + cs) | 0);
      var isEmpty = (x >= end);
      var scala$collection$immutable$Range$$lastElement = ((end - 1) | 0);
      if ((!isEmpty)) {
        var i = x;
        while (true) {
          var x0$2 = i;
          var end$1 = ((r + rs) | 0);
          var isEmpty$1 = (r >= end$1);
          var scala$collection$immutable$Range$$lastElement$1 = ((end$1 - 1) | 0);
          if ((!isEmpty$1)) {
            var i$1 = r;
            while (true) {
              occupied.oA(new $c_T2(x0$2, i$1));
              if ((i$1 === scala$collection$immutable$Range$$lastElement$1)) {
                break;
              }
              i$1 = ((1 + i$1) | 0);
            }
          }
          if ((i === scala$collection$immutable$Range$$lastElement)) {
            break;
          }
          i = ((1 + i) | 0);
        }
      }
      var this$17 = x0$1.gE.r("fixedsize");
      if ((!this$17.c())) {
        var x0$4 = this$17.d();
        var fixed = ((x0$4.toLowerCase() === "true") || (x0$4.toLowerCase() === "fixed"));
      } else {
        var fixed = false;
      }
      var this$18 = x0$1.gE.r("width");
      if (this$18.c()) {
        var fw = $m_s_None$();
      } else {
        var x0$5 = this$18.d();
        var fw = ($m_sc_StringParsers$().c1(x0$5) ? new $c_s_Some($m_jl_Double$().bd(x0$5)) : $m_s_None$());
      }
      var this$22 = x0$1.gE.r("height");
      if (this$22.c()) {
        var fh = $m_s_None$();
      } else {
        var x0$6 = this$22.d();
        var fh = ($m_sc_StringParsers$().c1(x0$6) ? new $c_s_Some($m_jl_Double$().bd(x0$6)) : $m_s_None$());
      }
      var margin = (2.0 * (($p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$__padOf$1__I__Lorg_jpablo_graphexplorer_graphviz_html_HtmlCell__I(this, pad, x0$1) + $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$__borderOf$1__Lorg_jpablo_graphexplorer_graphviz_html_HtmlTable__I__Lorg_jpablo_graphexplorer_graphviz_html_HtmlCell__I(this, tbl, tblBorder, x0$1)) | 0));
      if (((fixed && (!fw.c())) && (!fh.c()))) {
        var \u03b41$___1 = fw.d();
        var \u03b41$___2 = fh.d();
      } else {
        matchResult14: {
          var \u03b42$___1;
          var \u03b42$___2;
          var x21 = $m_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$().PU(x0$1.oL, baseSize, baseName, imgs);
          if ((x21 !== null)) {
            var \u03b42$___1 = (+x21.g());
            var \u03b42$___2 = (+x21.h());
            break matchResult14;
          }
          throw new $c_s_MatchError(x21);
        }
        var \u03b41$___1 = ((+\u03b42$___1) + margin);
        var \u03b41$___2 = ((+\u03b42$___2) + margin);
      }
      var cellW = (+\u03b41$___1);
      var cellH = (+\u03b41$___2);
      infos.aw(($p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$__Info$2__sr_LazyRef__Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$Info$3$(this, Info$lzy1$2), new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$Info$1(r, elem, cs, rs, cellW, cellH, x0$1)));
      elem = ((elem + cs) | 0);
      var x$1 = elem;
      var y = ncols.an;
      ncols.an = ((x$1 > y) ? x$1 : y);
      var x$2 = ((r + rs) | 0);
      var y$1 = nrows.an;
      nrows.an = ((x$2 > y$1) ? x$2 : y$1);
      these$1 = these$1.v();
    }
    these = these.v();
  }
  var n = ncols.an;
  if ((n <= 0)) {
    var colW = new $ac_D(0);
  } else {
    var array = new $ac_D(n);
    var i$2 = 0;
    while ((i$2 < n)) {
      array.a[i$2] = 0.0;
      i$2 = ((1 + i$2) | 0);
    }
    var colW = array;
  }
  $m_scm_ArrayBuffer$();
  var b = new $c_scm_ArrayBuffer$$anon$1();
  var it = infos.bB().o();
  while (it.p()) {
    var elem$3 = it.q();
    if ((elem$3.pP === 1)) {
      b.mI(elem$3);
    }
  }
  b.gj.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((i$3) => {
    var $x_1 = i$3.oT;
    var x$3 = colW.a[i$3.oT];
    var y$2 = i$3.Bd;
    colW.a[$x_1] = (+Math.max(x$3, y$2));
  })));
  $m_scm_ArrayBuffer$();
  var b$1 = new $c_scm_ArrayBuffer$$anon$1();
  var it$1 = infos.bB().o();
  while (it$1.p()) {
    var elem$4 = it$1.q();
    if ((elem$4.pP > 1)) {
      b$1.mI(elem$4);
    }
  }
  b$1.gj.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((i$2$1) => {
    var x$4 = i$2$1.oT;
    var end$2 = ((i$2$1.oT + i$2$1.pP) | 0);
    var isEmpty$2 = (x$4 >= end$2);
    var gap$2 = ((end$2 - x$4) | 0);
    var scala$collection$immutable$Range$$lastElement$2 = ((end$2 - 1) | 0);
    var f = $m_s_Predef$().ys(colW);
    if (((gap$2 <= 0) && (!isEmpty$2))) {
      $m_sci_Range$().ug(x$4, end$2, 1, false);
    }
    var b$2 = $m_sci_IndexedSeq$().b5();
    var it$2 = new $c_sci_RangeIterator(x$4, 1, scala$collection$immutable$Range$$lastElement$2, isEmpty$2);
    while (it$2.g0) {
      b$2.Y(f.ID(it$2.hp()));
    }
    var spanW = (+b$2.aR().k2($m_s_math_Numeric$DoubleIsFractional$()));
    var spacing = Math.imul(((i$2$1.pP - 1) | 0), space);
    if (((spanW + spacing) < i$2$1.Bd)) {
      var widen = (((i$2$1.Bd - spacing) - spanW) / i$2$1.pP);
      var x$5 = i$2$1.oT;
      var end$3 = ((i$2$1.oT + i$2$1.pP) | 0);
      var isEmpty$3 = (x$5 >= end$3);
      var scala$collection$immutable$Range$$lastElement$3 = ((end$3 - 1) | 0);
      if ((!isEmpty$3)) {
        var i$4 = x$5;
        while (true) {
          var x0$7 = i$4;
          colW.a[x0$7] = (colW.a[x0$7] + widen);
          if ((i$4 === scala$collection$immutable$Range$$lastElement$3)) {
            break;
          }
          i$4 = ((1 + i$4) | 0);
        }
      }
    }
  })));
  var n$1 = nrows.an;
  if ((n$1 <= 0)) {
    var rowH = new $ac_D(0);
  } else {
    var array$1 = new $ac_D(n$1);
    var i$5 = 0;
    while ((i$5 < n$1)) {
      array$1.a[i$5] = 0.0;
      i$5 = ((1 + i$5) | 0);
    }
    var rowH = array$1;
  }
  $m_scm_ArrayBuffer$();
  var b$3 = new $c_scm_ArrayBuffer$$anon$1();
  var it$3 = infos.bB().o();
  while (it$3.p()) {
    var elem$6 = it$3.q();
    if ((elem$6.pQ === 1)) {
      b$3.mI(elem$6);
    }
  }
  b$3.gj.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((i$3$1) => {
    var $x_2 = i$3$1.oU;
    var x$6 = rowH.a[i$3$1.oU];
    var y$3 = i$3$1.Bc;
    rowH.a[$x_2] = (+Math.max(x$6, y$3));
  })));
  $m_scm_ArrayBuffer$();
  var b$4 = new $c_scm_ArrayBuffer$$anon$1();
  var it$4 = infos.bB().o();
  while (it$4.p()) {
    var elem$7 = it$4.q();
    if ((elem$7.pQ > 1)) {
      b$4.mI(elem$7);
    }
  }
  b$4.gj.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((i$4$1) => {
    var x$7 = i$4$1.oU;
    var end$4 = ((i$4$1.oU + i$4$1.pQ) | 0);
    var isEmpty$4 = (x$7 >= end$4);
    var gap$4 = ((end$4 - x$7) | 0);
    var scala$collection$immutable$Range$$lastElement$4 = ((end$4 - 1) | 0);
    var f$1 = $m_s_Predef$().ys(rowH);
    if (((gap$4 <= 0) && (!isEmpty$4))) {
      $m_sci_Range$().ug(x$7, end$4, 1, false);
    }
    var b$5 = $m_sci_IndexedSeq$().b5();
    var it$5 = new $c_sci_RangeIterator(x$7, 1, scala$collection$immutable$Range$$lastElement$4, isEmpty$4);
    while (it$5.g0) {
      b$5.Y(f$1.ID(it$5.hp()));
    }
    var spanH = (+b$5.aR().k2($m_s_math_Numeric$DoubleIsFractional$()));
    var spacing$1 = Math.imul(((i$4$1.pQ - 1) | 0), space);
    if (((spanH + spacing$1) < i$4$1.Bc)) {
      var widen$1 = (((i$4$1.Bc - spacing$1) - spanH) / i$4$1.pQ);
      var x$8 = i$4$1.oU;
      var end$5 = ((i$4$1.oU + i$4$1.pQ) | 0);
      var isEmpty$5 = (x$8 >= end$5);
      var scala$collection$immutable$Range$$lastElement$5 = ((end$5 - 1) | 0);
      if ((!isEmpty$5)) {
        var i$6 = x$8;
        while (true) {
          var x0$8 = i$6;
          rowH.a[x0$8] = (rowH.a[x0$8] + widen$1);
          if ((i$6 === scala$collection$immutable$Range$$lastElement$5)) {
            break;
          }
          i$6 = ((1 + i$6) | 0);
        }
      }
    }
  })));
  var elem$9 = (((Math.imul(((1 + ncols.an) | 0), space) + (tblBorder << 1)) | 0) + (+$f_sc_IterableOnceOps__sum__s_math_Numeric__O($m_s_Predef$().ys(colW), $m_s_math_Numeric$DoubleIsFractional$())));
  var elem$10 = 0.0;
  elem$10 = elem$9;
  var elem$11 = (((Math.imul(((1 + nrows.an) | 0), space) + (tblBorder << 1)) | 0) + (+$f_sc_IterableOnceOps__sum__s_math_Numeric__O($m_s_Predef$().ys(rowH), $m_s_math_Numeric$DoubleIsFractional$())));
  var elem$12 = 0.0;
  elem$12 = elem$11;
  if ((!fit.c())) {
    var x0$9 = fit.d();
    var fw$1 = (+x0$9.g());
    var fh$1 = (+x0$9.h());
    var x$9 = (fw$1 - elem$10);
    var delx = (+Math.max(x$9, 0.0));
    if (((ncols.an > 0) && (delx > 0.0))) {
      var extra = (delx / ncols.an);
      var plus = $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$__cRound$1__D__I(this, (delx - (extra * ncols.an)));
      var end$6 = ncols.an;
      var isEmpty$6 = (end$6 <= 0);
      var scala$collection$immutable$Range$$lastElement$6 = ((end$6 - 1) | 0);
      if ((!isEmpty$6)) {
        var i$7 = 0;
        while (true) {
          var x0$10 = i$7;
          colW.a[x0$10] = (colW.a[x0$10] + (extra + ((x0$10 < plus) | 0)));
          if ((i$7 === scala$collection$immutable$Range$$lastElement$6)) {
            break;
          }
          i$7 = ((1 + i$7) | 0);
        }
      }
      elem$10 = (elem$10 + delx);
    }
    var x$10 = (fh$1 - elem$12);
    var dely = (+Math.max(x$10, 0.0));
    if (((nrows.an > 0) && (dely > 0.0))) {
      var extra$3 = (dely / nrows.an);
      var plus$3 = $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$__cRound$1__D__I(this, (dely - (extra$3 * nrows.an)));
      var end$7 = nrows.an;
      var isEmpty$7 = (end$7 <= 0);
      var scala$collection$immutable$Range$$lastElement$7 = ((end$7 - 1) | 0);
      if ((!isEmpty$7)) {
        var i$8 = 0;
        while (true) {
          var x0$11 = i$8;
          rowH.a[x0$11] = (rowH.a[x0$11] + (extra$3 + ((x0$11 < plus$3) | 0)));
          if ((i$8 === scala$collection$immutable$Range$$lastElement$7)) {
            break;
          }
          i$8 = ((1 + i$8) | 0);
        }
      }
      elem$12 = (elem$12 + dely);
    }
  }
  var posLLx = (0.5 * (-elem$10));
  var posURy = (0.5 * elem$12);
  var colStart = new $ac_D(((1 + ncols.an) | 0));
  var elem$13 = ((posLLx + tblBorder) + space);
  var elem$14 = 0.0;
  elem$14 = elem$13;
  var end$8 = ncols.an;
  if ((!(end$8 < 0))) {
    var i$9 = 0;
    while (true) {
      var x0$12 = i$9;
      colStart.a[x0$12] = elem$14;
      if ((x0$12 < ncols.an)) {
        elem$14 = (elem$14 + (colW.a[x0$12] + space));
      }
      if ((i$9 === end$8)) {
        break;
      }
      i$9 = ((1 + i$9) | 0);
    }
  }
  var rowStart = new $ac_D(((1 + nrows.an) | 0));
  var elem$15 = ((posURy - tblBorder) - space);
  var elem$16 = 0.0;
  elem$16 = elem$15;
  var end$9 = nrows.an;
  if ((!(end$9 < 0))) {
    var i$10 = 0;
    while (true) {
      var x0$13 = i$10;
      rowStart.a[x0$13] = elem$16;
      if ((x0$13 < nrows.an)) {
        elem$16 = (elem$16 - (rowH.a[x0$13] + space));
      }
      if ((i$10 === end$9)) {
        break;
      }
      i$10 = ((1 + i$10) | 0);
    }
  }
  var $x_4 = elem$10;
  var $x_3 = elem$12;
  $m_scm_ArrayBuffer$();
  var b$6 = new $c_scm_ArrayBuffer$$anon$1();
  var it$6 = infos.bB().o();
  while (it$6.p()) {
    var x0$14 = it$6.q();
    var llx$1 = colStart.a[x0$14.oT];
    var urx$1 = (colStart.a[((x0$14.oT + x0$14.pP) | 0)] - space);
    var box = new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$BoxLocal(llx$1, (rowStart.a[((x0$14.oU + x0$14.pQ) | 0)] + space), urx$1, rowStart.a[x0$14.oU]);
    var inset = (($p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$__borderOf$1__Lorg_jpablo_graphexplorer_graphviz_html_HtmlTable__I__Lorg_jpablo_graphexplorer_graphviz_html_HtmlCell__I(this, tbl, tblBorder, x0$14.yN) + $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$__padOf$1__I__Lorg_jpablo_graphexplorer_graphviz_html_HtmlCell__I(this, pad, x0$14.yN)) | 0);
    b$6.mI(new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$PlacedCell(box, new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$BoxLocal((box.lA + inset), (box.me + inset), (box.lB - inset), (box.mf - inset)), $p_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$__borderOf$1__Lorg_jpablo_graphexplorer_graphviz_html_HtmlTable__I__Lorg_jpablo_graphexplorer_graphviz_html_HtmlCell__I(this, tbl, tblBorder, x0$14.yN), x0$14.yN, x0$14.oU, x0$14.oT, x0$14.pQ, x0$14.pP));
  }
  return new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$Laid($x_4, $x_3, tblBorder, b$6.gj.d2(), $f_sc_SeqOps__sorted__s_math_Ordering__O(tbl.oR.bw(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((b$7) => {
    var b$8 = (b$7 | 0);
    return ((b$8 >= 1) && (b$8 <= nrows.an));
  }))).d2(), $m_s_math_Ordering$Int$()).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((b$2$1) => (rowStart.a[(b$2$1 | 0)] + (0.5 * space))))), $f_sc_SeqOps__sorted__s_math_Ordering__O(tbl.oS.bw(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((b$3$1) => {
    var b$10 = (b$3$1 | 0);
    return ((b$10 >= 1) && (b$10 <= ncols.an));
  }))).d2(), $m_s_math_Ordering$Int$()).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((b$4$1) => (colStart.a[(b$4$1 | 0)] - (0.5 * space))))), nrows.an, ncols.an);
});
var $d_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$, "org.jpablo.graphexplorer.graphviz.html.HtmlTableLayout$", ({
  uz: 1
}));
var $n_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$;
function $m_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$() {
  if ((!$n_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$)) {
    $n_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$ = new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$();
  }
  return $n_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__lenfact__I__D($thiz, tpe) {
  return (($thiz.RB === tpe) ? 0.5 : (($thiz.Rz === tpe) ? 1.2 : (($thiz.RA === tpe) ? 0.8 : (($thiz.Fa === tpe) ? 0.5 : 1.0))));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__matchNameFrag__T__sci_List__I__T2($thiz, name, table, flag) {
  _return: {
    var these = table;
    while ((!these.c())) {
      var x0 = these.t();
      var n = x0.g();
      (x0.h() | 0);
      if ((!(!name.startsWith(n)))) {
        var x2 = new $c_s_Some(these.t());
        break _return;
      }
      these = these.v();
    }
    var x2 = $m_s_None$();
  }
  if ((x2 instanceof $c_s_Some)) {
    var x4 = x2.J;
    if ((x4 !== null)) {
      var n$1 = x4.g();
      var t = (x4.h() | 0);
      var beginIndex = n$1.length;
      return new $c_T2(name.substring(beginIndex), (flag | t));
    }
  }
  if (($m_s_None$() === x2)) {
    return new $c_T2(name, flag);
  }
  throw new $c_s_MatchError(x2);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__matchShape__T__T2($thiz, name) {
  matchResult3: {
    var \u03b41$___1;
    var \u03b41$___2;
    var x7 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__matchNameFrag__T__sci_List__I__T2($thiz, name, $thiz.au4, $thiz.lC);
    if ((x7 !== null)) {
      var \u03b41$___1 = x7.g();
      var \u03b41$___2 = (x7.h() | 0);
      break matchResult3;
    }
    throw new $c_s_MatchError(x7);
  }
  var rest$2 = \u03b41$___1;
  var f$2 = (\u03b41$___2 | 0);
  if ((rest$2 === name)) {
    var progressed = true;
    while (progressed) {
      matchResult4: {
        var \u03b43$___1;
        var \u03b43$___2;
        var x10 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__matchNameFrag__T__sci_List__I__T2($thiz, rest$2, $thiz.au2, f$2);
        if ((x10 !== null)) {
          var \u03b43$___1 = x10.g();
          var \u03b43$___2 = (x10.h() | 0);
          break matchResult4;
        }
        throw new $c_s_MatchError(x10);
      }
      var r$2 = \u03b43$___1;
      var nf$2 = (\u03b43$___2 | 0);
      progressed = (r$2 !== rest$2);
      rest$2 = r$2;
      f$2 = nf$2;
    }
    matchResult5: {
      var \u03b42$___1;
      var \u03b42$___2;
      var x13 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__matchNameFrag__T__sci_List__I__T2($thiz, rest$2, $thiz.au3, f$2);
      if ((x13 !== null)) {
        var \u03b42$___1 = x13.g();
        var \u03b42$___2 = (x13.h() | 0);
        break matchResult5;
      }
      throw new $c_s_MatchError(x13);
    }
    var r$4 = \u03b42$___1;
    var nf$4 = (\u03b42$___2 | 0);
    rest$2 = r$4;
    f$2 = nf$4;
  }
  if (((f$2 !== 0) && ((f$2 & $thiz.ZI) === 0))) {
    f$2 = (f$2 | $thiz.nV);
  }
  return new $c_T2(rest$2, f$2);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__deltaTipFromJoin__T2__T2__D__D__D__T2($thiz, join, bigP, cosPhi, sinPhi, phi) {
  var dx = ((+join.g()) - (+bigP.g()));
  var dy = ((+join.h()) - (+bigP.h()));
  var h = $m_jl_Math$().ga(dx, dy);
  if ((dy > 0.0)) {
    var x = (dx / h);
    var alpha = (+Math.acos(x));
  } else {
    var x$1 = (dx / h);
    var alpha = (-(+Math.acos(x$1)));
  }
  var x$2 = (alpha - phi);
  var len = (h * (+Math.cos(x$2)));
  return new $c_T2((len * cosPhi), (len * sinPhi));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__typeNormal__T2__T2__D__I__T2($thiz, p, u, penwidth, flag) {
  matchResult21: {
    var \u03b46$___1;
    var \u03b46$___2;
    var x40 = $thiz.aQv(p, u, penwidth, flag);
    if ((x40 !== null)) {
      var \u03b46$___1 = x40.g();
      var \u03b46$___2 = x40.h();
      break matchResult21;
    }
    throw new $c_s_MatchError(x40);
  }
  var a$2 = \u03b46$___1;
  var q$2 = \u03b46$___2;
  var filled = ((flag & $thiz.Bf) === 0);
  return new $c_T2(new $c_sci_$colon$colon((((flag & $thiz.n2) !== 0) ? new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Polygon($m_sc_ArrayOps$().ls(a$2, 0, 3), filled) : (((flag & $thiz.nU) !== 0) ? new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Polygon($m_sc_ArrayOps$().ls(a$2, 2, 5), filled) : new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Polygon($m_sc_ArrayOps$().ls(a$2, 1, 4), filled))), $m_sci_Nil$()), q$2);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__typeCrow__T2__T2__D__D__I__T2($thiz, p, u, arrowsize, penwidth, flag) {
  matchResult24: {
    var \u03b48$___1;
    var \u03b48$___2;
    var x51 = $thiz.aNe(p, u, arrowsize, penwidth, flag);
    if ((x51 !== null)) {
      var \u03b48$___1 = x51.g();
      var \u03b48$___2 = x51.h();
      break matchResult24;
    }
    throw new $c_s_MatchError(x51);
  }
  var a$2 = \u03b48$___1;
  var q$2 = \u03b48$___2;
  return new $c_T2(new $c_sci_$colon$colon((((flag & $thiz.n2) !== 0) ? new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Polygon($m_sc_ArrayOps$().ls(a$2, 0, 5), true) : (((flag & $thiz.nU) !== 0) ? new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Polygon($m_sc_ArrayOps$().ls(a$2, 4, 9), true) : new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Polygon($m_sc_ArrayOps$().ls(a$2, 0, 8), true))), $m_sci_Nil$()), q$2);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__typeGap__T2__T2__T2($thiz, p, u) {
  var q = new $c_T2(((+p.g()) + (+u.g())), ((+p.h()) + (+u.h())));
  return new $c_T2(new $c_sci_$colon$colon(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Polyline(new ($d_T2.r().C)([p, q])), $m_sci_Nil$()), q);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__typeTee__T2__T2__D__I__T2($thiz, p0, u, penwidth, flag) {
  var p = p0;
  var _1 = (-(+u.h()));
  var _2 = u.g();
  var q = new $c_T2(((+p.g()) + (+u.g())), ((+p.h()) + (+u.h())));
  var m = new $c_T2(((+p.g()) + (0.2 * (+u.g()))), ((+p.h()) + (0.2 * (+u.h()))));
  var n = new $c_T2(((+p.g()) + (0.6 * (+u.g()))), ((+p.h()) + (0.6 * (+u.h()))));
  var length = $m_jl_Math$().ga((+u.g()), (+u.h()));
  var polygonExtendOverPolyline = ((0.5 * penwidth) - (0.2 * length));
  if (((length > 0.0) && (polygonExtendOverPolyline > 0.0))) {
    var _1$4 = (-(+u.g()));
    var _2$4 = (-(+u.h()));
    var h = $m_jl_Math$().ga(_1$4, _2$4);
    var _1$5 = (polygonExtendOverPolyline * (_1$4 / h));
    var _2$5 = (polygonExtendOverPolyline * (_2$4 / h));
    p = new $c_T2(((+p.g()) - _1$5), ((+p.h()) - _2$5));
    m = new $c_T2(((+m.g()) - _1$5), ((+m.h()) - _2$5));
    n = new $c_T2(((+n.g()) - _1$5), ((+n.h()) - _2$5));
    q = new $c_T2(((+q.g()) - _1$5), ((+q.h()) - _2$5));
  }
  var a = new ($d_T2.r().C)([new $c_T2(((+m.g()) + _1), ((+m.h()) + (+_2))), new $c_T2(((+m.g()) - _1), ((+m.h()) - (+_2))), new $c_T2(((+n.g()) - _1), ((+n.h()) - (+_2))), new $c_T2(((+n.g()) + _1), ((+n.h()) + (+_2)))]);
  if (((flag & $thiz.n2) !== 0)) {
    a.a[0] = m;
    a.a[3] = n;
  } else if (((flag & $thiz.nU) !== 0)) {
    a.a[1] = m;
    a.a[2] = n;
  }
  return new $c_T2(new $c_sci_$colon$colon(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Polygon(a, true), new $c_sci_$colon$colon(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Polyline(new ($d_T2.r().C)([p, q])), $m_sci_Nil$())), q);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__typeBox__T2__T2__D__I__T2($thiz, p0, u, penwidth, flag) {
  var p = p0;
  var _1 = (0.4 * (-(+u.h())));
  var _2 = (0.4 * (+u.g()));
  var m = new $c_T2(((+p.g()) + (0.8 * (+u.g()))), ((+p.h()) + (0.8 * (+u.h()))));
  var q = new $c_T2(((+p.g()) + (+u.g())), ((+p.h()) + (+u.h())));
  var delta___1 = 0.0;
  var delta___2 = 0.0;
  if ((((+u.g()) !== 0.0) || ((+u.h()) !== 0.0))) {
    var _1$3 = (-(+u.g()));
    var _2$3 = (-(+u.h()));
    var h = $m_jl_Math$().ga(_1$3, _2$3);
    var $x_1___1 = ((0.5 * penwidth) * (_1$3 / h));
    var $x_1___2 = ((0.5 * penwidth) * (_2$3 / h));
    delta___1 = $x_1___1;
    delta___2 = $x_1___2;
  }
  p = new $c_T2(((+p.g()) - (+delta___1)), ((+p.h()) - (+delta___2)));
  m = new $c_T2(((+m.g()) - (+delta___1)), ((+m.h()) - (+delta___2)));
  q = new $c_T2(((+q.g()) - (+delta___1)), ((+q.h()) - (+delta___2)));
  var a = new ($d_T2.r().C)([new $c_T2(((+p.g()) + _1), ((+p.h()) + _2)), new $c_T2(((+p.g()) - _1), ((+p.h()) - _2)), new $c_T2(((+m.g()) - _1), ((+m.h()) - _2)), new $c_T2(((+m.g()) + _1), ((+m.h()) + _2))]);
  if (((flag & $thiz.n2) !== 0)) {
    a.a[0] = p;
    a.a[3] = m;
  } else if (((flag & $thiz.nU) !== 0)) {
    a.a[1] = p;
    a.a[2] = m;
  }
  return new $c_T2(new $c_sci_$colon$colon(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Polygon(a, ((flag & $thiz.Bf) === 0)), new $c_sci_$colon$colon(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Polyline(new ($d_T2.r().C)([m, q])), $m_sci_Nil$())), q);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__typeDiamond__T2__T2__D__I__T2($thiz, p, u, penwidth, flag) {
  matchResult26: {
    var \u03b49$___1;
    var \u03b49$___2;
    var x58 = $thiz.aZW(p, u, penwidth, flag);
    if ((x58 !== null)) {
      var \u03b49$___1 = x58.g();
      var \u03b49$___2 = x58.h();
      break matchResult26;
    }
    throw new $c_s_MatchError(x58);
  }
  var a$2 = \u03b49$___1;
  var q$2 = \u03b49$___2;
  var filled = ((flag & $thiz.Bf) === 0);
  return new $c_T2(new $c_sci_$colon$colon((((flag & $thiz.n2) !== 0) ? new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Polygon($m_sc_ArrayOps$().ls(a$2, 2, 5), filled) : (((flag & $thiz.nU) !== 0) ? new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Polygon($m_sc_ArrayOps$().ls(a$2, 0, 3), filled) : new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Polygon($m_sc_ArrayOps$().ls(a$2, 0, 4), filled))), $m_sci_Nil$()), q$2);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__typeDot__T2__T2__D__I__T2($thiz, p0, u, penwidth, flag) {
  var p = p0;
  var r = (0.5 * $m_jl_Math$().ga((+u.g()), (+u.h())));
  var delta___1 = 0.0;
  var delta___2 = 0.0;
  if ((((+u.g()) !== 0.0) || ((+u.h()) !== 0.0))) {
    var _1 = (-(+u.g()));
    var _2 = (-(+u.h()));
    var h = $m_jl_Math$().ga(_1, _2);
    var $x_1___1 = ((0.5 * penwidth) * (_1 / h));
    var $x_1___2 = ((0.5 * penwidth) * (_2 / h));
    delta___1 = $x_1___1;
    delta___2 = $x_1___2;
    p = new $c_T2(((+p.g()) - (+delta___1)), ((+p.h()) - (+delta___2)));
  }
  var center = new $c_T2(((+p.g()) + (0.5 * (+u.g()))), ((+p.h()) + (0.5 * (+u.h()))));
  var q = new $c_T2((((+p.g()) + (+u.g())) - (+delta___1)), (((+p.h()) + (+u.h())) - (+delta___2)));
  return new $c_T2(new $c_sci_$colon$colon(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Ellipse(center, r, ((flag & $thiz.Bf) === 0)), $m_sci_Nil$()), q);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__typeCurve__T2__T2__D__I__T2($thiz, p0, u, penwidth, flag) {
  var p = p0;
  var a0 = p;
  if ((((flag & $thiz.nT) === 0) && (((+u.g()) !== 0.0) || ((+u.h()) !== 0.0)))) {
    var _1 = (-(+u.g()));
    var _2 = (-(+u.h()));
    var h = $m_jl_Math$().ga(_1, _2);
    var _1$1 = ((0.5 * penwidth) * (_1 / h));
    var _2$1 = ((0.5 * penwidth) * (_2 / h));
    p = new $c_T2(((+p.g()) - _1$1), ((+p.h()) - _2$1));
  }
  var arrowwidth = ((penwidth > 4.0) ? (0.25 * (0.5 * penwidth)) : 0.5);
  var q = new $c_T2(((+p.g()) + (+u.g())), ((+p.h()) + (+u.h())));
  var _1$4 = ((-(+u.h())) * arrowwidth);
  var _2$4 = ((+u.g()) * arrowwidth);
  var _2$5 = (-_1$4);
  var af = new ($d_T2.r().C)(4);
  af.a[0] = new $c_T2((((+p.g()) + _1$4) + _2$4), (((+p.h()) + _2$4) + _2$5));
  af.a[3] = new $c_T2((((+p.g()) - _1$4) + _2$4), (((+p.h()) - _2$4) + _2$5));
  if (((flag & $thiz.nT) !== 0)) {
    af.a[1] = new $c_T2(((((+p.g()) + (0.95 * _1$4)) + _2$4) + ((4.0 * _2$4) / 3.0)), ((+af.a[0].h()) + ((4.0 * _2$5) / 3.0)));
    af.a[2] = new $c_T2(((((+p.g()) - (0.95 * _1$4)) + _2$4) + ((4.0 * _2$4) / 3.0)), ((+af.a[3].h()) + ((4.0 * _2$5) / 3.0)));
  } else {
    af.a[1] = new $c_T2(((((+p.g()) + (0.95 * _1$4)) + _2$4) - ((4.0 * _2$4) / 3.0)), ((+af.a[0].h()) - ((4.0 * _2$5) / 3.0)));
    af.a[2] = new $c_T2(((((+p.g()) - (0.95 * _1$4)) + _2$4) - ((4.0 * _2$4) / 3.0)), ((+af.a[3].h()) - ((4.0 * _2$5) / 3.0)));
  }
  return new $c_T2(new $c_sci_$colon$colon(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Polyline(new ($d_T2.r().C)([a0, q])), new $c_sci_$colon$colon(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Curve((((flag & $thiz.n2) !== 0) ? $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__bezierSplit__AT2__T2($thiz, af).h() : (((flag & $thiz.nU) !== 0) ? $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__bezierSplit__AT2__T2($thiz, af).g() : af))), $m_sci_Nil$())), q);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__bezierSplit__AT2__T2($thiz, v) {
  var tri = $m_jl_reflect_Array$().m0($d_T2.l(), new $ac_I(new Int32Array([4, 4])));
  var j = 0;
  while ((j <= 3)) {
    tri.a[0].a[j] = v.a[j];
    j = ((1 + j) | 0);
  }
  var i = 1;
  while ((i <= 3)) {
    j = 0;
    while ((j <= ((3 - i) | 0))) {
      tri.a[i].a[j] = new $c_T2(((0.5 * (+tri.a[((i - 1) | 0)].a[j].g())) + (0.5 * (+tri.a[((i - 1) | 0)].a[((1 + j) | 0)].g()))), ((0.5 * (+tri.a[((i - 1) | 0)].a[j].h())) + (0.5 * (+tri.a[((i - 1) | 0)].a[((1 + j) | 0)].h()))));
      j = ((1 + j) | 0);
    }
    i = ((1 + i) | 0);
  }
  return new $c_T2(new ($d_T2.r().C)([tri.a[0].a[0], tri.a[1].a[0], tri.a[2].a[0], tri.a[3].a[0]]), new ($d_T2.r().C)([tri.a[3].a[0], tri.a[2].a[1], tri.a[1].a[2], tri.a[0].a[3]]));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__lengthGeneric__D__D__D($thiz, lf, arrowsize) {
  return ((lf * arrowsize) * $thiz.wC);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__lengthNormal__D__D__D__I__D($thiz, lf, arrowsize, penwidth, flag) {
  matchResult29: {
    var \u03b411$___1;
    var \u03b411$___2;
    var x65 = $thiz.aQv(new $c_T2(0.0, 0.0), new $c_T2(((lf * arrowsize) * $thiz.wC), 0.0), penwidth, flag);
    if ((x65 !== null)) {
      var \u03b411$___1 = x65.g();
      var \u03b411$___2 = x65.h();
      break matchResult29;
    }
    throw new $c_s_MatchError(x65);
  }
  var a$2 = \u03b411$___1;
  var q$2 = \u03b411$___2;
  var base1 = a$2.a[1];
  var base2 = a$2.a[3];
  var tip = a$2.a[2];
  var fullLength = (+q$2.g());
  var x = ((+base1.g()) - (+tip.g()));
  var nominalLength = (+Math.abs(x));
  var nominalBaseWidth = ((+base2.h()) - (+base1.h()));
  var fullBaseWidth = ((nominalBaseWidth * fullLength) / nominalLength);
  var overlapAtBase = (0.5 * penwidth);
  var overlapAtTip = ((fullLength * penwidth) / fullBaseWidth);
  return (fullLength - (((flag & $thiz.nT) !== 0) ? overlapAtTip : overlapAtBase));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__lengthTee__D__D__D__D($thiz, lf, arrowsize, penwidth) {
  var nominalLength = ((lf * arrowsize) * $thiz.wC);
  var length = nominalLength;
  var atStart = ((0.5 * penwidth) - (0.4 * nominalLength));
  if ((atStart > 0.0)) {
    length = (length + atStart);
  }
  var atEnd = ((0.5 * penwidth) - (0.2 * nominalLength));
  if ((atStart > 0.0)) {
    length = (length + atEnd);
  }
  return length;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__lengthBox__D__D__D__D($thiz, lf, arrowsize, penwidth) {
  return (((lf * arrowsize) * $thiz.wC) + (0.5 * penwidth));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__lengthDiamond__D__D__D__I__D($thiz, lf, arrowsize, penwidth, flag) {
  var p0 = new $c_T2(0.0, 0.0);
  var _1 = ((lf * arrowsize) * $thiz.wC);
  var p = p0;
  var _2 = (_1 / 3.0);
  var r___1 = ((+p.g()) + (0.5 * _1));
  var r___2 = ((+p.h()) + 0.0);
  var q = new $c_T2(((+p.g()) + _1), ((+p.h()) + 0.0));
  var origin = new $c_T2(0.0, 0.0);
  var unmodLeft = new $c_T2((((-0.5) * _1) - (-0)), ((-0) - _2));
  var unmodRight = new $c_T2((((-0.5) * _1) + (-0)), ((-0) + _2));
  var baseLeft = (((flag & $thiz.nU) !== 0) ? origin : unmodLeft);
  var baseRight = (((flag & $thiz.n2) !== 0) ? origin : unmodRight);
  var bigP = new $c_T2((-_1), (-0));
  matchResult25: {
    var p3$2;
    var x54 = $thiz.Xy(baseLeft, bigP, baseRight, penwidth);
    if ((x54 !== null)) {
      var p3$2 = x54.bH;
      break matchResult25;
    }
    throw new $c_s_MatchError(x54);
  }
  var _1$6 = ((+p3$2.g()) - (+bigP.bi));
  var _2$5 = ((+p3$2.h()) - (+bigP.be));
  p = new $c_T2(((+p.g()) - _1$6), ((+p.h()) - _2$5));
  var $x_1___1 = ((+r___1) - _1$6);
  var $x_1___2 = ((+r___2) - _2$5);
  r___1 = $x_1___1;
  r___2 = $x_1___2;
  q = new $c_T2(((+q.g()) - _1$6), ((+q.h()) - _2$5));
  var \u03b412$___1 = new ($d_T2.r().C)([q, new $c_T2(((+r___1) + (-0)), ((+r___2) + _2)), p, new $c_T2(((+r___1) - (-0)), ((+r___2) - _2)), q]);
  var \u03b412$___2 = new $c_T2(((+q.g()) - _1$6), ((+q.h()) - _2$5));
  var a$2 = \u03b412$___1;
  var q$2 = \u03b412$___2;
  var base1 = a$2.a[3];
  var base2 = a$2.a[1];
  var tip = a$2.a[2];
  var fullLength = (0.5 * (+q$2.g()));
  var x = ((+base1.g()) - (+tip.g()));
  var nominalLength = (+Math.abs(x));
  return ((2.0 * fullLength) - ((fullLength * penwidth) / ((((+base2.h()) - (+base1.h())) * fullLength) / nominalLength)));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__lengthDot__D__D__D__D($thiz, lf, arrowsize, penwidth) {
  return (((lf * arrowsize) * $thiz.wC) + penwidth);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__lengthCurve__D__D__D__D($thiz, lf, arrowsize, penwidth) {
  return (((lf * arrowsize) * $thiz.wC) + (0.5 * penwidth));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__lengthCrow__D__D__D__I__D($thiz, lf, arrowsize, penwidth, flag) {
  matchResult31: {
    var \u03b413$___1;
    var \u03b413$___2;
    var x71 = $thiz.aNe(new $c_T2(0.0, 0.0), new $c_T2(((lf * arrowsize) * $thiz.wC), 0.0), arrowsize, penwidth, flag);
    if ((x71 !== null)) {
      var \u03b413$___1 = x71.g();
      var \u03b413$___2 = x71.h();
      break matchResult31;
    }
    throw new $c_s_MatchError(x71);
  }
  var a$2 = \u03b413$___1;
  var q$2 = \u03b413$___2;
  var base1 = a$2.a[1];
  var base2 = a$2.a[7];
  var tip = a$2.a[0];
  var shaft1 = a$2.a[3];
  var fullLength = (+q$2.g());
  var fullLengthWithoutShaft = (fullLength - ((+base1.g()) - (+shaft1.g())));
  var x = ((+base1.g()) - (+tip.g()));
  var nominalLength = (+Math.abs(x));
  var nominalBaseWidth = ((+base2.h()) - (+base1.h()));
  var fullBaseWidth = ((nominalBaseWidth * fullLengthWithoutShaft) / nominalLength);
  var overlapAtBase = (0.5 * penwidth);
  var overlapAtTip = ((fullLengthWithoutShaft * penwidth) / fullBaseWidth);
  return (fullLength - (((flag & $thiz.nT) !== 0) ? overlapAtBase : overlapAtTip));
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$() {
  this.wC = 0.0;
  this.Rw = 0;
  this.Rx = 0;
  this.ZI = 0;
  this.a7Q = 0;
  this.lC = 0;
  this.nV = 0;
  this.Kz = 0;
  this.RB = 0;
  this.ZH = 0;
  this.Rz = 0;
  this.RA = 0;
  this.Ry = 0;
  this.Fa = 0;
  this.Bf = 0;
  this.nT = 0;
  this.n2 = 0;
  this.nU = 0;
  this.au4 = null;
  this.au2 = null;
  this.au3 = null;
  this.Ky = 0.0;
  $n_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$ = this;
  this.wC = 10.0;
  this.Rw = 8;
  this.Rx = 4;
  this.ZI = 15;
  this.a7Q = (((1 << this.Rw) - 1) | 0);
  this.lC = 0;
  this.nV = 1;
  this.Kz = 2;
  this.RB = 3;
  this.ZH = 4;
  this.Rz = 5;
  this.RA = 6;
  this.Ry = 7;
  this.Fa = 8;
  this.Bf = 16;
  this.nT = 32;
  this.n2 = 64;
  this.nU = 128;
  this.au4 = new $c_sci_$colon$colon(new $c_T2("invempty", ((this.nV | this.nT) | this.Bf)), $m_sci_Nil$());
  this.au2 = new $c_sci_$colon$colon(new $c_T2("o", this.Bf), new $c_sci_$colon$colon(new $c_T2("r", this.nU), new $c_sci_$colon$colon(new $c_T2("l", this.n2), new $c_sci_$colon$colon(new $c_T2("e", this.Bf), new $c_sci_$colon$colon(new $c_T2("half", this.n2), $m_sci_Nil$())))));
  this.au3 = $m_sci_Nil$().b6($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("normal", this.nV), new $c_T2("crow", this.Kz), new $c_T2("tee", this.RB), new $c_T2("box", this.ZH), new $c_T2("diamond", this.Rz), new $c_T2("dot", this.RA), new $c_T2("none", this.Fa), new $c_T2("inv", (this.nV | this.nT)), new $c_T2("vee", (this.Kz | this.nT)), new $c_T2("pen", (this.Kz | this.nT)), new $c_T2("mpty", this.nV), new $c_T2("curve", this.Ry), new $c_T2("icurve", (this.Ry | this.nT))])));
  this.Ky = 1.0E-4;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$.prototype = $p;
$p.aQc = (function(name) {
  var flag = 0;
  var rest = name;
  var i = 0;
  var stop = false;
  while ((((!stop) && (rest !== "")) && (i < this.Rx))) {
    matchResult6: {
      var \u03b44$___1;
      var \u03b44$___2;
      var x16 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__matchShape__T__T2(this, rest);
      if ((x16 !== null)) {
        var \u03b44$___1 = x16.g();
        var \u03b44$___2 = (x16.h() | 0);
        break matchResult6;
      }
      throw new $c_s_MatchError(x16);
    }
    var r$2 = \u03b44$___1;
    var f0$2 = (\u03b44$___2 | 0);
    rest = r$2;
    var f = f0$2;
    if ((f === this.lC)) {
      stop = true;
    } else {
      if (((f === this.Fa) && (i === ((this.Rx - 1) | 0)))) {
        f = this.lC;
      }
      if ((((f === this.Fa) && (i === 0)) && (rest === ""))) {
        f = this.lC;
      }
      if ((f !== this.lC)) {
        flag = (flag | (f << Math.imul(i, this.Rw)));
        i = ((1 + i) | 0);
      }
    }
  }
  return flag;
});
$p.aOc = (function(directed, dir, arrowhead, arrowtail) {
  var elem = this.lC;
  var elem$1 = 0;
  elem$1 = elem;
  var elem$2 = (directed ? this.nV : this.lC);
  var elem$3 = 0;
  elem$3 = elem$2;
  var this$5 = ((dir.c() || (dir.d() !== "")) ? dir : $m_s_None$());
  if ((!this$5.c())) {
    switch (this$5.d()) {
      case "forward": {
        elem$1 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$().lC;
        elem$3 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$().nV;
        break;
      }
      case "back": {
        elem$1 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$().nV;
        elem$3 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$().lC;
        break;
      }
      case "both": {
        elem$1 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$().nV;
        elem$3 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$().nV;
        break;
      }
      case "none": {
        elem$1 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$().lC;
        elem$3 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$().lC;
        break;
      }
    }
  }
  if ((elem$3 === this.nV)) {
    var this$8 = ((arrowhead.c() || (arrowhead.d() !== "")) ? arrowhead : $m_s_None$());
    if ((!this$8.c())) {
      var x0$3 = this$8.d();
      elem$3 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$().aQc(x0$3);
    }
  }
  if ((elem$1 === this.nV)) {
    var this$11 = ((arrowtail.c() || (arrowtail.d() !== "")) ? arrowtail : $m_s_None$());
    if ((!this$11.c())) {
      var x0$5 = this$11.d();
      elem$1 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$().aQc(x0$5);
    }
  }
  return new $c_T2(elem$1, elem$3);
});
$p.Xy = (function(baseLeft, bigP, baseRight, penwidth) {
  if ((((baseLeft === null) ? (bigP === null) : baseLeft.e(bigP)) || ((baseRight === null) ? (bigP === null) : baseRight.e(bigP)))) {
    return new $c_T3(bigP, bigP, bigP);
  } else {
    var dxA = ((+bigP.g()) - (+baseLeft.g()));
    var dyA = ((+bigP.h()) - (+baseLeft.h()));
    var hA = $m_jl_Math$().ga(dxA, dyA);
    var cosA = (dxA / hA);
    var sinA = (dyA / hA);
    var p1 = new $c_T2(((+bigP.g()) - ((0.5 * penwidth) * sinA)), ((+bigP.h()) + ((0.5 * penwidth) * cosA)));
    var dxB = ((+baseRight.g()) - (+bigP.g()));
    var dyB = ((+baseRight.h()) - (+bigP.h()));
    var hB = $m_jl_Math$().ga(dxB, dyB);
    var cosB = (dxB / hB);
    var sinB = (dyB / hB);
    var alpha = ((dyA > 0.0) ? (+Math.acos(cosA)) : (-(+Math.acos(cosA))));
    var beta = ((dyB > 0.0) ? (+Math.acos(cosB)) : (-(+Math.acos(cosB))));
    var betaRev = (beta - 3.141592653589793);
    var theta = ((betaRev - alpha) + (((betaRev - alpha) <= (-3.141592653589793)) ? 6.283185307179586 : 0.0));
    var p2 = new $c_T2(((+bigP.g()) + ((0.5 * penwidth) * (-sinB))), ((+bigP.h()) - ((0.5 * penwidth) * (-cosB))));
    var x = (0.5 * theta);
    if (((1.0 / (+Math.sin(x))) > 4.0)) {
      return new $c_T3(new $c_T2((0.5 * ((+p1.bi) + (+p2.bi))), (0.5 * ((+p1.be) + (+p2.be)))), p1, p2);
    } else {
      var x$1 = (0.5 * theta);
      var l = ((0.5 * penwidth) / (+Math.tan(x$1)));
      return new $c_T3(new $c_T2(((+p1.bi) + (l * cosA)), ((+p1.be) + (l * sinA))), p1, p2);
    }
  }
});
$p.aQv = (function(p0, u, penwidth, flag) {
  var p = p0;
  var arrowwidth = ((penwidth > 4.0) ? (0.25 * (0.35 * penwidth)) : 0.35);
  var v = new $c_T2(((-(+u.h())) * arrowwidth), ((+u.g()) * arrowwidth));
  var q = new $c_T2(((+p.g()) + (+u.g())), ((+p.h()) + (+u.h())));
  var deltaBase___1 = 0.0;
  var deltaBase___2 = 0.0;
  var origin = new $c_T2(0.0, 0.0);
  var vInv = new $c_T2((-(+v.bi)), (-(+v.be)));
  var normalLeft = (((flag & this.nU) !== 0) ? origin : vInv);
  var normalRight = (((flag & this.n2) !== 0) ? origin : v);
  var baseLeft = (((flag & this.nT) !== 0) ? normalRight : normalLeft);
  var baseRight = (((flag & this.nT) !== 0) ? normalLeft : normalRight);
  var bigP = (((flag & this.nT) !== 0) ? u : new $c_T2((-(+u.g())), (-(+u.h()))));
  var deltaTip = new $c_T2(0.0, 0.0);
  if ((((+u.g()) !== 0.0) || ((+u.h()) !== 0.0))) {
    var h = $m_jl_Math$().ga((+bigP.g()), (+bigP.h()));
    var cosPhi = ((+bigP.g()) / h);
    var sinPhi = ((+bigP.h()) / h);
    var phi = (((+bigP.h()) > 0.0) ? (+Math.acos(cosPhi)) : (-(+Math.acos(cosPhi))));
    matchResult20: {
      var \u03b45$___1;
      var \u03b45$___2;
      var \u03b45$___3;
      var x36 = this.Xy(baseLeft, bigP, baseRight, penwidth);
      if ((x36 !== null)) {
        var \u03b45$___1 = x36.bH;
        var \u03b45$___2 = x36.bU;
        var \u03b45$___3 = x36.c3;
        break matchResult20;
      }
      throw new $c_s_MatchError(x36);
    }
    var p3$2 = \u03b45$___1;
    var p1$2 = \u03b45$___2;
    var p2$2 = \u03b45$___3;
    deltaTip = (((flag & this.n2) !== 0) ? $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__deltaTipFromJoin__T2__T2__D__D__D__T2(this, p1$2, bigP, cosPhi, sinPhi, phi) : (((flag & this.nU) !== 0) ? $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__deltaTipFromJoin__T2__T2__D__D__D__T2(this, p2$2, bigP, cosPhi, sinPhi, phi) : new $c_T2(((+p3$2.g()) - (+bigP.g())), ((+p3$2.h()) - (+bigP.h())))));
    var $x_1___1 = ((0.5 * penwidth) * cosPhi);
    var $x_1___2 = ((0.5 * penwidth) * sinPhi);
    deltaBase___1 = $x_1___1;
    deltaBase___2 = $x_1___2;
  }
  var a = new ($d_T2.r().C)(5);
  if (((flag & this.nT) !== 0)) {
    p = new $c_T2(((+p.g()) + (+deltaBase___1)), ((+p.h()) + (+deltaBase___2)));
    q = new $c_T2(((+q.g()) + (+deltaBase___1)), ((+q.h()) + (+deltaBase___2)));
    a.a[0] = p;
    a.a[4] = p;
    a.a[1] = new $c_T2(((+p.g()) - (+v.bi)), ((+p.h()) - (+v.be)));
    a.a[2] = q;
    a.a[3] = new $c_T2(((+p.g()) + (+v.bi)), ((+p.h()) + (+v.be)));
    q = new $c_T2(((+q.g()) + (+deltaTip.g())), ((+q.h()) + (+deltaTip.h())));
  } else {
    p = new $c_T2(((+p.g()) - (+deltaTip.g())), ((+p.h()) - (+deltaTip.h())));
    q = new $c_T2(((+q.g()) - (+deltaTip.g())), ((+q.h()) - (+deltaTip.h())));
    a.a[0] = q;
    a.a[4] = q;
    a.a[1] = new $c_T2(((+q.g()) - (+v.bi)), ((+q.h()) - (+v.be)));
    a.a[2] = p;
    a.a[3] = new $c_T2(((+q.g()) + (+v.bi)), ((+q.h()) + (+v.be)));
    q = new $c_T2(((+q.g()) - (+deltaBase___1)), ((+q.h()) - (+deltaBase___2)));
  }
  return new $c_T2(a, q);
});
$p.aNe = (function(p0, u, arrowsize, penwidth, flag) {
  var p = p0;
  var inv = ((flag & this.nT) !== 0);
  var arrowwidth = (((penwidth > (4.0 * arrowsize)) && inv) ? ((0.45 * penwidth) / (4.0 * arrowsize)) : 0.45);
  var shaftwidth = (((penwidth > 1.0) && inv) ? ((0.05 * (penwidth - 1.0)) / arrowsize) : 0.0);
  var v = new $c_T2(((-(+u.h())) * arrowwidth), ((+u.g()) * arrowwidth));
  var _1$1 = ((-(+u.h())) * shaftwidth);
  var _2$1 = ((+u.g()) * shaftwidth);
  var q = new $c_T2(((+p.g()) + (+u.g())), ((+p.h()) + (+u.h())));
  var _1$3 = ((+p.g()) + (0.5 * (+u.g())));
  var _2$3 = ((+p.h()) + (0.5 * (+u.h())));
  var deltaBase___1 = 0.0;
  var deltaBase___2 = 0.0;
  var origin = new $c_T2(0.0, 0.0);
  var vInv = new $c_T2((-(+v.bi)), (-(+v.be)));
  var normalLeft = (((flag & this.nU) !== 0) ? origin : v);
  var normalRight = (((flag & this.n2) !== 0) ? origin : vInv);
  var baseLeft = (inv ? normalRight : normalLeft);
  var baseRight = (inv ? normalLeft : normalRight);
  var bigP = (inv ? new $c_T2((-(+u.g())), (-(+u.h()))) : u);
  var deltaTip = new $c_T2(0.0, 0.0);
  if ((((+u.g()) !== 0.0) || ((+u.h()) !== 0.0))) {
    var h = $m_jl_Math$().ga((+bigP.g()), (+bigP.h()));
    var cosPhi = ((+bigP.g()) / h);
    var sinPhi = ((+bigP.h()) / h);
    var phi = (((+bigP.h()) > 0.0) ? (+Math.acos(cosPhi)) : (-(+Math.acos(cosPhi))));
    matchResult22: {
      var \u03b47$___1;
      var \u03b47$___2;
      var \u03b47$___3;
      var x43 = this.Xy(baseLeft, bigP, baseRight, penwidth);
      if ((x43 !== null)) {
        var \u03b47$___1 = x43.bH;
        var \u03b47$___2 = x43.bU;
        var \u03b47$___3 = x43.c3;
        break matchResult22;
      }
      throw new $c_s_MatchError(x43);
    }
    var p3$2 = \u03b47$___1;
    var p1$2 = \u03b47$___2;
    var p2$2 = \u03b47$___3;
    deltaTip = (((((flag & this.n2) !== 0) && inv) || (((flag & this.nU) !== 0) && (!inv))) ? $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__deltaTipFromJoin__T2__T2__D__D__D__T2(this, p2$2, bigP, cosPhi, sinPhi, phi) : (((((flag & this.n2) !== 0) && (!inv)) || (((flag & this.nU) !== 0) && inv)) ? $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__deltaTipFromJoin__T2__T2__D__D__D__T2(this, p1$2, bigP, cosPhi, sinPhi, phi) : new $c_T2(((+p3$2.g()) - (+bigP.g())), ((+p3$2.h()) - (+bigP.h())))));
    if (inv) {
      var $x_1___1 = ((0.5 * penwidth) * cosPhi);
      var $x_1___2 = ((0.5 * penwidth) * sinPhi);
      deltaBase___1 = $x_1___1;
      deltaBase___2 = $x_1___2;
    } else {
      var toeBaseLeft = new $c_T2(((_1$3 - (+q.g())) + _1$1), ((_2$3 - (+q.h())) + _2$1));
      var toeP = new $c_T2(((+v.bi) - (+u.g())), ((+v.be) - (+u.h())));
      matchResult23: {
        var tp1$2;
        var x47 = this.Xy(toeBaseLeft, toeP, origin, penwidth);
        if ((x47 !== null)) {
          var tp1$2 = x47.bU;
          break matchResult23;
        }
        throw new $c_s_MatchError(x47);
      }
      var dx = ((+tp1$2.g()) - (+toeP.bi));
      var dy = ((+tp1$2.h()) - (+toeP.be));
      var hh = $m_jl_Math$().ga(dx, dy);
      if ((dy > 0.0)) {
        var x$1 = (dx / hh);
        var alpha = (+Math.acos(x$1));
      } else {
        var x$2 = (dx / hh);
        var alpha = (-(+Math.acos(x$2)));
      }
      var x$3 = (alpha - phi);
      var len = ((-hh) * (+Math.cos(x$3)));
      var $x_2___1 = (len * cosPhi);
      var $x_2___2 = (len * sinPhi);
      deltaBase___1 = $x_2___1;
      deltaBase___2 = $x_2___2;
    }
  }
  var a = new ($d_T2.r().C)(9);
  if (inv) {
    p = new $c_T2(((+p.g()) - (+deltaTip.g())), ((+p.h()) - (+deltaTip.h())));
    q = new $c_T2(((+q.g()) - (+deltaTip.g())), ((+q.h()) - (+deltaTip.h())));
    a.a[0] = p;
    a.a[8] = p;
    a.a[1] = new $c_T2(((+q.g()) - (+v.bi)), ((+q.h()) - (+v.be)));
    a.a[2] = new $c_T2((_1$3 - _1$1), (_2$3 - _2$1));
    a.a[3] = new $c_T2(((+q.g()) - _1$1), ((+q.h()) - _2$1));
    a.a[4] = q;
    a.a[5] = new $c_T2(((+q.g()) + _1$1), ((+q.h()) + _2$1));
    a.a[6] = new $c_T2((_1$3 + _1$1), (_2$3 + _2$1));
    a.a[7] = new $c_T2(((+q.g()) + (+v.bi)), ((+q.h()) + (+v.be)));
    q = new $c_T2(((+q.g()) - (+deltaBase___1)), ((+q.h()) - (+deltaBase___2)));
  } else {
    p = new $c_T2(((+p.g()) + (+deltaBase___1)), ((+p.h()) + (+deltaBase___2)));
    q = new $c_T2(((+q.g()) + (+deltaBase___1)), ((+q.h()) + (+deltaBase___2)));
    a.a[0] = q;
    a.a[8] = q;
    a.a[1] = new $c_T2(((+p.g()) - (+v.bi)), ((+p.h()) - (+v.be)));
    a.a[2] = new $c_T2((_1$3 - _1$1), (_2$3 - _2$1));
    a.a[3] = new $c_T2(((+p.g()) + (+deltaBase___1)), ((+p.h()) + (+deltaBase___2)));
    a.a[4] = new $c_T2(((+p.g()) + (+deltaBase___1)), ((+p.h()) + (+deltaBase___2)));
    a.a[5] = new $c_T2(((+p.g()) + (+deltaBase___1)), ((+p.h()) + (+deltaBase___2)));
    a.a[6] = new $c_T2((_1$3 + _1$1), (_2$3 + _2$1));
    a.a[7] = new $c_T2(((+p.g()) + (+v.bi)), ((+p.h()) + (+v.be)));
    q = new $c_T2(((+q.g()) + (+deltaTip.g())), ((+q.h()) + (+deltaTip.h())));
  }
  return new $c_T2(a, q);
});
$p.aZW = (function(p0, u, penwidth, flag) {
  var p = p0;
  var _1 = ((-(+u.h())) / 3.0);
  var _2 = ((+u.g()) / 3.0);
  var r___1 = ((+p.g()) + (0.5 * (+u.g())));
  var r___2 = ((+p.h()) + (0.5 * (+u.h())));
  var q = new $c_T2(((+p.g()) + (+u.g())), ((+p.h()) + (+u.h())));
  var origin = new $c_T2(0.0, 0.0);
  var unmodLeft = new $c_T2((((-0.5) * (+u.g())) - _1), (((-0.5) * (+u.h())) - _2));
  var unmodRight = new $c_T2((((-0.5) * (+u.g())) + _1), (((-0.5) * (+u.h())) + _2));
  var baseLeft = (((flag & this.nU) !== 0) ? origin : unmodLeft);
  var baseRight = (((flag & this.n2) !== 0) ? origin : unmodRight);
  var bigP = new $c_T2((-(+u.g())), (-(+u.h())));
  matchResult25: {
    var p3$2;
    var x54 = this.Xy(baseLeft, bigP, baseRight, penwidth);
    if ((x54 !== null)) {
      var p3$2 = x54.bH;
      break matchResult25;
    }
    throw new $c_s_MatchError(x54);
  }
  var _1$6 = ((+p3$2.g()) - (+bigP.bi));
  var _2$6 = ((+p3$2.h()) - (+bigP.be));
  p = new $c_T2(((+p.g()) - _1$6), ((+p.h()) - _2$6));
  var $x_1___1 = ((+r___1) - _1$6);
  var $x_1___2 = ((+r___2) - _2$6);
  r___1 = $x_1___1;
  r___2 = $x_1___2;
  q = new $c_T2(((+q.g()) - _1$6), ((+q.h()) - _2$6));
  return new $c_T2(new ($d_T2.r().C)([q, new $c_T2(((+r___1) + _1), ((+r___2) + _2)), p, new $c_T2(((+r___1) - _1), ((+r___2) - _2)), q]), new $c_T2(((+q.g()) - _1$6), ((+q.h()) - _2$6)));
});
$p.aMo = (function(flag, penwidth, arrowsize) {
  if ((arrowsize === 0.0)) {
    return 0.0;
  } else {
    var length = 0.0;
    var i = 0;
    while ((i < this.Rx)) {
      var f = ((flag >> Math.imul(i, this.Rw)) & this.a7Q);
      var tpe = (f & this.ZI);
      var lf = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__lenfact__I__D(this, tpe);
      length = (length + ((this.nV === tpe) ? $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__lengthNormal__D__D__D__I__D(this, lf, arrowsize, penwidth, f) : ((this.Kz === tpe) ? $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__lengthCrow__D__D__D__I__D(this, lf, arrowsize, penwidth, f) : ((this.RB === tpe) ? $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__lengthTee__D__D__D__D(this, lf, arrowsize, penwidth) : ((this.ZH === tpe) ? $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__lengthBox__D__D__D__D(this, lf, arrowsize, penwidth) : ((this.Rz === tpe) ? $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__lengthDiamond__D__D__D__I__D(this, lf, arrowsize, penwidth, f) : ((this.RA === tpe) ? $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__lengthDot__D__D__D__D(this, lf, arrowsize, penwidth) : ((this.Ry === tpe) ? $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__lengthCurve__D__D__D__D(this, lf, arrowsize, penwidth) : ((this.Fa === tpe) ? $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__lengthGeneric__D__D__D(this, lf, arrowsize) : 0.0)))))))));
      i = ((1 + i) | 0);
    }
    return length;
  }
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$, "org.jpablo.graphexplorer.graphviz.layout.Arrow$", ({
  uC: 1
}));
var $n_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$;
function $m_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$() {
  if ((!$n_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$)) {
    $n_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$ = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$();
  }
  return $n_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$__structure__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T2($thiz, g) {
  var this$1 = $thiz.au5;
  if ((g === this$1.f0)) {
    var $x_1 = this$1.f1;
  } else {
    var v = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$__compute__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T2($m_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$(), g);
    this$1.f0 = g;
    this$1.f1 = v;
    var $x_1 = v;
  }
  return $x_1;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$__compute__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T2($thiz, g) {
  $m_sci_Vector$();
  var flat = new $c_sci_VectorBuilder();
  var count = new $c_sr_IntRef(0);
  g.uF.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => {
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$__walk$1__sr_IntRef__scm_ReusableBuilder__Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph__I__V($thiz, count, flat, _$2, (-1));
  })));
  var cls = flat.bY();
  if ($f_sc_SeqOps__isEmpty__Z(cls)) {
    return new $c_T2(($m_sci_Vector$(), $m_sci_Vector0$()), $m_sci_Map$EmptyMap$());
  }
  var ranks = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().P0(g);
  var depth = $m_scm_Map$().aO();
  $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(cls).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    matchResult9: {
      if ((x$1 !== null)) {
        var x12 = x$1.g();
        if ((x12 !== null)) {
          var p = (x12.h() | 0);
          var i = (x$1.h() | 0);
          depth.cY(i, ((p < 0) ? 0 : ((1 + (depth.i(p) | 0)) | 0)));
          break matchResult9;
        }
      }
      throw new $c_s_MatchError(x$1);
    }
  })));
  var postorder = $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(new $c_sci_Range$Exclusive(0, cls.C(), 1), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((i$1) => {
    var i$2 = (i$1 | 0);
    return ((-(depth.i(i$2) | 0)) | 0);
  })), $m_s_math_Ordering$Int$());
  var clustOfB = $m_scm_Map$().aO();
  var realEdgeIdx = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$16(new $c_sc_Iterator$$anon$9(new $c_sc_Iterator$$anon$6(new $c_sc_Iterator$$anon$16(g.cu.o()), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    if ((x$1$2 !== null)) {
      var e = x$1$2.g();
      return (e.ai !== e.ak);
    }
    throw new $c_s_MatchError(x$1$2);
  })), false), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3) => (_$3.h() | 0))))));
  postorder.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => {
    var ci = (v1 | 0);
    matchResult11: {
      var s$2;
      var x19 = cls.l(ci);
      if ((x19 !== null)) {
        var s$2 = x19.g();
        break matchResult11;
      }
      throw new $c_s_MatchError(x19);
    }
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$__transNodes$1__Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph__sci_Vector($thiz, s$2).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((id) => {
      if ((!clustOfB.E(id))) {
        clustOfB.cY(id, ci);
      }
    })));
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$__transEdges$1__Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph__sci_Vector($thiz, s$2).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1$1) => {
      var eIx = (v1$1 | 0);
      var e$1 = g.cu.l(eIx);
      var this$15 = realEdgeIdx.r(eIx);
      if ((!this$15.c())) {
        var x0 = this$15.d();
        var d = (x0 | 0);
        var this$16 = ranks.r(e$1.ai);
        if ((!this$16.c())) {
          var x0$1 = this$16.d();
          var rt = (x0$1 | 0);
          var this$17 = ranks.r(e$1.ak);
          if ((!this$17.c())) {
            var x0$2 = this$17.d();
            var rh = (x0$2 | 0);
            var r = ((1 + ((rt < rh) ? rt : rh)) | 0);
            while ((r < ((rt > rh) ? rt : rh))) {
              var nm = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Virtual(d, r).bE();
              if ((!clustOfB.E(nm))) {
                clustOfB.cY(nm, ci);
              }
              r = ((1 + r) | 0);
            }
          }
        }
      }
    })));
  })));
  return new $c_T2($f_sc_StrictOptimizedIterableOps__zipWithIndex__O(cls).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3) => {
    if ((x$1$3 !== null)) {
      var x29 = x$1$3.g();
      if ((x29 !== null)) {
        var s$1 = x29.g();
        var parent = (x29.h() | 0);
        var ci$1 = (x$1$3.h() | 0);
        var nIds = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$__transNodes$1__Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph__sci_Vector($thiz, s$1);
        $m_sci_Vector$();
        var b = new $c_sci_VectorBuilder();
        var it = nIds.o();
        while (it.p()) {
          var x0$3 = it.q();
          b.fO(ranks.r(x0$3));
        }
        var rs = b.bY();
        var this$24 = s$1.q2.r("fontsize");
        if (this$24.c()) {
          var this$28 = $m_s_None$();
        } else {
          var x0$4 = this$24.d();
          var this$28 = ($m_sc_StringParsers$().c1(x0$4) ? new $c_s_Some($m_jl_Double$().bd(x0$4)) : $m_s_None$());
        }
        var fs = (+(this$28.c() ? $m_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$().au6 : this$28.d()));
        var fn = s$1.q2.ay("fontname", new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => "Times-Roman")));
        if ((s$1.wQ !== "")) {
          var $x_5 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$();
          var $x_4 = s$1.wQ;
          var this$31 = g.j5;
          var $x_3 = $x_5.Xq($x_4, fs, fn, (this$31.c() ? "" : this$31.d()));
          var $x_2 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$();
          var $x_1 = s$1.wQ;
          var this$32 = g.j5;
          var \u03b41$___1 = $x_3;
          var \u03b41$___2 = $x_2.PC($x_1, fs, (this$32.c() ? "" : this$32.d()));
        } else {
          var \u03b41$___1 = 0.0;
          var \u03b41$___2 = 0.0;
        }
        var lw = (+\u03b41$___1);
        var lh = (+\u03b41$___2);
        var this$35 = s$1.q2.r("labelloc");
        if ((!this$35.c())) {
          var x0$5 = this$35.d();
          var $x_6 = (!(!x0$5.startsWith("b")));
        } else {
          var $x_6 = false;
        }
        var top = (!$x_6);
        var this$36 = s$1.q2.r("labeljust");
        var this$38 = (this$36.c() ? $m_s_None$() : $m_sc_StringOps$().X8(this$36.d()));
        var just = $uC((this$38.c() ? $bC(99) : this$38.d()));
        return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$CInfo(s$1.z7, s$1.wQ, parent, nIds, $m_sci_Set$().af(new $c_sc_Iterator$$anon$7(clustOfB.o(), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$$anon$1(ci$1))), ($f_sc_SeqOps__isEmpty__Z(rs) ? 0 : ($f_sc_IterableOnceOps__min__s_math_Ordering__O(rs, $m_s_math_Ordering$Int$()) | 0)), ($f_sc_SeqOps__isEmpty__Z(rs) ? 0 : ($f_sc_IterableOnceOps__max__s_math_Ordering__O(rs, $m_s_math_Ordering$Int$()) | 0)), lw, lh, top, just, fs, fn, s$1.q2.ay("fontcolor", new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => ""))));
      }
    }
    throw new $c_s_MatchError(x$1$3);
  }))), $m_sci_Map$().ao(clustOfB));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$__walk$1__sr_IntRef__scm_ReusableBuilder__Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph__I__V($thiz, count$1, flat$1, s, parentCl) {
  if (s.wP) {
    var idx = count$1.an;
    flat$1.Y(new $c_T2(s, parentCl));
    count$1.an = ((1 + count$1.an) | 0);
    var here = idx;
  } else {
    var here = parentCl;
  }
  s.lD.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => {
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$__walk$1__sr_IntRef__scm_ReusableBuilder__Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph__I__V($thiz, count$1, flat$1, _$1, here);
  })));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$__transNodes$1__Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph__sci_Vector($thiz, s) {
  var $x_1 = s.rs;
  var this$1 = s.lD;
  $m_sci_Vector$();
  var b = new $c_sci_VectorBuilder();
  var it = this$1.o();
  while (it.p()) {
    b.fO($p_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$__transNodes$1__Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph__sci_Vector($thiz, it.q()));
  }
  return $f_sc_SeqOps__distinct__O($x_1.iR(b.bY()));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$__transEdges$1__Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph__sci_Vector($thiz, s) {
  var $x_1 = s.Ft;
  var this$1 = s.lD;
  $m_sci_Vector$();
  var b = new $c_sci_VectorBuilder();
  var it = this$1.o();
  while (it.p()) {
    b.fO($p_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$__transEdges$1__Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph__sci_Vector($thiz, it.q()));
  }
  return $f_sc_SeqOps__distinct__O($x_1.iR(b.bY()));
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$() {
  this.a7R = 0.0;
  this.au6 = 0.0;
  this.au5 = null;
  $n_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$ = this;
  this.a7R = 4.0;
  this.au6 = 14.0;
  this.au5 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_GraphMemo();
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$.prototype = $p;
$p.tV = (function(g) {
  return $p_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$__structure__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T2(this, g).g();
});
$p.P5 = (function(g) {
  return $p_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$__structure__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T2(this, g).h();
});
$p.qT = (function(g, ci) {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this.tV(g)).ct(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$$anon$2(ci));
});
$p.a2N = (function(g) {
  var cs = this.tV(g);
  if ($f_sc_SeqOps__isEmpty__Z(cs)) {
    $m_sci_Vector$();
    return $m_sci_Vector0$();
  }
  var xb = $m_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$().aYq(g);
  var yi = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().a5m(g);
  matchResult17: {
    var yOf$2;
    var x39 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().PL(g);
    if ((x39 !== null)) {
      var yOf$2 = x39.h();
      break matchResult17;
    }
    throw new $c_s_MatchError(x39);
  }
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(cs).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var c = x$1.g();
    var i = (x$1.h() | 0);
    return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$BB((+xb.l(i).g()), ((+yOf$2.i(c.l0)) - (+yi.KI.l(i))), (+xb.l(i).h()), ((+yOf$2.i(c.jC)) + (+yi.KJ.l(i))));
  })));
});
$p.aO9 = (function(g, bb, tf) {
  matchResult18: {
    var \u03b42$___1;
    var \u03b42$___2;
    var x42 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().pD(g);
    matchAlts1: {
      matchAlts2: {
        var x = $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__LR__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
        if (((x === null) ? (x42 === null) : (x === x42))) {
          break matchAlts2;
        }
        var x$3 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__BT__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
        if (((x$3 === null) ? (x42 === null) : (x$3 === x42))) {
          break matchAlts2;
        }
        break matchAlts1;
      }
      var \u03b42$___1 = tf.R(bb.nW, bb.pS);
      var \u03b42$___2 = tf.R(bb.nX, bb.pR);
      break matchResult18;
    }
    var \u03b42$___1 = tf.R(bb.nW, bb.pR);
    var \u03b42$___2 = tf.R(bb.nX, bb.pS);
  }
  var ll = \u03b42$___1;
  var ur = \u03b42$___2;
  return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$BB((+ll.g()), (+ll.h()), (+ur.g()), (+ur.h()));
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$, "org.jpablo.graphexplorer.graphviz.layout.Cluster$", ({
  uD: 1
}));
var $n_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$;
function $m_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$() {
  if ((!$n_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$)) {
    $n_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$ = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$();
  }
  return $n_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$__points__D__D($thiz, inches) {
  var x = (inches * $thiz.au7);
  if ((x >= 0.0)) {
    var x$1 = (x + 0.5);
    return (+Math.floor(x$1));
  } else {
    var x$2 = (x - 0.5);
    return (+Math.ceil(x$2));
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$__leadingDouble__T__s_Option($thiz, s) {
  var this$3 = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "^\\s*([+-]?(?:\\d+\\.?\\d*|\\.\\d+)(?:[eE][+-]?\\d+)?)", $m_sci_Nil$()).Pk(s);
  if (this$3.c()) {
    return $m_s_None$();
  } else {
    var x0 = this$3.d();
    var x = $f_s_util_matching_Regex$MatchData__group__I__T(x0, 1);
    return ($m_sc_StringParsers$().c1(x) ? new $c_s_Some($m_jl_Double$().bd(x)) : $m_s_None$());
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$__gvPortOf__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T__s_Option__Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort($thiz, g, nodeId, p) {
  if (p.c()) {
    var gp = $m_s_None$();
  } else {
    var x0 = p.d();
    var this$1 = g.cB;
    _return: {
      var it = this$1.o();
      while (it.p()) {
        var a = it.q();
        if ((a.br === nodeId)) {
          var this$2 = new $c_s_Some(a);
          break _return;
        }
      }
      var this$2 = $m_s_None$();
    }
    if (this$2.c()) {
      var gp = $m_s_None$();
    } else {
      var x0$1 = this$2.d();
      var this$3 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$().agn(x0$1, g, x0);
      var gp = (this$3.c() ? $m_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$().agm(x0$1, g, x0) : this$3);
    }
  }
  return (gp.c() ? $m_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort$().RO : gp.d());
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$__exactRanksep__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__Z($thiz, g) {
  var this$2 = g.f2.ag.r("ranksep");
  if ((!this$2.c())) {
    var x0 = this$2.d();
    return ((x0.indexOf("equally") | 0) !== (-1));
  } else {
    return false;
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$__rankSep__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D($thiz, g) {
  var base = $doubleToInt($thiz.aRk(g));
  if ($m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().J0(g)) {
    var num = ((1 + base) | 0);
    return (((num + ((num >>> 31) | 0)) | 0) >> 1);
  } else {
    return base;
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$__yInfoImpl__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo($thiz, g) {
  var ranks = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().P0(g);
  if (ranks.c()) {
    return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo($m_sci_Map$EmptyMap$(), $m_sci_Map$EmptyMap$(), $m_sci_Map$EmptyMap$(), $m_sci_Map$EmptyMap$(), 0.0, 0.0, ($m_sci_Vector$(), $m_sci_Vector0$()), ($m_sci_Vector$(), $m_sci_Vector0$()));
  }
  var ord = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Order$().ahg(g);
  var realMinR = (ranks.e6().lr($m_s_math_Ordering$Int$()) | 0);
  var this$8 = $f_sc_IterableOnceOps__minOption__s_math_Ordering__s_Option(ord.oX.J8(), $m_s_math_Ordering$Int$());
  var y = ((this$8.c() ? 2147483647 : this$8.d()) | 0);
  var minR = ((realMinR < y) ? realMinR : y);
  var maxR = (ranks.e6().lq($m_s_math_Ordering$Int$()) | 0);
  var cls = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$().tV(g);
  var clustOf = ($f_sc_SeqOps__isEmpty__Z(cls) ? $m_sci_Map$EmptyMap$() : $m_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$().P5(g));
  var n = cls.C();
  if ((n <= 0)) {
    var clHt1$1 = new $ac_D(0);
  } else {
    var array = new $ac_D(n);
    var i = 0;
    while ((i < n)) {
      array.a[i] = 0.0;
      i = ((1 + i) | 0);
    }
    var clHt1$1 = array;
  }
  var n$1 = cls.C();
  if ((n$1 <= 0)) {
    var clHt2$1 = new $ac_D(0);
  } else {
    var array$1 = new $ac_D(n$1);
    var i$1 = 0;
    while ((i$1 < n$1)) {
      array$1.a[i$1] = 0.0;
      i$1 = ((1 + i$1) | 0);
    }
    var clHt2$1 = array$1;
  }
  var rootHt1 = new $c_sr_DoubleRef(0.0);
  var rootHt2 = new $c_sr_DoubleRef(0.0);
  var pht = $f_scm_Map__withDefaultValue__O__scm_Map($m_scm_Map$().aO(), 0.0);
  g.cB.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n$2) => {
    var this$19 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().J9(n$2, g);
    if ((!this$19.c())) {
      var x0 = this$19.d();
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$__scanNode$1__scm_Map__sci_Map__sci_Vector__D__AD__AD__I__I__sr_DoubleRef__I__sr_DoubleRef__T__I__D__V($thiz, pht, clustOf, cls, 8.0, clHt2$1, clHt1$1, minR, realMinR, rootHt2, maxR, rootHt1, n$2.br, (ranks.i(n$2.br) | 0), $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().X4(x0));
    }
  })));
  var dedges = g.cu.d8(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e) => (e.ai !== e.ak))), false);
  ord.Fi.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => {
    var d = (v1 | 0);
    var fe = dedges.l(d);
    var this$21 = ranks.r(fe.ai);
    if ((!this$21.c())) {
      var x0$1 = this$21.d();
      var r = (x0$1 | 0);
      matchResult8: {
        var lht$2;
        var x17 = $thiz.a3o(fe, g);
        if ((x17 !== null)) {
          var lht$2 = (+x17.h());
          break matchResult8;
        }
        throw new $c_s_MatchError(x17);
      }
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$__scanNode$1__scm_Map__sci_Map__sci_Vector__D__AD__AD__I__I__sr_DoubleRef__I__sr_DoubleRef__T__I__D__V($thiz, pht, clustOf, cls, 8.0, clHt2$1, clHt1$1, minR, realMinR, rootHt2, maxR, rootHt1, new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$FlatLabel(d).bE(), ((r - 1) | 0), (0.5 * lht$2));
    }
  })));
  var this$25 = new $c_sc_Iterator$$anon$16(new $c_sc_Iterator$$anon$6(g.cu.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$2) => (e$2.ai !== e$2.ak))), false));
  while (this$25.p()) {
    var x0$2 = this$25.dC();
    var e$1 = x0$2.g();
    var dIdx = (x0$2.h() | 0);
    var this$26 = ranks.r(e$1.ai);
    if ((!this$26.c())) {
      var x0$3 = this$26.d();
      var rt = (x0$3 | 0);
      var this$27 = ranks.r(e$1.ak);
      if ((!this$27.c())) {
        var x0$4 = this$27.d();
        var rh = (x0$4 | 0);
        var r$1 = ((1 + ((rt < rh) ? rt : rh)) | 0);
        while ((r$1 < ((rt > rh) ? rt : rh))) {
          $p_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$__scanNode$1__scm_Map__sci_Map__sci_Vector__D__AD__AD__I__I__sr_DoubleRef__I__sr_DoubleRef__T__I__D__V($thiz, pht, clustOf, cls, 8.0, clHt2$1, clHt1$1, minR, realMinR, rootHt2, maxR, rootHt1, new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Virtual(dIdx, r$1).bE(), r$1, 0.5);
          r$1 = ((1 + r$1) | 0);
        }
        if ((rt !== rh)) {
          var this$34 = e$1.b4.ag.r("label");
          var this$37 = ((this$34.c() || (this$34.d() !== "")) ? this$34 : $m_s_None$());
          if ((!this$37.c())) {
            this$37.d();
            var num = ((rt + rh) | 0);
            var mid = (((num + ((num >>> 31) | 0)) | 0) >> 1);
            matchResult9: {
              var \u03b42$___1;
              var \u03b42$___2;
              var x20 = $thiz.tX(e$1, g);
              if ((x20 !== null)) {
                var \u03b42$___1 = (+x20.g());
                var \u03b42$___2 = (+x20.h());
                break matchResult9;
              }
              throw new $c_s_MatchError(x20);
            }
            var w$2 = (+\u03b42$___1);
            var h$2 = (+\u03b42$___2);
            var ht = ($m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().jT(g) ? w$2 : h$2);
            $p_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$__scanNode$1__scm_Map__sci_Map__sci_Vector__D__AD__AD__I__I__sr_DoubleRef__I__sr_DoubleRef__T__I__D__V($thiz, pht, clustOf, cls, 8.0, clHt2$1, clHt1$1, minR, realMinR, rootHt2, maxR, rootHt1, new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Virtual(dIdx, mid).bE(), mid, (0.5 * ht));
          }
        }
      }
    }
  }
  var ht1$1 = $f_scm_Map__withDefaultValue__O__scm_Map($m_scm_Map$().aO(), 0.0);
  var ht2$1 = $f_scm_Map__withDefaultValue__O__scm_Map($m_scm_Map$().aO(), 0.0);
  pht.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    var r$2 = (x$1$2.g() | 0);
    var h$1 = (+x$1$2.h());
    ht1$1.cY(r$2, h$1);
    ht2$1.cY(r$2, h$1);
  })));
  if ((!$f_sc_SeqOps__isEmpty__Z(cls))) {
    var depth = $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(cls).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3) => {
      var c = x$1$3.g();
      var i$2 = (x$1$3.h() | 0);
      var d$1 = 0;
      var p$1 = c.yP;
      while ((p$1 >= 0)) {
        d$1 = ((1 + d$1) | 0);
        p$1 = cls.l(p$1).yP;
      }
      return new $c_T2(i$2, d$1);
    }))).eX($m_s_$less$colon$less$().b1);
    $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(new $c_sci_Range$Exclusive(0, cls.C(), 1), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((i$3) => {
      var i$4 = (i$3 | 0);
      return ((-(depth.i(i$4) | 0)) | 0);
    })), $m_s_math_Ordering$Int$()).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1$2) => {
      var ci = (v1$2 | 0);
      var c$1 = cls.l(ci);
      $m_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$().qT(g, ci).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1$1) => {
        var cc = (v1$1 | 0);
        if (((cls.l(cc).l0 === c$1.l0) && ((clHt1$1.a[cc] + 8.0) > clHt1$1.a[ci]))) {
          clHt1$1.a[ci] = (clHt1$1.a[cc] + 8.0);
        }
        if (((cls.l(cc).jC === c$1.jC) && ((clHt2$1.a[cc] + 8.0) > clHt2$1.a[ci]))) {
          clHt2$1.a[ci] = (clHt2$1.a[cc] + 8.0);
        }
      })));
      if ((c$1.pv() && (!$m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().jT(g)))) {
        clHt1$1.a[ci] = (clHt1$1.a[ci] + c$1.aMx());
        clHt2$1.a[ci] = (clHt2$1.a[ci] + c$1.aMB());
      }
      if ((clHt2$1.a[ci] > (+ht2$1.i(c$1.jC)))) {
        ht2$1.cY(c$1.jC, clHt2$1.a[ci]);
      }
      if ((clHt1$1.a[ci] > (+ht1$1.i(c$1.l0)))) {
        ht1$1.cY(c$1.l0, clHt1$1.a[ci]);
      }
    })));
    $m_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$().qT(g, (-1)).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1$3) => {
      var cc$1 = (v1$3 | 0);
      if (((cls.l(cc$1).l0 === maxR) && ((clHt1$1.a[cc$1] + 8.0) > rootHt1.T))) {
        rootHt1.T = (clHt1$1.a[cc$1] + 8.0);
      }
      if (((cls.l(cc$1).jC === minR) && ((clHt2$1.a[cc$1] + 8.0) > rootHt2.T))) {
        rootHt2.T = (clHt2$1.a[cc$1] + 8.0);
      }
    })));
  }
  if ((rootHt2.T > (+ht2$1.i(minR)))) {
    ht2$1.cY(minR, rootHt2.T);
  }
  if ((rootHt1.T > (+ht1$1.i(maxR)))) {
    ht1$1.cY(maxR, rootHt1.T);
  }
  var gLabelPad = $thiz.aP0(g);
  var labelTop = $thiz.agk(g);
  var rs = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$__rankSep__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D($thiz, g);
  var yOf$1 = $m_scm_Map$().aO();
  yOf$1.cY(maxR, ((+ht1$1.i(maxR)) + (labelTop ? 0.0 : gLabelPad)));
  var maxht = 0.0;
  var r$3 = ((maxR - 1) | 0);
  while ((r$3 >= minR)) {
    var d0 = (((+pht.i(((1 + r$3) | 0))) + (+pht.i(r$3))) + rs);
    var d1 = (((+ht2$1.i(((1 + r$3) | 0))) + (+ht1$1.i(r$3))) + 8.0);
    var delta = (+Math.max(d0, d1));
    if ((delta > maxht)) {
      maxht = delta;
    }
    yOf$1.cY(r$3, ((+yOf$1.i(((1 + r$3) | 0))) + delta));
    r$3 = ((r$3 - 1) | 0);
  }
  var res = false;
  var it = cls.o();
  while (((!res) && it.p())) {
    res = it.q().pv();
  }
  if ((res && $m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().jT(g))) {
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$__adjustRanks$1__D__I__I__sci_Vector__sr_DoubleRef__AD__sr_DoubleRef__AD__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__scm_Map__scm_Map__scm_Map__I__D__V($thiz, 8.0, minR, maxR, cls, rootHt1, clHt1$1, rootHt2, clHt2$1, g, yOf$1, ht2$1, ht1$1, (-1), 0.0);
    if ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$__exactRanksep__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__Z($thiz, g)) {
      maxht = 0.0;
      var prev = (+yOf$1.i(maxR));
      r$3 = ((maxR - 1) | 0);
      while ((r$3 >= minR)) {
        var cur = (+yOf$1.i(r$3));
        if (((cur - prev) > maxht)) {
          maxht = (cur - prev);
        }
        prev = cur;
        r$3 = ((r$3 - 1) | 0);
      }
    }
  }
  if ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$__exactRanksep__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__Z($thiz, g)) {
    r$3 = ((maxR - 1) | 0);
    while ((r$3 >= minR)) {
      yOf$1.cY(r$3, ((+yOf$1.i(((1 + r$3) | 0))) + maxht));
      r$3 = ((r$3 - 1) | 0);
    }
  }
  var shiftY = (rootHt1.T - (+ht1$1.i(maxR)));
  var $x_6 = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$9(yOf$1.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$4) => new $c_T2((x$1$4.g() | 0), ((+x$1$4.h()) + shiftY))))));
  var $x_5 = $m_sci_Map$().ao(ht1$1).a5g(0.0);
  var $x_4 = $m_sci_Map$().ao(ht2$1).a5g(0.0);
  var $x_3 = rootHt1.T;
  var $x_2 = rootHt2.T;
  var this$54 = $m_s_Predef$().ys(clHt1$1);
  var $x_1 = $m_sci_Vector$().X(this$54);
  var this$55 = $m_s_Predef$().ys(clHt2$1);
  return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo(ranks, $x_6, $x_5, $x_4, $x_3, $x_2, $x_1, $m_sci_Vector$().X(this$55));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$__labelVnodeWidthsImpl__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map($thiz, g) {
  var ranks = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().P0(g);
  var flip = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().jT(g);
  return $m_sci_Map$().ao(new $c_sc_Iterator$$anon$10(new $c_sc_Iterator$$anon$16(new $c_sc_Iterator$$anon$6(g.cu.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e) => (e.ai !== e.ak))), false)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var e$1 = x$1.g();
    var dIdx = (x$1.h() | 0);
    var this$4 = e$1.b4.ag.r("label");
    var this$7 = ((this$4.c() || (this$4.d() !== "")) ? this$4 : $m_s_None$());
    if (this$7.c()) {
      return $m_s_None$();
    } else {
      this$7.d();
      var this$8 = ranks.r(e$1.ai);
      if (this$8.c()) {
        return $m_s_None$();
      } else {
        var x0$2 = this$8.d();
        var rt = (x0$2 | 0);
        var this$10 = new $c_s_Option$WithFilter(ranks.r(e$1.ak), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((rh) => (rt !== (rh | 0)))));
        var this$11 = this$10.tu;
        var p$2 = this$10.tv;
        var this$12 = ((this$11.c() || (!(!p$2.i(this$11.d())))) ? this$11 : $m_s_None$());
        if (this$12.c()) {
          return $m_s_None$();
        } else {
          var x0$3 = this$12.d();
          var rh$2 = (x0$3 | 0);
          matchResult11: {
            var \u03b45$___1;
            var \u03b45$___2;
            var x26 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().tX(e$1, g);
            if ((x26 !== null)) {
              var \u03b45$___1 = (+x26.g());
              var \u03b45$___2 = (+x26.h());
              break matchResult11;
            }
            throw new $c_s_MatchError(x26);
          }
          var w$2 = (+\u03b45$___1);
          var h$2 = (+\u03b45$___2);
          var rw = (flip ? h$2 : w$2);
          var num = ((rt + rh$2) | 0);
          return new $c_s_Some(new $c_T2(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Virtual(dIdx, (((num + ((num >>> 31) | 0)) | 0) >> 1)).bE(), rw));
        }
      }
    }
  }))));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$__plain$1__T__D__T__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T2($thiz, lbl$1, fs$1, fn$1, g$6) {
  var $x_3 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$();
  var this$1 = g$6.j5;
  var $x_2 = $x_3.Xq(lbl$1, fs$1, fn$1, (this$1.c() ? "" : this$1.d()));
  var $x_1 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$();
  var this$2 = g$6.j5;
  return new $c_T2($x_2, $x_1.PC(lbl$1, fs$1, (this$2.c() ? "" : this$2.d())));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$__scanNode$1__scm_Map__sci_Map__sci_Vector__D__AD__AD__I__I__sr_DoubleRef__I__sr_DoubleRef__T__I__D__V($thiz, pht$1, clustOf$1, cls$1, ClOffset$1, clHt2$2, clHt1$2, minR$1, realMinR$1, rootHt2$2, maxR$1, rootHt1$2, name, r, h) {
  if ((h > (+pht$1.i(r)))) {
    pht$1.cY(r, h);
  }
  matchResult7: {
    var x14 = clustOf$1.r(name);
    if ((x14 instanceof $c_s_Some)) {
      var ci = (x14.J | 0);
      if (((r === cls$1.l(ci).jC) && ((h + ClOffset$1) > clHt2$2.a[ci]))) {
        clHt2$2.a[ci] = (h + ClOffset$1);
      }
      if (((r === cls$1.l(ci).l0) && ((h + ClOffset$1) > clHt1$2.a[ci]))) {
        clHt1$2.a[ci] = (h + ClOffset$1);
        break matchResult7;
      } else {
        break matchResult7;
      }
    }
    if (($m_s_None$() === x14)) {
      if ((((r === minR$1) || (r === realMinR$1)) && (h > rootHt2$2.T))) {
        rootHt2$2.T = h;
      }
      if (((r === maxR$1) && (h > rootHt1$2.T))) {
        rootHt1$2.T = h;
        break matchResult7;
      } else {
        break matchResult7;
      }
    }
    throw new $c_s_MatchError(x14);
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$__adjustSimple$1__sci_Vector__AD__scm_Map__scm_Map__AD__scm_Map__I__I__D__D__V($thiz, cls$14, clHt1$14, ht1$4, yOf$2, clHt2$14, ht2$4, minR$11, ci, delta, marginTotal) {
  var mnR2 = cls$14.l(ci).jC;
  var mxR2 = cls$14.l(ci).l0;
  var bottom = (0.5 * (delta + 1.0));
  var delbottom = ((clHt1$14.a[ci] + bottom) - ((+ht1$4.i(mxR2)) - marginTotal));
  var elem = 0;
  elem = mxR2;
  if ((delbottom > 0.0)) {
    while ((elem >= mnR2)) {
      var this$2 = yOf$2.r(elem);
      if ((!this$2.c())) {
        var x0 = this$2.d();
        var y = (+x0);
        yOf$2.cY(elem, (y + delbottom));
      }
      elem = ((elem - 1) | 0);
    }
  }
  var deltop = (((clHt2$14.a[ci] + (delta - bottom)) + ((delbottom > 0.0) ? delbottom : 0.0)) - ((+ht2$4.i(mnR2)) - marginTotal));
  if ((deltop > 0.0)) {
    elem = ((mnR2 - 1) | 0);
    while ((elem >= minR$11)) {
      var this$3 = yOf$2.r(elem);
      if ((!this$3.c())) {
        var x0$1 = this$3.d();
        var y$1 = (+x0$1);
        yOf$2.cY(elem, (y$1 + deltop));
      }
      elem = ((elem - 1) | 0);
    }
  }
  clHt2$14.a[ci] = (clHt2$14.a[ci] + (delta - bottom));
  clHt1$14.a[ci] = (clHt1$14.a[ci] + bottom);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$__adjustRanks$1__D__I__I__sci_Vector__sr_DoubleRef__AD__sr_DoubleRef__AD__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__scm_Map__scm_Map__scm_Map__I__D__V($thiz, ClOffset$13, minR$12, maxR$11, cls$15, rootHt1$12, clHt1$15, rootHt2$12, clHt2$15, g$17, yOf$5, ht2$5, ht1$5, ci, marginTotal) {
  var margin = ((ci < 0) ? 0.0 : ClOffset$13);
  if ((ci < 0)) {
    var \u03b43$___1 = minR$12;
    var \u03b43$___2 = maxR$11;
  } else {
    var \u03b43$___1 = cls$15.l(ci).jC;
    var \u03b43$___2 = cls$15.l(ci).l0;
  }
  var mnR2 = (\u03b43$___1 | 0);
  var mxR2 = (\u03b43$___2 | 0);
  var a1 = new $c_sr_DoubleRef(((ci < 0) ? rootHt1$12.T : clHt1$15.a[ci]));
  var a2 = new $c_sr_DoubleRef(((ci < 0) ? rootHt2$12.T : clHt2$15.a[ci]));
  $m_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$().qT(g$17, ci).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => {
    var cc = (v1 | 0);
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$__adjustRanks$1__D__I__I__sci_Vector__sr_DoubleRef__AD__sr_DoubleRef__AD__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__scm_Map__scm_Map__scm_Map__I__D__V($thiz, ClOffset$13, minR$12, maxR$11, cls$15, rootHt1$12, clHt1$15, rootHt2$12, clHt2$15, g$17, yOf$5, ht2$5, ht1$5, cc, (margin + marginTotal));
    if (((cls$15.l(cc).l0 === mxR2) && ((clHt1$15.a[cc] + margin) > a1.T))) {
      a1.T = (clHt1$15.a[cc] + margin);
    }
    if (((cls$15.l(cc).jC === mnR2) && ((clHt2$15.a[cc] + margin) > a2.T))) {
      a2.T = (clHt2$15.a[cc] + margin);
    }
  })));
  if ((ci < 0)) {
    rootHt1$12.T = a1.T;
    rootHt2$12.T = a2.T;
  } else {
    clHt1$15.a[ci] = a1.T;
    clHt2$15.a[ci] = a2.T;
  }
  if (((ci >= 0) && cls$15.l(ci).pv())) {
    var x = cls$15.l(ci).aMy(true);
    var y = cls$15.l(ci).aMz(true);
    var lht = (+Math.max(x, y));
    var rht = ((+yOf$5.i(mnR2)) - (+yOf$5.i(mxR2)));
    var delta = (lht - ((rht + a1.T) + a2.T));
    if ((delta > 0.0)) {
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$__adjustSimple$1__sci_Vector__AD__scm_Map__scm_Map__AD__scm_Map__I__I__D__D__V($thiz, cls$15, clHt1$15, ht1$5, yOf$5, clHt2$15, ht2$5, minR$12, ci, delta, marginTotal);
    }
  }
  if ((ci >= 0)) {
    if ((clHt2$15.a[ci] > (+ht2$5.i(mnR2)))) {
      ht2$5.cY(mnR2, clHt2$15.a[ci]);
    }
    if ((clHt1$15.a[ci] > (+ht1$5.i(mxR2)))) {
      ht1$5.cY(mxR2, clHt1$15.a[ci]);
    }
  }
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$() {
  this.au7 = 0.0;
  this.a7U = 0.0;
  this.ZJ = 0.0;
  this.au9 = null;
  this.au8 = null;
  $n_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$ = this;
  this.au7 = 72.0;
  this.a7U = 4.0;
  this.ZJ = 14.0;
  this.au9 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_GraphMemo();
  this.au8 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_GraphMemo();
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$.prototype = $p;
$p.a4p = (function(attrs) {
  var f = ((k) => attrs.ag.r(k));
  var this$1 = f("penwidth");
  if (this$1.c()) {
    var this$5 = $m_s_None$();
  } else {
    var x0 = this$1.d();
    var this$5 = ($m_sc_StringParsers$().c1(x0) ? new $c_s_Some($m_jl_Double$().bd(x0)) : $m_s_None$());
  }
  if (this$5.c()) {
    var this$6 = f("style");
    if (this$6.c()) {
      return $m_s_None$();
    } else {
      var x0$1 = this$6.d();
      var elem = $m_s_None$();
      var elem$1 = null;
      elem$1 = elem;
      var this$10 = new $c_sc_Iterator$$anon$9($m_sc_ArrayOps$().u8($f_T__split__T__I__AT(x0$1, ",", 0)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => $f_T__trim__T(_$2))));
      while (this$10.p()) {
        var x0$2 = this$10.q();
        if ((x0$2 === "bold")) {
          elem$1 = new $c_s_Some(2.0);
        } else if (((!(!x0$2.startsWith("setlinewidth("))) && (!(!x0$2.endsWith(")"))))) {
          var x$1 = $f_T__trim__T($m_sc_StringOps$().wh($m_sc_StringOps$().wg(x0$2, "setlinewidth("), ")"));
          var this$16 = $m_sc_StringParsers$();
          var this$17 = (this$16.c1(x$1) ? new $c_s_Some($m_jl_Double$().bd(x$1)) : $m_s_None$());
          elem$1 = (this$17.c() ? new $c_s_Some(0.0) : this$17);
        }
      }
      return elem$1;
    }
  } else {
    return this$5;
  }
});
$p.ah6 = (function(g) {
  matchResult1: {
    var $x_1;
    var this$2 = g.f2.ag.r("nodesep");
    if (this$2.c()) {
      var x1 = $m_s_None$();
    } else {
      var x0 = this$2.d();
      var x1 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$__leadingDouble__T__s_Option($m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$(), x0);
    }
    if ((x1 instanceof $c_s_Some)) {
      var x = (+x1.J);
      var $x_1 = (+Math.max(0.02, x));
      break matchResult1;
    }
    if (($m_s_None$() === x1)) {
      var $x_1 = 0.25;
      break matchResult1;
    }
    throw new $c_s_MatchError(x1);
  }
  return $p_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$__points__D__D(this, $x_1);
});
$p.aTm = (function(g) {
  var num = $doubleToInt(this.ah6(g));
  return (1.0 + (((num + ((num >>> 31) | 0)) | 0) >> 1));
});
$p.ahY = (function(e, g) {
  var tp = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$__gvPortOf__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T__s_Option__Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort(this, g, e.ai, e.ka);
  var hp = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$__gvPortOf__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T__s_Option__Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort(this, g, e.ak, e.k9);
  if ((!(((!tp.o1) && (!hp.o1)) || ((((8 & tp.fV) === 0) && ((8 & hp.fV) === 0)) && ((tp.fV !== hp.fV) || ((5 & tp.fV) === 0)))))) {
    return 0.0;
  } else {
    var this$2 = e.b4.ag.r("label");
    var this$5 = ((this$2.c() || (this$2.d() !== "")) ? this$2 : $m_s_None$());
    if (this$5.c()) {
      var this$7 = $m_s_None$();
    } else {
      this$5.d();
      matchResult2: {
        var \u03b41$___1;
        var \u03b41$___2;
        var x4 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().tX(e, g);
        if ((x4 !== null)) {
          var \u03b41$___1 = (+x4.g());
          var \u03b41$___2 = (+x4.h());
          break matchResult2;
        }
        throw new $c_s_MatchError(x4);
      }
      var w$2 = (+\u03b41$___1);
      var h$2 = (+\u03b41$___2);
      var this$7 = new $c_s_Some(($m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().jT(g) ? h$2 : w$2));
    }
    return (18.0 + (+(this$7.c() ? 0.0 : this$7.d())));
  }
});
$p.aRk = (function(g) {
  matchResult3: {
    var $x_1;
    var this$2 = g.f2.ag.r("ranksep");
    if (this$2.c()) {
      var x7 = $m_s_None$();
    } else {
      var x0 = this$2.d();
      var x7 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$__leadingDouble__T__s_Option($m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$(), x0);
    }
    if ((x7 instanceof $c_s_Some)) {
      var x = (+x7.J);
      var $x_1 = (+Math.max(0.02, x));
      break matchResult3;
    }
    if (($m_s_None$() === x7)) {
      var $x_1 = 0.5;
      break matchResult3;
    }
    throw new $c_s_MatchError(x7);
  }
  return $p_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$__points__D__D(this, $x_1);
});
$p.b1X = (function(g) {
  return $doubleToInt($p_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$__rankSep__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D(this, g));
});
$p.tX = (function(e, g) {
  var lbl = e.b4.dL("label", "");
  var this$2 = e.b4.ag.r("fontsize");
  if (this$2.c()) {
    var this$6 = $m_s_None$();
  } else {
    var x0 = this$2.d();
    var this$6 = ($m_sc_StringParsers$().c1(x0) ? new $c_s_Some($m_jl_Double$().bd(x0)) : $m_s_None$());
  }
  var fs = (+(this$6.c() ? $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().ZJ : this$6.d()));
  var fn = e.b4.dL("fontname", "Times");
  if (e.b4.n7.E("label")) {
    var this$8 = $m_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$().mU(lbl);
    var this$9 = (this$8.c() ? $m_s_None$() : new $c_s_Some($m_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$().PU(this$8.d(), fs, fn, g.mj)));
    return (this$9.c() ? $p_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$__plain$1__T__D__T__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T2(this, lbl, fs, fn, g) : this$9.d());
  } else {
    return $p_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$__plain$1__T__D__T__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T2(this, lbl, fs, fn, g);
  }
});
$p.PL = (function(g) {
  var yi = this.a5m(g);
  return new $c_T2(yi.KM, yi.Bh);
});
$p.a5m = (function(g) {
  var this$1 = this.au9;
  if ((g === this$1.f0)) {
    var $x_1 = this$1.f1;
  } else {
    var v = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$__yInfoImpl__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo($m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$(), g);
    this$1.f0 = g;
    this$1.f1 = v;
    var $x_1 = v;
  }
  return $x_1;
});
$p.aP0 = (function(g) {
  var this$2 = g.f2.ag.r("label");
  var this$5 = ((this$2.c() || (this$2.d() !== "")) ? this$2 : $m_s_None$());
  if (this$5.c()) {
    var this$13 = $m_s_None$();
  } else {
    var x0$1 = this$5.d();
    var this$7 = g.f2.ag.r("fontsize");
    if (this$7.c()) {
      var this$11 = $m_s_None$();
    } else {
      var x0$2 = this$7.d();
      var this$11 = ($m_sc_StringParsers$().c1(x0$2) ? new $c_s_Some($m_jl_Double$().bd(x0$2)) : $m_s_None$());
    }
    var fs = (+(this$11.c() ? $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().ZJ : this$11.d()));
    var $x_1 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$();
    var this$12 = g.j5;
    var this$13 = new $c_s_Some(($x_1.PC(x0$1, fs, (this$12.c() ? "" : this$12.d())) + (2.0 * $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().a7U)));
  }
  return (+(this$13.c() ? 0.0 : this$13.d()));
});
$p.agk = (function(g) {
  var this$2 = g.f2.ag.r("labelloc");
  if ((!this$2.c())) {
    var x0 = this$2.d();
    return (!(!x0.startsWith("t")));
  } else {
    return false;
  }
});
$p.b2e = (function(g) {
  var this$2 = g.f2.ag.r("label");
  var this$5 = ((this$2.c() || (this$2.d() !== "")) ? this$2 : $m_s_None$());
  if (this$5.c()) {
    var this$13 = $m_s_None$();
  } else {
    var x0$1 = this$5.d();
    var this$7 = g.f2.ag.r("fontsize");
    if (this$7.c()) {
      var this$11 = $m_s_None$();
    } else {
      var x0$2 = this$7.d();
      var this$11 = ($m_sc_StringParsers$().c1(x0$2) ? new $c_s_Some($m_jl_Double$().bd(x0$2)) : $m_s_None$());
    }
    var fs = (+(this$11.c() ? $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().ZJ : this$11.d()));
    var fn = g.f2.dL("fontname", "Times");
    var $x_1 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$();
    var this$12 = g.j5;
    var this$13 = new $c_s_Some(($x_1.Xq(x0$1, fs, fn, (this$12.c() ? "" : this$12.d())) + (4.0 * $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().a7U)));
  }
  return (+(this$13.c() ? 0.0 : this$13.d()));
});
$p.agP = (function(g) {
  var this$1 = this.au8;
  if ((g === this$1.f0)) {
    var $x_1 = this$1.f1;
  } else {
    var v = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$__labelVnodeWidthsImpl__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map($m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$(), g);
    this$1.f0 = g;
    this$1.f1 = v;
    var $x_1 = v;
  }
  return $x_1;
});
$p.a3o = (function(e, g) {
  matchResult12: {
    var \u03b46$___1;
    var \u03b46$___2;
    var x29 = this.tX(e, g);
    if ((x29 !== null)) {
      var \u03b46$___1 = (+x29.g());
      var \u03b46$___2 = (+x29.h());
      break matchResult12;
    }
    throw new $c_s_MatchError(x29);
  }
  var w$2 = (+\u03b46$___1);
  var h$2 = (+\u03b46$___2);
  if ($m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().jT(g)) {
    var \u03b47$___1 = h$2;
    var \u03b47$___2 = w$2;
  } else {
    var \u03b47$___1 = w$2;
    var \u03b47$___2 = h$2;
  }
  return new $c_T2((0.5 * (+\u03b47$___1)), (+\u03b47$___2));
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$, "org.jpablo.graphexplorer.graphviz.layout.Coord$", ({
  uG: 1
}));
var $n_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$;
function $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$() {
  if ((!$n_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$)) {
    $n_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$ = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$();
  }
  return $n_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_DrawTransform$__ofImpl__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__F2($thiz, g) {
  var rd = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().pD(g);
  var x$2 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__TB__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
  if (((rd === null) ? (x$2 === null) : (rd === x$2))) {
    return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((x$3, y) => new $c_T2((+x$3), (+y))));
  } else {
    matchResult2: {
      var \u03b41$___1;
      var \u03b41$___2;
      var \u03b41$___3;
      var \u03b41$___4;
      var x2 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$().Wm(g);
      if ((x2 !== null)) {
        var \u03b41$___1 = (+x2.bO);
        var \u03b41$___2 = (+x2.bs);
        var \u03b41$___3 = (+x2.ch);
        var \u03b41$___4 = (+x2.ca);
        break matchResult2;
      }
      throw new $c_s_MatchError(x2);
    }
    var llx$2 = (+\u03b41$___1);
    var lly$2 = (+\u03b41$___2);
    var ury$2 = (+\u03b41$___4);
    matchResult3: {
      var \u03b42$___1;
      var \u03b42$___2;
      var x$4 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__LR__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
      if (((x$4 === null) ? (rd === null) : (x$4 === rd))) {
        var \u03b42$___1 = (-ury$2);
        var \u03b42$___2 = llx$2;
        break matchResult3;
      }
      var x$6 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__BT__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
      if (((x$6 === null) ? (rd === null) : (x$6 === rd))) {
        var \u03b42$___1 = llx$2;
        var \u03b42$___2 = (-ury$2);
        break matchResult3;
      }
      var x$8 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__RL__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
      if (((x$8 === null) ? (rd === null) : (x$8 === rd))) {
        var \u03b42$___1 = lly$2;
        var \u03b42$___2 = llx$2;
        break matchResult3;
      }
      var x$10 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__TB__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
      if (((x$10 === null) ? (rd === null) : (x$10 === rd))) {
        var \u03b42$___1 = llx$2;
        var \u03b42$___2 = lly$2;
        break matchResult3;
      }
      throw new $c_s_MatchError(rd);
    }
    return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((ox, oy) => ((x$12, y$2) => {
      var x$1 = (+x$12);
      var y$3 = (+y$2);
      matchResult4: {
        var \u03b43$___1;
        var \u03b43$___2;
        var x8 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_DrawTransform$__ccw$1__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir__D__D__T2($thiz, rd, x$1, y$3);
        if ((x8 !== null)) {
          var \u03b43$___1 = (+x8.g());
          var \u03b43$___2 = (+x8.h());
          break matchResult4;
        }
        throw new $c_s_MatchError(x8);
      }
      return new $c_T2(((+\u03b43$___1) - ox), ((+\u03b43$___2) - oy));
    }))((+\u03b42$___1), (+\u03b42$___2)));
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_DrawTransform$__ccw$1__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir__D__D__T2($thiz, rd$1, x, y) {
  var x$2 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__LR__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
  if (((x$2 === null) ? (rd$1 === null) : (x$2 === rd$1))) {
    return new $c_T2((-y), x);
  }
  var x$4 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__BT__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
  if (((x$4 === null) ? (rd$1 === null) : (x$4 === rd$1))) {
    return new $c_T2(x, (-y));
  }
  var x$6 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__RL__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
  if (((x$6 === null) ? (rd$1 === null) : (x$6 === rd$1))) {
    return new $c_T2(y, x);
  }
  var x$8 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__TB__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
  if (((x$8 === null) ? (rd$1 === null) : (x$8 === rd$1))) {
    return new $c_T2(x, y);
  }
  throw new $c_s_MatchError(rd$1);
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_DrawTransform$() {
  this.aua = null;
  $n_Lorg_jpablo_graphexplorer_graphviz_layout_DrawTransform$ = this;
  this.aua = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_GraphMemo();
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_DrawTransform$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_DrawTransform$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_DrawTransform$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_DrawTransform$.prototype = $p;
$p.ahL = (function(g) {
  var x = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().pD(g);
  var x$2 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__TB__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
  return (!((x === null) ? (x$2 === null) : (x === x$2)));
});
$p.aha = (function(g) {
  var this$1 = this.aua;
  if ((g === this$1.f0)) {
    var $x_1 = this$1.f1;
  } else {
    var v = $p_Lorg_jpablo_graphexplorer_graphviz_layout_DrawTransform$__ofImpl__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__F2($m_Lorg_jpablo_graphexplorer_graphviz_layout_DrawTransform$(), g);
    this$1.f0 = g;
    this$1.f1 = v;
    var $x_1 = v;
  }
  return $x_1;
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_DrawTransform$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_DrawTransform$, "org.jpablo.graphexplorer.graphviz.layout.DrawTransform$", ({
  uH: 1
}));
var $n_Lorg_jpablo_graphexplorer_graphviz_layout_DrawTransform$;
function $m_Lorg_jpablo_graphexplorer_graphviz_layout_DrawTransform$() {
  if ((!$n_Lorg_jpablo_graphexplorer_graphviz_layout_DrawTransform$)) {
    $n_Lorg_jpablo_graphexplorer_graphviz_layout_DrawTransform$ = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_DrawTransform$();
  }
  return $n_Lorg_jpablo_graphexplorer_graphviz_layout_DrawTransform$;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$__ptToLine2__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__D($thiz, a, b, p) {
  var dx = (b.W - a.W);
  var dy = (b.a6 - a.a6);
  var a2 = (((p.a6 - a.a6) * dx) - ((p.W - a.W) * dy));
  a2 = (a2 * a2);
  return ((a2 < 1.0E-6) ? 0.0 : (a2 / ((dx * dx) + (dy * dy))));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$__flatEnough__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Z($thiz, cp) {
  return (($p_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$__ptToLine2__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__D($thiz, cp.a[0], cp.a[3], cp.a[1]) < $thiz.a7V) && ($p_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$__ptToLine2__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__D($thiz, cp.a[0], cp.a[3], cp.a[2]) < $thiz.a7V));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$__bezierSplit__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__T2($thiz, cp) {
  var m01 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$__mid$1__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($thiz, cp.a[0], cp.a[1]);
  var m12 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$__mid$1__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($thiz, cp.a[1], cp.a[2]);
  var m23 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$__mid$1__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($thiz, cp.a[2], cp.a[3]);
  var mA = $p_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$__mid$1__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($thiz, m01, m12);
  var mB = $p_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$__mid$1__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($thiz, m12, m23);
  var c = $p_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$__mid$1__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($thiz, mA, mB);
  return new $c_T2(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY.r().C)([cp.a[0], m01, mA, c]), new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY.r().C)([c, mB, m23, cp.a[3]]));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$__updateBBbz__AD__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__V($thiz, bb, cp) {
  var cp$tailLocal1 = cp;
  while (true) {
    var xs = cp$tailLocal1;
    _return$1: {
      var i = 0;
      while ((i < xs.a.length)) {
        var x1 = i;
        var x0 = xs.a[x1];
        if (((((x0.W > bb.a[2]) || (x0.W < bb.a[0])) || (x0.a6 > bb.a[3])) || (x0.a6 < bb.a[1]))) {
          var $x_1 = i;
          break _return$1;
        }
        i = ((1 + i) | 0);
      }
      var $x_1 = (-1);
    }
    if (($x_1 >= 0)) {
      if ($p_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$__flatEnough__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Z($thiz, cp$tailLocal1)) {
        var xs$1 = cp$tailLocal1;
        var f = ((bb) => ((p$2) => {
          if ((p$2.W > bb.a[2])) {
            bb.a[2] = p$2.W;
          } else if ((p$2.W < bb.a[0])) {
            bb.a[0] = p$2.W;
          }
          if ((p$2.a6 > bb.a[3])) {
            bb.a[3] = p$2.a6;
          } else if ((p$2.a6 < bb.a[1])) {
            bb.a[1] = p$2.a6;
          }
        }))(bb);
        var len = xs$1.a.length;
        var i$1 = 0;
        if ((xs$1 !== null)) {
          while ((i$1 < len)) {
            var x0$1 = xs$1.a[i$1];
            f(x0$1);
            i$1 = ((1 + i$1) | 0);
          }
          return (void 0);
        } else if ((xs$1 instanceof $ac_I)) {
          while ((i$1 < len)) {
            var x0$2 = xs$1.a[i$1];
            f(x0$2);
            i$1 = ((1 + i$1) | 0);
          }
          return (void 0);
        } else if ((xs$1 instanceof $ac_D)) {
          while ((i$1 < len)) {
            var x0$3 = xs$1.a[i$1];
            f(x0$3);
            i$1 = ((1 + i$1) | 0);
          }
          return (void 0);
        } else if ((xs$1 instanceof $ac_J)) {
          while ((i$1 < len)) {
            var $x_2 = xs$1.a;
            var $x_3 = (i$1 << 1);
            var x0$4_$_lo = $x_2[$x_3];
            var x0$4_$_hi = $x_2[(($x_3 + 1) | 0)];
            f($bL(x0$4_$_lo, x0$4_$_hi));
            i$1 = ((1 + i$1) | 0);
          }
          return (void 0);
        } else if ((xs$1 instanceof $ac_F)) {
          while ((i$1 < len)) {
            var x0$5 = xs$1.a[i$1];
            f(x0$5);
            i$1 = ((1 + i$1) | 0);
          }
          return (void 0);
        } else if ((xs$1 instanceof $ac_C)) {
          while ((i$1 < len)) {
            var x0$6 = xs$1.a[i$1];
            f($bC(x0$6));
            i$1 = ((1 + i$1) | 0);
          }
          return (void 0);
        } else if ((xs$1 instanceof $ac_B)) {
          while ((i$1 < len)) {
            var x0$7 = xs$1.a[i$1];
            f(x0$7);
            i$1 = ((1 + i$1) | 0);
          }
          return (void 0);
        } else if ((xs$1 instanceof $ac_S)) {
          while ((i$1 < len)) {
            var x0$8 = xs$1.a[i$1];
            f(x0$8);
            i$1 = ((1 + i$1) | 0);
          }
          return (void 0);
        } else if ((xs$1 instanceof $ac_Z)) {
          while ((i$1 < len)) {
            var x0$9 = xs$1.a[i$1];
            f(x0$9);
            i$1 = ((1 + i$1) | 0);
          }
          return (void 0);
        } else {
          throw new $c_s_MatchError(xs$1);
        }
      } else {
        matchResult1: {
          var \u03b41$___1;
          var \u03b41$___2;
          var x1$1 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$__bezierSplit__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__T2($thiz, cp$tailLocal1);
          if ((x1$1 !== null)) {
            var \u03b41$___1 = x1$1.g();
            var \u03b41$___2 = x1$1.h();
            break matchResult1;
          }
          throw new $c_s_MatchError(x1$1);
        }
        var l$2 = \u03b41$___1;
        var r$2 = \u03b41$___2;
        $p_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$__updateBBbz__AD__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__V($thiz, bb, l$2);
        cp$tailLocal1 = r$2;
      }
    } else {
      return (void 0);
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$__growBySplines__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D__D__D__D__T4($thiz, g, minX, minY, maxX, maxY) {
  var spls = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$().a4K(g);
  if (spls.c()) {
    return new $c_T4(minX, minY, maxX, maxY);
  } else {
    var bb = new $ac_D(new Float64Array([minX, minY, maxX, maxY]));
    var this$2 = spls.hr();
    while (this$2.p()) {
      var x0 = this$2.q();
      var pts = x0.wM;
      var i = 0;
      while ((((3 + i) | 0) < pts.C())) {
        $p_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$__updateBBbz__AD__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__V($m_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$(), bb, new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY.r().C)([pts.l(i), pts.l(((1 + i) | 0)), pts.l(((2 + i) | 0)), pts.l(((3 + i) | 0))]));
        i = ((3 + i) | 0);
      }
    }
    return new $c_T4(bb.a[0], bb.a[1], bb.a[2], bb.a[3]);
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$__bboxImpl__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T4($thiz, g) {
  matchResult2: {
    var yOf$2;
    var x4 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().PL(g);
    if ((x4 !== null)) {
      var yOf$2 = x4.h();
      break matchResult2;
    }
    throw new $c_s_MatchError(x4);
  }
  var ranks = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().P0(g);
  var minX = new $c_sr_DoubleRef(1.7976931348623157E308);
  var maxX = new $c_sr_DoubleRef((-1.7976931348623157E308));
  var minY = new $c_sr_DoubleRef(1.7976931348623157E308);
  var maxY = new $c_sr_DoubleRef((-1.7976931348623157E308));
  var xs = $m_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$().a5k(g);
  var $x_1 = $m_sci_Map$();
  var this$6 = g.cu.d8(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e) => (e.ai === e.ak))), false);
  var m = $m_scm_Map$().aO();
  var it = this$6.o();
  while (it.p()) {
    var elem = it.q();
    var key = elem.ai;
    m.ec(key, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      $m_sci_Vector$();
      return new $c_sci_VectorBuilder();
    }))).Y(elem);
  }
  var result = $m_sci_HashMap$().fk;
  var mapIt = m.o();
  while (mapIt.p()) {
    var x1 = mapIt.q();
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1);
    }
    var k = x1.g();
    var v = x1.h();
    result = result.hq(k, v.aR());
  }
  var selfLoops = $x_1.ao(new $c_sc_MapView$MapValues(new $c_sc_MapView$Id(result), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => (+_$2.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3) => $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().ahY(_$3, g)))).k2($m_s_math_Numeric$DoubleIsFractional$()))))));
  g.cB.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n) => {
    var this$13 = xs.r(n.br);
    if ((!this$13.c())) {
      var x0 = this$13.d();
      var xPt = (+x0);
      var this$14 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().J9(n, g);
      if ((!this$14.c())) {
        var x0$1 = this$14.d();
        var x$proxy2 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().X5(x0$1);
        var x$proxy3 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().X4(x0$1);
        var selfW = (+selfLoops.ay(n.br, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 0.0))));
        var x$proxy4 = (+yOf$2.i(ranks.i(n.br)));
        var x = minX.T;
        var y = (xPt - x$proxy2);
        minX.T = (+Math.min(x, y));
        var x$1 = maxX.T;
        var y$1 = ((xPt + x$proxy2) + selfW);
        maxX.T = (+Math.max(x$1, y$1));
        var x$2 = minY.T;
        var y$2 = (x$proxy4 - x$proxy3);
        minY.T = (+Math.min(x$2, y$2));
        var x$3 = maxY.T;
        var y$3 = (x$proxy4 + x$proxy3);
        maxY.T = (+Math.max(x$3, y$3));
      }
    }
  })));
  var lps = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$().a43(g);
  if ((!lps.c())) {
    var realEdges = g.cu.d8(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$2) => (e$2.ai !== e$2.ak))), false);
    lps.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$1) => {
      var idx = (x$1$1.g() | 0);
      var p = x$1$1.h();
      var this$25 = new $c_s_PartialFunction$Lifted(realEdges).as(idx);
      if (this$25.c()) {
        var $x_2 = true;
      } else {
        var x0$2 = this$25.d();
        var x$4 = ranks.r(x0$2.ai);
        var x$2$1 = ranks.r(x0$2.ak);
        var $x_2 = (!((x$4 === null) ? (x$2$1 === null) : x$4.e(x$2$1)));
      }
      if ($x_2) {
        var this$26 = this$25;
      } else {
        var this$26 = $m_s_None$();
      }
      if ((!this$26.c())) {
        var x0$3 = this$26.d();
        matchResult3: {
          var \u03b43$___1;
          var \u03b43$___2;
          var x7 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().tX(x0$3, g);
          if ((x7 !== null)) {
            var \u03b43$___1 = (+x7.g());
            var \u03b43$___2 = (+x7.h());
            break matchResult3;
          }
          throw new $c_s_MatchError(x7);
        }
        var w0$2 = (+\u03b43$___1);
        var h0$2 = (+\u03b43$___2);
        if ($m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().jT(g)) {
          var \u03b44$___1 = h0$2;
          var \u03b44$___2 = w0$2;
        } else {
          var \u03b44$___1 = w0$2;
          var \u03b44$___2 = h0$2;
        }
        var wl = (+\u03b44$___1);
        var hl = (+\u03b44$___2);
        var x$5 = minX.T;
        var y$4 = (p.W - (0.5 * wl));
        minX.T = (+Math.min(x$5, y$4));
        var x$6 = maxX.T;
        var y$5 = (p.W + (0.5 * wl));
        maxX.T = (+Math.max(x$6, y$5));
        var x$7 = minY.T;
        var y$6 = (p.a6 - (0.5 * hl));
        minY.T = (+Math.min(x$7, y$6));
        var x$8 = maxY.T;
        var y$7 = (p.a6 + (0.5 * hl));
        maxY.T = (+Math.max(x$8, y$7));
      }
    })));
  }
  if ((!$f_sc_SeqOps__isEmpty__Z($m_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$().tV(g)))) {
    var cbbs = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$().a2N(g);
    $m_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$().qT(g, (-1)).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => {
      var i = (v1 | 0);
      var x$10 = minX.T;
      var y$8 = (cbbs.l(i).nW - 8.0);
      minX.T = (+Math.min(x$10, y$8));
      var x$11 = maxX.T;
      var y$9 = (cbbs.l(i).nX + 8.0);
      maxX.T = (+Math.max(x$11, y$9));
    })));
  }
  if ((!ranks.c())) {
    var yi = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().a5m(g);
    var spanMin = (yi.Bh.J8().lr($m_s_math_Ordering$Int$()) | 0);
    var spanMax = (yi.Bh.J8().lq($m_s_math_Ordering$Int$()) | 0);
    var x$12 = minY.T;
    var x$proxy5 = (+yOf$2.i(spanMax));
    var y$10 = (x$proxy5 - yi.KN);
    minY.T = (+Math.min(x$12, y$10));
    var x$13 = maxY.T;
    var x$proxy6 = (+yOf$2.i(spanMin));
    var y$11 = (x$proxy6 + yi.KO);
    maxY.T = (+Math.max(x$13, y$11));
  }
  matchResult4: {
    var \u03b42$___1;
    var \u03b42$___2;
    var \u03b42$___3;
    var \u03b42$___4;
    var x10 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$__growBySplines__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D__D__D__D__T4($thiz, g, minX.T, minY.T, maxX.T, maxY.T);
    if ((x10 !== null)) {
      var \u03b42$___1 = (+x10.bO);
      var \u03b42$___2 = (+x10.bs);
      var \u03b42$___3 = (+x10.ch);
      var \u03b42$___4 = (+x10.ca);
      break matchResult4;
    }
    throw new $c_s_MatchError(x10);
  }
  var gx0$2 = (+\u03b42$___1);
  var gy0$2 = (+\u03b42$___2);
  var gx1$2 = (+\u03b42$___3);
  var gy1$2 = (+\u03b42$___4);
  minX.T = gx0$2;
  minY.T = gy0$2;
  maxX.T = gx1$2;
  maxY.T = gy1$2;
  var xl = $m_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$().a4q(g);
  var this$49 = xl.Fr.hr().lS(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => xl.Fq.hr())));
  while (this$49.p()) {
    var x0$4 = this$49.q();
    if ($m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().jT(g)) {
      var \u03b45$___1 = x0$4.Bz;
      var \u03b45$___2 = x0$4.BA;
    } else {
      var \u03b45$___1 = x0$4.BA;
      var \u03b45$___2 = x0$4.Bz;
    }
    var w = (+\u03b45$___1);
    var h = (+\u03b45$___2);
    var x$14 = minX.T;
    var y$12 = (x0$4.uD - (0.5 * w));
    minX.T = (+Math.min(x$14, y$12));
    var x$15 = maxX.T;
    var y$13 = (x0$4.uD + (0.5 * w));
    maxX.T = (+Math.max(x$15, y$13));
    var x$16 = minY.T;
    var y$14 = (x0$4.uE - (0.5 * h));
    minY.T = (+Math.min(x$16, y$14));
    var x$17 = maxY.T;
    var y$15 = (x0$4.uE + (0.5 * h));
    maxY.T = (+Math.max(x$17, y$15));
  }
  var padY = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().aP0(g);
  if ((padY > 0.0)) {
    var lblW = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().b2e(g);
    var top = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().agk(g);
    if ($m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().jT(g)) {
      if (top) {
        maxX.T = (maxX.T + padY);
      } else {
        minX.T = (minX.T - padY);
      }
      if ((lblW > (maxY.T - minY.T))) {
        var diff = (0.5 * (lblW - (maxY.T - minY.T)));
        minY.T = (minY.T - diff);
        maxY.T = (maxY.T + diff);
      }
    } else {
      var x$19 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().pD(g);
      var x$2$2 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__TB__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
      var tb = ((x$19 === null) ? (x$2$2 === null) : (x$19 === x$2$2));
      if (top) {
        if (tb) {
          maxY.T = (maxY.T + padY);
        } else {
          minY.T = (minY.T - padY);
        }
      } else if (tb) {
        minY.T = (minY.T - padY);
      } else {
        maxY.T = (maxY.T + padY);
      }
      if ((lblW > (maxX.T - minX.T))) {
        var diff$2 = (0.5 * (lblW - (maxX.T - minX.T)));
        minX.T = (minX.T - diff$2);
        maxX.T = (maxX.T + diff$2);
      }
    }
  }
  return (((minX.T > maxX.T) || (minY.T > maxY.T)) ? new $c_T4(0.0, 0.0, 0.0, 0.0) : new $c_T4($p_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$__snap$1__D__D($thiz, minX.T), $p_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$__snap$1__D__D($thiz, minY.T), $p_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$__snap$1__D__D($thiz, maxX.T), $p_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$__snap$1__D__D($thiz, maxY.T)));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$__mid$1__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($thiz, a, b) {
  return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY((0.5 * (a.W + b.W)), (0.5 * (a.a6 + b.a6)));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$__snap$1__D__D($thiz, v) {
  var r = $m_jl_Math$().b7X(v);
  var x = (v - r);
  if (((+Math.abs(x)) < 1.0E-6)) {
    return r;
  } else {
    return v;
  }
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$() {
  this.a7V = 0.0;
  this.aub = null;
  $n_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$ = this;
  this.a7V = 4.0;
  this.aub = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_GraphMemo();
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$.prototype = $p;
$p.Wm = (function(g) {
  var this$1 = this.aub;
  if ((g === this$1.f0)) {
    var $x_1 = this$1.f1;
  } else {
    var v = $p_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$__bboxImpl__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T4($m_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$(), g);
    this$1.f0 = g;
    this$1.f1 = v;
    var $x_1 = v;
  }
  return $x_1;
});
$p.afN = (function(g) {
  matchResult5: {
    var \u03b46$___1;
    var \u03b46$___2;
    var \u03b46$___3;
    var \u03b46$___4;
    var x15 = this.Wm(g);
    if ((x15 !== null)) {
      var \u03b46$___1 = (+x15.bO);
      var \u03b46$___2 = (+x15.bs);
      var \u03b46$___3 = (+x15.ch);
      var \u03b46$___4 = (+x15.ca);
      break matchResult5;
    }
    throw new $c_s_MatchError(x15);
  }
  var llx$2 = (+\u03b46$___1);
  var lly$2 = (+\u03b46$___2);
  var urx$2 = (+\u03b46$___3);
  var ury$2 = (+\u03b46$___4);
  var tf = $m_Lorg_jpablo_graphexplorer_graphviz_layout_DrawTransform$().aha(g);
  matchResult6: {
    var \u03b47$___1;
    var \u03b47$___2;
    var x20 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().pD(g);
    matchAlts1: {
      matchAlts2: {
        var x = $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__LR__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
        if (((x === null) ? (x20 === null) : (x === x20))) {
          break matchAlts2;
        }
        var x$3 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__BT__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
        if (((x$3 === null) ? (x20 === null) : (x$3 === x20))) {
          break matchAlts2;
        }
        break matchAlts1;
      }
      var \u03b47$___1 = tf.R(llx$2, ury$2);
      var \u03b47$___2 = tf.R(urx$2, lly$2);
      break matchResult6;
    }
    var \u03b47$___1 = tf.R(llx$2, lly$2);
    var \u03b47$___2 = tf.R(urx$2, ury$2);
  }
  var ll = \u03b47$___1;
  var ur = \u03b47$___2;
  return new $c_T4(ll.g(), ll.h(), ur.g(), ur.h());
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$, "org.jpablo.graphexplorer.graphviz.layout.GraphBB$", ({
  uI: 1
}));
var $n_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$;
function $m_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$() {
  if ((!$n_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$)) {
    $n_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$ = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$();
  }
  return $n_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_GraphMemo() {
  this.f0 = null;
  this.f1 = null;
  this.f0 = null;
  this.f1 = null;
  $m_Lorg_jpablo_graphexplorer_graphviz_layout_GraphMemo$().b5o(this);
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_GraphMemo.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_GraphMemo;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_GraphMemo() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_GraphMemo.prototype = $p;
$p.ie = (function() {
  this.f0 = null;
  this.f1 = null;
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_GraphMemo = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_GraphMemo, "org.jpablo.graphexplorer.graphviz.layout.GraphMemo", ({
  uJ: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_GraphMemo$() {
  this.a7W = null;
  $n_Lorg_jpablo_graphexplorer_graphviz_layout_GraphMemo$ = this;
  this.a7W = ($m_scm_ArrayBuffer$(), $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer()));
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_GraphMemo$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_GraphMemo$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_GraphMemo$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_GraphMemo$.prototype = $p;
$p.b5o = (function(m) {
  this.a7W.aw(m);
});
$p.aYl = (function() {
  var this$1 = this.a7W;
  var it = this$1.bB().o();
  while (it.p()) {
    it.q().ie();
  }
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_GraphMemo$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_GraphMemo$, "org.jpablo.graphexplorer.graphviz.layout.GraphMemo$", ({
  uK: 1
}));
var $n_Lorg_jpablo_graphexplorer_graphviz_layout_GraphMemo$;
function $m_Lorg_jpablo_graphexplorer_graphviz_layout_GraphMemo$() {
  if ((!$n_Lorg_jpablo_graphexplorer_graphviz_layout_GraphMemo$)) {
    $n_Lorg_jpablo_graphexplorer_graphviz_layout_GraphMemo$ = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_GraphMemo$();
  }
  return $n_Lorg_jpablo_graphexplorer_graphviz_layout_GraphMemo$;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_MuslSort$__cycle$1__AI__AI__I__V($thiz, a$1, ar$1, cnt) {
  if ((cnt >= 2)) {
    var tmp = a$1.a[ar$1.a[0]];
    var i = 0;
    while ((i < ((cnt - 1) | 0))) {
      a$1.a[ar$1.a[i]] = a$1.a[ar$1.a[((1 + i) | 0)]];
      i = ((1 + i) | 0);
    }
    a$1.a[ar$1.a[((cnt - 1) | 0)]] = tmp;
  }
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_MuslSort$() {
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_MuslSort$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_MuslSort$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_MuslSort$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_MuslSort$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_MuslSort$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_MuslSort$, "org.jpablo.graphexplorer.graphviz.layout.MuslSort$", ({
  uM: 1
}));
var $n_Lorg_jpablo_graphexplorer_graphviz_layout_MuslSort$;
function $m_Lorg_jpablo_graphexplorer_graphviz_layout_MuslSort$() {
  if ((!$n_Lorg_jpablo_graphexplorer_graphviz_layout_MuslSort$)) {
    $n_Lorg_jpablo_graphexplorer_graphviz_layout_MuslSort$ = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_MuslSort$();
  }
  return $n_Lorg_jpablo_graphexplorer_graphviz_layout_MuslSort$;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__addTreeEdge$1__AI__scm_ArrayBuffer__Ascm_ArrayBuffer__AI__Ascm_ArrayBuffer__AI__I__V($thiz, treeIndex$1, treeEdge$1, treeOut$1, etail$1, treeIn$1, ehead$1, e) {
  treeIndex$1.a[e] = treeEdge$1.a1;
  treeEdge$1.aw(e);
  treeOut$1.a[etail$1.a[e]].aw(e);
  treeIn$1.a[ehead$1.a[e]].aw(e);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__exchangeTreeEdges$1__AI__scm_ArrayBuffer__Ascm_ArrayBuffer__AI__Ascm_ArrayBuffer__AI__I__I__V($thiz, treeIndex$2, treeEdge$2, treeOut$2, etail$2, treeIn$2, ehead$2, e, f) {
  treeIndex$2.a[f] = treeIndex$2.a[e];
  treeEdge$2.cM(treeIndex$2.a[e], f);
  treeIndex$2.a[e] = (-1);
  var to = treeOut$2.a[etail$2.a[e]];
  var jo = $f_sc_SeqOps__indexOf__O__I__I(to, e, 0);
  to.cM(jo, to.l(((to.a1 - 1) | 0)));
  to.wd(((to.a1 - 1) | 0));
  var ti = treeIn$2.a[ehead$2.a[e]];
  var ji = $f_sc_SeqOps__indexOf__O__I__I(ti, e, 0);
  ti.cM(ji, ti.l(((ti.a1 - 1) | 0)));
  ti.wd(((ti.a1 - 1) | 0));
  treeOut$2.a[etail$2.a[f]].aw(f);
  treeIn$2.a[ehead$2.a[f]].aw(f);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__newSubtree$1__scm_ArrayBuffer__scm_ArrayBuffer__scm_ArrayBuffer__scm_ArrayBuffer__I__I($thiz, stRep$1, stSize$1, stHeap$1, stPar$1, rep) {
  stRep$1.aw(rep);
  stSize$1.aw(0);
  stHeap$1.aw((-1));
  stPar$1.aw(((stRep$1.a1 - 1) | 0));
  return ((stRep$1.a1 - 1) | 0);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__stFind$1__AI__scm_ArrayBuffer__I__I($thiz, nodeSubtree$1, stPar$2, node) {
  var s = nodeSubtree$1.a[node];
  while (((stPar$2.l(s) | 0) !== s)) {
    s = (stPar$2.l(s) | 0);
  }
  return s;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__stFindRoot$1__scm_ArrayBuffer__I__I($thiz, stPar$3, t0) {
  var r = t0;
  while (((stPar$3.l(r) | 0) !== r)) {
    r = (stPar$3.l(r) | 0);
  }
  return r;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__stUnion$1__scm_ArrayBuffer__scm_ArrayBuffer__scm_ArrayBuffer__I__I__I($thiz, stHeap$2, stSize$2, stPar$4, s0, s1) {
  var r0 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__stFindRoot$1__scm_ArrayBuffer__I__I($thiz, stPar$4, s0);
  var r1 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__stFindRoot$1__scm_ArrayBuffer__I__I($thiz, stPar$4, s1);
  if ((r0 === r1)) {
    return r0;
  } else {
    var r = (((stHeap$2.l(r1) | 0) === (-1)) ? r0 : (((stHeap$2.l(r0) | 0) === (-1)) ? r1 : (((stSize$2.l(r1) | 0) < (stSize$2.l(r0) | 0)) ? r0 : r1)));
    stPar$4.cM(r0, r);
    stPar$4.cM(r1, r);
    stSize$2.cM(r, (((stSize$2.l(r0) | 0) + (stSize$2.l(r1) | 0)) | 0));
    return r;
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__tightSubtreeSearch$1__AI__AAI__AI__AI__AI__AI__AI__AAI__scm_ArrayBuffer__Ascm_ArrayBuffer__Ascm_ArrayBuffer__I__I__I($thiz, nodeSubtree$2, inE$1, treeIndex$3, etail$3, rank$1, ehead$3, eminlen$1, outE$1, treeEdge$3, treeOut$3, treeIn$3, root, st) {
  var rv = 1;
  nodeSubtree$2.a[root] = st;
  var elems = $m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$Frame$1.r().C)([new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$Frame$1(root, 0, 0, 1)]));
  var todo = $ct_scm_Stack__I__(new $c_scm_Stack(), 16).kl(elems);
  while ((!todo.c())) {
    var top = $f_sc_IndexedSeqOps__head__O(todo);
    var updated = false;
    var brk = false;
    while (((!brk) && (top.Ff < inE$1.a[top.RF].a.length))) {
      var e = inE$1.a[top.RF].a[top.Ff];
      if ((treeIndex$3.a[e] >= 0)) {
        top.Ff = ((1 + top.Ff) | 0);
      } else if (((nodeSubtree$2.a[etail$3.a[e]] === (-1)) && (((((rank$1.a[ehead$3.a[e]] - rank$1.a[etail$3.a[e]]) | 0) - eminlen$1.a[e]) | 0) === 0))) {
        $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__addTreeEdge$1__AI__scm_ArrayBuffer__Ascm_ArrayBuffer__AI__Ascm_ArrayBuffer__AI__I__V($thiz, treeIndex$3, treeEdge$3, treeOut$3, etail$3, treeIn$3, ehead$3, e);
        nodeSubtree$2.a[etail$3.a[e]] = st;
        todo.gm(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$Frame$1(etail$3.a[e], 0, 0, 1));
        updated = true;
        brk = true;
      } else {
        top.Ff = ((1 + top.Ff) | 0);
      }
    }
    if ((!updated)) {
      brk = false;
      while (((!brk) && (top.Fg < outE$1.a[top.RF].a.length))) {
        var e$2 = outE$1.a[top.RF].a[top.Fg];
        if ((treeIndex$3.a[e$2] >= 0)) {
          top.Fg = ((1 + top.Fg) | 0);
        } else if (((nodeSubtree$2.a[ehead$3.a[e$2]] === (-1)) && (((((rank$1.a[ehead$3.a[e$2]] - rank$1.a[etail$3.a[e$2]]) | 0) - eminlen$1.a[e$2]) | 0) === 0))) {
          $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__addTreeEdge$1__AI__scm_ArrayBuffer__Ascm_ArrayBuffer__AI__Ascm_ArrayBuffer__AI__I__V($thiz, treeIndex$3, treeEdge$3, treeOut$3, etail$3, treeIn$3, ehead$3, e$2);
          nodeSubtree$2.a[ehead$3.a[e$2]] = st;
          todo.gm(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$Frame$1(ehead$3.a[e$2], 0, 0, 1));
          updated = true;
          brk = true;
        } else {
          top.Fg = ((1 + top.Fg) | 0);
        }
      }
      if ((!updated)) {
        var last = todo.h7(false);
        if (todo.c()) {
          rv = last.RE;
        } else {
          var \u03b41$ = $f_sc_IndexedSeqOps__head__O(todo);
          \u03b41$.RE = ((\u03b41$.RE + last.RE) | 0);
        }
      }
    }
  }
  return rv;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__interTreeEdgeSearch$1__AI__AI__AI__AI__AAI__AI__AAI__AI__scm_ArrayBuffer__I__I__I__I($thiz, rank$2, ehead$4, etail$4, eminlen$2, outE$2, treeIndex$4, inE$2, nodeSubtree$3, stPar$5, v, from, best0) {
  var best = best0;
  var ts = $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__stFind$1__AI__scm_ArrayBuffer__I__I($thiz, nodeSubtree$3, stPar$5, v);
  if ((best >= 0)) {
    var e$proxy1 = best;
    var $x_1 = (((((rank$2.a[ehead$4.a[e$proxy1]] - rank$2.a[etail$4.a[e$proxy1]]) | 0) - eminlen$2.a[e$proxy1]) | 0) === 0);
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    return best;
  }
  var k = 0;
  while ((k < outE$2.a[v].a.length)) {
    var e = outE$2.a[v].a[k];
    if ((treeIndex$4.a[e] >= 0)) {
      if ((ehead$4.a[e] !== from)) {
        best = $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__interTreeEdgeSearch$1__AI__AI__AI__AI__AAI__AI__AAI__AI__scm_ArrayBuffer__I__I__I__I($thiz, rank$2, ehead$4, etail$4, eminlen$2, outE$2, treeIndex$4, inE$2, nodeSubtree$3, stPar$5, ehead$4.a[e], v, best);
      }
    } else if (($p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__stFind$1__AI__scm_ArrayBuffer__I__I($thiz, nodeSubtree$3, stPar$5, ehead$4.a[e]) !== ts)) {
      if ((best < 0)) {
        var $x_2 = true;
      } else {
        var $x_5 = rank$2.a[ehead$4.a[e]];
        var $x_4 = rank$2.a[etail$4.a[e]];
        var $x_3 = eminlen$2.a[e];
        var e$proxy2 = best;
        var $x_2 = ((((($x_5 - $x_4) | 0) - $x_3) | 0) < ((((rank$2.a[ehead$4.a[e$proxy2]] - rank$2.a[etail$4.a[e$proxy2]]) | 0) - eminlen$2.a[e$proxy2]) | 0));
      }
      if ($x_2) {
        best = e;
      }
    }
    k = ((1 + k) | 0);
  }
  k = 0;
  while ((k < inE$2.a[v].a.length)) {
    var e$2 = inE$2.a[v].a[k];
    if ((treeIndex$4.a[e$2] >= 0)) {
      if ((etail$4.a[e$2] !== from)) {
        best = $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__interTreeEdgeSearch$1__AI__AI__AI__AI__AAI__AI__AAI__AI__scm_ArrayBuffer__I__I__I__I($thiz, rank$2, ehead$4, etail$4, eminlen$2, outE$2, treeIndex$4, inE$2, nodeSubtree$3, stPar$5, etail$4.a[e$2], v, best);
      }
    } else if (($p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__stFind$1__AI__scm_ArrayBuffer__I__I($thiz, nodeSubtree$3, stPar$5, etail$4.a[e$2]) !== ts)) {
      if ((best < 0)) {
        var $x_6 = true;
      } else {
        var $x_9 = rank$2.a[ehead$4.a[e$2]];
        var $x_8 = rank$2.a[etail$4.a[e$2]];
        var $x_7 = eminlen$2.a[e$2];
        var e$proxy3 = best;
        var $x_6 = ((((($x_9 - $x_8) | 0) - $x_7) | 0) < ((((rank$2.a[ehead$4.a[e$proxy3]] - rank$2.a[etail$4.a[e$proxy3]]) | 0) - eminlen$2.a[e$proxy3]) | 0));
      }
      if ($x_6) {
        best = e$2;
      }
    }
    k = ((1 + k) | 0);
  }
  return best;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__treeAdjust$1__AI__Ascm_ArrayBuffer__AI__Ascm_ArrayBuffer__AI__I__I__I__V($thiz, rank$3, treeIn$4, etail$5, treeOut$4, ehead$5, v, from, delta) {
  rank$3.a[v] = ((rank$3.a[v] + delta) | 0);
  var k = 0;
  while ((k < treeIn$4.a[v].a1)) {
    var e = (treeIn$4.a[v].l(k) | 0);
    if ((etail$5.a[e] !== from)) {
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__treeAdjust$1__AI__Ascm_ArrayBuffer__AI__Ascm_ArrayBuffer__AI__I__I__I__V($thiz, rank$3, treeIn$4, etail$5, treeOut$4, ehead$5, etail$5.a[e], v, delta);
    }
    k = ((1 + k) | 0);
  }
  k = 0;
  while ((k < treeOut$4.a[v].a1)) {
    var e$2 = (treeOut$4.a[v].l(k) | 0);
    if ((ehead$5.a[e$2] !== from)) {
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__treeAdjust$1__AI__Ascm_ArrayBuffer__AI__Ascm_ArrayBuffer__AI__I__I__I__V($thiz, rank$3, treeIn$4, etail$5, treeOut$4, ehead$5, ehead$5.a[e$2], v, delta);
    }
    k = ((1 + k) | 0);
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__mergeTrees$1__AI__AI__scm_ArrayBuffer__AI__AI__scm_ArrayBuffer__AI__scm_ArrayBuffer__Ascm_ArrayBuffer__Ascm_ArrayBuffer__AI__scm_ArrayBuffer__scm_ArrayBuffer__I__I($thiz, etail$6, ehead$6, stHeap$3, rank$4, eminlen$3, stRep$2, nodeSubtree$4, stPar$6, treeIn$5, treeOut$5, treeIndex$5, treeEdge$4, stSize$3, e) {
  var t0 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__stFind$1__AI__scm_ArrayBuffer__I__I($thiz, nodeSubtree$4, stPar$6, etail$6.a[e]);
  var t1 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__stFind$1__AI__scm_ArrayBuffer__I__I($thiz, nodeSubtree$4, stPar$6, ehead$6.a[e]);
  if (((stHeap$3.l(t0) | 0) === (-1))) {
    var d = ((((rank$4.a[ehead$6.a[e]] - rank$4.a[etail$6.a[e]]) | 0) - eminlen$3.a[e]) | 0);
    if ((d !== 0)) {
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__treeAdjust$1__AI__Ascm_ArrayBuffer__AI__Ascm_ArrayBuffer__AI__I__I__I__V($thiz, rank$4, treeIn$5, etail$6, treeOut$5, ehead$6, (stRep$2.l(t0) | 0), (-1), d);
    }
  } else {
    var d$2 = ((-((((rank$4.a[ehead$6.a[e]] - rank$4.a[etail$6.a[e]]) | 0) - eminlen$3.a[e]) | 0)) | 0);
    if ((d$2 !== 0)) {
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__treeAdjust$1__AI__Ascm_ArrayBuffer__AI__Ascm_ArrayBuffer__AI__I__I__I__V($thiz, rank$4, treeIn$5, etail$6, treeOut$5, ehead$6, (stRep$2.l(t1) | 0), (-1), d$2);
    }
  }
  $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__addTreeEdge$1__AI__scm_ArrayBuffer__Ascm_ArrayBuffer__AI__Ascm_ArrayBuffer__AI__I__V($thiz, treeIndex$5, treeEdge$4, treeOut$5, etail$6, treeIn$5, ehead$6, e);
  return $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__stUnion$1__scm_ArrayBuffer__scm_ArrayBuffer__scm_ArrayBuffer__I__I__I($thiz, stHeap$3, stSize$3, stPar$6, t0, t1);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__heapify$1__scm_ArrayBuffer__scm_ArrayBuffer__scm_ArrayBuffer__I__V($thiz, heapElt$1, stSize$4, stHeap$4, i0) {
  var i = i0;
  var go = true;
  while ((go && (i < heapElt$1.a1))) {
    var l = (((((1 + i) | 0) << 1) - 1) | 0);
    var r = (((1 + i) | 0) << 1);
    var smallest = i;
    if (((l < heapElt$1.a1) && ((stSize$4.l((heapElt$1.l(l) | 0)) | 0) < (stSize$4.l((heapElt$1.l(smallest) | 0)) | 0)))) {
      smallest = l;
    }
    if (((r < heapElt$1.a1) && ((stSize$4.l((heapElt$1.l(r) | 0)) | 0) < (stSize$4.l((heapElt$1.l(smallest) | 0)) | 0)))) {
      smallest = r;
    }
    if ((smallest !== i)) {
      var t = (heapElt$1.l(i) | 0);
      heapElt$1.cM(i, heapElt$1.l(smallest));
      heapElt$1.cM(smallest, t);
      stHeap$4.cM((heapElt$1.l(i) | 0), i);
      stHeap$4.cM((heapElt$1.l(smallest) | 0), smallest);
      i = smallest;
    } else {
      go = false;
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__buildHeap$1__scm_ArrayBuffer__scm_ArrayBuffer__scm_ArrayBuffer__V($thiz, heapElt$2, stHeap$5, stSize$5) {
  var i = 0;
  while ((i < heapElt$2.a1)) {
    stHeap$5.cM((heapElt$2.l(i) | 0), i);
    i = ((1 + i) | 0);
  }
  var num = heapElt$2.a1;
  i = (((((num + ((num >>> 31) | 0)) | 0) >> 1) - 1) | 0);
  while ((i >= 0)) {
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__heapify$1__scm_ArrayBuffer__scm_ArrayBuffer__scm_ArrayBuffer__I__V($thiz, heapElt$2, stSize$5, stHeap$5, i);
    i = ((i - 1) | 0);
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__extractMin$1__scm_ArrayBuffer__scm_ArrayBuffer__scm_ArrayBuffer__I($thiz, heapElt$3, stHeap$6, stSize$6) {
  var rv = (heapElt$3.l(0) | 0);
  stHeap$6.cM(rv, (-1));
  heapElt$3.cM(0, heapElt$3.l(((heapElt$3.a1 - 1) | 0)));
  stHeap$6.cM((heapElt$3.l(0) | 0), 0);
  heapElt$3.wd(((heapElt$3.a1 - 1) | 0));
  $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__heapify$1__scm_ArrayBuffer__scm_ArrayBuffer__scm_ArrayBuffer__I__V($thiz, heapElt$3, stSize$6, stHeap$6, 0);
  return rv;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__dfsRangeInit$1__AI__AI__Ascm_ArrayBuffer__AI__Ascm_ArrayBuffer__AI__AI__I__V($thiz, par$1, low$1, treeOut$6, ehead$7, treeIn$6, etail$7, lim$1, root) {
  par$1.a[root] = (-1);
  low$1.a[root] = 1;
  var elems = $m_sr_ScalaRunTime$().f(new ($d_T4.r().C)([new $c_T4(root, (-1), 1, new $ac_I(new Int32Array([0, 0])))]));
  var todo = $ct_scm_Stack__I__(new $c_scm_Stack(), 16).kl(elems);
  var limMax = 0;
  while ((!todo.c())) {
    matchResult4: {
      var \u03b42$___1;
      var \u03b42$___2;
      var \u03b42$___3;
      var \u03b42$___4;
      var x5 = $f_sc_IndexedSeqOps__head__O(todo);
      if ((x5 !== null)) {
        var \u03b42$___1 = (x5.bO | 0);
        var \u03b42$___2 = (x5.bs | 0);
        var \u03b42$___3 = (x5.ch | 0);
        var \u03b42$___4 = x5.ca;
        break matchResult4;
      }
      throw new $c_s_MatchError(x5);
    }
    var v$2 = (\u03b42$___1 | 0);
    var pe$2 = (\u03b42$___2 | 0);
    var curLim$2 = (\u03b42$___3 | 0);
    var it$2 = \u03b42$___4;
    var pushed = false;
    while (((!pushed) && (it$2.a[0] < treeOut$6.a[v$2].a1))) {
      var e = (treeOut$6.a[v$2].l(it$2.a[0]) | 0);
      it$2.a[0] = ((1 + it$2.a[0]) | 0);
      if ((e !== pe$2)) {
        var n = ehead$7.a[e];
        par$1.a[n] = e;
        low$1.a[n] = curLim$2;
        todo.gm(new $c_T4(n, e, curLim$2, new $ac_I(new Int32Array([0, 0]))));
        pushed = true;
      }
    }
    if ((!pushed)) {
      while (((!pushed) && (it$2.a[1] < treeIn$6.a[v$2].a1))) {
        var e$2 = (treeIn$6.a[v$2].l(it$2.a[1]) | 0);
        it$2.a[1] = ((1 + it$2.a[1]) | 0);
        if ((e$2 !== pe$2)) {
          var n$2 = etail$7.a[e$2];
          par$1.a[n$2] = e$2;
          low$1.a[n$2] = curLim$2;
          todo.gm(new $c_T4(n$2, e$2, curLim$2, new $ac_I(new Int32Array([0, 0]))));
          pushed = true;
        }
      }
      if ((!pushed)) {
        lim$1.a[v$2] = curLim$2;
        limMax = curLim$2;
        todo.h7(false);
        if ((!todo.c())) {
          matchResult5: {
            var \u03b43$___1;
            var \u03b43$___2;
            var \u03b43$___3;
            var x10 = $f_sc_IndexedSeqOps__head__O(todo);
            if ((x10 !== null)) {
              var \u03b43$___1 = (x10.bO | 0);
              var \u03b43$___2 = (x10.bs | 0);
              var \u03b43$___3 = x10.ca;
              break matchResult5;
            }
            throw new $c_s_MatchError(x10);
          }
          var pv$2 = (\u03b43$___1 | 0);
          var ppe$2 = (\u03b43$___2 | 0);
          var pit$2 = \u03b43$___3;
          todo.h7(false);
          todo.gm(new $c_T4(pv$2, ppe$2, ((1 + limMax) | 0), pit$2));
        }
      }
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__xVal$1__AI__AI__AI__AI__AI__AI__AI__I__I__I__I($thiz, etail$8, ehead$8, low$2, lim$2, eweight$1, treeIndex$6, cutvalue$1, e, v, dir) {
  var other = ((etail$8.a[e] === v) ? ehead$8.a[e] : etail$8.a[e]);
  var rv = 0;
  var f = 0;
  var l$proxy1 = low$2.a[v];
  var x$proxy1 = lim$2.a[other];
  var h$proxy1 = lim$2.a[v];
  if ((!((x$proxy1 >= l$proxy1) && (x$proxy1 <= h$proxy1)))) {
    f = 1;
    rv = eweight$1.a[e];
  } else {
    rv = ((((treeIndex$6.a[e] >= 0) ? cutvalue$1.a[e] : 0) - eweight$1.a[e]) | 0);
  }
  var d = ((dir > 0) ? ((ehead$8.a[e] === v) ? 1 : (-1)) : ((etail$8.a[e] === v) ? 1 : (-1)));
  if ((f !== 0)) {
    d = ((-d) | 0);
  }
  return ((d < 0) ? ((-rv) | 0) : rv);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__xCutval$1__AI__AI__AI__AAI__AAI__AI__AI__AI__AI__AI__I__V($thiz, par$2, etail$9, ehead$9, outE$3, inE$3, cutvalue$2, low$3, lim$3, eweight$2, treeIndex$7, f) {
  if ((par$2.a[etail$9.a[f]] === f)) {
    var \u03b44$___1 = etail$9.a[f];
    var \u03b44$___2 = 1;
  } else {
    var \u03b44$___1 = ehead$9.a[f];
    var \u03b44$___2 = (-1);
  }
  var v = (\u03b44$___1 | 0);
  var dir = (\u03b44$___2 | 0);
  var sum = 0;
  var k = 0;
  while ((k < outE$3.a[v].a.length)) {
    sum = ((sum + $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__xVal$1__AI__AI__AI__AI__AI__AI__AI__I__I__I__I($thiz, etail$9, ehead$9, low$3, lim$3, eweight$2, treeIndex$7, cutvalue$2, outE$3.a[v].a[k], v, dir)) | 0);
    k = ((1 + k) | 0);
  }
  k = 0;
  while ((k < inE$3.a[v].a.length)) {
    sum = ((sum + $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__xVal$1__AI__AI__AI__AI__AI__AI__AI__I__I__I__I($thiz, etail$9, ehead$9, low$3, lim$3, eweight$2, treeIndex$7, cutvalue$2, inE$3.a[v].a[k], v, dir)) | 0);
    k = ((1 + k) | 0);
  }
  cutvalue$2.a[f] = sum;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__dfsCutval$1__Ascm_ArrayBuffer__AI__Ascm_ArrayBuffer__AI__AI__AAI__AAI__AI__AI__AI__AI__AI__I__I__V($thiz, treeOut$7, ehead$10, treeIn$7, etail$10, par$3, outE$4, inE$4, cutvalue$3, low$4, lim$4, eweight$3, treeIndex$8, v, pe) {
  var k = 0;
  while ((k < treeOut$7.a[v].a1)) {
    var e = (treeOut$7.a[v].l(k) | 0);
    if ((e !== pe)) {
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__dfsCutval$1__Ascm_ArrayBuffer__AI__Ascm_ArrayBuffer__AI__AI__AAI__AAI__AI__AI__AI__AI__AI__I__I__V($thiz, treeOut$7, ehead$10, treeIn$7, etail$10, par$3, outE$4, inE$4, cutvalue$3, low$4, lim$4, eweight$3, treeIndex$8, ehead$10.a[e], e);
    }
    k = ((1 + k) | 0);
  }
  k = 0;
  while ((k < treeIn$7.a[v].a1)) {
    var e$2 = (treeIn$7.a[v].l(k) | 0);
    if ((e$2 !== pe)) {
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__dfsCutval$1__Ascm_ArrayBuffer__AI__Ascm_ArrayBuffer__AI__AI__AAI__AAI__AI__AI__AI__AI__AI__I__I__V($thiz, treeOut$7, ehead$10, treeIn$7, etail$10, par$3, outE$4, inE$4, cutvalue$3, low$4, lim$4, eweight$3, treeIndex$8, etail$10.a[e$2], e$2);
    }
    k = ((1 + k) | 0);
  }
  if ((pe >= 0)) {
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__xCutval$1__AI__AI__AI__AAI__AAI__AI__AI__AI__AI__AI__I__V($thiz, par$3, etail$10, ehead$10, outE$4, inE$4, cutvalue$3, low$4, lim$4, eweight$3, treeIndex$8, pe);
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__dfsEnterOut$1__AAI__AI__sr_IntRef__AI__AI__sr_IntRef__AI__AI__AI__sr_IntRef__sr_IntRef__Ascm_ArrayBuffer__I__V($thiz, outE$5, treeIndex$9, LowC$1, lim$5, ehead$11, LimC$1, rank$5, etail$11, eminlen$4, enterSlack$1, enterE$1, treeIn$8, v) {
  var k = 0;
  while ((k < outE$5.a[v].a.length)) {
    var e = outE$5.a[v].a[k];
    if ((treeIndex$9.a[e] < 0)) {
      var l$proxy2 = LowC$1.an;
      var x$proxy2 = lim$5.a[ehead$11.a[e]];
      var h$proxy2 = LimC$1.an;
      if ((!((x$proxy2 >= l$proxy2) && (x$proxy2 <= h$proxy2)))) {
        var s = ((((rank$5.a[ehead$11.a[e]] - rank$5.a[etail$11.a[e]]) | 0) - eminlen$4.a[e]) | 0);
        if (((s < enterSlack$1.an) || (enterE$1.an < 0))) {
          enterE$1.an = e;
          enterSlack$1.an = s;
        }
      }
    } else if ((lim$5.a[ehead$11.a[e]] < lim$5.a[v])) {
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__dfsEnterOut$1__AAI__AI__sr_IntRef__AI__AI__sr_IntRef__AI__AI__AI__sr_IntRef__sr_IntRef__Ascm_ArrayBuffer__I__V($thiz, outE$5, treeIndex$9, LowC$1, lim$5, ehead$11, LimC$1, rank$5, etail$11, eminlen$4, enterSlack$1, enterE$1, treeIn$8, ehead$11.a[e]);
    }
    k = ((1 + k) | 0);
  }
  k = 0;
  while (((k < treeIn$8.a[v].a1) && (enterSlack$1.an > 0))) {
    var e$2 = (treeIn$8.a[v].l(k) | 0);
    if ((lim$5.a[etail$11.a[e$2]] < lim$5.a[v])) {
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__dfsEnterOut$1__AAI__AI__sr_IntRef__AI__AI__sr_IntRef__AI__AI__AI__sr_IntRef__sr_IntRef__Ascm_ArrayBuffer__I__V($thiz, outE$5, treeIndex$9, LowC$1, lim$5, ehead$11, LimC$1, rank$5, etail$11, eminlen$4, enterSlack$1, enterE$1, treeIn$8, etail$11.a[e$2]);
    }
    k = ((1 + k) | 0);
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__dfsEnterIn$1__AAI__AI__sr_IntRef__AI__AI__sr_IntRef__AI__AI__AI__sr_IntRef__sr_IntRef__Ascm_ArrayBuffer__I__V($thiz, inE$5, treeIndex$10, LowC$2, lim$6, etail$12, LimC$2, rank$6, ehead$12, eminlen$5, enterSlack$2, enterE$2, treeOut$8, v) {
  var k = 0;
  while ((k < inE$5.a[v].a.length)) {
    var e = inE$5.a[v].a[k];
    if ((treeIndex$10.a[e] < 0)) {
      var l$proxy3 = LowC$2.an;
      var x$proxy3 = lim$6.a[etail$12.a[e]];
      var h$proxy3 = LimC$2.an;
      if ((!((x$proxy3 >= l$proxy3) && (x$proxy3 <= h$proxy3)))) {
        var s = ((((rank$6.a[ehead$12.a[e]] - rank$6.a[etail$12.a[e]]) | 0) - eminlen$5.a[e]) | 0);
        if (((s < enterSlack$2.an) || (enterE$2.an < 0))) {
          enterE$2.an = e;
          enterSlack$2.an = s;
        }
      }
    } else if ((lim$6.a[etail$12.a[e]] < lim$6.a[v])) {
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__dfsEnterIn$1__AAI__AI__sr_IntRef__AI__AI__sr_IntRef__AI__AI__AI__sr_IntRef__sr_IntRef__Ascm_ArrayBuffer__I__V($thiz, inE$5, treeIndex$10, LowC$2, lim$6, etail$12, LimC$2, rank$6, ehead$12, eminlen$5, enterSlack$2, enterE$2, treeOut$8, etail$12.a[e]);
    }
    k = ((1 + k) | 0);
  }
  k = 0;
  while (((k < treeOut$8.a[v].a1) && (enterSlack$2.an > 0))) {
    var e$2 = (treeOut$8.a[v].l(k) | 0);
    if ((lim$6.a[ehead$12.a[e$2]] < lim$6.a[v])) {
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__dfsEnterIn$1__AAI__AI__sr_IntRef__AI__AI__sr_IntRef__AI__AI__AI__sr_IntRef__sr_IntRef__Ascm_ArrayBuffer__I__V($thiz, inE$5, treeIndex$10, LowC$2, lim$6, etail$12, LimC$2, rank$6, ehead$12, eminlen$5, enterSlack$2, enterE$2, treeOut$8, ehead$12.a[e$2]);
    }
    k = ((1 + k) | 0);
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__enterEdge$1__AI__AI__AI__sr_IntRef__sr_IntRef__sr_IntRef__AI__sr_IntRef__AAI__AI__AI__AI__Ascm_ArrayBuffer__AAI__Ascm_ArrayBuffer__I__I($thiz, lim$7, etail$13, ehead$13, enterE$3, enterSlack$3, LowC$3, low$5, LimC$3, outE$6, treeIndex$11, rank$7, eminlen$6, treeIn$9, inE$6, treeOut$9, e) {
  if ((lim$7.a[etail$13.a[e]] < lim$7.a[ehead$13.a[e]])) {
    var \u03b45$___1 = etail$13.a[e];
    var \u03b45$___2 = false;
  } else {
    var \u03b45$___1 = ehead$13.a[e];
    var \u03b45$___2 = true;
  }
  var v = (\u03b45$___1 | 0);
  var outsearch = (!(!\u03b45$___2));
  enterE$3.an = (-1);
  enterSlack$3.an = 2147483647;
  LowC$3.an = low$5.a[v];
  LimC$3.an = lim$7.a[v];
  if (outsearch) {
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__dfsEnterOut$1__AAI__AI__sr_IntRef__AI__AI__sr_IntRef__AI__AI__AI__sr_IntRef__sr_IntRef__Ascm_ArrayBuffer__I__V($thiz, outE$6, treeIndex$11, LowC$3, lim$7, ehead$13, LimC$3, rank$7, etail$13, eminlen$6, enterSlack$3, enterE$3, treeIn$9, v);
  } else {
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__dfsEnterIn$1__AAI__AI__sr_IntRef__AI__AI__sr_IntRef__AI__AI__AI__sr_IntRef__sr_IntRef__Ascm_ArrayBuffer__I__V($thiz, inE$6, treeIndex$11, LowC$3, lim$7, etail$13, LimC$3, rank$7, ehead$13, eminlen$6, enterSlack$3, enterE$3, treeOut$9, v);
  }
  return enterE$3.an;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__rerank$1__AI__Ascm_ArrayBuffer__AI__AI__Ascm_ArrayBuffer__AI__I__I__V($thiz, rank$8, treeOut$10, par$4, ehead$14, treeIn$10, etail$14, v, delta) {
  rank$8.a[v] = ((rank$8.a[v] - delta) | 0);
  var k = 0;
  while ((k < treeOut$10.a[v].a1)) {
    var e = (treeOut$10.a[v].l(k) | 0);
    if ((e !== par$4.a[v])) {
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__rerank$1__AI__Ascm_ArrayBuffer__AI__AI__Ascm_ArrayBuffer__AI__I__I__V($thiz, rank$8, treeOut$10, par$4, ehead$14, treeIn$10, etail$14, ehead$14.a[e], delta);
    }
    k = ((1 + k) | 0);
  }
  k = 0;
  while ((k < treeIn$10.a[v].a1)) {
    var e$2 = (treeIn$10.a[v].l(k) | 0);
    if ((e$2 !== par$4.a[v])) {
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__rerank$1__AI__Ascm_ArrayBuffer__AI__AI__Ascm_ArrayBuffer__AI__I__I__V($thiz, rank$8, treeOut$10, par$4, ehead$14, treeIn$10, etail$14, etail$14.a[e$2], delta);
    }
    k = ((1 + k) | 0);
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__treeUpdate$1__AI__AI__AI__AI__AI__AI__I__I__I__I__I($thiz, low$6, lim$8, par$5, etail$15, cutvalue$5, ehead$15, v0, w, cv, dir) {
  var v = v0;
  while (true) {
    var l$proxy4 = low$6.a[v];
    var x$proxy4 = lim$8.a[w];
    var h$proxy4 = lim$8.a[v];
    if ((!((x$proxy4 >= l$proxy4) && (x$proxy4 <= h$proxy4)))) {
      var e = par$5.a[v];
      if ((((v === etail$15.a[e]) ? dir : ((1 - dir) | 0)) !== 0)) {
        cutvalue$5.a[e] = ((cutvalue$5.a[e] + cv) | 0);
      } else {
        cutvalue$5.a[e] = ((cutvalue$5.a[e] - cv) | 0);
      }
      v = ((lim$8.a[etail$15.a[e]] > lim$8.a[ehead$15.a[e]]) ? etail$15.a[e] : ehead$15.a[e]);
    } else {
      break;
    }
  }
  return v;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__invalidatePath$1__AI__AI__AI__AI__AI__I__I__V($thiz, low$7, par$6, lim$9, etail$16, ehead$16, lca, to0) {
  var to = to0;
  var go = true;
  while (go) {
    if ((low$7.a[to] === (-1))) {
      go = false;
    } else {
      low$7.a[to] = (-1);
      var e = par$6.a[to];
      if ((e < 0)) {
        go = false;
      } else if ((lim$9.a[to] >= lim$9.a[lca])) {
        go = false;
      } else {
        to = ((lim$9.a[etail$16.a[e]] > lim$9.a[ehead$16.a[e]]) ? etail$16.a[e] : ehead$16.a[e]);
      }
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__dfsRange$1__AI__AI__Ascm_ArrayBuffer__AI__AI__Ascm_ArrayBuffer__AI__I__I__I__V($thiz, par$7, low$8, treeOut$11, ehead$17, lim$10, treeIn$11, etail$17, v0, par0, low0) {
  if (((par$7.a[v0] === par0) && (low$8.a[v0] === low0))) {
    return (void 0);
  }
  par$7.a[v0] = par0;
  low$8.a[v0] = low0;
  var elems = $m_sr_ScalaRunTime$().f(new ($d_T4.r().C)([new $c_T4(v0, par0, low0, new $ac_I(new Int32Array([0, 0])))]));
  var todo = $ct_scm_Stack__I__(new $c_scm_Stack(), 16).kl(elems);
  var limMax = 0;
  while ((!todo.c())) {
    matchResult6: {
      var \u03b46$___1;
      var \u03b46$___2;
      var \u03b46$___3;
      var \u03b46$___4;
      var x15 = $f_sc_IndexedSeqOps__head__O(todo);
      if ((x15 !== null)) {
        var \u03b46$___1 = (x15.bO | 0);
        var \u03b46$___2 = (x15.bs | 0);
        var \u03b46$___3 = (x15.ch | 0);
        var \u03b46$___4 = x15.ca;
        break matchResult6;
      }
      throw new $c_s_MatchError(x15);
    }
    var v$2 = (\u03b46$___1 | 0);
    var pe$2 = (\u03b46$___2 | 0);
    var curLim$2 = (\u03b46$___3 | 0);
    var it$2 = \u03b46$___4;
    var processed = false;
    while (((!processed) && (it$2.a[0] < treeOut$11.a[v$2].a1))) {
      var e = (treeOut$11.a[v$2].l(it$2.a[0]) | 0);
      it$2.a[0] = ((1 + it$2.a[0]) | 0);
      if ((e !== pe$2)) {
        var n = ehead$17.a[e];
        if (((par$7.a[n] === e) && (low$8.a[n] === curLim$2))) {
          todo.h7(false);
          todo.gm(new $c_T4(v$2, pe$2, ((1 + lim$10.a[n]) | 0), it$2));
        } else {
          par$7.a[n] = e;
          low$8.a[n] = curLim$2;
          todo.gm(new $c_T4(n, e, curLim$2, new $ac_I(new Int32Array([0, 0]))));
        }
        processed = true;
      }
    }
    if ((!processed)) {
      while (((!processed) && (it$2.a[1] < treeIn$11.a[v$2].a1))) {
        var e$2 = (treeIn$11.a[v$2].l(it$2.a[1]) | 0);
        it$2.a[1] = ((1 + it$2.a[1]) | 0);
        if ((e$2 !== pe$2)) {
          var n$2 = etail$17.a[e$2];
          if (((par$7.a[n$2] === e$2) && (low$8.a[n$2] === curLim$2))) {
            todo.h7(false);
            todo.gm(new $c_T4(v$2, pe$2, ((1 + lim$10.a[n$2]) | 0), it$2));
          } else {
            par$7.a[n$2] = e$2;
            low$8.a[n$2] = curLim$2;
            todo.gm(new $c_T4(n$2, e$2, curLim$2, new $ac_I(new Int32Array([0, 0]))));
          }
          processed = true;
        }
      }
      if ((!processed)) {
        lim$10.a[v$2] = curLim$2;
        limMax = curLim$2;
        todo.h7(false);
        if ((!todo.c())) {
          matchResult7: {
            var \u03b47$___1;
            var \u03b47$___2;
            var \u03b47$___3;
            var x20 = $f_sc_IndexedSeqOps__head__O(todo);
            if ((x20 !== null)) {
              var \u03b47$___1 = (x20.bO | 0);
              var \u03b47$___2 = (x20.bs | 0);
              var \u03b47$___3 = x20.ca;
              break matchResult7;
            }
            throw new $c_s_MatchError(x20);
          }
          var pv$2 = (\u03b47$___1 | 0);
          var ppe$2 = (\u03b47$___2 | 0);
          var pit$2 = \u03b47$___3;
          todo.h7(false);
          todo.gm(new $c_T4(pv$2, ppe$2, ((1 + limMax) | 0), pit$2));
        }
      }
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__update$1__AI__AI__AI__AI__Ascm_ArrayBuffer__Ascm_ArrayBuffer__AI__AI__AI__AI__AI__scm_ArrayBuffer__I__I__V($thiz, rank$9, ehead$18, etail$18, eminlen$7, treeIn$12, treeOut$12, lim$11, cutvalue$6, low$9, par$8, treeIndex$12, treeEdge$6, e, f) {
  var delta = ((((rank$9.a[ehead$18.a[f]] - rank$9.a[etail$18.a[f]]) | 0) - eminlen$7.a[f]) | 0);
  if ((delta > 0)) {
    if ((((treeIn$12.a[etail$18.a[e]].a1 + treeOut$12.a[etail$18.a[e]].a1) | 0) === 1)) {
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__rerank$1__AI__Ascm_ArrayBuffer__AI__AI__Ascm_ArrayBuffer__AI__I__I__V($thiz, rank$9, treeOut$12, par$8, ehead$18, treeIn$12, etail$18, etail$18.a[e], delta);
    } else if ((((treeIn$12.a[ehead$18.a[e]].a1 + treeOut$12.a[ehead$18.a[e]].a1) | 0) === 1)) {
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__rerank$1__AI__Ascm_ArrayBuffer__AI__AI__Ascm_ArrayBuffer__AI__I__I__V($thiz, rank$9, treeOut$12, par$8, ehead$18, treeIn$12, etail$18, ehead$18.a[e], ((-delta) | 0));
    } else if ((lim$11.a[etail$18.a[e]] < lim$11.a[ehead$18.a[e]])) {
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__rerank$1__AI__Ascm_ArrayBuffer__AI__AI__Ascm_ArrayBuffer__AI__I__I__V($thiz, rank$9, treeOut$12, par$8, ehead$18, treeIn$12, etail$18, etail$18.a[e], delta);
    } else {
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__rerank$1__AI__Ascm_ArrayBuffer__AI__AI__Ascm_ArrayBuffer__AI__I__I__V($thiz, rank$9, treeOut$12, par$8, ehead$18, treeIn$12, etail$18, ehead$18.a[e], ((-delta) | 0));
    }
  }
  var cv = cutvalue$6.a[e];
  var lca = $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__treeUpdate$1__AI__AI__AI__AI__AI__AI__I__I__I__I__I($thiz, low$9, lim$11, par$8, etail$18, cutvalue$6, ehead$18, etail$18.a[f], ehead$18.a[f], cv, 1);
  $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__treeUpdate$1__AI__AI__AI__AI__AI__AI__I__I__I__I__I($thiz, low$9, lim$11, par$8, etail$18, cutvalue$6, ehead$18, ehead$18.a[f], etail$18.a[f], cv, 0);
  var lcaLow = low$9.a[lca];
  $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__invalidatePath$1__AI__AI__AI__AI__AI__I__I__V($thiz, low$9, par$8, lim$11, etail$18, ehead$18, lca, ehead$18.a[f]);
  $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__invalidatePath$1__AI__AI__AI__AI__AI__I__I__V($thiz, low$9, par$8, lim$11, etail$18, ehead$18, lca, etail$18.a[f]);
  cutvalue$6.a[f] = ((-cv) | 0);
  cutvalue$6.a[e] = 0;
  $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__exchangeTreeEdges$1__AI__scm_ArrayBuffer__Ascm_ArrayBuffer__AI__Ascm_ArrayBuffer__AI__I__I__V($thiz, treeIndex$12, treeEdge$6, treeOut$12, etail$18, treeIn$12, ehead$18, e, f);
  $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__dfsRange$1__AI__AI__Ascm_ArrayBuffer__AI__AI__Ascm_ArrayBuffer__AI__I__I__I__V($thiz, par$8, low$9, treeOut$12, ehead$18, lim$11, treeIn$12, etail$18, lca, par$8.a[lca], lcaLow);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__scanAndNormalize$1__I__AZ__AI__I($thiz, N$1, normal$1, rank$10) {
  var mn = 2147483647;
  var mx = (-2147483648);
  var v = 0;
  while ((v < N$1)) {
    if (normal$1.a[v]) {
      var x = mn;
      var y = rank$10.a[v];
      mn = ((x < y) ? x : y);
      var x$1 = mx;
      var y$1 = rank$10.a[v];
      mx = ((x$1 > y$1) ? x$1 : y$1);
    }
    v = ((1 + v) | 0);
  }
  if ((mn === 2147483647)) {
    mn = 0;
    mx = 0;
  }
  v = 0;
  while ((v < N$1)) {
    var i$2 = v;
    rank$10.a[i$2] = ((rank$10.a[i$2] - mn) | 0);
    v = ((1 + v) | 0);
  }
  return ((mx - mn) | 0);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__lrBalance$1__scm_ArrayBuffer__AI__AI__AI__AI__AI__AI__sr_IntRef__sr_IntRef__sr_IntRef__AI__sr_IntRef__AAI__AI__Ascm_ArrayBuffer__AAI__Ascm_ArrayBuffer__AI__V($thiz, treeEdge$7, cutvalue$7, rank$11, ehead$19, etail$19, eminlen$8, lim$12, enterE$4, enterSlack$4, LowC$4, low$10, LimC$4, outE$7, treeIndex$13, treeIn$13, inE$7, treeOut$13, par$9) {
  var i = 0;
  while ((i < treeEdge$7.a1)) {
    var e = (treeEdge$7.l(i) | 0);
    if ((cutvalue$7.a[e] === 0)) {
      var f = $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__enterEdge$1__AI__AI__AI__sr_IntRef__sr_IntRef__sr_IntRef__AI__sr_IntRef__AAI__AI__AI__AI__Ascm_ArrayBuffer__AAI__Ascm_ArrayBuffer__I__I($thiz, lim$12, etail$19, ehead$19, enterE$4, enterSlack$4, LowC$4, low$10, LimC$4, outE$7, treeIndex$13, rank$11, eminlen$8, treeIn$13, inE$7, treeOut$13, e);
      if ((f >= 0)) {
        var delta = ((((rank$11.a[ehead$19.a[f]] - rank$11.a[etail$19.a[f]]) | 0) - eminlen$8.a[f]) | 0);
        if ((delta > 1)) {
          if ((lim$12.a[etail$19.a[e]] < lim$12.a[ehead$19.a[e]])) {
            $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__rerank$1__AI__Ascm_ArrayBuffer__AI__AI__Ascm_ArrayBuffer__AI__I__I__V($thiz, rank$11, treeOut$13, par$9, ehead$19, treeIn$13, etail$19, etail$19.a[e], (((delta + ((delta >>> 31) | 0)) | 0) >> 1));
          } else {
            $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__rerank$1__AI__Ascm_ArrayBuffer__AI__AI__Ascm_ArrayBuffer__AI__I__I__V($thiz, rank$11, treeOut$13, par$9, ehead$19, treeIn$13, etail$19, ehead$19.a[e], ((-(((delta + ((delta >>> 31) | 0)) | 0) >> 1)) | 0));
          }
        }
      }
    }
    i = ((1 + i) | 0);
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__tbBalance$1__sci_Seq__sci_Map__AI__I__AAI__AI__AI__AI__AAI__AI__AZ__V($thiz, tbOrder$1, idx$3, rank$12, N$2, inE$8, eweight$4, etail$20, eminlen$9, outE$8, ehead$20, normal$2) {
  var maxRank = $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__scanAndNormalize$1__I__AZ__AI__I($thiz, N$2, normal$2, rank$12);
  var n = ((1 + maxRank) | 0);
  if ((n <= 0)) {
    var nrank = new $ac_I(0);
  } else {
    var array = new $ac_I(n);
    var i = 0;
    while ((i < n)) {
      array.a[i] = 0;
      i = ((1 + i) | 0);
    }
    var nrank = array;
  }
  if ((!tbOrder$1.c())) {
    var this$5 = new $c_sc_Iterator$$anon$10(tbOrder$1.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((key) => idx$3.r(key))));
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    while (this$5.p()) {
      var elem = this$5.q();
      var unboxedElem = ((elem === null) ? 0 : elem);
      jsElems.push(unboxedElem);
    }
    var arr = new $ac_I(new Int32Array(jsElems));
    var this$9 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_MuslSort$();
    var f$1 = ((x, y) => {
      var x$1 = (x | 0);
      var y$1 = (y | 0);
      var x$2 = rank$12.a[x$1];
      var y$2 = rank$12.a[y$1];
      return ((x$2 === y$2) ? 0 : ((x$2 < y$2) ? (-1) : 1));
    });
    _return: {
      var n$1 = arr.a.length;
      if ((n$1 === 0)) {
        break _return;
      }
      var lp = new $ac_J(96);
      var $x_1 = lp.a;
      $x_1[0] = 1;
      $x_1[1] = 0;
      var $x_2 = lp.a;
      $x_2[2] = 1;
      $x_2[3] = 0;
      var li = 2;
      var last_$_lo = 0;
      var last_$_hi = 0;
      while (true) {
        var $x_3 = lp.a;
        var $x_4 = (((li - 2) | 0) << 1);
        var x$3_$_lo = $x_3[$x_4];
        var x$3_$_hi = $x_3[(($x_4 + 1) | 0)];
        var $x_5 = lp.a;
        var $x_6 = (((li - 1) | 0) << 1);
        var x$4_$_lo = $x_5[$x_6];
        var x$4_$_hi = $x_5[(($x_6 + 1) | 0)];
        var lo = ((x$3_$_lo + x$4_$_lo) | 0);
        var hi = ((((x$3_$_hi + x$4_$_hi) | 0) + (((lo >>> 0) < (x$3_$_lo >>> 0)) | 0)) | 0);
        var lo$1 = ((1 + lo) | 0);
        var hi$1 = ((hi + ((lo$1 === 0) | 0)) | 0);
        last_$_lo = lo$1;
        last_$_hi = hi$1;
        var $x_7 = lp.a;
        var $x_8 = (li << 1);
        $x_7[$x_8] = last_$_lo;
        $x_7[(($x_8 + 1) | 0)] = last_$_hi;
        var x$5_$_lo = last_$_lo;
        var x$5_$_hi = last_$_hi;
        var hi$2 = (n$1 >> 31);
        if (((x$5_$_hi === hi$2) ? ((x$5_$_lo >>> 0) < (n$1 >>> 0)) : (x$5_$_hi < hi$2))) {
          li = ((1 + li) | 0);
        } else {
          break;
        }
      }
      var elem$1_$_lo = 0;
      var elem$1_$_hi = 0;
      elem$1_$_lo = 1;
      elem$1_$_hi = 0;
      var elem$2_$_lo = 0;
      var elem$2_$_hi = 0;
      elem$2_$_lo = 0;
      elem$2_$_hi = 0;
      var pshift = 1;
      var ar = new $ac_I(512);
      var head = 0;
      var high = ((n$1 - 1) | 0);
      while ((head < high)) {
        if (((3 & elem$1_$_lo) === 3)) {
          var head0 = head;
          var pshift0 = pshift;
          var head$1 = head0;
          var ps = pshift0;
          ar.a[0] = head$1;
          var i$1 = 1;
          var stop = false;
          while (((ps > 1) && (!stop))) {
            var rt = ((head$1 - 1) | 0);
            var $x_12 = head$1;
            var $x_10 = lp.a;
            var $x_11 = (((ps - 2) | 0) << 1);
            var $x_9_$_lo = $x_10[$x_11];
            var $x_9_$_hi = $x_10[(($x_11 + 1) | 0)];
            var lf = (((($x_12 - 1) | 0) - $x_9_$_lo) | 0);
            var p$proxy1 = ar.a[0];
            var x0 = arr.a[p$proxy1];
            var x1 = arr.a[lf];
            if (((f$1(x0, x1) | 0) >= 0)) {
              var p$proxy2 = ar.a[0];
              var x0$1 = arr.a[p$proxy2];
              var x1$1 = arr.a[rt];
              var $x_13 = ((f$1(x0$1, x1$1) | 0) >= 0);
            } else {
              var $x_13 = false;
            }
            if ($x_13) {
              stop = true;
            } else {
              var x0$2 = arr.a[lf];
              var x1$2 = arr.a[rt];
              if (((f$1(x0$2, x1$2) | 0) >= 0)) {
                ar.a[i$1] = lf;
                i$1 = ((1 + i$1) | 0);
                head$1 = lf;
                ps = ((ps - 1) | 0);
              } else {
                ar.a[i$1] = rt;
                i$1 = ((1 + i$1) | 0);
                head$1 = rt;
                ps = ((ps - 2) | 0);
              }
            }
          }
          $p_Lorg_jpablo_graphexplorer_graphviz_layout_MuslSort$__cycle$1__AI__AI__I__V(this$9, arr, ar, i$1);
          _return$1: {
            var s = 2;
            if ((s >= 64)) {
              s = ((s - 64) | 0);
              elem$1_$_lo = elem$2_$_lo;
              elem$1_$_hi = elem$2_$_hi;
              elem$2_$_lo = 0;
              elem$2_$_hi = 0;
              if ((s === 0)) {
                break _return$1;
              }
            }
            var x$8_$_lo = elem$1_$_lo;
            var x$8_$_hi = elem$1_$_hi;
            var n$2 = s;
            var lo$3 = (((32 & n$2) === 0) ? (((x$8_$_lo >>> n$2) | 0) | ((x$8_$_hi << 1) << (~n$2))) : ((x$8_$_hi >>> n$2) | 0));
            var hi$3 = (((32 & n$2) === 0) ? ((x$8_$_hi >>> n$2) | 0) : 0);
            var x$9_$_lo = elem$2_$_lo;
            var x$9_$_hi = elem$2_$_hi;
            var n$3 = ((64 - s) | 0);
            var lo$4 = (((32 & n$3) === 0) ? (x$9_$_lo << n$3) : 0);
            var hi$4 = (((32 & n$3) === 0) ? (((((x$9_$_lo >>> 1) | 0) >>> (~n$3)) | 0) | (x$9_$_hi << n$3)) : (x$9_$_lo << n$3));
            var lo$5 = (lo$3 | lo$4);
            var hi$5 = (hi$3 | hi$4);
            elem$1_$_lo = lo$5;
            elem$1_$_hi = hi$5;
            var x$10_$_lo = elem$2_$_lo;
            var x$10_$_hi = elem$2_$_hi;
            var n$4 = s;
            var lo$6 = (((32 & n$4) === 0) ? (((x$10_$_lo >>> n$4) | 0) | ((x$10_$_hi << 1) << (~n$4))) : ((x$10_$_hi >>> n$4) | 0));
            var hi$6 = (((32 & n$4) === 0) ? ((x$10_$_hi >>> n$4) | 0) : 0);
            elem$2_$_lo = lo$6;
            elem$2_$_hi = hi$6;
          }
          pshift = ((2 + pshift) | 0);
        } else {
          var $x_14 = lp.a;
          var $x_15 = (((pshift - 1) | 0) << 1);
          var x$11_$_lo = $x_14[$x_15];
          var x$11_$_hi = $x_14[(($x_15 + 1) | 0)];
          var value = ((high - head) | 0);
          var hi$7 = (value >> 31);
          if (((x$11_$_hi === hi$7) ? ((x$11_$_lo >>> 0) >= (value >>> 0)) : (x$11_$_hi > hi$7))) {
            var head0$1 = head;
            var pp0_$_lo = elem$1_$_lo;
            var pp0_$_hi = elem$1_$_hi;
            var pp1_$_lo = elem$2_$_lo;
            var pp1_$_hi = elem$2_$_hi;
            var pshift0$1 = pshift;
            var head$2 = head0$1;
            var ps$1 = pshift0$1;
            var trusty = false;
            var q0_$_lo = pp0_$_lo;
            var q0_$_hi = pp0_$_hi;
            var q1_$_lo = pp1_$_lo;
            var q1_$_hi = pp1_$_hi;
            ar.a[0] = head$2;
            var i$2 = 1;
            var stop$1 = false;
            while (true) {
              var x$12_$_lo = q0_$_lo;
              var x$12_$_hi = q0_$_hi;
              if ((((1 ^ x$12_$_lo) | x$12_$_hi) !== 0)) {
                var $x_25 = true;
              } else {
                var x$13_$_lo = q1_$_lo;
                var x$13_$_hi = q1_$_hi;
                var $x_25 = ((x$13_$_lo | x$13_$_hi) !== 0);
              }
              if (($x_25 && (!stop$1))) {
                var $x_19 = head$2;
                var $x_17 = lp.a;
                var $x_18 = (ps$1 << 1);
                var $x_16_$_lo = $x_17[$x_18];
                var $x_16_$_hi = $x_17[(($x_18 + 1) | 0)];
                var stepson = (($x_19 - $x_16_$_lo) | 0);
                var q$proxy1 = ar.a[0];
                var x0$3 = arr.a[stepson];
                var x1$3 = arr.a[q$proxy1];
                if (((f$1(x0$3, x1$3) | 0) <= 0)) {
                  stop$1 = true;
                } else {
                  if (((!trusty) && (ps$1 > 1))) {
                    var rt$1 = ((head$2 - 1) | 0);
                    var $x_24 = head$2;
                    var $x_22 = lp.a;
                    var $x_23 = (((ps$1 - 2) | 0) << 1);
                    var $x_21_$_lo = $x_22[$x_23];
                    var $x_21_$_hi = $x_22[(($x_23 + 1) | 0)];
                    var lf$1 = (((($x_24 - 1) | 0) - $x_21_$_lo) | 0);
                    var x0$4 = arr.a[rt$1];
                    var x1$4 = arr.a[stepson];
                    if (((f$1(x0$4, x1$4) | 0) >= 0)) {
                      var $x_20 = true;
                    } else {
                      var x0$5 = arr.a[lf$1];
                      var x1$5 = arr.a[stepson];
                      var $x_20 = ((f$1(x0$5, x1$5) | 0) >= 0);
                    }
                  } else {
                    var $x_20 = false;
                  }
                  if ($x_20) {
                    stop$1 = true;
                  } else {
                    ar.a[i$2] = stepson;
                    i$2 = ((1 + i$2) | 0);
                    head$2 = stepson;
                    var x$16_$_lo = q0_$_lo;
                    var x$16_$_hi = q0_$_hi;
                    if ((((1 ^ x$16_$_lo) | x$16_$_hi) !== 0)) {
                      var x$17_$_lo = q0_$_lo;
                      var x$17_$_hi = q0_$_hi;
                      var lo$7 = ((x$17_$_lo - 1) | 0);
                      var hi$8 = ((((x$17_$_hi - 1) | 0) + ((lo$7 !== (-1)) | 0)) | 0);
                      var trail = ((lo$7 !== 0) ? ((32 - Math.clz32(((~lo$7) & ((lo$7 - 1) | 0)))) | 0) : ((64 - Math.clz32(((~hi$8) & ((hi$8 - 1) | 0)))) | 0));
                    } else {
                      var x$18_$_lo = q1_$_lo;
                      var x$18_$_hi = q1_$_hi;
                      if (((x$18_$_lo | x$18_$_hi) !== 0)) {
                        var l_$_lo = q1_$_lo;
                        var l_$_hi = q1_$_hi;
                        var trail = ((64 + ((l_$_lo !== 0) ? ((32 - Math.clz32(((~l_$_lo) & ((l_$_lo - 1) | 0)))) | 0) : ((64 - Math.clz32(((~l_$_hi) & ((l_$_hi - 1) | 0)))) | 0))) | 0);
                      } else {
                        var trail = 0;
                      }
                    }
                    var s$1 = trail;
                    if ((s$1 >= 64)) {
                      s$1 = ((s$1 - 64) | 0);
                      q0_$_lo = q1_$_lo;
                      q0_$_hi = q1_$_hi;
                      q1_$_lo = 0;
                      q1_$_hi = 0;
                    }
                    if ((s$1 > 0)) {
                      var x$19_$_lo = q0_$_lo;
                      var x$19_$_hi = q0_$_hi;
                      var n$5 = s$1;
                      var lo$8 = (((32 & n$5) === 0) ? (((x$19_$_lo >>> n$5) | 0) | ((x$19_$_hi << 1) << (~n$5))) : ((x$19_$_hi >>> n$5) | 0));
                      var hi$9 = (((32 & n$5) === 0) ? ((x$19_$_hi >>> n$5) | 0) : 0);
                      var x$20_$_lo = q1_$_lo;
                      var x$20_$_hi = q1_$_hi;
                      var n$6 = ((64 - s$1) | 0);
                      var lo$9 = (((32 & n$6) === 0) ? (x$20_$_lo << n$6) : 0);
                      var hi$10 = (((32 & n$6) === 0) ? (((((x$20_$_lo >>> 1) | 0) >>> (~n$6)) | 0) | (x$20_$_hi << n$6)) : (x$20_$_lo << n$6));
                      var lo$10 = (lo$8 | lo$9);
                      var hi$11 = (hi$9 | hi$10);
                      q0_$_lo = lo$10;
                      q0_$_hi = hi$11;
                      var x$21_$_lo = q1_$_lo;
                      var x$21_$_hi = q1_$_hi;
                      var n$7 = s$1;
                      var lo$11 = (((32 & n$7) === 0) ? (((x$21_$_lo >>> n$7) | 0) | ((x$21_$_hi << 1) << (~n$7))) : ((x$21_$_hi >>> n$7) | 0));
                      var hi$12 = (((32 & n$7) === 0) ? ((x$21_$_hi >>> n$7) | 0) : 0);
                      q1_$_lo = lo$11;
                      q1_$_hi = hi$12;
                    }
                    ps$1 = ((ps$1 + trail) | 0);
                    trusty = false;
                  }
                }
              } else {
                break;
              }
            }
            if ((!trusty)) {
              $p_Lorg_jpablo_graphexplorer_graphviz_layout_MuslSort$__cycle$1__AI__AI__I__V(this$9, arr, ar, i$2);
              var head0$2 = head$2;
              var pshift0$2 = ps$1;
              var head$3 = head0$2;
              var ps$2 = pshift0$2;
              ar.a[0] = head$3;
              var i$7 = 1;
              var stop$2 = false;
              while (((ps$2 > 1) && (!stop$2))) {
                var rt$2 = ((head$3 - 1) | 0);
                var $x_29 = head$3;
                var $x_27 = lp.a;
                var $x_28 = (((ps$2 - 2) | 0) << 1);
                var $x_26_$_lo = $x_27[$x_28];
                var $x_26_$_hi = $x_27[(($x_28 + 1) | 0)];
                var lf$2 = (((($x_29 - 1) | 0) - $x_26_$_lo) | 0);
                var p$proxy1$1 = ar.a[0];
                var x0$6 = arr.a[p$proxy1$1];
                var x1$6 = arr.a[lf$2];
                if (((f$1(x0$6, x1$6) | 0) >= 0)) {
                  var p$proxy2$1 = ar.a[0];
                  var x0$7 = arr.a[p$proxy2$1];
                  var x1$7 = arr.a[rt$2];
                  var $x_30 = ((f$1(x0$7, x1$7) | 0) >= 0);
                } else {
                  var $x_30 = false;
                }
                if ($x_30) {
                  stop$2 = true;
                } else {
                  var x0$8 = arr.a[lf$2];
                  var x1$8 = arr.a[rt$2];
                  if (((f$1(x0$8, x1$8) | 0) >= 0)) {
                    ar.a[i$7] = lf$2;
                    i$7 = ((1 + i$7) | 0);
                    head$3 = lf$2;
                    ps$2 = ((ps$2 - 1) | 0);
                  } else {
                    ar.a[i$7] = rt$2;
                    i$7 = ((1 + i$7) | 0);
                    head$3 = rt$2;
                    ps$2 = ((ps$2 - 2) | 0);
                  }
                }
              }
              $p_Lorg_jpablo_graphexplorer_graphviz_layout_MuslSort$__cycle$1__AI__AI__I__V(this$9, arr, ar, i$7);
            }
          } else {
            var head0$3 = head;
            var pshift0$3 = pshift;
            var head$4 = head0$3;
            var ps$3 = pshift0$3;
            ar.a[0] = head$4;
            var i$8 = 1;
            var stop$3 = false;
            while (((ps$3 > 1) && (!stop$3))) {
              var rt$3 = ((head$4 - 1) | 0);
              var $x_34 = head$4;
              var $x_32 = lp.a;
              var $x_33 = (((ps$3 - 2) | 0) << 1);
              var $x_31_$_lo = $x_32[$x_33];
              var $x_31_$_hi = $x_32[(($x_33 + 1) | 0)];
              var lf$3 = (((($x_34 - 1) | 0) - $x_31_$_lo) | 0);
              var p$proxy1$2 = ar.a[0];
              var x0$9 = arr.a[p$proxy1$2];
              var x1$9 = arr.a[lf$3];
              if (((f$1(x0$9, x1$9) | 0) >= 0)) {
                var p$proxy2$2 = ar.a[0];
                var x0$10 = arr.a[p$proxy2$2];
                var x1$10 = arr.a[rt$3];
                var $x_35 = ((f$1(x0$10, x1$10) | 0) >= 0);
              } else {
                var $x_35 = false;
              }
              if ($x_35) {
                stop$3 = true;
              } else {
                var x0$11 = arr.a[lf$3];
                var x1$11 = arr.a[rt$3];
                if (((f$1(x0$11, x1$11) | 0) >= 0)) {
                  ar.a[i$8] = lf$3;
                  i$8 = ((1 + i$8) | 0);
                  head$4 = lf$3;
                  ps$3 = ((ps$3 - 1) | 0);
                } else {
                  ar.a[i$8] = rt$3;
                  i$8 = ((1 + i$8) | 0);
                  head$4 = rt$3;
                  ps$3 = ((ps$3 - 2) | 0);
                }
              }
            }
            $p_Lorg_jpablo_graphexplorer_graphviz_layout_MuslSort$__cycle$1__AI__AI__I__V(this$9, arr, ar, i$8);
          }
          if ((pshift === 1)) {
            _return$2: {
              var s$2 = 1;
              if ((s$2 >= 64)) {
                s$2 = ((s$2 - 64) | 0);
                elem$2_$_lo = elem$1_$_lo;
                elem$2_$_hi = elem$1_$_hi;
                elem$1_$_lo = 0;
                elem$1_$_hi = 0;
                if ((s$2 === 0)) {
                  break _return$2;
                }
              }
              var x$24_$_lo = elem$2_$_lo;
              var x$24_$_hi = elem$2_$_hi;
              var n$8 = s$2;
              var lo$12 = (((32 & n$8) === 0) ? (x$24_$_lo << n$8) : 0);
              var hi$13 = (((32 & n$8) === 0) ? (((((x$24_$_lo >>> 1) | 0) >>> (~n$8)) | 0) | (x$24_$_hi << n$8)) : (x$24_$_lo << n$8));
              var x$25_$_lo = elem$1_$_lo;
              var x$25_$_hi = elem$1_$_hi;
              var n$9 = ((64 - s$2) | 0);
              var lo$13 = (((32 & n$9) === 0) ? (((x$25_$_lo >>> n$9) | 0) | ((x$25_$_hi << 1) << (~n$9))) : ((x$25_$_hi >>> n$9) | 0));
              var hi$14 = (((32 & n$9) === 0) ? ((x$25_$_hi >>> n$9) | 0) : 0);
              var lo$14 = (lo$12 | lo$13);
              var hi$15 = (hi$13 | hi$14);
              elem$2_$_lo = lo$14;
              elem$2_$_hi = hi$15;
              var x$26_$_lo = elem$1_$_lo;
              var x$26_$_hi = elem$1_$_hi;
              var n$10 = s$2;
              var lo$15 = (((32 & n$10) === 0) ? (x$26_$_lo << n$10) : 0);
              var hi$16 = (((32 & n$10) === 0) ? (((((x$26_$_lo >>> 1) | 0) >>> (~n$10)) | 0) | (x$26_$_hi << n$10)) : (x$26_$_lo << n$10));
              elem$1_$_lo = lo$15;
              elem$1_$_hi = hi$16;
            }
            pshift = 0;
          } else {
            var sh = ((pshift - 1) | 0);
            _return$3: {
              var s$3 = sh;
              if ((s$3 >= 64)) {
                s$3 = ((s$3 - 64) | 0);
                elem$2_$_lo = elem$1_$_lo;
                elem$2_$_hi = elem$1_$_hi;
                elem$1_$_lo = 0;
                elem$1_$_hi = 0;
                if ((s$3 === 0)) {
                  break _return$3;
                }
              }
              var x$27_$_lo = elem$2_$_lo;
              var x$27_$_hi = elem$2_$_hi;
              var n$11 = s$3;
              var lo$16 = (((32 & n$11) === 0) ? (x$27_$_lo << n$11) : 0);
              var hi$17 = (((32 & n$11) === 0) ? (((((x$27_$_lo >>> 1) | 0) >>> (~n$11)) | 0) | (x$27_$_hi << n$11)) : (x$27_$_lo << n$11));
              var x$28_$_lo = elem$1_$_lo;
              var x$28_$_hi = elem$1_$_hi;
              var n$12 = ((64 - s$3) | 0);
              var lo$17 = (((32 & n$12) === 0) ? (((x$28_$_lo >>> n$12) | 0) | ((x$28_$_hi << 1) << (~n$12))) : ((x$28_$_hi >>> n$12) | 0));
              var hi$18 = (((32 & n$12) === 0) ? ((x$28_$_hi >>> n$12) | 0) : 0);
              var lo$18 = (lo$16 | lo$17);
              var hi$19 = (hi$17 | hi$18);
              elem$2_$_lo = lo$18;
              elem$2_$_hi = hi$19;
              var x$29_$_lo = elem$1_$_lo;
              var x$29_$_hi = elem$1_$_hi;
              var n$13 = s$3;
              var lo$19 = (((32 & n$13) === 0) ? (x$29_$_lo << n$13) : 0);
              var hi$20 = (((32 & n$13) === 0) ? (((((x$29_$_lo >>> 1) | 0) >>> (~n$13)) | 0) | (x$29_$_hi << n$13)) : (x$29_$_lo << n$13));
              elem$1_$_lo = lo$19;
              elem$1_$_hi = hi$20;
            }
            pshift = 1;
          }
        }
        var x$30_$_lo = elem$1_$_lo;
        var x$30_$_hi = elem$1_$_hi;
        var lo$20 = (1 | x$30_$_lo);
        elem$1_$_lo = lo$20;
        elem$1_$_hi = x$30_$_hi;
        head = ((1 + head) | 0);
      }
      var head0$4 = head;
      var pp0$1_$_lo = elem$1_$_lo;
      var pp0$1_$_hi = elem$1_$_hi;
      var pp1$1_$_lo = elem$2_$_lo;
      var pp1$1_$_hi = elem$2_$_hi;
      var pshift0$4 = pshift;
      var head$5 = head0$4;
      var ps$4 = pshift0$4;
      var trusty$1 = false;
      var q0$1_$_lo = pp0$1_$_lo;
      var q0$1_$_hi = pp0$1_$_hi;
      var q1$1_$_lo = pp1$1_$_lo;
      var q1$1_$_hi = pp1$1_$_hi;
      ar.a[0] = head$5;
      var i$9 = 1;
      var stop$4 = false;
      while (true) {
        var x$31_$_lo = q0$1_$_lo;
        var x$31_$_hi = q0$1_$_hi;
        if ((((1 ^ x$31_$_lo) | x$31_$_hi) !== 0)) {
          var $x_45 = true;
        } else {
          var x$32_$_lo = q1$1_$_lo;
          var x$32_$_hi = q1$1_$_hi;
          var $x_45 = ((x$32_$_lo | x$32_$_hi) !== 0);
        }
        if (($x_45 && (!stop$4))) {
          var $x_39 = head$5;
          var $x_37 = lp.a;
          var $x_38 = (ps$4 << 1);
          var $x_36_$_lo = $x_37[$x_38];
          var $x_36_$_hi = $x_37[(($x_38 + 1) | 0)];
          var stepson$1 = (($x_39 - $x_36_$_lo) | 0);
          var q$proxy1$1 = ar.a[0];
          var x0$12 = arr.a[stepson$1];
          var x1$12 = arr.a[q$proxy1$1];
          if (((f$1(x0$12, x1$12) | 0) <= 0)) {
            stop$4 = true;
          } else {
            if (((!trusty$1) && (ps$4 > 1))) {
              var rt$4 = ((head$5 - 1) | 0);
              var $x_44 = head$5;
              var $x_42 = lp.a;
              var $x_43 = (((ps$4 - 2) | 0) << 1);
              var $x_41_$_lo = $x_42[$x_43];
              var $x_41_$_hi = $x_42[(($x_43 + 1) | 0)];
              var lf$4 = (((($x_44 - 1) | 0) - $x_41_$_lo) | 0);
              var x0$13 = arr.a[rt$4];
              var x1$13 = arr.a[stepson$1];
              if (((f$1(x0$13, x1$13) | 0) >= 0)) {
                var $x_40 = true;
              } else {
                var x0$14 = arr.a[lf$4];
                var x1$14 = arr.a[stepson$1];
                var $x_40 = ((f$1(x0$14, x1$14) | 0) >= 0);
              }
            } else {
              var $x_40 = false;
            }
            if ($x_40) {
              stop$4 = true;
            } else {
              ar.a[i$9] = stepson$1;
              i$9 = ((1 + i$9) | 0);
              head$5 = stepson$1;
              var x$35_$_lo = q0$1_$_lo;
              var x$35_$_hi = q0$1_$_hi;
              if ((((1 ^ x$35_$_lo) | x$35_$_hi) !== 0)) {
                var x$36_$_lo = q0$1_$_lo;
                var x$36_$_hi = q0$1_$_hi;
                var lo$21 = ((x$36_$_lo - 1) | 0);
                var hi$21 = ((((x$36_$_hi - 1) | 0) + ((lo$21 !== (-1)) | 0)) | 0);
                var trail$1 = ((lo$21 !== 0) ? ((32 - Math.clz32(((~lo$21) & ((lo$21 - 1) | 0)))) | 0) : ((64 - Math.clz32(((~hi$21) & ((hi$21 - 1) | 0)))) | 0));
              } else {
                var x$37_$_lo = q1$1_$_lo;
                var x$37_$_hi = q1$1_$_hi;
                if (((x$37_$_lo | x$37_$_hi) !== 0)) {
                  var l$1_$_lo = q1$1_$_lo;
                  var l$1_$_hi = q1$1_$_hi;
                  var trail$1 = ((64 + ((l$1_$_lo !== 0) ? ((32 - Math.clz32(((~l$1_$_lo) & ((l$1_$_lo - 1) | 0)))) | 0) : ((64 - Math.clz32(((~l$1_$_hi) & ((l$1_$_hi - 1) | 0)))) | 0))) | 0);
                } else {
                  var trail$1 = 0;
                }
              }
              var s$4 = trail$1;
              if ((s$4 >= 64)) {
                s$4 = ((s$4 - 64) | 0);
                q0$1_$_lo = q1$1_$_lo;
                q0$1_$_hi = q1$1_$_hi;
                q1$1_$_lo = 0;
                q1$1_$_hi = 0;
              }
              if ((s$4 > 0)) {
                var x$38_$_lo = q0$1_$_lo;
                var x$38_$_hi = q0$1_$_hi;
                var n$14 = s$4;
                var lo$22 = (((32 & n$14) === 0) ? (((x$38_$_lo >>> n$14) | 0) | ((x$38_$_hi << 1) << (~n$14))) : ((x$38_$_hi >>> n$14) | 0));
                var hi$22 = (((32 & n$14) === 0) ? ((x$38_$_hi >>> n$14) | 0) : 0);
                var x$39_$_lo = q1$1_$_lo;
                var x$39_$_hi = q1$1_$_hi;
                var n$15 = ((64 - s$4) | 0);
                var lo$23 = (((32 & n$15) === 0) ? (x$39_$_lo << n$15) : 0);
                var hi$23 = (((32 & n$15) === 0) ? (((((x$39_$_lo >>> 1) | 0) >>> (~n$15)) | 0) | (x$39_$_hi << n$15)) : (x$39_$_lo << n$15));
                var lo$24 = (lo$22 | lo$23);
                var hi$24 = (hi$22 | hi$23);
                q0$1_$_lo = lo$24;
                q0$1_$_hi = hi$24;
                var x$40_$_lo = q1$1_$_lo;
                var x$40_$_hi = q1$1_$_hi;
                var n$16 = s$4;
                var lo$25 = (((32 & n$16) === 0) ? (((x$40_$_lo >>> n$16) | 0) | ((x$40_$_hi << 1) << (~n$16))) : ((x$40_$_hi >>> n$16) | 0));
                var hi$25 = (((32 & n$16) === 0) ? ((x$40_$_hi >>> n$16) | 0) : 0);
                q1$1_$_lo = lo$25;
                q1$1_$_hi = hi$25;
              }
              ps$4 = ((ps$4 + trail$1) | 0);
              trusty$1 = false;
            }
          }
        } else {
          break;
        }
      }
      if ((!trusty$1)) {
        $p_Lorg_jpablo_graphexplorer_graphviz_layout_MuslSort$__cycle$1__AI__AI__I__V(this$9, arr, ar, i$9);
        var head0$5 = head$5;
        var pshift0$5 = ps$4;
        var head$6 = head0$5;
        var ps$5 = pshift0$5;
        ar.a[0] = head$6;
        var i$14 = 1;
        var stop$5 = false;
        while (((ps$5 > 1) && (!stop$5))) {
          var rt$5 = ((head$6 - 1) | 0);
          var $x_49 = head$6;
          var $x_47 = lp.a;
          var $x_48 = (((ps$5 - 2) | 0) << 1);
          var $x_46_$_lo = $x_47[$x_48];
          var $x_46_$_hi = $x_47[(($x_48 + 1) | 0)];
          var lf$5 = (((($x_49 - 1) | 0) - $x_46_$_lo) | 0);
          var p$proxy1$3 = ar.a[0];
          var x0$15 = arr.a[p$proxy1$3];
          var x1$15 = arr.a[lf$5];
          if (((f$1(x0$15, x1$15) | 0) >= 0)) {
            var p$proxy2$3 = ar.a[0];
            var x0$16 = arr.a[p$proxy2$3];
            var x1$16 = arr.a[rt$5];
            var $x_50 = ((f$1(x0$16, x1$16) | 0) >= 0);
          } else {
            var $x_50 = false;
          }
          if ($x_50) {
            stop$5 = true;
          } else {
            var x0$17 = arr.a[lf$5];
            var x1$17 = arr.a[rt$5];
            if (((f$1(x0$17, x1$17) | 0) >= 0)) {
              ar.a[i$14] = lf$5;
              i$14 = ((1 + i$14) | 0);
              head$6 = lf$5;
              ps$5 = ((ps$5 - 1) | 0);
            } else {
              ar.a[i$14] = rt$5;
              i$14 = ((1 + i$14) | 0);
              head$6 = rt$5;
              ps$5 = ((ps$5 - 2) | 0);
            }
          }
        }
        $p_Lorg_jpablo_graphexplorer_graphviz_layout_MuslSort$__cycle$1__AI__AI__I__V(this$9, arr, ar, i$14);
      }
      while (true) {
        if ((pshift !== 1)) {
          var $x_86 = true;
        } else {
          var x$42_$_lo = elem$1_$_lo;
          var x$42_$_hi = elem$1_$_hi;
          var $x_86 = (((1 ^ x$42_$_lo) | x$42_$_hi) !== 0);
        }
        if ($x_86) {
          var $x_85 = true;
        } else {
          var x$43_$_lo = elem$2_$_lo;
          var x$43_$_hi = elem$2_$_hi;
          var $x_85 = ((x$43_$_lo | x$43_$_hi) !== 0);
        }
        if ($x_85) {
          if ((pshift <= 1)) {
            var x$44_$_lo = elem$1_$_lo;
            var x$44_$_hi = elem$1_$_hi;
            if ((((1 ^ x$44_$_lo) | x$44_$_hi) !== 0)) {
              var x$45_$_lo = elem$1_$_lo;
              var x$45_$_hi = elem$1_$_hi;
              var lo$26 = ((x$45_$_lo - 1) | 0);
              var hi$26 = ((((x$45_$_hi - 1) | 0) + ((lo$26 !== (-1)) | 0)) | 0);
              var trail$2 = ((lo$26 !== 0) ? ((32 - Math.clz32(((~lo$26) & ((lo$26 - 1) | 0)))) | 0) : ((64 - Math.clz32(((~hi$26) & ((hi$26 - 1) | 0)))) | 0));
            } else {
              var x$46_$_lo = elem$2_$_lo;
              var x$46_$_hi = elem$2_$_hi;
              if (((x$46_$_lo | x$46_$_hi) !== 0)) {
                var l$2_$_lo = elem$2_$_lo;
                var l$2_$_hi = elem$2_$_hi;
                var trail$2 = ((64 + ((l$2_$_lo !== 0) ? ((32 - Math.clz32(((~l$2_$_lo) & ((l$2_$_lo - 1) | 0)))) | 0) : ((64 - Math.clz32(((~l$2_$_hi) & ((l$2_$_hi - 1) | 0)))) | 0))) | 0);
              } else {
                var trail$2 = 0;
              }
            }
            _return$4: {
              var s$5 = trail$2;
              if ((s$5 >= 64)) {
                s$5 = ((s$5 - 64) | 0);
                elem$1_$_lo = elem$2_$_lo;
                elem$1_$_hi = elem$2_$_hi;
                elem$2_$_lo = 0;
                elem$2_$_hi = 0;
                if ((s$5 === 0)) {
                  break _return$4;
                }
              }
              var x$47_$_lo = elem$1_$_lo;
              var x$47_$_hi = elem$1_$_hi;
              var n$17 = s$5;
              var lo$27 = (((32 & n$17) === 0) ? (((x$47_$_lo >>> n$17) | 0) | ((x$47_$_hi << 1) << (~n$17))) : ((x$47_$_hi >>> n$17) | 0));
              var hi$27 = (((32 & n$17) === 0) ? ((x$47_$_hi >>> n$17) | 0) : 0);
              var x$48_$_lo = elem$2_$_lo;
              var x$48_$_hi = elem$2_$_hi;
              var n$18 = ((64 - s$5) | 0);
              var lo$28 = (((32 & n$18) === 0) ? (x$48_$_lo << n$18) : 0);
              var hi$28 = (((32 & n$18) === 0) ? (((((x$48_$_lo >>> 1) | 0) >>> (~n$18)) | 0) | (x$48_$_hi << n$18)) : (x$48_$_lo << n$18));
              var lo$29 = (lo$27 | lo$28);
              var hi$29 = (hi$27 | hi$28);
              elem$1_$_lo = lo$29;
              elem$1_$_hi = hi$29;
              var x$49_$_lo = elem$2_$_lo;
              var x$49_$_hi = elem$2_$_hi;
              var n$19 = s$5;
              var lo$30 = (((32 & n$19) === 0) ? (((x$49_$_lo >>> n$19) | 0) | ((x$49_$_hi << 1) << (~n$19))) : ((x$49_$_hi >>> n$19) | 0));
              var hi$30 = (((32 & n$19) === 0) ? ((x$49_$_hi >>> n$19) | 0) : 0);
              elem$2_$_lo = lo$30;
              elem$2_$_hi = hi$30;
            }
            pshift = ((pshift + trail$2) | 0);
          } else {
            _return$5: {
              var s$6 = 2;
              if ((s$6 >= 64)) {
                s$6 = ((s$6 - 64) | 0);
                elem$2_$_lo = elem$1_$_lo;
                elem$2_$_hi = elem$1_$_hi;
                elem$1_$_lo = 0;
                elem$1_$_hi = 0;
                if ((s$6 === 0)) {
                  break _return$5;
                }
              }
              var x$50_$_lo = elem$2_$_lo;
              var x$50_$_hi = elem$2_$_hi;
              var n$20 = s$6;
              var lo$31 = (((32 & n$20) === 0) ? (x$50_$_lo << n$20) : 0);
              var hi$31 = (((32 & n$20) === 0) ? (((((x$50_$_lo >>> 1) | 0) >>> (~n$20)) | 0) | (x$50_$_hi << n$20)) : (x$50_$_lo << n$20));
              var x$51_$_lo = elem$1_$_lo;
              var x$51_$_hi = elem$1_$_hi;
              var n$21 = ((64 - s$6) | 0);
              var lo$32 = (((32 & n$21) === 0) ? (((x$51_$_lo >>> n$21) | 0) | ((x$51_$_hi << 1) << (~n$21))) : ((x$51_$_hi >>> n$21) | 0));
              var hi$32 = (((32 & n$21) === 0) ? ((x$51_$_hi >>> n$21) | 0) : 0);
              var lo$33 = (lo$31 | lo$32);
              var hi$33 = (hi$31 | hi$32);
              elem$2_$_lo = lo$33;
              elem$2_$_hi = hi$33;
              var x$52_$_lo = elem$1_$_lo;
              var x$52_$_hi = elem$1_$_hi;
              var n$22 = s$6;
              var lo$34 = (((32 & n$22) === 0) ? (x$52_$_lo << n$22) : 0);
              var hi$34 = (((32 & n$22) === 0) ? (((((x$52_$_lo >>> 1) | 0) >>> (~n$22)) | 0) | (x$52_$_hi << n$22)) : (x$52_$_lo << n$22));
              elem$1_$_lo = lo$34;
              elem$1_$_hi = hi$34;
            }
            pshift = ((pshift - 2) | 0);
            var x$53_$_lo = elem$1_$_lo;
            var x$53_$_hi = elem$1_$_hi;
            var lo$35 = (7 ^ x$53_$_lo);
            elem$1_$_lo = lo$35;
            elem$1_$_hi = x$53_$_hi;
            _return$6: {
              var s$7 = 1;
              if ((s$7 >= 64)) {
                s$7 = ((s$7 - 64) | 0);
                elem$1_$_lo = elem$2_$_lo;
                elem$1_$_hi = elem$2_$_hi;
                elem$2_$_lo = 0;
                elem$2_$_hi = 0;
                if ((s$7 === 0)) {
                  break _return$6;
                }
              }
              var x$54_$_lo = elem$1_$_lo;
              var x$54_$_hi = elem$1_$_hi;
              var n$23 = s$7;
              var lo$36 = (((32 & n$23) === 0) ? (((x$54_$_lo >>> n$23) | 0) | ((x$54_$_hi << 1) << (~n$23))) : ((x$54_$_hi >>> n$23) | 0));
              var hi$35 = (((32 & n$23) === 0) ? ((x$54_$_hi >>> n$23) | 0) : 0);
              var x$55_$_lo = elem$2_$_lo;
              var x$55_$_hi = elem$2_$_hi;
              var n$24 = ((64 - s$7) | 0);
              var lo$37 = (((32 & n$24) === 0) ? (x$55_$_lo << n$24) : 0);
              var hi$36 = (((32 & n$24) === 0) ? (((((x$55_$_lo >>> 1) | 0) >>> (~n$24)) | 0) | (x$55_$_hi << n$24)) : (x$55_$_lo << n$24));
              var lo$38 = (lo$36 | lo$37);
              var hi$37 = (hi$35 | hi$36);
              elem$1_$_lo = lo$38;
              elem$1_$_hi = hi$37;
              var x$56_$_lo = elem$2_$_lo;
              var x$56_$_hi = elem$2_$_hi;
              var n$25 = s$7;
              var lo$39 = (((32 & n$25) === 0) ? (((x$56_$_lo >>> n$25) | 0) | ((x$56_$_hi << 1) << (~n$25))) : ((x$56_$_hi >>> n$25) | 0));
              var hi$38 = (((32 & n$25) === 0) ? ((x$56_$_hi >>> n$25) | 0) : 0);
              elem$2_$_lo = lo$39;
              elem$2_$_hi = hi$38;
            }
            var $x_54 = head;
            var $x_52 = lp.a;
            var $x_53 = (pshift << 1);
            var $x_51_$_lo = $x_52[$x_53];
            var $x_51_$_hi = $x_52[(($x_53 + 1) | 0)];
            var head0$6 = (((($x_54 - $x_51_$_lo) | 0) - 1) | 0);
            var pp0$2_$_lo = elem$1_$_lo;
            var pp0$2_$_hi = elem$1_$_hi;
            var pp1$2_$_lo = elem$2_$_lo;
            var pp1$2_$_hi = elem$2_$_hi;
            var pshift0$6 = ((1 + pshift) | 0);
            var head$7 = head0$6;
            var ps$6 = pshift0$6;
            var trusty$2 = true;
            var q0$2_$_lo = pp0$2_$_lo;
            var q0$2_$_hi = pp0$2_$_hi;
            var q1$2_$_lo = pp1$2_$_lo;
            var q1$2_$_hi = pp1$2_$_hi;
            ar.a[0] = head$7;
            var i$19 = 1;
            var stop$6 = false;
            while (true) {
              var x$58_$_lo = q0$2_$_lo;
              var x$58_$_hi = q0$2_$_hi;
              if ((((1 ^ x$58_$_lo) | x$58_$_hi) !== 0)) {
                var $x_64 = true;
              } else {
                var x$59_$_lo = q1$2_$_lo;
                var x$59_$_hi = q1$2_$_hi;
                var $x_64 = ((x$59_$_lo | x$59_$_hi) !== 0);
              }
              if (($x_64 && (!stop$6))) {
                var $x_58 = head$7;
                var $x_56 = lp.a;
                var $x_57 = (ps$6 << 1);
                var $x_55_$_lo = $x_56[$x_57];
                var $x_55_$_hi = $x_56[(($x_57 + 1) | 0)];
                var stepson$2 = (($x_58 - $x_55_$_lo) | 0);
                var q$proxy1$2 = ar.a[0];
                var x0$18 = arr.a[stepson$2];
                var x1$18 = arr.a[q$proxy1$2];
                if (((f$1(x0$18, x1$18) | 0) <= 0)) {
                  stop$6 = true;
                } else {
                  if (((!trusty$2) && (ps$6 > 1))) {
                    var rt$6 = ((head$7 - 1) | 0);
                    var $x_63 = head$7;
                    var $x_61 = lp.a;
                    var $x_62 = (((ps$6 - 2) | 0) << 1);
                    var $x_60_$_lo = $x_61[$x_62];
                    var $x_60_$_hi = $x_61[(($x_62 + 1) | 0)];
                    var lf$6 = (((($x_63 - 1) | 0) - $x_60_$_lo) | 0);
                    var x0$19 = arr.a[rt$6];
                    var x1$19 = arr.a[stepson$2];
                    if (((f$1(x0$19, x1$19) | 0) >= 0)) {
                      var $x_59 = true;
                    } else {
                      var x0$20 = arr.a[lf$6];
                      var x1$20 = arr.a[stepson$2];
                      var $x_59 = ((f$1(x0$20, x1$20) | 0) >= 0);
                    }
                  } else {
                    var $x_59 = false;
                  }
                  if ($x_59) {
                    stop$6 = true;
                  } else {
                    ar.a[i$19] = stepson$2;
                    i$19 = ((1 + i$19) | 0);
                    head$7 = stepson$2;
                    var x$62_$_lo = q0$2_$_lo;
                    var x$62_$_hi = q0$2_$_hi;
                    if ((((1 ^ x$62_$_lo) | x$62_$_hi) !== 0)) {
                      var x$63_$_lo = q0$2_$_lo;
                      var x$63_$_hi = q0$2_$_hi;
                      var lo$40 = ((x$63_$_lo - 1) | 0);
                      var hi$39 = ((((x$63_$_hi - 1) | 0) + ((lo$40 !== (-1)) | 0)) | 0);
                      var trail$3 = ((lo$40 !== 0) ? ((32 - Math.clz32(((~lo$40) & ((lo$40 - 1) | 0)))) | 0) : ((64 - Math.clz32(((~hi$39) & ((hi$39 - 1) | 0)))) | 0));
                    } else {
                      var x$64_$_lo = q1$2_$_lo;
                      var x$64_$_hi = q1$2_$_hi;
                      if (((x$64_$_lo | x$64_$_hi) !== 0)) {
                        var l$3_$_lo = q1$2_$_lo;
                        var l$3_$_hi = q1$2_$_hi;
                        var trail$3 = ((64 + ((l$3_$_lo !== 0) ? ((32 - Math.clz32(((~l$3_$_lo) & ((l$3_$_lo - 1) | 0)))) | 0) : ((64 - Math.clz32(((~l$3_$_hi) & ((l$3_$_hi - 1) | 0)))) | 0))) | 0);
                      } else {
                        var trail$3 = 0;
                      }
                    }
                    var s$8 = trail$3;
                    if ((s$8 >= 64)) {
                      s$8 = ((s$8 - 64) | 0);
                      q0$2_$_lo = q1$2_$_lo;
                      q0$2_$_hi = q1$2_$_hi;
                      q1$2_$_lo = 0;
                      q1$2_$_hi = 0;
                    }
                    if ((s$8 > 0)) {
                      var x$65_$_lo = q0$2_$_lo;
                      var x$65_$_hi = q0$2_$_hi;
                      var n$26 = s$8;
                      var lo$41 = (((32 & n$26) === 0) ? (((x$65_$_lo >>> n$26) | 0) | ((x$65_$_hi << 1) << (~n$26))) : ((x$65_$_hi >>> n$26) | 0));
                      var hi$40 = (((32 & n$26) === 0) ? ((x$65_$_hi >>> n$26) | 0) : 0);
                      var x$66_$_lo = q1$2_$_lo;
                      var x$66_$_hi = q1$2_$_hi;
                      var n$27 = ((64 - s$8) | 0);
                      var lo$42 = (((32 & n$27) === 0) ? (x$66_$_lo << n$27) : 0);
                      var hi$41 = (((32 & n$27) === 0) ? (((((x$66_$_lo >>> 1) | 0) >>> (~n$27)) | 0) | (x$66_$_hi << n$27)) : (x$66_$_lo << n$27));
                      var lo$43 = (lo$41 | lo$42);
                      var hi$42 = (hi$40 | hi$41);
                      q0$2_$_lo = lo$43;
                      q0$2_$_hi = hi$42;
                      var x$67_$_lo = q1$2_$_lo;
                      var x$67_$_hi = q1$2_$_hi;
                      var n$28 = s$8;
                      var lo$44 = (((32 & n$28) === 0) ? (((x$67_$_lo >>> n$28) | 0) | ((x$67_$_hi << 1) << (~n$28))) : ((x$67_$_hi >>> n$28) | 0));
                      var hi$43 = (((32 & n$28) === 0) ? ((x$67_$_hi >>> n$28) | 0) : 0);
                      q1$2_$_lo = lo$44;
                      q1$2_$_hi = hi$43;
                    }
                    ps$6 = ((ps$6 + trail$3) | 0);
                    trusty$2 = false;
                  }
                }
              } else {
                break;
              }
            }
            if ((!trusty$2)) {
              $p_Lorg_jpablo_graphexplorer_graphviz_layout_MuslSort$__cycle$1__AI__AI__I__V(this$9, arr, ar, i$19);
              var head0$7 = head$7;
              var pshift0$7 = ps$6;
              var head$8 = head0$7;
              var ps$7 = pshift0$7;
              ar.a[0] = head$8;
              var i$24 = 1;
              var stop$7 = false;
              while (((ps$7 > 1) && (!stop$7))) {
                var rt$7 = ((head$8 - 1) | 0);
                var $x_68 = head$8;
                var $x_66 = lp.a;
                var $x_67 = (((ps$7 - 2) | 0) << 1);
                var $x_65_$_lo = $x_66[$x_67];
                var $x_65_$_hi = $x_66[(($x_67 + 1) | 0)];
                var lf$7 = (((($x_68 - 1) | 0) - $x_65_$_lo) | 0);
                var p$proxy1$4 = ar.a[0];
                var x0$21 = arr.a[p$proxy1$4];
                var x1$21 = arr.a[lf$7];
                if (((f$1(x0$21, x1$21) | 0) >= 0)) {
                  var p$proxy2$4 = ar.a[0];
                  var x0$22 = arr.a[p$proxy2$4];
                  var x1$22 = arr.a[rt$7];
                  var $x_69 = ((f$1(x0$22, x1$22) | 0) >= 0);
                } else {
                  var $x_69 = false;
                }
                if ($x_69) {
                  stop$7 = true;
                } else {
                  var x0$23 = arr.a[lf$7];
                  var x1$23 = arr.a[rt$7];
                  if (((f$1(x0$23, x1$23) | 0) >= 0)) {
                    ar.a[i$24] = lf$7;
                    i$24 = ((1 + i$24) | 0);
                    head$8 = lf$7;
                    ps$7 = ((ps$7 - 1) | 0);
                  } else {
                    ar.a[i$24] = rt$7;
                    i$24 = ((1 + i$24) | 0);
                    head$8 = rt$7;
                    ps$7 = ((ps$7 - 2) | 0);
                  }
                }
              }
              $p_Lorg_jpablo_graphexplorer_graphviz_layout_MuslSort$__cycle$1__AI__AI__I__V(this$9, arr, ar, i$24);
            }
            _return$7: {
              var s$9 = 1;
              if ((s$9 >= 64)) {
                s$9 = ((s$9 - 64) | 0);
                elem$2_$_lo = elem$1_$_lo;
                elem$2_$_hi = elem$1_$_hi;
                elem$1_$_lo = 0;
                elem$1_$_hi = 0;
                if ((s$9 === 0)) {
                  break _return$7;
                }
              }
              var x$69_$_lo = elem$2_$_lo;
              var x$69_$_hi = elem$2_$_hi;
              var n$29 = s$9;
              var lo$45 = (((32 & n$29) === 0) ? (x$69_$_lo << n$29) : 0);
              var hi$44 = (((32 & n$29) === 0) ? (((((x$69_$_lo >>> 1) | 0) >>> (~n$29)) | 0) | (x$69_$_hi << n$29)) : (x$69_$_lo << n$29));
              var x$70_$_lo = elem$1_$_lo;
              var x$70_$_hi = elem$1_$_hi;
              var n$30 = ((64 - s$9) | 0);
              var lo$46 = (((32 & n$30) === 0) ? (((x$70_$_lo >>> n$30) | 0) | ((x$70_$_hi << 1) << (~n$30))) : ((x$70_$_hi >>> n$30) | 0));
              var hi$45 = (((32 & n$30) === 0) ? ((x$70_$_hi >>> n$30) | 0) : 0);
              var lo$47 = (lo$45 | lo$46);
              var hi$46 = (hi$44 | hi$45);
              elem$2_$_lo = lo$47;
              elem$2_$_hi = hi$46;
              var x$71_$_lo = elem$1_$_lo;
              var x$71_$_hi = elem$1_$_hi;
              var n$31 = s$9;
              var lo$48 = (((32 & n$31) === 0) ? (x$71_$_lo << n$31) : 0);
              var hi$47 = (((32 & n$31) === 0) ? (((((x$71_$_lo >>> 1) | 0) >>> (~n$31)) | 0) | (x$71_$_hi << n$31)) : (x$71_$_lo << n$31));
              elem$1_$_lo = lo$48;
              elem$1_$_hi = hi$47;
            }
            var x$72_$_lo = elem$1_$_lo;
            var x$72_$_hi = elem$1_$_hi;
            var lo$49 = (1 | x$72_$_lo);
            elem$1_$_lo = lo$49;
            elem$1_$_hi = x$72_$_hi;
            var head0$8 = ((head - 1) | 0);
            var pp0$3_$_lo = elem$1_$_lo;
            var pp0$3_$_hi = elem$1_$_hi;
            var pp1$3_$_lo = elem$2_$_lo;
            var pp1$3_$_hi = elem$2_$_hi;
            var pshift0$8 = pshift;
            var head$9 = head0$8;
            var ps$8 = pshift0$8;
            var trusty$3 = true;
            var q0$3_$_lo = pp0$3_$_lo;
            var q0$3_$_hi = pp0$3_$_hi;
            var q1$3_$_lo = pp1$3_$_lo;
            var q1$3_$_hi = pp1$3_$_hi;
            ar.a[0] = head$9;
            var i$25 = 1;
            var stop$8 = false;
            while (true) {
              var x$73_$_lo = q0$3_$_lo;
              var x$73_$_hi = q0$3_$_hi;
              if ((((1 ^ x$73_$_lo) | x$73_$_hi) !== 0)) {
                var $x_79 = true;
              } else {
                var x$74_$_lo = q1$3_$_lo;
                var x$74_$_hi = q1$3_$_hi;
                var $x_79 = ((x$74_$_lo | x$74_$_hi) !== 0);
              }
              if (($x_79 && (!stop$8))) {
                var $x_73 = head$9;
                var $x_71 = lp.a;
                var $x_72 = (ps$8 << 1);
                var $x_70_$_lo = $x_71[$x_72];
                var $x_70_$_hi = $x_71[(($x_72 + 1) | 0)];
                var stepson$3 = (($x_73 - $x_70_$_lo) | 0);
                var q$proxy1$3 = ar.a[0];
                var x0$24 = arr.a[stepson$3];
                var x1$24 = arr.a[q$proxy1$3];
                if (((f$1(x0$24, x1$24) | 0) <= 0)) {
                  stop$8 = true;
                } else {
                  if (((!trusty$3) && (ps$8 > 1))) {
                    var rt$8 = ((head$9 - 1) | 0);
                    var $x_78 = head$9;
                    var $x_76 = lp.a;
                    var $x_77 = (((ps$8 - 2) | 0) << 1);
                    var $x_75_$_lo = $x_76[$x_77];
                    var $x_75_$_hi = $x_76[(($x_77 + 1) | 0)];
                    var lf$8 = (((($x_78 - 1) | 0) - $x_75_$_lo) | 0);
                    var x0$25 = arr.a[rt$8];
                    var x1$25 = arr.a[stepson$3];
                    if (((f$1(x0$25, x1$25) | 0) >= 0)) {
                      var $x_74 = true;
                    } else {
                      var x0$26 = arr.a[lf$8];
                      var x1$26 = arr.a[stepson$3];
                      var $x_74 = ((f$1(x0$26, x1$26) | 0) >= 0);
                    }
                  } else {
                    var $x_74 = false;
                  }
                  if ($x_74) {
                    stop$8 = true;
                  } else {
                    ar.a[i$25] = stepson$3;
                    i$25 = ((1 + i$25) | 0);
                    head$9 = stepson$3;
                    var x$77_$_lo = q0$3_$_lo;
                    var x$77_$_hi = q0$3_$_hi;
                    if ((((1 ^ x$77_$_lo) | x$77_$_hi) !== 0)) {
                      var x$78_$_lo = q0$3_$_lo;
                      var x$78_$_hi = q0$3_$_hi;
                      var lo$50 = ((x$78_$_lo - 1) | 0);
                      var hi$48 = ((((x$78_$_hi - 1) | 0) + ((lo$50 !== (-1)) | 0)) | 0);
                      var trail$4 = ((lo$50 !== 0) ? ((32 - Math.clz32(((~lo$50) & ((lo$50 - 1) | 0)))) | 0) : ((64 - Math.clz32(((~hi$48) & ((hi$48 - 1) | 0)))) | 0));
                    } else {
                      var x$79_$_lo = q1$3_$_lo;
                      var x$79_$_hi = q1$3_$_hi;
                      if (((x$79_$_lo | x$79_$_hi) !== 0)) {
                        var l$4_$_lo = q1$3_$_lo;
                        var l$4_$_hi = q1$3_$_hi;
                        var trail$4 = ((64 + ((l$4_$_lo !== 0) ? ((32 - Math.clz32(((~l$4_$_lo) & ((l$4_$_lo - 1) | 0)))) | 0) : ((64 - Math.clz32(((~l$4_$_hi) & ((l$4_$_hi - 1) | 0)))) | 0))) | 0);
                      } else {
                        var trail$4 = 0;
                      }
                    }
                    var s$10 = trail$4;
                    if ((s$10 >= 64)) {
                      s$10 = ((s$10 - 64) | 0);
                      q0$3_$_lo = q1$3_$_lo;
                      q0$3_$_hi = q1$3_$_hi;
                      q1$3_$_lo = 0;
                      q1$3_$_hi = 0;
                    }
                    if ((s$10 > 0)) {
                      var x$80_$_lo = q0$3_$_lo;
                      var x$80_$_hi = q0$3_$_hi;
                      var n$32 = s$10;
                      var lo$51 = (((32 & n$32) === 0) ? (((x$80_$_lo >>> n$32) | 0) | ((x$80_$_hi << 1) << (~n$32))) : ((x$80_$_hi >>> n$32) | 0));
                      var hi$49 = (((32 & n$32) === 0) ? ((x$80_$_hi >>> n$32) | 0) : 0);
                      var x$81_$_lo = q1$3_$_lo;
                      var x$81_$_hi = q1$3_$_hi;
                      var n$33 = ((64 - s$10) | 0);
                      var lo$52 = (((32 & n$33) === 0) ? (x$81_$_lo << n$33) : 0);
                      var hi$50 = (((32 & n$33) === 0) ? (((((x$81_$_lo >>> 1) | 0) >>> (~n$33)) | 0) | (x$81_$_hi << n$33)) : (x$81_$_lo << n$33));
                      var lo$53 = (lo$51 | lo$52);
                      var hi$51 = (hi$49 | hi$50);
                      q0$3_$_lo = lo$53;
                      q0$3_$_hi = hi$51;
                      var x$82_$_lo = q1$3_$_lo;
                      var x$82_$_hi = q1$3_$_hi;
                      var n$34 = s$10;
                      var lo$54 = (((32 & n$34) === 0) ? (((x$82_$_lo >>> n$34) | 0) | ((x$82_$_hi << 1) << (~n$34))) : ((x$82_$_hi >>> n$34) | 0));
                      var hi$52 = (((32 & n$34) === 0) ? ((x$82_$_hi >>> n$34) | 0) : 0);
                      q1$3_$_lo = lo$54;
                      q1$3_$_hi = hi$52;
                    }
                    ps$8 = ((ps$8 + trail$4) | 0);
                    trusty$3 = false;
                  }
                }
              } else {
                break;
              }
            }
            if ((!trusty$3)) {
              $p_Lorg_jpablo_graphexplorer_graphviz_layout_MuslSort$__cycle$1__AI__AI__I__V(this$9, arr, ar, i$25);
              var head0$9 = head$9;
              var pshift0$9 = ps$8;
              var head$10 = head0$9;
              var ps$9 = pshift0$9;
              ar.a[0] = head$10;
              var i$30 = 1;
              var stop$9 = false;
              while (((ps$9 > 1) && (!stop$9))) {
                var rt$9 = ((head$10 - 1) | 0);
                var $x_83 = head$10;
                var $x_81 = lp.a;
                var $x_82 = (((ps$9 - 2) | 0) << 1);
                var $x_80_$_lo = $x_81[$x_82];
                var $x_80_$_hi = $x_81[(($x_82 + 1) | 0)];
                var lf$9 = (((($x_83 - 1) | 0) - $x_80_$_lo) | 0);
                var p$proxy1$5 = ar.a[0];
                var x0$27 = arr.a[p$proxy1$5];
                var x1$27 = arr.a[lf$9];
                if (((f$1(x0$27, x1$27) | 0) >= 0)) {
                  var p$proxy2$5 = ar.a[0];
                  var x0$28 = arr.a[p$proxy2$5];
                  var x1$28 = arr.a[rt$9];
                  var $x_84 = ((f$1(x0$28, x1$28) | 0) >= 0);
                } else {
                  var $x_84 = false;
                }
                if ($x_84) {
                  stop$9 = true;
                } else {
                  var x0$29 = arr.a[lf$9];
                  var x1$29 = arr.a[rt$9];
                  if (((f$1(x0$29, x1$29) | 0) >= 0)) {
                    ar.a[i$30] = lf$9;
                    i$30 = ((1 + i$30) | 0);
                    head$10 = lf$9;
                    ps$9 = ((ps$9 - 1) | 0);
                  } else {
                    ar.a[i$30] = rt$9;
                    i$30 = ((1 + i$30) | 0);
                    head$10 = rt$9;
                    ps$9 = ((ps$9 - 2) | 0);
                  }
                }
              }
              $p_Lorg_jpablo_graphexplorer_graphviz_layout_MuslSort$__cycle$1__AI__AI__I__V(this$9, arr, ar, i$30);
            }
          }
          head = ((head - 1) | 0);
        } else {
          break;
        }
      }
    }
    var order = $m_sc_ArrayOps$().kX(arr);
  } else {
    var order = $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(new $c_sci_Range$Exclusive(0, N$2, 1), $m_s_Predef$().a5j(rank$12), $m_s_math_Ordering$Int$());
  }
  order.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => {
    var n$35 = (v1 | 0);
    var i$3$1 = rank$12.a[n$35];
    nrank.a[i$3$1] = ((1 + nrank.a[i$3$1]) | 0);
  })));
  order.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1$2) => {
    var n$36 = (v1$2 | 0);
    var inw = 0;
    var outw = 0;
    var lo$55 = 0;
    var hi$53 = maxRank;
    var k = 0;
    while ((k < inE$8.a[n$36].a.length)) {
      var e = inE$8.a[n$36].a[k];
      inw = ((inw + eweight$4.a[e]) | 0);
      var x$84 = lo$55;
      var y$3 = ((rank$12.a[etail$20.a[e]] + eminlen$9.a[e]) | 0);
      lo$55 = ((x$84 > y$3) ? x$84 : y$3);
      k = ((1 + k) | 0);
    }
    k = 0;
    while ((k < outE$8.a[n$36].a.length)) {
      var e$2 = outE$8.a[n$36].a[k];
      outw = ((outw + eweight$4.a[e$2]) | 0);
      var x$85 = hi$53;
      var y$4 = ((rank$12.a[ehead$20.a[e$2]] - eminlen$9.a[e$2]) | 0);
      hi$53 = ((x$85 < y$4) ? x$85 : y$4);
      k = ((1 + k) | 0);
    }
    if ((lo$55 < 0)) {
      lo$55 = 0;
    }
    if ((inw === outw)) {
      var choice = lo$55;
      var r = ((1 + lo$55) | 0);
      while ((r <= hi$53)) {
        if ((nrank.a[r] < nrank.a[choice])) {
          choice = r;
        }
        r = ((1 + r) | 0);
      }
      var i$4$1 = rank$12.a[n$36];
      nrank.a[i$4$1] = ((nrank.a[i$4$1] - 1) | 0);
      var i$5$1 = choice;
      nrank.a[i$5$1] = ((1 + nrank.a[i$5$1]) | 0);
      rank$12.a[n$36] = choice;
    }
  })));
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$() {
  this.aTR = 0;
  this.aTR = 30;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$.prototype = $p;
$p.b92 = (function(nodes, edges, balance, initRanks, tbOrder, isNormal) {
  if (nodes.c()) {
    return $m_sci_Map$EmptyMap$();
  }
  var nodeList = nodes.d2();
  var N = nodeList.C();
  if ((N <= 0)) {
    var normal = new $ac_Z(0);
  } else {
    var array = new $ac_Z(N);
    var i = 0;
    while ((i < N)) {
      var $x_1 = i;
      var x0 = i;
      array.a[$x_1] = (!(!isNormal.i(nodeList.l(x0))));
      i = ((1 + i) | 0);
    }
    var normal = array;
  }
  var idx = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$16(nodeList.o()));
  var es = edges.d2();
  var E = es.C();
  if ((E <= 0)) {
    var etail = new $ac_I(0);
  } else {
    var array$1 = new $ac_I(E);
    var i$1 = 0;
    while ((i$1 < E)) {
      var $x_2 = i$1;
      var x0$1 = i$1;
      array$1.a[$x_2] = (idx.i(es.l(x0$1).pT) | 0);
      i$1 = ((1 + i$1) | 0);
    }
    var etail = array$1;
  }
  if ((E <= 0)) {
    var ehead = new $ac_I(0);
  } else {
    var array$2 = new $ac_I(E);
    var i$2 = 0;
    while ((i$2 < E)) {
      var $x_3 = i$2;
      var x0$2 = i$2;
      array$2.a[$x_3] = (idx.i(es.l(x0$2).rp) | 0);
      i$2 = ((1 + i$2) | 0);
    }
    var ehead = array$2;
  }
  if ((E <= 0)) {
    var eminlen = new $ac_I(0);
  } else {
    var array$3 = new $ac_I(E);
    var i$3 = 0;
    while ((i$3 < E)) {
      var $x_4 = i$3;
      var x0$3 = i$3;
      array$3.a[$x_4] = es.l(x0$3).ut;
      i$3 = ((1 + i$3) | 0);
    }
    var eminlen = array$3;
  }
  if ((E <= 0)) {
    var eweight = new $ac_I(0);
  } else {
    var array$4 = new $ac_I(E);
    var i$4 = 0;
    while ((i$4 < E)) {
      var $x_5 = i$4;
      var x0$4 = i$4;
      array$4.a[$x_5] = es.l(x0$4).uu;
      i$4 = ((1 + i$4) | 0);
    }
    var eweight = array$4;
  }
  if ((E <= 0)) {
    var cutvalue = new $ac_I(0);
  } else {
    var array$5 = new $ac_I(E);
    var i$5 = 0;
    while ((i$5 < E)) {
      array$5.a[i$5] = 0;
      i$5 = ((1 + i$5) | 0);
    }
    var cutvalue = array$5;
  }
  if ((E <= 0)) {
    var treeIndex = new $ac_I(0);
  } else {
    var array$6 = new $ac_I(E);
    var i$6 = 0;
    while ((i$6 < E)) {
      array$6.a[i$6] = (-1);
      i$6 = ((1 + i$6) | 0);
    }
    var treeIndex = array$6;
  }
  if ((N <= 0)) {
    var outB = new ($d_scm_ArrayBuffer.r().C)(0);
  } else {
    var array$7 = new ($d_scm_ArrayBuffer.r().C)(N);
    var i$7 = 0;
    while ((i$7 < N)) {
      array$7.a[i$7] = ($m_scm_ArrayBuffer$(), $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer()));
      i$7 = ((1 + i$7) | 0);
    }
    var outB = array$7;
  }
  if ((N <= 0)) {
    var inB = new ($d_scm_ArrayBuffer.r().C)(0);
  } else {
    var array$8 = new ($d_scm_ArrayBuffer.r().C)(N);
    var i$8 = 0;
    while ((i$8 < N)) {
      array$8.a[i$8] = ($m_scm_ArrayBuffer$(), $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer()));
      i$8 = ((1 + i$8) | 0);
    }
    var inB = array$8;
  }
  var i0 = 0;
  while ((i0 < E)) {
    outB.a[etail.a[i0]].aw(i0);
    inB.a[ehead.a[i0]].aw(i0);
    i0 = ((1 + i0) | 0);
  }
  var len = outB.a.length;
  var ys = new ($d_I.r().r().C)(len);
  if ((len > 0)) {
    var i$9 = 0;
    while ((i$9 < len)) {
      var $x_7 = i$9;
      var x0$5 = outB.a[i$9];
      if ((x0$5.a1 >= 0)) {
        var destination = new $ac_I(x0$5.a1);
        x0$5.cR(destination, 0, 2147483647);
        var $x_6 = destination;
      } else {
        var capacity = 0;
        var size = 0;
        var jsElems = null;
        capacity = 0;
        size = 0;
        jsElems = [];
        var it = x0$5.bB().o();
        while (it.p()) {
          var elem$2 = it.q();
          var unboxedElem = ((elem$2 === null) ? 0 : elem$2);
          jsElems.push(unboxedElem);
        }
        var $x_6 = new $ac_I(new Int32Array(jsElems));
      }
      ys.a[$x_7] = $x_6;
      i$9 = ((1 + i$9) | 0);
    }
  }
  var len$2 = inB.a.length;
  var ys$1 = new ($d_I.r().r().C)(len$2);
  if ((len$2 > 0)) {
    var i$10 = 0;
    while ((i$10 < len$2)) {
      var $x_9 = i$10;
      var x0$6 = inB.a[i$10];
      if ((x0$6.a1 >= 0)) {
        var destination$1 = new $ac_I(x0$6.a1);
        x0$6.cR(destination$1, 0, 2147483647);
        var $x_8 = destination$1;
      } else {
        var capacity$1 = 0;
        var size$1 = 0;
        var jsElems$1 = null;
        capacity$1 = 0;
        size$1 = 0;
        jsElems$1 = [];
        var it$1 = x0$6.bB().o();
        while (it$1.p()) {
          var elem$3 = it$1.q();
          var unboxedElem$1 = ((elem$3 === null) ? 0 : elem$3);
          jsElems$1.push(unboxedElem$1);
        }
        var $x_8 = new $ac_I(new Int32Array(jsElems$1));
      }
      ys$1.a[$x_9] = $x_8;
      i$10 = ((1 + i$10) | 0);
    }
  }
  if ((N <= 0)) {
    var rank = new $ac_I(0);
  } else {
    var array$9 = new $ac_I(N);
    var i$11 = 0;
    while ((i$11 < N)) {
      var $x_10 = i$11;
      var x0$7 = i$11;
      array$9.a[$x_10] = (initRanks.ay(nodeList.l(x0$7), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 0))) | 0);
      i$11 = ((1 + i$11) | 0);
    }
    var rank = array$9;
  }
  if ((N <= 0)) {
    var prio = new $ac_I(0);
  } else {
    var array$10 = new $ac_I(N);
    var i$12 = 0;
    while ((i$12 < N)) {
      array$10.a[i$12] = 0;
      i$12 = ((1 + i$12) | 0);
    }
    var prio = array$10;
  }
  if ((N <= 0)) {
    var low = new $ac_I(0);
  } else {
    var array$11 = new $ac_I(N);
    var i$13 = 0;
    while ((i$13 < N)) {
      array$11.a[i$13] = 0;
      i$13 = ((1 + i$13) | 0);
    }
    var low = array$11;
  }
  if ((N <= 0)) {
    var lim = new $ac_I(0);
  } else {
    var array$12 = new $ac_I(N);
    var i$14 = 0;
    while ((i$14 < N)) {
      array$12.a[i$14] = 0;
      i$14 = ((1 + i$14) | 0);
    }
    var lim = array$12;
  }
  if ((N <= 0)) {
    var par = new $ac_I(0);
  } else {
    var array$13 = new $ac_I(N);
    var i$15 = 0;
    while ((i$15 < N)) {
      array$13.a[i$15] = (-1);
      i$15 = ((1 + i$15) | 0);
    }
    var par = array$13;
  }
  if ((N <= 0)) {
    var treeOut = new ($d_scm_ArrayBuffer.r().C)(0);
  } else {
    var array$14 = new ($d_scm_ArrayBuffer.r().C)(N);
    var i$16 = 0;
    while ((i$16 < N)) {
      array$14.a[i$16] = ($m_scm_ArrayBuffer$(), $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer()));
      i$16 = ((1 + i$16) | 0);
    }
    var treeOut = array$14;
  }
  if ((N <= 0)) {
    var treeIn = new ($d_scm_ArrayBuffer.r().C)(0);
  } else {
    var array$15 = new ($d_scm_ArrayBuffer.r().C)(N);
    var i$17 = 0;
    while ((i$17 < N)) {
      array$15.a[i$17] = ($m_scm_ArrayBuffer$(), $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer()));
      i$17 = ((1 + i$17) | 0);
    }
    var treeIn = array$15;
  }
  $m_scm_ArrayBuffer$();
  var treeEdge = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  var feasible = true;
  var v0 = 0;
  while ((v0 < N)) {
    prio.a[v0] = ys$1.a[v0].a.length;
    var k = 0;
    while ((k < ys$1.a[v0].a.length)) {
      var e = ys$1.a[v0].a[k];
      if ((((rank.a[ehead.a[e]] - rank.a[etail.a[e]]) | 0) < eminlen.a[e])) {
        feasible = false;
      }
      k = ((1 + k) | 0);
    }
    v0 = ((1 + v0) | 0);
  }
  if ((!feasible)) {
    var q = $ct_scm_Queue__I__(new $c_scm_Queue(), 16);
    var v = 0;
    while ((v < N)) {
      if ((prio.a[v] === 0)) {
        q.km(v);
      }
      v = ((1 + v) | 0);
    }
    while ((!q.c())) {
      var u = (q.h7(false) | 0);
      rank.a[u] = 0;
      var k$2 = 0;
      while ((k$2 < ys$1.a[u].a.length)) {
        var e$2 = ys$1.a[u].a[k$2];
        var x = rank.a[u];
        var y = ((rank.a[etail.a[e$2]] + eminlen.a[e$2]) | 0);
        rank.a[u] = ((x > y) ? x : y);
        k$2 = ((1 + k$2) | 0);
      }
      k$2 = 0;
      while ((k$2 < ys.a[u].a.length)) {
        var e$3 = ys.a[u].a[k$2];
        var i$1$1 = ehead.a[e$3];
        prio.a[i$1$1] = ((prio.a[i$1$1] - 1) | 0);
        if ((prio.a[ehead.a[e$3]] <= 0)) {
          q.km(ehead.a[e$3]);
        }
        k$2 = ((1 + k$2) | 0);
      }
    }
  }
  if ((N <= 0)) {
    var nodeSubtree = new $ac_I(0);
  } else {
    var array$16 = new $ac_I(N);
    var i$18 = 0;
    while ((i$18 < N)) {
      array$16.a[i$18] = (-1);
      i$18 = ((1 + i$18) | 0);
    }
    var nodeSubtree = array$16;
  }
  $m_scm_ArrayBuffer$();
  var stRep = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  $m_scm_ArrayBuffer$();
  var stSize = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  $m_scm_ArrayBuffer$();
  var stHeap = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  $m_scm_ArrayBuffer$();
  var stPar = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  $m_scm_ArrayBuffer$();
  var heapElt = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  var n0 = 0;
  while ((n0 < N)) {
    if ((nodeSubtree.a[n0] === (-1))) {
      var st = $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__newSubtree$1__scm_ArrayBuffer__scm_ArrayBuffer__scm_ArrayBuffer__scm_ArrayBuffer__I__I(this, stRep, stSize, stHeap, stPar, n0);
      stSize.cM(st, $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__tightSubtreeSearch$1__AI__AAI__AI__AI__AI__AI__AI__AAI__scm_ArrayBuffer__Ascm_ArrayBuffer__Ascm_ArrayBuffer__I__I__I(this, nodeSubtree, ys$1, treeIndex, etail, rank, ehead, eminlen, ys, treeEdge, treeOut, treeIn, n0, st));
      heapElt.aw(st);
    }
    n0 = ((1 + n0) | 0);
  }
  $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__buildHeap$1__scm_ArrayBuffer__scm_ArrayBuffer__scm_ArrayBuffer__V(this, heapElt, stHeap, stSize);
  while ((heapElt.a1 > 1)) {
    var tree0 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__extractMin$1__scm_ArrayBuffer__scm_ArrayBuffer__scm_ArrayBuffer__I(this, heapElt, stHeap, stSize);
    var ee = $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__interTreeEdgeSearch$1__AI__AI__AI__AI__AAI__AI__AAI__AI__scm_ArrayBuffer__I__I__I__I(this, rank, ehead, etail, eminlen, ys, treeIndex, ys$1, nodeSubtree, stPar, (stRep.l(tree0) | 0), (-1), (-1));
    if ((ee < 0)) {
      $p_scm_ArrayBuffer__reduceToSize__I__V(heapElt, 0);
    } else {
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__heapify$1__scm_ArrayBuffer__scm_ArrayBuffer__scm_ArrayBuffer__I__V(this, heapElt, stSize, stHeap, (stHeap.l($p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__mergeTrees$1__AI__AI__scm_ArrayBuffer__AI__AI__scm_ArrayBuffer__AI__scm_ArrayBuffer__Ascm_ArrayBuffer__Ascm_ArrayBuffer__AI__scm_ArrayBuffer__scm_ArrayBuffer__I__I(this, etail, ehead, stHeap, rank, eminlen, stRep, nodeSubtree, stPar, treeIn, treeOut, treeIndex, treeEdge, stSize, ee)) | 0));
    }
  }
  if ((treeEdge.a1 === ((N - 1) | 0))) {
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__dfsRangeInit$1__AI__AI__Ascm_ArrayBuffer__AI__Ascm_ArrayBuffer__AI__AI__I__V(this, par, low, treeOut, ehead, treeIn, etail, lim, 0);
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__dfsCutval$1__Ascm_ArrayBuffer__AI__Ascm_ArrayBuffer__AI__AI__AAI__AAI__AI__AI__AI__AI__AI__I__I__V(this, treeOut, ehead, treeIn, etail, par, ys, ys$1, cutvalue, low, lim, eweight, treeIndex, 0, (-1));
  }
  var elem$6 = 0;
  elem$6 = 0;
  var enterE = new $c_sr_IntRef((-1));
  var enterSlack = new $c_sr_IntRef(0);
  var LowC = new $c_sr_IntRef(0);
  var LimC = new $c_sr_IntRef(0);
  if ((treeEdge.a1 === ((N - 1) | 0))) {
    var maxiter = ((1000 + Math.imul((N << 2), ((1 + E) | 0))) | 0);
    var iter = 0;
    _return$1: {
      var rv = (-1);
      var cnt = 0;
      var j = elem$6;
      while ((elem$6 < treeEdge.a1)) {
        var f = (treeEdge.l(elem$6) | 0);
        if ((cutvalue.a[f] < 0)) {
          if (((rv < 0) || (cutvalue.a[rv] > cutvalue.a[f]))) {
            rv = f;
          }
          cnt = ((1 + cnt) | 0);
          if ((cnt >= 30)) {
            var e$4 = rv;
            break _return$1;
          }
        }
        elem$6 = ((1 + elem$6) | 0);
      }
      if ((j > 0)) {
        elem$6 = 0;
        while ((elem$6 < j)) {
          var f$2 = (treeEdge.l(elem$6) | 0);
          if ((cutvalue.a[f$2] < 0)) {
            if (((rv < 0) || (cutvalue.a[rv] > cutvalue.a[f$2]))) {
              rv = f$2;
            }
            cnt = ((1 + cnt) | 0);
            if ((cnt >= 30)) {
              var e$4 = rv;
              break _return$1;
            }
          }
          elem$6 = ((1 + elem$6) | 0);
        }
      }
      var e$4 = rv;
    }
    while (((e$4 >= 0) && (iter < maxiter))) {
      var f$1 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__enterEdge$1__AI__AI__AI__sr_IntRef__sr_IntRef__sr_IntRef__AI__sr_IntRef__AAI__AI__AI__AI__Ascm_ArrayBuffer__AAI__Ascm_ArrayBuffer__I__I(this, lim, etail, ehead, enterE, enterSlack, LowC, low, LimC, ys, treeIndex, rank, eminlen, treeIn, ys$1, treeOut, e$4);
      if ((f$1 < 0)) {
        e$4 = (-1);
      } else {
        $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__update$1__AI__AI__AI__AI__Ascm_ArrayBuffer__Ascm_ArrayBuffer__AI__AI__AI__AI__AI__scm_ArrayBuffer__I__I__V(this, rank, ehead, etail, eminlen, treeIn, treeOut, lim, cutvalue, low, par, treeIndex, treeEdge, e$4, f$1);
        iter = ((1 + iter) | 0);
        _return$2: {
          var rv$1 = (-1);
          var cnt$1 = 0;
          var j$1 = elem$6;
          while ((elem$6 < treeEdge.a1)) {
            var f$3 = (treeEdge.l(elem$6) | 0);
            if ((cutvalue.a[f$3] < 0)) {
              if (((rv$1 < 0) || (cutvalue.a[rv$1] > cutvalue.a[f$3]))) {
                rv$1 = f$3;
              }
              cnt$1 = ((1 + cnt$1) | 0);
              if ((cnt$1 >= 30)) {
                e$4 = rv$1;
                break _return$2;
              }
            }
            elem$6 = ((1 + elem$6) | 0);
          }
          if ((j$1 > 0)) {
            elem$6 = 0;
            while ((elem$6 < j$1)) {
              var f$2$1 = (treeEdge.l(elem$6) | 0);
              if ((cutvalue.a[f$2$1] < 0)) {
                if (((rv$1 < 0) || (cutvalue.a[rv$1] > cutvalue.a[f$2$1]))) {
                  rv$1 = f$2$1;
                }
                cnt$1 = ((1 + cnt$1) | 0);
                if ((cnt$1 >= 30)) {
                  e$4 = rv$1;
                  break _return$2;
                }
              }
              elem$6 = ((1 + elem$6) | 0);
            }
          }
          e$4 = rv$1;
        }
      }
    }
  }
  matchResult8: {
    var x$1 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$__TopBottom__Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance();
    if (((x$1 === null) ? (balance === null) : (x$1 === balance))) {
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__tbBalance$1__sci_Seq__sci_Map__AI__I__AAI__AI__AI__AI__AAI__AI__AZ__V(this, tbOrder, idx, rank, N, ys$1, eweight, etail, eminlen, ys, ehead, normal);
      break matchResult8;
    }
    var x$3 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$__LeftRight__Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance();
    if (((x$3 === null) ? (balance === null) : (x$3 === balance))) {
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__lrBalance$1__scm_ArrayBuffer__AI__AI__AI__AI__AI__AI__sr_IntRef__sr_IntRef__sr_IntRef__AI__sr_IntRef__AAI__AI__Ascm_ArrayBuffer__AAI__Ascm_ArrayBuffer__AI__V(this, treeEdge, cutvalue, rank, ehead, etail, eminlen, lim, enterE, enterSlack, LowC, low, LimC, ys, treeIndex, treeIn, ys$1, treeOut, par);
      break matchResult8;
    }
    var x$5 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$__None__Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance();
    if (((x$5 === null) ? (balance === null) : (x$5 === balance))) {
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__scanAndNormalize$1__I__AZ__AI__I(this, N, normal, rank);
      break matchResult8;
    }
    throw new $c_s_MatchError(balance);
  }
  return $m_sci_Map$().ao(new $c_sc_Iterator$$anon$9(new $c_sc_Iterator$$anon$16(nodeList.o()), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$1) => new $c_T2(x$1$1.g(), rank.a[(x$1$1.h() | 0)])))));
});
$p.b93 = (function() {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => true));
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$, "org.jpablo.graphexplorer.graphviz.layout.NetworkSimplex$", ({
  uV: 1
}));
var $n_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$;
function $m_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$() {
  if ((!$n_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$)) {
    $n_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$ = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$();
  }
  return $n_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$Frame$1(v, inI, outI, rv) {
  this.RF = 0;
  this.Ff = 0;
  this.Fg = 0;
  this.RE = 0;
  this.RF = v;
  this.Ff = inI;
  this.Fg = outI;
  this.RE = rv;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$Frame$1.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$Frame$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$Frame$1() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$Frame$1.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$Frame$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$Frame$1, "org.jpablo.graphexplorer.graphviz.layout.NetworkSimplex$Frame$1", ({
  uW: 1
}));
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$__shapeOf__T__Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$ShapeKind($thiz, name) {
  var x9 = name.toLowerCase();
  switch (x9) {
    case "ellipse":
    case "oval": {
      return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$ShapeKind(false, false, false, true, 1);
      break;
    }
    case "circle": {
      return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$ShapeKind(false, true, false, true, 1);
      break;
    }
    case "doublecircle": {
      return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$ShapeKind(false, true, false, true, 2);
      break;
    }
    case "box":
    case "rect":
    case "rectangle": {
      return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$ShapeKind(true, false, false, true, 1);
      break;
    }
    case "image": {
      return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$ShapeKind(true, false, false, true, 1);
      break;
    }
    case "square": {
      return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$ShapeKind(true, true, false, true, 1);
      break;
    }
    case "plaintext":
    case "none": {
      return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$ShapeKind(true, false, false, true, 1);
      break;
    }
    case "plain": {
      return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$ShapeKind(true, false, true, true, 1);
      break;
    }
    case "point": {
      return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$ShapeKind(false, true, false, true, 1);
      break;
    }
    default: {
      if (($m_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$().RR.E(x9) || (x9 === "underline"))) {
        return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$ShapeKind(true, false, false, true, 1);
      }
      if ((x9 === "msquare")) {
        return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$ShapeKind(true, true, false, true, 1);
      }
      if ((x9 === "mcircle")) {
        return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$ShapeKind(false, true, false, true, 1);
      }
      return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$ShapeKind(true, false, false, false, 1);
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$__pointDiamIn__Lorg_jpablo_graphexplorer_graphviz_model_RNode__D($thiz, n) {
  var w = $p_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$__ld$1__Lorg_jpablo_graphexplorer_graphviz_model_RNode__T__D__D($thiz, n, "width", 0.01);
  var h = $p_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$__ld$1__Lorg_jpablo_graphexplorer_graphviz_model_RNode__T__D__D($thiz, n, "height", 0.02);
  var m = (+Math.min(w, h));
  return (((w === 1.7976931348623157E308) && (h === 1.7976931348623157E308)) ? 0.05 : ((m > 0.0) ? (+Math.max(m, 3.0E-4)) : m));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$__labelLines__T__T__T__sci_List($thiz, raw, nodeId, graphName) {
  var this$1 = $thiz.a42(raw, nodeId, graphName);
  var f = ((_$9) => _$9.g());
  if ((this$1 === $m_sci_Nil$())) {
    return $m_sci_Nil$();
  } else {
    var x0 = this$1.t();
    var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
    var t = h;
    var rest = this$1.v();
    while ((rest !== $m_sci_Nil$())) {
      var x0$1 = rest.t();
      var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
      t.U = nx;
      t = nx;
      rest = rest.v();
    }
    return h;
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$__dbl__Lorg_jpablo_graphexplorer_graphviz_model_RNode__T__D__D($thiz, n, key, default$1) {
  var this$2 = n.aK.ag.r(key);
  if (this$2.c()) {
    var this$6 = $m_s_None$();
  } else {
    var x0 = this$2.d();
    var this$6 = ($m_sc_StringParsers$().c1(x0) ? new $c_s_Some($m_jl_Double$().bd(x0)) : $m_s_None$());
  }
  return (+(this$6.c() ? default$1 : this$6.d()));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$__marginPt__Lorg_jpablo_graphexplorer_graphviz_model_RNode__s_Option($thiz, n) {
  var this$2 = n.aK.ag.r("margin");
  if (this$2.c()) {
    return $m_s_None$();
  } else {
    var x0 = this$2.d();
    var xs = $f_T__split__T__I__AT(x0, ",", 0);
    var f = ((_$12) => $f_T__trim__T(_$12));
    var len = xs.a.length;
    var ys = new ($d_T.r().C)(len);
    if ((len > 0)) {
      var i = 0;
      if ((xs !== null)) {
        while ((i < len)) {
          var $x_1 = i;
          var x0$1 = xs.a[i];
          ys.a[$x_1] = f(x0$1);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_I)) {
        while ((i < len)) {
          var $x_2 = i;
          var x0$2 = xs.a[i];
          ys.a[$x_2] = f(x0$2);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_D)) {
        while ((i < len)) {
          var $x_3 = i;
          var x0$3 = xs.a[i];
          ys.a[$x_3] = f(x0$3);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_J)) {
        while ((i < len)) {
          var $x_6 = i;
          var $x_4 = xs.a;
          var $x_5 = (i << 1);
          var x0$4_$_lo = $x_4[$x_5];
          var x0$4_$_hi = $x_4[(($x_5 + 1) | 0)];
          ys.a[$x_6] = f($bL(x0$4_$_lo, x0$4_$_hi));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_F)) {
        while ((i < len)) {
          var $x_7 = i;
          var x0$5 = xs.a[i];
          ys.a[$x_7] = f(x0$5);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_C)) {
        while ((i < len)) {
          var $x_8 = i;
          var x0$6 = xs.a[i];
          ys.a[$x_8] = f($bC(x0$6));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_B)) {
        while ((i < len)) {
          var $x_9 = i;
          var x0$7 = xs.a[i];
          ys.a[$x_9] = f(x0$7);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_S)) {
        while ((i < len)) {
          var $x_10 = i;
          var x0$8 = xs.a[i];
          ys.a[$x_10] = f(x0$8);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_Z)) {
        while ((i < len)) {
          var $x_11 = i;
          var x0$9 = xs.a[i];
          ys.a[$x_11] = f(x0$9);
          i = ((1 + i) | 0);
        }
      } else {
        throw new $c_s_MatchError(xs);
      }
    }
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var i$1 = 0;
    while ((i$1 < ys.a.length)) {
      var x0$10 = ys.a[i$1];
      var this$14 = $m_sc_StringParsers$();
      var elems = (this$14.c1(x0$10) ? new $c_s_Some($m_jl_Double$().bd(x0$10)) : $m_s_None$());
      var it = elems.o();
      while (it.p()) {
        var elem = it.q();
        var unboxedElem = ((elem === null) ? 0.0 : elem);
        jsElems.push(unboxedElem);
      }
      i$1 = ((1 + i$1) | 0);
    }
    var x21 = new $ac_D(new Float64Array(jsElems));
    if (($m_s_Array$UnapplySeqWrapper$().u9(x21, 2) === 0)) {
      var x25 = x21.a[0];
      var x26 = x21.a[1];
      return new $c_s_Some(new $c_T2((x25 * $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().n4), (x26 * $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().n4)));
    }
    if (($m_s_Array$UnapplySeqWrapper$().u9(x21, 1) === 0)) {
      var x23 = x21.a[0];
      return new $c_s_Some(new $c_T2((x23 * $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().n4), (x23 * $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().n4)));
    }
    return $m_s_None$();
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$__recordLayoutImpl__Lorg_jpablo_graphexplorer_graphviz_model_RNode__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__s_Option($thiz, n, g) {
  var this$1 = n.aK.dL("shape", "ellipse");
  var sn = this$1.toLowerCase();
  if (((sn !== "record") && (sn !== "mrecord"))) {
    return $m_s_None$();
  }
  matchResult14: {
    var fixed;
    var this$2 = n.aK.dL("fixedsize", "false");
    var x27 = this$2.toLowerCase();
    matchAlts13: {
      matchAlts14: {
        if ((x27 === "true")) {
          break matchAlts14;
        }
        if ((x27 === "shape")) {
          break matchAlts14;
        }
        break matchAlts13;
      }
      var fixed = true;
      break matchResult14;
    }
    var fixed = false;
  }
  matchResult15: {
    var $x_1;
    var $x_12 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$();
    var $x_11 = n.aK.dL("label", "\\N");
    var $x_10 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().jT(g);
    var $x_9 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$__dbl__Lorg_jpablo_graphexplorer_graphviz_model_RNode__T__D__D($thiz, n, "fontsize", $thiz.ZL);
    var $x_8 = n.aK.dL("fontname", $thiz.ZK);
    var $x_7 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$__dbl__Lorg_jpablo_graphexplorer_graphviz_model_RNode__T__D__D($thiz, n, "width", $thiz.ZN);
    var $x_6 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$__dbl__Lorg_jpablo_graphexplorer_graphviz_model_RNode__T__D__D($thiz, n, "height", $thiz.ZM);
    var $x_5 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$__marginPt__Lorg_jpablo_graphexplorer_graphviz_model_RNode__s_Option($thiz, n);
    var $x_4 = n.aK.n7.E("label");
    var $x_3 = g.mj;
    var $x_2 = n.br;
    var this$4 = g.j5;
    var x28 = $x_12.agQ($x_11, (!$x_10), $x_9, $x_8, $x_7, $x_6, fixed, $x_5, $x_4, $x_3, $x_2, (this$4.c() ? "" : this$4.d()));
    if ((x28 !== null)) {
      var $x_1 = x28.c3;
      break matchResult15;
    }
    throw new $c_s_MatchError(x28);
  }
  return new $c_s_Some($x_1);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$__polyMetrics__Lorg_jpablo_graphexplorer_graphviz_model_RNode__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$ShapeKind__Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$Metrics($thiz, n, g, shape) {
  var fontSize = $p_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$__dbl__Lorg_jpablo_graphexplorer_graphviz_model_RNode__T__D__D($thiz, n, "fontsize", $thiz.ZL);
  var fontName = n.aK.dL("fontname", $thiz.ZK);
  var fnCanon = fontName.toLowerCase();
  var bold = ((fnCanon.indexOf("bold") | 0) !== (-1));
  var italic = (((fnCanon.indexOf("italic") | 0) !== (-1)) || ((fnCanon.indexOf("oblique") | 0) !== (-1)));
  var rawLabel = n.aK.dL("label", "\\N");
  if ((rawLabel === "")) {
    var lines = $m_sci_Nil$();
  } else {
    var $x_1 = n.br;
    var this$1 = g.j5;
    var lines = $p_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$__labelLines__T__T__T__sci_List($thiz, rawLabel, $x_1, (this$1.c() ? "" : this$1.d()));
  }
  var f = ((l) => ((l === "") ? 0.0 : (fontSize * $m_Lorg_jpablo_graphexplorer_graphviz_metrics_FontMetrics$().WI(fontName, l, bold, italic))));
  if ((lines === $m_sci_Nil$())) {
    var lineW = $m_sci_Nil$();
  } else {
    var x0 = lines.t();
    var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
    var t = h;
    var rest = lines.v();
    while ((rest !== $m_sci_Nil$())) {
      var x0$1 = rest.t();
      var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
      t.U = nx;
      t = nx;
      rest = rest.v();
    }
    var lineW = h;
  }
  var f$1 = ((l$2) => ((l$2 === "") ? $doubleToInt((fontSize * $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().Fh)) : (fontSize * $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().Fh)));
  if ((lines === $m_sci_Nil$())) {
    var lineH = $m_sci_Nil$();
  } else {
    var x0$2 = lines.t();
    var h$1 = new $c_sci_$colon$colon(f$1(x0$2), $m_sci_Nil$());
    var t$1 = h$1;
    var rest$1 = lines.v();
    while ((rest$1 !== $m_sci_Nil$())) {
      var x0$3 = rest$1.t();
      var nx$1 = new $c_sci_$colon$colon(f$1(x0$3), $m_sci_Nil$());
      t$1.U = nx$1;
      t$1 = nx$1;
      rest$1 = rest$1.v();
    }
    var lineH = h$1;
  }
  var this$2 = $f_sc_IterableOnceOps__maxOption__s_math_Ordering__s_Option(lineW, $m_s_math_Ordering$DeprecatedDoubleOrdering$());
  var elem = (+(this$2.c() ? 0.0 : this$2.d()));
  var elem$1 = 0.0;
  elem$1 = elem;
  var elem$2 = (+$f_sc_IterableOnceOps__sum__s_math_Numeric__O(lineH, $m_s_math_Numeric$DoubleIsFractional$()));
  var elem$3 = 0.0;
  elem$3 = elem$2;
  if (n.aK.n7.E("label")) {
    var this$6 = $m_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$().mU(rawLabel);
    if ((!this$6.c())) {
      var x0$4 = this$6.d();
      matchResult19: {
        var \u03b41$___1;
        var \u03b41$___2;
        var x36 = $m_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$().PU(x0$4, fontSize, fontName, g.mj);
        if ((x36 !== null)) {
          var \u03b41$___1 = (+x36.g());
          var \u03b41$___2 = (+x36.h());
          break matchResult19;
        }
        throw new $c_s_MatchError(x36);
      }
      var w$2 = (+\u03b41$___1);
      var h$2$1 = (+\u03b41$___2);
      elem$1 = w$2;
      elem$3 = h$2$1;
    }
  }
  if ((((elem$1 > 0.0) || (elem$3 > 0.0)) && (!shape.uw))) {
    matchResult21: {
      var x49 = n.aK.ag.r("margin");
      if ((x49 instanceof $c_s_Some)) {
        var mm = x49.J;
        var this$11 = $m_sci_Nil$().b6($m_s_Predef$().fB($f_T__split__T__I__AT(mm, ",", 0)));
        var rest$2 = this$11;
        var h$3 = null;
        var t$2 = null;
        while ((rest$2 !== $m_sci_Nil$())) {
          var x0$5 = rest$2.t();
          var x = $f_T__trim__T(x0$5);
          var it = ($m_sc_StringParsers$().c1(x) ? new $c_s_Some($m_jl_Double$().bd(x)) : $m_s_None$()).o();
          while (it.p()) {
            var nx$2 = new $c_sci_$colon$colon(it.q(), $m_sci_Nil$());
            if ((t$2 === null)) {
              h$3 = nx$2;
            } else {
              t$2.U = nx$2;
            }
            t$2 = nx$2;
          }
          rest$2 = rest$2.v();
        }
        var parts = ((h$3 === null) ? $m_sci_Nil$() : h$3);
        if ((parts instanceof $c_sci_$colon$colon)) {
          var x44 = (+parts.er);
          var x45 = parts.U;
          if ((x45 instanceof $c_sci_$colon$colon)) {
            var my = (+x45.er);
            elem$1 = (elem$1 + ((2.0 * $thiz.n4) * (+Math.max(x44, 0.0))));
            elem$3 = (elem$3 + ((2.0 * $thiz.n4) * (+Math.max(my, 0.0))));
            break matchResult21;
          }
          if ($m_sci_Nil$().e(x45)) {
            elem$1 = (elem$1 + ((2.0 * $thiz.n4) * (+Math.max(x44, 0.0))));
            elem$3 = (elem$3 + ((2.0 * $thiz.n4) * (+Math.max(x44, 0.0))));
            break matchResult21;
          }
        }
        if ($m_sci_Nil$().e(parts)) {
          elem$1 = (elem$1 + $thiz.a7X);
          elem$3 = (elem$3 + $thiz.a7Y);
          break matchResult21;
        }
        throw new $c_s_MatchError(parts);
      }
      if (($m_s_None$() === x49)) {
        elem$1 = (elem$1 + $thiz.a7X);
        elem$3 = (elem$3 + $thiz.a7Y);
        break matchResult21;
      }
      throw new $c_s_MatchError(x49);
    }
  }
  var this$24 = n.aK.ag.r("image");
  var this$27 = ((this$24.c() || (this$24.d() !== "")) ? this$24 : $m_s_None$());
  if (this$27.c()) {
    var $x_2 = $m_s_None$();
  } else {
    var x0$7 = this$27.d();
    var $x_2 = g.mj.r(x0$7);
  }
  var this$28 = $x_2;
  if ((!this$28.c())) {
    var x0$8 = this$28.d();
    matchResult22: {
      var \u03b42$___1;
      var \u03b42$___2;
      var x52 = x0$8.aNz();
      if ((x52 !== null)) {
        var \u03b42$___1 = (+x52.g());
        var \u03b42$___2 = (+x52.h());
        break matchResult22;
      }
      throw new $c_s_MatchError(x52);
    }
    var dw$2 = (+\u03b42$___1);
    var dh$2 = (+\u03b42$___2);
    var x$2 = elem$1;
    var y = (dw$2 + 2.0);
    elem$1 = (+Math.max(x$2, y));
    var x$4 = elem$3;
    var y$1 = (dh$2 + 2.0);
    elem$3 = (+Math.max(x$4, y$1));
  }
  var wAttr = $p_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$__dbl__Lorg_jpablo_graphexplorer_graphviz_model_RNode__T__D__D($thiz, n, "width", $thiz.ZN);
  var hAttr = $p_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$__dbl__Lorg_jpablo_graphexplorer_graphviz_model_RNode__T__D__D($thiz, n, "height", $thiz.ZM);
  var minW = ($thiz.n4 * (shape.uw ? 0.0 : wAttr));
  var minH = ($thiz.n4 * (shape.uw ? 0.0 : hAttr));
  if ((shape.wE && (!shape.uw))) {
    var this$35 = n.aK.ag.r("width");
    if (this$35.c()) {
      var this$39 = $m_s_None$();
    } else {
      var x0$9 = this$35.d();
      var this$39 = ($m_sc_StringParsers$().c1(x0$9) ? new $c_s_Some($m_jl_Double$().bd(x0$9)) : $m_s_None$());
    }
    if (this$39.c()) {
      var this$42 = $m_s_None$();
    } else {
      var x0$10 = this$39.d();
      var _$17 = (+x0$10);
      var this$42 = new $c_s_Some((+Math.max(_$17, 0.01)));
    }
    var uw = (+(this$42.c() ? 0.0 : this$42.d()));
    var this$44 = n.aK.ag.r("height");
    if (this$44.c()) {
      var this$48 = $m_s_None$();
    } else {
      var x0$11 = this$44.d();
      var this$48 = ($m_sc_StringParsers$().c1(x0$11) ? new $c_s_Some($m_jl_Double$().bd(x0$11)) : $m_s_None$());
    }
    if (this$48.c()) {
      var this$51 = $m_s_None$();
    } else {
      var x0$12 = this$48.d();
      var _$19 = (+x0$12);
      var this$51 = new $c_s_Some((+Math.max(_$19, 0.02)));
    }
    var uh = (+(this$51.c() ? 0.0 : this$51.d()));
    var usz = (+Math.max(uw, uh));
    var s = ($thiz.n4 * ((usz > 0.0) ? usz : (+Math.min(wAttr, hAttr))));
    minW = s;
    minH = s;
  }
  var $x_7 = elem$1;
  var $x_6 = elem$3;
  var $x_5 = minW;
  var $x_4 = minH;
  var this$57 = n.aK.ag.r("labelloc");
  var this$58 = (this$57.c() ? $m_s_None$() : new $c_s_Some($bC(this$57.d().charCodeAt(0))));
  if ((!this$58.c())) {
    var x0$14 = this$58.d();
    var c = $uC(x0$14);
    var $x_3 = ((c === 98) || (c === 116));
  } else {
    var $x_3 = false;
  }
  return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$Metrics($x_7, $x_6, $x_5, $x_4, (!$x_3));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$__fixedSizeOf__Lorg_jpablo_graphexplorer_graphviz_model_RNode__Z($thiz, n) {
  var this$1 = n.aK.dL("fixedsize", "false");
  var x55 = this$1.toLowerCase();
  matchAlts15: {
    matchAlts16: {
      if ((x55 === "true")) {
        break matchAlts16;
      }
      if ((x55 === "shape")) {
        break matchAlts16;
      }
      break matchAlts15;
    }
    return true;
  }
  return false;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$__polygonImpl__Lorg_jpablo_graphexplorer_graphviz_model_RNode__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__s_Option($thiz, n, g) {
  var this$1 = $thiz.aR1(n);
  if (this$1.c()) {
    return $m_s_None$();
  } else {
    var x0 = this$1.d();
    var reg = (x0.Bs || $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().Xu(n.aK.ag.r("regular")));
    var shape = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$ShapeKind(false, reg, false, true, 1);
    var m = $p_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$__polyMetrics__Lorg_jpablo_graphexplorer_graphviz_model_RNode__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$ShapeKind__Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$Metrics($m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$(), n, g, shape);
    return new $c_s_Some($m_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$().aPe(m.yR, m.uv, m.yS, m.nY, m.yT, reg, x0, $p_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$__fixedSizeOf__Lorg_jpablo_graphexplorer_graphviz_model_RNode__Z($m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$(), n), $m_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$().aMu(n.aK)));
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$__nodeSizeImpl__Lorg_jpablo_graphexplorer_graphviz_model_RNode__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__s_Option($thiz, n, g) {
  var shapeName = n.aK.dL("shape", "ellipse");
  var sn = shapeName.toLowerCase();
  if ((sn === "point")) {
    var d = $p_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$__pointDiamIn__Lorg_jpablo_graphexplorer_graphviz_model_RNode__D($thiz, n);
    return new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$Size(d, d));
  }
  if (((sn === "record") || (sn === "mrecord"))) {
    matchResult25: {
      var fixed;
      var this$3 = n.aK.dL("fixedsize", "false");
      var x57 = this$3.toLowerCase();
      matchAlts19: {
        matchAlts20: {
          if ((x57 === "true")) {
            break matchAlts20;
          }
          if ((x57 === "shape")) {
            break matchAlts20;
          }
          break matchAlts19;
        }
        var fixed = true;
        break matchResult25;
      }
      var fixed = false;
    }
    matchResult26: {
      var \u03b43$___1;
      var \u03b43$___2;
      var $x_11 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$();
      var $x_10 = n.aK.dL("label", "\\N");
      var $x_9 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().jT(g);
      var $x_8 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$__dbl__Lorg_jpablo_graphexplorer_graphviz_model_RNode__T__D__D($thiz, n, "fontsize", $thiz.ZL);
      var $x_7 = n.aK.dL("fontname", $thiz.ZK);
      var $x_6 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$__dbl__Lorg_jpablo_graphexplorer_graphviz_model_RNode__T__D__D($thiz, n, "width", $thiz.ZN);
      var $x_5 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$__dbl__Lorg_jpablo_graphexplorer_graphviz_model_RNode__T__D__D($thiz, n, "height", $thiz.ZM);
      var $x_4 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$__marginPt__Lorg_jpablo_graphexplorer_graphviz_model_RNode__s_Option($thiz, n);
      var $x_3 = n.aK.n7.E("label");
      var $x_2 = g.mj;
      var $x_1 = n.br;
      var this$5 = g.j5;
      var x58 = $x_11.agQ($x_10, (!$x_9), $x_8, $x_7, $x_6, $x_5, fixed, $x_4, $x_3, $x_2, $x_1, (this$5.c() ? "" : this$5.d()));
      if ((x58 !== null)) {
        var \u03b43$___1 = (+x58.bH);
        var \u03b43$___2 = (+x58.bU);
        break matchResult26;
      }
      throw new $c_s_MatchError(x58);
    }
    return new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$Size((+\u03b43$___1), (+\u03b43$___2)));
  }
  var polyDesc = $thiz.aR1(n);
  var regAttr = $thiz.Xu(n.aK.ag.r("regular"));
  var shape0 = ((!polyDesc.c()) ? new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$ShapeKind(false, polyDesc.d().Bs, false, true, 1) : $p_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$__shapeOf__T__Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$ShapeKind($thiz, shapeName));
  var shape = ((regAttr && (!shape0.wE)) ? new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$ShapeKind(shape0.yU, true, shape0.uw, shape0.yV, shape0.Bi) : shape0);
  if ((!shape.yV)) {
    return $m_s_None$();
  }
  var m = $p_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$__polyMetrics__Lorg_jpablo_graphexplorer_graphviz_model_RNode__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$ShapeKind__Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$Metrics($thiz, n, g, shape);
  matchResult27: {
    if ((polyDesc instanceof $c_s_Some)) {
      var desc = polyDesc.J;
      var p = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$().aPe(m.yR, m.uv, m.yS, m.nY, m.yT, shape.wE, desc, $p_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$__fixedSizeOf__Lorg_jpablo_graphexplorer_graphviz_model_RNode__Z($thiz, n), $m_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$().aMu(n.aK));
      return new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$Size((p.KU / $thiz.n4), (p.KV / $thiz.n4)));
    }
    if (($m_s_None$() === polyDesc)) {
      break matchResult27;
    }
    throw new $c_s_MatchError(polyDesc);
  }
  var bbX = m.yR;
  var bbY = m.uv;
  if ((!shape.yU)) {
    var temp = (bbY * $thiz.RG);
    if (((m.nY > temp) && m.yT)) {
      var $x_12 = bbX;
      var x$proxy8 = (bbY / m.nY);
      var x$1 = (1.0 / (1.0 - (x$proxy8 * x$proxy8)));
      bbX = ($x_12 * (+Math.sqrt(x$1)));
    } else {
      bbX = (bbX * $thiz.RG);
      bbY = temp;
    }
  }
  matchResult28: {
    var this$15 = n.aK.dL("fixedsize", "false");
    var x65 = this$15.toLowerCase();
    matchAlts21: {
      matchAlts22: {
        if ((x65 === "shape")) {
          break matchAlts22;
        }
        if ((x65 === "true")) {
          break matchAlts22;
        }
        break matchAlts21;
      }
      bbX = m.yS;
      bbY = m.nY;
      break matchResult28;
    }
    var x$2 = m.yS;
    var y = bbX;
    bbX = (+Math.max(x$2, y));
    var x$3 = m.nY;
    var y$1 = bbY;
    bbY = (+Math.max(x$3, y$1));
  }
  if (shape.wE) {
    var x$4 = bbX;
    var y$2 = bbY;
    var s = (+Math.max(x$4, y$2));
    bbX = s;
    bbY = s;
  }
  var peris = $thiz.ahs(n);
  if ((peris > 1)) {
    var grow = ((2.0 * $thiz.ZO) * ((peris - 1) | 0));
    bbX = (bbX + grow);
    bbY = (bbY + grow);
  }
  return new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$Size((bbX / $thiz.n4), (bbY / $thiz.n4)));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$__ld$1__Lorg_jpablo_graphexplorer_graphviz_model_RNode__T__D__D($thiz, n$1, key, minv) {
  var this$2 = n$1.aK.ag.r(key);
  if (this$2.c()) {
    var x10 = $m_s_None$();
  } else {
    var x0 = this$2.d();
    var x10 = ($m_sc_StringParsers$().c1(x0) ? new $c_s_Some($m_jl_Double$().bd(x0)) : $m_s_None$());
  }
  if ((x10 instanceof $c_s_Some)) {
    var v = (+x10.J);
    return (+Math.max(minv, v));
  }
  if (($m_s_None$() === x10)) {
    return 1.7976931348623157E308;
  }
  throw new $c_s_MatchError(x10);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$__ld$2__Lorg_jpablo_graphexplorer_graphviz_model_RNode__T__D__D__D($thiz, n$3, key, dflt, lo) {
  var this$2 = n$3.aK.ag.r(key);
  if (this$2.c()) {
    var this$6 = $m_s_None$();
  } else {
    var x0 = this$2.d();
    var this$6 = ($m_sc_StringParsers$().c1(x0) ? new $c_s_Some($m_jl_Double$().bd(x0)) : $m_s_None$());
  }
  if (this$6.c()) {
    var this$9 = $m_s_None$();
  } else {
    var x0$1 = this$6.d();
    var _$6 = (+x0$1);
    var this$9 = new $c_s_Some((+Math.max(lo, _$6)));
  }
  return (+(this$9.c() ? dflt : this$9.d()));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$__li$1__Lorg_jpablo_graphexplorer_graphviz_model_RNode__T__I__I__I($thiz, n$4, key, dflt, lo) {
  var this$2 = n$4.aK.ag.r(key);
  var this$5 = (this$2.c() ? $m_s_None$() : $m_sc_StringParsers$().hT(this$2.d()));
  if (this$5.c()) {
    var this$8 = $m_s_None$();
  } else {
    var x0$1 = this$5.d();
    var _$8 = (x0$1 | 0);
    var this$8 = new $c_s_Some(((lo > _$8) ? lo : _$8));
  }
  return ((this$8.c() ? dflt : this$8.d()) | 0);
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$() {
  this.auh = null;
  this.aug = null;
  this.auf = null;
  this.n4 = 0.0;
  this.ZO = 0.0;
  this.a7X = 0.0;
  this.a7Y = 0.0;
  this.Fh = 0.0;
  this.RG = 0.0;
  this.ZL = 0.0;
  this.ZK = null;
  this.ZN = 0.0;
  this.ZM = 0.0;
  $n_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$ = this;
  this.auh = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_GraphMemo();
  this.aug = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_GraphMemo();
  this.auf = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_GraphMemo();
  this.n4 = 72.0;
  this.ZO = 4.0;
  this.a7X = (4.0 * this.ZO);
  this.a7Y = (2.0 * this.ZO);
  this.Fh = 1.2;
  this.RG = 1.4142135623730951;
  this.ZL = 14.0;
  this.ZK = "Times-Roman";
  this.ZN = 0.75;
  this.ZM = 0.5;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$.prototype = $p;
$p.aiC = (function(s) {
  return (72.0 * s.Bk);
});
$p.agq = (function(s) {
  return (72.0 * s.Bj);
});
$p.X5 = (function(s) {
  return (0.5 * (72.0 * s.Bk));
});
$p.X4 = (function(s) {
  return (0.5 * (72.0 * s.Bj));
});
$p.ahs = (function(n) {
  var name = n.aK.dL("shape", "ellipse");
  var this$1 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$().afh(name);
  var this$2 = (this$1.c() ? $m_s_None$() : new $c_s_Some(this$1.d().Br));
  var base = ((this$2.c() ? $p_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$__shapeOf__T__Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$ShapeKind($m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$(), name).Bi : this$2.d()) | 0);
  var this$4 = n.aK.ag.r("peripheries");
  var this$7 = (this$4.c() ? $m_s_None$() : $m_sc_StringParsers$().hT(this$4.d()));
  var this$8 = ((this$7.c() || ((this$7.d() | 0) >= 0)) ? this$7 : $m_s_None$());
  return ((this$8.c() ? base : this$8.d()) | 0);
});
$p.aR1 = (function(n) {
  var this$1 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$().afh(n.aK.dL("shape", "ellipse"));
  if (this$1.c()) {
    return $m_s_None$();
  } else {
    var x0 = this$1.d();
    var peripheries = $p_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$__li$1__Lorg_jpablo_graphexplorer_graphviz_model_RNode__T__I__I__I(this, n, "peripheries", x0.Br, 0);
    var orientation = (x0.Fl + $p_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$__ld$2__Lorg_jpablo_graphexplorer_graphviz_model_RNode__T__D__D__D(this, n, "orientation", 0.0, (-360.0)));
    var regular = (x0.Bs || this.Xu(n.aK.ag.r("regular")));
    return new $c_s_Some(((x0.wF === 0) ? new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Desc($p_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$__li$1__Lorg_jpablo_graphexplorer_graphviz_model_RNode__T__I__I__I(this, n, "sides", 4, 0), peripheries, orientation, $p_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$__ld$2__Lorg_jpablo_graphexplorer_graphviz_model_RNode__T__D__D__D(this, n, "distortion", 0.0, (-100.0)), $p_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$__ld$2__Lorg_jpablo_graphexplorer_graphviz_model_RNode__T__D__D__D(this, n, "skew", 0.0, (-100.0)), regular, x0.yX) : new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Desc(x0.wF, peripheries, orientation, x0.Bq, x0.Bt, regular, x0.yX)));
  }
});
$p.a42 = (function(raw, nodeId, graphName) {
  var lines = new $c_scm_ListBuffer();
  var cur = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  var i = 0;
  while ((i < raw.length)) {
    var index = i;
    var c = raw.charCodeAt(index);
    if (((c === 92) && (((1 + i) | 0) < raw.length))) {
      var index$1 = ((1 + i) | 0);
      var x13 = raw.charCodeAt(index$1);
      switch (x13) {
        case 110:
        case 108:
        case 114: {
          lines.bb(new $c_T2(cur.bP.ah, $bC(x13)));
          cur.bP.PS(0);
          i = ((2 + i) | 0);
          break;
        }
        case 92: {
          cur.jl(92);
          i = ((2 + i) | 0);
          break;
        }
        case 78: {
          cur.ei(nodeId);
          i = ((2 + i) | 0);
          break;
        }
        case 71: {
          cur.ei(graphName);
          i = ((2 + i) | 0);
          break;
        }
        default: {
          cur.jl(x13);
          i = ((2 + i) | 0);
        }
      }
    } else {
      cur.jl(c);
      i = ((1 + i) | 0);
    }
  }
  if (((!cur.c()) || lines.c())) {
    lines.bb(new $c_T2(cur.bP.ah, $bC(110)));
  }
  return lines.bM();
});
$p.aPX = (function(line, fontSizePt) {
  return ((line === "") ? $doubleToInt((fontSizePt * this.Fh)) : (fontSizePt * this.Fh));
});
$p.b3X = (function(raw, fontSizePt, fontName, nodeId, graphName) {
  var this$1 = this.a42(raw, nodeId, graphName);
  var f = ((x$1) => {
    if ((x$1 !== null)) {
      var l = x$1.g();
      return ((l === "") ? 0.0 : (fontSizePt * $m_Lorg_jpablo_graphexplorer_graphviz_metrics_FontMetrics$().WI(fontName, l, false, false)));
    }
    throw new $c_s_MatchError(x$1);
  });
  if ((this$1 === $m_sci_Nil$())) {
    var $x_1 = $m_sci_Nil$();
  } else {
    var x0 = this$1.t();
    var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
    var t = h;
    var rest = this$1.v();
    while ((rest !== $m_sci_Nil$())) {
      var x0$1 = rest.t();
      var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
      t.U = nx;
      t = nx;
      rest = rest.v();
    }
    var $x_1 = h;
  }
  var this$3 = $f_sc_IterableOnceOps__maxOption__s_math_Ordering__s_Option($x_1, $m_s_math_Ordering$DeprecatedDoubleOrdering$());
  return (+(this$3.c() ? 0.0 : this$3.d()));
});
$p.Xu = (function(v) {
  if ((v instanceof $c_s_Some)) {
    var s = v.J;
    var x17 = s.toLowerCase();
    switch (x17) {
      case "true":
      case "yes": {
        return true;
        break;
      }
      case "false":
      case "no": {
        return false;
        break;
      }
      default: {
        var this$3 = $m_sc_StringParsers$().hT(x17);
        return ((!this$3.c()) && ((this$3.d() | 0) > 0));
      }
    }
  }
  if (($m_s_None$() === v)) {
    return false;
  }
  throw new $c_s_MatchError(v);
});
$p.PC = (function(raw, fontSizePt, graphName) {
  var this$1 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$__labelLines__T__T__T__sci_List(this, raw, "", graphName);
  var f = ((l) => ((l === "") ? $doubleToInt((fontSizePt * $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().Fh)) : (fontSizePt * $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().Fh)));
  if ((this$1 === $m_sci_Nil$())) {
    var $x_1 = $m_sci_Nil$();
  } else {
    var x0 = this$1.t();
    var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
    var t = h;
    var rest = this$1.v();
    while ((rest !== $m_sci_Nil$())) {
      var x0$1 = rest.t();
      var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
      t.U = nx;
      t = nx;
      rest = rest.v();
    }
    var $x_1 = h;
  }
  return (+$f_sc_IterableOnceOps__sum__s_math_Numeric__O($x_1, $m_s_math_Numeric$DoubleIsFractional$()));
});
$p.Xq = (function(raw, fontSizePt, fontName, graphName) {
  var this$1 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$__labelLines__T__T__T__sci_List(this, raw, "", graphName);
  var f = ((l) => ((l === "") ? 0.0 : (fontSizePt * $m_Lorg_jpablo_graphexplorer_graphviz_metrics_FontMetrics$().WI(fontName, l, false, false))));
  if ((this$1 === $m_sci_Nil$())) {
    var $x_1 = $m_sci_Nil$();
  } else {
    var x0 = this$1.t();
    var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
    var t = h;
    var rest = this$1.v();
    while ((rest !== $m_sci_Nil$())) {
      var x0$1 = rest.t();
      var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
      t.U = nx;
      t = nx;
      rest = rest.v();
    }
    var $x_1 = h;
  }
  var this$3 = $f_sc_IterableOnceOps__maxOption__s_math_Ordering__s_Option($x_1, $m_s_math_Ordering$DeprecatedDoubleOrdering$());
  return (+(this$3.c() ? 0.0 : this$3.d()));
});
$p.PN = (function(n, g) {
  var memo = this.aug;
  var id = n.br;
  var f = (() => $p_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$__recordLayoutImpl__Lorg_jpablo_graphexplorer_graphviz_model_RNode__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__s_Option($m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$(), n, g));
  if ((g === memo.f0)) {
    var $x_1 = memo.f1;
  } else {
    var v = $ct_scm_HashMap__(new $c_scm_HashMap());
    memo.f0 = g;
    memo.f1 = v;
    var $x_1 = v;
  }
  var m = $x_1;
  if ((!($objectGetClass(m) === $d_scm_HashMap.l()))) {
    var x1 = m.r(id);
    if ((x1 instanceof $c_s_Some)) {
      var $x_2 = x1.J;
    } else {
      if ((!($m_s_None$() === x1))) {
        throw new $c_s_MatchError(x1);
      }
      var d = f();
      $p_scm_HashMap__put0__O__O__Z__s_Some(m, id, d, false);
      var $x_2 = d;
    }
  } else {
    var originalHash = $m_sr_Statics$().u(id);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var idx = (hash & ((m.S.a.length - 1) | 0));
    var x1$1 = m.S.a[idx];
    var nd = ((x1$1 === null) ? null : x1$1.by(id, hash));
    if ((nd !== null)) {
      var $x_2 = nd.b9;
    } else {
      var table0 = m.S;
      var default$1 = f();
      if ((((1 + m.eh) | 0) >= m.kI)) {
        $p_scm_HashMap__growTable__I__V(m, (m.S.a.length << 1));
      }
      $p_scm_HashMap__put0__O__O__Z__I__I__s_Some(m, id, default$1, false, hash, ((table0 === m.S) ? idx : (hash & ((m.S.a.length - 1) | 0))));
      var $x_2 = default$1;
    }
  }
  return $x_2;
});
$p.ahv = (function(n, g) {
  var memo = this.auf;
  var id = n.br;
  var f = (() => $p_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$__polygonImpl__Lorg_jpablo_graphexplorer_graphviz_model_RNode__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__s_Option($m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$(), n, g));
  if ((g === memo.f0)) {
    var $x_1 = memo.f1;
  } else {
    var v = $ct_scm_HashMap__(new $c_scm_HashMap());
    memo.f0 = g;
    memo.f1 = v;
    var $x_1 = v;
  }
  var m = $x_1;
  if ((!($objectGetClass(m) === $d_scm_HashMap.l()))) {
    var x1 = m.r(id);
    if ((x1 instanceof $c_s_Some)) {
      var $x_2 = x1.J;
    } else {
      if ((!($m_s_None$() === x1))) {
        throw new $c_s_MatchError(x1);
      }
      var d = f();
      $p_scm_HashMap__put0__O__O__Z__s_Some(m, id, d, false);
      var $x_2 = d;
    }
  } else {
    var originalHash = $m_sr_Statics$().u(id);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var idx = (hash & ((m.S.a.length - 1) | 0));
    var x1$1 = m.S.a[idx];
    var nd = ((x1$1 === null) ? null : x1$1.by(id, hash));
    if ((nd !== null)) {
      var $x_2 = nd.b9;
    } else {
      var table0 = m.S;
      var default$1 = f();
      if ((((1 + m.eh) | 0) >= m.kI)) {
        $p_scm_HashMap__growTable__I__V(m, (m.S.a.length << 1));
      }
      $p_scm_HashMap__put0__O__O__Z__I__I__s_Some(m, id, default$1, false, hash, ((table0 === m.S) ? idx : (hash & ((m.S.a.length - 1) | 0))));
      var $x_2 = default$1;
    }
  }
  return $x_2;
});
$p.b3Y = (function(n, g) {
  var shapeName = n.aK.dL("shape", "ellipse");
  var regAttr = this.Xu(n.aK.ag.r("regular"));
  var shape0 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$__shapeOf__T__Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$ShapeKind(this, shapeName);
  var shape = ((regAttr && (!shape0.wE)) ? new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$ShapeKind(shape0.yU, true, shape0.uw, shape0.yV, shape0.Bi) : shape0);
  var m = $p_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$__polyMetrics__Lorg_jpablo_graphexplorer_graphviz_model_RNode__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$ShapeKind__Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$Metrics(this, n, g, shape);
  if ((!shape.yV)) {
    return m.uv;
  }
  var bbX = m.yR;
  var bbY = m.uv;
  if ((!shape.yU)) {
    var temp = (bbY * this.RG);
    if (((m.nY > temp) && m.yT)) {
      var $x_1 = bbX;
      var x$proxy7 = (bbY / m.nY);
      var x = (1.0 / (1.0 - (x$proxy7 * x$proxy7)));
      bbX = ($x_1 * (+Math.sqrt(x)));
    } else {
      bbX = (bbX * this.RG);
      bbY = temp;
    }
  }
  var minBbY = bbY;
  matchResult24: {
    var finalY;
    var this$4 = n.aK.dL("fixedsize", "false");
    var x56 = this$4.toLowerCase();
    matchAlts17: {
      matchAlts18: {
        if ((x56 === "shape")) {
          break matchAlts18;
        }
        if ((x56 === "true")) {
          break matchAlts18;
        }
        break matchAlts17;
      }
      var finalY = m.nY;
      break matchResult24;
    }
    var x$1 = m.nY;
    var y = bbY;
    var finalY = (+Math.max(x$1, y));
  }
  var $x_2 = m.uv;
  var x$2 = (finalY - minBbY);
  return ($x_2 + (+Math.max(x$2, 0.0)));
});
$p.XB = (function(n, g) {
  var memo = this.auh;
  var id = n.br;
  var f = (() => $p_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$__nodeSizeImpl__Lorg_jpablo_graphexplorer_graphviz_model_RNode__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__s_Option($m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$(), n, g));
  if ((g === memo.f0)) {
    var $x_1 = memo.f1;
  } else {
    var v = $ct_scm_HashMap__(new $c_scm_HashMap());
    memo.f0 = g;
    memo.f1 = v;
    var $x_1 = v;
  }
  var m = $x_1;
  if ((!($objectGetClass(m) === $d_scm_HashMap.l()))) {
    var x1 = m.r(id);
    if ((x1 instanceof $c_s_Some)) {
      var $x_2 = x1.J;
    } else {
      if ((!($m_s_None$() === x1))) {
        throw new $c_s_MatchError(x1);
      }
      var d = f();
      $p_scm_HashMap__put0__O__O__Z__s_Some(m, id, d, false);
      var $x_2 = d;
    }
  } else {
    var originalHash = $m_sr_Statics$().u(id);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var idx = (hash & ((m.S.a.length - 1) | 0));
    var x1$1 = m.S.a[idx];
    var nd = ((x1$1 === null) ? null : x1$1.by(id, hash));
    if ((nd !== null)) {
      var $x_2 = nd.b9;
    } else {
      var table0 = m.S;
      var default$1 = f();
      if ((((1 + m.eh) | 0) >= m.kI)) {
        $p_scm_HashMap__growTable__I__V(m, (m.S.a.length << 1));
      }
      $p_scm_HashMap__put0__O__O__Z__I__I__s_Some(m, id, default$1, false, hash, ((table0 === m.S) ? idx : (hash & ((m.S.a.length - 1) | 0))));
      var $x_2 = default$1;
    }
  }
  return $x_2;
});
$p.J9 = (function(n, g) {
  var this$1 = this.XB(n, g);
  if (this$1.c()) {
    return $m_s_None$();
  } else {
    var x0 = this$1.d();
    return new $c_s_Some(($m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().jT(g) ? new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$Size(x0.Bj, x0.Bk) : x0));
  }
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$, "org.jpablo.graphexplorer.graphviz.layout.NodeSize$", ({
  uX: 1
}));
var $n_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$;
function $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$() {
  if ((!$n_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$)) {
    $n_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$ = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$();
  }
  return $n_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__orderImpl__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__Lorg_jpablo_graphexplorer_graphviz_layout_Order$Result($thiz, g) {
  matchResult9$1: {
    var \u03b41$;
    var x17 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().aRl(g);
    if ((x17 !== null)) {
      var \u03b41$ = new $c_T2(x17.g(), x17.h());
      break matchResult9$1;
    }
    throw new $c_s_MatchError(x17);
  }
  var rank0$2 = \u03b41$.bi;
  var dedges$2 = \u03b41$.be;
  var rankOf = $m_scm_HashMap$().DY(new $c_sc_Iterator$$anon$9(rank0$2.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => new $c_T2(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real(x$1.g()), (x$1.h() | 0))))));
  var out = new $c_scm_LinkedHashMap();
  var in$1 = new $c_scm_LinkedHashMap();
  g.cB.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n) => {
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__node$1__scm_LinkedHashMap__scm_LinkedHashMap__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__V($thiz, out, in$1, new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real(n.br));
  })));
  $m_scm_ArrayBuffer$();
  var segs = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  $m_scm_ArrayBuffer$();
  var segOwn = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  var curOwner = new $c_sr_IntRef((-1));
  var nodeSeq = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$16(new $c_sc_Iterator$$anon$9(g.cB.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => _$2.br)))));
  var origEnds = g.cu.d8(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e) => (e.ai !== e.ak))), false).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$2) => new $c_T2(e$2.ai, e$2.ak))));
  var this$20 = new $c_sci_Range$Exclusive(0, dedges$2.C(), 1);
  var byOrigTail = $f_sc_IterableOps__groupBy__F1__sci_Map($m_sci_Vector$().X(this$20), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((i) => {
    var i$1 = (i | 0);
    return origEnds.l(i$1).g();
  })));
  var byIdN = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$9(g.cB.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n$2) => new $c_T2(n$2.br, n$2)))));
  var realEdges = g.cu.d8(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$3) => (e$3.ai !== e$3.ak))), false);
  var segPortsMap = $ct_scm_HashMap__(new $c_scm_HashMap());
  $m_scm_ArrayBuffer$();
  var flatReps = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  var n$1 = dedges$2.C();
  var f$4 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x) => (x | 0)));
  if ((n$1 <= 0)) {
    var mergedInto = new $ac_I(0);
  } else {
    var array = new $ac_I(n$1);
    var i$2 = 0;
    while ((i$2 < n$1)) {
      array.a[i$2] = (f$4.i(i$2) | 0);
      i$2 = ((1 + i$2) | 0);
    }
    var mergedInto = array;
  }
  g.cB.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n$3) => {
    var prev = new $c_sr_IntRef((-1));
    $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(byOrigTail.ay(n$3.br, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      $m_sci_Vector$();
      return $m_sci_Vector0$();
    }))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((i$3) => {
      var i$4 = (i$3 | 0);
      return new $c_T2(nodeSeq.ay(origEnds.l(i$4).h(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 2147483647))), i$4);
    })), new $c_s_math_Ordering$Tuple2Ordering($m_s_math_Ordering$Int$(), $m_s_math_Ordering$Int$())).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => {
      var idx = (v1 | 0);
      var flat = ((rankOf.i(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real(dedges$2.l(idx).oY)) | 0) === (rankOf.i(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real(dedges$2.l(idx).pY)) | 0));
      if ((((prev.an >= 0) && $m_sr_BoxesRunTime$().Q(origEnds.l(idx), origEnds.l(prev.an))) && (flat || (($p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__unlabeled$1__sci_Vector__I__Z($thiz, realEdges, idx) && $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__unlabeled$1__sci_Vector__I__Z($thiz, realEdges, prev.an)) && $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__portsEq$1__sci_Vector__I__I__Z($thiz, realEdges, idx, prev.an))))) {
        mergedInto.a[idx] = mergedInto.a[prev.an];
      } else {
        $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__emit$1__sci_Vector__sr_IntRef__scm_HashMap__sci_Vector__scm_ArrayBuffer__scm_LinkedHashMap__scm_LinkedHashMap__scm_ArrayBuffer__scm_ArrayBuffer__scm_HashMap__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__I__V($thiz, dedges$2, curOwner, rankOf, realEdges, flatReps, out, in$1, segs, segOwn, segPortsMap, byIdN, g, idx);
        prev.an = idx;
      }
    })));
  })));
  var flatOutAdj = $ct_scm_HashMap__(new $c_scm_HashMap());
  var flatInAdj = $ct_scm_HashMap__(new $c_scm_HashMap());
  $f_sc_IterableOnceOps__foreach__F1__V(flatReps, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    var t = x$1$2.bH;
    var h = x$1$2.bU;
    flatOutAdj.ec(t, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      $m_scm_ArrayBuffer$();
      return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
    }))).Y(h);
    return flatInAdj.ec(h, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      $m_scm_ArrayBuffer$();
      return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
    }))).Y(t);
  })));
  var done = $m_scm_Set$().aO();
  $m_scm_ArrayBuffer$();
  var res = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  $m_scm_ArrayBuffer$();
  var emptyAdj = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  g.cB.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((nn) => {
    var s$1 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real(nn.br);
    if ((!done.E(s$1))) {
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__visit$1__scm_Set__scm_ArrayBuffer__scm_HashMap__scm_ArrayBuffer__scm_HashMap__scm_LinkedHashMap__scm_LinkedHashMap__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__V($thiz, done, res, flatInAdj, emptyAdj, flatOutAdj, in$1, out, s$1);
    }
  })));
  var $x_1 = g.cB.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n$4) => new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real(n$4.br))));
  var this$50 = new $c_sc_Iterator$$anon$7(rankOf.lo(), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$$anon$2());
  $x_1.g9($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O($m_sci_Vector$().X(this$50), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v) => new $c_T2(v.kB, v.wD))), new $c_s_math_Ordering$Tuple2Ordering($m_s_math_Ordering$Int$(), $m_s_math_Ordering$Int$()))).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n$5) => {
    if ((!done.E(n$5))) {
      done.Y(n$5);
      res.aw(n$5);
    }
  })));
  var gdNlist = $m_sci_Vector$().X(res);
  var n$6 = dedges$2.C();
  var elem = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 0));
  if ((n$6 <= 0)) {
    var classSize = new $ac_I(0);
  } else {
    var array$1 = new $ac_I(n$6);
    var i$5 = 0;
    while ((i$5 < n$6)) {
      array$1.a[i$5] = (elem.a3() | 0);
      i$5 = ((1 + i$5) | 0);
    }
    var classSize = array$1;
  }
  $m_sc_ArrayOps$().aOh(mergedInto, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1$1) => {
    var r$1 = (v1$1 | 0);
    classSize.a[r$1] = ((1 + classSize.a[r$1]) | 0);
  })));
  var segXpen = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$9(new $c_sc_Iterator$$anon$14(segs.bB().o(), segOwn), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3) => {
    var s$2 = x$1$3.g();
    var o = (x$1$3.h() | 0);
    var value = classSize.a[o];
    var hi = (value >> 31);
    return new $c_T2(s$2, $bL(value, hi));
  }))));
  var this$77 = new $c_sc_Iterator$$anon$9(flatReps.bB().o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$4) => {
    var t$1 = x$1$4.bH;
    var h$1 = x$1$4.bU;
    var rep = (x$1$4.c3 | 0);
    return new $c_T3(t$1, h$1, (+$f_sc_IterableOnceOps__sum__s_math_Numeric__O(new $c_sc_Iterator$$anon$9(new $c_sc_Iterator$$anon$6($m_sc_ArrayOps$().b2M(mergedInto).o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$5) => (mergedInto.a[(_$5 | 0)] === rep))), false), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((j) => {
      var j$1 = (j | 0);
      var this$71 = realEdges.l(j$1).b4.ag.r("weight");
      var f$8 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6) => ($m_sc_StringParsers$().c1(_$6) ? new $c_s_Some($m_jl_Double$().bd(_$6)) : $m_s_None$())));
      var this$72 = (this$71.c() ? $m_s_None$() : f$8.i(this$71.d()));
      var default$1 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 1.0));
      return (+(this$72.c() ? default$1.a3() : this$72.d()));
    }))), $m_s_math_Numeric$DoubleIsFractional$())));
  })));
  var flatPairs = $m_sci_Vector$().X(this$77);
  var flip = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().jT(g);
  matchResult17$1: {
    var \u03b42$;
    if ($f_sc_SeqOps__isEmpty__Z($m_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$().tV(g))) {
      var ported = $m_sci_Set$().af(new $c_sc_Iterator$$anon$10(g.cu.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$4) => ((!e$4.ka.c()) ? $m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode.r().C)([new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real(e$4.ai)])).o() : $m_sc_Iterator$().b8).lS(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((e$2$1) => (() => ((!e$2$1.k9.c()) ? $m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode.r().C)([new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real(e$2$1.ak)])).o() : $m_sc_Iterator$().b8)))(e$4)))))));
      matchResult16$1: {
        var \u03b48$;
        var x37 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__runMincross__sc_Map__sc_Map__sc_Map__sci_Vector__Z__F2__F1__F1__Z__F2__F1__sci_Vector__s_CanEqual__T2($thiz, out, in$1, rankOf, gdNlist, flip, new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((t$2, h$2) => $uJ(segXpen.ay(new $c_T2(t$2, h$2), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $bL(1, 0))))))), $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__runMincross$default$7__F1($thiz), $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__runMincross$default$8__F1($thiz), true, new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((t$2$1, h$2$1) => segPortsMap.ay(new $c_T2(t$2$1, h$2$1), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts$().Fk))))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((elem$1) => ported.E(elem$1))), flatPairs, $m_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$().nx());
        if ((x37 !== null)) {
          var $x_3 = x37.g();
          var $x_2 = $uJ(x37.h());
          var \u03b48$ = new $c_T2($x_3, $x_2);
          break matchResult16$1;
        }
        throw new $c_s_MatchError(x37);
      }
      var $x_5 = \u03b48$.bi;
      var $x_4 = $uJ(\u03b48$.be);
      var x40 = new $c_T3($x_5, $x_4, gdNlist);
    } else {
      var portedC = $m_sci_Set$().af(new $c_sc_Iterator$$anon$10(g.cu.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$5) => ((!e$5.ka.c()) ? $m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode.r().C)([new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real(e$5.ai)])).o() : $m_sc_Iterator$().b8).lS(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((e$2$2) => (() => ((!e$2$2.k9.c()) ? $m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode.r().C)([new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real(e$2$2.ak)])).o() : $m_sc_Iterator$().b8)))(e$5)))))));
      var x40 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__orderClustered__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sc_Map__sc_Map__sc_Map__Z__sci_Vector__F2__F2__F1__sci_Vector__T3($thiz, g, out, in$1, rankOf, flip, $m_sci_Vector$().X(segs), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((t$3, h$3) => $uJ(segXpen.ay(new $c_T2(t$3, h$3), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $bL(1, 0))))))), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((t$4, h$4) => segPortsMap.ay(new $c_T2(t$4, h$4), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts$().Fk))))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((elem$2) => portedC.E(elem$2))), flatPairs);
    }
    if ((x40 !== null)) {
      var $x_7 = x40.bH;
      var $x_6 = $uJ(x40.bU);
      var \u03b42$ = new $c_T3($x_7, $x_6, x40.c3);
      break matchResult17$1;
    }
    throw new $c_s_MatchError(x40);
  }
  var order$2 = \u03b42$.bH;
  var $x_8 = $uJ(\u03b42$.bU);
  var cross$2_$_lo = $x_8.l;
  var cross$2_$_hi = $x_8.h;
  var posNlist$2 = \u03b42$.c3;
  matchResult18$1: {
    var \u03b43$;
    var x44 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__flatLabelSlots__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Vector__sci_Vector__F1__T2($thiz, g, order$2, posNlist$2, g.cu.d8(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$6) => (e$6.ai !== e$6.ak))), false), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n$6$1) => out.ay(n$6$1, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_Seq$().f7()))).iz())));
    if ((x44 !== null)) {
      var \u03b43$ = new $c_T2(x44.g(), x44.h());
      break matchResult18$1;
    }
    throw new $c_s_MatchError(x44);
  }
  var order2$2 = \u03b43$.bi;
  var flatCreation$2 = \u03b43$.be;
  var $x_10 = $m_sci_Vector$().X(segs);
  var $x_9 = $m_sci_Vector$().X(segOwn);
  var this$106 = $m_s_Predef$().a5j(mergedInto);
  return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$Result(rank0$2, order2$2, cross$2_$_lo, cross$2_$_hi, $x_10, $x_9, $m_sci_Vector$().X(this$106), flatCreation$2, posNlist$2);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__flatLabelSlots__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Vector__sci_Vector__F1__T2($thiz, g, order, nlist, dedges, outOf) {
  var pos = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$10(order.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var r = (x$1.g() | 0);
    return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(x$1.h()).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => new $c_T2(x$1$2.g(), new $c_T2(r, (x$1$2.h() | 0))))));
  }))));
  var labelled = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().agP(g).ln();
  var end = dedges.C();
  var isEmpty = (end <= 0);
  var scala$collection$immutable$Range$$lastElement = ((end - 1) | 0);
  var b = $m_sci_IndexedSeq$().b5();
  var it = new $c_sci_RangeIterator(0, 1, scala$collection$immutable$Range$$lastElement, isEmpty);
  while (it.g0) {
    var elem = it.hp();
    var e = dedges.l(elem);
    if ((e.ai !== e.ak)) {
      var this$10 = e.b4.ag.r("label");
      var $x_2 = ((!this$10.c()) && (this$10.d() !== ""));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      matchResult19: {
        var $x_1;
        var _1 = pos.r(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real(e.ai));
        var _2 = pos.r(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real(e.ak));
        if ((_1 instanceof $c_s_Some)) {
          var x55 = _1.J;
          if ((x55 !== null)) {
            var rt = (x55.g() | 0);
            if ((_2 instanceof $c_s_Some)) {
              var x51 = _2.J;
              if ((x51 !== null)) {
                var $x_1 = (rt === (x51.g() | 0));
                break matchResult19;
              }
            }
          }
        }
        var $x_1 = false;
      }
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      b.Y(elem);
    }
  }
  var cand = b.aR();
  if (cand.c()) {
    return new $c_T2(order, ($m_sci_Vector$(), $m_sci_Vector0$()));
  }
  var ranks = $m_scm_Map$().cc(new $c_sc_MapView$MapValues(new $c_sc_MapView$Id(order), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$8) => $m_scm_Buffer$().Al(_$8)))));
  $m_scm_ArrayBuffer$();
  var created = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  var nodeSeq = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$16(new $c_sc_Iterator$$anon$9(g.cB.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$10) => _$10.br)))));
  var m = $m_scm_Map$().aO();
  var it$1 = cand.o();
  while (it$1.p()) {
    var elem$1 = it$1.q();
    var i = (elem$1 | 0);
    var key = dedges.l(i).ai;
    m.ec(key, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((this$24) => (() => this$24.fS()))(cand))).Y(elem$1);
  }
  var result = $m_sci_HashMap$().fk;
  var mapIt = m.o();
  while (mapIt.p()) {
    var x1 = mapIt.q();
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1);
    }
    var k = x1.g();
    var v = x1.h();
    result = result.hq(k, v.aR());
  }
  var byTail = result;
  nlist.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((ln) => {
    var nid = ((ln instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real) ? ln.mh : "");
    $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(byTail.ay(nid, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      $m_sci_Vector$();
      return $m_sci_Vector0$();
    }))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((i$1) => {
      var i$2 = (i$1 | 0);
      return new $c_T2(nodeSeq.ay(dedges.l(i$2).ak, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 2147483647))), i$2);
    })), new $c_s_math_Ordering$Tuple2Ordering($m_s_math_Ordering$Int$(), $m_s_math_Ordering$Int$())).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => {
      var i$3 = (v1 | 0);
      var e$1 = dedges.l(i$3);
      if ((!$p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__adjacent$1__scm_Map__sci_Map__sci_Set__Lorg_jpablo_graphexplorer_graphviz_model_REdge__Z($thiz, ranks, pos, labelled, e$1))) {
        var r$1 = (pos.i(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real(e$1.ai)).g() | 0);
        var x = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__ordOf$1__scm_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__I($thiz, ranks, pos, new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real(e$1.ai));
        var y$1 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__ordOf$1__scm_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__I($thiz, ranks, pos, new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real(e$1.ak));
        var lpos = ((x < y$1) ? x : y$1);
        var x$2 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__ordOf$1__scm_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__I($thiz, ranks, pos, new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real(e$1.ai));
        var y$2 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__ordOf$1__scm_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__I($thiz, ranks, pos, new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real(e$1.ak));
        var rpos = ((x$2 > y$2) ? x$2 : y$2);
        var place = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__flatLimits$1__scm_Map__sci_Vector__I__I__I__I__F1__sci_Map__I__I__I__I($thiz, ranks, dedges, 2, 0, 3, 1, outOf, pos, ((r$1 - 1) | 0), lpos, rpos);
        var row = ranks.ec(((r$1 - 1) | 0), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_scm_Buffer$().f7())));
        var y$3 = row.C();
        var y$4 = ((place < y$3) ? place : y$3);
        row.a3M(((y$4 < 0) ? 0 : y$4), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$FlatLabel(i$3));
        created.aw(i$3);
      }
    })));
  })));
  return new $c_T2($m_sci_Map$().ao(new $c_sc_MapView$MapValues(new $c_sc_MapView$Id(ranks), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$11) => $m_sci_Vector$().X(_$11))))), $m_sci_Vector$().X(created));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__decomposeOrder__sci_Vector__sci_Vector__sc_Map__sc_Map__s_CanEqual__sci_Vector($thiz, seeds, others, out, in$1, x$5) {
  var done = $m_scm_Set$().aO();
  $m_scm_ArrayBuffer$();
  var res = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  seeds.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((s) => {
    if ((!done.E(s))) {
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__visit$2__scm_Set__scm_ArrayBuffer__sc_Map__sc_Map__O__V($thiz, done, res, in$1, out, s);
    }
  })));
  seeds.iR(others).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n) => {
    if ((!done.E(n))) {
      done.Y(n);
      res.aw(n);
    }
  })));
  return $m_sci_Vector$().X(res);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__orderClustered__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sc_Map__sc_Map__sc_Map__Z__sci_Vector__F2__F2__F1__sci_Vector__T3($thiz, g, nodeOut, nodeIn, rankOf, flip, segsInOrder, segWeight, segPorts, hasPort, flatPairs) {
  var cinfos = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$().tV(g);
  var mergedNlist = new $c_scm_ListBuffer();
  var clustOf = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$().P5(g);
  var vOrigEnds = g.cu.d8(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e) => (e.ai !== e.ak))), false).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$2) => new $c_T2(e$2.ai, e$2.ak))));
  var allNodes = nodeOut.lo().d2();
  var clRanks = $f_sc_IterableOps__groupBy__F1__sci_Map(allNodes, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n) => $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__cOf$1__sci_Map__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__s_Option($thiz, clustOf, vOrigEnds, n)))).DQ(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$$anon$3(rankOf));
  var cOut = new $c_scm_LinkedHashMap();
  var cIn = new $c_scm_LinkedHashMap();
  var cRank = $ct_scm_HashMap__(new $c_scm_HashMap());
  allNodes.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n$2) => {
    if ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__cOf$1__sci_Map__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__s_Option($thiz, clustOf, vOrigEnds, n$2).c()) {
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__cInit$1__scm_LinkedHashMap__scm_LinkedHashMap__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__I__V($thiz, cOut, cIn, cRank, new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Nd(n$2), (rankOf.i(n$2) | 0));
    }
  })));
  clRanks.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    matchResult37: {
      if ((x$1 !== null)) {
        var x114 = x$1.h();
        var ci = (x$1.g() | 0);
        if ((x114 !== null)) {
          var lo = (x114.g() | 0);
          var hi = (x114.h() | 0);
          new $c_sci_Range$Inclusive(lo, hi, 1).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => {
            var r = (v1 | 0);
            $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__cInit$1__scm_LinkedHashMap__scm_LinkedHashMap__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__I__V($thiz, cOut, cIn, cRank, new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Sk(ci, r), r);
          })));
          new $c_sci_Range$Exclusive(lo, hi, 1).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((r$1) => {
            var r$2 = (r$1 | 0);
            $f_sc_MapOps__apply__O__O(cOut, new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Sk(ci, r$2)).Y(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Sk(ci, ((1 + r$2) | 0)));
            return $f_sc_MapOps__apply__O__O(cIn, new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Sk(ci, ((1 + r$2) | 0))).Y(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Sk(ci, r$2));
          })));
          break matchResult37;
        }
      }
      throw new $c_s_MatchError(x$1);
    }
  })));
  segsInOrder.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    var t = x$1$2.g();
    var h = x$1$2.h();
    var lt = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__leaderC$1__sc_Map__sci_Map__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode($thiz, rankOf, clustOf, vOrigEnds, t);
    var lh = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__leaderC$1__sc_Map__sci_Map__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode($thiz, rankOf, clustOf, vOrigEnds, h);
    matchResult38$1: {
      var $x_1;
      var x117 = new $c_T2(lt, lh);
      var x118 = x117.bi;
      var x119 = x117.be;
      if ((x118 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Sk)) {
        var x126 = x118.pU;
        if ((x119 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Sk)) {
          var $x_1 = (x126 === x119.pU);
          break matchResult38$1;
        }
      }
      var $x_1 = ((lt === null) ? (lh === null) : lt.e(lh));
    }
    if ((!$x_1)) {
      $f_sc_MapOps__apply__O__O(cOut, lt).Y(lh);
      $f_sc_MapOps__apply__O__O(cIn, lh).Y(lt);
    }
  })));
  var cSeeds = $f_sc_Iterator__distinct__sc_Iterator(new $c_sc_Iterator$$anon$9(new $c_sc_Iterator$$anon$6(new $c_sc_Iterator$$anon$9(g.cB.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n$3) => new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real(n$3.br)))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((key$2) => rankOf.E(key$2))), false), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n$4) => $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__leaderC$1__sc_Map__sci_Map__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode($thiz, rankOf, clustOf, vOrigEnds, n$4))))).d2();
  var this$33 = new $c_sc_Iterator$$anon$6(cOut.lo(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((elem$2) => $f_sc_SeqOps__contains__O__Z(cSeeds, elem$2))), true);
  var cOthers = $m_sci_Vector$().X(this$33);
  var cSeed = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__decomposeOrder__sci_Vector__sci_Vector__sc_Map__sc_Map__s_CanEqual__sci_Vector($thiz, cSeeds, cOthers, cOut, cIn, $m_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$().nx());
  var skWeight = new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((x$1$3, x$2) => {
    var x128 = new $c_T2(x$1$3, x$2);
    var x129 = x128.bi;
    var x130 = x128.be;
    if ((x129 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Sk)) {
      var x137 = x129.pU;
      if ((x130 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Sk)) {
        if ((x137 === x130.pU)) {
          return $bL(1000, 0);
        }
      }
    }
    return $bL(1, 0);
  }));
  var skColOf = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$4) => ((x$1$4 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Sk) ? new $c_s_Some(x$1$4.pU) : $m_s_None$())));
  var skColNodes = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((ci$1) => {
    var ci$2 = (ci$1 | 0);
    matchResult41$1: {
      var \u03b413$;
      var x144 = clRanks.i(ci$2);
      if ((x144 !== null)) {
        var \u03b413$ = new $c_T2((x144.g() | 0), (x144.h() | 0));
        break matchResult41$1;
      }
      throw new $c_s_MatchError(x144);
    }
    return new $c_sci_Range$Inclusive((\u03b413$.bi | 0), (\u03b413$.be | 0), 1).PD(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((r$3) => new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Sk(ci$2, (r$3 | 0))))).d2();
  }));
  matchResult42$1: {
    var \u03b411$;
    var x147 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__runMincross__sc_Map__sc_Map__sc_Map__sci_Vector__Z__F2__F1__F1__Z__F2__F1__sci_Vector__s_CanEqual__T2($thiz, cOut, cIn, cRank, cSeed, flip, skWeight, skColOf, skColNodes, true, $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__runMincross$default$10__F2($thiz), $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__runMincross$default$11__F1($thiz), ($m_sci_Vector$(), $m_sci_Vector0$()), $m_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$().nx());
    if ((x147 !== null)) {
      var $x_3 = x147.g();
      var $x_2 = $uJ(x147.h());
      var \u03b411$ = new $c_T2($x_3, $x_2);
      break matchResult42$1;
    }
    throw new $c_s_MatchError(x147);
  }
  var cOrder$2 = \u03b411$.bi;
  $uJ(\u03b411$.be);
  var rows = $m_scm_HashMap$().DY(cOrder$2.kP(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$5) => {
    var r$5 = (x$1$5.g() | 0);
    var row = x$1$5.h();
    return new $c_T2(r$5, $m_scm_ArrayBuffer$().y9(row));
  }))));
  if ((!rankOf.c())) {
    new $c_sci_Range$Inclusive(($f_sc_IterableOnceOps__min__s_math_Ordering__O(rankOf.hr(), $m_s_math_Ordering$Int$()) | 0), ($f_sc_IterableOnceOps__max__s_math_Ordering__O(rankOf.hr(), $m_s_math_Ordering$Int$()) | 0), 1).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((r$6) => {
      var r$7 = (r$6 | 0);
      return rows.ec(r$7, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
        $m_scm_ArrayBuffer$();
        return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
      })));
    })));
  }
  var gpos = $ct_scm_HashMap__(new $c_scm_HashMap());
  $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__reindex$1__scm_HashMap__scm_HashMap__V($thiz, gpos, rows);
  var gMinR = (rankOf.c() ? 0 : ($f_sc_IterableOnceOps__min__s_math_Ordering__O(rankOf.hr(), $m_s_math_Ordering$Int$()) | 0));
  var gMaxR = (rankOf.c() ? 0 : ($f_sc_IterableOnceOps__max__s_math_Ordering__O(rankOf.hr(), $m_s_math_Ordering$Int$()) | 0));
  var expanded = $m_scm_Set$().aO();
  var hOut = new $c_scm_LinkedHashMap();
  var hIn = new $c_scm_LinkedHashMap();
  var hWeight = $ct_scm_HashMap__(new $c_scm_HashMap());
  var hPorts = $ct_scm_HashMap__(new $c_scm_HashMap());
  $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__rebuildAdjacency$1__scm_LinkedHashMap__scm_LinkedHashMap__scm_HashMap__scm_HashMap__scm_HashMap__sci_Map__scm_Set__sci_Vector__F2__F2__sc_Map__sci_Map__sci_Vector__V($thiz, hOut, hIn, hWeight, hPorts, rows, clRanks, expanded, segsInOrder, segWeight, segPorts, rankOf, clustOf, vOrigEnds);
  $m_scm_ArrayBuffer$();
  var emptyRow = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  var fInC = $ct_scm_HashMap__(new $c_scm_HashMap());
  var fOutC = $ct_scm_HashMap__(new $c_scm_HashMap());
  flatPairs.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$6) => {
    var t$1 = x$1$6.bH;
    var h$1 = x$1$6.bU;
    if (((+x$1$6.c3) !== 0.0)) {
      var \u03b414$ = new $c_T2(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Nd(t$1), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Nd(h$1));
      var ct = \u03b414$.bi;
      var ch = \u03b414$.be;
      fOutC.ec(ct, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
        $m_scm_ArrayBuffer$();
        return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
      }))).Y(ch);
      fInC.ec(ch, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
        $m_scm_ArrayBuffer$();
        return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
      }))).Y(ct);
    }
  })));
  $f_sc_SeqOps__sorted__s_math_Ordering__O(clRanks.lo().d2(), $m_s_math_Ordering$Int$()).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1$1) => {
    var ci$3 = (v1$1 | 0);
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__expandCluster$1__scm_ListBuffer__sci_Map__scm_HashMap__scm_Set__sci_Vector__sc_Map__sci_Vector__sc_Map__sci_Map__sci_Vector__scm_LinkedHashMap__scm_LinkedHashMap__scm_HashMap__scm_HashMap__sci_Vector__F2__F2__scm_HashMap__I__V($thiz, mergedNlist, clRanks, rows, expanded, allNodes, nodeOut, cinfos, rankOf, clustOf, vOrigEnds, hOut, hIn, hWeight, hPorts, segsInOrder, segWeight, segPorts, gpos, ci$3);
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__refineCluster$1__sci_Map__scm_HashMap__scm_HashMap__I__I__scm_LinkedHashMap__scm_ArrayBuffer__scm_HashMap__F1__scm_HashMap__scm_LinkedHashMap__sci_Map__sci_Vector__scm_HashMap__scm_HashMap__I__V($thiz, clRanks, rows, gpos, gMinR, gMaxR, hOut, emptyRow, hWeight, hasPort, hPorts, hIn, clustOf, vOrigEnds, fInC, fOutC, ci$3);
  })));
  var mval = $ct_scm_HashMap__(new $c_scm_HashMap());
  var candidate = $m_scm_HashMap$().DY(new $c_sci_Range$Inclusive(gMinR, gMaxR, 1).PD(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((r$2$1) => new $c_T2((r$2$1 | 0), true)))));
  var $x_4 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__ncrossGlobal$1__I__I__scm_HashMap__scm_HashMap__scm_LinkedHashMap__scm_ArrayBuffer__scm_HashMap__F1__scm_HashMap__scm_LinkedHashMap__J($thiz, gMinR, gMaxR, rows, gpos, hOut, emptyRow, hWeight, hasPort, hPorts, hIn);
  var cur_$_lo = $x_4.l;
  var cur_$_hi = $x_4.h;
  var best_$_lo = cur_$_lo;
  var best_$_hi = cur_$_hi;
  var bst = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__snapshot$2__scm_HashMap__sci_Map($thiz, rows);
  var trying = 0;
  var iter = 0;
  var brk = false;
  while (((iter < $thiz.RH) && (!brk))) {
    if ((trying >= $thiz.ZQ)) {
      brk = true;
    } else {
      trying = ((1 + trying) | 0);
      var x$3_$_lo = cur_$_lo;
      var x$3_$_hi = cur_$_hi;
      if (((x$3_$_lo | x$3_$_hi) === 0)) {
        brk = true;
      } else {
        $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__mincrossStep$2__I__I__scm_HashMap__scm_HashMap__scm_HashMap__scm_LinkedHashMap__scm_ArrayBuffer__scm_LinkedHashMap__scm_HashMap__scm_HashMap__scm_HashMap__sci_Map__sci_Vector__scm_HashMap__scm_HashMap__I__V($thiz, gMinR, gMaxR, rows, gpos, mval, hOut, emptyRow, hIn, hPorts, fInC, fOutC, clustOf, vOrigEnds, candidate, hWeight, iter);
        var $x_5 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__ncrossGlobal$1__I__I__scm_HashMap__scm_HashMap__scm_LinkedHashMap__scm_ArrayBuffer__scm_HashMap__F1__scm_HashMap__scm_LinkedHashMap__J($thiz, gMinR, gMaxR, rows, gpos, hOut, emptyRow, hWeight, hasPort, hPorts, hIn);
        cur_$_lo = $x_5.l;
        cur_$_hi = $x_5.h;
        var x$4_$_lo = cur_$_lo;
        var x$4_$_hi = cur_$_hi;
        var x$5_$_lo = best_$_lo;
        var x$5_$_hi = best_$_hi;
        if (((x$4_$_hi === x$5_$_hi) ? ((x$4_$_lo >>> 0) <= (x$5_$_lo >>> 0)) : (x$4_$_hi < x$5_$_hi))) {
          bst = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__snapshot$2__scm_HashMap__sci_Map($thiz, rows);
          var x$6_$_lo = cur_$_lo;
          var x$6_$_hi = cur_$_hi;
          var $x_6 = $thiz.ZP;
          var x$7_$_lo = best_$_lo;
          var x$7_$_hi = best_$_hi;
          if ((((4.294967296E9 * x$6_$_hi) + (x$6_$_lo >>> 0.0)) < ($x_6 * ((4.294967296E9 * x$7_$_hi) + (x$7_$_lo >>> 0.0))))) {
            trying = 0;
          }
          best_$_lo = cur_$_lo;
          best_$_hi = cur_$_hi;
        }
        iter = ((1 + iter) | 0);
      }
    }
  }
  var x$8_$_lo = cur_$_lo;
  var x$8_$_hi = cur_$_hi;
  var x$9_$_lo = best_$_lo;
  var x$9_$_hi = best_$_hi;
  if (((x$8_$_hi === x$9_$_hi) ? ((x$8_$_lo >>> 0) > (x$9_$_lo >>> 0)) : (x$8_$_hi > x$9_$_hi))) {
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__restore$2__scm_HashMap__scm_HashMap__sci_Map__V($thiz, rows, gpos, bst);
  }
  var x$10_$_lo = best_$_lo;
  var x$10_$_hi = best_$_hi;
  if (((x$10_$_hi === 0) ? (x$10_$_lo !== 0) : (x$10_$_hi > 0))) {
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__transpose$2__I__I__scm_HashMap__scm_HashMap__sci_Map__sci_Vector__scm_HashMap__scm_LinkedHashMap__scm_ArrayBuffer__scm_HashMap__scm_HashMap__scm_LinkedHashMap__Z__V($thiz, gMinR, gMaxR, candidate, rows, clustOf, vOrigEnds, gpos, hIn, emptyRow, hPorts, hWeight, hOut, false);
  }
  var $x_8 = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$9(rows.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$7) => {
    var r$9 = (x$1$7.g() | 0);
    var b = x$1$7.h();
    return new $c_T2(r$9, $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O($m_sci_Vector$().X(b), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$$anon$5()));
  }))));
  var $x_7 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__ncrossGlobal$1__I__I__scm_HashMap__scm_HashMap__scm_LinkedHashMap__scm_ArrayBuffer__scm_HashMap__F1__scm_HashMap__scm_LinkedHashMap__J($thiz, gMinR, gMaxR, rows, gpos, hOut, emptyRow, hWeight, hasPort, hPorts, hIn);
  return new $c_T3($x_8, $x_7, $m_sci_Vector$().X(mergedNlist).iR($f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(cSeed, new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$$anon$6())));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__runMincross__sc_Map__sc_Map__sc_Map__sci_Vector__Z__F2__F1__F1__Z__F2__F1__sci_Vector__s_CanEqual__T2($thiz, out, in$1, rankOf, gdNlist, flip, weight, columnOf, columnNodes, rootGraph, segPorts, hasPort, flatPairs, x$13) {
  if ((!rootGraph)) {
    var comps = $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_sci_Vector.r().C)([gdNlist])));
  } else {
    var adj = $ct_scm_HashMap__(new $c_scm_HashMap());
    out.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
      var n = x$1.g();
      var ws = x$1.h();
      var it = ws.bB().o();
      while (it.p()) {
        $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__link$1__scm_HashMap__O__O__V($thiz, adj, n, it.q());
      }
    })));
    flatPairs.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
      var t = x$1$2.bH;
      var h = x$1$2.bU;
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__link$1__scm_HashMap__O__O__V($thiz, adj, t, h);
    })));
    var compOf = $ct_scm_HashMap__(new $c_scm_HashMap());
    var ci = new $c_sr_IntRef(0);
    gdNlist.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((seed) => {
      if ((!compOf.E(seed))) {
        var elems$1 = $m_sr_ScalaRunTime$().hP(new $ac_O([seed]));
        var stk = $ct_scm_Stack__I__(new $c_scm_Stack(), 16).kl(elems$1);
        $p_scm_HashMap__put0__O__O__Z__s_Some(compOf, seed, ci.an, false);
        while ((!stk.c())) {
          var n$1 = stk.h7(false);
          var originalHash = $m_sr_Statics$().u(n$1);
          var hash = (originalHash ^ ((originalHash >>> 16) | 0));
          var x1 = adj.S.a[(hash & ((adj.S.a.length - 1) | 0))];
          var nd = ((x1 === null) ? null : x1.by(n$1, hash));
          ((nd === null) ? ($m_scm_ArrayBuffer$(), $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer())) : nd.b9).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((compOf, ci, stk) => ((w) => {
            if ((!compOf.E(w))) {
              $p_scm_HashMap__put0__O__O__Z__s_Some(compOf, w, ci.an, false);
              stk.gm(w);
            }
          }))(compOf, ci, stk)));
        }
        ci.an = ((1 + ci.an) | 0);
      }
    })));
    var end = ci.an;
    var this$14 = new $c_sc_Iterator$$anon$9(new $c_sci_RangeIterator(0, 1, ((end - 1) | 0), (end <= 0)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((k) => gdNlist.d8(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((k$1) => ((n$2) => ((compOf.i(n$2) | 0) === k$1)))((k | 0))), false))));
    var comps = $m_sci_Vector$().X(this$14);
  }
  if ((comps.C() === 1)) {
    return $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__runOne$1__sc_Map__Z__sc_Map__sc_Map__F1__F1__F2__F2__F1__Z__sci_Vector__sci_Vector__T2($thiz, rankOf, flip, out, in$1, columnOf, columnNodes, weight, segPorts, hasPort, rootGraph, comps.t(), flatPairs);
  } else {
    var totalCross = new $c_sr_LongRef(0, 0);
    var finalRanks = $ct_scm_HashMap__(new $c_scm_HashMap());
    comps.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((comp) => {
      var cset = $m_sci_Set$().af(comp);
      matchResult71: {
        var \u03b428$___1;
        var \u03b428$___2;
        var x256 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__runOne$1__sc_Map__Z__sc_Map__sc_Map__F1__F1__F2__F2__F1__Z__sci_Vector__sci_Vector__T2($thiz, rankOf, flip, out, in$1, columnOf, columnNodes, weight, segPorts, hasPort, rootGraph, comp, flatPairs.d8(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((p) => cset.E(p.bH))), false));
        if ((x256 !== null)) {
          var $x_2 = x256.g();
          var $x_1 = $uJ(x256.h());
          var \u03b428$___1 = $x_2;
          var \u03b428$___2 = $x_1;
          break matchResult71;
        }
        throw new $c_s_MatchError(x256);
      }
      var ord$2 = \u03b428$___1;
      var $x_3 = $uJ(\u03b428$___2);
      var c$2_$_lo = $x_3.l;
      var c$2_$_hi = $x_3.h;
      var x_$_lo = totalCross.ji;
      var x_$_hi = totalCross.jj;
      var lo = ((x_$_lo + c$2_$_lo) | 0);
      var hi = ((((x_$_hi + c$2_$_hi) | 0) + (((lo >>> 0) < (x_$_lo >>> 0)) | 0)) | 0);
      totalCross.ji = lo;
      totalCross.jj = hi;
      ord$2.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$1) => {
        var r = (x$1$1.g() | 0);
        var v = x$1$1.h();
        if ((!$f_sc_SeqOps__isEmpty__Z(v))) {
          var originalHash$1 = $m_sr_Statics$().u(r);
          var hash$1 = (originalHash$1 ^ ((originalHash$1 >>> 16) | 0));
          var x1$1 = finalRanks.S.a[(hash$1 & ((finalRanks.S.a.length - 1) | 0))];
          var nd$1 = ((x1$1 === null) ? null : x1$1.by(r, hash$1));
          $p_scm_HashMap__put0__O__O__Z__s_Some(finalRanks, r, ((nd$1 === null) ? ($m_sci_Vector$(), $m_sci_Vector0$()) : nd$1.b9).g9(v), false);
        }
      })));
    })));
    return new $c_T2($m_sci_Map$().ao(finalRanks).a5g(($m_sci_Vector$(), $m_sci_Vector0$())), $bL(totalCross.ji, totalCross.jj));
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__runMincross$default$7__F1($thiz) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$15) => $m_s_None$()));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__runMincross$default$8__F1($thiz) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$16) => {
    $m_sci_Vector$();
    return $m_sci_Vector0$();
  }));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__runMincross$default$10__F2($thiz) {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((_$17, _$18) => $m_Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts$().Fk));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__runMincross$default$11__F1($thiz) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$19) => false));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__node$1__scm_LinkedHashMap__scm_LinkedHashMap__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__V($thiz, out$1, in$1, id) {
  var f = (() => {
    $m_scm_ArrayBuffer$();
    return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  });
  if ((!($objectGetClass(out$1) === $d_scm_LinkedHashMap.l()))) {
    var x1 = out$1.r(id);
    if ((!(x1 instanceof $c_s_Some))) {
      if (($m_s_None$() === x1)) {
        $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(out$1, id, f(), false);
      } else {
        throw new $c_s_MatchError(x1);
      }
    }
  } else {
    var originalHash = $m_sr_Statics$().u(id);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var idx = (hash & ((out$1.au.a.length - 1) | 0));
    var x1$1 = out$1.au.a[idx];
    var nd = ((x1$1 === null) ? null : x1$1.ij(id, hash));
    if ((nd === null)) {
      var table0 = out$1.au;
      var default$1 = f();
      if ((((1 + out$1.e0) | 0) >= out$1.ki)) {
        $p_scm_LinkedHashMap__growTable__I__V(out$1, (out$1.au.a.length << 1));
      }
      $p_scm_LinkedHashMap__put0__O__O__Z__I__I__s_Some(out$1, id, default$1, false, hash, ((table0 === out$1.au) ? idx : (hash & ((out$1.au.a.length - 1) | 0))));
    }
  }
  var f$1 = (() => {
    $m_scm_ArrayBuffer$();
    return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  });
  if ((!($objectGetClass(in$1) === $d_scm_LinkedHashMap.l()))) {
    var x1$2 = in$1.r(id);
    if ((!(x1$2 instanceof $c_s_Some))) {
      if (($m_s_None$() === x1$2)) {
        $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(in$1, id, f$1(), false);
      } else {
        throw new $c_s_MatchError(x1$2);
      }
    }
  } else {
    var originalHash$1 = $m_sr_Statics$().u(id);
    var hash$1 = (originalHash$1 ^ ((originalHash$1 >>> 16) | 0));
    var idx$1 = (hash$1 & ((in$1.au.a.length - 1) | 0));
    var x1$3 = in$1.au.a[idx$1];
    var nd$1 = ((x1$3 === null) ? null : x1$3.ij(id, hash$1));
    if ((nd$1 === null)) {
      var table0$1 = in$1.au;
      var default$2 = f$1();
      if ((((1 + in$1.e0) | 0) >= in$1.ki)) {
        $p_scm_LinkedHashMap__growTable__I__V(in$1, (in$1.au.a.length << 1));
      }
      $p_scm_LinkedHashMap__put0__O__O__Z__I__I__s_Some(in$1, id, default$2, false, hash$1, ((table0$1 === in$1.au) ? idx$1 : (hash$1 & ((in$1.au.a.length - 1) | 0))));
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__connect$1__scm_LinkedHashMap__scm_LinkedHashMap__scm_ArrayBuffer__scm_ArrayBuffer__sr_IntRef__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__V($thiz, out$2, in$2, segs$1, segOwn$1, curOwner$1, t, h) {
  $f_sc_MapOps__apply__O__O(out$2, t).Y(h);
  $f_sc_MapOps__apply__O__O(in$2, h).Y(t);
  segs$1.aw(new $c_T2(t, h));
  segOwn$1.aw(curOwner$1.an);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__canonOf$1__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T__s_Option__T2($thiz, byIdN$1, g$2, nodeId, port) {
  if (port.c()) {
    return new $c_T2(0.0, 0);
  } else {
    var x24 = byIdN$1.r(nodeId);
    if ((x24 instanceof $c_s_Some)) {
      var n = x24.J;
      matchResult10: {
        var \u03b44$___1;
        var \u03b44$___2;
        var x20 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$().a2P(n, g$2, port);
        if ((x20 !== null)) {
          var \u03b44$___1 = (+x20.bH);
          var \u03b44$___2 = (x20.c3 | 0);
          break matchResult10;
        }
        throw new $c_s_MatchError(x20);
      }
      return new $c_T2((+\u03b44$___1), (\u03b44$___2 | 0));
    }
    if (($m_s_None$() === x24)) {
      return new $c_T2(0.0, 0);
    }
    throw new $c_s_MatchError(x24);
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__recordSeg$1__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts__V($thiz, segPortsMap$1, t, h, sp) {
  var x$2 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts$().Fk;
  if ((!((sp === null) ? (x$2 === null) : sp.e(x$2)))) {
    $p_scm_HashMap__put0__O__O__Z__s_Some(segPortsMap$1, new $c_T2(t, h), sp, false);
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__$6$$lzyINIT1$1__sr_LazyRef__Lorg_jpablo_graphexplorer_graphviz_layout_Rank$DEdge__s_Option__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T2($thiz, \u03b46$$lzy1$1, e$1, wtPort$1, byIdN$3, g$4) {
  if (\u03b46$$lzy1$1.ci) {
    var $x_1 = \u03b46$$lzy1$1.cj;
  } else {
    matchResult12$1: {
      var $x_2;
      var x27 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__canonOf$1__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T__s_Option__T2($thiz, byIdN$3, g$4, e$1.oY, wtPort$1);
      if ((x27 !== null)) {
        var $x_2 = new $c_T2((+x27.g()), (x27.h() | 0));
        break matchResult12$1;
      }
      throw new $c_s_MatchError(x27);
    }
    var $x_1 = \u03b46$$lzy1$1.h3($x_2);
  }
  return $x_1;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__$6$$1__sr_LazyRef__Lorg_jpablo_graphexplorer_graphviz_layout_Rank$DEdge__s_Option__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T2($thiz, \u03b46$$lzy1$2, e$2, wtPort$2, byIdN$4, g$5) {
  return (\u03b46$$lzy1$2.ci ? \u03b46$$lzy1$2.cj : $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__$6$$lzyINIT1$1__sr_LazyRef__Lorg_jpablo_graphexplorer_graphviz_layout_Rank$DEdge__s_Option__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T2($thiz, \u03b46$$lzy1$2, e$2, wtPort$2, byIdN$4, g$5));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__wtPX$1__sr_LazyRef__Lorg_jpablo_graphexplorer_graphviz_layout_Rank$DEdge__s_Option__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D($thiz, \u03b46$$lzy1$3, e$7, wtPort$3, byIdN$9, g$10) {
  return (+$p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__$6$$1__sr_LazyRef__Lorg_jpablo_graphexplorer_graphviz_layout_Rank$DEdge__s_Option__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T2($thiz, \u03b46$$lzy1$3, e$7, wtPort$3, byIdN$9, g$10).g());
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__wtOrd$1__sr_LazyRef__Lorg_jpablo_graphexplorer_graphviz_layout_Rank$DEdge__s_Option__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__I($thiz, \u03b46$$lzy1$4, e$8, wtPort$4, byIdN$10, g$11) {
  return ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__$6$$1__sr_LazyRef__Lorg_jpablo_graphexplorer_graphviz_layout_Rank$DEdge__s_Option__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T2($thiz, \u03b46$$lzy1$4, e$8, wtPort$4, byIdN$10, g$11).h() | 0);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__$7$$lzyINIT1$1__sr_LazyRef__Lorg_jpablo_graphexplorer_graphviz_layout_Rank$DEdge__s_Option__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T2($thiz, \u03b47$$lzy1$1, e$3, whPort$1, byIdN$5, g$6) {
  if (\u03b47$$lzy1$1.ci) {
    var $x_1 = \u03b47$$lzy1$1.cj;
  } else {
    matchResult13$1: {
      var $x_2;
      var x30 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__canonOf$1__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T__s_Option__T2($thiz, byIdN$5, g$6, e$3.pY, whPort$1);
      if ((x30 !== null)) {
        var $x_2 = new $c_T2((+x30.g()), (x30.h() | 0));
        break matchResult13$1;
      }
      throw new $c_s_MatchError(x30);
    }
    var $x_1 = \u03b47$$lzy1$1.h3($x_2);
  }
  return $x_1;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__$7$$1__sr_LazyRef__Lorg_jpablo_graphexplorer_graphviz_layout_Rank$DEdge__s_Option__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T2($thiz, \u03b47$$lzy1$2, e$4, whPort$2, byIdN$6, g$7) {
  return (\u03b47$$lzy1$2.ci ? \u03b47$$lzy1$2.cj : $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__$7$$lzyINIT1$1__sr_LazyRef__Lorg_jpablo_graphexplorer_graphviz_layout_Rank$DEdge__s_Option__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T2($thiz, \u03b47$$lzy1$2, e$4, whPort$2, byIdN$6, g$7));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__whPX$1__sr_LazyRef__Lorg_jpablo_graphexplorer_graphviz_layout_Rank$DEdge__s_Option__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D($thiz, \u03b47$$lzy1$3, e$9, whPort$3, byIdN$11, g$12) {
  return (+$p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__$7$$1__sr_LazyRef__Lorg_jpablo_graphexplorer_graphviz_layout_Rank$DEdge__s_Option__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T2($thiz, \u03b47$$lzy1$3, e$9, whPort$3, byIdN$11, g$12).g());
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__whOrd$1__sr_LazyRef__Lorg_jpablo_graphexplorer_graphviz_layout_Rank$DEdge__s_Option__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__I($thiz, \u03b47$$lzy1$4, e$10, whPort$4, byIdN$12, g$13) {
  return ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__$7$$1__sr_LazyRef__Lorg_jpablo_graphexplorer_graphviz_layout_Rank$DEdge__s_Option__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T2($thiz, \u03b47$$lzy1$4, e$10, whPort$4, byIdN$12, g$13).h() | 0);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__emit$1__sci_Vector__sr_IntRef__scm_HashMap__sci_Vector__scm_ArrayBuffer__scm_LinkedHashMap__scm_LinkedHashMap__scm_ArrayBuffer__scm_ArrayBuffer__scm_HashMap__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__I__V($thiz, dedges$1, curOwner$2, rankOf$1, realEdges$1, flatReps$1, out$3, in$3, segs$2, segOwn$2, segPortsMap$2, byIdN$2, g$3, idx) {
  var \u03b46$$lzy1 = new $c_sr_LazyRef();
  var \u03b47$$lzy1 = new $c_sr_LazyRef();
  var e = dedges$1.l(idx);
  curOwner$2.an = idx;
  var tail = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real(e.oY);
  var head = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real(e.pY);
  var rt = (rankOf$1.i(tail) | 0);
  var rh = (rankOf$1.i(head) | 0);
  var re = realEdges$1.l(idx);
  var reversed = (e.oY !== re.ai);
  if (reversed) {
    var \u03b45$___1 = re.k9;
    var \u03b45$___2 = re.ka;
  } else {
    var \u03b45$___1 = re.ka;
    var \u03b45$___2 = re.k9;
  }
  var wtPort = \u03b45$___1;
  var whPort = \u03b45$___2;
  if ((((rh - rt) | 0) <= 1)) {
    if ((rh !== rt)) {
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__connect$1__scm_LinkedHashMap__scm_LinkedHashMap__scm_ArrayBuffer__scm_ArrayBuffer__sr_IntRef__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__V($thiz, out$3, in$3, segs$2, segOwn$2, curOwner$2, tail, head);
      if (((!wtPort.c()) || (!whPort.c()))) {
        $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__recordSeg$1__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts__V($thiz, segPortsMap$2, tail, head, ($m_Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts$(), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts($p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__wtPX$1__sr_LazyRef__Lorg_jpablo_graphexplorer_graphviz_layout_Rank$DEdge__s_Option__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D($thiz, \u03b46$$lzy1, e, wtPort, byIdN$2, g$3), $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__wtOrd$1__sr_LazyRef__Lorg_jpablo_graphexplorer_graphviz_layout_Rank$DEdge__s_Option__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__I($thiz, \u03b46$$lzy1, e, wtPort, byIdN$2, g$3), $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__whPX$1__sr_LazyRef__Lorg_jpablo_graphexplorer_graphviz_layout_Rank$DEdge__s_Option__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D($thiz, \u03b47$$lzy1, e, whPort, byIdN$2, g$3), $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__whOrd$1__sr_LazyRef__Lorg_jpablo_graphexplorer_graphviz_layout_Rank$DEdge__s_Option__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__I($thiz, \u03b47$$lzy1, e, whPort, byIdN$2, g$3))));
      }
    } else {
      flatReps$1.aw(new $c_T3(tail, head, idx));
    }
  } else {
    var prev = tail;
    var r = ((1 + rt) | 0);
    while ((r < rh)) {
      var v = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Virtual(idx, r);
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__node$1__scm_LinkedHashMap__scm_LinkedHashMap__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__V($thiz, out$3, in$3, v);
      $p_scm_HashMap__put0__O__O__Z__s_Some(rankOf$1, v, r, false);
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__connect$1__scm_LinkedHashMap__scm_LinkedHashMap__scm_ArrayBuffer__scm_ArrayBuffer__sr_IntRef__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__V($thiz, out$3, in$3, segs$2, segOwn$2, curOwner$2, prev, v);
      if (((r === ((1 + rt) | 0)) && (!wtPort.c()))) {
        $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__recordSeg$1__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts__V($thiz, segPortsMap$2, tail, v, ($m_Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts$(), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts($p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__wtPX$1__sr_LazyRef__Lorg_jpablo_graphexplorer_graphviz_layout_Rank$DEdge__s_Option__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D($thiz, \u03b46$$lzy1, e, wtPort, byIdN$2, g$3), $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__wtOrd$1__sr_LazyRef__Lorg_jpablo_graphexplorer_graphviz_layout_Rank$DEdge__s_Option__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__I($thiz, \u03b46$$lzy1, e, wtPort, byIdN$2, g$3), 0.0, 0)));
      }
      prev = v;
      r = ((1 + r) | 0);
    }
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__connect$1__scm_LinkedHashMap__scm_LinkedHashMap__scm_ArrayBuffer__scm_ArrayBuffer__sr_IntRef__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__V($thiz, out$3, in$3, segs$2, segOwn$2, curOwner$2, prev, head);
    if ((!whPort.c())) {
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__recordSeg$1__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts__V($thiz, segPortsMap$2, prev, head, ($m_Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts$(), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts(0.0, 0, $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__whPX$1__sr_LazyRef__Lorg_jpablo_graphexplorer_graphviz_layout_Rank$DEdge__s_Option__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D($thiz, \u03b47$$lzy1, e, whPort, byIdN$2, g$3), $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__whOrd$1__sr_LazyRef__Lorg_jpablo_graphexplorer_graphviz_layout_Rank$DEdge__s_Option__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__I($thiz, \u03b47$$lzy1, e, whPort, byIdN$2, g$3))));
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__unlabeled$1__sci_Vector__I__Z($thiz, realEdges$2, i) {
  var this$2 = realEdges$2.l(i).b4.ag.r("label");
  return (this$2.c() || (this$2.d() === ""));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__portsEq$1__sci_Vector__I__I__Z($thiz, realEdges$3, i, j) {
  var x = realEdges$3.l(i).ka;
  var x$2 = realEdges$3.l(j).ka;
  if (((x === null) ? (x$2 === null) : x.e(x$2))) {
    var x$3 = realEdges$3.l(i).k9;
    var x$4 = realEdges$3.l(j).k9;
    return ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
  } else {
    return false;
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__visit$1__scm_Set__scm_ArrayBuffer__scm_HashMap__scm_ArrayBuffer__scm_HashMap__scm_LinkedHashMap__scm_LinkedHashMap__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__V($thiz, done$1, res$1, flatInAdj$2, emptyAdj$1, flatOutAdj$2, in$6, out$6, seed) {
  var elems = $m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode.r().C)([seed]));
  var stk = $ct_scm_Stack__I__(new $c_scm_Stack(), 16).kl(elems);
  while ((!stk.c())) {
    var n = stk.h7(false);
    if ((!done$1.E(n))) {
      done$1.Y(n);
      res$1.aw(n);
      var f = ((emptyAdj$1) => (() => emptyAdj$1))(emptyAdj$1);
      if ((!($objectGetClass(flatInAdj$2) === $d_scm_HashMap.l()))) {
        var x1 = flatInAdj$2.r(n);
        if ((x1 instanceof $c_s_Some)) {
          var $x_1 = x1.J;
        } else {
          if ((!($m_s_None$() === x1))) {
            throw new $c_s_MatchError(x1);
          }
          var $x_1 = f();
        }
      } else {
        var originalHash = $m_sr_Statics$().u(n);
        var hash = (originalHash ^ ((originalHash >>> 16) | 0));
        var x1$1 = flatInAdj$2.S.a[(hash & ((flatInAdj$2.S.a.length - 1) | 0))];
        var nd = ((x1$1 === null) ? null : x1$1.by(n, hash));
        var $x_1 = ((nd === null) ? f() : nd.b9);
      }
      var this$3 = $x_1.cx();
      while (this$3.p()) {
        var x0 = this$3.q();
        if ((!done$1.E(x0))) {
          stk.gm(x0);
        }
      }
      var f$1 = ((emptyAdj$1) => (() => emptyAdj$1))(emptyAdj$1);
      if ((!($objectGetClass(flatOutAdj$2) === $d_scm_HashMap.l()))) {
        var x1$2 = flatOutAdj$2.r(n);
        if ((x1$2 instanceof $c_s_Some)) {
          var $x_2 = x1$2.J;
        } else {
          if ((!($m_s_None$() === x1$2))) {
            throw new $c_s_MatchError(x1$2);
          }
          var $x_2 = f$1();
        }
      } else {
        var originalHash$1 = $m_sr_Statics$().u(n);
        var hash$1 = (originalHash$1 ^ ((originalHash$1 >>> 16) | 0));
        var x1$3 = flatOutAdj$2.S.a[(hash$1 & ((flatOutAdj$2.S.a.length - 1) | 0))];
        var nd$1 = ((x1$3 === null) ? null : x1$3.by(n, hash$1));
        var $x_2 = ((nd$1 === null) ? f$1() : nd$1.b9);
      }
      var this$4 = $x_2.cx();
      while (this$4.p()) {
        var x0$1 = this$4.q();
        if ((!done$1.E(x0$1))) {
          stk.gm(x0$1);
        }
      }
      var this$5 = $f_sc_MapOps__apply__O__O(in$6, n).cx();
      while (this$5.p()) {
        var x0$2 = this$5.q();
        if ((!done$1.E(x0$2))) {
          stk.gm(x0$2);
        }
      }
      var this$6 = $f_sc_MapOps__apply__O__O(out$6, n).cx();
      while (this$6.p()) {
        var x0$3 = this$6.q();
        if ((!done$1.E(x0$3))) {
          stk.gm(x0$3);
        }
      }
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__ordOf$1__scm_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__I($thiz, ranks$1, pos$2, n) {
  return ranks$1.i(pos$2.i(n).g()).mN(n, 0);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__adjacent$1__scm_Map__sci_Map__sci_Set__Lorg_jpablo_graphexplorer_graphviz_model_REdge__Z($thiz, ranks$2, pos$3, labelled$1, e) {
  var t = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real(e.ai);
  var h = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real(e.ak);
  var row = ranks$2.i(pos$3.i(t).g());
  var a = row.mN(t, 0);
  var b = row.mN(h, 0);
  var _1 = ((a < b) ? a : b);
  var _2 = ((a > b) ? a : b);
  var x = ((1 + _1) | 0);
  var isEmpty = (x >= _2);
  var scala$collection$immutable$Range$$lastElement = ((_2 - 1) | 0);
  var res = false;
  var it = new $c_sci_RangeIterator(x, 1, scala$collection$immutable$Range$$lastElement, isEmpty);
  while (((!res) && it.g0)) {
    var x0 = it.hp();
    matchResult20: {
      var x58 = row.l(x0);
      if ((x58 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real)) {
        res = true;
        break matchResult20;
      }
      if ((x58 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Virtual)) {
        res = labelled$1.E(x58.bE());
        break matchResult20;
      }
      if ((x58 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$FlatLabel)) {
        res = true;
        break matchResult20;
      }
      res = false;
    }
  }
  return (!res);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__setbounds$1__sci_Vector__I__AI__I__I__I__I__I__F1__sci_Map__scm_Map__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__I__V($thiz, dedges$6, lpos$1, b$1, SLB$2, HLB$2, rpos$1, SRB$2, HRB$2, outOf$2, pos$5, ranks$4, v, ord) {
  if ((v instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$FlatLabel)) {
    var fe = dedges$6.l(v.yQ);
    var a = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__ordOf$1__scm_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__I($thiz, ranks$4, pos$5, new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real(fe.ai));
    var c = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__ordOf$1__scm_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__I($thiz, ranks$4, pos$5, new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real(fe.ak));
    var _1 = ((a < c) ? a : c);
    var _2 = ((a > c) ? a : c);
    if ((_2 <= lpos$1)) {
      b$1.a[SLB$2] = ord;
      b$1.a[HLB$2] = ord;
    } else if ((_1 >= rpos$1)) {
      b$1.a[SRB$2] = ord;
      b$1.a[HRB$2] = ord;
    } else if ((!((_1 < lpos$1) && (_2 > rpos$1)))) {
      if (((_1 < lpos$1) || ((_1 === lpos$1) && (_2 < rpos$1)))) {
        b$1.a[SLB$2] = ord;
      }
      if (((_2 > rpos$1) || ((_2 === rpos$1) && (_1 > lpos$1)))) {
        b$1.a[SRB$2] = ord;
      }
    }
  } else if ((v instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Virtual)) {
    var onleft = new $c_sr_BooleanRef(false);
    var onright = new $c_sr_BooleanRef(false);
    outOf$2.i(v).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((hd) => {
      var this$10 = pos$5.r(hd);
      var this$11 = (this$10.c() ? $m_s_None$() : new $c_s_Some((this$10.d().h() | 0)));
      var o = ((this$11.c() ? (-1) : this$11.d()) | 0);
      if ((o <= lpos$1)) {
        onleft.dy = true;
      } else if ((o >= rpos$1)) {
        onright.dy = true;
      }
    })));
    if ((onleft.dy && (!onright.dy))) {
      b$1.a[HLB$2] = ((1 + ord) | 0);
    }
    if ((onright.dy && (!onleft.dy))) {
      b$1.a[HRB$2] = ((ord - 1) | 0);
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__flatLimits$1__scm_Map__sci_Vector__I__I__I__I__F1__sci_Map__I__I__I__I($thiz, ranks$3, dedges$5, SLB$1, HLB$1, SRB$1, HRB$1, outOf$1, pos$4, rPrev, lpos, rpos) {
  var row = ranks$3.ay(rPrev, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_scm_Buffer$().f7())));
  var b = new $ac_I(new Int32Array([(-1), row.C(), (-1), row.C()]));
  var lnode = 0;
  var rnode = ((row.C() - 1) | 0);
  while ((lnode <= rnode)) {
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__setbounds$1__sci_Vector__I__AI__I__I__I__I__I__F1__sci_Map__scm_Map__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__I__V($thiz, dedges$5, lpos, b, SLB$1, HLB$1, rpos, SRB$1, HRB$1, outOf$1, pos$4, ranks$3, row.l(lnode), lnode);
    if ((lnode !== rnode)) {
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__setbounds$1__sci_Vector__I__AI__I__I__I__I__I__F1__sci_Map__scm_Map__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__I__V($thiz, dedges$5, lpos, b, SLB$1, HLB$1, rpos, SRB$1, HRB$1, outOf$1, pos$4, ranks$3, row.l(rnode), rnode);
    }
    lnode = ((1 + lnode) | 0);
    rnode = ((rnode - 1) | 0);
    if ((((b.a[HRB$1] - b.a[HLB$1]) | 0) <= 1)) {
      lnode = ((1 + rnode) | 0);
    }
  }
  if ((b.a[HLB$1] <= b.a[HRB$1])) {
    var num = ((1 + ((b.a[HLB$1] + b.a[HRB$1]) | 0)) | 0);
    return (((num + ((num >>> 31) | 0)) | 0) >> 1);
  } else {
    var num$1 = ((1 + ((b.a[SLB$1] + b.a[SRB$1]) | 0)) | 0);
    return (((num$1 + ((num$1 >>> 31) | 0)) | 0) >> 1);
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__visit$2__scm_Set__scm_ArrayBuffer__sc_Map__sc_Map__O__V($thiz, done$8, res$4, in$8, out$9, seed) {
  var elems = $m_sr_ScalaRunTime$().hP(new $ac_O([seed]));
  var stk = $ct_scm_Stack__I__(new $c_scm_Stack(), 16).kl(elems);
  while ((!stk.c())) {
    var n = stk.h7(false);
    if ((!done$8.E(n))) {
      done$8.Y(n);
      res$4.aw(n);
      var this$3 = in$8.i(n).cx();
      while (this$3.p()) {
        var x0 = this$3.q();
        if ((!done$8.E(x0))) {
          stk.gm(x0);
        }
      }
      var this$4 = out$9.i(n).cx();
      while (this$4.p()) {
        var x0$1 = this$4.q();
        if ((!done$8.E(x0$1))) {
          stk.gm(x0$1);
        }
      }
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__cOf$1__sci_Map__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__s_Option($thiz, clustOf$1, vOrigEnds$1, n) {
  if ((n instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real)) {
    var x94 = n.mh;
    return clustOf$1.r(x94);
  }
  if ((n instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Virtual)) {
    var x90 = n.kB;
    matchResult29: {
      var \u03b412$___1;
      var \u03b412$___2;
      var x77 = vOrigEnds$1.l(x90);
      if ((x77 !== null)) {
        var \u03b412$___1 = x77.g();
        var \u03b412$___2 = x77.h();
        break matchResult29;
      }
      throw new $c_s_MatchError(x77);
    }
    var t$2 = \u03b412$___1;
    var h$2 = \u03b412$___2;
    var _1 = clustOf$1.r(t$2);
    var _2 = clustOf$1.r(h$2);
    if ((_1 instanceof $c_s_Some)) {
      var a = (_1.J | 0);
      if ((_2 instanceof $c_s_Some)) {
        if ((a === (_2.J | 0))) {
          return new $c_s_Some(a);
        }
      }
    }
    return $m_s_None$();
  }
  $m_s_sys_package$().b0N((("Order.cOf: " + n) + " is not a mincross node (class2 holds Real/Virtual only)"));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__install$1__scm_HashMap__sc_Map__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__V($thiz, rows$1, rankOf$6, n) {
  var key = rankOf$6.i(n);
  var f = (() => {
    $m_scm_ArrayBuffer$();
    return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  });
  if ((!($objectGetClass(rows$1) === $d_scm_HashMap.l()))) {
    var x1 = rows$1.r(key);
    if ((x1 instanceof $c_s_Some)) {
      var $x_1 = x1.J;
    } else {
      if ((!($m_s_None$() === x1))) {
        throw new $c_s_MatchError(x1);
      }
      var d = f();
      $p_scm_HashMap__put0__O__O__Z__s_Some(rows$1, key, d, false);
      var $x_1 = d;
    }
  } else {
    var originalHash = $m_sr_Statics$().u(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var idx = (hash & ((rows$1.S.a.length - 1) | 0));
    var x1$1 = rows$1.S.a[idx];
    var nd = ((x1$1 === null) ? null : x1$1.by(key, hash));
    if ((nd !== null)) {
      var $x_1 = nd.b9;
    } else {
      var table0 = rows$1.S;
      var default$1 = f();
      if ((((1 + rows$1.eh) | 0) >= rows$1.kI)) {
        $p_scm_HashMap__growTable__I__V(rows$1, (rows$1.S.a.length << 1));
      }
      $p_scm_HashMap__put0__O__O__Z__I__I__s_Some(rows$1, key, default$1, false, hash, ((table0 === rows$1.S) ? idx : (hash & ((rows$1.S.a.length - 1) | 0))));
      var $x_1 = default$1;
    }
  }
  $x_1.Y(n);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__internalInstall$1__sci_Vector__sc_Map__sci_Vector__sc_Map__sci_Map__sci_Vector__I__sci_Map($thiz, allNodes$1, nodeOut$1, cinfos$1, rankOf$5, clustOf$2, vOrigEnds$2, ci) {
  var members = $m_sci_Set$().af(allNodes$1.d8(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n) => $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__cOf$1__sci_Map__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__s_Option($thiz, clustOf$2, vOrigEnds$2, n).E(ci))), false));
  var iOut = new $c_scm_LinkedHashMap();
  var iIn = new $c_scm_LinkedHashMap();
  members.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n$2) => {
    var originalHash = $m_sr_Statics$().u(n$2);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var idx = (hash & ((iOut.au.a.length - 1) | 0));
    var x1 = iOut.au.a[idx];
    var nd = ((x1 === null) ? null : x1.ij(n$2, hash));
    if ((nd === null)) {
      var table0 = iOut.au;
      $m_scm_ArrayBuffer$();
      var default$1 = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
      if ((((1 + iOut.e0) | 0) >= iOut.ki)) {
        $p_scm_LinkedHashMap__growTable__I__V(iOut, (iOut.au.a.length << 1));
      }
      $p_scm_LinkedHashMap__put0__O__O__Z__I__I__s_Some(iOut, n$2, default$1, false, hash, ((table0 === iOut.au) ? idx : (hash & ((iOut.au.a.length - 1) | 0))));
    }
    var originalHash$1 = $m_sr_Statics$().u(n$2);
    var hash$1 = (originalHash$1 ^ ((originalHash$1 >>> 16) | 0));
    var idx$1 = (hash$1 & ((iIn.au.a.length - 1) | 0));
    var x1$1 = iIn.au.a[idx$1];
    var nd$1 = ((x1$1 === null) ? null : x1$1.ij(n$2, hash$1));
    if ((nd$1 !== null)) {
      var $x_1 = nd$1.fs;
    } else {
      var table0$1 = iIn.au;
      $m_scm_ArrayBuffer$();
      var default$2 = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
      if ((((1 + iIn.e0) | 0) >= iIn.ki)) {
        $p_scm_LinkedHashMap__growTable__I__V(iIn, (iIn.au.a.length << 1));
      }
      $p_scm_LinkedHashMap__put0__O__O__Z__I__I__s_Some(iIn, n$2, default$2, false, hash$1, ((table0$1 === iIn.au) ? idx$1 : (hash$1 & ((iIn.au.a.length - 1) | 0))));
      var $x_1 = default$2;
    }
    return $x_1;
  })));
  allNodes$1.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((t) => {
    if (members.E(t)) {
      nodeOut$1.i(t).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((t$2) => ((h) => {
        if (members.E(h)) {
          $f_sc_MapOps__apply__O__O(iOut, t$2).Y(h);
          $f_sc_MapOps__apply__O__O(iIn, h).Y(t$2);
        }
      }))(t)));
    }
  })));
  var this$12 = new $c_sc_Iterator$$anon$6(new $c_sc_Iterator$$anon$9(cinfos$1.l(ci).Bg.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((id) => new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real(id)))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((elem) => members.E(elem))), false);
  var declared = $m_sci_Vector$().X(this$12);
  var this$14 = new $c_sc_Iterator$$anon$7(members.o(), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$$anon$4());
  var virtuals = $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O($m_sci_Vector$().X(this$14), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v) => new $c_T2(v.kB, v.wD))), new $c_s_math_Ordering$Tuple2Ordering($m_s_math_Ordering$Int$(), $m_s_math_Ordering$Int$())).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v$2) => v$2)));
  var nlist = declared.iR(virtuals);
  var rows = $ct_scm_HashMap__(new $c_scm_HashMap());
  var mark = $m_scm_Set$().aO();
  var q = $ct_scm_Queue__I__(new $c_scm_Queue(), 16);
  nlist.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((root) => {
    if (($f_sc_MapOps__apply__O__O(iIn, root).c() && (!mark.E(root)))) {
      mark.Y(root);
      q.km(root);
      while ((!q.c())) {
        var n0 = q.h7(false);
        $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__install$1__scm_HashMap__sc_Map__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__V($thiz, rows, rankOf$5, n0);
        $f_sc_MapOps__apply__O__O(iOut, n0).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((mark, q) => ((w) => {
          if ((!mark.E(w))) {
            mark.Y(w);
            q.km(w);
          }
        }))(mark, q)));
      }
    }
  })));
  nlist.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n$3) => {
    if ((!mark.E(n$3))) {
      mark.Y(n$3);
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__install$1__scm_HashMap__sc_Map__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__V($thiz, rows, rankOf$5, n$3);
    }
  })));
  return $m_sci_Map$().ao(new $c_sc_Iterator$$anon$9(rows.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var r = (x$1.g() | 0);
    var b = x$1.h();
    return new $c_T2(r, $m_sci_Vector$().X(b));
  }))));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__leaderC$1__sc_Map__sci_Map__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode($thiz, rankOf$9, clustOf$4, vOrigEnds$4, n) {
  var x109 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__cOf$1__sci_Map__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__s_Option($thiz, clustOf$4, vOrigEnds$4, n);
  if ((x109 instanceof $c_s_Some)) {
    return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Sk((x109.J | 0), (rankOf$9.i(n) | 0));
  }
  if (($m_s_None$() === x109)) {
    return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Nd(n);
  }
  throw new $c_s_MatchError(x109);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__cInit$1__scm_LinkedHashMap__scm_LinkedHashMap__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__I__V($thiz, cOut$1, cIn$1, cRank$1, x, r) {
  var f = (() => {
    $m_scm_ArrayBuffer$();
    return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  });
  if ((!($objectGetClass(cOut$1) === $d_scm_LinkedHashMap.l()))) {
    var x1 = cOut$1.r(x);
    if ((!(x1 instanceof $c_s_Some))) {
      if (($m_s_None$() === x1)) {
        $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(cOut$1, x, f(), false);
      } else {
        throw new $c_s_MatchError(x1);
      }
    }
  } else {
    var originalHash = $m_sr_Statics$().u(x);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var idx = (hash & ((cOut$1.au.a.length - 1) | 0));
    var x1$1 = cOut$1.au.a[idx];
    var nd = ((x1$1 === null) ? null : x1$1.ij(x, hash));
    if ((nd === null)) {
      var table0 = cOut$1.au;
      var default$1 = f();
      if ((((1 + cOut$1.e0) | 0) >= cOut$1.ki)) {
        $p_scm_LinkedHashMap__growTable__I__V(cOut$1, (cOut$1.au.a.length << 1));
      }
      $p_scm_LinkedHashMap__put0__O__O__Z__I__I__s_Some(cOut$1, x, default$1, false, hash, ((table0 === cOut$1.au) ? idx : (hash & ((cOut$1.au.a.length - 1) | 0))));
    }
  }
  var f$1 = (() => {
    $m_scm_ArrayBuffer$();
    return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  });
  if ((!($objectGetClass(cIn$1) === $d_scm_LinkedHashMap.l()))) {
    var x1$2 = cIn$1.r(x);
    if ((!(x1$2 instanceof $c_s_Some))) {
      if (($m_s_None$() === x1$2)) {
        $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(cIn$1, x, f$1(), false);
      } else {
        throw new $c_s_MatchError(x1$2);
      }
    }
  } else {
    var originalHash$1 = $m_sr_Statics$().u(x);
    var hash$1 = (originalHash$1 ^ ((originalHash$1 >>> 16) | 0));
    var idx$1 = (hash$1 & ((cIn$1.au.a.length - 1) | 0));
    var x1$3 = cIn$1.au.a[idx$1];
    var nd$1 = ((x1$3 === null) ? null : x1$3.ij(x, hash$1));
    if ((nd$1 === null)) {
      var table0$1 = cIn$1.au;
      var default$2 = f$1();
      if ((((1 + cIn$1.e0) | 0) >= cIn$1.ki)) {
        $p_scm_LinkedHashMap__growTable__I__V(cIn$1, (cIn$1.au.a.length << 1));
      }
      $p_scm_LinkedHashMap__put0__O__O__Z__I__I__s_Some(cIn$1, x, default$2, false, hash$1, ((table0$1 === cIn$1.au) ? idx$1 : (hash$1 & ((cIn$1.au.a.length - 1) | 0))));
    }
  }
  $p_scm_HashMap__put0__O__O__Z__s_Some(cRank$1, x, r, false);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__reindex$1__scm_HashMap__scm_HashMap__V($thiz, gpos$1, rows$5) {
  gpos$1.ie();
  var this$1 = rows$5.hr();
  while (this$1.p()) {
    var x0 = this$1.q();
    var this$3 = new $c_sc_Iterator$$anon$16(x0.bB().o());
    while (this$3.p()) {
      var x0$1 = this$3.dC();
      $p_scm_HashMap__put0__O__O__Z__s_Some(gpos$1, x0$1.g(), (x0$1.h() | 0), false);
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__liveNode$1__scm_Set__sc_Map__sci_Map__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode($thiz, expanded$1, rankOf$13, clustOf$7, vOrigEnds$7, n) {
  var x150 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__cOf$1__sci_Map__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__s_Option($thiz, clustOf$7, vOrigEnds$7, n);
  if ((x150 instanceof $c_s_Some)) {
    var ci = (x150.J | 0);
    if ((!expanded$1.E(ci))) {
      return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Sk(ci, (rankOf$13.i(n) | 0));
    }
  }
  return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Nd(n);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__touch$1__scm_LinkedHashMap__scm_LinkedHashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__V($thiz, hOut$2, hIn$2, x) {
  var f = (() => {
    $m_scm_ArrayBuffer$();
    return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  });
  if ((!($objectGetClass(hOut$2) === $d_scm_LinkedHashMap.l()))) {
    var x1 = hOut$2.r(x);
    if ((!(x1 instanceof $c_s_Some))) {
      if (($m_s_None$() === x1)) {
        $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(hOut$2, x, f(), false);
      } else {
        throw new $c_s_MatchError(x1);
      }
    }
  } else {
    var originalHash = $m_sr_Statics$().u(x);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var idx = (hash & ((hOut$2.au.a.length - 1) | 0));
    var x1$1 = hOut$2.au.a[idx];
    var nd = ((x1$1 === null) ? null : x1$1.ij(x, hash));
    if ((nd === null)) {
      var table0 = hOut$2.au;
      var default$1 = f();
      if ((((1 + hOut$2.e0) | 0) >= hOut$2.ki)) {
        $p_scm_LinkedHashMap__growTable__I__V(hOut$2, (hOut$2.au.a.length << 1));
      }
      $p_scm_LinkedHashMap__put0__O__O__Z__I__I__s_Some(hOut$2, x, default$1, false, hash, ((table0 === hOut$2.au) ? idx : (hash & ((hOut$2.au.a.length - 1) | 0))));
    }
  }
  var f$1 = (() => {
    $m_scm_ArrayBuffer$();
    return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  });
  if ((!($objectGetClass(hIn$2) === $d_scm_LinkedHashMap.l()))) {
    var x1$2 = hIn$2.r(x);
    if ((!(x1$2 instanceof $c_s_Some))) {
      if (($m_s_None$() === x1$2)) {
        $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(hIn$2, x, f$1(), false);
      } else {
        throw new $c_s_MatchError(x1$2);
      }
    }
  } else {
    var originalHash$1 = $m_sr_Statics$().u(x);
    var hash$1 = (originalHash$1 ^ ((originalHash$1 >>> 16) | 0));
    var idx$1 = (hash$1 & ((hIn$2.au.a.length - 1) | 0));
    var x1$3 = hIn$2.au.a[idx$1];
    var nd$1 = ((x1$3 === null) ? null : x1$3.ij(x, hash$1));
    if ((nd$1 === null)) {
      var table0$1 = hIn$2.au;
      var default$2 = f$1();
      if ((((1 + hIn$2.e0) | 0) >= hIn$2.ki)) {
        $p_scm_LinkedHashMap__growTable__I__V(hIn$2, (hIn$2.au.a.length << 1));
      }
      $p_scm_LinkedHashMap__put0__O__O__Z__I__I__s_Some(hIn$2, x, default$2, false, hash$1, ((table0$1 === hIn$2.au) ? idx$1 : (hash$1 & ((hIn$2.au.a.length - 1) | 0))));
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__rebuildAdjacency$1__scm_LinkedHashMap__scm_LinkedHashMap__scm_HashMap__scm_HashMap__scm_HashMap__sci_Map__scm_Set__sci_Vector__F2__F2__sc_Map__sci_Map__sci_Vector__V($thiz, hOut$1, hIn$1, hWeight$1, hPorts$1, rows$6, clRanks$2, expanded$2, segsInOrder$1, segWeight$1, segPorts$1, rankOf$14, clustOf$8, vOrigEnds$8) {
  hOut$1.ie();
  hIn$1.ie();
  hWeight$1.ie();
  hPorts$1.ie();
  var this$1 = rows$6.hr();
  while (this$1.p()) {
    var x0 = this$1.q();
    var it = x0.bB().o();
    while (it.p()) {
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__touch$1__scm_LinkedHashMap__scm_LinkedHashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__V($thiz, hOut$1, hIn$1, it.q());
    }
  }
  clRanks$2.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    matchResult44: {
      if ((x$1 !== null)) {
        var x155 = x$1.h();
        var ci = (x$1.g() | 0);
        if ((x155 !== null)) {
          var lo = (x155.g() | 0);
          var hi = (x155.h() | 0);
          if ((!expanded$2.E(ci))) {
            var isEmpty = (lo >= hi);
            var scala$collection$immutable$Range$$lastElement = ((hi - 1) | 0);
            if ((!isEmpty)) {
              var i = lo;
              while (true) {
                var x0$2 = i;
                var a = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Sk(ci, x0$2);
                var b = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Sk(ci, ((1 + x0$2) | 0));
                $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__touch$1__scm_LinkedHashMap__scm_LinkedHashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__V($thiz, hOut$1, hIn$1, a);
                $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__touch$1__scm_LinkedHashMap__scm_LinkedHashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__V($thiz, hOut$1, hIn$1, b);
                $f_sc_MapOps__apply__O__O(hOut$1, a).Y(b);
                $f_sc_MapOps__apply__O__O(hIn$1, b).Y(a);
                $p_scm_HashMap__put0__O__O__Z__s_Some(hWeight$1, new $c_T2(a, b), $bL(1000, 0), false);
                if ((i === scala$collection$immutable$Range$$lastElement)) {
                  break matchResult44;
                }
                i = ((1 + i) | 0);
              }
            } else {
              break matchResult44;
            }
          } else {
            break matchResult44;
          }
        }
      }
      throw new $c_s_MatchError(x$1);
    }
  })));
  segsInOrder$1.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    var t = x$1$2.g();
    var h = x$1$2.h();
    var lt = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__liveNode$1__scm_Set__sc_Map__sci_Map__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode($thiz, expanded$2, rankOf$14, clustOf$8, vOrigEnds$8, t);
    var lh = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__liveNode$1__scm_Set__sc_Map__sci_Map__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode($thiz, expanded$2, rankOf$14, clustOf$8, vOrigEnds$8, h);
    matchResult45: {
      var $x_1;
      if ((lt instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Sk)) {
        var x167 = lt.pU;
        if ((lh instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Sk)) {
          var $x_1 = (x167 === lh.pU);
          break matchResult45;
        }
      }
      var $x_1 = false;
    }
    if (((!$x_1) && (!((lt === null) ? (lh === null) : lt.e(lh))))) {
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__touch$1__scm_LinkedHashMap__scm_LinkedHashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__V($thiz, hOut$1, hIn$1, lt);
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__touch$1__scm_LinkedHashMap__scm_LinkedHashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__V($thiz, hOut$1, hIn$1, lh);
      $f_sc_MapOps__apply__O__O(hOut$1, lt).Y(lh);
      $f_sc_MapOps__apply__O__O(hIn$1, lh).Y(lt);
      if ((!hWeight$1.E(new $c_T2(lt, lh)))) {
        $p_scm_HashMap__put0__O__O__Z__s_Some(hWeight$1, new $c_T2(lt, lh), segWeight$1.R(t, h), false);
        var sp = segPorts$1.R(t, h);
        var x$4 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts$().Fk;
        if ((!((sp === null) ? (x$4 === null) : sp.e(x$4)))) {
          $p_scm_HashMap__put0__O__O__Z__s_Some(hPorts$1, new $c_T2(lt, lh), sp, false);
        }
      }
    }
  })));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__out$51__scm_LinkedHashMap__scm_ArrayBuffer__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__scm_ArrayBuffer($thiz, hOut$6, emptyRow$1, x) {
  var f = (() => emptyRow$1);
  if ((!($objectGetClass(hOut$6) === $d_scm_LinkedHashMap.l()))) {
    var x1 = hOut$6.r(x);
    if ((x1 instanceof $c_s_Some)) {
      var $x_1 = x1.J;
    } else {
      if ((!($m_s_None$() === x1))) {
        throw new $c_s_MatchError(x1);
      }
      var $x_1 = f();
    }
  } else {
    var originalHash = $m_sr_Statics$().u(x);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var x1$1 = hOut$6.au.a[(hash & ((hOut$6.au.a.length - 1) | 0))];
    var nd = ((x1$1 === null) ? null : x1$1.ij(x, hash));
    var $x_1 = ((nd === null) ? f() : nd.fs);
  }
  return $x_1;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__in$47__scm_LinkedHashMap__scm_ArrayBuffer__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__scm_ArrayBuffer($thiz, hIn$6, emptyRow$3, x) {
  var f = (() => emptyRow$3);
  if ((!($objectGetClass(hIn$6) === $d_scm_LinkedHashMap.l()))) {
    var x1 = hIn$6.r(x);
    if ((x1 instanceof $c_s_Some)) {
      var $x_1 = x1.J;
    } else {
      if ((!($m_s_None$() === x1))) {
        throw new $c_s_MatchError(x1);
      }
      var $x_1 = f();
    }
  } else {
    var originalHash = $m_sr_Statics$().u(x);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var x1$1 = hIn$6.au.a[(hash & ((hIn$6.au.a.length - 1) | 0))];
    var nd = ((x1$1 === null) ? null : x1$1.ij(x, hash));
    var $x_1 = ((nd === null) ? f() : nd.fs);
  }
  return $x_1;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__wOf$1__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__J($thiz, hWeight$5, t, h) {
  var key = new $c_T2(t, h);
  var f = (() => $bL(1, 0));
  if ((!($objectGetClass(hWeight$5) === $d_scm_HashMap.l()))) {
    var x1 = hWeight$5.r(key);
    if ((x1 instanceof $c_s_Some)) {
      var $x_1 = x1.J;
    } else {
      if ((!($m_s_None$() === x1))) {
        throw new $c_s_MatchError(x1);
      }
      var $x_1 = f();
    }
  } else {
    var originalHash = $m_sr_Statics$().u(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var x1$1 = hWeight$5.S.a[(hash & ((hWeight$5.S.a.length - 1) | 0))];
    var nd = ((x1$1 === null) ? null : x1$1.by(key, hash));
    var $x_1 = ((nd === null) ? f() : nd.b9);
  }
  return $uJ($x_1);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__pOf$1__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts($thiz, hPorts$3, t, h) {
  var key = new $c_T2(t, h);
  var f = (() => $m_Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts$().Fk);
  if ((!($objectGetClass(hPorts$3) === $d_scm_HashMap.l()))) {
    var x1 = hPorts$3.r(key);
    if ((x1 instanceof $c_s_Some)) {
      var $x_1 = x1.J;
    } else {
      if ((!($m_s_None$() === x1))) {
        throw new $c_s_MatchError(x1);
      }
      var $x_1 = f();
    }
  } else {
    var originalHash = $m_sr_Statics$().u(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var x1$1 = hPorts$3.S.a[(hash & ((hPorts$3.S.a.length - 1) | 0))];
    var nd = ((x1$1 === null) ? null : x1$1.by(key, hash));
    var $x_1 = ((nd === null) ? f() : nd.b9);
  }
  return $x_1;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__portedC$2__F1__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Z($thiz, hasPort$1, x) {
  if ((x instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Nd)) {
    var x172 = x.Bl;
    return (!(!hasPort$1.i(x172)));
  } else {
    return false;
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__clustOfC$1__sci_Map__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__s_Option($thiz, clustOf$29, vOrigEnds$29, x) {
  if ((x instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Nd)) {
    return $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__cOf$1__sci_Map__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__s_Option($thiz, clustOf$29, vOrigEnds$29, x.Bl);
  }
  if ((x instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Sk)) {
    return new $c_s_Some(x.pU);
  }
  throw new $c_s_MatchError(x);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__mvalOf$1__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__D($thiz, mval$1, x) {
  var f = (() => 0.0);
  if ((!($objectGetClass(mval$1) === $d_scm_HashMap.l()))) {
    var x1 = mval$1.r(x);
    if ((x1 instanceof $c_s_Some)) {
      var $x_1 = x1.J;
    } else {
      if ((!($m_s_None$() === x1))) {
        throw new $c_s_MatchError(x1);
      }
      var $x_1 = f();
    }
  } else {
    var originalHash = $m_sr_Statics$().u(x);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var x1$1 = mval$1.S.a[(hash & ((mval$1.S.a.length - 1) | 0))];
    var nd = ((x1$1 === null) ? null : x1$1.by(x, hash));
    var $x_1 = ((nd === null) ? f() : nd.b9);
  }
  return (+$x_1);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__ordOf$2__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__I($thiz, gpos$5, x) {
  var f = (() => 0);
  if ((!($objectGetClass(gpos$5) === $d_scm_HashMap.l()))) {
    var x1 = gpos$5.r(x);
    if ((x1 instanceof $c_s_Some)) {
      var $x_1 = x1.J;
    } else {
      if ((!($m_s_None$() === x1))) {
        throw new $c_s_MatchError(x1);
      }
      var $x_1 = f();
    }
  } else {
    var originalHash = $m_sr_Statics$().u(x);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var x1$1 = gpos$5.S.a[(hash & ((gpos$5.S.a.length - 1) | 0))];
    var nd = ((x1$1 === null) ? null : x1$1.by(x, hash));
    var $x_1 = ((nd === null) ? f() : nd.b9);
  }
  return ($x_1 | 0);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__flatMvalOf$1__scm_HashMap__scm_HashMap__scm_HashMap__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Z($thiz, gpos$4, fInC$2, fOutC$2, mval, n) {
  var f = (() => {
    $m_scm_ArrayBuffer$();
    return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  });
  if ((!($objectGetClass(fInC$2) === $d_scm_HashMap.l()))) {
    var x1 = fInC$2.r(n);
    if ((x1 instanceof $c_s_Some)) {
      var $x_1 = x1.J;
    } else {
      if ((!($m_s_None$() === x1))) {
        throw new $c_s_MatchError(x1);
      }
      var $x_1 = f();
    }
  } else {
    var originalHash = $m_sr_Statics$().u(n);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var x1$1 = fInC$2.S.a[(hash & ((fInC$2.S.a.length - 1) | 0))];
    var nd = ((x1$1 === null) ? null : x1$1.by(n, hash));
    var $x_1 = ((nd === null) ? f() : nd.b9);
  }
  var fin = $x_1;
  if ((!$f_sc_SeqOps__isEmpty__Z(fin))) {
    var elem = fin.l(0);
    var elem$1 = null;
    elem$1 = elem;
    var it = fin.bB().o();
    while (it.p()) {
      var x0 = it.q();
      if (($p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__ordOf$2__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__I($thiz, gpos$4, x0) > $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__ordOf$2__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__I($thiz, gpos$4, elem$1))) {
        elem$1 = x0;
      }
    }
    return ((!($p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__mvalOf$1__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__D($thiz, mval, elem$1) >= 0.0)) || ($p_scm_HashMap__put0__O__O__Z__s_Some(mval, n, ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__mvalOf$1__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__D($thiz, mval, elem$1) + 1.0), false), false));
  } else {
    var f$1 = (() => {
      $m_scm_ArrayBuffer$();
      return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
    });
    if ((!($objectGetClass(fOutC$2) === $d_scm_HashMap.l()))) {
      var x1$2 = fOutC$2.r(n);
      if ((x1$2 instanceof $c_s_Some)) {
        var $x_2 = x1$2.J;
      } else {
        if ((!($m_s_None$() === x1$2))) {
          throw new $c_s_MatchError(x1$2);
        }
        var $x_2 = f$1();
      }
    } else {
      var originalHash$1 = $m_sr_Statics$().u(n);
      var hash$1 = (originalHash$1 ^ ((originalHash$1 >>> 16) | 0));
      var x1$3 = fOutC$2.S.a[(hash$1 & ((fOutC$2.S.a.length - 1) | 0))];
      var nd$1 = ((x1$3 === null) ? null : x1$3.by(n, hash$1));
      var $x_2 = ((nd$1 === null) ? f$1() : nd$1.b9);
    }
    var fout = $x_2;
    if ($f_sc_SeqOps__isEmpty__Z(fout)) {
      return true;
    } else {
      var elem$2 = fout.l(0);
      var elem$3 = null;
      elem$3 = elem$2;
      var it$1 = fout.bB().o();
      while (it$1.p()) {
        var x0$1 = it$1.q();
        if (($p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__ordOf$2__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__I($thiz, gpos$4, x0$1) < $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__ordOf$2__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__I($thiz, gpos$4, elem$3))) {
          elem$3 = x0$1;
        }
      }
      return ((!($p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__mvalOf$1__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__D($thiz, mval, elem$3) > 0.0)) || ($p_scm_HashMap__put0__O__O__Z__s_Some(mval, n, ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__mvalOf$1__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__D($thiz, mval, elem$3) - 1.0), false), false));
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__expandCluster$1__scm_ListBuffer__sci_Map__scm_HashMap__scm_Set__sci_Vector__sc_Map__sci_Vector__sc_Map__sci_Map__sci_Vector__scm_LinkedHashMap__scm_LinkedHashMap__scm_HashMap__scm_HashMap__sci_Vector__F2__F2__scm_HashMap__I__V($thiz, mergedNlist$1, clRanks$3, rows$7, expanded$5, allNodes$2, nodeOut$3, cinfos$2, rankOf$16, clustOf$10, vOrigEnds$10, hOut$7, hIn$7, hWeight$6, hPorts$4, segsInOrder$2, segWeight$3, segPorts$3, gpos$8, ci) {
  var interior = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__internalInstall$1__sci_Vector__sc_Map__sci_Vector__sc_Map__sci_Map__sci_Vector__I__sci_Map($thiz, allNodes$2, nodeOut$3, cinfos$2, rankOf$16, clustOf$10, vOrigEnds$10, ci);
  var x = (clRanks$3.i(ci).g() | 0);
  var end = (clRanks$3.i(ci).h() | 0);
  var isEmpty = (x > end);
  var b = $m_sci_IndexedSeq$().b5();
  var it = new $c_sci_RangeIterator(x, 1, end, isEmpty);
  while (it.g0) {
    var x0 = it.hp();
    b.dG(interior.ay(x0, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      $m_sci_Vector$();
      return $m_sci_Vector0$();
    }))));
  }
  $f_scm_Buffer__prependAll__sc_IterableOnce__scm_Buffer(mergedNlist$1, b.aR().hU());
  matchResult48: {
    var \u03b415$___1;
    var \u03b415$___2;
    var x181 = clRanks$3.i(ci);
    if ((x181 !== null)) {
      var \u03b415$___1 = (x181.g() | 0);
      var \u03b415$___2 = (x181.h() | 0);
      break matchResult48;
    }
    throw new $c_s_MatchError(x181);
  }
  var lo$2 = (\u03b415$___1 | 0);
  var hi$2 = (\u03b415$___2 | 0);
  if ((!(lo$2 > hi$2))) {
    var i = lo$2;
    while (true) {
      var x0$1 = i;
      var f = (() => {
        $m_scm_ArrayBuffer$();
        return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
      });
      if ((!($objectGetClass(rows$7) === $d_scm_HashMap.l()))) {
        var x1 = rows$7.r(x0$1);
        if ((x1 instanceof $c_s_Some)) {
          var $x_1 = x1.J;
        } else {
          if ((!($m_s_None$() === x1))) {
            throw new $c_s_MatchError(x1);
          }
          var d = f();
          $p_scm_HashMap__put0__O__O__Z__s_Some(rows$7, x0$1, d, false);
          var $x_1 = d;
        }
      } else {
        var originalHash = $m_sr_Statics$().u(x0$1);
        var hash = (originalHash ^ ((originalHash >>> 16) | 0));
        var idx = (hash & ((rows$7.S.a.length - 1) | 0));
        var x1$1 = rows$7.S.a[idx];
        var nd = ((x1$1 === null) ? null : x1$1.by(x0$1, hash));
        if ((nd !== null)) {
          var $x_1 = nd.b9;
        } else {
          var table0 = rows$7.S;
          var default$1 = f();
          if ((((1 + rows$7.eh) | 0) >= rows$7.kI)) {
            $p_scm_HashMap__growTable__I__V(rows$7, (rows$7.S.a.length << 1));
          }
          $p_scm_HashMap__put0__O__O__Z__I__I__s_Some(rows$7, x0$1, default$1, false, hash, ((table0 === rows$7.S) ? idx : (hash & ((rows$7.S.a.length - 1) | 0))));
          var $x_1 = default$1;
        }
      }
      var rb = $x_1;
      var repl = interior.ay(x0$1, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
        $m_sci_Vector$();
        return $m_sci_Vector0$();
      }))).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n) => new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Nd(n))));
      var idx$1 = $f_sc_SeqOps__indexOf__O__I__I(rb, new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Sk(ci, x0$1), 0);
      if ((idx$1 >= 0)) {
        rb.wd(idx$1);
        rb.Px(idx$1, repl);
      } else {
        rb.gS(repl);
      }
      if ((i === hi$2)) {
        break;
      }
      i = ((1 + i) | 0);
    }
  }
  expanded$5.Y(ci);
  $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__rebuildAdjacency$1__scm_LinkedHashMap__scm_LinkedHashMap__scm_HashMap__scm_HashMap__scm_HashMap__sci_Map__scm_Set__sci_Vector__F2__F2__sc_Map__sci_Map__sci_Vector__V($thiz, hOut$7, hIn$7, hWeight$6, hPorts$4, rows$7, clRanks$3, expanded$5, segsInOrder$2, segWeight$3, segPorts$3, rankOf$16, clustOf$10, vOrigEnds$10);
  $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__reindex$1__scm_HashMap__scm_HashMap__V($thiz, gpos$8, rows$7);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__localOutG$1__scm_HashMap__scm_LinkedHashMap__scm_ArrayBuffer__scm_HashMap__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__J($thiz, gpos$9, hOut$8, emptyRow$5, hPorts$5, hWeight$7, v) {
  var os = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__out$51__scm_LinkedHashMap__scm_ArrayBuffer__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__scm_ArrayBuffer($thiz, hOut$8, emptyRow$5, v);
  var c_$_lo = 0;
  var c_$_hi = 0;
  var i = 0;
  while ((i < os.a1)) {
    var j = ((1 + i) | 0);
    while ((j < os.a1)) {
      var e = os.l(i);
      var f = os.l(j);
      var this$2 = new $c_sr_RichInt((((gpos$9.i(f) | 0) - (gpos$9.i(e) | 0)) | 0));
      var x$1 = this$2.ns;
      var this$8 = new $c_sr_RichDouble(($p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__pOf$1__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts($thiz, hPorts$5, v, f).o0 - $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__pOf$1__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts($thiz, hPorts$5, v, e).o0));
      var x$3 = this$8.kk;
      if (((((x$1 >> 31) | ((((-x$1) | 0) >>> 31) | 0)) * ((x$3 > 0.0) ? 1.0 : ((x$3 < 0.0) ? (-1.0) : x$3))) < 0.0)) {
        var x$6_$_lo = c_$_lo;
        var x$6_$_hi = c_$_hi;
        var $x_1 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__wOf$1__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__J($thiz, hWeight$7, v, e);
        var x$4_$_lo = $x_1.l;
        var x$4_$_hi = $x_1.h;
        var $x_2 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__wOf$1__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__J($thiz, hWeight$7, v, f);
        var x$5_$_lo = $x_2.l;
        var x$5_$_hi = $x_2.h;
        var a0 = (65535 & x$4_$_lo);
        var a1 = ((x$4_$_lo >>> 16) | 0);
        var b0 = (65535 & x$5_$_lo);
        var b1 = ((x$5_$_lo >>> 16) | 0);
        var a0b0 = Math.imul(a0, b0);
        var a1b0 = Math.imul(a1, b0);
        var a0b1 = Math.imul(a0, b1);
        var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi = ((((((((Math.imul(x$4_$_lo, x$5_$_hi) + Math.imul(x$4_$_hi, x$5_$_lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
        var lo$1 = ((x$6_$_lo + lo) | 0);
        var hi$1 = ((((x$6_$_hi + hi) | 0) + (((lo$1 >>> 0) < (x$6_$_lo >>> 0)) | 0)) | 0);
        c_$_lo = lo$1;
        c_$_hi = hi$1;
      }
      j = ((1 + j) | 0);
    }
    i = ((1 + i) | 0);
  }
  return $bL(c_$_lo, c_$_hi);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__localInG$1__scm_HashMap__scm_LinkedHashMap__scm_ArrayBuffer__scm_HashMap__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__J($thiz, gpos$10, hIn$8, emptyRow$6, hPorts$6, hWeight$8, v) {
  var is0 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__in$47__scm_LinkedHashMap__scm_ArrayBuffer__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__scm_ArrayBuffer($thiz, hIn$8, emptyRow$6, v);
  var c_$_lo = 0;
  var c_$_hi = 0;
  var i = 0;
  while ((i < is0.a1)) {
    var j = ((1 + i) | 0);
    while ((j < is0.a1)) {
      var e = is0.l(i);
      var f = is0.l(j);
      var this$2 = new $c_sr_RichInt((((gpos$10.i(f) | 0) - (gpos$10.i(e) | 0)) | 0));
      var x$1 = this$2.ns;
      var this$8 = new $c_sr_RichDouble(($p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__pOf$1__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts($thiz, hPorts$6, f, v).nZ - $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__pOf$1__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts($thiz, hPorts$6, e, v).nZ));
      var x$3 = this$8.kk;
      if (((((x$1 >> 31) | ((((-x$1) | 0) >>> 31) | 0)) * ((x$3 > 0.0) ? 1.0 : ((x$3 < 0.0) ? (-1.0) : x$3))) < 0.0)) {
        var x$6_$_lo = c_$_lo;
        var x$6_$_hi = c_$_hi;
        var $x_1 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__wOf$1__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__J($thiz, hWeight$8, e, v);
        var x$4_$_lo = $x_1.l;
        var x$4_$_hi = $x_1.h;
        var $x_2 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__wOf$1__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__J($thiz, hWeight$8, f, v);
        var x$5_$_lo = $x_2.l;
        var x$5_$_hi = $x_2.h;
        var a0 = (65535 & x$4_$_lo);
        var a1 = ((x$4_$_lo >>> 16) | 0);
        var b0 = (65535 & x$5_$_lo);
        var b1 = ((x$5_$_lo >>> 16) | 0);
        var a0b0 = Math.imul(a0, b0);
        var a1b0 = Math.imul(a1, b0);
        var a0b1 = Math.imul(a0, b1);
        var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi = ((((((((Math.imul(x$4_$_lo, x$5_$_hi) + Math.imul(x$4_$_hi, x$5_$_lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
        var lo$1 = ((x$6_$_lo + lo) | 0);
        var hi$1 = ((((x$6_$_hi + hi) | 0) + (((lo$1 >>> 0) < (x$6_$_lo >>> 0)) | 0)) | 0);
        c_$_lo = lo$1;
        c_$_hi = hi$1;
      }
      j = ((1 + j) | 0);
    }
    i = ((1 + i) | 0);
  }
  return $bL(c_$_lo, c_$_hi);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__ncrossGlobal$1__I__I__scm_HashMap__scm_HashMap__scm_LinkedHashMap__scm_ArrayBuffer__scm_HashMap__F1__scm_HashMap__scm_LinkedHashMap__J($thiz, gMinR$1, gMaxR$1, rows$9, gpos$11, hOut$9, emptyRow$7, hWeight$9, hasPort$2, hPorts$7, hIn$9) {
  var c = new $c_sr_LongRef(0, 0);
  var r = gMinR$1;
  while ((r < gMaxR$1)) {
    $m_scm_ArrayBuffer$();
    var segs = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
    var key = r;
    var f = (() => {
      $m_scm_ArrayBuffer$();
      return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
    });
    if ((!($objectGetClass(rows$9) === $d_scm_HashMap.l()))) {
      var x1 = rows$9.r(key);
      if ((x1 instanceof $c_s_Some)) {
        var $x_1 = x1.J;
      } else {
        if ((!($m_s_None$() === x1))) {
          throw new $c_s_MatchError(x1);
        }
        var $x_1 = f();
      }
    } else {
      var originalHash = $m_sr_Statics$().u(key);
      var hash = (originalHash ^ ((originalHash >>> 16) | 0));
      var x1$1 = rows$9.S.a[(hash & ((rows$9.S.a.length - 1) | 0))];
      var nd = ((x1$1 === null) ? null : x1$1.by(key, hash));
      var $x_1 = ((nd === null) ? f() : nd.b9);
    }
    $x_1.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((segs, gpos$11, hOut$9, emptyRow$7, hWeight$9) => ((u) => {
      var this$5 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__out$51__scm_LinkedHashMap__scm_ArrayBuffer__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__scm_ArrayBuffer($thiz, hOut$9, emptyRow$7, u);
      var it = this$5.bB().o();
      while (it.p()) {
        var x0 = it.q();
        var $x_4 = gpos$11.i(u);
        var $x_3 = gpos$11.i(x0);
        var $x_2 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__wOf$1__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__J($thiz, hWeight$9, u, x0);
        segs.aw(new $c_T3($x_4, $x_3, $x_2));
      }
    }))(segs, gpos$11, hOut$9, emptyRow$7, hWeight$9)));
    var i = 0;
    while ((i < segs.a1)) {
      var j = ((1 + i) | 0);
      while ((j < segs.a1)) {
        matchResult49: {
          var \u03b416$___1;
          var \u03b416$___2;
          var \u03b416$___3;
          var x184 = segs.l(i);
          if ((x184 !== null)) {
            var $x_7 = x184.bH;
            var $x_6 = x184.bU;
            var $x_5 = $uJ(x184.c3);
            var \u03b416$___1 = ($x_7 | 0);
            var \u03b416$___2 = ($x_6 | 0);
            var \u03b416$___3 = $x_5;
            break matchResult49;
          }
          throw new $c_s_MatchError(x184);
        }
        var ui$2 = (\u03b416$___1 | 0);
        var wi$2 = (\u03b416$___2 | 0);
        var $x_8 = $uJ(\u03b416$___3);
        var xi$2_$_lo = $x_8.l;
        var xi$2_$_hi = $x_8.h;
        matchResult50: {
          var \u03b417$___1;
          var \u03b417$___2;
          var \u03b417$___3;
          var x188 = segs.l(j);
          if ((x188 !== null)) {
            var $x_11 = x188.bH;
            var $x_10 = x188.bU;
            var $x_9 = $uJ(x188.c3);
            var \u03b417$___1 = ($x_11 | 0);
            var \u03b417$___2 = ($x_10 | 0);
            var \u03b417$___3 = $x_9;
            break matchResult50;
          }
          throw new $c_s_MatchError(x188);
        }
        var uj$2 = (\u03b417$___1 | 0);
        var wj$2 = (\u03b417$___2 | 0);
        var $x_12 = $uJ(\u03b417$___3);
        var xj$2_$_lo = $x_12.l;
        var xj$2_$_hi = $x_12.h;
        if ((Math.imul(((ui$2 - uj$2) | 0), ((wi$2 - wj$2) | 0)) < 0)) {
          var x$2_$_lo = c.ji;
          var x$2_$_hi = c.jj;
          var a0 = (65535 & xi$2_$_lo);
          var a1 = ((xi$2_$_lo >>> 16) | 0);
          var b0 = (65535 & xj$2_$_lo);
          var b1 = ((xj$2_$_lo >>> 16) | 0);
          var a0b0 = Math.imul(a0, b0);
          var a1b0 = Math.imul(a1, b0);
          var a0b1 = Math.imul(a0, b1);
          var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
          var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
          var hi = ((((((((Math.imul(xi$2_$_lo, xj$2_$_hi) + Math.imul(xi$2_$_hi, xj$2_$_lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
          var lo$1 = ((x$2_$_lo + lo) | 0);
          var hi$1 = ((((x$2_$_hi + hi) | 0) + (((lo$1 >>> 0) < (x$2_$_lo >>> 0)) | 0)) | 0);
          c.ji = lo$1;
          c.jj = hi$1;
        }
        j = ((1 + j) | 0);
      }
      i = ((1 + i) | 0);
    }
    var key$1 = r;
    var f$1 = (() => {
      $m_scm_ArrayBuffer$();
      return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
    });
    if ((!($objectGetClass(rows$9) === $d_scm_HashMap.l()))) {
      var x1$2 = rows$9.r(key$1);
      if ((x1$2 instanceof $c_s_Some)) {
        var $x_13 = x1$2.J;
      } else {
        if ((!($m_s_None$() === x1$2))) {
          throw new $c_s_MatchError(x1$2);
        }
        var $x_13 = f$1();
      }
    } else {
      var originalHash$1 = $m_sr_Statics$().u(key$1);
      var hash$1 = (originalHash$1 ^ ((originalHash$1 >>> 16) | 0));
      var x1$3 = rows$9.S.a[(hash$1 & ((rows$9.S.a.length - 1) | 0))];
      var nd$1 = ((x1$3 === null) ? null : x1$3.by(key$1, hash$1));
      var $x_13 = ((nd$1 === null) ? f$1() : nd$1.b9);
    }
    $x_13.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((c, hasPort$2, gpos$11, hOut$9, emptyRow$7, hPorts$7, hWeight$9) => ((v$2) => {
      if ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__portedC$2__F1__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Z($thiz, hasPort$2, v$2)) {
        var x$5_$_lo = c.ji;
        var x$5_$_hi = c.jj;
        var $x_14 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__localOutG$1__scm_HashMap__scm_LinkedHashMap__scm_ArrayBuffer__scm_HashMap__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__J($thiz, gpos$11, hOut$9, emptyRow$7, hPorts$7, hWeight$9, v$2);
        var x$6_$_lo = $x_14.l;
        var x$6_$_hi = $x_14.h;
        var lo$2 = ((x$5_$_lo + x$6_$_lo) | 0);
        var hi$2 = ((((x$5_$_hi + x$6_$_hi) | 0) + (((lo$2 >>> 0) < (x$5_$_lo >>> 0)) | 0)) | 0);
        c.ji = lo$2;
        c.jj = hi$2;
      }
    }))(c, hasPort$2, gpos$11, hOut$9, emptyRow$7, hPorts$7, hWeight$9)));
    var key$2 = ((1 + r) | 0);
    var f$2 = (() => {
      $m_scm_ArrayBuffer$();
      return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
    });
    if ((!($objectGetClass(rows$9) === $d_scm_HashMap.l()))) {
      var x1$4 = rows$9.r(key$2);
      if ((x1$4 instanceof $c_s_Some)) {
        var $x_15 = x1$4.J;
      } else {
        if ((!($m_s_None$() === x1$4))) {
          throw new $c_s_MatchError(x1$4);
        }
        var $x_15 = f$2();
      }
    } else {
      var originalHash$2 = $m_sr_Statics$().u(key$2);
      var hash$2 = (originalHash$2 ^ ((originalHash$2 >>> 16) | 0));
      var x1$5 = rows$9.S.a[(hash$2 & ((rows$9.S.a.length - 1) | 0))];
      var nd$2 = ((x1$5 === null) ? null : x1$5.by(key$2, hash$2));
      var $x_15 = ((nd$2 === null) ? f$2() : nd$2.b9);
    }
    $x_15.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((c, hasPort$2, gpos$11, hIn$9, emptyRow$7, hPorts$7, hWeight$9) => ((v$2$1) => {
      if ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__portedC$2__F1__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Z($thiz, hasPort$2, v$2$1)) {
        var x$9_$_lo = c.ji;
        var x$9_$_hi = c.jj;
        var $x_16 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__localInG$1__scm_HashMap__scm_LinkedHashMap__scm_ArrayBuffer__scm_HashMap__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__J($thiz, gpos$11, hIn$9, emptyRow$7, hPorts$7, hWeight$9, v$2$1);
        var x$10_$_lo = $x_16.l;
        var x$10_$_hi = $x_16.h;
        var lo$3 = ((x$9_$_lo + x$10_$_lo) | 0);
        var hi$3 = ((((x$9_$_hi + x$10_$_hi) | 0) + (((lo$3 >>> 0) < (x$9_$_lo >>> 0)) | 0)) | 0);
        c.ji = lo$3;
        c.jj = hi$3;
      }
    }))(c, hasPort$2, gpos$11, hIn$9, emptyRow$7, hPorts$7, hWeight$9)));
    r = ((1 + r) | 0);
  }
  return $bL(c.ji, c.jj);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__slice$1__scm_HashMap__I__sci_Map__sci_Vector__I__T2($thiz, rows$11, ci$7, clustOf$12, vOrigEnds$12, r) {
  var rb = rows$11.i(r);
  var from = 0;
  while (((from < rb.a1) && (!$p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__clustOfC$1__sci_Map__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__s_Option($thiz, clustOf$12, vOrigEnds$12, rb.l(from)).E(ci$7)))) {
    from = ((1 + from) | 0);
  }
  var until = from;
  while (((until < rb.a1) && $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__clustOfC$1__sci_Map__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__s_Option($thiz, clustOf$12, vOrigEnds$12, rb.l(until)).E(ci$7))) {
    until = ((1 + until) | 0);
  }
  return new $c_T2(from, until);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__exchange$1__scm_HashMap__scm_HashMap__I__I__I__V($thiz, rows$12, gpos$17, r, i, j) {
  var rb = rows$12.i(r);
  var a = rb.l(i);
  var b = rb.l(j);
  rb.cM(i, b);
  rb.cM(j, a);
  $p_scm_HashMap__put0__O__O__Z__s_Some(gpos$17, a, j, false);
  $p_scm_HashMap__put0__O__O__Z__s_Some(gpos$17, b, i, false);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__medians$1__scm_HashMap__scm_HashMap__scm_HashMap__I__sci_Map__sci_Vector__scm_LinkedHashMap__scm_ArrayBuffer__scm_LinkedHashMap__scm_HashMap__scm_HashMap__scm_HashMap__I__I__Z($thiz, rows$13, gpos$18, mval$2, ci$8, clustOf$13, vOrigEnds$13, hOut$13, emptyRow$12, hIn$12, fInC$4, fOutC$4, hPorts$11, r0, r1) {
  matchResult52: {
    var \u03b419$___1;
    var \u03b419$___2;
    var x195 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__slice$1__scm_HashMap__I__sci_Map__sci_Vector__I__T2($thiz, rows$13, ci$8, clustOf$13, vOrigEnds$13, r0);
    if ((x195 !== null)) {
      var \u03b419$___1 = (x195.g() | 0);
      var \u03b419$___2 = (x195.h() | 0);
      break matchResult52;
    }
    throw new $c_s_MatchError(x195);
  }
  var from$2 = (\u03b419$___1 | 0);
  var until$2 = (\u03b419$___2 | 0);
  var rb = rows$13.i(r0);
  var k = from$2;
  while ((k < until$2)) {
    var n = rb.l(k);
    if ((r1 > r0)) {
      var this$2 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__out$51__scm_LinkedHashMap__scm_ArrayBuffer__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__scm_ArrayBuffer($thiz, hOut$13, emptyRow$12, n);
      $m_scm_ArrayBuffer$();
      var b = new $c_scm_ArrayBuffer$$anon$1();
      var it = this$2.bB().o();
      while (it.p()) {
        var x0 = it.q();
        b.mI(((((gpos$18.i(x0) | 0) << 8) + $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__pOf$1__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts($thiz, hPorts$11, n, x0).Bo) | 0));
      }
      var $x_1 = b.gj;
    } else {
      var this$4 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__in$47__scm_LinkedHashMap__scm_ArrayBuffer__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__scm_ArrayBuffer($thiz, hIn$12, emptyRow$12, n);
      $m_scm_ArrayBuffer$();
      var b$1 = new $c_scm_ArrayBuffer$$anon$1();
      var it$1 = this$4.bB().o();
      while (it$1.p()) {
        var x0$1 = it$1.q();
        b$1.mI(((((gpos$18.i(x0$1) | 0) << 8) + $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__pOf$1__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts($thiz, hPorts$11, x0$1, n).Bp) | 0));
      }
      var $x_1 = b$1.gj;
    }
    var nbrs = $f_sc_SeqOps__sorted__s_math_Ordering__O($x_1, $m_s_math_Ordering$Int$());
    var $x_2;
    var x198 = nbrs.a1;
    switch (x198) {
      case 0: {
        var $x_2 = (-1.0);
        break;
      }
      case 1: {
        var $x_2 = (nbrs.l(0) | 0);
        break;
      }
      case 2: {
        var num = (((nbrs.l(0) | 0) + (nbrs.l(1) | 0)) | 0);
        var $x_2 = (((num + ((num >>> 31) | 0)) | 0) >> 1);
        break;
      }
      default: {
        var rm = (((x198 + ((x198 >>> 31) | 0)) | 0) >> 1);
        var t = ((x198 >>> 31) | 0);
        if (((((1 & ((x198 + t) | 0)) - t) | 0) === 1)) {
          var $x_2 = (nbrs.l(rm) | 0);
        } else {
          var lm = ((rm - 1) | 0);
          var rspan = (((nbrs.l(((x198 - 1) | 0)) | 0) - (nbrs.l(rm) | 0)) | 0);
          var lspan = (((nbrs.l(lm) | 0) - (nbrs.l(0) | 0)) | 0);
          if ((lspan === rspan)) {
            var num$1 = (((nbrs.l(lm) | 0) + (nbrs.l(rm) | 0)) | 0);
            var $x_2 = (((num$1 + ((num$1 >>> 31) | 0)) | 0) >> 1);
          } else {
            var $x_2 = ((((nbrs.l(lm) | 0) * rspan) + ((nbrs.l(rm) | 0) * lspan)) / ((lspan + rspan) | 0));
          }
        }
      }
    }
    $p_scm_HashMap__put0__O__O__Z__s_Some(mval$2, n, $x_2, false);
    k = ((1 + k) | 0);
  }
  var hasfixed = false;
  k = from$2;
  while ((k < until$2)) {
    var n$4 = rb.l(k);
    if (($f_sc_SeqOps__isEmpty__Z($p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__out$51__scm_LinkedHashMap__scm_ArrayBuffer__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__scm_ArrayBuffer($thiz, hOut$13, emptyRow$12, n$4)) && $f_sc_SeqOps__isEmpty__Z($p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__in$47__scm_LinkedHashMap__scm_ArrayBuffer__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__scm_ArrayBuffer($thiz, hIn$12, emptyRow$12, n$4)))) {
      hasfixed = ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__flatMvalOf$1__scm_HashMap__scm_HashMap__scm_HashMap__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Z($thiz, gpos$18, fInC$4, fOutC$4, mval$2, n$4) || hasfixed);
    }
    k = ((1 + k) | 0);
  }
  return hasfixed;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__reorder$1__scm_HashMap__scm_HashMap__I__sci_Map__sci_Vector__scm_HashMap__I__Z__Z__V($thiz, rows$14, mval$3, ci$9, clustOf$14, vOrigEnds$14, gpos$21, r, reverse, hasfixed) {
  matchResult54: {
    var \u03b420$___1;
    var \u03b420$___2;
    var x199 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__slice$1__scm_HashMap__I__sci_Map__sci_Vector__I__T2($thiz, rows$14, ci$9, clustOf$14, vOrigEnds$14, r);
    if ((x199 !== null)) {
      var \u03b420$___1 = (x199.g() | 0);
      var \u03b420$___2 = (x199.h() | 0);
      break matchResult54;
    }
    throw new $c_s_MatchError(x199);
  }
  var from$2 = (\u03b420$___1 | 0);
  var until$2 = (\u03b420$___2 | 0);
  var rb = rows$14.i(r);
  var ep = until$2;
  var nelt = ((((until$2 - from$2) | 0) - 1) | 0);
  while ((nelt >= 0)) {
    var lp = from$2;
    while ((lp < ep)) {
      while (true) {
        if ((lp < ep)) {
          var key = rb.l(lp);
          var f = (() => (-1.0));
          if ((!($objectGetClass(mval$3) === $d_scm_HashMap.l()))) {
            var x1 = mval$3.r(key);
            if ((x1 instanceof $c_s_Some)) {
              var $x_2 = x1.J;
            } else {
              if ((!($m_s_None$() === x1))) {
                throw new $c_s_MatchError(x1);
              }
              var $x_2 = f();
            }
          } else {
            var originalHash = $m_sr_Statics$().u(key);
            var hash = (originalHash ^ ((originalHash >>> 16) | 0));
            var x1$1 = mval$3.S.a[(hash & ((mval$3.S.a.length - 1) | 0))];
            var nd = ((x1$1 === null) ? null : x1$1.by(key, hash));
            var $x_2 = ((nd === null) ? f() : nd.b9);
          }
          var $x_1 = ((+$x_2) < 0.0);
        } else {
          var $x_1 = false;
        }
        if ($x_1) {
          lp = ((1 + lp) | 0);
        } else {
          break;
        }
      }
      if ((lp < ep)) {
        var rp = ((1 + lp) | 0);
        while (true) {
          if ((rp < ep)) {
            var key$1 = rb.l(rp);
            var f$1 = (() => (-1.0));
            if ((!($objectGetClass(mval$3) === $d_scm_HashMap.l()))) {
              var x1$2 = mval$3.r(key$1);
              if ((x1$2 instanceof $c_s_Some)) {
                var $x_4 = x1$2.J;
              } else {
                if ((!($m_s_None$() === x1$2))) {
                  throw new $c_s_MatchError(x1$2);
                }
                var $x_4 = f$1();
              }
            } else {
              var originalHash$1 = $m_sr_Statics$().u(key$1);
              var hash$1 = (originalHash$1 ^ ((originalHash$1 >>> 16) | 0));
              var x1$3 = mval$3.S.a[(hash$1 & ((mval$3.S.a.length - 1) | 0))];
              var nd$1 = ((x1$3 === null) ? null : x1$3.by(key$1, hash$1));
              var $x_4 = ((nd$1 === null) ? f$1() : nd$1.b9);
            }
            var $x_3 = ((+$x_4) < 0.0);
          } else {
            var $x_3 = false;
          }
          if ($x_3) {
            rp = ((1 + rp) | 0);
          } else {
            break;
          }
        }
        if ((rp < ep)) {
          var key$2 = rb.l(lp);
          var f$2 = (() => (-1.0));
          if ((!($objectGetClass(mval$3) === $d_scm_HashMap.l()))) {
            var x1$4 = mval$3.r(key$2);
            if ((x1$4 instanceof $c_s_Some)) {
              var $x_5 = x1$4.J;
            } else {
              if ((!($m_s_None$() === x1$4))) {
                throw new $c_s_MatchError(x1$4);
              }
              var $x_5 = f$2();
            }
          } else {
            var originalHash$2 = $m_sr_Statics$().u(key$2);
            var hash$2 = (originalHash$2 ^ ((originalHash$2 >>> 16) | 0));
            var x1$5 = mval$3.S.a[(hash$2 & ((mval$3.S.a.length - 1) | 0))];
            var nd$2 = ((x1$5 === null) ? null : x1$5.by(key$2, hash$2));
            var $x_5 = ((nd$2 === null) ? f$2() : nd$2.b9);
          }
          var p1 = (+$x_5);
          var key$3 = rb.l(rp);
          var f$3 = (() => (-1.0));
          if ((!($objectGetClass(mval$3) === $d_scm_HashMap.l()))) {
            var x1$6 = mval$3.r(key$3);
            if ((x1$6 instanceof $c_s_Some)) {
              var $x_6 = x1$6.J;
            } else {
              if ((!($m_s_None$() === x1$6))) {
                throw new $c_s_MatchError(x1$6);
              }
              var $x_6 = f$3();
            }
          } else {
            var originalHash$3 = $m_sr_Statics$().u(key$3);
            var hash$3 = (originalHash$3 ^ ((originalHash$3 >>> 16) | 0));
            var x1$7 = mval$3.S.a[(hash$3 & ((mval$3.S.a.length - 1) | 0))];
            var nd$3 = ((x1$7 === null) ? null : x1$7.by(key$3, hash$3));
            var $x_6 = ((nd$3 === null) ? f$3() : nd$3.b9);
          }
          var p2 = (+$x_6);
          if (((p1 > p2) || ((p1 >= p2) && reverse))) {
            $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__exchange$1__scm_HashMap__scm_HashMap__I__I__I__V($thiz, rows$14, gpos$21, r, lp, rp);
          }
          lp = rp;
        } else {
          lp = ep;
        }
      } else {
        lp = ep;
      }
    }
    if (((!hasfixed) && (!reverse))) {
      ep = ((ep - 1) | 0);
    }
    nelt = ((nelt - 1) | 0);
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__crossIn$1__scm_HashMap__scm_LinkedHashMap__scm_ArrayBuffer__scm_HashMap__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__J($thiz, gpos$23, hIn$14, emptyRow$14, hPorts$15, hWeight$16, v, w) {
  var elem_$_lo = 0;
  var elem_$_hi = 0;
  elem_$_lo = 0;
  elem_$_hi = 0;
  var this$2 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__in$47__scm_LinkedHashMap__scm_ArrayBuffer__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__scm_ArrayBuffer($thiz, hIn$14, emptyRow$14, v);
  var it = this$2.bB().o();
  while (it.p()) {
    var x0 = it.q();
    var this$3 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__in$47__scm_LinkedHashMap__scm_ArrayBuffer__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__scm_ArrayBuffer($thiz, hIn$14, emptyRow$14, w);
    var it$1 = this$3.bB().o();
    while (it$1.p()) {
      var x0$1 = it$1.q();
      if ((((gpos$23.i(x0) | 0) > (gpos$23.i(x0$1) | 0)) || (((gpos$23.i(x0) | 0) === (gpos$23.i(x0$1) | 0)) && ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__pOf$1__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts($thiz, hPorts$15, x0, v).o0 > $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__pOf$1__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts($thiz, hPorts$15, x0$1, w).o0)))) {
        var x$2_$_lo = elem_$_lo;
        var x$2_$_hi = elem_$_hi;
        var $x_1 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__wOf$1__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__J($thiz, hWeight$16, x0, v);
        var x_$_lo = $x_1.l;
        var x_$_hi = $x_1.h;
        var $x_2 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__wOf$1__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__J($thiz, hWeight$16, x0$1, w);
        var x$1_$_lo = $x_2.l;
        var x$1_$_hi = $x_2.h;
        var a0 = (65535 & x_$_lo);
        var a1 = ((x_$_lo >>> 16) | 0);
        var b0 = (65535 & x$1_$_lo);
        var b1 = ((x$1_$_lo >>> 16) | 0);
        var a0b0 = Math.imul(a0, b0);
        var a1b0 = Math.imul(a1, b0);
        var a0b1 = Math.imul(a0, b1);
        var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi = ((((((((Math.imul(x_$_lo, x$1_$_hi) + Math.imul(x_$_hi, x$1_$_lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
        var lo$1 = ((x$2_$_lo + lo) | 0);
        var hi$1 = ((((x$2_$_hi + hi) | 0) + (((lo$1 >>> 0) < (x$2_$_lo >>> 0)) | 0)) | 0);
        elem_$_lo = lo$1;
        elem_$_hi = hi$1;
      }
    }
  }
  return $bL(elem_$_lo, elem_$_hi);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__crossOut$1__scm_HashMap__scm_LinkedHashMap__scm_ArrayBuffer__scm_HashMap__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__J($thiz, gpos$26, hOut$15, emptyRow$16, hPorts$18, hWeight$19, v, w) {
  var elem_$_lo = 0;
  var elem_$_hi = 0;
  elem_$_lo = 0;
  elem_$_hi = 0;
  var this$2 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__out$51__scm_LinkedHashMap__scm_ArrayBuffer__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__scm_ArrayBuffer($thiz, hOut$15, emptyRow$16, v);
  var it = this$2.bB().o();
  while (it.p()) {
    var x0 = it.q();
    var this$3 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__out$51__scm_LinkedHashMap__scm_ArrayBuffer__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__scm_ArrayBuffer($thiz, hOut$15, emptyRow$16, w);
    var it$1 = this$3.bB().o();
    while (it$1.p()) {
      var x0$1 = it$1.q();
      if ((((gpos$26.i(x0) | 0) > (gpos$26.i(x0$1) | 0)) || (((gpos$26.i(x0) | 0) === (gpos$26.i(x0$1) | 0)) && ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__pOf$1__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts($thiz, hPorts$18, v, x0).nZ > $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__pOf$1__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts($thiz, hPorts$18, w, x0$1).nZ)))) {
        var x$2_$_lo = elem_$_lo;
        var x$2_$_hi = elem_$_hi;
        var $x_1 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__wOf$1__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__J($thiz, hWeight$19, v, x0);
        var x_$_lo = $x_1.l;
        var x_$_hi = $x_1.h;
        var $x_2 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__wOf$1__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__J($thiz, hWeight$19, w, x0$1);
        var x$1_$_lo = $x_2.l;
        var x$1_$_hi = $x_2.h;
        var a0 = (65535 & x_$_lo);
        var a1 = ((x_$_lo >>> 16) | 0);
        var b0 = (65535 & x$1_$_lo);
        var b1 = ((x$1_$_lo >>> 16) | 0);
        var a0b0 = Math.imul(a0, b0);
        var a1b0 = Math.imul(a1, b0);
        var a0b1 = Math.imul(a0, b1);
        var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi = ((((((((Math.imul(x_$_lo, x$1_$_hi) + Math.imul(x_$_hi, x$1_$_lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
        var lo$1 = ((x$2_$_lo + lo) | 0);
        var hi$1 = ((((x$2_$_hi + hi) | 0) + (((lo$1 >>> 0) < (x$2_$_lo >>> 0)) | 0)) | 0);
        elem_$_lo = lo$1;
        elem_$_hi = hi$1;
      }
    }
  }
  return $bL(elem_$_lo, elem_$_hi);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__transposeStep$1__scm_HashMap__scm_HashMap__I__I__I__sci_Map__sci_Vector__scm_HashMap__scm_LinkedHashMap__scm_ArrayBuffer__scm_HashMap__scm_HashMap__scm_LinkedHashMap__I__Z__J($thiz, candidate$1, rows$15, cHi$1, cLo$1, ci$10, clustOf$15, vOrigEnds$15, gpos$28, hIn$15, emptyRow$17, hPorts$20, hWeight$21, hOut$16, r, reverse) {
  var delta_$_lo = 0;
  var delta_$_hi = 0;
  $p_scm_HashMap__put0__O__O__Z__s_Some(candidate$1, r, false, false);
  matchResult55: {
    var \u03b421$___1;
    var \u03b421$___2;
    var x202 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__slice$1__scm_HashMap__I__sci_Map__sci_Vector__I__T2($thiz, rows$15, ci$10, clustOf$15, vOrigEnds$15, r);
    if ((x202 !== null)) {
      var \u03b421$___1 = (x202.g() | 0);
      var \u03b421$___2 = (x202.h() | 0);
      break matchResult55;
    }
    throw new $c_s_MatchError(x202);
  }
  var from$2 = (\u03b421$___1 | 0);
  var until$2 = (\u03b421$___2 | 0);
  var rb = rows$15.i(r);
  var hasBelow = (r < cHi$1);
  var i = from$2;
  while ((i < ((until$2 - 1) | 0))) {
    var v = rb.l(i);
    var w = rb.l(((1 + i) | 0));
    var $x_1 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__crossIn$1__scm_HashMap__scm_LinkedHashMap__scm_ArrayBuffer__scm_HashMap__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__J($thiz, gpos$28, hIn$15, emptyRow$17, hPorts$20, hWeight$21, v, w);
    var x_$_lo = $x_1.l;
    var x_$_hi = $x_1.h;
    if (hasBelow) {
      var $x_2 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__crossOut$1__scm_HashMap__scm_LinkedHashMap__scm_ArrayBuffer__scm_HashMap__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__J($thiz, gpos$28, hOut$16, emptyRow$17, hPorts$20, hWeight$21, v, w);
      var x$1_$_lo = $x_2.l;
      var x$1_$_hi = $x_2.h;
    } else {
      var x$1_$_lo = 0;
      var x$1_$_hi = 0;
    }
    var lo = ((x_$_lo + x$1_$_lo) | 0);
    var hi = ((((x_$_hi + x$1_$_hi) | 0) + (((lo >>> 0) < (x_$_lo >>> 0)) | 0)) | 0);
    var $x_3 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__crossIn$1__scm_HashMap__scm_LinkedHashMap__scm_ArrayBuffer__scm_HashMap__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__J($thiz, gpos$28, hIn$15, emptyRow$17, hPorts$20, hWeight$21, w, v);
    var x$2_$_lo = $x_3.l;
    var x$2_$_hi = $x_3.h;
    if (hasBelow) {
      var $x_4 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__crossOut$1__scm_HashMap__scm_LinkedHashMap__scm_ArrayBuffer__scm_HashMap__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__J($thiz, gpos$28, hOut$16, emptyRow$17, hPorts$20, hWeight$21, w, v);
      var x$3_$_lo = $x_4.l;
      var x$3_$_hi = $x_4.h;
    } else {
      var x$3_$_lo = 0;
      var x$3_$_hi = 0;
    }
    var lo$1 = ((x$2_$_lo + x$3_$_lo) | 0);
    var hi$1 = ((((x$2_$_hi + x$3_$_hi) | 0) + (((lo$1 >>> 0) < (x$2_$_lo >>> 0)) | 0)) | 0);
    if ((((hi$1 === hi) ? ((lo$1 >>> 0) < (lo >>> 0)) : (hi$1 < hi)) || ((((hi === 0) ? (lo !== 0) : (hi > 0)) && reverse) && (((lo$1 ^ lo) | (hi$1 ^ hi)) === 0)))) {
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__exchange$1__scm_HashMap__scm_HashMap__I__I__I__V($thiz, rows$15, gpos$28, r, i, ((1 + i) | 0));
      var x$4_$_lo = delta_$_lo;
      var x$4_$_hi = delta_$_hi;
      var lo$2 = ((lo - lo$1) | 0);
      var hi$2 = ((((hi - hi$1) | 0) - (((lo$2 >>> 0) > (lo >>> 0)) | 0)) | 0);
      var lo$3 = ((x$4_$_lo + lo$2) | 0);
      var hi$3 = ((((x$4_$_hi + hi$2) | 0) + (((lo$3 >>> 0) < (x$4_$_lo >>> 0)) | 0)) | 0);
      delta_$_lo = lo$3;
      delta_$_hi = hi$3;
      $p_scm_HashMap__put0__O__O__Z__s_Some(candidate$1, r, true, false);
      if ((r > cLo$1)) {
        $p_scm_HashMap__put0__O__O__Z__s_Some(candidate$1, ((r - 1) | 0), true, false);
      }
      if ((r < cHi$1)) {
        $p_scm_HashMap__put0__O__O__Z__s_Some(candidate$1, ((1 + r) | 0), true, false);
      }
    }
    i = ((1 + i) | 0);
  }
  return $bL(delta_$_lo, delta_$_hi);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__transpose$1__I__I__scm_HashMap__scm_HashMap__I__sci_Map__sci_Vector__scm_HashMap__scm_LinkedHashMap__scm_ArrayBuffer__scm_HashMap__scm_HashMap__scm_LinkedHashMap__Z__V($thiz, cLo$2, cHi$2, candidate$2, rows$16, ci$11, clustOf$16, vOrigEnds$16, gpos$29, hIn$16, emptyRow$18, hPorts$21, hWeight$22, hOut$17, reverse) {
  if ((!(cLo$2 > cHi$2))) {
    var i = cLo$2;
    while (true) {
      $p_scm_HashMap__put0__O__O__Z__s_Some(candidate$2, i, true, false);
      if ((i === cHi$2)) {
        break;
      }
      i = ((1 + i) | 0);
    }
  }
  var elem_$_lo = 0;
  var elem_$_hi = 0;
  elem_$_lo = 0;
  elem_$_hi = 0;
  while (true) {
    elem_$_lo = 0;
    elem_$_hi = 0;
    if ((!(cLo$2 > cHi$2))) {
      var i$1 = cLo$2;
      while (true) {
        var x0$1 = i$1;
        if ((!(!candidate$2.i(x0$1)))) {
          var x_$_lo = elem_$_lo;
          var x_$_hi = elem_$_hi;
          var $x_1 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__transposeStep$1__scm_HashMap__scm_HashMap__I__I__I__sci_Map__sci_Vector__scm_HashMap__scm_LinkedHashMap__scm_ArrayBuffer__scm_HashMap__scm_HashMap__scm_LinkedHashMap__I__Z__J($thiz, candidate$2, rows$16, cHi$2, cLo$2, ci$11, clustOf$16, vOrigEnds$16, gpos$29, hIn$16, emptyRow$18, hPorts$21, hWeight$22, hOut$17, x0$1, reverse);
          var x$1_$_lo = $x_1.l;
          var x$1_$_hi = $x_1.h;
          var lo = ((x_$_lo + x$1_$_lo) | 0);
          var hi = ((((x_$_hi + x$1_$_hi) | 0) + (((lo >>> 0) < (x_$_lo >>> 0)) | 0)) | 0);
          elem_$_lo = lo;
          elem_$_hi = hi;
        }
        if ((i$1 === cHi$2)) {
          break;
        }
        i$1 = ((1 + i$1) | 0);
      }
    }
    var x$2_$_lo = elem_$_lo;
    var x$2_$_hi = elem_$_hi;
    if (((x$2_$_hi === 0) ? (x$2_$_lo !== 0) : (x$2_$_hi > 0))) {
    } else {
      break;
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__mincrossStep$1__I__I__I__I__scm_HashMap__scm_HashMap__scm_HashMap__I__sci_Map__sci_Vector__scm_LinkedHashMap__scm_ArrayBuffer__scm_LinkedHashMap__scm_HashMap__scm_HashMap__scm_HashMap__scm_HashMap__scm_HashMap__I__V($thiz, cLo$4, gMinR$3, cHi$4, gMaxR$3, rows$18, gpos$31, mval$4, ci$13, clustOf$18, vOrigEnds$18, hOut$19, emptyRow$20, hIn$18, fInC$5, fOutC$5, hPorts$23, candidate$5, hWeight$24, pass) {
  var t = (((pass >> 1) >>> 30) | 0);
  var reverse = ((((3 & ((pass + t) | 0)) - t) | 0) < 2);
  var t$1 = ((pass >>> 31) | 0);
  if (((((1 & ((pass + t$1) | 0)) - t$1) | 0) === 0)) {
    var \u03b422$___1 = ((cLo$4 > gMinR$3) ? cLo$4 : ((1 + cLo$4) | 0));
    var \u03b422$___2 = cHi$4;
    var \u03b422$___3 = 1;
  } else {
    var \u03b422$___1 = ((cHi$4 < gMaxR$3) ? cHi$4 : ((cHi$4 - 1) | 0));
    var \u03b422$___2 = cLo$4;
    var \u03b422$___3 = (-1);
  }
  var first = (\u03b422$___1 | 0);
  var last = (\u03b422$___2 | 0);
  var dir = (\u03b422$___3 | 0);
  var r = first;
  while ((r !== ((last + dir) | 0))) {
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__reorder$1__scm_HashMap__scm_HashMap__I__sci_Map__sci_Vector__scm_HashMap__I__Z__Z__V($thiz, rows$18, mval$4, ci$13, clustOf$18, vOrigEnds$18, gpos$31, r, reverse, $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__medians$1__scm_HashMap__scm_HashMap__scm_HashMap__I__sci_Map__sci_Vector__scm_LinkedHashMap__scm_ArrayBuffer__scm_LinkedHashMap__scm_HashMap__scm_HashMap__scm_HashMap__I__I__Z($thiz, rows$18, gpos$31, mval$4, ci$13, clustOf$18, vOrigEnds$18, hOut$19, emptyRow$20, hIn$18, fInC$5, fOutC$5, hPorts$23, r, ((r - dir) | 0)));
    r = ((r + dir) | 0);
  }
  $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__transpose$1__I__I__scm_HashMap__scm_HashMap__I__sci_Map__sci_Vector__scm_HashMap__scm_LinkedHashMap__scm_ArrayBuffer__scm_HashMap__scm_HashMap__scm_LinkedHashMap__Z__V($thiz, cLo$4, cHi$4, candidate$5, rows$18, ci$13, clustOf$18, vOrigEnds$18, gpos$31, hIn$18, emptyRow$20, hPorts$23, hWeight$24, hOut$19, (!reverse));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__snapshot$1__scm_HashMap__sci_Map($thiz, rows$19) {
  return $m_sci_Map$().ao(new $c_sc_Iterator$$anon$9(rows$19.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var r = (x$1.g() | 0);
    var b = x$1.h();
    return new $c_T2(r, $m_sci_Vector$().X(b));
  }))));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__restore$1__scm_HashMap__scm_HashMap__sci_Map__V($thiz, rows$20, gpos$32, s) {
  s.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var r = (x$1.g() | 0);
    var v = x$1.h();
    var rb = rows$20.i(r);
    $p_scm_ArrayBuffer__reduceToSize__I__V(rb, 0);
    rb.gS(v);
    var this$2 = new $c_sc_Iterator$$anon$16(v.o());
    while (this$2.p()) {
      var x0 = this$2.dC();
      $p_scm_HashMap__put0__O__O__Z__s_Some(gpos$32, x0.g(), (x0.h() | 0), false);
    }
  })));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__refineCluster$1__sci_Map__scm_HashMap__scm_HashMap__I__I__scm_LinkedHashMap__scm_ArrayBuffer__scm_HashMap__F1__scm_HashMap__scm_LinkedHashMap__sci_Map__sci_Vector__scm_HashMap__scm_HashMap__I__V($thiz, clRanks$4, rows$10, gpos$16, gMinR$2, gMaxR$2, hOut$12, emptyRow$11, hWeight$14, hasPort$5, hPorts$10, hIn$11, clustOf$11, vOrigEnds$11, fInC$3, fOutC$3, ci) {
  matchResult51: {
    var \u03b418$___1;
    var \u03b418$___2;
    var x192 = clRanks$4.i(ci);
    if ((x192 !== null)) {
      var \u03b418$___1 = (x192.g() | 0);
      var \u03b418$___2 = (x192.h() | 0);
      break matchResult51;
    }
    throw new $c_s_MatchError(x192);
  }
  var cLo$2 = (\u03b418$___1 | 0);
  var cHi$2 = (\u03b418$___2 | 0);
  var mval = $ct_scm_HashMap__(new $c_scm_HashMap());
  var $x_1 = $m_scm_HashMap$();
  var isEmpty = (cLo$2 > cHi$2);
  if (((((1 + ((cHi$2 - cLo$2) | 0)) | 0) <= 0) && (!isEmpty))) {
    $m_sci_Range$().ug(cLo$2, cHi$2, 1, true);
  }
  var b = $m_sci_IndexedSeq$().b5();
  var it = new $c_sci_RangeIterator(cLo$2, 1, cHi$2, isEmpty);
  while (it.g0) {
    b.Y(new $c_T2(it.hp(), true));
  }
  var candidate = $x_1.DY(b.aR());
  var $x_2 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__ncrossGlobal$1__I__I__scm_HashMap__scm_HashMap__scm_LinkedHashMap__scm_ArrayBuffer__scm_HashMap__F1__scm_HashMap__scm_LinkedHashMap__J($thiz, gMinR$2, gMaxR$2, rows$10, gpos$16, hOut$12, emptyRow$11, hWeight$14, hasPort$5, hPorts$10, hIn$11);
  var cur_$_lo = $x_2.l;
  var cur_$_hi = $x_2.h;
  var best_$_lo = cur_$_lo;
  var best_$_hi = cur_$_hi;
  var bst = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__snapshot$1__scm_HashMap__sci_Map($thiz, rows$10);
  var trying = 0;
  var iter = 0;
  var brk = false;
  while (((iter < $thiz.RH) && (!brk))) {
    if ((trying >= $thiz.ZQ)) {
      brk = true;
    } else {
      trying = ((1 + trying) | 0);
      var x_$_lo = cur_$_lo;
      var x_$_hi = cur_$_hi;
      if (((x_$_lo | x_$_hi) === 0)) {
        brk = true;
      } else {
        $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__mincrossStep$1__I__I__I__I__scm_HashMap__scm_HashMap__scm_HashMap__I__sci_Map__sci_Vector__scm_LinkedHashMap__scm_ArrayBuffer__scm_LinkedHashMap__scm_HashMap__scm_HashMap__scm_HashMap__scm_HashMap__scm_HashMap__I__V($thiz, cLo$2, gMinR$2, cHi$2, gMaxR$2, rows$10, gpos$16, mval, ci, clustOf$11, vOrigEnds$11, hOut$12, emptyRow$11, hIn$11, fInC$3, fOutC$3, hPorts$10, candidate, hWeight$14, iter);
        var $x_3 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__ncrossGlobal$1__I__I__scm_HashMap__scm_HashMap__scm_LinkedHashMap__scm_ArrayBuffer__scm_HashMap__F1__scm_HashMap__scm_LinkedHashMap__J($thiz, gMinR$2, gMaxR$2, rows$10, gpos$16, hOut$12, emptyRow$11, hWeight$14, hasPort$5, hPorts$10, hIn$11);
        cur_$_lo = $x_3.l;
        cur_$_hi = $x_3.h;
        var x$1_$_lo = cur_$_lo;
        var x$1_$_hi = cur_$_hi;
        var x$2_$_lo = best_$_lo;
        var x$2_$_hi = best_$_hi;
        if (((x$1_$_hi === x$2_$_hi) ? ((x$1_$_lo >>> 0) <= (x$2_$_lo >>> 0)) : (x$1_$_hi < x$2_$_hi))) {
          bst = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__snapshot$1__scm_HashMap__sci_Map($thiz, rows$10);
          var x$3_$_lo = cur_$_lo;
          var x$3_$_hi = cur_$_hi;
          var $x_4 = $thiz.ZP;
          var x$4_$_lo = best_$_lo;
          var x$4_$_hi = best_$_hi;
          if ((((4.294967296E9 * x$3_$_hi) + (x$3_$_lo >>> 0.0)) < ($x_4 * ((4.294967296E9 * x$4_$_hi) + (x$4_$_lo >>> 0.0))))) {
            trying = 0;
          }
          best_$_lo = cur_$_lo;
          best_$_hi = cur_$_hi;
        }
        iter = ((1 + iter) | 0);
      }
    }
  }
  var x$5_$_lo = cur_$_lo;
  var x$5_$_hi = cur_$_hi;
  var x$6_$_lo = best_$_lo;
  var x$6_$_hi = best_$_hi;
  if (((x$5_$_hi === x$6_$_hi) ? ((x$5_$_lo >>> 0) > (x$6_$_lo >>> 0)) : (x$5_$_hi > x$6_$_hi))) {
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__restore$1__scm_HashMap__scm_HashMap__sci_Map__V($thiz, rows$10, gpos$16, bst);
  }
  var x$7_$_lo = best_$_lo;
  var x$7_$_hi = best_$_hi;
  if (((x$7_$_hi === 0) ? (x$7_$_lo !== 0) : (x$7_$_hi > 0))) {
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__transpose$1__I__I__scm_HashMap__scm_HashMap__I__sci_Map__sci_Vector__scm_HashMap__scm_LinkedHashMap__scm_ArrayBuffer__scm_HashMap__scm_HashMap__scm_LinkedHashMap__Z__V($thiz, cLo$2, cHi$2, candidate, rows$10, ci, clustOf$11, vOrigEnds$11, gpos$16, hIn$11, emptyRow$11, hPorts$10, hWeight$14, hOut$12, false);
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__pinned$1__sci_Map__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Z($thiz, clustOf$33, vOrigEnds$33, v, w) {
  var x = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__clustOfC$1__sci_Map__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__s_Option($thiz, clustOf$33, vOrigEnds$33, v);
  var x$2 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__clustOfC$1__sci_Map__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__s_Option($thiz, clustOf$33, vOrigEnds$33, w);
  return (!((x === null) ? (x$2 === null) : x.e(x$2)));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__exchange$2__scm_HashMap__scm_HashMap__I__I__I__V($thiz, rows$22, gpos$35, r, i, j) {
  var rb = rows$22.i(r);
  var a = rb.l(i);
  var b = rb.l(j);
  rb.cM(i, b);
  rb.cM(j, a);
  $p_scm_HashMap__put0__O__O__Z__s_Some(gpos$35, a, j, false);
  $p_scm_HashMap__put0__O__O__Z__s_Some(gpos$35, b, i, false);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__medians$2__scm_HashMap__scm_HashMap__scm_HashMap__scm_LinkedHashMap__scm_ArrayBuffer__scm_LinkedHashMap__scm_HashMap__scm_HashMap__scm_HashMap__I__I__Z($thiz, rows$23, gpos$36, mval$5, hOut$20, emptyRow$21, hIn$19, hPorts$24, fInC$6, fOutC$6, r0, r1) {
  var f = (() => {
    $m_scm_ArrayBuffer$();
    return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  });
  if ((!($objectGetClass(rows$23) === $d_scm_HashMap.l()))) {
    var x1 = rows$23.r(r0);
    if ((x1 instanceof $c_s_Some)) {
      var $x_1 = x1.J;
    } else {
      if ((!($m_s_None$() === x1))) {
        throw new $c_s_MatchError(x1);
      }
      var $x_1 = f();
    }
  } else {
    var originalHash = $m_sr_Statics$().u(r0);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var x1$1 = rows$23.S.a[(hash & ((rows$23.S.a.length - 1) | 0))];
    var nd = ((x1$1 === null) ? null : x1$1.by(r0, hash));
    var $x_1 = ((nd === null) ? f() : nd.b9);
  }
  $x_1.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n) => {
    if ((r1 > r0)) {
      var this$3 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__out$51__scm_LinkedHashMap__scm_ArrayBuffer__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__scm_ArrayBuffer($thiz, hOut$20, emptyRow$21, n);
      $m_scm_ArrayBuffer$();
      var b = new $c_scm_ArrayBuffer$$anon$1();
      var it = this$3.bB().o();
      while (it.p()) {
        var x0 = it.q();
        b.mI(((((gpos$36.i(x0) | 0) << 8) + $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__pOf$1__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts($thiz, hPorts$24, n, x0).Bo) | 0));
      }
      var $x_2 = b.gj;
    } else {
      var this$5 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__in$47__scm_LinkedHashMap__scm_ArrayBuffer__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__scm_ArrayBuffer($thiz, hIn$19, emptyRow$21, n);
      $m_scm_ArrayBuffer$();
      var b$1 = new $c_scm_ArrayBuffer$$anon$1();
      var it$1 = this$5.bB().o();
      while (it$1.p()) {
        var x0$1 = it$1.q();
        b$1.mI(((((gpos$36.i(x0$1) | 0) << 8) + $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__pOf$1__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts($thiz, hPorts$24, x0$1, n).Bp) | 0));
      }
      var $x_2 = b$1.gj;
    }
    var nbrs = $f_sc_SeqOps__sorted__s_math_Ordering__O($x_2, $m_s_math_Ordering$Int$());
    var $x_3;
    var x205 = nbrs.a1;
    switch (x205) {
      case 0: {
        var $x_3 = (-1.0);
        break;
      }
      case 1: {
        var $x_3 = (nbrs.l(0) | 0);
        break;
      }
      case 2: {
        var num = (((nbrs.l(0) | 0) + (nbrs.l(1) | 0)) | 0);
        var $x_3 = (((num + ((num >>> 31) | 0)) | 0) >> 1);
        break;
      }
      default: {
        var rm = (((x205 + ((x205 >>> 31) | 0)) | 0) >> 1);
        var t = ((x205 >>> 31) | 0);
        if (((((1 & ((x205 + t) | 0)) - t) | 0) === 1)) {
          var $x_3 = (nbrs.l(rm) | 0);
        } else {
          var lm = ((rm - 1) | 0);
          var rspan = (((nbrs.l(((x205 - 1) | 0)) | 0) - (nbrs.l(rm) | 0)) | 0);
          var lspan = (((nbrs.l(lm) | 0) - (nbrs.l(0) | 0)) | 0);
          if ((lspan === rspan)) {
            var num$1 = (((nbrs.l(lm) | 0) + (nbrs.l(rm) | 0)) | 0);
            var $x_3 = (((num$1 + ((num$1 >>> 31) | 0)) | 0) >> 1);
          } else {
            var $x_3 = ((((nbrs.l(lm) | 0) * rspan) + ((nbrs.l(rm) | 0) * lspan)) / ((lspan + rspan) | 0));
          }
        }
      }
    }
    $p_scm_HashMap__put0__O__O__Z__s_Some(mval$5, n, $x_3, false);
  })));
  var hasfixed = new $c_sr_BooleanRef(false);
  var f$1 = (() => {
    $m_scm_ArrayBuffer$();
    return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  });
  if ((!($objectGetClass(rows$23) === $d_scm_HashMap.l()))) {
    var x1$2 = rows$23.r(r0);
    if ((x1$2 instanceof $c_s_Some)) {
      var $x_4 = x1$2.J;
    } else {
      if ((!($m_s_None$() === x1$2))) {
        throw new $c_s_MatchError(x1$2);
      }
      var $x_4 = f$1();
    }
  } else {
    var originalHash$1 = $m_sr_Statics$().u(r0);
    var hash$1 = (originalHash$1 ^ ((originalHash$1 >>> 16) | 0));
    var x1$3 = rows$23.S.a[(hash$1 & ((rows$23.S.a.length - 1) | 0))];
    var nd$1 = ((x1$3 === null) ? null : x1$3.by(r0, hash$1));
    var $x_4 = ((nd$1 === null) ? f$1() : nd$1.b9);
  }
  $x_4.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n$2) => {
    if (($f_sc_SeqOps__isEmpty__Z($p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__out$51__scm_LinkedHashMap__scm_ArrayBuffer__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__scm_ArrayBuffer($thiz, hOut$20, emptyRow$21, n$2)) && $f_sc_SeqOps__isEmpty__Z($p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__in$47__scm_LinkedHashMap__scm_ArrayBuffer__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__scm_ArrayBuffer($thiz, hIn$19, emptyRow$21, n$2)))) {
      hasfixed.dy = ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__flatMvalOf$1__scm_HashMap__scm_HashMap__scm_HashMap__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Z($thiz, gpos$36, fInC$6, fOutC$6, mval$5, n$2) || hasfixed.dy);
    }
  })));
  return hasfixed.dy;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__reorder$2__scm_HashMap__scm_HashMap__sci_Map__sci_Vector__scm_HashMap__I__Z__Z__V($thiz, rows$24, mval$8, clustOf$19, vOrigEnds$19, gpos$41, r, reverse, hasfixed) {
  var rb = rows$24.i(r);
  var ep = rb.a1;
  var nelt = ((rb.a1 - 1) | 0);
  while ((nelt >= 0)) {
    var lp = 0;
    while ((lp < ep)) {
      while (true) {
        if ((lp < ep)) {
          var key = rb.l(lp);
          var f = (() => (-1.0));
          if ((!($objectGetClass(mval$8) === $d_scm_HashMap.l()))) {
            var x1 = mval$8.r(key);
            if ((x1 instanceof $c_s_Some)) {
              var $x_2 = x1.J;
            } else {
              if ((!($m_s_None$() === x1))) {
                throw new $c_s_MatchError(x1);
              }
              var $x_2 = f();
            }
          } else {
            var originalHash = $m_sr_Statics$().u(key);
            var hash = (originalHash ^ ((originalHash >>> 16) | 0));
            var x1$1 = mval$8.S.a[(hash & ((mval$8.S.a.length - 1) | 0))];
            var nd = ((x1$1 === null) ? null : x1$1.by(key, hash));
            var $x_2 = ((nd === null) ? f() : nd.b9);
          }
          var $x_1 = ((+$x_2) < 0.0);
        } else {
          var $x_1 = false;
        }
        if ($x_1) {
          lp = ((1 + lp) | 0);
        } else {
          break;
        }
      }
      if ((lp < ep)) {
        var rp = ((1 + lp) | 0);
        var muststay = false;
        var found = false;
        var sawclust = false;
        while ((((rp < ep) && (!muststay)) && (!found))) {
          if (sawclust) {
            rp = ((1 + rp) | 0);
          } else if ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__pinned$1__sci_Map__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Z($thiz, clustOf$19, vOrigEnds$19, rb.l(lp), rb.l(rp))) {
            muststay = true;
          } else {
            var key$1 = rb.l(rp);
            var f$1 = (() => (-1.0));
            if ((!($objectGetClass(mval$8) === $d_scm_HashMap.l()))) {
              var x1$2 = mval$8.r(key$1);
              if ((x1$2 instanceof $c_s_Some)) {
                var $x_3 = x1$2.J;
              } else {
                if ((!($m_s_None$() === x1$2))) {
                  throw new $c_s_MatchError(x1$2);
                }
                var $x_3 = f$1();
              }
            } else {
              var originalHash$1 = $m_sr_Statics$().u(key$1);
              var hash$1 = (originalHash$1 ^ ((originalHash$1 >>> 16) | 0));
              var x1$3 = mval$8.S.a[(hash$1 & ((mval$8.S.a.length - 1) | 0))];
              var nd$1 = ((x1$3 === null) ? null : x1$3.by(key$1, hash$1));
              var $x_3 = ((nd$1 === null) ? f$1() : nd$1.b9);
            }
            if (((+$x_3) >= 0.0)) {
              found = true;
            } else {
              sawclust = true;
              rp = ((1 + rp) | 0);
            }
          }
        }
        if ((rp < ep)) {
          if ((!muststay)) {
            var key$2 = rb.l(lp);
            var f$2 = (() => (-1.0));
            if ((!($objectGetClass(mval$8) === $d_scm_HashMap.l()))) {
              var x1$4 = mval$8.r(key$2);
              if ((x1$4 instanceof $c_s_Some)) {
                var $x_4 = x1$4.J;
              } else {
                if ((!($m_s_None$() === x1$4))) {
                  throw new $c_s_MatchError(x1$4);
                }
                var $x_4 = f$2();
              }
            } else {
              var originalHash$2 = $m_sr_Statics$().u(key$2);
              var hash$2 = (originalHash$2 ^ ((originalHash$2 >>> 16) | 0));
              var x1$5 = mval$8.S.a[(hash$2 & ((mval$8.S.a.length - 1) | 0))];
              var nd$2 = ((x1$5 === null) ? null : x1$5.by(key$2, hash$2));
              var $x_4 = ((nd$2 === null) ? f$2() : nd$2.b9);
            }
            var p1 = (+$x_4);
            var key$3 = rb.l(rp);
            var f$3 = (() => (-1.0));
            if ((!($objectGetClass(mval$8) === $d_scm_HashMap.l()))) {
              var x1$6 = mval$8.r(key$3);
              if ((x1$6 instanceof $c_s_Some)) {
                var $x_5 = x1$6.J;
              } else {
                if ((!($m_s_None$() === x1$6))) {
                  throw new $c_s_MatchError(x1$6);
                }
                var $x_5 = f$3();
              }
            } else {
              var originalHash$3 = $m_sr_Statics$().u(key$3);
              var hash$3 = (originalHash$3 ^ ((originalHash$3 >>> 16) | 0));
              var x1$7 = mval$8.S.a[(hash$3 & ((mval$8.S.a.length - 1) | 0))];
              var nd$3 = ((x1$7 === null) ? null : x1$7.by(key$3, hash$3));
              var $x_5 = ((nd$3 === null) ? f$3() : nd$3.b9);
            }
            var p2 = (+$x_5);
            if (((p1 > p2) || ((p1 >= p2) && reverse))) {
              $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__exchange$2__scm_HashMap__scm_HashMap__I__I__I__V($thiz, rows$24, gpos$41, r, lp, rp);
            }
          }
          lp = rp;
        } else {
          lp = ep;
        }
      } else {
        lp = ep;
      }
    }
    if (((!hasfixed) && (!reverse))) {
      ep = ((ep - 1) | 0);
    }
    nelt = ((nelt - 1) | 0);
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__crossIn$2__scm_HashMap__scm_LinkedHashMap__scm_ArrayBuffer__scm_HashMap__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__J($thiz, gpos$43, hIn$23, emptyRow$25, hPorts$29, hWeight$26, v, w) {
  var elem_$_lo = 0;
  var elem_$_hi = 0;
  elem_$_lo = 0;
  elem_$_hi = 0;
  var this$2 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__in$47__scm_LinkedHashMap__scm_ArrayBuffer__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__scm_ArrayBuffer($thiz, hIn$23, emptyRow$25, v);
  var it = this$2.bB().o();
  while (it.p()) {
    var x0 = it.q();
    var this$3 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__in$47__scm_LinkedHashMap__scm_ArrayBuffer__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__scm_ArrayBuffer($thiz, hIn$23, emptyRow$25, w);
    var it$1 = this$3.bB().o();
    while (it$1.p()) {
      var x0$1 = it$1.q();
      if ((((gpos$43.i(x0) | 0) > (gpos$43.i(x0$1) | 0)) || (((gpos$43.i(x0) | 0) === (gpos$43.i(x0$1) | 0)) && ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__pOf$1__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts($thiz, hPorts$29, x0, v).o0 > $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__pOf$1__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts($thiz, hPorts$29, x0$1, w).o0)))) {
        var x$2_$_lo = elem_$_lo;
        var x$2_$_hi = elem_$_hi;
        var $x_1 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__wOf$1__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__J($thiz, hWeight$26, x0, v);
        var x_$_lo = $x_1.l;
        var x_$_hi = $x_1.h;
        var $x_2 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__wOf$1__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__J($thiz, hWeight$26, x0$1, w);
        var x$1_$_lo = $x_2.l;
        var x$1_$_hi = $x_2.h;
        var a0 = (65535 & x_$_lo);
        var a1 = ((x_$_lo >>> 16) | 0);
        var b0 = (65535 & x$1_$_lo);
        var b1 = ((x$1_$_lo >>> 16) | 0);
        var a0b0 = Math.imul(a0, b0);
        var a1b0 = Math.imul(a1, b0);
        var a0b1 = Math.imul(a0, b1);
        var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi = ((((((((Math.imul(x_$_lo, x$1_$_hi) + Math.imul(x_$_hi, x$1_$_lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
        var lo$1 = ((x$2_$_lo + lo) | 0);
        var hi$1 = ((((x$2_$_hi + hi) | 0) + (((lo$1 >>> 0) < (x$2_$_lo >>> 0)) | 0)) | 0);
        elem_$_lo = lo$1;
        elem_$_hi = hi$1;
      }
    }
  }
  return $bL(elem_$_lo, elem_$_hi);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__crossOut$2__scm_HashMap__scm_LinkedHashMap__scm_ArrayBuffer__scm_HashMap__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__J($thiz, gpos$46, hOut$24, emptyRow$27, hPorts$32, hWeight$29, v, w) {
  var elem_$_lo = 0;
  var elem_$_hi = 0;
  elem_$_lo = 0;
  elem_$_hi = 0;
  var this$2 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__out$51__scm_LinkedHashMap__scm_ArrayBuffer__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__scm_ArrayBuffer($thiz, hOut$24, emptyRow$27, v);
  var it = this$2.bB().o();
  while (it.p()) {
    var x0 = it.q();
    var this$3 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__out$51__scm_LinkedHashMap__scm_ArrayBuffer__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__scm_ArrayBuffer($thiz, hOut$24, emptyRow$27, w);
    var it$1 = this$3.bB().o();
    while (it$1.p()) {
      var x0$1 = it$1.q();
      if ((((gpos$46.i(x0) | 0) > (gpos$46.i(x0$1) | 0)) || (((gpos$46.i(x0) | 0) === (gpos$46.i(x0$1) | 0)) && ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__pOf$1__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts($thiz, hPorts$32, v, x0).nZ > $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__pOf$1__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts($thiz, hPorts$32, w, x0$1).nZ)))) {
        var x$2_$_lo = elem_$_lo;
        var x$2_$_hi = elem_$_hi;
        var $x_1 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__wOf$1__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__J($thiz, hWeight$29, v, x0);
        var x_$_lo = $x_1.l;
        var x_$_hi = $x_1.h;
        var $x_2 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__wOf$1__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__J($thiz, hWeight$29, w, x0$1);
        var x$1_$_lo = $x_2.l;
        var x$1_$_hi = $x_2.h;
        var a0 = (65535 & x_$_lo);
        var a1 = ((x_$_lo >>> 16) | 0);
        var b0 = (65535 & x$1_$_lo);
        var b1 = ((x$1_$_lo >>> 16) | 0);
        var a0b0 = Math.imul(a0, b0);
        var a1b0 = Math.imul(a1, b0);
        var a0b1 = Math.imul(a0, b1);
        var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi = ((((((((Math.imul(x_$_lo, x$1_$_hi) + Math.imul(x_$_hi, x$1_$_lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
        var lo$1 = ((x$2_$_lo + lo) | 0);
        var hi$1 = ((((x$2_$_hi + hi) | 0) + (((lo$1 >>> 0) < (x$2_$_lo >>> 0)) | 0)) | 0);
        elem_$_lo = lo$1;
        elem_$_hi = hi$1;
      }
    }
  }
  return $bL(elem_$_lo, elem_$_hi);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__transposeStep$2__scm_HashMap__scm_HashMap__I__I__sci_Map__sci_Vector__scm_HashMap__scm_LinkedHashMap__scm_ArrayBuffer__scm_HashMap__scm_HashMap__scm_LinkedHashMap__I__Z__J($thiz, candidate$6, rows$25, gMinR$4, gMaxR$4, clustOf$20, vOrigEnds$20, gpos$48, hIn$24, emptyRow$28, hPorts$34, hWeight$31, hOut$25, r, reverse) {
  var delta_$_lo = 0;
  var delta_$_hi = 0;
  $p_scm_HashMap__put0__O__O__Z__s_Some(candidate$6, r, false, false);
  var f = (() => {
    $m_scm_ArrayBuffer$();
    return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  });
  if ((!($objectGetClass(rows$25) === $d_scm_HashMap.l()))) {
    var x1 = rows$25.r(r);
    if ((x1 instanceof $c_s_Some)) {
      var $x_1 = x1.J;
    } else {
      if ((!($m_s_None$() === x1))) {
        throw new $c_s_MatchError(x1);
      }
      var $x_1 = f();
    }
  } else {
    var originalHash = $m_sr_Statics$().u(r);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var x1$1 = rows$25.S.a[(hash & ((rows$25.S.a.length - 1) | 0))];
    var nd = ((x1$1 === null) ? null : x1$1.by(r, hash));
    var $x_1 = ((nd === null) ? f() : nd.b9);
  }
  var rb = $x_1;
  var i = 0;
  while ((i < ((rb.a1 - 1) | 0))) {
    var v$1 = rb.l(i);
    var w = rb.l(((1 + i) | 0));
    if ((!$p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__pinned$1__sci_Map__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Z($thiz, clustOf$20, vOrigEnds$20, v$1, w))) {
      var c0_$_lo = 0;
      var c0_$_hi = 0;
      var c1_$_lo = 0;
      var c1_$_hi = 0;
      if ((r > gMinR$4)) {
        var x$2_$_lo = c0_$_lo;
        var x$2_$_hi = c0_$_hi;
        var $x_2 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__crossIn$2__scm_HashMap__scm_LinkedHashMap__scm_ArrayBuffer__scm_HashMap__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__J($thiz, gpos$48, hIn$24, emptyRow$28, hPorts$34, hWeight$31, v$1, w);
        var x$3_$_lo = $x_2.l;
        var x$3_$_hi = $x_2.h;
        var lo = ((x$2_$_lo + x$3_$_lo) | 0);
        var hi = ((((x$2_$_hi + x$3_$_hi) | 0) + (((lo >>> 0) < (x$2_$_lo >>> 0)) | 0)) | 0);
        c0_$_lo = lo;
        c0_$_hi = hi;
        var x$4_$_lo = c1_$_lo;
        var x$4_$_hi = c1_$_hi;
        var $x_3 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__crossIn$2__scm_HashMap__scm_LinkedHashMap__scm_ArrayBuffer__scm_HashMap__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__J($thiz, gpos$48, hIn$24, emptyRow$28, hPorts$34, hWeight$31, w, v$1);
        var x$5_$_lo = $x_3.l;
        var x$5_$_hi = $x_3.h;
        var lo$1 = ((x$4_$_lo + x$5_$_lo) | 0);
        var hi$1 = ((((x$4_$_hi + x$5_$_hi) | 0) + (((lo$1 >>> 0) < (x$4_$_lo >>> 0)) | 0)) | 0);
        c1_$_lo = lo$1;
        c1_$_hi = hi$1;
      }
      if ((r < gMaxR$4)) {
        var key = ((1 + r) | 0);
        var f$1 = (() => {
          $m_scm_ArrayBuffer$();
          return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
        });
        if ((!($objectGetClass(rows$25) === $d_scm_HashMap.l()))) {
          var x1$2 = rows$25.r(key);
          if ((x1$2 instanceof $c_s_Some)) {
            var $x_5 = x1$2.J;
          } else {
            if ((!($m_s_None$() === x1$2))) {
              throw new $c_s_MatchError(x1$2);
            }
            var $x_5 = f$1();
          }
        } else {
          var originalHash$1 = $m_sr_Statics$().u(key);
          var hash$1 = (originalHash$1 ^ ((originalHash$1 >>> 16) | 0));
          var x1$3 = rows$25.S.a[(hash$1 & ((rows$25.S.a.length - 1) | 0))];
          var nd$1 = ((x1$3 === null) ? null : x1$3.by(key, hash$1));
          var $x_5 = ((nd$1 === null) ? f$1() : nd$1.b9);
        }
        var $x_4 = (!$x_5.c());
      } else {
        var $x_4 = false;
      }
      if ($x_4) {
        var x$8_$_lo = c0_$_lo;
        var x$8_$_hi = c0_$_hi;
        var $x_6 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__crossOut$2__scm_HashMap__scm_LinkedHashMap__scm_ArrayBuffer__scm_HashMap__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__J($thiz, gpos$48, hOut$25, emptyRow$28, hPorts$34, hWeight$31, v$1, w);
        var x$9_$_lo = $x_6.l;
        var x$9_$_hi = $x_6.h;
        var lo$2 = ((x$8_$_lo + x$9_$_lo) | 0);
        var hi$2 = ((((x$8_$_hi + x$9_$_hi) | 0) + (((lo$2 >>> 0) < (x$8_$_lo >>> 0)) | 0)) | 0);
        c0_$_lo = lo$2;
        c0_$_hi = hi$2;
        var x$10_$_lo = c1_$_lo;
        var x$10_$_hi = c1_$_hi;
        var $x_7 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__crossOut$2__scm_HashMap__scm_LinkedHashMap__scm_ArrayBuffer__scm_HashMap__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode__J($thiz, gpos$48, hOut$25, emptyRow$28, hPorts$34, hWeight$31, w, v$1);
        var x$11_$_lo = $x_7.l;
        var x$11_$_hi = $x_7.h;
        var lo$3 = ((x$10_$_lo + x$11_$_lo) | 0);
        var hi$3 = ((((x$10_$_hi + x$11_$_hi) | 0) + (((lo$3 >>> 0) < (x$10_$_lo >>> 0)) | 0)) | 0);
        c1_$_lo = lo$3;
        c1_$_hi = hi$3;
      }
      var x$12_$_lo = c1_$_lo;
      var x$12_$_hi = c1_$_hi;
      var x$13_$_lo = c0_$_lo;
      var x$13_$_hi = c0_$_hi;
      if (((x$12_$_hi === x$13_$_hi) ? ((x$12_$_lo >>> 0) < (x$13_$_lo >>> 0)) : (x$12_$_hi < x$13_$_hi))) {
        var $x_8 = true;
      } else {
        var x$14_$_lo = c0_$_lo;
        var x$14_$_hi = c0_$_hi;
        if ((((x$14_$_hi === 0) ? (x$14_$_lo !== 0) : (x$14_$_hi > 0)) && reverse)) {
          var x$15_$_lo = c1_$_lo;
          var x$15_$_hi = c1_$_hi;
          var x$16_$_lo = c0_$_lo;
          var x$16_$_hi = c0_$_hi;
          var $x_8 = (((x$15_$_lo ^ x$16_$_lo) | (x$15_$_hi ^ x$16_$_hi)) === 0);
        } else {
          var $x_8 = false;
        }
      }
      if ($x_8) {
        $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__exchange$2__scm_HashMap__scm_HashMap__I__I__I__V($thiz, rows$25, gpos$48, r, i, ((1 + i) | 0));
        var x$19_$_lo = delta_$_lo;
        var x$19_$_hi = delta_$_hi;
        var x$17_$_lo = c0_$_lo;
        var x$17_$_hi = c0_$_hi;
        var x$18_$_lo = c1_$_lo;
        var x$18_$_hi = c1_$_hi;
        var lo$4 = ((x$17_$_lo - x$18_$_lo) | 0);
        var hi$4 = ((((x$17_$_hi - x$18_$_hi) | 0) - (((lo$4 >>> 0) > (x$17_$_lo >>> 0)) | 0)) | 0);
        var lo$5 = ((x$19_$_lo + lo$4) | 0);
        var hi$5 = ((((x$19_$_hi + hi$4) | 0) + (((lo$5 >>> 0) < (x$19_$_lo >>> 0)) | 0)) | 0);
        delta_$_lo = lo$5;
        delta_$_hi = hi$5;
        $p_scm_HashMap__put0__O__O__Z__s_Some(candidate$6, r, true, false);
        if ((r > gMinR$4)) {
          $p_scm_HashMap__put0__O__O__Z__s_Some(candidate$6, ((r - 1) | 0), true, false);
        }
        if ((r < gMaxR$4)) {
          $p_scm_HashMap__put0__O__O__Z__s_Some(candidate$6, ((1 + r) | 0), true, false);
        }
      }
    }
    i = ((1 + i) | 0);
  }
  return $bL(delta_$_lo, delta_$_hi);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__transpose$2__I__I__scm_HashMap__scm_HashMap__sci_Map__sci_Vector__scm_HashMap__scm_LinkedHashMap__scm_ArrayBuffer__scm_HashMap__scm_HashMap__scm_LinkedHashMap__Z__V($thiz, gMinR$5, gMaxR$5, candidate$7, rows$26, clustOf$21, vOrigEnds$21, gpos$49, hIn$25, emptyRow$29, hPorts$35, hWeight$32, hOut$26, reverse) {
  if ((!(gMinR$5 > gMaxR$5))) {
    var i = gMinR$5;
    while (true) {
      $p_scm_HashMap__put0__O__O__Z__s_Some(candidate$7, i, true, false);
      if ((i === gMaxR$5)) {
        break;
      }
      i = ((1 + i) | 0);
    }
  }
  var elem_$_lo = 0;
  var elem_$_hi = 0;
  elem_$_lo = 0;
  elem_$_hi = 0;
  while (true) {
    elem_$_lo = 0;
    elem_$_hi = 0;
    if ((!(gMinR$5 > gMaxR$5))) {
      var i$1 = gMinR$5;
      while (true) {
        var x0$1 = i$1;
        if ((!(!candidate$7.i(x0$1)))) {
          var x_$_lo = elem_$_lo;
          var x_$_hi = elem_$_hi;
          var $x_1 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__transposeStep$2__scm_HashMap__scm_HashMap__I__I__sci_Map__sci_Vector__scm_HashMap__scm_LinkedHashMap__scm_ArrayBuffer__scm_HashMap__scm_HashMap__scm_LinkedHashMap__I__Z__J($thiz, candidate$7, rows$26, gMinR$5, gMaxR$5, clustOf$21, vOrigEnds$21, gpos$49, hIn$25, emptyRow$29, hPorts$35, hWeight$32, hOut$26, x0$1, reverse);
          var x$1_$_lo = $x_1.l;
          var x$1_$_hi = $x_1.h;
          var lo = ((x_$_lo + x$1_$_lo) | 0);
          var hi = ((((x_$_hi + x$1_$_hi) | 0) + (((lo >>> 0) < (x_$_lo >>> 0)) | 0)) | 0);
          elem_$_lo = lo;
          elem_$_hi = hi;
        }
        if ((i$1 === gMaxR$5)) {
          break;
        }
        i$1 = ((1 + i$1) | 0);
      }
    }
    var x$2_$_lo = elem_$_lo;
    var x$2_$_hi = elem_$_hi;
    if (((x$2_$_hi === 0) ? (x$2_$_lo !== 0) : (x$2_$_hi > 0))) {
    } else {
      break;
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__mincrossStep$2__I__I__scm_HashMap__scm_HashMap__scm_HashMap__scm_LinkedHashMap__scm_ArrayBuffer__scm_LinkedHashMap__scm_HashMap__scm_HashMap__scm_HashMap__sci_Map__sci_Vector__scm_HashMap__scm_HashMap__I__V($thiz, gMinR$7, gMaxR$7, rows$28, gpos$51, mval$9, hOut$28, emptyRow$31, hIn$27, hPorts$37, fInC$8, fOutC$8, clustOf$23, vOrigEnds$23, candidate$10, hWeight$34, pass) {
  var t = (((pass >> 1) >>> 30) | 0);
  var reverse = ((((3 & ((pass + t) | 0)) - t) | 0) < 2);
  var t$1 = ((pass >>> 31) | 0);
  if (((((1 & ((pass + t$1) | 0)) - t$1) | 0) === 0)) {
    var \u03b423$___1 = ((1 + gMinR$7) | 0);
    var \u03b423$___2 = gMaxR$7;
    var \u03b423$___3 = 1;
  } else {
    var \u03b423$___1 = ((gMaxR$7 - 1) | 0);
    var \u03b423$___2 = gMinR$7;
    var \u03b423$___3 = (-1);
  }
  var first = (\u03b423$___1 | 0);
  var last = (\u03b423$___2 | 0);
  var dir = (\u03b423$___3 | 0);
  var r = first;
  while ((r !== ((last + dir) | 0))) {
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__reorder$2__scm_HashMap__scm_HashMap__sci_Map__sci_Vector__scm_HashMap__I__Z__Z__V($thiz, rows$28, mval$9, clustOf$23, vOrigEnds$23, gpos$51, r, reverse, $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__medians$2__scm_HashMap__scm_HashMap__scm_HashMap__scm_LinkedHashMap__scm_ArrayBuffer__scm_LinkedHashMap__scm_HashMap__scm_HashMap__scm_HashMap__I__I__Z($thiz, rows$28, gpos$51, mval$9, hOut$28, emptyRow$31, hIn$27, hPorts$37, fInC$8, fOutC$8, r, ((r - dir) | 0)));
    r = ((r + dir) | 0);
  }
  $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__transpose$2__I__I__scm_HashMap__scm_HashMap__sci_Map__sci_Vector__scm_HashMap__scm_LinkedHashMap__scm_ArrayBuffer__scm_HashMap__scm_HashMap__scm_LinkedHashMap__Z__V($thiz, gMinR$7, gMaxR$7, candidate$10, rows$28, clustOf$23, vOrigEnds$23, gpos$51, hIn$27, emptyRow$31, hPorts$37, hWeight$34, hOut$28, (!reverse));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__snapshot$2__scm_HashMap__sci_Map($thiz, rows$29) {
  return $m_sci_Map$().ao(new $c_sc_Iterator$$anon$9(rows$29.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var r = (x$1.g() | 0);
    var b = x$1.h();
    return new $c_T2(r, $m_sci_Vector$().X(b));
  }))));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__restore$2__scm_HashMap__scm_HashMap__sci_Map__V($thiz, rows$30, gpos$52, s) {
  s.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var r = (x$1.g() | 0);
    var v = x$1.h();
    var rb = rows$30.i(r);
    $p_scm_ArrayBuffer__reduceToSize__I__V(rb, 0);
    rb.gS(v);
    var this$2 = new $c_sc_Iterator$$anon$16(v.o());
    while (this$2.p()) {
      var x0 = this$2.dC();
      $p_scm_HashMap__put0__O__O__Z__s_Some(gpos$52, x0.g(), (x0.h() | 0), false);
    }
  })));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__link$1__scm_HashMap__O__O__V($thiz, adj$1, a, b) {
  var f = (() => {
    $m_scm_ArrayBuffer$();
    return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  });
  if ((!($objectGetClass(adj$1) === $d_scm_HashMap.l()))) {
    var x1 = adj$1.r(a);
    if ((x1 instanceof $c_s_Some)) {
      var $x_1 = x1.J;
    } else {
      if ((!($m_s_None$() === x1))) {
        throw new $c_s_MatchError(x1);
      }
      var d = f();
      $p_scm_HashMap__put0__O__O__Z__s_Some(adj$1, a, d, false);
      var $x_1 = d;
    }
  } else {
    var originalHash = $m_sr_Statics$().u(a);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var idx = (hash & ((adj$1.S.a.length - 1) | 0));
    var x1$1 = adj$1.S.a[idx];
    var nd = ((x1$1 === null) ? null : x1$1.by(a, hash));
    if ((nd !== null)) {
      var $x_1 = nd.b9;
    } else {
      var table0 = adj$1.S;
      var default$1 = f();
      if ((((1 + adj$1.eh) | 0) >= adj$1.kI)) {
        $p_scm_HashMap__growTable__I__V(adj$1, (adj$1.S.a.length << 1));
      }
      $p_scm_HashMap__put0__O__O__Z__I__I__s_Some(adj$1, a, default$1, false, hash, ((table0 === adj$1.S) ? idx : (hash & ((adj$1.S.a.length - 1) | 0))));
      var $x_1 = default$1;
    }
  }
  $x_1.Y(b);
  var f$1 = (() => {
    $m_scm_ArrayBuffer$();
    return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  });
  if ((!($objectGetClass(adj$1) === $d_scm_HashMap.l()))) {
    var x1$2 = adj$1.r(b);
    if ((x1$2 instanceof $c_s_Some)) {
      var $x_2 = x1$2.J;
    } else {
      if ((!($m_s_None$() === x1$2))) {
        throw new $c_s_MatchError(x1$2);
      }
      var d$1 = f$1();
      $p_scm_HashMap__put0__O__O__Z__s_Some(adj$1, b, d$1, false);
      var $x_2 = d$1;
    }
  } else {
    var originalHash$1 = $m_sr_Statics$().u(b);
    var hash$1 = (originalHash$1 ^ ((originalHash$1 >>> 16) | 0));
    var idx$1 = (hash$1 & ((adj$1.S.a.length - 1) | 0));
    var x1$3 = adj$1.S.a[idx$1];
    var nd$1 = ((x1$3 === null) ? null : x1$3.by(b, hash$1));
    if ((nd$1 !== null)) {
      var $x_2 = nd$1.b9;
    } else {
      var table0$1 = adj$1.S;
      var default$2 = f$1();
      if ((((1 + adj$1.eh) | 0) >= adj$1.kI)) {
        $p_scm_HashMap__growTable__I__V(adj$1, (adj$1.S.a.length << 1));
      }
      $p_scm_HashMap__put0__O__O__Z__I__I__s_Some(adj$1, b, default$2, false, hash$1, ((table0$1 === adj$1.S) ? idx$1 : (hash$1 & ((adj$1.S.a.length - 1) | 0))));
      var $x_2 = default$2;
    }
  }
  $x_2.Y(a);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__install$2__scm_HashMap__sc_Map__scm_HashMap__O__V($thiz, ranks$7, rankOf$18, pos$9, n) {
  var rb = ranks$7.i(rankOf$18.i(n));
  $p_scm_HashMap__put0__O__O__Z__s_Some(pos$9, n, rb.a1, false);
  rb.aw(n);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__fOut$1__scm_HashMap__O__scm_ArrayBuffer($thiz, flOut$2, n) {
  var f = (() => {
    $m_scm_ArrayBuffer$();
    return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  });
  if ((!($objectGetClass(flOut$2) === $d_scm_HashMap.l()))) {
    var x1 = flOut$2.r(n);
    if ((x1 instanceof $c_s_Some)) {
      var $x_1 = x1.J;
    } else {
      if ((!($m_s_None$() === x1))) {
        throw new $c_s_MatchError(x1);
      }
      var $x_1 = f();
    }
  } else {
    var originalHash = $m_sr_Statics$().u(n);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var x1$1 = flOut$2.S.a[(hash & ((flOut$2.S.a.length - 1) | 0))];
    var nd = ((x1$1 === null) ? null : x1$1.by(n, hash));
    var $x_1 = ((nd === null) ? f() : nd.b9);
  }
  return $x_1;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__fIn$1__scm_HashMap__O__scm_ArrayBuffer($thiz, flIn$2, n) {
  var f = (() => {
    $m_scm_ArrayBuffer$();
    return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  });
  if ((!($objectGetClass(flIn$2) === $d_scm_HashMap.l()))) {
    var x1 = flIn$2.r(n);
    if ((x1 instanceof $c_s_Some)) {
      var $x_1 = x1.J;
    } else {
      if ((!($m_s_None$() === x1))) {
        throw new $c_s_MatchError(x1);
      }
      var $x_1 = f();
    }
  } else {
    var originalHash = $m_sr_Statics$().u(n);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var x1$1 = flIn$2.S.a[(hash & ((flIn$2.S.a.length - 1) | 0))];
    var nd = ((x1$1 === null) ? null : x1$1.by(n, hash));
    var $x_1 = ((nd === null) ? f() : nd.b9);
  }
  return $x_1;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__flatRev$1__scm_HashMap__scm_HashMap__scm_HashMap__O__O__V($thiz, flWt$2, flOut$3, flIn$3, t, h) {
  var this$2 = flWt$2.AD(new $c_T2(t, h));
  var w = (+(this$2.c() ? 0.0 : this$2.d()));
  $f_scm_Buffer__subtractOne__O__scm_Buffer($p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__fOut$1__scm_HashMap__O__scm_ArrayBuffer($thiz, flOut$3, t), h);
  $f_scm_Buffer__subtractOne__O__scm_Buffer($p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__fIn$1__scm_HashMap__O__scm_ArrayBuffer($thiz, flIn$3, h), t);
  if ($f_sc_SeqOps__contains__O__Z($p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__fOut$1__scm_HashMap__O__scm_ArrayBuffer($thiz, flOut$3, h), t)) {
    var $x_2 = new $c_T2(h, t);
    var key = new $c_T2(h, t);
    var f = (() => 0.0);
    if ((!($objectGetClass(flWt$2) === $d_scm_HashMap.l()))) {
      var x1 = flWt$2.r(key);
      if ((x1 instanceof $c_s_Some)) {
        var $x_1 = x1.J;
      } else {
        if ((!($m_s_None$() === x1))) {
          throw new $c_s_MatchError(x1);
        }
        var $x_1 = f();
      }
    } else {
      var originalHash = $m_sr_Statics$().u(key);
      var hash = (originalHash ^ ((originalHash >>> 16) | 0));
      var x1$1 = flWt$2.S.a[(hash & ((flWt$2.S.a.length - 1) | 0))];
      var nd = ((x1$1 === null) ? null : x1$1.by(key, hash));
      var $x_1 = ((nd === null) ? f() : nd.b9);
    }
    $p_scm_HashMap__put0__O__O__Z__s_Some(flWt$2, $x_2, ((+$x_1) + w), false);
  } else {
    var f$1 = (() => {
      $m_scm_ArrayBuffer$();
      return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
    });
    if ((!($objectGetClass(flOut$3) === $d_scm_HashMap.l()))) {
      var x1$2 = flOut$3.r(h);
      if ((x1$2 instanceof $c_s_Some)) {
        var $x_3 = x1$2.J;
      } else {
        if ((!($m_s_None$() === x1$2))) {
          throw new $c_s_MatchError(x1$2);
        }
        var d = f$1();
        $p_scm_HashMap__put0__O__O__Z__s_Some(flOut$3, h, d, false);
        var $x_3 = d;
      }
    } else {
      var originalHash$1 = $m_sr_Statics$().u(h);
      var hash$1 = (originalHash$1 ^ ((originalHash$1 >>> 16) | 0));
      var idx = (hash$1 & ((flOut$3.S.a.length - 1) | 0));
      var x1$3 = flOut$3.S.a[idx];
      var nd$1 = ((x1$3 === null) ? null : x1$3.by(h, hash$1));
      if ((nd$1 !== null)) {
        var $x_3 = nd$1.b9;
      } else {
        var table0 = flOut$3.S;
        var default$1 = f$1();
        if ((((1 + flOut$3.eh) | 0) >= flOut$3.kI)) {
          $p_scm_HashMap__growTable__I__V(flOut$3, (flOut$3.S.a.length << 1));
        }
        $p_scm_HashMap__put0__O__O__Z__I__I__s_Some(flOut$3, h, default$1, false, hash$1, ((table0 === flOut$3.S) ? idx : (hash$1 & ((flOut$3.S.a.length - 1) | 0))));
        var $x_3 = default$1;
      }
    }
    $x_3.Y(t);
    var f$2 = (() => {
      $m_scm_ArrayBuffer$();
      return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
    });
    if ((!($objectGetClass(flIn$3) === $d_scm_HashMap.l()))) {
      var x1$4 = flIn$3.r(t);
      if ((x1$4 instanceof $c_s_Some)) {
        var $x_4 = x1$4.J;
      } else {
        if ((!($m_s_None$() === x1$4))) {
          throw new $c_s_MatchError(x1$4);
        }
        var d$1 = f$2();
        $p_scm_HashMap__put0__O__O__Z__s_Some(flIn$3, t, d$1, false);
        var $x_4 = d$1;
      }
    } else {
      var originalHash$2 = $m_sr_Statics$().u(t);
      var hash$2 = (originalHash$2 ^ ((originalHash$2 >>> 16) | 0));
      var idx$1 = (hash$2 & ((flIn$3.S.a.length - 1) | 0));
      var x1$5 = flIn$3.S.a[idx$1];
      var nd$2 = ((x1$5 === null) ? null : x1$5.by(t, hash$2));
      if ((nd$2 !== null)) {
        var $x_4 = nd$2.b9;
      } else {
        var table0$1 = flIn$3.S;
        var default$2 = f$2();
        if ((((1 + flIn$3.eh) | 0) >= flIn$3.kI)) {
          $p_scm_HashMap__growTable__I__V(flIn$3, (flIn$3.S.a.length << 1));
        }
        $p_scm_HashMap__put0__O__O__Z__I__I__s_Some(flIn$3, t, default$2, false, hash$2, ((table0$1 === flIn$3.S) ? idx$1 : (hash$2 & ((flIn$3.S.a.length - 1) | 0))));
        var $x_4 = default$2;
      }
    }
    $x_4.Y(h);
    $p_scm_HashMap__put0__O__O__Z__s_Some(flWt$2, new $c_T2(h, t), w, false);
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__left2right$1__scm_HashMap__sc_Map__Z__scm_HashMap__O__O__Z($thiz, flatMx$1, rankOf$19, flip$2, flatIdx$1, v, w) {
  var x229 = flatMx$1.r(rankOf$19.i(v));
  if (($m_s_None$() === x229)) {
    return false;
  }
  if ((x229 instanceof $c_s_Some)) {
    var m = x229.J;
    if (flip$2) {
      var \u03b424$___1 = w;
      var \u03b424$___2 = v;
    } else {
      var \u03b424$___1 = v;
      var \u03b424$___2 = w;
    }
    var a = \u03b424$___1;
    var b = \u03b424$___2;
    var _1 = flatIdx$1.r(a);
    var _2 = flatIdx$1.r(b);
    if ((_1 instanceof $c_s_Some)) {
      var ia = (_1.J | 0);
      if ((_2 instanceof $c_s_Some)) {
        var ib = (_2.J | 0);
        return m.E(new $c_T2(ia, ib));
      }
    }
    return false;
  }
  throw new $c_s_MatchError(x229);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__search$1__scm_Set__scm_Set__scm_HashMap__scm_HashSet__scm_HashMap__scm_HashMap__scm_HashMap__O__V($thiz, fmark$2, onstack$2, flWt$5, m$1, flatIdx$5, flOut$7, flIn$6, v) {
  fmark$2.Y(v);
  onstack$2.Y(v);
  var lst = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__fOut$1__scm_HashMap__O__scm_ArrayBuffer($thiz, flOut$7, v);
  var i = 0;
  while ((i < lst.a1)) {
    var h = lst.l(i);
    var key = new $c_T2(v, h);
    var f = (() => 0.0);
    if ((!($objectGetClass(flWt$5) === $d_scm_HashMap.l()))) {
      var x1 = flWt$5.r(key);
      if ((x1 instanceof $c_s_Some)) {
        var $x_1 = x1.J;
      } else {
        if ((!($m_s_None$() === x1))) {
          throw new $c_s_MatchError(x1);
        }
        var $x_1 = f();
      }
    } else {
      var originalHash = $m_sr_Statics$().u(key);
      var hash = (originalHash ^ ((originalHash >>> 16) | 0));
      var x1$1 = flWt$5.S.a[(hash & ((flWt$5.S.a.length - 1) | 0))];
      var nd = ((x1$1 === null) ? null : x1$1.by(key, hash));
      var $x_1 = ((nd === null) ? f() : nd.b9);
    }
    if (((+$x_1) === 0.0)) {
      i = ((1 + i) | 0);
    } else if (onstack$2.E(h)) {
      m$1.oA(new $c_T2(flatIdx$5.i(h), flatIdx$5.i(v)));
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__flatRev$1__scm_HashMap__scm_HashMap__scm_HashMap__O__O__V($thiz, flWt$5, flOut$7, flIn$6, v, h);
    } else {
      m$1.oA(new $c_T2(flatIdx$5.i(v), flatIdx$5.i(h)));
      if ((!fmark$2.E(h))) {
        $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__search$1__scm_Set__scm_Set__scm_HashMap__scm_HashSet__scm_HashMap__scm_HashMap__scm_HashMap__O__V($thiz, fmark$2, onstack$2, flWt$5, m$1, flatIdx$5, flOut$7, flIn$6, h);
      }
      i = ((1 + i) | 0);
    }
  }
  onstack$2.re(v);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__flatBreakcycles$1__Z__I__I__scm_HashMap__scm_HashMap__scm_HashMap__scm_HashMap__scm_HashMap__scm_HashMap__V($thiz, hasFlat$1, minR$1, maxR$1, ranks$8, flatIdx$2, flatMx$2, flWt$3, flOut$4, flIn$4) {
  if (hasFlat$1) {
    var fmark = $m_scm_Set$().aO();
    var onstack = $m_scm_Set$().aO();
    if ((!(minR$1 > maxR$1))) {
      var i = minR$1;
      while (true) {
        var x0 = i;
        var rb = ranks$8.i(x0);
        var elem = false;
        elem = false;
        var this$7 = new $c_sc_Iterator$$anon$16(rb.bB().o());
        while (this$7.p()) {
          var x0$1 = this$7.dC();
          var v = x0$1.g();
          $p_scm_HashMap__put0__O__O__Z__s_Some(flatIdx$2, v, (x0$1.h() | 0), false);
          if ((!$f_sc_SeqOps__isEmpty__Z($p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__fOut$1__scm_HashMap__O__scm_ArrayBuffer($thiz, flOut$4, v)))) {
            elem = true;
          }
        }
        if (elem) {
          var f = (() => $ct_scm_HashSet__(new $c_scm_HashSet()));
          if ((!($objectGetClass(flatMx$2) === $d_scm_HashMap.l()))) {
            var x1 = flatMx$2.r(x0);
            if ((x1 instanceof $c_s_Some)) {
              var $x_1 = x1.J;
            } else {
              if ((!($m_s_None$() === x1))) {
                throw new $c_s_MatchError(x1);
              }
              var d = f();
              $p_scm_HashMap__put0__O__O__Z__s_Some(flatMx$2, x0, d, false);
              var $x_1 = d;
            }
          } else {
            var originalHash = $m_sr_Statics$().u(x0);
            var hash = (originalHash ^ ((originalHash >>> 16) | 0));
            var idx = (hash & ((flatMx$2.S.a.length - 1) | 0));
            var x1$1 = flatMx$2.S.a[idx];
            var nd = ((x1$1 === null) ? null : x1$1.by(x0, hash));
            if ((nd !== null)) {
              var $x_1 = nd.b9;
            } else {
              var table0 = flatMx$2.S;
              var default$1 = f();
              if ((((1 + flatMx$2.eh) | 0) >= flatMx$2.kI)) {
                $p_scm_HashMap__growTable__I__V(flatMx$2, (flatMx$2.S.a.length << 1));
              }
              $p_scm_HashMap__put0__O__O__Z__I__I__s_Some(flatMx$2, x0, default$1, false, hash, ((table0 === flatMx$2.S) ? idx : (hash & ((flatMx$2.S.a.length - 1) | 0))));
              var $x_1 = default$1;
            }
          }
          var m = $x_1;
          var it = rb.bB().o();
          while (it.p()) {
            var x0$2 = it.q();
            if ((!fmark.E(x0$2))) {
              $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__search$1__scm_Set__scm_Set__scm_HashMap__scm_HashSet__scm_HashMap__scm_HashMap__scm_HashMap__O__V($thiz, fmark, onstack, flWt$3, m, flatIdx$2, flOut$4, flIn$4, x0$2);
            }
          }
        }
        if ((i === maxR$1)) {
          break;
        }
        i = ((1 + i) | 0);
      }
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__constraining$1__scm_HashMap__O__O__Z($thiz, flWt$9, t, h) {
  var key = new $c_T2(t, h);
  var f = (() => 0.0);
  if ((!($objectGetClass(flWt$9) === $d_scm_HashMap.l()))) {
    var x1 = flWt$9.r(key);
    if ((x1 instanceof $c_s_Some)) {
      var $x_1 = x1.J;
    } else {
      if ((!($m_s_None$() === x1))) {
        throw new $c_s_MatchError(x1);
      }
      var $x_1 = f();
    }
  } else {
    var originalHash = $m_sr_Statics$().u(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var x1$1 = flWt$9.S.a[(hash & ((flWt$9.S.a.length - 1) | 0))];
    var nd = ((x1$1 === null) ? null : x1$1.by(key, hash));
    var $x_1 = ((nd === null) ? f() : nd.b9);
  }
  return ((+$x_1) !== 0.0);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__post$1__scm_Set__scm_ArrayBuffer__scm_HashMap__scm_HashMap__O__V($thiz, fmark$4, temp$1, flOut$11, flWt$10, v) {
  fmark$4.Y(v);
  var this$1 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__fOut$1__scm_HashMap__O__scm_ArrayBuffer($thiz, flOut$11, v);
  var it = this$1.bB().o();
  while (it.p()) {
    var x0 = it.q();
    if (($p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__constraining$1__scm_HashMap__O__O__Z($thiz, flWt$10, v, x0) && (!fmark$4.E(x0)))) {
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__post$1__scm_Set__scm_ArrayBuffer__scm_HashMap__scm_HashMap__O__V($thiz, fmark$4, temp$1, flOut$11, flWt$10, x0);
    }
  }
  temp$1.aw(v);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__flatReorder$1__Z__I__I__scm_HashMap__scm_HashMap__Z__scm_HashMap__scm_HashMap__scm_HashMap__V($thiz, hasFlat$2, minR$2, maxR$2, ranks$10, flWt$7, flip$3, pos$10, flOut$9, flIn$8) {
  if (hasFlat$2) {
    if ((!(minR$2 > maxR$2))) {
      var i = minR$2;
      while (true) {
        var x0 = i;
        var rb = ranks$10.i(x0);
        if ((!$f_sc_SeqOps__isEmpty__Z(rb))) {
          var fmark = $m_scm_Set$().aO();
          $m_scm_ArrayBuffer$();
          var temp = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
          var n = rb.a1;
          var i$1 = 0;
          while ((i$1 < n)) {
            var v = (flip$3 ? rb.l(i$1) : rb.l(((((n - 1) | 0) - i$1) | 0)));
            var this$6 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__fIn$1__scm_HashMap__O__scm_ArrayBuffer($thiz, flIn$8, v);
            var res = 0;
            var it = this$6.bB().o();
            while (it.p()) {
              if ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__constraining$1__scm_HashMap__O__O__Z($thiz, flWt$7, it.q(), v)) {
                res = ((1 + res) | 0);
              }
            }
            var inCnt = res;
            var this$7 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__fOut$1__scm_HashMap__O__scm_ArrayBuffer($thiz, flOut$9, v);
            var res$1 = 0;
            var it$1 = this$7.bB().o();
            while (it$1.p()) {
              if ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__constraining$1__scm_HashMap__O__O__Z($thiz, flWt$7, v, it$1.q())) {
                res$1 = ((1 + res$1) | 0);
              }
            }
            if (((inCnt | res$1) === 0)) {
              temp.aw(v);
            } else if (((!fmark.E(v)) && (inCnt === 0))) {
              $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__post$1__scm_Set__scm_ArrayBuffer__scm_HashMap__scm_HashMap__O__V($thiz, fmark, temp, flOut$9, flWt$7, v);
            }
            i$1 = ((1 + i$1) | 0);
          }
          if (((!$f_sc_SeqOps__isEmpty__Z(temp)) && (temp.a1 === rb.a1))) {
            if ((!flip$3)) {
              var a = 0;
              var b = ((temp.a1 - 1) | 0);
              while ((a < b)) {
                var t$2 = temp.l(a);
                temp.cM(a, temp.l(b));
                temp.cM(b, t$2);
                a = ((1 + a) | 0);
                b = ((b - 1) | 0);
              }
            }
            var end = rb.a1;
            var isEmpty$1 = (end <= 0);
            var scala$collection$immutable$Range$$lastElement = ((end - 1) | 0);
            if ((!isEmpty$1)) {
              var i$2 = 0;
              while (true) {
                var x0$3 = i$2;
                rb.cM(x0$3, temp.l(x0$3));
                $p_scm_HashMap__put0__O__O__Z__s_Some(pos$10, rb.l(x0$3), x0$3, false);
                if ((i$2 === scala$collection$immutable$Range$$lastElement)) {
                  break;
                }
                i$2 = ((1 + i$2) | 0);
              }
            }
            var vi = 0;
            while ((vi < rb.a1)) {
              var v$4 = rb.l(vi);
              var lst = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__fOut$1__scm_HashMap__O__scm_ArrayBuffer($thiz, flOut$9, v$4);
              var j = 0;
              while ((j < lst.a1)) {
                var h$2 = lst.l(j);
                if ((((!flip$3) && ((pos$10.i(h$2) | 0) < (pos$10.i(v$4) | 0))) || (flip$3 && ((pos$10.i(h$2) | 0) > (pos$10.i(v$4) | 0))))) {
                  $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__flatRev$1__scm_HashMap__scm_HashMap__scm_HashMap__O__O__V($thiz, flWt$7, flOut$9, flIn$8, v$4, h$2);
                } else {
                  j = ((1 + j) | 0);
                }
              }
              vi = ((1 + vi) | 0);
            }
          }
        }
        if ((i === maxR$2)) {
          break;
        }
        i = ((1 + i) | 0);
      }
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__enq$1__I__sc_Map__sc_Map__scm_Set__scm_Queue__O__V($thiz, pass$1, out$13, in$12, mark$5, q$3, n0) {
  var this$1 = ((pass$1 === 0) ? out$13.i(n0) : in$12.i(n0));
  var it = this$1.bB().o();
  while (it.p()) {
    var x0 = it.q();
    if ((!mark$5.E(x0))) {
      mark$5.Y(x0);
      q$3.km(x0);
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__handle$1__F1__scm_Set__F1__scm_HashMap__sc_Map__scm_HashMap__I__sc_Map__sc_Map__scm_Set__scm_Queue__O__V($thiz, columnOf$3, colInstalled$1, columnNodes$3, ranks$13, rankOf$21, pos$14, pass$2, out$14, in$13, mark$7, q$5, n0) {
  var x232 = columnOf$3.i(n0);
  if ((x232 instanceof $c_s_Some)) {
    var ci = (x232.J | 0);
    if ((!colInstalled$1.E(ci))) {
      colInstalled$1.Y(ci);
      var col = columnNodes$3.i(ci);
      col.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n) => {
        $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__install$2__scm_HashMap__sc_Map__scm_HashMap__O__V($thiz, ranks$13, rankOf$21, pos$14, n);
      })));
      col.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n0$2) => {
        $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__enq$1__I__sc_Map__sc_Map__scm_Set__scm_Queue__O__V($thiz, pass$2, out$14, in$13, mark$7, q$5, n0$2);
      })));
      return (void 0);
    } else {
      return (void 0);
    }
  }
  if (($m_s_None$() === x232)) {
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__install$2__scm_HashMap__sc_Map__scm_HashMap__O__V($thiz, ranks$13, rankOf$21, pos$14, n0);
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__enq$1__I__sc_Map__sc_Map__scm_Set__scm_Queue__O__V($thiz, pass$2, out$14, in$13, mark$7, q$5, n0);
    return (void 0);
  }
  throw new $c_s_MatchError(x232);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__buildRanks$1__scm_HashMap__scm_HashMap__scm_Set__sc_Map__sc_Map__F1__F1__sci_Vector__Z__sc_Map__I__V($thiz, ranks$12, pos$13, mark$4, out$12, in$11, columnOf$2, columnNodes$2, nlist$2, flip$5, rankOf$20, pass) {
  var this$1 = ranks$12.hr();
  while (this$1.p()) {
    $p_scm_ArrayBuffer__reduceToSize__I__V(this$1.q(), 0);
  }
  pos$13.ie();
  mark$4.ie();
  var colInstalled = $m_scm_Set$().aO();
  var q = $ct_scm_Queue__I__(new $c_scm_Queue(), 16);
  nlist$2.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((root) => {
    if ((((pass === 0) ? in$11.i(root).c() : out$12.i(root).c()) && (!mark$4.E(root)))) {
      mark$4.Y(root);
      q.km(root);
      while ((!q.c())) {
        $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__handle$1__F1__scm_Set__F1__scm_HashMap__sc_Map__scm_HashMap__I__sc_Map__sc_Map__scm_Set__scm_Queue__O__V($thiz, columnOf$2, colInstalled, columnNodes$2, ranks$12, rankOf$20, pos$13, pass, out$12, in$11, mark$4, q, q.h7(false));
      }
    }
  })));
  nlist$2.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n) => {
    if ((!mark$4.E(n))) {
      mark$4.Y(n);
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__handle$1__F1__scm_Set__F1__scm_HashMap__sc_Map__scm_HashMap__I__sc_Map__sc_Map__scm_Set__scm_Queue__O__V($thiz, columnOf$2, colInstalled, columnNodes$2, ranks$12, rankOf$20, pos$13, pass, out$12, in$11, mark$4, q, n);
      while ((!q.c())) {
        $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__handle$1__F1__scm_Set__F1__scm_HashMap__sc_Map__scm_HashMap__I__sc_Map__sc_Map__scm_Set__scm_Queue__O__V($thiz, columnOf$2, colInstalled, columnNodes$2, ranks$12, rankOf$20, pos$13, pass, out$12, in$11, mark$4, q, q.h7(false));
      }
    }
  })));
  if (flip$5) {
    var this$4 = ranks$12.hr();
    while (this$4.p()) {
      var x0$1 = this$4.q();
      var n$1 = x0$1.a1;
      var i = 0;
      while ((i < (((n$1 + ((n$1 >>> 31) | 0)) | 0) >> 1))) {
        var t = x0$1.l(i);
        x0$1.cM(i, x0$1.l(((((n$1 - 1) | 0) - i) | 0)));
        x0$1.cM(((((n$1 - 1) | 0) - i) | 0), t);
        i = ((1 + i) | 0);
      }
      var this$6 = new $c_sc_Iterator$$anon$16(x0$1.bB().o());
      while (this$6.p()) {
        var x0$2 = this$6.dC();
        matchResult64: {
          if ((x0$2 !== null)) {
            $p_scm_HashMap__put0__O__O__Z__s_Some(pos$13, x0$2.g(), (x0$2.h() | 0), false);
            break matchResult64;
          }
          throw new $c_s_MatchError(x0$2);
        }
      }
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__bilayer$1__scm_HashMap__sc_Map__scm_HashMap__F2__I__J($thiz, ranks$16, out$17, pos$19, weight$2, r) {
  $m_scm_ArrayBuffer$();
  var segs = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  var f = (() => {
    $m_scm_ArrayBuffer$();
    return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  });
  if ((!($objectGetClass(ranks$16) === $d_scm_HashMap.l()))) {
    var x1 = ranks$16.r(r);
    if ((x1 instanceof $c_s_Some)) {
      var $x_1 = x1.J;
    } else {
      if ((!($m_s_None$() === x1))) {
        throw new $c_s_MatchError(x1);
      }
      var $x_1 = f();
    }
  } else {
    var originalHash = $m_sr_Statics$().u(r);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var x1$1 = ranks$16.S.a[(hash & ((ranks$16.S.a.length - 1) | 0))];
    var nd = ((x1$1 === null) ? null : x1$1.by(r, hash));
    var $x_1 = ((nd === null) ? f() : nd.b9);
  }
  $x_1.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((u) => {
    out$17.i(u).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((w) => segs.aw(new $c_T3(pos$19.i(u), pos$19.i(w), weight$2.R(u, w))))));
  })));
  var c_$_lo = 0;
  var c_$_hi = 0;
  var i = 0;
  while ((i < segs.a1)) {
    var j = ((1 + i) | 0);
    while ((j < segs.a1)) {
      matchResult65: {
        var \u03b425$___1;
        var \u03b425$___2;
        var \u03b425$___3;
        var x238 = segs.l(i);
        if ((x238 !== null)) {
          var $x_4 = x238.bH;
          var $x_3 = x238.bU;
          var $x_2 = $uJ(x238.c3);
          var \u03b425$___1 = ($x_4 | 0);
          var \u03b425$___2 = ($x_3 | 0);
          var \u03b425$___3 = $x_2;
          break matchResult65;
        }
        throw new $c_s_MatchError(x238);
      }
      var ui$2 = (\u03b425$___1 | 0);
      var wi$2 = (\u03b425$___2 | 0);
      var $x_5 = $uJ(\u03b425$___3);
      var xi$2_$_lo = $x_5.l;
      var xi$2_$_hi = $x_5.h;
      matchResult66: {
        var \u03b426$___1;
        var \u03b426$___2;
        var \u03b426$___3;
        var x242 = segs.l(j);
        if ((x242 !== null)) {
          var $x_8 = x242.bH;
          var $x_7 = x242.bU;
          var $x_6 = $uJ(x242.c3);
          var \u03b426$___1 = ($x_8 | 0);
          var \u03b426$___2 = ($x_7 | 0);
          var \u03b426$___3 = $x_6;
          break matchResult66;
        }
        throw new $c_s_MatchError(x242);
      }
      var uj$2 = (\u03b426$___1 | 0);
      var wj$2 = (\u03b426$___2 | 0);
      var $x_9 = $uJ(\u03b426$___3);
      var xj$2_$_lo = $x_9.l;
      var xj$2_$_hi = $x_9.h;
      if ((Math.imul(((ui$2 - uj$2) | 0), ((wi$2 - wj$2) | 0)) < 0)) {
        var x$2_$_lo = c_$_lo;
        var x$2_$_hi = c_$_hi;
        var a0 = (65535 & xi$2_$_lo);
        var a1 = ((xi$2_$_lo >>> 16) | 0);
        var b0 = (65535 & xj$2_$_lo);
        var b1 = ((xj$2_$_lo >>> 16) | 0);
        var a0b0 = Math.imul(a0, b0);
        var a1b0 = Math.imul(a1, b0);
        var a0b1 = Math.imul(a0, b1);
        var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi = ((((((((Math.imul(xi$2_$_lo, xj$2_$_hi) + Math.imul(xi$2_$_hi, xj$2_$_lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
        var lo$1 = ((x$2_$_lo + lo) | 0);
        var hi$1 = ((((x$2_$_hi + hi) | 0) + (((lo$1 >>> 0) < (x$2_$_lo >>> 0)) | 0)) | 0);
        c_$_lo = lo$1;
        c_$_hi = hi$1;
      }
      j = ((1 + j) | 0);
    }
    i = ((1 + i) | 0);
  }
  return $bL(c_$_lo, c_$_hi);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__localOut$1__sc_Map__scm_HashMap__F2__F2__O__J($thiz, out$19, pos$22, segPorts$5, weight$5, v) {
  var os = out$19.ay(v, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $m_scm_ArrayBuffer$();
    return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  })));
  var c_$_lo = 0;
  var c_$_hi = 0;
  var i = 0;
  while ((i < os.a1)) {
    var j = ((1 + i) | 0);
    while ((j < os.a1)) {
      var e = os.l(i);
      var f = os.l(j);
      var this$3 = new $c_sr_RichInt((((pos$22.i(f) | 0) - (pos$22.i(e) | 0)) | 0));
      var x$1 = this$3.ns;
      var this$9 = new $c_sr_RichDouble((segPorts$5.R(v, f).o0 - segPorts$5.R(v, e).o0));
      var x$3 = this$9.kk;
      if (((((x$1 >> 31) | ((((-x$1) | 0) >>> 31) | 0)) * ((x$3 > 0.0) ? 1.0 : ((x$3 < 0.0) ? (-1.0) : x$3))) < 0.0)) {
        var x$6_$_lo = c_$_lo;
        var x$6_$_hi = c_$_hi;
        var $x_1 = $uJ(weight$5.R(v, e));
        var x$4_$_lo = $x_1.l;
        var x$4_$_hi = $x_1.h;
        var $x_2 = $uJ(weight$5.R(v, f));
        var x$5_$_lo = $x_2.l;
        var x$5_$_hi = $x_2.h;
        var a0 = (65535 & x$4_$_lo);
        var a1 = ((x$4_$_lo >>> 16) | 0);
        var b0 = (65535 & x$5_$_lo);
        var b1 = ((x$5_$_lo >>> 16) | 0);
        var a0b0 = Math.imul(a0, b0);
        var a1b0 = Math.imul(a1, b0);
        var a0b1 = Math.imul(a0, b1);
        var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi = ((((((((Math.imul(x$4_$_lo, x$5_$_hi) + Math.imul(x$4_$_hi, x$5_$_lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
        var lo$1 = ((x$6_$_lo + lo) | 0);
        var hi$1 = ((((x$6_$_hi + hi) | 0) + (((lo$1 >>> 0) < (x$6_$_lo >>> 0)) | 0)) | 0);
        c_$_lo = lo$1;
        c_$_hi = hi$1;
      }
      j = ((1 + j) | 0);
    }
    i = ((1 + i) | 0);
  }
  return $bL(c_$_lo, c_$_hi);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__localIn$1__sc_Map__scm_HashMap__F2__F2__O__J($thiz, in$16, pos$23, segPorts$6, weight$6, v) {
  var is0 = in$16.ay(v, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $m_scm_ArrayBuffer$();
    return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  })));
  var c_$_lo = 0;
  var c_$_hi = 0;
  var i = 0;
  while ((i < is0.a1)) {
    var j = ((1 + i) | 0);
    while ((j < is0.a1)) {
      var e = is0.l(i);
      var f = is0.l(j);
      var this$3 = new $c_sr_RichInt((((pos$23.i(f) | 0) - (pos$23.i(e) | 0)) | 0));
      var x$1 = this$3.ns;
      var this$9 = new $c_sr_RichDouble((segPorts$6.R(f, v).nZ - segPorts$6.R(e, v).nZ));
      var x$3 = this$9.kk;
      if (((((x$1 >> 31) | ((((-x$1) | 0) >>> 31) | 0)) * ((x$3 > 0.0) ? 1.0 : ((x$3 < 0.0) ? (-1.0) : x$3))) < 0.0)) {
        var x$6_$_lo = c_$_lo;
        var x$6_$_hi = c_$_hi;
        var $x_1 = $uJ(weight$6.R(e, v));
        var x$4_$_lo = $x_1.l;
        var x$4_$_hi = $x_1.h;
        var $x_2 = $uJ(weight$6.R(f, v));
        var x$5_$_lo = $x_2.l;
        var x$5_$_hi = $x_2.h;
        var a0 = (65535 & x$4_$_lo);
        var a1 = ((x$4_$_lo >>> 16) | 0);
        var b0 = (65535 & x$5_$_lo);
        var b1 = ((x$5_$_lo >>> 16) | 0);
        var a0b0 = Math.imul(a0, b0);
        var a1b0 = Math.imul(a1, b0);
        var a0b1 = Math.imul(a0, b1);
        var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi = ((((((((Math.imul(x$4_$_lo, x$5_$_hi) + Math.imul(x$4_$_hi, x$5_$_lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
        var lo$1 = ((x$6_$_lo + lo) | 0);
        var hi$1 = ((((x$6_$_hi + hi) | 0) + (((lo$1 >>> 0) < (x$6_$_lo >>> 0)) | 0)) | 0);
        c_$_lo = lo$1;
        c_$_hi = hi$1;
      }
      j = ((1 + j) | 0);
    }
    i = ((1 + i) | 0);
  }
  return $bL(c_$_lo, c_$_hi);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__ncross$1__I__I__scm_HashMap__F1__sc_Map__scm_HashMap__F2__F2__sc_Map__J($thiz, minR$3, maxR$3, ranks$17, hasPort$7, out$20, pos$24, weight$7, segPorts$7, in$17) {
  return $uJ($f_sc_IterableOnceOps__sum__s_math_Numeric__O(new $c_sc_Iterator$$anon$9(new $c_sci_RangeIterator(minR$3, 1, ((maxR$3 - 1) | 0), (minR$3 >= maxR$3)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((r) => {
    var r$1 = (r | 0);
    var $x_1 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__bilayer$1__scm_HashMap__sc_Map__scm_HashMap__F2__I__J($thiz, ranks$17, out$20, pos$24, weight$7, r$1);
    var c = new $c_sr_LongRef($x_1.l, $x_1.h);
    var f = (() => {
      $m_scm_ArrayBuffer$();
      return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
    });
    if ((!($objectGetClass(ranks$17) === $d_scm_HashMap.l()))) {
      var x1 = ranks$17.r(r$1);
      if ((x1 instanceof $c_s_Some)) {
        var $x_2 = x1.J;
      } else {
        if ((!($m_s_None$() === x1))) {
          throw new $c_s_MatchError(x1);
        }
        var $x_2 = f();
      }
    } else {
      var originalHash = $m_sr_Statics$().u(r$1);
      var hash = (originalHash ^ ((originalHash >>> 16) | 0));
      var x1$1 = ranks$17.S.a[(hash & ((ranks$17.S.a.length - 1) | 0))];
      var nd = ((x1$1 === null) ? null : x1$1.by(r$1, hash));
      var $x_2 = ((nd === null) ? f() : nd.b9);
    }
    $x_2.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v$1) => {
      if ((!(!hasPort$7.i(v$1)))) {
        var x$2_$_lo = c.ji;
        var x$2_$_hi = c.jj;
        var $x_3 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__localOut$1__sc_Map__scm_HashMap__F2__F2__O__J($thiz, out$20, pos$24, segPorts$7, weight$7, v$1);
        var x$3_$_lo = $x_3.l;
        var x$3_$_hi = $x_3.h;
        var lo = ((x$2_$_lo + x$3_$_lo) | 0);
        var hi = ((((x$2_$_hi + x$3_$_hi) | 0) + (((lo >>> 0) < (x$2_$_lo >>> 0)) | 0)) | 0);
        c.ji = lo;
        c.jj = hi;
      }
    })));
    var key = ((1 + r$1) | 0);
    var f$1 = (() => {
      $m_scm_ArrayBuffer$();
      return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
    });
    if ((!($objectGetClass(ranks$17) === $d_scm_HashMap.l()))) {
      var x1$2 = ranks$17.r(key);
      if ((x1$2 instanceof $c_s_Some)) {
        var $x_4 = x1$2.J;
      } else {
        if ((!($m_s_None$() === x1$2))) {
          throw new $c_s_MatchError(x1$2);
        }
        var $x_4 = f$1();
      }
    } else {
      var originalHash$1 = $m_sr_Statics$().u(key);
      var hash$1 = (originalHash$1 ^ ((originalHash$1 >>> 16) | 0));
      var x1$3 = ranks$17.S.a[(hash$1 & ((ranks$17.S.a.length - 1) | 0))];
      var nd$1 = ((x1$3 === null) ? null : x1$3.by(key, hash$1));
      var $x_4 = ((nd$1 === null) ? f$1() : nd$1.b9);
    }
    $x_4.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v$2$1) => {
      if ((!(!hasPort$7.i(v$2$1)))) {
        var x$6_$_lo = c.ji;
        var x$6_$_hi = c.jj;
        var $x_5 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__localIn$1__sc_Map__scm_HashMap__F2__F2__O__J($thiz, in$17, pos$24, segPorts$7, weight$7, v$2$1);
        var x$7_$_lo = $x_5.l;
        var x$7_$_hi = $x_5.h;
        var lo$1 = ((x$6_$_lo + x$7_$_lo) | 0);
        var hi$1 = ((((x$6_$_hi + x$7_$_hi) | 0) + (((lo$1 >>> 0) < (x$6_$_lo >>> 0)) | 0)) | 0);
        c.ji = lo$1;
        c.jj = hi$1;
      }
    })));
    return $bL(c.ji, c.jj);
  }))), $m_s_math_Numeric$LongIsIntegral$()));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__exchange$3__scm_HashMap__scm_HashMap__I__I__I__V($thiz, ranks$19, pos$28, r, i, j) {
  var rb = ranks$19.i(r);
  var a = rb.l(i);
  var b = rb.l(j);
  rb.cM(i, b);
  rb.cM(j, a);
  $p_scm_HashMap__put0__O__O__Z__s_Some(pos$28, a, j, false);
  $p_scm_HashMap__put0__O__O__Z__s_Some(pos$28, b, i, false);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__flatMval$1__scm_HashMap__scm_HashMap__scm_HashMap__scm_HashMap__O__Z($thiz, pos$29, mval$10, flIn$10, flOut$13, n) {
  var fin = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__fIn$1__scm_HashMap__O__scm_ArrayBuffer($thiz, flIn$10, n);
  if ((!$f_sc_SeqOps__isEmpty__Z(fin))) {
    var elem = fin.l(0);
    var elem$1 = null;
    elem$1 = elem;
    var it = fin.bB().o();
    while (it.p()) {
      var x0 = it.q();
      if (((pos$29.i(x0) | 0) > (pos$29.i(elem$1) | 0))) {
        elem$1 = x0;
      }
    }
    var key = elem$1;
    var f = (() => (-1.0));
    if ((!($objectGetClass(mval$10) === $d_scm_HashMap.l()))) {
      var x1 = mval$10.r(key);
      if ((x1 instanceof $c_s_Some)) {
        var $x_1 = x1.J;
      } else {
        if ((!($m_s_None$() === x1))) {
          throw new $c_s_MatchError(x1);
        }
        var $x_1 = f();
      }
    } else {
      var originalHash = $m_sr_Statics$().u(key);
      var hash = (originalHash ^ ((originalHash >>> 16) | 0));
      var x1$1 = mval$10.S.a[(hash & ((mval$10.S.a.length - 1) | 0))];
      var nd = ((x1$1 === null) ? null : x1$1.by(key, hash));
      var $x_1 = ((nd === null) ? f() : nd.b9);
    }
    if ((!((+$x_1) >= 0.0))) {
      return true;
    } else {
      $p_scm_HashMap__put0__O__O__Z__s_Some(mval$10, n, ((+mval$10.i(elem$1)) + 1.0), false);
      return false;
    }
  } else {
    var fout = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__fOut$1__scm_HashMap__O__scm_ArrayBuffer($thiz, flOut$13, n);
    if ($f_sc_SeqOps__isEmpty__Z(fout)) {
      return true;
    } else {
      var elem$2 = fout.l(0);
      var elem$3 = null;
      elem$3 = elem$2;
      var it$1 = fout.bB().o();
      while (it$1.p()) {
        var x0$1 = it$1.q();
        if (((pos$29.i(x0$1) | 0) < (pos$29.i(elem$3) | 0))) {
          elem$3 = x0$1;
        }
      }
      var key$1 = elem$3;
      var f$1 = (() => (-1.0));
      if ((!($objectGetClass(mval$10) === $d_scm_HashMap.l()))) {
        var x1$2 = mval$10.r(key$1);
        if ((x1$2 instanceof $c_s_Some)) {
          var $x_2 = x1$2.J;
        } else {
          if ((!($m_s_None$() === x1$2))) {
            throw new $c_s_MatchError(x1$2);
          }
          var $x_2 = f$1();
        }
      } else {
        var originalHash$1 = $m_sr_Statics$().u(key$1);
        var hash$1 = (originalHash$1 ^ ((originalHash$1 >>> 16) | 0));
        var x1$3 = mval$10.S.a[(hash$1 & ((mval$10.S.a.length - 1) | 0))];
        var nd$1 = ((x1$3 === null) ? null : x1$3.by(key$1, hash$1));
        var $x_2 = ((nd$1 === null) ? f$1() : nd$1.b9);
      }
      if ((!((+$x_2) > 0.0))) {
        return true;
      } else {
        $p_scm_HashMap__put0__O__O__Z__s_Some(mval$10, n, ((+mval$10.i(elem$3)) - 1.0), false);
        return false;
      }
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__medians$3__scm_HashMap__sc_Map__scm_HashMap__F2__sc_Map__scm_HashMap__scm_HashMap__scm_HashMap__I__I__Z($thiz, ranks$20, out$23, pos$32, segPorts$11, in$20, mval$11, flIn$11, flOut$14, r0, r1) {
  var f = (() => {
    $m_scm_ArrayBuffer$();
    return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  });
  if ((!($objectGetClass(ranks$20) === $d_scm_HashMap.l()))) {
    var x1 = ranks$20.r(r0);
    if ((x1 instanceof $c_s_Some)) {
      var $x_1 = x1.J;
    } else {
      if ((!($m_s_None$() === x1))) {
        throw new $c_s_MatchError(x1);
      }
      var $x_1 = f();
    }
  } else {
    var originalHash = $m_sr_Statics$().u(r0);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var x1$1 = ranks$20.S.a[(hash & ((ranks$20.S.a.length - 1) | 0))];
    var nd = ((x1$1 === null) ? null : x1$1.by(r0, hash));
    var $x_1 = ((nd === null) ? f() : nd.b9);
  }
  var rb = $x_1;
  var it = rb.bB().o();
  while (it.p()) {
    var x0 = it.q();
    var nbrs = $f_sc_SeqOps__sorted__s_math_Ordering__O(((r1 > r0) ? out$23.i(x0).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((pos$32, segPorts$11, x0) => ((w) => ((((pos$32.i(w) | 0) << 8) + segPorts$11.R(x0, w).Bo) | 0)))(pos$32, segPorts$11, x0))) : in$20.i(x0).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((pos$32, segPorts$11, x0) => ((x$2) => ((((pos$32.i(x$2) | 0) << 8) + segPorts$11.R(x$2, x0).Bp) | 0)))(pos$32, segPorts$11, x0)))), $m_s_math_Ordering$Int$());
    var $x_2;
    var x246 = nbrs.a1;
    switch (x246) {
      case 0: {
        var $x_2 = (-1.0);
        break;
      }
      case 1: {
        var $x_2 = (nbrs.l(0) | 0);
        break;
      }
      case 2: {
        var num = (((nbrs.l(0) | 0) + (nbrs.l(1) | 0)) | 0);
        var $x_2 = (((num + ((num >>> 31) | 0)) | 0) >> 1);
        break;
      }
      default: {
        var rm = (((x246 + ((x246 >>> 31) | 0)) | 0) >> 1);
        var t = ((x246 >>> 31) | 0);
        if (((((1 & ((x246 + t) | 0)) - t) | 0) === 1)) {
          var $x_2 = (nbrs.l(rm) | 0);
        } else {
          var lm = ((rm - 1) | 0);
          var rspan = (((nbrs.l(((x246 - 1) | 0)) | 0) - (nbrs.l(rm) | 0)) | 0);
          var lspan = (((nbrs.l(lm) | 0) - (nbrs.l(0) | 0)) | 0);
          if ((lspan === rspan)) {
            var num$1 = (((nbrs.l(lm) | 0) + (nbrs.l(rm) | 0)) | 0);
            var $x_2 = (((num$1 + ((num$1 >>> 31) | 0)) | 0) >> 1);
          } else {
            var $x_2 = ((((nbrs.l(lm) | 0) * rspan) + ((nbrs.l(rm) | 0) * lspan)) / ((lspan + rspan) | 0));
          }
        }
      }
    }
    $p_scm_HashMap__put0__O__O__Z__s_Some(mval$11, x0, $x_2, false);
  }
  var elem = false;
  elem = false;
  var it$1 = rb.bB().o();
  while (it$1.p()) {
    var x0$1 = it$1.q();
    if ((out$23.i(x0$1).c() && in$20.i(x0$1).c())) {
      elem = ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__flatMval$1__scm_HashMap__scm_HashMap__scm_HashMap__scm_HashMap__O__Z($thiz, pos$32, mval$11, flIn$11, flOut$14, x0$1) || elem);
    }
  }
  return elem;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__reorder$3__scm_HashMap__scm_HashMap__F1__scm_HashMap__sc_Map__Z__scm_HashMap__scm_HashMap__I__Z__Z__V($thiz, ranks$21, mval$14, columnOf$6, flatMx$4, rankOf$24, flip$6, flatIdx$7, pos$37, r, reverse, hasfixed) {
  var rb = ranks$21.i(r);
  var ep = rb.a1;
  var nelt = ((rb.a1 - 1) | 0);
  while ((nelt >= 0)) {
    var lp = 0;
    while ((lp < ep)) {
      while (true) {
        if ((lp < ep)) {
          var key = rb.l(lp);
          var f = (() => (-1.0));
          if ((!($objectGetClass(mval$14) === $d_scm_HashMap.l()))) {
            var x1 = mval$14.r(key);
            if ((x1 instanceof $c_s_Some)) {
              var $x_2 = x1.J;
            } else {
              if ((!($m_s_None$() === x1))) {
                throw new $c_s_MatchError(x1);
              }
              var $x_2 = f();
            }
          } else {
            var originalHash = $m_sr_Statics$().u(key);
            var hash = (originalHash ^ ((originalHash >>> 16) | 0));
            var x1$1 = mval$14.S.a[(hash & ((mval$14.S.a.length - 1) | 0))];
            var nd = ((x1$1 === null) ? null : x1$1.by(key, hash));
            var $x_2 = ((nd === null) ? f() : nd.b9);
          }
          var $x_1 = ((+$x_2) < 0.0);
        } else {
          var $x_1 = false;
        }
        if ($x_1) {
          lp = ((1 + lp) | 0);
        } else {
          break;
        }
      }
      if ((lp < ep)) {
        var rp = ((1 + lp) | 0);
        var muststay = false;
        var found = false;
        var sawclust = false;
        while ((((rp < ep) && (!muststay)) && (!found))) {
          if ((sawclust && (!columnOf$6.i(rb.l(rp)).c()))) {
            rp = ((1 + rp) | 0);
          } else if ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__left2right$1__scm_HashMap__sc_Map__Z__scm_HashMap__O__O__Z($thiz, flatMx$4, rankOf$24, flip$6, flatIdx$7, rb.l(lp), rb.l(rp))) {
            muststay = true;
          } else {
            var key$1 = rb.l(rp);
            var f$1 = (() => (-1.0));
            if ((!($objectGetClass(mval$14) === $d_scm_HashMap.l()))) {
              var x1$2 = mval$14.r(key$1);
              if ((x1$2 instanceof $c_s_Some)) {
                var $x_3 = x1$2.J;
              } else {
                if ((!($m_s_None$() === x1$2))) {
                  throw new $c_s_MatchError(x1$2);
                }
                var $x_3 = f$1();
              }
            } else {
              var originalHash$1 = $m_sr_Statics$().u(key$1);
              var hash$1 = (originalHash$1 ^ ((originalHash$1 >>> 16) | 0));
              var x1$3 = mval$14.S.a[(hash$1 & ((mval$14.S.a.length - 1) | 0))];
              var nd$1 = ((x1$3 === null) ? null : x1$3.by(key$1, hash$1));
              var $x_3 = ((nd$1 === null) ? f$1() : nd$1.b9);
            }
            if (((+$x_3) >= 0.0)) {
              found = true;
            } else {
              if ((!columnOf$6.i(rb.l(rp)).c())) {
                sawclust = true;
              }
              rp = ((1 + rp) | 0);
            }
          }
        }
        if ((rp < ep)) {
          if ((!muststay)) {
            var key$2 = rb.l(lp);
            var f$2 = (() => (-1.0));
            if ((!($objectGetClass(mval$14) === $d_scm_HashMap.l()))) {
              var x1$4 = mval$14.r(key$2);
              if ((x1$4 instanceof $c_s_Some)) {
                var $x_4 = x1$4.J;
              } else {
                if ((!($m_s_None$() === x1$4))) {
                  throw new $c_s_MatchError(x1$4);
                }
                var $x_4 = f$2();
              }
            } else {
              var originalHash$2 = $m_sr_Statics$().u(key$2);
              var hash$2 = (originalHash$2 ^ ((originalHash$2 >>> 16) | 0));
              var x1$5 = mval$14.S.a[(hash$2 & ((mval$14.S.a.length - 1) | 0))];
              var nd$2 = ((x1$5 === null) ? null : x1$5.by(key$2, hash$2));
              var $x_4 = ((nd$2 === null) ? f$2() : nd$2.b9);
            }
            var p1 = (+$x_4);
            var key$3 = rb.l(rp);
            var f$3 = (() => (-1.0));
            if ((!($objectGetClass(mval$14) === $d_scm_HashMap.l()))) {
              var x1$6 = mval$14.r(key$3);
              if ((x1$6 instanceof $c_s_Some)) {
                var $x_5 = x1$6.J;
              } else {
                if ((!($m_s_None$() === x1$6))) {
                  throw new $c_s_MatchError(x1$6);
                }
                var $x_5 = f$3();
              }
            } else {
              var originalHash$3 = $m_sr_Statics$().u(key$3);
              var hash$3 = (originalHash$3 ^ ((originalHash$3 >>> 16) | 0));
              var x1$7 = mval$14.S.a[(hash$3 & ((mval$14.S.a.length - 1) | 0))];
              var nd$3 = ((x1$7 === null) ? null : x1$7.by(key$3, hash$3));
              var $x_5 = ((nd$3 === null) ? f$3() : nd$3.b9);
            }
            var p2 = (+$x_5);
            if (((p1 > p2) || ((p1 >= p2) && reverse))) {
              $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__exchange$3__scm_HashMap__scm_HashMap__I__I__I__V($thiz, ranks$21, pos$37, r, lp, rp);
            }
          }
          lp = rp;
        } else {
          lp = ep;
        }
      } else {
        lp = ep;
      }
    }
    if (((!hasfixed) && (!reverse))) {
      ep = ((ep - 1) | 0);
    }
    nelt = ((nelt - 1) | 0);
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__crossIn$3__sc_Map__scm_HashMap__F2__F2__O__O__J($thiz, in$23, pos$38, segPorts$15, weight$11, v, w) {
  var c = new $c_sr_LongRef(0, 0);
  in$23.i(v).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x) => {
    in$23.i(w).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((y) => {
      if ((((pos$38.i(x) | 0) > (pos$38.i(y) | 0)) || (((pos$38.i(x) | 0) === (pos$38.i(y) | 0)) && (segPorts$15.R(x, v).o0 > segPorts$15.R(y, w).o0)))) {
        var x$3_$_lo = c.ji;
        var x$3_$_hi = c.jj;
        var $x_1 = $uJ(weight$11.R(x, v));
        var x$1_$_lo = $x_1.l;
        var x$1_$_hi = $x_1.h;
        var $x_2 = $uJ(weight$11.R(y, w));
        var x$2_$_lo = $x_2.l;
        var x$2_$_hi = $x_2.h;
        var a0 = (65535 & x$1_$_lo);
        var a1 = ((x$1_$_lo >>> 16) | 0);
        var b0 = (65535 & x$2_$_lo);
        var b1 = ((x$2_$_lo >>> 16) | 0);
        var a0b0 = Math.imul(a0, b0);
        var a1b0 = Math.imul(a1, b0);
        var a0b1 = Math.imul(a0, b1);
        var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi = ((((((((Math.imul(x$1_$_lo, x$2_$_hi) + Math.imul(x$1_$_hi, x$2_$_lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
        var lo$1 = ((x$3_$_lo + lo) | 0);
        var hi$1 = ((((x$3_$_hi + hi) | 0) + (((lo$1 >>> 0) < (x$3_$_lo >>> 0)) | 0)) | 0);
        c.ji = lo$1;
        c.jj = hi$1;
      }
    })));
  })));
  return $bL(c.ji, c.jj);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__crossOut$3__sc_Map__scm_HashMap__F2__F2__O__O__J($thiz, out$26, pos$41, segPorts$18, weight$14, v, w) {
  var c = new $c_sr_LongRef(0, 0);
  out$26.i(v).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x) => {
    out$26.i(w).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((y) => {
      if ((((pos$41.i(x) | 0) > (pos$41.i(y) | 0)) || (((pos$41.i(x) | 0) === (pos$41.i(y) | 0)) && (segPorts$18.R(v, x).nZ > segPorts$18.R(w, y).nZ)))) {
        var x$3_$_lo = c.ji;
        var x$3_$_hi = c.jj;
        var $x_1 = $uJ(weight$14.R(v, x));
        var x$1_$_lo = $x_1.l;
        var x$1_$_hi = $x_1.h;
        var $x_2 = $uJ(weight$14.R(w, y));
        var x$2_$_lo = $x_2.l;
        var x$2_$_hi = $x_2.h;
        var a0 = (65535 & x$1_$_lo);
        var a1 = ((x$1_$_lo >>> 16) | 0);
        var b0 = (65535 & x$2_$_lo);
        var b1 = ((x$2_$_lo >>> 16) | 0);
        var a0b0 = Math.imul(a0, b0);
        var a1b0 = Math.imul(a1, b0);
        var a0b1 = Math.imul(a0, b1);
        var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi = ((((((((Math.imul(x$1_$_lo, x$2_$_hi) + Math.imul(x$1_$_hi, x$2_$_lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
        var lo$1 = ((x$3_$_lo + lo) | 0);
        var hi$1 = ((((x$3_$_hi + hi) | 0) + (((lo$1 >>> 0) < (x$3_$_lo >>> 0)) | 0)) | 0);
        c.ji = lo$1;
        c.jj = hi$1;
      }
    })));
  })));
  return $bL(c.ji, c.jj);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__transposeStep$3__scm_HashMap__scm_HashMap__I__I__scm_HashMap__sc_Map__Z__scm_HashMap__sc_Map__scm_HashMap__F2__F2__sc_Map__I__Z__J($thiz, candidate$11, ranks$22, minR$4, maxR$4, flatMx$5, rankOf$25, flip$7, flatIdx$8, in$25, pos$44, segPorts$21, weight$17, out$28, r, reverse) {
  var delta_$_lo = 0;
  var delta_$_hi = 0;
  $p_scm_HashMap__put0__O__O__Z__s_Some(candidate$11, r, false, false);
  var rb = ranks$22.i(r);
  var i = 0;
  while ((i < ((rb.a1 - 1) | 0))) {
    var v = rb.l(i);
    var w = rb.l(((1 + i) | 0));
    if ((!$p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__left2right$1__scm_HashMap__sc_Map__Z__scm_HashMap__O__O__Z($thiz, flatMx$5, rankOf$25, flip$7, flatIdx$8, v, w))) {
      var c0_$_lo = 0;
      var c0_$_hi = 0;
      var c1_$_lo = 0;
      var c1_$_hi = 0;
      if ((r > minR$4)) {
        var x_$_lo = c0_$_lo;
        var x_$_hi = c0_$_hi;
        var $x_1 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__crossIn$3__sc_Map__scm_HashMap__F2__F2__O__O__J($thiz, in$25, pos$44, segPorts$21, weight$17, v, w);
        var x$1_$_lo = $x_1.l;
        var x$1_$_hi = $x_1.h;
        var lo = ((x_$_lo + x$1_$_lo) | 0);
        var hi = ((((x_$_hi + x$1_$_hi) | 0) + (((lo >>> 0) < (x_$_lo >>> 0)) | 0)) | 0);
        c0_$_lo = lo;
        c0_$_hi = hi;
        var x$2_$_lo = c1_$_lo;
        var x$2_$_hi = c1_$_hi;
        var $x_2 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__crossIn$3__sc_Map__scm_HashMap__F2__F2__O__O__J($thiz, in$25, pos$44, segPorts$21, weight$17, w, v);
        var x$3_$_lo = $x_2.l;
        var x$3_$_hi = $x_2.h;
        var lo$1 = ((x$2_$_lo + x$3_$_lo) | 0);
        var hi$1 = ((((x$2_$_hi + x$3_$_hi) | 0) + (((lo$1 >>> 0) < (x$2_$_lo >>> 0)) | 0)) | 0);
        c1_$_lo = lo$1;
        c1_$_hi = hi$1;
      }
      if (((r < maxR$4) && (!ranks$22.i(((1 + r) | 0)).c()))) {
        var x$4_$_lo = c0_$_lo;
        var x$4_$_hi = c0_$_hi;
        var $x_3 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__crossOut$3__sc_Map__scm_HashMap__F2__F2__O__O__J($thiz, out$28, pos$44, segPorts$21, weight$17, v, w);
        var x$5_$_lo = $x_3.l;
        var x$5_$_hi = $x_3.h;
        var lo$2 = ((x$4_$_lo + x$5_$_lo) | 0);
        var hi$2 = ((((x$4_$_hi + x$5_$_hi) | 0) + (((lo$2 >>> 0) < (x$4_$_lo >>> 0)) | 0)) | 0);
        c0_$_lo = lo$2;
        c0_$_hi = hi$2;
        var x$6_$_lo = c1_$_lo;
        var x$6_$_hi = c1_$_hi;
        var $x_4 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__crossOut$3__sc_Map__scm_HashMap__F2__F2__O__O__J($thiz, out$28, pos$44, segPorts$21, weight$17, w, v);
        var x$7_$_lo = $x_4.l;
        var x$7_$_hi = $x_4.h;
        var lo$3 = ((x$6_$_lo + x$7_$_lo) | 0);
        var hi$3 = ((((x$6_$_hi + x$7_$_hi) | 0) + (((lo$3 >>> 0) < (x$6_$_lo >>> 0)) | 0)) | 0);
        c1_$_lo = lo$3;
        c1_$_hi = hi$3;
      }
      var x$8_$_lo = c1_$_lo;
      var x$8_$_hi = c1_$_hi;
      var x$9_$_lo = c0_$_lo;
      var x$9_$_hi = c0_$_hi;
      if (((x$8_$_hi === x$9_$_hi) ? ((x$8_$_lo >>> 0) < (x$9_$_lo >>> 0)) : (x$8_$_hi < x$9_$_hi))) {
        var $x_5 = true;
      } else {
        var x$10_$_lo = c0_$_lo;
        var x$10_$_hi = c0_$_hi;
        if ((((x$10_$_hi === 0) ? (x$10_$_lo !== 0) : (x$10_$_hi > 0)) && reverse)) {
          var x$11_$_lo = c1_$_lo;
          var x$11_$_hi = c1_$_hi;
          var x$12_$_lo = c0_$_lo;
          var x$12_$_hi = c0_$_hi;
          var $x_5 = (((x$11_$_lo ^ x$12_$_lo) | (x$11_$_hi ^ x$12_$_hi)) === 0);
        } else {
          var $x_5 = false;
        }
      }
      if ($x_5) {
        $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__exchange$3__scm_HashMap__scm_HashMap__I__I__I__V($thiz, ranks$22, pos$44, r, i, ((1 + i) | 0));
        var x$15_$_lo = delta_$_lo;
        var x$15_$_hi = delta_$_hi;
        var x$13_$_lo = c0_$_lo;
        var x$13_$_hi = c0_$_hi;
        var x$14_$_lo = c1_$_lo;
        var x$14_$_hi = c1_$_hi;
        var lo$4 = ((x$13_$_lo - x$14_$_lo) | 0);
        var hi$4 = ((((x$13_$_hi - x$14_$_hi) | 0) - (((lo$4 >>> 0) > (x$13_$_lo >>> 0)) | 0)) | 0);
        var lo$5 = ((x$15_$_lo + lo$4) | 0);
        var hi$5 = ((((x$15_$_hi + hi$4) | 0) + (((lo$5 >>> 0) < (x$15_$_lo >>> 0)) | 0)) | 0);
        delta_$_lo = lo$5;
        delta_$_hi = hi$5;
        $p_scm_HashMap__put0__O__O__Z__s_Some(candidate$11, r, true, false);
        if ((r > minR$4)) {
          $p_scm_HashMap__put0__O__O__Z__s_Some(candidate$11, ((r - 1) | 0), true, false);
        }
        if ((r < maxR$4)) {
          $p_scm_HashMap__put0__O__O__Z__s_Some(candidate$11, ((1 + r) | 0), true, false);
        }
      }
    }
    i = ((1 + i) | 0);
  }
  return $bL(delta_$_lo, delta_$_hi);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__transpose$3__I__I__scm_HashMap__scm_HashMap__scm_HashMap__sc_Map__Z__scm_HashMap__sc_Map__scm_HashMap__F2__F2__sc_Map__Z__V($thiz, minR$5, maxR$5, candidate$12, ranks$23, flatMx$6, rankOf$26, flip$8, flatIdx$9, in$26, pos$45, segPorts$22, weight$18, out$29, reverse) {
  if ((!(minR$5 > maxR$5))) {
    var i = minR$5;
    while (true) {
      $p_scm_HashMap__put0__O__O__Z__s_Some(candidate$12, i, true, false);
      if ((i === maxR$5)) {
        break;
      }
      i = ((1 + i) | 0);
    }
  }
  var elem_$_lo = 0;
  var elem_$_hi = 0;
  elem_$_lo = 0;
  elem_$_hi = 0;
  while (true) {
    elem_$_lo = 0;
    elem_$_hi = 0;
    if ((!(minR$5 > maxR$5))) {
      var i$1 = minR$5;
      while (true) {
        var x0$1 = i$1;
        if ((!(!candidate$12.i(x0$1)))) {
          var x_$_lo = elem_$_lo;
          var x_$_hi = elem_$_hi;
          var $x_1 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__transposeStep$3__scm_HashMap__scm_HashMap__I__I__scm_HashMap__sc_Map__Z__scm_HashMap__sc_Map__scm_HashMap__F2__F2__sc_Map__I__Z__J($thiz, candidate$12, ranks$23, minR$5, maxR$5, flatMx$6, rankOf$26, flip$8, flatIdx$9, in$26, pos$45, segPorts$22, weight$18, out$29, x0$1, reverse);
          var x$1_$_lo = $x_1.l;
          var x$1_$_hi = $x_1.h;
          var lo = ((x_$_lo + x$1_$_lo) | 0);
          var hi = ((((x_$_hi + x$1_$_hi) | 0) + (((lo >>> 0) < (x_$_lo >>> 0)) | 0)) | 0);
          elem_$_lo = lo;
          elem_$_hi = hi;
        }
        if ((i$1 === maxR$5)) {
          break;
        }
        i$1 = ((1 + i$1) | 0);
      }
    }
    var x$2_$_lo = elem_$_lo;
    var x$2_$_hi = elem_$_hi;
    if (((x$2_$_hi === 0) ? (x$2_$_lo !== 0) : (x$2_$_hi > 0))) {
    } else {
      break;
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__mincrossStep$3__I__I__scm_HashMap__sc_Map__scm_HashMap__F2__sc_Map__scm_HashMap__scm_HashMap__scm_HashMap__F1__scm_HashMap__sc_Map__Z__scm_HashMap__scm_HashMap__F2__I__V($thiz, minR$7, maxR$7, ranks$25, out$31, pos$47, segPorts$24, in$28, mval$15, flIn$13, flOut$16, columnOf$7, flatMx$8, rankOf$28, flip$10, flatIdx$11, candidate$15, weight$20, pass) {
  var t = (((pass >> 1) >>> 30) | 0);
  var reverse = ((((3 & ((pass + t) | 0)) - t) | 0) < 2);
  var t$1 = ((pass >>> 31) | 0);
  if (((((1 & ((pass + t$1) | 0)) - t$1) | 0) === 0)) {
    var \u03b427$___1 = ((1 + minR$7) | 0);
    var \u03b427$___2 = maxR$7;
    var \u03b427$___3 = 1;
  } else {
    var \u03b427$___1 = ((maxR$7 - 1) | 0);
    var \u03b427$___2 = minR$7;
    var \u03b427$___3 = (-1);
  }
  var first = (\u03b427$___1 | 0);
  var last = (\u03b427$___2 | 0);
  var dir = (\u03b427$___3 | 0);
  var r = first;
  while ((r !== ((last + dir) | 0))) {
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__reorder$3__scm_HashMap__scm_HashMap__F1__scm_HashMap__sc_Map__Z__scm_HashMap__scm_HashMap__I__Z__Z__V($thiz, ranks$25, mval$15, columnOf$7, flatMx$8, rankOf$28, flip$10, flatIdx$11, pos$47, r, reverse, $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__medians$3__scm_HashMap__sc_Map__scm_HashMap__F2__sc_Map__scm_HashMap__scm_HashMap__scm_HashMap__I__I__Z($thiz, ranks$25, out$31, pos$47, segPorts$24, in$28, mval$15, flIn$13, flOut$16, r, ((r - dir) | 0)));
    r = ((r + dir) | 0);
  }
  $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__transpose$3__I__I__scm_HashMap__scm_HashMap__scm_HashMap__sc_Map__Z__scm_HashMap__sc_Map__scm_HashMap__F2__F2__sc_Map__Z__V($thiz, minR$7, maxR$7, candidate$15, ranks$25, flatMx$8, rankOf$28, flip$10, flatIdx$11, in$28, pos$47, segPorts$24, weight$20, out$31, (!reverse));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__snapshot$3__scm_HashMap__sci_Map($thiz, ranks$26) {
  return $m_sci_Map$().ao(new $c_sc_Iterator$$anon$9(ranks$26.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    if ((x$1 !== null)) {
      var r = (x$1.g() | 0);
      var b = x$1.h();
      return new $c_T2(r, $m_sci_Vector$().X(b));
    }
    throw new $c_s_MatchError(x$1);
  }))));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__restore$3__scm_HashMap__scm_HashMap__sci_Map__V($thiz, ranks$27, pos$48, s) {
  s.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    matchResult70: {
      if ((x$1 !== null)) {
        var r = (x$1.g() | 0);
        var v = x$1.h();
        var rb = ranks$27.i(r);
        $p_scm_ArrayBuffer__reduceToSize__I__V(rb, 0);
        rb.gS(v);
        var this$2 = new $c_sc_Iterator$$anon$16(v.o());
        while (this$2.p()) {
          var x0 = this$2.dC();
          matchResult69: {
            if ((x0 !== null)) {
              $p_scm_HashMap__put0__O__O__Z__s_Some(pos$48, x0.g(), (x0.h() | 0), false);
              break matchResult69;
            }
            throw new $c_s_MatchError(x0);
          }
        }
        break matchResult70;
      }
      throw new $c_s_MatchError(x$1);
    }
  })));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__runOne$1__sc_Map__Z__sc_Map__sc_Map__F1__F1__F2__F2__F1__Z__sci_Vector__sci_Vector__T2($thiz, rankOf$17, flip$1, out$11, in$10, columnOf$1, columnNodes$1, weight$1, segPorts$4, hasPort$6, rootGraph$1, nlist, fps) {
  var minR = (rankOf$17.c() ? 0 : (rankOf$17.e6().lr($m_s_math_Ordering$Int$()) | 0));
  var maxR = (rankOf$17.c() ? 0 : (rankOf$17.e6().lq($m_s_math_Ordering$Int$()) | 0));
  var $x_1 = $m_scm_HashMap$();
  var isEmpty = (minR > maxR);
  if (((((1 + ((maxR - minR) | 0)) | 0) <= 0) && (!isEmpty))) {
    $m_sci_Range$().ug(minR, maxR, 1, true);
  }
  var b = $m_sci_IndexedSeq$().b5();
  var it = new $c_sci_RangeIterator(minR, 1, maxR, isEmpty);
  while (it.g0) {
    b.Y(new $c_T2(it.hp(), ($m_scm_ArrayBuffer$(), $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer()))));
  }
  var ranks = $x_1.DY(b.aR());
  var pos = $ct_scm_HashMap__(new $c_scm_HashMap());
  var mark = $m_scm_Set$().aO();
  var hasFlat = (!$f_sc_SeqOps__isEmpty__Z(fps));
  var flOut = $ct_scm_HashMap__(new $c_scm_HashMap());
  var flIn = $ct_scm_HashMap__(new $c_scm_HashMap());
  var flWt = $ct_scm_HashMap__(new $c_scm_HashMap());
  fps.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var t = x$1.bH;
    var h = x$1.bU;
    var w = (+x$1.c3);
    var originalHash = $m_sr_Statics$().u(t);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var idx = (hash & ((flOut.S.a.length - 1) | 0));
    var x1 = flOut.S.a[idx];
    var nd = ((x1 === null) ? null : x1.by(t, hash));
    if ((nd !== null)) {
      var $x_2 = nd.b9;
    } else {
      var table0 = flOut.S;
      $m_scm_ArrayBuffer$();
      var default$1 = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
      if ((((1 + flOut.eh) | 0) >= flOut.kI)) {
        $p_scm_HashMap__growTable__I__V(flOut, (flOut.S.a.length << 1));
      }
      $p_scm_HashMap__put0__O__O__Z__I__I__s_Some(flOut, t, default$1, false, hash, ((table0 === flOut.S) ? idx : (hash & ((flOut.S.a.length - 1) | 0))));
      var $x_2 = default$1;
    }
    $x_2.Y(h);
    var originalHash$1 = $m_sr_Statics$().u(h);
    var hash$1 = (originalHash$1 ^ ((originalHash$1 >>> 16) | 0));
    var idx$1 = (hash$1 & ((flIn.S.a.length - 1) | 0));
    var x1$1 = flIn.S.a[idx$1];
    var nd$1 = ((x1$1 === null) ? null : x1$1.by(h, hash$1));
    if ((nd$1 !== null)) {
      var $x_3 = nd$1.b9;
    } else {
      var table0$1 = flIn.S;
      $m_scm_ArrayBuffer$();
      var default$2 = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
      if ((((1 + flIn.eh) | 0) >= flIn.kI)) {
        $p_scm_HashMap__growTable__I__V(flIn, (flIn.S.a.length << 1));
      }
      $p_scm_HashMap__put0__O__O__Z__I__I__s_Some(flIn, h, default$2, false, hash$1, ((table0$1 === flIn.S) ? idx$1 : (hash$1 & ((flIn.S.a.length - 1) | 0))));
      var $x_3 = default$2;
    }
    $x_3.Y(t);
    var $x_4 = new $c_T2(t, h);
    var key = new $c_T2(t, h);
    var originalHash$2 = $m_sr_Statics$().u(key);
    var hash$2 = (originalHash$2 ^ ((originalHash$2 >>> 16) | 0));
    var x1$2 = flWt.S.a[(hash$2 & ((flWt.S.a.length - 1) | 0))];
    var nd$2 = ((x1$2 === null) ? null : x1$2.by(key, hash$2));
    $p_scm_HashMap__put0__O__O__Z__s_Some(flWt, $x_4, ((+((nd$2 === null) ? 0.0 : nd$2.b9)) + w), false);
  })));
  var flatIdx = $ct_scm_HashMap__(new $c_scm_HashMap());
  var flatMx = $ct_scm_HashMap__(new $c_scm_HashMap());
  var mval = $ct_scm_HashMap__(new $c_scm_HashMap());
  var $x_5 = $m_scm_HashMap$();
  var isEmpty$1 = (minR > maxR);
  if (((((1 + ((maxR - minR) | 0)) | 0) <= 0) && (!isEmpty$1))) {
    $m_sci_Range$().ug(minR, maxR, 1, true);
  }
  var b$1 = $m_sci_IndexedSeq$().b5();
  var it$1 = new $c_sci_RangeIterator(minR, 1, maxR, isEmpty$1);
  while (it$1.g0) {
    b$1.Y(new $c_T2(it$1.hp(), true));
  }
  var candidate = $x_5.DY(b$1.aR());
  var best = $m_sci_Map$EmptyMap$();
  var bestCross_$_lo = (-1);
  var bestCross_$_hi = 2147483647;
  var cur_$_lo = (-1);
  var cur_$_hi = 2147483647;
  var pass = 0;
  var stop = false;
  while (((pass <= 2) && (!stop))) {
    if ((pass <= 1)) {
      var y$1 = $thiz.RH;
      var maxthispass = ((y$1 > 4) ? 4 : y$1);
    } else {
      var maxthispass = $thiz.RH;
    }
    if ((pass <= 1)) {
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__buildRanks$1__scm_HashMap__scm_HashMap__scm_Set__sc_Map__sc_Map__F1__F1__sci_Vector__Z__sc_Map__I__V($thiz, ranks, pos, mark, out$11, in$10, columnOf$1, columnNodes$1, nlist, flip$1, rankOf$17, pass);
      if (rootGraph$1) {
        var $x_7 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__ncross$1__I__I__scm_HashMap__F1__sc_Map__scm_HashMap__F2__F2__sc_Map__J($thiz, minR, maxR, ranks, hasPort$6, out$11, pos, weight$1, segPorts$4, in$10);
        var x_$_lo = $x_7.l;
        var x_$_hi = $x_7.h;
        var $x_6 = ((x_$_hi === 0) ? (x_$_lo !== 0) : (x_$_hi > 0));
      } else {
        var $x_6 = false;
      }
      if ($x_6) {
        $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__transpose$3__I__I__scm_HashMap__scm_HashMap__scm_HashMap__sc_Map__Z__scm_HashMap__sc_Map__scm_HashMap__F2__F2__sc_Map__Z__V($thiz, minR, maxR, candidate, ranks, flatMx, rankOf$17, flip$1, flatIdx, in$10, pos, segPorts$4, weight$1, out$11, false);
      }
      if ((pass === 0)) {
        $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__flatBreakcycles$1__Z__I__I__scm_HashMap__scm_HashMap__scm_HashMap__scm_HashMap__scm_HashMap__scm_HashMap__V($thiz, hasFlat, minR, maxR, ranks, flatIdx, flatMx, flWt, flOut, flIn);
      }
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__flatReorder$1__Z__I__I__scm_HashMap__scm_HashMap__Z__scm_HashMap__scm_HashMap__scm_HashMap__V($thiz, hasFlat, minR, maxR, ranks, flWt, flip$1, pos, flOut, flIn);
      var $x_8 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__ncross$1__I__I__scm_HashMap__F1__sc_Map__scm_HashMap__F2__F2__sc_Map__J($thiz, minR, maxR, ranks, hasPort$6, out$11, pos, weight$1, segPorts$4, in$10);
      cur_$_lo = $x_8.l;
      cur_$_hi = $x_8.h;
      var x$2_$_lo = cur_$_lo;
      var x$2_$_hi = cur_$_hi;
      var x$3_$_lo = bestCross_$_lo;
      var x$3_$_hi = bestCross_$_hi;
      if (((x$2_$_hi === x$3_$_hi) ? ((x$2_$_lo >>> 0) <= (x$3_$_lo >>> 0)) : (x$2_$_hi < x$3_$_hi))) {
        best = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__snapshot$3__scm_HashMap__sci_Map($thiz, ranks);
        bestCross_$_lo = cur_$_lo;
        bestCross_$_hi = cur_$_hi;
      }
    } else {
      var x$4_$_lo = cur_$_lo;
      var x$4_$_hi = cur_$_hi;
      var x$5_$_lo = bestCross_$_lo;
      var x$5_$_hi = bestCross_$_hi;
      if (((x$4_$_hi === x$5_$_hi) ? ((x$4_$_lo >>> 0) > (x$5_$_lo >>> 0)) : (x$4_$_hi > x$5_$_hi))) {
        $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__restore$3__scm_HashMap__scm_HashMap__sci_Map__V($thiz, ranks, pos, best);
      }
      cur_$_lo = bestCross_$_lo;
      cur_$_hi = bestCross_$_hi;
    }
    var trying = 0;
    var iter = 0;
    var brk = false;
    while (((iter < maxthispass) && (!brk))) {
      if ((trying >= $thiz.ZQ)) {
        brk = true;
      } else {
        trying = ((1 + trying) | 0);
        var x$6_$_lo = cur_$_lo;
        var x$6_$_hi = cur_$_hi;
        if (((x$6_$_lo | x$6_$_hi) === 0)) {
          brk = true;
        } else {
          $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__mincrossStep$3__I__I__scm_HashMap__sc_Map__scm_HashMap__F2__sc_Map__scm_HashMap__scm_HashMap__scm_HashMap__F1__scm_HashMap__sc_Map__Z__scm_HashMap__scm_HashMap__F2__I__V($thiz, minR, maxR, ranks, out$11, pos, segPorts$4, in$10, mval, flIn, flOut, columnOf$1, flatMx, rankOf$17, flip$1, flatIdx, candidate, weight$1, iter);
          var $x_9 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__ncross$1__I__I__scm_HashMap__F1__sc_Map__scm_HashMap__F2__F2__sc_Map__J($thiz, minR, maxR, ranks, hasPort$6, out$11, pos, weight$1, segPorts$4, in$10);
          cur_$_lo = $x_9.l;
          cur_$_hi = $x_9.h;
          var x$7_$_lo = cur_$_lo;
          var x$7_$_hi = cur_$_hi;
          var x$8_$_lo = bestCross_$_lo;
          var x$8_$_hi = bestCross_$_hi;
          if (((x$7_$_hi === x$8_$_hi) ? ((x$7_$_lo >>> 0) <= (x$8_$_lo >>> 0)) : (x$7_$_hi < x$8_$_hi))) {
            best = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__snapshot$3__scm_HashMap__sci_Map($thiz, ranks);
            var x$9_$_lo = cur_$_lo;
            var x$9_$_hi = cur_$_hi;
            var $x_10 = $thiz.ZP;
            var x$10_$_lo = bestCross_$_lo;
            var x$10_$_hi = bestCross_$_hi;
            if ((((4.294967296E9 * x$9_$_hi) + (x$9_$_lo >>> 0.0)) < ($x_10 * ((4.294967296E9 * x$10_$_hi) + (x$10_$_lo >>> 0.0))))) {
              trying = 0;
            }
            bestCross_$_lo = cur_$_lo;
            bestCross_$_hi = cur_$_hi;
          }
          iter = ((1 + iter) | 0);
        }
      }
    }
    var x$11_$_lo = cur_$_lo;
    var x$11_$_hi = cur_$_hi;
    if (((x$11_$_lo | x$11_$_hi) === 0)) {
      stop = true;
    }
    pass = ((1 + pass) | 0);
  }
  var x$12_$_lo = cur_$_lo;
  var x$12_$_hi = cur_$_hi;
  var x$13_$_lo = bestCross_$_lo;
  var x$13_$_hi = bestCross_$_hi;
  if (((x$12_$_hi === x$13_$_hi) ? ((x$12_$_lo >>> 0) > (x$13_$_lo >>> 0)) : (x$12_$_hi > x$13_$_hi))) {
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__restore$3__scm_HashMap__scm_HashMap__sci_Map__V($thiz, ranks, pos, best);
  }
  var x$14_$_lo = bestCross_$_lo;
  var x$14_$_hi = bestCross_$_hi;
  if (((x$14_$_hi === 0) ? (x$14_$_lo !== 0) : (x$14_$_hi > 0))) {
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__transpose$3__I__I__scm_HashMap__scm_HashMap__scm_HashMap__sc_Map__Z__scm_HashMap__sc_Map__scm_HashMap__F2__F2__sc_Map__Z__V($thiz, minR, maxR, candidate, ranks, flatMx, rankOf$17, flip$1, flatIdx, in$10, pos, segPorts$4, weight$1, out$11, false);
    var $x_11 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__ncross$1__I__I__scm_HashMap__F1__sc_Map__scm_HashMap__F2__F2__sc_Map__J($thiz, minR, maxR, ranks, hasPort$6, out$11, pos, weight$1, segPorts$4, in$10);
    bestCross_$_lo = $x_11.l;
    bestCross_$_hi = $x_11.h;
  }
  return new $c_T2($p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__snapshot$3__scm_HashMap__sci_Map($thiz, ranks), $bL(bestCross_$_lo, bestCross_$_hi));
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$() {
  this.RH = 0;
  this.ZQ = 0;
  this.ZP = 0.0;
  this.aui = null;
  $n_Lorg_jpablo_graphexplorer_graphviz_layout_Order$ = this;
  this.RH = 24;
  this.ZQ = 8;
  this.ZP = 0.995;
  this.aui = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_GraphMemo();
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_Order$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_Order$.prototype = $p;
$p.ahg = (function(g) {
  var this$1 = this.aui;
  if ((g === this$1.f0)) {
    var $x_1 = this$1.f1;
  } else {
    var v = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Order$__orderImpl__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__Lorg_jpablo_graphexplorer_graphviz_layout_Order$Result($m_Lorg_jpablo_graphexplorer_graphviz_layout_Order$(), g);
    this$1.f0 = g;
    this$1.f1 = v;
    var $x_1 = v;
  }
  return $x_1;
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_Order$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$, "org.jpablo.graphexplorer.graphviz.layout.Order$", ({
  uY: 1
}));
var $n_Lorg_jpablo_graphexplorer_graphviz_layout_Order$;
function $m_Lorg_jpablo_graphexplorer_graphviz_layout_Order$() {
  if ((!$n_Lorg_jpablo_graphexplorer_graphviz_layout_Order$)) {
    $n_Lorg_jpablo_graphexplorer_graphviz_layout_Order$ = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$();
  }
  return $n_Lorg_jpablo_graphexplorer_graphviz_layout_Order$;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$__starSize__D__D__T2($thiz, x, y) {
  var x$1 = $thiz.ux;
  var rx = (x / (2.0 * (+Math.cos(x$1))));
  var x$2 = $thiz.ux;
  var $x_1 = Math.sin(x$2);
  var x$3 = $thiz.RJ;
  var ry = (y / ((+$x_1) + (+Math.sin(x$3))));
  var r0 = (+Math.max(rx, ry));
  var x$4 = $thiz.RK;
  var $x_4 = Math.sin(x$4);
  var x$5 = $thiz.KT;
  var $x_3 = Math.cos(x$5);
  var x$6 = $thiz.ux;
  var $x_2 = Math.cos(x$6);
  var x$7 = $thiz.RK;
  var r = (((r0 * (+$x_4)) * (+$x_3)) / ((+$x_2) * (+Math.cos(x$7))));
  var x$8 = $thiz.ux;
  var $x_5 = Math.cos(x$8);
  var x$9 = $thiz.RJ;
  return new $c_T2(((2.0 * r) * (+$x_5)), (r * (1.0 + (+Math.sin(x$9)))));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$__starVertices__D__D__T2($thiz, bbX, bbY) {
  var sx = bbX;
  var sy = bbY;
  var x = $thiz.RJ;
  var $x_1 = Math.sin(x);
  var x$1 = $thiz.ux;
  var aspect = ((1.0 + (+$x_1)) / (2.0 * (+Math.cos(x$1))));
  var a = (sy / sx);
  if ((a > aspect)) {
    sx = (sy / aspect);
  } else if ((a < aspect)) {
    sy = (sx * aspect);
  }
  var $x_2 = sx;
  var x$2 = $thiz.ux;
  var r = ($x_2 / (2.0 * (+Math.cos(x$2))));
  var x$3 = $thiz.ux;
  var $x_5 = Math.cos(x$3);
  var x$4 = $thiz.RK;
  var $x_4 = Math.cos(x$4);
  var x$5 = $thiz.RK;
  var $x_3 = Math.sin(x$5);
  var x$6 = $thiz.KT;
  var r0 = (((r * (+$x_5)) * (+$x_4)) / ((+$x_3) * (+Math.cos(x$6))));
  var x$7 = $thiz.RJ;
  var offset = (0.5 * (r * (1.0 - (+Math.sin(x$7)))));
  var v = new ($d_T2.r().C)(10);
  var theta = $thiz.ux;
  var i = 0;
  while ((i < 10)) {
    var $x_7 = i;
    var x$8 = theta;
    var $x_6 = Math.cos(x$8);
    var x$9 = theta;
    v.a[$x_7] = new $c_T2((r * (+$x_6)), ((r * (+Math.sin(x$9))) - offset));
    theta = (theta + $thiz.KT);
    var $x_9 = i;
    var x$10 = theta;
    var $x_8 = Math.cos(x$10);
    var x$11 = theta;
    v.a[((1 + $x_9) | 0)] = new $c_T2((r0 * (+$x_8)), ((r0 * (+Math.sin(x$11))) - offset));
    theta = (theta + $thiz.KT);
    i = ((2 + i) | 0);
  }
  return new $c_T2(v, new $c_T2(sx, sy));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$__cylinderSize__D__D__T2($thiz, x, y) {
  return new $c_T2(x, (1.375 * y));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$__cylinderVertices__D__D__T2($thiz, bbX, bbY) {
  var x = (0.5 * bbX);
  var y = (0.5 * bbY);
  var yr = (bbY / 11.0);
  var v = new ($d_T2.r().C)(19);
  v.a[0] = new $c_T2(x, (y - yr));
  v.a[1] = new $c_T2(x, (y - (0.44821599999999995 * yr)));
  v.a[2] = new $c_T2((0.551784 * x), y);
  v.a[3] = new $c_T2(0.0, y);
  v.a[4] = new $c_T2(((-0.551784) * x), y);
  v.a[5] = new $c_T2((-x), v.a[1].h());
  v.a[6] = new $c_T2((-x), (y - yr));
  v.a[7] = v.a[6];
  v.a[8] = new $c_T2((-x), (yr - y));
  v.a[9] = v.a[8];
  v.a[10] = new $c_T2((-x), (-(+v.a[1].h())));
  v.a[11] = new $c_T2(v.a[4].g(), (-(+v.a[4].h())));
  v.a[12] = new $c_T2(v.a[3].g(), (-(+v.a[3].h())));
  v.a[13] = new $c_T2(v.a[2].g(), (-(+v.a[2].h())));
  v.a[14] = new $c_T2(v.a[1].g(), (-(+v.a[1].h())));
  v.a[15] = new $c_T2(v.a[0].g(), (-(+v.a[0].h())));
  v.a[16] = v.a[15];
  v.a[17] = v.a[0];
  v.a[18] = v.a[0];
  return new $c_T2(v, new $c_T2(bbX, bbY));
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$() {
  this.ZS = 0.0;
  this.ux = 0.0;
  this.KT = 0.0;
  this.RJ = 0.0;
  this.RK = 0.0;
  this.ZR = 0.0;
  $n_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$ = this;
  this.ZS = 1.4142135623730951;
  this.ux = 0.3141592653589793;
  this.KT = (2.0 * this.ux);
  this.RJ = (3.0 * this.ux);
  this.RK = (2.0 * this.KT);
  this.ZR = 4.0;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$.prototype = $p;
$p.afh = (function(name) {
  switch (name.toLowerCase()) {
    case "triangle": {
      return new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Desc(3, 1, 0.0, 0.0, 0.0, false, $m_s_None$()));
      break;
    }
    case "invtriangle": {
      return new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Desc(3, 1, 180.0, 0.0, 0.0, false, $m_s_None$()));
      break;
    }
    case "diamond": {
      return new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Desc(4, 1, 45.0, 0.0, 0.0, false, $m_s_None$()));
      break;
    }
    case "trapezium": {
      return new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Desc(4, 1, 0.0, (-0.4), 0.0, false, $m_s_None$()));
      break;
    }
    case "invtrapezium": {
      return new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Desc(4, 1, 180.0, (-0.4), 0.0, false, $m_s_None$()));
      break;
    }
    case "parallelogram": {
      return new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Desc(4, 1, 0.0, 0.0, 0.6, false, $m_s_None$()));
      break;
    }
    case "pentagon": {
      return new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Desc(5, 1, 0.0, 0.0, 0.0, false, $m_s_None$()));
      break;
    }
    case "house": {
      return new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Desc(5, 1, 0.0, (-0.64), 0.0, false, $m_s_None$()));
      break;
    }
    case "invhouse": {
      return new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Desc(5, 1, 180.0, (-0.64), 0.0, false, $m_s_None$()));
      break;
    }
    case "hexagon": {
      return new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Desc(6, 1, 0.0, 0.0, 0.0, false, $m_s_None$()));
      break;
    }
    case "septagon": {
      return new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Desc(7, 1, 0.0, 0.0, 0.0, false, $m_s_None$()));
      break;
    }
    case "octagon": {
      return new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Desc(8, 1, 0.0, 0.0, 0.0, false, $m_s_None$()));
      break;
    }
    case "doubleoctagon": {
      return new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Desc(8, 2, 0.0, 0.0, 0.0, false, $m_s_None$()));
      break;
    }
    case "tripleoctagon": {
      return new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Desc(8, 3, 0.0, 0.0, 0.0, false, $m_s_None$()));
      break;
    }
    case "egg": {
      return new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Desc(1, 1, 0.0, (-0.3), 0.0, false, $m_s_None$()));
      break;
    }
    case "mdiamond": {
      return new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Desc(4, 1, 45.0, 0.0, 0.0, false, $m_s_None$()));
      break;
    }
    case "star": {
      return new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Desc(10, 1, 0.0, 0.0, 0.0, false, new $c_s_Some($s_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen$__Star__Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen())));
      break;
    }
    case "cylinder": {
      return new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Desc(19, 1, 0.0, 0.0, 0.0, false, new $c_s_Some($s_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen$__Cylinder__Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen())));
      break;
    }
    case "polygon": {
      return new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Desc(0, 1, 0.0, 0.0, 0.0, false, $m_s_None$()));
      break;
    }
    default: {
      return $m_s_None$();
    }
  }
});
$p.aMu = (function(attrs) {
  var this$1 = attrs.ag.r("penwidth");
  var x7 = ((this$1.c() || (this$1.d() !== "")) ? this$1 : $m_s_None$());
  if (($m_s_None$() === x7)) {
    return 1.0;
  }
  if ((x7 instanceof $c_s_Some)) {
    var s = x7.J;
    var this$6 = $m_sc_StringParsers$();
    var this$7 = (this$6.c1(s) ? new $c_s_Some($m_jl_Double$().bd(s)) : $m_s_None$());
    var v = (+(this$7.c() ? 0.0 : this$7.d()));
    return ((v < 0.0) ? 1.0 : v);
  }
  throw new $c_s_MatchError(x7);
});
$p.aPe = (function(dimenX, dimenY, minW, minH, valignCentered, regular, d, fixed, penwidth) {
  var elem = (((d.wF <= 2) && ((d.Bq !== 0.0) || (d.Bt !== 0.0))) ? 120 : ((d.wF < 3) ? 3 : d.wF));
  var elem$1 = 0;
  elem$1 = elem;
  var orientation = d.Fl;
  var distortion = d.Bq;
  var skew = d.Bt;
  var x = d.Br;
  var peripheries = ((x > 0) ? x : 0);
  var bbX = dimenX;
  var bbY = dimenY;
  if ((elem$1 === 4)) {
    var x$1 = (orientation % 90.0);
    var $x_1 = ((+Math.abs(x$1)) < 0.5);
  } else {
    var $x_1 = false;
  }
  if ((!(($x_1 && (distortion === 0.0)) && (skew === 0.0)))) {
    matchResult12: {
      var x18 = d.yX;
      if ((x18 instanceof $c_s_Some)) {
        var g = x18.J;
        matchResult11: {
          var \u03b41$___1;
          var \u03b41$___2;
          matchResult10: {
            var x15;
            var x$2 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen$__Star__Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen();
            if (((x$2 === null) ? (g === null) : (x$2 === g))) {
              var x15 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$__starSize__D__D__T2(this, bbX, bbY);
              break matchResult10;
            }
            var x$3 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen$__Cylinder__Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen();
            if (((x$3 === null) ? (g === null) : (x$3 === g))) {
              var x15 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$__cylinderSize__D__D__T2(this, bbX, bbY);
              break matchResult10;
            }
            throw new $c_s_MatchError(g);
          }
          if ((x15 !== null)) {
            var \u03b41$___1 = (+x15.g());
            var \u03b41$___2 = (+x15.h());
            break matchResult11;
          }
          throw new $c_s_MatchError(x15);
        }
        var gx$2 = (+\u03b41$___1);
        var gy$2 = (+\u03b41$___2);
        bbX = gx$2;
        bbY = gy$2;
        break matchResult12;
      }
      if (($m_s_None$() === x18)) {
        var temp = (bbY * this.ZS);
        if (((minH > temp) && valignCentered)) {
          var $x_2 = bbX;
          var x$proxy1 = (bbY / minH);
          var x$4 = (1.0 / (1.0 - (x$proxy1 * x$proxy1)));
          bbX = ($x_2 * (+Math.sqrt(x$4)));
        } else {
          bbX = (bbX * this.ZS);
          bbY = temp;
        }
        if ((elem$1 > 2)) {
          var x$6 = (3.141592653589793 / elem$1);
          var t = (+Math.cos(x$6));
          bbX = (bbX / t);
          bbY = (bbY / t);
          break matchResult12;
        } else {
          break matchResult12;
        }
      }
      throw new $c_s_MatchError(x18);
    }
  }
  if (fixed) {
    var width = minW;
  } else {
    var y = bbX;
    var width = (+Math.max(minW, y));
  }
  if (fixed) {
    var height = minH;
  } else {
    var y$1 = bbY;
    var height = (+Math.max(minH, y$1));
  }
  bbX = width;
  bbY = height;
  if (regular) {
    var x$7 = bbX;
    var y$2 = bbY;
    var s = (+Math.max(x$7, y$2));
    width = s;
    height = s;
    bbX = s;
    bbY = s;
  }
  var raw = $m_jl_reflect_Array$().m0($d_D.l(), new $ac_I(new Int32Array([elem$1, 2])));
  var xmax = 0.0;
  var ymax = 0.0;
  matchResult15: {
    var x25 = d.yX;
    if ((x25 instanceof $c_s_Some)) {
      var g$2 = x25.J;
      matchResult14: {
        var \u03b42$___1;
        var \u03b42$___2;
        matchResult13: {
          var x22;
          var x$7$1 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen$__Star__Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen();
          if (((x$7$1 === null) ? (g$2 === null) : (x$7$1 === g$2))) {
            var x22 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$__starVertices__D__D__T2(this, bbX, bbY);
            break matchResult13;
          }
          var x$9 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen$__Cylinder__Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen();
          if (((x$9 === null) ? (g$2 === null) : (x$9 === g$2))) {
            var x22 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$__cylinderVertices__D__D__T2(this, bbX, bbY);
            break matchResult13;
          }
          throw new $c_s_MatchError(g$2);
        }
        if ((x22 !== null)) {
          var \u03b42$___1 = x22.g();
          var \u03b42$___2 = x22.h();
          break matchResult14;
        }
        throw new $c_s_MatchError(x22);
      }
      var gv$2 = \u03b42$___1;
      var gbb$2 = \u03b42$___2;
      var k = 0;
      while ((k < elem$1)) {
        raw.a[k].a[0] = (+gv$2.a[k].g());
        raw.a[k].a[1] = (+gv$2.a[k].h());
        k = ((1 + k) | 0);
      }
      xmax = (0.5 * (+gbb$2.g()));
      ymax = (0.5 * (+gbb$2.h()));
      break matchResult15;
    }
    if (($m_s_None$() === x25)) {
      var sectorangle = (6.283185307179586 / elem$1);
      var x$8 = (0.5 * sectorangle);
      var sidelength = (+Math.sin(x$8));
      var skewdist = $m_jl_Math$().ga(((+Math.abs(distortion)) + (+Math.abs(skew))), 1.0);
      var $x_3 = this.ZS;
      var x$12 = (0.5 * sectorangle);
      var gdistortion = ((distortion * $x_3) / (+Math.cos(x$12)));
      var gskew = (0.5 * skew);
      var angle = (0.5 * (sectorangle - 3.141592653589793));
      var x$13 = angle;
      var rx = (0.5 * (+Math.cos(x$13)));
      var x$14 = angle;
      var ry = (0.5 * (+Math.sin(x$14)));
      angle = (angle + (0.5 * (3.141592653589793 - sectorangle)));
      var i = 0;
      while ((i < elem$1)) {
        angle = (angle + sectorangle);
        var $x_4 = rx;
        var x$15 = angle;
        rx = ($x_4 + (sidelength * (+Math.cos(x$15))));
        var $x_5 = ry;
        var x$16 = angle;
        ry = ($x_5 + (sidelength * (+Math.sin(x$16))));
        var px = ((rx * (skewdist + (ry * gdistortion))) + (ry * gskew));
        var py = ry;
        var y$3 = py;
        var x$17 = px;
        var alpha = ((0.017453292519943295 * orientation) + (+Math.atan2(y$3, x$17)));
        var h = $m_jl_Math$().ga(px, py);
        px = (h * (+Math.cos(alpha)));
        py = (h * (+Math.sin(alpha)));
        px = (px * bbX);
        py = (py * bbY);
        var x$19 = px;
        var x$20 = (+Math.abs(x$19));
        var y$5 = xmax;
        xmax = (+Math.max(x$20, y$5));
        var x$21 = py;
        var x$22 = (+Math.abs(x$21));
        var y$6 = ymax;
        ymax = (+Math.max(x$22, y$6));
        raw.a[i].a[0] = px;
        raw.a[i].a[1] = py;
        i = ((1 + i) | 0);
      }
      break matchResult15;
    }
    throw new $c_s_MatchError(x25);
  }
  xmax = (2.0 * xmax);
  ymax = (2.0 * ymax);
  var x$23 = width;
  var y$7 = xmax;
  bbX = (+Math.max(x$23, y$7));
  var x$24 = height;
  var y$8 = ymax;
  bbY = (+Math.max(x$24, y$8));
  var scalex = (bbX / xmax);
  var scaley = (bbY / ymax);
  var n = elem$1;
  if ((n <= 0)) {
    var base = new ($d_T2.r().C)(0);
  } else {
    var array = new ($d_T2.r().C)(n);
    var i$1 = 0;
    while ((i$1 < n)) {
      var $x_6 = i$1;
      var x0 = i$1;
      array.a[$x_6] = new $c_T2((raw.a[x0].a[0] * scalex), (raw.a[x0].a[1] * scaley));
      i$1 = ((1 + i$1) | 0);
    }
    var base = array;
  }
  var outp = (((peripheries >= 1) && (penwidth > 0.0)) ? ((1 + peripheries) | 0) : ((peripheries > 1) ? peripheries : 1));
  if ((outp <= 0)) {
    var rings = new ($d_D.r().r().r().C)(0);
  } else {
    var array$1 = new ($d_D.r().r().r().C)(outp);
    var i$2 = 0;
    while ((i$2 < outp)) {
      array$1.a[i$2] = $m_jl_reflect_Array$().m0($d_D.l(), new $ac_I(new Int32Array([elem$1, 2])));
      i$2 = ((1 + i$2) | 0);
    }
    var rings = array$1;
  }
  var s$2 = 0;
  while ((s$2 < elem$1)) {
    rings.a[0].a[s$2].a[0] = (+base.a[s$2].g());
    rings.a[0].a[s$2].a[1] = (+base.a[s$2].h());
    s$2 = ((1 + s$2) | 0);
  }
  if ((outp > 1)) {
    var R0 = base.a[0];
    var Q = base.a[((elem$1 - 1) | 0)];
    var jj = 1;
    while (true) {
      if ((jj < elem$1)) {
        var x$13$1 = Q;
        var $x_7 = ((x$13$1 === null) ? (R0 === null) : x$13$1.e(R0));
      } else {
        var $x_7 = false;
      }
      if ($x_7) {
        jj = ((1 + jj) | 0);
        Q = base.a[((elem$1 - jj) | 0)];
      } else {
        break;
      }
    }
    var y$9 = ((+R0.h()) - (+Q.h()));
    var x$25 = ((+R0.g()) - (+Q.g()));
    var beta = (+Math.atan2(y$9, x$25));
    var qprev = Q;
    var cosx = 0.0;
    var sinx = 0.0;
    var i2 = 0;
    while ((i2 < elem$1)) {
      var cur = base.a[i2];
      if ((!(((+cur.g()) === (+qprev.g())) && ((+cur.h()) === (+qprev.h()))))) {
        var r = base.a[((((1 + i2) | 0) % $checkIntDivisor(elem$1)) | 0)];
        var k$3 = 1;
        while (true) {
          if ((k$3 < elem$1)) {
            var x$15$1 = r;
            var $x_8 = ((x$15$1 === null) ? (cur === null) : x$15$1.e(cur));
          } else {
            var $x_8 = false;
          }
          if ($x_8) {
            r = base.a[((((i2 + k$3) | 0) % $checkIntDivisor(elem$1)) | 0)];
            k$3 = ((1 + k$3) | 0);
          } else {
            break;
          }
        }
        var alpha$2 = beta;
        var y$10 = ((+r.h()) - (+cur.h()));
        var x$26 = ((+r.g()) - (+cur.g()));
        beta = (+Math.atan2(y$10, x$26));
        var gamma = (0.5 * ((alpha$2 + 3.141592653589793) - beta));
        var temp$2 = (this.ZR / (+Math.sin(gamma)));
        var x$27 = (alpha$2 - gamma);
        sinx = ((+Math.sin(x$27)) * temp$2);
        var x$28 = (alpha$2 - gamma);
        cosx = ((+Math.cos(x$28)) * temp$2);
      }
      qprev = cur;
      var qx = (+cur.g());
      var qy = (+cur.h());
      var j = 1;
      while ((j < peripheries)) {
        qx = (qx + cosx);
        qy = (qy + sinx);
        rings.a[j].a[i2].a[0] = qx;
        rings.a[j].a[i2].a[1] = qy;
        j = ((1 + j) | 0);
      }
      if ((outp > peripheries)) {
        qx = (qx + ((0.5 * (cosx * penwidth)) / this.ZR));
        qy = (qy + ((0.5 * (sinx * penwidth)) / this.ZR));
        rings.a[peripheries].a[i2].a[0] = qx;
        rings.a[peripheries].a[i2].a[1] = qy;
      }
      i2 = ((1 + i2) | 0);
    }
    var idx = 0;
    while ((idx < elem$1)) {
      var p = rings.a[((peripheries - 1) | 0)].a[idx];
      var x$29 = p.a[0];
      var x$30 = (2.0 * (+Math.abs(x$29)));
      var y$11 = bbX;
      bbX = (+Math.max(x$30, y$11));
      var x$31 = p.a[1];
      var x$32 = (2.0 * (+Math.abs(x$31)));
      var y$12 = bbY;
      bbY = (+Math.max(x$32, y$12));
      idx = ((1 + idx) | 0);
    }
  }
  var $x_11 = bbX;
  var $x_10 = bbY;
  $m_sci_Vector$();
  var n$1 = ((peripheries > 1) ? peripheries : 1);
  var b = new $c_sci_VectorBuilder();
  var i$3 = 0;
  while ((i$3 < n$1)) {
    var x0$1 = i$3;
    $m_sci_Vector$();
    var n$2 = elem$1;
    var b$1 = new $c_sci_VectorBuilder();
    var i$4 = 0;
    while ((i$4 < n$2)) {
      var x0$2 = i$4;
      b$1.ck(new $c_T2(rings.a[x0$1].a[x0$2].a[0], rings.a[x0$1].a[x0$2].a[1]));
      i$4 = ((1 + i$4) | 0);
    }
    b.ck(b$1.bY());
    i$3 = ((1 + i$3) | 0);
  }
  var $x_9 = b.bY();
  $m_sci_Vector$();
  var n$3 = elem$1;
  var b$2 = new $c_sci_VectorBuilder();
  var i$5 = 0;
  while ((i$5 < n$3)) {
    var x0$3 = i$5;
    b$2.ck(new $c_T2(rings.a[((outp - 1) | 0)].a[x0$3].a[0], rings.a[((outp - 1) | 0)].a[x0$3].a[1]));
    i$5 = ((1 + i$5) | 0);
  }
  return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Poly($x_11, $x_10, $x_9, b$2.bY());
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$, "org.jpablo.graphexplorer.graphviz.layout.Polygon$", ({
  v6: 1
}));
var $n_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$;
function $m_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$() {
  if ((!$n_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$)) {
    $n_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$ = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$();
  }
  return $n_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$__compassOfName__T__s_Option($thiz, s) {
  switch (s) {
    case "n": {
      return new $c_s_Some($s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__N__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass());
      break;
    }
    case "ne": {
      return new $c_s_Some($s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__NE__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass());
      break;
    }
    case "e": {
      return new $c_s_Some($s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__E__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass());
      break;
    }
    case "se": {
      return new $c_s_Some($s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__SE__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass());
      break;
    }
    case "s": {
      return new $c_s_Some($s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__S__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass());
      break;
    }
    case "sw": {
      return new $c_s_Some($s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__SW__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass());
      break;
    }
    case "w": {
      return new $c_s_Some($s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__W__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass());
      break;
    }
    case "nw": {
      return new $c_s_Some($s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__NW__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass());
      break;
    }
    case "c": {
      return new $c_s_Some($s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__C__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass());
      break;
    }
    case "_": {
      return new $c_s_Some($s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__Underscore__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass());
      break;
    }
    default: {
      return $m_s_None$();
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$__htmlCellPort__Lorg_jpablo_graphexplorer_graphviz_model_RNode__T__s_Option__s_Option($thiz, n, name, compass) {
  if ((!n.aK.n7.E("label"))) {
    return $m_s_None$();
  } else {
    var x113 = $m_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$().mU(n.aK.dL("label", ""));
    if ((x113 instanceof $c_s_Some)) {
      var x115 = x113.J;
      if ((x115 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Table)) {
        var x118 = x115.k8;
        var this$4 = n.aK.ag.r("fontsize");
        if (this$4.c()) {
          var this$8 = $m_s_None$();
        } else {
          var x0 = this$4.d();
          var this$8 = ($m_sc_StringParsers$().c1(x0) ? new $c_s_Some($m_jl_Double$().bd(x0)) : $m_s_None$());
        }
        var fs = (+(this$8.c() ? 14.0 : this$8.d()));
        var fn = n.aK.dL("fontname", "Times");
        var this$10 = $m_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$().aYf(x118, name, fs, fn, $m_Lorg_jpablo_graphexplorer_graphviz_html_ImageDim$().Rv);
        if (this$10.c()) {
          return $m_s_None$();
        } else {
          var x0$1 = this$10.d();
          return new $c_s_Some($m_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$().aOz(x0$1.lA, x0$1.me, x0$1.lB, x0$1.mf, compass));
        }
      }
    }
    return $m_s_None$();
  }
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$() {
  this.Fm = 0.0;
  this.uy = 0;
  this.yZ = 0;
  this.uz = 0;
  this.yY = 0;
  this.ZT = 0;
  $n_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$ = this;
  this.Fm = 1.5707963267948966;
  this.uy = 1;
  this.yZ = 2;
  this.uz = 4;
  this.yY = 8;
  this.ZT = (((this.uy | this.yZ) | this.uz) | this.yY);
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$.prototype = $p;
$p.a2P = (function(n, g, port) {
  if (port.c()) {
    var a = $m_s_None$();
  } else {
    var x0 = port.d();
    var $x_1 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$();
    var this$1 = x0.wx;
    var this$2 = (this$1.c() ? $m_s_None$() : new $c_s_Some(this$1.d().fU));
    var a = $x_1.b7P(n, g, ((this$2.c() || (this$2.d() !== "")) ? this$2 : $m_s_None$()), x0.ww);
  }
  if (($m_s_None$() === a)) {
    return new $c_T3(0.0, 0.0, 128);
  }
  if ((a instanceof $c_s_Some)) {
    var anch = a.J;
    var x$proxy1 = anch.KX;
    var x$proxy2 = anch.KY;
    matchResult1: {
      var \u03b42$___1;
      var \u03b42$___2;
      var x1 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().pD(g);
      var x$3 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__TB__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
      if (((x$3 === null) ? (x1 === null) : (x$3 === x1))) {
        var \u03b42$___1 = x$proxy1;
        var \u03b42$___2 = x$proxy2;
        break matchResult1;
      }
      var x$5 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__LR__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
      if (((x$5 === null) ? (x1 === null) : (x$5 === x1))) {
        var \u03b42$___1 = x$proxy2;
        var \u03b42$___2 = (-x$proxy1);
        break matchResult1;
      }
      var x$7 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__BT__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
      if (((x$7 === null) ? (x1 === null) : (x$7 === x1))) {
        var \u03b42$___1 = x$proxy1;
        var \u03b42$___2 = (-x$proxy2);
        break matchResult1;
      }
      var x$9 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__RL__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
      if (((x$9 === null) ? (x1 === null) : (x$9 === x1))) {
        var \u03b42$___1 = x$proxy2;
        var \u03b42$___2 = x$proxy1;
        break matchResult1;
      }
      throw new $c_s_MatchError(x1);
    }
    var px = (+\u03b42$___1);
    var py = (+\u03b42$___2);
    if (((px === 0.0) && (py === 0.0))) {
      var $x_2 = 128;
    } else {
      var ang = ((+Math.atan2(py, px)) + 4.71238898038469);
      if ((ang >= 6.283185307179586)) {
        ang = (ang - 6.283185307179586);
      }
      var $x_2 = $doubleToInt(((256.0 * ang) / 6.283185307179586));
    }
    return new $c_T3(px, py, $x_2);
  }
  throw new $c_s_MatchError(a);
});
$p.aOz = (function(llx, lly, urx, ury, c) {
  var cx = (0.5 * (llx + urx));
  var cy = (0.5 * (lly + ury));
  matchAlts1: {
    matchAlts2: {
      if (($m_s_None$() === c)) {
        break matchAlts2;
      }
      if ((c instanceof $c_s_Some)) {
        var x29 = c.J;
        var x$3 = $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__Underscore__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass();
        if (((x$3 === null) ? (x29 === null) : (x$3 === x29))) {
          break matchAlts2;
        }
        var x$5 = $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__C__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass();
        if (((x$5 === null) ? (x29 === null) : (x$5 === x29))) {
          break matchAlts2;
        }
      }
      break matchAlts1;
    }
    return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$Anchor(cx, cy, true, false, 0.0);
  }
  if ((c instanceof $c_s_Some)) {
    var x25 = c.J;
    var x$7 = $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__S__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass();
    if (((x$7 === null) ? (x25 === null) : (x$7 === x25))) {
      return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$Anchor(cx, lly, false, true, (-this.Fm));
    }
    var x$9 = $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__N__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass();
    if (((x$9 === null) ? (x25 === null) : (x$9 === x25))) {
      return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$Anchor(cx, ury, false, true, this.Fm);
    }
    var x$11 = $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__E__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass();
    if (((x$11 === null) ? (x25 === null) : (x$11 === x25))) {
      return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$Anchor(urx, cy, false, true, 0.0);
    }
    var x$13 = $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__W__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass();
    if (((x$13 === null) ? (x25 === null) : (x$13 === x25))) {
      return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$Anchor(llx, cy, false, true, 3.141592653589793);
    }
    var x$15 = $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__SE__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass();
    if (((x$15 === null) ? (x25 === null) : (x$15 === x25))) {
      return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$Anchor(urx, lly, false, true, (0.5 * (-this.Fm)));
    }
    var x$17 = $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__SW__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass();
    if (((x$17 === null) ? (x25 === null) : (x$17 === x25))) {
      return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$Anchor(llx, lly, false, true, (0.5 * ((-3.0) * this.Fm)));
    }
    var x$19 = $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__NE__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass();
    if (((x$19 === null) ? (x25 === null) : (x$19 === x25))) {
      return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$Anchor(urx, ury, false, true, (0.5 * this.Fm));
    }
    var x$21 = $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__NW__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass();
    if (((x$21 === null) ? (x25 === null) : (x$21 === x25))) {
      return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$Anchor(llx, ury, false, true, (0.5 * (3.0 * this.Fm)));
    }
  }
  throw new $c_s_MatchError(c);
});
$p.b7P = (function(n, g, portName, compass) {
  if (($m_s_None$() === portName)) {
    return $m_s_None$();
  }
  if ((portName instanceof $c_s_Some)) {
    var name = portName.J;
    var this$1 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().PN(n, g);
    if (this$1.c()) {
      var record = $m_s_None$();
    } else {
      var x0 = this$1.d();
      var this$2 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$().b1a(x0, name);
      if (this$2.c()) {
        var record = $m_s_None$();
      } else {
        var x0$1 = this$2.d();
        var record = new $c_s_Some($m_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$().aOz((+x0$1.bO), (+x0$1.bs), (+x0$1.ch), (+x0$1.ca), compass));
      }
    }
    return (record.c() ? $p_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$__htmlCellPort__Lorg_jpablo_graphexplorer_graphviz_model_RNode__T__s_Option__s_Option($m_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$(), n, name, compass) : record);
  }
  throw new $c_s_MatchError(portName);
});
$p.b33 = (function(side, rd) {
  var x = $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__TB__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
  if (((x === null) ? (rd === null) : (x === rd))) {
    return side;
  }
  var x$3 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__BT__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
  if (((x$3 === null) ? (rd === null) : (x$3 === rd))) {
    return ((this.uz === side) ? this.uy : ((this.uy === side) ? this.uz : side));
  }
  var x$5 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__LR__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
  if (((x$5 === null) ? (rd === null) : (x$5 === rd))) {
    return ((this.uz === side) ? this.yZ : ((this.uy === side) ? this.yY : ((this.yY === side) ? this.uz : ((this.yZ === side) ? this.uy : side))));
  }
  var x$7 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__RL__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
  if (((x$7 === null) ? (rd === null) : (x$7 === rd))) {
    return ((this.uz === side) ? this.yZ : ((this.uy === side) ? this.yY : ((this.yY === side) ? this.uy : ((this.yZ === side) ? this.uz : side))));
  }
  throw new $c_s_MatchError(rd);
});
$p.b32 = (function(angle, rd) {
  var x = $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__TB__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
  if (((x === null) ? (rd === null) : (x === rd))) {
    return angle;
  }
  var x$3 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__BT__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
  if (((x$3 === null) ? (rd === null) : (x$3 === rd))) {
    return (-angle);
  }
  var x$5 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__LR__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
  if (((x$5 === null) ? (rd === null) : (x$5 === rd))) {
    return (angle - 1.5707963267948966);
  }
  var x$7 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__RL__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
  if (((x$7 === null) ? (rd === null) : (x$7 === rd))) {
    return ((angle === 3.141592653589793) ? (-1.5707963267948966) : ((angle === 2.356194490192345) ? (-0.7853981633974483) : ((angle === 1.5707963267948966) ? 0.0 : ((angle === 0.0) ? 1.5707963267948966 : ((angle === (-0.7853981633974483)) ? 2.356194490192345 : ((angle === (-1.5707963267948966)) ? 3.141592653589793 : angle))))));
  }
  throw new $c_s_MatchError(rd);
});
$p.aNi = (function(x, y, rd) {
  var x$2 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__TB__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
  if (((x$2 === null) ? (rd === null) : (x$2 === rd))) {
    return new $c_T2(x, y);
  }
  var x$4 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__LR__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
  if (((x$4 === null) ? (rd === null) : (x$4 === rd))) {
    return new $c_T2(y, (-x));
  }
  var x$6 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__BT__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
  if (((x$6 === null) ? (rd === null) : (x$6 === rd))) {
    return new $c_T2(x, (-y));
  }
  var x$8 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__RL__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
  if (((x$8 === null) ? (rd === null) : (x$8 === rd))) {
    return new $c_T2(y, x);
  }
  throw new $c_s_MatchError(rd);
});
$p.a2S = (function(x, y, rd) {
  var x$2 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__TB__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
  if (((x$2 === null) ? (rd === null) : (x$2 === rd))) {
    return new $c_T2(x, y);
  }
  var x$4 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__LR__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
  if (((x$4 === null) ? (rd === null) : (x$4 === rd))) {
    return new $c_T2((-y), x);
  }
  var x$6 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__BT__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
  if (((x$6 === null) ? (rd === null) : (x$6 === rd))) {
    return new $c_T2(x, (-y));
  }
  var x$8 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__RL__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
  if (((x$8 === null) ? (rd === null) : (x$8 === rd))) {
    return new $c_T2(y, x);
  }
  throw new $c_s_MatchError(rd);
});
$p.aNh = (function(x, y, rd) {
  var x$2 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__TB__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
  if (((x$2 === null) ? (rd === null) : (x$2 === rd))) {
    return new $c_T2(x, y);
  }
  var x$4 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__BT__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
  if (((x$4 === null) ? (rd === null) : (x$4 === rd))) {
    return new $c_T2(x, (-y));
  }
  var x$6 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__LR__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
  if (((x$6 === null) ? (rd === null) : (x$6 === rd))) {
    return new $c_T2((-y), x);
  }
  var x$8 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__RL__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
  if (((x$8 === null) ? (rd === null) : (x$8 === rd))) {
    return new $c_T2(y, x);
  }
  throw new $c_s_MatchError(rd);
});
$p.Wx = (function(box, sides, compass, rd) {
  matchResult19: {
    var \u03b43$___1;
    var \u03b43$___2;
    var \u03b43$___3;
    var \u03b43$___4;
    if ((box !== null)) {
      var \u03b43$___1 = (+box.bO);
      var \u03b43$___2 = (+box.bs);
      var \u03b43$___3 = (+box.ch);
      var \u03b43$___4 = (+box.ca);
      break matchResult19;
    }
    throw new $c_s_MatchError(box);
  }
  var llx$2 = (+\u03b43$___1);
  var lly$2 = (+\u03b43$___2);
  var urx$2 = (+\u03b43$___3);
  var ury$2 = (+\u03b43$___4);
  var ctrx = (0.5 * (llx$2 + urx$2));
  var ctry = (0.5 * (lly$2 + ury$2));
  var px = ctrx;
  var py = ctry;
  var theta = 0.0;
  var constrain = false;
  var dyna = false;
  var side = 0;
  var clip = true;
  matchResult20: {
    if ((compass instanceof $c_s_Some)) {
      var x70 = compass.J;
      var x = $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__E__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass();
      if (((x === null) ? (x70 === null) : (x === x70))) {
        px = urx$2;
        theta = 0.0;
        constrain = true;
        clip = false;
        side = (sides & this.yZ);
        break matchResult20;
      }
      var x$3 = $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__S__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass();
      if (((x$3 === null) ? (x70 === null) : (x$3 === x70))) {
        py = lly$2;
        px = ctrx;
        theta = (-1.5707963267948966);
        constrain = true;
        clip = false;
        side = (sides & this.uy);
        break matchResult20;
      }
      var x$5 = $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__SE__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass();
      if (((x$5 === null) ? (x70 === null) : (x$5 === x70))) {
        py = lly$2;
        px = urx$2;
        theta = (-0.7853981633974483);
        constrain = true;
        clip = false;
        side = (sides & (this.uy | this.yZ));
        break matchResult20;
      }
      var x$7 = $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__SW__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass();
      if (((x$7 === null) ? (x70 === null) : (x$7 === x70))) {
        py = lly$2;
        px = llx$2;
        theta = (-2.356194490192345);
        constrain = true;
        clip = false;
        side = (sides & (this.uy | this.yY));
        break matchResult20;
      }
      var x$9 = $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__W__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass();
      if (((x$9 === null) ? (x70 === null) : (x$9 === x70))) {
        px = llx$2;
        theta = 3.141592653589793;
        constrain = true;
        clip = false;
        side = (sides & this.yY);
        break matchResult20;
      }
      var x$11 = $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__N__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass();
      if (((x$11 === null) ? (x70 === null) : (x$11 === x70))) {
        py = ury$2;
        px = ctrx;
        theta = 1.5707963267948966;
        constrain = true;
        clip = false;
        side = (sides & this.uz);
        break matchResult20;
      }
      var x$13 = $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__NE__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass();
      if (((x$13 === null) ? (x70 === null) : (x$13 === x70))) {
        py = ury$2;
        px = urx$2;
        theta = 0.7853981633974483;
        constrain = true;
        clip = false;
        side = (sides & (this.uz | this.yZ));
        break matchResult20;
      }
      var x$15 = $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__NW__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass();
      if (((x$15 === null) ? (x70 === null) : (x$15 === x70))) {
        py = ury$2;
        px = llx$2;
        theta = 2.356194490192345;
        constrain = true;
        clip = false;
        side = (sides & (this.uz | this.yY));
        break matchResult20;
      }
      var x$17 = $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__Underscore__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass();
      if (((x$17 === null) ? (x70 === null) : (x$17 === x70))) {
        dyna = true;
        side = sides;
        break matchResult20;
      }
    }
    matchAlts3: {
      matchAlts4: {
        if ((compass instanceof $c_s_Some)) {
          var x$19 = $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__C__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass();
          var x$20 = compass.J;
          var $x_1 = ((x$19 === null) ? (x$20 === null) : (x$19 === x$20));
        } else {
          var $x_1 = false;
        }
        if ($x_1) {
          break matchAlts4;
        }
        if (($m_s_None$() === compass)) {
          break matchAlts4;
        }
        break matchAlts3;
      }
      break matchResult20;
    }
    throw new $c_s_MatchError(compass);
  }
  matchResult21: {
    var \u03b44$___1;
    var \u03b44$___2;
    var x71 = this.aNi(px, py, rd);
    if ((x71 !== null)) {
      var \u03b44$___1 = (+x71.g());
      var \u03b44$___2 = (+x71.h());
      break matchResult21;
    }
    throw new $c_s_MatchError(x71);
  }
  var cpx$2 = (+\u03b44$___1);
  var cpy$2 = (+\u03b44$___2);
  $m_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort$();
  return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort(cpx$2, cpy$2, this.b32(theta, rd), constrain, clip, (dyna ? side : this.b33(side, rd)), true, dyna, new $c_s_Some(box));
});
$p.agn = (function(n, g, port) {
  var rd = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().pD(g);
  var this$1 = port.wx;
  var this$2 = (this$1.c() ? $m_s_None$() : new $c_s_Some(this$1.d().fU));
  var this$5 = ((this$2.c() || (this$2.d() !== "")) ? this$2 : $m_s_None$());
  if (this$5.c()) {
    return $m_s_None$();
  } else {
    var x0$2 = this$5.d();
    var this$6 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().PN(n, g);
    if (this$6.c()) {
      return $m_s_None$();
    } else {
      var x0$3 = this$6.d();
      matchResult23: {
        var $x_1;
        var x75 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$().afH(x0$3, x0$2);
        if ((x75 instanceof $c_s_Some)) {
          var f = x75.J;
          var $x_4 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$();
          var $x_3 = new $c_T4(f.n5, f.q0, f.q1, f.o2);
          var $x_2 = f.a82;
          var this$8 = port.ww;
          var $x_1 = $x_4.Wx($x_3, $x_2, (this$8.c() ? new $c_s_Some($s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__Underscore__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass()) : this$8), rd);
          break matchResult23;
        }
        if (($m_s_None$() === x75)) {
          var rootBox = new $c_T4(x0$3.n5, x0$3.q0, x0$3.q1, x0$3.o2);
          var $x_6 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$();
          var $x_5 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$().ZT;
          var this$11 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$__compassOfName__T__s_Option($m_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$(), x0$2);
          var $x_1 = $x_6.Wx(rootBox, $x_5, (this$11.c() ? new $c_s_Some($s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__C__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass()) : this$11), rd);
          break matchResult23;
        }
        throw new $c_s_MatchError(x75);
      }
      return new $c_s_Some($x_1);
    }
  }
});
$p.agm = (function(n, g, port) {
  var rd = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().pD(g);
  var this$1 = port.wx;
  var this$2 = (this$1.c() ? $m_s_None$() : new $c_s_Some(this$1.d().fU));
  var this$5 = ((this$2.c() || (this$2.d() !== "")) ? this$2 : $m_s_None$());
  if (this$5.c()) {
    return $m_s_None$();
  } else {
    var x0$2 = this$5.d();
    if ((!n.aK.n7.E("label"))) {
      return $m_s_None$();
    } else {
      var this$8 = n.aK.ag.r("fontsize");
      if (this$8.c()) {
        var this$12 = $m_s_None$();
      } else {
        var x0$3 = this$8.d();
        var this$12 = ($m_sc_StringParsers$().c1(x0$3) ? new $c_s_Some($m_jl_Double$().bd(x0$3)) : $m_s_None$());
      }
      var fs = (+(this$12.c() ? 14.0 : this$12.d()));
      var fn = n.aK.dL("fontname", "Times");
      var this$13 = $m_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$().mU(n.aK.dL("label", ""));
      var pf = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$$anon$1();
      var this$15 = ((!this$13.c()) ? new $c_s_PartialFunction$Lifted(pf).as(this$13.d()) : $m_s_None$());
      var this$16 = (this$15.c() ? $m_s_None$() : $m_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$().aMF(this$15.d(), x0$2, fs, fn, g.mj));
      if (this$16.c()) {
        return $m_s_None$();
      } else {
        var x0$5 = this$16.d();
        var box = x0$5.g();
        var sides = (x0$5.h() | 0);
        var $x_2 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$();
        var $x_1 = new $c_T4(box.lA, box.me, box.lB, box.mf);
        var this$18 = port.ww;
        return new $c_s_Some($x_2.Wx($x_1, sides, (this$18.c() ? new $c_s_Some($s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__Underscore__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass()) : this$18), rd));
      }
    }
  }
});
$p.aP3 = (function(n, g, port) {
  var rd = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().pD(g);
  var this$1 = port.ww;
  if (this$1.c()) {
    var this$2 = port.wx;
    var this$3 = (this$2.c() ? $m_s_None$() : new $c_s_Some(this$2.d().fU));
    if (this$3.c()) {
      var cs = $m_s_None$();
    } else {
      var x0$1 = this$3.d();
      var cs = $p_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$__compassOfName__T__s_Option($m_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$(), x0$1);
    }
  } else {
    var cs = this$1;
  }
  if (cs.c()) {
    return $m_s_None$();
  } else {
    var x0$2 = cs.d();
    var this$4 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().XB(n, g);
    if (this$4.c()) {
      return $m_s_None$();
    } else {
      var x0$3 = this$4.d();
      var x$proxy3 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().aiC(x0$3);
      var w2 = (0.5 * x$proxy3);
      var x$proxy4 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().agq(x0$3);
      var h2 = (0.5 * x$proxy4);
      var \u03b49$ = $m_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$().Wx(new $c_T4((-w2), (-h2), w2, h2), $m_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$().ZT, new $c_s_Some(x0$2), rd);
      var bp$1 = $m_s_None$();
      var base = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort(\u03b49$.pW, \u03b49$.uB, \u03b49$.pX, \u03b49$.uA, \u03b49$.rq, \u03b49$.fV, \u03b49$.o1, \u03b49$.Bu, bp$1);
      var this$7 = n.aK.dL("shape", "ellipse");
      var shapeName = this$7.toLowerCase();
      var ellipseLike = $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_T.r().C)(["ellipse", "circle", "oval", "doublecircle", "point"]))).E(shapeName);
      var x = $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__E__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass();
      if (((x === null) ? (x0$2 === null) : (x === x0$2))) {
        var ray = new $c_s_Some(new $c_T2(1.0, 0.0));
      } else {
        var x$3 = $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__W__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass();
        if (((x$3 === null) ? (x0$2 === null) : (x$3 === x0$2))) {
          var ray = new $c_s_Some(new $c_T2((-1.0), 0.0));
        } else {
          var x$5 = $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__N__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass();
          if (((x$5 === null) ? (x0$2 === null) : (x$5 === x0$2))) {
            var ray = new $c_s_Some(new $c_T2(0.0, 1.0));
          } else {
            var x$7 = $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__S__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass();
            if (((x$7 === null) ? (x0$2 === null) : (x$7 === x0$2))) {
              var ray = new $c_s_Some(new $c_T2(0.0, (-1.0)));
            } else {
              var x$9 = $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__NE__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass();
              if (((x$9 === null) ? (x0$2 === null) : (x$9 === x0$2))) {
                var ray = new $c_s_Some(new $c_T2(1.0, 1.0));
              } else {
                var x$11 = $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__NW__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass();
                if (((x$11 === null) ? (x0$2 === null) : (x$11 === x0$2))) {
                  var ray = new $c_s_Some(new $c_T2((-1.0), 1.0));
                } else {
                  var x$13 = $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__SE__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass();
                  if (((x$13 === null) ? (x0$2 === null) : (x$13 === x0$2))) {
                    var ray = new $c_s_Some(new $c_T2(1.0, (-1.0)));
                  } else {
                    var x$15 = $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__SW__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass();
                    if (((x$15 === null) ? (x0$2 === null) : (x$15 === x0$2))) {
                      var ray = new $c_s_Some(new $c_T2((-1.0), (-1.0)));
                    } else {
                      var ray = $m_s_None$();
                    }
                  }
                }
              }
            }
          }
        }
      }
      matchResult34: {
        var $x_1;
        var x108 = (ellipseLike ? ray : $m_s_None$());
        if ((x108 instanceof $c_s_Some)) {
          var x110 = x108.J;
          if ((x110 !== null)) {
            var rx = (+x110.g());
            var ry = (+x110.h());
            var this$26 = n.aK.ag.r("penwidth");
            if (this$26.c()) {
              var this$30 = $m_s_None$();
            } else {
              var x0$4 = this$26.d();
              var this$30 = ($m_sc_StringParsers$().c1(x0$4) ? new $c_s_Some($m_jl_Double$().bd(x0$4)) : $m_s_None$());
            }
            if (this$30.c()) {
              var this$33 = $m_s_None$();
            } else {
              var x0$5 = this$30.d();
              var _$10 = (+x0$5);
              var this$33 = new $c_s_Some((+Math.max(0.0, _$10)));
            }
            var pw = (+(this$33.c() ? 1.0 : this$33.d()));
            var urx = (w2 + (0.5 * pw));
            var ury = (h2 + (0.5 * pw));
            var maxv = (4.0 * (+Math.max(w2, h2)));
            var _1$1 = (rx * maxv);
            var _2$1 = (ry * maxv);
            matchResult32: {
              var \u03b411$___1;
              var \u03b411$___2;
              var x102 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$().aNi(_1$1, _2$1, rd);
              if ((x102 !== null)) {
                var \u03b411$___1 = (+x102.g());
                var \u03b411$___2 = (+x102.h());
                break matchResult32;
              }
              throw new $c_s_MatchError(x102);
            }
            var cx0$2 = (+\u03b411$___1);
            var cy0$2 = (+\u03b411$___2);
            var curve = new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY.r().C)([new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(0.0, 0.0), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(0.0, 0.0), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(cx0$2, cy0$2), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(cx0$2, cy0$2)]);
            var this$42 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$();
            var seg = curve.ae();
            var best = curve.ae();
            var found = false;
            var low = 0.0;
            var high = 1.0;
            var pt = curve.a[0];
            var opt = pt;
            var first = true;
            while (true) {
              if (first) {
                var $x_3 = true;
              } else {
                var x$1 = (opt.W - pt.W);
                var $x_3 = ((+Math.abs(x$1)) > 0.5);
              }
              if ($x_3) {
                var $x_2 = true;
              } else {
                var x$2 = (opt.a6 - pt.a6);
                var $x_2 = ((+Math.abs(x$2)) > 0.5);
              }
              if ($x_2) {
                first = false;
                opt = pt;
                var t = (0.5 * (high + low));
                matchResult71: {
                  var \u03b428$___1;
                  var \u03b428$___2;
                  var \u03b428$___3;
                  var x246 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__bezier__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__I__D__T3(this$42, curve, 0, t);
                  if ((x246 !== null)) {
                    var \u03b428$___1 = x246.bH;
                    var \u03b428$___2 = x246.bU;
                    var \u03b428$___3 = x246.c3;
                    break matchResult71;
                  }
                  throw new $c_s_MatchError(x246);
                }
                var p$2 = \u03b428$___1;
                var r$2 = \u03b428$___3;
                pt = p$2;
                r$2.av(0, seg, 0, 4);
                var x0$6 = pt;
                matchResult33: {
                  var \u03b412$___1;
                  var \u03b412$___2;
                  var x105 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$().a2S(x0$6.W, x0$6.a6, rd);
                  if ((x105 !== null)) {
                    var \u03b412$___1 = (+x105.g());
                    var \u03b412$___2 = (+x105.h());
                    break matchResult33;
                  }
                  throw new $c_s_MatchError(x105);
                }
                var px$2 = (+\u03b412$___1);
                var py$2 = (+\u03b412$___2);
                if (((!(((+Math.abs(px$2)) > urx) || ((+Math.abs(py$2)) > ury))) && ($m_jl_Math$().ga((px$2 / urx), (py$2 / ury)) < 1.0))) {
                  low = t;
                  seg.av(0, best, 0, 4);
                  found = true;
                } else {
                  high = t;
                }
              } else {
                break;
              }
            }
            var srcseg = (found ? best : seg);
            srcseg.av(0, curve, 0, 4);
            var $x_1 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort(curve.a[0].W, curve.a[0].a6, base.pX, base.uA, base.rq, base.fV, base.o1, base.Bu, base.z0);
            break matchResult34;
          }
        }
        if (($m_s_None$() === x108)) {
          var $x_1 = base;
          break matchResult34;
        }
        throw new $c_s_MatchError(x108);
      }
      return new $c_s_Some($x_1);
    }
  }
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$, "org.jpablo.graphexplorer.graphviz.layout.PortAnchor$", ({
  va: 1
}));
var $n_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$;
function $m_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$() {
  if ((!$n_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$)) {
    $n_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$ = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$();
  }
  return $n_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__minlenOf__Lorg_jpablo_graphexplorer_graphviz_model_Attrs__I($thiz, attrs) {
  var this$1 = attrs.ag.r("minlen");
  var this$4 = (this$1.c() ? $m_s_None$() : $m_sc_StringParsers$().hT(this$1.d()));
  return ((this$4.c() ? 1 : this$4.d()) | 0);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__acyclic__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__I__sci_Vector($thiz, g, minlenScale) {
  var edges = g.cu.d8(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e) => (e.ai !== e.ak))), false);
  var outIdx = new $c_scm_LinkedHashMap();
  g.cB.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n) => {
    $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(outIdx, n.br, ($m_scm_ArrayBuffer$(), $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer())), false);
  })));
  $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(edges).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    matchResult6: {
      if ((x$1 !== null)) {
        var e$1 = x$1.g();
        var i = (x$1.h() | 0);
        if ($m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().Wz(e$1.b4)) {
          var key$1 = e$1.ai;
          var originalHash = $m_sr_Statics$().u(key$1);
          var hash = (originalHash ^ ((originalHash >>> 16) | 0));
          var idx = (hash & ((outIdx.au.a.length - 1) | 0));
          var x1 = outIdx.au.a[idx];
          var nd = ((x1 === null) ? null : x1.ij(key$1, hash));
          if ((nd !== null)) {
            var $x_1 = nd.fs;
          } else {
            var table0 = outIdx.au;
            $m_scm_ArrayBuffer$();
            var default$1 = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
            if ((((1 + outIdx.e0) | 0) >= outIdx.ki)) {
              $p_scm_LinkedHashMap__growTable__I__V(outIdx, (outIdx.au.a.length << 1));
            }
            $p_scm_LinkedHashMap__put0__O__O__Z__I__I__s_Some(outIdx, key$1, default$1, false, hash, ((table0 === outIdx.au) ? idx : (hash & ((outIdx.au.a.length - 1) | 0))));
            var $x_1 = default$1;
          }
          $x_1.Y(i);
          break matchResult6;
        } else {
          break matchResult6;
        }
      }
      throw new $c_s_MatchError(x$1);
    }
  })));
  var nodeSeq = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$16(new $c_sc_Iterator$$anon$9(g.cB.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4) => _$4.br)))));
  var this$10 = new $c_sc_MapOps$$anon$1(outIdx);
  var it = this$10.o();
  while (it.p()) {
    var x0 = it.q();
    var sorted = $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(x0, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((nodeSeq, edges) => ((i$1) => {
      var i$2 = (i$1 | 0);
      return new $c_T2(nodeSeq.ay(edges.l(i$2).ak, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 2147483647))), i$2);
    }))(nodeSeq, edges)), new $c_s_math_Ordering$Tuple2Ordering($m_s_math_Ordering$Int$(), $m_s_math_Ordering$Int$()));
    $p_scm_ArrayBuffer__reduceToSize__I__V(x0, 0);
    x0.gS(sorted);
  }
  var reversed = $m_scm_Set$().aO();
  var mark = $m_scm_Set$().aO();
  var onStack = $m_scm_Set$().aO();
  g.cB.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n$2) => {
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__dfs$1__scm_Set__scm_Set__scm_LinkedHashMap__sci_Vector__scm_Set__T__V($thiz, mark, onStack, outIdx, edges, reversed, n$2.br);
  })));
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(edges).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    if ((x$1$2 !== null)) {
      var e$2 = x$1$2.g();
      var i$3 = (x$1$2.h() | 0);
      var ml = Math.imul($p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__minlenOf__Lorg_jpablo_graphexplorer_graphviz_model_Attrs__I($m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$(), e$2.b4), minlenScale);
      return (reversed.E(i$3) ? new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$DEdge(e$2.ak, e$2.ai, ml) : new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$DEdge(e$2.ai, e$2.ak, ml));
    }
    throw new $c_s_MatchError(x$1$2);
  })));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__rankConstraints__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__Lorg_jpablo_graphexplorer_graphviz_layout_Rank$RankSets($thiz, g) {
  var parent = $m_scm_Map$().aO();
  var nodeSet = $m_sci_Set$().af(new $c_sc_Iterator$$anon$9(g.cB.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$5) => _$5.br))));
  $m_scm_ArrayBuffer$();
  var minMembers = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  $m_scm_ArrayBuffer$();
  var maxMembers = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  var slenX = new $c_sr_IntRef(0);
  var slenY = new $c_sr_IntRef(0);
  var this$8 = g.f2.ag.r("rank");
  $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__walk$1__s_Option__sci_Set__scm_ArrayBuffer__sr_IntRef__scm_ArrayBuffer__sr_IntRef__scm_Map__sci_Vector__V($thiz, ((this$8.c() || (this$8.d() !== "")) ? this$8 : $m_s_None$()), nodeSet, minMembers, slenX, maxMembers, slenY, parent, g.uF);
  var f$1 = ((a, b) => {
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__union$1__scm_Map__T__T__V($thiz, parent, a, b);
    return b;
  });
  switch (minMembers.a1) {
    case (-1): {
      var it = minMembers.bB().o();
      if (it.p()) {
        var acc = it.q();
        while (it.p()) {
          var x0$1 = acc;
          var x1$1 = it.q();
          acc = f$1(x0$1, x1$1);
        }
      }
      break;
    }
    case 0: {
      break;
    }
    default: {
      if ((minMembers.a1 > 0)) {
        var start = 1;
        var end = minMembers.a1;
        var z = minMembers.hl.a[0];
        while (true) {
          if ((start === end)) {
            break;
          } else {
            var temp$start = ((1 + start) | 0);
            var x0$2 = z;
            var x1$2 = minMembers.hl.a[start];
            var temp$z = f$1(x0$2, x1$2);
            start = temp$start;
            z = temp$z;
          }
        }
      } else {
        matchEnd4: {
          if ((minMembers.a1 > 0)) {
            var z$1 = minMembers.l(0);
            var at = 1;
            var end$1 = minMembers.a1;
            var acc$1 = z$1;
            while (true) {
              if ((at === end$1)) {
                break matchEnd4;
              } else {
                var temp$at = ((1 + at) | 0);
                var x0$3 = acc$1;
                var x1$3 = minMembers.l(at);
                var temp$acc = f$1(x0$3, x1$3);
                at = temp$at;
                acc$1 = temp$acc;
              }
            }
          }
          if ((minMembers.a1 === 0)) {
            throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.reduceLeft");
          }
          var it$1 = minMembers.bB().o();
          if (it$1.p()) {
            var acc$2 = it$1.q();
            while (it$1.p()) {
              var x0$4 = acc$2;
              var x1$4 = it$1.q();
              acc$2 = f$1(x0$4, x1$4);
            }
          } else {
            throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.reduceLeft");
          }
        }
      }
    }
  }
  var f$2 = ((a$2, b$2) => {
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__union$1__scm_Map__T__T__V($thiz, parent, a$2, b$2);
    return b$2;
  });
  switch (maxMembers.a1) {
    case (-1): {
      var it$2 = maxMembers.bB().o();
      if (it$2.p()) {
        var acc$3 = it$2.q();
        while (it$2.p()) {
          var x0$5 = acc$3;
          var x1$6 = it$2.q();
          acc$3 = f$2(x0$5, x1$6);
        }
      }
      break;
    }
    case 0: {
      break;
    }
    default: {
      if ((maxMembers.a1 > 0)) {
        var start$1 = 1;
        var end$2 = maxMembers.a1;
        var z$2 = maxMembers.hl.a[0];
        while (true) {
          if ((start$1 === end$2)) {
            break;
          } else {
            var temp$start$1 = ((1 + start$1) | 0);
            var x0$6 = z$2;
            var x1$7 = maxMembers.hl.a[start$1];
            var temp$z$1 = f$2(x0$6, x1$7);
            start$1 = temp$start$1;
            z$2 = temp$z$1;
          }
        }
      } else {
        matchEnd4$1: {
          if ((maxMembers.a1 > 0)) {
            var z$3 = maxMembers.l(0);
            var at$1 = 1;
            var end$3 = maxMembers.a1;
            var acc$4 = z$3;
            while (true) {
              if ((at$1 === end$3)) {
                break matchEnd4$1;
              } else {
                var temp$at$1 = ((1 + at$1) | 0);
                var x0$7 = acc$4;
                var x1$8 = maxMembers.l(at$1);
                var temp$acc$1 = f$2(x0$7, x1$8);
                at$1 = temp$at$1;
                acc$4 = temp$acc$1;
              }
            }
          }
          if ((maxMembers.a1 === 0)) {
            throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.reduceLeft");
          }
          var it$3 = maxMembers.bB().o();
          if (it$3.p()) {
            var acc$5 = it$3.q();
            while (it$3.p()) {
              var x0$8 = acc$5;
              var x1$9 = it$3.q();
              acc$5 = f$2(x0$8, x1$9);
            }
          } else {
            throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.reduceLeft");
          }
        }
      }
    }
  }
  var leader = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x) => $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__find$1__scm_Map__T__T($thiz, parent, x)));
  var this$12 = $f_sc_IndexedSeqOps__headOption__s_Option(minMembers);
  var minset = (this$12.c() ? $m_s_None$() : new $c_s_Some($p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__find$1__scm_Map__T__T($thiz, parent, this$12.d())));
  var this$13 = $f_sc_IndexedSeqOps__headOption__s_Option(maxMembers);
  return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$RankSets(leader, minset, (this$13.c() ? $m_s_None$() : new $c_s_Some($p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__find$1__scm_Map__T__T($thiz, parent, this$13.d()))), slenX.an, slenY.an);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__mapbool__s_Option__Z($thiz, v) {
  if ((!v.c())) {
    var x0 = v.d();
    var x20 = x0.toLowerCase();
    switch (x20) {
      case "true":
      case "yes": {
        return true;
        break;
      }
      case "false":
      case "no": {
        return false;
        break;
      }
      default: {
        var this$3 = $m_sc_StringParsers$().hT(x20);
        return ((!this$3.c()) && ((this$3.d() | 0) > 0));
      }
    }
  } else {
    return false;
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__rankedImpl__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T2($thiz, g) {
  var tops = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__topClusters$1__sci_Vector__sci_Vector($thiz, g.uF);
  return ((((!$f_sc_SeqOps__isEmpty__Z(tops)) && (!$p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__mapbool__s_Option__Z($thiz, g.f2.ag.r("newrank")))) && (!$p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__crossClusterRankSet$1__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__Z($thiz, tops, g))) ? $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__rankedDot1__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Vector__T2($thiz, g, tops) : $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__rankedGlobal__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T2($thiz, g));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__weightOf__Lorg_jpablo_graphexplorer_graphviz_model_Attrs__I($thiz, a) {
  var this$1 = a.ag.r("weight");
  if (this$1.c()) {
    var this$5 = $m_s_None$();
  } else {
    var x0 = this$1.d();
    var this$5 = ($m_sc_StringParsers$().c1(x0) ? new $c_s_Some($m_jl_Double$().bd(x0)) : $m_s_None$());
  }
  if (this$5.c()) {
    var this$8 = $m_s_None$();
  } else {
    var x0$1 = this$5.d();
    var w = (+x0$1);
    var y = $doubleToInt(w);
    var this$8 = new $c_s_Some(((y < 0) ? 0 : y));
  }
  return ((this$8.c() ? 1 : this$8.d()) | 0);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__solvePerComponent__sci_Vector__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance__sci_Vector__sci_Map($thiz, nodes, edges, balance, tbOrder) {
  var parent = $ct_scm_HashMap__(new $c_scm_HashMap());
  edges.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e) => {
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__union$2__scm_HashMap__T__T__V($thiz, parent, e.pT, e.rp);
  })));
  var compOf = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$9(nodes.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n) => new $c_T2(n, $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__find$2__scm_HashMap__T__T($thiz, parent, n))))));
  var roots = new $c_scm_LinkedHashSet();
  nodes.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n$2) => roots.OV(compOf.i(n$2)))));
  if ((roots.nr <= 1)) {
    var this$11 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$();
    if ($f_sc_SeqOps__isEmpty__Z(nodes)) {
      return $m_sci_Map$EmptyMap$();
    }
    var N = nodes.C();
    if ((N <= 0)) {
      var normal = new $ac_Z(0);
    } else {
      var array = new $ac_Z(N);
      var i = 0;
      while ((i < N)) {
        var $x_1 = i;
        var x0 = i;
        var x0$1 = nodes.l(x0);
        array.a[$x_1] = (!($m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$(), (!(!x0$1.startsWith("%slack:")))));
        i = ((1 + i) | 0);
      }
      var normal = array;
    }
    var idx = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$16(nodes.o()));
    var E = edges.C();
    if ((E <= 0)) {
      var etail = new $ac_I(0);
    } else {
      var array$1 = new $ac_I(E);
      var i$1 = 0;
      while ((i$1 < E)) {
        var $x_2 = i$1;
        var x0$2 = i$1;
        array$1.a[$x_2] = (idx.i(edges.l(x0$2).pT) | 0);
        i$1 = ((1 + i$1) | 0);
      }
      var etail = array$1;
    }
    if ((E <= 0)) {
      var ehead = new $ac_I(0);
    } else {
      var array$2 = new $ac_I(E);
      var i$2 = 0;
      while ((i$2 < E)) {
        var $x_3 = i$2;
        var x0$3 = i$2;
        array$2.a[$x_3] = (idx.i(edges.l(x0$3).rp) | 0);
        i$2 = ((1 + i$2) | 0);
      }
      var ehead = array$2;
    }
    if ((E <= 0)) {
      var eminlen = new $ac_I(0);
    } else {
      var array$3 = new $ac_I(E);
      var i$3 = 0;
      while ((i$3 < E)) {
        array$3.a[i$3] = edges.l(i$3).ut;
        i$3 = ((1 + i$3) | 0);
      }
      var eminlen = array$3;
    }
    if ((E <= 0)) {
      var eweight = new $ac_I(0);
    } else {
      var array$4 = new $ac_I(E);
      var i$4 = 0;
      while ((i$4 < E)) {
        array$4.a[i$4] = edges.l(i$4).uu;
        i$4 = ((1 + i$4) | 0);
      }
      var eweight = array$4;
    }
    if ((E <= 0)) {
      var cutvalue = new $ac_I(0);
    } else {
      var array$5 = new $ac_I(E);
      var i$5 = 0;
      while ((i$5 < E)) {
        array$5.a[i$5] = 0;
        i$5 = ((1 + i$5) | 0);
      }
      var cutvalue = array$5;
    }
    if ((E <= 0)) {
      var treeIndex = new $ac_I(0);
    } else {
      var array$6 = new $ac_I(E);
      var i$6 = 0;
      while ((i$6 < E)) {
        array$6.a[i$6] = (-1);
        i$6 = ((1 + i$6) | 0);
      }
      var treeIndex = array$6;
    }
    if ((N <= 0)) {
      var outB = new ($d_scm_ArrayBuffer.r().C)(0);
    } else {
      var array$7 = new ($d_scm_ArrayBuffer.r().C)(N);
      var i$7 = 0;
      while ((i$7 < N)) {
        array$7.a[i$7] = ($m_scm_ArrayBuffer$(), $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer()));
        i$7 = ((1 + i$7) | 0);
      }
      var outB = array$7;
    }
    if ((N <= 0)) {
      var inB = new ($d_scm_ArrayBuffer.r().C)(0);
    } else {
      var array$8 = new ($d_scm_ArrayBuffer.r().C)(N);
      var i$8 = 0;
      while ((i$8 < N)) {
        array$8.a[i$8] = ($m_scm_ArrayBuffer$(), $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer()));
        i$8 = ((1 + i$8) | 0);
      }
      var inB = array$8;
    }
    var i0 = 0;
    while ((i0 < E)) {
      outB.a[etail.a[i0]].aw(i0);
      inB.a[ehead.a[i0]].aw(i0);
      i0 = ((1 + i0) | 0);
    }
    var len = outB.a.length;
    var ys = new ($d_I.r().r().C)(len);
    if ((len > 0)) {
      var i$9 = 0;
      while ((i$9 < len)) {
        var $x_5 = i$9;
        var x0$6 = outB.a[i$9];
        if ((x0$6.a1 >= 0)) {
          var destination = new $ac_I(x0$6.a1);
          x0$6.cR(destination, 0, 2147483647);
          var $x_4 = destination;
        } else {
          var capacity = 0;
          var size = 0;
          var jsElems = null;
          capacity = 0;
          size = 0;
          jsElems = [];
          var it = x0$6.bB().o();
          while (it.p()) {
            var elem$3 = it.q();
            var unboxedElem = ((elem$3 === null) ? 0 : elem$3);
            jsElems.push(unboxedElem);
          }
          var $x_4 = new $ac_I(new Int32Array(jsElems));
        }
        ys.a[$x_5] = $x_4;
        i$9 = ((1 + i$9) | 0);
      }
    }
    var len$2 = inB.a.length;
    var ys$1 = new ($d_I.r().r().C)(len$2);
    if ((len$2 > 0)) {
      var i$10 = 0;
      while ((i$10 < len$2)) {
        var $x_7 = i$10;
        var x0$7 = inB.a[i$10];
        if ((x0$7.a1 >= 0)) {
          var destination$1 = new $ac_I(x0$7.a1);
          x0$7.cR(destination$1, 0, 2147483647);
          var $x_6 = destination$1;
        } else {
          var capacity$1 = 0;
          var size$1 = 0;
          var jsElems$1 = null;
          capacity$1 = 0;
          size$1 = 0;
          jsElems$1 = [];
          var it$1 = x0$7.bB().o();
          while (it$1.p()) {
            var elem$4 = it$1.q();
            var unboxedElem$1 = ((elem$4 === null) ? 0 : elem$4);
            jsElems$1.push(unboxedElem$1);
          }
          var $x_6 = new $ac_I(new Int32Array(jsElems$1));
        }
        ys$1.a[$x_7] = $x_6;
        i$10 = ((1 + i$10) | 0);
      }
    }
    if ((N <= 0)) {
      var rank = new $ac_I(0);
    } else {
      var array$9 = new $ac_I(N);
      var i$11 = 0;
      while ((i$11 < N)) {
        array$9.a[i$11] = (nodes.l(i$11), 0);
        i$11 = ((1 + i$11) | 0);
      }
      var rank = array$9;
    }
    if ((N <= 0)) {
      var prio = new $ac_I(0);
    } else {
      var array$10 = new $ac_I(N);
      var i$12 = 0;
      while ((i$12 < N)) {
        array$10.a[i$12] = 0;
        i$12 = ((1 + i$12) | 0);
      }
      var prio = array$10;
    }
    if ((N <= 0)) {
      var low = new $ac_I(0);
    } else {
      var array$11 = new $ac_I(N);
      var i$13 = 0;
      while ((i$13 < N)) {
        array$11.a[i$13] = 0;
        i$13 = ((1 + i$13) | 0);
      }
      var low = array$11;
    }
    if ((N <= 0)) {
      var lim = new $ac_I(0);
    } else {
      var array$12 = new $ac_I(N);
      var i$14 = 0;
      while ((i$14 < N)) {
        array$12.a[i$14] = 0;
        i$14 = ((1 + i$14) | 0);
      }
      var lim = array$12;
    }
    if ((N <= 0)) {
      var par = new $ac_I(0);
    } else {
      var array$13 = new $ac_I(N);
      var i$15 = 0;
      while ((i$15 < N)) {
        array$13.a[i$15] = (-1);
        i$15 = ((1 + i$15) | 0);
      }
      var par = array$13;
    }
    if ((N <= 0)) {
      var treeOut = new ($d_scm_ArrayBuffer.r().C)(0);
    } else {
      var array$14 = new ($d_scm_ArrayBuffer.r().C)(N);
      var i$16 = 0;
      while ((i$16 < N)) {
        array$14.a[i$16] = ($m_scm_ArrayBuffer$(), $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer()));
        i$16 = ((1 + i$16) | 0);
      }
      var treeOut = array$14;
    }
    if ((N <= 0)) {
      var treeIn = new ($d_scm_ArrayBuffer.r().C)(0);
    } else {
      var array$15 = new ($d_scm_ArrayBuffer.r().C)(N);
      var i$17 = 0;
      while ((i$17 < N)) {
        array$15.a[i$17] = ($m_scm_ArrayBuffer$(), $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer()));
        i$17 = ((1 + i$17) | 0);
      }
      var treeIn = array$15;
    }
    $m_scm_ArrayBuffer$();
    var treeEdge = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
    var feasible = true;
    var v0 = 0;
    while ((v0 < N)) {
      prio.a[v0] = ys$1.a[v0].a.length;
      var k = 0;
      while ((k < ys$1.a[v0].a.length)) {
        var e$1 = ys$1.a[v0].a[k];
        if ((((rank.a[ehead.a[e$1]] - rank.a[etail.a[e$1]]) | 0) < eminlen.a[e$1])) {
          feasible = false;
        }
        k = ((1 + k) | 0);
      }
      v0 = ((1 + v0) | 0);
    }
    if ((!feasible)) {
      var q = $ct_scm_Queue__I__(new $c_scm_Queue(), 16);
      var v = 0;
      while ((v < N)) {
        if ((prio.a[v] === 0)) {
          q.km(v);
        }
        v = ((1 + v) | 0);
      }
      while ((!q.c())) {
        var u = (q.h7(false) | 0);
        rank.a[u] = 0;
        var k$2 = 0;
        while ((k$2 < ys$1.a[u].a.length)) {
          var e$2 = ys$1.a[u].a[k$2];
          var x = rank.a[u];
          var y$1 = ((rank.a[etail.a[e$2]] + eminlen.a[e$2]) | 0);
          rank.a[u] = ((x > y$1) ? x : y$1);
          k$2 = ((1 + k$2) | 0);
        }
        k$2 = 0;
        while ((k$2 < ys.a[u].a.length)) {
          var e$3 = ys.a[u].a[k$2];
          var i$1$1 = ehead.a[e$3];
          prio.a[i$1$1] = ((prio.a[i$1$1] - 1) | 0);
          if ((prio.a[ehead.a[e$3]] <= 0)) {
            q.km(ehead.a[e$3]);
          }
          k$2 = ((1 + k$2) | 0);
        }
      }
    }
    if ((N <= 0)) {
      var nodeSubtree = new $ac_I(0);
    } else {
      var array$16 = new $ac_I(N);
      var i$18 = 0;
      while ((i$18 < N)) {
        array$16.a[i$18] = (-1);
        i$18 = ((1 + i$18) | 0);
      }
      var nodeSubtree = array$16;
    }
    $m_scm_ArrayBuffer$();
    var stRep = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
    $m_scm_ArrayBuffer$();
    var stSize = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
    $m_scm_ArrayBuffer$();
    var stHeap = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
    $m_scm_ArrayBuffer$();
    var stPar = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
    $m_scm_ArrayBuffer$();
    var heapElt = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
    var n0 = 0;
    while ((n0 < N)) {
      if ((nodeSubtree.a[n0] === (-1))) {
        var st = $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__newSubtree$1__scm_ArrayBuffer__scm_ArrayBuffer__scm_ArrayBuffer__scm_ArrayBuffer__I__I(this$11, stRep, stSize, stHeap, stPar, n0);
        stSize.cM(st, $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__tightSubtreeSearch$1__AI__AAI__AI__AI__AI__AI__AI__AAI__scm_ArrayBuffer__Ascm_ArrayBuffer__Ascm_ArrayBuffer__I__I__I(this$11, nodeSubtree, ys$1, treeIndex, etail, rank, ehead, eminlen, ys, treeEdge, treeOut, treeIn, n0, st));
        heapElt.aw(st);
      }
      n0 = ((1 + n0) | 0);
    }
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__buildHeap$1__scm_ArrayBuffer__scm_ArrayBuffer__scm_ArrayBuffer__V(this$11, heapElt, stHeap, stSize);
    while ((heapElt.a1 > 1)) {
      var tree0 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__extractMin$1__scm_ArrayBuffer__scm_ArrayBuffer__scm_ArrayBuffer__I(this$11, heapElt, stHeap, stSize);
      var ee = $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__interTreeEdgeSearch$1__AI__AI__AI__AI__AAI__AI__AAI__AI__scm_ArrayBuffer__I__I__I__I(this$11, rank, ehead, etail, eminlen, ys, treeIndex, ys$1, nodeSubtree, stPar, (stRep.l(tree0) | 0), (-1), (-1));
      if ((ee < 0)) {
        $p_scm_ArrayBuffer__reduceToSize__I__V(heapElt, 0);
      } else {
        $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__heapify$1__scm_ArrayBuffer__scm_ArrayBuffer__scm_ArrayBuffer__I__V(this$11, heapElt, stSize, stHeap, (stHeap.l($p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__mergeTrees$1__AI__AI__scm_ArrayBuffer__AI__AI__scm_ArrayBuffer__AI__scm_ArrayBuffer__Ascm_ArrayBuffer__Ascm_ArrayBuffer__AI__scm_ArrayBuffer__scm_ArrayBuffer__I__I(this$11, etail, ehead, stHeap, rank, eminlen, stRep, nodeSubtree, stPar, treeIn, treeOut, treeIndex, treeEdge, stSize, ee)) | 0));
      }
    }
    if ((treeEdge.a1 === ((N - 1) | 0))) {
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__dfsRangeInit$1__AI__AI__Ascm_ArrayBuffer__AI__Ascm_ArrayBuffer__AI__AI__I__V(this$11, par, low, treeOut, ehead, treeIn, etail, lim, 0);
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__dfsCutval$1__Ascm_ArrayBuffer__AI__Ascm_ArrayBuffer__AI__AI__AAI__AAI__AI__AI__AI__AI__AI__I__I__V(this$11, treeOut, ehead, treeIn, etail, par, ys, ys$1, cutvalue, low, lim, eweight, treeIndex, 0, (-1));
    }
    var elem$7 = 0;
    elem$7 = 0;
    var enterE = new $c_sr_IntRef((-1));
    var enterSlack = new $c_sr_IntRef(0);
    var LowC = new $c_sr_IntRef(0);
    var LimC = new $c_sr_IntRef(0);
    if ((treeEdge.a1 === ((N - 1) | 0))) {
      var maxiter = ((1000 + Math.imul((N << 2), ((1 + E) | 0))) | 0);
      var iter = 0;
      _return$1: {
        var rv = (-1);
        var cnt = 0;
        var j = elem$7;
        while ((elem$7 < treeEdge.a1)) {
          var f$1 = (treeEdge.l(elem$7) | 0);
          if ((cutvalue.a[f$1] < 0)) {
            if (((rv < 0) || (cutvalue.a[rv] > cutvalue.a[f$1]))) {
              rv = f$1;
            }
            cnt = ((1 + cnt) | 0);
            if ((cnt >= 30)) {
              var e$4 = rv;
              break _return$1;
            }
          }
          elem$7 = ((1 + elem$7) | 0);
        }
        if ((j > 0)) {
          elem$7 = 0;
          while ((elem$7 < j)) {
            var f$2 = (treeEdge.l(elem$7) | 0);
            if ((cutvalue.a[f$2] < 0)) {
              if (((rv < 0) || (cutvalue.a[rv] > cutvalue.a[f$2]))) {
                rv = f$2;
              }
              cnt = ((1 + cnt) | 0);
              if ((cnt >= 30)) {
                var e$4 = rv;
                break _return$1;
              }
            }
            elem$7 = ((1 + elem$7) | 0);
          }
        }
        var e$4 = rv;
      }
      while (((e$4 >= 0) && (iter < maxiter))) {
        var f$3 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__enterEdge$1__AI__AI__AI__sr_IntRef__sr_IntRef__sr_IntRef__AI__sr_IntRef__AAI__AI__AI__AI__Ascm_ArrayBuffer__AAI__Ascm_ArrayBuffer__I__I(this$11, lim, etail, ehead, enterE, enterSlack, LowC, low, LimC, ys, treeIndex, rank, eminlen, treeIn, ys$1, treeOut, e$4);
        if ((f$3 < 0)) {
          e$4 = (-1);
        } else {
          $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__update$1__AI__AI__AI__AI__Ascm_ArrayBuffer__Ascm_ArrayBuffer__AI__AI__AI__AI__AI__scm_ArrayBuffer__I__I__V(this$11, rank, ehead, etail, eminlen, treeIn, treeOut, lim, cutvalue, low, par, treeIndex, treeEdge, e$4, f$3);
          iter = ((1 + iter) | 0);
          _return$2: {
            var rv$1 = (-1);
            var cnt$1 = 0;
            var j$1 = elem$7;
            while ((elem$7 < treeEdge.a1)) {
              var f$4 = (treeEdge.l(elem$7) | 0);
              if ((cutvalue.a[f$4] < 0)) {
                if (((rv$1 < 0) || (cutvalue.a[rv$1] > cutvalue.a[f$4]))) {
                  rv$1 = f$4;
                }
                cnt$1 = ((1 + cnt$1) | 0);
                if ((cnt$1 >= 30)) {
                  e$4 = rv$1;
                  break _return$2;
                }
              }
              elem$7 = ((1 + elem$7) | 0);
            }
            if ((j$1 > 0)) {
              elem$7 = 0;
              while ((elem$7 < j$1)) {
                var f$2$1 = (treeEdge.l(elem$7) | 0);
                if ((cutvalue.a[f$2$1] < 0)) {
                  if (((rv$1 < 0) || (cutvalue.a[rv$1] > cutvalue.a[f$2$1]))) {
                    rv$1 = f$2$1;
                  }
                  cnt$1 = ((1 + cnt$1) | 0);
                  if ((cnt$1 >= 30)) {
                    e$4 = rv$1;
                    break _return$2;
                  }
                }
                elem$7 = ((1 + elem$7) | 0);
              }
            }
            e$4 = rv$1;
          }
        }
      }
    }
    matchResult8: {
      var x$1 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$__TopBottom__Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance();
      if (((x$1 === null) ? (balance === null) : (x$1 === balance))) {
        $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__tbBalance$1__sci_Seq__sci_Map__AI__I__AAI__AI__AI__AI__AAI__AI__AZ__V(this$11, tbOrder, idx, rank, N, ys$1, eweight, etail, eminlen, ys, ehead, normal);
        break matchResult8;
      }
      var x$3 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$__LeftRight__Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance();
      if (((x$3 === null) ? (balance === null) : (x$3 === balance))) {
        $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__lrBalance$1__scm_ArrayBuffer__AI__AI__AI__AI__AI__AI__sr_IntRef__sr_IntRef__sr_IntRef__AI__sr_IntRef__AAI__AI__Ascm_ArrayBuffer__AAI__Ascm_ArrayBuffer__AI__V(this$11, treeEdge, cutvalue, rank, ehead, etail, eminlen, lim, enterE, enterSlack, LowC, low, LimC, ys, treeIndex, treeIn, ys$1, treeOut, par);
        break matchResult8;
      }
      var x$5 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$__None__Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance();
      if (((x$5 === null) ? (balance === null) : (x$5 === balance))) {
        $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__scanAndNormalize$1__I__AZ__AI__I(this$11, N, normal, rank);
        break matchResult8;
      }
      throw new $c_s_MatchError(balance);
    }
    return $m_sci_Map$().ao(new $c_sc_Iterator$$anon$9(new $c_sc_Iterator$$anon$16(nodes.o()), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$1) => new $c_T2(x$1$1.g(), rank.a[(x$1$1.h() | 0)])))));
  } else {
    var out = new $c_sci_MapBuilderImpl();
    var cur = roots.A6;
    while ((cur !== null)) {
      var x0$9 = cur.pf;
      var ns = nodes.d8(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((compOf, r$2) => ((_$11) => {
        var x$2 = compOf.i(_$11);
        return ((x$2 === null) ? (r$2 === null) : $dp_equals__O__Z(x$2, r$2));
      }))(compOf, x0$9)), false);
      var nsSet = $m_sci_Set$().af(ns);
      var es = edges.d8(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((nsSet) => ((e$5) => nsSet.E(e$5.pT)))(nsSet)), false);
      var tbOrder$1 = tbOrder.d8(nsSet, false);
      var this$110 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$();
      _return$3: {
        if ($f_sc_SeqOps__isEmpty__Z(ns)) {
          var $x_8 = $m_sci_Map$EmptyMap$();
          break _return$3;
        }
        var N$1 = ns.C();
        if ((N$1 <= 0)) {
          var normal$1 = new $ac_Z(0);
        } else {
          var array$17 = new $ac_Z(N$1);
          var i$20 = 0;
          while ((i$20 < N$1)) {
            var $x_9 = i$20;
            var x0$10 = i$20;
            var x0$11 = ns.l(x0$10);
            array$17.a[$x_9] = (!($m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$(), (!(!x0$11.startsWith("%slack:")))));
            i$20 = ((1 + i$20) | 0);
          }
          var normal$1 = array$17;
        }
        var idx$1 = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$16(ns.o()));
        var E$1 = es.C();
        if ((E$1 <= 0)) {
          var etail$1 = new $ac_I(0);
        } else {
          var array$18 = new $ac_I(E$1);
          var i$21 = 0;
          while ((i$21 < E$1)) {
            var $x_10 = i$21;
            var x0$12 = i$21;
            array$18.a[$x_10] = (idx$1.i(es.l(x0$12).pT) | 0);
            i$21 = ((1 + i$21) | 0);
          }
          var etail$1 = array$18;
        }
        if ((E$1 <= 0)) {
          var ehead$1 = new $ac_I(0);
        } else {
          var array$19 = new $ac_I(E$1);
          var i$22 = 0;
          while ((i$22 < E$1)) {
            var $x_11 = i$22;
            var x0$13 = i$22;
            array$19.a[$x_11] = (idx$1.i(es.l(x0$13).rp) | 0);
            i$22 = ((1 + i$22) | 0);
          }
          var ehead$1 = array$19;
        }
        if ((E$1 <= 0)) {
          var eminlen$1 = new $ac_I(0);
        } else {
          var array$20 = new $ac_I(E$1);
          var i$23 = 0;
          while ((i$23 < E$1)) {
            array$20.a[i$23] = es.l(i$23).ut;
            i$23 = ((1 + i$23) | 0);
          }
          var eminlen$1 = array$20;
        }
        if ((E$1 <= 0)) {
          var eweight$1 = new $ac_I(0);
        } else {
          var array$21 = new $ac_I(E$1);
          var i$24 = 0;
          while ((i$24 < E$1)) {
            array$21.a[i$24] = es.l(i$24).uu;
            i$24 = ((1 + i$24) | 0);
          }
          var eweight$1 = array$21;
        }
        if ((E$1 <= 0)) {
          var cutvalue$1 = new $ac_I(0);
        } else {
          var array$22 = new $ac_I(E$1);
          var i$25 = 0;
          while ((i$25 < E$1)) {
            array$22.a[i$25] = 0;
            i$25 = ((1 + i$25) | 0);
          }
          var cutvalue$1 = array$22;
        }
        if ((E$1 <= 0)) {
          var treeIndex$1 = new $ac_I(0);
        } else {
          var array$23 = new $ac_I(E$1);
          var i$26 = 0;
          while ((i$26 < E$1)) {
            array$23.a[i$26] = (-1);
            i$26 = ((1 + i$26) | 0);
          }
          var treeIndex$1 = array$23;
        }
        if ((N$1 <= 0)) {
          var outB$1 = new ($d_scm_ArrayBuffer.r().C)(0);
        } else {
          var array$24 = new ($d_scm_ArrayBuffer.r().C)(N$1);
          var i$27 = 0;
          while ((i$27 < N$1)) {
            array$24.a[i$27] = ($m_scm_ArrayBuffer$(), $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer()));
            i$27 = ((1 + i$27) | 0);
          }
          var outB$1 = array$24;
        }
        if ((N$1 <= 0)) {
          var inB$1 = new ($d_scm_ArrayBuffer.r().C)(0);
        } else {
          var array$25 = new ($d_scm_ArrayBuffer.r().C)(N$1);
          var i$28 = 0;
          while ((i$28 < N$1)) {
            array$25.a[i$28] = ($m_scm_ArrayBuffer$(), $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer()));
            i$28 = ((1 + i$28) | 0);
          }
          var inB$1 = array$25;
        }
        var i0$1 = 0;
        while ((i0$1 < E$1)) {
          outB$1.a[etail$1.a[i0$1]].aw(i0$1);
          inB$1.a[ehead$1.a[i0$1]].aw(i0$1);
          i0$1 = ((1 + i0$1) | 0);
        }
        var len$4 = outB$1.a.length;
        var ys$2 = new ($d_I.r().r().C)(len$4);
        if ((len$4 > 0)) {
          var i$29 = 0;
          while ((i$29 < len$4)) {
            var $x_13 = i$29;
            var x0$16 = outB$1.a[i$29];
            if ((x0$16.a1 >= 0)) {
              var destination$2 = new $ac_I(x0$16.a1);
              x0$16.cR(destination$2, 0, 2147483647);
              var $x_12 = destination$2;
            } else {
              var capacity$2 = 0;
              var size$2 = 0;
              var jsElems$2 = null;
              capacity$2 = 0;
              size$2 = 0;
              jsElems$2 = [];
              var it$2 = x0$16.bB().o();
              while (it$2.p()) {
                var elem$11 = it$2.q();
                var unboxedElem$2 = ((elem$11 === null) ? 0 : elem$11);
                jsElems$2.push(unboxedElem$2);
              }
              var $x_12 = new $ac_I(new Int32Array(jsElems$2));
            }
            ys$2.a[$x_13] = $x_12;
            i$29 = ((1 + i$29) | 0);
          }
        }
        var len$6 = inB$1.a.length;
        var ys$3 = new ($d_I.r().r().C)(len$6);
        if ((len$6 > 0)) {
          var i$30 = 0;
          while ((i$30 < len$6)) {
            var $x_15 = i$30;
            var x0$17 = inB$1.a[i$30];
            if ((x0$17.a1 >= 0)) {
              var destination$3 = new $ac_I(x0$17.a1);
              x0$17.cR(destination$3, 0, 2147483647);
              var $x_14 = destination$3;
            } else {
              var capacity$3 = 0;
              var size$3 = 0;
              var jsElems$3 = null;
              capacity$3 = 0;
              size$3 = 0;
              jsElems$3 = [];
              var it$3 = x0$17.bB().o();
              while (it$3.p()) {
                var elem$12 = it$3.q();
                var unboxedElem$3 = ((elem$12 === null) ? 0 : elem$12);
                jsElems$3.push(unboxedElem$3);
              }
              var $x_14 = new $ac_I(new Int32Array(jsElems$3));
            }
            ys$3.a[$x_15] = $x_14;
            i$30 = ((1 + i$30) | 0);
          }
        }
        if ((N$1 <= 0)) {
          var rank$1 = new $ac_I(0);
        } else {
          var array$26 = new $ac_I(N$1);
          var i$31 = 0;
          while ((i$31 < N$1)) {
            array$26.a[i$31] = (ns.l(i$31), 0);
            i$31 = ((1 + i$31) | 0);
          }
          var rank$1 = array$26;
        }
        if ((N$1 <= 0)) {
          var prio$1 = new $ac_I(0);
        } else {
          var array$27 = new $ac_I(N$1);
          var i$32 = 0;
          while ((i$32 < N$1)) {
            array$27.a[i$32] = 0;
            i$32 = ((1 + i$32) | 0);
          }
          var prio$1 = array$27;
        }
        if ((N$1 <= 0)) {
          var low$1 = new $ac_I(0);
        } else {
          var array$28 = new $ac_I(N$1);
          var i$33 = 0;
          while ((i$33 < N$1)) {
            array$28.a[i$33] = 0;
            i$33 = ((1 + i$33) | 0);
          }
          var low$1 = array$28;
        }
        if ((N$1 <= 0)) {
          var lim$1 = new $ac_I(0);
        } else {
          var array$29 = new $ac_I(N$1);
          var i$34 = 0;
          while ((i$34 < N$1)) {
            array$29.a[i$34] = 0;
            i$34 = ((1 + i$34) | 0);
          }
          var lim$1 = array$29;
        }
        if ((N$1 <= 0)) {
          var par$1 = new $ac_I(0);
        } else {
          var array$30 = new $ac_I(N$1);
          var i$35 = 0;
          while ((i$35 < N$1)) {
            array$30.a[i$35] = (-1);
            i$35 = ((1 + i$35) | 0);
          }
          var par$1 = array$30;
        }
        if ((N$1 <= 0)) {
          var treeOut$1 = new ($d_scm_ArrayBuffer.r().C)(0);
        } else {
          var array$31 = new ($d_scm_ArrayBuffer.r().C)(N$1);
          var i$36 = 0;
          while ((i$36 < N$1)) {
            array$31.a[i$36] = ($m_scm_ArrayBuffer$(), $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer()));
            i$36 = ((1 + i$36) | 0);
          }
          var treeOut$1 = array$31;
        }
        if ((N$1 <= 0)) {
          var treeIn$1 = new ($d_scm_ArrayBuffer.r().C)(0);
        } else {
          var array$32 = new ($d_scm_ArrayBuffer.r().C)(N$1);
          var i$37 = 0;
          while ((i$37 < N$1)) {
            array$32.a[i$37] = ($m_scm_ArrayBuffer$(), $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer()));
            i$37 = ((1 + i$37) | 0);
          }
          var treeIn$1 = array$32;
        }
        $m_scm_ArrayBuffer$();
        var treeEdge$1 = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
        var feasible$1 = true;
        var v0$1 = 0;
        while ((v0$1 < N$1)) {
          prio$1.a[v0$1] = ys$3.a[v0$1].a.length;
          var k$1 = 0;
          while ((k$1 < ys$3.a[v0$1].a.length)) {
            var e$6 = ys$3.a[v0$1].a[k$1];
            if ((((rank$1.a[ehead$1.a[e$6]] - rank$1.a[etail$1.a[e$6]]) | 0) < eminlen$1.a[e$6])) {
              feasible$1 = false;
            }
            k$1 = ((1 + k$1) | 0);
          }
          v0$1 = ((1 + v0$1) | 0);
        }
        if ((!feasible$1)) {
          var q$1 = $ct_scm_Queue__I__(new $c_scm_Queue(), 16);
          var v$1 = 0;
          while ((v$1 < N$1)) {
            if ((prio$1.a[v$1] === 0)) {
              q$1.km(v$1);
            }
            v$1 = ((1 + v$1) | 0);
          }
          while ((!q$1.c())) {
            var u$1 = (q$1.h7(false) | 0);
            rank$1.a[u$1] = 0;
            var k$2$1 = 0;
            while ((k$2$1 < ys$3.a[u$1].a.length)) {
              var e$2$1 = ys$3.a[u$1].a[k$2$1];
              var x$4 = rank$1.a[u$1];
              var y$3 = ((rank$1.a[etail$1.a[e$2$1]] + eminlen$1.a[e$2$1]) | 0);
              rank$1.a[u$1] = ((x$4 > y$3) ? x$4 : y$3);
              k$2$1 = ((1 + k$2$1) | 0);
            }
            k$2$1 = 0;
            while ((k$2$1 < ys$2.a[u$1].a.length)) {
              var e$3$1 = ys$2.a[u$1].a[k$2$1];
              var i$1$2 = ehead$1.a[e$3$1];
              prio$1.a[i$1$2] = ((prio$1.a[i$1$2] - 1) | 0);
              if ((prio$1.a[ehead$1.a[e$3$1]] <= 0)) {
                q$1.km(ehead$1.a[e$3$1]);
              }
              k$2$1 = ((1 + k$2$1) | 0);
            }
          }
        }
        if ((N$1 <= 0)) {
          var nodeSubtree$1 = new $ac_I(0);
        } else {
          var array$33 = new $ac_I(N$1);
          var i$38 = 0;
          while ((i$38 < N$1)) {
            array$33.a[i$38] = (-1);
            i$38 = ((1 + i$38) | 0);
          }
          var nodeSubtree$1 = array$33;
        }
        $m_scm_ArrayBuffer$();
        var stRep$1 = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
        $m_scm_ArrayBuffer$();
        var stSize$1 = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
        $m_scm_ArrayBuffer$();
        var stHeap$1 = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
        $m_scm_ArrayBuffer$();
        var stPar$1 = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
        $m_scm_ArrayBuffer$();
        var heapElt$1 = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
        var n0$1 = 0;
        while ((n0$1 < N$1)) {
          if ((nodeSubtree$1.a[n0$1] === (-1))) {
            var st$1 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__newSubtree$1__scm_ArrayBuffer__scm_ArrayBuffer__scm_ArrayBuffer__scm_ArrayBuffer__I__I(this$110, stRep$1, stSize$1, stHeap$1, stPar$1, n0$1);
            stSize$1.cM(st$1, $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__tightSubtreeSearch$1__AI__AAI__AI__AI__AI__AI__AI__AAI__scm_ArrayBuffer__Ascm_ArrayBuffer__Ascm_ArrayBuffer__I__I__I(this$110, nodeSubtree$1, ys$3, treeIndex$1, etail$1, rank$1, ehead$1, eminlen$1, ys$2, treeEdge$1, treeOut$1, treeIn$1, n0$1, st$1));
            heapElt$1.aw(st$1);
          }
          n0$1 = ((1 + n0$1) | 0);
        }
        $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__buildHeap$1__scm_ArrayBuffer__scm_ArrayBuffer__scm_ArrayBuffer__V(this$110, heapElt$1, stHeap$1, stSize$1);
        while ((heapElt$1.a1 > 1)) {
          var tree0$1 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__extractMin$1__scm_ArrayBuffer__scm_ArrayBuffer__scm_ArrayBuffer__I(this$110, heapElt$1, stHeap$1, stSize$1);
          var ee$1 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__interTreeEdgeSearch$1__AI__AI__AI__AI__AAI__AI__AAI__AI__scm_ArrayBuffer__I__I__I__I(this$110, rank$1, ehead$1, etail$1, eminlen$1, ys$2, treeIndex$1, ys$3, nodeSubtree$1, stPar$1, (stRep$1.l(tree0$1) | 0), (-1), (-1));
          if ((ee$1 < 0)) {
            $p_scm_ArrayBuffer__reduceToSize__I__V(heapElt$1, 0);
          } else {
            $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__heapify$1__scm_ArrayBuffer__scm_ArrayBuffer__scm_ArrayBuffer__I__V(this$110, heapElt$1, stSize$1, stHeap$1, (stHeap$1.l($p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__mergeTrees$1__AI__AI__scm_ArrayBuffer__AI__AI__scm_ArrayBuffer__AI__scm_ArrayBuffer__Ascm_ArrayBuffer__Ascm_ArrayBuffer__AI__scm_ArrayBuffer__scm_ArrayBuffer__I__I(this$110, etail$1, ehead$1, stHeap$1, rank$1, eminlen$1, stRep$1, nodeSubtree$1, stPar$1, treeIn$1, treeOut$1, treeIndex$1, treeEdge$1, stSize$1, ee$1)) | 0));
          }
        }
        if ((treeEdge$1.a1 === ((N$1 - 1) | 0))) {
          $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__dfsRangeInit$1__AI__AI__Ascm_ArrayBuffer__AI__Ascm_ArrayBuffer__AI__AI__I__V(this$110, par$1, low$1, treeOut$1, ehead$1, treeIn$1, etail$1, lim$1, 0);
          $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__dfsCutval$1__Ascm_ArrayBuffer__AI__Ascm_ArrayBuffer__AI__AI__AAI__AAI__AI__AI__AI__AI__AI__I__I__V(this$110, treeOut$1, ehead$1, treeIn$1, etail$1, par$1, ys$2, ys$3, cutvalue$1, low$1, lim$1, eweight$1, treeIndex$1, 0, (-1));
        }
        var elem$15 = 0;
        elem$15 = 0;
        var enterE$1 = new $c_sr_IntRef((-1));
        var enterSlack$1 = new $c_sr_IntRef(0);
        var LowC$1 = new $c_sr_IntRef(0);
        var LimC$1 = new $c_sr_IntRef(0);
        if ((treeEdge$1.a1 === ((N$1 - 1) | 0))) {
          var maxiter$1 = ((1000 + Math.imul((N$1 << 2), ((1 + E$1) | 0))) | 0);
          var iter$1 = 0;
          _return$4: {
            var rv$2 = (-1);
            var cnt$2 = 0;
            var j$2 = elem$15;
            while ((elem$15 < treeEdge$1.a1)) {
              var f$6 = (treeEdge$1.l(elem$15) | 0);
              if ((cutvalue$1.a[f$6] < 0)) {
                if (((rv$2 < 0) || (cutvalue$1.a[rv$2] > cutvalue$1.a[f$6]))) {
                  rv$2 = f$6;
                }
                cnt$2 = ((1 + cnt$2) | 0);
                if ((cnt$2 >= 30)) {
                  var e$4$1 = rv$2;
                  break _return$4;
                }
              }
              elem$15 = ((1 + elem$15) | 0);
            }
            if ((j$2 > 0)) {
              elem$15 = 0;
              while ((elem$15 < j$2)) {
                var f$2$2 = (treeEdge$1.l(elem$15) | 0);
                if ((cutvalue$1.a[f$2$2] < 0)) {
                  if (((rv$2 < 0) || (cutvalue$1.a[rv$2] > cutvalue$1.a[f$2$2]))) {
                    rv$2 = f$2$2;
                  }
                  cnt$2 = ((1 + cnt$2) | 0);
                  if ((cnt$2 >= 30)) {
                    var e$4$1 = rv$2;
                    break _return$4;
                  }
                }
                elem$15 = ((1 + elem$15) | 0);
              }
            }
            var e$4$1 = rv$2;
          }
          while (((e$4$1 >= 0) && (iter$1 < maxiter$1))) {
            var f$7 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__enterEdge$1__AI__AI__AI__sr_IntRef__sr_IntRef__sr_IntRef__AI__sr_IntRef__AAI__AI__AI__AI__Ascm_ArrayBuffer__AAI__Ascm_ArrayBuffer__I__I(this$110, lim$1, etail$1, ehead$1, enterE$1, enterSlack$1, LowC$1, low$1, LimC$1, ys$2, treeIndex$1, rank$1, eminlen$1, treeIn$1, ys$3, treeOut$1, e$4$1);
            if ((f$7 < 0)) {
              e$4$1 = (-1);
            } else {
              $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__update$1__AI__AI__AI__AI__Ascm_ArrayBuffer__Ascm_ArrayBuffer__AI__AI__AI__AI__AI__scm_ArrayBuffer__I__I__V(this$110, rank$1, ehead$1, etail$1, eminlen$1, treeIn$1, treeOut$1, lim$1, cutvalue$1, low$1, par$1, treeIndex$1, treeEdge$1, e$4$1, f$7);
              iter$1 = ((1 + iter$1) | 0);
              _return$5: {
                var rv$3 = (-1);
                var cnt$3 = 0;
                var j$3 = elem$15;
                while ((elem$15 < treeEdge$1.a1)) {
                  var f$8 = (treeEdge$1.l(elem$15) | 0);
                  if ((cutvalue$1.a[f$8] < 0)) {
                    if (((rv$3 < 0) || (cutvalue$1.a[rv$3] > cutvalue$1.a[f$8]))) {
                      rv$3 = f$8;
                    }
                    cnt$3 = ((1 + cnt$3) | 0);
                    if ((cnt$3 >= 30)) {
                      e$4$1 = rv$3;
                      break _return$5;
                    }
                  }
                  elem$15 = ((1 + elem$15) | 0);
                }
                if ((j$3 > 0)) {
                  elem$15 = 0;
                  while ((elem$15 < j$3)) {
                    var f$2$3 = (treeEdge$1.l(elem$15) | 0);
                    if ((cutvalue$1.a[f$2$3] < 0)) {
                      if (((rv$3 < 0) || (cutvalue$1.a[rv$3] > cutvalue$1.a[f$2$3]))) {
                        rv$3 = f$2$3;
                      }
                      cnt$3 = ((1 + cnt$3) | 0);
                      if ((cnt$3 >= 30)) {
                        e$4$1 = rv$3;
                        break _return$5;
                      }
                    }
                    elem$15 = ((1 + elem$15) | 0);
                  }
                }
                e$4$1 = rv$3;
              }
            }
          }
        }
        matchResult8$1: {
          var x$6 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$__TopBottom__Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance();
          if (((x$6 === null) ? (balance === null) : (x$6 === balance))) {
            $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__tbBalance$1__sci_Seq__sci_Map__AI__I__AAI__AI__AI__AI__AAI__AI__AZ__V(this$110, tbOrder$1, idx$1, rank$1, N$1, ys$3, eweight$1, etail$1, eminlen$1, ys$2, ehead$1, normal$1);
            break matchResult8$1;
          }
          var x$3$1 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$__LeftRight__Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance();
          if (((x$3$1 === null) ? (balance === null) : (x$3$1 === balance))) {
            $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__lrBalance$1__scm_ArrayBuffer__AI__AI__AI__AI__AI__AI__sr_IntRef__sr_IntRef__sr_IntRef__AI__sr_IntRef__AAI__AI__Ascm_ArrayBuffer__AAI__Ascm_ArrayBuffer__AI__V(this$110, treeEdge$1, cutvalue$1, rank$1, ehead$1, etail$1, eminlen$1, lim$1, enterE$1, enterSlack$1, LowC$1, low$1, LimC$1, ys$2, treeIndex$1, treeIn$1, ys$3, treeOut$1, par$1);
            break matchResult8$1;
          }
          var x$5$1 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$__None__Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance();
          if (((x$5$1 === null) ? (balance === null) : (x$5$1 === balance))) {
            $p_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$__scanAndNormalize$1__I__AZ__AI__I(this$110, N$1, normal$1, rank$1);
            break matchResult8$1;
          }
          throw new $c_s_MatchError(balance);
        }
        var $x_8 = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$9(new $c_sc_Iterator$$anon$16(ns.o()), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((rank$1) => ((x$1$2) => new $c_T2(x$1$2.g(), rank$1.a[(x$1$2.h() | 0)])))(rank$1))));
      }
      out.aeA($x_8);
      cur = cur.vI;
    }
    return out.oG();
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__rankedDot1__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Vector__T2($thiz, g, tops) {
  var minlenScale = ($thiz.J0(g) ? 2 : 1);
  var realEdges = g.cu.d8(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e) => (e.ai !== e.ak))), false);
  var nodeSeq = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$16(new $c_sc_Iterator$$anon$9(g.cB.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$12) => _$12.br)))));
  var interiorRev = $m_scm_Set$().aO();
  var slackWasUsed = $m_scm_Set$().aO();
  var topSolved = tops.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((cl) => $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__solveCluster$1__sci_Vector__scm_Set__I__scm_Set__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph__T2($thiz, realEdges, interiorRev, minlenScale, slackWasUsed, nodeSeq, cl))));
  var leaderOf = $ct_scm_HashMap__(new $c_scm_HashMap());
  var localOf = $ct_scm_HashMap__(new $c_scm_HashMap());
  $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(tops, topSolved).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    matchResult15: {
      if ((x$1 !== null)) {
        var x31 = x$1.h();
        var cl$1 = x$1.g();
        if ((x31 !== null)) {
          var ld = x31.g();
          var loc = x31.h();
          $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__allNodes$1__Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph__sci_Vector($thiz, cl$1).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((m) => {
            $p_scm_HashMap__put0__O__O__Z__s_Some(leaderOf, m, ld, false);
          })));
          loc.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
            $p_scm_HashMap__put0__O__O__Z__s_Some(localOf, x$1$2.g(), (x$1$2.h() | 0), false);
          })));
          break matchResult15;
        }
      }
      throw new $c_s_MatchError(x$1);
    }
  })));
  var clustered = $ct_sc_MapOps$KeySet__sc_MapOps__(new $c_sc_MapOps$KeySet(), leaderOf);
  var end = realEdges.C();
  var isEmpty = (end <= 0);
  var scala$collection$immutable$Range$$lastElement = ((end - 1) | 0);
  var b = $m_sci_IndexedSeq$().b5();
  var it = new $c_sci_RangeIterator(0, 1, scala$collection$immutable$Range$$lastElement, isEmpty);
  while (it.g0) {
    var elem = it.hp();
    if ($m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().Wz(realEdges.l(elem).b4)) {
      b.Y(elem);
    }
  }
  var rootIdxs = b.aR().d2();
  var plainRoot = rootIdxs.d8(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((i$2) => {
    var i = (i$2 | 0);
    var e$1 = realEdges.l(i);
    var elem$1 = e$1.ai;
    if ((!clustered.of.E(elem$1))) {
      var elem$2 = e$1.ak;
      return (!clustered.of.E(elem$2));
    } else {
      return false;
    }
  })), false);
  var rootRev = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__acyclicScoped$1__sci_Vector__sci_Map__sci_Vector__sci_Vector__sci_Set($thiz, realEdges, nodeSeq, g.cB.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$13) => _$13.br))), plainRoot);
  var byPair = new $c_scm_LinkedHashMap();
  $m_scm_ArrayBuffer$();
  var extra = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  $m_scm_ArrayBuffer$();
  var slackNames = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  rootIdxs.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => {
    var i$1 = (v1 | 0);
    var e$2 = realEdges.l(i$1);
    var lt = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__lead$2__scm_HashMap__T__T($thiz, leaderOf, e$2.ai);
    var lh = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__lead$2__scm_HashMap__T__T($thiz, leaderOf, e$2.ak);
    if ((lt !== lh)) {
      var ml = Math.imul($p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__minlenOf__Lorg_jpablo_graphexplorer_graphviz_model_Attrs__I($thiz, e$2.b4), minlenScale);
      var elem$3 = e$2.ai;
      if (clustered.of.E(elem$3)) {
        var $x_1 = true;
      } else {
        var elem$4 = e$2.ak;
        var $x_1 = clustered.of.E(elem$4);
      }
      if ($x_1) {
        slackWasUsed.Y(i$1);
        var key = e$2.ai;
        var originalHash = $m_sr_Statics$().u(key);
        var hash = (originalHash ^ ((originalHash >>> 16) | 0));
        var x1 = localOf.S.a[(hash & ((localOf.S.a.length - 1) | 0))];
        var nd = ((x1 === null) ? null : x1.by(key, hash));
        var $x_2 = ((nd === null) ? 0 : nd.b9);
        var key$1 = e$2.ak;
        var originalHash$1 = $m_sr_Statics$().u(key$1);
        var hash$1 = (originalHash$1 ^ ((originalHash$1 >>> 16) | 0));
        var x1$1 = localOf.S.a[(hash$1 & ((localOf.S.a.length - 1) | 0))];
        var nd$1 = ((x1$1 === null) ? null : x1$1.by(key$1, hash$1));
        var off = ((((ml + ($x_2 | 0)) | 0) - (((nd$1 === null) ? 0 : nd$1.b9) | 0)) | 0);
        if ((off > 0)) {
          var \u03b46$___1 = 0;
          var \u03b46$___2 = off;
        } else {
          var \u03b46$___1 = ((-off) | 0);
          var \u03b46$___2 = 0;
        }
        var tLen = (\u03b46$___1 | 0);
        var hLen = (\u03b46$___2 | 0);
        var v = ("%slack:$root:" + slackNames.a1);
        slackNames.aw(v);
        var w = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__weightOf__Lorg_jpablo_graphexplorer_graphviz_model_Attrs__I($thiz, e$2.b4);
        extra.aw(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$NSEdge(v, lt, tLen, Math.imul(10, w)));
        extra.aw(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$NSEdge(v, lh, hLen, w));
      } else {
        if (rootRev.E(i$1)) {
          var \u03b47$___1 = lh;
          var \u03b47$___2 = lt;
        } else {
          var \u03b47$___1 = lt;
          var \u03b47$___2 = lh;
        }
        var t = \u03b47$___1;
        var h = \u03b47$___2;
        var w$2 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__weightOf__Lorg_jpablo_graphexplorer_graphviz_model_Attrs__I($thiz, e$2.b4);
        matchResult16: {
          var x34 = byPair.r(new $c_T2(t, h));
          if ((x34 instanceof $c_s_Some)) {
            var r$1 = x34.J;
            var $x_3 = new $c_T2(t, h);
            var x = r$1.ut;
            $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(byPair, $x_3, new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$NSEdge(t, h, ((x > ml) ? x : ml), ((r$1.uu + w$2) | 0)), false);
            break matchResult16;
          }
          if (($m_s_None$() === x34)) {
            $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(byPair, new $c_T2(t, h), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$NSEdge(t, h, ml, w$2), false);
            break matchResult16;
          }
          throw new $c_s_MatchError(x34);
        }
      }
    }
  })));
  var rootNodes = $f_sc_Iterator__distinct__sc_Iterator(new $c_sc_Iterator$$anon$9(g.cB.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n) => $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__lead$2__scm_HashMap__T__T($thiz, leaderOf, n.br))))).d2().iR(slackNames);
  var this$30 = new $c_sc_MapOps$$anon$1(byPair);
  var solved = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__solvePerComponent__sci_Vector__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance__sci_Vector__sci_Map($thiz, rootNodes, $m_sci_Vector$().X(this$30).iR($m_sci_Vector$().X(extra)), $s_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$__None__Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance(), ($m_sci_Vector$(), $m_sci_Vector0$()));
  var ranks = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$9(g.cB.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n$2) => {
    var $x_5 = n$2.br;
    var $x_4 = solved.ay($p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__lead$2__scm_HashMap__T__T($thiz, leaderOf, n$2.br), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 0)));
    var key$4 = n$2.br;
    var originalHash$2 = $m_sr_Statics$().u(key$4);
    var hash$2 = (originalHash$2 ^ ((originalHash$2 >>> 16) | 0));
    var x1$2 = localOf.S.a[(hash$2 & ((localOf.S.a.length - 1) | 0))];
    var nd$2 = ((x1$2 === null) ? null : x1$2.by(key$4, hash$2));
    return new $c_T2($x_5, ((($x_4 | 0) + (((nd$2 === null) ? 0 : nd$2.b9) | 0)) | 0));
  }))));
  return new $c_T2(ranks, $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(realEdges).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$1) => {
    var e$3 = x$1$2$1.g();
    var i$3 = (x$1$2$1.h() | 0);
    var ml$1 = Math.imul($p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__minlenOf__Lorg_jpablo_graphexplorer_graphviz_model_Attrs__I($m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$(), e$3.b4), minlenScale);
    return (slackWasUsed.E(i$3) ? (((ranks.i(e$3.ai) | 0) > (ranks.i(e$3.ak) | 0)) ? new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$DEdge(e$3.ak, e$3.ai, ml$1) : new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$DEdge(e$3.ai, e$3.ak, ml$1)) : ((interiorRev.E(i$3) || rootRev.E(i$3)) ? new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$DEdge(e$3.ak, e$3.ai, ml$1) : new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$DEdge(e$3.ai, e$3.ak, ml$1)));
  }))));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__rankedGlobal__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T2($thiz, g) {
  var wedges0 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__acyclic__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__I__sci_Vector($thiz, g, ($thiz.J0(g) ? 2 : 1));
  var rs = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__rankConstraints__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__Lorg_jpablo_graphexplorer_graphviz_layout_Rank$RankSets($thiz, g);
  var leader = rs.KZ;
  var wedges = ((rs.wI.c() && rs.wH.c()) ? wedges0 : wedges0.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e) => (rs.wI.E(leader.i(e.pY)) ? new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$DEdge(e.pY, e.oY, e.Bv) : (rs.wH.E(leader.i(e.oY)) ? new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$DEdge(e.pY, e.oY, e.Bv) : e))))));
  var realEdges = g.cu.d8(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$2) => (e$2.ai !== e$2.ak))), false);
  var minlenScaleG = ($thiz.J0(g) ? 2 : 1);
  $m_scm_ArrayBuffer$();
  var fTail = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  $m_scm_ArrayBuffer$();
  var fHead = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  $m_scm_ArrayBuffer$();
  var fMinlen = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  $m_scm_ArrayBuffer$();
  var fWeight = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  $m_scm_ArrayBuffer$();
  var fAlive = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  var fOut = new $c_scm_LinkedHashMap();
  var fIn = new $c_scm_LinkedHashMap();
  var fastByPair = $ct_scm_HashMap__(new $c_scm_HashMap());
  var nodeSeqC = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$16(new $c_sc_Iterator$$anon$9(g.cB.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$14) => _$14.br)))));
  var end = realEdges.C();
  var isEmpty = (end <= 0);
  var scala$collection$immutable$Range$$lastElement = ((end - 1) | 0);
  var m = $m_scm_Map$().aO();
  var it = new $c_sci_RangeIterator(0, 1, scala$collection$immutable$Range$$lastElement, isEmpty);
  while (it.g0) {
    var elem = it.hp();
    var key = realEdges.l(elem).ai;
    m.ec(key, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_IndexedSeq$().b5()))).Y(elem);
  }
  var result = $m_sci_HashMap$().fk;
  var mapIt = m.o();
  while (mapIt.p()) {
    var x1 = mapIt.q();
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1);
    }
    var k = x1.g();
    var v = x1.h();
    result = result.hq(k, v.aR());
  }
  var eByTail = result;
  g.cB.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n) => {
    $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(eByTail.ay(n.br, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_Seq$().f7()))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((i) => {
      var i$1 = (i | 0);
      return new $c_T2(nodeSeqC.ay(realEdges.l(i$1).ak, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 2147483647))), i$1);
    })), new $c_s_math_Ordering$Tuple2Ordering($m_s_math_Ordering$Int$(), $m_s_math_Ordering$Int$())).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => {
      var i$2 = (v1 | 0);
      var e$1 = realEdges.l(i$2);
      var _1$1 = leader.i(e$1.ai);
      var _2 = leader.i(e$1.ak);
      if (((_1$1 !== _2) && $thiz.Wz(e$1.b4))) {
        $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__fastMake$1__scm_HashMap__scm_ArrayBuffer__scm_ArrayBuffer__scm_ArrayBuffer__scm_ArrayBuffer__scm_ArrayBuffer__scm_LinkedHashMap__scm_LinkedHashMap__T__T__I__I__V($thiz, fastByPair, fMinlen, fWeight, fTail, fHead, fAlive, fOut, fIn, _1$1, _2, Math.imul($p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__minlenOf__Lorg_jpablo_graphexplorer_graphviz_model_Attrs__I($thiz, e$1.b4), minlenScaleG), $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__weightOf__Lorg_jpablo_graphexplorer_graphviz_model_Attrs__I($thiz, e$1.b4));
      }
    })));
  })));
  var this$24 = rs.wH;
  if ((!this$24.c())) {
    var x0 = this$24.d();
    var originalHash = $m_sr_Statics$().u(x0);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var idx = (hash & ((fOut.au.a.length - 1) | 0));
    var x1$1 = fOut.au.a[idx];
    var nd = ((x1$1 === null) ? null : x1$1.ij(x0, hash));
    if ((nd !== null)) {
      var $x_1 = nd.fs;
    } else {
      var table0 = fOut.au;
      $m_scm_ArrayBuffer$();
      var default$1 = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
      if ((((1 + fOut.e0) | 0) >= fOut.ki)) {
        $p_scm_LinkedHashMap__growTable__I__V(fOut, (fOut.au.a.length << 1));
      }
      $p_scm_LinkedHashMap__put0__O__O__Z__I__I__s_Some(fOut, x0, default$1, false, hash, ((table0 === fOut.au) ? idx : (hash & ((fOut.au.a.length - 1) | 0))));
      var $x_1 = default$1;
    }
    var out = $x_1;
    while ((!$f_sc_SeqOps__isEmpty__Z(out))) {
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__fastReverse$1__scm_ArrayBuffer__scm_LinkedHashMap__scm_ArrayBuffer__scm_LinkedHashMap__scm_ArrayBuffer__scm_HashMap__scm_ArrayBuffer__scm_ArrayBuffer__I__V($thiz, fAlive, fOut, fTail, fIn, fHead, fastByPair, fMinlen, fWeight, (out.l(0) | 0));
    }
  }
  var this$26 = rs.wI;
  if ((!this$26.c())) {
    var x0$1 = this$26.d();
    var originalHash$1 = $m_sr_Statics$().u(x0$1);
    var hash$1 = (originalHash$1 ^ ((originalHash$1 >>> 16) | 0));
    var idx$1 = (hash$1 & ((fIn.au.a.length - 1) | 0));
    var x1$2 = fIn.au.a[idx$1];
    var nd$1 = ((x1$2 === null) ? null : x1$2.ij(x0$1, hash$1));
    if ((nd$1 !== null)) {
      var $x_2 = nd$1.fs;
    } else {
      var table0$1 = fIn.au;
      $m_scm_ArrayBuffer$();
      var default$2 = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
      if ((((1 + fIn.e0) | 0) >= fIn.ki)) {
        $p_scm_LinkedHashMap__growTable__I__V(fIn, (fIn.au.a.length << 1));
      }
      $p_scm_LinkedHashMap__put0__O__O__Z__I__I__s_Some(fIn, x0$1, default$2, false, hash$1, ((table0$1 === fIn.au) ? idx$1 : (hash$1 & ((fIn.au.a.length - 1) | 0))));
      var $x_2 = default$2;
    }
    var in$1 = $x_2;
    while ((!$f_sc_SeqOps__isEmpty__Z(in$1))) {
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__fastReverse$1__scm_ArrayBuffer__scm_LinkedHashMap__scm_ArrayBuffer__scm_LinkedHashMap__scm_ArrayBuffer__scm_HashMap__scm_ArrayBuffer__scm_ArrayBuffer__I__V($thiz, fAlive, fOut, fTail, fIn, fHead, fastByPair, fMinlen, fWeight, (in$1.l(0) | 0));
    }
  }
  var leaderNodes = $f_sc_Iterator__distinct__sc_Iterator(new $c_sc_Iterator$$anon$9(g.cB.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n$2) => leader.i(n$2.br))))).d2();
  var nodeSeqR = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$16(new $c_sc_Iterator$$anon$9(g.cB.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$15) => _$15.br)))));
  var outAdjR = new $c_scm_LinkedHashMap();
  var inAdjR = new $c_scm_LinkedHashMap();
  leaderNodes.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n$3) => {
    $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(outAdjR, n$3, ($m_scm_ArrayBuffer$(), $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer())), false);
    $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(inAdjR, n$3, ($m_scm_ArrayBuffer$(), $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer())), false);
  })));
  var seen = $m_scm_Set$().aO();
  var this$41 = new $c_sc_Iterator$$anon$6(new $c_sc_Iterator$$anon$16(g.cu.o()), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var e$3 = x$1.g();
    (x$1.h() | 0);
    return $m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().Wz(e$3.b4);
  })), false);
  var this$42 = $m_sci_Vector$().X(this$41);
  var m$1 = $m_scm_Map$().aO();
  var it$1 = this$42.o();
  while (it$1.p()) {
    var elem$1 = it$1.q();
    var key$1 = elem$1.g().ai;
    m$1.ec(key$1, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      $m_sci_Vector$();
      return new $c_sci_VectorBuilder();
    }))).Y(elem$1);
  }
  var result$1 = $m_sci_HashMap$().fk;
  var mapIt$1 = m$1.o();
  while (mapIt$1.p()) {
    var x1$3 = mapIt$1.q();
    if ((x1$3 === null)) {
      throw new $c_s_MatchError(x1$3);
    }
    var k$1 = x1$3.g();
    var v$1 = x1$3.h();
    result$1 = result$1.hq(k$1, v$1.aR());
  }
  var byTail = result$1;
  g.cB.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n$4) => {
    $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(byTail.ay(n$4.br, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      $m_sci_Vector$();
      return $m_sci_Vector0$();
    }))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$1) => {
      var e$4 = x$1$1.g();
      var i$3 = (x$1$1.h() | 0);
      return new $c_T2(nodeSeqR.ay(e$4.ak, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 2147483647))), i$3);
    })), new $c_s_math_Ordering$Tuple2Ordering($m_s_math_Ordering$Int$(), $m_s_math_Ordering$Int$())).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
      var e$5 = x$1$2.g();
      (x$1$2.h() | 0);
      var lt = leader.i(e$5.ai);
      var lh = leader.i(e$5.ak);
      if (((lt !== lh) && (!seen.E(new $c_T2(lt, lh))))) {
        seen.Y(new $c_T2(lt, lh));
        $f_sc_MapOps__apply__O__O(outAdjR, lt).Y(lh);
        $f_sc_MapOps__apply__O__O(inAdjR, lh).Y(lt);
      }
    })));
  })));
  var done2 = $m_scm_Set$().aO();
  $m_scm_ArrayBuffer$();
  var res = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  leaderNodes.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((s) => {
    if ((!done2.E(s))) {
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__visit$2__scm_Set__scm_ArrayBuffer__scm_LinkedHashMap__scm_LinkedHashMap__T__V($thiz, done2, res, inAdjR, outAdjR, s);
    }
  })));
  var tbOrder = $m_sci_Vector$().X(res);
  var mark = $m_scm_Set$().aO();
  var onStack = $m_scm_Set$().aO();
  tbOrder.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n$5) => {
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__dfs$3__scm_Set__scm_Set__scm_LinkedHashMap__scm_ArrayBuffer__scm_ArrayBuffer__scm_ArrayBuffer__scm_LinkedHashMap__scm_HashMap__scm_ArrayBuffer__scm_ArrayBuffer__T__V($thiz, mark, onStack, fOut, fHead, fAlive, fTail, fIn, fastByPair, fMinlen, fWeight, n$5);
  })));
  leaderNodes.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n$6) => {
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__dfs$3__scm_Set__scm_Set__scm_LinkedHashMap__scm_ArrayBuffer__scm_ArrayBuffer__scm_ArrayBuffer__scm_LinkedHashMap__scm_HashMap__scm_ArrayBuffer__scm_ArrayBuffer__T__V($thiz, mark, onStack, fOut, fHead, fAlive, fTail, fIn, fastByPair, fMinlen, fWeight, n$6);
  })));
  var end$1 = fTail.a1;
  var this$59 = new $c_sc_Iterator$$anon$9(new $c_sc_Iterator$$anon$6(new $c_sci_RangeIterator(0, 1, ((end$1 - 1) | 0), (end$1 <= 0)), fAlive, false), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((i$2$1) => {
    var i$4 = (i$2$1 | 0);
    return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$NSEdge(fTail.l(i$4), fHead.l(i$4), (fMinlen.l(i$4) | 0), (fWeight.l(i$4) | 0));
  })));
  var nse = $m_sci_Vector$().X(this$59);
  if (((!rs.wI.c()) || (!rs.wH.c()))) {
    var hasOut = $m_sci_Set$().af(new $c_sc_Iterator$$anon$9(nse.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$19) => _$19.pT))));
    var hasIn = $m_sci_Set$().af(new $c_sc_Iterator$$anon$9(nse.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$20) => _$20.rp))));
    $m_scm_ArrayBuffer$();
    var extra = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
    leaderNodes.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n$7) => {
      var this$67 = rs.wH;
      if ((!this$67.c())) {
        var x0$2 = this$67.d();
        if (((!hasOut.E(n$7)) && (n$7 !== x0$2))) {
          extra.aw(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$NSEdge(n$7, x0$2, rs.L1, 0));
        }
      }
      var this$69 = rs.wI;
      if ((!this$69.c())) {
        var x0$3 = this$69.d();
        if (((!hasIn.E(n$7)) && (n$7 !== x0$3))) {
          extra.aw(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$NSEdge(x0$3, n$7, rs.L0, 0));
        }
      }
    })));
    nse = nse.iR($m_sci_Vector$().X(extra));
  }
  var leaderRanks = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__solvePerComponent__sci_Vector__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance__sci_Vector__sci_Map($thiz, leaderNodes, nse, $s_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$__TopBottom__Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance(), tbOrder);
  var ranks = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$9(g.cB.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n$8) => new $c_T2(n$8.br, leaderRanks.i(leader.i(n$8.br)))))));
  return new $c_T2(ranks, wedges.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$3$1) => (((ranks.ay(e$3$1.oY, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 0))) | 0) > (ranks.ay(e$3$1.pY, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 0))) | 0)) ? new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$DEdge(e$3$1.pY, e$3$1.oY, e$3$1.Bv) : e$3$1)))));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__dfs$1__scm_Set__scm_Set__scm_LinkedHashMap__sci_Vector__scm_Set__T__V($thiz, mark$1, onStack$1, outIdx$3, edges$3, reversed$1, n) {
  if (mark$1.E(n)) {
    return (void 0);
  }
  mark$1.Y(n);
  onStack$1.Y(n);
  var f = (() => {
    $m_scm_ArrayBuffer$();
    return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  });
  if ((!($objectGetClass(outIdx$3) === $d_scm_LinkedHashMap.l()))) {
    var x1 = outIdx$3.r(n);
    if ((x1 instanceof $c_s_Some)) {
      var $x_1 = x1.J;
    } else {
      if ((!($m_s_None$() === x1))) {
        throw new $c_s_MatchError(x1);
      }
      var $x_1 = f();
    }
  } else {
    var originalHash = $m_sr_Statics$().u(n);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var x1$1 = outIdx$3.au.a[(hash & ((outIdx$3.au.a.length - 1) | 0))];
    var nd = ((x1$1 === null) ? null : x1$1.ij(n, hash));
    var $x_1 = ((nd === null) ? f() : nd.fs);
  }
  $x_1.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => {
    var i = (v1 | 0);
    var w = edges$3.l(i).ak;
    if (onStack$1.E(w)) {
      reversed$1.Y(i);
    } else if ((!mark$1.E(w))) {
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__dfs$1__scm_Set__scm_Set__scm_LinkedHashMap__sci_Vector__scm_Set__T__V($thiz, mark$1, onStack$1, outIdx$3, edges$3, reversed$1, w);
    }
  })));
  onStack$1.re(n);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__find$1__scm_Map__T__T($thiz, parent$1, x) {
  var p = parent$1.ay(x, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => x)));
  if ((p === x)) {
    return x;
  } else {
    var r = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__find$1__scm_Map__T__T($thiz, parent$1, p);
    parent$1.cY(x, r);
    return r;
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__union$1__scm_Map__T__T__V($thiz, parent$2, a, b) {
  var _1 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__find$1__scm_Map__T__T($thiz, parent$2, a);
  var _2 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__find$1__scm_Map__T__T($thiz, parent$2, b);
  if ((_1 !== _2)) {
    parent$2.cY(_1, _2);
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__walk$1__s_Option__sci_Set__scm_ArrayBuffer__sr_IntRef__scm_ArrayBuffer__sr_IntRef__scm_Map__sci_Vector__V($thiz, defaultRank$1, nodeSet$1, minMembers$1, slenX$2, maxMembers$1, slenY$2, parent$3, subs) {
  subs.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((s) => {
    var this$2 = s.BC;
    var this$3 = (this$2.c() ? defaultRank$1 : this$2);
    if ((!this$3.c())) {
      var x0 = this$3.d();
      var members = s.rs.d8(nodeSet$1, false);
      var f = ((a, b) => {
        $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__union$1__scm_Map__T__T__V($thiz, parent$3, a, b);
        return b;
      });
      switch (members.C()) {
        case (-1): {
          var it = members.o();
          if (it.p()) {
            var acc = it.q();
            while (it.p()) {
              var x0$1 = acc;
              var x1$1 = it.q();
              acc = f(x0$1, x1$1);
            }
          }
          break;
        }
        case 0: {
          break;
        }
        default: {
          matchEnd4: {
            if ((members.C() > 0)) {
              var z = members.l(0);
              var at = 1;
              var end = members.C();
              var acc$1 = z;
              while (true) {
                if ((at === end)) {
                  break matchEnd4;
                } else {
                  var temp$at = ((1 + at) | 0);
                  var x0$2 = acc$1;
                  var x1$2 = members.l(at);
                  var temp$acc = f(x0$2, x1$2);
                  at = temp$at;
                  acc$1 = temp$acc;
                }
              }
            }
            if ((members.C() === 0)) {
              throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.reduceLeft");
            }
            var it$1 = members.o();
            if (it$1.p()) {
              var acc$2 = it$1.q();
              while (it$1.p()) {
                var x0$3 = acc$2;
                var x1$3 = it$1.q();
                acc$2 = f(x0$3, x1$3);
              }
            } else {
              throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.reduceLeft");
            }
          }
        }
      }
      switch (x0) {
        case "min": {
          minMembers$1.gS(members);
          break;
        }
        case "source": {
          minMembers$1.gS(members);
          slenX$2.an = 1;
          break;
        }
        case "max": {
          maxMembers$1.gS(members);
          break;
        }
        case "sink": {
          maxMembers$1.gS(members);
          slenY$2.an = 1;
          break;
        }
      }
    }
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__walk$1__s_Option__sci_Set__scm_ArrayBuffer__sr_IntRef__scm_ArrayBuffer__sr_IntRef__scm_Map__sci_Vector__V($thiz, defaultRank$1, nodeSet$1, minMembers$1, slenX$2, maxMembers$1, slenY$2, parent$3, s.lD);
  })));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__topClusters$1__sci_Vector__sci_Vector($thiz, subs) {
  $m_sci_Vector$();
  var b = new $c_sci_VectorBuilder();
  var it = subs.o();
  while (it.p()) {
    var x0 = it.q();
    b.fO((x0.wP ? $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph.r().C)([x0]))) : $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__topClusters$1__sci_Vector__sci_Vector($thiz, x0.lD)));
  }
  return b.bY();
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__mark$16__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph__I__V($thiz, clOf$1, s, ci) {
  s.rs.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n) => {
    $p_scm_HashMap__put0__O__O__Z__s_Some(clOf$1, n, ci, false);
  })));
  s.lD.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$8) => {
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__mark$16__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph__I__V($thiz, clOf$1, _$8, ci);
  })));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__walk$2__s_Option__scm_HashMap__sci_Vector__Z($thiz, defaultRank$4, clOf$4, subs) {
  var res = false;
  var it = subs.o();
  while (((!res) && it.p())) {
    var x0 = it.q();
    var this$1 = x0.BC;
    if ((((!(this$1.c() ? defaultRank$4 : this$1).c()) && (!x0.wP)) && (x0.rs.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((clOf$4) => ((key) => clOf$4.r(key)))(clOf$4))).nz().C() > 1))) {
      res = true;
    } else {
      res = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__walk$2__s_Option__scm_HashMap__sci_Vector__Z($thiz, defaultRank$4, clOf$4, x0.lD);
    }
  }
  return res;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__crossClusterRankSet$1__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__Z($thiz, tops$1, g$2) {
  var clOf = $ct_scm_HashMap__(new $c_scm_HashMap());
  $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(tops$1).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__mark$16__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph__I__V($thiz, clOf, x$1.g(), (x$1.h() | 0));
  })));
  var this$4 = g$2.f2.ag.r("rank");
  return $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__walk$2__s_Option__scm_HashMap__sci_Vector__Z($thiz, ((this$4.c() || (this$4.d() !== "")) ? this$4 : $m_s_None$()), clOf, g$2.uF);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__find$2__scm_HashMap__T__T($thiz, parent$6, x) {
  var f = (() => x);
  if ((!($objectGetClass(parent$6) === $d_scm_HashMap.l()))) {
    var x1 = parent$6.r(x);
    if ((x1 instanceof $c_s_Some)) {
      var $x_1 = x1.J;
    } else {
      if ((!($m_s_None$() === x1))) {
        throw new $c_s_MatchError(x1);
      }
      var $x_1 = f();
    }
  } else {
    var originalHash = $m_sr_Statics$().u(x);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var x1$1 = parent$6.S.a[(hash & ((parent$6.S.a.length - 1) | 0))];
    var nd = ((x1$1 === null) ? null : x1$1.by(x, hash));
    var $x_1 = ((nd === null) ? f() : nd.b9);
  }
  var p = $x_1;
  if ((p === x)) {
    return x;
  } else {
    var r = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__find$2__scm_HashMap__T__T($thiz, parent$6, p);
    $p_scm_HashMap__put0__O__O__Z__s_Some(parent$6, x, r, false);
    return r;
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__union$2__scm_HashMap__T__T__V($thiz, parent$7, a, b) {
  var _1 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__find$2__scm_HashMap__T__T($thiz, parent$7, a);
  var _2 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__find$2__scm_HashMap__T__T($thiz, parent$7, b);
  if ((_1 !== _2)) {
    $p_scm_HashMap__put0__O__O__Z__s_Some(parent$7, _1, _2, false);
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__dfs$2__scm_Set__scm_Set__scm_LinkedHashMap__sci_Vector__scm_Set__T__V($thiz, mark$3, onStack$3, outIdx$7, realEdges$5, reversed$4, n) {
  if ((!mark$3.E(n))) {
    mark$3.Y(n);
    onStack$3.Y(n);
    var f = (() => {
      $m_scm_ArrayBuffer$();
      return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
    });
    if ((!($objectGetClass(outIdx$7) === $d_scm_LinkedHashMap.l()))) {
      var x1 = outIdx$7.r(n);
      if ((x1 instanceof $c_s_Some)) {
        var $x_1 = x1.J;
      } else {
        if ((!($m_s_None$() === x1))) {
          throw new $c_s_MatchError(x1);
        }
        var $x_1 = f();
      }
    } else {
      var originalHash = $m_sr_Statics$().u(n);
      var hash = (originalHash ^ ((originalHash >>> 16) | 0));
      var x1$1 = outIdx$7.au.a[(hash & ((outIdx$7.au.a.length - 1) | 0))];
      var nd = ((x1$1 === null) ? null : x1$1.ij(n, hash));
      var $x_1 = ((nd === null) ? f() : nd.fs);
    }
    $x_1.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => {
      var i = (v1 | 0);
      var w = realEdges$5.l(i).ak;
      if (onStack$3.E(w)) {
        reversed$4.Y(i);
      } else if ((!mark$3.E(w))) {
        $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__dfs$2__scm_Set__scm_Set__scm_LinkedHashMap__sci_Vector__scm_Set__T__V($thiz, mark$3, onStack$3, outIdx$7, realEdges$5, reversed$4, w);
      }
    })));
    onStack$3.re(n);
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__acyclicScoped$1__sci_Vector__sci_Map__sci_Vector__sci_Vector__sci_Set($thiz, realEdges$2, nodeSeq$3, order, edgeIdxs) {
  var outIdx = new $c_scm_LinkedHashMap();
  order.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n) => {
    $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(outIdx, n, ($m_scm_ArrayBuffer$(), $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer())), false);
  })));
  edgeIdxs.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((i) => {
    var i$1 = (i | 0);
    var key = realEdges$2.l(i$1).ai;
    var originalHash = $m_sr_Statics$().u(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var idx = (hash & ((outIdx.au.a.length - 1) | 0));
    var x1 = outIdx.au.a[idx];
    var nd = ((x1 === null) ? null : x1.ij(key, hash));
    if ((nd !== null)) {
      var $x_1 = nd.fs;
    } else {
      var table0 = outIdx.au;
      $m_scm_ArrayBuffer$();
      var default$1 = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
      if ((((1 + outIdx.e0) | 0) >= outIdx.ki)) {
        $p_scm_LinkedHashMap__growTable__I__V(outIdx, (outIdx.au.a.length << 1));
      }
      $p_scm_LinkedHashMap__put0__O__O__Z__I__I__s_Some(outIdx, key, default$1, false, hash, ((table0 === outIdx.au) ? idx : (hash & ((outIdx.au.a.length - 1) | 0))));
      var $x_1 = default$1;
    }
    return $x_1.Y(i$1);
  })));
  var this$5 = new $c_sc_MapOps$$anon$1(outIdx);
  var it = this$5.o();
  while (it.p()) {
    var x0 = it.q();
    var sorted = $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(x0, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((nodeSeq$3, realEdges$2) => ((i$2) => {
      var i$3 = (i$2 | 0);
      return new $c_T2(nodeSeq$3.ay(realEdges$2.l(i$3).ak, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 2147483647))), i$3);
    }))(nodeSeq$3, realEdges$2)), new $c_s_math_Ordering$Tuple2Ordering($m_s_math_Ordering$Int$(), $m_s_math_Ordering$Int$()));
    $p_scm_ArrayBuffer__reduceToSize__I__V(x0, 0);
    x0.gS(sorted);
  }
  var reversed = $m_scm_Set$().aO();
  var mark = $m_scm_Set$().aO();
  var onStack = $m_scm_Set$().aO();
  order.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n$2) => {
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__dfs$2__scm_Set__scm_Set__scm_LinkedHashMap__sci_Vector__scm_Set__T__V($thiz, mark, onStack, outIdx, realEdges$2, reversed, n$2);
  })));
  return $m_sci_Set$().af(reversed);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__allNodes$1__Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph__sci_Vector($thiz, s) {
  var $x_1 = s.rs;
  var this$1 = s.lD;
  $m_sci_Vector$();
  var b = new $c_sci_VectorBuilder();
  var it = this$1.o();
  while (it.p()) {
    b.fO($p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__allNodes$1__Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph__sci_Vector($thiz, it.q()));
  }
  return $x_1.iR(b.bY());
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__subClusters$1__Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph__sci_Vector($thiz, s) {
  var this$1 = s.lD;
  $m_sci_Vector$();
  var b = new $c_sci_VectorBuilder();
  var it = this$1.o();
  while (it.p()) {
    var x0 = it.q();
    b.fO((x0.wP ? $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph.r().C)([x0]))) : $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__subClusters$1__Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph__sci_Vector($thiz, x0)));
  }
  return b.bY();
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__lead$1__scm_HashMap__T__T($thiz, nestedLeader$3, n) {
  var f = (() => n);
  if ((!($objectGetClass(nestedLeader$3) === $d_scm_HashMap.l()))) {
    var x1 = nestedLeader$3.r(n);
    if ((x1 instanceof $c_s_Some)) {
      var $x_1 = x1.J;
    } else {
      if ((!($m_s_None$() === x1))) {
        throw new $c_s_MatchError(x1);
      }
      var $x_1 = f();
    }
  } else {
    var originalHash = $m_sr_Statics$().u(n);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var x1$1 = nestedLeader$3.S.a[(hash & ((nestedLeader$3.S.a.length - 1) | 0))];
    var nd = ((x1$1 === null) ? null : x1$1.by(n, hash));
    var $x_1 = ((nd === null) ? f() : nd.b9);
  }
  return $x_1;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__solveCluster$1__sci_Vector__scm_Set__I__scm_Set__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph__T2($thiz, realEdges$7, interiorRev$1, minlenScale$2, slackWasUsed$1, nodeSeq$6, cl) {
  var nested = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__subClusters$1__Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph__sci_Vector($thiz, cl);
  var nestedSolved = nested.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((cl$2) => $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__solveCluster$1__sci_Vector__scm_Set__I__scm_Set__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph__T2($thiz, realEdges$7, interiorRev$1, minlenScale$2, slackWasUsed$1, nodeSeq$6, cl$2))));
  var nestedLeader = $ct_scm_HashMap__(new $c_scm_HashMap());
  var nestedLocal = $ct_scm_HashMap__(new $c_scm_HashMap());
  $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(nested, nestedSolved).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    matchResult13: {
      if ((x$1 !== null)) {
        var x23 = x$1.h();
        var nc = x$1.g();
        if ((x23 !== null)) {
          var ld = x23.g();
          var loc = x23.h();
          $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__allNodes$1__Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph__sci_Vector($thiz, nc).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((m) => {
            $p_scm_HashMap__put0__O__O__Z__s_Some(nestedLeader, m, ld, false);
          })));
          loc.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
            $p_scm_HashMap__put0__O__O__Z__s_Some(nestedLocal, x$1$2.g(), (x$1$2.h() | 0), false);
          })));
          break matchResult13;
        }
      }
      throw new $c_s_MatchError(x$1);
    }
  })));
  var memberVec = $f_sc_SeqOps__distinct__O($p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__allNodes$1__Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph__sci_Vector($thiz, cl));
  var memberSet = $m_sci_Set$().af(memberVec);
  var inNested = $ct_sc_MapOps$KeySet__sc_MapOps__(new $c_sc_MapOps$KeySet(), nestedLeader);
  var fastNodes = memberVec.d8(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n) => ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__lead$1__scm_HashMap__T__T($thiz, nestedLeader, n) === n))), false);
  var end = realEdges$7.C();
  var isEmpty = (end <= 0);
  var scala$collection$immutable$Range$$lastElement = ((end - 1) | 0);
  var b = $m_sci_IndexedSeq$().b5();
  var it = new $c_sci_RangeIterator(0, 1, scala$collection$immutable$Range$$lastElement, isEmpty);
  while (it.g0) {
    var elem = it.hp();
    var e = realEdges$7.l(elem);
    if (((memberSet.E(e.ai) && memberSet.E(e.ak)) && $m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().Wz(e.b4))) {
      b.Y(elem);
    }
  }
  var induced = b.aR().d2();
  var plain = induced.d8(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((i$2) => {
    var i = (i$2 | 0);
    var e$1 = realEdges$7.l(i);
    var elem$3 = e$1.ai;
    if ((!inNested.of.E(elem$3))) {
      var elem$4 = e$1.ak;
      return (!inNested.of.E(elem$4));
    } else {
      return false;
    }
  })), false);
  var rev = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__acyclicScoped$1__sci_Vector__sci_Map__sci_Vector__sci_Vector__sci_Set($thiz, realEdges$7, nodeSeq$6, $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__decomposeOrderOf$1__sci_Vector__sci_Map__sci_Vector__sci_Vector__sci_Set__sci_Vector($thiz, realEdges$7, nodeSeq$6, fastNodes, plain, $m_sci_Set$EmptySet$()), plain);
  interiorRev$1.dG(rev);
  var byPair = new $c_scm_LinkedHashMap();
  $m_scm_ArrayBuffer$();
  var extra = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  $m_scm_ArrayBuffer$();
  var slackNames = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  induced.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => {
    var i$1 = (v1 | 0);
    var e$2 = realEdges$7.l(i$1);
    var lt = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__lead$1__scm_HashMap__T__T($thiz, nestedLeader, e$2.ai);
    var lh = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__lead$1__scm_HashMap__T__T($thiz, nestedLeader, e$2.ak);
    if ((lt !== lh)) {
      var ml = Math.imul($p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__minlenOf__Lorg_jpablo_graphexplorer_graphviz_model_Attrs__I($thiz, e$2.b4), minlenScale$2);
      var elem$5 = e$2.ai;
      if (inNested.of.E(elem$5)) {
        var $x_1 = true;
      } else {
        var elem$6 = e$2.ak;
        var $x_1 = inNested.of.E(elem$6);
      }
      if ($x_1) {
        slackWasUsed$1.Y(i$1);
        var key = e$2.ai;
        var originalHash = $m_sr_Statics$().u(key);
        var hash = (originalHash ^ ((originalHash >>> 16) | 0));
        var x1 = nestedLocal.S.a[(hash & ((nestedLocal.S.a.length - 1) | 0))];
        var nd = ((x1 === null) ? null : x1.by(key, hash));
        var $x_2 = ((nd === null) ? 0 : nd.b9);
        var key$1 = e$2.ak;
        var originalHash$1 = $m_sr_Statics$().u(key$1);
        var hash$1 = (originalHash$1 ^ ((originalHash$1 >>> 16) | 0));
        var x1$1 = nestedLocal.S.a[(hash$1 & ((nestedLocal.S.a.length - 1) | 0))];
        var nd$1 = ((x1$1 === null) ? null : x1$1.by(key$1, hash$1));
        var off = ((((ml + ($x_2 | 0)) | 0) - (((nd$1 === null) ? 0 : nd$1.b9) | 0)) | 0);
        if ((off > 0)) {
          var \u03b44$___1 = 0;
          var \u03b44$___2 = off;
        } else {
          var \u03b44$___1 = ((-off) | 0);
          var \u03b44$___2 = 0;
        }
        var tLen = (\u03b44$___1 | 0);
        var hLen = (\u03b44$___2 | 0);
        var v = ((("%slack:" + cl.z7) + ":") + slackNames.a1);
        slackNames.aw(v);
        var w = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__weightOf__Lorg_jpablo_graphexplorer_graphviz_model_Attrs__I($thiz, e$2.b4);
        extra.aw(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$NSEdge(v, lt, tLen, Math.imul(10, w)));
        extra.aw(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$NSEdge(v, lh, hLen, w));
      } else {
        if (rev.E(i$1)) {
          var \u03b45$___1 = lh;
          var \u03b45$___2 = lt;
        } else {
          var \u03b45$___1 = lt;
          var \u03b45$___2 = lh;
        }
        var t = \u03b45$___1;
        var h = \u03b45$___2;
        var w$2 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__weightOf__Lorg_jpablo_graphexplorer_graphviz_model_Attrs__I($thiz, e$2.b4);
        matchResult14: {
          var x26 = byPair.r(new $c_T2(t, h));
          if ((x26 instanceof $c_s_Some)) {
            var r$1 = x26.J;
            var $x_3 = new $c_T2(t, h);
            var x = r$1.ut;
            $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(byPair, $x_3, new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$NSEdge(t, h, ((x > ml) ? x : ml), ((r$1.uu + w$2) | 0)), false);
            break matchResult14;
          }
          if (($m_s_None$() === x26)) {
            $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(byPair, new $c_T2(t, h), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$NSEdge(t, h, ml, w$2), false);
            break matchResult14;
          }
          throw new $c_s_MatchError(x26);
        }
      }
    }
  })));
  var this$24 = new $c_sc_MapOps$$anon$1(byPair);
  var nse = $m_sci_Vector$().X(this$24).iR(extra);
  if ($f_sc_SeqOps__isEmpty__Z(nested)) {
    var \u03b43$___1 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$__TopBottom__Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance();
    var \u03b43$___2 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__decomposeOrderOf$1__sci_Vector__sci_Map__sci_Vector__sci_Vector__sci_Set__sci_Vector($thiz, realEdges$7, nodeSeq$6, fastNodes, plain, rev);
  } else {
    var \u03b43$___1 = $s_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$__None__Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance();
    var \u03b43$___2 = ($m_sci_Vector$(), $m_sci_Vector0$());
  }
  var bal = \u03b43$___1;
  var tbo = \u03b43$___2;
  var solved = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__solvePerComponent__sci_Vector__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance__sci_Vector__sci_Map($thiz, fastNodes.iR(slackNames), nse, bal, tbo);
  var local = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$9(memberVec.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((m$2) => {
    var $x_4 = solved.ay($p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__lead$1__scm_HashMap__T__T($thiz, nestedLeader, m$2), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 0)));
    var originalHash$2 = $m_sr_Statics$().u(m$2);
    var hash$2 = (originalHash$2 ^ ((originalHash$2 >>> 16) | 0));
    var x1$2 = nestedLocal.S.a[(hash$2 & ((nestedLocal.S.a.length - 1) | 0))];
    var nd$2 = ((x1$2 === null) ? null : x1$2.by(m$2, hash$2));
    return new $c_T2(m$2, ((($x_4 | 0) + (((nd$2 === null) ? 0 : nd$2.b9) | 0)) | 0));
  }))));
  var this$35 = $f_sc_IterableOps__lastOption__s_Option(fastNodes.d8(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n$2) => ((solved.ay(n$2, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 0))) | 0) === 0))), false));
  return new $c_T2((this$35.c() ? memberVec.t() : this$35.d()), local);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__visit$1__scm_Set__scm_ArrayBuffer__scm_LinkedHashMap__scm_LinkedHashMap__T__V($thiz, done$1, res$1, inAdjR$4, outAdjR$4, seed) {
  var elems = $m_sr_ScalaRunTime$().f(new ($d_T.r().C)([seed]));
  var stk = $ct_scm_Stack__I__(new $c_scm_Stack(), 16).kl(elems);
  while ((!stk.c())) {
    var n = stk.h7(false);
    if ((!done$1.E(n))) {
      done$1.Y(n);
      res$1.aw(n);
      var this$3 = $f_sc_MapOps__apply__O__O(inAdjR$4, n).cx();
      while (this$3.p()) {
        var x0 = this$3.q();
        if ((!done$1.E(x0))) {
          stk.gm(x0);
        }
      }
      var this$4 = $f_sc_MapOps__apply__O__O(outAdjR$4, n).cx();
      while (this$4.p()) {
        var x0$1 = this$4.q();
        if ((!done$1.E(x0$1))) {
          stk.gm(x0$1);
        }
      }
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__decomposeOrderOf$1__sci_Vector__sci_Map__sci_Vector__sci_Vector__sci_Set__sci_Vector($thiz, realEdges$11, nodeSeq$7, fastNodes, plain, rev) {
  var outAdjR = new $c_scm_LinkedHashMap();
  var inAdjR = new $c_scm_LinkedHashMap();
  fastNodes.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n) => {
    $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(outAdjR, n, ($m_scm_ArrayBuffer$(), $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer())), false);
    $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(inAdjR, n, ($m_scm_ArrayBuffer$(), $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer())), false);
  })));
  var seen = $m_scm_Set$().aO();
  var m = $m_scm_Map$().aO();
  var it = plain.o();
  while (it.p()) {
    var elem = it.q();
    var i = (elem | 0);
    var key = realEdges$11.l(i).ai;
    m.ec(key, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      $m_sci_Vector$();
      return new $c_sci_VectorBuilder();
    }))).Y(elem);
  }
  var result = $m_sci_HashMap$().fk;
  var mapIt = m.o();
  while (mapIt.p()) {
    var x1 = mapIt.q();
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1);
    }
    var k = x1.g();
    var v = x1.h();
    result = result.hq(k, v.aR());
  }
  var byTail = result;
  fastNodes.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n$2) => {
    $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(byTail.ay(n$2, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      $m_sci_Vector$();
      return $m_sci_Vector0$();
    }))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((i$1) => {
      var i$2 = (i$1 | 0);
      return new $c_T2(nodeSeq$7.ay(realEdges$11.l(i$2).ak, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 2147483647))), i$2);
    })), new $c_s_math_Ordering$Tuple2Ordering($m_s_math_Ordering$Int$(), $m_s_math_Ordering$Int$())).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => {
      var i$3 = (v1 | 0);
      var e = realEdges$11.l(i$3);
      if ((!seen.E(new $c_T2(e.ai, e.ak)))) {
        seen.Y(new $c_T2(e.ai, e.ak));
        $f_sc_MapOps__apply__O__O(outAdjR, e.ai).Y(e.ak);
        $f_sc_MapOps__apply__O__O(inAdjR, e.ak).Y(e.ai);
      }
    })));
  })));
  var done = $m_scm_Set$().aO();
  $m_scm_ArrayBuffer$();
  var res = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  fastNodes.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((s) => {
    if ((!done.E(s))) {
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__visit$1__scm_Set__scm_ArrayBuffer__scm_LinkedHashMap__scm_LinkedHashMap__T__V($thiz, done, res, inAdjR, outAdjR, s);
    }
  })));
  return $m_sci_Vector$().X(res);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__lead$2__scm_HashMap__T__T($thiz, leaderOf$3, n) {
  var f = (() => n);
  if ((!($objectGetClass(leaderOf$3) === $d_scm_HashMap.l()))) {
    var x1 = leaderOf$3.r(n);
    if ((x1 instanceof $c_s_Some)) {
      var $x_1 = x1.J;
    } else {
      if ((!($m_s_None$() === x1))) {
        throw new $c_s_MatchError(x1);
      }
      var $x_1 = f();
    }
  } else {
    var originalHash = $m_sr_Statics$().u(n);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var x1$1 = leaderOf$3.S.a[(hash & ((leaderOf$3.S.a.length - 1) | 0))];
    var nd = ((x1$1 === null) ? null : x1$1.by(n, hash));
    var $x_1 = ((nd === null) ? f() : nd.b9);
  }
  return $x_1;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__fastMake$1__scm_HashMap__scm_ArrayBuffer__scm_ArrayBuffer__scm_ArrayBuffer__scm_ArrayBuffer__scm_ArrayBuffer__scm_LinkedHashMap__scm_LinkedHashMap__T__T__I__I__V($thiz, fastByPair$1, fMinlen$1, fWeight$1, fTail$1, fHead$1, fAlive$1, fOut$1, fIn$1, t, h, ml, w) {
  var x37 = fastByPair$1.r(new $c_T2(t, h));
  if ((x37 instanceof $c_s_Some)) {
    var i = (x37.J | 0);
    var x = (fMinlen$1.l(i) | 0);
    fMinlen$1.cM(i, ((x > ml) ? x : ml));
    fWeight$1.cM(i, (((fWeight$1.l(i) | 0) + w) | 0));
    return (void 0);
  }
  if (($m_s_None$() === x37)) {
    var i$2 = fTail$1.a1;
    fTail$1.aw(t);
    fHead$1.aw(h);
    fMinlen$1.aw(ml);
    fWeight$1.aw(w);
    fAlive$1.aw(true);
    var f = (() => {
      $m_scm_ArrayBuffer$();
      return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
    });
    if ((!($objectGetClass(fOut$1) === $d_scm_LinkedHashMap.l()))) {
      var x1 = fOut$1.r(t);
      if ((x1 instanceof $c_s_Some)) {
        var $x_1 = x1.J;
      } else {
        if ((!($m_s_None$() === x1))) {
          throw new $c_s_MatchError(x1);
        }
        var d = f();
        $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(fOut$1, t, d, false);
        var $x_1 = d;
      }
    } else {
      var originalHash = $m_sr_Statics$().u(t);
      var hash = (originalHash ^ ((originalHash >>> 16) | 0));
      var idx = (hash & ((fOut$1.au.a.length - 1) | 0));
      var x1$1 = fOut$1.au.a[idx];
      var nd = ((x1$1 === null) ? null : x1$1.ij(t, hash));
      if ((nd !== null)) {
        var $x_1 = nd.fs;
      } else {
        var table0 = fOut$1.au;
        var default$1 = f();
        if ((((1 + fOut$1.e0) | 0) >= fOut$1.ki)) {
          $p_scm_LinkedHashMap__growTable__I__V(fOut$1, (fOut$1.au.a.length << 1));
        }
        $p_scm_LinkedHashMap__put0__O__O__Z__I__I__s_Some(fOut$1, t, default$1, false, hash, ((table0 === fOut$1.au) ? idx : (hash & ((fOut$1.au.a.length - 1) | 0))));
        var $x_1 = default$1;
      }
    }
    $x_1.Y(i$2);
    var f$1 = (() => {
      $m_scm_ArrayBuffer$();
      return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
    });
    if ((!($objectGetClass(fIn$1) === $d_scm_LinkedHashMap.l()))) {
      var x1$2 = fIn$1.r(h);
      if ((x1$2 instanceof $c_s_Some)) {
        var $x_2 = x1$2.J;
      } else {
        if ((!($m_s_None$() === x1$2))) {
          throw new $c_s_MatchError(x1$2);
        }
        var d$1 = f$1();
        $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(fIn$1, h, d$1, false);
        var $x_2 = d$1;
      }
    } else {
      var originalHash$1 = $m_sr_Statics$().u(h);
      var hash$1 = (originalHash$1 ^ ((originalHash$1 >>> 16) | 0));
      var idx$1 = (hash$1 & ((fIn$1.au.a.length - 1) | 0));
      var x1$3 = fIn$1.au.a[idx$1];
      var nd$1 = ((x1$3 === null) ? null : x1$3.ij(h, hash$1));
      if ((nd$1 !== null)) {
        var $x_2 = nd$1.fs;
      } else {
        var table0$1 = fIn$1.au;
        var default$2 = f$1();
        if ((((1 + fIn$1.e0) | 0) >= fIn$1.ki)) {
          $p_scm_LinkedHashMap__growTable__I__V(fIn$1, (fIn$1.au.a.length << 1));
        }
        $p_scm_LinkedHashMap__put0__O__O__Z__I__I__s_Some(fIn$1, h, default$2, false, hash$1, ((table0$1 === fIn$1.au) ? idx$1 : (hash$1 & ((fIn$1.au.a.length - 1) | 0))));
        var $x_2 = default$2;
      }
    }
    $x_2.Y(i$2);
    $p_scm_HashMap__put0__O__O__Z__s_Some(fastByPair$1, new $c_T2(t, h), i$2, false);
    return (void 0);
  }
  throw new $c_s_MatchError(x37);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__zap$1__scm_ArrayBuffer__I__V($thiz, buf, e) {
  var j = $f_sc_SeqOps__indexOf__O__I__I(buf, e, 0);
  if ((j >= 0)) {
    buf.cM(j, buf.l(((buf.a1 - 1) | 0)));
    buf.wd(((buf.a1 - 1) | 0));
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__fastReverse$1__scm_ArrayBuffer__scm_LinkedHashMap__scm_ArrayBuffer__scm_LinkedHashMap__scm_ArrayBuffer__scm_HashMap__scm_ArrayBuffer__scm_ArrayBuffer__I__V($thiz, fAlive$2, fOut$2, fTail$2, fIn$2, fHead$2, fastByPair$2, fMinlen$2, fWeight$2, e) {
  fAlive$2.cM(e, false);
  var key = fTail$2.l(e);
  var f = (() => {
    $m_scm_ArrayBuffer$();
    return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  });
  if ((!($objectGetClass(fOut$2) === $d_scm_LinkedHashMap.l()))) {
    var x1 = fOut$2.r(key);
    if ((x1 instanceof $c_s_Some)) {
      var $x_1 = x1.J;
    } else {
      if ((!($m_s_None$() === x1))) {
        throw new $c_s_MatchError(x1);
      }
      var d = f();
      $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(fOut$2, key, d, false);
      var $x_1 = d;
    }
  } else {
    var originalHash = $m_sr_Statics$().u(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var idx = (hash & ((fOut$2.au.a.length - 1) | 0));
    var x1$1 = fOut$2.au.a[idx];
    var nd = ((x1$1 === null) ? null : x1$1.ij(key, hash));
    if ((nd !== null)) {
      var $x_1 = nd.fs;
    } else {
      var table0 = fOut$2.au;
      var default$1 = f();
      if ((((1 + fOut$2.e0) | 0) >= fOut$2.ki)) {
        $p_scm_LinkedHashMap__growTable__I__V(fOut$2, (fOut$2.au.a.length << 1));
      }
      $p_scm_LinkedHashMap__put0__O__O__Z__I__I__s_Some(fOut$2, key, default$1, false, hash, ((table0 === fOut$2.au) ? idx : (hash & ((fOut$2.au.a.length - 1) | 0))));
      var $x_1 = default$1;
    }
  }
  $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__zap$1__scm_ArrayBuffer__I__V($thiz, $x_1, e);
  var key$1 = fHead$2.l(e);
  var f$1 = (() => {
    $m_scm_ArrayBuffer$();
    return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  });
  if ((!($objectGetClass(fIn$2) === $d_scm_LinkedHashMap.l()))) {
    var x1$2 = fIn$2.r(key$1);
    if ((x1$2 instanceof $c_s_Some)) {
      var $x_2 = x1$2.J;
    } else {
      if ((!($m_s_None$() === x1$2))) {
        throw new $c_s_MatchError(x1$2);
      }
      var d$1 = f$1();
      $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(fIn$2, key$1, d$1, false);
      var $x_2 = d$1;
    }
  } else {
    var originalHash$1 = $m_sr_Statics$().u(key$1);
    var hash$1 = (originalHash$1 ^ ((originalHash$1 >>> 16) | 0));
    var idx$1 = (hash$1 & ((fIn$2.au.a.length - 1) | 0));
    var x1$3 = fIn$2.au.a[idx$1];
    var nd$1 = ((x1$3 === null) ? null : x1$3.ij(key$1, hash$1));
    if ((nd$1 !== null)) {
      var $x_2 = nd$1.fs;
    } else {
      var table0$1 = fIn$2.au;
      var default$2 = f$1();
      if ((((1 + fIn$2.e0) | 0) >= fIn$2.ki)) {
        $p_scm_LinkedHashMap__growTable__I__V(fIn$2, (fIn$2.au.a.length << 1));
      }
      $p_scm_LinkedHashMap__put0__O__O__Z__I__I__s_Some(fIn$2, key$1, default$2, false, hash$1, ((table0$1 === fIn$2.au) ? idx$1 : (hash$1 & ((fIn$2.au.a.length - 1) | 0))));
      var $x_2 = default$2;
    }
  }
  $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__zap$1__scm_ArrayBuffer__I__V($thiz, $x_2, e);
  fastByPair$2.AD(new $c_T2(fTail$2.l(e), fHead$2.l(e)));
  $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__fastMake$1__scm_HashMap__scm_ArrayBuffer__scm_ArrayBuffer__scm_ArrayBuffer__scm_ArrayBuffer__scm_ArrayBuffer__scm_LinkedHashMap__scm_LinkedHashMap__T__T__I__I__V($thiz, fastByPair$2, fMinlen$2, fWeight$2, fTail$2, fHead$2, fAlive$2, fOut$2, fIn$2, fHead$2.l(e), fTail$2.l(e), (fMinlen$2.l(e) | 0), (fWeight$2.l(e) | 0));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__visit$2__scm_Set__scm_ArrayBuffer__scm_LinkedHashMap__scm_LinkedHashMap__T__V($thiz, done2$1, res$3, inAdjR$9, outAdjR$9, seed) {
  var elems = $m_sr_ScalaRunTime$().f(new ($d_T.r().C)([seed]));
  var stk = $ct_scm_Stack__I__(new $c_scm_Stack(), 16).kl(elems);
  while ((!stk.c())) {
    var n = stk.h7(false);
    if ((!done2$1.E(n))) {
      done2$1.Y(n);
      res$3.aw(n);
      var this$3 = $f_sc_MapOps__apply__O__O(inAdjR$9, n).cx();
      while (this$3.p()) {
        var x0 = this$3.q();
        if ((!done2$1.E(x0))) {
          stk.gm(x0);
        }
      }
      var this$4 = $f_sc_MapOps__apply__O__O(outAdjR$9, n).cx();
      while (this$4.p()) {
        var x0$1 = this$4.q();
        if ((!done2$1.E(x0$1))) {
          stk.gm(x0$1);
        }
      }
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__dfs$3__scm_Set__scm_Set__scm_LinkedHashMap__scm_ArrayBuffer__scm_ArrayBuffer__scm_ArrayBuffer__scm_LinkedHashMap__scm_HashMap__scm_ArrayBuffer__scm_ArrayBuffer__T__V($thiz, mark$5, onStack$5, fOut$7, fHead$7, fAlive$7, fTail$7, fIn$7, fastByPair$7, fMinlen$7, fWeight$7, n) {
  if ((!mark$5.E(n))) {
    mark$5.Y(n);
    onStack$5.Y(n);
    var f = (() => {
      $m_scm_ArrayBuffer$();
      return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
    });
    if ((!($objectGetClass(fOut$7) === $d_scm_LinkedHashMap.l()))) {
      var x1 = fOut$7.r(n);
      if ((x1 instanceof $c_s_Some)) {
        var $x_1 = x1.J;
      } else {
        if ((!($m_s_None$() === x1))) {
          throw new $c_s_MatchError(x1);
        }
        var d = f();
        $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(fOut$7, n, d, false);
        var $x_1 = d;
      }
    } else {
      var originalHash = $m_sr_Statics$().u(n);
      var hash = (originalHash ^ ((originalHash >>> 16) | 0));
      var idx = (hash & ((fOut$7.au.a.length - 1) | 0));
      var x1$1 = fOut$7.au.a[idx];
      var nd = ((x1$1 === null) ? null : x1$1.ij(n, hash));
      if ((nd !== null)) {
        var $x_1 = nd.fs;
      } else {
        var table0 = fOut$7.au;
        var default$1 = f();
        if ((((1 + fOut$7.e0) | 0) >= fOut$7.ki)) {
          $p_scm_LinkedHashMap__growTable__I__V(fOut$7, (fOut$7.au.a.length << 1));
        }
        $p_scm_LinkedHashMap__put0__O__O__Z__I__I__s_Some(fOut$7, n, default$1, false, hash, ((table0 === fOut$7.au) ? idx : (hash & ((fOut$7.au.a.length - 1) | 0))));
        var $x_1 = default$1;
      }
    }
    var out = $x_1;
    var i = 0;
    while ((i < out.a1)) {
      var e = (out.l(i) | 0);
      var w = fHead$7.l(e);
      if (onStack$5.E(w)) {
        $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__fastReverse$1__scm_ArrayBuffer__scm_LinkedHashMap__scm_ArrayBuffer__scm_LinkedHashMap__scm_ArrayBuffer__scm_HashMap__scm_ArrayBuffer__scm_ArrayBuffer__I__V($thiz, fAlive$7, fOut$7, fTail$7, fIn$7, fHead$7, fastByPair$7, fMinlen$7, fWeight$7, e);
      } else {
        if ((!mark$5.E(w))) {
          $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__dfs$3__scm_Set__scm_Set__scm_LinkedHashMap__scm_ArrayBuffer__scm_ArrayBuffer__scm_ArrayBuffer__scm_LinkedHashMap__scm_HashMap__scm_ArrayBuffer__scm_ArrayBuffer__T__V($thiz, mark$5, onStack$5, fOut$7, fHead$7, fAlive$7, fTail$7, fIn$7, fastByPair$7, fMinlen$7, fWeight$7, w);
        }
        i = ((1 + i) | 0);
      }
    }
    onStack$5.re(n);
  }
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$() {
  this.aum = null;
  $n_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$ = this;
  this.aum = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_GraphMemo();
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$.prototype = $p;
$p.J0 = (function(g) {
  var this$1 = g.cu;
  var res = false;
  var it = this$1.o();
  while (((!res) && it.p())) {
    var x0 = it.q();
    if ((x0.ai !== x0.ak)) {
      var this$3 = x0.b4.ag.r("label");
      res = ((!this$3.c()) && (this$3.d() !== ""));
    } else {
      res = false;
    }
  }
  return res;
});
$p.pD = (function(g) {
  return $m_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$().b1I(g.f2.ag.r("rankdir"));
});
$p.jT = (function(g) {
  return this.pD(g).b3j();
});
$p.Wz = (function(attrs) {
  var x6 = attrs.ag.r("constraint");
  if ((x6 instanceof $c_s_Some)) {
    var v = x6.J;
    var x5 = v.toLowerCase();
    matchAlts1: {
      matchAlts2: {
        if ((x5 === "false")) {
          break matchAlts2;
        }
        if ((x5 === "no")) {
          break matchAlts2;
        }
        break matchAlts1;
      }
      return false;
    }
    var this$3 = $m_sc_StringParsers$().hT(x5);
    return (this$3.c() || ((this$3.d() | 0) > 0));
  }
  if (($m_s_None$() === x6)) {
    return true;
  }
  throw new $c_s_MatchError(x6);
});
$p.aRl = (function(g) {
  var this$1 = this.aum;
  if ((g === this$1.f0)) {
    var $x_1 = this$1.f1;
  } else {
    var v = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$__rankedImpl__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T2($m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$(), g);
    this$1.f0 = g;
    this$1.f1 = v;
    var $x_1 = v;
  }
  return $x_1;
});
$p.P0 = (function(g) {
  return this.aRl(g).g();
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$, "org.jpablo.graphexplorer.graphviz.layout.Rank$", ({
  vd: 1
}));
var $n_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$;
function $m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$() {
  if ((!$n_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$)) {
    $n_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$ = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$();
  }
  return $n_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$__parseLevel__Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$P__Z__Z__sci_Vector($thiz, p, lr, html) {
  $m_scm_ArrayBuffer$();
  var fields = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  var txt = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  var elem = $m_s_None$();
  var elem$1 = null;
  elem$1 = elem;
  var elem$2 = $m_s_None$();
  var elem$3 = null;
  elem$3 = elem$2;
  var inPort = false;
  var port = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  var closed = false;
  while (((!closed) && (!p.b0G()))) {
    var this$4 = p.RQ;
    var index = p.j4;
    var c = this$4.charCodeAt(index);
    if ((c < 32)) {
      p.j4 = ((1 + p.j4) | 0);
    } else if (((c === 92) && (((1 + p.j4) | 0) < p.RQ.length))) {
      p.j4 = ((1 + p.j4) | 0);
      var this$6 = p.RQ;
      var index$1 = p.j4;
      var n = this$6.charCodeAt(index$1);
      if (((!html) && (n === 32))) {
        txt.id(32);
      } else {
        txt.id(92);
        txt.id(n);
      }
      p.j4 = ((1 + p.j4) | 0);
    } else {
      matchResult2: {
        if (((c === 60) && (!html))) {
          inPort = true;
          port.bP.PS(0);
          p.j4 = ((1 + p.j4) | 0);
          break matchResult2;
        }
        if (((c === 62) && (!html))) {
          elem$1 = new $c_s_Some($f_T__trim__T(port.bP.ah));
          inPort = false;
          p.j4 = ((1 + p.j4) | 0);
          break matchResult2;
        }
        switch (c) {
          case 123: {
            p.j4 = ((1 + p.j4) | 0);
            elem$3 = new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$Field($m_s_None$(), $m_s_None$(), (!lr), $p_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$__parseLevel__Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$P__Z__Z__sci_Vector($thiz, p, (!lr), html)));
            break;
          }
          case 125: {
            p.j4 = ((1 + p.j4) | 0);
            var t0 = txt.bP.ah;
            var t = (html ? (((t0.length >= 2) && (!(!t0.endsWith(" ")))) ? $m_sc_StringOps$().WF(t0, 1) : t0) : $f_T__trim__T(t0));
            matchResult1: {
              var $x_1;
              var x1 = elem$3;
              if ((x1 instanceof $c_s_Some)) {
                var st = x1.J;
                var $x_1 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$Field(elem$1, $m_s_None$(), st.wL, st.hX);
                break matchResult1;
              }
              if (($m_s_None$() === x1)) {
                var $x_1 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$Field(elem$1, new $c_s_Some(((t === "") ? " " : t)), true, ($m_sci_Vector$(), $m_sci_Vector0$()));
                break matchResult1;
              }
              throw new $c_s_MatchError(x1);
            }
            fields.aw($x_1);
            txt.bP.PS(0);
            elem$1 = $m_s_None$();
            elem$3 = $m_s_None$();
            closed = true;
            break;
          }
          case 124: {
            p.j4 = ((1 + p.j4) | 0);
            var t0$1 = txt.bP.ah;
            var t$1 = (html ? (((t0$1.length >= 2) && (!(!t0$1.endsWith(" ")))) ? $m_sc_StringOps$().WF(t0$1, 1) : t0$1) : $f_T__trim__T(t0$1));
            matchResult1$1: {
              var $x_2;
              var x1$1 = elem$3;
              if ((x1$1 instanceof $c_s_Some)) {
                var st$1 = x1$1.J;
                var $x_2 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$Field(elem$1, $m_s_None$(), st$1.wL, st$1.hX);
                break matchResult1$1;
              }
              if (($m_s_None$() === x1$1)) {
                var $x_2 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$Field(elem$1, new $c_s_Some(((t$1 === "") ? " " : t$1)), true, ($m_sci_Vector$(), $m_sci_Vector0$()));
                break matchResult1$1;
              }
              throw new $c_s_MatchError(x1$1);
            }
            fields.aw($x_2);
            txt.bP.PS(0);
            elem$1 = $m_s_None$();
            elem$3 = $m_s_None$();
            break;
          }
          default: {
            if (inPort) {
              port.id(c);
            } else {
              $p_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$__pushText$1__Z__scm_StringBuilder__C__V($thiz, html, txt, c);
            }
            p.j4 = ((1 + p.j4) | 0);
          }
        }
      }
    }
  }
  if ((!closed)) {
    var t0$2 = txt.bP.ah;
    var t$2 = (html ? (((t0$2.length >= 2) && (!(!t0$2.endsWith(" ")))) ? $m_sc_StringOps$().WF(t0$2, 1) : t0$2) : $f_T__trim__T(t0$2));
    matchResult1$2: {
      var $x_3;
      var x1$2 = elem$3;
      if ((x1$2 instanceof $c_s_Some)) {
        var st$2 = x1$2.J;
        var $x_3 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$Field(elem$1, $m_s_None$(), st$2.wL, st$2.hX);
        break matchResult1$2;
      }
      if (($m_s_None$() === x1$2)) {
        var $x_3 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$Field(elem$1, new $c_s_Some(((t$2 === "") ? " " : t$2)), true, ($m_sci_Vector$(), $m_sci_Vector0$()));
        break matchResult1$2;
      }
      throw new $c_s_MatchError(x1$2);
    }
    fields.aw($x_3);
    txt.bP.PS(0);
    elem$1 = $m_s_None$();
    elem$3 = $m_s_None$();
  }
  return $m_sci_Vector$().X(fields);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$__textDimen__T__D__T__T__T__T2($thiz, text, fontSizePt, fontName, nodeId, graphName) {
  var this$1 = fontName.toLowerCase();
  var bold = ((this$1.indexOf("bold") | 0) !== (-1));
  var this$2 = fontName.toLowerCase();
  if (((this$2.indexOf("italic") | 0) !== (-1))) {
    var italic = true;
  } else {
    var this$3 = fontName.toLowerCase();
    var italic = ((this$3.indexOf("oblique") | 0) !== (-1));
  }
  var this$4 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().a42(text, nodeId, graphName);
  var f = ((_$1) => _$1.g());
  if ((this$4 === $m_sci_Nil$())) {
    var lines = $m_sci_Nil$();
  } else {
    var x0 = this$4.t();
    var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
    var t = h;
    var rest = this$4.v();
    while ((rest !== $m_sci_Nil$())) {
      var x0$1 = rest.t();
      var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
      t.U = nx;
      t = nx;
      rest = rest.v();
    }
    var lines = h;
  }
  var this$7 = $f_sc_IterableOnceOps__maxOption__s_math_Ordering__s_Option(new $c_sc_Iterator$$anon$9(lines.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((l) => ((l === "") ? 0.0 : (fontSizePt * $m_Lorg_jpablo_graphexplorer_graphviz_metrics_FontMetrics$().WI(fontName, l, bold, italic)))))), $m_s_math_Ordering$DeprecatedDoubleOrdering$());
  return new $c_T2((+(this$7.c() ? 0.0 : this$7.d())), (+$f_sc_IterableOnceOps__sum__s_math_Numeric__O(new $c_sc_Iterator$$anon$9(lines.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((l$2) => ((l$2 === "") ? $doubleToInt((fontSizePt * $m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$().a80)) : (fontSizePt * $m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$().a80))))), $m_s_math_Numeric$DoubleIsFractional$())));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$__sizeOf__Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$Field__D__T__s_Option__Z__sci_Map__T__T__V($thiz, f, fontSizePt, fontName, margin, html, imgs, nodeId, graphName) {
  if ($f_sc_SeqOps__isEmpty__Z(f.hX)) {
    matchResult4: {
      var \u03b41$___1;
      var \u03b41$___2;
      if (html) {
        matchResult3: {
          var x8;
          var $x_1 = $m_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$();
          var this$2 = f.L2;
          var x5 = $x_1.mU((this$2.c() ? " " : this$2.d()));
          if ((x5 instanceof $c_s_Some)) {
            var lbl = x5.J;
            f.a81 = new $c_s_Some(lbl);
            var x8 = $m_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$().PU(lbl, fontSizePt, fontName, imgs);
            break matchResult3;
          }
          if (($m_s_None$() === x5)) {
            var this$4 = f.L2;
            var x8 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$__textDimen__T__D__T__T__T__T2($thiz, (this$4.c() ? " " : this$4.d()), fontSizePt, fontName, nodeId, graphName);
            break matchResult3;
          }
          throw new $c_s_MatchError(x5);
        }
      } else {
        var this$5 = f.L2;
        var x8 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$__textDimen__T__D__T__T__T__T2($thiz, (this$5.c() ? " " : this$5.d()), fontSizePt, fontName, nodeId, graphName);
      }
      if ((x8 !== null)) {
        var \u03b41$___1 = (+x8.g());
        var \u03b41$___2 = (+x8.h());
        break matchResult4;
      }
      throw new $c_s_MatchError(x8);
    }
    var tw$2 = (+\u03b41$___1);
    var th$2 = (+\u03b41$___2);
    if (((tw$2 > 0.0) || (th$2 > 0.0))) {
      matchResult5: {
        if ((margin instanceof $c_s_Some)) {
          var x13 = margin.J;
          if ((x13 !== null)) {
            var mx = (+x13.g());
            var my = (+x13.h());
            f.oZ = (tw$2 + (2.0 * mx));
            f.p0 = (th$2 + (2.0 * my));
            break matchResult5;
          }
        }
        if (($m_s_None$() === margin)) {
          f.oZ = (tw$2 + $thiz.aun);
          f.p0 = (th$2 + $thiz.auo);
          break matchResult5;
        }
        throw new $c_s_MatchError(margin);
      }
    } else {
      f.oZ = tw$2;
      f.p0 = th$2;
    }
  } else {
    var x$5 = new $c_sr_DoubleRef(0.0);
    var y = new $c_sr_DoubleRef(0.0);
    f.hX.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((c) => {
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$__sizeOf__Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$Field__D__T__s_Option__Z__sci_Map__T__T__V($m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$(), c, fontSizePt, fontName, margin, html, imgs, nodeId, graphName);
      if (f.wL) {
        x$5.T = (x$5.T + c.oZ);
        var x$1 = y.T;
        var y$1 = c.p0;
        y.T = (+Math.max(x$1, y$1));
      } else {
        y.T = (y.T + c.p0);
        var x$2 = x$5.T;
        var y$2 = c.oZ;
        x$5.T = (+Math.max(x$2, y$2));
      }
    })));
    f.oZ = x$5.T;
    f.p0 = y.T;
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$__resize__Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$Field__D__D__V($thiz, f, sx, sy) {
  f.oZ = sx;
  f.p0 = sy;
  if ((!$f_sc_SeqOps__isEmpty__Z(f.hX))) {
    var n = f.hX.C();
    var d = (f.wL ? (sx - (+$f_sc_IterableOnceOps__sum__s_math_Numeric__O(new $c_sc_Iterator$$anon$9(f.hX.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => _$2.oZ))), $m_s_math_Numeric$DoubleIsFractional$()))) : (sy - (+$f_sc_IterableOnceOps__sum__s_math_Numeric__O(new $c_sc_Iterator$$anon$9(f.hX.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3) => _$3.p0))), $m_s_math_Numeric$DoubleIsFractional$()))));
    var inc = (d / n);
    var i = 0;
    while ((i < n)) {
      var x = (((1 + i) | 0) * inc);
      var $x_1 = Math.floor(x);
      var x$1 = (i * inc);
      var amt = (($doubleToInt((+$x_1)) - $doubleToInt((+Math.floor(x$1)))) | 0);
      var c = f.hX.l(i);
      if (f.wL) {
        $p_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$__resize__Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$Field__D__D__V($thiz, c, (c.oZ + amt), sy);
      } else {
        $p_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$__resize__Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$Field__D__D__V($thiz, c, sx, (c.p0 + amt));
      }
      i = ((1 + i) | 0);
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$__pos__Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$Field__D__D__I__V($thiz, f, ulx, uly, sides) {
  f.a82 = sides;
  f.n5 = ulx;
  f.q0 = (uly - f.p0);
  f.q1 = (ulx + f.oZ);
  f.o2 = uly;
  var elem = 0.0;
  elem = ulx;
  var elem$1 = 0.0;
  elem$1 = uly;
  var last = ((f.hX.C() - 1) | 0);
  var this$4 = new $c_sc_Iterator$$anon$16(f.hX.o());
  while (this$4.p()) {
    var x0 = this$4.dC();
    matchResult6: {
      if ((x0 !== null)) {
        var c = x0.g();
        var i = (x0.h() | 0);
        var mask = ((sides === 0) ? 0 : (f.wL ? ((i === 0) ? ((i === last) ? $m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$().ZU : (($m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$().wK | $m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$().wJ) | $m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$().pZ)) : ((i === last) ? (($m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$().wK | $m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$().wJ) | $m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$().Bw) : ($m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$().wK | $m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$().wJ))) : ((i === 0) ? ((i === last) ? $m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$().ZU : (($m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$().wK | $m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$().Bw) | $m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$().pZ)) : ((i === last) ? (($m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$().pZ | $m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$().wJ) | $m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$().Bw) : ($m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$().pZ | $m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$().Bw)))));
        $p_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$__pos__Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$Field__D__D__I__V($m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$(), c, elem, elem$1, (sides & mask));
        if (f.wL) {
          elem = (elem + c.oZ);
          break matchResult6;
        } else {
          elem$1 = (elem$1 - c.p0);
          break matchResult6;
        }
      }
      throw new $c_s_MatchError(x0);
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$__pushText$1__Z__scm_StringBuilder__C__V($thiz, html$1, txt$1, c) {
  if (html$1) {
    if ((!((c === 32) && txt$1.c()))) {
      txt$1.id(c);
    }
  } else if ((!((c === 32) && (txt$1.c() || ($uC($f_sc_IndexedSeqOps__last__O(txt$1)) === 32))))) {
    txt$1.id(c);
  }
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$() {
  this.aun = 0.0;
  this.auo = 0.0;
  this.a80 = 0.0;
  this.RP = 0.0;
  this.wJ = 0;
  this.Bw = 0;
  this.wK = 0;
  this.pZ = 0;
  this.ZU = 0;
  $n_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$ = this;
  this.aun = 16.0;
  this.auo = 8.0;
  this.a80 = 1.2;
  this.RP = 72.0;
  this.wJ = 1;
  this.Bw = 2;
  this.wK = 4;
  this.pZ = 8;
  this.ZU = (((this.wJ | this.Bw) | this.wK) | this.pZ);
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$.prototype = $p;
$p.aQU = (function(label, topLR, html) {
  return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$Field($m_s_None$(), $m_s_None$(), topLR, $p_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$__parseLevel__Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$P__Z__Z__sci_Vector(this, new $c_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$P(label), topLR, html));
});
$p.agQ = (function(label, topLR, fontSizePt, fontName, minWIn, minHIn, fixed, margin, html, imgs, nodeId, graphName) {
  var root = this.aQU(label, topLR, html);
  $p_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$__sizeOf__Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$Field__D__T__s_Option__Z__sci_Map__T__T__V(this, root, fontSizePt, fontName, margin, html, imgs, nodeId, graphName);
  var mw = (minWIn * this.RP);
  var mh = (minHIn * this.RP);
  if (fixed) {
    var sx = mw;
  } else {
    var x = root.oZ;
    var sx = (+Math.max(x, mw));
  }
  if (fixed) {
    var sy = mh;
  } else {
    var x$1 = root.p0;
    var sy = (+Math.max(x$1, mh));
  }
  $p_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$__resize__Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$Field__D__D__V(this, root, sx, sy);
  $p_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$__pos__Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$Field__D__D__I__V(this, root, (0.5 * (-sx)), (0.5 * sy), this.ZU);
  return new $c_T3((root.oZ / this.RP), ((root.p0 + 1.0) / this.RP), root);
});
$p.afH = (function(root, portId) {
  return (root.ZV.E(portId) ? new $c_s_Some(root) : $f_sc_Iterator__nextOption__s_Option(new $c_sc_Iterator$$anon$10(root.hX.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((f) => $m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$().afH(f, portId))))));
});
$p.b1a = (function(root, portId) {
  var this$1 = this.afH(root, portId);
  if (this$1.c()) {
    return $m_s_None$();
  } else {
    var x0 = this$1.d();
    return new $c_s_Some(new $c_T4(x0.n5, x0.q0, x0.q1, x0.o2));
  }
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$, "org.jpablo.graphexplorer.graphviz.layout.RecordLabel$", ({
  vj: 1
}));
var $n_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$;
function $m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$() {
  if ((!$n_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$)) {
    $n_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$ = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$();
  }
  return $n_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$Field(id, text, lr, flds) {
  this.ZV = null;
  this.L2 = null;
  this.wL = false;
  this.hX = null;
  this.oZ = 0.0;
  this.p0 = 0.0;
  this.n5 = 0.0;
  this.q0 = 0.0;
  this.q1 = 0.0;
  this.o2 = 0.0;
  this.a82 = 0;
  this.a81 = null;
  this.ZV = id;
  this.L2 = text;
  this.wL = lr;
  this.hX = flds;
  this.oZ = 0.0;
  this.p0 = 0.0;
  this.n5 = 0.0;
  this.q0 = 0.0;
  this.q1 = 0.0;
  this.o2 = 0.0;
  this.a82 = 0;
  this.a81 = $m_s_None$();
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$Field.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$Field;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$Field() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$Field.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$Field = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$Field, "org.jpablo.graphexplorer.graphviz.layout.RecordLabel$Field", ({
  vk: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$P(s) {
  this.RQ = null;
  this.j4 = 0;
  this.RQ = s;
  this.j4 = 0;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$P.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$P;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$P() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$P.prototype = $p;
$p.b0G = (function() {
  return (this.j4 >= this.RQ.length);
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$P = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$P, "org.jpablo.graphexplorer.graphviz.layout.RecordLabel$P", ({
  vl: 1
}));
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__allocInterp__sci_Vector__I__I__AT2($thiz, af, sides, code) {
  var rbconst = 12.0;
  var seg = 0;
  while ((seg < sides)) {
    var p0 = af.l(seg);
    var p1 = af.l(((((1 + seg) | 0) % $checkIntDivisor(sides)) | 0));
    var x$1 = rbconst;
    var y$1 = ($m_jl_Math$().ga(((+p1.g()) - (+p0.g())), ((+p1.h()) - (+p0.h()))) / 3.0);
    rbconst = (+Math.min(x$1, y$1));
    seg = ((1 + seg) | 0);
  }
  var b = new ($d_T2.r().C)(((3 + Math.imul(3, sides)) | 0));
  var i = 0;
  seg = 0;
  while ((seg < sides)) {
    var p0$2 = af.l(seg);
    var p1$2 = af.l(((((1 + seg) | 0) % $checkIntDivisor(sides)) | 0));
    var d = $m_jl_Math$().ga(((+p1$2.g()) - (+p0$2.g())), ((+p1$2.h()) - (+p0$2.h())));
    var t = (rbconst / d);
    if (((((code - 4) | 0) >>> 0) <= 1)) {
      t = (t / 3.0);
    } else if ((code === 1)) {
      t = (0.5 * t);
    }
    b.a[i] = p0$2;
    i = ((1 + i) | 0);
    var $x_1 = i;
    var t$proxy4 = t;
    b.a[$x_1] = new $c_T2(((+p0$2.g()) + (t$proxy4 * ((+p1$2.g()) - (+p0$2.g())))), ((+p0$2.h()) + (t$proxy4 * ((+p1$2.h()) - (+p0$2.h())))));
    i = ((1 + i) | 0);
    var $x_2 = i;
    var t$proxy5 = (1.0 - t);
    b.a[$x_2] = new $c_T2(((+p0$2.g()) + (t$proxy5 * ((+p1$2.g()) - (+p0$2.g())))), ((+p0$2.h()) + (t$proxy5 * ((+p1$2.h()) - (+p0$2.h())))));
    i = ((1 + i) | 0);
    seg = ((1 + seg) | 0);
  }
  b.a[i] = b.a[0];
  i = ((1 + i) | 0);
  b.a[i] = b.a[1];
  i = ((1 + i) | 0);
  b.a[i] = b.a[2];
  return b;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__nxt$1__sci_Vector__I__I__T2($thiz, af$1, sides$1, s) {
  return af$1.l(((((1 + s) | 0) % $checkIntDivisor(sides$1)) | 0));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__poly$1__scm_ListBuffer__Z__AT2__I__V($thiz, ops$1, filled$2, d, n) {
  var this$3 = $m_s_Predef$().fB($m_sc_ArrayOps$().ls(d, 0, n));
  ops$1.bb(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$Op$Poly($m_sci_Vector$().X(this$3), filled$2));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__line$1__scm_ListBuffer__sci_Seq__V($thiz, ops$2, pts) {
  ops$2.bb(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$Op$Line(pts.d2()));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D($thiz, b$1) {
  return ((+b$1.a[2].g()) - (+b$1.a[3].g()));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D($thiz, b$2) {
  return ((+b$2.a[3].h()) - (+b$2.a[4].h()));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__rect$1__I__AT2__D__D__AT2($thiz, sides$2, b$3, x0, y0) {
  var r = new ($d_T2.r().C)(sides$2);
  r.a[0] = new $c_T2(x0, y0);
  r.a[1] = new $c_T2((x0 + $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D($thiz, b$3)), y0);
  r.a[2] = new $c_T2(r.a[1].g(), ((+r.a[1].h()) + (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D($thiz, b$3))));
  r.a[3] = new $c_T2(x0, r.a[2].h());
  return r;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__rect$2__D__I__AT2__D__AT2($thiz, mx$1, sides$3, b$4, y0) {
  var x0 = (mx$1 - $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D($thiz, b$4));
  var r = new ($d_T2.r().C)(sides$3);
  r.a[0] = new $c_T2(x0, y0);
  r.a[1] = new $c_T2((x0 + (2.0 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D($thiz, b$4))), y0);
  r.a[2] = new $c_T2(r.a[1].g(), ((+r.a[1].h()) + (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D($thiz, b$4))));
  r.a[3] = new $c_T2(x0, r.a[2].h());
  return r;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$() {
  this.RR = null;
  this.aup = 0.0;
  this.a83 = 0.0;
  $n_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$ = this;
  this.RR = $m_sci_Map$().ao($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("note", 1), new $c_T2("tab", 2), new $c_T2("folder", 3), new $c_T2("box3d", 4), new $c_T2("component", 5), new $c_T2("promoter", 6), new $c_T2("cds", 7), new $c_T2("terminator", 8), new $c_T2("utr", 9), new $c_T2("primersite", 10), new $c_T2("restrictionsite", 11), new $c_T2("fivepoverhang", 12), new $c_T2("threepoverhang", 13), new $c_T2("noverhang", 14), new $c_T2("assembly", 15), new $c_T2("signature", 16), new $c_T2("insulator", 17), new $c_T2("ribosite", 18), new $c_T2("rnastab", 19), new $c_T2("proteasesite", 20), new $c_T2("proteinstab", 21), new $c_T2("rpromoter", 22), new $c_T2("rarrow", 23), new $c_T2("larrow", 24), new $c_T2("lpromoter", 25)])));
  this.aup = 12.0;
  this.a83 = 0.5;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$.prototype = $p;
$p.aRO = (function(af) {
  var sides = af.C();
  var rbconst = this.aup;
  var s = 0;
  while ((s < sides)) {
    var p0 = af.l(s);
    var p1 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__nxt$1__sci_Vector__I__I__T2(this, af, sides, s);
    var x$1 = rbconst;
    var y$1 = ($m_jl_Math$().ga(((+p1.g()) - (+p0.g())), ((+p1.h()) - (+p0.h()))) / 3.0);
    rbconst = (+Math.min(x$1, y$1));
    s = ((1 + s) | 0);
  }
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  s = 0;
  while ((s < sides)) {
    var p0$2 = af.l(s);
    var p1$2 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__nxt$1__sci_Vector__I__I__T2(this, af, sides, s);
    var t = (rbconst / $m_jl_Math$().ga(((+p1$2.g()) - (+p0$2.g())), ((+p1$2.h()) - (+p0$2.h()))));
    var t$proxy1 = (this.a83 * t);
    var elem = new $c_T2(((+p0$2.g()) + (t$proxy1 * ((+p1$2.g()) - (+p0$2.g())))), ((+p0$2.h()) + (t$proxy1 * ((+p1$2.h()) - (+p0$2.h())))));
    jsElems.push(elem);
    var elem$1 = new $c_T2(((+p0$2.g()) + (t * ((+p1$2.g()) - (+p0$2.g())))), ((+p0$2.h()) + (t * ((+p1$2.h()) - (+p0$2.h())))));
    jsElems.push(elem$1);
    var t$proxy2 = (1.0 - t);
    var elem$2 = new $c_T2(((+p0$2.g()) + (t$proxy2 * ((+p1$2.g()) - (+p0$2.g())))), ((+p0$2.h()) + (t$proxy2 * ((+p1$2.h()) - (+p0$2.h())))));
    jsElems.push(elem$2);
    var t$proxy3 = (1.0 - (this.a83 * t));
    var elem$3 = new $c_T2(((+p0$2.g()) + (t$proxy3 * ((+p1$2.g()) - (+p0$2.g())))), ((+p0$2.h()) + (t$proxy3 * ((+p1$2.h()) - (+p0$2.h())))));
    jsElems.push(elem$3);
    s = ((1 + s) | 0);
  }
  var bb = new ($d_T2.r().C)(jsElems);
  $m_sci_Vector$();
  var pts = new $c_sci_VectorBuilder();
  s = 0;
  while ((s < sides)) {
    pts.ck(bb.a[(s << 2)]);
    pts.ck(bb.a[((1 + (s << 2)) | 0)]);
    pts.ck(bb.a[((1 + (s << 2)) | 0)]);
    pts.ck(bb.a[((2 + (s << 2)) | 0)]);
    pts.ck(bb.a[((2 + (s << 2)) | 0)]);
    pts.ck(bb.a[((3 + (s << 2)) | 0)]);
    s = ((1 + s) | 0);
  }
  var p = pts.bY();
  return p.mX().bv(p.t()).bv(p.l(1));
});
$p.aNo = (function(af, sides, filled) {
  var b = $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__allocInterp__sci_Vector__I__I__AT2(this, af, sides, 0);
  var ops = new $c_scm_ListBuffer().kU($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$Op.r().C)([new $c_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$Op$Poly(af, filled)])));
  var seg = 0;
  while ((seg < sides)) {
    ops.bb(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$Op$Line($m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([b.a[((2 + Math.imul(3, seg)) | 0)], b.a[((4 + Math.imul(3, seg)) | 0)]])))));
    seg = ((1 + seg) | 0);
  }
  return ops.bM();
});
$p.aXw = (function(af, code, filled) {
  var sides = af.C();
  var b = $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__allocInterp__sci_Vector__I__I__AT2(this, af, sides, code);
  var ops = new $c_scm_ListBuffer();
  var mx = (0.5 * ((+af.l(0).g()) + (+af.l(1).g())));
  var myA1 = (0.5 * ((+af.l(1).h()) + (+af.l(2).h())));
  switch (code) {
    case 1: {
      var d = new ($d_T2.r().C)(((1 + sides) | 0));
      var s = 1;
      while ((s < sides)) {
        d.a[s] = af.l(s);
        s = ((1 + s) | 0);
      }
      d.a[0] = b.a[((4 + Math.imul(3, ((sides - 1) | 0))) | 0)];
      d.a[sides] = b.a[((2 + Math.imul(3, ((sides - 1) | 0))) | 0)];
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__poly$1__scm_ListBuffer__Z__AT2__I__V(this, ops, filled, d, ((1 + sides) | 0));
      var ss = ((sides - 1) | 0);
      var c0 = b.a[((2 + Math.imul(3, ss)) | 0)];
      var c1 = b.a[((4 + Math.imul(3, ss)) | 0)];
      var c2 = new $c_T2(((+c1.g()) + ((+c0.g()) - (+b.a[((3 + Math.imul(3, ss)) | 0)].g()))), ((+c1.h()) + ((+c0.h()) - (+b.a[((3 + Math.imul(3, ss)) | 0)].h()))));
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__line$1__scm_ListBuffer__sci_Seq__V(this, ops, $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([c1, c2])));
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__line$1__scm_ListBuffer__sci_Seq__V(this, ops, $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([c0, c2])));
      break;
    }
    case 2: {
      var d$2 = new ($d_T2.r().C)(((2 + sides) | 0));
      d$2.a[0] = af.l(0);
      d$2.a[1] = b.a[2];
      d$2.a[2] = new $c_T2(((+b.a[2].g()) + (((+b.a[3].g()) - (+b.a[4].g())) / 3.0)), ((+b.a[2].h()) + (((+b.a[3].h()) - (+b.a[4].h())) / 3.0)));
      d$2.a[3] = new $c_T2(((+b.a[3].g()) + (((+b.a[3].g()) - (+b.a[4].g())) / 3.0)), ((+b.a[3].h()) + (((+b.a[3].h()) - (+b.a[4].h())) / 3.0)));
      var s$2 = 4;
      while ((s$2 < ((2 + sides) | 0))) {
        d$2.a[s$2] = af.l(((s$2 - 2) | 0));
        s$2 = ((1 + s$2) | 0);
      }
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__poly$1__scm_ListBuffer__Z__AT2__I__V(this, ops, filled, d$2, ((2 + sides) | 0));
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__line$1__scm_ListBuffer__sci_Seq__V(this, ops, $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([b.a[3], b.a[2]])));
      break;
    }
    case 3: {
      var d$3 = new ($d_T2.r().C)(((3 + sides) | 0));
      d$3.a[0] = af.l(0);
      d$3.a[1] = new $c_T2(((+af.l(0).g()) - (0.25 * ((+af.l(0).g()) - (+b.a[1].g())))), ((+af.l(0).h()) + (((+b.a[3].h()) - (+b.a[4].h())) / 3.0)));
      d$3.a[2] = new $c_T2(((+af.l(0).g()) - (2.0 * ((+af.l(0).g()) - (+b.a[1].g())))), d$3.a[1].h());
      d$3.a[3] = new $c_T2(((+af.l(0).g()) - (2.25 * ((+af.l(0).g()) - (+b.a[1].g())))), b.a[3].h());
      d$3.a[4] = new $c_T2(b.a[3].g(), b.a[3].h());
      var s$3 = 4;
      while ((s$3 < ((3 + sides) | 0))) {
        d$3.a[s$3] = af.l(((s$3 - 3) | 0));
        s$3 = ((1 + s$3) | 0);
      }
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__poly$1__scm_ListBuffer__Z__AT2__I__V(this, ops, filled, d$3, ((3 + sides) | 0));
      break;
    }
    case 4: {
      var d$4 = new ($d_T2.r().C)(((2 + sides) | 0));
      d$4.a[0] = af.l(0);
      d$4.a[1] = b.a[2];
      d$4.a[2] = b.a[4];
      d$4.a[3] = af.l(2);
      d$4.a[4] = b.a[8];
      d$4.a[5] = b.a[10];
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__poly$1__scm_ListBuffer__Z__AT2__I__V(this, ops, filled, d$4, ((2 + sides) | 0));
      var c0$2 = new $c_T2(((+b.a[1].g()) + ((+b.a[11].g()) - (+b.a[0].g()))), ((+b.a[1].h()) + ((+b.a[11].h()) - (+b.a[0].h()))));
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__line$1__scm_ListBuffer__sci_Seq__V(this, ops, $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([c0$2, b.a[4]])));
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__line$1__scm_ListBuffer__sci_Seq__V(this, ops, $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([c0$2, b.a[8]])));
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__line$1__scm_ListBuffer__sci_Seq__V(this, ops, $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([c0$2, b.a[0]])));
      break;
    }
    case 5: {
      var d$5 = new ($d_T2.r().C)(((8 + sides) | 0));
      d$5.a[0] = af.l(0);
      d$5.a[1] = af.l(1);
      d$5.a[2] = new $c_T2(((+b.a[3].g()) + ((+b.a[4].g()) - (+b.a[3].g()))), ((+b.a[3].h()) + ((+b.a[4].h()) - (+b.a[3].h()))));
      d$5.a[3] = new $c_T2(((+d$5.a[2].g()) + ((+b.a[3].g()) - (+b.a[2].g()))), ((+d$5.a[2].h()) + ((+b.a[3].h()) - (+b.a[2].h()))));
      d$5.a[4] = new $c_T2(((+d$5.a[3].g()) + ((+b.a[4].g()) - (+b.a[3].g()))), ((+d$5.a[3].h()) + ((+b.a[4].h()) - (+b.a[3].h()))));
      d$5.a[5] = new $c_T2(((+d$5.a[4].g()) + ((+d$5.a[2].g()) - (+d$5.a[3].g()))), ((+d$5.a[4].h()) + ((+d$5.a[2].h()) - (+d$5.a[3].h()))));
      d$5.a[9] = new $c_T2(((+b.a[6].g()) + ((+b.a[5].g()) - (+b.a[6].g()))), ((+b.a[6].h()) + ((+b.a[5].h()) - (+b.a[6].h()))));
      d$5.a[8] = new $c_T2(((+d$5.a[9].g()) + ((+b.a[6].g()) - (+b.a[7].g()))), ((+d$5.a[9].h()) + ((+b.a[6].h()) - (+b.a[7].h()))));
      d$5.a[7] = new $c_T2(((+d$5.a[8].g()) + ((+b.a[5].g()) - (+b.a[6].g()))), ((+d$5.a[8].h()) + ((+b.a[5].h()) - (+b.a[6].h()))));
      d$5.a[6] = new $c_T2(((+d$5.a[7].g()) + ((+d$5.a[9].g()) - (+d$5.a[8].g()))), ((+d$5.a[7].h()) + ((+d$5.a[9].h()) - (+d$5.a[8].h()))));
      d$5.a[10] = af.l(2);
      d$5.a[11] = af.l(3);
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__poly$1__scm_ListBuffer__Z__AT2__I__V(this, ops, filled, d$5, ((8 + sides) | 0));
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__line$1__scm_ListBuffer__sci_Seq__V(this, ops, $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([d$5.a[2], new $c_T2(((+d$5.a[2].g()) - ((+d$5.a[3].g()) - (+d$5.a[2].g()))), ((+d$5.a[2].h()) - ((+d$5.a[3].h()) - (+d$5.a[2].h())))), new $c_T2((((+d$5.a[2].g()) - ((+d$5.a[3].g()) - (+d$5.a[2].g()))) + ((+d$5.a[4].g()) - (+d$5.a[3].g()))), (((+d$5.a[2].h()) - ((+d$5.a[3].h()) - (+d$5.a[2].h()))) + ((+d$5.a[4].h()) - (+d$5.a[3].h())))), d$5.a[5]])));
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__line$1__scm_ListBuffer__sci_Seq__V(this, ops, $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([d$5.a[6], new $c_T2(((+d$5.a[6].g()) - ((+d$5.a[7].g()) - (+d$5.a[6].g()))), ((+d$5.a[6].h()) - ((+d$5.a[7].h()) - (+d$5.a[6].h())))), new $c_T2((((+d$5.a[6].g()) - ((+d$5.a[7].g()) - (+d$5.a[6].g()))) + ((+d$5.a[8].g()) - (+d$5.a[7].g()))), (((+d$5.a[6].h()) - ((+d$5.a[7].h()) - (+d$5.a[6].h()))) + ((+d$5.a[8].h()) - (+d$5.a[7].h())))), d$5.a[9]])));
      break;
    }
    case 6: {
      var d$6 = new ($d_T2.r().C)(((5 + sides) | 0));
      d$6.a[0] = new $c_T2((mx + (0.125 * ((+af.l(0).g()) - (+af.l(1).g())))), (myA1 + (0.5 * (3.0 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b)))));
      d$6.a[1] = new $c_T2((mx - (0.25 * ((+af.l(0).g()) - (+af.l(1).g())))), d$6.a[0].h());
      d$6.a[2] = new $c_T2(d$6.a[1].g(), myA1);
      d$6.a[3] = new $c_T2(((+d$6.a[2].g()) + (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), myA1);
      d$6.a[4] = new $c_T2(d$6.a[3].g(), (myA1 + $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b)));
      d$6.a[5] = new $c_T2(d$6.a[0].g(), d$6.a[4].h());
      d$6.a[6] = new $c_T2(d$6.a[0].g(), ((+d$6.a[4].h()) - (0.25 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$6.a[7] = new $c_T2(((+d$6.a[6].g()) + $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b)), ((+d$6.a[6].h()) + (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$6.a[8] = new $c_T2(d$6.a[0].g(), ((+d$6.a[0].h()) + (0.25 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__poly$1__scm_ListBuffer__Z__AT2__I__V(this, ops, filled, d$6, ((5 + sides) | 0));
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__line$1__scm_ListBuffer__sci_Seq__V(this, ops, $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2(af.l(1).g(), myA1), new $c_T2(af.l(0).g(), ((+af.l(2).h()) + (0.5 * ((+af.l(0).h()) - (+af.l(3).h())))))])));
      break;
    }
    case 7: {
      var d$7 = new ($d_T2.r().C)(((1 + sides) | 0));
      d$7.a[0] = new $c_T2(b.a[1].g(), ((+b.a[1].h()) - (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$7.a[1] = new $c_T2(b.a[3].g(), ((+b.a[3].h()) - (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$7.a[2] = new $c_T2(af.l(2).g(), ((+af.l(2).h()) + (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$7.a[3] = new $c_T2(b.a[1].g(), ((+af.l(2).h()) + (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$7.a[4] = new $c_T2(af.l(0).g(), ((+af.l(0).h()) - (0.5 * ((+af.l(0).h()) - (+af.l(3).h())))));
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__poly$1__scm_ListBuffer__Z__AT2__I__V(this, ops, filled, d$7, ((1 + sides) | 0));
      break;
    }
    case 8: {
      var d$8 = new ($d_T2.r().C)(((4 + sides) | 0));
      d$8.a[0] = new $c_T2((mx + (0.25 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), myA1);
      d$8.a[1] = new $c_T2(d$8.a[0].g(), ((+d$8.a[0].h()) + (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$8.a[2] = new $c_T2(((+d$8.a[1].g()) + (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), d$8.a[1].h());
      d$8.a[3] = new $c_T2(d$8.a[2].g(), ((+d$8.a[2].h()) + (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$8.a[4] = new $c_T2((mx - (0.25 * (3.0 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b)))), d$8.a[3].h());
      d$8.a[5] = new $c_T2(d$8.a[4].g(), d$8.a[2].h());
      d$8.a[6] = new $c_T2((mx - (0.25 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), d$8.a[1].h());
      d$8.a[7] = new $c_T2(d$8.a[6].g(), d$8.a[0].h());
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__poly$1__scm_ListBuffer__Z__AT2__I__V(this, ops, filled, d$8, ((4 + sides) | 0));
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__line$1__scm_ListBuffer__sci_Seq__V(this, ops, $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2(af.l(1).g(), myA1), new $c_T2(af.l(0).g(), ((+af.l(2).h()) + (0.5 * ((+af.l(0).h()) - (+af.l(3).h())))))])));
      break;
    }
    case 9: {
      var d$9 = new ($d_T2.r().C)(((2 + sides) | 0));
      d$9.a[0] = new $c_T2((mx + (0.25 * (3.0 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b)))), myA1);
      d$9.a[1] = new $c_T2(d$9.a[0].g(), ((+d$9.a[0].h()) + (0.25 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$9.a[2] = new $c_T2((mx + (0.25 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), ((+d$9.a[1].h()) + (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$9.a[3] = new $c_T2((mx - (0.25 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), d$9.a[2].h());
      d$9.a[4] = new $c_T2((mx - (0.25 * (3.0 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b)))), d$9.a[1].h());
      d$9.a[5] = new $c_T2(d$9.a[4].g(), d$9.a[0].h());
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__poly$1__scm_ListBuffer__Z__AT2__I__V(this, ops, filled, d$9, ((2 + sides) | 0));
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__line$1__scm_ListBuffer__sci_Seq__V(this, ops, $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2(af.l(1).g(), myA1), new $c_T2(af.l(0).g(), ((+af.l(2).h()) + (0.5 * ((+af.l(0).h()) - (+af.l(3).h())))))])));
      break;
    }
    case 10: {
      var d$10 = new ($d_T2.r().C)(((1 + sides) | 0));
      d$10.a[0] = new $c_T2((mx + $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b)), (myA1 + (0.25 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$10.a[1] = new $c_T2(((+d$10.a[0].g()) - $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b)), ((+d$10.a[0].h()) + $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b)));
      d$10.a[2] = new $c_T2(d$10.a[1].g(), ((+d$10.a[0].h()) + (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$10.a[3] = new $c_T2((mx - (0.25 * ((+af.l(0).g()) - (+af.l(1).g())))), d$10.a[2].h());
      d$10.a[4] = new $c_T2(d$10.a[3].g(), d$10.a[0].h());
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__poly$1__scm_ListBuffer__Z__AT2__I__V(this, ops, filled, d$10, ((1 + sides) | 0));
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__line$1__scm_ListBuffer__sci_Seq__V(this, ops, $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2(af.l(1).g(), myA1), new $c_T2(af.l(0).g(), ((+af.l(2).h()) + (0.5 * ((+af.l(0).h()) - (+af.l(3).h())))))])));
      break;
    }
    case 11: {
      var d$11 = new ($d_T2.r().C)(((4 + sides) | 0));
      d$11.a[0] = new $c_T2(((mx + (0.125 * ((+af.l(0).g()) - (+af.l(1).g())))) + (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), (myA1 + (0.25 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$11.a[1] = new $c_T2((mx - (0.125 * ((+af.l(0).g()) - (+af.l(1).g())))), d$11.a[0].h());
      d$11.a[2] = new $c_T2(d$11.a[1].g(), ((+d$11.a[1].h()) + (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$11.a[3] = new $c_T2(((+d$11.a[2].g()) - (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), d$11.a[2].h());
      d$11.a[4] = new $c_T2(d$11.a[3].g(), (myA1 - (0.25 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$11.a[5] = new $c_T2(((+d$11.a[0].g()) - (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), d$11.a[4].h());
      d$11.a[6] = new $c_T2(d$11.a[5].g(), ((+d$11.a[5].h()) - (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$11.a[7] = new $c_T2(d$11.a[0].g(), d$11.a[6].h());
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__poly$1__scm_ListBuffer__Z__AT2__I__V(this, ops, filled, d$11, ((4 + sides) | 0));
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__line$1__scm_ListBuffer__sci_Seq__V(this, ops, $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2(af.l(1).g(), myA1), new $c_T2(d$11.a[4].g(), ((+af.l(2).h()) + (0.5 * ((+af.l(0).h()) - (+af.l(3).h())))))])));
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__line$1__scm_ListBuffer__sci_Seq__V(this, ops, $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2(d$11.a[7].g(), myA1), new $c_T2(af.l(0).g(), ((+af.l(2).h()) + (0.5 * ((+af.l(0).h()) - (+af.l(3).h())))))])));
      break;
    }
    case 12: {
      var d$12 = new ($d_T2.r().C)(sides);
      d$12.a[0] = new $c_T2(af.l(1).g(), (myA1 + (0.125 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$12.a[1] = new $c_T2(((+d$12.a[0].g()) + (2.0 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), d$12.a[0].h());
      d$12.a[2] = new $c_T2(d$12.a[1].g(), ((+d$12.a[1].h()) + (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$12.a[3] = new $c_T2(d$12.a[0].g(), d$12.a[2].h());
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__poly$1__scm_ListBuffer__Z__AT2__I__V(this, ops, filled, d$12, sides);
      var e = new ($d_T2.r().C)(sides);
      e.a[0] = new $c_T2(((+af.l(1).g()) + $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b)), (myA1 - (0.125 * (5.0 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b)))));
      e.a[1] = new $c_T2(((+e.a[0].g()) + $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b)), e.a[0].h());
      e.a[2] = new $c_T2(e.a[1].g(), ((+e.a[1].h()) + (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      e.a[3] = new $c_T2(e.a[0].g(), e.a[2].h());
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__poly$1__scm_ListBuffer__Z__AT2__I__V(this, ops, filled, e, sides);
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__line$1__scm_ListBuffer__sci_Seq__V(this, ops, $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2(e.a[1].g(), myA1), new $c_T2(af.l(0).g(), ((+af.l(2).h()) + (0.5 * ((+af.l(0).h()) - (+af.l(3).h())))))])));
      break;
    }
    case 13: {
      var d$13 = new ($d_T2.r().C)(sides);
      d$13.a[0] = new $c_T2(af.l(0).g(), (myA1 + (0.125 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$13.a[1] = new $c_T2(d$13.a[0].g(), ((+d$13.a[0].h()) + (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$13.a[2] = new $c_T2(((+d$13.a[1].g()) - (2.0 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))), d$13.a[1].h());
      d$13.a[3] = new $c_T2(d$13.a[2].g(), d$13.a[0].h());
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__poly$1__scm_ListBuffer__Z__AT2__I__V(this, ops, filled, d$13, sides);
      var e$2 = new ($d_T2.r().C)(sides);
      e$2.a[0] = new $c_T2(((+af.l(0).g()) - $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b)), (myA1 - (0.125 * (5.0 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b)))));
      e$2.a[1] = new $c_T2(e$2.a[0].g(), ((+e$2.a[0].h()) + (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      e$2.a[2] = new $c_T2(((+e$2.a[1].g()) - $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b)), e$2.a[1].h());
      e$2.a[3] = new $c_T2(e$2.a[2].g(), e$2.a[0].h());
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__poly$1__scm_ListBuffer__Z__AT2__I__V(this, ops, filled, e$2, sides);
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__line$1__scm_ListBuffer__sci_Seq__V(this, ops, $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2(af.l(1).g(), myA1), new $c_T2(e$2.a[3].g(), ((+af.l(2).h()) + (0.5 * ((+af.l(0).h()) - (+af.l(3).h())))))])));
      break;
    }
    case 14: {
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__poly$1__scm_ListBuffer__Z__AT2__I__V(this, ops, filled, $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__rect$1__I__AT2__D__D__AT2(this, sides, b, (mx - (0.125 * (9.0 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b)))), (myA1 + (0.125 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b)))), sides);
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__poly$1__scm_ListBuffer__Z__AT2__I__V(this, ops, filled, $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__rect$1__I__AT2__D__D__AT2(this, sides, b, (mx - (0.125 * (9.0 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b)))), (myA1 - (0.125 * (5.0 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))))), sides);
      var lr = $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__rect$1__I__AT2__D__D__AT2(this, sides, b, (mx + (0.125 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), (myA1 - (0.125 * (5.0 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b)))));
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__poly$1__scm_ListBuffer__Z__AT2__I__V(this, ops, filled, lr, sides);
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__poly$1__scm_ListBuffer__Z__AT2__I__V(this, ops, filled, $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__rect$1__I__AT2__D__D__AT2(this, sides, b, (mx + (0.125 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), (myA1 + (0.125 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b)))), sides);
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__line$1__scm_ListBuffer__sci_Seq__V(this, ops, $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2(lr.a[1].g(), myA1), new $c_T2(af.l(0).g(), ((+af.l(2).h()) + (0.5 * ((+af.l(0).h()) - (+af.l(3).h())))))])));
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__line$1__scm_ListBuffer__sci_Seq__V(this, ops, $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2((mx - (0.125 * (9.0 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b)))), myA1), new $c_T2(af.l(1).g(), ((+af.l(2).h()) + (0.5 * ((+af.l(0).h()) - (+af.l(3).h())))))])));
      break;
    }
    case 15: {
      var up = $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__rect$2__D__I__AT2__D__AT2(this, mx, sides, b, (myA1 + (0.125 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__poly$1__scm_ListBuffer__Z__AT2__I__V(this, ops, filled, up, sides);
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__poly$1__scm_ListBuffer__Z__AT2__I__V(this, ops, filled, $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__rect$2__D__I__AT2__D__AT2(this, mx, sides, b, (myA1 - (0.125 * (5.0 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))))), sides);
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__line$1__scm_ListBuffer__sci_Seq__V(this, ops, $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2(up.a[1].g(), myA1), new $c_T2(af.l(0).g(), ((+af.l(2).h()) + (0.5 * ((+af.l(0).h()) - (+af.l(3).h())))))])));
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__line$1__scm_ListBuffer__sci_Seq__V(this, ops, $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2(af.l(1).g(), myA1), new $c_T2(up.a[0].g(), ((+af.l(2).h()) + (0.5 * ((+af.l(0).h()) - (+af.l(3).h())))))])));
      break;
    }
    case 16: {
      var d$14 = new ($d_T2.r().C)(sides);
      d$14.a[0] = new $c_T2(af.l(0).g(), ((+b.a[1].h()) - (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$14.a[1] = new $c_T2(b.a[3].g(), ((+b.a[3].h()) - (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$14.a[2] = new $c_T2(af.l(2).g(), ((+af.l(2).h()) + (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$14.a[3] = new $c_T2(af.l(0).g(), ((+af.l(2).h()) + (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__poly$1__scm_ListBuffer__Z__AT2__I__V(this, ops, filled, d$14, sides);
      var c0a = new $c_T2(((+af.l(1).g()) + (0.25 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), (myA1 + (0.125 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__line$1__scm_ListBuffer__sci_Seq__V(this, ops, $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([c0a, new $c_T2(((+c0a.bi) + (0.25 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), ((+c0a.be) - (0.25 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))))])));
      var c0b = new $c_T2(((+af.l(1).g()) + (0.25 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), (myA1 - (0.125 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__line$1__scm_ListBuffer__sci_Seq__V(this, ops, $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([c0b, new $c_T2(((+c0b.bi) + (0.25 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), ((+c0b.be) + (0.25 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))))])));
      var c0c = new $c_T2(((+af.l(1).g()) + (0.25 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), ((+af.l(2).h()) + (0.25 * (3.0 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b)))));
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__line$1__scm_ListBuffer__sci_Seq__V(this, ops, $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([c0c, new $c_T2(((+af.l(0).g()) - (0.25 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), c0c.be)])));
      break;
    }
    case 17: {
      var d$15 = new ($d_T2.r().C)(sides);
      d$15.a[0] = new $c_T2((mx + (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), (myA1 + (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))));
      d$15.a[1] = new $c_T2(d$15.a[0].g(), (myA1 - (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))));
      d$15.a[2] = new $c_T2((mx - (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), d$15.a[1].h());
      d$15.a[3] = new $c_T2(d$15.a[2].g(), d$15.a[0].h());
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__poly$1__scm_ListBuffer__Z__AT2__I__V(this, ops, filled, d$15, sides);
      var o0 = new $c_T2((mx + (0.25 * (3.0 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b)))), (myA1 + (0.25 * (3.0 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b)))));
      var o1 = new $c_T2(o0.bi, (myA1 - (0.25 * (3.0 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b)))));
      var o2 = new $c_T2((mx - (0.25 * (3.0 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b)))), o1.be);
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__line$1__scm_ListBuffer__sci_Seq__V(this, ops, $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([o0, o1, o2, new $c_T2(o2.bi, o0.be), o0])));
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__line$1__scm_ListBuffer__sci_Seq__V(this, ops, $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2((mx + (0.25 * (3.0 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b)))), myA1), new $c_T2(af.l(0).g(), ((+af.l(2).h()) + (0.5 * ((+af.l(0).h()) - (+af.l(3).h())))))])));
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__line$1__scm_ListBuffer__sci_Seq__V(this, ops, $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2(af.l(1).g(), myA1), new $c_T2((mx - (0.25 * (3.0 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b)))), ((+af.l(2).h()) + (0.5 * ((+af.l(0).h()) - (+af.l(3).h())))))])));
      break;
    }
    case 18: {
      var d$16 = new ($d_T2.r().C)(((12 + sides) | 0));
      d$16.a[0] = new $c_T2((mx + (0.25 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), (myA1 + (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$16.a[1] = new $c_T2(d$16.a[0].g(), ((+d$16.a[0].h()) + (0.125 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$16.a[2] = new $c_T2(((+d$16.a[0].g()) - (0.125 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), ((+d$16.a[1].h()) + (0.125 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$16.a[3] = new $c_T2(d$16.a[0].g(), ((+d$16.a[2].h()) + (0.125 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$16.a[4] = new $c_T2(d$16.a[0].g(), ((+d$16.a[3].h()) + (0.125 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$16.a[5] = new $c_T2(d$16.a[2].g(), d$16.a[4].h());
      d$16.a[6] = new $c_T2(mx, d$16.a[3].h());
      d$16.a[7] = new $c_T2(((+d$16.a[6].g()) - (0.125 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), d$16.a[5].h());
      d$16.a[8] = new $c_T2(((+d$16.a[7].g()) - (0.125 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), d$16.a[7].h());
      d$16.a[9] = new $c_T2(d$16.a[8].g(), d$16.a[3].h());
      d$16.a[10] = new $c_T2(((+d$16.a[8].g()) + (0.125 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), d$16.a[2].h());
      d$16.a[11] = new $c_T2(d$16.a[8].g(), d$16.a[1].h());
      d$16.a[12] = new $c_T2(d$16.a[8].g(), d$16.a[0].h());
      d$16.a[13] = new $c_T2(d$16.a[10].g(), d$16.a[12].h());
      d$16.a[14] = new $c_T2(d$16.a[6].g(), d$16.a[1].h());
      d$16.a[15] = new $c_T2(d$16.a[2].g(), d$16.a[0].h());
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__poly$1__scm_ListBuffer__Z__AT2__I__V(this, ops, filled, d$16, ((12 + sides) | 0));
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__line$1__scm_ListBuffer__sci_Seq__V(this, ops, $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2(d$16.a[14].g(), myA1), new $c_T2(d$16.a[14].g(), (myA1 + (0.125 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))))])));
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__line$1__scm_ListBuffer__sci_Seq__V(this, ops, $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2(d$16.a[14].g(), (myA1 + (0.25 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b)))), new $c_T2(d$16.a[14].g(), ((myA1 + (0.25 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))) + (0.125 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))))])));
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__line$1__scm_ListBuffer__sci_Seq__V(this, ops, $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2(af.l(1).g(), myA1), new $c_T2(af.l(0).g(), ((+af.l(2).h()) + (0.5 * ((+af.l(0).h()) - (+af.l(3).h())))))])));
      break;
    }
    case 19: {
      var d$17 = new ($d_T2.r().C)(((4 + sides) | 0));
      d$17.a[0] = new $c_T2((mx + (0.125 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), (myA1 + (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$17.a[1] = new $c_T2(((+d$17.a[0].g()) + (0.125 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), ((+d$17.a[0].h()) + (0.125 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$17.a[2] = new $c_T2(d$17.a[1].g(), ((+d$17.a[1].h()) + (0.25 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$17.a[3] = new $c_T2(d$17.a[0].g(), ((+d$17.a[2].h()) + (0.125 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$17.a[4] = new $c_T2(((+d$17.a[3].g()) - (0.25 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), d$17.a[3].h());
      d$17.a[5] = new $c_T2(((+d$17.a[4].g()) - (0.125 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), d$17.a[2].h());
      d$17.a[6] = new $c_T2(d$17.a[5].g(), d$17.a[1].h());
      d$17.a[7] = new $c_T2(d$17.a[4].g(), d$17.a[0].h());
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__poly$1__scm_ListBuffer__Z__AT2__I__V(this, ops, filled, d$17, ((4 + sides) | 0));
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__line$1__scm_ListBuffer__sci_Seq__V(this, ops, $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2(mx, myA1), new $c_T2(mx, (myA1 + (0.125 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))))])));
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__line$1__scm_ListBuffer__sci_Seq__V(this, ops, $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2(mx, (myA1 + (0.25 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b)))), new $c_T2(mx, ((myA1 + (0.25 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))) + (0.125 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))))])));
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__line$1__scm_ListBuffer__sci_Seq__V(this, ops, $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2(af.l(1).g(), myA1), new $c_T2(af.l(0).g(), ((+af.l(2).h()) + (0.5 * ((+af.l(0).h()) - (+af.l(3).h())))))])));
      break;
    }
    case 20: {
      var d$18 = new ($d_T2.r().C)(((12 + sides) | 0));
      d$18.a[0] = new $c_T2((mx + (0.25 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), (myA1 + (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$18.a[1] = new $c_T2(d$18.a[0].g(), ((+d$18.a[0].h()) + (0.125 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$18.a[2] = new $c_T2(((+d$18.a[0].g()) - (0.125 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), ((+d$18.a[1].h()) + (0.125 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$18.a[3] = new $c_T2(d$18.a[0].g(), ((+d$18.a[2].h()) + (0.125 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$18.a[4] = new $c_T2(d$18.a[0].g(), ((+d$18.a[3].h()) + (0.125 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$18.a[5] = new $c_T2(d$18.a[2].g(), d$18.a[4].h());
      d$18.a[6] = new $c_T2(mx, d$18.a[3].h());
      d$18.a[7] = new $c_T2(((+d$18.a[6].g()) - (0.125 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), d$18.a[5].h());
      d$18.a[8] = new $c_T2(((+d$18.a[7].g()) - (0.125 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), d$18.a[7].h());
      d$18.a[9] = new $c_T2(d$18.a[8].g(), d$18.a[3].h());
      d$18.a[10] = new $c_T2(((+d$18.a[8].g()) + (0.125 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), d$18.a[2].h());
      d$18.a[11] = new $c_T2(d$18.a[8].g(), d$18.a[1].h());
      d$18.a[12] = new $c_T2(d$18.a[8].g(), d$18.a[0].h());
      d$18.a[13] = new $c_T2(d$18.a[10].g(), d$18.a[12].h());
      d$18.a[14] = new $c_T2(d$18.a[6].g(), d$18.a[1].h());
      d$18.a[15] = new $c_T2(d$18.a[2].g(), d$18.a[0].h());
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__poly$1__scm_ListBuffer__Z__AT2__I__V(this, ops, filled, d$18, ((12 + sides) | 0));
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__line$1__scm_ListBuffer__sci_Seq__V(this, ops, $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([d$18.a[14], new $c_T2(d$18.a[14].g(), myA1)])));
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__line$1__scm_ListBuffer__sci_Seq__V(this, ops, $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2(af.l(1).g(), myA1), new $c_T2(af.l(0).g(), ((+af.l(2).h()) + (0.5 * ((+af.l(0).h()) - (+af.l(3).h())))))])));
      break;
    }
    case 21: {
      var d$19 = new ($d_T2.r().C)(((4 + sides) | 0));
      d$19.a[0] = new $c_T2((mx + (0.125 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), (myA1 + (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$19.a[1] = new $c_T2(((+d$19.a[0].g()) + (0.125 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), ((+d$19.a[0].h()) + (0.125 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$19.a[2] = new $c_T2(d$19.a[1].g(), ((+d$19.a[1].h()) + (0.25 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$19.a[3] = new $c_T2(d$19.a[0].g(), ((+d$19.a[2].h()) + (0.125 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$19.a[4] = new $c_T2(((+d$19.a[3].g()) - (0.25 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), d$19.a[3].h());
      d$19.a[5] = new $c_T2(((+d$19.a[4].g()) - (0.125 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), d$19.a[2].h());
      d$19.a[6] = new $c_T2(d$19.a[5].g(), d$19.a[1].h());
      d$19.a[7] = new $c_T2(d$19.a[4].g(), d$19.a[0].h());
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__poly$1__scm_ListBuffer__Z__AT2__I__V(this, ops, filled, d$19, ((4 + sides) | 0));
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__line$1__scm_ListBuffer__sci_Seq__V(this, ops, $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2(mx, d$19.a[0].h()), new $c_T2(mx, myA1)])));
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__line$1__scm_ListBuffer__sci_Seq__V(this, ops, $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2(af.l(1).g(), myA1), new $c_T2(af.l(0).g(), ((+af.l(2).h()) + (0.5 * ((+af.l(0).h()) - (+af.l(3).h())))))])));
      break;
    }
    case 22: {
      var d$20 = new ($d_T2.r().C)(((5 + sides) | 0));
      d$20.a[0] = new $c_T2(((+b.a[1].g()) - (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), ((+b.a[1].h()) - (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$20.a[1] = new $c_T2(b.a[3].g(), ((+b.a[3].h()) - (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$20.a[2] = new $c_T2(af.l(2).g(), af.l(2).h());
      d$20.a[3] = new $c_T2(((+b.a[2].g()) + (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), af.l(2).h());
      d$20.a[4] = new $c_T2(((+b.a[2].g()) + (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), ((+af.l(2).h()) + (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$20.a[5] = new $c_T2(((+b.a[1].g()) - (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), ((+af.l(2).h()) + (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$20.a[6] = new $c_T2(((+b.a[1].g()) - (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), af.l(3).h());
      d$20.a[7] = new $c_T2(af.l(0).g(), ((+af.l(0).h()) - (0.5 * ((+af.l(0).h()) - (+af.l(3).h())))));
      d$20.a[8] = new $c_T2(((+b.a[1].g()) - (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), af.l(0).h());
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__poly$1__scm_ListBuffer__Z__AT2__I__V(this, ops, filled, d$20, ((5 + sides) | 0));
      break;
    }
    case 23: {
      var d$21 = new ($d_T2.r().C)(((3 + sides) | 0));
      d$21.a[0] = new $c_T2(((+b.a[1].g()) - (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), ((+b.a[1].h()) - (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$21.a[1] = new $c_T2(b.a[3].g(), ((+b.a[3].h()) - (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$21.a[2] = new $c_T2(af.l(2).g(), ((+af.l(2).h()) + (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$21.a[3] = new $c_T2(((+b.a[1].g()) - (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), ((+af.l(2).h()) + (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$21.a[4] = new $c_T2(((+b.a[1].g()) - (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), af.l(3).h());
      d$21.a[5] = new $c_T2(af.l(0).g(), ((+af.l(0).h()) - (0.5 * ((+af.l(0).h()) - (+af.l(3).h())))));
      d$21.a[6] = new $c_T2(((+b.a[1].g()) - (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), af.l(0).h());
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__poly$1__scm_ListBuffer__Z__AT2__I__V(this, ops, filled, d$21, ((3 + sides) | 0));
      break;
    }
    case 24: {
      var d$22 = new ($d_T2.r().C)(((3 + sides) | 0));
      d$22.a[0] = new $c_T2(af.l(0).g(), ((+af.l(0).h()) - (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$22.a[1] = new $c_T2(((+b.a[2].g()) + (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), ((+af.l(0).h()) - (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$22.a[2] = new $c_T2(((+b.a[2].g()) + (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), b.a[2].h());
      d$22.a[3] = new $c_T2(af.l(1).g(), ((+af.l(1).h()) - (0.5 * ((+af.l(1).h()) - (+af.l(2).h())))));
      d$22.a[4] = new $c_T2(((+b.a[2].g()) + (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), af.l(2).h());
      d$22.a[5] = new $c_T2(((+b.a[2].g()) + (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), ((+af.l(2).h()) + (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$22.a[6] = new $c_T2(af.l(0).g(), ((+af.l(3).h()) + (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__poly$1__scm_ListBuffer__Z__AT2__I__V(this, ops, filled, d$22, ((3 + sides) | 0));
      break;
    }
    case 25: {
      var d$23 = new ($d_T2.r().C)(((5 + sides) | 0));
      d$23.a[0] = new $c_T2(af.l(0).g(), ((+af.l(0).h()) - (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$23.a[1] = new $c_T2(((+b.a[2].g()) + (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), ((+af.l(0).h()) - (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$23.a[2] = new $c_T2(((+b.a[2].g()) + (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), b.a[2].h());
      d$23.a[3] = new $c_T2(af.l(1).g(), ((+af.l(1).h()) - (0.5 * ((+af.l(1).h()) - (+af.l(2).h())))));
      d$23.a[4] = new $c_T2(((+b.a[2].g()) + (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), af.l(2).h());
      d$23.a[5] = new $c_T2(((+b.a[2].g()) + (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), ((+af.l(2).h()) + (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$23.a[6] = new $c_T2(((+b.a[1].g()) - (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), ((+af.l(3).h()) + (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wY$1__AT2__D(this, b))));
      d$23.a[7] = new $c_T2(((+b.a[1].g()) - (0.5 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__wX$1__AT2__D(this, b))), af.l(3).h());
      d$23.a[8] = new $c_T2(af.l(3).g(), af.l(3).h());
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$__poly$1__scm_ListBuffer__Z__AT2__I__V(this, ops, filled, d$23, ((5 + sides) | 0));
      break;
    }
  }
  return ops.bM();
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$, "org.jpablo.graphexplorer.graphviz.layout.RoundCorners$", ({
  vm: 1
}));
var $n_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$;
function $m_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$() {
  if ((!$n_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$)) {
    $n_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$ = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$();
  }
  return $n_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__splinesExImpl__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T2($thiz, g) {
  var res = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Order$().ahg(g);
  matchResult10$1: {
    var allXNode$2;
    var x13 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$().b94(g);
    if ((x13 !== null)) {
      var allXNode$2 = x13.h();
      break matchResult10$1;
    }
    throw new $c_s_MatchError(x13);
  }
  matchResult11$1: {
    var yOf$2;
    var x16 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().PL(g);
    if ((x16 !== null)) {
      var yOf$2 = x16.h();
      break matchResult11$1;
    }
    throw new $c_s_MatchError(x16);
  }
  var byId = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$9(g.cB.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n) => new $c_T2(n.br, n)))));
  var NodeSep = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().ah6(g);
  var num = $doubleToInt(NodeSep);
  var Splinesep = (((num + (((num >> 1) >>> 30) | 0)) | 0) >> 2);
  var VirtualHalf = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().aTm(g);
  var allX = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$9(allXNode$2.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var k = x$1.g();
    var v = (+x$1.h());
    return new $c_T2(k.bE(), v);
  }))));
  var nodeOf = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$9(allXNode$2.lo(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((k$1) => new $c_T2(k$1.bE(), k$1)))));
  var orderByRank = $m_sci_Map$().ao(new $c_sc_MapView$MapValues(new $c_sc_MapView$Id(res.oX), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => _$2.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3) => _$3.bE())))))));
  var rankOf = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$10(orderByRank.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    if ((x$1$2 !== null)) {
      var r = (x$1$2.g() | 0);
      return x$1$2.h().L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4) => new $c_T2(_$4, r))));
    }
    throw new $c_s_MatchError(x$1$2);
  }))));
  var cxOv = $ct_scm_HashMap__(new $c_scm_HashMap());
  var lwOv = $ct_scm_HashMap__(new $c_scm_HashMap());
  var rwOv = $ct_scm_HashMap__(new $c_scm_HashMap());
  var labelPos = $ct_scm_HashMap__(new $c_scm_HashMap());
  var labelW = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().agP(g);
  var clustOfName = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$().P5(g);
  var ends = g.cu.d8(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e) => (e.ai !== e.ak))), false).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$2) => new $c_T2(e$2.ai, e$2.ak))));
  var intraVEdge = $m_sci_Set$().af($f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(new $c_sci_Range$Exclusive(0, ends.C(), 1), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((i) => {
    var i$1 = (i | 0);
    var x22 = new $c_T2(clustOfName.r(ends.l(i$1).g()), clustOfName.r(ends.l(i$1).h()));
    var x23 = x22.bi;
    var x24 = x22.be;
    if ((x23 instanceof $c_s_Some)) {
      var a = (x23.J | 0);
      if ((x24 instanceof $c_s_Some)) {
        return (a === (x24.J | 0));
      }
    }
    return false;
  })), false));
  var fd = g.cu.d8(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$3) => (e$3.ai !== e$3.ak))), false);
  var flatLabelHalf = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$9(new $c_sci_Range$Exclusive(0, fd.C(), 1).o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((d) => {
    var d$1 = (d | 0);
    return new $c_T2(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$FlatLabel(d$1).bE(), $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().a3o(fd.l(d$1), g).g());
  }))));
  var selfRwSpl = $m_sci_Map$().ao(new $c_sc_MapView$MapValues(new $c_sc_MapView$Id($f_sc_IterableOps__groupBy__F1__sci_Map(g.cu.d8(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$4) => (e$4.ai === e$4.ak))), false), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6) => _$6.ai)))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$7) => (+_$7.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$8) => $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().ahY(_$8, g)))).k2($m_s_math_Numeric$DoubleIsFractional$()))))));
  var yiHt = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().a5m(g);
  var ranksSorted = $f_sc_SeqOps__sorted__s_math_Ordering__O(orderByRank.J8().d2(), $m_s_math_Ordering$Int$());
  var leftBound = new $c_sr_DoubleRef(0.0);
  var rightBound = new $c_sr_DoubleRef(0.0);
  ranksSorted.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => {
    var r$1 = (v1 | 0);
    var row = orderByRank.i(r$1);
    if ((!$f_sc_SeqOps__isEmpty__Z(row))) {
      var x = leftBound.T;
      var y$1 = ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv, allX, row.t()) - $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__lw$1__scm_HashMap__sci_Map__D__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Set__D__T__D($thiz, lwOv, labelW, NodeSep, flatLabelHalf, byId, g, nodeOf, intraVEdge, VirtualHalf, row.t()));
      leftBound.T = (+Math.min(x, y$1));
      var x$2 = rightBound.T;
      var y$2 = ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv, allX, row.bJ()) + $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__rw$1__scm_HashMap__sci_Map__D__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Set__D__T__D($thiz, rwOv, labelW, NodeSep, flatLabelHalf, byId, g, nodeOf, intraVEdge, VirtualHalf, row.bJ()));
      rightBound.T = (+Math.max(x$2, y$2));
    }
    leftBound.T = (leftBound.T - $thiz.n6);
    rightBound.T = (rightBound.T + $thiz.n6);
  })));
  var cluBBs = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$().a2N(g);
  var cluOf = ($f_sc_SeqOps__isEmpty__Z(cluBBs) ? $m_sci_Map$EmptyMap$() : $m_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$().P5(g));
  var dedges = g.cu.d8(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$5) => (e$5.ai !== e$5.ak))), false);
  var orderIdx = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$10(orderByRank.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3) => {
    (x$1$3.g() | 0);
    return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(x$1$3.h());
  }))));
  var workEnds = dedges.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$6) => {
    var rt = (rankOf.ay(e$6.ai, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 0))) | 0);
    var rh = (rankOf.ay(e$6.ak, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 0))) | 0);
    return ((rt <= rh) ? new $c_T4(e$6.ai, e$6.ak, rt, rh) : new $c_T4(e$6.ak, e$6.ai, rh, rt));
  })));
  var outDeg = $f_scm_Map__withDefaultValue__O__scm_Map($ct_scm_HashMap__(new $c_scm_HashMap()), 0);
  var inDeg = $f_scm_Map__withDefaultValue__O__scm_Map($ct_scm_HashMap__(new $c_scm_HashMap()), 0);
  workEnds.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$4) => {
    matchResult17: {
      if ((x$1$4 !== null)) {
        var wt = x$1$4.bO;
        var wh = x$1$4.bs;
        if (((x$1$4.ch | 0) !== (x$1$4.ca | 0))) {
          outDeg.cY(wt, ((1 + (outDeg.i(wt) | 0)) | 0));
          inDeg.cY(wh, ((1 + (inDeg.i(wh) | 0)) | 0));
          break matchResult17;
        } else {
          break matchResult17;
        }
      }
      throw new $c_s_MatchError(x$1$4);
    }
  })));
  var realOutSeg = $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(workEnds).ct(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$$anon$1()).eX($m_s_$less$colon$less$().b1);
  var realInSeg = $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(workEnds).ct(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$$anon$2()).eX($m_s_$less$colon$less$().b1);
  var TopRankSep = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$__rankSep__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D($m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$(), g);
  var out = new $c_scm_LinkedHashMap();
  var centerOf = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((id) => new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv, allX, id), $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cy$1__sci_Map__sci_Map__T__D($thiz, yOf$2, rankOf, id))));
  var rd = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().pD(g);
  var flip = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().jT(g);
  var RanksepPt = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().aRk(g);
  var this$74 = g.f2.ag.r("splines");
  var f$9 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$11) => $f_T__trim__T(_$11)));
  var polylineMode = (this$74.c() ? $m_s_None$() : new $c_s_Some(f$9.i(this$74.d()))).E("polyline");
  var this$77 = g.f2.ag.r("splines");
  var f$10 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$12) => {
    var this$76 = $f_T__trim__T(_$12);
    return this$76.toLowerCase();
  }));
  var this$79 = (this$77.c() ? $m_s_None$() : new $c_s_Some(f$10.i(this$77.d())));
  var p = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((s) => ((((s === "false") || (s === "line")) || (s === "no")) || $m_sc_StringOps$().X8(s).E($bC(48)))));
  var lineMode = ((!this$79.c()) && (!(!p.i(this$79.d()))));
  var dedgeOrigIdx = $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(g.cu).ct(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$$anon$4());
  var flatDedges = g.cu.d8(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$7) => (e$7.ai !== e$7.ak))), false);
  var flatLabelRep = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((byPair) => ((d$2) => {
    var d$3 = (d$2 | 0);
    return (byPair.i(new $c_T2(flatDedges.l(d$3).ai, flatDedges.l(d$3).ak)).lr($m_s_math_Ordering$Int$()) | 0);
  }))($f_sc_IterableOps__groupBy__F1__sci_Map(new $c_sci_Range$Exclusive(0, flatDedges.C(), 1), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((k$2) => {
    var k$3 = (k$2 | 0);
    return new $c_T2(flatDedges.l(k$3).ai, flatDedges.l(k$3).ak);
  })))));
  $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O($f_sc_StrictOptimizedIterableOps__zipWithIndex__O($f_sc_StrictOptimizedIterableOps__zipWithIndex__O(g.cu).bw(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$5) => {
    if ((x$1$5 !== null)) {
      var e$1 = x$1$5.g();
      return (e$1.ai !== e$1.ak);
    }
    throw new $c_s_MatchError(x$1$5);
  })))).bw(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$6) => {
    if ((x$1$6 !== null)) {
      var e$8 = x$1$6.g();
      var i$2 = (x$1$6.h() | 0);
      var this$89 = new $c_s_PartialFunction$Lifted(res.pV).as(i$2);
      var p$1 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$16) => ((_$16 | 0) === i$2)));
      if ((this$89.c() || (!(!p$1.i(this$89.d()))))) {
        return true;
      } else {
        return $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__isLabelledFlat$1__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_REdge__Z($thiz, rankOf, e$8.g());
      }
    }
    throw new $c_s_MatchError(x$1$6);
  }))).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$7) => {
    if ((x$1$7 !== null)) {
      var x161 = x$1$7.g();
      if ((x161 !== null)) {
        return new $c_T3(x161.g(), (x161.h() | 0), (x$1$7.h() | 0));
      }
    }
    throw new $c_s_MatchError(x$1$7);
  }))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$8) => {
    var e$10 = x$1$8.bH;
    var i$4 = (x$1$8.c3 | 0);
    var rt$1 = (rankOf.ay(e$10.ai, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 0))) | 0);
    var rh$1 = (rankOf.ay(e$10.ak, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 0))) | 0);
    var typeKey = ((rt$1 === rh$1) ? (-2) : (-1));
    var this$91 = allX.r(e$10.ai);
    var ifEmpty = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 0.0));
    var f$12 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$18) => (+_$18)));
    var $x_12 = (this$91.c() ? ifEmpty.a3() : f$12.i(this$91.d()));
    var this$92 = allX.r(e$10.ak);
    var ifEmpty$1 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 0.0));
    var f$13 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$19) => (+_$19)));
    var x$4 = ((+$x_12) - (+(this$92.c() ? ifEmpty$1.a3() : f$13.i(this$92.d()))));
    var dx = (+Math.abs(x$4));
    var x$5 = ((rt$1 - rh$1) | 0);
    var sign = (x$5 >> 31);
    return new $c_T4(typeKey, (((x$5 ^ sign) - sign) | 0), dx, i$4);
  })), new $c_s_math_Ordering$Tuple4Ordering($m_s_math_Ordering$Int$(), $m_s_math_Ordering$Int$(), $m_s_math_Ordering$DeprecatedDoubleOrdering$(), $m_s_math_Ordering$Int$())).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$9) => {
    matchResult59: {
      if ((x$1$9 !== null)) {
        var e$11 = x$1$9.bH;
        var origIdx$1 = (x$1$9.bU | 0);
        var i$5 = (x$1$9.c3 | 0);
        var rt$2 = (rankOf.i(e$11.ai) | 0);
        var rh$2 = (rankOf.i(e$11.ak) | 0);
        if ((rt$2 !== rh$2)) {
          var lo$1 = ((rt$2 < rh$2) ? rt$2 : rh$2);
          var hi$1 = ((rt$2 > rh$2) ? rt$2 : rh$2);
          var this$106 = new $c_sci_Range$Exclusive(((1 + lo$1) | 0), hi$1, 1);
          var midRanks = $m_sci_Vector$().X(this$106);
          var mids = midRanks.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((r$2) => new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Virtual(i$5, (r$2 | 0)).bE())));
          if ($f_sc_IterableOnceOps__forall__F1__Z(mids, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((m) => (rankOf.E(m) && allX.E(m)))))) {
            var low = ((rt$2 < rh$2) ? e$11.ai : e$11.ak);
            var high = ((rt$2 < rh$2) ? e$11.ak : e$11.ai);
            var pathTopDown = mids.mV(low).bv(high);
            var ownPath = $m_sci_Set$().af(pathTopDown);
            var tn0 = pathTopDown.t();
            var hn0 = pathTopDown.bJ();
            var \u03b46$ = ((rt$2 < rh$2) ? new $c_T2(e$11.ka, e$11.k9) : new $c_T2(e$11.k9, e$11.ka));
            var wtPort = \u03b46$.bi;
            var whPort = \u03b46$.be;
            var tEnd = $m_s_None$();
            var hEnd = $m_s_None$();
            if (($f_sc_SeqOps__isEmpty__Z(mids) && ((!tEnd.c()) || (!hEnd.c())))) {
              var p$3 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$20) => _$20.bdj()));
              if (((!tEnd.c()) && (!(!p$3.i(tEnd.eO()))))) {
                var tBoxes = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__topBoxes$1__sci_Map__D__sci_Vector__D__D__sr_DoubleRef__sr_DoubleRef__sci_Map__scm_HashMap__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo__scm_HashMap__sci_Map__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Set__D__scm_HashMap__sci_Map__sci_Vector__sci_Map__T__D__Z__sci_Set__sci_Vector($thiz, rankOf, TopRankSep, cluBBs, Splinesep, NodeSep, leftBound, rightBound, orderByRank, cxOv, allX, yOf$2, yiHt, lwOv, labelW, flatLabelHalf, byId, g, nodeOf, intraVEdge, VirtualHalf, rwOv, cluOf, dedges, selfRwSpl, tn0, tEnd.eO(), tEnd.eO(), ownPath);
              } else {
                var $x_2 = $m_sci_Vector$();
                var $x_1 = $m_sr_ScalaRunTime$();
                var f$14 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$21) => _$21.aY1()));
                var this$111 = (tEnd.c() ? $m_s_None$() : new $c_s_Some(f$14.i(tEnd.eO())));
                var default$1 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__maximalBbox$1__sci_Map__sci_Vector__D__D__sr_DoubleRef__sr_DoubleRef__sci_Map__sci_Map__scm_HashMap__sci_Map__scm_HashMap__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Set__D__sci_Map__sci_Vector__sci_Map__sci_Map__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo__T__sci_Set__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box($thiz, rankOf, cluBBs, Splinesep, NodeSep, leftBound, rightBound, orderByRank, labelW, cxOv, allX, lwOv, flatLabelHalf, byId, g, nodeOf, intraVEdge, VirtualHalf, cluOf, dedges, yOf$2, selfRwSpl, rwOv, yiHt, tn0, ownPath)));
                var tBoxes = $x_2.X($x_1.f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box.r().C)([(this$111.c() ? default$1.a3() : this$111.d())])));
              }
              var f$15 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$22) => _$22.aY1()));
              var this$113 = (hEnd.c() ? $m_s_None$() : new $c_s_Some(f$15.i(hEnd.eO())));
              var default$2 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__maximalBbox$1__sci_Map__sci_Vector__D__D__sr_DoubleRef__sr_DoubleRef__sci_Map__sci_Map__scm_HashMap__sci_Map__scm_HashMap__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Set__D__sci_Map__sci_Vector__sci_Map__sci_Map__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo__T__sci_Set__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box($thiz, rankOf, cluBBs, Splinesep, NodeSep, leftBound, rightBound, orderByRank, labelW, cxOv, allX, lwOv, flatLabelHalf, byId, g, nodeOf, intraVEdge, VirtualHalf, cluOf, dedges, yOf$2, selfRwSpl, rwOv, yiHt, hn0, ownPath)));
              var hBox = (this$113.c() ? default$2.a3() : this$113.d());
              var boxes = $m_scm_ArrayBuffer$().y9(tBoxes);
              boxes.aw($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__rankBox$1__sr_DoubleRef__sci_Map__sr_DoubleRef__Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo__I__I__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box($thiz, leftBound, yOf$2, rightBound, yiHt, (rankOf.i(tn0) | 0), (rankOf.i(hn0) | 0)));
              boxes.aw(hBox);
              var f$16 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$23) => _$23.b6h()));
              var this$115 = (tEnd.c() ? $m_s_None$() : new $c_s_Some(f$16.i(tEnd.eO())));
              var default$3 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv, allX, tn0), ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cy$1__sci_Map__sci_Map__T__D($thiz, yOf$2, rankOf, tn0) - 1.0))));
              var start = (this$115.c() ? default$3.a3() : this$115.d());
              var f$17 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$24) => _$24.b6h()));
              var this$117 = (hEnd.c() ? $m_s_None$() : new $c_s_Some(f$17.i(hEnd.eO())));
              var default$4 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv, allX, hn0), ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cy$1__sci_Map__sci_Map__T__D($thiz, yOf$2, rankOf, hn0) + 1.0))));
              var end$3 = (this$117.c() ? default$4.a3() : this$117.d());
              var p$4 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$25) => _$25.aYY()));
              if (((!tEnd.c()) && (!(!p$4.i(tEnd.eO()))))) {
                var ev0;
                tEnd.eO();
              } else {
                var ev0 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(0.0, 0.0);
              }
              var p$5 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$26) => _$26.aYY()));
              if (((!hEnd.c()) && (!(!p$5.i(hEnd.eO()))))) {
                var ev1;
                hEnd.eO();
              } else {
                var ev1 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(0.0, 0.0);
              }
              $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__adjustRegularPath__scm_ArrayBuffer__V($thiz, boxes);
              var st = new $ac_D(new Float64Array([start.W, start.a6]));
              var en = new $ac_D(new Float64Array([end$3.W, end$3.a6]));
              var $x_4 = ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__checkpath__scm_ArrayBuffer__AD__AD__Z($thiz, boxes, st, en) ? $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY.r().C)([new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(st.a[0], st.a[1]), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(en.a[0], en.a[1])]))) : ($f_scm_IndexedBuffer__filterInPlace__F1__scm_IndexedBuffer(boxes, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((b$1) => {
                var x$11 = (b$1.bG - b$1.bZ);
                if (((+Math.abs(x$11)) > 0.01)) {
                  var x$12 = (b$1.aF - b$1.aJ);
                  return ((+Math.abs(x$12)) > 0.01);
                } else {
                  return false;
                }
              }))), $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__proutespline__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__sci_Vector($thiz, $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__buildPolygon__scm_ArrayBuffer__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($thiz, boxes), $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__funnel__scm_ArrayBuffer__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__sci_Vector($thiz, boxes, new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(st.a[0], st.a[1]), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(en.a[0], en.a[1])), ev0, ev1)));
              var p$7 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$27) => _$27.aYo()));
              var $x_3 = (tEnd.c() || (!(!p$7.i(tEnd.eO()))));
              var p$8 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$28) => _$28.aYo()));
              $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(out, origIdx$1, $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__clipInstall__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_model_REdge__sci_Map__F1__Z__Z__Z__s_Option__s_Option__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$ESpline($thiz, g, $x_4, e$11, byId, centerOf, $x_3, (hEnd.c() || (!(!p$8.i(hEnd.eO())))), (rt$2 > rh$2), $m_s_None$(), $m_s_None$()), false);
              break matchResult59;
            } else if (((lineMode && (((hi$1 - lo$1) | 0) > 1)) && (!((((hi$1 - lo$1) | 0) === 2) && $m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().J0(g))))) {
              matchResult47$1: {
                var \u03b47$;
                var f$19 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((pp) => {
                  var this$130 = byId.r(tn0);
                  var f$18 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((pp$2) => ((n$1) => $m_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$().a2P(n$1, g, new $c_s_Some(pp$2))))(pp));
                  return (this$130.c() ? $m_s_None$() : new $c_s_Some(f$18.i(this$130.d())));
                }));
                var this$132 = (wtPort.c() ? $m_s_None$() : f$19.i(wtPort.d()));
                var default$5 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => new $c_T3(0.0, 0.0, 128)));
                var x165 = (this$132.c() ? default$5.a3() : this$132.d());
                if ((x165 !== null)) {
                  var \u03b47$ = new $c_T2((+x165.bH), (+x165.bU));
                  break matchResult47$1;
                }
                throw new $c_s_MatchError(x165);
              }
              var tpx$2 = (+\u03b47$.bi);
              var tpy$2 = (+\u03b47$.be);
              matchResult48$1: {
                var \u03b48$;
                var f$21 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((pp$2$1) => {
                  var this$135 = byId.r(hn0);
                  var f$20 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((pp$2$2) => ((n$2) => $m_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$().a2P(n$2, g, new $c_s_Some(pp$2$2))))(pp$2$1));
                  return (this$135.c() ? $m_s_None$() : new $c_s_Some(f$20.i(this$135.d())));
                }));
                var this$137 = (whPort.c() ? $m_s_None$() : f$21.i(whPort.d()));
                var default$6 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => new $c_T3(0.0, 0.0, 128)));
                var x169 = (this$137.c() ? default$6.a3() : this$137.d());
                if ((x169 !== null)) {
                  var \u03b48$ = new $c_T2((+x169.bH), (+x169.bU));
                  break matchResult48$1;
                }
                throw new $c_s_MatchError(x169);
              }
              var hpx$2 = (+\u03b48$.bi);
              var hpy$2 = (+\u03b48$.be);
              var startp = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv, allX, tn0) + tpx$2), ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cy$1__sci_Map__sci_Map__T__D($thiz, yOf$2, rankOf, tn0) + tpy$2));
              var endp = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv, allX, hn0) + hpx$2), ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cy$1__sci_Map__sci_Map__T__D($thiz, yOf$2, rankOf, hn0) + hpy$2));
              $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(out, origIdx$1, $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__clipInstall__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_model_REdge__sci_Map__F1__Z__Z__Z__s_Option__s_Option__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$ESpline($thiz, g, $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY.r().C)([startp, startp, endp, endp]))), e$11, byId, centerOf, true, true, (rt$2 > rh$2), $m_s_None$(), $m_s_None$()), false);
              break matchResult59;
            } else {
              var this$143 = $f_sc_IndexedSeqOps__headOption__s_Option(mids);
              var f$22 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((m$2) => new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv, allX, m$2), $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cy$1__sci_Map__sci_Map__T__D($thiz, yOf$2, rankOf, m$2))));
              var this$145 = (this$143.c() ? $m_s_None$() : new $c_s_Some(f$22.i(this$143.d())));
              var default$7 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv, allX, hn0), $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cy$1__sci_Map__sci_Map__T__D($thiz, yOf$2, rankOf, hn0))));
              var tOther = (this$145.c() ? default$7.a3() : this$145.d());
              var this$147 = $f_sc_IterableOps__lastOption__s_Option(mids);
              var f$23 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((m$3) => new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv, allX, m$3), $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cy$1__sci_Map__sci_Map__T__D($thiz, yOf$2, rankOf, m$3))));
              var this$149 = (this$147.c() ? $m_s_None$() : new $c_s_Some(f$23.i(this$147.d())));
              var default$8 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv, allX, tn0), $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cy$1__sci_Map__sci_Map__T__D($thiz, yOf$2, rankOf, tn0))));
              var hOther = (this$149.c() ? default$8.a3() : this$149.d());
              matchResult49$1: {
                var \u03b49$;
                var x173 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__endPort$1__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir__scm_HashMap__sci_Map__sci_Map__sci_Map__T__s_Option__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__T2($thiz, byId, g, rd, cxOv, allX, yOf$2, rankOf, tn0, wtPort, tOther);
                if ((x173 !== null)) {
                  var \u03b49$ = new $c_T2(x173.g(), (!(!x173.h())));
                  break matchResult49$1;
                }
                throw new $c_s_MatchError(x173);
              }
              var tGp$2 = \u03b49$.bi;
              var tOrigClip$2 = (!(!\u03b49$.be));
              matchResult50$1: {
                var \u03b410$;
                var x176 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__endPort$1__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir__scm_HashMap__sci_Map__sci_Map__sci_Map__T__s_Option__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__T2($thiz, byId, g, rd, cxOv, allX, yOf$2, rankOf, hn0, whPort, hOther);
                if ((x176 !== null)) {
                  var \u03b410$ = new $c_T2(x176.g(), (!(!x176.h())));
                  break matchResult50$1;
                }
                throw new $c_s_MatchError(x176);
              }
              var hGp$2 = \u03b410$.bi;
              var hOrigClip$2 = (!(!\u03b410$.be));
              var nbT = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__maximalBboxGv$1__sci_Map__sci_Vector__D__D__sr_DoubleRef__sr_DoubleRef__sci_Map__sci_Map__sci_Map__scm_Map__sci_Map__sci_Map__sci_Vector__scm_Map__sci_Map__scm_HashMap__sci_Map__scm_HashMap__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Set__D__sci_Map__sci_Vector__sci_Map__sci_Map__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo__T__s_Option__s_Option__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box($thiz, rankOf, cluBBs, Splinesep, NodeSep, leftBound, rightBound, orderByRank, orderIdx, labelW, outDeg, realOutSeg, nodeOf, workEnds, inDeg, realInSeg, cxOv, allX, lwOv, flatLabelHalf, byId, g, intraVEdge, VirtualHalf, cluOf, dedges, yOf$2, selfRwSpl, rwOv, yiHt, tn0, $m_s_None$(), new $c_s_Some($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__segAt$1__sci_Vector__I__T2($thiz, pathTopDown, 0)));
              matchResult51$1: {
                var \u03b411$;
                var x179 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__beginPathR$1__D__D__scm_HashMap__sci_Map__sci_Map__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__scm_HashMap__sci_Map__D__sci_Map__sci_Map__sci_Set__D__scm_HashMap__Z__T__Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box__T4($thiz, RanksepPt, 2.0, cxOv, allX, yOf$2, rankOf, byId, g, lwOv, labelW, NodeSep, flatLabelHalf, nodeOf, intraVEdge, VirtualHalf, rwOv, flip, tn0, tGp$2, nbT);
                if ((x179 !== null)) {
                  var \u03b411$ = new $c_T4(x179.bO, x179.bs, x179.ch, (!(!x179.ca)));
                  break matchResult51$1;
                }
                throw new $c_s_MatchError(x179);
              }
              var start$3 = \u03b411$.bO;
              var thT$2 = \u03b411$.bs;
              var tB0$2 = \u03b411$.ch;
              var tCleared$2 = (!(!\u03b411$.ca));
              var fillT = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box(nbT.aJ, ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cy$1__sci_Map__sci_Map__T__D($thiz, yOf$2, rankOf, tn0) - $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__ht1$1__Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo__I__D($thiz, yiHt, lo$1)), nbT.aF, tB0$2.bJ().bZ);
              var tBoxes$2 = (((fillT.aJ < fillT.aF) && (fillT.bZ < fillT.bG)) ? tB0$2.bv(fillT) : tB0$2);
              var threshold = ($m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().J0(g) ? 5 : 3);
              $m_scm_ArrayBuffer$();
              var pointfs = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
              var curTend = new $c_sr_ObjectRef(tBoxes$2);
              var curStart = new $c_sr_ObjectRef(start$3);
              var f$24 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((t) => {
                var t$1 = (+t);
                return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY((+Math.cos(t$1)), (+Math.sin(t$1)));
              }));
              var this$164 = (thT$2.c() ? $m_s_None$() : new $c_s_Some(f$24.i(thT$2.d())));
              var default$9 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(0.0, 0.0)));
              var curEv0 = new $c_sr_ObjectRef((this$164.c() ? default$9.a3() : this$164.d()));
              var segStart = new $c_sr_IntRef(0);
              $m_scm_ArrayBuffer$();
              var boxesBuf = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
              var tnI = 0;
              var hnI = 1;
              var smode = false;
              var si = (-1);
              var sl = 0;
              while ((hnI < ((pathTopDown.C() - 1) | 0))) {
                var tn = pathTopDown.l(tnI);
                var hn = pathTopDown.l(hnI);
                boxesBuf.aw($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__rankBox$1__sr_DoubleRef__sci_Map__sr_DoubleRef__Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo__I__I__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box($thiz, leftBound, yOf$2, rightBound, yiHt, (rankOf.i(tn) | 0), (rankOf.i(hn) | 0)));
                if ((!smode)) {
                  sl = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__straightLen$1__sci_Map__sci_Vector__scm_Map__scm_Map__scm_HashMap__sci_Map__T__I($thiz, nodeOf, workEnds, outDeg, inDeg, cxOv, allX, hn);
                  var $x_5 = (sl >= threshold);
                } else {
                  var $x_5 = false;
                }
                if ($x_5) {
                  smode = true;
                  si = 1;
                  sl = ((sl - 2) | 0);
                }
                if (((!smode) || (si > 0))) {
                  si = ((si - 1) | 0);
                  boxesBuf.aw($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__maximalBboxGv$1__sci_Map__sci_Vector__D__D__sr_DoubleRef__sr_DoubleRef__sci_Map__sci_Map__sci_Map__scm_Map__sci_Map__sci_Map__sci_Vector__scm_Map__sci_Map__scm_HashMap__sci_Map__scm_HashMap__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Set__D__sci_Map__sci_Vector__sci_Map__sci_Map__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo__T__s_Option__s_Option__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box($thiz, rankOf, cluBBs, Splinesep, NodeSep, leftBound, rightBound, orderByRank, orderIdx, labelW, outDeg, realOutSeg, nodeOf, workEnds, inDeg, realInSeg, cxOv, allX, lwOv, flatLabelHalf, byId, g, intraVEdge, VirtualHalf, cluOf, dedges, yOf$2, selfRwSpl, rwOv, yiHt, hn, new $c_s_Some($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__segAt$1__sci_Vector__I__T2($thiz, pathTopDown, ((hnI - 1) | 0))), new $c_s_Some($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__segAt$1__sci_Vector__I__T2($thiz, pathTopDown, hnI))));
                  tnI = hnI;
                  hnI = ((1 + hnI) | 0);
                } else {
                  var nbS = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__maximalBboxGv$1__sci_Map__sci_Vector__D__D__sr_DoubleRef__sr_DoubleRef__sci_Map__sci_Map__sci_Map__scm_Map__sci_Map__sci_Map__sci_Vector__scm_Map__sci_Map__scm_HashMap__sci_Map__scm_HashMap__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Set__D__sci_Map__sci_Vector__sci_Map__sci_Map__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo__T__s_Option__s_Option__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box($thiz, rankOf, cluBBs, Splinesep, NodeSep, leftBound, rightBound, orderByRank, orderIdx, labelW, outDeg, realOutSeg, nodeOf, workEnds, inDeg, realInSeg, cxOv, allX, lwOv, flatLabelHalf, byId, g, intraVEdge, VirtualHalf, cluOf, dedges, yOf$2, selfRwSpl, rwOv, yiHt, hn, new $c_s_Some($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__segAt$1__sci_Vector__I__T2($thiz, pathTopDown, ((hnI - 1) | 0))), new $c_s_Some($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__segAt$1__sci_Vector__I__T2($thiz, pathTopDown, hnI)));
                  var hb0 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box(nbS.aJ, $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cy$1__sci_Map__sci_Map__T__D($thiz, yOf$2, rankOf, hn), nbS.aF, nbS.bG);
                  var fillS = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box(nbS.aJ, hb0.bG, nbS.aF, ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cy$1__sci_Map__sci_Map__T__D($thiz, yOf$2, rankOf, hn) + $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__ht2$1__Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo__I__D($thiz, yiHt, (rankOf.i(hn) | 0))));
                  $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__routeSeg$1__sr_ObjectRef__scm_ArrayBuffer__sr_ObjectRef__Z__Z__sr_ObjectRef__scm_ArrayBuffer__sci_Vector__sr_IntRef__I__scm_HashMap__scm_HashMap__scm_HashMap__scm_HashMap__sci_Map__sci_Map__sci_Map__D__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Set__D__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__V($thiz, curTend, boxesBuf, curStart, polylineMode, lineMode, curEv0, pointfs, pathTopDown, segStart, origIdx$1, cxOv, lwOv, rwOv, labelPos, yOf$2, rankOf, labelW, NodeSep, flatLabelHalf, byId, g, nodeOf, intraVEdge, VirtualHalf, (((fillS.aJ < fillS.aF) && (fillS.bZ < fillS.bG)) ? $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box.r().C)([hb0, fillS]))) : $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box.r().C)([hb0])))), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv, allX, hn), ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cy$1__sci_Map__sci_Map__T__D($thiz, yOf$2, rankOf, hn) + 1.0)), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(0.0, (-1.0)));
                  var lastPt = $f_sc_IndexedSeqOps__last__O(pointfs);
                  pointfs.aw(lastPt);
                  pointfs.aw(lastPt);
                  tnI = ((hnI + sl) | 0);
                  hnI = ((1 + tnI) | 0);
                  segStart.an = tnI;
                  $p_scm_ArrayBuffer__reduceToSize__I__V(boxesBuf, 0);
                  var tnN = pathTopDown.l(tnI);
                  var nbT2 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__maximalBboxGv$1__sci_Map__sci_Vector__D__D__sr_DoubleRef__sr_DoubleRef__sci_Map__sci_Map__sci_Map__scm_Map__sci_Map__sci_Map__sci_Vector__scm_Map__sci_Map__scm_HashMap__sci_Map__scm_HashMap__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Set__D__sci_Map__sci_Vector__sci_Map__sci_Map__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo__T__s_Option__s_Option__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box($thiz, rankOf, cluBBs, Splinesep, NodeSep, leftBound, rightBound, orderByRank, orderIdx, labelW, outDeg, realOutSeg, nodeOf, workEnds, inDeg, realInSeg, cxOv, allX, lwOv, flatLabelHalf, byId, g, intraVEdge, VirtualHalf, cluOf, dedges, yOf$2, selfRwSpl, rwOv, yiHt, tnN, new $c_s_Some($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__segAt$1__sci_Vector__I__T2($thiz, pathTopDown, ((tnI - 1) | 0))), new $c_s_Some($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__segAt$1__sci_Vector__I__T2($thiz, pathTopDown, tnI)));
                  curTend.aD = $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box.r().C)([new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box(nbT2.aJ, nbT2.bZ, nbT2.aF, $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cy$1__sci_Map__sci_Map__T__D($thiz, yOf$2, rankOf, tnN))])));
                  curStart.aD = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv, allX, tnN), ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cy$1__sci_Map__sci_Map__T__D($thiz, yOf$2, rankOf, tnN) - 1.0));
                  curEv0.aD = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(0.0, (-1.0));
                  smode = false;
                }
              }
              boxesBuf.aw($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__rankBox$1__sr_DoubleRef__sci_Map__sr_DoubleRef__Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo__I__I__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box($thiz, leftBound, yOf$2, rightBound, yiHt, (rankOf.i(pathTopDown.l(tnI)) | 0), (rankOf.i(hn0) | 0)));
              var nbH = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__maximalBboxGv$1__sci_Map__sci_Vector__D__D__sr_DoubleRef__sr_DoubleRef__sci_Map__sci_Map__sci_Map__scm_Map__sci_Map__sci_Map__sci_Vector__scm_Map__sci_Map__scm_HashMap__sci_Map__scm_HashMap__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Set__D__sci_Map__sci_Vector__sci_Map__sci_Map__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo__T__s_Option__s_Option__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box($thiz, rankOf, cluBBs, Splinesep, NodeSep, leftBound, rightBound, orderByRank, orderIdx, labelW, outDeg, realOutSeg, nodeOf, workEnds, inDeg, realInSeg, cxOv, allX, lwOv, flatLabelHalf, byId, g, intraVEdge, VirtualHalf, cluOf, dedges, yOf$2, selfRwSpl, rwOv, yiHt, hn0, new $c_s_Some($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__segAt$1__sci_Vector__I__T2($thiz, pathTopDown, ((pathTopDown.C() - 2) | 0))), $m_s_None$());
              matchResult52$1: {
                var \u03b412$;
                var x184 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__endPathR$1__D__D__scm_HashMap__sci_Map__sci_Map__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__scm_HashMap__sci_Map__D__sci_Map__sci_Map__sci_Set__D__scm_HashMap__Z__T__Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box__T4($thiz, RanksepPt, 2.0, cxOv, allX, yOf$2, rankOf, byId, g, lwOv, labelW, NodeSep, flatLabelHalf, nodeOf, intraVEdge, VirtualHalf, rwOv, flip, hn0, hGp$2, nbH);
                if ((x184 !== null)) {
                  var \u03b412$ = new $c_T4(x184.bO, x184.bs, x184.ch, (!(!x184.ca)));
                  break matchResult52$1;
                }
                throw new $c_s_MatchError(x184);
              }
              var end$3$1 = \u03b412$.bO;
              var thH$2 = \u03b412$.bs;
              var hB0$2 = \u03b412$.ch;
              var hCleared$2 = (!(!\u03b412$.ca));
              var fillH = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box(nbH.aJ, hB0$2.bJ().bG, nbH.aF, ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cy$1__sci_Map__sci_Map__T__D($thiz, yOf$2, rankOf, hn0) + $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__ht2$1__Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo__I__D($thiz, yiHt, hi$1)));
              var $x_6 = (((fillH.aJ < fillH.aF) && (fillH.bZ < fillH.bG)) ? hB0$2.bv(fillH) : hB0$2);
              var f$25 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((t$2) => {
                var t$3 = (+t$2);
                return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY((-(+Math.cos(t$3))), (-(+Math.sin(t$3))));
              }));
              var this$193 = (thH$2.c() ? $m_s_None$() : new $c_s_Some(f$25.i(thH$2.d())));
              var default$10 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(0.0, 0.0)));
              $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__routeSeg$1__sr_ObjectRef__scm_ArrayBuffer__sr_ObjectRef__Z__Z__sr_ObjectRef__scm_ArrayBuffer__sci_Vector__sr_IntRef__I__scm_HashMap__scm_HashMap__scm_HashMap__scm_HashMap__sci_Map__sci_Map__sci_Map__D__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Set__D__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__V($thiz, curTend, boxesBuf, curStart, polylineMode, lineMode, curEv0, pointfs, pathTopDown, segStart, origIdx$1, cxOv, lwOv, rwOv, labelPos, yOf$2, rankOf, labelW, NodeSep, flatLabelHalf, byId, g, nodeOf, intraVEdge, VirtualHalf, $x_6, end$3$1, (this$193.c() ? default$10.a3() : this$193.d()));
              var routed = $m_sci_Vector$().X(pointfs);
              var members = $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(new $c_sci_Range$Exclusive(0, res.pV.C(), 1), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$29) => {
                var _$29$1 = (_$29 | 0);
                return ((res.pV.l(_$29$1) | 0) === i$5);
              })), false).d2();
              if ((members.C() <= 1)) {
                $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__install$1__scm_LinkedHashMap__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__F1__Z__Z__Z__Z__I__I__Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort__Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort__I__Lorg_jpablo_graphexplorer_graphviz_model_REdge__sci_Vector__Z__V($thiz, out, g, byId, centerOf, tOrigClip$2, tCleared$2, hOrigClip$2, hCleared$2, rt$2, rh$2, tGp$2, hGp$2, origIdx$1, e$11, routed, true);
                break matchResult59;
              } else {
                if ((routed.C() >= 4)) {
                  var $x_7 = routed;
                } else {
                  var s$1 = routed.t();
                  var t$3$1 = routed.bJ();
                  var $x_7 = $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY.r().C)([s$1, new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY((s$1.W + ((t$3$1.W - s$1.W) / 3.0)), (s$1.a6 + ((t$3$1.a6 - s$1.a6) / 3.0))), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY((s$1.W + ((2.0 * (t$3$1.W - s$1.W)) / 3.0)), (s$1.a6 + ((2.0 * (t$3$1.a6 - s$1.a6)) / 3.0))), t$3$1])));
                }
                var base = $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O($x_7, new $c_s_reflect_ClassTag$GenericClassTag($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY.l()));
                var dxm = (0.5 * (NodeSep * ((members.C() - 1) | 0)));
                var k$4 = 1;
                while ((k$4 < ((base.a.length - 1) | 0))) {
                  base.a[k$4] = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY((base.a[k$4].W - dxm), base.a[k$4].a6);
                  k$4 = ((1 + k$4) | 0);
                }
                $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(members).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$1) => {
                  var dj = (x$1$2$1.g() | 0);
                  var mi = (x$1$2$1.h() | 0);
                  if ((mi > 0)) {
                    var q = 1;
                    while ((q < ((base.a.length - 1) | 0))) {
                      base.a[q] = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY((base.a[q].W + NodeSep), base.a[q].a6);
                      q = ((1 + q) | 0);
                    }
                  }
                  var $x_9 = dedgeOrigIdx.l(dj);
                  var $x_8 = g.cu.l((dedgeOrigIdx.l(dj) | 0));
                  var this$204 = $m_s_Predef$().fB(base);
                  $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__install$1__scm_LinkedHashMap__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__F1__Z__Z__Z__Z__I__I__Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort__Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort__I__Lorg_jpablo_graphexplorer_graphviz_model_REdge__sci_Vector__Z__V($thiz, out, g, byId, centerOf, tOrigClip$2, tCleared$2, hOrigClip$2, hCleared$2, rt$2, rh$2, tGp$2, hGp$2, ($x_9 | 0), $x_8, $m_sci_Vector$().X(this$204), (mi === 0));
                })));
                break matchResult59;
              }
            }
          } else {
            break matchResult59;
          }
        } else {
          var row$1 = orderByRank.ay(rt$2, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
            $m_sci_Vector$();
            return $m_sci_Vector0$();
          })));
          var ti = $f_sc_SeqOps__indexOf__O__I__I(row$1, e$11.ai, 0);
          var hi$2 = $f_sc_SeqOps__indexOf__O__I__I(row$1, e$11.ak, 0);
          var \u03b413$ = ((ti < hi$2) ? new $c_T2(ti, hi$2) : new $c_T2(hi$2, ti));
          var lo$2 = (\u03b413$.bi | 0);
          var hi2 = (\u03b413$.be | 0);
          var adjacent = ((lo$2 >= 0) && $f_sc_IterableOnceOps__forall__F1__Z(new $c_sci_Range$Exclusive(((1 + lo$2) | 0), hi2, 1), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((k$2$1) => {
            var k$5 = (k$2$1 | 0);
            var id$1 = row$1.l(k$5);
            if ((!(!id$1.startsWith("__v")))) {
              var id$2 = row$1.l(k$5);
              return (!labelW.E(id$2));
            } else {
              return false;
            }
          }))));
          var ports = ((!e$11.ka.c()) || (!e$11.k9.c()));
          var this$217 = e$11.b4.ag.r("label");
          var p$10 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$30) => (_$30 !== "")));
          var labelled = ((!this$217.c()) && (!(!p$10.i(this$217.d()))));
          if ((adjacent && (!ports))) {
            var flatRev = ($f_sc_SeqOps__indexOf__O__I__I(row$1, e$11.ak, 0) < $f_sc_SeqOps__indexOf__O__I__I(row$1, e$11.ai, 0));
            var \u03b414$ = (flatRev ? new $c_T2(e$11.ak, e$11.ai) : new $c_T2(e$11.ai, e$11.ak));
            var wt$1 = \u03b414$.bi;
            var wh$1 = \u03b414$.be;
            var tp = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv, allX, wt$1), $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cy$1__sci_Map__sci_Map__T__D($thiz, yOf$2, rankOf, wt$1));
            var hp = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv, allX, wh$1), $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cy$1__sci_Map__sci_Map__T__D($thiz, yOf$2, rankOf, wh$1));
            $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(out, origIdx$1, $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__clipInstall__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_model_REdge__sci_Map__F1__Z__Z__Z__s_Option__s_Option__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$ESpline($thiz, g, (labelled ? $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY.r().C)([tp, tp, hp, hp]))) : $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY.r().C)([tp, new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY((((2.0 * tp.W) + hp.W) / 3.0), tp.a6), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY((((2.0 * hp.W) + tp.W) / 3.0), tp.a6), hp])))), e$11, byId, centerOf, true, true, flatRev, $m_s_None$(), $m_s_None$()), false);
            if (labelled) {
              matchResult53$1: {
                var dh$2;
                var x189 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().tX(e$11, g);
                if ((x189 !== null)) {
                  var dh$2 = (+x189.h());
                  break matchResult53$1;
                }
                throw new $c_s_MatchError(x189);
              }
              var \u03b415$ = (($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv, allX, e$11.ai) <= $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv, allX, e$11.ak)) ? new $c_T2(e$11.ai, e$11.ak) : new $c_T2(e$11.ak, e$11.ai));
              var ln = \u03b415$.bi;
              var rn = \u03b415$.be;
              $p_scm_HashMap__put0__O__O__Z__s_Some(labelPos, origIdx$1, new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY((0.5 * ((($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv, allX, ln) + $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__rw$1__scm_HashMap__sci_Map__D__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Set__D__T__D($thiz, rwOv, labelW, NodeSep, flatLabelHalf, byId, g, nodeOf, intraVEdge, VirtualHalf, ln)) + $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv, allX, rn)) - $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__lw$1__scm_HashMap__sci_Map__D__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Set__D__T__D($thiz, lwOv, labelW, NodeSep, flatLabelHalf, byId, g, nodeOf, intraVEdge, VirtualHalf, rn))), (tp.a6 + (0.5 * (dh$2 + 6.0)))), false);
              break matchResult59;
            } else {
              break matchResult59;
            }
          } else if (((!ports) && (!labelled))) {
            var \u03b416$ = (($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv, allX, e$11.ai) <= $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv, allX, e$11.ak)) ? new $c_T2(e$11.ai, e$11.ak) : new $c_T2(e$11.ak, e$11.ai));
            var tn$2 = \u03b416$.bi;
            var hn$2 = \u03b416$.be;
            var tmb = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__maximalBbox$1__sci_Map__sci_Vector__D__D__sr_DoubleRef__sr_DoubleRef__sci_Map__sci_Map__scm_HashMap__sci_Map__scm_HashMap__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Set__D__sci_Map__sci_Vector__sci_Map__sci_Map__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo__T__sci_Set__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box($thiz, rankOf, cluBBs, Splinesep, NodeSep, leftBound, rightBound, orderByRank, labelW, cxOv, allX, lwOv, flatLabelHalf, byId, g, nodeOf, intraVEdge, VirtualHalf, cluOf, dedges, yOf$2, selfRwSpl, rwOv, yiHt, tn$2, $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_T.r().C)([tn$2]))));
            var hmb = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__maximalBbox$1__sci_Map__sci_Vector__D__D__sr_DoubleRef__sr_DoubleRef__sci_Map__sci_Map__scm_HashMap__sci_Map__scm_HashMap__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Set__D__sci_Map__sci_Vector__sci_Map__sci_Map__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo__T__sci_Set__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box($thiz, rankOf, cluBBs, Splinesep, NodeSep, leftBound, rightBound, orderByRank, labelW, cxOv, allX, lwOv, flatLabelHalf, byId, g, nodeOf, intraVEdge, VirtualHalf, cluOf, dedges, yOf$2, selfRwSpl, rwOv, yiHt, hn$2, $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_T.r().C)([hn$2]))));
            var tend = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box(tmb.aJ, $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cy$1__sci_Map__sci_Map__T__D($thiz, yOf$2, rankOf, tn$2), tmb.aF, tmb.bG);
            var hend$2 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box(hmb.aJ, $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cy$1__sci_Map__sci_Map__T__D($thiz, yOf$2, rankOf, hn$2), hmb.aF, hmb.bG);
            var stepx = (0.5 * NodeSep);
            var topRank = (ranksSorted.t() | 0);
            var vspace = ((rt$2 === topRank) ? $p_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$__rankSep__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D($m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$(), g) : (((+yOf$2.i(((rt$2 - 1) | 0))) - $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__ht1$1__Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo__I__D($thiz, yiHt, ((rt$2 - 1) | 0))) - ((+yOf$2.i(rt$2)) + $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__ht2$1__Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo__I__D($thiz, yiHt, rt$2))));
            var stepy = (0.5 * vspace);
            var cb0 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box(tend.aJ, tend.bG, (tend.aF + stepx), (tend.bG + stepy));
            var cb1 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box(tend.aJ, cb0.bG, hend$2.aF, (cb0.bG + stepy));
            var cb2 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box((hend$2.aJ - stepx), hend$2.bG, hend$2.aF, cb1.bZ);
            var boxes$2 = $m_scm_ArrayBuffer$().y9($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box.r().C)([tend, cb0, cb1, cb2, hend$2])));
            var st$2 = new $ac_D(new Float64Array([$p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv, allX, tn$2), $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cy$1__sci_Map__sci_Map__T__D($thiz, yOf$2, rankOf, tn$2)]));
            var en$2 = new $ac_D(new Float64Array([$p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv, allX, hn$2), $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cy$1__sci_Map__sci_Map__T__D($thiz, yOf$2, rankOf, hn$2)]));
            $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(out, origIdx$1, $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__clipInstall__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_model_REdge__sci_Map__F1__Z__Z__Z__s_Option__s_Option__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$ESpline($thiz, g, ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__checkpath__scm_ArrayBuffer__AD__AD__Z($thiz, boxes$2, st$2, en$2) ? $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY.r().C)([new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(st$2.a[0], st$2.a[1]), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(en$2.a[0], en$2.a[1])]))) : $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__proutespline__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__sci_Vector__sci_Vector($thiz, $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__buildPolygon__scm_ArrayBuffer__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($thiz, boxes$2), $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__funnelGeneral__scm_ArrayBuffer__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__sci_Vector($thiz, boxes$2, new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(st$2.a[0], st$2.a[1]), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(en$2.a[0], en$2.a[1])))), e$11, byId, centerOf, true, true, (e$11.ai !== tn$2), $m_s_None$(), $m_s_None$()), false);
            break matchResult59;
          } else if (labelled) {
            var lnIdx = (flatLabelRep.i(i$5) | 0);
            var lnNode = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$FlatLabel(lnIdx);
            var lnName = lnNode.bE();
            if (rankOf.E(lnName)) {
              var \u03b417$ = (($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv, allX, e$11.ai) <= $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv, allX, e$11.ak)) ? new $c_T2(e$11.ai, e$11.ak) : new $c_T2(e$11.ak, e$11.ai));
              var tn$3 = \u03b417$.bi;
              var hn$3 = \u03b417$.be;
              var \u03b418$ = ((tn$3 === e$11.ai) ? new $c_T2(e$11.ka, e$11.k9) : new $c_T2(e$11.k9, e$11.ka));
              var tPort = \u03b418$.bi;
              var hPort = \u03b418$.be;
              matchResult54$1: {
                var tGp$5;
                var x192 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__endPort$1__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir__scm_HashMap__sci_Map__sci_Map__sci_Map__T__s_Option__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__T2($thiz, byId, g, rd, cxOv, allX, yOf$2, rankOf, tn$3, tPort, new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv, allX, hn$3), $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cy$1__sci_Map__sci_Map__T__D($thiz, yOf$2, rankOf, hn$3)));
                if ((x192 !== null)) {
                  var tGp$5 = x192.g();
                  break matchResult54$1;
                }
                throw new $c_s_MatchError(x192);
              }
              matchResult55$1: {
                var hGp$5;
                var x195 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__endPort$1__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir__scm_HashMap__sci_Map__sci_Map__sci_Map__T__s_Option__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__T2($thiz, byId, g, rd, cxOv, allX, yOf$2, rankOf, hn$3, hPort, new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv, allX, tn$3), $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cy$1__sci_Map__sci_Map__T__D($thiz, yOf$2, rankOf, tn$3)));
                if ((x195 !== null)) {
                  var hGp$5 = x195.g();
                  break matchResult55$1;
                }
                throw new $c_s_MatchError(x195);
              }
              var flatOe = new $c_s_Some(new $c_T2(tn$3, hn$3));
              matchResult56$1: {
                var \u03b419$;
                var x198 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__flatEnd$1__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D__sci_Map__sci_Vector__D__D__sr_DoubleRef__sr_DoubleRef__sci_Map__sci_Map__sci_Map__scm_Map__sci_Map__sci_Map__sci_Vector__scm_Map__sci_Map__scm_HashMap__sci_Map__sci_Map__sci_Map__scm_HashMap__sci_Map__sci_Set__D__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo__sci_Map__sci_Vector__sci_Map__T__Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort__Z__s_Option__T2($thiz, g, 2.0, rankOf, cluBBs, Splinesep, NodeSep, leftBound, rightBound, orderByRank, orderIdx, labelW, outDeg, realOutSeg, nodeOf, workEnds, inDeg, realInSeg, cxOv, allX, yOf$2, byId, rwOv, flatLabelHalf, intraVEdge, VirtualHalf, lwOv, yiHt, cluOf, dedges, selfRwSpl, tn$3, tGp$5, true, flatOe);
                if ((x198 !== null)) {
                  var \u03b419$ = new $c_T2(x198.g(), x198.h());
                  break matchResult56$1;
                }
                throw new $c_s_MatchError(x198);
              }
              var tStart$2 = \u03b419$.bi;
              var tBoxes$4 = \u03b419$.be;
              matchResult57$1: {
                var \u03b420$;
                var x201 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__flatEnd$1__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D__sci_Map__sci_Vector__D__D__sr_DoubleRef__sr_DoubleRef__sci_Map__sci_Map__sci_Map__scm_Map__sci_Map__sci_Map__sci_Vector__scm_Map__sci_Map__scm_HashMap__sci_Map__sci_Map__sci_Map__scm_HashMap__sci_Map__sci_Set__D__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo__sci_Map__sci_Vector__sci_Map__T__Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort__Z__s_Option__T2($thiz, g, 2.0, rankOf, cluBBs, Splinesep, NodeSep, leftBound, rightBound, orderByRank, orderIdx, labelW, outDeg, realOutSeg, nodeOf, workEnds, inDeg, realInSeg, cxOv, allX, yOf$2, byId, rwOv, flatLabelHalf, intraVEdge, VirtualHalf, lwOv, yiHt, cluOf, dedges, selfRwSpl, hn$3, hGp$5, false, flatOe);
                if ((x201 !== null)) {
                  var \u03b420$ = new $c_T2(x201.g(), x201.h());
                  break matchResult57$1;
                }
                throw new $c_s_MatchError(x201);
              }
              var hEnd$3 = \u03b420$.bi;
              var hBoxes$3 = \u03b420$.be;
              var lx = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv, allX, lnName);
              var ly = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cy$1__sci_Map__sci_Map__T__D($thiz, yOf$2, rankOf, lnName);
              matchResult58$1: {
                var \u03b421$;
                var x204 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().a3o(flatDedges.l(lnIdx), g);
                if ((x204 !== null)) {
                  var \u03b421$ = new $c_T2((+x204.g()), (+x204.h()));
                  break matchResult58$1;
                }
                throw new $c_s_MatchError(x204);
              }
              var lhw$2 = (+\u03b421$.bi);
              var lht$2 = (+\u03b421$.be);
              $p_scm_HashMap__put0__O__O__Z__s_Some(labelPos, origIdx$1, new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(lx, ly), false);
              var lbLLx = (lx - lhw$2);
              var lbURx = (lx + lhw$2);
              var lbURy = (ly + (0.5 * lht$2));
              var ydelta = ((((ly - $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__ht1$1__Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo__I__D($thiz, yiHt, rt$2)) - $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cy$1__sci_Map__sci_Map__T__D($thiz, yOf$2, rankOf, tn$3)) + $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__ht2$1__Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo__I__D($thiz, yiHt, rt$2)) / 6.0);
              var lbLLy = (lbURy - (+Math.max(5.0, ydelta)));
              var tLast = tBoxes$4.bJ();
              var hLast = hBoxes$3.bJ();
              var b0 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box(tLast.aJ, tLast.bG, lbLLx, lbLLy);
              var b1 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box(tLast.aJ, lbLLy, hLast.aF, lbURy);
              var b2 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box(lbURx, hLast.bG, hLast.aF, lbLLy);
              var boxes$3 = $m_scm_ArrayBuffer$().y9(tBoxes$4).gS($m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box.r().C)([b0, b1, b2])))).gS($f_sc_IndexedSeqOps__reverse__O(hBoxes$3));
              var st$3 = new $ac_D(new Float64Array([tStart$2.W, tStart$2.a6]));
              var en$3 = new $ac_D(new Float64Array([hEnd$3.W, hEnd$3.a6]));
              if (tGp$5.uA) {
                var x$40 = tGp$5.pX;
                var $x_10 = Math.cos(x$40);
                var x$41 = tGp$5.pX;
                var fev0 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY((+$x_10), (+Math.sin(x$41)));
              } else {
                var fev0 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(0.0, 0.0);
              }
              if (hGp$5.uA) {
                var x$43 = hGp$5.pX;
                var $x_11 = Math.cos(x$43);
                var x$44 = hGp$5.pX;
                var fev1 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY((-(+$x_11)), (-(+Math.sin(x$44))));
              } else {
                var fev1 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(0.0, 0.0);
              }
              $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(out, origIdx$1, $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__clipInstall__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_model_REdge__sci_Map__F1__Z__Z__Z__s_Option__s_Option__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$ESpline($thiz, g, ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__checkpath__scm_ArrayBuffer__AD__AD__Z($thiz, boxes$3, st$3, en$3) ? $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY.r().C)([new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(st$3.a[0], st$3.a[1]), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(en$3.a[0], en$3.a[1])]))) : $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__proutespline__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__sci_Vector($thiz, $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__buildPolygon__scm_ArrayBuffer__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($thiz, boxes$3), $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__funnelGeneral__scm_ArrayBuffer__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__sci_Vector($thiz, boxes$3, new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(st$3.a[0], st$3.a[1]), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(en$3.a[0], en$3.a[1])), fev0, fev1)), e$11, byId, centerOf, ((tGp$5.fV === 0) && tGp$5.rq), ((hGp$5.fV === 0) && hGp$5.rq), (e$11.ai !== tn$3), $m_s_None$(), $m_s_None$()), false);
              break matchResult59;
            } else {
              break matchResult59;
            }
          } else {
            break matchResult59;
          }
        }
      }
      throw new $c_s_MatchError(x$1$9);
    }
  })));
  var minRank = ($f_sc_SeqOps__isEmpty__Z(ranksSorted) ? 0 : (ranksSorted.t() | 0));
  var maxRank = ($f_sc_SeqOps__isEmpty__Z(ranksSorted) ? 0 : (ranksSorted.bJ() | 0));
  $f_sc_IterableOps__groupBy__F1__sci_Map($f_sc_StrictOptimizedIterableOps__zipWithIndex__O(g.cu).bw(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$10) => {
    if ((x$1$10 !== null)) {
      var e$12 = x$1$10.g();
      return ((e$12.ai === e$12.ak) && rankOf.E(e$12.ai));
    }
    throw new $c_s_MatchError(x$1$10);
  }))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$33) => _$33.g().ai))).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$11) => {
    matchResult66: {
      if ((x$1$11 !== null)) {
        var nid = x$1$11.g();
        var group = x$1$11.h();
        var r$4 = (rankOf.i(nid) | 0);
        var ndHt = (2.0 * $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__halfH$1__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T__D($thiz, byId, g, nid));
        if ((r$4 === maxRank)) {
          var sizeyCs = ((r$4 > minRank) ? ((+yOf$2.i(((r$4 - 1) | 0))) - (+yOf$2.i(r$4))) : ndHt);
        } else if ((r$4 === minRank)) {
          var sizeyCs = ((+yOf$2.i(r$4)) - (+yOf$2.i(((1 + r$4) | 0))));
        } else {
          var x$proxy15 = (+yOf$2.i(((r$4 - 1) | 0)));
          var x$50 = (x$proxy15 - (+yOf$2.i(r$4)));
          var x$proxy17 = (+yOf$2.i(r$4));
          var y$41 = (x$proxy17 - (+yOf$2.i(((1 + r$4) | 0))));
          var sizeyCs = (+Math.min(x$50, y$41));
        }
        var cnt = group.C();
        var x$51 = ((0.5 * (0.5 * sizeyCs)) / cnt);
        var stepy$1 = (+Math.max(x$51, 2.0));
        var np = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv, allX, nid), $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cy$1__sci_Map__sci_Map__T__D($thiz, yOf$2, rankOf, nid));
        var rw = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__lw$1__scm_HashMap__sci_Map__D__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Set__D__T__D($thiz, lwOv, labelW, NodeSep, flatLabelHalf, byId, g, nodeOf, intraVEdge, VirtualHalf, nid);
        var e0 = group.t().g();
        var t0Raw = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__rawPort$1__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T__s_Option__s_Option($thiz, byId, g, nid, e0.ka);
        var h0Raw = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__rawPort$1__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T__s_Option__s_Option($thiz, byId, g, nid, e0.k9);
        var default$11 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort$().RO));
        var t0Gp = (t0Raw.c() ? default$11.a3() : t0Raw.d());
        var default$12 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort$().RO));
        var h0Gp = (h0Raw.c() ? default$12.a3() : h0Raw.d());
        var f$26 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$34) => _$34.fV));
        var this$289 = (t0Raw.c() ? $m_s_None$() : new $c_s_Some(f$26.i(t0Raw.d())));
        var default$13 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 0));
        var tSide = ((this$289.c() ? default$13.a3() : this$289.d()) | 0);
        var f$27 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$35) => _$35.fV));
        var this$290 = (h0Raw.c() ? $m_s_None$() : new $c_s_Some(f$27.i(h0Raw.d())));
        var default$14 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 0));
        var hSide = ((this$290.c() ? default$14.a3() : this$290.d()) | 0);
        var p$11 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$36) => _$36.o1));
        if ((!((!t0Raw.c()) && (!(!p$11.i(t0Raw.d())))))) {
          var p$12 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$37) => _$37.o1));
          var $x_13 = (!((!h0Raw.c()) && (!(!p$12.i(h0Raw.d())))));
        } else {
          var $x_13 = false;
        }
        if ((((!($x_13 || ((((tSide & $m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$().pZ) === 0) && ((hSide & $m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$().pZ) === 0)) && ((tSide !== hSide) || ((tSide & ($m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$().wK | $m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$().wJ)) === 0))))) && (((tSide & $m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$().pZ) !== 0) || ((hSide & $m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$().pZ) !== 0))) && (((tSide & $m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$().Bw) !== 0) || ((hSide & $m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$().Bw) !== 0)))) {
          $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__selfTop$1__D__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__scm_HashMap__scm_LinkedHashMap__sci_Map__F1__scm_HashMap__sci_Map__sci_Map__sci_Map__sci_Set__D__scm_HashMap__T__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort__Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort__D__I__V($thiz, NodeSep, g, labelPos, out, byId, centerOf, lwOv, labelW, flatLabelHalf, nodeOf, intraVEdge, VirtualHalf, rwOv, nid, group, np, t0Gp, h0Gp, (0.5 * sizeyCs), cnt);
          break matchResult66;
        } else {
          var dx$1 = new $c_sr_DoubleRef(rw);
          var tx = new $c_sr_DoubleRef(rw);
          var hx = new $c_sr_DoubleRef(rw);
          var dy = new $c_sr_DoubleRef(0.0);
          group.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$2) => {
            matchResult65: {
              if ((x$1$2$2 !== null)) {
                var e$13 = x$1$2$2.g();
                var origIdx$2 = (x$1$2$2.h() | 0);
                dx$1.T = (dx$1.T + NodeSep);
                tx.T = (tx.T + NodeSep);
                hx.T = (hx.T + NodeSep);
                dy.T = (dy.T + stepy$1);
                var pts = $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY.r().C)([np, new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY((np.W + (tx.T / 3.0)), (np.a6 + dy.T)), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY((np.W + dx$1.T), (np.a6 + dy.T)), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY((np.W + dx$1.T), np.a6), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY((np.W + dx$1.T), (np.a6 - dy.T)), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY((np.W + (hx.T / 3.0)), (np.a6 - dy.T)), np])));
                var this$304 = e$13.b4.ag.r("label");
                var p$13 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$38) => (_$38 !== "")));
                var this$307 = ((this$304.c() || (!(!p$13.i(this$304.d())))) ? this$304 : $m_s_None$());
                var f$28 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$39) => {
                  matchResult64$1: {
                    var \u03b423$;
                    var x221 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().tX(e$13, g);
                    if ((x221 !== null)) {
                      var \u03b423$ = new $c_T2((+x221.g()), (+x221.h()));
                      break matchResult64$1;
                    }
                    throw new $c_s_MatchError(x221);
                  }
                  var wl$2 = (+\u03b423$.bi);
                  var hl$2 = (+\u03b423$.be);
                  var width = ($m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().jT(g) ? hl$2 : wl$2);
                  $p_scm_HashMap__put0__O__O__Z__s_Some(labelPos, origIdx$2, new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(((np.W + dx$1.T) + (0.5 * width)), np.a6), false);
                  if ((width > NodeSep)) {
                    dx$1.T = (dx$1.T + (width - NodeSep));
                  }
                }));
                if ((!this$307.c())) {
                  f$28.i(this$307.d());
                }
                $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(out, origIdx$2, $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__clipInstall__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_model_REdge__sci_Map__F1__Z__Z__Z__s_Option__s_Option__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$ESpline($thiz, g, pts, e$13, byId, centerOf, true, true, false, $m_s_None$(), $m_s_None$()), false);
                break matchResult65;
              }
              throw new $c_s_MatchError(x$1$2$2);
            }
          })));
          break matchResult66;
        }
      }
      throw new $c_s_MatchError(x$1$11);
    }
  })));
  new $c_sci_Range$Exclusive(0, res.pV.C(), 1).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1$2) => {
    var d$4 = (v1$2 | 0);
    var r$5 = (res.pV.l(d$4) | 0);
    if (((r$5 !== d$4) && (!$p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__isLabelledFlat$1__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_REdge__Z($thiz, rankOf, flatDedges.l(d$4))))) {
      var mo = (dedgeOrigIdx.l(d$4) | 0);
      if ((!out.E(mo))) {
        var this$310 = out.r(dedgeOrigIdx.l(r$5));
        var f$29 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((sp$1) => {
          $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(out, mo, sp$1, false);
        }));
        if ((!this$310.c())) {
          f$29.i(this$310.d());
        }
      }
    }
  })));
  labelW.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$12) => {
    var vn = x$1$12.g();
    var w = (+x$1$12.h());
    matchResult67: {
      var x230 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$().b1O(vn);
      if ((x230 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Virtual)) {
        var x233 = x230.kB;
        if (allX.E(vn)) {
          var orig = (dedgeOrigIdx.l(x233) | 0);
          if ((!labelPos.E(orig))) {
            $p_scm_HashMap__put0__O__O__Z__s_Some(labelPos, orig, new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv, allX, vn) + (0.5 * w)), $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cy$1__sci_Map__sci_Map__T__D($thiz, yOf$2, rankOf, vn)), false);
            break matchResult67;
          } else {
            break matchResult67;
          }
        }
      }
    }
  })));
  return new $c_T2($m_sci_Map$().ao(out), $m_sci_Map$().ao(labelPos));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__adjustRegularPath__scm_ArrayBuffer__V($thiz, boxes) {
  var i = 0;
  while ((((1 + i) | 0) < boxes.a1)) {
    var a = boxes.l(i);
    var b = boxes.l(((1 + i) | 0));
    if (((a.aF - $thiz.n6) < b.aJ)) {
      b.aJ = (a.aF - $thiz.n6);
    }
    if (((a.aJ + $thiz.n6) > b.aF)) {
      b.aF = (a.aJ + $thiz.n6);
    }
    i = ((1 + i) | 0);
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__adjustRegularPath__scm_ArrayBuffer__I__I__V($thiz, boxes, fb, lb) {
  var i = ((fb - 1) | 0);
  while ((i < ((1 + lb) | 0))) {
    if (((i >= 0) && (i < boxes.a1))) {
      var bp1 = boxes.l(i);
      if ((i >= fb)) {
        var num = ((i - fb) | 0);
        var t = ((num >>> 31) | 0);
        var $x_1 = ((((1 & ((num + t) | 0)) - t) | 0) === 0);
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        if ((bp1.aJ >= bp1.aF)) {
          var x = (0.5 * (bp1.aJ + bp1.aF));
          bp1.aJ = (x - $thiz.RS);
          bp1.aF = (x + $thiz.RS);
        }
      } else if (((bp1.aJ + $thiz.n6) > bp1.aF)) {
        var x$2 = (0.5 * (bp1.aJ + bp1.aF));
        bp1.aJ = (x$2 - $thiz.RS);
        bp1.aF = (x$2 + $thiz.RS);
      }
    }
    i = ((1 + i) | 0);
  }
  i = 0;
  while ((((1 + i) | 0) < boxes.a1)) {
    var bp1$2 = boxes.l(i);
    var bp2 = boxes.l(((1 + i) | 0));
    if (((i >= fb) && (i <= lb))) {
      var num$1 = ((i - fb) | 0);
      var t$1 = ((num$1 >>> 31) | 0);
      var $x_2 = ((((1 & ((num$1 + t$1) | 0)) - t$1) | 0) === 0);
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      if (((bp1$2.aJ + $thiz.n6) > bp2.aF)) {
        bp2.aF = (bp1$2.aJ + $thiz.n6);
      }
      if (((bp1$2.aF - $thiz.n6) < bp2.aJ)) {
        bp2.aJ = (bp1$2.aF - $thiz.n6);
      }
    } else {
      if (((((1 + i) | 0) >= fb) && (i < lb))) {
        var num$2 = ((((1 + i) | 0) - fb) | 0);
        var t$2 = ((num$2 >>> 31) | 0);
        var $x_3 = ((((1 & ((num$2 + t$2) | 0)) - t$2) | 0) === 0);
      } else {
        var $x_3 = false;
      }
      if ($x_3) {
        if (((bp1$2.aJ + $thiz.n6) > bp2.aF)) {
          bp1$2.aJ = (bp2.aF - $thiz.n6);
        }
        if (((bp1$2.aF - $thiz.n6) < bp2.aJ)) {
          bp1$2.aF = (bp2.aJ + $thiz.n6);
        }
      }
    }
    i = ((1 + i) | 0);
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__checkpath__scm_ArrayBuffer__AD__AD__Z($thiz, boxes0, st, en) {
  $m_scm_ArrayBuffer$();
  var b = new $c_scm_ArrayBuffer$$anon$1();
  var it = boxes0.bB().o();
  while (it.p()) {
    var elem = it.q();
    var x = (elem.bZ - elem.bG);
    if (((+Math.abs(x)) < 0.01)) {
      var $x_1 = true;
    } else {
      var x$1 = (elem.aJ - elem.aF);
      var $x_1 = ((+Math.abs(x$1)) < 0.01);
    }
    if ((!$x_1)) {
      b.mI(elem);
    }
  }
  var boxes = b.gj;
  $p_scm_ArrayBuffer__reduceToSize__I__V(boxes0, 0);
  boxes0.gS(boxes);
  var n = boxes0.a1;
  if ((n === 0)) {
    return true;
  }
  if (((boxes0.l(0).aJ > boxes0.l(0).aF) || (boxes0.l(0).bZ > boxes0.l(0).bG))) {
    return true;
  }
  var bi = 0;
  while ((((1 + bi) | 0) < n)) {
    var ba = boxes0.l(bi);
    var bb = boxes0.l(((1 + bi) | 0));
    if (((bb.aJ > bb.aF) || (bb.bZ > bb.bG))) {
      return true;
    }
    var l = ((ba.aF < bb.aJ) | 0);
    var r = ((ba.aJ > bb.aF) | 0);
    var d = ((ba.bG < bb.bZ) | 0);
    var u = ((ba.bZ > bb.bG) | 0);
    var errs = ((((((l + r) | 0) + d) | 0) + u) | 0);
    if ((errs > 0)) {
      if ((l === 1)) {
        var xy = ba.aF;
        ba.aF = bb.aJ;
        bb.aJ = xy;
        l = 0;
      } else if ((r === 1)) {
        var xy$2 = ba.aJ;
        ba.aJ = bb.aF;
        bb.aF = xy$2;
        r = 0;
      } else if ((d === 1)) {
        var xy$3 = ba.bG;
        ba.bG = bb.bZ;
        bb.bZ = xy$3;
        d = 0;
      } else if ((u === 1)) {
        var xy$4 = ba.bZ;
        ba.bZ = bb.bG;
        bb.bG = xy$4;
        u = 0;
      }
      var j = 0;
      while ((j < ((errs - 1) | 0))) {
        if ((l === 1)) {
          var xy$5 = ((0.5 * (ba.aF + bb.aJ)) + 0.5);
          ba.aF = xy$5;
          bb.aJ = xy$5;
          l = 0;
        } else if ((r === 1)) {
          var xy$6 = ((0.5 * (ba.aJ + bb.aF)) + 0.5);
          ba.aJ = xy$6;
          bb.aF = xy$6;
          r = 0;
        } else if ((d === 1)) {
          var xy$7 = ((0.5 * (ba.bG + bb.bZ)) + 0.5);
          ba.bG = xy$7;
          bb.bZ = xy$7;
          d = 0;
        } else if ((u === 1)) {
          var xy$8 = ((0.5 * (ba.bZ + bb.bG)) + 0.5);
          ba.bZ = xy$8;
          bb.bG = xy$8;
          u = 0;
        }
        j = ((1 + j) | 0);
      }
    }
    var xo = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__overlap__D__D__D__D__D($thiz, ba.aJ, ba.aF, bb.aJ, bb.aF);
    var yo = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__overlap__D__D__D__D__D($thiz, ba.bZ, ba.bG, bb.bZ, bb.bG);
    if (((xo > 0.0) && (yo > 0.0))) {
      if ((xo < yo)) {
        if (((ba.aF - ba.aJ) > (bb.aF - bb.aJ))) {
          if ((ba.aF < bb.aF)) {
            ba.aF = bb.aJ;
          } else {
            ba.aJ = bb.aF;
          }
        } else if ((ba.aF < bb.aF)) {
          bb.aJ = ba.aF;
        } else {
          bb.aF = ba.aJ;
        }
      } else if (((ba.bG - ba.bZ) > (bb.bG - bb.bZ))) {
        if ((ba.bG < bb.bG)) {
          ba.bG = bb.bZ;
        } else {
          ba.bZ = bb.bG;
        }
      } else if ((ba.bG < bb.bG)) {
        bb.bZ = ba.bG;
      } else {
        bb.bG = ba.bZ;
      }
    }
    bi = ((1 + bi) | 0);
  }
  var b0 = boxes0.l(0);
  if (((((st.a[0] < b0.aJ) || (st.a[0] > b0.aF)) || (st.a[1] < b0.bZ)) || (st.a[1] > b0.bG))) {
    var x$2 = st.a[0];
    var y = b0.aJ;
    var x$3 = (+Math.max(x$2, y));
    var y$1 = b0.aF;
    st.a[0] = (+Math.min(x$3, y$1));
    var x$4 = st.a[1];
    var y$2 = b0.bZ;
    var x$5 = (+Math.max(x$4, y$2));
    var y$3 = b0.bG;
    st.a[1] = (+Math.min(x$5, y$3));
  }
  var bn = boxes0.l(((n - 1) | 0));
  if (((((en.a[0] < bn.aJ) || (en.a[0] > bn.aF)) || (en.a[1] < bn.bZ)) || (en.a[1] > bn.bG))) {
    var x$6 = en.a[0];
    var y$4 = bn.aJ;
    var x$7 = (+Math.max(x$6, y$4));
    var y$5 = bn.aF;
    en.a[0] = (+Math.min(x$7, y$5));
    var x$8 = en.a[1];
    var y$6 = bn.bZ;
    var x$9 = (+Math.max(x$8, y$6));
    var y$7 = bn.bG;
    en.a[1] = (+Math.min(x$9, y$7));
  }
  return false;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__overlap__D__D__D__D__D($thiz, i0, i1, j0, j1) {
  return (((i1 <= j0) || (i0 >= j1)) ? 0.0 : (((i0 <= j0) && (i1 >= j1)) ? (i1 - i0) : (((j0 <= i0) && (j1 >= i1)) ? (j1 - j0) : (((j0 <= i0) && (i0 <= j1)) ? (j1 - i0) : (i1 - j0)))));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__buildPolygon__scm_ArrayBuffer__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($thiz, boxes) {
  var n = boxes.a1;
  $m_scm_ArrayBuffer$();
  var pts = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  var bi = 0;
  while ((bi < n)) {
    matchResult68: {
      var \u03b424$___1;
      var \u03b424$___2;
      var x235 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__prevNext$1__scm_ArrayBuffer__I__I__T2($thiz, boxes, n, bi);
      if ((x235 !== null)) {
        var \u03b424$___1 = (x235.g() | 0);
        var \u03b424$___2 = (x235.h() | 0);
        break matchResult68;
      }
      throw new $c_s_MatchError(x235);
    }
    var prev$2 = (\u03b424$___1 | 0);
    var next$2 = (\u03b424$___2 | 0);
    if ((prev$2 !== next$2)) {
      if (((next$2 === (-1)) || (prev$2 === 1))) {
        pts.aw(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(boxes.l(bi).aJ, boxes.l(bi).bG));
        pts.aw(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(boxes.l(bi).aJ, boxes.l(bi).bZ));
      } else {
        pts.aw(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(boxes.l(bi).aF, boxes.l(bi).bZ));
        pts.aw(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(boxes.l(bi).aF, boxes.l(bi).bG));
      }
    } else if ((prev$2 === 0)) {
      pts.aw(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(boxes.l(bi).aJ, boxes.l(bi).bG));
      pts.aw(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(boxes.l(bi).aJ, boxes.l(bi).bZ));
    }
    bi = ((1 + bi) | 0);
  }
  bi = ((n - 1) | 0);
  while ((bi >= 0)) {
    var prev$3 = ((((1 + bi) | 0) < n) ? ((boxes.l(bi).bZ > boxes.l(((1 + bi) | 0)).bZ) ? (-1) : 1) : 0);
    var next$3 = ((bi > 0) ? ((boxes.l(((bi - 1) | 0)).bZ > boxes.l(bi).bZ) ? 1 : (-1)) : 0);
    if ((prev$3 !== next$3)) {
      if (((next$3 === (-1)) || (prev$3 === 1))) {
        pts.aw(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(boxes.l(bi).aJ, boxes.l(bi).bG));
        pts.aw(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(boxes.l(bi).aJ, boxes.l(bi).bZ));
      } else {
        pts.aw(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(boxes.l(bi).aF, boxes.l(bi).bZ));
        pts.aw(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(boxes.l(bi).aF, boxes.l(bi).bG));
      }
    } else if ((prev$3 === 0)) {
      pts.aw(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(boxes.l(bi).aF, boxes.l(bi).bZ));
      pts.aw(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(boxes.l(bi).aF, boxes.l(bi).bG));
    } else {
      pts.aw(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(boxes.l(bi).aF, boxes.l(bi).bZ));
      pts.aw(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(boxes.l(bi).aF, boxes.l(bi).bG));
      pts.aw(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(boxes.l(bi).aJ, boxes.l(bi).bG));
      pts.aw(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(boxes.l(bi).aJ, boxes.l(bi).bZ));
    }
    bi = ((bi - 1) | 0);
  }
  if ((pts.a1 >= 0)) {
    var destination = new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY.r().C)(pts.a1);
    pts.cR(destination, 0, 2147483647);
    return destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = pts.bB().o();
    while (it.p()) {
      var elem$16 = it.q();
      var unboxedElem = ((elem$16 === null) ? null : elem$16);
      jsElems.push(unboxedElem);
    }
    return new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY.r().C)(jsElems);
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__funnel__scm_ArrayBuffer__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__sci_Vector($thiz, boxes, s, e) {
  $m_scm_ArrayBuffer$();
  var gates = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  gates.aw(new $c_T2(s, s));
  var k = 0;
  while ((((1 + k) | 0) < boxes.a1)) {
    var a = boxes.l(k);
    var b = boxes.l(((1 + k) | 0));
    var y = a.bZ;
    var x = a.aJ;
    var y$1 = b.aJ;
    var $x_1 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY((+Math.max(x, y$1)), y);
    var x$1 = a.aF;
    var y$2 = b.aF;
    gates.aw(new $c_T2($x_1, new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY((+Math.min(x$1, y$2)), y)));
    k = ((1 + k) | 0);
  }
  gates.aw(new $c_T2(e, e));
  if ((gates.a1 >= 0)) {
    var destination = new ($d_T2.r().C)(gates.a1);
    gates.cR(destination, 0, 2147483647);
    var $x_2 = destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = gates.bB().o();
    while (it.p()) {
      var elem$3 = it.q();
      var unboxedElem = ((elem$3 === null) ? null : elem$3);
      jsElems.push(unboxedElem);
    }
    var $x_2 = new ($d_T2.r().C)(jsElems);
  }
  return $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__funnelCore__AT2__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__sci_Vector($thiz, $x_2, e);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__funnelGeneral__scm_ArrayBuffer__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__sci_Vector($thiz, boxes, s, e) {
  $m_scm_ArrayBuffer$();
  var gates = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  gates.aw(new $c_T2(s, s));
  var k = 0;
  while ((((1 + k) | 0) < boxes.a1)) {
    var a = boxes.l(k);
    var b = boxes.l(((1 + k) | 0));
    var x = a.aJ;
    var y = b.aJ;
    var xlo = (+Math.max(x, y));
    var x$1 = a.aF;
    var y$1 = b.aF;
    var xhi = (+Math.min(x$1, y$1));
    var x$2 = a.bZ;
    var y$2 = b.bZ;
    var ylo = (+Math.max(x$2, y$2));
    var x$3 = a.bG;
    var y$3 = b.bG;
    var yhi = (+Math.min(x$3, y$3));
    if (((yhi - ylo) <= (xhi - xlo))) {
      var y$4 = (0.5 * (ylo + yhi));
      var \u03b425$___1 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(xlo, y$4);
      var \u03b425$___2 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(xhi, y$4);
    } else {
      var x$4 = (0.5 * (xlo + xhi));
      var \u03b425$___1 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(x$4, ylo);
      var \u03b425$___2 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(x$4, yhi);
    }
    var p = \u03b425$___1;
    var q = \u03b425$___2;
    var dx = (0.5 * (((b.aJ + b.aF) - a.aJ) - a.aF));
    var dy = (0.5 * (((b.bZ + b.bG) - a.bZ) - a.bG));
    gates.aw(((((dy * p.W) - (dx * p.a6)) >= ((dy * q.W) - (dx * q.a6))) ? new $c_T2(p, q) : new $c_T2(q, p)));
    k = ((1 + k) | 0);
  }
  gates.aw(new $c_T2(e, e));
  if ((gates.a1 >= 0)) {
    var destination = new ($d_T2.r().C)(gates.a1);
    gates.cR(destination, 0, 2147483647);
    var $x_1 = destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = gates.bB().o();
    while (it.p()) {
      var elem$3 = it.q();
      var unboxedElem = ((elem$3 === null) ? null : elem$3);
      jsElems.push(unboxedElem);
    }
    var $x_1 = new ($d_T2.r().C)(jsElems);
  }
  return $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__funnelCore__AT2__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__sci_Vector($thiz, $x_1, e);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__funnelCore__AT2__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__sci_Vector($thiz, portals, e) {
  var pts = $m_scm_ArrayBuffer$().y9($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY.r().C)([portals.a[0].g()])));
  var apex = portals.a[0].g();
  var pL = portals.a[0].g();
  var pR = portals.a[0].h();
  var apexI = 0;
  var lI = 0;
  var rI = 0;
  var i = 1;
  while ((i < portals.a.length)) {
    var L = portals.a[i].g();
    var R = portals.a[i].h();
    var restart = false;
    if (($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__triArea2$1__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__D($thiz, apex, pR, R) <= 0.0)) {
      if (($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__eq$1__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Z($thiz, apex, pR) || ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__triArea2$1__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__D($thiz, apex, pL, R) > 0.0))) {
        pR = R;
        rI = i;
      } else {
        pts.aw(pL);
        apex = pL;
        apexI = lI;
        pL = apex;
        pR = apex;
        lI = apexI;
        rI = apexI;
        i = ((1 + apexI) | 0);
        restart = true;
      }
    }
    if ((!restart)) {
      if (($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__triArea2$1__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__D($thiz, apex, pL, L) >= 0.0)) {
        if (($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__eq$1__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Z($thiz, apex, pL) || ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__triArea2$1__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__D($thiz, apex, pR, L) < 0.0))) {
          pL = L;
          lI = i;
        } else {
          pts.aw(pR);
          apex = pR;
          apexI = rI;
          pL = apex;
          pR = apex;
          lI = apexI;
          rI = apexI;
          i = ((1 + apexI) | 0);
          restart = true;
        }
      }
      if ((!restart)) {
        i = ((1 + i) | 0);
      }
    }
  }
  if (($f_sc_SeqOps__isEmpty__Z(pts) || (!$p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__eq$1__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Z($thiz, $f_sc_IndexedSeqOps__last__O(pts), e)))) {
    pts.aw(e);
  }
  return $m_sci_Vector$().X(pts);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__proutespline__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__sci_Vector__sci_Vector($thiz, poly, pl) {
  return $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__proutespline__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__sci_Vector($thiz, poly, pl, new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(0.0, 0.0), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(0.0, 0.0));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__proutespline__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__sci_Vector($thiz, poly, pl, ev0, ev1) {
  var n = poly.a.length;
  if ((n <= 0)) {
    var edges = new ($d_T2.r().C)(0);
  } else {
    var array = new ($d_T2.r().C)(n);
    var i = 0;
    while ((i < n)) {
      var $x_1 = i;
      var x0 = i;
      array.a[$x_1] = new $c_T2(poly.a[x0], poly.a[((((1 + x0) | 0) % $checkIntDivisor(poly.a.length)) | 0)]);
      i = ((1 + i) | 0);
    }
    var edges = array;
  }
  if ((pl.C() >= 0)) {
    var destination = new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY.r().C)(pl.C());
    pl.o().cR(destination, 0, 2147483647);
    var inps = destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = pl.o();
    while (it.p()) {
      var elem = it.q();
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem);
    }
    var inps = new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY.r().C)(jsElems);
  }
  $m_scm_ArrayBuffer$();
  var ops = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  ops.aw(inps.a[0]);
  $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__reallyRoute__AT2__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__I__I__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__scm_ArrayBuffer__V($thiz, edges, inps, 0, inps.a.length, $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__normv__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($thiz, ev0), $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__normv__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($thiz, ev1), ops);
  return $m_sci_Vector$().X(ops);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__vsub__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($thiz, a, b) {
  return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY((a.W - b.W), (a.a6 - b.a6));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__vadd__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($thiz, a, b) {
  return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY((a.W + b.W), (a.a6 + b.a6));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__vscale__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__D__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($thiz, a, c) {
  return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY((a.W * c), (a.a6 * c));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__vdot__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__D($thiz, a, b) {
  return ((a.W * b.W) + (a.a6 * b.a6));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__vdist__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__D($thiz, a, b) {
  return $m_jl_Math$().ga((b.W - a.W), (b.a6 - a.a6));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__normv__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($thiz, v) {
  var d = ((v.W * v.W) + (v.a6 * v.a6));
  if ((d > 1.0E-6)) {
    var s = (+Math.sqrt(d));
    return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY((v.W / s), (v.a6 / s));
  } else {
    return v;
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__b0__D__D($thiz, t) {
  var u = (1.0 - t);
  return ((u * u) * u);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__b1__D__D($thiz, t) {
  var u = (1.0 - t);
  return (((3.0 * t) * u) * u);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__b2__D__D($thiz, t) {
  return (((3.0 * t) * t) * (1.0 - t));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__b3__D__D($thiz, t) {
  return ((t * t) * t);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__b01__D__D($thiz, t) {
  var u = (1.0 - t);
  return ((u * u) * (u + (3.0 * t)));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__b23__D__D($thiz, t) {
  return ((t * t) * ((3.0 * (1.0 - t)) + t));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__reallyRoute__AT2__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__I__I__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__scm_ArrayBuffer__V($thiz, edges, inps, off, inpn, ev0, ev1, ops) {
  var ev0$tailLocal1 = ev0;
  var inpn$tailLocal1 = inpn;
  var off$tailLocal1 = off;
  while (true) {
    var t = new $ac_D(inpn$tailLocal1);
    t.a[0] = 0.0;
    var i = 1;
    while ((i < inpn$tailLocal1)) {
      t.a[i] = (t.a[((i - 1) | 0)] + $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__vdist__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__D($thiz, inps.a[((off$tailLocal1 + i) | 0)], inps.a[((((off$tailLocal1 + i) | 0) - 1) | 0)]));
      i = ((1 + i) | 0);
    }
    i = 1;
    var tot = t.a[((inpn$tailLocal1 - 1) | 0)];
    while ((i < inpn$tailLocal1)) {
      if ((tot !== 0.0)) {
        t.a[i] = (t.a[i] / tot);
      }
      i = ((1 + i) | 0);
    }
    var n = inpn$tailLocal1;
    var ev0$tailLocal1$2 = ev0$tailLocal1;
    if ((n <= 0)) {
      var a0 = new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY.r().C)(0);
    } else {
      var array = new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY.r().C)(n);
      var i$1 = 0;
      while ((i$1 < n)) {
        var $x_1 = i$1;
        var x0 = i$1;
        array.a[$x_1] = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__vscale__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__D__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($m_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$(), ev0$tailLocal1$2, $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__b1__D__D($m_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$(), t.a[x0]));
        i$1 = ((1 + i$1) | 0);
      }
      var a0 = array;
    }
    var n$1 = inpn$tailLocal1;
    if ((n$1 <= 0)) {
      var a1 = new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY.r().C)(0);
    } else {
      var array$1 = new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY.r().C)(n$1);
      var i$2 = 0;
      while ((i$2 < n$1)) {
        var $x_2 = i$2;
        var x0$1 = i$2;
        array$1.a[$x_2] = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__vscale__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__D__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($m_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$(), ev1, $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__b2__D__D($m_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$(), t.a[x0$1]));
        i$2 = ((1 + i$2) | 0);
      }
      var a1 = array$1;
    }
    matchResult69: {
      var \u03b426$___1;
      var \u03b426$___2;
      var \u03b426$___3;
      var \u03b426$___4;
      var x238 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__mkspline__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__I__I__AD__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__T4($thiz, inps, off$tailLocal1, inpn$tailLocal1, t, a0, a1, ev0$tailLocal1, ev1);
      if ((x238 !== null)) {
        var \u03b426$___1 = x238.bO;
        var \u03b426$___2 = x238.bs;
        var \u03b426$___3 = x238.ch;
        var \u03b426$___4 = x238.ca;
        break matchResult69;
      }
      throw new $c_s_MatchError(x238);
    }
    var p1$2 = \u03b426$___1;
    var v1$2 = \u03b426$___2;
    var p2$2 = \u03b426$___3;
    var v2$2 = \u03b426$___4;
    if (($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__splinefits__AT2__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__I__I__scm_ArrayBuffer__I($thiz, edges, p1$2, v1$2, p2$2, v2$2, inps, off$tailLocal1, inpn$tailLocal1, ops) <= 0)) {
      var cp1 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__vadd__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($thiz, p1$2, $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__vscale__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__D__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($thiz, v1$2, 0.3333333333333333));
      var cp2 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__vsub__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($thiz, p2$2, $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__vscale__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__D__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($thiz, v2$2, 0.3333333333333333));
      var maxd = (-1.0);
      var maxi = (-1);
      i = 1;
      while ((i < ((inpn$tailLocal1 - 1) | 0))) {
        var tt = t.a[i];
        var px = (((($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__b0__D__D($thiz, tt) * p1$2.W) + ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__b1__D__D($thiz, tt) * cp1.W)) + ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__b2__D__D($thiz, tt) * cp2.W)) + ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__b3__D__D($thiz, tt) * p2$2.W));
        var py = (((($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__b0__D__D($thiz, tt) * p1$2.a6) + ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__b1__D__D($thiz, tt) * cp1.a6)) + ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__b2__D__D($thiz, tt) * cp2.a6)) + ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__b3__D__D($thiz, tt) * p2$2.a6));
        var d = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__vdist__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__D($thiz, new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(px, py), inps.a[((off$tailLocal1 + i) | 0)]);
        if ((d > maxd)) {
          maxd = d;
          maxi = i;
        }
        i = ((1 + i) | 0);
      }
      var sp = maxi;
      var sv1 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__normv__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($thiz, $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__vsub__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($thiz, inps.a[((off$tailLocal1 + sp) | 0)], inps.a[((((off$tailLocal1 + sp) | 0) - 1) | 0)]));
      var sv2 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__normv__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($thiz, $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__vsub__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($thiz, inps.a[((1 + ((off$tailLocal1 + sp) | 0)) | 0)], inps.a[((off$tailLocal1 + sp) | 0)]));
      var sv = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__normv__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($thiz, $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__vadd__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($thiz, sv1, sv2));
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__reallyRoute__AT2__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__I__I__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__scm_ArrayBuffer__V($thiz, edges, inps, off$tailLocal1, ((1 + sp) | 0), ev0$tailLocal1, sv, ops);
      var off$tailLocal1$tmp1 = ((off$tailLocal1 + sp) | 0);
      var inpn$tailLocal1$tmp1 = ((inpn$tailLocal1 - sp) | 0);
      off$tailLocal1 = off$tailLocal1$tmp1;
      inpn$tailLocal1 = inpn$tailLocal1$tmp1;
      ev0$tailLocal1 = sv;
    } else {
      return (void 0);
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__mkspline__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__I__I__AD__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__T4($thiz, inps, off, inpn, t, a0, a1, ev0, ev1) {
  var c00 = 0.0;
  var c01 = 0.0;
  var c11 = 0.0;
  var x0 = 0.0;
  var x1 = 0.0;
  var i = 0;
  while ((i < inpn)) {
    c00 = (c00 + $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__vdot__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__D($thiz, a0.a[i], a0.a[i]));
    c01 = (c01 + $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__vdot__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__D($thiz, a0.a[i], a1.a[i]));
    c11 = (c11 + $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__vdot__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__D($thiz, a1.a[i], a1.a[i]));
    var tmp = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__vsub__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($thiz, inps.a[((off + i) | 0)], $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__vadd__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($thiz, $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__vscale__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__D__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($thiz, inps.a[off], $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__b01__D__D($thiz, t.a[i])), $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__vscale__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__D__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($thiz, inps.a[((((off + inpn) | 0) - 1) | 0)], $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__b23__D__D($thiz, t.a[i]))));
    x0 = (x0 + $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__vdot__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__D($thiz, a0.a[i], tmp));
    x1 = (x1 + $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__vdot__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__D($thiz, a1.a[i], tmp));
    i = ((1 + i) | 0);
  }
  var det01 = ((c00 * c11) - (c01 * c01));
  var det0X = ((c00 * x1) - (c01 * x0));
  var detX1 = ((x0 * c11) - (x1 * c01));
  var s0 = 0.0;
  var s3 = 0.0;
  if (((+Math.abs(det01)) >= 1.0E-6)) {
    s0 = (detX1 / det01);
    s3 = (det0X / det01);
  }
  if (((((+Math.abs(det01)) < 1.0E-6) || (s0 <= 0.0)) || (s3 <= 0.0))) {
    var d01 = ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__vdist__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__D($thiz, inps.a[off], inps.a[((((off + inpn) | 0) - 1) | 0)]) / 3.0);
    s0 = d01;
    s3 = d01;
  }
  return new $c_T4(inps.a[off], $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__vscale__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__D__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($thiz, ev0, s0), inps.a[((((off + inpn) | 0) - 1) | 0)], $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__vscale__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__D__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($thiz, ev1, s3));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__distN__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__D($thiz, p) {
  var rv = 0.0;
  var i = 1;
  while ((i < p.a.length)) {
    rv = (rv + $m_jl_Math$().ga((p.a[i].W - p.a[((i - 1) | 0)].W), (p.a[i].a6 - p.a[((i - 1) | 0)].a6)));
    i = ((1 + i) | 0);
  }
  return rv;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__splinefits__AT2__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__I__I__scm_ArrayBuffer__I($thiz, edges, pa, va, pb, vb, inps, off, inpn, ops) {
  var forceflag = (inpn === 2);
  var a = 4.0;
  var first = true;
  var result = (-2);
  var inpsSeg = $m_sc_ArrayOps$().ls(inps, off, ((off + inpn) | 0));
  while ((result === (-2))) {
    var sps = new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY.r().C)([pa, new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY((pa.W + ((a * va.W) / 3.0)), (pa.a6 + ((a * va.a6) / 3.0))), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY((pb.W - ((a * vb.W) / 3.0)), (pb.a6 - ((a * vb.a6) / 3.0))), pb]);
    if ((first && ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__distN__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__D($thiz, sps) < ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__distN__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__D($thiz, inpsSeg) - 0.001)))) {
      result = 0;
    } else {
      first = false;
      if ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__splineIsInside__AT2__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Z($thiz, edges, sps)) {
        ops.aw(sps.a[1]);
        ops.aw(sps.a[2]);
        ops.aw(sps.a[3]);
        result = 1;
      } else if ((a < 0.005)) {
        if (forceflag) {
          ops.aw(sps.a[1]);
          ops.aw(sps.a[2]);
          ops.aw(sps.a[3]);
          result = 1;
        } else {
          result = 0;
        }
      } else if ((a > 0.01)) {
        a = (0.5 * a);
      } else {
        a = 0.0;
      }
    }
  }
  return result;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__splineIsInside__AT2__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Z($thiz, edges, sps) {
  var ei = 0;
  while ((ei < edges.a.length)) {
    matchResult70: {
      var \u03b427$___1;
      var \u03b427$___2;
      var x243 = edges.a[ei];
      if ((x243 !== null)) {
        var \u03b427$___1 = x243.g();
        var \u03b427$___2 = x243.h();
        break matchResult70;
      }
      throw new $c_s_MatchError(x243);
    }
    var la$2 = \u03b427$___1;
    var lb$2 = \u03b427$___2;
    var roots = new $ac_D(4);
    var rootn = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__splineIntersectsLine__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__AD__I($thiz, sps, la$2, lb$2, roots);
    if ((rootn !== 4)) {
      var ri = 0;
      while ((ri < rootn)) {
        var tt = roots.a[ri];
        if (((tt >= 1.0E-6) && (tt <= 0.999999))) {
          var td = ((tt * tt) * tt);
          var tc = (((3.0 * tt) * tt) * (1.0 - tt));
          var tb = (((3.0 * tt) * (1.0 - tt)) * (1.0 - tt));
          var ta = (((1.0 - tt) * (1.0 - tt)) * (1.0 - tt));
          var ipx = ((((ta * sps.a[0].W) + (tb * sps.a[1].W)) + (tc * sps.a[2].W)) + (td * sps.a[3].W));
          var ipy = ((((ta * sps.a[0].a6) + (tb * sps.a[1].a6)) + (tc * sps.a[2].a6)) + (td * sps.a[3].a6));
          var d0 = (((ipx - la$2.W) * (ipx - la$2.W)) + ((ipy - la$2.a6) * (ipy - la$2.a6)));
          var d1 = (((ipx - lb$2.W) * (ipx - lb$2.W)) + ((ipy - lb$2.a6) * (ipy - lb$2.a6)));
          if (((d0 >= 0.001) && (d1 >= 0.001))) {
            return false;
          }
        }
        ri = ((1 + ri) | 0);
      }
    }
    ei = ((1 + ei) | 0);
  }
  return true;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__points2coeff__D__D__D__D__AD($thiz, v0, v1, v2, v3) {
  return new $ac_D(new Float64Array([v0, (3.0 * (v1 - v0)), (((3.0 * v0) + (3.0 * v2)) - (6.0 * v1)), ((v3 + (3.0 * v1)) - (v0 + (3.0 * v2)))]));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__addRoot__D__AD__I__I($thiz, root, roots, rootn) {
  if (((root >= 0.0) && (root <= 1.0))) {
    roots.a[rootn] = root;
    return ((1 + rootn) | 0);
  } else {
    return rootn;
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__splineIntersectsLine__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__AD__I($thiz, sps, l0, l1, roots) {
  var xc0 = l0.W;
  var xc1 = (l1.W - l0.W);
  var yc0 = l0.a6;
  var yc1 = (l1.a6 - l0.a6);
  var rootn = 0;
  if ((xc1 === 0.0)) {
    if ((yc1 === 0.0)) {
      var s1 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__points2coeff__D__D__D__D__AD($thiz, sps.a[0].W, sps.a[1].W, sps.a[2].W, sps.a[3].W);
      s1.a[0] = (s1.a[0] - xc0);
      var xr = new $ac_D(3);
      var xn = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__solve3__AD__AD__I($thiz, s1, xr);
      var s2 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__points2coeff__D__D__D__D__AD($thiz, sps.a[0].a6, sps.a[1].a6, sps.a[2].a6, sps.a[3].a6);
      s2.a[0] = (s2.a[0] - yc0);
      var yr = new $ac_D(3);
      var yn = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__solve3__AD__AD__I($thiz, s2, yr);
      if ((xn === 4)) {
        if ((yn === 4)) {
          return 4;
        } else {
          var j = 0;
          while ((j < yn)) {
            rootn = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__addRoot__D__AD__I__I($thiz, yr.a[j], roots, rootn);
            j = ((1 + j) | 0);
          }
        }
      } else if ((yn === 4)) {
        var k = 0;
        while ((k < xn)) {
          rootn = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__addRoot__D__AD__I__I($thiz, xr.a[k], roots, rootn);
          k = ((1 + k) | 0);
        }
      } else {
        var k$2 = 0;
        while ((k$2 < xn)) {
          var j$2 = 0;
          while ((j$2 < yn)) {
            if ((xr.a[k$2] === yr.a[j$2])) {
              rootn = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__addRoot__D__AD__I__I($thiz, xr.a[k$2], roots, rootn);
            }
            j$2 = ((1 + j$2) | 0);
          }
          k$2 = ((1 + k$2) | 0);
        }
      }
      return rootn;
    } else {
      var s1$2 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__points2coeff__D__D__D__D__AD($thiz, sps.a[0].W, sps.a[1].W, sps.a[2].W, sps.a[3].W);
      s1$2.a[0] = (s1$2.a[0] - xc0);
      var xr$2 = new $ac_D(3);
      var xn$2 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__solve3__AD__AD__I($thiz, s1$2, xr$2);
      if ((xn$2 === 4)) {
        return 4;
      }
      var k$3 = 0;
      while ((k$3 < xn$2)) {
        var tv = xr$2.a[k$3];
        if (((tv >= 0.0) && (tv <= 1.0))) {
          var s2$2 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__points2coeff__D__D__D__D__AD($thiz, sps.a[0].a6, sps.a[1].a6, sps.a[2].a6, sps.a[3].a6);
          var sv0 = (s2$2.a[0] + (tv * (s2$2.a[1] + (tv * (s2$2.a[2] + (tv * s2$2.a[3]))))));
          var sv = ((sv0 - yc0) / yc1);
          if (((sv >= 0.0) && (sv <= 1.0))) {
            rootn = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__addRoot__D__AD__I__I($thiz, tv, roots, rootn);
          }
        }
        k$3 = ((1 + k$3) | 0);
      }
      return rootn;
    }
  } else {
    var rat = (yc1 / xc1);
    var s1$3 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__points2coeff__D__D__D__D__AD($thiz, (sps.a[0].a6 - (rat * sps.a[0].W)), (sps.a[1].a6 - (rat * sps.a[1].W)), (sps.a[2].a6 - (rat * sps.a[2].W)), (sps.a[3].a6 - (rat * sps.a[3].W)));
    s1$3.a[0] = (s1$3.a[0] + ((rat * xc0) - yc0));
    var xr$3 = new $ac_D(3);
    var xn$3 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__solve3__AD__AD__I($thiz, s1$3, xr$3);
    if ((xn$3 === 4)) {
      return 4;
    }
    var k$4 = 0;
    while ((k$4 < xn$3)) {
      var tv$2 = xr$3.a[k$4];
      if (((tv$2 >= 0.0) && (tv$2 <= 1.0))) {
        var s2$3 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__points2coeff__D__D__D__D__AD($thiz, sps.a[0].W, sps.a[1].W, sps.a[2].W, sps.a[3].W);
        var sv0$2 = (s2$3.a[0] + (tv$2 * (s2$3.a[1] + (tv$2 * (s2$3.a[2] + (tv$2 * s2$3.a[3]))))));
        var sv$2 = ((sv0$2 - xc0) / xc1);
        if (((sv$2 >= 0.0) && (sv$2 <= 1.0))) {
          rootn = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__addRoot__D__AD__I__I($thiz, tv$2, roots, rootn);
        }
      }
      k$4 = ((1 + k$4) | 0);
    }
    return rootn;
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__aeq0__D__Z($thiz, x) {
  return ((x < $thiz.a84) && (x > (-$thiz.a84)));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__solve3__AD__AD__I($thiz, coeff, roots) {
  var a = coeff.a[3];
  var b = coeff.a[2];
  var c = coeff.a[1];
  var d = coeff.a[0];
  if ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__aeq0__D__Z($thiz, a)) {
    return $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__solve2__AD__AD__I($thiz, coeff, roots);
  }
  var b3a = (b / (3.0 * a));
  var ca = (c / a);
  var da = (d / a);
  var p = (b3a * b3a);
  var q = ((((2.0 * b3a) * p) - (b3a * ca)) + da);
  p = ((ca / 3.0) - p);
  var disc = ((q * q) + (((4.0 * p) * p) * p));
  var rootn = 0;
  if ((disc < 0.0)) {
    var x = ((-disc) + (q * q));
    var r = (0.5 * (+Math.sqrt(x)));
    var x$1 = (-disc);
    var y = (+Math.sqrt(x$1));
    var x$2 = (-q);
    var theta = (+Math.atan2(y, x$2));
    var temp = (2.0 * $m_jl_Math$().a2R(r));
    var x$3 = (theta / 3.0);
    roots.a[0] = (temp * (+Math.cos(x$3)));
    var x$4 = ((theta + 6.283185307179586) / 3.0);
    roots.a[1] = (temp * (+Math.cos(x$4)));
    var x$5 = ((theta - 6.283185307179586) / 3.0);
    roots.a[2] = (temp * (+Math.cos(x$5)));
    rootn = 3;
  } else {
    var alpha = (0.5 * ((+Math.sqrt(disc)) - q));
    var beta = ((-q) - alpha);
    roots.a[0] = ($m_jl_Math$().a2R(alpha) + $m_jl_Math$().a2R(beta));
    if ((disc > 0.0)) {
      rootn = 1;
    } else {
      roots.a[1] = ((-0.5) * roots.a[0]);
      roots.a[2] = roots.a[1];
      rootn = 3;
    }
  }
  var i = 0;
  while ((i < rootn)) {
    var i$1 = i;
    roots.a[i$1] = (roots.a[i$1] - b3a);
    i = ((1 + i) | 0);
  }
  return rootn;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__solve2__AD__AD__I($thiz, coeff, roots) {
  var a = coeff.a[2];
  var b = coeff.a[1];
  var c = coeff.a[0];
  if ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__aeq0__D__Z($thiz, a)) {
    return $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__solve1__AD__AD__I($thiz, coeff, roots);
  }
  var b2a = (b / (2.0 * a));
  var ca = (c / a);
  var disc = ((b2a * b2a) - ca);
  if ((disc < 0.0)) {
    return 0;
  } else if ((disc > 0.0)) {
    roots.a[0] = ((-b2a) + (+Math.sqrt(disc)));
    roots.a[1] = (((-2.0) * b2a) - roots.a[0]);
    return 2;
  } else {
    roots.a[0] = (-b2a);
    return 1;
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__solve1__AD__AD__I($thiz, coeff, roots) {
  var a = coeff.a[1];
  var b = coeff.a[0];
  if ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__aeq0__D__Z($thiz, a)) {
    return ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__aeq0__D__Z($thiz, b) ? 4 : 0);
  } else {
    roots.a[0] = ((-b) / a);
    return 1;
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__bezier__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__I__D__T3($thiz, v, s, t) {
  var tri = $m_jl_reflect_Array$().m0($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY.l(), new $ac_I(new Int32Array([4, 4])));
  var j = 0;
  while ((j <= 3)) {
    tri.a[0].a[j] = v.a[((s + j) | 0)];
    j = ((1 + j) | 0);
  }
  var i = 1;
  while ((i <= 3)) {
    j = 0;
    while ((j <= ((3 - i) | 0))) {
      tri.a[i].a[j] = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY((((1.0 - t) * tri.a[((i - 1) | 0)].a[j].W) + (t * tri.a[((i - 1) | 0)].a[((1 + j) | 0)].W)), (((1.0 - t) * tri.a[((i - 1) | 0)].a[j].a6) + (t * tri.a[((i - 1) | 0)].a[((1 + j) | 0)].a6)));
      j = ((1 + j) | 0);
    }
    i = ((1 + i) | 0);
  }
  var left = new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY.r().C)([tri.a[0].a[0], tri.a[1].a[0], tri.a[2].a[0], tri.a[3].a[0]]);
  var right = new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY.r().C)([tri.a[3].a[0], tri.a[2].a[1], tri.a[1].a[2], tri.a[0].a[3]]);
  return new $c_T3(tri.a[3].a[0], left, right);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__clipInstall__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_model_REdge__sci_Map__F1__Z__Z__Z__s_Option__s_Option__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$ESpline($thiz, g, ctrl0, e, byId, centerOf, tailClip, headClip, reversedWork, tailBp, headBp) {
  if (((ctrl0.C() >= 4) && (((((ctrl0.C() - 1) | 0) % 3) | 0) === 0))) {
    if ((ctrl0.C() >= 0)) {
      var destination = new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY.r().C)(ctrl0.C());
      ctrl0.o().cR(destination, 0, 2147483647);
      var ps = destination;
    } else {
      var capacity = 0;
      var size = 0;
      var jsElems = null;
      capacity = 0;
      size = 0;
      jsElems = [];
      var it = ctrl0.o();
      while (it.p()) {
        var elem = it.q();
        var unboxedElem = ((elem === null) ? null : elem);
        jsElems.push(unboxedElem);
      }
      var ps = new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY.r().C)(jsElems);
    }
  } else {
    var s = ctrl0.t();
    var t = ctrl0.bJ();
    var ps = new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY.r().C)([s, new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY((s.W + ((t.W - s.W) / 3.0)), (s.a6 + ((t.a6 - s.a6) / 3.0))), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY((s.W + ((2.0 * (t.W - s.W)) / 3.0)), (s.a6 + ((2.0 * (t.a6 - s.a6)) / 3.0))), t]);
  }
  var pn = ps.a.length;
  var startNodeId = (reversedWork ? e.ak : e.ai);
  var endNodeId = (reversedWork ? e.ai : e.ak);
  var elem$1 = 0;
  elem$1 = 0;
  if (tailClip) {
    var this$9 = (tailBp.c() ? $m_s_None$() : new $c_s_Some(new $c_s_Some($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__bpInsideFn$1__F1__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__T__T4__F1($thiz, centerOf, g, byId, startNodeId, tailBp.d()))));
    var this$10 = (this$9.c() ? $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__insideFn$1__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__F1__T__s_Option($thiz, byId, g, centerOf, startNodeId) : this$9.d());
    if ((!this$10.c())) {
      var x0$1 = this$10.d();
      var s$1 = 0;
      var stop = false;
      while (((!stop) && (s$1 < ((pn - 4) | 0)))) {
        if ((!(!(!x0$1.i(ps.a[((3 + s$1) | 0)]))))) {
          stop = true;
        } else {
          s$1 = ((3 + s$1) | 0);
        }
      }
      elem$1 = s$1;
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__shapeClip0$1__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__I__F1__Z__V($thiz, ps, elem$1, x0$1, true);
    }
  }
  var elem$2 = ((pn - 4) | 0);
  var elem$3 = 0;
  elem$3 = elem$2;
  if (headClip) {
    var this$13 = (headBp.c() ? $m_s_None$() : new $c_s_Some(new $c_s_Some($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__bpInsideFn$1__F1__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__T__T4__F1($thiz, centerOf, g, byId, endNodeId, headBp.d()))));
    var this$14 = (this$13.c() ? $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__insideFn$1__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__F1__T__s_Option($thiz, byId, g, centerOf, endNodeId) : this$13.d());
    if ((!this$14.c())) {
      var x0$3 = this$14.d();
      var en = ((pn - 4) | 0);
      var stop$1 = false;
      while (((!stop$1) && (en > 0))) {
        if ((!(!(!x0$3.i(ps.a[en]))))) {
          stop$1 = true;
        } else {
          en = ((en - 3) | 0);
        }
      }
      elem$3 = en;
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__shapeClip0$1__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__I__F1__Z__V($thiz, ps, elem$3, x0$3, false);
    }
  }
  while (((elem$1 < ((pn - 4) | 0)) && $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__approxEq$1__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Z($thiz, ps.a[elem$1], ps.a[((3 + elem$1) | 0)]))) {
    elem$1 = ((3 + elem$1) | 0);
  }
  while (((elem$3 > 0) && $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__approxEq$1__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Z($thiz, ps.a[elem$3], ps.a[((3 + elem$3) | 0)]))) {
    elem$3 = ((elem$3 - 3) | 0);
  }
  matchResult80: {
    var \u03b429$___1;
    var \u03b429$___2;
    var x276 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$().aOc(g.z6, e.b4.ag.r("dir"), e.b4.ag.r("arrowhead"), e.b4.ag.r("arrowtail"));
    if ((x276 !== null)) {
      var \u03b429$___1 = (x276.g() | 0);
      var \u03b429$___2 = (x276.h() | 0);
      break matchResult80;
    }
    throw new $c_s_MatchError(x276);
  }
  var sflagO$2 = (\u03b429$___1 | 0);
  var eflagO$2 = (\u03b429$___2 | 0);
  if (reversedWork) {
    var \u03b430$___1 = eflagO$2;
    var \u03b430$___2 = sflagO$2;
  } else {
    var \u03b430$___1 = sflagO$2;
    var \u03b430$___2 = eflagO$2;
  }
  var sFlag = (\u03b430$___1 | 0);
  var eFlag = (\u03b430$___2 | 0);
  var this$22 = e.b4.ag.r("penwidth");
  if (this$22.c()) {
    var this$26 = $m_s_None$();
  } else {
    var x0$4 = this$22.d();
    var this$26 = ($m_sc_StringParsers$().c1(x0$4) ? new $c_s_Some($m_jl_Double$().bd(x0$4)) : $m_s_None$());
  }
  var pw = (+(this$26.c() ? 1.0 : this$26.d()));
  var this$28 = e.b4.ag.r("arrowsize");
  if (this$28.c()) {
    var this$32 = $m_s_None$();
  } else {
    var x0$5 = this$28.d();
    var this$32 = ($m_sc_StringParsers$().c1(x0$5) ? new $c_s_Some($m_jl_Double$().bd(x0$5)) : $m_s_None$());
  }
  var asz = (+(this$32.c() ? 1.0 : this$32.d()));
  var spAttachW = $m_s_None$();
  var epAttachW = $m_s_None$();
  if ((sFlag !== $m_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$().lC)) {
    var x$proxy23 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$().aMo(sFlag, pw, asz);
    var elen2 = (x$proxy23 * x$proxy23);
    var sp = ps.a[elem$1];
    spAttachW = new $c_s_Some(sp);
    if (((elem$3 > elem$1) && ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__dist2__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__D($thiz, ps.a[elem$1], ps.a[((3 + elem$1) | 0)]) < elen2))) {
      elem$1 = ((3 + elem$1) | 0);
    }
    var w = new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY.r().C)([ps.a[((3 + elem$1) | 0)], ps.a[((2 + elem$1) | 0)], ps.a[((1 + elem$1) | 0)], sp]);
    var seg = w.ae();
    var best = w.ae();
    var found = false;
    var low = 0.0;
    var high = 1.0;
    var pt = w.a[3];
    var opt = pt;
    var first = true;
    while (true) {
      if (first) {
        var $x_2 = true;
      } else {
        var x$2 = (opt.W - pt.W);
        var $x_2 = ((+Math.abs(x$2)) > 0.5);
      }
      if ($x_2) {
        var $x_1 = true;
      } else {
        var x$3 = (opt.a6 - pt.a6);
        var $x_1 = ((+Math.abs(x$3)) > 0.5);
      }
      if ($x_1) {
        first = false;
        opt = pt;
        var t$1 = (0.5 * (high + low));
        matchResult71: {
          var \u03b428$___1;
          var \u03b428$___2;
          var \u03b428$___3;
          var x246 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__bezier__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__I__D__T3($thiz, w, 0, t$1);
          if ((x246 !== null)) {
            var \u03b428$___1 = x246.bH;
            var \u03b428$___2 = x246.bU;
            var \u03b428$___3 = x246.c3;
            break matchResult71;
          }
          throw new $c_s_MatchError(x246);
        }
        var p$2 = \u03b428$___1;
        var l$2 = \u03b428$___2;
        pt = p$2;
        l$2.av(0, seg, 0, 4);
        var x0$6 = pt;
        if (($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__dist2__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__D($m_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$(), x0$6, sp) < elen2)) {
          high = t$1;
          seg.av(0, best, 0, 4);
          found = true;
        } else {
          low = t$1;
        }
      } else {
        break;
      }
    }
    var srcseg = (found ? best : seg);
    srcseg.av(0, w, 0, 4);
    ps.a[elem$1] = w.a[3];
    ps.a[((1 + elem$1) | 0)] = w.a[2];
    ps.a[((2 + elem$1) | 0)] = w.a[1];
    ps.a[((3 + elem$1) | 0)] = w.a[0];
  }
  if ((eFlag !== $m_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$().lC)) {
    var x$proxy24 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$().aMo(eFlag, pw, asz);
    var elen2$3 = (x$proxy24 * x$proxy24);
    var ep = ps.a[((3 + elem$3) | 0)];
    epAttachW = new $c_s_Some(ep);
    if (((elem$3 > elem$1) && ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__dist2__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__D($thiz, ps.a[elem$3], ps.a[((3 + elem$3) | 0)]) < elen2$3))) {
      elem$3 = ((elem$3 - 3) | 0);
    }
    var sp$3 = new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY.r().C)([ep, ps.a[((2 + elem$3) | 0)], ps.a[((1 + elem$3) | 0)], ps.a[elem$3]]);
    var seg$1 = sp$3.ae();
    var best$1 = sp$3.ae();
    var found$1 = false;
    var low$1 = 0.0;
    var high$1 = 1.0;
    var pt$1 = sp$3.a[0];
    var opt$1 = pt$1;
    var first$1 = true;
    while (true) {
      if (first$1) {
        var $x_4 = true;
      } else {
        var x$4 = (opt$1.W - pt$1.W);
        var $x_4 = ((+Math.abs(x$4)) > 0.5);
      }
      if ($x_4) {
        var $x_3 = true;
      } else {
        var x$5 = (opt$1.a6 - pt$1.a6);
        var $x_3 = ((+Math.abs(x$5)) > 0.5);
      }
      if ($x_3) {
        first$1 = false;
        opt$1 = pt$1;
        var t$2 = (0.5 * (high$1 + low$1));
        matchResult71$1: {
          var \u03b428$$1___1;
          var \u03b428$$1___2;
          var \u03b428$$1___3;
          var x246$1 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__bezier__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__I__D__T3($thiz, sp$3, 0, t$2);
          if ((x246$1 !== null)) {
            var \u03b428$$1___1 = x246$1.bH;
            var \u03b428$$1___2 = x246$1.bU;
            var \u03b428$$1___3 = x246$1.c3;
            break matchResult71$1;
          }
          throw new $c_s_MatchError(x246$1);
        }
        var p$2$1 = \u03b428$$1___1;
        var r$2$1 = \u03b428$$1___3;
        pt$1 = p$2$1;
        r$2$1.av(0, seg$1, 0, 4);
        var x0$7 = pt$1;
        if (($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__dist2__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__D($m_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$(), x0$7, ep) < elen2$3)) {
          low$1 = t$2;
          seg$1.av(0, best$1, 0, 4);
          found$1 = true;
        } else {
          high$1 = t$2;
        }
      } else {
        break;
      }
    }
    var srcseg$1 = (found$1 ? best$1 : seg$1);
    srcseg$1.av(0, sp$3, 0, 4);
    ps.a[elem$3] = sp$3.a[3];
    ps.a[((1 + elem$3) | 0)] = sp$3.a[2];
    ps.a[((2 + elem$3) | 0)] = sp$3.a[1];
    ps.a[((3 + elem$3) | 0)] = sp$3.a[0];
  }
  var this$46 = $m_s_Predef$().fB($m_sc_ArrayOps$().ls(ps, elem$1, ((4 + elem$3) | 0)));
  var pts = $m_sci_Vector$().X(this$46);
  return (reversedWork ? new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$ESpline($f_sc_IndexedSeqOps__reverse__O(pts), spAttachW, epAttachW) : new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$ESpline(pts, epAttachW, spAttachW));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__dist2__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__D($thiz, a, b) {
  var dx = (a.W - b.W);
  var dy = (a.a6 - b.a6);
  return ((dx * dx) + (dy * dy));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__sameSide__D__D__D__D__D__D__D__D__Z($thiz, p0x, p0y, p1x, p1y, l0x, l0y, l1x, l1y) {
  var a = (-(l1y - l0y));
  var b = (l1x - l0x);
  var c = ((a * l0x) + (b * l0y));
  return (((((a * p0x) + (b * p0y)) - c) >= 0.0) === ((((a * p1x) + (b * p1y)) - c) >= 0.0));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv$1, allX$1, id) {
  var f = (() => (+allX$1.i(id)));
  if ((!($objectGetClass(cxOv$1) === $d_scm_HashMap.l()))) {
    var x1 = cxOv$1.r(id);
    if ((x1 instanceof $c_s_Some)) {
      var $x_1 = x1.J;
    } else {
      if ((!($m_s_None$() === x1))) {
        throw new $c_s_MatchError(x1);
      }
      var $x_1 = f();
    }
  } else {
    var originalHash = $m_sr_Statics$().u(id);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var x1$1 = cxOv$1.S.a[(hash & ((cxOv$1.S.a.length - 1) | 0))];
    var nd = ((x1$1 === null) ? null : x1$1.by(id, hash));
    var $x_1 = ((nd === null) ? f() : nd.b9);
  }
  return (+$x_1);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cy$1__sci_Map__sci_Map__T__D($thiz, yOf$1, rankOf$1, id) {
  return (+yOf$1.i(rankOf$1.i(id)));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__vHalf$1__sci_Map__sci_Set__D__T__D($thiz, nodeOf$1, intraVEdge$1, VirtualHalf$1, id) {
  var x29 = nodeOf$1.r(id);
  if ((x29 instanceof $c_s_Some)) {
    var x31 = x29.J;
    if ((x31 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Virtual)) {
      if (intraVEdge$1.E(x31.kB)) {
        return 1.0;
      }
    }
  }
  return VirtualHalf$1;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__lw0$1__sci_Map__D__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Set__D__T__D($thiz, labelW$2, NodeSep$1, flatLabelHalf$1, byId$1, g$4, nodeOf$2, intraVEdge$2, VirtualHalf$2, id) {
  if (labelW$2.E(id)) {
    return NodeSep$1;
  } else if (flatLabelHalf$1.E(id)) {
    return (+flatLabelHalf$1.i(id));
  } else if ((!(!id.startsWith("__v")))) {
    return $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__vHalf$1__sci_Map__sci_Set__D__T__D($thiz, nodeOf$2, intraVEdge$2, VirtualHalf$2, id);
  } else {
    var this$1 = byId$1.r(id);
    if (this$1.c()) {
      var $x_1 = $m_s_None$();
    } else {
      var x0 = this$1.d();
      var $x_1 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().J9(x0, g$4);
    }
    var this$2 = $x_1;
    if (this$2.c()) {
      var this$3 = $m_s_None$();
    } else {
      var x0$1 = this$2.d();
      var this$3 = new $c_s_Some($m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().X5(x0$1));
    }
    return (+(this$3.c() ? 1.0 : this$3.d()));
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__lw$1__scm_HashMap__sci_Map__D__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Set__D__T__D($thiz, lwOv$1, labelW$3, NodeSep$2, flatLabelHalf$2, byId$2, g$6, nodeOf$3, intraVEdge$3, VirtualHalf$3, id) {
  var f = (() => $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__lw0$1__sci_Map__D__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Set__D__T__D($thiz, labelW$3, NodeSep$2, flatLabelHalf$2, byId$2, g$6, nodeOf$3, intraVEdge$3, VirtualHalf$3, id));
  if ((!($objectGetClass(lwOv$1) === $d_scm_HashMap.l()))) {
    var x1 = lwOv$1.r(id);
    if ((x1 instanceof $c_s_Some)) {
      var $x_1 = x1.J;
    } else {
      if ((!($m_s_None$() === x1))) {
        throw new $c_s_MatchError(x1);
      }
      var $x_1 = f();
    }
  } else {
    var originalHash = $m_sr_Statics$().u(id);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var x1$1 = lwOv$1.S.a[(hash & ((lwOv$1.S.a.length - 1) | 0))];
    var nd = ((x1$1 === null) ? null : x1$1.by(id, hash));
    var $x_1 = ((nd === null) ? f() : nd.b9);
  }
  return (+$x_1);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__rw$1__scm_HashMap__sci_Map__D__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Set__D__T__D($thiz, rwOv$1, labelW$5, NodeSep$4, flatLabelHalf$4, byId$4, g$8, nodeOf$5, intraVEdge$5, VirtualHalf$5, id) {
  var f = (() => (+labelW$5.ay(id, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__lw0$1__sci_Map__D__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Set__D__T__D($thiz, labelW$5, NodeSep$4, flatLabelHalf$4, byId$4, g$8, nodeOf$5, intraVEdge$5, VirtualHalf$5, id))))));
  if ((!($objectGetClass(rwOv$1) === $d_scm_HashMap.l()))) {
    var x1 = rwOv$1.r(id);
    if ((x1 instanceof $c_s_Some)) {
      var $x_1 = x1.J;
    } else {
      if ((!($m_s_None$() === x1))) {
        throw new $c_s_MatchError(x1);
      }
      var $x_1 = f();
    }
  } else {
    var originalHash = $m_sr_Statics$().u(id);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var x1$1 = rwOv$1.S.a[(hash & ((rwOv$1.S.a.length - 1) | 0))];
    var nd = ((x1$1 === null) ? null : x1$1.by(id, hash));
    var $x_1 = ((nd === null) ? f() : nd.b9);
  }
  return (+$x_1);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__mvalRw$1__sci_Map__sci_Map__D__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Set__D__T__D($thiz, labelW$8, selfRwSpl$1, NodeSep$7, flatLabelHalf$7, byId$7, g$13, nodeOf$8, intraVEdge$8, VirtualHalf$8, id) {
  return (+labelW$8.ay(id, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__lw0$1__sci_Map__D__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Set__D__T__D($thiz, labelW$8, NodeSep$7, flatLabelHalf$7, byId$7, g$13, nodeOf$8, intraVEdge$8, VirtualHalf$8, id) + (+selfRwSpl$1.ay(id, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 0.0)))))))));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__ht1$1__Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo__I__D($thiz, yiHt$1, r) {
  return (+yiHt$1.KK.ay(r, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 0.0))));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__ht2$1__Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo__I__D($thiz, yiHt$2, r) {
  return (+yiHt$2.KL.ay(r, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 0.0))));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__neighbor$1__sci_Map__sci_Map__T__I__sci_Set__s_Option($thiz, orderByRank$2, rankOf$2, vn, dir, ownPath) {
  var row = orderByRank$2.i(rankOf$2.i(vn));
  var idx = $f_sc_SeqOps__indexOf__O__I__I(row, vn, 0);
  var i = ((idx + dir) | 0);
  var ans = $m_s_None$();
  while (((ans.c() && (i >= 0)) && (i < row.C()))) {
    var n = row.l(i);
    if ((!ownPath.E(n))) {
      ans = new $c_s_Some(n);
    }
    i = ((i + dir) | 0);
  }
  return ans;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__origEnds$1__sci_Map__sci_Vector__T__s_Option($thiz, nodeOf$11, dedges$1, vname) {
  var x36 = nodeOf$11.r(vname);
  if ((x36 instanceof $c_s_Some)) {
    var x38 = x36.J;
    if ((x38 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Virtual)) {
      var x41 = x38.kB;
      var this$3 = new $c_s_PartialFunction$Lifted(dedges$1).as(x41);
      if (this$3.c()) {
        return $m_s_None$();
      } else {
        var x0 = this$3.d();
        return new $c_s_Some(new $c_T2(x0.ai, x0.ak));
      }
    }
  }
  return $m_s_None$();
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__foreign$1__s_Option__s_Option__I__Z($thiz, tcl$1, hcl$1, c) {
  return ((!tcl$1.E(c)) && (!hcl$1.E(c)));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__vninside$1__sci_Vector__scm_HashMap__sci_Map__sci_Map__sci_Map__I__T__Z($thiz, cluBBs$2, cxOv$4, allX$5, yOf$3, rankOf$4, ci, m) {
  var bb = cluBBs$2.l(ci);
  return ((((bb.nW <= $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv$4, allX$5, m)) && ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv$4, allX$5, m) <= bb.nX)) && (bb.pR <= $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cy$1__sci_Map__sci_Map__T__D($thiz, yOf$3, rankOf$4, m))) && ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cy$1__sci_Map__sci_Map__T__D($thiz, yOf$3, rankOf$4, m) <= bb.pS));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__clBound$1__sci_Vector__sci_Map__sci_Map__sci_Vector__scm_HashMap__sci_Map__sci_Map__sci_Map__T__T__s_Option($thiz, cluBBs$1, cluOf$1, nodeOf$12, dedges$2, cxOv$3, allX$4, yOf$2, rankOf$3, n, adj) {
  if ($f_sc_SeqOps__isEmpty__Z(cluBBs$1)) {
    return $m_s_None$();
  } else {
    if ((!(!(!n.startsWith("__v"))))) {
      var c = cluOf$1.r(n);
      var \u03b41$___1 = c;
      var \u03b41$___2 = c;
    } else {
      matchResult16: {
        var \u03b41$___1;
        var \u03b41$___2;
        var x43 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__origEnds$1__sci_Map__sci_Vector__T__s_Option($thiz, nodeOf$12, dedges$2, n);
        if ((x43 instanceof $c_s_Some)) {
          var x45 = x43.J;
          if ((x45 !== null)) {
            var t = x45.g();
            var h = x45.h();
            var \u03b41$___1 = cluOf$1.r(t);
            var \u03b41$___2 = cluOf$1.r(h);
            break matchResult16;
          }
        }
        if (($m_s_None$() === x43)) {
          var \u03b41$___1 = $m_s_None$();
          var \u03b41$___2 = $m_s_None$();
          break matchResult16;
        }
        throw new $c_s_MatchError(x43);
      }
    }
    var tcl = \u03b41$___1;
    var hcl = \u03b41$___2;
    if ((!(!(!adj.startsWith("__v"))))) {
      var this$4 = cluOf$1.r(adj);
      return ((this$4.c() || $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__foreign$1__s_Option__s_Option__I__Z($thiz, tcl, hcl, (this$4.d() | 0))) ? this$4 : $m_s_None$());
    } else {
      var this$5 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__origEnds$1__sci_Map__sci_Vector__T__s_Option($thiz, nodeOf$12, dedges$2, adj);
      if (this$5.c()) {
        return $m_s_None$();
      } else {
        var x0$1 = this$5.d();
        var t2 = x0$1.g();
        var h2 = x0$1.h();
        var this$6 = cluOf$1.r(t2);
        if (this$6.c()) {
          var $x_1 = true;
        } else {
          var x0$2 = this$6.d();
          var c$2 = (x0$2 | 0);
          var $x_1 = ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__foreign$1__s_Option__s_Option__I__Z($thiz, tcl, hcl, c$2) && $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__vninside$1__sci_Vector__scm_HashMap__sci_Map__sci_Map__sci_Map__I__T__Z($thiz, cluBBs$1, cxOv$3, allX$4, yOf$2, rankOf$3, c$2, adj));
        }
        if ($x_1) {
          var this$7 = this$6;
        } else {
          var this$7 = $m_s_None$();
        }
        if (this$7.c()) {
          var this$8 = cluOf$1.r(h2);
          if (this$8.c()) {
            var $x_2 = true;
          } else {
            var x0$3 = this$8.d();
            var c$3 = (x0$3 | 0);
            var $x_2 = ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__foreign$1__s_Option__s_Option__I__Z($thiz, tcl, hcl, c$3) && $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__vninside$1__sci_Vector__scm_HashMap__sci_Map__sci_Map__sci_Map__I__T__Z($thiz, cluBBs$1, cxOv$3, allX$4, yOf$2, rankOf$3, c$3, adj));
          }
          if ($x_2) {
            return this$8;
          } else {
            return $m_s_None$();
          }
        } else {
          return this$7;
        }
      }
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__outSize$1__scm_Map__T__I($thiz, outDeg$2, n) {
  return ((!(!n.startsWith("__v"))) ? 1 : (outDeg$2.i(n) | 0));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__inSize$1__scm_Map__T__I($thiz, inDeg$2, n) {
  return ((!(!n.startsWith("__v"))) ? 1 : (inDeg$2.i(n) | 0));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__chainNextOf$1__sci_Map__sci_Vector__T__T($thiz, nodeOf$13, workEnds$1, vn) {
  var x86 = nodeOf$13.i(vn);
  if ((x86 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Virtual)) {
    var x89 = x86.kB;
    var x90 = x86.wD;
    matchResult22: {
      var \u03b42$___1;
      var \u03b42$___2;
      var x81 = workEnds$1.l(x89);
      if ((x81 !== null)) {
        var \u03b42$___1 = x81.bs;
        var \u03b42$___2 = (x81.ca | 0);
        break matchResult22;
      }
      throw new $c_s_MatchError(x81);
    }
    var wh$2 = \u03b42$___1;
    return ((((1 + x90) | 0) <= (((\u03b42$___2 | 0) - 1) | 0)) ? new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Virtual(x89, ((1 + x90) | 0)).bE() : wh$2);
  }
  return vn;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__chainPrevOf$1__sci_Map__sci_Vector__T__T($thiz, nodeOf$14, workEnds$2, vn) {
  var x96 = nodeOf$14.i(vn);
  if ((x96 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Virtual)) {
    var x99 = x96.kB;
    var x100 = x96.wD;
    matchResult24: {
      var \u03b43$___1;
      var \u03b43$___2;
      var x91 = workEnds$2.l(x99);
      if ((x91 !== null)) {
        var \u03b43$___1 = x91.bO;
        var \u03b43$___2 = (x91.ch | 0);
        break matchResult24;
      }
      throw new $c_s_MatchError(x91);
    }
    var wt$2 = \u03b43$___1;
    return ((((x100 - 1) | 0) >= ((1 + (\u03b43$___2 | 0)) | 0)) ? new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Virtual(x99, ((x100 - 1) | 0)).bE() : wt$2);
  }
  return vn;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__outSegOf$1__sci_Map__sci_Map__sci_Vector__T__s_Option($thiz, realOutSeg$1, nodeOf$15, workEnds$3, n) {
  return ((!(!n.startsWith("__v"))) ? new $c_s_Some(new $c_T2(n, $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__chainNextOf$1__sci_Map__sci_Vector__T__T($thiz, nodeOf$15, workEnds$3, n))) : realOutSeg$1.r(n));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__inSegOf$1__sci_Map__sci_Map__sci_Vector__T__s_Option($thiz, realInSeg$1, nodeOf$16, workEnds$4, n) {
  return ((!(!n.startsWith("__v"))) ? new $c_s_Some(new $c_T2($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__chainPrevOf$1__sci_Map__sci_Vector__T__T($thiz, nodeOf$16, workEnds$4, n), n)) : realInSeg$1.r(n));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__pathscross$1__sci_Map__scm_Map__sci_Map__sci_Map__sci_Vector__scm_Map__sci_Map__T__T__s_Option__s_Option__Z($thiz, orderIdx$1, outDeg$3, realOutSeg$2, nodeOf$17, workEnds$5, inDeg$3, realInSeg$2, n0, n1, ie1, oe1) {
  var order = ((orderIdx$1.i(n0) | 0) > (orderIdx$1.i(n1) | 0));
  if ((($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__outSize$1__scm_Map__T__I($thiz, outDeg$3, n0) !== 1) && ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__outSize$1__scm_Map__T__I($thiz, outDeg$3, n1) !== 1))) {
    return false;
  }
  var e1 = oe1;
  if ((($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__outSize$1__scm_Map__T__I($thiz, outDeg$3, n0) === 1) && (!e1.c()))) {
    var e0 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__outSegOf$1__sci_Map__sci_Map__sci_Vector__T__s_Option($thiz, realOutSeg$2, nodeOf$17, workEnds$5, n0);
    var cnt = 0;
    var stop = false;
    while (((!stop) && (cnt < 2))) {
      var na = e0.d().h();
      var nb = e1.d().h();
      if ((na === nb)) {
        stop = true;
      } else if ((order !== ((orderIdx$1.i(na) | 0) > (orderIdx$1.i(nb) | 0)))) {
        return true;
      } else if ((($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__outSize$1__scm_Map__T__I($thiz, outDeg$3, na) !== 1) || (!(!(!na.startsWith("__v")))))) {
        stop = true;
      } else {
        e0 = new $c_s_Some(new $c_T2(na, $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__chainNextOf$1__sci_Map__sci_Vector__T__T($thiz, nodeOf$17, workEnds$5, na)));
        if ((($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__outSize$1__scm_Map__T__I($thiz, outDeg$3, nb) !== 1) || (!(!(!nb.startsWith("__v")))))) {
          stop = true;
        } else {
          e1 = new $c_s_Some(new $c_T2(nb, $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__chainNextOf$1__sci_Map__sci_Vector__T__T($thiz, nodeOf$17, workEnds$5, nb)));
        }
      }
      cnt = ((1 + cnt) | 0);
    }
  }
  e1 = ie1;
  if ((($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__inSize$1__scm_Map__T__I($thiz, inDeg$3, n0) === 1) && (!e1.c()))) {
    var e0$2 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__inSegOf$1__sci_Map__sci_Map__sci_Vector__T__s_Option($thiz, realInSeg$2, nodeOf$17, workEnds$5, n0);
    var cnt$2 = 0;
    var stop$2 = false;
    while (((!stop$2) && (cnt$2 < 2))) {
      var na$2 = e0$2.d().g();
      var nb$2 = e1.d().g();
      if ((na$2 === nb$2)) {
        stop$2 = true;
      } else if ((order !== ((orderIdx$1.i(na$2) | 0) > (orderIdx$1.i(nb$2) | 0)))) {
        return true;
      } else if ((($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__inSize$1__scm_Map__T__I($thiz, inDeg$3, na$2) !== 1) || (!(!(!na$2.startsWith("__v")))))) {
        stop$2 = true;
      } else {
        e0$2 = new $c_s_Some(new $c_T2($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__chainPrevOf$1__sci_Map__sci_Vector__T__T($thiz, nodeOf$17, workEnds$5, na$2), na$2));
        if ((($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__inSize$1__scm_Map__T__I($thiz, inDeg$3, nb$2) !== 1) || (!(!(!nb$2.startsWith("__v")))))) {
          stop$2 = true;
        } else {
          e1 = new $c_s_Some(new $c_T2($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__chainPrevOf$1__sci_Map__sci_Vector__T__T($thiz, nodeOf$17, workEnds$5, nb$2), nb$2));
        }
      }
      cnt$2 = ((1 + cnt$2) | 0);
    }
  }
  return false;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__neighborGv$1__sci_Map__sci_Map__sci_Map__sci_Map__scm_Map__sci_Map__sci_Map__sci_Vector__scm_Map__sci_Map__T__I__s_Option__s_Option__s_Option($thiz, orderByRank$3, rankOf$10, orderIdx$2, labelW$11, outDeg$4, realOutSeg$3, nodeOf$18, workEnds$6, inDeg$4, realInSeg$3, vn, dir, ie, oe) {
  var row = orderByRank$3.i(rankOf$10.i(vn));
  var i = (((orderIdx$2.i(vn) | 0) + dir) | 0);
  var ans = $m_s_None$();
  while (((ans.c() && (i >= 0)) && (i < row.C()))) {
    var n = row.l(i);
    if (labelW$11.E(n)) {
      ans = new $c_s_Some(n);
    } else if ((!(!(!n.startsWith("__v"))))) {
      ans = new $c_s_Some(n);
    } else if ((!$p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__pathscross$1__sci_Map__scm_Map__sci_Map__sci_Map__sci_Vector__scm_Map__sci_Map__T__T__s_Option__s_Option__Z($thiz, orderIdx$2, outDeg$4, realOutSeg$3, nodeOf$18, workEnds$6, inDeg$4, realInSeg$3, n, vn, ie, oe))) {
      ans = new $c_s_Some(n);
    }
    i = ((i + dir) | 0);
  }
  return ans;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__maximalBbox$1__sci_Map__sci_Vector__D__D__sr_DoubleRef__sr_DoubleRef__sci_Map__sci_Map__scm_HashMap__sci_Map__scm_HashMap__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Set__D__sci_Map__sci_Vector__sci_Map__sci_Map__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo__T__sci_Set__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box($thiz, rankOf$43, cluBBs$17, Splinesep$9, NodeSep$27, leftBound$12, rightBound$12, orderByRank$12, labelW$29, cxOv$35, allX$35, lwOv$19, flatLabelHalf$27, byId$49, g$69, nodeOf$35, intraVEdge$27, VirtualHalf$27, cluOf$12, dedges$11, yOf$34, selfRwSpl$11, rwOv$19, yiHt$12, vn, ownPath) {
  return $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__maximalBboxCore$1__sci_Map__sci_Vector__D__D__sr_DoubleRef__sr_DoubleRef__sci_Map__scm_HashMap__sci_Map__scm_HashMap__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Set__D__sci_Map__sci_Vector__sci_Map__sci_Map__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo__T__s_Option__s_Option__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box($thiz, rankOf$43, cluBBs$17, Splinesep$9, NodeSep$27, leftBound$12, rightBound$12, labelW$29, cxOv$35, allX$35, lwOv$19, flatLabelHalf$27, byId$49, g$69, nodeOf$35, intraVEdge$27, VirtualHalf$27, cluOf$12, dedges$11, yOf$34, selfRwSpl$11, rwOv$19, yiHt$12, vn, $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__neighbor$1__sci_Map__sci_Map__T__I__sci_Set__s_Option($thiz, orderByRank$12, rankOf$43, vn, (-1), ownPath), $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__neighbor$1__sci_Map__sci_Map__T__I__sci_Set__s_Option($thiz, orderByRank$12, rankOf$43, vn, 1, ownPath));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__maximalBboxGv$1__sci_Map__sci_Vector__D__D__sr_DoubleRef__sr_DoubleRef__sci_Map__sci_Map__sci_Map__scm_Map__sci_Map__sci_Map__sci_Vector__scm_Map__sci_Map__scm_HashMap__sci_Map__scm_HashMap__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Set__D__sci_Map__sci_Vector__sci_Map__sci_Map__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo__T__s_Option__s_Option__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box($thiz, rankOf$44, cluBBs$18, Splinesep$10, NodeSep$28, leftBound$13, rightBound$13, orderByRank$13, orderIdx$5, labelW$30, outDeg$8, realOutSeg$6, nodeOf$36, workEnds$9, inDeg$8, realInSeg$6, cxOv$36, allX$36, lwOv$20, flatLabelHalf$28, byId$50, g$70, intraVEdge$28, VirtualHalf$28, cluOf$13, dedges$12, yOf$35, selfRwSpl$12, rwOv$20, yiHt$13, vn, ie, oe) {
  return $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__maximalBboxCore$1__sci_Map__sci_Vector__D__D__sr_DoubleRef__sr_DoubleRef__sci_Map__scm_HashMap__sci_Map__scm_HashMap__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Set__D__sci_Map__sci_Vector__sci_Map__sci_Map__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo__T__s_Option__s_Option__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box($thiz, rankOf$44, cluBBs$18, Splinesep$10, NodeSep$28, leftBound$13, rightBound$13, labelW$30, cxOv$36, allX$36, lwOv$20, flatLabelHalf$28, byId$50, g$70, nodeOf$36, intraVEdge$28, VirtualHalf$28, cluOf$13, dedges$12, yOf$35, selfRwSpl$12, rwOv$20, yiHt$13, vn, $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__neighborGv$1__sci_Map__sci_Map__sci_Map__sci_Map__scm_Map__sci_Map__sci_Map__sci_Vector__scm_Map__sci_Map__T__I__s_Option__s_Option__s_Option($thiz, orderByRank$13, rankOf$44, orderIdx$5, labelW$30, outDeg$8, realOutSeg$6, nodeOf$36, workEnds$9, inDeg$8, realInSeg$6, vn, (-1), ie, oe), $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__neighborGv$1__sci_Map__sci_Map__sci_Map__sci_Map__scm_Map__sci_Map__sci_Map__sci_Vector__scm_Map__sci_Map__T__I__s_Option__s_Option__s_Option($thiz, orderByRank$13, rankOf$44, orderIdx$5, labelW$30, outDeg$8, realOutSeg$6, nodeOf$36, workEnds$9, inDeg$8, realInSeg$6, vn, 1, ie, oe));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__isVirtualN$1__sci_Map__T__Z($thiz, flatLabelHalf$10, id) {
  return ((!(!id.startsWith("__v"))) || flatLabelHalf$10.E(id));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__maximalBboxCore$1__sci_Map__sci_Vector__D__D__sr_DoubleRef__sr_DoubleRef__sci_Map__scm_HashMap__sci_Map__scm_HashMap__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Set__D__sci_Map__sci_Vector__sci_Map__sci_Map__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo__T__s_Option__s_Option__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box($thiz, rankOf$11, cluBBs$7, Splinesep$1, NodeSep$10, leftBound$2, rightBound$2, labelW$12, cxOv$9, allX$10, lwOv$3, flatLabelHalf$11, byId$10, g$16, nodeOf$19, intraVEdge$11, VirtualHalf$11, cluOf$4, dedges$3, yOf$8, selfRwSpl$3, rwOv$3, yiHt$3, vn, leftNb, rightNb) {
  var r = (rankOf$11.i(vn) | 0);
  var labelVn = labelW$12.E(vn);
  var b = (($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv$9, allX$10, vn) - $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__lw$1__scm_HashMap__sci_Map__D__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Set__D__T__D($thiz, lwOv$3, labelW$12, NodeSep$10, flatLabelHalf$11, byId$10, g$16, nodeOf$19, intraVEdge$11, VirtualHalf$11, vn)) - $thiz.a85);
  matchResult27: {
    var llx;
    if ((leftNb instanceof $c_s_Some)) {
      var left = leftNb.J;
      matchResult26: {
        var nb;
        var x101 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__clBound$1__sci_Vector__sci_Map__sci_Map__sci_Vector__scm_HashMap__sci_Map__sci_Map__sci_Map__T__T__s_Option($thiz, cluBBs$7, cluOf$4, nodeOf$19, dedges$3, cxOv$9, allX$10, yOf$8, rankOf$11, vn, left);
        if ((x101 instanceof $c_s_Some)) {
          var cl = (x101.J | 0);
          var nb = (cluBBs$7.l(cl).nX + Splinesep$1);
          break matchResult26;
        }
        if (($m_s_None$() === x101)) {
          var nb = (($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv$9, allX$10, left) + $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__mvalRw$1__sci_Map__sci_Map__D__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Set__D__T__D($thiz, labelW$12, selfRwSpl$3, NodeSep$10, flatLabelHalf$11, byId$10, g$16, nodeOf$19, intraVEdge$11, VirtualHalf$11, left)) + ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__isVirtualN$1__sci_Map__T__Z($thiz, flatLabelHalf$11, left) ? Splinesep$1 : (0.5 * NodeSep$10)));
          break matchResult26;
        }
        throw new $c_s_MatchError(x101);
      }
      if ((nb < b)) {
        b = nb;
      }
      var x$1 = b;
      var $x_1 = $m_RTLong$().d1((+Math.round(x$1)));
      var x$2_$_lo = $x_1.l;
      var x$2_$_hi = $x_1.h;
      var llx = ((4.294967296E9 * x$2_$_hi) + (x$2_$_lo >>> 0.0));
      break matchResult27;
    }
    if (($m_s_None$() === leftNb)) {
      var x$4 = b;
      var $x_2 = $m_RTLong$().d1((+Math.round(x$4)));
      var x$5_$_lo = $x_2.l;
      var x$5_$_hi = $x_2.h;
      var x$6 = ((4.294967296E9 * x$5_$_hi) + (x$5_$_lo >>> 0.0));
      var y = leftBound$2.T;
      var llx = (+Math.min(x$6, y));
      break matchResult27;
    }
    throw new $c_s_MatchError(leftNb);
  }
  var b2 = (labelVn ? ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv$9, allX$10, vn) + 10.0) : (($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv$9, allX$10, vn) + $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__rw$1__scm_HashMap__sci_Map__D__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Set__D__T__D($thiz, rwOv$3, labelW$12, NodeSep$10, flatLabelHalf$11, byId$10, g$16, nodeOf$19, intraVEdge$11, VirtualHalf$11, vn)) + $thiz.a85));
  matchResult29: {
    var urx;
    if ((rightNb instanceof $c_s_Some)) {
      var right = rightNb.J;
      matchResult28: {
        var nb$2;
        var x107 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__clBound$1__sci_Vector__sci_Map__sci_Map__sci_Vector__scm_HashMap__sci_Map__sci_Map__sci_Map__T__T__s_Option($thiz, cluBBs$7, cluOf$4, nodeOf$19, dedges$3, cxOv$9, allX$10, yOf$8, rankOf$11, vn, right);
        if ((x107 instanceof $c_s_Some)) {
          var cl$2 = (x107.J | 0);
          var nb$2 = (cluBBs$7.l(cl$2).nW - Splinesep$1);
          break matchResult28;
        }
        if (($m_s_None$() === x107)) {
          var nb$2 = (($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv$9, allX$10, right) - $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__lw$1__scm_HashMap__sci_Map__D__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Set__D__T__D($thiz, lwOv$3, labelW$12, NodeSep$10, flatLabelHalf$11, byId$10, g$16, nodeOf$19, intraVEdge$11, VirtualHalf$11, right)) - ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__isVirtualN$1__sci_Map__T__Z($thiz, flatLabelHalf$11, right) ? Splinesep$1 : (0.5 * NodeSep$10)));
          break matchResult28;
        }
        throw new $c_s_MatchError(x107);
      }
      if ((nb$2 > b2)) {
        b2 = nb$2;
      }
      var x$7 = b2;
      var $x_3 = $m_RTLong$().d1((+Math.round(x$7)));
      var x$8_$_lo = $x_3.l;
      var x$8_$_hi = $x_3.h;
      var urx = ((4.294967296E9 * x$8_$_hi) + (x$8_$_lo >>> 0.0));
      break matchResult29;
    }
    if (($m_s_None$() === rightNb)) {
      var x$9 = b2;
      var $x_4 = $m_RTLong$().d1((+Math.round(x$9)));
      var x$10_$_lo = $x_4.l;
      var x$10_$_hi = $x_4.h;
      var x$11 = ((4.294967296E9 * x$10_$_hi) + (x$10_$_lo >>> 0.0));
      var y$1 = rightBound$2.T;
      var urx = (+Math.max(x$11, y$1));
      break matchResult29;
    }
    throw new $c_s_MatchError(rightNb);
  }
  if (labelVn) {
    urx = (urx - $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__rw$1__scm_HashMap__sci_Map__D__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Set__D__T__D($thiz, rwOv$3, labelW$12, NodeSep$10, flatLabelHalf$11, byId$10, g$16, nodeOf$19, intraVEdge$11, VirtualHalf$11, vn));
    if ((urx < llx)) {
      urx = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv$9, allX$10, vn);
    }
  }
  return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box(llx, ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cy$1__sci_Map__sci_Map__T__D($thiz, yOf$8, rankOf$11, vn) - $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__ht1$1__Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo__I__D($thiz, yiHt$3, r)), urx, ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cy$1__sci_Map__sci_Map__T__D($thiz, yOf$8, rankOf$11, vn) + $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__ht2$1__Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo__I__D($thiz, yiHt$3, r)));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__rankBox$1__sr_DoubleRef__sci_Map__sr_DoubleRef__Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo__I__I__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box($thiz, leftBound$3, yOf$9, rightBound$3, yiHt$4, rUpper, rLower) {
  return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box(leftBound$3.T, ((+yOf$9.i(rLower)) + $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__ht2$1__Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo__I__D($thiz, yiHt$4, rLower)), rightBound$3.T, ((+yOf$9.i(rUpper)) - $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__ht1$1__Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo__I__D($thiz, yiHt$4, rUpper)));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__limitBoxes$1__scm_ArrayBuffer__sci_Vector__V($thiz, boxes, ctrl) {
  if (((ctrl.C() >= 4) && (((((ctrl.C() - 1) | 0) % 3) | 0) === 0))) {
    var pts = ctrl;
  } else {
    var s = ctrl.t();
    var t = ctrl.bJ();
    var pts = $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY.r().C)([s, new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY((s.W + ((t.W - s.W) / 3.0)), (s.a6 + ((t.a6 - s.a6) / 3.0))), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY((s.W + ((2.0 * (t.W - s.W)) / 3.0)), (s.a6 + ((2.0 * (t.a6 - s.a6)) / 3.0))), t])));
  }
  var delta = 10.0;
  var tries = 0;
  var done = false;
  while (((!done) && (tries < 15))) {
    var it = boxes.bB().o();
    while (it.p()) {
      var x0 = it.q();
      x0.aJ = 1.7976931348623157E308;
      x0.aF = (-1.7976931348623157E308);
    }
    var numDiv = (delta * boxes.a1);
    var pi = 0;
    while ((((3 + pi) | 0) < pts.C())) {
      var si = 0.0;
      while ((si <= numDiv)) {
        var t$2 = (si / numDiv);
        var elem = pts.l(pi).W;
        var elem$1 = 0.0;
        elem$1 = elem;
        var elem$2 = pts.l(pi).a6;
        var elem$3 = 0.0;
        elem$3 = elem$2;
        var bx = pts.l(((1 + pi) | 0)).W;
        var by = pts.l(((1 + pi) | 0)).a6;
        var cx2 = pts.l(((2 + pi) | 0)).W;
        var cy2 = pts.l(((2 + pi) | 0)).a6;
        var dx = pts.l(((3 + pi) | 0)).W;
        var dy = pts.l(((3 + pi) | 0)).a6;
        elem$1 = (elem$1 + (t$2 * (bx - elem$1)));
        elem$3 = (elem$3 + (t$2 * (by - elem$3)));
        bx = (bx + (t$2 * (cx2 - bx)));
        by = (by + (t$2 * (cy2 - by)));
        cx2 = (cx2 + (t$2 * (dx - cx2)));
        cy2 = (cy2 + (t$2 * (dy - cy2)));
        elem$1 = (elem$1 + (t$2 * (bx - elem$1)));
        elem$3 = (elem$3 + (t$2 * (by - elem$3)));
        bx = (bx + (t$2 * (cx2 - bx)));
        by = (by + (t$2 * (cy2 - by)));
        elem$1 = (elem$1 + (t$2 * (bx - elem$1)));
        elem$3 = (elem$3 + (t$2 * (by - elem$3)));
        var it$1 = boxes.bB().o();
        while (it$1.p()) {
          var x0$1 = it$1.q();
          if (((elem$3 <= (x0$1.bG + 1.0E-4)) && (elem$3 >= (x0$1.bZ - 1.0E-4)))) {
            var x$2 = x0$1.aJ;
            var y$2 = elem$1;
            x0$1.aJ = (+Math.min(x$2, y$2));
            var x$3 = x0$1.aF;
            var y$3 = elem$1;
            x0$1.aF = (+Math.max(x$3, y$3));
          }
        }
        si = (si + 1.0);
      }
      pi = ((3 + pi) | 0);
    }
    var res = true;
    var it$2 = boxes.bB().o();
    while ((res && it$2.p())) {
      var x0$2 = it$2.q();
      res = ((x0$2.aJ !== 1.7976931348623157E308) && (x0$2.aF !== (-1.7976931348623157E308)));
    }
    if (res) {
      done = true;
    } else {
      delta = (2.0 * delta);
      tries = ((1 + tries) | 0);
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__recoverSlack$1__scm_HashMap__scm_HashMap__scm_HashMap__scm_HashMap__sci_Map__sci_Map__sci_Map__D__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Set__D__sci_Vector__scm_ArrayBuffer__I__V($thiz, cxOv$11, lwOv$5, rwOv$5, labelPos$2, yOf$11, rankOf$13, labelW$14, NodeSep$12, flatLabelHalf$13, byId$12, g$18, nodeOf$21, intraVEdge$13, VirtualHalf$13, vns, boxes, origIdx) {
  var b = new $c_sr_IntRef(0);
  vns.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((vn) => {
    var vy = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cy$1__sci_Map__sci_Map__T__D($thiz, yOf$11, rankOf$13, vn);
    while (((b.an < boxes.a1) && (boxes.l(b.an).bZ > vy))) {
      b.an = ((1 + b.an) | 0);
    }
    if (((b.an < boxes.a1) && (boxes.l(b.an).bG >= vy))) {
      var bx = boxes.l(b.an);
      if (labelW$14.E(vn)) {
        var wl = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__rw$1__scm_HashMap__sci_Map__D__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Set__D__T__D($thiz, rwOv$5, labelW$14, NodeSep$12, flatLabelHalf$13, byId$12, g$18, nodeOf$21, intraVEdge$13, VirtualHalf$13, vn);
        $p_scm_HashMap__put0__O__O__Z__s_Some(cxOv$11, vn, bx.aF, false);
        $p_scm_HashMap__put0__O__O__Z__s_Some(lwOv$5, vn, (bx.aF - bx.aJ), false);
        $p_scm_HashMap__put0__O__O__Z__s_Some(rwOv$5, vn, wl, false);
        $p_scm_HashMap__put0__O__O__Z__s_Some(labelPos$2, origIdx, new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY((bx.aF + (0.5 * wl)), vy), false);
      } else {
        var c = (0.5 * (bx.aJ + bx.aF));
        $p_scm_HashMap__put0__O__O__Z__s_Some(cxOv$11, vn, c, false);
        $p_scm_HashMap__put0__O__O__Z__s_Some(lwOv$5, vn, (c - bx.aJ), false);
        $p_scm_HashMap__put0__O__O__Z__s_Some(rwOv$5, vn, (bx.aF - c), false);
      }
    }
  })));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__topBoxes$1__sci_Map__D__sci_Vector__D__D__sr_DoubleRef__sr_DoubleRef__sci_Map__scm_HashMap__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo__scm_HashMap__sci_Map__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Set__D__scm_HashMap__sci_Map__sci_Vector__sci_Map__T__D__Z__sci_Set__sci_Vector($thiz, rankOf$14, TopRankSep$1, cluBBs$8, Splinesep$2, NodeSep$13, leftBound$4, rightBound$4, orderByRank$4, cxOv$12, allX$11, yOf$12, yiHt$5, lwOv$6, labelW$15, flatLabelHalf$14, byId$13, g$19, nodeOf$22, intraVEdge$14, VirtualHalf$14, rwOv$6, cluOf$5, dedges$4, selfRwSpl$4, id, portY, goLeft, ownPath) {
  var nb = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__maximalBbox$1__sci_Map__sci_Vector__D__D__sr_DoubleRef__sr_DoubleRef__sci_Map__sci_Map__scm_HashMap__sci_Map__scm_HashMap__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Set__D__sci_Map__sci_Vector__sci_Map__sci_Map__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo__T__sci_Set__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box($thiz, rankOf$14, cluBBs$8, Splinesep$2, NodeSep$13, leftBound$4, rightBound$4, orderByRank$4, labelW$15, cxOv$12, allX$11, lwOv$6, flatLabelHalf$14, byId$13, g$19, nodeOf$22, intraVEdge$14, VirtualHalf$14, cluOf$5, dedges$4, yOf$12, selfRwSpl$4, rwOv$6, yiHt$5, id, ownPath);
  var ncx = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv$12, allX$11, id);
  var ncy = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cy$1__sci_Map__sci_Map__T__D($thiz, yOf$12, rankOf$14, id);
  var r = (rankOf$14.i(id) | 0);
  var bTop = ((ncy + $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__ht2$1__Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo__I__D($thiz, yiHt$5, r)) + (0.5 * TopRankSep$1));
  var yLo = (ncy - $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__ht2$1__Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo__I__D($thiz, yiHt$5, r));
  return (goLeft ? $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box.r().C)([new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box((nb.aJ - 1.0), portY, nb.aF, bTop), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box((nb.aJ - 1.0), yLo, (ncx - $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__lw$1__scm_HashMap__sci_Map__D__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Set__D__T__D($thiz, lwOv$6, labelW$15, NodeSep$13, flatLabelHalf$14, byId$13, g$19, nodeOf$22, intraVEdge$14, VirtualHalf$14, id)), portY), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box(nb.aJ, yLo, nb.aF, portY)]))) : $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box.r().C)([new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box(nb.aJ, portY, (nb.aF + 1.0), bTop), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box((ncx + $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__rw$1__scm_HashMap__sci_Map__D__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Set__D__T__D($thiz, rwOv$6, labelW$15, NodeSep$13, flatLabelHalf$14, byId$13, g$19, nodeOf$22, intraVEdge$14, VirtualHalf$14, id)), yLo, (nb.aF + 1.0), portY), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box(nb.aJ, yLo, nb.aF, portY)]))));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__halfH$1__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T__D($thiz, byId$14, g$20, id) {
  var this$1 = byId$14.r(id);
  if (this$1.c()) {
    var $x_1 = $m_s_None$();
  } else {
    var x0 = this$1.d();
    var $x_1 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().J9(x0, g$20);
  }
  var this$2 = $x_1;
  if (this$2.c()) {
    var this$3 = $m_s_None$();
  } else {
    var x0$1 = this$2.d();
    var this$3 = new $c_s_Some($m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().X4(x0$1));
  }
  return (+(this$3.c() ? 0.0 : this$3.d()));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__recRoot$1__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T__s_Option($thiz, byId$15, g$22, id) {
  var this$1 = byId$15.r(id);
  if (this$1.c()) {
    return $m_s_None$();
  } else {
    var x0 = this$1.d();
    return $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().PN(x0, g$22);
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__makePolyline$1__sci_Vector__sci_Vector($thiz, pl) {
  if ((pl.C() < 2)) {
    return pl;
  } else {
    $m_sci_Vector$();
    var out = new $c_sci_VectorBuilder();
    out.ck(pl.t());
    out.ck(pl.t());
    var i = 1;
    while ((i < ((pl.C() - 1) | 0))) {
      out.ck(pl.l(i));
      out.ck(pl.l(i));
      out.ck(pl.l(i));
      i = ((1 + i) | 0);
    }
    out.ck(pl.bJ());
    out.ck(pl.bJ());
    return out.bY();
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__rawPort$1__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T__s_Option__s_Option($thiz, byId$16, g$24, id, portOpt) {
  if (portOpt.c()) {
    return $m_s_None$();
  } else {
    var x0 = portOpt.d();
    var this$1 = byId$16.r(id);
    if (this$1.c()) {
      return $m_s_None$();
    } else {
      var x0$1 = this$1.d();
      var this$2 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$().agn(x0$1, g$24, x0);
      var this$3 = (this$2.c() ? $m_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$().agm(x0$1, g$24, x0) : this$2);
      return (this$3.c() ? $m_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$().aP3(x0$1, g$24, x0) : this$3);
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__endPort$1__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir__scm_HashMap__sci_Map__sci_Map__sci_Map__T__s_Option__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__T2($thiz, byId$18, g$29, rd$1, cxOv$13, allX$12, yOf$13, rankOf$15, id, portOpt, otherCanon) {
  if (portOpt.c()) {
    var x117 = $m_s_None$();
  } else {
    var x0 = portOpt.d();
    var this$1 = byId$18.r(id);
    if (this$1.c()) {
      var x117 = $m_s_None$();
    } else {
      var x0$1 = this$1.d();
      var this$2 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$().agn(x0$1, g$29, x0);
      var this$3 = (this$2.c() ? $m_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$().agm(x0$1, g$29, x0) : this$2);
      var x117 = (this$3.c() ? $m_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$().aP3(x0$1, g$29, x0) : this$3);
    }
  }
  if (($m_s_None$() === x117)) {
    return new $c_T2($m_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort$().RO, true);
  }
  if ((x117 instanceof $c_s_Some)) {
    var gp0 = x117.J;
    if (gp0.Bu) {
      var this$7 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$();
      var _1$1 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv$13, allX$12, id);
      var _2 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cy$1__sci_Map__sci_Map__T__D($thiz, yOf$13, rankOf$15, id);
      var _1$2 = otherCanon.W;
      var _2$1 = otherCanon.a6;
      matchResult24: {
        var $x_1;
        var x78 = gp0.z0;
        if (($m_s_None$() === x78)) {
          var $x_1 = gp0;
          break matchResult24;
        }
        if ((x78 instanceof $c_s_Some)) {
          var bp = x78.J;
          var sides = gp0.fV;
          if (((sides === 0) || (sides === this$7.ZT))) {
            var $x_2 = $m_s_None$();
          } else {
            matchResult25: {
              var \u03b45$___1;
              var \u03b45$___2;
              var \u03b45$___3;
              var \u03b45$___4;
              if ((bp !== null)) {
                var \u03b45$___1 = (+bp.bO);
                var \u03b45$___2 = (+bp.bs);
                var \u03b45$___3 = (+bp.ch);
                var \u03b45$___4 = (+bp.ca);
                break matchResult25;
              }
              throw new $c_s_MatchError(bp);
            }
            var llx$2 = (+\u03b45$___1);
            var lly$2 = (+\u03b45$___2);
            var urx$2 = (+\u03b45$___3);
            var ury$2 = (+\u03b45$___4);
            matchResult26: {
              var \u03b46$___1;
              var \u03b46$___2;
              var x86 = this$7.aNh(_1$1, _2, rd$1);
              if ((x86 !== null)) {
                var \u03b46$___1 = (+x86.g());
                var \u03b46$___2 = (+x86.h());
                break matchResult26;
              }
              throw new $c_s_MatchError(x86);
            }
            var ptx$2 = (+\u03b46$___1);
            var pty$2 = (+\u03b46$___2);
            matchResult27: {
              var \u03b47$___1;
              var \u03b47$___2;
              var x89 = this$7.aNh(_1$2, _2$1, rd$1);
              if ((x89 !== null)) {
                var \u03b47$___1 = (+x89.g());
                var \u03b47$___2 = (+x89.h());
                break matchResult27;
              }
              throw new $c_s_MatchError(x89);
            }
            var otx$2 = (+\u03b47$___1);
            var oty$2 = (+\u03b47$___2);
            var best = (-1);
            var mind = 0.0;
            var i = 0;
            while ((i < 4)) {
              if (((sides & (1 << i)) !== 0)) {
                var \u03b48$___1;
                var \u03b48$___2;
                switch (i) {
                  case 0: {
                    var \u03b48$___1 = (0.5 * (llx$2 + urx$2));
                    var \u03b48$___2 = lly$2;
                    break;
                  }
                  case 1: {
                    var \u03b48$___1 = urx$2;
                    var \u03b48$___2 = (0.5 * (lly$2 + ury$2));
                    break;
                  }
                  case 2: {
                    var \u03b48$___1 = (0.5 * (llx$2 + urx$2));
                    var \u03b48$___2 = ury$2;
                    break;
                  }
                  default: {
                    var \u03b48$___1 = llx$2;
                    var \u03b48$___2 = (0.5 * (lly$2 + ury$2));
                  }
                }
                var mx = (+\u03b48$___1);
                var my = (+\u03b48$___2);
                var dx = ((ptx$2 + mx) - otx$2);
                var dy = ((pty$2 + my) - oty$2);
                var d = ((dx * dx) + (dy * dy));
                if (((best < 0) || (d < mind))) {
                  mind = d;
                  best = i;
                }
              }
              i = ((1 + i) | 0);
            }
            var $x_2 = new $c_s_PartialFunction$Lifted($m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass.r().C)([$s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__S__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass(), $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__E__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass(), $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__N__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass(), $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__W__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass()])))).as(best);
          }
          var $x_1 = this$7.Wx(bp, sides, $x_2, rd$1);
          break matchResult24;
        }
        throw new $c_s_MatchError(x78);
      }
    } else {
      var $x_1 = gp0;
    }
    return new $c_T2($x_1, gp0.rq);
  }
  throw new $c_s_MatchError(x117);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__recordPathBox$1__Z__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__scm_HashMap__sci_Map__sci_Map__sci_Map__T__D__s_Option($thiz, flip$1, byId$20, g$34, cxOv$14, allX$13, yOf$14, rankOf$16, id, px) {
  var this$1 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__recRoot$1__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T__s_Option($thiz, byId$20, g$34, id);
  if (this$1.c()) {
    return $m_s_None$();
  } else {
    var x0 = this$1.d();
    var this$2 = x0.hX;
    _return: {
      var it = this$2.o();
      while (it.p()) {
        var a = it.q();
        if (flip$1) {
          var \u03b44$___1 = a.q0;
          var \u03b44$___2 = a.o2;
        } else {
          var \u03b44$___1 = a.n5;
          var \u03b44$___2 = a.q1;
        }
        var ls = (+\u03b44$___1);
        var rs = (+\u03b44$___2);
        if (((ls <= px) && (px <= rs))) {
          var this$5 = new $c_s_Some(a);
          break _return;
        }
      }
      var this$5 = $m_s_None$();
    }
    if (this$5.c()) {
      return $m_s_None$();
    } else {
      var x0$1 = this$5.d();
      var hh = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__halfH$1__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T__D($thiz, byId$20, g$34, id);
      return new $c_s_Some((flip$1 ? new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box(($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv$14, allX$13, id) + x0$1.q0), ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cy$1__sci_Map__sci_Map__T__D($thiz, yOf$14, rankOf$16, id) + x0$1.n5), ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv$14, allX$13, id) + x0$1.o2), ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cy$1__sci_Map__sci_Map__T__D($thiz, yOf$14, rankOf$16, id) + hh)) : new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box(($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv$14, allX$13, id) + x0$1.n5), ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cy$1__sci_Map__sci_Map__T__D($thiz, yOf$14, rankOf$16, id) - hh), ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv$14, allX$13, id) + x0$1.q1), ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cy$1__sci_Map__sci_Map__T__D($thiz, yOf$14, rankOf$16, id) + hh))));
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__beginPathR$1__D__D__scm_HashMap__sci_Map__sci_Map__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__scm_HashMap__sci_Map__D__sci_Map__sci_Map__sci_Set__D__scm_HashMap__Z__T__Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box__T4($thiz, RanksepPt$1, BpFudge$1, cxOv$17, allX$16, yOf$17, rankOf$19, byId$23, g$37, lwOv$7, labelW$16, NodeSep$14, flatLabelHalf$15, nodeOf$23, intraVEdge$15, VirtualHalf$15, rwOv$7, flip$5, id, gp, nb) {
  var sx = ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv$17, allX$16, id) + gp.pW);
  var sy = ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cy$1__sci_Map__sci_Map__T__D($thiz, yOf$17, rankOf$19, id) + gp.uB);
  var hh = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__halfH$1__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T__D($thiz, byId$23, g$37, id);
  var th = (gp.uA ? new $c_s_Some(gp.pX) : $m_s_None$());
  if ((gp.fV !== 0)) {
    var ncx = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv$17, allX$16, id);
    var ncy = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cy$1__sci_Map__sci_Map__T__D($thiz, yOf$17, rankOf$19, id);
    if (((gp.fV & $m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$().wK) !== 0)) {
      var bs = ((sx < ncx) ? $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box.r().C)([new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box((nb.aJ - 1.0), sy, nb.aF, ((ncy + hh) + (0.5 * RanksepPt$1))), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box((nb.aJ - 1.0), (ncy - hh), ((ncx - $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__lw$1__scm_HashMap__sci_Map__D__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Set__D__T__D($thiz, lwOv$7, labelW$16, NodeSep$14, flatLabelHalf$15, byId$23, g$37, nodeOf$23, intraVEdge$15, VirtualHalf$15, id)) - (BpFudge$1 - 2.0)), sy)]))) : $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box.r().C)([new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box(nb.aJ, sy, (nb.aF + 1.0), ((ncy + hh) + (0.5 * RanksepPt$1))), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box(((ncx + $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__rw$1__scm_HashMap__sci_Map__D__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Set__D__T__D($thiz, rwOv$7, labelW$16, NodeSep$14, flatLabelHalf$15, byId$23, g$37, nodeOf$23, intraVEdge$15, VirtualHalf$15, id)) + (BpFudge$1 - 2.0)), (ncy - hh), (nb.aF + 1.0), sy)]))));
      sy = (sy + 1.0);
      var boxes = bs;
    } else if (((gp.fV & $m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$().wJ) !== 0)) {
      var $x_3 = nb.aJ;
      var $x_2 = nb.bZ;
      var $x_1 = nb.aF;
      var x = nb.bG;
      var y = sy;
      var b = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box($x_3, $x_2, $x_1, (+Math.max(x, y)));
      sy = (sy - 1.0);
      var boxes = $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box.r().C)([b])));
    } else if (((gp.fV & $m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$().pZ) !== 0)) {
      var b$2 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box(nb.aJ, (ncy - hh), sx, sy);
      sx = (sx - 1.0);
      var boxes = $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box.r().C)([b$2])));
    } else {
      var b$3 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box(sx, (ncy - hh), nb.aF, sy);
      sx = (sx + 1.0);
      var boxes = $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box.r().C)([b$3])));
    }
    return new $c_T4(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(sx, sy), th, boxes, true);
  } else {
    var corridor = (gp.o1 ? $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__recordPathBox$1__Z__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__scm_HashMap__sci_Map__sci_Map__sci_Map__T__D__s_Option($thiz, flip$5, byId$23, g$37, cxOv$17, allX$16, yOf$17, rankOf$19, id, gp.pW) : $m_s_None$());
    if ((corridor instanceof $c_s_Some)) {
      var cb = corridor.J;
      return new $c_T4(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(sx, sy), th, $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box.r().C)([cb]))), false);
    }
    if (($m_s_None$() === corridor)) {
      var b$4 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box(nb.aJ, nb.bZ, nb.aF, sy);
      sy = (sy - 1.0);
      return new $c_T4(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(sx, sy), th, $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box.r().C)([b$4]))), false);
    }
    throw new $c_s_MatchError(corridor);
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__flatEnd$1__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D__sci_Map__sci_Vector__D__D__sr_DoubleRef__sr_DoubleRef__sci_Map__sci_Map__sci_Map__scm_Map__sci_Map__sci_Map__sci_Vector__scm_Map__sci_Map__scm_HashMap__sci_Map__sci_Map__sci_Map__scm_HashMap__sci_Map__sci_Set__D__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo__sci_Map__sci_Vector__sci_Map__T__Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort__Z__s_Option__T2($thiz, g$38, BpFudge$2, rankOf$20, cluBBs$9, Splinesep$3, NodeSep$15, leftBound$5, rightBound$5, orderByRank$5, orderIdx$3, labelW$17, outDeg$5, realOutSeg$4, nodeOf$24, workEnds$7, inDeg$5, realInSeg$4, cxOv$18, allX$17, yOf$18, byId$24, rwOv$8, flatLabelHalf$16, intraVEdge$16, VirtualHalf$16, lwOv$8, yiHt$6, cluOf$6, dedges$5, selfRwSpl$5, id, gp, isBegin, oe) {
  var nb = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__maximalBboxGv$1__sci_Map__sci_Vector__D__D__sr_DoubleRef__sr_DoubleRef__sci_Map__sci_Map__sci_Map__scm_Map__sci_Map__sci_Map__sci_Vector__scm_Map__sci_Map__scm_HashMap__sci_Map__scm_HashMap__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Set__D__sci_Map__sci_Vector__sci_Map__sci_Map__scm_HashMap__Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo__T__s_Option__s_Option__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box($thiz, rankOf$20, cluBBs$9, Splinesep$3, NodeSep$15, leftBound$5, rightBound$5, orderByRank$5, orderIdx$3, labelW$17, outDeg$5, realOutSeg$4, nodeOf$24, workEnds$7, inDeg$5, realInSeg$4, cxOv$18, allX$17, lwOv$8, flatLabelHalf$16, byId$24, g$38, intraVEdge$16, VirtualHalf$16, cluOf$6, dedges$5, yOf$18, selfRwSpl$5, rwOv$8, yiHt$6, id, $m_s_None$(), oe);
  var ncx = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv$18, allX$17, id);
  var ncy = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cy$1__sci_Map__sci_Map__T__D($thiz, yOf$18, rankOf$20, id);
  var hh = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__halfH$1__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T__D($thiz, byId$24, g$38, id);
  var ex = (ncx + gp.pW);
  var ey = (ncy + gp.uB);
  if ((gp.fV === 0)) {
    var boxes = $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box.r().C)([new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box(nb.aJ, ey, nb.aF, nb.bG)])));
  } else if (((gp.fV & $m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$().wK) !== 0)) {
    var $x_1 = nb.aJ;
    var x = nb.bZ;
    var y = ey;
    var b = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box($x_1, (+Math.min(x, y)), nb.aF, nb.bG);
    ey = (ey + 1.0);
    var boxes = $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box.r().C)([b])));
  } else if (((gp.fV & $m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$().wJ) !== 0)) {
    var cut = (ncy - hh);
    var num = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().b1X(g$38);
    var half = (((num + ((num >>> 31) | 0)) | 0) >> 1);
    var bs = (isBegin ? $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box.r().C)([new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box(ex, (cut - half), (nb.aF + 1.0), cut), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box(((ncx + $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__rw$1__scm_HashMap__sci_Map__D__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Set__D__T__D($thiz, rwOv$8, labelW$17, NodeSep$15, flatLabelHalf$16, byId$24, g$38, nodeOf$24, intraVEdge$16, VirtualHalf$16, id)) + (BpFudge$2 - 2.0)), cut, (nb.aF + 1.0), (ncy + hh))]))) : $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box.r().C)([new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box((nb.aJ - 1.0), (cut - half), ex, cut), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box((nb.aJ - 1.0), cut, ((ncx - $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__lw$1__scm_HashMap__sci_Map__D__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Set__D__T__D($thiz, lwOv$8, labelW$17, NodeSep$15, flatLabelHalf$16, byId$24, g$38, nodeOf$24, intraVEdge$16, VirtualHalf$16, id)) - 2.0), (ncy + hh))]))));
    ey = (ey - 1.0);
    var boxes = bs;
  } else if (((gp.fV & $m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$().pZ) !== 0)) {
    var b$2 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box(nb.aJ, (ey - 1.0), (ex + 1.0), (ncy + hh));
    ex = (ex - 1.0);
    var boxes = $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box.r().C)([b$2])));
  } else {
    var b$3 = (isBegin ? new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box(ex, ey, nb.aF, (ncy + hh)) : new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box((ex - 1.0), (ey - 1.0), nb.aF, (ncy + hh)));
    ex = (ex + 1.0);
    var boxes = $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box.r().C)([b$3])));
  }
  var lastB = boxes.bJ();
  var extra = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box(nb.aJ, lastB.bG, nb.aF, (ncy + $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__ht2$1__Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo__I__D($thiz, yiHt$6, (rankOf$20.i(id) | 0))));
  if (((extra.aJ < extra.aF) && (extra.bZ < extra.bG))) {
    boxes = boxes.bv(extra);
  }
  return new $c_T2(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(ex, ey), boxes);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__endPathR$1__D__D__scm_HashMap__sci_Map__sci_Map__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__scm_HashMap__sci_Map__D__sci_Map__sci_Map__sci_Set__D__scm_HashMap__Z__T__Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box__T4($thiz, RanksepPt$2, BpFudge$3, cxOv$19, allX$18, yOf$19, rankOf$21, byId$25, g$39, lwOv$9, labelW$18, NodeSep$16, flatLabelHalf$17, nodeOf$25, intraVEdge$17, VirtualHalf$17, rwOv$9, flip$6, id, gp, nb) {
  var ex = ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv$19, allX$18, id) + gp.pW);
  var ey = ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cy$1__sci_Map__sci_Map__T__D($thiz, yOf$19, rankOf$21, id) + gp.uB);
  var hh = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__halfH$1__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T__D($thiz, byId$25, g$39, id);
  var th = (gp.uA ? new $c_s_Some(gp.pX) : $m_s_None$());
  if ((gp.fV !== 0)) {
    var ncx = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv$19, allX$18, id);
    var ncy = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cy$1__sci_Map__sci_Map__T__D($thiz, yOf$19, rankOf$21, id);
    if (((gp.fV & $m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$().wK) !== 0)) {
      var $x_1 = nb.aJ;
      var x = nb.bZ;
      var y = ey;
      var b = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box($x_1, (+Math.min(x, y)), nb.aF, nb.bG);
      ey = (ey + 1.0);
      var boxes = $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box.r().C)([b])));
    } else if (((gp.fV & $m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$().wJ) !== 0)) {
      var bs = ((ex < ncx) ? $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box.r().C)([new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box((nb.aJ - 1.0), ((ncy - hh) - (0.5 * RanksepPt$2)), nb.aF, ey), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box((nb.aJ - 1.0), ey, ((ncx - $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__lw$1__scm_HashMap__sci_Map__D__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Set__D__T__D($thiz, lwOv$9, labelW$18, NodeSep$16, flatLabelHalf$17, byId$25, g$39, nodeOf$25, intraVEdge$17, VirtualHalf$17, id)) - (BpFudge$3 - 2.0)), (ncy + hh))]))) : $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box.r().C)([new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box(nb.aJ, ((ncy - hh) - (0.5 * RanksepPt$2)), (nb.aF + 1.0), ey), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box(((ncx + $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__rw$1__scm_HashMap__sci_Map__D__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Set__D__T__D($thiz, rwOv$9, labelW$18, NodeSep$16, flatLabelHalf$17, byId$25, g$39, nodeOf$25, intraVEdge$17, VirtualHalf$17, id)) + (BpFudge$3 - 2.0)), ey, (nb.aF + 1.0), (ncy + hh))]))));
      ey = (ey - 1.0);
      var boxes = bs;
    } else if (((gp.fV & $m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$().pZ) !== 0)) {
      var b$2 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box(nb.aJ, ey, ex, (ncy + hh));
      ex = (ex - 1.0);
      var boxes = $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box.r().C)([b$2])));
    } else {
      var b$3 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box(ex, ey, nb.aF, (ncy + hh));
      ex = (ex + 1.0);
      var boxes = $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box.r().C)([b$3])));
    }
    return new $c_T4(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(ex, ey), th, boxes, true);
  } else {
    var corridor = (gp.o1 ? $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__recordPathBox$1__Z__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__scm_HashMap__sci_Map__sci_Map__sci_Map__T__D__s_Option($thiz, flip$6, byId$25, g$39, cxOv$19, allX$18, yOf$19, rankOf$21, id, gp.pW) : $m_s_None$());
    if ((corridor instanceof $c_s_Some)) {
      var cb = corridor.J;
      return new $c_T4(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(ex, ey), th, $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box.r().C)([cb]))), false);
    }
    if (($m_s_None$() === corridor)) {
      var b$4 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box(nb.aJ, ey, nb.aF, nb.bG);
      ey = (ey + 1.0);
      return new $c_T4(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(ex, ey), th, $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box.r().C)([b$4]))), false);
    }
    throw new $c_s_MatchError(corridor);
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__isLabelledFlat$1__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_REdge__Z($thiz, rankOf$24, e) {
  if ((e.ai !== e.ak)) {
    var this$2 = e.b4.ag.r("label");
    var $x_1 = ((!this$2.c()) && (this$2.d() !== ""));
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    var this$5 = rankOf$24.r(e.ai);
    if ((!this$5.c())) {
      var x0$1 = this$5.d();
      var rt = (x0$1 | 0);
      return rankOf$24.r(e.ak).E(rt);
    } else {
      return false;
    }
  } else {
    return false;
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__segAt$1__sci_Vector__I__T2($thiz, pathTopDown$1, i) {
  return new $c_T2(pathTopDown$1.l(i), pathTopDown$1.l(((1 + i) | 0)));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__straightLen$1__sci_Map__sci_Vector__scm_Map__scm_Map__scm_HashMap__sci_Map__T__I($thiz, nodeOf$38, workEnds$10, outDeg$9, inDeg$9, cxOv$41, allX$40, v0) {
  var cnt = 0;
  var v = v0;
  var go = true;
  while (go) {
    var w = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__chainNextOf$1__sci_Map__sci_Vector__T__T($thiz, nodeOf$38, workEnds$10, v);
    if (((((!(!(!w.startsWith("__v")))) || ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__outSize$1__scm_Map__T__I($thiz, outDeg$9, w) !== 1)) || ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__inSize$1__scm_Map__T__I($thiz, inDeg$9, w) !== 1)) || ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv$41, allX$40, w) !== $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__cx$1__scm_HashMap__sci_Map__T__D($thiz, cxOv$41, allX$40, v0)))) {
      go = false;
    } else {
      cnt = ((1 + cnt) | 0);
      v = w;
    }
  }
  return cnt;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__addBox$1__scm_ArrayBuffer__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box__V($thiz, boxes$2, b) {
  if (((b.aJ < b.aF) && (b.bZ < b.bG))) {
    boxes$2.aw(b);
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__routeSeg$1__sr_ObjectRef__scm_ArrayBuffer__sr_ObjectRef__Z__Z__sr_ObjectRef__scm_ArrayBuffer__sci_Vector__sr_IntRef__I__scm_HashMap__scm_HashMap__scm_HashMap__scm_HashMap__sci_Map__sci_Map__sci_Map__D__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Set__D__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__V($thiz, curTend$1, boxesBuf$1, curStart$1, polylineMode$2, lineMode$2, curEv0$1, pointfs$1, pathTopDown$2, segStart$1, origIdx$2, cxOv$29, lwOv$15, rwOv$15, labelPos$4, yOf$29, rankOf$36, labelW$24, NodeSep$22, flatLabelHalf$23, byId$33, g$49, nodeOf$31, intraVEdge$23, VirtualHalf$23, hend, endPt, ev1) {
  $m_scm_ArrayBuffer$();
  var boxes = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  curTend$1.aD.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((b) => {
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__addBox$1__scm_ArrayBuffer__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box__V($thiz, boxes, b);
  })));
  var fb = ((1 + boxes.a1) | 0);
  var lb = ((((fb + boxesBuf$1.a1) | 0) - 3) | 0);
  var it = boxesBuf$1.bB().o();
  while (it.p()) {
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__addBox$1__scm_ArrayBuffer__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box__V($thiz, boxes, it.q());
  }
  $f_sc_IndexedSeqOps__reverse__O(hend).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((b$3) => {
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__addBox$1__scm_ArrayBuffer__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box__V($thiz, boxes, b$3);
  })));
  $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__adjustRegularPath__scm_ArrayBuffer__I__I__V($thiz, boxes, fb, lb);
  var st = new $ac_D(new Float64Array([curStart$1.aD.W, curStart$1.aD.a6]));
  var en = new $ac_D(new Float64Array([endPt.W, endPt.a6]));
  if ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__checkpath__scm_ArrayBuffer__AD__AD__Z($thiz, boxes, st, en)) {
    var seg = $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY.r().C)([new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(st.a[0], st.a[1]), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(en.a[0], en.a[1])])));
  } else {
    var sp = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__funnel__scm_ArrayBuffer__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__sci_Vector($thiz, boxes, new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(st.a[0], st.a[1]), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(en.a[0], en.a[1]));
    var seg = ((polylineMode$2 || lineMode$2) ? $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__makePolyline$1__sci_Vector__sci_Vector($thiz, sp) : $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__proutespline__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__sci_Vector($thiz, $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__buildPolygon__scm_ArrayBuffer__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($thiz, boxes), sp, curEv0$1.aD, ev1));
  }
  if ((lineMode$2 && (seg.C() > 4))) {
    pointfs$1.aw(seg.t());
    pointfs$1.aw(seg.t());
    pointfs$1.aw(seg.bJ());
    pointfs$1.aw(seg.bJ());
  } else {
    pointfs$1.gS(seg);
  }
  $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__limitBoxes$1__scm_ArrayBuffer__sci_Vector__V($thiz, boxes, seg);
  $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__recoverSlack$1__scm_HashMap__scm_HashMap__scm_HashMap__scm_HashMap__sci_Map__sci_Map__sci_Map__D__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Set__D__sci_Vector__scm_ArrayBuffer__I__V($thiz, cxOv$29, lwOv$15, rwOv$15, labelPos$4, yOf$29, rankOf$36, labelW$24, NodeSep$22, flatLabelHalf$23, byId$33, g$49, nodeOf$31, intraVEdge$23, VirtualHalf$23, pathTopDown$2.pH(((1 + segStart$1.an) | 0), ((pathTopDown$2.C() - 1) | 0)), boxes, origIdx$2);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__install$1__scm_LinkedHashMap__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__F1__Z__Z__Z__Z__I__I__Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort__Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort__I__Lorg_jpablo_graphexplorer_graphviz_model_REdge__sci_Vector__Z__V($thiz, out$2, g$50, byId$34, centerOf$4, tOrigClip$1, tCleared$1, hOrigClip$1, hCleared$1, rt$1, rh$1, tGp$1, hGp$1, oIx, me, pts, isRep) {
  $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(out$2, oIx, $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__clipInstall__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_model_REdge__sci_Map__F1__Z__Z__Z__s_Option__s_Option__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$ESpline($thiz, g$50, pts, me, byId$34, centerOf$4, (tOrigClip$1 && (!(isRep && tCleared$1))), (hOrigClip$1 && (!(isRep && hCleared$1))), (rt$1 > rh$1), (tGp$1.o1 ? tGp$1.z0 : $m_s_None$()), (hGp$1.o1 ? hGp$1.z0 : $m_s_None$())), false);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__selfTop$1__D__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__scm_HashMap__scm_LinkedHashMap__sci_Map__F1__scm_HashMap__sci_Map__sci_Map__sci_Map__sci_Set__D__scm_HashMap__T__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort__Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort__D__I__V($thiz, NodeSep$24, g$52, labelPos$5, out$4, byId$36, centerOf$6, lwOv$16, labelW$26, flatLabelHalf$24, nodeOf$32, intraVEdge$24, VirtualHalf$24, rwOv$16, nid, group, np, tGp, hGp, stepy, cnt) {
  var x = ((0.5 * NodeSep$24) / cnt);
  var stepx = (+Math.max(x, 2.0));
  var tp = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY((np.W + tGp.pW), (np.a6 + tGp.uB));
  var hp = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY((np.W + hGp.pW), (np.a6 + hGp.uB));
  var sgn = ((tp.W >= hp.W) ? 1.0 : (-1.0));
  var vertices = $m_sci_Vector$().X($m_sr_ScalaRunTime$().a5i($constArrUVals_I(8, "iac_`^fe")));
  var ti = $f_sc_SeqOps__indexOf__O__I__I(vertices, tGp.fV, 0);
  var hi = $f_sc_SeqOps__indexOf__O__I__I(vertices, hGp.fV, 0);
  var pointPair = (((ti < 0) || (hi < 0)) ? 0 : ((Math.imul(10, ((1 + ti) | 0)) + ((1 + hi) | 0)) | 0));
  var nlw = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__lw$1__scm_HashMap__sci_Map__D__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Set__D__T__D($thiz, lwOv$16, labelW$26, NodeSep$24, flatLabelHalf$24, byId$36, g$52, nodeOf$32, intraVEdge$24, VirtualHalf$24, nid);
  var nrw = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__rw$1__scm_HashMap__sci_Map__D__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Set__D__T__D($thiz, rwOv$16, labelW$26, NodeSep$24, flatLabelHalf$24, byId$36, g$52, nodeOf$32, intraVEdge$24, VirtualHalf$24, nid);
  var $x_1;
  switch (pointPair) {
    case 15: {
      var $x_1 = (sgn * ((nrw - (hp.W - np.W)) + stepx));
      break;
    }
    case 38: {
      var $x_1 = (sgn * ((nlw - (np.W - hp.W)) + stepx));
      break;
    }
    case 41:
    case 48: {
      var $x_1 = (sgn * ((nrw - (tp.W - np.W)) + stepx));
      break;
    }
    case 14:
    case 37:
    case 47:
    case 51:
    case 57:
    case 58: {
      var $x_1 = (sgn * (((nlw - (np.W - tp.W)) + (nrw - (hp.W - np.W))) / 3.0));
      break;
    }
    case 73: {
      var $x_1 = (sgn * ((nlw - (np.W - tp.W)) + stepx));
      break;
    }
    case 83: {
      var $x_1 = (sgn * (nlw - (np.W - tp.W)));
      break;
    }
    case 84: {
      var $x_1 = (sgn * ((0.5 * ((nlw - (np.W - tp.W)) + (nrw - (hp.W - np.W)))) + stepx));
      break;
    }
    case 74:
    case 75:
    case 85: {
      var $x_1 = (sgn * ((0.5 * ((nlw - (np.W - tp.W)) + (nrw - (hp.W - np.W)))) + (2.0 * stepx)));
      break;
    }
    default: {
      var $x_1 = 0.0;
    }
  }
  var dx = new $c_sr_DoubleRef($x_1);
  var dy = new $c_sr_DoubleRef($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__halfH$1__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T__D($thiz, byId$36, g$52, nid));
  var x$3 = dy.T;
  var y$2 = (3.0 * ((np.a6 + dy.T) - tp.a6));
  var ty = new $c_sr_DoubleRef((+Math.min(x$3, y$2)));
  var x$4 = dy.T;
  var y$3 = (3.0 * ((np.a6 + dy.T) - hp.a6));
  var hy = new $c_sr_DoubleRef((+Math.min(x$4, y$3)));
  group.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$1) => {
    matchResult62: {
      if ((x$1$1 !== null)) {
        var e = x$1$1.g();
        var origIdx = (x$1$1.h() | 0);
        dy.T = (dy.T + stepy);
        ty.T = (ty.T + stepy);
        hy.T = (hy.T + stepy);
        dx.T = (dx.T + (sgn * stepx));
        var pts = $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY.r().C)([tp, new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY((tp.W + dx.T), (tp.a6 + (ty.T / 3.0))), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY((tp.W + dx.T), (np.a6 + dy.T)), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY((0.5 * (tp.W + hp.W)), (np.a6 + dy.T)), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY((hp.W - dx.T), (np.a6 + dy.T)), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY((hp.W - dx.T), (hp.a6 + (hy.T / 3.0))), hp])));
        var this$22 = e.b4.ag.r("label");
        var this$25 = ((this$22.c() || (this$22.d() !== "")) ? this$22 : $m_s_None$());
        if ((!this$25.c())) {
          this$25.d();
          matchResult61: {
            var \u03b422$___1;
            var \u03b422$___2;
            var x212 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().tX(e, g$52);
            if ((x212 !== null)) {
              var \u03b422$___1 = (+x212.g());
              var \u03b422$___2 = (+x212.h());
              break matchResult61;
            }
            throw new $c_s_MatchError(x212);
          }
          var wl$2 = (+\u03b422$___1);
          var hl$2 = (+\u03b422$___2);
          var height = ($m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().jT(g$52) ? wl$2 : hl$2);
          $p_scm_HashMap__put0__O__O__Z__s_Some(labelPos$5, origIdx, new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(np.W, ((np.a6 + dy.T) + (0.5 * height))), false);
          if ((height > stepy)) {
            dy.T = (dy.T + (height - stepy));
          }
        }
        $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(out$4, origIdx, $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__clipInstall__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_model_REdge__sci_Map__F1__Z__Z__Z__s_Option__s_Option__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$ESpline($thiz, g$52, pts, e, byId$36, centerOf$6, tGp.rq, hGp.rq, false, $m_s_None$(), $m_s_None$()), false);
        break matchResult62;
      }
      throw new $c_s_MatchError(x$1$1);
    }
  })));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__prevNext$1__scm_ArrayBuffer__I__I__T2($thiz, boxes$3, n$5, bi) {
  return new $c_T2(((bi > 0) ? ((boxes$3.l(bi).bZ > boxes$3.l(((bi - 1) | 0)).bZ) ? (-1) : 1) : 0), ((((1 + bi) | 0) < n$5) ? ((boxes$3.l(((1 + bi) | 0)).bZ > boxes$3.l(bi).bZ) ? 1 : (-1)) : 0));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__triArea2$1__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__D($thiz, a, b, c) {
  return (((b.W - a.W) * (c.a6 - a.a6)) - ((c.W - a.W) * (b.a6 - a.a6)));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__eq$1__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Z($thiz, a, b) {
  var x = (a.W - b.W);
  if (((+Math.abs(x)) < 1.0E-9)) {
    var x$1 = (a.a6 - b.a6);
    return ((+Math.abs(x$1)) < 1.0E-9);
  } else {
    return false;
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__insideFn$1__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__F1__T__s_Option($thiz, byId$40, g$58, centerOf$10, id) {
  var this$1 = byId$40.r(id);
  if (this$1.c()) {
    return $m_s_None$();
  } else {
    var x0 = this$1.d();
    var this$3 = x0.aK.ag.r("shape");
    var shapeName = (this$3.c() ? "" : this$3.d());
    var x265 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$().afh(shapeName);
    if ((x265 instanceof $c_s_Some)) {
      var this$4 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().ahv(x0, g$58);
      if (this$4.c()) {
        return $m_s_None$();
      } else {
        var x0$1 = this$4.d();
        var cen = centerOf$10.i(id);
        var rd = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().pD(g$58);
        var ol = x0$1.KW;
        var m = ol.C();
        return new $c_s_Some(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((boxURx, boxURy, last) => ((p) => {
          matchResult72: {
            var \u03b431$___1;
            var \u03b431$___2;
            var x250 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$().a2S((p.W - cen.W), (p.a6 - cen.a6), rd);
            if ((x250 !== null)) {
              var \u03b431$___1 = (+x250.g());
              var \u03b431$___2 = (+x250.h());
              break matchResult72;
            }
            throw new $c_s_MatchError(x250);
          }
          var px$2 = (+\u03b431$___1);
          var py$2 = (+\u03b431$___2);
          if ((!(((+Math.abs(px$2)) > boxURx) || ((+Math.abs(py$2)) > boxURy)))) {
            var i = ((last.an % $checkIntDivisor(m)) | 0);
            var i1 = ((((1 + i) | 0) % $checkIntDivisor(m)) | 0);
            matchResult73: {
              var \u03b432$___1;
              var \u03b432$___2;
              var x253 = ol.l(i);
              if ((x253 !== null)) {
                var \u03b432$___1 = (+x253.g());
                var \u03b432$___2 = (+x253.h());
                break matchResult73;
              }
              throw new $c_s_MatchError(x253);
            }
            var qx$2 = (+\u03b432$___1);
            var qy$2 = (+\u03b432$___2);
            matchResult74: {
              var \u03b433$___1;
              var \u03b433$___2;
              var x256 = ol.l(i1);
              if ((x256 !== null)) {
                var \u03b433$___1 = (+x256.g());
                var \u03b433$___2 = (+x256.h());
                break matchResult74;
              }
              throw new $c_s_MatchError(x256);
            }
            var rx$2 = (+\u03b433$___1);
            var ry$2 = (+\u03b433$___2);
            if ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__sameSide__D__D__D__D__D__D__D__D__Z($m_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$(), px$2, py$2, 0.0, 0.0, qx$2, qy$2, rx$2, ry$2)) {
              var s = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__sameSide__D__D__D__D__D__D__D__D__Z($m_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$(), px$2, py$2, qx$2, qy$2, rx$2, ry$2, 0.0, 0.0);
              if ((s && $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__sameSide__D__D__D__D__D__D__D__D__Z($m_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$(), px$2, py$2, rx$2, ry$2, 0.0, 0.0, qx$2, qy$2))) {
                return true;
              } else {
                var j = 1;
                var res = true;
                var done = false;
                while (((j < m) && (!done))) {
                  if (s) {
                    i = i1;
                    i1 = ((((1 + i) | 0) % $checkIntDivisor(m)) | 0);
                  } else {
                    i1 = i;
                    i = ((((((i + m) | 0) - 1) | 0) % $checkIntDivisor(m)) | 0);
                  }
                  matchResult75: {
                    var \u03b434$___1;
                    var \u03b434$___2;
                    var x259 = ol.l(i);
                    if ((x259 !== null)) {
                      var \u03b434$___1 = (+x259.g());
                      var \u03b434$___2 = (+x259.h());
                      break matchResult75;
                    }
                    throw new $c_s_MatchError(x259);
                  }
                  var ax$2 = (+\u03b434$___1);
                  var ay$2 = (+\u03b434$___2);
                  matchResult76: {
                    var \u03b435$___1;
                    var \u03b435$___2;
                    var x262 = ol.l(i1);
                    if ((x262 !== null)) {
                      var \u03b435$___1 = (+x262.g());
                      var \u03b435$___2 = (+x262.h());
                      break matchResult76;
                    }
                    throw new $c_s_MatchError(x262);
                  }
                  var bx$2 = (+\u03b435$___1);
                  var by$2 = (+\u03b435$___2);
                  if ((!$p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__sameSide__D__D__D__D__D__D__D__D__Z($m_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$(), px$2, py$2, 0.0, 0.0, ax$2, ay$2, bx$2, by$2))) {
                    last.an = i;
                    res = false;
                    done = true;
                  }
                  j = ((1 + j) | 0);
                }
                if (res) {
                  last.an = i;
                }
                return res;
              }
            } else {
              return false;
            }
          } else {
            return false;
          }
        }))((+$f_sc_IterableOnceOps__max__s_math_Ordering__O(new $c_sc_Iterator$$anon$9(ol.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v) => {
          var x = (+v.g());
          return (+Math.abs(x));
        }))), $m_s_math_Ordering$DeprecatedDoubleOrdering$())), (+$f_sc_IterableOnceOps__max__s_math_Ordering__O(new $c_sc_Iterator$$anon$9(ol.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v$2) => {
          var x$1 = (+v$2.h());
          return (+Math.abs(x$1));
        }))), $m_s_math_Ordering$DeprecatedDoubleOrdering$())), new $c_sr_IntRef(0))));
      }
    }
    if (($m_s_None$() === x265)) {
      if ($m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_T.r().C)(["record", "mrecord"]))).E(shapeName.toLowerCase())) {
        var this$24 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().PN(x0, g$58);
        if (this$24.c()) {
          return $m_s_None$();
        } else {
          var x0$2 = this$24.d();
          var _1 = x0$2.n5;
          var _2 = x0$2.q0;
          var _3 = x0$2.q1;
          var _4 = x0$2.o2;
          var cen$1 = centerOf$10.i(id);
          var rd$1 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().pD(g$58);
          var this$26 = byId$40.r(id);
          var this$28 = (this$26.c() ? $m_s_None$() : this$26.d().aK.ag.r("penwidth"));
          if (this$28.c()) {
            var this$32 = $m_s_None$();
          } else {
            var x0$4 = this$28.d();
            var this$32 = ($m_sc_StringParsers$().c1(x0$4) ? new $c_s_Some($m_jl_Double$().bd(x0$4)) : $m_s_None$());
          }
          if (this$32.c()) {
            var this$35 = $m_s_None$();
          } else {
            var x0$5 = this$32.d();
            var _$44 = (+x0$5);
            var this$35 = new $c_s_Some((+Math.max(0.0, _$44)));
          }
          var pw = (0.5 * (+(this$35.c() ? $m_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$().ZW : this$35.d())));
          var \u03b436$___1;
          var \u03b436$___2;
          var \u03b436$___3;
          var \u03b436$___4;
          var \u03b436$___1 = _1;
          var \u03b436$___2 = _2;
          var \u03b436$___3 = _3;
          var \u03b436$___4 = _4;
          var bllx$2 = (+\u03b436$___1);
          var blly$2 = (+\u03b436$___2);
          return new $c_s_Some(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((burx$2, bury$2) => ((p$1) => {
            matchResult79: {
              var \u03b437$___1;
              var \u03b437$___2;
              var x273 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$().a2S((p$1.W - cen$1.W), (p$1.a6 - cen$1.a6), rd$1);
              if ((x273 !== null)) {
                var \u03b437$___1 = (+x273.g());
                var \u03b437$___2 = (+x273.h());
                break matchResult79;
              }
              throw new $c_s_MatchError(x273);
            }
            var tx$2 = (+\u03b437$___1);
            var ty$2 = (+\u03b437$___2);
            return (((((bllx$2 - pw) <= tx$2) && (tx$2 <= (burx$2 + pw))) && ((blly$2 - pw) <= ty$2)) && (ty$2 <= (bury$2 + pw)));
          }))((+\u03b436$___3), (+\u03b436$___4))));
        }
      }
      var this$38 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().J9(x0, g$58);
      if (this$38.c()) {
        return $m_s_None$();
      } else {
        var x0$6 = this$38.d();
        var cen$2 = centerOf$10.i(id);
        var plain = $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_T.r().C)(["plaintext", "none", "plain"]))).E(shapeName);
        if (plain) {
          var pw$1 = 0.0;
        } else {
          var this$41 = x0.aK.ag.r("penwidth");
          if (this$41.c()) {
            var this$45 = $m_s_None$();
          } else {
            var x0$7 = this$41.d();
            var this$45 = ($m_sc_StringParsers$().c1(x0$7) ? new $c_s_Some($m_jl_Double$().bd(x0$7)) : $m_s_None$());
          }
          if (this$45.c()) {
            var this$48 = $m_s_None$();
          } else {
            var x0$8 = this$45.d();
            var _$41 = (+x0$8);
            var this$48 = new $c_s_Some((+Math.max(0.0, _$41)));
          }
          var pw$1 = (+(this$48.c() ? $m_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$().ZW : this$48.d()));
        }
        var x$proxy19 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().aiC(x0$6);
        var urx = (0.5 * (x$proxy19 + pw$1));
        var x$proxy20 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().agq(x0$6);
        var ury = (0.5 * (x$proxy20 + pw$1));
        return new $c_s_Some(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((sz$2, boxLike) => ((p$2) => {
          var px$1 = (p$2.W - cen$2.W);
          var py$1 = (p$2.a6 - cen$2.a6);
          if (($m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().aiC(sz$2) === 0.0)) {
            px$1 = 0.0;
          }
          if (($m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().agq(sz$2) === 0.0)) {
            py$1 = 0.0;
          }
          if (boxLike) {
            var x$3 = px$1;
            if (((+Math.abs(x$3)) <= urx)) {
              var x$4 = py$1;
              return ((+Math.abs(x$4)) <= ury);
            } else {
              return false;
            }
          } else {
            var x$5 = px$1;
            if (((+Math.abs(x$5)) > urx)) {
              var $x_1 = true;
            } else {
              var x$6 = py$1;
              var $x_1 = ((+Math.abs(x$6)) > ury);
            }
            if ((!$x_1)) {
              return ($m_jl_Math$().ga((px$1 / urx), (py$1 / ury)) < 1.0);
            } else {
              return false;
            }
          }
        }))(x0$6, ((plain || $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_T.r().C)(["box", "rect", "rectangle", "square", "Msquare", "underline", "image"]))).E(shapeName)) || $m_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$().RR.E(shapeName)))));
      }
    }
    throw new $c_s_MatchError(x265);
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__shapeClip0$1__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__I__F1__Z__V($thiz, ps$1, seg, inside, leftInside) {
  var w = new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY.r().C)([ps$1.a[seg], ps$1.a[((1 + seg) | 0)], ps$1.a[((2 + seg) | 0)], ps$1.a[((3 + seg) | 0)]]);
  $thiz.aXW(w, leftInside, inside);
  var k = 0;
  while ((k < 4)) {
    ps$1.a[((seg + k) | 0)] = w.a[k];
    k = ((1 + k) | 0);
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__approxEq$1__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Z($thiz, a, b) {
  var x = (a.W - b.W);
  if (((+Math.abs(x)) < 0.001)) {
    var x$1 = (a.a6 - b.a6);
    return ((+Math.abs(x$1)) < 0.001);
  } else {
    return false;
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__bpInsideFn$1__F1__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__T__T4__F1($thiz, centerOf$15, g$62, byId$43, id, bp) {
  var cen = centerOf$15.i(id);
  var rd = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().pD(g$62);
  var this$1 = byId$43.r(id);
  var this$3 = (this$1.c() ? $m_s_None$() : this$1.d().aK.ag.r("penwidth"));
  if (this$3.c()) {
    var this$7 = $m_s_None$();
  } else {
    var x0$1 = this$3.d();
    var this$7 = ($m_sc_StringParsers$().c1(x0$1) ? new $c_s_Some($m_jl_Double$().bd(x0$1)) : $m_s_None$());
  }
  if (this$7.c()) {
    var this$10 = $m_s_None$();
  } else {
    var x0$2 = this$7.d();
    var _$44 = (+x0$2);
    var this$10 = new $c_s_Some((+Math.max(0.0, _$44)));
  }
  var pw = (0.5 * (+(this$10.c() ? $m_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$().ZW : this$10.d())));
  matchResult78: {
    var \u03b436$___1;
    var \u03b436$___2;
    var \u03b436$___3;
    var \u03b436$___4;
    if ((bp !== null)) {
      var \u03b436$___1 = (+bp.bO);
      var \u03b436$___2 = (+bp.bs);
      var \u03b436$___3 = (+bp.ch);
      var \u03b436$___4 = (+bp.ca);
      break matchResult78;
    }
    throw new $c_s_MatchError(bp);
  }
  var bllx$2 = (+\u03b436$___1);
  var blly$2 = (+\u03b436$___2);
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((burx$2, bury$2) => ((p) => {
    matchResult79: {
      var \u03b437$___1;
      var \u03b437$___2;
      var x273 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$().a2S((p.W - cen.W), (p.a6 - cen.a6), rd);
      if ((x273 !== null)) {
        var \u03b437$___1 = (+x273.g());
        var \u03b437$___2 = (+x273.h());
        break matchResult79;
      }
      throw new $c_s_MatchError(x273);
    }
    var tx$2 = (+\u03b437$___1);
    var ty$2 = (+\u03b437$___2);
    return (((((bllx$2 - pw) <= tx$2) && (tx$2 <= (burx$2 + pw))) && ((blly$2 - pw) <= ty$2)) && (ty$2 <= (bury$2 + pw)));
  }))((+\u03b436$___3), (+\u03b436$___4)));
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$() {
  this.n6 = 0.0;
  this.RS = 0.0;
  this.a85 = 0.0;
  this.a86 = null;
  this.a84 = 0.0;
  this.ZW = 0.0;
  $n_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$ = this;
  this.n6 = 16.0;
  this.RS = 8.0;
  this.a85 = 4.0;
  this.a86 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_GraphMemo();
  this.a84 = 1.0E-7;
  this.ZW = 1.0;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$.prototype = $p;
$p.a4K = (function(g) {
  var this$1 = this.a86;
  if ((g === this$1.f0)) {
    var $x_1 = this$1.f1;
  } else {
    var v = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__splinesExImpl__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T2($m_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$(), g);
    this$1.f0 = g;
    this$1.f1 = v;
    var $x_1 = v;
  }
  return $x_1.g();
});
$p.a43 = (function(g) {
  var this$1 = this.a86;
  if ((g === this$1.f0)) {
    var $x_1 = this$1.f1;
  } else {
    var v = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__splinesExImpl__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T2($m_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$(), g);
    this$1.f0 = g;
    this$1.f1 = v;
    var $x_1 = v;
  }
  return $x_1.h();
});
$p.aXW = (function(sp, leftInside, inside) {
  var seg = sp.ae();
  var best = sp.ae();
  var found = false;
  var low = 0.0;
  var high = 1.0;
  var pt = (leftInside ? sp.a[0] : sp.a[3]);
  var opt = pt;
  var first = true;
  while (true) {
    if (first) {
      var $x_2 = true;
    } else {
      var x = (opt.W - pt.W);
      var $x_2 = ((+Math.abs(x)) > 0.5);
    }
    if ($x_2) {
      var $x_1 = true;
    } else {
      var x$1 = (opt.a6 - pt.a6);
      var $x_1 = ((+Math.abs(x$1)) > 0.5);
    }
    if ($x_1) {
      first = false;
      opt = pt;
      var t = (0.5 * (high + low));
      matchResult71: {
        var \u03b428$___1;
        var \u03b428$___2;
        var \u03b428$___3;
        var x246 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$__bezier__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__I__D__T3(this, sp, 0, t);
        if ((x246 !== null)) {
          var \u03b428$___1 = x246.bH;
          var \u03b428$___2 = x246.bU;
          var \u03b428$___3 = x246.c3;
          break matchResult71;
        }
        throw new $c_s_MatchError(x246);
      }
      var p$2 = \u03b428$___1;
      var l$2 = \u03b428$___2;
      var r$2 = \u03b428$___3;
      pt = p$2;
      var s = (leftInside ? r$2 : l$2);
      s.av(0, seg, 0, 4);
      if ((!(!inside.i(pt)))) {
        if (leftInside) {
          low = t;
        } else {
          high = t;
        }
        seg.av(0, best, 0, 4);
        found = true;
      } else if (leftInside) {
        high = t;
      } else {
        low = t;
      }
    } else {
      break;
    }
  }
  var srcseg = (found ? best : seg);
  srcseg.av(0, sp, 0, 4);
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$, "org.jpablo.graphexplorer.graphviz.layout.Spline$", ({
  vn: 1
}));
var $n_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$;
function $m_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$() {
  if ((!$n_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$)) {
    $n_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$ = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$();
  }
  return $n_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__xSolve__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T3($thiz, g) {
  var this$1 = $thiz.auq;
  if ((g === this$1.f0)) {
    var $x_1 = this$1.f1;
  } else {
    var v = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__xSolveImpl__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T3($m_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$(), g);
    this$1.f0 = g;
    this$1.f1 = v;
    var $x_1 = v;
  }
  return $x_1;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__decomposeOrder__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__Lorg_jpablo_graphexplorer_graphviz_layout_Order$Result__sci_Vector($thiz, g, res) {
  var nodes = res.oX.e6().dk($m_s_$less$colon$less$().b1).d2();
  var out = $m_scm_LinkedHashMap$().a3w(nodes.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => new $c_T2(_$1, ($m_scm_ArrayBuffer$(), $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer())))))));
  var in$1 = $m_scm_LinkedHashMap$().a3w(nodes.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => new $c_T2(_$2, ($m_scm_ArrayBuffer$(), $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer())))))));
  res.yW.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    if ((x$1 !== null)) {
      var t = x$1.g();
      var h = x$1.h();
      $f_sc_MapOps__apply__O__O(out, t).Y(h);
      return $f_sc_MapOps__apply__O__O(in$1, h).Y(t);
    }
    throw new $c_s_MatchError(x$1);
  })));
  var flatOut = $ct_scm_HashMap__(new $c_scm_HashMap());
  var flatIn = $ct_scm_HashMap__(new $c_scm_HashMap());
  var nodeSeqD = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$16(new $c_sc_Iterator$$anon$9(g.cB.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3) => _$3.br)))));
  var realD = g.cu.d8(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e) => (e.ai !== e.ak))), false);
  var end = realD.C();
  var isEmpty = (end <= 0);
  var scala$collection$immutable$Range$$lastElement = ((end - 1) | 0);
  var m = $m_scm_Map$().aO();
  var it = new $c_sci_RangeIterator(0, 1, scala$collection$immutable$Range$$lastElement, isEmpty);
  while (it.g0) {
    var elem = it.hp();
    var key = realD.l(elem).ai;
    m.ec(key, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_IndexedSeq$().b5()))).Y(elem);
  }
  var result = $m_sci_HashMap$().fk;
  var mapIt = m.o();
  while (mapIt.p()) {
    var x1 = mapIt.q();
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1);
    }
    var k = x1.g();
    var v = x1.h();
    result = result.hq(k, v.aR());
  }
  var byTailD = result;
  var seen = $m_scm_Set$().aO();
  g.cB.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n) => {
    $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(byTailD.ay(n.br, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_Seq$().f7()))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((i) => {
      var i$1 = (i | 0);
      return new $c_T2(nodeSeqD.ay(realD.l(i$1).ak, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 2147483647))), i$1);
    })), new $c_s_math_Ordering$Tuple2Ordering($m_s_math_Ordering$Int$(), $m_s_math_Ordering$Int$())).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => {
      var i$2 = (v1 | 0);
      var e$1 = realD.l(i$2);
      var x = res.Bn.r(e$1.ai);
      var x$2 = res.Bn.r(e$1.ak);
      if (((((x === null) ? (x$2 === null) : x.e(x$2)) && res.Bn.E(e$1.ai)) && (!seen.E(new $c_T2(e$1.ai, e$1.ak))))) {
        seen.Y(new $c_T2(e$1.ai, e$1.ak));
        var _1$3 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real(e$1.ai);
        var _2$2 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real(e$1.ak);
        var originalHash = $m_sr_Statics$().u(_1$3);
        var hash = (originalHash ^ ((originalHash >>> 16) | 0));
        var idx = (hash & ((flatOut.S.a.length - 1) | 0));
        var x1$1 = flatOut.S.a[idx];
        var nd = ((x1$1 === null) ? null : x1$1.by(_1$3, hash));
        if ((nd !== null)) {
          var $x_1 = nd.b9;
        } else {
          var table0 = flatOut.S;
          $m_scm_ArrayBuffer$();
          var default$1 = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
          if ((((1 + flatOut.eh) | 0) >= flatOut.kI)) {
            $p_scm_HashMap__growTable__I__V(flatOut, (flatOut.S.a.length << 1));
          }
          $p_scm_HashMap__put0__O__O__Z__I__I__s_Some(flatOut, _1$3, default$1, false, hash, ((table0 === flatOut.S) ? idx : (hash & ((flatOut.S.a.length - 1) | 0))));
          var $x_1 = default$1;
        }
        $x_1.Y(_2$2);
        var originalHash$1 = $m_sr_Statics$().u(_2$2);
        var hash$1 = (originalHash$1 ^ ((originalHash$1 >>> 16) | 0));
        var idx$1 = (hash$1 & ((flatIn.S.a.length - 1) | 0));
        var x1$2 = flatIn.S.a[idx$1];
        var nd$1 = ((x1$2 === null) ? null : x1$2.by(_2$2, hash$1));
        if ((nd$1 !== null)) {
          var $x_2 = nd$1.b9;
        } else {
          var table0$1 = flatIn.S;
          $m_scm_ArrayBuffer$();
          var default$2 = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
          if ((((1 + flatIn.eh) | 0) >= flatIn.kI)) {
            $p_scm_HashMap__growTable__I__V(flatIn, (flatIn.S.a.length << 1));
          }
          $p_scm_HashMap__put0__O__O__Z__I__I__s_Some(flatIn, _2$2, default$2, false, hash$1, ((table0$1 === flatIn.S) ? idx$1 : (hash$1 & ((flatIn.S.a.length - 1) | 0))));
          var $x_2 = default$2;
        }
        $x_2.Y(_1$3);
      }
    })));
  })));
  var done = $m_scm_Set$().aO();
  $m_scm_ArrayBuffer$();
  var result$1 = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  $m_scm_ArrayBuffer$();
  var emptyA = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  g.cB.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n$2) => {
    var s = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real(n$2.br);
    if ((!done.E(s))) {
      $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__visit$1__scm_Set__scm_ArrayBuffer__scm_HashMap__scm_ArrayBuffer__scm_HashMap__scm_LinkedHashMap__scm_LinkedHashMap__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__V($thiz, done, result$1, flatIn, emptyA, flatOut, in$1, out, s);
    }
  })));
  nodes.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n$3) => {
    if ((!done.E(n$3))) {
      done.Y(n$3);
      result$1.aw(n$3);
    }
  })));
  return $m_sci_Vector$().X(result$1);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__xSolveImpl__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T3($thiz, g) {
  var FlatBump$lzy1 = new $c_sr_LazyRef();
  var res = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Order$().ahg(g);
  var byId = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$9(g.cB.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n) => new $c_T2(n.br, n)))));
  var NodeSep = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().ah6(g);
  var VirtualHalf = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().aTm(g);
  var clustOfName = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$().P5(g);
  var ends = g.cu.d8(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e) => (e.ai !== e.ak))), false).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$2) => new $c_T2(e$2.ai, e$2.ak))));
  var intraVEdge = $m_sci_Set$().af($f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(new $c_sci_Range$Exclusive(0, ends.C(), 1), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((i) => {
    var i$1 = (i | 0);
    var x4 = new $c_T2(clustOfName.r(ends.l(i$1).g()), clustOfName.r(ends.l(i$1).h()));
    var x5 = x4.bi;
    var x6 = x4.be;
    if ((x5 instanceof $c_s_Some)) {
      var a = (x5.J | 0);
      if ((x6 instanceof $c_s_Some)) {
        return (a === (x6.J | 0));
      }
    }
    return false;
  })), false));
  var dedgeVec = g.cu.d8(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$3) => (e$3.ai !== e$3.ak))), false);
  var wOf = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((i$2) => {
    var i$3 = (i$2 | 0);
    var this$17 = dedgeVec.l(i$3).b4.ag.r("weight");
    var f$1 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4) => ($m_sc_StringParsers$().c1(_$4) ? new $c_s_Some($m_jl_Double$().bd(_$4)) : $m_s_None$())));
    var this$20 = (this$17.c() ? $m_s_None$() : f$1.i(this$17.d()));
    var f$2 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((w) => {
      var w$1 = (+w);
      var y = $doubleToInt(w$1);
      return ((y < 0) ? 0 : y);
    }));
    var this$21 = (this$20.c() ? $m_s_None$() : new $c_s_Some(f$2.i(this$20.d())));
    var default$1 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 1));
    return ((this$21.c() ? default$1.a3() : this$21.d()) | 0);
  }));
  var flatLabelWeight = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((byPair) => ((d) => {
    var d$1 = (d | 0);
    var cls = byPair.i(new $c_T2(dedgeVec.l(d$1).ai, dedgeVec.l(d$1).ak));
    return (((cls.lr($m_s_math_Ordering$Int$()) | 0) === d$1) ? (cls.L(wOf).k2($m_s_math_Numeric$IntIsIntegral$()) | 0) : (wOf.i(d$1) | 0));
  }))($f_sc_IterableOps__groupBy__F1__sci_Map(new $c_sci_Range$Exclusive(0, dedgeVec.C(), 1), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((i$3$1) => {
    var i$4 = (i$3$1 | 0);
    return new $c_T2(dedgeVec.l(i$4).ai, dedgeVec.l(i$4).ak);
  })))));
  var num = $doubleToInt(NodeSep);
  var Incr = (((num + ((num >>> 31) | 0)) | 0) >> 1);
  var y$1 = dedgeVec.C();
  var n$1 = ((y$1 < 1) ? 1 : y$1);
  var elem = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 0));
  if ((n$1 <= 0)) {
    var a$1 = new $ac_I(0);
  } else {
    var array = new $ac_I(n$1);
    var i$5 = 0;
    while ((i$5 < n$1)) {
      array.a[i$5] = (elem.a3() | 0);
      i$5 = ((1 + i$5) | 0);
    }
    var a$1 = array;
  }
  res.pV.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => {
    var r = (v1 | 0);
    if (((r >= 0) && (r < a$1.a.length))) {
      a$1.a[r] = ((1 + a$1.a[r]) | 0);
    }
  })));
  var labelW = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().agP(g);
  var selfRw = $m_sci_Map$().ao(new $c_sc_MapView$MapValues(new $c_sc_MapView$Id($f_sc_IterableOps__groupBy__F1__sci_Map(g.cu.d8(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$4) => (e$4.ai === e$4.ak))), false), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6) => _$6.ai)))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$7) => (+_$7.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$8) => $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().ahY(_$8, g)))).k2($m_s_math_Numeric$DoubleIsFractional$()))))));
  var clustOfX = ($f_sc_SeqOps__isEmpty__Z($m_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$().tV(g)) ? $m_sci_Map$EmptyMap$() : $m_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$().P5(g));
  var rootWc = $f_scm_Map__withDefaultValue__O__scm_Map($ct_scm_HashMap__(new $c_scm_HashMap()), 0);
  g.cu.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$5) => {
    rootWc.cY(e$5.ai, ((1 + (rootWc.i(e$5.ai) | 0)) | 0));
    rootWc.cY(e$5.ak, ((1 + (rootWc.i(e$5.ak) | 0)) | 0));
  })));
  var intraWc = $f_scm_Map__withDefaultValue__O__scm_Map($ct_scm_HashMap__(new $c_scm_HashMap()), 0);
  g.cu.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$6) => {
    matchResult6: {
      var x36 = new $c_T2(clustOfX.r(e$6.ai), clustOfX.r(e$6.ak));
      var x37 = x36.bi;
      var x38 = x36.be;
      if ((x37 instanceof $c_s_Some)) {
        var a$2 = (x37.J | 0);
        if ((x38 instanceof $c_s_Some)) {
          if ((a$2 === (x38.J | 0))) {
            intraWc.cY(new $c_T2(e$6.ai, a$2), ((1 + (intraWc.i(new $c_T2(e$6.ai, a$2)) | 0)) | 0));
            intraWc.cY(new $c_T2(e$6.ak, a$2), ((1 + (intraWc.i(new $c_T2(e$6.ak, a$2)) | 0)) | 0));
            break matchResult6;
          }
        }
      }
    }
  })));
  $m_scm_ArrayBuffer$();
  var edges = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  var initRank = $m_scm_Map$().aO();
  var hasEL = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().J0(g);
  var posInRank = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$10(res.oX.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var r$1 = (x$1.g() | 0);
    return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(x$1.h()).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
      var n$2 = x$1$2.g();
      var p = (x$1$2.h() | 0);
      return new $c_T2(n$2.bE(), new $c_T2(r$1, p));
    })));
  }))));
  var $x_1 = $m_sci_Map$();
  var this$88 = new $c_sc_Iterator$$anon$10(new $c_sc_Iterator$$anon$6(g.cu.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$7) => (e$7.ai !== e$7.ak))), false), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((FlatBump$lzy1$2) => ((e$8) => {
    var this$86 = posInRank.r(e$8.ai);
    var f$10 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$2$1) => ((x$1$1) => {
      if ((x$1$1 !== null)) {
        var rt = (x$1$1.g() | 0);
        var pt = (x$1$1.h() | 0);
        return new $c_s_Option$WithFilter(posInRank.r(e$2$1.ak), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$1) => {
          if ((x$1$2$1 !== null)) {
            var rh = (x$1$2$1.g() | 0);
            var ph = (x$1$2$1.h() | 0);
            if ((rt === rh)) {
              var x = ((pt - ph) | 0);
              var sign = (x >> 31);
              return ((((x ^ sign) - sign) | 0) === 1);
            } else {
              return false;
            }
          }
          throw new $c_s_MatchError(x$1$2$1);
        }))).b4f(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3) => {
          if ((x$1$3 !== null)) {
            (x$1$3.g() | 0);
            var ph$1 = (x$1$3.h() | 0);
            var \u03b42$ = ((pt < ph$1) ? new $c_T2(e$2$1.ai, e$2$1.ak) : new $c_T2(e$2$1.ak, e$2$1.ai));
            var l = \u03b42$.bi;
            var r$2 = \u03b42$.be;
            var this$64 = e$2$1.b4.ag.r("label");
            var p$3 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$9) => (_$9 !== "")));
            if (((!this$64.c()) && (!(!p$3.i(this$64.d()))))) {
              matchResult12$1: {
                var \u03b43$;
                var x59 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().tX(e$2$1, g);
                if ((x59 !== null)) {
                  var \u03b43$ = new $c_T2((+x59.g()), (+x59.h()));
                  break matchResult12$1;
                }
                throw new $c_s_MatchError(x59);
              }
              var wl$2 = (+\u03b43$.bi);
              var hl$2 = (+\u03b43$.be);
              var dist = ($m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().jT(g) ? hl$2 : wl$2);
            } else {
              var dist = 0.0;
            }
            var this$69 = e$2$1.b4.ag.r("minlen");
            var f$7 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$10) => $m_sc_StringParsers$().hT(_$10)));
            var this$70 = (this$69.c() ? $m_s_None$() : f$7.i(this$69.d()));
            var default$2 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 1));
            var y$3 = ((this$70.c() ? default$2.a3() : this$70.d()) | 0);
            var ml = ((y$3 < 0) ? 0 : y$3);
            var this$77 = e$2$1.b4.ag.r("weight");
            var f$8 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$11) => ($m_sc_StringParsers$().c1(_$11) ? new $c_s_Some($m_jl_Double$().bd(_$11)) : $m_s_None$())));
            var this$78 = (this$77.c() ? $m_s_None$() : f$8.i(this$77.d()));
            var f$9 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$12) => $doubleToInt((+_$12))));
            var this$79 = (this$78.c() ? $m_s_None$() : new $c_s_Some(f$9.i(this$78.d())));
            var default$3 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 1));
            var y$4 = ((this$79.c() ? default$3.a3() : this$79.d()) | 0);
            var wt = ((y$4 < 0) ? 0 : y$4);
            return new $c_T2(new $c_T2(l, r$2), ($p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__FlatBump$2__sr_LazyRef__Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$FlatBump$3$($thiz, FlatBump$lzy1$2), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$FlatBump$1(ml, dist, wt)));
          }
          throw new $c_s_MatchError(x$1$3);
        })));
      }
      throw new $c_s_MatchError(x$1$1);
    }))(e$8));
    return (this$86.c() ? $m_s_None$() : f$10.i(this$86.d()));
  }))(FlatBump$lzy1)));
  var flatBump = $x_1.ao(new $c_sc_MapView$MapValues(new $c_sc_MapView$Id($f_sc_IterableOps__groupBy__F1__sci_Map($m_sci_Vector$().X(this$88), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$13) => _$13.g())))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((FlatBump$lzy1$3) => ((bs) => {
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__FlatBump$2__sr_LazyRef__Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$FlatBump$3$($thiz, FlatBump$lzy1$3);
    return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$FlatBump$1((bs.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$14) => _$14.h().z2))).lq($m_s_math_Ordering$Int$()) | 0), (+bs.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$15) => _$15.h().z1))).lq($m_s_math_Ordering$DeprecatedDoubleOrdering$())), (bs.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$16) => _$16.h().z3))).k2($m_s_math_Numeric$IntIsIntegral$()) | 0));
  }))(FlatBump$lzy1))));
  var nodeSeqX = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$16(new $c_sc_Iterator$$anon$9(g.cB.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$17) => _$17.br)))));
  var realIdx = g.cu.d8(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$9) => (e$9.ai !== e$9.ak))), false);
  var byTailX = $f_sc_IterableOps__groupBy__F1__sci_Map(new $c_sci_Range$Exclusive(0, realIdx.C(), 1), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((i$4$1) => {
    var i$6 = (i$4$1 | 0);
    return realIdx.l(i$6).ai;
  })));
  var buf = new $c_scm_LinkedHashMap();
  g.cB.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((FlatBump$lzy1$4) => ((n$2$1) => {
    $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(byTailX.ay(n$2$1.br, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_Seq$().f7()))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((i$7) => {
      var i$8 = (i$7 | 0);
      return new $c_T2(nodeSeqX.ay(realIdx.l(i$8).ak, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 2147483647))), i$8);
    })), new $c_s_math_Ordering$Tuple2Ordering($m_s_math_Ordering$Int$(), $m_s_math_Ordering$Int$())).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1$1) => {
      var i$9 = (v1$1 | 0);
      var e$1 = realIdx.l(i$9);
      matchResult18: {
        var x77 = new $c_T2(posInRank.r(e$1.ai), posInRank.r(e$1.ak));
        var x78 = x77.bi;
        var x79 = x77.be;
        if ((x78 instanceof $c_s_Some)) {
          var x85 = x78.J;
          if ((x85 !== null)) {
            var rt$1 = (x85.g() | 0);
            if ((x79 instanceof $c_s_Some)) {
              var x81 = x79.J;
              if ((x81 !== null)) {
                if ((rt$1 === (x81.g() | 0))) {
                  var this$109 = e$1.b4.ag.r("label");
                  var p$4 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$18) => (_$18 !== "")));
                  if (((!this$109.c()) && (!(!p$4.i(this$109.d()))))) {
                    matchResult16$1: {
                      var \u03b44$;
                      var x71 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().tX(e$1, g);
                      if ((x71 !== null)) {
                        var \u03b44$ = new $c_T2((+x71.g()), (+x71.h()));
                        break matchResult16$1;
                      }
                      throw new $c_s_MatchError(x71);
                    }
                    var wl$2$1 = (+\u03b44$.bi);
                    var hl$2$1 = (+\u03b44$.be);
                    var dist$2 = ($m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().jT(g) ? hl$2$1 : wl$2$1);
                  } else {
                    var dist$2 = 0.0;
                  }
                  var this$114 = e$1.b4.ag.r("minlen");
                  var f$16 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$19) => $m_sc_StringParsers$().hT(_$19)));
                  var this$115 = (this$114.c() ? $m_s_None$() : f$16.i(this$114.d()));
                  var default$4 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 1));
                  var y$6 = ((this$115.c() ? default$4.a3() : this$115.d()) | 0);
                  var ml$1 = ((y$6 < 0) ? 0 : y$6);
                  var this$122 = e$1.b4.ag.r("weight");
                  var f$17 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$20) => ($m_sc_StringParsers$().c1(_$20) ? new $c_s_Some($m_jl_Double$().bd(_$20)) : $m_s_None$())));
                  var this$123 = (this$122.c() ? $m_s_None$() : f$17.i(this$122.d()));
                  var f$18 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$21) => $doubleToInt((+_$21))));
                  var this$124 = (this$123.c() ? $m_s_None$() : new $c_s_Some(f$18.i(this$123.d())));
                  var default$5 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 1));
                  var y$7 = ((this$124.c() ? default$5.a3() : this$124.d()) | 0);
                  var wt$1 = ((y$7 < 0) ? 0 : y$7);
                  var x74 = buf.r(new $c_T2(e$1.ai, e$1.ak));
                  if ((x74 instanceof $c_s_Some)) {
                    var b$2 = x74.J;
                    var $x_2 = new $c_T2(e$1.ai, e$1.ak);
                    $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__FlatBump$2__sr_LazyRef__Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$FlatBump$3$($thiz, FlatBump$lzy1$4);
                    var x$2 = b$2.z2;
                    var x$3 = b$2.z1;
                    $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(buf, $x_2, new $c_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$FlatBump$1(((x$2 > ml$1) ? x$2 : ml$1), (+Math.max(x$3, dist$2)), ((b$2.z3 + wt$1) | 0)), false);
                    break matchResult18;
                  }
                  if (($m_s_None$() === x74)) {
                    $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(buf, new $c_T2(e$1.ai, e$1.ak), ($p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__FlatBump$2__sr_LazyRef__Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$FlatBump$3$($thiz, FlatBump$lzy1$4), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$FlatBump$1(ml$1, dist$2, wt$1)), false);
                    break matchResult18;
                  }
                  throw new $c_s_MatchError(x74);
                }
              }
            }
          }
        }
      }
    })));
  }))(FlatBump$lzy1)));
  var flatOutByTail = $m_sci_Map$().ao(new $c_sc_MapView$MapValues(new $c_sc_MapView$Id($f_sc_IterableOps__groupBy__F1__sci_Map($m_sci_Vector$().X(buf), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$22) => _$22.g().g())))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$23) => _$23.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$4) => {
    var k = x$1$4.g();
    var b$3 = x$1$4.h();
    return new $c_T2(k.h(), b$3);
  })))))));
  var auxOut = $ct_scm_HashMap__(new $c_scm_HashMap());
  var this$179 = $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O($m_sci_Nil$().b6(res.oX), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$24) => (_$24.g() | 0))), $m_s_math_Ordering$Int$());
  var f$24 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$2) => {
    matchResult23: {
      if ((x$1$2$2 !== null)) {
        var rank = (x$1$2$2.g() | 0);
        var ids$1 = x$1$2$2.h();
        var nodesep = ((hasEL && ((1 & rank) === 1)) ? 5.0 : NodeSep);
        var this$146 = $f_sc_IndexedSeqOps__headOption__s_Option(ids$1);
        var f$22 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((h) => {
          initRank.cY(h.bE(), 0);
        }));
        if ((!this$146.c())) {
          f$22.i(this$146.d());
        }
        var last = 0;
        var j = 0;
        while ((j < ids$1.C())) {
          var u = ids$1.l(j);
          if ((((1 + j) | 0) < ids$1.C())) {
            var v = ids$1.l(((1 + j) | 0));
            var width = (($p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__rw$1__sci_Map__sci_Map__sci_Set__AI__D__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D__sci_Map__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__D($thiz, labelW, selfRw, intraVEdge, a$1, Incr, dedgeVec, g, VirtualHalf, byId, u) + $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__lw$1__sci_Map__D__sci_Set__AI__D__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D__sci_Map__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__D($thiz, labelW, NodeSep, intraVEdge, a$1, Incr, dedgeVec, g, VirtualHalf, byId, v)) + nodesep);
            matchResult19$1: {
              var \u03b45$;
              var $x_3 = $m_RTLong$().d1((+Math.round(width)));
              var x88 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__flatAdj$1__sci_Map__Z__D__sci_Map__sci_Map__sci_Set__AI__D__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D__sci_Map__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__I__T2($thiz, flatBump, hasEL, NodeSep, labelW, selfRw, intraVEdge, a$1, Incr, dedgeVec, g, VirtualHalf, byId, u, v, $s_RTLong__toInt__I__I__I($x_3.l, $x_3.h));
              if ((x88 !== null)) {
                var \u03b45$ = new $c_T2((x88.g() | 0), (x88.h() | 0));
                break matchResult19$1;
              }
              throw new $c_s_MatchError(x88);
            }
            var minlen$2 = (\u03b45$.bi | 0);
            var fw$2 = (\u03b45$.be | 0);
            $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__addLR$1__scm_HashMap__scm_ArrayBuffer__T__T__I__I__V($thiz, auxOut, edges, u.bE(), v.bE(), minlen$2, fw$2);
            last = $doubleToInt((last + width));
            initRank.cY(v.bE(), last);
          }
          if ((u instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$FlatLabel)) {
            var x94 = u.yQ;
            var fe = dedgeVec.l(x94);
            var a$3 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real(fe.ai);
            var b$4 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real(fe.ak);
            var \u03b46$ = (((posInRank.i(fe.ai).h() | 0) <= (posInRank.i(fe.ak).h() | 0)) ? new $c_T2(a$3, b$4) : new $c_T2(b$4, a$3));
            var l$1 = \u03b46$.bi;
            var r$3 = \u03b46$.be;
            var this$159 = fe.b4.ag.r("minlen");
            var f$23 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$25) => $m_sc_StringParsers$().hT(_$25)));
            var this$160 = (this$159.c() ? $m_s_None$() : f$23.i(this$159.d()));
            var default$6 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 1));
            var y$8 = ((this$160.c() ? default$6.a3() : this$160.d()) | 0);
            var ml0 = Math.imul(((y$8 < 0) ? 0 : y$8), (hasEL ? 2 : 1));
            var num$1 = Math.imul(ml0, $doubleToInt(NodeSep));
            var m0 = (((num$1 + ((num$1 >>> 31) | 0)) | 0) >> 1);
            var w$2 = (flatLabelWeight.i(x94) | 0);
            if ((!$p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__canreach$1__scm_HashMap__T__T__Z($thiz, auxOut, u.bE(), l$1.bE()))) {
              var $x_6 = l$1.bE();
              var $x_5 = u.bE();
              var x$6 = ((m0 + $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__rw$1__sci_Map__sci_Map__sci_Set__AI__D__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D__sci_Map__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__D($thiz, labelW, selfRw, intraVEdge, a$1, Incr, dedgeVec, g, VirtualHalf, byId, l$1)) + $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__lw$1__sci_Map__D__sci_Set__AI__D__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D__sci_Map__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__D($thiz, labelW, NodeSep, intraVEdge, a$1, Incr, dedgeVec, g, VirtualHalf, byId, u));
              var $x_4 = $m_RTLong$().d1((+Math.round(x$6)));
              $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__addLR$1__scm_HashMap__scm_ArrayBuffer__T__T__I__I__V($thiz, auxOut, edges, $x_6, $x_5, $s_RTLong__toInt__I__I__I($x_4.l, $x_4.h), w$2);
            }
            if ((!$p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__canreach$1__scm_HashMap__T__T__Z($thiz, auxOut, r$3.bE(), u.bE()))) {
              var $x_9 = u.bE();
              var $x_8 = r$3.bE();
              var x$8 = ((m0 + $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__rw$1__sci_Map__sci_Map__sci_Set__AI__D__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D__sci_Map__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__D($thiz, labelW, selfRw, intraVEdge, a$1, Incr, dedgeVec, g, VirtualHalf, byId, u)) + $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__lw$1__sci_Map__D__sci_Set__AI__D__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D__sci_Map__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__D($thiz, labelW, NodeSep, intraVEdge, a$1, Incr, dedgeVec, g, VirtualHalf, byId, r$3));
              var $x_7 = $m_RTLong$().d1((+Math.round(x$8)));
              $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__addLR$1__scm_HashMap__scm_ArrayBuffer__T__T__I__I__V($thiz, auxOut, edges, $x_9, $x_8, $s_RTLong__toInt__I__I__I($x_7.l, $x_7.h), w$2);
            }
          }
          if ((u instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real)) {
            var x109 = u.mh;
            flatOutByTail.ay(x109, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
              $m_sci_Vector$();
              return $m_sci_Vector0$();
            }))).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((posInRank, x109, hasEL, NodeSep, labelW, selfRw, intraVEdge, a$1, Incr, dedgeVec, g, VirtualHalf, byId, auxOut, edges) => ((x$1$2$3) => {
              var other = x$1$2$3.g();
              var fb = x$1$2$3.h();
              matchResult21: {
                var x95 = new $c_T2(posInRank.r(x109), posInRank.r(other));
                var x96 = x95.bi;
                var x97 = x95.be;
                if ((x96 instanceof $c_s_Some)) {
                  var x103 = x96.J;
                  if ((x103 !== null)) {
                    var pu = (x103.h() | 0);
                    if ((x97 instanceof $c_s_Some)) {
                      var x99 = x97.J;
                      if ((x99 !== null)) {
                        var po = (x99.h() | 0);
                        var \u03b47$ = ((pu < po) ? new $c_T4(x109, other, pu, po) : new $c_T4(other, x109, po, pu));
                        var t0 = \u03b47$.bO;
                        var h0 = \u03b47$.bs;
                        var pt0 = (\u03b47$.ch | 0);
                        if ((((((\u03b47$.ca | 0) - pt0) | 0) > 1) && (fb.z1 === 0.0))) {
                          var t0n = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real(t0);
                          var h0n = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real(h0);
                          var width$1 = ($p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__rw$1__sci_Map__sci_Map__sci_Set__AI__D__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D__sci_Map__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__D($thiz, labelW, selfRw, intraVEdge, a$1, Incr, dedgeVec, g, VirtualHalf, byId, t0n) + $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__lw$1__sci_Map__D__sci_Set__AI__D__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D__sci_Map__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__D($thiz, labelW, NodeSep, intraVEdge, a$1, Incr, dedgeVec, g, VirtualHalf, byId, h0n));
                          var fm = Math.imul(fb.z2, (hasEL ? 2 : 1));
                          var m0$1 = ((fm * NodeSep) + width$1);
                          var $x_10 = $m_RTLong$().d1((+Math.round(m0$1)));
                          $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__addLR$1__scm_HashMap__scm_ArrayBuffer__T__T__I__I__V($thiz, auxOut, edges, t0, h0, $s_RTLong__toInt__I__I__I($x_10.l, $x_10.h), fb.z3);
                          break matchResult21;
                        } else {
                          break matchResult21;
                        }
                      }
                    }
                  }
                }
              }
            }))(posInRank, x109, hasEL, NodeSep, labelW, selfRw, intraVEdge, a$1, Incr, dedgeVec, g, VirtualHalf, byId, auxOut, edges)));
          }
          j = ((1 + j) | 0);
        }
        break matchResult23;
      }
      throw new $c_s_MatchError(x$1$2$2);
    }
  }));
  var these = this$179;
  while ((!these.c())) {
    f$24.i(these.t());
    these = these.v();
  }
  var realEdges = g.cu.d8(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$10) => (e$10.ai !== e$10.ak))), false);
  var cs = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$().tV(g);
  if ($f_sc_SeqOps__isEmpty__Z(cs)) {
    var decomp = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__decomposeOrder__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__Lorg_jpablo_graphexplorer_graphviz_layout_Order$Result__sci_Vector($thiz, g, res);
  } else if ((!$f_sc_SeqOps__isEmpty__Z(res.Bm))) {
    var inN = $m_sci_Set$().af(res.Bm);
    var decomp = res.Bm.iR($p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__decomposeOrder__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__Lorg_jpablo_graphexplorer_graphviz_layout_Order$Result__sci_Vector($thiz, g, res).d8(inN, true));
  } else {
    var this$186 = new $c_sci_Range$Exclusive(0, cs.C(), 1);
    var directMembers = $m_sci_Vector$().X(this$186).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((ci) => {
      var ci$1 = (ci | 0);
      var childIds = $f_sc_StrictOptimizedIterableOps__flatMap__F1__O($m_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$().qT(g, ci$1), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((cc) => {
        var cc$1 = (cc | 0);
        return cs.l(cc$1).n3;
      })));
      return cs.l(ci$1).n3.jv(childIds);
    })));
    var expansion = $f_sc_StrictOptimizedIterableOps__flatMap__F1__O($m_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$().qT(g, (-1)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((ci$2) => $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__preorder$1__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__I__sci_Vector($thiz, g, (ci$2 | 0)))));
    var this$193 = new $c_sc_Iterator$$anon$9($ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), new $c_sc_IndexedSeqView$Id(expansion)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((ci$3$1) => $f_sc_IndexedSeqOps__reverse__O($p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__blockOf$1__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_layout_Order$Result__sci_Vector__sci_Vector__I__sci_Vector($thiz, cs, res, directMembers, realEdges, (ci$3$1 | 0))))));
    var blocks = $m_sci_Vector$().X(this$193);
    var inBlocks = $m_sci_Set$().af(new $c_sc_Iterator$$anon$10(blocks.o(), $m_s_$less$colon$less$().b1));
    var decomp = $f_sc_StrictOptimizedIterableOps__flatten__F1__O(blocks, $m_s_$less$colon$less$().b1).g9($p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__decomposeOrder__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__Lorg_jpablo_graphexplorer_graphviz_layout_Order$Result__sci_Vector($thiz, g, res).d8(inBlocks, true));
  }
  var cluX = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$().tV(g);
  var expansionOrder = $f_sc_StrictOptimizedIterableOps__flatMap__F1__O($m_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$().qT(g, (-1)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((ci$4$1) => $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__pre$1__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__I__sci_Vector($thiz, g, (ci$4$1 | 0)))));
  var outSegs = new $c_scm_LinkedHashMap();
  $f_sc_IterableOnceOps__foreach__F1__V(new $c_sc_Iterator$$anon$16(res.yW.o()), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3$1) => {
    if ((x$1$3$1 !== null)) {
      var x122 = x$1$3$1.g();
      if ((x122 !== null)) {
        var t = x122.g();
        var i$10 = (x$1$3$1.h() | 0);
        return outSegs.ec(t, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
          $m_scm_ArrayBuffer$();
          return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
        }))).Y(i$10);
      }
    }
    throw new $c_s_MatchError(x$1$3$1);
  })));
  if ((!clustOfX.c())) {
    outSegs.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$4$1) => {
      var node = x$1$4$1.g();
      var segs = x$1$4$1.h();
      var nid = ((node instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real) ? node.mh : "");
      var regrouped = $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O($m_sci_Vector$().X(segs), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((i$11) => $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__grp$1__sci_Map__T__Lorg_jpablo_graphexplorer_graphviz_layout_Order$Result__sci_Vector__I__I($thiz, clustOfX, nid, res, realEdges, (i$11 | 0)))), $m_s_math_Ordering$Int$());
      var x$2$1 = $m_sci_Vector$().X(segs);
      if ((!((regrouped === null) ? (x$2$1 === null) : regrouped.e(x$2$1)))) {
        $p_scm_ArrayBuffer__reduceToSize__I__V(segs, 0);
        segs.gS(regrouped);
      }
    })));
  }
  $m_scm_ArrayBuffer$();
  var slackNodes = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  $f_sc_IterableOnceOps__foreach__F1__V($ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), new $c_sc_IndexedSeqView$Id(res.Fi)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1$2) => {
    var d$2 = (v1$2 | 0);
    var fe$1 = dedgeVec.l(d$2);
    var vn = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$FlatLabel(d$2);
    var hv = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__half$1__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Set__D__sci_Map__AI__D__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__D($thiz, dedgeVec, g, intraVEdge, VirtualHalf, byId, a$1, Incr, vn);
    var t$1 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real(fe$1.ai);
    var h$1 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real(fe$1.ak);
    var fw$1 = (flatLabelWeight.i(d$2) | 0);
    $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2(t$1, ($p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__rw$1__sci_Map__sci_Map__sci_Set__AI__D__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D__sci_Map__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__D($thiz, labelW, selfRw, intraVEdge, a$1, Incr, dedgeVec, g, VirtualHalf, byId, t$1) + hv)), new $c_T2(h$1, ($p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__lw$1__sci_Map__D__sci_Set__AI__D__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D__sci_Map__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__D($thiz, labelW, NodeSep, intraVEdge, a$1, Incr, dedgeVec, g, VirtualHalf, byId, h$1) - hv))]))).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$5) => {
      var endp = x$1$5.g();
      var mRaw = (+x$1$5.h());
      var sn = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Slack(((slackNodes.a1 + res.yW.C()) | 0));
      slackNodes.aw(sn);
      var m = $doubleToInt(mRaw);
      var \u03b48$ = ((m > 0) ? new $c_T2(m, 0) : new $c_T2(0, ((-m) | 0)));
      var m0$2 = (\u03b48$.bi | 0);
      var m1 = (\u03b48$.be | 0);
      edges.aw(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$NSEdge(sn.bE(), vn.bE(), ((1 + m0$2) | 0), fw$1));
      edges.aw(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$NSEdge(sn.bE(), endp.bE(), ((1 + m1) | 0), fw$1));
      var $x_11 = sn.bE();
      var x$11 = (((initRank.i(vn.bE()) | 0) - ((1 + m0$2) | 0)) | 0);
      var y$9 = (((initRank.i(endp.bE()) | 0) - ((1 + m1) | 0)) | 0);
      initRank.cY($x_11, ((x$11 < y$9) ? x$11 : y$9));
    })));
  })));
  decomp.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((node$1) => {
    outSegs.ay(node$1, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      $m_scm_ArrayBuffer$();
      return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
    }))).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1$3) => {
      var i$13 = (v1$3 | 0);
      matchResult30$1: {
        var \u03b49$;
        var x140 = res.yW.l(i$13);
        if ((x140 !== null)) {
          var \u03b49$ = new $c_T2(x140.g(), x140.h());
          break matchResult30$1;
        }
        throw new $c_s_MatchError(x140);
      }
      var t$2$1 = \u03b49$.bi;
      var h$2$1 = \u03b49$.be;
      var sn$1 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Slack(i$13);
      slackNodes.aw(sn$1);
      var this$232 = new $c_s_PartialFunction$Lifted(res.Fj).as(i$13);
      var default$7 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => (-1)));
      var owner = ((this$232.c() ? default$7.a3() : this$232.d()) | 0);
      var owned = (((owner >= 0) && (owner < realEdges.C())) ? new $c_s_Some(realEdges.l(owner)) : $m_s_None$());
      var wtRep = ((owner >= 0) ? $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__weightAttr$1__sci_Vector__I__I($thiz, realEdges, owner) : 1);
      var wtMerged = ((owner >= 0) ? ($f_sc_IterableOnceOps__sum__s_math_Numeric__O(new $c_sc_Iterator$$anon$9(new $c_sc_Iterator$$anon$6(new $c_sci_Range$Exclusive(0, res.pV.C(), 1).o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((d$3) => {
        var d$4 = (d$3 | 0);
        return ((d$4 !== owner) && ((res.pV.l(d$4) | 0) === owner));
      })), false), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((d$2$1) => $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__weightAttr$1__sci_Vector__I__I($thiz, realEdges, (d$2$1 | 0))))), $m_s_math_Numeric$IntIsIntegral$()) | 0) : 0);
      var f$33 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((re) => {
        var x143 = new $c_T2(clustOfX.r(re.ai), clustOfX.r(re.ak));
        var x144 = x143.bi;
        var x145 = x143.be;
        if ((x144 instanceof $c_s_Some)) {
          var a$4 = (x144.J | 0);
          if ((x145 instanceof $c_s_Some)) {
            if ((a$4 === (x145.J | 0))) {
              return new $c_s_Some(a$4);
            }
          }
        }
        return $m_s_None$();
      }));
      var chainCi = (owned.c() ? $m_s_None$() : f$33.i(owned.d()));
      var f$34 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((re$2) => $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__mergeVisitors$1__sci_Vector__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_model_REdge__sci_Vector($thiz, expansionOrder, cluX, re$2)));
      var this$242 = (owned.c() ? $m_s_None$() : new $c_s_Some(f$34.i(owned.d())));
      var default$8 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
        $m_sci_Vector$();
        return $m_sci_Vector0$();
      }));
      var visits = (this$242.c() ? default$8.a3() : this$242.d());
      var mergePasses = ((1 + visits.C()) | 0);
      var x$12 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__rebornAt$1__sci_Vector__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__I($thiz, visits, cluX, t$2$1);
      var y$10 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__rebornAt$1__sci_Vector__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__I($thiz, visits, cluX, h$2$1);
      var reborn = ((x$12 > y$10) ? x$12 : y$10);
      if ((reborn > 0)) {
        var omega = 1;
      } else {
        var tail$proxy1 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__cls$1__scm_Map__scm_Map__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__s_Option__Lorg_jpablo_graphexplorer_graphviz_layout_NSClass($thiz, rootWc, intraWc, t$2$1, chainCi);
        var head$proxy1 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__cls$1__scm_Map__scm_Map__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__s_Option__Lorg_jpablo_graphexplorer_graphviz_layout_NSClass($thiz, rootWc, intraWc, h$2$1, chainCi);
        var omega = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$().aue.a[tail$proxy1.KS].a[head$proxy1.KS];
      }
      var w$3 = ((Math.imul(omega, wtRep) + Math.imul(((mergePasses - reborn) | 0), wtMerged)) | 0);
      matchResult35$1: {
        var \u03b410$;
        if ((owned instanceof $c_s_Some)) {
          var re$3 = owned.J;
          matchResult33$1: {
            var tpx;
            if ((t$2$1 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real)) {
              var x160 = t$2$1.mh;
              if ((x160 === re$3.ai)) {
                var tpx = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__portX$1__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T__s_Option__D($thiz, byId, g, re$3.ai, re$3.ka);
                break matchResult33$1;
              }
              if ((x160 === re$3.ak)) {
                var tpx = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__portX$1__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T__s_Option__D($thiz, byId, g, re$3.ak, re$3.k9);
                break matchResult33$1;
              }
            }
            var tpx = 0.0;
          }
          matchResult34$1: {
            var hpx;
            if ((h$2$1 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real)) {
              var x167 = h$2$1.mh;
              if ((x167 === re$3.ak)) {
                var hpx = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__portX$1__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T__s_Option__D($thiz, byId, g, re$3.ak, re$3.k9);
                break matchResult34$1;
              }
              if ((x167 === re$3.ai)) {
                var hpx = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__portX$1__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T__s_Option__D($thiz, byId, g, re$3.ai, re$3.ka);
                break matchResult34$1;
              }
            }
            var hpx = 0.0;
          }
          var m$1 = $doubleToInt((hpx - tpx));
          var \u03b410$ = ((m$1 > 0) ? new $c_T2(m$1, 0) : new $c_T2(0, ((-m$1) | 0)));
          break matchResult35$1;
        }
        if (($m_s_None$() === owned)) {
          var \u03b410$ = new $c_T2(0, 0);
          break matchResult35$1;
        }
        throw new $c_s_MatchError(owned);
      }
      var m0$3 = (\u03b410$.bi | 0);
      var m1$1 = (\u03b410$.be | 0);
      edges.aw(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$NSEdge(sn$1.bE(), t$2$1.bE(), ((1 + m0$3) | 0), w$3));
      edges.aw(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$NSEdge(sn$1.bE(), h$2$1.bE(), ((1 + m1$1) | 0), w$3));
      var $x_12 = sn$1.bE();
      var x$14 = (((initRank.i(t$2$1.bE()) | 0) - ((1 + m0$3) | 0)) | 0);
      var y$11 = (((initRank.i(h$2$1.bE()) | 0) - ((1 + m1$1) | 0)) | 0);
      initRank.cY($x_12, ((x$14 < y$11) ? x$14 : y$11));
    })));
  })));
  var cluInfos = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$().tV(g);
  $m_scm_ArrayBuffer$();
  var clSlacks = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  if ((!$f_sc_SeqOps__isEmpty__Z(cluInfos))) {
    var flip = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().jT(g);
    var lrvnMade = $m_scm_Set$().aO();
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__containClustnodes$1__scm_ArrayBuffer__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Vector__Z__D__scm_Set__scm_ArrayBuffer__Lorg_jpablo_graphexplorer_graphviz_layout_Order$Result__sci_Vector__sci_Map__D__sci_Set__AI__D__sci_Vector__D__sci_Map__sci_Map__I__V($thiz, edges, g, cluInfos, flip, 8.0, lrvnMade, clSlacks, res, realEdges, labelW, NodeSep, intraVEdge, a$1, Incr, dedgeVec, VirtualHalf, byId, selfRw, (-1));
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__keepout$1__sci_Vector__scm_ArrayBuffer__D__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__Lorg_jpablo_graphexplorer_graphviz_layout_Order$Result__sci_Vector__sci_Map__sci_Map__sci_Set__AI__D__sci_Vector__D__sci_Map__D__I__V($thiz, cluInfos, edges, 8.0, g, res, realEdges, labelW, selfRw, intraVEdge, a$1, Incr, dedgeVec, VirtualHalf, byId, NodeSep, (-1));
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__containSubclust$1__sci_Vector__Z__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__scm_ArrayBuffer__D__scm_Set__scm_ArrayBuffer__I__V($thiz, cluInfos, flip, g, edges, 8.0, lrvnMade, clSlacks, (-1));
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__separateSubclust$1__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Vector__scm_ArrayBuffer__D__scm_Set__scm_ArrayBuffer__Z__Lorg_jpablo_graphexplorer_graphviz_layout_Order$Result__sci_Vector__I__V($thiz, g, cluInfos, edges, 8.0, lrvnMade, clSlacks, flip, res, realEdges, (-1));
  }
  var nodeOrder = clSlacks.bB().cx().d2().iR(slackNodes.bB().cx().d2()).iR(decomp);
  var xr = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$().b92(nodeOrder.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$31) => _$31.bE()))), $m_sci_Seq$().fw(edges), $s_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$__LeftRight__Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance(), initRank, $m_sci_Seq$().f7(), $m_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$().b93());
  var xrByNode = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$9(nodeOrder.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n$3) => new $c_T2(n$3, xr.i(n$3.bE()))))));
  return new $c_T3(res, $m_sci_Map$().ao(new $c_sc_Iterator$$anon$9(res.oX.e6().dk($m_s_$less$colon$less$().b1).d2().o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((id$4) => new $c_T2(id$4, ((xrByNode.i(id$4) | 0) - 0.0)))))), new $c_sci_Range$Exclusive(0, cluInfos.C(), 1).PD(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((i$5$1) => {
    var i$14 = (i$5$1 | 0);
    return new $c_T2(((xrByNode.i(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ClusterLn(i$14)) | 0) - 0.0), ((xrByNode.i(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ClusterRn(i$14)) | 0) - 0.0));
  }))).d2());
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__visit$1__scm_Set__scm_ArrayBuffer__scm_HashMap__scm_ArrayBuffer__scm_HashMap__scm_LinkedHashMap__scm_LinkedHashMap__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__V($thiz, done$1, result$1, flatIn$3, emptyA$1, flatOut$3, in$2, out$2, seed) {
  var elems = $m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode.r().C)([seed]));
  var stk = $ct_scm_Stack__I__(new $c_scm_Stack(), 16).kl(elems);
  while ((!stk.c())) {
    var n = stk.h7(false);
    if ((!done$1.E(n))) {
      done$1.Y(n);
      result$1.aw(n);
      var f = ((emptyA$1) => (() => emptyA$1))(emptyA$1);
      if ((!($objectGetClass(flatIn$3) === $d_scm_HashMap.l()))) {
        var x1 = flatIn$3.r(n);
        if ((x1 instanceof $c_s_Some)) {
          var $x_1 = x1.J;
        } else {
          if ((!($m_s_None$() === x1))) {
            throw new $c_s_MatchError(x1);
          }
          var $x_1 = f();
        }
      } else {
        var originalHash = $m_sr_Statics$().u(n);
        var hash = (originalHash ^ ((originalHash >>> 16) | 0));
        var x1$1 = flatIn$3.S.a[(hash & ((flatIn$3.S.a.length - 1) | 0))];
        var nd = ((x1$1 === null) ? null : x1$1.by(n, hash));
        var $x_1 = ((nd === null) ? f() : nd.b9);
      }
      var this$3 = $x_1.cx();
      while (this$3.p()) {
        var x0 = this$3.q();
        if ((!done$1.E(x0))) {
          stk.gm(x0);
        }
      }
      var f$1 = ((emptyA$1) => (() => emptyA$1))(emptyA$1);
      if ((!($objectGetClass(flatOut$3) === $d_scm_HashMap.l()))) {
        var x1$2 = flatOut$3.r(n);
        if ((x1$2 instanceof $c_s_Some)) {
          var $x_2 = x1$2.J;
        } else {
          if ((!($m_s_None$() === x1$2))) {
            throw new $c_s_MatchError(x1$2);
          }
          var $x_2 = f$1();
        }
      } else {
        var originalHash$1 = $m_sr_Statics$().u(n);
        var hash$1 = (originalHash$1 ^ ((originalHash$1 >>> 16) | 0));
        var x1$3 = flatOut$3.S.a[(hash$1 & ((flatOut$3.S.a.length - 1) | 0))];
        var nd$1 = ((x1$3 === null) ? null : x1$3.by(n, hash$1));
        var $x_2 = ((nd$1 === null) ? f$1() : nd$1.b9);
      }
      var this$4 = $x_2.cx();
      while (this$4.p()) {
        var x0$1 = this$4.q();
        if ((!done$1.E(x0$1))) {
          stk.gm(x0$1);
        }
      }
      var this$5 = $f_sc_MapOps__apply__O__O(in$2, n).cx();
      while (this$5.p()) {
        var x0$2 = this$5.q();
        if ((!done$1.E(x0$2))) {
          stk.gm(x0$2);
        }
      }
      var this$6 = $f_sc_MapOps__apply__O__O(out$2, n).cx();
      while (this$6.p()) {
        var x0$3 = this$6.q();
        if ((!done$1.E(x0$3))) {
          stk.gm(x0$3);
        }
      }
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__mergeExtra$1__sci_Set__AI__D__I__D($thiz, intraVEdge$1, classSize$1, Incr$1, d) {
  if (((intraVEdge$1.E(d) || (d < 0)) || (d >= classSize$1.a.length))) {
    return 0.0;
  } else {
    var y = ((classSize$1.a[d] - 1) | 0);
    return (((y < 0) ? 0 : y) * Incr$1);
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__half$1__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Set__D__sci_Map__AI__D__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__D($thiz, dedgeVec$4, g$2, intraVEdge$2, VirtualHalf$1, byId$1, classSize$2, Incr$2, n) {
  if ((n instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$FlatLabel)) {
    var x28 = n.yQ;
    return (+$m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().a3o(dedgeVec$4.l(x28), g$2).g());
  }
  if ((n instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Virtual)) {
    var x24 = n.kB;
    if (intraVEdge$2.E(x24)) {
      return 1.0;
    }
    return (VirtualHalf$1 + $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__mergeExtra$1__sci_Set__AI__D__I__D($thiz, intraVEdge$2, classSize$2, Incr$2, x24));
  }
  if ((n instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Slack)) {
    return VirtualHalf$1;
  }
  matchAlts1: {
    matchAlts2: {
      if ((n instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ClusterLn)) {
        break matchAlts2;
      }
      if ((n instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ClusterRn)) {
        break matchAlts2;
      }
      break matchAlts1;
    }
    return 1.0;
  }
  if ((n instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real)) {
    var x14 = n.mh;
    var this$4 = byId$1.r(x14);
    if (this$4.c()) {
      var $x_1 = $m_s_None$();
    } else {
      var x0 = this$4.d();
      var $x_1 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().J9(x0, g$2);
    }
    var this$5 = $x_1;
    if (this$5.c()) {
      var this$6 = $m_s_None$();
    } else {
      var x0$1 = this$5.d();
      var this$6 = new $c_s_Some($m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().X5(x0$1));
    }
    return (+(this$6.c() ? 1.0 : this$6.d()));
  }
  throw new $c_s_MatchError(n);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__lw$1__sci_Map__D__sci_Set__AI__D__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D__sci_Map__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__D($thiz, labelW$1, NodeSep$1, intraVEdge$3, classSize$3, Incr$3, dedgeVec$5, g$6, VirtualHalf$2, byId$2, n) {
  if ((n instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Virtual)) {
    if (labelW$1.E(n.bE())) {
      return (NodeSep$1 + $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__mergeExtra$1__sci_Set__AI__D__I__D($thiz, intraVEdge$3, classSize$3, Incr$3, n.kB));
    }
  }
  return $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__half$1__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Set__D__sci_Map__AI__D__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__D($thiz, dedgeVec$5, g$6, intraVEdge$3, VirtualHalf$2, byId$2, classSize$3, Incr$3, n);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__rw$1__sci_Map__sci_Map__sci_Set__AI__D__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D__sci_Map__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__D($thiz, labelW$2, selfRw$1, intraVEdge$4, classSize$4, Incr$4, dedgeVec$6, g$7, VirtualHalf$3, byId$3, n) {
  if ((n instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Virtual)) {
    if (labelW$2.E(n.bE())) {
      return ((+labelW$2.i(n.bE())) + $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__mergeExtra$1__sci_Set__AI__D__I__D($thiz, intraVEdge$4, classSize$4, Incr$4, n.kB));
    }
  }
  if ((n instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real)) {
    var x34 = n.mh;
    if (selfRw$1.E(x34)) {
      return ($p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__half$1__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Set__D__sci_Map__AI__D__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__D($thiz, dedgeVec$6, g$7, intraVEdge$4, VirtualHalf$3, byId$3, classSize$4, Incr$4, n) + (+selfRw$1.i(x34)));
    }
  }
  return $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__half$1__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Set__D__sci_Map__AI__D__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__D($thiz, dedgeVec$6, g$7, intraVEdge$4, VirtualHalf$3, byId$3, classSize$4, Incr$4, n);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__weightClass$1__scm_Map__scm_Map__T__s_Option__I($thiz, rootWc$2, intraWc$2, id, ci) {
  var $x_1 = rootWc$2.i(id);
  if (ci.c()) {
    var this$2 = $m_s_None$();
  } else {
    var x0 = ci.d();
    var c = (x0 | 0);
    var this$2 = new $c_s_Some((intraWc$2.i(new $c_T2(id, c)) | 0));
  }
  var y = ((($x_1 | 0) + ((this$2.c() ? 0 : this$2.d()) | 0)) | 0);
  return ((y > 3) ? 3 : y);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__cls$1__scm_Map__scm_Map__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__s_Option__Lorg_jpablo_graphexplorer_graphviz_layout_NSClass($thiz, rootWc$6, intraWc$8, n, ci) {
  if ((n instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$FlatLabel)) {
    return $s_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$__Virtual__Lorg_jpablo_graphexplorer_graphviz_layout_NSClass();
  }
  if ((n instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Virtual)) {
    return $s_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$__Virtual__Lorg_jpablo_graphexplorer_graphviz_layout_NSClass();
  }
  if ((n instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Slack)) {
    return $s_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$__Virtual__Lorg_jpablo_graphexplorer_graphviz_layout_NSClass();
  }
  matchAlts3: {
    matchAlts4: {
      if ((n instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ClusterLn)) {
        break matchAlts4;
      }
      if ((n instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ClusterRn)) {
        break matchAlts4;
      }
      break matchAlts3;
    }
    return $s_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$__Virtual__Lorg_jpablo_graphexplorer_graphviz_layout_NSClass();
  }
  if ((n instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real)) {
    return (($p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__weightClass$1__scm_Map__scm_Map__T__s_Option__I($thiz, rootWc$6, intraWc$8, n.mh, ci) <= 1) ? $s_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$__Singleton__Lorg_jpablo_graphexplorer_graphviz_layout_NSClass() : $s_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$__Ordinary__Lorg_jpablo_graphexplorer_graphviz_layout_NSClass());
  }
  throw new $c_s_MatchError(n);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__FlatBump$lzyINIT1$1__sr_LazyRef__Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$FlatBump$3$($thiz, FlatBump$lzy1$1) {
  return (FlatBump$lzy1$1.ci ? FlatBump$lzy1$1.cj : FlatBump$lzy1$1.h3(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$FlatBump$3$()));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__FlatBump$2__sr_LazyRef__Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$FlatBump$3$($thiz, FlatBump$lzy1$2) {
  return (FlatBump$lzy1$2.ci ? FlatBump$lzy1$2.cj : $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__FlatBump$lzyINIT1$1__sr_LazyRef__Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$FlatBump$3$($thiz, FlatBump$lzy1$2));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__flatAdj$1__sci_Map__Z__D__sci_Map__sci_Map__sci_Set__AI__D__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D__sci_Map__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__I__T2($thiz, flatBump$1, hasEL$1, NodeSep$2, labelW$3, selfRw$2, intraVEdge$5, classSize$5, Incr$5, dedgeVec$7, g$11, VirtualHalf$4, byId$4, u, v, base) {
  var x68 = flatBump$1.r(new $c_T2(u.bE(), v.bE()));
  if ((x68 instanceof $c_s_Some)) {
    var fb = x68.J;
    var width = ($p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__rw$1__sci_Map__sci_Map__sci_Set__AI__D__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D__sci_Map__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__D($thiz, labelW$3, selfRw$2, intraVEdge$5, classSize$5, Incr$5, dedgeVec$7, g$11, VirtualHalf$4, byId$4, u) + $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__lw$1__sci_Map__D__sci_Set__AI__D__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D__sci_Map__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__D($thiz, labelW$3, NodeSep$2, intraVEdge$5, classSize$5, Incr$5, dedgeVec$7, g$11, VirtualHalf$4, byId$4, v));
    var fm = Math.imul(fb.z2, (hasEL$1 ? 2 : 1));
    var m0a = $doubleToInt(((fm * NodeSep$2) + width));
    var x$2 = m0a;
    var x = fb.z1;
    var $x_1 = $m_RTLong$().d1((+Math.round(x)));
    var x$1_$_lo = $x_1.l;
    var x$1_$_hi = $x_1.h;
    var y = ((width + NodeSep$2) + ((4.294967296E9 * x$1_$_hi) + (x$1_$_lo >>> 0.0)));
    var m0 = $doubleToInt((+Math.max(x$2, y)));
    return new $c_T2(((base > m0) ? base : m0), fb.z3);
  }
  if (($m_s_None$() === x68)) {
    return new $c_T2(base, 0);
  }
  throw new $c_s_MatchError(x68);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__addLR$1__scm_HashMap__scm_ArrayBuffer__T__T__I__I__V($thiz, auxOut$1, edges$1, t, h, ml, w) {
  var f = (() => {
    $m_scm_ArrayBuffer$();
    return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  });
  if ((!($objectGetClass(auxOut$1) === $d_scm_HashMap.l()))) {
    var x1 = auxOut$1.r(t);
    if ((x1 instanceof $c_s_Some)) {
      var $x_1 = x1.J;
    } else {
      if ((!($m_s_None$() === x1))) {
        throw new $c_s_MatchError(x1);
      }
      var d = f();
      $p_scm_HashMap__put0__O__O__Z__s_Some(auxOut$1, t, d, false);
      var $x_1 = d;
    }
  } else {
    var originalHash = $m_sr_Statics$().u(t);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var idx = (hash & ((auxOut$1.S.a.length - 1) | 0));
    var x1$1 = auxOut$1.S.a[idx];
    var nd = ((x1$1 === null) ? null : x1$1.by(t, hash));
    if ((nd !== null)) {
      var $x_1 = nd.b9;
    } else {
      var table0 = auxOut$1.S;
      var default$1 = f();
      if ((((1 + auxOut$1.eh) | 0) >= auxOut$1.kI)) {
        $p_scm_HashMap__growTable__I__V(auxOut$1, (auxOut$1.S.a.length << 1));
      }
      $p_scm_HashMap__put0__O__O__Z__I__I__s_Some(auxOut$1, t, default$1, false, hash, ((table0 === auxOut$1.S) ? idx : (hash & ((auxOut$1.S.a.length - 1) | 0))));
      var $x_1 = default$1;
    }
  }
  $x_1.Y(h);
  edges$1.aw(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$NSEdge(t, h, ml, w));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__canreach$1__scm_HashMap__T__T__Z($thiz, auxOut$2, from, to) {
  var seen = $m_scm_Set$().dr($m_sr_ScalaRunTime$().f(new ($d_T.r().C)([from])));
  var elems = $m_sr_ScalaRunTime$().f(new ($d_T.r().C)([from]));
  var stk = $ct_scm_Stack__I__(new $c_scm_Stack(), 16).kl(elems);
  var hit = new $c_sr_BooleanRef((from === to));
  while (((!hit.dy) && (!stk.c()))) {
    var key = stk.h7(false);
    var f = (() => {
      $m_scm_ArrayBuffer$();
      return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
    });
    if ((!($objectGetClass(auxOut$2) === $d_scm_HashMap.l()))) {
      var x1 = auxOut$2.r(key);
      if ((x1 instanceof $c_s_Some)) {
        var $x_1 = x1.J;
      } else {
        if ((!($m_s_None$() === x1))) {
          throw new $c_s_MatchError(x1);
        }
        var $x_1 = f();
      }
    } else {
      var originalHash = $m_sr_Statics$().u(key);
      var hash = (originalHash ^ ((originalHash >>> 16) | 0));
      var x1$1 = auxOut$2.S.a[(hash & ((auxOut$2.S.a.length - 1) | 0))];
      var nd = ((x1$1 === null) ? null : x1$1.by(key, hash));
      var $x_1 = ((nd === null) ? f() : nd.b9);
    }
    $x_1.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((to, hit, seen, stk) => ((w) => {
      if ((w === to)) {
        hit.dy = true;
      } else if (seen.oA(w)) {
        stk.gm(w);
      }
    }))(to, hit, seen, stk)));
  }
  return hit.dy;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__portX$1__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T__s_Option__D($thiz, byId$7, g$16, nodeId, port) {
  var this$1 = byId$7.r(nodeId);
  if (this$1.c()) {
    var this$2 = $m_s_None$();
  } else {
    var x0 = this$1.d();
    var this$2 = new $c_s_Some((+$m_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$().a2P(x0, g$16, port).bH));
  }
  return (+(this$2.c() ? 0.0 : this$2.d()));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__vnodeCluster$1__sci_Vector__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Virtual__I($thiz, realEdges$1, cs$3, v) {
  var x113 = new $c_s_PartialFunction$Lifted(realEdges$1).as(v.kB);
  if ((x113 instanceof $c_s_Some)) {
    var re = x113.J;
    var end = cs$3.C();
    var isEmpty = (end <= 0);
    var scala$collection$immutable$Range$$lastElement = ((end - 1) | 0);
    var b = $m_sci_IndexedSeq$().b5();
    var it = new $c_sci_RangeIterator(0, 1, scala$collection$immutable$Range$$lastElement, isEmpty);
    while (it.g0) {
      var elem = it.hp();
      if ((cs$3.l(elem).n3.E(re.ai) && cs$3.l(elem).n3.E(re.ak))) {
        b.Y(elem);
      }
    }
    var this$6 = $f_sc_IterableOnceOps__minByOption__F1__s_math_Ordering__s_Option(b.aR(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((ci$2) => {
      var ci = (ci$2 | 0);
      return cs$3.l(ci).n3.aa();
    })), $m_s_math_Ordering$Int$());
    return ((this$6.c() ? (-1) : this$6.d()) | 0);
  }
  if (($m_s_None$() === x113)) {
    return (-1);
  }
  throw new $c_s_MatchError(x113);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__blockOf$1__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_layout_Order$Result__sci_Vector__sci_Vector__I__sci_Vector($thiz, cs$6, res$3, directMembers$1, realEdges$2, ci) {
  var x = cs$6.l(ci).jC;
  var end = cs$6.l(ci).l0;
  var this$11 = new $c_sc_Iterator$$anon$10(new $c_sci_RangeIterator(x, 1, end, (x > end)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((r) => {
    var r$1 = (r | 0);
    return new $c_sc_Iterator$$anon$6(res$3.oX.ay(r$1, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      $m_sci_Vector$();
      return $m_sci_Vector0$();
    }))).o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
      if ((x$1 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real)) {
        var x120 = x$1.mh;
        return directMembers$1.l(ci).E(x120);
      } else {
        return ((x$1 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Virtual) && ($p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__vnodeCluster$1__sci_Vector__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Virtual__I($thiz, realEdges$2, cs$6, x$1) === ci));
      }
    })), false);
  })));
  return $m_sci_Vector$().X(this$11);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__preorder$1__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__I__sci_Vector($thiz, g$19, ci) {
  var this$1 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$().qT(g$19, ci);
  $m_sci_Vector$();
  var b = new $c_sci_VectorBuilder();
  var it = this$1.o();
  while (it.p()) {
    b.fO($p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__preorder$1__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__I__sci_Vector($thiz, g$19, (it.q() | 0)));
  }
  return b.bY().mV(ci);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__pre$1__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__I__sci_Vector($thiz, g$20, ci) {
  var this$1 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$().qT(g$20, ci);
  $m_sci_Vector$();
  var b = new $c_sci_VectorBuilder();
  var it = this$1.o();
  while (it.p()) {
    b.fO($p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__pre$1__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__I__sci_Vector($thiz, g$20, (it.q() | 0)));
  }
  return b.bY().mV(ci);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__mergeVisitors$1__sci_Vector__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_model_REdge__sci_Vector($thiz, expansionOrder$1, cluX$1, re) {
  return expansionOrder$1.d8(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((ci) => {
    var ci$1 = (ci | 0);
    return (cluX$1.l(ci$1).n3.E(re.ai) !== cluX$1.l(ci$1).n3.E(re.ak));
  })), false);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__ownerOf$1__Lorg_jpablo_graphexplorer_graphviz_layout_Order$Result__sci_Vector__I__s_Option($thiz, res$6, realEdges$6, i) {
  var this$3 = new $c_s_PartialFunction$Lifted(res$6.Fj).as(i);
  var this$4 = ((this$3.c() || ((this$3.d() | 0) >= 0)) ? this$3 : $m_s_None$());
  var f = new $c_s_PartialFunction$Lifted(realEdges$6);
  return (this$4.c() ? $m_s_None$() : f.as(this$4.d()));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__grp$1__sci_Map__T__Lorg_jpablo_graphexplorer_graphviz_layout_Order$Result__sci_Vector__I__I($thiz, clustOfX$3, nid$1, res$7, realEdges$7, i) {
  var x137 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__ownerOf$1__Lorg_jpablo_graphexplorer_graphviz_layout_Order$Result__sci_Vector__I__s_Option($thiz, res$7, realEdges$7, i);
  if ((x137 instanceof $c_s_Some)) {
    var re = x137.J;
    var _1 = clustOfX$3.r(re.ai);
    var _2 = clustOfX$3.r(re.ak);
    if ((_1 instanceof $c_s_Some)) {
      var a = (_1.J | 0);
      if ((_2 instanceof $c_s_Some)) {
        if ((a === (_2.J | 0))) {
          return 0;
        }
      }
    }
    return ((re.ai === nid$1) ? 1 : 2);
  }
  if (($m_s_None$() === x137)) {
    return 0;
  }
  throw new $c_s_MatchError(x137);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__weightAttr$1__sci_Vector__I__I($thiz, realEdges$10, d) {
  var this$2 = new $c_s_PartialFunction$Lifted(realEdges$10).as(d);
  var this$4 = (this$2.c() ? $m_s_None$() : this$2.d().b4.ag.r("weight"));
  if (this$4.c()) {
    var this$8 = $m_s_None$();
  } else {
    var x0$1 = this$4.d();
    var this$8 = ($m_sc_StringParsers$().c1(x0$1) ? new $c_s_Some($m_jl_Double$().bd(x0$1)) : $m_s_None$());
  }
  if (this$8.c()) {
    var this$11 = $m_s_None$();
  } else {
    var x0$2 = this$8.d();
    var w = (+x0$2);
    var y = $doubleToInt(w);
    var this$11 = new $c_s_Some(((y < 0) ? 0 : y));
  }
  return ((this$11.c() ? 1 : this$11.d()) | 0);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__rebornAt$1__sci_Vector__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__I($thiz, visits$1, cluX$5, n) {
  if ((n instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real)) {
    var x153 = n.mh;
    var i = ((visits$1.C() - 1) | 0);
    var it = $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), new $c_sc_IndexedSeqView$Id(visits$1));
    while (true) {
      if ((it.kc > 0)) {
        var elem = it.q();
        var _$29 = (elem | 0);
        var $x_1 = (!cluX$5.l(_$29).n3.E(x153));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        i = ((i - 1) | 0);
      } else {
        break;
      }
    }
    return ((1 + i) | 0);
  } else {
    return 0;
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__inClust$1__sci_Vector__sci_Vector__I__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__Z($thiz, cluInfos$1, realEdges$11, ci, n) {
  if ((n instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real)) {
    var x178 = n.mh;
    return cluInfos$1.l(ci).n3.E(x178);
  } else if ((n instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Virtual)) {
    var x174 = n.kB;
    var this$5 = new $c_s_PartialFunction$Lifted(realEdges$11).as(x174);
    if ((!this$5.c())) {
      var x0 = this$5.d();
      return (cluInfos$1.l(ci).n3.E(x0.ai) && cluInfos$1.l(ci).n3.E(x0.ak));
    } else {
      return false;
    }
  } else {
    return false;
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__slice$1__Lorg_jpablo_graphexplorer_graphviz_layout_Order$Result__sci_Vector__sci_Vector__I__I__sci_Vector($thiz, res$13, cluInfos$3, realEdges$12, ci, r) {
  return res$13.oX.ay(r, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $m_sci_Vector$();
    return $m_sci_Vector0$();
  }))).bw(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$30) => $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__inClust$1__sci_Vector__sci_Vector__I__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__Z($thiz, cluInfos$3, realEdges$12, ci, _$30))));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__gRow$1__Lorg_jpablo_graphexplorer_graphviz_layout_Order$Result__I__sci_Vector($thiz, res$14, r) {
  return res$14.oX.ay(r, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $m_sci_Vector$();
    return $m_sci_Vector0$();
  })));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__makeLrvn$1__scm_Set__scm_ArrayBuffer__sci_Vector__Z__scm_ArrayBuffer__I__V($thiz, lrvnMade$1, clSlacks$1, cluInfos$5, flip$1, edges$8, ci) {
  if ((!lrvnMade$1.E(ci))) {
    lrvnMade$1.Y(ci);
    clSlacks$1.aw(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ClusterLn(ci));
    clSlacks$1.aw(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ClusterRn(ci));
    if ((((ci >= 0) && cluInfos$5.l(ci).pv()) && (!flip$1))) {
      var $x_2 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ClusterLn(ci).bE();
      var $x_1 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ClusterRn(ci).bE();
      var x = cluInfos$5.l(ci).aMA();
      var y = cluInfos$5.l(ci).aMw();
      edges$8.aw(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$NSEdge($x_2, $x_1, $doubleToInt((+Math.max(x, y))), 0));
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__containNodes$1__sci_Vector__Z__scm_ArrayBuffer__D__scm_Set__scm_ArrayBuffer__Lorg_jpablo_graphexplorer_graphviz_layout_Order$Result__sci_Vector__sci_Map__D__sci_Set__AI__D__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D__sci_Map__sci_Map__I__V($thiz, cluInfos$6, flip$2, edges$9, ClOffset$1, lrvnMade$2, clSlacks$2, res$15, realEdges$14, labelW$7, NodeSep$6, intraVEdge$9, classSize$9, Incr$9, dedgeVec$11, g$24, VirtualHalf$8, byId$11, selfRw$6, ci) {
  $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__makeLrvn$1__scm_Set__scm_ArrayBuffer__sci_Vector__Z__scm_ArrayBuffer__I__V($thiz, lrvnMade$2, clSlacks$2, cluInfos$6, flip$2, edges$9, ci);
  var bl = cluInfos$6.l(ci).aeV(flip$2);
  var br = cluInfos$6.l(ci).aeW(flip$2);
  var r = cluInfos$6.l(ci).jC;
  while ((r <= cluInfos$6.l(ci).l0)) {
    var row = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__slice$1__Lorg_jpablo_graphexplorer_graphviz_layout_Order$Result__sci_Vector__sci_Vector__I__I__sci_Vector($thiz, res$15, cluInfos$6, realEdges$14, ci, r);
    if ((!$f_sc_SeqOps__isEmpty__Z(row))) {
      var $x_3 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ClusterLn(ci).bE();
      var $x_2 = row.t().bE();
      var x = (($p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__lw$1__sci_Map__D__sci_Set__AI__D__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D__sci_Map__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__D($thiz, labelW$7, NodeSep$6, intraVEdge$9, classSize$9, Incr$9, dedgeVec$11, g$24, VirtualHalf$8, byId$11, row.t()) + ClOffset$1) + bl);
      var $x_1 = $m_RTLong$().d1((+Math.round(x)));
      edges$9.aw(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$NSEdge($x_3, $x_2, $s_RTLong__toInt__I__I__I($x_1.l, $x_1.h), 0));
      var $x_6 = row.bJ().bE();
      var $x_5 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ClusterRn(ci).bE();
      var x$2 = (($p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__rw$1__sci_Map__sci_Map__sci_Set__AI__D__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D__sci_Map__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__D($thiz, labelW$7, selfRw$6, intraVEdge$9, classSize$9, Incr$9, dedgeVec$11, g$24, VirtualHalf$8, byId$11, row.bJ()) + ClOffset$1) + br);
      var $x_4 = $m_RTLong$().d1((+Math.round(x$2)));
      edges$9.aw(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$NSEdge($x_6, $x_5, $s_RTLong__toInt__I__I__I($x_4.l, $x_4.h), 0));
    }
    r = ((1 + r) | 0);
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__containClustnodes$1__scm_ArrayBuffer__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Vector__Z__D__scm_Set__scm_ArrayBuffer__Lorg_jpablo_graphexplorer_graphviz_layout_Order$Result__sci_Vector__sci_Map__D__sci_Set__AI__D__sci_Vector__D__sci_Map__sci_Map__I__V($thiz, edges$10, g$25, cluInfos$7, flip$3, ClOffset$2, lrvnMade$3, clSlacks$3, res$16, realEdges$15, labelW$8, NodeSep$7, intraVEdge$10, classSize$10, Incr$10, dedgeVec$12, VirtualHalf$9, byId$12, selfRw$7, ci) {
  if ((ci >= 0)) {
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__containNodes$1__sci_Vector__Z__scm_ArrayBuffer__D__scm_Set__scm_ArrayBuffer__Lorg_jpablo_graphexplorer_graphviz_layout_Order$Result__sci_Vector__sci_Map__D__sci_Set__AI__D__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D__sci_Map__sci_Map__I__V($thiz, cluInfos$7, flip$3, edges$10, ClOffset$2, lrvnMade$3, clSlacks$3, res$16, realEdges$15, labelW$8, NodeSep$7, intraVEdge$10, classSize$10, Incr$10, dedgeVec$12, g$25, VirtualHalf$9, byId$12, selfRw$7, ci);
    var this$1 = edges$10.bB().o();
    _return: {
      var i = 0;
      var dropped = this$1.iV(0);
      while (dropped.p()) {
        var x0 = dropped.q();
        if (((x0.pT === new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ClusterLn(ci).bE()) && (x0.rp === new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ClusterRn(ci).bE()))) {
          var ei = i;
          break _return;
        }
        i = ((1 + i) | 0);
      }
      var ei = (-1);
    }
    if ((ei >= 0)) {
      var \u03b411$ = edges$10.l(ei);
      var weight$1 = ((128 + edges$10.l(ei).uu) | 0);
      edges$10.cM(ei, new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$NSEdge(\u03b411$.pT, \u03b411$.rp, \u03b411$.ut, weight$1));
    } else {
      edges$10.aw(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$NSEdge(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ClusterLn(ci).bE(), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ClusterRn(ci).bE(), 1, 128));
    }
  }
  $m_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$().qT(g$25, ci).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => {
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__containClustnodes$1__scm_ArrayBuffer__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Vector__Z__D__scm_Set__scm_ArrayBuffer__Lorg_jpablo_graphexplorer_graphviz_layout_Order$Result__sci_Vector__sci_Map__D__sci_Set__AI__D__sci_Vector__D__sci_Map__sci_Map__I__V($thiz, edges$10, g$25, cluInfos$7, flip$3, ClOffset$2, lrvnMade$3, clSlacks$3, res$16, realEdges$15, labelW$8, NodeSep$7, intraVEdge$10, classSize$10, Incr$10, dedgeVec$12, VirtualHalf$9, byId$12, selfRw$7, (v1 | 0));
  })));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__vnodeNotRelated$1__sci_Vector__sci_Vector__I__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__Z($thiz, realEdges$16, cluInfos$8, ci, n) {
  if ((n instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Virtual)) {
    var x183 = n.kB;
    var this$3 = new $c_s_PartialFunction$Lifted(realEdges$16).as(x183);
    if (this$3.c()) {
      return true;
    } else {
      var x0 = this$3.d();
      return ((!$f_sc_SeqOps__contains__O__Z(cluInfos$8.l(ci).Bg, x0.ai)) && (!$f_sc_SeqOps__contains__O__Z(cluInfos$8.l(ci).Bg, x0.ak)));
    }
  } else {
    return ((n instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$FlatLabel) || false);
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__isNormal$1__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__Z($thiz, n) {
  return ((n instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real) || false);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__keepout$1__sci_Vector__scm_ArrayBuffer__D__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__Lorg_jpablo_graphexplorer_graphviz_layout_Order$Result__sci_Vector__sci_Map__sci_Map__sci_Set__AI__D__sci_Vector__D__sci_Map__D__I__V($thiz, cluInfos$10, edges$11, ClOffset$3, g$26, res$17, realEdges$17, labelW$9, selfRw$8, intraVEdge$11, classSize$11, Incr$11, dedgeVec$13, VirtualHalf$10, byId$13, NodeSep$8, ci) {
  if ((ci >= 0)) {
    var r = cluInfos$10.l(ci).jC;
    while ((r <= cluInfos$10.l(ci).l0)) {
      var row = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__slice$1__Lorg_jpablo_graphexplorer_graphviz_layout_Order$Result__sci_Vector__sci_Vector__I__I__sci_Vector($thiz, res$17, cluInfos$10, realEdges$17, ci, r);
      if ((!$f_sc_SeqOps__isEmpty__Z(row))) {
        var grow = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__gRow$1__Lorg_jpablo_graphexplorer_graphviz_layout_Order$Result__I__sci_Vector($thiz, res$17, r);
        var pos = $f_sc_SeqOps__indexOf__O__I__I(grow, row.t(), 0);
        var i = ((pos - 1) | 0);
        var stop = false;
        while (((!stop) && (i >= 0))) {
          var u = grow.l(i);
          if (($p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__isNormal$1__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__Z($thiz, u) || $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__vnodeNotRelated$1__sci_Vector__sci_Vector__I__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__Z($thiz, realEdges$17, cluInfos$10, ci, u))) {
            var $x_3 = u.bE();
            var $x_2 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ClusterLn(ci).bE();
            var x = (ClOffset$3 + $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__rw$1__sci_Map__sci_Map__sci_Set__AI__D__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D__sci_Map__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__D($thiz, labelW$9, selfRw$8, intraVEdge$11, classSize$11, Incr$11, dedgeVec$13, g$26, VirtualHalf$10, byId$13, u));
            var $x_1 = $m_RTLong$().d1((+Math.round(x)));
            edges$11.aw(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$NSEdge($x_3, $x_2, $s_RTLong__toInt__I__I__I($x_1.l, $x_1.h), 0));
            stop = true;
          }
          i = ((i - 1) | 0);
        }
        var j = ((pos + row.C()) | 0);
        stop = false;
        while (((!stop) && (j < grow.C()))) {
          var u$2 = grow.l(j);
          if (($p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__isNormal$1__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__Z($thiz, u$2) || $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__vnodeNotRelated$1__sci_Vector__sci_Vector__I__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__Z($thiz, realEdges$17, cluInfos$10, ci, u$2))) {
            var $x_6 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ClusterRn(ci).bE();
            var $x_5 = u$2.bE();
            var x$2 = (ClOffset$3 + $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__lw$1__sci_Map__D__sci_Set__AI__D__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D__sci_Map__Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode__D($thiz, labelW$9, NodeSep$8, intraVEdge$11, classSize$11, Incr$11, dedgeVec$13, g$26, VirtualHalf$10, byId$13, u$2));
            var $x_4 = $m_RTLong$().d1((+Math.round(x$2)));
            edges$11.aw(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$NSEdge($x_6, $x_5, $s_RTLong__toInt__I__I__I($x_4.l, $x_4.h), 0));
            stop = true;
          }
          j = ((1 + j) | 0);
        }
      }
      r = ((1 + r) | 0);
    }
  }
  $m_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$().qT(g$26, ci).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => {
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__keepout$1__sci_Vector__scm_ArrayBuffer__D__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__Lorg_jpablo_graphexplorer_graphviz_layout_Order$Result__sci_Vector__sci_Map__sci_Map__sci_Set__AI__D__sci_Vector__D__sci_Map__D__I__V($thiz, cluInfos$10, edges$11, ClOffset$3, g$26, res$17, realEdges$17, labelW$9, selfRw$8, intraVEdge$11, classSize$11, Incr$11, dedgeVec$13, VirtualHalf$10, byId$13, NodeSep$8, (v1 | 0));
  })));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__containSubclust$1__sci_Vector__Z__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__scm_ArrayBuffer__D__scm_Set__scm_ArrayBuffer__I__V($thiz, cluInfos$11, flip$4, g$27, edges$12, ClOffset$4, lrvnMade$4, clSlacks$4, ci) {
  $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__makeLrvn$1__scm_Set__scm_ArrayBuffer__sci_Vector__Z__scm_ArrayBuffer__I__V($thiz, lrvnMade$4, clSlacks$4, cluInfos$11, flip$4, edges$12, ci);
  var bl = ((ci >= 0) ? cluInfos$11.l(ci).aeV(flip$4) : 0.0);
  var br = ((ci >= 0) ? cluInfos$11.l(ci).aeW(flip$4) : 0.0);
  $m_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$().qT(g$27, ci).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => {
    var cc = (v1 | 0);
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__makeLrvn$1__scm_Set__scm_ArrayBuffer__sci_Vector__Z__scm_ArrayBuffer__I__V($thiz, lrvnMade$4, clSlacks$4, cluInfos$11, flip$4, edges$12, cc);
    var $x_3 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ClusterLn(ci).bE();
    var $x_2 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ClusterLn(cc).bE();
    var x = (ClOffset$4 + bl);
    var $x_1 = $m_RTLong$().d1((+Math.round(x)));
    edges$12.aw(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$NSEdge($x_3, $x_2, $s_RTLong__toInt__I__I__I($x_1.l, $x_1.h), 0));
    var $x_6 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ClusterRn(cc).bE();
    var $x_5 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ClusterRn(ci).bE();
    var x$2 = (ClOffset$4 + br);
    var $x_4 = $m_RTLong$().d1((+Math.round(x$2)));
    edges$12.aw(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$NSEdge($x_6, $x_5, $s_RTLong__toInt__I__I__I($x_4.l, $x_4.h), 0));
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__containSubclust$1__sci_Vector__Z__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__scm_ArrayBuffer__D__scm_Set__scm_ArrayBuffer__I__V($thiz, cluInfos$11, flip$4, g$27, edges$12, ClOffset$4, lrvnMade$4, clSlacks$4, cc);
  })));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__separateSubclust$1__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Vector__scm_ArrayBuffer__D__scm_Set__scm_ArrayBuffer__Z__Lorg_jpablo_graphexplorer_graphviz_layout_Order$Result__sci_Vector__I__V($thiz, g$29, cluInfos$13, edges$14, ClOffset$6, lrvnMade$6, clSlacks$6, flip$6, res$18, realEdges$18, ci) {
  var kids = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$().qT(g$29, ci);
  kids.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => {
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__makeLrvn$1__scm_Set__scm_ArrayBuffer__sci_Vector__Z__scm_ArrayBuffer__I__V($thiz, lrvnMade$6, clSlacks$6, cluInfos$13, flip$6, edges$14, (v1 | 0));
  })));
  var end = kids.C();
  var isEmpty = (end <= 0);
  var scala$collection$immutable$Range$$lastElement = ((end - 1) | 0);
  if ((!isEmpty)) {
    var i = 0;
    while (true) {
      var x0 = i;
      var x = ((1 + x0) | 0);
      var end$1 = kids.C();
      var isEmpty$1 = (x >= end$1);
      var scala$collection$immutable$Range$$lastElement$1 = ((end$1 - 1) | 0);
      if ((!isEmpty$1)) {
        var i$1 = x;
        while (true) {
          var x0$1 = i$1;
          var low = (kids.l(x0) | 0);
          var high = (kids.l(x0$1) | 0);
          if ((cluInfos$13.l(low).jC > cluInfos$13.l(high).jC)) {
            var t = low;
            low = high;
            high = t;
          }
          if ((cluInfos$13.l(low).l0 >= cluInfos$13.l(high).jC)) {
            var r = cluInfos$13.l(high).jC;
            var grow = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__gRow$1__Lorg_jpablo_graphexplorer_graphviz_layout_Order$Result__I__sci_Vector($thiz, res$18, r);
            var lo = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__slice$1__Lorg_jpablo_graphexplorer_graphviz_layout_Order$Result__sci_Vector__sci_Vector__I__I__sci_Vector($thiz, res$18, cluInfos$13, realEdges$18, low, r);
            var hi = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__slice$1__Lorg_jpablo_graphexplorer_graphviz_layout_Order$Result__sci_Vector__sci_Vector__I__I__sci_Vector($thiz, res$18, cluInfos$13, realEdges$18, high, r);
            if (((!$f_sc_SeqOps__isEmpty__Z(lo)) && (!$f_sc_SeqOps__isEmpty__Z(hi)))) {
              if (($f_sc_SeqOps__indexOf__O__I__I(grow, lo.t(), 0) < $f_sc_SeqOps__indexOf__O__I__I(grow, hi.t(), 0))) {
                var \u03b412$___1 = low;
                var \u03b412$___2 = high;
              } else {
                var \u03b412$___1 = high;
                var \u03b412$___2 = low;
              }
              var l = (\u03b412$___1 | 0);
              var rr = (\u03b412$___2 | 0);
              var $x_3 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ClusterRn(l).bE();
              var $x_2 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ClusterLn(rr).bE();
              var $x_1 = $m_RTLong$().d1((+Math.round(ClOffset$6)));
              edges$14.aw(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$NSEdge($x_3, $x_2, $s_RTLong__toInt__I__I__I($x_1.l, $x_1.h), 0));
            }
          }
          if ((i$1 === scala$collection$immutable$Range$$lastElement$1)) {
            break;
          }
          i$1 = ((1 + i$1) | 0);
        }
      }
      if ((i === scala$collection$immutable$Range$$lastElement)) {
        break;
      }
      i = ((1 + i) | 0);
    }
  }
  kids.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1$3) => {
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__separateSubclust$1__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Vector__scm_ArrayBuffer__D__scm_Set__scm_ArrayBuffer__Z__Lorg_jpablo_graphexplorer_graphviz_layout_Order$Result__sci_Vector__I__V($thiz, g$29, cluInfos$13, edges$14, ClOffset$6, lrvnMade$6, clSlacks$6, flip$6, res$18, realEdges$18, (v1$3 | 0));
  })));
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$() {
  this.auq = null;
  this.aur = null;
  $n_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$ = this;
  this.auq = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_GraphMemo();
  this.aur = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_GraphMemo();
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$.prototype = $p;
$p.b94 = (function(g) {
  matchResult39: {
    var \u03b413$___1;
    var \u03b413$___2;
    var x187 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__xSolve__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T3(this, g);
    if ((x187 !== null)) {
      var \u03b413$___1 = x187.bH;
      var \u03b413$___2 = x187.bU;
      break matchResult39;
    }
    throw new $c_s_MatchError(x187);
  }
  return new $c_T2(\u03b413$___1, \u03b413$___2);
});
$p.aYq = (function(g) {
  return $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__xSolve__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T3(this, g).c3;
});
$p.a5k = (function(g) {
  var this$1 = this.aur;
  if ((g === this$1.f0)) {
    var $x_1 = this$1.f1;
  } else {
    matchResult40: {
      var allX$2;
      var x191 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$__xSolve__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T3($m_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$(), g);
      if ((x191 !== null)) {
        var allX$2 = x191.bU;
        break matchResult40;
      }
      throw new $c_s_MatchError(x191);
    }
    var v = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$9(g.cB.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n) => new $c_T2(n.br, allX$2.i(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real(n.br)))))));
    this$1.f0 = g;
    this$1.f1 = v;
    var $x_1 = v;
  }
  return $x_1;
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$, "org.jpablo.graphexplorer.graphviz.layout.XCoord$", ({
  vr: 1
}));
var $n_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$;
function $m_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$() {
  if ((!$n_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$)) {
    $n_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$ = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$();
  }
  return $n_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__cRound__D__D($thiz, v) {
  if ((v < 0.0)) {
    var x = (-v);
    var $x_1 = $m_RTLong$().d1((+Math.round(x)));
    var x$1_$_lo = $x_1.l;
    var x$1_$_hi = $x_1.h;
    return (-((4.294967296E9 * x$1_$_hi) + (x$1_$_lo >>> 0.0)));
  } else {
    var $x_2 = $m_RTLong$().d1((+Math.round(v)));
    var x$2_$_lo = $x_2.l;
    var x$2_$_hi = $x_2.h;
    return ((4.294967296E9 * x$2_$_hi) + (x$2_$_lo >>> 0.0));
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__objp2rect__Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__T4($thiz, o) {
  return new $c_T4($p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__cRound__D__D($thiz, o.fW), $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__cRound__D__D($thiz, o.gF), $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__cRound__D__D($thiz, (o.fW + o.wN)), $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__cRound__D__D($thiz, (o.gF + o.uC)));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__objplp2rect__Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__T4($thiz, o) {
  var lp = o.mi;
  return new $c_T4($p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__cRound__D__D($thiz, lp.jD), $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__cRound__D__D($thiz, lp.hc), $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__cRound__D__D($thiz, (lp.jD + lp.rr)), $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__cRound__D__D($thiz, (lp.hc + lp.o3)));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__objplpmks__Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__T4($thiz, o) {
  if ((o.mi !== null)) {
    var \u03b41$___1 = o.mi.rr;
    var \u03b41$___2 = o.mi.o3;
  } else {
    var \u03b41$___1 = 0.0;
    var \u03b41$___2 = 0.0;
  }
  var px = (+\u03b41$___1);
  var py = (+\u03b41$___2);
  var x = (o.fW - px);
  var $x_3 = Math.floor(x);
  var x$1 = (o.gF - py);
  var $x_2 = Math.floor(x$1);
  var x$2 = ((o.fW + o.wN) + px);
  var $x_1 = Math.ceil(x$2);
  var x$3 = ((o.gF + o.uC) + py);
  return new $c_T4((+$x_3), (+$x_2), (+$x_1), (+Math.ceil(x$3)));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__overlap__T4__T4__Z($thiz, r, s) {
  return (!(((((+r.bO) > (+s.ch)) || ((+s.bO) > (+r.ch))) || ((+r.bs) > (+s.ca))) || ((+s.bs) > (+r.ca))));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__aabbaabb__T4__T4__D($thiz, r, s) {
  if ((!$p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__overlap__T4__T4__Z($thiz, r, s))) {
    return 0.0;
  } else {
    var x = (+r.bO);
    var y = (+s.bO);
    var iminx = (+Math.max(x, y));
    var x$1 = (+r.bs);
    var y$1 = (+s.bs);
    var iminy = (+Math.max(x$1, y$1));
    var x$2 = (+r.ch);
    var y$2 = (+s.ch);
    var $x_1 = Math.min(x$2, y$2);
    var x$3 = (+r.ca);
    var y$3 = (+s.ca);
    return (((+$x_1) - iminx) * ((+Math.min(x$3, y$3)) - iminy));
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__getintrsxi__Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__I($thiz, op, cp) {
  var lp = op.mi;
  var clp = cp.mi;
  if (((((lp === null) || (clp === null)) || (!lp.Fs)) || (!clp.Fs))) {
    return (-1);
  }
  if ((((op.fW === 0.0) && (op.gF === 0.0)) || ((cp.fW === 0.0) && (cp.gF === 0.0)))) {
    return (-1);
  }
  return ((cp.gF < op.gF) ? ((cp.fW < op.fW) ? $thiz.L4 : ((cp.fW > op.fW) ? $thiz.a87 : $thiz.ZY)) : ((cp.gF > op.gF) ? ((cp.fW < op.fW) ? $thiz.a88 : ((cp.fW > op.fW) ? $thiz.L3 : $thiz.ZX)) : ((cp.fW < op.fW) ? $thiz.a00 : ((cp.fW > op.fW) ? $thiz.ZZ : (-1)))));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__recordIntrsx__Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__T4__D__ALorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__D($thiz, op, cp, rp, a, intrsx) {
  var i = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__getintrsxi__Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__I($thiz, op, cp);
  if ((i < 0)) {
    i = 5;
  }
  if ((intrsx.a[i] !== null)) {
    var maxa = 0.0;
    var sa1 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__aabbaabb__T4__T4__D($thiz, rp, $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__objp2rect__Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__T4($thiz, intrsx.a[i]));
    if ((sa1 > a)) {
      maxa = sa1;
    }
    if ((intrsx.a[i].mi !== null)) {
      var sa2 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__aabbaabb__T4__T4__D($thiz, rp, $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__objplp2rect__Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__T4($thiz, intrsx.a[i]));
      if ((sa2 > a)) {
        var y = maxa;
        maxa = (+Math.max(sa2, y));
      }
    }
    if ((maxa > 0.0)) {
      return maxa;
    }
    intrsx.a[i] = cp;
    return a;
  } else {
    intrsx.a[i] = cp;
    return a;
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__xlintersections__ALorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__ALorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__T4($thiz, objs, op, intrsx) {
  var lp = op.mi;
  var n = 0;
  var area = 0.0;
  var i = 0;
  while ((i < objs.a.length)) {
    var o = objs.a[i];
    if (((((((o !== op) && (!((o.wN > 0.0) && (o.uC > 0.0)))) && (o.fW > lp.jD)) && (o.fW < (lp.jD + lp.rr))) && (o.gF > lp.hc)) && (o.gF < (lp.hc + lp.o3)))) {
      n = ((1 + n) | 0);
    }
    i = ((1 + i) | 0);
  }
  var rect = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__objplp2rect__Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__T4($thiz, op);
  i = 0;
  while ((i < objs.a.length)) {
    var cp = objs.a[i];
    if (((cp !== op) && $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__overlap__T4__T4__Z($thiz, rect, $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__objplpmks__Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__T4($thiz, cp)))) {
      var a = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__aabbaabb__T4__T4__D($thiz, rect, $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__objp2rect__Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__T4($thiz, cp));
      if ((a > 0.0)) {
        area = (area + $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__recordIntrsx__Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__T4__D__ALorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__D($thiz, op, cp, rect, a, intrsx));
        n = ((1 + n) | 0);
      }
      if (((cp.mi !== null) && cp.mi.Fs)) {
        var a2 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__aabbaabb__T4__T4__D($thiz, rect, $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__objplp2rect__Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__T4($thiz, cp));
        if ((a2 > 0.0)) {
          area = (area + $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__recordIntrsx__Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__T4__D__ALorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__D($thiz, op, cp, rect, a2, intrsx));
          n = ((1 + n) | 0);
        }
      }
    }
    i = ((1 + i) | 0);
  }
  return new $c_T4(n, area, lp.jD, lp.hc);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__xladjust__ALorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__T4($thiz, objs, op) {
  var lp = op.mi;
  var xincr = (((2.0 * lp.rr) + op.wN) / $thiz.aus);
  var yincr = (((2.0 * lp.o3) + op.uC) / $thiz.aut);
  var intrsx = new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj.r().C)(9);
  lp.jD = (op.fW - lp.rr);
  lp.hc = (op.gF + op.uC);
  var bp = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__xlintersections__ALorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__ALorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__T4($thiz, objs, op, intrsx);
  if (((bp.bO | 0) === 0)) {
    return bp;
  }
  lp.hc = op.gF;
  var nbp = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__xlintersections__ALorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__ALorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__T4($thiz, objs, op, intrsx);
  if (((nbp.bO | 0) === 0)) {
    return nbp;
  }
  if (((+nbp.bs) < (+bp.bs))) {
    bp = nbp;
  }
  lp.hc = (op.gF - lp.o3);
  nbp = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__xlintersections__ALorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__ALorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__T4($thiz, objs, op, intrsx);
  if (((nbp.bO | 0) === 0)) {
    return nbp;
  }
  if (((+nbp.bs) < (+bp.bs))) {
    bp = nbp;
  }
  lp.jD = op.fW;
  lp.hc = (op.gF + op.uC);
  nbp = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__xlintersections__ALorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__ALorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__T4($thiz, objs, op, intrsx);
  if (((nbp.bO | 0) === 0)) {
    return nbp;
  }
  if (((+nbp.bs) < (+bp.bs))) {
    bp = nbp;
  }
  lp.hc = (op.gF - lp.o3);
  nbp = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__xlintersections__ALorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__ALorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__T4($thiz, objs, op, intrsx);
  if (((nbp.bO | 0) === 0)) {
    return nbp;
  }
  if (((+nbp.bs) < (+bp.bs))) {
    bp = nbp;
  }
  lp.jD = (op.fW + op.wN);
  lp.hc = (op.gF + op.uC);
  nbp = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__xlintersections__ALorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__ALorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__T4($thiz, objs, op, intrsx);
  if (((nbp.bO | 0) === 0)) {
    return nbp;
  }
  if (((+nbp.bs) < (+bp.bs))) {
    bp = nbp;
  }
  lp.hc = op.gF;
  nbp = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__xlintersections__ALorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__ALorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__T4($thiz, objs, op, intrsx);
  if (((nbp.bO | 0) === 0)) {
    return nbp;
  }
  if (((+nbp.bs) < (+bp.bs))) {
    bp = nbp;
  }
  lp.hc = (op.gF - lp.o3);
  nbp = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__xlintersections__ALorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__ALorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__T4($thiz, objs, op, intrsx);
  if (((nbp.bO | 0) === 0)) {
    return nbp;
  }
  if (((+nbp.bs) < (+bp.bs))) {
    bp = nbp;
  }
  if ((((((intrsx.a[$thiz.a88] !== null) || (intrsx.a[$thiz.ZX] !== null)) || (intrsx.a[$thiz.L3] !== null)) || (intrsx.a[$thiz.a00] !== null)) || (intrsx.a[$thiz.L4] !== null))) {
    if (((intrsx.a[$thiz.ZX] === null) && (intrsx.a[$thiz.L3] === null))) {
      lp.jD = (op.fW - lp.rr);
      lp.hc = (op.gF + op.uC);
      while ((lp.jD <= (op.fW + op.wN))) {
        nbp = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__xlintersections__ALorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__ALorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__T4($thiz, objs, op, intrsx);
        if (((nbp.bO | 0) === 0)) {
          return nbp;
        }
        if (((+nbp.bs) < (+bp.bs))) {
          bp = nbp;
        }
        lp.jD = (lp.jD + xincr);
      }
    }
    if (((intrsx.a[$thiz.a00] === null) && (intrsx.a[$thiz.L4] === null))) {
      lp.jD = (op.fW - lp.rr);
      lp.hc = (op.gF + op.uC);
      while ((lp.hc >= (op.gF - lp.o3))) {
        nbp = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__xlintersections__ALorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__ALorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__T4($thiz, objs, op, intrsx);
        if (((nbp.bO | 0) === 0)) {
          return nbp;
        }
        if (((+nbp.bs) < (+bp.bs))) {
          bp = nbp;
        }
        lp.hc = (lp.hc - yincr);
      }
    }
  }
  lp.jD = (op.fW + op.wN);
  lp.hc = (op.gF - lp.o3);
  if ((((((intrsx.a[$thiz.a87] !== null) || (intrsx.a[$thiz.ZY] !== null)) || (intrsx.a[$thiz.L4] !== null)) || (intrsx.a[$thiz.ZZ] !== null)) || (intrsx.a[$thiz.L3] !== null))) {
    if (((intrsx.a[$thiz.ZY] === null) && (intrsx.a[$thiz.L4] === null))) {
      lp.jD = (op.fW + op.wN);
      lp.hc = (op.gF - lp.o3);
      while ((lp.jD >= (op.fW - lp.rr))) {
        nbp = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__xlintersections__ALorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__ALorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__T4($thiz, objs, op, intrsx);
        if (((nbp.bO | 0) === 0)) {
          return nbp;
        }
        if (((+nbp.bs) < (+bp.bs))) {
          bp = nbp;
        }
        lp.jD = (lp.jD - xincr);
      }
    }
    if (((intrsx.a[$thiz.ZZ] === null) && (intrsx.a[$thiz.L3] === null))) {
      lp.jD = (op.fW + op.wN);
      lp.hc = (op.gF - lp.o3);
      while ((lp.hc <= (op.gF + op.uC))) {
        nbp = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__xlintersections__ALorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__ALorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__T4($thiz, objs, op, intrsx);
        if (((nbp.bO | 0) === 0)) {
          return nbp;
        }
        if (((+nbp.bs) < (+bp.bs))) {
          bp = nbp;
        }
        lp.hc = (lp.hc + yincr);
      }
    }
  }
  return bp;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__dist2__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__D($thiz, a, b) {
  var dx = (a.W - b.W);
  var dy = (a.a6 - b.a6);
  return ((dx * dx) + (dy * dy));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__bezierAt__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__D__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($thiz, c, t) {
  var vx = new $ac_D(new Float64Array([c.a[0].W, c.a[1].W, c.a[2].W, c.a[3].W]));
  var vy = new $ac_D(new Float64Array([c.a[0].a6, c.a[1].a6, c.a[2].a6, c.a[3].a6]));
  var i = 1;
  while ((i <= 3)) {
    var j = 0;
    while ((j <= ((3 - i) | 0))) {
      vx.a[j] = (((1.0 - t) * vx.a[j]) + (t * vx.a[((1 + j) | 0)]));
      vy.a[j] = (((1.0 - t) * vy.a[j]) + (t * vy.a[((1 + j) | 0)]));
      j = ((1 + j) | 0);
    }
    i = ((1 + i) | 0);
  }
  return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(vx.a[0], vy.a[0]);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__dotneatoClosest__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($thiz, pts, pt) {
  var besti = (-1);
  var bestdist2 = 1.0E38;
  var j = 0;
  while ((j < pts.C())) {
    var d2 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__dist2__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__D($thiz, pts.l(j), pt);
    if (((besti < 0) || (d2 < bestdist2))) {
      besti = j;
      bestdist2 = d2;
    }
    j = ((1 + j) | 0);
  }
  var bestj = besti;
  if ((bestj === ((pts.C() - 1) | 0))) {
    bestj = ((bestj - 1) | 0);
  }
  var j0 = Math.imul(3, ((bestj / 3) | 0));
  var c = new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY.r().C)([pts.l(j0), pts.l(((1 + j0) | 0)), pts.l(((2 + j0) | 0)), pts.l(((3 + j0) | 0))]);
  var low = 0.0;
  var high = 1.0;
  var dlow2 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__dist2__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__D($thiz, c.a[0], pt);
  var dhigh2 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__dist2__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__D($thiz, c.a[3], pt);
  var pt2 = c.a[0];
  var go = true;
  while (go) {
    var t = (0.5 * (low + high));
    pt2 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__bezierAt__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__D__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($thiz, c, t);
    var x = (dlow2 - dhigh2);
    if (((+Math.abs(x)) < 1.0)) {
      go = false;
    } else {
      var x$1 = (high - low);
      if (((+Math.abs(x$1)) < 1.0E-5)) {
        go = false;
      } else if ((dlow2 < dhigh2)) {
        high = t;
        dhigh2 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__dist2__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__D($thiz, pt2, pt);
      } else {
        low = t;
        dlow2 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__dist2__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__D($thiz, pt2, pt);
      }
    }
  }
  return pt2;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__edgeMidpoint__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$ESpline__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($thiz, spl) {
  var this$1 = spl.Fp;
  var p = (this$1.c() ? spl.wM.t() : this$1.d());
  var this$2 = spl.Fo;
  var q = (this$2.c() ? spl.wM.bJ() : this$2.d());
  return (($p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__dist2__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__D($thiz, p, q) < 1.0E-6) ? p : $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__dotneatoClosest__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($thiz, spl.wM, new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY((0.5 * (q.W + p.W)), (0.5 * (p.a6 + q.a6)))));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__labelDim__T__Z__D__T__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T2($thiz, raw, isHtml, fs, fn, g) {
  if (isHtml) {
    var this$1 = $m_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$().mU(raw);
    var this$2 = (this$1.c() ? $m_s_None$() : new $c_s_Some($m_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$().PU(this$1.d(), fs, fn, g.mj)));
    return (this$2.c() ? $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__plain$1__T__D__T__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T2($thiz, raw, fs, fn, g) : this$2.d());
  } else {
    return $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__plain$1__T__D__T__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T2($thiz, raw, fs, fn, g);
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__xlabelOf__Lorg_jpablo_graphexplorer_graphviz_model_Attrs__s_Option($thiz, attrs) {
  var this$1 = attrs.ag.r("xlabel");
  return ((this$1.c() || (this$1.d() !== "")) ? this$1 : $m_s_None$());
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__placeImpl__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Result($thiz, g) {
  var empty = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Result($m_sci_Map$EmptyMap$(), $m_sci_Map$EmptyMap$());
  var this$4 = g.cB;
  var res = false;
  var it = this$4.o();
  while (((!res) && it.p())) {
    var x0 = it.q();
    res = (!$p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__xlabelOf__Lorg_jpablo_graphexplorer_graphviz_model_Attrs__s_Option($m_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$(), x0.aK).c());
  }
  var anyNode = res;
  var this$6 = g.cu;
  var res$1 = false;
  var it$1 = this$6.o();
  while (((!res$1) && it$1.p())) {
    var x0$1 = it$1.q();
    res$1 = (!$p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__xlabelOf__Lorg_jpablo_graphexplorer_graphviz_model_Attrs__s_Option($m_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$(), x0$1.b4).c());
  }
  var anyEdge = res$1;
  if (((!anyNode) && (!anyEdge))) {
    return empty;
  }
  var flip = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().jT(g);
  var xs = $m_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$().a5k(g);
  matchResult7: {
    var \u03b42$___1;
    var \u03b42$___2;
    var x9 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().PL(g);
    if ((x9 !== null)) {
      var \u03b42$___1 = x9.g();
      var \u03b42$___2 = x9.h();
      break matchResult7;
    }
    throw new $c_s_MatchError(x9);
  }
  var ranks$2 = \u03b42$___1;
  var yOf$2 = \u03b42$___2;
  var spls = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$().a4K(g);
  var lps = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$().a43(g);
  var nodeSeq = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$16(new $c_sc_Iterator$$anon$9(g.cB.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => _$2.br)))));
  var this$14 = $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(g.cu);
  var m = $m_scm_Map$().aO();
  var it$2 = this$14.o();
  while (it$2.p()) {
    var elem = it$2.q();
    var key = elem.g().ai;
    m.ec(key, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((this$14) => (() => this$14.fS()))(this$14))).Y(elem);
  }
  var result = $m_sci_HashMap$().fk;
  var mapIt = m.o();
  while (mapIt.p()) {
    var x1 = mapIt.q();
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1);
    }
    var k = x1.g();
    var v = x1.h();
    result = result.hq(k, v.aR());
  }
  var byTail = result;
  $m_scm_ArrayBuffer$();
  var objs = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  $m_scm_ArrayBuffer$();
  var lbls = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  g.cB.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n$2) => {
    var this$19 = xs.r(n$2.br);
    if ((!this$19.c())) {
      var x0$2 = this$19.d();
      var xPt = (+x0$2);
      var this$20 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().J9(n$2, g);
      if ((!this$20.c())) {
        var x0$3 = this$20.d();
        var x$proxy2 = (+yOf$2.i(ranks$2.i(n$2.br)));
        var sx = (2.0 * $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().X5(x0$3));
        var sy = (2.0 * $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().X4(x0$3));
        var this$21 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__xlabelOf__Lorg_jpablo_graphexplorer_graphviz_model_Attrs__s_Option($thiz, n$2.aK);
        if (this$21.c()) {
          var this$33 = $m_s_None$();
        } else {
          var x0$4 = this$21.d();
          var this$23 = n$2.aK.ag.r("fontsize");
          if (this$23.c()) {
            var this$27 = $m_s_None$();
          } else {
            var x0$5 = this$23.d();
            var this$27 = ($m_sc_StringParsers$().c1(x0$5) ? new $c_s_Some($m_jl_Double$().bd(x0$5)) : $m_s_None$());
          }
          var fs = (+(this$27.c() ? 14.0 : this$27.d()));
          var fn = n$2.aK.dL("fontname", "Times");
          matchResult8: {
            var \u03b43$___1;
            var \u03b43$___2;
            var x12 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__labelDim__T__Z__D__T__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T2($thiz, x0$4, n$2.aK.n7.E("xlabel"), fs, fn, g);
            if ((x12 !== null)) {
              var \u03b43$___1 = (+x12.g());
              var \u03b43$___2 = (+x12.h());
              break matchResult8;
            }
            throw new $c_s_MatchError(x12);
          }
          var w$2 = (+\u03b43$___1);
          var h$2 = (+\u03b43$___2);
          matchResult9: {
            var \u03b44$___1;
            var \u03b44$___2;
            var x15 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__swapped$1__Z__D__D__T2($thiz, flip, w$2, h$2);
            if ((x15 !== null)) {
              var \u03b44$___1 = (+x15.g());
              var \u03b44$___2 = (+x15.h());
              break matchResult9;
            }
            throw new $c_s_MatchError(x15);
          }
          var this$33 = new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$XL((+\u03b44$___1), (+\u03b44$___2), new $c_s_util_Left(n$2.br)));
        }
        var xl = (this$33.c() ? null : this$33.d());
        if ((xl !== null)) {
          lbls.aw(xl);
        }
        objs.aw(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj((xPt - (0.5 * sx)), (x$proxy2 - (0.5 * sy)), sx, sy, xl));
      }
    }
    $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__outEdges$1__sci_Map__sci_Map__T__sci_Seq($thiz, byTail, nodeSeq, n$2.br).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
      var e = x$1.g();
      var idx = (x$1.h() | 0);
      var this$34 = lps.r(idx);
      if ((!this$34.c())) {
        var x0$6 = this$34.d();
        matchResult10: {
          var \u03b45$___1;
          var \u03b45$___2;
          var x18 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().tX(e, g);
          if ((x18 !== null)) {
            var \u03b45$___1 = (+x18.g());
            var \u03b45$___2 = (+x18.h());
            break matchResult10;
          }
          throw new $c_s_MatchError(x18);
        }
        var w$2$1 = (+\u03b45$___1);
        var h$2$1 = (+\u03b45$___2);
        matchResult11: {
          var \u03b46$___1;
          var \u03b46$___2;
          var x21 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__swapped$1__Z__D__D__T2($thiz, flip, w$2$1, h$2$1);
          if ((x21 !== null)) {
            var \u03b46$___1 = (+x21.g());
            var \u03b46$___2 = (+x21.h());
            break matchResult11;
          }
          throw new $c_s_MatchError(x21);
        }
        var cw$2$1 = (+\u03b46$___1);
        var ch$2$1 = (+\u03b46$___2);
        objs.aw(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj((x0$6.W - (0.5 * cw$2$1)), (x0$6.a6 - (0.5 * ch$2$1)), cw$2$1, ch$2$1, null));
      }
      var this$37 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__xlabelOf__Lorg_jpablo_graphexplorer_graphviz_model_Attrs__s_Option($thiz, e.b4);
      if ((!this$37.c())) {
        var x0$7 = this$37.d();
        var this$38 = spls.r(idx);
        if ((!this$38.c())) {
          var x0$8 = this$38.d();
          var this$40 = e.b4.ag.r("fontsize");
          if (this$40.c()) {
            var this$44 = $m_s_None$();
          } else {
            var x0$9 = this$40.d();
            var this$44 = ($m_sc_StringParsers$().c1(x0$9) ? new $c_s_Some($m_jl_Double$().bd(x0$9)) : $m_s_None$());
          }
          var fs$1 = (+(this$44.c() ? 14.0 : this$44.d()));
          var fn$1 = e.b4.dL("fontname", "Times");
          matchResult12: {
            var \u03b47$___1;
            var \u03b47$___2;
            var x24 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__labelDim__T__Z__D__T__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T2($thiz, x0$7, e.b4.n7.E("xlabel"), fs$1, fn$1, g);
            if ((x24 !== null)) {
              var \u03b47$___1 = (+x24.g());
              var \u03b47$___2 = (+x24.h());
              break matchResult12;
            }
            throw new $c_s_MatchError(x24);
          }
          var w$2$2 = (+\u03b47$___1);
          var h$2$2 = (+\u03b47$___2);
          matchResult13: {
            var \u03b48$___1;
            var \u03b48$___2;
            var x27 = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__swapped$1__Z__D__D__T2($thiz, flip, w$2$2, h$2$2);
            if ((x27 !== null)) {
              var \u03b48$___1 = (+x27.g());
              var \u03b48$___2 = (+x27.h());
              break matchResult13;
            }
            throw new $c_s_MatchError(x27);
          }
          var cw$2$2 = (+\u03b48$___1);
          var ch$2$2 = (+\u03b48$___2);
          var xl$1 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$XL(cw$2$2, ch$2$2, new $c_s_util_Right(idx));
          var mid = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__edgeMidpoint__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$ESpline__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY($thiz, x0$8);
          lbls.aw(xl$1);
          objs.aw(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj(mid.W, mid.a6, 0.0, 0.0, xl$1));
        }
      }
    })));
  })));
  if ($f_sc_SeqOps__isEmpty__Z(lbls)) {
    return empty;
  }
  matchResult14: {
    var force;
    var this$50 = g.f2.ag.r("forcelabels");
    if (this$50.c()) {
      var x30 = $m_s_None$();
    } else {
      var x0$10 = this$50.d();
      var x30 = new $c_s_Some(x0$10.toLowerCase());
    }
    matchAlts1: {
      matchAlts2: {
        if ((x30 instanceof $c_s_Some)) {
          var x36 = x30.J;
          if ((x36 === "false")) {
            break matchAlts2;
          }
          if ((x36 === "no")) {
            break matchAlts2;
          }
        }
        break matchAlts1;
      }
      var force = false;
      break matchResult14;
    }
    if ((x30 instanceof $c_s_Some)) {
      var v$1 = x30.J;
      var this$53 = $m_sc_StringParsers$().hT(v$1);
      var force = (this$53.c() || ((this$53.d() | 0) > 0));
      break matchResult14;
    }
    if (($m_s_None$() === x30)) {
      var force = true;
      break matchResult14;
    }
    throw new $c_s_MatchError(x30);
  }
  if ((objs.a1 >= 0)) {
    var destination = new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj.r().C)(objs.a1);
    objs.cR(destination, 0, 2147483647);
    var arr = destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it$3 = objs.bB().o();
    while (it$3.p()) {
      var elem$4 = it$3.q();
      var unboxedElem = ((elem$4 === null) ? null : elem$4);
      jsElems.push(unboxedElem);
    }
    var arr = new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj.r().C)(jsElems);
  }
  var len$1 = arr.a.length;
  var i = 0;
  while ((i < len$1)) {
    var x0$12 = arr.a[i];
    if ((x0$12.mi !== null)) {
      var bp = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__xladjust__ALorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj__T4($m_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$(), arr, x0$12);
      if (((bp.bO | 0) === 0)) {
        x0$12.mi.Fs = true;
      } else if ((((+bp.bs) === 0.0) || force)) {
        x0$12.mi.jD = (+bp.ch);
        x0$12.mi.hc = (+bp.ca);
        x0$12.mi.Fs = true;
      }
    }
    i = ((1 + i) | 0);
  }
  var nodesOut = new $c_sci_MapBuilderImpl();
  var edgesOut = new $c_sci_MapBuilderImpl();
  var it$4 = lbls.bB().o();
  while (it$4.p()) {
    var x0$13 = it$4.q();
    if (x0$13.Fs) {
      var cx = (x0$13.jD + (0.5 * x0$13.rr));
      var cy = (x0$13.hc + (0.5 * x0$13.o3));
      if (flip) {
        var \u03b49$___1 = x0$13.o3;
        var \u03b49$___2 = x0$13.rr;
      } else {
        var \u03b49$___1 = x0$13.rr;
        var \u03b49$___2 = x0$13.o3;
      }
      var w$4 = (+\u03b49$___1);
      var h$4 = (+\u03b49$___2);
      matchResult15: {
        var x37 = x0$13.auv;
        if ((x37 instanceof $c_s_util_Left)) {
          nodesOut.lR(x37.lP, new $c_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Placed(cx, cy, w$4, h$4));
          break matchResult15;
        }
        if ((x37 instanceof $c_s_util_Right)) {
          edgesOut.lR((x37.hm | 0), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Placed(cx, cy, w$4, h$4));
          break matchResult15;
        }
        throw new $c_s_MatchError(x37);
      }
    }
  }
  return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Result(nodesOut.oG(), edgesOut.oG());
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__plain$1__T__D__T__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T2($thiz, raw$1, fs$1, fn$1, g$2) {
  var $x_3 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$();
  var this$1 = g$2.j5;
  var $x_2 = $x_3.Xq(raw$1, fs$1, fn$1, (this$1.c() ? "" : this$1.d()));
  var $x_1 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$();
  var this$2 = g$2.j5;
  return new $c_T2($x_2, $x_1.PC(raw$1, fs$1, (this$2.c() ? "" : this$2.d())));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__outEdges$1__sci_Map__sci_Map__T__sci_Seq($thiz, byTail$1, nodeSeq$1, id) {
  return $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(byTail$1.ay(id, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $m_sci_Vector$();
    return $m_sci_Vector0$();
  }))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var e = x$1.g();
    var i = (x$1.h() | 0);
    return new $c_T2(nodeSeq$1.ay(e.ak, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 2147483647))), i);
  })), new $c_s_math_Ordering$Tuple2Ordering($m_s_math_Ordering$Int$(), $m_s_math_Ordering$Int$()));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__swapped$1__Z__D__D__T2($thiz, flip$1, w, h) {
  return (flip$1 ? new $c_T2(h, w) : new $c_T2(w, h));
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$() {
  this.auu = null;
  this.L4 = 0;
  this.ZY = 0;
  this.a87 = 0;
  this.a00 = 0;
  this.ZZ = 0;
  this.a88 = 0;
  this.ZX = 0;
  this.L3 = 0;
  this.aus = 0.0;
  this.aut = 0.0;
  $n_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$ = this;
  this.auu = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_GraphMemo();
  this.L4 = 0;
  this.ZY = 1;
  this.a87 = 2;
  this.a00 = 3;
  this.ZZ = 5;
  this.a88 = 6;
  this.ZX = 7;
  this.L3 = 8;
  this.aus = 8.0;
  this.aut = 2.0;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$.prototype = $p;
$p.a4q = (function(g) {
  var this$1 = this.auu;
  if ((g === this$1.f0)) {
    var $x_1 = this$1.f1;
  } else {
    var v = $p_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$__placeImpl__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Result($m_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$(), g);
    this$1.f0 = g;
    this$1.f1 = v;
    var $x_1 = v;
  }
  return $x_1;
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$, "org.jpablo.graphexplorer.graphviz.layout.XLabels$", ({
  vt: 1
}));
var $n_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$;
function $m_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$() {
  if ((!$n_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$)) {
    $n_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$ = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$();
  }
  return $n_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj(px, py, sx, sy, lbl) {
  this.fW = 0.0;
  this.gF = 0.0;
  this.wN = 0.0;
  this.uC = 0.0;
  this.mi = null;
  this.fW = px;
  this.gF = py;
  this.wN = sx;
  this.uC = sy;
  this.mi = lbl;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Obj, "org.jpablo.graphexplorer.graphviz.layout.XLabels$Obj", ({
  vu: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$XL(szx, szy, owner) {
  this.rr = 0.0;
  this.o3 = 0.0;
  this.auv = null;
  this.jD = 0.0;
  this.hc = 0.0;
  this.Fs = false;
  this.rr = szx;
  this.o3 = szy;
  this.auv = owner;
  this.jD = 0.0;
  this.hc = 0.0;
  this.Fs = false;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$XL.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$XL;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$XL() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$XL.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$XL = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$XL, "org.jpablo.graphexplorer.graphviz.layout.XLabels$XL", ({
  vv: 1
}));
function $p_Lorg_jpablo_graphexplorer_graphviz_metrics_FontMetrics$__canon__T__T($thiz, s) {
  var x = s.toLowerCase();
  var len = x.length;
  var sb = $ct_jl_StringBuilder__I__(new $c_jl_StringBuilder(), len);
  var i = 0;
  while ((i < len)) {
    var index = i;
    var x$1 = x.charCodeAt(index);
    if (((((x$1 - 97) | 0) >>> 0) <= 25)) {
      var str = ("" + $cToS(x$1));
      sb.ah = (sb.ah + str);
    }
    i = ((1 + i) | 0);
  }
  return ((len === sb.C()) ? x : sb.ah);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_metrics_FontMetrics$__variant__Lorg_jpablo_graphexplorer_graphviz_metrics_FontFamilyMetrics__Z__Z__AS($thiz, f, bold, italic) {
  if (bold) {
    if (italic) {
      return f.L6;
    }
    if ((!italic)) {
      return f.L5;
    }
  }
  if (((!bold) && italic)) {
    return f.L7;
  }
  return f.L9;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_metrics_FontMetrics$() {
  this.auw = null;
  $n_Lorg_jpablo_graphexplorer_graphviz_metrics_FontMetrics$ = this;
  var $x_2 = $m_sci_Map$();
  var this$1 = $m_Lorg_jpablo_graphexplorer_graphviz_metrics_FontMetricsTables$().a89;
  var rest = this$1;
  var h = null;
  var t = null;
  while ((rest !== $m_sci_Nil$())) {
    var x0 = rest.t();
    var this$5 = x0.L8;
    var f = ((f$2) => ((n) => new $c_T2($p_Lorg_jpablo_graphexplorer_graphviz_metrics_FontMetrics$__canon__T__T(this, n), f$2)))(x0);
    if ((this$5 === $m_sci_Nil$())) {
      var $x_1 = $m_sci_Nil$();
    } else {
      var x0$1 = this$5.t();
      var h$1 = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
      var t$1 = h$1;
      var rest$1 = this$5.v();
      while ((rest$1 !== $m_sci_Nil$())) {
        var x0$2 = rest$1.t();
        var nx = new $c_sci_$colon$colon(f(x0$2), $m_sci_Nil$());
        t$1.U = nx;
        t$1 = nx;
        rest$1 = rest$1.v();
      }
      var $x_1 = h$1;
    }
    var it = $x_1.o();
    while (it.p()) {
      var nx$1 = new $c_sci_$colon$colon(it.q(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx$1;
      } else {
        t.U = nx$1;
      }
      t = nx$1;
    }
    rest = rest.v();
  }
  this.auw = $x_2.ao(((h === null) ? $m_sci_Nil$() : h));
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_metrics_FontMetrics$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_metrics_FontMetrics$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_metrics_FontMetrics$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_metrics_FontMetrics$.prototype = $p;
$p.b19 = (function(fontName) {
  return this.auw.ay($p_Lorg_jpablo_graphexplorer_graphviz_metrics_FontMetrics$__canon__T__T(this, fontName), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $m_Lorg_jpablo_graphexplorer_graphviz_metrics_FontMetrics$();
    return $m_Lorg_jpablo_graphexplorer_graphviz_metrics_FontMetricsTables$().a89.t();
  })));
});
$p.WI = (function(fontName, text, bold, italic) {
  var fam = this.b19(fontName);
  var w = $p_Lorg_jpablo_graphexplorer_graphviz_metrics_FontMetrics$__variant__Lorg_jpablo_graphexplorer_graphviz_metrics_FontFamilyMetrics__Z__Z__AS(this, fam, bold, italic);
  var bytes = $f_T__getBytes__Ljava_nio_charset_Charset__AB(text, $m_Ljava_nio_charset_UTF\uff3f8$());
  var sum = 0;
  var i = 0;
  while ((i < bytes.a.length)) {
    var code = (255 & bytes.a[i]);
    var rawWidth = w.a[((code >= 128) ? 32 : code)];
    sum = ((sum + ((rawWidth === (-1)) ? 0 : rawWidth)) | 0);
    i = ((1 + i) | 0);
  }
  return (sum / fam.La);
});
var $d_Lorg_jpablo_graphexplorer_graphviz_metrics_FontMetrics$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_metrics_FontMetrics$, "org.jpablo.graphexplorer.graphviz.metrics.FontMetrics$", ({
  vw: 1
}));
var $n_Lorg_jpablo_graphexplorer_graphviz_metrics_FontMetrics$;
function $m_Lorg_jpablo_graphexplorer_graphviz_metrics_FontMetrics$() {
  if ((!$n_Lorg_jpablo_graphexplorer_graphviz_metrics_FontMetrics$)) {
    $n_Lorg_jpablo_graphexplorer_graphviz_metrics_FontMetrics$ = new $c_Lorg_jpablo_graphexplorer_graphviz_metrics_FontMetrics$();
  }
  return $n_Lorg_jpablo_graphexplorer_graphviz_metrics_FontMetrics$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_metrics_FontMetricsTables$() {
  this.a89 = null;
  $n_Lorg_jpablo_graphexplorer_graphviz_metrics_FontMetricsTables$ = this;
  var $x_12 = $m_sci_Nil$();
  var $x_11 = $m_sr_ScalaRunTime$();
  var names = $m_sci_Nil$().b6($m_sr_ScalaRunTime$().f(new ($d_T.r().C)(["times", "timesroman", "timesnewroman", "freeserif", "liberationserif", "nimbusroman", "texgyretermes", "tinos", "thorndale"])));
  var xs = $constArrSDiffs_I(128, "|]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]0@^5g4w5y]0EgLlNIu9v]:s4`O;z5gJs1v>d]]]]]]]]]Av]0Bg]]Hg0NnCfLl]3nHyLm:q]O7`3p0EgHy0AwEg]Ei:qLlHz3m7a]>cAw]HyO>dLl3n8t1|Eg7`3pLj3pLjHz:s]Av]>dAv10]O>d]]]Eg3pHy>d]>dAv]Lj2gO>`0Az3zNMh");
  var len = xs.a.length;
  var ys = new $ac_S(len);
  if ((len > 0)) {
    var i = 0;
    while ((i < len)) {
      ys.a[i] = ((xs.a[i] << 16) >> 16);
      i = ((1 + i) | 0);
    }
  }
  var xs$1 = $constArrSDiffs_I(128, "|]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]0@^5g>dLl]10]EgNLl3n]:s4lO;n5gJs1v>d]]]]]]]]]Eg]?b]]Kn0KnBsLl3n]LlLj:s]O7a7`0AvHz0AtAw3oEg:sLkEi7`3n]0AvO>d]LlO:qLl3n?yJwEg:s3pHw7cHwHz:s3pO>c3n>fO>c13nO>fLj3p]HwLmLj>fLj>dAv]LjLwDy;a8_NNs");
  var len$1 = xs$1.a.length;
  var ys$1 = new $ac_S(len$1);
  if ((len$1 > 0)) {
    var i$1 = 0;
    while ((i$1 < len$1)) {
      ys$1.a[i$1] = ((xs$1.a[i$1] << 16) >> 16);
      i$1 = ((1 + i$1) | 0);
    }
  }
  var xs$2 = $constArrSDiffs_I(128, "|]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]0@^5g5o5a]0EgLlNKz7q]:s;cO4w5gJs1v>d]]]]]]]]]Eg]0Ey]]Dw0JyO<d]3p3nHy]7a]O7`7`>fHz0AtEi3nHy7aHyHz3p:qHy>dAvLm]EgHy7a2`5]Eg:s]Lj3pLjEi>d]Av]:qEi0LkAv]]]Hz]Hy>dLj>fAt]Lm0sH]8]9^NMh");
  var len$2 = xs$2.a.length;
  var ys$2 = new $ac_S(len$2);
  if ((len$2 > 0)) {
    var i$2 = 0;
    while ((i$2 < len$2)) {
      ys$2.a[i$2] = ((xs$2.a[i$2] << 16) >> 16);
      i$2 = ((1 + i$2) | 0);
    }
  }
  var xs$3 = $constArrSDiffs_I(128, "|]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]0@^8z:qLl]0EgLlO0]3n]:s4lO;n5gJs1v>d]]]]]]]]]Eg]?b]]Kn0EeEk]]3nLl]3n3oO7a7`:sLj0AwEg]Hy7aLlHz3m7aLl>dAvLj]O>dLl3n?bKnEg:s]Lj3pLjHz:s3pO>c]>dAv10]AwLj]]Hz]Hy0AwHw>fEgLjLmMiGw8c>cNKm");
  var len$3 = xs$3.a.length;
  var ys$3 = new $ac_S(len$3);
  if ((len$3 > 0)) {
    var i$3 = 0;
    while ((i$3 < len$3)) {
      ys$3.a[i$3] = ((xs$3.a[i$3] << 16) >> 16);
      i$3 = ((1 + i$3) | 0);
    }
  }
  var $x_10 = new $c_Lorg_jpablo_graphexplorer_graphviz_metrics_FontFamilyMetrics(names, 2048, ys, ys$1, ys$2, ys$3);
  var names$1 = $m_sci_Nil$().b6($m_sr_ScalaRunTime$().f(new ($d_T.r().C)(["helvetica", "arial", "arialmt", "freesans", "liberationsans", "arimo", "albany", "nimbussans", "nimbussansa", "texgyreheros", "albany", "arimo"])));
  var xs$4 = $constArrSDiffs_I(128, "|]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]0Aw]4{<y]0EgAvO1n9`]3p<lO<j3nLl]0Aw]]]]]]]]]O>c]0Cp]]Nd0MiO9t]3n]LlLj:sLkO3o>d:sHz0AtHz3oHz7`LkLlLj7aLl0AtO>f]LjO:s]]<e5oAt>f]Lj3p]O>c0Aw]O:q]0AvO>d17`O>f]]]At:sAv0AwLj>dAv]]EiKe4u0@]NJp");
  var len$4 = xs$4.a.length;
  var ys$4 = new $ac_S(len$4);
  if ((len$4 > 0)) {
    var i$4 = 0;
    while ((i$4 < len$4)) {
      ys$4.a[i$4] = ((xs$4.a[i$4] << 16) >> 16);
      i$4 = ((1 + i$4) | 0);
    }
  }
  var xs$5 = $constArrSDiffs_I(128, "|]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]0Aw3n9^5e]0EgEgO1]6`]3p<lO<j3nLl]0Aw]]]]]]]]]At]0@_]]1t0GgO?w]]]LlLj:sLkO3o0Aw:qHy>dHz3oHz7`LkLlLj7aLl0AtO>f]LjO>dLl3n0@_NdAt>f3mLm3mLmAt0Av]O:s]0AwO>c17aO>c]]]Aw:sAt0AvLm>cAw]LjHzI]7]<lNJp");
  var len$5 = xs$5.a.length;
  var ys$5 = new $ac_S(len$5);
  if ((len$5 > 0)) {
    var i$5 = 0;
    while ((i$5 < len$5)) {
      ys$5.a[i$5] = ((xs$5.a[i$5] << 16) >> 16);
      i$5 = ((1 + i$5) | 0);
    }
  }
  var xs$6 = $constArrSDiffs_I(128, "|]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]0Aw]4{<y]0EgAvO1n9`]3p<lO<j3nLl]0Aw]]]]]]]]]O>c]0Cp]]Nd0MiO9t]3n]LlLj:sLkO3o>d:sHz0AtHz3oHz7`LkLlLj7aLl0AtO>f]LjO:s]]<e5oAt>f]Lj3p]O>c0Aw]O:q]0AvO>d17`O>f]]]At:sAv0AwLj>dAv]]EiKe4u0@]NJp");
  var len$6 = xs$6.a.length;
  var ys$6 = new $ac_S(len$6);
  if ((len$6 > 0)) {
    var i$6 = 0;
    while ((i$6 < len$6)) {
      ys$6.a[i$6] = ((xs$6.a[i$6] << 16) >> 16);
      i$6 = ((1 + i$6) | 0);
    }
  }
  var xs$7 = $constArrSDiffs_I(128, "|]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]0Aw3n9^5e]0EgEgO1]6`]3p<lO<j3nLl]0Aw]]]]]]]]]At]0@_]]1t0GgO?w]]]LlLj:sLkO3o0Aw:qHy>dHz3oHz7`LkLlLj7aLl0AtO>f]LjO>dLl3n0@_NdAt>f3mLm3mLmAt0Av]O:s]0AwO>c17aO>c]]]Aw:sAt0AvLm>cAw]LjHzI]7]<lNJp");
  var len$7 = xs$7.a.length;
  var ys$7 = new $ac_S(len$7);
  if ((len$7 > 0)) {
    var i$7 = 0;
    while ((i$7 < len$7)) {
      ys$7.a[i$7] = ((xs$7.a[i$7] << 16) >> 16);
      i$7 = ((1 + i$7) | 0);
    }
  }
  var $x_9 = new $c_Lorg_jpablo_graphexplorer_graphviz_metrics_FontFamilyMetrics(names$1, 2048, ys$4, ys$5, ys$6, ys$7);
  var names$2 = $m_sci_Nil$().b6($m_sr_ScalaRunTime$().f(new ($d_T.r().C)(["cour", "courier", "couriernew", "nimbusmono", "texgyrecursor", "freemono", "liberationmono", "cousine", "cumberland"])));
  var xs$8 = $constArrSDiffs_I(128, "|]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]16k]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]NIo");
  var len$8 = xs$8.a.length;
  var ys$8 = new $ac_S(len$8);
  if ((len$8 > 0)) {
    var i$8 = 0;
    while ((i$8 < len$8)) {
      ys$8.a[i$8] = ((xs$8.a[i$8] << 16) >> 16);
      i$8 = ((1 + i$8) | 0);
    }
  }
  var xs$9 = $constArrSDiffs_I(128, "|]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]16k]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]NIo");
  var len$9 = xs$9.a.length;
  var ys$9 = new $ac_S(len$9);
  if ((len$9 > 0)) {
    var i$9 = 0;
    while ((i$9 < len$9)) {
      ys$9.a[i$9] = ((xs$9.a[i$9] << 16) >> 16);
      i$9 = ((1 + i$9) | 0);
    }
  }
  var xs$10 = $constArrSDiffs_I(128, "|]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]16k]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]NIo");
  var len$10 = xs$10.a.length;
  var ys$10 = new $ac_S(len$10);
  if ((len$10 > 0)) {
    var i$10 = 0;
    while ((i$10 < len$10)) {
      ys$10.a[i$10] = ((xs$10.a[i$10] << 16) >> 16);
      i$10 = ((1 + i$10) | 0);
    }
  }
  var xs$11 = $constArrSDiffs_I(128, "|]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]16k]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]NIo");
  var len$11 = xs$11.a.length;
  var ys$11 = new $ac_S(len$11);
  if ((len$11 > 0)) {
    var i$11 = 0;
    while ((i$11 < len$11)) {
      ys$11.a[i$11] = ((xs$11.a[i$11] << 16) >> 16);
      i$11 = ((1 + i$11) | 0);
    }
  }
  var $x_8 = new $c_Lorg_jpablo_graphexplorer_graphviz_metrics_FontFamilyMetrics(names$2, 2048, ys$8, ys$9, ys$10, ys$11);
  var names$3 = $m_sci_Nil$().b6($m_sr_ScalaRunTime$().f(new ($d_T.r().C)(["Nunito"])));
  var xs$12 = $constArrSDiffs_I(128, "]|]]]]]]]]]]]8`Gz]]]]]]]]]]]]]]]]]8`O_5a6m]:gHpAe3]]4b4sDi6aIy1t9z]]]]]]]]]Di];q]]K`?tIdNhz2bK^Nz5o1`@e2`9jMk9uLj0xKw4cL{Ngp3{Nv<yAzNgvGkO]1]8zLy]0{1rLe3uNjIv7zOkEma8eIq0AmG]q0x]H|3xKz6pNo:cFarNjLnMf2t7uO=d");
  var len$12 = xs$12.a.length;
  var ys$12 = new $ac_S(len$12);
  if ((len$12 > 0)) {
    var i$12 = 0;
    while ((i$12 < len$12)) {
      ys$12.a[i$12] = ((xs$12.a[i$12] << 16) >> 16);
      i$12 = ((1 + i$12) | 0);
    }
  }
  var xs$13 = $constArrSDiffs_I(128, "]|]]]]]]]]]]]8mGm]]]]]]]]]]]]]]]]]8mOf6e4u]:vIb@z3p]2|4pE]5wJc2^8|]]]]]]]]]E]];]]]Kp?hIoNeu2oJxNz5k1b@r2e9tLv9oLe1bKx4bLzNfs3rOd<mBdNgpHbNt1f7sLy]1l1rL]4]NcJk7mOjEsa8rId0AkFyt0u]Im3]Lu6`Ni:cFjOiNiMjLv3d6nO=d");
  var len$13 = xs$13.a.length;
  var ys$13 = new $ac_S(len$13);
  if ((len$13 > 0)) {
    var i$13 = 0;
    while ((i$13 < len$13)) {
      ys$13.a[i$13] = ((xs$13.a[i$13] << 16) >> 16);
      i$13 = ((1 + i$13) | 0);
    }
  }
  var xs$14 = $constArrSDiffs_I(128, "]|]]]]]]]]]]]8`Gz]]]]]]]]]]]]]]]]]8`O_5a6m]:gHpAe3]]4b4sDi6aIy1t9z]]]]]]]]]Di];q]]K`?tIdNhz2bK^Nz5o1`@e2`9jMk9vLh0yKw4cL{Ngp3{Nu<zAzNgvGkO]1]8zLy]0{1rLe3uNjIv7zOkEma8eIq0AmG]q0x]H|3xKz6pNo:cFarNjLnMf2t7uO=d");
  var len$14 = xs$14.a.length;
  var ys$14 = new $ac_S(len$14);
  if ((len$14 > 0)) {
    var i$14 = 0;
    while ((i$14 < len$14)) {
      ys$14.a[i$14] = ((xs$14.a[i$14] << 16) >> 16);
      i$14 = ((1 + i$14) | 0);
    }
  }
  var xs$15 = $constArrSDiffs_I(128, "]|]]]]]]]]]]]8mGm]]]]]]]]]]]]]]]]]8mOf6e4u]:vIb@z3p]2|4pE]5wJc2^8|]]]]]]]]]E]];]]]Kp?hIoNeu2oJxNz5k1b@r2e9sLw9pLc1cKx4bLzNfs3rOd<mBdNgpHbNt1f7sLy]1l1rL]4]NcJk7mOjEsa8rId0AkFyt0u]Im3]Lu6`Ni:cFjOiNiMjLv3d6nO=d");
  var len$15 = xs$15.a.length;
  var ys$15 = new $ac_S(len$15);
  if ((len$15 > 0)) {
    var i$15 = 0;
    while ((i$15 < len$15)) {
      ys$15.a[i$15] = ((xs$15.a[i$15] << 16) >> 16);
      i$15 = ((1 + i$15) | 0);
    }
  }
  var $x_7 = new $c_Lorg_jpablo_graphexplorer_graphviz_metrics_FontFamilyMetrics(names$3, 1000, ys$12, ys$13, ys$14, ys$15);
  var names$4 = $m_sci_Nil$().b6($m_sr_ScalaRunTime$().f(new ($d_T.r().C)(["dejavusans"])));
  var xs$16 = $constArrSDiffs_I(128, "|]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]0Di5g3v0HcC`0D`E`NOs7i]7^0EqNNt2uMe1d0Cb]]]]]]]]]O<x]10_]]O<h0N^O;va0v4pGbLi<vNnO2u]0G`Is0CoHr2mDd;vJ`LbNl7uL{0CmO<oKe4uO=aLp3j0LrO:i]7d1jJo5kNuO?b0B`{O9d]0CfO<t1<oO:dNp1l]As7^Gu?lMg>lAn]Kt7aO<x0Cb<zN:h");
  var len$16 = xs$16.a.length;
  var ys$16 = new $ac_S(len$16);
  if ((len$16 > 0)) {
    var i$16 = 0;
    while ((i$16 < len$16)) {
      ys$16.a[i$16] = ((xs$16.a[i$16] << 16) >> 16);
      i$16 = ((1 + i$16) | 0);
    }
  }
  var xs$17 = $constArrSDiffs_I(128, "|]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]0Fg6z4b0DfFz0CpGsNKv9r]4d0DbO2s2eMuO_0Eb]]]]]]]]]O=_]0L^]]O?m0JyAnOeNc6bFp]8w1^O2e]0IvGc0FzEy0xHm7mJyLwMo8gMo0E_O:uM]_O>xJa5y0HiO:i];c2qHa7yMp@k0A|uO8i]0DqO;i1<uO:yNj1x]Au6nHm>|Lb0AjO>bkKn8gO9w0Fc8_N:h");
  var len$17 = xs$17.a.length;
  var ys$17 = new $ac_S(len$17);
  if ((len$17 > 0)) {
    var i$17 = 0;
    while ((i$17 < len$17)) {
      ys$17.a[i$17] = ((xs$17.a[i$17] << 16) >> 16);
      i$17 = ((1 + i$17) | 0);
    }
  }
  var xs$18 = $constArrSDiffs_I(128, "|]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]0Di5g3v0HcC`0D`E`NOs7i]7^0EqNNt2uMe1d0Cb]]]]]]]]]O<x]10_]]O<h0N^O;va0v4pGbLi<vNnO2u]0G`Is0CoHr2mDd;vJ`LbNl7uL{0CmO<oKe4uO=aLp3j0LrO:i]7d1jJo5kNuO?b0B`{O9d]0CfO<t1<oO:dNp1l]As7^Gu?lMg>lAn]Kt7aO<x0Cb<zN:h");
  var len$18 = xs$18.a.length;
  var ys$18 = new $ac_S(len$18);
  if ((len$18 > 0)) {
    var i$18 = 0;
    while ((i$18 < len$18)) {
      ys$18.a[i$18] = ((xs$18.a[i$18] << 16) >> 16);
      i$18 = ((1 + i$18) | 0);
    }
  }
  var xs$19 = $constArrSDiffs_I(128, "|]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]0Fg6z4b;c]0CpGsNKv9r]4d0DbO2s2eMuO_0Eb]]]]]]]]]O=_]0L^]]O?m0JyAnOeNc6bFp]8w1^O2e]0IvGc0FzEy0xHm7mJyLwMo8gMo0E_O:uM]_O>xJa5y0HiO:i];c2qHa7yMp@k0A|uO8i]0DqO;i1<uO:yNj1x]Au6nHm>|Lb0AjO>bkKn8gO9w0Fc8_N:h");
  var len$19 = xs$19.a.length;
  var ys$19 = new $ac_S(len$19);
  if ((len$19 > 0)) {
    var i$19 = 0;
    while ((i$19 < len$19)) {
      ys$19.a[i$19] = ((xs$19.a[i$19] << 16) >> 16);
      i$19 = ((1 + i$19) | 0);
    }
  }
  var $x_6 = new $c_Lorg_jpablo_graphexplorer_graphviz_metrics_FontFamilyMetrics(names$4, 2048, ys$16, ys$17, ys$18, ys$19);
  var names$5 = $m_sci_Nil$().b6($m_sr_ScalaRunTime$().f(new ($d_T.r().C)(["consola", "consolas"])));
  var xs$20 = $constArrSDiffs_I(128, "13cNLv]]]]]]]]]]]^|]]]]]]]]]]]]]]]]]13d]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]NLv");
  var len$20 = xs$20.a.length;
  var ys$20 = new $ac_S(len$20);
  if ((len$20 > 0)) {
    var i$20 = 0;
    while ((i$20 < len$20)) {
      ys$20.a[i$20] = ((xs$20.a[i$20] << 16) >> 16);
      i$20 = ((1 + i$20) | 0);
    }
  }
  var xs$21 = $constArrSDiffs_I(128, "13cNLv]]]]]]]]]]]^|]]]]]]]]]]]]]]]]]13d]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]NLv");
  var len$21 = xs$21.a.length;
  var ys$21 = new $ac_S(len$21);
  if ((len$21 > 0)) {
    var i$21 = 0;
    while ((i$21 < len$21)) {
      ys$21.a[i$21] = ((xs$21.a[i$21] << 16) >> 16);
      i$21 = ((1 + i$21) | 0);
    }
  }
  var xs$22 = $constArrSDiffs_I(128, "13cNLv]]]]]]]]]]]^|]]]]]]]]]]]]]]]]]13d]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]NLv");
  var len$22 = xs$22.a.length;
  var ys$22 = new $ac_S(len$22);
  if ((len$22 > 0)) {
    var i$22 = 0;
    while ((i$22 < len$22)) {
      ys$22.a[i$22] = ((xs$22.a[i$22] << 16) >> 16);
      i$22 = ((1 + i$22) | 0);
    }
  }
  var xs$23 = $constArrSDiffs_I(128, "|]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]13d]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]NLv");
  var len$23 = xs$23.a.length;
  var ys$23 = new $ac_S(len$23);
  if ((len$23 > 0)) {
    var i$23 = 0;
    while ((i$23 < len$23)) {
      ys$23.a[i$23] = ((xs$23.a[i$23] << 16) >> 16);
      i$23 = ((1 + i$23) | 0);
    }
  }
  var $x_5 = new $c_Lorg_jpablo_graphexplorer_graphviz_metrics_FontFamilyMetrics(names$5, 2048, ys$20, ys$21, ys$22, ys$23);
  var names$6 = $m_sci_Nil$().b6($m_sr_ScalaRunTime$().f(new ($d_T.r().C)(["Trebuchet MS", "Trebuchet"])));
  var xs$24 = $constArrSDiffs_I(128, "|]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]0Cg4dMf<v]4x6vNM^=f]]:_E{]]:_]]]]]]]]]]E{]:_]]E{0IwDkNl2_0|K^Og9sNpO7{<s6hKo=]Kk2fHo7oJ]In6i4hL`0@{O=`0yNtDfOe0u:_]]_2^L^3|OeDu8l2xO?f5d8wBp12eO=xOi1g]Ed1^Ol9pLi0@f@kmNwIa:_E{:_NNj");
  var len$24 = xs$24.a.length;
  var ys$24 = new $ac_S(len$24);
  if ((len$24 > 0)) {
    var i$24 = 0;
    while ((i$24 < len$24)) {
      ys$24.a[i$24] = ((xs$24.a[i$24] << 16) >> 16);
      i$24 = ((1 + i$24) | 0);
    }
  }
  var xs$25 = $constArrSDiffs_I(128, "|]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]0Cg4d|>^]6f1jO1m8w]4b9xB]]]1l<n]]]]]]]]]B]]>]]]Fn0EfGdMo1_1|Kf0{5q0vO6_0@f5jKy<gK^2fHo7wItIq6k4dLj0@vO=y0wLpEyM^2|;v]]Lp3aKn4jqBy8l5wO=b4i;pO?w14aO>vNk1_`E|dMw<kK{0@jAcNwrI{9uFe9uNJl");
  var len$25 = xs$25.a.length;
  var ys$25 = new $ac_S(len$25);
  if ((len$25 > 0)) {
    var i$25 = 0;
    while ((i$25 < len$25)) {
      ys$25.a[i$25] = ((xs$25.a[i$25] << 16) >> 16);
      i$25 = ((1 + i$25) | 0);
    }
  }
  var xs$26 = $constArrSDiffs_I(128, "|]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]0Cg4dMf<vMd7q6vNM^=f]]:_E{]]:_]]]]]]]]]]E{]:_]]E{0IwEvMa2_0|K^Og9sNpO7{<s6hKo0@gHa2fGr8hJaIn6i4hL`0@{O=`0yNtDfOe0u:_]]_2^Iv6dNtGg6k3nO?|3x8wDd10qO=xOi1g]G]Oe0|8uKt0@f@kmNwIa:_E{:_NNj");
  var len$26 = xs$26.a.length;
  var ys$26 = new $ac_S(len$26);
  if ((len$26 > 0)) {
    var i$26 = 0;
    while ((i$26 < len$26)) {
      ys$26.a[i$26] = ((xs$26.a[i$26] << 16) >> 16);
      i$26 = ((1 + i$26) | 0);
    }
  }
  var xs$27 = $constArrSDiffs_I(128, "|]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]0Cg4d1m<m]9iNgO6`4d]4b9xB]]]1z<`]]]]]]]]]B]]>]]]Cz0GzE|Nl1l1eMmm5waO6j>`9sHd0@mG{2sHj;zFrHc;uNm1i?oO>u1tKiG{m0m6k]]k^Io6kMhF{8]1t@{3z9tA{10rO>x0m1x]Ff0vNr7qs>bChOeN]L|6kIo6kNJl");
  var len$27 = xs$27.a.length;
  var ys$27 = new $ac_S(len$27);
  if ((len$27 > 0)) {
    var i$27 = 0;
    while ((i$27 < len$27)) {
      ys$27.a[i$27] = ((xs$27.a[i$27] << 16) >> 16);
      i$27 = ((1 + i$27) | 0);
    }
  }
  var $x_4 = new $c_Lorg_jpablo_graphexplorer_graphviz_metrics_FontFamilyMetrics(names$6, 2048, ys$24, ys$25, ys$26, ys$27);
  var names$7 = $m_sci_Nil$().b6($m_sr_ScalaRunTime$().f(new ($d_T.r().C)(["Verdana"])));
  var xs$28 = $constArrSDiffs_I(128, "|]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]0Fn2s4c0G]Dg0LcO9qO2s;y];q;sO2z5vJd5v;q]]]]]]]]]Di]0Gg]]O>n0M`O;ua0w4qGbLg<xNlO:x2b?eGf0BgI{2mDd;vJaOeKs7jLz0CnO<oKn4lAd]]0GgDg]Mu1kIl6nNe@i0Ai0qO9_4l?xO;s1<sO:eNh1^]Ck6^Gy?fMi>mAm]Ku7]Dk;o;uN;p");
  var len$28 = xs$28.a.length;
  var ys$28 = new $ac_S(len$28);
  if ((len$28 > 0)) {
    var i$28 = 0;
    while ((i$28 < len$28)) {
      ys$28.a[i$28] = ((xs$28.a[i$28] << 16) >> 16);
      i$28 = ((1 + i$28) | 0);
    }
  }
  var xs$29 = $constArrSDiffs_I(128, "|]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]0Ez3y;x0AzF]13zO5vNN_=n]:t:]NOq7pHj0E]1i]]]]]]]]]O<e]0Mu]]O?|0FdD]O_Mo6wFpMz:f1sO=h0p=wGk0CyIndHm7mKrKjNb8hLz0GhO8rNfMaFm9hFr0DtF]]Me2]Hz7`Mu@n0At0xO8f3z0AbO:{1=xO9yNh0w]C_6bGc0@kL]0E`O<aNxLn7gEf:t:]N8l");
  var len$29 = xs$29.a.length;
  var ys$29 = new $ac_S(len$29);
  if ((len$29 > 0)) {
    var i$29 = 0;
    while ((i$29 < len$29)) {
      ys$29.a[i$29] = ((xs$29.a[i$29] << 16) >> 16);
      i$29 = ((1 + i$29) | 0);
    }
  }
  var xs$30 = $constArrSDiffs_I(128, "|]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]0Fn2s4c0G]Dg0LcO9qO2s;y];q;sO2z5vJd5v;q]]]]]]]]]Di]0Gg]]O>n0M`O;sc0w4gGlLg<xNlO:x2b?eGf0BgI{2mDd;vJaOeKs7jLx0CsO<lKn4lAd]]0GgDg]Mu1kIl6nNe@i0Af0tO9_4l?nO<]1<tO:dNh1^]Ck6^Gy?fMg>oAm{Kw7]Dk;o;uN;p");
  var len$30 = xs$30.a.length;
  var ys$30 = new $ac_S(len$30);
  if ((len$30 > 0)) {
    var i$30 = 0;
    while ((i$30 < len$30)) {
      ys$30.a[i$30] = ((xs$30.a[i$30] << 16) >> 16);
      i$30 = ((1 + i$30) | 0);
    }
  }
  var xs$31 = $constArrSDiffs_I(128, "|]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]0Ez3y;x0AzF]13zO5vNN_=n]:t:]NOq7pHj0E]1i]]]]]]]]]O<e]0Mu]]O?|0FdD]O_Mo6wFpMz:f1sO=h0p=wGk0CyIndHm7mKrKjNb8hLz0GhO8rNfMaFm9hFr0DtF]]Me2]Hz7`Mu@n0At0xO8f3z0AbO:{1=xO9yNf0y]C_6bGc0@kK{0EbO<aNxLn7gEf:t:]N8l");
  var len$31 = xs$31.a.length;
  var ys$31 = new $ac_S(len$31);
  if ((len$31 > 0)) {
    var i$31 = 0;
    while ((i$31 < len$31)) {
      ys$31.a[i$31] = ((xs$31.a[i$31] << 16) >> 16);
      i$31 = ((1 + i$31) | 0);
    }
  }
  var $x_3 = new $c_Lorg_jpablo_graphexplorer_graphviz_metrics_FontFamilyMetrics(names$7, 2048, ys$28, ys$29, ys$30, ys$31);
  var names$8 = $m_sci_Nil$().b6($m_sr_ScalaRunTime$().f(new ($d_T.r().C)(["OpenSans"])));
  var xs$32 = $constArrSDiffs_I(128, "|]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]0@rl8o?sKe0@`J^NOk4v]0@i1fO;`4zLk6l=`]]]]]]]]]O<k]0Co]]Fy0N_O>|0|Nz6fD{Mk=o0qO2qOe0FcI{0HoFl1pDs;gEtKof;cGm0EbO9sNz0s@n2kMo=qJ]8eNr3qGe8uLsAv=i4dO8z]0AjO>p1;hO;uOi0o]Bz4jH_0@sHv0AtO?uNtMsJg;]E]<hNKi");
  var len$32 = xs$32.a.length;
  var ys$32 = new $ac_S(len$32);
  if ((len$32 > 0)) {
    var i$32 = 0;
    while ((i$32 < len$32)) {
      ys$32.a[i$32] = ((xs$32.a[i$32] << 16) >> 16);
      i$32 = ((1 + i$32) | 0);
    }
  }
  var xs$33 = $constArrSDiffs_I(128, "|]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]0@r1s;z;aKc0EaFhO1^4r]=c1rO>^2^Mr8c:`]]]]]]]]]O=tg0A|]]J]0JyBuNxMv6pDlOf;d2qO4d]0EgIr0HcGsNzEe:uGgI]1w;gId0DfO<wMeMa@a5eJu<yHe<nw1xHj7pMgB|;i5zO9l]0DbO;x1;gO;dMo0y]Do2uK|>fJh0BiO>dOjJwJ]:^E|;gNKk");
  var len$33 = xs$33.a.length;
  var ys$33 = new $ac_S(len$33);
  if ((len$33 > 0)) {
    var i$33 = 0;
    while ((i$33 < len$33)) {
      ys$33.a[i$33] = ((xs$33.a[i$33] << 16) >> 16);
      i$33 = ((1 + i$33) | 0);
    }
  }
  var xs$34 = $constArrSDiffs_I(128, "|]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]0@r{8b0@qIz?mHaO3]4i]0A_{O<a4pLd6d<x]]]]]]]]]O<{]0C_]]H_0JzO=g2uOb5cF`Mm=``O6_q0BoJs0GdGi1bFa9yFgKtu;iGw0ClO:sN|1v@h4`Kz>vHa:e0s0vGy8aJqDl<^4yO;g]>|A^17oO=aN|1^]Dj2_Ih0@cHq0@g@tN|NxI{<zC`<zNLt");
  var len$34 = xs$34.a.length;
  var ys$34 = new $ac_S(len$34);
  if ((len$34 > 0)) {
    var i$34 = 0;
    while ((i$34 < len$34)) {
      ys$34.a[i$34] = ((xs$34.a[i$34] << 16) >> 16);
      i$34 = ((1 + i$34) | 0);
    }
  }
  var xs$35 = $constArrSDiffs_I(128, "|]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]0@r1s:s<hIz0CnFnO3]5i]=ciO>n2wMr8s8g]]]]]]]]]O?]]0A]]]Ja0IjAjmOl4bGiOf:c0rO7v0p0B^I{0GbH]NjFj9pHeJ{_:eIn0ClO=oMgNdBy5uJe<pGw9y2o_Hw7aMqDd:u4^O<h]0AhO>r16zO<uNv0r{Dz3hK|<jJa0ArO?nOeKzIp<nCl<nNLt");
  var len$35 = xs$35.a.length;
  var ys$35 = new $ac_S(len$35);
  if ((len$35 > 0)) {
    var i$35 = 0;
    while ((i$35 < len$35)) {
      ys$35.a[i$35] = ((xs$35.a[i$35] << 16) >> 16);
      i$35 = ((1 + i$35) | 0);
    }
  }
  var $x_2 = new $c_Lorg_jpablo_graphexplorer_graphviz_metrics_FontFamilyMetrics(names$8, 2048, ys$32, ys$33, ys$34, ys$35);
  var names$9 = $m_sci_Nil$().b6($m_sr_ScalaRunTime$().f(new ($d_T.r().C)(["Georgia"])));
  var xs$36 = $constArrSDiffs_I(128, "|]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]?l5u5b>wMy=fIbO0g:d]6d:{O8`6sIg<u9fDd8eo0xMr2jK{6]N_O?v]0Eb]]El0LwO?mNzOe6xIyLn8_5uO4v8c;gJc0DtEuNnGj8pMfG]3s8wJe0CvO?^IzOaAm6]J]0Ab]Fxe3pId7sJcEy;v4rO=m{?p@^16_O=kLs2_OeFj1kJk>tJ|?jAaOcLzOaLl3n=qNFw");
  var len$36 = xs$36.a.length;
  var ys$36 = new $ac_S(len$36);
  if ((len$36 > 0)) {
    var i$36 = 0;
    while ((i$36 < len$36)) {
      ys$36.a[i$36] = ((xs$36.a[i$36] << 16) >> 16);
      i$36 = ((1 + i$36) | 0);
    }
  }
  var xs$37 = $constArrSDiffs_I(128, "|]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]0@f7x8n<iL]?fJyNN_;i]2e>bO8]3eLu9c>sBl8uy1pLv3aJ]7wNcO>^]0Em]]F`0JvBr{Mg7pHvLw8s6vO2`9o>cGp0EqDdNuHj7pNoFm2e9oKk0GgO;rK`Mf@l1pNj0@j]C]6a3cHs8kJbDo;u6pO;an0BfO=p1:|O;bLn1jOjGvnHq0AyH|0B|O>iNhMrNiHw7c=]NB|");
  var len$37 = xs$37.a.length;
  var ys$37 = new $ac_S(len$37);
  if ((len$37 > 0)) {
    var i$37 = 0;
    while ((i$37 < len$37)) {
      ys$37.a[i$37] = ((xs$37.a[i$37] << 16) >> 16);
      i$37 = ((1 + i$37) | 0);
    }
  }
  var xs$38 = $constArrSDiffs_I(128, "|]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]?l5u5b>wMy=fIbO0g:d]6d:{O8`6sIg<u9fDd8eo0xMr2jKo6iN_Dh]0@p]]El0LwO?mNzOe6xIyLn8_5uO4v8c;gJc0DtEuMrHf7tNbG]3s8wJe0CvO?^IzOaAm6]J]0Ab]Fx4rNvIp7vIiFx?qOhO?^p?b@l16^O=lLq2qNnJ]N_Jq>pMq0BcO;k3uHpOaLl3n=qNFw");
  var len$38 = xs$38.a.length;
  var ys$38 = new $ac_S(len$38);
  if ((len$38 > 0)) {
    var i$38 = 0;
    while ((i$38 < len$38)) {
      ys$38.a[i$38] = ((xs$38.a[i$38] << 16) >> 16);
      i$38 = ((1 + i$38) | 0);
    }
  }
  var xs$39 = $constArrSDiffs_I(128, "|]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]0@f7x8n<iL]?fJyNN_;i]2e>bO8]3eLu9c>sBl8uy1pLv3aJv7^NcO>^]0Em]]F`0JvBr_Mc7pHvLw8s6vO2j9e>cGp0FeB|OiHt7fNoFu2]9oKk0GgO;eKmMf@l1pNj0@j]C]:eOfHu8aIeDt0Ac1rO<c{0AsO=r19kO<^Ln1tOcHoN{Ip0AbKh0DoO9p5mFeNzHw7c=]NB|");
  var len$39 = xs$39.a.length;
  var ys$39 = new $ac_S(len$39);
  if ((len$39 > 0)) {
    var i$39 = 0;
    while ((i$39 < len$39)) {
      ys$39.a[i$39] = ((xs$39.a[i$39] << 16) >> 16);
      i$39 = ((1 + i$39) | 0);
    }
  }
  var $x_1 = new $c_Lorg_jpablo_graphexplorer_graphviz_metrics_FontFamilyMetrics(names$9, 2048, ys$36, ys$37, ys$38, ys$39);
  var names$10 = $m_sci_Nil$().b6($m_sr_ScalaRunTime$().f(new ($d_T.r().C)(["Calibri"])));
  var xs$40 = $constArrSDiffs_I(128, "|]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]>m6i4w6d0o=gMzO2l5f]<l]@`3qLo8o7t]]]]]]]]]@s]>u]]Mv0KoO;wMvOg5eGyNb:|mO8e4f<xIr0KwBp1_Fs:]GsJr1v9yKe0DqO8fM|NvEr5`Jz<e]Bu<^2|Ik6oNdCs:p3mO=_0q=vAp14kO>may]Ds2tLj<cKf0@xO=|1eLgJx9hFr;uO0`");
  var len$40 = xs$40.a.length;
  var ys$40 = new $ac_S(len$40);
  if ((len$40 > 0)) {
    var i$40 = 0;
    while ((i$40 < len$40)) {
      ys$40.a[i$40] = ((xs$40.a[i$40] << 16) >> 16);
      i$40 = ((1 + i$40) | 0);
    }
  }
  var xs$41 = $constArrSDiffs_I(128, "]|]]]]]]]]]]]^|]]]]]]]]]]]]]]]]]>m6i7d3w0o>dNkO1x5]];{]@q3`Mm:j4{]]]]]]]]]Ad]>d]]Mv0KxO=fM`N]6lFyNb;jpO8s4a=wH_0LyBd1aFv9xHaJd1k:`L_0DbO9eN]MhFc6tIf;`]Ch<i2uHk7oMyD^:`4]O=i0q>iA]14hO>f_{]Dj2vLr<bK{0AjO=t0zKaLo8jGp9yO0`");
  var len$41 = xs$41.a.length;
  var ys$41 = new $ac_S(len$41);
  if ((len$41 > 0)) {
    var i$41 = 0;
    while ((i$41 < len$41)) {
      ys$41.a[i$41] = ((xs$41.a[i$41] << 16) >> 16);
      i$41 = ((1 + i$41) | 0);
    }
  }
  var xs$42 = $constArrSDiffs_I(128, "|]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]>m6i4w6d0o=gMzO2l5f]<l]@`3qLo8r7q]]]]]]]]]@s]>u]]Mv0KoO;wMvNq5{GyNb:|mO8e4f<xIr0KwBn0qGc9kHeJc2e9yKe0DrO8eM|NvEr4|K^<e]Bu>f]It6fMrD|=i]O=v0q=vAp13{O>f{_]E^2|Ln;lKq0AdO=|0zLrJx9hFr;uO0`");
  var len$42 = xs$42.a.length;
  var ys$42 = new $ac_S(len$42);
  if ((len$42 > 0)) {
    var i$42 = 0;
    while ((i$42 < len$42)) {
      ys$42.a[i$42] = ((xs$42.a[i$42] << 16) >> 16);
      i$42 = ((1 + i$42) | 0);
    }
  }
  var xs$43 = $constArrSDiffs_I(128, "|]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]>m6i7d3w0o>dNkO1x5]];{]@q3`Mm:s4r]]]]]]]]]Ad]>d]]Mv0KxO=fM`Mg7bFyNb;jpO8s4a=wH_0LyB_0vGf9fHsIu1z:`L_0DcO9dN]MhFc6jIp;`]Ch>o]Ho7kMrDw=n|O=|0q>iA]13tO>g]^]Du2sL|;oLf0ArO=t0sKhLo8jGp9yO0`");
  var len$43 = xs$43.a.length;
  var ys$43 = new $ac_S(len$43);
  if ((len$43 > 0)) {
    var i$43 = 0;
    while ((i$43 < len$43)) {
      ys$43.a[i$43] = ((xs$43.a[i$43] << 16) >> 16);
      i$43 = ((1 + i$43) | 0);
    }
  }
  this.a89 = $x_12.b6($x_11.f(new ($d_Lorg_jpablo_graphexplorer_graphviz_metrics_FontFamilyMetrics.r().C)([$x_10, $x_9, $x_8, $x_7, $x_6, $x_5, $x_4, $x_3, $x_2, $x_1, new $c_Lorg_jpablo_graphexplorer_graphviz_metrics_FontFamilyMetrics(names$10, 2048, ys$40, ys$41, ys$42, ys$43)])));
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_metrics_FontMetricsTables$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_metrics_FontMetricsTables$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_metrics_FontMetricsTables$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_metrics_FontMetricsTables$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_graphviz_metrics_FontMetricsTables$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_metrics_FontMetricsTables$, "org.jpablo.graphexplorer.graphviz.metrics.FontMetricsTables$", ({
  vx: 1
}));
var $n_Lorg_jpablo_graphexplorer_graphviz_metrics_FontMetricsTables$;
function $m_Lorg_jpablo_graphexplorer_graphviz_metrics_FontMetricsTables$() {
  if ((!$n_Lorg_jpablo_graphexplorer_graphviz_metrics_FontMetricsTables$)) {
    $n_Lorg_jpablo_graphexplorer_graphviz_metrics_FontMetricsTables$ = new $c_Lorg_jpablo_graphexplorer_graphviz_metrics_FontMetricsTables$();
  }
  return $n_Lorg_jpablo_graphexplorer_graphviz_metrics_FontMetricsTables$;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$__ensureNode$1__scm_LinkedHashMap__T__Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$Scope__V($thiz, nodes$2, id, sc) {
  if ((!nodes$2.E(id))) {
    $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(nodes$2, id, sc.wO, false);
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$__mergeNode$1__scm_LinkedHashMap__T__Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$Scope__Lorg_jpablo_graphexplorer_graphviz_model_Attrs__V($thiz, nodes$3, id, sc, explicit) {
  $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(nodes$3, id, (nodes$3.E(id) ? $f_sc_MapOps__apply__O__O(nodes$3, id) : sc.wO).DA(explicit), false);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$__mapBool$1__T__Z($thiz, v) {
  var x64 = v.toLowerCase();
  switch (x64) {
    case "true":
    case "yes": {
      return true;
      break;
    }
    case "false":
    case "no": {
      return false;
      break;
    }
    default: {
      var this$3 = $m_sc_StringParsers$().hT(x64);
      return ((!this$3.c()) && ((this$3.d() | 0) > 0));
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$__enterSub$1__sr_IntRef__sr_ObjectRef__scm_LinkedHashSet__scm_LinkedHashMap__scm_ListBuffer__Lorg_jpablo_graphexplorer_graphviz_dotlang_Subgraph__Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$Scope__Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph($thiz, anonCtr$1, rootAttrs$2, graphAttrKeys$2, nodes$4, edges$2, sg, sc) {
  matchResult26: {
    var id;
    var x61 = sg.Rr;
    if ((x61 instanceof $c_s_Some)) {
      var id = x61.J.fU;
      break matchResult26;
    }
    if (($m_s_None$() === x61)) {
      var s = ("%" + ((1 + (anonCtr$1.an << 1)) | 0));
      anonCtr$1.an = ((1 + anonCtr$1.an) | 0);
      var id = s;
      break matchResult26;
    }
    throw new $c_s_MatchError(x61);
  }
  var col = $p_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$__walk$1__sr_ObjectRef__scm_LinkedHashSet__scm_LinkedHashMap__scm_ListBuffer__sr_IntRef__sci_List__Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$Scope__Z__Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$Collected($thiz, rootAttrs$2, graphAttrKeys$2, nodes$4, edges$2, anonCtr$1, sg.Rs, sc, false);
  var sgAttrs = sc.z5.ag.hN(col.RU);
  var this$2 = id.toLowerCase();
  if ((!(!this$2.startsWith("cluster")))) {
    var isClu = true;
  } else {
    var this$3 = sgAttrs.r("cluster");
    var isClu = ((!this$3.c()) && $p_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$__mapBool$1__T__Z($thiz, this$3.d()));
  }
  return new $c_Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph(id, col.RV, isClu, col.RX, col.RW, col.RT, col.Lb, sgAttrs);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$__attrPort$1__Lorg_jpablo_graphexplorer_graphviz_model_Attrs__T__s_Option($thiz, eAttrs$1, key) {
  var this$1 = eAttrs$1.ag.r(key);
  var this$4 = ((this$1.c() || (this$1.d() !== "")) ? this$1 : $m_s_None$());
  if (this$4.c()) {
    return $m_s_None$();
  } else {
    var x0$1 = this$4.d();
    matchResult32: {
      var $x_1;
      var x79 = $f_T__split__T__I__AT(x0$1, ":", 2);
      if ((x79 !== null)) {
        if (($m_s_Array$UnapplySeqWrapper$().u9(x79, 2) === 0)) {
          var x81 = x79.a[0];
          var x82 = x79.a[1];
          var this$10 = new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Id(x81, false));
          var $x_1 = new $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Port(((this$10.c() || (this$10.J.fU !== "")) ? this$10 : $m_s_None$()), $m_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$().Pm(x82));
          break matchResult32;
        }
      }
      var this$15 = $m_sc_ArrayOps$().X7(x79);
      var $x_1 = new $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Port(new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Id((this$15.c() ? "" : this$15.d()), false)), $m_s_None$());
    }
    return new $c_s_Some($x_1);
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$__walk$1__sr_ObjectRef__scm_LinkedHashSet__scm_LinkedHashMap__scm_ListBuffer__sr_IntRef__sci_List__Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$Scope__Z__Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$Collected($thiz, rootAttrs$4, graphAttrKeys$4, nodes$6, edges$4, anonCtr$3, stmts, sc0, isRoot) {
  var sc = new $c_sr_ObjectRef(sc0);
  var levelNodes = new $c_scm_LinkedHashSet();
  var levelEdges = new $c_scm_ListBuffer();
  var children = new $c_scm_ListBuffer();
  var elem = null;
  elem = "";
  var elem$1 = $m_s_None$();
  var elem$2 = null;
  elem$2 = elem$1;
  var levelGA = new $c_scm_LinkedHashMap();
  var these = stmts;
  while ((!these.c())) {
    var x0 = these.t();
    matchResult36: {
      if ((x0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$AttrStmt)) {
        var x110 = x0.Rl;
        var x111 = x0.Rk;
        var a = $m_Lorg_jpablo_graphexplorer_graphviz_model_Attrs$().ahb(x111);
        matchResult29: {
          var $x_1;
          var x = $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$__Node__Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget();
          if (((x === null) ? (x110 === null) : (x === x110))) {
            var \u03b41$ = sc.aD;
            var $x_1 = new $c_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$Scope(sc.aD.wO.DA(a), \u03b41$.z4, \u03b41$.z5);
            break matchResult29;
          }
          var x$3 = $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$__Edge__Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget();
          if (((x$3 === null) ? (x110 === null) : (x$3 === x110))) {
            var \u03b42$ = sc.aD;
            var edge$1 = sc.aD.z4.DA(a);
            var $x_1 = new $c_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$Scope(\u03b42$.wO, edge$1, \u03b42$.z5);
            break matchResult29;
          }
          var x$5 = $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$__Graph__Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget();
          if (((x$5 === null) ? (x110 === null) : (x$5 === x110))) {
            if (isRoot) {
              rootAttrs$4.aD = rootAttrs$4.aD.DA(a);
            }
            var these$1 = x111;
            while ((!these$1.c())) {
              var x0$1 = these$1.t();
              matchResult28: {
                if ((x0$1 !== null)) {
                  var k = x0$1.g();
                  var v = x0$1.h();
                  graphAttrKeys$4.OV(k.fU);
                  var k$1 = k.fU;
                  var v$1 = v.fU;
                  if ((k$1 === "label")) {
                    elem = v$1;
                  }
                  if ((k$1 === "rank")) {
                    elem$2 = new $c_s_Some(v$1);
                  }
                  $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(levelGA, k$1, v$1, false);
                  break matchResult28;
                }
                throw new $c_s_MatchError(x0$1);
              }
              these$1 = these$1.v();
            }
            var \u03b43$ = sc.aD;
            var graph$2 = sc.aD.z5.DA(a);
            var $x_1 = new $c_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$Scope(\u03b43$.wO, \u03b43$.z4, graph$2);
            break matchResult29;
          }
          throw new $c_s_MatchError(x110);
        }
        sc.aD = $x_1;
        break matchResult36;
      }
      if ((x0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$Assign)) {
        var x106 = x0.Ri;
        var x107 = x0.Rj;
        $m_Lorg_jpablo_graphexplorer_graphviz_model_Attrs$();
        var a$2 = new $c_Lorg_jpablo_graphexplorer_graphviz_model_Attrs($m_sci_Map$().ao($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2(x106.fU, x107.fU)]))), (x107.EY ? $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_T.r().C)([x106.fU]))) : $m_sci_Set$EmptySet$()));
        if (isRoot) {
          rootAttrs$4.aD = rootAttrs$4.aD.DA(a$2);
        }
        graphAttrKeys$4.OV(x106.fU);
        var k$2 = x106.fU;
        var v$2 = x107.fU;
        if ((k$2 === "label")) {
          elem = v$2;
        }
        if ((k$2 === "rank")) {
          elem$2 = new $c_s_Some(v$2);
        }
        $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(levelGA, k$2, v$2, false);
        var \u03b44$ = sc.aD;
        var graph$3 = sc.aD.z5.DA(a$2);
        sc.aD = new $c_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$Scope(\u03b44$.wO, \u03b44$.z4, graph$3);
        break matchResult36;
      }
      if ((x0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$NodeStmt)) {
        var x102 = x0.Rp;
        var x103 = x0.Ro;
        $p_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$__mergeNode$1__scm_LinkedHashMap__T__Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$Scope__Lorg_jpablo_graphexplorer_graphviz_model_Attrs__V($thiz, nodes$6, x102.Ba.fU, sc.aD, $m_Lorg_jpablo_graphexplorer_graphviz_model_Attrs$().ahb(x103));
        levelNodes.OV(x102.Ba.fU);
        break matchResult36;
      }
      if ((x0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$EdgeStmt)) {
        var x98 = x0.Rn;
        var x99 = x0.Rm;
        var ea = $m_Lorg_jpablo_graphexplorer_graphviz_model_Attrs$().ahb(x99);
        var f = ((sc, children, nodes$6, anonCtr$3, rootAttrs$4, graphAttrKeys$4, edges$4) => ((x$1$3) => {
          matchResult30: {
            var $x_2;
            if ((x$1$3 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_EdgeEnd$Node)) {
              var x75 = x$1$3.Rf;
              $p_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$__ensureNode$1__scm_LinkedHashMap__T__Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$Scope__V($thiz, nodes$6, x75.Ba.fU, sc.aD);
              var $x_2 = new $c_sci_$colon$colon(new $c_T2(x75.Ba.fU, x75.Rh), $m_sci_Nil$());
              break matchResult30;
            }
            if ((x$1$3 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_EdgeEnd$Sub)) {
              var x72 = x$1$3.Rg;
              var sub = $p_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$__enterSub$1__sr_IntRef__sr_ObjectRef__scm_LinkedHashSet__scm_LinkedHashMap__scm_ListBuffer__Lorg_jpablo_graphexplorer_graphviz_dotlang_Subgraph__Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$Scope__Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph($thiz, anonCtr$3, rootAttrs$4, graphAttrKeys$4, nodes$6, edges$4, x72, sc.aD);
              children.bb(sub);
              var seqIdx = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$16(nodes$6.lo()));
              var $x_2 = $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(sub.rs, seqIdx, $m_s_math_Ordering$Int$()).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$11) => new $c_T2(_$11, $m_s_None$()))));
              break matchResult30;
            }
            throw new $c_s_MatchError(x$1$3);
          }
          return $x_2;
        }))(sc, children, nodes$6, anonCtr$3, rootAttrs$4, graphAttrKeys$4, edges$4);
        if ((x98 === $m_sci_Nil$())) {
          var ids = $m_sci_Nil$();
        } else {
          var x0$2 = x98.t();
          var h = new $c_sci_$colon$colon(f(x0$2), $m_sci_Nil$());
          var t = h;
          var rest = x98.v();
          while ((rest !== $m_sci_Nil$())) {
            var x0$3 = rest.t();
            var nx = new $c_sci_$colon$colon(f(x0$3), $m_sci_Nil$());
            t.U = nx;
            t = nx;
            rest = rest.v();
          }
          var ids = h;
        }
        var these$2 = ids;
        while ((!these$2.c())) {
          these$2.t().F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((levelNodes) => ((x$1) => {
            if ((x$1 !== null)) {
              return levelNodes.OV(x$1.g());
            }
            throw new $c_s_MatchError(x$1);
          }))(levelNodes)));
          these$2 = these$2.v();
        }
        var this$29 = $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(ids, $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(ids, 1, ids));
        var these$3 = this$29;
        while ((!these$3.c())) {
          var x0$5 = these$3.t();
          matchResult35: {
            if ((x0$5 !== null)) {
              var tails = x0$5.g();
              var heads = x0$5.h();
              tails.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((heads, sc, levelEdges, edges$4, ea, anonCtr$3, nodes$6) => ((x$1$2) => {
                matchResult34: {
                  if ((x$1$2 !== null)) {
                    var t$1 = x$1$2.g();
                    var tp = x$1$2.h();
                    heads.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$1) => {
                      matchResult33: {
                        if ((x$1$2$1 !== null)) {
                          var h$1 = x$1$2$1.g();
                          var hp = x$1$2$1.h();
                          $p_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$__ensureNode$1__scm_LinkedHashMap__T__Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$Scope__V($thiz, nodes$6, t$1, sc.aD);
                          $p_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$__ensureNode$1__scm_LinkedHashMap__T__Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$Scope__V($thiz, nodes$6, h$1, sc.aD);
                          levelEdges.bb(edges$4.eb);
                          var eAttrs = sc.aD.z4.DA(ea);
                          edges$4.bb(new $c_Lorg_jpablo_graphexplorer_graphviz_model_REdge(t$1, h$1, eAttrs, (tp.c() ? $p_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$__attrPort$1__Lorg_jpablo_graphexplorer_graphviz_model_Attrs__T__s_Option($thiz, eAttrs, "tailport") : tp), (hp.c() ? $p_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$__attrPort$1__Lorg_jpablo_graphexplorer_graphviz_model_Attrs__T__s_Option($thiz, eAttrs, "headport") : hp)));
                          anonCtr$3.an = ((1 + anonCtr$3.an) | 0);
                          break matchResult33;
                        }
                        throw new $c_s_MatchError(x$1$2$1);
                      }
                    })));
                    break matchResult34;
                  }
                  throw new $c_s_MatchError(x$1$2);
                }
              }))(heads, sc, levelEdges, edges$4, ea, anonCtr$3, nodes$6)));
              break matchResult35;
            }
            throw new $c_s_MatchError(x0$5);
          }
          these$3 = these$3.v();
        }
        break matchResult36;
      }
      if ((x0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$SubStmt)) {
        children.bb($p_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$__enterSub$1__sr_IntRef__sr_ObjectRef__scm_LinkedHashSet__scm_LinkedHashMap__scm_ListBuffer__Lorg_jpablo_graphexplorer_graphviz_dotlang_Subgraph__Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$Scope__Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph($thiz, anonCtr$3, rootAttrs$4, graphAttrKeys$4, nodes$6, edges$4, x0.Rq, sc.aD));
        break matchResult36;
      }
      throw new $c_s_MatchError(x0);
    }
    these = these.v();
  }
  return new $c_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$Collected($m_sci_Vector$().X(levelNodes), $m_sci_Vector$().X(levelEdges), $m_sci_Vector$().X(children), elem, elem$2, $m_sci_Vector$().X(levelGA));
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$() {
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$.prototype = $p;
$p.b7O = (function(g) {
  var nodes = new $c_scm_LinkedHashMap();
  var edges = new $c_scm_ListBuffer();
  var rootAttrs = new $c_sr_ObjectRef($m_Lorg_jpablo_graphexplorer_graphviz_model_Attrs$().RY);
  var anonCtr = new $c_sr_IntRef((g.EX.c() | 0));
  var graphAttrKeys = new $c_scm_LinkedHashSet();
  var root = $p_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$__walk$1__sr_ObjectRef__scm_LinkedHashSet__scm_LinkedHashMap__scm_ListBuffer__sr_IntRef__sci_List__Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$Scope__Z__Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$Collected(this, rootAttrs, graphAttrKeys, nodes, edges, anonCtr, g.Kl, new $c_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$Scope($m_Lorg_jpablo_graphexplorer_graphviz_model_Attrs$().RY, $m_Lorg_jpablo_graphexplorer_graphviz_model_Attrs$().RY, $m_Lorg_jpablo_graphexplorer_graphviz_model_Attrs$().RY), true);
  var strict = g.Km;
  var directed = g.Kk;
  var this$7 = g.EX;
  var $x_2 = (this$7.c() ? $m_s_None$() : new $c_s_Some(this$7.d().fU));
  var $x_1 = rootAttrs.aD;
  var this$10 = new $c_sc_Iterator$$anon$9(nodes.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    if ((x$1 !== null)) {
      return new $c_Lorg_jpablo_graphexplorer_graphviz_model_RNode(x$1.g(), x$1.h());
    }
    throw new $c_s_MatchError(x$1);
  })));
  return new $c_Lorg_jpablo_graphexplorer_graphviz_model_RGraph(strict, directed, $x_2, $x_1, $m_sci_Vector$().X(this$10), $m_sci_Vector$().X(edges), root.Lb, $m_sci_Vector$().X(graphAttrKeys), $m_Lorg_jpablo_graphexplorer_graphviz_html_ImageDim$().Rv);
});
var $d_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$, "org.jpablo.graphexplorer.graphviz.model.AttrResolver$", ({
  vy: 1
}));
var $n_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$;
function $m_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$() {
  if ((!$n_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$)) {
    $n_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$ = new $c_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$();
  }
  return $n_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__esc__T__T($thiz, s) {
  var b = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  var len = s.length;
  var i = 0;
  while ((i < len)) {
    var index = i;
    var x0 = s.charCodeAt(index);
    switch (x0) {
      case 34: {
        b.ad("\\\"");
        break;
      }
      case 92: {
        b.ad("\\\\");
        break;
      }
      case 47: {
        b.ad("\\/");
        break;
      }
      case 10: {
        b.ad("\\n");
        break;
      }
      case 13: {
        b.ad("\\r");
        break;
      }
      case 9: {
        b.ad("\\t");
        break;
      }
      default: {
        b.id(x0);
      }
    }
    i = ((1 + i) | 0);
  }
  return b.bP.ah;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__attrPairs__sci_Map__sci_Vector($thiz, attrs) {
  return $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O($m_sci_Vector$().X(attrs).d8(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    if ((x$1 !== null)) {
      var k = x$1.g();
      return ((x$1.h() !== "") || (k === "label"));
    }
    throw new $c_s_MatchError(x$1);
  })), false), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3) => _$3.g())), $m_s_math_Ordering$String$());
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__rootLabelText__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__s_Option($thiz, g) {
  var this$2 = g.f2.ag.r("label");
  return ((this$2.c() || (this$2.d() !== "")) ? this$2 : $m_s_None$());
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__labelFontSize__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D($thiz, g) {
  var this$2 = g.f2.ag.r("fontsize");
  if (this$2.c()) {
    var this$6 = $m_s_None$();
  } else {
    var x0 = this$2.d();
    var this$6 = ($m_sc_StringParsers$().c1(x0) ? new $c_s_Some($m_jl_Double$().bd(x0)) : $m_s_None$());
  }
  return (+(this$6.c() ? $m_Lorg_jpablo_graphexplorer_graphviz_output_Output$().aux : this$6.d()));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__labelHtPt__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T__D($thiz, g, lbl) {
  var $x_2 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$();
  var $x_1 = $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__labelFontSize__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D($thiz, g);
  var this$1 = g.j5;
  return $x_2.PC(lbl, $x_1, (this$1.c() ? "" : this$1.d()));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__f2__D__T($thiz, x) {
  var this$1 = $m_s_package$().oz();
  return this$1.y8(x, this$1.qI).Jm(2, ($m_s_package$().oz(), $m_s_math_BigDecimal$RoundingMode$().Oe)).dN.m();
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__doc__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__Lorg_jpablo_graphexplorer_graphviz_output_Output$Doc($thiz, g) {
  var this$1 = $thiz.auy;
  if ((g === this$1.f0)) {
    var $x_1 = this$1.f1;
  } else {
    var v = $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__docImpl__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__Lorg_jpablo_graphexplorer_graphviz_output_Output$Doc($m_Lorg_jpablo_graphexplorer_graphviz_output_Output$(), g);
    this$1.f0 = g;
    this$1.f1 = v;
    var $x_1 = v;
  }
  return $x_1;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__docImpl__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__Lorg_jpablo_graphexplorer_graphviz_output_Output$Doc($thiz, g) {
  $m_sci_Vector$();
  var sgFlat = new $c_sci_VectorBuilder();
  g.uF.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((s) => {
    $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__preorder$1__scm_ReusableBuilder__Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph__V($thiz, sgFlat, s);
  })));
  var flat = sgFlat.bY();
  var sgCnt = flat.C();
  var nodeIdx = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$16(new $c_sc_Iterator$$anon$9(g.cB.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6) => _$6.br)))));
  var nodes = g.cB.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n) => new $c_T2(n.br, $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__nodeGvid$1__I__sci_Map__T__I($thiz, sgCnt, nodeIdx, n.br)))));
  var this$10 = $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(g.cu);
  var m = $m_scm_Map$().aO();
  var it = this$10.o();
  while (it.p()) {
    var elem = it.q();
    var key = elem.g().ai;
    m.ec(key, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((this$10) => (() => this$10.fS()))(this$10))).Y(elem);
  }
  var result = $m_sci_HashMap$().fk;
  var mapIt = m.o();
  while (mapIt.p()) {
    var x1 = mapIt.q();
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1);
    }
    var k = x1.g();
    var v = x1.h();
    result = result.hq(k, v.aR());
  }
  var edgesByTail = result;
  var k$1 = new $c_sr_IntRef(0);
  var this$18 = new $c_sc_Iterator$$anon$10(g.cB.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n$2) => $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(edgesByTail.ay(n$2.br, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $m_sci_Vector$();
    return $m_sci_Vector0$();
  }))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    if ((x$1 !== null)) {
      var e = x$1.g();
      var ix = (x$1.h() | 0);
      return new $c_T2(nodeIdx.ay(e.ak, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 2147483647))), ix);
    }
    throw new $c_s_MatchError(x$1);
  })), new $c_s_math_Ordering$Tuple2Ordering($m_s_math_Ordering$Int$(), $m_s_math_Ordering$Int$())).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    if ((x$1$2 !== null)) {
      var e$1 = x$1$2.g();
      var ix$1 = (x$1$2.h() | 0);
      var r = new $c_Lorg_jpablo_graphexplorer_graphviz_output_Output$Doc$E(k$1.an, $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__nodeGvid$1__I__sci_Map__T__I($thiz, sgCnt, nodeIdx, e$1.ai), $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__nodeGvid$1__I__sci_Map__T__I($thiz, sgCnt, nodeIdx, e$1.ak), e$1.b9K(), e$1.b2B(), ix$1);
      k$1.an = ((1 + k$1.an) | 0);
      return r;
    }
    throw new $c_s_MatchError(x$1$2);
  }))))));
  var edgesByK = $m_sci_Vector$().X(this$18);
  var edgeGvidByIdx = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$9(edgesByK.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$2) => new $c_T2(e$2.rt, e$2.BD)))));
  var edges = $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(edgesByK, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$8) => _$8.rt)), $m_s_math_Ordering$Int$());
  var labelDeclared = $f_sc_SeqOps__contains__O__Z(g.BB, "label");
  var subgraphs = $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(flat).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$1) => {
    if ((x$1$1 !== null)) {
      var s$1 = x$1$1.g();
      var gv$1 = (x$1$1.h() | 0);
      var mem = $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__memberNodes$1__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph__sci_Vector($thiz, g, s$1);
      var memSet = $m_sci_Set$().af(mem);
      if (s$1.wP) {
        var this$27 = new $c_sc_Iterator$$anon$7(new $c_sc_Iterator$$anon$16(g.cu.o()), new $c_Lorg_jpablo_graphexplorer_graphviz_output_Output$$anon$1(memSet, edgeGvidByIdx));
        var edgeGids = $m_sci_Vector$().X(this$27);
      } else {
        var edgeGids = $f_sc_SeqOps__sorted__s_math_Ordering__O(s$1.Ft.d8(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((ix$2) => {
          var ix$3 = (ix$2 | 0);
          return memSet.E(g.cu.l(ix$3).ai);
        })), false), $m_s_math_Ordering$Int$()).L(edgeGvidByIdx);
      }
      var childGvids = s$1.lD.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((c) => {
        var this$30 = flat.o();
        var i = 0;
        var dropped = this$30.iV(0);
        while (dropped.p()) {
          if ((dropped.q() === c)) {
            return i;
          }
          i = ((1 + i) | 0);
        }
        return (-1);
      }))).bw(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$11) => ((_$11 | 0) >= 0))));
      return new $c_Lorg_jpablo_graphexplorer_graphviz_output_Output$Doc$SG(gv$1, s$1.z7, s$1.wQ, s$1.BC, mem.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((id) => $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__nodeGvid$1__I__sci_Map__T__I($thiz, sgCnt, nodeIdx, id)))), edgeGids, childGvids, labelDeclared, s$1.q2);
    }
    throw new $c_s_MatchError(x$1$1);
  })));
  var rootAttrs = $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__attrPairs__sci_Map__sci_Vector($thiz, $m_sci_Map$().ao(new $c_sc_Iterator$$anon$9(g.BB.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((k$3) => new $c_T2(k$3, g.f2.dL(k$3, "")))))));
  var this$39 = g.j5;
  return new $c_Lorg_jpablo_graphexplorer_graphviz_output_Output$Doc((this$39.c() ? "%1" : this$39.d()), g.z6, g.Lc, rootAttrs, sgCnt, subgraphs, nodes, edges);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__sgBlockJson__Lorg_jpablo_graphexplorer_graphviz_output_Output$Doc$SG__sci_Vector__T($thiz, sg, attrs) {
  $m_sci_Vector$();
  var fields = new $c_sci_VectorBuilder();
  fields.ck((("      \"name\": \"" + $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__esc__T__T($thiz, sg.FH)) + "\""));
  attrs.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var k = x$1.g();
    var v = x$1.h();
    return fields.ck((((("      \"" + $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__esc__T__T($m_Lorg_jpablo_graphexplorer_graphviz_output_Output$(), k)) + "\": \"") + $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__esc__T__T($m_Lorg_jpablo_graphexplorer_graphviz_output_Output$(), v)) + "\""));
  })));
  fields.ck(("      \"_gvid\": " + sg.Ld));
  if ((!$f_sc_SeqOps__isEmpty__Z(sg.FK))) {
    fields.ck((("      \"subgraphs\": [\n        " + $f_sc_IterableOnceOps__mkString__T__T__T__T(sg.FK, "", ",\n", "")) + "\n      ]"));
  }
  if ((!$f_sc_SeqOps__isEmpty__Z(sg.FI))) {
    fields.ck((("      \"nodes\": [\n        " + $f_sc_IterableOnceOps__mkString__T__T__T__T(sg.FI, "", ",", "")) + "\n      ]"));
  }
  if ((!$f_sc_SeqOps__isEmpty__Z(sg.FF))) {
    fields.ck((("      \"edges\": [\n        " + $f_sc_IterableOnceOps__mkString__T__T__T__T(sg.FF, "", ",", "")) + "\n      ]"));
  }
  return (("    {\n" + $f_sc_IterableOnceOps__mkString__T__T__T__T(fields.bY(), "", ",\n", "")) + "\n    }");
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__sgAttrs__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__Lorg_jpablo_graphexplorer_graphviz_output_Output$Doc$SG__sci_Vector($thiz, g, sg) {
  var this$11 = new $c_sc_Iterator$$anon$9(g.BB.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((k) => {
    if ((k === "label")) {
      var \u03b41$___1 = sg.BE.ay("label", new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => sg.Le)));
      var \u03b41$___2 = sg.FG;
    } else if ((k === "rank")) {
      var this$2 = sg.FJ;
      var \u03b41$___1 = (this$2.c() ? "" : this$2.d());
      var \u03b41$___2 = (!sg.FJ.c());
    } else {
      var \u03b41$___1 = sg.BE.ay(k, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => "")));
      var \u03b41$___2 = sg.BE.E(k);
    }
    var own = \u03b41$___1;
    return new $c_T2(k, (((!(!\u03b41$___2)) || (own !== "")) ? own : g.f2.dL(k, "")));
  })));
  return $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O($m_sci_Vector$().X(this$11).d8(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    if ((x$1 !== null)) {
      var k$1 = x$1.g();
      return ((x$1.h() !== "") || ((k$1 === "label") && sg.FG));
    }
    throw new $c_s_MatchError(x$1);
  })), false), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$12) => _$12.g())), $m_s_math_Ordering$String$());
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__boundingBox__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T($thiz, g) {
  matchResult20: {
    var \u03b42$___1;
    var \u03b42$___2;
    var \u03b42$___3;
    var \u03b42$___4;
    if ($m_Lorg_jpablo_graphexplorer_graphviz_layout_DrawTransform$().ahL(g)) {
      var x41 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$().afN(g);
    } else {
      matchResult19: {
        var \u03b44$___1;
        var \u03b44$___2;
        var \u03b44$___3;
        var \u03b44$___4;
        var x36 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$().Wm(g);
        if ((x36 !== null)) {
          var \u03b44$___1 = (+x36.bO);
          var \u03b44$___2 = (+x36.bs);
          var \u03b44$___3 = (+x36.ch);
          var \u03b44$___4 = (+x36.ca);
          break matchResult19;
        }
        throw new $c_s_MatchError(x36);
      }
      var x41 = new $c_T4((+\u03b44$___1), (+\u03b44$___2), (+\u03b44$___3), (+\u03b44$___4));
    }
    if ((x41 !== null)) {
      var \u03b42$___1 = (+x41.bO);
      var \u03b42$___2 = (+x41.bs);
      var \u03b42$___3 = (+x41.ch);
      var \u03b42$___4 = (+x41.ca);
      break matchResult20;
    }
    throw new $c_s_MatchError(x41);
  }
  var lx$2 = (+\u03b42$___1);
  var ly$2 = (+\u03b42$___2);
  var ux$2 = (+\u03b42$___3);
  var uy$2 = (+\u03b42$___4);
  var _1 = $thiz.E2(0.0);
  var _2 = $thiz.E2(0.0);
  var _3 = $thiz.E2((ux$2 - lx$2));
  var _4 = $thiz.E2((uy$2 - ly$2));
  return (((((($thiz.dU(_1) + " ") + $thiz.dU(_2)) + " ") + $thiz.dU(_3)) + " ") + $thiz.dU(_4));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__dotJsonWith__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T__T($thiz, g, bb) {
  var d = $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__doc__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__Lorg_jpablo_graphexplorer_graphviz_output_Output$Doc($thiz, g);
  var sb = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  sb.ad("{\n");
  sb.ad((("  \"name\": \"" + $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__esc__T__T($thiz, d.Fv)) + "\",\n"));
  sb.ad((("  \"directed\": " + d.Fu) + ",\n"));
  sb.ad((("  \"strict\": " + d.Fz) + ",\n"));
  sb.ad((("  \"bb\": \"" + bb) + "\",\n"));
  d.Fx.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    if ((x$1 !== null)) {
      var k = x$1.g();
      var v = x$1.h();
      return sb.ad((((("  \"" + $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__esc__T__T($m_Lorg_jpablo_graphexplorer_graphviz_output_Output$(), k)) + "\": \"") + $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__esc__T__T($m_Lorg_jpablo_graphexplorer_graphviz_output_Output$(), v)) + "\",\n"));
    }
    throw new $c_s_MatchError(x$1);
  })));
  sb.ad(("  \"_subgraph_cnt\": " + d.Fy));
  var byId = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$9(g.cB.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n) => new $c_T2(n.br, n)))));
  var this$6 = g.cu;
  var res = false;
  var it = this$6.o();
  while (((!res) && it.p())) {
    res = it.q().b4.ag.E("label");
  }
  var edgeLabels = res;
  var objBlocks = d.FA.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((sg) => $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__sgBlockJson__Lorg_jpablo_graphexplorer_graphviz_output_Output$Doc$SG__sci_Vector__T($m_Lorg_jpablo_graphexplorer_graphviz_output_Output$(), sg, $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__sgAttrs__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__Lorg_jpablo_graphexplorer_graphviz_output_Output$Doc$SG__sci_Vector($m_Lorg_jpablo_graphexplorer_graphviz_output_Output$(), g, sg))))).g9(d.Fw.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__nodeBlock$1__sci_Map__T__I__T($thiz, byId, x$1$2.g(), (x$1$2.h() | 0))))));
  if ((!$f_sc_SeqOps__isEmpty__Z(objBlocks))) {
    sb.ad(",\n  \"objects\": [\n");
    sb.ad($f_sc_IterableOnceOps__mkString__T__T__T__T(objBlocks, "", ",\n", ""));
    sb.ad("\n  ]");
  }
  if ((!$f_sc_SeqOps__isEmpty__Z(d.wR))) {
    sb.ad(",\n  \"edges\": [\n");
    sb.ad($f_sc_IterableOnceOps__mkString__T__T__T__T(d.wR.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e) => $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__edgeBlock$1__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__Z__Lorg_jpablo_graphexplorer_graphviz_output_Output$Doc$E__T($thiz, g, edgeLabels, e)))), "", ",\n", ""));
    sb.ad("\n  ]");
  }
  sb.ad("\n}\n");
  return sb.bP.ah;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__preorder$1__scm_ReusableBuilder__Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph__V($thiz, sgFlat$1, s) {
  sgFlat$1.Y(s);
  s.lD.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((s$2) => {
    $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__preorder$1__scm_ReusableBuilder__Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph__V($thiz, sgFlat$1, s$2);
  })));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__nodeGvid$1__I__sci_Map__T__I($thiz, sgCnt$2, nodeIdx$1, id) {
  return ((sgCnt$2 + (nodeIdx$1.i(id) | 0)) | 0);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__transitiveNodeIds$1__Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph__sci_Set($thiz, s) {
  var $x_1 = $m_sci_Set$().af(s.rs);
  var this$2 = s.lD;
  $m_sci_Vector$();
  var b = new $c_sci_VectorBuilder();
  var it = this$2.o();
  while (it.p()) {
    b.fO($p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__transitiveNodeIds$1__Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph__sci_Set($thiz, it.q()));
  }
  return $x_1.dI(b.bY());
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__memberNodes$1__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph__sci_Vector($thiz, g$2, s) {
  var declared = $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__transitiveNodeIds$1__Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph__sci_Set($thiz, s);
  var this$3 = new $c_sc_Iterator$$anon$6(new $c_sc_Iterator$$anon$9(g$2.cB.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$9) => _$9.br))), declared, false);
  return $m_sci_Vector$().X(this$3);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__nodeBlock$1__sci_Map__T__I__T($thiz, byId$1, id, gv) {
  var a = byId$1.i(id).aK.ag.Q8("label", new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v) => new $c_s_Some((v.c() ? "\\N" : v.d())))));
  $m_sci_Vector$();
  var fields = new $c_sci_VectorBuilder();
  fields.ck(("      \"_gvid\": " + gv));
  fields.ck((("      \"name\": \"" + $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__esc__T__T($thiz, id)) + "\""));
  $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__attrPairs__sci_Map__sci_Vector($thiz, a).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var k = x$1.g();
    var v$1 = x$1.h();
    return fields.ck((((("      \"" + $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__esc__T__T($m_Lorg_jpablo_graphexplorer_graphviz_output_Output$(), k)) + "\": \"") + $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__esc__T__T($m_Lorg_jpablo_graphexplorer_graphviz_output_Output$(), v$1)) + "\""));
  })));
  return (("    {\n" + $f_sc_IterableOnceOps__mkString__T__T__T__T(fields.bY(), "", ",\n", "")) + "\n    }");
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__edgeBlock$1__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__Z__Lorg_jpablo_graphexplorer_graphviz_output_Output$Doc$E__T($thiz, g$8, edgeLabels$1, e) {
  var elem = g$8.cu.l(e.rt).b4.ag;
  var elem$1 = null;
  elem$1 = elem;
  var this$2 = e.FE;
  if ((!this$2.c())) {
    var x0 = this$2.d();
    elem$1 = elem$1.bN("tailport", x0);
  }
  var this$6 = e.FC;
  if ((!this$6.c())) {
    var x0$1 = this$6.d();
    elem$1 = elem$1.bN("headport", x0$1);
  }
  if (edgeLabels$1) {
    elem$1 = elem$1.Q8("label", new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v) => new $c_s_Some((v.c() ? "" : v.d())))));
  }
  $m_sci_Vector$();
  var fields = new $c_sci_VectorBuilder();
  fields.ck(("      \"_gvid\": " + e.BD));
  fields.ck(("      \"tail\": " + e.FD));
  fields.ck(("      \"head\": " + e.FB));
  $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__attrPairs__sci_Map__sci_Vector($thiz, elem$1).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var k = x$1.g();
    var v$1 = x$1.h();
    return fields.ck((((("      \"" + $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__esc__T__T($m_Lorg_jpablo_graphexplorer_graphviz_output_Output$(), k)) + "\": \"") + $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__esc__T__T($m_Lorg_jpablo_graphexplorer_graphviz_output_Output$(), v$1)) + "\""));
  })));
  return (("    {\n" + $f_sc_IterableOnceOps__mkString__T__T__T__T(fields.bY(), "", ",\n", "")) + "\n    }");
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__leaves$1__Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$Field__sci_Vector($thiz, f) {
  if ($f_sc_SeqOps__isEmpty__Z(f.hX)) {
    return $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$Field.r().C)([f])));
  } else {
    var this$3 = f.hX;
    $m_sci_Vector$();
    var b = new $c_sci_VectorBuilder();
    var it = this$3.o();
    while (it.p()) {
      b.fO($p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__leaves$1__Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$Field__sci_Vector($thiz, it.q()));
    }
    return b.bY();
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__nodeBlock$2__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Map__sci_Map__F2__T__I__T($thiz, byId$2, g$10, xs$1, yOf$1, ranks$1, tf$1, id, gv) {
  var n = byId$2.i(id);
  var sz = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().XB(n, g$10);
  var this$1 = xs$1.r(id);
  var px = (this$1.c() ? 0.0 : (+this$1.d()));
  var x$proxy10 = (+yOf$1.i(ranks$1.i(id)));
  var a = n.aK.ag.Q8("label", new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v) => new $c_s_Some((v.c() ? "\\N" : v.d())))));
  var kv = new $c_scm_LinkedHashMap();
  $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__attrPairs__sci_Map__sci_Vector($thiz, a).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var k = x$1.g();
    var v$1 = x$1.h();
    $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(kv, k, (("\"" + $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__esc__T__T($m_Lorg_jpablo_graphexplorer_graphviz_output_Output$(), v$1)) + "\""), false);
  })));
  if ((!sz.c())) {
    var x0$1 = sz.d();
    $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(kv, "height", (("\"" + $m_Lorg_jpablo_graphexplorer_graphviz_output_Output$().dU(x0$1.Bj)) + "\""), false);
    $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(kv, "width", (("\"" + $m_Lorg_jpablo_graphexplorer_graphviz_output_Output$().dU(x0$1.Bk)) + "\""), false);
  }
  matchResult28: {
    var \u03b48$___1;
    var \u03b48$___2;
    var x71 = tf$1.R(px, x$proxy10);
    if ((x71 !== null)) {
      var \u03b48$___1 = (+x71.g());
      var \u03b48$___2 = (+x71.h());
      break matchResult28;
    }
    throw new $c_s_MatchError(x71);
  }
  var tpx$2 = (+\u03b48$___1);
  var tpy$2 = (+\u03b48$___2);
  $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(kv, "pos", (((("\"" + $thiz.dU(tpx$2)) + ",") + $thiz.dU(tpy$2)) + "\""), false);
  var this$5 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$().a4q(g$10).Fr.r(id);
  if ((!this$5.c())) {
    var x0$2 = this$5.d();
    matchResult29: {
      var \u03b49$___1;
      var \u03b49$___2;
      var x74 = tf$1.R(x0$2.uD, x0$2.uE);
      if ((x74 !== null)) {
        var \u03b49$___1 = (+x74.g());
        var \u03b49$___2 = (+x74.h());
        break matchResult29;
      }
      throw new $c_s_MatchError(x74);
    }
    var x$2 = (+\u03b49$___1);
    var y$2 = (+\u03b49$___2);
    $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(kv, "xlp", (((("\"" + $m_Lorg_jpablo_graphexplorer_graphviz_output_Output$().dU(x$2)) + ",") + $m_Lorg_jpablo_graphexplorer_graphviz_output_Output$().dU(y$2)) + "\""), false);
  }
  var this$8 = n.aK.ag.r("shape");
  if (this$8.c()) {
    var $x_1 = $m_s_None$();
  } else {
    var x0$3 = this$8.d();
    var $x_1 = new $c_s_Some(x0$3.toLowerCase());
  }
  if ($x_1.E("record")) {
    var this$9 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().PN(n, g$10);
    if ((!this$9.c())) {
      $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(kv, "rects", (("\"" + $f_sc_IterableOnceOps__mkString__T__T__T__T($p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__leaves$1__Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$Field__sci_Vector($thiz, this$9.d()).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((f) => (((((($m_Lorg_jpablo_graphexplorer_graphviz_output_Output$().dU((tpx$2 + f.n5)) + ",") + $m_Lorg_jpablo_graphexplorer_graphviz_output_Output$().dU((tpy$2 + f.q0))) + ",") + $m_Lorg_jpablo_graphexplorer_graphviz_output_Output$().dU((tpx$2 + f.q1))) + ",") + $m_Lorg_jpablo_graphexplorer_graphviz_output_Output$().dU((tpy$2 + f.o2)))))), "", " ", "")) + "\""), false);
    }
  }
  $m_sci_Vector$();
  var fields = new $c_sci_VectorBuilder();
  fields.ck(("      \"_gvid\": " + gv));
  fields.ck((("      \"name\": \"" + $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__esc__T__T($thiz, id)) + "\""));
  $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O($m_sci_Vector$().X(kv), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$18) => _$18.g())), $m_s_math_Ordering$String$()).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    var k$1 = x$1$2.g();
    var v$2 = x$1$2.h();
    return fields.ck(((("      \"" + $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__esc__T__T($m_Lorg_jpablo_graphexplorer_graphviz_output_Output$(), k$1)) + "\": ") + v$2));
  })));
  return (("    {\n" + $f_sc_IterableOnceOps__mkString__T__T__T__T(fields.bY(), "", ",\n", "")) + "\n    }");
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__edgeBlock$2__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__Z__sci_Map__F2__sci_Map__Lorg_jpablo_graphexplorer_graphviz_output_Output$Doc$E__T($thiz, g$13, edgeLabels$2, lps$1, tf$4, spl$1, e) {
  var elem = g$13.cu.l(e.rt).b4.ag;
  var elem$1 = null;
  elem$1 = elem;
  var this$2 = e.FE;
  if ((!this$2.c())) {
    var x0 = this$2.d();
    elem$1 = elem$1.bN("tailport", x0);
  }
  var this$6 = e.FC;
  if ((!this$6.c())) {
    var x0$1 = this$6.d();
    elem$1 = elem$1.bN("headport", x0$1);
  }
  if (edgeLabels$2) {
    elem$1 = elem$1.Q8("label", new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v) => new $c_s_Some((v.c() ? "" : v.d())))));
  }
  var kv = new $c_scm_LinkedHashMap();
  $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__attrPairs__sci_Map__sci_Vector($thiz, elem$1).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var k = x$1.g();
    var v$1 = x$1.h();
    $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(kv, k, (("\"" + $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__esc__T__T($m_Lorg_jpablo_graphexplorer_graphviz_output_Output$(), v$1)) + "\""), false);
  })));
  var this$12 = lps$1.r(e.rt);
  if ((!this$12.c())) {
    var x0$2 = this$12.d();
    matchResult31: {
      var \u03b411$___1;
      var \u03b411$___2;
      var x80 = tf$4.R(x0$2.W, x0$2.a6);
      if ((x80 !== null)) {
        var \u03b411$___1 = (+x80.g());
        var \u03b411$___2 = (+x80.h());
        break matchResult31;
      }
      throw new $c_s_MatchError(x80);
    }
    var lpx$2 = (+\u03b411$___1);
    var lpy$2 = (+\u03b411$___2);
    $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(kv, "lp", (((("\"" + $m_Lorg_jpablo_graphexplorer_graphviz_output_Output$().dU(lpx$2)) + ",") + $m_Lorg_jpablo_graphexplorer_graphviz_output_Output$().dU(lpy$2)) + "\""), false);
  }
  var this$14 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$().a4q(g$13).Fq.r(e.rt);
  if ((!this$14.c())) {
    var x0$3 = this$14.d();
    matchResult32: {
      var \u03b412$___1;
      var \u03b412$___2;
      var x83 = tf$4.R(x0$3.uD, x0$3.uE);
      if ((x83 !== null)) {
        var \u03b412$___1 = (+x83.g());
        var \u03b412$___2 = (+x83.h());
        break matchResult32;
      }
      throw new $c_s_MatchError(x83);
    }
    var x$2 = (+\u03b412$___1);
    var y$2 = (+\u03b412$___2);
    $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(kv, "xlp", (((("\"" + $m_Lorg_jpablo_graphexplorer_graphviz_output_Output$().dU(x$2)) + ",") + $m_Lorg_jpablo_graphexplorer_graphviz_output_Output$().dU(y$2)) + "\""), false);
  }
  var this$16 = spl$1.r(e.rt);
  if ((!this$16.c())) {
    var x0$4 = this$16.d();
    var this$17 = x0$4.Fp;
    if (this$17.c()) {
      var this$19 = $m_s_None$();
    } else {
      var x0$5 = this$17.d();
      matchResult33: {
        var \u03b413$___1;
        var \u03b413$___2;
        var x86 = tf$4.R(x0$5.W, x0$5.a6);
        if ((x86 !== null)) {
          var \u03b413$___1 = (+x86.g());
          var \u03b413$___2 = (+x86.h());
          break matchResult33;
        }
        throw new $c_s_MatchError(x86);
      }
      var x$2$1 = (+\u03b413$___1);
      var y$2$1 = (+\u03b413$___2);
      var this$19 = new $c_s_Some((((("s," + $thiz.dU(x$2$1)) + ",") + $thiz.dU(y$2$1)) + " "));
    }
    var $x_1 = (this$19.c() ? "" : this$19.d());
    var this$20 = x0$4.Fo;
    if (this$20.c()) {
      var this$22 = $m_s_None$();
    } else {
      var x0$6 = this$20.d();
      matchResult34: {
        var \u03b414$___1;
        var \u03b414$___2;
        var x89 = tf$4.R(x0$6.W, x0$6.a6);
        if ((x89 !== null)) {
          var \u03b414$___1 = (+x89.g());
          var \u03b414$___2 = (+x89.h());
          break matchResult34;
        }
        throw new $c_s_MatchError(x89);
      }
      var x$2$2 = (+\u03b414$___1);
      var y$2$2 = (+\u03b414$___2);
      var this$22 = new $c_s_Some((((("e," + $thiz.dU(x$2$2)) + ",") + $thiz.dU(y$2$2)) + " "));
    }
    var pre = (("" + $x_1) + (this$22.c() ? "" : this$22.d()));
    var pts = $f_sc_IterableOnceOps__mkString__T__T__T__T(x0$4.wM.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((p$3) => {
      matchResult35: {
        var \u03b415$___1;
        var \u03b415$___2;
        var x92 = tf$4.R(p$3.W, p$3.a6);
        if ((x92 !== null)) {
          var \u03b415$___1 = (+x92.g());
          var \u03b415$___2 = (+x92.h());
          break matchResult35;
        }
        throw new $c_s_MatchError(x92);
      }
      var x$2$3 = (+\u03b415$___1);
      var y$2$3 = (+\u03b415$___2);
      return (($thiz.dU(x$2$3) + ",") + $thiz.dU(y$2$3));
    }))), "", " ", "");
    $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(kv, "pos", ((("\"" + pre) + pts) + "\""), false);
  }
  $m_sci_Vector$();
  var fields = new $c_sci_VectorBuilder();
  fields.ck(("      \"_gvid\": " + e.BD));
  fields.ck(("      \"tail\": " + e.FD));
  fields.ck(("      \"head\": " + e.FB));
  $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O($m_sci_Vector$().X(kv), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$20) => _$20.g())), $m_s_math_Ordering$String$()).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    var k$1 = x$1$2.g();
    var v$2 = x$1$2.h();
    return fields.ck(((("      \"" + $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__esc__T__T($m_Lorg_jpablo_graphexplorer_graphviz_output_Output$(), k$1)) + "\": ") + v$2));
  })));
  return (("    {\n" + $f_sc_IterableOnceOps__mkString__T__T__T__T(fields.bY(), "", ",\n", "")) + "\n    }");
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_output_Output$() {
  this.a8a = 0.0;
  this.aux = 0.0;
  this.auy = null;
  $n_Lorg_jpablo_graphexplorer_graphviz_output_Output$ = this;
  this.a8a = 4.0;
  this.aux = 14.0;
  this.auy = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_GraphMemo();
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_output_Output$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_output_Output$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_output_Output$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_output_Output$.prototype = $p;
$p.dU = (function(x0) {
  var x = ((x0 === 0.0) ? 0.0 : x0);
  if ((x === 0.0)) {
    return "0";
  } else {
    var neg = (x < 0.0);
    var a = (+Math.abs(x));
    var x$1 = (+Math.log10(a));
    var exp = $doubleToInt((+Math.floor(x$1)));
    var y = ((4 - exp) | 0);
    var dec = ((y < 0) ? 0 : y);
    var this$9 = $m_s_package$().oz();
    var bd = this$9.y8(a, this$9.qI).Jm(dec, ($m_s_package$().oz(), $m_s_math_BigDecimal$RoundingMode$().Oe));
    var s = bd.dN.Q2();
    if ($m_sc_StringOps$().IJ(s, 46)) {
      var $x_1 = $m_sc_StringOps$();
      var x$4 = $m_sc_StringOps$().a4z(s);
      _return: {
        var len = x$4.length;
        var i = 0;
        while ((i < len)) {
          if ((x$4.charCodeAt(i) !== 48)) {
            var x1 = i;
            break _return;
          }
          i = ((1 + i) | 0);
        }
        var x1 = (-1);
      }
      var x$5 = ((x1 === (-1)) ? "" : x$4.substring(x1));
      _return$1: {
        var len$1 = x$5.length;
        var i$1 = 0;
        while ((i$1 < len$1)) {
          if ((x$5.charCodeAt(i$1) !== 46)) {
            var x1$1 = i$1;
            break _return$1;
          }
          i$1 = ((1 + i$1) | 0);
        }
        var x1$1 = (-1);
      }
      s = $x_1.a4z(((x1$1 === (-1)) ? "" : x$5.substring(x1$1)));
    }
    return ((neg && (s !== "0")) ? ("-" + s) : s);
  }
});
$p.E2 = (function(x) {
  if ((x >= 0.0)) {
    var x$1 = (x + 0.5);
    return (+Math.floor(x$1));
  } else {
    var x$2 = (x - 0.5);
    return (+Math.ceil(x$2));
  }
});
$p.b07 = (function(g) {
  return $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__dotJsonWith__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T__T(this, g, $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__boundingBox__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T(this, g));
});
$p.b3S = (function(g) {
  var d = $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__doc__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__Lorg_jpablo_graphexplorer_graphviz_output_Output$Doc(this, g);
  var tf0 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_DrawTransform$().aha(g);
  matchResult23: {
    var \u03b45$___1;
    var \u03b45$___2;
    var \u03b45$___3;
    var \u03b45$___4;
    if ($m_Lorg_jpablo_graphexplorer_graphviz_layout_DrawTransform$().ahL(g)) {
      var x54 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$().afN(g);
    } else {
      matchResult22: {
        var \u03b46$___1;
        var \u03b46$___2;
        var \u03b46$___3;
        var \u03b46$___4;
        var x49 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$().Wm(g);
        if ((x49 !== null)) {
          var \u03b46$___1 = (+x49.bO);
          var \u03b46$___2 = (+x49.bs);
          var \u03b46$___3 = (+x49.ch);
          var \u03b46$___4 = (+x49.ca);
          break matchResult22;
        }
        throw new $c_s_MatchError(x49);
      }
      var x54 = new $c_T4((+\u03b46$___1), (+\u03b46$___2), (+\u03b46$___3), (+\u03b46$___4));
    }
    if ((x54 !== null)) {
      var \u03b45$___1 = (+x54.bO);
      var \u03b45$___2 = (+x54.bs);
      var \u03b45$___3 = (+x54.ch);
      var \u03b45$___4 = (+x54.ca);
      break matchResult23;
    }
    throw new $c_s_MatchError(x54);
  }
  var lx$2 = (+\u03b45$___1);
  var ly$2 = (+\u03b45$___2);
  var ux$2 = (+\u03b45$___3);
  var uy$2 = (+\u03b45$___4);
  var dx = (-lx$2);
  var dy = (-ly$2);
  var tf = new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((x, y) => {
    var x$1 = (+x);
    var y$1 = (+y);
    matchResult24: {
      var \u03b47$___1;
      var \u03b47$___2;
      var x59 = tf0.R(x$1, y$1);
      if ((x59 !== null)) {
        var \u03b47$___1 = (+x59.g());
        var \u03b47$___2 = (+x59.h());
        break matchResult24;
      }
      throw new $c_s_MatchError(x59);
    }
    return new $c_T2(((+\u03b47$___1) + dx), ((+\u03b47$___2) + dy));
  }));
  var byId = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$9(g.cB.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n) => new $c_T2(n.br, n)))));
  var xs = $m_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$().a5k(g);
  matchResult25: {
    var yOf$2;
    var x62 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().PL(g);
    if ((x62 !== null)) {
      var yOf$2 = x62.h();
      break matchResult25;
    }
    throw new $c_s_MatchError(x62);
  }
  var ranks = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().P0(g);
  var spl = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$().a4K(g);
  var lps = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$().a43(g);
  var sb = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  sb.ad("{\n");
  sb.ad((("  \"name\": \"" + $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__esc__T__T(this, d.Fv)) + "\",\n"));
  sb.ad((("  \"directed\": " + d.Fu) + ",\n"));
  sb.ad((("  \"strict\": " + d.Fz) + ",\n"));
  sb.ad((((((((("  \"bb\": \"" + this.dU((lx$2 + dx))) + ",") + this.dU((ly$2 + dy))) + ",") + this.dU((ux$2 + dx))) + ",") + this.dU((uy$2 + dy))) + "\",\n"));
  var rootKv = new $c_scm_LinkedHashMap();
  d.Fx.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$1) => {
    matchResult26: {
      if ((x$1$1 !== null)) {
        var k = x$1$1.g();
        var v = x$1$1.h();
        $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(rootKv, k, (("\"" + $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__esc__T__T($m_Lorg_jpablo_graphexplorer_graphviz_output_Output$(), v)) + "\""), false);
        break matchResult26;
      }
      throw new $c_s_MatchError(x$1$1);
    }
  })));
  var this$12 = $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__rootLabelText__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__s_Option(this, g);
  if ((!this$12.c())) {
    var x0 = this$12.d();
    var lhPt = $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__labelHtPt__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__T__D($m_Lorg_jpablo_graphexplorer_graphviz_output_Output$(), g, x0);
    var $x_3 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$();
    var $x_2 = $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__labelFontSize__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D($m_Lorg_jpablo_graphexplorer_graphviz_output_Output$(), g);
    var $x_1 = g.f2.dL("fontname", "Times");
    var this$13 = g.j5;
    var lwIn = ($x_3.Xq(x0, $x_2, $x_1, (this$13.c() ? "" : this$13.d())) / 72.0);
    $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(rootKv, "lheight", (("\"" + $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__f2__D__T($m_Lorg_jpablo_graphexplorer_graphviz_output_Output$(), (lhPt / 72.0))) + "\""), false);
    $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(rootKv, "lp", (((("\"" + $m_Lorg_jpablo_graphexplorer_graphviz_output_Output$().dU(((0.5 * (lx$2 + ux$2)) + dx))) + ",") + $m_Lorg_jpablo_graphexplorer_graphviz_output_Output$().dU(((($m_Lorg_jpablo_graphexplorer_graphviz_output_Output$(), $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().agk(g)) ? ((uy$2 - $m_Lorg_jpablo_graphexplorer_graphviz_output_Output$().a8a) - (0.5 * lhPt)) : ($m_Lorg_jpablo_graphexplorer_graphviz_output_Output$().a8a + (0.5 * lhPt))) + dy))) + "\""), false);
    $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(rootKv, "lwidth", (("\"" + $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__f2__D__T($m_Lorg_jpablo_graphexplorer_graphviz_output_Output$(), lwIn)) + "\""), false);
  }
  $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O($m_sci_Vector$().X(rootKv), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$14) => _$14.g())), $m_s_math_Ordering$String$()).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    if ((x$1$2 !== null)) {
      var k$1 = x$1$2.g();
      var v$1 = x$1$2.h();
      return sb.ad((((("  \"" + $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__esc__T__T($m_Lorg_jpablo_graphexplorer_graphviz_output_Output$(), k$1)) + "\": ") + v$1) + ",\n"));
    }
    throw new $c_s_MatchError(x$1$2);
  })));
  sb.ad(("  \"_subgraph_cnt\": " + d.Fy));
  var this$16 = g.cu;
  var res = false;
  var it = this$16.o();
  while (((!res) && it.p())) {
    res = it.q().b4.ag.E("label");
  }
  var edgeLabels = res;
  var cls = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$().tV(g);
  if ($f_sc_SeqOps__isEmpty__Z(cls)) {
    var cluLayoutAttrs = $m_sci_Map$EmptyMap$();
  } else {
    var cbbs = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$().a2N(g);
    var flip = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().jT(g);
    var cluLayoutAttrs = $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(cls).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3) => {
      var c$1 = x$1$3.g();
      var i = (x$1$3.h() | 0);
      var bb = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$().aO9(g, cbbs.l(i), tf);
      var base = $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("bb", (((((($m_Lorg_jpablo_graphexplorer_graphviz_output_Output$().dU(bb.nW) + ",") + $m_Lorg_jpablo_graphexplorer_graphviz_output_Output$().dU(bb.pR)) + ",") + $m_Lorg_jpablo_graphexplorer_graphviz_output_Output$().dU(bb.nX)) + ",") + $m_Lorg_jpablo_graphexplorer_graphviz_output_Output$().dU(bb.pS)))])));
      if (c$1.pv()) {
        matchResult30: {
          var \u03b410$___1;
          var \u03b410$___2;
          var x77 = $f_F2__tupled__F1(tf).i(c$1.aPG(cbbs.l(i), flip));
          if ((x77 !== null)) {
            var \u03b410$___1 = (+x77.g());
            var \u03b410$___2 = (+x77.h());
            break matchResult30;
          }
          throw new $c_s_MatchError(x77);
        }
        var lpx$2 = (+\u03b410$___1);
        var lpy$2 = (+\u03b410$___2);
        var lbl = $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("lheight", $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__f2__D__T($m_Lorg_jpablo_graphexplorer_graphviz_output_Output$(), (c$1.Fd / 72.0))), new $c_T2("lp", (($m_Lorg_jpablo_graphexplorer_graphviz_output_Output$().dU(lpx$2) + ",") + $m_Lorg_jpablo_graphexplorer_graphviz_output_Output$().dU(lpy$2))), new $c_T2("lwidth", $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__f2__D__T($m_Lorg_jpablo_graphexplorer_graphviz_output_Output$(), (c$1.Fe / 72.0)))])));
      } else {
        $m_sci_Vector$();
        var lbl = $m_sci_Vector0$();
      }
      return new $c_T2(c$1.yO, base.iR(lbl));
    }))).eX($m_s_$less$colon$less$().b1);
  }
  var objBlocks = d.FA.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((sg) => {
    var attrs = $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O($p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__sgAttrs__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__Lorg_jpablo_graphexplorer_graphviz_output_Output$Doc$SG__sci_Vector($m_Lorg_jpablo_graphexplorer_graphviz_output_Output$(), g, sg).iR(cluLayoutAttrs.ay(sg.FH, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      $m_sci_Vector$();
      return $m_sci_Vector0$();
    })))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$19) => _$19.g())), $m_s_math_Ordering$String$());
    return $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__sgBlockJson__Lorg_jpablo_graphexplorer_graphviz_output_Output$Doc$SG__sci_Vector__T($m_Lorg_jpablo_graphexplorer_graphviz_output_Output$(), sg, attrs);
  }))).g9(d.Fw.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$4) => $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__nodeBlock$2__sci_Map__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__sci_Map__sci_Map__F2__T__I__T(this, byId, g, xs, yOf$2, ranks, tf, x$1$4.g(), (x$1$4.h() | 0))))));
  if ((!$f_sc_SeqOps__isEmpty__Z(objBlocks))) {
    sb.ad(",\n  \"objects\": [\n");
    sb.ad($f_sc_IterableOnceOps__mkString__T__T__T__T(objBlocks, "", ",\n", ""));
    sb.ad(((!$f_sc_SeqOps__isEmpty__Z(d.wR)) ? "\n  ],\n" : "\n  ]\n"));
  } else {
    sb.ad("\n");
  }
  if ((!$f_sc_SeqOps__isEmpty__Z(d.wR))) {
    sb.ad("  \"edges\": [\n");
    sb.ad($f_sc_IterableOnceOps__mkString__T__T__T__T(d.wR.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e) => $p_Lorg_jpablo_graphexplorer_graphviz_output_Output$__edgeBlock$2__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__Z__sci_Map__F2__sci_Map__Lorg_jpablo_graphexplorer_graphviz_output_Output$Doc$E__T(this, g, edgeLabels, lps, tf, spl, e)))), "", ",\n", ""));
    sb.ad("\n  ]\n");
  }
  sb.ad("}\n");
  return sb.bP.ah;
});
var $d_Lorg_jpablo_graphexplorer_graphviz_output_Output$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_output_Output$, "org.jpablo.graphexplorer.graphviz.output.Output$", ({
  vB: 1
}));
var $n_Lorg_jpablo_graphexplorer_graphviz_output_Output$;
function $m_Lorg_jpablo_graphexplorer_graphviz_output_Output$() {
  if ((!$n_Lorg_jpablo_graphexplorer_graphviz_output_Output$)) {
    $n_Lorg_jpablo_graphexplorer_graphviz_output_Output$ = new $c_Lorg_jpablo_graphexplorer_graphviz_output_Output$();
  }
  return $n_Lorg_jpablo_graphexplorer_graphviz_output_Output$;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__svgFontAttrs__T__T($thiz, fontName) {
  var x1 = $thiz.auC.r(fontName.toLowerCase());
  if ((x1 instanceof $c_s_Some)) {
    var x3 = x1.J;
    if ((x3 !== null)) {
      var family = x3.No;
      var weight = x3.Np;
      var stretch = x3.Nq;
      var style = x3.Nr;
      var svgFam = x3.Ns;
      var fam = (((svgFam !== "") && (svgFam !== family)) ? ((family + ",") + svgFam) : family);
      var sb = $ct_scm_StringBuilder__T__(new $c_scm_StringBuilder(), ((" font-family=\"" + fam) + "\""));
      if ((weight !== "")) {
        sb.ad(((" font-weight=\"" + weight) + "\""));
      }
      if ((stretch !== "")) {
        sb.ad(((" font-stretch=\"" + stretch) + "\""));
      }
      if ((style !== "")) {
        sb.ad(((" font-style=\"" + style) + "\""));
      }
      return sb.bP.ah;
    }
  }
  if (($m_s_None$() === x1)) {
    return ((" font-family=\"" + fontName) + "\"");
  }
  throw new $c_s_MatchError(x1);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__stripZeros__T__T($thiz, s) {
  if ((!$m_sc_StringOps$().IJ(s, 46))) {
    return s;
  } else {
    var e = s.length;
    while (((e > 0) && (s.charCodeAt(((e - 1) | 0)) === 48))) {
      e = ((e - 1) | 0);
    }
    if (((e > 0) && (s.charCodeAt(((e - 1) | 0)) === 46))) {
      e = ((e - 1) | 0);
    }
    var endIndex = e;
    var r = s.substring(0, endIndex);
    return (((r === "-0") || (r === "")) ? "0" : r);
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__xml__T__T($thiz, s) {
  var b = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  var elem = 0;
  elem = 0;
  var len = s.length;
  var i = 0;
  while ((i < len)) {
    var index = i;
    var x0 = s.charCodeAt(index);
    switch (x0) {
      case 38: {
        b.ad("&amp;");
        break;
      }
      case 60: {
        b.ad("&lt;");
        break;
      }
      case 62: {
        b.ad("&gt;");
        break;
      }
      case 34: {
        b.ad("&quot;");
        break;
      }
      case 39: {
        b.ad("&#39;");
        break;
      }
      case 45: {
        b.ad("&#45;");
        break;
      }
      default: {
        if ((((32 ^ x0) | (32 ^ elem)) === 0)) {
          b.ad("&#160;");
          break;
        }
        b.id(x0);
      }
    }
    elem = x0;
    i = ((1 + i) | 0);
  }
  return b.bP.ah;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__xmlHref__T__T($thiz, s) {
  var b = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  var i = 0;
  while ((i < s.length)) {
    var i$1 = i;
    var x29 = s.charCodeAt(i$1);
    switch (x29) {
      case 38: {
        if ((!$p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__isEntity$1__T__I__Z($thiz, s, i))) {
          b.ad("&amp;");
          break;
        }
        b.id(38);
        break;
      }
      case 60: {
        b.ad("&lt;");
        break;
      }
      case 62: {
        b.ad("&gt;");
        break;
      }
      case 34: {
        b.ad("&quot;");
        break;
      }
      case 39: {
        b.ad("&#39;");
        break;
      }
      default: {
        b.id(x29);
      }
    }
    i = ((1 + i) | 0);
  }
  return b.bP.ah;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__xmlTooltip__T__T($thiz, s) {
  var b = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  var elem = 0;
  elem = 0;
  var len = s.length;
  var i = 0;
  while ((i < len)) {
    var index = i;
    var x0 = s.charCodeAt(index);
    switch (x0) {
      case 38: {
        b.ad("&amp;");
        break;
      }
      case 60: {
        b.ad("&lt;");
        break;
      }
      case 62: {
        b.ad("&gt;");
        break;
      }
      case 45: {
        b.ad("&#45;");
        break;
      }
      default: {
        if ((((32 ^ x0) | (32 ^ elem)) === 0)) {
          b.ad("&#160;");
          break;
        }
        switch (x0) {
          case 34: {
            b.ad("&quot;");
            break;
          }
          case 39: {
            b.ad("&#39;");
            break;
          }
          case 10: {
            b.ad("&#10;");
            break;
          }
          case 13: {
            b.ad("&#13;");
            break;
          }
          default: {
            b.id(x0);
          }
        }
      }
    }
    elem = x0;
    i = ((1 + i) | 0);
  }
  return b.bP.ah;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__at$1__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__D__T2($thiz, c$1, t) {
  var tri = $m_jl_reflect_Array$().m0($d_T2.l(), new $ac_I(new Int32Array([4, 4])));
  var k = 0;
  while ((k <= 3)) {
    tri.a[0].a[k] = new $c_T2(c$1.a[k].W, c$1.a[k].a6);
    k = ((1 + k) | 0);
  }
  var i = 1;
  while ((i <= 3)) {
    k = 0;
    while ((k <= ((3 - i) | 0))) {
      tri.a[i].a[k] = new $c_T2((((1.0 - t) * (+tri.a[((i - 1) | 0)].a[k].g())) + (t * (+tri.a[((i - 1) | 0)].a[((1 + k) | 0)].g()))), (((1.0 - t) * (+tri.a[((i - 1) | 0)].a[k].h())) + (t * (+tri.a[((i - 1) | 0)].a[((1 + k) | 0)].h()))));
      k = ((1 + k) | 0);
    }
    i = ((1 + i) | 0);
  }
  return tri.a[3].a[0];
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__isEntity$1__T__I__Z($thiz, s$1, i) {
  var j = ((1 + i) | 0);
  if (((j < s$1.length) && (s$1.charCodeAt(j) === 35))) {
    j = ((1 + j) | 0);
    if (((j < s$1.length) && ((s$1.charCodeAt(j) === 120) || (s$1.charCodeAt(j) === 88)))) {
      j = ((1 + j) | 0);
      var st = j;
      while (((j < s$1.length) && ($m_jl_Character$().WE(s$1.charCodeAt(j), 16) >= 0))) {
        j = ((1 + j) | 0);
      }
      return (((j > st) && (j < s$1.length)) && (s$1.charCodeAt(j) === 59));
    } else {
      var st$2 = j;
      while (((j < s$1.length) && $m_jl_UnicodeData$().b3i(s$1.charCodeAt(j)))) {
        j = ((1 + j) | 0);
      }
      return (((j > st$2) && (j < s$1.length)) && (s$1.charCodeAt(j) === 59));
    }
  } else {
    var st$3 = j;
    while (((j < s$1.length) && $m_jl_UnicodeData$().E5(s$1.charCodeAt(j)))) {
      j = ((1 + j) | 0);
    }
    return ((((j > st$3) && (j < s$1.length)) && (s$1.charCodeAt(j) === 59)) && $m_jl_UnicodeData$().a3S(s$1.charCodeAt(st$3)));
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__textAt$1__D__D__T__T__T__D__T($thiz, cx, cyc, s, fill, fontName, fontSize) {
  var dimY = (fontSize * $thiz.auB);
  var ty = (-(((cyc + (0.5 * dimY)) - fontSize) + (0.1 * fontSize)));
  var fillP = ((fill === "") ? "" : $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__fillPaint$1__T__T($thiz, fill));
  if ((fillP !== "")) {
    _return: {
      var len = fillP.length;
      if ((len === 5)) {
        var i = 0;
        while ((i !== len)) {
          var thisCP = $f_T__codePointAt__I__I(fillP, i);
          if (($m_jl_Character$().iy($m_jl_Character$().j0(thisCP)) !== $m_jl_Character$().iy($m_jl_Character$().j0($f_T__codePointAt__I__I("black", i))))) {
            var $x_2 = false;
            break _return;
          }
          i = ((i + ((thisCP >= 65536) ? 2 : 1)) | 0);
        }
        var $x_2 = true;
      } else {
        var $x_2 = false;
      }
    }
    var $x_1 = (!$x_2);
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    var f = ((" fill=\"" + fillP) + "\"");
  } else {
    var f = "";
  }
  return (((((((((((("<text xml:space=\"preserve\" text-anchor=\"middle\" x=\"" + $thiz.ac(cx)) + "\" y=\"") + $thiz.ac(ty)) + "\"") + $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__svgFontAttrs__T__T($thiz, fontName)) + " font-size=\"") + $thiz.aNZ(fontSize)) + "\"") + f) + ">") + $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__xmlTooltip__T__T($thiz, s)) + "</text>\n");
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__textLines$1__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D__D__T__T__T__T__D__C__D__T($thiz, g$1, cx, cyc, raw, fill, nodeId, fontName, fontSize, valign, spaceY) {
  var $x_1 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$();
  var this$1 = g$1.j5;
  var lines = $x_1.a42(raw, nodeId, (this$1.c() ? "" : this$1.d()));
  _return$1: {
    var these = lines;
    while ((!these.c())) {
      if ((!(these.t().g() === ""))) {
        var $x_2 = false;
        break _return$1;
      }
      these = these.v();
    }
    var $x_2 = true;
  }
  if ($x_2) {
    return "";
  }
  var f = ((x$1) => {
    var l = x$1.g();
    $uC(x$1.h());
    return $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().aPX(l, fontSize);
  });
  if ((lines === $m_sci_Nil$())) {
    var $x_3 = $m_sci_Nil$();
  } else {
    var x0$1 = lines.t();
    var h = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
    var t = h;
    var rest = lines.v();
    while ((rest !== $m_sci_Nil$())) {
      var x0$2 = rest.t();
      var nx = new $c_sci_$colon$colon(f(x0$2), $m_sci_Nil$());
      t.U = nx;
      t = nx;
      rest = rest.v();
    }
    var $x_3 = h;
  }
  var dimenY = (+$f_sc_IterableOnceOps__sum__s_math_Numeric__O($x_3, $m_s_math_Numeric$DoubleIsFractional$()));
  var $x_4 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$();
  var this$4 = g$1.j5;
  var boxW = $x_4.b3X(raw, fontSize, fontName, nodeId, (this$4.c() ? "" : this$4.d()));
  var fillP = ((fill === "") ? "" : $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__fillPaint$1__T__T($thiz, fill));
  if ((fillP !== "")) {
    _return$2: {
      var len = fillP.length;
      if ((len === 5)) {
        var i = 0;
        while ((i !== len)) {
          var thisCP = $f_T__codePointAt__I__I(fillP, i);
          if (($m_jl_Character$().iy($m_jl_Character$().j0(thisCP)) !== $m_jl_Character$().iy($m_jl_Character$().j0($f_T__codePointAt__I__I("black", i))))) {
            var $x_6 = false;
            break _return$2;
          }
          i = ((i + ((thisCP >= 65536) ? 2 : 1)) | 0);
        }
        var $x_6 = true;
      } else {
        var $x_6 = false;
      }
    }
    var $x_5 = (!$x_6);
  } else {
    var $x_5 = false;
  }
  if ($x_5) {
    var f$1 = ((" fill=\"" + fillP) + "\"");
  } else {
    var f$1 = "";
  }
  var out = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  var elem = ((valign === 116) ? ((cyc + (0.5 * spaceY)) - fontSize) : ((valign === 98) ? (((cyc - (0.5 * spaceY)) + dimenY) - fontSize) : ((cyc + (0.5 * dimenY)) - fontSize)));
  var elem$1 = 0.0;
  elem$1 = elem;
  var these$1 = lines;
  while ((!these$1.c())) {
    var x0$3 = these$1.t();
    matchResult17: {
      if ((x0$3 !== null)) {
        var line = x0$3.g();
        var just = $uC(x0$3.h());
        var h$1 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().aPX(line, fontSize);
        if ((line !== "")) {
          var ty = (-(elem$1 + (0.1 * fontSize)));
          if ((just === 108)) {
            var \u03b48$___1 = "start";
            var \u03b48$___2 = (cx - (0.5 * boxW));
          } else if ((just === 114)) {
            var \u03b48$___1 = "end";
            var \u03b48$___2 = (cx + (0.5 * boxW));
          } else {
            var \u03b48$___1 = "middle";
            var \u03b48$___2 = cx;
          }
          var anchor = \u03b48$___1;
          var tx = (+\u03b48$___2);
          out.ad((((((((((((((("<text xml:space=\"preserve\" text-anchor=\"" + anchor) + "\" x=\"") + $m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$().ac(tx)) + "\" y=\"") + $m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$().ac(ty)) + "\"") + $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__svgFontAttrs__T__T($m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$(), fontName)) + " font-size=\"") + $m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$().aNZ(fontSize)) + "\"") + f$1) + ">") + $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__xmlTooltip__T__T($m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$(), line)) + "</text>\n"));
        }
        elem$1 = (elem$1 - h$1);
        break matchResult17;
      }
      throw new $c_s_MatchError(x0$3);
    }
    these$1 = these$1.v();
  }
  return out.bP.ah;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__walk$1__scm_Builder__Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph__V($thiz, b$3, s) {
  b$3.Y(new $c_T2(s.z7, s));
  s.lD.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((s$2) => {
    $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__walk$1__scm_Builder__Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph__V($thiz, b$3, s$2);
  })));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__rgbaSplit$1__T__T2($thiz, c) {
  var t = $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__svgColor$1__T__T($thiz, c);
  if (((t.length === 9) && (t.charCodeAt(0) === 35))) {
    var a = $m_jl_Integer$().gc(t.substring(7), 16, 134217728);
    if ((a === 0)) {
      return new $c_T2("none", $m_s_None$());
    } else if ((a === 255)) {
      return new $c_T2(t.substring(0, 7), $m_s_None$());
    } else {
      var this$8 = $m_s_package$().oz();
      var v = this$8.y8(Math.fround((Math.fround(a) / 255.0)), this$8.qI).Jm(6, ($m_s_package$().oz(), $m_s_math_BigDecimal$RoundingMode$().Oe)).dN.Q2();
      return new $c_T2(t.substring(0, 7), new $c_s_Some(v));
    }
  } else {
    return new $c_T2(t, $m_s_None$());
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__fillPaint$1__T__T($thiz, c) {
  matchResult19: {
    var \u03b410$___1;
    var \u03b410$___2;
    var x67 = $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__rgbaSplit$1__T__T2($thiz, c);
    if ((x67 !== null)) {
      var \u03b410$___1 = x67.g();
      var \u03b410$___2 = x67.h();
      break matchResult19;
    }
    throw new $c_s_MatchError(x67);
  }
  var p$2 = \u03b410$___1;
  var o$2 = \u03b410$___2;
  if (o$2.c()) {
    var $x_1 = p$2;
  } else {
    var x0 = o$2.d();
    var $x_1 = ((p$2 + "\" fill-opacity=\"") + x0);
  }
  return $x_1;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__strokeSplit$1__T__T2($thiz, c) {
  matchResult20: {
    var \u03b411$___1;
    var \u03b411$___2;
    var x70 = $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__rgbaSplit$1__T__T2($thiz, c);
    if ((x70 !== null)) {
      var \u03b411$___1 = x70.g();
      var \u03b411$___2 = x70.h();
      break matchResult20;
    }
    throw new $c_s_MatchError(x70);
  }
  var p$2 = \u03b411$___1;
  var o$2 = \u03b411$___2;
  return new $c_T2(p$2, (o$2.c() ? "" : ((" stroke-opacity=\"" + o$2.d()) + "\"")));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__svgColor$1__T__T($thiz, c) {
  var t = $f_T__trim__T(c);
  if ((!(!t.startsWith("#")))) {
    return t.toLowerCase();
  } else {
    var parts = $f_T__split__T__I__AT(t, "[,\\s]+", 0);
    if ((parts.a.length === 3)) {
      _return: {
        var i = 0;
        while ((i < parts.a.length)) {
          var x1 = i;
          var x0 = parts.a[x1];
          if ((!(!($m_sc_StringParsers$().c1(x0) ? new $c_s_Some($m_jl_Double$().bd(x0)) : $m_s_None$()).c()))) {
            var $x_1 = false;
            break _return;
          }
          i = ((1 + i) | 0);
        }
        var $x_1 = true;
      }
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var h0 = $m_jl_Double$().bd(parts.a[0]);
      var s0 = $m_jl_Double$().bd(parts.a[1]);
      var v0 = $m_jl_Double$().bd(parts.a[2]);
      if ((s0 <= 0.0)) {
        var \u03b412$___1 = v0;
        var \u03b412$___2 = v0;
        var \u03b412$___3 = v0;
      } else {
        var h = ((h0 >= 1.0) ? 0.0 : h0);
        h = (6.0 * h);
        var i$1 = $doubleToInt(h);
        var f = (h - i$1);
        var pp = (v0 * (1.0 - s0));
        var q = (v0 * (1.0 - (s0 * f)));
        var tt = (v0 * (1.0 - (s0 * (1.0 - f))));
        var \u03b412$___1;
        var \u03b412$___2;
        var \u03b412$___3;
        switch (i$1) {
          case 0: {
            var \u03b412$___1 = v0;
            var \u03b412$___2 = tt;
            var \u03b412$___3 = pp;
            break;
          }
          case 1: {
            var \u03b412$___1 = q;
            var \u03b412$___2 = v0;
            var \u03b412$___3 = pp;
            break;
          }
          case 2: {
            var \u03b412$___1 = pp;
            var \u03b412$___2 = v0;
            var \u03b412$___3 = tt;
            break;
          }
          case 3: {
            var \u03b412$___1 = pp;
            var \u03b412$___2 = q;
            var \u03b412$___3 = v0;
            break;
          }
          case 4: {
            var \u03b412$___1 = tt;
            var \u03b412$___2 = pp;
            var \u03b412$___3 = v0;
            break;
          }
          default: {
            var \u03b412$___1 = v0;
            var \u03b412$___2 = pp;
            var \u03b412$___3 = q;
          }
        }
      }
      return $m_sc_StringOps$().u0("#%02x%02x%02x", $m_sr_ScalaRunTime$().hP(new $ac_O([$doubleToInt((255.0 * (+\u03b412$___1))), $doubleToInt((255.0 * (+\u03b412$___2))), $doubleToInt((255.0 * (+\u03b412$___3)))])));
    } else {
      return $m_Lorg_jpablo_graphexplorer_graphviz_output_X11Colors$().auD.ay(t.toLowerCase(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => t)));
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__htmlText$1__D__D__Lorg_jpablo_graphexplorer_graphviz_html_HtmlText__T__D__Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign__D__T__T($thiz, cx, cyc, block, defColor, alignWidth, defAlign, baseSize, baseName) {
  var out = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  var tm = $m_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$().aSJ(block, baseSize, baseName);
  var elem = (cyc + (0.5 * tm.F1));
  var elem$1 = 0.0;
  elem$1 = elem;
  var this$3 = $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(block.oW, tm.Ko);
  var these = this$3;
  while ((!these.c())) {
    var x0 = these.t();
    var sp = x0.g();
    var ln = x0.h();
    elem$1 = (elem$1 - ln.Kn);
    matchResult22: {
      var x0$1;
      var this$4 = sp.yM;
      var x74 = (this$4.c() ? defAlign : this$4.d());
      var x = $s_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$__Left__Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign();
      if (((x === null) ? (x74 === null) : (x === x74))) {
        var x0$1 = (cx - (0.5 * alignWidth));
        break matchResult22;
      }
      var x$3 = $s_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$__Right__Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign();
      if (((x$3 === null) ? (x74 === null) : (x$3 === x74))) {
        var x0$1 = ((cx + (0.5 * alignWidth)) - ln.F0);
        break matchResult22;
      }
      var x0$1 = (cx - (0.5 * ln.F0));
    }
    var elem$2 = 0.0;
    elem$2 = x0$1;
    var this$6 = sp.lz;
    var these$1 = this$6;
    while ((!these$1.c())) {
      var x0$2 = these$1.t();
      var this$7 = x0$2.hb.kZ;
      var fs = (+(this$7.c() ? baseSize : this$7.d()));
      var this$8 = x0$2.hb.n1;
      var nm = (this$8.c() ? baseName : this$8.d());
      if (x0$2.hb.nP) {
        var bold = true;
      } else {
        var this$9 = nm.toLowerCase();
        var bold = ((this$9.indexOf("bold") | 0) !== (-1));
      }
      if (x0$2.hb.nQ) {
        var $x_1 = true;
      } else {
        var this$10 = nm.toLowerCase();
        var $x_1 = ((this$10.indexOf("italic") | 0) !== (-1));
      }
      if ($x_1) {
        var ital = true;
      } else {
        var this$11 = nm.toLowerCase();
        var ital = ((this$11.indexOf("oblique") | 0) !== (-1));
      }
      var w = $m_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$().aPt(x0$2, baseSize, baseName);
      var wgt = (bold ? " font-weight=\"bold\"" : "");
      var sty = (ital ? " font-style=\"italic\"" : "");
      var bsh = (x0$2.hb.oN ? " baseline-shift=\"sub\"" : (x0$2.hb.oO ? " baseline-shift=\"super\"" : ""));
      var this$12 = x0$2.hb.oM;
      if (this$12.c()) {
        var this$13 = $m_s_Option$().as(defColor);
        var col = ((this$13.c() || (this$13.d() !== "")) ? this$13 : $m_s_None$());
      } else {
        var col = this$12;
      }
      var this$16 = (col.c() ? $m_s_None$() : new $c_s_Some($p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__fillPaint$1__T__T($thiz, col.d())));
      if (this$16.c()) {
        var $x_2 = true;
      } else {
        var x0$5 = this$16.d();
        _return: {
          var len = x0$5.length;
          if ((len === 5)) {
            var i = 0;
            while ((i !== len)) {
              var thisCP = $f_T__codePointAt__I__I(x0$5, i);
              if (($m_jl_Character$().iy($m_jl_Character$().j0(thisCP)) !== $m_jl_Character$().iy($m_jl_Character$().j0($f_T__codePointAt__I__I("black", i))))) {
                var $x_3 = false;
                break _return;
              }
              i = ((i + ((thisCP >= 65536) ? 2 : 1)) | 0);
            }
            var $x_3 = true;
          } else {
            var $x_3 = false;
          }
        }
        var $x_2 = (!$x_3);
      }
      if ($x_2) {
        var this$18 = this$16;
      } else {
        var this$18 = $m_s_None$();
      }
      var this$19 = (this$18.c() ? $m_s_None$() : new $c_s_Some(((" fill=\"" + this$18.d()) + "\"")));
      var f = (this$19.c() ? "" : this$19.d());
      var dec = (x0$2.hb.oP ? " text-decoration=\"underline\"" : "");
      var yoffC = (tm.Kp ? (0.1 * fs) : 1.0);
      var ty = (-(elem$1 + yoffC));
      out.ad((((((((((((((((("<text xml:space=\"preserve\" text-anchor=\"start\" x=\"" + $thiz.ac(elem$2)) + "\" y=\"") + $thiz.ac(ty)) + "\"") + $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__svgFontAttrs__T__T($thiz, nm)) + wgt) + sty) + bsh) + " font-size=\"") + $m_sc_StringOps$().u0("%.2f", $m_sr_ScalaRunTime$().hP(new $ac_O([fs])))) + "\"") + f) + dec) + ">") + $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__xmlTooltip__T__T($thiz, x0$2.pO)) + "</text>\n"));
      elem$2 = (elem$2 + w);
      these$1 = these$1.v();
    }
    these = these.v();
  }
  return out.bP.ah;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__boxPoly$1__D__D__Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$BoxLocal__T($thiz, cx$3, cyc$1, b) {
  var _1 = (cx$3 + b.lA);
  var _2 = (cx$3 + b.lB);
  var _1$1 = (cyc$1 + b.me);
  var _2$1 = (cyc$1 + b.mf);
  return (((((((((((((((((($thiz.ac(_1) + ",") + $thiz.ac((-_1$1))) + " ") + $thiz.ac(_1)) + ",") + $thiz.ac((-_2$1))) + " ") + $thiz.ac(_2)) + ",") + $thiz.ac((-_2$1))) + " ") + $thiz.ac(_2)) + ",") + $thiz.ac((-_1$1))) + " ") + $thiz.ac(_1)) + ",") + $thiz.ac((-_1$1)));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__pt$4__D__D__T($thiz, px, py) {
  return (($thiz.ac(px) + ",") + $thiz.ac(py));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__line$1__scm_StringBuilder__T__T__T__T__sci_Seq__V($thiz, out$5, stroke$1, dash$1, swA$1, strokeOp$1, pts) {
  out$5.ad((((((((("<polyline fill=\"none\" stroke=\"" + stroke$1) + "\"") + dash$1) + swA$1) + strokeOp$1) + " points=\"") + $f_sc_IterableOnceOps__mkString__T__T__T__T(pts, "", " ", "")) + "\"/>\n"));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__doBorder$1__T__D__D__scm_StringBuilder__sci_Map__I__Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$BoxLocal__V($thiz, defPen$2, cx$4, cyc$2, out$4, attrs, border, b) {
  matchResult23: {
    var \u03b417$___1;
    var \u03b417$___2;
    var this$1 = attrs.r("color");
    var x75 = $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__strokeSplit$1__T__T2($thiz, (this$1.c() ? defPen$2 : this$1.d()));
    if ((x75 !== null)) {
      var \u03b417$___1 = x75.g();
      var \u03b417$___2 = x75.h();
      break matchResult23;
    }
    throw new $c_s_MatchError(x75);
  }
  var stroke$2 = \u03b417$___1;
  var strokeOp$2 = \u03b417$___2;
  var this$3 = attrs.r("style");
  var this$8 = (this$3.c() ? $m_s_None$() : new $c_s_Some($m_sci_Set$().af(new $c_sc_Iterator$$anon$9($m_sc_ArrayOps$().u8($f_T__split__T__I__AT(this$3.d(), ",", 0)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$34) => {
    var this$5 = $f_T__trim__T(_$34);
    return this$5.toLowerCase();
  }))))));
  var styles = (this$8.c() ? $m_sci_Set$EmptySet$() : this$8.d());
  var dash = (styles.E("dashed") ? " stroke-dasharray=\"5,2\"" : (styles.E("dotted") ? " stroke-dasharray=\"1,5\"" : ""));
  var swA = ((border !== 1) ? ((" stroke-width=\"" + border) + "\"") : "");
  var delta = ((border > 1) ? (0.5 * border) : 0.0);
  var _1 = ((cx$4 + b.lA) + delta);
  var _2 = ((cx$4 + b.lB) - delta);
  var _1$1 = (-((cyc$2 + b.me) + delta));
  var _2$1 = (-((cyc$2 + b.mf) - delta));
  var _1$2 = $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__pt$4__D__D__T($thiz, _1, _1$1);
  var _2$2 = $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__pt$4__D__D__T($thiz, _2, _1$1);
  var _3 = $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__pt$4__D__D__T($thiz, _2, _2$1);
  var _4 = $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__pt$4__D__D__T($thiz, _1, _2$1);
  var $x_3 = $m_sci_Seq$();
  var this$13 = attrs.r("sides");
  if (this$13.c()) {
    var this$19 = $m_s_None$();
  } else {
    var x0$1 = this$13.d();
    var $x_2 = $m_sci_Set$();
    var $x_1 = $m_s_Predef$();
    var x = x0$1.toLowerCase();
    var len = x.length;
    var sb = $ct_jl_StringBuilder__I__(new $c_jl_StringBuilder(), len);
    var i = 0;
    while ((i < len)) {
      var index = i;
      var x$1 = x.charCodeAt(index);
      if ($m_sc_StringOps$().IJ("ltrb", x$1)) {
        var str = ("" + $cToS(x$1));
        sb.ah = (sb.ah + str);
      }
      i = ((1 + i) | 0);
    }
    var this$19 = new $c_s_Some($x_2.af($x_1.JL(((len === sb.C()) ? x : sb.ah))));
  }
  switch ($f_sc_IterableOnceOps__mkString__T__T__T__T($x_3.fw((this$19.c() ? $m_sci_Set$EmptySet$() : this$19.d())).h9($m_s_math_Ordering$Char$()), "", "", "")) {
    case "b": {
      $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__line$1__scm_StringBuilder__T__T__T__T__sci_Seq__V($thiz, out$4, stroke$2, dash, swA, strokeOp$2, $m_sr_ScalaRunTime$().f(new ($d_T.r().C)([_1$2, _2$2])));
      break;
    }
    case "r": {
      $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__line$1__scm_StringBuilder__T__T__T__T__sci_Seq__V($thiz, out$4, stroke$2, dash, swA, strokeOp$2, $m_sr_ScalaRunTime$().f(new ($d_T.r().C)([_2$2, _3])));
      break;
    }
    case "t": {
      $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__line$1__scm_StringBuilder__T__T__T__T__sci_Seq__V($thiz, out$4, stroke$2, dash, swA, strokeOp$2, $m_sr_ScalaRunTime$().f(new ($d_T.r().C)([_3, _4])));
      break;
    }
    case "l": {
      $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__line$1__scm_StringBuilder__T__T__T__T__sci_Seq__V($thiz, out$4, stroke$2, dash, swA, strokeOp$2, $m_sr_ScalaRunTime$().f(new ($d_T.r().C)([_4, _1$2])));
      break;
    }
    case "br": {
      $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__line$1__scm_StringBuilder__T__T__T__T__sci_Seq__V($thiz, out$4, stroke$2, dash, swA, strokeOp$2, $m_sr_ScalaRunTime$().f(new ($d_T.r().C)([_1$2, _2$2, _3])));
      break;
    }
    case "rt": {
      $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__line$1__scm_StringBuilder__T__T__T__T__sci_Seq__V($thiz, out$4, stroke$2, dash, swA, strokeOp$2, $m_sr_ScalaRunTime$().f(new ($d_T.r().C)([_2$2, _3, _4])));
      break;
    }
    case "lt": {
      $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__line$1__scm_StringBuilder__T__T__T__T__sci_Seq__V($thiz, out$4, stroke$2, dash, swA, strokeOp$2, $m_sr_ScalaRunTime$().f(new ($d_T.r().C)([_3, _4, _1$2])));
      break;
    }
    case "bl": {
      $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__line$1__scm_StringBuilder__T__T__T__T__sci_Seq__V($thiz, out$4, stroke$2, dash, swA, strokeOp$2, $m_sr_ScalaRunTime$().f(new ($d_T.r().C)([_4, _1$2, _2$2])));
      break;
    }
    case "brt": {
      $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__line$1__scm_StringBuilder__T__T__T__T__sci_Seq__V($thiz, out$4, stroke$2, dash, swA, strokeOp$2, $m_sr_ScalaRunTime$().f(new ($d_T.r().C)([_1$2, _2$2, _3, _4])));
      break;
    }
    case "lrt": {
      $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__line$1__scm_StringBuilder__T__T__T__T__sci_Seq__V($thiz, out$4, stroke$2, dash, swA, strokeOp$2, $m_sr_ScalaRunTime$().f(new ($d_T.r().C)([_2$2, _3, _4, _1$2])));
      break;
    }
    case "blt": {
      $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__line$1__scm_StringBuilder__T__T__T__T__sci_Seq__V($thiz, out$4, stroke$2, dash, swA, strokeOp$2, $m_sr_ScalaRunTime$().f(new ($d_T.r().C)([_3, _4, _1$2, _2$2])));
      break;
    }
    case "blr": {
      $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__line$1__scm_StringBuilder__T__T__T__T__sci_Seq__V($thiz, out$4, stroke$2, dash, swA, strokeOp$2, $m_sr_ScalaRunTime$().f(new ($d_T.r().C)([_4, _1$2, _2$2, _3])));
      break;
    }
    case "bt": {
      $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__line$1__scm_StringBuilder__T__T__T__T__sci_Seq__V($thiz, out$4, stroke$2, dash, swA, strokeOp$2, $m_sr_ScalaRunTime$().f(new ($d_T.r().C)([_1$2, _2$2])));
      $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__line$1__scm_StringBuilder__T__T__T__T__sci_Seq__V($thiz, out$4, stroke$2, dash, swA, strokeOp$2, $m_sr_ScalaRunTime$().f(new ($d_T.r().C)([_3, _4])));
      break;
    }
    case "lr": {
      $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__line$1__scm_StringBuilder__T__T__T__T__sci_Seq__V($thiz, out$4, stroke$2, dash, swA, strokeOp$2, $m_sr_ScalaRunTime$().f(new ($d_T.r().C)([_4, _1$2])));
      $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__line$1__scm_StringBuilder__T__T__T__T__sci_Seq__V($thiz, out$4, stroke$2, dash, swA, strokeOp$2, $m_sr_ScalaRunTime$().f(new ($d_T.r().C)([_2$2, _3])));
      break;
    }
    default: {
      out$4.ad((((((((((((((((("<polygon fill=\"none\" stroke=\"" + stroke$2) + "\"") + dash) + swA) + strokeOp$2) + " points=\"") + _1$2) + " ") + _4) + " ") + _3) + " ") + _2$2) + " ") + _1$2) + "\"/>\n"));
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__col$1__T__T($thiz, s) {
  return $m_sc_ArrayOps$().aP6($f_T__split__T__I__AT(s, ";", 0));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__bgFill$1__sr_IntRef__D__D__scm_StringBuilder__T__Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$BoxLocal__V($thiz, htmlGradId$2, cx$5, cyc$3, out$6, bg, box) {
  var parts = $f_T__split__T__I__AT(bg, ":", 0);
  if ((parts.a.length >= 2)) {
    var id = ("l_" + htmlGradId$2.an);
    htmlGradId$2.an = ((1 + htmlGradId$2.an) | 0);
    var _1 = (cx$5 + box.lA);
    var _2 = (cx$5 + box.lB);
    var gy = (-(cyc$3 + box.aff()));
    out$6.ad((((((((((("<defs>\n<linearGradient id=\"" + id) + "\" gradientUnits=\"userSpaceOnUse\" x1=\"") + $thiz.ac(_1)) + "\" y1=\"") + $thiz.ac(gy)) + "\" x2=\"") + $thiz.ac(_2)) + "\" y2=\"") + $thiz.ac(gy)) + "\" >\n"));
    out$6.ad((("<stop offset=\"0\" style=\"stop-color:" + $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__col$1__T__T($thiz, parts.a[0])) + ";stop-opacity:1.;\"/>\n"));
    out$6.ad((("<stop offset=\"1\" style=\"stop-color:" + $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__col$1__T__T($thiz, parts.a[1])) + ";stop-opacity:1.;\"/>\n"));
    out$6.ad("</linearGradient>\n</defs>\n");
    out$6.ad((((("<polygon fill=\"url(#" + id) + ")\" stroke=\"none\" points=\"") + $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__boxPoly$1__D__D__Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$BoxLocal__T($thiz, cx$5, cyc$3, box)) + "\"/>\n"));
  } else {
    out$6.ad((((("<polygon fill=\"" + $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__fillPaint$1__T__T($thiz, bg)) + "\" stroke=\"none\" points=\"") + $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__boxPoly$1__D__D__Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$BoxLocal__T($thiz, cx$5, cyc$3, box)) + "\"/>\n"));
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__htmlTable$1__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sr_IntRef__D__D__Lorg_jpablo_graphexplorer_graphviz_html_HtmlTable__T__D__T__s_Option__T__T($thiz, g$4, htmlGradId$1, cx, cyc, tbl, defColor, baseSize, baseName, fit, defPen) {
  var laid = $m_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$().a46(tbl, baseSize, baseName, g$4.mj, fit);
  var tblSpace = tbl.Bb;
  var out = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  var tblBox = new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$BoxLocal((0.5 * (-laid.wB)), (0.5 * (-laid.wA)), (0.5 * laid.wB), (0.5 * laid.wA));
  var this$2 = tbl.nR.r("bgcolor");
  if ((!this$2.c())) {
    $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__bgFill$1__sr_IntRef__D__D__scm_StringBuilder__T__Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$BoxLocal__V($thiz, htmlGradId$1, cx, cyc, out, this$2.d(), tblBox);
  }
  laid.Be.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((pc) => {
    var this$3 = pc.oV.gE.r("bgcolor");
    if ((!this$3.c())) {
      $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__bgFill$1__sr_IntRef__D__D__scm_StringBuilder__T__Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$BoxLocal__V($thiz, htmlGradId$1, cx, cyc, out, this$3.d(), pc.nS);
    }
    if ((pc.F7 > 0)) {
      $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__doBorder$1__T__D__D__scm_StringBuilder__sci_Map__I__Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$BoxLocal__V($thiz, defPen, cx, cyc, out, pc.oV.gE, pc.F7, pc.nS);
    }
    var ccx = (cx + pc.hW.aNj());
    matchResult25: {
      var contentH$2;
      var x79 = $m_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$().PU(pc.oV.oL, baseSize, baseName, g$4.mj);
      if ((x79 !== null)) {
        var contentH$2 = (+x79.h());
        break matchResult25;
      }
      throw new $c_s_MatchError(x79);
    }
    matchResult26: {
      var ccy;
      var this$4 = pc.oV.gE.r("valign");
      if (this$4.c()) {
        var x82 = $m_s_None$();
      } else {
        var x0$2 = this$4.d();
        var x82 = new $c_s_Some(x0$2.toLowerCase());
      }
      if ((x82 instanceof $c_s_Some)) {
        var x86 = x82.J;
        if ((x86 === "top")) {
          var ccy = ((cyc + pc.hW.mf) - (0.5 * contentH$2));
          break matchResult26;
        }
        if ((x86 === "bottom")) {
          var ccy = ((cyc + pc.hW.me) + (0.5 * contentH$2));
          break matchResult26;
        }
      }
      var ccy = (cyc + pc.hW.aff());
    }
    var x92 = pc.oV.oL;
    if ((x92 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Text)) {
      var $x_4 = x92.oQ;
      var $x_3 = pc.hW.lB;
      var $x_2 = pc.hW.lA;
      matchResult27: {
        var $x_1;
        var this$6 = pc.oV.gE.r("align");
        if (this$6.c()) {
          var x87 = $m_s_None$();
        } else {
          var x0$3 = this$6.d();
          var x87 = new $c_s_Some(x0$3.toLowerCase());
        }
        if ((x87 instanceof $c_s_Some)) {
          var x91 = x87.J;
          if ((x91 === "left")) {
            var $x_1 = $s_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$__Left__Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign();
            break matchResult27;
          }
          if ((x91 === "right")) {
            var $x_1 = $s_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$__Right__Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign();
            break matchResult27;
          }
        }
        var $x_1 = $s_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$__Center__Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign();
      }
      return out.ad($p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__htmlText$1__D__D__Lorg_jpablo_graphexplorer_graphviz_html_HtmlText__T__D__Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign__D__T__T($thiz, ccx, ccy, $x_4, defColor, ($x_3 - $x_2), $x_1, baseSize, baseName));
    }
    if ((x92 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Table)) {
      return out.ad($p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__htmlTable$1__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sr_IntRef__D__D__Lorg_jpablo_graphexplorer_graphviz_html_HtmlTable__T__D__T__s_Option__T__T($thiz, g$4, htmlGradId$1, ccx, ccy, x92.k8, defColor, baseSize, baseName, new $c_s_Some(new $c_T2((pc.hW.lB - pc.hW.lA), (pc.hW.mf - pc.hW.me))), defPen));
    }
    if ((x92 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Image)) {
      var x95 = x92.wy;
      var x96 = x92.EZ;
      var this$11 = g$4.mj.r(x95);
      if ((!this$11.c())) {
        var x0$4 = this$11.d();
        out.ad($thiz.aTf(x95, (cx + pc.hW.lA), (cx + pc.hW.lB), (cyc + pc.hW.me), (cyc + pc.hW.mf), x0$4.bbR(), x0$4.b2l(), x96, "mc"));
      }
      return (void 0);
    }
    throw new $c_s_MatchError(x92);
  })));
  var _1$1 = (cx - (0.5 * laid.wB));
  var _2$1 = (cx + (0.5 * laid.wB));
  var _1$2 = (cyc - (0.5 * laid.wA));
  var _2$2 = (cyc + (0.5 * laid.wA));
  laid.Ks.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((hy) => {
    var hy$1 = (+hy);
    var y = (-(cyc + hy$1));
    return out.ad((((((((((((((((((((("<polygon fill=\"black\" stroke=\"black\" points=\"" + $m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$().ac(_1$1)) + ",") + $m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$().ac(y)) + " ") + $m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$().ac(_1$1)) + ",") + $m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$().ac(y)) + " ") + $m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$().ac(_2$1)) + ",") + $m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$().ac(y)) + " ") + $m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$().ac(_2$1)) + ",") + $m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$().ac(y)) + " ") + $m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$().ac(_1$1)) + ",") + $m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$().ac(y)) + "\"/>\n"));
  })));
  laid.Kv.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((vx) => {
    var vx$1 = (+vx);
    var x = (cx + vx$1);
    var lo = (-(_1$2 + tblSpace));
    var hi = (-_2$2);
    return out.ad((((((((((((((((((((("<polygon fill=\"black\" stroke=\"black\" points=\"" + $m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$().ac(x)) + ",") + $m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$().ac(lo)) + " ") + $m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$().ac(x)) + ",") + $m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$().ac(hi)) + " ") + $m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$().ac(x)) + ",") + $m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$().ac(hi)) + " ") + $m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$().ac(x)) + ",") + $m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$().ac(lo)) + " ") + $m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$().ac(x)) + ",") + $m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$().ac(lo)) + "\"/>\n"));
  })));
  if ((laid.F6 > 0)) {
    $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__doBorder$1__T__D__D__scm_StringBuilder__sci_Map__I__Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$BoxLocal__V($thiz, defPen, cx, cyc, out, tbl.nR, laid.F6, tblBox);
  }
  return out.bP.ah;
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__genFields$1__scm_StringBuilder__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sr_IntRef__Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$Field__D__D__T__D__T__T__V($thiz, sb$4, g$6, htmlGradId$6, f, ncx, ncy, fontName, fontSize, fontColor, nodeId) {
  if ($f_sc_SeqOps__isEmpty__Z(f.hX)) {
    var fcx = (ncx + (0.5 * (f.n5 + f.q1)));
    var fcy = (ncy + (0.5 * (f.q0 + f.o2)));
    matchResult29: {
      var x103 = f.a81;
      if ((x103 instanceof $c_s_Some)) {
        var x116 = x103.J;
        if ((x116 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Text)) {
          var x119 = x116.oQ;
          sb$4.ad($p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__htmlText$1__D__D__Lorg_jpablo_graphexplorer_graphviz_html_HtmlText__T__D__Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign__D__T__T($thiz, fcx, fcy, x119, fontColor, (+$m_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$().a4W(x119, fontSize, fontName).g()), $s_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$__Center__Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign(), fontSize, fontName));
          break matchResult29;
        }
        if ((x116 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Table)) {
          sb$4.ad($p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__htmlTable$1__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sr_IntRef__D__D__Lorg_jpablo_graphexplorer_graphviz_html_HtmlTable__T__D__T__s_Option__T__T($thiz, g$6, htmlGradId$6, fcx, fcy, x116.k8, fontColor, fontSize, fontName, $m_s_None$(), "black"));
          break matchResult29;
        }
        if ((x116 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Image)) {
          break matchResult29;
        }
      }
      if (($m_s_None$() === x103)) {
        var this$5 = f.L2;
        var this$8 = ((this$5.c() || (this$5.d() !== "")) ? this$5 : $m_s_None$());
        if ((!this$8.c())) {
          sb$4.ad($p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__textLines$1__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D__D__T__T__T__T__D__C__D__T($thiz, g$6, fcx, fcy, this$8.d(), fontColor, nodeId, fontName, fontSize, 99, 0.0));
          break matchResult29;
        } else {
          break matchResult29;
        }
      }
      throw new $c_s_MatchError(x103);
    }
  } else {
    var this$10 = new $c_sc_Iterator$$anon$16(f.hX.o());
    while (this$10.p()) {
      var x0$2 = this$10.dC();
      matchResult30: {
        if ((x0$2 !== null)) {
          var c = x0$2.g();
          if (((x0$2.h() | 0) > 0)) {
            if (f.wL) {
              var \u03b422$___1 = new $c_T2(c.n5, c.q0);
              var \u03b422$___2 = new $c_T2(c.n5, c.o2);
            } else {
              var \u03b422$___1 = new $c_T2(c.n5, c.o2);
              var \u03b422$___2 = new $c_T2(c.q1, c.o2);
            }
            var a0 = \u03b422$___1;
            var a1 = \u03b422$___2;
            sb$4.ad((((((((("<polyline fill=\"none\" stroke=\"black\" points=\"" + $thiz.ac((ncx + (+a0.g())))) + ",") + $thiz.ac((-(ncy + (+a0.h()))))) + " ") + $thiz.ac((ncx + (+a1.g())))) + ",") + $thiz.ac((-(ncy + (+a1.h()))))) + "\"/>\n"));
          }
          $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__genFields$1__scm_StringBuilder__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sr_IntRef__Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$Field__D__D__T__D__T__T__V($thiz, sb$4, g$6, htmlGradId$6, c, ncx, ncy, fontName, fontSize, fontColor, nodeId);
          break matchResult30;
        }
        throw new $c_s_MatchError(x0$2);
      }
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__af$1__D__D__sci_Vector($thiz, rx$1, ry$1) {
  return $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2(rx$1, ry$1), new $c_T2((-rx$1), ry$1), new $c_T2((-rx$1), (-ry$1)), new $c_T2(rx$1, (-ry$1))])));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__afSvg$1__D__D__T2__T($thiz, x$4, cy$1, p) {
  return (($thiz.ac((x$4 + (+p.g()))) + ",") + $thiz.ac((-(cy$1 + (+p.h())))));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__emitNode$1__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__scm_StringBuilder__F2__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Result__sr_IntRef__I__V($thiz, g$9, xs$1, sb$7, tf$2, yOf$1, ranks$1, xlabels$1, htmlGradId$8, i) {
  var n = g$9.cB.l(i);
  if ($f_sc_Iterator__contains__O__Z(new $c_sc_Iterator$$anon$9(new $c_sc_Iterator$$anon$10(n.aK.ag.r("style").o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$41) => $m_s_Predef$().fB($f_T__split__T__I__AT(_$41, ",", 0))))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$42) => $f_T__trim__T(_$42)))), "invis")) {
    var this$5 = xs$1.r(n.br);
    if ((!this$5.c())) {
      (+this$5.d());
      var this$6 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().XB(n, g$9);
      if ((!this$6.c())) {
        this$6.d();
        sb$7.ad((("<!-- " + $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__xml__T__T($m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$(), n.br)) + " -->\n"));
      }
    }
    return (void 0);
  }
  var this$7 = xs$1.r(n.br);
  if ((!this$7.c())) {
    var x0$2 = this$7.d();
    var xPt$1 = (+x0$2);
    var this$8 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().XB(n, g$9);
    if ((!this$8.c())) {
      var x0$3 = this$8.d();
      matchResult31: {
        var \u03b423$___1;
        var \u03b423$___2;
        var x123 = tf$2.R(xPt$1, (+yOf$1.i(ranks$1.i(n.br))));
        if ((x123 !== null)) {
          var \u03b423$___1 = (+x123.g());
          var \u03b423$___2 = (+x123.h());
          break matchResult31;
        }
        throw new $c_s_MatchError(x123);
      }
      var x$2 = (+\u03b423$___1);
      var cy$2 = (+\u03b423$___2);
      var this$11 = n.aK.ag.r("id");
      var this$14 = ((this$11.c() || (this$11.d() !== "")) ? this$11 : $m_s_None$());
      var objId = (this$14.c() ? ("node" + ((1 + i) | 0)) : this$14.d());
      sb$7.ad((("<!-- " + $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__xml__T__T($thiz, n.br)) + " -->\n"));
      sb$7.ad((("<g id=\"" + $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__xml__T__T($thiz, objId)) + "\" class=\"node\">\n"));
      sb$7.ad((("<title>" + $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__xml__T__T($thiz, n.br)) + "</title>\n"));
      var this$16 = n.aK.ag.r("href");
      var this$18 = (this$16.c() ? n.aK.ag.r("URL") : this$16);
      var href = ((this$18.c() || (this$18.d() !== "")) ? this$18 : $m_s_None$());
      var this$22 = n.aK.ag.r("tooltip");
      var explicitTooltip = ((this$22.c() || (this$22.d() !== "")) ? this$22 : $m_s_None$());
      if (explicitTooltip.c()) {
        if ((!href.c())) {
          var $x_1 = $m_s_Option$();
          var this$26 = n.aK.ag.r("label");
          var this$27 = ((this$26.c() || (this$26.d() !== "\\N")) ? this$26 : $m_s_None$());
          var this$28 = $x_1.as((this$27.c() ? n.br : this$27.d()));
          var tooltip = ((this$28.c() || (this$28.d() !== "")) ? this$28 : $m_s_None$());
        } else {
          var tooltip = $m_s_None$();
        }
      } else {
        var tooltip = explicitTooltip;
      }
      var this$32 = n.aK.ag.r("target");
      var target = ((this$32.c() || (this$32.d() !== "")) ? this$32 : $m_s_None$());
      var anchored = ((!href.c()) || (!tooltip.c()));
      if (anchored) {
        var a = $ct_scm_StringBuilder__T__(new $c_scm_StringBuilder(), (("<g id=\"a_" + $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__xml__T__T($thiz, objId)) + "\"><a"));
        if ((!href.c())) {
          var x0$10 = href.d();
          a.ad(((" xlink:href=\"" + $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__xmlHref__T__T($m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$(), x0$10)) + "\""));
        }
        if ((!tooltip.c())) {
          var x0$11 = tooltip.d();
          a.ad(((" xlink:title=\"" + $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__xmlTooltip__T__T($m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$(), x0$11)) + "\""));
        }
        if ((!target.c())) {
          var x0$12 = target.d();
          a.ad(((" target=\"" + $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__xml__T__T($m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$(), x0$12)) + "\""));
        }
        a.ad(">\n");
        sb$7.ad(a.bP.ah);
      }
      matchResult41: {
        var x186 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().PN(n, g$9);
        if ((x186 instanceof $c_s_Some)) {
          var root = x186.J;
          var this$36 = n.aK.ag.r("style");
          var this$40 = (this$36.c() ? $m_s_None$() : new $c_s_Some($m_sci_Set$().af(new $c_sc_Iterator$$anon$9($m_sc_ArrayOps$().u8($f_T__split__T__I__AT(this$36.d(), ",", 0)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$50) => $f_T__trim__T(_$50)))))));
          var styles = (this$40.c() ? $m_sci_Set$EmptySet$() : this$40.d());
          if (styles.E("filled")) {
            var this$43 = n.aK.ag.r("fillcolor");
            var this$45 = (this$43.c() ? n.aK.ag.r("color") : this$43);
            var $x_2 = (this$45.c() ? "lightgrey" : this$45.d());
          } else {
            var $x_2 = "none";
          }
          var fill = $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__fillPaint$1__T__T($thiz, $x_2);
          matchResult32: {
            var \u03b424$___1;
            var \u03b424$___2;
            var this$47 = n.aK.ag.r("color");
            var x126 = $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__strokeSplit$1__T__T2($thiz, (this$47.c() ? "black" : this$47.d()));
            if ((x126 !== null)) {
              var \u03b424$___1 = x126.g();
              var \u03b424$___2 = x126.h();
              break matchResult32;
            }
            throw new $c_s_MatchError(x126);
          }
          var stroke$2 = \u03b424$___1;
          var strokeOp$2 = \u03b424$___2;
          var this$49 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().a4p(n.aK);
          var rPw = (+(this$49.c() ? 1.0 : this$49.d()));
          var rDash = (styles.E("dashed") ? " stroke-dasharray=\"5,2\"" : (styles.E("dotted") ? " stroke-dasharray=\"1,5\"" : ""));
          var rSw = ((((rPw !== 1.0) ? ((" stroke-width=\"" + $m_Lorg_jpablo_graphexplorer_graphviz_output_Output$().dU(rPw)) + "\"") : "") + rDash) + strokeOp$2);
          var _1 = (x$2 + root.n5);
          var _2 = (cy$2 + root.q0);
          var _1$1 = (x$2 + root.q1);
          var _2$1 = (cy$2 + root.o2);
          var this$53 = n.aK.ag.r("shape");
          if (this$53.c()) {
            var $x_3 = $m_s_None$();
          } else {
            var x0$14 = this$53.d();
            var $x_3 = new $c_s_Some(x0$14.toLowerCase());
          }
          if ($x_3.E("mrecord")) {
            var B = (-_2);
            var T = (-_2$1);
            var x$1 = (0.5 * (_1$1 - _1));
            var y = (0.5 * (_2$1 - _2));
            var y$1 = (+Math.min(x$1, y));
            var c = (+Math.min(12.0, y$1));
            var segs = $m_sci_Seq$().kM($m_sr_ScalaRunTime$().f(new ($d_T.r().C)([(((((((((($thiz.ac((_1 + c)) + ",") + $thiz.ac(B)) + " ") + $thiz.ac((_1$1 - c))) + ",") + $thiz.ac(B)) + " ") + $thiz.ac((_1$1 - c))) + ",") + $thiz.ac(B)), (((((((((($thiz.ac((_1$1 - (0.5 * c))) + ",") + $thiz.ac(B)) + " ") + $thiz.ac(_1$1)) + ",") + $thiz.ac((B - (0.5 * c)))) + " ") + $thiz.ac(_1$1)) + ",") + $thiz.ac((B - c))), (((((((((($thiz.ac(_1$1) + ",") + $thiz.ac((B - c))) + " ") + $thiz.ac(_1$1)) + ",") + $thiz.ac((T + c))) + " ") + $thiz.ac(_1$1)) + ",") + $thiz.ac((T + c))), (((((((((($thiz.ac(_1$1) + ",") + $thiz.ac((T + (0.5 * c)))) + " ") + $thiz.ac((_1$1 - (0.5 * c)))) + ",") + $thiz.ac(T)) + " ") + $thiz.ac((_1$1 - c))) + ",") + $thiz.ac(T)), (((((((((($thiz.ac((_1$1 - c)) + ",") + $thiz.ac(T)) + " ") + $thiz.ac((_1 + c))) + ",") + $thiz.ac(T)) + " ") + $thiz.ac((_1 + c))) + ",") + $thiz.ac(T)), (((((((((($thiz.ac((_1 + (0.5 * c))) + ",") + $thiz.ac(T)) + " ") + $thiz.ac(_1)) + ",") + $thiz.ac((T + (0.5 * c)))) + " ") + $thiz.ac(_1)) + ",") + $thiz.ac((T + c))), (((((((((($thiz.ac(_1) + ",") + $thiz.ac((T + c))) + " ") + $thiz.ac(_1)) + ",") + $thiz.ac((B - c))) + " ") + $thiz.ac(_1)) + ",") + $thiz.ac((B - c))), (((((((((($thiz.ac(_1) + ",") + $thiz.ac((B - (0.5 * c)))) + " ") + $thiz.ac((_1 + (0.5 * c)))) + ",") + $thiz.ac(B)) + " ") + $thiz.ac((_1 + c))) + ",") + $thiz.ac(B))])));
            sb$7.ad((((((((((((("<path fill=\"" + fill) + "\" stroke=\"") + stroke$2) + "\"") + rSw) + " d=\"M") + $thiz.ac((_1 + c))) + ",") + $thiz.ac(B)) + "C") + $f_sc_IterableOnceOps__mkString__T__T__T__T(segs, "", " ", "")) + "\"/>\n"));
          } else {
            sb$7.ad((((((((((((((((((((((((((("<polygon fill=\"" + fill) + "\" stroke=\"") + stroke$2) + "\"") + rSw) + " points=\"") + $thiz.ac(_1)) + ",") + $thiz.ac((-_2))) + " ") + $thiz.ac(_1)) + ",") + $thiz.ac((-_2$1))) + " ") + $thiz.ac(_1$1)) + ",") + $thiz.ac((-_2$1))) + " ") + $thiz.ac(_1$1)) + ",") + $thiz.ac((-_2))) + " ") + $thiz.ac(_1)) + ",") + $thiz.ac((-_2))) + "\"/>\n"));
          }
          var $x_4 = n.aK.dL("fontname", "Times-Roman");
          var this$59 = n.aK.ag.r("fontsize");
          if (this$59.c()) {
            var this$63 = $m_s_None$();
          } else {
            var x0$15 = this$59.d();
            var this$63 = ($m_sc_StringParsers$().c1(x0$15) ? new $c_s_Some($m_jl_Double$().bd(x0$15)) : $m_s_None$());
          }
          $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__genFields$1__scm_StringBuilder__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sr_IntRef__Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$Field__D__D__T__D__T__T__V($thiz, sb$7, g$9, htmlGradId$8, root, x$2, cy$2, $x_4, (+(this$63.c() ? $m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$().BF : this$63.d())), n.aK.dL("fontcolor", ""), n.br);
          break matchResult41;
        }
        if (($m_s_None$() === x186)) {
          var x$proxy7 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().X5(x0$3);
          var x$proxy8 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().X4(x0$3);
          var this$65 = n.aK.ag.r("label");
          var this$66 = ((this$65.c() || (this$65.d() !== "\\N")) ? this$65 : $m_s_None$());
          var lbl = (this$66.c() ? n.br : this$66.d());
          var this$68 = n.aK.ag.r("style");
          var this$72 = (this$68.c() ? $m_s_None$() : new $c_s_Some($m_sci_Set$().af(new $c_sc_Iterator$$anon$9($m_sc_ArrayOps$().u8($f_T__split__T__I__AT(this$68.d(), ",", 0)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$55) => $f_T__trim__T(_$55)))))));
          var styles$2 = (this$72.c() ? $m_sci_Set$EmptySet$() : this$72.d());
          var isPoint = n.aK.ag.r("shape").E("point");
          if (isPoint) {
            var this$76 = n.aK.ag.r("color");
            var $x_5 = (this$76.c() ? "black" : this$76.d());
          } else if (styles$2.E("filled")) {
            var this$78 = n.aK.ag.r("fillcolor");
            var this$80 = (this$78.c() ? n.aK.ag.r("color") : this$78);
            var $x_5 = (this$80.c() ? "lightgrey" : this$80.d());
          } else {
            var $x_5 = "none";
          }
          var fill$2 = $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__fillPaint$1__T__T($thiz, $x_5);
          matchResult33: {
            var \u03b427$___1;
            var \u03b427$___2;
            var this$82 = n.aK.ag.r("color");
            var x129 = $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__strokeSplit$1__T__T2($thiz, (this$82.c() ? "black" : this$82.d()));
            if ((x129 !== null)) {
              var \u03b427$___1 = x129.g();
              var \u03b427$___2 = x129.h();
              break matchResult33;
            }
            throw new $c_s_MatchError(x129);
          }
          var stroke$4 = \u03b427$___1;
          var strokeOp$4 = \u03b427$___2;
          var this$84 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().a4p(n.aK);
          var nodePw = (+(this$84.c() ? 1.0 : this$84.d()));
          var nodeDash = (styles$2.E("dashed") ? " stroke-dasharray=\"5,2\"" : (styles$2.E("dotted") ? " stroke-dasharray=\"1,5\"" : ""));
          var swAttr = ((((nodePw !== 1.0) ? ((" stroke-width=\"" + $m_Lorg_jpablo_graphexplorer_graphviz_output_Output$().dU(nodePw)) + "\"") : "") + nodeDash) + strokeOp$4);
          var boxLike = $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_T.r().C)(["box", "rect", "rectangle", "square", "image"])));
          var this$87 = n.aK.ag.r("shape");
          var shapeName = (this$87.c() ? "" : this$87.d());
          var noShape = $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_T.r().C)(["plaintext", "none", "plain"]))).E(shapeName);
          if (noShape) {
            if ((fill$2 !== "none")) {
              sb$7.ad((((("<polygon fill=\"" + fill$2) + "\" stroke=\"none\" points=\"") + $f_sc_IterableOnceOps__mkString__T__T__T__T($p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__af$1__D__D__sci_Vector($thiz, x$proxy7, x$proxy8).bv($p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__af$1__D__D__sci_Vector($thiz, x$proxy7, x$proxy8).t()).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((p) => $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__afSvg$1__D__D__T2__T($thiz, x$2, cy$2, p)))), "", " ", "")) + "\"/>\n"));
            }
          } else if ($m_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$().RR.E(shapeName)) {
            var this$92 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$().aXw($p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__af$1__D__D__sci_Vector($thiz, x$proxy7, x$proxy8), ($m_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$().RR.i(shapeName) | 0), (fill$2 !== "none"));
            var these = this$92;
            while ((!these.c())) {
              var x0$18 = these.t();
              matchResult34: {
                if ((x0$18 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$Op$Poly)) {
                  var x138 = x0$18.By;
                  var x139 = x0$18.Bx;
                  var ps = $f_sc_IterableOnceOps__mkString__T__T__T__T(x138.bv(x138.t()).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2, cy$2) => ((p$1) => $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__afSvg$1__D__D__T2__T($thiz, x$2, cy$2, p$1)))(x$2, cy$2))), "", " ", "");
                  sb$7.ad((((((((("<polygon fill=\"" + (x139 ? fill$2 : "none")) + "\" stroke=\"") + stroke$4) + "\"") + swAttr) + " points=\"") + ps) + "\"/>\n"));
                  break matchResult34;
                }
                if ((x0$18 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$Op$Line)) {
                  var x135 = x0$18.Fn;
                  sb$7.ad((((((("<polyline fill=\"none\" stroke=\"" + stroke$4) + "\"") + swAttr) + " points=\"") + $f_sc_IterableOnceOps__mkString__T__T__T__T(x135.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2, cy$2) => ((p$2) => $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__afSvg$1__D__D__T2__T($thiz, x$2, cy$2, p$2)))(x$2, cy$2))), "", " ", "")) + "\"/>\n"));
                  break matchResult34;
                }
                throw new $c_s_MatchError(x0$18);
              }
              these = these.v();
            }
          } else if ((shapeName === "underline")) {
            var boxPts = $f_sc_IterableOnceOps__mkString__T__T__T__T($p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__af$1__D__D__sci_Vector($thiz, x$proxy7, x$proxy8).bv($p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__af$1__D__D__sci_Vector($thiz, x$proxy7, x$proxy8).t()).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((p$2$1) => $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__afSvg$1__D__D__T2__T($thiz, x$2, cy$2, p$2$1)))), "", " ", "");
            sb$7.ad((((("<polygon fill=\"" + fill$2) + "\" stroke=\"none\" points=\"") + boxPts) + "\"/>\n"));
            sb$7.ad((((((((("<polyline fill=\"none\" stroke=\"" + stroke$4) + "\"") + swAttr) + " points=\"") + $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__afSvg$1__D__D__T2__T($thiz, x$2, cy$2, $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__af$1__D__D__sci_Vector($thiz, x$proxy7, x$proxy8).l(2))) + " ") + $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__afSvg$1__D__D__T2__T($thiz, x$2, cy$2, $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__af$1__D__D__sci_Vector($thiz, x$proxy7, x$proxy8).l(3))) + "\"/>\n"));
          } else if ((shapeName === "Msquare")) {
            var this$100 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$().aNo($p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__af$1__D__D__sci_Vector($thiz, x$proxy7, x$proxy8), 4, (fill$2 !== "none"));
            var these$1 = this$100;
            while ((!these$1.c())) {
              var x0$19 = these$1.t();
              matchResult35: {
                if ((x0$19 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$Op$Poly)) {
                  var x146 = x0$19.By;
                  var x147 = x0$19.Bx;
                  var ps$1 = $f_sc_IterableOnceOps__mkString__T__T__T__T(x146.bv(x146.t()).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2, cy$2) => ((p$3) => $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__afSvg$1__D__D__T2__T($thiz, x$2, cy$2, p$3)))(x$2, cy$2))), "", " ", "");
                  sb$7.ad((((((((("<polygon fill=\"" + (x147 ? fill$2 : "none")) + "\" stroke=\"") + stroke$4) + "\"") + swAttr) + " points=\"") + ps$1) + "\"/>\n"));
                  break matchResult35;
                }
                if ((x0$19 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$Op$Line)) {
                  var x143 = x0$19.Fn;
                  sb$7.ad((((((("<polyline fill=\"none\" stroke=\"" + stroke$4) + "\"") + swAttr) + " points=\"") + $f_sc_IterableOnceOps__mkString__T__T__T__T(x143.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2, cy$2) => ((p$2$2) => $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__afSvg$1__D__D__T2__T($thiz, x$2, cy$2, p$2$2)))(x$2, cy$2))), "", " ", "")) + "\"/>\n"));
                  break matchResult35;
                }
                throw new $c_s_MatchError(x0$19);
              }
              these$1 = these$1.v();
            }
          } else if (boxLike.E(shapeName)) {
            var _1$2 = (x$2 - x$proxy7);
            var _2$2 = (x$2 + x$proxy7);
            var _1$3 = (-(cy$2 + x$proxy8));
            var _2$3 = (-(cy$2 - x$proxy8));
            if (styles$2.E("rounded")) {
              var pts = $m_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$().aRO($p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__af$1__D__D__sci_Vector($thiz, x$proxy7, x$proxy8)).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((p$3$1) => $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__afSvg$1__D__D__T2__T($thiz, x$2, cy$2, p$3$1))));
              sb$7.ad((((((((((("<path fill=\"" + fill$2) + "\" stroke=\"") + stroke$4) + "\"") + swAttr) + " d=\"M") + pts.t()) + "C") + $f_sc_IterableOnceOps__mkString__T__T__T__T(pts.mX(), "", " ", "")) + "\"/>\n"));
            } else {
              var x$4 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().ahs(n);
              var peris = ((x$4 > 1) ? x$4 : 1);
              var k = 0;
              while ((k < peris)) {
                var off = (4.0 * ((((peris - 1) | 0) - k) | 0));
                var _1$4 = (_1$2 + off);
                var _2$4 = (_2$2 - off);
                var _3 = (_1$3 + off);
                var _4 = (_2$3 - off);
                sb$7.ad((((((((((((((((((((((((((("<polygon fill=\"" + ((k === 0) ? fill$2 : "none")) + "\" stroke=\"") + stroke$4) + "\"") + swAttr) + " points=\"") + $thiz.ac(_2$4)) + ",") + $thiz.ac(_3)) + " ") + $thiz.ac(_1$4)) + ",") + $thiz.ac(_3)) + " ") + $thiz.ac(_1$4)) + ",") + $thiz.ac(_4)) + " ") + $thiz.ac(_2$4)) + ",") + $thiz.ac(_4)) + " ") + $thiz.ac(_2$4)) + ",") + $thiz.ac(_3)) + "\"/>\n"));
                k = ((1 + k) | 0);
              }
            }
          } else {
            matchResult37: {
              var x156 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().ahv(n, g$9);
              if ((x156 instanceof $c_s_Some)) {
                var x162 = x156.J;
                if ((shapeName === "cylinder")) {
                  var afc = x162.wG.t();
                  var body = ((("M" + $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__afSvg$1__D__D__T2__T($thiz, x$2, cy$2, afc.l(0))) + "C") + $f_sc_IterableOnceOps__mkString__T__T__T__T(afc.pH(1, afc.C()).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((p$4) => $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__afSvg$1__D__D__T2__T($thiz, x$2, cy$2, p$4)))), "", " ", ""));
                  sb$7.ad((((((((("<path fill=\"" + fill$2) + "\" stroke=\"") + stroke$4) + "\"") + swAttr) + " d=\"") + body) + "\"/>\n"));
                  var y0 = (+afc.l(0).h());
                  var $x_6 = $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([afc.l(0)])));
                  var b = $m_sci_IndexedSeq$().b5();
                  var it = new $c_sci_RangeIterator(1, 1, 5, false);
                  while (it.g0) {
                    var x0$20 = it.hp();
                    b.Y(new $c_T2(afc.l(x0$20).g(), ((2.0 * y0) - (+afc.l(x0$20).h()))));
                  }
                  var cap = $x_6.iR(b.aR()).bv(afc.l(6));
                  var capD = ((("M" + $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__afSvg$1__D__D__T2__T($thiz, x$2, cy$2, cap.l(0))) + "C") + $f_sc_IterableOnceOps__mkString__T__T__T__T(cap.pH(1, cap.C()).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((p$5) => $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__afSvg$1__D__D__T2__T($thiz, x$2, cy$2, p$5)))), "", " ", ""));
                  sb$7.ad((((((("<path fill=\"none\" stroke=\"" + stroke$4) + "\"") + swAttr) + " d=\"") + capD) + "\"/>\n"));
                  break matchResult37;
                }
                if ((shapeName === "Mdiamond")) {
                  var this$122 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$().aNo(x162.wG.t(), 4, (fill$2 !== "none"));
                  var these$2 = this$122;
                  while ((!these$2.c())) {
                    var x0$21 = these$2.t();
                    matchResult36: {
                      if ((x0$21 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$Op$Poly)) {
                        var x154 = x0$21.By;
                        var x155 = x0$21.Bx;
                        var ps$2 = $f_sc_IterableOnceOps__mkString__T__T__T__T(x154.bv(x154.t()).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2, cy$2) => ((p$6) => $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__afSvg$1__D__D__T2__T($thiz, x$2, cy$2, p$6)))(x$2, cy$2))), "", " ", "");
                        sb$7.ad((((((((("<polygon fill=\"" + (x155 ? fill$2 : "none")) + "\" stroke=\"") + stroke$4) + "\"") + swAttr) + " points=\"") + ps$2) + "\"/>\n"));
                        break matchResult36;
                      }
                      if ((x0$21 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$Op$Line)) {
                        var x151 = x0$21.Fn;
                        sb$7.ad((((((("<polyline fill=\"none\" stroke=\"" + stroke$4) + "\"") + swAttr) + " points=\"") + $f_sc_IterableOnceOps__mkString__T__T__T__T(x151.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2, cy$2) => ((p$2$3) => $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__afSvg$1__D__D__T2__T($thiz, x$2, cy$2, p$2$3)))(x$2, cy$2))), "", " ", "")) + "\"/>\n"));
                        break matchResult36;
                      }
                      throw new $c_s_MatchError(x0$21);
                    }
                    these$2 = these$2.v();
                  }
                  break matchResult37;
                }
                $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(x162.wG).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$4) => {
                  var ring = x$1$4.g();
                  var j = (x$1$4.h() | 0);
                  var pts$1 = ring.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
                    var vx = (+x$1$2.g());
                    var vy = (+x$1$2.h());
                    return (($m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$().ac((x$2 + vx)) + ",") + $m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$().ac((-(cy$2 + vy))));
                  })));
                  var closed = $f_sc_IterableOnceOps__mkString__T__T__T__T(pts$1.bv(pts$1.t()), "", " ", "");
                  return sb$7.ad((((((((("<polygon fill=\"" + ((j === 0) ? fill$2 : "none")) + "\" stroke=\"") + stroke$4) + "\"") + swAttr) + " points=\"") + closed) + "\"/>\n"));
                })));
                break matchResult37;
              }
              if (($m_s_None$() === x156)) {
                var peris$2 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().ahs(n);
                var j$1 = 0;
                while ((j$1 < peris$2)) {
                  var off$2 = (4.0 * ((((peris$2 - 1) | 0) - j$1) | 0));
                  sb$7.ad((((((((((((((("<ellipse fill=\"" + fill$2) + "\" stroke=\"") + stroke$4) + "\"") + swAttr) + " cx=\"") + $thiz.ac(x$2)) + "\" cy=\"") + $thiz.ac((-cy$2))) + "\" rx=\"") + $thiz.ac((x$proxy7 - off$2))) + "\" ry=\"") + $thiz.ac((x$proxy8 - off$2))) + "\"/>\n"));
                  j$1 = ((1 + j$1) | 0);
                }
                if ((shapeName === "Mcircle")) {
                  var px = (0.6614 * x$proxy7);
                  var py = (0.75 * x$proxy8);
                  sb$7.ad(((((((((("<polyline fill=\"none\" stroke=\"" + stroke$4) + "\"") + swAttr) + " points=\"") + ($thiz.ac((x$2 + px)) + ",")) + $thiz.ac((-(cy$2 + py)))) + " ") + (($thiz.ac((x$2 + (-px))) + ",") + $thiz.ac((-(cy$2 + py))))) + "\"/>\n"));
                  var _2$6 = (-py);
                  var $x_8 = $thiz.ac((x$2 + px));
                  var $x_7 = $thiz.ac((-(cy$2 + _2$6)));
                  var _1$7 = (-px);
                  var _2$7 = (-py);
                  sb$7.ad((((((((("<polyline fill=\"none\" stroke=\"" + stroke$4) + "\"") + swAttr) + " points=\"") + (($x_8 + ",") + $x_7)) + " ") + (($thiz.ac((x$2 + _1$7)) + ",") + $thiz.ac((-(cy$2 + _2$7))))) + "\"/>\n"));
                  break matchResult37;
                } else {
                  break matchResult37;
                }
              }
              throw new $c_s_MatchError(x156);
            }
          }
          if ((!noShape)) {
            var this$135 = n.aK.ag.r("image");
            var this$138 = ((this$135.c() || (this$135.d() !== "")) ? this$135 : $m_s_None$());
            if ((!this$138.c())) {
              var x0$23 = this$138.d();
              var this$139 = g$9.mj.r(x0$23);
              if ((!this$139.c())) {
                var x0$24 = this$139.d();
                matchResult38: {
                  var \u03b431$___1;
                  var \u03b431$___2;
                  var \u03b431$___3;
                  var \u03b431$___4;
                  var x163 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().ahv(n, g$9);
                  if ((x163 instanceof $c_s_Some)) {
                    var poly = x163.J;
                    var vx$1 = poly.wG.t().L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$57) => (+_$57.g()))));
                    var vy$1 = poly.wG.t().L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$58) => (+_$58.h()))));
                    var \u03b431$___1 = (x$2 + (+$f_sc_IterableOnceOps__min__s_math_Ordering__O(vx$1, $m_s_math_Ordering$DeprecatedDoubleOrdering$())));
                    var \u03b431$___2 = (x$2 + (+$f_sc_IterableOnceOps__max__s_math_Ordering__O(vx$1, $m_s_math_Ordering$DeprecatedDoubleOrdering$())));
                    var \u03b431$___3 = (cy$2 + (+$f_sc_IterableOnceOps__min__s_math_Ordering__O(vy$1, $m_s_math_Ordering$DeprecatedDoubleOrdering$())));
                    var \u03b431$___4 = (cy$2 + (+$f_sc_IterableOnceOps__max__s_math_Ordering__O(vy$1, $m_s_math_Ordering$DeprecatedDoubleOrdering$())));
                    break matchResult38;
                  }
                  if (($m_s_None$() === x163)) {
                    var \u03b431$___1 = (x$2 - x$proxy7);
                    var \u03b431$___2 = (x$2 + x$proxy7);
                    var \u03b431$___3 = (cy$2 - x$proxy8);
                    var \u03b431$___4 = (cy$2 + x$proxy8);
                    break matchResult38;
                  }
                  throw new $c_s_MatchError(x163);
                }
                var bllx = (+\u03b431$___1);
                var burx = (+\u03b431$___2);
                var blly = (+\u03b431$___3);
                var bury = (+\u03b431$___4);
                var $x_12 = $m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$();
                var $x_11 = x0$24.bbR();
                var $x_10 = x0$24.b2l();
                var $x_9 = n.aK.ag.r("imagescale");
                var this$144 = n.aK.ag.r("imagepos");
                sb$7.ad($x_12.aTf(x0$23, bllx, burx, blly, bury, $x_11, $x_10, $x_9, (this$144.c() ? "mc" : this$144.d())));
              }
            }
          }
          if (n.aK.n7.E("label")) {
            var x169 = $m_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$().mU(n.aK.dL("label", ""));
            if ((x169 instanceof $c_s_Some)) {
              var x182 = x169.J;
              if ((x182 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Text)) {
                var x185 = x182.oQ;
                var this$148 = n.aK.ag.r("fontsize");
                if (this$148.c()) {
                  var this$152 = $m_s_None$();
                } else {
                  var x0$25 = this$148.d();
                  var this$152 = ($m_sc_StringParsers$().c1(x0$25) ? new $c_s_Some($m_jl_Double$().bd(x0$25)) : $m_s_None$());
                }
                var nfs = (+(this$152.c() ? 14.0 : this$152.d()));
                var nfn = n.aK.dL("fontname", "Times-Roman");
                var bw = (+$m_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$().a4W(x185, nfs, nfn).g());
                var this$154 = n.aK.ag.r("fontcolor");
                sb$7.ad($p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__htmlText$1__D__D__Lorg_jpablo_graphexplorer_graphviz_html_HtmlText__T__D__Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign__D__T__T($thiz, x$2, cy$2, x185, (this$154.c() ? "" : this$154.d()), bw, $s_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$__Center__Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign(), nfs, nfn));
                break matchResult41;
              }
              if ((x182 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Table)) {
                var x180 = x182.k8;
                var this$157 = n.aK.ag.r("fontsize");
                if (this$157.c()) {
                  var this$161 = $m_s_None$();
                } else {
                  var x0$26 = this$157.d();
                  var this$161 = ($m_sc_StringParsers$().c1(x0$26) ? new $c_s_Some($m_jl_Double$().bd(x0$26)) : $m_s_None$());
                }
                var nfs$2 = (+(this$161.c() ? 14.0 : this$161.d()));
                var nfn$2 = n.aK.dL("fontname", "Times-Roman");
                var this$163 = n.aK.ag.r("fontcolor");
                var $x_14 = (this$163.c() ? "" : this$163.d());
                var $x_13 = $m_s_None$();
                var this$165 = n.aK.ag.r("pencolor");
                var this$168 = ((this$165.c() || (this$165.d() !== "")) ? this$165 : $m_s_None$());
                var this$170 = (this$168.c() ? n.aK.ag.r("color") : this$168);
                sb$7.ad($p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__htmlTable$1__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sr_IntRef__D__D__Lorg_jpablo_graphexplorer_graphviz_html_HtmlTable__T__D__T__s_Option__T__T($thiz, g$9, htmlGradId$8, x$2, cy$2, x180, $x_14, nfs$2, nfn$2, $x_13, (this$170.c() ? "black" : this$170.d())));
                break matchResult41;
              }
              if ((x182 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Image)) {
                var x174 = x182.wy;
                var this$172 = g$9.mj.r(x174);
                if ((!this$172.c())) {
                  var x0$28 = this$172.d();
                  matchResult39: {
                    var \u03b432$___1;
                    var \u03b432$___2;
                    var x166 = x0$28.aNz();
                    if ((x166 !== null)) {
                      var \u03b432$___1 = (+x166.g());
                      var \u03b432$___2 = (+x166.h());
                      break matchResult39;
                    }
                    throw new $c_s_MatchError(x166);
                  }
                  var dw$2 = (+\u03b432$___1);
                  var dh$2 = (+\u03b432$___2);
                  sb$7.ad((((((((((("<image xlink:href=\"" + x174) + "\" width=\"") + $m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$().Am(dw$2)) + "px\" height=\"") + $m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$().Am(dh$2)) + "px\" preserveAspectRatio=\"xMinYMin meet\" x=\"") + $m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$().Am((x$2 - (0.5 * dw$2)))) + "\" y=\"") + $m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$().Am((-(cy$2 + (0.5 * dh$2))))) + "\"/>\n"));
                  break matchResult41;
                } else {
                  break matchResult41;
                }
              }
            }
            if (($m_s_None$() === x169)) {
              if ((lbl !== "")) {
                var this$177 = n.aK.ag.r("fontcolor");
                var $x_17 = (this$177.c() ? "" : this$177.d());
                var $x_16 = n.br;
                var $x_15 = n.aK.dL("fontname", "Times-Roman");
                var this$179 = n.aK.ag.r("fontsize");
                if (this$179.c()) {
                  var this$183 = $m_s_None$();
                } else {
                  var x0$29 = this$179.d();
                  var this$183 = ($m_sc_StringParsers$().c1(x0$29) ? new $c_s_Some($m_jl_Double$().bd(x0$29)) : $m_s_None$());
                }
                sb$7.ad($p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__textLines$1__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D__D__T__T__T__T__D__C__D__T($thiz, g$9, x$2, cy$2, lbl, $x_17, $x_16, $x_15, (+(this$183.c() ? $m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$().BF : this$183.d())), 99, 0.0));
                break matchResult41;
              } else {
                break matchResult41;
              }
            }
            throw new $c_s_MatchError(x169);
          } else if (((lbl !== "") && (!isPoint))) {
            var this$187 = n.aK.ag.r("labelloc");
            if (this$187.c()) {
              var this$190 = $m_s_None$();
            } else {
              var x0$30 = this$187.d();
              var this$189 = $m_sc_StringOps$().X8(x0$30);
              var this$190 = new $c_s_Some($bC($uC((this$189.c() ? $bC(99) : this$189.d()))));
            }
            if (this$190.c()) {
              var $x_18 = true;
            } else {
              var x0$31 = this$190.d();
              var c$1 = $uC(x0$31);
              var $x_18 = ((c$1 === 98) || (c$1 === 116));
            }
            if ($x_18) {
              var this$191 = this$190;
            } else {
              var this$191 = $m_s_None$();
            }
            var va = $uC((this$191.c() ? $bC(99) : this$191.d()));
            var this$193 = n.aK.ag.r("fontcolor");
            var $x_21 = (this$193.c() ? "" : this$193.d());
            var $x_20 = n.br;
            var $x_19 = n.aK.dL("fontname", "Times-Roman");
            var this$195 = n.aK.ag.r("fontsize");
            if (this$195.c()) {
              var this$199 = $m_s_None$();
            } else {
              var x0$32 = this$195.d();
              var this$199 = ($m_sc_StringParsers$().c1(x0$32) ? new $c_s_Some($m_jl_Double$().bd(x0$32)) : $m_s_None$());
            }
            sb$7.ad($p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__textLines$1__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D__D__T__T__T__T__D__C__D__T($thiz, g$9, x$2, cy$2, lbl, $x_21, $x_20, $x_19, (+(this$199.c() ? $m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$().BF : this$199.d())), va, ((va !== 99) ? $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().b3Y(n, g$9) : 0.0)));
            break matchResult41;
          } else {
            break matchResult41;
          }
        }
        throw new $c_s_MatchError(x186);
      }
      var this$201 = n.aK.ag.r("xlabel");
      var this$204 = ((this$201.c() || (this$201.d() !== "")) ? this$201 : $m_s_None$());
      if ((!this$204.c())) {
        var x0$34 = this$204.d();
        var this$205 = xlabels$1.Fr.r(n.br);
        if ((!this$205.c())) {
          var x0$35 = this$205.d();
          matchResult42: {
            var \u03b433$___1;
            var \u03b433$___2;
            var x189 = tf$2.R(x0$35.uD, x0$35.uE);
            if ((x189 !== null)) {
              var \u03b433$___1 = (+x189.g());
              var \u03b433$___2 = (+x189.h());
              break matchResult42;
            }
            throw new $c_s_MatchError(x189);
          }
          var this$208 = n.aK.ag.r("fontcolor");
          sb$7.ad($p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__textLines$1__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D__D__T__T__T__T__D__C__D__T($thiz, g$9, (+\u03b433$___1), (+\u03b433$___2), x0$34, (this$208.c() ? "" : this$208.d()), n.br, n.aK.dL("fontname", "Times-Roman"), $thiz.BF, 99, 0.0));
        }
      }
      if (anchored) {
        sb$7.ad("</a>\n</g>\n");
      }
      sb$7.ad("</g>\n");
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__edgeAnchorOpen$1__scm_StringBuilder__T__s_Option__s_Option__s_Option__V($thiz, sb$23, id, url, tip, tgt) {
  var a = $ct_scm_StringBuilder__T__(new $c_scm_StringBuilder(), (("<g id=\"a_" + $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__xml__T__T($thiz, id)) + "\"><a"));
  if ((!url.c())) {
    var x0 = url.d();
    a.ad(((" xlink:href=\"" + $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__xmlHref__T__T($m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$(), x0)) + "\""));
  }
  if ((!tip.c())) {
    var x0$1 = tip.d();
    a.ad(((" xlink:title=\"" + $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__xmlTooltip__T__T($m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$(), x0$1)) + "\""));
  }
  if ((!tgt.c())) {
    var x0$2 = tgt.d();
    a.ad(((" target=\"" + $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__xml__T__T($m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$(), x0$2)) + "\""));
  }
  a.ad(">\n");
  sb$23.ad(a.bP.ah);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__offP$1__D__D__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__T2($thiz, SepE$1, EpsE$1, p, q) {
  var x = (p.W - q.W);
  var y = (p.a6 - q.a6);
  var x$1 = (((x * x) + (y * y)) + EpsE$1);
  var d = (SepE$1 / (+Math.sqrt(x$1)));
  return new $c_T2((y * d), ((-x) * d));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__offQR$1__D__D__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__T2($thiz, EpsE$2, SepE$2, p, q, r, s) {
  var x = (q.W - r.W);
  var y = (q.a6 - r.a6);
  var len = $m_jl_Math$().ga(x, y);
  if ((len < EpsE$2)) {
    x = (p.W - s.W);
    y = (p.a6 - s.a6);
    var x$2 = (((x * x) + (y * y)) + EpsE$2);
    len = (+Math.sqrt(x$2));
  }
  var d = (SepE$2 / len);
  return new $c_T2((y * d), ((-x) * d));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__pt$5__T2__T($thiz, p) {
  return (($thiz.ac((+p.g())) + ",") + $thiz.ac((-(+p.h()))));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__drawArrow$1__F2__Lorg_jpablo_graphexplorer_graphviz_model_REdge__scm_StringBuilder__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__I__T__V($thiz, tf$10, e$6, sb$25, attach, base, flag, aCol) {
  matchResult46: {
    var \u03b438$___1;
    var \u03b438$___2;
    var x201 = tf$10.R(attach.W, attach.a6);
    if ((x201 !== null)) {
      var \u03b438$___1 = (+x201.g());
      var \u03b438$___2 = (+x201.h());
      break matchResult46;
    }
    throw new $c_s_MatchError(x201);
  }
  var tip = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY((+\u03b438$___1), (+\u03b438$___2));
  if (($m_jl_Math$().ga((base.W - tip.W), (base.a6 - tip.a6)) > 1.0E-9)) {
    var this$4 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().a4p(e$6.b4);
    var pw = (+(this$4.c() ? 1.0 : this$4.d()));
    var this$6 = e$6.b4.ag.r("arrowsize");
    if (this$6.c()) {
      var this$10 = $m_s_None$();
    } else {
      var x0 = this$6.d();
      var this$10 = ($m_sc_StringParsers$().c1(x0) ? new $c_s_Some($m_jl_Double$().bd(x0)) : $m_s_None$());
    }
    var as = (+(this$10.c() ? 1.0 : this$10.d()));
    matchResult47: {
      var \u03b439$___1;
      var \u03b439$___2;
      var x204 = $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__strokeSplit$1__T__T2($thiz, aCol);
      if ((x204 !== null)) {
        var \u03b439$___1 = x204.g();
        var \u03b439$___2 = x204.h();
        break matchResult47;
      }
      throw new $c_s_MatchError(x204);
    }
    var aPen$2 = \u03b439$___1;
    var aPenOp0$2 = \u03b439$___2;
    var aFill = $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__fillPaint$1__T__T($thiz, aCol);
    var aPenOp = (((pw !== 1.0) ? ((" stroke-width=\"" + $m_Lorg_jpablo_graphexplorer_graphviz_output_Output$().dU(pw)) + "\"") : "") + aPenOp0$2);
    var this$14 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$();
    var p0 = new $c_T2(tip.W, tip.a6);
    var _1$1 = base.W;
    var _2$1 = base.a6;
    var dx = (_1$1 - (+p0.bi));
    var dy = (_2$1 - (+p0.be));
    var s = (this$14.wC / ($m_jl_Math$().ga(dx, dy) + this$14.Ky));
    var _1$2 = ((dx + ((dx >= 0.0) ? this$14.Ky : (-this$14.Ky))) * s);
    var _2$2 = ((dy + ((dy >= 0.0) ? this$14.Ky : (-this$14.Ky))) * s);
    var out = new $c_scm_ListBuffer();
    var p = p0;
    var i = 0;
    var stop = false;
    while (((!stop) && (i < this$14.Rx))) {
      var f = ((flag >> Math.imul(i, this$14.Rw)) & this$14.a7Q);
      if ((f === this$14.lC)) {
        stop = true;
      } else {
        matchResult28: {
          var \u03b410$___1;
          var \u03b410$___2;
          var p$1 = p;
          var tpe = (f & this$14.ZI);
          if ((tpe === this$14.lC)) {
            var x62 = new $c_T2($m_sci_Nil$(), p$1);
          } else {
            var f$1 = ($p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__lenfact__I__D(this$14, tpe) * as);
            var u = new $c_T2((_1$2 * f$1), (_2$2 * f$1));
            var x62 = ((this$14.nV === tpe) ? $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__typeNormal__T2__T2__D__I__T2(this$14, p$1, u, pw, f) : ((this$14.Kz === tpe) ? $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__typeCrow__T2__T2__D__D__I__T2(this$14, p$1, u, as, pw, f) : ((this$14.RB === tpe) ? $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__typeTee__T2__T2__D__I__T2(this$14, p$1, u, pw, f) : ((this$14.ZH === tpe) ? $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__typeBox__T2__T2__D__I__T2(this$14, p$1, u, pw, f) : ((this$14.Rz === tpe) ? $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__typeDiamond__T2__T2__D__I__T2(this$14, p$1, u, pw, f) : ((this$14.RA === tpe) ? $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__typeDot__T2__T2__D__I__T2(this$14, p$1, u, pw, f) : ((this$14.Ry === tpe) ? $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__typeCurve__T2__T2__D__I__T2(this$14, p$1, u, pw, f) : ((this$14.Fa === tpe) ? $p_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$__typeGap__T2__T2__T2(this$14, p$1, u) : new $c_T2($m_sci_Nil$(), p$1)))))))));
          }
          if ((x62 !== null)) {
            var \u03b410$___1 = x62.g();
            var \u03b410$___2 = x62.h();
            break matchResult28;
          }
          throw new $c_s_MatchError(x62);
        }
        var prims$2 = \u03b410$___1;
        var np$2 = \u03b410$___2;
        out.aeB(prims$2);
        p = np$2;
        i = ((1 + i) | 0);
      }
    }
    var this$22 = out.bM();
    var these = this$22;
    while ((!these.c())) {
      var x0$1 = these.t();
      matchResult48: {
        if ((x0$1 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Polygon)) {
          var x221 = x0$1.KE;
          var x222 = x0$1.KD;
          var $x_12 = $m_s_Predef$();
          var f$2 = ((p$2) => $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__pt$5__T2__T($thiz, p$2));
          var len$1 = x221.a.length;
          var ys = new ($d_T.r().C)(len$1);
          if ((len$1 > 0)) {
            var i$1 = 0;
            if ((x221 !== null)) {
              while ((i$1 < len$1)) {
                var $x_1 = i$1;
                var x0$2 = x221.a[i$1];
                ys.a[$x_1] = f$2(x0$2);
                i$1 = ((1 + i$1) | 0);
              }
            } else if ((x221 instanceof $ac_I)) {
              while ((i$1 < len$1)) {
                var $x_2 = i$1;
                var x0$3 = x221.a[i$1];
                ys.a[$x_2] = f$2(x0$3);
                i$1 = ((1 + i$1) | 0);
              }
            } else if ((x221 instanceof $ac_D)) {
              while ((i$1 < len$1)) {
                var $x_3 = i$1;
                var x0$4 = x221.a[i$1];
                ys.a[$x_3] = f$2(x0$4);
                i$1 = ((1 + i$1) | 0);
              }
            } else if ((x221 instanceof $ac_J)) {
              while ((i$1 < len$1)) {
                var $x_6 = i$1;
                var $x_4 = x221.a;
                var $x_5 = (i$1 << 1);
                var x0$5_$_lo = $x_4[$x_5];
                var x0$5_$_hi = $x_4[(($x_5 + 1) | 0)];
                ys.a[$x_6] = f$2($bL(x0$5_$_lo, x0$5_$_hi));
                i$1 = ((1 + i$1) | 0);
              }
            } else if ((x221 instanceof $ac_F)) {
              while ((i$1 < len$1)) {
                var $x_7 = i$1;
                var x0$6 = x221.a[i$1];
                ys.a[$x_7] = f$2(x0$6);
                i$1 = ((1 + i$1) | 0);
              }
            } else if ((x221 instanceof $ac_C)) {
              while ((i$1 < len$1)) {
                var $x_8 = i$1;
                var x0$7 = x221.a[i$1];
                ys.a[$x_8] = f$2($bC(x0$7));
                i$1 = ((1 + i$1) | 0);
              }
            } else if ((x221 instanceof $ac_B)) {
              while ((i$1 < len$1)) {
                var $x_9 = i$1;
                var x0$8 = x221.a[i$1];
                ys.a[$x_9] = f$2(x0$8);
                i$1 = ((1 + i$1) | 0);
              }
            } else if ((x221 instanceof $ac_S)) {
              while ((i$1 < len$1)) {
                var $x_10 = i$1;
                var x0$9 = x221.a[i$1];
                ys.a[$x_10] = f$2(x0$9);
                i$1 = ((1 + i$1) | 0);
              }
            } else if ((x221 instanceof $ac_Z)) {
              while ((i$1 < len$1)) {
                var $x_11 = i$1;
                var x0$10 = x221.a[i$1];
                ys.a[$x_11] = f$2(x0$10);
                i$1 = ((1 + i$1) | 0);
              }
            } else {
              throw new $c_s_MatchError(x221);
            }
          }
          var x$3 = $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__pt$5__T2__T($thiz, x221.a[0]);
          var newLength = ((1 + ys.a.length) | 0);
          if ($d_T.R($d_T)) {
            var dest$1 = $m_ju_Arrays$().WA(ys, newLength, $d_T.r().l());
          } else {
            var dest = new ($d_T.r().C)(newLength);
            $m_s_Array$().fv(ys, 0, dest, 0, ys.a.length);
            var dest$1 = dest;
          }
          $m_sr_ScalaRunTime$().kn(dest$1, ys.a.length, x$3);
          var poly = $f_sc_IterableOnceOps__mkString__T__T__T__T($x_12.fB(dest$1), "", " ", "");
          sb$25.ad((((((((("<polygon fill=\"" + (x222 ? aFill : "none")) + "\" stroke=\"") + aPen$2) + "\"") + aPenOp) + " points=\"") + poly) + "\"/>\n"));
          break matchResult48;
        }
        if ((x0$1 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Polyline)) {
          var x218 = x0$1.RD;
          var $x_24 = $m_s_Predef$();
          var f$3 = ((p$2$1) => $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__pt$5__T2__T($thiz, p$2$1));
          var len$2 = x218.a.length;
          var ys$1 = new ($d_T.r().C)(len$2);
          if ((len$2 > 0)) {
            var i$2 = 0;
            if ((x218 !== null)) {
              while ((i$2 < len$2)) {
                var $x_13 = i$2;
                var x0$11 = x218.a[i$2];
                ys$1.a[$x_13] = f$3(x0$11);
                i$2 = ((1 + i$2) | 0);
              }
            } else if ((x218 instanceof $ac_I)) {
              while ((i$2 < len$2)) {
                var $x_14 = i$2;
                var x0$12 = x218.a[i$2];
                ys$1.a[$x_14] = f$3(x0$12);
                i$2 = ((1 + i$2) | 0);
              }
            } else if ((x218 instanceof $ac_D)) {
              while ((i$2 < len$2)) {
                var $x_15 = i$2;
                var x0$13 = x218.a[i$2];
                ys$1.a[$x_15] = f$3(x0$13);
                i$2 = ((1 + i$2) | 0);
              }
            } else if ((x218 instanceof $ac_J)) {
              while ((i$2 < len$2)) {
                var $x_18 = i$2;
                var $x_16 = x218.a;
                var $x_17 = (i$2 << 1);
                var x0$14_$_lo = $x_16[$x_17];
                var x0$14_$_hi = $x_16[(($x_17 + 1) | 0)];
                ys$1.a[$x_18] = f$3($bL(x0$14_$_lo, x0$14_$_hi));
                i$2 = ((1 + i$2) | 0);
              }
            } else if ((x218 instanceof $ac_F)) {
              while ((i$2 < len$2)) {
                var $x_19 = i$2;
                var x0$15 = x218.a[i$2];
                ys$1.a[$x_19] = f$3(x0$15);
                i$2 = ((1 + i$2) | 0);
              }
            } else if ((x218 instanceof $ac_C)) {
              while ((i$2 < len$2)) {
                var $x_20 = i$2;
                var x0$16 = x218.a[i$2];
                ys$1.a[$x_20] = f$3($bC(x0$16));
                i$2 = ((1 + i$2) | 0);
              }
            } else if ((x218 instanceof $ac_B)) {
              while ((i$2 < len$2)) {
                var $x_21 = i$2;
                var x0$17 = x218.a[i$2];
                ys$1.a[$x_21] = f$3(x0$17);
                i$2 = ((1 + i$2) | 0);
              }
            } else if ((x218 instanceof $ac_S)) {
              while ((i$2 < len$2)) {
                var $x_22 = i$2;
                var x0$18 = x218.a[i$2];
                ys$1.a[$x_22] = f$3(x0$18);
                i$2 = ((1 + i$2) | 0);
              }
            } else if ((x218 instanceof $ac_Z)) {
              while ((i$2 < len$2)) {
                var $x_23 = i$2;
                var x0$19 = x218.a[i$2];
                ys$1.a[$x_23] = f$3(x0$19);
                i$2 = ((1 + i$2) | 0);
              }
            } else {
              throw new $c_s_MatchError(x218);
            }
          }
          sb$25.ad((((((("<polyline fill=\"none\" stroke=\"" + aPen$2) + "\"") + aPenOp) + " points=\"") + $f_sc_IterableOnceOps__mkString__T__T__T__T($x_24.fB(ys$1), "", " ", "")) + "\"/>\n"));
          break matchResult48;
        }
        if ((x0$1 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Ellipse)) {
          var x213 = x0$1.KA;
          var x214 = x0$1.KC;
          sb$25.ad((((((((((((((("<ellipse fill=\"" + (x0$1.KB ? aFill : "none")) + "\" stroke=\"") + aPen$2) + "\"") + aPenOp) + " cx=\"") + $thiz.ac((+x213.g()))) + "\" cy=\"") + $thiz.ac((-(+x213.h())))) + "\" rx=\"") + $thiz.ac(x214)) + "\" ry=\"") + $thiz.ac(x214)) + "\"/>\n"));
          break matchResult48;
        }
        if ((x0$1 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Curve)) {
          var x210 = x0$1.RC;
          var $x_36 = $m_s_Predef$();
          var xs = $m_sc_ArrayOps$().aSG(x210);
          var f$4 = ((p$3) => $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__pt$5__T2__T($thiz, p$3));
          var len$3 = xs.a.length;
          var ys$2 = new ($d_T.r().C)(len$3);
          if ((len$3 > 0)) {
            var i$3 = 0;
            if ((xs !== null)) {
              while ((i$3 < len$3)) {
                var $x_25 = i$3;
                var x0$20 = xs.a[i$3];
                ys$2.a[$x_25] = f$4(x0$20);
                i$3 = ((1 + i$3) | 0);
              }
            } else if ((xs instanceof $ac_I)) {
              while ((i$3 < len$3)) {
                var $x_26 = i$3;
                var x0$21 = xs.a[i$3];
                ys$2.a[$x_26] = f$4(x0$21);
                i$3 = ((1 + i$3) | 0);
              }
            } else if ((xs instanceof $ac_D)) {
              while ((i$3 < len$3)) {
                var $x_27 = i$3;
                var x0$22 = xs.a[i$3];
                ys$2.a[$x_27] = f$4(x0$22);
                i$3 = ((1 + i$3) | 0);
              }
            } else if ((xs instanceof $ac_J)) {
              while ((i$3 < len$3)) {
                var $x_30 = i$3;
                var $x_28 = xs.a;
                var $x_29 = (i$3 << 1);
                var x0$23_$_lo = $x_28[$x_29];
                var x0$23_$_hi = $x_28[(($x_29 + 1) | 0)];
                ys$2.a[$x_30] = f$4($bL(x0$23_$_lo, x0$23_$_hi));
                i$3 = ((1 + i$3) | 0);
              }
            } else if ((xs instanceof $ac_F)) {
              while ((i$3 < len$3)) {
                var $x_31 = i$3;
                var x0$24 = xs.a[i$3];
                ys$2.a[$x_31] = f$4(x0$24);
                i$3 = ((1 + i$3) | 0);
              }
            } else if ((xs instanceof $ac_C)) {
              while ((i$3 < len$3)) {
                var $x_32 = i$3;
                var x0$25 = xs.a[i$3];
                ys$2.a[$x_32] = f$4($bC(x0$25));
                i$3 = ((1 + i$3) | 0);
              }
            } else if ((xs instanceof $ac_B)) {
              while ((i$3 < len$3)) {
                var $x_33 = i$3;
                var x0$26 = xs.a[i$3];
                ys$2.a[$x_33] = f$4(x0$26);
                i$3 = ((1 + i$3) | 0);
              }
            } else if ((xs instanceof $ac_S)) {
              while ((i$3 < len$3)) {
                var $x_34 = i$3;
                var x0$27 = xs.a[i$3];
                ys$2.a[$x_34] = f$4(x0$27);
                i$3 = ((1 + i$3) | 0);
              }
            } else if ((xs instanceof $ac_Z)) {
              while ((i$3 < len$3)) {
                var $x_35 = i$3;
                var x0$28 = xs.a[i$3];
                ys$2.a[$x_35] = f$4(x0$28);
                i$3 = ((1 + i$3) | 0);
              }
            } else {
              throw new $c_s_MatchError(xs);
            }
          }
          var body = $f_sc_IterableOnceOps__mkString__T__T__T__T($x_36.fB(ys$2), "", " ", "");
          sb$25.ad((((((((("<path fill=\"none\" stroke=\"" + aPen$2) + "\"") + aPenOp) + " d=\"M") + $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__pt$5__T2__T($thiz, x210.a[0])) + "C") + body) + "\"/>\n"));
          break matchResult48;
        }
        throw new $c_s_MatchError(x0$1);
      }
      these = these.v();
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__attachment$1__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_model_REdge__scm_StringBuilder__D__D__D__D__T__V($thiz, pts$5, e$9, sb$29, lpx, lpy, w, h, text) {
  _return: {
    var len = text.length;
    var i = 0;
    while ((i < len)) {
      if ((!$m_jl_UnicodeData$().E7(text.charCodeAt(i)))) {
        var $x_1 = i;
        break _return;
      }
      i = ((1 + i) | 0);
    }
    var $x_1 = (-1);
  }
  if (($x_1 !== (-1))) {
    var _1 = (lpx + (0.5 * w));
    var _2 = (lpy - (0.5 * h));
    var elem = 0;
    elem = 0;
    var elem$1 = 0.0;
    elem$1 = 0.0;
    var end = pts$5.C();
    var isEmpty = (end <= 0);
    var scala$collection$immutable$Range$$lastElement = ((end - 1) | 0);
    if ((!isEmpty)) {
      var i$1 = 0;
      while (true) {
        var x0$1 = i$1;
        var x = pts$5.l(x0$1).W;
        var y = pts$5.l(x0$1).a6;
        var dx = (x - lpx);
        var dy = (y - lpy);
        var d = ((dx * dx) + (dy * dy));
        if (((x0$1 === 0) || (d < elem$1))) {
          elem = x0$1;
          elem$1 = d;
        }
        if ((i$1 === scala$collection$immutable$Range$$lastElement)) {
          break;
        }
        i$1 = ((1 + i$1) | 0);
      }
    }
    if ((elem === ((pts$5.C() - 1) | 0))) {
      elem = ((elem - 1) | 0);
    }
    var j = Math.imul(3, ((elem / 3) | 0));
    var c = new ($d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY.r().C)([pts$5.l(j), pts$5.l(((1 + j) | 0)), pts$5.l(((2 + j) | 0)), pts$5.l(((3 + j) | 0))]);
    var low = 0.0;
    var high = 1.0;
    var x$1 = c.a[0].W;
    var y$1 = c.a[0].a6;
    var dx$1 = (x$1 - lpx);
    var dy$1 = (y$1 - lpy);
    var dlow2 = ((dx$1 * dx$1) + (dy$1 * dy$1));
    var x$2 = c.a[3].W;
    var y$2 = c.a[3].a6;
    var dx$2 = (x$2 - lpx);
    var dy$2 = (y$2 - lpy);
    var dhigh2 = ((dx$2 * dx$2) + (dy$2 * dy$2));
    var pt2 = new $c_T2(0.0, 0.0);
    var going = true;
    while (going) {
      var t = (0.5 * (low + high));
      pt2 = $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__at$1__ALorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__D__T2($thiz, c, t);
      var x$3 = (dlow2 - dhigh2);
      if (((+Math.abs(x$3)) < 1.0)) {
        var $x_2 = true;
      } else {
        var x$4 = (high - low);
        var $x_2 = ((+Math.abs(x$4)) < 1.0E-5);
      }
      if ($x_2) {
        going = false;
      } else if ((dlow2 < dhigh2)) {
        high = t;
        var x$5 = (+pt2.g());
        var y$3 = (+pt2.h());
        var dx$3 = (x$5 - lpx);
        var dy$3 = (y$3 - lpy);
        dhigh2 = ((dx$3 * dx$3) + (dy$3 * dy$3));
      } else {
        low = t;
        var x$6 = (+pt2.g());
        var y$4 = (+pt2.h());
        var dx$4 = (x$6 - lpx);
        var dy$4 = (y$4 - lpy);
        dlow2 = ((dx$4 * dx$4) + (dy$4 * dy$4));
      }
    }
    var cl = pt2;
    matchResult50: {
      var \u03b441$___1;
      var \u03b441$___2;
      var this$19 = e$9.b4.ag.r("fontcolor");
      var this$22 = ((this$19.c() || (this$19.d() !== "")) ? this$19 : $m_s_None$());
      var x226 = $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__strokeSplit$1__T__T2($thiz, (this$22.c() ? "black" : this$22.d()));
      if ((x226 !== null)) {
        var \u03b441$___1 = x226.g();
        var \u03b441$___2 = x226.h();
        break matchResult50;
      }
      throw new $c_s_MatchError(x226);
    }
    var fPen$2 = \u03b441$___1;
    var fOp$2 = \u03b441$___2;
    var this$26 = new $c_sci_$colon$colon(new $c_T2(_1, _2), new $c_sci_$colon$colon(new $c_T2((_1 - w), _2), new $c_sci_$colon$colon(cl, $m_sci_Nil$())));
    var f = ((x$1$1) => {
      var x$7 = (+x$1$1.g());
      var y$5 = (+x$1$1.h());
      return (($m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$().ac(x$7) + ",") + $m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$().ac((-y$5)));
    });
    if ((this$26 === $m_sci_Nil$())) {
      var $x_3 = $m_sci_Nil$();
    } else {
      var x0$3 = this$26.er;
      var h$1 = new $c_sci_$colon$colon(f(x0$3), $m_sci_Nil$());
      var t$1 = h$1;
      var rest = this$26.U;
      while ((rest !== $m_sci_Nil$())) {
        var x0$4 = rest.t();
        var nx = new $c_sci_$colon$colon(f(x0$4), $m_sci_Nil$());
        t$1.U = nx;
        t$1 = nx;
        rest = rest.v();
      }
      var $x_3 = h$1;
    }
    var pl = $f_sc_IterableOnceOps__mkString__T__T__T__T($x_3, "", " ", "");
    sb$29.ad((((((("<polyline fill=\"none\" stroke=\"" + fPen$2) + "\"") + fOp$2) + " points=\"") + pl) + "\"/>\n"));
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__emitEdge$1__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__F2__T__scm_StringBuilder__sci_Map__Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Result__sr_IntRef__I__I__V($thiz, g$17, spl$1, tf$7, op$1, sb$21, labelPos$1, xlabels$5, htmlGradId$11, ix, ei) {
  var e = g$17.cu.l(ix);
  var this$1 = spl$1.r(ix);
  if ((!this$1.c())) {
    var x0 = this$1.d();
    boundary1: {
      var pts = x0.wM.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((p) => {
        matchResult43: {
          var \u03b435$___1;
          var \u03b435$___2;
          var x192 = tf$7.R(p.W, p.a6);
          if ((x192 !== null)) {
            var \u03b435$___1 = (+x192.g());
            var \u03b435$___2 = (+x192.h());
            break matchResult43;
          }
          throw new $c_s_MatchError(x192);
        }
        return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY((+\u03b435$___1), (+\u03b435$___2));
      })));
      var comment = ((("" + e.ai) + op$1) + e.ak);
      var this$4 = e.b9J();
      var tp = (this$4.c() ? "" : (":" + this$4.d()));
      var this$5 = e.b2A();
      var hp = (this$5.c() ? "" : (":" + this$5.d()));
      var label = ((((e.ai + tp) + op$1) + e.ak) + hp);
      sb$21.ad((("<!-- " + $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__xml__T__T($thiz, comment)) + " -->\n"));
      var this$7 = e.b4.ag.r("style");
      if (((!this$7.c()) && $f_sc_Iterator__contains__O__Z(new $c_sc_Iterator$$anon$9($m_sc_ArrayOps$().u8($f_T__split__T__I__AT(this$7.d(), ",", 0)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$69) => $f_T__trim__T(_$69)))), "invis"))) {
        break boundary1;
      }
      var this$12 = e.b4.ag.r("id");
      var this$15 = ((this$12.c() || (this$12.d() !== "")) ? this$12 : $m_s_None$());
      var edgeObjId = (this$15.c() ? ("edge" + ei) : this$15.d());
      sb$21.ad((("<g id=\"" + $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__xml__T__T($thiz, edgeObjId)) + "\" class=\"edge\">\n"));
      sb$21.ad((("<title>" + $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__xml__T__T($thiz, label)) + "</title>\n"));
      var this$17 = e.b4.ag.r("href");
      var this$19 = (this$17.c() ? e.b4.ag.r("URL") : this$17);
      var eDfltUrl = ((this$19.c() || (this$19.d() !== "")) ? this$19 : $m_s_None$());
      var this$23 = e.b4.ag.r("edgehref");
      var this$25 = (this$23.c() ? e.b4.ag.r("edgeURL") : this$23);
      var this$28 = ((this$25.c() || (this$25.d() !== "")) ? this$25 : $m_s_None$());
      var eUrl = (this$28.c() ? eDfltUrl : this$28);
      var this$30 = e.b4.ag.r("labelhref");
      var this$32 = (this$30.c() ? e.b4.ag.r("labelURL") : this$30);
      var this$35 = ((this$32.c() || (this$32.d() !== "")) ? this$32 : $m_s_None$());
      var eLblUrl = (this$35.c() ? eDfltUrl : this$35);
      var this$37 = e.b4.ag.r("tooltip");
      var this$39 = (this$37.c() ? e.b4.ag.r("edgetooltip") : this$37);
      var eExpTip = ((this$39.c() || (this$39.d() !== "")) ? this$39 : $m_s_None$());
      var this$43 = e.b4.ag.r("labeltooltip");
      var eLblExpTip = ((this$43.c() || (this$43.d() !== "")) ? this$43 : $m_s_None$());
      var this$47 = e.b4.ag.r("label");
      var eLblTxt = ((this$47.c() || (this$47.d() !== "")) ? this$47 : $m_s_None$());
      var eTip = (eExpTip.c() ? eLblTxt : eExpTip);
      var eLblTip = (eLblExpTip.c() ? eLblTxt : eLblExpTip);
      var this$51 = e.b4.ag.r("target");
      var eDfltTgt = ((this$51.c() || (this$51.d() !== "")) ? this$51 : $m_s_None$());
      var this$55 = e.b4.ag.r("edgetarget");
      var this$58 = ((this$55.c() || (this$55.d() !== "")) ? this$55 : $m_s_None$());
      var eTgt = (this$58.c() ? eDfltTgt : this$58);
      var this$60 = e.b4.ag.r("labeltarget");
      var this$63 = ((this$60.c() || (this$60.d() !== "")) ? this$60 : $m_s_None$());
      var eLblTgt = (this$63.c() ? eDfltTgt : this$63);
      var eAnchored = ((!eUrl.c()) || (!eExpTip.c()));
      var eLblAnchored = ((!eLblUrl.c()) || (!eLblExpTip.c()));
      if (eAnchored) {
        $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__edgeAnchorOpen$1__scm_StringBuilder__T__s_Option__s_Option__s_Option__V($thiz, sb$21, edgeObjId, eUrl, eTip, eTgt);
      }
      var head = pts.t();
      var rest = $f_sc_IterableOnceOps__mkString__T__T__T__T(pts.mX().L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((p$2) => (($m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$().ac(p$2.W) + ",") + $m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$().ac((-p$2.a6)))))), "", " ", "");
      var this$66 = e.b4.ag.r("color");
      var eStroke = (this$66.c() ? "black" : this$66.d());
      var this$68 = e.b4.ag.r("style");
      var this$72 = (this$68.c() ? $m_s_None$() : new $c_s_Some($m_sci_Set$().af(new $c_sc_Iterator$$anon$9($m_sc_ArrayOps$().u8($f_T__split__T__I__AT(this$68.d(), ",", 0)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$81) => $f_T__trim__T(_$81)))))));
      var eStyles = (this$72.c() ? $m_sci_Set$EmptySet$() : this$72.d());
      var dash = (eStyles.E("dashed") ? " stroke-dasharray=\"5,2\"" : (eStyles.E("dotted") ? " stroke-dasharray=\"1,5\"" : ""));
      var this$74 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().a4p(e.b4);
      var ePw = (+(this$74.c() ? 1.0 : this$74.d()));
      var eSw = ((ePw !== 1.0) ? ((" stroke-width=\"" + $m_Lorg_jpablo_graphexplorer_graphviz_output_Output$().dU(ePw)) + "\"") : "");
      var i = 0;
      var res = 0;
      var len = eStroke.length;
      while ((i < len)) {
        if ((eStroke.charCodeAt(i) === 58)) {
          res = ((1 + res) | 0);
        }
        i = ((1 + i) | 0);
      }
      var numc = res;
      var this$81 = new $c_sc_Iterator$$anon$6($m_sc_ArrayOps$().u8($f_T__split__T__I__AT(eStroke, ":", 0)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$83) => (_$83 !== ""))), false);
      var comps = $m_sci_Vector$().X(this$81);
      var multi = ((numc > 0) && (!$m_sc_StringOps$().IJ(eStroke, 59)));
      if (multi) {
        var np = pts.C();
        var off = new ($d_T2.r().C)(np);
        var pf3 = pts.l(0);
        var pf2 = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(0.0, 0.0);
        var j = 0;
        while ((j < ((np - 1) | 0))) {
          var pf0 = pf3;
          var pf1 = pts.l(((1 + j) | 0));
          off.a[j] = ((j === 0) ? $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__offP$1__D__D__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__T2($thiz, 2.0, 1.0E-4, pf0, pf1) : $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__offP$1__D__D__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__T2($thiz, 2.0, 1.0E-4, pf2, pf1));
          pf2 = pts.l(((2 + j) | 0));
          pf3 = pts.l(((3 + j) | 0));
          var o = $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__offQR$1__D__D__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__T2($thiz, 1.0E-4, 2.0, pf0, pf1, pf2, pf3);
          off.a[((1 + j) | 0)] = o;
          off.a[((2 + j) | 0)] = o;
          j = ((3 + j) | 0);
        }
        off.a[j] = $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__offP$1__D__D__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__T2($thiz, 2.0, 1.0E-4, pf2, pf3);
        var numc2 = (0.5 * (2.0 + numc));
        if ((np <= 0)) {
          var tmp = new ($d_T2.r().C)(0);
        } else {
          var array = new ($d_T2.r().C)(np);
          var i$1 = 0;
          while ((i$1 < np)) {
            var $x_1 = i$1;
            var x0$16 = i$1;
            array.a[$x_1] = new $c_T2((pts.l(x0$16).W - (numc2 * (+off.a[x0$16].g()))), (pts.l(x0$16).a6 - (numc2 * (+off.a[x0$16].h()))));
            i$1 = ((1 + i$1) | 0);
          }
          var tmp = array;
        }
        comps.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((c0) => {
          var k = 0;
          while ((k < np)) {
            tmp.a[k] = new $c_T2(((+tmp.a[k].g()) + (+off.a[k].g())), ((+tmp.a[k].h()) + (+off.a[k].h())));
            k = ((1 + k) | 0);
          }
          var isEmpty = (np <= 1);
          var gap = ((np - 1) | 0);
          var scala$collection$immutable$Range$$lastElement = ((np - 1) | 0);
          if (((gap <= 0) && (!isEmpty))) {
            $m_sci_Range$().ug(1, np, 1, false);
          }
          var b = $m_sci_IndexedSeq$().b5();
          var it = new $c_sci_RangeIterator(1, 1, scala$collection$immutable$Range$$lastElement, isEmpty);
          while (it.g0) {
            var x0$17 = it.hp();
            b.Y((($m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$().ac((+tmp.a[x0$17].g())) + ",") + $m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$().ac((-(+tmp.a[x0$17].h())))));
          }
          var body = $f_sc_IterableOnceOps__mkString__T__T__T__T(b.aR(), "", " ", "");
          matchResult44: {
            var \u03b436$___1;
            var \u03b436$___2;
            var x195 = $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__strokeSplit$1__T__T2($thiz, c0);
            if ((x195 !== null)) {
              var \u03b436$___1 = x195.g();
              var \u03b436$___2 = x195.h();
              break matchResult44;
            }
            throw new $c_s_MatchError(x195);
          }
          var cp$2 = \u03b436$___1;
          var cop$2 = \u03b436$___2;
          return sb$21.ad((((((((((((("<path fill=\"none\" stroke=\"" + cp$2) + "\"") + eSw) + dash) + cop$2) + " d=\"M") + $thiz.ac((+tmp.a[0].g()))) + ",") + $thiz.ac((-(+tmp.a[0].h())))) + "C") + body) + "\"/>\n"));
        })));
      } else {
        matchResult45: {
          var \u03b437$___1;
          var \u03b437$___2;
          var x198 = $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__strokeSplit$1__T__T2($thiz, eStroke);
          if ((x198 !== null)) {
            var \u03b437$___1 = x198.g();
            var \u03b437$___2 = x198.h();
            break matchResult45;
          }
          throw new $c_s_MatchError(x198);
        }
        var ep$2 = \u03b437$___1;
        var eop$2 = \u03b437$___2;
        sb$21.ad((((((((((((("<path fill=\"none\" stroke=\"" + ep$2) + "\"") + eSw) + dash) + eop$2) + " d=\"M") + $thiz.ac(head.W)) + ",") + $thiz.ac((-head.a6))) + "C") + rest) + "\"/>\n"));
      }
      var headArrowCol = (multi ? $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__svgColor$1__T__T($thiz, comps.t()) : eStroke);
      var tailArrowCol = ((multi && (comps.C() > 1)) ? $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__svgColor$1__T__T($thiz, comps.l(1)) : headArrowCol);
      matchResult49: {
        var \u03b434$___1;
        var \u03b434$___2;
        var x223 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$().aOc(g$17.z6, e.b4.ag.r("dir"), e.b4.ag.r("arrowhead"), e.b4.ag.r("arrowtail"));
        if ((x223 !== null)) {
          var \u03b434$___1 = (x223.g() | 0);
          var \u03b434$___2 = (x223.h() | 0);
          break matchResult49;
        }
        throw new $c_s_MatchError(x223);
      }
      var sFlag$2 = (\u03b434$___1 | 0);
      var eFlag$2 = (\u03b434$___2 | 0);
      if ((sFlag$2 !== $m_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$().lC)) {
        var this$102 = x0.Fp;
        if ((!this$102.c())) {
          $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__drawArrow$1__F2__Lorg_jpablo_graphexplorer_graphviz_model_REdge__scm_StringBuilder__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__I__T__V($thiz, tf$7, e, sb$21, this$102.d(), pts.t(), sFlag$2, tailArrowCol);
        }
      }
      if ((eFlag$2 !== $m_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$().lC)) {
        var this$103 = x0.Fo;
        if ((!this$103.c())) {
          $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__drawArrow$1__F2__Lorg_jpablo_graphexplorer_graphviz_model_REdge__scm_StringBuilder__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY__I__T__V($thiz, tf$7, e, sb$21, this$103.d(), pts.bJ(), eFlag$2, headArrowCol);
        }
      }
      if (eAnchored) {
        sb$21.ad("</a>\n</g>\n");
      }
      var decorated = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$().Xu(e.b4.ag.r("decorate"));
      var this$106 = e.b4.ag.r("label");
      var this$109 = ((this$106.c() || (this$106.d() !== "")) ? this$106 : $m_s_None$());
      if ((!this$109.c())) {
        var x0$21 = this$109.d();
        var this$110 = labelPos$1.r(ix);
        if ((!this$110.c())) {
          var x0$22 = this$110.d();
          if (eLblAnchored) {
            $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__edgeAnchorOpen$1__scm_StringBuilder__T__s_Option__s_Option__s_Option__V($thiz, sb$21, (edgeObjId + "-label"), eLblUrl, eLblTip, eLblTgt);
          }
          matchResult51: {
            var \u03b442$___1;
            var \u03b442$___2;
            var x229 = tf$7.R(x0$22.W, x0$22.a6);
            if ((x229 !== null)) {
              var \u03b442$___1 = (+x229.g());
              var \u03b442$___2 = (+x229.h());
              break matchResult51;
            }
            throw new $c_s_MatchError(x229);
          }
          var lpx$2 = (+\u03b442$___1);
          var lpy$2 = (+\u03b442$___2);
          var this$113 = e.b4.ag.r("fontcolor");
          var col = (this$113.c() ? "" : this$113.d());
          if (e.b4.n7.E("label")) {
            matchResult52: {
              var x232 = $m_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$().mU(x0$21);
              if ((x232 instanceof $c_s_Some)) {
                var x239 = x232.J;
                if ((x239 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Text)) {
                  var x242 = x239.oQ;
                  var this$117 = e.b4.ag.r("fontsize");
                  if (this$117.c()) {
                    var this$121 = $m_s_None$();
                  } else {
                    var x0$23 = this$117.d();
                    var this$121 = ($m_sc_StringParsers$().c1(x0$23) ? new $c_s_Some($m_jl_Double$().bd(x0$23)) : $m_s_None$());
                  }
                  var efs = (+(this$121.c() ? 14.0 : this$121.d()));
                  var efn = e.b4.dL("fontname", "Times-Roman");
                  sb$21.ad($p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__htmlText$1__D__D__Lorg_jpablo_graphexplorer_graphviz_html_HtmlText__T__D__Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign__D__T__T($thiz, lpx$2, lpy$2, x242, col, (+$m_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$().a4W(x242, efs, efn).g()), $s_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$__Center__Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign(), efs, efn));
                  break matchResult52;
                }
                if ((x239 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Table)) {
                  var $x_2 = x239.k8;
                  var this$124 = e.b4.ag.r("fontsize");
                  if (this$124.c()) {
                    var this$128 = $m_s_None$();
                  } else {
                    var x0$24 = this$124.d();
                    var this$128 = ($m_sc_StringParsers$().c1(x0$24) ? new $c_s_Some($m_jl_Double$().bd(x0$24)) : $m_s_None$());
                  }
                  sb$21.ad($p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__htmlTable$1__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sr_IntRef__D__D__Lorg_jpablo_graphexplorer_graphviz_html_HtmlTable__T__D__T__s_Option__T__T($thiz, g$17, htmlGradId$11, lpx$2, lpy$2, $x_2, col, (+(this$128.c() ? 14.0 : this$128.d())), e.b4.dL("fontname", "Times-Roman"), $m_s_None$(), "black"));
                  break matchResult52;
                }
              }
            }
          } else {
            var $x_3 = e.b4.dL("fontname", "Times-Roman");
            var this$130 = e.b4.ag.r("fontsize");
            if (this$130.c()) {
              var this$134 = $m_s_None$();
            } else {
              var x0$25 = this$130.d();
              var this$134 = ($m_sc_StringParsers$().c1(x0$25) ? new $c_s_Some($m_jl_Double$().bd(x0$25)) : $m_s_None$());
            }
            sb$21.ad($p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__textLines$1__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D__D__T__T__T__T__D__C__D__T($thiz, g$17, lpx$2, lpy$2, x0$21, col, "", $x_3, (+(this$134.c() ? $m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$().BF : this$134.d())), 99, 0.0));
          }
          if (decorated) {
            matchResult53: {
              var \u03b443$___1;
              var \u03b443$___2;
              var x243 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().tX(e, g$17);
              if ((x243 !== null)) {
                var \u03b443$___1 = (+x243.g());
                var \u03b443$___2 = (+x243.h());
                break matchResult53;
              }
              throw new $c_s_MatchError(x243);
            }
            $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__attachment$1__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_model_REdge__scm_StringBuilder__D__D__D__D__T__V($thiz, pts, e, sb$21, lpx$2, lpy$2, (+\u03b443$___1), (+\u03b443$___2), x0$21);
          }
          if (eLblAnchored) {
            sb$21.ad("</a>\n</g>\n");
          }
        }
      }
      var this$137 = e.b4.ag.r("xlabel");
      var this$140 = ((this$137.c() || (this$137.d() !== "")) ? this$137 : $m_s_None$());
      if ((!this$140.c())) {
        var x0$27 = this$140.d();
        var this$141 = xlabels$5.Fq.r(ix);
        if ((!this$141.c())) {
          var x0$28 = this$141.d();
          if (eLblAnchored) {
            $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__edgeAnchorOpen$1__scm_StringBuilder__T__s_Option__s_Option__s_Option__V($thiz, sb$21, (edgeObjId + "-label"), eLblUrl, eLblTip, eLblTgt);
          }
          matchResult54: {
            var \u03b444$___1;
            var \u03b444$___2;
            var x246 = tf$7.R(x0$28.uD, x0$28.uE);
            if ((x246 !== null)) {
              var \u03b444$___1 = (+x246.g());
              var \u03b444$___2 = (+x246.h());
              break matchResult54;
            }
            throw new $c_s_MatchError(x246);
          }
          var lx$2 = (+\u03b444$___1);
          var ly$2 = (+\u03b444$___2);
          var this$144 = e.b4.ag.r("fontcolor");
          sb$21.ad($p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__textLines$1__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D__D__T__T__T__T__D__C__D__T($thiz, g$17, lx$2, ly$2, x0$27, (this$144.c() ? "" : this$144.d()), "", e.b4.dL("fontname", "Times-Roman"), $thiz.BF, 99, 0.0));
          if (decorated) {
            $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__attachment$1__sci_Vector__Lorg_jpablo_graphexplorer_graphviz_model_REdge__scm_StringBuilder__D__D__D__D__T__V($thiz, pts, e, sb$21, lx$2, ly$2, x0$28.BA, x0$28.Bz, x0$27);
          }
          if (eLblAnchored) {
            sb$21.ad("</a>\n</g>\n");
          }
        }
      }
      sb$21.ad("</g>\n");
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__ensureNode$1__sci_Map__scm_Set__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__scm_StringBuilder__F2__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Result__sr_IntRef__T__V($thiz, nodeIdx$1, emitted$1, g$23, xs$2, sb$34, tf$17, yOf$4, ranks$4, xlabels$8, htmlGradId$15, id) {
  var this$1 = nodeIdx$1.r(id);
  if ((!this$1.c())) {
    var x0 = this$1.d();
    var i = (x0 | 0);
    if ((!emitted$1.E(id))) {
      emitted$1.Y(id);
      $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__emitNode$1__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__scm_StringBuilder__F2__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Result__sr_IntRef__I__V($thiz, g$23, xs$2, sb$34, tf$17, yOf$4, ranks$4, xlabels$8, htmlGradId$15, i);
    }
  }
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_output_Svg$() {
  this.a8b = 0.0;
  this.BF = 0.0;
  this.auC = null;
  this.auB = 0.0;
  this.auA = null;
  $n_Lorg_jpablo_graphexplorer_graphviz_output_Svg$ = this;
  this.a8b = 4.0;
  this.BF = 14.0;
  this.auC = $m_sci_Map$().ao($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("avantgarde-book", new $c_T5("URW Gothic L", "book", "", "", "sans-Serif")), new $c_T2("avantgarde-bookoblique", new $c_T5("URW Gothic L", "book", "", "oblique", "sans-Serif")), new $c_T2("avantgarde-demi", new $c_T5("URW Gothic L", "demi", "", "", "sans-Serif")), new $c_T2("avantgarde-demioblique", new $c_T5("URW Gothic L", "demi", "", "oblique", "sans-Serif")), new $c_T2("bookman-demi", new $c_T5("URW Bookman L", "demi", "", "", "serif")), new $c_T2("bookman-demiitalic", new $c_T5("URW Bookman L", "demi", "", "italic", "serif")), new $c_T2("bookman-light", new $c_T5("URW Bookman L", "light", "", "", "serif")), new $c_T2("bookman-lightitalic", new $c_T5("URW Bookman L", "light", "", "italic", "serif")), new $c_T2("courier", new $c_T5("Courier", "", "", "", "monospace")), new $c_T2("courier-bold", new $c_T5("Courier", "bold", "", "", "monospace")), new $c_T2("courier-boldoblique", new $c_T5("Courier", "bold", "", "oblique", "monospace")), new $c_T2("courier-oblique", new $c_T5("Courier", "", "", "oblique", "monospace")), new $c_T2("helvetica", new $c_T5("Helvetica", "", "", "", "sans-Serif")), new $c_T2("helvetica-bold", new $c_T5("Helvetica", "bold", "", "", "sans-Serif")), new $c_T2("helvetica-boldoblique", new $c_T5("Helvetica", "bold", "", "oblique", "sans-Serif")), new $c_T2("helvetica-narrow", new $c_T5("Helvetica", "", "condensed", "", "sans-Serif")), new $c_T2("helvetica-narrow-bold", new $c_T5("Helvetica", "bold", "condensed", "", "sans-Serif")), new $c_T2("helvetica-narrow-boldoblique", new $c_T5("Helvetica", "bold", "condensed", "oblique", "sans-Serif")), new $c_T2("helvetica-narrow-oblique", new $c_T5("Helvetica", "", "condensed", "oblique", "sans-Serif")), new $c_T2("helvetica-oblique", new $c_T5("Helvetica", "", "", "oblique", "sans-Serif")), new $c_T2("newcenturyschlbk-bold", new $c_T5("Century Schoolbook L", "bold", "", "", "serif")), new $c_T2("newcenturyschlbk-bolditalic", new $c_T5("Century Schoolbook L", "bold", "", "italic", "serif")), new $c_T2("newcenturyschlbk-italic", new $c_T5("Century Schoolbook L", "", "", "italic", "serif")), new $c_T2("newcenturyschlbk-roman", new $c_T5("Century Schoolbook L", "roman", "", "", "serif")), new $c_T2("palatino-bold", new $c_T5("Palatino Linotype", "bold", "", "", "serif")), new $c_T2("palatino-bolditalic", new $c_T5("Palatino Linotype", "bold", "", "italic", "serif")), new $c_T2("palatino-italic", new $c_T5("Palatino Linotype", "", "", "italic", "serif")), new $c_T2("palatino-roman", new $c_T5("Palatino Linotype", "roman", "", "", "serif")), new $c_T2("symbol", new $c_T5("Symbol", "", "", "", "fantasy")), new $c_T2("times-bold", new $c_T5("Times", "bold", "", "", "serif")), new $c_T2("times-bolditalic", new $c_T5("Times", "bold", "", "italic", "serif")), new $c_T2("times-italic", new $c_T5("Times", "", "", "italic", "serif")), new $c_T2("times-roman", new $c_T5("Times", "", "", "", "serif")), new $c_T2("zapfchancery-mediumitalic", new $c_T5("URW Chancery L", "medium", "", "italic", "serif")), new $c_T2("zapfdingbats", new $c_T5("Dingbats", "", "", "", "fantasy"))])));
  this.auB = 1.2;
  this.auA = "13.0.1 (20250615.1724)";
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_output_Svg$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_output_Svg$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_output_Svg$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_output_Svg$.prototype = $p;
$p.Am = (function(x) {
  if (((x === 0.0) || ((x > (-1.0E-11)) && (x < 1.0E-11)))) {
    return "0";
  } else {
    var a = (+Math.abs(x));
    var x$1 = (+Math.log10(a));
    var exp = $doubleToInt((+Math.floor(x$1)));
    var x$2 = exp;
    var y = x$2;
    if (((+Math.pow(10.0, y)) > a)) {
      exp = ((exp - 1) | 0);
    }
    var x$3 = ((1 + exp) | 0);
    var y$1 = x$3;
    if (((+Math.pow(10.0, y$1)) <= a)) {
      exp = ((1 + exp) | 0);
    }
    if (((((4 + exp) | 0) >>> 0) > 9)) {
      var x$4 = exp;
      var y$2 = x$4;
      var m = (x / (+Math.pow(10.0, y$2)));
      var this$16 = $m_s_package$().oz();
      var ms = $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__stripZeros__T__T(this, this$16.y8(m, this$16.qI).Jm(5, ($m_s_package$().oz(), $m_s_math_BigDecimal$RoundingMode$().adi)).dN.Q2());
      var $x_3 = ((exp < 0) ? "-" : "+");
      var $x_2 = $m_sc_StringOps$();
      var $x_1 = $m_sr_ScalaRunTime$();
      var x$5 = exp;
      var sign = (x$5 >> 31);
      var es = ($x_3 + $x_2.u0("%02d", $x_1.hP(new $ac_O([(((x$5 ^ sign) - sign) | 0)]))));
      return ((ms + "e") + es);
    } else {
      var y$3 = ((5 - exp) | 0);
      var frac = ((y$3 < 0) ? 0 : y$3);
      var this$21 = $m_s_package$().oz();
      return $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__stripZeros__T__T(this, this$21.y8(x, this$21.qI).Jm(frac, ($m_s_package$().oz(), $m_s_math_BigDecimal$RoundingMode$().adi)).dN.Q2());
    }
  }
});
$p.aTf = (function(src, bllx, burx, blly, bury, natW, natH, scale, pos) {
  var llx = bllx;
  var urx = burx;
  var lly = blly;
  var ury = bury;
  var pw = (urx - llx);
  var ph = (ury - lly);
  if (((natW > 0.0) && (natH > 0.0))) {
    var iw = natW;
    var ih = natH;
    matchResult2: {
      if (scale.c()) {
        var x9 = $m_s_None$();
      } else {
        var x0 = scale.d();
        var x9 = new $c_s_Some(x0.toLowerCase());
      }
      if ((x9 instanceof $c_s_Some)) {
        var x17 = x9.J;
        switch (x17) {
          case "true": {
            var x = (pw / natW);
            var y = (ph / natH);
            var s = (+Math.min(x, y));
            iw = (natW * s);
            ih = (natH * s);
            break matchResult2;
            break;
          }
          case "width": {
            iw = pw;
            break matchResult2;
            break;
          }
          case "height": {
            ih = ph;
            break matchResult2;
            break;
          }
          default: {
            if ((x17 === "both")) {
              iw = pw;
              ih = ph;
              break matchResult2;
            }
          }
        }
      }
    }
    if ((iw < pw)) {
      matchResult3: {
        var x18 = new $c_s_PartialFunction$Lifted($m_s_Predef$().JL(pos)).as(1);
        if ((x18 instanceof $c_s_Some)) {
          var x22 = $uC(x18.J);
          if ((x22 === 108)) {
            urx = (llx + iw);
            break matchResult3;
          }
          if ((x22 === 114)) {
            llx = (urx - iw);
            break matchResult3;
          }
        }
        llx = (llx + (0.5 * (pw - iw)));
        urx = (urx - (0.5 * (pw - iw)));
      }
    }
    if ((ih < ph)) {
      matchResult4: {
        var x23 = $m_sc_StringOps$().X8(pos);
        if ((x23 instanceof $c_s_Some)) {
          var x27 = $uC(x23.J);
          if ((x27 === 116)) {
            lly = (ury - ih);
            break matchResult4;
          }
          if ((x27 === 98)) {
            ury = (lly + ih);
            break matchResult4;
          }
        }
        lly = (lly + (0.5 * (ph - ih)));
        ury = (ury - (0.5 * (ph - ih)));
      }
    }
  }
  return (((((((((("<image xlink:href=\"" + src) + "\" width=\"") + this.Am((urx - llx))) + "px\" height=\"") + this.Am((ury - lly))) + "px\" preserveAspectRatio=\"xMinYMin meet\" x=\"") + this.Am(llx)) + "\" y=\"") + this.Am((-ury))) + "\"/>\n");
});
$p.ac = (function(x) {
  if (((x > (-0.005)) && (x < 0.005))) {
    return "0";
  } else {
    var this$1 = $m_s_package$().oz();
    var bd = this$1.y8(x, this$1.qI).Jm(2, ($m_s_package$().oz(), $m_s_math_BigDecimal$RoundingMode$().Oe));
    var s = bd.dN.Q2();
    if ($m_sc_StringOps$().IJ(s, 46)) {
      var $x_1 = $m_sc_StringOps$();
      var x$3 = $m_sc_StringOps$().a4z(s);
      _return: {
        var len = x$3.length;
        var i = 0;
        while ((i < len)) {
          if ((x$3.charCodeAt(i) !== 48)) {
            var x1 = i;
            break _return;
          }
          i = ((1 + i) | 0);
        }
        var x1 = (-1);
      }
      var x$4 = ((x1 === (-1)) ? "" : x$3.substring(x1));
      _return$1: {
        var len$1 = x$4.length;
        var i$1 = 0;
        while ((i$1 < len$1)) {
          if ((x$4.charCodeAt(i$1) !== 46)) {
            var x1$1 = i$1;
            break _return$1;
          }
          i$1 = ((1 + i$1) | 0);
        }
        var x1$1 = (-1);
      }
      s = $x_1.a4z(((x1$1 === (-1)) ? "" : x$4.substring(x1$1)));
    }
    return ((s === "-0") ? "0" : s);
  }
});
$p.aNZ = (function(x) {
  var this$1 = $m_s_package$().oz();
  return this$1.y8(x, this$1.qI).Jm(2, ($m_s_package$().oz(), $m_s_math_BigDecimal$RoundingMode$().Oe)).dN.Q2();
});
$p.b9y = (function(g) {
  var xs = $m_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$().a5k(g);
  matchResult8: {
    var yOf$2;
    var x31 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$().PL(g);
    if ((x31 !== null)) {
      var yOf$2 = x31.h();
      break matchResult8;
    }
    throw new $c_s_MatchError(x31);
  }
  var ranks = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().P0(g);
  var spl = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$().a4K(g);
  var labelPos = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$().a43(g);
  var xlabels = $m_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$().a4q(g);
  var tf0 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_DrawTransform$().aha(g);
  matchResult10: {
    var \u03b42$___1;
    var \u03b42$___2;
    var \u03b42$___3;
    var \u03b42$___4;
    if ($m_Lorg_jpablo_graphexplorer_graphviz_layout_DrawTransform$().ahL(g)) {
      var x39 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$().afN(g);
    } else {
      matchResult9: {
        var \u03b46$___1;
        var \u03b46$___2;
        var \u03b46$___3;
        var \u03b46$___4;
        var x34 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_GraphBB$().Wm(g);
        if ((x34 !== null)) {
          var \u03b46$___1 = (+x34.bO);
          var \u03b46$___2 = (+x34.bs);
          var \u03b46$___3 = (+x34.ch);
          var \u03b46$___4 = (+x34.ca);
          break matchResult9;
        }
        throw new $c_s_MatchError(x34);
      }
      var x39 = new $c_T4((+\u03b46$___1), (+\u03b46$___2), (+\u03b46$___3), (+\u03b46$___4));
    }
    if ((x39 !== null)) {
      var \u03b42$___1 = (+x39.bO);
      var \u03b42$___2 = (+x39.bs);
      var \u03b42$___3 = (+x39.ch);
      var \u03b42$___4 = (+x39.ca);
      break matchResult10;
    }
    throw new $c_s_MatchError(x39);
  }
  var rlx$2 = (+\u03b42$___1);
  var rly$2 = (+\u03b42$___2);
  var rux$2 = (+\u03b42$___3);
  var ruy$2 = (+\u03b42$___4);
  var dx = (-rlx$2);
  var dy = (-rly$2);
  var tf = new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((x, y) => {
    var x$1 = (+x);
    var y$1 = (+y);
    matchResult11: {
      var \u03b47$___1;
      var \u03b47$___2;
      var x44 = tf0.R(x$1, y$1);
      if ((x44 !== null)) {
        var \u03b47$___1 = (+x44.g());
        var \u03b47$___2 = (+x44.h());
        break matchResult11;
      }
      throw new $c_s_MatchError(x44);
    }
    return new $c_T2(((+\u03b47$___1) + dx), ((+\u03b47$___2) + dy));
  }));
  var _1$1 = (rlx$2 + dx);
  var _2$1 = (rly$2 + dy);
  var _3 = (rux$2 + dx);
  var _4 = (ruy$2 + dy);
  matchResult12: {
    var \u03b44$___1;
    var \u03b44$___2;
    var this$8 = g.f2.ag.r("pad");
    if (this$8.c()) {
      var this$27 = $m_s_None$();
    } else {
      var x0 = this$8.d();
      var xs$1 = $f_T__split__T__I__AT(x0, ",", 0);
      var f = ((_$4) => $f_T__trim__T(_$4));
      var len = xs$1.a.length;
      var ys = new ($d_T.r().C)(len);
      if ((len > 0)) {
        var i = 0;
        if ((xs$1 !== null)) {
          while ((i < len)) {
            var $x_1 = i;
            var x0$1 = xs$1.a[i];
            ys.a[$x_1] = f(x0$1);
            i = ((1 + i) | 0);
          }
        } else if ((xs$1 instanceof $ac_I)) {
          while ((i < len)) {
            var $x_2 = i;
            var x0$2 = xs$1.a[i];
            ys.a[$x_2] = f(x0$2);
            i = ((1 + i) | 0);
          }
        } else if ((xs$1 instanceof $ac_D)) {
          while ((i < len)) {
            var $x_3 = i;
            var x0$3 = xs$1.a[i];
            ys.a[$x_3] = f(x0$3);
            i = ((1 + i) | 0);
          }
        } else if ((xs$1 instanceof $ac_J)) {
          while ((i < len)) {
            var $x_6 = i;
            var $x_4 = xs$1.a;
            var $x_5 = (i << 1);
            var x0$4_$_lo = $x_4[$x_5];
            var x0$4_$_hi = $x_4[(($x_5 + 1) | 0)];
            ys.a[$x_6] = f($bL(x0$4_$_lo, x0$4_$_hi));
            i = ((1 + i) | 0);
          }
        } else if ((xs$1 instanceof $ac_F)) {
          while ((i < len)) {
            var $x_7 = i;
            var x0$5 = xs$1.a[i];
            ys.a[$x_7] = f(x0$5);
            i = ((1 + i) | 0);
          }
        } else if ((xs$1 instanceof $ac_C)) {
          while ((i < len)) {
            var $x_8 = i;
            var x0$6 = xs$1.a[i];
            ys.a[$x_8] = f($bC(x0$6));
            i = ((1 + i) | 0);
          }
        } else if ((xs$1 instanceof $ac_B)) {
          while ((i < len)) {
            var $x_9 = i;
            var x0$7 = xs$1.a[i];
            ys.a[$x_9] = f(x0$7);
            i = ((1 + i) | 0);
          }
        } else if ((xs$1 instanceof $ac_S)) {
          while ((i < len)) {
            var $x_10 = i;
            var x0$8 = xs$1.a[i];
            ys.a[$x_10] = f(x0$8);
            i = ((1 + i) | 0);
          }
        } else if ((xs$1 instanceof $ac_Z)) {
          while ((i < len)) {
            var $x_11 = i;
            var x0$9 = xs$1.a[i];
            ys.a[$x_11] = f(x0$9);
            i = ((1 + i) | 0);
          }
        } else {
          throw new $c_s_MatchError(xs$1);
        }
      }
      var this$14 = $m_sc_ArrayOps$().X7(ys);
      if (this$14.c()) {
        var this$18 = $m_s_None$();
      } else {
        var x0$10 = this$14.d();
        var this$18 = ($m_sc_StringParsers$().c1(x0$10) ? new $c_s_Some($m_jl_Double$().bd(x0$10)) : $m_s_None$());
      }
      if (this$18.c()) {
        var this$27 = $m_s_None$();
      } else {
        var x0$11 = this$18.d();
        var x$2 = (+x0$11);
        var this$21 = new $c_s_PartialFunction$Lifted($m_s_Predef$().fB(ys)).as(1);
        if (this$21.c()) {
          var this$25 = $m_s_None$();
        } else {
          var x0$12 = this$21.d();
          var this$25 = ($m_sc_StringParsers$().c1(x0$12) ? new $c_s_Some($m_jl_Double$().bd(x0$12)) : $m_s_None$());
        }
        var this$27 = new $c_s_Some(new $c_T2((72.0 * x$2), (72.0 * (+(this$25.c() ? x$2 : this$25.d())))));
      }
    }
    var x47 = (this$27.c() ? new $c_T2($m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$().a8b, $m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$().a8b) : this$27.d());
    if ((x47 !== null)) {
      var \u03b44$___1 = (+x47.g());
      var \u03b44$___2 = (+x47.h());
      break matchResult12;
    }
    throw new $c_s_MatchError(x47);
  }
  var padX$2 = (+\u03b44$___1);
  var padY$2 = (+\u03b44$___2);
  var bbW = (_3 - _1$1);
  var bbH = (_4 - _2$1);
  var _1$4 = (bbW + (2.0 * padX$2));
  var _2$4 = (bbH + (2.0 * padY$2));
  matchResult13: {
    var zoom;
    var this$32 = g.f2.ag.r("size");
    if (this$32.c()) {
      var x50 = $m_s_None$();
    } else {
      var x0$13 = this$32.d();
      var this$33 = $f_T__trim__T(x0$13);
      var bang = (!(!this$33.endsWith("!")));
      var xs$2 = $f_T__split__T__I__AT($m_sc_StringOps$().wh($f_T__trim__T(x0$13), "!"), ",", 0);
      var f$1 = ((_$7) => $f_T__trim__T(_$7));
      var len$1 = xs$2.a.length;
      var ys$1 = new ($d_T.r().C)(len$1);
      if ((len$1 > 0)) {
        var i$1 = 0;
        if ((xs$2 !== null)) {
          while ((i$1 < len$1)) {
            var $x_12 = i$1;
            var x0$14 = xs$2.a[i$1];
            ys$1.a[$x_12] = f$1(x0$14);
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((xs$2 instanceof $ac_I)) {
          while ((i$1 < len$1)) {
            var $x_13 = i$1;
            var x0$15 = xs$2.a[i$1];
            ys$1.a[$x_13] = f$1(x0$15);
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((xs$2 instanceof $ac_D)) {
          while ((i$1 < len$1)) {
            var $x_14 = i$1;
            var x0$16 = xs$2.a[i$1];
            ys$1.a[$x_14] = f$1(x0$16);
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((xs$2 instanceof $ac_J)) {
          while ((i$1 < len$1)) {
            var $x_17 = i$1;
            var $x_15 = xs$2.a;
            var $x_16 = (i$1 << 1);
            var x0$17_$_lo = $x_15[$x_16];
            var x0$17_$_hi = $x_15[(($x_16 + 1) | 0)];
            ys$1.a[$x_17] = f$1($bL(x0$17_$_lo, x0$17_$_hi));
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((xs$2 instanceof $ac_F)) {
          while ((i$1 < len$1)) {
            var $x_18 = i$1;
            var x0$18 = xs$2.a[i$1];
            ys$1.a[$x_18] = f$1(x0$18);
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((xs$2 instanceof $ac_C)) {
          while ((i$1 < len$1)) {
            var $x_19 = i$1;
            var x0$19 = xs$2.a[i$1];
            ys$1.a[$x_19] = f$1($bC(x0$19));
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((xs$2 instanceof $ac_B)) {
          while ((i$1 < len$1)) {
            var $x_20 = i$1;
            var x0$20 = xs$2.a[i$1];
            ys$1.a[$x_20] = f$1(x0$20);
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((xs$2 instanceof $ac_S)) {
          while ((i$1 < len$1)) {
            var $x_21 = i$1;
            var x0$21 = xs$2.a[i$1];
            ys$1.a[$x_21] = f$1(x0$21);
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((xs$2 instanceof $ac_Z)) {
          while ((i$1 < len$1)) {
            var $x_22 = i$1;
            var x0$22 = xs$2.a[i$1];
            ys$1.a[$x_22] = f$1(x0$22);
            i$1 = ((1 + i$1) | 0);
          }
        } else {
          throw new $c_s_MatchError(xs$2);
        }
      }
      var this$41 = $m_sc_ArrayOps$().X7(ys$1);
      if (this$41.c()) {
        var xf = $m_s_None$();
      } else {
        var x0$23 = this$41.d();
        var xf = ($m_sc_StringParsers$().c1(x0$23) ? new $c_s_Some($m_jl_Double$().bd(x0$23)) : $m_s_None$());
      }
      if ((ys$1.a.length > 1)) {
        var this$47 = new $c_s_PartialFunction$Lifted($m_s_Predef$().fB(ys$1)).as(1);
        if (this$47.c()) {
          var yf = $m_s_None$();
        } else {
          var x0$24 = this$47.d();
          var yf = ($m_sc_StringParsers$().c1(x0$24) ? new $c_s_Some($m_jl_Double$().bd(x0$24)) : $m_s_None$());
        }
      } else {
        var yf = xf;
      }
      if (xf.c()) {
        var x50 = $m_s_None$();
      } else {
        var x0$25 = xf.d();
        var x$4 = (+x0$25);
        var this$51 = new $c_s_Option$WithFilter(yf, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((y$2) => {
          var y$3 = (+y$2);
          return ((x$4 > 0.0) && (y$3 > 0.0));
        })));
        var this$52 = this$51.tu;
        var p$1 = this$51.tv;
        var this$53 = ((this$52.c() || (!(!p$1.i(this$52.d())))) ? this$52 : $m_s_None$());
        if (this$53.c()) {
          var x50 = $m_s_None$();
        } else {
          var x0$26 = this$53.d();
          var y$4 = (+x0$26);
          var x50 = new $c_s_Some(new $c_T3($m_Lorg_jpablo_graphexplorer_graphviz_output_Output$().E2((72.0 * x$4)), $m_Lorg_jpablo_graphexplorer_graphviz_output_Output$().E2((72.0 * y$4)), bang));
        }
      }
    }
    if ((x50 instanceof $c_s_Some)) {
      var x52 = x50.J;
      if ((x52 !== null)) {
        var sx = (+x52.bH);
        var sy = (+x52.bU);
        var filled = (!(!x52.c3));
        if (((sx > 0.001) && (sy > 0.001))) {
          if ((((sx < _1$4) || (sy < _2$4)) || ((filled && (sx > _1$4)) && (sy > _2$4)))) {
            var x$5 = (sx / _1$4);
            var y$5 = (sy / _2$4);
            var zoom = (+Math.min(x$5, y$5));
            break matchResult13;
          } else {
            var zoom = 1.0;
            break matchResult13;
          }
        }
      }
    }
    var zoom = 1.0;
  }
  var w = $doubleToInt($m_Lorg_jpablo_graphexplorer_graphviz_output_Output$().E2((_1$4 * zoom)));
  var h = $doubleToInt($m_Lorg_jpablo_graphexplorer_graphviz_output_Output$().E2((_2$4 * zoom)));
  var trX = (padX$2 - _1$1);
  var trY = (_4 + padY$2);
  var sb = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  sb.ad("<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?>\n");
  sb.ad("<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\"\n");
  sb.ad(" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n");
  sb.ad((("<!-- Generated by graphviz version " + this.auA) + "\n -->\n"));
  var this$57 = g.j5;
  var gname = ((this$57.c() || (this$57.d() !== "")) ? this$57 : $m_s_None$());
  matchResult14: {
    var $x_23;
    if ((gname instanceof $c_s_Some)) {
      var $x_23 = (("<!-- Title: " + $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__xml__T__T(this, gname.J)) + " Pages: 1 -->\n");
      break matchResult14;
    }
    if (($m_s_None$() === gname)) {
      var $x_23 = "<!-- Pages: 1 -->\n";
      break matchResult14;
    }
    throw new $c_s_MatchError(gname);
  }
  sb.ad($x_23);
  sb.ad((((("<svg width=\"" + w) + "pt\" height=\"") + h) + "pt\"\n"));
  sb.ad(((((" viewBox=\"0.00 0.00 " + w) + ".00 ") + h) + ".00\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n"));
  var zs = this.Am(zoom);
  sb.ad((((((((("<g id=\"graph0\" class=\"graph\" transform=\"scale(" + zs) + " ") + zs) + ") rotate(0) translate(") + this.ac(trX)) + " ") + this.ac(trY)) + ")\">\n"));
  if ((!gname.c())) {
    var x0$28 = gname.d();
    sb.ad((("<title>" + $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__xml__T__T($m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$(), x0$28)) + "</title>\n"));
  }
  var bx0 = (_1$1 - padX$2);
  var bx1 = (_3 + padX$2);
  var by1 = (-(_4 + padY$2));
  var this$61 = g.f2.ag.r("bgcolor");
  var this$64 = ((this$61.c() || (this$61.d() !== "")) ? this$61 : $m_s_None$());
  if (this$64.c()) {
    var this$65 = $m_s_None$();
  } else {
    var x0$30 = this$64.d();
    var this$65 = new $c_s_Some(((!(!x0$30.startsWith("#"))) ? x0$30.toLowerCase() : x0$30));
  }
  sb.ad((((((((((((((((((((((("<polygon fill=\"" + (this$65.c() ? "white" : this$65.d())) + "\" stroke=\"none\" points=\"") + this.ac(bx0)) + ",") + this.ac(padY$2)) + " ") + this.ac(bx0)) + ",") + this.ac(by1)) + " ") + this.ac(bx1)) + ",") + this.ac(by1)) + " ") + this.ac(bx1)) + ",") + this.ac(padY$2)) + " ") + this.ac(bx0)) + ",") + this.ac(padY$2)) + "\"/>\n"));
  var this$67 = g.f2.ag.r("label");
  var this$70 = ((this$67.c() || (this$67.d() !== "")) ? this$67 : $m_s_None$());
  if ((!this$70.c())) {
    var x0$32 = this$70.d();
    var this$72 = g.f2.ag.r("fontsize");
    if (this$72.c()) {
      var this$76 = $m_s_None$();
    } else {
      var x0$33 = this$72.d();
      var this$76 = ($m_sc_StringParsers$().c1(x0$33) ? new $c_s_Some($m_jl_Double$().bd(x0$33)) : $m_s_None$());
    }
    var gfs = (+(this$76.c() ? $m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$().BF : this$76.d()));
    var $x_24 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$();
    var this$77 = g.j5;
    var lh = $x_24.PC(x0$32, gfs, (this$77.c() ? "" : this$77.d()));
    var this$79 = g.f2.ag.r("labelloc");
    if ((!this$79.c())) {
      var x0$34 = this$79.d();
      var $x_25 = (!(!x0$34.startsWith("t")));
    } else {
      var $x_25 = false;
    }
    sb.ad($p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__textLines$1__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__D__D__T__T__T__T__D__C__D__T(this, g, (0.5 * (_1$1 + _3)), ($x_25 ? (((_4 - _2$1) - 4.0) - (0.5 * lh)) : (4.0 + (0.5 * lh))), x0$32, g.f2.dL("fontcolor", ""), "", g.f2.dL("fontname", "Times-Roman"), gfs, 99, 0.0));
  }
  var cls = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$().tV(g);
  if ((!$f_sc_SeqOps__isEmpty__Z(cls))) {
    var cbbs = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$().a2N(g);
    var b$3 = new $c_sci_MapBuilderImpl();
    g.uF.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((s$8) => {
      $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__walk$1__scm_Builder__Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph__V(this, b$3, s$8);
    })));
    var sgByName = b$3.oG();
    $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(cls).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$1) => {
      var c$1 = x$1$1.g();
      var i$2 = (x$1$1.h() | 0);
      var cb = $m_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$().aO9(g, cbbs.l(i$2), tf);
      var llx = cb.nW;
      var urx = cb.nX;
      var lly = cb.pR;
      var ury = cb.pS;
      var this$81 = sgByName.r(c$1.yO);
      var this$82 = (this$81.c() ? $m_s_None$() : this$81.d().q2.r("id"));
      var this$85 = ((this$82.c() || (this$82.d() !== "")) ? this$82 : $m_s_None$());
      sb.ad((("<g id=\"" + $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__xml__T__T(this, (this$85.c() ? ("clust" + ((1 + i$2) | 0)) : this$85.d()))) + "\" class=\"cluster\">\n"));
      sb.ad((("<title>" + $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__xml__T__T(this, c$1.yO)) + "</title>\n"));
      var this$86 = sgByName.r(c$1.yO);
      var this$87 = (this$86.c() ? $m_s_None$() : new $c_s_Some(this$86.d().q2));
      var a$3 = (this$87.c() ? $m_sci_Map$EmptyMap$() : this$87.d());
      var this$89 = a$3.r("style");
      if ((!this$89.c())) {
        var x0$38 = this$89.d();
        var xs$3 = $f_T__split__T__I__AT(x0$38, ",", 0);
        var f$2 = ((_$21) => $f_T__trim__T(_$21));
        var len$2 = xs$3.a.length;
        var ys$2 = new ($d_T.r().C)(len$2);
        if ((len$2 > 0)) {
          var i$3 = 0;
          if ((xs$3 !== null)) {
            while ((i$3 < len$2)) {
              var $x_26 = i$3;
              var x0$39 = xs$3.a[i$3];
              ys$2.a[$x_26] = f$2(x0$39);
              i$3 = ((1 + i$3) | 0);
            }
          } else if ((xs$3 instanceof $ac_I)) {
            while ((i$3 < len$2)) {
              var $x_27 = i$3;
              var x0$40 = xs$3.a[i$3];
              ys$2.a[$x_27] = f$2(x0$40);
              i$3 = ((1 + i$3) | 0);
            }
          } else if ((xs$3 instanceof $ac_D)) {
            while ((i$3 < len$2)) {
              var $x_28 = i$3;
              var x0$41 = xs$3.a[i$3];
              ys$2.a[$x_28] = f$2(x0$41);
              i$3 = ((1 + i$3) | 0);
            }
          } else if ((xs$3 instanceof $ac_J)) {
            while ((i$3 < len$2)) {
              var $x_31 = i$3;
              var $x_29 = xs$3.a;
              var $x_30 = (i$3 << 1);
              var x0$42_$_lo = $x_29[$x_30];
              var x0$42_$_hi = $x_29[(($x_30 + 1) | 0)];
              ys$2.a[$x_31] = f$2($bL(x0$42_$_lo, x0$42_$_hi));
              i$3 = ((1 + i$3) | 0);
            }
          } else if ((xs$3 instanceof $ac_F)) {
            while ((i$3 < len$2)) {
              var $x_32 = i$3;
              var x0$43 = xs$3.a[i$3];
              ys$2.a[$x_32] = f$2(x0$43);
              i$3 = ((1 + i$3) | 0);
            }
          } else if ((xs$3 instanceof $ac_C)) {
            while ((i$3 < len$2)) {
              var $x_33 = i$3;
              var x0$44 = xs$3.a[i$3];
              ys$2.a[$x_33] = f$2($bC(x0$44));
              i$3 = ((1 + i$3) | 0);
            }
          } else if ((xs$3 instanceof $ac_B)) {
            while ((i$3 < len$2)) {
              var $x_34 = i$3;
              var x0$45 = xs$3.a[i$3];
              ys$2.a[$x_34] = f$2(x0$45);
              i$3 = ((1 + i$3) | 0);
            }
          } else if ((xs$3 instanceof $ac_S)) {
            while ((i$3 < len$2)) {
              var $x_35 = i$3;
              var x0$46 = xs$3.a[i$3];
              ys$2.a[$x_35] = f$2(x0$46);
              i$3 = ((1 + i$3) | 0);
            }
          } else if ((xs$3 instanceof $ac_Z)) {
            while ((i$3 < len$2)) {
              var $x_36 = i$3;
              var x0$47 = xs$3.a[i$3];
              ys$2.a[$x_36] = f$2(x0$47);
              i$3 = ((1 + i$3) | 0);
            }
          } else {
            throw new $c_s_MatchError(xs$3);
          }
        }
        var invis = $m_sc_ArrayOps$().afc(ys$2, "invis");
      } else {
        var invis = false;
      }
      var this$95 = a$3.r("style");
      if ((!this$95.c())) {
        var x0$48 = this$95.d();
        var xs$4 = $f_T__split__T__I__AT(x0$48, ",", 0);
        var f$3 = ((_$23) => $f_T__trim__T(_$23));
        var len$3 = xs$4.a.length;
        var ys$3 = new ($d_T.r().C)(len$3);
        if ((len$3 > 0)) {
          var i$4 = 0;
          if ((xs$4 !== null)) {
            while ((i$4 < len$3)) {
              var $x_37 = i$4;
              var x0$49 = xs$4.a[i$4];
              ys$3.a[$x_37] = f$3(x0$49);
              i$4 = ((1 + i$4) | 0);
            }
          } else if ((xs$4 instanceof $ac_I)) {
            while ((i$4 < len$3)) {
              var $x_38 = i$4;
              var x0$50 = xs$4.a[i$4];
              ys$3.a[$x_38] = f$3(x0$50);
              i$4 = ((1 + i$4) | 0);
            }
          } else if ((xs$4 instanceof $ac_D)) {
            while ((i$4 < len$3)) {
              var $x_39 = i$4;
              var x0$51 = xs$4.a[i$4];
              ys$3.a[$x_39] = f$3(x0$51);
              i$4 = ((1 + i$4) | 0);
            }
          } else if ((xs$4 instanceof $ac_J)) {
            while ((i$4 < len$3)) {
              var $x_42 = i$4;
              var $x_40 = xs$4.a;
              var $x_41 = (i$4 << 1);
              var x0$52_$_lo = $x_40[$x_41];
              var x0$52_$_hi = $x_40[(($x_41 + 1) | 0)];
              ys$3.a[$x_42] = f$3($bL(x0$52_$_lo, x0$52_$_hi));
              i$4 = ((1 + i$4) | 0);
            }
          } else if ((xs$4 instanceof $ac_F)) {
            while ((i$4 < len$3)) {
              var $x_43 = i$4;
              var x0$53 = xs$4.a[i$4];
              ys$3.a[$x_43] = f$3(x0$53);
              i$4 = ((1 + i$4) | 0);
            }
          } else if ((xs$4 instanceof $ac_C)) {
            while ((i$4 < len$3)) {
              var $x_44 = i$4;
              var x0$54 = xs$4.a[i$4];
              ys$3.a[$x_44] = f$3($bC(x0$54));
              i$4 = ((1 + i$4) | 0);
            }
          } else if ((xs$4 instanceof $ac_B)) {
            while ((i$4 < len$3)) {
              var $x_45 = i$4;
              var x0$55 = xs$4.a[i$4];
              ys$3.a[$x_45] = f$3(x0$55);
              i$4 = ((1 + i$4) | 0);
            }
          } else if ((xs$4 instanceof $ac_S)) {
            while ((i$4 < len$3)) {
              var $x_46 = i$4;
              var x0$56 = xs$4.a[i$4];
              ys$3.a[$x_46] = f$3(x0$56);
              i$4 = ((1 + i$4) | 0);
            }
          } else if ((xs$4 instanceof $ac_Z)) {
            while ((i$4 < len$3)) {
              var $x_47 = i$4;
              var x0$57 = xs$4.a[i$4];
              ys$3.a[$x_47] = f$3(x0$57);
              i$4 = ((1 + i$4) | 0);
            }
          } else {
            throw new $c_s_MatchError(xs$4);
          }
        }
        var elem = $m_sc_ArrayOps$().afc(ys$3, "filled");
      } else {
        var elem = false;
      }
      var elem$1 = false;
      elem$1 = elem;
      var elem$2 = $m_s_None$();
      var elem$3 = null;
      elem$3 = elem$2;
      var elem$4 = $m_s_None$();
      var elem$5 = null;
      elem$5 = elem$4;
      var this$106 = a$3.r("color");
      var this$109 = ((this$106.c() || (this$106.d() !== "")) ? this$106 : $m_s_None$());
      if ((!this$109.c())) {
        var x0$59 = this$109.d();
        elem$3 = new $c_s_Some(x0$59);
        elem$5 = new $c_s_Some(x0$59);
      }
      var this$112 = a$3.r("pencolor");
      var this$115 = ((this$112.c() || (this$112.d() !== "")) ? this$112 : $m_s_None$());
      if ((!this$115.c())) {
        var x0$61 = this$115.d();
        elem$3 = new $c_s_Some(x0$61);
      }
      var this$117 = a$3.r("fillcolor");
      var this$120 = ((this$117.c() || (this$117.d() !== "")) ? this$117 : $m_s_None$());
      if ((!this$120.c())) {
        var x0$63 = this$120.d();
        elem$5 = new $c_s_Some(x0$63);
      }
      if (((!elem$1) || elem$5.c())) {
        var this$122 = a$3.r("bgcolor");
        var this$125 = ((this$122.c() || (this$122.d() !== "")) ? this$122 : $m_s_None$());
        if ((!this$125.c())) {
          var x0$65 = this$125.d();
          elem$5 = new $c_s_Some(x0$65);
          elem$1 = true;
        }
      }
      var this$127 = elem$3;
      var pen = $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__fillPaint$1__T__T(this, (this$127.c() ? "black" : this$127.d()));
      if (elem$1) {
        var this$128 = elem$5;
        var fill = $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__fillPaint$1__T__T(this, (this$128.c() ? "lightgrey" : this$128.d()));
      } else {
        var fill = "none";
      }
      $m_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$();
      var f$4 = ((key) => a$3.r(key));
      var this$130 = f$4("penwidth");
      if (this$130.c()) {
        var this$134 = $m_s_None$();
      } else {
        var x0$66 = this$130.d();
        var this$134 = ($m_sc_StringParsers$().c1(x0$66) ? new $c_s_Some($m_jl_Double$().bd(x0$66)) : $m_s_None$());
      }
      if (this$134.c()) {
        var this$135 = f$4("style");
        if (this$135.c()) {
          var $x_48 = $m_s_None$();
        } else {
          var x0$67 = this$135.d();
          var elem$6 = $m_s_None$();
          var elem$7 = null;
          elem$7 = elem$6;
          var this$139 = new $c_sc_Iterator$$anon$9($m_sc_ArrayOps$().u8($f_T__split__T__I__AT(x0$67, ",", 0)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => $f_T__trim__T(_$2))));
          while (this$139.p()) {
            var x0$68 = this$139.q();
            if ((x0$68 === "bold")) {
              elem$7 = new $c_s_Some(2.0);
            } else if (((!(!x0$68.startsWith("setlinewidth("))) && (!(!x0$68.endsWith(")"))))) {
              var x$7 = $f_T__trim__T($m_sc_StringOps$().wh($m_sc_StringOps$().wg(x0$68, "setlinewidth("), ")"));
              var this$145 = $m_sc_StringParsers$();
              var this$146 = (this$145.c1(x$7) ? new $c_s_Some($m_jl_Double$().bd(x$7)) : $m_s_None$());
              elem$7 = (this$146.c() ? new $c_s_Some(0.0) : this$146);
            }
          }
          var $x_48 = elem$7;
        }
      } else {
        var $x_48 = this$134;
      }
      var this$148 = $x_48;
      var cpw = (+(this$148.c() ? 1.0 : this$148.d()));
      var sw = ((cpw !== 1.0) ? ((" stroke-width=\"" + $m_Lorg_jpablo_graphexplorer_graphviz_output_Output$().dU(cpw)) + "\"") : "");
      var this$149 = a$3.r("style");
      if ((!this$149.c())) {
        var x0$69 = this$149.d();
        var xs$6 = $f_T__split__T__I__AT(x0$69, ",", 0);
        var f$6 = ((_$29) => $f_T__trim__T(_$29));
        var len$4 = xs$6.a.length;
        var ys$4 = new ($d_T.r().C)(len$4);
        if ((len$4 > 0)) {
          var i$5 = 0;
          if ((xs$6 !== null)) {
            while ((i$5 < len$4)) {
              var $x_49 = i$5;
              var x0$70 = xs$6.a[i$5];
              ys$4.a[$x_49] = f$6(x0$70);
              i$5 = ((1 + i$5) | 0);
            }
          } else if ((xs$6 instanceof $ac_I)) {
            while ((i$5 < len$4)) {
              var $x_50 = i$5;
              var x0$71 = xs$6.a[i$5];
              ys$4.a[$x_50] = f$6(x0$71);
              i$5 = ((1 + i$5) | 0);
            }
          } else if ((xs$6 instanceof $ac_D)) {
            while ((i$5 < len$4)) {
              var $x_51 = i$5;
              var x0$72 = xs$6.a[i$5];
              ys$4.a[$x_51] = f$6(x0$72);
              i$5 = ((1 + i$5) | 0);
            }
          } else if ((xs$6 instanceof $ac_J)) {
            while ((i$5 < len$4)) {
              var $x_54 = i$5;
              var $x_52 = xs$6.a;
              var $x_53 = (i$5 << 1);
              var x0$73_$_lo = $x_52[$x_53];
              var x0$73_$_hi = $x_52[(($x_53 + 1) | 0)];
              ys$4.a[$x_54] = f$6($bL(x0$73_$_lo, x0$73_$_hi));
              i$5 = ((1 + i$5) | 0);
            }
          } else if ((xs$6 instanceof $ac_F)) {
            while ((i$5 < len$4)) {
              var $x_55 = i$5;
              var x0$74 = xs$6.a[i$5];
              ys$4.a[$x_55] = f$6(x0$74);
              i$5 = ((1 + i$5) | 0);
            }
          } else if ((xs$6 instanceof $ac_C)) {
            while ((i$5 < len$4)) {
              var $x_56 = i$5;
              var x0$75 = xs$6.a[i$5];
              ys$4.a[$x_56] = f$6($bC(x0$75));
              i$5 = ((1 + i$5) | 0);
            }
          } else if ((xs$6 instanceof $ac_B)) {
            while ((i$5 < len$4)) {
              var $x_57 = i$5;
              var x0$76 = xs$6.a[i$5];
              ys$4.a[$x_57] = f$6(x0$76);
              i$5 = ((1 + i$5) | 0);
            }
          } else if ((xs$6 instanceof $ac_S)) {
            while ((i$5 < len$4)) {
              var $x_58 = i$5;
              var x0$77 = xs$6.a[i$5];
              ys$4.a[$x_58] = f$6(x0$77);
              i$5 = ((1 + i$5) | 0);
            }
          } else if ((xs$6 instanceof $ac_Z)) {
            while ((i$5 < len$4)) {
              var $x_59 = i$5;
              var x0$78 = xs$6.a[i$5];
              ys$4.a[$x_59] = f$6(x0$78);
              i$5 = ((1 + i$5) | 0);
            }
          } else {
            throw new $c_s_MatchError(xs$6);
          }
        }
        var rounded = $m_sc_ArrayOps$().afc(ys$4, "rounded");
      } else {
        var rounded = false;
      }
      if ((!invis)) {
        if (rounded) {
          var af = $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2(llx, lly), new $c_T2(urx, lly), new $c_T2(urx, ury), new $c_T2(llx, ury)])));
          var pts = $m_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$().aRO(af).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
            var px = (+x$1$2.g());
            var py = (+x$1$2.h());
            return (($m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$().ac(px) + ",") + $m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$().ac((-py)));
          })));
          sb.ad((((((((((("<path fill=\"" + fill) + "\" stroke=\"") + pen) + "\"") + sw) + " d=\"M") + pts.t()) + "C") + $f_sc_IterableOnceOps__mkString__T__T__T__T(pts.mX(), "", " ", "")) + "\"/>\n"));
        } else {
          sb.ad((((((((((((((((((((((((((("<polygon fill=\"" + fill) + "\" stroke=\"") + pen) + "\"") + sw) + " points=\"") + this.ac(llx)) + ",") + this.ac((-lly))) + " ") + this.ac(llx)) + ",") + this.ac((-ury))) + " ") + this.ac(urx)) + ",") + this.ac((-ury))) + " ") + this.ac(urx)) + ",") + this.ac((-lly))) + " ") + this.ac(llx)) + ",") + this.ac((-lly))) + "\"/>\n"));
        }
      }
      if ((c$1.pv() && (!invis))) {
        matchResult18: {
          var \u03b49$___1;
          var \u03b49$___2;
          var x64 = $f_F2__tupled__F1(tf).i(c$1.aPG(cbbs.l(i$2), $m_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$().jT(g)));
          if ((x64 !== null)) {
            var \u03b49$___1 = (+x64.g());
            var \u03b49$___2 = (+x64.h());
            break matchResult18;
          }
          throw new $c_s_MatchError(x64);
        }
        sb.ad($p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__textAt$1__D__D__T__T__T__D__T(this, (+\u03b49$___1), (+\u03b49$___2), c$1.Fb, c$1.KF, c$1.KG, c$1.KH));
      }
      return sb.ad("</g>\n");
    })));
  }
  var htmlGradId = new $c_sr_IntRef(0);
  var op = (g.z6 ? "->" : "--");
  var nodeIdx = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$16(new $c_sc_Iterator$$anon$9(g.cB.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$40) => _$40.br)))));
  var emitted = $m_scm_Set$().aO();
  var this$168 = g.cu;
  var end = this$168.C();
  var isEmpty = (end <= 0);
  var scala$collection$immutable$Range$$lastElement = ((end - 1) | 0);
  var m = $m_scm_Map$().aO();
  var it = new $c_sci_RangeIterator(0, 1, scala$collection$immutable$Range$$lastElement, isEmpty);
  while (it.g0) {
    var elem$8 = it.hp();
    var key$1 = g.cu.l(elem$8).ai;
    m.ec(key$1, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_IndexedSeq$().b5()))).Y(elem$8);
  }
  var result = $m_sci_HashMap$().fk;
  var mapIt = m.o();
  while (mapIt.p()) {
    var x1 = mapIt.q();
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1);
    }
    var k = x1.g();
    var v = x1.h();
    result = result.hq(k, v.aR());
  }
  var outEdgeIdxByTail = result;
  var this$173 = g.cB;
  var end$1 = this$173.C();
  var isEmpty$1 = (end$1 <= 0);
  var scala$collection$immutable$Range$$lastElement$1 = ((end$1 - 1) | 0);
  if ((!isEmpty$1)) {
    var i$6 = 0;
    while (true) {
      var x0$79 = i$6;
      $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__ensureNode$1__sci_Map__scm_Set__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__scm_StringBuilder__F2__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Result__sr_IntRef__T__V(this, nodeIdx, emitted, g, xs, sb, tf, yOf$2, ranks, xlabels, htmlGradId, g.cB.l(x0$79).br);
      $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(outEdgeIdxByTail.ay(g.cB.l(x0$79).br, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_Seq$().f7()))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((nodeIdx, g) => ((ix) => {
        var ix$1 = (ix | 0);
        return new $c_T2(nodeIdx.ay(g.cu.l(ix$1).ak, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 2147483647))), ix$1);
      }))(nodeIdx, g)), new $c_s_math_Ordering$Tuple2Ordering($m_s_math_Ordering$Int$(), $m_s_math_Ordering$Int$())).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((g, nodeIdx, emitted, xs, sb, tf, yOf$2, ranks, xlabels, htmlGradId, spl, op, labelPos) => ((v1) => {
        var ix$2 = (v1 | 0);
        $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__ensureNode$1__sci_Map__scm_Set__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__scm_StringBuilder__F2__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Result__sr_IntRef__T__V(this, nodeIdx, emitted, g, xs, sb, tf, yOf$2, ranks, xlabels, htmlGradId, g.cu.l(ix$2).ak);
        $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__emitEdge$1__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__F2__T__scm_StringBuilder__sci_Map__Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Result__sr_IntRef__I__I__V(this, g, spl, tf, op, sb, labelPos, xlabels, htmlGradId, ix$2, ((1 + ix$2) | 0));
      }))(g, nodeIdx, emitted, xs, sb, tf, yOf$2, ranks, xlabels, htmlGradId, spl, op, labelPos)));
      if ((i$6 === scala$collection$immutable$Range$$lastElement$1)) {
        break;
      }
      i$6 = ((1 + i$6) | 0);
    }
  }
  var this$179 = g.cB;
  var end$2 = this$179.C();
  var isEmpty$2 = (end$2 <= 0);
  var scala$collection$immutable$Range$$lastElement$2 = ((end$2 - 1) | 0);
  if ((!isEmpty$2)) {
    var i$7 = 0;
    while (true) {
      var x0$80 = i$7;
      $p_Lorg_jpablo_graphexplorer_graphviz_output_Svg$__ensureNode$1__sci_Map__scm_Set__Lorg_jpablo_graphexplorer_graphviz_model_RGraph__sci_Map__scm_StringBuilder__F2__sci_Map__sci_Map__Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Result__sr_IntRef__T__V(this, nodeIdx, emitted, g, xs, sb, tf, yOf$2, ranks, xlabels, htmlGradId, g.cB.l(x0$80).br);
      if ((i$7 === scala$collection$immutable$Range$$lastElement$2)) {
        break;
      }
      i$7 = ((1 + i$7) | 0);
    }
  }
  sb.ad("</g>\n</svg>\n");
  return sb.bP.ah;
});
var $d_Lorg_jpablo_graphexplorer_graphviz_output_Svg$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_output_Svg$, "org.jpablo.graphexplorer.graphviz.output.Svg$", ({
  vD: 1
}));
var $n_Lorg_jpablo_graphexplorer_graphviz_output_Svg$;
function $m_Lorg_jpablo_graphexplorer_graphviz_output_Svg$() {
  if ((!$n_Lorg_jpablo_graphexplorer_graphviz_output_Svg$)) {
    $n_Lorg_jpablo_graphexplorer_graphviz_output_Svg$ = new $c_Lorg_jpablo_graphexplorer_graphviz_output_Svg$();
  }
  return $n_Lorg_jpablo_graphexplorer_graphviz_output_Svg$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_output_X11Colors$() {
  this.auD = null;
  $n_Lorg_jpablo_graphexplorer_graphviz_output_X11Colors$ = this;
  this.auD = $m_sci_Map$().ao($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("antiquewhite1", "#ffefdb"), new $c_T2("antiquewhite2", "#eedfcc"), new $c_T2("antiquewhite3", "#cdc0b0"), new $c_T2("antiquewhite4", "#8b8378"), new $c_T2("aquamarine1", "#7fffd4"), new $c_T2("aquamarine2", "#76eec6"), new $c_T2("aquamarine3", "#66cdaa"), new $c_T2("aquamarine4", "#458b74"), new $c_T2("azure1", "#f0ffff"), new $c_T2("azure2", "#e0eeee"), new $c_T2("azure3", "#c1cdcd"), new $c_T2("azure4", "#838b8b"), new $c_T2("bisque1", "#ffe4c4"), new $c_T2("bisque2", "#eed5b7"), new $c_T2("bisque3", "#cdb79e"), new $c_T2("bisque4", "#8b7d6b"), new $c_T2("blue1", "#0000ff"), new $c_T2("blue2", "#0000ee"), new $c_T2("blue3", "#0000cd"), new $c_T2("blue4", "#00008b"), new $c_T2("brown1", "#ff4040"), new $c_T2("brown2", "#ee3b3b"), new $c_T2("brown3", "#cd3333"), new $c_T2("brown4", "#8b2323"), new $c_T2("burlywood1", "#ffd39b"), new $c_T2("burlywood2", "#eec591"), new $c_T2("burlywood3", "#cdaa7d"), new $c_T2("burlywood4", "#8b7355"), new $c_T2("cadetblue1", "#98f5ff"), new $c_T2("cadetblue2", "#8ee5ee"), new $c_T2("cadetblue3", "#7ac5cd"), new $c_T2("cadetblue4", "#53868b"), new $c_T2("chartreuse1", "#7fff00"), new $c_T2("chartreuse2", "#76ee00"), new $c_T2("chartreuse3", "#66cd00"), new $c_T2("chartreuse4", "#458b00"), new $c_T2("chocolate1", "#ff7f24"), new $c_T2("chocolate2", "#ee7621"), new $c_T2("chocolate3", "#cd661d"), new $c_T2("chocolate4", "#8b4513"), new $c_T2("coral1", "#ff7256"), new $c_T2("coral2", "#ee6a50"), new $c_T2("coral3", "#cd5b45"), new $c_T2("coral4", "#8b3e2f"), new $c_T2("cornsilk1", "#fff8dc"), new $c_T2("cornsilk2", "#eee8cd"), new $c_T2("cornsilk3", "#cdc8b1"), new $c_T2("cornsilk4", "#8b8878"), new $c_T2("cyan1", "#00ffff"), new $c_T2("cyan2", "#00eeee"), new $c_T2("cyan3", "#00cdcd"), new $c_T2("cyan4", "#008b8b"), new $c_T2("darkgoldenrod1", "#ffb90f"), new $c_T2("darkgoldenrod2", "#eead0e"), new $c_T2("darkgoldenrod3", "#cd950c"), new $c_T2("darkgoldenrod4", "#8b6508"), new $c_T2("darkolivegreen1", "#caff70"), new $c_T2("darkolivegreen2", "#bcee68"), new $c_T2("darkolivegreen3", "#a2cd5a"), new $c_T2("darkolivegreen4", "#6e8b3d"), new $c_T2("darkorange1", "#ff7f00"), new $c_T2("darkorange2", "#ee7600"), new $c_T2("darkorange3", "#cd6600"), new $c_T2("darkorange4", "#8b4500"), new $c_T2("darkorchid1", "#bf3eff"), new $c_T2("darkorchid2", "#b23aee"), new $c_T2("darkorchid3", "#9a32cd"), new $c_T2("darkorchid4", "#68228b"), new $c_T2("darkseagreen1", "#c1ffc1"), new $c_T2("darkseagreen2", "#b4eeb4"), new $c_T2("darkseagreen3", "#9bcd9b"), new $c_T2("darkseagreen4", "#698b69"), new $c_T2("darkslategray1", "#97ffff"), new $c_T2("darkslategray2", "#8deeee"), new $c_T2("darkslategray3", "#79cdcd"), new $c_T2("darkslategray4", "#528b8b"), new $c_T2("deeppink1", "#ff1493"), new $c_T2("deeppink2", "#ee1289"), new $c_T2("deeppink3", "#cd1076"), new $c_T2("deeppink4", "#8b0a50"), new $c_T2("deepskyblue1", "#00bfff"), new $c_T2("deepskyblue2", "#00b2ee"), new $c_T2("deepskyblue3", "#009acd"), new $c_T2("deepskyblue4", "#00688b"), new $c_T2("dodgerblue1", "#1e90ff"), new $c_T2("dodgerblue2", "#1c86ee"), new $c_T2("dodgerblue3", "#1874cd"), new $c_T2("dodgerblue4", "#104e8b"), new $c_T2("firebrick1", "#ff3030"), new $c_T2("firebrick2", "#ee2c2c"), new $c_T2("firebrick3", "#cd2626"), new $c_T2("firebrick4", "#8b1a1a"), new $c_T2("gold1", "#ffd700"), new $c_T2("gold2", "#eec900"), new $c_T2("gold3", "#cdad00"), new $c_T2("gold4", "#8b7500"), new $c_T2("goldenrod1", "#ffc125"), new $c_T2("goldenrod2", "#eeb422"), new $c_T2("goldenrod3", "#cd9b1d"), new $c_T2("goldenrod4", "#8b6914"), new $c_T2("gray0", "#000000"), new $c_T2("gray1", "#030303"), new $c_T2("gray10", "#1a1a1a"), new $c_T2("gray100", "#ffffff"), new $c_T2("gray11", "#1c1c1c"), new $c_T2("gray12", "#1f1f1f"), new $c_T2("gray13", "#212121"), new $c_T2("gray14", "#242424"), new $c_T2("gray15", "#262626"), new $c_T2("gray16", "#292929"), new $c_T2("gray17", "#2b2b2b"), new $c_T2("gray18", "#2e2e2e"), new $c_T2("gray19", "#303030"), new $c_T2("gray2", "#050505"), new $c_T2("gray20", "#333333"), new $c_T2("gray21", "#363636"), new $c_T2("gray22", "#383838"), new $c_T2("gray23", "#3b3b3b"), new $c_T2("gray24", "#3d3d3d"), new $c_T2("gray25", "#404040"), new $c_T2("gray26", "#424242"), new $c_T2("gray27", "#454545"), new $c_T2("gray28", "#474747"), new $c_T2("gray29", "#4a4a4a"), new $c_T2("gray3", "#080808"), new $c_T2("gray30", "#4d4d4d"), new $c_T2("gray31", "#4f4f4f"), new $c_T2("gray32", "#525252"), new $c_T2("gray33", "#545454"), new $c_T2("gray34", "#575757"), new $c_T2("gray35", "#595959"), new $c_T2("gray36", "#5c5c5c"), new $c_T2("gray37", "#5e5e5e"), new $c_T2("gray38", "#616161"), new $c_T2("gray39", "#636363"), new $c_T2("gray4", "#0a0a0a"), new $c_T2("gray40", "#666666"), new $c_T2("gray41", "#696969"), new $c_T2("gray42", "#6b6b6b"), new $c_T2("gray43", "#6e6e6e"), new $c_T2("gray44", "#707070"), new $c_T2("gray45", "#737373"), new $c_T2("gray46", "#757575"), new $c_T2("gray47", "#787878"), new $c_T2("gray48", "#7a7a7a"), new $c_T2("gray49", "#7d7d7d"), new $c_T2("gray5", "#0d0d0d"), new $c_T2("gray50", "#7f7f7f"), new $c_T2("gray51", "#828282"), new $c_T2("gray52", "#858585"), new $c_T2("gray53", "#878787"), new $c_T2("gray54", "#8a8a8a"), new $c_T2("gray55", "#8c8c8c"), new $c_T2("gray56", "#8f8f8f"), new $c_T2("gray57", "#919191"), new $c_T2("gray58", "#949494"), new $c_T2("gray59", "#969696"), new $c_T2("gray6", "#0f0f0f"), new $c_T2("gray60", "#999999"), new $c_T2("gray61", "#9c9c9c"), new $c_T2("gray62", "#9e9e9e"), new $c_T2("gray63", "#a1a1a1"), new $c_T2("gray64", "#a3a3a3"), new $c_T2("gray65", "#a6a6a6"), new $c_T2("gray66", "#a8a8a8"), new $c_T2("gray67", "#ababab"), new $c_T2("gray68", "#adadad"), new $c_T2("gray69", "#b0b0b0"), new $c_T2("gray7", "#121212"), new $c_T2("gray70", "#b3b3b3"), new $c_T2("gray71", "#b5b5b5"), new $c_T2("gray72", "#b8b8b8"), new $c_T2("gray73", "#bababa"), new $c_T2("gray74", "#bdbdbd"), new $c_T2("gray75", "#bfbfbf"), new $c_T2("gray76", "#c2c2c2"), new $c_T2("gray77", "#c4c4c4"), new $c_T2("gray78", "#c7c7c7"), new $c_T2("gray79", "#c9c9c9"), new $c_T2("gray8", "#141414"), new $c_T2("gray80", "#cccccc"), new $c_T2("gray81", "#cfcfcf"), new $c_T2("gray82", "#d1d1d1"), new $c_T2("gray83", "#d4d4d4"), new $c_T2("gray84", "#d6d6d6"), new $c_T2("gray85", "#d9d9d9"), new $c_T2("gray86", "#dbdbdb"), new $c_T2("gray87", "#dedede"), new $c_T2("gray88", "#e0e0e0"), new $c_T2("gray89", "#e3e3e3"), new $c_T2("gray9", "#171717"), new $c_T2("gray90", "#e5e5e5"), new $c_T2("gray91", "#e8e8e8"), new $c_T2("gray92", "#ebebeb"), new $c_T2("gray93", "#ededed"), new $c_T2("gray94", "#f0f0f0"), new $c_T2("gray95", "#f2f2f2"), new $c_T2("gray96", "#f5f5f5"), new $c_T2("gray97", "#f7f7f7"), new $c_T2("gray98", "#fafafa"), new $c_T2("gray99", "#fcfcfc"), new $c_T2("green1", "#00ff00"), new $c_T2("green2", "#00ee00"), new $c_T2("green3", "#00cd00"), new $c_T2("green4", "#008b00"), new $c_T2("grey0", "#000000"), new $c_T2("grey1", "#030303"), new $c_T2("grey10", "#1a1a1a"), new $c_T2("grey100", "#ffffff"), new $c_T2("grey11", "#1c1c1c"), new $c_T2("grey12", "#1f1f1f"), new $c_T2("grey13", "#212121"), new $c_T2("grey14", "#242424"), new $c_T2("grey15", "#262626"), new $c_T2("grey16", "#292929"), new $c_T2("grey17", "#2b2b2b"), new $c_T2("grey18", "#2e2e2e"), new $c_T2("grey19", "#303030"), new $c_T2("grey2", "#050505"), new $c_T2("grey20", "#333333"), new $c_T2("grey21", "#363636"), new $c_T2("grey22", "#383838"), new $c_T2("grey23", "#3b3b3b"), new $c_T2("grey24", "#3d3d3d"), new $c_T2("grey25", "#404040"), new $c_T2("grey26", "#424242"), new $c_T2("grey27", "#454545"), new $c_T2("grey28", "#474747"), new $c_T2("grey29", "#4a4a4a"), new $c_T2("grey3", "#080808"), new $c_T2("grey30", "#4d4d4d"), new $c_T2("grey31", "#4f4f4f"), new $c_T2("grey32", "#525252"), new $c_T2("grey33", "#545454"), new $c_T2("grey34", "#575757"), new $c_T2("grey35", "#595959"), new $c_T2("grey36", "#5c5c5c"), new $c_T2("grey37", "#5e5e5e"), new $c_T2("grey38", "#616161"), new $c_T2("grey39", "#636363"), new $c_T2("grey4", "#0a0a0a"), new $c_T2("grey40", "#666666"), new $c_T2("grey41", "#696969"), new $c_T2("grey42", "#6b6b6b"), new $c_T2("grey43", "#6e6e6e"), new $c_T2("grey44", "#707070"), new $c_T2("grey45", "#737373"), new $c_T2("grey46", "#757575"), new $c_T2("grey47", "#787878"), new $c_T2("grey48", "#7a7a7a"), new $c_T2("grey49", "#7d7d7d"), new $c_T2("grey5", "#0d0d0d"), new $c_T2("grey50", "#7f7f7f"), new $c_T2("grey51", "#828282"), new $c_T2("grey52", "#858585"), new $c_T2("grey53", "#878787"), new $c_T2("grey54", "#8a8a8a"), new $c_T2("grey55", "#8c8c8c"), new $c_T2("grey56", "#8f8f8f"), new $c_T2("grey57", "#919191"), new $c_T2("grey58", "#949494"), new $c_T2("grey59", "#969696"), new $c_T2("grey6", "#0f0f0f"), new $c_T2("grey60", "#999999"), new $c_T2("grey61", "#9c9c9c"), new $c_T2("grey62", "#9e9e9e"), new $c_T2("grey63", "#a1a1a1"), new $c_T2("grey64", "#a3a3a3"), new $c_T2("grey65", "#a6a6a6"), new $c_T2("grey66", "#a8a8a8"), new $c_T2("grey67", "#ababab"), new $c_T2("grey68", "#adadad"), new $c_T2("grey69", "#b0b0b0"), new $c_T2("grey7", "#121212"), new $c_T2("grey70", "#b3b3b3"), new $c_T2("grey71", "#b5b5b5"), new $c_T2("grey72", "#b8b8b8"), new $c_T2("grey73", "#bababa"), new $c_T2("grey74", "#bdbdbd"), new $c_T2("grey75", "#bfbfbf"), new $c_T2("grey76", "#c2c2c2"), new $c_T2("grey77", "#c4c4c4"), new $c_T2("grey78", "#c7c7c7"), new $c_T2("grey79", "#c9c9c9"), new $c_T2("grey8", "#141414"), new $c_T2("grey80", "#cccccc"), new $c_T2("grey81", "#cfcfcf"), new $c_T2("grey82", "#d1d1d1"), new $c_T2("grey83", "#d4d4d4"), new $c_T2("grey84", "#d6d6d6"), new $c_T2("grey85", "#d9d9d9"), new $c_T2("grey86", "#dbdbdb"), new $c_T2("grey87", "#dedede"), new $c_T2("grey88", "#e0e0e0"), new $c_T2("grey89", "#e3e3e3"), new $c_T2("grey9", "#171717"), new $c_T2("grey90", "#e5e5e5"), new $c_T2("grey91", "#e8e8e8"), new $c_T2("grey92", "#ebebeb"), new $c_T2("grey93", "#ededed"), new $c_T2("grey94", "#f0f0f0"), new $c_T2("grey95", "#f2f2f2"), new $c_T2("grey96", "#f5f5f5"), new $c_T2("grey97", "#f7f7f7"), new $c_T2("grey98", "#fafafa"), new $c_T2("grey99", "#fcfcfc"), new $c_T2("honeydew1", "#f0fff0"), new $c_T2("honeydew2", "#e0eee0"), new $c_T2("honeydew3", "#c1cdc1"), new $c_T2("honeydew4", "#838b83"), new $c_T2("hotpink1", "#ff6eb4"), new $c_T2("hotpink2", "#ee6aa7"), new $c_T2("hotpink3", "#cd6090"), new $c_T2("hotpink4", "#8b3a62"), new $c_T2("indianred1", "#ff6a6a"), new $c_T2("indianred2", "#ee6363"), new $c_T2("indianred3", "#cd5555"), new $c_T2("indianred4", "#8b3a3a"), new $c_T2("ivory1", "#fffff0"), new $c_T2("ivory2", "#eeeee0"), new $c_T2("ivory3", "#cdcdc1"), new $c_T2("ivory4", "#8b8b83"), new $c_T2("khaki1", "#fff68f"), new $c_T2("khaki2", "#eee685"), new $c_T2("khaki3", "#cdc673"), new $c_T2("khaki4", "#8b864e"), new $c_T2("lavenderblush1", "#fff0f5"), new $c_T2("lavenderblush2", "#eee0e5"), new $c_T2("lavenderblush3", "#cdc1c5"), new $c_T2("lavenderblush4", "#8b8386"), new $c_T2("lemonchiffon1", "#fffacd"), new $c_T2("lemonchiffon2", "#eee9bf"), new $c_T2("lemonchiffon3", "#cdc9a5"), new $c_T2("lemonchiffon4", "#8b8970"), new $c_T2("lightblue1", "#bfefff"), new $c_T2("lightblue2", "#b2dfee"), new $c_T2("lightblue3", "#9ac0cd"), new $c_T2("lightblue4", "#68838b"), new $c_T2("lightcyan1", "#e0ffff"), new $c_T2("lightcyan2", "#d1eeee"), new $c_T2("lightcyan3", "#b4cdcd"), new $c_T2("lightcyan4", "#7a8b8b"), new $c_T2("lightgoldenrod", "#eedd82"), new $c_T2("lightgoldenrod1", "#ffec8b"), new $c_T2("lightgoldenrod2", "#eedc82"), new $c_T2("lightgoldenrod3", "#cdbe70"), new $c_T2("lightgoldenrod4", "#8b814c"), new $c_T2("lightpink1", "#ffaeb9"), new $c_T2("lightpink2", "#eea2ad"), new $c_T2("lightpink3", "#cd8c95"), new $c_T2("lightpink4", "#8b5f65"), new $c_T2("lightsalmon1", "#ffa07a"), new $c_T2("lightsalmon2", "#ee9572"), new $c_T2("lightsalmon3", "#cd8162"), new $c_T2("lightsalmon4", "#8b5742"), new $c_T2("lightskyblue1", "#b0e2ff"), new $c_T2("lightskyblue2", "#a4d3ee"), new $c_T2("lightskyblue3", "#8db6cd"), new $c_T2("lightskyblue4", "#607b8b"), new $c_T2("lightslateblue", "#8470ff"), new $c_T2("lightsteelblue1", "#cae1ff"), new $c_T2("lightsteelblue2", "#bcd2ee"), new $c_T2("lightsteelblue3", "#a2b5cd"), new $c_T2("lightsteelblue4", "#6e7b8b"), new $c_T2("lightyellow1", "#ffffe0"), new $c_T2("lightyellow2", "#eeeed1"), new $c_T2("lightyellow3", "#cdcdb4"), new $c_T2("lightyellow4", "#8b8b7a"), new $c_T2("magenta1", "#ff00ff"), new $c_T2("magenta2", "#ee00ee"), new $c_T2("magenta3", "#cd00cd"), new $c_T2("magenta4", "#8b008b"), new $c_T2("maroon1", "#ff34b3"), new $c_T2("maroon2", "#ee30a7"), new $c_T2("maroon3", "#cd2990"), new $c_T2("maroon4", "#8b1c62"), new $c_T2("mediumorchid1", "#e066ff"), new $c_T2("mediumorchid2", "#d15fee"), new $c_T2("mediumorchid3", "#b452cd"), new $c_T2("mediumorchid4", "#7a378b"), new $c_T2("mediumpurple1", "#ab82ff"), new $c_T2("mediumpurple2", "#9f79ee"), new $c_T2("mediumpurple3", "#8968cd"), new $c_T2("mediumpurple4", "#5d478b"), new $c_T2("mistyrose1", "#ffe4e1"), new $c_T2("mistyrose2", "#eed5d2"), new $c_T2("mistyrose3", "#cdb7b5"), new $c_T2("mistyrose4", "#8b7d7b"), new $c_T2("navajowhite1", "#ffdead"), new $c_T2("navajowhite2", "#eecfa1"), new $c_T2("navajowhite3", "#cdb38b"), new $c_T2("navajowhite4", "#8b795e"), new $c_T2("navyblue", "#000080"), new $c_T2("olivedrab1", "#c0ff3e"), new $c_T2("olivedrab2", "#b3ee3a"), new $c_T2("olivedrab3", "#9acd32"), new $c_T2("olivedrab4", "#698b22"), new $c_T2("orange1", "#ffa500"), new $c_T2("orange2", "#ee9a00"), new $c_T2("orange3", "#cd8500"), new $c_T2("orange4", "#8b5a00"), new $c_T2("orangered1", "#ff4500"), new $c_T2("orangered2", "#ee4000"), new $c_T2("orangered3", "#cd3700"), new $c_T2("orangered4", "#8b2500"), new $c_T2("orchid1", "#ff83fa"), new $c_T2("orchid2", "#ee7ae9"), new $c_T2("orchid3", "#cd69c9"), new $c_T2("orchid4", "#8b4789"), new $c_T2("palegreen1", "#9aff9a"), new $c_T2("palegreen2", "#90ee90"), new $c_T2("palegreen3", "#7ccd7c"), new $c_T2("palegreen4", "#548b54"), new $c_T2("paleturquoise1", "#bbffff"), new $c_T2("paleturquoise2", "#aeeeee"), new $c_T2("paleturquoise3", "#96cdcd"), new $c_T2("paleturquoise4", "#668b8b"), new $c_T2("palevioletred1", "#ff82ab"), new $c_T2("palevioletred2", "#ee799f"), new $c_T2("palevioletred3", "#cd6889"), new $c_T2("palevioletred4", "#8b475d"), new $c_T2("peachpuff1", "#ffdab9"), new $c_T2("peachpuff2", "#eecbad"), new $c_T2("peachpuff3", "#cdaf95"), new $c_T2("peachpuff4", "#8b7765"), new $c_T2("pink1", "#ffb5c5"), new $c_T2("pink2", "#eea9b8"), new $c_T2("pink3", "#cd919e"), new $c_T2("pink4", "#8b636c"), new $c_T2("plum1", "#ffbbff"), new $c_T2("plum2", "#eeaeee"), new $c_T2("plum3", "#cd96cd"), new $c_T2("plum4", "#8b668b"), new $c_T2("purple1", "#9b30ff"), new $c_T2("purple2", "#912cee"), new $c_T2("purple3", "#7d26cd"), new $c_T2("purple4", "#551a8b"), new $c_T2("rebeccapurple", "#663399"), new $c_T2("red1", "#ff0000"), new $c_T2("red2", "#ee0000"), new $c_T2("red3", "#cd0000"), new $c_T2("red4", "#8b0000"), new $c_T2("rosybrown1", "#ffc1c1"), new $c_T2("rosybrown2", "#eeb4b4"), new $c_T2("rosybrown3", "#cd9b9b"), new $c_T2("rosybrown4", "#8b6969"), new $c_T2("royalblue1", "#4876ff"), new $c_T2("royalblue2", "#436eee"), new $c_T2("royalblue3", "#3a5fcd"), new $c_T2("royalblue4", "#27408b"), new $c_T2("salmon1", "#ff8c69"), new $c_T2("salmon2", "#ee8262"), new $c_T2("salmon3", "#cd7054"), new $c_T2("salmon4", "#8b4c39"), new $c_T2("seagreen1", "#54ff9f"), new $c_T2("seagreen2", "#4eee94"), new $c_T2("seagreen3", "#43cd80"), new $c_T2("seagreen4", "#2e8b57"), new $c_T2("seashell1", "#fff5ee"), new $c_T2("seashell2", "#eee5de"), new $c_T2("seashell3", "#cdc5bf"), new $c_T2("seashell4", "#8b8682"), new $c_T2("sienna1", "#ff8247"), new $c_T2("sienna2", "#ee7942"), new $c_T2("sienna3", "#cd6839"), new $c_T2("sienna4", "#8b4726"), new $c_T2("skyblue1", "#87ceff"), new $c_T2("skyblue2", "#7ec0ee"), new $c_T2("skyblue3", "#6ca6cd"), new $c_T2("skyblue4", "#4a708b"), new $c_T2("slateblue1", "#836fff"), new $c_T2("slateblue2", "#7a67ee"), new $c_T2("slateblue3", "#6959cd"), new $c_T2("slateblue4", "#473c8b"), new $c_T2("slategray1", "#c6e2ff"), new $c_T2("slategray2", "#b9d3ee"), new $c_T2("slategray3", "#9fb6cd"), new $c_T2("slategray4", "#6c7b8b"), new $c_T2("snow1", "#fffafa"), new $c_T2("snow2", "#eee9e9"), new $c_T2("snow3", "#cdc9c9"), new $c_T2("snow4", "#8b8989"), new $c_T2("springgreen1", "#00ff7f"), new $c_T2("springgreen2", "#00ee76"), new $c_T2("springgreen3", "#00cd66"), new $c_T2("springgreen4", "#008b45"), new $c_T2("steelblue1", "#63b8ff"), new $c_T2("steelblue2", "#5cacee"), new $c_T2("steelblue3", "#4f94cd"), new $c_T2("steelblue4", "#36648b"), new $c_T2("tan1", "#ffa54f"), new $c_T2("tan2", "#ee9a49"), new $c_T2("tan3", "#cd853f"), new $c_T2("tan4", "#8b5a2b"), new $c_T2("thistle1", "#ffe1ff"), new $c_T2("thistle2", "#eed2ee"), new $c_T2("thistle3", "#cdb5cd"), new $c_T2("thistle4", "#8b7b8b"), new $c_T2("tomato1", "#ff6347"), new $c_T2("tomato2", "#ee5c42"), new $c_T2("tomato3", "#cd4f39"), new $c_T2("tomato4", "#8b3626"), new $c_T2("turquoise1", "#00f5ff"), new $c_T2("turquoise2", "#00e5ee"), new $c_T2("turquoise3", "#00c5cd"), new $c_T2("turquoise4", "#00868b"), new $c_T2("violetred", "#d02090"), new $c_T2("violetred1", "#ff3e96"), new $c_T2("violetred2", "#ee3a8c"), new $c_T2("violetred3", "#cd3278"), new $c_T2("violetred4", "#8b2252"), new $c_T2("webgray", "#808080"), new $c_T2("webgreen", "#008000"), new $c_T2("webgrey", "#808080"), new $c_T2("webmaroon", "#800000"), new $c_T2("webpurple", "#800080"), new $c_T2("wheat1", "#ffe7ba"), new $c_T2("wheat2", "#eed8ae"), new $c_T2("wheat3", "#cdba96"), new $c_T2("wheat4", "#8b7e66"), new $c_T2("x11gray", "#bebebe"), new $c_T2("x11green", "#00ff00"), new $c_T2("x11grey", "#bebebe"), new $c_T2("x11maroon", "#b03060"), new $c_T2("x11purple", "#a020f0"), new $c_T2("yellow1", "#ffff00"), new $c_T2("yellow2", "#eeee00"), new $c_T2("yellow3", "#cdcd00"), new $c_T2("yellow4", "#8b8b00")])));
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_output_X11Colors$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_output_X11Colors$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_output_X11Colors$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_output_X11Colors$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_graphviz_output_X11Colors$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_output_X11Colors$, "org.jpablo.graphexplorer.graphviz.output.X11Colors$", ({
  vE: 1
}));
var $n_Lorg_jpablo_graphexplorer_graphviz_output_X11Colors$;
function $m_Lorg_jpablo_graphexplorer_graphviz_output_X11Colors$() {
  if ((!$n_Lorg_jpablo_graphexplorer_graphviz_output_X11Colors$)) {
    $n_Lorg_jpablo_graphexplorer_graphviz_output_X11Colors$ = new $c_Lorg_jpablo_graphexplorer_graphviz_output_X11Colors$();
  }
  return $n_Lorg_jpablo_graphexplorer_graphviz_output_X11Colors$;
}
function $p_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommands$__resolve__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand__s_util_Either($thiz, graph, command) {
  matchResult9: {
    var named;
    if (false) {
      var x52 = command.pl();
      command.DC();
      command.aLI();
      var named = x52;
      break matchResult9;
    }
    if (false) {
      var x48 = command.pl();
      command.DC();
      var named = x48;
      break matchResult9;
    }
    if (false) {
      var named = command.pl();
      break matchResult9;
    }
    if (false) {
      var x41 = command.pl();
      command.DC();
      var named = x41;
      break matchResult9;
    }
    if ((command instanceof $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$Ungroup)) {
      var named = command.Li;
      break matchResult9;
    }
    if ((command instanceof $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$CombineIntoRecord)) {
      var named = command.Lf.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x) => x)));
      break matchResult9;
    }
    if ((command instanceof $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$SplitRecord)) {
      var named = $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_ElementId.r().C)([command.Lg])));
      break matchResult9;
    }
    if ((command instanceof $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$TransposeRecord)) {
      var named = $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_ElementId.r().C)([command.Lh])));
      break matchResult9;
    }
    if (false) {
      var named = command.pl();
      break matchResult9;
    }
    matchAlts1: {
      matchAlts2: {
        var x$2 = $s_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$__ListNodes__Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand();
        if (((x$2 === null) ? (command === null) : x$2.e(command))) {
          break matchAlts2;
        }
        var x$4 = $s_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$__ListArrows__Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand();
        if (((x$4 === null) ? (command === null) : x$4.e(command))) {
          break matchAlts2;
        }
        var x$6 = $s_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$__ListGroups__Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand();
        if (((x$6 === null) ? (command === null) : x$6.e(command))) {
          break matchAlts2;
        }
        break matchAlts1;
      }
      var named = $m_sci_Set$EmptySet$();
      break matchResult9;
    }
    throw new $c_s_MatchError(command);
  }
  var missing = named.cE(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => $p_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommands$__exists__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_ElementId__Z($m_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommands$(), graph, _$2))));
  return (missing.c() ? new $c_s_util_Right((void 0)) : new $c_s_util_Left(new $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandError$NotApplicable($m_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$().a4d(command), ("no such element: " + $f_sc_IterableOnceOps__mkString__T__T__T__T($m_sci_Vector$().X(missing).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((id) => {
    $m_Lorg_jpablo_graphexplorer_gxcore_command_ElementRef$();
    return id.kx();
  }))).h9($m_s_math_Ordering$String$()), "", ", ", "")))));
}
function $p_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommands$__exists__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_ElementId__Z($thiz, graph, id) {
  if ((id instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId)) {
    return graph.dQ.l8.E(id);
  }
  if ((id instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowId)) {
    return graph.fX.E(id);
  }
  if ((id instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId)) {
    return graph.aA.fh.E(id);
  }
  throw new $c_s_MatchError(id);
}
function $p_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommands$__interpret__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand__s_util_Either($thiz, graph, command) {
  if (false) {
    var x88 = command.pl();
    var x89 = command.DC();
    var x90 = command.aLI();
    return new $c_s_util_Right(new $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandResult$Updated($f_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps__updateAttributes__sci_Set__Lorg_jpablo_graphexplorer_viewer_models_AttributeUpdates__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(graph, x88, new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeUpdates($m_sci_Map$().ao($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId(x89), new $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single(($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(x90))))])))))));
  }
  if (false) {
    return new $c_s_util_Right(new $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandResult$Updated($f_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps__updateAttributes__sci_Set__Lorg_jpablo_graphexplorer_viewer_models_AttributeUpdates__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(graph, command.pl(), $m_Lorg_jpablo_graphexplorer_viewer_models_AttributeUpdates$().aRv($m_sci_Set$().af($m_sr_ScalaRunTime$().hP(new ($d_Lorg_jpablo_graphexplorer_viewer_models_AttributeId.r().C)([new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId(command.DC())])))))));
  }
  if (false) {
    return new $c_s_util_Right(new $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandResult$Updated($f_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps__resetAttributes__sci_Set__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(graph, command.pl())));
  }
  if (false) {
    return new $c_s_util_Right(new $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandResult$Updated($f_Lorg_jpablo_graphexplorer_viewer_graph_GroupsOps__moveToNewGroup__sci_Set__T__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(graph, command.pl(), command.DC())));
  }
  if ((command instanceof $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$Ungroup)) {
    return new $c_s_util_Right(new $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandResult$Updated($f_Lorg_jpablo_graphexplorer_viewer_graph_GroupsOps__ungroupSelection__sci_Set__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(graph, command.Li)));
  }
  if ((command instanceof $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$CombineIntoRecord)) {
    var x71 = command.Lf;
    return ($f_Lorg_jpablo_graphexplorer_viewer_graph_CombineNodesOps__canCombineNodes__sci_Set__Z(graph, x71) ? new $c_s_util_Right(new $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandResult$Updated($f_Lorg_jpablo_graphexplorer_viewer_graph_CombineNodesOps__combineIntoRecord__sci_Set__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(graph, x71))) : new $c_s_util_Left(new $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandError$NotApplicable($m_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$().a4d(command), ("these nodes cannot be combined into a record: " + $p_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommands$__render__sci_Set__T($thiz, x71)))));
  }
  if ((command instanceof $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$SplitRecord)) {
    var x68 = command.Lg;
    return ($f_Lorg_jpablo_graphexplorer_viewer_graph_CombineNodesOps__isRecordNode__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Z(graph, x68) ? new $c_s_util_Right(new $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandResult$Updated($f_Lorg_jpablo_graphexplorer_viewer_graph_CombineNodesOps__splitRecordNode__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(graph, x68))) : new $c_s_util_Left(new $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandError$NotApplicable($m_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$().a4d(command), (($m_Lorg_jpablo_graphexplorer_gxcore_command_ElementRef$(), x68.kx()) + " is not a record node"))));
  }
  if ((command instanceof $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$TransposeRecord)) {
    var x65 = command.Lh;
    return ($f_Lorg_jpablo_graphexplorer_viewer_graph_CombineNodesOps__isRecordNode__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Z(graph, x65) ? new $c_s_util_Right(new $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandResult$Updated($f_Lorg_jpablo_graphexplorer_viewer_graph_CombineNodesOps__transposeRecord__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(graph, x65))) : new $c_s_util_Left(new $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandError$NotApplicable($m_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$().a4d(command), (($m_Lorg_jpablo_graphexplorer_gxcore_command_ElementRef$(), x65.kx()) + " is not a record node"))));
  }
  var x = $s_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$__ListNodes__Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand();
  if (((x === null) ? (command === null) : x.e(command))) {
    var this$47 = graph.j8;
    return new $c_s_util_Right(new $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandResult$Answered($p_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommands$__listing__sci_Vector__Lujson_Arr($thiz, $m_sci_Vector$().X(this$47).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((id) => new $c_T2(id, $p_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommands$__labelOf__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_NodeId__s_Option($m_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommands$(), graph, id))))))));
  }
  var x$3 = $s_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$__ListArrows__Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand();
  if (((x$3 === null) ? (command === null) : x$3.e(command))) {
    var $x_1 = $m_Lujson_Arr$();
    var this$52 = graph.fX;
    return new $c_s_util_Right(new $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandResult$Answered($x_1.a3u($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O($m_sci_Vector$().X(this$52), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3) => _$3.g().l3)), $m_s_math_Ordering$String$()).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
      var id$1 = x$1.g();
      var arrow = x$1.h();
      $m_Lorg_jpablo_graphexplorer_gxcore_command_ElementRef$();
      var y$2 = id$1.kx();
      var items = $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("source", new $c_Lujson_Str(($m_Lorg_jpablo_graphexplorer_gxcore_command_ElementRef$(), arrow.bX.kx()))), new $c_T2("target", new $c_Lujson_Str(($m_Lorg_jpablo_graphexplorer_gxcore_command_ElementRef$(), arrow.c0.kx())))]));
      var map = new $c_Lupickle_core_LinkedHashMap($ct_ju_LinkedHashMap__(new $c_ju_LinkedHashMap()));
      map.ue("ref", new $c_Lujson_Str(y$2));
      var it = items.o();
      while (it.p()) {
        var x0 = it.q();
        map.ue(x0.g(), x0.h());
      }
      return new $c_Lujson_Obj(map);
    }))), $m_s_$less$colon$less$().b1)));
  }
  var x$5 = $s_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$__ListGroups__Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand();
  if (((x$5 === null) ? (command === null) : x$5.e(command))) {
    var $x_2 = $m_Lujson_Arr$();
    var this$76 = graph.hu;
    return new $c_s_util_Right(new $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandResult$Answered($x_2.a3u($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O($m_sci_Vector$().X(this$76), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4) => _$4.g().dR)), $m_s_math_Ordering$String$()).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
      var id$4 = x$1$2.g();
      var group = x$1$2.h();
      $m_Lorg_jpablo_graphexplorer_gxcore_command_ElementRef$();
      var y$5 = id$4.kx();
      var items$1 = $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("label", new $c_Lujson_Str($f_Lorg_jpablo_graphexplorer_viewer_models_ViewerElement__label__Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(group).m()))]));
      var map$1 = new $c_Lupickle_core_LinkedHashMap($ct_ju_LinkedHashMap__(new $c_ju_LinkedHashMap()));
      map$1.ue("ref", new $c_Lujson_Str(y$5));
      var it$1 = items$1.o();
      while (it$1.p()) {
        var x0$1 = it$1.q();
        map$1.ue(x0$1.g(), x0$1.h());
      }
      return new $c_Lujson_Obj(map$1);
    }))), $m_s_$less$colon$less$().b1)));
  }
  if (false) {
    var x62 = command.pl();
    return new $c_s_util_Right(new $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandResult$Answered($m_Lujson_Obj$().ag3($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O($m_sci_Vector$().X(x62), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((id$2$1) => {
      $m_Lorg_jpablo_graphexplorer_gxcore_command_ElementRef$();
      return id$2$1.kx();
    })), $m_s_math_Ordering$String$()).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((id$3$1) => {
      $m_Lorg_jpablo_graphexplorer_gxcore_command_ElementRef$();
      var $x_4 = id$3$1.kx();
      var $x_3 = $m_Lujson_Obj$();
      var this$99 = $f_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps__getAttributesById__Lorg_jpablo_graphexplorer_viewer_models_ElementId__sci_Map(graph, id$3$1);
      return new $c_T2($x_4, $x_3.ag3($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O($m_sci_Vector$().X(this$99).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$1) => new $c_T2(((x$1$1.g() === null) ? null : x$1$1.g().fY), new $c_Lujson_Str(x$1$1.h().m()))))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$5) => _$5.g())), $m_s_math_Ordering$String$())));
    }))))));
  }
  throw new $c_s_MatchError(command);
}
function $p_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommands$__listing__sci_Vector__Lujson_Arr($thiz, entries) {
  return $m_Lujson_Arr$().a3u($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(entries, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6) => _$6.g().dE)), $m_s_math_Ordering$String$()).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var id = x$1.g();
    var label = x$1.h();
    $m_Lorg_jpablo_graphexplorer_gxcore_command_ElementRef$();
    var y = id.kx();
    var $x_1 = $m_sr_ScalaRunTime$();
    var this$6 = (label.c() ? $m_s_None$() : new $c_s_Some(new $c_Lujson_Str(label.d())));
    var items = $x_1.f(new ($d_T2.r().C)([new $c_T2("label", (this$6.c() ? $m_Lujson_Null$() : this$6.d()))]));
    var map = new $c_Lupickle_core_LinkedHashMap($ct_ju_LinkedHashMap__(new $c_ju_LinkedHashMap()));
    map.ue("ref", new $c_Lujson_Str(y));
    var it = items.o();
    while (it.p()) {
      var x0$1 = it.q();
      map.ue(x0$1.g(), x0$1.h());
    }
    return new $c_Lujson_Obj(map);
  }))), $m_s_$less$colon$less$().b1);
}
function $p_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommands$__labelOf__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_NodeId__s_Option($thiz, graph, id) {
  var this$1 = graph.dQ.r(id);
  var this$2 = (this$1.c() ? $m_s_None$() : new $c_s_Some($f_Lorg_jpablo_graphexplorer_viewer_models_ViewerElement__label__Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(this$1.d()).m()));
  return ((this$2.c() || (this$2.d() !== "")) ? this$2 : $m_s_None$());
}
function $p_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommands$__render__sci_Set__T($thiz, ids) {
  return $f_sc_IterableOnceOps__mkString__T__T__T__T($m_sci_Vector$().X(ids).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((id) => {
    $m_Lorg_jpablo_graphexplorer_gxcore_command_ElementRef$();
    return id.kx();
  }))).h9($m_s_math_Ordering$String$()), "", ", ", "");
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommands$() {
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommands$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommands$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommands$() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommands$.prototype = $p;
$p.b82 = (function(graph, command) {
  var this$1 = $p_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommands$__resolve__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand__s_util_Either(this, graph, command);
  return ((this$1 instanceof $c_s_util_Right) ? $p_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommands$__interpret__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand__s_util_Either($m_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommands$(), graph, command) : this$1);
});
var $d_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommands$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommands$, "org.jpablo.graphexplorer.gxcore.command.DocumentCommands$", ({
  vM: 1
}));
var $n_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommands$;
function $m_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommands$() {
  if ((!$n_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommands$)) {
    $n_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommands$ = new $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommands$();
  }
  return $n_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommands$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_command_ElementRef$() {
  this.a02 = null;
  $n_Lorg_jpablo_graphexplorer_gxcore_command_ElementRef$ = this;
  this.a02 = new $c_sci_$colon$colon("node", new $c_sci_$colon$colon("arrow", new $c_sci_$colon$colon("group", $m_sci_Nil$())));
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_command_ElementRef$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_command_ElementRef$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_command_ElementRef$() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_command_ElementRef$.prototype = $p;
$p.PH = (function(text) {
  var x1 = $f_T__split__T__I__AT(text, ":", 2);
  if ((x1 !== null)) {
    if (($m_s_Array$UnapplySeqWrapper$().u9(x1, 2) === 0)) {
      var x15 = x1.a[0];
      var x16 = x1.a[1];
      if ((x15 === "node")) {
        if ((x16 !== "")) {
          return new $c_s_util_Right(($m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$(), new $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId(x16)));
        }
      }
      if ((x15 === "arrow")) {
        if ((x16 !== "")) {
          return new $c_s_util_Right(($m_Lorg_jpablo_graphexplorer_viewer_models_ArrowId$(), new $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowId(x16)));
        }
      }
      if ((x15 === "group")) {
        if ((x16 !== "")) {
          return new $c_s_util_Right(($m_Lorg_jpablo_graphexplorer_viewer_models_GroupId$(), new $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId(x16)));
        }
      }
      if (this.a02.E(x15)) {
        return new $c_s_util_Left((("element reference has an empty id: '" + text) + "'"));
      }
      return new $c_s_util_Left((((((("unknown element kind '" + x15) + "' in '") + text) + "' (expected ") + $f_sc_IterableOnceOps__mkString__T__T__T__T(this.a02, "", ", ", "")) + ")"));
    }
  }
  return new $c_s_util_Left((((("element reference must be <kind>:<id>, got '" + text) + "' (expected ") + $f_sc_IterableOnceOps__mkString__T__T__T__T(this.a02, "", ", ", "")) + ")"));
});
$p.b6t = (function(texts) {
  matchResult2: {
    var \u03b41$___1;
    var \u03b41$___2;
    var x17 = texts.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((text) => $m_Lorg_jpablo_graphexplorer_gxcore_command_ElementRef$().PH(text)))).fy(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x) => x)));
    if ((x17 !== null)) {
      var \u03b41$___1 = x17.g();
      var \u03b41$___2 = x17.h();
      break matchResult2;
    }
    throw new $c_s_MatchError(x17);
  }
  var bad$2 = \u03b41$___1;
  var good$2 = \u03b41$___2;
  return (bad$2.c() ? new $c_s_util_Right($m_sci_Set$().af(good$2)) : new $c_s_util_Left($f_sc_IterableOnceOps__mkString__T__T__T__T(bad$2, "", "; ", "")));
});
var $d_Lorg_jpablo_graphexplorer_gxcore_command_ElementRef$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_command_ElementRef$, "org.jpablo.graphexplorer.gxcore.command.ElementRef$", ({
  vN: 1
}));
var $n_Lorg_jpablo_graphexplorer_gxcore_command_ElementRef$;
function $m_Lorg_jpablo_graphexplorer_gxcore_command_ElementRef$() {
  if ((!$n_Lorg_jpablo_graphexplorer_gxcore_command_ElementRef$)) {
    $n_Lorg_jpablo_graphexplorer_gxcore_command_ElementRef$ = new $c_Lorg_jpablo_graphexplorer_gxcore_command_ElementRef$();
  }
  return $n_Lorg_jpablo_graphexplorer_gxcore_command_ElementRef$;
}
function $p_Lorg_jpablo_graphexplorer_gxcore_command_SessionCodec$__decodeNamed__T__Lujson_Obj__s_util_Either($thiz, name, params) {
  switch (name) {
    case "select": {
      var this$1 = $p_Lorg_jpablo_graphexplorer_gxcore_command_SessionCodec$__targets__T__Lujson_Obj__s_util_Either($thiz, name, params);
      return ((this$1 instanceof $c_s_util_Right) ? new $c_s_util_Right(new $c_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$Select(this$1.hm)) : this$1);
      break;
    }
    case "add-to-selection": {
      var this$3 = $p_Lorg_jpablo_graphexplorer_gxcore_command_SessionCodec$__targets__T__Lujson_Obj__s_util_Either($thiz, name, params);
      return ((this$3 instanceof $c_s_util_Right) ? new $c_s_util_Right(new $c_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$AddToSelection(this$3.hm)) : this$3);
      break;
    }
    case "clear-selection": {
      return new $c_s_util_Right($s_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$__ClearSelection__Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand());
      break;
    }
    case "reset-view": {
      return new $c_s_util_Right($s_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$__ResetView__Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand());
      break;
    }
    case "what-is-selected": {
      return new $c_s_util_Right($s_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$__WhatIsSelected__Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand());
      break;
    }
    case "push-text": {
      return $p_Lorg_jpablo_graphexplorer_gxcore_command_SessionCodec$__pushText__Lujson_Obj__s_util_Either($thiz, params);
      break;
    }
    default: {
      return new $c_s_util_Left(new $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandError$UnknownCommand(name));
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_gxcore_command_SessionCodec$__pushText__Lujson_Obj__s_util_Either($thiz, params) {
  var this$1 = params.tM.r("sessionId");
  var this$2 = (this$1.c() ? $m_s_None$() : $f_Lujson_Value__strOpt__s_Option(this$1.d()));
  var this$5 = ((this$2.c() || (this$2.d() !== "")) ? this$2 : $m_s_None$());
  var this$7 = (this$5.c() ? new $c_s_util_Left(new $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandError$BadArgument("push-text", "missing required 'sessionId'")) : new $c_s_util_Right(this$5.d()));
  if ((this$7 instanceof $c_s_util_Right)) {
    var b = this$7.hm;
    var this$8 = params.tM.r("text");
    var this$9 = (this$8.c() ? $m_s_None$() : $f_Lujson_Value__strOpt__s_Option(this$8.d()));
    var this$11 = (this$9.c() ? new $c_s_util_Left(new $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandError$BadArgument("push-text", "missing required 'text'")) : new $c_s_util_Right(this$9.d()));
    return ((this$11 instanceof $c_s_util_Right) ? new $c_s_util_Right(new $c_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$PushText(b, this$11.hm)) : this$11);
  } else {
    return this$7;
  }
}
function $p_Lorg_jpablo_graphexplorer_gxcore_command_SessionCodec$__targets__T__Lujson_Obj__s_util_Either($thiz, command, params) {
  var this$1 = params.tM.r("targets");
  var x38 = (this$1.c() ? $m_s_None$() : $f_Lujson_Value__arrOpt__s_Option(this$1.d()));
  if (($m_s_None$() === x38)) {
    return new $c_s_util_Left(new $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandError$BadArgument(command, "missing required 'targets' array"));
  }
  if ((x38 instanceof $c_s_Some)) {
    var items = x38.J;
    $m_scm_ArrayBuffer$();
    var b = new $c_scm_ArrayBuffer$$anon$1();
    var it = items.bB().o();
    while (it.p()) {
      b.a2B($f_Lujson_Value__strOpt__s_Option(it.q()));
    }
    var texts = b.gj.d2();
    var size = items.a1;
    var x$1 = texts.C();
    if ((((x$1 === size) ? 0 : ((x$1 < size) ? (-1) : 1)) !== 0)) {
      return new $c_s_util_Left(new $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandError$BadArgument(command, "every target must be a string like 'node:a'"));
    } else {
      var this$10 = new $c_s_util_Either$LeftProjection($m_Lorg_jpablo_graphexplorer_gxcore_command_ElementRef$().b6t(texts));
      var x1 = this$10.Of;
      return ((x1 instanceof $c_s_util_Left) ? new $c_s_util_Left(new $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandError$BadArgument(command, x1.lP)) : this$10.Of);
    }
  }
  throw new $c_s_MatchError(x38);
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_command_SessionCodec$() {
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_command_SessionCodec$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_command_SessionCodec$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_command_SessionCodec$() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_command_SessionCodec$.prototype = $p;
$p.aZF = (function(frame) {
  var this$1 = $f_Lujson_Value__objOpt__s_Option(frame);
  var this$3 = (this$1.c() ? new $c_s_util_Left(new $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandError$BadArgument("<frame>", "a command must be a JSON object")) : new $c_s_util_Right(this$1.d()));
  if ((this$3 instanceof $c_s_util_Right)) {
    var b = this$3.hm;
    var this$4 = b.r("command");
    var this$5 = (this$4.c() ? $m_s_None$() : $f_Lujson_Value__strOpt__s_Option(this$4.d()));
    var this$7 = (this$5.c() ? new $c_s_util_Left(new $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandError$BadArgument("<frame>", "a command must have a 'command' name")) : new $c_s_util_Right(this$5.d()));
    if ((this$7 instanceof $c_s_util_Right)) {
      var $x_2 = $m_Lorg_jpablo_graphexplorer_gxcore_command_SessionCodec$();
      var $x_1 = this$7.hm;
      var this$8 = b.r("params");
      var this$9 = (this$8.c() ? $m_s_None$() : $f_Lujson_Value__objOpt__s_Option(this$8.d()));
      var this$10 = (this$9.c() ? $m_s_None$() : new $c_s_Some($m_Lujson_Obj$().ag3(this$9.d())));
      return $p_Lorg_jpablo_graphexplorer_gxcore_command_SessionCodec$__decodeNamed__T__Lujson_Obj__s_util_Either($x_2, $x_1, (this$10.c() ? new $c_Lujson_Obj(new $c_Lupickle_core_LinkedHashMap($ct_ju_LinkedHashMap__(new $c_ju_LinkedHashMap()))) : this$10.d()));
    } else {
      return this$7;
    }
  } else {
    return this$3;
  }
});
var $d_Lorg_jpablo_graphexplorer_gxcore_command_SessionCodec$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_command_SessionCodec$, "org.jpablo.graphexplorer.gxcore.command.SessionCodec$", ({
  vO: 1
}));
var $n_Lorg_jpablo_graphexplorer_gxcore_command_SessionCodec$;
function $m_Lorg_jpablo_graphexplorer_gxcore_command_SessionCodec$() {
  if ((!$n_Lorg_jpablo_graphexplorer_gxcore_command_SessionCodec$)) {
    $n_Lorg_jpablo_graphexplorer_gxcore_command_SessionCodec$ = new $c_Lorg_jpablo_graphexplorer_gxcore_command_SessionCodec$();
  }
  return $n_Lorg_jpablo_graphexplorer_gxcore_command_SessionCodec$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_model_ContentHash$package$ContentHash$() {
  this.auG = null;
  this.auH = false;
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_model_ContentHash$package$ContentHash$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_model_ContentHash$package$ContentHash$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_model_ContentHash$package$ContentHash$() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_model_ContentHash$package$ContentHash$.prototype = $p;
$p.agf = (function() {
  if ((!this.auH)) {
    this.auG = ($m_Lupickle_default$(), new $c_Lupickle_core_Types$$anon$1(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => _$1)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((hex) => hex.toLowerCase())), $m_Lupickle_default$().cw().ez($m_Lupickle_default$().a5, $m_Lupickle_default$().I)));
    this.auH = true;
  }
  return this.auG;
});
var $d_Lorg_jpablo_graphexplorer_gxcore_model_ContentHash$package$ContentHash$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_model_ContentHash$package$ContentHash$, "org.jpablo.graphexplorer.gxcore.model.ContentHash$package$ContentHash$", ({
  w0: 1
}));
var $n_Lorg_jpablo_graphexplorer_gxcore_model_ContentHash$package$ContentHash$;
function $m_Lorg_jpablo_graphexplorer_gxcore_model_ContentHash$package$ContentHash$() {
  if ((!$n_Lorg_jpablo_graphexplorer_gxcore_model_ContentHash$package$ContentHash$)) {
    $n_Lorg_jpablo_graphexplorer_gxcore_model_ContentHash$package$ContentHash$ = new $c_Lorg_jpablo_graphexplorer_gxcore_model_ContentHash$package$ContentHash$();
  }
  return $n_Lorg_jpablo_graphexplorer_gxcore_model_ContentHash$package$ContentHash$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_model_OriginUri$package$OriginUri$() {
  this.auR = null;
  this.auS = false;
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_model_OriginUri$package$OriginUri$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_model_OriginUri$package$OriginUri$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_model_OriginUri$package$OriginUri$() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_model_OriginUri$package$OriginUri$.prototype = $p;
$p.b5z = (function(encoded) {
  var out = $ct_scm_ArrayBuffer__I__(new $c_scm_ArrayBuffer(), encoded.length);
  var i = 0;
  while ((i < encoded.length)) {
    var index = i;
    var x3 = encoded.charCodeAt(index);
    if (((x3 === 37) && (((2 + i) | 0) < encoded.length))) {
      var $x_1 = $m_jl_Integer$();
      var beginIndex = ((1 + i) | 0);
      var endIndex = ((3 + i) | 0);
      out.aw((($x_1.gc(encoded.substring(beginIndex, endIndex), 16, 134217728) << 24) >> 24));
      i = ((3 + i) | 0);
      continue;
    }
    out.gS($m_s_Predef$().bc2($f_T__getBytes__Ljava_nio_charset_Charset__AB(("" + $cToS(x3)), $m_Ljava_nio_charset_UTF\uff3f8$())));
    i = ((1 + i) | 0);
  }
  if ((out.a1 >= 0)) {
    var destination = new $ac_B(out.a1);
    out.cR(destination, 0, 2147483647);
    return destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = out.bB().o();
    while (it.p()) {
      var elem$1 = it.q();
      var unboxedElem = ((elem$1 === null) ? 0 : elem$1);
      jsElems.push(unboxedElem);
    }
    return new $ac_B(new Int8Array(jsElems));
  }
});
$p.aO1 = (function(u) {
  if ((!(!u.startsWith("file://")))) {
    var encoded = $m_sc_StringOps$().wg(u, "file://");
    var decoded = $m_jl_String$().b4N($m_Lorg_jpablo_graphexplorer_gxcore_model_OriginUri$package$OriginUri$().b5z(encoded), $m_Ljava_nio_charset_UTF\uff3f8$());
    return new $c_s_Some(((!$ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "^/[A-Za-z]:", $m_sci_Nil$()).b1m(decoded).c()) ? decoded.substring(1) : decoded));
  } else {
    return $m_s_None$();
  }
});
$p.agg = (function() {
  if ((!this.auS)) {
    this.auR = ($m_Lupickle_default$(), new $c_Lupickle_core_Types$$anon$1(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => _$2)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x) => x)), $m_Lupickle_default$().cw().ez($m_Lupickle_default$().a5, $m_Lupickle_default$().I)));
    this.auS = true;
  }
  return this.auR;
});
var $d_Lorg_jpablo_graphexplorer_gxcore_model_OriginUri$package$OriginUri$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_model_OriginUri$package$OriginUri$, "org.jpablo.graphexplorer.gxcore.model.OriginUri$package$OriginUri$", ({
  wd: 1
}));
var $n_Lorg_jpablo_graphexplorer_gxcore_model_OriginUri$package$OriginUri$;
function $m_Lorg_jpablo_graphexplorer_gxcore_model_OriginUri$package$OriginUri$() {
  if ((!$n_Lorg_jpablo_graphexplorer_gxcore_model_OriginUri$package$OriginUri$)) {
    $n_Lorg_jpablo_graphexplorer_gxcore_model_OriginUri$package$OriginUri$ = new $c_Lorg_jpablo_graphexplorer_gxcore_model_OriginUri$package$OriginUri$();
  }
  return $n_Lorg_jpablo_graphexplorer_gxcore_model_OriginUri$package$OriginUri$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_model_Reconciler$() {
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_model_Reconciler$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_model_Reconciler$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_model_Reconciler$() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_model_Reconciler$.prototype = $p;
$p.b9n = (function(origin) {
  var this$1 = (origin.c() ? $m_s_None$() : new $c_s_Some(origin.d().Sa));
  return (this$1.c() ? $s_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$__Lf__Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding() : this$1.d());
});
$p.b6I = (function(binding, text, origin, local) {
  if (($m_s_None$() === binding)) {
    return $s_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$__Unbound__Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan();
  }
  if ((binding instanceof $c_s_Some)) {
    var binding$2 = binding.J;
    var state = $m_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$().b5c(binding$2.z8, local, (origin.c() ? $m_s_None$() : new $c_s_Some(origin.d().BG)));
    matchResult20: {
      var $x_1;
      var x35 = $m_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$().aXP(binding$2.z9, state);
      if ((x35 instanceof $c_s_Some)) {
        var x41 = x35.J;
        var x$3 = $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$__Pull__Lorg_jpablo_graphexplorer_gxcore_model_SyncAction();
        if (((x$3 === null) ? (x41 === null) : (x$3 === x41))) {
          if (origin.c()) {
            var this$2 = $m_s_None$();
          } else {
            var x0$1 = origin.d();
            var this$2 = new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$AdoptOrigin(x0$1.Lk, x0$1.BG));
          }
          var $x_1 = (this$2.c() ? $s_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$__DoNothing__Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction() : this$2.d());
          break matchResult20;
        }
        var x$5 = $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$__Push__Lorg_jpablo_graphexplorer_gxcore_model_SyncAction();
        if (((x$5 === null) ? (x41 === null) : (x$5 === x41))) {
          var $x_1 = new $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$WriteOrigin(text, binding$2.z8);
          break matchResult20;
        }
        var x$7 = $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$__AdvanceBase__Lorg_jpablo_graphexplorer_gxcore_model_SyncAction();
        if (((x$7 === null) ? (x41 === null) : (x$7 === x41))) {
          var $x_1 = new $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$AdvanceBase(local);
          break matchResult20;
        }
      }
      if (($m_s_None$() === x35)) {
        var $x_1 = $s_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$__DoNothing__Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction();
        break matchResult20;
      }
      throw new $c_s_MatchError(x35);
    }
    return new $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$Bound(state, $x_1, local);
  }
  throw new $c_s_MatchError(binding);
});
var $d_Lorg_jpablo_graphexplorer_gxcore_model_Reconciler$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_model_Reconciler$, "org.jpablo.graphexplorer.gxcore.model.Reconciler$", ({
  wi: 1
}));
var $n_Lorg_jpablo_graphexplorer_gxcore_model_Reconciler$;
function $m_Lorg_jpablo_graphexplorer_gxcore_model_Reconciler$() {
  if ((!$n_Lorg_jpablo_graphexplorer_gxcore_model_Reconciler$)) {
    $n_Lorg_jpablo_graphexplorer_gxcore_model_Reconciler$ = new $c_Lorg_jpablo_graphexplorer_gxcore_model_Reconciler$();
  }
  return $n_Lorg_jpablo_graphexplorer_gxcore_model_Reconciler$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_store_DiagramFileName$() {
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_store_DiagramFileName$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_store_DiagramFileName$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_store_DiagramFileName$() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_store_DiagramFileName$.prototype = $p;
$p.ah9 = (function(id) {
  var len = id.length;
  var dst = new $ac_C(len);
  var i = 0;
  while ((i < len)) {
    var $x_1 = i;
    var index = i;
    var x0 = id.charCodeAt(index);
    dst.a[$x_1] = ((($m_jl_UnicodeData$().E5(x0) || (x0 === 45)) || (x0 === 95)) ? x0 : 95);
    i = ((1 + i) | 0);
  }
  var cleaned = $m_jl_String$().kS(dst, 0, dst.a.length);
  return ((cleaned === "") ? "_" : $m_sc_StringOps$().a4R(cleaned, 120));
});
var $d_Lorg_jpablo_graphexplorer_gxcore_store_DiagramFileName$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_store_DiagramFileName$, "org.jpablo.graphexplorer.gxcore.store.DiagramFileName$", ({
  wr: 1
}));
var $n_Lorg_jpablo_graphexplorer_gxcore_store_DiagramFileName$;
function $m_Lorg_jpablo_graphexplorer_gxcore_store_DiagramFileName$() {
  if ((!$n_Lorg_jpablo_graphexplorer_gxcore_store_DiagramFileName$)) {
    $n_Lorg_jpablo_graphexplorer_gxcore_store_DiagramFileName$ = new $c_Lorg_jpablo_graphexplorer_gxcore_store_DiagramFileName$();
  }
  return $n_Lorg_jpablo_graphexplorer_gxcore_store_DiagramFileName$;
}
function $p_Lorg_jpablo_graphexplorer_gxcore_store_LocalStorageMigration$__parseDirectory__T__s_util_Either($thiz, json) {
  try {
    var this$2 = $f_Lujson_Value__obj__Lupickle_core_LinkedHashMap($m_Lujson_package$().ahw(new $c_Lujson_Readable$fromTransformer(json, $m_Lujson_StringParser$()), false)).r("projects");
    var this$3 = (this$2.c() ? $m_s_None$() : new $c_s_Some($f_Lujson_Value__arr__scm_ArrayBuffer(this$2.d())));
    var projects = (this$3.c() ? $f_Lujson_Value__arr__scm_ArrayBuffer($m_Lujson_Arr$().aXu($m_sr_ScalaRunTime$().f(new ($d_Lujson_Value.r().C)([])))) : this$3.d());
    var this$5 = $m_sci_Vector$().X(projects);
    $m_sci_Vector$();
    var b = new $c_sci_VectorBuilder();
    var it = this$5.o();
    while (it.p()) {
      var x0$1 = it.q();
      var o = $f_Lujson_Value__obj__Lupickle_core_LinkedHashMap(x0$1);
      var this$7 = o.r("id");
      if (this$7.c()) {
        var id = $m_s_None$();
      } else {
        var x0$2 = this$7.d();
        if ((x0$2 instanceof $c_Lujson_Str)) {
          var id = new $c_s_Some(x0$2.xP);
        } else if ((x0$2 instanceof $c_Lujson_Obj)) {
          var x25 = x0$2.tM;
          var this$11 = x25.r("value");
          var id = (this$11.c() ? $m_s_None$() : $f_Lujson_Value__strOpt__s_Option(this$11.d()));
        } else {
          var id = $m_s_None$();
        }
      }
      if (id.c()) {
        var $x_1 = $m_s_None$();
      } else {
        var $x_7 = id.d();
        var this$12 = o.r("name");
        var this$13 = (this$12.c() ? $m_s_None$() : $f_Lujson_Value__strOpt__s_Option(this$12.d()));
        var $x_6 = (this$13.c() ? "" : this$13.d());
        var this$14 = o.r("lastModified");
        var this$15 = (this$14.c() ? $m_s_None$() : $f_Lujson_Value__numOpt__s_Option(this$14.d()));
        if (this$15.c()) {
          var this$16 = $m_s_None$();
        } else {
          var $x_5 = $m_RTLong$().d1((+this$15.d()));
          var this$16 = new $c_s_Some($x_5);
        }
        var $x_4 = $uJ((this$16.c() ? $bL(0, 0) : this$16.d()));
        var this$17 = o.r("createdAt");
        var this$18 = (this$17.c() ? $m_s_None$() : $f_Lujson_Value__numOpt__s_Option(this$17.d()));
        if (this$18.c()) {
          var this$19 = $m_s_None$();
        } else {
          var $x_3 = $m_RTLong$().d1((+this$18.d()));
          var this$19 = new $c_s_Some($x_3);
        }
        var $x_2 = $uJ((this$19.c() ? $bL(0, 0) : this$19.d()));
        var $x_1 = new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_gxcore_store_LocalStorageMigration$LegacyProject($x_7, $x_6, $x_4.l, $x_4.h, $x_2.l, $x_2.h));
      }
      b.fO($x_1);
    }
    return new $c_s_util_Right(b.bY());
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    var x30 = $m_s_util_control_NonFatal$().wm(e$2);
    if ((!x30.c())) {
      return new $c_s_util_Left(("could not parse the projects directory: " + x30.d()));
    }
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
  }
}
function $p_Lorg_jpablo_graphexplorer_gxcore_store_LocalStorageMigration$__toDiagram__Lorg_jpablo_graphexplorer_gxcore_model_DiagramId__Lorg_jpablo_graphexplorer_gxcore_store_LocalStorageMigration$LegacyProject__T__J__s_util_Either($thiz, id, project, payload, nowMs_$_lo, nowMs_$_hi) {
  try {
    var o = $f_Lujson_Value__obj__Lupickle_core_LinkedHashMap($m_Lujson_package$().ahw(new $c_Lujson_Readable$fromTransformer(payload, $m_Lujson_StringParser$()), false));
    var this$2 = o.r("source");
    var this$3 = (this$2.c() ? $m_s_None$() : $f_Lujson_Value__strOpt__s_Option(this$2.d()));
    var text = (this$3.c() ? "" : this$3.d());
    var $x_1 = project.Ll;
    var this$4 = o.r("projectName");
    var this$5 = (this$4.c() ? $m_s_None$() : $f_Lujson_Value__strOpt__s_Option(this$4.d()));
    var this$6 = new $c_sci_$colon$colon($x_1, new $c_sci_$colon$colon((this$5.c() ? "" : this$5.d()), $m_sci_Nil$()));
    _return: {
      var these = this$6;
      while ((!these.c())) {
        var x0$2 = these.t();
        if (((x0$2 !== "") && (x0$2 !== "Untitled"))) {
          var this$9 = new $c_s_Some(these.t());
          break _return;
        }
        these = these.v();
      }
      var this$9 = $m_s_None$();
    }
    var name = (this$9.c() ? "Untitled" : this$9.d());
    var this$10 = o.r("format");
    var this$11 = (this$10.c() ? $m_s_None$() : $f_Lujson_Value__strOpt__s_Option(this$10.d()));
    var this$14 = ((this$11.c() || (this$11.d() !== "")) ? this$11 : $m_s_None$());
    var format = (this$14.c() ? "DOT" : this$14.d());
    var $x_6 = $m_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath$().a03;
    var $x_5 = $m_s_None$();
    $m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$();
    var $x_4 = new $c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata($p_Lorg_jpablo_graphexplorer_gxcore_store_LocalStorageMigration$__idsIn__s_Option__s_Option__sci_Set($thiz, o.r("hiddenElements"), $m_s_None$()), $p_Lorg_jpablo_graphexplorer_gxcore_store_LocalStorageMigration$__idsIn__s_Option__s_Option__sci_Set($thiz, o.r("collapsedGroups"), new $c_s_Some("group")), ($m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$(), $m_sci_Nil$()), ($m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$(), ""), ($m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$(), $m_s_None$()));
    var x_$_lo = project.Ir;
    var x_$_hi = project.Is;
    if (((x_$_hi === 0) ? (x_$_lo !== 0) : (x_$_hi > 0))) {
      var $x_3_$_lo = project.Ir;
      var $x_3_$_hi = project.Is;
    } else {
      var $x_3_$_lo = nowMs_$_lo;
      var $x_3_$_hi = nowMs_$_hi;
    }
    var x$1_$_lo = project.It;
    var x$1_$_hi = project.Iu;
    if (((x$1_$_hi === 0) ? (x$1_$_lo !== 0) : (x$1_$_hi > 0))) {
      var $x_2_$_lo = project.It;
      var $x_2_$_hi = project.Iu;
    } else {
      var $x_2_$_lo = nowMs_$_lo;
      var $x_2_$_hi = nowMs_$_hi;
    }
    return new $c_s_util_Right(new $c_Lorg_jpablo_graphexplorer_gxcore_model_Diagram(id, name, $x_6, format, text, $x_5, $x_4, $x_3_$_lo, $x_3_$_hi, $x_2_$_lo, $x_2_$_hi));
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    var x34 = $m_s_util_control_NonFatal$().wm(e$2);
    if ((!x34.c())) {
      return new $c_s_util_Left(("could not parse the stored payload: " + x34.d()));
    }
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
  }
}
function $p_Lorg_jpablo_graphexplorer_gxcore_store_LocalStorageMigration$__idsIn__s_Option__s_Option__sci_Set($thiz, value, assume) {
  return (value.c() ? $m_sci_Set$EmptySet$() : $p_Lorg_jpablo_graphexplorer_gxcore_store_LocalStorageMigration$__walk$1__Lujson_Value__s_Option__sci_Set($thiz, value.d(), assume));
}
function $p_Lorg_jpablo_graphexplorer_gxcore_store_LocalStorageMigration$__kindOf$1__T__s_Option($thiz, tag) {
  switch (tag) {
    case "NodeId": {
      return new $c_s_Some("node");
      break;
    }
    case "ArrowId": {
      return new $c_s_Some("arrow");
      break;
    }
    case "GroupId": {
      return new $c_s_Some("group");
      break;
    }
    default: {
      return $m_s_None$();
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_gxcore_store_LocalStorageMigration$__walk$1__Lujson_Value__s_Option__sci_Set($thiz, v, kind) {
  if ((v instanceof $c_Lujson_Str)) {
    var x47 = v.xP;
    return $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_T.r().C)([(kind.c() ? x47 : ((kind.d() + ":") + x47))])));
  } else if ((v instanceof $c_Lujson_Arr)) {
    return $m_sci_Set$().af(new $c_sc_Iterator$$anon$10(v.Dj.bB().o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$12) => $p_Lorg_jpablo_graphexplorer_gxcore_store_LocalStorageMigration$__walk$1__Lujson_Value__s_Option__sci_Set($thiz, _$12, kind)))));
  } else if ((v instanceof $c_Lujson_Obj)) {
    var x41 = v.tM;
    var this$8 = x41.r("$type");
    var this$9 = (this$8.c() ? $m_s_None$() : $f_Lujson_Value__strOpt__s_Option(this$8.d()));
    var this$10 = (this$9.c() ? $m_s_None$() : $p_Lorg_jpablo_graphexplorer_gxcore_store_LocalStorageMigration$__kindOf$1__T__s_Option($thiz, this$9.d()));
    var tagged = (this$10.c() ? kind : this$10);
    return $m_sci_Set$().af(new $c_sc_Iterator$$anon$10(new $c_sc_Iterator$$anon$6(x41.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
      var k = x$1.g();
      x$1.h();
      return (!(!k.startsWith("$")));
    })), true), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
      x$1$2.g();
      return $p_Lorg_jpablo_graphexplorer_gxcore_store_LocalStorageMigration$__walk$1__Lujson_Value__s_Option__sci_Set($thiz, x$1$2.h(), tagged);
    }))));
  } else {
    return $m_sci_Set$EmptySet$();
  }
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_store_LocalStorageMigration$() {
  this.aTX = null;
  this.aTX = "ls";
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_store_LocalStorageMigration$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_store_LocalStorageMigration$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_store_LocalStorageMigration$() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_store_LocalStorageMigration$.prototype = $p;
$p.b2G = (function(projectId) {
  return $m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId$().aZP("ls", projectId);
});
var $d_Lorg_jpablo_graphexplorer_gxcore_store_LocalStorageMigration$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_store_LocalStorageMigration$, "org.jpablo.graphexplorer.gxcore.store.LocalStorageMigration$", ({
  wt: 1
}));
var $n_Lorg_jpablo_graphexplorer_gxcore_store_LocalStorageMigration$;
function $m_Lorg_jpablo_graphexplorer_gxcore_store_LocalStorageMigration$() {
  if ((!$n_Lorg_jpablo_graphexplorer_gxcore_store_LocalStorageMigration$)) {
    $n_Lorg_jpablo_graphexplorer_gxcore_store_LocalStorageMigration$ = new $c_Lorg_jpablo_graphexplorer_gxcore_store_LocalStorageMigration$();
  }
  return $n_Lorg_jpablo_graphexplorer_gxcore_store_LocalStorageMigration$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_projects_DesktopLibrary$() {
  this.aTY = null;
  this.aTZ = 0.0;
  this.aTY = "ge:library.changed";
  this.aTZ = 400.0;
}
$p = $c_Lorg_jpablo_graphexplorer_projects_DesktopLibrary$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_projects_DesktopLibrary$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_projects_DesktopLibrary$() {
}
$h_Lorg_jpablo_graphexplorer_projects_DesktopLibrary$.prototype = $p;
$p.agW = (function() {
  return ((!(!$p_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$__invoker__s_Option($m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$()).c())) ? $m_s_concurrent_Future$().m4(($m_sci_Vector$(), $m_sci_Vector0$())) : $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$().u7("library_list", $m_sjs_js_special_package$().eA($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([])))).jX(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((raw) => {
    var this$6 = $ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), raw);
    var this$7 = $m_sci_Vector$().X(this$6);
    $m_sci_Vector$();
    var b = new $c_sci_VectorBuilder();
    var it = this$7.o();
    while (it.p()) {
      var x0 = it.q();
      var name = x0.name;
      var json = x0.json;
      if (((json === (void 0)) || (json === null))) {
        console.warn((("[library] " + name) + " could not be read"));
        var $x_1 = $m_s_None$();
      } else {
        try {
          var $x_1 = new $c_s_Some($f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer(json, $m_Lujson_StringParser$()), ($m_Lupickle_default$(), false), $m_Lorg_jpablo_graphexplorer_gxcore_model_Diagram$().bm()));
        } catch (e) {
          var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
          matchResult6: {
            var $x_1;
            var x13 = $m_s_util_control_NonFatal$().wm(e$2);
            if ((!x13.c())) {
              var x14 = x13.d();
              console.warn(((("[library] " + name) + " is not a readable record: ") + x14.e3()));
              var $x_1 = $m_s_None$();
              break matchResult6;
            }
            throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
          }
        }
      }
      b.fO($x_1);
    }
    return b.bY();
  })), $m_s_concurrent_ExecutionContext$().ek()).AC(new $c_Lorg_jpablo_graphexplorer_projects_DesktopLibrary$$anon$2(), $m_s_concurrent_ExecutionContext$().ek()));
});
var $d_Lorg_jpablo_graphexplorer_projects_DesktopLibrary$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_projects_DesktopLibrary$, "org.jpablo.graphexplorer.projects.DesktopLibrary$", ({
  wv: 1
}));
var $n_Lorg_jpablo_graphexplorer_projects_DesktopLibrary$;
function $m_Lorg_jpablo_graphexplorer_projects_DesktopLibrary$() {
  if ((!$n_Lorg_jpablo_graphexplorer_projects_DesktopLibrary$)) {
    $n_Lorg_jpablo_graphexplorer_projects_DesktopLibrary$ = new $c_Lorg_jpablo_graphexplorer_projects_DesktopLibrary$();
  }
  return $n_Lorg_jpablo_graphexplorer_projects_DesktopLibrary$;
}
function $p_Lorg_jpablo_graphexplorer_projects_DesktopMigration$__writeAll__sci_Vector__s_concurrent_Future($thiz, diagrams) {
  return $m_s_concurrent_Future$().b8v(diagrams.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((d) => $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$().u7("library_write", $m_sjs_js_special_package$().eA($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("name", ($m_Lorg_jpablo_graphexplorer_gxcore_store_DiagramFileName$().ah9(d.jE.kD) + ".json")), new $c_T2("json", $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($m_Lupickle_default$(), d, 2, ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lorg_jpablo_graphexplorer_gxcore_model_Diagram$().bm()))])))).jX(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => $m_s_None$())), $m_s_concurrent_ExecutionContext$().ek()).AC(new $c_Lorg_jpablo_graphexplorer_projects_DesktopMigration$$anon$1(d), $m_s_concurrent_ExecutionContext$().ek())))), new $c_sc_BuildFromLowPriority2$$anon$11($m_sc_BuildFrom$()), $m_s_concurrent_ExecutionContext$().ek()).jX(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => $f_sc_StrictOptimizedIterableOps__flatten__F1__O(_$2, $m_s_$less$colon$less$().b1))), $m_s_concurrent_ExecutionContext$().ek());
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_projects_DesktopMigration$() {
  this.aU0 = null;
  this.aU0 = "graph-explorer.migrated-to-disk";
}
$p = $c_Lorg_jpablo_graphexplorer_projects_DesktopMigration$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_projects_DesktopMigration$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_projects_DesktopMigration$() {
}
$h_Lorg_jpablo_graphexplorer_projects_DesktopMigration$.prototype = $p;
$p.b2s = (function() {
  return (!$m_Lorg_jpablo_graphexplorer_projects_ProjectStorage$().b7c("graph-explorer.migrated-to-disk").c());
});
$p.b84 = (function(existing) {
  if (this.b2s()) {
    return $m_s_concurrent_Future$().m4($m_s_None$());
  } else {
    var sink = new $c_Lorg_jpablo_graphexplorer_projects_DesktopMigration$CollectingSink(existing);
    var this$1 = $m_Lorg_jpablo_graphexplorer_gxcore_store_LocalStorageMigration$();
    var directoryJson = $m_Lorg_jpablo_graphexplorer_projects_ProjectStorage$().b79();
    var this$2 = $p_Lorg_jpablo_graphexplorer_gxcore_store_LocalStorageMigration$__parseDirectory__T__s_util_Either(this$1, directoryJson);
    if ((this$2 instanceof $c_s_util_Right)) {
      var b = this$2.hm;
      var z = new $c_Lorg_jpablo_graphexplorer_gxcore_store_MigrationReport(($m_sci_Vector$(), $m_sci_Vector0$()), ($m_sci_Vector$(), $m_sci_Vector0$()), ($m_sci_Vector$(), $m_sci_Vector0$()));
      var at = 0;
      var end = b.C();
      var acc = z;
      var $x_1;
      while (true) {
        if ((at !== end)) {
          var temp$at = ((1 + at) | 0);
          var x0 = acc;
          var x1 = b.l(at);
          var id = $m_Lorg_jpablo_graphexplorer_gxcore_store_LocalStorageMigration$().b2G(x1.wY);
          if (sink.aZ1(id)) {
            var skipped$1 = x0.zc.bv(id);
            var temp$acc = new $c_Lorg_jpablo_graphexplorer_gxcore_store_MigrationReport(x0.zb, skipped$1, x0.za);
          } else {
            matchResult6: {
              var temp$acc;
              var x15 = $m_Lorg_jpablo_graphexplorer_projects_ProjectStorage$().b7a(x1.wY);
              if (($m_s_None$() === x15)) {
                var failed$2 = x0.za.bv(new $c_T2(x1.wY, "no stored payload"));
                var temp$acc = new $c_Lorg_jpablo_graphexplorer_gxcore_store_MigrationReport(x0.zb, x0.zc, failed$2);
                break matchResult6;
              }
              if ((x15 instanceof $c_s_Some)) {
                var payload = x15.J;
                var $x_3 = $m_Lorg_jpablo_graphexplorer_gxcore_store_LocalStorageMigration$();
                var $x_2 = $m_RTLong$().d1((+Date.now()));
                var x10 = $p_Lorg_jpablo_graphexplorer_gxcore_store_LocalStorageMigration$__toDiagram__Lorg_jpablo_graphexplorer_gxcore_model_DiagramId__Lorg_jpablo_graphexplorer_gxcore_store_LocalStorageMigration$LegacyProject__T__J__s_util_Either($x_3, id, x1, payload, $x_2.l, $x_2.h);
                if ((x10 instanceof $c_s_util_Left)) {
                  var why = x10.lP;
                  var failed$3 = x0.za.bv(new $c_T2(x1.wY, why));
                  var temp$acc = new $c_Lorg_jpablo_graphexplorer_gxcore_store_MigrationReport(x0.zb, x0.zc, failed$3);
                  break matchResult6;
                }
                if ((x10 instanceof $c_s_util_Right)) {
                  var diagram = x10.hm;
                  var x5 = sink.bc4(diagram);
                  if ((x5 instanceof $c_s_util_Left)) {
                    var err = x5.lP;
                    var failed$4 = x0.za.bv(new $c_T2(x1.wY, err));
                    var temp$acc = new $c_Lorg_jpablo_graphexplorer_gxcore_store_MigrationReport(x0.zb, x0.zc, failed$4);
                    break matchResult6;
                  }
                  if ((x5 instanceof $c_s_util_Right)) {
                    var temp$acc = new $c_Lorg_jpablo_graphexplorer_gxcore_store_MigrationReport(x0.zb.bv(id), x0.zc, x0.za);
                    break matchResult6;
                  }
                  throw new $c_s_MatchError(x5);
                }
                throw new $c_s_MatchError(x10);
              }
              throw new $c_s_MatchError(x15);
            }
          }
          at = temp$at;
          acc = temp$acc;
          continue;
        }
        var $x_1 = acc;
        break;
      }
      var x1$1 = new $c_s_util_Right($x_1);
    } else {
      var x1$1 = this$2;
    }
    if ((x1$1 instanceof $c_s_util_Left)) {
      var why$1 = x1$1.lP;
      console.error(("[library] the browser library could not be read, so nothing was copied: " + why$1));
      return $m_s_concurrent_Future$().m4($m_s_None$());
    }
    if ((x1$1 instanceof $c_s_util_Right)) {
      var report = x1$1.hm;
      var this$18 = sink.a05;
      return $p_Lorg_jpablo_graphexplorer_projects_DesktopMigration$__writeAll__sci_Vector__s_concurrent_Future(this, $m_sci_Vector$().X(this$18)).jX(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((failures) => {
        if ($f_sc_SeqOps__isEmpty__Z(failures)) {
          var $x_5 = $m_Lorg_jpablo_graphexplorer_projects_ProjectStorage$();
          var $x_4 = $m_RTLong$().d1((+Date.now()));
          var this$19_$_lo = $x_4.l;
          var this$19_$_hi = $x_4.h;
          $p_Lorg_jpablo_graphexplorer_projects_ProjectStorage$__writeLocalStorage__T__T__V($x_5, "graph-explorer.migrated-to-disk", $m_RTLong$().kY(this$19_$_lo, this$19_$_hi));
          return new $c_s_Some(report);
        } else {
          console.error((("[library] " + failures.C()) + " diagram(s) could not be copied to disk; the browser library is untouched and the copy will be retried next launch."));
          failures.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((f) => {
            console.error(("[library]   " + f));
          })));
          return $m_s_None$();
        }
      })), $m_s_concurrent_ExecutionContext$().ek());
    }
    throw new $c_s_MatchError(x1$1);
  }
});
var $d_Lorg_jpablo_graphexplorer_projects_DesktopMigration$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_projects_DesktopMigration$, "org.jpablo.graphexplorer.projects.DesktopMigration$", ({
  wy: 1
}));
var $n_Lorg_jpablo_graphexplorer_projects_DesktopMigration$;
function $m_Lorg_jpablo_graphexplorer_projects_DesktopMigration$() {
  if ((!$n_Lorg_jpablo_graphexplorer_projects_DesktopMigration$)) {
    $n_Lorg_jpablo_graphexplorer_projects_DesktopMigration$ = new $c_Lorg_jpablo_graphexplorer_projects_DesktopMigration$();
  }
  return $n_Lorg_jpablo_graphexplorer_projects_DesktopMigration$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_projects_Library$() {
  this.na = null;
  $n_Lorg_jpablo_graphexplorer_projects_Library$ = this;
  this.na = $m_Lorg_jpablo_graphexplorer_projects_ProjectStorage$();
}
$p = $c_Lorg_jpablo_graphexplorer_projects_Library$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_projects_Library$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_projects_Library$() {
}
$h_Lorg_jpablo_graphexplorer_projects_Library$.prototype = $p;
$p.IP = (function() {
  return this.na.IP();
});
$p.a34 = (function(id, initialSource) {
  return this.na.a34(id, initialSource);
});
$p.IM = (function(name) {
  return this.na.IM(name);
});
$p.a32 = (function(name, source) {
  return this.na.a32(name, source);
});
$p.WD = (function(id) {
  this.na.WD(id);
});
$p.a3E = (function(id) {
  return this.na.a3E(id);
});
$p.XN = (function(id) {
  return this.na.XN(id);
});
$p.XP = (function(path) {
  return this.na.XP(path);
});
$p.a4r = (function(id) {
  return this.na.a4r(id);
});
$p.XE = (function(id) {
  return this.na.XE(id);
});
$p.Ef = (function(id, text, base) {
  this.na.Ef(id, text, base);
});
$p.a3n = (function(dot) {
  return this.na.a3n(dot);
});
$p.XM = (function(id, languages) {
  return this.na.XM(id, languages);
});
$p.WT = (function() {
  this.na.WT();
});
var $d_Lorg_jpablo_graphexplorer_projects_Library$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_projects_Library$, "org.jpablo.graphexplorer.projects.Library$", ({
  wB: 1
}));
var $n_Lorg_jpablo_graphexplorer_projects_Library$;
function $m_Lorg_jpablo_graphexplorer_projects_Library$() {
  if ((!$n_Lorg_jpablo_graphexplorer_projects_Library$)) {
    $n_Lorg_jpablo_graphexplorer_projects_Library$ = new $c_Lorg_jpablo_graphexplorer_projects_Library$();
  }
  return $n_Lorg_jpablo_graphexplorer_projects_Library$;
}
function $p_Lorg_jpablo_graphexplorer_projects_LibraryMapping$__partitionRefs__sci_Set__T2($thiz, refs) {
  var parsed = refs.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((r) => new $c_T2(r, $m_Lorg_jpablo_graphexplorer_gxcore_command_ElementRef$().PH(r)))));
  return new $c_T2(parsed.ct(new $c_Lorg_jpablo_graphexplorer_projects_LibraryMapping$$anon$2()), parsed.ct(new $c_Lorg_jpablo_graphexplorer_projects_LibraryMapping$$anon$3()));
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_projects_LibraryMapping$() {
}
$p = $c_Lorg_jpablo_graphexplorer_projects_LibraryMapping$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_projects_LibraryMapping$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_projects_LibraryMapping$() {
}
$h_Lorg_jpablo_graphexplorer_projects_LibraryMapping$.prototype = $p;
$p.aSW = (function(diagram) {
  matchResult4: {
    var \u03b41$___1;
    var \u03b41$___2;
    var x5 = $p_Lorg_jpablo_graphexplorer_projects_LibraryMapping$__partitionRefs__sci_Set__T2(this, diagram.o4.wV);
    if ((x5 !== null)) {
      var \u03b41$___1 = x5.g();
      var \u03b41$___2 = x5.h();
      break matchResult4;
    }
    throw new $c_s_MatchError(x5);
  }
  var hiddenIds$2 = \u03b41$___1;
  var hiddenBad$2 = \u03b41$___2;
  matchResult5: {
    var \u03b42$___1;
    var \u03b42$___2;
    var x8 = $p_Lorg_jpablo_graphexplorer_projects_LibraryMapping$__partitionRefs__sci_Set__T2(this, diagram.o4.wU);
    if ((x8 !== null)) {
      var \u03b42$___1 = x8.g();
      var \u03b42$___2 = x8.h();
      break matchResult5;
    }
    throw new $c_s_MatchError(x8);
  }
  var collapsed$2 = \u03b42$___1;
  var collapsedBad$2 = \u03b42$___2;
  $m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$();
  var collapsedGroups = collapsed$2.ct(new $c_Lorg_jpablo_graphexplorer_projects_LibraryMapping$$anon$1());
  var projectName = diagram.n8;
  var source = diagram.kC;
  var this$4 = $m_s_Option$().as(diagram.ru);
  var state = new $c_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState(hiddenIds$2, collapsedGroups, projectName, source, ((this$4.c() || (this$4.d() !== "")) ? this$4 : $m_s_None$()), diagram.o4.wT);
  var strayCollapsed = collapsed$2.cE(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => (_$2 instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId)))).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((id) => {
    $m_Lorg_jpablo_graphexplorer_gxcore_command_ElementRef$();
    return id.kx();
  })));
  return new $c_T2(state, ($m_Lorg_jpablo_graphexplorer_projects_LibraryMapping$Unparsed$(), new $c_Lorg_jpablo_graphexplorer_projects_LibraryMapping$Unparsed(hiddenBad$2, collapsedBad$2.dI(strayCollapsed))));
});
$p.ba6 = (function(id, state, previous, unparsed, now_$_lo, now_$_hi) {
  $m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$();
  var $x_3 = state.ob.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((id$2) => {
    $m_Lorg_jpablo_graphexplorer_gxcore_command_ElementRef$();
    return id$2.kx();
  }))).dI(unparsed.Sk);
  var $x_2 = state.oa.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((id$3) => {
    $m_Lorg_jpablo_graphexplorer_gxcore_command_ElementRef$();
    return id$3.kx();
  }))).dI(unparsed.Sj);
  var this$5 = (previous.c() ? $m_s_None$() : new $c_s_Some(previous.d().o4.wX));
  var $x_1 = (this$5.c() ? $m_sci_Nil$() : this$5.d());
  var this$6 = (previous.c() ? $m_s_None$() : new $c_s_Some(previous.d().o4.wW));
  var metadata = new $c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata($x_3, $x_2, $x_1, (this$6.c() ? "" : this$6.d()), state.o9);
  var $x_10 = state.oc;
  var this$8 = (previous.c() ? $m_s_None$() : new $c_s_Some(previous.d().uG));
  var $x_9 = (this$8.c() ? $m_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath$().a03 : this$8.d());
  var this$9 = state.nf;
  var $x_8 = (this$9.c() ? "" : this$9.d());
  var $x_7 = state.hf;
  var $x_6 = (previous.c() ? $m_s_None$() : previous.d().q3);
  if (previous.c()) {
    var this$10 = $m_s_None$();
  } else {
    var $x_5 = previous.d();
    var this$10 = new $c_s_Some($bL($x_5.tP, $x_5.tQ));
  }
  var $x_4 = $uJ((this$10.c() ? $bL(now_$_lo, now_$_hi) : this$10.d()));
  return new $c_Lorg_jpablo_graphexplorer_gxcore_model_Diagram(id, $x_10, $x_9, $x_8, $x_7, $x_6, metadata, $x_4.l, $x_4.h, now_$_lo, now_$_hi);
});
var $d_Lorg_jpablo_graphexplorer_projects_LibraryMapping$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_projects_LibraryMapping$, "org.jpablo.graphexplorer.projects.LibraryMapping$", ({
  wC: 1
}));
var $n_Lorg_jpablo_graphexplorer_projects_LibraryMapping$;
function $m_Lorg_jpablo_graphexplorer_projects_LibraryMapping$() {
  if ((!$n_Lorg_jpablo_graphexplorer_projects_LibraryMapping$)) {
    $n_Lorg_jpablo_graphexplorer_projects_LibraryMapping$ = new $c_Lorg_jpablo_graphexplorer_projects_LibraryMapping$();
  }
  return $n_Lorg_jpablo_graphexplorer_projects_LibraryMapping$;
}
function $p_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$__shownName$1__sci_Map__Lorg_jpablo_graphexplorer_projects_ProjectInfo__T($thiz, infos$2, p) {
  var this$1 = infos$2.r(p.eG);
  var this$2 = (this$1.c() ? $m_s_None$() : new $c_s_Some(this$1.d().BI));
  return (this$2.c() ? p.nb : this$2.d());
}
function $p_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$__body$proxy1$1__sci_Map__Lorg_jpablo_graphexplorer_projects_ProjectsDirectory__T__s_Option__Lorg_jpablo_graphexplorer_projects_SortOption__Lorg_jpablo_graphexplorer_projects_LibraryViewMode__Lorg_jpablo_graphexplorer_viewer_backends_graphviz_Graphviz__Lorg_jpablo_graphexplorer_router_Router__sci_List($thiz, infos$1, directory$1, searchTerm$1, kindFilter$1, sortOption$1, viewMode$1, graphviz$1, router$1) {
  var this$4 = directory$1.hY;
  var f = ((p) => {
    var this$2 = ((p.nb + " ") + $p_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$__shownName$1__sci_Map__Lorg_jpablo_graphexplorer_projects_ProjectInfo__T($thiz, infos$1, p));
    var this$3 = this$2.toLowerCase();
    var s = searchTerm$1.toLowerCase();
    return ((this$3.indexOf(s) | 0) !== (-1));
  });
  var l = this$4;
  block: {
    var result;
    while (true) {
      if (l.c()) {
        var result = $m_sci_Nil$();
        break;
      } else {
        var h = l.t();
        var t = l.v();
        if ((!(!(!f(h))))) {
          l = t;
          continue;
        }
        var start = l;
        var remaining = t;
        while (true) {
          if (remaining.c()) {
            var result = start;
            break block;
          } else {
            var x = remaining.t();
            if ((!(!f(x)))) {
              remaining = remaining.v();
              continue;
            }
            var firstMiss = remaining;
            var newHead = new $c_sci_$colon$colon(start.t(), $m_sci_Nil$());
            var toProcess = start.v();
            var currentLast = newHead;
            while ((toProcess !== firstMiss)) {
              var newElem = new $c_sci_$colon$colon(toProcess.t(), $m_sci_Nil$());
              currentLast.U = newElem;
              currentLast = newElem;
              toProcess = toProcess.v();
            }
            var next = firstMiss.v();
            var nextToCopy = next;
            while ((!next.c())) {
              var head = next.t();
              if ((!(!f(head)))) {
                next = next.v();
              } else {
                while ((nextToCopy !== next)) {
                  var newElem$2 = new $c_sci_$colon$colon(nextToCopy.t(), $m_sci_Nil$());
                  currentLast.U = newElem$2;
                  currentLast = newElem$2;
                  nextToCopy = nextToCopy.v();
                }
                nextToCopy = next.v();
                next = next.v();
              }
            }
            if ((!nextToCopy.c())) {
              currentLast.U = nextToCopy;
            }
            var result = newHead;
            break block;
          }
        }
      }
    }
  }
  var f$1 = ((p$2) => {
    if (kindFilter$1.c()) {
      return true;
    } else {
      var x0 = kindFilter$1.d();
      var this$5 = infos$1.r(p$2.eG);
      if ((!this$5.c())) {
        var x0$1 = this$5.d();
        var x$1 = x0$1.FL;
        return ((x$1 === null) ? (x0 === null) : (x$1 === x0));
      } else {
        return false;
      }
    }
  });
  var l$1 = result;
  block$2: {
    var result$1;
    while (true) {
      if (l$1.c()) {
        var result$1 = $m_sci_Nil$();
        break;
      } else {
        var h$1 = l$1.t();
        var t$1 = l$1.v();
        if ((!(!(!f$1(h$1))))) {
          l$1 = t$1;
          continue;
        }
        var start$1 = l$1;
        var remaining$1 = t$1;
        while (true) {
          if (remaining$1.c()) {
            var result$1 = start$1;
            break block$2;
          } else {
            var x$2 = remaining$1.t();
            if ((!(!f$1(x$2)))) {
              remaining$1 = remaining$1.v();
              continue;
            }
            var firstMiss$1 = remaining$1;
            var newHead$1 = new $c_sci_$colon$colon(start$1.t(), $m_sci_Nil$());
            var toProcess$1 = start$1.v();
            var currentLast$1 = newHead$1;
            while ((toProcess$1 !== firstMiss$1)) {
              var newElem$1 = new $c_sci_$colon$colon(toProcess$1.t(), $m_sci_Nil$());
              currentLast$1.U = newElem$1;
              currentLast$1 = newElem$1;
              toProcess$1 = toProcess$1.v();
            }
            var next$1 = firstMiss$1.v();
            var nextToCopy$1 = next$1;
            while ((!next$1.c())) {
              var head$1 = next$1.t();
              if ((!(!f$1(head$1)))) {
                next$1 = next$1.v();
              } else {
                while ((nextToCopy$1 !== next$1)) {
                  var newElem$2$1 = new $c_sci_$colon$colon(nextToCopy$1.t(), $m_sci_Nil$());
                  currentLast$1.U = newElem$2$1;
                  currentLast$1 = newElem$2$1;
                  nextToCopy$1 = nextToCopy$1.v();
                }
                nextToCopy$1 = next$1.v();
                next$1 = next$1.v();
              }
            }
            if ((!nextToCopy$1.c())) {
              currentLast$1.U = nextToCopy$1;
            }
            var result$1 = newHead$1;
            break block$2;
          }
        }
      }
    }
  }
  matchResult4: {
    var sorted;
    var x$3 = $s_Lorg_jpablo_graphexplorer_projects_SortOption$__LastModified__Lorg_jpablo_graphexplorer_projects_SortOption();
    if (((x$3 === null) ? (sortOption$1 === null) : (x$3 === sortOption$1))) {
      var sorted = $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(result$1, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$19) => {
        var $x_1 = _$19;
        var x$4_$_lo = $x_1.vP;
        var x$4_$_hi = $x_1.vQ;
        var lo = ((-x$4_$_lo) | 0);
        var hi = ((((-x$4_$_hi) | 0) - ((lo !== 0) | 0)) | 0);
        return $bL(lo, hi);
      })), $m_s_math_Ordering$Long$());
      break matchResult4;
    }
    var x$3$1 = $s_Lorg_jpablo_graphexplorer_projects_SortOption$__Title__Lorg_jpablo_graphexplorer_projects_SortOption();
    if (((x$3$1 === null) ? (sortOption$1 === null) : (x$3$1 === sortOption$1))) {
      var sorted = $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(result$1, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$20) => {
        var this$7 = $p_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$__shownName$1__sci_Map__Lorg_jpablo_graphexplorer_projects_ProjectInfo__T($thiz, infos$1, _$20);
        return this$7.toLowerCase();
      })), $m_s_math_Ordering$String$());
      break matchResult4;
    }
    var x$5 = $s_Lorg_jpablo_graphexplorer_projects_SortOption$__CreationDate__Lorg_jpablo_graphexplorer_projects_SortOption();
    if (((x$5 === null) ? (sortOption$1 === null) : (x$5 === sortOption$1))) {
      var sorted = $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(result$1, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$21) => {
        var $x_2 = _$21;
        var x$6_$_lo = $x_2.ox;
        var x$6_$_hi = $x_2.oy;
        var lo$1 = ((-x$6_$_lo) | 0);
        var hi$1 = ((((-x$6_$_hi) | 0) - ((lo$1 !== 0) | 0)) | 0);
        return $bL(lo$1, hi$1);
      })), $m_s_math_Ordering$Long$());
      break matchResult4;
    }
    throw new $c_s_MatchError(sortOption$1);
  }
  $m_Lorg_jpablo_graphexplorer_viewer_telemetry_Telemetry$().r7("home.projects.cardsReady", $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("projectsShown", sorted.C())])));
  matchResult5$1: {
    var render;
    var x$7 = $s_Lorg_jpablo_graphexplorer_projects_LibraryViewMode$__Cards__Lorg_jpablo_graphexplorer_projects_LibraryViewMode();
    if (((x$7 === null) ? (viewMode$1 === null) : (x$7 === viewMode$1))) {
      var render = new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((_$22, _$23) => $m_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$().b6T(graphviz$1, router$1, _$22, _$23)));
      break matchResult5$1;
    }
    var x$9 = $s_Lorg_jpablo_graphexplorer_projects_LibraryViewMode$__Rows__Lorg_jpablo_graphexplorer_projects_LibraryViewMode();
    if (((x$9 === null) ? (viewMode$1 === null) : (x$9 === viewMode$1))) {
      var render = new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((_$24, _$25) => $m_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$().b6U(graphviz$1, router$1, _$24, _$25)));
      break matchResult5$1;
    }
    throw new $c_s_MatchError(viewMode$1);
  }
  var f$5 = ((p$3) => render.R(infos$1.r(p$3.eG), p$3));
  if ((sorted === $m_sci_Nil$())) {
    return $m_sci_Nil$();
  } else {
    var x0$2 = sorted.t();
    var h$2 = new $c_sci_$colon$colon(f$5(x0$2), $m_sci_Nil$());
    var t$2 = h$2;
    var rest = sorted.v();
    while ((rest !== $m_sci_Nil$())) {
      var x0$3 = rest.t();
      var nx = new $c_sci_$colon$colon(f$5(x0$3), $m_sci_Nil$());
      t$2.U = nx;
      t$2 = nx;
      rest = rest.v();
    }
    return h$2;
  }
}
function $p_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$__enablePreview$1__Lcom_raquo_airstream_state_Var__T__Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ExampleSource__V($thiz, previewEnabled$1, name$3, example$1) {
  if ((!(!(!previewEnabled$1.P().aq().d())))) {
    $m_Lorg_jpablo_graphexplorer_viewer_telemetry_Telemetry$().r7("home.exampleThumb.visible", $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("example", name$3), new $c_T2("path", example$1.q4)])));
    $f_Lcom_raquo_airstream_state_Var__set__O__V(previewEnabled$1, true);
  }
}
function $p_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$__enablePreview$2__Lcom_raquo_airstream_state_Var__Lorg_jpablo_graphexplorer_projects_ProjectInfo__V($thiz, previewEnabled$2, project$2) {
  if ((!(!(!previewEnabled$2.P().aq().d())))) {
    $m_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$().aPZ(project$2);
    $f_Lcom_raquo_airstream_state_Var__set__O__V(previewEnabled$2, true);
  }
}
function $p_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$__enablePreview$3__Lcom_raquo_airstream_state_Var__Lorg_jpablo_graphexplorer_projects_ProjectInfo__V($thiz, previewEnabled$3, project$8) {
  if ((!(!(!previewEnabled$3.P().aq().d())))) {
    $m_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$().aPZ(project$8);
    $f_Lcom_raquo_airstream_state_Var__set__O__V(previewEnabled$3, true);
  }
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$() {
  this.avk = null;
  this.a8o = null;
  $n_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$ = this;
  this.avk = $m_sci_Map$().ao($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2($s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__DOT__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat(), "badge-neutral"), new $c_T2($s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__Mermaid__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat(), "badge-secondary")])));
  this.a8o = "Open this example (it is not added to your library)";
}
$p = $c_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$() {
}
$h_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$.prototype = $p;
$p.afX = (function(format) {
  var color = $m_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$().avk.ay(format, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => "badge-neutral")));
  return $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s((("badge badge-xs " + color) + " badge-outline shrink-0")), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, format.m(), $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])));
});
$p.aPD = (function(info) {
  var this$1 = info.Sl;
  if (this$1.c()) {
    return $m_s_None$();
  } else {
    var x0 = this$1.d();
    return new $c_s_Some($m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("badge badge-xs badge-ghost shrink-0"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, x0, $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))));
  }
});
$p.aWb = (function(graphviz, router, routerCmds, viewerSettings, setTheme) {
  var sortOptionVar = $f_Lcom_raquo_airstream_state_Var__zoomLazy__F1__F2__Lcom_raquo_airstream_state_Var(viewerSettings, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((s) => $m_Lorg_jpablo_graphexplorer_projects_SortOption$().b6q(s.ms))), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((s$2, o) => {
    var librarySort$1 = new $c_s_Some(o.m());
    return new $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings(s$2.mp, s$2.mv, s$2.lH, s$2.mu, s$2.mw, s$2.my, s$2.ml, s$2.mx, s$2.mm, s$2.mo, s$2.mt, s$2.mn, s$2.mr, librarySort$1, s$2.mq, s$2.ni);
  })));
  var searchTermVar = $m_Lcom_raquo_laminar_api_package$().b.ff.bx("");
  var kindFilterVar = $f_Lcom_raquo_airstream_state_Var__zoomLazy__F1__F2__Lcom_raquo_airstream_state_Var(viewerSettings, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((s$3) => {
    var this$3 = s$3.mq;
    var f = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((name) => $m_sc_ArrayOps$().b1i($m_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$().aTi(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((name$2) => ((_$2) => (_$2.m() === name$2)))(name)))));
    return (this$3.c() ? $m_s_None$() : f.i(this$3.d()));
  })), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((s$4, f$1) => {
    var f$2 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3) => _$3.m()));
    var libraryFormatFilter$2 = (f$1.c() ? $m_s_None$() : new $c_s_Some(f$2.i(f$1.d())));
    return new $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings(s$4.mp, s$4.mv, s$4.lH, s$4.mu, s$4.mw, s$4.my, s$4.ml, s$4.mx, s$4.mm, s$4.mo, s$4.mt, s$4.mn, s$4.mr, s$4.ms, libraryFormatFilter$2, s$4.ni);
  })));
  var aboutDialogOpen = $m_Lcom_raquo_laminar_api_package$().b.ff.bx(false);
  var preferencesDialogOpen = $m_Lcom_raquo_laminar_api_package$().b.ff.bx(false);
  var viewModeVar = $f_Lcom_raquo_airstream_state_Var__zoomLazy__F1__F2__Lcom_raquo_airstream_state_Var(viewerSettings, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((s$5) => (s$5.mr ? $s_Lorg_jpablo_graphexplorer_projects_LibraryViewMode$__Rows__Lorg_jpablo_graphexplorer_projects_LibraryViewMode() : $s_Lorg_jpablo_graphexplorer_projects_LibraryViewMode$__Cards__Lorg_jpablo_graphexplorer_projects_LibraryViewMode()))), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((s$6, m) => {
    var x$2 = $s_Lorg_jpablo_graphexplorer_projects_LibraryViewMode$__Rows__Lorg_jpablo_graphexplorer_projects_LibraryViewMode();
    var libraryListMode$3 = ((m === null) ? (x$2 === null) : (m === x$2));
    return new $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings(s$6.mp, s$6.mv, s$6.lH, s$6.mu, s$6.mw, s$6.my, s$6.ml, s$6.mx, s$6.mm, s$6.mo, s$6.mt, s$6.mn, libraryListMode$3, s$6.ms, s$6.mq, s$6.ni);
  })));
  var promptLabelVar = $f_Lcom_raquo_airstream_state_Var__zoomLazy__F1__F2__Lcom_raquo_airstream_state_Var(viewerSettings, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4) => _$4.mu)), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((s$7, b) => {
    var b$1 = (!(!b));
    return new $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings(s$7.mp, s$7.mv, s$7.lH, b$1, s$7.mw, s$7.my, s$7.ml, s$7.mx, s$7.mm, s$7.mo, s$7.mt, s$7.mn, s$7.mr, s$7.ms, s$7.mq, s$7.ni);
  })));
  var enable3DVar = $f_Lcom_raquo_airstream_state_Var__zoomLazy__F1__F2__Lcom_raquo_airstream_state_Var(viewerSettings, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$5) => _$5.mm)), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((s$8, b$2) => {
    var b$3 = (!(!b$2));
    return new $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings(s$8.mp, s$8.mv, s$8.lH, s$8.mu, s$8.mw, s$8.my, s$8.ml, s$8.mx, b$3, s$8.mo, s$8.mt, s$8.mn, s$8.mr, s$8.ms, s$8.mq, s$8.ni);
  })));
  $m_Lcom_raquo_laminar_api_package$();
  var gearMenu = $m_Lcom_raquo_airstream_state_Val$().iT(new $c_sci_$colon$colon(new $c_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$MenuOption("Preferences\u2026", new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lcom_raquo_airstream_state_Var__set__O__V(preferencesDialogOpen, true);
  })), new $c_s_Some("Theme and editing preferences"), $m_s_None$()), new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$__Sep__Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry(), new $c_sci_$colon$colon(new $c_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$MenuOption("About Graph Explorer", new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lcom_raquo_airstream_state_Var__set__O__V(aboutDialogOpen, true);
  })), $m_s_None$(), $m_s_None$()), new $c_sci_$colon$colon(new $c_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$MenuOption("Source on GitHub", new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    window.open("https://github.com/jpablo/graph-explorer/tree/viewer", "_blank");
  })), $m_s_None$(), $m_s_None$()), $m_sci_Nil$())))));
  var $x_46 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_45 = $m_sr_ScalaRunTime$();
  var $x_44 = $m_Lcom_raquo_laminar_api_package$().b.gz().n("projects-view");
  var $x_41 = $f_Lcom_raquo_laminar_api_MountHooks__onMountCallback__F1__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6) => {
    $f_Lcom_raquo_airstream_state_Var__set__O__V(viewerSettings, $m_Lorg_jpablo_graphexplorer_projects_ProjectStorage$().b7f());
    var t0 = $m_Lorg_jpablo_graphexplorer_viewer_telemetry_Telemetry$().uc();
    var navDtMs = $m_Lorg_jpablo_graphexplorer_viewer_telemetry_Telemetry$().aYZ($m_Lorg_jpablo_graphexplorer_router_Router$().a8u);
    var $x_43 = $m_Lorg_jpablo_graphexplorer_viewer_telemetry_Telemetry$();
    var $x_42 = $m_sr_ScalaRunTime$();
    var default$1 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => (-1.0)));
    $x_43.r7("home.mount", $x_42.f(new ($d_T2.r().C)([new $c_T2("dtSinceNavMs", (navDtMs.c() ? default$1.a3() : navDtMs.d()))])));
    window.requestAnimationFrame(((_$7) => {
      $m_Lorg_jpablo_graphexplorer_viewer_telemetry_Telemetry$().r7("home.raf1", $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("dtSinceMountMs", ($m_Lorg_jpablo_graphexplorer_viewer_telemetry_Telemetry$().uc() - t0))])));
    }));
  })));
  var $x_40 = $f_Lcom_raquo_laminar_api_MountHooks__onUnmountCallback__F1__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$8) => {
    $m_Lorg_jpablo_graphexplorer_viewer_telemetry_Telemetry$().r7("home.unmount", $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([])));
  })));
  var $x_39 = $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("navbar bg-base-100"), $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("flex-1 flex items-center gap-2 ml-2"), $m_Lcom_raquo_laminar_api_package$().b.aPc().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.aSm().n("/favicon.svg"), $m_Lcom_raquo_laminar_api_package$().b.y.s("h-6 w-6")]))), $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("text-xl font-semibold"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Graph Explorer", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))]))), $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("flex-none mr-2 flex items-center gap-2"), $f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement($m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().DB($m_Lcom_raquo_laminar_api_package$().b.Af().Aq().n("Settings"), gearMenu, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$9) => new $c_Lcom_raquo_laminar_modifiers_EventListener(_$9, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((action) => {
    action.a3();
  }))))), $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("bi bi-gear")]))), false, "w-56"), $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("dropdown-end")])))])))])));
  var $x_38 = $m_Lorg_jpablo_graphexplorer_viewer_components_AboutDialog$package$().aLo(aboutDialogOpen);
  var $x_37 = $m_Lorg_jpablo_graphexplorer_viewer_components_PreferencesDialog$package$().aLy(preferencesDialogOpen, $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), viewerSettings.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$10) => _$10.lH)), $m_s_None$()), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((theme) => {
    $f_Lcom_raquo_airstream_state_Var__update__F1__V(viewerSettings, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((theme$2) => ((_$11) => {
      var currentTheme$4$1 = new $c_s_Some(theme$2);
      return new $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings(_$11.mp, _$11.mv, currentTheme$4$1, _$11.mu, _$11.mw, _$11.my, _$11.ml, _$11.mx, _$11.mm, _$11.mo, _$11.mt, _$11.mn, _$11.mr, _$11.ms, _$11.mq, _$11.ni);
    }))(theme)));
    setTheme.i(theme);
  })), promptLabelVar, enable3DVar);
  var $x_36 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_35 = $m_sr_ScalaRunTime$();
  var $x_34 = $m_Lcom_raquo_laminar_api_package$().b.gz().n("projects-body");
  var $x_33 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_32 = $m_sr_ScalaRunTime$();
  var $x_31 = $m_Lcom_raquo_laminar_api_package$().b.y.s("navbar px-6");
  var $x_30 = $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("flex-1"), $m_Lcom_raquo_laminar_api_package$().b.ago().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("text-2xl font-bold gap-2 flex"), $m_Lorg_jpablo_graphexplorer_viewer_widgets_Icons$().aOf($m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([])))), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Library", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))])));
  var $x_29 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_28 = $m_sr_ScalaRunTime$();
  var $x_27 = $m_Lcom_raquo_laminar_api_package$().b.y.s("flex flex-wrap md:flex-nowrap justify-end items-center gap-2");
  var $x_26 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$();
  var $x_25 = $m_sr_ScalaRunTime$();
  var $x_24 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_InputVariant$().aH5;
  var $x_23 = $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("bi bi-search")])));
  var $x_22 = $m_Lcom_raquo_laminar_api_package$().b.w7();
  var $x_21 = $m_sr_ScalaRunTime$();
  var $x_20 = $m_Lcom_raquo_laminar_api_package$().b.y.s("grow");
  var $x_19 = $m_Lcom_raquo_laminar_api_package$().b.yo().n("search");
  var $x_18 = $m_Lcom_raquo_laminar_api_package$().b.ud().n("Search library...");
  $m_Lcom_raquo_laminar_api_package$();
  var updater = $m_Lcom_raquo_laminar_api_package$().b.jx().bj(searchTermVar);
  var listener = new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.oE(), false, false)).nC(), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => {
    searchTermVar.jA().bA(_$1);
  })));
  var $x_17 = $x_26.aLv($x_25.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_24, $x_23, $x_22.w($x_21.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_20, $x_19, $x_18, $m_Lcom_raquo_laminar_inputs_InputController$().qU(listener, updater)])))])));
  var $x_16 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().aLu("library-kind-filter", $m_sc_ArrayOps$().kX($m_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$().aTi()), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$12) => _$12.m())), kindFilterVar, "All kinds", $m_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$().nx());
  var $x_15 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().aet($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lorg_jpablo_graphexplorer_viewer_widgets_SelectVariant$().aH7, $m_Lcom_raquo_laminar_api_package$().b.y.s("h-8"), $f_Lcom_raquo_laminar_api_Implicits__nodeSeqToModifier__O__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, $m_sc_ArrayOps$().kX($m_Lorg_jpablo_graphexplorer_projects_SortOption$().aTh()).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((opt) => $m_Lcom_raquo_laminar_api_package$().b.Jd().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.jx().n(opt.m()), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, opt.aI(), $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))))), $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$()), $m_Lcom_raquo_laminar_api_package$().b.jx().bj($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), sortOptionVar.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$13) => _$13.m())), $m_s_None$())), new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.Eb(), false, false)).nC().E9(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((\u03b4name) => $m_Lorg_jpablo_graphexplorer_projects_SortOption$().bb1(\u03b4name)))), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1$1) => {
    sortOptionVar.jA().bA(_$1$1);
  })))])));
  var $x_14 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().aVZ(new $c_sci_$colon$colon(new $c_T3($s_Lorg_jpablo_graphexplorer_projects_LibraryViewMode$__Cards__Lorg_jpablo_graphexplorer_projects_LibraryViewMode(), "bi bi-grid", "View as cards"), new $c_sci_$colon$colon(new $c_T3($s_Lorg_jpablo_graphexplorer_projects_LibraryViewMode$__Rows__Lorg_jpablo_graphexplorer_projects_LibraryViewMode(), "bi bi-list-ul", "View as list"), $m_sci_Nil$())), viewModeVar, $m_Lorg_jpablo_graphexplorer_projects_LibraryViewMode$().nx());
  var $x_13 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$();
  var $x_12 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$();
  var $x_11 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Button$package$();
  var $x_10 = $m_sr_ScalaRunTime$();
  var $x_9 = $m_Lcom_raquo_laminar_api_package$().b.y.s("h-8");
  var $x_8 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Icons$().b6J($m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([]))));
  var $x_7 = $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Create Diagram", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7);
  var this$40 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false));
  var onNext$3 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    routerCmds.SL.gZ(new $c_s_Some(new $c_s_Some($m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$().GZ)), true);
  }));
  $m_Lcom_raquo_laminar_api_package$features$().cz();
  var $x_6 = $x_33.w($x_32.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_31, $x_30, $x_29.w($x_28.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_27, $x_17, $x_16, $x_15, $x_14, $x_13.ai5($x_12.AB($x_11.hH($x_10.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_9, $x_8, $x_7, new $c_Lcom_raquo_laminar_modifiers_EventListener(this$40, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2$1) => {
    onNext$3.a3();
  })))])))))])))])));
  var $x_5 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_4 = $m_sr_ScalaRunTime$();
  var $x_3 = $m_Lcom_raquo_laminar_api_package$().b.gz().n("projects-grid");
  var $x_2 = $m_Lcom_raquo_laminar_api_package$().b.y.s("list-mode").bj($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), viewModeVar.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$14) => {
    var x$2$1 = $s_Lorg_jpablo_graphexplorer_projects_LibraryViewMode$__Rows__Lorg_jpablo_graphexplorer_projects_LibraryViewMode();
    return ((_$14 === null) ? (x$2$1 === null) : (_$14 === x$2$1));
  })), $m_s_None$()));
  $m_Lcom_raquo_laminar_api_package$();
  var $x_1 = $m_Lcom_raquo_laminar_inserters_ChildrenInserter$();
  var debouncedSearch = $f_Lcom_raquo_airstream_core_EventStream__toSignal__F0__Z__Lcom_raquo_airstream_core_Signal(new $c_Lcom_raquo_airstream_timing_DebounceStream(new $c_Lcom_raquo_airstream_misc_StreamFromSignal(searchTermVar.P(), true), 300), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => "")), false);
  var languages = new $c_Lorg_jpablo_graphexplorer_viewer_backends_DefaultDiagramLanguages(graphviz, $m_s_concurrent_ExecutionContext$().ek());
  var cardInfoSignal = $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), $m_Lorg_jpablo_graphexplorer_projects_Library$().IP(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((dir) => $m_sci_Map$().ao(dir.hY.aOd(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((p) => {
    var this$49 = $m_Lorg_jpablo_graphexplorer_projects_Library$().XM(p.eG, languages);
    var f$3 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((p$2) => ((_$15) => new $c_T2(p$2.eG, _$15)))(p));
    return (this$49.c() ? $m_s_None$() : new $c_s_Some(f$3.i(this$49.d())));
  })))))), $m_s_None$());
  return $x_46.w($x_45.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_44, $x_41, $x_40, $x_39, $x_38, $x_37, $x_36.w($x_35.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_34, $x_6, $x_5.w($x_4.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_3, $x_2, $x_1.IB($m_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$().aMO($m_Lorg_jpablo_graphexplorer_projects_Library$().IP(), debouncedSearch, sortOptionVar.P(), kindFilterVar.P(), cardInfoSignal, viewModeVar.P(), new $c_sr_AbstractFunction6_$$Lambda$70739abafae35d0aa747e9aa55a42abdab2f8361(((directory, searchTerm, sortOption, kindFilter, infos, viewMode) => {
    var $x_50 = $m_sr_ScalaRunTime$();
    var $x_49 = new $c_T2("projectsTotal", directory.hY.C());
    var $x_48 = new $c_T2("searchLen", searchTerm.length);
    var $x_47 = new $c_T2("sort", sortOption.m());
    var ifEmpty = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => "AllKinds"));
    var f$4 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$16) => _$16.m()));
    var fields$proxy1 = $x_50.f(new ($d_T2.r().C)([$x_49, $x_48, $x_47, new $c_T2("kind", (kindFilter.c() ? ifEmpty.a3() : f$4.i(kindFilter.d()))), new $c_T2("view", viewMode.m())]));
    if ((!$m_Lorg_jpablo_graphexplorer_viewer_telemetry_Telemetry$().a3f())) {
      return $p_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$__body$proxy1$1__sci_Map__Lorg_jpablo_graphexplorer_projects_ProjectsDirectory__T__s_Option__Lorg_jpablo_graphexplorer_projects_SortOption__Lorg_jpablo_graphexplorer_projects_LibraryViewMode__Lorg_jpablo_graphexplorer_viewer_backends_graphviz_Graphviz__Lorg_jpablo_graphexplorer_router_Router__sci_List(this, infos, directory, searchTerm, kindFilter, sortOption, viewMode, graphviz, router);
    } else {
      var startedAt = $m_Lorg_jpablo_graphexplorer_viewer_telemetry_Telemetry$().uc();
      var a = $p_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$__body$proxy1$1__sci_Map__Lorg_jpablo_graphexplorer_projects_ProjectsDirectory__T__s_Option__Lorg_jpablo_graphexplorer_projects_SortOption__Lorg_jpablo_graphexplorer_projects_LibraryViewMode__Lorg_jpablo_graphexplorer_viewer_backends_graphviz_Graphviz__Lorg_jpablo_graphexplorer_router_Router__sci_List(this, infos, directory, searchTerm, kindFilter, sortOption, viewMode, graphviz, router);
      $m_Lorg_jpablo_graphexplorer_viewer_telemetry_Telemetry$().r7("home.projects.computeCards", fields$proxy1.hJ(new $c_T2("dtMs", ($m_Lorg_jpablo_graphexplorer_viewer_telemetry_Telemetry$().uc() - startedAt))));
      return a;
    }
  }))), $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$(), $m_Lcom_raquo_laminar_modifiers_RenderableNode$().ht, (void 0))]))), $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.gz().n("examples-grid"), $m_Lcom_raquo_laminar_api_package$().b.ago().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("text-2xl font-bold gap-2 flex mb-4"), $m_Lorg_jpablo_graphexplorer_viewer_widgets_Icons$().aOf($m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([])))), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Examples", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4"), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_inserters_ChildrenInserter$().IB(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_airstream_state_Val$().iT($f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$().a8A, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    if ((x$1 !== null)) {
      var example = x$1.h();
      return ((example.q4 === $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$().a8y.q4) || (example.q4 === $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$().a8z.q4));
    }
    throw new $c_s_MatchError(x$1);
  })), true).iz().L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    if ((x$1$2 !== null)) {
      var name$1 = x$1$2.g();
      var example$1 = x$1$2.h();
      return $m_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$().b0U(graphviz, routerCmds, name$1, example$1);
    }
    throw new $c_s_MatchError(x$1$2);
  }))))), $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$(), $m_Lcom_raquo_laminar_modifiers_RenderableNode$().ht, (void 0)))])))])))])))])));
});
$p.afs = (function(enable) {
  var observerOpt = new $c_sr_ObjectRef($m_s_None$());
  return new $c_sci_$colon$colon($f_Lcom_raquo_laminar_api_MountHooks__onMountCallback__F1__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((ctx) => {
    var ioCtor = IntersectionObserver;
    if (((typeof ioCtor) === "function")) {
      var obs = new $c_sr_ObjectRef(null);
      obs.aD = new ioCtor($m_sjs_js_Any$().b1K(new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((entries, _$26) => {
        var entry0 = entries[0];
        if (((entry0 !== null) && (!(!entry0.isIntersecting)))) {
          enable.a3();
          if ((obs.aD !== null)) {
            obs.aD.disconnect();
          }
        }
      }))));
      obs.aD.observe(ctx.JW.en);
      observerOpt.aD = new $c_s_Some(obs.aD);
    } else {
      enable.a3();
    }
  }))), new $c_sci_$colon$colon($f_Lcom_raquo_laminar_api_MountHooks__onUnmountCallback__F1__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$27) => {
    var this$5 = observerOpt.aD;
    if ((!this$5.c())) {
      var x0 = this$5.d();
      x0.disconnect();
    }
    observerOpt.aD = $m_s_None$();
  }))), $m_sci_Nil$()));
});
$p.b0U = (function(graphviz, routerCmds, name, example) {
  var previewEnabled = $m_Lcom_raquo_laminar_api_package$().b.ff.bx(false);
  return $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("example-card card card-sm"), $m_Lcom_raquo_laminar_api_package$().b.aO0().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("w-full h-32 overflow-hidden bg-base-200 flex items-center justify-center cursor-pointer"), $f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, $m_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$().afs(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $p_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$__enablePreview$1__Lcom_raquo_airstream_state_Var__T__Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ExampleSource__V(this, previewEnabled, name, example);
  }))), $m_s_$less$colon$less$().b1, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$()), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_inserters_ChildInserter$().nv($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), previewEnabled.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var x$1$1 = (!(!x$1));
    if ((!x$1$1)) {
      var $x_5 = $m_Lcom_raquo_laminar_api_package$().b.a8();
      var $x_4 = $m_sr_ScalaRunTime$();
      var $x_3 = $m_Lcom_raquo_laminar_api_package$().b.y.s("w-full h-full p-1 flex items-center justify-center text-base-content/40 text-xs");
      var $x_2 = $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Loading preview\u2026", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7);
      var $x_1 = $m_Lcom_raquo_laminar_api_package$().b.eW().n($m_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$().a8o);
      var this$8 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false));
      var onNext = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
        routerCmds.a9b.gZ(new $c_s_Some($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$().ai4(name)), true);
      }));
      $m_Lcom_raquo_laminar_api_package$features$().cz();
      return $x_5.w($x_4.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_3, $x_2, $x_1, new $c_Lcom_raquo_laminar_modifiers_EventListener(this$8, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => {
        onNext.a3();
      })))])));
    }
    if (x$1$1) {
      var $x_9 = $m_Lcom_raquo_laminar_api_package$().b.a8();
      var $x_8 = $m_sr_ScalaRunTime$();
      var $x_7 = $m_Lcom_raquo_laminar_api_package$().b.y.s("w-full h-full");
      $m_Lcom_raquo_laminar_api_package$();
      var $x_6 = $m_Lcom_raquo_laminar_inserters_ChildInserter$();
      var this$21 = $m_Lcom_raquo_laminar_api_package$().b.aLt().aOL(example.q4, $m_sr_ScalaRunTime$().f(new ($d_F1.r().C)([])));
      var project = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((str) => {
        $m_Lorg_jpablo_graphexplorer_viewer_telemetry_Telemetry$().r7("home.exampleThumb.start", $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("example", name), new $c_T2("path", example.q4), new $c_T2("sourceChars", str.length)])));
        return $m_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$().aRa(graphviz, new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_DotText(str), new $c_sci_$colon$colon(new $c_T2("example", name), new $c_sci_$colon$colon(new $c_T2("path", example.q4), $m_sci_Nil$())), $m_s_concurrent_ExecutionContext$().ek());
      }));
      return $x_9.w($x_8.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_7, $x_6.nv(new $c_Lcom_raquo_airstream_misc_MapStream($m_Lcom_raquo_airstream_core_Observable$().aj8.mK(new $c_Lcom_raquo_airstream_misc_MapStream(this$21, project, $m_s_None$())), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((svgElement) => {
        var $x_14 = $m_Lcom_raquo_laminar_api_package$().b.a8();
        var $x_13 = $m_sr_ScalaRunTime$();
        var $x_12 = $m_Lcom_raquo_laminar_api_package$().b.y.s("w-full h-full p-1 flex items-center justify-center");
        var $x_11 = $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("w-full h-full relative"), $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("absolute inset-0 w-full h-full"), $f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement(svgElement, $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n("100%"), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n("100%"), $m_Lcom_raquo_laminar_api_package$().b.j().aR6().n("xMidYMid meet")])))])))])));
        var $x_10 = $m_Lcom_raquo_laminar_api_package$().b.eW().n($m_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$().a8o);
        var this$24 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false));
        var onNext$1 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
          routerCmds.a9b.gZ(new $c_s_Some($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$().ai4(name)), true);
        }));
        $m_Lcom_raquo_laminar_api_package$features$().cz();
        return $x_14.w($x_13.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_12, $x_11, $x_10, new $c_Lcom_raquo_laminar_modifiers_EventListener(this$24, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2$1) => {
          onNext$1.a3();
        })))])));
      })), $m_s_None$()), $m_Lcom_raquo_laminar_modifiers_RenderableNode$().ht, (void 0))])));
    }
    throw new $c_s_MatchError(x$1$1);
  })), $m_s_None$()), $m_Lcom_raquo_laminar_modifiers_RenderableNode$().ht, (void 0)))])))]))), $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("card-body p-2"), $m_Lcom_raquo_laminar_api_package$().b.E3().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("card-title text-sm justify-center gap-2"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, name, $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7), $m_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$().afX(example.Sx)])))])))])));
});
$p.aRc = (function(graphviz, project) {
  var this$13 = $f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable($m_Lorg_jpablo_graphexplorer_projects_Library$().a3E(project.eG));
  var project$1 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((str) => {
    $m_Lorg_jpablo_graphexplorer_viewer_telemetry_Telemetry$().r7("home.thumb.start", $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("projectId", project.eG.cv), new $c_T2("name", project.nb), new $c_T2("sourceChars", str.length)])));
    return $m_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$().aRa(graphviz, new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_DotText(str), new $c_sci_$colon$colon(new $c_T2("projectId", project.eG.cv), new $c_sci_$colon$colon(new $c_T2("name", project.nb), $m_sci_Nil$())), $m_s_concurrent_ExecutionContext$().ek());
  }));
  return $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), $m_Lcom_raquo_airstream_core_Observable$().AL.mK(this$13.fQ(project$1)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((svgElement) => $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("w-full h-full p-1 flex items-center justify-center"), $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("w-full h-full relative"), $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("absolute inset-0 w-full h-full"), $f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement(svgElement, $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n("100%"), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n("100%"), $m_Lcom_raquo_laminar_api_package$().b.j().aR6().n("xMidYMid meet")])))])))])))]))))), $m_s_None$());
});
$p.aPZ = (function(project) {
  $m_Lorg_jpablo_graphexplorer_viewer_telemetry_Telemetry$().r7("home.thumb.visible", $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("projectId", project.eG.cv), new $c_T2("name", project.nb)])));
});
$p.b6T = (function(graphviz, router, info, project) {
  var previewEnabled = $m_Lcom_raquo_laminar_api_package$().b.ff.bx(false);
  var $x_32 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_31 = $m_sr_ScalaRunTime$();
  var $x_30 = $m_Lcom_raquo_laminar_api_package$().b.y.s("project-card card");
  var $x_29 = $m_Lcom_raquo_laminar_api_package$().b.aO0();
  var $x_28 = $m_sr_ScalaRunTime$();
  var $x_27 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_26 = $m_sr_ScalaRunTime$();
  var $x_25 = $m_Lcom_raquo_laminar_api_package$().b.y.s("w-full h-48 overflow-hidden bg-base-200 flex items-center justify-center cursor-pointer");
  var $x_24 = $f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, $m_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$().afs(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $p_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$__enablePreview$2__Lcom_raquo_airstream_state_Var__Lorg_jpablo_graphexplorer_projects_ProjectInfo__V(this, previewEnabled, project);
  }))), $m_s_$less$colon$less$().b1, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$());
  $m_Lcom_raquo_laminar_api_package$();
  var $x_23 = $m_Lcom_raquo_laminar_inserters_ChildInserter$();
  var this$8 = previewEnabled.P();
  var project$1 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var x$1$1 = (!(!x$1));
    if ((!x$1$1)) {
      $m_Lcom_raquo_laminar_api_package$();
      return $m_Lcom_raquo_airstream_state_Val$().iT($m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("w-full h-full p-1 flex items-center justify-center text-base-content/40 text-xs"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Loading preview\u2026", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))));
    }
    if (x$1$1) {
      return $m_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$().aRc(graphviz, project);
    }
    throw new $c_s_MatchError(x$1$1);
  }));
  var $x_22 = $x_23.nv($m_Lcom_raquo_airstream_core_Observable$().AL.mK($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), this$8, project$1, $m_s_None$())).dM(), $m_Lcom_raquo_laminar_modifiers_RenderableNode$().ht, (void 0));
  var this$13 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false)).jY();
  var onNext = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    router.rh(new $c_Lorg_jpablo_graphexplorer_router_Route$ProjectDetail(project.eG.cv, $m_s_None$()));
  }));
  $m_Lcom_raquo_laminar_api_package$features$().cz();
  var $x_21 = $x_29.w($x_28.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_27.w($x_26.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_25, $x_24, $x_22, new $c_Lcom_raquo_laminar_modifiers_EventListener(this$13, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => {
    onNext.a3();
  })))])))])));
  var $x_20 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_19 = $m_sr_ScalaRunTime$();
  var $x_18 = $m_Lcom_raquo_laminar_api_package$().b.y.s("card-body p-3 pt-2");
  var $x_17 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_16 = $m_sr_ScalaRunTime$();
  var $x_15 = $m_Lcom_raquo_laminar_api_package$().b.y.s("flex items-center justify-between");
  var $x_14 = $m_Lcom_raquo_laminar_api_package$().b.E3();
  var $x_13 = $m_sr_ScalaRunTime$();
  var $x_12 = $m_Lcom_raquo_laminar_api_package$().b.y.s("card-title");
  var $x_11 = $m_Lcom_raquo_laminar_api_package$().b.DD();
  var $x_10 = $m_sr_ScalaRunTime$();
  var $x_9 = $m_Lcom_raquo_laminar_api_package$().b.ags().n(("#/" + project.eG.cv));
  var $x_8 = $m_Lcom_raquo_laminar_api_package$().b.y.s("flex items-center gap-2 hover:text-primary transition-colors");
  var this$15 = $m_Lcom_raquo_laminar_api_package$().b;
  var this$14 = (info.c() ? $m_s_None$() : new $c_s_Some(info.d().BI));
  var $x_7 = $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode(this$15, (this$14.c() ? project.nb : this$14.d()), $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7);
  var this$19 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false)).jY();
  var onNext$1 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    router.rh(new $c_Lorg_jpablo_graphexplorer_router_Route$ProjectDetail(project.eG.cv, $m_s_None$()));
  }));
  $m_Lcom_raquo_laminar_api_package$features$().cz();
  var $x_6 = $x_11.w($x_10.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_9, $x_8, $x_7, new $c_Lcom_raquo_laminar_modifiers_EventListener(this$19, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2$1) => {
    onNext$1.a3();
  })))])));
  var $x_5 = $m_Lcom_raquo_laminar_api_package$().b;
  if (info.c()) {
    var $x_4 = $m_s_None$();
  } else {
    var x0$1 = info.d();
    var $x_4 = new $c_s_Some($m_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$().afX(x0$1.FL));
  }
  var $x_3 = $f_Lcom_raquo_laminar_api_Implicits__nodeOptionToModifier__s_Option__Lcom_raquo_laminar_modifiers_Modifier($x_5, $x_4);
  var $x_2 = $m_Lcom_raquo_laminar_api_package$().b;
  if (info.c()) {
    var $x_1 = $m_s_None$();
  } else {
    var x0$2 = info.d();
    var $x_1 = $m_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$().aPD(x0$2);
  }
  return $x_32.w($x_31.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_30, $x_21, $x_20.w($x_19.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_18, $x_17.w($x_16.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_15, $x_14.w($x_13.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_12, $x_6, $x_3, $f_Lcom_raquo_laminar_api_Implicits__nodeOptionToModifier__s_Option__Lcom_raquo_laminar_modifiers_Modifier($x_2, $x_1)]))), $m_Lorg_jpablo_graphexplorer_viewer_widgets_IconButton$package$().Ae("bi-trash", "Delete diagram", "tooltip-left", $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("danger")])), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    if ((!(!window.confirm("Are you sure you want to delete this project?")))) {
      $m_Lorg_jpablo_graphexplorer_projects_Library$().WD(project.eG);
    }
  })))]))), $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("text-sm text-base-content/70 flex flex-col gap-1"), $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("flex items-center gap-1"), $m_Lorg_jpablo_graphexplorer_viewer_widgets_Icons$().b49($m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([])))), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, ("Last modified: " + $m_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$().a3s(project.vP, project.vQ)), $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("flex items-center gap-1"), $m_Lorg_jpablo_graphexplorer_viewer_widgets_Icons$().b1b($m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([])))), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, ("Created: " + $m_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$().a3s(project.ox, project.oy)), $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))])))])))])));
});
$p.b6U = (function(graphviz, router, info, project) {
  var previewEnabled = $m_Lcom_raquo_laminar_api_package$().b.ff.bx(false);
  var $x_24 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_23 = $m_sr_ScalaRunTime$();
  var $x_22 = $m_Lcom_raquo_laminar_api_package$().b.y.s("project-row");
  var this$4 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false));
  var onNext = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    router.rh(new $c_Lorg_jpablo_graphexplorer_router_Route$ProjectDetail(project.eG.cv, $m_s_None$()));
  }));
  $m_Lcom_raquo_laminar_api_package$features$().cz();
  var $x_21 = new $c_Lcom_raquo_laminar_modifiers_EventListener(this$4, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => {
    onNext.a3();
  })));
  var $x_20 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_19 = $m_sr_ScalaRunTime$();
  var $x_18 = $m_Lcom_raquo_laminar_api_package$().b.y.s("row-thumb");
  var $x_17 = $f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, $m_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$().afs(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $p_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$__enablePreview$3__Lcom_raquo_airstream_state_Var__Lorg_jpablo_graphexplorer_projects_ProjectInfo__V(this, previewEnabled, project);
  }))), $m_s_$less$colon$less$().b1, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$());
  $m_Lcom_raquo_laminar_api_package$();
  var $x_16 = $m_Lcom_raquo_laminar_receivers_ChildOptionReceiver$();
  var this$13 = previewEnabled.P();
  var project$2 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var x$1$1 = (!(!x$1));
    if ((!x$1$1)) {
      $m_Lcom_raquo_laminar_api_package$();
      return $m_Lcom_raquo_airstream_state_Val$().iT($m_s_None$());
    }
    if (x$1$1) {
      return $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), $m_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$().aRc(graphviz, project), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$30) => new $c_s_Some(_$30))), $m_s_None$());
    }
    throw new $c_s_MatchError(x$1$1);
  }));
  var $x_15 = $x_20.w($x_19.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_18, $x_17, $x_16.gR($m_Lcom_raquo_airstream_core_Observable$().AL.mK($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), this$13, project$2, $m_s_None$())))])));
  var $x_14 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_13 = $m_sr_ScalaRunTime$();
  var $x_12 = $m_Lcom_raquo_laminar_api_package$().b.y.s("flex-1 min-w-0 flex items-center gap-2");
  var $x_11 = $m_Lcom_raquo_laminar_api_package$().b.DD();
  var $x_10 = $m_sr_ScalaRunTime$();
  var $x_9 = $m_Lcom_raquo_laminar_api_package$().b.ags().n(("#/" + project.eG.cv));
  var $x_8 = $m_Lcom_raquo_laminar_api_package$().b.y.s("font-medium truncate hover:text-primary transition-colors");
  var this$15 = $m_Lcom_raquo_laminar_api_package$().b;
  var this$14 = (info.c() ? $m_s_None$() : new $c_s_Some(info.d().BI));
  var $x_7 = $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode(this$15, (this$14.c() ? project.nb : this$14.d()), $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7);
  var this$19 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false)).jY().AG();
  var onNext$1 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    router.rh(new $c_Lorg_jpablo_graphexplorer_router_Route$ProjectDetail(project.eG.cv, $m_s_None$()));
  }));
  $m_Lcom_raquo_laminar_api_package$features$().cz();
  var $x_6 = $x_11.w($x_10.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_9, $x_8, $x_7, new $c_Lcom_raquo_laminar_modifiers_EventListener(this$19, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2$1) => {
    onNext$1.a3();
  })))])));
  var $x_5 = $m_Lcom_raquo_laminar_api_package$().b;
  if (info.c()) {
    var $x_4 = $m_s_None$();
  } else {
    var x0$1 = info.d();
    var $x_4 = new $c_s_Some($m_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$().afX(x0$1.FL));
  }
  var $x_3 = $f_Lcom_raquo_laminar_api_Implicits__nodeOptionToModifier__s_Option__Lcom_raquo_laminar_modifiers_Modifier($x_5, $x_4);
  var $x_2 = $m_Lcom_raquo_laminar_api_package$().b;
  if (info.c()) {
    var $x_1 = $m_s_None$();
  } else {
    var x0$2 = info.d();
    var $x_1 = $m_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$().aPD(x0$2);
  }
  return $x_24.w($x_23.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_22, $x_21, $x_15, $x_14.w($x_13.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_12, $x_6, $x_3, $f_Lcom_raquo_laminar_api_Implicits__nodeOptionToModifier__s_Option__Lcom_raquo_laminar_modifiers_Modifier($x_2, $x_1)]))), $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("row-date hidden sm:block"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, ("Modified " + $m_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$().a3s(project.vP, project.vQ)), $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("row-date hidden md:block"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, ("Created " + $m_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$().a3s(project.ox, project.oy)), $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false)).AG(), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((sink) => ((_$1) => {
    sink.bA(_$1);
  }))($m_Lcom_raquo_laminar_api_package$().b.ED.m5))), $m_Lorg_jpablo_graphexplorer_viewer_widgets_IconButton$package$().Ae("bi-trash", "Delete diagram", "tooltip-left", $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("danger")])), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    if ((!(!window.confirm("Are you sure you want to delete this project?")))) {
      $m_Lorg_jpablo_graphexplorer_projects_Library$().WD(project.eG);
    }
  })))])))])));
});
$p.a3s = (function(timestamp_$_lo, timestamp_$_hi) {
  var date = new Date(((4.294967296E9 * timestamp_$_hi) + (timestamp_$_lo >>> 0.0)));
  return date.toLocaleDateString();
});
var $d_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$, "org.jpablo.graphexplorer.projects.ProjectsDirectoryView$package$", ({
  wR: 1
}));
var $n_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$;
function $m_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$)) {
    $n_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$ = new $c_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$;
}
function $p_Lorg_jpablo_graphexplorer_router_Router__currentPathname__T($thiz) {
  return (((typeof window) !== "undefined") ? window.location.pathname : "/");
}
function $p_Lorg_jpablo_graphexplorer_router_Router__parsePath__T__Lorg_jpablo_graphexplorer_router_Route($thiz, path) {
  var sourceOpt = (((typeof window) !== "undefined") ? $m_Lorg_jpablo_graphexplorer_viewer_utils_ShareUrl$().aRm() : $m_s_None$());
  var $x_2 = $m_sci_Nil$();
  var $x_1 = $m_s_Predef$();
  var xs = $f_T__split__T__I__AT($m_sc_StringOps$().wg(path, "/"), "/", 0);
  var evidence$1 = $m_s_reflect_ClassTag$().y0($objectGetClass(xs).ba.Q());
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1.h8();
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var i = 0;
  while ((i < xs.a.length)) {
    var x1 = i;
    var x = xs.a[x1];
    if ((x !== "")) {
      var unboxedElem = (isCharArrayBuilder ? $uC(x) : ((x === null) ? elementClass.ba.z : x));
      jsElems.push(unboxedElem);
    }
    i = ((1 + i) | 0);
  }
  var elemRuntimeClass = ((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass));
  var x14 = $x_2.b6($x_1.fB(elemRuntimeClass.ba.r().w(jsElems)));
  if ((x14 instanceof $c_sci_$colon$colon)) {
    var x34 = x14.er;
    var x35 = x14.U;
    if ((($m_Lorg_jpablo_graphexplorer_router_Router$().a8r === x34) && $m_sci_Nil$().e(x35))) {
      return $s_Lorg_jpablo_graphexplorer_router_Route$__Home__Lorg_jpablo_graphexplorer_router_Route();
    }
    if ((($m_Lorg_jpablo_graphexplorer_router_Router$().So === x34) && (x35 instanceof $c_sci_$colon$colon))) {
      var x32 = x35.U;
      var id = x35.er;
      if ($m_sci_Nil$().e(x32)) {
        return new $c_Lorg_jpablo_graphexplorer_router_Route$ProjectDetail(id, sourceOpt);
      }
    }
    if ((($m_Lorg_jpablo_graphexplorer_router_Router$().a8t === x34) && (x35 instanceof $c_sci_$colon$colon))) {
      var x26 = x35.U;
      var slug = x35.er;
      if ($m_sci_Nil$().e(x26)) {
        return new $c_Lorg_jpablo_graphexplorer_router_Route$Example(slug);
      }
    }
    if ((($m_Lorg_jpablo_graphexplorer_router_Router$().a8s === x34) && (x35 instanceof $c_sci_$colon$colon))) {
      var x20 = x35.U;
      var session = x35.er;
      if ($m_sci_Nil$().e(x20)) {
        return new $c_Lorg_jpablo_graphexplorer_router_Route$LooseDocument(session);
      }
    }
  }
  return $s_Lorg_jpablo_graphexplorer_router_Route$__Home__Lorg_jpablo_graphexplorer_router_Route();
}
function $p_Lorg_jpablo_graphexplorer_router_Router__buildPath__Lorg_jpablo_graphexplorer_router_Route__T($thiz, route) {
  var x = $s_Lorg_jpablo_graphexplorer_router_Route$__Home__Lorg_jpablo_graphexplorer_router_Route();
  if (((x === null) ? (route === null) : x.e(route))) {
    return $m_Lorg_jpablo_graphexplorer_router_Router$().a8u;
  }
  if ((route instanceof $c_Lorg_jpablo_graphexplorer_router_Route$ProjectDetail)) {
    var x45 = route.FO;
    return ((("/" + $m_Lorg_jpablo_graphexplorer_router_Router$().So) + "/") + x45);
  }
  if ((route instanceof $c_Lorg_jpablo_graphexplorer_router_Route$Example)) {
    var x42 = route.Ln;
    return ((("/" + $m_Lorg_jpablo_graphexplorer_router_Router$().a8t) + "/") + x42);
  }
  if ((route instanceof $c_Lorg_jpablo_graphexplorer_router_Route$LooseDocument)) {
    var x39 = route.FN;
    return ((("/" + $m_Lorg_jpablo_graphexplorer_router_Router$().a8s) + "/") + x39);
  }
  throw new $c_s_MatchError(route);
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_router_Router() {
  this.avn = null;
  this.avo = false;
  this.zd = null;
  this.Sn = null;
  this.BJ = null;
  this.zd = $m_Lcom_raquo_laminar_api_package$().b.ff.bx($p_Lorg_jpablo_graphexplorer_router_Router__parsePath__T__Lorg_jpablo_graphexplorer_router_Route(this, $p_Lorg_jpablo_graphexplorer_router_Router__currentPathname__T(this)));
  this.Sn = $f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable(this.zd.P());
  $f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription(this.Sn, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((route) => {
    var path = $p_Lorg_jpablo_graphexplorer_router_Router__buildPath__Lorg_jpablo_graphexplorer_router_Route__T(this, route);
    $m_Lorg_jpablo_graphexplorer_viewer_telemetry_Telemetry$().r7("router.routeChanged", $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("path", path), new $c_T2("route", route.m())])));
    try {
      var gtag$1 = gtag;
      if (((typeof gtag$1) === "function")) {
        gtag$1("event", "page_view", $m_sjs_js_special_package$().eA($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("page_path", path)]))));
      }
    } catch (e) {
    }
  })), this.a3H());
  this.BJ = $m_s_None$();
  if ((((typeof window) !== "undefined") && ((typeof window.addEventListener) === "function"))) {
    var this$11 = $m_Lcom_raquo_laminar_api_package$().b;
    var x0 = this$11.EE;
    $m_Lcom_raquo_laminar_api_package$();
    var p = $m_Lcom_raquo_laminar_keys_EventProcessor$().az(x0.aQJ(), false, false);
    $f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription(new $c_Lcom_raquo_airstream_misc_CollectStream($m_Lcom_raquo_airstream_web_DomEventStream$().IC(window, p.j1.m8, p.m7), p.m6), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3) => {
      var next = $p_Lorg_jpablo_graphexplorer_router_Router__parsePath__T__Lorg_jpablo_graphexplorer_router_Route(this, $p_Lorg_jpablo_graphexplorer_router_Router__currentPathname__T(this));
      var this$17 = this.BJ;
      if ((this$17.c() || (!(!this$17.d().i(next))))) {
        $f_Lcom_raquo_airstream_state_Var__set__O__V(this.zd, next);
      } else if (((typeof window.history) !== "undefined")) {
        window.history.pushState(null, "", $p_Lorg_jpablo_graphexplorer_router_Router__buildPath__Lorg_jpablo_graphexplorer_router_Route__T(this, this.zd.P().aq().d()));
      }
    })), this.a3H());
  }
}
$p = $c_Lorg_jpablo_graphexplorer_router_Router.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_router_Router;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_router_Router() {
}
$h_Lorg_jpablo_graphexplorer_router_Router.prototype = $p;
$p.a3H = (function() {
  if ((!this.avo)) {
    this.avn = $m_Lcom_raquo_laminar_api_package$().b.a55();
    this.avo = true;
  }
  return this.avn;
});
$p.b2k = (function(guard) {
  this.BJ = new $c_s_Some(guard);
});
$p.aYm = (function(guard) {
  var this$1 = this.BJ;
  if (((!this$1.c()) && (this$1.d() === guard))) {
    this.BJ = $m_s_None$();
  }
});
$p.rh = (function(route) {
  var this$1 = this.BJ;
  if ((this$1.c() || (!(!this$1.d().i(route))))) {
    this.aOg(route);
    return true;
  } else {
    return false;
  }
});
$p.aOg = (function(route) {
  var path = $p_Lorg_jpablo_graphexplorer_router_Router__buildPath__Lorg_jpablo_graphexplorer_router_Route__T(this, route);
  $m_Lorg_jpablo_graphexplorer_viewer_telemetry_Telemetry$().b4l(path);
  if (((((typeof window) !== "undefined") && ((typeof window.history) !== "undefined")) && ((typeof window.history.pushState) === "function"))) {
    window.history.pushState(null, "", path);
  }
  $f_Lcom_raquo_airstream_state_Var__set__O__V(this.zd, route);
});
var $d_Lorg_jpablo_graphexplorer_router_Router = new $TypeData().i($c_Lorg_jpablo_graphexplorer_router_Router, "org.jpablo.graphexplorer.router.Router", ({
  wW: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_router_Router$() {
  this.a8r = null;
  this.a8u = null;
  this.So = null;
  this.a8t = null;
  this.a8s = null;
  $n_Lorg_jpablo_graphexplorer_router_Router$ = this;
  this.a8r = "app";
  this.a8u = ("/" + this.a8r);
  this.So = "diagrams";
  this.a8t = "example";
  this.a8s = "documents";
}
$p = $c_Lorg_jpablo_graphexplorer_router_Router$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_router_Router$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_router_Router$() {
}
$h_Lorg_jpablo_graphexplorer_router_Router$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_router_Router$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_router_Router$, "org.jpablo.graphexplorer.router.Router$", ({
  wX: 1
}));
var $n_Lorg_jpablo_graphexplorer_router_Router$;
function $m_Lorg_jpablo_graphexplorer_router_Router$() {
  if ((!$n_Lorg_jpablo_graphexplorer_router_Router$)) {
    $n_Lorg_jpablo_graphexplorer_router_Router$ = new $c_Lorg_jpablo_graphexplorer_router_Router$();
  }
  return $n_Lorg_jpablo_graphexplorer_router_Router$;
}
function $s_Lorg_jpablo_graphexplorer_viewer_Viewer__main__AT__V(args) {
  $m_Lorg_jpablo_graphexplorer_viewer_Viewer$().b4d(args);
}
function $p_Lorg_jpablo_graphexplorer_viewer_Viewer$__exampleBanner__T__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_viewer_components_RouterCommands__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($thiz, name, state, routerCmds) {
  return $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("example-banner"), $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("example-banner-title"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Example: ", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7), $m_Lcom_raquo_laminar_api_package$().b.aXT().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, name, $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))]))), $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("example-banner-note"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Not saved to your library", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$().iZ($m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$().AB($m_Lorg_jpablo_graphexplorer_viewer_widgets_Button$package$().hH($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Copy to my library", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7), new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$10) => {
    routerCmds.axq.gZ(new $c_s_Some(new $c_T2(name, state.mz.P().aq().d())), true);
  })))])))))])));
}
function $p_Lorg_jpablo_graphexplorer_viewer_Viewer$__unknownDocumentSession__Lorg_jpablo_graphexplorer_viewer_components_RouterCommands__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($thiz, routerCmds) {
  return $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("loose-document-placeholder"), $m_Lcom_raquo_laminar_api_package$().b.E3().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "No such document session", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $m_Lcom_raquo_laminar_api_package$().b.Ax().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "This page shows a file the desktop opened. That session is not open now.", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$().ai5($m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$().AB($m_Lorg_jpablo_graphexplorer_viewer_widgets_Button$package$().hH($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Back to the library", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7), new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$11) => {
    routerCmds.LF.gZ($m_s_None$(), true);
  })))])))))])));
}
function $p_Lorg_jpablo_graphexplorer_viewer_Viewer$__unknownExample__T__Lorg_jpablo_graphexplorer_viewer_components_RouterCommands__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($thiz, slug, routerCmds) {
  return $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("unknown-example"), $m_Lcom_raquo_laminar_api_package$().b.E3().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "No such example", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $m_Lcom_raquo_laminar_api_package$().b.Ax().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "There is no example named ", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7), $m_Lcom_raquo_laminar_api_package$().b.aYr().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, slug, $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, " any more.", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$().ai5($m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$().AB($m_Lorg_jpablo_graphexplorer_viewer_widgets_Button$package$().hH($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Back to the library", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7), new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$12) => {
    routerCmds.LF.gZ($m_s_None$(), true);
  })))])))))])));
}
function $p_Lorg_jpablo_graphexplorer_viewer_Viewer$__setupErrorHandling__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_eventbus_EventBus($thiz, x$1) {
  $m_Lcom_raquo_laminar_api_package$();
  var errors = new $c_Lcom_raquo_airstream_eventbus_EventBus();
  $m_Lcom_raquo_laminar_api_package$().b.aoM.aRr(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((ex) => {
    var event = ex.e3();
    errors.dn.bA(event);
  })));
  var this$2 = $m_Lcom_raquo_laminar_api_package$().b;
  var x0 = this$2.EE;
  $m_Lcom_raquo_laminar_api_package$();
  var p = $m_Lcom_raquo_laminar_keys_EventProcessor$().az(x0.ahe(), false, false);
  $f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription(new $c_Lcom_raquo_airstream_misc_CollectStream($m_Lcom_raquo_airstream_web_DomEventStream$().IC(window, p.j1.m8, p.m7), p.m6), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e) => {
    var event$1 = e.message;
    errors.dn.bA(event$1);
  })), x$1);
  $f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription(errors.k5, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$2) => {
    console.error("Error:", e$2);
  })), x$1);
  document.addEventListener("focusin", ((e$3) => {
    console.debug("focusin:", e$3.target);
  }));
  document.addEventListener("focusout", ((e$4) => {
    console.debug("focusout:", e$4.target);
  }));
  return errors;
}
function $p_Lorg_jpablo_graphexplorer_viewer_Viewer$__printBanner__V($thiz) {
  var banner = $m_sc_StringOps$().aSv((((((((("\n        |Welcome to Graph Explorer!\n        |------------------------------\n        |version:      " + $m_Lbuildinfo_BuildInfo$().Qg) + "\n        |scalaVersion: ") + $m_Lbuildinfo_BuildInfo$().Qf) + "\n        |sbtVersion:   ") + $m_Lbuildinfo_BuildInfo$().Yj) + "\n        |builtAt:      ") + new Date($m_Lbuildinfo_BuildInfo$().Qe).toUTCString()) + "\n        |"), 124);
  console.info(banner);
}
function $p_Lorg_jpablo_graphexplorer_viewer_Viewer$__given_Owner$lzyINIT1$1__sr_LazyRef__Lcom_raquo_airstream_ownership_Owner($thiz, given_Owner$lzy1$1) {
  return (given_Owner$lzy1$1.ci ? given_Owner$lzy1$1.cj : given_Owner$lzy1$1.h3($m_Lcom_raquo_laminar_api_package$().b.a55()));
}
function $p_Lorg_jpablo_graphexplorer_viewer_Viewer$__given_Owner$1__sr_LazyRef__Lcom_raquo_airstream_ownership_Owner($thiz, given_Owner$lzy1$2) {
  return (given_Owner$lzy1$2.ci ? given_Owner$lzy1$2.cj : $p_Lorg_jpablo_graphexplorer_viewer_Viewer$__given_Owner$lzyINIT1$1__sr_LazyRef__Lcom_raquo_airstream_ownership_Owner($thiz, given_Owner$lzy1$2));
}
function $p_Lorg_jpablo_graphexplorer_viewer_Viewer$__setTheme$1__T__V($thiz, theme) {
  document.documentElement.setAttribute("data-theme", theme);
}
function $p_Lorg_jpablo_graphexplorer_viewer_Viewer$__clipboardWrite$1__Lcom_raquo_airstream_eventbus_EventBus__T__V($thiz, errors$1, text) {
  try {
    window.navigator.clipboard.writeText(text).then(((_$1) => (void 0)), $m_sjs_js_Any$().Pn(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((err) => {
      var event = (("Could not copy to clipboard: " + "") + err);
      errors$1.dn.bA(event);
    }))));
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    var event$1 = ("Clipboard unavailable: " + e$2.e3());
    errors$1.dn.bA(event$1);
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_Viewer$__clipboardRead$1__s_concurrent_Future($thiz) {
  try {
    return $m_sjs_js_Thenable$ThenableOps$().a50(window.navigator.clipboard.readText());
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    return $m_s_concurrent_Future$().WL(e$2);
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_Viewer$__diagramView$1__Lorg_jpablo_graphexplorer_viewer_backends_graphviz_Graphviz__Lcom_raquo_airstream_eventbus_EventBus__Lcom_raquo_airstream_eventbus_EventBus__sr_ObjectRef__sr_BooleanRef__Lorg_jpablo_graphexplorer_viewer_models_ClientSize__Lorg_jpablo_graphexplorer_viewer_logging_Level__Lorg_jpablo_graphexplorer_router_Router__Lorg_jpablo_graphexplorer_viewer_components_RouterCommands__sr_LazyRef__Lorg_jpablo_graphexplorer_viewer_state_ViewTarget__s_Option__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($thiz, graphviz$1, errors$4, infos$2, lastRightPanelSection$2, lastLeftPanelVisible$2, clientSize$2, logLevel$2, router$4, routerCmds$2, given_Owner$lzy1$4, target, source) {
  var exampleName = ((target instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$Example) ? new $c_s_Some(target.MV) : $m_s_None$());
  var viewOwner = new $c_Lcom_raquo_airstream_ownership_ManualOwner();
  var state = new $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerState(target, graphviz$1, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((text) => {
    $p_Lorg_jpablo_graphexplorer_viewer_Viewer$__clipboardWrite$1__Lcom_raquo_airstream_eventbus_EventBus__T__V($thiz, errors$4, text);
  })), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $p_Lorg_jpablo_graphexplorer_viewer_Viewer$__clipboardRead$1__s_concurrent_Future($thiz))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((theme) => {
    $p_Lorg_jpablo_graphexplorer_viewer_Viewer$__setTheme$1__T__V($thiz, theme);
  })), errors$4, infos$2, source, lastRightPanelSection$2.aD, lastLeftPanelVisible$2.dy, clientSize$2, logLevel$2, viewOwner);
  $f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription($f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable(new $c_Lcom_raquo_airstream_misc_StreamFromSignal(state.qs.P(), true)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$5) => {
    lastRightPanelSection$2.aD = _$5;
  })), viewOwner);
  $f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription($f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable(new $c_Lcom_raquo_airstream_misc_StreamFromSignal(state.H7.P(), true)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => {
    var _$6 = (!(!v1));
    lastLeftPanelVisible$2.dy = _$6;
  })), viewOwner);
  var leaveGuard = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((route) => ((!$f_Lorg_jpablo_graphexplorer_viewer_state_Persistence__documentIsDirty__Z(state)) || ($f_Lcom_raquo_airstream_state_Var__set__O__V(state.xs, new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent$Navigate(route))), false))));
  router$4.b2k(leaveGuard);
  $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopClose$().b2X(state, $p_Lorg_jpablo_graphexplorer_viewer_Viewer$__given_Owner$1__sr_LazyRef__Lcom_raquo_airstream_ownership_Owner($thiz, given_Owner$lzy1$4), $m_s_concurrent_ExecutionContext$().ek());
  var warnOnClose = ((event) => {
    if ($f_Lorg_jpablo_graphexplorer_viewer_state_Persistence__documentIsDirty__Z(state)) {
      event.preventDefault();
      event.returnValue = "";
    }
  });
  window.addEventListener("beforeunload", warnOnClose);
  $m_Lorg_jpablo_graphexplorer_viewer_desktop_SessionCommands$().aXO(state);
  $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$().aXN(state, $m_s_concurrent_ExecutionContext$().ek());
  return $f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement($m_Lorg_jpablo_graphexplorer_viewer_components_TopLevel$package$().aWq(state, router$4, new $c_Lorg_jpablo_graphexplorer_viewer_components_Commands(state, routerCmds$2), (exampleName.c() ? $m_s_None$() : new $c_s_Some($p_Lorg_jpablo_graphexplorer_viewer_Viewer$__exampleBanner__T__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_viewer_components_RouterCommands__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($m_Lorg_jpablo_graphexplorer_viewer_Viewer$(), exampleName.d(), state, routerCmds$2)))), $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_MountHooks__onUnmountCallback__F1__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$8) => {
    $m_Lorg_jpablo_graphexplorer_viewer_desktop_SessionCommands$().afi(state);
    $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$().afi(state);
    router$4.aYm(leaveGuard);
    $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopClose$().aZR(state, $m_s_concurrent_ExecutionContext$().ek());
    window.removeEventListener("beforeunload", warnOnClose);
    state.zH.aeZ();
    $f_Lcom_raquo_airstream_ownership_Owner__killSubscriptions__V(viewOwner);
  })))])));
}
function $p_Lorg_jpablo_graphexplorer_viewer_Viewer$__looseDocumentView$1__Lorg_jpablo_graphexplorer_viewer_components_RouterCommands__Lorg_jpablo_graphexplorer_viewer_backends_graphviz_Graphviz__Lcom_raquo_airstream_eventbus_EventBus__Lcom_raquo_airstream_eventbus_EventBus__sr_ObjectRef__sr_BooleanRef__Lorg_jpablo_graphexplorer_viewer_models_ClientSize__Lorg_jpablo_graphexplorer_viewer_logging_Level__Lorg_jpablo_graphexplorer_router_Router__sr_LazyRef__T__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($thiz, routerCmds$5, graphviz$2, errors$6, infos$4, lastRightPanelSection$5, lastLeftPanelVisible$5, clientSize$4, logLevel$4, router$7, given_Owner$lzy1$6, sessionId) {
  var this$1 = $m_Lorg_jpablo_graphexplorer_viewer_state_DocumentSessionId$().mU(sessionId);
  if (this$1.c()) {
    var $x_1 = true;
  } else {
    var x0 = this$1.d();
    var $x_1 = (!$m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$().IY(x0).c());
  }
  if ($x_1) {
    var x13 = this$1;
  } else {
    var x13 = $m_s_None$();
  }
  if ((x13 instanceof $c_s_Some)) {
    return $p_Lorg_jpablo_graphexplorer_viewer_Viewer$__diagramView$1__Lorg_jpablo_graphexplorer_viewer_backends_graphviz_Graphviz__Lcom_raquo_airstream_eventbus_EventBus__Lcom_raquo_airstream_eventbus_EventBus__sr_ObjectRef__sr_BooleanRef__Lorg_jpablo_graphexplorer_viewer_models_ClientSize__Lorg_jpablo_graphexplorer_viewer_logging_Level__Lorg_jpablo_graphexplorer_router_Router__Lorg_jpablo_graphexplorer_viewer_components_RouterCommands__sr_LazyRef__Lorg_jpablo_graphexplorer_viewer_state_ViewTarget__s_Option__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($thiz, graphviz$2, errors$6, infos$4, lastRightPanelSection$5, lastLeftPanelVisible$5, clientSize$4, logLevel$4, router$7, routerCmds$5, given_Owner$lzy1$6, new $c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$LooseFile(x13.J), $m_s_None$());
  }
  if (($m_s_None$() === x13)) {
    return $p_Lorg_jpablo_graphexplorer_viewer_Viewer$__unknownDocumentSession__Lorg_jpablo_graphexplorer_viewer_components_RouterCommands__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($thiz, routerCmds$5);
  }
  throw new $c_s_MatchError(x13);
}
function $p_Lorg_jpablo_graphexplorer_viewer_Viewer$__startApp$1__Lorg_jpablo_graphexplorer_router_Router__Lcom_raquo_airstream_eventbus_EventBus__Lcom_raquo_airstream_eventbus_EventBus__sr_ObjectRef__sr_BooleanRef__Lorg_jpablo_graphexplorer_viewer_models_ClientSize__Lorg_jpablo_graphexplorer_viewer_logging_Level__Lorg_jpablo_graphexplorer_viewer_components_RouterCommands__Lcom_raquo_airstream_state_Var__sr_LazyRef__V($thiz, router$1, errors$3, infos$1, lastRightPanelSection$1, lastLeftPanelVisible$1, clientSize$1, logLevel$1, routerCmds$1, viewerSettings$1, given_Owner$lzy1$3) {
  var sharedDot = $m_Lorg_jpablo_graphexplorer_viewer_utils_ShareUrl$().aRm();
  var f = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((dot) => {
    matchResult3: {
      var this$1 = $m_Lorg_jpablo_graphexplorer_viewer_utils_ShareUrl$().b7d();
      var p = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((id) => $m_Lorg_jpablo_graphexplorer_projects_Library$().XN(id)));
      var x5 = ((this$1.c() || (!(!p.i(this$1.d())))) ? this$1 : $m_s_None$());
      if ((x5 instanceof $c_s_Some)) {
        router$1.rh(new $c_Lorg_jpablo_graphexplorer_router_Route$ProjectDetail(x5.J.cv, $m_s_None$()));
        break matchResult3;
      }
      if (($m_s_None$() === x5)) {
        var x2 = $m_Lorg_jpablo_graphexplorer_projects_Library$().a3n(dot);
        if ((x2 instanceof $c_s_Some)) {
          router$1.rh(new $c_Lorg_jpablo_graphexplorer_router_Route$ProjectDetail(x2.J.cv, $m_s_None$()));
          break matchResult3;
        }
        if (($m_s_None$() === x2)) {
          router$1.rh(new $c_Lorg_jpablo_graphexplorer_router_Route$ProjectDetail($m_Lorg_jpablo_graphexplorer_projects_Library$().IM($m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$().GY).cv, new $c_s_Some(dot)));
          break matchResult3;
        }
        throw new $c_s_MatchError(x2);
      }
      throw new $c_s_MatchError(x5);
    }
  }));
  if ((!sharedDot.c())) {
    f.i(sharedDot.d());
  }
  $m_Lorg_jpablo_graphexplorer_viewer_desktop_SessionCommands$().a3O();
  $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopBridge$().a3O();
  $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$().b2Y(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((route$3) => router$1.rh(route$3))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((id$1) => $m_Lorg_jpablo_graphexplorer_projects_Library$().XN(new $c_Lorg_jpablo_graphexplorer_viewer_state_ProjectId(id$1)))), $m_s_concurrent_ExecutionContext$().ek());
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_Graphviz$().aY4().oB(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((graphviz) => {
    console.log("Graphviz initialized (Scala port for dot, viz-js for other engines):", graphviz);
    $p_Lorg_jpablo_graphexplorer_viewer_Viewer$__printBanner__V($thiz);
    var app = $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_inserters_ChildInserter$().nv($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), router$1.Sn, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((graphviz$2) => ((x$1) => {
      var x$2 = $s_Lorg_jpablo_graphexplorer_router_Route$__Home__Lorg_jpablo_graphexplorer_router_Route();
      if (((x$2 === null) ? (x$1 === null) : x$2.e(x$1))) {
        return $m_Lorg_jpablo_graphexplorer_projects_ProjectsDirectoryView$package$().aWb(graphviz$2, router$1, routerCmds$1, viewerSettings$1, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((theme) => {
          $p_Lorg_jpablo_graphexplorer_viewer_Viewer$__setTheme$1__T__V($thiz, theme);
        })));
      }
      if ((x$1 instanceof $c_Lorg_jpablo_graphexplorer_router_Route$ProjectDetail)) {
        var x30 = x$1.FO;
        var x31 = x$1.Sm;
        return $p_Lorg_jpablo_graphexplorer_viewer_Viewer$__diagramView$1__Lorg_jpablo_graphexplorer_viewer_backends_graphviz_Graphviz__Lcom_raquo_airstream_eventbus_EventBus__Lcom_raquo_airstream_eventbus_EventBus__sr_ObjectRef__sr_BooleanRef__Lorg_jpablo_graphexplorer_viewer_models_ClientSize__Lorg_jpablo_graphexplorer_viewer_logging_Level__Lorg_jpablo_graphexplorer_router_Router__Lorg_jpablo_graphexplorer_viewer_components_RouterCommands__sr_LazyRef__Lorg_jpablo_graphexplorer_viewer_state_ViewTarget__s_Option__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($thiz, graphviz$2, errors$3, infos$1, lastRightPanelSection$1, lastLeftPanelVisible$1, clientSize$1, logLevel$1, router$1, routerCmds$1, given_Owner$lzy1$3, $m_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$().b44(x30), x31);
      }
      if ((x$1 instanceof $c_Lorg_jpablo_graphexplorer_router_Route$Example)) {
        var x27 = x$1.Ln;
        var x16 = $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$().aY9().r(x27);
        if ((x16 instanceof $c_s_Some)) {
          var x18 = x16.J;
          if ((x18 !== null)) {
            var name = x18.g();
            var example = x18.h();
            return $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("contents"), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_inserters_ChildInserter$().nv(new $c_Lcom_raquo_airstream_misc_MapStream($m_Lcom_raquo_laminar_api_package$().b.aLt().aOL(example.q4, $m_sr_ScalaRunTime$().f(new ($d_F1.r().C)([]))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((text) => $p_Lorg_jpablo_graphexplorer_viewer_Viewer$__diagramView$1__Lorg_jpablo_graphexplorer_viewer_backends_graphviz_Graphviz__Lcom_raquo_airstream_eventbus_EventBus__Lcom_raquo_airstream_eventbus_EventBus__sr_ObjectRef__sr_BooleanRef__Lorg_jpablo_graphexplorer_viewer_models_ClientSize__Lorg_jpablo_graphexplorer_viewer_logging_Level__Lorg_jpablo_graphexplorer_router_Router__Lorg_jpablo_graphexplorer_viewer_components_RouterCommands__sr_LazyRef__Lorg_jpablo_graphexplorer_viewer_state_ViewTarget__s_Option__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($thiz, graphviz$2, errors$3, infos$1, lastRightPanelSection$1, lastLeftPanelVisible$1, clientSize$1, logLevel$1, router$1, routerCmds$1, given_Owner$lzy1$3, new $c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$Example(x27, name), new $c_s_Some(text)))), $m_s_None$()), $m_Lcom_raquo_laminar_modifiers_RenderableNode$().ht, (void 0)))])));
          }
        }
        if (($m_s_None$() === x16)) {
          return $p_Lorg_jpablo_graphexplorer_viewer_Viewer$__unknownExample__T__Lorg_jpablo_graphexplorer_viewer_components_RouterCommands__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($thiz, x27, routerCmds$1);
        }
        throw new $c_s_MatchError(x16);
      }
      if ((x$1 instanceof $c_Lorg_jpablo_graphexplorer_router_Route$LooseDocument)) {
        return $p_Lorg_jpablo_graphexplorer_viewer_Viewer$__looseDocumentView$1__Lorg_jpablo_graphexplorer_viewer_components_RouterCommands__Lorg_jpablo_graphexplorer_viewer_backends_graphviz_Graphviz__Lcom_raquo_airstream_eventbus_EventBus__Lcom_raquo_airstream_eventbus_EventBus__sr_ObjectRef__sr_BooleanRef__Lorg_jpablo_graphexplorer_viewer_models_ClientSize__Lorg_jpablo_graphexplorer_viewer_logging_Level__Lorg_jpablo_graphexplorer_router_Router__sr_LazyRef__T__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($thiz, routerCmds$1, graphviz$2, errors$3, infos$1, lastRightPanelSection$1, lastLeftPanelVisible$1, clientSize$1, logLevel$1, router$1, given_Owner$lzy1$3, x$1.FN);
      }
      throw new $c_s_MatchError(x$1);
    }))(graphviz)), $m_s_None$()), $m_Lcom_raquo_laminar_modifiers_RenderableNode$().ht, (void 0)))])));
    $m_Lcom_raquo_laminar_api_package$();
    return new $c_Lcom_raquo_laminar_nodes_RootNode(document.querySelector("#app"), app);
  })), $m_s_concurrent_ExecutionContext$().ek());
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_Viewer$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_Viewer$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_Viewer$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_Viewer$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_Viewer$.prototype = $p;
$p.b4d = (function(args) {
  var given_Owner$lzy1 = new $c_sr_LazyRef();
  var errors = $p_Lorg_jpablo_graphexplorer_viewer_Viewer$__setupErrorHandling__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_eventbus_EventBus(this, $p_Lorg_jpablo_graphexplorer_viewer_Viewer$__given_Owner$1__sr_LazyRef__Lcom_raquo_airstream_ownership_Owner(this, given_Owner$lzy1));
  $m_Lcom_raquo_laminar_api_package$();
  var infos = new $c_Lcom_raquo_airstream_eventbus_EventBus();
  var router = new $c_Lorg_jpablo_graphexplorer_router_Router();
  var routerCmds = new $c_Lorg_jpablo_graphexplorer_viewer_components_RouterCommands(router);
  var lastRightPanelSection = new $c_sr_ObjectRef($s_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$__none__Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection());
  var lastLeftPanelVisible = new $c_sr_BooleanRef(false);
  var viewerSettings = $m_Lorg_jpablo_graphexplorer_projects_ProjectStorage$().aPY();
  $p_Lorg_jpablo_graphexplorer_viewer_Viewer$__setTheme$1__T__V(this, $m_Lorg_jpablo_graphexplorer_viewer_components_ThemeSelect$package$().a4w(viewerSettings.P().aq().d().lH));
  var mediaQueryList = window.matchMedia("(max-width: 768px)");
  var clientSize = ((!(!mediaQueryList.matches)) ? $s_Lorg_jpablo_graphexplorer_viewer_models_ClientSize$__Small__Lorg_jpablo_graphexplorer_viewer_models_ClientSize() : $s_Lorg_jpablo_graphexplorer_viewer_models_ClientSize$__Normal__Lorg_jpablo_graphexplorer_viewer_models_ClientSize());
  var queryParams = new URLSearchParams(window.location.search);
  var this$6 = $m_s_Option$().as(queryParams.get("logLevel"));
  if (this$6.c()) {
    var this$7 = $m_s_None$();
  } else {
    var x0 = this$6.d();
    var this$7 = new $c_s_Some($m_Lorg_jpablo_graphexplorer_viewer_logging_Level$().b1T(x0));
  }
  var logLevel = (this$7.c() ? $s_Lorg_jpablo_graphexplorer_viewer_logging_Level$__None__Lorg_jpablo_graphexplorer_viewer_logging_Level() : this$7.d());
  ((!(!$p_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$__invoker__s_Option($m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$()).c())) ? $m_s_concurrent_Future$().m4((void 0)) : $m_Lorg_jpablo_graphexplorer_projects_DesktopLibrary$().agW().IX(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((onDisk) => $m_Lorg_jpablo_graphexplorer_projects_DesktopMigration$().b84($m_sci_Set$().af(onDisk.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => _$2.jE.kD))))).IX(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => $m_Lorg_jpablo_graphexplorer_projects_DesktopLibrary$().agW().jX(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((records) => {
    $m_Lorg_jpablo_graphexplorer_projects_Library$().na = new $c_Lorg_jpablo_graphexplorer_projects_DesktopLibrary(records);
    var flush = ((_$3) => {
      $m_Lorg_jpablo_graphexplorer_projects_Library$().WT();
    });
    window.addEventListener("pagehide", flush);
    window.addEventListener("blur", flush);
  })), $m_s_concurrent_ExecutionContext$().ek()))), $m_s_concurrent_ExecutionContext$().ek()))), $m_s_concurrent_ExecutionContext$().ek())).oB(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((given_Owner$lzy1$2) => ((_$4) => {
    $p_Lorg_jpablo_graphexplorer_viewer_Viewer$__startApp$1__Lorg_jpablo_graphexplorer_router_Router__Lcom_raquo_airstream_eventbus_EventBus__Lcom_raquo_airstream_eventbus_EventBus__sr_ObjectRef__sr_BooleanRef__Lorg_jpablo_graphexplorer_viewer_models_ClientSize__Lorg_jpablo_graphexplorer_viewer_logging_Level__Lorg_jpablo_graphexplorer_viewer_components_RouterCommands__Lcom_raquo_airstream_state_Var__sr_LazyRef__V(this, router, errors, infos, lastRightPanelSection, lastLeftPanelVisible, clientSize, logLevel, routerCmds, viewerSettings, given_Owner$lzy1$2);
  }))(given_Owner$lzy1)), $m_s_concurrent_ExecutionContext$().ek());
});
var $d_Lorg_jpablo_graphexplorer_viewer_Viewer$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_Viewer$, "org.jpablo.graphexplorer.viewer.Viewer$", ({
  wY: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_Viewer$;
function $m_Lorg_jpablo_graphexplorer_viewer_Viewer$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_Viewer$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_Viewer$ = new $c_Lorg_jpablo_graphexplorer_viewer_Viewer$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_Viewer$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$.prototype = $p;
$p.b8g = (function(text, format) {
  var x = $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__DOT__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat();
  if (((x === null) ? (format === null) : (x === format))) {
    return $m_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$DotLoss$().ahT(text);
  }
  var x$3 = $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__Mermaid__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat();
  if (((x$3 === null) ? (format === null) : (x$3 === format))) {
    return $m_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$MermaidLoss$().ahT(text);
  }
  throw new $c_s_MatchError(format);
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$, "org.jpablo.graphexplorer.viewer.backends.RoundTripLoss$", ({
  x6: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$;
function $m_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$ = new $c_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$DotLoss$__isIdChar__C__Z($thiz, c) {
  return (((c === 95) || $m_jl_UnicodeData$().E5(c)) || (c >= 128));
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$DotLoss$__identifierEnd__T__I__I($thiz, text, from) {
  var i = from;
  while (((i < text.length) && $p_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$DotLoss$__isIdChar__C__Z($thiz, text.charCodeAt(i)))) {
    i = ((1 + i) | 0);
  }
  return i;
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$DotLoss$__quotedEnd__T__I__I($thiz, text, from) {
  var i = from;
  var closed = false;
  while (((i < text.length) && (!closed))) {
    var index = i;
    var x3 = text.charCodeAt(index);
    if ((x3 === 92)) {
      i = ((2 + i) | 0);
      continue;
    }
    if ((x3 === 34)) {
      i = ((1 + i) | 0);
      closed = true;
      continue;
    }
    i = ((1 + i) | 0);
  }
  var x = i;
  var that = text.length;
  return ((x < that) ? x : that);
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$DotLoss$__htmlEnd__T__I__I($thiz, text, from) {
  var i = from;
  var depth = 0;
  var done = false;
  while (((i < text.length) && (!done))) {
    matchResult4: {
      var index = i;
      var x4 = text.charCodeAt(index);
      if ((x4 === 60)) {
        depth = ((1 + depth) | 0);
        break matchResult4;
      }
      if ((x4 === 62)) {
        depth = ((depth - 1) | 0);
        done = (depth === 0);
        break matchResult4;
      }
    }
    i = ((1 + i) | 0);
  }
  return i;
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$DotLoss$__at$1__I__T__I__C($thiz, n$1, text$1, k) {
  return ((k < n$1) ? text$1.charCodeAt(k) : 0);
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$DotLoss$__lineEnd$1__T__I__I__I($thiz, text$2, n$2, from) {
  var end = $f_T__indexOf__I__I__I(text$2, 10, from);
  return ((end < 0) ? n$2 : end);
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$DotLoss$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$DotLoss$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$DotLoss$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$DotLoss$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$DotLoss$.prototype = $p;
$p.ahT = (function(text) {
  var n = text.length;
  var comments = false;
  var firstToken = $m_s_None$();
  var i = 0;
  while ((i < n)) {
    var index = i;
    var c = text.charCodeAt(index);
    if ($m_jl_UnicodeData$().E7(c)) {
      i = ((1 + i) | 0);
    } else if (((c === 35) || ((c === 47) && ($p_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$DotLoss$__at$1__I__T__I__C(this, n, text, ((1 + i) | 0)) === 47)))) {
      comments = true;
      i = $p_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$DotLoss$__lineEnd$1__T__I__I__I(this, text, n, i);
    } else if (((c === 47) && ($p_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$DotLoss$__at$1__I__T__I__C(this, n, text, ((1 + i) | 0)) === 42))) {
      comments = true;
      var fromIndex = ((2 + i) | 0);
      var end = (text.indexOf("*/", fromIndex) | 0);
      i = ((end < 0) ? n : ((2 + end) | 0));
    } else {
      var end$2 = ((c === 34) ? $p_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$DotLoss$__quotedEnd__T__I__I(this, text, ((1 + i) | 0)) : ((c === 60) ? $p_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$DotLoss$__htmlEnd__T__I__I(this, text, i) : ($p_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$DotLoss$__isIdChar__C__Z(this, c) ? $p_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$DotLoss$__identifierEnd__T__I__I(this, text, i) : ((1 + i) | 0))));
      if (firstToken.c()) {
        var beginIndex = i;
        firstToken = new $c_s_Some(text.substring(beginIndex, end$2));
      }
      i = end$2;
    }
  }
  var this$7 = firstToken;
  if ((!this$7.c())) {
    var x0 = this$7.d();
    _return: {
      var len = x0.length;
      if ((len === 6)) {
        var i$1 = 0;
        while ((i$1 !== len)) {
          var thisCP = $f_T__codePointAt__I__I(x0, i$1);
          if (($m_jl_Character$().iy($m_jl_Character$().j0(thisCP)) !== $m_jl_Character$().iy($m_jl_Character$().j0($f_T__codePointAt__I__I("strict", i$1))))) {
            var strict = false;
            break _return;
          }
          i$1 = ((i$1 + ((thisCP >= 65536) ? 2 : 1)) | 0);
        }
        var strict = true;
      } else {
        var strict = false;
      }
    }
  } else {
    var strict = false;
  }
  return $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_s_Option.r().C)([(comments ? new $c_s_Some($s_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$__Comments__Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent()) : $m_s_None$()), (strict ? new $c_s_Some($s_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$__StrictKeyword__Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent()) : $m_s_None$())]))).dk($m_s_$less$colon$less$().b1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$DotLoss$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$DotLoss$, "org.jpablo.graphexplorer.viewer.backends.RoundTripLoss$DotLoss$", ({
  x7: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$DotLoss$;
function $m_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$DotLoss$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$DotLoss$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$DotLoss$ = new $c_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$DotLoss$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$DotLoss$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$MermaidLoss$() {
  this.avv = null;
  this.avu = null;
  this.avt = null;
  this.avy = null;
  this.avx = null;
  this.avw = null;
  $n_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$MermaidLoss$ = this;
  this.avv = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "(?i)click\\s+[A-Za-z0-9_].*", $m_sci_Nil$());
  this.avu = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "(?i)acc(?:Title|Descr)\\s*[:{].*", $m_sci_Nil$());
  this.avt = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "(?i)accDescr\\s*\\{.*", $m_sci_Nil$());
  this.avy = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "(?i)subgraph(?:\\s.*)?", $m_sci_Nil$());
  this.avx = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "end(?:[\\s;].*)?", $m_sci_Nil$());
  this.avw = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "(?i)direction\\s+(?:TB|TD|BT|LR|RL)\\s*;?", $m_sci_Nil$());
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$MermaidLoss$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$MermaidLoss$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$MermaidLoss$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$MermaidLoss$.prototype = $p;
$p.ahT = (function(text) {
  var found = new $c_sci_SetBuilderImpl();
  var this$6 = new $c_sc_Iterator$$anon$9(new $c_sc_StringOps$$anon$1(text, true), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => $f_T__trim__T(_$2))));
  var lines = $m_sci_Vector$().X(this$6);
  if ((!$f_sc_IndexedSeqOps__headOption__s_Option(lines).E("---"))) {
    var bodyStart = 0;
  } else {
    var this$7 = lines.o();
    _return: {
      var i = 1;
      var dropped = this$7.iV(1);
      while (dropped.p()) {
        if ((dropped.q() === "---")) {
          var closing = i;
          break _return;
        }
        i = ((1 + i) | 0);
      }
      var closing = (-1);
    }
    var bodyStart = ((closing < 0) ? 0 : (lines.pH(1, closing).d8(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4) => (_$4 !== ""))), false).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((line) => {
      if ((!(!line.startsWith("#")))) {
        found.DE($s_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$__Comments__Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent());
      } else if ((!(!(!line.startsWith("title:"))))) {
        found.DE($s_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$__Directives__Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent());
      }
    }))), ((1 + closing) | 0)));
  }
  var depth = new $c_sr_IntRef(0);
  var inDirective = new $c_sr_BooleanRef(false);
  var inAccessibility = new $c_sr_BooleanRef(false);
  lines.pH(bodyStart, lines.C()).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((line$2) => {
    if (inDirective.dy) {
      inDirective.dy = ((line$2.indexOf("}%%") | 0) === (-1));
      return (void 0);
    } else if (inAccessibility.dy) {
      inAccessibility.dy = ((line$2.indexOf("}") | 0) === (-1));
      return (void 0);
    } else if ((!(!line$2.startsWith("%%{")))) {
      found.DE($s_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$__Directives__Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent());
      var this$17 = $m_sc_StringOps$().kp(line$2, 3);
      inDirective.dy = (!((this$17.indexOf("}%%") | 0) !== (-1)));
      return (void 0);
    } else if ((!(!line$2.startsWith("%%")))) {
      return found.DE($s_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$__Comments__Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent());
    } else {
      var this$18 = $m_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$MermaidLoss$().b5E(line$2);
      var these = this$18;
      while ((!these.c())) {
        var x0$1 = these.t();
        matchResult5: {
          if ((x0$1 !== null)) {
            var x14 = $m_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$MermaidLoss$().avv.jw(x0$1);
            if ((!x14.c())) {
              if ((x14.d().bL(0) === 0)) {
                found.DE($s_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$__ClickHandlers__Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent());
                break matchResult5;
              }
            }
            var x12 = $m_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$MermaidLoss$().avu.jw(x0$1);
            if ((!x12.c())) {
              if ((x12.d().bL(0) === 0)) {
                found.DE($s_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$__AccessibilityText__Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent());
                break matchResult5;
              }
            }
            var x10 = $m_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$MermaidLoss$().avy.jw(x0$1);
            if ((!x10.c())) {
              if ((x10.d().bL(0) === 0)) {
                depth.an = ((1 + depth.an) | 0);
                break matchResult5;
              }
            }
            var x8 = $m_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$MermaidLoss$().avx.jw(x0$1);
            if ((!x8.c())) {
              if ((x8.d().bL(0) === 0)) {
                var that = ((depth.an - 1) | 0);
                depth.an = ((that < 0) ? 0 : that);
                break matchResult5;
              }
            }
            var x6 = $m_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$MermaidLoss$().avw.jw(x0$1);
            if ((!x6.c())) {
              if ((x6.d().bL(0) === 0)) {
                if ((depth.an > 0)) {
                  found.DE($s_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$__SubgraphDirection__Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent());
                  break matchResult5;
                } else {
                  break matchResult5;
                }
              }
            }
          }
        }
        these = these.v();
      }
      matchResult6: {
        var $x_1;
        if ((line$2 !== null)) {
          var x17 = $m_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$MermaidLoss$().avt.jw(line$2);
          if ((!x17.c())) {
            if ((x17.d().bL(0) === 0)) {
              var this$24 = $m_sc_StringOps$().kp(line$2, ((1 + $f_T__indexOf__I__I(line$2, 123)) | 0));
              var $x_1 = (!((this$24.indexOf("}") | 0) !== (-1)));
              break matchResult6;
            }
          }
        }
        var $x_1 = false;
      }
      inAccessibility.dy = $x_1;
      return (void 0);
    }
  })));
  return found.ahJ();
});
$p.b5E = (function(line) {
  var parts = new $c_scm_ListBuffer();
  var current = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  var elem = false;
  elem = false;
  var len = line.length;
  var i = 0;
  while ((i < len)) {
    var index = i;
    var x0 = line.charCodeAt(index);
    if ((x0 === 34)) {
      elem = (!elem);
    }
    if (((x0 === 59) && (!elem))) {
      parts.bb($f_T__trim__T(current.bP.ah));
      current.bP.PS(0);
    } else {
      current.id(x0);
    }
    i = ((1 + i) | 0);
  }
  parts.bb($f_T__trim__T(current.bP.ah));
  var this$7 = parts.bM();
  var f = ((_$5) => (_$5 !== ""));
  var l = this$7;
  while (true) {
    if (l.c()) {
      return $m_sci_Nil$();
    } else {
      var h = l.t();
      var t = l.v();
      if ((!(!(!f(h))))) {
        l = t;
        continue;
      }
      var start = l;
      var remaining = t;
      while (true) {
        if (remaining.c()) {
          return start;
        } else {
          var x = remaining.t();
          if ((!(!f(x)))) {
            remaining = remaining.v();
            continue;
          }
          var firstMiss = remaining;
          var newHead = new $c_sci_$colon$colon(start.t(), $m_sci_Nil$());
          var toProcess = start.v();
          var currentLast = newHead;
          while ((toProcess !== firstMiss)) {
            var newElem = new $c_sci_$colon$colon(toProcess.t(), $m_sci_Nil$());
            currentLast.U = newElem;
            currentLast = newElem;
            toProcess = toProcess.v();
          }
          var next = firstMiss.v();
          var nextToCopy = next;
          while ((!next.c())) {
            var head = next.t();
            if ((!(!f(head)))) {
              next = next.v();
            } else {
              while ((nextToCopy !== next)) {
                var newElem$2 = new $c_sci_$colon$colon(nextToCopy.t(), $m_sci_Nil$());
                currentLast.U = newElem$2;
                currentLast = newElem$2;
                nextToCopy = nextToCopy.v();
              }
              nextToCopy = next.v();
              next = next.v();
            }
          }
          if ((!nextToCopy.c())) {
            currentLast.U = nextToCopy;
          }
          return newHead;
        }
      }
    }
  }
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$MermaidLoss$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$MermaidLoss$, "org.jpablo.graphexplorer.viewer.backends.RoundTripLoss$MermaidLoss$", ({
  x8: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$MermaidLoss$;
function $m_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$MermaidLoss$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$MermaidLoss$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$MermaidLoss$ = new $c_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$MermaidLoss$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$MermaidLoss$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$() {
  this.a8y = null;
  this.a8z = null;
  this.a8A = null;
  this.avA = null;
  this.avB = false;
  $n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ = this;
  this.a8y = new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ExampleSource("/examples/empty-graph.dot", $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__DOT__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat());
  this.a8z = new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ExampleSource("/examples/empty-mermaid.mmd", $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__Mermaid__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat());
  this.a8A = $m_sci_VectorMap$().u3($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("Empty Graph (Graphviz)", this.a8y), new $c_T2("Empty Graph (MermaidJS)", this.a8z), new $c_T2("Finite State Machine", new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ExampleSource("/examples/finite-state-machine.dot", $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__DOT__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat())), new $c_T2("Groups", new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ExampleSource("/examples/groups.dot", $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__DOT__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat())), new $c_T2("Data Structures", new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ExampleSource("/examples/data-structures.dot", $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__DOT__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat())), new $c_T2("HTML", new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ExampleSource("/examples/html.dot", $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__DOT__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat())), new $c_T2("sbt dependencies", new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ExampleSource("/examples/sbt-project-dependencies.dot", $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__DOT__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat())), new $c_T2("Logo", new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ExampleSource("/examples/logo.dot", $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__DOT__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat())), new $c_T2("Colors", new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ExampleSource("/examples/neato/colors.dot", $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__DOT__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat())), new $c_T2("Twelve Colors", new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ExampleSource("/examples/neato/twelve-colors.dot", $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__DOT__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat())), new $c_T2("Mermaid: Microservices", new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ExampleSource("/examples/mermaid-microservices.mmd", $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__Mermaid__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat())), new $c_T2("Mermaid: Feature Showcase", new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ExampleSource("/examples/mermaid-showcase.mmd", $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__Mermaid__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat())), new $c_T2("Sequence Diagram", new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ExampleSource("/examples/mermaid-sequence.mmd", $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__Mermaid__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat())), new $c_T2("Class Diagram", new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ExampleSource("/examples/mermaid-class.mmd", $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__Mermaid__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat())), new $c_T2("State Diagram", new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ExampleSource("/examples/mermaid-state.mmd", $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__Mermaid__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat())), new $c_T2("ER Diagram", new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ExampleSource("/examples/mermaid-er.mmd", $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__Mermaid__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat())), new $c_T2("User Journey", new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ExampleSource("/examples/mermaid-journey.mmd", $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__Mermaid__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat())), new $c_T2("Gantt Chart", new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ExampleSource("/examples/mermaid-gantt.mmd", $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__Mermaid__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat())), new $c_T2("Pie Chart", new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ExampleSource("/examples/mermaid-pie.mmd", $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__Mermaid__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat())), new $c_T2("Mindmap", new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ExampleSource("/examples/mermaid-mindmap.mmd", $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__Mermaid__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat())), new $c_T2("Timeline", new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ExampleSource("/examples/mermaid-timeline.mmd", $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__Mermaid__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat())), new $c_T2("Git Graph", new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ExampleSource("/examples/mermaid-gitgraph.mmd", $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__Mermaid__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat())), new $c_T2("Quadrant Chart", new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ExampleSource("/examples/mermaid-quadrant.mmd", $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__Mermaid__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat())), new $c_T2("XY Chart", new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ExampleSource("/examples/mermaid-xychart.mmd", $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__Mermaid__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat())), new $c_T2("Sankey", new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ExampleSource("/examples/mermaid-sankey.mmd", $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__Mermaid__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat())), new $c_T2("Requirement Diagram", new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ExampleSource("/examples/mermaid-requirement.mmd", $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__Mermaid__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat())), new $c_T2("C4 Context", new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ExampleSource("/examples/mermaid-c4.mmd", $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__Mermaid__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat())), new $c_T2("Block Diagram", new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ExampleSource("/examples/mermaid-block.mmd", $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__Mermaid__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat())), new $c_T2("Kanban", new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ExampleSource("/examples/mermaid-kanban.mmd", $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__Mermaid__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat())), new $c_T2("Packet Diagram", new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ExampleSource("/examples/mermaid-packet.mmd", $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__Mermaid__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat())), new $c_T2("Radar Chart", new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ExampleSource("/examples/mermaid-radar.mmd", $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__Mermaid__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat())), new $c_T2("Architecture", new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ExampleSource("/examples/mermaid-architecture.mmd", $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__Mermaid__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat())), new $c_T2("Treemap", new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ExampleSource("/examples/mermaid-treemap.mmd", $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__Mermaid__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat()))])));
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$.prototype = $p;
$p.ai4 = (function(name) {
  var $x_3 = $m_s_Predef$();
  var $x_2 = $m_sc_StringOps$();
  var x = name.toLowerCase();
  var len = x.length;
  var dst = new $ac_C(len);
  var i = 0;
  while ((i < len)) {
    var $x_1 = i;
    var index = i;
    var x0 = x.charCodeAt(index);
    dst.a[$x_1] = ($m_jl_UnicodeData$().E5(x0) ? x0 : 45);
    i = ((1 + i) | 0);
  }
  var xs = $x_2.Ej($m_jl_String$().kS(dst, 0, dst.a.length), 45);
  var evidence$1 = $m_s_reflect_ClassTag$().y0($objectGetClass(xs).ba.Q());
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1.h8();
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var i$1 = 0;
  while ((i$1 < xs.a.length)) {
    var x1 = i$1;
    var x$2 = xs.a[x1];
    if ((x$2 !== "")) {
      var unboxedElem = (isCharArrayBuilder ? $uC(x$2) : ((x$2 === null) ? elementClass.ba.z : x$2));
      jsElems.push(unboxedElem);
    }
    i$1 = ((1 + i$1) | 0);
  }
  var elemRuntimeClass = ((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass));
  return $f_sc_IterableOnceOps__mkString__T__T__T__T($x_3.fB(elemRuntimeClass.ba.r().w(jsElems)), "", "-", "");
});
$p.aY9 = (function() {
  if ((!this.avB)) {
    var $x_1 = $m_sci_Map$();
    var this$1 = this.a8A;
    $m_sci_VectorMap$();
    var b = new $c_sci_VectorMapBuilder();
    var it = new $c_sci_VectorMap$$anon$1(this$1);
    while (it.p()) {
      var x0 = it.dC();
      var name = x0.g();
      var source = x0.h();
      b.pm($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$().ai4(name), new $c_T2(name, source));
    }
    this.avA = $x_1.ao(b.rb());
    this.avB = true;
  }
  return this.avA;
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$, "org.jpablo.graphexplorer.viewer.backends.graphviz.DotExamples$", ({
  xg: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$;
function $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ = new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$() {
  this.a8B = null;
  this.avD = null;
  this.avC = null;
  this.a8C = null;
  $n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$ = this;
  this.a8B = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "label\\s*=\\s*\"([^\"]*)\"\\s*,?\\s*;?", $m_sci_Nil$());
  this.avD = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "label\\s*=\\s*\"([^\"]*)\"", $m_sci_Nil$());
  this.avC = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "\"[^\"]*\"", $m_sci_Nil$());
  this.a8C = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "(?i)^(?:strict\\s+)?(digraph|graph)\\b.*", $m_sci_Nil$());
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$.prototype = $p;
$p.Aj = (function(text) {
  return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option($f_sc_Iterator__take__I__sc_Iterator(new $c_sc_Iterator$$anon$9(new $c_sc_StringOps$$anon$1(text, true), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => $f_T__trim__T(_$1)))), 50), new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$$anon$1());
});
$p.b2g = (function(text) {
  var this$7 = new $c_sc_Iterator$$anon$11($f_sc_Iterator__take__I__sc_Iterator(new $c_sc_Iterator$$anon$9(new $c_sc_StringOps$$anon$1(text, true), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => $f_T__trim__T(_$2)))), 50), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((line) => (!(!(!line.startsWith("subgraph")))))));
  var z = $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$Scan$().avE;
  var result = z;
  while (this$7.p()) {
    var x0 = result;
    var x1 = this$7.q();
    result = x0.b4O(x1);
  }
  return result.FS;
});
$p.b5F = (function(line) {
  var unquoted = this.avC.ahE(line, "");
  var i = 0;
  var res = 0;
  var len = unquoted.length;
  while ((i < len)) {
    if ((unquoted.charCodeAt(i) === 91)) {
      res = ((1 + res) | 0);
    }
    i = ((1 + i) | 0);
  }
  var $x_1 = res;
  var i$1 = 0;
  var res$1 = 0;
  var len$1 = unquoted.length;
  while ((i$1 < len$1)) {
    if ((unquoted.charCodeAt(i$1) === 93)) {
      res$1 = ((1 + res$1) | 0);
    }
    i$1 = ((1 + i$1) | 0);
  }
  return (($x_1 - res$1) | 0);
});
$p.b5G = (function(line) {
  if ((!(!line.startsWith("graph")))) {
    if ((line.length === 5)) {
      return true;
    } else {
      var c = line.charCodeAt(5);
      return ((!$m_jl_UnicodeData$().E5(c)) && (c !== 95));
    }
  } else {
    return false;
  }
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$, "org.jpablo.graphexplorer.viewer.backends.graphviz.DotSourceScan$", ({
  xh: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$;
function $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$ = new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_Graphviz__renderScala__T__sci_Seq__Lorg_jpablo_graphexplorer_viewer_backends_graphviz_RenderOutputs($thiz, dot, formats) {
  var r = $m_Lorg_jpablo_graphexplorer_graphviz_Graphviz$().aRF(dot, formats);
  return new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_RenderOutputs(r.Kh, r.Kg, $f_sc_IterableOnceOps__mkString__T__T__T__T(r.Rc.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => _$1.Rd))), "", "; ", ""));
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_Graphviz__renderViz__T__sci_Seq__Lorg_jpablo_graphexplorer_viewer_backends_graphviz_RenderOutputs($thiz, dot, formats) {
  var r = $thiz.avF.renderFormats(dot, [...$m_sjsr_Compat$().Y8(formats)]);
  var $x_2 = r.status;
  var $x_1 = $m_sci_Map$().ao(new $c_sjs_js_WrappedDictionary(r.output));
  var array = r.errors;
  return new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_RenderOutputs($x_2, $x_1, $f_sc_IterableOnceOps__mkString__T__T__T__T($m_sci_IndexedSeq$().WW($ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), array)).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => _$2.message))), "", "; ", ""));
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_Graphviz__renderOutputs__T__sci_Seq__Lorg_jpablo_graphexplorer_viewer_backends_graphviz_RenderOutputs($thiz, dot, formats) {
  return ($m_Lorg_jpablo_graphexplorer_graphviz_EngineRouting$().baX(dot) ? $p_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_Graphviz__renderScala__T__sci_Seq__Lorg_jpablo_graphexplorer_viewer_backends_graphviz_RenderOutputs($thiz, dot, formats) : $p_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_Graphviz__renderViz__T__sci_Seq__Lorg_jpablo_graphexplorer_viewer_backends_graphviz_RenderOutputs($thiz, dot, formats));
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_Graphviz(viz) {
  this.avF = null;
  this.avF = viz;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_Graphviz.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_Graphviz;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_Graphviz() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_Graphviz.prototype = $p;
$p.aSL = (function(dotText) {
  try {
    var result = $p_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_Graphviz__renderOutputs__T__sci_Seq__Lorg_jpablo_graphexplorer_viewer_backends_graphviz_RenderOutputs(this, $f_T__replaceAll__T__T__T(dotText, "(label\\s*=\\s*\")\\\\n+", "$1"), new $c_sci_$colon$colon("dot_json", $m_sci_Nil$()));
    if ((result.ze !== "success")) {
      throw $ct_jl_Exception__T__(new $c_jl_Exception(), ("Graphviz parsing failed: " + result.BQ));
    }
    return new $c_s_util_Success($f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer(result.BR.i("dot_json"), $m_Lujson_StringParser$()), ($m_Lupickle_default$(), false), $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$().a3I()));
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if ($m_s_util_control_NonFatal$().ew(e$2)) {
      return new $c_s_util_Failure(e$2);
    }
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
  }
});
$p.b9U = (function(dot) {
  try {
    var result = $p_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_Graphviz__renderOutputs__T__sci_Seq__Lorg_jpablo_graphexplorer_viewer_backends_graphviz_RenderOutputs(this, $f_T__replaceAll__T__T__T(dot.o6, "(label\\s*=\\s*\")\\\\n+", "$1"), new $c_sci_$colon$colon("svg", $m_sci_Nil$()));
    if ((result.ze !== "success")) {
      throw $ct_jl_Exception__T__(new $c_jl_Exception(), ((("Graphviz rendering failed: " + result.ze) + " - ") + result.BQ));
    }
    return new $c_s_util_Success($m_Lorg_jpablo_graphexplorer_viewer_domUtils_SvgParser$package$().XH(result.BR.i("svg")).e8);
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if ($m_s_util_control_NonFatal$().ew(e$2)) {
      return new $c_s_util_Failure(e$2);
    }
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
  }
});
$p.b9T = (function(dot) {
  try {
    var result = $p_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_Graphviz__renderOutputs__T__sci_Seq__Lorg_jpablo_graphexplorer_viewer_backends_graphviz_RenderOutputs(this, dot.o6, new $c_sci_$colon$colon("svg", new $c_sci_$colon$colon("json0", $m_sci_Nil$())));
    if ((result.ze !== "success")) {
      console.group("Graphviz.renderToSvg");
      console.error(dot.o6);
      console.error(result.BQ);
      console.groupEnd();
      throw $ct_jl_Exception__T__(new $c_jl_Exception(), ((("Graphviz rendering failed: " + result.ze) + " - ") + result.BQ));
    }
    var result_svg = result.BR.i("svg");
    var result_json0 = result.BR.i("json0");
    var graph = $f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer(result_json0, $m_Lujson_StringParser$()), ($m_Lupickle_default$(), false), $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$().a3I());
    var edgePos = $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_package$().aOR(graph);
    var svg = $m_Lorg_jpablo_graphexplorer_viewer_domUtils_SvgParser$package$().XH(result_svg);
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_Graphviz$().aeD(svg.e8);
    return new $c_s_util_Success(new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_SvgWithPositions(svg, edgePos));
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if ($m_s_util_control_NonFatal$().ew(e$2)) {
      return new $c_s_util_Failure(e$2);
    }
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
  }
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_Graphviz = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_Graphviz, "org.jpablo.graphexplorer.viewer.backends.graphviz.Graphviz", ({
  xk: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_Graphviz$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_Graphviz$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_Graphviz$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_Graphviz$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_Graphviz$.prototype = $p;
$p.aeD = (function(svg) {
  $m_Lorg_jpablo_graphexplorer_viewer_domUtils_QuerySelector$package$().m3(svg, "g.edge > path").F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((p) => p.parentNode.insertBefore($m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().aP9(p), p))));
});
$p.aY4 = (function() {
  var $x_1 = $m_sjs_js_Thenable$ThenableOps$();
  var \u03b41$ = $i_$0040viz$002djs$002fviz.instance();
  return $x_1.a50(\u03b41$.then(((viz) => new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_Graphviz(viz))));
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_Graphviz$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_Graphviz$, "org.jpablo.graphexplorer.viewer.backends.graphviz.Graphviz$", ({
  xl: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_Graphviz$;
function $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_Graphviz$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_Graphviz$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_Graphviz$ = new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_Graphviz$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_Graphviz$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ArrowPositionParser$__parseCoordinate__T__s_Option($thiz, coord) {
  var x16 = $f_T__split__T__I__AT(coord, ",", 0);
  if ((x16 !== null)) {
    if (($m_s_Array$UnapplySeqWrapper$().u9(x16, 2) === 0)) {
      var x18 = x16.a[0];
      var x19 = x16.a[1];
      try {
        return new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_Point($m_jl_Double$().bd(x18), $m_jl_Double$().bd(x19)));
      } catch (e) {
        if ((e instanceof $c_jl_NumberFormatException)) {
          return $m_s_None$();
        } else {
          throw e;
        }
      }
    }
  }
  return $m_s_None$();
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ArrowPositionParser$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ArrowPositionParser$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ArrowPositionParser$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ArrowPositionParser$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ArrowPositionParser$.prototype = $p;
$p.mU = (function(posString) {
  var coords = $m_sci_Nil$().b6($m_s_Predef$().fB($f_T__split__T__I__AT($f_T__trim__T(posString), "\\s+", 0)));
  if ((coords.C() < 2)) {
    return $m_s_None$();
  } else {
    var elem = $m_s_None$();
    var elem$1 = null;
    elem$1 = elem;
    var elem$2 = $m_s_None$();
    var elem$3 = null;
    elem$3 = elem$2;
    var controlPoints = new $c_scm_ListBuffer().kU($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_Point.r().C)([])));
    var these = coords;
    while ((!these.c())) {
      var x0 = these.t();
      if ((!(!x0.startsWith("s,")))) {
        elem$1 = $p_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ArrowPositionParser$__parseCoordinate__T__s_Option($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ArrowPositionParser$(), $m_sc_StringOps$().kp(x0, 2));
      } else if ((!(!x0.startsWith("e,")))) {
        elem$3 = $p_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ArrowPositionParser$__parseCoordinate__T__s_Option($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ArrowPositionParser$(), $m_sc_StringOps$().kp(x0, 2));
      } else {
        var this$9 = $p_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ArrowPositionParser$__parseCoordinate__T__s_Option($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ArrowPositionParser$(), x0);
        if ((!this$9.c())) {
          controlPoints.bb(this$9.d());
        }
      }
      these = these.v();
    }
    if ((elem$1.c() && (!controlPoints.c()))) {
      elem$1 = new $c_s_Some(controlPoints.o().q());
      controlPoints.wd(0);
    }
    if ((elem$3.c() && (!controlPoints.c()))) {
      elem$3 = new $c_s_Some(controlPoints.bJ());
      controlPoints.wd(((controlPoints.eb - 1) | 0));
    }
    var _1 = elem$1;
    var _2 = elem$3;
    if ((_1 instanceof $c_s_Some)) {
      var start = _1.J;
      if ((_2 instanceof $c_s_Some)) {
        return new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ArrowPosition(start, _2.J, controlPoints.bM()));
      }
    }
    return $m_s_None$();
  }
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ArrowPositionParser$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ArrowPositionParser$, "org.jpablo.graphexplorer.viewer.backends.graphviz.vizjs.simplegraph.ArrowPositionParser$", ({
  xn: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ArrowPositionParser$;
function $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ArrowPositionParser$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ArrowPositionParser$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ArrowPositionParser$ = new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ArrowPositionParser$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ArrowPositionParser$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ExtraAttrs$() {
  this.a8E = null;
  $n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ExtraAttrs$ = this;
  this.a8E = $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_T.r().C)(["bb", "xlp"])));
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ExtraAttrs$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ExtraAttrs$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ExtraAttrs$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ExtraAttrs$.prototype = $p;
$p.a2Q = (function(js, knownKeys) {
  return $m_sci_Map$().ao(new $c_sc_Iterator$$anon$7($f_Lujson_Value__obj__Lupickle_core_LinkedHashMap(js).o(), new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ExtraAttrs$$anon$1(knownKeys)));
});
$p.a4c = (function(js, extras) {
  $f_scm_MapOps__remove__O__s_Option($f_Lujson_Value__obj__Lupickle_core_LinkedHashMap(js), "extraAttrs");
  extras.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var k = x$1.g();
    var v = x$1.h();
    $f_scm_MapOps__update__O__O__V($f_Lujson_Value__obj__Lupickle_core_LinkedHashMap(js), k, new $c_Lujson_Str(v));
  })));
  return js;
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ExtraAttrs$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ExtraAttrs$, "org.jpablo.graphexplorer.viewer.backends.graphviz.vizjs.simplegraph.ExtraAttrs$", ({
  xo: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ExtraAttrs$;
function $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ExtraAttrs$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ExtraAttrs$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ExtraAttrs$ = new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ExtraAttrs$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ExtraAttrs$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ToViewerGraph$package$__attrAppender$1__scm_ListBuffer__sci_Set__F2($thiz, attrs, exclude) {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((v1, v2) => {
    var attrId = ((v1 === null) ? null : v1.fY);
    if ((!v2.c())) {
      var x0 = v2.d();
      if ((!exclude.E(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId(attrId)))) {
        attrs.bb(new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId(attrId), ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(x0))));
      }
    }
  }));
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ToViewerGraph$package$__appendExtras$1__F2__sci_Map__V($thiz, add, extras) {
  $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O($m_sci_Vector$().X(extras), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => _$1.g())), $m_s_math_Ordering$String$()).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var k = x$1.g();
    var v = x$1.h();
    add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId(k), new $c_s_Some(v));
  })));
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ToViewerGraph$package$__toAttributesFromNode$1__Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphNode__sci_Set__sci_Map($thiz, node, exclude) {
  var attrs = new $c_scm_ListBuffer().kU($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([])));
  var add = $p_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ToViewerGraph$package$__attrAppender$1__scm_ListBuffer__sci_Set__F2($thiz, attrs, exclude);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GvId$().xd), new $c_s_Some(("" + node.vc)));
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Name$())), new $c_s_Some(node.p2));
  var $x_1 = new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Label$()));
  var this$9 = new $c_s_Some(node.zg);
  var this$10 = ((this$9.c() || (this$9.J !== "\\N")) ? this$9 : $m_s_None$());
  add.R($x_1, (this$10.c() ? $m_s_None$() : new $c_s_Some($f_T__replaceAll__T__T__T(this$10.d(), "^(\\\\n)+", ""))));
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Pos$())), node.qg);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Height$())), node.qf);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Width$())), node.qh);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$())), node.t8);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontName$())), node.sW);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontSize$())), node.sX);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontColor$())), node.sV);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Color$())), node.sQ);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillColor$())), node.sT);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$())), node.ta);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_PenWidth$())), node.t4);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rects$())), node.t6);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Sides$())), node.t9);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Peripheries$())), node.t5);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FixedSize$())), node.sU);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Regular$())), node.t7);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Orientation$())), node.t3);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_URL$().a0H), node.sN);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Area$())), node.sO);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Class$())), node.sP);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ColorScheme$())), node.sR);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Target$())), node.tb);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Tooltip$())), node.tc);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Vertices$())), node.td);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Image$())), node.sY);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ImagePath$())), node.sZ);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ImagePos$())), node.t0);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Margin$())), node.t1);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NoJustify$())), node.t2);
  $p_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ToViewerGraph$package$__appendExtras$1__F2__sci_Map__V($thiz, add, node.sS);
  return $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().DZ(attrs);
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ToViewerGraph$package$__toAttributesFromCluster$1__Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphCluster__sci_Set__sci_Map($thiz, cluster, exclude) {
  var attrs = new $c_scm_ListBuffer().kU($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([])));
  var add = $p_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ToViewerGraph$package$__attrAppender$1__scm_ListBuffer__sci_Set__F2($thiz, attrs, exclude);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GvId$().xd), new $c_s_Some(("" + cluster.v8)));
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Name$())), new $c_s_Some(cluster.p1));
  var $x_1 = new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Label$()));
  var this$8 = cluster.s0;
  var this$9 = ((this$8.c() || (this$8.d() !== "\\N")) ? this$8 : $m_s_None$());
  add.R($x_1, (this$9.c() ? $m_s_None$() : new $c_s_Some($f_T__replaceAll__T__T__T(this$9.d(), "^(\\\\n)+", ""))));
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontName$())), cluster.rY);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontSize$())), cluster.rZ);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontColor$())), cluster.rX);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Color$())), cluster.rT);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_PenColor$())), cluster.s8);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_PenWidth$())), cluster.s9);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BgColor$())), cluster.rQ);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillColor$())), cluster.rW);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$())), cluster.sd);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$())), cluster.s1);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ClusterLabelLoc$().aa3), cluster.s2);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LHeight$())), cluster.s3);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Lp$())), cluster.s4);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LWidth$())), cluster.s5);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Normalize$())), cluster.s6);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Start$())), cluster.sc);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap$())), cluster.s7);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Cluster$())), cluster.rS);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$())), cluster.sb);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Target$())), cluster.se);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Tooltip$())), cluster.sf);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_URL$().a0H), cluster.rP);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Class$())), cluster.rR);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ColorScheme$())), cluster.rU);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rank$())), cluster.sa);
  $p_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ToViewerGraph$package$__appendExtras$1__F2__sci_Map__V($thiz, add, cluster.rV);
  return $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().DZ(attrs);
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ToViewerGraph$package$__toAttributesFromGraph$1__Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph__sci_Map($thiz, simpleGraph) {
  var attrs = new $c_scm_ListBuffer().kU($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([])));
  var add = $p_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ToViewerGraph$package$__attrAppender$1__scm_ListBuffer__sci_Set__F2($thiz, attrs, $m_sci_Set$EmptySet$());
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontName$())), simpleGraph.ry);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontSize$())), simpleGraph.rz);
  var $x_1 = new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Label$()));
  var this$6 = simpleGraph.rA;
  add.R($x_1, (this$6.c() ? $m_s_None$() : new $c_s_Some($f_T__replaceAll__T__T__T(this$6.d(), "^(\\\\n)+", ""))));
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RootGraphLabelLoc$().aau), simpleGraph.rB);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Lp$())), simpleGraph.rE);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LHeight$())), simpleGraph.rD);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LWidth$())), simpleGraph.rF);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$())), simpleGraph.rK);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$())), simpleGraph.rC);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BgColor$())), simpleGraph.rv);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeSep$())), simpleGraph.rG);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Pad$())), simpleGraph.rJ);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankSep$())), simpleGraph.rL);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Ratio$())), simpleGraph.rM);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$())), simpleGraph.rN);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap$())), simpleGraph.rI);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Normalize$())), simpleGraph.rH);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Start$())), simpleGraph.rO);
  $p_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ToViewerGraph$package$__appendExtras$1__F2__sci_Map__V($thiz, add, simpleGraph.rx);
  return $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().DZ(attrs);
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ToViewerGraph$package$__toAttributesFromEdge$1__Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge__sci_Set__sci_Map($thiz, edge, exclude) {
  var attrs = new $c_scm_ListBuffer().kU($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([])));
  var add = $p_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ToViewerGraph$package$__attrAppender$1__scm_ListBuffer__sci_Set__F2($thiz, attrs, exclude);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GvId$().xd), new $c_s_Some(("" + edge.vb)));
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Tail$())), new $c_s_Some(("" + edge.qd)));
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Head$())), new $c_s_Some(("" + edge.q9)));
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Pos$())), edge.qc);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Id$())), edge.qb);
  var $x_1 = new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Label$()));
  var this$16 = edge.ss;
  var this$17 = ((this$16.c() || (this$16.d() !== "\\N")) ? this$16 : $m_s_None$());
  add.R($x_1, (this$17.c() ? $m_s_None$() : new $c_s_Some($f_T__replaceAll__T__T__T(this$17.d(), "^(\\\\n)+", ""))));
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontName$())), edge.sp);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontSize$())), edge.sq);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Color$())), edge.sk);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_PenWidth$())), edge.sB);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$())), edge.sF);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Lp$())), edge.sz);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Len$())), edge.sy);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Constraint$())), edge.sm);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ForceLabels$())), edge.sr);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HeadPort$())), edge.qa);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailPort$())), edge.qe);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowHead$())), edge.sg);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowTail$())), edge.si);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowSize$())), edge.sh);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Dir$())), edge.sn);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Class$())), edge.sj);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ColorScheme$())), edge.sl);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layer$())), edge.sx);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NoJustify$())), edge.sA);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_SameHead$())), edge.sC);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_SameTail$())), edge.sD);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ShowBoxes$())), edge.sE);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailLp$().aay), edge.sH);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailClip$())), edge.sI);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Target$())), edge.sL);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Tooltip$())), edge.sM);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelDistance$())), edge.st);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelFloat$())), edge.su);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelFontColor$())), edge.sv);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelFontName$())), edge.sw);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailTarget$())), edge.sJ);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailTooltip$())), edge.sK);
  add.R(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailURL$().aaz), edge.sG);
  $p_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ToViewerGraph$package$__appendExtras$1__F2__sci_Map__V($thiz, add, edge.so);
  return $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().DZ(attrs);
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ToViewerGraph$package$__innermostOwners$1__scm_Map__sci_Map__sci_Map__F1__F1__scm_Map($thiz, rawClusters$3, clusterFirstByGroupId$1, clusterByGvid$1, ownGvids, subClusterGvids) {
  var owners = $m_scm_Map$().dr($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([])));
  rawClusters$3.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    matchResult6: {
      if ((x$1 !== null)) {
        var groupId = x$1.g();
        var clusterData = x$1.h();
        var this$1 = clusterFirstByGroupId$1.r(groupId).bM();
        var rest = this$1;
        var h = null;
        var t = null;
        while ((rest !== $m_sci_Nil$())) {
          var x0 = rest.t();
          var this$2 = x0.q8;
          var it = (this$2.c() ? $m_sci_Nil$() : this$2.d()).o();
          while (it.p()) {
            var nx = new $c_sci_$colon$colon(it.q(), $m_sci_Nil$());
            if ((t === null)) {
              h = nx;
            } else {
              t.U = nx;
            }
            t = nx;
          }
          rest = rest.v();
        }
        var this$3 = ((h === null) ? $m_sci_Nil$() : h);
        var rest$1 = this$3;
        var h$1 = null;
        var t$1 = null;
        while ((rest$1 !== $m_sci_Nil$())) {
          var x0$1 = rest$1.t();
          var key = (x0$1 | 0);
          var it$1 = clusterByGvid$1.r(key).o();
          while (it$1.p()) {
            var nx$1 = new $c_sci_$colon$colon(it$1.q(), $m_sci_Nil$());
            if ((t$1 === null)) {
              h$1 = nx$1;
            } else {
              t$1.U = nx$1;
            }
            t$1 = nx$1;
          }
          rest$1 = rest$1.v();
        }
        var this$5 = ((h$1 === null) ? $m_sci_Nil$() : h$1);
        var f = ((sub) => $m_sci_Set$().af(subClusterGvids.i(sub)));
        if ((this$5 === $m_sci_Nil$())) {
          var subItemSets = $m_sci_Nil$();
        } else {
          var x0$2 = this$5.t();
          var h$2 = new $c_sci_$colon$colon(f(x0$2), $m_sci_Nil$());
          var t$2 = h$2;
          var rest$2 = this$5.v();
          while ((rest$2 !== $m_sci_Nil$())) {
            var x0$3 = rest$2.t();
            var nx$2 = new $c_sci_$colon$colon(f(x0$3), $m_sci_Nil$());
            t$2.U = nx$2;
            t$2 = nx$2;
            rest$2 = rest$2.v();
          }
          var subItemSets = h$2;
        }
        var this$6 = ownGvids.i(clusterData);
        var these = this$6;
        while ((!these.c())) {
          var x0$4 = these.t();
          var gvid = (x0$4 | 0);
          _return: {
            var these$1 = subItemSets;
            while ((!these$1.c())) {
              if (these$1.t().E(gvid)) {
                var $x_1 = true;
                break _return;
              }
              these$1 = these$1.v();
            }
            var $x_1 = false;
          }
          if ((!$x_1)) {
            owners.cY(gvid, groupId);
          }
          these = these.v();
        }
        break matchResult6;
      }
      throw new $c_s_MatchError(x$1);
    }
  })));
  return owners;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ToViewerGraph$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ToViewerGraph$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ToViewerGraph$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ToViewerGraph$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ToViewerGraph$package$.prototype = $p;
$p.baf = (function(simpleGraph) {
  $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$();
  var this$1 = $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ToViewerGraph$package$().bah(simpleGraph);
  var this$2 = this$1.b0Z();
  $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$();
  return new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements(this$2.Mu, this$2.Mq, this$2.Mt, this$2.Mp, this$2.Ms, this$2.Mr, ($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$(), $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV), ($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$(), $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV)), simpleGraph.zf, $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$().b1J(simpleGraph.rw), ($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$(), 0), ($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$(), 0), ($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$(), $m_sci_Map$EmptyMap$()));
});
$p.bah = (function(simpleGraph) {
  var gvidToNodeId = $m_scm_Map$().dr($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([])));
  $m_sci_VectorMap$();
  var rawNodesBuilder = new $c_sci_VectorMapBuilder();
  var rawClusters = $m_scm_Map$().dr($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([])));
  var this$2 = simpleGraph.o5;
  if ((!this$2.c())) {
    var x0 = this$2.d();
    var these = x0;
    while ((!these.c())) {
      var x0$1 = these.t();
      matchResult2: {
        if ((x0$1 instanceof $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject$Node)) {
          var x10 = x0$1.BU;
          $m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$();
          var nodeId = new $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId(x10.p2);
          gvidToNodeId.cY(x10.vc, x10.p2);
          rawNodesBuilder.pm(nodeId, new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes($p_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ToViewerGraph$package$__toAttributesFromNode$1__Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphNode__sci_Set__sci_Map(this, x10, $m_sci_Set$().af($m_sr_ScalaRunTime$().hP(new ($d_Lorg_jpablo_graphexplorer_viewer_models_AttributeId.r().C)([new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Name$()))]))))));
          break matchResult2;
        }
        if ((x0$1 instanceof $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject$Cluster)) {
          var x7 = x0$1.FU;
          matchResult1: {
            var \u03b41$___1;
            var \u03b41$___2;
            var x1 = $m_Lorg_jpablo_graphexplorer_viewer_models_GroupId$().WX(x7.p1);
            if ((x1 !== null)) {
              var \u03b41$___1 = x1.g();
              var \u03b41$___2 = (!(!x1.h()));
              break matchResult1;
            }
            throw new $c_s_MatchError(x1);
          }
          var groupId$2 = \u03b41$___1;
          var wasCluster$2 = (!(!\u03b41$___2));
          var attrs$2 = $p_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ToViewerGraph$package$__toAttributesFromCluster$1__Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphCluster__sci_Set__sci_Map(this, x7, $m_sci_Set$().af($m_sr_ScalaRunTime$().hP(new ($d_Lorg_jpablo_graphexplorer_viewer_models_AttributeId.r().C)([new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Name$()))]))));
          var this$13 = x7.q7;
          var nodeGvids = (this$13.c() ? $m_sci_Nil$() : this$13.d());
          var this$15 = x7.q6;
          var edgeGvids = (this$15.c() ? $m_sci_Nil$() : this$15.d());
          rawClusters.cY(groupId$2, new $c_T4(new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(attrs$2), nodeGvids, edgeGvids, wasCluster$2));
          break matchResult2;
        }
        throw new $c_s_MatchError(x0$1);
      }
      these = these.v();
    }
  }
  var rawNodes = rawNodesBuilder.rb();
  var membershipsBuilder = $m_scm_Map$().dr($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([])));
  var groupsBuilder = $m_scm_Map$().dr($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([])));
  rawClusters.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    matchResult3: {
      if ((x$1 !== null)) {
        var x13 = x$1.h();
        var groupId$1 = x$1.g();
        if ((x13 !== null)) {
          var attrs$1 = ((x13.bO === null) ? null : x13.bO.ce);
          var wasCluster$1 = (!(!x13.ca));
          if (attrs$1.E(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Cluster$())))) {
            var updatedAttrs = attrs$1;
          } else {
            var defaultValue = (wasCluster$1 ? "true" : "false");
            var updatedValues = attrs$1.bN(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Cluster$())), ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(defaultValue)));
            $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$();
            var updatedAttrs = updatedValues;
          }
          groupsBuilder.cY(groupId$1, $m_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$().a3J(groupId$1, updatedAttrs));
          break matchResult3;
        }
      }
      throw new $c_s_MatchError(x$1);
    }
  })));
  var this$24 = simpleGraph.o5;
  var objectClusters = (this$24.c() ? $m_sci_Nil$() : this$24.d()).Ag(new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ToViewerGraph$package$$anon$1());
  if ((objectClusters.bL(1) <= 0)) {
    var $x_1 = objectClusters;
  } else {
    var builder = new $c_scm_ListBuffer();
    var seen = $ct_scm_HashSet__(new $c_scm_HashSet());
    var it = objectClusters.o();
    var different = false;
    while (it.p()) {
      var next = it.q();
      if (seen.oA($m_Lorg_jpablo_graphexplorer_viewer_models_GroupId$().WX(next.p1).g())) {
        builder.bb(next);
      } else {
        different = true;
      }
    }
    var $x_1 = (different ? builder.bM() : objectClusters);
  }
  var this$29 = $x_1;
  var f = ((c$2) => new $c_T2($m_Lorg_jpablo_graphexplorer_viewer_models_GroupId$().WX(c$2.p1).g(), c$2));
  var $x_3 = $m_sci_Map$();
  if ((this$29 === $m_sci_Nil$())) {
    var $x_2 = $m_sci_Nil$();
  } else {
    var x0$2 = this$29.t();
    var h = new $c_sci_$colon$colon(f(x0$2), $m_sci_Nil$());
    var t = h;
    var rest = this$29.v();
    while ((rest !== $m_sci_Nil$())) {
      var x0$3 = rest.t();
      var nx = new $c_sci_$colon$colon(f(x0$3), $m_sci_Nil$());
      t.U = nx;
      t = nx;
      rest = rest.v();
    }
    var $x_2 = h;
  }
  var clusterFirstByGroupId = $x_3.ao($x_2);
  if ((objectClusters.bL(1) <= 0)) {
    var $x_4 = objectClusters;
  } else {
    var builder$1 = new $c_scm_ListBuffer();
    var seen$1 = $ct_scm_HashSet__(new $c_scm_HashSet());
    var it$1 = objectClusters.o();
    var different$1 = false;
    while (it$1.p()) {
      var next$1 = it$1.q();
      if (seen$1.oA(next$1.v8)) {
        builder$1.bb(next$1);
      } else {
        different$1 = true;
      }
    }
    var $x_4 = (different$1 ? builder$1.bM() : objectClusters);
  }
  var this$36 = $x_4;
  var f$1 = ((c$3) => new $c_T2(c$3.v8, c$3));
  var $x_6 = $m_sci_Map$();
  if ((this$36 === $m_sci_Nil$())) {
    var $x_5 = $m_sci_Nil$();
  } else {
    var x0$4 = this$36.t();
    var h$1 = new $c_sci_$colon$colon(f$1(x0$4), $m_sci_Nil$());
    var t$1 = h$1;
    var rest$1 = this$36.v();
    while ((rest$1 !== $m_sci_Nil$())) {
      var x0$5 = rest$1.t();
      var nx$1 = new $c_sci_$colon$colon(f$1(x0$5), $m_sci_Nil$());
      t$1.U = nx$1;
      t$1 = nx$1;
      rest$1 = rest$1.v();
    }
    var $x_5 = h$1;
  }
  var clusterByGvid = $x_6.ao($x_5);
  $p_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ToViewerGraph$package$__innermostOwners$1__scm_Map__sci_Map__sci_Map__F1__F1__scm_Map(this, rawClusters, clusterFirstByGroupId, clusterByGvid, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$8) => _$8.bs)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$9) => {
    var this$39 = _$9.q7;
    return (this$39.c() ? $m_sci_Nil$() : this$39.d());
  }))).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    matchResult7: {
      if ((x$1$2 !== null)) {
        var gvid = (x$1$2.g() | 0);
        var groupId$3 = x$1$2.h();
        var this$40 = gvidToNodeId.r(gvid);
        if ((!this$40.c())) {
          var x0$6 = this$40.d();
          membershipsBuilder.cY(($m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$(), new $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId(x0$6)), groupId$3);
          break matchResult7;
        } else {
          break matchResult7;
        }
      }
      throw new $c_s_MatchError(x$1$2);
    }
  })));
  var these$1 = objectClusters;
  while ((!these$1.c())) {
    var x0$7 = these$1.t();
    var parentGroupId = $m_Lorg_jpablo_graphexplorer_viewer_models_GroupId$().WX(x0$7.p1).g();
    var this$42 = x0$7.q8;
    if ((!this$42.c())) {
      var x0$8 = this$42.d();
      var these$2 = x0$8;
      while ((!these$2.c())) {
        var x0$9 = these$2.t();
        var subgraphGvid = (x0$9 | 0);
        var this$43 = clusterByGvid.r(subgraphGvid);
        if ((!this$43.c())) {
          var x0$10 = this$43.d();
          membershipsBuilder.cY($m_Lorg_jpablo_graphexplorer_viewer_models_GroupId$().WX(x0$10.p1).g(), parentGroupId);
        }
        these$2 = these$2.v();
      }
    }
    these$1 = these$1.v();
  }
  var edgeToCluster = $p_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ToViewerGraph$package$__innermostOwners$1__scm_Map__sci_Map__sci_Map__F1__F1__scm_Map(this, rawClusters, clusterFirstByGroupId, clusterByGvid, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$10) => _$10.ch)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$11) => {
    var this$44 = _$11.q6;
    return (this$44.c() ? $m_sci_Nil$() : this$44.d());
  })));
  var this$45 = simpleGraph.q5;
  var this$60 = (this$45.c() ? $m_sci_Nil$() : this$45.d());
  var f$2 = ((edge) => {
    var sourceName = gvidToNodeId.ay(edge.qd, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((edge$2) => (() => ("" + edge$2.qd)))(edge)));
    var targetName = gvidToNodeId.ay(edge.q9, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((edge$3) => (() => ("" + edge$3.q9)))(edge)));
    var attrs$3 = $p_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ToViewerGraph$package$__toAttributesFromEdge$1__Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge__sci_Set__sci_Map(this, edge, $m_sci_Set$().af($m_sr_ScalaRunTime$().hP(new ($d_Lorg_jpablo_graphexplorer_viewer_models_AttributeId.r().C)([new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Tail$())), new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Head$())), new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailPort$())), new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HeadPort$()))]))));
    var $x_7 = edge.vb;
    $m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$();
    var source$1 = new $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId(sourceName);
    $m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$();
    var target$1 = new $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId(targetName);
    $m_Lorg_jpablo_graphexplorer_viewer_models_Arrow$();
    return new $c_T2($x_7, new $c_Lorg_jpablo_graphexplorer_viewer_models_Arrow(source$1, target$1, attrs$3, edge.qe, edge.qa, edge.vb));
  });
  if ((this$60 === $m_sci_Nil$())) {
    var edgeArrowPairs = $m_sci_Nil$();
  } else {
    var x0$11 = this$60.t();
    var h$2 = new $c_sci_$colon$colon(f$2(x0$11), $m_sci_Nil$());
    var t$2 = h$2;
    var rest$2 = this$60.v();
    while ((rest$2 !== $m_sci_Nil$())) {
      var x0$12 = rest$2.t();
      var nx$2 = new $c_sci_$colon$colon(f$2(x0$12), $m_sci_Nil$());
      t$2.U = nx$2;
      t$2 = nx$2;
      rest$2 = rest$2.v();
    }
    var edgeArrowPairs = h$2;
  }
  var f$3 = ((x$1$3) => {
    (x$1$3.g() | 0);
    var a = x$1$3.h();
    return new $c_T2(a.dw, a);
  });
  var $x_9 = $m_sci_Map$();
  if ((edgeArrowPairs === $m_sci_Nil$())) {
    var $x_8 = $m_sci_Nil$();
  } else {
    var x0$13 = edgeArrowPairs.t();
    var h$3 = new $c_sci_$colon$colon(f$3(x0$13), $m_sci_Nil$());
    var t$3 = h$3;
    var rest$3 = edgeArrowPairs.v();
    while ((rest$3 !== $m_sci_Nil$())) {
      var x0$14 = rest$3.t();
      var nx$3 = new $c_sci_$colon$colon(f$3(x0$14), $m_sci_Nil$());
      t$3.U = nx$3;
      t$3 = nx$3;
      rest$3 = rest$3.v();
    }
    var $x_8 = h$3;
  }
  var arrows = $x_9.ao($x_8);
  var $x_11 = $m_sci_Map$();
  var rest$4 = edgeArrowPairs;
  var h$4 = null;
  var t$4 = null;
  while ((rest$4 !== $m_sci_Nil$())) {
    var x0$15 = rest$4.t();
    var gvid$1 = (x0$15.g() | 0);
    var a$1 = x0$15.h();
    var this$65 = edgeToCluster.r(gvid$1);
    if (this$65.c()) {
      var $x_10 = $m_s_None$();
    } else {
      var x0$16 = this$65.d();
      var $x_10 = new $c_s_Some(new $c_T2(a$1.dw, x0$16));
    }
    var it$2 = $x_10.o();
    while (it$2.p()) {
      var nx$4 = new $c_sci_$colon$colon(it$2.q(), $m_sci_Nil$());
      if ((t$4 === null)) {
        h$4 = nx$4;
      } else {
        t$4.U = nx$4;
      }
      t$4 = nx$4;
    }
    rest$4 = rest$4.v();
  }
  var arrowMembershipsMap = $x_11.ao(((h$4 === null) ? $m_sci_Nil$() : h$4));
  var arrowEndpoints = arrows.e6().c5(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$14) => _$14.aft()))).cE(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((key) => rawNodes.l8.E(key))));
  $m_sci_VectorMap$();
  var finalNodesBuilder = new $c_sci_VectorMapBuilder();
  var it$3 = new $c_sci_VectorMap$$anon$1(rawNodes);
  while (it$3.p()) {
    var x0$17 = it$3.dC();
    matchResult8: {
      if ((x0$17 !== null)) {
        var nodeId$1 = x0$17.g();
        var attrs$4 = ((x0$17.h() === null) ? null : x0$17.h().ce);
        finalNodesBuilder.pm(nodeId$1, ($m_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$(), $m_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$(), new $c_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode(nodeId$1, attrs$4, ($m_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$(), $m_s_None$()))));
        break matchResult8;
      }
      throw new $c_s_MatchError(x0$17);
    }
  }
  arrowEndpoints.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((nodeId$2) => {
    $m_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$();
    var attributes = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV;
    $m_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$();
    return finalNodesBuilder.pm(nodeId$2, new $c_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode(nodeId$2, attributes, ($m_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$(), $m_s_None$())));
  })));
  var finalNodes = finalNodesBuilder.rb();
  var graphAttrs = $p_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ToViewerGraph$package$__toAttributesFromGraph$1__Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph__sci_Map(this, simpleGraph);
  $m_Lorg_jpablo_graphexplorer_viewer_graph_VizViewerGraphElements$();
  return new $c_Lorg_jpablo_graphexplorer_viewer_graph_VizViewerGraphElements(finalNodes, arrows, $m_sci_VectorMap$().u3(membershipsBuilder), arrowMembershipsMap, $m_sci_Map$().ao(groupsBuilder), graphAttrs);
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ToViewerGraph$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ToViewerGraph$package$, "org.jpablo.graphexplorer.viewer.backends.graphviz.vizjs.simplegraph.ToViewerGraph$package$", ({
  xE: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ToViewerGraph$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ToViewerGraph$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ToViewerGraph$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ToViewerGraph$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ToViewerGraph$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ToViewerGraph$package$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_package$.prototype = $p;
$p.aOR = (function(graph) {
  var edgePositions = $m_scm_Map$().dr($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([])));
  var this$1 = graph.o5;
  var this$4 = (this$1.c() ? $m_s_None$() : new $c_s_Some($m_sci_Map$().ao(this$1.d().Ag(new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_package$$anon$1()))));
  var nodeMap = (this$4.c() ? $m_sci_Map$EmptyMap$() : this$4.d());
  var this$6 = graph.q5;
  if ((!this$6.c())) {
    var x0$1 = this$6.d();
    var these = x0$1;
    while ((!these.c())) {
      var x0$2 = these.t();
      var this$7 = x0$2.qc;
      if ((!this$7.c())) {
        var x0$3 = this$7.d();
        var this$8 = $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ArrowPositionParser$().mU(x0$3);
        if ((!this$8.c())) {
          var x0$4 = this$8.d();
          var tailName = nodeMap.ay(x0$2.qd, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((edge$2$2) => (() => ("" + edge$2$2.qd)))(x0$2)));
          var headName = nodeMap.ay(x0$2.q9, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((edge$2$3) => (() => ("" + edge$2$3.q9)))(x0$2)));
          matchResult3: {
            var edgeId;
            var x9 = x0$2.qb;
            if ((x9 instanceof $c_s_Some)) {
              var id = x9.J;
              var this$13 = $m_Lorg_jpablo_graphexplorer_viewer_models_ArrowId$().WZ(id);
              var this$14 = (this$13.c() ? $m_s_None$() : new $c_s_Some(this$13.d().l3));
              var edgeId = (this$14.c() ? id : this$14.d());
              break matchResult3;
            }
            if (($m_s_None$() === x9)) {
              var edgeId = ((tailName + "->") + headName);
              break matchResult3;
            }
            throw new $c_s_MatchError(x9);
          }
          edgePositions.cY(edgeId, x0$4);
        }
      }
      these = these.v();
    }
  }
  return $m_sci_Map$().ao(edgePositions);
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_package$, "org.jpablo.graphexplorer.viewer.backends.graphviz.vizjs.simplegraph.package$", ({
  xG: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_package$;
function $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_package$ = new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_package$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FlowchartConfig$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FlowchartConfig$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FlowchartConfig$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FlowchartConfig$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FlowchartConfig$.prototype = $p;
$p.aXi = (function(htmlLabels, curve, nodeSpacing, rankSpacing, useMaxWidth) {
  var obj = $m_sjs_js_special_package$().eA($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([])));
  if ((htmlLabels !== (void 0))) {
    var _$1 = (!(!htmlLabels));
    obj.htmlLabels = _$1;
  }
  if ((curve !== (void 0))) {
    obj.curve = curve;
  }
  if ((nodeSpacing !== (void 0))) {
    var _$3 = (nodeSpacing | 0);
    obj.nodeSpacing = _$3;
  }
  if ((rankSpacing !== (void 0))) {
    var _$4 = (rankSpacing | 0);
    obj.rankSpacing = _$4;
  }
  if ((useMaxWidth !== (void 0))) {
    var _$5 = (!(!useMaxWidth));
    obj.useMaxWidth = _$5;
  }
  return obj;
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FlowchartConfig$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FlowchartConfig$, "org.jpablo.graphexplorer.viewer.backends.mermaid.FlowchartConfig$", ({
  xI: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FlowchartConfig$;
function $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FlowchartConfig$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FlowchartConfig$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FlowchartConfig$ = new $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FlowchartConfig$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FlowchartConfig$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$__emitSubgraph$1__scm_Set__scm_StringBuilder__sci_Map__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__scm_Set__sci_Map__Lorg_jpablo_graphexplorer_viewer_models_GroupId__Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup__I__V($thiz, emittedGroups$1, lines$2, nodesByGroup$1, graph$2, subgraphNodes$1, childGroupsByParent$1, groupId, group, depth) {
  if (emittedGroups$1.oA(groupId)) {
    var indent = $m_sc_StringOps$().tR("  ", depth);
    matchResult5: {
      var title;
      var x17 = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidLabelText$().ag6($f_Lorg_jpablo_graphexplorer_viewer_models_ViewerElement__label__Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(group).m());
      if ((x17 !== "")) {
        var title = ((" [" + x17) + "]");
        break matchResult5;
      }
      var title = "";
    }
    lines$2.ei(((((indent + "subgraph ") + $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().Ea(groupId.dR)) + title) + "\n"));
    $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(nodesByGroup$1.ay(groupId, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_Nil$()))).d2(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$9) => _$9.dE)), $m_s_math_Ordering$String$()).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((nodeId) => {
      var this$5 = graph$2.dQ.r(nodeId);
      if ((!this$5.c())) {
        var x0 = this$5.d();
        lines$2.ei((((indent + "  ") + $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().aS1(nodeId, x0)) + "\n"));
        subgraphNodes$1.Y(nodeId);
      }
    })));
    $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(childGroupsByParent$1.ay(groupId, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      $m_sci_Vector$();
      return $m_sci_Vector0$();
    }))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$10) => _$10.dR)), $m_s_math_Ordering$String$()).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((childId) => {
      var this$8 = graph$2.hu.r(childId);
      if ((!this$8.c())) {
        $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$__emitSubgraph$1__scm_Set__scm_StringBuilder__sci_Map__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__scm_Set__sci_Map__Lorg_jpablo_graphexplorer_viewer_models_GroupId__Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup__I__V($thiz, emittedGroups$1, lines$2, nodesByGroup$1, graph$2, subgraphNodes$1, childGroupsByParent$1, childId, this$8.d(), ((1 + depth) | 0));
      }
    })));
    lines$2.ei((indent + "end\n"));
  }
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$() {
  this.a8G = null;
  this.avQ = null;
  $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$ = this;
  this.a8G = $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_T.r().C)(["fill", "stroke", "stroke-width", "color", "font-family", "font-size"])));
  this.avQ = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "[^A-Za-z0-9_-]", $m_sci_Nil$());
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$.prototype = $p;
$p.bbo = (function(graph) {
  var lines = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  var this$2 = graph.aA.dW.r(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Label$())));
  var this$3 = (this$2.c() ? $m_s_None$() : new $c_s_Some(this$2.d().m()));
  var titleOpt = ((this$3.c() || (this$3.d() !== "")) ? this$3 : $m_s_None$());
  if ((!titleOpt.c())) {
    var x0$2 = titleOpt.d();
    lines.ei("---\n");
    lines.ei((("title: " + x0$2) + "\n"));
    lines.ei("---\n");
  }
  lines.ei((("flowchart " + $dp_toString__T($m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().E0(graph.aA.dW, $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$()))) + "\n"));
  $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().b0s(lines, graph.aA.dW);
  $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().b0t(lines, graph.aA.dW);
  $m_Lorg_jpablo_graphexplorer_viewer_models_GroupId$();
  var rootGroupId = new $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$().p4.dR);
  var connectedNodeIds = $m_sci_Set$().af(graph.fX.e6().c5(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3) => _$3.aft()))));
  var this$8 = graph.hu;
  var sortedGroups = $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O($m_sci_Vector$().X(this$8), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4) => _$4.g().dR)), $m_s_math_Ordering$String$());
  var this$12 = $m_sci_Nil$().b6(graph.go).Ag(new $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$1());
  var m = $m_scm_Map$().aO();
  var these = this$12;
  while ((!these.c())) {
    var x0$3 = these.t();
    var k = x0$3.g();
    m.ec(k, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => new $c_scm_ListBuffer()))).Y(x0$3.h());
    these = these.v();
  }
  var result = new $c_sc_IterableOps$Result$1(this$12);
  m.F(result);
  var nodesByGroup = result.zS;
  var this$14 = graph.go;
  var childGroupsByParent = $f_sc_IterableOps__groupMap__F1__F1__sci_Map($f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O($m_sci_Vector$().X(this$14), new $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$2(rootGroupId, graph)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$7) => _$7.g())), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$8) => _$8.h())));
  var nestedGroupIds = $m_sci_Set$().af(childGroupsByParent.e6().dk($m_s_$less$colon$less$().b1));
  var subgraphNodes = $m_scm_Set$().dr($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_NodeId.r().C)([])));
  var emittedGroups = $m_scm_Set$().dr($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_GroupId.r().C)([])));
  sortedGroups.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    matchResult6: {
      if ((x$1 !== null)) {
        var groupId = x$1.g();
        var group = x$1.h();
        if (((!((groupId !== null) && groupId.e(rootGroupId))) && (!nestedGroupIds.E(groupId)))) {
          $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$__emitSubgraph$1__scm_Set__scm_StringBuilder__sci_Map__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__scm_Set__sci_Map__Lorg_jpablo_graphexplorer_viewer_models_GroupId__Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup__I__V(this, emittedGroups, lines, nodesByGroup, graph, subgraphNodes, childGroupsByParent, groupId, group, 1);
          break matchResult6;
        } else {
          break matchResult6;
        }
      }
      throw new $c_s_MatchError(x$1);
    }
  })));
  sortedGroups.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    matchResult7: {
      if ((x$1$2 !== null)) {
        var groupId$1 = x$1$2.g();
        var group$1 = x$1$2.h();
        if (((!((groupId$1 !== null) && groupId$1.e(rootGroupId))) && (!emittedGroups.E(groupId$1)))) {
          $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$__emitSubgraph$1__scm_Set__scm_StringBuilder__sci_Map__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__scm_Set__sci_Map__Lorg_jpablo_graphexplorer_viewer_models_GroupId__Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup__I__V(this, emittedGroups, lines, nodesByGroup, graph, subgraphNodes, childGroupsByParent, groupId$1, group$1, 1);
          break matchResult7;
        } else {
          break matchResult7;
        }
      }
      throw new $c_s_MatchError(x$1$2);
    }
  })));
  var this$20 = graph.dQ;
  var it = new $c_sci_VectorMap$$anon$1(this$20);
  while (it.p()) {
    var x0$4 = it.dC();
    matchResult8: {
      if ((x0$4 !== null)) {
        var nodeId = x0$4.g();
        var node = x0$4.h();
        if ((!subgraphNodes.E(nodeId))) {
          if ($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().b8R(nodeId, node, connectedNodeIds)) {
            lines.ei((("  " + $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().aS1(nodeId, node)) + "\n"));
            break matchResult8;
          } else {
            break matchResult8;
          }
        } else {
          break matchResult8;
        }
      }
      throw new $c_s_MatchError(x0$4);
    }
  }
  var orderedArrows = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().b9g(graph.fX.e6());
  orderedArrows.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((arrow) => lines.ei((("  " + $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().b8x(arrow)) + "\n")))));
  $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(orderedArrows).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$4) => {
    matchResult9: {
      if ((x$1$4 !== null)) {
        var arrow$1 = x$1$4.g();
        var edgeIndex = (x$1$4.h() | 0);
        var this$21 = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().b0l(arrow$1);
        if ((!this$21.c())) {
          var x0$5 = this$21.d();
          lines.ei((((("  linkStyle " + edgeIndex) + " ") + x0$5) + "\n"));
          break matchResult9;
        } else {
          break matchResult9;
        }
      }
      throw new $c_s_MatchError(x$1$4);
    }
  })));
  var this$22 = graph.dQ;
  var it$1 = new $c_sci_VectorMap$$anon$1(this$22);
  while (it$1.p()) {
    var x0$6 = it$1.dC();
    matchResult10: {
      if ((x0$6 !== null)) {
        var nodeId$1 = x0$6.g();
        var node$1 = x0$6.h();
        var this$23 = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().b54(node$1);
        if ((!this$23.c())) {
          var x0$7 = this$23.d();
          lines.ei((((("  style " + $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().Ea(nodeId$1.dE)) + " ") + x0$7) + "\n"));
          break matchResult10;
        } else {
          break matchResult10;
        }
      }
      throw new $c_s_MatchError(x0$6);
    }
  }
  var this$24 = graph.dQ;
  var it$2 = new $c_sci_VectorMap$$anon$1(this$24);
  while (it$2.p()) {
    var x0$8 = it$2.dC();
    matchResult11: {
      if ((x0$8 !== null)) {
        var nodeId$2 = x0$8.g();
        var node$2 = x0$8.h();
        var this$26 = node$2.fH.r(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$())));
        var this$27 = (this$26.c() ? $m_s_None$() : new $c_s_Some(this$26.d().m()));
        if (this$27.c()) {
          var $x_1 = true;
        } else {
          var x0$10 = this$27.d();
          var $x_1 = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().aQi(x0$10).c();
        }
        if ($x_1) {
          var this$28 = this$27;
        } else {
          var this$28 = $m_s_None$();
        }
        if ((!this$28.c())) {
          var x0$11 = this$28.d();
          lines.ei(((((("  class " + $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().Ea(nodeId$2.dE)) + " ") + $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$().a0a) + x0$11) + "\n"));
          break matchResult11;
        } else {
          break matchResult11;
        }
      }
      throw new $c_s_MatchError(x0$8);
    }
  }
  sortedGroups.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$7) => {
    matchResult12: {
      if ((x$1$7 !== null)) {
        var groupId$2 = x$1$7.g();
        var group$2 = x$1$7.h();
        if ((!((groupId$2 !== null) && groupId$2.e(rootGroupId)))) {
          var this$29 = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().b2j(group$2);
          if ((!this$29.c())) {
            var x0$12 = this$29.d();
            lines.ei((((("  style " + $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().Ea(groupId$2.dR)) + " ") + x0$12) + "\n"));
            break matchResult12;
          } else {
            break matchResult12;
          }
        } else {
          break matchResult12;
        }
      }
      throw new $c_s_MatchError(x$1$7);
    }
  })));
  $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().b0u(lines, sortedGroups, rootGroupId);
  return lines.bP.ah;
});
$p.aS1 = (function(nodeId, node) {
  var this$2 = node.fH.r(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Label$())));
  var this$3 = (this$2.c() ? $m_s_None$() : new $c_s_Some(this$2.d().m()));
  var labelOpt = ((this$3.c() || (this$3.d() !== "")) ? this$3 : $m_s_None$());
  var this$7 = node.fH.r(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$())));
  var shapeOpt = (this$7.c() ? $m_s_None$() : new $c_s_Some(this$7.d().m()));
  var this$8 = node.fH.r(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$().FV));
  var this$9 = (this$8.c() ? $m_s_None$() : new $c_s_Some(this$8.d().m()));
  var classOpt = ((this$9.c() || (this$9.d() !== "")) ? this$9 : $m_s_None$());
  var this$13 = node.fH.r(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$())));
  var rounded = ((!this$13.c()) && (this$13.d().m() === "rounded"));
  var safeId = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().Ea(nodeId.dE);
  var label = (labelOpt.c() ? nodeId.dE : labelOpt.d());
  matchResult15: {
    var \u03b41$___1;
    var \u03b41$___2;
    matchResult14$1: {
      var x49;
      if ((shapeOpt instanceof $c_s_Some)) {
        var s = shapeOpt.J;
        var x39 = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().aQi(s);
        if ((x39 instanceof $c_s_Some)) {
          var x43 = x39.J;
          if (((((x43 !== null) && (x43.g() === "[")) && (x43.h() === "]")) && rounded)) {
            var x49 = new $c_T2("(", ")");
            break matchResult14$1;
          }
          var x49 = x43;
          break matchResult14$1;
        }
        if (($m_s_None$() === x39)) {
          var x49 = new $c_T2("[", "]");
          break matchResult14$1;
        }
        throw new $c_s_MatchError(x39);
      }
      if (($m_s_None$() === shapeOpt)) {
        var x49 = (rounded ? new $c_T2("(", ")") : new $c_T2("[", "]"));
        break matchResult14$1;
      }
      throw new $c_s_MatchError(shapeOpt);
    }
    if ((x49 !== null)) {
      var \u03b41$___1 = x49.g();
      var \u03b41$___2 = x49.h();
      break matchResult15;
    }
    throw new $c_s_MatchError(x49);
  }
  var openBracket$2 = \u03b41$___1;
  var closeBracket$2 = \u03b41$___2;
  var this$19 = (classOpt.c() ? $m_s_None$() : new $c_s_Some((":::" + classOpt.d())));
  var classSuffix = (this$19.c() ? "" : this$19.d());
  if ((((shapeOpt.c() && (!rounded)) && (label === nodeId.dE)) && (safeId === nodeId.dE))) {
    return (("" + safeId) + classSuffix);
  } else {
    var escapedLabel = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().aNS($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidLabelText$().ag6(label));
    return ((((("" + safeId) + openBracket$2) + escapedLabel) + closeBracket$2) + classSuffix);
  }
});
$p.b8x = (function(arrow) {
  matchResult16: {
    var \u03b42$___1;
    var \u03b42$___2;
    var x52 = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().aND(arrow.fG);
    if ((x52 !== null)) {
      var \u03b42$___1 = (!(!x52.g()));
      var \u03b42$___2 = (!(!x52.h()));
      break matchResult16;
    }
    throw new $c_s_MatchError(x52);
  }
  var startArrow$2 = (!(!\u03b42$___1));
  var endArrow$2 = (!(!\u03b42$___2));
  if ((startArrow$2 && (!endArrow$2))) {
    var \u03b43$___1 = arrow.c0;
    var \u03b43$___2 = arrow.bX;
    var \u03b43$___3 = false;
    var \u03b43$___4 = true;
  } else {
    var \u03b43$___1 = arrow.bX;
    var \u03b43$___2 = arrow.c0;
    var \u03b43$___3 = startArrow$2;
    var \u03b43$___4 = endArrow$2;
  }
  var src = \u03b43$___1;
  var dst = \u03b43$___2;
  var start = (!(!\u03b43$___3));
  var end = (!(!\u03b43$___4));
  var arrowType = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().b4p($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().b0k(arrow.fG), start, end);
  var this$5 = arrow.fG.r(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Label$())));
  var this$6 = (this$5.c() ? $m_s_None$() : new $c_s_Some(this$5.d().m()));
  var labelOpt = ((this$6.c() || (this$6.d() !== "")) ? this$6 : $m_s_None$());
  if (labelOpt.c()) {
    var this$9 = $m_s_None$();
  } else {
    var x0$2 = labelOpt.d();
    var this$9 = new $c_s_Some((("|" + $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().aNS($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidLabelText$().ag6(x0$2))) + "|"));
  }
  var labelPart = (this$9.c() ? "" : this$9.d());
  return ((((($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().Ea(src.dE) + " ") + arrowType) + labelPart) + " ") + $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().Ea(dst.dE));
});
$p.aND = (function(attrs) {
  var this$2 = attrs.r(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowHead$())));
  var this$3 = (this$2.c() ? $m_s_None$() : new $c_s_Some(this$2.d().m()));
  var headDrawn = (this$3.c() || (this$3.d() !== "none"));
  var this$5 = attrs.r(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowTail$())));
  var this$6 = (this$5.c() ? $m_s_None$() : new $c_s_Some(this$5.d().m()));
  var tailDrawn = ((!this$6.c()) && (this$6.d() !== "none"));
  var this$8 = attrs.r(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Dir$())));
  var x55 = (this$8.c() ? $m_s_None$() : new $c_s_Some(this$8.d().m()));
  if ((x55 instanceof $c_s_Some)) {
    var x61 = x55.J;
    if ((x61 === "forward")) {
      return new $c_T2(false, headDrawn);
    }
    if ((x61 === "back")) {
      return new $c_T2(tailDrawn, false);
    }
    if ((x61 === "none")) {
      return new $c_T2(false, false);
    }
  }
  return new $c_T2(tailDrawn, headDrawn);
});
$p.b0k = (function(attrs) {
  var this$2 = attrs.r(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$())));
  var this$3 = (this$2.c() ? $m_s_None$() : new $c_s_Some(this$2.d().m()));
  if (this$3.c()) {
    var $x_1 = true;
  } else {
    var x0$1 = this$3.d();
    var $x_1 = (!((x0$1.indexOf(":") | 0) !== (-1)));
  }
  if ($x_1) {
    var this$4 = this$3;
  } else {
    var this$4 = $m_s_None$();
  }
  if (this$4.c()) {
    var this$6 = attrs.r(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BoldStyle$())));
    var this$8 = (((!this$6.c()) && (this$6.d().m() === "true")) ? new $c_s_Some("bold") : $m_s_None$());
  } else {
    var this$8 = this$4;
  }
  if (this$8.c()) {
    var this$10 = attrs.r(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$())));
    return (this$10.c() ? $m_s_None$() : new $c_s_Some(this$10.d().m()));
  } else {
    return this$8;
  }
});
$p.Ea = (function(id) {
  _return: {
    var i = 0;
    var len = id.length;
    while ((i < len)) {
      var index = i;
      var x0 = id.charCodeAt(index);
      if ((!$m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$().agE(x0))) {
        var $x_1 = false;
        break _return;
      }
      i = ((1 + i) | 0);
    }
    var $x_1 = true;
  }
  if ($x_1) {
    return id;
  } else {
    return $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().avQ.ahE(id, "_");
  }
});
$p.aQi = (function(dotShape) {
  switch (dotShape.toLowerCase()) {
    case "box":
    case "rect":
    case "rectangle": {
      return new $c_s_Some(new $c_T2("[", "]"));
      break;
    }
    case "folder": {
      return new $c_s_Some(new $c_T2("[[", "]]"));
      break;
    }
    case "diamond": {
      return new $c_s_Some(new $c_T2("{", "}"));
      break;
    }
    case "circle": {
      return new $c_s_Some(new $c_T2("((", "))"));
      break;
    }
    case "ellipse": {
      return new $c_s_Some(new $c_T2("([", "])"));
      break;
    }
    case "cylinder": {
      return new $c_s_Some(new $c_T2("[(", ")]"));
      break;
    }
    case "hexagon": {
      return new $c_s_Some(new $c_T2("{{", "}}"));
      break;
    }
    case "parallelogram": {
      return new $c_s_Some(new $c_T2("[/", "/]"));
      break;
    }
    case "trapezium":
    case "trapezoid": {
      return new $c_s_Some(new $c_T2("[/", "\\]"));
      break;
    }
    case "invtrapezium": {
      return new $c_s_Some(new $c_T2("[\\", "/]"));
      break;
    }
    case "doublecircle": {
      return new $c_s_Some(new $c_T2("(((", ")))"));
      break;
    }
    case "stadium": {
      return new $c_s_Some(new $c_T2("([", "])"));
      break;
    }
    default: {
      return $m_s_None$();
    }
  }
});
$p.b4p = (function(styleOpt, start, end) {
  matchResult19: {
    var family___1;
    var family___2;
    var family___3;
    matchAlts5: {
      matchAlts6: {
        if ((styleOpt instanceof $c_s_Some)) {
          var x69 = styleOpt.J;
          if ((x69 === "dashed")) {
            break matchAlts6;
          }
          if ((x69 === "dotted")) {
            break matchAlts6;
          }
        }
        break matchAlts5;
      }
      var family___1 = "-.->";
      var family___2 = "<-.->";
      var family___3 = "-.-";
      break matchResult19;
    }
    if (((styleOpt instanceof $c_s_Some) && (styleOpt.J === "bold"))) {
      var family___1 = "==>";
      var family___2 = "<==>";
      var family___3 = "===";
      break matchResult19;
    }
    var family___1 = "-->";
    var family___2 = "<-->";
    var family___3 = "---";
  }
  return ((start && end) ? family___2 : (((!start) && (!end)) ? family___3 : family___1));
});
$p.b8R = (function(nodeId, node, connectedNodeIds) {
  var this$2 = node.fH.r(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Label$())));
  var this$3 = (this$2.c() ? $m_s_None$() : new $c_s_Some(this$2.d().m()));
  var labelOpt = ((this$3.c() || (this$3.d() !== "")) ? this$3 : $m_s_None$());
  var this$7 = node.fH.r(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$())));
  var shapeOpt = (this$7.c() ? $m_s_None$() : new $c_s_Some(this$7.d().m()));
  var hasExplicitLabel = ((!labelOpt.c()) && (labelOpt.d() !== nodeId.dE));
  var hasShape = (!shapeOpt.c());
  var hasClass = node.fH.E(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$().FV));
  var this$9 = node.fH.r(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$())));
  if ((!this$9.c())) {
    var x0$4 = this$9.d();
    var this$10 = x0$4.m();
    var hasCssStyle = ((this$10.indexOf(":") | 0) !== (-1));
  } else {
    var hasCssStyle = false;
  }
  return (((((!connectedNodeIds.E(nodeId)) || hasExplicitLabel) || hasShape) || hasClass) || hasCssStyle);
});
$p.b0s = (function(lines, graphAttributes) {
  $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().aYx(graphAttributes).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    if ((x$1 !== null)) {
      var className = x$1.g();
      var body = x$1.h();
      return lines.ei((((("  classDef " + className) + " ") + body) + "\n"));
    }
    throw new $c_s_MatchError(x$1);
  })));
});
$p.aYx = (function(graphAttributes) {
  var styleByClass = graphAttributes.DQ(new $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$3());
  var textByClass = graphAttributes.DQ(new $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$4());
  var this$2 = styleByClass.ln().dI(textByClass.ln());
  var allClassNames = $f_sc_SeqOps__sorted__s_math_Ordering__O($m_sci_Vector$().X(this$2), $m_s_math_Ordering$String$());
  $m_sci_Vector$();
  var b = new $c_sci_VectorBuilder();
  var it = allClassNames.o();
  while (it.p()) {
    var x0 = it.q();
    var merged = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().aQh(styleByClass.r(x0), textByClass.r(x0));
    b.fO((merged.c() ? $m_s_None$() : new $c_s_Some(new $c_T2(x0, merged.d()))));
  }
  return b.bY();
});
$p.b0t = (function(lines, graphAttributes) {
  var this$1 = graphAttributes.r(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$().a08));
  var this$2 = (this$1.c() ? $m_s_None$() : new $c_s_Some(this$1.d().m()));
  var defaultStyleOpt = ((this$2.c() || (this$2.d() !== "")) ? this$2 : $m_s_None$());
  var this$5 = graphAttributes.r(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$().a8J));
  var this$6 = (this$5.c() ? $m_s_None$() : new $c_s_Some(this$5.d().m()));
  var this$9 = ((this$6.c() || (this$6.d() !== "")) ? this$6 : $m_s_None$());
  var defaultInterpolateOpt = (this$9.c() ? $m_s_None$() : new $c_s_Some(("interpolate:" + this$9.d())));
  var this$10 = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().aQh(defaultStyleOpt, defaultInterpolateOpt);
  if ((!this$10.c())) {
    var x0$5 = this$10.d();
    lines.ei((("  linkStyle default " + x0$5) + "\n"));
  }
});
$p.b0u = (function(lines, sortedGroups, rootGroupId) {
  sortedGroups.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    matchResult26: {
      if ((x$1 !== null)) {
        var groupId = x$1.g();
        var group = x$1.h();
        if ((!((groupId === null) ? (rootGroupId === null) : groupId.e(rootGroupId)))) {
          var $x_1 = $m_s_Option$();
          var this$1 = group.kb.r(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$().FV));
          var this$2 = $x_1.m2((this$1.c() ? $m_s_None$() : new $c_s_Some(this$1.d().m()))).d2();
          $m_sci_Vector$();
          var b = new $c_sci_VectorBuilder();
          var it = this$2.o();
          while (it.p()) {
            var x0$1 = it.q();
            b.fO($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$().aQX(x0$1));
          }
          var classNames = b.bY();
          if ((!$f_sc_SeqOps__isEmpty__Z(classNames))) {
            lines.ei((((("  class " + $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().Ea(groupId.dR)) + " ") + $f_sc_IterableOnceOps__mkString__T__T__T__T(classNames, "", ",", "")) + "\n"));
            break matchResult26;
          } else {
            break matchResult26;
          }
        } else {
          break matchResult26;
        }
      }
      throw new $c_s_MatchError(x$1);
    }
  })));
});
$p.aQh = (function(styleBodyOpt, extraBodyOpt) {
  var this$1 = (styleBodyOpt.c() ? $m_s_None$() : new $c_s_Some($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidStyleDeclarations$().Az(styleBodyOpt.d())));
  var base = (this$1.c() ? $m_sci_VectorMap$().jg : this$1.d());
  var this$2 = (extraBodyOpt.c() ? $m_s_None$() : new $c_s_Some($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidStyleDeclarations$().Az(extraBodyOpt.d())));
  var extra = (this$2.c() ? $m_sci_VectorMap$().jg : this$2.d());
  var merged = $f_sci_StrictOptimizedMapOps__concat__sc_IterableOnce__sci_MapOps(base, extra);
  return (merged.c() ? $m_s_None$() : new $c_s_Some($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().aOl(merged)));
});
$p.y5 = (function(attrs, attrId) {
  var this$1 = attrs.r(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId(attrId));
  var this$2 = (this$1.c() ? $m_s_None$() : new $c_s_Some(this$1.d().m()));
  return ((this$2.c() || (this$2.d() !== "")) ? this$2 : $m_s_None$());
});
$p.Pe = (function(attrs, attrId) {
  var this$1 = attrs.r(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId(attrId));
  var this$2 = (this$1.c() ? $m_s_None$() : new $c_s_Some((this$1.d().m() + "px")));
  return ((this$2.c() || (this$2.d() !== "")) ? this$2 : $m_s_None$());
});
$p.a35 = (function(attrs, attrId) {
  var this$1 = attrs.r(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId(attrId));
  var this$2 = (this$1.c() ? $m_s_None$() : new $c_s_Some(this$1.d().m()));
  if (this$2.c()) {
    var $x_1 = true;
  } else {
    var x0$1 = this$2.d();
    var $x_1 = ((x0$1.indexOf(":") | 0) !== (-1));
  }
  if ($x_1) {
    var this$3 = this$2;
  } else {
    var this$3 = $m_s_None$();
  }
  var this$4 = (this$3.c() ? $m_s_None$() : new $c_s_Some($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidStyleDeclarations$().Az(this$3.d())));
  return (this$4.c() ? $m_sci_VectorMap$().jg : this$4.d());
});
$p.ah2 = (function(base, overrides) {
  var merged = overrides.hO(base, new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((x$1, x$2) => {
    var x93 = new $c_T2(x$1, x$2);
    var x95 = x93.be;
    var acc = x93.bi;
    if ((x95 !== null)) {
      var key = x95.g();
      var valueOpt = x95.h();
      var previousValue = acc.r(key);
      var x1 = (valueOpt.c() ? previousValue : valueOpt);
      if (($m_s_None$() === x1)) {
        return (previousValue.c() ? acc : (previousValue.d(), acc.ahC(key)));
      } else {
        if ((!(x1 instanceof $c_s_Some))) {
          throw new $c_s_MatchError(x1);
        }
        var nextValue = x1.J;
        return (((!previousValue.c()) && Object.is(previousValue.d(), nextValue)) ? acc : acc.AJ(key, nextValue));
      }
    }
    throw new $c_s_MatchError(x93);
  }))).bw(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    x$1$2.g();
    return ($f_T__trim__T(x$1$2.h()) !== "");
  })));
  return (merged.c() ? $m_s_None$() : new $c_s_Some($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().aOl(merged)));
});
$p.b54 = (function(node) {
  var attrs = node.fH;
  var $x_11 = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$();
  var $x_10 = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().a35(attrs, $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$()));
  var $x_9 = $m_sci_Seq$();
  var $x_8 = $m_sr_ScalaRunTime$();
  var $x_7 = new $c_T2("fill", $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().y5(attrs, $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillColor$())));
  var $x_6 = new $c_T2("stroke", $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().y5(attrs, $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Color$())));
  var $x_5 = new $c_T2("stroke-width", $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().Pe(attrs, $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_PenWidth$())));
  var $x_4 = new $c_T2("color", $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().y5(attrs, $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontColor$())));
  var $x_3 = new $c_T2("font-family", $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().y5(attrs, $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontName$())));
  var $x_2 = new $c_T2("font-size", $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().Pe(attrs, $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontSize$())));
  var this$22 = attrs.r(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$())));
  var this$23 = (this$22.c() ? $m_s_None$() : new $c_s_Some(this$22.d().m()));
  var pf = new $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$5();
  var $x_1 = new $c_T2("stroke-dasharray", ((!this$23.c()) ? new $c_s_PartialFunction$Lifted(pf).as(this$23.d()) : $m_s_None$()));
  var this$28 = attrs.r(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_InvisibleStyle$())));
  var this$29 = (this$28.c() ? $m_s_None$() : new $c_s_Some(this$28.d().m()));
  var pf$1 = new $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$6();
  return $x_11.ah2($x_10, $x_9.kM($x_8.f(new ($d_T2.r().C)([$x_7, $x_6, $x_5, $x_4, $x_3, $x_2, $x_1, new $c_T2("opacity", ((!this$29.c()) ? new $c_s_PartialFunction$Lifted(pf$1).as(this$29.d()) : $m_s_None$()))]))));
});
$p.b0l = (function(arrow) {
  var attrs = arrow.fG;
  var this$1 = attrs.r(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$().a8K));
  var this$2 = (this$1.c() ? $m_s_None$() : new $c_s_Some(this$1.d().m()));
  var this$5 = ((this$2.c() || (this$2.d() !== "")) ? this$2 : $m_s_None$());
  if (this$5.c()) {
    var this$9 = $m_s_None$();
  } else {
    var x0$2 = this$5.d();
    var this$9 = new $c_s_Some($m_sci_VectorMap$().u3($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("interpolate", x0$2)]))));
  }
  var interpolateDeclaration = (this$9.c() ? $m_sci_VectorMap$().jg : this$9.d());
  return $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().ah2($f_sci_StrictOptimizedMapOps__concat__sc_IterableOnce__sci_MapOps($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().a35(attrs, $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$().a09), $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().a35(attrs, $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$()))).hN(interpolateDeclaration), new $c_sci_$colon$colon(new $c_T2("stroke", $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().y5(attrs, $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Color$()))), new $c_sci_$colon$colon(new $c_T2("stroke-width", $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().Pe(attrs, $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_PenWidth$()))), new $c_sci_$colon$colon(new $c_T2("color", $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().y5(attrs, $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontColor$()))), new $c_sci_$colon$colon(new $c_T2("font-family", $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().y5(attrs, $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontName$()))), new $c_sci_$colon$colon(new $c_T2("font-size", $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().Pe(attrs, $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontSize$()))), $m_sci_Nil$()))))));
});
$p.b2j = (function(group) {
  var attrs = group.kb;
  var this$2 = attrs.r(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_PenColor$())));
  var this$4 = (this$2.c() ? attrs.r(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Color$()))) : this$2);
  var this$5 = (this$4.c() ? $m_s_None$() : new $c_s_Some(this$4.d().m()));
  var borderColor = ((this$5.c() || (this$5.d() !== "")) ? this$5 : $m_s_None$());
  return $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().ah2($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().a35(attrs, $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$())), new $c_sci_$colon$colon(new $c_T2("fill", $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().y5(attrs, $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillColor$()))), new $c_sci_$colon$colon(new $c_T2("stroke", borderColor), new $c_sci_$colon$colon(new $c_T2("stroke-width", $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().Pe(attrs, $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_PenWidth$()))), new $c_sci_$colon$colon(new $c_T2("color", $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().y5(attrs, $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontColor$()))), new $c_sci_$colon$colon(new $c_T2("font-family", $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().y5(attrs, $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontName$()))), new $c_sci_$colon$colon(new $c_T2("font-size", $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().Pe(attrs, $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontSize$()))), $m_sci_Nil$())))))));
});
$p.aOl = (function(declarations) {
  var this$1 = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().a8G;
  $m_sci_Vector$();
  var b = new $c_sci_VectorBuilder();
  var it = this$1.o();
  while (it.p()) {
    var x0 = it.q();
    var this$3 = declarations.r(x0);
    b.fO((this$3.c() ? $m_s_None$() : new $c_s_Some(new $c_T2(x0, this$3.d()))));
  }
  var preferred = b.bY();
  var preferredKeys = $m_sci_Set$().af($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().a8G);
  var this$8 = new $c_sc_Iterator$$anon$6(new $c_sci_VectorMap$$anon$1(declarations), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var key = x$1.g();
    x$1.h();
    return preferredKeys.E(key);
  })), true);
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(preferred.iR($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O($m_sci_Vector$().X(this$8), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$53) => _$53.g())), $m_s_math_Ordering$String$())).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    if ((x$1$2 !== null)) {
      var key$1 = x$1$2.g();
      var value = x$1$2.h();
      return ((key$1 + ":") + value);
    }
    throw new $c_s_MatchError(x$1$2);
  }))), "", ",", "");
});
$p.b9g = (function(arrows) {
  return $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(arrows.d2(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((arrow) => new $c_T4(arrow.bX.dE, arrow.c0.dE, arrow.jH, arrow.dw.l3))), new $c_s_math_Ordering$Tuple4Ordering($m_s_math_Ordering$String$(), $m_s_math_Ordering$String$(), $m_s_math_Ordering$Int$(), $m_s_math_Ordering$String$()));
});
$p.aNS = (function(label) {
  return ((((((((((((label.indexOf("\"") | 0) !== (-1)) || ((label.indexOf("[") | 0) !== (-1))) || ((label.indexOf("]") | 0) !== (-1))) || ((label.indexOf("{") | 0) !== (-1))) || ((label.indexOf("}") | 0) !== (-1))) || ((label.indexOf("(") | 0) !== (-1))) || ((label.indexOf(")") | 0) !== (-1))) || ((label.indexOf("|") | 0) !== (-1))) || ((label.indexOf("<") | 0) !== (-1))) || ((label.indexOf(">") | 0) !== (-1))) ? (("\"" + label.split("\"").join("#quot;")) + "\"") : label);
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$, "org.jpablo.graphexplorer.viewer.backends.mermaid.FromViewerGraph$package$", ({
  xJ: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$() {
  this.a0a = null;
  this.BV = null;
  this.BW = null;
  this.FV = null;
  this.a08 = null;
  this.a8J = null;
  this.a09 = null;
  this.a8K = null;
  this.avS = null;
  this.avR = null;
  this.a0a = "gx-shape-";
  this.BV = "mermaid_classDef_";
  this.BW = "mermaid_classDefText_";
  this.FV = "mermaid_class";
  this.a08 = "mermaid_linkStyle_default";
  this.a8J = "mermaid_linkInterpolate_default";
  this.a09 = "mermaid_edgeStyle";
  this.a8K = "mermaid_edgeInterpolate";
  this.avS = "mermaid_edgeType";
  this.avR = "mermaid_domId";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$.prototype = $p;
$p.aQX = (function(value) {
  var this$1 = $m_s_Predef$().fB($f_T__split__T__I__AT(value, "[,\\s]+", 0));
  return $m_sci_Vector$().X(this$1).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => $f_T__trim__T(_$1)))).bw(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => (_$2 !== ""))));
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$, "org.jpablo.graphexplorer.viewer.backends.mermaid.MermaidAttrKeys$", ({
  xQ: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$;
function $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$ = new $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__windowDyn__sjs_js_Dynamic($thiz) {
  return window;
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__isInitialized__Z($thiz) {
  return ((!($p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__windowDyn__sjs_js_Dynamic($thiz).__mermaidInitialized === (void 0))) && (!(!$p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__windowDyn__sjs_js_Dynamic($thiz).__mermaidInitialized)));
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__setInitialized__V($thiz) {
  $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__windowDyn__sjs_js_Dynamic($thiz).__mermaidInitialized = true;
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__withTimeout__s_concurrent_Future__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, f, x$2) {
  var p = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
  var handle = $m_sjs_js_timers_package$().ym($thiz.a8L, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_s_concurrent_Promise__tryFailure__jl_Throwable__Z(p, $ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), (("[mermaid] operation did not settle within " + $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$().a8L) + "ms")));
  })));
  f.XC(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((result) => {
    $m_sjs_js_timers_package$().IH(handle);
    return p.El(result);
  })), x$2);
  return p;
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__fixViewBoxCase__Lorg_scalajs_dom_SVGSVGElement__V($thiz, svg) {
  if (((!(!(!svg.hasAttribute("viewBox")))) && (!(!svg.hasAttribute("viewbox"))))) {
    svg.setAttribute("viewBox", svg.getAttribute("viewbox"));
    svg.removeAttribute("viewbox");
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__enforceInlineStylePrecedence__Lorg_scalajs_dom_SVGSVGElement__V($thiz, svg) {
  var nodes = svg.querySelectorAll("g.node > rect[style], g.cluster > rect[style], path.flowchart-link[style]");
  var end = (nodes.length | 0);
  var isEmpty = (end <= 0);
  var scala$collection$immutable$Range$$lastElement = ((end - 1) | 0);
  if ((!isEmpty)) {
    var i = 0;
    while (true) {
      var x0 = i;
      var this$5 = $m_s_Option$().as(nodes.item(x0));
      if ((!this$5.c())) {
        var x0$1 = this$5.d();
        var this$6 = $m_s_Option$().as(x0$1.getAttribute("style"));
        var this$9 = ((this$6.c() || (this$6.d() !== "")) ? this$6 : $m_s_None$());
        if ((!this$9.c())) {
          var x0$3 = this$9.d();
          var normalized = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$().aTu(x0$3);
          if ((normalized !== "")) {
            x0$1.setAttribute("style", normalized);
          }
        }
      }
      if ((i === scala$collection$immutable$Range$$lastElement)) {
        break;
      }
      i = ((1 + i) | 0);
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__applyNodeInlineTextStyles__Lorg_scalajs_dom_SVGSVGElement__V($thiz, svg) {
  var classSpanFontSizes = $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__extractClassSpanFontSizes__Lorg_scalajs_dom_SVGSVGElement__sci_Map($thiz, svg);
  var nodes = svg.querySelectorAll("g.node");
  var end = (nodes.length | 0);
  var isEmpty = (end <= 0);
  var scala$collection$immutable$Range$$lastElement = ((end - 1) | 0);
  if ((!isEmpty)) {
    var i = 0;
    while (true) {
      var x0 = i;
      var this$5 = $m_s_Option$().as(nodes.item(x0));
      if ((!this$5.c())) {
        var x0$1 = this$5.d();
        var baseFontPx = $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__resolveNodeBaseFontSize__Lorg_scalajs_dom_Element__sci_Map__s_Option($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$(), x0$1, classSpanFontSizes);
        var this$6 = $m_s_Option$().as(x0$1.querySelector("rect[style]"));
        if (this$6.c()) {
          var $x_1 = $m_s_None$();
        } else {
          var x0$2 = this$6.d();
          var $x_1 = $m_s_Option$().as(x0$2.getAttribute("style"));
        }
        var this$7 = $x_1;
        if (this$7.c()) {
          var this$8 = $m_s_None$();
        } else {
          var x0$3 = this$7.d();
          var this$8 = new $c_s_Some($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$().b16(x0$3));
        }
        var this$9 = ((this$8.c() || (!this$8.d().c())) ? this$8 : $m_s_None$());
        if ((!this$9.c())) {
          var x0$5 = this$9.d();
          _return$1: {
            var these = x0$5;
            while ((!these.c())) {
              var x0$6 = these.t();
              var x = x0$6.g();
              if (((x !== null) && $dp_equals__O__Z(x, "font-size"))) {
                var this$10 = new $c_s_Some(these.t());
                break _return$1;
              }
              these = these.v();
            }
            var this$10 = $m_s_None$();
          }
          if (this$10.c()) {
            var targetFontPx = $m_s_None$();
          } else {
            var x0$7 = this$10.d();
            matchResult13: {
              var targetFontPx;
              if ((x0$7 !== null)) {
                var value = x0$7.h();
                var targetFontPx = $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__parsePx__T__s_Option($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$(), value);
                break matchResult13;
              }
              throw new $c_s_MatchError(x0$7);
            }
          }
          var f = ((x$1$2) => {
            if ((x$1$2 !== null)) {
              var k = x$1$2.g();
              var v = x$1$2.h();
              return ((k + ":") + v);
            }
            throw new $c_s_MatchError(x$1$2);
          });
          if ((x0$5 === $m_sci_Nil$())) {
            var $x_2 = $m_sci_Nil$();
          } else {
            var x0$8 = x0$5.t();
            var h = new $c_sci_$colon$colon(f(x0$8), $m_sci_Nil$());
            var t = h;
            var rest = x0$5.v();
            while ((rest !== $m_sci_Nil$())) {
              var x0$9 = rest.t();
              var nx = new $c_sci_$colon$colon(f(x0$9), $m_sci_Nil$());
              t.U = nx;
              t = nx;
              rest = rest.v();
            }
            var $x_2 = h;
          }
          var appendedStyle = $f_sc_IterableOnceOps__mkString__T__T__T__T($x_2, "", ";", "");
          var labels = x0$1.querySelectorAll("g.label span, g.label text, g.label tspan");
          var end$1 = (labels.length | 0);
          var isEmpty$1 = (end$1 <= 0);
          var scala$collection$immutable$Range$$lastElement$1 = ((end$1 - 1) | 0);
          if ((!isEmpty$1)) {
            var i$1 = 0;
            while (true) {
              var x0$10 = i$1;
              var this$16 = $m_s_Option$().as(labels.item(x0$10));
              if ((!this$16.c())) {
                var x0$11 = this$16.d();
                matchResult15: {
                  var merged;
                  var this$17 = $m_s_Option$().as(x0$11.getAttribute("style"));
                  var x28 = ((this$17.c() || (this$17.d() !== "")) ? this$17 : $m_s_None$());
                  if ((x28 instanceof $c_s_Some)) {
                    var merged = ((x28.J + ";") + appendedStyle);
                    break matchResult15;
                  }
                  if (($m_s_None$() === x28)) {
                    var merged = appendedStyle;
                    break matchResult15;
                  }
                  throw new $c_s_MatchError(x28);
                }
                var normalized = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$().aTu(merged);
                if ((normalized !== "")) {
                  x0$11.setAttribute("style", normalized);
                }
              }
              if ((i$1 === scala$collection$immutable$Range$$lastElement$1)) {
                break;
              }
              i$1 = ((1 + i$1) | 0);
            }
          }
          if (baseFontPx.c()) {
            var scaleFactor = $m_s_None$();
          } else {
            var x0$13 = baseFontPx.d();
            var from = (+x0$13);
            var this$22 = new $c_s_Option$WithFilter(targetFontPx, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((from) => ((to) => {
              var to$1 = (+to);
              return ((from > 0.0) && (to$1 > from));
            }))(from)));
            var this$23 = this$22.tu;
            var p$1 = this$22.tv;
            var this$24 = ((this$23.c() || (!(!p$1.i(this$23.d())))) ? this$23 : $m_s_None$());
            var scaleFactor = (this$24.c() ? $m_s_None$() : new $c_s_Some(((+this$24.d()) / from)));
          }
          if ((!scaleFactor.c())) {
            var x0$15 = scaleFactor.d();
            var scale = (+x0$15);
            $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__expandNodeLabelBox__Lorg_scalajs_dom_Element__D__V($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$(), x0$1, scale);
          }
        }
      }
      if ((i === scala$collection$immutable$Range$$lastElement)) {
        break;
      }
      i = ((1 + i) | 0);
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__extractClassSpanFontSizes__Lorg_scalajs_dom_SVGSVGElement__sci_Map($thiz, svg) {
  var this$1 = $m_s_Option$().as(svg.querySelector("style"));
  if (this$1.c()) {
    var $x_1 = $m_s_None$();
  } else {
    var x0 = this$1.d();
    var $x_1 = $m_s_Option$().as(x0.textContent);
  }
  var this$2 = $x_1;
  var cssText = (this$2.c() ? "" : this$2.d());
  var classRulePattern = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "\\.([A-Za-z0-9_-]+)\\s+span\\s*\\{([^}]*)\\}", $m_sci_Nil$());
  var this$9 = classRulePattern.afQ(cssText);
  var z = $m_sci_Map$EmptyMap$();
  var f = ((acc, m) => {
    var className = $f_s_util_matching_Regex$MatchData__group__I__T(m, 1);
    var body = $f_s_util_matching_Regex$MatchData__group__I__T(m, 2);
    var this$6 = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$().aOa(body, "font-size");
    if (this$6.c()) {
      var fontSize = $m_s_None$();
    } else {
      var x0$1 = this$6.d();
      var fontSize = $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__parsePx__T__s_Option($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$(), x0$1);
    }
    if ((fontSize instanceof $c_s_Some)) {
      return acc.bN(className, (+fontSize.J));
    }
    if (($m_s_None$() === fontSize)) {
      return acc;
    }
    throw new $c_s_MatchError(fontSize);
  });
  if ($is_sc_IndexedSeq(this$9)) {
    var at = 0;
    var end = this$9.C();
    var acc$1 = z;
    var $x_2;
    while (true) {
      if ((at !== end)) {
        var temp$at = ((1 + at) | 0);
        var x0$2 = acc$1;
        var x1 = this$9.l(at);
        var temp$acc = f(x0$2, x1);
        at = temp$at;
        acc$1 = temp$acc;
        continue;
      }
      var $x_2 = acc$1;
      break;
    }
  } else {
    var result = z;
    while (this$9.p()) {
      var x0$3 = result;
      var x1$1 = this$9.q();
      result = f(x0$3, x1$1);
    }
    var $x_2 = result;
  }
  return $x_2;
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__resolveNodeBaseFontSize__Lorg_scalajs_dom_Element__sci_Map__s_Option($thiz, node, classSpanFontSizes) {
  var this$1 = $m_s_Option$().as(node.getAttribute("class")).bM();
  var rest = this$1;
  var h = null;
  var t = null;
  while ((rest !== $m_sci_Nil$())) {
    var it = $ct_sc_ArrayOps$ArrayIterator__O__(new $c_sc_ArrayOps$ArrayIterator(), $m_s_Predef$().fB($f_T__split__T__I__AT(rest.t(), "\\s+", 0)).tK);
    while (it.p()) {
      var nx = new $c_sci_$colon$colon(it.q(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        t.U = nx;
      }
      t = nx;
    }
    rest = rest.v();
  }
  var this$5 = ((h === null) ? $m_sci_Nil$() : h);
  var f = ((_$23) => (_$23 !== ""));
  var l = this$5;
  block: {
    var result;
    while (true) {
      if (l.c()) {
        var result = $m_sci_Nil$();
        break;
      } else {
        var h$1 = l.t();
        var t$1 = l.v();
        if ((!(!(!f(h$1))))) {
          l = t$1;
          continue;
        }
        var start = l;
        var remaining = t$1;
        while (true) {
          if (remaining.c()) {
            var result = start;
            break block;
          } else {
            var x = remaining.t();
            if ((!(!f(x)))) {
              remaining = remaining.v();
              continue;
            }
            var firstMiss = remaining;
            var newHead = new $c_sci_$colon$colon(start.t(), $m_sci_Nil$());
            var toProcess = start.v();
            var currentLast = newHead;
            while ((toProcess !== firstMiss)) {
              var newElem = new $c_sci_$colon$colon(toProcess.t(), $m_sci_Nil$());
              currentLast.U = newElem;
              currentLast = newElem;
              toProcess = toProcess.v();
            }
            var next = firstMiss.v();
            var nextToCopy = next;
            while ((!next.c())) {
              var head = next.t();
              if ((!(!f(head)))) {
                next = next.v();
              } else {
                while ((nextToCopy !== next)) {
                  var newElem$2 = new $c_sci_$colon$colon(nextToCopy.t(), $m_sci_Nil$());
                  currentLast.U = newElem$2;
                  currentLast = newElem$2;
                  nextToCopy = nextToCopy.v();
                }
                nextToCopy = next.v();
                next = next.v();
              }
            }
            if ((!nextToCopy.c())) {
              currentLast.U = nextToCopy;
            }
            var result = newHead;
            break block;
          }
        }
      }
    }
  }
  var z = $m_s_None$();
  var acc = z;
  var these = result;
  while ((!these.c())) {
    var x0$1 = acc;
    var x1 = these.t();
    var this$7 = classSpanFontSizes.r(x1);
    acc = (this$7.c() ? x0$1 : this$7);
    these = these.v();
  }
  var fromClasses = acc;
  var this$8 = (fromClasses.c() ? classSpanFontSizes.r("default") : fromClasses);
  return (this$8.c() ? new $c_s_Some(16.0) : this$8);
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__normalizeEdgeMarkers__Lorg_scalajs_dom_SVGSVGElement__s_Option__V($thiz, svg, defaultEdgeMarkerColor) {
  var edges = svg.querySelectorAll("path.flowchart-link");
  var end = (edges.length | 0);
  var isEmpty = (end <= 0);
  var scala$collection$immutable$Range$$lastElement = ((end - 1) | 0);
  if ((!isEmpty)) {
    var i = 0;
    while (true) {
      var x0 = i;
      matchResult19: {
        var x40 = edges.item(x0);
        if ((!(!(x40 instanceof SVGPathElement)))) {
          var this$5 = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$().avT;
          var these = this$5;
          while ((!these.c())) {
            var x0$1 = these.t();
            var this$6 = $m_s_Option$().as(x40.getAttribute(x0$1));
            if (this$6.c()) {
              var $x_1 = $m_s_None$();
            } else {
              var x0$2 = this$6.d();
              var $x_1 = $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__extractMarkerId__T__s_Option($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$(), x0$2);
            }
            var this$7 = $x_1;
            if (this$7.c()) {
              var $x_2 = $m_s_None$();
            } else {
              var x0$3 = this$7.d();
              var this$8 = $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__markerColorForPath__Lorg_scalajs_dom_SVGPathElement__s_Option__s_Option($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$(), x40, defaultEdgeMarkerColor);
              if (this$8.c()) {
                var $x_2 = $m_s_None$();
              } else {
                var x0$4 = this$8.d();
                var $x_2 = $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__ensureColoredMarker__Lorg_scalajs_dom_SVGSVGElement__T__T__s_Option($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$(), svg, x0$3, x0$4);
              }
            }
            var this$9 = $x_2;
            if ((!this$9.c())) {
              var x0$5 = this$9.d();
              x40.setAttribute(x0$1, (("url(#" + x0$5) + ")"));
            }
            these = these.v();
          }
          break matchResult19;
        }
      }
      if ((i === scala$collection$immutable$Range$$lastElement)) {
        break;
      }
      i = ((1 + i) | 0);
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__markerColorForPath__Lorg_scalajs_dom_SVGPathElement__s_Option__s_Option($thiz, path, defaultEdgeMarkerColor) {
  if (defaultEdgeMarkerColor.c()) {
    var this$1 = $m_s_Option$().as(path.getAttribute("style"));
    if (this$1.c()) {
      var $x_2 = $m_s_None$();
    } else {
      var x0 = this$1.d();
      var $x_2 = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$().aOa(x0, "stroke");
    }
    var this$2 = $x_2;
    if (this$2.c()) {
      var $x_1 = $m_s_None$();
    } else {
      var x0$1 = this$2.d();
      var $x_1 = $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__normalizeCssValue__T__s_Option($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$(), x0$1);
    }
  } else {
    var $x_1 = defaultEdgeMarkerColor;
  }
  var this$3 = $x_1;
  if (this$3.c()) {
    var this$4 = $m_s_Option$().as(path.getAttribute("stroke"));
    if (this$4.c()) {
      return $m_s_None$();
    } else {
      var x0$2 = this$4.d();
      return $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__normalizeCssValue__T__s_Option($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$(), x0$2);
    }
  } else {
    return this$3;
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__cssDeclarations__T__sci_List($thiz, styleText) {
  return $m_sci_Nil$().b6(new $c_sc_Iterator$$anon$10(new $c_sc_Iterator$$anon$6(new $c_sc_Iterator$$anon$9($m_sc_ArrayOps$().u8($m_sc_StringOps$().Ej(styleText, 59)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$26) => $f_T__trim__T(_$26)))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$27) => (_$27 !== ""))), false), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((declaration) => {
    var separator = $f_T__indexOf__I__I(declaration, 58);
    if ((separator < 0)) {
      return $m_s_None$();
    } else {
      var this$8 = $f_T__trim__T(declaration.substring(0, separator));
      var declKey = this$8.toLowerCase();
      var beginIndex = ((1 + separator) | 0);
      var value = $f_T__trim__T(declaration.substring(beginIndex));
      return (((declKey !== "") && (value !== "")) ? new $c_s_Some(new $c_T2(declKey, value)) : $m_s_None$());
    }
  }))));
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__ensureColoredMarker__Lorg_scalajs_dom_SVGSVGElement__T__T__s_Option($thiz, svg, markerId, color) {
  var suffix = $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__markerColorSuffix__T__T($thiz, color);
  var coloredMarkerId = ((markerId + "__") + suffix);
  var x48 = $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__queryById__Lorg_scalajs_dom_SVGSVGElement__T__s_Option($thiz, svg, coloredMarkerId);
  if ((x48 instanceof $c_s_Some)) {
    return new $c_s_Some(coloredMarkerId);
  }
  if (($m_s_None$() === x48)) {
    var this$2 = $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__queryById__Lorg_scalajs_dom_SVGSVGElement__T__s_Option($thiz, svg, markerId);
    if (this$2.c()) {
      return $m_s_None$();
    } else {
      var x0 = this$2.d();
      var markerParent = x0.parentNode;
      if ((markerParent === null)) {
        return $m_s_None$();
      } else {
        var clonedMarker = x0.cloneNode(true);
        clonedMarker.setAttribute("id", coloredMarkerId);
        $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__colorizeMarkerContent__Lorg_scalajs_dom_Element__T__V($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$(), clonedMarker, color);
        markerParent.appendChild(clonedMarker);
        return new $c_s_Some(coloredMarkerId);
      }
    }
  }
  throw new $c_s_MatchError(x48);
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__colorizeMarkerContent__Lorg_scalajs_dom_Element__T__V($thiz, marker, color) {
  var shapes = marker.querySelectorAll("path, polygon, polyline");
  if (((shapes.length | 0) === 0)) {
    var this$1 = $m_s_Option$().as(marker.querySelector("*"));
    if ((!this$1.c())) {
      var x0 = this$1.d();
      $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__setMarkerShapeColor__Lorg_scalajs_dom_Element__T__V($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$(), x0, color);
    }
  } else {
    var end = (shapes.length | 0);
    var isEmpty = (end <= 0);
    var scala$collection$immutable$Range$$lastElement = ((end - 1) | 0);
    if ((!isEmpty)) {
      var i = 0;
      while (true) {
        var x0$1 = i;
        var this$6 = $m_s_Option$().as(shapes.item(x0$1));
        if ((!this$6.c())) {
          var x0$2 = this$6.d();
          $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__setMarkerShapeColor__Lorg_scalajs_dom_Element__T__V($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$(), x0$2, color);
        }
        if ((i === scala$collection$immutable$Range$$lastElement)) {
          break;
        }
        i = ((1 + i) | 0);
      }
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__setMarkerShapeColor__Lorg_scalajs_dom_Element__T__V($thiz, shape, color) {
  shape.setAttribute("fill", color);
  shape.setAttribute("stroke", color);
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__markerColorSuffix__T__T($thiz, color) {
  var this$1 = $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__normalizeCssValue__T__s_Option($thiz, color);
  var this$3 = (this$1.c() ? $m_s_None$() : new $c_s_Some($m_sc_StringOps$().wg(this$1.d(), "#")));
  return $f_T__replaceAll__T__T__T((this$3.c() ? "marker" : this$3.d()), "[^A-Za-z0-9_-]", "_");
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__extractMarkerId__T__s_Option($thiz, markerUrl) {
  if ((((!(!markerUrl.startsWith("url(#"))) && (!(!markerUrl.endsWith(")")))) && (markerUrl.length > 6))) {
    var endIndex = ((markerUrl.length - 1) | 0);
    return new $c_s_Some(markerUrl.substring(5, endIndex));
  } else {
    return $m_s_None$();
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__queryById__Lorg_scalajs_dom_SVGSVGElement__T__s_Option($thiz, svg, id) {
  var this$1 = id.split("\\").join("\\\\");
  var escaped = this$1.split("\"").join("\\\"");
  return $m_s_Option$().as(svg.querySelector((("[id=\"" + escaped) + "\"]")));
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__normalizeCssValue__T__s_Option($thiz, value) {
  var this$1 = $m_s_Option$().as($f_T__trim__T(value.split("!important").join("")));
  return ((this$1.c() || (this$1.d() !== "")) ? this$1 : $m_s_None$());
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__parsePx__T__s_Option($thiz, value) {
  var this$1 = $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__normalizeCssValue__T__s_Option($thiz, value);
  if (this$1.c()) {
    return $m_s_None$();
  } else {
    var x0 = this$1.d();
    var withoutPx = $m_sc_StringOps$().wh(x0, "px");
    return ($m_sc_StringParsers$().c1(withoutPx) ? new $c_s_Some($m_jl_Double$().bd(withoutPx)) : $m_s_None$());
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__expandNodeLabelBox__Lorg_scalajs_dom_Element__D__V($thiz, node, scaleFactor) {
  if ((!(scaleFactor <= 1.0))) {
    var this$1 = $m_s_Option$().as(node.querySelector("rect.basic.label-container"));
    if ((!this$1.c())) {
      var x0 = this$1.d();
      $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__scaleCenteredAttribute__Lorg_scalajs_dom_Element__T__T__D__V($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$(), x0, "width", "x", scaleFactor);
    }
    var this$2 = $m_s_Option$().as(node.querySelector("g.label foreignObject"));
    if ((!this$2.c())) {
      var x0$1 = this$2.d();
      $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__scaleCenteredAttribute__Lorg_scalajs_dom_Element__T__T__D__V($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$(), x0$1, "width", "x", scaleFactor);
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__scaleCenteredAttribute__Lorg_scalajs_dom_Element__T__T__D__V($thiz, elem, sizeAttr, centerAttr, scaleFactor) {
  var this$1 = $m_s_Option$().as(elem.getAttribute(sizeAttr));
  if (this$1.c()) {
    var this$5 = $m_s_None$();
  } else {
    var x0 = this$1.d();
    var this$5 = ($m_sc_StringParsers$().c1(x0) ? new $c_s_Some($m_jl_Double$().bd(x0)) : $m_s_None$());
  }
  if ((!this$5.c())) {
    var x0$1 = this$5.d();
    var currentSize = (+x0$1);
    var newSize = (currentSize * scaleFactor);
    elem.setAttribute(sizeAttr, ("" + newSize));
    var this$7 = $m_s_Option$().as(elem.getAttribute(centerAttr));
    if (this$7.c()) {
      var this$11 = $m_s_None$();
    } else {
      var x0$2 = this$7.d();
      var this$11 = ($m_sc_StringParsers$().c1(x0$2) ? new $c_s_Some($m_jl_Double$().bd(x0$2)) : $m_s_None$());
    }
    var currentCenter = (+(this$11.c() ? 0.0 : this$11.d()));
    var delta = (newSize - currentSize);
    elem.setAttribute(centerAttr, ("" + (currentCenter - (0.5 * delta))));
  }
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$() {
  this.avV = null;
  this.a8M = null;
  this.avT = null;
  this.avU = null;
  this.a8L = 0;
  $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$ = this;
  this.avV = new $c_ju_concurrent_atomic_AtomicInteger(0);
  this.a8M = $m_s_concurrent_Future$().m4((void 0));
  this.avT = new $c_sci_$colon$colon("marker-start", new $c_sci_$colon$colon("marker-end", $m_sci_Nil$()));
  this.avU = $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_T.r().C)(["color", "font-size", "font-family", "font-weight", "font-style"])));
  this.a8L = 15000;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$.prototype = $p;
$p.aPC = (function(raw) {
  return (((!(raw.entries === (void 0))) && ((typeof raw.entries) === "function")) ? Object.fromEntries(raw) : raw);
});
$p.aNV = (function(phase, error, source) {
  var raw = ((("Mermaid " + phase) + " failed: ") + error);
  var this$1 = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$().b10(source);
  return (this$1.c() ? raw : ((this$1.d() + "\n\n") + raw));
});
$p.aNJ = (function() {
  if ((!$p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__isInitialized__Z(this))) {
    $i_mermaid.default.initialize($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidConfig$().aXe(false, "loose", "default", true, $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FlowchartConfig$().aXi(true, (void 0), (void 0), (void 0), false)));
    $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__setInitialized__V(this);
    console.info("[mermaid] Mermaid.js initialized");
  }
});
$p.aQL = (function(op, x$2) {
  var previous = this.a8M.AC(new $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$$anon$3(), x$2);
  var next = previous.IX(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$13) => $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__withTimeout__s_concurrent_Future__s_concurrent_ExecutionContext__s_concurrent_Future($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$(), $m_s_util_Try$().aM9(op).kO(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((exception) => $m_s_concurrent_Future$().WL(exception))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x) => x))), x$2))), x$2);
  this.a8M = next.jX(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$14) => (void 0))), x$2).AC(new $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$$anon$4(), x$2);
  return next;
});
$p.aP5 = (function(yy) {
  var vertices = yy.getVertices;
  return ((vertices !== (void 0)) && ((typeof vertices) === "function"));
});
$p.b8n = (function(diagram) {
  var x = diagram.db;
  var this$6 = ((x === (void 0)) ? $m_s_None$() : new $c_s_Some(x));
  if (this$6.c()) {
    var $x_1 = true;
  } else {
    var x0 = this$6.d();
    var $x_1 = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$().aP5(x0);
  }
  if ($x_1) {
    var this$7 = this$6;
  } else {
    var this$7 = $m_s_None$();
  }
  if (this$7.c()) {
    var x$1 = diagram.parser;
    var this$13 = ((x$1 === (void 0)) ? $m_s_None$() : new $c_s_Some(x$1));
    if (this$13.c()) {
      return $m_s_None$();
    } else {
      var x0$1 = this$13.d();
      var x$2 = x0$1.yy;
      var this$19 = ((x$2 === (void 0)) ? $m_s_None$() : new $c_s_Some(x$2));
      if (this$19.c()) {
        var $x_2 = true;
      } else {
        var x0$2 = this$19.d();
        var $x_2 = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$().aP5(x0$2);
      }
      if ($x_2) {
        return this$19;
      } else {
        return $m_s_None$();
      }
    }
  } else {
    return this$7;
  }
});
$p.b59 = (function(svg, defaultEdgeMarkerColor) {
  $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__fixViewBoxCase__Lorg_scalajs_dom_SVGSVGElement__V(this, svg);
  $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__normalizeEdgeMarkers__Lorg_scalajs_dom_SVGSVGElement__s_Option__V(this, svg, defaultEdgeMarkerColor);
  $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__enforceInlineStylePrecedence__Lorg_scalajs_dom_SVGSVGElement__V(this, svg);
  $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__applyNodeInlineTextStyles__Lorg_scalajs_dom_SVGSVGElement__V(this, svg);
});
$p.aZB = (function(svgString) {
  return ((((svgString.indexOf("xlink:") | 0) !== (-1)) && ((svgString.indexOf("xmlns:xlink") | 0) === (-1))) ? $f_T__replaceFirst__T__T__T(svgString, "<svg", "<svg xmlns:xlink=\"http://www.w3.org/1999/xlink\"") : svgString);
});
$p.aeD = (function(svg) {
  $m_Lorg_jpablo_graphexplorer_viewer_domUtils_QuerySelector$package$().m3(svg, "path.flowchart-link").F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((p) => {
    var hit = $m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().aP9(p);
    hit.removeAttribute("marker-start");
    hit.removeAttribute("marker-end");
    hit.setAttribute("data-edge-id", p.id);
    var this$1 = $m_s_Option$().as(p.getAttribute("class"));
    hit.setAttribute("class", $f_T__trim__T((((this$1.c() ? "" : this$1.d()) + " ") + $m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().xa)));
    return p.parentNode.insertBefore(hit, p);
  })));
  $m_Lorg_jpablo_graphexplorer_viewer_domUtils_QuerySelector$package$().m3(svg, ".edgeLabel g.label[data-id]").F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((label) => {
    var this$2 = $m_s_Option$().as(label.getAttribute("data-id"));
    var edgeId = (this$2.c() ? "" : this$2.d());
    var this$3 = $m_s_Option$().as(label.querySelector("foreignObject"));
    if ((!this$3.c())) {
      var x0 = this$3.d();
      var this$4 = $m_s_Option$().as(x0.getAttribute("width"));
      var w = (this$4.c() ? "0" : this$4.d());
      var this$5 = $m_s_Option$().as(x0.getAttribute("height"));
      var h = (this$5.c() ? "0" : this$5.d());
      if ((edgeId !== "")) {
        var this$10 = $m_sc_StringParsers$();
        var this$11 = (this$10.c1(w) ? new $c_s_Some($m_jl_Double$().bd(w)) : $m_s_None$());
        var $x_1 = ((!this$11.c()) && ((+this$11.d()) > 0.0));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        var hit$1 = document.createElementNS("http://www.w3.org/2000/svg", "rect");
        hit$1.setAttribute("width", w);
        hit$1.setAttribute("height", h);
        hit$1.setAttribute("data-edge-id", edgeId);
        hit$1.setAttribute("class", (($m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().a0u + " ") + $m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().xa));
        hit$1.setAttribute("style", "fill:transparent;pointer-events:all;cursor:pointer");
        label.appendChild(hit$1);
      }
    }
  })));
});
$p.aTu = (function(styleText) {
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(new $c_sc_Iterator$$anon$9(new $c_sc_Iterator$$anon$6(new $c_sc_Iterator$$anon$9($m_sc_ArrayOps$().u8($m_sc_StringOps$().Ej(styleText, 59)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$17) => $f_T__trim__T(_$17)))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$18) => (_$18 !== ""))), false), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((declaration) => {
    var separator = $f_T__indexOf__I__I(declaration, 58);
    if ((separator < 0)) {
      return declaration;
    } else {
      var key = $f_T__trim__T(declaration.substring(0, separator));
      var beginIndex = ((1 + separator) | 0);
      var value = $f_T__trim__T(declaration.substring(beginIndex));
      var this$10 = value.toLowerCase();
      if (((this$10.indexOf("!important") | 0) !== (-1))) {
        var normalizedValue = value;
      } else {
        var normalizedValue = (value + " !important");
      }
      return ((key + ":") + normalizedValue);
    }
  }))), "", ";", "");
});
$p.b16 = (function(styleText) {
  var declarations = $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__cssDeclarations__T__sci_List(this, styleText);
  var f = ((x$1) => {
    if ((x$1 !== null)) {
      var key = x$1.g();
      return $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$().avU.E(key);
    }
    throw new $c_s_MatchError(x$1);
  });
  var l = declarations;
  block: {
    var result;
    while (true) {
      if (l.c()) {
        var result = $m_sci_Nil$();
        break;
      } else {
        var h = l.t();
        var t = l.v();
        if ((!(!(!f(h))))) {
          l = t;
          continue;
        }
        var start = l;
        var remaining = t;
        while (true) {
          if (remaining.c()) {
            var result = start;
            break block;
          } else {
            var x = remaining.t();
            if ((!(!f(x)))) {
              remaining = remaining.v();
              continue;
            }
            var firstMiss = remaining;
            var newHead = new $c_sci_$colon$colon(start.t(), $m_sci_Nil$());
            var toProcess = start.v();
            var currentLast = newHead;
            while ((toProcess !== firstMiss)) {
              var newElem = new $c_sci_$colon$colon(toProcess.t(), $m_sci_Nil$());
              currentLast.U = newElem;
              currentLast = newElem;
              toProcess = toProcess.v();
            }
            var next = firstMiss.v();
            var nextToCopy = next;
            while ((!next.c())) {
              var head = next.t();
              if ((!(!f(head)))) {
                next = next.v();
              } else {
                while ((nextToCopy !== next)) {
                  var newElem$2 = new $c_sci_$colon$colon(nextToCopy.t(), $m_sci_Nil$());
                  currentLast.U = newElem$2;
                  currentLast = newElem$2;
                  nextToCopy = nextToCopy.v();
                }
                nextToCopy = next.v();
                next = next.v();
              }
            }
            if ((!nextToCopy.c())) {
              currentLast.U = nextToCopy;
            }
            var result = newHead;
            break block;
          }
        }
      }
    }
  }
  _return: {
    var these = result;
    while ((!these.c())) {
      var x0 = these.t();
      var x$2 = x0.g();
      if (((x$2 !== null) && $dp_equals__O__Z(x$2, "color"))) {
        var this$1 = new $c_s_Some(these.t());
        break _return;
      }
      these = these.v();
    }
    var this$1 = $m_s_None$();
  }
  var this$2 = (this$1.c() ? $m_s_None$() : new $c_s_Some(this$1.d().h()));
  if (this$2.c()) {
    return result;
  } else {
    var x0$2 = this$2.d();
    _return$1: {
      var these$1 = result;
      while ((!these$1.c())) {
        var x0$3 = these$1.t();
        matchResult18: {
          var $x_2;
          if ((x0$3 !== null)) {
            var $x_2 = (x0$3.g() === "fill");
            break matchResult18;
          }
          throw new $c_s_MatchError(x0$3);
        }
        if ($x_2) {
          var $x_1 = true;
          break _return$1;
        }
        these$1 = these$1.v();
      }
      var $x_1 = false;
    }
    if ($x_1) {
      return result;
    } else {
      return $f_sc_StrictOptimizedSeqOps__appended__O__O(result, new $c_T2("fill", x0$2));
    }
  }
});
$p.aOa = (function(styleText, key) {
  var this$1 = $f_T__trim__T(key);
  var target = this$1.toLowerCase();
  return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option($p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__cssDeclarations__T__sci_List(this, styleText), new $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$$anon$5(target));
});
$p.b13 = (function(text) {
  var this$5 = new $c_sc_StringOps$$anon$1(text, true);
  var z = $m_s_None$();
  var result = z;
  while ((this$5.kd < this$5.zV)) {
    var x0 = result;
    var x1 = this$5.wa();
    var line = $f_T__trim__T(x1);
    if ((!(!line.startsWith("linkStyle default ")))) {
      var declarations = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidStyleDeclarations$().Az($m_sc_StringOps$().kp(line, 18));
      var this$7 = declarations.r("stroke");
      var this$8 = (this$7.c() ? declarations.r("color") : this$7);
      if (this$8.c()) {
        var $x_1 = $m_s_None$();
      } else {
        var x0$1 = this$8.d();
        var $x_1 = $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$__normalizeCssValue__T__s_Option($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$(), x0$1);
      }
      var this$9 = $x_1;
      result = (this$9.c() ? x0 : this$9);
    } else {
      result = x0;
    }
  }
  return result;
});
$p.b52 = (function() {
  var this$1 = this.avV;
  var newValue = ((1 + this$1.Zy) | 0);
  this$1.Zy = newValue;
  return ("mermaid-render-" + newValue);
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$, "org.jpablo.graphexplorer.viewer.backends.mermaid.MermaidBackend$", ({
  xS: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$;
function $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$ = new $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassAssignmentFallback$__splitCsv__T__sci_List($thiz, value) {
  var this$4 = $m_sci_Nil$().b6($m_s_Predef$().fB($m_sc_StringOps$().Ej(value, 44)));
  var f = ((_$3) => $f_T__trim__T(_$3));
  if ((this$4 === $m_sci_Nil$())) {
    var this$7 = $m_sci_Nil$();
  } else {
    var x0 = this$4.t();
    var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
    var t = h;
    var rest = this$4.v();
    while ((rest !== $m_sci_Nil$())) {
      var x0$1 = rest.t();
      var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
      t.U = nx;
      t = nx;
      rest = rest.v();
    }
    var this$7 = h;
  }
  var f$1 = ((_$4) => (_$4 !== ""));
  var l = this$7;
  while (true) {
    if (l.c()) {
      return $m_sci_Nil$();
    } else {
      var h$1 = l.t();
      var t$1 = l.v();
      if ((!(!(!f$1(h$1))))) {
        l = t$1;
        continue;
      }
      var start = l;
      var remaining = t$1;
      while (true) {
        if (remaining.c()) {
          return start;
        } else {
          var x = remaining.t();
          if ((!(!f$1(x)))) {
            remaining = remaining.v();
            continue;
          }
          var firstMiss = remaining;
          var newHead = new $c_sci_$colon$colon(start.t(), $m_sci_Nil$());
          var toProcess = start.v();
          var currentLast = newHead;
          while ((toProcess !== firstMiss)) {
            var newElem = new $c_sci_$colon$colon(toProcess.t(), $m_sci_Nil$());
            currentLast.U = newElem;
            currentLast = newElem;
            toProcess = toProcess.v();
          }
          var next = firstMiss.v();
          var nextToCopy = next;
          while ((!next.c())) {
            var head = next.t();
            if ((!(!f$1(head)))) {
              next = next.v();
            } else {
              while ((nextToCopy !== next)) {
                var newElem$2 = new $c_sci_$colon$colon(nextToCopy.t(), $m_sci_Nil$());
                currentLast.U = newElem$2;
                currentLast = newElem$2;
                nextToCopy = nextToCopy.v();
              }
              nextToCopy = next.v();
              next = next.v();
            }
          }
          if ((!nextToCopy.c())) {
            currentLast.U = nextToCopy;
          }
          return newHead;
        }
      }
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassAssignmentFallback$__mergeClasses__sci_List__sci_List__sci_List($thiz, parserClasses, sourceClasses) {
  return $f_sc_SeqOps__distinct__O(parserClasses.hK(sourceClasses));
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassAssignmentFallback$__classesForVertex__T__T__sci_Map__sci_List($thiz, rawKey, vertexId, assignments) {
  var candidates = $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_T.r().C)([rawKey, vertexId]))).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$5) => $f_T__trim__T(_$5)))).bw(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6) => (_$6 !== "")))).nz();
  $m_sci_Vector$();
  var b = new $c_sci_VectorBuilder();
  var it = candidates.o();
  while (it.p()) {
    var x0 = it.q();
    b.fO(assignments.ay(x0, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_Nil$()))));
  }
  return $f_sc_SeqOps__distinct__O(b.bY()).bM();
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassAssignmentFallback$() {
  this.aU9 = null;
  this.aU8 = null;
  this.aU9 = "class ";
  this.aU8 = "classdef";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassAssignmentFallback$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassAssignmentFallback$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassAssignmentFallback$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassAssignmentFallback$.prototype = $p;
$p.bbV = (function(sourceText, vertices, subgraphs) {
  var assignments = this.aNX(sourceText);
  var mergedVertices = vertices.kP(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    if ((x$1 !== null)) {
      var rawKey = x$1.g();
      var vertex = x$1.h();
      var sourceClasses = $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassAssignmentFallback$__classesForVertex__T__T__sci_Map__sci_List($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassAssignmentFallback$(), rawKey, vertex.qi, assignments);
      if ((!sourceClasses.c())) {
        var merged = $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassAssignmentFallback$__mergeClasses__sci_List__sci_List__sci_List($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassAssignmentFallback$(), vertex.C1, sourceClasses);
        return new $c_T2(rawKey, new $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidVertex(vertex.qi, vertex.x3, vertex.G1, vertex.C2, vertex.vf, merged, vertex.C3));
      } else {
        return new $c_T2(rawKey, vertex);
      }
    }
    throw new $c_s_MatchError(x$1);
  })));
  var f = ((subgraph) => {
    var x4 = assignments.r(subgraph.x2);
    if ((x4 instanceof $c_s_Some)) {
      var fromSource = x4.J;
      var merged$1 = $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassAssignmentFallback$__mergeClasses__sci_List__sci_List__sci_List($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassAssignmentFallback$(), subgraph.G0, fromSource);
      return new $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSubgraph(subgraph.x2, subgraph.Ly, subgraph.C0, merged$1);
    }
    return subgraph;
  });
  if ((subgraphs === $m_sci_Nil$())) {
    var $x_1 = $m_sci_Nil$();
  } else {
    var x0 = subgraphs.t();
    var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
    var t = h;
    var rest = subgraphs.v();
    while ((rest !== $m_sci_Nil$())) {
      var x0$1 = rest.t();
      var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
      t.U = nx;
      t = nx;
      rest = rest.v();
    }
    var $x_1 = h;
  }
  return new $c_T2(mergedVertices, $x_1);
});
$p.aNX = (function(sourceText) {
  var this$17 = new $c_sc_Iterator$$anon$10(new $c_sc_Iterator$$anon$6(new $c_sc_Iterator$$anon$6(new $c_sc_Iterator$$anon$9(new $c_sc_StringOps$$anon$1(sourceText, true), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => $f_T__trim__T(_$1)))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((line) => ((line !== "") && (!(!(!line.startsWith("%%"))))))), false), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((line$2) => {
    var lower = line$2.toLowerCase();
    return ((!(!lower.startsWith("class "))) && (!(!(!lower.startsWith("classdef")))));
  })), false), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((line$3) => {
    var withoutPrefix = $m_sc_StringOps$().wh($f_T__trim__T($m_sc_StringOps$().kp(line$3, 6)), ";");
    var normalized = $f_T__replaceAll__T__T__T(withoutPrefix, "\\s*,\\s*", ",");
    var x7 = $m_sci_Nil$().b6($m_s_Predef$().fB($f_T__split__T__I__AT(normalized, "\\s+", 2)));
    if ((x7 instanceof $c_sci_$colon$colon)) {
      var x10 = x7.U;
      var targetPart = x7.er;
      if ((x10 instanceof $c_sci_$colon$colon)) {
        var x13 = x10.U;
        var classPart = x10.er;
        if ($m_sci_Nil$().e(x13)) {
          var targets = $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassAssignmentFallback$__splitCsv__T__sci_List($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassAssignmentFallback$(), targetPart);
          var classes = $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassAssignmentFallback$__splitCsv__T__sci_List($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassAssignmentFallback$(), classPart);
          if (((!targets.c()) && (!classes.c()))) {
            var f$1 = ((_$2) => new $c_T2(_$2, classes));
            if ((targets === $m_sci_Nil$())) {
              return $m_sci_Nil$();
            } else {
              var x0 = targets.t();
              var h = new $c_sci_$colon$colon(f$1(x0), $m_sci_Nil$());
              var t = h;
              var rest = targets.v();
              while ((rest !== $m_sci_Nil$())) {
                var x0$1 = rest.t();
                var nx = new $c_sci_$colon$colon(f$1(x0$1), $m_sci_Nil$());
                t.U = nx;
                t = nx;
                rest = rest.v();
              }
              return h;
            }
          } else {
            return $m_sci_Nil$();
          }
        }
      }
    }
    return $m_sci_Nil$();
  })));
  var z = $m_sci_Map$EmptyMap$();
  var result = z;
  while (this$17.p()) {
    var x0$2 = result;
    var x1 = this$17.q();
    matchResult4: {
      var x14 = new $c_T2(x0$2, x1);
      var x16 = x14.be;
      var acc = x14.bi;
      if ((x16 !== null)) {
        var targetId = x16.g();
        var classNames = x16.h();
        result = acc.bN(targetId, $f_sc_SeqOps__distinct__O(acc.ay(targetId, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_Nil$()))).g9(classNames)));
        break matchResult4;
      }
      throw new $c_s_MatchError(x14);
    }
  }
  return result;
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassAssignmentFallback$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassAssignmentFallback$, "org.jpablo.graphexplorer.viewer.backends.mermaid.MermaidClassAssignmentFallback$", ({
  xY: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassAssignmentFallback$;
function $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassAssignmentFallback$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassAssignmentFallback$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassAssignmentFallback$ = new $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassAssignmentFallback$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassAssignmentFallback$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassDefFallback$() {
  this.aUa = null;
  this.aUa = "classdef";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassDefFallback$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassDefFallback$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassDefFallback$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassDefFallback$.prototype = $p;
$p.bbW = (function(sourceText, classDefs) {
  var this$6 = this.b12(sourceText);
  var f = ((x$1, x$2) => {
    var x4 = new $c_T2(x$1, x$2);
    var x6 = x4.be;
    var acc = x4.bi;
    if ((x6 !== null)) {
      var className = x6.g();
      var fromSource = x6.h();
      var x1 = acc.r(className);
      if ((x1 instanceof $c_s_Some)) {
        var existing = x1.J;
        if (((!existing.BY.c()) || (!existing.FW.c()))) {
          return acc;
        }
      }
      return acc.bN(className, fromSource);
    }
    throw new $c_s_MatchError(x4);
  });
  if ($is_sc_IndexedSeq(this$6)) {
    var at = 0;
    var end = this$6.C();
    var acc$1 = classDefs;
    var $x_1;
    while (true) {
      if ((at !== end)) {
        var temp$at = ((1 + at) | 0);
        var x0 = acc$1;
        var x1$1 = this$6.l(at);
        var temp$acc = f(x0, x1$1);
        at = temp$at;
        acc$1 = temp$acc;
        continue;
      }
      var $x_1 = acc$1;
      break;
    }
  } else {
    var result = classDefs;
    var it = this$6.o();
    while (it.p()) {
      var x0$1 = result;
      var x1$2 = it.q();
      result = f(x0$1, x1$2);
    }
    var $x_1 = result;
  }
  return $x_1;
});
$p.b12 = (function(sourceText) {
  var this$36 = new $c_sc_Iterator$$anon$10(new $c_sc_Iterator$$anon$6(new $c_sc_Iterator$$anon$9(new $c_sc_StringOps$$anon$1(sourceText, true), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => $f_T__trim__T(_$1)))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((line) => {
    var this$5 = line.toLowerCase();
    return (!(!this$5.startsWith("classdef")));
  })), false), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((line$2) => {
    var withoutPrefix = $f_T__trim__T($m_sc_StringOps$().kp(line$2, 8));
    var firstSpace = $f_T__indexOf__I__I(withoutPrefix, 32);
    if ((firstSpace < 0)) {
      return $m_sci_Nil$();
    } else {
      var rawNames = $f_T__trim__T(withoutPrefix.substring(0, firstSpace));
      var $x_1 = $m_sc_StringOps$();
      var beginIndex = ((1 + firstSpace) | 0);
      var body = $x_1.wh($f_T__trim__T(withoutPrefix.substring(beginIndex)), ";");
      var xs = $f_T__split__T__I__AT(rawNames, ",", 0);
      var f$1 = ((_$2) => $f_T__trim__T(_$2));
      var len = xs.a.length;
      var ys = new ($d_T.r().C)(len);
      if ((len > 0)) {
        var i = 0;
        if ((xs !== null)) {
          while ((i < len)) {
            var $x_2 = i;
            var x0 = xs.a[i];
            ys.a[$x_2] = f$1(x0);
            i = ((1 + i) | 0);
          }
        } else if ((xs instanceof $ac_I)) {
          while ((i < len)) {
            var $x_3 = i;
            var x0$1 = xs.a[i];
            ys.a[$x_3] = f$1(x0$1);
            i = ((1 + i) | 0);
          }
        } else if ((xs instanceof $ac_D)) {
          while ((i < len)) {
            var $x_4 = i;
            var x0$2 = xs.a[i];
            ys.a[$x_4] = f$1(x0$2);
            i = ((1 + i) | 0);
          }
        } else if ((xs instanceof $ac_J)) {
          while ((i < len)) {
            var $x_7 = i;
            var $x_5 = xs.a;
            var $x_6 = (i << 1);
            var x0$3_$_lo = $x_5[$x_6];
            var x0$3_$_hi = $x_5[(($x_6 + 1) | 0)];
            ys.a[$x_7] = f$1($bL(x0$3_$_lo, x0$3_$_hi));
            i = ((1 + i) | 0);
          }
        } else if ((xs instanceof $ac_F)) {
          while ((i < len)) {
            var $x_8 = i;
            var x0$4 = xs.a[i];
            ys.a[$x_8] = f$1(x0$4);
            i = ((1 + i) | 0);
          }
        } else if ((xs instanceof $ac_C)) {
          while ((i < len)) {
            var $x_9 = i;
            var x0$5 = xs.a[i];
            ys.a[$x_9] = f$1($bC(x0$5));
            i = ((1 + i) | 0);
          }
        } else if ((xs instanceof $ac_B)) {
          while ((i < len)) {
            var $x_10 = i;
            var x0$6 = xs.a[i];
            ys.a[$x_10] = f$1(x0$6);
            i = ((1 + i) | 0);
          }
        } else if ((xs instanceof $ac_S)) {
          while ((i < len)) {
            var $x_11 = i;
            var x0$7 = xs.a[i];
            ys.a[$x_11] = f$1(x0$7);
            i = ((1 + i) | 0);
          }
        } else if ((xs instanceof $ac_Z)) {
          while ((i < len)) {
            var $x_12 = i;
            var x0$8 = xs.a[i];
            ys.a[$x_12] = f$1(x0$8);
            i = ((1 + i) | 0);
          }
        } else {
          throw new $c_s_MatchError(xs);
        }
      }
      var capacity = 0;
      var size = 0;
      var jsElems = null;
      capacity = 0;
      size = 0;
      jsElems = [];
      var i$1 = 0;
      while ((i$1 < ys.a.length)) {
        var x$1 = ys.a[i$1];
        if ((x$1 !== "")) {
          var unboxedElem = ((x$1 === null) ? null : x$1);
          jsElems.push(unboxedElem);
        }
        i$1 = ((1 + i$1) | 0);
      }
      var classNames = new ($d_T.r().C)(jsElems);
      var this$26 = $m_sci_Nil$().b6($m_s_Predef$().fB($f_T__split__T__I__AT(body, ",", 0)));
      var f$2 = ((_$4) => $f_T__trim__T(_$4));
      if ((this$26 === $m_sci_Nil$())) {
        var this$27 = $m_sci_Nil$();
      } else {
        var x0$9 = this$26.t();
        var h = new $c_sci_$colon$colon(f$2(x0$9), $m_sci_Nil$());
        var t = h;
        var rest = this$26.v();
        while ((rest !== $m_sci_Nil$())) {
          var x0$10 = rest.t();
          var nx = new $c_sci_$colon$colon(f$2(x0$10), $m_sci_Nil$());
          t.U = nx;
          t = nx;
          rest = rest.v();
        }
        var this$27 = h;
      }
      var f$3 = ((fragment) => ((fragment.indexOf(":") | 0) !== (-1)));
      var l = this$27;
      block: {
        var result;
        while (true) {
          if (l.c()) {
            var result = $m_sci_Nil$();
            break;
          } else {
            var h$1 = l.t();
            var t$1 = l.v();
            if ((!(!(!f$3(h$1))))) {
              l = t$1;
              continue;
            }
            var start = l;
            var remaining = t$1;
            while (true) {
              if (remaining.c()) {
                var result = start;
                break block;
              } else {
                var x$2 = remaining.t();
                if ((!(!f$3(x$2)))) {
                  remaining = remaining.v();
                  continue;
                }
                var firstMiss = remaining;
                var newHead = new $c_sci_$colon$colon(start.t(), $m_sci_Nil$());
                var toProcess = start.v();
                var currentLast = newHead;
                while ((toProcess !== firstMiss)) {
                  var newElem = new $c_sci_$colon$colon(toProcess.t(), $m_sci_Nil$());
                  currentLast.U = newElem;
                  currentLast = newElem;
                  toProcess = toProcess.v();
                }
                var next = firstMiss.v();
                var nextToCopy = next;
                while ((!next.c())) {
                  var head = next.t();
                  if ((!(!f$3(head)))) {
                    next = next.v();
                  } else {
                    while ((nextToCopy !== next)) {
                      var newElem$2 = new $c_sci_$colon$colon(nextToCopy.t(), $m_sci_Nil$());
                      currentLast.U = newElem$2;
                      currentLast = newElem$2;
                      nextToCopy = nextToCopy.v();
                    }
                    nextToCopy = next.v();
                    next = next.v();
                  }
                }
                if ((!nextToCopy.c())) {
                  currentLast.U = nextToCopy;
                }
                var result = newHead;
                break block;
              }
            }
          }
        }
      }
      if ((!result.c())) {
        var $x_14 = $m_s_Predef$();
        var len$1 = classNames.a.length;
        var ys$1 = new ($d_T2.r().C)(len$1);
        if ((len$1 > 0)) {
          var i$2 = 0;
          while ((i$2 < len$1)) {
            ys$1.a[i$2] = new $c_T2(classNames.a[i$2], result);
            i$2 = ((1 + i$2) | 0);
          }
        }
        var $x_13 = $x_14.fB(ys$1);
      } else {
        var $x_13 = $m_sci_Nil$();
      }
      return $x_13;
    }
  })));
  var z = $m_sci_Map$EmptyMap$();
  var result$1 = z;
  while (this$36.p()) {
    var x0$12 = result$1;
    var x1 = this$36.q();
    matchResult3: {
      var x9 = new $c_T2(x0$12, x1);
      var x11 = x9.be;
      var acc = x9.bi;
      if ((x11 !== null)) {
        var className = x11.g();
        var declarations = x11.h();
        var this$38 = acc.r(className);
        var this$39 = (this$38.c() ? $m_s_None$() : new $c_s_Some(this$38.d().BY));
        result$1 = acc.bN(className, new $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassDef((this$39.c() ? $m_sci_Nil$() : this$39.d()).g9(declarations), $m_sci_Nil$()));
        break matchResult3;
      }
      throw new $c_s_MatchError(x9);
    }
  }
  return result$1;
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassDefFallback$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassDefFallback$, "org.jpablo.graphexplorer.viewer.backends.mermaid.MermaidClassDefFallback$", ({
  xZ: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassDefFallback$;
function $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassDefFallback$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassDefFallback$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassDefFallback$ = new $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassDefFallback$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassDefFallback$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidConfig$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidConfig$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidConfig$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidConfig$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidConfig$.prototype = $p;
$p.aXe = (function(startOnLoad, securityLevel, theme, suppressErrorRendering, flowchart) {
  var obj = $m_sjs_js_special_package$().eA($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("startOnLoad", startOnLoad), new $c_T2("securityLevel", securityLevel), new $c_T2("theme", theme), new $c_T2("suppressErrorRendering", suppressErrorRendering)])));
  if ((flowchart !== (void 0))) {
    obj.flowchart = flowchart;
  }
  return obj;
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidConfig$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidConfig$, "org.jpablo.graphexplorer.viewer.backends.mermaid.MermaidConfig$", ({
  y0: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidConfig$;
function $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidConfig$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidConfig$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidConfig$ = new $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidConfig$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidConfig$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidEdgeLabelFallback$__extractEdgeFromLine__T__s_Option($thiz, line) {
  var labeled = $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(new $c_sc_Iterator$$anon$9(new $c_sc_Iterator$$anon$10(new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(new $c_sci_$colon$colon($thiz.avX, new $c_sci_$colon$colon($thiz.avW, $m_sci_Nil$()))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$5) => _$5.Pk(line)))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((m) => new $c_T3($f_s_util_matching_Regex$MatchData__group__I__T(m, 1), $f_s_util_matching_Regex$MatchData__group__I__T(m, 3), $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$().aQx($f_s_util_matching_Regex$MatchData__group__I__T(m, 2)))))), new $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidEdgeLabelFallback$$anon$1());
  if (labeled.c()) {
    var this$6 = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidEdgeLabelFallback$().avY.Pk(line);
    if (this$6.c()) {
      return $m_s_None$();
    } else {
      var x0 = this$6.d();
      return new $c_s_Some(new $c_T3($f_s_util_matching_Regex$MatchData__group__I__T(x0, 1), $f_s_util_matching_Regex$MatchData__group__I__T(x0, 2), $m_s_None$()));
    }
  } else {
    return labeled;
  }
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidEdgeLabelFallback$() {
  this.avX = null;
  this.avW = null;
  this.avY = null;
  $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidEdgeLabelFallback$ = this;
  this.avX = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "([A-Za-z0-9_][A-Za-z0-9_-]*)\\s+[^\\s|]+\\|([^|]+)\\|\\s+([A-Za-z0-9_][A-Za-z0-9_-]*)", $m_sci_Nil$());
  this.avW = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "([A-Za-z0-9_][A-Za-z0-9_-]*)\\s+--\\s+(.+?)\\s+-->\\s+([A-Za-z0-9_][A-Za-z0-9_-]*)", $m_sci_Nil$());
  this.avY = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "([A-Za-z0-9_][A-Za-z0-9_-]*)\\s+[-.=<>ox~]*[-.=][-.=<>ox~]*\\s+([A-Za-z0-9_][A-Za-z0-9_-]*)", $m_sci_Nil$());
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidEdgeLabelFallback$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidEdgeLabelFallback$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidEdgeLabelFallback$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidEdgeLabelFallback$.prototype = $p;
$p.bbX = (function(sourceText, edges) {
  if (edges.c()) {
    var $x_1 = true;
  } else {
    _return: {
      var these = edges;
      while ((!these.c())) {
        var x0 = these.t();
        var this$1 = x0.FZ;
        if ((!((!this$1.c()) && (this$1.d() !== "")))) {
          var $x_1 = false;
          break _return;
        }
        these = these.v();
      }
      var $x_1 = true;
    }
  }
  if ($x_1) {
    return edges;
  } else {
    var sourceLabels = this.b14(sourceText);
    var edgeCounts = $f_scm_Map__withDefaultValue__O__scm_Map($m_scm_Map$().dr($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([]))), 0);
    var f = ((edge) => {
      var key = new $c_T2(edge.ve, edge.vd);
      edgeCounts.cY(key, ((1 + (edgeCounts.i(key) | 0)) | 0));
      var seq = (edgeCounts.i(key) | 0);
      var this$5 = edge.FZ;
      if (((!this$5.c()) && (this$5.d() !== ""))) {
        return edge;
      } else {
        var this$9 = sourceLabels.r(new $c_T3(edge.ve, edge.vd, seq));
        if (this$9.c()) {
          return edge;
        } else {
          var x0$3 = this$9.d();
          var text$1 = new $c_s_Some(x0$3);
          return new $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidEdge(edge.ve, edge.vd, edge.FX, text$1, edge.SA, edge.Lu, edge.FY, edge.Lt);
        }
      }
    });
    if ((edges === $m_sci_Nil$())) {
      return $m_sci_Nil$();
    } else {
      var x0$4 = edges.t();
      var h = new $c_sci_$colon$colon(f(x0$4), $m_sci_Nil$());
      var t = h;
      var rest = edges.v();
      while ((rest !== $m_sci_Nil$())) {
        var x0$5 = rest.t();
        var nx = new $c_sci_$colon$colon(f(x0$5), $m_sci_Nil$());
        t.U = nx;
        t = nx;
        rest = rest.v();
      }
      return h;
    }
  }
});
$p.b14 = (function(sourceText) {
  var result = $m_scm_Map$().dr($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([])));
  var counts = $f_scm_Map__withDefaultValue__O__scm_Map($m_scm_Map$().dr($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([]))), 0);
  var this$8 = new $c_sc_Iterator$$anon$6(new $c_sc_Iterator$$anon$9(new $c_sc_StringOps$$anon$1(sourceText, true), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4) => $f_T__trim__T(_$4)))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((line) => ((line !== "") && (!$m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$().aPp(line))))), false);
  while (this$8.p()) {
    var x0 = this$8.q();
    var this$9 = $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidEdgeLabelFallback$__extractEdgeFromLine__T__s_Option($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidEdgeLabelFallback$(), x0);
    if ((!this$9.c())) {
      var x0$1 = this$9.d();
      matchResult1: {
        if ((x0$1 !== null)) {
          var source = x0$1.bH;
          var target = x0$1.bU;
          var labelOpt = x0$1.c3;
          var key = new $c_T2(source, target);
          counts.cY(key, ((1 + (counts.i(key) | 0)) | 0));
          if ((!labelOpt.c())) {
            var x0$2 = labelOpt.d();
            result.cY(new $c_T3(source, target, counts.i(key)), x0$2);
            break matchResult1;
          } else {
            break matchResult1;
          }
        }
        throw new $c_s_MatchError(x0$1);
      }
    }
  }
  return $m_sci_Map$().ao(result);
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidEdgeLabelFallback$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidEdgeLabelFallback$, "org.jpablo.graphexplorer.viewer.backends.mermaid.MermaidEdgeLabelFallback$", ({
  y1: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidEdgeLabelFallback$;
function $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidEdgeLabelFallback$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidEdgeLabelFallback$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidEdgeLabelFallback$ = new $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidEdgeLabelFallback$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidEdgeLabelFallback$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidLabelText$() {
  this.avZ = null;
  $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidLabelText$ = this;
  this.avZ = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "(?i)<br\\s*/?>", $m_sci_Nil$());
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidLabelText$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidLabelText$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidLabelText$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidLabelText$.prototype = $p;
$p.ag6 = (function(stored) {
  var sb = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  var i = 0;
  while ((i < stored.length)) {
    var index = i;
    var c = stored.charCodeAt(index);
    if (((c === 92) && (((1 + i) | 0) < stored.length))) {
      var index$1 = ((1 + i) | 0);
      var x1 = stored.charCodeAt(index$1);
      switch (x1) {
        case 92: {
          sb.jl(92);
          break;
        }
        case 110:
        case 108:
        case 114: {
          sb.ei("<br/>");
          break;
        }
        default: {
          sb.jl(92).jl(x1);
        }
      }
      i = ((2 + i) | 0);
    } else {
      sb.jl(c);
      i = ((1 + i) | 0);
    }
  }
  return sb.bP.ah;
});
$p.aig = (function(mermaidText) {
  return $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_TextUtils$().a3j(this.avZ.ahE(mermaidText, "\n"));
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidLabelText$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidLabelText$, "org.jpablo.graphexplorer.viewer.backends.mermaid.MermaidLabelText$", ({
  y3: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidLabelText$;
function $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidLabelText$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidLabelText$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidLabelText$ = new $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidLabelText$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidLabelText$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidMissingVertexFallback$__representedIds$1__sci_Set__T__Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidVertex__sci_Set($thiz, referencedIds$1, rawKey, vertex) {
  var $x_2 = $m_sci_Set$();
  var $x_1 = $m_s_Option$();
  var this$1 = $m_s_Option$().as(vertex.qi);
  var vertexId = $x_2.af($x_1.m2(((this$1.c() || (this$1.d() !== "")) ? this$1 : $m_s_None$())));
  return $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_T.r().C)([rawKey]))).dI(vertexId).J3(referencedIds$1);
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidMissingVertexFallback$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidMissingVertexFallback$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidMissingVertexFallback$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidMissingVertexFallback$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidMissingVertexFallback$.prototype = $p;
$p.bbZ = (function(sourceText, vertices, edges, subgraphs) {
  var labelsById = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidVertexLabelFallback$().aNY(sourceText);
  var classesById = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassAssignmentFallback$().aNX(sourceText);
  var referencedIds = $m_sci_Set$().af(new $c_sc_Iterator$$anon$10(edges.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e) => $m_sr_ScalaRunTime$().f(new ($d_T.r().C)([e.ve, e.vd])).o())))).dI($m_sci_Set$().af(new $c_sc_Iterator$$anon$10(subgraphs.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => _$1.C0))))).dI(labelsById.ln()).dI(classesById.ln());
  var coveredIds = $m_sci_Set$().af(new $c_sc_Iterator$$anon$10(vertices.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    if ((x$1 !== null)) {
      return $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidMissingVertexFallback$__representedIds$1__sci_Set__T__Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidVertex__sci_Set(this, referencedIds, x$1.g(), x$1.h());
    }
    throw new $c_s_MatchError(x$1);
  }))));
  var missingIds = referencedIds.jv(coveredIds);
  return (missingIds.c() ? vertices : vertices.hN($f_sc_SeqOps__sorted__s_math_Ordering__O($m_sci_Vector$().X(missingIds), $m_s_math_Ordering$String$()).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((id) => new $c_T2(id, new $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidVertex(id, labelsById.ay(id, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((id$2) => (() => id$2))(id))), $m_s_None$(), $m_s_None$(), $m_sci_Nil$(), classesById.ay(id, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_Nil$()))), $m_s_None$())))))));
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidMissingVertexFallback$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidMissingVertexFallback$, "org.jpablo.graphexplorer.viewer.backends.mermaid.MermaidMissingVertexFallback$", ({
  y4: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidMissingVertexFallback$;
function $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidMissingVertexFallback$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidMissingVertexFallback$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidMissingVertexFallback$ = new $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidMissingVertexFallback$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidMissingVertexFallback$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$__headerOnward__T__s_Option($thiz, text) {
  var lines = $m_sci_Nil$().b6($f_sc_Iterator__take__I__sc_Iterator(new $c_sc_Iterator$$anon$9(new $c_sc_StringOps$$anon$1(text, true), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => $f_T__trim__T(_$1)))), 50));
  matchResult3: {
    var body;
    if ((lines instanceof $c_sci_$colon$colon)) {
      var x10 = lines.U;
      if ((lines.er === "---")) {
        var s = x10;
        while (((!s.c()) && (s.t() !== "---"))) {
          s = s.v();
        }
        var this$9 = s;
        var body = $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(this$9, 1, this$9);
        break matchResult3;
      }
    }
    var body = lines;
  }
  _return: {
    var i = 0;
    var these = $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(body, 0, body);
    while ((!these.c())) {
      var x0$1 = these.t();
      if (((x0$1 !== "") && (!(!(!x0$1.startsWith("%%")))))) {
        var header = i;
        break _return;
      }
      i = ((1 + i) | 0);
      these = these.v();
    }
    var header = (-1);
  }
  if ((header >= 0)) {
    var this$17 = $f_sc_IterableOnceOps__mkString__T__T__T__T($p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(body, header, body), "", "\n", "");
    return new $c_s_Some(this$17.toLowerCase());
  } else {
    return $m_s_None$();
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$__hasLeadingDirective__T__Z($thiz, text) {
  var this$6 = $f_sc_Iterator__take__I__sc_Iterator(new $c_sc_Iterator$$anon$9(new $c_sc_StringOps$$anon$1(text, true), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3) => $f_T__trim__T(_$3)))), 50);
  _return: {
    while (this$6.p()) {
      var a = this$6.q();
      if ((a !== "")) {
        var this$9 = new $c_s_Some(a);
        break _return;
      }
    }
    var this$9 = $m_s_None$();
  }
  if ((!this$9.c())) {
    var x0 = this$9.d();
    return (!(!x0.startsWith("%%{")));
  } else {
    return false;
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$__stripSurroundingQuotes__T__T($thiz, s) {
  if ((((s.length >= 2) && ($m_sc_StringOps$().pw(s) === 34)) && ($m_sc_StringOps$().b40(s) === 34))) {
    var endIndex = ((s.length - 1) | 0);
    return $f_T__trim__T(s.substring(1, endIndex));
  } else {
    return s;
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$__isIgnoredPrefix__T__T__Z($thiz, lower, prefix) {
  return (((!(!prefix.endsWith(" "))) || (prefix === "%%")) ? (!(!lower.startsWith(prefix))) : ((lower === prefix) || ((!(!lower.startsWith(prefix))) && (!$thiz.agE(lower.charCodeAt(prefix.length))))));
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$__isSequenceDiagram__T__Z($thiz, source) {
  var this$5 = new $c_sc_Iterator$$anon$9(new $c_sc_StringOps$$anon$1(source, true), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$10) => $f_T__trim__T(_$10))));
  _return: {
    while (this$5.p()) {
      var a = this$5.q();
      if ((((a !== "") && (!(!(!a.startsWith("%%"))))) && (a !== "---"))) {
        var this$8 = new $c_s_Some(a);
        break _return;
      }
    }
    var this$8 = $m_s_None$();
  }
  if ((!this$8.c())) {
    var x0 = this$8.d();
    var this$9 = x0.toLowerCase();
    return (!(!this$9.startsWith("sequencediagram")));
  } else {
    return false;
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$__reservedParticipant__T__s_Option($thiz, source) {
  var declaration = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "^\\s*(?:participant|actor)\\s+([^\\s:]+)", $m_sci_Nil$());
  var hit = $f_sc_Iterator__nextOption__s_Option(new $c_sc_Iterator$$anon$10(new $c_sc_Iterator$$anon$16(new $c_sc_StringOps$$anon$1(source, true)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var line = x$1.g();
    var idx = (x$1.h() | 0);
    var this$7 = declaration.afR(line);
    var fromDecl = (this$7.c() ? $m_s_None$() : new $c_s_Some($f_s_util_matching_Regex$MatchData__group__I__T(this$7.d(), 1)));
    if (fromDecl.c()) {
      var this$9 = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$().aw2.afR(line);
      if (this$9.c()) {
        var $x_2 = $m_s_None$();
      } else {
        var x0$1 = this$9.d();
        var endIndex = x0$1.VA;
        var lhs = $f_T__trim__T(line.substring(0, endIndex));
        var beginIndex = x0$1.HL;
        var x = line.substring(beginIndex);
        _return: {
          var len = x.length;
          var i = 0;
          while ((i < len)) {
            if ((x.charCodeAt(i) === 58)) {
              var x1 = i;
              break _return;
            }
            i = ((1 + i) | 0);
          }
          var x1 = (-1);
        }
        var rhs = $f_T__trim__T(((x1 === (-1)) ? x : x.substring(0, x1)));
        var $x_2 = $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_T.r().C)([lhs, rhs]))).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((s) => $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$__stripActivationMark__T__T($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$(), s)))).iW(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((candidate) => $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$__isReserved__T__Z($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$(), candidate))));
      }
      var $x_1 = new $c_s_Some($x_2);
    } else {
      var $x_1 = $m_s_None$();
    }
    var fromMessage = $x_1.WS($m_s_$less$colon$less$().b1);
    if (fromDecl.c()) {
      var $x_3 = true;
    } else {
      var x0$3 = fromDecl.d();
      var $x_3 = $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$__isReserved__T__Z($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$(), x0$3);
    }
    if ($x_3) {
      var this$19 = fromDecl;
    } else {
      var this$19 = $m_s_None$();
    }
    var this$20 = (this$19.c() ? fromMessage : this$19);
    return (this$20.c() ? $m_s_None$() : new $c_s_Some(new $c_T2(this$20.d(), ((1 + idx) | 0))));
  }))));
  if (hit.c()) {
    return $m_s_None$();
  } else {
    var x0$5 = hit.d();
    var word = x0$5.g();
    var line$1 = (x0$5.h() | 0);
    return new $c_s_Some((((((((("'" + word) + "' is a reserved word in Mermaid sequence diagrams (line ") + line$1) + "), so it cannot be used as a participant id \u2014 the name is matched whole-word and ignoring case. Rename the id and ") + ("keep the label with `as`, e.g. `participant Agent as " + word)) + "`. ") + ("(A longer name containing it, like '" + word)) + "s', is fine.)"));
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$__stripActivationMark__T__T($thiz, s) {
  _return: {
    var len = s.length;
    var i = 0;
    while ((i < len)) {
      var index = i;
      var x0 = s.charCodeAt(index);
      if ((!((x0 === 43) || (x0 === 45)))) {
        var x1 = i;
        break _return;
      }
      i = ((1 + i) | 0);
    }
    var x1 = (-1);
  }
  return $f_T__trim__T(((x1 === (-1)) ? "" : s.substring(x1)));
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$__isReserved__T__Z($thiz, candidate) {
  return ((candidate !== "") && $thiz.aw3.E(candidate.toLowerCase()));
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$__firstContent$1__sci_List__s_Option($thiz, lines$1) {
  var these = lines$1;
  while ((!these.c())) {
    var x0 = these.t();
    if ((((x0 !== "") && (!(!(!x0.startsWith("%%"))))) && (x0 !== "---"))) {
      return new $c_s_Some(these.t());
    }
    these = these.v();
  }
  return $m_s_None$();
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$__isFlowchart$1__sci_List__Z($thiz, lines$4) {
  var this$1 = $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$__firstContent$1__sci_List__s_Option($thiz, lines$4);
  if ((!this$1.c())) {
    var x0 = this$1.d();
    if ((!(!x0.startsWith("flowchart")))) {
      return true;
    } else {
      var this$2 = x0.toLowerCase();
      return (!(!this$2.startsWith("graph ")));
    }
  } else {
    return false;
  }
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$() {
  this.aw1 = null;
  this.aw0 = null;
  this.aw3 = null;
  this.aw2 = null;
  $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$ = this;
  this.aw1 = $m_sci_Nil$().b6($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("flowchart", "flowchart"), new $c_T2("graph td", "flowchart"), new $c_T2("graph tb", "flowchart"), new $c_T2("graph bt", "flowchart"), new $c_T2("graph lr", "flowchart"), new $c_T2("graph rl", "flowchart"), new $c_T2("sequencediagram", "sequence"), new $c_T2("classdiagram", "class"), new $c_T2("statediagram", "state"), new $c_T2("erdiagram", "ER"), new $c_T2("journey", "journey"), new $c_T2("gantt", "gantt"), new $c_T2("pie", "pie"), new $c_T2("mindmap", "mindmap"), new $c_T2("timeline", "timeline"), new $c_T2("gitgraph", "git"), new $c_T2("quadrantchart", "quadrant"), new $c_T2("xychart", "xy chart"), new $c_T2("sankey", "sankey"), new $c_T2("requirementdiagram", "requirement"), new $c_T2("c4context", "C4"), new $c_T2("c4container", "C4"), new $c_T2("c4component", "C4"), new $c_T2("c4dynamic", "C4"), new $c_T2("c4deployment", "C4"), new $c_T2("block-beta", "block"), new $c_T2("kanban", "kanban"), new $c_T2("packet", "packet"), new $c_T2("radar", "radar"), new $c_T2("architecture", "architecture"), new $c_T2("treemap", "treemap"), new $c_T2("zenuml", "zenUML")])));
  this.aw0 = $m_sci_Nil$().b6($m_sr_ScalaRunTime$().f(new ($d_T.r().C)(["%%", "flowchart", "graph", "subgraph", "classdef", "class ", "style ", "linkstyle", "click ", "end"])));
  this.aw3 = $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_T.r().C)(["activate", "actor", "alt", "and", "autonumber", "box", "break", "create", "critical", "deactivate", "destroy", "details", "else", "end", "link", "links", "loop", "note", "off", "opt", "option", "over", "par", "participant", "properties", "rect", "sequencediagram"])));
  this.aw2 = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "(?:--?)(?:>>?|\\)|x)", $m_sci_Nil$());
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$.prototype = $p;
$p.b4c = (function(text) {
  return ((!this.Aj(text).c()) || $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$__hasLeadingDirective__T__Z(this, text));
});
$p.Aj = (function(text) {
  var this$1 = $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$__headerOnward__T__s_Option(this, text);
  if (this$1.c()) {
    return $m_s_None$();
  } else {
    var x0 = this$1.d();
    return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this.aw1, new $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$$anon$1(x0));
  }
});
$p.aQM = (function(header, prefix) {
  if ((!(!header.startsWith(prefix)))) {
    if ((!(!(!prefix.startsWith("graph "))))) {
      return true;
    } else {
      var rest = $m_sc_StringOps$().kp(header, prefix.length);
      var this$3 = $m_sc_StringOps$().X8(rest);
      if (this$3.c()) {
        var $x_1 = true;
      } else {
        var x0 = this$3.d();
        var c = $uC(x0);
        var $x_1 = (!$m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$().agE(c));
      }
      if ($x_1) {
        _return: {
          var len = rest.length;
          var i = 0;
          while ((i < len)) {
            if ((!$m_jl_UnicodeData$().E7(rest.charCodeAt(i)))) {
              var x1 = i;
              break _return;
            }
            i = ((1 + i) | 0);
          }
          var x1 = (-1);
        }
        var this$12 = ((x1 === (-1)) ? "" : rest.substring(x1));
        return (!(!(!this$12.startsWith("{"))));
      } else {
        return false;
      }
    }
  } else {
    return false;
  }
});
$p.aZV = (function(text) {
  var lines = $m_sci_Nil$().b6($f_sc_Iterator__take__I__sc_Iterator(new $c_sc_Iterator$$anon$9(new $c_sc_StringOps$$anon$1(text, true), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$7) => $f_T__trim__T(_$7)))), 50));
  matchResult6: {
    var fromFrontmatter;
    if ((lines instanceof $c_sci_$colon$colon)) {
      var x16 = lines.U;
      if ((lines.er === "---")) {
        var b = new $c_scm_ListBuffer();
        var these = x16;
        while (((!these.c()) && (these.t() !== "---"))) {
          b.bb(these.t());
          these = these.v();
        }
        var fromFrontmatter = $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(b.bM(), new $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$$anon$2());
        break matchResult6;
      }
    }
    var fromFrontmatter = $m_s_None$();
  }
  var this$11 = (fromFrontmatter.c() ? ((!$p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$__isFlowchart$1__sci_List__Z(this, lines)) ? new $c_s_Some($f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(lines, new $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$$anon$3())) : $m_s_None$()).WS($m_s_$less$colon$less$().b1) : fromFrontmatter);
  if (this$11.c()) {
    var this$12 = $m_s_None$();
  } else {
    var x0$1 = this$11.d();
    var this$12 = new $c_s_Some($p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$__stripSurroundingQuotes__T__T($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$(), x0$1));
  }
  return ((this$12.c() || (this$12.d() !== "")) ? this$12 : $m_s_None$());
});
$p.aPp = (function(line) {
  var lower = line.toLowerCase();
  var this$1 = this.aw0;
  var these = this$1;
  while ((!these.c())) {
    var x0 = these.t();
    if ($p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$__isIgnoredPrefix__T__T__Z($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$(), lower, x0)) {
      return true;
    }
    these = these.v();
  }
  return false;
});
$p.agE = (function(c) {
  return (($m_jl_UnicodeData$().E5(c) || (c === 95)) || (c === 45));
});
$p.b10 = (function(source) {
  return ($p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$__isSequenceDiagram__T__Z(this, source) ? new $c_s_Some($p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$__reservedParticipant__T__s_Option($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$(), source)) : $m_s_None$()).WS($m_s_$less$colon$less$().b1);
});
$p.aQx = (function(raw) {
  var trimmed = $f_T__trim__T(raw);
  if ((((trimmed.length >= 2) && (!(!trimmed.startsWith("\"")))) && (!(!trimmed.endsWith("\""))))) {
    var endIndex = ((trimmed.length - 1) | 0);
    var unquoted = trimmed.substring(1, endIndex);
  } else {
    var unquoted = trimmed;
  }
  return $f_T__trim__T(unquoted.split("#quot;").join("\""));
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$, "org.jpablo.graphexplorer.viewer.backends.mermaid.MermaidSourceScan$", ({
  y5: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$;
function $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$ = new $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidStyleDeclarations$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidStyleDeclarations$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidStyleDeclarations$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidStyleDeclarations$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidStyleDeclarations$.prototype = $p;
$p.Az = (function(styleText) {
  return this.b6r($m_sc_ArrayOps$().kX($f_T__split__T__I__AT(styleText, ",", 0)));
});
$p.b6r = (function(fragments) {
  return fragments.hO($m_sci_VectorMap$().jg, new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((acc, rawFragment) => {
    var fragment = $f_T__trim__T(rawFragment);
    var separatorIdx = $f_T__indexOf__I__I(fragment, 58);
    if ((separatorIdx < 0)) {
      return acc;
    } else {
      var this$2 = $f_T__trim__T(fragment.substring(0, separatorIdx));
      var key = this$2.toLowerCase();
      if ((key === "")) {
        return acc;
      } else {
        var beginIndex = ((1 + separatorIdx) | 0);
        return acc.AJ(key, $f_T__trim__T(fragment.substring(beginIndex)));
      }
    }
  })));
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidStyleDeclarations$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidStyleDeclarations$, "org.jpablo.graphexplorer.viewer.backends.mermaid.MermaidStyleDeclarations$", ({
  y9: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidStyleDeclarations$;
function $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidStyleDeclarations$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidStyleDeclarations$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidStyleDeclarations$ = new $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidStyleDeclarations$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidStyleDeclarations$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidVertexLabelFallback$__extractVertexLabelsFromLine__T__sci_Map($thiz, line) {
  return $m_s_Option$().m2($f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(new $c_sc_Iterator$$anon$9(new $c_sc_Iterator$$anon$10($thiz.aw4.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$5) => _$5.Pk(line)))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((m) => new $c_T2($f_s_util_matching_Regex$MatchData__group__I__T(m, 1), $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$().aQx($f_s_util_matching_Regex$MatchData__group__I__T(m, 2)))))), new $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidVertexLabelFallback$$anon$1())).eX($m_s_$less$colon$less$().b1);
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidVertexLabelFallback$() {
  this.aw4 = null;
  $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidVertexLabelFallback$ = this;
  this.aw4 = new $c_sci_$colon$colon($ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "([A-Za-z0-9_][A-Za-z0-9_-]*)\\s*\\[\\(([^\\]]+?)\\)\\]", $m_sci_Nil$()), new $c_sci_$colon$colon($ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "([A-Za-z0-9_][A-Za-z0-9_-]*)\\s*\\(\\[([^\\]]+?)\\]\\)", $m_sci_Nil$()), new $c_sci_$colon$colon($ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "([A-Za-z0-9_][A-Za-z0-9_-]*)\\s*\\(\\(([^\\)]+?)\\)\\)", $m_sci_Nil$()), new $c_sci_$colon$colon($ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "([A-Za-z0-9_][A-Za-z0-9_-]*)\\s*\\{\\{([^\\}]+?)\\}\\}", $m_sci_Nil$()), new $c_sci_$colon$colon($ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "([A-Za-z0-9_][A-Za-z0-9_-]*)\\s*\\{([^\\}]+?)\\}", $m_sci_Nil$()), new $c_sci_$colon$colon($ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "([A-Za-z0-9_][A-Za-z0-9_-]*)\\s*\\[([^\\]]+?)\\]", $m_sci_Nil$()), $m_sci_Nil$()))))));
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidVertexLabelFallback$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidVertexLabelFallback$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidVertexLabelFallback$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidVertexLabelFallback$.prototype = $p;
$p.bbY = (function(sourceText, vertices) {
  var labels = this.aNY(sourceText);
  return vertices.kP(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    if ((x$1 !== null)) {
      var rawKey = x$1.g();
      var vertex = x$1.h();
      var candidateIds = $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_T.r().C)([rawKey, vertex.qi]))).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => $f_T__trim__T(_$1)))).bw(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => (_$2 !== "")))).nz();
      var parserMissingLabel = (($f_T__trim__T(vertex.x3) === "") || $f_sc_SeqOps__contains__O__Z(candidateIds, vertex.x3));
      var this$6 = new $c_sc_Iterator$$anon$10(candidateIds.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((id) => labels.r(id))));
      _return: {
        while (this$6.p()) {
          var a = this$6.q();
          if ((a !== "")) {
            var sourceLabel = new $c_s_Some(a);
            break _return;
          }
        }
        var sourceLabel = $m_s_None$();
      }
      if (parserMissingLabel) {
        var this$9 = ((sourceLabel.c() || (!$f_sc_SeqOps__contains__O__Z(candidateIds, sourceLabel.d()))) ? sourceLabel : $m_s_None$());
        if (this$9.c()) {
          var this$12 = $m_s_None$();
        } else {
          var x0$1 = this$9.d();
          var this$12 = new $c_s_Some(new $c_T2(rawKey, new $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidVertex(vertex.qi, x0$1, vertex.G1, vertex.C2, vertex.vf, vertex.C1, vertex.C3)));
        }
        return (this$12.c() ? new $c_T2(rawKey, vertex) : this$12.d());
      } else {
        return new $c_T2(rawKey, vertex);
      }
    }
    throw new $c_s_MatchError(x$1);
  })));
});
$p.aNY = (function(sourceText) {
  var this$10 = new $c_sc_Iterator$$anon$6(new $c_sc_Iterator$$anon$6(new $c_sc_Iterator$$anon$9(new $c_sc_StringOps$$anon$1(sourceText, true), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4) => $f_T__trim__T(_$4)))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((line) => (line !== ""))), false), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((line$2) => $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$().aPp(line$2))), true);
  var z = $m_sci_Map$EmptyMap$();
  var result = z;
  while (this$10.p()) {
    var x0 = result;
    var x1 = this$10.q();
    result = x0.hN($p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidVertexLabelFallback$__extractVertexLabelsFromLine__T__sci_Map($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidVertexLabelFallback$(), x1));
  }
  return result;
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidVertexLabelFallback$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidVertexLabelFallback$, "org.jpablo.graphexplorer.viewer.backends.mermaid.MermaidVertexLabelFallback$", ({
  ya: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidVertexLabelFallback$;
function $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidVertexLabelFallback$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidVertexLabelFallback$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidVertexLabelFallback$ = new $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidVertexLabelFallback$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidVertexLabelFallback$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_ToViewerGraph$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_ToViewerGraph$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_ToViewerGraph$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_ToViewerGraph$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_ToViewerGraph$package$.prototype = $p;
$p.bag = (function(mermaidGraph) {
  $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$();
  return new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_ToViewerGraph$package$().bai(mermaidGraph), "mermaid", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$__digraph__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType(), ($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$(), 0), ($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$(), 0), ($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$(), $m_sci_Map$EmptyMap$()));
});
$p.bai = (function(mermaidGraph) {
  var referencedNodeIds = $m_sci_Set$().af(new $c_sc_Iterator$$anon$10(mermaidGraph.Lw.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e) => $m_sr_ScalaRunTime$().f(new ($d_T.r().C)([e.ve, e.vd])).o())))).dI($m_sci_Set$().af(new $c_sc_Iterator$$anon$10(mermaidGraph.BZ.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => _$1.C0)))));
  var subgraphIds = $m_sci_Set$().af(new $c_sc_Iterator$$anon$9(mermaidGraph.BZ.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => _$2.x2))));
  var this$18 = mermaidGraph.Lx.o();
  var z = $m_sci_VectorMap$().jg;
  var f$3 = ((x$1, x$2) => {
    var x1 = new $c_T2(x$1, x$2);
    var x3 = x1.be;
    var acc = x1.bi;
    if ((x3 !== null)) {
      var rawKey = x3.g();
      var vertex = x3.h();
      var this$10 = $m_s_Option$().as(vertex.qi);
      var vertexId = ((this$10.c() || (this$10.d() !== "")) ? this$10 : $m_s_None$());
      if (referencedNodeIds.E(rawKey)) {
        var canonicalId = rawKey;
      } else {
        if (vertexId.c()) {
          var $x_1 = true;
        } else {
          var x0$1 = vertexId.d();
          var $x_1 = referencedNodeIds.E(x0$1);
        }
        if ($x_1) {
          var this$13 = vertexId;
        } else {
          var this$13 = $m_s_None$();
        }
        var canonicalId = (this$13.c() ? rawKey : this$13.d());
      }
      $m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$();
      var nodeId = new $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId(canonicalId);
      var attrs = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_ToViewerGraph$package$().bbl(new $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidVertex(canonicalId, vertex.x3, vertex.G1, vertex.C2, vertex.vf, vertex.C1, vertex.C3));
      return ((subgraphIds.E(canonicalId) || acc.l8.E(nodeId)) ? acc : acc.AJ(nodeId, ($m_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$(), $m_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$(), new $c_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode(nodeId, attrs, ($m_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$(), $m_s_None$())))));
    }
    throw new $c_s_MatchError(x1);
  });
  if ($is_sc_IndexedSeq(this$18)) {
    var at = 0;
    var end = this$18.C();
    var acc$1 = z;
    var $x_2;
    while (true) {
      if ((at !== end)) {
        var temp$at = ((1 + at) | 0);
        var x0$2 = acc$1;
        var x1$1 = this$18.l(at);
        var temp$acc = f$3(x0$2, x1$1);
        at = temp$at;
        acc$1 = temp$acc;
        continue;
      }
      var $x_2 = acc$1;
      break;
    }
  } else {
    var result = z;
    while (this$18.p()) {
      var x0$3 = result;
      var x1$2 = this$18.q();
      result = f$3(x0$3, x1$2);
    }
    var $x_2 = result;
  }
  var nodes = $x_2;
  var edgeCounts = $f_scm_Map__withDefaultValue__O__scm_Map($m_scm_Map$().dr($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([]))), 0);
  var this$27 = mermaidGraph.Lw;
  var f$4 = ((edge) => {
    $m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$();
    var sourceId = new $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId(edge.ve);
    $m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$();
    var targetId = new $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId(edge.vd);
    var key = new $c_T2(edge.ve, edge.vd);
    edgeCounts.cY(key, ((1 + (edgeCounts.i(key) | 0)) | 0));
    var seq = (edgeCounts.i(key) | 0);
    var attrs$1 = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_ToViewerGraph$package$().b0m(edge);
    $m_Lorg_jpablo_graphexplorer_viewer_models_Arrow$();
    var arrow = new $c_Lorg_jpablo_graphexplorer_viewer_models_Arrow(sourceId, targetId, attrs$1, ($m_Lorg_jpablo_graphexplorer_viewer_models_Arrow$(), $m_s_None$()), ($m_Lorg_jpablo_graphexplorer_viewer_models_Arrow$(), $m_s_None$()), seq);
    return new $c_T2(arrow.dw, arrow);
  });
  var $x_4 = $m_sci_Map$();
  if ((this$27 === $m_sci_Nil$())) {
    var $x_3 = $m_sci_Nil$();
  } else {
    var x0$4 = this$27.t();
    var h = new $c_sci_$colon$colon(f$4(x0$4), $m_sci_Nil$());
    var t = h;
    var rest = this$27.v();
    while ((rest !== $m_sci_Nil$())) {
      var x0$5 = rest.t();
      var nx = new $c_sci_$colon$colon(f$4(x0$5), $m_sci_Nil$());
      t.U = nx;
      t = nx;
      rest = rest.v();
    }
    var $x_3 = h;
  }
  var arrows = $x_4.ao($x_3);
  var subgraphVertexStyles = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$10(mermaidGraph.Lx.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    if ((x$1$2 !== null)) {
      var rawKey$1 = x$1$2.g();
      var v = x$1$2.h();
      var sid = (subgraphIds.E(rawKey$1) ? new $c_s_Some(rawKey$1) : (subgraphIds.E(v.qi) ? new $c_s_Some(v.qi) : $m_s_None$()));
      var this$33 = ((sid.c() || (sid.d(), (!v.vf.c()))) ? sid : $m_s_None$());
      return (this$33.c() ? $m_s_None$() : new $c_s_Some(new $c_T2(this$33.d(), v.vf)));
    }
    throw new $c_s_MatchError(x$1$2);
  }))));
  var this$42 = mermaidGraph.BZ;
  var f$6 = ((subgraph) => {
    $m_Lorg_jpablo_graphexplorer_viewer_models_GroupId$();
    var groupId = new $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId(subgraph.x2);
    var attrs$2 = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_ToViewerGraph$package$().b9o(subgraph, subgraphVertexStyles.ay(subgraph.x2, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_Nil$()))));
    return new $c_T2(groupId, $m_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$().a3J(groupId, attrs$2));
  });
  var $x_6 = $m_sci_Map$();
  if ((this$42 === $m_sci_Nil$())) {
    var $x_5 = $m_sci_Nil$();
  } else {
    var x0$8 = this$42.t();
    var h$1 = new $c_sci_$colon$colon(f$6(x0$8), $m_sci_Nil$());
    var t$1 = h$1;
    var rest$1 = this$42.v();
    while ((rest$1 !== $m_sci_Nil$())) {
      var x0$9 = rest$1.t();
      var nx$1 = new $c_sci_$colon$colon(f$6(x0$9), $m_sci_Nil$());
      t$1.U = nx$1;
      t$1 = nx$1;
      rest$1 = rest$1.v();
    }
    var $x_5 = h$1;
  }
  var groups = $x_6.ao($x_5);
  var $x_8 = $m_sci_VectorMap$();
  var this$45 = mermaidGraph.BZ;
  var rest$2 = this$45;
  var h$2 = null;
  var t$2 = null;
  while ((rest$2 !== $m_sci_Nil$())) {
    var x0$10 = rest$2.t();
    $m_Lorg_jpablo_graphexplorer_viewer_models_GroupId$();
    var groupId$1 = new $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId(x0$10.x2);
    var this$51 = x0$10.C0;
    var f$7 = ((subgraphIds, groupId$1) => ((memberId) => new $c_T2((subgraphIds.E(memberId) ? ($m_Lorg_jpablo_graphexplorer_viewer_models_GroupId$(), new $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId(memberId)) : ($m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$(), new $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId(memberId))), groupId$1)))(subgraphIds, groupId$1);
    if ((this$51 === $m_sci_Nil$())) {
      var $x_7 = $m_sci_Nil$();
    } else {
      var x0$11 = this$51.t();
      var h$3 = new $c_sci_$colon$colon(f$7(x0$11), $m_sci_Nil$());
      var t$3 = h$3;
      var rest$3 = this$51.v();
      while ((rest$3 !== $m_sci_Nil$())) {
        var x0$12 = rest$3.t();
        var nx$2 = new $c_sci_$colon$colon(f$7(x0$12), $m_sci_Nil$());
        t$3.U = nx$2;
        t$3 = nx$2;
        rest$3 = rest$3.v();
      }
      var $x_7 = h$3;
    }
    var it = $x_7.o();
    while (it.p()) {
      var nx$3 = new $c_sci_$colon$colon(it.q(), $m_sci_Nil$());
      if ((t$2 === null)) {
        h$2 = nx$3;
      } else {
        t$2.U = nx$3;
      }
      t$2 = nx$3;
    }
    rest$2 = rest$2.v();
  }
  var memberships = $x_8.u3(((h$2 === null) ? $m_sci_Nil$() : h$2));
  var missingNodes = arrows.e6().c5(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6) => _$6.aft()))).cE(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((key$1) => nodes.l8.E(key$1))));
  var allNodes = $f_sci_StrictOptimizedMapOps__concat__sc_IterableOnce__sci_MapOps(nodes, missingNodes.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((nid) => {
    $m_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$();
    var attributes = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV;
    $m_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$();
    return new $c_T2(nid, new $c_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode(nid, attributes, ($m_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$(), $m_s_None$())));
  }))));
  var graphAttrs = new $c_scm_ListBuffer().kU($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([])));
  var this$58 = mermaidGraph.SD;
  if ((!this$58.c())) {
    var x0$13 = this$58.d();
    graphAttrs.bb(new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$())), ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(x0$13))));
  }
  var this$63 = mermaidGraph.SE;
  if ((!this$63.c())) {
    var x0$14 = this$63.d();
    graphAttrs.bb(new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Label$())), ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(x0$14))));
  }
  mermaidGraph.SB.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3) => {
    matchResult3: {
      if ((x$1$3 !== null)) {
        var name = x$1$3.g();
        var classDef = x$1$3.h();
        if ((!classDef.BY.c())) {
          graphAttrs.bb(new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId((("" + $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$().BV) + name)), ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue($f_sc_IterableOnceOps__mkString__T__T__T__T(classDef.BY, "", ",", "")))));
        }
        if ((!classDef.FW.c())) {
          graphAttrs.bb(new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId((("" + $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$().BW) + name)), ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue($f_sc_IterableOnceOps__mkString__T__T__T__T(classDef.FW, "", ",", "")))));
          break matchResult3;
        } else {
          break matchResult3;
        }
      }
      throw new $c_s_MatchError(x$1$3);
    }
  })));
  if ((!mermaidGraph.Lv.c())) {
    graphAttrs.bb(new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$().a08), ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue($f_sc_IterableOnceOps__mkString__T__T__T__T(mermaidGraph.Lv, "", ",", "")))));
  }
  var this$85 = mermaidGraph.SC;
  if ((!this$85.c())) {
    var x0$15 = this$85.d();
    graphAttrs.bb(new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$().a8J), ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(x0$15))));
  }
  var graphAttributes$1 = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().DZ(graphAttrs);
  $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$();
  var arrowMemberships$1 = $m_sci_Map$EmptyMap$();
  $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$();
  var defaultNodeAttributes$1 = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV;
  $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$();
  var defaultArrowAttributes$1 = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV;
  $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$();
  return new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements(allNodes, arrows, memberships, arrowMemberships$1, groups, graphAttributes$1, defaultNodeAttributes$1, defaultArrowAttributes$1);
});
$p.bbl = (function(vertex) {
  var attrs = new $c_scm_ListBuffer().kU($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([])));
  if ((vertex.x3 !== vertex.qi)) {
    attrs.bb(new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Label$())), ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidLabelText$().aig(vertex.x3)))));
  }
  matchResult4: {
    var \u03b41$___1;
    var \u03b41$___2;
    var this$6 = vertex.C1;
    if (this$6.c()) {
      var x12 = $m_sci_List$().acG;
    } else {
      var l = new $c_scm_ListBuffer();
      var r = new $c_scm_ListBuffer();
      var this$9 = this$6.o();
      while (this$9.p()) {
        var x0 = this$9.q();
        var prefix = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$().a0a;
        ((!(!x0.startsWith(prefix))) ? l : r).bb(x0);
      }
      var x1 = new $c_T2(l.bM(), r.bM());
      var x12 = ($m_sci_Nil$().e(x1.bi) ? new $c_T2($m_sci_Nil$(), this$6) : ($m_sci_Nil$().e(x1.be) ? new $c_T2(this$6, $m_sci_Nil$()) : x1));
    }
    if ((x12 !== null)) {
      var \u03b41$___1 = x12.g();
      var \u03b41$___2 = x12.h();
      break matchResult4;
    }
    throw new $c_s_MatchError(x12);
  }
  var shapeMarkers$2 = \u03b41$___1;
  var cssClasses$2 = \u03b41$___2;
  matchResult5: {
    var this$12 = shapeMarkers$2.dt();
    var x15 = (this$12.c() ? $m_s_None$() : new $c_s_Some($m_sc_StringOps$().wg(this$12.d(), $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$().a0a)));
    if ((x15 instanceof $c_s_Some)) {
      var dotShape = x15.J;
      attrs.bb(new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$())), ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(dotShape))));
      break matchResult5;
    }
    if (($m_s_None$() === x15)) {
      var this$18 = vertex.C3;
      if ((!this$18.c())) {
        var x0$2 = this$18.d();
        attrs.bb(new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$())), ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_ToViewerGraph$package$().b4q(x0$2)))));
        if (((x0$2 === "round") || (x0$2 === "rounded"))) {
          attrs.bb(new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$())), ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue("rounded"))));
          break matchResult5;
        } else {
          break matchResult5;
        }
      } else {
        break matchResult5;
      }
    }
    throw new $c_s_MatchError(x15);
  }
  var this$27 = vertex.C2;
  if ((!this$27.c())) {
    var x0$3 = this$27.d();
    attrs.bb(new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$().avR), ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(x0$3))));
  }
  if ((!vertex.vf.c())) {
    attrs.bb(new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$())), ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue($f_sc_IterableOnceOps__mkString__T__T__T__T(vertex.vf, "", ",", "")))));
  }
  if ((!cssClasses$2.c())) {
    attrs.bb(new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$().FV), ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue($f_sc_IterableOnceOps__mkString__T__T__T__T(cssClasses$2, "", " ", "")))));
  }
  return $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().DZ(attrs);
});
$p.b0m = (function(edge) {
  var attrs = new $c_scm_ListBuffer().kU($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([])));
  var this$2 = edge.FZ;
  var this$5 = ((this$2.c() || (this$2.d() !== "")) ? this$2 : $m_s_None$());
  if ((!this$5.c())) {
    var x0$1 = this$5.d();
    attrs.bb(new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Label$())), ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidLabelText$().aig(x0$1)))));
  }
  var this$10 = edge.Lu;
  if ((!this$10.c())) {
    var x0$2 = this$10.d();
    if ((x0$2 === "dotted")) {
      attrs.bb(new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$())), ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue("dashed"))));
    } else if ((x0$2 === "thick")) {
      attrs.bb(new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$())), ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue("bold"))));
    }
  }
  matchResult7: {
    var x19 = edge.FX;
    if ((x19 instanceof $c_s_Some)) {
      var x23 = x19.J;
      if ((!(!x23.startsWith("double_")))) {
        attrs.bb(new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowTail$())), ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue("normal"))));
        break matchResult7;
      }
      if ((x23 === "arrow_open")) {
        attrs.bb(new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowHead$())), ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue("none"))));
        break matchResult7;
      }
    }
  }
  var this$27 = edge.FX;
  if ((!this$27.c())) {
    var x0$3 = this$27.d();
    attrs.bb(new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$().avS), ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(x0$3))));
  }
  if ((!edge.FY.c())) {
    attrs.bb(new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$().a09), ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue($f_sc_IterableOnceOps__mkString__T__T__T__T(edge.FY, "", ",", "")))));
  }
  var this$36 = edge.Lt;
  if ((!this$36.c())) {
    var x0$4 = this$36.d();
    attrs.bb(new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$().a8K), ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(x0$4))));
  }
  return $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().DZ(attrs);
});
$p.b9o = (function(subgraph, styles) {
  var attrs = new $c_scm_ListBuffer().kU($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([])));
  var this$2 = subgraph.Ly;
  if ((!this$2.c())) {
    var x0 = this$2.d();
    attrs.bb(new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Label$())), ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidLabelText$().aig(x0)))));
  }
  if ((!styles.c())) {
    attrs.bb(new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$())), ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue($f_sc_IterableOnceOps__mkString__T__T__T__T(styles, "", ",", "")))));
  }
  if ((!subgraph.G0.c())) {
    attrs.bb(new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$().FV), ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue($f_sc_IterableOnceOps__mkString__T__T__T__T(subgraph.G0, "", " ", "")))));
  }
  return $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().DZ(attrs);
});
$p.b4q = (function(mermaidShape) {
  switch (mermaidShape.toLowerCase()) {
    case "rect":
    case "rectangle": {
      return "box";
      break;
    }
    case "round":
    case "rounded": {
      return "box";
      break;
    }
    case "stadium": {
      return "ellipse";
      break;
    }
    case "subroutine": {
      return "folder";
      break;
    }
    case "cylinder":
    case "database": {
      return "cylinder";
      break;
    }
    case "circle": {
      return "circle";
      break;
    }
    case "ellipse": {
      return "ellipse";
      break;
    }
    case "diamond":
    case "rhombus": {
      return "diamond";
      break;
    }
    case "hexagon": {
      return "hexagon";
      break;
    }
    case "parallelogram": {
      return "parallelogram";
      break;
    }
    case "parallelogram-alt": {
      return "parallelogram";
      break;
    }
    case "trapezoid": {
      return "trapezium";
      break;
    }
    case "trapezoid-alt": {
      return "invtrapezium";
      break;
    }
    case "double-circle":
    case "doublecircle": {
      return "doublecircle";
      break;
    }
    default: {
      return "box";
    }
  }
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_ToViewerGraph$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_ToViewerGraph$package$, "org.jpablo.graphexplorer.viewer.backends.mermaid.ToViewerGraph$package$", ({
  yc: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_ToViewerGraph$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_ToViewerGraph$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_ToViewerGraph$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_ToViewerGraph$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_ToViewerGraph$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_ToViewerGraph$package$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_threejs_LineBasicMaterial$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_threejs_LineBasicMaterial$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_threejs_LineBasicMaterial$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_threejs_LineBasicMaterial$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_threejs_LineBasicMaterial$.prototype = $p;
$p.b6j = (function(vertexColors, transparent, opacity) {
  return $m_sjs_js_special_package$().eA($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("vertexColors", vertexColors), new $c_T2("transparent", transparent), new $c_T2("opacity", opacity)])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_threejs_LineBasicMaterial$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_threejs_LineBasicMaterial$, "org.jpablo.graphexplorer.viewer.backends.threejs.LineBasicMaterial$", ({
  yd: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_backends_threejs_LineBasicMaterial$;
function $m_Lorg_jpablo_graphexplorer_viewer_backends_threejs_LineBasicMaterial$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_backends_threejs_LineBasicMaterial$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_backends_threejs_LineBasicMaterial$ = new $c_Lorg_jpablo_graphexplorer_viewer_backends_threejs_LineBasicMaterial$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_backends_threejs_LineBasicMaterial$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_threejs_MeshBasicMaterial$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_threejs_MeshBasicMaterial$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_threejs_MeshBasicMaterial$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_threejs_MeshBasicMaterial$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_threejs_MeshBasicMaterial$.prototype = $p;
$p.Ay = (function(color, transparent, opacity, depthWrite, side, colorWrite) {
  return $m_sjs_js_special_package$().eA($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("color", color), new $c_T2("transparent", transparent), new $c_T2("opacity", opacity), new $c_T2("depthWrite", depthWrite), new $c_T2("side", side), new $c_T2("colorWrite", colorWrite)])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_threejs_MeshBasicMaterial$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_threejs_MeshBasicMaterial$, "org.jpablo.graphexplorer.viewer.backends.threejs.MeshBasicMaterial$", ({
  ye: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_backends_threejs_MeshBasicMaterial$;
function $m_Lorg_jpablo_graphexplorer_viewer_backends_threejs_MeshBasicMaterial$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_backends_threejs_MeshBasicMaterial$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_backends_threejs_MeshBasicMaterial$ = new $c_Lorg_jpablo_graphexplorer_viewer_backends_threejs_MeshBasicMaterial$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_backends_threejs_MeshBasicMaterial$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_threejs_SpriteMaterial$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_threejs_SpriteMaterial$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_threejs_SpriteMaterial$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_threejs_SpriteMaterial$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_threejs_SpriteMaterial$.prototype = $p;
$p.b6l = (function(map, transparent) {
  return $m_sjs_js_special_package$().eA($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("map", map), new $c_T2("transparent", transparent)])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_threejs_SpriteMaterial$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_threejs_SpriteMaterial$, "org.jpablo.graphexplorer.viewer.backends.threejs.SpriteMaterial$", ({
  yf: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_backends_threejs_SpriteMaterial$;
function $m_Lorg_jpablo_graphexplorer_viewer_backends_threejs_SpriteMaterial$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_backends_threejs_SpriteMaterial$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_backends_threejs_SpriteMaterial$ = new $c_Lorg_jpablo_graphexplorer_viewer_backends_threejs_SpriteMaterial$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_backends_threejs_SpriteMaterial$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_threejs_WebGLRenderer$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_threejs_WebGLRenderer$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_threejs_WebGLRenderer$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_threejs_WebGLRenderer$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_threejs_WebGLRenderer$.prototype = $p;
$p.b6k = (function(antialias, alpha) {
  return $m_sjs_js_special_package$().eA($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("antialias", antialias), new $c_T2("alpha", alpha)])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_threejs_WebGLRenderer$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_threejs_WebGLRenderer$, "org.jpablo.graphexplorer.viewer.backends.threejs.WebGLRenderer$", ({
  yg: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_backends_threejs_WebGLRenderer$;
function $m_Lorg_jpablo_graphexplorer_viewer_backends_threejs_WebGLRenderer$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_backends_threejs_WebGLRenderer$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_backends_threejs_WebGLRenderer$ = new $c_Lorg_jpablo_graphexplorer_viewer_backends_threejs_WebGLRenderer$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_backends_threejs_WebGLRenderer$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$() {
  this.aw5 = null;
  this.aw6 = null;
  $n_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ = this;
  this.aw5 = $m_sci_VectorMap$().u3($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("red-50", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.971, 0.013, 17.38)), new $c_T2("red-100", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.936, 0.032, 17.717)), new $c_T2("red-200", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.885, 0.062, 18.334)), new $c_T2("red-300", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.808, 0.114, 19.571)), new $c_T2("red-400", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.704, 0.191, 22.216)), new $c_T2("red-500", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.637, 0.237, 25.331)), new $c_T2("red-600", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.577, 0.245, 27.325)), new $c_T2("red-700", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.505, 0.213, 27.518)), new $c_T2("red-800", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.444, 0.177, 26.899)), new $c_T2("red-900", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.396, 0.141, 25.723)), new $c_T2("red-950", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.258, 0.092, 26.042)), new $c_T2("orange-50", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.98, 0.016, 73.684)), new $c_T2("orange-100", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.954, 0.038, 75.164)), new $c_T2("orange-200", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.901, 0.076, 70.697)), new $c_T2("orange-300", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.837, 0.128, 66.29)), new $c_T2("orange-400", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.75, 0.183, 55.934)), new $c_T2("orange-500", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.705, 0.213, 47.604)), new $c_T2("orange-600", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.646, 0.222, 41.116)), new $c_T2("orange-700", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.553, 0.195, 38.402)), new $c_T2("orange-800", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.47, 0.157, 37.304)), new $c_T2("orange-900", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.408, 0.123, 38.172)), new $c_T2("orange-950", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.266, 0.079, 36.259)), new $c_T2("amber-50", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.987, 0.022, 95.277)), new $c_T2("amber-100", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.962, 0.059, 95.617)), new $c_T2("amber-200", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.924, 0.12, 95.746)), new $c_T2("amber-300", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.879, 0.169, 91.605)), new $c_T2("amber-400", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.828, 0.189, 84.429)), new $c_T2("amber-500", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.769, 0.188, 70.08)), new $c_T2("amber-600", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.666, 0.179, 58.318)), new $c_T2("amber-700", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.555, 0.163, 48.998)), new $c_T2("amber-800", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.473, 0.137, 46.201)), new $c_T2("amber-900", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.414, 0.112, 45.904)), new $c_T2("amber-950", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.279, 0.077, 45.635)), new $c_T2("yellow-50", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.987, 0.026, 102.212)), new $c_T2("yellow-100", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.973, 0.071, 103.193)), new $c_T2("yellow-200", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.945, 0.129, 101.54)), new $c_T2("yellow-300", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.905, 0.182, 98.111)), new $c_T2("yellow-400", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.852, 0.199, 91.936)), new $c_T2("yellow-500", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.795, 0.184, 86.047)), new $c_T2("yellow-600", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.681, 0.162, 75.834)), new $c_T2("yellow-700", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.554, 0.135, 66.442)), new $c_T2("yellow-800", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.476, 0.114, 61.907)), new $c_T2("yellow-900", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.421, 0.095, 57.708)), new $c_T2("yellow-950", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.286, 0.066, 53.813)), new $c_T2("lime-50", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.986, 0.031, 120.757)), new $c_T2("lime-100", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.967, 0.067, 122.328)), new $c_T2("lime-200", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.938, 0.127, 124.321)), new $c_T2("lime-300", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.897, 0.196, 126.665)), new $c_T2("lime-400", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.841, 0.238, 128.85)), new $c_T2("lime-500", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.768, 0.233, 130.85)), new $c_T2("lime-600", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.648, 0.2, 131.684)), new $c_T2("lime-700", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.532, 0.157, 131.589)), new $c_T2("lime-800", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.453, 0.124, 130.933)), new $c_T2("lime-900", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.405, 0.101, 131.063)), new $c_T2("lime-950", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.274, 0.072, 132.109)), new $c_T2("green-50", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.982, 0.018, 155.826)), new $c_T2("green-100", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.962, 0.044, 156.743)), new $c_T2("green-200", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.925, 0.084, 155.995)), new $c_T2("green-300", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.871, 0.15, 154.449)), new $c_T2("green-400", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.792, 0.209, 151.711)), new $c_T2("green-500", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.723, 0.219, 149.579)), new $c_T2("green-600", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.627, 0.194, 149.214)), new $c_T2("green-700", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.527, 0.154, 150.069)), new $c_T2("green-800", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.448, 0.119, 151.328)), new $c_T2("green-900", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.393, 0.095, 152.535)), new $c_T2("green-950", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.266, 0.065, 152.934)), new $c_T2("emerald-50", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.979, 0.021, 166.113)), new $c_T2("emerald-100", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.95, 0.052, 163.051)), new $c_T2("emerald-200", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.905, 0.093, 164.15)), new $c_T2("emerald-300", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.845, 0.143, 164.978)), new $c_T2("emerald-400", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.765, 0.177, 163.223)), new $c_T2("emerald-500", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.696, 0.17, 162.48)), new $c_T2("emerald-600", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.596, 0.145, 163.225)), new $c_T2("emerald-700", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.508, 0.118, 165.612)), new $c_T2("emerald-800", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.432, 0.095, 166.913)), new $c_T2("emerald-900", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.378, 0.077, 168.94)), new $c_T2("emerald-950", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.262, 0.051, 172.552)), new $c_T2("teal-50", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.984, 0.014, 180.72)), new $c_T2("teal-100", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.953, 0.051, 180.801)), new $c_T2("teal-200", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.91, 0.096, 180.426)), new $c_T2("teal-300", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.855, 0.138, 181.071)), new $c_T2("teal-400", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.777, 0.152, 181.912)), new $c_T2("teal-500", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.704, 0.14, 182.503)), new $c_T2("teal-600", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.6, 0.118, 184.704)), new $c_T2("teal-700", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.511, 0.096, 186.391)), new $c_T2("teal-800", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.437, 0.078, 188.216)), new $c_T2("teal-900", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.386, 0.063, 188.416)), new $c_T2("teal-950", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.277, 0.046, 192.524)), new $c_T2("cyan-50", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.984, 0.019, 200.873)), new $c_T2("cyan-100", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.956, 0.045, 203.388)), new $c_T2("cyan-200", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.917, 0.08, 205.041)), new $c_T2("cyan-300", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.865, 0.127, 207.078)), new $c_T2("cyan-400", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.789, 0.154, 211.53)), new $c_T2("cyan-500", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.715, 0.143, 215.221)), new $c_T2("cyan-600", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.609, 0.126, 221.723)), new $c_T2("cyan-700", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.52, 0.105, 223.128)), new $c_T2("cyan-800", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.45, 0.085, 224.283)), new $c_T2("cyan-900", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.398, 0.07, 227.392)), new $c_T2("cyan-950", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.302, 0.056, 229.695)), new $c_T2("sky-50", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.977, 0.013, 236.62)), new $c_T2("sky-100", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.951, 0.026, 236.824)), new $c_T2("sky-200", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.901, 0.058, 230.902)), new $c_T2("sky-300", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.828, 0.111, 230.318)), new $c_T2("sky-400", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.746, 0.16, 232.661)), new $c_T2("sky-500", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.685, 0.169, 237.323)), new $c_T2("sky-600", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.588, 0.158, 241.966)), new $c_T2("sky-700", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.5, 0.134, 242.749)), new $c_T2("sky-800", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.443, 0.11, 240.79)), new $c_T2("sky-900", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.391, 0.09, 240.876)), new $c_T2("sky-950", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.293, 0.066, 243.157)), new $c_T2("blue-50", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.97, 0.014, 254.604)), new $c_T2("blue-100", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.932, 0.032, 255.585)), new $c_T2("blue-200", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.882, 0.059, 254.128)), new $c_T2("blue-300", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.809, 0.105, 251.813)), new $c_T2("blue-400", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.707, 0.165, 254.624)), new $c_T2("blue-500", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.623, 0.214, 259.815)), new $c_T2("blue-600", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.546, 0.245, 262.881)), new $c_T2("blue-700", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.488, 0.243, 264.376)), new $c_T2("blue-800", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.424, 0.199, 265.638)), new $c_T2("blue-900", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.379, 0.146, 265.522)), new $c_T2("blue-950", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.282, 0.091, 267.935)), new $c_T2("indigo-50", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.962, 0.018, 272.314)), new $c_T2("indigo-100", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.93, 0.034, 272.788)), new $c_T2("indigo-200", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.87, 0.065, 274.039)), new $c_T2("indigo-300", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.785, 0.115, 274.713)), new $c_T2("indigo-400", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.673, 0.182, 276.935)), new $c_T2("indigo-500", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.585, 0.233, 277.117)), new $c_T2("indigo-600", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.511, 0.262, 276.966)), new $c_T2("indigo-700", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.457, 0.24, 277.023)), new $c_T2("indigo-800", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.398, 0.195, 277.366)), new $c_T2("indigo-900", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.359, 0.144, 278.697)), new $c_T2("indigo-950", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.257, 0.09, 281.288)), new $c_T2("violet-50", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.969, 0.016, 293.756)), new $c_T2("violet-100", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.943, 0.029, 294.588)), new $c_T2("violet-200", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.894, 0.057, 293.283)), new $c_T2("violet-300", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.811, 0.111, 293.571)), new $c_T2("violet-400", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.702, 0.183, 293.541)), new $c_T2("violet-500", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.606, 0.25, 292.717)), new $c_T2("violet-600", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.541, 0.281, 293.009)), new $c_T2("violet-700", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.491, 0.27, 292.581)), new $c_T2("violet-800", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.432, 0.232, 292.759)), new $c_T2("violet-900", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.38, 0.189, 293.745)), new $c_T2("violet-950", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.283, 0.141, 291.089)), new $c_T2("purple-50", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.977, 0.014, 308.299)), new $c_T2("purple-100", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.946, 0.033, 307.174)), new $c_T2("purple-200", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.902, 0.063, 306.703)), new $c_T2("purple-300", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.827, 0.119, 306.383)), new $c_T2("purple-400", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.714, 0.203, 305.504)), new $c_T2("purple-500", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.627, 0.265, 303.9)), new $c_T2("purple-600", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.558, 0.288, 302.321)), new $c_T2("purple-700", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.496, 0.265, 301.924)), new $c_T2("purple-800", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.438, 0.218, 303.724)), new $c_T2("purple-900", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.381, 0.176, 304.987)), new $c_T2("purple-950", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.291, 0.149, 302.717)), new $c_T2("fuchsia-50", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.977, 0.017, 320.058)), new $c_T2("fuchsia-100", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.952, 0.037, 318.852)), new $c_T2("fuchsia-200", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.903, 0.076, 319.62)), new $c_T2("fuchsia-300", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.833, 0.145, 321.434)), new $c_T2("fuchsia-400", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.74, 0.238, 322.16)), new $c_T2("fuchsia-500", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.667, 0.295, 322.15)), new $c_T2("fuchsia-600", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.591, 0.293, 322.896)), new $c_T2("fuchsia-700", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.518, 0.253, 323.949)), new $c_T2("fuchsia-800", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.452, 0.211, 324.591)), new $c_T2("fuchsia-900", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.401, 0.17, 325.612)), new $c_T2("fuchsia-950", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.293, 0.136, 325.661)), new $c_T2("pink-50", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.971, 0.014, 343.198)), new $c_T2("pink-100", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.948, 0.028, 342.258)), new $c_T2("pink-200", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.899, 0.061, 343.231)), new $c_T2("pink-300", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.823, 0.12, 346.018)), new $c_T2("pink-400", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.718, 0.202, 349.761)), new $c_T2("pink-500", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.656, 0.241, 354.308)), new $c_T2("pink-600", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.592, 0.249, 0.584)), new $c_T2("pink-700", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.525, 0.223, 3.958)), new $c_T2("pink-800", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.459, 0.187, 3.815)), new $c_T2("pink-900", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.408, 0.153, 2.432)), new $c_T2("pink-950", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.284, 0.109, 3.907)), new $c_T2("rose-50", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.969, 0.015, 12.422)), new $c_T2("rose-100", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.941, 0.03, 12.58)), new $c_T2("rose-200", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.892, 0.058, 10.001)), new $c_T2("rose-300", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.81, 0.117, 11.638)), new $c_T2("rose-400", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.712, 0.194, 13.428)), new $c_T2("rose-500", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.645, 0.246, 16.439)), new $c_T2("rose-600", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.586, 0.253, 17.585)), new $c_T2("rose-700", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.514, 0.222, 16.935)), new $c_T2("rose-800", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.455, 0.188, 13.697)), new $c_T2("rose-900", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.41, 0.159, 10.272)), new $c_T2("rose-950", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.271, 0.105, 12.094)), new $c_T2("slate-50", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.984, 0.003, 247.858)), new $c_T2("slate-100", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.968, 0.007, 247.896)), new $c_T2("slate-200", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.929, 0.013, 255.508)), new $c_T2("slate-300", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.869, 0.022, 252.894)), new $c_T2("slate-400", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.704, 0.04, 256.788)), new $c_T2("slate-500", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.554, 0.046, 257.417)), new $c_T2("slate-600", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.446, 0.043, 257.281)), new $c_T2("slate-700", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.372, 0.044, 257.287)), new $c_T2("slate-800", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.279, 0.041, 260.031)), new $c_T2("slate-900", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.208, 0.042, 265.755)), new $c_T2("slate-950", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.129, 0.042, 264.695)), new $c_T2("gray-50", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.985, 0.002, 247.839)), new $c_T2("gray-100", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.967, 0.003, 264.542)), new $c_T2("gray-200", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.928, 0.006, 264.531)), new $c_T2("gray-300", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.872, 0.01, 258.338)), new $c_T2("gray-400", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.707, 0.022, 261.325)), new $c_T2("gray-500", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.551, 0.027, 264.364)), new $c_T2("gray-600", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.446, 0.03, 256.802)), new $c_T2("gray-700", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.373, 0.034, 259.733)), new $c_T2("gray-800", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.278, 0.033, 256.848)), new $c_T2("gray-900", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.21, 0.034, 264.665)), new $c_T2("gray-950", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.13, 0.028, 261.692)), new $c_T2("zinc-50", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.985, 0.0, 0.0)), new $c_T2("zinc-100", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.967, 0.001, 286.375)), new $c_T2("zinc-200", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.92, 0.004, 286.32)), new $c_T2("zinc-300", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.871, 0.006, 286.286)), new $c_T2("zinc-400", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.705, 0.015, 286.067)), new $c_T2("zinc-500", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.552, 0.016, 285.938)), new $c_T2("zinc-600", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.442, 0.017, 285.786)), new $c_T2("zinc-700", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.37, 0.013, 285.805)), new $c_T2("zinc-800", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.274, 0.006, 286.033)), new $c_T2("zinc-900", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.21, 0.006, 285.885)), new $c_T2("zinc-950", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.141, 0.005, 285.823)), new $c_T2("neutral-50", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.985, 0.0, 0.0)), new $c_T2("neutral-100", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.97, 0.0, 0.0)), new $c_T2("neutral-200", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.922, 0.0, 0.0)), new $c_T2("neutral-300", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.87, 0.0, 0.0)), new $c_T2("neutral-400", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.708, 0.0, 0.0)), new $c_T2("neutral-500", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.556, 0.0, 0.0)), new $c_T2("neutral-600", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.439, 0.0, 0.0)), new $c_T2("neutral-700", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.371, 0.0, 0.0)), new $c_T2("neutral-800", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.269, 0.0, 0.0)), new $c_T2("neutral-900", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.205, 0.0, 0.0)), new $c_T2("neutral-950", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.145, 0.0, 0.0)), new $c_T2("stone-50", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.985, 0.001, 106.423)), new $c_T2("stone-100", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.97, 0.001, 106.424)), new $c_T2("stone-200", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.923, 0.003, 48.717)), new $c_T2("stone-300", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.869, 0.005, 56.366)), new $c_T2("stone-400", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.709, 0.01, 56.259)), new $c_T2("stone-500", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.553, 0.013, 58.071)), new $c_T2("stone-600", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.444, 0.011, 73.639)), new $c_T2("stone-700", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.374, 0.01, 67.558)), new $c_T2("stone-800", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.268, 0.007, 34.298)), new $c_T2("stone-900", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.216, 0.006, 56.043)), new $c_T2("stone-950", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(0.147, 0.004, 49.25))])));
  var this$728 = this.aw5;
  $m_sci_VectorMap$();
  var b = new $c_sci_VectorMapBuilder();
  var it = new $c_sci_VectorMap$$anon$1(this$728);
  while (it.p()) {
    var x0 = it.dC();
    if ((x0 === null)) {
      throw new $c_s_MatchError(x0);
    }
    b.pm(x0.g(), $m_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$().aQC(x0.h()));
  }
  this.aw6 = b.rb();
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$, "org.jpablo.graphexplorer.viewer.color.TailWindColors$", ({
  yi: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$;
function $m_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ = new $c_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_color_X11Colors$package$() {
  this.aw7 = null;
  $n_Lorg_jpablo_graphexplorer_viewer_color_X11Colors$package$ = this;
  this.aw7 = $m_sci_VectorMap$().u3($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("none", "#fffffe"), new $c_T2("aliceblue", "#f0f8ff"), new $c_T2("antiquewhite", "#faebd7"), new $c_T2("antiquewhite1", "#ffefdb"), new $c_T2("antiquewhite2", "#eedfcc"), new $c_T2("antiquewhite3", "#cdc0b0"), new $c_T2("antiquewhite4", "#8b8378"), new $c_T2("aqua", "#00ffff"), new $c_T2("aquamarine", "#7fffd4"), new $c_T2("aquamarine1", "#7fffd4"), new $c_T2("aquamarine2", "#76eec6"), new $c_T2("aquamarine3", "#66cdaa"), new $c_T2("aquamarine4", "#458b74"), new $c_T2("azure", "#f0ffff"), new $c_T2("azure1", "#f0ffff"), new $c_T2("azure2", "#e0eeee"), new $c_T2("azure3", "#c1cdcd"), new $c_T2("azure4", "#838b8b"), new $c_T2("beige", "#f5f5dc"), new $c_T2("bisque", "#ffe4c4"), new $c_T2("bisque1", "#ffe4c4"), new $c_T2("bisque2", "#eed5b7"), new $c_T2("bisque3", "#cdb79e"), new $c_T2("bisque4", "#8b7d6b"), new $c_T2("black", "#000000"), new $c_T2("blanchedalmond", "#ffebcd"), new $c_T2("blue", "#0000ff"), new $c_T2("blue1", "#0000ff"), new $c_T2("blue2", "#0000ee"), new $c_T2("blue3", "#0000cd"), new $c_T2("blue4", "#00008b"), new $c_T2("blueviolet", "#8a2be2"), new $c_T2("brown", "#a52a2a"), new $c_T2("brown1", "#ff4040"), new $c_T2("brown2", "#ee3b3b"), new $c_T2("brown3", "#cd3333"), new $c_T2("brown4", "#8b2323"), new $c_T2("burlywood", "#deb887"), new $c_T2("burlywood1", "#ffd39b"), new $c_T2("burlywood2", "#eec591"), new $c_T2("burlywood3", "#cdaa7d"), new $c_T2("burlywood4", "#8b7355"), new $c_T2("cadetblue", "#5f9ea0"), new $c_T2("cadetblue1", "#98f5ff"), new $c_T2("cadetblue2", "#8ee5ee"), new $c_T2("cadetblue3", "#7ac5cd"), new $c_T2("cadetblue4", "#53868b"), new $c_T2("chartreuse", "#7fff00"), new $c_T2("chartreuse1", "#7fff00"), new $c_T2("chartreuse2", "#76ee00"), new $c_T2("chartreuse3", "#66cd00"), new $c_T2("chartreuse4", "#458b00"), new $c_T2("chocolate", "#d2691e"), new $c_T2("chocolate1", "#ff7f24"), new $c_T2("chocolate2", "#ee7621"), new $c_T2("chocolate3", "#cd661d"), new $c_T2("chocolate4", "#8b4513"), new $c_T2("coral", "#ff7f50"), new $c_T2("coral1", "#ff7256"), new $c_T2("coral2", "#ee6a50"), new $c_T2("coral3", "#cd5b45"), new $c_T2("coral4", "#8b3e2f"), new $c_T2("cornflowerblue", "#6495ed"), new $c_T2("cornsilk", "#fff8dc"), new $c_T2("cornsilk1", "#fff8dc"), new $c_T2("cornsilk2", "#eee8cd"), new $c_T2("cornsilk3", "#cdc8b1"), new $c_T2("cornsilk4", "#8b8878"), new $c_T2("crimson", "#dc143c"), new $c_T2("cyan", "#00ffff"), new $c_T2("cyan1", "#00ffff"), new $c_T2("cyan2", "#00eeee"), new $c_T2("cyan3", "#00cdcd"), new $c_T2("cyan4", "#008b8b"), new $c_T2("darkblue", "#00008b"), new $c_T2("darkcyan", "#008b8b"), new $c_T2("darkgoldenrod", "#b8860b"), new $c_T2("darkgoldenrod1", "#ffb90f"), new $c_T2("darkgoldenrod2", "#eead0e"), new $c_T2("darkgoldenrod3", "#cd950c"), new $c_T2("darkgoldenrod4", "#8b6508"), new $c_T2("darkgray", "#a9a9a9"), new $c_T2("darkgreen", "#006400"), new $c_T2("darkgrey", "#a9a9a9"), new $c_T2("darkkhaki", "#bdb76b"), new $c_T2("darkmagenta", "#8b008b"), new $c_T2("darkolivegreen", "#556b2f"), new $c_T2("darkolivegreen1", "#caff70"), new $c_T2("darkolivegreen2", "#bcee68"), new $c_T2("darkolivegreen3", "#a2cd5a"), new $c_T2("darkolivegreen4", "#6e8b3d"), new $c_T2("darkorange", "#ff8c00"), new $c_T2("darkorange1", "#ff7f00"), new $c_T2("darkorange2", "#ee7600"), new $c_T2("darkorange3", "#cd6600"), new $c_T2("darkorange4", "#8b4500"), new $c_T2("darkorchid", "#9932cc"), new $c_T2("darkorchid1", "#bf3eff"), new $c_T2("darkorchid2", "#b23aee"), new $c_T2("darkorchid3", "#9a32cd"), new $c_T2("darkorchid4", "#68228b"), new $c_T2("darkred", "#8b0000"), new $c_T2("darksalmon", "#e9967a"), new $c_T2("darkseagreen", "#8fbc8f"), new $c_T2("darkseagreen1", "#c1ffc1"), new $c_T2("darkseagreen2", "#b4eeb4"), new $c_T2("darkseagreen3", "#9bcd9b"), new $c_T2("darkseagreen4", "#698b69"), new $c_T2("darkslateblue", "#483d8b"), new $c_T2("darkslategray", "#2f4f4f"), new $c_T2("darkslategray1", "#97ffff"), new $c_T2("darkslategray2", "#8deeee"), new $c_T2("darkslategray3", "#79cdcd"), new $c_T2("darkslategray4", "#528b8b"), new $c_T2("darkslategrey", "#2f4f4f"), new $c_T2("darkturquoise", "#00ced1"), new $c_T2("darkviolet", "#9400d3"), new $c_T2("deeppink", "#ff1493"), new $c_T2("deeppink1", "#ff1493"), new $c_T2("deeppink2", "#ee1289"), new $c_T2("deeppink3", "#cd1076"), new $c_T2("deeppink4", "#8b0a50"), new $c_T2("deepskyblue", "#00bfff"), new $c_T2("deepskyblue1", "#00bfff"), new $c_T2("deepskyblue2", "#00b2ee"), new $c_T2("deepskyblue3", "#009acd"), new $c_T2("deepskyblue4", "#00688b"), new $c_T2("dimgray", "#696969"), new $c_T2("dimgrey", "#696969"), new $c_T2("dodgerblue", "#1e90ff"), new $c_T2("dodgerblue1", "#1e90ff"), new $c_T2("dodgerblue2", "#1c86ee"), new $c_T2("dodgerblue3", "#1874cd"), new $c_T2("dodgerblue4", "#104e8b"), new $c_T2("firebrick", "#b22222"), new $c_T2("firebrick1", "#ff3030"), new $c_T2("firebrick2", "#ee2c2c"), new $c_T2("firebrick3", "#cd2626"), new $c_T2("firebrick4", "#8b1a1a"), new $c_T2("floralwhite", "#fffaf0"), new $c_T2("forestgreen", "#228b22"), new $c_T2("fuchsia", "#ff00ff"), new $c_T2("gainsboro", "#dcdcdc"), new $c_T2("ghostwhite", "#f8f8ff"), new $c_T2("gold", "#ffd700"), new $c_T2("gold1", "#ffd700"), new $c_T2("gold2", "#eec900"), new $c_T2("gold3", "#cdad00"), new $c_T2("gold4", "#8b7500"), new $c_T2("goldenrod", "#daa520"), new $c_T2("goldenrod1", "#ffc125"), new $c_T2("goldenrod2", "#eeb422"), new $c_T2("goldenrod3", "#cd9b1d"), new $c_T2("goldenrod4", "#8b6914"), new $c_T2("gray", "#c0c0c0"), new $c_T2("gray0", "#000000"), new $c_T2("gray1", "#030303"), new $c_T2("gray10", "#1a1a1a"), new $c_T2("gray100", "#ffffff"), new $c_T2("gray11", "#1c1c1c"), new $c_T2("gray12", "#1f1f1f"), new $c_T2("gray13", "#212121"), new $c_T2("gray14", "#242424"), new $c_T2("gray15", "#262626"), new $c_T2("gray16", "#292929"), new $c_T2("gray17", "#2b2b2b"), new $c_T2("gray18", "#2e2e2e"), new $c_T2("gray19", "#303030"), new $c_T2("gray2", "#050505"), new $c_T2("gray20", "#333333"), new $c_T2("gray21", "#363636"), new $c_T2("gray22", "#383838"), new $c_T2("gray23", "#3b3b3b"), new $c_T2("gray24", "#3d3d3d"), new $c_T2("gray25", "#404040"), new $c_T2("gray26", "#424242"), new $c_T2("gray27", "#454545"), new $c_T2("gray28", "#474747"), new $c_T2("gray29", "#4a4a4a"), new $c_T2("gray3", "#080808"), new $c_T2("gray30", "#4d4d4d"), new $c_T2("gray31", "#4f4f4f"), new $c_T2("gray32", "#525252"), new $c_T2("gray33", "#545454"), new $c_T2("gray34", "#575757"), new $c_T2("gray35", "#595959"), new $c_T2("gray36", "#5c5c5c"), new $c_T2("gray37", "#5e5e5e"), new $c_T2("gray38", "#616161"), new $c_T2("gray39", "#636363"), new $c_T2("gray4", "#0a0a0a"), new $c_T2("gray40", "#666666"), new $c_T2("gray41", "#696969"), new $c_T2("gray42", "#6b6b6b"), new $c_T2("gray43", "#6e6e6e"), new $c_T2("gray44", "#707070"), new $c_T2("gray45", "#737373"), new $c_T2("gray46", "#757575"), new $c_T2("gray47", "#787878"), new $c_T2("gray48", "#7a7a7a"), new $c_T2("gray49", "#7d7d7d"), new $c_T2("gray5", "#0d0d0d"), new $c_T2("gray50", "#7f7f7f"), new $c_T2("gray51", "#828282"), new $c_T2("gray52", "#858585"), new $c_T2("gray53", "#878787"), new $c_T2("gray54", "#8a8a8a"), new $c_T2("gray55", "#8c8c8c"), new $c_T2("gray56", "#8f8f8f"), new $c_T2("gray57", "#919191"), new $c_T2("gray58", "#949494"), new $c_T2("gray59", "#969696"), new $c_T2("gray6", "#0f0f0f"), new $c_T2("gray60", "#999999"), new $c_T2("gray61", "#9c9c9c"), new $c_T2("gray62", "#9e9e9e"), new $c_T2("gray63", "#a1a1a1"), new $c_T2("gray64", "#a3a3a3"), new $c_T2("gray65", "#a6a6a6"), new $c_T2("gray66", "#a8a8a8"), new $c_T2("gray67", "#ababab"), new $c_T2("gray68", "#adadad"), new $c_T2("gray69", "#b0b0b0"), new $c_T2("gray7", "#121212"), new $c_T2("gray70", "#b3b3b3"), new $c_T2("gray71", "#b5b5b5"), new $c_T2("gray72", "#b8b8b8"), new $c_T2("gray73", "#bababa"), new $c_T2("gray74", "#bdbdbd"), new $c_T2("gray75", "#bfbfbf"), new $c_T2("gray76", "#c2c2c2"), new $c_T2("gray77", "#c4c4c4"), new $c_T2("gray78", "#c7c7c7"), new $c_T2("gray79", "#c9c9c9"), new $c_T2("gray8", "#141414"), new $c_T2("gray80", "#cccccc"), new $c_T2("gray81", "#cfcfcf"), new $c_T2("gray82", "#d1d1d1"), new $c_T2("gray83", "#d4d4d4"), new $c_T2("gray84", "#d6d6d6"), new $c_T2("gray85", "#d9d9d9"), new $c_T2("gray86", "#dbdbdb"), new $c_T2("gray87", "#dedede"), new $c_T2("gray88", "#e0e0e0"), new $c_T2("gray89", "#e3e3e3"), new $c_T2("gray9", "#171717"), new $c_T2("gray90", "#e5e5e5"), new $c_T2("gray91", "#e8e8e8"), new $c_T2("gray92", "#ebebeb"), new $c_T2("gray93", "#ededed"), new $c_T2("gray94", "#f0f0f0"), new $c_T2("gray95", "#f2f2f2"), new $c_T2("gray96", "#f5f5f5"), new $c_T2("gray97", "#f7f7f7"), new $c_T2("gray98", "#fafafa"), new $c_T2("gray99", "#fcfcfc"), new $c_T2("green", "#00ff00"), new $c_T2("green1", "#00ff00"), new $c_T2("green2", "#00ee00"), new $c_T2("green3", "#00cd00"), new $c_T2("green4", "#008b00"), new $c_T2("greenyellow", "#adff2f"), new $c_T2("grey", "#c0c0c0"), new $c_T2("grey0", "#000000"), new $c_T2("grey1", "#030303"), new $c_T2("grey10", "#1a1a1a"), new $c_T2("grey100", "#ffffff"), new $c_T2("grey11", "#1c1c1c"), new $c_T2("grey12", "#1f1f1f"), new $c_T2("grey13", "#212121"), new $c_T2("grey14", "#242424"), new $c_T2("grey15", "#262626"), new $c_T2("grey16", "#292929"), new $c_T2("grey17", "#2b2b2b"), new $c_T2("grey18", "#2e2e2e"), new $c_T2("grey19", "#303030"), new $c_T2("grey2", "#050505"), new $c_T2("grey20", "#333333"), new $c_T2("grey21", "#363636"), new $c_T2("grey22", "#383838"), new $c_T2("grey23", "#3b3b3b"), new $c_T2("grey24", "#3d3d3d"), new $c_T2("grey25", "#404040"), new $c_T2("grey26", "#424242"), new $c_T2("grey27", "#454545"), new $c_T2("grey28", "#474747"), new $c_T2("grey29", "#4a4a4a"), new $c_T2("grey3", "#080808"), new $c_T2("grey30", "#4d4d4d"), new $c_T2("grey31", "#4f4f4f"), new $c_T2("grey32", "#525252"), new $c_T2("grey33", "#545454"), new $c_T2("grey34", "#575757"), new $c_T2("grey35", "#595959"), new $c_T2("grey36", "#5c5c5c"), new $c_T2("grey37", "#5e5e5e"), new $c_T2("grey38", "#616161"), new $c_T2("grey39", "#636363"), new $c_T2("grey4", "#0a0a0a"), new $c_T2("grey40", "#666666"), new $c_T2("grey41", "#696969"), new $c_T2("grey42", "#6b6b6b"), new $c_T2("grey43", "#6e6e6e"), new $c_T2("grey44", "#707070"), new $c_T2("grey45", "#737373"), new $c_T2("grey46", "#757575"), new $c_T2("grey47", "#787878"), new $c_T2("grey48", "#7a7a7a"), new $c_T2("grey49", "#7d7d7d"), new $c_T2("grey5", "#0d0d0d"), new $c_T2("grey50", "#7f7f7f"), new $c_T2("grey51", "#828282"), new $c_T2("grey52", "#858585"), new $c_T2("grey53", "#878787"), new $c_T2("grey54", "#8a8a8a"), new $c_T2("grey55", "#8c8c8c"), new $c_T2("grey56", "#8f8f8f"), new $c_T2("grey57", "#919191"), new $c_T2("grey58", "#949494"), new $c_T2("grey59", "#969696"), new $c_T2("grey6", "#0f0f0f"), new $c_T2("grey60", "#999999"), new $c_T2("grey61", "#9c9c9c"), new $c_T2("grey62", "#9e9e9e"), new $c_T2("grey63", "#a1a1a1"), new $c_T2("grey64", "#a3a3a3"), new $c_T2("grey65", "#a6a6a6"), new $c_T2("grey66", "#a8a8a8"), new $c_T2("grey67", "#ababab"), new $c_T2("grey68", "#adadad"), new $c_T2("grey69", "#b0b0b0"), new $c_T2("grey7", "#121212"), new $c_T2("grey70", "#b3b3b3"), new $c_T2("grey71", "#b5b5b5"), new $c_T2("grey72", "#b8b8b8"), new $c_T2("grey73", "#bababa"), new $c_T2("grey74", "#bdbdbd"), new $c_T2("grey75", "#bfbfbf"), new $c_T2("grey76", "#c2c2c2"), new $c_T2("grey77", "#c4c4c4"), new $c_T2("grey78", "#c7c7c7"), new $c_T2("grey79", "#c9c9c9"), new $c_T2("grey8", "#141414"), new $c_T2("grey80", "#cccccc"), new $c_T2("grey81", "#cfcfcf"), new $c_T2("grey82", "#d1d1d1"), new $c_T2("grey83", "#d4d4d4"), new $c_T2("grey84", "#d6d6d6"), new $c_T2("grey85", "#d9d9d9"), new $c_T2("grey86", "#dbdbdb"), new $c_T2("grey87", "#dedede"), new $c_T2("grey88", "#e0e0e0"), new $c_T2("grey89", "#e3e3e3"), new $c_T2("grey9", "#171717"), new $c_T2("grey90", "#e5e5e5"), new $c_T2("grey91", "#e8e8e8"), new $c_T2("grey92", "#ebebeb"), new $c_T2("grey93", "#ededed"), new $c_T2("grey94", "#f0f0f0"), new $c_T2("grey95", "#f2f2f2"), new $c_T2("grey96", "#f5f5f5"), new $c_T2("grey97", "#f7f7f7"), new $c_T2("grey98", "#fafafa"), new $c_T2("grey99", "#fcfcfc"), new $c_T2("honeydew", "#f0fff0"), new $c_T2("honeydew1", "#f0fff0"), new $c_T2("honeydew2", "#e0eee0"), new $c_T2("honeydew3", "#c1cdc1"), new $c_T2("honeydew4", "#838b83"), new $c_T2("hotpink", "#ff69b4"), new $c_T2("hotpink1", "#ff6eb4"), new $c_T2("hotpink2", "#ee6aa7"), new $c_T2("hotpink3", "#cd6090"), new $c_T2("hotpink4", "#8b3a62"), new $c_T2("indianred", "#cd5c5c"), new $c_T2("indianred1", "#ff6a6a"), new $c_T2("indianred2", "#ee6363"), new $c_T2("indianred3", "#cd5555"), new $c_T2("indianred4", "#8b3a3a"), new $c_T2("indigo", "#4b0082"), new $c_T2("ivory", "#fffff0"), new $c_T2("ivory1", "#fffff0"), new $c_T2("ivory2", "#eeeee0"), new $c_T2("ivory3", "#cdcdc1"), new $c_T2("ivory4", "#8b8b83"), new $c_T2("khaki", "#f0e68c"), new $c_T2("khaki1", "#fff68f"), new $c_T2("khaki2", "#eee685"), new $c_T2("khaki3", "#cdc673"), new $c_T2("khaki4", "#8b864e"), new $c_T2("lavender", "#e6e6fa"), new $c_T2("lavenderblush", "#fff0f5"), new $c_T2("lavenderblush1", "#fff0f5"), new $c_T2("lavenderblush2", "#eee0e5"), new $c_T2("lavenderblush3", "#cdc1c5"), new $c_T2("lavenderblush4", "#8b8386"), new $c_T2("lawngreen", "#7cfc00"), new $c_T2("lemonchiffon", "#fffacd"), new $c_T2("lemonchiffon1", "#fffacd"), new $c_T2("lemonchiffon2", "#eee9bf"), new $c_T2("lemonchiffon3", "#cdc9a5"), new $c_T2("lemonchiffon4", "#8b8970"), new $c_T2("lightblue", "#add8e6"), new $c_T2("lightblue1", "#bfefff"), new $c_T2("lightblue2", "#b2dfee"), new $c_T2("lightblue3", "#9ac0cd"), new $c_T2("lightblue4", "#68838b"), new $c_T2("lightcoral", "#f08080"), new $c_T2("lightcyan", "#e0ffff"), new $c_T2("lightcyan1", "#e0ffff"), new $c_T2("lightcyan2", "#d1eeee"), new $c_T2("lightcyan3", "#b4cdcd"), new $c_T2("lightcyan4", "#7a8b8b"), new $c_T2("lightgoldenrod", "#eedd82"), new $c_T2("lightgoldenrod1", "#ffec8b"), new $c_T2("lightgoldenrod2", "#eedc82"), new $c_T2("lightgoldenrod3", "#cdbe70"), new $c_T2("lightgoldenrod4", "#8b814c"), new $c_T2("lightgoldenrodyellow", "#fafad2"), new $c_T2("lightgray", "#d3d3d3"), new $c_T2("lightgreen", "#90ee90"), new $c_T2("lightgrey", "#d3d3d3"), new $c_T2("lightpink", "#ffb6c1"), new $c_T2("lightpink1", "#ffaeb9"), new $c_T2("lightpink2", "#eea2ad"), new $c_T2("lightpink3", "#cd8c95"), new $c_T2("lightpink4", "#8b5f65"), new $c_T2("lightsalmon", "#ffa07a"), new $c_T2("lightsalmon1", "#ffa07a"), new $c_T2("lightsalmon2", "#ee9572"), new $c_T2("lightsalmon3", "#cd8162"), new $c_T2("lightsalmon4", "#8b5742"), new $c_T2("lightseagreen", "#20b2aa"), new $c_T2("lightskyblue", "#87cefa"), new $c_T2("lightskyblue1", "#b0e2ff"), new $c_T2("lightskyblue2", "#a4d3ee"), new $c_T2("lightskyblue3", "#8db6cd"), new $c_T2("lightskyblue4", "#607b8b"), new $c_T2("lightslateblue", "#8470ff"), new $c_T2("lightslategray", "#778899"), new $c_T2("lightslategrey", "#778899"), new $c_T2("lightsteelblue", "#b0c4de"), new $c_T2("lightsteelblue1", "#cae1ff"), new $c_T2("lightsteelblue2", "#bcd2ee"), new $c_T2("lightsteelblue3", "#a2b5cd"), new $c_T2("lightsteelblue4", "#6e7b8b"), new $c_T2("lightyellow", "#ffffe0"), new $c_T2("lightyellow1", "#ffffe0"), new $c_T2("lightyellow2", "#eeeed1"), new $c_T2("lightyellow3", "#cdcdb4"), new $c_T2("lightyellow4", "#8b8b7a"), new $c_T2("lime", "#00ff00"), new $c_T2("limegreen", "#32cd32"), new $c_T2("linen", "#faf0e6"), new $c_T2("magenta", "#ff00ff"), new $c_T2("magenta1", "#ff00ff"), new $c_T2("magenta2", "#ee00ee"), new $c_T2("magenta3", "#cd00cd"), new $c_T2("magenta4", "#8b008b"), new $c_T2("maroon", "#b03060"), new $c_T2("maroon1", "#ff34b3"), new $c_T2("maroon2", "#ee30a7"), new $c_T2("maroon3", "#cd2990"), new $c_T2("maroon4", "#8b1c62"), new $c_T2("mediumaquamarine", "#66cdaa"), new $c_T2("mediumblue", "#0000cd"), new $c_T2("mediumorchid", "#ba55d3"), new $c_T2("mediumorchid1", "#e066ff"), new $c_T2("mediumorchid2", "#d15fee"), new $c_T2("mediumorchid3", "#b452cd"), new $c_T2("mediumorchid4", "#7a378b"), new $c_T2("mediumpurple", "#9370db"), new $c_T2("mediumpurple1", "#ab82ff"), new $c_T2("mediumpurple2", "#9f79ee"), new $c_T2("mediumpurple3", "#8968cd"), new $c_T2("mediumpurple4", "#5d478b"), new $c_T2("mediumseagreen", "#3cb371"), new $c_T2("mediumslateblue", "#7b68ee"), new $c_T2("mediumspringgreen", "#00fa9a"), new $c_T2("mediumturquoise", "#48d1cc"), new $c_T2("mediumvioletred", "#c71585"), new $c_T2("midnightblue", "#191970"), new $c_T2("mintcream", "#f5fffa"), new $c_T2("mistyrose", "#ffe4e1"), new $c_T2("mistyrose1", "#ffe4e1"), new $c_T2("mistyrose2", "#eed5d2"), new $c_T2("mistyrose3", "#cdb7b5"), new $c_T2("mistyrose4", "#8b7d7b"), new $c_T2("moccasin", "#ffe4b5"), new $c_T2("navajowhite", "#ffdead"), new $c_T2("navajowhite1", "#ffdead"), new $c_T2("navajowhite2", "#eecfa1"), new $c_T2("navajowhite3", "#cdb38b"), new $c_T2("navajowhite4", "#8b795e"), new $c_T2("navy", "#000080"), new $c_T2("navyblue", "#000080"), new $c_T2("oldlace", "#fdf5e6"), new $c_T2("olive", "#808000"), new $c_T2("olivedrab", "#6b8e23"), new $c_T2("olivedrab1", "#c0ff3e"), new $c_T2("olivedrab2", "#b3ee3a"), new $c_T2("olivedrab3", "#9acd32"), new $c_T2("olivedrab4", "#698b22"), new $c_T2("orange", "#ffa500"), new $c_T2("orange1", "#ffa500"), new $c_T2("orange2", "#ee9a00"), new $c_T2("orange3", "#cd8500"), new $c_T2("orange4", "#8b5a00"), new $c_T2("orangered", "#ff4500"), new $c_T2("orangered1", "#ff4500"), new $c_T2("orangered2", "#ee4000"), new $c_T2("orangered3", "#cd3700"), new $c_T2("orangered4", "#8b2500"), new $c_T2("orchid", "#da70d6"), new $c_T2("orchid1", "#ff83fa"), new $c_T2("orchid2", "#ee7ae9"), new $c_T2("orchid3", "#cd69c9"), new $c_T2("orchid4", "#8b4789"), new $c_T2("palegoldenrod", "#eee8aa"), new $c_T2("palegreen", "#98fb98"), new $c_T2("palegreen1", "#9aff9a"), new $c_T2("palegreen2", "#90ee90"), new $c_T2("palegreen3", "#7ccd7c"), new $c_T2("palegreen4", "#548b54"), new $c_T2("paleturquoise", "#afeeee"), new $c_T2("paleturquoise1", "#bbffff"), new $c_T2("paleturquoise2", "#aeeeee"), new $c_T2("paleturquoise3", "#96cdcd"), new $c_T2("paleturquoise4", "#668b8b"), new $c_T2("palevioletred", "#db7093"), new $c_T2("palevioletred1", "#ff82ab"), new $c_T2("palevioletred2", "#ee799f"), new $c_T2("palevioletred3", "#cd6889"), new $c_T2("palevioletred4", "#8b475d"), new $c_T2("papayawhip", "#ffefd5"), new $c_T2("peachpuff", "#ffdab9"), new $c_T2("peachpuff1", "#ffdab9"), new $c_T2("peachpuff2", "#eecbad"), new $c_T2("peachpuff3", "#cdaf95"), new $c_T2("peachpuff4", "#8b7765"), new $c_T2("peru", "#cd853f"), new $c_T2("pink", "#ffc0cb"), new $c_T2("pink1", "#ffb5c5"), new $c_T2("pink2", "#eea9b8"), new $c_T2("pink3", "#cd919e"), new $c_T2("pink4", "#8b636c"), new $c_T2("plum", "#dda0dd"), new $c_T2("plum1", "#ffbbff"), new $c_T2("plum2", "#eeaeee"), new $c_T2("plum3", "#cd96cd"), new $c_T2("plum4", "#8b668b"), new $c_T2("powderblue", "#b0e0e6"), new $c_T2("purple", "#a020f0"), new $c_T2("purple1", "#9b30ff"), new $c_T2("purple2", "#912cee"), new $c_T2("purple3", "#7d26cd"), new $c_T2("purple4", "#551a8b"), new $c_T2("rebeccapurple", "#663399"), new $c_T2("red", "#ff0000"), new $c_T2("red1", "#ff0000"), new $c_T2("red2", "#ee0000"), new $c_T2("red3", "#cd0000"), new $c_T2("red4", "#8b0000"), new $c_T2("rosybrown", "#bc8f8f"), new $c_T2("rosybrown1", "#ffc1c1"), new $c_T2("rosybrown2", "#eeb4b4"), new $c_T2("rosybrown3", "#cd9b9b"), new $c_T2("rosybrown4", "#8b6969"), new $c_T2("royalblue", "#4169e1"), new $c_T2("royalblue1", "#4876ff"), new $c_T2("royalblue2", "#436eee"), new $c_T2("royalblue3", "#3a5fcd"), new $c_T2("royalblue4", "#27408b"), new $c_T2("saddlebrown", "#8b4513"), new $c_T2("salmon", "#fa8072"), new $c_T2("salmon1", "#ff8c69"), new $c_T2("salmon2", "#ee8262"), new $c_T2("salmon3", "#cd7054"), new $c_T2("salmon4", "#8b4c39"), new $c_T2("sandybrown", "#f4a460"), new $c_T2("seagreen", "#2e8b57"), new $c_T2("seagreen1", "#54ff9f"), new $c_T2("seagreen2", "#4eee94"), new $c_T2("seagreen3", "#43cd80"), new $c_T2("seagreen4", "#2e8b57"), new $c_T2("seashell", "#fff5ee"), new $c_T2("seashell1", "#fff5ee"), new $c_T2("seashell2", "#eee5de"), new $c_T2("seashell3", "#cdc5bf"), new $c_T2("seashell4", "#8b8682"), new $c_T2("sienna", "#a0522d"), new $c_T2("sienna1", "#ff8247"), new $c_T2("sienna2", "#ee7942"), new $c_T2("sienna3", "#cd6839"), new $c_T2("sienna4", "#8b4726"), new $c_T2("silver", "#c0c0c0"), new $c_T2("skyblue", "#87ceeb"), new $c_T2("skyblue1", "#87ceff"), new $c_T2("skyblue2", "#7ec0ee"), new $c_T2("skyblue3", "#6ca6cd"), new $c_T2("skyblue4", "#4a708b"), new $c_T2("slateblue", "#6a5acd"), new $c_T2("slateblue1", "#836fff"), new $c_T2("slateblue2", "#7a67ee"), new $c_T2("slateblue3", "#6959cd"), new $c_T2("slateblue4", "#473c8b"), new $c_T2("slategray", "#708090"), new $c_T2("slategray1", "#c6e2ff"), new $c_T2("slategray2", "#b9d3ee"), new $c_T2("slategray3", "#9fb6cd"), new $c_T2("slategray4", "#6c7b8b"), new $c_T2("slategrey", "#708090"), new $c_T2("snow", "#fffafa"), new $c_T2("snow1", "#fffafa"), new $c_T2("snow2", "#eee9e9"), new $c_T2("snow3", "#cdc9c9"), new $c_T2("snow4", "#8b8989"), new $c_T2("springgreen", "#00ff7f"), new $c_T2("springgreen1", "#00ff7f"), new $c_T2("springgreen2", "#00ee76"), new $c_T2("springgreen3", "#00cd66"), new $c_T2("springgreen4", "#008b45"), new $c_T2("steelblue", "#4682b4"), new $c_T2("steelblue1", "#63b8ff"), new $c_T2("steelblue2", "#5cacee"), new $c_T2("steelblue3", "#4f94cd"), new $c_T2("steelblue4", "#36648b"), new $c_T2("tan", "#d2b48c"), new $c_T2("tan1", "#ffa54f"), new $c_T2("tan2", "#ee9a49"), new $c_T2("tan3", "#cd853f"), new $c_T2("tan4", "#8b5a2b"), new $c_T2("teal", "#008080"), new $c_T2("thistle", "#d8bfd8"), new $c_T2("thistle1", "#ffe1ff"), new $c_T2("thistle2", "#eed2ee"), new $c_T2("thistle3", "#cdb5cd"), new $c_T2("thistle4", "#8b7b8b"), new $c_T2("tomato", "#ff6347"), new $c_T2("tomato1", "#ff6347"), new $c_T2("tomato2", "#ee5c42"), new $c_T2("tomato3", "#cd4f39"), new $c_T2("tomato4", "#8b3626"), new $c_T2("turquoise", "#40e0d0"), new $c_T2("turquoise1", "#00f5ff"), new $c_T2("turquoise2", "#00e5ee"), new $c_T2("turquoise3", "#00c5cd"), new $c_T2("turquoise4", "#00868b"), new $c_T2("violet", "#ee82ee"), new $c_T2("violetred", "#d02090"), new $c_T2("violetred1", "#ff3e96"), new $c_T2("violetred2", "#ee3a8c"), new $c_T2("violetred3", "#cd3278"), new $c_T2("violetred4", "#8b2252"), new $c_T2("webgray", "#808080"), new $c_T2("webgreen", "#008000"), new $c_T2("webgrey", "#808080"), new $c_T2("webmaroon", "#800000"), new $c_T2("webpurple", "#800080"), new $c_T2("wheat", "#f5deb3"), new $c_T2("wheat1", "#ffe7ba"), new $c_T2("wheat2", "#eed8ae"), new $c_T2("wheat3", "#cdba96"), new $c_T2("wheat4", "#8b7e66"), new $c_T2("white", "#ffffff"), new $c_T2("whitesmoke", "#f5f5f5"), new $c_T2("x11gray", "#bebebe"), new $c_T2("x11green", "#00ff00"), new $c_T2("x11grey", "#bebebe"), new $c_T2("x11maroon", "#b03060"), new $c_T2("x11purple", "#a020f0"), new $c_T2("yellow", "#ffff00"), new $c_T2("yellow1", "#ffff00"), new $c_T2("yellow2", "#eeee00"), new $c_T2("yellow3", "#cdcd00"), new $c_T2("yellow4", "#8b8b00"), new $c_T2("yellowgreen", "#9acd32")])));
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_color_X11Colors$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_color_X11Colors$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_color_X11Colors$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_color_X11Colors$package$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_viewer_color_X11Colors$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_color_X11Colors$package$, "org.jpablo.graphexplorer.viewer.color.X11Colors$package$", ({
  yl: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_color_X11Colors$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_color_X11Colors$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_color_X11Colors$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_color_X11Colors$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_color_X11Colors$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_color_X11Colors$package$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_AboutDialog$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_AboutDialog$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_AboutDialog$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_AboutDialog$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_AboutDialog$package$.prototype = $p;
$p.aLo = (function(isOpen) {
  return $m_Lorg_jpablo_graphexplorer_viewer_widgets_Dialog$package$().aeu(isOpen, $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("space-y-4"), $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("flex items-center gap-2"), $m_Lcom_raquo_laminar_api_package$().b.aPc().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.aSm().n("/favicon.svg"), $m_Lcom_raquo_laminar_api_package$().b.y.s("h-6 w-6")]))), $m_Lcom_raquo_laminar_api_package$().b.ya().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("text-xl font-semibold text-gray-900"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Graph Explorer", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))]))), $m_Lcom_raquo_laminar_api_package$().b.aid().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("w-full text-sm"), $m_Lcom_raquo_laminar_api_package$().b.aie().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.uk().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.kW().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("font-bold text-gray-600 py-1 pr-2"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Version:", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $m_Lcom_raquo_laminar_api_package$().b.kW().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("text-gray-700 py-1"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, $m_Lbuildinfo_BuildInfo$().Qg, $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))]))), $m_Lcom_raquo_laminar_api_package$().b.uk().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.kW().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("font-bold text-gray-600 py-1 pr-2"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Scala Version:", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $m_Lcom_raquo_laminar_api_package$().b.kW().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("text-gray-700 py-1"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, $m_Lbuildinfo_BuildInfo$().Qf, $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))]))), $m_Lcom_raquo_laminar_api_package$().b.uk().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.kW().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("font-bold text-gray-600 py-1 pr-2"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Build date:", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $m_Lcom_raquo_laminar_api_package$().b.kW().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("text-gray-700 py-1"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, new Date($m_Lbuildinfo_BuildInfo$().Qe).toUTCString(), $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))])))])))]))), $m_Lcom_raquo_laminar_api_package$().b.Ax().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("text-xs text-gray-500 pt-2"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "\u00a9 2025 Juan Pablo Romero & contributors.", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $m_Lcom_raquo_laminar_api_package$().b.Ax().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("text-xs text-gray-500"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Crafted with \u2764\ufe0f in Northern California", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))])))])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_AboutDialog$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_AboutDialog$package$, "org.jpablo.graphexplorer.viewer.components.AboutDialog$package$", ({
  ym: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_AboutDialog$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_AboutDialog$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_AboutDialog$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_AboutDialog$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_AboutDialog$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_AboutDialog$package$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_AttributesToolbar$package$__part$1__I__T__s_Option($thiz, n, noun) {
  return ((n > 0) ? new $c_s_Some((((n + " ") + noun) + ((n === 1) ? "" : "s"))) : $m_s_None$());
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_AttributesToolbar$package$__cmdButton$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_viewer_components_Command__T__T__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($thiz, state$3, command, iconCls, label) {
  var elem$1 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$().u4($m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$().iZ($m_Lorg_jpablo_graphexplorer_viewer_widgets_Button$package$().hH($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s(("bi " + iconCls))]))), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, label, $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7), new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6) => {
    command.gZ($m_s_None$(), true);
    state$3.CE.dn.bA(true);
  })))])))));
  return $m_Lorg_jpablo_graphexplorer_viewer_widgets_Tooltip$package$().Iz(command.Xr(), $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("tooltip-bottom"), elem$1])));
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_AttributesToolbar$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_AttributesToolbar$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_AttributesToolbar$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_AttributesToolbar$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_AttributesToolbar$package$.prototype = $p;
$p.aVF = (function(projectName, commands, state) {
  var hiddenCount = $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), state.il().N6, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => ((_$1 === null) ? null : _$1.aS).aa())), $m_s_None$());
  var hasSelection = $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), state.aH().ne, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => (!((_$2 === null) ? null : _$2.aS).c()))), $m_s_None$());
  var stripVisible = $m_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$().li(hasSelection, hiddenCount, new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((_$3, _$4) => {
    var _$3$1 = (!(!_$3));
    var _$4$1 = (_$4 | 0);
    return (_$3$1 || (_$4$1 > 0));
  })));
  var $x_17 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_16 = $m_sr_ScalaRunTime$();
  var $x_15 = $m_Lcom_raquo_laminar_api_package$().b.gz().n("selection-toolbar");
  var $x_14 = $m_Lcom_raquo_laminar_api_package$().b.y.s("navbar");
  var $x_13 = $m_Lcom_raquo_laminar_api_package$().b.y.s("hidden").bj(($m_Lcom_raquo_airstream_core_Observable$(), $m_Lcom_raquo_airstream_extensions_BooleanObservable$().r1(stripVisible)));
  var $x_12 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_receivers_ChildOptionReceiver$()).gR($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), $f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable(state.aH().ne), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((sel) => {
    var sel$1 = ((sel === null) ? null : sel.aS);
    return ((!sel$1.c()) ? new $c_s_Some($m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("gx-selection-count"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, $m_Lorg_jpablo_graphexplorer_viewer_components_AttributesToolbar$package$().b8t(sel$1), $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))) : $m_s_None$());
  })), $m_s_None$()));
  var $x_11 = $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("flex-1 min-w-0 flex items-center"), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_inserters_ChildInserter$().nv($m_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$().li($f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable(state.aH().ne), $f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable(state.gs.P()), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((sel$2, cellOpt) => {
    var sel$3 = ((sel$2 === null) ? null : sel$2.aS);
    if ((cellOpt instanceof $c_s_Some)) {
      return $m_Lorg_jpablo_graphexplorer_viewer_components_AttributesToolbar$package$().b7h(state, commands, cellOpt.J);
    }
    if (($m_s_None$() === cellOpt)) {
      return $m_Lorg_jpablo_graphexplorer_viewer_components_AttributesToolbar$package$().b8u(state, commands, sel$3);
    }
    throw new $c_s_MatchError(cellOpt);
  }))), $m_Lcom_raquo_laminar_modifiers_RenderableNode$().ht, (void 0)))])));
  var $x_10 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_9 = $m_sr_ScalaRunTime$();
  var $x_8 = $m_Lcom_raquo_laminar_api_package$().b.y.s("shrink-0");
  var $x_7 = $m_Lcom_raquo_laminar_api_package$().b.y.s("hidden").bj($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), hiddenCount, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$5) => ((_$5 | 0) === 0))), $m_s_None$()));
  var $x_6 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$();
  var $x_5 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$();
  var $x_4 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$();
  var $x_3 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Button$package$();
  var $x_2 = $m_sr_ScalaRunTime$();
  $m_Lcom_raquo_laminar_api_package$();
  var $x_1 = $m_Lcom_raquo_laminar_inserters_ChildTextInserter$().DG($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), hiddenCount, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n) => ((n | 0) + " hidden \u00b7 Show all"))), $m_s_None$()), $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7);
  var this$21 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false));
  var onNext = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    commands.ap().a0h.gZ((commands.ap(), $m_s_None$()), (commands.ap(), true));
  }));
  $m_Lcom_raquo_laminar_api_package$features$().cz();
  var elem$2 = $x_6.AB($x_5.b91($x_4.iZ($x_3.hH($x_2.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_1, new $c_Lcom_raquo_laminar_modifiers_EventListener(this$21, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2$2) => {
    onNext.a3();
  })))]))))));
  return $x_17.w($x_16.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_15, $x_14, $x_13, $x_12, $x_11, $x_10.w($x_9.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_8, $x_7, $m_Lorg_jpablo_graphexplorer_viewer_widgets_Tooltip$package$().Iz(commands.ap().a0h.Xr(), $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("tooltip-bottom"), elem$2])))])))])));
});
$p.b8t = (function(sel) {
  matchResult2: {
    var \u03b43$___1;
    var \u03b43$___2;
    var \u03b43$___3;
    var x4 = $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().gV(sel);
    if ((x4 !== null)) {
      var \u03b43$___1 = x4.f3;
      var \u03b43$___2 = x4.gg;
      var \u03b43$___3 = x4.gf;
      break matchResult2;
    }
    throw new $c_s_MatchError(x4);
  }
  var clusterIds$2 = \u03b43$___1;
  var nodeIds$2 = \u03b43$___2;
  var arrowIds$2 = \u03b43$___3;
  var _1 = $p_Lorg_jpablo_graphexplorer_viewer_components_AttributesToolbar$package$__part$1__I__T__s_Option(this, nodeIds$2.aa(), "node");
  var _2 = $p_Lorg_jpablo_graphexplorer_viewer_components_AttributesToolbar$package$__part$1__I__T__s_Option(this, arrowIds$2.aa(), "arrow");
  var _3 = $p_Lorg_jpablo_graphexplorer_viewer_components_AttributesToolbar$package$__part$1__I__T__s_Option(this, clusterIds$2.aa(), "group");
  if ((_1 instanceof $c_s_Some)) {
    var s = _1.J;
    if ((($m_s_None$() === _2) && ($m_s_None$() === _3))) {
      return s;
    }
  }
  if (($m_s_None$() === _1)) {
    if ((_2 instanceof $c_s_Some)) {
      var s$2 = _2.J;
      if (($m_s_None$() === _3)) {
        return s$2;
      }
    }
    if ((($m_s_None$() === _2) && (_3 instanceof $c_s_Some))) {
      return _3.J;
    }
  }
  return (sel.aa() + " objects");
});
$p.b7h = (function(state, commands, cell) {
  var chip = $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("gx-selection-count"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "cell", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_receivers_ChildOptionReceiver$()).gR($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), state.du().b8s(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$7) => {
    if (_$7.c()) {
      return $m_s_None$();
    } else {
      var x0 = _$7.d();
      return new $c_s_Some($m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("ml-1 font-mono text-xs opacity-60"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, (("<" + x0) + ">"), $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))));
    }
  })), $m_s_None$()))])));
  if (state.du().ahV()) {
    return $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("flex flex-row items-center gap-1 min-w-0"), chip, $p_Lorg_jpablo_graphexplorer_viewer_components_AttributesToolbar$package$__cmdButton$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_viewer_components_Command__T__T__Lcom_raquo_laminar_nodes_ReactiveHtmlElement(this, state, commands.ap().a0b, "bi-pencil", "Edit"), $p_Lorg_jpablo_graphexplorer_viewer_components_AttributesToolbar$package$__cmdButton$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_viewer_components_Command__T__T__Lcom_raquo_laminar_nodes_ReactiveHtmlElement(this, state, commands.ap().a8V, "bi-arrow-bar-up", "Row"), $p_Lorg_jpablo_graphexplorer_viewer_components_AttributesToolbar$package$__cmdButton$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_viewer_components_Command__T__T__Lcom_raquo_laminar_nodes_ReactiveHtmlElement(this, state, commands.ap().a8W, "bi-arrow-bar-down", "Row"), $p_Lorg_jpablo_graphexplorer_viewer_components_AttributesToolbar$package$__cmdButton$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_viewer_components_Command__T__T__Lcom_raquo_laminar_nodes_ReactiveHtmlElement(this, state, commands.ap().a0e, "bi-arrow-bar-left", "Col"), $p_Lorg_jpablo_graphexplorer_viewer_components_AttributesToolbar$package$__cmdButton$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_viewer_components_Command__T__T__Lcom_raquo_laminar_nodes_ReactiveHtmlElement(this, state, commands.ap().a0d, "bi-arrow-bar-right", "Col"), $p_Lorg_jpablo_graphexplorer_viewer_components_AttributesToolbar$package$__cmdButton$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_viewer_components_Command__T__T__Lcom_raquo_laminar_nodes_ReactiveHtmlElement(this, state, commands.ap().a8U, "bi-dash-square", "Row"), $p_Lorg_jpablo_graphexplorer_viewer_components_AttributesToolbar$package$__cmdButton$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_viewer_components_Command__T__T__Lcom_raquo_laminar_nodes_ReactiveHtmlElement(this, state, commands.ap().a8T, "bi-dash-square", "Col"), $p_Lorg_jpablo_graphexplorer_viewer_components_AttributesToolbar$package$__cmdButton$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_viewer_components_Command__T__T__Lcom_raquo_laminar_nodes_ReactiveHtmlElement(this, state, commands.ap().a0g, "bi-eraser", "Clear"), $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarHtmlCellAttributesView$package$().aWo(state, state.du().aYc(cell))])));
  } else {
    var lr = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$().b6p(cell.f4, state.du().aT0());
    if (lr) {
      var \u03b41$___1 = "bi-arrow-bar-left";
      var \u03b41$___2 = "bi-arrow-bar-right";
    } else {
      var \u03b41$___1 = "bi-arrow-bar-up";
      var \u03b41$___2 = "bi-arrow-bar-down";
    }
    var beforeLbl = \u03b41$___1;
    var afterLbl = \u03b41$___2;
    return $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("flex flex-row items-center gap-1"), chip, $p_Lorg_jpablo_graphexplorer_viewer_components_AttributesToolbar$package$__cmdButton$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_viewer_components_Command__T__T__Lcom_raquo_laminar_nodes_ReactiveHtmlElement(this, state, commands.ap().a0b, "bi-pencil", "Edit"), $p_Lorg_jpablo_graphexplorer_viewer_components_AttributesToolbar$package$__cmdButton$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_viewer_components_Command__T__T__Lcom_raquo_laminar_nodes_ReactiveHtmlElement(this, state, commands.ap().a0e, beforeLbl, "Insert"), $p_Lorg_jpablo_graphexplorer_viewer_components_AttributesToolbar$package$__cmdButton$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_viewer_components_Command__T__T__Lcom_raquo_laminar_nodes_ReactiveHtmlElement(this, state, commands.ap().a0d, afterLbl, "Insert"), $p_Lorg_jpablo_graphexplorer_viewer_components_AttributesToolbar$package$__cmdButton$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_viewer_components_Command__T__T__Lcom_raquo_laminar_nodes_ReactiveHtmlElement(this, state, commands.ap().a90, (lr ? "bi-hr" : "bi-vr"), "Split"), $p_Lorg_jpablo_graphexplorer_viewer_components_AttributesToolbar$package$__cmdButton$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_viewer_components_Command__T__T__Lcom_raquo_laminar_nodes_ReactiveHtmlElement(this, state, commands.ap().a0g, "bi-x-lg", "Remove")])));
  }
});
$p.b8u = (function(state, commands, selectedNodes) {
  matchResult4: {
    var \u03b42$___1;
    var \u03b42$___2;
    var \u03b42$___3;
    var x25 = $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().gV(selectedNodes);
    if ((x25 !== null)) {
      var \u03b42$___1 = x25.f3;
      var \u03b42$___2 = x25.gg;
      var \u03b42$___3 = x25.gf;
      break matchResult4;
    }
    throw new $c_s_MatchError(x25);
  }
  var clusterIds$2 = \u03b42$___1;
  var nodeIds$2 = \u03b42$___2;
  var arrowIds$2 = \u03b42$___3;
  var _1 = (!arrowIds$2.c());
  var _2 = (!nodeIds$2.c());
  var _3 = (!clusterIds$2.c());
  if (((_1 && (!_2)) && (!_3))) {
    return $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarArrowsAttributesView$package$().aWm(state, commands.ap().SK, state.a3b(arrowIds$2));
  }
  if ((!_1)) {
    if ((_2 && (!_3))) {
      return $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarNodesAttributesView$package$().aWp(state, commands.ap().SK, state.a3b(nodeIds$2));
    }
    if ((!_2)) {
      if (_3) {
        return $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarGroupAttributesView$package$().aWn(state, commands.ap().SK, state.a3b(clusterIds$2));
      }
      if ((!_3)) {
        return $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([])));
      }
    }
  }
  var classified = $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().gV($f_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps__resolveProxies__sci_Set__sci_Set($f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__visibleGraphObs__Lcom_raquo_airstream_state_OwnedSignal(state)).d(), selectedNodes));
  var options = $m_Lorg_jpablo_graphexplorer_viewer_selection_SelectByKind$().b5k(classified);
  var $x_6 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_5 = $m_sr_ScalaRunTime$();
  var $x_4 = $m_Lcom_raquo_laminar_api_package$().b.y.s("flex flex-row gap-2");
  var $x_3 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$();
  var $x_2 = new $c_s_Some((("Filter " + selectedNodes.aa()) + " objects"));
  var f = ((option) => new $c_T2(option.MN, option.MM.u6()));
  if ((options === $m_sci_Nil$())) {
    var $x_1 = $m_sci_Nil$();
  } else {
    var x0 = options.t();
    var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
    var t = h;
    var rest = options.v();
    while ((rest !== $m_sci_Nil$())) {
      var x0$1 = rest.t();
      var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
      t.U = nx;
      t = nx;
      rest = rest.v();
    }
    var $x_1 = h;
  }
  return $x_6.w($x_5.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_4, $x_3.aWh($x_2, $x_1, $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.Eb(), false, false)).nC(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((value$1) => {
    var this$14 = $m_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$().b1N(value$1);
    if ((!this$14.c())) {
      var x0$2 = this$14.d();
      var picked = $m_Lorg_jpablo_graphexplorer_viewer_selection_SelectByKind$().b2H(classified, x0$2);
      state.aH().rd(picked.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((id) => $f_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps__renderedId__Lorg_jpablo_graphexplorer_viewer_models_ElementId__Lorg_jpablo_graphexplorer_viewer_models_ElementId($f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__visibleGraphObs__Lcom_raquo_airstream_state_OwnedSignal(state)).d(), id)))));
    }
  })))])))])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_AttributesToolbar$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_AttributesToolbar$package$, "org.jpablo.graphexplorer.viewer.components.AttributesToolbar$package$", ({
  yn: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_AttributesToolbar$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_AttributesToolbar$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_AttributesToolbar$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_AttributesToolbar$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_AttributesToolbar$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_AttributesToolbar$package$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_Commands__changeProjectNameAction__V($thiz) {
  $f_Lcom_raquo_airstream_state_Var__set__O__V($thiz.aX.CI, true);
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_Commands__moveToGroupActionVisible__sci_Set__Z($thiz, selection) {
  var classified = $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().gV(selection);
  return ((classified.f3.aa() === 1) && (!classified.gg.c()));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_Commands__singleGroupSelected__sci_Set__Z($thiz, selection) {
  var classified = $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().gV(selection);
  return (((classified.f3.aa() === 1) && classified.gg.c()) && classified.gf.c());
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_Commands__groupOrCollapsedBox__sci_Set__Z($thiz, selection) {
  var resolved = $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().gV($f_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps__resolveProxies__sci_Set__sci_Set($f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__visibleGraphObs__Lcom_raquo_airstream_state_OwnedSignal($thiz.aX)).d(), selection));
  return ((!resolved.f3.c()) && resolved.gf.c());
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_Commands__singleNodeSelected__sci_Set__Z($thiz, selection) {
  var classified = $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().gV(selection);
  return (((classified.gg.aa() === 1) && classified.f3.c()) && classified.gf.c());
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_Commands__onlyArrowSelected__sci_Set__Z($thiz, selection) {
  var classified = $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().gV(selection);
  return ((classified.gg.c() && classified.f3.c()) && (!classified.gf.c()));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_Commands__canCombineNodesVisible__sci_Set__Z($thiz, selection) {
  var classified = $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().gV(selection);
  return (((classified.gg.aa() >= 2) && classified.gf.c()) && classified.f3.c());
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_Commands__canSplitRecordVisible__sci_Set__Z($thiz, selection) {
  var classified = $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().gV(selection);
  return ((((classified.gg.aa() === 1) && classified.gf.c()) && classified.f3.c()) && $f_Lorg_jpablo_graphexplorer_viewer_graph_CombineNodesOps__isRecordNode__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Z($f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__fullGraphObs__Lcom_raquo_airstream_state_OwnedSignal($thiz.aX)).d(), classified.gg.t()));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_Commands__cellSelected__sci_Set__Z($thiz, selection) {
  return (!$thiz.aX.gs.P().aq().d().c());
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_Commands__htmlCellSelected__sci_Set__Z($thiz, selection) {
  return ($p_Lorg_jpablo_graphexplorer_viewer_components_Commands__cellSelected__sci_Set__Z($thiz, selection) && $thiz.aX.du().ahV());
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_Commands__recordCellSelected__sci_Set__Z($thiz, selection) {
  return ($p_Lorg_jpablo_graphexplorer_viewer_components_Commands__cellSelected__sci_Set__Z($thiz, selection) && (!$thiz.aX.du().ahV()));
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_Commands(state, routerCmds) {
  this.aX = null;
  this.a8R = null;
  this.awa = null;
  this.awb = false;
  this.awc = null;
  this.awd = false;
  this.vh = null;
  this.awe = null;
  this.awf = false;
  this.a8Q = null;
  this.aX = state;
  this.a8R = routerCmds;
  this.vh = $m_sci_VectorMap$().u3($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2(this.jq().axf, new $c_sci_$colon$colon(this.ap().SJ, new $c_sci_$colon$colon(this.ap().a8Y, new $c_sci_$colon$colon(this.ap().SI, new $c_sci_$colon$colon(this.ap().a8X, new $c_sci_$colon$colon(routerCmds.SL, new $c_sci_$colon$colon(routerCmds.LF, $m_sci_Nil$()))))))), new $c_T2(this.jq().axi, new $c_sci_$colon$colon(this.ap().awH, new $c_sci_$colon$colon(this.ap().awI, new $c_sci_$colon$colon(this.ap().awJ, new $c_sci_$colon$colon(this.ap().awG, $m_sci_Nil$()))))), new $c_T2(this.jq().a93, new $c_sci_$colon$colon(this.ap().SJ, new $c_sci_$colon$colon(this.ap().a8Y, $m_sci_Nil$()))), new $c_T2(this.jq().a97, $m_sci_Nil$().b6($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_components_Command.r().C)([this.ap().awT, this.ap().awW, this.ap().awU, this.ap().awV, this.ap().ax1, this.ap().awY, this.ap().ax0, this.ap().awX, this.ap().awZ])))), new $c_T2(this.jq().a98, $m_sci_Nil$().b6($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_components_Command.r().C)([this.ap().awy, this.ap().axc, this.ap().a8X, this.ap().axd, this.ap().ax7, this.ap().awk, this.ap().awt, this.ap().a0b, this.ap().awC, this.ap().awF, this.ap().awo, this.ap().awq, this.ap().awl, this.ap().ax6, this.ap().axb, this.ap().a0e, this.ap().a0d, this.ap().a90, this.ap().a0g, this.ap().a8V, this.ap().a8W, this.ap().a8U, this.ap().a8T, this.ap().awr, this.ap().awQ, this.ap().awR, this.ap().SK, this.ap().awi])))), new $c_T2(this.jq().a99, new $c_sci_$colon$colon(this.ap().ax3, new $c_sci_$colon$colon(this.ap().ax5, new $c_sci_$colon$colon(this.ap().awE, new $c_sci_$colon$colon(this.ap().awD, new $c_sci_$colon$colon(this.ap().axa, $m_sci_Nil$())))))), new $c_T2(this.jq().a96, new $c_sci_$colon$colon(this.ap().ax2, new $c_sci_$colon$colon(this.ap().ax4, new $c_sci_$colon$colon(this.ap().awB, new $c_sci_$colon$colon(this.ap().awA, new $c_sci_$colon$colon(this.ap().ax9, $m_sci_Nil$())))))), new $c_T2(this.jq().a9a, $m_sci_Nil$().b6($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_components_Command.r().C)([this.ap().awx, this.ap().awS, this.ap().a0h, this.ap().awz, this.ap().awj, this.ap().aws, this.ap().ax8, this.ap().awp])))), new $c_T2(this.jq().axh, new $c_sci_$colon$colon(this.ap().SI, new $c_sci_$colon$colon(routerCmds.SL, $m_sci_Nil$()))), new $c_T2(this.jq().a95, new $c_sci_$colon$colon(this.ap().awK, $m_sci_Nil$())), new $c_T2(this.jq().a94, new $c_sci_$colon$colon(this.ap().awm, new $c_sci_$colon$colon(this.ap().aww, new $c_sci_$colon$colon(this.ap().awu, new $c_sci_$colon$colon(this.ap().awv, new $c_sci_$colon$colon(this.ap().awn, $m_sci_Nil$())))))), new $c_T2(this.jq().axk, new $c_sci_$colon$colon(this.ap().a92, new $c_sci_$colon$colon(this.ap().a0c, new $c_sci_$colon$colon(this.ap().a91, $m_sci_Nil$())))), new $c_T2(this.jq().axj, new $c_sci_$colon$colon(this.ap().a0i, new $c_sci_$colon$colon(this.ap().a0f, $m_sci_Nil$()))), new $c_T2(this.jq().axe, new $c_sci_$colon$colon(routerCmds.LF, new $c_sci_$colon$colon(this.ap().LE, new $c_sci_$colon$colon(this.ap().a8Z, $m_sci_Nil$())))), new $c_T2(this.jq().axg, new $c_sci_$colon$colon(this.ap().awO, new $c_sci_$colon$colon(this.ap().awN, new $c_sci_$colon$colon(this.ap().awM, new $c_sci_$colon$colon(this.ap().awP, new $c_sci_$colon$colon(this.ap().awL, $m_sci_Nil$()))))))])));
  this.a8Q = $f_sc_IterableOps__flatMap__F1__O(new $c_sci_VectorMap$$anon$2(this.vh), $m_s_$less$colon$less$().b1).ct(new $c_Lorg_jpablo_graphexplorer_viewer_components_Commands$$anon$4(this)).eX($m_s_$less$colon$less$().b1);
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_Commands.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_Commands;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_Commands() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_Commands.prototype = $p;
$p.ap = (function() {
  if ((!this.awb)) {
    this.awa = new $c_Lorg_jpablo_graphexplorer_viewer_components_Commands$all$(this);
    this.awb = true;
  }
  return this.awa;
});
$p.jq = (function() {
  if ((!this.awd)) {
    this.awc = new $c_Lorg_jpablo_graphexplorer_viewer_components_Commands$headers$();
    this.awd = true;
  }
  return this.awc;
});
$p.XY = (function() {
  if ((!this.awf)) {
    this.awe = new $c_Lorg_jpablo_graphexplorer_viewer_components_Commands$sections$(this);
    this.awf = true;
  }
  return this.awe;
});
$p.aQN = (function(sh) {
  if (((sh.te.length === 1) && $m_jl_UnicodeData$().a3S($m_sc_StringOps$().pw(sh.te)))) {
    var this$6 = sh.te;
    var keyLower = this$6.toLowerCase();
  } else {
    var keyLower = sh.te;
  }
  return (((sh.te.length === 1) && (!$m_jl_UnicodeData$().E5($m_sc_StringOps$().pw(sh.te)))) ? new $c_Lorg_jpablo_graphexplorer_viewer_components_Shortcut(keyLower, false, sh.C7, sh.C5, sh.C6) : new $c_Lorg_jpablo_graphexplorer_viewer_components_Shortcut(keyLower, sh.G9, sh.C7, sh.C5, sh.C6));
});
$p.b2n = (function(ev) {
  console.debug("Key pressed:", ev.key, ev.code, (!(!ev.shiftKey)), (!(!ev.metaKey)), (!(!ev.altKey)), (!(!ev.ctrlKey)));
  console.debug("activeElement:", document.activeElement);
  var this$1 = ev.key;
  _return$1: {
    var len = this$1.length;
    if ((len === 1)) {
      var i = 0;
      while ((i !== len)) {
        var thisCP = $f_T__codePointAt__I__I(this$1, i);
        if (($m_jl_Character$().iy($m_jl_Character$().j0(thisCP)) !== $m_jl_Character$().iy($m_jl_Character$().j0($f_T__codePointAt__I__I("s", i))))) {
          var $x_1 = false;
          break _return$1;
        }
        i = ((i + ((thisCP >= 65536) ? 2 : 1)) | 0);
      }
      var $x_1 = true;
    } else {
      var $x_1 = false;
    }
  }
  if ((($x_1 && ((!(!ev.metaKey)) || (!(!ev.ctrlKey)))) && (!(!(!ev.altKey))))) {
    ev.preventDefault();
    ev.stopPropagation();
    var this$4 = this.aX;
    var x$1 = $m_s_concurrent_ExecutionContext$().ek();
    this$4.zH.a4B($f_Lorg_jpablo_graphexplorer_viewer_state_Persistence__snapshot__Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState(this$4), x$1).oB(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$1) => {
      matchResult19: {
        var x = $s_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$__Saved__Lorg_jpablo_graphexplorer_viewer_state_SaveResult();
        if (((x === null) ? (x$1$1 === null) : x.e(x$1$1))) {
          this.aX.od.dn.bA("Saved");
          break matchResult19;
        }
        if ((x$1$1 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$Conflict)) {
          var x66 = x$1$1.MS;
          this.aX.tr.dn.bA(x66);
          break matchResult19;
        }
        if ((x$1$1 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$Failed)) {
          var x63 = x$1$1.MT;
          var this$10 = this.aX.tr;
          var event = ("Save failed: " + x63);
          this$10.dn.bA(event);
          break matchResult19;
        }
        if ((x$1$1 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$Unsupported)) {
          var x60 = x$1$1.MU;
          this.aX.od.dn.bA(x60);
          break matchResult19;
        }
        throw new $c_s_MatchError(x$1$1);
      }
    })), $m_s_concurrent_ExecutionContext$().ek());
    return (void 0);
  }
  var this$14 = ev.key;
  _return$2: {
    var len$1 = this$14.length;
    if ((len$1 === 1)) {
      var i$1 = 0;
      while ((i$1 !== len$1)) {
        var thisCP$1 = $f_T__codePointAt__I__I(this$14, i$1);
        if (($m_jl_Character$().iy($m_jl_Character$().j0(thisCP$1)) !== $m_jl_Character$().iy($m_jl_Character$().j0($f_T__codePointAt__I__I("v", i$1))))) {
          var $x_2 = false;
          break _return$2;
        }
        i$1 = ((i$1 + ((thisCP$1 >= 65536) ? 2 : 1)) | 0);
      }
      var $x_2 = true;
    } else {
      var $x_2 = false;
    }
  }
  if ((($x_2 && ((!(!ev.metaKey)) || (!(!ev.ctrlKey)))) && (!(!(!ev.altKey))))) {
    return (void 0);
  }
  var sh = this.aQN(new $c_Lorg_jpablo_graphexplorer_viewer_components_Shortcut(ev.key, (!(!ev.shiftKey)), (!(!ev.metaKey)), (!(!ev.altKey)), (!(!ev.ctrlKey))));
  var this$18 = new $c_s_Option$WithFilter(this.a8Q.r(sh), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((cmd) => (!(!cmd.G8.i(new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds(this.aX.aH().cL())))))));
  var this$19 = this$18.tu;
  var p$1 = this$18.tv;
  var this$20 = ((this$19.c() || (!(!p$1.i(this$19.d())))) ? this$19 : $m_s_None$());
  if ((!this$20.c())) {
    var x0 = this$20.d();
    ev.preventDefault();
    ev.stopPropagation();
    var logEvent$1 = (!(!(!ev.repeat)));
    var arg$1 = $m_s_None$();
    x0.gZ(arg$1, logEvent$1);
  }
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_Commands = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_Commands, "org.jpablo.graphexplorer.viewer.components.Commands", ({
  yr: 1
}));
function $p_Lorg_jpablo_graphexplorer_viewer_components_Commands$all$__navCommand__T__T__Lorg_jpablo_graphexplorer_viewer_state_NavDirection__Lorg_jpablo_graphexplorer_viewer_components_Command($thiz, label, key, dir) {
  var action$63 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    if ((!$thiz.a8S.aX.du().b4x(dir))) {
      $thiz.a8S.aX.b3V().b4K(dir);
    }
  })));
  var shortcut$63 = new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_components_Shortcut(key, false, false, false, false));
  var description$63 = new $c_s_Some((label + ": follow an arrow from the selected element (a lone match jumps through; several select the arrow first \u2014 perpendicular keys pick among them, the same key continues)"));
  return new $c_Lorg_jpablo_graphexplorer_viewer_components_Command(label, action$63, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().kK(), shortcut$63, description$63);
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_Commands$all$(outer) {
  this.SJ = null;
  this.a8Y = null;
  this.a0b = null;
  this.awT = null;
  this.awW = null;
  this.awU = null;
  this.awV = null;
  this.awC = null;
  this.awF = null;
  this.awo = null;
  this.awq = null;
  this.awy = null;
  this.a8X = null;
  this.axc = null;
  this.awi = null;
  this.awl = null;
  this.ax6 = null;
  this.axb = null;
  this.ax1 = null;
  this.axd = null;
  this.ax7 = null;
  this.awk = null;
  this.awt = null;
  this.awj = null;
  this.aws = null;
  this.ax8 = null;
  this.awm = null;
  this.ax3 = null;
  this.ax5 = null;
  this.awE = null;
  this.awD = null;
  this.awY = null;
  this.axa = null;
  this.ax0 = null;
  this.ax9 = null;
  this.awB = null;
  this.awA = null;
  this.ax2 = null;
  this.ax4 = null;
  this.awX = null;
  this.awZ = null;
  this.awS = null;
  this.a0h = null;
  this.awz = null;
  this.awp = null;
  this.awK = null;
  this.SI = null;
  this.aww = null;
  this.awu = null;
  this.awv = null;
  this.awn = null;
  this.a92 = null;
  this.a0c = null;
  this.awh = null;
  this.a91 = null;
  this.a0i = null;
  this.a0f = null;
  this.awx = null;
  this.LE = null;
  this.a8Z = null;
  this.awO = null;
  this.awN = null;
  this.awM = null;
  this.awP = null;
  this.awL = null;
  this.SK = null;
  this.awQ = null;
  this.awR = null;
  this.awH = null;
  this.awI = null;
  this.awJ = null;
  this.awG = null;
  this.a0d = null;
  this.a0e = null;
  this.a90 = null;
  this.a0g = null;
  this.a8V = null;
  this.a8W = null;
  this.a8U = null;
  this.a8T = null;
  this.awr = null;
  this.a8S = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.a8S = outer;
  this.SJ = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("New node", $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    outer.aX.a33($m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV, $s_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$__forward__Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection());
  }))), $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().ep, new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_components_Shortcut("n", false, false, false, false)), new $c_s_Some("Add a new node"));
  this.a8Y = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("New backwards node", $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    var direction$1 = $s_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$__backward__Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection();
    var attributes$1 = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV;
    outer.aX.a33(attributes$1, direction$1);
  }))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((selection) => {
    var selection$1 = ((selection === null) ? null : selection.aS);
    return $p_Lorg_jpablo_graphexplorer_viewer_components_Commands__singleNodeSelected__sci_Set__Z(outer, selection$1);
  })), new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_components_Shortcut("n", true, false, false, false)), new $c_s_Some("Add a new node without connections"));
  this.a0b = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Edit label", $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    if ((!outer.aX.du().b0F())) {
      outer.aX.aH().afp();
    }
  }))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((selection$2) => $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().b8T(((selection$2 === null) ? null : selection$2.aS)))), new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_components_Shortcut("Enter", false, false, false, false)), new $c_s_Some("Edit the label of the selected element (records: select/edit the cell)"));
  this.awT = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Select all", $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    outer.aX.aH().b8j();
  }))), $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().ep, new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_components_Shortcut("a", false, false, false, false)), new $c_s_Some("Select all visible elements (nodes, arrows, and groups)"));
  var action$13 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    outer.aX.aH().b8m();
  })));
  var description$13 = new $c_s_Some("Select all visible nodes");
  var shortcut$13 = $m_s_None$();
  this.awW = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Select all nodes", action$13, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().ep, shortcut$13, description$13);
  var action$14 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    outer.aX.aH().b8k();
  })));
  var description$14 = new $c_s_Some("Select all visible arrows");
  var shortcut$14 = $m_s_None$();
  this.awU = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Select all arrows", action$14, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().ep, shortcut$14, description$14);
  var action$15 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    outer.aX.aH().b8l();
  })));
  var description$15 = new $c_s_Some("Select all visible groups");
  var shortcut$15 = $m_s_None$();
  this.awV = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Select all groups", action$15, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().ep, shortcut$15, description$15);
  var action$16 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    outer.aX.aH().b2C();
  })));
  var shortcut$16 = new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_components_Shortcut("h", false, false, false, false));
  var description$16 = new $c_s_Some("Hide selected nodes");
  this.awC = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Hide selection", action$16, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().kK(), shortcut$16, description$16);
  this.awF = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Keep selection", $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__hideNonSelectedNodes__V(outer.aX);
  }))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((selection$3$1) => $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().aLX(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((selection$2$1) => $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().aQA(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((selection$2$2) => {
    var selection$6 = ((selection$2$2 === null) ? null : selection$2$2.aS);
    return $p_Lorg_jpablo_graphexplorer_viewer_components_Commands__singleGroupSelected__sci_Set__Z(outer, selection$6);
  })), ((selection$2$1 === null) ? null : selection$2$1.aS)))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((selection$3$2) => (!((selection$3$2 === null) ? null : selection$3$2.aS).c()))), ((selection$3$1 === null) ? null : selection$3$1.aS)))), new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_components_Shortcut("k", false, false, false, false)), new $c_s_Some("Hide all nodes except selected"));
  var action$17 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    if ((!outer.aX.du().aRz())) {
      outer.aX.aH().aZO();
    }
  })));
  var shortcut$17 = new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_components_Shortcut("Backspace", false, false, false, false));
  var description$17 = new $c_s_Some("Delete selected nodes (records: the selected cell)");
  this.awo = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Delete selection", action$17, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().kK(), shortcut$17, description$17);
  this.awq = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Duplicate selection", $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    outer.aX.aH().b0j();
  }))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((selection$4$1) => (!((selection$4$1 === null) ? null : selection$4$1.aS).c()))), new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_components_Shortcut("d", false, false, false, false)), new $c_s_Some("Duplicate selected nodes"));
  this.awy = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Group", $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    outer.aX.aH().b2i();
  }))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((selection$5$1) => $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().aLX(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((selection$2$3) => $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().aQA(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((selection$2$4) => {
    var selection$11 = ((selection$2$4 === null) ? null : selection$2$4.aS);
    return $p_Lorg_jpablo_graphexplorer_viewer_components_Commands__onlyArrowSelected__sci_Set__Z(outer, selection$11);
  })), ((selection$2$3 === null) ? null : selection$2$3.aS)))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((selection$3$3) => (!((selection$3$3 === null) ? null : selection$3$3.aS).c()))), ((selection$5$1 === null) ? null : selection$5$1.aS)))), new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_components_Shortcut("g", false, false, false, false)), new $c_s_Some("Add selected nodes into a new group"));
  this.a8X = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Move to group", $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    outer.aX.aH().aWS();
  }))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((selection$6$1) => {
    var selection$13 = ((selection$6$1 === null) ? null : selection$6$1.aS);
    return $p_Lorg_jpablo_graphexplorer_viewer_components_Commands__moveToGroupActionVisible__sci_Set__Z(outer, selection$13);
  })), $m_s_None$(), new $c_s_Some("Move selected nodes to existing group"));
  var action$19 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    outer.aX.aH().baD();
  })));
  var shortcut$19 = new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_components_Shortcut("u", false, false, false, false));
  var description$19 = new $c_s_Some("Remove selected nodes from their current group");
  this.axc = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Ungroup", action$19, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().kK(), shortcut$19, description$19);
  var action$20 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    if ((!outer.aX.du().b0P())) {
      outer.aX.aH().ie();
    }
  })));
  var shortcut$20 = new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_components_Shortcut("Escape", false, false, false, false));
  this.awi = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Clear selection", action$20, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().kK(), shortcut$20, $m_s_None$());
  this.awl = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Combine into Record", $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    outer.aX.aH().aYF();
  }))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((selection$7$1) => {
    var selection$14 = ((selection$7$1 === null) ? null : selection$7$1.aS);
    return $p_Lorg_jpablo_graphexplorer_viewer_components_Commands__canCombineNodesVisible__sci_Set__Z(outer, selection$14);
  })), new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_components_Shortcut("b", false, false, false, false)), new $c_s_Some("Combine selected nodes into a record node"));
  this.ax6 = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Split Record", $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    outer.aX.aH().b9j();
  }))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((selection$8$1) => {
    var selection$15 = ((selection$8$1 === null) ? null : selection$8$1.aS);
    return $p_Lorg_jpablo_graphexplorer_viewer_components_Commands__canSplitRecordVisible__sci_Set__Z(outer, selection$15);
  })), new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_components_Shortcut("b", true, false, false, false)), new $c_s_Some("Split record node into individual nodes"));
  this.axb = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Transpose Record", $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    outer.aX.aH().bau();
  }))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((selection$9$1) => {
    var selection$16 = ((selection$9$1 === null) ? null : selection$9$1.aS);
    return $p_Lorg_jpablo_graphexplorer_viewer_components_Commands__canSplitRecordVisible__sci_Set__Z(outer, selection$16);
  })), new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_components_Shortcut("t", false, false, false, false)), new $c_s_Some("Toggle record node between horizontal and vertical orientation"));
  this.ax1 = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Select group members", $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    outer.aX.aH().aRX();
  }))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((selection$10$1) => {
    var selection$17 = ((selection$10$1 === null) ? null : selection$10$1.aS);
    return $p_Lorg_jpablo_graphexplorer_viewer_components_Commands__singleGroupSelected__sci_Set__Z(outer, selection$17);
  })), new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_components_Shortcut("m", false, false, false, false)), new $c_s_Some("Select all nodes that are members of the selected group"));
  this.axd = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Zoom into group", $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__showOnlyGroup__V(outer.aX);
  }))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((selection$11$1) => {
    var selection$18 = ((selection$11$1 === null) ? null : selection$11$1.aS);
    return $p_Lorg_jpablo_graphexplorer_viewer_components_Commands__singleGroupSelected__sci_Set__Z(outer, selection$18);
  })), new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_components_Shortcut("z", false, false, false, false)), new $c_s_Some("Show only the selected group and its members"));
  this.ax7 = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Collapse/expand group", $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    outer.aX.aH().aii();
  }))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((selection$12$1) => {
    var selection$19 = ((selection$12$1 === null) ? null : selection$12$1.aS);
    return $p_Lorg_jpablo_graphexplorer_viewer_components_Commands__groupOrCollapsedBox__sci_Set__Z(outer, selection$19);
  })), new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_components_Shortcut("e", false, false, false, false)), new $c_s_Some("Render the selected group as a single box, or unfold it again"));
  this.awk = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Collapse selected groups", $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    outer.aX.aH().aYs();
  }))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((selection$13$1) => {
    var selection$20 = ((selection$13$1 === null) ? null : selection$13$1.aS);
    return $p_Lorg_jpablo_graphexplorer_viewer_components_Commands__groupOrCollapsedBox__sci_Set__Z(outer, selection$20);
  })), $m_s_None$(), new $c_s_Some("Render each selected group as a single box"));
  this.awt = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Expand selected groups", $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    outer.aX.aH().b0X();
  }))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((selection$14$1) => {
    var selection$21 = ((selection$14$1 === null) ? null : selection$14$1.aS);
    return $p_Lorg_jpablo_graphexplorer_viewer_components_Commands__groupOrCollapsedBox__sci_Set__Z(outer, selection$21);
  })), $m_s_None$(), new $c_s_Some("Unfold the selected collapsed groups"));
  var action$23 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    outer.aX.aYt();
  })));
  var description$23 = new $c_s_Some("Render every group in the diagram as a single box");
  var shortcut$23 = $m_s_None$();
  this.awj = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Collapse all groups", action$23, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().ep, shortcut$23, description$23);
  var action$24 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    outer.aX.b0Y();
  })));
  var description$24 = new $c_s_Some("Unfold every collapsed group");
  var shortcut$24 = $m_s_None$();
  this.aws = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Expand all groups", action$24, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().ep, shortcut$24, description$24);
  var action$25 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lcom_raquo_airstream_state_Var__update__F1__V(outer.aX.abg, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4) => (!(!(!_$4))))));
  })));
  var description$25 = new $c_s_Some("Animate elements to their new place when the layout changes");
  var shortcut$25 = $m_s_None$();
  this.ax8 = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Toggle layout animation", action$25, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().ep, shortcut$25, description$25);
  var action$26 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lorg_jpablo_graphexplorer_viewer_state_ExportOps__copySelectionAsSVG__V(outer.aX);
  })));
  var shortcut$26 = new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_components_Shortcut("c", false, false, false, false));
  var description$26 = new $c_s_Some("Copy the selected nodes as SVG to the clipboard");
  this.awm = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Copy selection as SVG", action$26, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().kK(), shortcut$26, description$26);
  var action$27 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__showAllSuccessors__V(outer.aX);
  })));
  var description$27 = new $c_s_Some("Show all successors of the selected nodes");
  this.ax3 = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Show all successors", action$27, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().kK(), $m_s_None$(), description$27);
  var action$28 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__showDirectSuccessors__V(outer.aX);
  })));
  var shortcut$28 = new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_components_Shortcut("+", false, false, false, false));
  var description$28 = new $c_s_Some("Show direct successors of the selected nodes");
  this.ax5 = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Show direct successors", action$28, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().kK(), shortcut$28, description$28);
  var action$29 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $p_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__contractSelection__Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction__Z__V(outer.aX, $s_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$__Successors__Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction(), true);
  })));
  var shortcut$29 = new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_components_Shortcut("-", false, false, false, false));
  var description$29 = new $c_s_Some("Hide outgoing arrows; hide successors that lose all incoming arrows, recursively");
  this.awE = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Hide successors (recursive)", action$29, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().kK(), shortcut$29, description$29);
  var action$30 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $p_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__contractSelection__Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction__Z__V(outer.aX, $s_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$__Successors__Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction(), false);
  })));
  var description$30 = new $c_s_Some("Hide outgoing arrows; hide successors that lose all incoming arrows (one layer)");
  this.awD = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Hide successor layer", action$30, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().kK(), $m_s_None$(), description$30);
  var action$31 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $p_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$selection$__selectRelated__Z__Z__V(outer.aX.aH(), true, true);
  })));
  var shortcut$31 = new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_components_Shortcut("s", true, false, false, false));
  var description$31 = new $c_s_Some("Select all successors of the selected nodes");
  this.awY = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Select all successors", action$31, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().kK(), shortcut$31, description$31);
  var action$32 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__toggleSuccessors__sci_Set__V(outer.aX, $f_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__toggleSuccessors$default$1__sci_Set(outer.aX));
  })));
  var description$32 = new $c_s_Some("Tree-style toggle: show the selected nodes' hidden direct successors, or hide the successor layer if none are hidden");
  var shortcut$32 = new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_components_Shortcut(".", false, false, false, false));
  this.axa = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Expand/contract successors", action$32, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().kK(), shortcut$32, description$32);
  var action$33 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $p_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$selection$__selectRelated__Z__Z__V(outer.aX.aH(), true, false);
  })));
  var shortcut$33 = new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_components_Shortcut("s", false, false, false, false));
  var description$33 = new $c_s_Some("Select direct successors of the selected nodes");
  this.ax0 = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Select direct successors", action$33, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().kK(), shortcut$33, description$33);
  var action$34 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__togglePredecessors__sci_Set__V(outer.aX, $f_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__togglePredecessors$default$1__sci_Set(outer.aX));
  })));
  var description$34 = new $c_s_Some("Tree-style toggle: show the selected nodes' hidden direct predecessors, or hide the predecessor layer if none are hidden");
  var shortcut$34 = new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_components_Shortcut(",", false, false, false, false));
  this.ax9 = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Expand/contract predecessors", action$34, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().kK(), shortcut$34, description$34);
  var action$35 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $p_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__contractSelection__Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction__Z__V(outer.aX, $s_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$__Predecessors__Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction(), true);
  })));
  var description$35 = new $c_s_Some("Hide incoming arrows; hide predecessors that lose all outgoing arrows, recursively");
  this.awB = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Hide predecessors (recursive)", action$35, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().kK(), $m_s_None$(), description$35);
  var action$36 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $p_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__contractSelection__Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction__Z__V(outer.aX, $s_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$__Predecessors__Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction(), false);
  })));
  var description$36 = new $c_s_Some("Hide incoming arrows; hide predecessors that lose all outgoing arrows (one layer)");
  this.awA = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Hide predecessor layer", action$36, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().kK(), $m_s_None$(), description$36);
  var action$37 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__showAllPredecessors__V(outer.aX);
  })));
  var description$37 = new $c_s_Some("Show all predecessors of the selected nodes");
  this.ax2 = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Show all predecessors", action$37, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().kK(), $m_s_None$(), description$37);
  var action$38 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__showDirectPredecessors__V(outer.aX);
  })));
  var description$38 = new $c_s_Some("Show direct predecessors of the selected nodes");
  this.ax4 = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Show direct predecessors", action$38, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().kK(), $m_s_None$(), description$38);
  var action$39 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $p_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$selection$__selectRelated__Z__Z__V(outer.aX.aH(), false, true);
  })));
  var shortcut$39 = new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_components_Shortcut("p", true, false, false, false));
  var description$39 = new $c_s_Some("Select all predecessors of the selected nodes");
  this.awX = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Select all predecessors", action$39, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().kK(), shortcut$39, description$39);
  var action$40 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $p_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$selection$__selectRelated__Z__Z__V(outer.aX.aH(), false, false);
  })));
  var shortcut$40 = new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_components_Shortcut("p", false, false, false, false));
  var description$40 = new $c_s_Some("Select direct predecessors of the selected nodes");
  this.awZ = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Select direct predecessors", action$40, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().kK(), shortcut$40, description$40);
  var action$41 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__keepRootsOnly__V(outer.aX);
  })));
  var description$41 = new $c_s_Some("A root is a node without predecessors");
  var shortcut$41 = $m_s_None$();
  this.awS = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Show roots only", action$41, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().ep, shortcut$41, description$41);
  var action$12$1 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    outer.aX.il().ie();
  })));
  var description$12$1 = new $c_s_Some("Show all elements");
  var shortcut$12$1 = $m_s_None$();
  this.a0h = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Show all", action$12$1, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().ep, shortcut$12$1, description$12$1);
  var action$42 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__hideAllNodes__V(outer.aX);
  })));
  var description$42 = new $c_s_Some("Hide all nodes");
  var shortcut$42 = $m_s_None$();
  this.awz = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Hide all", action$42, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().ep, shortcut$42, description$42);
  var action$43 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__deleteHiddenElements__V(outer.aX);
  })));
  var description$43 = new $c_s_Some("Delete all currently hidden nodes, arrows, and groups");
  var shortcut$43 = $m_s_None$();
  this.awp = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Delete hidden elements", action$43, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().ep, shortcut$43, description$43);
  this.awK = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Paste diagram", $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lorg_jpablo_graphexplorer_viewer_state_ImportOps__pasteDiagram__V(outer.aX);
  }))), $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().ep, new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_components_Shortcut("v", false, true, false, false)), new $c_s_Some("Replace the diagram with the DOT or Mermaid source on the clipboard"));
  var action$44$1 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $p_Lorg_jpablo_graphexplorer_viewer_components_Commands__changeProjectNameAction__V(outer);
  })));
  var description$44$1 = new $c_s_Some("Change the name of the current project");
  var shortcut$44$1 = $m_s_None$();
  this.SI = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Change project name", action$44$1, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().ep, shortcut$44$1, description$44$1);
  var action$45 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lorg_jpablo_graphexplorer_viewer_state_ExportOps__copyAsFullDiagramSVG__V(outer.aX);
  })));
  var description$45 = new $c_s_Some("Copy the full diagram as SVG to the clipboard");
  var shortcut$45 = $m_s_None$();
  this.aww = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Copy full diagram as SVG", action$45, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().ep, shortcut$45, description$45);
  var action$46 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lorg_jpablo_graphexplorer_viewer_state_ExportOps__copyAsDOT__V(outer.aX);
  })));
  var description$46 = new $c_s_Some("Copy the full diagram as DOT to the clipboard");
  var shortcut$46 = $m_s_None$();
  this.awu = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("as DOT", action$46, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().ep, shortcut$46, description$46);
  var action$47 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lorg_jpablo_graphexplorer_viewer_state_ExportOps__copyAsJSON__V(outer.aX);
  })));
  var description$47 = new $c_s_Some("Copy the full diagram as JSON to the clipboard");
  var shortcut$47 = $m_s_None$();
  this.awv = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("as JSON", action$47, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().ep, shortcut$47, description$47);
  var action$48 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    var dot = outer.aX.mz.P().aq().d();
    var url = $m_Lorg_jpablo_graphexplorer_viewer_utils_ShareUrl$().aY6(outer.aX.aRb(), dot);
    outer.aX.vt.i(url);
    console.info("Share URL copied to clipboard", url);
    outer.aX.od.dn.bA("Link copied to clipboard");
  })));
  var description$48 = new $c_s_Some("Copy a link that holds this diagram");
  var shortcut$48 = $m_s_None$();
  this.awn = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Share URL", action$48, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().ep, shortcut$48, description$48);
  var action$49 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps__zoomOut__V(outer.aX);
  })));
  var description$49 = new $c_s_Some("Zoom out the diagram");
  var shortcut$49 = $m_s_None$();
  this.a92 = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Zoom out", action$49, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().ep, shortcut$49, description$49);
  var action$50 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    outer.aX.a11.dn.bA((void 0));
  })));
  var description$50 = new $c_s_Some("Fit the diagram to the screen");
  var shortcut$50 = $m_s_None$();
  this.a0c = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Fit", action$50, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().ep, shortcut$50, description$50);
  var action$51 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps__autoFitToggle__V(outer.aX);
  })));
  var description$51 = new $c_s_Some("Zoom in the diagram");
  var shortcut$51 = $m_s_None$();
  this.awh = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Auto fit", action$51, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().ep, shortcut$51, description$51);
  var action$52 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps__zoomIn__V(outer.aX);
  })));
  var description$52 = new $c_s_Some("Zoom in the diagram");
  var shortcut$52 = $m_s_None$();
  this.a91 = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Zoom in", action$52, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().ep, shortcut$52, description$52);
  var action$53 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    outer.aX.abs.dn.bA((void 0));
  })));
  var description$53 = new $c_s_Some("Undo the last action");
  var shortcut$53 = $m_s_None$();
  this.a0i = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Undo", action$53, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().ep, shortcut$53, description$53);
  var action$54 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    outer.aX.abp.dn.bA((void 0));
  })));
  var description$54 = new $c_s_Some("Redo the last action");
  var shortcut$54 = $m_s_None$();
  this.a0f = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Redo", action$54, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().ep, shortcut$54, description$54);
  this.awx = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Find elements", $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lcom_raquo_airstream_state_Var__set__O__V(outer.aX.qs, $s_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$__elements__Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection());
  }))), $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().ep, new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_components_Shortcut("/", false, false, false, false)), new $c_s_Some("Open the Elements palette with the filter focused"));
  var action$55$1 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lcom_raquo_airstream_state_Var__set__O__V(outer.aX.abi, true);
  })));
  var description$55$1 = new $c_s_Some("Open the keyboard shortcuts help dialog");
  var shortcut$55$1 = $m_s_None$();
  this.LE = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Help - Keyboard Shortcuts", action$55$1, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().ep, shortcut$55$1, description$55$1);
  var action$56 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lcom_raquo_airstream_state_Var__set__O__V(outer.aX.abf, true);
  })));
  var description$56 = new $c_s_Some("Show application information");
  var shortcut$56 = $m_s_None$();
  this.a8Z = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("About", action$56, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().ep, shortcut$56, description$56);
  var action$57 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lorg_jpablo_graphexplorer_viewer_state_ExportOps__printVisibleGraphToConsole__V(outer.aX);
  })));
  var description$57 = new $c_s_Some("Print the visible graph to the browser console for debugging");
  var shortcut$57 = $m_s_None$();
  this.awO = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Print visible graph to the console", action$57, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().ep, shortcut$57, description$57);
  var action$58 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lorg_jpablo_graphexplorer_viewer_state_ExportOps__printVisibleGraphJsonToConsole__V(outer.aX);
  })));
  var description$58 = new $c_s_Some("Print the visible graph as json to the browser console for debugging");
  var shortcut$58 = $m_s_None$();
  this.awN = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Print visible graph as json to the console", action$58, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().ep, shortcut$58, description$58);
  var action$59 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lorg_jpablo_graphexplorer_viewer_state_ExportOps__printVisibleDOTtoConsole__V(outer.aX);
  })));
  var description$59 = new $c_s_Some("Print the visible DOT to the browser console for debugging");
  var shortcut$59 = $m_s_None$();
  this.awM = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Print visible DOT to the console", action$59, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().ep, shortcut$59, description$59);
  var action$60 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lorg_jpablo_graphexplorer_viewer_state_ExportOps__printVisibleSimpleGraphJSONtoConsole__V(outer.aX);
  })));
  var description$60 = new $c_s_Some("Print the full diagram as graph JSON to console for debugging");
  var shortcut$60 = $m_s_None$();
  this.awP = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Print Visible Simple Graph Json to the console", action$60, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().ep, shortcut$60, description$60);
  var action$61 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps__printSelectionToConsole__V(outer.aX);
  })));
  var description$61 = new $c_s_Some("Print the current selection to console for debugging");
  var shortcut$61 = $m_s_None$();
  this.awL = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Print the current selection to the console", action$61, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().ep, shortcut$61, description$61);
  this.SK = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Reset Attributes", $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    outer.aX.aH().b7J();
  }))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((selection$15$1) => (!((selection$15$1 === null) ? null : selection$15$1.aS).c()))), $m_s_None$(), new $c_s_Some("Remove all attributes except 'label' from selected elements"));
  $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    outer.aX.aH().b7K();
  })));
  this.awQ = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Reverse Arrows direction", $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    outer.aX.aH().b7U();
  }))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((selection$17$1) => {
    var selection$24 = ((selection$17$1 === null) ? null : selection$17$1.aS);
    return $p_Lorg_jpablo_graphexplorer_viewer_components_Commands__onlyArrowSelected__sci_Set__Z(outer, selection$24);
  })), $m_s_None$(), new $c_s_Some("Reverse the direction of the selected arrows"));
  this.awR = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Reverse Arrows Head/Tail Style", $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    outer.aX.aH().b7W();
  }))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((selection$18$1) => {
    var selection$25 = ((selection$18$1 === null) ? null : selection$18$1.aS);
    return $p_Lorg_jpablo_graphexplorer_viewer_components_Commands__onlyArrowSelected__sci_Set__Z(outer, selection$25);
  })), new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_components_Shortcut("r", false, false, false, false)), new $c_s_Some("Reverse the Head/Tail *Style* of the selected arrows"));
  this.awH = $p_Lorg_jpablo_graphexplorer_viewer_components_Commands$all$__navCommand__T__T__Lorg_jpablo_graphexplorer_viewer_state_NavDirection__Lorg_jpablo_graphexplorer_viewer_components_Command(this, "Navigate left", "ArrowLeft", $s_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$__NavLeft__Lorg_jpablo_graphexplorer_viewer_state_NavDirection());
  this.awI = $p_Lorg_jpablo_graphexplorer_viewer_components_Commands$all$__navCommand__T__T__Lorg_jpablo_graphexplorer_viewer_state_NavDirection__Lorg_jpablo_graphexplorer_viewer_components_Command(this, "Navigate right", "ArrowRight", $s_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$__NavRight__Lorg_jpablo_graphexplorer_viewer_state_NavDirection());
  this.awJ = $p_Lorg_jpablo_graphexplorer_viewer_components_Commands$all$__navCommand__T__T__Lorg_jpablo_graphexplorer_viewer_state_NavDirection__Lorg_jpablo_graphexplorer_viewer_components_Command(this, "Navigate up", "ArrowUp", $s_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$__NavUp__Lorg_jpablo_graphexplorer_viewer_state_NavDirection());
  this.awG = $p_Lorg_jpablo_graphexplorer_viewer_components_Commands$all$__navCommand__T__T__Lorg_jpablo_graphexplorer_viewer_state_NavDirection__Lorg_jpablo_graphexplorer_viewer_components_Command(this, "Navigate down", "ArrowDown", $s_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$__NavDown__Lorg_jpablo_graphexplorer_viewer_state_NavDirection());
  this.a0d = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Insert cell after", $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    outer.aX.du().aPm(true);
  }))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((selection$19$1) => {
    var selection$26 = ((selection$19$1 === null) ? null : selection$19$1.aS);
    return $p_Lorg_jpablo_graphexplorer_viewer_components_Commands__cellSelected__sci_Set__Z(outer, selection$26);
  })), new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_components_Shortcut("|", false, false, false, false)), new $c_s_Some("Insert an empty record cell after the selected cell"));
  this.a0e = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Insert cell before", $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    outer.aX.du().aPm(false);
  }))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((selection$20$1) => {
    var selection$27 = ((selection$20$1 === null) ? null : selection$20$1.aS);
    return $p_Lorg_jpablo_graphexplorer_viewer_components_Commands__cellSelected__sci_Set__Z(outer, selection$27);
  })), $m_s_None$(), new $c_s_Some("Insert an empty record cell before the selected cell"));
  this.a90 = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Split cell", $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    outer.aX.du().b9k();
  }))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((selection$21$1) => {
    var selection$28 = ((selection$21$1 === null) ? null : selection$21$1.aS);
    return $p_Lorg_jpablo_graphexplorer_viewer_components_Commands__recordCellSelected__sci_Set__Z(outer, selection$28);
  })), $m_s_None$(), new $c_s_Some("Split the selected cell perpendicular to its group ({\u2026} nesting)"));
  this.a0g = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Remove cell", $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    outer.aX.du().aRz();
  }))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((selection$22$1) => {
    var selection$29 = ((selection$22$1 === null) ? null : selection$22$1.aS);
    return $p_Lorg_jpablo_graphexplorer_viewer_components_Commands__cellSelected__sci_Set__Z(outer, selection$29);
  })), $m_s_None$(), new $c_s_Some("Remove the selected record cell (html tables: clear the cell)"));
  this.a8V = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Insert row above", $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    outer.aX.du().aPl(false);
  }))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((selection$23$1) => {
    var selection$30 = ((selection$23$1 === null) ? null : selection$23$1.aS);
    return $p_Lorg_jpablo_graphexplorer_viewer_components_Commands__htmlCellSelected__sci_Set__Z(outer, selection$30);
  })), $m_s_None$(), new $c_s_Some("Insert a row of empty cells above the selected table cell"));
  this.a8W = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Insert row below", $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    outer.aX.du().aPl(true);
  }))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((selection$24$1) => {
    var selection$31 = ((selection$24$1 === null) ? null : selection$24$1.aS);
    return $p_Lorg_jpablo_graphexplorer_viewer_components_Commands__htmlCellSelected__sci_Set__Z(outer, selection$31);
  })), $m_s_None$(), new $c_s_Some("Insert a row of empty cells below the selected table cell"));
  this.a8U = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Delete row", $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    outer.aX.du().aZM();
  }))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((selection$25$1) => {
    var selection$32 = ((selection$25$1 === null) ? null : selection$25$1.aS);
    return $p_Lorg_jpablo_graphexplorer_viewer_components_Commands__htmlCellSelected__sci_Set__Z(outer, selection$32);
  })), $m_s_None$(), new $c_s_Some("Delete the selected table cell's row"));
  this.a8T = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Delete column", $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    outer.aX.du().aZL();
  }))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((selection$26$1) => {
    var selection$33 = ((selection$26$1 === null) ? null : selection$26$1.aS);
    return $p_Lorg_jpablo_graphexplorer_viewer_components_Commands__htmlCellSelected__sci_Set__Z(outer, selection$33);
  })), $m_s_None$(), new $c_s_Some("Delete the selected table cell's column"));
  this.awr = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Edit record label (raw)", $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    outer.aX.aH().afp();
  }))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((selection$27$1) => {
    var selection$34 = ((selection$27$1 === null) ? null : selection$27$1.aS);
    return $p_Lorg_jpablo_graphexplorer_viewer_components_Commands__canSplitRecordVisible__sci_Set__Z(outer, selection$34);
  })), $m_s_None$(), new $c_s_Some("Edit the record's whole label as raw record syntax"));
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_Commands$all$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_Commands$all$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_Commands$all$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_Commands$all$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_viewer_components_Commands$all$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_Commands$all$, "org.jpablo.graphexplorer.viewer.components.Commands$all$", ({
  yt: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_Commands$headers$() {
  this.axf = null;
  this.axi = null;
  this.a93 = null;
  this.a97 = null;
  this.a98 = null;
  this.a99 = null;
  this.a96 = null;
  this.a9a = null;
  this.axh = null;
  this.a95 = null;
  this.a94 = null;
  this.axk = null;
  this.axj = null;
  this.axe = null;
  this.axg = null;
  this.axf = "Common";
  this.axi = "Navigation";
  this.a93 = "Add";
  this.a97 = "Select";
  this.a98 = "Selection";
  this.a99 = "Successors";
  this.a96 = "Predecessors";
  this.a9a = "View";
  this.axh = "Document";
  this.a95 = "Import";
  this.a94 = "Export";
  this.axk = "Zoom";
  this.axj = "Undo/Redo";
  this.axe = "Application";
  this.axg = "Developer";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_Commands$headers$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_Commands$headers$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_Commands$headers$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_Commands$headers$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_viewer_components_Commands$headers$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_Commands$headers$, "org.jpablo.graphexplorer.viewer.components.Commands$headers$", ({
  yu: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_Commands$sections$(outer) {
  this.axm = null;
  this.axp = null;
  this.axl = null;
  this.axo = null;
  this.axn = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.axm = $f_sc_MapOps__apply__O__O(outer.vh, outer.jq().a93);
  this.axp = $f_sc_MapOps__apply__O__O(outer.vh, outer.jq().a97);
  this.axl = $f_sc_MapOps__apply__O__O(outer.vh, outer.jq().a98).g9($f_sc_MapOps__apply__O__O(outer.vh, outer.jq().a9a)).g9($f_sc_MapOps__apply__O__O(outer.vh, outer.jq().a99)).g9($f_sc_MapOps__apply__O__O(outer.vh, outer.jq().a96));
  this.axo = $f_sc_MapOps__apply__O__O(outer.vh, outer.jq().a95);
  this.axn = $f_sc_MapOps__apply__O__O(outer.vh, outer.jq().a94);
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_Commands$sections$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_Commands$sections$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_Commands$sections$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_Commands$sections$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_viewer_components_Commands$sections$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_Commands$sections$, "org.jpablo.graphexplorer.viewer.components.Commands$sections$", ({
  yv: 1
}));
function $p_Lorg_jpablo_graphexplorer_viewer_components_CommandsPanel$package$__shouldShowCommand$1__T__sci_Set__Lorg_jpablo_graphexplorer_viewer_components_Command__Z($thiz, term, selection, cmd) {
  var this$1 = cmd.lE;
  var this$2 = this$1.toLowerCase();
  var s = term.toLowerCase();
  if (((this$2.indexOf(s) | 0) !== (-1))) {
    return (!(!cmd.G8.i(new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds(selection))));
  } else {
    return false;
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_CommandsPanel$package$__getVisibleCommands$1__Lorg_jpablo_graphexplorer_viewer_components_Commands__T__sci_Set__sci_Map($thiz, commands$1, term, selection) {
  var this$1 = commands$1.vh;
  $m_sci_VectorMap$();
  var b = new $c_sci_VectorMapBuilder();
  var it = new $c_sci_VectorMap$$anon$1(this$1);
  while (it.p()) {
    var x0 = it.dC();
    if ((x0 === null)) {
      throw new $c_s_MatchError(x0);
    }
    var k = x0.g();
    var v = x0.h();
    var f = ((term, selection) => ((cmd) => $p_Lorg_jpablo_graphexplorer_viewer_components_CommandsPanel$package$__shouldShowCommand$1__T__sci_Set__Lorg_jpablo_graphexplorer_viewer_components_Command__Z($thiz, term, selection, cmd)))(term, selection);
    var l = v;
    block: {
      var $x_1;
      while (true) {
        if (l.c()) {
          var $x_1 = $m_sci_Nil$();
          break;
        } else {
          var h = l.t();
          var t = l.v();
          if ((!(!(!f(h))))) {
            l = t;
            continue;
          }
          var start = l;
          var remaining = t;
          while (true) {
            if (remaining.c()) {
              var $x_1 = start;
              break block;
            } else {
              var x = remaining.t();
              if ((!(!f(x)))) {
                remaining = remaining.v();
                continue;
              }
              var firstMiss = remaining;
              var newHead = new $c_sci_$colon$colon(start.t(), $m_sci_Nil$());
              var toProcess = start.v();
              var currentLast = newHead;
              while ((toProcess !== firstMiss)) {
                var newElem = new $c_sci_$colon$colon(toProcess.t(), $m_sci_Nil$());
                currentLast.U = newElem;
                currentLast = newElem;
                toProcess = toProcess.v();
              }
              var next = firstMiss.v();
              var nextToCopy = next;
              while ((!next.c())) {
                var head = next.t();
                if ((!(!f(head)))) {
                  next = next.v();
                } else {
                  while ((nextToCopy !== next)) {
                    var newElem$2 = new $c_sci_$colon$colon(nextToCopy.t(), $m_sci_Nil$());
                    currentLast.U = newElem$2;
                    currentLast = newElem$2;
                    nextToCopy = nextToCopy.v();
                  }
                  nextToCopy = next.v();
                  next = next.v();
                }
              }
              if ((!nextToCopy.c())) {
                currentLast.U = nextToCopy;
              }
              var $x_1 = newHead;
              break block;
            }
          }
        }
      }
    }
    b.pm(k, $x_1);
  }
  return b.rb();
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_CommandsPanel$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_CommandsPanel$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_CommandsPanel$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_CommandsPanel$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_CommandsPanel$package$.prototype = $p;
$p.aVM = (function(state, commands) {
  var searchTerm = $m_Lcom_raquo_laminar_api_package$().b.ff.bx("");
  var searchHasFocus = $m_Lcom_raquo_laminar_api_package$().b.ff.bx(false);
  $m_Lcom_raquo_laminar_api_package$();
  var focusSearch = new $c_Lcom_raquo_airstream_eventbus_EventBus();
  var highlightedIndex = $m_Lcom_raquo_laminar_api_package$().b.ff.bx((-1));
  var scrollDown = $m_Lcom_raquo_laminar_api_package$().b.ff.bx(true);
  var rows = $m_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$().li(searchTerm.P(), state.aH().ne, new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((term, selection) => {
    var selection$1 = ((selection === null) ? null : selection.aS);
    var allVisibleCmds = $p_Lorg_jpablo_graphexplorer_viewer_components_CommandsPanel$package$__getVisibleCommands$1__Lorg_jpablo_graphexplorer_viewer_components_Commands__T__sci_Set__sci_Map(this, commands, term, selection$1);
    var flattenedCmds = allVisibleCmds.e6().dk($m_s_$less$colon$less$().b1).bM();
    return $m_sci_Seq$().fw(allVisibleCmds).un(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
      if ((x$1 !== null)) {
        x$1.g();
        return (!x$1.h().c());
      }
      throw new $c_s_MatchError(x$1);
    }))).c5(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
      if ((x$1$2 !== null)) {
        var cmdTitle$1 = x$1$2.g();
        var visibleCmds$1 = x$1$2.h();
        var titleElement = $m_Lcom_raquo_laminar_api_package$().b.yc().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("menu-title"), $m_Lcom_raquo_laminar_api_package$().b.ago().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, cmdTitle$1, $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $m_Lcom_raquo_laminar_api_package$().b.b2F().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([])))])));
        var f$1 = ((cmd) => {
          _return: {
            var i = 0;
            var these = $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(flattenedCmds, 0, flattenedCmds);
            while ((!these.c())) {
              if ((these.t().lE === cmd.lE)) {
                var cmdIndex = i;
                break _return;
              }
              i = ((1 + i) | 0);
              these = these.v();
            }
            var cmdIndex = (-1);
          }
          var isActive = $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), highlightedIndex.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3) => ((_$3 | 0) === cmdIndex))), $m_s_None$());
          var $x_17 = $m_Lcom_raquo_laminar_api_package$().b.yc();
          var $x_16 = $m_sr_ScalaRunTime$();
          var $x_15 = $m_Lcom_raquo_laminar_api_package$().b.DD();
          var $x_14 = $m_sr_ScalaRunTime$();
          var $x_13 = $m_Lcom_raquo_laminar_api_package$().b.gz();
          var this$11 = cmd.lE;
          var this$12 = this$11.split(" ").join("-");
          var $x_12 = $x_13.n(("cmd-" + this$12.toLowerCase()));
          var $x_11 = $m_Lcom_raquo_laminar_api_package$().b.y.s("flex justify-between");
          var $x_10 = $m_Lcom_raquo_laminar_api_package$().b.eW();
          var this$13 = cmd.vg;
          var $x_9 = $x_10.n((this$13.c() ? cmd.lE : this$13.d()));
          var $x_8 = $m_Lcom_raquo_laminar_api_package$().b.y.s("menu-active").bj(isActive);
          var $x_7 = $f_Lcom_raquo_laminar_api_Laminar__inContext__F1__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((thisNode) => {
            $m_Lcom_raquo_laminar_api_package$();
            return $m_Lcom_raquo_laminar_api_Implicits$RichSource$().ft(isActive, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((thisNode$2) => ((v1) => {
              if ((!(!v1))) {
                thisNode$2.en.scrollIntoView($m_sjs_js_special_package$().eA($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("block", "nearest")]))));
              }
            }))(thisNode)));
          })));
          var $x_6 = $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, cmd.lE, $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])));
          var $x_5 = $m_Lcom_raquo_laminar_api_package$().b.a8();
          var $x_4 = $m_sr_ScalaRunTime$();
          var this$26 = $m_Lcom_raquo_laminar_api_package$().b;
          var this$21 = cmd.x4;
          if (this$21.c()) {
            var $x_1 = $m_s_None$();
          } else {
            var x0$1 = this$21.d();
            var $x_3 = $m_Lorg_jpablo_graphexplorer_viewer_utils_Utils$package$();
            var this$23 = x0$1.bM();
            var f = ((s) => $m_Lcom_raquo_laminar_api_package$().b.oD().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("kbd kbd-sm opacity-60"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, s, $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))));
            if ((this$23 === $m_sci_Nil$())) {
              var $x_2 = $m_sci_Nil$();
            } else {
              var x0$2 = this$23.t();
              var h = new $c_sci_$colon$colon(f(x0$2), $m_sci_Nil$());
              var t = h;
              var rest = this$23.v();
              while ((rest !== $m_sci_Nil$())) {
                var x0$3 = rest.t();
                var nx = new $c_sci_$colon$colon(f(x0$3), $m_sci_Nil$());
                t.U = nx;
                t = nx;
                rest = rest.v();
              }
              var $x_2 = h;
            }
            var $x_1 = new $c_s_Some($x_3.a3P($x_2, $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, " + ", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))));
          }
          return $x_17.w($x_16.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_15.w($x_14.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_12, $x_11, $x_9, $x_8, $x_7, $x_6, $x_5.w($x_4.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__optionToModifier__s_Option__F1__Lcom_raquo_laminar_modifiers_Modifier(this$26, $x_1, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((nodes) => $f_Lcom_raquo_laminar_api_Implicits__nodeSeqToModifier__O__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, nodes, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$()))))]))), new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.Av(), false, false)).AG().jY(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((cmd$4) => ((_$5) => {
            cmd$4.gZ($m_s_None$(), true);
            focusSearch.dn.bA(true);
          }))(cmd)))])))])));
        });
        if ((visibleCmds$1 === $m_sci_Nil$())) {
          var $x_18 = $m_sci_Nil$();
        } else {
          var x0$4 = visibleCmds$1.t();
          var h$1 = new $c_sci_$colon$colon(f$1(x0$4), $m_sci_Nil$());
          var t$1 = h$1;
          var rest$1 = visibleCmds$1.v();
          while ((rest$1 !== $m_sci_Nil$())) {
            var x0$5 = rest$1.t();
            var nx$1 = new $c_sci_$colon$colon(f$1(x0$5), $m_sci_Nil$());
            t$1.U = nx$1;
            t$1 = nx$1;
            rest$1 = rest$1.v();
          }
          var $x_18 = h$1;
        }
        return $x_18.Ec(titleElement);
      }
      throw new $c_s_MatchError(x$1$2);
    })));
  })));
  var $x_24 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_23 = $m_sr_ScalaRunTime$();
  var $x_22 = $m_Lcom_raquo_laminar_api_package$().b.y.s("dropdown");
  $m_Lcom_raquo_laminar_api_package$();
  var $x_21 = $m_Lcom_raquo_laminar_api_Implicits$RichSource$().ft(searchTerm.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6) => {
    $f_Lcom_raquo_airstream_state_Var__set__O__V(highlightedIndex, (-1));
  })));
  $m_Lcom_raquo_laminar_api_package$();
  var $x_20 = $m_Lcom_raquo_laminar_api_Implicits$RichSource$().ft(state.aH().ne, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1$1) => {
    $f_Lcom_raquo_airstream_state_Var__set__O__V(highlightedIndex, (-1));
  })));
  $m_Lcom_raquo_laminar_api_package$();
  var $x_19 = $m_Lcom_raquo_laminar_api_Implicits$RichSource$();
  var this$32 = $m_Lcom_raquo_laminar_api_package$().b;
  var x0$6 = this$32.apc;
  $m_Lcom_raquo_laminar_api_package$();
  var p = $m_Lcom_raquo_laminar_keys_EventProcessor$().az(x0$6.m1(), false, false);
  return $x_24.w($x_23.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_22, $x_21, $x_20, $x_19.ft(new $c_Lcom_raquo_airstream_misc_FilterStream(new $c_Lcom_raquo_airstream_misc_CollectStream($m_Lcom_raquo_airstream_web_DomEventStream$().IC(document, p.j1.m8, p.m7), p.m6), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e) => {
    var this$38 = e.key;
    if ((this$38.toLowerCase() === "k")) {
      return (!(!e.metaKey));
    } else {
      return false;
    }
  }))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$2) => {
    e$2.preventDefault();
    focusSearch.dn.bA(true);
  }))), $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().aLv($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lorg_jpablo_graphexplorer_viewer_widgets_InputVariant$().aH6, $m_Lcom_raquo_laminar_api_package$().b.y.s("px-1.5 w-44 transition-all duration-200 ease-in-out mt-[-3px] no-outline"), $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("bi bi-search opacity-40 text-xs")]))), $f_Lcom_raquo_laminar_api_Laminar__inContext__F1__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((thisNode$1) => {
    var $x_32 = $m_Lcom_raquo_laminar_api_package$().b.w7();
    var $x_31 = $m_sr_ScalaRunTime$();
    var $x_30 = $m_Lcom_raquo_laminar_api_package$().b.wl().n("search");
    var $x_29 = $m_Lcom_raquo_laminar_api_package$().b.y.s("grow");
    var $x_28 = $m_Lcom_raquo_laminar_api_package$().b.ud().n("Search commands\u2026");
    var $x_27 = new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.aQI(), false, false)).Xv(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => true))), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => {
      searchHasFocus.jA().bA(_$1);
    })));
    var $x_26 = new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.aQE(), false, false)).Xv(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => false))), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1$1) => {
      searchHasFocus.jA().bA(_$1$1);
    })));
    var this$46 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.aQI(), false, false));
    var onNext$3 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((thisNode$2$1) => (() => {
      thisNode$2$1.en.classList.add("w-60");
    }))(thisNode$1));
    $m_Lcom_raquo_laminar_api_package$features$().cz();
    var $x_25 = new $c_Lcom_raquo_laminar_modifiers_EventListener(this$46, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => {
      onNext$3.a3();
    })));
    var this$48 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.aQE(), false, false));
    var onNext$4 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((thisNode$3) => (() => {
      thisNode$3.en.classList.remove("w-60");
    }))(thisNode$1));
    $m_Lcom_raquo_laminar_api_package$features$().cz();
    return $x_32.w($x_31.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_30, $x_29, $x_28, $x_27, $x_26, $x_25, new $c_Lcom_raquo_laminar_modifiers_EventListener(this$48, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2$1) => {
      onNext$4.a3();
    }))), new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.oE(), false, false)).nC(), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1$2) => {
      searchTerm.jA().bA(_$1$2);
    }))), $m_Lcom_raquo_laminar_api_package$().b.a6q.aLi(focusSearch.k5), new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.m1(), false, false)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$1) => {
      var term$1 = searchTerm.P().aq().d();
      var visibleCmds$2 = $p_Lorg_jpablo_graphexplorer_viewer_components_CommandsPanel$package$__getVisibleCommands$1__Lorg_jpablo_graphexplorer_viewer_components_Commands__T__sci_Set__sci_Map(this, commands, term$1, state.aH().cL()).e6().dk($m_s_$less$colon$less$().b1).iz();
      var cmdCount = visibleCmds$2.C();
      if ((cmdCount > 0)) {
        switch (e$1.key) {
          case "ArrowDown": {
            e$1.preventDefault();
            $m_Lcom_raquo_laminar_api_package$().b.ff.aTb($m_sr_ScalaRunTime$().hP(new ($d_Lcom_raquo_airstream_state_Var$VarModTuple.r().C)([new $c_Lcom_raquo_airstream_state_Var$VarModTuple(new $c_T2(scrollDown, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$9) => true)))), new $c_Lcom_raquo_airstream_state_Var$VarModTuple(new $c_T2(highlightedIndex, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((idx) => ((((1 + (idx | 0)) | 0) % $checkIntDivisor(cmdCount)) | 0)))))])));
            break;
          }
          case "ArrowUp": {
            e$1.preventDefault();
            $m_Lcom_raquo_laminar_api_package$().b.ff.aTb($m_sr_ScalaRunTime$().hP(new ($d_Lcom_raquo_airstream_state_Var$VarModTuple.r().C)([new $c_Lcom_raquo_airstream_state_Var$VarModTuple(new $c_T2(scrollDown, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$10) => false)))), new $c_Lcom_raquo_airstream_state_Var$VarModTuple(new $c_T2(highlightedIndex, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((idx$2) => (((((((((idx$2 | 0) - 1) | 0) % $checkIntDivisor(cmdCount)) | 0) + cmdCount) | 0) % $checkIntDivisor(cmdCount)) | 0)))))])));
            break;
          }
          case "Enter": {
            e$1.preventDefault();
            var idx$3$1 = (highlightedIndex.P().aq().d() | 0);
            if (((idx$3$1 >= 0) && (idx$3$1 < cmdCount))) {
              visibleCmds$2.l(idx$3$1).gZ($m_s_None$(), true);
              focusSearch.dn.bA(false);
              $f_Lcom_raquo_airstream_state_Var__set__O__V(highlightedIndex, (-1));
            }
            break;
          }
          case "Escape": {
            e$1.preventDefault();
            focusSearch.dn.bA(false);
            $f_Lcom_raquo_airstream_state_Var__set__O__V(highlightedIndex, (-1));
            break;
          }
        }
      }
    })))])));
  }))), $m_Lcom_raquo_laminar_api_package$().b.oD().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("kbd kbd-xs opacity-60 mr-[-5px]"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "\u2318", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $m_Lcom_raquo_laminar_api_package$().b.oD().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("kbd kbd-xs opacity-60"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "K", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))]))), $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("dropdown-content bg-base-100 rounded-box z-1 w-52 shadow-lg border-4 border-base-100"), $m_Lcom_raquo_laminar_api_package$().b.y.s("max-h-80 overflow-y-auto"), $m_Lcom_raquo_laminar_api_package$().b.Q6().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.wj().n(0), $m_Lcom_raquo_laminar_api_package$().b.y.s("menu menu-xs p-1"), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_inserters_ChildrenInserter$().IB(rows, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$(), $m_Lcom_raquo_laminar_modifiers_RenderableNode$().ht, (void 0)))])))])))])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_CommandsPanel$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_CommandsPanel$package$, "org.jpablo.graphexplorer.viewer.components.CommandsPanel$package$", ({
  yw: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_CommandsPanel$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_CommandsPanel$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_CommandsPanel$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_CommandsPanel$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_CommandsPanel$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_CommandsPanel$package$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_DocumentConflictBanner$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_DocumentConflictBanner$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_DocumentConflictBanner$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_DocumentConflictBanner$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_DocumentConflictBanner$package$.prototype = $p;
$p.aVP = (function(state) {
  return $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_inserters_ChildInserter$().nv($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), state.b04(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    if (($m_s_None$() === x$1)) {
      $m_Lcom_raquo_laminar_api_package$();
      return new $c_Lcom_raquo_laminar_nodes_CommentNode("");
    }
    if ((x$1 instanceof $c_s_Some)) {
      return $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("document-conflict-banner"), $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("document-conflict-title"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "This file changed on disk", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("document-conflict-note"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Your edit is still here. Choose which version to keep.", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$().iZ($m_Lorg_jpablo_graphexplorer_viewer_widgets_Button$package$().hH($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Load the file", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7), new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => {
        $f_Lorg_jpablo_graphexplorer_viewer_state_Persistence__resolveDocumentConflict__Z__V(state, true);
      })))])))), $m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$().iZ($m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$().AB($m_Lorg_jpablo_graphexplorer_viewer_widgets_Button$package$().hH($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Keep my edit", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7), new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => {
        $f_Lorg_jpablo_graphexplorer_viewer_state_Persistence__resolveDocumentConflict__Z__V(state, false);
      })))])))))])));
    }
    throw new $c_s_MatchError(x$1);
  })), $m_s_None$()), $m_Lcom_raquo_laminar_modifiers_RenderableNode$().ht, (void 0)))])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_DocumentConflictBanner$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_DocumentConflictBanner$package$, "org.jpablo.graphexplorer.viewer.components.DocumentConflictBanner$package$", ({
  yx: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_DocumentConflictBanner$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_DocumentConflictBanner$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_DocumentConflictBanner$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_DocumentConflictBanner$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_DocumentConflictBanner$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_DocumentConflictBanner$package$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_EditCellDialog$package$__saveAndClose$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lcom_raquo_airstream_state_Var__V($thiz, state$2, modalText$1) {
  var this$3 = state$2.vs.P().aq().d();
  if ((!this$3.c())) {
    var x0 = this$3.d();
    state$2.du().aS3(x0, modalText$1.P().aq().d());
  }
  $f_Lcom_raquo_airstream_state_Var__set__O__V(state$2.vs, $m_s_None$());
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_EditCellDialog$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_EditCellDialog$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_EditCellDialog$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_EditCellDialog$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_EditCellDialog$package$.prototype = $p;
$p.aVS = (function(state) {
  var dialogIsOpen = $f_Lcom_raquo_airstream_state_Var__zoomLazy__F1__F2__Lcom_raquo_airstream_state_Var(state.vs, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => (!_$1.c()))), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((cell, open) => ((!(!open)) ? cell : $m_s_None$()))));
  var modalText = $m_Lcom_raquo_laminar_api_package$().b.ff.bx("");
  var $x_7 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$();
  var $x_6 = $m_sr_ScalaRunTime$();
  var $x_5 = $m_Lcom_raquo_laminar_api_package$().b.ud().n("Enter cell text...");
  var $x_4 = $m_Lcom_raquo_laminar_api_package$().b.a4A().n(3);
  $m_Lcom_raquo_laminar_api_package$();
  var updater = $m_Lcom_raquo_laminar_api_package$().b.jx().bj(modalText);
  var listener = new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.oE(), false, false)).nC(), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1$1) => {
    modalText.jA().bA(_$1$1);
  })));
  var $x_3 = $m_Lcom_raquo_laminar_inputs_InputController$().qU(listener, updater);
  var $x_2 = $m_Lcom_raquo_laminar_api_package$().b.AR;
  var this$6 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.m1(), false, false)).pt(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((ev) => ((ev.key === "Enter") && (!(!(!ev.shiftKey))))))).jY();
  var onNext$1 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $p_Lorg_jpablo_graphexplorer_viewer_components_EditCellDialog$package$__saveAndClose$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lcom_raquo_airstream_state_Var__V(this, state, modalText);
  }));
  $m_Lcom_raquo_laminar_api_package$features$().cz();
  var $x_1 = new $c_Lcom_raquo_laminar_modifiers_EventListener(this$6, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => {
    onNext$1.a3();
  })));
  var this$8 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.m1(), false, false)).pt(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2$1) => (_$2$1.key === "Escape"))));
  var onNext$2 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lcom_raquo_airstream_state_Var__set__O__V(state.vs, $m_s_None$());
  }));
  $m_Lcom_raquo_laminar_api_package$features$().cz();
  var textAreaElement = $x_7.a2s($x_6.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_5, $x_4, $x_3, $x_2, $x_1, new $c_Lcom_raquo_laminar_modifiers_EventListener(this$8, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2$2) => {
    onNext$2.a3();
  })))])));
  var $x_25 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_24 = $m_sr_ScalaRunTime$();
  var $x_23 = $m_Lcom_raquo_laminar_api_package$().b.gz().n("edit-cell-dialog");
  $m_Lcom_raquo_laminar_api_package$();
  var $x_22 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Dialog$package$();
  var $x_21 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lcom_raquo_airstream_state_Var__set__O__V(state.vs, $m_s_None$());
  }));
  var $x_20 = $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([]));
  var $x_19 = $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.ya().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("font-bold text-md mb-2"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Edit Cell", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_receivers_ChildOptionReceiver$()).gR($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), state.vs.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3) => {
    var this$11 = state.du().b8r();
    var f = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((p) => $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("ml-2 font-mono text-xs opacity-60"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, (("<" + p) + ">"), $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))));
    return (this$11.c() ? $m_s_None$() : new $c_s_Some(f.i(this$11.d())));
  })), $m_s_None$()))]))), textAreaElement, $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("flex justify-between items-center mt-2"), $m_Lcom_raquo_laminar_api_package$().b.Ax().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("text-xs text-gray-500"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Press Shift+Enter to add a new line", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))])))]))), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_api_Implicits$RichSource$().Dz($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), state.vs.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4) => {
    var ifEmpty = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => ""));
    var f$1 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((cell$1) => state.du().aME(cell$1)));
    return (_$4.c() ? ifEmpty.a3() : f$1.i(_$4.d()));
  })), $m_s_None$()), modalText)), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_api_Implicits$RichSource$().ft(dialogIsOpen.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => {
    if ((!(!(!v1)))) {
      state.CE.dn.bA(true);
    }
  }))))]));
  var $x_18 = $m_sr_ScalaRunTime$();
  var $x_17 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_16 = $m_sr_ScalaRunTime$();
  var $x_15 = $m_Lcom_raquo_laminar_api_package$().b.y.s("flex justify-end gap-2 mt-2");
  var $x_14 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Actions$package$();
  var $x_13 = $m_sr_ScalaRunTime$();
  var $x_12 = $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Cancel", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7);
  var this$20 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false));
  var onNext$3 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lcom_raquo_airstream_state_Var__set__O__V(state.vs, $m_s_None$());
  }));
  $m_Lcom_raquo_laminar_api_package$features$().cz();
  var $x_11 = $x_14.Ix($x_13.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_12, new $c_Lcom_raquo_laminar_modifiers_EventListener(this$20, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2$3) => {
    onNext$3.a3();
  })))])));
  var $x_10 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Actions$package$();
  var $x_9 = $m_sr_ScalaRunTime$();
  var $x_8 = $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Ok", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7);
  var this$23 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false));
  var onNext$4 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $p_Lorg_jpablo_graphexplorer_viewer_components_EditCellDialog$package$__saveAndClose$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lcom_raquo_airstream_state_Var__V(this, state, modalText);
  }));
  $m_Lcom_raquo_laminar_api_package$features$().cz();
  return $x_25.w($x_24.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_23, new $c_Lcom_raquo_laminar_receivers_LockedChildReceiver($x_22.Iw($x_21, $x_20, $x_19, $x_18.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_17.w($x_16.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_15, $x_11, $x_10.OO($x_9.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_8, new $c_Lcom_raquo_laminar_modifiers_EventListener(this$23, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2$4) => {
    onNext$4.a3();
  })))])))])))])))).gR(dialogIsOpen)])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_EditCellDialog$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_EditCellDialog$package$, "org.jpablo.graphexplorer.viewer.components.EditCellDialog$package$", ({
  yy: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_EditCellDialog$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_EditCellDialog$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_EditCellDialog$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_EditCellDialog$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_EditCellDialog$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_EditCellDialog$package$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_EditLabelDialog$package$__elementLabelVar$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_viewer_models_ElementId__Lcom_raquo_airstream_state_Var($thiz, state$1, elementId) {
  var attrUpdates = state$1.a3b($m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_ElementId.r().C)([elementId]))));
  return $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$().aSX($m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_RowBuilder$().aSe($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Label$()), attrUpdates, $m_s_None$()), "");
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_EditLabelDialog$package$__saveAndClose$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lcom_raquo_airstream_state_Var__V($thiz, state$3, modalText$1) {
  var this$3 = state$3.zB.P().aq().d();
  if ((!this$3.c())) {
    $f_Lcom_raquo_airstream_state_Var__set__O__V($p_Lorg_jpablo_graphexplorer_viewer_components_EditLabelDialog$package$__elementLabelVar$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_viewer_models_ElementId__Lcom_raquo_airstream_state_Var($thiz, state$3, this$3.d()), modalText$1.P().aq().d());
  }
  $f_Lcom_raquo_airstream_state_Var__set__O__V(state$3.zB, $m_s_None$());
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_EditLabelDialog$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_EditLabelDialog$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_EditLabelDialog$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_EditLabelDialog$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_EditLabelDialog$package$.prototype = $p;
$p.aVT = (function(state) {
  var dialogIsOpen = $f_Lcom_raquo_airstream_state_Var__zoomLazy__F1__F2__Lcom_raquo_airstream_state_Var(state.zB, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => (!_$1.c()))), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((elem, open) => ((!(!open)) ? elem : $m_s_None$()))));
  var modalText = $m_Lcom_raquo_laminar_api_package$().b.ff.bx("");
  var $x_7 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$();
  var $x_6 = $m_sr_ScalaRunTime$();
  var $x_5 = $m_Lcom_raquo_laminar_api_package$().b.ud().n("Enter label text...");
  var $x_4 = $m_Lcom_raquo_laminar_api_package$().b.a4A().n(3);
  $m_Lcom_raquo_laminar_api_package$();
  var updater = $m_Lcom_raquo_laminar_api_package$().b.jx().bj(modalText);
  var listener = new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.oE(), false, false)).nC(), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1$1) => {
    modalText.jA().bA(_$1$1);
  })));
  var $x_3 = $m_Lcom_raquo_laminar_inputs_InputController$().qU(listener, updater);
  var $x_2 = $m_Lcom_raquo_laminar_api_package$().b.AR;
  var this$6 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.m1(), false, false)).pt(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((ev) => ((ev.key === "Enter") && (!(!(!ev.shiftKey))))))).jY();
  var onNext$1 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $p_Lorg_jpablo_graphexplorer_viewer_components_EditLabelDialog$package$__saveAndClose$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lcom_raquo_airstream_state_Var__V(this, state, modalText);
  }));
  $m_Lcom_raquo_laminar_api_package$features$().cz();
  var $x_1 = new $c_Lcom_raquo_laminar_modifiers_EventListener(this$6, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => {
    onNext$1.a3();
  })));
  var this$8 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.m1(), false, false)).pt(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3) => (_$3.key === "Escape"))));
  var onNext$2 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lcom_raquo_airstream_state_Var__set__O__V(state.zB, $m_s_None$());
  }));
  $m_Lcom_raquo_laminar_api_package$features$().cz();
  var textAreaElement = $x_7.a2s($x_6.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_5, $x_4, $x_3, $x_2, $x_1, new $c_Lcom_raquo_laminar_modifiers_EventListener(this$8, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2$1) => {
    onNext$2.a3();
  })))])));
  var $x_25 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_24 = $m_sr_ScalaRunTime$();
  var $x_23 = $m_Lcom_raquo_laminar_api_package$().b.gz().n("edit-label-dialog");
  $m_Lcom_raquo_laminar_api_package$();
  var $x_22 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Dialog$package$();
  var $x_21 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lcom_raquo_airstream_state_Var__set__O__V(state.zB, $m_s_None$());
  }));
  var $x_20 = $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([]));
  var $x_19 = $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.ya().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("font-bold text-md mb-2"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Edit Label", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), textAreaElement, $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("flex justify-between items-center mt-2"), $m_Lcom_raquo_laminar_api_package$().b.Ax().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("text-xs text-gray-500"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Press Shift+Enter to add a new line", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))])))]))), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_api_Implicits$RichSource$().Dz($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), state.zB.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4) => {
    var ifEmpty = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => ""));
    var f = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$5) => $p_Lorg_jpablo_graphexplorer_viewer_components_EditLabelDialog$package$__elementLabelVar$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_viewer_models_ElementId__Lcom_raquo_airstream_state_Var(this, state, _$5).P().aq().d()));
    return (_$4.c() ? ifEmpty.a3() : f.i(_$4.d()));
  })), $m_s_None$()), modalText)), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_api_Implicits$RichSource$().ft(dialogIsOpen.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => {
    if ((!(!(!v1)))) {
      state.CE.dn.bA(true);
    }
  }))))]));
  var $x_18 = $m_sr_ScalaRunTime$();
  var $x_17 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_16 = $m_sr_ScalaRunTime$();
  var $x_15 = $m_Lcom_raquo_laminar_api_package$().b.y.s("flex justify-end gap-2 mt-2");
  var $x_14 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Actions$package$();
  var $x_13 = $m_sr_ScalaRunTime$();
  var $x_12 = $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Cancel", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7);
  var this$19 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false));
  var onNext$3 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lcom_raquo_airstream_state_Var__set__O__V(state.zB, $m_s_None$());
  }));
  $m_Lcom_raquo_laminar_api_package$features$().cz();
  var $x_11 = $x_14.Ix($x_13.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_12, new $c_Lcom_raquo_laminar_modifiers_EventListener(this$19, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2$2) => {
    onNext$3.a3();
  })))])));
  var $x_10 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Actions$package$();
  var $x_9 = $m_sr_ScalaRunTime$();
  var $x_8 = $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Ok", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7);
  var this$22 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false));
  var onNext$4 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $p_Lorg_jpablo_graphexplorer_viewer_components_EditLabelDialog$package$__saveAndClose$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lcom_raquo_airstream_state_Var__V(this, state, modalText);
  }));
  $m_Lcom_raquo_laminar_api_package$features$().cz();
  return $x_25.w($x_24.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_23, new $c_Lcom_raquo_laminar_receivers_LockedChildReceiver($x_22.Iw($x_21, $x_20, $x_19, $x_18.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_17.w($x_16.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_15, $x_11, $x_10.OO($x_9.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_8, new $c_Lcom_raquo_laminar_modifiers_EventListener(this$22, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2$3) => {
    onNext$4.a3();
  })))])))])))])))).gR(dialogIsOpen)])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_EditLabelDialog$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_EditLabelDialog$package$, "org.jpablo.graphexplorer.viewer.components.EditLabelDialog$package$", ({
  yz: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_EditLabelDialog$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_EditLabelDialog$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_EditLabelDialog$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_EditLabelDialog$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_EditLabelDialog$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_EditLabelDialog$package$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_ErrorAlert$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_ErrorAlert$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_ErrorAlert$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_ErrorAlert$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_ErrorAlert$package$.prototype = $p;
$p.aVW = (function(errors) {
  var latestError = $m_Lcom_raquo_laminar_api_package$().b.ff.bx($m_s_None$());
  var $x_4 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Alert$package$();
  var $x_3 = $m_sr_ScalaRunTime$();
  $m_Lcom_raquo_laminar_api_package$();
  var $x_2 = $m_Lcom_raquo_laminar_api_Implicits$RichSource$().Dz(errors.k5, $f_Lcom_raquo_airstream_core_Observer__contramap__F1__Lcom_raquo_airstream_core_Observer(latestError.jA(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => new $c_s_Some(_$1)))));
  $m_Lcom_raquo_laminar_api_package$();
  var $x_1 = $m_Lcom_raquo_laminar_api_Implicits$RichSource$();
  var this$7 = new $c_Lcom_raquo_airstream_misc_FilterStream(new $c_Lcom_raquo_airstream_misc_StreamFromSignal(latestError.P(), true), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => (!_$2.c()))));
  var project = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3) => new $c_Lcom_raquo_airstream_timing_DelayStream(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_airstream_core_EventStream$()).a3x($m_s_None$(), false), 5000)));
  return $x_4.aLF($x_3.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_2, $x_1.Dz($m_Lcom_raquo_airstream_core_Observable$().AM.mK(new $c_Lcom_raquo_airstream_misc_MapStream(this$7, project, $m_s_None$())), latestError), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_receivers_ChildOptionReceiver$()).gR($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), latestError.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4) => {
    if (_$4.c()) {
      return $m_s_None$();
    } else {
      var x0 = _$4.d();
      return new $c_s_Some($m_Lorg_jpablo_graphexplorer_viewer_widgets_Alert$package$().aep($s_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$__Error__Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone(), $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("shadow-lg"), $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, x0, $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))]))));
    }
  })), $m_s_None$()))])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_ErrorAlert$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_ErrorAlert$package$, "org.jpablo.graphexplorer.viewer.components.ErrorAlert$package$", ({
  yA: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_ErrorAlert$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_ErrorAlert$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_ErrorAlert$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_ErrorAlert$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_ErrorAlert$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_ErrorAlert$package$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_HelpDialog$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_HelpDialog$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_HelpDialog$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_HelpDialog$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_HelpDialog$package$.prototype = $p;
$p.aVX = (function(open, commands) {
  return $m_Lorg_jpablo_graphexplorer_viewer_widgets_Dialog$package$().aeu(open, $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("p-4 space-y-6"), $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.ya().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("text-lg font-bold mb-4"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Keyboard Shortcuts", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $m_Lcom_raquo_laminar_api_package$().b.aid().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("table table-xs min-w-full border-collapse"), $m_Lcom_raquo_laminar_api_package$().b.aSN().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.uk().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.a4X().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Key", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $m_Lcom_raquo_laminar_api_package$().b.a4X().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Action", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))])))]))), $m_Lcom_raquo_laminar_api_package$().b.aie().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__nodeSeqToModifier__O__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O($m_sci_Seq$().fw(commands.a8Q), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => $f_sc_IterableOnceOps__mkString__T__T__T__T(_$1.g().bM(), "", "", ""))), $m_s_math_Ordering$String$()).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    if ((x$1 !== null)) {
      var shortcut = x$1.g();
      var command = x$1.h();
      var $x_11 = $m_Lcom_raquo_laminar_api_package$().b.uk();
      var $x_10 = $m_sr_ScalaRunTime$();
      var $x_9 = $m_Lcom_raquo_laminar_api_package$().b.kW();
      var $x_8 = $m_sr_ScalaRunTime$();
      var $x_7 = $m_Lcom_raquo_laminar_api_package$().b.y.s("whitespace-nowrap");
      var $x_6 = $m_Lcom_raquo_laminar_api_package$().b;
      var $x_5 = $m_Lorg_jpablo_graphexplorer_viewer_utils_Utils$package$();
      var this$7 = shortcut.bM();
      var f = ((_$2) => $m_Lcom_raquo_laminar_api_package$().b.oD().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("kbd kbd-sm"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, _$2, $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))));
      if ((this$7 === $m_sci_Nil$())) {
        var $x_4 = $m_sci_Nil$();
      } else {
        var x0 = this$7.t();
        var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
        var t = h;
        var rest = this$7.v();
        while ((rest !== $m_sci_Nil$())) {
          var x0$1 = rest.t();
          var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
          t.U = nx;
          t = nx;
          rest = rest.v();
        }
        var $x_4 = h;
      }
      var $x_3 = $x_9.w($x_8.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_7, $f_Lcom_raquo_laminar_api_Implicits__nodeSeqToModifier__O__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($x_6, $x_5.a3P($x_4, $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, " + ", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))), $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())])));
      var $x_2 = $m_Lcom_raquo_laminar_api_package$().b.kW();
      var $x_1 = $m_sr_ScalaRunTime$();
      var this$11 = $m_Lcom_raquo_laminar_api_package$().b;
      var this$10 = command.vg;
      return $x_11.w($x_10.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_3, $x_2.w($x_1.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode(this$11, (this$10.c() ? command.lE : this$10.d()), $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))])));
    }
    throw new $c_s_MatchError(x$1);
  }))), $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())])))])))]))), $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.ya().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("text-lg font-bold mb-4"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Mouse Controls", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $m_Lcom_raquo_laminar_api_package$().b.aid().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("table table-xs min-w-full border-collapse"), $m_Lcom_raquo_laminar_api_package$().b.aSN().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.uk().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.a4X().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Action", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $m_Lcom_raquo_laminar_api_package$().b.a4X().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Description", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))])))]))), $m_Lcom_raquo_laminar_api_package$().b.aie().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.uk().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.kW().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.oD().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("kbd kbd-sm"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Click", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, " + ", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $m_Lcom_raquo_laminar_api_package$().b.oD().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("kbd kbd-sm"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Drag", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, " between nodes", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))]))), $m_Lcom_raquo_laminar_api_package$().b.kW().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Create a new edge between nodes", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))]))), $m_Lcom_raquo_laminar_api_package$().b.uk().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.kW().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.oD().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("kbd kbd-sm"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "\u2318", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, " + ", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $m_Lcom_raquo_laminar_api_package$().b.oD().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("kbd kbd-sm"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Mouse wheel", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))]))), $m_Lcom_raquo_laminar_api_package$().b.kW().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Zoom in/out", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))]))), $m_Lcom_raquo_laminar_api_package$().b.uk().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.kW().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.oD().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("kbd kbd-sm"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Mouse wheel", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))]))), $m_Lcom_raquo_laminar_api_package$().b.kW().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Pan vertically", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))]))), $m_Lcom_raquo_laminar_api_package$().b.uk().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.kW().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.oD().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("kbd kbd-sm"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Shift", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, " + ", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $m_Lcom_raquo_laminar_api_package$().b.oD().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("kbd kbd-sm"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Mouse wheel", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))]))), $m_Lcom_raquo_laminar_api_package$().b.kW().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Pan horizontally", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))]))), $m_Lcom_raquo_laminar_api_package$().b.uk().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.kW().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.oD().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("kbd kbd-sm"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Click", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))]))), $m_Lcom_raquo_laminar_api_package$().b.kW().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Select element", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))]))), $m_Lcom_raquo_laminar_api_package$().b.uk().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.kW().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.oD().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("kbd kbd-sm"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Shift", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, " + ", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $m_Lcom_raquo_laminar_api_package$().b.oD().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("kbd kbd-sm"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Click", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))]))), $m_Lcom_raquo_laminar_api_package$().b.kW().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("p-2"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Toggle element selection", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))])))])))])))])))])))])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_HelpDialog$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_HelpDialog$package$, "org.jpablo.graphexplorer.viewer.components.HelpDialog$package$", ({
  yB: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_HelpDialog$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_HelpDialog$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_HelpDialog$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_HelpDialog$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_HelpDialog$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_HelpDialog$package$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_InfoAlert$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_InfoAlert$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_InfoAlert$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_InfoAlert$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_InfoAlert$package$.prototype = $p;
$p.aW0 = (function(infos) {
  var latest = $m_Lcom_raquo_laminar_api_package$().b.ff.bx($m_s_None$());
  var $x_4 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Alert$package$();
  var $x_3 = $m_sr_ScalaRunTime$();
  $m_Lcom_raquo_laminar_api_package$();
  var $x_2 = $m_Lcom_raquo_laminar_api_Implicits$RichSource$().Dz(infos.k5, $f_Lcom_raquo_airstream_core_Observer__contramap__F1__Lcom_raquo_airstream_core_Observer(latest.jA(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => new $c_s_Some(_$1)))));
  $m_Lcom_raquo_laminar_api_package$();
  var $x_1 = $m_Lcom_raquo_laminar_api_Implicits$RichSource$();
  var this$7 = new $c_Lcom_raquo_airstream_misc_FilterStream(new $c_Lcom_raquo_airstream_misc_StreamFromSignal(latest.P(), true), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => (!_$2.c()))));
  var project = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3) => new $c_Lcom_raquo_airstream_timing_DelayStream(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_airstream_core_EventStream$()).a3x($m_s_None$(), false), 2500)));
  return $x_4.aLF($x_3.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_2, $x_1.Dz($m_Lcom_raquo_airstream_core_Observable$().AM.mK(new $c_Lcom_raquo_airstream_misc_MapStream(this$7, project, $m_s_None$())), latest), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_receivers_ChildOptionReceiver$()).gR($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), latest.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4) => {
    if (_$4.c()) {
      return $m_s_None$();
    } else {
      var x0 = _$4.d();
      return new $c_s_Some($m_Lorg_jpablo_graphexplorer_viewer_widgets_Alert$package$().aep($s_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$__Success__Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone(), $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("shadow-lg"), $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, x0, $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))]))));
    }
  })), $m_s_None$()))])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_InfoAlert$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_InfoAlert$package$, "org.jpablo.graphexplorer.viewer.components.InfoAlert$package$", ({
  yC: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_InfoAlert$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_InfoAlert$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_InfoAlert$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_InfoAlert$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_InfoAlert$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_InfoAlert$package$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_NewGroupLabelDialog$package$__saveAndCreate$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lcom_raquo_airstream_state_Var__V($thiz, state$2, modalText$1) {
  var this$3 = state$2.zF.P().aq().d();
  if ((!this$3.c())) {
    var x0 = this$3.d();
    var text = modalText$1.P().aq().d();
    var label = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_TextUtils$().a3j(text);
    state$2.aZr(x0.U3, label);
  }
  $f_Lcom_raquo_airstream_state_Var__set__O__V(state$2.zF, $m_s_None$());
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_NewGroupLabelDialog$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_NewGroupLabelDialog$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_NewGroupLabelDialog$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_NewGroupLabelDialog$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_NewGroupLabelDialog$package$.prototype = $p;
$p.aW6 = (function(state) {
  var dialogIsOpen = $f_Lcom_raquo_airstream_state_Var__zoomLazy__F1__F2__Lcom_raquo_airstream_state_Var(state.zF, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => (!_$1.c()))), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((pending, open) => ((!(!open)) ? pending : $m_s_None$()))));
  var modalText = $m_Lcom_raquo_laminar_api_package$().b.ff.bx("");
  var $x_7 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$();
  var $x_6 = $m_sr_ScalaRunTime$();
  var $x_5 = $m_Lcom_raquo_laminar_api_package$().b.ud().n("Enter group label...");
  var $x_4 = $m_Lcom_raquo_laminar_api_package$().b.a4A().n(3);
  $m_Lcom_raquo_laminar_api_package$();
  var updater = $m_Lcom_raquo_laminar_api_package$().b.jx().bj(modalText);
  var listener = new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.oE(), false, false)).nC(), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1$1) => {
    modalText.jA().bA(_$1$1);
  })));
  var $x_3 = $m_Lcom_raquo_laminar_inputs_InputController$().qU(listener, updater);
  var $x_2 = $m_Lcom_raquo_laminar_api_package$().b.AR;
  var this$6 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.m1(), false, false)).pt(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((ev) => ((ev.key === "Enter") && (!(!(!ev.shiftKey))))))).jY();
  var onNext$1 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $p_Lorg_jpablo_graphexplorer_viewer_components_NewGroupLabelDialog$package$__saveAndCreate$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lcom_raquo_airstream_state_Var__V(this, state, modalText);
  }));
  $m_Lcom_raquo_laminar_api_package$features$().cz();
  var $x_1 = new $c_Lcom_raquo_laminar_modifiers_EventListener(this$6, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => {
    onNext$1.a3();
  })));
  var this$8 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.m1(), false, false)).pt(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2$1) => (_$2$1.key === "Escape"))));
  var onNext$2 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lcom_raquo_airstream_state_Var__set__O__V(state.zF, $m_s_None$());
  }));
  $m_Lcom_raquo_laminar_api_package$features$().cz();
  var textAreaElement = $x_7.a2s($x_6.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_5, $x_4, $x_3, $x_2, $x_1, new $c_Lcom_raquo_laminar_modifiers_EventListener(this$8, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2$2) => {
    onNext$2.a3();
  })))])));
  var $x_25 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_24 = $m_sr_ScalaRunTime$();
  var $x_23 = $m_Lcom_raquo_laminar_api_package$().b.gz().n("new-group-label-dialog");
  $m_Lcom_raquo_laminar_api_package$();
  var $x_22 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Dialog$package$();
  var $x_21 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lcom_raquo_airstream_state_Var__set__O__V(state.zF, $m_s_None$());
  }));
  var $x_20 = $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([]));
  var $x_19 = $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.ya().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("font-bold text-md mb-2"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "New Group Label", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), textAreaElement, $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("flex justify-between items-center mt-2"), $m_Lcom_raquo_laminar_api_package$().b.Ax().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("text-xs text-gray-500"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Press Shift+Enter to add a new line", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))])))]))), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_api_Implicits$RichSource$().Dz($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), state.zF.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3) => "")), $m_s_None$()), modalText)), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_api_Implicits$RichSource$().ft(dialogIsOpen.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => {
    if ((!(!(!v1)))) {
      state.CE.dn.bA(true);
    }
  }))))]));
  var $x_18 = $m_sr_ScalaRunTime$();
  var $x_17 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_16 = $m_sr_ScalaRunTime$();
  var $x_15 = $m_Lcom_raquo_laminar_api_package$().b.y.s("flex justify-end gap-2 mt-2");
  var $x_14 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Actions$package$();
  var $x_13 = $m_sr_ScalaRunTime$();
  var $x_12 = $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Cancel", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7);
  var this$17 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false));
  var onNext$3 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lcom_raquo_airstream_state_Var__set__O__V(state.zF, $m_s_None$());
  }));
  $m_Lcom_raquo_laminar_api_package$features$().cz();
  var $x_11 = $x_14.Ix($x_13.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_12, new $c_Lcom_raquo_laminar_modifiers_EventListener(this$17, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2$3) => {
    onNext$3.a3();
  })))])));
  var $x_10 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Actions$package$();
  var $x_9 = $m_sr_ScalaRunTime$();
  var $x_8 = $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Ok", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7);
  var this$20 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false));
  var onNext$4 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $p_Lorg_jpablo_graphexplorer_viewer_components_NewGroupLabelDialog$package$__saveAndCreate$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lcom_raquo_airstream_state_Var__V(this, state, modalText);
  }));
  $m_Lcom_raquo_laminar_api_package$features$().cz();
  return $x_25.w($x_24.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_23, new $c_Lcom_raquo_laminar_receivers_LockedChildReceiver($x_22.Iw($x_21, $x_20, $x_19, $x_18.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_17.w($x_16.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_15, $x_11, $x_10.OO($x_9.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_8, new $c_Lcom_raquo_laminar_modifiers_EventListener(this$20, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2$4) => {
    onNext$4.a3();
  })))])))])))])))).gR(dialogIsOpen)])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_NewGroupLabelDialog$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_NewGroupLabelDialog$package$, "org.jpablo.graphexplorer.viewer.components.NewGroupLabelDialog$package$", ({
  yD: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_NewGroupLabelDialog$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_NewGroupLabelDialog$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_NewGroupLabelDialog$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_NewGroupLabelDialog$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_NewGroupLabelDialog$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_NewGroupLabelDialog$package$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_NewNodeLabelDialog$package$__saveAndCreate$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lcom_raquo_airstream_state_Var__V($thiz, state$2, modalText$1) {
  var this$3 = state$2.zG.P().aq().d();
  if ((!this$3.c())) {
    var x0 = this$3.d();
    var text = modalText$1.P().aq().d();
    var attrs = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().a2r(x0.U4, $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().Au($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_AttributePair.r().C)([new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributePair$$anon$3(new $c_T2($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Label$(), $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_TextUtils$().a3j(text)))]))));
    var dir = x0.U5;
    state$2.aLR(attrs, dir);
  }
  $f_Lcom_raquo_airstream_state_Var__set__O__V(state$2.zG, $m_s_None$());
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_NewNodeLabelDialog$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_NewNodeLabelDialog$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_NewNodeLabelDialog$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_NewNodeLabelDialog$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_NewNodeLabelDialog$package$.prototype = $p;
$p.aW7 = (function(state) {
  var dialogIsOpen = $f_Lcom_raquo_airstream_state_Var__zoomLazy__F1__F2__Lcom_raquo_airstream_state_Var(state.zG, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => (!_$1.c()))), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((pending, open) => ((!(!open)) ? pending : $m_s_None$()))));
  var modalText = $m_Lcom_raquo_laminar_api_package$().b.ff.bx("");
  var $x_7 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$();
  var $x_6 = $m_sr_ScalaRunTime$();
  var $x_5 = $m_Lcom_raquo_laminar_api_package$().b.ud().n("Enter label text...");
  var $x_4 = $m_Lcom_raquo_laminar_api_package$().b.a4A().n(3);
  $m_Lcom_raquo_laminar_api_package$();
  var updater = $m_Lcom_raquo_laminar_api_package$().b.jx().bj(modalText);
  var listener = new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.oE(), false, false)).nC(), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1$1) => {
    modalText.jA().bA(_$1$1);
  })));
  var $x_3 = $m_Lcom_raquo_laminar_inputs_InputController$().qU(listener, updater);
  var $x_2 = $m_Lcom_raquo_laminar_api_package$().b.AR;
  var this$6 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.m1(), false, false)).pt(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((ev) => ((ev.key === "Enter") && (!(!(!ev.shiftKey))))))).jY();
  var onNext$1 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $p_Lorg_jpablo_graphexplorer_viewer_components_NewNodeLabelDialog$package$__saveAndCreate$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lcom_raquo_airstream_state_Var__V(this, state, modalText);
  }));
  $m_Lcom_raquo_laminar_api_package$features$().cz();
  var $x_1 = new $c_Lcom_raquo_laminar_modifiers_EventListener(this$6, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => {
    onNext$1.a3();
  })));
  var this$8 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.m1(), false, false)).pt(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2$1) => (_$2$1.key === "Escape"))));
  var onNext$2 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lcom_raquo_airstream_state_Var__set__O__V(state.zG, $m_s_None$());
  }));
  $m_Lcom_raquo_laminar_api_package$features$().cz();
  var textAreaElement = $x_7.a2s($x_6.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_5, $x_4, $x_3, $x_2, $x_1, new $c_Lcom_raquo_laminar_modifiers_EventListener(this$8, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2$2) => {
    onNext$2.a3();
  })))])));
  var $x_25 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_24 = $m_sr_ScalaRunTime$();
  var $x_23 = $m_Lcom_raquo_laminar_api_package$().b.gz().n("new-node-label-dialog");
  $m_Lcom_raquo_laminar_api_package$();
  var $x_22 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Dialog$package$();
  var $x_21 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lcom_raquo_airstream_state_Var__set__O__V(state.zG, $m_s_None$());
  }));
  var $x_20 = $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([]));
  var $x_19 = $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.ya().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("font-bold text-md mb-2"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Edit Label", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), textAreaElement, $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("flex justify-between items-center mt-2"), $m_Lcom_raquo_laminar_api_package$().b.Ax().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("text-xs text-gray-500"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Press Shift+Enter to add a new line", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))])))]))), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_api_Implicits$RichSource$().Dz($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), state.zG.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3) => "")), $m_s_None$()), modalText)), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_api_Implicits$RichSource$().ft(dialogIsOpen.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => {
    if ((!(!(!v1)))) {
      state.CE.dn.bA(true);
    }
  }))))]));
  var $x_18 = $m_sr_ScalaRunTime$();
  var $x_17 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_16 = $m_sr_ScalaRunTime$();
  var $x_15 = $m_Lcom_raquo_laminar_api_package$().b.y.s("flex justify-end gap-2 mt-2");
  var $x_14 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Actions$package$();
  var $x_13 = $m_sr_ScalaRunTime$();
  var $x_12 = $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Cancel", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7);
  var this$17 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false));
  var onNext$3 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lcom_raquo_airstream_state_Var__set__O__V(state.zG, $m_s_None$());
  }));
  $m_Lcom_raquo_laminar_api_package$features$().cz();
  var $x_11 = $x_14.Ix($x_13.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_12, new $c_Lcom_raquo_laminar_modifiers_EventListener(this$17, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2$3) => {
    onNext$3.a3();
  })))])));
  var $x_10 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Actions$package$();
  var $x_9 = $m_sr_ScalaRunTime$();
  var $x_8 = $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Ok", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7);
  var this$20 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false));
  var onNext$4 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $p_Lorg_jpablo_graphexplorer_viewer_components_NewNodeLabelDialog$package$__saveAndCreate$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lcom_raquo_airstream_state_Var__V(this, state, modalText);
  }));
  $m_Lcom_raquo_laminar_api_package$features$().cz();
  return $x_25.w($x_24.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_23, new $c_Lcom_raquo_laminar_receivers_LockedChildReceiver($x_22.Iw($x_21, $x_20, $x_19, $x_18.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_17.w($x_16.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_15, $x_11, $x_10.OO($x_9.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_8, new $c_Lcom_raquo_laminar_modifiers_EventListener(this$20, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2$4) => {
    onNext$4.a3();
  })))])))])))])))).gR(dialogIsOpen)])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_NewNodeLabelDialog$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_NewNodeLabelDialog$package$, "org.jpablo.graphexplorer.viewer.components.NewNodeLabelDialog$package$", ({
  yE: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_NewNodeLabelDialog$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_NewNodeLabelDialog$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_NewNodeLabelDialog$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_NewNodeLabelDialog$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_NewNodeLabelDialog$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_NewNodeLabelDialog$package$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_OriginStateBanner$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_OriginStateBanner$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_OriginStateBanner$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_OriginStateBanner$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_OriginStateBanner$package$.prototype = $p;
$p.aW8 = (function(target) {
  var record = ((target instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$LibraryDiagram) ? new $c_s_Some(target.xp) : $m_s_None$());
  if (record.c()) {
    var this$3 = $m_s_None$();
  } else {
    var x0 = record.d();
    var this$3 = new $c_s_Some($m_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$().baG(x0));
  }
  var unresolved = (this$3.c() ? ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_airstream_state_Val$().iT($m_s_None$())) : this$3.d());
  return $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_inserters_ChildInserter$().nv($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), unresolved, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    if ((x$1 instanceof $c_s_Some)) {
      var x17 = x$1.J;
      if ((x17 !== null)) {
        var x19 = x17.Tm;
        var x20 = x17.Gz;
        var x = $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__Diverged__Lorg_jpablo_graphexplorer_gxcore_model_SyncState();
        if (((x === null) ? (x19 === null) : (x === x19))) {
          if ((x20 instanceof $c_s_Some)) {
            return $m_Lorg_jpablo_graphexplorer_viewer_components_OriginStateBanner$package$().ai9("This diagram and its file both changed", "Nothing is written and nothing is lost. Choose which version to keep.", $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$().iZ($m_Lorg_jpablo_graphexplorer_viewer_widgets_Button$package$().hH($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Take the file's version", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7), new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => {
              if ((!record.c())) {
                var x0$1 = record.d();
                $m_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$().b9O(x0$1);
              }
            })))])))), $m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$().iZ($m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$().AB($m_Lorg_jpablo_graphexplorer_viewer_widgets_Button$package$().hH($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Keep this diagram", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7), new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => {
              if ((!record.c())) {
                var x0$2 = record.d();
                $m_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$().b3U(x0$2);
              }
            })))])))))])));
          }
          if (($m_s_None$() === x20)) {
            return $m_Lorg_jpablo_graphexplorer_viewer_components_OriginStateBanner$package$().ai9("This diagram and its file both changed", "Nothing is written and nothing is lost. The diagram keeps showing your version.", $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([])));
          }
        }
        var x$5 = $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__OriginMissing__Lorg_jpablo_graphexplorer_gxcore_model_SyncState();
        if (((x$5 === null) ? (x19 === null) : (x$5 === x19))) {
          return $m_Lorg_jpablo_graphexplorer_viewer_components_OriginStateBanner$package$().ai9("This diagram's file is gone", "It was deleted or moved. The library's copy is now the only one.", $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([])));
        }
      }
    }
    $m_Lcom_raquo_laminar_api_package$();
    return new $c_Lcom_raquo_laminar_nodes_CommentNode("");
  })), $m_s_None$()), $m_Lcom_raquo_laminar_modifiers_RenderableNode$().ht, (void 0)))])));
});
$p.ai9 = (function(title, detail, actions) {
  return $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("origin-state-banner"), $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("origin-state-title"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, title, $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("origin-state-detail"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, detail, $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, actions, $m_s_$less$colon$less$().b1, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_OriginStateBanner$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_OriginStateBanner$package$, "org.jpablo.graphexplorer.viewer.components.OriginStateBanner$package$", ({
  yF: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_OriginStateBanner$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_OriginStateBanner$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_OriginStateBanner$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_OriginStateBanner$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_OriginStateBanner$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_OriginStateBanner$package$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_PanelSectionToggles$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_PanelSectionToggles$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_PanelSectionToggles$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_PanelSectionToggles$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_PanelSectionToggles$package$.prototype = $p;
$p.aW9 = (function(state) {
  var $x_15 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_14 = $m_sr_ScalaRunTime$();
  var $x_13 = $m_Lcom_raquo_laminar_api_package$().b.gz().n("panel-toggles");
  var $x_12 = $m_Lcom_raquo_laminar_api_package$().b.y.s("flex items-center gap-0.5 shrink-0 print:hidden");
  var this$16 = $m_Lcom_raquo_laminar_api_package$().b;
  var this$15 = new $c_sci_$colon$colon(new $c_T2($s_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$__diagramAttributes__Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection(), new $c_T3("bi-sliders", "Diagram", "tooltip-bottom")), new $c_sci_$colon$colon(new $c_T2($s_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$__elements__Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection(), new $c_T3("bi-list-ul", "Elements", "tooltip-bottom")), new $c_sci_$colon$colon(new $c_T2($s_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$__sources__Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection(), new $c_T3("bi-code-square", "Source", "tooltip-bottom tooltip-end")), $m_sci_Nil$())));
  var f = ((x$1) => {
    if ((x$1 !== null)) {
      var x3 = x$1.h();
      var section = x$1.g();
      if ((x3 !== null)) {
        var icon = x3.bH;
        var text = x3.bU;
        var tipPos = x3.c3;
        var $x_10 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Tooltip$package$();
        var $x_9 = $m_sr_ScalaRunTime$();
        var $x_8 = $m_Lcom_raquo_laminar_api_package$().b.y.s(tipPos);
        var $x_7 = $m_Lcom_raquo_laminar_api_package$().b.IF();
        var $x_6 = $m_sr_ScalaRunTime$();
        var $x_5 = $m_Lcom_raquo_laminar_api_package$().b.y.s("gx-icon-btn");
        var $x_4 = $m_Lcom_raquo_laminar_api_package$().b.wl().n("button");
        var $x_3 = $m_Lcom_raquo_laminar_api_package$().b.Af().Aq().n((text + " panel"));
        var $x_2 = $m_Lcom_raquo_laminar_api_package$().b.y.s("active").bj($f_Lorg_jpablo_graphexplorer_viewer_state_UIState__isSectionActive__Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection__Lcom_raquo_airstream_core_Signal(state, section));
        var $x_1 = $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s(icon), $m_Lcom_raquo_laminar_api_package$().b.y.s("text-error").bj($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), state.CF.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => {
          if (((!_$1.c()) && _$1.d().J6())) {
            var x$2 = $s_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$__sources__Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection();
            return ((section === null) ? (x$2 === null) : (section === x$2));
          } else {
            return false;
          }
        })), $m_s_None$()))])));
        var this$14 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false));
        var onNext = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
          $f_Lcom_raquo_airstream_state_Var__update__F1__V(state.qs, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((curr) => (((curr === null) ? (section === null) : (curr === section)) ? $s_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$__none__Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection() : section))));
        }));
        $m_Lcom_raquo_laminar_api_package$features$().cz();
        return $x_10.Iz(text, $x_9.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_8, $x_7.w($x_6.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_5, $x_4, $x_3, $x_2, $x_1, new $c_Lcom_raquo_laminar_modifiers_EventListener(this$14, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => {
          onNext.a3();
        })))])))])));
      }
    }
    throw new $c_s_MatchError(x$1);
  });
  if ((this$15 === $m_sci_Nil$())) {
    var $x_11 = $m_sci_Nil$();
  } else {
    var x0$1 = this$15.er;
    var h = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
    var t = h;
    var rest = this$15.U;
    while ((rest !== $m_sci_Nil$())) {
      var x0$2 = rest.t();
      var nx = new $c_sci_$colon$colon(f(x0$2), $m_sci_Nil$());
      t.U = nx;
      t = nx;
      rest = rest.v();
    }
    var $x_11 = h;
  }
  return $x_15.w($x_14.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_13, $x_12, $f_Lcom_raquo_laminar_api_Implicits__nodeSeqToModifier__O__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier(this$16, $x_11, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_PanelSectionToggles$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_PanelSectionToggles$package$, "org.jpablo.graphexplorer.viewer.components.PanelSectionToggles$package$", ({
  yG: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_PanelSectionToggles$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_PanelSectionToggles$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_PanelSectionToggles$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_PanelSectionToggles$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_PanelSectionToggles$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_PanelSectionToggles$package$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_PreferencesDialog$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_PreferencesDialog$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_PreferencesDialog$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_PreferencesDialog$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_PreferencesDialog$package$.prototype = $p;
$p.aLy = (function(open, currentTheme, onSelectTheme, promptLabelBeforeNewNode, enable3D) {
  return $m_Lorg_jpablo_graphexplorer_viewer_widgets_Dialog$package$().aeu(open, $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("min-w-[26rem] overflow-visible"), $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("space-y-4"), $m_Lcom_raquo_laminar_api_package$().b.ya().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("text-lg font-semibold"), $m_Lcom_raquo_laminar_api_package$().b.wj().n((-1)), $m_Lcom_raquo_laminar_api_package$().b.aXQ().n(true), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Preferences", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("flex items-center justify-between gap-6"), $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("text-sm"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Theme", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $m_Lorg_jpablo_graphexplorer_viewer_components_ThemeSelect$package$().aWk(currentTheme, onSelectTheme)]))), $m_Lcom_raquo_laminar_api_package$().b.Xp().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("flex items-center justify-between gap-6 cursor-pointer"), $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("text-sm"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Ask for a label when creating a node", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().aLG(promptLabelBeforeNewNode, $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([])))]))), $m_Lcom_raquo_laminar_api_package$().b.Xp().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("flex items-center justify-between gap-6 cursor-pointer"), $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("text-sm"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "3D view (experimental)", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().aLG(enable3D, $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([])))])))])))])));
});
$p.aWa = (function(state) {
  return $m_Lorg_jpablo_graphexplorer_viewer_components_PreferencesDialog$package$().aLy(state.abo, state.Pf().P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((theme) => {
    $f_Lcom_raquo_airstream_state_Var__set__O__V(state.Pf(), new $c_s_Some(theme));
  })), state.U1, state.H5);
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_PreferencesDialog$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_PreferencesDialog$package$, "org.jpablo.graphexplorer.viewer.components.PreferencesDialog$package$", ({
  yH: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_PreferencesDialog$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_PreferencesDialog$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_PreferencesDialog$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_PreferencesDialog$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_PreferencesDialog$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_PreferencesDialog$package$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_RenameProjectDialog$package$__saveAndClose$1__Lcom_raquo_airstream_state_Var__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__V($thiz, modalText$1, state$2) {
  var newName = modalText$1.P().aq().d();
  if (($f_T__trim__T(newName) !== "")) {
    $f_Lcom_raquo_airstream_state_Var__set__O__V(state$2.gn().H0, newName);
  }
  $f_Lcom_raquo_airstream_state_Var__set__O__V(state$2.CI, false);
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_RenameProjectDialog$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_RenameProjectDialog$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_RenameProjectDialog$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_RenameProjectDialog$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_RenameProjectDialog$package$.prototype = $p;
$p.aWd = (function(state) {
  var modalText = $m_Lcom_raquo_laminar_api_package$().b.ff.bx("");
  var $x_29 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_28 = $m_sr_ScalaRunTime$();
  var $x_27 = $m_Lcom_raquo_laminar_api_package$().b.gz().n("rename-project-dialog");
  $m_Lcom_raquo_laminar_api_package$();
  var $x_26 = $m_Lcom_raquo_laminar_api_Implicits$RichSource$().ft(state.CI.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => {
    if ((!(!v1))) {
      $f_Lcom_raquo_airstream_state_Var__set__O__V(modalText, state.gn().H0.P().aq().d());
    }
  })));
  $m_Lcom_raquo_laminar_api_package$();
  var $x_25 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Dialog$package$();
  var $x_24 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lcom_raquo_airstream_state_Var__set__O__V(state.CI, false);
  }));
  var $x_23 = $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([]));
  var $x_22 = $m_sr_ScalaRunTime$();
  var $x_21 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_20 = $m_sr_ScalaRunTime$();
  var $x_19 = $m_Lcom_raquo_laminar_api_package$().b.ya().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("font-bold text-md mb-2"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Rename diagram", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])));
  var $x_18 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$();
  var $x_17 = $m_sr_ScalaRunTime$();
  var $x_16 = $m_Lcom_raquo_laminar_api_package$().b.ud().n("Diagram name");
  $m_Lcom_raquo_laminar_api_package$();
  var updater = $m_Lcom_raquo_laminar_api_package$().b.jx().bj(modalText);
  var listener = new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.oE(), false, false)).nC(), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => {
    modalText.jA().bA(_$1);
  })));
  var $x_15 = $m_Lcom_raquo_laminar_inputs_InputController$().qU(listener, updater);
  var $x_14 = $m_Lcom_raquo_laminar_api_package$().b.AR;
  var this$10 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.m1(), false, false)).pt(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$1) => (_$1$1.key === "Enter")))).jY();
  var onNext$1 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $p_Lorg_jpablo_graphexplorer_viewer_components_RenameProjectDialog$package$__saveAndClose$1__Lcom_raquo_airstream_state_Var__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__V(this, modalText, state);
  }));
  $m_Lcom_raquo_laminar_api_package$features$().cz();
  var $x_13 = new $c_Lcom_raquo_laminar_modifiers_EventListener(this$10, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => {
    onNext$1.a3();
  })));
  var this$12 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.m1(), false, false)).pt(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2$1) => (_$2$1.key === "Escape"))));
  var onNext$2 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lcom_raquo_airstream_state_Var__set__O__V(state.CI, false);
  }));
  $m_Lcom_raquo_laminar_api_package$features$().cz();
  var $x_12 = $x_22.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_21.w($x_20.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_19, $x_18.aVO($x_17.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_16, $x_15, $x_14, $x_13, new $c_Lcom_raquo_laminar_modifiers_EventListener(this$12, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2$2) => {
    onNext$2.a3();
  })))])))])))]));
  var $x_11 = $m_sr_ScalaRunTime$();
  var $x_10 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_9 = $m_sr_ScalaRunTime$();
  var $x_8 = $m_Lcom_raquo_laminar_api_package$().b.y.s("flex justify-end gap-2 mt-2");
  var $x_7 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Actions$package$();
  var $x_6 = $m_sr_ScalaRunTime$();
  var $x_5 = $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Cancel", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7);
  var this$15 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false));
  var onNext$3 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lcom_raquo_airstream_state_Var__set__O__V(state.CI, false);
  }));
  $m_Lcom_raquo_laminar_api_package$features$().cz();
  var $x_4 = $x_7.Ix($x_6.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_5, new $c_Lcom_raquo_laminar_modifiers_EventListener(this$15, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2$3) => {
    onNext$3.a3();
  })))])));
  var $x_3 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Actions$package$();
  var $x_2 = $m_sr_ScalaRunTime$();
  var $x_1 = $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Ok", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7);
  var this$18 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false));
  var onNext$4 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $p_Lorg_jpablo_graphexplorer_viewer_components_RenameProjectDialog$package$__saveAndClose$1__Lcom_raquo_airstream_state_Var__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__V(this, modalText, state);
  }));
  $m_Lcom_raquo_laminar_api_package$features$().cz();
  return $x_29.w($x_28.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_27, $x_26, new $c_Lcom_raquo_laminar_receivers_LockedChildReceiver($x_25.Iw($x_24, $x_23, $x_12, $x_11.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_10.w($x_9.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_8, $x_4, $x_3.OO($x_2.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_1, new $c_Lcom_raquo_laminar_modifiers_EventListener(this$18, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2$4) => {
    onNext$4.a3();
  })))])))])))])))).gR(state.CI.P())])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_RenameProjectDialog$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_RenameProjectDialog$package$, "org.jpablo.graphexplorer.viewer.components.RenameProjectDialog$package$", ({
  yI: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_RenameProjectDialog$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_RenameProjectDialog$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_RenameProjectDialog$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_RenameProjectDialog$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_RenameProjectDialog$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_RenameProjectDialog$package$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_RouterCommands__createProjectAndNavigate__s_Option__V($thiz, source) {
  var id = $m_Lorg_jpablo_graphexplorer_projects_Library$().IM($m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$().GY);
  $thiz.axr.rh(new $c_Lorg_jpablo_graphexplorer_router_Route$ProjectDetail(id.cv, source));
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_RouterCommands(router) {
  this.axr = null;
  this.SL = null;
  this.axq = null;
  this.a9b = null;
  this.LF = null;
  this.axr = router;
  var action$1 = new $c_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$OneArg(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((source) => {
    $p_Lorg_jpablo_graphexplorer_viewer_components_RouterCommands__createProjectAndNavigate__s_Option__V(this, source);
  })));
  var description$1 = new $c_s_Some("Create a new project and navigate to it");
  var shortcut$1 = $m_s_None$();
  this.SL = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Create new Project", action$1, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().ep, shortcut$1, description$1);
  var action$3 = new $c_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$OneArg(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((nameAndSource) => {
    matchResult16: {
      var \u03b41$___1;
      var \u03b41$___2;
      if ((nameAndSource !== null)) {
        var \u03b41$___1 = nameAndSource.g();
        var \u03b41$___2 = nameAndSource.h();
        break matchResult16;
      }
      throw new $c_s_MatchError(nameAndSource);
    }
    router.rh(new $c_Lorg_jpablo_graphexplorer_router_Route$ProjectDetail($m_Lorg_jpablo_graphexplorer_projects_Library$().a32(\u03b41$___1, \u03b41$___2).cv, $m_s_None$()));
  })));
  var description$3 = new $c_s_Some("Add a copy of this example to your library");
  var shortcut$3 = $m_s_None$();
  this.axq = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Copy example to library", action$3, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().ep, shortcut$3, description$3);
  var action$2 = new $c_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$OneArg(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((slug) => {
    router.rh(new $c_Lorg_jpablo_graphexplorer_router_Route$Example(slug));
  })));
  var description$2 = new $c_s_Some("Open a built-in example without adding it to the library");
  var shortcut$2 = $m_s_None$();
  this.a9b = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Open example", action$2, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().ep, shortcut$2, description$2);
  var action$4 = $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$().bp().i(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    router.rh($s_Lorg_jpablo_graphexplorer_router_Route$__Home__Lorg_jpablo_graphexplorer_router_Route());
  })));
  var description$4 = new $c_s_Some("Navigate to the home page");
  var shortcut$4 = $m_s_None$();
  this.LF = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command("Navigate home", action$4, $m_Lorg_jpablo_graphexplorer_viewer_components_Command$().ep, shortcut$4, description$4);
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_RouterCommands.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_RouterCommands;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_RouterCommands() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_RouterCommands.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_viewer_components_RouterCommands = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_RouterCommands, "org.jpablo.graphexplorer.viewer.components.RouterCommands", ({
  yJ: 1
}));
function $p_Lorg_jpablo_graphexplorer_viewer_components_SvgElementOps__buildSvgElement__Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement__T2($thiz, elem) {
  var e = $m_Lcom_raquo_laminar_DomApi$().baJ(elem.dD().outerHTML);
  var selectedBorders = e.querySelectorAll(("." + elem.PR()));
  var this$2 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(selectedBorders);
  var it = this$2.o();
  while (it.p()) {
    var x0 = it.q();
    x0.parentNode.removeChild(x0);
  }
  var bbox = elem.dD().getBBox();
  return new $c_T2(e, new $c_Lorg_jpablo_graphexplorer_viewer_utils_BBox((+bbox.x), (+bbox.y), (+bbox.width), (+bbox.height)));
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_SvgElementOps(ref) {
  this.axs = null;
  this.axs = ref;
  ref.setAttribute("class", "graphviz");
  ref.removeAttribute("style");
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_SvgElementOps.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_SvgElementOps;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_SvgElementOps() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_SvgElementOps.prototype = $p;
$p.bab = (function(ids, strategy) {
  if (ids.c()) {
    return "";
  } else {
    matchResult1: {
      var \u03b41$___1;
      var \u03b41$___2;
      var x1 = $m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().DW(this.axs, strategy).bw(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().mJ(ids, _$1.lj())))).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((elem) => $p_Lorg_jpablo_graphexplorer_viewer_components_SvgElementOps__buildSvgElement__Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement__T2(this, elem)))).fa($m_s_$less$colon$less$().b1);
      if ((x1 !== null)) {
        var \u03b41$___1 = x1.g();
        var \u03b41$___2 = x1.h();
        break matchResult1;
      }
      throw new $c_s_MatchError(x1);
    }
    var svgs$2 = \u03b41$___1;
    var boxes$2 = \u03b41$___2;
    var bbox = boxes$2.kT(new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((a, b) => {
      var x = a.xt;
      var that = b.xt;
      var x$1 = (+Math.min(x, that));
      var x$2 = a.vu;
      var that$1 = b.vu;
      var y = (+Math.min(x$2, that$1));
      var x$3 = a.zP;
      var that$2 = ((b.xt + b.zP) - x$1);
      var $x_1 = Math.max(x$3, that$2);
      var x$4 = (a.vu + a.zO);
      var that$3 = (b.vu + b.zO);
      return new $c_Lorg_jpablo_graphexplorer_viewer_utils_BBox(x$1, y, (+$x_1), ((+Math.max(x$4, that$3)) - y));
    })));
    var s = $m_Lorg_jpablo_graphexplorer_viewer_components_SvgElementOps$().b0x(bbox, $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__nodeSeqToModifier__O__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, svgs$2.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((element) => $f_Lcom_raquo_laminar_api_Laminar__foreignSvgElement__Lorg_scalajs_dom_SVGElement__Lcom_raquo_laminar_nodes_ReactiveSvgElement($m_Lcom_raquo_laminar_api_package$().b, element)))), $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())])));
    return s.e8.outerHTML;
  }
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_SvgElementOps = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_SvgElementOps, "org.jpablo.graphexplorer.viewer.components.SvgElementOps", ({
  yL: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_SvgElementOps$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_SvgElementOps$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_SvgElementOps$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_SvgElementOps$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_SvgElementOps$.prototype = $p;
$p.b0x = (function(viewBox, mods) {
  return $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().a5l().n("http://www.w3.org/2000/svg"), $m_Lcom_raquo_laminar_api_package$().b.j().bcY().n("http://www.w3.org/1999/xlink"), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n(((((((viewBox.xt + " ") + viewBox.vu) + " ") + viewBox.zP) + " ") + viewBox.zO)), $m_Lcom_raquo_laminar_api_package$().b.j().ar.s("graphviz no-text-select"), $f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, mods, $m_s_$less$colon$less$().b1, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_SvgElementOps$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_SvgElementOps$, "org.jpablo.graphexplorer.viewer.components.SvgElementOps$", ({
  yM: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_SvgElementOps$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_SvgElementOps$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_SvgElementOps$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_SvgElementOps$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_SvgElementOps$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_SvgElementOps$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_SvgElementOps$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_SvgElementOps$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_SvgElementOps$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_SvgElementOps$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_SvgElementOps$package$.prototype = $p;
$p.Q5 = (function(clientPoint, screenCtm) {
  var DOMPoint$1 = new DOMPoint(clientPoint.fi, clientPoint.fj).matrixTransform(screenCtm.inverse());
  $m_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint$();
  return new $c_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint((+DOMPoint$1.x), (+DOMPoint$1.y));
});
$p.bae = (function(rect, screenCtm) {
  return new $c_T2($m_Lorg_jpablo_graphexplorer_viewer_components_SvgElementOps$package$().Q5(rect.oe, screenCtm), $m_Lorg_jpablo_graphexplorer_viewer_components_SvgElementOps$package$().Q5(rect.jK, screenCtm));
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_SvgElementOps$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_SvgElementOps$package$, "org.jpablo.graphexplorer.viewer.components.SvgElementOps$package$", ({
  yN: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_SvgElementOps$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_SvgElementOps$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_SvgElementOps$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_SvgElementOps$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_SvgElementOps$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_SvgElementOps$package$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_ThemeSelect$package$() {
  this.axt = null;
  this.a9c = null;
  $n_Lorg_jpablo_graphexplorer_viewer_components_ThemeSelect$package$ = this;
  this.axt = "drafting";
  this.a9c = $m_sci_Seq$().kM($m_sr_ScalaRunTime$().f(new ($d_T.r().C)(["light", "dark", "workbench", "drafting", "signal", "cupcake", "nord", "retro", "night", "synthwave"])));
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_ThemeSelect$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_ThemeSelect$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_ThemeSelect$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_ThemeSelect$package$.prototype = $p;
$p.a4w = (function(stored) {
  if (stored.c()) {
    var $x_1 = true;
  } else {
    var x0 = stored.d();
    var $x_1 = $m_Lorg_jpablo_graphexplorer_viewer_components_ThemeSelect$package$().a9c.E(x0);
  }
  if ($x_1) {
    var this$1 = stored;
  } else {
    var this$1 = $m_s_None$();
  }
  return (this$1.c() ? $m_Lorg_jpablo_graphexplorer_viewer_components_ThemeSelect$package$().axt : this$1.d());
});
$p.aSO = (function(theme) {
  return $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_defs_complex_ComplexHtmlKeys__dataAttr__T__Lcom_raquo_laminar_keys_HtmlAttr($m_Lcom_raquo_laminar_api_package$().b, "theme").n(theme), $m_Lcom_raquo_laminar_api_package$().b.y.s("flex items-center gap-0.5 rounded-selector border border-base-300 bg-base-100 p-0.5 shrink-0"), $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("w-1 h-3 rounded-full bg-base-content")]))), $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("w-1 h-3 rounded-full bg-primary")]))), $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("w-1 h-3 rounded-full bg-secondary")]))), $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("w-1 h-3 rounded-full bg-accent")])))])));
});
$p.b9V = (function(theme, current) {
  return $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("flex items-center gap-2 w-full"), $m_Lorg_jpablo_graphexplorer_viewer_components_ThemeSelect$package$().aSO(theme), $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, theme, $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("ml-auto"), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_receivers_ChildOptionReceiver$()).gR($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), current, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((c) => (($m_Lorg_jpablo_graphexplorer_viewer_components_ThemeSelect$package$().a4w(c) === theme) ? new $c_s_Some($m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("bi bi-check-lg")])))) : $m_s_None$()))), $m_s_None$()))])))])));
});
$p.aWk = (function(current, onSelect) {
  var currentName = $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), current, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((stored) => $m_Lorg_jpablo_graphexplorer_viewer_components_ThemeSelect$package$().a4w(stored))), $m_s_None$());
  return $f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement($m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().DB($m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("flex items-center gap-1.5 font-normal"), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_inserters_ChildInserter$().nv($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), currentName, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((theme) => $m_Lorg_jpablo_graphexplorer_viewer_components_ThemeSelect$package$().aSO(theme))), $m_s_None$()), $m_Lcom_raquo_laminar_modifiers_RenderableNode$().ht, (void 0))), $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_inserters_ChildTextInserter$().DG(currentName, $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7))])))]))), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_airstream_state_Val$().iT($m_Lorg_jpablo_graphexplorer_viewer_components_ThemeSelect$package$().a9c.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((theme$2) => new $c_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$MenuOption($m_Lorg_jpablo_graphexplorer_viewer_components_ThemeSelect$package$().b9V(theme$2, current), theme$2, new $c_s_Some((("Switch to the " + theme$2) + " theme")), $m_s_None$())))))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((ep) => new $c_Lcom_raquo_laminar_modifiers_EventListener(ep, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((theme$1) => {
    onSelect.i(theme$1);
  }))))), $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().a2t(), false, "w-48 max-h-96 overflow-y-auto flex-nowrap"), $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("dropdown-end theme-select")])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_ThemeSelect$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_ThemeSelect$package$, "org.jpablo.graphexplorer.viewer.components.ThemeSelect$package$", ({
  yO: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_ThemeSelect$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_ThemeSelect$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_ThemeSelect$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_ThemeSelect$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_ThemeSelect$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_ThemeSelect$package$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_Toolbar$package$__shapePreview$1__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape__O($thiz, shape) {
  var this$1 = $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ShapePreview$package$().aLB(shape, 16, 20);
  var this$2 = (this$1.c() ? $m_s_None$() : new $c_s_Some(this$1.d().a3()));
  return (this$2.c() ? shape.m() : this$2.d());
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_Toolbar$package$__filteredMenu$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__sci_Seq__Lcom_raquo_airstream_core_Signal($thiz, state$3, cmds) {
  return $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), state$3.aH().ne, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((selection) => {
    var selection$1 = ((selection === null) ? null : selection.aS);
    return cmds.bw(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => ((x$1 instanceof $c_Lorg_jpablo_graphexplorer_viewer_components_Command) ? (!(!x$1.G8.i(new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds(selection$1)))) : true)))).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
      if ((x$1$2 instanceof $c_Lorg_jpablo_graphexplorer_viewer_components_Command)) {
        var elem = x$1$2.lE;
        var value$1 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((cmd$2) => (() => {
          cmd$2.gZ($m_s_None$(), true);
        }))(x$1$2));
        var this$1 = x$1$2.vg;
        var description = new $c_s_Some((this$1.c() ? x$1$2.lE : this$1.d()));
        var this$3 = x$1$2.x4;
        return new $c_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$MenuOption(elem, value$1, description, (this$3.c() ? $m_s_None$() : new $c_s_Some(this$3.d().bM())));
      } else {
        return $s_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$__Sep__Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry();
      }
    })));
  })), $m_s_None$());
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_Toolbar$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_Toolbar$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_Toolbar$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_Toolbar$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_Toolbar$package$.prototype = $p;
$p.aWl = (function(projectName, commands, state) {
  var defaultShapePreview = $p_Lorg_jpablo_graphexplorer_viewer_components_Toolbar$package$__shapePreview$1__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape__O(this, $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().E0($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$().aF4.aaE, $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$()));
  var shapePreviews = new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__box__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__circle__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__ellipse__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__diamond__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__star__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $m_sci_Nil$()))))).As(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((shape) => new $c_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$MenuOption($p_Lorg_jpablo_graphexplorer_viewer_components_Toolbar$package$__shapePreview$1__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape__O(this, shape), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((shape$2) => (() => {
    state.a33($m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().Au($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_AttributePair.r().C)([new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributePair$$anon$3(new $c_T2($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$(), shape$2))]))), $s_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$__forward__Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection());
  }))(shape)), $m_s_None$(), $m_s_None$()))));
  $m_Lcom_raquo_laminar_api_package$();
  var $x_2 = $m_Lcom_raquo_airstream_state_Val$();
  var $x_1 = new $c_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$MenuOption("Preferences\u2026", new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lcom_raquo_airstream_state_Var__set__O__V(state.abo, true);
  })), new $c_s_Some("Theme and editing preferences"), $m_s_None$());
  var elem$1 = commands.ap().LE.lE;
  var value$3 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    commands.ap().LE.gZ((commands.ap(), $m_s_None$()), (commands.ap(), true));
  }));
  var this$11 = commands.ap().LE.vg;
  var default$1 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => ""));
  var description$2 = new $c_s_Some((this$11.c() ? default$1.a3() : this$11.d()));
  var this$13 = commands.ap().LE.x4;
  var f$1 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3) => _$3.bM()));
  var gearMenu = $x_2.iT(new $c_sci_$colon$colon($x_1, new $c_sci_$colon$colon(new $c_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$MenuOption(elem$1, value$3, description$2, (this$13.c() ? $m_s_None$() : new $c_s_Some(f$1.i(this$13.d())))), new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$__Sep__Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry(), new $c_sci_$colon$colon(new $c_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$MenuOption("About Graph Explorer", new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    commands.ap().a8Z.gZ((commands.ap(), $m_s_None$()), (commands.ap(), true));
  })), $m_s_None$(), $m_s_None$()), new $c_sci_$colon$colon(new $c_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$MenuOption("Source on GitHub", new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    window.open("https://github.com/jpablo/graph-explorer/tree/viewer", "_blank");
  })), $m_s_None$(), $m_s_None$()), $m_sci_Nil$()))))));
  var $x_48 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_47 = $m_sr_ScalaRunTime$();
  var $x_46 = $m_Lcom_raquo_laminar_api_package$().b.gz().n("toolbar");
  var $x_45 = $m_Lcom_raquo_laminar_api_package$().b.y.s("navbar");
  var $x_44 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_43 = $m_sr_ScalaRunTime$();
  var $x_42 = $m_Lcom_raquo_laminar_api_package$().b.y.s("navbar-start gap-4");
  var $x_41 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_IconButton$package$().ON("bi-layout-sidebar", "Toggle Library", state.H7, "tooltip-bottom tooltip-start", $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.gz().n("toggle-library")])));
  var $x_40 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_39 = $m_sr_ScalaRunTime$();
  var $x_38 = $m_Lcom_raquo_laminar_api_package$().b.y.s("breadcrumbs text-md py-0");
  var $x_37 = $m_Lcom_raquo_laminar_api_package$().b.Q6();
  var $x_36 = $m_sr_ScalaRunTime$();
  var $x_35 = $m_Lcom_raquo_laminar_api_package$().b.yc();
  var $x_34 = $m_sr_ScalaRunTime$();
  var $x_33 = $m_Lcom_raquo_laminar_api_package$().b.DD();
  var $x_32 = $m_sr_ScalaRunTime$();
  var $x_31 = $m_Lcom_raquo_laminar_api_package$().b.y.s("text-sm opacity-60");
  var $x_30 = $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Library", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7);
  var this$22 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false));
  var onNext = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    commands.a8R.LF.gZ($m_s_None$(), true);
  }));
  $m_Lcom_raquo_laminar_api_package$features$().cz();
  var $x_29 = $x_35.w($x_34.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_33.w($x_32.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_31, $x_30, new $c_Lcom_raquo_laminar_modifiers_EventListener(this$22, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => {
    onNext.a3();
  })))])))])));
  var $x_28 = $m_Lcom_raquo_laminar_api_package$().b.yc();
  var $x_27 = $m_sr_ScalaRunTime$();
  var $x_26 = $m_Lcom_raquo_laminar_api_package$().b.y.s("text-sm");
  var $x_25 = $m_Lcom_raquo_laminar_api_package$().b.aU();
  var $x_24 = $m_sr_ScalaRunTime$();
  var $x_23 = $m_Lcom_raquo_laminar_api_package$().b.y.s("cursor-pointer hover:underline decoration-dotted underline-offset-4");
  var $x_22 = $m_Lcom_raquo_laminar_api_package$().b.eW().n("Rename diagram");
  $m_Lcom_raquo_laminar_api_package$();
  var $x_21 = $m_Lcom_raquo_laminar_inserters_ChildTextInserter$().DG(projectName, $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7);
  var this$26 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false));
  var onNext$1 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    commands.ap().SI.gZ((commands.ap(), $m_s_None$()), (commands.ap(), true));
  }));
  $m_Lcom_raquo_laminar_api_package$features$().cz();
  var $x_20 = $x_44.w($x_43.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_42, $x_41, $x_40.w($x_39.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_38, $x_37.w($x_36.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_29, $x_28.w($x_27.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_26, $x_25.w($x_24.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_23, $x_22, $x_21, new $c_Lcom_raquo_laminar_modifiers_EventListener(this$26, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2$1) => {
    onNext$1.a3();
  })))]))), $m_Lorg_jpablo_graphexplorer_viewer_widgets_IconButton$package$().aVY("bi-pencil text-[.65rem]", "Change title", $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([])), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    commands.ap().SI.gZ((commands.ap(), $m_s_None$()), (commands.ap(), true));
  })))])))])))])))])));
  var $x_19 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_18 = $m_sr_ScalaRunTime$();
  var $x_17 = $m_Lcom_raquo_laminar_api_package$().b.y.s("navbar-center gap-2");
  var $x_16 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_15 = $m_sr_ScalaRunTime$();
  var $x_14 = $m_Lcom_raquo_laminar_api_package$().b.y.s("flex-nowrap");
  var $x_13 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$();
  var $x_12 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Button$package$();
  var $x_11 = $m_sr_ScalaRunTime$();
  var $x_10 = $m_Lcom_raquo_laminar_api_package$().b.y.s("gap-1 pl-1");
  var $x_9 = $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("bi bi-plus")])));
  matchResult3$1: {
    var $x_8;
    if ((defaultShapePreview instanceof $c_Lcom_raquo_laminar_nodes_ReactiveSvgElement)) {
      var $x_8 = $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([defaultShapePreview])));
      break matchResult3$1;
    }
    if (((typeof defaultShapePreview) === "string")) {
      var $x_8 = $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, defaultShapePreview, $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])));
      break matchResult3$1;
    }
    throw new $c_s_MatchError(defaultShapePreview);
  }
  var this$31 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false));
  var onNext$2 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    commands.ap().SJ.gZ((commands.ap(), $m_s_None$()), (commands.ap(), true));
  }));
  $m_Lcom_raquo_laminar_api_package$features$().cz();
  var elem$1$1 = $x_13.iZ($x_12.hH($x_11.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_10, $x_9, $x_8, new $c_Lcom_raquo_laminar_modifiers_EventListener(this$31, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2$2) => {
    onNext$2.a3();
  })))]))));
  var $x_7 = $x_16.w($x_15.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_14, $m_Lorg_jpablo_graphexplorer_viewer_widgets_Tooltip$package$().Iz(commands.ap().SJ.Xr(), $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("tooltip-bottom"), elem$1$1]))), $f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement($m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().DB($m_Lcom_raquo_laminar_api_package$().b.JU, ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_airstream_state_Val$().iT(shapePreviews)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4) => new $c_Lcom_raquo_laminar_modifiers_EventListener(_$4, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((action) => {
    action.a3();
  }))))), $m_Lorg_jpablo_graphexplorer_viewer_widgets_Icons$().aSQ($m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([])))), true, "items-center"), $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("dropdown-center ml-[-1px]")])))])));
  var $x_6 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().DB($m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Add", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $p_Lorg_jpablo_graphexplorer_viewer_components_Toolbar$package$__filteredMenu$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__sci_Seq__Lcom_raquo_airstream_core_Signal(this, state, commands.XY().axm), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$5) => new $c_Lcom_raquo_laminar_modifiers_EventListener(_$5, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((action$1) => {
    action$1.a3();
  }))))), $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().a2t(), false, "w-48");
  var $x_5 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().DB($m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Select", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $p_Lorg_jpablo_graphexplorer_viewer_components_Toolbar$package$__filteredMenu$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__sci_Seq__Lcom_raquo_airstream_core_Signal(this, state, commands.XY().axp), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6) => new $c_Lcom_raquo_laminar_modifiers_EventListener(_$6, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((action$2) => {
    action$2.a3();
  }))))), $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().a2t(), false, "w-48");
  var $x_4 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$();
  var $x_3 = $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Actions", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])));
  var this$38 = commands.XY().axo;
  var importGroup = new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$__Sep__Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry(), this$38);
  var this$39 = commands.XY().axn;
  var exportGroup = new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$__Sep__Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry(), this$39);
  return $x_48.w($x_47.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_46, $x_45, $x_20, $x_19.w($x_18.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_17, $x_7, $x_6, $x_5, $x_4.DB($x_3, $p_Lorg_jpablo_graphexplorer_viewer_components_Toolbar$package$__filteredMenu$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__sci_Seq__Lcom_raquo_airstream_core_Signal(this, state, $f_sc_StrictOptimizedSeqFactory__concat__sci_Seq__sc_SeqOps($m_sci_List$(), $m_sr_ScalaRunTime$().f(new ($d_sc_Iterable.r().C)([commands.XY().axl, importGroup, exportGroup])))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$7) => new $c_Lcom_raquo_laminar_modifiers_EventListener(_$7, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((action$3) => {
    action$3.a3();
  }))))), $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().a2t(), false, "w-48")]))), $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("navbar-end gap-2"), $f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement($m_Lorg_jpablo_graphexplorer_viewer_components_CommandsPanel$package$().aVM(state, commands), $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("hidden lg:block")]))), $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("gx-tool-group"), $m_Lorg_jpablo_graphexplorer_viewer_widgets_IconButton$package$().Ae("bi-arrow-counterclockwise", commands.ap().a0i.Xr(), "tooltip-bottom", $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([])), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    commands.ap().a0i.gZ((commands.ap(), $m_s_None$()), (commands.ap(), true));
  }))), $m_Lorg_jpablo_graphexplorer_viewer_widgets_IconButton$package$().Ae("bi-arrow-clockwise", commands.ap().a0f.Xr(), "tooltip-bottom", $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([])), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    commands.ap().a0f.gZ((commands.ap(), $m_s_None$()), (commands.ap(), true));
  })))]))), $f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement($m_Lorg_jpablo_graphexplorer_viewer_components_PanelSectionToggles$package$().aW9(state), $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("gx-tool-group")]))), $f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement($m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().DB($m_Lcom_raquo_laminar_api_package$().b.Af().Aq().n("Settings"), gearMenu, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$8) => new $c_Lcom_raquo_laminar_modifiers_EventListener(_$8, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((action$4) => {
    action$4.a3();
  }))))), $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("bi bi-gear")]))), false, "w-56"), $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("dropdown-end")])))])))])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_Toolbar$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_Toolbar$package$, "org.jpablo.graphexplorer.viewer.components.Toolbar$package$", ({
  yP: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_Toolbar$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_Toolbar$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_Toolbar$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_Toolbar$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_Toolbar$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_Toolbar$package$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_TopLevel$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_TopLevel$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_TopLevel$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_TopLevel$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_TopLevel$package$.prototype = $p;
$p.aWq = (function(state, router, commands, banner) {
  return $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.gz().n("top-level"), $m_Lorg_jpablo_graphexplorer_viewer_components_Toolbar$package$().aWl(state.a10, commands, state), $f_Lcom_raquo_laminar_api_Implicits__nodeSeqToModifier__O__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, $m_s_Option$().m2(banner).iz(), $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$()), $m_Lorg_jpablo_graphexplorer_viewer_components_DocumentConflictBanner$package$().aVP(state), $m_Lorg_jpablo_graphexplorer_viewer_components_OriginStateBanner$package$().aW8(state.lI), $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("flex flex-1 overflow-y-auto relative"), $m_Lorg_jpablo_graphexplorer_viewer_components_leftPanel_LeftPanel$package$().aW3(state, router, commands), $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("relative flex flex-1 min-w-0"), $m_Lorg_jpablo_graphexplorer_viewer_components_AttributesToolbar$package$().aVF(state.a10, commands, state), $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasContainer$package$().aVK(state, commands)]))), $m_Lorg_jpablo_graphexplorer_viewer_components_ZoomToolbar$package$().aWu(state, commands), $m_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_RightPanel$package$().aWe(state), $m_Lorg_jpablo_graphexplorer_viewer_components_HelpDialog$package$().aVX(state.abi, commands), $m_Lorg_jpablo_graphexplorer_viewer_components_AboutDialog$package$().aLo(state.abf), $m_Lorg_jpablo_graphexplorer_viewer_components_PreferencesDialog$package$().aWa(state), $m_Lorg_jpablo_graphexplorer_viewer_components_RenameProjectDialog$package$().aWd(state), $m_Lorg_jpablo_graphexplorer_viewer_components_InfoAlert$package$().aW0(state.od), $m_Lorg_jpablo_graphexplorer_viewer_components_EditLabelDialog$package$().aVT(state), $m_Lorg_jpablo_graphexplorer_viewer_components_EditCellDialog$package$().aVS(state), $m_Lorg_jpablo_graphexplorer_viewer_components_NewNodeLabelDialog$package$().aW7(state), $m_Lorg_jpablo_graphexplorer_viewer_components_NewGroupLabelDialog$package$().aW6(state), $m_Lorg_jpablo_graphexplorer_viewer_components_UnsavedChangesDialog$package$().aWs(state, router), $m_Lorg_jpablo_graphexplorer_viewer_components_ErrorAlert$package$().aVW(state.tr)])))])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_TopLevel$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_TopLevel$package$, "org.jpablo.graphexplorer.viewer.components.TopLevel$package$", ({
  yQ: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_TopLevel$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_TopLevel$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_TopLevel$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_TopLevel$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_TopLevel$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_TopLevel$package$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_UnsavedChangesDialog$package$__leave$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_router_Router__Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent__V($thiz, state$1, router$1, intent) {
  $f_Lcom_raquo_airstream_state_Var__set__O__V(state$1.xs, $m_s_None$());
  matchResult1: {
    if ((intent instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent$Navigate)) {
      var x4 = intent.TL;
      router$1.aOg(x4);
      break matchResult1;
    }
    var x = $s_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent$__CloseWindow__Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent();
    if (((x === null) ? (intent === null) : x.e(intent))) {
      $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopClose$().aMZ($m_s_concurrent_ExecutionContext$().ek());
      break matchResult1;
    }
    throw new $c_s_MatchError(intent);
  }
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_UnsavedChangesDialog$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_UnsavedChangesDialog$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_UnsavedChangesDialog$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_UnsavedChangesDialog$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_UnsavedChangesDialog$package$.prototype = $p;
$p.aWs = (function(state, router) {
  return $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_inserters_ChildInserter$().nv($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), state.xs.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    if (($m_s_None$() === x$1)) {
      $m_Lcom_raquo_laminar_api_package$();
      return new $c_Lcom_raquo_laminar_nodes_CommentNode("");
    }
    if ((x$1 instanceof $c_s_Some)) {
      var intent = x$1.J;
      var $x_19 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Dialog$package$();
      var $x_18 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
        $f_Lcom_raquo_airstream_state_Var__set__O__V(state.xs, $m_s_None$());
      }));
      var $x_17 = $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([]));
      var $x_16 = $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.ya().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("font-bold text-md mb-2"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Save this file?", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $m_Lcom_raquo_laminar_api_package$().b.Ax().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "This file has changes that are not written to disk.", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))])))]));
      var $x_15 = $m_sr_ScalaRunTime$();
      var $x_14 = $m_Lcom_raquo_laminar_api_package$().b.a8();
      var $x_13 = $m_sr_ScalaRunTime$();
      var $x_12 = $m_Lcom_raquo_laminar_api_package$().b.y.s("flex gap-2");
      var $x_11 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Actions$package$();
      var $x_10 = $m_sr_ScalaRunTime$();
      var $x_9 = $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Cancel", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7);
      var this$7 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false));
      var onNext = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
        $f_Lcom_raquo_airstream_state_Var__set__O__V(state.xs, $m_s_None$());
      }));
      $m_Lcom_raquo_laminar_api_package$features$().cz();
      var $x_8 = $x_11.Ix($x_10.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_9, new $c_Lcom_raquo_laminar_modifiers_EventListener(this$7, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => {
        onNext.a3();
      })))])));
      var $x_7 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Actions$package$();
      var $x_6 = $m_sr_ScalaRunTime$();
      var $x_5 = $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Discard", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7);
      var this$10 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false));
      var onNext$1 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
        $p_Lorg_jpablo_graphexplorer_viewer_components_UnsavedChangesDialog$package$__leave$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_router_Router__Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent__V(this, state, router, intent);
      }));
      $m_Lcom_raquo_laminar_api_package$features$().cz();
      var $x_4 = $x_7.aVz($x_6.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_5, new $c_Lcom_raquo_laminar_modifiers_EventListener(this$10, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2$1) => {
        onNext$1.a3();
      })))])));
      var $x_3 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Actions$package$();
      var $x_2 = $m_sr_ScalaRunTime$();
      var $x_1 = $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Save", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7);
      var this$21 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false));
      var onNext$2 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
        var x$1$1 = $m_s_concurrent_ExecutionContext$().ek();
        state.zH.a4B($f_Lorg_jpablo_graphexplorer_viewer_state_Persistence__snapshot__Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState(state), x$1$1).oB(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
          matchResult2: {
            var x$2 = $s_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$__Saved__Lorg_jpablo_graphexplorer_viewer_state_SaveResult();
            if (((x$2 === null) ? (x$1$2 === null) : x$2.e(x$1$2))) {
              $p_Lorg_jpablo_graphexplorer_viewer_components_UnsavedChangesDialog$package$__leave$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_router_Router__Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent__V(this, state, router, intent);
              break matchResult2;
            }
            if ((x$1$2 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$Conflict)) {
              var x14 = x$1$2.MS;
              $f_Lcom_raquo_airstream_state_Var__set__O__V(state.xs, $m_s_None$());
              state.tr.dn.bA(x14);
              break matchResult2;
            }
            if ((x$1$2 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$Failed)) {
              var x11 = x$1$2.MT;
              $f_Lcom_raquo_airstream_state_Var__set__O__V(state.xs, $m_s_None$());
              var this$17 = state.tr;
              var event = ("Save failed: " + x11);
              this$17.dn.bA(event);
              break matchResult2;
            }
            if ((x$1$2 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$Unsupported)) {
              var x8 = x$1$2.MU;
              $f_Lcom_raquo_airstream_state_Var__set__O__V(state.xs, $m_s_None$());
              state.od.dn.bA(x8);
              break matchResult2;
            }
            throw new $c_s_MatchError(x$1$2);
          }
        })), $m_s_concurrent_ExecutionContext$().ek());
      }));
      $m_Lcom_raquo_laminar_api_package$features$().cz();
      return $x_19.Iw($x_18, $x_17, $x_16, $x_15.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_14.w($x_13.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_12, $x_8, $x_4, $x_3.OO($x_2.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_1, new $c_Lcom_raquo_laminar_modifiers_EventListener(this$21, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2$2) => {
        onNext$2.a3();
      })))])))])))])));
    }
    throw new $c_s_MatchError(x$1);
  })), $m_s_None$()), $m_Lcom_raquo_laminar_modifiers_RenderableNode$().ht, (void 0)))])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_UnsavedChangesDialog$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_UnsavedChangesDialog$package$, "org.jpablo.graphexplorer.viewer.components.UnsavedChangesDialog$package$", ({
  yR: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_UnsavedChangesDialog$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_UnsavedChangesDialog$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_UnsavedChangesDialog$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_UnsavedChangesDialog$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_UnsavedChangesDialog$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_UnsavedChangesDialog$package$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_ZoomToolbar$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_ZoomToolbar$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_ZoomToolbar$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_ZoomToolbar$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_ZoomToolbar$package$.prototype = $p;
$p.aWu = (function(state, commands) {
  var $x_30 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_29 = $m_sr_ScalaRunTime$();
  var $x_28 = $m_Lcom_raquo_laminar_api_package$().b.gz().n("zoom-toolbar");
  var $x_27 = $m_Lcom_raquo_laminar_api_package$().b.y.s("floating-toolbar");
  var $x_26 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$();
  var $x_25 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$();
  var $x_24 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Button$package$();
  var $x_23 = $m_sr_ScalaRunTime$();
  var $x_22 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Icons$().aZw($m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([]))));
  var this$3 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false));
  var onNext = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    commands.ap().a92.gZ((commands.ap(), $m_s_None$()), (commands.ap(), true));
  }));
  $m_Lcom_raquo_laminar_api_package$features$().cz();
  var $x_21 = $x_26.u4($x_25.iZ($x_24.hH($x_23.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_22, new $c_Lcom_raquo_laminar_modifiers_EventListener(this$3, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => {
    onNext.a3();
  })))])))));
  var $x_20 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$();
  var $x_19 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$();
  var $x_18 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Button$package$();
  var $x_17 = $m_sr_ScalaRunTime$();
  var $x_16 = $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, commands.ap().a0c.lE, $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7);
  var this$7 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false));
  var onNext$1 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    commands.ap().a0c.gZ((commands.ap(), $m_s_None$()), (commands.ap(), true));
  }));
  $m_Lcom_raquo_laminar_api_package$features$().cz();
  var $x_15 = $x_20.u4($x_19.iZ($x_18.hH($x_17.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_16, new $c_Lcom_raquo_laminar_modifiers_EventListener(this$7, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2$1) => {
    onNext$1.a3();
  })))])))));
  var $x_14 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$();
  var $x_13 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$();
  var $x_12 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$();
  var $x_11 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Button$package$();
  var $x_10 = $m_sr_ScalaRunTime$();
  var $x_9 = $m_Lcom_raquo_laminar_api_package$().b.eW().n("Auto fit");
  var $x_8 = $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Auto", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7);
  var $x_7 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().aLC(state.xq.P(), "bi bi-check-circle", "bi bi-circle");
  var this$11 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false));
  var onNext$2 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    commands.ap().awh.gZ((commands.ap(), $m_s_None$()), (commands.ap(), true));
  }));
  $m_Lcom_raquo_laminar_api_package$features$().cz();
  var $x_6 = $x_14.aLL($x_13.u4($x_12.iZ($x_11.hH($x_10.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_9, $x_8, $x_7, new $c_Lcom_raquo_laminar_modifiers_EventListener(this$11, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2$2) => {
    onNext$2.a3();
  })))]))))), state.xq.P());
  var $x_5 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$();
  var $x_4 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$();
  var $x_3 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Button$package$();
  var $x_2 = $m_sr_ScalaRunTime$();
  var $x_1 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Icons$().b6K($m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([]))));
  var this$14 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false));
  var onNext$3 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    commands.ap().a91.gZ((commands.ap(), $m_s_None$()), (commands.ap(), true));
  }));
  $m_Lcom_raquo_laminar_api_package$features$().cz();
  return $x_30.w($x_29.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_28, $x_27, $x_21, $x_15, $x_6, $x_5.u4($x_4.iZ($x_3.hH($x_2.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_1, new $c_Lcom_raquo_laminar_modifiers_EventListener(this$14, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2$3) => {
    onNext$3.a3();
  })))]))))), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_receivers_ChildOptionReceiver$()).gR($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), state.H5.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((en) => ((!(!en)) ? new $c_s_Some($m_Lorg_jpablo_graphexplorer_viewer_components_ZoomToolbar$package$().b9X(state)) : $m_s_None$()))), $m_s_None$())), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_receivers_ChildOptionReceiver$()).gR($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), state.abt, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((on) => ((!(!on)) ? new $c_s_Some($m_Lorg_jpablo_graphexplorer_viewer_components_ZoomToolbar$package$().b9W(state)) : $m_s_None$()))), $m_s_None$()))])));
});
$p.b9X = (function(state) {
  var $x_8 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$();
  var $x_7 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$();
  var $x_6 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$();
  var $x_5 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Button$package$();
  var $x_4 = $m_sr_ScalaRunTime$();
  var $x_3 = $m_Lcom_raquo_laminar_api_package$().b.eW().n("3D view (experimental)");
  var $x_2 = $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "3D", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7);
  var $x_1 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().aLC(state.CJ.P(), "bi bi-check-circle", "bi bi-circle");
  var this$3 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false));
  var onNext = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lcom_raquo_airstream_state_Var__update__F1__V(state.CJ, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => (!(!(!_$1))))));
  }));
  $m_Lcom_raquo_laminar_api_package$features$().cz();
  return $x_8.aLL($x_7.u4($x_6.iZ($x_5.hH($x_4.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_3, $x_2, $x_1, new $c_Lcom_raquo_laminar_modifiers_EventListener(this$3, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => {
    onNext.a3();
  })))]))))), state.CJ.P());
});
$p.b9W = (function(state) {
  var $x_10 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_9 = $m_sr_ScalaRunTime$();
  var $x_8 = $m_Lcom_raquo_laminar_api_package$().b.y.s("flex items-center gap-1");
  var $x_7 = $m_Lorg_jpablo_graphexplorer_viewer_components_ZoomToolbar$package$().b42(state);
  var $x_6 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$();
  var $x_5 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$();
  var $x_4 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Button$package$();
  var $x_3 = $m_sr_ScalaRunTime$();
  var $x_2 = $m_Lcom_raquo_laminar_api_package$().b.eW().n("Face the drawing straight-on (orthogonal to its plane)");
  var $x_1 = $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("bi bi-aspect-ratio")])));
  var this$3 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false));
  var onNext = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    state.abh.dn.bA((void 0));
  }));
  $m_Lcom_raquo_laminar_api_package$features$().cz();
  return $x_10.w($x_9.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_8, $x_7, $x_6.u4($x_5.iZ($x_4.hH($x_3.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_2, $x_1, new $c_Lcom_raquo_laminar_modifiers_EventListener(this$3, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => {
    onNext.a3();
  })))]))))), $m_Lorg_jpablo_graphexplorer_viewer_widgets_IconButton$package$().ON("bi-arrow-repeat", "Trackpad navigation: scroll orbits without clicking, pinch zooms (off: wheel zooms). \u2325 pans in both modes.", state.TV, "tooltip-top", $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([]))), $m_Lorg_jpablo_graphexplorer_viewer_widgets_IconButton$package$().ON("bi-person-video", "Labels face the camera (off: labels are fixed sheets facing the front view)", state.TT, "tooltip-top", $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([])))])));
});
$p.b42 = (function(state) {
  var $x_8 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$();
  var $x_7 = $m_sr_ScalaRunTime$();
  var $x_6 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_SelectVariant$().abD;
  var $x_5 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_SelectVariant$().abE;
  var $x_4 = $m_Lcom_raquo_laminar_api_package$().b.y.s("w-auto");
  var $x_3 = $m_Lcom_raquo_laminar_api_package$().b.eW().n("3D layout algorithm");
  var this$3 = $m_Lcom_raquo_laminar_api_package$().b;
  var this$2 = $m_Lorg_jpablo_graphexplorer_viewer_layout3d_Layout3D$().aaO;
  var f = ((algo) => $m_Lcom_raquo_laminar_api_package$().b.Jd().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.jx().n(algo.u6()), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, algo.aI(), $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))));
  if ((this$2 === $m_sci_Nil$())) {
    var $x_2 = $m_sci_Nil$();
  } else {
    var x0 = this$2.t();
    var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
    var t = h;
    var rest = this$2.v();
    while ((rest !== $m_sci_Nil$())) {
      var x0$1 = rest.t();
      var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
      t.U = nx;
      t = nx;
      rest = rest.v();
    }
    var $x_2 = h;
  }
  var $x_1 = $f_Lcom_raquo_laminar_api_Implicits__nodeSeqToModifier__O__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier(this$3, $x_2, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$());
  $m_Lcom_raquo_laminar_api_package$();
  var updater = $m_Lcom_raquo_laminar_api_package$().b.jx().bj(state.H6.P());
  var listener = new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.Eb(), false, false)).nC(), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((sink) => ((_$1) => {
    sink.bA(_$1);
  }))(state.H6.jA())));
  return $x_8.aet($x_7.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_6, $x_5, $x_4, $x_3, $x_1, $m_Lcom_raquo_laminar_inputs_InputController$().qU(listener, updater)])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_ZoomToolbar$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_ZoomToolbar$package$, "org.jpablo.graphexplorer.viewer.components.ZoomToolbar$package$", ({
  yS: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_ZoomToolbar$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_ZoomToolbar$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_ZoomToolbar$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_ZoomToolbar$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_ZoomToolbar$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_ZoomToolbar$package$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ArrowPreview$package$__rotationTransform$1__T__D__T($thiz, viewBox, angle) {
  matchResult1: {
    var \u03b41$___1;
    var \u03b41$___2;
    var \u03b41$___3;
    var \u03b41$___4;
    var xs = $f_T__split__T__I__AT(viewBox, " ", 0);
    var f = ((_$1) => $m_jl_Double$().bd(_$1));
    var len = xs.a.length;
    var ys = new $ac_D(len);
    if ((len > 0)) {
      var i = 0;
      if ((xs !== null)) {
        while ((i < len)) {
          var $x_1 = i;
          var x0 = xs.a[i];
          ys.a[$x_1] = (+f(x0));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_I)) {
        while ((i < len)) {
          var $x_2 = i;
          var x0$1 = xs.a[i];
          ys.a[$x_2] = (+f(x0$1));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_D)) {
        while ((i < len)) {
          var $x_3 = i;
          var x0$2 = xs.a[i];
          ys.a[$x_3] = (+f(x0$2));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_J)) {
        while ((i < len)) {
          var $x_6 = i;
          var $x_4 = xs.a;
          var $x_5 = (i << 1);
          var x0$3_$_lo = $x_4[$x_5];
          var x0$3_$_hi = $x_4[(($x_5 + 1) | 0)];
          ys.a[$x_6] = (+f($bL(x0$3_$_lo, x0$3_$_hi)));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_F)) {
        while ((i < len)) {
          var $x_7 = i;
          var x0$4 = xs.a[i];
          ys.a[$x_7] = (+f(x0$4));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_C)) {
        while ((i < len)) {
          var $x_8 = i;
          var x0$5 = xs.a[i];
          ys.a[$x_8] = (+f($bC(x0$5)));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_B)) {
        while ((i < len)) {
          var $x_9 = i;
          var x0$6 = xs.a[i];
          ys.a[$x_9] = (+f(x0$6));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_S)) {
        while ((i < len)) {
          var $x_10 = i;
          var x0$7 = xs.a[i];
          ys.a[$x_10] = (+f(x0$7));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_Z)) {
        while ((i < len)) {
          var $x_11 = i;
          var x0$8 = xs.a[i];
          ys.a[$x_11] = (+f(x0$8));
          i = ((1 + i) | 0);
        }
      } else {
        throw new $c_s_MatchError(xs);
      }
    }
    if (($m_s_Array$UnapplySeqWrapper$().u9(ys, 4) === 0)) {
      var \u03b41$___1 = ys.a[0];
      var \u03b41$___2 = ys.a[1];
      var \u03b41$___3 = ys.a[2];
      var \u03b41$___4 = ys.a[3];
      break matchResult1;
    }
    throw new $c_s_MatchError(ys);
  }
  var x$2 = (+\u03b41$___1);
  var y$2 = (+\u03b41$___2);
  var w$2 = (+\u03b41$___3);
  var h$2 = (+\u03b41$___4);
  var centerX = (x$2 + (0.5 * w$2));
  var centerY = (y$2 + (0.5 * h$2));
  return (((((("rotate(" + angle) + " ") + centerX) + " ") + centerY) + ")");
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ArrowPreview$package$__normal$1__I__I__Z__D__Lcom_raquo_laminar_nodes_ReactiveSvgElement($thiz, width$1, height$1, fill, angle) {
  return $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + width$1)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + height$1)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("10 0 41 20"), $m_Lcom_raquo_laminar_api_package$().b.j().dm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().mZ().n($p_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ArrowPreview$package$__rotationTransform$1__T__D__T($thiz, "10 0 41 20", angle)), $m_Lcom_raquo_laminar_api_package$().b.j().lp().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("arrow-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().lt().n("0"), $m_Lcom_raquo_laminar_api_package$().b.j().lv().n("10"), $m_Lcom_raquo_laminar_api_package$().b.j().lu().n("40"), $m_Lcom_raquo_laminar_api_package$().b.j().lw().n("10")]))), $m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("arrow-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("40,5 50,10 40,15"), $m_Lcom_raquo_laminar_api_package$().b.j().pI().n(("fill: " + (fill ? "currentColor" : "none")))])))])))])));
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ArrowPreview$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ArrowPreview$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ArrowPreview$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ArrowPreview$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ArrowPreview$package$.prototype = $p;
$p.aVD = (function(arrowType, width, height, angle) {
  var x = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__normal__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType();
  if (((x === null) ? (arrowType === null) : (x === arrowType))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $p_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ArrowPreview$package$__normal$1__I__I__Z__D__Lcom_raquo_laminar_nodes_ReactiveSvgElement(this, width, height, true, angle))));
  }
  var x$3 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__inv__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType();
  if (((x$3 === null) ? (arrowType === null) : (x$3 === arrowType))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + width)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + height)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("0 0 55 20"), $m_Lcom_raquo_laminar_api_package$().b.j().dm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().mZ().n($p_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ArrowPreview$package$__rotationTransform$1__T__D__T(this, "0 0 55 20", angle)), $m_Lcom_raquo_laminar_api_package$().b.j().lp().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("arrow-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().lt().n("0"), $m_Lcom_raquo_laminar_api_package$().b.j().lv().n("10"), $m_Lcom_raquo_laminar_api_package$().b.j().lu().n("40"), $m_Lcom_raquo_laminar_api_package$().b.j().lw().n("10")]))), $m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("arrow-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("50,5 40,10 50,15"), $m_Lcom_raquo_laminar_api_package$().b.j().pI().n("fill: currentColor;")])))])))]))))));
  }
  var x$5 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__dot__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType();
  if (((x$5 === null) ? (arrowType === null) : (x$5 === arrowType))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + width)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + height)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("0 0 50 20"), $m_Lcom_raquo_laminar_api_package$().b.j().dm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().mZ().n($p_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ArrowPreview$package$__rotationTransform$1__T__D__T(this, "0 0 50 20", angle)), $m_Lcom_raquo_laminar_api_package$().b.j().lp().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("arrow-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().lt().n("0"), $m_Lcom_raquo_laminar_api_package$().b.j().lv().n("10"), $m_Lcom_raquo_laminar_api_package$().b.j().lu().n("40"), $m_Lcom_raquo_laminar_api_package$().b.j().lw().n("10")]))), $m_Lcom_raquo_laminar_api_package$().b.j().DP().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("arrow-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().y6().n("40"), $m_Lcom_raquo_laminar_api_package$().b.j().y7().n("10"), $m_Lcom_raquo_laminar_api_package$().b.j().Ee().n("6"), $m_Lcom_raquo_laminar_api_package$().b.j().pI().n("fill: currentColor;")])))])))]))))));
  }
  var x$7 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__odot__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType();
  if (((x$7 === null) ? (arrowType === null) : (x$7 === arrowType))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + width)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + height)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("0 0 55 20"), $m_Lcom_raquo_laminar_api_package$().b.j().dm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().mZ().n($p_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ArrowPreview$package$__rotationTransform$1__T__D__T(this, "0 0 55 20", angle)), $m_Lcom_raquo_laminar_api_package$().b.j().lp().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("arrow-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().lt().n("0"), $m_Lcom_raquo_laminar_api_package$().b.j().lv().n("10"), $m_Lcom_raquo_laminar_api_package$().b.j().lu().n("40"), $m_Lcom_raquo_laminar_api_package$().b.j().lw().n("10")]))), $m_Lcom_raquo_laminar_api_package$().b.j().DP().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("arrow-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().y6().n("45"), $m_Lcom_raquo_laminar_api_package$().b.j().y7().n("10"), $m_Lcom_raquo_laminar_api_package$().b.j().Ee().n("6"), $m_Lcom_raquo_laminar_api_package$().b.j().wi().n("currentColor"), $m_Lcom_raquo_laminar_api_package$().b.j().AH().n("3"), $m_Lcom_raquo_laminar_api_package$().b.j().b1d().n("none")])))])))]))))));
  }
  var x$9 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__none__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType();
  if (((x$9 === null) ? (arrowType === null) : (x$9 === arrowType))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + width)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + height)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("0 0 50 20"), $m_Lcom_raquo_laminar_api_package$().b.j().dm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().mZ().n($p_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ArrowPreview$package$__rotationTransform$1__T__D__T(this, "0 0 50 20", angle)), $m_Lcom_raquo_laminar_api_package$().b.j().lp().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("arrow-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().lt().n("0"), $m_Lcom_raquo_laminar_api_package$().b.j().lv().n("10"), $m_Lcom_raquo_laminar_api_package$().b.j().lu().n("50"), $m_Lcom_raquo_laminar_api_package$().b.j().lw().n("10")])))])))]))))));
  }
  var x$11 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__tee__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType();
  if (((x$11 === null) ? (arrowType === null) : (x$11 === arrowType))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + width)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + height)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("0 0 50 20"), $m_Lcom_raquo_laminar_api_package$().b.j().dm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().mZ().n($p_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ArrowPreview$package$__rotationTransform$1__T__D__T(this, "0 0 50 20", angle)), $m_Lcom_raquo_laminar_api_package$().b.j().lp().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("arrow-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().lt().n("0"), $m_Lcom_raquo_laminar_api_package$().b.j().lv().n("10"), $m_Lcom_raquo_laminar_api_package$().b.j().lu().n("40"), $m_Lcom_raquo_laminar_api_package$().b.j().lw().n("10"), $m_Lcom_raquo_laminar_api_package$().b.j().wi().n("currentColor")]))), $m_Lcom_raquo_laminar_api_package$().b.j().lp().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("arrow-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().lt().n("40"), $m_Lcom_raquo_laminar_api_package$().b.j().lv().n("5"), $m_Lcom_raquo_laminar_api_package$().b.j().lu().n("40"), $m_Lcom_raquo_laminar_api_package$().b.j().lw().n("15"), $m_Lcom_raquo_laminar_api_package$().b.j().wi().n("currentColor")])))])))]))))));
  }
  var x$13 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__onormal__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType();
  if (((x$13 === null) ? (arrowType === null) : (x$13 === arrowType))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $p_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ArrowPreview$package$__normal$1__I__I__Z__D__Lcom_raquo_laminar_nodes_ReactiveSvgElement(this, width, height, false, angle))));
  }
  var x$15 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__diamond__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType();
  if (((x$15 === null) ? (arrowType === null) : (x$15 === arrowType))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + width)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + height)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("0 0 55 20"), $m_Lcom_raquo_laminar_api_package$().b.j().dm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().mZ().n($p_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ArrowPreview$package$__rotationTransform$1__T__D__T(this, "0 0 55 20", angle)), $m_Lcom_raquo_laminar_api_package$().b.j().lp().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("arrow-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().lt().n("0"), $m_Lcom_raquo_laminar_api_package$().b.j().lv().n("10"), $m_Lcom_raquo_laminar_api_package$().b.j().lu().n("35"), $m_Lcom_raquo_laminar_api_package$().b.j().lw().n("10"), $m_Lcom_raquo_laminar_api_package$().b.j().wi().n("currentColor")]))), $m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("arrow-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("35,10 42,5 49,10 42,15"), $m_Lcom_raquo_laminar_api_package$().b.j().pI().n("fill: currentColor;")])))])))]))))));
  }
  var x$17 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__odiamond__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType();
  if (((x$17 === null) ? (arrowType === null) : (x$17 === arrowType))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + width)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + height)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("0 0 55 20"), $m_Lcom_raquo_laminar_api_package$().b.j().dm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().mZ().n($p_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ArrowPreview$package$__rotationTransform$1__T__D__T(this, "0 0 55 20", angle)), $m_Lcom_raquo_laminar_api_package$().b.j().lp().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("arrow-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().lt().n("0"), $m_Lcom_raquo_laminar_api_package$().b.j().lv().n("10"), $m_Lcom_raquo_laminar_api_package$().b.j().lu().n("35"), $m_Lcom_raquo_laminar_api_package$().b.j().lw().n("10")]))), $m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("arrow-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("35,10 42,5 49,10 42,15"), $m_Lcom_raquo_laminar_api_package$().b.j().pI().n("fill: none; stroke-width: 1.5px;")])))])))]))))));
  }
  var x$19 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__crow__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType();
  if (((x$19 === null) ? (arrowType === null) : (x$19 === arrowType))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + width)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + height)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("0 0 55 15"), $m_Lcom_raquo_laminar_api_package$().b.j().dm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().mZ().n($p_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ArrowPreview$package$__rotationTransform$1__T__D__T(this, "0 0 55 15", angle)), $m_Lcom_raquo_laminar_api_package$().b.j().pC().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("arrow-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().qV().n("M0 7.10C12.35 7.10 26.11 7.10 39.29 7.10")]))), $m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("arrow-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("39.23 7.10 55.00 0.00 47.65 7.10 54.48 7.10 54.48 7.10 54.48 7.10 47.65 7.10 55.00 14.19 39.23 7.10")])))])))]))))));
  }
  var x$21 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__box__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType();
  if (((x$21 === null) ? (arrowType === null) : (x$21 === arrowType))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + width)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + height)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("0 0 50 20"), $m_Lcom_raquo_laminar_api_package$().b.j().dm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().mZ().n($p_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ArrowPreview$package$__rotationTransform$1__T__D__T(this, "0 0 50 20", angle)), $m_Lcom_raquo_laminar_api_package$().b.j().lp().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("arrow-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().lt().n("0"), $m_Lcom_raquo_laminar_api_package$().b.j().lv().n("10"), $m_Lcom_raquo_laminar_api_package$().b.j().lu().n("35"), $m_Lcom_raquo_laminar_api_package$().b.j().lw().n("10")]))), $m_Lcom_raquo_laminar_api_package$().b.j().a4s().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("arrow-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().Eq().n("35"), $m_Lcom_raquo_laminar_api_package$().b.j().Er().n("5"), $m_Lcom_raquo_laminar_api_package$().b.j().bh().n("10"), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n("10"), $m_Lcom_raquo_laminar_api_package$().b.j().pI().n("fill: currentColor")])))])))]))))));
  }
  var x$23 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__obox__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType();
  if (((x$23 === null) ? (arrowType === null) : (x$23 === arrowType))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + width)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + height)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("0 0 55 20"), $m_Lcom_raquo_laminar_api_package$().b.j().dm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().mZ().n($p_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ArrowPreview$package$__rotationTransform$1__T__D__T(this, "0 0 55 20", angle)), $m_Lcom_raquo_laminar_api_package$().b.j().lp().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("arrow-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().lt().n("0"), $m_Lcom_raquo_laminar_api_package$().b.j().lv().n("10"), $m_Lcom_raquo_laminar_api_package$().b.j().lu().n("35"), $m_Lcom_raquo_laminar_api_package$().b.j().lw().n("10")]))), $m_Lcom_raquo_laminar_api_package$().b.j().a4s().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("arrow-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().Eq().n("35"), $m_Lcom_raquo_laminar_api_package$().b.j().Er().n("5"), $m_Lcom_raquo_laminar_api_package$().b.j().bh().n("10"), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n("10"), $m_Lcom_raquo_laminar_api_package$().b.j().pI().n("fill: none")])))])))]))))));
  }
  var x$25 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__halfvee__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType();
  if (((x$25 === null) ? (arrowType === null) : (x$25 === arrowType))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + width)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + height)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("0 0 55 20"), $m_Lcom_raquo_laminar_api_package$().b.j().dm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().mZ().n($p_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ArrowPreview$package$__rotationTransform$1__T__D__T(this, "0 0 55 20", angle)), $m_Lcom_raquo_laminar_api_package$().b.j().pC().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("arrow-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().qV().n("M0 7.07C12.44 7.07 26.29 7.07 39.59 7.07")]))), $m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("arrow-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("55 7.07 39.30 0 47.49 7.07 39.30 7.07 39.30 7.07 55 7.07")])))])))]))))));
  }
  var x$27 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__vee__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType();
  if (((x$27 === null) ? (arrowType === null) : (x$27 === arrowType))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + width)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + height)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("65 -23 25 10"), $m_Lcom_raquo_laminar_api_package$().b.j().dm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().mZ().n($p_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ArrowPreview$package$__rotationTransform$1__T__D__T(this, "65 -23 25 10", angle)), $m_Lcom_raquo_laminar_api_package$().b.j().pC().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("arrow-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().qV().n("M54.4,-18C61.97,-18 70.38,-18 88,-18")]))), $m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("arrow-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("88.4,-18 78.4,-22.5 84.62,-18 78.4,-18 78.4,-18 78.4,-18 84.62,-18 78.4,-13.5 88.4,-18")])))])))]))))));
  }
  var x$29 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__curve__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType();
  if (((x$29 === null) ? (arrowType === null) : (x$29 === arrowType))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + width)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + height)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("65 -23 25 10"), $m_Lcom_raquo_laminar_api_package$().b.j().dm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().mZ().n($p_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ArrowPreview$package$__rotationTransform$1__T__D__T(this, "65 -23 25 10", angle)), $m_Lcom_raquo_laminar_api_package$().b.j().pC().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("arrow-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().qV().n("M54.4,-18C62.23,-18 70.96,-18 79.32,-18")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("arrow-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("89.62,-18 79.12,-18")]))), $m_Lcom_raquo_laminar_api_package$().b.j().pC().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("arrow-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().pI().n("fill: none"), $m_Lcom_raquo_laminar_api_package$().b.j().qV().n("M84.12,-13C90.78,-13 90.78,-23 84.12,-23")])))])))]))))));
  }
  throw new $c_s_MatchError(arrowType);
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ArrowPreview$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ArrowPreview$package$, "org.jpablo.graphexplorer.viewer.components.attributes.previews.ArrowPreview$package$", ({
  yT: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ArrowPreview$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ArrowPreview$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ArrowPreview$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ArrowPreview$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ArrowPreview$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ArrowPreview$package$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ArrowStylePreview$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ArrowStylePreview$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ArrowStylePreview$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ArrowStylePreview$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ArrowStylePreview$package$.prototype = $p;
$p.aVE = (function(style, width, height) {
  var x = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$__solid__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle();
  if (((x === null) ? (style === null) : (x === style))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + width)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + height)), $m_Lcom_raquo_laminar_api_package$().b.j().lp().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().lt().n("0"), $m_Lcom_raquo_laminar_api_package$().b.j().lv().n(("" + (((height + ((height >>> 31) | 0)) | 0) >> 1))), $m_Lcom_raquo_laminar_api_package$().b.j().lu().n(("" + width)), $m_Lcom_raquo_laminar_api_package$().b.j().lw().n(("" + (((height + ((height >>> 31) | 0)) | 0) >> 1))), $m_Lcom_raquo_laminar_api_package$().b.j().wi().n("currentColor"), $m_Lcom_raquo_laminar_api_package$().b.j().AH().n("2")])))]))))));
  }
  var x$3 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$__dashed__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle();
  if (((x$3 === null) ? (style === null) : (x$3 === style))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + width)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + height)), $m_Lcom_raquo_laminar_api_package$().b.j().lp().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().lt().n("0"), $m_Lcom_raquo_laminar_api_package$().b.j().lv().n(("" + (((height + ((height >>> 31) | 0)) | 0) >> 1))), $m_Lcom_raquo_laminar_api_package$().b.j().lu().n(("" + width)), $m_Lcom_raquo_laminar_api_package$().b.j().lw().n(("" + (((height + ((height >>> 31) | 0)) | 0) >> 1))), $m_Lcom_raquo_laminar_api_package$().b.j().wi().n("currentColor"), $m_Lcom_raquo_laminar_api_package$().b.j().AH().n("2"), $m_Lcom_raquo_laminar_api_package$().b.j().a4M().n("5,2")])))]))))));
  }
  var x$5 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$__dotted__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle();
  if (((x$5 === null) ? (style === null) : (x$5 === style))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + width)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + height)), $m_Lcom_raquo_laminar_api_package$().b.j().lp().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().lt().n("0"), $m_Lcom_raquo_laminar_api_package$().b.j().lv().n(("" + (((height + ((height >>> 31) | 0)) | 0) >> 1))), $m_Lcom_raquo_laminar_api_package$().b.j().lu().n(("" + width)), $m_Lcom_raquo_laminar_api_package$().b.j().lw().n(("" + (((height + ((height >>> 31) | 0)) | 0) >> 1))), $m_Lcom_raquo_laminar_api_package$().b.j().wi().n("currentColor"), $m_Lcom_raquo_laminar_api_package$().b.j().AH().n("2"), $m_Lcom_raquo_laminar_api_package$().b.j().a4M().n("1,5")])))]))))));
  }
  var x$7 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$__bold__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle();
  if (((x$7 === null) ? (style === null) : (x$7 === style))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + width)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + height)), $m_Lcom_raquo_laminar_api_package$().b.j().lp().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().lt().n("0"), $m_Lcom_raquo_laminar_api_package$().b.j().lv().n(("" + (((height + ((height >>> 31) | 0)) | 0) >> 1))), $m_Lcom_raquo_laminar_api_package$().b.j().lu().n(("" + width)), $m_Lcom_raquo_laminar_api_package$().b.j().lw().n(("" + (((height + ((height >>> 31) | 0)) | 0) >> 1))), $m_Lcom_raquo_laminar_api_package$().b.j().wi().n("currentColor"), $m_Lcom_raquo_laminar_api_package$().b.j().AH().n("4")])))]))))));
  }
  var x$9 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$__tapered__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle();
  if (((x$9 === null) ? (style === null) : (x$9 === style))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((taperedSVG) => (() => $m_Lorg_jpablo_graphexplorer_viewer_domUtils_SvgParser$package$().XH(taperedSVG)))($m_sc_StringOps$().aSv("<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?>\n          |<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n          |<svg width=\"28px\" height=\"20px\" viewBox=\"0 0 16 1\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xml:space=\"preserve\" xmlns:serif=\"http://www.serif.com/\" style=\"fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;\">\n          |    <g transform=\"matrix(1,0,0,1,-1.06429,-80.4635)\">\n          |        <g id=\"Artboard4\" transform=\"matrix(0.912884,0,0,0.32278,0.269693,54.8034)\">\n          |            <rect x=\"0.87\" y=\"79.497\" width=\"17.08\" height=\"3.401\" style=\"fill:none;\"/>\n          |            <g transform=\"matrix(0.715621,0,0,2.32599,-38.0352,123.069)\">\n          |                <path d=\"M54.4,-18L55.53,-18.05L56.67,-18.1L57.82,-18.14L58.98,-18.19L60.15,-18.24L62.51,-18.34L63.7,-18.39L66.1,-18.49L67.31,-18.46L68.51,-18.41L69.73,-18.36L70.94,-18.31L72.15,-18.25L73.36,-18.2L74.58,-18.15L75.79,-18.1L76.99,-18.05L78.2,-18L76.99,-17.95L75.79,-17.9L74.58,-17.85L73.36,-17.8L72.15,-17.75L70.94,-17.69L69.73,-17.64L68.51,-17.59L67.31,-17.54L66.1,-17.51L63.7,-17.61L62.51,-17.66L60.15,-17.76L58.98,-17.81L57.82,-17.86L56.67,-17.9L55.53,-17.95L54.4,-18Z\" style=\"fill-rule:nonzero;\"/>\n          |            </g>\n          |        </g>\n          |    </g>\n          |</svg>\n          |", 124))));
  }
  var x$11 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$__invis__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle();
  if (((x$11 === null) ? (style === null) : (x$11 === style))) {
    return $m_s_None$();
  }
  throw new $c_s_MatchError(style);
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ArrowStylePreview$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ArrowStylePreview$package$, "org.jpablo.graphexplorer.viewer.components.attributes.previews.ArrowStylePreview$package$", ({
  yU: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ArrowStylePreview$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ArrowStylePreview$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ArrowStylePreview$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ArrowStylePreview$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ArrowStylePreview$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ArrowStylePreview$package$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_BorderStylePreview$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_BorderStylePreview$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_BorderStylePreview$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_BorderStylePreview$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_BorderStylePreview$package$.prototype = $p;
$p.aVJ = (function(style, width, height) {
  var x = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$__solid__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle();
  if (((x === null) ? (style === null) : (x === style))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + width)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + height)), $m_Lcom_raquo_laminar_api_package$().b.j().lp().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().lt().n("0"), $m_Lcom_raquo_laminar_api_package$().b.j().lv().n(("" + (((height + ((height >>> 31) | 0)) | 0) >> 1))), $m_Lcom_raquo_laminar_api_package$().b.j().lu().n(("" + width)), $m_Lcom_raquo_laminar_api_package$().b.j().lw().n(("" + (((height + ((height >>> 31) | 0)) | 0) >> 1))), $m_Lcom_raquo_laminar_api_package$().b.j().wi().n("currentColor"), $m_Lcom_raquo_laminar_api_package$().b.j().AH().n("2")])))]))))));
  }
  var x$3 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$__dashed__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle();
  if (((x$3 === null) ? (style === null) : (x$3 === style))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + width)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + height)), $m_Lcom_raquo_laminar_api_package$().b.j().lp().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().lt().n("0"), $m_Lcom_raquo_laminar_api_package$().b.j().lv().n(("" + (((height + ((height >>> 31) | 0)) | 0) >> 1))), $m_Lcom_raquo_laminar_api_package$().b.j().lu().n(("" + width)), $m_Lcom_raquo_laminar_api_package$().b.j().lw().n(("" + (((height + ((height >>> 31) | 0)) | 0) >> 1))), $m_Lcom_raquo_laminar_api_package$().b.j().wi().n("currentColor"), $m_Lcom_raquo_laminar_api_package$().b.j().AH().n("2"), $m_Lcom_raquo_laminar_api_package$().b.j().a4M().n("5,2")])))]))))));
  }
  var x$5 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$__dotted__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle();
  if (((x$5 === null) ? (style === null) : (x$5 === style))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + width)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + height)), $m_Lcom_raquo_laminar_api_package$().b.j().lp().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().lt().n("0"), $m_Lcom_raquo_laminar_api_package$().b.j().lv().n(("" + (((height + ((height >>> 31) | 0)) | 0) >> 1))), $m_Lcom_raquo_laminar_api_package$().b.j().lu().n(("" + width)), $m_Lcom_raquo_laminar_api_package$().b.j().lw().n(("" + (((height + ((height >>> 31) | 0)) | 0) >> 1))), $m_Lcom_raquo_laminar_api_package$().b.j().wi().n("currentColor"), $m_Lcom_raquo_laminar_api_package$().b.j().AH().n("2"), $m_Lcom_raquo_laminar_api_package$().b.j().a4M().n("1,5")])))]))))));
  }
  throw new $c_s_MatchError(style);
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_BorderStylePreview$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_BorderStylePreview$package$, "org.jpablo.graphexplorer.viewer.components.attributes.previews.BorderStylePreview$package$", ({
  yV: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_BorderStylePreview$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_BorderStylePreview$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_BorderStylePreview$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_BorderStylePreview$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_BorderStylePreview$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_BorderStylePreview$package$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_CornerPreview$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_CornerPreview$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_CornerPreview$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_CornerPreview$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_CornerPreview$package$.prototype = $p;
$p.aLq = (function(corner) {
  var x = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$__rounded__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle();
  if (((x === null) ? (corner === null) : (x === corner))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_CornerPreview$package$().b7Z("17px", "17px"))));
  }
  var x$3 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$__diagonals__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle();
  if (((x$3 === null) ? (corner === null) : (x$3 === corner))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_CornerPreview$package$().aZT("17px", "17px"))));
  }
  var x$5 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$__normal__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle();
  if (((x$5 === null) ? (corner === null) : (x$5 === corner))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_CornerPreview$package$().b58("17px", "17px"))));
  }
  throw new $c_s_MatchError(corner);
});
$p.b7Z = (function(width, height) {
  return $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(width), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(height), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("70 -38 26 26"), $m_Lcom_raquo_laminar_api_package$().b.j().a5l().n("http://www.w3.org/2000/svg"), $m_Lcom_raquo_laminar_api_package$().b.j().pC().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().qV().n("M94,-36 L84,-36 C78,-36 72,-30 72,-24 L72,-14"), $m_Lcom_raquo_laminar_api_package$().b.j().pI().n("fill:none;stroke:black;stroke-width:1px; vector-effect: non-scaling-stroke;")])))])));
});
$p.aZT = (function(width, height) {
  return $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(width), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(height), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("142 -38 26 26"), $m_Lcom_raquo_laminar_api_package$().b.j().a5l().n("http://www.w3.org/2000/svg"), $m_Lcom_raquo_laminar_api_package$().b.j().pC().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().qV().n("M166,-36 L144,-36 L144,-14 M156,-36 L144,-24"), $m_Lcom_raquo_laminar_api_package$().b.j().pI().n("fill:none;stroke:black;stroke-width:1px; vector-effect: non-scaling-stroke;")])))])));
});
$p.b58 = (function(width, height) {
  return $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(width), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(height), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("0 0 17 17"), $m_Lcom_raquo_laminar_api_package$().b.j().a5l().n("http://www.w3.org/2000/svg"), $m_Lcom_raquo_laminar_api_package$().b.j().pC().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().qV().n("M 15 2 L 2 2 L 2 15"), $m_Lcom_raquo_laminar_api_package$().b.j().pI().n("fill:none;stroke:black;stroke-width:1px;stroke-linejoin:miter; vector-effect: non-scaling-stroke;")])))])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_CornerPreview$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_CornerPreview$package$, "org.jpablo.graphexplorer.viewer.components.attributes.previews.CornerPreview$package$", ({
  yW: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_CornerPreview$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_CornerPreview$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_CornerPreview$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_CornerPreview$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_CornerPreview$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_CornerPreview$package$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ShapePreview$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ShapePreview$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ShapePreview$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ShapePreview$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ShapePreview$package$.prototype = $p;
$p.aLB = (function(shape, w, h) {
  matchAlts7: {
    matchAlts8: {
      var x = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__box__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
      if (((x === null) ? (shape === null) : (x === shape))) {
        break matchAlts8;
      }
      var x$3 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__rectangle__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
      if (((x$3 === null) ? (shape === null) : (x$3 === shape))) {
        break matchAlts8;
      }
      var x$5 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__rect__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
      if (((x$5 === null) ? (shape === null) : (x$5 === shape))) {
        break matchAlts8;
      }
      break matchAlts7;
    }
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("0 0 24 16"), $m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("2,2 22,2 22,14 2,14 2,2")])))]))))));
  }
  var x$7 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__square__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$7 === null) ? (shape === null) : (x$7 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("0 0 24 24"), $m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("2,2 22,2 22,22 2,22 2,2")])))]))))));
  }
  var x$9 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__circle__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$9 === null) ? (shape === null) : (x$9 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("0 0 24 24"), $m_Lcom_raquo_laminar_api_package$().b.j().afq().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().y6().n("12"), $m_Lcom_raquo_laminar_api_package$().b.j().y7().n("12"), $m_Lcom_raquo_laminar_api_package$().b.j().ahO().n("11"), $m_Lcom_raquo_laminar_api_package$().b.j().ahP().n("11")])))]))))));
  }
  matchAlts5: {
    matchAlts6: {
      var x$11 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__ellipse__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
      if (((x$11 === null) ? (shape === null) : (x$11 === shape))) {
        break matchAlts6;
      }
      var x$13 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__oval__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
      if (((x$13 === null) ? (shape === null) : (x$13 === shape))) {
        break matchAlts6;
      }
      break matchAlts5;
    }
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("0 0 24 16"), $m_Lcom_raquo_laminar_api_package$().b.j().afq().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().y6().n("12"), $m_Lcom_raquo_laminar_api_package$().b.j().y7().n("8"), $m_Lcom_raquo_laminar_api_package$().b.j().ahO().n("11"), $m_Lcom_raquo_laminar_api_package$().b.j().ahP().n("7")])))]))))));
  }
  var x$15 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__point__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$15 === null) ? (shape === null) : (x$15 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("0 0 24 24"), $m_Lcom_raquo_laminar_api_package$().b.j().DP().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().y6().n("12"), $m_Lcom_raquo_laminar_api_package$().b.j().y7().n("12"), $m_Lcom_raquo_laminar_api_package$().b.j().Ee().n("3")])))]))))));
  }
  var x$17 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__none__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$17 === null) ? (shape === null) : (x$17 === shape))) {
    return $m_s_None$();
  }
  matchAlts3: {
    matchAlts4: {
      var x$19 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__polygon__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
      if (((x$19 === null) ? (shape === null) : (x$19 === shape))) {
        break matchAlts4;
      }
      var x$21 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__pentagon__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
      if (((x$21 === null) ? (shape === null) : (x$21 === shape))) {
        break matchAlts4;
      }
      var x$23 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__hexagon__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
      if (((x$23 === null) ? (shape === null) : (x$23 === shape))) {
        break matchAlts4;
      }
      var x$25 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__septagon__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
      if (((x$25 === null) ? (shape === null) : (x$25 === shape))) {
        break matchAlts4;
      }
      var x$27 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__octagon__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
      if (((x$27 === null) ? (shape === null) : (x$27 === shape))) {
        break matchAlts4;
      }
      break matchAlts3;
    }
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("0 0 24 22"), $m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("23.41,8.29 12,0 0.59,8.29 4.95,21.71 19.05,21.71")])))]))))));
  }
  var x$29 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__triangle__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$29 === null) ? (shape === null) : (x$29 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("0 0 24 16"), $m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("12,2 22,14 2,14 12,2")])))]))))));
  }
  var x$31 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__diamond__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$31 === null) ? (shape === null) : (x$31 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("0 0 24 16"), $m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("12,2 2,8 12,14 22,8 12,2")])))]))))));
  }
  var x$33 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__star__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$33 === null) ? (shape === null) : (x$33 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("166 -607 91 87"), $m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("256.06,-573.65 222.04,-573.65 211.52,-606.01 201.01,-573.65 166.98,-573.65 194.51,-553.65 184,-521.29 211.52,-541.29 239.05,-521.29 228.54,-553.65 256.06,-573.65")])))]))))));
  }
  var x$35 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__invtriangle__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$35 === null) ? (shape === null) : (x$35 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("0 0 24 16"), $m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("12,14 22,2 2,2 12,14")])))]))))));
  }
  var x$37 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__invtrapezium__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$37 === null) ? (shape === null) : (x$37 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("0 0 24 16"), $m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("2,2 22,2 19,14 5,14 2,2")])))]))))));
  }
  var x$39 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__invhouse__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$39 === null) ? (shape === null) : (x$39 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("745 -367 85 42"), $m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("745.88,-341.13 787.52,-325.58 829.17,-341.13 829.13,-366.29 745.92,-366.29 745.88,-341.13")])))]))))));
  }
  var x$41 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__trapezium__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$41 === null) ? (shape === null) : (x$41 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("0 0 24 16"), $m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("5,2 19,2 22,14 2,14 5,2")])))]))))));
  }
  var x$43 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__parallelogram__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$43 === null) ? (shape === null) : (x$43 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("0 -267 136 55"), $m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("135.05,-266.65 27.63,-266.65 0,-212.65 107.42,-212.65 135.05,-266.65")])))]))))));
  }
  var x$45 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__house__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$45 === null) ? (shape === null) : (x$45 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("-0.5 0 25 16"), $m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("23.85,5.92 12,0 0.15,5.92 0.16,15.52 23.84,15.52 23.85,5.92")])))]))))));
  }
  var x$47 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__doublecircle__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$47 === null) ? (shape === null) : (x$47 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("0 0 24 24"), $m_Lcom_raquo_laminar_api_package$().b.j().dm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().DP().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().y6().n("12"), $m_Lcom_raquo_laminar_api_package$().b.j().y7().n("12"), $m_Lcom_raquo_laminar_api_package$().b.j().Ee().n("11")]))), $m_Lcom_raquo_laminar_api_package$().b.j().DP().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().y6().n("12"), $m_Lcom_raquo_laminar_api_package$().b.j().y7().n("12"), $m_Lcom_raquo_laminar_api_package$().b.j().Ee().n("8")])))])))]))))));
  }
  matchAlts1: {
    matchAlts2: {
      var x$49 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__doubleoctagon__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
      if (((x$49 === null) ? (shape === null) : (x$49 === shape))) {
        break matchAlts2;
      }
      var x$51 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__tripleoctagon__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
      if (((x$51 === null) ? (shape === null) : (x$51 === shape))) {
        break matchAlts2;
      }
      break matchAlts1;
    }
    var x$54 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__doubleoctagon__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((rings) => (() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("0 0 24 24"), $m_Lcom_raquo_laminar_api_package$().b.j().dm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__nodeSeqToModifier__O__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, new $c_sci_Range$Exclusive(0, rings, 1).PD(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((i) => {
      var i$1 = (i | 0);
      var radius = (11.0 - (2.0 * i$1));
      return $m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n($f_sc_IterableOnceOps__mkString__T__T__T__T(new $c_sci_Range$Exclusive(0, 8, 1).PD(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((j) => {
        var j$1 = (j | 0);
        var angle = ((-1.5707963267948966) + (0.125 * (3.141592653589793 * (j$1 << 1))));
        var x$1 = (12.0 + (radius * (+Math.cos(angle))));
        var y = (12.0 + (radius * (+Math.sin(angle))));
        var x$2 = (10.0 * x$1);
        var $x_2 = $m_RTLong$().d1((+Math.round(x$2)));
        var x$4_$_lo = $x_2.l;
        var x$4_$_hi = $x_2.h;
        var x$6 = (10.0 * y);
        var $x_1 = $m_RTLong$().d1((+Math.round(x$6)));
        var x$8_$_lo = $x_1.l;
        var x$8_$_hi = $x_1.h;
        return (((((4.294967296E9 * x$4_$_hi) + (x$4_$_lo >>> 0.0)) / 10.0) + ",") + (((4.294967296E9 * x$8_$_hi) + (x$8_$_lo >>> 0.0)) / 10.0));
      }))), "", " ", ""))])));
    }))), $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())])))])))))((((shape === null) ? (x$54 === null) : (shape === x$54)) ? 2 : 3))));
  }
  var x$55 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__Mdiamond__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$55 === null) ? (shape === null) : (x$55 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("0 0 24 16"), $m_Lcom_raquo_laminar_api_package$().b.j().dm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("11.84,0.55 0,7.45 11.84,14.36 23.68,7.45 11.84,0.55")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("4.13,4.91 4.13,10")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("7.74,12.18 15.94,12.18")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("19.55,10 19.55,4.91")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("15.94,2.64 7.74,2.64")])))])))]))))));
  }
  var x$57 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__Msquare__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$57 === null) ? (shape === null) : (x$57 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("0 0 24 25"), $m_Lcom_raquo_laminar_api_package$().b.j().dm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("24,0.39 0,0.39 0,24.39 24,24.39 24,0.39")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("5.24,0.39 0,5.63")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("0,19.15 5.24,24.39")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("18.76,24.39 24,19.15")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("24,5.63 18.76,0.39")])))])))]))))));
  }
  var x$59 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__Mcircle__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$59 === null) ? (shape === null) : (x$59 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("326 -485 60 60"), $m_Lcom_raquo_laminar_api_package$().b.j().dm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().afq().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().y6().n("355.52"), $m_Lcom_raquo_laminar_api_package$().b.j().y7().n("-455.65"), $m_Lcom_raquo_laminar_api_package$().b.j().ahO().n("28.66"), $m_Lcom_raquo_laminar_api_package$().b.j().ahP().n("28.66")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("374.48,-477.15 336.57,-477.15")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("374.48,-434.16 336.57,-434.16")])))])))]))))));
  }
  var x$61 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__Mrecord__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$61 === null) ? (shape === null) : (x$61 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("0 0 20 16"), $m_Lcom_raquo_laminar_api_package$().b.j().pC().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().qV().n("M5.24,15.89C5.24,15.89 13.96,15.89 13.96,15.89 16.58,15.89 18.76,13.71 18.76,11.09 18.76,11.09 18.76,5.51 18.76,5.51 18.76,2.89 16.58,0.71 13.96,0.71 13.96,0.71 5.24,0.71 5.24,0.71 2.62,0.71 0.44,2.89 0.44,5.51 0.44,5.51 0.44,11.09 0.44,11.09 0.44,13.71 2.62,15.89 5.24,15.89")])))]))))));
  }
  var x$63 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__egg__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$63 === null) ? (shape === null) : (x$63 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("38 -150 60 37"), $m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("70.18,-113.7 71.94,-113.8 75.41,-114.14 78.74,-114.68 81.89,-115.4 84.81,-116.3 87.45,-117.37 89.79,-118.59 91.79,-119.96 93.43,-121.45 94.7,-123.06 95.59,-124.76 96.11,-126.54 96.27,-128.37 96.07,-130.24 95.55,-132.12 94.73,-134 93.63,-135.86 92.29,-137.66 90.74,-139.41 89.01,-141.06 87.12,-142.62 85.11,-144.05 83,-145.35 80.82,-146.49 78.57,-147.48 76.29,-148.29 73.97,-148.92 71.63,-149.36 69.29,-149.6 66.94,-149.65 64.59,-149.51 62.24,-149.16 59.92,-148.63 57.61,-147.91 55.35,-147.01 53.13,-145.94 50.98,-144.71 48.92,-143.35 46.97,-141.85 45.15,-140.25 43.51,-138.54 42.06,-136.77 40.83,-134.93 39.87,-133.07 39.19,-131.18 38.83,-129.3 38.81,-127.45 39.15,-125.64 39.85,-123.9 40.94,-122.25 42.39,-120.69 44.22,-119.26 46.39,-117.96 48.88,-116.81 51.67,-115.83 54.71,-115.02 57.96,-114.39 61.36,-113.95 64.86,-113.7 68.41,-113.65")])))]))))));
  }
  var x$65 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__cylinder__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$65 === null) ? (shape === null) : (x$65 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("472 -582 55 37"), $m_Lcom_raquo_laminar_api_package$().b.j().dm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().pC().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().qV().n("M526.52,-578.38C526.52,-580.19 514.42,-581.65 499.52,-581.65 484.63,-581.65 472.52,-580.19 472.52,-578.38 472.52,-578.38 472.52,-548.93 472.52,-548.93 472.52,-547.12 484.63,-545.65 499.52,-545.65 514.42,-545.65 526.52,-547.12 526.52,-548.93 526.52,-548.93 526.52,-578.38 526.52,-578.38")]))), $m_Lcom_raquo_laminar_api_package$().b.j().pC().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().qV().n("M526.52,-578.38C526.52,-576.58 514.42,-575.11 499.52,-575.11 484.63,-575.11 472.52,-576.58 472.52,-578.38")])))])))]))))));
  }
  var x$67 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__note__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$67 === null) ? (shape === null) : (x$67 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("616 -582 55 37"), $m_Lcom_raquo_laminar_api_package$().b.j().dm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("664.52,-581.65 616.52,-581.65 616.52,-545.65 670.52,-545.65 670.52,-575.65 664.52,-581.65")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("664.52,-581.65 664.52,-575.65")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("670.52,-575.65 664.52,-575.65")])))])))]))))));
  }
  var x$69 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__tab__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$69 === null) ? (shape === null) : (x$69 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("760 -586 55 41"), $m_Lcom_raquo_laminar_api_package$().b.j().dm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("814.52,-581.65 772.52,-581.65 772.52,-585.65 760.52,-585.65 760.52,-545.65 814.52,-545.65 814.52,-581.65")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("760.52,-581.65 772.52,-581.65")])))])))]))))));
  }
  var x$71 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__folder__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$71 === null) ? (shape === null) : (x$71 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("40 -694 55 41"), $m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("94.52,-689.65 91.52,-693.65 70.52,-693.65 67.52,-689.65 40.52,-689.65 40.52,-653.65 94.52,-653.65 94.52,-689.65")])))]))))));
  }
  var x$73 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__box3d__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$73 === null) ? (shape === null) : (x$73 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("184 -690 55 37"), $m_Lcom_raquo_laminar_api_package$().b.j().dm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("238.52,-689.65 188.52,-689.65 184.52,-685.65 184.52,-653.65 234.52,-653.65 238.52,-657.65 238.52,-689.65")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("234.52,-685.65 184.52,-685.65")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("234.52,-685.65 234.52,-653.65")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("234.52,-685.65 238.52,-689.65")])))])))]))))));
  }
  var x$75 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__component__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$75 === null) ? (shape === null) : (x$75 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("462 -690 71 37"), $m_Lcom_raquo_laminar_api_package$().b.j().dm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("532.26,-689.65 466.79,-689.65 466.79,-685.65 462.79,-685.65 462.79,-681.65 466.79,-681.65 466.79,-661.65 462.79,-661.65 462.79,-657.65 466.79,-657.65 466.79,-653.65 532.26,-653.65 532.26,-689.65")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("466.79,-685.65 470.79,-685.65 470.79,-681.65 466.79,-681.65")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("466.79,-661.65 470.79,-661.65 470.79,-657.65 466.79,-657.65")])))])))]))))));
  }
  var x$77 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__rarrow__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$77 === null) ? (shape === null) : (x$77 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("328 -1014 55 37"), $m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("364.52,-1007.65 328.52,-1007.65 328.52,-983.65 364.52,-983.65 364.52,-977.65 382.52,-995.65 364.52,-1013.65 364.52,-1007.65")])))]))))));
  }
  var x$79 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__larrow__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$79 === null) ? (shape === null) : (x$79 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("472 -1014 55 37"), $m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("526.52,-1007.65 490.52,-1007.65 490.52,-1013.65 472.52,-995.65 490.52,-977.65 490.52,-983.65 526.52,-983.65 526.52,-1007.65")])))]))))));
  }
  var x$81 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__lpromoter__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$81 === null) ? (shape === null) : (x$81 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("614 -1014 59 37"), $m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("672.64,-1007.65 632.41,-1007.65 632.41,-1013.65 614.41,-995.65 632.41,-977.65 632.41,-983.65 654.64,-983.65 654.64,-977.65 672.64,-977.65 672.64,-1007.65")])))]))))));
  }
  var x$83 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__rpromoter__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$83 === null) ? (shape === null) : (x$83 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("757 -1014 61 37"), $m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("799.2,-1007.65 757.85,-1007.65 757.85,-977.65 775.85,-977.65 775.85,-983.65 799.2,-983.65 799.2,-977.65 817.2,-995.65 799.2,-1013.65 799.2,-1007.65")])))]))))));
  }
  var x$85 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__promoter__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$85 === null) ? (shape === null) : (x$85 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("757 -1014 61 37"), $m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("799.2,-1007.65 757.85,-1007.65 757.85,-977.65 775.85,-977.65 775.85,-983.65 799.2,-983.65 799.2,-977.65 817.2,-995.65 799.2,-1013.65 799.2,-1007.65")])))]))))));
  }
  var x$87 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__cds__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$87 === null) ? (shape === null) : (x$87 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("760 -684 55 25"), $m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("802.52,-683.65 760.52,-683.65 760.52,-659.65 802.52,-659.65 814.52,-671.65 802.52,-683.65")])))]))))));
  }
  var x$89 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__terminator__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$89 === null) ? (shape === null) : (x$89 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("37 -792 62 13"), $m_Lcom_raquo_laminar_api_package$().b.j().dm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("70.52,-779.65 70.52,-785.65 76.52,-785.65 76.52,-791.65 58.52,-791.65 58.52,-785.65 64.52,-785.65 64.52,-779.65 70.52,-779.65")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("37.02,-779.65 98.03,-779.65")])))])))]))))));
  }
  var x$91 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__utr__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$91 === null) ? (shape === null) : (x$91 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("184 -789 55 10"), $m_Lcom_raquo_laminar_api_package$().b.j().dm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("220.52,-779.65 220.52,-782.65 214.52,-788.65 208.52,-788.65 202.52,-782.65 202.52,-779.65 220.52,-779.65")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("184.52,-779.65 238.52,-779.65")])))])))]))))));
  }
  var x$93 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__fivepoverhang__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$93 === null) ? (shape === null) : (x$93 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("604 -788 79 16"), $m_Lcom_raquo_laminar_api_package$().b.j().dm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("604.11,-781.15 628.11,-781.15 628.11,-787.15 604.11,-787.15 604.11,-781.15")]))), $m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("616.11,-772.15 628.11,-772.15 628.11,-778.15 616.11,-778.15 616.11,-772.15")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("628.11,-779.65 682.94,-779.65")])))])))]))))));
  }
  var x$95 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__primersite__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$95 === null) ? (shape === null) : (x$95 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("325 -795 61 16"), $m_Lcom_raquo_laminar_api_package$().b.j().dm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("367.52,-782.65 355.52,-794.65 355.52,-788.65 340.55,-788.65 340.55,-782.65 367.52,-782.65")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("325.58,-779.65 385.47,-779.65")])))])))]))))));
  }
  var x$97 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__restrictionsite__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$97 === null) ? (shape === null) : (x$97 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("462 -789 75 19"), $m_Lcom_raquo_laminar_api_package$().b.j().dm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("514.89,-782.65 490.16,-782.65 490.16,-788.65 484.16,-788.65 484.16,-776.65 508.89,-776.65 508.89,-770.65 514.89,-770.65 514.89,-782.65")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("462.07,-779.65 484.16,-779.65")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("514.89,-779.65 536.98,-779.65")])))])))]))))));
  }
  var x$99 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__threepoverhang__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$99 === null) ? (shape === null) : (x$99 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("744 -788 87 16"), $m_Lcom_raquo_laminar_api_package$().b.j().dm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("830.55,-781.15 830.55,-787.15 806.55,-787.15 806.55,-781.15 830.55,-781.15")]))), $m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("818.55,-772.15 818.55,-778.15 806.55,-778.15 806.55,-772.15 818.55,-772.15")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("744.5,-779.65 806.55,-779.65")])))])))]))))));
  }
  var x$101 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__noverhang__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$101 === null) ? (shape === null) : (x$101 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("35 -896 65 17"), $m_Lcom_raquo_laminar_api_package$().b.j().dm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("54.02,-889.15 66.02,-889.15 66.02,-895.15 54.02,-895.15 54.02,-889.15")]))), $m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("54.02,-880.15 66.02,-880.15 66.02,-886.15 54.02,-886.15 54.02,-880.15")]))), $m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("69.02,-880.15 81.02,-880.15 81.02,-886.15 69.02,-886.15 69.02,-880.15")]))), $m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("69.02,-889.15 81.02,-889.15 81.02,-895.15 69.02,-895.15 69.02,-889.15")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("81.02,-887.65 99.15,-887.65")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("54.02,-887.65 35.89,-887.65")])))])))]))))));
  }
  var x$103 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__assembly__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$103 === null) ? (shape === null) : (x$103 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("182 -896 59 17"), $m_Lcom_raquo_laminar_api_package$().b.j().dm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("199.52,-889.15 223.52,-889.15 223.52,-895.15 199.52,-895.15 199.52,-889.15")]))), $m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("199.52,-880.15 223.52,-880.15 223.52,-886.15 199.52,-886.15 199.52,-880.15")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("223.52,-887.65 240.64,-887.65")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("182.41,-887.65 199.52,-887.65")])))])))]))))));
  }
  var x$105 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__signature__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$105 === null) ? (shape === null) : (x$105 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("326 -900 59 25"), $m_Lcom_raquo_laminar_api_package$().b.j().dm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("384.09,-899.65 326.96,-899.65 326.96,-875.65 384.09,-875.65 384.09,-899.65")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("329.96,-889.15 332.96,-886.15")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("329.96,-886.15 332.96,-889.15")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("329.96,-878.65 381.09,-878.65")])))])))]))))));
  }
  var x$107 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__insulator__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$107 === null) ? (shape === null) : (x$107 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("472 -897 55 19"), $m_Lcom_raquo_laminar_api_package$().b.j().dm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("505.52,-893.65 505.52,-881.65 493.52,-881.65 493.52,-893.65 505.52,-893.65")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("508.52,-896.65 508.52,-878.65 490.52,-878.65 490.52,-896.65 508.52,-896.65")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("508.52,-887.65 526.52,-887.65")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("472.52,-887.65 490.52,-887.65")])))])))]))))));
  }
  var x$109 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__ribosite__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$109 === null) ? (shape === null) : (x$109 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("616 -900 55 13"), $m_Lcom_raquo_laminar_api_package$().b.j().dm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("646.52,-893.65 646.52,-895.15 645.02,-896.65 646.52,-898.15 646.52,-899.65 645.02,-899.65 643.52,-898.15 642.02,-899.65 640.52,-899.65 640.52,-898.15 642.02,-896.65 640.52,-895.15 640.52,-893.65 642.02,-893.65 643.52,-895.15 645.02,-893.65 646.52,-893.65")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("643.52,-887.65 643.52,-889.15")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("643.52,-890.65 643.52,-892.15")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("616.52,-887.65 670.52,-887.65")])))])))]))))));
  }
  var x$111 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__rnastab__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$111 === null) ? (shape === null) : (x$111 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("760 -900 55 13"), $m_Lcom_raquo_laminar_api_package$().b.j().dm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("789.02,-893.65 790.52,-895.15 790.52,-898.15 789.02,-899.65 786.02,-899.65 784.52,-898.15 784.52,-895.15 786.02,-893.65 789.02,-893.65")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("787.52,-887.65 787.52,-889.15")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("787.52,-890.65 787.52,-892.15")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("760.52,-887.65 814.52,-887.65")])))])))]))))));
  }
  var x$113 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__proteasesite__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$113 === null) ? (shape === null) : (x$113 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("32 -1008 71 13"), $m_Lcom_raquo_laminar_api_package$().b.j().dm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("70.52,-1001.65 70.52,-1003.15 69.02,-1004.65 70.52,-1006.15 70.52,-1007.65 69.02,-1007.65 67.52,-1006.15 66.02,-1007.65 64.52,-1007.65 64.52,-1006.15 66.02,-1004.65 64.52,-1003.15 64.52,-1001.65 66.02,-1001.65 67.52,-1003.15 69.02,-1001.65 70.52,-1001.65")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("67.52,-1003.15 67.52,-995.65")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("32.29,-995.65 102.76,-995.65")])))])))]))))));
  }
  var x$115 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__proteinstab__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$115 === null) ? (shape === null) : (x$115 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("178 -1008 67 13"), $m_Lcom_raquo_laminar_api_package$().b.j().dm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("213.02,-1001.65 214.52,-1003.15 214.52,-1006.15 213.02,-1007.65 210.02,-1007.65 208.52,-1006.15 208.52,-1003.15 210.02,-1001.65 213.02,-1001.65")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("211.52,-1001.65 211.52,-995.65")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("178.79,-995.65 244.26,-995.65")])))])))]))))));
  }
  var x$117 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__plain__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$117 === null) ? (shape === null) : (x$117 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("497 -142 24 14"), $m_Lcom_raquo_laminar_api_package$().b.j().dm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("521.38,-142.44 497.38,-142.44 497.38,-128.04 521.38,-128.04 521.38,-142.44"), $m_Lcom_raquo_laminar_api_package$().b.j().pI().n("stroke:none;fill:lightgrey")]))), $m_Lcom_raquo_laminar_api_package$().b.j().a4U().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().Eq().n("509.38"), $m_Lcom_raquo_laminar_api_package$().b.j().Er().n("-131"), $m_Lcom_raquo_laminar_api_package$().b.j().afT().n("Times,serif"), $m_Lcom_raquo_laminar_api_package$().b.j().afU().n("13.00"), $m_Lcom_raquo_laminar_api_package$().b.j().a4V().n("middle"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "abc", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))])))]))))));
  }
  var x$119 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__plaintext__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$119 === null) ? (shape === null) : (x$119 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("0 0 24 14"), $m_Lcom_raquo_laminar_api_package$().b.j().dm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("24,0 0,0 0,15 24,15 24,0"), $m_Lcom_raquo_laminar_api_package$().b.j().pI().n("stroke:none;fill:lightgrey")]))), $m_Lcom_raquo_laminar_api_package$().b.j().a4U().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().Eq().n("12"), $m_Lcom_raquo_laminar_api_package$().b.j().Er().n("10"), $m_Lcom_raquo_laminar_api_package$().b.j().afT().n("Times,serif"), $m_Lcom_raquo_laminar_api_package$().b.j().afU().n("7"), $m_Lcom_raquo_laminar_api_package$().b.j().a4V().n("middle"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "abc", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))])))]))))));
  }
  var x$121 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__underline__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  if (((x$121 === null) ? (shape === null) : (x$121 === shape))) {
    return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + w)), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + h)), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("338 -586 55 37"), $m_Lcom_raquo_laminar_api_package$().b.j().dm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().co().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("392.38,-585.24 338.38,-585.24 338.38,-549.24 392.38,-549.24 392.38,-585.24"), $m_Lcom_raquo_laminar_api_package$().b.j().pI().n("stroke:none;fill:lightgrey")]))), $m_Lcom_raquo_laminar_api_package$().b.j().dd().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ().n("338.38,-549.24 392.38,-549.24")]))), $m_Lcom_raquo_laminar_api_package$().b.j().a4U().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("node-preview"), $m_Lcom_raquo_laminar_api_package$().b.j().Eq().n("365.38"), $m_Lcom_raquo_laminar_api_package$().b.j().Er().n("-560.64"), $m_Lcom_raquo_laminar_api_package$().b.j().afT().n("Times,serif"), $m_Lcom_raquo_laminar_api_package$().b.j().afU().n("18.00"), $m_Lcom_raquo_laminar_api_package$().b.j().a4V().n("middle"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "abc", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))])))]))))));
  }
  return $m_s_None$();
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ShapePreview$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ShapePreview$package$, "org.jpablo.graphexplorer.viewer.components.attributes.previews.ShapePreview$package$", ({
  yX: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ShapePreview$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ShapePreview$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ShapePreview$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ShapePreview$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ShapePreview$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ShapePreview$package$;
}
function $is_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.bU)));
}
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bU)));
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_RowBuilder(updates, layout) {
  this.axv = null;
  this.axu = null;
  this.axv = updates;
  this.axu = layout;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_RowBuilder.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_RowBuilder;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_RowBuilder() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_RowBuilder.prototype = $p;
$p.we = (function(dotAttributes) {
  return dotAttributes.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    if ($is_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow(x$1)) {
      return x$1;
    }
    if (($is_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute(x$1) || (x$1 instanceof $c_T2))) {
      matchResult1: {
        var \u03b41$___1;
        var \u03b41$___2;
        if ($is_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttributeEnum(x$1)) {
          var \u03b41$___1 = x$1;
          var \u03b41$___2 = $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__select__Lorg_jpablo_graphexplorer_viewer_widgets_InputType();
          break matchResult1;
        }
        if ($is_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttributeSimple(x$1)) {
          var \u03b41$___1 = x$1;
          var \u03b41$___2 = $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__text__Lorg_jpablo_graphexplorer_viewer_widgets_InputType();
          break matchResult1;
        }
        if ((x$1 instanceof $c_T2)) {
          var x3 = x$1.g();
          var x4 = x$1.h();
          if ((x3 !== null)) {
            if ((x4 !== null)) {
              var \u03b41$___1 = x3;
              var \u03b41$___2 = x4;
              break matchResult1;
            }
          }
        }
        throw new $c_s_MatchError(x$1);
      }
      return this.c7(\u03b41$___1, \u03b41$___2, $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$());
    }
    throw new $c_s_MatchError(x$1);
  })));
});
$p.Xa = (function(attr) {
  return $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), this.axu, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => (!attr.aV().E(_$1)))), $m_s_None$());
});
$p.c7 = (function(attr, inputType, onReset, label, placeholder, hidden, unit) {
  return $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_RowBuilder$().aPj(new $c_T2(attr, inputType), $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_RowBuilder$().aSe(attr.aN(), this.axv, onReset), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_airstream_state_Val$().iT($dp_toString__T(attr.aT()))), label, placeholder, (hidden.c() ? new $c_s_Some(this.Xa(attr)) : hidden), unit);
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_RowBuilder = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_RowBuilder, "org.jpablo.graphexplorer.viewer.components.attributes.rows.RowBuilder", ({
  z1: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_RowBuilder$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_RowBuilder$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_RowBuilder$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_RowBuilder$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_RowBuilder$.prototype = $p;
$p.aSe = (function(attrId, updates, onReset) {
  return $f_Lcom_raquo_airstream_state_Var__zoomLazy__F1__F2__Lcom_raquo_airstream_state_Var(updates, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => _$2.GS.ay(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId(attrId), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $s_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$__Missing__Lorg_jpablo_graphexplorer_viewer_models_AttrStatus()))))), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((attrs, value) => {
    var self = new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId(attrId);
    var x = $s_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$__Missing__Lorg_jpablo_graphexplorer_viewer_models_AttrStatus();
    if (((x === null) ? (value === null) : x.e(value))) {
      if (onReset.c()) {
        var $x_1 = value;
      } else {
        var x0 = onReset.d();
        var $x_1 = new $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single(($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(x0)));
      }
      var y = $x_1;
    } else {
      var y = value;
    }
    return new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeUpdates(attrs.GS.bN(self, y));
  })));
});
$p.aPj = (function(attr, inputVar, default$1, label, placeholder, hidden, unit) {
  if ((attr !== null)) {
    var x14 = attr.g();
    var x15 = attr.h();
    if ((x14 !== null)) {
      if ((x15 !== null)) {
        var $x_14 = x14.aN();
        var $x_13 = (label.c() ? x14.aI() : label.d());
        var $x_12 = (placeholder.c() ? x14.aZ() : placeholder.d());
        var xs = x14.aP();
        var f = ((x$1) => {
          var l = x$1.g();
          var v = x$1.h();
          return new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$RowOption(l, new $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single(($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue($dp_toString__T(v)))), $m_s_None$());
        });
        var len = xs.a.length;
        var ys = new ($d_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$RowOption.r().C)(len);
        if ((len > 0)) {
          var i = 0;
          if ((xs !== null)) {
            while ((i < len)) {
              var $x_1 = i;
              var x0 = xs.a[i];
              ys.a[$x_1] = f(x0);
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $ac_I)) {
            while ((i < len)) {
              var $x_2 = i;
              var x0$1 = xs.a[i];
              ys.a[$x_2] = f(x0$1);
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $ac_D)) {
            while ((i < len)) {
              var $x_3 = i;
              var x0$2 = xs.a[i];
              ys.a[$x_3] = f(x0$2);
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $ac_J)) {
            while ((i < len)) {
              var $x_6 = i;
              var $x_4 = xs.a;
              var $x_5 = (i << 1);
              var x0$3_$_lo = $x_4[$x_5];
              var x0$3_$_hi = $x_4[(($x_5 + 1) | 0)];
              ys.a[$x_6] = f($bL(x0$3_$_lo, x0$3_$_hi));
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $ac_F)) {
            while ((i < len)) {
              var $x_7 = i;
              var x0$4 = xs.a[i];
              ys.a[$x_7] = f(x0$4);
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $ac_C)) {
            while ((i < len)) {
              var $x_8 = i;
              var x0$5 = xs.a[i];
              ys.a[$x_8] = f($bC(x0$5));
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $ac_B)) {
            while ((i < len)) {
              var $x_9 = i;
              var x0$6 = xs.a[i];
              ys.a[$x_9] = f(x0$6);
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $ac_S)) {
            while ((i < len)) {
              var $x_10 = i;
              var x0$7 = xs.a[i];
              ys.a[$x_10] = f(x0$7);
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $ac_Z)) {
            while ((i < len)) {
              var $x_11 = i;
              var x0$8 = xs.a[i];
              ys.a[$x_11] = f(x0$8);
              i = ((1 + i) | 0);
            }
          } else {
            throw new $c_s_MatchError(xs);
          }
        }
        return new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute($x_14, $x_13, $x_12, x15, inputVar, $m_sc_ArrayOps$().kX(ys), default$1, x14.aV(), (hidden.c() ? ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_airstream_state_Val$().iT(false)) : hidden.d()), false, $m_s_None$(), unit, $m_s_None$());
      }
    }
  }
  throw new $c_s_MatchError(attr);
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_RowBuilder$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_RowBuilder$, "org.jpablo.graphexplorer.viewer.components.attributes.rows.RowBuilder$", ({
  z2: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_RowBuilder$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_RowBuilder$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_RowBuilder$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_RowBuilder$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_RowBuilder$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_RowBuilder$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_DiagramAttributesView$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_DiagramAttributesView$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_DiagramAttributesView$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_DiagramAttributesView$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_DiagramAttributesView$package$.prototype = $p;
$p.aVN = (function(state) {
  var builder = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_RowBuilder(state.aNp(), state.Pq());
  var directedVar = $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().aY5(state.b2h());
  var graphTypeRow = $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_RowBuilder$().aPj(new $c_T2($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$(), $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__checkbox__Lorg_jpablo_graphexplorer_viewer_widgets_InputType()), directedVar, ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_airstream_state_Val$().iT("true")), new $c_s_Some("Directed"), $m_s_None$(), $m_s_None$(), $m_s_None$());
  var labelRow = builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Label$(), new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$multiText(false), new $c_s_Some(""), new $c_s_Some("Title"), new $c_s_Some("Enter diagram title"), $m_s_None$(), $m_s_None$());
  var labelRelatedHidden = $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$().y3(labelRow), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => (_$1 === ""))), $m_s_None$());
  var $x_20 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_19 = $m_sr_ScalaRunTime$();
  var $x_18 = $m_Lcom_raquo_laminar_api_package$().b.gz().n("diagram-attributes-view");
  var $x_17 = $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("attributes-title flex-none"), $m_Lcom_raquo_laminar_api_package$().b.E3().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Diagram", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))])));
  var $x_16 = $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_VerticalAttributesView$package$();
  var $x_15 = $m_sr_ScalaRunTime$();
  var $x_14 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader("Title", $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader$().hG());
  var \u03b41$ = builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RootGraphLabelLoc$(), new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$menuWithExtra(4, $s_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$__start__Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection(), $m_s_None$()), $m_s_None$(), new $c_s_Some("Position"), $m_s_None$(), $m_s_None$(), $m_s_None$());
  var $x_13 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute(\u03b41$.da, \u03b41$.cF, \u03b41$.d3, \u03b41$.cJ, \u03b41$.cl, $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().a9h, \u03b41$.dg, \u03b41$.dq, labelRelatedHidden, \u03b41$.dp, \u03b41$.eH, \u03b41$.dh, \u03b41$.eI);
  var \u03b42$ = builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$(), new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$menuWithExtra(4, $s_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$__start__Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection(), $m_s_None$()), $m_s_None$(), new $c_s_Some("Align"), $m_s_None$(), $m_s_None$(), $m_s_None$());
  var $x_12 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute(\u03b42$.da, \u03b42$.cF, \u03b42$.d3, \u03b42$.cJ, \u03b42$.cl, $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().a9j, \u03b42$.dg, \u03b42$.dq, labelRelatedHidden, \u03b42$.dp, \u03b42$.eH, \u03b42$.dh, \u03b42$.eI);
  var $x_11 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader("Layout", $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader$().hG());
  var $x_10 = builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$(), $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__select__Lorg_jpablo_graphexplorer_viewer_widgets_InputType(), $m_s_None$(), new $c_s_Some("Engine"), $m_s_None$(), $m_s_None$(), $m_s_None$());
  var \u03b43$ = builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$(), new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$menuWithExtra(4, $s_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$__start__Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection(), $m_s_None$()), $m_s_None$(), new $c_s_Some("Direction"), $m_s_None$(), $m_s_None$(), $m_s_None$());
  var $x_9 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute(\u03b43$.da, \u03b43$.cF, \u03b43$.d3, \u03b43$.cJ, \u03b43$.cl, $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().a9i, \u03b43$.dg, \u03b43$.dq, \u03b43$.hd, \u03b43$.dp, \u03b43$.eH, \u03b43$.dh, \u03b43$.eI);
  var $x_8 = builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankSep$(), new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$range(new $c_s_Some(0.02), new $c_s_Some(2.0), new $c_s_Some(0.05)), $m_s_None$(), new $c_s_Some("Rank gap"), $m_s_None$(), $m_s_None$(), new $c_s_Some("in"));
  var $x_7 = builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeSep$(), new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$range(new $c_s_Some(0.02), new $c_s_Some(2.0), new $c_s_Some(0.05)), $m_s_None$(), new $c_s_Some("Node gap"), $m_s_None$(), $m_s_None$(), new $c_s_Some("in"));
  var $x_6 = builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Pad$(), new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$range(new $c_s_Some(0.0), new $c_s_Some(1.0), new $c_s_Some(0.05)), $m_s_None$(), new $c_s_Some("Margin"), $m_s_None$(), $m_s_None$(), new $c_s_Some("in"));
  var $x_5 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader("Edges", $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader$().hG());
  var $x_4 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute(graphTypeRow.da, "Arrowheads", graphTypeRow.d3, graphTypeRow.cJ, graphTypeRow.cl, graphTypeRow.j6, graphTypeRow.dg, graphTypeRow.dq, graphTypeRow.hd, graphTypeRow.dp, graphTypeRow.eH, graphTypeRow.dh, graphTypeRow.eI);
  var $x_3 = builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$(), $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__select__Lorg_jpablo_graphexplorer_viewer_widgets_InputType(), $m_s_None$(), new $c_s_Some("Routing"), $m_s_None$(), $m_s_None$(), $m_s_None$());
  var attr$9 = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Concentrate$();
  var label$9 = new $c_s_Some("Merge parallel");
  var onReset$9 = $m_s_None$();
  var placeholder$9 = $m_s_None$();
  var hidden$9$1 = $m_s_None$();
  var unit$9 = $m_s_None$();
  var $x_2 = builder.c7(attr$9, $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__checkbox__Lorg_jpablo_graphexplorer_viewer_widgets_InputType(), onReset$9, label$9, placeholder$9, hidden$9$1, unit$9);
  var $x_1 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader("Canvas", $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader$().hG());
  var \u03b44$ = builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BgColor$(), new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$menuWithExtra($m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().a9k.C(), $s_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$__end__Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection(), $m_s_None$()), $m_s_None$(), new $c_s_Some("Background"), $m_s_None$(), $m_s_None$(), $m_s_None$());
  var options$1$1 = $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().a9k.hK($m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().tf);
  var hidden$11 = builder.Xa($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BgColor$());
  return $x_20.w($x_19.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_18, $x_17, $f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement($x_16.a2w("root-graph-attributes", builder.we($x_15.f(new $ac_O([$x_14, labelRow, $x_13, $x_12, $x_11, $x_10, $x_9, $x_8, $x_7, $x_6, $x_5, $x_4, $x_3, $x_2, $x_1, new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute(\u03b44$.da, \u03b44$.cF, \u03b44$.d3, \u03b44$.cJ, \u03b44$.cl, options$1$1, \u03b44$.dg, \u03b44$.dq, hidden$11, \u03b44$.dp, \u03b44$.eH, \u03b44$.dh, \u03b44$.eI)]))), $m_sci_Seq$().f7()), $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("flex-grow")])))])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_DiagramAttributesView$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_DiagramAttributesView$package$, "org.jpablo.graphexplorer.viewer.components.attributes.views.DiagramAttributesView$package$", ({
  z3: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_DiagramAttributesView$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_DiagramAttributesView$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_DiagramAttributesView$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_DiagramAttributesView$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_DiagramAttributesView$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_DiagramAttributesView$package$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_DiagramAttributesViews$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_DiagramAttributesViews$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_DiagramAttributesViews$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_DiagramAttributesViews$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_DiagramAttributesViews$.prototype = $p;
$p.b1v = (function(format, state) {
  var x = $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__DOT__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat();
  if (((x === null) ? (format === null) : (x === format))) {
    return $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_DiagramAttributesView$package$().aVN(state);
  }
  var x$3 = $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__Mermaid__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat();
  if (((x$3 === null) ? (format === null) : (x$3 === format))) {
    return $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_MermaidDiagramAttributesView$package$().aW5(state);
  }
  throw new $c_s_MatchError(format);
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_DiagramAttributesViews$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_DiagramAttributesViews$, "org.jpablo.graphexplorer.viewer.components.attributes.views.DiagramAttributesViews$", ({
  z4: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_DiagramAttributesViews$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_DiagramAttributesViews$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_DiagramAttributesViews$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_DiagramAttributesViews$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_DiagramAttributesViews$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_DiagramAttributesViews$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_MermaidDiagramAttributesView$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_MermaidDiagramAttributesView$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_MermaidDiagramAttributesView$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_MermaidDiagramAttributesView$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_MermaidDiagramAttributesView$package$.prototype = $p;
$p.aW5 = (function(state) {
  var builder = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_RowBuilder(state.aNp(), state.Pq());
  var labelRow = builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Label$(), new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$multiText(false), new $c_s_Some(""), new $c_s_Some("Title"), new $c_s_Some("Enter diagram title"), $m_s_None$(), $m_s_None$());
  var $x_6 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_5 = $m_sr_ScalaRunTime$();
  var $x_4 = $m_Lcom_raquo_laminar_api_package$().b.gz().n("mermaid-diagram-attributes-view");
  var $x_3 = $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("attributes-title flex-none"), $m_Lcom_raquo_laminar_api_package$().b.E3().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Mermaid Diagram", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))])));
  var $x_2 = $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_VerticalAttributesView$package$();
  var $x_1 = $m_sr_ScalaRunTime$();
  var \u03b41$ = builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$(), new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$menuWithExtra(4, $s_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$__start__Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection(), $m_s_None$()), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$());
  return $x_6.w($x_5.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_4, $x_3, $f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement($x_2.a2w("mermaid-diagram-attributes", builder.we($x_1.f(new $ac_O([labelRow, new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute(\u03b41$.da, \u03b41$.cF, \u03b41$.d3, \u03b41$.cJ, \u03b41$.cl, $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().a9i, \u03b41$.dg, \u03b41$.dq, \u03b41$.hd, \u03b41$.dp, \u03b41$.eH, \u03b41$.dh, \u03b41$.eI)]))), $m_sci_Seq$().f7()), $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("flex-grow")])))])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_MermaidDiagramAttributesView$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_MermaidDiagramAttributesView$package$, "org.jpablo.graphexplorer.viewer.components.attributes.views.MermaidDiagramAttributesView$package$", ({
  z5: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_MermaidDiagramAttributesView$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_MermaidDiagramAttributesView$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_MermaidDiagramAttributesView$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_MermaidDiagramAttributesView$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_MermaidDiagramAttributesView$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_MermaidDiagramAttributesView$package$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_VerticalAttributesView$package$() {
  this.aUb = 0;
  this.aUb = 5;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_VerticalAttributesView$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_VerticalAttributesView$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_VerticalAttributesView$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_VerticalAttributesView$package$.prototype = $p;
$p.OR = (function(builder, id, iAttrs) {
  var title$1 = $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("flex gap-4 bg-base-100 rounded-box px-3"), $f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, iAttrs.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((ia) => {
    $m_Lcom_raquo_laminar_api_package$();
    return $m_Lcom_raquo_laminar_inserters_ChildInserter$().nv($m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$().ahW(ia), $m_Lcom_raquo_laminar_modifiers_RenderableNode$().ht, (void 0));
  }))), $m_s_$less$colon$less$().b1, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())])));
  var body$2 = $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("card card-border card-xs bg-base-100 shadow-sm attr-card"), $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("card-body"), $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_VerticalAttributesView$package$().a2w(id, builder.we(iAttrs), $m_sci_Seq$().f7())])))])));
  return $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().aeq(title$1, $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().aLs(), false, body$2);
});
$p.a2x = (function(id, title, iars) {
  var body$1 = $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("card card-border card-xs bg-base-100 shadow-sm attr-card"), $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("card-body"), $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_VerticalAttributesView$package$().a2w(id, iars, $m_sci_Seq$().f7())])))])));
  return $f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement($m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().aeq(title, $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().aLs(), false, body$1), $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("dropdown-end")])));
});
$p.a2w = (function(id, rows, extra) {
  var extraVisible = $m_Lcom_raquo_laminar_api_package$().b.ff.bx(false);
  return $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.gz().n(id), $m_Lcom_raquo_laminar_api_package$().b.y.s("attributes-view"), $f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement($m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().aW1((id + "extra-visible"), "extra", extraVisible, $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().aW2(), true), $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("flex justify-end mr-2"), $m_Lcom_raquo_laminar_api_package$().b.y.s("hidden").xV(extra.c())]))), $m_Lcom_raquo_laminar_receivers_ChildrenReceiver$RichChildrenReceiver$().aMb($m_Lcom_raquo_laminar_api_package$().b.a6p, $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_VerticalAttributesView$package$().a2O(rows), $m_Lcom_raquo_laminar_modifiers_RenderableNode$().ht, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$()).gR($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), extraVisible.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => (!(!(!_$1))))), $m_s_None$())), $m_Lcom_raquo_laminar_receivers_ChildrenReceiver$RichChildrenReceiver$().aMb($m_Lcom_raquo_laminar_api_package$().b.a6p, $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_VerticalAttributesView$package$().a2O(extra), $m_Lcom_raquo_laminar_modifiers_RenderableNode$().ht, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$()).gR(extraVisible.P())])));
});
$p.aVG = (function(attRow) {
  if ((attRow instanceof $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputElement)) {
    return $m_sci_Seq$().f7();
  }
  if ((attRow instanceof $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader)) {
    return $m_sci_Seq$().f7();
  }
  if ((attRow instanceof $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute)) {
    var x1 = attRow.cJ;
    if ((x1 instanceof $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$multiText)) {
      return new $c_sci_$colon$colon($m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("fieldset-label"), $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().a2v(attRow)]))), new $c_sci_$colon$colon($m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("fieldset-input"), $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_VerticalAttributesView$package$().DN(attRow)]))), $m_sci_Nil$()));
    }
    if ((x1 instanceof $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$menuWithExtra)) {
      if ((x1.CM >= 5)) {
        return new $c_sci_$colon$colon($m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("attr-row attr-row-stacked"), $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().a2v(attRow), $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("attr-value"), $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_VerticalAttributesView$package$().DN(attRow)])))]))), $m_sci_Nil$());
      }
    }
    if ((x1 instanceof $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$range)) {
      var x4 = x1.Nb;
      var x5 = x1.Na;
      var x6 = x1.Nc;
      var $x_11 = $m_Lcom_raquo_laminar_api_package$().b.a8();
      var $x_10 = $m_sr_ScalaRunTime$();
      var $x_9 = $m_Lcom_raquo_laminar_api_package$().b.y.s("attr-row attr-row-range");
      var $x_8 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().a2v(attRow);
      var $x_7 = $m_Lcom_raquo_laminar_api_package$().b.aU();
      var $x_6 = $m_sr_ScalaRunTime$();
      var $x_5 = $m_Lcom_raquo_laminar_api_package$().b.y.s("attr-value flex items-center gap-1");
      var $x_4 = $f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement($m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_VerticalAttributesView$package$().DN(attRow), $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("gx-range-nano")])));
      var $x_3 = $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_VerticalAttributesView$package$();
      var inputType$1 = new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$number(x4, x5, x6);
      var $x_2 = $f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement($x_3.DN(new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute(attRow.da, attRow.cF, attRow.d3, inputType$1, attRow.cl, attRow.j6, attRow.dg, attRow.dq, attRow.hd, attRow.dp, attRow.eH, attRow.dh, attRow.eI)), $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lorg_jpablo_graphexplorer_viewer_widgets_InputVariant$().aH4, $m_Lcom_raquo_laminar_api_package$().b.y.s("text-[.6rem] text-right"), $m_Lcom_raquo_laminar_api_package$().b.Af().Aq().n((attRow.cF + " value"))])));
      var this$9 = $m_Lcom_raquo_laminar_api_package$().b;
      var this$7 = attRow.dh;
      if (this$7.c()) {
        var $x_1 = $m_s_None$();
      } else {
        var x0 = this$7.d();
        var $x_1 = new $c_s_Some($m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("attr-unit"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, x0, $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))));
      }
      return new $c_sci_$colon$colon($x_11.w($x_10.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_9, $x_8, $x_7.w($x_6.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_5, $x_4, $x_2, $f_Lcom_raquo_laminar_api_Implicits__nodeOptionToModifier__s_Option__Lcom_raquo_laminar_modifiers_Modifier(this$9, $x_1)])))]))), $m_sci_Nil$());
    }
    return new $c_sci_$colon$colon($m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("attr-row"), $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().a2v(attRow), $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("attr-value"), $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_VerticalAttributesView$package$().DN(attRow)])))]))), $m_sci_Nil$());
  }
  throw new $c_s_MatchError(attRow);
});
$p.a2O = (function(rows) {
  return $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_VerticalAttributesView$package$().b9i(rows).c5(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var header = x$1.g();
    var sectionRows = x$1.h();
    var inputs = sectionRows.ct(new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_VerticalAttributesView$package$$anon$1());
    var fieldSets = inputs.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((row) => $m_Lcom_raquo_laminar_api_package$().b.afI().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("fieldset"), $f_Lcom_raquo_laminar_api_Implicits__nodeSeqToModifier__O__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_VerticalAttributesView$package$().aVG(row).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((row$2) => ((_$2) => $f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement(_$2, $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("hidden").bj(row$2.hd)])))))(row))), $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())]))))));
    return $m_s_Option$().m2(header).iz().L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((h) => $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_VerticalAttributesView$package$().b8h(h, inputs)))).g9(fieldSets);
  })));
});
$p.b8h = (function(header, rows) {
  var allHidden = (rows.c() ? ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_airstream_state_Val$().iT(true)) : $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_airstream_core_Signal$()).b8w(rows.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3) => _$3.hd)))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4) => _$4.lV(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x) => (!(!x))))))), $m_s_None$()));
  return $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("attributes-section"), $m_Lcom_raquo_laminar_api_package$().b.y.s("hidden").bj(allHidden), $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, header.LG, $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))])));
});
$p.b9i = (function(rows) {
  matchResult6: {
    var \u03b41$___1;
    var \u03b41$___2;
    var x25 = rows.PW(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => ((x$1 instanceof $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader) ? false : true))));
    if ((x25 !== null)) {
      var \u03b41$___1 = x25.g();
      var \u03b41$___2 = x25.h();
      break matchResult6;
    }
    throw new $c_s_MatchError(x25);
  }
  var leading$2 = \u03b41$___1;
  var rest$2 = \u03b41$___2;
  var this$11 = rest$2.hO($m_sci_Nil$(), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((x$1$2, x$2) => {
    var x28 = new $c_T2(x$1$2, x$2);
    var x38 = x28.bi;
    var x39 = x28.be;
    if ((x39 instanceof $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader)) {
      return new $c_sci_$colon$colon(new $c_T2(new $c_s_Some(x39), $m_sci_Nil$()), x38);
    }
    if ($m_sci_Nil$().e(x38)) {
      return new $c_sci_$colon$colon(new $c_T2($m_s_None$(), new $c_sci_$colon$colon(x39, $m_sci_Nil$())), $m_sci_Nil$());
    }
    if ((x38 instanceof $c_sci_$colon$colon)) {
      var x32 = x38.er;
      var x33 = x38.U;
      if ((x32 !== null)) {
        return new $c_sci_$colon$colon(new $c_T2(x32.g(), new $c_sci_$colon$colon(x39, x32.h())), x33);
      }
    }
    throw new $c_s_MatchError(x28);
  })));
  var f = ((x$1$3) => new $c_T2(x$1$3.g(), x$1$3.h().Jj()));
  if ((this$11 === $m_sci_Nil$())) {
    var $x_1 = $m_sci_Nil$();
  } else {
    var x0 = this$11.t();
    var h$1 = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
    var t = h$1;
    var rest$1 = this$11.v();
    while ((rest$1 !== $m_sci_Nil$())) {
      var x0$1 = rest$1.t();
      var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
      t.U = nx;
      t = nx;
      rest$1 = rest$1.v();
    }
    var $x_1 = h$1;
  }
  var grouped = $x_1.Jj();
  return (leading$2.c() ? grouped : grouped.Ec(new $c_T2($m_s_None$(), leading$2)));
});
$p.DN = (function(row) {
  matchResult8: {
    var $x_1;
    var x41 = row.cJ;
    if ((x41 instanceof $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$menuWithExtra)) {
      var $x_1 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().aLw(row, x41.CM, x41.Hf, x41.He);
      break matchResult8;
    }
    var x = $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__dropdown__Lorg_jpablo_graphexplorer_viewer_widgets_InputType();
    if (((x === null) ? (x41 === null) : x.e(x41))) {
      var $x_1 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().aLr(row);
      break matchResult8;
    }
    var x$3 = $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__select__Lorg_jpablo_graphexplorer_viewer_widgets_InputType();
    if (((x$3 === null) ? (x41 === null) : x$3.e(x41))) {
      var $x_1 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().aLA(row, $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([])));
      break matchResult8;
    }
    var x$5 = $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__checkbox__Lorg_jpablo_graphexplorer_viewer_widgets_InputType();
    if (((x$5 === null) ? (x41 === null) : x$5.e(x41))) {
      var $x_1 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().aLp(row);
      break matchResult8;
    }
    if ((x41 instanceof $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$multiText)) {
      var $x_1 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().aLE(row, "", x41.Hg);
      break matchResult8;
    }
    var $x_1 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().aes(row, false);
  }
  return $f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement($x_1, $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.Af().Aq().n(row.cF)])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_VerticalAttributesView$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_VerticalAttributesView$package$, "org.jpablo.graphexplorer.viewer.components.attributes.views.VerticalAttributesView$package$", ({
  z6: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_VerticalAttributesView$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_VerticalAttributesView$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_VerticalAttributesView$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_VerticalAttributesView$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_VerticalAttributesView$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_VerticalAttributesView$package$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$() {
  this.C9 = null;
  this.Gb = null;
  this.a9e = null;
  this.a9f = null;
  this.a9d = null;
  this.a9k = null;
  this.a0j = null;
  this.C8 = null;
  this.tf = null;
  this.axG = null;
  this.a9g = null;
  this.axx = null;
  this.axE = null;
  this.axF = null;
  this.axz = null;
  this.axA = null;
  this.axw = null;
  this.axH = null;
  this.axB = null;
  this.axC = null;
  this.axD = null;
  this.a9h = null;
  this.a9j = null;
  this.axy = null;
  this.a9i = null;
  $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$ = this;
  var this$1 = $m_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$().aw6;
  $m_sci_VectorMap$();
  var b = new $c_sci_VectorMapBuilder();
  var it = new $c_sci_VectorMap$$anon$1(this$1);
  while (it.p()) {
    var x0 = it.dC();
    if ((x0 === null)) {
      throw new $c_s_MatchError(x0);
    }
    var k = x0.g();
    var v = x0.h();
    b.pm(k, $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().aRM(k, v));
  }
  this.C9 = b.rb();
  this.Gb = $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().aRM("none", new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$RGB(0, 0, 0));
  this.a9e = new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__red__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName(), new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__yellow__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName(), new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__green__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName(), new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__blue__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName(), $m_sci_Nil$()))));
  this.a9f = new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__red__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName(), new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__yellow__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName(), new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__green__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName(), new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__blue__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName(), new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__indigo__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName(), new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__sky__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName(), new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__slate__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName(), $m_sci_Nil$())))))));
  this.a9d = $m_sci_Nil$().b6($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName.r().C)([$s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__red__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName(), $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__yellow__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName(), $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__green__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName(), $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__blue__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName(), $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__indigo__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName(), $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__sky__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName(), $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__slate__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName(), $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__purple__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName(), $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__pink__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName(), $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__rose__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName()])));
  var this$5 = $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().a9e;
  var f = ((c) => (c + "-200"));
  if ((this$5 === $m_sci_Nil$())) {
    var $x_1 = $m_sci_Nil$();
  } else {
    var x0$1 = this$5.t();
    var h = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
    var t = h;
    var rest = this$5.v();
    while ((rest !== $m_sci_Nil$())) {
      var x0$2 = rest.t();
      var nx = new $c_sci_$colon$colon(f(x0$2), $m_sci_Nil$());
      t.U = nx;
      t = nx;
      rest = rest.v();
    }
    var $x_1 = h;
  }
  var this$6 = $x_1.As($m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().C9);
  new $c_sci_$colon$colon($m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().Gb, this$6);
  var this$7 = $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().a9f;
  var f$1 = ((c$2) => (c$2 + "-200"));
  if ((this$7 === $m_sci_Nil$())) {
    var $x_2 = $m_sci_Nil$();
  } else {
    var x0$3 = this$7.t();
    var h$1 = new $c_sci_$colon$colon(f$1(x0$3), $m_sci_Nil$());
    var t$1 = h$1;
    var rest$1 = this$7.v();
    while ((rest$1 !== $m_sci_Nil$())) {
      var x0$4 = rest$1.t();
      var nx$1 = new $c_sci_$colon$colon(f$1(x0$4), $m_sci_Nil$());
      t$1.U = nx$1;
      t$1 = nx$1;
      rest$1 = rest$1.v();
    }
    var $x_2 = h$1;
  }
  var this$8 = $x_2.As($m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().C9);
  this.a9k = new $c_sci_$colon$colon($m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().Gb, this$8);
  var this$9 = $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().a9d;
  var f$2 = ((c$3) => (c$3 + "-200"));
  if ((this$9 === $m_sci_Nil$())) {
    var $x_3 = $m_sci_Nil$();
  } else {
    var x0$5 = this$9.t();
    var h$2 = new $c_sci_$colon$colon(f$2(x0$5), $m_sci_Nil$());
    var t$2 = h$2;
    var rest$2 = this$9.v();
    while ((rest$2 !== $m_sci_Nil$())) {
      var x0$6 = rest$2.t();
      var nx$2 = new $c_sci_$colon$colon(f$2(x0$6), $m_sci_Nil$());
      t$2.U = nx$2;
      t$2 = nx$2;
      rest$2 = rest$2.v();
    }
    var $x_3 = h$2;
  }
  var this$10 = $x_3.As($m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().C9);
  this.a0j = new $c_sci_$colon$colon($m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().Gb, this$10);
  var this$11 = $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().a9e;
  var f$3 = ((c$4) => (c$4 + "-500"));
  if ((this$11 === $m_sci_Nil$())) {
    var $x_4 = $m_sci_Nil$();
  } else {
    var x0$7 = this$11.t();
    var h$3 = new $c_sci_$colon$colon(f$3(x0$7), $m_sci_Nil$());
    var t$3 = h$3;
    var rest$3 = this$11.v();
    while ((rest$3 !== $m_sci_Nil$())) {
      var x0$8 = rest$3.t();
      var nx$3 = new $c_sci_$colon$colon(f$3(x0$8), $m_sci_Nil$());
      t$3.U = nx$3;
      t$3 = nx$3;
      rest$3 = rest$3.v();
    }
    var $x_4 = h$3;
  }
  var this$12 = $x_4.As($m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().C9);
  new $c_sci_$colon$colon($m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().Gb, this$12);
  var this$13 = $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().a9f;
  var f$4 = ((c$5) => (c$5 + "-500"));
  if ((this$13 === $m_sci_Nil$())) {
    var $x_5 = $m_sci_Nil$();
  } else {
    var x0$9 = this$13.t();
    var h$4 = new $c_sci_$colon$colon(f$4(x0$9), $m_sci_Nil$());
    var t$4 = h$4;
    var rest$4 = this$13.v();
    while ((rest$4 !== $m_sci_Nil$())) {
      var x0$10 = rest$4.t();
      var nx$4 = new $c_sci_$colon$colon(f$4(x0$10), $m_sci_Nil$());
      t$4.U = nx$4;
      t$4 = nx$4;
      rest$4 = rest$4.v();
    }
    var $x_5 = h$4;
  }
  var this$14 = $x_5.As($m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().C9);
  new $c_sci_$colon$colon($m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().Gb, this$14);
  var this$15 = $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().a9d;
  var f$5 = ((c$6) => (c$6 + "-500"));
  if ((this$15 === $m_sci_Nil$())) {
    var $x_6 = $m_sci_Nil$();
  } else {
    var x0$11 = this$15.t();
    var h$5 = new $c_sci_$colon$colon(f$5(x0$11), $m_sci_Nil$());
    var t$5 = h$5;
    var rest$5 = this$15.v();
    while ((rest$5 !== $m_sci_Nil$())) {
      var x0$12 = rest$5.t();
      var nx$5 = new $c_sci_$colon$colon(f$5(x0$12), $m_sci_Nil$());
      t$5.U = nx$5;
      t$5 = nx$5;
      rest$5 = rest$5.v();
    }
    var $x_6 = h$5;
  }
  var this$16 = $x_6.As($m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().C9);
  this.C8 = new $c_sci_$colon$colon($m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().Gb, this$16);
  this.tf = $m_sci_Seq$().fw(new $c_sci_VectorMap$$anon$2($m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().C9));
  var $x_7 = $m_sc_ArrayOps$();
  var xs = $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$());
  var evidence$1 = $m_s_reflect_ClassTag$().y0($objectGetClass(xs).ba.Q());
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1.h8();
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var i = 0;
  while ((i < xs.a.length)) {
    var x1 = i;
    var x = xs.a[x1];
    x.g();
    var s = x.h();
    if ((!$m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$().aDr.E(s))) {
      var unboxedElem = (isCharArrayBuilder ? $uC(x) : ((x === null) ? elementClass.ba.z : x));
      jsElems.push(unboxedElem);
    }
    i = ((1 + i) | 0);
  }
  var elemRuntimeClass = ((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass));
  this.axG = $x_7.kX(elemRuntimeClass.ba.r().w(jsElems)).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    var label = x$1$2.g();
    var shape = x$1$2.h();
    return new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$RowOption(label, new $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single(($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(shape.m()))), $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ShapePreview$package$().aLB(shape, 20, 20));
  })));
  this.a9g = $m_sc_ArrayOps$().kX($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$().aP()).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3) => {
    var label$1 = x$1$3.g();
    var style = x$1$3.h();
    return new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$RowOption(label$1, new $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single(($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(style.m()))), $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_BorderStylePreview$package$().aVJ(style, 20, 20));
  })));
  this.axx = $m_sc_ArrayOps$().kX($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$().aP()).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$4) => {
    var label$2 = x$1$4.g();
    var style$1 = x$1$4.h();
    return new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$RowOption(label$2, new $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single(($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(style$1.m()))), $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_CornerPreview$package$().aLq(style$1));
  })));
  this.axE = $m_sci_Map$().ao($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$__t__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc(), "bi-align-top"), new $c_T2($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$__c__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc(), "bi-align-middle"), new $c_T2($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$__b__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc(), "bi-align-bottom")])));
  this.axF = $m_sc_ArrayOps$().kX($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$().aan).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$5) => {
    var label$3 = x$1$5.g();
    var style$2 = x$1$5.h();
    return new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$RowOption(label$3, new $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single(($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(style$2.m()))), new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s(("bi " + $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().axE.i(style$2)))])))))));
  })));
  this.axz = $m_sci_Map$().ao($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$__forward__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType(), "bi-arrow-right"), new $c_T2($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$__back__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType(), "bi-arrow-left"), new $c_T2($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$__both__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType(), "bi-arrow-left-right"), new $c_T2($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$__none__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType(), "bi-dash-lg")])));
  this.axA = $m_sc_ArrayOps$().kX($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Dir$().aP()).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$6) => {
    var label$4 = x$1$6.g();
    var dir = x$1$6.h();
    return new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$RowOption(label$4, new $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single(($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(dir.m()))), new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s(("bi " + $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().axz.i(dir)))])))))));
  })));
  this.axw = $m_sc_ArrayOps$().kX($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$().aP()).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$7) => {
    var label$5 = x$1$7.g();
    var style$3 = x$1$7.h();
    var x$2 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$__invis__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle();
    if (((style$3 === null) ? (x$2 === null) : (style$3 === x$2))) {
      var elem$11 = new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("w-5 h-5 bi bi-ban none-color-icon")]))))));
    } else {
      var elem$11 = $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ArrowStylePreview$package$().aVE(style$3, 18, 20);
    }
    return new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$RowOption(label$5, new $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single(($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(style$3.m()))), elem$11);
  })));
  this.axH = $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle.r().C)([$s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$__normal__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$__rounded__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle()])));
  var $x_8 = $m_sc_ArrayOps$();
  var xs$7 = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$().aP();
  var evidence$1$1 = $m_s_reflect_ClassTag$().y0($objectGetClass(xs$7).ba.Q());
  var capacity$1 = 0;
  var size$1 = 0;
  var jsElems$1 = null;
  var elementClass$1 = evidence$1$1.h8();
  capacity$1 = 0;
  size$1 = 0;
  var isCharArrayBuilder$1 = (elementClass$1 === $d_C.l());
  jsElems$1 = [];
  var i$1 = 0;
  while ((i$1 < xs$7.a.length)) {
    var x1$1 = i$1;
    var x$1 = xs$7.a[x1$1];
    x$1.g();
    var s$1 = x$1.h();
    if ($m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().axH.E(s$1)) {
      var unboxedElem$1 = (isCharArrayBuilder$1 ? $uC(x$1) : ((x$1 === null) ? elementClass$1.ba.z : x$1));
      jsElems$1.push(unboxedElem$1);
    }
    i$1 = ((1 + i$1) | 0);
  }
  var elemRuntimeClass$1 = ((elementClass$1 === $d_V.l()) ? $d_jl_Void.l() : (((elementClass$1 === $d_sr_Null$.l()) || (elementClass$1 === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass$1));
  this.axB = $x_8.kX(elemRuntimeClass$1.ba.r().w(jsElems$1)).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$9) => {
    var label$6 = x$1$9.g();
    var style$4 = x$1$9.h();
    return new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$RowOption(label$6, new $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single(($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(style$4.m()))), $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_CornerPreview$package$().aLq(style$4));
  })));
  this.axC = $m_sci_Map$().ao($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc$__t__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc(), "bi-align-top"), new $c_T2($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc$__b__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc(), "bi-align-bottom")])));
  this.axD = $m_sci_Map$().ao($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$__l__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust(), "bi-align-start"), new $c_T2($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$__c__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust(), "bi-align-center"), new $c_T2($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$__r__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust(), "bi-align-end")])));
  this.a9h = $m_sc_ArrayOps$().kX($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ClusterLabelLoc$().aa4).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$10) => {
    var label$7 = x$1$10.g();
    var style$5 = x$1$10.h();
    return new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$RowOption(label$7, new $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single(($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(style$5.m()))), new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s(("bi " + $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().axC.i(style$5)))])))))));
  })));
  this.a9j = $m_sc_ArrayOps$().kX($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$().aak).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$11) => {
    var label$8 = x$1$11.g();
    var style$6 = x$1$11.h();
    return new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$RowOption(label$8, new $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single(($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(style$6.m()))), new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s(("bi " + $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().axD.i(style$6)))])))))));
  })));
  $m_sci_Map$().ao($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc$__t__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc(), "bi-align-top"), new $c_T2($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc$__b__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc(), "bi-align-bottom")])));
  this.axy = $m_sci_Map$().ao($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$__TB__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir(), "bi-arrow-down"), new $c_T2($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$__LR__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir(), "bi-arrow-right"), new $c_T2($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$__BT__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir(), "bi-arrow-up"), new $c_T2($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$__RL__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir(), "bi-arrow-left")])));
  this.a9i = $m_sc_ArrayOps$().kX($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$().aas).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$12) => {
    var label$9 = x$1$12.g();
    var style$7 = x$1$12.h();
    return new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$RowOption(label$9, new $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single(($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(style$7.m()))), new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s(("bi " + $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().axy.i(style$7)))])))))));
  })));
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$.prototype = $p;
$p.yf = (function(attrStr) {
  var cssColor = ((attrStr === "none") ? "unset" : $m_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$().Y7($m_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$().ag7(attrStr)).C4);
  return $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().aNf(attrStr, cssColor);
});
$p.aNf = (function(name, cssColor) {
  return ((name === "none") ? $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("w-5 h-5 bi bi-ban none-color-icon")]))) : $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("w-5 h-5 regular-color-icon"), $m_Lcom_raquo_laminar_api_package$().b.PZ().n(("background-color: " + cssColor))]))));
});
$p.aRM = (function(name, rgb) {
  if ((name === "none")) {
    var \u03b41$___1 = "unset";
    var \u03b41$___2 = "none";
  } else {
    var \u03b41$___1 = (((((("rgb(" + rgb.G4) + " ") + rgb.G3) + " ") + rgb.G2) + ")");
    var \u03b41$___2 = $m_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$().Y7(rgb).C4;
  }
  var cssColor = \u03b41$___1;
  var dotColor = \u03b41$___2;
  return new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$RowOption(name, new $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single(($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(dotColor))), new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().aNf(name, cssColor)))));
});
$p.aMq = (function(angle) {
  return $m_sc_ArrayOps$().kX($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$().aiw()).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((arrowType) => new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$RowOption(arrowType.m(), new $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single(($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(arrowType.m()))), $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_previews_ArrowPreview$package$().aVD(arrowType, 20, 20, angle)))));
});
$p.aY5 = (function(graphType) {
  return $f_Lcom_raquo_airstream_state_Var__zoomLazy__F1__F2__Lcom_raquo_airstream_state_Var(graphType, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((tpe) => {
    $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$();
    var x$2 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$__digraph__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType();
    return new $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single(new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(("" + ((tpe === null) ? (x$2 === null) : (tpe === x$2)))));
  })), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((_$3, status) => {
    if ((status instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single)) {
      return (status.nd.a3T() ? $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$__digraph__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType() : $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$__graph__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType());
    }
    var x = $s_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$__Multiple__Lorg_jpablo_graphexplorer_viewer_models_AttrStatus();
    if (((x === null) ? (status === null) : x.e(status))) {
      return $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$().GB;
    }
    var x$3 = $s_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$__Missing__Lorg_jpablo_graphexplorer_viewer_models_AttrStatus();
    if (((x$3 === null) ? (status === null) : x$3.e(status))) {
      return $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$().GB;
    }
    throw new $c_s_MatchError(status);
  })));
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$, "org.jpablo.graphexplorer.viewer.components.attributes.views.package$", ({
  z8: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_HorizontalAttributesView$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_HorizontalAttributesView$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_HorizontalAttributesView$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_HorizontalAttributesView$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_HorizontalAttributesView$package$.prototype = $p;
$p.a2u = (function(rows) {
  return $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("horizontal-attributes-view"), $f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_HorizontalAttributesView$package$().a2O(rows), $m_s_$less$colon$less$().b1, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())])));
});
$p.a2O = (function(rows) {
  return rows.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((row) => {
    $m_Lcom_raquo_laminar_api_package$();
    matchResult1: {
      var $x_1;
      if ((row instanceof $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute)) {
        var $x_1 = $m_Lcom_raquo_laminar_api_package$().b.afI().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("fieldset"), $f_Lcom_raquo_laminar_api_Implicits__nodeSeqToModifier__O__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_HorizontalAttributesView$package$().aVH(row), $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())])));
        break matchResult1;
      }
      if ((row instanceof $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputElement)) {
        var $x_1 = $m_Lcom_raquo_laminar_api_package$().b.afI().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("fieldset"), row.SM])));
        break matchResult1;
      }
      if ((row instanceof $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader)) {
        var $x_1 = $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("attr-cluster-sep"), $m_Lcom_raquo_laminar_api_package$().b.XU().s("separator"), $m_Lcom_raquo_laminar_api_package$().b.eW().n(row.LG)])));
        break matchResult1;
      }
      throw new $c_s_MatchError(row);
    }
    return new $c_Lcom_raquo_laminar_receivers_LockedChildReceiver($x_1).gR(($m_Lcom_raquo_airstream_core_Observable$(), $m_Lcom_raquo_airstream_extensions_BooleanObservable$().r1(row.agr())));
  })));
});
$p.aVH = (function(row) {
  var x5 = row.cJ;
  var x = $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__checkbox__Lorg_jpablo_graphexplorer_viewer_widgets_InputType();
  if (((x === null) ? (x5 === null) : x.e(x5))) {
    return new $c_sci_$colon$colon($m_Lcom_raquo_laminar_api_package$().b.Xp().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("fieldset-label fieldset-input"), $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, row.cF, $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_HorizontalAttributesView$package$().DN(row)]))), $m_sci_Nil$());
  }
  return new $c_sci_$colon$colon($m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("attr-control"), $m_Lcom_raquo_laminar_api_package$().b.eW().n(row.cF), $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_HorizontalAttributesView$package$().DN(row), $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_HorizontalAttributesView$package$().aYh(row)]))), $m_sci_Nil$());
});
$p.aYh = (function(row) {
  return ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_receivers_ChildOptionReceiver$()).gR($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$().a3Q(row), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((changed) => ((!(!changed)) ? new $c_s_Some($m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().aLz(row)) : $m_s_None$()))), $m_s_None$()));
});
$p.DN = (function(row) {
  var x6 = row.cJ;
  if ((x6 instanceof $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$menuWithExtra)) {
    return $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().aLw(row, x6.CM, x6.Hf, x6.He);
  }
  if ((x6 instanceof $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$currentValueWithSelector)) {
    return $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().aVQ(row, x6.N8, x6.N7, x6.N9);
  }
  var x = $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__dropdown__Lorg_jpablo_graphexplorer_viewer_widgets_InputType();
  if (((x === null) ? (x6 === null) : x.e(x6))) {
    return $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().aLr(row);
  }
  var x$3 = $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__select__Lorg_jpablo_graphexplorer_viewer_widgets_InputType();
  if (((x$3 === null) ? (x6 === null) : x$3.e(x6))) {
    return $f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement($m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().aLA(row, $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([]))), $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("ml-1")])));
  }
  var x$5 = $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__checkbox__Lorg_jpablo_graphexplorer_viewer_widgets_InputType();
  if (((x$5 === null) ? (x6 === null) : x$5.e(x6))) {
    return $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().aLp(row);
  }
  if ((x6 instanceof $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$multiText)) {
    return $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().aLE(row, "", x6.Hg);
  }
  if ((x6 instanceof $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$number)) {
    return $f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement($m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().aes(row, false), $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("horizontal-attribute-input no-outline")])));
  }
  return $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().aes(row, false);
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_HorizontalAttributesView$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_HorizontalAttributesView$package$, "org.jpablo.graphexplorer.viewer.components.attributes.views.toolbarViews.HorizontalAttributesView$package$", ({
  z9: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_HorizontalAttributesView$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_HorizontalAttributesView$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_HorizontalAttributesView$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_HorizontalAttributesView$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_HorizontalAttributesView$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_HorizontalAttributesView$package$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarArrowsAttributesView$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarArrowsAttributesView$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarArrowsAttributesView$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarArrowsAttributesView$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarArrowsAttributesView$package$.prototype = $p;
$p.aWm = (function(state, resetAttributes, updates) {
  var multiSelection = $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), state.aH().ne, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => (((_$1 === null) ? null : _$1.aS).aa() !== 1))), $m_s_None$());
  var builder = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_RowBuilder(updates, state.Pq());
  var \u03b41$ = builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Label$(), new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$multiText(false), new $c_s_Some(""), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$());
  var labelRow = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute(\u03b41$.da, \u03b41$.cF, \u03b41$.d3, \u03b41$.cJ, \u03b41$.cl, \u03b41$.j6, \u03b41$.dg, \u03b41$.dq, multiSelection, \u03b41$.dp, \u03b41$.eH, \u03b41$.dh, \u03b41$.eI);
  $m_Lio_laminext_syntax_core$();
  var this$10 = new $c_Lio_laminext_core_ops_signal_SignalOfBooleanOps($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$().y3(labelRow), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => (_$2 === ""))), $m_s_None$()));
  var that = $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), ($m_Lio_laminext_syntax_core$(), new $c_Lio_laminext_core_ops_signal_SignalOfBooleanOps(multiSelection)).wr, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2$1) => (!(!(!_$2$1))))), $m_s_None$());
  var labelRelatedHidden = $m_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$().li(this$10.wr, that, new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((_$5, _$6) => {
    var _$5$1 = (!(!_$5));
    var _$6$1 = (!(!_$6));
    return (_$5$1 && _$6$1);
  })));
  var $x_27 = $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_HorizontalAttributesView$package$();
  var $x_26 = $m_sr_ScalaRunTime$();
  var $x_25 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader("Paint", $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader$().hG());
  var \u03b42$ = builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Color$(), new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$currentValueWithSelector($s_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$__start__Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection(), $m_s_None$(), false), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$());
  var options$1 = $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().C8.hK($m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().tf);
  var missingRowOption$1 = new $c_s_Some(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((attrStr) => $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().yf(attrStr))));
  var triggerGlyph$1 = new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("bi bi-dash-lg")]))))));
  var $x_24 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute(\u03b42$.da, \u03b42$.cF, \u03b42$.d3, \u03b42$.cJ, \u03b42$.cl, options$1, \u03b42$.dg, \u03b42$.dq, \u03b42$.hd, \u03b42$.dp, missingRowOption$1, \u03b42$.dh, triggerGlyph$1);
  var $x_23 = $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_VerticalAttributesView$package$();
  var $x_22 = $m_sr_ScalaRunTime$();
  var \u03b43$ = builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$(), new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$menuWithExtra(3, $s_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$__start__Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection(), $m_s_None$()), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$());
  var $x_21 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputElement($x_23.OR(builder, "arrow-border-attributes", $x_22.f(new ($d_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute.r().C)([new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute(\u03b43$.da, \u03b43$.cF, \u03b43$.d3, \u03b43$.cJ, \u03b43$.cl, $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().axw, \u03b43$.dg, \u03b43$.dq, \u03b43$.hd, \u03b43$.dp, \u03b43$.eH, \u03b43$.dh, \u03b43$.eI), builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_PenWidth$(), new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$range(new $c_s_Some(0.0), new $c_s_Some(10.0), new $c_s_Some(0.1)), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$())]))), $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputElement$().hG());
  var $x_20 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader("Ends", $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader$().hG());
  var \u03b44$ = builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Dir$(), $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__dropdown__Lorg_jpablo_graphexplorer_viewer_widgets_InputType(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$());
  var $x_19 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute(\u03b44$.da, \u03b44$.cF, \u03b44$.d3, \u03b44$.cJ, \u03b44$.cl, $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().axA, \u03b44$.dg, \u03b44$.dq, \u03b44$.hd, \u03b44$.dp, \u03b44$.eH, \u03b44$.dh, \u03b44$.eI);
  var $x_17 = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowTail$();
  var cardClass$1$1 = new $c_s_Some("narrow-card");
  var \u03b45$ = builder.c7($x_17, new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$currentValueWithSelector($s_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$__start__Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection(), cardClass$1$1, false), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$());
  var options$2$1 = $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().aMq(180.0);
  var $x_18 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute(\u03b45$.da, \u03b45$.cF, \u03b45$.d3, \u03b45$.cJ, \u03b45$.cl, options$2$1, \u03b45$.dg, \u03b45$.dq, \u03b45$.hd, \u03b45$.dp, \u03b45$.eH, \u03b45$.dh, \u03b45$.eI);
  var $x_15 = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowHead$();
  var cardClass$2 = new $c_s_Some("narrow-card");
  var \u03b46$ = builder.c7($x_15, new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$currentValueWithSelector($s_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$__start__Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection(), cardClass$2, false), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$());
  var options$3$1 = $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().aMq(0.0);
  var $x_16 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute(\u03b46$.da, \u03b46$.cF, \u03b46$.d3, \u03b46$.cJ, \u03b46$.cl, options$3$1, \u03b46$.dg, \u03b46$.dq, \u03b46$.hd, \u03b46$.dp, \u03b46$.eH, \u03b46$.dh, \u03b46$.eI);
  var $x_14 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader("Text", $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader$().hG());
  var \u03b47$ = builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontColor$(), new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$currentValueWithSelector($s_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$__end__Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection(), $m_s_None$(), false), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$());
  var options$4 = $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().C8.hK($m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().tf);
  var missingRowOption$4 = new $c_s_Some(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((attrStr$2) => $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().yf(attrStr$2))));
  var triggerGlyph$4 = new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("gx-glyph-a"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "A", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))))));
  var $x_13 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute(\u03b47$.da, \u03b47$.cF, \u03b47$.d3, \u03b47$.cJ, \u03b47$.cl, options$4, \u03b47$.dg, \u03b47$.dq, labelRelatedHidden, \u03b47$.dp, missingRowOption$4, \u03b47$.dh, triggerGlyph$4);
  var $x_12 = $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_VerticalAttributesView$package$();
  var $x_11 = $m_sr_ScalaRunTime$();
  var \u03b48$ = builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontName$(), $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__dropdown__Lorg_jpablo_graphexplorer_viewer_widgets_InputType(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$());
  var $x_10 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute(\u03b48$.da, \u03b48$.cF, \u03b48$.d3, \u03b48$.cJ, \u03b48$.cl, \u03b48$.j6, \u03b48$.dg, \u03b48$.dq, labelRelatedHidden, \u03b48$.dp, \u03b48$.eH, \u03b48$.dh, \u03b48$.eI);
  var \u03b49$ = builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontSize$(), new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$range(new $c_s_Some(1.0), new $c_s_Some(100.0), new $c_s_Some(1.0)), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$());
  var $x_9 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputElement($x_12.OR(builder, "arrow-font-attributes", $x_11.f(new ($d_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute.r().C)([$x_10, new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute(\u03b49$.da, \u03b49$.cF, \u03b49$.d3, \u03b49$.cJ, \u03b49$.cl, \u03b49$.j6, \u03b49$.dg, \u03b49$.dq, labelRelatedHidden, \u03b49$.dp, \u03b49$.eH, \u03b49$.dh, \u03b49$.eI)]))), labelRelatedHidden);
  var $x_8 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputElement($m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_VerticalAttributesView$package$().a2x("extra-arrow-attributes", $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("bi-three-dots"), $m_Lcom_raquo_laminar_api_package$().b.eW().n("More attributes")]))), builder.we($m_sr_ScalaRunTime$().f(new $ac_O([new $c_T2($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Decorate$(), $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__checkbox__Lorg_jpablo_graphexplorer_viewer_widgets_InputType()), new $c_T2($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Constraint$(), $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__checkbox__Lorg_jpablo_graphexplorer_viewer_widgets_InputType()), new $c_T2($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Weight$(), new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$number(new $c_s_Some(0.0), new $c_s_Some(100.0), new $c_s_Some(1.0))), new $c_T2($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowSize$(), new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$number(new $c_s_Some(0.0), new $c_s_Some(5.0), new $c_s_Some(0.1))), builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_XLabel$(), $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__text__Lorg_jpablo_graphexplorer_viewer_widgets_InputType(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$()), builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_URL$(), $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__text__Lorg_jpablo_graphexplorer_viewer_widgets_InputType(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$()), new $c_T2($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailPort$(), $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__dropdown__Lorg_jpablo_graphexplorer_viewer_widgets_InputType()), new $c_T2($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HeadPort$(), $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__dropdown__Lorg_jpablo_graphexplorer_viewer_widgets_InputType())])))), $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputElement$().hG());
  var $x_7 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader("Reset", $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader$().hG());
  var $x_6 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$();
  var $x_5 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$();
  var $x_4 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Button$package$();
  var $x_3 = $m_sr_ScalaRunTime$();
  var $x_2 = $m_Lcom_raquo_laminar_api_package$().b.eW().n("Reset all attributes");
  var $x_1 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Icons$().aeS($m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([]))));
  var this$70 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false));
  var onNext = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    resetAttributes.gZ($m_s_None$(), true);
  }));
  $m_Lcom_raquo_laminar_api_package$features$().cz();
  return $x_27.a2u(builder.we($x_26.f(new $ac_O([$x_25, $x_24, $x_21, $x_20, $x_19, $x_18, $x_16, $x_14, $x_13, $x_9, $x_8, $x_7, new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputElement($x_6.u4($x_5.iZ($x_4.hH($x_3.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_2, $x_1, new $c_Lcom_raquo_laminar_modifiers_EventListener(this$70, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2$3) => {
    onNext.a3();
  })))]))))), $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputElement$().hG())]))));
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarArrowsAttributesView$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarArrowsAttributesView$package$, "org.jpablo.graphexplorer.viewer.components.attributes.views.toolbarViews.ToolbarArrowsAttributesView$package$", ({
  za: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarArrowsAttributesView$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarArrowsAttributesView$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarArrowsAttributesView$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarArrowsAttributesView$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarArrowsAttributesView$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarArrowsAttributesView$package$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarGroupAttributesView$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarGroupAttributesView$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarGroupAttributesView$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarGroupAttributesView$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarGroupAttributesView$package$.prototype = $p;
$p.aWn = (function(state, resetAttributes, updates) {
  var multiSelection = $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), state.aH().ne, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => (((_$1 === null) ? null : _$1.aS).aa() !== 1))), $m_s_None$());
  var builder = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_RowBuilder(updates, state.Pq());
  var \u03b41$ = builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Label$(), new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$multiText(false), new $c_s_Some(""), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$());
  var labelRow = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute(\u03b41$.da, \u03b41$.cF, \u03b41$.d3, \u03b41$.cJ, \u03b41$.cl, \u03b41$.j6, \u03b41$.dg, \u03b41$.dq, multiSelection, \u03b41$.dp, \u03b41$.eH, \u03b41$.dh, \u03b41$.eI);
  $m_Lio_laminext_syntax_core$();
  var this$10 = new $c_Lio_laminext_core_ops_signal_SignalOfBooleanOps($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$().y3(labelRow), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => (_$2 === ""))), $m_s_None$()));
  var that = $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), ($m_Lio_laminext_syntax_core$(), new $c_Lio_laminext_core_ops_signal_SignalOfBooleanOps(multiSelection)).wr, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2$1) => (!(!(!_$2$1))))), $m_s_None$());
  var labelRelatedHidden = $m_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$().li(this$10.wr, that, new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((_$5, _$6) => {
    var _$5$1 = (!(!_$5));
    var _$6$1 = (!(!_$6));
    return (_$5$1 && _$6$1);
  })));
  var $x_26 = $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_HorizontalAttributesView$package$();
  var $x_25 = $m_sr_ScalaRunTime$();
  var $x_24 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader("Shape", $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader$().hG());
  var \u03b42$ = builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$(), $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__dropdown__Lorg_jpablo_graphexplorer_viewer_widgets_InputType(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$());
  var $x_23 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute(\u03b42$.da, \u03b42$.cF, \u03b42$.d3, \u03b42$.cJ, \u03b42$.cl, $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().axB, \u03b42$.dg, \u03b42$.dq, \u03b42$.hd, \u03b42$.dp, \u03b42$.eH, \u03b42$.dh, \u03b42$.eI);
  var $x_22 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader("Paint", $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader$().hG());
  var \u03b43$ = builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillColor$(), new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$currentValueWithSelector($s_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$__start__Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection(), $m_s_None$(), false), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$());
  var options$1$1 = $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().a0j.hK($m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().tf);
  var hidden$1$1 = builder.Xa($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillColor$());
  var missingRowOption$1$1 = new $c_s_Some(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((attrStr) => $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().yf(attrStr))));
  var triggerGlyph$1$1 = new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("bi bi-paint-bucket")]))))));
  var $x_21 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute(\u03b43$.da, \u03b43$.cF, \u03b43$.d3, \u03b43$.cJ, \u03b43$.cl, options$1$1, \u03b43$.dg, \u03b43$.dq, hidden$1$1, \u03b43$.dp, missingRowOption$1$1, \u03b43$.dh, triggerGlyph$1$1);
  var \u03b44$ = builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_PenColor$(), new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$currentValueWithSelector($s_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$__start__Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection(), $m_s_None$(), false), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$());
  var options$2 = $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().C8.hK($m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().tf);
  var missingRowOption$2 = new $c_s_Some(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((attrStr$2) => $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().yf(attrStr$2))));
  var triggerGlyph$2 = new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("bi bi-square")]))))));
  var $x_20 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute(\u03b44$.da, \u03b44$.cF, \u03b44$.d3, \u03b44$.cJ, \u03b44$.cl, options$2, \u03b44$.dg, \u03b44$.dq, \u03b44$.hd, \u03b44$.dp, missingRowOption$2, \u03b44$.dh, triggerGlyph$2);
  var $x_19 = $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_VerticalAttributesView$package$();
  var $x_18 = $m_sr_ScalaRunTime$();
  var \u03b45$ = builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$(), new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$menuWithExtra(3, $s_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$__start__Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection(), $m_s_None$()), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$());
  var $x_17 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputElement($x_19.OR(builder, "group-border-attributes", $x_18.f(new ($d_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute.r().C)([new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute(\u03b45$.da, \u03b45$.cF, \u03b45$.d3, \u03b45$.cJ, \u03b45$.cl, $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().a9g, \u03b45$.dg, \u03b45$.dq, \u03b45$.hd, \u03b45$.dp, \u03b45$.eH, \u03b45$.dh, \u03b45$.eI), builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_PenWidth$(), new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$range(new $c_s_Some(0.0), new $c_s_Some(10.0), new $c_s_Some(0.1)), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$())]))), $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputElement$().hG());
  var $x_16 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader("Text", $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader$().hG());
  var \u03b46$ = builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ClusterLabelLoc$(), $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__dropdown__Lorg_jpablo_graphexplorer_viewer_widgets_InputType(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$());
  var $x_15 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute(\u03b46$.da, \u03b46$.cF, \u03b46$.d3, \u03b46$.cJ, \u03b46$.cl, $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().a9h, \u03b46$.dg, \u03b46$.dq, labelRelatedHidden, \u03b46$.dp, \u03b46$.eH, \u03b46$.dh, \u03b46$.eI);
  var \u03b47$ = builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$(), $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__dropdown__Lorg_jpablo_graphexplorer_viewer_widgets_InputType(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$());
  var $x_14 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute(\u03b47$.da, \u03b47$.cF, \u03b47$.d3, \u03b47$.cJ, \u03b47$.cl, $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().a9j, \u03b47$.dg, \u03b47$.dq, labelRelatedHidden, \u03b47$.dp, \u03b47$.eH, \u03b47$.dh, \u03b47$.eI);
  var \u03b48$ = builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontColor$(), new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$currentValueWithSelector($s_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$__end__Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection(), $m_s_None$(), false), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$());
  var options$3$1 = $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().C8.hK($m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().tf);
  var missingRowOption$3$1 = new $c_s_Some(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((attrStr$3) => $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().yf(attrStr$3))));
  var triggerGlyph$3$1 = new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("gx-glyph-a"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "A", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))))));
  var $x_13 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute(\u03b48$.da, \u03b48$.cF, \u03b48$.d3, \u03b48$.cJ, \u03b48$.cl, options$3$1, \u03b48$.dg, \u03b48$.dq, labelRelatedHidden, \u03b48$.dp, missingRowOption$3$1, \u03b48$.dh, triggerGlyph$3$1);
  var $x_12 = $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_VerticalAttributesView$package$();
  var $x_11 = $m_sr_ScalaRunTime$();
  var \u03b49$ = builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontName$(), $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__dropdown__Lorg_jpablo_graphexplorer_viewer_widgets_InputType(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$());
  var $x_10 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute(\u03b49$.da, \u03b49$.cF, \u03b49$.d3, \u03b49$.cJ, \u03b49$.cl, \u03b49$.j6, \u03b49$.dg, \u03b49$.dq, labelRelatedHidden, \u03b49$.dp, \u03b49$.eH, \u03b49$.dh, \u03b49$.eI);
  var \u03b410$ = builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontSize$(), new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$range(new $c_s_Some(1.0), new $c_s_Some(100.0), new $c_s_Some(1.0)), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$());
  var $x_9 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputElement($x_12.OR(builder, "group-font-attributes", $x_11.f(new ($d_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute.r().C)([$x_10, new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute(\u03b410$.da, \u03b410$.cF, \u03b410$.d3, \u03b410$.cJ, \u03b410$.cl, \u03b410$.j6, \u03b410$.dg, \u03b410$.dq, labelRelatedHidden, \u03b410$.dp, \u03b410$.eH, \u03b410$.dh, \u03b410$.eI)]))), labelRelatedHidden);
  var $x_8 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputElement($m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_VerticalAttributesView$package$().a2x("extra-group-attributes", $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("bi-three-dots"), $m_Lcom_raquo_laminar_api_package$().b.eW().n("More attributes")]))), builder.we($m_sr_ScalaRunTime$().f(new $ac_O([new $c_T2($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_InvisibleStyle$(), $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__checkbox__Lorg_jpablo_graphexplorer_viewer_widgets_InputType()), builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Cluster$(), $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__checkbox__Lorg_jpablo_graphexplorer_viewer_widgets_InputType(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$()), new $c_T2($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rank$(), $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__dropdown__Lorg_jpablo_graphexplorer_viewer_widgets_InputType()), builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_URL$(), $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__text__Lorg_jpablo_graphexplorer_viewer_widgets_InputType(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$())])))), $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputElement$().hG());
  var $x_7 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader("Reset", $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader$().hG());
  var $x_6 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$();
  var $x_5 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$();
  var $x_4 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Button$package$();
  var $x_3 = $m_sr_ScalaRunTime$();
  var $x_2 = $m_Lcom_raquo_laminar_api_package$().b.eW().n("Reset all attributes");
  var $x_1 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Icons$().aeS($m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([]))));
  var this$54 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false));
  var onNext = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    resetAttributes.gZ($m_s_None$(), true);
  }));
  $m_Lcom_raquo_laminar_api_package$features$().cz();
  return $x_26.a2u(builder.we($x_25.f(new $ac_O([$x_24, $x_23, $x_22, $x_21, $x_20, $x_17, $x_16, $x_15, $x_14, $x_13, $x_9, $x_8, $x_7, new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputElement($x_6.u4($x_5.iZ($x_4.hH($x_3.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_2, $x_1, new $c_Lcom_raquo_laminar_modifiers_EventListener(this$54, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2$3) => {
    onNext.a3();
  })))]))))), $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputElement$().hG())]))));
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarGroupAttributesView$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarGroupAttributesView$package$, "org.jpablo.graphexplorer.viewer.components.attributes.views.toolbarViews.ToolbarGroupAttributesView$package$", ({
  zb: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarGroupAttributesView$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarGroupAttributesView$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarGroupAttributesView$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarGroupAttributesView$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarGroupAttributesView$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarGroupAttributesView$package$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarHtmlCellAttributesView$package$() {
  this.axI = null;
  this.axK = null;
  this.axJ = null;
  this.axL = null;
  $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarHtmlCellAttributesView$package$ = this;
  this.axI = $m_sci_Map$().ao($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$__left__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign(), "bi-align-start"), new $c_T2($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$__center__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign(), "bi-align-center"), new $c_T2($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$__right__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign(), "bi-align-end"), new $c_T2($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$__text__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign(), "bi-justify")])));
  this.axK = $m_sci_Map$().ao($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$__top__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign(), "bi-align-top"), new $c_T2($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$__middle__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign(), "bi-align-middle"), new $c_T2($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$__bottom__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign(), "bi-align-bottom")])));
  this.axJ = $m_sc_ArrayOps$().kX($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellAlign$())).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var label = x$1.g();
    var v = x$1.h();
    return new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$RowOption(label, new $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single(($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(v.m()))), new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s(("bi " + $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarHtmlCellAttributesView$package$().axI.i(v)))])))))));
  })));
  this.axL = $m_sc_ArrayOps$().kX($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellVAlign$())).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    var label$1 = x$1$2.g();
    var v$1 = x$1$2.h();
    return new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$RowOption(label$1, new $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single(($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(v$1.m()))), new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s(("bi " + $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarHtmlCellAttributesView$package$().axK.i(v$1)))])))))));
  })));
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarHtmlCellAttributesView$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarHtmlCellAttributesView$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarHtmlCellAttributesView$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarHtmlCellAttributesView$package$.prototype = $p;
$p.aWo = (function(state, updates) {
  var builder = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_RowBuilder(updates, state.Pq());
  var $x_5 = $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_HorizontalAttributesView$package$();
  var $x_4 = $m_sr_ScalaRunTime$();
  var \u03b41$ = builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellBgColor$(), new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$currentValueWithSelector($s_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$__start__Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection(), $m_s_None$(), false), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$());
  var options$1 = $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().a0j.hK($m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().tf);
  var missingRowOption$1 = new $c_s_Some(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((attrStr) => $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().yf(attrStr))));
  var triggerGlyph$1 = new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("bi bi-paint-bucket")]))))));
  var $x_3 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute(\u03b41$.da, \u03b41$.cF, \u03b41$.d3, \u03b41$.cJ, \u03b41$.cl, options$1, \u03b41$.dg, \u03b41$.dq, \u03b41$.hd, \u03b41$.dp, missingRowOption$1, \u03b41$.dh, triggerGlyph$1);
  var \u03b42$ = builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellColor$(), new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$currentValueWithSelector($s_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$__start__Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection(), $m_s_None$(), false), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$());
  var options$2 = $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().C8.hK($m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().tf);
  var missingRowOption$2 = new $c_s_Some(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((attrStr$2) => $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().yf(attrStr$2))));
  var triggerGlyph$2 = new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("bi bi-square")]))))));
  var $x_2 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute(\u03b42$.da, \u03b42$.cF, \u03b42$.d3, \u03b42$.cJ, \u03b42$.cl, options$2, \u03b42$.dg, \u03b42$.dq, \u03b42$.hd, \u03b42$.dp, missingRowOption$2, \u03b42$.dh, triggerGlyph$2);
  var \u03b43$ = builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellAlign$(), $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__dropdown__Lorg_jpablo_graphexplorer_viewer_widgets_InputType(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$());
  var $x_1 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute(\u03b43$.da, \u03b43$.cF, \u03b43$.d3, \u03b43$.cJ, \u03b43$.cl, $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarHtmlCellAttributesView$package$().axJ, \u03b43$.dg, \u03b43$.dq, \u03b43$.hd, \u03b43$.dp, \u03b43$.eH, \u03b43$.dh, \u03b43$.eI);
  var \u03b44$ = builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellVAlign$(), $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__dropdown__Lorg_jpablo_graphexplorer_viewer_widgets_InputType(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$());
  return $x_5.a2u(builder.we($x_4.f(new $ac_O([$x_3, $x_2, $x_1, new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute(\u03b44$.da, \u03b44$.cF, \u03b44$.d3, \u03b44$.cJ, \u03b44$.cl, $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarHtmlCellAttributesView$package$().axL, \u03b44$.dg, \u03b44$.dq, \u03b44$.hd, \u03b44$.dp, \u03b44$.eH, \u03b44$.dh, \u03b44$.eI), new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputElement($m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_VerticalAttributesView$package$().a2x("html-cell-extra-attributes", $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("bi-three-dots"), $m_Lcom_raquo_laminar_api_package$().b.eW().n("More cell attributes")]))), builder.we($m_sr_ScalaRunTime$().f(new $ac_O([builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellColSpan$(), new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$number(new $c_s_Some(1.0), new $c_s_Some(20.0), new $c_s_Some(1.0)), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$()), builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellRowSpan$(), new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$number(new $c_s_Some(1.0), new $c_s_Some(20.0), new $c_s_Some(1.0)), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$()), builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellBorder$(), new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$number(new $c_s_Some(0.0), new $c_s_Some(10.0), new $c_s_Some(1.0)), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$()), builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellPadding$(), new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$number(new $c_s_Some(0.0), new $c_s_Some(20.0), new $c_s_Some(1.0)), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$()), builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellPort$(), $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__text__Lorg_jpablo_graphexplorer_viewer_widgets_InputType(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$())])))), $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputElement$().hG())]))));
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarHtmlCellAttributesView$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarHtmlCellAttributesView$package$, "org.jpablo.graphexplorer.viewer.components.attributes.views.toolbarViews.ToolbarHtmlCellAttributesView$package$", ({
  zc: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarHtmlCellAttributesView$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarHtmlCellAttributesView$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarHtmlCellAttributesView$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarHtmlCellAttributesView$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarHtmlCellAttributesView$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarHtmlCellAttributesView$package$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarNodesAttributesView$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarNodesAttributesView$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarNodesAttributesView$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarNodesAttributesView$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarNodesAttributesView$package$.prototype = $p;
$p.aWp = (function(state, resetAttributes, updates) {
  var multiSelection = $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), state.aH().ne, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => (((_$1 === null) ? null : _$1.aS).aa() !== 1))), $m_s_None$());
  var builder = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_RowBuilder(updates, state.Pq());
  var \u03b41$ = builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Label$(), new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$multiText(false), new $c_s_Some(""), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$());
  var labelRow = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute(\u03b41$.da, \u03b41$.cF, \u03b41$.d3, \u03b41$.cJ, \u03b41$.cl, \u03b41$.j6, \u03b41$.dg, \u03b41$.dq, multiSelection, \u03b41$.dp, \u03b41$.eH, \u03b41$.dh, \u03b41$.eI);
  $m_Lio_laminext_syntax_core$();
  var this$11 = new $c_Lio_laminext_core_ops_signal_SignalOfBooleanOps($m_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$().li(labelRow.cl.P(), $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$().y3(labelRow), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((status, str) => {
    var x$2 = $s_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$__Missing__Lorg_jpablo_graphexplorer_viewer_models_AttrStatus();
    if ((!((status === null) ? (x$2 === null) : status.e(x$2)))) {
      return (str === "");
    } else {
      return false;
    }
  }))));
  var that = $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), ($m_Lio_laminext_syntax_core$(), new $c_Lio_laminext_core_ops_signal_SignalOfBooleanOps(multiSelection)).wr, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => (!(!(!_$2))))), $m_s_None$());
  var labelRelatedHidden = $m_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$().li(this$11.wr, that, new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((_$5, _$6) => {
    var _$5$1 = (!(!_$5));
    var _$6$1 = (!(!_$6));
    return (_$5$1 && _$6$1);
  })));
  var $x_1 = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  var cardClass$1 = new $c_s_Some("narrow-card");
  var \u03b42$ = builder.c7($x_1, new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$currentValueWithSelector($s_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$__start__Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection(), cardClass$1, false), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$());
  var shapeRow = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute(\u03b42$.da, \u03b42$.cF, \u03b42$.d3, \u03b42$.cJ, \u03b42$.cl, $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().axG, \u03b42$.dg, \u03b42$.dq, \u03b42$.hd, \u03b42$.dp, \u03b42$.eH, \u03b42$.dh, \u03b42$.eI);
  var shapeIsNotPolygon = $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), shapeRow.cl.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2$2) => ((_$2$2 instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single) && (_$2$2.nd.m() !== $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__polygon__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape().m())))), $m_s_None$());
  var shapeIsPlainOrPlainText = $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), shapeRow.cl.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4) => {
    if ((_$4 instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single)) {
      var x24$1 = _$4.nd;
      return ((x24$1.m() === $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__plain__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape().m()) || (x24$1.m() === $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__plaintext__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape().m()));
    } else {
      return false;
    }
  })), $m_s_None$());
  var sidesRow = builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Sides$(), new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$number(new $c_s_Some(3.0), new $c_s_Some(10.0), new $c_s_Some(1.0)), $m_s_None$(), $m_s_None$(), $m_s_None$(), new $c_s_Some($m_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$().li(($m_Lio_laminext_syntax_core$(), new $c_Lio_laminext_core_ops_signal_SignalOfBooleanOps(builder.Xa($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Sides$()))).wr, shapeIsNotPolygon, new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((_$3, _$4$1) => {
    var _$3$1 = (!(!_$3));
    var _$4$2 = (!(!_$4$1));
    return (_$3$1 || _$4$2);
  })))), $m_s_None$());
  var $x_26 = $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_HorizontalAttributesView$package$();
  var $x_25 = $m_sr_ScalaRunTime$();
  var $x_24 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader("Shape", $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader$().hG());
  var \u03b43$ = builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$(), $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__dropdown__Lorg_jpablo_graphexplorer_viewer_widgets_InputType(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$());
  var $x_23 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute(\u03b43$.da, \u03b43$.cF, \u03b43$.d3, \u03b43$.cJ, \u03b43$.cl, $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().axx, \u03b43$.dg, \u03b43$.dq, \u03b43$.hd, \u03b43$.dp, \u03b43$.eH, \u03b43$.dh, \u03b43$.eI);
  var $x_22 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader("Paint", $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader$().hG());
  var \u03b44$ = builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillColor$(), new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$currentValueWithSelector($s_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$__start__Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection(), $m_s_None$(), false), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$());
  var options$1$1 = $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().a0j.hK($m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().tf);
  var hidden$2$1 = builder.Xa($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillColor$());
  var missingRowOption$1$1 = new $c_s_Some(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((attrStr) => $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().yf(attrStr))));
  var triggerGlyph$1$1 = new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("bi bi-paint-bucket")]))))));
  var $x_21 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute(\u03b44$.da, \u03b44$.cF, \u03b44$.d3, \u03b44$.cJ, \u03b44$.cl, options$1$1, \u03b44$.dg, \u03b44$.dq, hidden$2$1, \u03b44$.dp, missingRowOption$1$1, \u03b44$.dh, triggerGlyph$1$1);
  var \u03b45$ = builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Color$(), new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$currentValueWithSelector($s_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$__start__Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection(), $m_s_None$(), false), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$());
  var options$2$1 = $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().C8.hK($m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().tf);
  var missingRowOption$2$1 = new $c_s_Some(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((attrStr$2) => $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().yf(attrStr$2))));
  var triggerGlyph$2$1 = new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("bi bi-square")]))))));
  var $x_20 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute(\u03b45$.da, \u03b45$.cF, \u03b45$.d3, \u03b45$.cJ, \u03b45$.cl, options$2$1, \u03b45$.dg, \u03b45$.dq, shapeIsPlainOrPlainText, \u03b45$.dp, missingRowOption$2$1, \u03b45$.dh, triggerGlyph$2$1);
  var $x_19 = $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_VerticalAttributesView$package$();
  var $x_18 = $m_sr_ScalaRunTime$();
  var \u03b46$ = builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$(), new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$menuWithExtra(3, $s_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$__start__Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection(), $m_s_None$()), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$());
  var $x_17 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputElement($x_19.OR(builder, "nodes-border-attributes", $x_18.f(new ($d_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute.r().C)([new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute(\u03b46$.da, \u03b46$.cF, \u03b46$.d3, \u03b46$.cJ, \u03b46$.cl, $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().a9g, \u03b46$.dg, \u03b46$.dq, \u03b46$.hd, \u03b46$.dp, \u03b46$.eH, \u03b46$.dh, \u03b46$.eI), builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_PenWidth$(), new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$range(new $c_s_Some(0.1), new $c_s_Some(4.0), new $c_s_Some(0.25)), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$())]))), shapeIsPlainOrPlainText);
  var $x_16 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader("Text", $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader$().hG());
  var \u03b47$ = builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$(), $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__dropdown__Lorg_jpablo_graphexplorer_viewer_widgets_InputType(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$());
  var $x_15 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute(\u03b47$.da, \u03b47$.cF, \u03b47$.d3, \u03b47$.cJ, \u03b47$.cl, $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().axF, \u03b47$.dg, \u03b47$.dq, labelRelatedHidden, \u03b47$.dp, \u03b47$.eH, \u03b47$.dh, \u03b47$.eI);
  var \u03b48$ = builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontColor$(), new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$currentValueWithSelector($s_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$__end__Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection(), $m_s_None$(), false), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$());
  var options$3$1 = $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().C8.hK($m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().tf);
  var missingRowOption$3$1 = new $c_s_Some(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((attrStr$3) => $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_package$().yf(attrStr$3))));
  var triggerGlyph$3$1 = new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("gx-glyph-a"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "A", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))))));
  var $x_14 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute(\u03b48$.da, \u03b48$.cF, \u03b48$.d3, \u03b48$.cJ, \u03b48$.cl, options$3$1, \u03b48$.dg, \u03b48$.dq, labelRelatedHidden, \u03b48$.dp, missingRowOption$3$1, \u03b48$.dh, triggerGlyph$3$1);
  var $x_13 = $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_VerticalAttributesView$package$();
  var $x_12 = $m_sr_ScalaRunTime$();
  var \u03b49$ = builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontName$(), $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__dropdown__Lorg_jpablo_graphexplorer_viewer_widgets_InputType(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$());
  var $x_11 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute(\u03b49$.da, \u03b49$.cF, \u03b49$.d3, \u03b49$.cJ, \u03b49$.cl, \u03b49$.j6, \u03b49$.dg, \u03b49$.dq, labelRelatedHidden, \u03b49$.dp, \u03b49$.eH, \u03b49$.dh, \u03b49$.eI);
  var \u03b410$ = builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontSize$(), new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$range(new $c_s_Some(1.0), new $c_s_Some(100.0), new $c_s_Some(1.0)), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$());
  var $x_10 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputElement($x_13.OR(builder, "nodes-font-attributes", $x_12.f(new ($d_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute.r().C)([$x_11, new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute(\u03b410$.da, \u03b410$.cF, \u03b410$.d3, \u03b410$.cJ, \u03b410$.cl, \u03b410$.j6, \u03b410$.dg, \u03b410$.dq, labelRelatedHidden, \u03b410$.dp, \u03b410$.eH, \u03b410$.dh, \u03b410$.eI)]))), labelRelatedHidden);
  var $x_9 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputElement($m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_VerticalAttributesView$package$().a2x("extra-node-attributes", $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("bi-three-dots"), $m_Lcom_raquo_laminar_api_package$().b.eW().n("More attributes")]))), builder.we($m_sr_ScalaRunTime$().f(new $ac_O([new $c_T2($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_InvisibleStyle$(), $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__checkbox__Lorg_jpablo_graphexplorer_viewer_widgets_InputType()), builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_XLabel$(), $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__text__Lorg_jpablo_graphexplorer_viewer_widgets_InputType(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$()), sidesRow, new $c_T2($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Regular$(), $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__checkbox__Lorg_jpablo_graphexplorer_viewer_widgets_InputType()), new $c_T2($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Orientation$(), new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$range(new $c_s_Some(0.0), new $c_s_Some(360.0), new $c_s_Some(1.0))), new $c_T2($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Peripheries$(), new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$number(new $c_s_Some(1.0), new $c_s_Some(10.0), new $c_s_Some(1.0))), new $c_T2($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FixedSize$(), $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__checkbox__Lorg_jpablo_graphexplorer_viewer_widgets_InputType()), new $c_T2($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Width$(), new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$range(new $c_s_Some($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Width$().aEt), new $c_s_Some(5.0), new $c_s_Some(0.1))), new $c_T2($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Height$(), new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$range(new $c_s_Some($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Height$().aAW), new $c_s_Some(5.0), new $c_s_Some(0.1))), builder.c7($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_URL$(), $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__text__Lorg_jpablo_graphexplorer_viewer_widgets_InputType(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$())])))), $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputElement$().hG());
  var $x_8 = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader("Reset", $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader$().hG());
  var $x_7 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$();
  var $x_6 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$();
  var $x_5 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Button$package$();
  var $x_4 = $m_sr_ScalaRunTime$();
  var $x_3 = $m_Lcom_raquo_laminar_api_package$().b.eW().n("Reset all attributes");
  var $x_2 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Icons$().aeS($m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([]))));
  var this$97 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false));
  var onNext = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    resetAttributes.gZ($m_s_None$(), true);
  }));
  $m_Lcom_raquo_laminar_api_package$features$().cz();
  return $x_26.a2u(builder.we($x_25.f(new $ac_O([$x_24, shapeRow, $x_23, $x_22, $x_21, $x_20, $x_17, $x_16, $x_15, $x_14, $x_10, $x_9, $x_8, new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputElement($x_7.u4($x_6.iZ($x_5.hH($x_4.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_3, $x_2, new $c_Lcom_raquo_laminar_modifiers_EventListener(this$97, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2$3) => {
    onNext.a3();
  })))]))))), $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputElement$().hG())]))));
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarNodesAttributesView$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarNodesAttributesView$package$, "org.jpablo.graphexplorer.viewer.components.attributes.views.toolbarViews.ToolbarNodesAttributesView$package$", ({
  zd: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarNodesAttributesView$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarNodesAttributesView$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarNodesAttributesView$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarNodesAttributesView$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarNodesAttributesView$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_toolbarViews_ToolbarNodesAttributesView$package$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_codeMirror_CodeMirror$package$__baseExtensions$lzyINIT1$1__sr_LazyRef__Lorg_jpablo_graphexplorer_viewer_components_codeMirror_Compartment__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lcom_raquo_airstream_eventbus_EventBus__sjs_js_Array($thiz, baseExtensions$lzy1$1, wrapping$1, state$1, textUpdates$1) {
  return (baseExtensions$lzy1$1.ci ? baseExtensions$lzy1$1.cj : baseExtensions$lzy1$1.h3([$i_codemirror.basicSetup, $i_$0040codemirror$002fview.keymap.of([$i_$0040codemirror$002fcommands.indentWithTab]), $i_$0040viz$002djs$002flang$002ddot.dot(), wrapping$1.of($thiz.aQO((!(!state$1.N5.P().aq().d())))), $i_$0040codemirror$002fview.EditorView.updateListener.of(((_$1) => {
    $p_Lorg_jpablo_graphexplorer_viewer_components_codeMirror_CodeMirror$package$__updateSource$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lcom_raquo_airstream_eventbus_EventBus__Lorg_jpablo_graphexplorer_viewer_components_codeMirror_ViewUpdate__V($thiz, state$1, textUpdates$1, _$1);
  }))]));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_codeMirror_CodeMirror$package$__updateSource$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lcom_raquo_airstream_eventbus_EventBus__Lorg_jpablo_graphexplorer_viewer_components_codeMirror_ViewUpdate__V($thiz, state$3, textUpdates$3, update) {
  if ((!(!update.docChanged))) {
    var newText = $dp_toString__T(update.state.doc);
    var x = state$3.mz.P().aq().d();
    if ((!((x === null) ? (newText === null) : $dp_equals__O__Z(x, newText)))) {
      var array = update.transactions;
      _return: {
        var len = (array.length | 0);
        var i = 0;
        while ((i < len)) {
          var x0 = array[i];
          if (((!(!x0.isUserEvent("undo"))) || (!(!x0.isUserEvent("redo"))))) {
            var $x_1 = i;
            break _return;
          }
          i = ((1 + i) | 0);
        }
        var $x_1 = (-1);
      }
      var fromHistory = ($x_1 >= 0);
      var event = new $c_Lorg_jpablo_graphexplorer_viewer_components_codeMirror_EditorEdit(newText, fromHistory);
      textUpdates$3.dn.bA(event);
    }
  }
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_codeMirror_CodeMirror$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_codeMirror_CodeMirror$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_codeMirror_CodeMirror$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_codeMirror_CodeMirror$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_codeMirror_CodeMirror$package$.prototype = $p;
$p.aVL = (function(state, mods) {
  var baseExtensions$lzy1 = new $c_sr_LazyRef();
  var textUpdates = new $c_Lcom_raquo_airstream_eventbus_EventBus();
  var wrapping = new $i_$0040codemirror$002fstate.Compartment();
  return $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, mods, $m_s_$less$colon$less$().b1, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$()), $f_Lcom_raquo_laminar_api_MountHooks__onMountCallback__F1__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((baseExtensions$lzy1$2) => ((ctx) => {
    $f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription(textUpdates.k5, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((edit) => {
      if (edit.LH) {
        $f_Lorg_jpablo_graphexplorer_viewer_state_ImportOps__restoreSource__T__V(state, edit.Gc);
      } else {
        $f_Lcom_raquo_airstream_state_Var__set__O__V(state.mz, edit.Gc);
      }
    })), ctx.rj);
    var editorView = new $i_$0040codemirror$002fview.EditorView(((ctx$1$2) => (() => {
      var state$6 = null;
      var ctx$1 = null;
      var baseExtensions$lzy1$4 = null;
      var wrapping$4 = null;
      var textUpdates$5 = null;
      state$6 = state;
      ctx$1 = ctx$1$2;
      baseExtensions$lzy1$4 = baseExtensions$lzy1$2;
      wrapping$4 = wrapping;
      textUpdates$5 = textUpdates;
      var this$5 = ({});
      this$5.doc = state$6.mz.P().aq().d();
      this$5.parent = ctx$1.JW.en;
      this$5.extensions = $m_Lorg_jpablo_graphexplorer_viewer_components_codeMirror_CodeMirror$package$().b5P(baseExtensions$lzy1$4, wrapping$4, state$6, textUpdates$5);
      return this$5;
    }))(ctx)());
    $f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription(new $c_Lcom_raquo_airstream_misc_StreamFromSignal(state.N5.P(), true), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => {
      var wrap = (!(!v1));
      editorView.dispatch((() => {
        var wrapping$6 = null;
        var wrap$1 = false;
        wrapping$6 = wrapping;
        wrap$1 = wrap;
        var this$9 = ({});
        this$9.effects = wrapping$6.reconfigure($m_Lorg_jpablo_graphexplorer_viewer_components_codeMirror_CodeMirror$package$().aQO(wrap$1));
        return this$9;
      })());
    })), ctx.rj);
    $f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription(state.abs.k5, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
      $i_$0040codemirror$002fcommands.undo(editorView);
    })), ctx.rj);
    $f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription(state.abp.k5, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
      $i_$0040codemirror$002fcommands.redo(editorView);
    })), ctx.rj);
    $f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription($f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable(state.mz.P()), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((newSource) => {
      var existingSource = $dp_toString__T(editorView.state.doc);
      if ((newSource !== existingSource)) {
        editorView.dispatch(((newSource$1$2) => (() => {
          var existingSource$1 = null;
          var newSource$1 = null;
          existingSource$1 = existingSource;
          newSource$1 = newSource$1$2;
          var this$11 = ({});
          this$11.changes = ((existingSource$2$2, newSource$2$2) => (() => {
            var existingSource$2 = null;
            var newSource$2 = null;
            var outer = null;
            existingSource$2 = existingSource$2$2;
            newSource$2 = newSource$2$2;
            outer = this$11;
            if ((outer === null)) {
              throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
            }
            var this$12 = ({});
            this$12.from = 0;
            this$12.to = existingSource$2.length;
            this$12.insert = newSource$2;
            return this$12;
          }))(existingSource$1, newSource$1)();
          return this$11;
        }))(newSource)());
      }
    })), ctx.rj);
  }))(baseExtensions$lzy1)))])));
});
$p.aQO = (function(enabled) {
  return (enabled ? $i_$0040codemirror$002fview.EditorView.lineWrapping : []);
});
$p.b5P = (function(baseExtensions$lzy1$2, wrapping$2, state$2, textUpdates$2) {
  return (baseExtensions$lzy1$2.ci ? baseExtensions$lzy1$2.cj : $p_Lorg_jpablo_graphexplorer_viewer_components_codeMirror_CodeMirror$package$__baseExtensions$lzyINIT1$1__sr_LazyRef__Lorg_jpablo_graphexplorer_viewer_components_codeMirror_Compartment__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lcom_raquo_airstream_eventbus_EventBus__sjs_js_Array(this, baseExtensions$lzy1$2, wrapping$2, state$2, textUpdates$2));
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_codeMirror_CodeMirror$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_codeMirror_CodeMirror$package$, "org.jpablo.graphexplorer.viewer.components.codeMirror.CodeMirror$package$", ({
  ze: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_codeMirror_CodeMirror$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_codeMirror_CodeMirror$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_codeMirror_CodeMirror$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_codeMirror_CodeMirror$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_codeMirror_CodeMirror$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_codeMirror_CodeMirror$package$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_leftPanel_LeftPanel$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_leftPanel_LeftPanel$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_leftPanel_LeftPanel$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_leftPanel_LeftPanel$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_leftPanel_LeftPanel$package$.prototype = $p;
$p.aZY = (function(state) {
  return $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), $f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), $m_Lorg_jpablo_graphexplorer_projects_Library$().IP(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => {
    var this$1 = _$1.hY;
    var f = ((_$2) => _$2.eG);
    if ((this$1 === $m_sci_Nil$())) {
      return $m_sci_Nil$();
    } else {
      var x0 = this$1.t();
      var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
      var t = h;
      var rest = this$1.v();
      while ((rest !== $m_sci_Nil$())) {
        var x0$1 = rest.t();
        var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
        t.U = nx;
        t = nx;
        rest = rest.v();
      }
      return h;
    }
  })), $m_s_None$())), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((ids) => {
    var $x_1 = $m_sci_Map$();
    var rest$1 = ids;
    var h$1 = null;
    var t$1 = null;
    while ((rest$1 !== $m_sci_Nil$())) {
      var x0$2 = rest$1.t();
      var this$4 = $m_Lorg_jpablo_graphexplorer_projects_Library$().XM(x0$2, state.CH);
      var it = (this$4.c() ? $m_s_None$() : new $c_s_Some(new $c_T2(x0$2, this$4.d().BI))).o();
      while (it.p()) {
        var nx$1 = new $c_sci_$colon$colon(it.q(), $m_sci_Nil$());
        if ((t$1 === null)) {
          h$1 = nx$1;
        } else {
          t$1.U = nx$1;
        }
        t$1 = nx$1;
      }
      rest$1 = rest$1.v();
    }
    return $x_1.ao(((h$1 === null) ? $m_sci_Nil$() : h$1));
  })), $m_s_None$());
});
$p.aW3 = (function(state, router, commands) {
  return $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("border-r border-base-300"), $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.gz().n("left-panel"), $m_Lcom_raquo_laminar_api_package$().b.y.ael($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), state.H7.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4) => ((!(!_$4)) ? "w-[16rem] opacity-100 visible" : "w-0 opacity-0 invisible"))), $m_s_None$()), $m_Lcom_raquo_laminar_api_package$().b.aew()), $m_Lcom_raquo_laminar_api_package$().b.PZ().bj($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), state.H7.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((visible) => ((!(!visible)) ? "--left-panel-width: 16rem; --left-panel-border-width: 0px;" : "--left-panel-width: 0px; --left-panel-border-width: 0px;"))), $m_s_None$())), $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("header-section flex flex-col h-full"), $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("flex items-center border-b border-base-300 px-2 pb-1"), $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("flex items-center justify-between w-full ml-2 mt-1.5"), $m_Lcom_raquo_laminar_api_package$().b.E3().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("text-lg font-semibold flex-1"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Library", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $m_Lorg_jpablo_graphexplorer_viewer_widgets_IconButton$package$().Ae("bi-plus-circle", "Create Diagram", "tooltip-bottom", $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([])), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    commands.a8R.SL.gZ(new $c_s_Some(new $c_s_Some($m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$().GZ)), true);
  })))])))]))), $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("grow overflow-y-auto"), $m_Lcom_raquo_laminar_api_package$().b.Q6().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("menu menu-sm w-full"), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_inserters_ChildrenInserter$().IB($m_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$().aYI($m_Lorg_jpablo_graphexplorer_projects_Library$().IP(), $m_Lorg_jpablo_graphexplorer_viewer_components_leftPanel_LeftPanel$package$().aZY(state), state.a10, state.gn().ab7, new $c_sr_AbstractFunction4_$$Lambda$451042f443265710aa66de6985cba67480d9b00a(((directory, names, openTitle, openProject) => {
    var this$17 = $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(directory.hY, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$5) => {
      var $x_1 = _$5;
      var x_$_lo = $x_1.ox;
      var x_$_hi = $x_1.oy;
      var lo = ((-x_$_lo) | 0);
      var hi = ((((-x_$_hi) | 0) - ((lo !== 0) | 0)) | 0);
      return $bL(lo, hi);
    })), $m_s_math_Ordering$Long$());
    var f$1 = ((openProject$2, openTitle$2, names$2) => ((project$2) => {
      var x$1 = project$2.eG;
      var x$2 = openProject$2.xn;
      if (((x$1 === null) ? (x$2 === null) : x$1.e(x$2))) {
        var shown = openTitle$2;
      } else {
        var shown = names$2.ay(project$2.eG, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((project$2$1) => (() => project$2$1.nb))(project$2)));
      }
      var $x_8 = $m_Lcom_raquo_laminar_api_package$().b.yc();
      var $x_7 = $m_sr_ScalaRunTime$();
      var $x_6 = $m_Lcom_raquo_laminar_api_package$().b.DD();
      var $x_5 = $m_sr_ScalaRunTime$();
      var $x_4 = $m_Lcom_raquo_laminar_api_package$().b.y.s("flex items-center gap-2");
      var $x_3 = $m_Lcom_raquo_laminar_api_package$().b.y.s("gx-row-active").bj($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), state.gn().ab7, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((project$3) => ((_$6) => {
        var x$3 = _$6.xn;
        var x$2$1 = project$3.eG;
        return ((x$3 === null) ? (x$2$1 === null) : x$3.e(x$2$1));
      }))(project$2)), $m_s_None$()));
      var $x_2 = $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("truncate"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, shown, $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])));
      var this$16 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false));
      var onNext = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((project$4$1) => (() => {
        router.rh(new $c_Lorg_jpablo_graphexplorer_router_Route$ProjectDetail(project$4$1.eG.cv, $m_s_None$()));
      }))(project$2));
      $m_Lcom_raquo_laminar_api_package$features$().cz();
      return $x_8.w($x_7.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_6.w($x_5.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_4, $x_3, $x_2, new $c_Lcom_raquo_laminar_modifiers_EventListener(this$16, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => {
        onNext.a3();
      })))])))])));
    }))(openProject, openTitle, names);
    if ((this$17 === $m_sci_Nil$())) {
      return $m_sci_Nil$();
    } else {
      var x0 = this$17.t();
      var h = new $c_sci_$colon$colon(f$1(x0), $m_sci_Nil$());
      var t = h;
      var rest = this$17.v();
      while ((rest !== $m_sci_Nil$())) {
        var x0$1 = rest.t();
        var nx = new $c_sci_$colon$colon(f$1(x0$1), $m_sci_Nil$());
        t.U = nx;
        t = nx;
        rest = rest.v();
      }
      return h;
    }
  }))), $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$(), $m_Lcom_raquo_laminar_modifiers_RenderableNode$().ht, (void 0)))])))])))])))])))])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_leftPanel_LeftPanel$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_leftPanel_LeftPanel$package$, "org.jpablo.graphexplorer.viewer.components.leftPanel.LeftPanel$package$", ({
  zf: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_leftPanel_LeftPanel$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_leftPanel_LeftPanel$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_leftPanel_LeftPanel$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_leftPanel_LeftPanel$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_leftPanel_LeftPanel$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_leftPanel_LeftPanel$package$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__nodeLabel$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_NodeId__T($thiz, graph, nodeId) {
  var this$1 = graph.dQ.r(nodeId);
  if (this$1.c()) {
    var this$5 = $m_s_None$();
  } else {
    var x0 = this$1.d();
    var lbl = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_LabelSummary$().ai2($f_Lorg_jpablo_graphexplorer_viewer_models_ViewerElement__label__Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(x0).m(), $f_Lorg_jpablo_graphexplorer_viewer_graph_CombineNodesOps__isRecordNode__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Z(graph, nodeId), 120);
    var this$5 = new $c_s_Some(((lbl !== "") ? lbl : nodeId.dE));
  }
  return (this$5.c() ? nodeId.dE : this$5.d());
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__nodeSearchText$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_NodeId__T($thiz, graph, nodeId) {
  var this$1 = graph.dQ.r(nodeId);
  var this$2 = (this$1.c() ? $m_s_None$() : new $c_s_Some($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_LabelSummary$().aOJ($f_Lorg_jpablo_graphexplorer_viewer_models_ViewerElement__label__Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(this$1.d()).m(), $f_Lorg_jpablo_graphexplorer_viewer_graph_CombineNodesOps__isRecordNode__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Z(graph, nodeId))));
  return (this$2.c() ? "" : this$2.d());
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__nodeFill$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_NodeId__s_Option($thiz, graph, nodeId) {
  var this$1 = graph.dQ.r(nodeId);
  var this$3 = (this$1.c() ? $m_s_None$() : this$1.d().fH.r(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillColor$()))));
  var this$4 = (this$3.c() ? $m_s_None$() : new $c_s_Some(this$3.d().m()));
  return ((this$4.c() || (this$4.d() !== "")) ? this$4 : $m_s_None$());
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__groupLabel$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_GroupId__T($thiz, graph, groupId) {
  var this$1 = graph.hu.r(groupId);
  if (this$1.c()) {
    var this$5 = $m_s_None$();
  } else {
    var x0 = this$1.d();
    var lbl = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_LabelSummary$().ai2($f_Lorg_jpablo_graphexplorer_viewer_models_ViewerElement__label__Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(x0).m(), false, 120);
    var this$5 = new $c_s_Some(((lbl !== "") ? lbl : groupId.dR));
  }
  return (this$5.c() ? groupId.dR : this$5.d());
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__groupFill$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_GroupId__s_Option($thiz, graph, groupId) {
  var this$1 = graph.hu.r(groupId);
  if (this$1.c()) {
    return $m_s_None$();
  } else {
    var x0 = this$1.d();
    var vs = x0.kb;
    var this$3 = vs.r(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BgColor$())));
    var this$5 = (this$3.c() ? vs.r(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillColor$()))) : this$3);
    var this$6 = (this$5.c() ? $m_s_None$() : new $c_s_Some(this$5.d().m()));
    return ((this$6.c() || (this$6.d() !== "")) ? this$6 : $m_s_None$());
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__groupMatches$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_GroupId__T__Z($thiz, graph, groupId, filter) {
  var this$1 = $f_T__trim__T(filter);
  var f = this$1.toLowerCase();
  if ((f === "")) {
    var $x_1 = true;
  } else {
    var this$2 = groupId.dR;
    var this$3 = this$2.toLowerCase();
    var $x_1 = ((this$3.indexOf(f) | 0) !== (-1));
  }
  if ($x_1) {
    return true;
  } else {
    var this$4 = $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__groupLabel$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_GroupId__T($thiz, graph, groupId);
    var this$5 = this$4.toLowerCase();
    return ((this$5.indexOf(f) | 0) !== (-1));
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__groupVisible$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_GroupId__Lcom_raquo_airstream_core_Signal($thiz, state$1, graph, groupId) {
  return $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), state$1.il().N6, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6) => $m_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$().aP2(graph, groupId, ((_$6 === null) ? null : _$6.aS)))), $m_s_None$());
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__groupListed$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_GroupId__Z__sci_Set__Z($thiz, graph, groupId, showHidden, hidden) {
  return (showHidden || $m_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$().aP2(graph, groupId, hidden));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__collidingLabels$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__sci_Set($thiz, graph) {
  var $x_1 = $m_sci_Set$();
  var this$1 = graph.dQ;
  var this$2 = new $c_sc_MapOps$$anon$2(this$1);
  var this$3 = $m_sci_Vector$().X(this$2);
  var m = $m_scm_Map$().aO();
  var it = this$3.o();
  while (it.p()) {
    var elem = it.q();
    var key = $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__nodeLabel$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_NodeId__T($thiz, graph, elem);
    m.ec(key, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      $m_sci_Vector$();
      return new $c_sci_VectorBuilder();
    }))).Y(elem);
  }
  var result = $m_sci_HashMap$().fk;
  var mapIt = m.o();
  while (mapIt.p()) {
    var x1 = mapIt.q();
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1);
    }
    var k = x1.g();
    var v = x1.h();
    result = result.hq(k, v.aR());
  }
  return $x_1.af($f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(result, new $c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$$anon$2()));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__nodeMatches$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_NodeId__T__Z($thiz, graph, nodeId, filter) {
  var this$1 = $f_T__trim__T(filter);
  var f = this$1.toLowerCase();
  if ((f === "")) {
    var $x_1 = true;
  } else {
    var this$2 = nodeId.dE;
    var this$3 = this$2.toLowerCase();
    var $x_1 = ((this$3.indexOf(f) | 0) !== (-1));
  }
  if ($x_1) {
    return true;
  } else {
    var this$4 = $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__nodeSearchText$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_NodeId__T($thiz, graph, nodeId);
    var this$5 = this$4.toLowerCase();
    return ((this$5.indexOf(f) | 0) !== (-1));
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__arrowMatches$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_Arrow__T__Z($thiz, graph, arrow, filter) {
  var this$1 = $f_T__trim__T(filter);
  var f = this$1.toLowerCase();
  if ((f === "")) {
    var $x_2 = true;
  } else {
    var this$2 = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_LabelSummary$().aOJ($f_Lorg_jpablo_graphexplorer_viewer_models_ViewerElement__label__Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(arrow).m(), false);
    var this$3 = this$2.toLowerCase();
    var $x_2 = ((this$3.indexOf(f) | 0) !== (-1));
  }
  if ($x_2) {
    var $x_1 = true;
  } else {
    var this$4 = $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__nodeSearchText$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_NodeId__T($thiz, graph, arrow.bX);
    var this$5 = this$4.toLowerCase();
    var $x_1 = ((this$5.indexOf(f) | 0) !== (-1));
  }
  if ($x_1) {
    return true;
  } else {
    var this$6 = $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__nodeSearchText$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_NodeId__T($thiz, graph, arrow.c0);
    var this$7 = this$6.toLowerCase();
    return ((this$7.indexOf(f) | 0) !== (-1));
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__listed$1__Lorg_jpablo_graphexplorer_viewer_models_ElementId__Z__sci_Set__Z($thiz, id, showHidden, hidden) {
  return (showHidden || (!$m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().mJ(hidden, id)));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__shownIds$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__s_Option__T__Z__sci_Set__sci_Set($thiz, graph, kind, filter, showHidden, hidden) {
  var nodes = ((kind.E($s_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$__Arrows__Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind()) || kind.E($s_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$__Groups__Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind())) ? $m_sci_Set$EmptySet$() : $m_sci_Set$().af(graph.j8.bw(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n) => ($p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__nodeMatches$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_NodeId__T__Z($thiz, graph, n, filter) && $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__listed$1__Lorg_jpablo_graphexplorer_viewer_models_ElementId__Z__sci_Set__Z($thiz, n, showHidden, hidden)))))));
  var arrows = ((kind.E($s_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$__Nodes__Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind()) || kind.E($s_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$__Groups__Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind())) ? $m_sci_Set$EmptySet$() : $m_sci_Set$().af(graph.fX.e6().bw(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((a) => ($p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__arrowMatches$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_Arrow__T__Z($thiz, graph, a, filter) && $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__listed$1__Lorg_jpablo_graphexplorer_viewer_models_ElementId__Z__sci_Set__Z($thiz, a.dw, showHidden, hidden))))).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$7) => _$7.dw)))));
  if ((!kind.c())) {
    var x0 = kind.d();
    var x$2 = $s_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$__Groups__Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind();
    var $x_1 = (!((x0 === null) ? (x$2 === null) : (x0 === x$2)));
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    var groups = $m_sci_Set$EmptySet$();
  } else {
    var groups = $m_sci_Set$().af(graph.xf.lT($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$().p4).bw(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((g) => ($p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__groupMatches$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_GroupId__T__Z($thiz, graph, g, filter) && $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__groupListed$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_GroupId__Z__sci_Set__Z($thiz, graph, g, showHidden, hidden))))));
  }
  return nodes.dI(arrows).dI(groups);
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__selectShown$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lcom_raquo_airstream_state_Var__Lcom_raquo_airstream_state_Var__Lcom_raquo_airstream_state_Var__V($thiz, state$2, kindVar$1, filterVar$1, showHiddenVar$1) {
  state$2.aH().gC($p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__shownIds$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__s_Option__T__Z__sci_Set__sci_Set($thiz, $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__fullGraphObs__Lcom_raquo_airstream_state_OwnedSignal(state$2)).d(), kindVar$1.P().aq().d(), filterVar$1.P().aq().d(), (!(!showHiddenVar$1.P().aq().d())), state$2.il().cL()));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__closePalette$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__V($thiz, state$3) {
  if ((!(!(!state$3.H4.P().aq().d())))) {
    $f_Lcom_raquo_airstream_state_Var__set__O__V(state$3.qs, $s_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$__none__Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection());
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__eyeControl$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_viewer_models_ElementId__F0__F0__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($thiz, state$4, id, hide, show) {
  var $x_5 = $m_Lcom_raquo_laminar_api_package$().b.aU();
  var $x_4 = $m_sr_ScalaRunTime$();
  var $x_3 = $m_Lcom_raquo_laminar_api_package$().b.y.s("el-eye");
  var $x_2 = $m_Lcom_raquo_laminar_api_package$().b.eW().bj($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), $f_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__isElementVisible__Lorg_jpablo_graphexplorer_viewer_models_ElementId__Lcom_raquo_airstream_core_Signal(state$4, id), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v) => ((!(!v)) ? "Hide" : "Show"))), $m_s_None$()));
  var $x_1 = $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("bi bi-eye").bj($f_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__isElementVisible__Lorg_jpablo_graphexplorer_viewer_models_ElementId__Lcom_raquo_airstream_core_Signal(state$4, id)), $m_Lcom_raquo_laminar_api_package$().b.y.s("bi bi-eye-slash").bj(($m_Lcom_raquo_airstream_core_Observable$(), $m_Lcom_raquo_airstream_extensions_BooleanObservable$().r1($f_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__isElementVisible__Lorg_jpablo_graphexplorer_viewer_models_ElementId__Lcom_raquo_airstream_core_Signal(state$4, id))))])));
  var this$9 = new $c_Lcom_raquo_laminar_keys_LockedEventKey(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false)).AG(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$9) => {
    $m_Lcom_raquo_airstream_core_EventStream$();
    return $m_Lcom_raquo_airstream_combine_generated_CombinableStream$().XV(_$9, $f_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__isElementVisible__Lorg_jpablo_graphexplorer_viewer_models_ElementId__Lcom_raquo_airstream_core_Signal(state$4, id));
  })));
  var onNext = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => {
    if ((!(!v1))) {
      hide.a3();
    } else {
      show.a3();
    }
  }));
  return $x_5.w($x_4.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_3, $x_2, $x_1, this$9.Iv($m_Lcom_raquo_airstream_core_Observer$().wo(onNext, $m_s_PartialFunction$().gt, true))])));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__nodeRow$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_NodeId__sci_Set__Z__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($thiz, state$35, graph, nodeId, colliding, nested) {
  return $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("el-row"), $m_Lcom_raquo_laminar_api_package$().b.y.s("el-nested").xV(nested), $f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__nodeRowMods$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_NodeId__sci_Set__sci_Seq($thiz, state$35, graph, nodeId, colliding), $m_s_$less$colon$less$().b1, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())])));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__nodeEntry$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lcom_raquo_airstream_state_Var__Lcom_raquo_airstream_state_Var__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_NodeId__sci_Set__Z__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($thiz, state$6, expandOverrideV$1, expandedRecordsV$1, graph, nodeId, colliding, nested) {
  var boxes = state$6.du().DO(nodeId);
  var x = boxes.C();
  if ((((x === 2) ? 0 : ((x < 2) ? (-1) : 1)) < 0)) {
    return $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__nodeRow$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_NodeId__sci_Set__Z__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($thiz, state$6, graph, nodeId, colliding, nested);
  } else {
    return $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.aNn().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("el-group"), $m_Lorg_jpablo_graphexplorer_viewer_domUtils_DomUtils$package$().a9Y.bj($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), $m_Lcom_raquo_airstream_combine_generated_CombinableSignal$().vV(expandOverrideV$1.P(), expandedRecordsV$1.P(), new $c_Lapp_tulz_tuplez_Composition\uff3fPri0$$anon$1()), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
      if ((x$1 !== null)) {
        var x11 = x$1.g();
        if ((x11 instanceof $c_s_Some)) {
          return (!(!x11.J));
        }
        if (($m_s_None$() === x11)) {
          return x$1.h().E(nodeId);
        }
      }
      throw new $c_s_MatchError(x$1);
    })), $m_s_None$())), $m_Lcom_raquo_laminar_api_package$().b.aSB().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("el-row el-group-head"), $m_Lcom_raquo_laminar_api_package$().b.y.s("el-nested").xV(nested), $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("el-kind el-chevron"), $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("bi bi-chevron-down")])))]))), $f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__nodeRowMods$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_NodeId__sci_Set__sci_Seq($thiz, state$6, graph, nodeId, colliding), $m_s_$less$colon$less$().b1, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$()), new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false)).jY(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$10) => {
      $f_Lcom_raquo_airstream_state_Var__set__O__V(expandOverrideV$1, $m_s_None$());
      $f_Lcom_raquo_airstream_state_Var__update__F1__V(expandedRecordsV$1, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((set$1) => (set$1.E(nodeId) ? set$1.lT(nodeId) : set$1.hQ(nodeId)))));
    })))]))), $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__nodeSeqToModifier__O__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, boxes.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$11) => $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__cellRow$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Lorg_jpablo_graphexplorer_viewer_state_RecordCellBox__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($thiz, state$6, nodeId, _$11)))), $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())])))])))])));
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__cellRow$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Lorg_jpablo_graphexplorer_viewer_state_RecordCellBox__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($thiz, state$8, nodeId, box) {
  var text = state$8.du().aME(new $c_Lorg_jpablo_graphexplorer_viewer_state_SelectedCell(nodeId, box.qq));
  var isSelected = $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), state$8.gs.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$12) => {
    if ((!_$12.c())) {
      var x0 = _$12.d();
      var x = x0.bT;
      if (((x === null) ? (nodeId === null) : x.e(nodeId))) {
        var x$3 = x0.f4;
        var x$4 = box.qq;
        return ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
      } else {
        return false;
      }
    } else {
      return false;
    }
  })), $m_s_None$());
  var $x_7 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_6 = $m_sr_ScalaRunTime$();
  var $x_5 = $m_Lcom_raquo_laminar_api_package$().b.y.s("el-row el-nested el-cell-row");
  var $x_4 = $m_Lcom_raquo_laminar_api_package$().b.y.s("el-selected").bj(isSelected);
  var $x_3 = $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("el-kind"), $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("bi bi-dash-lg")])))])));
  var $x_2 = $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("el-label"), $m_Lcom_raquo_laminar_api_package$().b.eW().n(text), ((text !== "") ? $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, text, $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7) : $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "\u2014", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7))])));
  var this$10 = $m_Lcom_raquo_laminar_api_package$().b;
  var this$8 = box.H1;
  if (this$8.c()) {
    var $x_1 = $m_s_None$();
  } else {
    var x0$1 = this$8.d();
    var $x_1 = new $c_s_Some($m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("el-id"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, (("<" + x0$1) + ">"), $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))));
  }
  return $x_7.w($x_6.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_5, $x_4, $x_3, $x_2, $f_Lcom_raquo_laminar_api_Implicits__nodeOptionToModifier__s_Option__Lcom_raquo_laminar_modifiers_Modifier(this$10, $x_1), new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.Av(), false, false)).jY(), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((sink) => ((_$1) => {
    sink.bA(_$1);
  }))($m_Lcom_raquo_laminar_api_package$().b.ED.m5))), new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false)).AG(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$13) => {
    state$8.aH().gC($m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_ElementId.r().C)([nodeId]))));
    state$8.du().pG(nodeId, box.qq);
  })))])));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__nodeRowMods$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_NodeId__sci_Set__sci_Seq($thiz, state$10, graph, nodeId, colliding) {
  var label = $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__nodeLabel$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_NodeId__T($thiz, graph, nodeId);
  var $x_18 = $m_sci_Seq$();
  var $x_17 = $m_sr_ScalaRunTime$();
  var $x_16 = $m_Lcom_raquo_laminar_api_package$().b.y.s("el-hidden").bj(($m_Lcom_raquo_airstream_core_Observable$(), $m_Lcom_raquo_airstream_extensions_BooleanObservable$().r1($f_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__isElementVisible__Lorg_jpablo_graphexplorer_viewer_models_ElementId__Lcom_raquo_airstream_core_Signal(state$10, nodeId))));
  var $x_15 = $m_Lcom_raquo_laminar_api_package$().b.y.s("el-selected").bj(state$10.aH().a2Z(nodeId));
  var $x_14 = $m_Lcom_raquo_laminar_api_package$().b.aU();
  var $x_13 = $m_sr_ScalaRunTime$();
  var $x_12 = $m_Lcom_raquo_laminar_api_package$().b.y.s("el-swatch");
  matchResult5: {
    var $x_11;
    var x15 = $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__nodeFill$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_NodeId__s_Option($thiz, graph, nodeId);
    if ((x15 instanceof $c_s_Some)) {
      var c = x15.J;
      var $x_11 = $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("bi bi-square-fill"), $m_Lcom_raquo_laminar_api_package$().b.PZ().n(("color: " + c))])));
      break matchResult5;
    }
    if (($m_s_None$() === x15)) {
      var $x_11 = $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("bi bi-square")])));
      break matchResult5;
    }
    throw new $c_s_MatchError(x15);
  }
  var $x_10 = $x_14.w($x_13.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_12, $x_11])));
  var $x_9 = $m_Lcom_raquo_laminar_api_package$().b.aU();
  var $x_8 = $m_sr_ScalaRunTime$();
  var $x_7 = $m_Lcom_raquo_laminar_api_package$().b.y.s("el-label");
  var $x_6 = $m_Lcom_raquo_laminar_api_package$().b.eW();
  var full = $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__nodeSearchText$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_NodeId__T($thiz, graph, nodeId);
  var $x_5 = $x_9.w($x_8.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_7, $x_6.n((((full !== "") && (full !== label)) ? full : nodeId.dE)), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, label, $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])));
  var $x_4 = $f_Lcom_raquo_laminar_api_Implicits__nodeOptionToModifier__s_Option__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, ((colliding.E(label) && (nodeId.dE !== label)) ? new $c_s_Some($m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("el-id"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, ("#" + nodeId.dE), $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))) : $m_s_None$()));
  var $x_3 = $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__eyeControl$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_viewer_models_ElementId__F0__F0__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($thiz, state$10, nodeId, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    var ids = $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_NodeId.r().C)([nodeId])));
    state$10.il().OU(ids);
  })), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    var ids$1 = $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_NodeId.r().C)([nodeId])));
    state$10.il().XR(ids$1);
  })));
  var $x_2 = new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.Av(), false, false)).jY(), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((sink) => ((_$1) => {
    sink.bA(_$1);
  }))($m_Lcom_raquo_laminar_api_package$().b.ED.m5)));
  var $x_1 = new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false)).E9(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$14) => (!(!_$14.shiftKey))))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => {
    var shiftKey = (!(!v1));
    state$10.aH().a57(nodeId, shiftKey);
  })));
  var this$22 = new $c_Lcom_raquo_laminar_keys_LockedEventKey(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.aQG(), false, false)).jY().AG(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$15) => {
    $m_Lcom_raquo_airstream_core_EventStream$();
    return $m_Lcom_raquo_airstream_combine_generated_CombinableStream$().XV(_$15, $f_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__isElementVisible__Lorg_jpablo_graphexplorer_viewer_models_ElementId__Lcom_raquo_airstream_core_Signal(state$10, nodeId));
  })));
  var onNext$2 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1$2) => {
    if ((!(!v1$2))) {
      var ids$2 = $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_NodeId.r().C)([nodeId])));
      state$10.il().OU(ids$2);
    } else {
      var ids$3 = $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_NodeId.r().C)([nodeId])));
      state$10.il().XR(ids$3);
    }
  }));
  return $x_18.kM($x_17.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_16, $x_15, $x_10, $x_5, $x_4, $x_3, $x_2, $x_1, this$22.Iv($m_Lcom_raquo_airstream_core_Observer$().wo(onNext$2, $m_s_PartialFunction$().gt, true))])));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__arrowRow$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_Arrow__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($thiz, state$16, graph, arrow) {
  var lbl = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_LabelSummary$().ai2($f_Lorg_jpablo_graphexplorer_viewer_models_ViewerElement__label__Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(arrow).m(), false, 120);
  return $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("el-row el-nested"), $m_Lcom_raquo_laminar_api_package$().b.y.s("el-hidden").bj(($m_Lcom_raquo_airstream_core_Observable$(), $m_Lcom_raquo_airstream_extensions_BooleanObservable$().r1($f_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__isElementVisible__Lorg_jpablo_graphexplorer_viewer_models_ElementId__Lcom_raquo_airstream_core_Signal(state$16, arrow.dw)))), $m_Lcom_raquo_laminar_api_package$().b.y.s("el-selected").bj(state$16.aH().a2Z(arrow.dw)), $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("el-kind"), $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("bi bi-arrow-right")])))]))), $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("el-label"), $m_Lcom_raquo_laminar_api_package$().b.eW().n(arrow.dw.l3), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, (($p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__nodeLabel$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_NodeId__T($thiz, graph, arrow.bX) + " \u2192 ") + $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__nodeLabel$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_NodeId__T($thiz, graph, arrow.c0)), $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7), $f_Lcom_raquo_laminar_api_Implicits__nodeOptionToModifier__s_Option__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, ((lbl !== "") ? new $c_s_Some($m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("el-id"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, lbl, $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))) : $m_s_None$()))]))), $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__eyeControl$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_viewer_models_ElementId__F0__F0__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($thiz, state$16, arrow.dw, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    state$16.il().zI.i(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds($m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().tS(((v1 === null) ? null : v1.aS), $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_ArrowId.r().C)([arrow.dw]))))))));
  })), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    state$16.il().zI.i(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1$1) => new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds($m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().yk(((v1$1 === null) ? null : v1$1.aS), $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_ArrowId.r().C)([arrow.dw]))))))));
  }))), new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.Av(), false, false)).jY(), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((sink) => ((_$1) => {
    sink.bA(_$1);
  }))($m_Lcom_raquo_laminar_api_package$().b.ED.m5))), new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false)).E9(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$18) => (!(!_$18.shiftKey))))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1$2) => {
    var shiftKey = (!(!v1$2));
    state$16.aH().b2m(arrow, shiftKey);
  })))])));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__groupSwatch$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_GroupId__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($thiz, graph, groupId) {
  var $x_4 = $m_Lcom_raquo_laminar_api_package$().b.aU();
  var $x_3 = $m_sr_ScalaRunTime$();
  var $x_2 = $m_Lcom_raquo_laminar_api_package$().b.y.s("el-swatch");
  matchResult6: {
    var $x_1;
    var x18 = $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__groupFill$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_GroupId__s_Option($thiz, graph, groupId);
    if ((x18 instanceof $c_s_Some)) {
      var c = x18.J;
      var $x_1 = $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("bi bi-folder-fill"), $m_Lcom_raquo_laminar_api_package$().b.PZ().n(("color: " + c))])));
      break matchResult6;
    }
    if (($m_s_None$() === x18)) {
      var $x_1 = $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("bi bi-folder")])));
      break matchResult6;
    }
    throw new $c_s_MatchError(x18);
  }
  return $x_4.w($x_3.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_2, $x_1])));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__groupEye$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_GroupId__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($thiz, state$21, graph, groupId) {
  var visible = $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__groupVisible$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_GroupId__Lcom_raquo_airstream_core_Signal($thiz, state$21, graph, groupId);
  var $x_5 = $m_Lcom_raquo_laminar_api_package$().b.aU();
  var $x_4 = $m_sr_ScalaRunTime$();
  var $x_3 = $m_Lcom_raquo_laminar_api_package$().b.y.s("el-eye");
  var $x_2 = $m_Lcom_raquo_laminar_api_package$().b.eW().bj($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), visible, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v) => ((!(!v)) ? "Hide members" : "Show members"))), $m_s_None$()));
  var $x_1 = $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("bi bi-eye").bj(visible), $m_Lcom_raquo_laminar_api_package$().b.y.s("bi bi-eye-slash").bj(($m_Lcom_raquo_airstream_core_Observable$(), $m_Lcom_raquo_airstream_extensions_BooleanObservable$().r1(visible)))])));
  var this$9 = new $c_Lcom_raquo_laminar_keys_LockedEventKey(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false)).AG(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$19) => {
    $m_Lcom_raquo_airstream_core_EventStream$();
    return $m_Lcom_raquo_airstream_combine_generated_CombinableStream$().XV(_$19, visible);
  })));
  var onNext = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => {
    var isVisible = (!(!v1));
    var members = $m_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$().ah1(graph, groupId);
    if (isVisible) {
      state$21.il().OU(members);
    } else {
      state$21.il().XR(members);
    }
  }));
  return $x_5.w($x_4.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_3, $x_2, $x_1, this$9.Iv($m_Lcom_raquo_airstream_core_Observer$().wo(onNext, $m_s_PartialFunction$().gt, true))])));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__groupCollapse$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_viewer_models_GroupId__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($thiz, state$22, groupId) {
  var collapsed = state$22.b3k(groupId);
  return $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("el-collapse"), $m_Lcom_raquo_laminar_api_package$().b.y.s("el-is-collapsed").bj(collapsed), $m_Lcom_raquo_laminar_api_package$().b.eW().bj($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), collapsed, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((c) => ((!(!c)) ? "Expand group" : "Collapse group"))), $m_s_None$())), $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("bi bi-arrows-angle-expand").bj(collapsed), $m_Lcom_raquo_laminar_api_package$().b.y.s("bi bi-arrows-angle-contract").bj(($m_Lcom_raquo_airstream_core_Observable$(), $m_Lcom_raquo_airstream_extensions_BooleanObservable$().r1(collapsed)))]))), new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false)).jY().AG(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$20) => {
    state$22.bal(groupId);
  })))])));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__renderGroup$1__Lcom_raquo_airstream_state_Var__Lcom_raquo_airstream_state_Var__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lcom_raquo_airstream_state_Var__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_GroupId__sci_Set__T__Z__sci_Set__s_Option($thiz, expandOverrideV$5, expandedGroupsV$2, state$26, expandedRecordsV$5, graph, groupId, colliding, filter, showHidden, hidden) {
  var x$2 = $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$().p4;
  if (((groupId === null) ? (x$2 === null) : groupId.e(x$2))) {
    return $m_s_None$();
  } else {
    var children = $m_sci_Seq$().fw($f_Lorg_jpablo_graphexplorer_viewer_graph_GroupsOps__getDirectChildren__sci_Set__sci_Set(graph, $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_GroupId.r().C)([groupId]))))).c5(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
      if ((x$1 instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId)) {
        return $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__renderGroup$1__Lcom_raquo_airstream_state_Var__Lcom_raquo_airstream_state_Var__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lcom_raquo_airstream_state_Var__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_GroupId__sci_Set__T__Z__sci_Set__s_Option($thiz, expandOverrideV$5, expandedGroupsV$2, state$26, expandedRecordsV$5, graph, x$1, colliding, filter, showHidden, hidden);
      }
      if ((x$1 instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId)) {
        return (($p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__nodeMatches$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_NodeId__T__Z($thiz, graph, x$1, filter) && $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__listed$1__Lorg_jpablo_graphexplorer_viewer_models_ElementId__Z__sci_Set__Z($thiz, x$1, showHidden, hidden)) ? new $c_s_Some($p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__nodeEntry$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lcom_raquo_airstream_state_Var__Lcom_raquo_airstream_state_Var__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_NodeId__sci_Set__Z__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($thiz, state$26, expandOverrideV$5, expandedRecordsV$5, graph, x$1, colliding, true)) : $m_s_None$());
      }
      throw new $c_s_MatchError(x$1);
    })));
    return ((children.c() && (!($p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__groupMatches$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_GroupId__T__Z($thiz, graph, groupId, filter) && $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__groupListed$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_GroupId__Z__sci_Set__Z($thiz, graph, groupId, showHidden, hidden)))) ? $m_s_None$() : new $c_s_Some($m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.aNn().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("el-group"), $m_Lorg_jpablo_graphexplorer_viewer_domUtils_DomUtils$package$().a9Y.bj($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), $m_Lcom_raquo_airstream_combine_generated_CombinableSignal$().vV(expandOverrideV$5.P(), expandedGroupsV$2.P(), new $c_Lapp_tulz_tuplez_Composition\uff3fPri0$$anon$1()), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
      if ((x$1$2 !== null)) {
        var x27 = x$1$2.g();
        if ((x27 instanceof $c_s_Some)) {
          return (!(!x27.J));
        }
        if (($m_s_None$() === x27)) {
          return x$1$2.h().E(groupId);
        }
      }
      throw new $c_s_MatchError(x$1$2);
    })), $m_s_None$())), $m_Lcom_raquo_laminar_api_package$().b.aSB().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("el-row el-group-head"), $m_Lcom_raquo_laminar_api_package$().b.y.s("el-hidden").bj(($m_Lcom_raquo_airstream_core_Observable$(), $m_Lcom_raquo_airstream_extensions_BooleanObservable$().r1($p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__groupVisible$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_GroupId__Lcom_raquo_airstream_core_Signal($thiz, state$26, graph, groupId)))), $m_Lcom_raquo_laminar_api_package$().b.y.s("el-selected").bj(state$26.aH().a2Z(groupId)), $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("el-kind el-chevron"), $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("bi bi-chevron-down")])))]))), $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__groupSwatch$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_GroupId__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($thiz, graph, groupId), $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("el-label"), $m_Lcom_raquo_laminar_api_package$().b.eW().n(groupId.dR), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__groupLabel$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_GroupId__T($thiz, graph, groupId), $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__groupCollapse$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_viewer_models_GroupId__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($thiz, state$26, groupId), $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__groupEye$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_GroupId__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($thiz, state$26, graph, groupId), new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.Av(), false, false)).jY(), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((sink) => ((_$1) => {
      sink.bA(_$1);
    }))($m_Lcom_raquo_laminar_api_package$().b.ED.m5))), new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false)).jY(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e) => {
      state$26.aH().a57(groupId, (!(!e.shiftKey)));
      $f_Lcom_raquo_airstream_state_Var__set__O__V(expandOverrideV$5, $m_s_None$());
      $f_Lcom_raquo_airstream_state_Var__update__F1__V(expandedGroupsV$2, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((set$1) => (set$1.E(groupId) ? set$1.lT(groupId) : set$1.hQ(groupId)))));
    })))]))), $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__nodeSeqToModifier__O__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, children, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())])))])))])))));
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__renderGroupsSection$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__T__Z__sci_Set__sci_Seq($thiz, state$29, graph, filter, showHidden, hidden) {
  return $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O($m_sci_Seq$().fw(graph.xf.lT($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$().p4)).bw(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((g) => ($p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__groupMatches$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_GroupId__T__Z($thiz, graph, g, filter) && $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__groupListed$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_GroupId__Z__sci_Set__Z($thiz, graph, g, showHidden, hidden))))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((g$2) => {
    var this$4 = $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__groupLabel$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_GroupId__T($thiz, graph, g$2);
    return this$4.toLowerCase();
  })), $m_s_math_Ordering$String$()).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((groupId) => $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("el-row el-nested"), $m_Lcom_raquo_laminar_api_package$().b.y.s("el-hidden").bj(($m_Lcom_raquo_airstream_core_Observable$(), $m_Lcom_raquo_airstream_extensions_BooleanObservable$().r1($p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__groupVisible$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_GroupId__Lcom_raquo_airstream_core_Signal($thiz, state$29, graph, groupId)))), $m_Lcom_raquo_laminar_api_package$().b.y.s("el-selected").bj(state$29.aH().a2Z(groupId)), $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__groupSwatch$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_GroupId__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($thiz, graph, groupId), $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("el-label"), $m_Lcom_raquo_laminar_api_package$().b.eW().n(groupId.dR), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__groupLabel$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_GroupId__T($thiz, graph, groupId), $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("el-id"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, ("" + $m_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$().ah1(graph, groupId).aa()), $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__groupCollapse$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_viewer_models_GroupId__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($thiz, state$29, groupId), $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__groupEye$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_GroupId__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($thiz, state$29, graph, groupId), new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.Av(), false, false)).jY(), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((sink) => ((_$1) => {
    sink.bA(_$1);
  }))($m_Lcom_raquo_laminar_api_package$().b.ED.m5))), new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((groupId$2) => ((e) => {
    state$29.aH().a57($f_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps__renderedId__Lorg_jpablo_graphexplorer_viewer_models_ElementId__Lorg_jpablo_graphexplorer_viewer_models_ElementId($f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__visibleGraphObs__Lcom_raquo_airstream_state_OwnedSignal(state$29)).d(), groupId$2), (!(!e.shiftKey)));
  }))(groupId)))]))))));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__renderNodesSection$1__Lcom_raquo_airstream_state_Var__Lcom_raquo_airstream_state_Var__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lcom_raquo_airstream_state_Var__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__sci_Set__T__Z__sci_Set__sci_Seq($thiz, expandOverrideV$14, expandedGroupsV$8, state$48, expandedRecordsV$10, graph, colliding, filter, showHidden, hidden) {
  matchResult9: {
    var \u03b41$___1;
    var \u03b41$___2;
    var x31 = $f_Lorg_jpablo_graphexplorer_viewer_graph_GroupsOps__getRootChildren__sci_Set(graph).ju(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$21) => $f_Lorg_jpablo_graphexplorer_viewer_models_ElementId__isGroupId__Z(_$21))));
    if ((x31 !== null)) {
      var \u03b41$___1 = x31.g();
      var \u03b41$___2 = x31.h();
      break matchResult9;
    }
    throw new $c_s_MatchError(x31);
  }
  var groups$2 = \u03b41$___1;
  var nodes$2 = \u03b41$___2;
  return $m_sci_Seq$().fw(groups$2).ct(new $c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$$anon$3()).c5(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((gid) => $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__renderGroup$1__Lcom_raquo_airstream_state_Var__Lcom_raquo_airstream_state_Var__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lcom_raquo_airstream_state_Var__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_GroupId__sci_Set__T__Z__sci_Set__s_Option($thiz, expandOverrideV$14, expandedGroupsV$8, state$48, expandedRecordsV$10, graph, gid, colliding, filter, showHidden, hidden)))).gU($m_sci_Seq$().fw(nodes$2).ct(new $c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$$anon$4()).bw(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((nid) => ($p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__nodeMatches$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_NodeId__T__Z($thiz, graph, nid, filter) && $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__listed$1__Lorg_jpablo_graphexplorer_viewer_models_ElementId__Z__sci_Set__Z($thiz, nid, showHidden, hidden))))).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((nid$2) => $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__nodeEntry$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lcom_raquo_airstream_state_Var__Lcom_raquo_airstream_state_Var__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_NodeId__sci_Set__Z__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($thiz, state$48, expandOverrideV$14, expandedRecordsV$10, graph, nid$2, colliding, true)))));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__renderArrowsSection$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__T__Z__sci_Set__sci_Seq($thiz, state$49, graph, filter, showHidden, hidden) {
  return $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(graph.fX.e6().iz().bw(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((a) => ($p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__arrowMatches$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_Arrow__T__Z($thiz, graph, a, filter) && $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__listed$1__Lorg_jpablo_graphexplorer_viewer_models_ElementId__Z__sci_Set__Z($thiz, a.dw, showHidden, hidden))))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((a$2) => {
    var this$3 = $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__nodeLabel$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_NodeId__T($thiz, graph, a$2.bX);
    var $x_1 = this$3.toLowerCase();
    var this$4 = $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__nodeLabel$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_NodeId__T($thiz, graph, a$2.c0);
    return new $c_T2($x_1, this$4.toLowerCase());
  })), new $c_s_math_Ordering$Tuple2Ordering($m_s_math_Ordering$String$(), $m_s_math_Ordering$String$())).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$22) => $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__arrowRow$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_Arrow__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($thiz, state$49, graph, _$22))));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__sectionHead$1__T__Lcom_raquo_airstream_core_Signal__Lcom_raquo_airstream_state_Var__Lcom_raquo_laminar_nodes_ReactiveHtmlElement($thiz, label, count, openV) {
  return $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("el-row el-section"), $m_Lcom_raquo_laminar_api_package$().b.y.s("el-closed").bj(($m_Lcom_raquo_airstream_core_Observable$(), $m_Lcom_raquo_airstream_extensions_BooleanObservable$().r1(openV.P()))), $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("el-kind el-chevron"), $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("bi bi-chevron-down")])))]))), $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("el-label"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, label, $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("el-id"), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_inserters_ChildTextInserter$().DG($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), count, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$23) => ("" + (_$23 | 0)))), $m_s_None$()), $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7))]))), new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$24) => {
    $f_Lcom_raquo_airstream_state_Var__update__F1__V(openV, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$25) => (!(!(!_$25))))));
  })))])));
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$.prototype = $p;
$p.aVU = (function(state) {
  var filterVar = $m_Lcom_raquo_airstream_state_Var$().bx("");
  var kindVar = $m_Lcom_raquo_airstream_state_Var$().bx($m_s_None$());
  var showHiddenVar = $m_Lcom_raquo_airstream_state_Var$().bx(true);
  var expandOverrideV = $m_Lcom_raquo_airstream_state_Var$().bx(new $c_s_Some(true));
  var expandedGroupsV = $m_Lcom_raquo_airstream_state_Var$().bx($m_sci_Set$EmptySet$());
  var expandedRecordsV = $m_Lcom_raquo_airstream_state_Var$().bx($m_sci_Set$EmptySet$());
  var knownGroupsV = $m_Lcom_raquo_airstream_state_Var$().bx($m_sci_Set$EmptySet$());
  var nodesOpenV = $m_Lcom_raquo_airstream_state_Var$().bx(true);
  var arrowsOpenV = $m_Lcom_raquo_airstream_state_Var$().bx(true);
  var shownSignal = $m_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$().aMP(state.zC, kindVar.P(), filterVar.P(), showHiddenVar.P(), state.il().N6, new $c_sr_AbstractFunction5_$$Lambda$e688b1adbc65539969b4b8c5192c202236fd1078(((graph, kind, filter, showHidden, hidden) => $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__shownIds$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__s_Option__T__Z__sci_Set__sci_Set(this, graph, kind, filter, (!(!showHidden)), ((hidden === null) ? null : hidden.aS)))));
  var $x_3 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$();
  var $x_2 = $m_sr_ScalaRunTime$();
  var $x_1 = $m_Lcom_raquo_laminar_api_package$().b.ud().n("Filter elements");
  $m_Lcom_raquo_laminar_api_package$();
  var updater = $m_Lcom_raquo_laminar_api_package$().b.jx().bj(filterVar);
  var listener = new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.oE(), false, false)).nC(), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => {
    filterVar.jA().bA(_$1);
  })));
  var searchBox = $x_3.aWg($x_2.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_1, $m_Lcom_raquo_laminar_inputs_InputController$().qU(listener, updater), new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.m1(), false, false)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e) => {
    if ((e.key === "Enter")) {
      e.preventDefault();
      $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__selectShown$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lcom_raquo_airstream_state_Var__Lcom_raquo_airstream_state_Var__Lcom_raquo_airstream_state_Var__V(this, state, kindVar, filterVar, showHiddenVar);
    }
  })))])));
  var summary = $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), state.zC, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$26) => _$26.b9x())), $m_s_None$());
  return $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.gz().n("elements-list"), $m_Lcom_raquo_laminar_api_package$().b.y.s("h-full max-h-full flex flex-col"), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_api_Implicits$RichSource$().ft(new $c_Lcom_raquo_airstream_misc_FilterStream(new $c_Lcom_raquo_airstream_misc_StreamFromSignal(state.qs.P(), true), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$27) => {
    var x$2 = $s_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$__elements__Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection();
    return ((_$27 === null) ? (x$2 === null) : (_$27 === x$2));
  }))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$28) => {
    $m_sjs_js_timers_package$().ym(0.0, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      searchBox.en.focus();
    })));
  })))), new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.m1(), false, false)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$2) => {
    if ((e$2.key === "Escape")) {
      $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__closePalette$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__V(this, state);
    }
  }))), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_api_Implicits$RichSource$().ft(state.zC, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((g) => {
    var currentGroups = g.xf.lT($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$().p4);
    var newlyAdded = currentGroups.jv(knownGroupsV.P().aq().d());
    $f_Lcom_raquo_airstream_state_Var__set__O__V(knownGroupsV, currentGroups);
    $f_Lcom_raquo_airstream_state_Var__update__F1__V(expandedGroupsV, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((set) => set.J3(currentGroups).dI(newlyAdded))));
  })))), $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("attributes-title flex-none flex items-center justify-between"), $m_Lcom_raquo_laminar_api_package$().b.E3().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Elements", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $m_Lorg_jpablo_graphexplorer_viewer_widgets_IconButton$package$().ON("bi-pin-angle", "Pin: keep this list docked in the panel", state.H4, "tooltip-bottom", $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([])))]))), $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("el-tools flex-none flex items-center gap-1"), $f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement(searchBox, $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("grow")]))), $m_Lorg_jpablo_graphexplorer_viewer_widgets_IconButton$package$().Ae("bi-chevron-expand", "Expand all groups", "tooltip-bottom", $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([])), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lcom_raquo_airstream_state_Var__set__O__V(expandOverrideV, new $c_s_Some(true));
  }))), $m_Lorg_jpablo_graphexplorer_viewer_widgets_IconButton$package$().Ae("bi-chevron-contract", "Collapse all groups", "tooltip-bottom", $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([])), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lcom_raquo_airstream_state_Var__set__O__V(expandOverrideV, new $c_s_Some(false));
  }))), $m_Lorg_jpablo_graphexplorer_viewer_widgets_IconButton$package$().ON("bi-eye", "List hidden elements (dimmed)", showHiddenVar, "tooltip-bottom", $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([])))]))), $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("el-tools flex-none"), $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().aLu("elements-kind-filter", $m_sc_ArrayOps$().kX($m_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$().bb5()), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$29) => _$29.m())), kindVar, "All", $m_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$().nx())]))), $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("el-contents grow overflow-y-auto overflow-x-auto"), $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("el-rows"), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_inserters_ChildrenInserter$().IB($m_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$().aMP(state.zC, kindVar.P(), filterVar.P(), showHiddenVar.P(), state.il().N6, new $c_sr_AbstractFunction5_$$Lambda$e688b1adbc65539969b4b8c5192c202236fd1078(((graph$2, kind$2, filter$2, showHidden$2, hidden$2) => {
    var showHidden$3 = (!(!showHidden$2));
    var hidden$3 = ((hidden$2 === null) ? null : hidden$2.aS);
    var colliding = $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__collidingLabels$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__sci_Set(this, graph$2);
    if ((!kind$2.c())) {
      var x0 = kind$2.d();
      var x$2$1 = $s_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$__Nodes__Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind();
      var $x_4 = (!((x0 === null) ? (x$2$1 === null) : (x0 === x$2$1)));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var nodesSection = $m_sci_Seq$().f7();
    } else {
      var elem$1 = $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__sectionHead$1__T__Lcom_raquo_airstream_core_Signal__Lcom_raquo_airstream_state_Var__Lcom_raquo_laminar_nodes_ReactiveHtmlElement(this, "Nodes", $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), summary, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$31) => _$31.Mo)), $m_s_None$()), nodesOpenV);
      var nodesSection = new $c_sci_$colon$colon($m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("hidden").bj(($m_Lcom_raquo_airstream_core_Observable$(), $m_Lcom_raquo_airstream_extensions_BooleanObservable$().r1(nodesOpenV.P()))), $f_Lcom_raquo_laminar_api_Implicits__nodeSeqToModifier__O__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__renderNodesSection$1__Lcom_raquo_airstream_state_Var__Lcom_raquo_airstream_state_Var__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lcom_raquo_airstream_state_Var__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__sci_Set__T__Z__sci_Set__sci_Seq(this, expandOverrideV, expandedGroupsV, state, expandedRecordsV, graph$2, colliding, filter$2, showHidden$3, hidden$3), $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())]))), $m_sci_Nil$()).Ec(elem$1);
    }
    if ((!kind$2.c())) {
      var x0$1 = kind$2.d();
      var x$2$2 = $s_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$__Arrows__Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind();
      var $x_5 = (!((x0$1 === null) ? (x$2$2 === null) : (x0$1 === x$2$2)));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var arrowsSection = $m_sci_Seq$().f7();
    } else {
      var elem$2 = $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__sectionHead$1__T__Lcom_raquo_airstream_core_Signal__Lcom_raquo_airstream_state_Var__Lcom_raquo_laminar_nodes_ReactiveHtmlElement(this, "Arrows", $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), summary, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$33) => _$33.Mn)), $m_s_None$()), arrowsOpenV);
      var arrowsSection = new $c_sci_$colon$colon($m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("hidden").bj(($m_Lcom_raquo_airstream_core_Observable$(), $m_Lcom_raquo_airstream_extensions_BooleanObservable$().r1(arrowsOpenV.P()))), $f_Lcom_raquo_laminar_api_Implicits__nodeSeqToModifier__O__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__renderArrowsSection$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__T__Z__sci_Set__sci_Seq(this, state, graph$2, filter$2, showHidden$3, hidden$3), $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())]))), $m_sci_Nil$()).Ec(elem$2);
    }
    if ((!kind$2.E($s_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$__Groups__Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind()))) {
      var groupsSection = $m_sci_Seq$().f7();
    } else {
      var elem$3$1 = $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__sectionHead$1__T__Lcom_raquo_airstream_core_Signal__Lcom_raquo_airstream_state_Var__Lcom_raquo_laminar_nodes_ReactiveHtmlElement(this, "Groups", $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), state.zC, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((g$1) => g$1.xf.lT($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$().p4).aa())), $m_s_None$()), nodesOpenV);
      var groupsSection = new $c_sci_$colon$colon($m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("hidden").bj(($m_Lcom_raquo_airstream_core_Observable$(), $m_Lcom_raquo_airstream_extensions_BooleanObservable$().r1(nodesOpenV.P()))), $f_Lcom_raquo_laminar_api_Implicits__nodeSeqToModifier__O__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__renderGroupsSection$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__T__Z__sci_Set__sci_Seq(this, state, graph$2, filter$2, showHidden$3, hidden$3), $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())]))), $m_sci_Nil$()).Ec(elem$3$1);
    }
    return nodesSection.gU(arrowsSection).g9(groupsSection);
  }))), $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$(), $m_Lcom_raquo_laminar_modifiers_RenderableNode$().ht, (void 0)))])))]))), $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("el-footer flex-none flex items-center justify-between"), $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_inserters_ChildTextInserter$().DG($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), shownSignal, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((ids) => (ids.aa() + " shown"))), $m_s_None$()), $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7))]))), $m_Lcom_raquo_laminar_api_package$().b.DD().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("el-select-shown"), $m_Lcom_raquo_laminar_api_package$().b.eW().n("Select every element the current filter matches (Enter in the filter does the same)"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Select shown", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7), new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$34) => {
    $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$__selectShown$1__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__Lcom_raquo_airstream_state_Var__Lcom_raquo_airstream_state_Var__Lcom_raquo_airstream_state_Var__V(this, state, kindVar, filterVar, showHiddenVar);
  })))])))])))])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$, "org.jpablo.graphexplorer.viewer.components.rightPanel.ElementsList$package$", ({
  zi: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_RightPanel$package$__whileDragging$1__Lcom_raquo_airstream_state_Var__F0__Lcom_raquo_airstream_core_EventStream($thiz, drag$1, events) {
  var this$2 = drag$1.P();
  var project = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    if (($m_s_None$() === x$1)) {
      return ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_airstream_core_EventStream$()).Qr;
    }
    if ((x$1 instanceof $c_s_Some)) {
      return events.a3();
    }
    throw new $c_s_MatchError(x$1);
  }));
  return $m_Lcom_raquo_airstream_core_Observable$().AM.mK($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), this$2, project, $m_s_None$()));
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_RightPanel$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_RightPanel$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_RightPanel$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_RightPanel$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_RightPanel$package$.prototype = $p;
$p.aWe = (function(state) {
  var activeSection = state.qs.P();
  var activeSectionPair = $f_Lcom_raquo_airstream_core_Signal__scanLeft__F1__F2__Lcom_raquo_airstream_core_Signal(activeSection, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x0) => new $c_T2(x0, x0))), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((x$1, x$2) => {
    var x5 = new $c_T2(x$1, x$2);
    var x6 = x5.bi;
    if ((x6 !== null)) {
      x6.g();
      return new $c_T2(x6.h(), x5.be);
    }
    throw new $c_s_MatchError(x5);
  })));
  var elementsFloating = $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), ($m_Lio_laminext_syntax_core$(), new $c_Lio_laminext_core_ops_signal_SignalOfBooleanOps(state.H4.P())).wr, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => (!(!(!_$2))))), $m_s_None$());
  var useTransition = $m_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$().li(activeSectionPair, state.H4.P(), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((pair, pinned) => {
    var pinned$1 = (!(!pinned));
    matchResult5: {
      var \u03b41$___1;
      var \u03b41$___2;
      if ((pair !== null)) {
        var \u03b41$___1 = pair.g();
        var \u03b41$___2 = pair.h();
        break matchResult5;
      }
      throw new $c_s_MatchError(pair);
    }
    var curr$2 = \u03b41$___1;
    var next$2 = \u03b41$___2;
    if (curr$2.a3U()) {
      var $x_1 = true;
    } else {
      var x$2$1 = $s_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$__diagramAttributes__Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection();
      var $x_1 = ((curr$2 === null) ? (x$2$1 === null) : (curr$2 === x$2$1));
    }
    if ($x_1) {
      var x$4 = $s_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$__elements__Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection();
      if ((((next$2 === null) ? (x$4 === null) : (next$2 === x$4)) && pinned$1)) {
        var open = true;
      } else {
        var x$6 = $s_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$__sources__Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection();
        var open = ((next$2 === null) ? (x$6 === null) : (next$2 === x$6));
      }
    } else {
      var open = false;
    }
    if (next$2.a3U()) {
      var x$8 = $s_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$__elements__Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection();
      if ((((next$2 === null) ? (x$8 === null) : (next$2 === x$8)) && pinned$1)) {
        var close = true;
      } else {
        var x$10 = $s_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$__sources__Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection();
        var close = ((next$2 === null) ? (x$10 === null) : (next$2 === x$10));
      }
    } else {
      var close = false;
    }
    return (open || close);
  })));
  var isFloating = $m_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$().li(activeSection, elementsFloating, new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((section, elFloating) => {
    var elFloating$1 = (!(!elFloating));
    var x$2$2 = $s_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$__diagramAttributes__Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection();
    if (((section === null) ? (x$2$2 === null) : (section === x$2$2))) {
      return true;
    } else {
      var x$4$1 = $s_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$__elements__Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection();
      if (((section === null) ? (x$4$1 === null) : (section === x$4$1))) {
        return elFloating$1;
      } else {
        return false;
      }
    }
  })));
  var diagramAttributesContent = $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_inserters_ChildInserter$().nv($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), state.a0Z, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_DiagramAttributesViews$().b1v(_$1, state))), $m_s_None$()), $m_Lcom_raquo_laminar_modifiers_RenderableNode$().ht, (void 0)))])));
  var $x_15 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_14 = $m_sr_ScalaRunTime$();
  var $x_13 = $m_Lcom_raquo_laminar_api_package$().b.gz().n("right-panel");
  var $x_12 = $m_Lcom_raquo_laminar_api_package$().b.y.ael($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), state.qs.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((s$1) => (s$1.a3U() ? "visible" : "not-visible"))), $m_s_None$()), $m_Lcom_raquo_laminar_api_package$().b.aew());
  var $x_11 = $m_Lcom_raquo_laminar_api_package$().b.y.s("floating card card-xs").bj(isFloating);
  var $x_10 = $m_Lcom_raquo_laminar_api_package$().b.y.s("elements-palette").bj($m_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$().li(activeSection, elementsFloating, new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((_$2$2, _$3) => {
    var _$3$1 = (!(!_$3));
    var x$2$3 = $s_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$__elements__Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection();
    if (((_$2$2 === null) ? (x$2$3 === null) : (_$2$2 === x$2$3))) {
      return _$3$1;
    } else {
      return false;
    }
  }))));
  var $x_9 = $m_Lcom_raquo_laminar_api_package$().b.y.s("transition-all duration-200").bj(useTransition);
  var $x_8 = $m_Lcom_raquo_laminar_api_package$().b.PZ().bj($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), state.H9.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((px) => (("--right-panel-width: " + (px | 0)) + "px"))), $m_s_None$()));
  var $x_7 = $m_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_RightPanel$package$().b7M(state, isFloating);
  var $x_6 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_5 = $m_sr_ScalaRunTime$();
  var $x_4 = $m_Lcom_raquo_laminar_api_package$().b.gz().n("right-panel-content");
  var $x_3 = $m_Lcom_raquo_laminar_api_package$().b.y.s("card-body").bj(isFloating);
  var this$33 = $m_Lcom_raquo_laminar_api_package$().b;
  var this$32 = new $c_sci_$colon$colon(new $c_T2($s_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$__diagramAttributes__Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection(), diagramAttributesContent), new $c_sci_$colon$colon(new $c_T2($s_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$__elements__Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection(), $m_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$().aVU(state)), new $c_sci_$colon$colon(new $c_T2($s_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$__sources__Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection(), $m_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_SourceTab$package$().aWi(state)), $m_sci_Nil$())));
  var f = ((x$1$2) => {
    var section$1 = x$1$2.g();
    return $f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement(x$1$2.h(), $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("h-full max-h-full flex flex-col"), $m_Lcom_raquo_laminar_api_package$().b.y.s("hidden").bj($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), ($m_Lio_laminext_syntax_core$(), new $c_Lio_laminext_core_ops_signal_SignalOfBooleanOps($f_Lorg_jpablo_graphexplorer_viewer_state_UIState__isSectionActive__Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection__Lcom_raquo_airstream_core_Signal(state, section$1))).wr, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2$3) => (!(!(!_$2$3))))), $m_s_None$()))])));
  });
  if ((this$32 === $m_sci_Nil$())) {
    var $x_2 = $m_sci_Nil$();
  } else {
    var x0$1 = this$32.er;
    var h = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
    var t = h;
    var rest = this$32.U;
    while ((rest !== $m_sci_Nil$())) {
      var x0$2 = rest.t();
      var nx = new $c_sci_$colon$colon(f(x0$2), $m_sci_Nil$());
      t.U = nx;
      t = nx;
      rest = rest.v();
    }
    var $x_2 = h;
  }
  return $x_15.w($x_14.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_13, $x_12, $x_11, $x_10, $x_9, $x_8, $x_7, $x_6.w($x_5.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_4, $x_3, $f_Lcom_raquo_laminar_api_Implicits__nodeSeqToModifier__O__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier(this$33, $x_2, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())])))])));
});
$p.b7M = (function(state, isFloating) {
  var drag = $m_Lcom_raquo_laminar_api_package$().b.ff.bx($m_s_None$());
  return $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("right-panel-resizer"), $m_Lcom_raquo_laminar_api_package$().b.y.s("dragging").bj($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), drag.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4) => (!_$4.c()))), $m_s_None$())), $m_Lcom_raquo_laminar_api_package$().b.y.s("hidden").bj($m_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$().li(state.qs.P(), isFloating, new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((s, floating) => {
    var floating$1 = (!(!floating));
    return ((!s.a3U()) || floating$1);
  })))), new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.Av(), false, false)).jY(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((ev) => {
    $f_Lcom_raquo_airstream_state_Var__set__O__V(drag, new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_PanelDrag((+ev.clientX), (state.H9.P().aq().d() | 0))));
    document.documentElement.classList.add("resizing-h");
  }))), new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.aQG(), false, false)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$5) => {
    $f_Lcom_raquo_airstream_state_Var__set__O__V(state.H9, $m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$().a0X);
  }))), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_api_Implicits$RichSource$().ft($p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_RightPanel$package$__whileDragging$1__Lcom_raquo_airstream_state_Var__F0__Lcom_raquo_airstream_core_EventStream(this, drag, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    var this$15 = $m_Lcom_raquo_laminar_api_package$().b;
    var x0 = this$15.EE;
    $m_Lcom_raquo_laminar_api_package$();
    var p = $m_Lcom_raquo_laminar_keys_EventProcessor$().az(x0.a4i(), false, false);
    return new $c_Lcom_raquo_airstream_misc_CollectStream($m_Lcom_raquo_airstream_web_DomEventStream$().IC(window, p.j1.m8, p.m7), p.m6);
  }))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((ev$2) => {
    var this$23 = drag.P().aq().d();
    if ((!this$23.c())) {
      var x0$1 = this$23.d();
      $f_Lcom_raquo_airstream_state_Var__set__O__V(state.H9, $m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$().aMH((x0$1.LI + (x0$1.LJ - (+ev$2.clientX))), (+window.innerWidth)));
    }
  })))), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_api_Implicits$RichSource$().ft($p_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_RightPanel$package$__whileDragging$1__Lcom_raquo_airstream_state_Var__F0__Lcom_raquo_airstream_core_EventStream(this, drag, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    var this$24 = $m_Lcom_raquo_laminar_api_package$().b;
    var x0$2 = this$24.EE;
    $m_Lcom_raquo_laminar_api_package$();
    var p$1 = $m_Lcom_raquo_laminar_keys_EventProcessor$().az(x0$2.a4j(), false, false);
    return new $c_Lcom_raquo_airstream_misc_CollectStream($m_Lcom_raquo_airstream_web_DomEventStream$().IC(window, p$1.j1.m8, p$1.m7), p$1.m6);
  }))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$8) => {
    $f_Lcom_raquo_airstream_state_Var__set__O__V(drag, $m_s_None$());
    document.documentElement.classList.remove("resizing-h");
  }))))])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_RightPanel$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_RightPanel$package$, "org.jpablo.graphexplorer.viewer.components.rightPanel.RightPanel$package$", ({
  zm: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_RightPanel$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_RightPanel$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_RightPanel$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_RightPanel$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_RightPanel$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_RightPanel$package$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_SourceTab$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_SourceTab$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_SourceTab$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_SourceTab$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_SourceTab$package$.prototype = $p;
$p.aWi = (function(state) {
  var currentInfo = $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), state.CG.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((format) => state.afY(format))), $m_s_None$());
  var $x_15 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_14 = $m_sr_ScalaRunTime$();
  var $x_13 = $m_Lcom_raquo_laminar_api_package$().b.gz().n("source-tab");
  var $x_12 = $m_Lcom_raquo_laminar_api_package$().b.y.s("border-error border").bj($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), state.CF.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => ((!_$1.c()) && _$1.d().J6()))), $m_s_None$()));
  var $x_11 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_10 = $m_sr_ScalaRunTime$();
  var $x_9 = $m_Lcom_raquo_laminar_api_package$().b.y.s("source-toolbar");
  var $x_8 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$();
  var $x_7 = $m_sr_ScalaRunTime$();
  var $x_6 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_SelectVariant$().abD;
  var $x_5 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_SelectVariant$().abE;
  var $x_4 = $m_Lcom_raquo_laminar_api_package$().b.y.s("source-format");
  var $x_3 = $m_Lcom_raquo_laminar_api_package$().b.Jd().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.jx().n(state.a3t().U6), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_inserters_ChildTextInserter$().DG(state.a3t().aGZ, $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7))])));
  var this$7 = $m_Lcom_raquo_laminar_api_package$().b;
  var this$6 = state.aXR();
  var f = ((x$1) => {
    var format$1 = x$1.g();
    var info = x$1.h();
    return $m_Lcom_raquo_laminar_api_package$().b.Jd().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.jx().n(format$1.m()), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, info.FP, $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])));
  });
  if ((this$6 === $m_sci_Nil$())) {
    var $x_2 = $m_sci_Nil$();
  } else {
    var x0$1 = this$6.t();
    var h = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
    var t = h;
    var rest = this$6.v();
    while ((rest !== $m_sci_Nil$())) {
      var x0$2 = rest.t();
      var nx = new $c_sci_$colon$colon(f(x0$2), $m_sci_Nil$());
      t.U = nx;
      t = nx;
      rest = rest.v();
    }
    var $x_2 = h;
  }
  var $x_1 = $f_Lcom_raquo_laminar_api_Implicits__nodeSeqToModifier__O__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier(this$7, $x_2, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$());
  $m_Lcom_raquo_laminar_api_package$();
  var updater = $m_Lcom_raquo_laminar_api_package$().b.jx().bj(state.a3t().aH0);
  var listener = new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.Eb(), false, false)).nC(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((value$1) => {
    state.a3t().b8i(value$1);
  })));
  return $x_15.w($x_14.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_13, $x_12, $x_11.w($x_10.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_9, $x_8.aet($x_7.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_6, $x_5, $x_4, $x_3, $x_1, $m_Lcom_raquo_laminar_inputs_InputController$().qU(listener, updater)]))), $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("flex items-center gap-0.5"), $m_Lorg_jpablo_graphexplorer_viewer_widgets_IconButton$package$().ON("bi-text-wrap", "Wrap long lines", state.N5, "tooltip-bottom tooltip-end", $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([]))), $m_Lorg_jpablo_graphexplorer_viewer_widgets_IconButton$package$().Ae("bi-clipboard", "Copy source", "tooltip-bottom tooltip-end", $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([])), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lorg_jpablo_graphexplorer_viewer_state_ExportOps__copySourceText__V(state);
  }))), $m_Lorg_jpablo_graphexplorer_viewer_widgets_IconButton$package$().Ae("bi-clipboard-plus", "Paste diagram (replaces the source, DOT or Mermaid)", "tooltip-bottom tooltip-end", $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([])), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lorg_jpablo_graphexplorer_viewer_state_ImportOps__pasteDiagram__V(state);
  }))), $m_Lorg_jpablo_graphexplorer_viewer_widgets_Tooltip$package$().Iz("Documentation", $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("tooltip-bottom tooltip-end"), $m_Lcom_raquo_laminar_api_package$().b.DD().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("gx-icon-btn"), $m_Lcom_raquo_laminar_api_package$().b.ags().bj($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), currentInfo, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3) => _$3.Sr)), $m_s_None$())), $m_Lcom_raquo_laminar_api_package$().b.b9R().n("_blank"), $m_Lcom_raquo_laminar_api_package$().b.eW().bj($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), currentInfo, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4) => _$4.Sq)), $m_s_None$())), $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("bi-question-circle")])))])))])))])))]))), $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("flex-grow overflow-y-auto"), $m_Lorg_jpablo_graphexplorer_viewer_components_codeMirror_CodeMirror$package$().aVL(state, $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.gz().n("nodes-source"), $m_Lcom_raquo_laminar_api_package$().b.ud().bj($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), currentInfo, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$5) => _$5.Ss)), $m_s_None$()))])))]))), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_receivers_ChildOptionReceiver$()).gR($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), state.CF.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6) => {
    if (_$6.c()) {
      return $m_s_None$();
    } else {
      var x0$3 = _$6.d();
      var $x_24 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Alert$package$();
      var $x_23 = (x0$3.J6() ? $s_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$__Error__Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone() : $s_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$__Info__Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone());
      var $x_22 = $m_sr_ScalaRunTime$();
      var $x_21 = $m_Lcom_raquo_laminar_api_package$().b.y.s("m-1 mt-2 p-1 rounded-box flex-none text-sm");
      var $x_20 = $m_Lcom_raquo_laminar_api_package$().b.a8();
      var $x_19 = $m_sr_ScalaRunTime$();
      var $x_18 = $m_Lcom_raquo_laminar_api_package$().b.y.s("flex flex-col gap-1.5 w-full min-w-0");
      var $x_17 = $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, x0$3.Cw, $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])));
      var this$19 = $m_Lcom_raquo_laminar_api_package$().b;
      var this$12 = x0$3.TI;
      if (this$12.c()) {
        var $x_16 = $m_s_None$();
      } else {
        var x0$4 = this$12.d();
        var $x_16 = new $c_s_Some($m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("flex flex-wrap gap-1"), $m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$().iZ($m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$().AB($m_Lorg_jpablo_graphexplorer_viewer_widgets_Button$package$().hH($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, ("Switch to " + state.afY(x0$4).FP), $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7), new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((actual$2) => ((_$7) => {
          state.aS5(actual$2);
        }))(x0$4)))]))))), $m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$().iZ($m_Lorg_jpablo_graphexplorer_viewer_widgets_Button$package$().hH($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Always detect", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7), new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$8) => {
          $f_Lcom_raquo_airstream_state_Var__set__O__V(state.CD, true);
        })))]))))]))));
      }
      return new $c_s_Some($x_24.aep($x_23, $x_22.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_21, $x_20.w($x_19.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_18, $x_17, $f_Lcom_raquo_laminar_api_Implicits__nodeOptionToModifier__s_Option__Lcom_raquo_laminar_modifiers_Modifier(this$19, $x_16)])))]))));
    }
  })), $m_s_None$()))])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_SourceTab$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_SourceTab$package$, "org.jpablo.graphexplorer.viewer.components.rightPanel.SourceTab$package$", ({
  zn: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_SourceTab$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_SourceTab$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_SourceTab$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_SourceTab$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_SourceTab$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_SourceTab$package$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__defaultKnobValues__Lorg_jpablo_graphexplorer_viewer_layout3d_Layout3D__sci_Map($thiz, a) {
  var this$3 = a.E8();
  var f = ((k) => new $c_T2(k.zu, k.Ct));
  var $x_2 = $m_sci_Map$();
  if ((this$3 === $m_sci_Nil$())) {
    var $x_1 = $m_sci_Nil$();
  } else {
    var x0 = this$3.t();
    var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
    var t = h;
    var rest = this$3.v();
    while ((rest !== $m_sci_Nil$())) {
      var x0$1 = rest.t();
      var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
      t.U = nx;
      t = nx;
      rest = rest.v();
    }
    var $x_1 = h;
  }
  return $x_2.ao($x_1);
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__buildGizmo__T2($thiz) {
  $m_scm_ArrayBuffer$();
  var pts = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  $m_scm_ArrayBuffer$();
  var cols = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  var i = 0;
  while (true) {
    var x0 = i;
    var az = ((3.141592653589793 * x0) / 6.0);
    var i$1 = 0;
    while (true) {
      var x0$1 = i$1;
      var t0 = ((6.283185307179586 * x0$1) / 48.0);
      var t1 = ((6.283185307179586 * ((1 + x0$1) | 0)) / 48.0);
      pts.gS(new $c_sci_$colon$colon(Math.fround(((+Math.sin(t0)) * (+Math.sin(az)))), new $c_sci_$colon$colon(Math.fround((+Math.cos(t0))), new $c_sci_$colon$colon(Math.fround(((+Math.sin(t0)) * (+Math.cos(az)))), new $c_sci_$colon$colon(Math.fround(((+Math.sin(t1)) * (+Math.sin(az)))), new $c_sci_$colon$colon(Math.fround((+Math.cos(t1))), new $c_sci_$colon$colon(Math.fround(((+Math.sin(t1)) * (+Math.cos(az)))), $m_sci_Nil$())))))));
      cols.gS($m_sci_Seq$().kM($m_sr_ScalaRunTime$().Yi(new $ac_F(new Float32Array([0.550000011920929, 0.6000000238418579, 0.6800000071525574, 0.550000011920929, 0.550000011920929, 0.6000000238418579, 0.6800000071525574, 0.550000011920929])))));
      if ((i$1 === 47)) {
        break;
      }
      i$1 = ((1 + i$1) | 0);
    }
    if ((i === 5)) {
      break;
    }
    i = ((1 + i) | 0);
  }
  var this$34 = new $c_sci_$colon$colon((-60), new $c_sci_$colon$colon((-30), new $c_sci_$colon$colon(0, new $c_sci_$colon$colon(30, new $c_sci_$colon$colon(60, $m_sci_Nil$())))));
  var these = this$34;
  while ((!these.c())) {
    var x0$2 = these.t();
    var lat = (x0$2 | 0);
    var x = lat;
    var x$1 = (0.017453292519943295 * x);
    var y = (+Math.sin(x$1));
    var x$2 = lat;
    var x$3 = (0.017453292519943295 * x$2);
    var r = (+Math.cos(x$3));
    var i$2 = 0;
    while (true) {
      var x0$3 = i$2;
      var a0 = ((6.283185307179586 * x0$3) / 48.0);
      var a1 = ((6.283185307179586 * ((1 + x0$3) | 0)) / 48.0);
      pts.gS(new $c_sci_$colon$colon(Math.fround((r * (+Math.sin(a0)))), new $c_sci_$colon$colon(Math.fround(y), new $c_sci_$colon$colon(Math.fround((r * (+Math.cos(a0)))), new $c_sci_$colon$colon(Math.fround((r * (+Math.sin(a1)))), new $c_sci_$colon$colon(Math.fround(y), new $c_sci_$colon$colon(Math.fround((r * (+Math.cos(a1)))), $m_sci_Nil$())))))));
      cols.gS($m_sci_Seq$().kM($m_sr_ScalaRunTime$().Yi(new $ac_F(new Float32Array([0.550000011920929, 0.6000000238418579, 0.6800000071525574, 0.550000011920929, 0.550000011920929, 0.6000000238418579, 0.6800000071525574, 0.550000011920929])))));
      if ((i$2 === 47)) {
        break;
      }
      i$2 = ((1 + i$2) | 0);
    }
    these = these.v();
  }
  var _1$4 = $thiz.Gd;
  var c = $thiz.axR;
  pts.gS(new $c_sci_$colon$colon(0.0, new $c_sci_$colon$colon(0.0, new $c_sci_$colon$colon(0.0, new $c_sci_$colon$colon(Math.fround(_1$4), new $c_sci_$colon$colon(0.0, new $c_sci_$colon$colon(0.0, $m_sci_Nil$())))))));
  cols.gS($m_sci_Seq$().kM($m_sr_ScalaRunTime$().Yi(new $ac_F(new Float32Array([Math.fround((+c.bH)), Math.fround((+c.bU)), Math.fround((+c.c3)), 1.0, Math.fround((+c.bH)), Math.fround((+c.bU)), Math.fround((+c.c3)), 1.0])))));
  var _2$2 = $thiz.Gd;
  var c$1 = $thiz.axQ;
  pts.gS(new $c_sci_$colon$colon(0.0, new $c_sci_$colon$colon(0.0, new $c_sci_$colon$colon(0.0, new $c_sci_$colon$colon(0.0, new $c_sci_$colon$colon(Math.fround(_2$2), new $c_sci_$colon$colon(0.0, $m_sci_Nil$())))))));
  cols.gS($m_sci_Seq$().kM($m_sr_ScalaRunTime$().Yi(new $ac_F(new Float32Array([Math.fround((+c$1.bH)), Math.fround((+c$1.bU)), Math.fround((+c$1.c3)), 1.0, Math.fround((+c$1.bH)), Math.fround((+c$1.bU)), Math.fround((+c$1.c3)), 1.0])))));
  var _3$4 = $thiz.Gd;
  var c$2 = $thiz.axP;
  pts.gS(new $c_sci_$colon$colon(0.0, new $c_sci_$colon$colon(0.0, new $c_sci_$colon$colon(0.0, new $c_sci_$colon$colon(0.0, new $c_sci_$colon$colon(0.0, new $c_sci_$colon$colon(Math.fround(_3$4), $m_sci_Nil$())))))));
  cols.gS($m_sci_Seq$().kM($m_sr_ScalaRunTime$().Yi(new $ac_F(new Float32Array([Math.fround((+c$2.bH)), Math.fround((+c$2.bU)), Math.fround((+c$2.c3)), 1.0, Math.fround((+c$2.bH)), Math.fround((+c$2.bU)), Math.fround((+c$2.c3)), 1.0])))));
  var geometry = new $i_three.BufferGeometry();
  geometry.setAttribute("position", new $i_three.BufferAttribute(Float32Array.from([...$m_sjsr_Compat$().Y8($m_sci_Seq$().fw(pts))]), 3));
  geometry.setAttribute("color", new $i_three.BufferAttribute(Float32Array.from([...$m_sjsr_Compat$().Y8($m_sci_Seq$().fw(cols))]), 4));
  var material = new $i_three.LineBasicMaterial($m_Lorg_jpablo_graphexplorer_viewer_backends_threejs_LineBasicMaterial$().b6j(true, true, 1.0));
  var lines = new $i_three.LineSegments(geometry, material);
  lines.frustumCulled = false;
  $thiz.SU.add(lines);
  $thiz.a9x = $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_T3.r().C)([new $c_T3(new $c_T3($thiz.Gd, 0.0, 0.0), 16741235, new $c_T3(1.0, 0.0, 0.0)), new $c_T3(new $c_T3(0.0, $thiz.Gd, 0.0), 7664260, new $c_T3(0.0, 1.0, 0.0)), new $c_T3(new $c_T3(0.0, 0.0, $thiz.Gd), 8042751, new $c_T3(0.0, 0.0, 1.0))]))).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$1) => {
    var tip = x$1$1.bH;
    var color = (x$1$1.bU | 0);
    var axis = x$1$1.c3;
    var mat = new $i_three.MeshBasicMaterial($m_Lorg_jpablo_graphexplorer_viewer_backends_threejs_MeshBasicMaterial$().Ay(color, true, 1.0, true, 0, true));
    var cone = new $i_three.Mesh($thiz.a0m, mat);
    cone.scale.set(1.6, 1.6, 1.6);
    cone.position.set((+tip.bH), (+tip.bU), (+tip.c3));
    cone.quaternion.setFromUnitVectors($thiz.LL, $thiz.LP.set((+axis.bH), (+axis.bU), (+axis.c3)));
    $thiz.SU.add(cone);
    return new $c_T2(cone, mat);
  })));
  return new $c_T2(geometry, material);
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__renderGizmo__V($thiz) {
  $m_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$();
  var camP = new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3((+$thiz.eq.position.x), (+$thiz.eq.position.y), (+$thiz.eq.position.z));
  var toCam = camP.fN($thiz.iB);
  var y$1 = toCam.js();
  var dir = toCam.dj((1.0 / (+Math.max(1.0E-9, y$1))));
  $thiz.ST.position.set((dir.cq * $thiz.a0k), (dir.cr * $thiz.a0k), (dir.cg * $thiz.a0k));
  $thiz.ST.up.set($thiz.qj.cq, $thiz.qj.cr, $thiz.qj.cg);
  $thiz.ST.lookAt(0.0, 0.0, 0.0);
  var w = ($thiz.e9.domElement.clientWidth | 0);
  $thiz.e9.autoClear = false;
  $thiz.e9.setViewport(((w - $thiz.Ge) - 10.0), 52.0, $thiz.Ge, $thiz.Ge);
  $thiz.e9.setScissor(((w - $thiz.Ge) - 10.0), 52.0, $thiz.Ge, $thiz.Ge);
  $thiz.e9.setScissorTest(true);
  $thiz.e9.clearDepth();
  $thiz.e9.render($thiz.SU, $thiz.ST);
  $thiz.e9.setScissorTest(false);
  $thiz.e9.setViewport(0.0, 0.0, w, ($thiz.e9.domElement.clientHeight | 0));
  $thiz.e9.autoClear = true;
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__visibleClusters__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__sci_Vector__sci_Vector($thiz, g, nodeIds) {
  var visible = $m_sci_Set$().af(nodeIds);
  var memberOrder = $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(nodeIds).eX($m_s_$less$colon$less$().b1);
  var this$2 = g.aA.gq;
  var this$4 = $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O($m_sci_Vector$().X(this$2), new $c_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D$$anon$1(visible));
  var m = $m_scm_Map$().aO();
  var it = this$4.o();
  while (it.p()) {
    var elem = it.q();
    var key = elem.g();
    m.ec(key, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((this$4) => (() => this$4.fS()))(this$4))).Y(elem);
  }
  var result = $m_sci_HashMap$().fk;
  var mapIt = m.o();
  while (mapIt.p()) {
    var x1 = mapIt.q();
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1);
    }
    var k = x1.g();
    var v = x1.h();
    result = result.hq(k, v.aR());
  }
  var this$6 = result;
  return $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O($m_sci_Vector$().X(this$6), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$8) => _$8.g().dR)), $m_s_math_Ordering$String$()).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    x$1.g();
    return $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(x$1.h().L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$10) => _$10.h()))), memberOrder, $m_s_math_Ordering$Int$());
  }))).bw(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$11) => (_$11.C() >= 2))));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__hintsFor__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__s_Option($thiz, g) {
  return ($thiz.vi.Qb() ? $m_Lorg_jpablo_graphexplorer_viewer_layout3d_PlanarHints$().b1W(g) : $m_s_None$());
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__displayLabel__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Lorg_jpablo_graphexplorer_viewer_models_ViewerNode__sci_Vector($thiz, g, id, node) {
  var raw = $f_Lorg_jpablo_graphexplorer_viewer_models_ViewerElement__label__Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(node).m();
  if (((raw === "") || (raw === "\\N"))) {
    return $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_T.r().C)([id.dE])));
  } else {
    var ls = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_LabelSummary$().b47(raw, $f_Lorg_jpablo_graphexplorer_viewer_graph_CombineNodesOps__isRecordNode__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Z(g, id), 40, 8);
    return ($f_sc_SeqOps__isEmpty__Z(ls) ? $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_T.r().C)([id.dE]))) : ls);
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__dictatedSize__Lorg_jpablo_graphexplorer_viewer_models_NodeId__s_Option($thiz, id) {
  var this$1 = $thiz.dv.he.GR;
  var this$2 = (this$1.c() ? $m_s_None$() : this$1.d().TB.r(id));
  if (this$2.c()) {
    return $m_s_None$();
  } else {
    var x0$1 = this$2.d();
    var w = (+x0$1.g());
    var h = (+x0$1.h());
    return new $c_s_Some(new $c_T2((w * $m_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$().Tw), (h * $m_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$().Tw)));
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__defaultSpriteSize__sci_Vector__D__T2($thiz, lines, aspect) {
  var $x_1 = $thiz.x6;
  var x = lines.C();
  var height = ($x_1 * ((x > 1) ? x : 1));
  var x$1 = (height * aspect);
  var y = $thiz.axV;
  var width = (+Math.min(x$1, y));
  return new $c_T2(width, (width / aspect));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__createSprite__Lorg_jpablo_graphexplorer_viewer_models_NodeId__sci_Vector__Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D$NodeSprite($thiz, id, label) {
  var dictated = $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__dictatedSize__Lorg_jpablo_graphexplorer_viewer_models_NodeId__s_Option($thiz, id);
  matchResult11: {
    var \u03b43$___1;
    var \u03b43$___2;
    if (dictated.c()) {
      var $x_1 = $m_s_None$();
    } else {
      var x0 = dictated.d();
      var $x_1 = new $c_s_Some(((+x0.g()) / (+x0.h())));
    }
    var x28 = $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__paintLabel__sci_Vector__s_Option__T2($thiz, label, $x_1);
    if ((x28 !== null)) {
      var \u03b43$___1 = x28.g();
      var \u03b43$___2 = (+x28.h());
      break matchResult11;
    }
    throw new $c_s_MatchError(x28);
  }
  var texture$2 = \u03b43$___1;
  var aspect$2 = (+\u03b43$___2);
  matchResult12: {
    var \u03b44$___1;
    var \u03b44$___2;
    var x31 = (dictated.c() ? $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__defaultSpriteSize__sci_Vector__D__T2($thiz, label, aspect$2) : dictated.d());
    if ((x31 !== null)) {
      var \u03b44$___1 = (+x31.g());
      var \u03b44$___2 = (+x31.h());
      break matchResult12;
    }
    throw new $c_s_MatchError(x31);
  }
  var w$2 = (+\u03b44$___1);
  var h$2 = (+\u03b44$___2);
  if (((!dictated.c()) || (!$thiz.SV))) {
    var material = new $i_three.MeshBasicMaterial($m_Lorg_jpablo_graphexplorer_viewer_backends_threejs_MeshBasicMaterial$().Ay(16777215, true, 1.0, true, 2, true));
    material.map = texture$2;
    material.needsUpdate = true;
    var mesh = new $i_three.Mesh($thiz.ay0, material);
    mesh.scale.set(w$2, h$2, 1.0);
    mesh.renderOrder = (-2.0);
    var dict = mesh.userData;
    var s = id.dE;
    dict.nodeId = s;
    $thiz.Gh.add(mesh);
    return $thiz.a9r.aM7(mesh, texture$2, label, true, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((t) => {
      material.map = t;
      material.needsUpdate = true;
    })), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((v1, v2) => {
      var c = (v1 | 0);
      var o = (+v2);
      material.color.setHex(c);
      material.opacity = o;
    })), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      material.dispose();
    })));
  } else {
    var material$5 = new $i_three.SpriteMaterial($m_Lorg_jpablo_graphexplorer_viewer_backends_threejs_SpriteMaterial$().b6l(texture$2, true));
    var sprite = new $i_three.Sprite(material$5);
    sprite.scale.set(w$2, h$2, 1.0);
    var dict$1 = sprite.userData;
    var s$1 = id.dE;
    dict$1.nodeId = s$1;
    $thiz.Gh.add(sprite);
    return $thiz.a9r.aM7(sprite, texture$2, label, false, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((t$2) => {
      material$5.map = t$2;
    })), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((v1$2, v2$2) => {
      var c$1 = (v1$2 | 0);
      var o$1 = (+v2$2);
      material$5.color.setHex(c$1);
      material$5.opacity = o$1;
    })), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      material$5.dispose();
    })));
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__resizeSprites__V($thiz) {
  $thiz.qk = $thiz.qk.kP(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var id = x$1.g();
    var ns = x$1.h();
    var dictated = $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__dictatedSize__Lorg_jpablo_graphexplorer_viewer_models_NodeId__s_Option($thiz, id);
    var asSheet = ((!dictated.c()) || (!$thiz.SV));
    if ((ns.Cd !== asSheet)) {
      $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__disposeSprite__Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D$NodeSprite__V($thiz, ns);
      return new $c_T2(id, $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__createSprite__Lorg_jpablo_graphexplorer_viewer_models_NodeId__sci_Vector__Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D$NodeSprite($thiz, id, ns.ql));
    } else {
      matchResult13: {
        var \u03b45$___1;
        var \u03b45$___2;
        var x34 = (dictated.c() ? $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__defaultSpriteSize__sci_Vector__D__T2($thiz, ns.ql, $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__paintLabelAspect__sci_Vector__D($thiz, ns.ql)) : dictated.d());
        if ((x34 !== null)) {
          var \u03b45$___1 = (+x34.g());
          var \u03b45$___2 = (+x34.h());
          break matchResult13;
        }
        throw new $c_s_MatchError(x34);
      }
      var w$2 = (+\u03b45$___1);
      var h$2 = (+\u03b45$___2);
      var x = ((+ns.p3.scale.x) - w$2);
      if (((+Math.abs(x)) < 1.0E-6)) {
        var x$2 = ((+ns.p3.scale.y) - h$2);
        var $x_1 = ((+Math.abs(x$2)) < 1.0E-6);
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        return new $c_T2(id, ns);
      } else {
        matchResult14: {
          var texture$2;
          var x37 = $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__paintLabel__sci_Vector__s_Option__T2($thiz, ns.ql, new $c_s_Some((w$2 / h$2)));
          if ((x37 !== null)) {
            var texture$2 = x37.g();
            break matchResult14;
          }
          throw new $c_s_MatchError(x37);
        }
        ns.zk.i(texture$2);
        ns.Cf.dispose();
        ns.p3.scale.set(w$2, h$2, 1.0);
        return new $c_T2(id, ns.aN1(ns.p3, texture$2, ns.ql, ns.Cd, ns.zk, ns.Ce, ns.Cc));
      }
    }
  })));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__paintLabelAspect__sci_Vector__D($thiz, lines) {
  var canvas = document.createElement("canvas");
  var ctx = canvas.getContext("2d");
  ctx.font = ("64px " + window.getComputedStyle(document.body).fontFamily);
  var this$1 = $f_sc_IterableOnceOps__maxOption__s_math_Ordering__s_Option(lines.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$13) => (+ctx.measureText(_$13).width)))), $m_s_math_Ordering$DeprecatedDoubleOrdering$());
  var textWidth = (+(this$1.c() ? 0.0 : this$1.d()));
  var x = ((textWidth + 70.4) + 8.0);
  var x$1 = (+Math.ceil(x));
  var $x_1 = Math.max(x$1, 1.0);
  var x$2 = lines.C();
  var x$3 = (((80.0 * ((x$2 > 1) ? x$2 : 1)) + 40.96) + 8.0);
  return ((+$x_1) / (+Math.ceil(x$3)));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__disposeSprite__Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D$NodeSprite__V($thiz, ns) {
  $thiz.Gh.remove(ns.p3);
  ns.Cc.a3();
  ns.Cf.dispose();
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__paintLabel__sci_Vector__s_Option__T2($thiz, lines, forcedAspect) {
  var x = lines.C();
  var n = ((x > 1) ? x : 1);
  var canvas = document.createElement("canvas");
  var ctx = canvas.getContext("2d");
  var font = ("64px " + window.getComputedStyle(document.body).fontFamily);
  ctx.font = font;
  var this$5 = $f_sc_IterableOnceOps__maxOption__s_math_Ordering__s_Option(lines.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$14) => (+ctx.measureText(_$14).width)))), $m_s_math_Ordering$DeprecatedDoubleOrdering$());
  var textWidth = (+(this$5.c() ? 0.0 : this$5.d()));
  var x$1 = (((80.0 * n) + 40.96) + 8.0);
  canvas.height = $doubleToInt((+Math.ceil(x$1)));
  matchResult15: {
    var $x_1;
    if ((forcedAspect instanceof $c_s_Some)) {
      var aspect = (+forcedAspect.J);
      var x$2 = ((canvas.height | 0) * aspect);
      var x$3 = $doubleToInt((+Math.ceil(x$2)));
      var $x_1 = ((x$3 > 1) ? x$3 : 1);
      break matchResult15;
    }
    if (($m_s_None$() === forcedAspect)) {
      var x$5 = ((textWidth + 70.4) + 8.0);
      var x$6 = $doubleToInt((+Math.ceil(x$5)));
      var $x_1 = ((x$6 > 1) ? x$6 : 1);
      break matchResult15;
    }
    throw new $c_s_MatchError(forcedAspect);
  }
  canvas.width = $x_1;
  ctx.font = font;
  ctx.fillStyle = $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__themeColor__T__T__T($thiz, "--color-base-100", "#ffffff");
  ctx.strokeStyle = $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__themeColor__T__T__T($thiz, "--color-base-content", "#333333");
  ctx.lineWidth = 4.0;
  if ((!forcedAspect.c())) {
    var radius = 8.0;
  } else {
    var x$7 = (0.25 * ((canvas.height | 0) - 4.0));
    var radius = (+Math.min(x$7, 48.0));
  }
  ctx.beginPath();
  ctx.roundRect(2.0, 2.0, ((canvas.width | 0) - 4.0), ((canvas.height | 0) - 4.0), radius);
  ctx.fill();
  ctx.stroke();
  ctx.fillStyle = $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__themeColor__T__T__T($thiz, "--color-base-content", "#333333");
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  var availW = (((canvas.width | 0) - 8.0) - 19.2);
  if (((textWidth > availW) && (availW > 1.0))) {
    ctx.font = ((((64.0 * availW) / textWidth) + "px ") + window.getComputedStyle(document.body).fontFamily);
  }
  $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(lines).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$1) => {
    var line = x$1$1.g();
    var i = (x$1$1.h() | 0);
    ctx.fillText(line, (0.5 * (canvas.width | 0)), ((0.5 * (canvas.height | 0)) + (80.0 * (i - (0.5 * ((n - 1) | 0))))));
  })));
  var texture = new $i_three.CanvasTexture(canvas);
  texture.colorSpace = "srgb";
  return new $c_T2(texture, ((canvas.width | 0) / (canvas.height | 0)));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__themeColor__T__T__T($thiz, cssVar, fallback) {
  var v = $f_T__trim__T(window.getComputedStyle(document.documentElement).getPropertyValue(cssVar));
  return ((v === "") ? fallback : v);
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__rebuildLines__V($thiz) {
  $f_sc_StrictOptimizedIterableOps__flatten__F1__O($thiz.ti, $m_s_$less$colon$less$().b1).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$15) => $thiz.hZ.remove(_$15))));
  $f_sc_StrictOptimizedIterableOps__flatten__F1__O($thiz.x9, $m_s_$less$colon$less$().b1).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$16) => $thiz.hZ.remove(_$16))));
  $f_sc_StrictOptimizedIterableOps__flatten__F1__O($thiz.LQ, $m_s_$less$colon$less$().b1).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$17) => $thiz.hZ.remove(_$17))));
  $thiz.Cb.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$18) => $thiz.hZ.remove(_$18))));
  $thiz.ti = ($m_sci_Vector$(), $m_sci_Vector0$());
  $thiz.x9 = ($m_sci_Vector$(), $m_sci_Vector0$());
  $thiz.LQ = ($m_sci_Vector$(), $m_sci_Vector0$());
  $thiz.Cb = ($m_sci_Vector$(), $m_sci_Vector0$());
  if ((!$f_sc_SeqOps__isEmpty__Z($thiz.tg))) {
    var n = $thiz.tg.C();
    if ((n <= 0)) {
      var $x_1 = new $ac_Z(0);
    } else {
      var array = new $ac_Z(n);
      var i = 0;
      while ((i < n)) {
        array.a[i] = true;
        i = ((1 + i) | 0);
      }
      var $x_1 = array;
    }
    $thiz.Gg = $x_1;
    var this$21 = new $c_sci_Range$Exclusive(0, $thiz.tg.C(), 1);
    $thiz.ti = $m_sci_Vector$().X(this$21).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((i$1) => {
      var i$2 = (i$1 | 0);
      var this$24 = new $c_s_PartialFunction$Lifted($thiz.dv.lF).as(i$2);
      var this$25 = ((this$24.c() || (this$24.d().C() >= 2)) ? this$24 : $m_s_None$());
      var this$26 = (this$25.c() ? $m_s_None$() : new $c_s_Some(((this$25.d().C() - 1) | 0)));
      var segments = ((this$26.c() ? 1 : this$26.d()) | 0);
      $m_sci_Vector$();
      var b = new $c_sci_VectorBuilder();
      var i$3 = 0;
      while ((i$3 < segments)) {
        var stem = new $i_three.Mesh($thiz.a0n, $thiz.SX);
        stem.frustumCulled = false;
        $thiz.hZ.add(stem);
        b.ck(stem);
        i$3 = ((1 + i$3) | 0);
      }
      return b.bY();
    })));
    $thiz.x9 = $thiz.ti.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((chain) => {
      $m_sci_Vector$();
      var y = ((chain.C() - 1) | 0);
      var n$1 = ((y < 0) ? 0 : y);
      var b$1 = new $c_sci_VectorBuilder();
      var i$4 = 0;
      while ((i$4 < n$1)) {
        var joint = new $i_three.Mesh($thiz.axZ, $thiz.SX);
        joint.frustumCulled = false;
        $thiz.hZ.add(joint);
        b$1.ck(joint);
        i$4 = ((1 + i$4) | 0);
      }
      return b$1.bY();
    })));
    $thiz.LQ = $thiz.ti.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((chain$2) => chain$2.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$21) => {
      var halo = new $i_three.Mesh($thiz.a0n, $thiz.ay4);
      halo.frustumCulled = false;
      halo.renderOrder = (-1.0);
      $thiz.hZ.add(halo);
      return halo;
    }))))));
    $thiz.Cb = $thiz.tg.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$22) => {
      var cone = new $i_three.Mesh($thiz.a0m, $thiz.a9s);
      $thiz.hZ.add(cone);
      return cone;
    })));
    $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__writeEdgeHighlight__V($thiz);
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__altitudeMaterial__I__Lorg_jpablo_graphexplorer_viewer_backends_threejs_MeshBasicMaterial($thiz, i) {
  var this$3 = new $c_s_PartialFunction$Lifted($thiz.dv.lF).as(i);
  var this$4 = ((this$3.c() || (!$f_sc_SeqOps__isEmpty__Z(this$3.d()))) ? this$3 : $m_s_None$());
  var this$7 = (this$4.c() ? $m_s_None$() : new $c_s_Some($f_sc_IterableOnceOps__maxBy__F1__s_math_Ordering__O(this$4.d(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((o) => {
    var x = o.cg;
    return (+Math.abs(x));
  })), $m_s_math_Ordering$DeprecatedDoubleOrdering$()).cg));
  var apex = (+(this$7.c() ? 0.0 : this$7.d()));
  return ((apex > 1.0E-6) ? $thiz.ay3 : ((apex < (-1.0E-6)) ? $thiz.ay2 : $thiz.SX));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__writeEdgeHighlight__V($thiz) {
  var this$1 = $thiz.tg;
  var end = this$1.C();
  var isEmpty = (end <= 0);
  var scala$collection$immutable$Range$$lastElement = ((end - 1) | 0);
  if ((!isEmpty)) {
    var i = 0;
    while (true) {
      var x0 = i;
      matchResult16: {
        var \u03b46$___1;
        var \u03b46$___2;
        var x43 = $thiz.tg.l(x0);
        if ((x43 !== null)) {
          var \u03b46$___1 = x43.g();
          var \u03b46$___2 = x43.h();
          break matchResult16;
        }
        throw new $c_s_MatchError(x43);
      }
      var s$2 = \u03b46$___1;
      var t$2 = \u03b46$___2;
      $thiz.Gg.a[x0] = (($thiz.x8.c() || $thiz.x8.E(s$2)) || $thiz.x8.E(t$2));
      if ((x0 < $thiz.ti.C())) {
        var material = ($thiz.Gg.a[x0] ? $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__altitudeMaterial__I__Lorg_jpablo_graphexplorer_viewer_backends_threejs_MeshBasicMaterial($thiz, x0) : $thiz.a9C);
        $thiz.ti.l(x0).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((material) => ((_$24) => {
          _$24.material = material;
        }))(material)));
        if ((x0 < $thiz.x9.C())) {
          $thiz.x9.l(x0).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((material) => ((_$25) => {
            _$25.material = material;
          }))(material)));
        }
      }
      if ((i === scala$collection$immutable$Range$$lastElement)) {
        break;
      }
      i = ((1 + i) | 0);
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__rebuildHulls__V($thiz) {
  $thiz.LM.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var mesh = x$1.g();
    var material = x$1.h();
    $thiz.hZ.remove(mesh);
    mesh.geometry.dispose();
    material.dispose();
  })));
  $thiz.LM = $f_sc_StrictOptimizedIterableOps__zipWithIndex__O($thiz.SR).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    var members = x$1$2.g();
    var i = (x$1$2.h() | 0);
    var material$1 = new $i_three.MeshBasicMaterial($m_Lorg_jpablo_graphexplorer_viewer_backends_threejs_MeshBasicMaterial$().Ay(($thiz.a9q.l(((i % $checkIntDivisor($thiz.a9q.C())) | 0)) | 0), true, 0.16, false, 2, true));
    var mesh$1 = new $i_three.Mesh($p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__hullGeometry__sci_Vector__Lorg_jpablo_graphexplorer_viewer_backends_threejs_ConvexGeometry($thiz, members), material$1);
    $thiz.hZ.add(mesh$1);
    return new $c_T2(mesh$1, material$1);
  })));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__hullGeometry__sci_Vector__Lorg_jpablo_graphexplorer_viewer_backends_threejs_ConvexGeometry($thiz, members) {
  var pts = [];
  members.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((m) => {
    var this$2 = $thiz.dv.fF.r(m);
    if ((!this$2.c())) {
      var x0 = this$2.d();
      var this$9 = new $c_sci_$colon$colon(new $c_T3($thiz.Gf, 0.0, 0.0), new $c_sci_$colon$colon(new $c_T3((-$thiz.Gf), 0.0, 0.0), new $c_sci_$colon$colon(new $c_T3(0.0, $thiz.Gf, 0.0), new $c_sci_$colon$colon(new $c_T3(0.0, (-$thiz.Gf), 0.0), new $c_sci_$colon$colon(new $c_T3(0.0, 0.0, $thiz.Gf), new $c_sci_$colon$colon(new $c_T3(0.0, 0.0, (-$thiz.Gf)), $m_sci_Nil$()))))));
      var these = this$9;
      while ((!these.c())) {
        var x0$1 = these.t();
        matchResult17: {
          if ((x0$1 !== null)) {
            var dx = (+x0$1.bH);
            var dy = (+x0$1.bU);
            var dz = (+x0$1.c3);
            (pts.push(new $i_three.Vector3().set((x0.cq + dx), (x0.cr + dy), (x0.cg + dz))) | 0);
            break matchResult17;
          }
          throw new $c_s_MatchError(x0$1);
        }
        these = these.v();
      }
    }
  })));
  return new $i_three$002faddons$002fgeometries$002fConvexGeometry$002ejs.ConvexGeometry(pts);
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__updateHulls__V($thiz) {
  $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O($thiz.LM, $thiz.SR).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    matchResult18: {
      if ((x$1 !== null)) {
        var x51 = x$1.g();
        if ((x51 !== null)) {
          var mesh = x51.g();
          var members = x$1.h();
          var old = mesh.geometry;
          mesh.geometry = $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__hullGeometry__sci_Vector__Lorg_jpablo_graphexplorer_viewer_backends_threejs_ConvexGeometry($thiz, members);
          old.dispose();
          break matchResult18;
        }
      }
      throw new $c_s_MatchError(x$1);
    }
  })));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__writePositions__V($thiz) {
  $thiz.qk.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var id = x$1.g();
    var ns = x$1.h();
    var this$2 = $thiz.dv.fF.r(id);
    if ((!this$2.c())) {
      var x0 = this$2.d();
      ns.p3.position.set(x0.cq, x0.cr, x0.cg);
    }
  })));
  var this$3 = $thiz.tg;
  var end = this$3.C();
  var isEmpty = (end <= 0);
  var scala$collection$immutable$Range$$lastElement = ((end - 1) | 0);
  if ((!isEmpty)) {
    var i = 0;
    while (true) {
      var x0$1 = i;
      matchResult19: {
        var \u03b47$___1;
        var \u03b47$___2;
        var x55 = $thiz.tg.l(x0$1);
        if ((x55 !== null)) {
          var \u03b47$___1 = x55.g();
          var \u03b47$___2 = x55.h();
          break matchResult19;
        }
        throw new $c_s_MatchError(x55);
      }
      var s$2 = \u03b47$___1;
      var t$2 = \u03b47$___2;
      var this$7 = $thiz.dv.fF.r(s$2);
      if ((!this$7.c())) {
        var x0$2 = this$7.d();
        var this$8 = $thiz.dv.fF.r(t$2);
        if ((!this$8.c())) {
          var x0$3 = this$8.d();
          var chain = ((x0$1 < $thiz.ti.C()) ? $thiz.ti.l(x0$1) : ($m_sci_Vector$(), $m_sci_Vector0$()));
          var path = $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__curvedPath__I__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3__sci_Vector($thiz, x0$1, x0$2, x0$3);
          if (((path.C() >= 2) && (chain.C() === ((path.C() - 1) | 0)))) {
            var lastD = path.bJ().fN(path.l(((path.C() - 2) | 0)));
            var lastLen = lastD.js();
            var coneOn = ((lastLen >= 1.0E-6) && $thiz.Gg.a[x0$1]);
            if (coneOn) {
              var dir = lastD.dj((1.0 / lastLen));
              var x = $thiz.axT;
              var y = (0.9 * lastLen);
              var trim = (+Math.min(x, y));
              var drawPath = path.nI(((path.C() - 1) | 0), path.bJ().fN(dir.dj(trim)));
            } else {
              var drawPath = path;
            }
            var end$1 = chain.C();
            var isEmpty$1 = (end$1 <= 0);
            var scala$collection$immutable$Range$$lastElement$1 = ((end$1 - 1) | 0);
            if ((!isEmpty$1)) {
              var i$1 = 0;
              while (true) {
                var x0$4 = i$1;
                $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__placeStemSegment__Lorg_jpablo_graphexplorer_viewer_backends_threejs_Mesh__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3__V($thiz, chain.l(x0$4), drawPath.l(x0$4), drawPath.l(((1 + x0$4) | 0)));
                if ((i$1 === scala$collection$immutable$Range$$lastElement$1)) {
                  break;
                }
                i$1 = ((1 + i$1) | 0);
              }
            }
            if ((x0$1 < $thiz.x9.C())) {
              var joints = $thiz.x9.l(x0$1);
              var end$2 = joints.C();
              var isEmpty$2 = (end$2 <= 0);
              var scala$collection$immutable$Range$$lastElement$2 = ((end$2 - 1) | 0);
              if ((!isEmpty$2)) {
                var i$2 = 0;
                while (true) {
                  var x0$5 = i$2;
                  var p = drawPath.l(((1 + x0$5) | 0));
                  joints.l(x0$5).visible = true;
                  joints.l(x0$5).position.set(p.cq, p.cr, p.cg);
                  joints.l(x0$5).scale.set($thiz.Ca, $thiz.Ca, $thiz.Ca);
                  if ((i$2 === scala$collection$immutable$Range$$lastElement$2)) {
                    break;
                  }
                  i$2 = ((1 + i$2) | 0);
                }
              }
            }
            if ((x0$1 < $thiz.Cb.C())) {
              var cone = $thiz.Cb.l(x0$1);
              if ((!coneOn)) {
                cone.visible = false;
              } else {
                cone.visible = true;
                var dir$2 = lastD.dj((1.0 / lastLen));
                var tip = path.bJ();
                cone.position.set((tip.cq - (dir$2.cq * $thiz.SP)), (tip.cr - (dir$2.cr * $thiz.SP)), (tip.cg - (dir$2.cg * $thiz.SP)));
                cone.quaternion.setFromUnitVectors($thiz.LL, $thiz.SS.set(dir$2.cq, dir$2.cr, dir$2.cg));
              }
            }
          } else {
            var d = x0$3.fN(x0$2);
            var len = d.js();
            var this$19 = $f_sc_IndexedSeqOps__headOption__s_Option(chain);
            if ((!this$19.c())) {
              var x0$6 = this$19.d();
              if ((len < 1.0E-6)) {
                x0$6.visible = false;
              } else {
                x0$6.visible = true;
                var dir$1 = d.dj((1.0 / len));
                var x$2 = (0.3 * len);
                var y$1 = (0.4 * $thiz.x6);
                var insetSrc = (+Math.min(x$2, y$1));
                if ($thiz.Gg.a[x0$1]) {
                  var x$3 = (0.5 * len);
                  var y$2 = (0.55 * $thiz.x6);
                  var insetTgt = ((+Math.min(x$3, y$2)) + $thiz.SP);
                } else {
                  var insetTgt = insetSrc;
                }
                var a = x0$2.iQ(dir$1.dj(insetSrc));
                var b = x0$3.fN(dir$1.dj(insetTgt));
                x0$6.position.set((0.5 * (a.cq + b.cq)), (0.5 * (a.cr + b.cr)), (0.5 * (a.cg + b.cg)));
                var $x_2 = x0$6.scale;
                var $x_1 = $thiz.Ca;
                var y$3 = ((len - insetSrc) - insetTgt);
                $x_2.set($x_1, (+Math.max(0.001, y$3)), $thiz.Ca);
                x0$6.quaternion.setFromUnitVectors($thiz.LL, $thiz.SS.set(dir$1.cq, dir$1.cr, dir$1.cg));
              }
            }
            chain.pH(1, chain.C()).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$26) => {
              _$26.visible = false;
            })));
            if ((x0$1 < $thiz.x9.C())) {
              $thiz.x9.l(x0$1).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$27) => {
                _$27.visible = false;
              })));
            }
            if ((x0$1 < $thiz.Cb.C())) {
              var cone$2 = $thiz.Cb.l(x0$1);
              if (((len < 1.0E-6) || (!$thiz.Gg.a[x0$1]))) {
                cone$2.visible = false;
              } else {
                cone$2.visible = true;
                var dir$3 = d.dj((1.0 / len));
                var x$4 = (0.5 * len);
                var y$4 = (0.55 * $thiz.x6);
                var back = (+Math.min(x$4, y$4));
                cone$2.position.set((x0$3.cq - (dir$3.cq * back)), (x0$3.cr - (dir$3.cr * back)), (x0$3.cg - (dir$3.cg * back)));
                cone$2.quaternion.setFromUnitVectors($thiz.LL, $thiz.SS.set(dir$3.cq, dir$3.cr, dir$3.cg));
              }
            }
          }
        }
      }
      if ((i === scala$collection$immutable$Range$$lastElement)) {
        break;
      }
      i = ((1 + i) | 0);
    }
  }
  $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__updateHulls__V($thiz);
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__curvedPath__I__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3__sci_Vector($thiz, i, sp, tp) {
  var this$3 = new $c_s_PartialFunction$Lifted($thiz.dv.lF).as(i);
  var x58 = ((this$3.c() || (this$3.d().C() >= 2)) ? this$3 : $m_s_None$());
  if ((x58 instanceof $c_s_Some)) {
    var off = x58.J;
    var n = off.C();
    $m_sci_Vector$();
    var b = new $c_sci_VectorBuilder();
    var i$1 = 0;
    while ((i$1 < n)) {
      var x0$1 = i$1;
      b.ck(sp.iQ(tp.fN(sp).dj((x0$1 / ((n - 1) | 0)))).iQ(off.l(x0$1)));
      i$1 = ((1 + i$1) | 0);
    }
    return b.bY();
  }
  if (($m_s_None$() === x58)) {
    $m_sci_Vector$();
    return $m_sci_Vector0$();
  }
  throw new $c_s_MatchError(x58);
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__placeStemSegment__Lorg_jpablo_graphexplorer_viewer_backends_threejs_Mesh__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3__V($thiz, stem, p, q) {
  var d = q.fN(p);
  var len = d.js();
  if ((len < 1.0E-6)) {
    stem.visible = false;
  } else {
    stem.visible = true;
    var dir = d.dj((1.0 / len));
    stem.position.set((0.5 * (p.cq + q.cq)), (0.5 * (p.cr + q.cr)), (0.5 * (p.cg + q.cg)));
    stem.scale.set($thiz.Ca, len, $thiz.Ca);
    stem.quaternion.setFromUnitVectors($thiz.LL, $thiz.SS.set(dir.cq, dir.cr, dir.cg));
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__applySelection__V($thiz) {
  if ($thiz.x8.c()) {
    var neighborhood = $m_s_None$();
  } else {
    var $x_1 = $thiz.x8;
    var this$1 = $thiz.tg;
    $m_sci_Vector$();
    var b = new $c_sci_VectorBuilder();
    var it = this$1.o();
    while (it.p()) {
      var x0 = it.q();
      var s = x0.g();
      var t = x0.h();
      b.fO(($thiz.x8.E(s) ? new $c_sci_$colon$colon(s, new $c_sci_$colon$colon(t, $m_sci_Nil$())) : ($thiz.x8.E(t) ? new $c_sci_$colon$colon(s, new $c_sci_$colon$colon(t, $m_sci_Nil$())) : $m_sci_Nil$())));
    }
    var neighborhood = new $c_s_Some($x_1.dI(b.bY()));
  }
  $thiz.qk.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    var id = x$1$2.g();
    x$1$2.h().Ce.R(($thiz.x8.E(id) ? $thiz.axX : $thiz.axW), ((neighborhood.c() || neighborhood.d().E(id)) ? 1.0 : $thiz.axU));
  })));
  $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__writeEdgeHighlight__V($thiz);
  $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__writePositions__V($thiz);
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__updateFog__V($thiz) {
  if ((!$thiz.dv.fF.c())) {
    $m_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$();
    var camP = new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3((+$thiz.eq.position.x), (+$thiz.eq.position.y), (+$thiz.eq.position.z));
    var toT = $thiz.iB.fN(camP);
    var y$1 = toT.js();
    var view = toT.dj((1.0 / (+Math.max(1.0E-9, y$1))));
    var minD = new $c_sr_DoubleRef(1.7976931348623157E308);
    var maxD = new $c_sr_DoubleRef((-1.7976931348623157E308));
    $thiz.dv.fF.e6().F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((p) => {
      var d = $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__localToWorld__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3($thiz, p).fN(camP).qW(view);
      var x$1 = minD.T;
      minD.T = (+Math.min(x$1, d));
      var x$2 = maxD.T;
      maxD.T = (+Math.max(x$2, d));
    })));
    var y$2 = (maxD.T - minD.T);
    var spread = (+Math.max(1.0, y$2));
    var $x_1 = $thiz.x7.fog;
    var y$3 = minD.T;
    $x_1.near = (+Math.max(0.1, y$3));
    $thiz.x7.fog.far = (maxD.T + spread);
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__basisFor__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3__T3($thiz, dir) {
  var view = dir.dj((-1.0));
  var x = view.qW($thiz.qj);
  if (((+Math.abs(x)) > 0.99)) {
    $m_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$();
    var ref = new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3(0.0, 0.0, 1.0);
  } else {
    var ref = $thiz.qj;
  }
  var right0 = view.IN(ref);
  var right = ((right0.js() < 1.0E-9) ? ($m_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$(), new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3(1.0, 0.0, 0.0)) : right0.dj((1.0 / right0.js())));
  return new $c_T3(right, right.IN(view), view);
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__fitCamera__D__V($thiz, alpha) {
  if (((!$thiz.dv.fF.c()) && (!(!(!$thiz.e9.xr.isPresenting))))) {
    var target0 = $thiz.iB;
    $m_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$();
    var camP = new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3((+$thiz.eq.position.x), (+$thiz.eq.position.y), (+$thiz.eq.position.z));
    var dirRaw = camP.fN(target0);
    var dir = ((dirRaw.js() < 1.0E-6) ? $thiz.a9n.dj((1.0 / $thiz.a9n.js())) : dirRaw.dj((1.0 / dirRaw.js())));
    matchResult21: {
      var \u03b48$___1;
      var \u03b48$___2;
      var \u03b48$___3;
      var x61 = $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__basisFor__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3__T3($thiz, dir);
      if ((x61 !== null)) {
        var \u03b48$___1 = x61.bH;
        var \u03b48$___2 = x61.bU;
        var \u03b48$___3 = x61.c3;
        break matchResult21;
      }
      throw new $c_s_MatchError(x61);
    }
    var right$2 = \u03b48$___1;
    var up$2 = \u03b48$___2;
    var view$2 = \u03b48$___3;
    var minX = new $c_sr_DoubleRef(1.7976931348623157E308);
    var minY = new $c_sr_DoubleRef(1.7976931348623157E308);
    var minZ = new $c_sr_DoubleRef(1.7976931348623157E308);
    var maxX = new $c_sr_DoubleRef((-1.7976931348623157E308));
    var maxY = new $c_sr_DoubleRef((-1.7976931348623157E308));
    var maxZ = new $c_sr_DoubleRef((-1.7976931348623157E308));
    $thiz.dv.fF.e6().F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((p) => {
      var x$1 = minX.T;
      var y$1 = p.cq;
      minX.T = (+Math.min(x$1, y$1));
      var x$2 = maxX.T;
      var y$2 = p.cq;
      maxX.T = (+Math.max(x$2, y$2));
      var x$3 = minY.T;
      var y$3 = p.cr;
      minY.T = (+Math.min(x$3, y$3));
      var x$4 = maxY.T;
      var y$4 = p.cr;
      maxY.T = (+Math.max(x$4, y$4));
      var x$5 = minZ.T;
      var y$5 = p.cg;
      minZ.T = (+Math.min(x$5, y$5));
      var x$6 = maxZ.T;
      var y$6 = p.cg;
      maxZ.T = (+Math.max(x$6, y$6));
    })));
    $m_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$();
    var roughCenter = new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3((0.5 * (minX.T + maxX.T)), (0.5 * (minY.T + maxY.T)), (0.5 * (minZ.T + maxZ.T)));
    var x$8 = (0.5 * $thiz.a9m);
    var x$9 = (0.017453292519943295 * x$8);
    var tanV = (+Math.tan(x$9));
    var y$8 = (+$thiz.eq.aspect);
    var tanH = (tanV * (+Math.max(0.3, y$8)));
    matchResult22: {
      var \u03b49$___1;
      var \u03b49$___2;
      var \u03b49$___3;
      var \u03b49$___4;
      var x65 = $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__solveAbout$1__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3__D__D__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3__T4($thiz, right$2, up$2, view$2, tanH, tanV, roughCenter);
      if ((x65 !== null)) {
        var \u03b49$___1 = (+x65.bO);
        var \u03b49$___2 = (+x65.bs);
        var \u03b49$___3 = (+x65.ch);
        var \u03b49$___4 = (+x65.ca);
        break matchResult22;
      }
      throw new $c_s_MatchError(x65);
    }
    var aX1$2 = (+\u03b49$___1);
    var bX1$2 = (+\u03b49$___2);
    var aY1$2 = (+\u03b49$___3);
    var bY1$2 = (+\u03b49$___4);
    var center1 = roughCenter.iQ(right$2.dj((0.5 * (tanH * (aX1$2 - bX1$2))))).iQ(up$2.dj((0.5 * (tanV * (aY1$2 - bY1$2)))));
    var x$10 = (0.5 * (aX1$2 + bX1$2));
    var y$9 = (0.5 * (aY1$2 + bY1$2));
    var y$10 = (+Math.max(x$10, y$9));
    var dist1 = (+Math.max(2.0, y$10));
    var camC = center1.iQ(dir.dj(dist1));
    var minNX = new $c_sr_DoubleRef(1.7976931348623157E308);
    var maxNX = new $c_sr_DoubleRef((-1.7976931348623157E308));
    var minNY = new $c_sr_DoubleRef(1.7976931348623157E308);
    var maxNY = new $c_sr_DoubleRef((-1.7976931348623157E308));
    $thiz.dv.fF.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$1) => {
      var nodeId = x$1$1.g();
      var p$1 = x$1$1.h();
      var rel = p$1.fN(camC);
      var y$11 = rel.qW(view$2);
      var dz = (+Math.max(0.1, y$11));
      var nx = (rel.qW(right$2) / (dz * tanH));
      var ny = (rel.qW(up$2) / (dz * tanV));
      var hw = ($p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__halfW$1__Lorg_jpablo_graphexplorer_viewer_models_NodeId__D($thiz, nodeId) / (dz * tanH));
      var hh = ($p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__halfH$1__Lorg_jpablo_graphexplorer_viewer_models_NodeId__D($thiz, nodeId) / (dz * tanV));
      var x$11 = minNX.T;
      var y$12 = (nx - hw);
      minNX.T = (+Math.min(x$11, y$12));
      var x$12 = maxNX.T;
      var y$13 = (nx + hw);
      maxNX.T = (+Math.max(x$12, y$13));
      var x$13 = minNY.T;
      var y$14 = (ny - hh);
      minNY.T = (+Math.min(x$13, y$14));
      var x$14 = maxNY.T;
      var y$15 = (ny + hh);
      maxNY.T = (+Math.max(x$14, y$15));
    })));
    var center = center1.iQ(right$2.dj((((0.5 * (minNX.T + maxNX.T)) * dist1) * tanH))).iQ(up$2.dj((((0.5 * (minNY.T + maxNY.T)) * dist1) * tanV)));
    matchResult23: {
      var \u03b410$___1;
      var \u03b410$___2;
      var \u03b410$___3;
      var \u03b410$___4;
      var x70 = $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__solveAbout$1__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3__D__D__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3__T4($thiz, right$2, up$2, view$2, tanH, tanV, center);
      if ((x70 !== null)) {
        var \u03b410$___1 = (+x70.bO);
        var \u03b410$___2 = (+x70.bs);
        var \u03b410$___3 = (+x70.ch);
        var \u03b410$___4 = (+x70.ca);
        break matchResult23;
      }
      throw new $c_s_MatchError(x70);
    }
    var aX2$2 = (+\u03b410$___1);
    var bX2$2 = (+\u03b410$___2);
    var aY2$2 = (+\u03b410$___3);
    var bY2$2 = (+\u03b410$___4);
    var x$15 = (0.5 * (aX2$2 + bX2$2));
    var y$16 = (0.5 * (aY2$2 + bY2$2));
    var y$17 = (+Math.max(x$15, y$16));
    var fitDist = (1.04 * (+Math.max(2.0, y$17)));
    var newTarget = target0.iQ(center.fN(target0).dj(alpha));
    var newDist = (dirRaw.js() + ((fitDist - dirRaw.js()) * alpha));
    $thiz.iB = newTarget;
    $thiz.eq.position.set((newTarget.cq + (dir.cq * newDist)), (newTarget.cr + (dir.cr * newDist)), (newTarget.cg + (dir.cg * newDist)));
    $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__applyCameraPose__V($thiz);
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__setupXR__V($thiz) {
  $thiz.e9.xr.enabled = true;
  $thiz.e9.xr.addEventListener("sessionstart", ((_$34) => {
    $f_Lcom_raquo_airstream_state_Var__set__O__V($thiz.a0o, true);
    $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__enterXRLayout__V($thiz);
  }));
  $thiz.e9.xr.addEventListener("sessionend", ((_$35) => {
    $thiz.SY = $m_s_None$();
    $f_Lcom_raquo_airstream_state_Var__set__O__V($thiz.a0o, false);
    $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__exitXRLayout__V($thiz);
  }));
  $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__bindController__I__V($thiz, 0);
  $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__bindController__I__V($thiz, 1);
  var navXr = navigator.xr;
  if ((navXr !== (void 0))) {
    $m_sjs_js_Thenable$Implicits$().aSP(navXr.isSessionSupported("immersive-vr")).oB(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => {
      if ((!(!v1))) {
        $f_Lcom_raquo_airstream_state_Var__set__O__V($thiz.a9G, true);
      }
    })), $m_s_concurrent_ExecutionContext$().ek());
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__enterXRLayout__V($thiz) {
  var this$1 = $f_sc_IterableOnceOps__maxOption__s_math_Ordering__s_Option($thiz.dv.fF.e6().L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$36) => _$36.js()))), $m_s_math_Ordering$DeprecatedDoubleOrdering$());
  var radius = (+(this$1.c() ? 1.0 : this$1.d()));
  var y = (1.1 / (+Math.max(0.5, radius)));
  var s = (+Math.min(1.0, y));
  $thiz.hZ.scale.set(s, s, s);
  $thiz.hZ.position.set(0.0, 1.3, (-1.6));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__exitXRLayout__V($thiz) {
  $thiz.hZ.scale.set(1.0, 1.0, 1.0);
  $thiz.hZ.position.set(0.0, 0.0, 0.0);
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__bindController__I__V($thiz, index) {
  var controller = $thiz.e9.xr.getController(index);
  $thiz.x7.add(controller);
  controller.addEventListener("selectstart", ((_$37) => {
    $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__vrSelectStart__Lorg_jpablo_graphexplorer_viewer_backends_threejs_Object3D__V($thiz, controller);
  }));
  controller.addEventListener("selectend", ((_$38) => {
    $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__vrSelectEnd__Lorg_jpablo_graphexplorer_viewer_backends_threejs_Object3D__V($thiz, controller);
  }));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__setRayFromController__Lorg_jpablo_graphexplorer_viewer_backends_threejs_Object3D__V($thiz, controller) {
  $thiz.a9D.identity().extractRotation(controller.matrixWorld);
  $thiz.th.ray.origin.setFromMatrixPosition(controller.matrixWorld);
  $thiz.th.ray.direction.set(0.0, 0.0, (-1.0)).applyMatrix4($thiz.a9D);
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__vrSelectStart__Lorg_jpablo_graphexplorer_viewer_backends_threejs_Object3D__V($thiz, controller) {
  $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__setRayFromController__Lorg_jpablo_graphexplorer_viewer_backends_threejs_Object3D__V($thiz, controller);
  $thiz.a9F = $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__rayDirection__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3($thiz);
  var this$2 = $m_sjs_js_ArrayOps$().aP7($thiz.th.intersectObjects($thiz.Gh.children, false));
  if ((!this$2.c())) {
    var x0 = this$2.d();
    var dict = x0.object.userData;
    var this$5 = ((!(!$m_sjs_js_WrappedDictionary$Cache$().vL.call(dict, "nodeId"))) ? new $c_s_Some(dict.nodeId) : $m_s_None$());
    if ((!this$5.c())) {
      var x0$1 = this$5.d();
      $thiz.LR = new $c_s_Some(new $c_T3(controller, ($m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$(), new $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId(x0$1)), (+x0.distance)));
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__vrSelectEnd__Lorg_jpablo_graphexplorer_viewer_backends_threejs_Object3D__V($thiz, controller) {
  var x78 = $thiz.LR;
  if ((x78 instanceof $c_s_Some)) {
    var x80 = x78.J;
    if ((x80 !== null)) {
      var c = x80.bH;
      var id = x80.bU;
      if (Object.is(c, controller)) {
        $thiz.LR = $m_s_None$();
        $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__setRayFromController__Lorg_jpablo_graphexplorer_viewer_backends_threejs_Object3D__V($thiz, controller);
        var wasClick = ($thiz.a9F.qW($p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__rayDirection__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3($thiz)) > 0.9985);
        $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__releasePins__V($thiz);
        if (wasClick) {
          $thiz.zj.aH().a53($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_ElementId.r().C)([id])));
          return (void 0);
        } else {
          return (void 0);
        }
      }
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__frame__D__V($thiz, time) {
  var this$1 = $thiz.LR;
  if ((!this$1.c())) {
    var x0 = this$1.d();
    var controller = x0.bH;
    var id = x0.bU;
    var dist = (+x0.c3);
    $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__setRayFromController__Lorg_jpablo_graphexplorer_viewer_backends_threejs_Object3D__V($thiz, controller);
    $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__pinNodeAt__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3__V($thiz, id, $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__worldToLocal__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3($thiz, $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__rayOrigin__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3($thiz).iQ($p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__rayDirection__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3($thiz).dj(dist))));
  }
  if ((!$thiz.dv.DU())) {
    var s = 0;
    while (((s < $thiz.axY) && (!$thiz.dv.DU()))) {
      $thiz.dv = $thiz.vi.Jo($thiz.dv);
      s = ((1 + s) | 0);
    }
    $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__writePositions__V($thiz);
  }
  if (((($thiz.SQ || $thiz.zi) && $thiz.LO.c()) && $thiz.LR.c())) {
    $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__fitCamera__D__V($thiz, 0.2);
    if (($thiz.zi && $thiz.dv.DU())) {
      $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__fitCamera__D__V($thiz, 1.0);
      $thiz.zi = false;
    }
  }
  $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__updateFog__V($thiz);
  $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__updateStemHalos__V($thiz);
  $thiz.e9.render($thiz.x7, $thiz.eq);
  if ((!(!(!$thiz.e9.xr.isPresenting)))) {
    $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__renderGizmo__V($thiz);
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__updateStemHalos__V($thiz) {
  var vd = $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__cameraDirection__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3($thiz);
  var i = 0;
  while ((i < $thiz.ti.C())) {
    var chain = $thiz.ti.l(i);
    var halos = ((i < $thiz.LQ.C()) ? $thiz.LQ.l(i) : ($m_sci_Vector$(), $m_sci_Vector0$()));
    var k = 0;
    while (((k < chain.C()) && (k < halos.C()))) {
      var stem = chain.l(k);
      var halo = halos.l(k);
      halo.visible = (!(!stem.visible));
      if ((!(!stem.visible))) {
        halo.position.set(((+stem.position.x) + (vd.cq * $thiz.a0l)), ((+stem.position.y) + (vd.cr * $thiz.a0l)), ((+stem.position.z) + (vd.cg * $thiz.a0l)));
        halo.quaternion.copy(stem.quaternion);
        halo.scale.set(((+stem.scale.x) * $thiz.a9p), (+stem.scale.y), ((+stem.scale.z) * $thiz.a9p));
      }
      k = ((1 + k) | 0);
    }
    i = ((1 + i) | 0);
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__resize__Lorg_scalajs_dom_Element__V($thiz, container) {
  var w = (container.clientWidth | 0);
  var h = (container.clientHeight | 0);
  if (((w > 0.0) && (h > 0.0))) {
    $thiz.e9.setSize(w, h);
    $thiz.eq.aspect = (w / h);
    $thiz.eq.updateProjectionMatrix();
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__applyCameraPose__V($thiz) {
  $thiz.eq.up.set($thiz.qj.cq, $thiz.qj.cr, $thiz.qj.cg);
  $thiz.eq.lookAt($thiz.iB.cq, $thiz.iB.cr, $thiz.iB.cg);
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__rotateBy__D__D__V($thiz, mx, my) {
  $m_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$();
  var camP = new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3((+$thiz.eq.position.x), (+$thiz.eq.position.y), (+$thiz.eq.position.z));
  var offset = camP.fN($thiz.iB);
  var y$1 = ($thiz.e9.domElement.clientHeight | 0);
  var h = ((y$1 < 1) ? 1 : y$1);
  var y$2 = offset.js();
  var view = offset.dj(((-1.0) / (+Math.max(1.0E-9, y$2))));
  var right0 = view.IN($thiz.qj);
  var y$3 = right0.js();
  var right = right0.dj((1.0 / (+Math.max(1.0E-9, y$3))));
  var up = right.IN(view);
  var yaw = (((-6.283185307179586) * mx) / h);
  var pitch = (((-6.283185307179586) * my) / h);
  var off1 = offset.ahM(up, yaw);
  var off2 = off1.ahM(right, pitch);
  $thiz.qj = up.ahM(right, pitch);
  $thiz.eq.position.set(($thiz.iB.cq + off2.cq), ($thiz.iB.cr + off2.cr), ($thiz.iB.cg + off2.cg));
  $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__applyCameraPose__V($thiz);
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__panBy__D__D__V($thiz, mx, my) {
  $thiz.zi = false;
  if ((!(!$thiz.zj.xq.P().aq().d()))) {
    $f_Lcom_raquo_airstream_state_Var__set__O__V($thiz.zj.xq, false);
  }
  $m_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$();
  var camP = new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3((+$thiz.eq.position.x), (+$thiz.eq.position.y), (+$thiz.eq.position.z));
  var offset = camP.fN($thiz.iB);
  var y$1 = offset.js();
  var dist = (+Math.max(1.0E-9, y$1));
  var y$2 = ($thiz.e9.domElement.clientHeight | 0);
  var h = ((y$2 < 1) ? 1 : y$2);
  var x$1 = ((3.141592653589793 * (0.5 * $thiz.a9m)) / 180.0);
  var wpp = (((2.0 * dist) * (+Math.tan(x$1))) / h);
  var view = offset.dj(((-1.0) / dist));
  var right0 = view.IN($thiz.qj);
  var y$3 = right0.js();
  var right = right0.dj((1.0 / (+Math.max(1.0E-9, y$3))));
  var up = right.IN(view);
  var move = right.dj(((-mx) * wpp)).iQ(up.dj((my * wpp)));
  $thiz.iB = $thiz.iB.iQ(move);
  $thiz.eq.position.set((camP.cq + move.cq), (camP.cr + move.cr), (camP.cg + move.cg));
  $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__applyCameraPose__V($thiz);
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__dollyBy__D__Lorg_scalajs_dom_MouseEvent__V($thiz, factor, e) {
  $thiz.zi = false;
  $m_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$();
  var camP = new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3((+$thiz.eq.position.x), (+$thiz.eq.position.y), (+$thiz.eq.position.z));
  var offset = camP.fN($thiz.iB);
  var y$1 = offset.js();
  var dist = (+Math.max(1.0E-9, y$1));
  var y$2 = (dist * factor);
  var y$3 = (+Math.max(0.6, y$2));
  var nd = (+Math.min(400.0, y$3));
  var f = (nd / dist);
  $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__setRayFromPointer__Lorg_scalajs_dom_MouseEvent__V($thiz, e);
  var view = offset.dj(((-1.0) / dist));
  var this$8 = $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__planeIntersect__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3__s_Option($thiz, $thiz.iB, view);
  var anchor = (this$8.c() ? $thiz.iB : this$8.d());
  $thiz.iB = anchor.iQ($thiz.iB.fN(anchor).dj(f));
  $thiz.eq.position.set((anchor.cq + ((camP.cq - anchor.cq) * f)), (anchor.cr + ((camP.cr - anchor.cr) * f)), (anchor.cg + ((camP.cg - anchor.cg) * f)));
  $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__applyCameraPose__V($thiz);
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__attachWheelNavigation__V($thiz) {
  $thiz.e9.domElement.addEventListener("wheel", ((e) => {
    if ((!(!(!$thiz.e9.xr.isPresenting)))) {
      e.preventDefault();
      if ((!(!e.altKey))) {
        $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__panBy__D__D__V($thiz, (-(+e.deltaX)), (-(+e.deltaY)));
        return (void 0);
      } else if ((((!(!e.ctrlKey)) || (!(!e.metaKey))) || (!$thiz.a9E))) {
        if ((!(!$thiz.zj.xq.P().aq().d()))) {
          $f_Lcom_raquo_airstream_state_Var__set__O__V($thiz.zj.xq, false);
        }
        var x = (0.01 * (+e.deltaY));
        $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__dollyBy__D__Lorg_scalajs_dom_MouseEvent__V($thiz, (+Math.exp(x)), e);
        return (void 0);
      } else {
        $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__rotateBy__D__D__V($thiz, (-(+e.deltaX)), (-(+e.deltaY)));
        return (void 0);
      }
    } else {
      return (void 0);
    }
  }));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__attachPointerHandlers__V($thiz) {
  $thiz.e9.domElement.addEventListener("pointerdown", ((e) => {
    $thiz.a9t = (+e.clientX);
    $thiz.a9u = (+e.clientY);
    $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__setRayFromPointer__Lorg_scalajs_dom_MouseEvent__V($thiz, e);
    var x84 = $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__hitNodeId__s_Option($thiz);
    if ((x84 instanceof $c_s_Some)) {
      var id = x84.J;
      $thiz.LO = new $c_s_Some(id);
      $thiz.a9w = $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__localToWorld__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3($thiz, $thiz.dv.fF.ay(id, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$().zv))));
      $thiz.a9v = $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__cameraDirection__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3($thiz);
      return $thiz.e9.domElement.setPointerCapture((+e.pointerId));
    }
    if (($m_s_None$() === x84)) {
      $thiz.SW = new $c_s_Some(new $c_T2((+e.clientX), (+e.clientY)));
      return $thiz.e9.domElement.setPointerCapture((+e.pointerId));
    }
    throw new $c_s_MatchError(x84);
  }));
  $thiz.e9.domElement.addEventListener("pointermove", ((e$2) => {
    var this$7 = $thiz.LO;
    if ((!this$7.c())) {
      var x0 = this$7.d();
      $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__setRayFromPointer__Lorg_scalajs_dom_MouseEvent__V($thiz, e$2);
      var this$8 = $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__planeIntersect__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3__s_Option($thiz, $thiz.a9w, $thiz.a9v);
      if ((!this$8.c())) {
        $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__pinNodeAt__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3__V($thiz, x0, $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__worldToLocal__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3($thiz, this$8.d()));
      }
    }
    var this$9 = $thiz.SW;
    if ((!this$9.c())) {
      var x0$2 = this$9.d();
      var lx = (+x0$2.g());
      var ly = (+x0$2.h());
      if ((!(!e$2.altKey))) {
        $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__panBy__D__D__V($thiz, ((+e$2.clientX) - lx), ((+e$2.clientY) - ly));
      } else {
        $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__rotateBy__D__D__V($thiz, ((+e$2.clientX) - lx), ((+e$2.clientY) - ly));
      }
      $thiz.SW = new $c_s_Some(new $c_T2((+e$2.clientX), (+e$2.clientY)));
    }
  }));
  $thiz.e9.domElement.addEventListener("pointerup", ((e$3) => {
    var wasClick = ($m_jl_Math$().ga(((+e$3.clientX) - $thiz.a9t), ((+e$3.clientY) - $thiz.a9u)) < $thiz.axS);
    var additive = ((!(!e$3.shiftKey)) || (!(!e$3.metaKey)));
    $thiz.SW = $m_s_None$();
    matchResult27: {
      var x87 = $thiz.LO;
      if ((x87 instanceof $c_s_Some)) {
        var id$1 = x87.J;
        $thiz.LO = $m_s_None$();
        $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__releasePins__V($thiz);
        if (wasClick) {
          if (additive) {
            $thiz.zj.aH().a53($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_ElementId.r().C)([id$1])));
          } else {
            $thiz.zj.aH().gC($m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_ElementId.r().C)([id$1]))));
          }
          break matchResult27;
        } else {
          break matchResult27;
        }
      }
      if (($m_s_None$() === x87)) {
        if ((wasClick && (!additive))) {
          $thiz.zj.aH().rd($m_sci_Set$EmptySet$());
          break matchResult27;
        } else {
          break matchResult27;
        }
      }
      throw new $c_s_MatchError(x87);
    }
  }));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__setRayFromPointer__Lorg_scalajs_dom_MouseEvent__V($thiz, e) {
  var rect = $thiz.e9.domElement.getBoundingClientRect();
  var ndcX = ((2.0 * (((+e.clientX) - (+rect.left)) / (+rect.width))) - 1.0);
  var ndcY = (-((2.0 * (((+e.clientY) - (+rect.top)) / (+rect.height))) - 1.0));
  $thiz.th.setFromCamera($thiz.ay1.set(ndcX, ndcY), $thiz.eq);
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__hitNodeId__s_Option($thiz) {
  var this$2 = $m_sjs_js_ArrayOps$().aP7($thiz.th.intersectObjects($thiz.Gh.children, false));
  if (this$2.c()) {
    var this$5 = $m_s_None$();
  } else {
    var x0 = this$2.d();
    var dict = x0.object.userData;
    var this$5 = ((!(!$m_sjs_js_WrappedDictionary$Cache$().vL.call(dict, "nodeId"))) ? new $c_s_Some(dict.nodeId) : $m_s_None$());
  }
  if (this$5.c()) {
    return $m_s_None$();
  } else {
    var x0$1 = this$5.d();
    $m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$();
    return new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId(x0$1));
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__rayOrigin__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3($thiz) {
  $m_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$();
  return new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3((+$thiz.th.ray.origin.x), (+$thiz.th.ray.origin.y), (+$thiz.th.ray.origin.z));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__rayDirection__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3($thiz) {
  $m_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$();
  return new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3((+$thiz.th.ray.direction.x), (+$thiz.th.ray.direction.y), (+$thiz.th.ray.direction.z));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__cameraDirection__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3($thiz) {
  $thiz.eq.getWorldDirection($thiz.LP);
  $m_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$();
  return new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3((+$thiz.LP.x), (+$thiz.LP.y), (+$thiz.LP.z));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__planeIntersect__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3__s_Option($thiz, p0, n) {
  var o = $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__rayOrigin__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3($thiz);
  var d = $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__rayDirection__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3($thiz);
  var denom = n.qW(d);
  if (((+Math.abs(denom)) < 1.0E-6)) {
    return $m_s_None$();
  } else {
    var t = (n.qW(p0.fN(o)) / denom);
    return ((t <= 0.0) ? $m_s_None$() : new $c_s_Some(o.iQ(d.dj(t))));
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__localToWorld__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3($thiz, local) {
  var s = (+$thiz.hZ.scale.x);
  $m_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$();
  return new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3(((local.cq * s) + (+$thiz.hZ.position.x)), ((local.cr * s) + (+$thiz.hZ.position.y)), ((local.cg * s) + (+$thiz.hZ.position.z)));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__worldToLocal__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3($thiz, world) {
  var y = (+$thiz.hZ.scale.x);
  var s = (+Math.max(1.0E-9, y));
  $m_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$();
  return new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3(((world.cq - (+$thiz.hZ.position.x)) / s), ((world.cr - (+$thiz.hZ.position.y)) / s), ((world.cg - (+$thiz.hZ.position.z)) / s));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__pinNodeAt__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3__V($thiz, id, local) {
  var \u03b411$ = $thiz.dv;
  var positions$1 = $thiz.dv.fF.bN(id, local);
  var pinned$1 = $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_NodeId.r().C)([id])));
  var x = $thiz.dv.vq;
  var y = $thiz.a9o;
  var temperature$1 = (+Math.max(x, y));
  $thiz.dv = new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayoutState3D(\u03b411$.l2, \u03b411$.he, positions$1, temperature$1, \u03b411$.mk, \u03b411$.kE, pinned$1, \u03b411$.nc, \u03b411$.lF);
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__releasePins__V($thiz) {
  var \u03b412$ = $thiz.dv;
  var pinned$2 = $m_sci_Set$EmptySet$();
  var x = $thiz.dv.vq;
  var y = $thiz.a9o;
  var temperature$2 = (+Math.max(x, y));
  $thiz.dv = new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayoutState3D(\u03b412$.l2, \u03b412$.he, \u03b412$.fF, temperature$2, \u03b412$.mk, \u03b412$.kE, pinned$2, \u03b412$.nc, \u03b412$.lF);
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__halfW$1__Lorg_jpablo_graphexplorer_viewer_models_NodeId__D($thiz, nodeId) {
  var this$1 = $thiz.qk.r(nodeId);
  if (this$1.c()) {
    var this$2 = $m_s_None$();
  } else {
    var x0 = this$1.d();
    var this$2 = new $c_s_Some((0.5 * (+x0.p3.scale.x)));
  }
  return ((+(this$2.c() ? $thiz.x6 : this$2.d())) + (0.25 * $thiz.x6));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__halfH$1__Lorg_jpablo_graphexplorer_viewer_models_NodeId__D($thiz, nodeId) {
  var this$1 = $thiz.qk.r(nodeId);
  if (this$1.c()) {
    var this$2 = $m_s_None$();
  } else {
    var x0 = this$1.d();
    var this$2 = new $c_s_Some((0.5 * (+x0.p3.scale.y)));
  }
  return ((+(this$2.c() ? $thiz.x6 : this$2.d())) + (0.25 * $thiz.x6));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__solveAbout$1__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3__D__D__Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3__T4($thiz, right$2, up$2, view$3, tanH$2, tanV$2, c) {
  var aX = new $c_sr_DoubleRef((-1.7976931348623157E308));
  var bX = new $c_sr_DoubleRef((-1.7976931348623157E308));
  var aY = new $c_sr_DoubleRef((-1.7976931348623157E308));
  var bY = new $c_sr_DoubleRef((-1.7976931348623157E308));
  $thiz.dv.fF.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var nodeId = x$1.g();
    var p = x$1.h();
    var rel = p.fN(c);
    var x = rel.qW(right$2);
    var y = rel.qW(up$2);
    var z = rel.qW(view$3);
    var x$2 = aX.T;
    var y$1 = (((x + $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__halfW$1__Lorg_jpablo_graphexplorer_viewer_models_NodeId__D($thiz, nodeId)) / tanH$2) - z);
    aX.T = (+Math.max(x$2, y$1));
    var x$3 = bX.T;
    var y$2 = ((((-x) + $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__halfW$1__Lorg_jpablo_graphexplorer_viewer_models_NodeId__D($thiz, nodeId)) / tanH$2) - z);
    bX.T = (+Math.max(x$3, y$2));
    var x$4 = aY.T;
    var y$3 = (((y + $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__halfH$1__Lorg_jpablo_graphexplorer_viewer_models_NodeId__D($thiz, nodeId)) / tanV$2) - z);
    aY.T = (+Math.max(x$4, y$3));
    var x$5 = bY.T;
    var y$4 = ((((-y) + $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__halfH$1__Lorg_jpablo_graphexplorer_viewer_models_NodeId__D($thiz, nodeId)) / tanV$2) - z);
    bY.T = (+Math.max(x$5, y$4));
  })));
  return new $c_T4(aX.T, bX.T, aY.T, bY.T);
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D(state) {
  this.zj = null;
  this.a9r = null;
  this.axY = 0;
  this.x6 = 0.0;
  this.axV = 0.0;
  this.axX = 0;
  this.axW = 0;
  this.axU = 0.0;
  this.e9 = null;
  this.x7 = null;
  this.eq = null;
  this.hZ = null;
  this.Gh = null;
  this.th = null;
  this.ay1 = null;
  this.a9D = null;
  this.LP = null;
  this.LK = null;
  this.vi = null;
  this.dv = null;
  this.LN = null;
  this.qk = null;
  this.tg = null;
  this.x8 = null;
  this.a9z = 0;
  this.iB = null;
  this.qj = null;
  this.SW = null;
  this.a9B = null;
  this.a9G = null;
  this.a0o = null;
  this.SY = null;
  this.Gg = null;
  this.a0m = null;
  this.axT = 0.0;
  this.SP = 0.0;
  this.a9s = null;
  this.Cb = null;
  this.LL = null;
  this.SS = null;
  this.Ca = 0.0;
  this.a0n = null;
  this.SX = null;
  this.ay3 = null;
  this.ay2 = null;
  this.a9p = 0.0;
  this.a0l = 0.0;
  this.ay4 = null;
  this.LQ = null;
  this.a9C = null;
  this.ti = null;
  this.axZ = null;
  this.x9 = null;
  this.ay0 = null;
  this.a9q = null;
  this.Gf = 0.0;
  this.SR = null;
  this.LM = null;
  this.Ge = 0.0;
  this.a0k = 0.0;
  this.SU = null;
  this.ST = null;
  this.axR = null;
  this.axQ = null;
  this.axP = null;
  this.Gd = 0.0;
  this.a9x = null;
  this.a9y = null;
  this.a9E = false;
  this.SV = false;
  this.a9A = null;
  this.a9m = 0.0;
  this.a9n = null;
  this.SQ = false;
  this.zi = false;
  this.LR = null;
  this.a9F = null;
  this.a9o = 0.0;
  this.axS = 0.0;
  this.LO = null;
  this.a9w = null;
  this.a9v = null;
  this.a9t = 0.0;
  this.a9u = 0.0;
  this.zj = state;
  this.a9r = new $c_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D$NodeSprite$(this);
  this.axY = 3;
  this.x6 = 0.42;
  this.axV = 3.0;
  this.axX = 8828671;
  this.axW = 16777215;
  this.axU = 0.16;
  this.e9 = new $i_three.WebGLRenderer($m_Lorg_jpablo_graphexplorer_viewer_backends_threejs_WebGLRenderer$().b6k(true, true));
  this.x7 = new $i_three.Scene();
  this.eq = new $i_three.PerspectiveCamera(50.0, 1.0, 0.1, 2000.0);
  this.hZ = new $i_three.Group();
  this.Gh = new $i_three.Group();
  this.th = new $i_three.Raycaster();
  this.ay1 = new $i_three.Vector2();
  this.a9D = new $i_three.Matrix4();
  this.LP = new $i_three.Vector3();
  this.x7.background = new $i_three.Color().setHex(1382945.0);
  this.x7.fog = new $i_three.Fog(1382945.0, 10.0, 60.0);
  this.x7.add(this.hZ);
  this.hZ.add(this.Gh);
  this.LK = $m_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$();
  this.vi = this.LK;
  this.dv = this.vi.Pv(new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayoutGraph(($m_sci_Vector$(), $m_sci_Vector0$()), ($m_sci_Vector$(), $m_sci_Vector0$()), ($m_sci_Vector$(), $m_sci_Vector0$()), $m_s_None$()));
  this.LN = $m_Lcom_raquo_laminar_api_package$().b.ff.bx($p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__defaultKnobValues__Lorg_jpablo_graphexplorer_viewer_layout3d_Layout3D__sci_Map(this, this.LK));
  this.qk = $m_sci_Map$EmptyMap$();
  this.tg = ($m_sci_Vector$(), $m_sci_Vector0$());
  this.x8 = $m_sci_Set$EmptySet$();
  this.a9z = (-1);
  this.iB = $m_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$().zv;
  this.qj = ($m_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$(), new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3(0.0, 1.0, 0.0));
  this.SW = $m_s_None$();
  this.a9B = $m_s_None$();
  this.a9G = $m_Lcom_raquo_laminar_api_package$().b.ff.bx(false);
  this.a0o = $m_Lcom_raquo_laminar_api_package$().b.ff.bx(false);
  this.SY = $m_s_None$();
  this.Gg = new $ac_Z(0);
  this.a0m = new $i_three.ConeGeometry(0.05, 0.14, 10);
  this.axT = 0.14;
  this.SP = 0.07;
  this.a9s = new $i_three.MeshBasicMaterial($m_Lorg_jpablo_graphexplorer_viewer_backends_threejs_MeshBasicMaterial$().Ay(5938674, false, 1.0, true, 0, true));
  this.Cb = ($m_sci_Vector$(), $m_sci_Vector0$());
  this.LL = new $i_three.Vector3().set(0.0, 1.0, 0.0);
  this.SS = new $i_three.Vector3();
  this.Ca = 0.011;
  this.a0n = new $i_three.CylinderGeometry(1.0, 1.0, 1.0, 8);
  this.SX = new $i_three.MeshBasicMaterial($m_Lorg_jpablo_graphexplorer_viewer_backends_threejs_MeshBasicMaterial$().Ay(9081504, false, 1.0, true, 0, true));
  this.ay3 = new $i_three.MeshBasicMaterial($m_Lorg_jpablo_graphexplorer_viewer_backends_threejs_MeshBasicMaterial$().Ay(12107980, false, 1.0, true, 0, true));
  this.ay2 = new $i_three.MeshBasicMaterial($m_Lorg_jpablo_graphexplorer_viewer_backends_threejs_MeshBasicMaterial$().Ay(5857385, false, 1.0, true, 0, true));
  this.a9p = 2.2;
  this.a0l = 0.055;
  this.ay4 = new $i_three.MeshBasicMaterial($m_Lorg_jpablo_graphexplorer_viewer_backends_threejs_MeshBasicMaterial$().Ay(0, false, 1.0, true, 0, false));
  this.LQ = ($m_sci_Vector$(), $m_sci_Vector0$());
  this.a9C = new $i_three.MeshBasicMaterial($m_Lorg_jpablo_graphexplorer_viewer_backends_threejs_MeshBasicMaterial$().Ay(9081504, true, 0.1, false, 0, true));
  this.ti = ($m_sci_Vector$(), $m_sci_Vector0$());
  this.axZ = new $i_three.SphereGeometry(1.0, 8, 6);
  this.x9 = ($m_sci_Vector$(), $m_sci_Vector0$());
  this.ay0 = new $i_three.PlaneGeometry(1.0, 1.0);
  this.a9q = $m_sci_Vector$().X($m_sr_ScalaRunTime$().a5i(new $ac_I(new Int32Array([4886745, 14251082, 4905359, 13218904, 10119897, 5290185]))));
  this.Gf = (0.7 * this.x6);
  this.SR = ($m_sci_Vector$(), $m_sci_Vector0$());
  this.LM = ($m_sci_Vector$(), $m_sci_Vector0$());
  this.Ge = 96.0;
  this.a0k = 3.8;
  this.SU = new $i_three.Scene();
  this.ST = new $i_three.PerspectiveCamera(46.0, 1.0, 0.1, 12.0);
  this.SU.fog = new $i_three.Fog(1382945.0, 3.2, 5.6);
  this.axR = new $c_T3(1.0, 0.45, 0.45);
  this.axQ = new $c_T3(0.45, 0.95, 0.52);
  this.axP = new $c_T3(0.48, 0.72, 1.0);
  this.Gd = 1.4;
  this.a9x = ($m_sci_Vector$(), $m_sci_Vector0$());
  this.a9y = $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__buildGizmo__T2(this);
  this.a9E = true;
  this.SV = false;
  this.a9A = $m_s_None$();
  this.a9m = 50.0;
  this.a9n = ($m_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$(), new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3(0.62, 0.4, 0.62));
  this.SQ = false;
  this.zi = false;
  this.LR = $m_s_None$();
  this.a9F = $m_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$().zv;
  this.a9o = 0.3;
  this.axS = 5.0;
  this.LO = $m_s_None$();
  this.a9w = $m_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$().zv;
  this.a9v = $m_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$().zv;
  this.a9t = 0.0;
  this.a9u = 0.0;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D.prototype = $p;
$p.b8F = (function(knobId, value) {
  $f_Lcom_raquo_airstream_state_Var__update__F1__V(this.LN, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6) => _$6.bN(knobId, value))));
  this.vi = this.LK.AK(this.LN.P().aq().d());
  this.dv = this.vi.PO(this.dv);
  $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__writePositions__V(this);
  $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__writeEdgeHighlight__V(this);
});
$p.b8D = (function(g) {
  this.a9A = new $c_s_Some(g);
  var this$2 = g.dQ;
  var this$3 = new $c_sc_MapOps$$anon$2(this$2);
  var nodeIds = $m_sci_Vector$().X(this$3);
  this.tg = g.fX.e6().L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((a) => new $c_T2(a.bX, a.c0)))).d2();
  this.SR = $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__visibleClusters__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__sci_Vector__sci_Vector(this, g, nodeIds);
  this.dv = this.vi.Jr(this.dv, new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayoutGraph(nodeIds, this.tg, this.SR, $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__hintsFor__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__s_Option(this, g)));
  var $x_1 = $m_sci_Map$();
  var this$6 = g.dQ;
  $m_sci_VectorMap$();
  var b = new $c_sci_VectorMapBuilder();
  var it = new $c_sci_VectorMap$$anon$1(this$6);
  while (it.p()) {
    var x0 = it.dC();
    var id = x0.g();
    b.pm(id, $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__displayLabel__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Lorg_jpablo_graphexplorer_viewer_models_ViewerNode__sci_Vector(this, g, id, x0.h()));
  }
  var labels = $x_1.ao(b.rb());
  matchResult4: {
    var \u03b41$___1;
    var \u03b41$___2;
    var x5 = this.qk.ju(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
      var id$1 = x$1$2.g();
      var ns = x$1$2.h();
      return labels.r(id$1).E(ns.ql);
    })));
    if ((x5 !== null)) {
      var \u03b41$___1 = x5.g();
      var \u03b41$___2 = x5.h();
      break matchResult4;
    }
    throw new $c_s_MatchError(x5);
  }
  var keep$2 = \u03b41$___1;
  \u03b41$___2.e6().F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((ns$1) => {
    $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__disposeSprite__Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D$NodeSprite__V(this, ns$1);
  })));
  var f = ((x$1$3, x$2) => {
    var x8 = new $c_T2(x$1$3, x$2);
    var x10 = x8.be;
    var acc = x8.bi;
    if ((x10 !== null)) {
      var id$2 = x10.g();
      var label = x10.h();
      return (acc.E(id$2) ? acc : acc.bN(id$2, $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__createSprite__Lorg_jpablo_graphexplorer_viewer_models_NodeId__sci_Vector__Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D$NodeSprite(this, id$2, label)));
    }
    throw new $c_s_MatchError(x8);
  });
  if ($is_sc_IndexedSeq(labels)) {
    var at = 0;
    var end = labels.C();
    var acc$1 = keep$2;
    var $x_2;
    while (true) {
      if ((at !== end)) {
        var temp$at = ((1 + at) | 0);
        var x0$1 = acc$1;
        var x1 = labels.l(at);
        var temp$acc = f(x0$1, x1);
        at = temp$at;
        acc$1 = temp$acc;
        continue;
      }
      var $x_2 = acc$1;
      break;
    }
  } else {
    var result = keep$2;
    var it$1 = labels.o();
    while (it$1.p()) {
      var x0$2 = result;
      var x1$1 = it$1.q();
      result = f(x0$2, x1$1);
    }
    var $x_2 = result;
  }
  this.qk = $x_2;
  $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__resizeSprites__V(this);
  $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__rebuildLines__V(this);
  $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__rebuildHulls__V(this);
  $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__applySelection__V(this);
  $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__writePositions__V(this);
  if ((nodeIds.C() !== this.a9z)) {
    this.a9z = nodeIds.C();
    $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__fitCamera__D__V(this, 1.0);
    this.zi = true;
  }
});
$p.b8L = (function(sel) {
  this.x8 = $m_sci_Set$().af(sel.ct(new $c_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D$$anon$2()));
  $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__applySelection__V(this);
});
$p.b7D = (function() {
  this.qk = this.qk.kP(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var id = x$1.g();
    var ns = x$1.h();
    matchResult10: {
      var texture$2;
      var $x_2 = ns.ql;
      var this$2 = $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__dictatedSize__Lorg_jpablo_graphexplorer_viewer_models_NodeId__s_Option(this, id);
      if (this$2.c()) {
        var $x_1 = $m_s_None$();
      } else {
        var x0 = this$2.d();
        var $x_1 = new $c_s_Some(((+x0.g()) / (+x0.h())));
      }
      var x25 = $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__paintLabel__sci_Vector__s_Option__T2(this, $x_2, $x_1);
      if ((x25 !== null)) {
        var texture$2 = x25.g();
        break matchResult10;
      }
      throw new $c_s_MatchError(x25);
    }
    ns.zk.i(texture$2);
    ns.Cf.dispose();
    return new $c_T2(id, ns.aN1(ns.p3, texture$2, ns.ql, ns.Cd, ns.zk, ns.Ce, ns.Cc));
  })));
});
$p.b8G = (function(on) {
  if ((on !== this.SV)) {
    this.SV = on;
    $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__resizeSprites__V(this);
  }
});
$p.b8y = (function(algoId) {
  var this$1 = $m_Lorg_jpablo_graphexplorer_viewer_layout3d_Layout3D$().aMC(algoId);
  var next = (this$1.c() ? $m_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$() : this$1.d());
  if ((next.u6() !== this.LK.u6())) {
    this.LK = next;
    $f_Lcom_raquo_airstream_state_Var__set__O__V(this.LN, $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__defaultKnobValues__Lorg_jpablo_graphexplorer_viewer_layout3d_Layout3D__sci_Map(this, next));
    this.vi = next;
    var \u03b42$ = this.dv.he;
    var this$2 = this.a9A;
    var hints$1 = (this$2.c() ? $m_s_None$() : $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__hintsFor__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__s_Option(this, this$2.d()));
    var newGraph = new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayoutGraph(\u03b42$.l1, \u03b42$.hv, \u03b42$.MG, hints$1);
    this.dv = this.vi.Jr(this.dv, newGraph);
    $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__resizeSprites__V(this);
    $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__rebuildLines__V(this);
    $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__applySelection__V(this);
  }
});
$p.b17 = (function() {
  this.qj = ($m_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$(), new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3(0.0, 1.0, 0.0));
  $m_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$();
  var camP = new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3((+this.eq.position.x), (+this.eq.position.y), (+this.eq.position.z));
  var y$1 = camP.fN(this.iB).js();
  var dist = (+Math.max(1.0E-9, y$1));
  this.eq.position.set(this.iB.cq, this.iB.cr, (this.iB.cg + dist));
  $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__applyCameraPose__V(this);
  $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__fitCamera__D__V(this, 1.0);
});
$p.b9l = (function(container) {
  this.e9.setPixelRatio((+window.devicePixelRatio));
  this.e9.domElement.style.display = "block";
  container.appendChild(this.e9.domElement);
  $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__attachWheelNavigation__V(this);
  $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__resize__Lorg_scalajs_dom_Element__V(this, container);
  var observer = new ResizeObserver(((_$32, _$33) => {
    $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__resize__Lorg_scalajs_dom_Element__V(this, container);
  }));
  observer.observe(container);
  this.a9B = new $c_s_Some(observer);
  $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__attachPointerHandlers__V(this);
  $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__setupXR__V(this);
  this.e9.setAnimationLoop(((arg1) => {
    $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__frame__D__V(this, (+arg1));
  }));
  if ((window.localStorage.getItem("gx3d-debug") !== null)) {
    window.__gx3d = $m_sjs_js_special_package$().eA($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("scene", this.x7), new $c_T2("camera", this.eq), new $c_T2("info", $m_sjs_js_Any$().ag5(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => (((((((((("algo=" + this.vi.u6()) + " done=") + this.dv.DU()) + " temp=") + this.dv.vq) + " iter=") + this.dv.mk) + " ") + (("pinned=" + $f_sc_IterableOnceOps__mkString__T__T__T__T(this.dv.lG, "", ",", "")) + " autoFit=")) + this.SQ))))), new $c_T2("posOf", $m_sjs_js_Any$().Pn(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((id) => {
      var this$8 = this.dv.fF.r(($m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$(), new $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId(id)));
      if (this$8.c()) {
        var this$9 = $m_s_None$();
      } else {
        var x0 = this$8.d();
        var this$9 = new $c_s_Some([x0.cq, x0.cr, x0.cg]);
      }
      return (this$9.c() ? [] : this$9.d());
    })))), new $c_T2("settle", $m_sjs_js_Any$().ag5(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      while ((!this.dv.DU())) {
        this.dv = this.vi.Jo(this.dv);
      }
      $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__writePositions__V(this);
      if ((this.SQ || this.zi)) {
        $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__fitCamera__D__V(this, 1.0);
      }
      this.zi = false;
      $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__updateFog__V(this);
      this.e9.render(this.x7, this.eq);
    }))))])));
  }
});
$p.bam = (function() {
  var x75 = this.SY;
  if ((x75 instanceof $c_s_Some)) {
    var session = x75.J;
    session.end();
    return (void 0);
  }
  if (($m_s_None$() === x75)) {
    var sessionInit = $m_sjs_js_special_package$().eA($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("optionalFeatures", ["local-floor", "bounded-floor", "hand-tracking", "layers"])])));
    $m_sjs_js_Thenable$Implicits$().aSP(navigator.xr.requestSession("immersive-vr", sessionInit)).oB(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((session$2) => {
      this.SY = new $c_s_Some(session$2);
      return this.e9.xr.setSession(session$2);
    })), $m_s_concurrent_ExecutionContext$().ek());
    return (void 0);
  }
  throw new $c_s_MatchError(x75);
});
$p.aZZ = (function() {
  this.e9.setAnimationLoop(null);
  var this$1 = this.a9B;
  if ((!this$1.c())) {
    var x0 = this$1.d();
    x0.disconnect();
  }
  var this$2 = this.SY;
  if ((!this$2.c())) {
    var x0$1 = this$2.d();
    x0$1.end();
  }
  this.qk.e6().F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((ns) => {
    $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__disposeSprite__Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D$NodeSprite__V(this, ns);
  })));
  this.qk = $m_sci_Map$EmptyMap$();
  this.LM.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var mesh = x$1.g();
    var material = x$1.h();
    mesh.geometry.dispose();
    material.dispose();
  })));
  this.LM = ($m_sci_Vector$(), $m_sci_Vector0$());
  this.a0m.dispose();
  this.a9s.dispose();
  this.a9y.g().dispose();
  this.a9y.h().dispose();
  this.a9x.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    x$1$2.g();
    var mat = x$1$2.h();
    mat.dispose();
  })));
  this.a0n.dispose();
  this.SX.dispose();
  this.a9C.dispose();
  this.e9.dispose();
  this.e9.domElement.remove();
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D, "org.jpablo.graphexplorer.viewer.components.scene3d.GraphScene3D", ({
  zo: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_scene3d_Scene3D$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_scene3d_Scene3D$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_scene3d_Scene3D$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_scene3d_Scene3D$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_scene3d_Scene3D$package$.prototype = $p;
$p.aWf = (function(state) {
  var scene = new $c_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D(state);
  return $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.gz().n("scene3d-container"), $m_Lcom_raquo_laminar_api_package$().b.y.s("relative h-full w-full overflow-hidden"), $f_Lcom_raquo_laminar_api_MountHooks__onMountUnmountCallback__F1__F1__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((ctx) => {
    scene.b9l(ctx.JW.en);
  })), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => {
    scene.aZZ();
  }))), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_api_Implicits$RichSource$().ft(state.a13, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((g) => {
    scene.b8D(g);
  })))), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_api_Implicits$RichSource$().ft(state.aH().ne, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => {
    scene.b8L(((v1 === null) ? null : v1.aS));
  })))), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_api_Implicits$RichSource$().ft(state.H6.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((algoId) => {
    scene.b8y(algoId);
  })))), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_api_Implicits$RichSource$().ft(state.TV.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1$2) => {
    var trackpad = (!(!v1$2));
    scene.a9E = trackpad;
  })))), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_api_Implicits$RichSource$().ft(state.TT.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1$3) => {
    scene.b8G((!(!v1$3)));
  })))), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_api_Implicits$RichSource$().ft(state.xq.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1$4) => {
    var on$1 = (!(!v1$4));
    scene.SQ = on$1;
  })))), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_api_Implicits$RichSource$().ft(state.a11.k5, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => {
    $p_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D__fitCamera__D__V(scene, 1.0);
  })))), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_api_Implicits$RichSource$().ft(state.abh.k5, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3) => {
    scene.b17();
  })))), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_api_Implicits$RichSource$().ft(new $c_Lcom_raquo_airstream_misc_StreamFromSignal(state.Pf().P(), true), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4) => {
    scene.b7D();
  })))), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_receivers_ChildOptionReceiver$()).gR($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), scene.a9G.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((av) => ((!(!av)) ? new $c_s_Some($m_Lorg_jpablo_graphexplorer_viewer_components_scene3d_Scene3D$package$().bbQ(scene)) : $m_s_None$()))), $m_s_None$())), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_receivers_ChildOptionReceiver$()).gR($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), state.H6.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((algoId$2) => {
    var this$14 = $m_Lorg_jpablo_graphexplorer_viewer_layout3d_Layout3D$().aMC(algoId$2);
    var algo = (this$14.c() ? $m_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$() : this$14.d());
    return ((!algo.E8().c()) ? new $c_s_Some($m_Lorg_jpablo_graphexplorer_viewer_components_scene3d_Scene3D$package$().b3W(scene, algo)) : $m_s_None$());
  })), $m_s_None$()))])));
});
$p.b3W = (function(scene, algo) {
  var $x_14 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_13 = $m_sr_ScalaRunTime$();
  var $x_12 = $m_Lcom_raquo_laminar_api_package$().b.y.s("floating-toolbar top-2 right-2 flex-col items-stretch gap-1.5 w-60 px-3 py-2");
  var this$17 = $m_Lcom_raquo_laminar_api_package$().b;
  var this$16 = algo.E8();
  var f = ((knob) => {
    var $x_10 = $m_Lcom_raquo_laminar_api_package$().b.a8();
    var $x_9 = $m_sr_ScalaRunTime$();
    var $x_8 = $m_Lcom_raquo_laminar_api_package$().b.y.s("flex items-center gap-2");
    var $x_7 = $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("text-xs w-20 shrink-0 opacity-70"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, knob.Mz, $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])));
    var $x_6 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$();
    var $x_5 = $m_sr_ScalaRunTime$();
    var $x_4 = $m_Lcom_raquo_laminar_api_package$().b.y.s("flex-1");
    var $x_3 = $m_Lcom_raquo_laminar_api_package$().b.ah3().n(("" + knob.MB));
    var $x_2 = $m_Lcom_raquo_laminar_api_package$().b.ah0().n(("" + knob.MA));
    var $x_1 = $m_Lcom_raquo_laminar_api_package$().b.ai8().n(("" + knob.MC));
    $m_Lcom_raquo_laminar_api_package$();
    var updater = $m_Lcom_raquo_laminar_api_package$().b.jx().bj($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), scene.LN.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((knob$2) => ((_$5) => $dp_toString__T(_$5.ay(knob$2.zu, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => knob$2.Ct))))))(knob)), $m_s_None$()));
    var listener = new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.oE(), false, false)).nC(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((knob$3) => ((v) => {
      scene.b8F(knob$3.zu, $m_jl_Double$().bd(v));
    }))(knob)));
    return $x_10.w($x_9.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_8, $x_7, $x_6.aWc($x_5.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_4, $x_3, $x_2, $x_1, $m_Lcom_raquo_laminar_inputs_InputController$().qU(listener, updater)]))), $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("text-xs w-9 text-right tabular-nums opacity-70"), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_inserters_ChildTextInserter$().DG($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), scene.LN.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((knob$4) => ((vs) => $m_sc_StringOps$().u0("%.2f", $m_sr_ScalaRunTime$().hP(new $ac_O([vs.ay(knob$4.zu, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => knob$4.Ct)))])))))(knob)), $m_s_None$()), $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7))])))])));
  });
  if ((this$16 === $m_sci_Nil$())) {
    var $x_11 = $m_sci_Nil$();
  } else {
    var x0 = this$16.t();
    var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
    var t = h;
    var rest = this$16.v();
    while ((rest !== $m_sci_Nil$())) {
      var x0$1 = rest.t();
      var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
      t.U = nx;
      t = nx;
      rest = rest.v();
    }
    var $x_11 = h;
  }
  return $x_14.w($x_13.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_12, $f_Lcom_raquo_laminar_api_Implicits__nodeSeqToModifier__O__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier(this$17, $x_11, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())])));
});
$p.bbQ = (function(scene) {
  var $x_10 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_9 = $m_sr_ScalaRunTime$();
  var $x_8 = $m_Lcom_raquo_laminar_api_package$().b.y.s("floating-toolbar bottom-2 left-2");
  var $x_7 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$();
  var $x_6 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$();
  var $x_5 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Button$package$();
  var $x_4 = $m_sr_ScalaRunTime$();
  var $x_3 = $m_Lcom_raquo_laminar_api_package$().b.y.s("gap-1.5");
  var $x_2 = $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("bi bi-badge-vr")])));
  $m_Lcom_raquo_laminar_api_package$();
  var $x_1 = $m_Lcom_raquo_laminar_inserters_ChildTextInserter$().DG($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), scene.a0o.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((p) => ((!(!p)) ? "Exit VR" : "Enter VR"))), $m_s_None$()), $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7);
  var this$4 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false));
  var onNext = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    scene.bam();
  }));
  $m_Lcom_raquo_laminar_api_package$features$().cz();
  return $x_10.w($x_9.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_8, $x_7.u4($x_6.iZ($x_5.hH($x_4.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_3, $x_2, $x_1, new $c_Lcom_raquo_laminar_modifiers_EventListener(this$4, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => {
    onNext.a3();
  })))])))))])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_scene3d_Scene3D$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_scene3d_Scene3D$package$, "org.jpablo.graphexplorer.viewer.components.scene3d.Scene3D$package$", ({
  zs: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_scene3d_Scene3D$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_scene3d_Scene3D$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_scene3d_Scene3D$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_scene3d_Scene3D$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_scene3d_Scene3D$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_scene3d_Scene3D$package$;
}
function $f_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement__$init$__V($thiz) {
  $thiz.ahj($thiz.dD().id);
  $thiz.ahi($m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().a0x);
}
function $f_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement__nodeId__s_Option($thiz) {
  var x1 = $thiz.lj();
  if ((x1 instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId)) {
    return new $c_s_Some(x1);
  }
  return $m_s_None$();
}
function $f_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement__arrowId__s_Option($thiz) {
  var x3 = $thiz.lj();
  if ((x3 instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowId)) {
    return new $c_s_Some(x3);
  }
  return $m_s_None$();
}
function $f_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement__unselect__V($thiz) {
  $thiz.dD().classList.remove($thiz.a4F());
  $m_Lorg_jpablo_graphexplorer_viewer_domUtils_QuerySelector$package$().m3($thiz.dD(), ((("rect." + $thiz.PR()) + ", rect.") + $m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().a0w)).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => {
    _$1.remove();
  })));
}
function $f_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement__select__V($thiz) {
  $thiz.dD().classList.add($thiz.a4F());
  if (($thiz.dD().querySelector(("rect." + $thiz.PR())) === null)) {
    var bbox = $p_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement__ownGeometryBBox__Lorg_scalajs_dom_SVGRect($thiz);
    var newRects = new $c_sci_$colon$colon($p_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement__SelectedRect__Lorg_scalajs_dom_SVGRect__T__Lcom_raquo_laminar_nodes_ReactiveSvgElement($thiz, bbox, $m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().a0w), new $c_sci_$colon$colon($p_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement__SelectedRect__Lorg_scalajs_dom_SVGRect__T__Lcom_raquo_laminar_nodes_ReactiveSvgElement($thiz, bbox, $thiz.PR()), $m_sci_Nil$()));
    var labelGroup = $thiz.dD().querySelector("g.label");
    var these = newRects;
    while ((!these.c())) {
      var x0 = these.t();
      if ((labelGroup !== null)) {
        $thiz.dD().insertBefore(x0.e8, labelGroup);
      } else {
        $thiz.dD().appendChild(x0.e8);
      }
      these = these.v();
    }
    $m_Lorg_jpablo_graphexplorer_viewer_domUtils_QuerySelector$package$().m3($thiz.dD(), ("." + $m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().T3)).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((d) => $thiz.dD().appendChild(d))));
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement__ownGeometryBBox__Lorg_scalajs_dom_SVGRect($thiz) {
  var decorations = $m_Lorg_jpablo_graphexplorer_viewer_domUtils_QuerySelector$package$().m3($thiz.dD(), ("." + $m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().T3));
  decorations.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => {
    _$2.setAttribute("display", "none");
  })));
  var bbox = $thiz.dD().getBBox();
  decorations.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3) => {
    _$3.removeAttribute("display");
  })));
  return bbox;
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement__SelectedRect__Lorg_scalajs_dom_SVGRect__T__Lcom_raquo_laminar_nodes_ReactiveSvgElement($thiz, bbox, cls) {
  return $m_Lcom_raquo_laminar_api_package$().b.j().a4s().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s(cls), $m_Lcom_raquo_laminar_api_package$().b.j().ahu().n("none"), $m_Lcom_raquo_laminar_api_package$().b.j().Eq().n(("" + (+bbox.x))), $m_Lcom_raquo_laminar_api_package$().b.j().Er().n(("" + (+bbox.y))), $m_Lcom_raquo_laminar_api_package$().b.j().bh().n(("" + (+bbox.width))), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(("" + (+bbox.height))), $f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, $m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().aXU(bbox), $m_s_$less$colon$less$().b1, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())])));
}
var $d_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement = new $TypeData().i(1, "org.jpablo.graphexplorer.viewer.components.selection.SelectableElement", ({
  cz: 1
}));
function $f_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElementStrategy__allSelector__T($thiz) {
  return (((($thiz.Jc() + ", ") + $thiz.a3a()) + ", ") + $thiz.Ws());
}
function $f_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElementStrategy__isNode__Lorg_scalajs_dom_Element__Z($thiz, e) {
  return (!(!e.matches($thiz.Jc())));
}
function $f_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElementStrategy__isEdge__Lorg_scalajs_dom_Element__Z($thiz, e) {
  return (!(!e.matches($thiz.a3a())));
}
function $f_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElementStrategy__isCluster__Lorg_scalajs_dom_Element__Z($thiz, e) {
  return (!(!e.matches($thiz.Ws())));
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowEndpointControl$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowEndpointControl$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowEndpointControl$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowEndpointControl$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowEndpointControl$package$.prototype = $p;
$p.aVB = (function(edge, endpoint, clientSize, endpointElement, edgePositions, svgMods) {
  var x$2 = $s_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint$__source__Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint();
  var isSource = ((endpoint === null) ? (x$2 === null) : (endpoint === x$2));
  matchResult1: {
    var currentClientSize;
    var x$3 = $s_Lorg_jpablo_graphexplorer_viewer_models_ClientSize$__Small__Lorg_jpablo_graphexplorer_viewer_models_ClientSize();
    if (((x$3 === null) ? (clientSize === null) : (x$3 === clientSize))) {
      var currentClientSize = 24.0;
      break matchResult1;
    }
    var x$5 = $s_Lorg_jpablo_graphexplorer_viewer_models_ClientSize$__Normal__Lorg_jpablo_graphexplorer_viewer_models_ClientSize();
    if (((x$5 === null) ? (clientSize === null) : (x$5 === clientSize))) {
      var currentClientSize = 12.0;
      break matchResult1;
    }
    throw new $c_s_MatchError(clientSize);
  }
  var this$1 = $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$().Yg(edge.zl);
  var userPerPx = (+(this$1.c() ? 1.0 : this$1.d()));
  matchResult2: {
    var \u03b41$___1;
    var \u03b41$___2;
    var this$2 = edgePositions.r(edge.a3c().l3);
    if (this$2.c()) {
      var this$4 = $m_s_None$();
    } else {
      var x0 = this$2.d();
      var point = (isSource ? x0.Ls : x0.FT);
      var this$4 = new $c_s_Some(new $c_T2(point.BS, (-point.BT)));
    }
    var x2 = (this$4.c() ? new $c_T2(0.0, 0.0) : this$4.d());
    if ((x2 !== null)) {
      var \u03b41$___1 = (+x2.g());
      var \u03b41$___2 = (+x2.h());
      break matchResult2;
    }
    throw new $c_s_MatchError(x2);
  }
  var trX$2 = (+\u03b41$___1);
  var trY$2 = (+\u03b41$___2);
  var anchored = new $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$Anchored(trX$2, trY$2, 0.0, 0.0, currentClientSize, 8.0);
  return $m_Lcom_raquo_laminar_api_package$().b.j().dm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s(("edge-endpoint-disk edge-endpoint-disk-" + (isSource ? "source" : "target"))), $m_Lcom_raquo_laminar_api_package$().b.j().ahu().n("all"), $m_Lcom_raquo_laminar_api_package$().b.j().DP().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().Ee().n("4")]))), $f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$().aQm(anchored, userPerPx), $m_s_$less$colon$less$().b1, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$()), $f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, svgMods, $m_s_$less$colon$less$().b1, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowEndpointControl$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowEndpointControl$package$, "org.jpablo.graphexplorer.viewer.components.svgCanvas.ArrowEndpointControl$package$", ({
  zx: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowEndpointControl$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowEndpointControl$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowEndpointControl$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowEndpointControl$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowEndpointControl$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowEndpointControl$package$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowFromSourceToPointer$package$__toRoot$1__Lorg_scalajs_dom_SVGMatrix__Lorg_scalajs_dom_SVGMatrix__D__D__Lorg_jpablo_graphexplorer_viewer_domUtils_DOMPoint($thiz, elemMatrix$1, inv$1, x, y) {
  return new DOMPoint(x, y).matrixTransform(elemMatrix$1).matrixTransform(inv$1);
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowFromSourceToPointer$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowFromSourceToPointer$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowFromSourceToPointer$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowFromSourceToPointer$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowFromSourceToPointer$package$.prototype = $p;
$p.aVC = (function(action, rootGroup) {
  var point = $m_Lorg_jpablo_graphexplorer_viewer_components_SvgElementOps$package$().Q5(action.ts.jK, rootGroup.getScreenCTM());
  var localBBox = action.zJ.dD().getBBox();
  var elemCtm = $m_s_Option$().as(action.zJ.dD().getScreenCTM());
  var rootCtm = $m_s_Option$().as(rootGroup.getScreenCTM());
  matchResult1: {
    var \u03b41$___1;
    var \u03b41$___2;
    var \u03b41$___3;
    var \u03b41$___4;
    if ((rootCtm instanceof $c_s_Some)) {
      var rootMatrix = rootCtm.J;
      if ((elemCtm instanceof $c_s_Some)) {
        var elemMatrix = elemCtm.J;
        var inv = rootMatrix.inverse();
        var p1 = $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowFromSourceToPointer$package$__toRoot$1__Lorg_scalajs_dom_SVGMatrix__Lorg_scalajs_dom_SVGMatrix__D__D__Lorg_jpablo_graphexplorer_viewer_domUtils_DOMPoint(this, elemMatrix, inv, (+localBBox.x), (+localBBox.y));
        var p2 = $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowFromSourceToPointer$package$__toRoot$1__Lorg_scalajs_dom_SVGMatrix__Lorg_scalajs_dom_SVGMatrix__D__D__Lorg_jpablo_graphexplorer_viewer_domUtils_DOMPoint(this, elemMatrix, inv, ((+localBBox.x) + (+localBBox.width)), (+localBBox.y));
        var p3 = $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowFromSourceToPointer$package$__toRoot$1__Lorg_scalajs_dom_SVGMatrix__Lorg_scalajs_dom_SVGMatrix__D__D__Lorg_jpablo_graphexplorer_viewer_domUtils_DOMPoint(this, elemMatrix, inv, (+localBBox.x), ((+localBBox.y) + (+localBBox.height)));
        var p4 = $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowFromSourceToPointer$package$__toRoot$1__Lorg_scalajs_dom_SVGMatrix__Lorg_scalajs_dom_SVGMatrix__D__D__Lorg_jpablo_graphexplorer_viewer_domUtils_DOMPoint(this, elemMatrix, inv, ((+localBBox.x) + (+localBBox.width)), ((+localBBox.y) + (+localBBox.height)));
        var minX = (+$f_sc_IterableOnceOps__min__s_math_Ordering__O(new $c_sci_$colon$colon((+p1.x), new $c_sci_$colon$colon((+p2.x), new $c_sci_$colon$colon((+p3.x), new $c_sci_$colon$colon((+p4.x), $m_sci_Nil$())))), $m_s_math_Ordering$DeprecatedDoubleOrdering$()));
        var minY = (+$f_sc_IterableOnceOps__min__s_math_Ordering__O(new $c_sci_$colon$colon((+p1.y), new $c_sci_$colon$colon((+p2.y), new $c_sci_$colon$colon((+p3.y), new $c_sci_$colon$colon((+p4.y), $m_sci_Nil$())))), $m_s_math_Ordering$DeprecatedDoubleOrdering$()));
        var \u03b41$___1 = minX;
        var \u03b41$___2 = minY;
        var \u03b41$___3 = ((+$f_sc_IterableOnceOps__max__s_math_Ordering__O(new $c_sci_$colon$colon((+p1.x), new $c_sci_$colon$colon((+p2.x), new $c_sci_$colon$colon((+p3.x), new $c_sci_$colon$colon((+p4.x), $m_sci_Nil$())))), $m_s_math_Ordering$DeprecatedDoubleOrdering$())) - minX);
        var \u03b41$___4 = ((+$f_sc_IterableOnceOps__max__s_math_Ordering__O(new $c_sci_$colon$colon((+p1.y), new $c_sci_$colon$colon((+p2.y), new $c_sci_$colon$colon((+p3.y), new $c_sci_$colon$colon((+p4.y), $m_sci_Nil$())))), $m_s_math_Ordering$DeprecatedDoubleOrdering$())) - minY);
        break matchResult1;
      }
    }
    var \u03b41$___1 = (+localBBox.x);
    var \u03b41$___2 = (+localBBox.y);
    var \u03b41$___3 = (+localBBox.width);
    var \u03b41$___4 = (+localBBox.height);
  }
  var bboxX = (+\u03b41$___1);
  var bboxY = (+\u03b41$___2);
  var bboxWidth = (+\u03b41$___3);
  var bboxHeight = (+\u03b41$___4);
  var centerX = (bboxX + (0.5 * bboxWidth));
  var centerY = (bboxY + (0.5 * bboxHeight));
  var isInside = ((((point.gI >= bboxX) && (point.gI <= (bboxX + bboxWidth))) && (point.gJ >= bboxY)) && (point.gJ <= (bboxY + bboxHeight)));
  if (isInside) {
    var \u03b42$___1 = centerX;
    var \u03b42$___2 = centerY;
  } else {
    var right = (bboxX + bboxWidth);
    var bottom = (bboxY + bboxHeight);
    var dx = (point.gI - centerX);
    var dy = (point.gJ - centerY);
    var tLeft = ((dx !== 0.0) ? ((bboxX - centerX) / dx) : Infinity);
    var tRight = ((dx !== 0.0) ? ((right - centerX) / dx) : Infinity);
    var tTop = ((dy !== 0.0) ? ((bboxY - centerY) / dy) : Infinity);
    var tBottom = ((dy !== 0.0) ? ((bottom - centerY) / dy) : Infinity);
    var this$13 = new $c_sci_$colon$colon(((dx > 0.0) ? new $c_T3(tRight, right, (centerY + (dy * tRight))) : null), new $c_sci_$colon$colon(((dx < 0.0) ? new $c_T3(tLeft, bboxX, (centerY + (dy * tLeft))) : null), new $c_sci_$colon$colon(((dy > 0.0) ? new $c_T3(tBottom, (centerX + (dx * tBottom)), bottom) : null), new $c_sci_$colon$colon(((dy < 0.0) ? new $c_T3(tTop, (centerX + (dx * tTop)), bboxY) : null), $m_sci_Nil$()))));
    var f = ((_$1) => (_$1 !== null));
    var l = this$13;
    block: {
      var result;
      while (true) {
        if (l.c()) {
          var result = $m_sci_Nil$();
          break;
        } else {
          var h = l.t();
          var t = l.v();
          if ((!(!(!f(h))))) {
            l = t;
            continue;
          }
          var start = l;
          var remaining = t;
          while (true) {
            if (remaining.c()) {
              var result = start;
              break block;
            } else {
              var x = remaining.t();
              if ((!(!f(x)))) {
                remaining = remaining.v();
                continue;
              }
              var firstMiss = remaining;
              var newHead = new $c_sci_$colon$colon(start.t(), $m_sci_Nil$());
              var toProcess = start.v();
              var currentLast = newHead;
              while ((toProcess !== firstMiss)) {
                var newElem = new $c_sci_$colon$colon(toProcess.t(), $m_sci_Nil$());
                currentLast.U = newElem;
                currentLast = newElem;
                toProcess = toProcess.v();
              }
              var next = firstMiss.v();
              var nextToCopy = next;
              while ((!next.c())) {
                var head = next.t();
                if ((!(!f(head)))) {
                  next = next.v();
                } else {
                  while ((nextToCopy !== next)) {
                    var newElem$2 = new $c_sci_$colon$colon(nextToCopy.t(), $m_sci_Nil$());
                    currentLast.U = newElem$2;
                    currentLast = newElem$2;
                    nextToCopy = nextToCopy.v();
                  }
                  nextToCopy = next.v();
                  next = next.v();
                }
              }
              if ((!nextToCopy.c())) {
                currentLast.U = nextToCopy;
              }
              var result = newHead;
              break block;
            }
          }
        }
      }
    }
    matchResult2: {
      var \u03b43$___1;
      var \u03b43$___2;
      var x8 = $f_sc_IterableOnceOps__minBy__F1__s_math_Ordering__O(result, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => (+_$2.bH))), $m_s_math_Ordering$DeprecatedDoubleOrdering$());
      if ((x8 !== null)) {
        var \u03b43$___1 = (+x8.bU);
        var \u03b43$___2 = (+x8.c3);
        break matchResult2;
      }
      throw new $c_s_MatchError(x8);
    }
    var ix$2 = (+\u03b43$___1);
    var iy$2 = (+\u03b43$___2);
    var that = (+Math.min(right, ix$2));
    var $x_1 = Math.max(bboxX, that);
    var that$1 = (+Math.min(bottom, iy$2));
    var \u03b42$___1 = (+$x_1);
    var \u03b42$___2 = (+Math.max(bboxY, that$1));
  }
  var x1$2 = (+\u03b42$___1);
  var y1 = (+\u03b42$___2);
  matchResult3: {
    var markerAttr;
    var x12 = action.Hb;
    var x$1 = $s_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$__forward__Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection();
    if (((x$1 === null) ? (x12 === null) : (x$1 === x12))) {
      var markerAttr = new $c_sci_$colon$colon($m_Lcom_raquo_laminar_api_package$().b.j().aQa().n("url(#arrowtail)"), new $c_sci_$colon$colon($m_Lcom_raquo_laminar_api_package$().b.j().aQ8().n("url(#arrowhead)"), $m_sci_Nil$()));
      break matchResult3;
    }
    var x$3 = $s_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$__backward__Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection();
    if (((x$3 === null) ? (x12 === null) : (x$3 === x12))) {
      var markerAttr = new $c_sci_$colon$colon($m_Lcom_raquo_laminar_api_package$().b.j().aQa().n("url(#arrowhead)"), new $c_sci_$colon$colon($m_Lcom_raquo_laminar_api_package$().b.j().aQ8().n("url(#arrowtail)"), $m_sci_Nil$()));
      break matchResult3;
    }
    throw new $c_s_MatchError(x12);
  }
  var scale = $m_Lorg_jpablo_graphexplorer_viewer_domUtils_SvgUtils$().aMD(rootGroup, 1.0, 3.0);
  return $m_Lcom_raquo_laminar_api_package$().b.j().dm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().Pt().n("dragging-arrow-group"), $m_Lcom_raquo_laminar_api_package$().b.j().aNm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowMarkers$package$().aMn("arrowhead"), $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowMarkers$package$().aMp("arrowtail")]))), $m_Lcom_raquo_laminar_api_package$().b.j().lp().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().Pt().n("dragging-arrow-line"), $m_Lcom_raquo_laminar_api_package$().b.j().lt().n(("" + x1$2)), $m_Lcom_raquo_laminar_api_package$().b.j().lv().n(("" + y1)), $m_Lcom_raquo_laminar_api_package$().b.j().lu().n(("" + point.gI)), $m_Lcom_raquo_laminar_api_package$().b.j().lw().n(("" + point.gJ)), $f_Lcom_raquo_laminar_api_Implicits__seqToSetter__O__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Setter($m_Lcom_raquo_laminar_api_package$().b, markerAttr, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$()), $m_Lcom_raquo_laminar_api_package$().b.j().AH().n(("" + scale))])))])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowFromSourceToPointer$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowFromSourceToPointer$package$, "org.jpablo.graphexplorer.viewer.components.svgCanvas.ArrowFromSourceToPointer$package$", ({
  zy: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowFromSourceToPointer$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowFromSourceToPointer$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowFromSourceToPointer$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowFromSourceToPointer$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowFromSourceToPointer$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowFromSourceToPointer$package$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowMarkers$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowMarkers$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowMarkers$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowMarkers$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowMarkers$package$.prototype = $p;
$p.aMn = (function(markerId) {
  return $m_Lcom_raquo_laminar_api_package$().b.j().aQ7().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().Pt().n(markerId), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("0 0 10 10"), $m_Lcom_raquo_laminar_api_package$().b.j().aRo().n("9"), $m_Lcom_raquo_laminar_api_package$().b.j().aRp().n("5"), $m_Lcom_raquo_laminar_api_package$().b.j().aQb().n("4"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ9().n("4"), $m_Lcom_raquo_laminar_api_package$().b.j().aQS().n("auto-start-reverse"), $m_Lcom_raquo_laminar_api_package$().b.j().pC().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().qV().n("M 0 0 L 10 5 L 0 10 L 2 5 z")])))])));
});
$p.aMp = (function(markerId) {
  return $m_Lcom_raquo_laminar_api_package$().b.j().aQ7().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().Pt().n(markerId), $m_Lcom_raquo_laminar_api_package$().b.j().bK().n("0 0 10 10"), $m_Lcom_raquo_laminar_api_package$().b.j().aRo().n("5"), $m_Lcom_raquo_laminar_api_package$().b.j().aRp().n("5"), $m_Lcom_raquo_laminar_api_package$().b.j().aQb().n("4"), $m_Lcom_raquo_laminar_api_package$().b.j().aQ9().n("4"), $m_Lcom_raquo_laminar_api_package$().b.j().aQS().n("auto"), $m_Lcom_raquo_laminar_api_package$().b.j().DP().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().y6().n("5"), $m_Lcom_raquo_laminar_api_package$().b.j().y7().n("5"), $m_Lcom_raquo_laminar_api_package$().b.j().Ee().n("3")])))])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowMarkers$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowMarkers$package$, "org.jpablo.graphexplorer.viewer.components.svgCanvas.ArrowMarkers$package$", ({
  zz: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowMarkers$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowMarkers$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowMarkers$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowMarkers$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowMarkers$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowMarkers$package$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowWithEndpoint$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowWithEndpoint$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowWithEndpoint$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowWithEndpoint$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowWithEndpoint$package$.prototype = $p;
$p.aVA = (function(action, rootGroup) {
  matchResult1: {
    var basePath;
    var x1 = action.zM.dD();
    if ((!(!(x1 instanceof SVGPathElement)))) {
      var basePath = x1;
      break matchResult1;
    }
    var basePath = action.zM.dD().querySelector($m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().a0y);
  }
  var clonedPath = basePath.cloneNode();
  clonedPath.removeAttribute("style");
  var pathData = clonedPath.getAttribute("d");
  var point = $m_Lorg_jpablo_graphexplorer_viewer_components_SvgElementOps$package$().Q5(action.tt.jK, rootGroup.getScreenCTM());
  var this$2 = new $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_SVGPathParser().PH(pathData);
  if ((this$2 instanceof $c_s_util_Right)) {
    var b = this$2.hm;
    var this$5 = new $c_s_util_Right((action.zL.aPr() ? $m_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$().b4y(b, new $c_T2(point.gI, point.gJ)) : $m_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$().b4z(b, new $c_T2(point.gI, point.gJ))));
  } else {
    var this$5 = this$2;
  }
  var this$6 = ((this$5 instanceof $c_s_util_Right) ? new $c_s_util_Right($m_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$().ba4(this$5.hm)) : this$5);
  var updatedPathData = ((this$6 instanceof $c_s_util_Right) ? this$6.hm : pathData);
  var scale = $m_Lorg_jpablo_graphexplorer_viewer_domUtils_SvgUtils$().aMD(rootGroup, 1.0, 3.0);
  clonedPath.setAttribute("id", "dragging-arrow-line");
  clonedPath.setAttribute("d", updatedPathData);
  clonedPath.setAttribute("stroke-width", ("" + scale));
  if (action.zL.b3p()) {
    clonedPath.setAttribute("marker-end", "url(#arrowhead)");
  } else {
    clonedPath.setAttribute("marker-start", "url(#arrowtail)");
  }
  return $m_Lcom_raquo_laminar_api_package$().b.j().dm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().Pt().n("dragging-arrow-group"), $m_Lcom_raquo_laminar_api_package$().b.j().aNm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowMarkers$package$().aMn("arrowhead"), $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowMarkers$package$().aMp("arrowtail")]))), $f_Lcom_raquo_laminar_api_Laminar__foreignSvgElement__Lcom_raquo_laminar_tags_SvgTag__Lorg_scalajs_dom_SVGElement__Lcom_raquo_laminar_nodes_ReactiveSvgElement($m_Lcom_raquo_laminar_api_package$().b, $m_Lcom_raquo_laminar_api_package$().b.j().pC(), clonedPath)])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowWithEndpoint$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowWithEndpoint$package$, "org.jpablo.graphexplorer.viewer.components.svgCanvas.ArrowWithEndpoint$package$", ({
  zA: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowWithEndpoint$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowWithEndpoint$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowWithEndpoint$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowWithEndpoint$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowWithEndpoint$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowWithEndpoint$package$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasContainer$package$() {
  this.ayl = null;
  $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasContainer$package$ = this;
  this.ayl = [$m_sjs_js_special_package$().eA($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("transform", "scale(1)")]))), $m_sjs_js_special_package$().eA($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("transform", "scale(1.15)")]))), $m_sjs_js_special_package$().eA($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("transform", "scale(1)")])))];
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasContainer$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasContainer$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasContainer$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasContainer$package$.prototype = $p;
$p.aVK = (function(state, commands) {
  $m_Lcom_raquo_laminar_api_package$();
  var viewOnlyNudge = new $c_Lcom_raquo_airstream_eventbus_EventBus();
  var $x_12 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_11 = $m_sr_ScalaRunTime$();
  var $x_10 = $m_Lcom_raquo_laminar_api_package$().b.gz().n("canvas-container");
  var $x_9 = $m_Lcom_raquo_laminar_api_package$().b.wj().n(0);
  $m_Lcom_raquo_laminar_api_package$();
  var $x_8 = $m_Lcom_raquo_laminar_api_Implicits$RichSource$().aVx(state.a11.k5, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps__resetView__V(state);
  })), $m_Lcom_raquo_laminar_api_package$features$().cz());
  $m_Lcom_raquo_laminar_api_package$();
  var $x_7 = $m_Lcom_raquo_laminar_receivers_ChildOptionReceiver$();
  var this$7 = $f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable(state.abt);
  var project$1 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var x$1$1 = (!(!x$1));
    if (x$1$1) {
      $m_Lcom_raquo_laminar_api_package$();
      return $m_Lcom_raquo_airstream_state_Val$().iT(new $c_s_Some($m_Lorg_jpablo_graphexplorer_viewer_components_scene3d_Scene3D$package$().aWf(state)));
    }
    if ((!x$1$1)) {
      return $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), state.afO(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((svg) => svg)), $m_s_None$());
    }
    throw new $c_s_MatchError(x$1$1);
  }));
  var $x_6 = $x_7.gR($m_Lcom_raquo_airstream_core_Observable$().AL.mK(this$7.fQ(project$1)));
  var $x_5 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_receivers_ChildOptionReceiver$()).gR($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), state.CF.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => ((_$1.c() || (!_$1.d().J6())) ? _$1 : $m_s_None$()))), $m_s_None$()), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => {
    if (_$2.c()) {
      return $m_s_None$();
    } else {
      var x0$1 = _$2.d();
      return new $c_s_Some($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasContainer$package$().aWt(x0$1, viewOnlyNudge.k5));
    }
  })), $m_s_None$()));
  var $x_4 = new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.Av(), false, false)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4) => {
    var this$13 = state.CF.P().aq().d();
    if (((!this$13.c()) && (!this$13.d().J6()))) {
      viewOnlyNudge.dn.bA((void 0));
    }
  })));
  var $x_3 = $m_Lcom_raquo_laminar_api_package$().b.a6q.aLi(state.CE);
  var $x_2 = new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.m1(), false, false)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((ev) => {
    commands.b2n(ev);
  })));
  var $x_1 = new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.b5f(), false, false)).jY(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((ev$2) => {
    var this$18 = $m_s_Option$().as(ev$2.clipboardData);
    if (this$18.c()) {
      var this$19 = $m_s_None$();
    } else {
      var x0$3 = this$18.d();
      var this$19 = new $c_s_Some(x0$3.getData("text/plain"));
    }
    $f_Lorg_jpablo_graphexplorer_viewer_state_ImportOps__pasteDiagramFromGesture__T__V(state, (this$19.c() ? "" : this$19.d()));
  })));
  var this$25 = new $c_Lcom_raquo_laminar_keys_LockedEventKey(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.b5i(), false, false)).jY(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6) => {
    $m_Lcom_raquo_airstream_core_EventStream$();
    return $m_Lcom_raquo_airstream_combine_generated_CombinableStream$().aTt(new $c_Lcom_raquo_airstream_misc_FilterStream(_$6, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$7) => (!$f_Lorg_jpablo_graphexplorer_viewer_state_UIState__view3DActiveNow__Z(state))))), state.afO(), new $c_Lapp_tulz_tuplez_Composition\uff3fPri0$$anon$1());
  })));
  var onNext$3 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    var e = x$1$2.g();
    var svgElemO = x$1$2.h();
    if ((!svgElemO.c())) {
      var x0$4 = svgElemO.d();
      var mainGroup = $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasRoot$().aQ5(x0$4.e8);
      $f_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps__handleWheel__Lorg_scalajs_dom_WheelEvent__Lorg_scalajs_dom_SVGRect__Lorg_scalajs_dom_SVGGElement__V(state, e, x0$4.e8.viewBox.baseVal, mainGroup);
    }
  }));
  return $x_12.w($x_11.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_10, $x_9, $x_8, $x_6, $x_5, $x_4, $x_3, $x_2, $x_1, this$25.Iv($m_Lcom_raquo_airstream_core_Observer$().wo(onNext$3, $m_s_PartialFunction$().gt, true))])));
});
$p.aWt = (function(notice, nudge) {
  return $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.gz().n("view-only-chip"), $m_Lcom_raquo_laminar_api_package$().b.y.s("floating-toolbar"), $m_Lorg_jpablo_graphexplorer_viewer_widgets_Tooltip$package$().Iz(notice.Cw, $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("tooltip-bottom"), $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("flex items-center gap-1.5"), $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("bi bi-eye")]))), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "View-only", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))]))), $f_Lcom_raquo_laminar_api_Laminar__inContext__F1__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((el) => {
    $m_Lcom_raquo_laminar_api_package$();
    return $m_Lcom_raquo_laminar_api_Implicits$RichSource$().ft(nudge, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((el$2) => ((_$8) => {
      if ((!(!(!window.matchMedia("(prefers-reduced-motion: reduce)").matches)))) {
        el$2.en.animate($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasContainer$package$().ayl, $m_sjs_js_special_package$().eA($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("duration", 350), new $c_T2("easing", "ease-out")]))));
      }
    }))(el)));
  })))])));
});
$p.aeY = (function(e) {
  return new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_utils_ClientPoint((+e.clientX), (+e.clientY)), (!(!e.shiftKey)));
});
$p.aPH = (function(e) {
  return ((e.button | 0) === 0);
});
$p.b43 = (function(e) {
  return ((e.buttons | 0) === 1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasContainer$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasContainer$package$, "org.jpablo.graphexplorer.viewer.components.svgCanvas.CanvasContainer$package$", ({
  zB: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasContainer$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasContainer$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasContainer$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasContainer$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasContainer$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasContainer$package$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasRoot$() {
  this.ayn = null;
  this.a0z = null;
  this.aym = null;
  $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasRoot$ = this;
  this.ayn = "http://www.w3.org/2000/svg";
  this.a0z = "gx-canvas-root";
  this.aym = $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_T.r().C)(["defs", "style", "title", "desc", "metadata", "script"])));
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasRoot$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasRoot$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasRoot$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasRoot$.prototype = $p;
$p.aQ5 = (function(svg) {
  var this$1 = $m_s_Option$().as(svg.querySelector((":scope > g." + this.a0z)));
  var pf = new $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasRoot$$anon$1();
  var this$3 = ((!this$1.c()) ? new $c_s_PartialFunction$Lifted(pf).as(this$1.d()) : $m_s_None$());
  if (this$3.c()) {
    var end = (svg.children.length | 0);
    var isEmpty = (end <= 0);
    var scala$collection$immutable$Range$$lastElement = ((end - 1) | 0);
    var \u03b41$ = svg.children;
    if (((end <= 0) && (!isEmpty))) {
      $m_sci_Range$().ug(0, end, 1, false);
    }
    var b = $m_sci_IndexedSeq$().b5();
    var it = new $c_sci_RangeIterator(0, 1, scala$collection$immutable$Range$$lastElement, isEmpty);
    while (it.g0) {
      var x0 = it.hp();
      b.Y(\u03b41$.item(x0));
    }
    var drawingRoots = b.aR().bw(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((element) => {
      var $x_1 = $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasRoot$().aym;
      var this$8 = element.tagName;
      return (!$x_1.E(this$8.toLowerCase()));
    }))).d2();
    if ((drawingRoots !== null)) {
      $m_sci_Vector$();
      var x = drawingRoots.C();
      if ((((x === 1) ? 0 : ((x < 1) ? (-1) : 1)) === 0)) {
        var x8 = drawingRoots.l(0);
        if ((!(!(x8 instanceof SVGGElement)))) {
          x8.classList.add($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasRoot$().a0z);
          return x8;
        }
      }
      var x$1 = drawingRoots.C();
      if ((((x$1 === 0) ? 0 : ((x$1 < 0) ? (-1) : 1)) === 0)) {
        throw $ct_jl_Exception__T__(new $c_jl_Exception(), "No drawing elements found in the SVG");
      }
    }
    var group$2 = svg.ownerDocument.createElementNS($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasRoot$().ayn, "g");
    group$2.classList.add($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasRoot$().a0z);
    svg.insertBefore(group$2, drawingRoots.t());
    drawingRoots.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((newChild) => group$2.appendChild(newChild))));
    return group$2;
  } else {
    return this$3.d();
  }
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasRoot$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasRoot$, "org.jpablo.graphexplorer.viewer.components.svgCanvas.CanvasRoot$", ({
  zC: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasRoot$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasRoot$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasRoot$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasRoot$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasRoot$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasRoot$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$__place__Lorg_scalajs_dom_Element__D__D__Lorg_scalajs_dom_Element__V($thiz, g, cx, cy, reference) {
  var anchored = new $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$Anchored(cx, cy, 0.0, 0.0, 18.0, 14.0);
  var $x_1 = $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$();
  var this$2 = $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$().Yg(reference);
  $x_1.b6G(g, anchored, (+(this$2.c() ? 1.0 : this$2.d())));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$__layerOf__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_Element($thiz, mainGroup) {
  var this$1 = $m_s_Option$().as(mainGroup.querySelector("g.gx-badge-layer"));
  if (this$1.c()) {
    var g = document.createElementNS("http://www.w3.org/2000/svg", "g");
    g.setAttribute("class", "gx-badge-layer");
    mainGroup.appendChild(g);
    return g;
  } else {
    return this$1.d();
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$__toLayer__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_Element__D__D__T2($thiz, el, layer, x, y) {
  var elemCtm = $m_s_Option$().as(el.getScreenCTM());
  var layerCtm = $m_s_Option$().as(layer.getScreenCTM());
  if ((elemCtm instanceof $c_s_Some)) {
    var e = elemCtm.J;
    if ((layerCtm instanceof $c_s_Some)) {
      var l = layerCtm.J;
      var p = new DOMPoint(x, y).matrixTransform(e).matrixTransform(l.inverse());
      return new $c_T2((+p.x), (+p.y));
    }
  }
  return new $c_T2(x, y);
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$__groupUnder__Lorg_scalajs_dom_Element__Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElementStrategy__s_Option($thiz, target, strategy) {
  var this$1 = $m_s_Option$().as(target.closest("g.gx-fold-badge"));
  if (this$1.c()) {
    var this$2 = $m_s_None$();
  } else {
    var x0 = this$1.d();
    var this$2 = new $c_s_Some(x0.getAttribute("data-gid"));
  }
  if (this$2.c()) {
    var this$3 = $m_s_Option$().as(target.closest(strategy.Ws()));
    if (this$3.c()) {
      var this$4 = $m_s_None$();
    } else {
      var x0$1 = this$3.d();
      var this$4 = new $c_s_Some(strategy.a3k(x0$1).dR);
    }
  } else {
    var this$4 = this$2;
  }
  return ((this$4.c() || (this$4.d() !== null)) ? this$4 : $m_s_None$());
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$__setHovered__Lorg_scalajs_dom_Element__s_Option__V($thiz, root, gid) {
  var next = (gid.c() ? "" : gid.d());
  if ((root.getAttribute("data-gx-fold-hovered") !== next)) {
    root.setAttribute("data-gx-fold-hovered", next);
    $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$__applyHovered__Lorg_scalajs_dom_Element__T__V($thiz, root, next);
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$__applyHovered__Lorg_scalajs_dom_Element__T__V($thiz, root, gid) {
  $m_Lorg_jpablo_graphexplorer_viewer_domUtils_QuerySelector$package$().m3(root, "g.gx-fold-badge").F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((b) => {
    if (((gid !== "") && (b.getAttribute("data-gid") === gid))) {
      b.classList.add("gx-badge-active");
    } else {
      b.classList.remove("gx-badge-active");
    }
  })));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$__countLabel__I__T($thiz, count) {
  return ((count > 99) ? "99+" : ("" + count));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$__badge__T__T__T__F0__Lorg_scalajs_dom_Element($thiz, label, cls, tooltip, onToggle) {
  var g = document.createElementNS("http://www.w3.org/2000/svg", "g");
  g.setAttribute("class", ((cls + " ") + $m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().T3));
  var title = document.createElementNS("http://www.w3.org/2000/svg", "title");
  title.textContent = tooltip;
  g.appendChild(title);
  var c = document.createElementNS("http://www.w3.org/2000/svg", "circle");
  c.setAttribute("cx", "0");
  c.setAttribute("cy", "0");
  c.setAttribute("r", "7");
  g.appendChild(c);
  var t = document.createElementNS("http://www.w3.org/2000/svg", "text");
  t.setAttribute("x", "0");
  t.setAttribute("y", "0");
  t.setAttribute("dy", "0.34em");
  t.textContent = label;
  g.appendChild(t);
  g.addEventListener("pointerdown", ((ev) => {
    ev.stopPropagation();
  }));
  g.addEventListener("mousedown", ((ev$2) => {
    ev$2.stopPropagation();
  }));
  g.addEventListener("click", ((ev$3) => {
    ev$3.stopPropagation();
    return onToggle.a3();
  }));
  return g;
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$__isGhost$1__Lorg_scalajs_dom_Element__Z($thiz, el) {
  return (el.closest(("." + $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$().a0A)) !== null);
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$__addBadge$1__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_Element__D__D__T__T__T__F0__Lorg_scalajs_dom_Element($thiz, layer$1, el, cx, cy, label, cls, tooltip, onToggle) {
  var b = $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$__badge__T__T__T__F0__Lorg_scalajs_dom_Element($thiz, label, cls, tooltip, onToggle);
  matchResult2: {
    var \u03b41$___1;
    var \u03b41$___2;
    var x8 = $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$__toLayer__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_Element__D__D__T2($thiz, el, layer$1, cx, cy);
    if ((x8 !== null)) {
      var \u03b41$___1 = (+x8.g());
      var \u03b41$___2 = (+x8.h());
      break matchResult2;
    }
    throw new $c_s_MatchError(x8);
  }
  var lx$2 = (+\u03b41$___1);
  var ly$2 = (+\u03b41$___2);
  layer$1.appendChild(b);
  $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$__place__Lorg_scalajs_dom_Element__D__D__Lorg_scalajs_dom_Element__V($thiz, b, lx$2, ly$2, layer$1);
  return b;
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$__bb$lzyINIT1$1__sr_LazyRef__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_SVGRect($thiz, bb$lzy1$1, el$1) {
  return (bb$lzy1$1.ci ? bb$lzy1$1.cj : bb$lzy1$1.h3(el$1.getBBox()));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$__bb$1__sr_LazyRef__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_SVGRect($thiz, bb$lzy1$2, el$2) {
  return (bb$lzy1$2.ci ? bb$lzy1$2.cj : $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$__bb$lzyINIT1$1__sr_LazyRef__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_SVGRect($thiz, bb$lzy1$2, el$2));
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$() {
  this.aUe = null;
  this.aUg = null;
  this.aUi = null;
  this.aUd = null;
  this.aUm = null;
  this.aUj = null;
  this.aUk = null;
  this.aUl = null;
  this.aUc = null;
  this.aUh = 0.0;
  this.aUf = 0.0;
  this.aUe = "gx-expand-badge";
  this.aUg = "gx-collapse-badge";
  this.aUi = "gx-fold-badge";
  this.aUd = "gx-badge-active";
  this.aUm = "gx-badge-layer";
  this.aUj = "data-gid";
  this.aUk = "data-gx-fold-hover";
  this.aUl = "data-gx-fold-hovered";
  this.aUc = "http://www.w3.org/2000/svg";
  this.aUh = 7.0;
  this.aUf = 18.0;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$.prototype = $p;
$p.aZH = (function(mainGroup, strategy, concealed, onToggleConcealed, collapsed, onToggleCollapsed, onCollapseGroup) {
  var layer = $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$__layerOf__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_Element(this, mainGroup);
  $m_Lorg_jpablo_graphexplorer_viewer_domUtils_QuerySelector$package$().m3(layer, "g.gx-expand-badge").F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => {
    _$1.remove();
  })));
  if (((!concealed.c()) || (!collapsed.c()))) {
    $m_Lorg_jpablo_graphexplorer_viewer_domUtils_QuerySelector$package$().m3(mainGroup, strategy.Jc()).cE(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((el) => $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$__isGhost$1__Lorg_scalajs_dom_Element__Z(this, el)))).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((el$2) => {
      var bb$lzy1 = new $c_sr_LazyRef();
      var id = strategy.afF(el$2);
      var this$3 = concealed.r(id);
      var bb$lzy1$2 = bb$lzy1;
      if ((!this$3.c())) {
        var x0 = this$3.d();
        var succ = (x0.g() | 0);
        var pred = (x0.h() | 0);
        var cy = ((+$p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$__bb$1__sr_LazyRef__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_SVGRect(this, bb$lzy1$2, el$2).y) + (0.5 * (+$p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$__bb$1__sr_LazyRef__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_SVGRect(this, bb$lzy1$2, el$2).height)));
        if ((succ > 0)) {
          $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$__addBadge$1__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_Element__D__D__T__T__T__F0__Lorg_scalajs_dom_Element(this, layer, el$2, ((+$p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$__bb$1__sr_LazyRef__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_SVGRect(this, bb$lzy1$2, el$2).x) + (+$p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$__bb$1__sr_LazyRef__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_SVGRect(this, bb$lzy1$2, el$2).width)), cy, $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$__countLabel__I__T(this, succ), "gx-expand-badge", (succ + " hidden successor(s) \u2014 click to show"), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
            onToggleConcealed.R(id, true);
          })));
        }
        if ((pred > 0)) {
          $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$__addBadge$1__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_Element__D__D__T__T__T__F0__Lorg_scalajs_dom_Element(this, layer, el$2, (+$p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$__bb$1__sr_LazyRef__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_SVGRect(this, bb$lzy1$2, el$2).x), cy, $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$__countLabel__I__T(this, pred), "gx-expand-badge", (pred + " hidden predecessor(s) \u2014 click to show"), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
            onToggleConcealed.R(id, false);
          })));
        }
      }
      var this$4 = collapsed.r(id);
      var bb$lzy1$3 = bb$lzy1;
      if ((!this$4.c())) {
        var x0$1 = this$4.d();
        var members = (x0$1 | 0);
        $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$__addBadge$1__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_Element__D__D__T__T__T__F0__Lorg_scalajs_dom_Element(this, layer, el$2, ((+$p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$__bb$1__sr_LazyRef__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_SVGRect(this, bb$lzy1$3, el$2).x) + (+$p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$__bb$1__sr_LazyRef__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_SVGRect(this, bb$lzy1$3, el$2).width)), (+$p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$__bb$1__sr_LazyRef__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_SVGRect(this, bb$lzy1$3, el$2).y), $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$__countLabel__I__T(this, members), "gx-expand-badge gx-collapse-badge", (members + " member(s) \u2014 click to expand"), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
          onToggleCollapsed.i(id);
        })));
      }
    })));
  }
  $m_Lorg_jpablo_graphexplorer_viewer_domUtils_QuerySelector$package$().m3(mainGroup, strategy.Ws()).cE(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((el$3) => $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$__isGhost$1__Lorg_scalajs_dom_Element__Z(this, el$3)))).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((el$4) => {
    var gid = strategy.a3k(el$4);
    var bb = el$4.getBBox();
    var b = $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$__addBadge$1__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_Element__D__D__T__T__T__F0__Lorg_scalajs_dom_Element(this, layer, el$4, ((+bb.x) + (+bb.width)), (+bb.y), "\u2212", "gx-expand-badge gx-fold-badge", "Collapse group into one box", new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      onCollapseGroup.i(gid);
    })));
    b.setAttribute("data-gid", gid.dR);
  })));
  var this$5 = $m_s_Option$().as(mainGroup.closest("svg"));
  if ((!this$5.c())) {
    var x0$2 = this$5.d();
    var this$6 = $m_s_Option$().as(x0$2.getAttribute("data-gx-fold-hovered"));
    var this$9 = ((this$6.c() || (this$6.d() !== "")) ? this$6 : $m_s_None$());
    if ((!this$9.c())) {
      $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$__applyHovered__Lorg_scalajs_dom_Element__T__V($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$(), x0$2, this$9.d());
    }
  }
});
$p.b2Z = (function(mainGroup, strategy) {
  var this$1 = $m_s_Option$().as(mainGroup.closest("svg"));
  var root = (this$1.c() ? mainGroup : this$1.d());
  if ((root.getAttribute("data-gx-fold-hover") === null)) {
    root.setAttribute("data-gx-fold-hover", "1");
    root.addEventListener("mouseover", ((e) => {
      $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$__setHovered__Lorg_scalajs_dom_Element__s_Option__V($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$(), root, $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$__groupUnder__Lorg_scalajs_dom_Element__Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElementStrategy__s_Option($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$(), e.target, strategy));
    }));
    root.addEventListener("mouseleave", ((_$4) => {
      $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$__setHovered__Lorg_scalajs_dom_Element__s_Option__V($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$(), root, $m_s_None$());
    }));
  }
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$, "org.jpablo.graphexplorer.viewer.components.svgCanvas.CountBadges$", ({
  zE: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__ctmOf__Lorg_scalajs_dom_Element__s_Option($thiz, el) {
  var m = el.getScreenCTM();
  return ((m === null) ? $m_s_None$() : new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$Ctm((+m.a), (+m.d), (+m.e), (+m.f))));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__clientBox__Lorg_scalajs_dom_Element__T4($thiz, el) {
  var r = el.getBoundingClientRect();
  return new $c_T4(((+r.left) + (0.5 * (+r.width))), ((+r.top) + (0.5 * (+r.height))), (+r.width), (+r.height));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__edgePathOf__Lorg_scalajs_dom_Element__s_Option($thiz, ref) {
  var this$1 = ref.tagName;
  _return: {
    var len = this$1.length;
    if ((len === 4)) {
      var i = 0;
      while ((i !== len)) {
        var thisCP = $f_T__codePointAt__I__I(this$1, i);
        if (($m_jl_Character$().iy($m_jl_Character$().j0(thisCP)) !== $m_jl_Character$().iy($m_jl_Character$().j0($f_T__codePointAt__I__I("path", i))))) {
          var $x_1 = false;
          break _return;
        }
        i = ((i + ((thisCP >= 65536) ? 2 : 1)) | 0);
      }
      var $x_1 = true;
    } else {
      var $x_1 = false;
    }
  }
  if ($x_1) {
    return new $c_s_Some(ref);
  } else {
    return $m_s_Option$().as(ref.querySelector($m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().a0y));
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__samplePath__Lorg_scalajs_dom_Element__s_Option($thiz, path) {
  var len = (+path.getTotalLength());
  if ((!(len > 0.0))) {
    return $m_s_None$();
  } else {
    var this$4 = new $c_sci_Range$Inclusive(0, $thiz.a9L, 1);
    return new $c_s_Some($m_sci_Vector$().X(this$4).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((i) => {
      var i$1 = (i | 0);
      var pt = path.getPointAtLength(((len * i$1) / $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$().a9L));
      return new $c_T2((+pt.x), (+pt.y));
    }))));
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__unmeasurable__Lorg_scalajs_dom_SVGSVGElement__Z($thiz, svg) {
  var r = svg.getBoundingClientRect();
  return (((+r.width) === 0.0) && ((+r.height) === 0.0));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__sheetOf__Lorg_scalajs_dom_SVGSVGElement__s_Option($thiz, svg) {
  return $m_s_Option$().as(svg.querySelector(":scope > g > polygon"));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__edgeTextKey__T__I__T($thiz, edgeKey, i) {
  return ((edgeKey + "##t") + i);
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__edgeHeadKey__T__I__T($thiz, edgeKey, i) {
  return ((edgeKey + "##h") + i);
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__correlationKeys__sci_Seq__sci_Seq($thiz, els) {
  var seen = $m_scm_Map$().aO();
  return els.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((se) => {
    var id = se.lj().Q9();
    var n = (seen.ay(id, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 0))) | 0);
    seen.cY(id, ((1 + n) | 0));
    return new $c_T2(((n === 0) ? id : ((id + "##s") + n)), se);
  })));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__baseTransformOf__Lorg_scalajs_dom_Element__T($thiz, el) {
  var this$1 = $m_s_Option$().as(el.getAttribute("transform"));
  return (this$1.c() ? "" : this$1.d());
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__restore__Lorg_scalajs_dom_Element__T__V($thiz, el, base) {
  if ((base === "")) {
    el.removeAttribute("transform");
  } else {
    el.setAttribute("transform", base);
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__start__Lorg_scalajs_dom_SVGSVGElement__sci_Seq__sci_Set__Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$Snapshot__F0($thiz, newSvg, keyed, newKeys, snap) {
  var step$lzy1 = new $c_sr_LazyRef();
  $m_sci_Vector$();
  var boxTweens = new $c_sci_VectorBuilder();
  $m_sci_Vector$();
  var edgeTweens = new $c_sci_VectorBuilder();
  $m_sci_Vector$();
  var enters = new $c_sci_VectorBuilder();
  keyed.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var key = x$1.g();
    var se = x$1.h();
    var x41 = $f_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement__arrowId__s_Option(se);
    if ((x41 instanceof $c_s_Some)) {
      var this$5 = $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__edgePathOf__Lorg_scalajs_dom_Element__s_Option($thiz, se.dD());
      if ((!this$5.c())) {
        var x0 = this$5.d();
        var this$6 = $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__ctmOf__Lorg_scalajs_dom_Element__s_Option($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$(), x0);
        if (this$6.c()) {
          var $x_1 = $m_s_None$();
        } else {
          var x0$1 = this$6.d();
          var this$7 = $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__samplePath__Lorg_scalajs_dom_Element__s_Option($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$(), x0);
          if (this$7.c()) {
            var $x_1 = $m_s_None$();
          } else {
            var x0$2 = this$7.d();
            var this$8 = snap.M2.r(key);
            if (this$8.c()) {
              var $x_1 = $m_s_None$();
            } else {
              var x0$3 = this$8.d();
              var $x_1 = new $c_s_Some(edgeTweens.ck(new $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$EdgeTween(x0, x0.getAttribute("d"), x0$3.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((ctm$4$2) => ((x$1$1) => {
                var cx = (+x$1$1.g());
                var cy = (+x$1$1.h());
                return ctm$4$2.Q1(cx, cy);
              }))(x0$1))), x0$2)));
            }
          }
        }
        var tweened = (!$x_1.c());
      } else {
        var tweened = false;
      }
      $f_sc_IterableOps__zipWithIndex__O(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(se.dD().querySelectorAll("text"))).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
        var t = x$1$2.g();
        var i = (x$1$2.h() | 0);
        var this$13 = snap.M1.r($p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__edgeTextKey__T__I__T($thiz, key, i));
        if ((!this$13.c())) {
          $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__rectTween$1__scm_ReusableBuilder__Lorg_scalajs_dom_Element__T4__V($thiz, boxTweens, t, this$13.d());
        }
      })));
      $f_sc_IterableOps__zipWithIndex__O(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(se.dD().querySelectorAll("polygon, ellipse"))).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3) => {
        var h = x$1$3.g();
        var i$1 = (x$1$3.h() | 0);
        var this$16 = snap.M1.r($p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__edgeHeadKey__T__I__T($thiz, key, i$1));
        if ((!this$16.c())) {
          $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__rectTween$1__scm_ReusableBuilder__Lorg_scalajs_dom_Element__T4__V($thiz, boxTweens, h, this$16.d());
        }
      })));
      return ((!tweened) ? ((!snap.zq.E(key)) ? (enters.ck(se.dD()), (void 0)) : (void 0)) : (void 0));
    }
    if (($m_s_None$() === x41)) {
      var x38 = snap.zq.r(key);
      if ((x38 instanceof $c_s_Some)) {
        var old = x38.J;
        $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__rectTween$1__scm_ReusableBuilder__Lorg_scalajs_dom_Element__T4__V($thiz, boxTweens, se.dD(), old);
        return (void 0);
      }
      if (($m_s_None$() === x38)) {
        return enters.ck(se.dD());
      }
      throw new $c_s_MatchError(x38);
    }
    throw new $c_s_MatchError(x41);
  })));
  var mainGroup = newSvg.querySelector("g");
  var this$17 = $m_s_Option$().as(mainGroup);
  if (this$17.c()) {
    var ghostRefFrame = $m_s_None$();
  } else {
    var x0$6 = this$17.d();
    var ghostRefFrame = $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__ctmOf__Lorg_scalajs_dom_Element__s_Option($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$(), x0$6);
  }
  if ((mainGroup === null)) {
    $m_sci_Vector$();
    var ghosts = $m_sci_Vector0$();
  } else {
    var this$19 = $m_s_Option$().m2(ghostRefFrame).d2();
    $m_sci_Vector$();
    var b = new $c_sci_VectorBuilder();
    var it = this$19.o();
    while (it.p()) {
      var x0$7 = it.q();
      var this$21 = snap.T7;
      b.fO($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O($m_sci_Vector$().X(this$21), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4) => _$4.g())), $m_s_math_Ordering$String$()).un(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((newKeys) => ((x$1$4) => {
        if ((x$1$4 !== null)) {
          var key$1 = x$1$4.g();
          x$1$4.h();
          return (!newKeys.E(key$1));
        }
        throw new $c_s_MatchError(x$1$4);
      }))(newKeys))).c5(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((snap, frame$2, mainGroup) => ((x$1$2$1) => {
        if ((x$1$2$1 !== null)) {
          var key$2 = x$1$2$1.g();
          var el$1 = x$1$2$1.h();
          var this$23 = $m_s_Option$().m2(snap.zq.r(key$2)).d2();
          $m_sci_Vector$();
          var b$1 = new $c_sci_VectorBuilder();
          var it$1 = this$23.o();
          while (it$1.p()) {
            var x0$8 = it$1.q();
            b$1.fO($m_s_Option$().m2(snap.T6.r(key$2)).d2().L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((frame$2, oldClient$2, el$1, mainGroup) => ((x$1$5) => {
              if ((x$1$5 !== null)) {
                var bbX = (+x$1$5.bO);
                var bbY = (+x$1$5.bs);
                var bbW = (+x$1$5.ch);
                var bbH = (+x$1$5.ca);
                var _1 = (bbX + (0.5 * bbW));
                var _2 = (bbY + (0.5 * bbH));
                matchResult25: {
                  var \u03b44$___1;
                  var \u03b44$___2;
                  var x47 = frame$2.Q1((+oldClient$2.bO), (+oldClient$2.bs));
                  if ((x47 !== null)) {
                    var \u03b44$___1 = (+x47.g());
                    var \u03b44$___2 = (+x47.h());
                    break matchResult25;
                  }
                  throw new $c_s_MatchError(x47);
                }
                var tx$2 = (+\u03b44$___1);
                var ty$2 = (+\u03b44$___2);
                var kgx = (((bbW > 0.0) && (frame$2.zo !== 0.0)) ? ((+oldClient$2.ch) / (bbW * frame$2.zo)) : 1.0);
                var kgy = (((bbH > 0.0) && (frame$2.zp !== 0.0)) ? ((+oldClient$2.ca) / (bbH * frame$2.zp)) : 1.0);
                var wrap = document.createElementNS("http://www.w3.org/2000/svg", "g");
                wrap.setAttribute("class", $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$().a0A);
                var tween = new $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$GhostTween(wrap, _1, _2, tx$2, ty$2, kgx, kgy);
                wrap.setAttribute("transform", tween.aT3(0.0));
                wrap.style.pointerEvents = "none";
                el$1.removeAttribute("id");
                var this$28 = $m_s_Option$().as(el$1.getAttribute("class"));
                el$1.setAttribute("class", $f_T__trim__T((((this$28.c() ? "" : this$28.d()) + " ") + $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$().a0A)));
                wrap.appendChild(el$1);
                mainGroup.appendChild(wrap);
                return tween;
              }
              throw new $c_s_MatchError(x$1$5);
            }))(frame$2, x0$8, el$1, mainGroup))));
          }
          return b$1.bY();
        }
        throw new $c_s_MatchError(x$1$2$1);
      }))(snap, x0$7, mainGroup))));
    }
    var ghosts = b.bY();
  }
  var boxes = boxTweens.bY();
  var edges = edgeTweens.bY();
  var entered = enters.bY();
  entered.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$5) => {
    _$5.style.opacity = "0";
  })));
  var this$29 = snap.T8;
  if (this$29.c()) {
    var sheetTween = $m_s_None$();
  } else {
    var x0$9 = this$29.d();
    var this$30 = $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__sheetOf__Lorg_scalajs_dom_SVGSVGElement__s_Option($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$(), newSvg);
    if (this$30.c()) {
      var sheetTween = $m_s_None$();
    } else {
      var x0$10 = this$30.d();
      var this$31 = $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__ctmOf__Lorg_scalajs_dom_Element__s_Option($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$(), x0$10);
      if (this$31.c()) {
        var sheetTween = $m_s_None$();
      } else {
        var x0$11 = this$31.d();
        var r = x0$10.getBoundingClientRect();
        matchResult28: {
          var \u03b45$___1;
          var \u03b45$___2;
          var x58 = x0$11.Q1((+r.left), (+r.top));
          if ((x58 !== null)) {
            var \u03b45$___1 = (+x58.g());
            var \u03b45$___2 = (+x58.h());
            break matchResult28;
          }
          throw new $c_s_MatchError(x58);
        }
        var sheetTween = new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$SheetTween(x0$10, x0$11, (+\u03b45$___1), (+\u03b45$___2), x0$9, new $c_T4((+r.left), (+r.top), (+r.width), (+r.height))));
      }
    }
  }
  var rafId = new $c_sr_IntRef(0);
  var done = new $c_sr_BooleanRef(false);
  var t0 = new $c_sr_DoubleRef((-1.0));
  newSvg.classList.add($thiz.a9N);
  $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__applyFrame$1__sci_Vector__s_Option__sci_Vector__sci_Vector__sci_Vector__D__V($thiz, boxes, sheetTween, edges, entered, ghosts, 0.0);
  rafId.an = (window.requestAnimationFrame($p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__step$1__sr_LazyRef__sr_BooleanRef__sr_DoubleRef__sr_IntRef__sci_Vector__s_Option__sci_Vector__sci_Vector__sci_Vector__Lorg_scalajs_dom_SVGSVGElement__sjs_js_Function1($thiz, step$lzy1, done, t0, rafId, boxes, sheetTween, edges, entered, ghosts, newSvg)) | 0);
  return new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    if ((!done.dy)) {
      done.dy = true;
      window.cancelAnimationFrame(rafId.an);
      $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__finish$1__sci_Vector__s_Option__sci_Vector__sci_Vector__sci_Vector__Lorg_scalajs_dom_SVGSVGElement__V($thiz, boxes, sheetTween, edges, entered, ghosts, newSvg);
    }
  }));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__rectTween$1__scm_ReusableBuilder__Lorg_scalajs_dom_Element__T4__V($thiz, boxTweens$2, el, old) {
  var this$1 = $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__ctmOf__Lorg_scalajs_dom_Element__s_Option($thiz, el);
  if ((!this$1.c())) {
    var x0 = this$1.d();
    matchResult19: {
      var \u03b41$___1;
      var \u03b41$___2;
      var \u03b41$___3;
      var \u03b41$___4;
      if ((old !== null)) {
        var \u03b41$___1 = (+old.bO);
        var \u03b41$___2 = (+old.bs);
        var \u03b41$___3 = (+old.ch);
        var \u03b41$___4 = (+old.ca);
        break matchResult19;
      }
      throw new $c_s_MatchError(old);
    }
    var oldX$2 = (+\u03b41$___1);
    var oldY$2 = (+\u03b41$___2);
    var oldW$2 = (+\u03b41$___3);
    var oldH$2 = (+\u03b41$___4);
    matchResult20: {
      var \u03b42$___1;
      var \u03b42$___2;
      var \u03b42$___3;
      var \u03b42$___4;
      var x30 = $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__clientBox__Lorg_scalajs_dom_Element__T4($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$(), el);
      if ((x30 !== null)) {
        var \u03b42$___1 = (+x30.bO);
        var \u03b42$___2 = (+x30.bs);
        var \u03b42$___3 = (+x30.ch);
        var \u03b42$___4 = (+x30.ca);
        break matchResult20;
      }
      throw new $c_s_MatchError(x30);
    }
    var newX$2 = (+\u03b42$___1);
    var newY$2 = (+\u03b42$___2);
    var newW$2 = (+\u03b42$___3);
    var newH$2 = (+\u03b42$___4);
    matchResult21: {
      var \u03b43$___1;
      var \u03b43$___2;
      var x35 = x0.Q1(newX$2, newY$2);
      if ((x35 !== null)) {
        var \u03b43$___1 = (+x35.g());
        var \u03b43$___2 = (+x35.h());
        break matchResult21;
      }
      throw new $c_s_MatchError(x35);
    }
    var cfx$2 = (+\u03b43$___1);
    var cfy$2 = (+\u03b43$___2);
    var kx0 = ((newW$2 > 0.0) ? (oldW$2 / newW$2) : 1.0);
    var ky0 = ((newH$2 > 0.0) ? (oldH$2 / newH$2) : 1.0);
    boxTweens$2.Y(new $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$BoxTween(el, $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__baseTransformOf__Lorg_scalajs_dom_Element__T($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$(), el), x0, cfx$2, cfy$2, new $c_T2(oldX$2, oldY$2), new $c_T2(newX$2, newY$2), kx0, ky0));
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__ease$1__D__D($thiz, t) {
  if ((t < 0.5)) {
    return (((4.0 * t) * t) * t);
  } else {
    var x = (((-2.0) * t) + 2.0);
    return (1.0 - (0.5 * (+Math.pow(x, 3.0))));
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__applyFrame$1__sci_Vector__s_Option__sci_Vector__sci_Vector__sci_Vector__D__V($thiz, boxes$3, sheetTween$1, edges$6, entered$1, ghosts$3, e) {
  boxes$3.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((b) => {
    var cx = ((+b.zn.g()) + (((+b.Gm.g()) - (+b.zn.g())) * e));
    var cy = ((+b.zn.h()) + (((+b.Gm.h()) - (+b.zn.h())) * e));
    matchResult29: {
      var \u03b46$___1;
      var \u03b46$___2;
      var x61 = b.LV.Q1(cx, cy);
      if ((x61 !== null)) {
        var \u03b46$___1 = (+x61.g());
        var \u03b46$___2 = (+x61.h());
        break matchResult29;
      }
      throw new $c_s_MatchError(x61);
    }
    var lx$2 = (+\u03b46$___1);
    var ly$2 = (+\u03b46$___2);
    var kx = (b.Gk + ((1.0 - b.Gk) * e));
    var ky = (b.Gl + ((1.0 - b.Gl) * e));
    b.Gj.setAttribute("transform", $f_T__trim__T((((((((((b.Gi + " translate(") + (lx$2 - (kx * b.LT))) + " ") + (ly$2 - (ky * b.LU))) + ") scale(") + kx) + " ") + ky) + ")")));
  })));
  if ((!sheetTween$1.c())) {
    var x0 = sheetTween$1.d();
    var x = ((+x0.qm.bO) + (((+x0.vj.bO) - (+x0.qm.bO)) * e));
    var y = ((+x0.qm.bs) + (((+x0.vj.bs) - (+x0.qm.bs)) * e));
    var kx$1 = (((+x0.qm.ch) + (((+x0.vj.ch) - (+x0.qm.ch)) * e)) / (+x0.vj.ch));
    var ky$1 = (((+x0.qm.ca) + (((+x0.vj.ca) - (+x0.qm.ca)) * e)) / (+x0.vj.ca));
    matchResult30: {
      var \u03b47$___1;
      var \u03b47$___2;
      var x64 = x0.M0.Q1(x, y);
      if ((x64 !== null)) {
        var \u03b47$___1 = (+x64.g());
        var \u03b47$___2 = (+x64.h());
        break matchResult30;
      }
      throw new $c_s_MatchError(x64);
    }
    var lx$2$1 = (+\u03b47$___1);
    var ly$2$1 = (+\u03b47$___2);
    x0.Gv.setAttribute("transform", (((((((("translate(" + (lx$2$1 - (kx$1 * x0.LY))) + " ") + (ly$2$1 - (ky$1 * x0.LZ))) + ") scale(") + kx$1) + " ") + ky$1) + ")"));
  }
  edges$6.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((et) => {
    var this$3 = et.LW;
    var end = this$3.C();
    var isEmpty = (end <= 0);
    var scala$collection$immutable$Range$$lastElement = ((end - 1) | 0);
    if (((end <= 0) && (!isEmpty))) {
      $m_sci_Range$().ug(0, end, 1, false);
    }
    var b$1 = $m_sci_IndexedSeq$().b5();
    var it = new $c_sci_RangeIterator(0, 1, scala$collection$immutable$Range$$lastElement, isEmpty);
    while (it.g0) {
      var x0$1 = it.hp();
      matchResult31: {
        var \u03b48$___1;
        var \u03b48$___2;
        var x67 = et.LW.l(x0$1);
        if ((x67 !== null)) {
          var \u03b48$___1 = (+x67.g());
          var \u03b48$___2 = (+x67.h());
          break matchResult31;
        }
        throw new $c_s_MatchError(x67);
      }
      var fx$2 = (+\u03b48$___1);
      var fy$2 = (+\u03b48$___2);
      matchResult32: {
        var \u03b49$___1;
        var \u03b49$___2;
        var x70 = et.T5.l(x0$1);
        if ((x70 !== null)) {
          var \u03b49$___1 = (+x70.g());
          var \u03b49$___2 = (+x70.h());
          break matchResult32;
        }
        throw new $c_s_MatchError(x70);
      }
      var tx$2 = (+\u03b49$___1);
      var ty$2 = (+\u03b49$___2);
      b$1.Y((((fx$2 + ((tx$2 - fx$2) * e)) + ",") + (fy$2 + ((ty$2 - fy$2) * e))));
    }
    var pts = b$1.aR();
    et.LX.setAttribute("d", ((("M" + pts.t()) + "L") + $f_sc_IterableOnceOps__mkString__T__T__T__T(pts.v(), "", " ", "")));
  })));
  entered$1.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6) => {
    var $x_1 = _$6.style;
    var x$1 = ((e - 0.4) / 0.6);
    var x$2 = (+Math.max(x$1, 0.0));
    $x_1.opacity = ("" + (+Math.min(x$2, 1.0)));
  })));
  ghosts$3.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((g) => {
    g.xb.setAttribute("transform", g.aT3(e));
    var $x_2 = g.xb.style;
    var x$3 = (1.0 - (2.0 * e));
    $x_2.opacity = ("" + (+Math.max(x$3, 0.0)));
  })));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__finish$1__sci_Vector__s_Option__sci_Vector__sci_Vector__sci_Vector__Lorg_scalajs_dom_SVGSVGElement__V($thiz, boxes$4, sheetTween$2, edges$7, entered$2, ghosts$4, newSvg$2) {
  boxes$4.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((b) => {
    $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__restore__Lorg_scalajs_dom_Element__T__V($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$(), b.Gj, b.Gi);
  })));
  if ((!sheetTween$2.c())) {
    var x0 = sheetTween$2.d();
    x0.Gv.removeAttribute("transform");
  }
  edges$7.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((et) => {
    et.LX.setAttribute("d", et.T4);
  })));
  entered$2.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$7) => {
    _$7.style.opacity = "";
  })));
  ghosts$4.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((g) => {
    if ((g.xb.parentNode !== null)) {
      g.xb.parentNode.removeChild(g.xb);
    }
  })));
  newSvg$2.classList.remove($thiz.a9N);
  newSvg$2.dispatchEvent(new Event($thiz.a9M));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__step$lzyINIT1$1__sr_LazyRef__sr_BooleanRef__sr_DoubleRef__sr_IntRef__sci_Vector__s_Option__sci_Vector__sci_Vector__sci_Vector__Lorg_scalajs_dom_SVGSVGElement__sjs_js_Function1($thiz, step$lzy1$1, done$1, t0$1, rafId$1, boxes$5, sheetTween$3, edges$8, entered$3, ghosts$5, newSvg$3) {
  return (step$lzy1$1.ci ? step$lzy1$1.cj : step$lzy1$1.h3(((arg1) => {
    var now = (+arg1);
    if ((!done$1.dy)) {
      if ((t0$1.T < 0.0)) {
        t0$1.T = now;
      }
      var x = ((now - t0$1.T) / $thiz.ayo);
      var t = (+Math.min(x, 1.0));
      $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__applyFrame$1__sci_Vector__s_Option__sci_Vector__sci_Vector__sci_Vector__D__V($thiz, boxes$5, sheetTween$3, edges$8, entered$3, ghosts$5, $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__ease$1__D__D($thiz, t));
      if ((t < 1.0)) {
        rafId$1.an = (window.requestAnimationFrame($p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__step$1__sr_LazyRef__sr_BooleanRef__sr_DoubleRef__sr_IntRef__sci_Vector__s_Option__sci_Vector__sci_Vector__sci_Vector__Lorg_scalajs_dom_SVGSVGElement__sjs_js_Function1($thiz, step$lzy1$1, done$1, t0$1, rafId$1, boxes$5, sheetTween$3, edges$8, entered$3, ghosts$5, newSvg$3)) | 0);
      } else {
        done$1.dy = true;
        $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__finish$1__sci_Vector__s_Option__sci_Vector__sci_Vector__sci_Vector__Lorg_scalajs_dom_SVGSVGElement__V($thiz, boxes$5, sheetTween$3, edges$8, entered$3, ghosts$5, newSvg$3);
      }
    }
  })));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__step$1__sr_LazyRef__sr_BooleanRef__sr_DoubleRef__sr_IntRef__sci_Vector__s_Option__sci_Vector__sci_Vector__sci_Vector__Lorg_scalajs_dom_SVGSVGElement__sjs_js_Function1($thiz, step$lzy1$3, done$3, t0$3, rafId$3, boxes$7, sheetTween$5, edges$10, entered$5, ghosts$7, newSvg$5) {
  return (step$lzy1$3.ci ? step$lzy1$3.cj : $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__step$lzyINIT1$1__sr_LazyRef__sr_BooleanRef__sr_DoubleRef__sr_IntRef__sci_Vector__s_Option__sci_Vector__sci_Vector__sci_Vector__Lorg_scalajs_dom_SVGSVGElement__sjs_js_Function1($thiz, step$lzy1$3, done$3, t0$3, rafId$3, boxes$7, sheetTween$5, edges$10, entered$5, ghosts$7, newSvg$5));
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$() {
  this.a9L = 0;
  this.ayo = 0.0;
  this.a0A = null;
  this.a9N = null;
  this.a9M = null;
  $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$ = this;
  this.a9L = 24;
  this.ayo = 300.0;
  this.a0A = $m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().a0v;
  this.a9N = "gx-transitioning";
  this.a9M = "gx-transition-end";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$.prototype = $p;
$p.b7i = (function() {
  return (!(!window.matchMedia("(prefers-reduced-motion: reduce)").matches));
});
$p.aYb = (function(oldSvg, strategy) {
  if ($p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__unmeasurable__Lorg_scalajs_dom_SVGSVGElement__Z(this, oldSvg)) {
    return new $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$Snapshot($m_sci_Map$EmptyMap$(), $m_sci_Map$EmptyMap$(), $m_sci_Map$EmptyMap$(), $m_sci_Map$EmptyMap$(), $m_sci_Map$EmptyMap$(), $m_s_None$());
  }
  var els = $m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().DW(oldSvg, strategy);
  var boxes$1 = new $c_sci_MapBuilderImpl();
  var edges$1 = new $c_sci_MapBuilderImpl();
  var edgeParts$1 = new $c_sci_MapBuilderImpl();
  var ghosts$1 = new $c_sci_MapBuilderImpl();
  var ghostBBoxes$1 = new $c_sci_MapBuilderImpl();
  $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__correlationKeys__sci_Seq__sci_Seq(this, els).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var key = x$1.g();
    var se = x$1.h();
    ghosts$1.lR(key, se.dD());
    var bb = se.dD().getBBox();
    ghostBBoxes$1.lR(key, new $c_T4((+bb.x), (+bb.y), (+bb.width), (+bb.height)));
    if ((!$f_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement__arrowId__s_Option(se).c())) {
      var this$18 = $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__edgePathOf__Lorg_scalajs_dom_Element__s_Option($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$(), se.dD());
      if ((!this$18.c())) {
        var x0 = this$18.d();
        var this$19 = $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__ctmOf__Lorg_scalajs_dom_Element__s_Option($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$(), x0);
        if ((!this$19.c())) {
          var x0$1 = this$19.d();
          var this$20 = $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__samplePath__Lorg_scalajs_dom_Element__s_Option($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$(), x0);
          if ((!this$20.c())) {
            edges$1.lR(key, this$20.d().L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((ctm$1$2) => ((x$1$1) => {
              var x = (+x$1$1.g());
              var y$2 = (+x$1$1.h());
              return ctm$1$2.ba3(x, y$2);
            }))(x0$1))));
          }
        }
      }
      $f_sc_IterableOps__zipWithIndex__O(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(se.dD().querySelectorAll("text"))).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
        var t = x$1$2.g();
        var i = (x$1$2.h() | 0);
        return edgeParts$1.lR($p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__edgeTextKey__T__I__T($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$(), key, i), $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__clientBox__Lorg_scalajs_dom_Element__T4($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$(), t));
      })));
      $f_sc_IterableOps__zipWithIndex__O(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(se.dD().querySelectorAll("polygon, ellipse"))).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3) => {
        var h = x$1$3.g();
        var i$1 = (x$1$3.h() | 0);
        return edgeParts$1.lR($p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__edgeHeadKey__T__I__T($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$(), key, i$1), $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__clientBox__Lorg_scalajs_dom_Element__T4($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$(), h));
      })));
      return boxes$1.lR(key, $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__clientBox__Lorg_scalajs_dom_Element__T4($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$(), se.dD()));
    } else {
      return boxes$1.lR(key, $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__clientBox__Lorg_scalajs_dom_Element__T4($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$(), se.dD()));
    }
  })));
  var this$35 = $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__sheetOf__Lorg_scalajs_dom_SVGSVGElement__s_Option(this, oldSvg);
  if (this$35.c()) {
    var sheet$1 = $m_s_None$();
  } else {
    var x0$3 = this$35.d();
    var r = x0$3.getBoundingClientRect();
    var sheet$1 = new $c_s_Some(new $c_T4((+r.left), (+r.top), (+r.width), (+r.height)));
  }
  return new $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$Snapshot(boxes$1.oG(), edges$1.oG(), edgeParts$1.oG(), ghosts$1.oG(), ghostBBoxes$1.oG(), sheet$1);
});
$p.aWX = (function(newSvg, strategy, snap) {
  if ((snap.c() || $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__unmeasurable__Lorg_scalajs_dom_SVGSVGElement__Z(this, newSvg))) {
    return $m_s_None$();
  }
  var els = $m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().DW(newSvg, strategy);
  if (els.c()) {
    return $m_s_None$();
  } else {
    var keyed = $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__correlationKeys__sci_Seq__sci_Seq(this, els);
    var newKeys = $m_sci_Set$().af(keyed.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => _$1.g()))));
    return ((!newKeys.lU(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((key) => snap.zq.E(key))))) ? $m_s_None$() : new $c_s_Some($p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$__start__Lorg_scalajs_dom_SVGSVGElement__sci_Seq__sci_Set__Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$Snapshot__F0(this, newSvg, keyed, newKeys, snap)));
  }
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$, "org.jpablo.graphexplorer.viewer.components.svgCanvas.LayoutTransition$", ({
  zF: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_NewArrowControl$package$__toParent$1__Lorg_scalajs_dom_SVGMatrix__Lorg_scalajs_dom_SVGMatrix__D__D__Lorg_jpablo_graphexplorer_viewer_domUtils_DOMPoint($thiz, elemMatrix$1, inv$1, x, y) {
  return new DOMPoint(x, y).matrixTransform(elemMatrix$1).matrixTransform(inv$1);
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_NewArrowControl$package$__sideGapPx$1__D__D__Z__D($thiz, edgeGapPx$1, badgeLanePx$1, occupied) {
  return (edgeGapPx$1 + (occupied ? badgeLanePx$1 : 0.0));
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_NewArrowControl$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_NewArrowControl$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_NewArrowControl$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_NewArrowControl$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_NewArrowControl$package$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_NewArrowControl$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_NewArrowControl$package$, "org.jpablo.graphexplorer.viewer.components.svgCanvas.NewArrowControl$package$", ({
  zG: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_NewArrowControl$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_NewArrowControl$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_NewArrowControl$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_NewArrowControl$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_NewArrowControl$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_NewArrowControl$package$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_RecordCellOverlay$__insertBelowRaised__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_Element__V($thiz, mainGroup, g) {
  var this$1 = $m_s_Option$().as(mainGroup.querySelector(("." + $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionZOrder$().a0C)));
  var anchor = (this$1.c() ? $m_s_Option$().as(mainGroup.querySelector("g.gx-badge-layer")) : this$1);
  mainGroup.insertBefore(g, (anchor.c() ? null : anchor.d()));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_RecordCellOverlay$__ringPath__Lorg_scalajs_dom_SVGRect__D__D__D__D__T($thiz, outer, x, y, w, h) {
  return (((((((((((("M" + (+outer.x)) + ",") + (+outer.y)) + " h") + (+outer.width)) + " v") + (+outer.height)) + " h") + (-(+outer.width))) + " Z ") + ((((((((("M" + x) + ",") + y) + " h") + w) + " v") + h) + " h") + (-w))) + " Z");
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_RecordCellOverlay$__cellRect__Lorg_jpablo_graphexplorer_viewer_state_RecordCellBox__D__D__T__Lorg_scalajs_dom_Element($thiz, box, cx, cy, cls) {
  var rect = document.createElementNS("http://www.w3.org/2000/svg", "rect");
  rect.setAttribute("class", cls);
  rect.setAttribute("x", ("" + (cx + box.to)));
  rect.setAttribute("y", ("" + (cy - box.tp)));
  rect.setAttribute("width", ("" + box.aTs()));
  rect.setAttribute("height", ("" + box.aP8()));
  return rect;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_RecordCellOverlay$() {
  this.aUr = null;
  this.aUq = null;
  this.aUp = null;
  this.aUo = 0.0;
  this.aUn = 0.0;
  this.aUr = "record-cell-overlay";
  this.aUq = "record-cell-drop-overlay";
  this.aUp = "http://www.w3.org/2000/svg";
  this.aUo = 3.0;
  this.aUn = 2.5;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_RecordCellOverlay$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_RecordCellOverlay$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_RecordCellOverlay$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_RecordCellOverlay$.prototype = $p;
$p.aRq = (function(mainGroup, strategy, cellOpt, boxesFor) {
  var this$1 = $m_s_Option$().as(mainGroup.querySelector("#record-cell-overlay"));
  if ((!this$1.c())) {
    var x0 = this$1.d();
    x0.remove();
  }
  if (cellOpt.c()) {
    var cellOpt$1 = $m_s_None$();
  } else {
    var x0$1 = cellOpt.d();
    var cellOpt$1 = new $c_s_Some(new $c_T2(x0$1.bT, x0$1.f4));
  }
  if ((!cellOpt$1.c())) {
    var x0$2 = cellOpt$1.d();
    matchResult1: {
      if ((x0$2 !== null)) {
        var nodeId = x0$2.g();
        var path = x0$2.h();
        var this$5 = $m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().Ed(mainGroup, $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_NodeId.r().C)([nodeId]))), strategy).dt();
        if ((!this$5.c())) {
          var x0$3 = this$5.d();
          var this$6 = boxesFor.i(nodeId).iW(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4) => {
            var x = _$4.qq;
            return ((x === null) ? (path === null) : x.e(path));
          })));
          if ((!this$6.c())) {
            var x0$4 = this$6.d();
            var bbox = $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_RecordCellOverlay$().ahn(x0$3.dD());
            var x1 = ((+bbox.x) + (0.5 * (+bbox.width)));
            var x2 = ((+bbox.y) + (0.5 * (+bbox.height)));
            var g = document.createElementNS("http://www.w3.org/2000/svg", "g");
            g.setAttribute("id", "record-cell-overlay");
            g.setAttribute("pointer-events", "none");
            var veil = document.createElementNS("http://www.w3.org/2000/svg", "path");
            veil.setAttribute("class", "record-cell-veil");
            veil.setAttribute("fill-rule", "evenodd");
            veil.setAttribute("d", $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_RecordCellOverlay$__ringPath__Lorg_scalajs_dom_SVGRect__D__D__D__D__T($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_RecordCellOverlay$(), bbox, (x1 + x0$4.to), (x2 - x0$4.tp), x0$4.aTs(), x0$4.aP8()));
            g.appendChild(veil);
            var rect = $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_RecordCellOverlay$__cellRect__Lorg_jpablo_graphexplorer_viewer_state_RecordCellBox__D__D__T__Lorg_scalajs_dom_Element($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_RecordCellOverlay$(), x0$4, x1, x2, "record-cell-selected");
            rect.style.strokeWidth = ($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$().a4N(3.0) + "px");
            g.appendChild(rect);
            var this$8 = x0$4.H1;
            if ((!this$8.c())) {
              var x0$5 = this$8.d();
              var label = document.createElementNS("http://www.w3.org/2000/svg", "text");
              label.setAttribute("class", "record-cell-port");
              label.setAttribute("x", ("" + ((x1 + x0$4.to) + 2.0)));
              label.setAttribute("y", ("" + ((x2 - x0$4.tp) - 3.0)));
              label.textContent = (("<" + x0$5) + ">");
              g.appendChild(label);
            }
            $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_RecordCellOverlay$__insertBelowRaised__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_Element__V($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_RecordCellOverlay$(), mainGroup, g);
            break matchResult1;
          } else {
            break matchResult1;
          }
        } else {
          break matchResult1;
        }
      }
      throw new $c_s_MatchError(x0$2);
    }
  }
});
$p.b7m = (function(mainGroup, strategy, cellOpt, boxesFor) {
  var this$1 = $m_s_Option$().as(mainGroup.querySelector("#record-cell-drop-overlay"));
  if ((!this$1.c())) {
    var x0 = this$1.d();
    x0.remove();
  }
  if ((!cellOpt.c())) {
    var x0$1 = cellOpt.d();
    matchResult1: {
      if ((x0$1 !== null)) {
        var nodeId = x0$1.g();
        var path = x0$1.h();
        var this$4 = $m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().Ed(mainGroup, $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_NodeId.r().C)([nodeId]))), strategy).dt();
        if ((!this$4.c())) {
          var x0$2 = this$4.d();
          var this$5 = boxesFor.i(nodeId).iW(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4) => {
            var x = _$4.qq;
            return ((x === null) ? (path === null) : x.e(path));
          })));
          if ((!this$5.c())) {
            var x0$3 = this$5.d();
            var bbox = $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_RecordCellOverlay$().ahn(x0$2.dD());
            var x1 = ((+bbox.x) + (0.5 * (+bbox.width)));
            var x2 = ((+bbox.y) + (0.5 * (+bbox.height)));
            var g = document.createElementNS("http://www.w3.org/2000/svg", "g");
            g.setAttribute("id", "record-cell-drop-overlay");
            g.setAttribute("pointer-events", "none");
            var rect = $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_RecordCellOverlay$__cellRect__Lorg_jpablo_graphexplorer_viewer_state_RecordCellBox__D__D__T__Lorg_scalajs_dom_Element($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_RecordCellOverlay$(), x0$3, x1, x2, "record-cell-drop");
            rect.style.strokeWidth = ($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$().a4N(2.5) + "px");
            g.appendChild(rect);
            $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_RecordCellOverlay$__insertBelowRaised__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_Element__V($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_RecordCellOverlay$(), mainGroup, g);
            break matchResult1;
          } else {
            break matchResult1;
          }
        } else {
          break matchResult1;
        }
      }
      throw new $c_s_MatchError(x0$1);
    }
  }
});
$p.ahn = (function(ref) {
  var decorations = $m_Lorg_jpablo_graphexplorer_viewer_domUtils_QuerySelector$package$().m3(ref, ("." + $m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().T3));
  decorations.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$5) => {
    _$5.setAttribute("display", "none");
  })));
  var bbox = ref.getBBox();
  decorations.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6) => {
    _$6.removeAttribute("display");
  })));
  return bbox;
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_RecordCellOverlay$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_RecordCellOverlay$, "org.jpablo.graphexplorer.viewer.components.svgCanvas.RecordCellOverlay$", ({
  zH: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_RecordCellOverlay$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_RecordCellOverlay$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_RecordCellOverlay$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_RecordCellOverlay$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_RecordCellOverlay$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_RecordCellOverlay$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$__measuredFactor__D($thiz) {
  var body = document.body;
  if ((body === null)) {
    return 0.0;
  } else {
    var host = document.createElement("div");
    host.style.cssText = "position:fixed;left:0;top:0;width:200px;height:200px;opacity:0;pointer-events:auto;z-index:2147483647";
    var svgEl = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svgEl.setAttribute("width", "200");
    svgEl.setAttribute("height", "200");
    var path = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path.setAttribute("d", "M10,100 L190,100");
    path.setAttribute("fill", "none");
    path.setAttribute("stroke", "black");
    path.setAttribute("stroke-width", ("" + $thiz.a0B));
    path.style.pointerEvents = "stroke";
    path.style.vectorEffect = "non-scaling-stroke";
    svgEl.appendChild(path);
    host.appendChild(svgEl);
    body.appendChild(host);
    try {
      var lo = 0.0;
      var hi = $thiz.a0B;
      var i = 0;
      while ((i < 20)) {
        var mid = (0.5 * (lo + hi));
        var hit = document.elementFromPoint(100.0, (100.0 + mid));
        if (((hit !== null) && Object.is(hit, path))) {
          lo = mid;
        } else {
          hi = mid;
        }
        i = ((1 + i) | 0);
      }
      return ((lo > 0.0) ? ($thiz.a0B / (2.0 * lo)) : 0.0);
    } finally {
      var parent = host.parentNode;
      if ((parent !== null)) {
        parent.removeChild(host);
      }
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$__anchoredOf__Lorg_scalajs_dom_Element__s_Option($thiz, g) {
  var this$1 = $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$__num__Lorg_scalajs_dom_Element__T__s_Option($thiz, g, "data-ax");
  if (this$1.c()) {
    return $m_s_None$();
  } else {
    var x0 = this$1.d();
    var ax = (+x0);
    var this$2 = $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$__num__Lorg_scalajs_dom_Element__T__s_Option($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$(), g, "data-ay");
    if (this$2.c()) {
      return $m_s_None$();
    } else {
      var x0$1 = this$2.d();
      var ay = (+x0$1);
      var this$3 = $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$__num__Lorg_scalajs_dom_Element__T__s_Option($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$(), g, "data-ox");
      if (this$3.c()) {
        return $m_s_None$();
      } else {
        var x0$2 = this$3.d();
        var ox = (+x0$2);
        var this$4 = $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$__num__Lorg_scalajs_dom_Element__T__s_Option($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$(), g, "data-oy");
        if (this$4.c()) {
          return $m_s_None$();
        } else {
          var x0$3 = this$4.d();
          var oy = (+x0$3);
          var this$5 = $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$__num__Lorg_scalajs_dom_Element__T__s_Option($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$(), g, "data-size-px");
          if (this$5.c()) {
            return $m_s_None$();
          } else {
            var x0$4 = this$5.d();
            var size = (+x0$4);
            var this$6 = $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$__num__Lorg_scalajs_dom_Element__T__s_Option($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$(), g, "data-design-box");
            var this$7 = ((this$6.c() || ((+this$6.d()) > 0.0)) ? this$6 : $m_s_None$());
            return (this$7.c() ? $m_s_None$() : new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$Anchored(ax, ay, ox, oy, size, (+this$7.d()))));
          }
        }
      }
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$__num__Lorg_scalajs_dom_Element__T__s_Option($thiz, g, name) {
  var this$1 = $m_s_Option$().as(g.getAttribute(name));
  if (this$1.c()) {
    var $x_1 = $m_s_None$();
  } else {
    var x0 = this$1.d();
    var $x_1 = new $c_s_Some(($m_sc_StringParsers$().c1(x0) ? new $c_s_Some($m_jl_Double$().bd(x0)) : $m_s_None$()));
  }
  return $x_1.WS($m_s_$less$colon$less$().b1);
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$() {
  this.ayp = null;
  this.ayq = null;
  this.ays = null;
  this.ayt = null;
  this.ayu = null;
  this.ayr = null;
  this.a0B = 0.0;
  this.a9O = null;
  $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$ = this;
  this.ayp = ($m_Lcom_raquo_laminar_api_package$().b.j(), new $c_Lcom_raquo_laminar_keys_SvgAttr("data-ax", $m_Lcom_raquo_laminar_codecs_package$().bW, $m_s_None$()));
  this.ayq = ($m_Lcom_raquo_laminar_api_package$().b.j(), new $c_Lcom_raquo_laminar_keys_SvgAttr("data-ay", $m_Lcom_raquo_laminar_codecs_package$().bW, $m_s_None$()));
  this.ays = ($m_Lcom_raquo_laminar_api_package$().b.j(), new $c_Lcom_raquo_laminar_keys_SvgAttr("data-ox", $m_Lcom_raquo_laminar_codecs_package$().bW, $m_s_None$()));
  this.ayt = ($m_Lcom_raquo_laminar_api_package$().b.j(), new $c_Lcom_raquo_laminar_keys_SvgAttr("data-oy", $m_Lcom_raquo_laminar_codecs_package$().bW, $m_s_None$()));
  this.ayu = ($m_Lcom_raquo_laminar_api_package$().b.j(), new $c_Lcom_raquo_laminar_keys_SvgAttr("data-size-px", $m_Lcom_raquo_laminar_codecs_package$().bW, $m_s_None$()));
  this.ayr = ($m_Lcom_raquo_laminar_api_package$().b.j(), new $c_Lcom_raquo_laminar_keys_SvgAttr("data-design-box", $m_Lcom_raquo_laminar_codecs_package$().bW, $m_s_None$()));
  this.a0B = 32.0;
  this.a9O = $m_s_None$();
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$.prototype = $p;
$p.Yg = (function(reference) {
  var this$1 = $m_s_Option$().as(reference.getScreenCTM());
  if (this$1.c()) {
    var this$4 = $m_s_None$();
  } else {
    var x0 = this$1.d();
    var x = (+x0.a);
    var this$4 = new $c_s_Some((+Math.abs(x)));
  }
  var this$5 = ((this$4.c() || ((+this$4.d()) > 0.0)) ? this$4 : $m_s_None$());
  return (this$5.c() ? $m_s_None$() : new $c_s_Some((1.0 / (+this$5.d()))));
});
$p.ah7 = (function() {
  var dpr = (+window.devicePixelRatio);
  var x5 = this.a9O;
  if ((x5 instanceof $c_s_Some)) {
    var x7 = x5.J;
    if ((x7 !== null)) {
      var d = (+x7.g());
      var f = (+x7.h());
      if ((d === dpr)) {
        return f;
      }
    }
  }
  var f$2 = $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$__measuredFactor__D(this);
  if ((f$2 > 0.0)) {
    this.a9O = new $c_s_Some(new $c_T2(dpr, f$2));
  }
  return (+Math.max(f$2, 1.0));
});
$p.a4N = (function(clientPx) {
  return (clientPx * this.ah7());
});
$p.b7C = (function(specifiedPx) {
  return (specifiedPx / this.ah7());
});
$p.ail = (function(a, upp) {
  var x = (a.Cg + (a.Cj * upp));
  var y = (a.Ch + (a.Ck * upp));
  return (((((("translate(" + x) + ", ") + y) + ") scale(") + ((a.Cl / a.Ci) * upp)) + ")");
});
$p.aQm = (function(a, upp) {
  return new $c_sci_$colon$colon($m_Lcom_raquo_laminar_api_package$().b.j().mZ().n(this.ail(a, upp)), new $c_sci_$colon$colon(this.ayp.n(("" + a.Cg)), new $c_sci_$colon$colon(this.ayq.n(("" + a.Ch)), new $c_sci_$colon$colon(this.ays.n(("" + a.Cj)), new $c_sci_$colon$colon(this.ayt.n(("" + a.Ck)), new $c_sci_$colon$colon(this.ayu.n(("" + a.Cl)), new $c_sci_$colon$colon(this.ayr.n(("" + a.Ci)), $m_sci_Nil$())))))));
});
$p.b6G = (function(g, a, upp) {
  g.setAttribute("data-ax", ("" + a.Cg));
  g.setAttribute("data-ay", ("" + a.Ch));
  g.setAttribute("data-ox", ("" + a.Cj));
  g.setAttribute("data-oy", ("" + a.Ck));
  g.setAttribute("data-size-px", ("" + a.Cl));
  g.setAttribute("data-design-box", ("" + a.Ci));
  g.setAttribute("transform", this.ail(a, upp));
});
$p.b7j = (function(svg) {
  this.ahz(svg, "g.gx-expand-badge");
  this.ahz(svg, "g.new-arrow-control");
  this.ahz(svg, "g.edge-endpoint-disk");
});
$p.ahz = (function(root, selector) {
  $m_Lorg_jpablo_graphexplorer_viewer_domUtils_QuerySelector$package$().m3(root, selector).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((g) => {
    var this$1 = $m_s_Option$().as(g.parentNode);
    if ((!this$1.c())) {
      var x0 = this$1.d();
      var this$2 = $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$().Yg(x0);
      if ((!this$2.c())) {
        var x0$1 = this$2.d();
        var upp = (+x0$1);
        var this$3 = $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$__anchoredOf__Lorg_scalajs_dom_Element__s_Option($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$(), g);
        if ((!this$3.c())) {
          var x0$2 = this$3.d();
          g.setAttribute("transform", $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$().ail(x0$2, upp));
        }
      }
    }
  })));
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$, "org.jpablo.graphexplorer.viewer.components.svgCanvas.ScreenConstant$", ({
  zI: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$__px__D__T($thiz, clientPx) {
  return ($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$().a4N(clientPx) + "px");
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$__subjectOf__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_Element($thiz, el) {
  if ((!(!el.classList.contains($m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().xa)))) {
    var this$1 = $m_s_Option$().as(el.nextElementSibling);
    return (this$1.c() ? el : this$1.d());
  } else {
    return el;
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$__casingsOf__Lorg_scalajs_dom_Element__sci_Seq($thiz, el) {
  if ((!(!el.classList.contains($m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().xa)))) {
    return new $c_sci_$colon$colon(el, $m_sci_Nil$());
  } else {
    var inside = $m_Lorg_jpablo_graphexplorer_viewer_domUtils_QuerySelector$package$().m3(el, ("path." + $m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().xa));
    if ((!inside.c())) {
      return inside;
    } else {
      var $x_2 = $m_s_Option$();
      var this$1 = $m_s_Option$().as(el.previousElementSibling);
      if (this$1.c()) {
        var $x_1 = true;
      } else {
        var x0 = this$1.d();
        var $x_1 = (!(!x0.classList.contains($m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().xa)));
      }
      return $x_2.m2(($x_1 ? this$1 : $m_s_None$())).iz();
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$__ownStrokePx__Lorg_scalajs_dom_Element__D__D($thiz, el, upp) {
  var shapeSelector = ((($m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().a0y + ", polygon, ellipse, ") + ("rect:not(." + $m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().a0x)) + "), line, polyline");
  var shape = ((!(!el.matches(shapeSelector))) ? new $c_s_Some(el) : $m_s_Option$().as(el.querySelector(shapeSelector)));
  if (shape.c()) {
    return 1.0;
  } else {
    var x0 = shape.d();
    var cs = window.getComputedStyle(x0);
    var this$2 = cs.strokeWidth;
    var x = this$2.split("px").join("");
    var this$5 = $m_sc_StringParsers$();
    var this$6 = (this$5.c1(x) ? new $c_s_Some($m_jl_Double$().bd(x)) : $m_s_None$());
    var w = (+(this$6.c() ? 1.0 : this$6.d()));
    return ((cs.getPropertyValue("vector-effect") === "non-scaling-stroke") ? $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$().b7C(w) : (w / upp));
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$__setStyle__Lorg_scalajs_dom_Element__T__T__V($thiz, el, prop, value) {
  el.style.setProperty(prop, value);
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$__num__Lorg_scalajs_dom_Element__T__s_Option($thiz, el, name) {
  var this$1 = $m_s_Option$().as(el.getAttribute(name));
  if (this$1.c()) {
    return $m_s_None$();
  } else {
    var x0 = this$1.d();
    return ($m_sc_StringParsers$().c1(x0) ? new $c_s_Some($m_jl_Double$().bd(x0)) : $m_s_None$());
  }
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$() {
  this.ayA = 0.0;
  this.ayz = 0.0;
  this.ayx = 0.0;
  this.ayy = 0.0;
  this.ayB = 0.0;
  this.ayv = 0.0;
  this.ayw = 0.0;
  this.ayC = null;
  this.ayD = null;
  this.ayF = null;
  this.ayE = null;
  this.a9P = null;
  $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$ = this;
  this.ayA = 2.0;
  this.ayz = 7.0;
  this.ayx = $m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().a9K;
  this.ayy = 5.0;
  this.ayB = 1.0;
  this.ayv = 5.0;
  this.ayw = 1.6;
  this.ayC = "--gx-casing-w";
  this.ayD = "--gx-casing-halo";
  this.ayF = "--gx-ring-w";
  this.ayE = "--gx-node-casing-w";
  this.a9P = "data-casing-scale";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$.prototype = $p;
$p.ahy = (function(root, force) {
  var this$1 = $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$().Yg(root);
  if ((!this$1.c())) {
    var x0 = this$1.d();
    var upp = (+x0);
    var key = ((upp + "/") + $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$().ah7());
    if ((force || (root.getAttribute($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$().a9P) !== key))) {
      root.setAttribute($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$().a9P, key);
      $m_Lorg_jpablo_graphexplorer_viewer_domUtils_QuerySelector$package$().m3(root, ".selected").F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((el) => {
        $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$().b8V(el);
      })));
    }
  }
});
$p.b8V = (function(el) {
  var this$1 = $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$().Yg(el);
  if ((!this$1.c())) {
    var x0 = this$1.d();
    var upp = (+x0);
    var ownPx = $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$__ownStrokePx__Lorg_scalajs_dom_Element__D__D($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$(), $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$__subjectOf__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_Element($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$(), el), upp);
    var x = $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$().ayv;
    var y = (ownPx * $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$().ayw);
    var overhang = (+Math.max(x, y));
    var x$1 = $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$().ayz;
    var y$1 = (ownPx + overhang);
    var casingPx = (+Math.max(x$1, y$1));
    $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$__setStyle__Lorg_scalajs_dom_Element__T__T__V($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$(), el, $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$().ayC, $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$__px__D__T($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$(), casingPx));
    $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$__setStyle__Lorg_scalajs_dom_Element__T__T__V($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$(), el, $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$().ayD, $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$__px__D__T($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$(), (casingPx - ownPx)));
    $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$__casingsOf__Lorg_scalajs_dom_Element__sci_Seq($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$(), el).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((c) => {
      $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$__setStyle__Lorg_scalajs_dom_Element__T__T__V($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$(), c, "stroke-width", $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$__px__D__T($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$(), casingPx));
      c.classList.add($m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().a9J);
    })));
    var x$3 = $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$().ayy;
    var x$2 = $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$().ayA;
    var y$2 = (ownPx + $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$().ayB);
    var y$3 = (+Math.max(x$2, y$2));
    var ringPx = (+Math.min(x$3, y$3));
    $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$__setStyle__Lorg_scalajs_dom_Element__T__T__V($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$(), el, $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$().ayF, $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$__px__D__T($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$(), ringPx));
    $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$__setStyle__Lorg_scalajs_dom_Element__T__T__V($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$(), el, $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$().ayE, $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$__px__D__T($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$(), casingPx));
    var out = (((0.5 * ownPx) + (0.5 * casingPx)) * upp);
    $m_Lorg_jpablo_graphexplorer_viewer_domUtils_QuerySelector$package$().m3(el, ((("rect." + $m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().a0x) + ", rect.") + $m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().a0w)).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((r) => {
      var this$10 = $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$__num__Lorg_scalajs_dom_Element__T__s_Option($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$(), r, $m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().zm.bO);
      if ((!this$10.c())) {
        var x0$1 = this$10.d();
        var bx = (+x0$1);
        var this$11 = $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$__num__Lorg_scalajs_dom_Element__T__s_Option($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$(), r, $m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().zm.bs);
        if ((!this$11.c())) {
          var x0$2 = this$11.d();
          var by = (+x0$2);
          var this$12 = $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$__num__Lorg_scalajs_dom_Element__T__s_Option($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$(), r, $m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().zm.ch);
          if ((!this$12.c())) {
            var x0$3 = this$12.d();
            var bw = (+x0$3);
            var this$13 = $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$__num__Lorg_scalajs_dom_Element__T__s_Option($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$(), r, $m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().zm.ca);
            if ((!this$13.c())) {
              var x0$4 = this$13.d();
              var bh = (+x0$4);
              r.setAttribute("x", ("" + (bx - out)));
              r.setAttribute("y", ("" + (by - out)));
              r.setAttribute("width", ("" + (bw + (2.0 * out))));
              r.setAttribute("height", ("" + (bh + (2.0 * out))));
            }
          }
        }
      }
    })));
  }
});
$p.aYk = (function(el) {
  $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$__casingsOf__Lorg_scalajs_dom_Element__sci_Seq(this, el).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((c) => {
    $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$__setStyle__Lorg_scalajs_dom_Element__T__T__V($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$(), c, "stroke-width", $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$__px__D__T($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$(), $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$().ayx));
    c.classList.remove($m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().a9J);
  })));
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$, "org.jpablo.graphexplorer.viewer.components.svgCanvas.SelectionCasing$", ({
  zJ: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionZOrder$() {
  this.M3 = null;
  this.a0C = null;
  $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionZOrder$ = this;
  this.M3 = $m_scm_Map$().aO();
  this.a0C = "gx-raised";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionZOrder$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionZOrder$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionZOrder$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionZOrder$.prototype = $p;
$p.b7k = (function(mainGroup, strategy, selected) {
  this.M3.afM(new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((el, _$1) => (el.parentNode !== null))));
  var wanted = $m_sci_Set$().af($m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().DW(mainGroup, strategy).bw(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((se) => ($f_Lorg_jpablo_graphexplorer_viewer_models_ElementId__isArrowId__Z(se.lj()) && $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().mJ(selected, se.lj()))))).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => _$2.dD()))).bw(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3) => Object.is(_$3.parentNode, mainGroup)))));
  var this$6 = $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(new $c_sc_IterableOps$WithFilter(), $m_sci_Nil$().b6(this.M3), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    if ((x$1 !== null)) {
      var el$1 = x$1.g();
      x$1.h();
      return (!wanted.E(el$1));
    }
    throw new $c_s_MatchError(x$1);
  })));
  var f = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    if ((x$1$2 !== null)) {
      var el$2 = x$1$2.g();
      var before$1 = x$1$2.h();
      try {
        mainGroup.insertBefore(el$2, (before$1.c() ? null : before$1.d()));
      } catch (e) {
        mainGroup.appendChild(el$2);
      }
      el$2.classList.remove($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionZOrder$().a0C);
      return $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionZOrder$().M3.AD(el$2);
    }
    throw new $c_s_MatchError(x$1$2);
  }));
  this$6.qY().F(f);
  var ceiling = $m_s_Option$().as(mainGroup.querySelector("g.gx-badge-layer"));
  var this$8 = $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(new $c_sc_IterableOps$WithFilter(), wanted, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((el$2$1) => (!$m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionZOrder$().M3.E(el$2$1)))));
  var f$1 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((el$3) => {
    $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionZOrder$().M3.cY(el$3, $m_s_Option$().as(el$3.nextSibling));
    el$3.classList.add($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionZOrder$().a0C);
    return mainGroup.insertBefore(el$3, (ceiling.c() ? null : ceiling.d()));
  }));
  this$8.qY().F(f$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionZOrder$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionZOrder$, "org.jpablo.graphexplorer.viewer.components.svgCanvas.SelectionZOrder$", ({
  zK: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionZOrder$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionZOrder$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionZOrder$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionZOrder$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionZOrder$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionZOrder$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SvgCanvas$package$__cellUnderPointer$1__Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Lorg_scalajs_dom_MouseEvent__s_Option($thiz, viewerOps$1, nodeId, ev) {
  return viewerOps$1.du().Wq(nodeId, (+ev.clientX), (+ev.clientY));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SvgCanvas$package$__dropCellAt$1__Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElementStrategy__Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps__Lorg_jpablo_graphexplorer_viewer_utils_ClientPoint__s_Option($thiz, strategy$1, viewerOps$2, end) {
  var this$2 = $m_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$().WO($m_Lorg_jpablo_graphexplorer_viewer_domUtils_DomUtils$package$().a3d(document, end.fi, end.fj), strategy$1, new $c_s_Some(strategy$1.Jc()));
  var this$3 = (this$2.c() ? $m_s_None$() : $f_Lorg_jpablo_graphexplorer_viewer_models_ElementId__asNodeId__s_Option(this$2.d()));
  if (this$3.c()) {
    return $m_s_None$();
  } else {
    var x0$1 = this$3.d();
    var this$4 = viewerOps$2.du().Wq(x0$1, end.fi, end.fj);
    return (this$4.c() ? $m_s_None$() : new $c_s_Some(new $c_T2(x0$1, this$4.d())));
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SvgCanvas$package$__handleElementClick$1__sr_ObjectRef__sr_DoubleRef__D__Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps__Lorg_scalajs_dom_MouseEvent__D__s_Option__Z($thiz, lastClickedElementId$1, lastClickTimestamp$1, doubleClickThreshold$1, viewerOps$4, ev, now, currentElementIdO) {
  if ((!currentElementIdO.c())) {
    var x0 = currentElementIdO.d();
    var isRepeatClick = (lastClickedElementId$1.aD.E(x0) && ((now - lastClickTimestamp$1.T) < doubleClickThreshold$1));
  } else {
    var isRepeatClick = false;
  }
  matchResult2: {
    var handled;
    if ((currentElementIdO instanceof $c_s_Some)) {
      var x8 = currentElementIdO.J;
      if ((x8 instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId)) {
        if (((viewerOps$4.du().agz(x8) && (viewerOps$4.aH().cL().aa() === 1)) && $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().mJ(viewerOps$4.aH().cL(), x8))) {
          var x1 = $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SvgCanvas$package$__cellUnderPointer$1__Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Lorg_scalajs_dom_MouseEvent__s_Option($thiz, viewerOps$4, x8, ev);
          if ((x1 instanceof $c_s_Some)) {
            var path = x1.J;
            ev.preventDefault();
            ev.stopPropagation();
            viewerOps$4.du().pG(x8, path);
            if (isRepeatClick) {
              viewerOps$4.du().b0n(new $c_Lorg_jpablo_graphexplorer_viewer_state_SelectedCell(x8, path));
            }
            var handled = true;
            break matchResult2;
          }
          if (($m_s_None$() === x1)) {
            var handled = false;
            break matchResult2;
          }
          throw new $c_s_MatchError(x1);
        }
      }
      if (isRepeatClick) {
        ev.preventDefault();
        ev.stopPropagation();
        viewerOps$4.aH().rd($m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_ElementId.r().C)([x8]))));
        viewerOps$4.aH().afp();
        var handled = true;
        break matchResult2;
      }
    }
    var handled = false;
  }
  matchResult3: {
    if ((currentElementIdO instanceof $c_s_Some)) {
      var id$2 = currentElementIdO.J;
      if ((!(handled && isRepeatClick))) {
        lastClickTimestamp$1.T = now;
        lastClickedElementId$1.aD = new $c_s_Some(id$2);
        break matchResult3;
      }
    }
    lastClickTimestamp$1.T = 0.0;
    lastClickedElementId$1.aD = $m_s_None$();
  }
  return handled;
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SvgCanvas$package$__refreshOverlayControls$1__Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps__Lorg_scalajs_dom_SVGGElement__sci_Map__s_Option__Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction__V($thiz, viewerOps$5, mainGroup$1, edgePositions$1, elem, action) {
  $f_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_AddNewArrowOps__handleNewArrowControls__Lorg_scalajs_dom_SVGGElement__s_Option__Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction__V(viewerOps$5, mainGroup$1, elem, action);
  $f_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MoveArrowEndpointOps__handleArrowEndpointControl__Lorg_scalajs_dom_SVGGElement__s_Option__Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction__sci_Map__V(viewerOps$5, mainGroup$1, elem, action, edgePositions$1);
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SvgCanvas$package$__refitChrome$1__Lcom_raquo_laminar_nodes_ReactiveSvgElement__Lorg_scalajs_dom_SVGGElement__V($thiz, rawSvg$2, mainGroup$2) {
  $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$().b7j(rawSvg$2.e8);
  $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$().ahy(mainGroup$2, ($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$(), false));
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SvgCanvas$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SvgCanvas$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SvgCanvas$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SvgCanvas$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SvgCanvas$package$.prototype = $p;
$p.aWj = (function(rawSvg, transform, viewerOps, mouseAction, edgePositions, strategy, concealedCounts, onToggleConcealed, collapsedCounts, onToggleCollapsed, onCollapseGroup, onRendered) {
  var mainGroup = $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasRoot$().aQ5(rawSvg.e8);
  var tr = $m_Lorg_jpablo_graphexplorer_viewer_domUtils_SvgUtils$().b2c(mainGroup);
  var viewBox = rawSvg.e8.viewBox.baseVal;
  var bbox = new $c_Lorg_jpablo_graphexplorer_viewer_utils_BBox((((+viewBox.x) - tr.gI) + 0.4), (((+viewBox.y) - tr.gJ) + (-0.4)), (+viewBox.width), (+viewBox.height));
  var lastClickTimestamp = new $c_sr_DoubleRef(0.0);
  var lastClickedElementId = new $c_sr_ObjectRef($m_s_None$());
  var selectionElementChanges = new $c_Lcom_raquo_airstream_misc_MapStream($f_Lcom_raquo_airstream_core_EventStream__dropWhile__F1__Z__Lcom_raquo_airstream_core_EventStream(viewerOps.aH().aFC, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((groups) => (groups.h().aS.c() && groups.g().aS.c()))), (viewerOps.aH(), false)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((groups$2) => {
    var elems = groups$2.g().aS;
    var $x_1 = $m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().Ed(rawSvg.e8, elems, strategy);
    var elems$1 = groups$2.h().aS;
    return new $c_T2($x_1, $m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().Ed(rawSvg.e8, elems$1, strategy));
  })), $m_s_None$());
  var singleSelection = $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), viewerOps.aH().ne, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((selected) => {
    var selected$1 = ((selected === null) ? null : selected.aS);
    return ((selected$1.aa() === 1) ? $m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().Ed(rawSvg.e8, selected$1, strategy).dt() : $m_s_None$());
  })), $m_s_None$());
  var allSelectable = $m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().DW(rawSvg.e8, strategy);
  $m_Lcom_raquo_laminar_api_package$();
  var layoutSettled = new $c_Lcom_raquo_airstream_eventbus_EventBus();
  var $x_14 = $m_sr_ScalaRunTime$();
  var $x_13 = $m_Lcom_raquo_laminar_api_package$().b;
  var $x_12 = $m_sci_Seq$();
  var $x_11 = $m_sr_ScalaRunTime$();
  var $x_10 = $m_Lcom_raquo_laminar_api_package$().b.j().bK().n(((((((bbox.xt + " ") + bbox.vu) + " ") + bbox.zP) + " ") + bbox.zO));
  var $x_9 = $m_Lcom_raquo_laminar_api_package$().b.j().bh().n(null);
  var $x_8 = $m_Lcom_raquo_laminar_api_package$().b.j().bg().n(null);
  var $x_7 = $m_Lcom_raquo_laminar_api_package$().b.j().a6n.s("graphviz");
  $m_Lcom_raquo_laminar_api_package$();
  var $x_6 = $m_Lcom_raquo_laminar_api_Implicits$RichSource$().ft(transform, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((tr$2) => {
    mainGroup.setAttribute($m_Lcom_raquo_laminar_api_package$().b.j().mZ().QP, tr$2);
    $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SvgCanvas$package$__refitChrome$1__Lcom_raquo_laminar_nodes_ReactiveSvgElement__Lorg_scalajs_dom_SVGGElement__V(this, rawSvg, mainGroup);
  })));
  $m_Lcom_raquo_laminar_api_package$();
  var $x_5 = $m_Lcom_raquo_laminar_api_Implicits$RichSource$().ft($f_Lcom_raquo_laminar_api_Laminar__windowEvents__F1__Lcom_raquo_airstream_core_EventStream($m_Lcom_raquo_laminar_api_package$().b, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$8) => {
    $m_Lcom_raquo_laminar_api_package$();
    return $m_Lcom_raquo_laminar_keys_EventProcessor$().az(_$8.ahf(), false, false);
  }))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$9) => {
    $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SvgCanvas$package$__refitChrome$1__Lcom_raquo_laminar_nodes_ReactiveSvgElement__Lorg_scalajs_dom_SVGGElement__V(this, rawSvg, mainGroup);
  })));
  var $x_4 = $f_Lcom_raquo_laminar_api_MountHooks__onMountCallback__F1__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$10) => {
    rawSvg.e8.addEventListener($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$().a9M, ((_$11) => {
      layoutSettled.dn.bA((void 0));
    }));
    $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$().aZH(mainGroup, strategy, concealedCounts, onToggleConcealed, collapsedCounts, onToggleCollapsed, onCollapseGroup);
    $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CountBadges$().b2Z(mainGroup, strategy);
    onRendered.i(rawSvg.e8);
  })));
  var $x_3 = new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.Av(), false, false)).pt(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e) => $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasContainer$package$().aPH(e)))).E9(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((ev) => new $c_T2(ev, $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasContainer$package$().aeY(ev))))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    matchResult4: {
      if ((x$1 !== null)) {
        var x15 = x$1.h();
        var ev$1 = x$1.g();
        if ((x15 !== null)) {
          var pos = x15.g();
          var shift = (!(!x15.h()));
          if ((!$p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SvgCanvas$package$__handleElementClick$1__sr_ObjectRef__sr_DoubleRef__D__Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps__Lorg_scalajs_dom_MouseEvent__D__s_Option__Z(this, lastClickedElementId, lastClickTimestamp, 300.0, viewerOps, ev$1, (+Date.now()), $m_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$().WO([ev$1.target], strategy, $m_s_None$())))) {
            var mouseAction$1 = new $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$ExtendSelectionAction(new $c_Lorg_jpablo_graphexplorer_viewer_utils_MouseActionRect(pos, pos, shift));
            $f_Lcom_raquo_airstream_state_Var__set__O__V(mouseAction.zN, mouseAction$1);
            break matchResult4;
          } else {
            break matchResult4;
          }
        }
      }
      throw new $c_s_MatchError(x$1);
    }
  })));
  var $x_2 = new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.a4i(), false, false)).pt(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$2) => $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasContainer$package$().b43(e$2)))).E9(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$3) => $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasContainer$package$().aeY(e$3)))), $f_F2__tupled__F1(new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((v1, v2) => {
    var shift$1 = (!(!v2));
    mouseAction.baV(v1, shift$1);
  }))));
  var this$32 = new $c_Lcom_raquo_laminar_keys_LockedEventKey(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.a4j(), false, false)).pt(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$4) => $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasContainer$package$().aPH(e$4)))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$12) => {
    $m_Lcom_raquo_airstream_core_EventStream$();
    return $m_Lcom_raquo_airstream_combine_generated_CombinableStream$().aTt(_$12, mouseAction.Hc, new $c_Lapp_tulz_tuplez_Composition\uff3fPri0$$anon$1());
  })));
  var onNext$2 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    var ev$2 = x$1$2.g();
    var previousAction = x$1$2.h();
    $f_Lcom_raquo_airstream_state_Var__set__O__V(mouseAction.zN, $s_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$__Inactive__Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction());
    if ((previousAction instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$AddNewArrowAction)) {
      $f_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_AddNewArrowOps__handleAddNewArrowMouseUp__Lorg_scalajs_dom_MouseEvent__Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$AddNewArrowAction__V(viewerOps, ev$2, previousAction);
    } else if ((previousAction instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$MoveArrowEndpointAction)) {
      $f_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MoveArrowEndpointOps__handleMoveArrowStartMouseUp__Lorg_scalajs_dom_MouseEvent__Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$MoveArrowEndpointAction__V(viewerOps, ev$2, previousAction);
    }
  }));
  return $f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement(rawSvg, $x_14.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($x_13, $x_12.kM($x_11.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_10, $x_9, $x_8, $x_7, $x_6, $x_5, $x_4, $x_3, $x_2, this$32.Iv($m_Lcom_raquo_airstream_core_Observer$().wo(onNext$2, $m_s_PartialFunction$().gt, true)), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_api_Implicits$RichSource$().ft($m_Lcom_raquo_airstream_combine_generated_CombinableSignal$().vV(singleSelection, mouseAction.Hc, new $c_Lapp_tulz_tuplez_Composition\uff3fPri0$$anon$1()), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3) => {
    $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SvgCanvas$package$__refreshOverlayControls$1__Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps__Lorg_scalajs_dom_SVGGElement__sci_Map__s_Option__Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction__V(this, viewerOps, mainGroup, edgePositions, x$1$3.g(), x$1$3.h());
  })))), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_api_Implicits$RichSource$().ft(($m_Lcom_raquo_airstream_core_EventStream$(), $m_Lcom_raquo_airstream_combine_generated_CombinableStream$().XV(layoutSettled.k5, $m_Lcom_raquo_airstream_combine_generated_CombinableSignal$().vV(singleSelection, mouseAction.Hc, new $c_Lapp_tulz_tuplez_Composition\uff3fPri0$$anon$1()))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$4) => {
    $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SvgCanvas$package$__refreshOverlayControls$1__Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps__Lorg_scalajs_dom_SVGGElement__sci_Map__s_Option__Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction__V(this, viewerOps, mainGroup, edgePositions, x$1$4.g(), x$1$4.h());
    $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SvgCanvas$package$__refitChrome$1__Lcom_raquo_laminar_nodes_ReactiveSvgElement__Lorg_scalajs_dom_SVGGElement__V(this, rawSvg, mainGroup);
  })))), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_api_Implicits$RichSource$().ft($f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable(viewerOps.gs.P()), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((cellOpt) => {
    $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_RecordCellOverlay$().aRq(mainGroup, strategy, cellOpt, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((nodeId) => viewerOps.du().DO(nodeId))));
  })))), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_api_Implicits$RichSource$().ft(($m_Lcom_raquo_airstream_core_EventStream$(), $m_Lcom_raquo_airstream_combine_generated_CombinableStream$().XV(layoutSettled.k5, viewerOps.gs.P())), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((cellOpt$2) => {
    $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_RecordCellOverlay$().aRq(mainGroup, strategy, cellOpt$2, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((nodeId$1) => viewerOps.du().DO(nodeId$1))));
  })))), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_api_Implicits$RichSource$().ft(viewerOps.aH().ne, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1$2) => {
    var sel = ((v1$2 === null) ? null : v1$2.aS);
    viewerOps.du().b6X(sel);
    $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionZOrder$().b7k(mainGroup, strategy, sel);
  })))), $f_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ExtendSelectionOps__SelectionRect__F0__Lcom_raquo_laminar_nodes_ReactiveSvgElement(viewerOps, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => rawSvg.e8.getScreenCTM()))), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_api_Implicits$RichSource$().ft(mouseAction.Hc, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((action$2) => {
    $f_sc_IterableOnceOps__foreach__F1__V(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(mainGroup.querySelectorAll("g#dragging-arrow-group")), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$13) => {
      _$13.remove();
    })));
    matchResult6: {
      if ((action$2 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$AddNewArrowAction)) {
        if ((!action$2.ts.c())) {
          $f_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_AddNewArrowOps__addArrowFromSourceToPointer__Lorg_scalajs_dom_SVGGElement__Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$AddNewArrowAction__V(viewerOps, mainGroup, action$2);
          break matchResult6;
        }
      }
      if ((action$2 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$MoveArrowEndpointAction)) {
        if ((!action$2.tt.c())) {
          $f_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MoveArrowEndpointOps__addArrowBetweenPointerAndEndpoint__Lorg_scalajs_dom_SVGGElement__Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$MoveArrowEndpointAction__V(viewerOps, mainGroup, action$2);
          break matchResult6;
        }
      }
    }
    var $x_16 = $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_RecordCellOverlay$();
    matchResult7$1: {
      var $x_15;
      if ((action$2 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$AddNewArrowAction)) {
        if ((!action$2.ts.c())) {
          var $x_15 = $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SvgCanvas$package$__dropCellAt$1__Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElementStrategy__Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps__Lorg_jpablo_graphexplorer_viewer_utils_ClientPoint__s_Option(this, strategy, viewerOps, action$2.ts.jK);
          break matchResult7$1;
        }
      }
      if ((action$2 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$MoveArrowEndpointAction)) {
        if ((!action$2.tt.c())) {
          var $x_15 = $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SvgCanvas$package$__dropCellAt$1__Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElementStrategy__Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps__Lorg_jpablo_graphexplorer_viewer_utils_ClientPoint__s_Option(this, strategy, viewerOps, action$2.tt.jK);
          break matchResult7$1;
        }
      }
      var $x_15 = $m_s_None$();
    }
    $x_16.b7m(mainGroup, strategy, $x_15, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((nodeId$2) => viewerOps.du().DO(nodeId$2))));
  })))), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_api_Implicits$RichSource$().ft(mouseAction.Hc, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$5) => {
    if ((x$1$5 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$ExtendSelectionAction)) {
      $f_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ExtendSelectionOps__onExtendSelectionAction__sci_Seq__Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$ExtendSelectionAction__V(viewerOps, allSelectable, x$1$5);
    } else if ((x$1$5 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$AddNewArrowAction)) {
      $f_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_AddNewArrowOps__onAddNewArrowAction__Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$AddNewArrowAction__V(viewerOps, x$1$5);
    } else if ((x$1$5 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$MoveArrowEndpointAction)) {
      $f_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MoveArrowEndpointOps__onMoveArrowSourceAction__Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$MoveArrowEndpointAction__V(viewerOps, x$1$5);
    }
  })))), $f_Lcom_raquo_laminar_api_MountHooks__onMountCallback__F1__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((ctx) => {
    var elems$2 = viewerOps.aH().cL();
    $m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().Ed(rawSvg.e8, elems$2, strategy).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$14) => {
      _$14.a4E();
    })));
    $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$().ahy(mainGroup, true);
  }))), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_api_Implicits$RichSource$().ft(selectionElementChanges, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((groups$3) => {
    groups$3.g().F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$1) => {
      e$1.aio();
      $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$().aYk(e$1.dD());
    })));
    groups$3.h().F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$15) => {
      _$15.a4E();
    })));
    $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SelectionCasing$().ahy(mainGroup, true);
    window.requestAnimationFrame(((_$16) => ((!$m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SvgCanvas$package$().b3q()) ? (viewerOps.CE.dn.bA(true), (void 0)) : (void 0))));
  }))))]))), $m_s_$less$colon$less$().b1, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())])));
});
$p.b3q = (function() {
  var this$1 = $m_s_Option$().as(document.activeElement);
  if ((!this$1.c())) {
    var x0 = this$1.d();
    var this$2 = x0.tagName;
    var tag = this$2.toUpperCase();
    return ((((tag === "INPUT") || (tag === "TEXTAREA")) || (!(!x0.isContentEditable))) || (x0.closest(".cm-editor") !== null));
  } else {
    return false;
  }
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SvgCanvas$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SvgCanvas$package$, "org.jpablo.graphexplorer.viewer.components.svgCanvas.SvgCanvas$package$", ({
  zL: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SvgCanvas$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SvgCanvas$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SvgCanvas$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SvgCanvas$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SvgCanvas$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SvgCanvas$package$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopBridge$__recordedSession__Lorg_jpablo_graphexplorer_viewer_desktop_DesktopBridge$DesktopMessage__s_Option($thiz, message) {
  var this$1 = message.M4;
  if (this$1.c()) {
    return $m_s_None$();
  } else {
    var x0 = this$1.d();
    var this$2 = message.M5;
    if (this$2.c()) {
      return $m_s_None$();
    } else {
      var x0$1 = this$2.d();
      var previous = $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$().afP(x0);
      return new $c_s_Some(new $c_T2($m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$().aRn(x0, x0$1, message.M6).vk, previous));
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopBridge$__asString$1__sjs_js_Any__s_Option($thiz, value) {
  return (((value === (void 0)) || (value === null)) ? $m_s_None$() : (((typeof value) === "string") ? new $c_s_Some(value) : $m_s_None$()));
}
function $p_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopBridge$__field$1__sjs_js_Any__T__sjs_js_Any($thiz, value, name) {
  return (((value === (void 0)) || (value === null)) ? (void 0) : value[name]);
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopBridge$() {
  this.aUs = null;
  this.a9Q = false;
  this.aUs = "ge:document.changed";
  this.a9Q = false;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopBridge$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopBridge$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopBridge$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopBridge$.prototype = $p;
$p.a3O = (function() {
  if ((!this.a9Q)) {
    var handler = ((event) => {
      var this$1 = $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopBridge$().b15(event);
      if ((!this$1.c())) {
        $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopBridge$().b80(this$1.d());
      }
    });
    window.addEventListener("ge:document.changed", handler);
    this.a9Q = true;
    console.info("Desktop bridge listener installed.");
  }
});
$p.b15 = (function(event) {
  var detailValue = event.detail;
  var payloadValue = event.payload;
  var payloadText = $p_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopBridge$__asString$1__sjs_js_Any__s_Option(this, $p_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopBridge$__field$1__sjs_js_Any__T__sjs_js_Any(this, payloadValue, "text"));
  var detailText = $p_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopBridge$__asString$1__sjs_js_Any__s_Option(this, $p_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopBridge$__field$1__sjs_js_Any__T__sjs_js_Any(this, detailValue, "text"));
  var directPayload = $p_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopBridge$__asString$1__sjs_js_Any__s_Option(this, payloadValue);
  var detailPayload = $p_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopBridge$__asString$1__sjs_js_Any__s_Option(this, detailValue);
  var this$1 = (payloadText.c() ? detailText : payloadText);
  var this$2 = (this$1.c() ? directPayload : this$1);
  var text = (this$2.c() ? detailPayload : this$2);
  if (text.c()) {
    return $m_s_None$();
  } else {
    var x0 = text.d();
    var this$3 = $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$().vU(detailValue, "path");
    var path = (this$3.c() ? $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$().vU(payloadValue, "path") : this$3);
    var this$4 = $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$().vU(detailValue, "revision");
    return new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopBridge$DesktopMessage(x0, path, (this$4.c() ? $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$().vU(payloadValue, "revision") : this$4)));
  }
});
$p.b80 = (function(message) {
  var this$1 = message.M4;
  var x5 = ((this$1.c() || (!$m_Lorg_jpablo_graphexplorer_projects_Library$().XP(this$1.d()).c())) ? this$1 : $m_s_None$());
  if ((x5 instanceof $c_s_Some)) {
    var path = x5.J;
    var $x_2 = $m_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$();
    var $x_1 = message.M6;
    var this$3 = message.M5;
    $x_2.b7g(path, $x_1, (this$3.c() ? "" : this$3.d()), $m_s_concurrent_ExecutionContext$().ek());
    return (void 0);
  }
  if (($m_s_None$() === x5)) {
    $p_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopBridge$__recordedSession__Lorg_jpablo_graphexplorer_viewer_desktop_DesktopBridge$DesktopMessage__s_Option(this, message);
    return (void 0);
  }
  throw new $c_s_MatchError(x5);
});
var $d_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopBridge$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopBridge$, "org.jpablo.graphexplorer.viewer.desktop.DesktopBridge$", ({
  zM: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopBridge$;
function $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopBridge$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopBridge$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopBridge$ = new $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopBridge$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopBridge$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopClose$__report__Z__s_concurrent_ExecutionContext__V($thiz, unsaved, x$2) {
  $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$().u7("set_unsaved", $m_sjs_js_special_package$().eA($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("unsaved", unsaved)])))).IT().oB(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4) => (void 0))), x$2);
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopClose$() {
  this.aUt = null;
  this.aUv = null;
  this.aUu = null;
  this.T9 = null;
  this.a9R = null;
  $n_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopClose$ = this;
  this.aUt = "ge:close.requested";
  this.aUv = "set_unsaved";
  this.aUu = "confirm_close";
  this.T9 = $m_s_None$();
  this.a9R = $m_s_None$();
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopClose$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopClose$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopClose$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopClose$.prototype = $p;
$p.b2X = (function(state, x$2, x$3) {
  this.T9 = new $c_s_Some(state);
  $f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription(state.b05(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => {
    $p_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopClose$__report__Z__s_concurrent_ExecutionContext__V($m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopClose$(), (!(!v1)), x$3);
  })), x$2);
  if (this.a9R.c()) {
    var handler = ((_$2) => {
      matchResult1: {
        var x1 = $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopClose$().T9;
        if ((x1 instanceof $c_s_Some)) {
          var current = x1.J;
          if ($f_Lorg_jpablo_graphexplorer_viewer_state_Persistence__documentIsDirty__Z(current)) {
            $f_Lcom_raquo_airstream_state_Var__set__O__V(current.xs, new $c_s_Some($s_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent$__CloseWindow__Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent()));
            break matchResult1;
          }
        }
        $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopClose$().aMZ(x$3);
      }
    });
    window.addEventListener("ge:close.requested", handler);
    this.a9R = new $c_s_Some(handler);
  }
});
$p.aZR = (function(state, x$2) {
  var this$1 = this.T9;
  if (((!this$1.c()) && (this$1.d() === state))) {
    this.T9 = $m_s_None$();
    $p_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopClose$__report__Z__s_concurrent_ExecutionContext__V(this, false, x$2);
  }
});
$p.aMZ = (function(x$1) {
  $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$().u7("confirm_close", $m_sjs_js_special_package$().eA($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([])))).IT().oB(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((error) => {
    console.warn(("could not close the window: " + error.e3()));
  })), x$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopClose$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopClose$, "org.jpablo.graphexplorer.viewer.desktop.DesktopClose$", ({
  zN: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopClose$;
function $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopClose$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopClose$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopClose$ = new $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopClose$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopClose$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$() {
  this.Gw = null;
  $n_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$ = this;
  this.Gw = $m_Lcom_raquo_airstream_state_Var$().bx($m_sci_Map$EmptyMap$());
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$.prototype = $p;
$p.IY = (function(id) {
  return this.Gw.P().aq().d().r(id);
});
$p.b8S = (function(id) {
  return $f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), this.Gw.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => _$2.r(id))), $m_s_None$()));
});
$p.afP = (function(path) {
  return this.Gw.P().aq().d().e6().iW(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3) => (_$3.vl === path))));
});
$p.aRn = (function(path, revision, sourceText) {
  matchResult7: {
    var session;
    var x9 = this.afP(path);
    if ((x9 instanceof $c_s_Some)) {
      var existing = x9.J;
      var conflict$1 = $m_s_None$();
      var session = new $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$Session(existing.vk, existing.vl, revision, sourceText, conflict$1);
      break matchResult7;
    }
    if (($m_s_None$() === x9)) {
      var session = new $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$Session($m_Lorg_jpablo_graphexplorer_viewer_state_DocumentSessionId$().b77(), path, revision, sourceText, $m_s_None$());
      break matchResult7;
    }
    throw new $c_s_MatchError(x9);
  }
  $f_Lcom_raquo_airstream_state_Var__update__F1__V(this.Gw, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4) => _$4.bN(session.vk, session))));
  return session;
});
$p.b4k = (function(id, revision, text) {
  $f_Lcom_raquo_airstream_state_Var__update__F1__V(this.Gw, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$5) => _$5.Q8(id, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6) => {
    if (_$6.c()) {
      return $m_s_None$();
    } else {
      var x0 = _$6.d();
      var conflict$2 = new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$Conflict(revision, text));
      return new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$Session(x0.vk, x0.vl, x0.Cm, x0.tj, conflict$2));
    }
  }))))));
});
$p.aWv = (function(id) {
  var this$1 = this.IY(id);
  var this$2 = (this$1.c() ? $m_s_None$() : this$1.d().Gy);
  if (this$2.c()) {
    return $m_s_None$();
  } else {
    var x0$1 = this$2.d();
    var \u03b41$ = $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$().IY(id).d();
    var conflict$3 = $m_s_None$();
    var resolved = new $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$Session(\u03b41$.vk, \u03b41$.vl, x0$1.Ta, x0$1.Gx, conflict$3);
    $f_Lcom_raquo_airstream_state_Var__update__F1__V($m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$().Gw, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$9) => _$9.bN(id, resolved))));
    return new $c_s_Some(resolved);
  }
});
var $d_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$, "org.jpablo.graphexplorer.viewer.desktop.DesktopDocumentRegistry$", ({
  zO: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$;
function $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$ = new $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$__invoker__s_Option($thiz) {
  var this$1 = $p_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$__child$1__sjs_js_Dynamic__T__s_Option($thiz, window, "__TAURI__");
  if (this$1.c()) {
    return $m_s_None$();
  } else {
    var x0 = this$1.d();
    var this$2 = $p_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$__child$1__sjs_js_Dynamic__T__s_Option($thiz, x0, "core");
    if (this$2.c()) {
      return $m_s_None$();
    } else {
      var x0$1 = this$2.d();
      var this$4 = new $c_s_Option$WithFilter($p_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$__child$1__sjs_js_Dynamic__T__s_Option($thiz, x0$1, "invoke"), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((invoke) => ((typeof invoke) === "function"))));
      var this$5 = this$4.tu;
      var p$1 = this$4.tv;
      var this$6 = ((this$5.c() || (!(!p$1.i(this$5.d())))) ? this$5 : $m_s_None$());
      return (this$6.c() ? $m_s_None$() : new $c_s_Some(this$6.d()));
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$__failureOutcome__jl_Throwable__Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome($thiz, error) {
  var rejection = ((error instanceof $c_sjs_js_JavaScriptException) ? error.bf : error.e3());
  if ((((typeof rejection) === "object") && (rejection !== null))) {
    var x27 = $thiz.vU(rejection, "code");
    if (((x27 instanceof $c_s_Some) && (x27.J === "DOCUMENT_CONFLICT"))) {
      return new $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$Conflict($thiz.vU(rejection, "currentRevision"));
    }
    var this$3 = $thiz.vU(rejection, "message");
    return new $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$Failed((this$3.c() ? ("" + rejection) : this$3.d()));
  } else {
    return new $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$Failed(("" + rejection));
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$__field__sjs_js_Any__T__s_Option($thiz, value, name) {
  if (((value === (void 0)) || (value === null))) {
    return $m_s_None$();
  } else {
    var selected = value[name];
    return (((selected === (void 0)) || (selected === null)) ? $m_s_None$() : new $c_s_Some(selected));
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$__child$1__sjs_js_Dynamic__T__s_Option($thiz, parent, name) {
  var value = parent[name];
  return (((value === (void 0)) || (value === null)) ? $m_s_None$() : new $c_s_Some(value));
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$() {
  this.aUx = null;
  this.aUy = null;
  this.aUw = null;
  this.aUx = "open_document";
  this.aUy = "save_document";
  this.aUw = "hash_text";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$.prototype = $p;
$p.u7 = (function(command, args) {
  var x14 = $p_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$__invoker__s_Option(this);
  if ((x14 instanceof $c_s_Some)) {
    var fn = x14.J;
    return $m_sjs_js_Thenable$ThenableOps$().a50(fn(command, args));
  }
  if (($m_s_None$() === x14)) {
    return $m_s_concurrent_Future$().WL(new $c_sjs_js_JavaScriptException("desktop IPC is unavailable"));
  }
  throw new $c_s_MatchError(x14);
});
$p.b5j = (function(path, x$2) {
  return ((!(!$p_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$__invoker__s_Option(this).c())) ? $m_s_concurrent_Future$().aIV : this.u7("open_document", $m_sjs_js_special_package$().eA($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("path", path)])))).jX(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => (void 0))), x$2).AC(new $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$$anon$2(path), x$2));
});
$p.aRP = (function(path, text, baseRevision, x$4) {
  return ((!(!$p_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$__invoker__s_Option(this).c())) ? $m_s_concurrent_Future$().m4($s_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$__Unavailable__Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome()) : this.u7("save_document", $m_sjs_js_special_package$().eA($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("path", path), new $c_T2("text", text), new $c_T2("baseRevision", baseRevision)])))).aij(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    if ((x$1 instanceof $c_s_util_Success)) {
      var value = x$1.fM;
      var this$9 = $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$().vU(value, "path");
      var $x_1 = (this$9.c() ? path : this$9.d());
      var this$10 = $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$().vU(value, "revision");
      return new $c_s_util_Success(new $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$Saved($x_1, (this$10.c() ? baseRevision : this$10.d())));
    }
    if ((x$1 instanceof $c_s_util_Failure)) {
      return new $c_s_util_Success($p_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$__failureOutcome__jl_Throwable__Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome($m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$(), x$1.le));
    }
    throw new $c_s_MatchError(x$1);
  })), x$4));
});
$p.b2w = (function(storedText, x$2) {
  return ((!(!$p_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$__invoker__s_Option(this).c())) ? $m_s_concurrent_Future$().WL($m_Lorg_jpablo_graphexplorer_viewer_desktop_IpcUnavailable$()) : this.u7("hash_text", $m_sjs_js_special_package$().eA($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("text", storedText)])))).jX(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((value) => {
    if (((typeof value) === "string")) {
      return value.toLowerCase();
    } else {
      throw $m_Lorg_jpablo_graphexplorer_viewer_desktop_IpcUnavailable$();
    }
  })), x$2));
});
$p.vU = (function(value, name) {
  var this$1 = $p_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$__field__sjs_js_Any__T__s_Option(this, value, name);
  var pf = new $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$$anon$3();
  return ((!this$1.c()) ? new $c_s_PartialFunction$Lifted(pf).as(this$1.d()) : $m_s_None$());
});
$p.aXI = (function(value, name) {
  var this$1 = $p_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$__field__sjs_js_Any__T__s_Option(this, value, name);
  var pf = new $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$$anon$4();
  return ((!this$1.c()) ? new $c_s_PartialFunction$Lifted(pf).as(this$1.d()) : $m_s_None$());
});
var $d_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$, "org.jpablo.graphexplorer.viewer.desktop.DesktopIpc$", ({
  zP: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$;
function $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$ = new $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$__settlePending__s_concurrent_ExecutionContext__V($thiz, x$1) {
  var this$1 = $thiz.Td;
  if ((!this$1.c())) {
    var x0 = this$1.d();
    var this$2 = $thiz.xc;
    $m_sci_Vector$().X(this$2).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((state$2) => ((x$1$1) => {
      var $x_1 = $uJ(x$1$1.g());
      var requestId_$_lo = $x_1.l;
      var requestId_$_hi = $x_1.h;
      var request = x$1$1.h();
      matchResult5: {
        var x14 = $thiz.aWx(request.Tk, state$2.lI, state$2.abj.P().aq().d());
        var x = $s_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$__Waiting__Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation();
        if (((x === null) ? (x14 === null) : x.e(x14))) {
          break matchResult5;
        }
        var x$3 = $s_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$__Displayed__Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation();
        if (((x$3 === null) ? (x14 === null) : x$3.e(x14))) {
          $thiz.xc = $thiz.xc.fz($bL(requestId_$_lo, requestId_$_hi));
          $p_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$__complete__J__T__s_Option__s_Option__s_Option__s_concurrent_ExecutionContext__V($thiz, requestId_$_lo, requestId_$_hi, "displayed", $m_s_None$(), $m_s_None$(), new $c_s_Some(request.Tl), x$1);
          break matchResult5;
        }
        if ((x14 instanceof $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$Rejected)) {
          var x17 = x14.Te;
          var x18 = x14.Tf;
          $thiz.xc = $thiz.xc.fz($bL(requestId_$_lo, requestId_$_hi));
          $p_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$__complete__J__T__s_Option__s_Option__s_Option__s_concurrent_ExecutionContext__V($thiz, requestId_$_lo, requestId_$_hi, "rejected", new $c_s_Some(x17), new $c_s_Some(x18), $m_s_None$(), x$1);
          break matchResult5;
        }
        throw new $c_s_MatchError(x14);
      }
    }))(x0)));
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$__complete__J__T__s_Option__s_Option__s_Option__s_concurrent_ExecutionContext__V($thiz, requestId_$_lo, requestId_$_hi, status, code, message, view, x$6) {
  var args = $m_sjs_js_special_package$().eA($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("requestId", ((4.294967296E9 * requestId_$_hi) + (requestId_$_lo >>> 0.0))), new $c_T2("status", status)])));
  if ((!code.c())) {
    var x0 = code.d();
    args.code = x0;
  }
  if ((!message.c())) {
    var x0$1 = message.d();
    args.message = x0$1;
  }
  if ((!view.c())) {
    var x0$2 = view.d();
    args.view = x0$2;
  }
  $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$().u7($thiz.ayH, args).IT().oB(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((error) => {
    console.warn(("could not acknowledge an open request: " + error.e3()));
  })), x$6);
}
function $p_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$__field$1__sjs_js_Dynamic__T__s_Option($thiz, target$1, name) {
  var this$1 = $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$().vU(target$1, name);
  var this$2 = (this$1.c() ? $m_s_None$() : new $c_s_Some($f_T__trim__T(this$1.d())));
  return ((this$2.c() || (this$2.d() !== "")) ? this$2 : $m_s_None$());
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$() {
  this.ayI = null;
  this.a9T = false;
  this.Td = null;
  this.xc = null;
  this.ayJ = null;
  this.ayH = null;
  $n_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$ = this;
  this.ayI = "ge:open.requested";
  this.a9T = false;
  this.Td = $m_s_None$();
  this.xc = $m_sci_Map$EmptyMap$();
  this.ayJ = "viewer_ready";
  this.ayH = "complete_open";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$.prototype = $p;
$p.b2Y = (function(navigate, exists, x$3) {
  if ((!this.a9T)) {
    var handler = ((event) => {
      var requestId = $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$().aXI(event.detail, "requestId");
      matchResult4: {
        var x5 = this.aZA(event, exists);
        if ((x5 instanceof $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Decision$Show)) {
          var x12 = x5.Ti;
          var x13 = x5.Tj;
          if ((!requestId.c())) {
            var x0 = requestId.d();
            var $x_1 = $uJ(x0);
            var id_$_lo = $x_1.l;
            var id_$_hi = $x_1.h;
            $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$().xc = $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$().xc.bN($bL(id_$_lo, id_$_hi), new $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Pending(x12, x13));
          }
          if ((!(!navigate.i(x12)))) {
            $p_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$__settlePending__s_concurrent_ExecutionContext__V(this, x$3);
            break matchResult4;
          } else if ((!requestId.c())) {
            var x0$1 = requestId.d();
            var $x_2 = $uJ(x0$1);
            var id$1_$_lo = $x_2.l;
            var id$1_$_hi = $x_2.h;
            this.xc = this.xc.fz($bL(id$1_$_lo, id$1_$_hi));
            $p_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$__complete__J__T__s_Option__s_Option__s_Option__s_concurrent_ExecutionContext__V(this, id$1_$_lo, id$1_$_hi, "rejected", new $c_s_Some("ACTIVATION_REFUSED"), new $c_s_Some("the current diagram refused navigation"), $m_s_None$(), x$3);
            break matchResult4;
          } else {
            break matchResult4;
          }
        }
        if ((x5 instanceof $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Decision$Reject)) {
          var x8 = x5.Tg;
          var x9 = x5.Th;
          if ((!requestId.c())) {
            var $x_3 = $uJ(requestId.d());
            $p_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$__complete__J__T__s_Option__s_Option__s_Option__s_concurrent_ExecutionContext__V(this, $x_3.l, $x_3.h, "rejected", new $c_s_Some(x8), new $c_s_Some(x9), $m_s_None$(), x$3);
            break matchResult4;
          } else {
            break matchResult4;
          }
        }
        throw new $c_s_MatchError(x5);
      }
    });
    window.addEventListener(this.ayI, handler);
    this.a9T = true;
    $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$().u7(this.ayJ, $m_sjs_js_special_package$().eA($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([])))).IT().oB(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((error) => {
      console.debug(("viewer_ready is unavailable outside the desktop shell: " + error.e3()));
    })), x$3);
  }
});
$p.aXN = (function(state, x$2) {
  this.Td = new $c_s_Some(state);
  $f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription(new $c_Lcom_raquo_airstream_misc_StreamFromSignal(state.abj.P(), true), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => {
    $p_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$__settlePending__s_concurrent_ExecutionContext__V($m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$(), x$2);
  })), state.p5);
  $p_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$__settlePending__s_concurrent_ExecutionContext__V(this, x$2);
});
$p.afi = (function(state) {
  var this$1 = this.Td;
  if (((!this$1.c()) && (this$1.d() === state))) {
    this.Td = $m_s_None$();
  }
});
$p.aWx = (function(route, target, status) {
  matchResult10: {
    var $x_1;
    if ((route instanceof $c_Lorg_jpablo_graphexplorer_router_Route$ProjectDetail)) {
      var x40 = route.FO;
      if ((target instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$LibraryDiagram)) {
        var $x_1 = (x40 === target.xp.cv);
        break matchResult10;
      }
    }
    if ((route instanceof $c_Lorg_jpablo_graphexplorer_router_Route$LooseDocument)) {
      var x32 = route.FN;
      if ((target instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$LooseFile)) {
        var $x_1 = (x32 === target.tq.Cv);
        break matchResult10;
      }
    }
    var $x_1 = false;
  }
  if ((!$x_1)) {
    return $s_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$__Waiting__Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation();
  } else {
    var x = $s_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$__Loading__Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus();
    if (((x === null) ? (status === null) : x.e(status))) {
      return $s_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$__Waiting__Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation();
    }
    var x$3 = $s_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$__Ready__Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus();
    if (((x$3 === null) ? (status === null) : x$3.e(status))) {
      return $s_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$__Displayed__Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation();
    }
    if ((status instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$RenderOnly)) {
      return $s_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$__Displayed__Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation();
    }
    if ((status instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$Failed)) {
      return new $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$Rejected("PARSE_FAILED", status.TE);
    }
    throw new $c_s_MatchError(status);
  }
});
$p.aZA = (function(event, exists) {
  var detail = event.detail;
  var target = detail.target;
  var kind = $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$().vU(target, "kind");
  var _2 = $p_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$__field$1__sjs_js_Dynamic__T__s_Option(this, target, "diagramId");
  var _3 = $p_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$__field$1__sjs_js_Dynamic__T__s_Option(this, target, "path");
  if ((kind instanceof $c_s_Some)) {
    var x81 = kind.J;
    if (((x81 === "library") && (_2 instanceof $c_s_Some))) {
      var x79 = _2.J;
      if ((!(!exists.i(x79)))) {
        return new $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Decision$Show(new $c_Lorg_jpablo_graphexplorer_router_Route$ProjectDetail(x79, $m_s_None$()), $m_sjs_js_special_package$().eA($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("kind", "library"), new $c_T2("diagramId", x79)]))));
      }
      return new $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Decision$Reject("DIAGRAM_NOT_FOUND", (("no diagram '" + x79) + "' in this library"));
    }
    if (((x81 === "file") && (_3 instanceof $c_s_Some))) {
      var path = _3.J;
      var x57 = $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$().afP(path);
      if ((x57 instanceof $c_s_Some)) {
        var session = x57.J;
        return new $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Decision$Show(new $c_Lorg_jpablo_graphexplorer_router_Route$LooseDocument(session.vk.Cv), $m_sjs_js_special_package$().eA($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("kind", "file"), new $c_T2("sessionId", session.vk.Cv), new $c_T2("revision", session.Cm)]))));
      }
      if (($m_s_None$() === x57)) {
        return new $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Decision$Reject("DOCUMENT_NOT_FOUND", "the page holds no open document for that path");
      }
      throw new $c_s_MatchError(x57);
    }
  }
  return new $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Decision$Reject("VIEW_REJECTED", "the page could not route to that target");
});
var $d_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$, "org.jpablo.graphexplorer.viewer.desktop.DesktopOpenRequests$", ({
  zV: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$;
function $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$ = new $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$__reconcileOne__T__Lorg_jpablo_graphexplorer_gxcore_model_OriginSnapshot__Lorg_jpablo_graphexplorer_projects_BoundRecord__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, path, origin, record, x$4) {
  return $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$().b2w($m_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$().aXH($m_Lorg_jpablo_graphexplorer_gxcore_model_Reconciler$().b9n(new $c_s_Some(origin)), record.Lm), x$4).IX(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((local) => {
    var plan = $m_Lorg_jpablo_graphexplorer_gxcore_model_Reconciler$().b6I(new $c_s_Some(record.Si), record.Lm, new $c_s_Some(origin), local);
    return $p_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$__perform__T__Lorg_jpablo_graphexplorer_projects_BoundRecord__Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan__s_concurrent_ExecutionContext__s_concurrent_Future($m_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$(), path, record, plan, x$4).jX(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((state) => {
      var x = $m_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$().PY(plan);
      var x$2 = $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__Diverged__Lorg_jpablo_graphexplorer_gxcore_model_SyncState();
      return new $c_T2(state, (((x === null) ? (x$2 === null) : (x === x$2)) ? new $c_s_Some(origin) : $m_s_None$()));
    })), x$4);
  })), x$4).AC(new $c_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$$anon$1(record, origin), x$4).jX(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var state$1 = x$1.g();
    var resolvable = x$1.h();
    $p_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$__remember__Lorg_jpablo_graphexplorer_viewer_state_ProjectId__Lorg_jpablo_graphexplorer_gxcore_model_SyncState__s_Option__V($m_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$(), record.wZ, state$1, resolvable);
    return new $c_T2(record.wZ, state$1);
  })), x$4);
}
function $p_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$__perform__T__Lorg_jpablo_graphexplorer_projects_BoundRecord__Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, path, record, plan, x$4) {
  var x16 = $m_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$().aWw(plan);
  var x = $s_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$__DoNothing__Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction();
  if (((x === null) ? (x16 === null) : x.e(x16))) {
    return $m_s_concurrent_Future$().m4($m_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$().PY(plan));
  }
  if ((x16 instanceof $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$AdoptOrigin)) {
    var x26 = x16.Sc;
    var x27 = x16.Sb;
    $m_Lorg_jpablo_graphexplorer_projects_Library$().Ef(record.wZ, new $c_s_Some(x26), x27);
    return $m_s_concurrent_Future$().m4($m_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$().PY(plan));
  }
  if ((x16 instanceof $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$AdvanceBase)) {
    var x23 = x16.Sd;
    $m_Lorg_jpablo_graphexplorer_projects_Library$().Ef(record.wZ, $m_s_None$(), x23);
    return $m_s_concurrent_Future$().m4($m_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$().PY(plan));
  }
  if ((x16 instanceof $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$WriteOrigin)) {
    return $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$().aRP(path, x16.Sf, x16.Se, x$4).jX(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
      if ((x$1 instanceof $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$Saved)) {
        var x15 = x$1.M7;
        $m_Lorg_jpablo_graphexplorer_projects_Library$().Ef(record.wZ, $m_s_None$(), x15.toLowerCase());
        return $m_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$().PY(plan);
      } else {
        return ((x$1 instanceof $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$Conflict) ? $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__Diverged__Lorg_jpablo_graphexplorer_gxcore_model_SyncState() : (console.warn(((("[origin] could not write " + path) + ": ") + x$1)), $m_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$().PY(plan)));
      }
    })), x$4);
  }
  throw new $c_s_MatchError(x16);
}
function $p_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$__remember__Lorg_jpablo_graphexplorer_viewer_state_ProjectId__Lorg_jpablo_graphexplorer_gxcore_model_SyncState__s_Option__V($thiz, id, state, origin) {
  if ($m_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$().b4L(state)) {
    $f_Lcom_raquo_airstream_state_Var__update__F1__V($thiz.Cn, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$9) => _$9.bN(id, new $c_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$Unresolved(state, origin)))));
  } else {
    $f_Lcom_raquo_airstream_state_Var__update__F1__V($thiz.Cn, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$10) => _$10.fz(id))));
  }
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$() {
  this.Cn = null;
  $n_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$ = this;
  this.Cn = $m_Lcom_raquo_airstream_state_Var$().bx($m_sci_Map$EmptyMap$());
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$.prototype = $p;
$p.baG = (function(id) {
  return $f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), this.Cn.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3) => _$3.r(id))), $m_s_None$()));
});
$p.b9O = (function(id) {
  var this$3 = this.Cn.P().aq().d().r(id);
  var this$4 = (this$3.c() ? $m_s_None$() : this$3.d().Gz);
  if ((!this$4.c())) {
    var x0$1 = this$4.d();
    $m_Lorg_jpablo_graphexplorer_projects_Library$().Ef(id, new $c_s_Some(x0$1.Lk), x0$1.BG);
    $f_Lcom_raquo_airstream_state_Var__update__F1__V($m_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$().Cn, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$7) => _$7.fz(id))));
  }
});
$p.b3U = (function(id) {
  var this$3 = this.Cn.P().aq().d().r(id);
  var this$4 = (this$3.c() ? $m_s_None$() : this$3.d().Gz);
  if ((!this$4.c())) {
    $m_Lorg_jpablo_graphexplorer_projects_Library$().Ef(id, $m_s_None$(), this$4.d().BG);
    $f_Lcom_raquo_airstream_state_Var__update__F1__V($m_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$().Cn, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$7) => _$7.fz(id))));
  }
});
$p.b7g = (function(path, text, revision, x$4) {
  var x5 = $m_Lorg_jpablo_graphexplorer_projects_Library$().XP(path);
  if ($m_sci_Nil$().e(x5)) {
    return $m_s_concurrent_Future$().m4($m_sci_Nil$());
  }
  var origin = new $c_Lorg_jpablo_graphexplorer_gxcore_model_OriginSnapshot(text, revision.toLowerCase(), $m_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$().aZS(text));
  return $m_s_concurrent_Future$().bav(x5, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$8) => $p_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$__reconcileOne__T__Lorg_jpablo_graphexplorer_gxcore_model_OriginSnapshot__Lorg_jpablo_graphexplorer_projects_BoundRecord__s_concurrent_ExecutionContext__s_concurrent_Future($m_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$(), path, origin, _$8, x$4))), new $c_sc_BuildFromLowPriority2$$anon$11($m_sc_BuildFrom$()), x$4);
});
var $d_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$, "org.jpablo.graphexplorer.viewer.desktop.OriginReconciler$", ({
  A0: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$;
function $m_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$ = new $c_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_desktop_SessionCommands$__handle__Lorg_scalajs_dom_Event__V($thiz, event) {
  var detail = event.detail;
  var this$1 = $p_Lorg_jpablo_graphexplorer_viewer_desktop_SessionCommands$__field__sjs_js_Any__T__s_Option($thiz, detail, "id");
  if (this$1.c()) {
    var id = $m_s_None$();
  } else {
    var x0 = this$1.d();
    var id = (((typeof x0) === "number") ? new $c_s_Some((+x0)) : $m_s_None$());
  }
  matchResult3: {
    if (($m_s_None$() === id)) {
      console.warn("session command arrived with no id; ignoring");
      break matchResult3;
    }
    if ((id instanceof $c_s_Some)) {
      var requestId = (+id.J);
      try {
        var frame = $m_Lujson_package$().ahw(new $c_Lujson_Readable$fromTransformer(JSON.stringify(detail), $m_Lujson_StringParser$()), false);
      } catch (e) {
        var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
        matchResult1: {
          var frame;
          var x2 = $m_s_util_control_NonFatal$().wm(e$2);
          if ((!x2.c())) {
            x2.d();
            var frame = new $c_Lujson_Obj(new $c_Lupickle_core_LinkedHashMap($ct_ju_LinkedHashMap__(new $c_ju_LinkedHashMap())));
            break matchResult1;
          }
          throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
        }
      }
      var x5 = $m_Lorg_jpablo_graphexplorer_gxcore_command_SessionCodec$().aZF(frame);
      if ((x5 instanceof $c_s_util_Left)) {
        $p_Lorg_jpablo_graphexplorer_viewer_desktop_SessionCommands$__reply__D__s_util_Either__V($thiz, requestId, new $c_s_util_Left(new $c_Lorg_jpablo_graphexplorer_viewer_desktop_SessionCommands$Refusal("INVALID_REQUEST", x5.lP.aQj())));
        break matchResult3;
      }
      if ((x5 instanceof $c_s_util_Right)) {
        $p_Lorg_jpablo_graphexplorer_viewer_desktop_SessionCommands$__reply__D__s_util_Either__V($thiz, requestId, $thiz.b81(x5.hm));
        break matchResult3;
      }
      throw new $c_s_MatchError(x5);
    }
    throw new $c_s_MatchError(id);
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_desktop_SessionCommands$__pushText__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__T__T__s_util_Either($thiz, state, sessionId, text) {
  var x39 = $m_Lorg_jpablo_graphexplorer_viewer_state_DocumentSessionId$().mU(sessionId);
  if (($m_s_None$() === x39)) {
    return new $c_s_util_Left(new $c_Lorg_jpablo_graphexplorer_viewer_desktop_SessionCommands$Refusal("INVALID_REQUEST", (("'" + sessionId) + "' is not a document session id")));
  }
  if ((x39 instanceof $c_s_Some)) {
    var id = x39.J;
    var x35 = state.lI;
    if ((x35 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$LooseFile)) {
      var x38 = x35.tq;
      if (((x38 === null) ? (id === null) : x38.e(id))) {
        $f_Lorg_jpablo_graphexplorer_viewer_state_ImportOps__replaceSourceDetectingFormat__T__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat(state, text);
        return new $c_s_util_Right($m_Lujson_Null$());
      }
    }
    return new $c_s_util_Left(new $c_Lorg_jpablo_graphexplorer_viewer_desktop_SessionCommands$Refusal("VIEW_REJECTED", (("the view on screen is not document session '" + sessionId) + "'")));
  }
  throw new $c_s_MatchError(x39);
}
function $p_Lorg_jpablo_graphexplorer_viewer_desktop_SessionCommands$__reply__D__s_util_Either__V($thiz, id, outcome) {
  var $x_2 = $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$();
  matchResult12: {
    var $x_1;
    if ((outcome instanceof $c_s_util_Right)) {
      var value = outcome.hm;
      var $x_1 = $m_sjs_js_special_package$().eA($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("id", id), new $c_T2("ok", true), new $c_T2("result", JSON.parse($m_Lujson_package$().bc5(value, (-1), false, false)))])));
      break matchResult12;
    }
    if ((outcome instanceof $c_s_util_Left)) {
      var refusal = outcome.lP;
      var $x_1 = $m_sjs_js_special_package$().eA($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("id", id), new $c_T2("ok", false), new $c_T2("code", refusal.To), new $c_T2("message", refusal.Tp)])));
      break matchResult12;
    }
    throw new $c_s_MatchError(outcome);
  }
  $x_2.u7("session_reply", $x_1).IT().oB(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((error) => {
    console.warn(("could not deliver a session reply: " + error.e3()));
  })), $m_s_concurrent_ExecutionContext$().ek());
}
function $p_Lorg_jpablo_graphexplorer_viewer_desktop_SessionCommands$__field__sjs_js_Any__T__s_Option($thiz, value, name) {
  if (((value === (void 0)) || (value === null))) {
    return $m_s_None$();
  } else {
    var selected = value[name];
    return (((selected === (void 0)) || (selected === null)) ? $m_s_None$() : new $c_s_Some(selected));
  }
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_desktop_SessionCommands$() {
  this.aUz = null;
  this.aUA = null;
  this.a9W = false;
  this.Tn = null;
  $n_Lorg_jpablo_graphexplorer_viewer_desktop_SessionCommands$ = this;
  this.aUz = "ge:session.command";
  this.aUA = "session_reply";
  this.a9W = false;
  this.Tn = $m_s_None$();
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_desktop_SessionCommands$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_desktop_SessionCommands$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_desktop_SessionCommands$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_desktop_SessionCommands$.prototype = $p;
$p.a3O = (function() {
  if ((!this.a9W)) {
    var handler = ((event) => {
      $p_Lorg_jpablo_graphexplorer_viewer_desktop_SessionCommands$__handle__Lorg_scalajs_dom_Event__V($m_Lorg_jpablo_graphexplorer_viewer_desktop_SessionCommands$(), event);
    });
    window.addEventListener("ge:session.command", handler);
    this.a9W = true;
  }
});
$p.aXO = (function(state) {
  this.a3O();
  this.Tn = new $c_s_Some(state);
});
$p.afi = (function(state) {
  var this$1 = this.Tn;
  if (((!this$1.c()) && (this$1.d() === state))) {
    this.Tn = $m_s_None$();
  }
});
$p.b81 = (function(command) {
  var x32 = this.Tn;
  if (($m_s_None$() === x32)) {
    return new $c_s_util_Left(new $c_Lorg_jpablo_graphexplorer_viewer_desktop_SessionCommands$Refusal("NO_SESSION", "no diagram is open"));
  }
  if ((x32 instanceof $c_s_Some)) {
    var state = x32.J;
    try {
      if ((command instanceof $c_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$Select)) {
        var x27 = command.S9;
        state.aH().gC(x27);
        return new $c_s_util_Right($m_Lujson_Null$());
      }
      if ((command instanceof $c_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$AddToSelection)) {
        var x24 = command.S6;
        state.aH().aeE(x24);
        return new $c_s_util_Right($m_Lujson_Null$());
      }
      var x$3 = $s_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$__ClearSelection__Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand();
      if (((x$3 === null) ? (command === null) : x$3.e(command))) {
        state.aH().ie();
        return new $c_s_util_Right($m_Lujson_Null$());
      }
      var x$5 = $s_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$__ResetView__Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand();
      if (((x$5 === null) ? (command === null) : x$5.e(command))) {
        $f_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps__resetView__V(state);
        return new $c_s_util_Right($m_Lujson_Null$());
      }
      if ((command instanceof $c_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$PushText)) {
        return $p_Lorg_jpablo_graphexplorer_viewer_desktop_SessionCommands$__pushText__Lorg_jpablo_graphexplorer_viewer_state_ViewerState__T__T__s_util_Either(this, state, command.S7, command.S8);
      }
      var x$7 = $s_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$__WhatIsSelected__Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand();
      if (((x$7 === null) ? (command === null) : x$7.e(command))) {
        var $x_1 = $m_Lujson_Arr$();
        var this$12 = state.aH().cL();
        return new $c_s_util_Right($x_1.a3u($m_sci_Vector$().X(this$12).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((id) => {
          $m_Lorg_jpablo_graphexplorer_gxcore_command_ElementRef$();
          return id.kx();
        }))).h9($m_s_math_Ordering$String$()).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3) => new $c_Lujson_Str(_$3)))), $m_s_$less$colon$less$().b1));
      }
      throw new $c_s_MatchError(command);
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      var x29 = $m_s_util_control_NonFatal$().wm(e$2);
      if ((!x29.c())) {
        var x30 = x29.d();
        return new $c_s_util_Left(new $c_Lorg_jpablo_graphexplorer_viewer_desktop_SessionCommands$Refusal("SESSION_FAILED", (($m_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$().b4I(command) + " failed: ") + x30.e3())));
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
    }
  }
  throw new $c_s_MatchError(x32);
});
var $d_Lorg_jpablo_graphexplorer_viewer_desktop_SessionCommands$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_desktop_SessionCommands$, "org.jpablo.graphexplorer.viewer.desktop.SessionCommands$", ({
  A2: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_desktop_SessionCommands$;
function $m_Lorg_jpablo_graphexplorer_viewer_desktop_SessionCommands$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_desktop_SessionCommands$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_desktop_SessionCommands$ = new $c_Lorg_jpablo_graphexplorer_viewer_desktop_SessionCommands$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_desktop_SessionCommands$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_domUtils_DomUtils$package$() {
  this.ayQ = null;
  this.ayR = null;
  this.a9X = null;
  this.ayP = null;
  this.a9Y = null;
  this.ayO = null;
  $n_Lorg_jpablo_graphexplorer_viewer_domUtils_DomUtils$package$ = this;
  $m_Lcom_raquo_laminar_api_package$();
  $m_Lcom_raquo_laminar_api_package$();
  this.ayQ = ($m_Lcom_raquo_laminar_api_package$(), new $c_Lcom_raquo_laminar_tags_HtmlTag("dialog", ($m_Lcom_raquo_laminar_api_package$(), false)));
  $m_Lcom_raquo_laminar_api_package$();
  $m_Lcom_raquo_laminar_api_package$();
  this.ayR = ($m_Lcom_raquo_laminar_api_package$(), new $c_Lcom_raquo_laminar_keys_EventProp("close"));
  this.a9X = ($m_Lcom_raquo_laminar_api_package$(), new $c_Lcom_raquo_laminar_keys_HtmlAttr("aria-label", $m_Lcom_raquo_laminar_codecs_package$().bW));
  $m_Lcom_raquo_laminar_api_package$();
  $m_Lcom_raquo_laminar_codecs_package$();
  this.ayP = ($m_Lcom_raquo_laminar_api_package$(), new $c_Lcom_raquo_laminar_keys_HtmlAttr("data-tip", $m_Lcom_raquo_laminar_codecs_package$().bW));
  $m_Lcom_raquo_laminar_api_package$();
  $m_Lcom_raquo_laminar_codecs_package$();
  this.a9Y = ($m_Lcom_raquo_laminar_api_package$(), new $c_Lcom_raquo_laminar_keys_HtmlAttr("open", $m_Lcom_raquo_laminar_codecs_package$().arh));
  this.ayO = ($m_Lcom_raquo_laminar_api_package$(), new $c_Lcom_raquo_laminar_keys_HtmlProp("autocomplete", $m_Lcom_raquo_laminar_codecs_package$().bW));
  $m_Lcom_raquo_laminar_api_package$();
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_domUtils_DomUtils$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_domUtils_DomUtils$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_domUtils_DomUtils$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_domUtils_DomUtils$package$.prototype = $p;
$p.a3d = (function(doc, x, y) {
  return doc.elementsFromPoint(x, y);
});
var $d_Lorg_jpablo_graphexplorer_viewer_domUtils_DomUtils$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_domUtils_DomUtils$package$, "org.jpablo.graphexplorer.viewer.domUtils.DomUtils$package$", ({
  A3: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_domUtils_DomUtils$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_domUtils_DomUtils$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_domUtils_DomUtils$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_domUtils_DomUtils$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_domUtils_DomUtils$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_domUtils_DomUtils$package$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_domUtils_QuerySelector$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_domUtils_QuerySelector$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_domUtils_QuerySelector$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_domUtils_QuerySelector$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_domUtils_QuerySelector$package$.prototype = $p;
$p.m3 = (function(node, selectors) {
  return $f_sc_IterableOps__map__F1__O(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(node.querySelectorAll(selectors)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => _$2))).iz();
});
var $d_Lorg_jpablo_graphexplorer_viewer_domUtils_QuerySelector$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_domUtils_QuerySelector$package$, "org.jpablo.graphexplorer.viewer.domUtils.QuerySelector$package$", ({
  A4: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_domUtils_QuerySelector$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_domUtils_QuerySelector$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_domUtils_QuerySelector$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_domUtils_QuerySelector$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_domUtils_QuerySelector$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_domUtils_QuerySelector$package$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_domUtils_SvgParser$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_domUtils_SvgParser$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_domUtils_SvgParser$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_domUtils_SvgParser$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_domUtils_SvgParser$package$.prototype = $p;
$p.XH = (function(svgString) {
  var parser = new DOMParser();
  var doc = parser.parseFromString(svgString, "image/svg+xml");
  var svgElem = doc.documentElement;
  return $f_Lcom_raquo_laminar_api_Laminar__foreignSvgElement__Lcom_raquo_laminar_tags_SvgTag__Lorg_scalajs_dom_SVGElement__Lcom_raquo_laminar_nodes_ReactiveSvgElement($m_Lcom_raquo_laminar_api_package$().b, $m_Lcom_raquo_laminar_api_package$().b.j().bo(), svgElem);
});
var $d_Lorg_jpablo_graphexplorer_viewer_domUtils_SvgParser$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_domUtils_SvgParser$package$, "org.jpablo.graphexplorer.viewer.domUtils.SvgParser$package$", ({
  A5: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_domUtils_SvgParser$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_domUtils_SvgParser$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_domUtils_SvgParser$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_domUtils_SvgParser$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_domUtils_SvgParser$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_domUtils_SvgParser$package$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_domUtils_SvgUtils$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_domUtils_SvgUtils$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_domUtils_SvgUtils$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_domUtils_SvgUtils$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_domUtils_SvgUtils$.prototype = $p;
$p.aMD = (function(ref, svgSize, clientSize) {
  return ((clientSize / svgSize) / this.b23(ref));
});
$p.b23 = (function(svgElement) {
  try {
    var ctm = svgElement.getScreenCTM();
    if ((ctm !== null)) {
      var x = (+ctm.a);
      return (+Math.abs(x));
    } else {
      return 1.0;
    }
  } catch (e) {
    if ((((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e)) instanceof $c_jl_Exception)) {
      return 1.0;
    } else {
      throw e;
    }
  }
});
$p.b2c = (function(g) {
  if ((g.transform === (void 0))) {
    console.warn("undefined!");
    return $m_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint$().Hd;
  } else {
    var transformList = g.transform.baseVal;
    var end = (transformList.numberOfItems | 0);
    var isEmpty = (end <= 0);
    var scala$collection$immutable$Range$$lastElement = ((end - 1) | 0);
    if (((end <= 0) && (!isEmpty))) {
      $m_sci_Range$().ug(0, end, 1, false);
    }
    var b = $m_sci_IndexedSeq$().b5();
    var it = new $c_sci_RangeIterator(0, 1, scala$collection$immutable$Range$$lastElement, isEmpty);
    while (it.g0) {
      var x0 = it.hp();
      b.Y(new $c_T2(x0, transformList.getItem(x0)));
    }
    var transformPoints = $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(new $c_sc_IterableOps$WithFilter(), b.aR(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
      if ((x$1 !== null)) {
        (x$1.g() | 0);
        var transform$1 = x$1.h();
        return ((transform$1.type | 0) === (SVGTransform.SVG_TRANSFORM_TRANSLATE | 0));
      }
      throw new $c_s_MatchError(x$1);
    }))).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
      if ((x$1$2 !== null)) {
        (x$1$2.g() | 0);
        var transform$2 = x$1$2.h();
        $m_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint$();
        return new $c_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint((+transform$2.matrix.e), (+transform$2.matrix.f));
      }
      throw new $c_s_MatchError(x$1$2);
    })));
    var this$10 = $f_sc_IndexedSeqOps__headOption__s_Option(transformPoints);
    return (this$10.c() ? $m_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint$().Hd : this$10.d());
  }
});
var $d_Lorg_jpablo_graphexplorer_viewer_domUtils_SvgUtils$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_domUtils_SvgUtils$, "org.jpablo.graphexplorer.viewer.domUtils.SvgUtils$", ({
  A6: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_domUtils_SvgUtils$;
function $m_Lorg_jpablo_graphexplorer_viewer_domUtils_SvgUtils$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_domUtils_SvgUtils$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_domUtils_SvgUtils$ = new $c_Lorg_jpablo_graphexplorer_viewer_domUtils_SvgUtils$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_domUtils_SvgUtils$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$__printTableIndented__Lorg_jpablo_graphexplorer_graphviz_html_HtmlTable__I__T($thiz, tbl, level) {
  var ind = $m_sc_StringOps$().tR("  ", level);
  var ind1 = $m_sc_StringOps$().tR("  ", ((1 + level) | 0));
  var ind2 = $m_sc_StringOps$().tR("  ", ((2 + level) | 0));
  var sb = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  sb.ad((((ind + "<table") + $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$__attrsMarkup__sci_Map__T($thiz, tbl.nR)) + ">\n"));
  var end = tbl.fg.C();
  if ((!(end < 0))) {
    var i = 0;
    while (true) {
      var x0 = i;
      if (tbl.oR.E(x0)) {
        sb.ad((ind1 + "<hr/>\n"));
      }
      if ((x0 < tbl.fg.C())) {
        sb.ad((ind1 + "<tr>\n"));
        var cells = $f_sc_LinearSeqOps__apply__I__O(tbl.fg, x0);
        var end$1 = cells.C();
        if ((!(end$1 < 0))) {
          var i$1 = 0;
          while (true) {
            var x0$1 = i$1;
            if (((x0 === 0) && tbl.oS.E(x0$1))) {
              sb.ad((ind2 + "<vr/>\n"));
            }
            if ((x0$1 < cells.C())) {
              sb.ad($p_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$__printCell__Lorg_jpablo_graphexplorer_graphviz_html_HtmlCell__I__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$(), $f_sc_LinearSeqOps__apply__I__O(cells, x0$1), ((2 + level) | 0)));
            }
            if ((i$1 === end$1)) {
              break;
            }
            i$1 = ((1 + i$1) | 0);
          }
        }
        sb.ad((ind1 + "</tr>\n"));
      }
      if ((i === end)) {
        break;
      }
      i = ((1 + i) | 0);
    }
  }
  sb.ad((ind + "</table>"));
  return sb.bP.ah;
}
function $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$__printCell__Lorg_jpablo_graphexplorer_graphviz_html_HtmlCell__I__T($thiz, cell, level) {
  var ind = $m_sc_StringOps$().tR("  ", level);
  var x18 = cell.oL;
  if ((x18 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Table)) {
    var x28 = x18.k8;
    return (((((((ind + "<td") + $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$__attrsMarkup__sci_Map__T($thiz, cell.gE)) + ">\n") + $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$__printTableIndented__Lorg_jpablo_graphexplorer_graphviz_html_HtmlTable__I__T($thiz, x28, ((1 + level) | 0))) + "\n") + ind) + "</td>\n");
  }
  if ((x18 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Image)) {
    var x24 = x18.wy;
    var x25 = x18.EZ;
    return (((((ind + "<td") + $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$__attrsMarkup__sci_Map__T($thiz, cell.gE)) + ">") + $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$__imgMarkup__T__s_Option__T($thiz, x24, x25)) + "</td>\n");
  }
  if ((x18 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Text)) {
    var x21 = x18.oQ;
    return (((((ind + "<td") + $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$__attrsMarkup__sci_Map__T($thiz, cell.gE)) + ">") + $thiz.aR9(x21)) + "</td>\n");
  }
  throw new $c_s_MatchError(x18);
}
function $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$__printItem__Lorg_jpablo_graphexplorer_graphviz_html_HtmlItem__T($thiz, it) {
  var f = it.hb;
  var out = $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$__escText__T__T($thiz, it.pO);
  if (f.oO) {
    out = (("<sup>" + out) + "</sup>");
  }
  if (f.oN) {
    out = (("<sub>" + out) + "</sub>");
  }
  if (f.pN) {
    out = (("<s>" + out) + "</s>");
  }
  if (f.oP) {
    out = (("<u>" + out) + "</u>");
  }
  if (f.nQ) {
    out = (("<i>" + out) + "</i>");
  }
  if (f.nP) {
    out = (("<b>" + out) + "</b>");
  }
  var this$1 = f.kZ;
  var this$2 = (this$1.c() ? $m_s_None$() : new $c_s_Some(((" point-size=\"" + $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$__fmtNum__D__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$(), (+this$1.d()))) + "\"")));
  var $x_2 = (this$2.c() ? "" : this$2.d());
  var this$3 = f.n1;
  var this$4 = (this$3.c() ? $m_s_None$() : new $c_s_Some(((" face=\"" + $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$__escAttr__T__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$(), this$3.d())) + "\"")));
  var $x_1 = (this$4.c() ? "" : this$4.d());
  var this$5 = f.oM;
  var this$6 = (this$5.c() ? $m_s_None$() : new $c_s_Some(((" color=\"" + $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$__escAttr__T__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$(), this$5.d())) + "\"")));
  var fontAttrs = ((("" + $x_2) + $x_1) + (this$6.c() ? "" : this$6.d()));
  return ((fontAttrs !== "") ? (((("<font" + fontAttrs) + ">") + out) + "</font>") : out);
}
function $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$__imgMarkup__T__s_Option__T($thiz, src, scale) {
  var this$1 = (scale.c() ? $m_s_None$() : new $c_s_Some(((" scale=\"" + $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$__escAttr__T__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$(), scale.d())) + "\"")));
  var sc = (this$1.c() ? "" : this$1.d());
  return (((("<img src=\"" + $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$__escAttr__T__T($thiz, src)) + "\"") + sc) + "/>");
}
function $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$__attrsMarkup__sci_Map__T($thiz, attrs) {
  var this$3 = $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O($m_sci_Nil$().b6(attrs), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => _$1.g())), $m_s_math_Ordering$String$());
  var f$1 = ((x$1) => {
    var k = x$1.g();
    var v = x$1.h();
    return ((((" " + k) + "=\"") + $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$__escAttr__T__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$(), v)) + "\"");
  });
  if ((this$3 === $m_sci_Nil$())) {
    var $x_1 = $m_sci_Nil$();
  } else {
    var x0 = this$3.t();
    var h = new $c_sci_$colon$colon(f$1(x0), $m_sci_Nil$());
    var t = h;
    var rest = this$3.v();
    while ((rest !== $m_sci_Nil$())) {
      var x0$1 = rest.t();
      var nx = new $c_sci_$colon$colon(f$1(x0$1), $m_sci_Nil$());
      t.U = nx;
      t = nx;
      rest = rest.v();
    }
    var $x_1 = h;
  }
  return $f_sc_IterableOnceOps__mkString__T__T__T__T($x_1, "", "", "");
}
function $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$__alignName__Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign__T($thiz, a) {
  var x = $s_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$__Left__Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign();
  if (((x === null) ? (a === null) : (x === a))) {
    return "left";
  }
  var x$3 = $s_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$__Center__Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign();
  if (((x$3 === null) ? (a === null) : (x$3 === a))) {
    return "center";
  }
  var x$5 = $s_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$__Right__Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign();
  if (((x$5 === null) ? (a === null) : (x$5 === a))) {
    return "right";
  }
  var x$7 = $s_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$__Text___Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign();
  if (((x$7 === null) ? (a === null) : (x$7 === a))) {
    return "text";
  }
  throw new $c_s_MatchError(a);
}
function $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$__escText__T__T($thiz, s) {
  var len = s.length;
  var sb = $ct_jl_StringBuilder__(new $c_jl_StringBuilder());
  var i = 0;
  while ((i < len)) {
    var index = i;
    var x0 = s.charCodeAt(index);
    var str;
    switch (x0) {
      case 38: {
        var str = "&amp;";
        break;
      }
      case 60: {
        var str = "&lt;";
        break;
      }
      case 62: {
        var str = "&gt;";
        break;
      }
      default: {
        var str = ("" + $cToS(x0));
      }
    }
    sb.ah = (sb.ah + str);
    i = ((1 + i) | 0);
  }
  return sb.ah;
}
function $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$__escAttr__T__T($thiz, s) {
  var len = s.length;
  var sb = $ct_jl_StringBuilder__(new $c_jl_StringBuilder());
  var i = 0;
  while ((i < len)) {
    var index = i;
    var x0 = s.charCodeAt(index);
    var str;
    switch (x0) {
      case 38: {
        var str = "&amp;";
        break;
      }
      case 60: {
        var str = "&lt;";
        break;
      }
      case 62: {
        var str = "&gt;";
        break;
      }
      case 34: {
        var str = "&quot;";
        break;
      }
      default: {
        var str = ("" + $cToS(x0));
      }
    }
    sb.ah = (sb.ah + str);
    i = ((1 + i) | 0);
  }
  return sb.ah;
}
function $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$__fmtNum__D__T($thiz, d) {
  var $x_1 = $m_RTLong$().d1(d);
  var x_$_lo = $x_1.l;
  var x_$_hi = $x_1.h;
  if ((d === ((4.294967296E9 * x_$_hi) + (x_$_lo >>> 0.0)))) {
    var $x_2 = $m_RTLong$().d1(d);
    var this$2_$_lo = $x_2.l;
    var this$2_$_hi = $x_2.h;
    return $m_RTLong$().kY(this$2_$_lo, this$2_$_hi);
  } else {
    return ("" + d);
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$__normalizeCell__Lorg_jpablo_graphexplorer_graphviz_html_HtmlCell__Lorg_jpablo_graphexplorer_graphviz_html_HtmlCell($thiz, cell) {
  return new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlCell($p_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$__normalizeLabel__Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel__Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel($thiz, cell.oL), cell.gE);
}
function $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$__normalizeLabel__Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel__Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel($thiz, l) {
  return ((l instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Table) ? new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Table($thiz.aQy(l.k8)) : ((l instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Text) ? new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Text($thiz.aQz(l.oQ)) : l));
}
function $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$__contentFromDisplay__T__Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel($thiz, display) {
  var cond = $m_sc_StringOps$().IJ(display, 60);
  var this$3 = (cond ? new $c_s_Some(display) : $m_s_None$());
  if (this$3.c()) {
    var parsed = $m_s_None$();
  } else {
    var x0 = this$3.d();
    var parsed = $m_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$().mU(x0);
  }
  var this$4 = (parsed.c() ? $m_s_None$() : new $c_s_Some($p_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$__normalizeLabel__Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel__Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$(), parsed.d())));
  if (this$4.c()) {
    var this$16 = $m_sci_Nil$().b6($m_s_Predef$().fB($f_T__split__T__I__AT(display.split("\r\n").join("\n"), "\n", (-1))));
    var f = ((line) => {
      if ((line === "")) {
        var $x_2 = $m_sci_Nil$();
      } else {
        var len = line.length;
        var sb = $ct_jl_StringBuilder__I__(new $c_jl_StringBuilder(), len);
        var i = 0;
        while ((i < len)) {
          var index = i;
          var x = line.charCodeAt(index);
          if ((x >= 32)) {
            var str = ("" + $cToS(x));
            sb.ah = (sb.ah + str);
          }
          i = ((1 + i) | 0);
        }
        var $x_2 = new $c_sci_$colon$colon(new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlItem(((len === sb.C()) ? line : sb.ah), new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlFont($m_s_None$(), $m_s_None$(), $m_s_None$(), false, false, false, false, false, false)), $m_sci_Nil$());
      }
      return new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlSpan($x_2, $m_s_None$());
    });
    var $x_4 = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$();
    if ((this$16 === $m_sci_Nil$())) {
      var $x_3 = $m_sci_Nil$();
    } else {
      var x0$2 = this$16.t();
      var h = new $c_sci_$colon$colon(f(x0$2), $m_sci_Nil$());
      var t = h;
      var rest = this$16.v();
      while ((rest !== $m_sci_Nil$())) {
        var x0$3 = rest.t();
        var nx = new $c_sci_$colon$colon(f(x0$3), $m_sci_Nil$());
        t.U = nx;
        t = nx;
        rest = rest.v();
      }
      var $x_3 = h;
    }
    var $x_1 = new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Text($x_4.aQz(new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlText($x_3)));
  } else {
    var $x_1 = this$4.d();
  }
  return $x_1;
}
function $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$__int$1__sci_Map__T__I__I($thiz, attrs$2, k, d) {
  var this$1 = attrs$2.r(k);
  var this$4 = (this$1.c() ? $m_s_None$() : $m_sc_StringParsers$().hT(this$1.d()));
  return ((this$4.c() ? d : this$4.d()) | 0);
}
function $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$__mergeSpan$1__Lorg_jpablo_graphexplorer_graphviz_html_HtmlSpan__Lorg_jpablo_graphexplorer_graphviz_html_HtmlSpan($thiz, span) {
  var this$3 = span.lz;
  var f = ((_$7) => (_$7.pO !== ""));
  var l = this$3;
  block: {
    var result;
    while (true) {
      if (l.c()) {
        var result = $m_sci_Nil$();
        break;
      } else {
        var h = l.t();
        var t = l.v();
        if ((!(!(!f(h))))) {
          l = t;
          continue;
        }
        var start = l;
        var remaining = t;
        while (true) {
          if (remaining.c()) {
            var result = start;
            break block;
          } else {
            var x$1 = remaining.t();
            if ((!(!f(x$1)))) {
              remaining = remaining.v();
              continue;
            }
            var firstMiss = remaining;
            var newHead = new $c_sci_$colon$colon(start.t(), $m_sci_Nil$());
            var toProcess = start.v();
            var currentLast = newHead;
            while ((toProcess !== firstMiss)) {
              var newElem = new $c_sci_$colon$colon(toProcess.t(), $m_sci_Nil$());
              currentLast.U = newElem;
              currentLast = newElem;
              toProcess = toProcess.v();
            }
            var next = firstMiss.v();
            var nextToCopy = next;
            while ((!next.c())) {
              var head = next.t();
              if ((!(!f(head)))) {
                next = next.v();
              } else {
                while ((nextToCopy !== next)) {
                  var newElem$2 = new $c_sci_$colon$colon(nextToCopy.t(), $m_sci_Nil$());
                  currentLast.U = newElem$2;
                  currentLast = newElem$2;
                  nextToCopy = nextToCopy.v();
                }
                nextToCopy = next.v();
                next = next.v();
              }
            }
            if ((!nextToCopy.c())) {
              currentLast.U = nextToCopy;
            }
            var result = newHead;
            break block;
          }
        }
      }
    }
  }
  var z = $m_sci_Nil$();
  var acc = z;
  var these = result;
  while ((!these.c())) {
    var x0 = acc;
    var x1 = these.t();
    matchResult9: {
      if ((x0 !== null)) {
        var x51 = $m_sc_package$$colon$plus$().Y9(x0);
        if ((!x51.c())) {
          var x52 = x51.d();
          var acc$1 = x52.g();
          var last = x52.h();
          var x$2 = last.hb;
          var x$3 = x1.hb;
          if (((x$2 === null) ? (x$3 === null) : x$2.e(x$3))) {
            acc = $f_sc_StrictOptimizedSeqOps__appended__O__O(acc$1, new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlItem((("" + last.pO) + x1.pO), last.hb));
            break matchResult9;
          }
        }
      }
      acc = $f_sc_StrictOptimizedSeqOps__appended__O__O(x0, x1);
    }
    these = these.v();
  }
  return new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlSpan(acc, span.yM);
}
function $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$__goCell$1__Lorg_jpablo_graphexplorer_graphviz_html_HtmlCell__sci_Set($thiz, cell) {
  var $x_2 = $m_sci_Set$().af($m_s_Option$().m2(cell.gE.r("port")));
  matchResult13: {
    var $x_1;
    var x77 = cell.oL;
    if ((x77 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Table)) {
      var $x_1 = $thiz.aR3(x77.k8);
      break matchResult13;
    }
    var $x_1 = $m_sci_Set$EmptySet$();
  }
  return $x_2.dI($x_1);
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$.prototype = $p;
$p.Jf = (function(markup) {
  var x1 = $m_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$().mU(markup);
  if ((x1 instanceof $c_s_Some)) {
    var x3 = x1.J;
    if ((x3 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Table)) {
      return new $c_s_Some(this.aQy(x3.k8));
    }
  }
  return $m_s_None$();
});
$p.aR9 = (function(text) {
  var sb = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  var this$2 = $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(text.oW);
  var these = this$2;
  while ((!these.c())) {
    var x0 = these.t();
    var span = x0.g();
    var i = (x0.h() | 0);
    var this$3 = span.lz;
    var f = ((it) => $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$__printItem__Lorg_jpablo_graphexplorer_graphviz_html_HtmlItem__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$(), it));
    if ((this$3 === $m_sci_Nil$())) {
      var $x_1 = $m_sci_Nil$();
    } else {
      var x0$1 = this$3.t();
      var h = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
      var t = h;
      var rest = this$3.v();
      while ((rest !== $m_sci_Nil$())) {
        var x0$2 = rest.t();
        var nx = new $c_sci_$colon$colon(f(x0$2), $m_sci_Nil$());
        t.U = nx;
        t = nx;
        rest = rest.v();
      }
      var $x_1 = h;
    }
    sb.ad($f_sc_IterableOnceOps__mkString__T__T__T__T($x_1, "", "", ""));
    var this$5 = span.yM;
    var this$6 = (this$5.c() ? $m_s_None$() : new $c_s_Some(((" align=\"" + $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$__alignName__Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$(), this$5.d())) + "\"")));
    var alignAttr = (this$6.c() ? "" : this$6.d());
    var isLast = (i === ((text.oW.C() - 1) | 0));
    var lastNeedsBr = ((!span.yM.c()) || (span.lz.c() && (text.oW.C() > 1)));
    if (((!isLast) || lastNeedsBr)) {
      sb.ad((("<br" + alignAttr) + "/>"));
    }
    these = these.v();
  }
  return sb.bP.ah;
});
$p.JK = (function(rows, attrs, hrAfter, vrAfter) {
  matchResult7: {
    var align;
    var this$1 = attrs.r("align");
    if (this$1.c()) {
      var x32 = $m_s_None$();
    } else {
      var x0 = this$1.d();
      var x32 = new $c_s_Some(x0.toLowerCase());
    }
    if ((x32 instanceof $c_s_Some)) {
      var x38 = x32.J;
      if ((x38 === "left")) {
        var align = $s_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$__Left__Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign();
        break matchResult7;
      }
      if ((x38 === "right")) {
        var align = $s_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$__Right__Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign();
        break matchResult7;
      }
      if ((x38 === "text")) {
        var align = $s_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$__Text___Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign();
        break matchResult7;
      }
    }
    var align = $s_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$__Center__Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign();
  }
  var boundedVr = (rows.c() ? $m_sci_Set$EmptySet$() : vrAfter.bw(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4) => ((_$4 | 0) <= rows.t().C())))));
  var border = $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$__int$1__sci_Map__T__I__I(this, attrs, "border", 1);
  var this$3 = attrs.r("cellborder");
  return new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTable(rows, border, (this$3.c() ? $m_s_None$() : $m_sc_StringParsers$().hT(this$3.d())), $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$__int$1__sci_Map__T__I__I(this, attrs, "cellspacing", 2), $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$__int$1__sci_Map__T__I__I(this, attrs, "cellpadding", 2), align, attrs, hrAfter, boundedVr);
});
$p.aQy = (function(tbl) {
  var this$1 = tbl.fg;
  var f$1 = ((_$6) => {
    var f = ((cell) => $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$__normalizeCell__Lorg_jpablo_graphexplorer_graphviz_html_HtmlCell__Lorg_jpablo_graphexplorer_graphviz_html_HtmlCell($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$(), cell));
    if ((_$6 === $m_sci_Nil$())) {
      return $m_sci_Nil$();
    } else {
      var x0 = _$6.t();
      var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
      var t = h;
      var rest = _$6.v();
      while ((rest !== $m_sci_Nil$())) {
        var x0$1 = rest.t();
        var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
        t.U = nx;
        t = nx;
        rest = rest.v();
      }
      return h;
    }
  });
  if ((this$1 === $m_sci_Nil$())) {
    var $x_1 = $m_sci_Nil$();
  } else {
    var x0$2 = this$1.t();
    var h$1 = new $c_sci_$colon$colon(f$1(x0$2), $m_sci_Nil$());
    var t$1 = h$1;
    var rest$1 = this$1.v();
    while ((rest$1 !== $m_sci_Nil$())) {
      var x0$3 = rest$1.t();
      var nx$1 = new $c_sci_$colon$colon(f$1(x0$3), $m_sci_Nil$());
      t$1.U = nx$1;
      t$1 = nx$1;
      rest$1 = rest$1.v();
    }
    var $x_1 = h$1;
  }
  return this.JK($x_1, tbl.nR, tbl.oR, tbl.oS);
});
$p.aQz = (function(t) {
  var this$2 = t.oW;
  var f = ((span) => $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$__mergeSpan$1__Lorg_jpablo_graphexplorer_graphviz_html_HtmlSpan__Lorg_jpablo_graphexplorer_graphviz_html_HtmlSpan(this, span));
  if ((this$2 === $m_sci_Nil$())) {
    var $x_1 = $m_sci_Nil$();
  } else {
    var x0 = this$2.t();
    var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
    var t$1 = h;
    var rest = this$2.v();
    while ((rest !== $m_sci_Nil$())) {
      var x0$1 = rest.t();
      var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
      t$1.U = nx;
      t$1 = nx;
      rest = rest.v();
    }
    var $x_1 = h;
  }
  return new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlText($x_1);
});
$p.aht = (function(label) {
  if ((label instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Text)) {
    var x65 = label.oQ;
    var this$4 = x65.oW;
    var f$1 = ((_$8) => {
      var this$2 = _$8.lz;
      var f = ((_$9) => _$9.pO);
      if ((this$2 === $m_sci_Nil$())) {
        var $x_1 = $m_sci_Nil$();
      } else {
        var x0 = this$2.t();
        var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
        var t = h;
        var rest = this$2.v();
        while ((rest !== $m_sci_Nil$())) {
          var x0$1 = rest.t();
          var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
          t.U = nx;
          t = nx;
          rest = rest.v();
        }
        var $x_1 = h;
      }
      return $f_sc_IterableOnceOps__mkString__T__T__T__T($x_1, "", "", "");
    });
    if ((this$4 === $m_sci_Nil$())) {
      var $x_2 = $m_sci_Nil$();
    } else {
      var x0$2 = this$4.t();
      var h$1 = new $c_sci_$colon$colon(f$1(x0$2), $m_sci_Nil$());
      var t$1 = h$1;
      var rest$1 = this$4.v();
      while ((rest$1 !== $m_sci_Nil$())) {
        var x0$3 = rest$1.t();
        var nx$1 = new $c_sci_$colon$colon(f$1(x0$3), $m_sci_Nil$());
        t$1.U = nx$1;
        t$1 = nx$1;
        rest$1 = rest$1.v();
      }
      var $x_2 = h$1;
    }
    return $f_sc_IterableOnceOps__mkString__T__T__T__T($x_2, "", " ", "");
  }
  if ((label instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Table)) {
    return $f_sc_IterableOnceOps__mkString__T__T__T__T(this.a2T(label.k8), "", " ", "");
  }
  if ((label instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Image)) {
    return label.wy;
  }
  throw new $c_s_MatchError(label);
});
$p.a2T = (function(tbl) {
  var this$1 = tbl.fg;
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O($m_sci_Vector$().X(this$1), $m_s_$less$colon$less$().b1).c5(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((cell) => {
    var x66 = cell.oL;
    if ((x66 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Table)) {
      return $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$().a2T(x66.k8);
    }
    return $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_T.r().C)([$m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$().aht(x66)])));
  })));
});
$p.aZC = (function(tbl) {
  var this$2 = $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(tbl.fg);
  var rest = this$2;
  var h = null;
  var t = null;
  while ((rest !== $m_sci_Nil$())) {
    var x0 = rest.t();
    var row = x0.g();
    var r = (x0.h() | 0);
    var end = row.C();
    var isEmpty = (end <= 0);
    var scala$collection$immutable$Range$$lastElement = ((end - 1) | 0);
    if (((end <= 0) && (!isEmpty))) {
      $m_sci_Range$().ug(0, end, 1, false);
    }
    var b = $m_sci_IndexedSeq$().b5();
    var it = new $c_sci_RangeIterator(0, 1, scala$collection$immutable$Range$$lastElement, isEmpty);
    while (it.g0) {
      b.Y(new $c_sci_$colon$colon(r, new $c_sci_$colon$colon(it.hp(), $m_sci_Nil$())));
    }
    var it$1 = b.aR().o();
    while (it$1.p()) {
      var nx = new $c_sci_$colon$colon(it$1.q(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        t.U = nx;
      }
      t = nx;
    }
    rest = rest.v();
  }
  var this$5 = ((h === null) ? $m_sci_Nil$() : h);
  return $m_sci_Vector$().X(this$5);
});
$p.Wp = (function(tbl, path) {
  if ((path instanceof $c_sci_$colon$colon)) {
    var x73 = path.U;
    var r = (path.er | 0);
    if ((x73 instanceof $c_sci_$colon$colon)) {
      var x76 = x73.U;
      var c = (x73.er | 0);
      if ($m_sci_Nil$().e(x76)) {
        var this$3 = new $c_s_PartialFunction$Lifted(tbl.fg).as(r);
        return (this$3.c() ? $m_s_None$() : new $c_s_PartialFunction$Lifted(this$3.d()).as(c));
      }
    }
  }
  return $m_s_None$();
});
$p.b0o = (function(tbl, cellAttrs) {
  var this$1 = cellAttrs.r("border");
  var this$4 = (this$1.c() ? $m_s_None$() : $m_sc_StringParsers$().hT(this$1.d()));
  var this$5 = ((this$4.c() || (((this$4.d() | 0) >>> 0) <= 255)) ? this$4 : $m_s_None$());
  if (this$5.c()) {
    var this$6 = tbl.F4;
    var $x_1 = ((this$6.c() ? tbl.F3 : this$6.d()) | 0);
  } else {
    var $x_1 = this$5.d();
  }
  return ($x_1 | 0);
});
$p.aR3 = (function(tbl) {
  var $x_1 = $m_sci_Set$();
  var this$4 = $f_sc_StrictOptimizedIterableOps__flatten__F1__O(tbl.fg, $m_s_$less$colon$less$().b1);
  var rest = this$4;
  var h = null;
  var t = null;
  while ((rest !== $m_sci_Nil$())) {
    var it = $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$__goCell$1__Lorg_jpablo_graphexplorer_graphviz_html_HtmlCell__sci_Set(this, rest.t()).o();
    while (it.p()) {
      var nx = new $c_sci_$colon$colon(it.q(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        t.U = nx;
      }
      t = nx;
    }
    rest = rest.v();
  }
  return $x_1.af(((h === null) ? $m_sci_Nil$() : h));
});
$p.ah4 = (function(tbl, path) {
  if (tbl.fg.c()) {
    return $m_sci_Nil$();
  } else {
    var this$1 = path.dt();
    var x = ((this$1.c() ? 0 : this$1.d()) | 0);
    var x$1 = ((x > 0) ? x : 0);
    var that = ((tbl.fg.C() - 1) | 0);
    var r = ((x$1 < that) ? x$1 : that);
    var row = $f_sc_LinearSeqOps__apply__I__O(tbl.fg, r);
    if (row.c()) {
      return new $c_sci_$colon$colon(r, new $c_sci_$colon$colon(0, $m_sci_Nil$()));
    } else {
      var this$12 = new $c_s_PartialFunction$Lifted(path).as(1);
      var x$2 = ((this$12.c() ? 0 : this$12.d()) | 0);
      var x$3 = ((x$2 > 0) ? x$2 : 0);
      var that$1 = ((row.C() - 1) | 0);
      return new $c_sci_$colon$colon(r, new $c_sci_$colon$colon(((x$3 < that$1) ? x$3 : that$1), $m_sci_Nil$()));
    }
  }
});
$p.b8B = (function(tbl, path, display) {
  if ((path instanceof $c_sci_$colon$colon)) {
    var x84 = path.U;
    var r = (path.er | 0);
    if ((x84 instanceof $c_sci_$colon$colon)) {
      var x87 = x84.U;
      var c = (x84.er | 0);
      if ($m_sci_Nil$().e(x87)) {
        var this$3 = new $c_s_PartialFunction$Lifted(tbl.fg).as(r);
        if ((!this$3.c())) {
          var x0 = this$3.d();
          var end = x0.C();
          var isEmpty = (end <= 0);
          var scala$collection$immutable$Range$$lastElement = ((end - 1) | 0);
          var $x_1 = ((!isEmpty) && (!((c < 0) || (c > scala$collection$immutable$Range$$lastElement))));
        } else {
          var $x_1 = false;
        }
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        var $x_3 = tbl.fg;
        var $x_2 = $f_sc_LinearSeqOps__apply__I__O(tbl.fg, r);
        var x0$1 = $f_sc_LinearSeqOps__apply__I__O($f_sc_LinearSeqOps__apply__I__O(tbl.fg, r), c);
        return this.JK($x_3.a5a(r, $x_2.a5a(c, new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlCell($p_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$__contentFromDisplay__T__Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$(), display), x0$1.gE))), tbl.nR, tbl.oR, tbl.oS);
      }
    }
  }
  return tbl;
});
$p.aS2 = (function(tbl, path, key, value) {
  if ((path instanceof $c_sci_$colon$colon)) {
    var x84 = path.U;
    var r = (path.er | 0);
    if ((x84 instanceof $c_sci_$colon$colon)) {
      var x87 = x84.U;
      var c = (x84.er | 0);
      if ($m_sci_Nil$().e(x87)) {
        var this$3 = new $c_s_PartialFunction$Lifted(tbl.fg).as(r);
        if ((!this$3.c())) {
          var x0 = this$3.d();
          var end = x0.C();
          var isEmpty = (end <= 0);
          var scala$collection$immutable$Range$$lastElement = ((end - 1) | 0);
          var $x_1 = ((!isEmpty) && (!((c < 0) || (c > scala$collection$immutable$Range$$lastElement))));
        } else {
          var $x_1 = false;
        }
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        var $x_3 = tbl.fg;
        var $x_2 = $f_sc_LinearSeqOps__apply__I__O(tbl.fg, r);
        var x0$1 = $f_sc_LinearSeqOps__apply__I__O($f_sc_LinearSeqOps__apply__I__O(tbl.fg, r), c);
        if (value.c()) {
          var attrs$1 = x0$1.gE.fz(key);
        } else {
          var x0$2 = value.d();
          var attrs$1 = x0$1.gE.bN(key, x0$2);
        }
        return this.JK($x_3.a5a(r, $x_2.a5a(c, new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlCell(x0$1.oL, attrs$1))), tbl.nR, tbl.oR, tbl.oS);
      }
    }
  }
  return tbl;
});
$p.aYd = (function(cell) {
  var x88 = cell.oL;
  if ((x88 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Text)) {
    var x101 = x88.oQ;
    var this$2 = x101.oW;
    _return: {
      var these = this$2;
      while ((!these.c())) {
        var x0 = these.t();
        if (x0.yM.c()) {
          var this$3 = x0.lz;
          _return$1: {
            var these$1 = this$3;
            while ((!these$1.c())) {
              var x0$1 = these$1.t();
              var x = x0$1.hb;
              var x$2 = new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlFont($m_s_None$(), $m_s_None$(), $m_s_None$(), false, false, false, false, false, false);
              if ((!((x !== null) && x.e(x$2)))) {
                var $x_2 = false;
                break _return$1;
              }
              these$1 = these$1.v();
            }
            var $x_2 = true;
          }
        } else {
          var $x_2 = false;
        }
        if ((!$x_2)) {
          var $x_1 = false;
          break _return;
        }
        these = these.v();
      }
      var $x_1 = true;
    }
    if ($x_1) {
      var this$10 = x101.oW;
      var f$1 = ((_$15) => {
        var this$8 = _$15.lz;
        var f = ((_$16) => _$16.pO);
        if ((this$8 === $m_sci_Nil$())) {
          var $x_3 = $m_sci_Nil$();
        } else {
          var x0$2 = this$8.t();
          var h = new $c_sci_$colon$colon(f(x0$2), $m_sci_Nil$());
          var t = h;
          var rest = this$8.v();
          while ((rest !== $m_sci_Nil$())) {
            var x0$3 = rest.t();
            var nx = new $c_sci_$colon$colon(f(x0$3), $m_sci_Nil$());
            t.U = nx;
            t = nx;
            rest = rest.v();
          }
          var $x_3 = h;
        }
        return $f_sc_IterableOnceOps__mkString__T__T__T__T($x_3, "", "", "");
      });
      if ((this$10 === $m_sci_Nil$())) {
        var $x_4 = $m_sci_Nil$();
      } else {
        var x0$4 = this$10.t();
        var h$1 = new $c_sci_$colon$colon(f$1(x0$4), $m_sci_Nil$());
        var t$1 = h$1;
        var rest$1 = this$10.v();
        while ((rest$1 !== $m_sci_Nil$())) {
          var x0$5 = rest$1.t();
          var nx$1 = new $c_sci_$colon$colon(f$1(x0$5), $m_sci_Nil$());
          t$1.U = nx$1;
          t$1 = nx$1;
          rest$1 = rest$1.v();
        }
        var $x_4 = h$1;
      }
      return $f_sc_IterableOnceOps__mkString__T__T__T__T($x_4, "", "\n", "");
    }
    return this.aR9(x101);
  }
  if ((x88 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Table)) {
    return $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$__printTableIndented__Lorg_jpablo_graphexplorer_graphviz_html_HtmlTable__I__T(this, x88.k8, 0);
  }
  if ((x88 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Image)) {
    return $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$__imgMarkup__T__s_Option__T(this, x88.wy, x88.EZ);
  }
  throw new $c_s_MatchError(x88);
});
$p.a3e = (function() {
  return new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlCell(new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Text(new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlText(new $c_sci_$colon$colon(new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlSpan($m_sci_Nil$(), $m_s_None$()), $m_sci_Nil$()))), $m_sci_Map$EmptyMap$());
});
$p.b2V = (function(tbl, at) {
  if (((at < 0) || (at > tbl.fg.C()))) {
    return tbl;
  } else {
    var this$1 = tbl.fg;
    var f = ((_$18) => _$18.C());
    if ((this$1 === $m_sci_Nil$())) {
      var $x_1 = $m_sci_Nil$();
    } else {
      var x0 = this$1.t();
      var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
      var t = h;
      var rest = this$1.v();
      while ((rest !== $m_sci_Nil$())) {
        var x0$1 = rest.t();
        var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
        t.U = nx;
        t = nx;
        rest = rest.v();
      }
      var $x_1 = h;
    }
    var this$3 = $f_sc_IterableOnceOps__maxOption__s_math_Ordering__s_Option($x_1, $m_s_math_Ordering$Int$());
    var x = ((this$3.c() ? 1 : this$3.d()) | 0);
    var width = ((x > 1) ? x : 1);
    var b = new $c_scm_ListBuffer();
    var i = 0;
    while ((i < width)) {
      b.bb($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$().a3e());
      i = ((1 + i) | 0);
    }
    var newRow = b.bM();
    return this.JK($f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(tbl.fg, at, new $c_sci_$colon$colon(newRow, $m_sci_Nil$()), 0), tbl.nR, tbl.oR.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((b$1) => {
      var b$2 = (b$1 | 0);
      return ((b$2 >= at) ? ((1 + b$2) | 0) : b$2);
    }))), tbl.oS);
  }
});
$p.aZN = (function(tbl, at) {
  var this$1 = tbl.fg;
  var end = this$1.C();
  var isEmpty = (end <= 0);
  var scala$collection$immutable$Range$$lastElement = ((end - 1) | 0);
  if ((!((!isEmpty) && (!((at < 0) || (at > scala$collection$immutable$Range$$lastElement)))))) {
    return tbl;
  } else {
    var rows0 = $f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(tbl.fg, at, $m_sci_Nil$(), 1);
    return this.JK((rows0.c() ? new $c_sci_$colon$colon(new $c_sci_$colon$colon(this.a3e(), $m_sci_Nil$()), $m_sci_Nil$()) : rows0), tbl.nR, tbl.oR.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((b) => {
      var b$1 = (b | 0);
      return ((b$1 > at) ? ((b$1 - 1) | 0) : b$1);
    }))), tbl.oS);
  }
});
$p.b2U = (function(tbl, at) {
  if ((at < 0)) {
    return tbl;
  } else {
    var this$5 = tbl.fg;
    var f = ((row) => {
      var that = row.C();
      return $f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(row, ((at < that) ? at : that), new $c_sci_$colon$colon($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$().a3e(), $m_sci_Nil$()), 0);
    });
    if ((this$5 === $m_sci_Nil$())) {
      var $x_1 = $m_sci_Nil$();
    } else {
      var x0 = this$5.t();
      var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
      var t = h;
      var rest = this$5.v();
      while ((rest !== $m_sci_Nil$())) {
        var x0$1 = rest.t();
        var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
        t.U = nx;
        t = nx;
        rest = rest.v();
      }
      var $x_1 = h;
    }
    return this.JK($x_1, tbl.nR, tbl.oR, tbl.oS.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((b) => {
      var b$1 = (b | 0);
      return ((b$1 > at) ? ((1 + b$1) | 0) : b$1);
    }))));
  }
});
$p.aZK = (function(tbl, at) {
  if ((at < 0)) {
    var $x_1 = true;
  } else {
    var this$1 = tbl.fg;
    _return: {
      var these = this$1;
      while ((!these.c())) {
        var x0 = these.t();
        var end = x0.C();
        var isEmpty = (end <= 0);
        var scala$collection$immutable$Range$$lastElement = ((end - 1) | 0);
        if (((!isEmpty) && (!((at < 0) || (at > scala$collection$immutable$Range$$lastElement))))) {
          var $x_2 = true;
          break _return;
        }
        these = these.v();
      }
      var $x_2 = false;
    }
    var $x_1 = (!$x_2);
  }
  if ($x_1) {
    return tbl;
  } else {
    var this$6 = tbl.fg;
    var f = ((row) => {
      var end$1 = row.C();
      var isEmpty$1 = (end$1 <= 0);
      var scala$collection$immutable$Range$$lastElement$1 = ((end$1 - 1) | 0);
      if (((!isEmpty$1) && (!((at < 0) || (at > scala$collection$immutable$Range$$lastElement$1))))) {
        return $f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(row, at, $m_sci_Nil$(), 1);
      } else {
        return row;
      }
    });
    if ((this$6 === $m_sci_Nil$())) {
      var rows0 = $m_sci_Nil$();
    } else {
      var x0$1 = this$6.t();
      var h = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
      var t = h;
      var rest = this$6.v();
      while ((rest !== $m_sci_Nil$())) {
        var x0$2 = rest.t();
        var nx = new $c_sci_$colon$colon(f(x0$2), $m_sci_Nil$());
        t.U = nx;
        t = nx;
        rest = rest.v();
      }
      var rows0 = h;
    }
    _return$1: {
      var these$1 = rows0;
      while ((!these$1.c())) {
        if ((!these$1.t().c())) {
          var $x_3 = false;
          break _return$1;
        }
        these$1 = these$1.v();
      }
      var $x_3 = true;
    }
    return this.JK(($x_3 ? new $c_sci_$colon$colon(new $c_sci_$colon$colon(this.a3e(), $m_sci_Nil$()), $m_sci_Nil$()) : rows0), tbl.nR, tbl.oR, tbl.oS.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((b) => {
      var b$1 = (b | 0);
      return ((b$1 > at) ? ((b$1 - 1) | 0) : b$1);
    }))));
  }
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$, "org.jpablo.graphexplorer.viewer.formats.dot.HtmlLabelOps$", ({
  A7: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabels$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabels$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabels$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabels$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabels$.prototype = $p;
$p.w8 = (function(value) {
  var v = value.toLowerCase();
  return ((((v.indexOf("<") | 0) !== (-1)) && ((v.indexOf(">") | 0) !== (-1))) && ((((((((((v.indexOf("<table") | 0) !== (-1)) || ((v.indexOf("<b>") | 0) !== (-1))) || ((v.indexOf("<i>") | 0) !== (-1))) || ((v.indexOf("<font") | 0) !== (-1))) || ((v.indexOf("<br") | 0) !== (-1))) || ((v.indexOf("<hr") | 0) !== (-1))) || ((v.indexOf("<td") | 0) !== (-1))) || ((v.indexOf("<tr") | 0) !== (-1))) || ((v.indexOf("</") | 0) !== (-1))));
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabels$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabels$, "org.jpablo.graphexplorer.viewer.formats.dot.HtmlLabels$", ({
  A8: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabels$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabels$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabels$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabels$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabels$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabels$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_LabelSummary$__headline__T__Z__T($thiz, label, isRecord) {
  var ps = $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_LabelSummary$__parts__T__Z__sci_Vector($thiz, label, isRecord).d8(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6) => ($f_T__trim__T(_$6) !== ""))), false);
  if ($f_sc_SeqOps__isEmpty__Z(ps)) {
    return "";
  } else {
    var taken = $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_T.r().C)([ps.t()])));
    while ((((taken.C() < 3) && (ps.C() > taken.C())) && $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_LabelSummary$__isWeak__T__Z($thiz, $f_sc_IterableOnceOps__mkString__T__T__T__T(taken, "", " ", "")))) {
      taken = taken.bv(ps.l(taken.C()));
    }
    return $f_sc_IterableOnceOps__mkString__T__T__T__T(taken, "", " ", "");
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_LabelSummary$__isWeak__T__Z($thiz, s) {
  var t = $f_T__trim__T(s);
  if ((t.length < 3)) {
    return true;
  } else {
    _return: {
      var len = t.length;
      var i = 0;
      while ((i < len)) {
        if ($m_jl_UnicodeData$().a3S(t.charCodeAt(i))) {
          var $x_1 = i;
          break _return;
        }
        i = ((1 + i) | 0);
      }
      var $x_1 = (-1);
    }
    return ($x_1 === (-1));
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_LabelSummary$__parts__T__Z__sci_Vector($thiz, label, isRecord) {
  if ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabels$().w8(label)) {
    var x14 = $m_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$().mU(label);
    if ((x14 instanceof $c_s_Some)) {
      var x18 = x14.J;
      if ((x18 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Table)) {
        return $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$().a2T(x18.k8);
      }
      return $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_T.r().C)([$m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$().aht(x18)])));
    }
    if (($m_s_None$() === x14)) {
      return $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_T.r().C)([label])));
    }
    throw new $c_s_MatchError(x14);
  } else {
    return (isRecord ? $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$().agS($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$().Je(label)).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((l) => $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$__unescapeWith__T__Z__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$(), l.tl, true)))) : $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_T.r().C)([$m_Lorg_jpablo_graphexplorer_viewer_formats_dot_TextUtils$().ain(label)]))));
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_LabelSummary$__collapse__T__T($thiz, s) {
  return $f_T__trim__T($f_T__replaceAll__T__T__T(s, "\\s+", " "));
}
function $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_LabelSummary$__truncate__T__I__T($thiz, s, maxLen) {
  if ((s.length <= maxLen)) {
    return s;
  } else {
    var $x_1 = $m_sc_StringOps$();
    var x = ((maxLen - 1) | 0);
    return ($f_T__trim__T($x_1.a4R(s, ((x > 1) ? x : 1))) + "\u2026");
  }
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_LabelSummary$() {
  this.aUB = 0;
  this.aUD = 0;
  this.aUC = 0;
  this.aUB = 120;
  this.aUD = 3;
  this.aUC = 3;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_LabelSummary$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_LabelSummary$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_LabelSummary$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_LabelSummary$.prototype = $p;
$p.ai2 = (function(label, isRecord, maxLen) {
  return $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_LabelSummary$__truncate__T__I__T(this, $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_LabelSummary$__collapse__T__T(this, $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_LabelSummary$__headline__T__Z__T(this, label, isRecord)), maxLen);
});
$p.aOJ = (function(label, isRecord) {
  return $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_LabelSummary$__collapse__T__T(this, $f_sc_IterableOnceOps__mkString__T__T__T__T($p_Lorg_jpablo_graphexplorer_viewer_formats_dot_LabelSummary$__parts__T__Z__sci_Vector(this, label, isRecord), "", " ", ""));
});
$p.b47 = (function(label, isRecord, maxLen, maxLines) {
  if ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabels$().w8(label)) {
    matchResult1: {
      var raw;
      var x1 = $m_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$().mU(label);
      if ((x1 instanceof $c_s_Some)) {
        var x10 = x1.J;
        if ((x10 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Text)) {
          var x13 = x10.oQ;
          var this$2 = x13.oW;
          var raw = $m_sci_Vector$().X(this$2).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => {
            var this$3 = _$1.lz;
            var f = ((_$2) => _$2.pO);
            if ((this$3 === $m_sci_Nil$())) {
              var $x_1 = $m_sci_Nil$();
            } else {
              var x0 = this$3.t();
              var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
              var t = h;
              var rest = this$3.v();
              while ((rest !== $m_sci_Nil$())) {
                var x0$1 = rest.t();
                var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
                t.U = nx;
                t = nx;
                rest = rest.v();
              }
              var $x_1 = h;
            }
            return $f_sc_IterableOnceOps__mkString__T__T__T__T($x_1, "", "", "");
          })));
          break matchResult1;
        }
        if ((x10 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Table)) {
          var raw = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$().a2T(x10.k8);
          break matchResult1;
        }
        var raw = $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_T.r().C)([$m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$().aht(x10)])));
        break matchResult1;
      }
      if (($m_s_None$() === x1)) {
        var raw = $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_T.r().C)([label])));
        break matchResult1;
      }
      throw new $c_s_MatchError(x1);
    }
  } else if (isRecord) {
    var raw = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$().agS($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$().Je(label)).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((l) => $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$__unescapeWith__T__Z__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$(), l.tl, true))));
  } else {
    var this$10 = $m_s_Predef$().fB($m_sc_StringOps$().Ej($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_TextUtils$().ain(label), 10));
    var this$11 = $m_sci_Vector$().X(this$10);
    $m_sci_Vector$();
    var b = new $c_sci_VectorBuilder();
    var it = this$11.o();
    while (it.p()) {
      var x0$2 = it.q();
      var this$13 = $m_s_Predef$().fB($f_T__split__T__I__AT(x0$2, "\\\\[lr]", 0));
      b.fO($m_sci_Vector$().X(this$13));
    }
    var raw = b.bY();
  }
  var cleaned = raw.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((s) => $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_LabelSummary$__collapse__T__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_LabelSummary$(), s)))).bw(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4) => (_$4 !== "")))).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$5) => $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_LabelSummary$__truncate__T__I__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_LabelSummary$(), _$5, maxLen))));
  return ((cleaned.C() <= maxLines) ? cleaned : cleaned.pH(0, ((maxLines - 1) | 0)).bv("\u2026"));
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_LabelSummary$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_LabelSummary$, "org.jpablo.graphexplorer.viewer.formats.dot.LabelSummary$", ({
  A9: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_LabelSummary$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_LabelSummary$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_LabelSummary$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_LabelSummary$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_LabelSummary$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_LabelSummary$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_TextUtils$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_TextUtils$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_TextUtils$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_TextUtils$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_TextUtils$.prototype = $p;
$p.a3j = (function(userText) {
  return $f_T__replaceAll__T__T__T($f_T__replaceAll__T__T__T(userText, "\\\\", "\\\\\\\\"), "\n", "\\\\n");
});
$p.ain = (function(dotText) {
  var sb = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  var i = 0;
  while ((i < dotText.length)) {
    var index = i;
    var c = dotText.charCodeAt(index);
    if (((c === 92) && (((1 + i) | 0) < dotText.length))) {
      matchResult1: {
        var index$1 = ((1 + i) | 0);
        var x1 = dotText.charCodeAt(index$1);
        if ((x1 === 92)) {
          sb.jl(92);
          break matchResult1;
        }
        if ((x1 === 110)) {
          sb.jl(10);
          break matchResult1;
        }
        sb.jl(92).jl(x1);
      }
      i = ((2 + i) | 0);
    } else {
      sb.jl(c);
      i = ((1 + i) | 0);
    }
  }
  return sb.bP.ah;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_TextUtils$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_TextUtils$, "org.jpablo.graphexplorer.viewer.formats.dot.TextUtils$", ({
  Ab: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_TextUtils$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_TextUtils$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_TextUtils$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_TextUtils$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_TextUtils$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_TextUtils$;
}
function $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($thiz) {
  var this$1 = $objectGetClass($thiz).a3F();
  var this$2 = this$1.toLowerCase();
  return this$2.split("$").join("");
}
function $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2($thiz) {
  var xs = $thiz.aW();
  var f = ((v) => new $c_T2($dp_toString__T(v), v));
  var len = $m_jl_reflect_Array$().c6(xs);
  var ys = new ($d_T2.r().C)(len);
  if ((len > 0)) {
    var i = 0;
    if ((xs instanceof $ac_O)) {
      while ((i < len)) {
        var $x_1 = i;
        var x0 = xs.a[i];
        ys.a[$x_1] = f(x0);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_I)) {
      while ((i < len)) {
        var $x_2 = i;
        var x0$1 = xs.a[i];
        ys.a[$x_2] = f(x0$1);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_D)) {
      while ((i < len)) {
        var $x_3 = i;
        var x0$2 = xs.a[i];
        ys.a[$x_3] = f(x0$2);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_J)) {
      while ((i < len)) {
        var $x_6 = i;
        var $x_4 = xs.a;
        var $x_5 = (i << 1);
        var x0$3_$_lo = $x_4[$x_5];
        var x0$3_$_hi = $x_4[(($x_5 + 1) | 0)];
        ys.a[$x_6] = f($bL(x0$3_$_lo, x0$3_$_hi));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_F)) {
      while ((i < len)) {
        var $x_7 = i;
        var x0$4 = xs.a[i];
        ys.a[$x_7] = f(x0$4);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_C)) {
      while ((i < len)) {
        var $x_8 = i;
        var x0$5 = xs.a[i];
        ys.a[$x_8] = f($bC(x0$5));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_B)) {
      while ((i < len)) {
        var $x_9 = i;
        var x0$6 = xs.a[i];
        ys.a[$x_9] = f(x0$6);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_S)) {
      while ((i < len)) {
        var $x_10 = i;
        var x0$7 = xs.a[i];
        ys.a[$x_10] = f(x0$7);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_Z)) {
      while ((i < len)) {
        var $x_11 = i;
        var x0$8 = xs.a[i];
        ys.a[$x_11] = f(x0$8);
        i = ((1 + i) | 0);
      }
    } else {
      throw new $c_s_MatchError(xs);
    }
  }
  return ys;
}
function $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set($thiz) {
  return $m_sci_Set$().af($m_s_Predef$().fB($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$().aTk()));
}
function $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option($thiz, s) {
  var xs = $thiz.aW();
  _return: {
    var i = 0;
    while ((i < $m_jl_reflect_Array$().c6(xs))) {
      if (($dp_toString__T($m_sr_ScalaRunTime$().f6(xs, i)) === s)) {
        var idx = i;
        break _return;
      }
      i = ((1 + i) | 0);
    }
    var idx = (-1);
  }
  return ((idx === (-1)) ? $m_s_None$() : new $c_s_Some($m_sr_ScalaRunTime$().f6(xs, idx)));
}
function $is_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.o)));
}
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.o)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute = new $TypeData().i(1, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.DotAttribute", ({
  o: 1
}));
function $f_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps__$init$__V($thiz) {
  $thiz.aaE = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().Au($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_AttributePair.r().C)([new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributePair$$anon$3(new $c_T2($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Sides$(), 5)), new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributePair$$anon$3(new $c_T2($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__box__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape()))])));
  matchResult2: {
    var dir;
    var x5 = $thiz.iC;
    var x = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$__graph__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType();
    if (((x === null) ? (x5 === null) : (x === x5))) {
      var dir = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$__none__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType();
      break matchResult2;
    }
    var x$3 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$__digraph__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType();
    if (((x$3 === null) ? (x5 === null) : (x$3 === x5))) {
      var dir = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$__both__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType();
      break matchResult2;
    }
    throw new $c_s_MatchError(x5);
  }
  $thiz.a0K = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().Au($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_AttributePair.r().C)([new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributePair$$anon$3(new $c_T2($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Dir$(), dir)), new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributePair$$anon$3(new $c_T2($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowHead$(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__vee__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType())), new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributePair$$anon$3(new $c_T2($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowTail$(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__none__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType()))])));
}
function $f_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps__withoutUnsupportedFeatures__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph($thiz) {
  var this$13 = new $c_Lcom_softwaremill_quicklens_package$PathModify($thiz, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x) => {
    var nodes = $thiz.aA.gr;
    var arrows = $thiz.aA.gH;
    var memberships = $thiz.aA.gq;
    var arrowMemberships = $thiz.aA.gp;
    var groups = $thiz.aA.fh;
    var ev$21 = x.i(new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes($thiz.aA.dW));
    return new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements(nodes, arrows, memberships, arrowMemberships, groups, ((ev$21 === null) ? null : ev$21.ce), $thiz.aA.fE, $thiz.aA.fD), $thiz.j7, $thiz.iC, $thiz.jG, $thiz.jF, $thiz.i0);
  })));
  var mod = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => {
    var _$2 = ((v1 === null) ? null : v1.ce);
    return new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes($m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().a2q($m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().a2q(_$2, $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Size$())), $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap$())));
  }));
  return this$13.eF.i(mod);
}
function $f_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps__updateAttributes__sci_Set__Lorg_jpablo_graphexplorer_viewer_models_AttributeUpdates__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph($thiz, ids, selectionAttrs) {
  var classified = $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().gV(ids);
  var updatedArrows = $m_sci_Map$().ao(new $c_sc_MapView$MapValues(new $c_sc_MapView$FilterKeys(new $c_sc_MapView$Id($thiz.fX), classified.gf), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3) => {
    var this$4 = new $c_Lcom_softwaremill_quicklens_package$PathModify(_$3, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3$2) => ((x) => {
      var source = _$3$2.bX;
      var target = _$3$2.c0;
      var ev$22 = x.i(new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(_$3$2.fG));
      return new $c_Lorg_jpablo_graphexplorer_viewer_models_Arrow(source, target, ((ev$22 === null) ? null : ev$22.ce), _$3$2.iD, _$3$2.iE, _$3$2.jH);
    }))(_$3)));
    var mod = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => {
      var attrs = ((v1 === null) ? null : v1.ce);
      return new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(selectionAttrs.Wk(attrs));
    }));
    return this$4.eF.i(mod);
  }))));
  var updatedClusters = $m_sci_Map$().ao(new $c_sc_MapView$MapValues(new $c_sc_MapView$FilterKeys(new $c_sc_MapView$Id($thiz.hu), classified.f3), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$5) => {
    var this$10 = _$5.yg();
    var mod$1 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1$1) => {
      var attrs$1 = ((v1$1 === null) ? null : v1$1.ce);
      return new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes($m_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$().aQw(selectionAttrs.Wk(attrs$1)));
    }));
    return this$10.eF.i(mod$1);
  }))));
  var this$16 = classified.gg;
  var z = $thiz.dQ;
  var f$3 = ((nodes, id) => {
    var x1 = nodes.r(id);
    if ((x1 instanceof $c_s_Some)) {
      var $x_1 = x1.J;
    } else {
      if ((!($m_s_None$() === x1))) {
        throw new $c_s_MatchError(x1);
      }
      var $x_1 = $m_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$().a4f(id, ($m_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$(), $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV));
    }
    var this$15 = $x_1.yg();
    var mod$2 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1$2) => {
      var attrs$2 = ((v1$2 === null) ? null : v1$2.ce);
      return new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes($m_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$().aQw(selectionAttrs.Wk(attrs$2)));
    }));
    return nodes.AJ(id, this$15.eF.i(mod$2));
  });
  if ($is_sc_IndexedSeq(this$16)) {
    var at = 0;
    var end = this$16.C();
    var acc = z;
    var $x_2;
    while (true) {
      if ((at !== end)) {
        var temp$at = ((1 + at) | 0);
        var x0 = acc;
        var x1$1 = this$16.l(at);
        var temp$acc = f$3(x0, x1$1);
        at = temp$at;
        acc = temp$acc;
        continue;
      }
      var $x_2 = acc;
      break;
    }
  } else {
    var result = z;
    var it = this$16.o();
    while (it.p()) {
      var x0$1 = result;
      var x1$2 = it.q();
      result = f$3(x0$1, x1$2);
    }
    var $x_2 = result;
  }
  var updatedNodes = $x_2;
  var this$20 = $thiz.GH;
  var mod$3 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6) => {
    var arrows$1 = $thiz.fX.hN(updatedArrows);
    var groups$1 = $thiz.hu.hN(updatedClusters);
    return new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements(updatedNodes, arrows$1, _$6.gq, _$6.gp, groups$1, _$6.dW, _$6.fE, _$6.fD);
  }));
  return this$20.eF.i(mod$3);
}
function $f_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps__getAttributesById__Lorg_jpablo_graphexplorer_viewer_models_ElementId__sci_Map($thiz, id) {
  if ((id instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowId)) {
    var this$1 = $thiz.fX.r(id);
    return (this$1.c() ? new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes($m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV) : new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(this$1.d().fG)).ce;
  }
  if ((id instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId)) {
    var this$2 = $thiz.hu.r(id);
    return (this$2.c() ? new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes($m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV) : new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(this$2.d().kb)).ce;
  }
  if ((id instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId)) {
    var this$3 = $thiz.dQ.r(id);
    return (this$3.c() ? new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes($m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV) : new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(this$3.d().fH)).ce;
  }
  throw new $c_s_MatchError(id);
}
function $f_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps__getAttributesUpdatesById__sci_Set__Lorg_jpablo_graphexplorer_viewer_models_AttributeUpdates($thiz, elementIds) {
  var mermaidStyleIndex = $m_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex$().b1M($thiz.aA.dW);
  var z = $m_sci_Map$EmptyMap$();
  var f = ((attrs, elementId) => {
    var baseAttrs = $f_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps__getAttributesById__Lorg_jpablo_graphexplorer_viewer_models_ElementId__sci_Map($thiz, elementId);
    return attrs.hN($m_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$().bbU(elementId, baseAttrs, mermaidStyleIndex).wk(new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((attrs$2) => ((attrId, v) => {
      var attrId$1 = ((attrId === null) ? null : attrId.fY);
      return ((attrs$2.E(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId(attrId$1)) && (!attrs$2.i(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId(attrId$1)).Py(v, $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$().nx()))) ? $s_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$__Multiple__Lorg_jpablo_graphexplorer_viewer_models_AttrStatus() : new $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single(v));
    }))(attrs))));
  });
  if ($is_sc_IndexedSeq(elementIds)) {
    var at = 0;
    var end = elementIds.C();
    var acc = z;
    var $x_1;
    while (true) {
      if ((at !== end)) {
        var temp$at = ((1 + at) | 0);
        var x0 = acc;
        var x1 = elementIds.l(at);
        var temp$acc = f(x0, x1);
        at = temp$at;
        acc = temp$acc;
        continue;
      }
      var $x_1 = acc;
      break;
    }
  } else {
    var result = z;
    var it = elementIds.o();
    while (it.p()) {
      var x0$1 = result;
      var x1$1 = it.q();
      result = f(x0$1, x1$1);
    }
    var $x_1 = result;
  }
  return new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeUpdates($x_1);
}
function $f_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps__withDefaultTheme__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph($thiz) {
  var obj$proxy1 = new $c_Lcom_softwaremill_quicklens_package$PathModify($thiz, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x) => {
    var nodes = $thiz.aA.gr;
    var arrows = $thiz.aA.gH;
    var memberships = $thiz.aA.gq;
    var arrowMemberships = $thiz.aA.gp;
    var groups = $thiz.aA.fh;
    var graphAttributes = $thiz.aA.dW;
    var ev$26 = x.i(new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes($thiz.aA.fE));
    return new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements(nodes, arrows, memberships, arrowMemberships, groups, graphAttributes, ((ev$26 === null) ? null : ev$26.ce), $thiz.aA.fD), $thiz.j7, $thiz.iC, $thiz.jG, $thiz.jF, $thiz.i0);
  }))).Y3(new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes($thiz.aaE));
  return new $c_Lcom_softwaremill_quicklens_package$PathModify(obj$proxy1, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2) => {
    var nodes$1 = obj$proxy1.aA.gr;
    var arrows$1 = obj$proxy1.aA.gH;
    var memberships$1 = obj$proxy1.aA.gq;
    var arrowMemberships$1 = obj$proxy1.aA.gp;
    var groups$1 = obj$proxy1.aA.fh;
    var graphAttributes$1 = obj$proxy1.aA.dW;
    var defaultNodeAttributes$1 = obj$proxy1.aA.fE;
    var ev$27 = x$2.i(new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(obj$proxy1.aA.fD));
    return new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements(nodes$1, arrows$1, memberships$1, arrowMemberships$1, groups$1, graphAttributes$1, defaultNodeAttributes$1, ((ev$27 === null) ? null : ev$27.ce)), obj$proxy1.j7, obj$proxy1.iC, obj$proxy1.jG, obj$proxy1.jF, obj$proxy1.i0);
  }))).Y3(new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes($thiz.a0K));
}
function $f_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps__resetAttributes__sci_Set__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph($thiz, selection) {
  var keepAttributes = $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_T.r().C)([$f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Label$()), $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Cluster$())])));
  var f$1 = ((currentGraph, elementId) => {
    var currentAttrs = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().ba7($f_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps__getAttributesById__Lorg_jpablo_graphexplorer_viewer_models_ElementId__sci_Map(currentGraph, elementId));
    if (currentAttrs.c()) {
      return currentGraph;
    } else {
      var f = ((_$12) => _$12.Tq);
      var $x_2 = $m_sci_Set$();
      if ((currentAttrs === $m_sci_Nil$())) {
        var $x_1 = $m_sci_Nil$();
      } else {
        var x0 = currentAttrs.t();
        var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
        var t = h;
        var rest = currentAttrs.v();
        while ((rest !== $m_sci_Nil$())) {
          var x0$1 = rest.t();
          var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
          t.U = nx;
          t = nx;
          rest = rest.v();
        }
        var $x_1 = h;
      }
      var keysToRemove = $x_2.af($x_1).jv(keepAttributes);
      if (keysToRemove.c()) {
        return currentGraph;
      } else {
        var updateForThisElement = $m_Lorg_jpablo_graphexplorer_viewer_models_AttributeUpdates$().aRv(keysToRemove.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$13) => new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId(_$13)))));
        return $f_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps__updateAttributes__sci_Set__Lorg_jpablo_graphexplorer_viewer_models_AttributeUpdates__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(currentGraph, $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_ElementId.r().C)([elementId]))), updateForThisElement);
      }
    }
  });
  if ($is_sc_IndexedSeq(selection)) {
    var at = 0;
    var end = selection.C();
    var acc = $thiz;
    var $x_3;
    while (true) {
      if ((at !== end)) {
        var temp$at = ((1 + at) | 0);
        var x0$2 = acc;
        var x1 = selection.l(at);
        var temp$acc = f$1(x0$2, x1);
        at = temp$at;
        acc = temp$acc;
        continue;
      }
      var $x_3 = acc;
      break;
    }
  } else {
    var result = $thiz;
    var it = selection.o();
    while (it.p()) {
      var x0$3 = result;
      var x1$1 = it.q();
      result = f$1(x0$3, x1$1);
    }
    var $x_3 = result;
  }
  return $x_3;
}
function $p_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$__withMermaidEffectiveMemberAttrs__sci_Map__Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex__T__sci_Map($thiz, memberAttrs, mermaidStyleIndex, strokeAttr) {
  matchResult12: {
    var \u03b41$___1;
    var \u03b41$___2;
    var x31 = $p_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$__resolveMermaidClassAndInlineStyles__sci_Map__Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex__T2($thiz, memberAttrs, mermaidStyleIndex);
    if ((x31 !== null)) {
      var \u03b41$___1 = x31.g();
      var \u03b41$___2 = x31.h();
      break matchResult12;
    }
    throw new $c_s_MatchError(x31);
  }
  var effectiveStyles$2 = \u03b41$___1;
  var effectiveTextStyles$2 = \u03b41$___2;
  if ((effectiveStyles$2.c() && effectiveTextStyles$2.c())) {
    return memberAttrs;
  } else {
    var derived = new $c_scm_ListBuffer();
    var this$3 = effectiveStyles$2.r("fill");
    if ((!this$3.c())) {
      var x0 = this$3.d();
      derived.bb(new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillColor$())), ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(x0))));
    }
    var this$8 = effectiveStyles$2.r("stroke");
    if ((!this$8.c())) {
      var x0$1 = this$8.d();
      derived.bb(new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId(strokeAttr), ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(x0$1))));
    }
    var this$12 = effectiveStyles$2.r("stroke-width");
    if (this$12.c()) {
      var $x_1 = $m_s_None$();
    } else {
      var x0$2 = this$12.d();
      var $x_1 = $p_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$__parseCssNumber__T__s_Option($m_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$(), x0$2);
    }
    var this$13 = $x_1;
    if ((!this$13.c())) {
      var x0$3 = this$13.d();
      derived.bb(new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_PenWidth$())), ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(x0$3))));
    }
    var this$18 = effectiveStyles$2.r("font-family");
    if ((!this$18.c())) {
      var x0$4 = this$18.d();
      derived.bb(new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontName$())), ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(x0$4))));
    }
    var this$23 = effectiveStyles$2.r("font-size");
    if (this$23.c()) {
      var $x_2 = $m_s_None$();
    } else {
      var x0$5 = this$23.d();
      var $x_2 = $p_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$__parseCssNumber__T__s_Option($m_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$(), x0$5);
    }
    var this$24 = $x_2;
    if ((!this$24.c())) {
      var x0$6 = this$24.d();
      derived.bb(new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontSize$())), ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(x0$6))));
    }
    var this$29 = effectiveStyles$2.r("color");
    var this$30 = (this$29.c() ? effectiveTextStyles$2.r("fill") : this$29);
    if ((!this$30.c())) {
      var x0$7 = this$30.d();
      derived.bb(new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontColor$())), ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(x0$7))));
    }
    var b = $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), new $c_scm_ListBuffer());
    var it = derived.o();
    while (it.p()) {
      var elem$6 = it.q();
      var attrId = ((elem$6.g() === null) ? null : elem$6.g().fY);
      elem$6.h();
      if ((!memberAttrs.E(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId(attrId)))) {
        b.mI(elem$6);
      }
    }
    var derivedMissingOnly = b.gj.eX($m_s_$less$colon$less$().b1);
    return $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().aMY(memberAttrs, derivedMissingOnly);
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$__withMermaidEffectiveEdgeAttrs__sci_Map__Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex__sci_Map($thiz, edgeAttrs, mermaidStyleIndex) {
  var this$1 = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().X0(edgeAttrs, $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$().a09);
  var this$2 = (this$1.c() ? $m_s_None$() : new $c_s_Some($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidStyleDeclarations$().Az(this$1.d().m())));
  var perEdgeStyle = (this$2.c() ? $m_sci_VectorMap$().jg : this$2.d());
  var effectiveStyles = $f_sci_StrictOptimizedMapOps__concat__sc_IterableOnce__sci_MapOps(mermaidStyleIndex.Tt, perEdgeStyle);
  if (effectiveStyles.c()) {
    return edgeAttrs;
  } else {
    var derived = new $c_scm_ListBuffer();
    var this$5 = effectiveStyles.r("stroke");
    if ((!this$5.c())) {
      var x0$1 = this$5.d();
      derived.bb(new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Color$())), ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(x0$1))));
    }
    var this$10 = effectiveStyles.r("stroke-width");
    if (this$10.c()) {
      var $x_1 = $m_s_None$();
    } else {
      var x0$2 = this$10.d();
      var $x_1 = $p_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$__parseCssNumber__T__s_Option($m_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$(), x0$2);
    }
    var this$11 = $x_1;
    if ((!this$11.c())) {
      var x0$3 = this$11.d();
      derived.bb(new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_PenWidth$())), ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(x0$3))));
    }
    var this$16 = effectiveStyles.r("color");
    if ((!this$16.c())) {
      var x0$4 = this$16.d();
      derived.bb(new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontColor$())), ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(x0$4))));
    }
    var this$21 = effectiveStyles.r("font-family");
    if ((!this$21.c())) {
      var x0$5 = this$21.d();
      derived.bb(new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontName$())), ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(x0$5))));
    }
    var this$26 = effectiveStyles.r("font-size");
    if (this$26.c()) {
      var $x_2 = $m_s_None$();
    } else {
      var x0$6 = this$26.d();
      var $x_2 = $p_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$__parseCssNumber__T__s_Option($m_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$(), x0$6);
    }
    var this$27 = $x_2;
    if ((!this$27.c())) {
      var x0$7 = this$27.d();
      derived.bb(new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontSize$())), ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(x0$7))));
    }
    var b = $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), new $c_scm_ListBuffer());
    var it = derived.o();
    while (it.p()) {
      var elem$5 = it.q();
      var attrId = ((elem$5.g() === null) ? null : elem$5.g().fY);
      elem$5.h();
      if ((!edgeAttrs.E(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId(attrId)))) {
        b.mI(elem$5);
      }
    }
    var derivedMissingOnly = b.gj.eX($m_s_$less$colon$less$().b1);
    return $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().aMY(edgeAttrs, derivedMissingOnly);
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$__resolveMermaidClassAndInlineStyles__sci_Map__Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex__T2($thiz, attrs, mermaidStyleIndex) {
  var this$1 = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().X0(attrs, $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$().FV).bM();
  var rest = this$1;
  var h = null;
  var t = null;
  while ((rest !== $m_sci_Nil$())) {
    var x0 = rest.t();
    var it = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$().aQX(x0.m()).o();
    while (it.p()) {
      var nx = new $c_sci_$colon$colon(it.q(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        t.U = nx;
      }
      t = nx;
    }
    rest = rest.v();
  }
  var classNames = ((h === null) ? $m_sci_Nil$() : h);
  var defaultStyles = mermaidStyleIndex.Ml.ay("default", new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_VectorMap$().jg)));
  var defaultTextStyles = mermaidStyleIndex.Mk.ay("default", new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_VectorMap$().jg)));
  var f = ((name) => mermaidStyleIndex.Ml.ay(name, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_VectorMap$().jg))));
  if ((classNames === $m_sci_Nil$())) {
    var classStyleLayers = $m_sci_Nil$();
  } else {
    var x0$1 = classNames.t();
    var h$1 = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
    var t$1 = h$1;
    var rest$1 = classNames.v();
    while ((rest$1 !== $m_sci_Nil$())) {
      var x0$2 = rest$1.t();
      var nx$1 = new $c_sci_$colon$colon(f(x0$2), $m_sci_Nil$());
      t$1.U = nx$1;
      t$1 = nx$1;
      rest$1 = rest$1.v();
    }
    var classStyleLayers = h$1;
  }
  var f$1 = ((name$2) => mermaidStyleIndex.Mk.ay(name$2, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_VectorMap$().jg))));
  if ((classNames === $m_sci_Nil$())) {
    var classTextLayers = $m_sci_Nil$();
  } else {
    var x0$3 = classNames.t();
    var h$2 = new $c_sci_$colon$colon(f$1(x0$3), $m_sci_Nil$());
    var t$2 = h$2;
    var rest$2 = classNames.v();
    while ((rest$2 !== $m_sci_Nil$())) {
      var x0$4 = rest$2.t();
      var nx$2 = new $c_sci_$colon$colon(f$1(x0$4), $m_sci_Nil$());
      t$2.U = nx$2;
      t$2 = nx$2;
      rest$2 = rest$2.v();
    }
    var classTextLayers = h$2;
  }
  var $x_1 = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidStyleDeclarations$();
  var this$3 = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().X0(attrs, $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$()));
  var inlineStyleLayer = $x_1.Az((this$3.c() ? "" : this$3.d().m()));
  var effectiveStyles = $f_sc_StrictOptimizedSeqOps__appended__O__O(classStyleLayers.Ec(defaultStyles), inlineStyleLayer).hO($m_sci_VectorMap$().jg, new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((_$18, _$19) => $f_sci_StrictOptimizedMapOps__concat__sc_IterableOnce__sci_MapOps(_$18, _$19))));
  var this$5 = classTextLayers.Ec(defaultTextStyles);
  var z = $m_sci_VectorMap$().jg;
  var acc = z;
  var these = this$5;
  while ((!these.c())) {
    acc = $f_sci_StrictOptimizedMapOps__concat__sc_IterableOnce__sci_MapOps(acc, these.t());
    these = these.v();
  }
  return new $c_T2(effectiveStyles, acc);
}
function $p_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$__parseCssNumber__T__s_Option($thiz, rawValue) {
  var x34 = $f_T__trim__T(rawValue);
  if ((x34 !== null)) {
    var x35 = $thiz.aEI.jw(x34);
    if ((!x35.c())) {
      var x36 = x35.d();
      if ((x36.bL(1) === 0)) {
        return new $c_s_Some($f_sc_LinearSeqOps__apply__I__O(x36, 0));
      }
    }
  }
  return $m_s_None$();
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$() {
  this.aEI = null;
  $n_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$ = this;
  this.aEI = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "([+-]?\\d*\\.?\\d+)(?:[a-zA-Z%]+)?", $m_sci_Nil$());
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$.prototype = $p;
$p.aQw = (function(attrs) {
  var fc = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().qZ(attrs, $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillColor$());
  if ((fc instanceof $c_s_Some)) {
    if ((fc.J.m() === $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillColor$().a0G)) {
      $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$();
      var this$ = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().W6(attrs, $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillColor$());
      var self = new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillStyle$()));
      $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$();
      var y = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue("false");
      $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$();
      return this$.bN(self, y);
    }
    $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$();
    var self$1 = new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillStyle$()));
    $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$();
    var y$1 = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue("true");
    $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$();
    return attrs.bN(self$1, y$1);
  }
  if (($m_s_None$() === fc)) {
    return attrs;
  }
  throw new $c_s_MatchError(fc);
});
$p.aZU = (function() {
  return new $c_Lorg_jpablo_graphexplorer_viewer_models_Lens(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((graph) => $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().aih(graph.aA.dW))), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((graph$2, updates) => {
    var this$10 = new $c_Lcom_softwaremill_quicklens_package$PathModify(graph$2, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((graph$2$1) => ((x) => {
      var nodes = graph$2$1.aA.gr;
      var arrows = graph$2$1.aA.gH;
      var memberships = graph$2$1.aA.gq;
      var arrowMemberships = graph$2$1.aA.gp;
      var groups = graph$2$1.aA.fh;
      var ev$28 = x.i(new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(graph$2$1.aA.dW));
      return new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements(nodes, arrows, memberships, arrowMemberships, groups, ((ev$28 === null) ? null : ev$28.ce), graph$2$1.aA.fE, graph$2$1.aA.fD), graph$2$1.j7, graph$2$1.iC, graph$2$1.jG, graph$2$1.jF, graph$2$1.i0);
    }))(graph$2)));
    var mod = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((updates$2) => ((v1) => {
      var attrs = ((v1 === null) ? null : v1.ce);
      return new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(updates$2.Wk(attrs));
    }))(updates));
    return this$10.eF.i(mod);
  })));
});
$p.b0p = (function(elementIds) {
  return new $c_Lorg_jpablo_graphexplorer_viewer_models_Lens(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((graph) => $f_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps__getAttributesUpdatesById__sci_Set__Lorg_jpablo_graphexplorer_viewer_models_AttributeUpdates(graph, elementIds))), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((graph$2, updates) => $f_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps__updateAttributes__sci_Set__Lorg_jpablo_graphexplorer_viewer_models_AttributeUpdates__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(graph$2, elementIds, updates))));
});
$p.bbU = (function(elementId, attrs, mermaidStyleIndex) {
  if ((elementId instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId)) {
    return $p_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$__withMermaidEffectiveMemberAttrs__sci_Map__Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex__T__sci_Map(this, attrs, mermaidStyleIndex, $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Color$()));
  }
  if ((elementId instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowId)) {
    return $p_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$__withMermaidEffectiveEdgeAttrs__sci_Map__Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex__sci_Map(this, attrs, mermaidStyleIndex);
  }
  if ((elementId instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId)) {
    return $p_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$__withMermaidEffectiveMemberAttrs__sci_Map__Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex__T__sci_Map(this, attrs, mermaidStyleIndex, $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_PenColor$()));
  }
  throw new $c_s_MatchError(elementId);
});
var $d_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$, "org.jpablo.graphexplorer.viewer.graph.AttributesOps$", ({
  Cm: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$;
function $m_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$ = new $c_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$;
}
function $f_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps__proxyOrigin__Lorg_jpablo_graphexplorer_viewer_models_ElementId__s_Option($thiz, id) {
  return ((id instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId) ? $thiz.i0.r(id) : $m_s_None$());
}
function $f_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps__resolveProxies__sci_Set__sci_Set($thiz, ids) {
  return ($thiz.i0.c() ? ids : ids.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((id) => {
    var this$2 = $f_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps__proxyOrigin__Lorg_jpablo_graphexplorer_viewer_models_ElementId__s_Option($thiz, id);
    return (this$2.c() ? id : this$2.d());
  }))));
}
function $f_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps__renderedId__Lorg_jpablo_graphexplorer_viewer_models_ElementId__Lorg_jpablo_graphexplorer_viewer_models_ElementId($thiz, id) {
  return ((id instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId) ? $thiz.b6W().ay(id, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((g$2) => (() => g$2))(id))) : id);
}
function $f_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps__proxyForGroup__sci_Map($thiz) {
  return $thiz.i0.kP(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => _$1.b9A())));
}
function $f_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps__proxyIds__sci_Set($thiz) {
  return $thiz.i0.ln();
}
function $f_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps__effectiveCollapsed__sci_Set__sci_Set($thiz, collapsed) {
  return collapsed.bw(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((g) => ($thiz.hu.E(g) && (!$p_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps__hasCollapsedAncestor$1__sci_Set__Lorg_jpablo_graphexplorer_viewer_models_GroupId__Z($thiz, collapsed, g))))));
}
function $f_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps__collapsedView__sci_Set__sci_Set__Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$CollapsedView($thiz, collapsed, hidden) {
  var outermost = $f_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps__effectiveCollapsed__sci_Set__sci_Set($thiz, collapsed);
  var g2 = $f_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps__collapseGroups__sci_Set__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph($thiz, collapsed);
  if (outermost.c()) {
    return new $c_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$CollapsedView(g2, hidden, $m_sci_Map$EmptyMap$());
  } else {
    var changed = $p_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps__rewriteArrows__sci_Map__sci_Vector($thiz, $p_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps__proxyMapFor__sci_Set__sci_Map($thiz, outermost)).d8(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
      var o = x$1.g();
      var r = x$1.h();
      var x = o.dw;
      var x$2 = r.dw;
      return (!((x === null) ? (x$2 === null) : x.e(x$2)));
    })), false);
    var m = $m_scm_Map$().aO();
    var it = changed.o();
    while (it.p()) {
      var elem = it.q();
      elem.g();
      var r$1 = elem.h();
      var key = new $c_T4(r$1.bX, r$1.c0, r$1.iD, r$1.iE);
      m.ec(key, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
        $m_sci_Vector$();
        return new $c_sci_VectorBuilder();
      }))).Y(elem);
    }
    var result = $m_sci_HashMap$().fk;
    var mapIt = m.o();
    while (mapIt.p()) {
      var x1 = mapIt.q();
      if ((x1 === null)) {
        throw new $c_s_MatchError(x1);
      }
      var k = x1.g();
      var v = x1.h();
      result = result.hq(k, v.aR());
    }
    var this$8 = result;
    $m_sci_HashMap$();
    var b = new $c_sci_HashMapBuilder();
    var it$1 = this$8.o();
    while (it$1.p()) {
      var x0 = it$1.q();
      x0.g();
      var grp = x0.h();
      var self = grp.t().h().dw;
      var y = $m_sci_Set$().af(grp.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4) => _$4.g().dw))));
      $p_sci_HashMapBuilder__ensureUnaliased__V(b);
      var h = $m_sr_Statics$().u(self);
      var im = $m_sc_Hashing$().bz(h);
      b.JE(b.qA, self, y, h, im, 0);
    }
    var underlying = b.a4x();
    var hiddenArrowIds = $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().gV(hidden).gf;
    var hiddenViewArrows = $m_sci_Set$().af($f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(underlying, new $c_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$$anon$1(hiddenArrowIds)));
    var hiddenProxies = $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().gV(hidden).f3.bw(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((elem$1) => outermost.E(elem$1)))).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((g) => {
      $m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$();
      return new $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId(g.dR);
    })));
    return new $c_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$CollapsedView(g2, $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().tS($m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().tS(hidden, hiddenViewArrows), hiddenProxies), underlying);
  }
}
function $f_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps__collapsedMemberCounts__sci_Set__sci_Map($thiz, collapsed) {
  return $m_sci_Map$().ao(new $c_sc_Iterator$$anon$9($f_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps__effectiveCollapsed__sci_Set__sci_Set($thiz, collapsed).o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((g) => new $c_T2(($m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$(), new $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId(g.dR)), $f_Lorg_jpablo_graphexplorer_viewer_graph_GroupsOps__getAllChildren__sci_Set__sci_Set($thiz, $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_GroupId.r().C)([g])))).ct(new $c_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$$anon$2()).aa())))));
}
function $p_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps__proxyMapFor__sci_Set__sci_Map($thiz, outermost) {
  return outermost.c5(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((g) => {
    $m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$();
    var proxy = new $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId(g.dR);
    return $f_Lorg_jpablo_graphexplorer_viewer_graph_GroupsOps__getAllChildren__sci_Set__sci_Set($thiz, $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_GroupId.r().C)([g])))).ct(new $c_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$$anon$3(proxy));
  }))).eX($m_s_$less$colon$less$().b1);
}
function $p_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps__rewriteArrows__sci_Map__sci_Vector($thiz, proxyOf) {
  var this$1 = $thiz.fX;
  return $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O($m_sci_Vector$().X(this$1), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var id = x$1.g();
    x$1.h();
    return id.l3;
  })), $m_s_math_Ordering$String$()).c5(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    x$1$2.g();
    var a = x$1$2.h();
    var s = proxyOf.ay(a.bX, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => a.bX)));
    var t = proxyOf.ay(a.c0, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => a.c0)));
    if (((((s === null) ? (t === null) : s.e(t)) && proxyOf.E(a.bX)) && proxyOf.E(a.c0))) {
      return $m_s_None$();
    } else {
      var x$4 = a.bX;
      if (((s === null) ? (x$4 === null) : s.e(x$4))) {
        var x$6 = a.c0;
        var $x_1 = ((t === null) ? (x$6 === null) : t.e(x$6));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        return new $c_s_Some(new $c_T2(a, a));
      } else {
        var x$8 = a.bX;
        if (((s === null) ? (x$8 === null) : s.e(x$8))) {
          var sourcePort$1 = a.iD;
        } else {
          var sourcePort$1 = $m_s_None$();
        }
        var x$10 = a.c0;
        if (((t === null) ? (x$10 === null) : t.e(x$10))) {
          var targetPort$1 = a.iE;
        } else {
          var targetPort$1 = $m_s_None$();
        }
        return new $c_s_Some(new $c_T2(a, new $c_Lorg_jpablo_graphexplorer_viewer_models_Arrow(s, t, a.fG, sourcePort$1, targetPort$1, a.jH)));
      }
    }
  })));
}
function $f_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps__collapseGroups__sci_Set__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph($thiz, collapsed) {
  var outermost = $f_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps__effectiveCollapsed__sci_Set__sci_Set($thiz, collapsed);
  if (outermost.c()) {
    return $thiz;
  } else {
    var proxyOf = $p_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps__proxyMapFor__sci_Set__sci_Map($thiz, outermost);
    var swallowedGroups = outermost.c5(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((g) => $f_Lorg_jpablo_graphexplorer_viewer_graph_GroupsOps__getAllChildren__sci_Set__sci_Set($thiz, $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_GroupId.r().C)([g])))).ct(new $c_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$$anon$4())))).dI(outermost);
    var proxies = $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O($m_sci_Seq$().fw(outermost), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$7) => _$7.dR)), $m_s_math_Ordering$String$()).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((g$2) => {
      $m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$();
      var proxyId = new $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId(g$2.dR);
      $m_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$();
      var attributes = $m_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$().b6V($thiz.hu.r(g$2), g$2);
      $m_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$();
      return new $c_T2(proxyId, new $c_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode(proxyId, attributes, ($m_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$(), $m_s_None$())));
    })));
    var this$11 = $thiz.dQ;
    $m_sci_VectorMap$();
    var b = new $c_sci_VectorMapBuilder();
    var it = new $c_sci_VectorMap$$anon$1(this$11);
    while (it.p()) {
      var elem = it.dC();
      var id = elem.g();
      elem.h();
      if ((!proxyOf.E(id))) {
        b.pm(elem.g(), elem.h());
      }
    }
    var remainingNodes = b.rb();
    var proxyMemberships = outermost.c5(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((g$3) => {
      var this$13 = $thiz.go.r(g$3);
      if (this$13.c()) {
        return $m_s_None$();
      } else {
        var x0 = this$13.d();
        return new $c_s_Some(new $c_T2(($m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$(), new $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId(g$3.dR)), x0));
      }
    }))).eX($m_s_$less$colon$less$().b1);
    var this$19 = $p_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps__rewriteArrows__sci_Map__sci_Vector($thiz, proxyOf).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$10) => _$10.h())));
    if ((this$19.bL(1) <= 0)) {
      var $x_1 = this$19;
    } else {
      var builder = this$19.fS();
      var seen = $ct_scm_HashSet__(new $c_scm_HashSet());
      var it$1 = this$19.o();
      var different = false;
      while (it$1.p()) {
        var next = it$1.q();
        if (seen.oA(new $c_T4(next.bX, next.c0, next.iD, next.iE))) {
          builder.Y(next);
        } else {
          different = true;
        }
      }
      var $x_1 = (different ? builder.aR() : this$19);
    }
    var rewritten = $x_1;
    var remainingArrows = rewritten.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((a$2) => new $c_T2(a$2.dw, a$2)))).eX($m_s_$less$colon$less$().b1);
    var remainingMemberships = $thiz.go.cE(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
      var memberId = x$1$2.g();
      var groupId = x$1$2.h();
      if (swallowedGroups.E(groupId)) {
        var $x_2 = true;
      } else {
        var this$25 = $f_Lorg_jpablo_graphexplorer_viewer_models_ElementId__asGroupId__s_Option(memberId);
        if ((!this$25.c())) {
          var x0$1 = this$25.d();
          var $x_2 = swallowedGroups.E(x0$1);
        } else {
          var $x_2 = false;
        }
      }
      if ($x_2) {
        return true;
      } else {
        var this$26 = $f_Lorg_jpablo_graphexplorer_viewer_models_ElementId__asNodeId__s_Option(memberId);
        if ((!this$26.c())) {
          var x0$2 = this$26.d();
          return proxyOf.E(x0$2);
        } else {
          return false;
        }
      }
    })));
    var origins = outermost.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((g$4) => new $c_T2(($m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$(), new $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId(g$4.dR)), g$4)))).eX($m_s_$less$colon$less$().b1);
    var this$32 = $thiz.GH;
    var mod = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$12) => {
      var nodes$1 = $f_sci_StrictOptimizedMapOps__concat__sc_IterableOnce__sci_MapOps(remainingNodes, proxies);
      var groups$1 = $thiz.hu.cE(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
        var id$1 = x$1.g();
        x$1.h();
        return swallowedGroups.E(id$1);
      })));
      return new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements(nodes$1, remainingArrows, remainingMemberships.hN(proxyMemberships), $thiz.aA.gp.cE(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$1) => {
        var arrowId = x$1$2$1.g();
        var groupId$1 = x$1$2$1.h();
        return (swallowedGroups.E(groupId$1) || (!remainingArrows.E(arrowId)));
      }))), groups$1, _$12.dW, _$12.fE, _$12.fD);
    }));
    var \u03b41$ = this$32.eF.i(mod);
    return new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(\u03b41$.aA, \u03b41$.j7, \u03b41$.iC, \u03b41$.jG, \u03b41$.jF, origins);
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps__hasCollapsedAncestor$1__sci_Set__Lorg_jpablo_graphexplorer_viewer_models_GroupId__Z($thiz, collapsed$1, g) {
  var g$tailLocal1 = g;
  while (true) {
    var id = g$tailLocal1;
    var x5 = $thiz.go.r(id);
    if (($m_s_None$() === x5)) {
      return false;
    }
    if ((x5 instanceof $c_s_Some)) {
      var parent = x5.J;
      if (collapsed$1.E(parent)) {
        return true;
      } else {
        g$tailLocal1 = parent;
        continue;
      }
    }
    throw new $c_s_MatchError(x5);
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$__carry$1__sci_Map__T__T__s_Option($thiz, groupAttrs$1, from, to) {
  var this$1 = groupAttrs$1.r(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId(from));
  var this$4 = (this$1.c() ? $m_s_None$() : new $c_s_Some(new $c_T2(to, this$1.d().m())));
  return ((this$4.c() || (this$4.d().h() !== "")) ? this$4 : $m_s_None$());
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$.prototype = $p;
$p.b6V = (function(source, g) {
  var this$1 = (source.c() ? $m_s_None$() : new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(source.d().kb)));
  var ev$15 = (this$1.c() ? new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes($m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV) : this$1.d());
  var groupAttrs = ((ev$15 === null) ? null : ev$15.ce);
  var this$3 = groupAttrs.r(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Label$())));
  var this$4 = (this$3.c() ? $m_s_None$() : new $c_s_Some(this$3.d().m()));
  var this$7 = ((this$4.c() || (this$4.d() !== "")) ? this$4 : $m_s_None$());
  var label = (this$7.c() ? g.dR : this$7.d());
  var this$10 = $p_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$__carry$1__sci_Map__T__T__s_Option(this, groupAttrs, $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BgColor$()), $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillColor$()));
  var fill = (this$10.c() ? $p_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$__carry$1__sci_Map__T__T__s_Option(this, groupAttrs, $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillColor$()), $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillColor$())) : this$10);
  return $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().aQB(new $c_sci_$colon$colon(new $c_T2($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Label$()), label), new $c_sci_$colon$colon(new $c_T2($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$()), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__folder__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape().m()), new $c_sci_$colon$colon(new $c_T2($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillStyle$()), "true"), $m_sci_Nil$()))).hK($m_s_Option$().m2(fill).iz()).hK($m_s_Option$().m2($p_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$__carry$1__sci_Map__T__T__s_Option(this, groupAttrs, $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Color$()), $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Color$()))).iz()));
});
var $d_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$, "org.jpablo.graphexplorer.viewer.graph.CollapseOps$", ({
  Cr: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$;
function $m_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$ = new $c_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_graph_CombineNodesOps__remapArrows__F1__T2($thiz, transform) {
  var arrowRemap = $m_sci_Seq$().fw($thiz.fX).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var oldId = x$1.g();
    var arrow = x$1.h();
    return new $c_T2(oldId, transform.i(arrow));
  })));
  var remapped = $m_sci_VectorMap$().u3(arrowRemap.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    x$1$2.g();
    var a = x$1$2.h();
    return new $c_T2(a.dw, a);
  }))));
  var idRemap = arrowRemap.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3) => new $c_T2(x$1$3.g(), x$1$3.h().dw)))).eX($m_s_$less$colon$less$().b1);
  return new $c_T2(remapped, $thiz.aA.gp.Pl(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$4) => {
    var oldId$2 = x$1$4.g();
    var g = x$1$4.h();
    var this$9 = idRemap.r(oldId$2);
    return (this$9.c() ? $m_s_None$() : new $c_s_Some(new $c_T2(this$9.d(), g)));
  }))));
}
function $f_Lorg_jpablo_graphexplorer_viewer_graph_CombineNodesOps__canCombineNodes__sci_Set__Z($thiz, nodeIds) {
  return ((nodeIds.aa() >= 2) && (nodeIds.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((key) => $thiz.go.r(key)))).aa() === 1));
}
function $f_Lorg_jpablo_graphexplorer_viewer_graph_CombineNodesOps__combineIntoRecord__sci_Set__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph($thiz, nodeIds) {
  if ((!$f_Lorg_jpablo_graphexplorer_viewer_graph_CombineNodesOps__canCombineNodes__sci_Set__Z($thiz, nodeIds))) {
    return $thiz;
  } else {
    var nodesToCombine = nodeIds.c5(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((id) => $thiz.dQ.r(id)))).iz();
    if ((nodesToCombine.C() !== nodeIds.aa())) {
      return $thiz;
    } else {
      var newNodeId = $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__nextAvailable$1__Lorg_jpablo_graphexplorer_viewer_models_NodeId($thiz);
      var this$3 = $thiz.aA.dW.r(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$())));
      if (this$3.c()) {
        var this$7 = $m_s_None$();
      } else {
        var x0 = this$3.d();
        var xs = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$().aTl();
        _return: {
          var i = 0;
          while ((i < xs.a.length)) {
            var x1 = i;
            if ((xs.a[x1].m() === x0.m())) {
              var idx = i;
              break _return;
            }
            i = ((1 + i) | 0);
          }
          var idx = (-1);
        }
        var this$7 = ((idx === (-1)) ? $m_s_None$() : new $c_s_Some(xs.a[idx]));
      }
      var rankdir = (this$7.c() ? $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$__TB__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir() : this$7.d());
      var recordLabel = $p_Lorg_jpablo_graphexplorer_viewer_graph_CombineNodesOps__createRecordLabel__sci_Seq__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir__T($thiz, nodesToCombine, rankdir);
      var groupMembership = $thiz.go.r(nodesToCombine.t().o7);
      var newNode = $m_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$().a4f(newNodeId, $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().Au($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_AttributePair.r().C)([new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributePair$$anon$3(new $c_T2($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__record__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape())), new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributePair$$anon$3(new $c_T2($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Label$(), recordLabel))]))));
      var portMapping = nodesToCombine.Es().L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
        if ((x$1 !== null)) {
          var node = x$1.g();
          var idx$1 = (x$1.h() | 0);
          return new $c_T2(node.o7, ("f" + idx$1));
        }
        throw new $c_s_MatchError(x$1);
      }))).eX($m_s_$less$colon$less$().b1);
      matchResult2: {
        var \u03b41$___1;
        var \u03b41$___2;
        var x4 = $p_Lorg_jpablo_graphexplorer_viewer_graph_CombineNodesOps__remapArrows__F1__T2($thiz, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((arrow) => {
          var source$1 = (portMapping.E(arrow.bX) ? newNodeId : arrow.bX);
          var target$1 = (portMapping.E(arrow.c0) ? newNodeId : arrow.c0);
          var this$17 = portMapping.r(arrow.bX);
          var sourcePort$1 = (this$17.c() ? arrow.iD : this$17);
          var this$18 = portMapping.r(arrow.c0);
          var targetPort$1 = (this$18.c() ? arrow.iE : this$18);
          return new $c_Lorg_jpablo_graphexplorer_viewer_models_Arrow(source$1, target$1, arrow.fG, sourcePort$1, targetPort$1, arrow.jH);
        })));
        if ((x4 !== null)) {
          var \u03b41$___1 = x4.g();
          var \u03b41$___2 = x4.h();
          break matchResult2;
        }
        throw new $c_s_MatchError(x4);
      }
      var remappedArrows$2 = \u03b41$___1;
      var updatedArrowMemberships$2 = \u03b41$___2;
      return new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements($f_sci_MapOps__removedAll__sc_IterableOnce__sci_MapOps($thiz.dQ, nodeIds).bN(newNodeId, newNode), remappedArrows$2, $thiz.go.XS(nodeIds).hN((groupMembership.c() ? $m_s_None$() : new $c_s_Some(new $c_T2(newNodeId, groupMembership.d())))), updatedArrowMemberships$2, $thiz.aA.fh, $thiz.aA.dW, $thiz.aA.fE, $thiz.aA.fD), $thiz.j7, $thiz.iC, $thiz.jG, $thiz.jF, $thiz.i0);
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_graph_CombineNodesOps__createRecordLabel__sci_Seq__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir__T($thiz, nodes, rankdir) {
  var fields = nodes.Es().L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    if ((x$1 !== null)) {
      var node = x$1.g();
      return new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Leaf(new $c_s_Some(("f" + (x$1.h() | 0))), $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$().aSt($f_Lorg_jpablo_graphexplorer_viewer_models_ViewerElement__label__Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(node).m()));
    }
    throw new $c_s_MatchError(x$1);
  }))).d2();
  matchResult4: {
    var root;
    matchAlts3: {
      matchAlts4: {
        var x = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$__TB__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir();
        if (((x === null) ? (rankdir === null) : (x === rankdir))) {
          break matchAlts4;
        }
        var x$3 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$__BT__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir();
        if (((x$3 === null) ? (rankdir === null) : (x$3 === rankdir))) {
          break matchAlts4;
        }
        break matchAlts3;
      }
      var root = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group($m_s_None$(), $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group.r().C)([new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group($m_s_None$(), fields)]))));
      break matchResult4;
    }
    matchAlts1: {
      matchAlts2: {
        var x$5 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$__LR__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir();
        if (((x$5 === null) ? (rankdir === null) : (x$5 === rankdir))) {
          break matchAlts2;
        }
        var x$7 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$__RL__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir();
        if (((x$7 === null) ? (rankdir === null) : (x$7 === rankdir))) {
          break matchAlts2;
        }
        break matchAlts1;
      }
      var root = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group($m_s_None$(), fields);
      break matchResult4;
    }
    throw new $c_s_MatchError(rankdir);
  }
  return $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$().a4H(root);
}
function $f_Lorg_jpablo_graphexplorer_viewer_graph_CombineNodesOps__isRecordNode__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Z($thiz, nodeId) {
  var this$1 = $thiz.dQ.r(nodeId);
  if ((!this$1.c())) {
    var x0 = this$1.d();
    var this$3 = x0.fH.r(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$())));
    if ((!this$3.c())) {
      var x0$1 = this$3.d();
      var shapeStr = x0$1.m();
      return ((shapeStr === "record") || (shapeStr === "Mrecord"));
    } else {
      return false;
    }
  } else {
    return false;
  }
}
function $f_Lorg_jpablo_graphexplorer_viewer_graph_CombineNodesOps__splitRecordNode__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph($thiz, nodeId) {
  if ((!$f_Lorg_jpablo_graphexplorer_viewer_graph_CombineNodesOps__isRecordNode__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Z($thiz, nodeId))) {
    return $thiz;
  } else {
    var x30 = $thiz.dQ.r(nodeId);
    if (($m_s_None$() === x30)) {
      return $thiz;
    }
    if ((x30 instanceof $c_s_Some)) {
      var recordNode = x30.J;
      var recordLabel = $f_Lorg_jpablo_graphexplorer_viewer_models_ViewerElement__label__Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(recordNode).m();
      var recordLeaves = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$().agS($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$().Je(recordLabel));
      var res = true;
      var it = recordLeaves.o();
      while ((res && it.p())) {
        res = (it.q().tl === "");
      }
      if (res) {
        return $thiz;
      } else {
        var groupMembership = $thiz.go.r(nodeId);
        var newNodes = recordLeaves.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((leaf) => {
          var newId = $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__nextAvailable$1__Lorg_jpablo_graphexplorer_viewer_models_NodeId($thiz);
          return new $c_T2(newId, $m_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$().a4f(newId, $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().Au($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_AttributePair.r().C)([new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributePair$$anon$3(new $c_T2($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Label$(), $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$__unescapeWith__T__Z__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$(), leaf.tl, false)))])))));
        })));
        var portToNodeMap = $m_sci_Map$().ao($f_sc_StrictOptimizedIterableOps__zipWithIndex__O(newNodes).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
          if ((x$1 !== null)) {
            var x12 = x$1.g();
            if ((x12 !== null)) {
              var newId$1 = x12.g();
              return new $c_T2(("f" + (x$1.h() | 0)), newId$1);
            }
          }
          throw new $c_s_MatchError(x$1);
        }))).iR($f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(recordLeaves, newNodes).c5(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
          if ((x$1$2 !== null)) {
            var x18 = x$1$2.h();
            var leaf$1 = x$1$2.g();
            if ((x18 !== null)) {
              var newId$2 = x18.g();
              var this$11 = leaf$1.vm;
              return (this$11.c() ? $m_s_None$() : new $c_s_Some(new $c_T2(this$11.d(), newId$2)));
            }
          }
          throw new $c_s_MatchError(x$1$2);
        })))));
        var firstNewNodeId = newNodes.t().g();
        matchResult7: {
          var \u03b42$___1;
          var \u03b42$___2;
          var x21 = $p_Lorg_jpablo_graphexplorer_viewer_graph_CombineNodesOps__remapArrows__F1__T2($thiz, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((arrow) => {
            var x$2 = arrow.bX;
            if (((x$2 === null) ? (nodeId === null) : x$2.e(nodeId))) {
              var this$16 = arrow.iD;
              if (this$16.c()) {
                var $x_1 = $m_s_None$();
              } else {
                var x0$2 = this$16.d();
                var $x_1 = portToNodeMap.r(x0$2);
              }
              var this$17 = $x_1;
              var \u03b43$___1 = (this$17.c() ? firstNewNodeId : this$17.d());
              var \u03b43$___2 = $m_s_None$();
            } else {
              var \u03b43$___1 = arrow.bX;
              var \u03b43$___2 = arrow.iD;
            }
            var newSource = \u03b43$___1;
            var newSourcePort = \u03b43$___2;
            var x$3 = arrow.c0;
            if (((x$3 === null) ? (nodeId === null) : x$3.e(nodeId))) {
              var this$20 = arrow.iE;
              if (this$20.c()) {
                var $x_2 = $m_s_None$();
              } else {
                var x0$3 = this$20.d();
                var $x_2 = portToNodeMap.r(x0$3);
              }
              var this$21 = $x_2;
              var \u03b44$___1 = (this$21.c() ? firstNewNodeId : this$21.d());
              var \u03b44$___2 = $m_s_None$();
            } else {
              var \u03b44$___1 = arrow.c0;
              var \u03b44$___2 = arrow.iE;
            }
            var newTarget = \u03b44$___1;
            var newTargetPort = \u03b44$___2;
            return new $c_Lorg_jpablo_graphexplorer_viewer_models_Arrow(newSource, newTarget, arrow.fG, newSourcePort, newTargetPort, arrow.jH);
          })));
          if ((x21 !== null)) {
            var \u03b42$___1 = x21.g();
            var \u03b42$___2 = x21.h();
            break matchResult7;
          }
          throw new $c_s_MatchError(x21);
        }
        var remappedArrows$2 = \u03b42$___1;
        var updatedArrowMemberships$2 = \u03b42$___2;
        var $x_4 = $f_sci_StrictOptimizedMapOps__concat__sc_IterableOnce__sci_MapOps($thiz.dQ.ahC(nodeId), newNodes.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3) => {
          if ((x$1$3 !== null)) {
            return new $c_T2(x$1$3.g(), x$1$3.h());
          }
          throw new $c_s_MatchError(x$1$3);
        }))));
        var $x_3 = $thiz.go.fz(nodeId);
        if (groupMembership.c()) {
          var this$32 = $m_s_None$();
        } else {
          var x0$4 = groupMembership.d();
          var this$32 = new $c_s_Some(newNodes.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((g$2) => ((x$1$1) => {
            if ((x$1$1 !== null)) {
              return new $c_T2(x$1$1.g(), g$2);
            }
            throw new $c_s_MatchError(x$1$1);
          }))(x0$4))));
        }
        return new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements($x_4, remappedArrows$2, $x_3.hN((this$32.c() ? $m_sci_Map$EmptyMap$() : this$32.d())), updatedArrowMemberships$2, $thiz.aA.fh, $thiz.aA.dW, $thiz.aA.fE, $thiz.aA.fD), $thiz.j7, $thiz.iC, $thiz.jG, $thiz.jF, $thiz.i0);
      }
    }
    throw new $c_s_MatchError(x30);
  }
}
function $f_Lorg_jpablo_graphexplorer_viewer_graph_CombineNodesOps__withRecordLabel__Lorg_jpablo_graphexplorer_viewer_models_NodeId__T__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph($thiz, nodeId, newLabel) {
  var x33 = $thiz.dQ.r(nodeId);
  if ((x33 instanceof $c_s_Some)) {
    var node = x33.J;
    if ($f_Lorg_jpablo_graphexplorer_viewer_graph_CombineNodesOps__isRecordNode__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Z($thiz, nodeId)) {
      $m_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$();
      var nodeId$1 = node.o7;
      $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$();
      var this$ = node.fH;
      var self = new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Label$()));
      $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$();
      var y = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(newLabel);
      $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$();
      var values = this$.bN(self, y);
      $m_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$();
      var updatedNode = new $c_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode(nodeId$1, values, ($m_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$(), $m_s_None$()));
      return new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements($thiz.dQ.AJ(nodeId, updatedNode), $thiz.aA.gH, $thiz.aA.gq, $thiz.aA.gp, $thiz.aA.fh, $thiz.aA.dW, $thiz.aA.fE, $thiz.aA.fD), $thiz.j7, $thiz.iC, $thiz.jG, $thiz.jF, $thiz.i0);
    }
  }
  return $thiz;
}
function $f_Lorg_jpablo_graphexplorer_viewer_graph_CombineNodesOps__renamePort__Lorg_jpablo_graphexplorer_viewer_models_NodeId__T__s_Option__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph($thiz, nodeId, oldPort, newPort) {
  if ((oldPort === "")) {
    return $thiz;
  } else {
    matchResult12: {
      var \u03b45$___1;
      var \u03b45$___2;
      var x36 = $p_Lorg_jpablo_graphexplorer_viewer_graph_CombineNodesOps__remapArrows__F1__T2($thiz, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((arrow) => {
        var x = arrow.bX;
        if ((((x === null) ? (nodeId === null) : x.e(nodeId)) && arrow.iD.E(oldPort))) {
          var sourcePort$2 = newPort;
        } else {
          var sourcePort$2 = arrow.iD;
        }
        var x$3 = arrow.c0;
        if ((((x$3 === null) ? (nodeId === null) : x$3.e(nodeId)) && arrow.iE.E(oldPort))) {
          var targetPort$2 = newPort;
        } else {
          var targetPort$2 = arrow.iE;
        }
        return new $c_Lorg_jpablo_graphexplorer_viewer_models_Arrow(arrow.bX, arrow.c0, arrow.fG, sourcePort$2, targetPort$2, arrow.jH);
      })));
      if ((x36 !== null)) {
        var \u03b45$___1 = x36.g();
        var \u03b45$___2 = x36.h();
        break matchResult12;
      }
      throw new $c_s_MatchError(x36);
    }
    var remapped$2 = \u03b45$___1;
    var memberships$2 = \u03b45$___2;
    return new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements($thiz.aA.gr, remapped$2, $thiz.aA.gq, memberships$2, $thiz.aA.fh, $thiz.aA.dW, $thiz.aA.fE, $thiz.aA.fD), $thiz.j7, $thiz.iC, $thiz.jG, $thiz.jF, $thiz.i0);
  }
}
function $f_Lorg_jpablo_graphexplorer_viewer_graph_CombineNodesOps__withHtmlLabel__Lorg_jpablo_graphexplorer_viewer_models_NodeId__T__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph($thiz, nodeId, newLabel) {
  var x39 = $thiz.dQ.r(nodeId);
  if ((x39 instanceof $c_s_Some)) {
    var node = x39.J;
    $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$();
    var value$1 = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq(newLabel, true));
    $m_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$();
    var nodeId$1 = node.o7;
    $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$();
    var this$ = node.fH;
    var self = new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Label$()));
    $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$();
    var values = this$.bN(self, value$1);
    $m_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$();
    var updatedNode = new $c_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode(nodeId$1, values, ($m_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$(), $m_s_None$()));
    return new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements($thiz.dQ.AJ(nodeId, updatedNode), $thiz.aA.gH, $thiz.aA.gq, $thiz.aA.gp, $thiz.aA.fh, $thiz.aA.dW, $thiz.aA.fE, $thiz.aA.fD), $thiz.j7, $thiz.iC, $thiz.jG, $thiz.jF, $thiz.i0);
  }
  if (($m_s_None$() === x39)) {
    return $thiz;
  }
  throw new $c_s_MatchError(x39);
}
function $f_Lorg_jpablo_graphexplorer_viewer_graph_CombineNodesOps__transposeRecord__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph($thiz, nodeId) {
  if ((!$f_Lorg_jpablo_graphexplorer_viewer_graph_CombineNodesOps__isRecordNode__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Z($thiz, nodeId))) {
    return $thiz;
  } else {
    var x49 = $thiz.dQ.r(nodeId);
    if (($m_s_None$() === x49)) {
      return $thiz;
    }
    if ((x49 instanceof $c_s_Some)) {
      var recordNode = x49.J;
      var currentLabel = $f_Lorg_jpablo_graphexplorer_viewer_models_ViewerElement__label__Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(recordNode).m();
      var root = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$().Je(currentLabel);
      matchResult14: {
        var newRoot;
        var x42 = root.gG;
        if ((x42 !== null)) {
          $m_sci_Vector$();
          var x$1 = x42.C();
          if ((((x$1 === 1) ? 0 : ((x$1 < 1) ? (-1) : 1)) === 0)) {
            var x44 = x42.l(0);
            if ((x44 instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group)) {
              var x47 = x44.tk;
              var x48 = x44.gG;
              if (($m_s_None$() === x47)) {
                var newRoot = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group($m_s_None$(), x48);
                break matchResult14;
              }
            }
          }
        }
        var newRoot = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group($m_s_None$(), $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group.r().C)([new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group($m_s_None$(), x42)]))));
      }
      return $f_Lorg_jpablo_graphexplorer_viewer_graph_CombineNodesOps__withRecordLabel__Lorg_jpablo_graphexplorer_viewer_models_NodeId__T__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph($thiz, nodeId, $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$().a4H(newRoot));
    }
    throw new $c_s_MatchError(x49);
  }
}
function $f_Lorg_jpablo_graphexplorer_viewer_graph_GroupsOps__moveToGroup__Lorg_jpablo_graphexplorer_viewer_models_GroupId__sci_Seq__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph($thiz, groupId, nodeIds) {
  var this$3 = $thiz.aaF;
  var mod = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => _$1.hN(nodeIds.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => new $c_T2(_$2, groupId)))))));
  return this$3.eF.i(mod);
}
function $f_Lorg_jpablo_graphexplorer_viewer_graph_GroupsOps__moveToNewGroup__sci_Set__T__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph($thiz, elementIds, label) {
  var memberIds = elementIds.ct(new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$$anon$1());
  if (memberIds.c()) {
    return $thiz;
  } else {
    var groupId = $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__nextAvailable$2__Lorg_jpablo_graphexplorer_viewer_models_GroupId($thiz);
    var newGroup = $m_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$().a3J(groupId, $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().Au($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_AttributePair.r().C)([new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributePair$$anon$3(new $c_T2($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Label$(), label))]))));
    var parents = memberIds.c5(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((id) => $thiz.go.r(id))));
    var commonParentId = ((parents.aa() === 1) ? $f_sc_IterableOps__headOption__s_Option(parents) : $m_s_None$());
    var updated = $thiz.go.hN(memberIds.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3) => new $c_T2(_$3, groupId)))));
    var this$14 = $thiz.GH;
    var mod = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4) => {
      var groups$1 = $thiz.hu.bN(groupId, newGroup);
      var memberships$1 = (commonParentId.c() ? updated : updated.bN(groupId, commonParentId.d()));
      return new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements(_$4.gr, _$4.gH, memberships$1, _$4.gp, groups$1, _$4.dW, _$4.fE, _$4.fD);
    }));
    return $f_Lorg_jpablo_graphexplorer_viewer_graph_GroupsOps__removeEmptyGroups__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(this$14.eF.i(mod));
  }
}
function $f_Lorg_jpablo_graphexplorer_viewer_graph_GroupsOps__ungroupSelection__sci_Set__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph($thiz, elementIds) {
  var this$7 = elementIds.ct(new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$$anon$1());
  var z = $thiz.go;
  var f = ((acc, element) => {
    var this$3 = $thiz.go.r(element);
    if (this$3.c()) {
      return acc;
    } else {
      var x0 = this$3.d();
      var this$4 = $thiz.go.r(x0);
      return (this$4.c() ? acc.fz(element) : acc.bN(element, this$4.d()));
    }
  });
  if ($is_sc_IndexedSeq(this$7)) {
    var at = 0;
    var end = this$7.C();
    var acc$1 = z;
    var $x_1;
    while (true) {
      if ((at !== end)) {
        var temp$at = ((1 + at) | 0);
        var x0$2 = acc$1;
        var x1 = this$7.l(at);
        var temp$acc = f(x0$2, x1);
        at = temp$at;
        acc$1 = temp$acc;
        continue;
      }
      var $x_1 = acc$1;
      break;
    }
  } else {
    var result = z;
    var it = this$7.o();
    while (it.p()) {
      var x0$3 = result;
      var x1$1 = it.q();
      result = f(x0$3, x1$1);
    }
    var $x_1 = result;
  }
  var newMemberships = $x_1;
  return $f_Lorg_jpablo_graphexplorer_viewer_graph_GroupsOps__removeEmptyGroups__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph($thiz.aaF.Y3(newMemberships));
}
function $f_Lorg_jpablo_graphexplorer_viewer_graph_GroupsOps__getDirectChildren__sci_Set__sci_Set($thiz, groupIds) {
  return $m_sci_Set$().af($thiz.go.ct(new $c_Lorg_jpablo_graphexplorer_viewer_graph_GroupsOps$$anon$1(groupIds)));
}
function $f_Lorg_jpablo_graphexplorer_viewer_graph_GroupsOps__getRootChildren__sci_Set($thiz) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O($ct_sci_MapOps$ImmutableKeySet__sci_MapOps__(new $c_sci_MapOps$ImmutableKeySet(), $thiz.dQ), $thiz.hu.ln()).jv($thiz.go.ln());
}
function $f_Lorg_jpablo_graphexplorer_viewer_graph_GroupsOps__getAllChildren__sci_Set__sci_Set($thiz, groupIds) {
  if (groupIds.c()) {
    return $m_sci_Set$EmptySet$();
  } else {
    var directChildren = $f_Lorg_jpablo_graphexplorer_viewer_graph_GroupsOps__getDirectChildren__sci_Set__sci_Set($thiz, groupIds);
    var childGroups = directChildren.ct(new $c_Lorg_jpablo_graphexplorer_viewer_graph_GroupsOps$$anon$2($thiz));
    return (childGroups.c() ? directChildren : directChildren.dI($f_Lorg_jpablo_graphexplorer_viewer_graph_GroupsOps__getAllChildren__sci_Set__sci_Set($thiz, childGroups)));
  }
}
function $f_Lorg_jpablo_graphexplorer_viewer_graph_GroupsOps__getEmptyGroups__sci_Set($thiz) {
  return $thiz.hu.ln().jv($m_sci_Set$().af($thiz.go.e6()));
}
function $f_Lorg_jpablo_graphexplorer_viewer_graph_GroupsOps__removeEmptyGroups__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph($thiz) {
  var emptyGroups = $f_Lorg_jpablo_graphexplorer_viewer_graph_GroupsOps__getEmptyGroups__sci_Set($thiz);
  if (emptyGroups.c()) {
    return $thiz;
  } else {
    var updatedMemberships = $thiz.go.cE(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
      var elementId = x$1.g();
      x$1.h();
      var this$1 = $f_Lorg_jpablo_graphexplorer_viewer_models_ElementId__asGroupId__s_Option(elementId);
      if ((!this$1.c())) {
        var x0 = this$1.d();
        return emptyGroups.E(x0);
      } else {
        return false;
      }
    })));
    var this$4 = $thiz.GH;
    var mod = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$7) => {
      var groups$2 = $thiz.hu.XS(emptyGroups);
      return new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements(_$7.gr, _$7.gH, updatedMemberships, _$7.gp, groups$2, _$7.dW, _$7.fE, _$7.fD);
    }));
    return $f_Lorg_jpablo_graphexplorer_viewer_graph_GroupsOps__removeEmptyGroups__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(this$4.eF.i(mod));
  }
}
function $f_Lorg_jpablo_graphexplorer_viewer_graph_TraversalOps__directSuccessors__sci_Map($thiz) {
  var this$1 = $thiz.aeO();
  var m = $m_scm_Map$().aO();
  var it = this$1.o();
  while (it.p()) {
    var elem = it.q();
    var key = elem.bX;
    m.ec(key, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((this$1) => (() => this$1.fS()))(this$1))).Y(elem);
  }
  var result = $m_sci_HashMap$().fk;
  var mapIt = m.o();
  while (mapIt.p()) {
    var x1 = mapIt.q();
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1);
    }
    var k = x1.g();
    var v = x1.h();
    result = result.hq(k, v.aR());
  }
  return $f_sci_Map__withDefaultValue__O__sci_Map(result.aik(new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((_$2, ss) => ss.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3) => _$3.c0)))))), $m_sci_Set$EmptySet$());
}
function $f_Lorg_jpablo_graphexplorer_viewer_graph_TraversalOps__directPredecessors__sci_Map($thiz) {
  var this$1 = $thiz.aeO();
  var m = $m_scm_Map$().aO();
  var it = this$1.o();
  while (it.p()) {
    var elem = it.q();
    var key = elem.c0;
    m.ec(key, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((this$1) => (() => this$1.fS()))(this$1))).Y(elem);
  }
  var result = $m_sci_HashMap$().fk;
  var mapIt = m.o();
  while (mapIt.p()) {
    var x1 = mapIt.q();
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1);
    }
    var k = x1.g();
    var v = x1.h();
    result = result.hq(k, v.aR());
  }
  return $f_sci_Map__withDefaultValue__O__sci_Map(result.aik(new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((_$5, ss) => ss.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6) => _$6.bX)))))), $m_sci_Set$EmptySet$());
}
function $f_Lorg_jpablo_graphexplorer_viewer_graph_TraversalOps__unfold__F1__sci_Set__sci_Set($thiz, f, ids0) {
  return $f_sc_IterableFactory__unfold__O__F1__O($m_sci_Set$(), new $c_T2(ids0, $m_sci_Set$EmptySet$()), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var ids = x$1.g();
    var visited = x$1.h();
    var newBatch = ids.c5(f).jv(visited);
    return (newBatch.c() ? $m_s_None$() : new $c_s_Some(new $c_T2(newBatch, new $c_T2(newBatch, visited.dI(newBatch)))));
  }))).dk($m_s_$less$colon$less$().b1);
}
function $p_Lorg_jpablo_graphexplorer_viewer_graph_TraversalOps__subgraphUnfoldWith__F1__sci_Set__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph($thiz, f, ids) {
  return $thiz.aSx(ids.dI($f_Lorg_jpablo_graphexplorer_viewer_graph_TraversalOps__unfold__F1__sci_Set__sci_Set($thiz, f, ids)));
}
function $p_Lorg_jpablo_graphexplorer_viewer_graph_TraversalOps__subgraphWith__F1__sci_Set__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph($thiz, f, ids) {
  return $thiz.aSx(ids.dI(ids.c5(f)));
}
function $f_Lorg_jpablo_graphexplorer_viewer_graph_TraversalOps__directSuccessorsGraph__F1($thiz) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((f$1) => ((ids) => $p_Lorg_jpablo_graphexplorer_viewer_graph_TraversalOps__subgraphWith__F1__sci_Set__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph($thiz, f$1, ids)))($thiz.aNt()));
}
function $f_Lorg_jpablo_graphexplorer_viewer_graph_TraversalOps__directPredecessorsGraph__F1($thiz) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((f$2) => ((ids) => $p_Lorg_jpablo_graphexplorer_viewer_graph_TraversalOps__subgraphWith__F1__sci_Set__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph($thiz, f$2, ids)))($thiz.aNr()));
}
function $f_Lorg_jpablo_graphexplorer_viewer_graph_TraversalOps__allSuccessorsGraph__F1($thiz) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((f$3) => ((ids) => $p_Lorg_jpablo_graphexplorer_viewer_graph_TraversalOps__subgraphUnfoldWith__F1__sci_Set__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph($thiz, f$3, ids)))($thiz.aNt()));
}
function $f_Lorg_jpablo_graphexplorer_viewer_graph_TraversalOps__allPredecessorsGraph__F1($thiz) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((f$4) => ((ids) => $p_Lorg_jpablo_graphexplorer_viewer_graph_TraversalOps__subgraphUnfoldWith__F1__sci_Set__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph($thiz, f$4, ids)))($thiz.aNr()));
}
function $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__padding$1__Z__Z__I__T($thiz, hasNestedSubgraphs$1, hasComplexHtmlLabels$1, level) {
  return ((hasNestedSubgraphs$1 || hasComplexHtmlLabels$1) ? $m_sc_StringOps$().tR("    ", level) : $m_sc_StringOps$().tR("  ", level));
}
function $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__quoted$1__T__T($thiz, value) {
  return (("\"" + value.split("\"").join("\\\"")) + "\"");
}
function $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__formatLabelValue$1__T__T($thiz, value) {
  return ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabels$().w8(value) ? (("<" + $f_T__trim__T(value)) + ">") : $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__quoted$1__T__T($thiz, value));
}
function $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__gvidOrder$1__sci_Map__D($thiz, attrs) {
  var this$1 = attrs.r(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GvId$().xd));
  var this$4 = (this$1.c() ? $m_s_None$() : new $c_s_Some($m_jl_Double$().bd(this$1.d().m())));
  return (+(this$4.c() ? 1.7976931348623157E308 : this$4.d()));
}
function $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__collectNodeAttributes$1__Z__Lorg_jpablo_graphexplorer_viewer_models_ViewerNode__sci_Set__sci_List($thiz, omitInternal$1, node, excludeKeys) {
  var attrs = new $c_scm_ListBuffer().kU($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([])));
  var internalAttrs = (omitInternal$1 ? $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_T.r().C)(["id"]))) : $m_sci_Set$EmptySet$());
  var allExcludeKeys = excludeKeys.dI(internalAttrs).hQ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GvId$().xd);
  if ((!allExcludeKeys.E("id"))) {
    attrs.bb(new $c_T2("id", ("node:" + node.o7.dE)));
  }
  node.fH.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    matchResult3: {
      if ((x$1 !== null)) {
        var attrId = ((x$1.g() === null) ? null : x$1.g().fY);
        var attrValue = x$1.h();
        var value = attrValue.m();
        if (((!allExcludeKeys.E(attrId)) && (attrId !== "id"))) {
          attrs.bb(new $c_T2(attrId, value));
          break matchResult3;
        } else {
          break matchResult3;
        }
      }
      throw new $c_s_MatchError(x$1);
    }
  })));
  return attrs.bM();
}
function $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__isDefaultValue$1__T__T__Z($thiz, key, value) {
  var this$2 = $m_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$().aaT.r(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId(key));
  return ((!this$2.c()) && (this$2.d().m() === value));
}
function $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__collectClusterAttributes$1__Z__Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup__sci_Set__sci_List($thiz, omitInternal$2, group, excludeKeys) {
  var attrs = new $c_scm_ListBuffer().kU($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([])));
  var internalAttrs = (omitInternal$2 ? $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_T.r().C)(["id"]))) : $m_sci_Set$EmptySet$());
  var allExcludeKeys = excludeKeys.dI(internalAttrs).hQ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GvId$().xd);
  if ((!allExcludeKeys.E("id"))) {
    attrs.bb(new $c_T2("id", ("group:" + group.tm.dR)));
  }
  group.kb.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    matchResult4: {
      if ((x$1 !== null)) {
        var attrId = ((x$1.g() === null) ? null : x$1.g().fY);
        var attrValue = x$1.h();
        var value = attrValue.m();
        if (((!allExcludeKeys.E(attrId)) && (attrId !== "id"))) {
          if (((attrId === "label") && (!excludeKeys.E("label")))) {
            attrs.bb(new $c_T2(attrId, value));
            break matchResult4;
          } else if ((attrId === "cluster")) {
            attrs.bb(new $c_T2(attrId, value));
            break matchResult4;
          } else if (((attrId !== "label") && (!$p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__isDefaultValue$1__T__T__Z($thiz, attrId, value)))) {
            attrs.bb(new $c_T2(attrId, value));
            break matchResult4;
          } else {
            break matchResult4;
          }
        } else {
          break matchResult4;
        }
      }
      throw new $c_s_MatchError(x$1);
    }
  })));
  return attrs.bM();
}
function $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__collectGraphAttributes$1__sci_Map__sci_Set__sci_List($thiz, attrs, excludeKeys) {
  var result = new $c_scm_ListBuffer().kU($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([])));
  attrs.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    matchResult5: {
      if ((x$1 !== null)) {
        var attrId = ((x$1.g() === null) ? null : x$1.g().fY);
        var attrValue = x$1.h();
        var value = attrValue.m();
        if ((!excludeKeys.E(attrId))) {
          result.bb(new $c_T2(attrId, value));
          break matchResult5;
        } else {
          break matchResult5;
        }
      }
      throw new $c_s_MatchError(x$1);
    }
  })));
  return result.bM();
}
function $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__collectEdgeAttributes$1__Z__Lorg_jpablo_graphexplorer_viewer_models_Arrow__sci_Set__sci_List($thiz, omitInternal$3, arrow, excludeKeys) {
  var attrs = new $c_scm_ListBuffer().kU($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([])));
  var internalAttrs = (omitInternal$3 ? $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_T.r().C)(["id"]))) : $m_sci_Set$EmptySet$());
  var allExcludeKeys = excludeKeys.dI(internalAttrs).hQ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GvId$().xd);
  if ((!allExcludeKeys.E("id"))) {
    attrs.bb(new $c_T2("id", arrow.kx()));
  }
  arrow.fG.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    matchResult6: {
      if ((x$1 !== null)) {
        var attrId = ((x$1.g() === null) ? null : x$1.g().fY);
        var attrValue = x$1.h();
        var value = attrValue.m();
        if (((!allExcludeKeys.E(attrId)) && (attrId !== "id"))) {
          attrs.bb(new $c_T2(attrId, value));
          break matchResult6;
        } else {
          break matchResult6;
        }
      }
      throw new $c_s_MatchError(x$1);
    }
  })));
  return attrs.bM();
}
function $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__formatAttributes$1__sci_List__T($thiz, attrs) {
  if (attrs.c()) {
    return "";
  } else {
    var f = ((x$1) => {
      if ((x$1 !== null)) {
        var key = x$1.g();
        var value = x$1.h();
        return ((key === "label") ? ((key + "=") + $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__formatLabelValue$1__T__T($thiz, value)) : ((key + "=") + $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__quoted$1__T__T($thiz, value)));
      }
      throw new $c_s_MatchError(x$1);
    });
    if ((attrs === $m_sci_Nil$())) {
      var $x_1 = $m_sci_Nil$();
    } else {
      var x0 = attrs.t();
      var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
      var t = h;
      var rest = attrs.v();
      while ((rest !== $m_sci_Nil$())) {
        var x0$1 = rest.t();
        var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
        t.U = nx;
        t = nx;
        rest = rest.v();
      }
      var $x_1 = h;
    }
    return ((" [" + $f_sc_IterableOnceOps__mkString__T__T__T__T($x_1, "", ", ", "")) + "]");
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__formatAttributesMultiLine$1__Z__Z__sci_List__I__Z__T($thiz, hasNestedSubgraphs$2, hasComplexHtmlLabels$2, attrs, level, forceMultiLine) {
  if (attrs.c()) {
    return "";
  } else {
    if (((forceMultiLine || hasNestedSubgraphs$2) || hasComplexHtmlLabels$2)) {
      var $x_1 = true;
    } else {
      _return: {
        var these = attrs;
        while ((!these.c())) {
          var x0 = these.t();
          matchResult8: {
            var $x_2;
            if ((x0 !== null)) {
              var k = x0.g();
              var v = x0.h();
              var $x_2 = (((k === "label") && $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabels$().w8(v)) && ($f_T__split__T__I__AT($f_T__trim__T(v), "\n", 0).a.length > 1));
              break matchResult8;
            }
            throw new $c_s_MatchError(x0);
          }
          if ($x_2) {
            var $x_1 = true;
            break _return;
          }
          these = these.v();
        }
        var $x_1 = false;
      }
    }
    if ($x_1) {
      var this$22 = $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(attrs);
      var f$1 = ((x$1$2) => {
        if ((x$1$2 !== null)) {
          var x27 = x$1$2.g();
          if ((x27 !== null)) {
            var key = x27.g();
            var value = x27.h();
            var idx = (x$1$2.h() | 0);
            var isLast = (idx === ((attrs.C() - 1) | 0));
            var comma = (isLast ? "" : (hasComplexHtmlLabels$2 ? ", " : ","));
            if ((((key === "label") && $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabels$().w8(value)) && ($f_T__split__T__I__AT($f_T__trim__T(value), "\n", 0).a.length > 1))) {
              var xs = $f_T__split__T__I__AT($f_T__trim__T(value), "\n", 0);
              var f = ((_$4) => $f_T__trim__T(_$4));
              var len = xs.a.length;
              var ys = new ($d_T.r().C)(len);
              if ((len > 0)) {
                var i = 0;
                if ((xs !== null)) {
                  while ((i < len)) {
                    var $x_3 = i;
                    var x0$1 = xs.a[i];
                    ys.a[$x_3] = f(x0$1);
                    i = ((1 + i) | 0);
                  }
                } else if ((xs instanceof $ac_I)) {
                  while ((i < len)) {
                    var $x_4 = i;
                    var x0$2 = xs.a[i];
                    ys.a[$x_4] = f(x0$2);
                    i = ((1 + i) | 0);
                  }
                } else if ((xs instanceof $ac_D)) {
                  while ((i < len)) {
                    var $x_5 = i;
                    var x0$3 = xs.a[i];
                    ys.a[$x_5] = f(x0$3);
                    i = ((1 + i) | 0);
                  }
                } else if ((xs instanceof $ac_J)) {
                  while ((i < len)) {
                    var $x_8 = i;
                    var $x_6 = xs.a;
                    var $x_7 = (i << 1);
                    var x0$4_$_lo = $x_6[$x_7];
                    var x0$4_$_hi = $x_6[(($x_7 + 1) | 0)];
                    ys.a[$x_8] = f($bL(x0$4_$_lo, x0$4_$_hi));
                    i = ((1 + i) | 0);
                  }
                } else if ((xs instanceof $ac_F)) {
                  while ((i < len)) {
                    var $x_9 = i;
                    var x0$5 = xs.a[i];
                    ys.a[$x_9] = f(x0$5);
                    i = ((1 + i) | 0);
                  }
                } else if ((xs instanceof $ac_C)) {
                  while ((i < len)) {
                    var $x_10 = i;
                    var x0$6 = xs.a[i];
                    ys.a[$x_10] = f($bC(x0$6));
                    i = ((1 + i) | 0);
                  }
                } else if ((xs instanceof $ac_B)) {
                  while ((i < len)) {
                    var $x_11 = i;
                    var x0$7 = xs.a[i];
                    ys.a[$x_11] = f(x0$7);
                    i = ((1 + i) | 0);
                  }
                } else if ((xs instanceof $ac_S)) {
                  while ((i < len)) {
                    var $x_12 = i;
                    var x0$8 = xs.a[i];
                    ys.a[$x_12] = f(x0$8);
                    i = ((1 + i) | 0);
                  }
                } else if ((xs instanceof $ac_Z)) {
                  while ((i < len)) {
                    var $x_13 = i;
                    var x0$9 = xs.a[i];
                    ys.a[$x_13] = f(x0$9);
                    i = ((1 + i) | 0);
                  }
                } else {
                  throw new $c_s_MatchError(xs);
                }
              }
              var capacity = 0;
              var size = 0;
              var jsElems = null;
              capacity = 0;
              size = 0;
              jsElems = [];
              var i$1 = 0;
              while ((i$1 < ys.a.length)) {
                var x = ys.a[i$1];
                if ((x !== "")) {
                  var unboxedElem = ((x === null) ? null : x);
                  jsElems.push(unboxedElem);
                }
                i$1 = ((1 + i$1) | 0);
              }
              var lines = new ($d_T.r().C)(jsElems);
              var htmlPadding = (hasComplexHtmlLabels$2 ? "              " : ("" + $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__padding$1__Z__Z__I__T($thiz, hasNestedSubgraphs$2, hasComplexHtmlLabels$2, ((2 + level) | 0))));
              var $x_14 = $m_s_Predef$();
              var len$1 = lines.a.length;
              var ys$1 = new ($d_T.r().C)(len$1);
              if ((len$1 > 0)) {
                var i$2 = 0;
                while ((i$2 < len$1)) {
                  ys$1.a[i$2] = (htmlPadding + lines.a[i$2]);
                  i$2 = ((1 + i$2) | 0);
                }
              }
              var htmlLines = $f_sc_IterableOnceOps__mkString__T__T__T__T($x_14.fB(ys$1), "", "\n", "");
              return (((((((("" + $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__padding$1__Z__Z__I__T($thiz, hasNestedSubgraphs$2, hasComplexHtmlLabels$2, ((1 + level) | 0))) + key) + "=<\n") + htmlLines) + "\n") + $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__padding$1__Z__Z__I__T($thiz, hasNestedSubgraphs$2, hasComplexHtmlLabels$2, ((1 + level) | 0))) + ">") + comma);
            } else {
              return ((key === "label") ? ((((("" + $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__padding$1__Z__Z__I__T($thiz, hasNestedSubgraphs$2, hasComplexHtmlLabels$2, ((1 + level) | 0))) + key) + "=") + $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__formatLabelValue$1__T__T($thiz, value)) + comma) : ((((("" + $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__padding$1__Z__Z__I__T($thiz, hasNestedSubgraphs$2, hasComplexHtmlLabels$2, ((1 + level) | 0))) + key) + "=") + $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__quoted$1__T__T($thiz, value)) + comma));
            }
          }
        }
        throw new $c_s_MatchError(x$1$2);
      });
      if ((this$22 === $m_sci_Nil$())) {
        var $x_15 = $m_sci_Nil$();
      } else {
        var x0$11 = this$22.t();
        var h = new $c_sci_$colon$colon(f$1(x0$11), $m_sci_Nil$());
        var t = h;
        var rest = this$22.v();
        while ((rest !== $m_sci_Nil$())) {
          var x0$12 = rest.t();
          var nx = new $c_sci_$colon$colon(f$1(x0$12), $m_sci_Nil$());
          t.U = nx;
          t = nx;
          rest = rest.v();
        }
        var $x_15 = h;
      }
      return ((((" [\n" + $f_sc_IterableOnceOps__mkString__T__T__T__T($x_15, "", "\n", "")) + "\n") + $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__padding$1__Z__Z__I__T($thiz, hasNestedSubgraphs$2, hasComplexHtmlLabels$2, level)) + "]");
    } else {
      return $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__formatAttributes$1__sci_List__T($thiz, attrs);
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__emitAttrStatement$1__scm_ListBuffer__Z__Z__T__sci_List__V($thiz, lines$1, hasNestedSubgraphs$4, hasComplexHtmlLabels$4, keyword, attrs) {
  if ((!attrs.c())) {
    var attrFormatting = ((attrs.C() > 1) ? $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__formatAttributesMultiLine$1__Z__Z__sci_List__I__Z__T($thiz, hasNestedSubgraphs$4, hasComplexHtmlLabels$4, attrs, 1, true) : $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__formatAttributes$1__sci_List__T($thiz, attrs));
    lines$1.bb((((("" + $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__padding$1__Z__Z__I__T($thiz, hasNestedSubgraphs$4, hasComplexHtmlLabels$4, 1)) + keyword) + attrFormatting) + ";"));
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__portAttr$1__Lorg_jpablo_graphexplorer_viewer_models_Arrow__T__s_Option($thiz, arrow$1, attrId) {
  var this$1 = arrow$1.fG.r(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId(attrId));
  return (this$1.c() ? $m_s_None$() : new $c_s_Some(this$1.d().m()));
}
function $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__emitArrow$1__Z__Z__scm_ListBuffer__T__scm_Set__Z__Lorg_jpablo_graphexplorer_viewer_models_Arrow__I__V($thiz, hasNestedSubgraphs$5, hasComplexHtmlLabels$5, lines$2, edgeOp$1, emittedArrows$1, omitInternal$4, arrow, level) {
  var this$2 = $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__portAttr$1__Lorg_jpablo_graphexplorer_viewer_models_Arrow__T__s_Option($thiz, arrow, $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailPort$()));
  var this$3 = (this$2.c() ? arrow.iD : this$2);
  var this$4 = (this$3.c() ? $m_s_None$() : new $c_s_Some((":" + $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__quoted$1__T__T($thiz, this$3.d()))));
  var tailPort = (this$4.c() ? "" : this$4.d());
  var this$6 = $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__portAttr$1__Lorg_jpablo_graphexplorer_viewer_models_Arrow__T__s_Option($thiz, arrow, $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HeadPort$()));
  var this$7 = (this$6.c() ? arrow.iE : this$6);
  var this$8 = (this$7.c() ? $m_s_None$() : new $c_s_Some((":" + $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__quoted$1__T__T($thiz, this$7.d()))));
  var headPort = (this$8.c() ? "" : this$8.d());
  var edgeAttrs = $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__collectEdgeAttributes$1__Z__Lorg_jpablo_graphexplorer_viewer_models_Arrow__sci_Set__sci_List($thiz, omitInternal$4, arrow, $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_T.r().C)(["tail", "head", $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailPort$()), $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HeadPort$())]))));
  var attrFormatting = (((hasNestedSubgraphs$5 || hasComplexHtmlLabels$5) || (edgeAttrs.C() > 1)) ? $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__formatAttributesMultiLine$1__Z__Z__sci_List__I__Z__T($thiz, hasNestedSubgraphs$5, hasComplexHtmlLabels$5, edgeAttrs, level, (hasComplexHtmlLabels$5 || (edgeAttrs.C() > 1))) : $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__formatAttributes$1__sci_List__T($thiz, edgeAttrs));
  lines$2.bb((((((((((("" + $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__padding$1__Z__Z__I__T($thiz, hasNestedSubgraphs$5, hasComplexHtmlLabels$5, level)) + $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__quoted$1__T__T($thiz, arrow.bX.dE)) + tailPort) + " ") + edgeOp$1) + " ") + $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__quoted$1__T__T($thiz, arrow.c0.dE)) + headPort) + attrFormatting) + ";"));
  emittedArrows$1.Y(arrow.dw);
}
function $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__emitNode$1__Z__Z__scm_ListBuffer__Z__Lorg_jpablo_graphexplorer_viewer_models_ViewerNode__I__V($thiz, hasNestedSubgraphs$6, hasComplexHtmlLabels$6, lines$3, omitInternal$5, node, level) {
  var nodeAttrs = $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__collectNodeAttributes$1__Z__Lorg_jpablo_graphexplorer_viewer_models_ViewerNode__sci_Set__sci_List($thiz, omitInternal$5, node, $m_sci_Set$EmptySet$());
  var this$3 = node.fH.r(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Label$())));
  var this$4 = (this$3.c() ? $m_s_None$() : new $c_s_Some(this$3.d().m()));
  if ((!this$4.c())) {
    var x0$1 = this$4.d();
    var hasMultiLineHtmlLabel = ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabels$().w8(x0$1) && ($f_T__split__T__I__AT($f_T__trim__T(x0$1), "\n", 0).a.length > 1));
  } else {
    var hasMultiLineHtmlLabel = false;
  }
  var attrFormatting = ((((hasNestedSubgraphs$6 || hasMultiLineHtmlLabel) || hasComplexHtmlLabels$6) || (nodeAttrs.C() > 1)) ? $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__formatAttributesMultiLine$1__Z__Z__sci_List__I__Z__T($thiz, hasNestedSubgraphs$6, hasComplexHtmlLabels$6, nodeAttrs, level, (hasComplexHtmlLabels$6 || (nodeAttrs.C() > 1))) : $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__formatAttributes$1__sci_List__T($thiz, nodeAttrs));
  lines$3.bb((((("" + $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__padding$1__Z__Z__I__T($thiz, hasNestedSubgraphs$6, hasComplexHtmlLabels$6, level)) + $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__quoted$1__T__T($thiz, node.o7.dE)) + attrFormatting) + ";"));
}
function $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__processCluster$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements__scm_ListBuffer__Z__Z__sci_Map__sci_Map__sci_Map__Z__T__scm_Set__Lorg_jpablo_graphexplorer_viewer_models_GroupId__I__scm_Set__V($thiz, elements$3, lines$4, hasNestedSubgraphs$7, hasComplexHtmlLabels$7, childGroupsByParent$1, nodesByParent$1, arrowsByOwner$1, omitInternal$6, edgeOp$2, emittedArrows$2, groupId, level, processedGroups) {
  if (processedGroups.E(groupId)) {
    return (void 0);
  }
  processedGroups.Y(groupId);
  var group = elements$3.fh.i(groupId);
  var this$2 = group.kb.r(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId("cluster"));
  var isCluster = ((!this$2.c()) && (this$2.d().m() === "true"));
  if (isCluster) {
    var this$3 = group.tm.dR;
    var $x_1 = (!(!(!this$3.startsWith("cluster"))));
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    var subgraphName = ("cluster_" + group.tm.dR);
  } else {
    var subgraphName = group.tm.dR;
  }
  lines$4.bb(((($p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__padding$1__Z__Z__I__T($thiz, hasNestedSubgraphs$7, hasComplexHtmlLabels$7, level) + "subgraph ") + $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__quoted$1__T__T($thiz, subgraphName)) + " {"));
  var clusterAttrs = $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__collectClusterAttributes$1__Z__Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup__sci_Set__sci_List($thiz, omitInternal$6, group, $m_sci_Set$EmptySet$());
  if ((!clusterAttrs.c())) {
    var attrFormatting = (((hasNestedSubgraphs$7 || hasComplexHtmlLabels$7) || (clusterAttrs.C() > 1)) ? $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__formatAttributesMultiLine$1__Z__Z__sci_List__I__Z__T($thiz, hasNestedSubgraphs$7, hasComplexHtmlLabels$7, clusterAttrs, ((1 + level) | 0), (clusterAttrs.C() > 1)) : $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__formatAttributes$1__sci_List__T($thiz, clusterAttrs));
    lines$4.bb(((($p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__padding$1__Z__Z__I__T($thiz, hasNestedSubgraphs$7, hasComplexHtmlLabels$7, ((1 + level) | 0)) + "graph") + attrFormatting) + ";"));
  }
  var this$6 = $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(childGroupsByParent$1.ay(groupId, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_Nil$()))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((childGroupId) => $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__gvidOrder$1__sci_Map__D($thiz, elements$3.fh.i(childGroupId).kb))), $m_s_math_Ordering$DeprecatedDoubleOrdering$());
  var these = this$6;
  while ((!these.c())) {
    $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__processCluster$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements__scm_ListBuffer__Z__Z__sci_Map__sci_Map__sci_Map__Z__T__scm_Set__Lorg_jpablo_graphexplorer_viewer_models_GroupId__I__scm_Set__V($thiz, elements$3, lines$4, hasNestedSubgraphs$7, hasComplexHtmlLabels$7, childGroupsByParent$1, nodesByParent$1, arrowsByOwner$1, omitInternal$6, edgeOp$2, emittedArrows$2, these.t(), ((1 + level) | 0), processedGroups);
    these = these.v();
  }
  var this$8 = $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(nodesByParent$1.ay(groupId, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_Nil$()))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((nodeId) => $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__gvidOrder$1__sci_Map__D($thiz, $f_sc_MapOps__apply__O__O(elements$3.gr, nodeId).fH))), $m_s_math_Ordering$DeprecatedDoubleOrdering$());
  var these$1 = this$8;
  while ((!these$1.c())) {
    var x0$2 = these$1.t();
    $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__emitNode$1__Z__Z__scm_ListBuffer__Z__Lorg_jpablo_graphexplorer_viewer_models_ViewerNode__I__V($thiz, hasNestedSubgraphs$7, hasComplexHtmlLabels$7, lines$4, omitInternal$6, $f_sc_MapOps__apply__O__O(elements$3.gr, x0$2), ((1 + level) | 0));
    these$1 = these$1.v();
  }
  var this$10 = $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(arrowsByOwner$1.ay(groupId, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_Nil$()))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$16) => _$16.jH)), $m_s_math_Ordering$Int$());
  var these$2 = this$10;
  while ((!these$2.c())) {
    $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__emitArrow$1__Z__Z__scm_ListBuffer__T__scm_Set__Z__Lorg_jpablo_graphexplorer_viewer_models_Arrow__I__V($thiz, hasNestedSubgraphs$7, hasComplexHtmlLabels$7, lines$4, edgeOp$2, emittedArrows$2, omitInternal$6, these$2.t(), ((1 + level) | 0));
    these$2 = these$2.v();
  }
  lines$4.bb(($p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__padding$1__Z__Z__I__T($thiz, hasNestedSubgraphs$7, hasComplexHtmlLabels$7, level) + "}"));
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$.prototype = $p;
$p.bbn = (function(elements, graphName, graphType, omitInternal) {
  var lines = new $c_scm_ListBuffer().kU($m_sr_ScalaRunTime$().f(new ($d_T.r().C)([])));
  var hasNestedSubgraphs = elements.gq.lU(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    if (((x$1 !== null) && (x$1.g() instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId))) {
      var parentId = x$1.h();
      return elements.fh.E(parentId);
    } else {
      return false;
    }
  })));
  var this$2 = elements.gr;
  var res = false;
  var it = new $c_sci_VectorMap$$anon$1(this$2);
  while (((!res) && it.p())) {
    var x0 = it.dC();
    matchResult2: {
      if ((x0 !== null)) {
        var node = x0.h();
        var this$4 = node.fH.r(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Label$())));
        var this$5 = (this$4.c() ? $m_s_None$() : new $c_s_Some(this$4.d().m()));
        if ((!this$5.c())) {
          var x0$2 = this$5.d();
          res = ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabels$().w8(x0$2) && ($f_T__split__T__I__AT($f_T__trim__T(x0$2), "\n", 0).a.length > 1));
          break matchResult2;
        } else {
          res = false;
          break matchResult2;
        }
      }
      throw new $c_s_MatchError(x0);
    }
  }
  var hasComplexHtmlLabels = res;
  var graphTypeStr = (graphType.aPn() ? "digraph" : "graph");
  var edgeOp = (graphType.aPn() ? "->" : "--");
  lines.bb((((graphTypeStr + " ") + $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__quoted$1__T__T(this, graphName)) + " {"));
  $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__emitAttrStatement$1__scm_ListBuffer__Z__Z__T__sci_List__V(this, lines, hasNestedSubgraphs, hasComplexHtmlLabels, "graph", $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__collectGraphAttributes$1__sci_Map__sci_Set__sci_List(this, elements.dW, $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_T.r().C)(["name", "directed"])))));
  $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__emitAttrStatement$1__scm_ListBuffer__Z__Z__T__sci_List__V(this, lines, hasNestedSubgraphs, hasComplexHtmlLabels, "node", $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__collectGraphAttributes$1__sci_Map__sci_Set__sci_List(this, elements.fE, $m_sci_Set$EmptySet$()));
  $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__emitAttrStatement$1__scm_ListBuffer__Z__Z__T__sci_List__V(this, lines, hasNestedSubgraphs, hasComplexHtmlLabels, "edge", $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__collectGraphAttributes$1__sci_Map__sci_Set__sci_List(this, elements.fD, $m_sci_Set$EmptySet$()));
  var this$12 = $m_sci_Nil$().b6(elements.gq).Ag(new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$$anon$1());
  var m = $m_scm_Map$().aO();
  var these = this$12;
  while ((!these.c())) {
    var x0$3 = these.t();
    var k = x0$3.g();
    m.ec(k, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => new $c_scm_ListBuffer()))).Y(x0$3.h());
    these = these.v();
  }
  var result = new $c_sc_IterableOps$Result$1(this$12);
  m.F(result);
  var childGroupsByParent = result.zS;
  var this$16 = $m_sci_Nil$().b6(elements.gq).Ag(new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$$anon$2());
  var m$1 = $m_scm_Map$().aO();
  var these$1 = this$16;
  while ((!these$1.c())) {
    var x0$4 = these$1.t();
    var k$1 = x0$4.g();
    m$1.ec(k$1, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => new $c_scm_ListBuffer()))).Y(x0$4.h());
    these$1 = these$1.v();
  }
  var result$1 = new $c_sc_IterableOps$Result$1(this$16);
  m$1.F(result$1);
  var nodesByParent = result$1.zS;
  var this$18 = elements.gH.e6().bM();
  var rest = this$18;
  var h = null;
  var t = null;
  while ((rest !== $m_sci_Nil$())) {
    var x0$5 = rest.t();
    var this$19 = elements.gp.r(x0$5.dw);
    var it$1 = (this$19.c() ? $m_s_None$() : new $c_s_Some(new $c_T2(this$19.d(), x0$5))).o();
    while (it$1.p()) {
      var nx = new $c_sci_$colon$colon(it$1.q(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        t.U = nx;
      }
      t = nx;
    }
    rest = rest.v();
  }
  var this$22 = ((h === null) ? $m_sci_Nil$() : h);
  var m$2 = $m_scm_Map$().aO();
  var these$2 = this$22;
  while ((!these$2.c())) {
    var x0$7 = these$2.t();
    var k$2 = x0$7.g();
    m$2.ec(k$2, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => new $c_scm_ListBuffer()))).Y(x0$7.h());
    these$2 = these$2.v();
  }
  var result$2 = new $c_sc_IterableOps$Result$1(this$22);
  m$2.F(result$2);
  var arrowsByOwner = result$2.zS;
  var emittedArrows = $m_scm_Set$().dr($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_ArrowId.r().C)([])));
  var processedGroups = $m_scm_Set$().dr($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_GroupId.r().C)([])));
  var topLevelGroups = elements.fh.J8().bw(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((groupId) => (!elements.gq.E(groupId)))));
  var groupsToProcess = ((!topLevelGroups.c()) ? topLevelGroups : elements.fh.J8());
  var sortedGroupsToProcess = $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(groupsToProcess.bM(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((groupId$2) => $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__gvidOrder$1__sci_Map__D(this, elements.fh.i(groupId$2).kb))), $m_s_math_Ordering$DeprecatedDoubleOrdering$());
  var these$3 = sortedGroupsToProcess;
  while ((!these$3.c())) {
    $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__processCluster$1__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements__scm_ListBuffer__Z__Z__sci_Map__sci_Map__sci_Map__Z__T__scm_Set__Lorg_jpablo_graphexplorer_viewer_models_GroupId__I__scm_Set__V(this, elements, lines, hasNestedSubgraphs, hasComplexHtmlLabels, childGroupsByParent, nodesByParent, arrowsByOwner, omitInternal, edgeOp, emittedArrows, these$3.t(), 1, processedGroups);
    these$3 = these$3.v();
  }
  var clusterNodeIds = $m_sci_Set$().af(nodesByParent.e6().dk($m_s_$less$colon$less$().b1));
  var this$28 = elements.gr;
  var it$2 = new $c_sci_VectorMap$$anon$1(this$28);
  while (it$2.p()) {
    var x0$9 = it$2.dC();
    matchResult14: {
      if ((x0$9 !== null)) {
        var nodeId = x0$9.g();
        var node$1 = x0$9.h();
        if ((!clusterNodeIds.E(nodeId))) {
          $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__emitNode$1__Z__Z__scm_ListBuffer__Z__Lorg_jpablo_graphexplorer_viewer_models_ViewerNode__I__V(this, hasNestedSubgraphs, hasComplexHtmlLabels, lines, omitInternal, node$1, 1);
          break matchResult14;
        } else {
          break matchResult14;
        }
      }
      throw new $c_s_MatchError(x0$9);
    }
  }
  var this$29 = elements.gH.e6().bM();
  var f$1 = ((a$2) => emittedArrows.E(a$2.dw));
  var l = this$29;
  block: {
    var result$3;
    while (true) {
      if (l.c()) {
        var result$3 = $m_sci_Nil$();
        break;
      } else {
        var h$1 = l.t();
        var t$1 = l.v();
        if ((!(!f$1(h$1)))) {
          l = t$1;
          continue;
        }
        var start = l;
        var remaining = t$1;
        while (true) {
          if (remaining.c()) {
            var result$3 = start;
            break block;
          } else {
            var x = remaining.t();
            if ((!(!(!f$1(x))))) {
              remaining = remaining.v();
              continue;
            }
            var firstMiss = remaining;
            var newHead = new $c_sci_$colon$colon(start.t(), $m_sci_Nil$());
            var toProcess = start.v();
            var currentLast = newHead;
            while ((toProcess !== firstMiss)) {
              var newElem = new $c_sci_$colon$colon(toProcess.t(), $m_sci_Nil$());
              currentLast.U = newElem;
              currentLast = newElem;
              toProcess = toProcess.v();
            }
            var next = firstMiss.v();
            var nextToCopy = next;
            while ((!next.c())) {
              var head = next.t();
              if ((!(!(!f$1(head))))) {
                next = next.v();
              } else {
                while ((nextToCopy !== next)) {
                  var newElem$2 = new $c_sci_$colon$colon(nextToCopy.t(), $m_sci_Nil$());
                  currentLast.U = newElem$2;
                  currentLast = newElem$2;
                  nextToCopy = nextToCopy.v();
                }
                nextToCopy = next.v();
                next = next.v();
              }
            }
            if ((!nextToCopy.c())) {
              currentLast.U = nextToCopy;
            }
            var result$3 = newHead;
            break block;
          }
        }
      }
    }
  }
  var these$4 = result$3;
  while ((!these$4.c())) {
    $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$__emitArrow$1__Z__Z__scm_ListBuffer__T__scm_Set__Z__Lorg_jpablo_graphexplorer_viewer_models_Arrow__I__V(this, hasNestedSubgraphs, hasComplexHtmlLabels, lines, edgeOp, emittedArrows, omitInternal, these$4.t(), 1);
    these$4 = these$4.v();
  }
  lines.bb("}");
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(lines, "", "\n", "");
});
var $d_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$, "org.jpablo.graphexplorer.viewer.graph.ViewerGraphElementsToText$package$", ({
  CF: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$__farEnd$1__Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction__Lorg_jpablo_graphexplorer_viewer_models_Arrow__Lorg_jpablo_graphexplorer_viewer_models_NodeId($thiz, dir$1, a) {
  var x = $s_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$__Successors__Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction();
  if (((x === null) ? (dir$1 === null) : (x === dir$1))) {
    return a.c0;
  }
  var x$3 = $s_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$__Predecessors__Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction();
  if (((x$3 === null) ? (dir$1 === null) : (x$3 === dir$1))) {
    return a.bX;
  }
  throw new $c_s_MatchError(dir$1);
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$.prototype = $p;
$p.aZ5 = (function(g, hidden, sel, dir, recursive) {
  var hiddenNodeIds = $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().io(hidden);
  var hiddenArrowIds = $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().gV(hidden).gf;
  var visibleNodes = g.j8.jv(hiddenNodeIds);
  var visibleArrows = g.fX.e6().bw(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((a) => (((!hiddenArrowIds.E(a.dw)) && visibleNodes.E(a.bX)) && visibleNodes.E(a.c0))))).d2();
  var m = $m_scm_Map$().aO();
  var it = visibleArrows.o();
  while (it.p()) {
    var elem = it.q();
    var key = elem.bX;
    m.ec(key, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      $m_sci_Vector$();
      return new $c_sci_VectorBuilder();
    }))).Y(elem);
  }
  var result = $m_sci_HashMap$().fk;
  var mapIt = m.o();
  while (mapIt.p()) {
    var x1 = mapIt.q();
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1);
    }
    var k = x1.g();
    var v = x1.h();
    result = result.hq(k, v.aR());
  }
  var bySource = $f_sci_Map__withDefaultValue__O__sci_Map(result, ($m_sci_Vector$(), $m_sci_Vector0$()));
  var m$1 = $m_scm_Map$().aO();
  var it$1 = visibleArrows.o();
  while (it$1.p()) {
    var elem$1 = it$1.q();
    var key$1 = elem$1.c0;
    m$1.ec(key$1, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      $m_sci_Vector$();
      return new $c_sci_VectorBuilder();
    }))).Y(elem$1);
  }
  var result$1 = $m_sci_HashMap$().fk;
  var mapIt$1 = m$1.o();
  while (mapIt$1.p()) {
    var x1$1 = mapIt$1.q();
    if ((x1$1 === null)) {
      throw new $c_s_MatchError(x1$1);
    }
    var k$1 = x1$1.g();
    var v$1 = x1$1.h();
    result$1 = result$1.hq(k$1, v$1.aR());
  }
  var byTarget = $f_sci_Map__withDefaultValue__O__sci_Map(result$1, ($m_sci_Vector$(), $m_sci_Vector0$()));
  matchResult2: {
    var \u03b41$___1;
    var \u03b41$___2;
    var x = $s_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$__Successors__Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction();
    if (((x === null) ? (dir === null) : (x === dir))) {
      var \u03b41$___1 = bySource;
      var \u03b41$___2 = byTarget;
      break matchResult2;
    }
    var x$3 = $s_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$__Predecessors__Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction();
    if (((x$3 === null) ? (dir === null) : (x$3 === dir))) {
      var \u03b41$___1 = byTarget;
      var \u03b41$___2 = bySource;
      break matchResult2;
    }
    throw new $c_s_MatchError(dir);
  }
  var outBy = \u03b41$___1;
  var inBy = \u03b41$___2;
  var source = sel.J3(visibleNodes);
  var queue = $ct_scm_Queue__I__(new $c_scm_Queue(), 16).kl(source);
  var processed = $m_scm_Set$().aO();
  var newlyHiddenA = $m_scm_Set$().aO();
  var newlyHiddenN = $m_scm_Set$().aO();
  while ((!queue.c())) {
    var src = queue.h7(false);
    if ((!processed.E(src))) {
      processed.Y(src);
      var outs = outBy.i(src).cE(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((newlyHiddenA) => ((a$2) => newlyHiddenA.E(a$2.dw)))(newlyHiddenA)));
      if ((!$f_sc_SeqOps__isEmpty__Z(outs))) {
        newlyHiddenA.dG(outs.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3) => _$3.dw))));
        outs.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((src, newlyHiddenN, inBy, newlyHiddenA, recursive, queue, dir) => ((a$3) => {
          var far = $p_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$__farEnd$1__Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction__Lorg_jpablo_graphexplorer_viewer_models_Arrow__Lorg_jpablo_graphexplorer_viewer_models_NodeId(this, dir, a$3);
          if (((!((far === null) ? (src === null) : far.e(src))) && (!newlyHiddenN.E(far)))) {
            if ($f_sc_SeqOps__isEmpty__Z(inBy.i(far).cE(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((in$1) => newlyHiddenA.E(in$1.dw)))))) {
              newlyHiddenN.Y(far);
              if (recursive) {
                queue.km(far);
              }
            }
          }
        }))(src, newlyHiddenN, inBy, newlyHiddenA, recursive, queue, dir)));
      }
    }
  }
  return new $c_T2($m_sci_Set$().af(newlyHiddenA), $m_sci_Set$().af(newlyHiddenN));
});
$p.af9 = (function(g, hidden, n, dir) {
  var hiddenNodeIds = $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().io(hidden);
  var hiddenArrowIds = $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().gV(hidden).gf;
  if (hiddenNodeIds.E(n)) {
    return $m_sci_Set$EmptySet$();
  } else {
    var $x_2 = $m_sci_Set$();
    matchResult4: {
      var $x_1;
      var x = $s_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$__Successors__Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction();
      if (((x === null) ? (dir === null) : (x === dir))) {
        var $x_1 = g.aMr().ay(n, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
          $m_sci_Vector$();
          return $m_sci_Vector0$();
        })));
        break matchResult4;
      }
      var x$3 = $s_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$__Predecessors__Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction();
      if (((x$3 === null) ? (dir === null) : (x$3 === dir))) {
        var $x_1 = g.aMs().ay(n, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
          $m_sci_Vector$();
          return $m_sci_Vector0$();
        })));
        break matchResult4;
      }
      throw new $c_s_MatchError(dir);
    }
    return $x_2.af(new $c_sc_Iterator$$anon$9(new $c_sc_Iterator$$anon$6(new $c_sc_Iterator$$anon$6($x_1.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((a) => {
      var x$1 = a.bX;
      var x$2 = a.c0;
      return (!((x$1 === null) ? (x$2 === null) : x$1.e(x$2)));
    })), false), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((a$2) => {
      if (hiddenArrowIds.E(a$2.dw)) {
        return true;
      } else {
        var x$2$1 = $s_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$__Successors__Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction();
        return hiddenNodeIds.E((((dir === null) ? (x$2$1 === null) : (dir === x$2$1)) ? a$2.c0 : a$2.bX));
      }
    })), false), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((a$3) => {
      var x$2$2 = $s_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$__Successors__Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction();
      if (((dir === null) ? (x$2$2 === null) : (dir === x$2$2))) {
        return a$3.c0;
      } else {
        return a$3.bX;
      }
    }))));
  }
});
$p.aYX = (function(g, hidden) {
  return $m_sci_Map$().ao(new $c_sc_Iterator$$anon$6(new $c_sc_Iterator$$anon$9(g.j8.jv($m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().io(hidden)).o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n) => new $c_T2(n, new $c_T2($m_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$().af9(g, hidden, n, $s_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$__Successors__Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction()).aa(), $m_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$().af9(g, hidden, n, $s_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$__Predecessors__Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction()).aa()))))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    x$1.g();
    var c = x$1.h();
    return (((c.g() | 0) > 0) || ((c.h() | 0) > 0));
  })), false));
});
$p.ah1 = (function(g, groupId) {
  return $f_Lorg_jpablo_graphexplorer_viewer_graph_GroupsOps__getAllChildren__sci_Set__sci_Set(g, $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_GroupId.r().C)([groupId])))).ct(new $c_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$$anon$2());
});
$p.aP2 = (function(g, groupId, hidden) {
  var members = this.ah1(g, groupId);
  return (members.c() ? (!$m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().mJ(hidden, groupId)) : members.lU(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n) => (!$m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().mJ(hidden, n))))));
});
var $d_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$, "org.jpablo.graphexplorer.viewer.graph.VisibilityRules$", ({
  CI: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$;
function $m_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$ = new $c_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Layout3D$() {
  this.aaO = null;
  $n_Lorg_jpablo_graphexplorer_viewer_layout3d_Layout3D$ = this;
  this.aaO = new $c_sci_$colon$colon($m_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$(), new $c_sci_$colon$colon($m_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$(), new $c_sci_$colon$colon($m_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$(), $m_sci_Nil$())));
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Layout3D$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Layout3D$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_layout3d_Layout3D$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_layout3d_Layout3D$.prototype = $p;
$p.aMC = (function(id) {
  var this$1 = this.aaO;
  var these = this$1;
  while ((!these.c())) {
    if ((these.t().u6() === id)) {
      return new $c_s_Some(these.t());
    }
    these = these.v();
  }
  return $m_s_None$();
});
var $d_Lorg_jpablo_graphexplorer_viewer_layout3d_Layout3D$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_layout3d_Layout3D$, "org.jpablo.graphexplorer.viewer.layout3d.Layout3D$", ({
  CV: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_layout3d_Layout3D$;
function $m_Lorg_jpablo_graphexplorer_viewer_layout3d_Layout3D$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_layout3d_Layout3D$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_layout3d_Layout3D$ = new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Layout3D$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_layout3d_Layout3D$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_logging_WithLog$package$() {
  this.TC = null;
  this.TC = null;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_logging_WithLog$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_logging_WithLog$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_logging_WithLog$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_logging_WithLog$package$.prototype = $p;
$p.nF = (function() {
  if (($m_Lorg_jpablo_graphexplorer_viewer_logging_WithLog$package$().TC === null)) {
    $m_Lorg_jpablo_graphexplorer_viewer_logging_WithLog$package$().TC = new Date();
  }
  var currentDate = new Date();
  var delta = ((+currentDate.getTime()) - (+$m_Lorg_jpablo_graphexplorer_viewer_logging_WithLog$package$().TC.getTime()));
  $m_Lorg_jpablo_graphexplorer_viewer_logging_WithLog$package$().TC = currentDate;
  return (((delta / 1000.0) + " s,  at: ") + $m_sc_StringOps$().Ej(currentDate.toISOString(), 84).a[1]);
});
var $d_Lorg_jpablo_graphexplorer_viewer_logging_WithLog$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_logging_WithLog$package$, "org.jpablo.graphexplorer.viewer.logging.WithLog$package$", ({
  D1: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_logging_WithLog$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_logging_WithLog$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_logging_WithLog$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_logging_WithLog$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_logging_WithLog$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_logging_WithLog$package$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId$() {
  this.aFh = null;
  this.aFi = false;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_AttributeId$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_AttributeId$.prototype = $p;
$p.aOW = (function() {
  if ((!this.aFi)) {
    var this$4 = $m_Lupickle_default$();
    this.aFh = new $c_Lupickle_Api$$anon$3(($m_Lupickle_default$(), new $c_Lupickle_core_Types$$anon$1(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => ((_$2 === null) ? null : _$2.fY))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3) => new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId(_$3))), $m_Lupickle_default$().cw().ez($m_Lupickle_default$().a5, $m_Lupickle_default$().I))), this$4);
    this.aFi = true;
  }
  return this.aFh;
});
$p.b0K = (function(this$, x$0) {
  return ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId) && (this$ === ((x$0 === null) ? null : x$0.fY)));
});
$p.b6N = (function(this$, n) {
  if ((n === 0)) {
    return this$;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.b6Q = (function(this$, n) {
  if ((n === 0)) {
    return "value";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lorg_jpablo_graphexplorer_viewer_models_AttributeId$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId$, "org.jpablo.graphexplorer.viewer.models.AttributeId$", ({
  Db: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_models_AttributeId$;
function $m_Lorg_jpablo_graphexplorer_viewer_models_AttributeId$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_models_AttributeId$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_models_AttributeId$ = new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_models_AttributeId$;
}
var $d_Lorg_jpablo_graphexplorer_viewer_models_AttributePair = new $TypeData().i(1, "org.jpablo.graphexplorer.viewer.models.AttributePair", ({
  jm: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes$() {
  this.aFj = null;
  this.aFk = false;
  this.cV = null;
  $n_Lorg_jpablo_graphexplorer_viewer_models_Attributes$ = this;
  this.cV = ($m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$(), $m_sci_Map$EmptyMap$());
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_Attributes$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_Attributes$.prototype = $p;
$p.lW = (function() {
  if ((!this.aFk)) {
    var this$6 = $m_Lupickle_default$();
    $m_Lupickle_default$();
    var $x_4 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6) => ((_$6 === null) ? null : _$6.ce)));
    var $x_3 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$7) => new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(($m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$(), _$7))));
    var $x_2 = $m_Lupickle_default$().cw();
    var $x_1 = $f_Lupickle_implicits_Readers__MapReader2__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lorg_jpablo_graphexplorer_viewer_models_AttributeId$().aOW(), $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$().aOV());
    var this$2 = $m_Lupickle_default$();
    this.aFj = new $c_Lupickle_Api$$anon$3(new $c_Lupickle_core_Types$$anon$1($x_4, $x_3, $x_2.ez($x_1, new $c_Lupickle_implicits_Writers$$anon$20($m_Lorg_jpablo_graphexplorer_viewer_models_AttributeId$().aOW(), $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$().aOV(), this$2))), this$6);
    this.aFk = true;
  }
  return this.aFj;
});
$p.DZ = (function(pairs) {
  $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$();
  return $m_sci_VectorMap$().u3(pairs);
});
$p.Au = (function(values) {
  $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$();
  return values.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$8) => _$8.aSZ()))).eX($m_s_$less$colon$less$().b1);
});
$p.aQB = (function(attrs) {
  $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$();
  return attrs.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var k = x$1.g();
    var v = x$1.h();
    return new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId(k), ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(v)));
  }))).eX($m_s_$less$colon$less$().b1);
});
$p.lk = (function(this$, x$0) {
  if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes)) {
    var x$0$2 = ((x$0 === null) ? null : x$0.ce);
    return ((this$ === null) ? (x$0$2 === null) : this$.e(x$0$2));
  } else {
    return false;
  }
});
$p.bac = (function(this$) {
  return $m_sr_ScalaRunTime$().M(new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(this$));
});
$p.b6O = (function(this$, n) {
  if ((n === 0)) {
    return this$;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.b6R = (function(this$, n) {
  if ((n === 0)) {
    return "values";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.a2r = (function(this$, other) {
  $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$();
  return this$.hN(other);
});
$p.aMY = (function(this$, other) {
  $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$();
  return this$.hN(other);
});
$p.aen = (function(this$, other) {
  $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$();
  return this$.XS(other);
});
$p.a2q = (function(this$, key) {
  $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$();
  return this$.fz(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId(key));
});
$p.W6 = (function(this$, attr) {
  $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$();
  return this$.fz(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId(attr.aN()));
});
$p.aLl = (function(this$, kv) {
  $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$();
  var kv$1 = kv.aSZ();
  return this$.bN(kv$1.g(), kv$1.h());
});
$p.ba7 = (function(this$) {
  return this$.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_Attr(((x$1.g() === null) ? null : x$1.g().fY), x$1.h())))).bM();
});
$p.X0 = (function(this$, key) {
  return this$.r(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId(key));
});
$p.qZ = (function(this$, attr) {
  return this$.r(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId(attr.aN()));
});
$p.aO6 = (function(this$, p) {
  $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$();
  return $m_sci_Map$().ao(new $c_sc_MapView$FilterKeys(new $c_sc_MapView$Id(this$), p));
});
$p.E0 = (function(this$, b) {
  var this$1 = this.X0(this$, b.aN());
  if (this$1.c()) {
    var $x_1 = $m_s_None$();
  } else {
    var x0 = this$1.d();
    var $x_1 = b.aY(x0.m());
  }
  var this$2 = $x_1;
  return (this$2.c() ? b.aT() : this$2.d());
});
$p.aih = (function(this$) {
  return new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeUpdates(this$.wk(new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((_$5, v) => new $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single(v)))));
});
var $d_Lorg_jpablo_graphexplorer_viewer_models_Attributes$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_Attributes$, "org.jpablo.graphexplorer.viewer.models.Attributes$", ({
  De: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_models_Attributes$;
function $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_models_Attributes$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_models_Attributes$ = new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_models_Attributes$;
}
function $f_Lorg_jpablo_graphexplorer_viewer_models_ElementId__isGroupId__Z($thiz) {
  return (($thiz instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId) || false);
}
function $f_Lorg_jpablo_graphexplorer_viewer_models_ElementId__isNodeId__Z($thiz) {
  return (($thiz instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId) || false);
}
function $f_Lorg_jpablo_graphexplorer_viewer_models_ElementId__isArrowId__Z($thiz) {
  return (($thiz instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowId) || false);
}
function $f_Lorg_jpablo_graphexplorer_viewer_models_ElementId__asNodeId__s_Option($thiz) {
  return (($thiz instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId) ? new $c_s_Some($thiz) : $m_s_None$());
}
function $f_Lorg_jpablo_graphexplorer_viewer_models_ElementId__asGroupId__s_Option($thiz) {
  return (($thiz instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId) ? new $c_s_Some($thiz) : $m_s_None$());
}
var $d_Lorg_jpablo_graphexplorer_viewer_models_ElementId = new $TypeData().i(1, "org.jpablo.graphexplorer.viewer.models.ElementId", ({
  cB: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$() {
  this.aFn = null;
  this.aFo = false;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$.prototype = $p;
$p.ahN = (function() {
  if ((!this.aFo)) {
    $m_Lupickle_default$();
    var $x_4 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => ((_$1 === null) ? null : _$1.aS)));
    var $x_3 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds(_$2)));
    var $x_2 = $m_Lupickle_default$().cw();
    var $x_1 = new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lorg_jpablo_graphexplorer_viewer_models_ElementId$().bm(), new $c_sc_IterableFactory$ToFactory($m_sci_Set$()));
    var this$4 = $m_Lupickle_default$();
    this.aFn = new $c_Lupickle_core_Types$$anon$1($x_4, $x_3, $x_2.ez($x_1, new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lorg_jpablo_graphexplorer_viewer_models_ElementId$().bm(), this$4)));
    this.aFo = true;
  }
  return this.aFn;
});
$p.a3i = (function(this$, x$0) {
  if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds)) {
    var x$0$2 = ((x$0 === null) ? null : x$0.aS);
    return ((this$ === null) ? (x$0$2 === null) : this$.e(x$0$2));
  } else {
    return false;
  }
});
$p.bad = (function(this$) {
  return $m_sr_ScalaRunTime$().M(new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds(this$));
});
$p.b6P = (function(this$, n) {
  if ((n === 0)) {
    return this$;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.b6S = (function(this$, n) {
  if ((n === 0)) {
    return "ids";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.bak = (function(this$, id) {
  return ((!this.mJ(this$, id)) ? this.aVy(this$, id) : this.aem(this$, id));
});
$p.b31 = (function(this$, that) {
  return this$.J3(that);
});
$p.mJ = (function(this$, id) {
  return this$.E(id);
});
$p.afK = (function(this$, p) {
  return this$.bw(p);
});
$p.aVy = (function(this$, that) {
  return this$.hQ(that);
});
$p.aem = (function(this$, that) {
  return this$.lT(that);
});
$p.aLm = (function(this$, that) {
  return this$.dI(that);
});
$p.aLk = (function(this$, that) {
  return this$.jv(that);
});
$p.tS = (function(this$, that) {
  return this$.dI(that);
});
$p.yk = (function(this$, that) {
  return this$.jv(that);
});
$p.io = (function(this$) {
  return this.gV(this$).gg;
});
$p.gV = (function(this$) {
  var z = new $c_Lorg_jpablo_graphexplorer_viewer_models_IdsByKind($m_sci_Set$EmptySet$(), $m_sci_Set$EmptySet$(), $m_sci_Set$EmptySet$());
  var f = ((acc, eId) => {
    if ((eId instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId)) {
      return new $c_Lorg_jpablo_graphexplorer_viewer_models_IdsByKind(acc.f3.hQ(eId), acc.gg, acc.gf);
    }
    if ((eId instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId)) {
      var nodes$1$1 = acc.gg.hQ(eId);
      return new $c_Lorg_jpablo_graphexplorer_viewer_models_IdsByKind(acc.f3, nodes$1$1, acc.gf);
    }
    if ((eId instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowId)) {
      var arrows$2 = acc.gf.hQ(eId);
      return new $c_Lorg_jpablo_graphexplorer_viewer_models_IdsByKind(acc.f3, acc.gg, arrows$2);
    }
    throw new $c_s_MatchError(eId);
  });
  if ($is_sc_IndexedSeq(this$)) {
    var at = 0;
    var end = this$.C();
    var acc$1 = z;
    var $x_1;
    while (true) {
      if ((at !== end)) {
        var temp$at = ((1 + at) | 0);
        var x0 = acc$1;
        var x1 = this$.l(at);
        var temp$acc = f(x0, x1);
        at = temp$at;
        acc$1 = temp$acc;
        continue;
      }
      var $x_1 = acc$1;
      break;
    }
  } else {
    var result = z;
    var it = this$.o();
    while (it.p()) {
      var x0$1 = result;
      var x1$1 = it.q();
      result = f(x0$1, x1$1);
    }
    var $x_1 = result;
  }
  return $x_1;
});
var $d_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$, "org.jpablo.graphexplorer.viewer.models.ElementIds$", ({
  Dl: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$;
function $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$ = new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$;
}
function $f_Lorg_jpablo_graphexplorer_viewer_models_ViewerElement__label__Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue($thiz) {
  return $thiz.aeR().ay(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Label$())), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$().ayW)));
}
function $p_Lorg_jpablo_graphexplorer_viewer_selection_SelectByKind$__menuOption__Lorg_jpablo_graphexplorer_viewer_selection_ElementKind__I__s_Option($thiz, kind, count) {
  return ((count > 0) ? new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_selection_SelectByKind$MenuOption((((kind.aI() + " (") + count) + ")"), kind, count)) : $m_s_None$());
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_selection_SelectByKind$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_selection_SelectByKind$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_selection_SelectByKind$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_selection_SelectByKind$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_selection_SelectByKind$.prototype = $p;
$p.b5k = (function(ids) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(new $c_sci_$colon$colon($p_Lorg_jpablo_graphexplorer_viewer_selection_SelectByKind$__menuOption__Lorg_jpablo_graphexplorer_viewer_selection_ElementKind__I__s_Option(this, $s_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$__Nodes__Lorg_jpablo_graphexplorer_viewer_selection_ElementKind(), ids.gg.aa()), new $c_sci_$colon$colon($p_Lorg_jpablo_graphexplorer_viewer_selection_SelectByKind$__menuOption__Lorg_jpablo_graphexplorer_viewer_selection_ElementKind__I__s_Option(this, $s_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$__Edges__Lorg_jpablo_graphexplorer_viewer_selection_ElementKind(), ids.gf.aa()), new $c_sci_$colon$colon($p_Lorg_jpablo_graphexplorer_viewer_selection_SelectByKind$__menuOption__Lorg_jpablo_graphexplorer_viewer_selection_ElementKind__I__s_Option(this, $s_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$__Groups__Lorg_jpablo_graphexplorer_viewer_selection_ElementKind(), ids.f3.aa()), $m_sci_Nil$()))), $m_s_$less$colon$less$().b1);
});
$p.b2H = (function(ids, kind) {
  var x = $s_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$__Nodes__Lorg_jpablo_graphexplorer_viewer_selection_ElementKind();
  if (((x === null) ? (kind === null) : (x === kind))) {
    return ids.gg;
  }
  var x$3 = $s_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$__Edges__Lorg_jpablo_graphexplorer_viewer_selection_ElementKind();
  if (((x$3 === null) ? (kind === null) : (x$3 === kind))) {
    return ids.gf;
  }
  var x$5 = $s_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$__Groups__Lorg_jpablo_graphexplorer_viewer_selection_ElementKind();
  if (((x$5 === null) ? (kind === null) : (x$5 === kind))) {
    return ids.f3;
  }
  throw new $c_s_MatchError(kind);
});
var $d_Lorg_jpablo_graphexplorer_viewer_selection_SelectByKind$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_selection_SelectByKind$, "org.jpablo.graphexplorer.viewer.selection.SelectByKind$", ({
  DD: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_selection_SelectByKind$;
function $m_Lorg_jpablo_graphexplorer_viewer_selection_SelectByKind$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_selection_SelectByKind$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_selection_SelectByKind$ = new $c_Lorg_jpablo_graphexplorer_viewer_selection_SelectByKind$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_selection_SelectByKind$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramPersistence$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramPersistence$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramPersistence$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_DiagramPersistence$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_DiagramPersistence$.prototype = $p;
$p.b1x = (function(target, initialSource) {
  if ((target instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$LibraryDiagram)) {
    return new $c_Lorg_jpablo_graphexplorer_viewer_state_LibraryDiagramPersistence(target.xp, initialSource);
  }
  if ((target instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$LooseFile)) {
    return new $c_Lorg_jpablo_graphexplorer_viewer_desktop_LooseFilePersistence(target.tq);
  }
  if ((target instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$Example)) {
    return $m_Lorg_jpablo_graphexplorer_viewer_state_EphemeralPersistence$().b0T(initialSource, target.MV);
  }
  throw new $c_s_MatchError(target);
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_DiagramPersistence$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_DiagramPersistence$, "org.jpablo.graphexplorer.viewer.state.DiagramPersistence$", ({
  DG: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_state_DiagramPersistence$;
function $m_Lorg_jpablo_graphexplorer_viewer_state_DiagramPersistence$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_state_DiagramPersistence$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_state_DiagramPersistence$ = new $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramPersistence$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_state_DiagramPersistence$;
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps__$init$__V($thiz) {
  $thiz.N0 = $m_Lcom_raquo_airstream_state_Var$().bx(new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds($m_sci_Set$EmptySet$()));
  $thiz.zB = $m_Lcom_raquo_airstream_state_Var$().bx($m_s_None$());
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps__printSelectionToConsole__V($thiz) {
  var this$9 = $m_Lpprint_package$();
  var x = new $c_Lsourcecode_Text(new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds($thiz.aH().cL()), "selection.now()");
  $m_Lpprint_package$();
  var tag = "";
  var width = $m_Lpprint_package$().CQ;
  var height = $m_Lpprint_package$().CO;
  var indent = $m_Lpprint_package$().CP;
  var escapeUnicode = $m_Lpprint_package$().CN;
  var showFieldNames = $m_Lpprint_package$().Hk;
  $m_Lsourcecode_Line$();
  var line = new $c_Lsourcecode_Line(406);
  $m_Lsourcecode_FileName$();
  var fileName = new $c_Lsourcecode_FileName("DiagramSelectionOps.scala");
  this$9.aR4(x, tag, width, height, indent, escapeUnicode, showFieldNames, $m_s_Console$().ahl(), line, fileName);
  console.log("Visible current selection to the console");
}
function $s_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps__org$jpablo$graphexplorer$viewer$state$DiagramSelectionOps$selection$$$_$selector$1__Z__Z__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__sci_Set__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(outgoing$1, transitive$1, graph, nodes) {
  var x6 = new $c_T2(outgoing$1, transitive$1);
  var x13 = (!(!x6.bi));
  var x14 = (!(!x6.be));
  if (x13) {
    if (x14) {
      return graph.aLW().i($m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().io(nodes));
    }
    if ((!x14)) {
      return graph.aNu().i($m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().io(nodes));
    }
  }
  if ((!x13)) {
    if (x14) {
      return graph.aLV().i($m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().io(nodes));
    }
    if ((!x14)) {
      return graph.aNs().i($m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().io(nodes));
    }
  }
  throw new $c_s_MatchError(x6);
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$.prototype = $p;
$p.WO = (function(elements, strategy, selector) {
  var effectiveSelector = (selector.c() ? $f_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElementStrategy__allSelector__T(strategy) : selector.d());
  var $x_1 = $m_sjs_js_ArrayOps$();
  var res = [];
  var len = (elements.length | 0);
  var i = 0;
  while ((i < len)) {
    var x0 = elements[i];
    if ((x0.namespaceURI === "http://www.w3.org/2000/svg")) {
      (res.push(x0) | 0);
    }
    i = ((1 + i) | 0);
  }
  var b = [];
  var len$1 = (res.length | 0);
  var i$1 = 0;
  while ((i$1 < len$1)) {
    var x0$1 = res[i$1];
    $m_sjs_js_ArrayOps$().aLP(b, $m_s_Option$().as(x0$1.closest(effectiveSelector)));
    i$1 = ((1 + i$1) | 0);
  }
  var array$1 = $x_1.aYw($m_sjs_js_ArrayOps$().b01(b), new $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$$anon$1());
  var len$2 = (array$1.length | 0);
  var res$1 = new Array(len$2);
  var i$2 = 0;
  while ((i$2 < len$2)) {
    var $x_2 = i$2;
    var x0$2 = array$1[i$2];
    res$1[$x_2] = $m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().ag4(x0$2, strategy);
    i$2 = ((1 + i$2) | 0);
  }
  return $m_sjs_js_ArrayOps$().aYy(res$1, new $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$$anon$2());
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$, "org.jpablo.graphexplorer.viewer.state.DiagramSelectionOps$", ({
  DI: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$;
function $m_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$ = new $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$selection$__selectRelated__Z__Z__V($thiz, outgoing, transitive) {
  var visibleSubGraph = $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__fullGraphObs__Lcom_raquo_airstream_state_OwnedSignal($thiz.di)).d().a4t($thiz.di.il().cL());
  matchResult3: {
    var x15 = $thiz.di.du().b8q(visibleSubGraph, outgoing);
    if ((x15 instanceof $c_s_Some)) {
      var x17 = x15.J;
      if ((x17 !== null)) {
        var arrowIds = x17.g();
        var farNodes = x17.h();
        var keptCell = $thiz.di.du().b8p();
        var rest = $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().io($thiz.cL()).jv($m_sci_Set$().af($m_s_Option$().m2($thiz.di.du().aRZ())));
        var seed = rest.dI((transitive ? farNodes : $m_sci_Set$EmptySet$()));
        var g = $s_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps__org$jpablo$graphexplorer$viewer$state$DiagramSelectionOps$selection$$$_$selector$1__Z__Z__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__sci_Set__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(outgoing, transitive, visibleSubGraph, seed.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x) => x))));
        $thiz.OU($m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().tS($m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().tS(arrowIds.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2) => x$2))).dI(farNodes), g.j8), g.qn));
        if ((!keptCell.c())) {
          var x0 = keptCell.d();
          $thiz.di.du().b7Q(x0);
          break matchResult3;
        } else {
          break matchResult3;
        }
      }
    }
    if (($m_s_None$() === x15)) {
      var relatedSubGraph = $s_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps__org$jpablo$graphexplorer$viewer$state$DiagramSelectionOps$selection$$$_$selector$1__Z__Z__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__sci_Set__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(outgoing, transitive, visibleSubGraph, $thiz.cL());
      $thiz.aeE(relatedSubGraph.j8.g9(relatedSubGraph.qn));
      break matchResult3;
    }
    throw new $c_s_MatchError(x15);
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$selection$__selectNewNodes__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__V($thiz, before, after) {
  var created = after.j8.jv(before.j8);
  if ((!created.c())) {
    $thiz.gC(created);
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$selection$__followNewArrows__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__sci_Set__V($thiz, old, updated, keep) {
  var newArrowIds = updated.qn.jv(old.qn);
  if ((!newArrowIds.c())) {
    $thiz.gC(keep.dI(newArrowIds));
  }
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$selection$(outer) {
  this.ne = null;
  this.aFC = null;
  this.di = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.di = outer;
  this.ne = $f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable(outer.N0.P());
  this.aFC = new $c_Lcom_raquo_airstream_misc_StreamFromSignal($f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), $f_Lcom_raquo_airstream_core_Signal__scanLeft__F1__F2__Lcom_raquo_airstream_core_Signal(this.ne, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((curr) => new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds($m_sci_Set$EmptySet$()), new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds(((curr === null) ? null : curr.aS))))), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((x$1, x$2) => {
    var x$2$1 = ((x$2 === null) ? null : x$2.aS);
    var x1 = new $c_T2(x$1, new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds(x$2$1));
    var x2 = x1.bi;
    if ((x2 !== null)) {
      return new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds(((x2.h() === null) ? null : x2.h().aS)), new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds(((x1.be === null) ? null : x1.be.aS)));
    }
    throw new $c_s_MatchError(x1);
  }))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    var curr$3 = ((x$1$2.g() === null) ? null : x$1$2.g().aS);
    var next$1 = ((x$1$2.h() === null) ? null : x$1$2.h().aS);
    return new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds($m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().afK(curr$3, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((id) => (!$m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().mJ(next$1, id)))))), new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds($m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().afK(next$1, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((id$2) => (!$m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().mJ(curr$3, id$2)))))));
  })), $m_s_None$())), true);
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$selection$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$selection$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$selection$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$selection$.prototype = $p;
$p.afp = (function() {
  var current = this.cL();
  if ((current.aa() === 1)) {
    $f_Lcom_raquo_airstream_state_Var__set__O__V(this.di.zB, new $c_s_Some(current.t()));
  }
});
$p.cL = (function() {
  var ev$7 = this.di.N0.P().aq().d();
  return ((ev$7 === null) ? null : ev$7.aS);
});
$p.a53 = (function(ss) {
  $f_Lcom_raquo_airstream_state_Var__update__F1__V(this.di.N0, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => {
    var _$1 = ((v1 === null) ? null : v1.aS);
    var ev$8 = ss.hO(new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds(_$1), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((v1$1, v2) => new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds($m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().bak(((v1$1 === null) ? null : v1$1.aS), v2)))));
    return new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds(((ev$8 === null) ? null : ev$8.aS));
  })));
});
$p.rd = (function(ss) {
  $f_Lcom_raquo_airstream_state_Var__set__O__V(this.di.N0, new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds(ss));
});
$p.gC = (function(ss) {
  this.rd(ss);
});
$p.aeE = (function(ss) {
  this.OU(ss);
});
$p.OU = (function(ss) {
  var current = this.cL();
  var newNodes = $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().aLk(ss, current);
  if ((!newNodes.c())) {
    this.rd($m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().aLm(current, newNodes));
  }
});
$p.XR = (function(ss) {
  var current = this.cL();
  var nodesToRemove = $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().b31(ss, current);
  if ((!nodesToRemove.c())) {
    this.rd($m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().aLk(current, nodesToRemove));
  }
});
$p.b3T = (function(p) {
  $f_Lcom_raquo_airstream_state_Var__update__F1__V(this.di.N0, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds($m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().afK(((v1 === null) ? null : v1.aS), p)))));
});
$p.ie = (function() {
  this.rd($m_sci_Set$EmptySet$());
});
$p.a2Z = (function(id) {
  return $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), this.ne, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((ids) => $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().mJ(((ids === null) ? null : ids.aS), id))), $m_s_None$());
});
$p.b2C = (function() {
  $f_Lcom_raquo_airstream_state_Var__update__F1__V(this.di.gn().CB, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => {
    var $x_2 = $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$();
    var $x_1 = ((v1 === null) ? null : v1.aS);
    var this$2 = this.di;
    var ids = this.cL();
    return new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds($x_2.aLm($x_1, $f_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps__resolveProxies__sci_Set__sci_Set($f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__visibleGraphObs__Lcom_raquo_airstream_state_OwnedSignal(this$2)).d(), ids)));
  })));
});
$p.af0 = (function() {
  var $x_1 = $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$();
  var this$1 = this.di;
  var ids = this.cL();
  return $x_1.gV($f_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps__resolveProxies__sci_Set__sci_Set($f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__visibleGraphObs__Lcom_raquo_airstream_state_OwnedSignal(this$1)).d(), ids)).f3;
});
$p.aii = (function() {
  var gs = this.af0();
  if ((!gs.c())) {
    $f_Lcom_raquo_airstream_state_Var__update__F1__V(this.di.gn().nh, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((collapsed) => (gs.Q0(collapsed) ? collapsed.jv(gs) : collapsed.dI(gs)))));
  }
});
$p.aYs = (function() {
  var gs = this.af0();
  if ((!gs.c())) {
    $f_Lcom_raquo_airstream_state_Var__update__F1__V(this.di.gn().nh, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6) => _$6.dI(gs))));
  }
});
$p.b0X = (function() {
  var gs = this.af0();
  if ((!gs.c())) {
    $f_Lcom_raquo_airstream_state_Var__update__F1__V(this.di.gn().nh, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$7) => _$7.jv(gs))));
  }
});
$p.aRX = (function() {
  var s = this.cL();
  var classified = $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().gV(s);
  if ((!classified.f3.c())) {
    var groupIds = classified.f3;
    this.rd($m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().tS(s, $f_Lorg_jpablo_graphexplorer_viewer_graph_GroupsOps__getAllChildren__sci_Set__sci_Set($f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__fullGraphObs__Lcom_raquo_airstream_state_OwnedSignal(this.di)).d(), groupIds)));
  }
});
$p.aWS = (function() {
  var classified = $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().gV(this.cL());
  var this$2 = $f_sc_IterableOps__headOption__s_Option(classified.f3);
  if ((!this$2.c())) {
    var x0 = this$2.d();
    $f_Lcom_raquo_airstream_state_Var__update__F1__V(this.di.d4.jI, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((groupNodeId$2) => ((_$8) => $f_Lorg_jpablo_graphexplorer_viewer_graph_GroupsOps__moveToGroup__Lorg_jpablo_graphexplorer_viewer_models_GroupId__sci_Seq__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(_$8, groupNodeId$2, $m_sci_Seq$().fw(classified.gg))))(x0)));
  }
});
$p.b2i = (function() {
  this.di.aZq(this.cL());
});
$p.baD = (function() {
  $f_Lorg_jpablo_graphexplorer_viewer_state_DocumentCommandRunner__runDocumentCommand__Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand__F2__V(this.di, new $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$Ungroup($m_sci_Set$().af(this.cL())), $f_Lorg_jpablo_graphexplorer_viewer_state_DocumentCommandRunner__runDocumentCommand$default$2__F2(this.di));
});
$p.aYF = (function() {
  var nodeIds = $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().io(this.cL());
  if ((!nodeIds.c())) {
    $f_Lorg_jpablo_graphexplorer_viewer_state_DocumentCommandRunner__runDocumentCommand__Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand__F2__V(this.di, new $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$CombineIntoRecord(nodeIds), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((before, after) => {
      $p_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$selection$__selectNewNodes__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__V(this, before, after);
    })));
  }
});
$p.b9j = (function() {
  var nodeIds = $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().io(this.cL());
  if ((nodeIds.aa() === 1)) {
    $f_Lorg_jpablo_graphexplorer_viewer_state_DocumentCommandRunner__runDocumentCommand__Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand__F2__V(this.di, new $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$SplitRecord(nodeIds.t()), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((before, after) => {
      $p_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$selection$__selectNewNodes__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__V(this, before, after);
    })));
  }
});
$p.bau = (function() {
  var nodeIds = $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().io(this.cL());
  if ((nodeIds.aa() === 1)) {
    $f_Lorg_jpablo_graphexplorer_viewer_state_DocumentCommandRunner__runDocumentCommand__Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand__F2__V(this.di, new $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$TransposeRecord(nodeIds.t()), $f_Lorg_jpablo_graphexplorer_viewer_state_DocumentCommandRunner__runDocumentCommand$default$2__F2(this.di));
  }
});
$p.b7W = (function() {
  var x = $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__currentFormatObs__Lcom_raquo_airstream_state_OwnedSignal(this.di)).d();
  var x$2 = $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__Mermaid__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat();
  var mermaidMode = ((x === null) ? (x$2 === null) : (x === x$2));
  var applies = this.di.d4.u5();
  $f_Lcom_raquo_airstream_state_Var__update__F1__V(this.di.d4.jI, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((graph) => {
    var classified = $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().gV(this.cL());
    matchResult4: {
      var \u03b42$___1;
      var \u03b42$___2;
      var x20 = (mermaidMode ? classified.gf.ju(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((graph$2) => ((id) => {
        var this$4 = graph$2.fX.r(id);
        if ((!this$4.c())) {
          var x0 = this$4.d();
          var markers = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().aND(x0.fG);
          return ((!(!markers.h())) && (!(!(!markers.g()))));
        } else {
          return false;
        }
      }))(graph))) : new $c_T2($m_sci_Set$EmptySet$(), classified.gf));
      if ((x20 !== null)) {
        var \u03b42$___1 = x20.g();
        var \u03b42$___2 = x20.h();
        break matchResult4;
      }
      throw new $c_s_MatchError(x20);
    }
    var toReverse$2 = \u03b42$___1;
    var toSwap$2 = \u03b42$___2;
    var newGraph = graph.b7V(toSwap$2).aRL(toReverse$2);
    if (applies) {
      $p_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$selection$__followNewArrows__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__sci_Set__V(this, graph, newGraph, classified.gg.g9(classified.f3).dI(toSwap$2));
    }
    return newGraph;
  })));
});
$p.b7U = (function() {
  var applies = this.di.d4.u5();
  $f_Lcom_raquo_airstream_state_Var__update__F1__V(this.di.d4.jI, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((graph) => {
    var classified = $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().gV(this.cL());
    var newGraph = graph.aRL(this.cL());
    if (applies) {
      $p_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$selection$__followNewArrows__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__sci_Set__V(this, graph, newGraph, classified.gg.g9(classified.f3));
    }
    return newGraph;
  })));
});
$p.b8m = (function() {
  this.gC($f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__visibleGraphObs__Lcom_raquo_airstream_state_OwnedSignal(this.di)).d().j8);
});
$p.b8k = (function() {
  this.gC($f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__visibleGraphObs__Lcom_raquo_airstream_state_OwnedSignal(this.di)).d().qn);
});
$p.b8l = (function() {
  var visible = $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__visibleGraphObs__Lcom_raquo_airstream_state_OwnedSignal(this.di)).d();
  this.gC(visible.xf.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((g) => g))).dI($f_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps__proxyIds__sci_Set(visible)));
});
$p.b8j = (function() {
  var visibleGraph = $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__visibleGraphObs__Lcom_raquo_airstream_state_OwnedSignal(this.di)).d();
  var nodes = visibleGraph.j8;
  var edges = visibleGraph.qn;
  var groups = visibleGraph.xf;
  this.gC(nodes.g9(edges).dI(groups));
});
$p.aZO = (function() {
  var this$1 = this.di;
  var ids = this.cL();
  var toRemove = $f_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps__resolveProxies__sci_Set__sci_Set($f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__visibleGraphObs__Lcom_raquo_airstream_state_OwnedSignal(this$1)).d(), ids);
  var applies = this.di.d4.u5();
  $f_Lcom_raquo_airstream_state_Var__update__F1__V(this.di.d4.jI, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$9) => _$9.a4t(toRemove))));
  if (applies) {
    $f_Lcom_raquo_airstream_state_Var__update__F1__V(this.di.gn().nh, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$10) => _$10.jv($m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().gV(toRemove).f3))));
  }
});
$p.b0j = (function() {
  var applies = this.di.d4.u5();
  $f_Lcom_raquo_airstream_state_Var__update__F1__V(this.di.d4.jI, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((graph) => {
    var currentSelection = this.cL();
    if (currentSelection.c()) {
      return graph;
    } else {
      matchResult5: {
        var \u03b41$___1;
        var \u03b41$___2;
        var x23 = graph.b0i($m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().gV(currentSelection));
        if ((x23 !== null)) {
          var \u03b41$___1 = x23.g();
          var \u03b41$___2 = x23.h();
          break matchResult5;
        }
        throw new $c_s_MatchError(x23);
      }
      var newGraph$2 = \u03b41$___1;
      var newElements$2 = \u03b41$___2;
      if ((applies && (!newElements$2.c()))) {
        this.gC(newElements$2);
      }
      return newGraph$2;
    }
  })));
});
$p.b7J = (function() {
  var selection = this.cL();
  if ((!selection.c())) {
    $f_Lcom_raquo_airstream_state_Var__update__F1__V(this.di.d4.jI, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$11) => $f_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps__resetAttributes__sci_Set__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(_$11, selection))));
  }
});
$p.b7K = (function() {
  var x = ("resetLayout called for selection: " + new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds(this.cL()));
  $m_s_Console$().ahl().a3V((x + "\n"));
});
$p.a57 = (function(elementId, shiftKey) {
  if (shiftKey) {
    this.a53($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_ElementId.r().C)([elementId])));
  } else {
    this.rd($m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_ElementId.r().C)([elementId]))));
  }
  if ($m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().mJ(this.cL(), elementId)) {
    $f_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps__navCursorSet__Lorg_jpablo_graphexplorer_viewer_models_ElementId__V(this.di, elementId);
  }
});
$p.b2m = (function(arrow, shiftKey) {
  var nodeId = arrow.dw;
  if (shiftKey) {
    this.a53($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_ElementId.r().C)([nodeId])));
  } else {
    this.rd($m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_ElementId.r().C)([nodeId]))));
  }
  if ($m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().mJ(this.cL(), nodeId)) {
    $f_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps__navCursorSet__Lorg_jpablo_graphexplorer_viewer_models_ElementId__V(this.di, nodeId);
  }
});
$p.b3l = (function(elem, rect) {
  var bbox = elem.dD().getBoundingClientRect();
  var x = rect.oe.fi;
  var that = rect.jK.fi;
  var x$1 = (+Math.min(x, that));
  var x$2 = rect.oe.fj;
  var that$1 = rect.jK.fj;
  var y = (+Math.min(x$2, that$1));
  var x$3 = (rect.jK.fi - rect.oe.fi);
  var width = (+Math.abs(x$3));
  var x$4 = (rect.jK.fj - rect.oe.fj);
  var height = (+Math.abs(x$4));
  return (!(((((+bbox.right) < x$1) || ((+bbox.left) > (x$1 + width))) || ((+bbox.bottom) < y)) || ((+bbox.top) > (y + height))));
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$selection$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$selection$, "org.jpablo.graphexplorer.viewer.state.DiagramSelectionOps$selection$", ({
  DL: 1
}));
function $f_Lorg_jpablo_graphexplorer_viewer_state_DocumentCommandRunner__runDocumentCommand__Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand__F2__V($thiz, command, onApplied) {
  var applies = $thiz.d4.u5();
  $f_Lcom_raquo_airstream_state_Var__update__F1__V($thiz.d4.jI, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((graph) => {
    var x1 = $m_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommands$().b82(graph, command);
    if ((x1 instanceof $c_s_util_Right)) {
      var x10 = x1.hm;
      if ((x10 instanceof $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandResult$Updated)) {
        var x13 = x10.S5;
        if (applies) {
          onApplied.R(graph, x13);
        }
        return x13;
      }
      if ((x10 instanceof $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandResult$Answered)) {
        return graph;
      }
    }
    if ((x1 instanceof $c_s_util_Left)) {
      var error = x1.lP;
      var this$4 = $thiz.tr;
      var event = error.aQj();
      this$4.dn.bA(event);
      return graph;
    }
    throw new $c_s_MatchError(x1);
  })));
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_DocumentCommandRunner__runDocumentCommand$default$2__F2($thiz) {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((_$1, _$2) => (void 0)));
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_EditorPacing$() {
  this.aUQ = 0.0;
  this.aUP = 0.0;
  this.aaX = 0.0;
  this.aUQ = 60.0;
  this.aUP = 900.0;
  this.aaX = 0.0;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_EditorPacing$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_EditorPacing$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_EditorPacing$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_EditorPacing$.prototype = $p;
$p.aZJ = (function() {
  var y = this.aaX;
  var y$1 = (+Math.min(900.0, y));
  return $doubleToInt((+Math.max(60.0, y$1)));
});
$p.aQT = (function(stream) {
  var project = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((a) => $m_Lcom_raquo_airstream_core_EventStream$().aZI($m_Lorg_jpablo_graphexplorer_viewer_state_EditorPacing$().aZJ(), a, ($m_Lcom_raquo_airstream_core_EventStream$(), false))));
  return $m_Lcom_raquo_airstream_core_Observable$().AM.mK(new $c_Lcom_raquo_airstream_misc_MapStream(stream, project, $m_s_None$()));
});
$p.b6i = (function(signal) {
  var initialOperator = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x) => x));
  return new $c_Lcom_raquo_airstream_misc_SignalFromStream($m_Lorg_jpablo_graphexplorer_viewer_state_EditorPacing$().aQT(new $c_Lcom_raquo_airstream_misc_StreamFromSignal(signal, true)), new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d(((this$2) => (() => initialOperator.i(this$2.aq())))(signal)), false);
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_EditorPacing$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_EditorPacing$, "org.jpablo.graphexplorer.viewer.state.EditorPacing$", ({
  DS: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_state_EditorPacing$;
function $m_Lorg_jpablo_graphexplorer_viewer_state_EditorPacing$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_state_EditorPacing$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_state_EditorPacing$ = new $c_Lorg_jpablo_graphexplorer_viewer_state_EditorPacing$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_state_EditorPacing$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_EphemeralPersistence$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_EphemeralPersistence$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_EphemeralPersistence$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_EphemeralPersistence$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_EphemeralPersistence$.prototype = $p;
$p.b0T = (function(initialSource, name) {
  var \u03b41$ = $m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$().Jb(initialSource);
  return new $c_Lorg_jpablo_graphexplorer_viewer_state_EphemeralPersistence(new $c_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState(\u03b41$.ob, \u03b41$.oa, name, \u03b41$.hf, \u03b41$.nf, \u03b41$.o9), "Copy this example to your library before you save it");
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_EphemeralPersistence$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_EphemeralPersistence$, "org.jpablo.graphexplorer.viewer.state.EphemeralPersistence$", ({
  DU: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_state_EphemeralPersistence$;
function $m_Lorg_jpablo_graphexplorer_viewer_state_EphemeralPersistence$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_state_EphemeralPersistence$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_state_EphemeralPersistence$ = new $c_Lorg_jpablo_graphexplorer_viewer_state_EphemeralPersistence$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_state_EphemeralPersistence$;
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_ExportOps__copyAsFullDiagramSVG__V($thiz) {
  var this$2 = $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__finalSVGObs__Lcom_raquo_airstream_state_OwnedSignal($thiz)).d();
  if ((!this$2.c())) {
    var x0 = this$2.d();
    $thiz.vt.i(x0.e8.outerHTML);
  }
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_ExportOps__copySelectionAsSVG__V($thiz) {
  var this$2 = $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__finalSVGObs__Lcom_raquo_airstream_state_OwnedSignal($thiz)).d();
  if ((!this$2.c())) {
    var x0 = this$2.d();
    $thiz.vt.i(new $c_Lorg_jpablo_graphexplorer_viewer_components_SvgElementOps(x0.e8).bab($thiz.aH().cL(), $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__selectionStrategyObs__Lcom_raquo_airstream_state_OwnedSignal($thiz)).d()));
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_ExportOps__visibleDOT__T($thiz) {
  return $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$().aiz($f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__visibleGraphObs__Lcom_raquo_airstream_state_OwnedSignal($thiz)).d(), false);
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_ExportOps__copyAsDOT__V($thiz) {
  $thiz.vt.i($p_Lorg_jpablo_graphexplorer_viewer_state_ExportOps__visibleDOT__T($thiz));
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_ExportOps__copyAsJSON__V($thiz) {
  var graph = $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__visibleGraphObs__Lcom_raquo_airstream_state_OwnedSignal($thiz)).d();
  $thiz.vt.i($f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($m_Lupickle_default$(), graph.aA, ($m_Lupickle_default$(), (-1)), ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$().bm()));
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_ExportOps__copySourceText__V($thiz) {
  $thiz.vt.i($thiz.mz.P().aq().d());
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_ExportOps__printVisibleGraphToConsole__V($thiz) {
  var graph = $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__visibleGraphObs__Lcom_raquo_airstream_state_OwnedSignal($thiz)).d();
  var x$1 = new $c_Lsourcecode_Text(graph, "graph");
  $m_Lpprint_package$();
  var tag$1 = "";
  var width$1 = $m_Lpprint_package$().CQ;
  var height$1 = $m_Lpprint_package$().CO;
  var indent$1 = $m_Lpprint_package$().CP;
  var escapeUnicode$1 = $m_Lpprint_package$().CN;
  var this$9 = $m_Lpprint_package$();
  $m_Lsourcecode_Line$();
  var line = new $c_Lsourcecode_Line(41);
  $m_Lsourcecode_FileName$();
  var fileName = new $c_Lsourcecode_FileName("ExportOps.scala");
  this$9.aR4(x$1, tag$1, width$1, height$1, indent$1, escapeUnicode$1, true, $m_s_Console$().ahl(), line, fileName);
  console.log("Visible graph printed to the console");
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_ExportOps__printVisibleGraphJsonToConsole__V($thiz) {
  var graph = $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__visibleGraphObs__Lcom_raquo_airstream_state_OwnedSignal($thiz)).d();
  console.log($f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($m_Lupickle_default$(), graph.aA, 2, ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$().bm()));
  console.log("Visible graph printed to the console");
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_ExportOps__printVisibleDOTtoConsole__V($thiz) {
  console.log($p_Lorg_jpablo_graphexplorer_viewer_state_ExportOps__visibleDOT__T($thiz));
  console.log("Visible DOT printed to the console");
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_ExportOps__printVisibleSimpleGraphJSONtoConsole__V($thiz) {
  $thiz.MW.aSL($p_Lorg_jpablo_graphexplorer_viewer_state_ExportOps__visibleDOT__T($thiz)).kO(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((err) => {
    console.error("Could not build SimpleGraph JSON:", err.e3());
  })), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((graph) => {
    console.log(JSON.parse($f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($m_Lupickle_default$(), graph, ($m_Lupickle_default$(), (-1)), ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$().a3I())));
    console.log("Visible SimpleGraph JSON printed to the console");
  })));
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_ImportOps__replaceSource__T__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat__V($thiz, text, format) {
  $thiz.d4.aRI(text, format);
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_ImportOps__replaceSourceDetectingFormat__T__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat($thiz, text) {
  var format = $m_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$().Pg(text);
  $f_Lorg_jpablo_graphexplorer_viewer_state_ImportOps__replaceSource__T__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat__V($thiz, text, format);
  return format;
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_ImportOps__restoreSource__T__V($thiz, text) {
  var x1 = $m_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$().WB(text);
  if (($m_s_None$() === x1)) {
    $f_Lcom_raquo_airstream_state_Var__set__O__V($thiz.mz, text);
    return (void 0);
  }
  if ((x1 instanceof $c_s_Some)) {
    $f_Lorg_jpablo_graphexplorer_viewer_state_ImportOps__replaceSource__T__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat__V($thiz, text, x1.J);
    return (void 0);
  }
  throw new $c_s_MatchError(x1);
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_ImportOps__pasteDiagram__V($thiz) {
  $thiz.N4.a3().XC(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    matchResult3: {
      if ((x$1 instanceof $c_s_util_Success)) {
        var raw = x$1.fM;
        var x4 = $m_Lorg_jpablo_graphexplorer_viewer_backends_PastedDiagram$().Pm(raw);
        if ((x4 instanceof $c_s_Some)) {
          $p_Lorg_jpablo_graphexplorer_viewer_state_ImportOps__applyPaste__Lorg_jpablo_graphexplorer_viewer_backends_PastedDiagram__V($thiz, x4.J);
          break matchResult3;
        }
        if (($m_s_None$() === x4)) {
          $thiz.od.dn.bA("Nothing to paste: the clipboard holds no text");
          break matchResult3;
        }
        throw new $c_s_MatchError(x4);
      }
      if ((x$1 instanceof $c_s_util_Failure)) {
        var err = x$1.le;
        var this$3 = $thiz.tr;
        var event = ("Could not read the clipboard: " + err.e3());
        this$3.dn.bA(event);
        break matchResult3;
      }
      throw new $c_s_MatchError(x$1);
    }
  })), $m_s_concurrent_ExecutionContext$().ek());
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_ImportOps__pasteDiagramFromGesture__T__V($thiz, raw) {
  var this$1 = $m_Lorg_jpablo_graphexplorer_viewer_backends_PastedDiagram$().Pm(raw);
  var x12 = ((this$1.c() || this$1.d().Lp) ? this$1 : $m_s_None$());
  if ((x12 instanceof $c_s_Some)) {
    $p_Lorg_jpablo_graphexplorer_viewer_state_ImportOps__applyPaste__Lorg_jpablo_graphexplorer_viewer_backends_PastedDiagram__V($thiz, x12.J);
    return (void 0);
  }
  if (($m_s_None$() === x12)) {
    $thiz.od.dn.bA("The clipboard holds no DOT or Mermaid diagram");
    return (void 0);
  }
  throw new $c_s_MatchError(x12);
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_ImportOps__applyPaste__Lorg_jpablo_graphexplorer_viewer_backends_PastedDiagram__V($thiz, pasted) {
  $f_Lorg_jpablo_graphexplorer_viewer_state_ImportOps__replaceSource__T__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat__V($thiz, pasted.Lq, pasted.FQ);
  var this$1 = $thiz.od;
  var event = (("Pasted " + pasted.FQ.DT()) + " diagram from the clipboard");
  this$1.dn.bA(event);
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_InternalPhases__lossyEditRefusal__Lorg_jpablo_graphexplorer_viewer_state_GraphState__s_Option($thiz, current) {
  if ((!(!(!$thiz.aFG.a3())))) {
    return $m_s_None$();
  } else {
    var lost = $m_Lorg_jpablo_graphexplorer_viewer_backends_RoundTripLoss$().b8g(current.qo, current.vr);
    return ((!lost.c()) ? new $c_s_Some($p_Lorg_jpablo_graphexplorer_viewer_state_InternalPhases__refusalMessage__sci_Set__T($thiz, lost)) : $m_s_None$());
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_InternalPhases__refusalMessage__sci_Set__T($thiz, lost) {
  var this$3 = $m_sci_Nil$().b6($m_s_Predef$().fB($m_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$().bb4()));
  var f = ((elem) => lost.E(elem));
  var l = this$3;
  block: {
    var result;
    while (true) {
      if (l.c()) {
        var result = $m_sci_Nil$();
        break;
      } else {
        var h = l.t();
        var t = l.v();
        if ((!(!(!f(h))))) {
          l = t;
          continue;
        }
        var start = l;
        var remaining = t;
        while (true) {
          if (remaining.c()) {
            var result = start;
            break block;
          } else {
            var x = remaining.t();
            if ((!(!f(x)))) {
              remaining = remaining.v();
              continue;
            }
            var firstMiss = remaining;
            var newHead = new $c_sci_$colon$colon(start.t(), $m_sci_Nil$());
            var toProcess = start.v();
            var currentLast = newHead;
            while ((toProcess !== firstMiss)) {
              var newElem = new $c_sci_$colon$colon(toProcess.t(), $m_sci_Nil$());
              currentLast.U = newElem;
              currentLast = newElem;
              toProcess = toProcess.v();
            }
            var next = firstMiss.v();
            var nextToCopy = next;
            while ((!next.c())) {
              var head = next.t();
              if ((!(!f(head)))) {
                next = next.v();
              } else {
                while ((nextToCopy !== next)) {
                  var newElem$2 = new $c_sci_$colon$colon(nextToCopy.t(), $m_sci_Nil$());
                  currentLast.U = newElem$2;
                  currentLast = newElem$2;
                  nextToCopy = nextToCopy.v();
                }
                nextToCopy = next.v();
                next = next.v();
              }
            }
            if ((!nextToCopy.c())) {
              currentLast.U = nextToCopy;
            }
            var result = newHead;
            break block;
          }
        }
      }
    }
  }
  var f$1 = ((_$3) => _$3.BO);
  if ((result === $m_sci_Nil$())) {
    var names = $m_sci_Nil$();
  } else {
    var x0 = result.t();
    var h$1 = new $c_sci_$colon$colon(f$1(x0), $m_sci_Nil$());
    var t$1 = h$1;
    var rest = result.v();
    while ((rest !== $m_sci_Nil$())) {
      var x0$1 = rest.t();
      var nx = new $c_sci_$colon$colon(f$1(x0$1), $m_sci_Nil$());
      t$1.U = nx;
      t$1 = nx;
      rest = rest.v();
    }
    var names = h$1;
  }
  matchResult17: {
    var $x_1;
    var x44 = $m_sc_package$$colon$plus$().Y9(names);
    if ((!x44.c())) {
      var x45 = x44.d();
      var init = x45.g();
      var last = x45.h();
      if ((!init.c())) {
        var $x_1 = (($f_sc_IterableOnceOps__mkString__T__T__T__T(init, "", ", ", "") + " and ") + last);
        break matchResult17;
      }
    }
    var $x_1 = $f_sc_IterableOnceOps__mkString__T__T__T__T(names, "", "", "");
  }
  return (("The viewer did not apply the canvas edit, because it would remove " + $x_1) + " from the file. Make the change in the text instead.");
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_InternalPhases__explain__T__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat__jl_Throwable__Lorg_jpablo_graphexplorer_viewer_state_EditorNotice($thiz, text, format, failure) {
  var this$1 = $m_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$().WB(text);
  if (this$1.c()) {
    var $x_1 = true;
  } else {
    var x0 = this$1.d();
    var $x_1 = (!((x0 === null) ? (format === null) : (x0 === format)));
  }
  if ($x_1) {
    var x48 = this$1;
  } else {
    var x48 = $m_s_None$();
  }
  if ((x48 instanceof $c_s_Some)) {
    return $m_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$().b1E(x48.J, format);
  }
  if (($m_s_None$() === x48)) {
    var message = failure.e3();
    return new $c_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice($s_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level$__Error__Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level(), message, $m_s_None$());
  }
  throw new $c_s_MatchError(x48);
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_InternalPhases__parseTextToGraphAsync__T__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat__Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin__V($thiz, text, format, origin) {
  var label = ((((("[" + format.DT()) + "] parseTextToGraphAsync len=") + text.length) + " origin=") + origin);
  $thiz.zx.nH().i(label);
  $f_Lcom_raquo_airstream_state_Var__set__O__V($thiz.TK, $s_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$__Loading__Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus());
  $thiz.ab0.dn.bA(new $c_T3(text, format, origin));
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_InternalPhases__hasNoElements__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Z($thiz, g) {
  return ((g.j8.c() && g.qn.c()) && g.xf.lV(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$7) => {
    $m_Lorg_jpablo_graphexplorer_viewer_models_GroupId$();
    var x$2 = new $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$().p4.dR);
    return ((_$7 !== null) && _$7.e(x$2));
  }))));
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_InternalPhases__applyAutoDetect__T__V($thiz, text) {
  if ((!(!$thiz.a0R.P().aq().d()))) {
    var this$7 = new $c_s_Option$WithFilter($m_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$().WB(text), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((actual) => {
      var x$2 = $thiz.o8.P().aq().d().vr;
      return (!((actual === null) ? (x$2 === null) : (actual === x$2)));
    })));
    var this$8 = this$7.tu;
    var p$1 = this$7.tv;
    var this$9 = ((this$8.c() || (!(!p$1.i(this$8.d())))) ? this$8 : $m_s_None$());
    if ((!this$9.c())) {
      $thiz.aRI(text, this$9.d());
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_InternalPhases__body$proxy1$1__T__Lorg_jpablo_graphexplorer_viewer_state_GraphState__Lorg_jpablo_graphexplorer_viewer_state_GraphState($thiz, newText$1, currentState$1) {
  if ((newText$1 !== currentState$1.qo)) {
    var selectedFormat = $thiz.MO.P().aq().d();
    var this$4 = $thiz.aaY;
    var event = new $c_T3(newText$1, selectedFormat, $s_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin$__CodeMirror__Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin());
    this$4.dn.bA(event);
    var lastOrigin$1 = $s_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin$__CodeMirror__Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin();
    return new $c_Lorg_jpablo_graphexplorer_viewer_state_GraphState(newText$1, currentState$1.qp, selectedFormat, lastOrigin$1, currentState$1.xi);
  } else {
    return currentState$1;
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_InternalPhases__body$proxy2$1__Lorg_jpablo_graphexplorer_viewer_state_GraphState__Lorg_jpablo_graphexplorer_viewer_logging_Level__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lcom_raquo_airstream_core_Observer__Lorg_jpablo_graphexplorer_viewer_backends_DiagramLanguages__Lorg_jpablo_graphexplorer_viewer_state_GraphState($thiz, currentState$2, logLevel$7, newGraph$1, refusedEdits$1, languages$2) {
  if ((!currentState$2.xi)) {
    logLevel$7.nH().i("Ignoring graph edit while text and graph are out of sync (parse error)");
    return currentState$2;
  } else {
    var x$2 = currentState$2.qp;
    if ((!((newGraph$1 === null) ? (x$2 === null) : newGraph$1.e(x$2)))) {
      var x40 = $p_Lorg_jpablo_graphexplorer_viewer_state_InternalPhases__lossyEditRefusal__Lorg_jpablo_graphexplorer_viewer_state_GraphState__s_Option($thiz, currentState$2);
      if ((x40 instanceof $c_s_Some)) {
        var message = x40.J;
        var label = ("Refusing a lossy graph edit: " + message);
        logLevel$7.nH().i(label);
        new $c_Lcom_raquo_airstream_core_Transaction(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => {
          refusedEdits$1.bA(message);
        })));
        return currentState$2;
      }
      if (($m_s_None$() === x40)) {
        return new $c_Lorg_jpablo_graphexplorer_viewer_state_GraphState(languages$2.w3(currentState$2.vr).X3(newGraph$1, true), newGraph$1, currentState$2.vr, $s_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin$__Graph__Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin(), true);
      }
      throw new $c_s_MatchError(x40);
    } else {
      return currentState$2;
    }
  }
}
function $ps_Lorg_jpablo_graphexplorer_viewer_state_InternalPhases__body$proxy4$1__Lorg_jpablo_graphexplorer_viewer_backends_DiagramLanguages__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__T(languages$5, format$4, graph$1) {
  return languages$5.w3(format$4).X3(graph$1, false);
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_InternalPhases(languages, initialSource, hiddenNodes, collapsedGroups, editorNotice, logLevel, pace, keepTextWhole, refusedEdits, x$10, x$11) {
  this.zx = null;
  this.aFG = null;
  this.MO = null;
  this.o8 = null;
  this.ab0 = null;
  this.TK = null;
  this.aaY = null;
  this.aaZ = null;
  this.jI = null;
  this.aFF = null;
  this.ab1 = null;
  this.TJ = null;
  this.aUR = null;
  this.aFH = null;
  this.a0R = null;
  this.zx = logLevel;
  this.aFG = keepTextWhole;
  var label = ("InternalPhases: Initializing with " + initialSource);
  logLevel.nH().i(label);
  var initialText = (initialSource.c() ? "digraph \"G\" {}" : initialSource.d());
  var initialFormat = $m_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$().Pg(initialText);
  this.MO = $m_Lcom_raquo_airstream_state_Var$().bx(initialFormat);
  var initialViewerGraph = $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$().a0L;
  this.o8 = $m_Lcom_raquo_airstream_state_Var$().bx(new $c_Lorg_jpablo_graphexplorer_viewer_state_GraphState(initialText, initialViewerGraph, initialFormat, $s_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin$__CodeMirror__Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin(), true));
  this.ab0 = ($m_Lcom_raquo_laminar_api_package$(), new $c_Lcom_raquo_airstream_eventbus_EventBus());
  this.TK = $m_Lcom_raquo_airstream_state_Var$().bx($s_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$__Loading__Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus());
  var this$22 = this.ab0.k5;
  var project = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    if ((x$1 !== null)) {
      var text = x$1.bH;
      var format = x$1.bU;
      var origin = x$1.c3;
      if (($f_T__trim__T(text) === "")) {
        return $m_Lcom_raquo_airstream_core_EventStream$().a3x(new $c_T4(text, new $c_s_util_Right($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$().a0L), format, origin), ($m_Lcom_raquo_airstream_core_EventStream$(), false));
      } else {
        var parseFuture = languages.w3(format).aSK(text).aij(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
          if ((x$1$2 instanceof $c_s_util_Success)) {
            return new $c_s_util_Success(new $c_T4(text, new $c_s_util_Right(x$1$2.fM), format, origin));
          }
          if ((x$1$2 instanceof $c_s_util_Failure)) {
            var x18 = x$1$2.le;
            if ((x18 instanceof $c_Lorg_jpablo_graphexplorer_viewer_backends_RenderOnlyDiagram)) {
              var label$1 = ((("[" + format.DT()) + "] render-only diagram kind: ") + x18.Sw);
              logLevel.nH().i(label$1);
              var message = x18.Sv;
              return new $c_s_util_Success(new $c_T4(text, new $c_s_util_Left(new $c_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice($s_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level$__Info__Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level(), message, $m_s_None$())), format, origin));
            }
            var label$2 = ((("Error parsing " + format.DT()) + " to ViewerGraph: ") + x18.e3());
            logLevel.nH().i(label$2);
            return new $c_s_util_Success(new $c_T4(text, new $c_s_util_Left($p_Lorg_jpablo_graphexplorer_viewer_state_InternalPhases__explain__T__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat__jl_Throwable__Lorg_jpablo_graphexplorer_viewer_state_EditorNotice(this, text, format, x18)), format, origin));
          }
          throw new $c_s_MatchError(x$1$2);
        })), x$11);
        return $m_Lcom_raquo_airstream_core_EventStream$().aOB(parseFuture, ($m_Lcom_raquo_airstream_core_EventStream$(), false), x$11);
      }
    }
    throw new $c_s_MatchError(x$1);
  }));
  $f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription($m_Lcom_raquo_airstream_core_Observable$().AM.mK(new $c_Lcom_raquo_airstream_misc_MapStream(this$22, project, $m_s_None$())), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$1) => {
    matchResult14: {
      if ((x$1$2$1 !== null)) {
        var text$1 = x$1$2$1.bO;
        var result = x$1$2$1.bs;
        var format$1 = x$1$2$1.ch;
        var origin$1 = x$1$2$1.ca;
        if ((this.o8.P().aq().d().qo === text$1)) {
          var x = this.MO.P().aq().d();
          var $x_1 = ((x === null) ? (format$1 === null) : $dp_equals__O__Z(x, format$1));
        } else {
          var $x_1 = false;
        }
        if ($x_1) {
          if ((result instanceof $c_s_util_Right)) {
            var graph$1 = result.hm;
            $f_Lcom_raquo_airstream_state_Var__set__O__V(editorNotice, $m_s_None$());
            var label$3 = ((((((((("[" + format$1.DT()) + "] viewerGraph nodes=") + graph$1.j8.aa()) + " arrows=") + graph$1.qn.aa()) + " groups=") + graph$1.xf.aa()) + " origin=") + origin$1);
            logLevel.nH().i(label$3);
            $f_Lcom_raquo_airstream_state_Var__set__O__V(this.o8, new $c_Lorg_jpablo_graphexplorer_viewer_state_GraphState(text$1, graph$1, format$1, origin$1, true));
            $f_Lcom_raquo_airstream_state_Var__set__O__V(this.TK, $s_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$__Ready__Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus());
            break matchResult14;
          }
          if ((result instanceof $c_s_util_Left)) {
            var notice = result.lP;
            $f_Lcom_raquo_airstream_state_Var__set__O__V(editorNotice, $m_s_Option$().as(notice));
            $f_Lcom_raquo_airstream_state_Var__set__O__V(this.o8, new $c_Lorg_jpablo_graphexplorer_viewer_state_GraphState(text$1, $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$().a0L, format$1, origin$1, false));
            $f_Lcom_raquo_airstream_state_Var__set__O__V(this.TK, (notice.J6() ? new $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$Failed(notice.Cw) : new $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$RenderOnly(notice.Cw)));
            break matchResult14;
          }
          throw new $c_s_MatchError(result);
        } else {
          break matchResult14;
        }
      }
      throw new $c_s_MatchError(x$1$2$1);
    }
  })), x$10);
  this.aaY = ($m_Lcom_raquo_laminar_api_package$(), new $c_Lcom_raquo_airstream_eventbus_EventBus());
  $f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription(pace.i(this.aaY.k5), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3) => {
    matchResult15: {
      if ((x$1$3 !== null)) {
        var text$2 = x$1$3.bH;
        var format$2 = x$1$3.bU;
        var origin$2 = x$1$3.c3;
        var t0 = (+Date.now());
        $p_Lorg_jpablo_graphexplorer_viewer_state_InternalPhases__parseTextToGraphAsync__T__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat__Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin__V(this, text$2, format$2, origin$2);
        window.setTimeout((() => {
          $m_Lorg_jpablo_graphexplorer_viewer_state_EditorPacing$().aaX = ((+Date.now()) - t0);
        }), 0.0);
        break matchResult15;
      }
      throw new $c_s_MatchError(x$1$3);
    }
  })), x$10);
  $p_Lorg_jpablo_graphexplorer_viewer_state_InternalPhases__parseTextToGraphAsync__T__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat__Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin__V(this, initialText, initialFormat, $s_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin$__CodeMirror__Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin());
  this.aaZ = $f_Lcom_raquo_airstream_state_Var__distinct__Lcom_raquo_airstream_state_Var($f_Lcom_raquo_airstream_state_Var__zoomLazy__F1__F2__Lcom_raquo_airstream_state_Var(this.o8, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((currentState) => {
    var log = logLevel.nH();
    var x$2 = $s_Lorg_jpablo_graphexplorer_viewer_logging_Level$__None__Lorg_jpablo_graphexplorer_viewer_logging_Level();
    if ((!((logLevel === null) ? (x$2 === null) : (logLevel === x$2)))) {
      console.group(("1b. [sourceText <- GraphState]: " + $m_Lorg_jpablo_graphexplorer_viewer_logging_WithLog$package$().nF()));
    }
    $m_Lorg_jpablo_graphexplorer_viewer_logging_WithLog$package$().nF();
    var a = currentState.qo;
    log.i(("" + a));
    var x$4 = $s_Lorg_jpablo_graphexplorer_viewer_logging_Level$__None__Lorg_jpablo_graphexplorer_viewer_logging_Level();
    if ((!((logLevel === null) ? (x$4 === null) : (logLevel === x$4)))) {
      console.groupEnd();
    }
    return a;
  })), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((currentState$2, newText) => {
    var log$1 = logLevel.nH();
    var x$2$1 = $s_Lorg_jpablo_graphexplorer_viewer_logging_Level$__None__Lorg_jpablo_graphexplorer_viewer_logging_Level();
    if ((!((logLevel === null) ? (x$2$1 === null) : (logLevel === x$2$1)))) {
      console.group(("1a. [sourceText -> GraphState]: " + $m_Lorg_jpablo_graphexplorer_viewer_logging_WithLog$package$().nF()));
    }
    $m_Lorg_jpablo_graphexplorer_viewer_logging_WithLog$package$().nF();
    var a$1 = $p_Lorg_jpablo_graphexplorer_viewer_state_InternalPhases__body$proxy1$1__T__Lorg_jpablo_graphexplorer_viewer_state_GraphState__Lorg_jpablo_graphexplorer_viewer_state_GraphState(this, newText, currentState$2);
    log$1.i(("" + a$1));
    var x$4$1 = $s_Lorg_jpablo_graphexplorer_viewer_logging_Level$__None__Lorg_jpablo_graphexplorer_viewer_logging_Level();
    if ((!((logLevel === null) ? (x$4$1 === null) : (logLevel === x$4$1)))) {
      console.groupEnd();
    }
    return a$1;
  }))));
  this.jI = $f_Lcom_raquo_airstream_state_Var__distinct__Lcom_raquo_airstream_state_Var($f_Lcom_raquo_airstream_state_Var__zoomLazy__F1__F2__Lcom_raquo_airstream_state_Var(this.o8, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((currentState$3) => {
    var log$2 = logLevel.nH();
    var x$2$2 = $s_Lorg_jpablo_graphexplorer_viewer_logging_Level$__None__Lorg_jpablo_graphexplorer_viewer_logging_Level();
    if ((!((logLevel === null) ? (x$2$2 === null) : (logLevel === x$2$2)))) {
      console.group(("2a. [GraphState -> fullGraphV: ViewerGraph]: " + $m_Lorg_jpablo_graphexplorer_viewer_logging_WithLog$package$().nF()));
    }
    $m_Lorg_jpablo_graphexplorer_viewer_logging_WithLog$package$().nF();
    var a$2 = currentState$3.qp;
    log$2.i(("" + a$2));
    var x$4$2 = $s_Lorg_jpablo_graphexplorer_viewer_logging_Level$__None__Lorg_jpablo_graphexplorer_viewer_logging_Level();
    if ((!((logLevel === null) ? (x$4$2 === null) : (logLevel === x$4$2)))) {
      console.groupEnd();
    }
    return a$2;
  })), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((currentState$4, newGraph) => {
    var log$3 = logLevel.nH();
    var x$2$3 = $s_Lorg_jpablo_graphexplorer_viewer_logging_Level$__None__Lorg_jpablo_graphexplorer_viewer_logging_Level();
    if ((!((logLevel === null) ? (x$2$3 === null) : (logLevel === x$2$3)))) {
      console.group(("2b. [GraphState <- fullGraphV: ViewerGraph]: " + $m_Lorg_jpablo_graphexplorer_viewer_logging_WithLog$package$().nF()));
    }
    $m_Lorg_jpablo_graphexplorer_viewer_logging_WithLog$package$().nF();
    var a$3 = $p_Lorg_jpablo_graphexplorer_viewer_state_InternalPhases__body$proxy2$1__Lorg_jpablo_graphexplorer_viewer_state_GraphState__Lorg_jpablo_graphexplorer_viewer_logging_Level__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lcom_raquo_airstream_core_Observer__Lorg_jpablo_graphexplorer_viewer_backends_DiagramLanguages__Lorg_jpablo_graphexplorer_viewer_state_GraphState(this, currentState$4, logLevel, newGraph, refusedEdits, languages);
    log$3.i(("" + a$3));
    var x$4$3 = $s_Lorg_jpablo_graphexplorer_viewer_logging_Level$__None__Lorg_jpablo_graphexplorer_viewer_logging_Level();
    if ((!((logLevel === null) ? (x$4$3 === null) : (logLevel === x$4$3)))) {
      console.groupEnd();
    }
    return a$3;
  }))));
  this.aFF = $f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable(this.jI.P());
  this.ab1 = $f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable($m_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$().aMQ(this.jI.P(), hiddenNodes, collapsedGroups, new $c_sr_AbstractFunction3_$$Lambda$d1e06cbab540de4f9f09e7182f18ea80659b9825(((fullGraph, hiddenNodes$2, collapsed) => {
    var hiddenNodes$1 = ((hiddenNodes$2 === null) ? null : hiddenNodes$2.aS);
    var log$4 = logLevel.nH();
    var x$2$4 = $s_Lorg_jpablo_graphexplorer_viewer_logging_Level$__None__Lorg_jpablo_graphexplorer_viewer_logging_Level();
    if ((!((logLevel === null) ? (x$2$4 === null) : (logLevel === x$2$4)))) {
      console.group(("3. [fullGraphV -> visibleGraph]: " + $m_Lorg_jpablo_graphexplorer_viewer_logging_WithLog$package$().nF()));
    }
    $m_Lorg_jpablo_graphexplorer_viewer_logging_WithLog$package$().nF();
    var a$4 = fullGraph.baj(hiddenNodes$1, collapsed);
    log$4.i(("" + a$4));
    var x$4$4 = $s_Lorg_jpablo_graphexplorer_viewer_logging_Level$__None__Lorg_jpablo_graphexplorer_viewer_logging_Level();
    if ((!((logLevel === null) ? (x$4$4 === null) : (logLevel === x$4$4)))) {
      console.groupEnd();
    }
    return a$4;
  }))));
  this.TJ = $f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), this.o8.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4) => _$4.vr)), $m_s_None$()));
  this.aUR = $m_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$().li(this.ab1, this.TJ, new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((graph$2, format$3) => {
    var log$5 = logLevel.nH();
    var x$2$5 = $s_Lorg_jpablo_graphexplorer_viewer_logging_Level$__None__Lorg_jpablo_graphexplorer_viewer_logging_Level();
    if ((!((logLevel === null) ? (x$2$5 === null) : (logLevel === x$2$5)))) {
      console.group(("4. [visibleGraph -> visibleText]: " + $m_Lorg_jpablo_graphexplorer_viewer_logging_WithLog$package$().nF()));
    }
    $m_Lorg_jpablo_graphexplorer_viewer_logging_WithLog$package$().nF();
    var a$5 = $ps_Lorg_jpablo_graphexplorer_viewer_state_InternalPhases__body$proxy4$1__Lorg_jpablo_graphexplorer_viewer_backends_DiagramLanguages__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__T(languages, format$3, graph$2);
    log$5.i(("" + a$5));
    var x$4$5 = $s_Lorg_jpablo_graphexplorer_viewer_logging_Level$__None__Lorg_jpablo_graphexplorer_viewer_logging_Level();
    if ((!((logLevel === null) ? (x$4$5 === null) : (logLevel === x$4$5)))) {
      console.groupEnd();
    }
    return a$5;
  })));
  this.aFH = $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), this.TJ, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$5) => languages.w3(_$5).aS0())), $m_s_None$());
  this.a0R = $m_Lcom_raquo_airstream_state_Var$().bx(true);
  $f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription(new $c_Lcom_raquo_airstream_misc_StreamFromSignal(this.aaZ.P(), true), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((text$3) => {
    $p_Lorg_jpablo_graphexplorer_viewer_state_InternalPhases__applyAutoDetect__T__V(this, text$3);
  })), x$10);
  $f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription(new $c_Lcom_raquo_airstream_misc_FilterStream(new $c_Lcom_raquo_airstream_misc_StreamFromSignal(this.a0R.P(), true), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$3) => (!(!x$3))))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => {
    $p_Lorg_jpablo_graphexplorer_viewer_state_InternalPhases__applyAutoDetect__T__V(this, this.o8.P().aq().d().qo);
  })), x$10);
  $f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription(new $c_Lcom_raquo_airstream_misc_StreamFromSignal(this.MO.P(), true), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((newFormat) => {
    var currentState$1 = this.o8.P().aq().d();
    var x$6 = currentState$1.vr;
    if ((!((x$6 === null) ? (newFormat === null) : (x$6 === newFormat)))) {
      if (((currentState$1.xi && ($f_T__trim__T(currentState$1.qo) !== "")) && $p_Lorg_jpablo_graphexplorer_viewer_state_InternalPhases__hasNoElements__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Z(this, currentState$1.qp))) {
        var newText$1 = languages.w3(newFormat).X3(currentState$1.qp, true);
        $f_Lcom_raquo_airstream_state_Var__set__O__V(this.o8, new $c_Lorg_jpablo_graphexplorer_viewer_state_GraphState(newText$1, currentState$1.qp, newFormat, currentState$1.zw, true));
        $p_Lorg_jpablo_graphexplorer_viewer_state_InternalPhases__parseTextToGraphAsync__T__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat__Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin__V(this, newText$1, newFormat, currentState$1.zw);
      } else {
        $f_Lcom_raquo_airstream_state_Var__set__O__V(this.o8, new $c_Lorg_jpablo_graphexplorer_viewer_state_GraphState(currentState$1.qo, currentState$1.qp, newFormat, currentState$1.zw, currentState$1.xi));
        $p_Lorg_jpablo_graphexplorer_viewer_state_InternalPhases__parseTextToGraphAsync__T__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat__Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin__V(this, currentState$1.qo, newFormat, currentState$1.zw);
      }
    }
  })), x$10);
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_InternalPhases.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_InternalPhases;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_InternalPhases() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_InternalPhases.prototype = $p;
$p.u5 = (function() {
  var current = this.o8.P().aq().d();
  return (current.xi && $p_Lorg_jpablo_graphexplorer_viewer_state_InternalPhases__lossyEditRefusal__Lorg_jpablo_graphexplorer_viewer_state_GraphState__s_Option(this, current).c());
});
$p.aRI = (function(text, format) {
  var origin = $s_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin$__CodeMirror__Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin();
  var label = ((("[" + format.DT()) + "] replaceDocument len=") + text.length);
  this.zx.nH().i(label);
  $m_Lcom_raquo_airstream_state_Var$().Y1($m_sr_ScalaRunTime$().hP(new ($d_Lcom_raquo_airstream_state_Var$VarTuple.r().C)([new $c_Lcom_raquo_airstream_state_Var$VarTuple(new $c_T2(this.o8, new $c_Lorg_jpablo_graphexplorer_viewer_state_GraphState(text, this.o8.P().aq().d().qp, format, origin, false))), new $c_Lcom_raquo_airstream_state_Var$VarTuple(new $c_T2(this.MO, format))])));
  $p_Lorg_jpablo_graphexplorer_viewer_state_InternalPhases__parseTextToGraphAsync__T__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat__Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin__V(this, text, format, origin);
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_InternalPhases = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_InternalPhases, "org.jpablo.graphexplorer.viewer.state.InternalPhases", ({
  DX: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_InternalPhases$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_InternalPhases$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_InternalPhases$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_InternalPhases$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_InternalPhases$.prototype = $p;
$p.aVw = (function() {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => $m_Lorg_jpablo_graphexplorer_viewer_state_EditorPacing$().aQT(_$1)));
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_InternalPhases$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_InternalPhases$, "org.jpablo.graphexplorer.viewer.state.InternalPhases$", ({
  DY: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_state_InternalPhases$;
function $m_Lorg_jpablo_graphexplorer_viewer_state_InternalPhases$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_state_InternalPhases$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_state_InternalPhases$ = new $c_Lorg_jpablo_graphexplorer_viewer_state_InternalPhases$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_state_InternalPhases$;
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps__$init$__V($thiz) {
  $thiz.TW = $m_Lcom_raquo_airstream_state_Var$().bx($m_s_None$());
  $thiz.N1 = $m_Lcom_raquo_airstream_state_Var$().bx($m_s_None$());
  $thiz.TX = $m_s_None$();
  $f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription(new $c_Lcom_raquo_airstream_misc_StreamFromSignal($thiz.aH().ne, true), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => {
    var sel = ((v1 === null) ? null : v1.aS);
    var own = $thiz.TX;
    $thiz.TX = $m_s_None$();
    if ((!own.c())) {
      var x0 = own.d();
      var $x_1 = ((sel.aa() === 1) && $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().mJ(sel, x0));
    } else {
      var $x_1 = false;
    }
    if ((!$x_1)) {
      $f_Lcom_raquo_airstream_state_Var__set__O__V($thiz.N1, $m_s_None$());
    }
  })), $thiz.p5);
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps__navCursorSet__Lorg_jpablo_graphexplorer_viewer_models_ElementId__V($thiz, id) {
  $f_Lcom_raquo_airstream_state_Var__set__O__V($thiz.TW, new $c_s_Some(id));
}
function $ps_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps__score$1__Lorg_jpablo_graphexplorer_viewer_utils_ClientPoint__Lorg_jpablo_graphexplorer_viewer_state_NavDirection__Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$Cand__T2(c0$4, dir$10, c) {
  var _1 = c0$4.fi;
  var _2 = c0$4.fj;
  var this$2 = c.tn;
  var _1$1 = this$2.fi;
  var _2$1 = this$2.fj;
  var \u03b41$___1;
  var \u03b41$___2;
  var \u03b41$___1 = _1;
  var \u03b41$___2 = _2;
  var x1$3 = (+\u03b41$___1);
  var y1$2 = (+\u03b41$___2);
  var \u03b42$___1;
  var \u03b42$___2;
  var \u03b42$___1 = _1$1;
  var \u03b42$___2 = _2$1;
  var x$1 = $m_jl_Math$().ga(((+\u03b42$___1) - x1$3), ((+\u03b42$___2) - y1$2));
  var len = (+Math.max(x$1, 1.0E-9));
  var _1$2 = (c.tn.fi - c0$4.fi);
  var _2$2 = (c.tn.fj - c0$4.fj);
  return new $c_T2(((-((_1$2 * dir$10.Cx) + (_2$2 * dir$10.zy))) / len), len);
}
function $s_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps__org$jpablo$graphexplorer$viewer$state$KeyboardNavOps$keyboardNav$$$_$gap$1__Lorg_jpablo_graphexplorer_viewer_state_NavDirection__Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$NavBox__Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$NavBox__D(dir$13, o$1, b) {
  var x = $s_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$__NavLeft__Lorg_jpablo_graphexplorer_viewer_state_NavDirection();
  if (((x === null) ? (dir$13 === null) : (x === dir$13))) {
    return (o$1.xk - b.xl);
  }
  var x$3 = $s_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$__NavRight__Lorg_jpablo_graphexplorer_viewer_state_NavDirection();
  if (((x$3 === null) ? (dir$13 === null) : (x$3 === dir$13))) {
    return (b.xk - o$1.xl);
  }
  var x$5 = $s_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$__NavUp__Lorg_jpablo_graphexplorer_viewer_state_NavDirection();
  if (((x$5 === null) ? (dir$13 === null) : (x$5 === dir$13))) {
    return (o$1.xm - b.xj);
  }
  var x$7 = $s_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$__NavDown__Lorg_jpablo_graphexplorer_viewer_state_NavDirection();
  if (((x$7 === null) ? (dir$13 === null) : (x$7 === dir$13))) {
    return (b.xm - o$1.xj);
  }
  throw new $c_s_MatchError(dir$13);
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$__candidatesFor__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Lorg_jpablo_graphexplorer_viewer_state_NavDirection__sci_Map__s_Option($thiz, n, dir, centers) {
  var this$1 = centers.r(n);
  if (this$1.c()) {
    return $m_s_None$();
  } else {
    var x0 = this$1.d();
    var g = $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__visibleGraphObs__Lcom_raquo_airstream_state_OwnedSignal($thiz.j9)).d();
    var this$4 = $thiz.j9.du().aRY(g);
    var this$5 = ((this$4.c() || (this$4.d(), $thiz.j9.du().aRZ().E(n))) ? this$4 : $m_s_None$());
    var incident = (this$5.c() ? g.b2I(n) : this$5.d()).bw(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((a) => {
      var x = a.bX;
      var x$2 = a.c0;
      return (!((x === null) ? (x$2 === null) : x.e(x$2)));
    })));
    var resolved = incident.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((a$2) => {
      var far = a$2.b6f(n);
      var this$6 = centers.r(far);
      if (this$6.c()) {
        return $m_s_None$();
      } else {
        var x0$2 = this$6.d();
        return new $c_s_Some($thiz.aFJ.aXn(a$2.dw, far, x0$2));
      }
    })));
    var res = false;
    var it = resolved.o();
    while (((!res) && it.p())) {
      res = it.q().c();
    }
    return ((!res) ? new $c_s_Some($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O($f_sc_StrictOptimizedIterableOps__flatten__F1__O(resolved, $m_s_$less$colon$less$().b1).bw(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((c0$1$2) => ((c) => {
      var _1 = (c.tn.fi - c0$1$2.fi);
      var _2 = (c.tn.fj - c0$1$2.fj);
      var _1$1 = c0$1$2.fi;
      var _2$1 = c0$1$2.fj;
      var this$13 = c.tn;
      var _1$2 = this$13.fi;
      var _2$2 = this$13.fj;
      var \u03b41$___1;
      var \u03b41$___2;
      var \u03b41$___1 = _1$1;
      var \u03b41$___2 = _2$1;
      var x1$3 = (+\u03b41$___1);
      var y1$2 = (+\u03b41$___2);
      var \u03b42$___1;
      var \u03b42$___2;
      var \u03b42$___1 = _1$2;
      var \u03b42$___2 = _2$2;
      var x$3 = $m_jl_Math$().ga(((+\u03b42$___1) - x1$3), ((+\u03b42$___2) - y1$2));
      var len = (+Math.max(x$3, 1.0E-9));
      return ((((_1 * dir.Cx) + (_2 * dir.zy)) / len) >= $thiz.aFK);
    }))(x0))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((c$2) => (dir.X9() ? c$2.tn.fj : c$2.tn.fi))), $m_s_math_Ordering$DeprecatedDoubleOrdering$())) : $m_s_None$());
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$__fromNode__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Lorg_jpablo_graphexplorer_viewer_state_NavDirection__sci_Map__sci_Map__V($thiz, n, dir, centers, boxes) {
  var this$1 = centers.r(n);
  if ((!this$1.c())) {
    var x0 = this$1.d();
    var this$2 = $p_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$__candidatesFor__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Lorg_jpablo_graphexplorer_viewer_state_NavDirection__sci_Map__s_Option($thiz, n, dir, centers);
    if ((!this$2.c())) {
      var x0$1 = this$2.d();
      var res = false;
      var it = x0$1.o();
      while (((!res) && it.p())) {
        res = $p_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$__sameRow__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Lorg_jpablo_graphexplorer_viewer_state_NavDirection__sci_Map__Z($thiz, n, it.q().GV, dir, boxes);
      }
      var edgeOnMyRow = res;
      var peer = (edgeOnMyRow ? $m_s_None$() : $p_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$__abreastPeer__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Lorg_jpablo_graphexplorer_viewer_state_NavDirection__sci_Map__s_Option($thiz, n, dir, boxes));
      matchResult14: {
        if ((peer instanceof $c_s_Some)) {
          $p_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$__moveToNode__Lorg_jpablo_graphexplorer_viewer_models_NodeId__sci_Map__V($thiz, peer.J, centers);
          break matchResult14;
        }
        if (($m_s_None$() === peer)) {
          if ((x0$1 !== null)) {
            $m_sci_Vector$();
            var x$1 = x0$1.C();
            if ((((x$1 === 0) ? 0 : ((x$1 < 0) ? (-1) : 1)) === 0)) {
              break matchResult14;
            }
            var x$2 = x0$1.C();
            if ((((x$2 === 1) ? 0 : ((x$2 < 1) ? (-1) : 1)) === 0)) {
              $p_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$__moveToNode__Lorg_jpablo_graphexplorer_viewer_models_NodeId__sci_Map__V($thiz, x0$1.l(0).GV, centers);
              break matchResult14;
            }
          }
          var idx = ($f_sc_IterableOnceOps__minBy__F1__s_math_Ordering__O(new $c_sci_Range$Exclusive(0, x0$1.C(), 1), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((cands$2, c0$3$2) => ((i) => {
            var i$1 = (i | 0);
            return $ps_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps__score$1__Lorg_jpablo_graphexplorer_viewer_utils_ClientPoint__Lorg_jpablo_graphexplorer_viewer_state_NavDirection__Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$Cand__T2(c0$3$2, dir, cands$2.l(i$1));
          }))(x0$1, x0)), new $c_s_math_Ordering$Tuple2Ordering($m_s_math_Ordering$DeprecatedDoubleOrdering$(), $m_s_math_Ordering$DeprecatedDoubleOrdering$())) | 0);
          $f_Lcom_raquo_airstream_state_Var__set__O__V($thiz.j9.N1, new $c_s_Some($thiz.j9.b67().aXo(n, dir)));
          $p_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$__selectArrow__Lorg_jpablo_graphexplorer_viewer_models_ArrowId__sci_Map__V($thiz, x0$1.l(idx).GU, centers);
          break matchResult14;
        }
        throw new $c_s_MatchError(peer);
      }
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$__abreastPeer__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Lorg_jpablo_graphexplorer_viewer_state_NavDirection__sci_Map__s_Option($thiz, n, dir, boxes) {
  var this$1 = boxes.r(n);
  if (this$1.c()) {
    return $m_s_None$();
  } else {
    var x0 = this$1.d();
    var this$12 = $f_sc_IterableOnceOps__minByOption__F1__s_math_Ordering__s_Option(new $c_sc_Iterator$$anon$6(new $c_sc_Iterator$$anon$10(new $c_sc_Iterator$$anon$6($f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__visibleGraphObs__Lcom_raquo_airstream_state_OwnedSignal($thiz.j9)).d().j8.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4) => (!((_$4 === null) ? (n === null) : _$4.e(n))))), false), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((id) => {
      var this$5 = boxes.r(id);
      return (this$5.c() ? $m_s_None$() : new $c_s_Some(new $c_T2(id, this$5.d())));
    }))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((o$2) => ((x$1) => {
      x$1.g();
      var b = x$1.h();
      return ($p_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$__overlaps__Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$NavBox__Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$NavBox__Lorg_jpablo_graphexplorer_viewer_state_NavDirection__Z($thiz, o$2, b, dir) && ($s_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps__org$jpablo$graphexplorer$viewer$state$KeyboardNavOps$keyboardNav$$$_$gap$1__Lorg_jpablo_graphexplorer_viewer_state_NavDirection__Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$NavBox__Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$NavBox__D(dir, o$2, b) >= 0.0));
    }))(x0)), false), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((o$3) => ((x$1$2) => {
      x$1$2.g();
      return $s_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps__org$jpablo$graphexplorer$viewer$state$KeyboardNavOps$keyboardNav$$$_$gap$1__Lorg_jpablo_graphexplorer_viewer_state_NavDirection__Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$NavBox__Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$NavBox__D(dir, o$3, x$1$2.h());
    }))(x0)), $m_s_math_Ordering$DeprecatedDoubleOrdering$());
    return (this$12.c() ? $m_s_None$() : new $c_s_Some(this$12.d().g()));
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$__overlaps__Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$NavBox__Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$NavBox__Lorg_jpablo_graphexplorer_viewer_state_NavDirection__Z($thiz, o, b, dir) {
  return (dir.X9() ? ((b.xm < o.xj) && (b.xj > o.xm)) : ((b.xk < o.xl) && (b.xl > o.xk)));
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$__sameRow__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Lorg_jpablo_graphexplorer_viewer_state_NavDirection__sci_Map__Z($thiz, n, other, dir, boxes) {
  var this$1 = boxes.r(n);
  if (this$1.c()) {
    var this$3 = $m_s_None$();
  } else {
    var x0 = this$1.d();
    var this$2 = boxes.r(other);
    var this$3 = (this$2.c() ? $m_s_None$() : new $c_s_Some($p_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$__overlaps__Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$NavBox__Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$NavBox__Lorg_jpablo_graphexplorer_viewer_state_NavDirection__Z($thiz, x0, this$2.d(), dir)));
  }
  return (!(!(this$3.c() ? false : this$3.d())));
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$__fromArrow__Lorg_jpablo_graphexplorer_viewer_models_ArrowId__Lorg_jpablo_graphexplorer_viewer_state_NavDirection__sci_Map__V($thiz, a, dir, centers) {
  var this$3 = $thiz.j9.N1.P().aq().d();
  if (this$3.c()) {
    var resumed = $m_s_None$();
  } else {
    var x0 = this$3.d();
    var this$4 = $p_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$__candidatesFor__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Lorg_jpablo_graphexplorer_viewer_state_NavDirection__sci_Map__s_Option($thiz, x0.MP, x0.GT, centers);
    if (this$4.c()) {
      var $x_1 = $m_s_None$();
    } else {
      var x0$1 = this$4.d();
      var this$5 = x0$1.o();
      _return: {
        var i = 0;
        var dropped = this$5.iV(0);
        while (dropped.p()) {
          var x0$2 = dropped.q();
          var x = x0$2.GU;
          if (((x === null) ? (a === null) : x.e(a))) {
            var $x_2 = i;
            break _return;
          }
          i = ((1 + i) | 0);
        }
        var $x_2 = (-1);
      }
      var $x_1 = new $c_s_Some(new $c_T2(x0$1, $x_2));
    }
    var this$10 = new $c_s_Option$WithFilter($x_1, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
      if ((x$1 !== null)) {
        x$1.g();
        return ((x$1.h() | 0) >= 0);
      }
      throw new $c_s_MatchError(x$1);
    })));
    var this$11 = this$10.tu;
    var p$1 = this$10.tv;
    var this$12 = ((this$11.c() || (!(!p$1.i(this$11.d())))) ? this$11 : $m_s_None$());
    if (this$12.c()) {
      var resumed = $m_s_None$();
    } else {
      var x0$3 = this$12.d();
      matchResult17$1: {
        var $x_3;
        if ((x0$3 !== null)) {
          var $x_3 = new $c_T3(x0, x0$3.g(), (x0$3.h() | 0));
          break matchResult17$1;
        }
        throw new $c_s_MatchError(x0$3);
      }
      var resumed = new $c_s_Some($x_3);
    }
  }
  matchResult18: {
    if ((resumed instanceof $c_s_Some)) {
      var x35 = resumed.J;
      if ((x35 !== null)) {
        var ctx$2 = x35.bH;
        var cands$2 = x35.bU;
        var idx$3 = (x35.c3 | 0);
        if ((ctx$2.GT.X9() === dir.X9())) {
          var x$2 = ctx$2.GT;
          if (((dir === null) ? (x$2 === null) : (dir === x$2))) {
            $p_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$__moveToNode__Lorg_jpablo_graphexplorer_viewer_models_NodeId__sci_Map__V($thiz, cands$2.l(idx$3).GV, centers);
            break matchResult18;
          } else {
            $p_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$__moveToNode__Lorg_jpablo_graphexplorer_viewer_models_NodeId__sci_Map__V($thiz, ctx$2.MP, centers);
            break matchResult18;
          }
        } else {
          var x$4 = $s_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$__NavDown__Lorg_jpablo_graphexplorer_viewer_state_NavDirection();
          if (((dir === null) ? (x$4 === null) : (dir === x$4))) {
            var $x_4 = true;
          } else {
            var x$6 = $s_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$__NavRight__Lorg_jpablo_graphexplorer_viewer_state_NavDirection();
            var $x_4 = ((dir === null) ? (x$6 === null) : (dir === x$6));
          }
          var i2 = ((idx$3 + ($x_4 ? 1 : (-1))) | 0);
          if (((i2 >= 0) && (i2 < cands$2.C()))) {
            $p_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$__selectArrow__Lorg_jpablo_graphexplorer_viewer_models_ArrowId__sci_Map__V($thiz, cands$2.l(i2).GU, centers);
            break matchResult18;
          } else {
            break matchResult18;
          }
        }
      }
    }
    if (($m_s_None$() === resumed)) {
      $f_Lcom_raquo_airstream_state_Var__set__O__V($thiz.j9.N1, $m_s_None$());
      var this$16 = $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__visibleGraphObs__Lcom_raquo_airstream_state_OwnedSignal($thiz.j9)).d().fX.r(a);
      if ((!this$16.c())) {
        var x0$4 = this$16.d();
        var x$3 = x0$4.bX;
        var x$2$1 = x0$4.c0;
        if (((x$3 === null) ? (x$2$1 === null) : x$3.e(x$2$1))) {
          $p_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$__moveToNode__Lorg_jpablo_graphexplorer_viewer_models_NodeId__sci_Map__V($thiz, x0$4.bX, centers);
          break matchResult18;
        } else {
          var this$17 = centers.r(x0$4.bX);
          if ((!this$17.c())) {
            var x0$5 = this$17.d();
            var this$18 = centers.r(x0$4.c0);
            if ((!this$18.c())) {
              var x0$6 = this$18.d();
              var comp = (((x0$6.fi - x0$5.fi) * dir.Cx) + ((x0$6.fj - x0$5.fj) * dir.zy));
              if ((comp > 0.0)) {
                $p_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$__moveToNode__Lorg_jpablo_graphexplorer_viewer_models_NodeId__sci_Map__V($thiz, x0$4.c0, centers);
                break matchResult18;
              } else if ((comp < 0.0)) {
                $p_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$__moveToNode__Lorg_jpablo_graphexplorer_viewer_models_NodeId__sci_Map__V($thiz, x0$4.bX, centers);
                break matchResult18;
              } else {
                break matchResult18;
              }
            } else {
              break matchResult18;
            }
          } else {
            break matchResult18;
          }
        }
      } else {
        break matchResult18;
      }
    }
    throw new $c_s_MatchError(resumed);
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$__moveToNode__Lorg_jpablo_graphexplorer_viewer_models_NodeId__sci_Map__V($thiz, n, centers) {
  $f_Lcom_raquo_airstream_state_Var__set__O__V($thiz.j9.N1, $m_s_None$());
  $thiz.j9.TX = new $c_s_Some(n);
  $thiz.j9.aH().gC($m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_ElementId.r().C)([n]))));
  $f_Lcom_raquo_airstream_state_Var__set__O__V($thiz.j9.TW, new $c_s_Some(n));
  $p_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$__ensureVisible__Lorg_jpablo_graphexplorer_viewer_models_ElementId__sci_Map__V($thiz, n, centers);
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$__selectArrow__Lorg_jpablo_graphexplorer_viewer_models_ArrowId__sci_Map__V($thiz, a, centers) {
  $thiz.j9.TX = new $c_s_Some(a);
  $thiz.j9.aH().gC($m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_ElementId.r().C)([a]))));
  $f_Lcom_raquo_airstream_state_Var__set__O__V($thiz.j9.TW, new $c_s_Some(a));
  $p_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$__ensureVisible__Lorg_jpablo_graphexplorer_viewer_models_ElementId__sci_Map__V($thiz, a, centers);
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$__ensureVisible__Lorg_jpablo_graphexplorer_viewer_models_ElementId__sci_Map__V($thiz, id, centers) {
  var this$1 = centers.r(id);
  if ((!this$1.c())) {
    var x0 = this$1.d();
    var this$2 = $m_s_Option$().as(document.getElementById("canvas-container"));
    if ((!this$2.c())) {
      var x0$1 = this$2.d();
      var this$5 = $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__finalSVGObs__Lcom_raquo_airstream_state_OwnedSignal($thiz.j9)).d();
      if ((!this$5.c())) {
        var x0$2 = this$5.d();
        var box = x0$1.getBoundingClientRect();
        var m = $thiz.aFM;
        var dx = ((x0.fi > ((+box.right) - m)) ? (x0.fi - ((+box.right) - m)) : ((x0.fi < ((+box.left) + m)) ? (x0.fi - ((+box.left) + m)) : 0.0));
        var dy = ((x0.fj > ((+box.bottom) - m)) ? (x0.fj - ((+box.bottom) - m)) : ((x0.fj < ((+box.top) + m)) ? (x0.fj - ((+box.top) + m)) : 0.0));
        if (((dx !== 0.0) || (dy !== 0.0))) {
          $f_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps__panByClient__D__D__Lorg_scalajs_dom_SVGRect__V($thiz.j9, dx, dy, x0$2.e8.viewBox.baseVal);
        }
      }
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$__boxesSnapshot__sci_Map($thiz) {
  var x44 = $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__finalSVGObs__Lcom_raquo_airstream_state_OwnedSignal($thiz.j9)).d();
  if (($m_s_None$() === x44)) {
    return $m_sci_Map$EmptyMap$();
  }
  if ((x44 instanceof $c_s_Some)) {
    var svgEl = x44.J;
    return $m_sci_Map$().ao(new $c_sc_MapView$MapValues(new $c_sc_MapView$Id($f_sc_IterableOps__groupMapReduce__F1__F1__F2__sci_Map($m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().DW(svgEl.e8, $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__selectionStrategyObs__Lcom_raquo_airstream_state_OwnedSignal($thiz.j9)).d()).c5(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((el) => {
      var r = el.dD().getBoundingClientRect();
      return ((((+r.width) <= 0.0) && ((+r.height) <= 0.0)) ? $m_s_None$() : new $c_s_Some(new $c_T2(el.lj(), new $c_T4((+r.left), (+r.top), (+r.right), (+r.bottom)))));
    }))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$10) => _$10.g())), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$11) => _$11.h())), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((a, b) => {
      var x$1 = (+a.bO);
      var y$1 = (+b.bO);
      var $x_3 = Math.min(x$1, y$1);
      var x$2 = (+a.bs);
      var y$2 = (+b.bs);
      var $x_2 = Math.min(x$2, y$2);
      var x$3 = (+a.ch);
      var y$3 = (+b.ch);
      var $x_1 = Math.max(x$3, y$3);
      var x$4 = (+a.ca);
      var y$4 = (+b.ca);
      return new $c_T4((+$x_3), (+$x_2), (+$x_1), (+Math.max(x$4, y$4)));
    })))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$1) => {
      if ((x$1$1 !== null)) {
        var l = (+x$1$1.bO);
        var t = (+x$1$1.bs);
        var r$1 = (+x$1$1.ch);
        var b$1 = (+x$1$1.ca);
        return $thiz.aFL.aXc(l, t, r$1, b$1);
      }
      throw new $c_s_MatchError(x$1$1);
    }))));
  }
  throw new $c_s_MatchError(x44);
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$(outer) {
  this.aFK = 0.0;
  this.aFM = 0.0;
  this.aFJ = null;
  this.aFL = null;
  this.j9 = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.j9 = outer;
  this.aFJ = new $c_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$Cand$(this);
  this.aFL = new $c_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$NavBox$(this);
  this.aFK = 0.17;
  this.aFM = 40.0;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$.prototype = $p;
$p.b4K = (function(dir) {
  var sel = this.j9.aH().cL();
  var this$3 = this.j9.TW.P().aq().d();
  var this$4 = ((this$3.c() || $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().mJ(sel, this$3.d())) ? this$3 : $m_s_None$());
  var cursorOpt = (this$4.c() ? ((sel.aa() === 1) ? new $c_s_Some(sel.t()) : $m_s_None$()) : this$4);
  if ((!cursorOpt.c())) {
    var x0$1 = cursorOpt.d();
    if ((x0$1 instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId)) {
    } else {
      var boxes = $p_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$__boxesSnapshot__sci_Map(this);
      var centers = $m_sci_Map$().ao(new $c_sc_MapView$MapValues(new $c_sc_MapView$Id(boxes), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => _$1.aYg()))));
      if ((x0$1 instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId)) {
        $p_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$__fromNode__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Lorg_jpablo_graphexplorer_viewer_state_NavDirection__sci_Map__sci_Map__V(this, x0$1, dir, centers, boxes);
      } else if ((x0$1 instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowId)) {
        $p_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$__fromArrow__Lorg_jpablo_graphexplorer_viewer_models_ArrowId__Lorg_jpablo_graphexplorer_viewer_state_NavDirection__sci_Map__V(this, x0$1, dir, centers);
      }
    }
  }
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$, "org.jpablo.graphexplorer.viewer.state.KeyboardNavOps$keyboardNav$", ({
  E1: 1
}));
function $f_Lorg_jpablo_graphexplorer_viewer_state_LayoutStabilityOps__$init$__V($thiz) {
  $thiz.abg = $m_Lcom_raquo_airstream_state_Var$().bx(true);
  $thiz.abk = $m_s_None$();
  $thiz.TY = $m_s_None$();
  $thiz.TZ = $m_s_None$();
  $thiz.a12 = $m_s_None$();
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_LayoutStabilityOps__clientCenter__Lorg_scalajs_dom_Element__s_Option($thiz, e) {
  var r = e.getBoundingClientRect();
  return ((((+r.width) === 0.0) && ((+r.height) === 0.0)) ? $m_s_None$() : new $c_s_Some(new $c_T2(((+r.left) + (0.5 * (+r.width))), ((+r.top) + (0.5 * (+r.height))))));
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_LayoutStabilityOps__beforeLayoutSwap__Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElementStrategy__V($thiz, strategy) {
  $thiz.TY = $m_s_None$();
  $thiz.TZ = $m_s_None$();
  var this$1 = $thiz.abk;
  if (this$1.c()) {
    var $x_1 = true;
  } else {
    var x0 = this$1.d();
    var $x_1 = (!(!x0.isConnected));
  }
  if ($x_1) {
    var this$2 = this$1;
  } else {
    var this$2 = $m_s_None$();
  }
  if ((!this$2.c())) {
    var x0$1 = this$2.d();
    if (((!(!$thiz.abg.P().aq().d())) && (!$m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$().b7i()))) {
      $thiz.TZ = new $c_s_Some($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$().aYb(x0$1, strategy));
    }
    var nodes = $m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().DW(x0$1, strategy).c5(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((se) => {
      var this$7 = $f_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement__nodeId__s_Option(se);
      if (this$7.c()) {
        return $m_s_None$();
      } else {
        var x0$2 = this$7.d();
        var this$8 = $p_Lorg_jpablo_graphexplorer_viewer_state_LayoutStabilityOps__clientCenter__Lorg_scalajs_dom_Element__s_Option($thiz, se.dD());
        return (this$8.c() ? $m_s_None$() : new $c_s_Some(new $c_T2(x0$2, this$8.d())));
      }
    })));
    if ((!nodes.c())) {
      var selected = $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().io($thiz.aH().cL());
      var this$10 = nodes.iW(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
        var id = x$1.g();
        x$1.h();
        return selected.E(id);
      })));
      var focal = (this$10.c() ? $f_sc_IterableOnceOps__minByOption__F1__s_math_Ordering__s_Option(nodes, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((cx, cy) => ((x$1$1) => {
        x$1$1.g();
        var c = x$1$1.h();
        var dx = ((+c.g()) - cx);
        var dy = ((+c.h()) - cy);
        return ((dx * dx) + (dy * dy));
      }))((0.5 * (+window.innerWidth)), (0.5 * (+window.innerHeight)))), $m_s_math_Ordering$DeprecatedDoubleOrdering$()) : this$10);
      if (focal.c()) {
        var $x_2 = $m_s_None$();
      } else {
        var x0$4 = focal.d();
        var id$1 = x0$4.g();
        var c$1 = x0$4.h();
        var $x_2 = new $c_s_Some(new $c_T3(id$1, c$1.g(), c$1.h()));
      }
      $thiz.TY = $x_2;
    }
  }
  var this$12 = $thiz.a12;
  if ((!this$12.c())) {
    this$12.d().a3();
  }
  $thiz.a12 = $m_s_None$();
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_LayoutStabilityOps__afterLayoutSwap__Lorg_scalajs_dom_SVGSVGElement__Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElementStrategy__V($thiz, newSvg, strategy) {
  $thiz.abk = new $c_s_Some(newSvg);
  if ((!(!$thiz.xq.P().aq().d()))) {
    $f_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps__resetView__V($thiz);
  } else {
    var this$4 = $thiz.TY;
    if ((!this$4.c())) {
      var x0 = this$4.d();
      var id = x0.bH;
      var oldX = (+x0.bU);
      var oldY = (+x0.c3);
      var this$7 = $m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().Ed(newSvg, $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_ElementId.r().C)([id]))), strategy).dt();
      if ((!this$7.c())) {
        var x0$1 = this$7.d();
        var this$8 = $p_Lorg_jpablo_graphexplorer_viewer_state_LayoutStabilityOps__clientCenter__Lorg_scalajs_dom_Element__s_Option($thiz, x0$1.dD());
        if ((!this$8.c())) {
          var x0$2 = this$8.d();
          var newX = (+x0$2.g());
          var newY = (+x0$2.h());
          var dx = (newX - oldX);
          var dy = (newY - oldY);
          var x = (+window.innerWidth);
          var that = (+window.innerHeight);
          var limit = (0.4 * (+Math.min(x, that)));
          var x$1 = (+Math.abs(dx));
          var that$1 = (+Math.abs(dy));
          if ((((+Math.max(x$1, that$1)) <= limit) && (((+Math.abs(dx)) > 0.5) || ((+Math.abs(dy)) > 0.5)))) {
            var ctm = x0$1.dD().getScreenCTM();
            if ((ctm !== null)) {
              $f_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps__panCompensateClient__D__D__D__D__V($thiz, dx, dy, (+ctm.a), (+ctm.d));
            }
          }
        }
      }
    }
  }
  $thiz.TY = $m_s_None$();
  var this$33 = $thiz.TZ;
  if (this$33.c()) {
    var $x_1 = $m_s_None$();
  } else {
    var x0$3 = this$33.d();
    var $x_1 = $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$().aWX(newSvg, strategy, x0$3);
  }
  $thiz.a12 = $x_1;
  $thiz.TZ = $m_s_None$();
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_Persistence__$init$__V($thiz) {
  $thiz.zH = $m_Lorg_jpablo_graphexplorer_viewer_state_DiagramPersistence$().b1x($thiz.lI, $thiz.MZ);
  $thiz.xs = $m_Lcom_raquo_airstream_state_Var$().bx($m_s_None$());
  $thiz.N2 = "";
  $thiz.abl = $m_Lorg_jpablo_graphexplorer_projects_ProjectStorage$().aPY();
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_Persistence__documentSession__Lcom_raquo_airstream_core_Signal($thiz) {
  var x6 = $thiz.lI;
  if ((x6 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$LooseFile)) {
    var x9 = x6.tq;
    return $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$().b8S(x9);
  }
  $m_Lcom_raquo_laminar_api_package$();
  return $m_Lcom_raquo_airstream_state_Val$().iT($m_s_None$());
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_Persistence__documentDirty__Lcom_raquo_airstream_core_Signal($thiz) {
  var x10 = $thiz.lI;
  if ((x10 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$LooseFile)) {
    return $f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), $m_Lcom_raquo_airstream_combine_generated_CombinableSignal$().vV($thiz.afo(), $thiz.mz.P(), new $c_Lapp_tulz_tuplez_Composition\uff3fPri0$$anon$1()), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
      var session = x$1.g();
      var text = x$1.h();
      return ((!session.c()) && (session.d().tj !== text));
    })), $m_s_None$()));
  }
  $m_Lcom_raquo_laminar_api_package$();
  return $m_Lcom_raquo_airstream_state_Val$().iT(false);
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_Persistence__followDocumentSession__V($thiz) {
  var x17 = $thiz.lI;
  if ((x17 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$LooseFile)) {
    var x20 = x17.tq;
    $thiz.N2 = $thiz.zH.Pw().hf;
    $f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription(new $c_Lcom_raquo_airstream_misc_StreamFromSignal($thiz.afo(), true), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
      matchResult7: {
        if (($m_s_None$() === x$1)) {
          break matchResult7;
        }
        if ((x$1 instanceof $c_s_Some)) {
          var current = x$1.J;
          var x$3 = $thiz.mz.P().aq().d();
          var x$4 = $thiz.N2;
          var editorMoved = (!((x$3 === null) ? (x$4 === null) : $dp_equals__O__Z(x$3, x$4)));
          var fileMoved = (current.tj !== $thiz.N2);
          if ((!editorMoved)) {
            $thiz.N2 = current.tj;
            $f_Lorg_jpablo_graphexplorer_viewer_state_ImportOps__replaceSourceDetectingFormat__T__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat($thiz, current.tj);
            break matchResult7;
          } else if (fileMoved) {
            $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$().b4k(x20, current.Cm, current.tj);
            break matchResult7;
          } else {
            break matchResult7;
          }
        }
        throw new $c_s_MatchError(x$1);
      }
    })), $thiz.p5);
    return (void 0);
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_Persistence__followRecord__V($thiz) {
  var x21 = $thiz.lI;
  if ((x21 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$LibraryDiagram)) {
    $f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription($thiz.zH.afB(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((next) => {
      var x = $thiz.mz.P().aq().d();
      var x$2 = next.hf;
      if ((!((x === null) ? (x$2 === null) : $dp_equals__O__Z(x, x$2)))) {
        $f_Lorg_jpablo_graphexplorer_viewer_state_ImportOps__replaceSourceDetectingFormat__T__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat($thiz, next.hf);
      }
    })), $thiz.p5);
    return (void 0);
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_Persistence__watchOrigin__V($thiz) {
  var x25 = $thiz.lI;
  if ((x25 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$LibraryDiagram)) {
    var x28 = x25.xp;
    var this$2 = $m_Lorg_jpablo_graphexplorer_projects_Library$().XE(x28);
    if ((!this$2.c())) {
      $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$().b5j(this$2.d(), $m_s_concurrent_ExecutionContext$().ek());
      return (void 0);
    } else {
      return (void 0);
    }
  }
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_Persistence__isFileBacked__Z($thiz) {
  var x29 = $thiz.lI;
  if ((x29 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$LooseFile)) {
    return true;
  }
  if ((x29 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$LibraryDiagram)) {
    return (!$m_Lorg_jpablo_graphexplorer_projects_Library$().XE(x29.xp).c());
  }
  if ((x29 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$Example)) {
    return false;
  }
  throw new $c_s_MatchError(x29);
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_Persistence__documentIsDirty__Z($thiz) {
  var x40 = $thiz.lI;
  if ((x40 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$LooseFile)) {
    var x43 = x40.tq;
    var this$2 = $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$().IY(x43);
    return ((!this$2.c()) && (this$2.d().tj !== $thiz.mz.P().aq().d()));
  }
  return false;
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_Persistence__documentConflict__Lcom_raquo_airstream_core_Signal($thiz) {
  return $f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), $thiz.afo(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3) => (_$3.c() ? $m_s_None$() : _$3.d().Gy))), $m_s_None$()));
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_Persistence__resolveDocumentConflict__Z__V($thiz, adoptRemoteText) {
  var x44 = $thiz.lI;
  if ((x44 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$LooseFile)) {
    var x47 = x44.tq;
    var this$2 = $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$().IY(x47);
    var this$3 = (this$2.c() ? $m_s_None$() : this$2.d().Gy);
    if ((!this$3.c())) {
      var x0$1 = this$3.d();
      $thiz.N2 = x0$1.Gx;
      $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$().aWv(x47);
      if (adoptRemoteText) {
        $f_Lorg_jpablo_graphexplorer_viewer_state_ImportOps__replaceSourceDetectingFormat__T__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat($thiz, x0$1.Gx);
        return (void 0);
      } else {
        return (void 0);
      }
    } else {
      return (void 0);
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_Persistence__restorePersistedState__V($thiz) {
  var restoredDiagramState = $thiz.zH.Pw();
  var restoredViewerSettings = $thiz.abl.P().aq().d();
  $f_Lcom_raquo_airstream_state_Var__set__O__V($thiz.gn().CB, new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds(restoredDiagramState.ob));
  $f_Lcom_raquo_airstream_state_Var__set__O__V($thiz.gn().nh, restoredDiagramState.oa);
  var this$3 = restoredDiagramState.nf;
  if (this$3.c()) {
    var $x_1 = $m_s_None$();
  } else {
    var x0 = this$3.d();
    try {
      var $x_2 = new $c_s_util_Success($m_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$().a5d(x0));
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      matchEnd8: {
        var $x_2;
        if ($m_s_util_control_NonFatal$().ew(e$2)) {
          var $x_2 = new $c_s_util_Failure(e$2);
          break matchEnd8;
        }
        throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
      }
    }
    var $x_1 = $x_2.rg();
  }
  var this$5 = $x_1;
  if ((!this$5.c())) {
    var x0$1 = this$5.d();
    $f_Lcom_raquo_airstream_state_Var__set__O__V($thiz.CG, x0$1);
  }
  var $x_3 = $thiz.CD;
  var this$6 = restoredDiagramState.o9;
  $f_Lcom_raquo_airstream_state_Var__set__O__V($x_3, (this$6.c() || this$6.d()));
  var $x_19 = $m_Lcom_raquo_airstream_state_Var$();
  var $x_18 = $m_sr_ScalaRunTime$();
  var $x_17 = new $c_Lcom_raquo_airstream_state_Var$VarTuple(new $c_T2($thiz.gn().H0, restoredDiagramState.oc));
  var $x_16 = new $c_Lcom_raquo_airstream_state_Var$VarTuple(new $c_T2($thiz.H7, restoredViewerSettings.mp));
  var $x_15 = $thiz.qs;
  try {
    var $x_14 = new $c_s_util_Success($m_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$().b1Q(restoredViewerSettings.mv));
  } catch (e$1) {
    var e$2$1 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
    matchEnd8$1: {
      var $x_14;
      if ($m_s_util_control_NonFatal$().ew(e$2$1)) {
        var $x_14 = new $c_s_util_Failure(e$2$1);
        break matchEnd8$1;
      }
      throw ((e$2$1 instanceof $c_sjs_js_JavaScriptException) ? e$2$1.bf : e$2$1);
    }
  }
  var $x_13 = new $c_Lcom_raquo_airstream_state_Var$VarTuple(new $c_T2($x_15, $x_14.X2(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $s_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$__none__Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection())))));
  var $x_12 = new $c_Lcom_raquo_airstream_state_Var$VarTuple(new $c_T2($thiz.Pf(), restoredViewerSettings.lH));
  var $x_11 = new $c_Lcom_raquo_airstream_state_Var$VarTuple(new $c_T2($thiz.U1, restoredViewerSettings.mu));
  var $x_10 = $thiz.H9;
  var $x_9 = $m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$();
  var this$24 = restoredViewerSettings.mw;
  var $x_8 = new $c_Lcom_raquo_airstream_state_Var$VarTuple(new $c_T2($x_10, $x_9.aMH(((this$24.c() ? $m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$().a0X : this$24.d()) | 0), (+window.innerWidth))));
  var $x_7 = new $c_Lcom_raquo_airstream_state_Var$VarTuple(new $c_T2($thiz.N5, restoredViewerSettings.my));
  var $x_6 = new $c_Lcom_raquo_airstream_state_Var$VarTuple(new $c_T2($thiz.H4, restoredViewerSettings.ml));
  var $x_5 = new $c_Lcom_raquo_airstream_state_Var$VarTuple(new $c_T2($thiz.CJ, restoredViewerSettings.mx));
  var $x_4 = new $c_Lcom_raquo_airstream_state_Var$VarTuple(new $c_T2($thiz.H5, restoredViewerSettings.mm));
  var self$10 = $thiz.H6;
  var this$41 = restoredViewerSettings.mo;
  $x_19.Y1($x_18.hP(new ($d_Lcom_raquo_airstream_state_Var$VarTuple.r().C)([$x_17, $x_16, $x_13, $x_12, $x_11, $x_8, $x_7, $x_6, $x_5, $x_4, new $c_Lcom_raquo_airstream_state_Var$VarTuple(new $c_T2(self$10, (this$41.c() ? $m_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$().Cq : this$41.d()))), new $c_Lcom_raquo_airstream_state_Var$VarTuple(new $c_T2($thiz.TV, restoredViewerSettings.mt)), new $c_Lcom_raquo_airstream_state_Var$VarTuple(new $c_T2($thiz.TT, restoredViewerSettings.mn))])));
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_Persistence__setupStateSynchronization__V($thiz) {
  $f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription($f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable(new $c_Lcom_raquo_airstream_misc_StreamFromSignal(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$()).aYC($thiz.gn().CB.P(), $thiz.gn().nh.P(), $thiz.gn().H0.P(), $thiz.mz.P(), $thiz.CG.P(), $thiz.CD.P()), true)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6) => {
    $thiz.zH.a56($f_Lorg_jpablo_graphexplorer_viewer_state_Persistence__snapshot__Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState($thiz));
  })), $thiz.p5);
  $f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription($f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable(new $c_Lcom_raquo_airstream_misc_StreamFromSignal($m_Lcom_raquo_airstream_combine_generated_CombinableSignal$().vV($m_Lcom_raquo_airstream_combine_generated_CombinableSignal$().vV($m_Lcom_raquo_airstream_combine_generated_CombinableSignal$().vV(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$()).aYB($thiz.H7.P(), $thiz.qs.P(), $thiz.Pf().P(), $thiz.U1.P(), $thiz.H9.P(), $thiz.N5.P(), $thiz.H4.P(), $thiz.CJ.P(), $thiz.H6.P()), $thiz.TV.P(), new $c_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$18()), $thiz.H5.P(), new $c_Lapp_tulz_tuplez_Composition\uff3fPri0$$anon$1()), $thiz.TT.P(), new $c_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$4()), true)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    matchResult14: {
      if ((x$1 !== null)) {
        var x49 = x$1.bH;
        if ((x49 !== null)) {
          var leftVisible = (!(!x49.Ne));
          var tabIndex = x49.Ng;
          var theme = x49.Nh;
          var promptBeforeNewNode = (!(!x49.Ni));
          var panelWidth = (x49.Nj | 0);
          var wrapLines = (!(!x49.Nk));
          var pinned = (!(!x49.Nl));
          var in3D = (!(!x49.Nm));
          var layout3DId = x49.Nn;
          var navTrackpad = (!(!x49.Nf));
          var en3D = (!(!x$1.bU));
          var billboard3D = (!(!x$1.c3));
          $f_Lcom_raquo_airstream_state_Var__update__F1__V($thiz.abl, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$7) => {
            var rightPanelTabIndex$1 = tabIndex.aG0;
            var rightPanelWidth$1 = new $c_s_Some(panelWidth);
            var layout3D$1 = new $c_s_Some(layout3DId);
            var schemaVersion$1 = $m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$().H2;
            return new $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings(leftVisible, rightPanelTabIndex$1, theme, promptBeforeNewNode, rightPanelWidth$1, wrapLines, pinned, in3D, en3D, layout3D$1, navTrackpad, billboard3D, _$7.mr, _$7.ms, _$7.mq, schemaVersion$1);
          })));
          break matchResult14;
        }
      }
      throw new $c_s_MatchError(x$1);
    }
  })), $thiz.p5);
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_Persistence__snapshot__Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState($thiz) {
  $m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$();
  var ev$18 = $thiz.gn().CB.P().aq().d();
  return new $c_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState(((ev$18 === null) ? null : ev$18.aS), $thiz.gn().nh.P().aq().d(), $thiz.gn().H0.P().aq().d(), $thiz.mz.P().aq().d(), new $c_s_Some($dp_toString__T($thiz.CG.P().aq().d())), new $c_s_Some($thiz.CD.P().aq().d()));
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_Persistence__initializePersistence__V($thiz) {
  $p_Lorg_jpablo_graphexplorer_viewer_state_Persistence__restorePersistedState__V($thiz);
  $p_Lorg_jpablo_graphexplorer_viewer_state_Persistence__setupStateSynchronization__V($thiz);
  $p_Lorg_jpablo_graphexplorer_viewer_state_Persistence__followDocumentSession__V($thiz);
  $p_Lorg_jpablo_graphexplorer_viewer_state_Persistence__followRecord__V($thiz);
  $p_Lorg_jpablo_graphexplorer_viewer_state_Persistence__watchOrigin__V($thiz);
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps__$init$__V($thiz) {
  $thiz.gs = $m_Lcom_raquo_airstream_state_Var$().bx($m_s_None$());
  $thiz.vs = $m_Lcom_raquo_airstream_state_Var$().bx($m_s_None$());
}
function $ps_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps__walk$1__scm_ReusableBuilder__Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$Field__sci_List__V(boxes$1, f, path) {
  if ($f_sc_SeqOps__isEmpty__Z(f.hX)) {
    var this$2 = f.ZV;
    var this$3 = (this$2.c() ? $m_s_None$() : new $c_s_Some($f_T__trim__T(this$2.d())));
    boxes$1.Y(new $c_Lorg_jpablo_graphexplorer_viewer_state_RecordCellBox(path, ((this$3.c() || (this$3.d() !== "")) ? this$3 : $m_s_None$()), f.n5, f.q0, f.q1, f.o2));
  } else {
    $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(f.hX).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
      $ps_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps__walk$1__scm_ReusableBuilder__Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$Field__sci_List__V(boxes$1, x$1.g(), $f_sc_StrictOptimizedSeqOps__appended__O__O(path, (x$1.h() | 0)));
    })));
  }
}
function $s_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps__org$jpablo$graphexplorer$viewer$state$RecordCellOps$recordCells$$$_$spread$1__sci_Vector__F1__D(boxes$4, centre) {
  var vs = boxes$4.L(centre);
  return ((+$f_sc_IterableOnceOps__max__s_math_Ordering__O(vs, $m_s_math_Ordering$DeprecatedDoubleOrdering$())) - (+$f_sc_IterableOnceOps__min__s_math_Ordering__O(vs, $m_s_math_Ordering$DeprecatedDoubleOrdering$())));
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__nodeAttr__Lorg_jpablo_graphexplorer_viewer_models_ViewerNode__T__s_Option($thiz, node, name) {
  var this$2 = node.fH.r(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId(name));
  var this$3 = (this$2.c() ? $m_s_None$() : new $c_s_Some(this$2.d().m()));
  return ((this$3.c() || (this$3.d() !== "")) ? this$3 : $m_s_None$());
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__labelIsHtml__Lorg_jpablo_graphexplorer_viewer_models_ViewerNode__Z($thiz, node) {
  var x10 = $f_Lorg_jpablo_graphexplorer_viewer_models_ViewerElement__label__Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(node).GA;
  if ((x10 instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq)) {
    return x10.vn;
  }
  if (((typeof x10) === "string")) {
    return $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabels$().w8(x10);
  }
  throw new $c_s_MatchError(x10);
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__kindOf__Lorg_jpablo_graphexplorer_viewer_models_NodeId__s_Option($thiz, nodeId) {
  var g = $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__fullGraphObs__Lcom_raquo_airstream_state_OwnedSignal($thiz.ee)).d();
  var this$3 = g.dQ.r(nodeId);
  if (this$3.c()) {
    return $m_s_None$();
  } else {
    var x0 = this$3.d();
    return ($p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__labelIsHtml__Lorg_jpablo_graphexplorer_viewer_models_ViewerNode__Z($thiz, x0) ? ((!$m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$().Jf($f_Lorg_jpablo_graphexplorer_viewer_models_ViewerElement__label__Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(x0).m()).c()) ? new $c_s_Some($thiz.jJ.qr) : $m_s_None$()) : ($f_Lorg_jpablo_graphexplorer_viewer_graph_CombineNodesOps__isRecordNode__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Z(g, nodeId) ? new $c_s_Some($thiz.jJ.xo) : $m_s_None$()));
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__getNodeNow__Lorg_jpablo_graphexplorer_viewer_models_NodeId__s_Option($thiz, nodeId) {
  return $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__fullGraphObs__Lcom_raquo_airstream_state_OwnedSignal($thiz.ee)).d().dQ.r(nodeId);
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__htmlTableOf__Lorg_jpablo_graphexplorer_viewer_models_NodeId__s_Option($thiz, nodeId) {
  if ($p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__kindOf__Lorg_jpablo_graphexplorer_viewer_models_NodeId__s_Option($thiz, nodeId).E($thiz.jJ.qr)) {
    var this$1 = $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__getNodeNow__Lorg_jpablo_graphexplorer_viewer_models_NodeId__s_Option($thiz, nodeId);
    return (this$1.c() ? $m_s_None$() : $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$().Jf($f_Lorg_jpablo_graphexplorer_viewer_models_ViewerElement__label__Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(this$1.d()).m()));
  } else {
    return $m_s_None$();
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__recordBoxes__Lorg_jpablo_graphexplorer_viewer_models_NodeId__sci_Vector($thiz, nodeId) {
  var this$1 = $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__getNodeNow__Lorg_jpablo_graphexplorer_viewer_models_NodeId__s_Option($thiz, nodeId);
  if (this$1.c()) {
    $m_sci_Vector$();
    var $x_1 = $m_sci_Vector0$();
  } else {
    var x0 = this$1.d();
    var this$3 = $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__nodeAttr__Lorg_jpablo_graphexplorer_viewer_models_ViewerNode__T__s_Option($thiz, x0, "margin");
    if (this$3.c()) {
      var margin = $m_s_None$();
    } else {
      var x0$1 = this$3.d();
      matchResult10: {
        var margin;
        var xs = $f_T__split__T__I__AT(x0$1, ",", 0);
        var f = ((_$3) => $f_T__trim__T(_$3));
        var len = xs.a.length;
        var ys = new ($d_T.r().C)(len);
        if ((len > 0)) {
          var i = 0;
          if ((xs !== null)) {
            while ((i < len)) {
              var $x_2 = i;
              var x0$2 = xs.a[i];
              ys.a[$x_2] = f(x0$2);
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $ac_I)) {
            while ((i < len)) {
              var $x_3 = i;
              var x0$3 = xs.a[i];
              ys.a[$x_3] = f(x0$3);
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $ac_D)) {
            while ((i < len)) {
              var $x_4 = i;
              var x0$4 = xs.a[i];
              ys.a[$x_4] = f(x0$4);
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $ac_J)) {
            while ((i < len)) {
              var $x_7 = i;
              var $x_5 = xs.a;
              var $x_6 = (i << 1);
              var x0$5_$_lo = $x_5[$x_6];
              var x0$5_$_hi = $x_5[(($x_6 + 1) | 0)];
              ys.a[$x_7] = f($bL(x0$5_$_lo, x0$5_$_hi));
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $ac_F)) {
            while ((i < len)) {
              var $x_8 = i;
              var x0$6 = xs.a[i];
              ys.a[$x_8] = f(x0$6);
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $ac_C)) {
            while ((i < len)) {
              var $x_9 = i;
              var x0$7 = xs.a[i];
              ys.a[$x_9] = f($bC(x0$7));
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $ac_B)) {
            while ((i < len)) {
              var $x_10 = i;
              var x0$8 = xs.a[i];
              ys.a[$x_10] = f(x0$8);
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $ac_S)) {
            while ((i < len)) {
              var $x_11 = i;
              var x0$9 = xs.a[i];
              ys.a[$x_11] = f(x0$9);
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $ac_Z)) {
            while ((i < len)) {
              var $x_12 = i;
              var x0$10 = xs.a[i];
              ys.a[$x_12] = f(x0$10);
              i = ((1 + i) | 0);
            }
          } else {
            throw new $c_s_MatchError(xs);
          }
        }
        var capacity = 0;
        var size = 0;
        var jsElems = null;
        capacity = 0;
        size = 0;
        jsElems = [];
        var i$1 = 0;
        while ((i$1 < ys.a.length)) {
          var x0$11 = ys.a[i$1];
          var this$15 = $m_sc_StringParsers$();
          var elems = (this$15.c1(x0$11) ? new $c_s_Some($m_jl_Double$().bd(x0$11)) : $m_s_None$());
          var it = elems.o();
          while (it.p()) {
            var elem = it.q();
            var unboxedElem = ((elem === null) ? 0.0 : elem);
            jsElems.push(unboxedElem);
          }
          i$1 = ((1 + i$1) | 0);
        }
        var x18 = new $ac_D(new Float64Array(jsElems));
        if (($m_s_Array$UnapplySeqWrapper$().u9(x18, 2) === 0)) {
          var x22 = x18.a[0];
          var x23 = x18.a[1];
          var margin = new $c_s_Some(new $c_T2((x22 * $thiz.TM), (x23 * $thiz.TM)));
          break matchResult10;
        }
        if (($m_s_Array$UnapplySeqWrapper$().u9(x18, 1) === 0)) {
          var x20 = x18.a[0];
          var margin = new $c_s_Some(new $c_T2((x20 * $thiz.TM), (x20 * $thiz.TM)));
          break matchResult10;
        }
        var margin = $m_s_None$();
      }
    }
    var this$24 = $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__nodeAttr__Lorg_jpablo_graphexplorer_viewer_models_ViewerNode__T__s_Option($thiz, x0, "fixedsize");
    if (this$24.c()) {
      var this$25 = $m_s_None$();
    } else {
      var x0$12 = this$24.d();
      var this$25 = new $c_s_Some(x0$12.toLowerCase());
    }
    if ((!this$25.c())) {
      var x0$13 = this$25.d();
      var fixed = ((x0$13 === "true") || (x0$13 === "shape"));
    } else {
      var fixed = false;
    }
    matchResult11: {
      var root$2;
      var this$26 = $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__nodeAttr__Lorg_jpablo_graphexplorer_viewer_models_ViewerNode__T__s_Option($thiz, x0, "label");
      var label$1 = (this$26.c() ? "\\N" : this$26.d());
      var topLR$1 = $thiz.aT0();
      var this$27 = $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__nodeAttr__Lorg_jpablo_graphexplorer_viewer_models_ViewerNode__T__s_Option($thiz, x0, "fontsize");
      if (this$27.c()) {
        var this$31 = $m_s_None$();
      } else {
        var x0$14 = this$27.d();
        var this$31 = ($m_sc_StringParsers$().c1(x0$14) ? new $c_s_Some($m_jl_Double$().bd(x0$14)) : $m_s_None$());
      }
      var fontSizePt$1 = (+(this$31.c() ? $thiz.aba : this$31.d()));
      var this$32 = $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__nodeAttr__Lorg_jpablo_graphexplorer_viewer_models_ViewerNode__T__s_Option($thiz, x0, "fontname");
      var fontName$1 = (this$32.c() ? $thiz.ab9 : this$32.d());
      var this$33 = $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__nodeAttr__Lorg_jpablo_graphexplorer_viewer_models_ViewerNode__T__s_Option($thiz, x0, "width");
      if (this$33.c()) {
        var this$37 = $m_s_None$();
      } else {
        var x0$15 = this$33.d();
        var this$37 = ($m_sc_StringParsers$().c1(x0$15) ? new $c_s_Some($m_jl_Double$().bd(x0$15)) : $m_s_None$());
      }
      var minWIn$1 = (+(this$37.c() ? $thiz.aFX : this$37.d()));
      var this$38 = $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__nodeAttr__Lorg_jpablo_graphexplorer_viewer_models_ViewerNode__T__s_Option($thiz, x0, "height");
      if (this$38.c()) {
        var this$42 = $m_s_None$();
      } else {
        var x0$16 = this$38.d();
        var this$42 = ($m_sc_StringParsers$().c1(x0$16) ? new $c_s_Some($m_jl_Double$().bd(x0$16)) : $m_s_None$());
      }
      var minHIn$1 = (+(this$42.c() ? $thiz.aFW : this$42.d()));
      $m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$();
      var html$1 = false;
      $m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$();
      var imgs$1 = $m_Lorg_jpablo_graphexplorer_graphviz_html_ImageDim$().Rv;
      $m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$();
      var graphName$1 = "";
      var x24 = $m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$().agQ(label$1, topLR$1, fontSizePt$1, fontName$1, minWIn$1, minHIn$1, fixed, margin, html$1, imgs$1, x0.o7.dE, graphName$1);
      if ((x24 !== null)) {
        var root$2 = x24.c3;
        break matchResult11;
      }
      throw new $c_s_MatchError(x24);
    }
    $m_sci_Vector$();
    var boxes = new $c_sci_VectorBuilder();
    $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(root$2.hX).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
      $ps_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps__walk$1__scm_ReusableBuilder__Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$Field__sci_List__V(boxes, x$1.g(), new $c_sci_$colon$colon((x$1.h() | 0), $m_sci_Nil$()));
    })));
    var $x_1 = boxes.bY();
  }
  return $x_1;
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__htmlBoxes__Lorg_jpablo_graphexplorer_viewer_models_NodeId__sci_Vector($thiz, nodeId) {
  var this$1 = $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__getNodeNow__Lorg_jpablo_graphexplorer_viewer_models_NodeId__s_Option($thiz, nodeId);
  if (this$1.c()) {
    var this$16 = $m_s_None$();
  } else {
    var x0 = this$1.d();
    var this$2 = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$().Jf($f_Lorg_jpablo_graphexplorer_viewer_models_ViewerElement__label__Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(x0).m());
    if (this$2.c()) {
      var this$16 = $m_s_None$();
    } else {
      var x0$1 = this$2.d();
      var $x_2 = $m_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$();
      var this$3 = $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__nodeAttr__Lorg_jpablo_graphexplorer_viewer_models_ViewerNode__T__s_Option($thiz, x0, "fontsize");
      if (this$3.c()) {
        var this$7 = $m_s_None$();
      } else {
        var x0$2 = this$3.d();
        var this$7 = ($m_sc_StringParsers$().c1(x0$2) ? new $c_s_Some($m_jl_Double$().bd(x0$2)) : $m_s_None$());
      }
      var $x_1 = (this$7.c() ? $thiz.aba : this$7.d());
      var this$8 = $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__nodeAttr__Lorg_jpablo_graphexplorer_viewer_models_ViewerNode__T__s_Option($thiz, x0, "fontname");
      var this$16 = new $c_s_Some($f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O($x_2.a46(x0$1, (+$x_1), (this$8.c() ? $thiz.ab9 : this$8.d()), $m_Lorg_jpablo_graphexplorer_graphviz_html_ImageDim$().Rv, $m_s_None$()).Be, $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$().aZC(x0$1)).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
        var pc = x$1.g();
        var path = x$1.h();
        var this$12 = pc.oV.gE.r("port");
        return new $c_Lorg_jpablo_graphexplorer_viewer_state_RecordCellBox(path, ((this$12.c() || (this$12.d() !== "")) ? this$12 : $m_s_None$()), pc.nS.lA, pc.nS.me, pc.nS.lB, pc.nS.mf);
      }))));
    }
  }
  return (this$16.c() ? ($m_sci_Vector$(), $m_sci_Vector0$()) : this$16.d());
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__nodeGroupInDom__Lorg_jpablo_graphexplorer_viewer_models_NodeId__s_Option($thiz, nodeId) {
  return $m_Lorg_jpablo_graphexplorer_viewer_domUtils_QuerySelector$package$().m3(document.documentElement, (("[id='" + nodeId.kx()) + "']")).cE(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$16) => (_$16.closest(("." + $m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().a0v)) !== null)))).nw(new $c_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$$anon$2());
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__clientToLocal__Lorg_scalajs_dom_SVGGElement__D__D__s_Option($thiz, group, clientX, clientY) {
  var this$1 = $m_s_Option$().as(group.getScreenCTM());
  return (this$1.c() ? $m_s_None$() : new $c_s_Some($m_Lorg_jpablo_graphexplorer_viewer_components_SvgElementOps$package$().Q5(new $c_Lorg_jpablo_graphexplorer_viewer_utils_ClientPoint(clientX, clientY), this$1.d())));
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__resolveRecordPortIn__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Lorg_jpablo_graphexplorer_viewer_models_ViewerNode__sci_List__T2($thiz, g, nodeId, node, p) {
  var root = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$().Je($f_Lorg_jpablo_graphexplorer_viewer_models_ViewerElement__label__Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(node).m());
  var x35 = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$().P1(root, p);
  if ((x35 instanceof $c_s_Some)) {
    var x37 = x35.J;
    if ((x37 instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Leaf)) {
      var x32 = x37.vm;
      if ((x32 instanceof $c_s_Some)) {
        return new $c_T2(g, x32);
      }
      if (($m_s_None$() === x32)) {
        var fresh = $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__freshPortName__sci_Set__T($thiz, $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$__go$4__Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree__sci_Set($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$(), root));
        return new $c_T2($f_Lorg_jpablo_graphexplorer_viewer_graph_CombineNodesOps__withRecordLabel__Lorg_jpablo_graphexplorer_viewer_models_NodeId__T__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(g, nodeId, $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$().a4H($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$().b8I(root, p, new $c_s_Some(fresh)))), new $c_s_Some(fresh));
      }
      throw new $c_s_MatchError(x32);
    }
  }
  return new $c_T2(g, $m_s_None$());
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__resolveHtmlPortIn__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Lorg_jpablo_graphexplorer_viewer_models_ViewerNode__sci_List__T2($thiz, g, nodeId, node, p) {
  var x45 = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$().Jf($f_Lorg_jpablo_graphexplorer_viewer_models_ViewerElement__label__Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(node).m());
  if ((x45 instanceof $c_s_Some)) {
    var tbl = x45.J;
    var x42 = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$().Wp(tbl, p);
    if ((x42 instanceof $c_s_Some)) {
      var cell = x42.J;
      var this$1 = cell.gE.r("port");
      var x39 = ((this$1.c() || (this$1.d() !== "")) ? this$1 : $m_s_None$());
      if ((x39 instanceof $c_s_Some)) {
        return new $c_T2(g, x39);
      }
      if (($m_s_None$() === x39)) {
        var fresh = $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__freshPortName__sci_Set__T($thiz, $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$().aR3(tbl));
        return new $c_T2($f_Lorg_jpablo_graphexplorer_viewer_graph_CombineNodesOps__withHtmlLabel__Lorg_jpablo_graphexplorer_viewer_models_NodeId__T__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(g, nodeId, $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$__printTableIndented__Lorg_jpablo_graphexplorer_graphviz_html_HtmlTable__I__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$(), $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$().aS2(tbl, p, "port", new $c_s_Some(fresh)), 0)), new $c_s_Some(fresh));
      }
      throw new $c_s_MatchError(x39);
    }
    if (($m_s_None$() === x42)) {
      return new $c_T2(g, $m_s_None$());
    }
    throw new $c_s_MatchError(x42);
  }
  if (($m_s_None$() === x45)) {
    return new $c_T2(g, $m_s_None$());
  }
  throw new $c_s_MatchError(x45);
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__freshPortName__sci_Set__T($thiz, used) {
  return new $c_sc_Iterator$$anon$6(new $c_sc_Iterator$$anon$9(new $c_sc_Iterator$$anon$24(0, 1), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((i) => ("f" + (i | 0))))), used, true).q();
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__clamped__Lorg_jpablo_graphexplorer_viewer_state_SelectedCell__Lorg_jpablo_graphexplorer_viewer_state_SelectedCell($thiz, cell) {
  var x51 = $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__kindOf__Lorg_jpablo_graphexplorer_viewer_models_NodeId__s_Option($thiz, cell.bT);
  if ((x51 instanceof $c_s_Some)) {
    var x55 = x51.J;
    var x = $thiz.jJ.xo;
    if (((x === null) ? (x55 === null) : (x === x55))) {
      var this$1 = $thiz.P3(cell.bT);
      if (this$1.c()) {
        return cell;
      } else {
        var x0 = this$1.d();
        return new $c_Lorg_jpablo_graphexplorer_viewer_state_SelectedCell(cell.bT, $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$__go$3__Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree__sci_List__sci_List__sci_List($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$(), x0, cell.f4, $m_sci_Nil$()));
      }
    }
    var x$3 = $thiz.jJ.qr;
    if (((x$3 === null) ? (x55 === null) : (x$3 === x55))) {
      var this$4 = $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__htmlTableOf__Lorg_jpablo_graphexplorer_viewer_models_NodeId__s_Option($thiz, cell.bT);
      if (this$4.c()) {
        return cell;
      } else {
        var x0$1 = this$4.d();
        return new $c_Lorg_jpablo_graphexplorer_viewer_state_SelectedCell(cell.bT, $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$().ah4(x0$1, cell.f4));
      }
    }
  }
  if (($m_s_None$() === x51)) {
    return cell;
  }
  throw new $c_s_MatchError(x51);
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__singleSelectedCellEditable__s_Option($thiz) {
  var sel = $thiz.ee.aH().cL();
  if ((sel.aa() === 1)) {
    var this$3 = $f_sc_IterableOps__headOption__s_Option($m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().gV(sel).gg);
    return ((this$3.c() || $thiz.agz(this$3.d())) ? this$3 : $m_s_None$());
  } else {
    return $m_s_None$();
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__cellsStackVertically__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Z($thiz, nodeId) {
  var boxes = $thiz.DO(nodeId);
  return ((boxes.C() < 2) || ($s_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps__org$jpablo$graphexplorer$viewer$state$RecordCellOps$recordCells$$$_$spread$1__sci_Vector__F1__D(boxes, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((b) => (0.5 * (b.zz + b.tp))))) >= $s_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps__org$jpablo$graphexplorer$viewer$state$RecordCellOps$recordCells$$$_$spread$1__sci_Vector__F1__D(boxes, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((b$2) => (0.5 * (b$2.to + b$2.zA)))))));
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__portOfIn__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_state_SelectedCell__s_Option($thiz, g, cell) {
  var id = cell.bT;
  var this$1 = g.dQ.r(id);
  if (this$1.c()) {
    return $m_s_None$();
  } else {
    var x0 = this$1.d();
    if ($p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__labelIsHtml__Lorg_jpablo_graphexplorer_viewer_models_ViewerNode__Z($thiz, x0)) {
      var this$2 = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$().Jf($f_Lorg_jpablo_graphexplorer_viewer_models_ViewerElement__label__Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(x0).m());
      if (this$2.c()) {
        return $m_s_None$();
      } else {
        var x0$1 = this$2.d();
        var this$3 = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$().Wp(x0$1, cell.f4);
        if (this$3.c()) {
          return $m_s_None$();
        } else {
          var x0$2 = this$3.d();
          var this$4 = x0$2.gE.r("port");
          return ((this$4.c() || (this$4.d() !== "")) ? this$4 : $m_s_None$());
        }
      }
    } else if ($f_Lorg_jpablo_graphexplorer_viewer_graph_CombineNodesOps__isRecordNode__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Z(g, cell.bT)) {
      var this$7 = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$().P1($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$().Je($f_Lorg_jpablo_graphexplorer_viewer_models_ViewerElement__label__Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(x0).m()), cell.f4);
      var pf = new $c_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$$anon$3();
      var this$9 = ((!this$7.c()) ? new $c_s_PartialFunction$Lifted(pf).as(this$7.d()) : $m_s_None$());
      return (this$9.c() ? $m_s_None$() : this$9.d().vm);
    } else {
      return $m_s_None$();
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__cellAttrsIn__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_state_SelectedCell__s_Option($thiz, g, cell) {
  var id = cell.bT;
  var this$1 = g.dQ.r(id);
  if (this$1.c()) {
    return $m_s_None$();
  } else {
    var x0 = this$1.d();
    var this$2 = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$().Jf($f_Lorg_jpablo_graphexplorer_viewer_models_ViewerElement__label__Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(x0).m());
    if (this$2.c()) {
      return $m_s_None$();
    } else {
      var x0$1 = this$2.d();
      var this$3 = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$().Wp(x0$1, cell.f4);
      return (this$3.c() ? $m_s_None$() : new $c_s_Some(this$3.d().gE));
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__readCellAttrs__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_state_SelectedCell__Lorg_jpablo_graphexplorer_viewer_models_AttributeUpdates($thiz, g, cell) {
  var this$1 = $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__cellAttrsIn__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_state_SelectedCell__s_Option($thiz, g, cell);
  return new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeUpdates((this$1.c() ? $m_sci_Map$EmptyMap$() : this$1.d()).kP(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var k = x$1.g();
    var v = x$1.h();
    return new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId(k), new $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single(($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(v))));
  }))));
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__writeCellAttrs__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_state_SelectedCell__Lorg_jpablo_graphexplorer_viewer_models_AttributeUpdates__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph($thiz, g, cell, updates) {
  var id = cell.bT;
  var this$1 = g.dQ.r(id);
  if (this$1.c()) {
    var this$21 = $m_s_None$();
  } else {
    var x0 = this$1.d();
    var this$2 = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$().Jf($f_Lorg_jpablo_graphexplorer_viewer_models_ViewerElement__label__Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(x0).m());
    if (this$2.c()) {
      var this$21 = $m_s_None$();
    } else {
      var x0$1 = this$2.d();
      var this$3 = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$().Wp(x0$1, cell.f4);
      var this$4 = (this$3.c() ? $m_s_None$() : new $c_s_Some(this$3.d().gE));
      if (this$4.c()) {
        var this$21 = $m_s_None$();
      } else {
        var x0$3 = this$4.d();
        var applied = updates.Wk(($m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$(), x0$3.kP(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
          var k = x$1.g();
          var v = x$1.h();
          return new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId(k), ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(v)));
        }))))).kP(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => new $c_T2(((x$1$2.g() === null) ? null : x$1$2.g().fY), x$1$2.h().m())))).bw(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3) => {
          x$1$3.g();
          return (x$1$3.h() !== "");
        })));
        var this$14 = applied.r("color");
        if ((!this$14.c())) {
          var x0$4 = this$14.d();
          var $x_1 = (!x0$3.r("color").E(x0$4));
        } else {
          var $x_1 = false;
        }
        if (($x_1 && ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$().b0o(x0$1, applied) === 0))) {
          var newAttrs = applied.bN("border", "1");
        } else {
          var newAttrs = applied;
        }
        var this$18 = newAttrs.ln().dI(x0$3.ln());
        var f = ((acc, key) => $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$().aS2(acc, cell.f4, key, newAttrs.r(key)));
        if ($is_sc_IndexedSeq(this$18)) {
          var at = 0;
          var end = this$18.C();
          var acc$1 = x0$1;
          var $x_2;
          while (true) {
            if ((at !== end)) {
              var temp$at = ((1 + at) | 0);
              var x0$5 = acc$1;
              var x1 = this$18.l(at);
              var temp$acc = f(x0$5, x1);
              at = temp$at;
              acc$1 = temp$acc;
              continue;
            }
            var $x_2 = acc$1;
            break;
          }
        } else {
          var result = x0$1;
          var it = this$18.o();
          while (it.p()) {
            var x0$6 = result;
            var x1$1 = it.q();
            result = f(x0$6, x1$1);
          }
          var $x_2 = result;
        }
        var newTbl = $x_2;
        var withLabel = $f_Lorg_jpablo_graphexplorer_viewer_graph_CombineNodesOps__withHtmlLabel__Lorg_jpablo_graphexplorer_viewer_models_NodeId__T__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(g, cell.bT, $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$__printTableIndented__Lorg_jpablo_graphexplorer_graphviz_html_HtmlTable__I__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$(), newTbl, 0));
        matchResult29: {
          var $x_3;
          var _1 = x0$3.r("port");
          var _2 = newAttrs.r("port");
          if ((_1 instanceof $c_s_Some)) {
            var before = _1.J;
            if ((!_2.E(before))) {
              var $x_3 = $f_Lorg_jpablo_graphexplorer_viewer_graph_CombineNodesOps__renamePort__Lorg_jpablo_graphexplorer_viewer_models_NodeId__T__s_Option__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(withLabel, cell.bT, before, _2);
              break matchResult29;
            }
          }
          var $x_3 = withLabel;
        }
        var this$21 = new $c_s_Some($x_3);
      }
    }
  }
  return (this$21.c() ? g : this$21.d());
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__commitRecord__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group__Z($thiz, nodeId, root) {
  var applies = $thiz.ee.d4.u5();
  $f_Lcom_raquo_airstream_state_Var__update__F1__V($thiz.ee.d4.jI, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$27) => $f_Lorg_jpablo_graphexplorer_viewer_graph_CombineNodesOps__withRecordLabel__Lorg_jpablo_graphexplorer_viewer_models_NodeId__T__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(_$27, nodeId, $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$().a4H(root)))));
  return applies;
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__commitHtml__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Lorg_jpablo_graphexplorer_graphviz_html_HtmlTable__Z($thiz, nodeId, tbl) {
  var applies = $thiz.ee.d4.u5();
  $f_Lcom_raquo_airstream_state_Var__update__F1__V($thiz.ee.d4.jI, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$28) => $f_Lorg_jpablo_graphexplorer_viewer_graph_CombineNodesOps__withHtmlLabel__Lorg_jpablo_graphexplorer_viewer_models_NodeId__T__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(_$28, nodeId, $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$__printTableIndented__Lorg_jpablo_graphexplorer_graphviz_html_HtmlTable__I__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$(), tbl, 0)))));
  return applies;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$(outer) {
  this.aba = 0.0;
  this.ab9 = null;
  this.aFX = 0.0;
  this.aFW = 0.0;
  this.TM = 0.0;
  this.jJ = null;
  this.ee = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.ee = outer;
  this.jJ = new $c_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$CellKind$(this);
  this.aba = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontSize$().aac;
  this.ab9 = "Times-Roman";
  this.aFX = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Width$().aaA;
  this.aFW = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Height$().aaf;
  this.TM = 72.0;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$.prototype = $p;
$p.agz = (function(nodeId) {
  return (!$p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__kindOf__Lorg_jpablo_graphexplorer_viewer_models_NodeId__s_Option(this, nodeId).c());
});
$p.ahV = (function() {
  var this$3 = this.ee.gs.P().aq().d();
  return ((!this$3.c()) && $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__kindOf__Lorg_jpablo_graphexplorer_viewer_models_NodeId__s_Option(this, this$3.d().bT).E(this.jJ.qr));
});
$p.aT0 = (function() {
  return $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$().bao($f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__graphRankDirObs__Lcom_raquo_airstream_state_OwnedSignal(this.ee)).d());
});
$p.P3 = (function(nodeId) {
  if ($p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__kindOf__Lorg_jpablo_graphexplorer_viewer_models_NodeId__s_Option(this, nodeId).E(this.jJ.xo)) {
    var this$1 = $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__getNodeNow__Lorg_jpablo_graphexplorer_viewer_models_NodeId__s_Option(this, nodeId);
    if (this$1.c()) {
      return $m_s_None$();
    } else {
      var x0 = this$1.d();
      return new $c_s_Some($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$().Je($f_Lorg_jpablo_graphexplorer_viewer_models_ViewerElement__label__Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(x0).m()));
    }
  } else {
    return $m_s_None$();
  }
});
$p.DO = (function(nodeId) {
  var x13 = $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__kindOf__Lorg_jpablo_graphexplorer_viewer_models_NodeId__s_Option(this, nodeId);
  if ((x13 instanceof $c_s_Some)) {
    var x17 = x13.J;
    var x = this.jJ.xo;
    if (((x === null) ? (x17 === null) : (x === x17))) {
      return $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__recordBoxes__Lorg_jpablo_graphexplorer_viewer_models_NodeId__sci_Vector(this, nodeId);
    }
    var x$3 = this.jJ.qr;
    if (((x$3 === null) ? (x17 === null) : (x$3 === x17))) {
      return $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__htmlBoxes__Lorg_jpablo_graphexplorer_viewer_models_NodeId__sci_Vector(this, nodeId);
    }
  }
  if (($m_s_None$() === x13)) {
    $m_sci_Vector$();
    return $m_sci_Vector0$();
  }
  throw new $c_s_MatchError(x13);
});
$p.aYe = (function(nodeId, x, y) {
  var boxes = this.DO(nodeId);
  _return: {
    var it = boxes.o();
    while (it.p()) {
      var a = it.q();
      if (a.aZ0(x, y)) {
        var this$1 = new $c_s_Some(a);
        break _return;
      }
    }
    var this$1 = $m_s_None$();
  }
  var this$2 = (this$1.c() ? $f_sc_IterableOnceOps__minByOption__F1__s_math_Ordering__s_Option(boxes, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$14) => _$14.b00(x, y))), $m_s_math_Ordering$DeprecatedDoubleOrdering$()) : this$1);
  return (this$2.c() ? $m_s_None$() : new $c_s_Some(this$2.d().qq));
});
$p.Wq = (function(nodeId, clientX, clientY) {
  if ((!this.agz(nodeId))) {
    return $m_s_None$();
  } else {
    var this$1 = $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__nodeGroupInDom__Lorg_jpablo_graphexplorer_viewer_models_NodeId__s_Option(this, nodeId);
    if (this$1.c()) {
      return $m_s_None$();
    } else {
      var x0 = this$1.d();
      var this$2 = $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__clientToLocal__Lorg_scalajs_dom_SVGGElement__D__D__s_Option(this, x0, clientX, clientY);
      if (this$2.c()) {
        return $m_s_None$();
      } else {
        var x0$1 = this$2.d();
        var bbox = $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_RecordCellOverlay$().ahn(x0);
        return this.aYe(nodeId, (x0$1.gI - ((+bbox.x) + (0.5 * (+bbox.width)))), (((+bbox.y) + (0.5 * (+bbox.height))) - x0$1.gJ));
      }
    }
  }
});
$p.ahH = (function(g, nodeId, path) {
  if (path.c()) {
    var resolved = $m_s_None$();
  } else {
    var x0 = path.d();
    var this$1 = g.dQ.r(nodeId);
    if (this$1.c()) {
      var resolved = $m_s_None$();
    } else {
      var x0$1 = this$1.d();
      var resolved = new $c_s_Some(($p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__labelIsHtml__Lorg_jpablo_graphexplorer_viewer_models_ViewerNode__Z(this, x0$1) ? $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__resolveHtmlPortIn__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Lorg_jpablo_graphexplorer_viewer_models_ViewerNode__sci_List__T2(this, g, nodeId, x0$1, x0) : ($f_Lorg_jpablo_graphexplorer_viewer_graph_CombineNodesOps__isRecordNode__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Z(g, nodeId) ? $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__resolveRecordPortIn__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Lorg_jpablo_graphexplorer_viewer_models_ViewerNode__sci_List__T2(this, g, nodeId, x0$1, x0) : new $c_T2(g, $m_s_None$()))));
    }
  }
  return (resolved.c() ? new $c_T2(g, $m_s_None$()) : resolved.d());
});
$p.pG = (function(nodeId, path) {
  $f_Lcom_raquo_airstream_state_Var__set__O__V(this.ee.gs, new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_state_SelectedCell(nodeId, path)));
});
$p.aMI = (function() {
  if ((!this.ee.gs.P().aq().d().c())) {
    $f_Lcom_raquo_airstream_state_Var__set__O__V(this.ee.gs, $m_s_None$());
  }
});
$p.b0P = (function() {
  var x48 = this.ee.gs.P().aq().d();
  if ((x48 instanceof $c_s_Some)) {
    var cell = x48.J;
    this.aMI();
    this.ee.aH().gC($m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_ElementId.r().C)([cell.bT]))));
    return true;
  }
  if (($m_s_None$() === x48)) {
    return false;
  }
  throw new $c_s_MatchError(x48);
});
$p.b6X = (function(sel) {
  var this$3 = this.ee.gs.P().aq().d();
  if ((!this$3.c())) {
    var x0 = this$3.d();
    if ((!((sel.aa() === 1) && $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().mJ(sel, x0.bT)))) {
      this.aMI();
    }
  }
});
$p.b0F = (function() {
  var x59 = this.ee.gs.P().aq().d();
  if ((x59 instanceof $c_s_Some)) {
    var cell = x59.J;
    $f_Lcom_raquo_airstream_state_Var__set__O__V(this.ee.vs, new $c_s_Some($p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__clamped__Lorg_jpablo_graphexplorer_viewer_state_SelectedCell__Lorg_jpablo_graphexplorer_viewer_state_SelectedCell(this, cell)));
    return true;
  }
  if (($m_s_None$() === x59)) {
    var x56 = $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__singleSelectedCellEditable__s_Option(this);
    if ((x56 instanceof $c_s_Some)) {
      var nodeId = x56.J;
      var this$5 = $f_sc_IndexedSeqOps__headOption__s_Option(this.DO(nodeId));
      if ((!this$5.c())) {
        this.pG(nodeId, this$5.d().qq);
      }
      return true;
    }
    if (($m_s_None$() === x56)) {
      return false;
    }
    throw new $c_s_MatchError(x56);
  }
  throw new $c_s_MatchError(x59);
});
$p.b0n = (function(cell) {
  this.pG(cell.bT, cell.f4);
  $f_Lcom_raquo_airstream_state_Var__set__O__V(this.ee.vs, new $c_s_Some($p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__clamped__Lorg_jpablo_graphexplorer_viewer_state_SelectedCell__Lorg_jpablo_graphexplorer_viewer_state_SelectedCell(this, cell)));
});
$p.b4x = (function(dir) {
  var x62 = this.ee.gs.P().aq().d();
  if ((x62 instanceof $c_s_Some)) {
    var cell = x62.J;
    if ((dir.X9() !== $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__cellsStackVertically__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Z(this, cell.bT))) {
      var paths = this.DO(cell.bT).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$18) => _$18.qq)));
      if ((!$f_sc_SeqOps__isEmpty__Z(paths))) {
        var x$2 = $s_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$__NavDown__Lorg_jpablo_graphexplorer_viewer_state_NavDirection();
        if (((dir === null) ? (x$2 === null) : (dir === x$2))) {
          var $x_1 = true;
        } else {
          var x$4 = $s_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$__NavRight__Lorg_jpablo_graphexplorer_viewer_state_NavDirection();
          var $x_1 = ((dir === null) ? (x$4 === null) : (dir === x$4));
        }
        if ($x_1) {
          var delta = 1;
        } else {
          var delta = (-1);
        }
        var x = $f_sc_SeqOps__indexOf__O__I__I(paths, $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__clamped__Lorg_jpablo_graphexplorer_viewer_state_SelectedCell__Lorg_jpablo_graphexplorer_viewer_state_SelectedCell(this, cell).f4, 0);
        var cur = ((x > 0) ? x : 0);
        var next = ((((((((cur + delta) | 0) % $checkIntDivisor(paths.C())) | 0) + paths.C()) | 0) % $checkIntDivisor(paths.C())) | 0);
        this.ee.aH().gC($m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_ElementId.r().C)([cell.bT]))));
        this.pG(cell.bT, paths.l(next));
      }
      return true;
    } else {
      return false;
    }
  }
  if (($m_s_None$() === x62)) {
    return false;
  }
  throw new $c_s_MatchError(x62);
});
$p.aME = (function(cell) {
  var x69 = $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__kindOf__Lorg_jpablo_graphexplorer_viewer_models_NodeId__s_Option(this, cell.bT);
  if ((x69 instanceof $c_s_Some)) {
    var x73 = x69.J;
    var x = this.jJ.xo;
    if (((x === null) ? (x73 === null) : (x === x73))) {
      var this$1 = this.P3(cell.bT);
      if (this$1.c()) {
        var x65 = $m_s_None$();
      } else {
        var x0 = this$1.d();
        var x65 = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$().P1(x0, cell.f4);
      }
      if ((x65 instanceof $c_s_Some)) {
        var x67 = x65.J;
        if ((x67 instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Leaf)) {
          return $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$__unescapeWith__T__Z__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$(), x67.tl, true);
        }
      }
      return "";
    }
    var x$3 = this.jJ.qr;
    if (((x$3 === null) ? (x73 === null) : (x$3 === x73))) {
      var this$3 = $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__htmlTableOf__Lorg_jpablo_graphexplorer_viewer_models_NodeId__s_Option(this, cell.bT);
      if (this$3.c()) {
        var this$5 = $m_s_None$();
      } else {
        var x0$1 = this$3.d();
        var this$4 = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$().Wp(x0$1, cell.f4);
        var this$5 = (this$4.c() ? $m_s_None$() : new $c_s_Some($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$().aYd(this$4.d())));
      }
      return (this$5.c() ? "" : this$5.d());
    }
  }
  if (($m_s_None$() === x69)) {
    return "";
  }
  throw new $c_s_MatchError(x69);
});
$p.aS3 = (function(cell, display) {
  var x74 = $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__kindOf__Lorg_jpablo_graphexplorer_viewer_models_NodeId__s_Option(this, cell.bT);
  if ((x74 instanceof $c_s_Some)) {
    var x78 = x74.J;
    var x = this.jJ.xo;
    if (((x === null) ? (x78 === null) : (x === x78))) {
      var this$1 = this.P3(cell.bT);
      if ((!this$1.c())) {
        var x0 = this$1.d();
        if ($p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__commitRecord__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group__Z(this, cell.bT, $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$().b8N(x0, cell.f4, display))) {
          this.pG(cell.bT, cell.f4);
          return (void 0);
        } else {
          return (void 0);
        }
      } else {
        return (void 0);
      }
    }
    var x$3 = this.jJ.qr;
    if (((x$3 === null) ? (x78 === null) : (x$3 === x78))) {
      var this$2 = $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__htmlTableOf__Lorg_jpablo_graphexplorer_viewer_models_NodeId__s_Option(this, cell.bT);
      if ((!this$2.c())) {
        var x0$1 = this$2.d();
        if ($p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__commitHtml__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Lorg_jpablo_graphexplorer_graphviz_html_HtmlTable__Z(this, cell.bT, $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$().b8B(x0$1, cell.f4, display))) {
          this.pG(cell.bT, cell.f4);
          return (void 0);
        } else {
          return (void 0);
        }
      } else {
        return (void 0);
      }
    }
  }
  if (($m_s_None$() === x74)) {
    return (void 0);
  }
  throw new $c_s_MatchError(x74);
});
$p.aRZ = (function() {
  var this$3 = this.ee.gs.P().aq().d();
  return (this$3.c() ? $m_s_None$() : new $c_s_Some(this$3.d().bT));
});
$p.b8p = (function() {
  return this.ee.gs.P().aq().d();
});
$p.b7Q = (function(cell) {
  $f_Lcom_raquo_airstream_state_Var__set__O__V(this.ee.gs, new $c_s_Some(cell));
});
$p.b8r = (function() {
  var this$3 = this.ee.gs.P().aq().d();
  if (this$3.c()) {
    return $m_s_None$();
  } else {
    var x0 = this$3.d();
    return $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__portOfIn__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_state_SelectedCell__s_Option(this, $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__fullGraphObs__Lcom_raquo_airstream_state_OwnedSignal(this.ee)).d(), x0);
  }
});
$p.aRY = (function(g) {
  var this$3 = this.ee.gs.P().aq().d();
  if (this$3.c()) {
    return $m_s_None$();
  } else {
    var x0 = this$3.d();
    var this$4 = $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__portOfIn__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_state_SelectedCell__s_Option(this, g, x0);
    if (this$4.c()) {
      return $m_s_None$();
    } else {
      var x0$1 = this$4.d();
      var this$6 = new $c_sc_Iterator$$anon$6(g.fX.e6().o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((cell$9$2, port$2) => ((a) => {
        var x = a.bX;
        var x$2 = cell$9$2.bT;
        if ((((x === null) ? (x$2 === null) : x.e(x$2)) && a.iD.E(port$2))) {
          return true;
        } else {
          var x$3 = a.c0;
          var x$4 = cell$9$2.bT;
          if (((x$3 === null) ? (x$4 === null) : x$3.e(x$4))) {
            return a.iE.E(port$2);
          } else {
            return false;
          }
        }
      }))(x0, x0$1)), false);
      return new $c_s_Some($m_sci_Vector$().X(this$6));
    }
  }
});
$p.b8q = (function(g, outgoing) {
  var this$3 = this.ee.gs.P().aq().d();
  if (this$3.c()) {
    return $m_s_None$();
  } else {
    var x0 = this$3.d();
    var this$4 = this.aRY(g);
    if (this$4.c()) {
      return $m_s_None$();
    } else {
      var x0$1 = this$4.d();
      var scoped = x0$1.d8(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((cell$11$2) => ((a) => {
        if (outgoing) {
          var x = a.bX;
          var x$2 = cell$11$2.bT;
          return ((x === null) ? (x$2 === null) : x.e(x$2));
        } else {
          var x$3 = a.c0;
          var x$4 = cell$11$2.bT;
          return ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
        }
      }))(x0)), false);
      return new $c_s_Some(new $c_T2($m_sci_Set$().af(scoped.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$20) => _$20.dw)))), $m_sci_Set$().af(scoped.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((a$2) => (outgoing ? a$2.c0 : a$2.bX)))))));
    }
  }
});
$p.b8s = (function() {
  return $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), $m_Lcom_raquo_airstream_combine_generated_CombinableSignal$().vV(this.ee.gs.P(), this.ee.d4.jI.P(), new $c_Lapp_tulz_tuplez_Composition\uff3fPri0$$anon$1()), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var cellOpt = x$1.g();
    var g = x$1.h();
    return (cellOpt.c() ? $m_s_None$() : $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__portOfIn__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_state_SelectedCell__s_Option(this, g, cellOpt.d()));
  })), $m_s_None$());
});
$p.aYc = (function(cell) {
  return $f_Lcom_raquo_airstream_state_Var__zoomLazy__F1__F2__Lcom_raquo_airstream_state_Var(this.ee.d4.jI, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$24) => $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__readCellAttrs__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_state_SelectedCell__Lorg_jpablo_graphexplorer_viewer_models_AttributeUpdates(this, _$24, cell))), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((g, updates) => $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__writeCellAttrs__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_state_SelectedCell__Lorg_jpablo_graphexplorer_viewer_models_AttributeUpdates__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(this, g, cell, updates))));
});
$p.aPm = (function(after) {
  var this$3 = this.ee.gs.P().aq().d();
  if ((!this$3.c())) {
    var x0 = this$3.d();
    var this$4 = $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__kindOf__Lorg_jpablo_graphexplorer_viewer_models_NodeId__s_Option(this, x0.bT);
    if ((!this$4.c())) {
      var x0$1 = this$4.d();
      var x0$2 = $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__clamped__Lorg_jpablo_graphexplorer_viewer_state_SelectedCell__Lorg_jpablo_graphexplorer_viewer_state_SelectedCell(this, x0);
      matchResult31: {
        var x = this.jJ.xo;
        if (((x === null) ? (x0$1 === null) : (x === x0$1))) {
          var this$5 = this.P3(x0$2.bT);
          if ((!this$5.c())) {
            var x0$3 = this$5.d();
            matchResult30: {
              var \u03b41$___1;
              var \u03b41$___2;
              var x88 = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$().b2W(x0$3, x0$2.f4, after);
              if ((x88 !== null)) {
                var \u03b41$___1 = x88.g();
                var \u03b41$___2 = x88.h();
                break matchResult30;
              }
              throw new $c_s_MatchError(x88);
            }
            var newRoot$2 = \u03b41$___1;
            var newPath$2 = \u03b41$___2;
            if ($p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__commitRecord__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group__Z(this, x0$2.bT, newRoot$2)) {
              this.pG(x0$2.bT, newPath$2);
              break matchResult31;
            } else {
              break matchResult31;
            }
          } else {
            break matchResult31;
          }
        }
        var x$3 = this.jJ.qr;
        if (((x$3 === null) ? (x0$1 === null) : (x$3 === x0$1))) {
          var this$7 = $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__htmlTableOf__Lorg_jpablo_graphexplorer_viewer_models_NodeId__s_Option(this, x0$2.bT);
          if ((!this$7.c())) {
            var x0$4 = this$7.d();
            var this$8 = x0$2.f4.dt();
            if ((!this$8.c())) {
              var x0$5 = this$8.d();
              var r = (x0$5 | 0);
              var this$11 = new $c_s_PartialFunction$Lifted(x0$2.f4).as(1);
              if ((!this$11.c())) {
                var x0$6 = this$11.d();
                var c = (x0$6 | 0);
                var at = (after ? ((1 + c) | 0) : c);
                var \u03b44$___1 = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$().b2U(x0$4, at);
                var \u03b44$___2 = new $c_sci_$colon$colon(r, new $c_sci_$colon$colon(at, $m_sci_Nil$()));
                var newTbl$2 = \u03b44$___1;
                var newPath$2$1 = \u03b44$___2;
                if ($p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__commitHtml__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Lorg_jpablo_graphexplorer_graphviz_html_HtmlTable__Z(this, x0$2.bT, newTbl$2)) {
                  this.pG(x0$2.bT, newPath$2$1);
                  break matchResult31;
                } else {
                  break matchResult31;
                }
              } else {
                break matchResult31;
              }
            } else {
              break matchResult31;
            }
          } else {
            break matchResult31;
          }
        }
        throw new $c_s_MatchError(x0$1);
      }
    }
  }
});
$p.aPl = (function(below) {
  var this$3 = this.ee.gs.P().aq().d();
  if ((!this$3.c())) {
    var x0 = this$3.d();
    var this$4 = $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__kindOf__Lorg_jpablo_graphexplorer_viewer_models_NodeId__s_Option(this, x0.bT);
    if ((!this$4.c())) {
      var x0$1 = this$4.d();
      var x0$2 = $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__clamped__Lorg_jpablo_graphexplorer_viewer_state_SelectedCell__Lorg_jpablo_graphexplorer_viewer_state_SelectedCell(this, x0);
      var x$2 = this.jJ.qr;
      if (((x0$1 === null) ? (x$2 === null) : (x0$1 === x$2))) {
        var this$5 = $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__htmlTableOf__Lorg_jpablo_graphexplorer_viewer_models_NodeId__s_Option(this, x0$2.bT);
        if ((!this$5.c())) {
          var x0$3 = this$5.d();
          var this$6 = x0$2.f4.dt();
          if ((!this$6.c())) {
            var x0$4 = this$6.d();
            var r = (x0$4 | 0);
            var this$9 = new $c_s_PartialFunction$Lifted(x0$2.f4).as(1);
            if ((!this$9.c())) {
              var x0$5 = this$9.d();
              var c = (x0$5 | 0);
              var at = (below ? ((1 + r) | 0) : r);
              var \u03b44$___1 = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$().b2V(x0$3, at);
              var \u03b44$___2 = new $c_sci_$colon$colon(at, new $c_sci_$colon$colon(c, $m_sci_Nil$()));
              var newTbl$2 = \u03b44$___1;
              var newPath$2 = \u03b44$___2;
              if ($p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__commitHtml__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Lorg_jpablo_graphexplorer_graphviz_html_HtmlTable__Z(this, x0$2.bT, newTbl$2)) {
                this.pG(x0$2.bT, newPath$2);
              }
            }
          }
        }
      }
    }
  }
});
$p.aZM = (function() {
  var this$3 = this.ee.gs.P().aq().d();
  if ((!this$3.c())) {
    var x0 = this$3.d();
    var this$4 = $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__kindOf__Lorg_jpablo_graphexplorer_viewer_models_NodeId__s_Option(this, x0.bT);
    if ((!this$4.c())) {
      var x0$1 = this$4.d();
      var x0$2 = $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__clamped__Lorg_jpablo_graphexplorer_viewer_state_SelectedCell__Lorg_jpablo_graphexplorer_viewer_state_SelectedCell(this, x0);
      var x$2 = this.jJ.qr;
      if (((x0$1 === null) ? (x$2 === null) : (x0$1 === x$2))) {
        var this$5 = $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__htmlTableOf__Lorg_jpablo_graphexplorer_viewer_models_NodeId__s_Option(this, x0$2.bT);
        if ((!this$5.c())) {
          var x0$3 = this$5.d();
          var this$6 = x0$2.f4.dt();
          if ((!this$6.c())) {
            var x0$4 = this$6.d();
            var r = (x0$4 | 0);
            var this$9 = new $c_s_PartialFunction$Lifted(x0$2.f4).as(1);
            if ((!this$9.c())) {
              var x0$5 = this$9.d();
              var c = (x0$5 | 0);
              var newTbl = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$().aZN(x0$3, r);
              var \u03b44$___1 = newTbl;
              var \u03b44$___2 = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$().ah4(newTbl, new $c_sci_$colon$colon(r, new $c_sci_$colon$colon(c, $m_sci_Nil$())));
              var newTbl$2 = \u03b44$___1;
              var newPath$2 = \u03b44$___2;
              if ($p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__commitHtml__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Lorg_jpablo_graphexplorer_graphviz_html_HtmlTable__Z(this, x0$2.bT, newTbl$2)) {
                this.pG(x0$2.bT, newPath$2);
              }
            }
          }
        }
      }
    }
  }
});
$p.aZL = (function() {
  var this$3 = this.ee.gs.P().aq().d();
  if ((!this$3.c())) {
    var x0 = this$3.d();
    var this$4 = $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__kindOf__Lorg_jpablo_graphexplorer_viewer_models_NodeId__s_Option(this, x0.bT);
    if ((!this$4.c())) {
      var x0$1 = this$4.d();
      var x0$2 = $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__clamped__Lorg_jpablo_graphexplorer_viewer_state_SelectedCell__Lorg_jpablo_graphexplorer_viewer_state_SelectedCell(this, x0);
      var x$2 = this.jJ.qr;
      if (((x0$1 === null) ? (x$2 === null) : (x0$1 === x$2))) {
        var this$5 = $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__htmlTableOf__Lorg_jpablo_graphexplorer_viewer_models_NodeId__s_Option(this, x0$2.bT);
        if ((!this$5.c())) {
          var x0$3 = this$5.d();
          var this$6 = x0$2.f4.dt();
          if ((!this$6.c())) {
            var x0$4 = this$6.d();
            var r = (x0$4 | 0);
            var this$9 = new $c_s_PartialFunction$Lifted(x0$2.f4).as(1);
            if ((!this$9.c())) {
              var x0$5 = this$9.d();
              var c = (x0$5 | 0);
              var newTbl = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$().aZK(x0$3, c);
              var \u03b44$___1 = newTbl;
              var \u03b44$___2 = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabelOps$().ah4(newTbl, new $c_sci_$colon$colon(r, new $c_sci_$colon$colon(c, $m_sci_Nil$())));
              var newTbl$2 = \u03b44$___1;
              var newPath$2 = \u03b44$___2;
              if ($p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__commitHtml__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Lorg_jpablo_graphexplorer_graphviz_html_HtmlTable__Z(this, x0$2.bT, newTbl$2)) {
                this.pG(x0$2.bT, newPath$2);
              }
            }
          }
        }
      }
    }
  }
});
$p.b9k = (function() {
  var this$3 = this.ee.gs.P().aq().d();
  if ((!this$3.c())) {
    var x0 = this$3.d();
    var this$4 = $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__kindOf__Lorg_jpablo_graphexplorer_viewer_models_NodeId__s_Option(this, x0.bT);
    if ((!this$4.c())) {
      var x0$1 = this$4.d();
      var x0$2 = $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__clamped__Lorg_jpablo_graphexplorer_viewer_state_SelectedCell__Lorg_jpablo_graphexplorer_viewer_state_SelectedCell(this, x0);
      var x$2 = this.jJ.xo;
      if (((x0$1 === null) ? (x$2 === null) : (x0$1 === x$2))) {
        var this$5 = this.P3(x0$2.bT);
        if ((!this$5.c())) {
          var x0$3 = this$5.d();
          matchResult32: {
            var \u03b42$___1;
            var \u03b42$___2;
            var x92 = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$().b9h(x0$3, x0$2.f4);
            if ((x92 !== null)) {
              var \u03b42$___1 = x92.g();
              var \u03b42$___2 = x92.h();
              break matchResult32;
            }
            throw new $c_s_MatchError(x92);
          }
          var newRoot$2 = \u03b42$___1;
          var newPath$2 = \u03b42$___2;
          if ($p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__commitRecord__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group__Z(this, x0$2.bT, newRoot$2)) {
            this.pG(x0$2.bT, newPath$2);
          }
        }
      }
    }
  }
});
$p.aRz = (function() {
  var x99 = this.ee.gs.P().aq().d();
  if ((x99 instanceof $c_s_Some)) {
    var this$5 = this.ee.gs.P().aq().d();
    if ((!this$5.c())) {
      var x0 = this$5.d();
      var this$6 = $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__kindOf__Lorg_jpablo_graphexplorer_viewer_models_NodeId__s_Option(this, x0.bT);
      if ((!this$6.c())) {
        var x0$1 = this$6.d();
        var x0$2 = $p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__clamped__Lorg_jpablo_graphexplorer_viewer_state_SelectedCell__Lorg_jpablo_graphexplorer_viewer_state_SelectedCell(this, x0);
        matchResult34: {
          var x = this.jJ.xo;
          if (((x === null) ? (x0$1 === null) : (x === x0$1))) {
            var this$7 = this.P3(x0$2.bT);
            if ((!this$7.c())) {
              var x0$3 = this$7.d();
              matchResult33: {
                var \u03b43$___1;
                var \u03b43$___2;
                var x95 = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$().b7s(x0$3, x0$2.f4);
                if ((x95 !== null)) {
                  var \u03b43$___1 = x95.g();
                  var \u03b43$___2 = x95.h();
                  break matchResult33;
                }
                throw new $c_s_MatchError(x95);
              }
              var newRoot$2 = \u03b43$___1;
              var newPath$2 = \u03b43$___2;
              if ($p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__commitRecord__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group__Z(this, x0$2.bT, newRoot$2)) {
                this.pG(x0$2.bT, newPath$2);
                break matchResult34;
              } else {
                break matchResult34;
              }
            } else {
              break matchResult34;
            }
          }
          var x$3 = this.jJ.qr;
          if (((x$3 === null) ? (x0$1 === null) : (x$3 === x0$1))) {
            this.aS3($p_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__clamped__Lorg_jpablo_graphexplorer_viewer_state_SelectedCell__Lorg_jpablo_graphexplorer_viewer_state_SelectedCell(this, x0$2), "");
            break matchResult34;
          }
          throw new $c_s_MatchError(x0$1);
        }
      }
    }
    return true;
  }
  if (($m_s_None$() === x99)) {
    return false;
  }
  throw new $c_s_MatchError(x99);
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$, "org.jpablo.graphexplorer.viewer.state.RecordCellOps$recordCells$", ({
  Eo: 1
}));
function $f_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps__$init$__V($thiz) {
  $thiz.xr = $m_Lcom_raquo_airstream_state_Var$().bx($m_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint$().Hd);
  $thiz.zD = $m_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint$().Hd;
  $thiz.N3 = $m_s_None$();
  $thiz.U0 = 0.0;
  $thiz.zE = $m_Lcom_raquo_airstream_state_Var$().bx(1.0);
  $thiz.abn = 0.05;
  $thiz.aGG = 20.0;
  $thiz.abm = 0.01;
  $thiz.xq = $m_Lcom_raquo_airstream_state_Var$().bx(false);
  $thiz.a11 = ($m_Lcom_raquo_laminar_api_package$(), new $c_Lcom_raquo_airstream_eventbus_EventBus());
  $thiz.aGT = $m_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$().li($thiz.zE.P(), $thiz.xr.P(), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((z, p) => (((((("scale(" + (+z)) + ") translate(") + p.gI) + " ") + p.gJ) + ")"))));
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps__autoFitToggle__V($thiz) {
  $f_Lcom_raquo_airstream_state_Var__update__F1__V($thiz.xq, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => (!(!(!_$1))))));
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps__zoomOut__V($thiz) {
  $f_Lcom_raquo_airstream_state_Var__update__F1__V($thiz.zE, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => {
    var _$2$1 = (+_$2);
    var x = (0.9 * _$2$1);
    var that = $thiz.abn;
    return (+Math.max(x, that));
  })));
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps__zoomIn__V($thiz) {
  $f_Lcom_raquo_airstream_state_Var__update__F1__V($thiz.zE, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3) => (1.1 * (+_$3)))));
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps__panBy__Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint__V($thiz, delta) {
  $thiz.zD = $m_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint$().aLj($thiz.zD, delta);
  if ($thiz.N3.c()) {
    $thiz.U0 = 0.0;
    $p_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps__requestPanFrame__V($thiz);
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps__snapPan__Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint__V($thiz, p) {
  $p_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps__cancelPanChase__V($thiz);
  $thiz.zD = p;
  $f_Lcom_raquo_airstream_state_Var__set__O__V($thiz.xr, p);
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps__requestPanFrame__V($thiz) {
  $thiz.N3 = new $c_s_Some((window.requestAnimationFrame(((_$4) => {
    $p_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps__stepPan__D__V($thiz, (+_$4));
  })) | 0));
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps__cancelPanChase__V($thiz) {
  var this$1 = $thiz.N3;
  if ((!this$1.c())) {
    var x0 = this$1.d();
    var handle = (x0 | 0);
    window.cancelAnimationFrame(handle);
  }
  $thiz.N3 = $m_s_None$();
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps__stepPan__D__V($thiz, nowMs) {
  var dtMs = (($thiz.U0 === 0.0) ? 16.7 : (nowMs - $thiz.U0));
  $thiz.U0 = nowMs;
  var cur = $thiz.xr.P().aq().d();
  var dx = ($thiz.zD.gI - cur.gI);
  var dy = ($thiz.zD.gJ - cur.gJ);
  if ((((+Math.abs(dx)) < $thiz.abm) && ((+Math.abs(dy)) < $thiz.abm))) {
    $thiz.N3 = $m_s_None$();
    if (((dx !== 0.0) || (dy !== 0.0))) {
      $f_Lcom_raquo_airstream_state_Var__set__O__V($thiz.xr, $thiz.zD);
    }
  } else {
    var x = ((-dtMs) / $thiz.aGG);
    var alpha = (1.0 - (+Math.exp(x)));
    $f_Lcom_raquo_airstream_state_Var__set__O__V($thiz.xr, ($m_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint$(), new $c_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint((cur.gI + (dx * alpha)), (cur.gJ + (dy * alpha)))));
    $p_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps__requestPanFrame__V($thiz);
  }
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps__resetView__V($thiz) {
  $p_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps__cancelPanChase__V($thiz);
  $thiz.zD = $m_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint$().Hd;
  $m_Lcom_raquo_airstream_state_Var$().Y1($m_sr_ScalaRunTime$().hP(new ($d_Lcom_raquo_airstream_state_Var$VarTuple.r().C)([new $c_Lcom_raquo_airstream_state_Var$VarTuple(new $c_T2($thiz.zE, 0.9)), new $c_Lcom_raquo_airstream_state_Var$VarTuple(new $c_T2($thiz.xr, $m_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint$().Hd))])));
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps__panCompensateClient__D__D__D__D__V($thiz, dx, dy, scaleX, scaleY) {
  if (((scaleX > 0.0) && (scaleY > 0.0))) {
    $p_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps__snapPan__Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint__V($thiz, $m_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint$().aLj($thiz.xr.P().aq().d(), ($m_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint$(), new $c_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint((dx / scaleX), (dy / scaleY)))));
  }
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps__panByClient__D__D__Lorg_scalajs_dom_SVGRect__V($thiz, dx, dy, viewBox) {
  var x = (+window.innerHeight);
  var clientHeight = (+Math.max(x, 1.0));
  var x$1 = (+window.innerWidth);
  var clientWidth = (+Math.max(x$1, 1.0));
  var z = (+$thiz.zE.P().aq().d());
  var x$2 = ((+viewBox.width) / clientWidth);
  var that = ((+viewBox.height) / clientHeight);
  var scale = (+Math.max(x$2, that));
  $p_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps__panBy__Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint__V($thiz, ($m_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint$(), new $c_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint(((dx * scale) / z), ((dy * scale) / z))));
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps__handleWheel__Lorg_scalajs_dom_WheelEvent__Lorg_scalajs_dom_SVGRect__Lorg_scalajs_dom_SVGGElement__V($thiz, wEv, viewBox, mainGroup) {
  var x = (+window.innerHeight);
  var clientHeight = (+Math.max(x, 1.0));
  var x$1 = (+window.innerWidth);
  var clientWidth = (+Math.max(x$1, 1.0));
  if (((!(!wEv.metaKey)) && ((+wEv.deltaY) !== 0.0))) {
    var oldZoom = (+$thiz.zE.P().aq().d());
    var x$2 = (oldZoom - ((+wEv.deltaY) / clientHeight));
    var that = $thiz.abn;
    var newZoom = (+Math.max(x$2, that));
    if ((newZoom !== oldZoom)) {
      var this$15 = $m_s_Option$().as(mainGroup.getScreenCTM());
      if ((!this$15.c())) {
        var x0 = this$15.d();
        var anchor = $m_Lorg_jpablo_graphexplorer_viewer_components_SvgElementOps$package$().Q5(new $c_Lorg_jpablo_graphexplorer_viewer_utils_ClientPoint((+wEv.clientX), (+wEv.clientY)), x0);
        var origin = $m_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps$().bat(mainGroup);
        $p_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps__cancelPanChase__V($thiz);
        var pan = $m_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps$().aWW($thiz.xr.P().aq().d(), anchor, origin, oldZoom, newZoom);
        $thiz.zD = pan;
        $m_Lcom_raquo_airstream_state_Var$().Y1($m_sr_ScalaRunTime$().hP(new ($d_Lcom_raquo_airstream_state_Var$VarTuple.r().C)([new $c_Lcom_raquo_airstream_state_Var$VarTuple(new $c_T2($thiz.zE, newZoom)), new $c_Lcom_raquo_airstream_state_Var$VarTuple(new $c_T2($thiz.xr, pan))])));
      }
    }
  } else {
    var z = (+$thiz.zE.P().aq().d());
    var x$4 = ((+viewBox.width) / clientWidth);
    var that$1 = ((+viewBox.height) / clientHeight);
    var scale = (+Math.max(x$4, that$1));
    $p_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps__panBy__Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint__V($thiz, ($m_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint$(), new $c_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint((((+wEv.deltaX) * scale) / z), (((+wEv.deltaY) * scale) / z))));
  }
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps$.prototype = $p;
$p.aWW = (function(currentPan, anchor, origin, oldZoom, newZoom) {
  var ratio = (oldZoom / newZoom);
  $m_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint$();
  return new $c_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint((((((anchor.gI + currentPan.gI) - origin.gI) * ratio) - anchor.gI) + origin.gI), (((((anchor.gJ + currentPan.gJ) - origin.gJ) * ratio) - anchor.gJ) + origin.gJ));
});
$p.bat = (function(group) {
  var xs = $f_T__split__T__I__AT(window.getComputedStyle(group).transformOrigin, " ", 0);
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var i = 0;
  while ((i < xs.a.length)) {
    var x1 = i;
    var x0 = xs.a[x1];
    var x = $m_sc_StringOps$().wh(x0, "px");
    var this$10 = $m_sc_StringParsers$();
    var elems = (this$10.c1(x) ? new $c_s_Some($m_jl_Double$().bd(x)) : $m_s_None$());
    var it = elems.o();
    while (it.p()) {
      var elem = it.q();
      var unboxedElem = ((elem === null) ? 0.0 : elem);
      jsElems.push(unboxedElem);
    }
    i = ((1 + i) | 0);
  }
  var values = new $ac_D(new Float64Array(jsElems));
  $m_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint$();
  var this$12 = $m_sc_ArrayOps$().X7(values);
  var $x_1 = (this$12.c() ? 0.0 : this$12.d());
  var this$15 = $m_sc_ArrayOps$().X7($m_sc_ArrayOps$().aNB(values, 1));
  return new $c_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint((+$x_1), (+(this$15.c() ? 0.0 : this$15.d())));
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps$, "org.jpablo.graphexplorer.viewer.state.SvgTransformOps$", ({
  Ew: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps$;
function $m_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps$ = new $c_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailDiskCache$__db__s_concurrent_Future($thiz) {
  var x1 = $thiz.abd;
  if ((x1 instanceof $c_s_Some)) {
    return x1.J;
  }
  if (($m_s_None$() === x1)) {
    var f$2 = $p_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailDiskCache$__openDb__s_concurrent_Future($thiz);
    $thiz.abd = new $c_s_Some(f$2);
    return f$2;
  }
  throw new $c_s_MatchError(x1);
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailDiskCache$__openDb__s_concurrent_Future($thiz) {
  var idb = window.indexedDB;
  if (((idb === (void 0)) || (idb === null))) {
    return $m_s_concurrent_Future$().m4($m_s_None$());
  } else {
    var p = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
    try {
      var req = idb.open("graph-explorer-thumbnails", 1);
      req.onupgradeneeded = ((_$1) => {
        var database = req.result;
        if ((!(!(!database.objectStoreNames.contains("thumbs"))))) {
          var store = database.createObjectStore("thumbs", $m_sjs_js_special_package$().eA($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("keyPath", "k")]))));
          store.createIndex("at", "at", $m_sjs_js_special_package$().eA($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("unique", false)]))));
        }
      });
      req.onsuccess = ((_$2) => {
        $f_s_concurrent_Promise__trySuccess__O__Z(p, new $c_s_Some(req.result));
      });
      req.onerror = ((_$3) => {
        $f_s_concurrent_Promise__trySuccess__O__Z(p, $m_s_None$());
      });
      req.onblocked = ((_$4) => {
        $f_s_concurrent_Promise__trySuccess__O__Z(p, $m_s_None$());
      });
    } catch (e) {
      $f_s_concurrent_Promise__trySuccess__O__Z(p, $m_s_None$());
    }
    return p;
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailDiskCache$__evict__sjs_js_Dynamic__V($thiz, database) {
  try {
    var store = database.transaction("thumbs", "readwrite").objectStore("thumbs");
    var countRq = store.count();
    countRq.onsuccess = ((_$8) => {
      var remaining = new $c_sr_IntRef((((countRq.result | 0) - 128) | 0));
      if ((remaining.an > 0)) {
        var cursorRq = store.index("at").openCursor();
        cursorRq.onsuccess = ((_$9) => {
          var cursor = cursorRq.result;
          if ((((cursor !== (void 0)) && (cursor !== null)) && (remaining.an > 0))) {
            cursor.delete();
            remaining.an = ((remaining.an - 1) | 0);
            cursor.continue();
          }
        });
      }
    });
  } catch (e) {
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailDiskCache$__keyFor__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat__T__T($thiz, format, source) {
  return ((((format.m() + ":") + $m_s_util_hashing_MurmurHash3$().aSu(source, (-137723950))) + ":") + source.length);
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailDiskCache$() {
  this.aUU = null;
  this.aUW = null;
  this.aUX = null;
  this.aUV = 0;
  this.abd = null;
  $n_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailDiskCache$ = this;
  this.aUU = "graph-explorer-thumbnails";
  this.aUW = "thumbs";
  this.aUX = "at";
  this.aUV = 128;
  this.abd = $m_s_None$();
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailDiskCache$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailDiskCache$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailDiskCache$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailDiskCache$.prototype = $p;
$p.b20 = (function(format, source) {
  return $p_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailDiskCache$__db__s_concurrent_Future(this).IX(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    if (($m_s_None$() === x$1)) {
      return $m_s_concurrent_Future$().m4($m_s_None$());
    }
    if ((x$1 instanceof $c_s_Some)) {
      var database = x$1.J;
      var p = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
      try {
        var req = database.transaction("thumbs", "readonly").objectStore("thumbs").get($p_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailDiskCache$__keyFor__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat__T__T($m_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailDiskCache$(), format, source));
        req.onsuccess = ((_$5) => {
          var rec = req.result;
          $f_s_concurrent_Promise__trySuccess__O__Z(p, (((rec === (void 0)) || (rec === null)) ? $m_s_None$() : ((rec.source === source) ? $m_s_Option$().as(rec.svg) : $m_s_None$())));
        });
        req.onerror = ((_$6) => {
          $f_s_concurrent_Promise__trySuccess__O__Z(p, $m_s_None$());
        });
      } catch (e) {
        $f_s_concurrent_Promise__trySuccess__O__Z(p, $m_s_None$());
      }
      return p;
    }
    throw new $c_s_MatchError(x$1);
  })), $m_s_concurrent_ExecutionContext$().ek()).AC(new $c_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailDiskCache$$anon$1(), $m_s_concurrent_ExecutionContext$().ek());
});
$p.b72 = (function(format, source, svgHtml) {
  $p_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailDiskCache$__db__s_concurrent_Future(this).oB(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    matchResult5: {
      if (($m_s_None$() === x$1)) {
        break matchResult5;
      }
      if ((x$1 instanceof $c_s_Some)) {
        var database = x$1.J;
        try {
          var tx = database.transaction("thumbs", "readwrite");
          tx.objectStore("thumbs").put($m_sjs_js_special_package$().eA($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("k", $p_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailDiskCache$__keyFor__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat__T__T($m_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailDiskCache$(), format, source)), new $c_T2("source", source), new $c_T2("svg", svgHtml), new $c_T2("at", (+Date.now()))]))));
          tx.oncomplete = ((_$7) => {
            $p_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailDiskCache$__evict__sjs_js_Dynamic__V($m_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailDiskCache$(), database);
          });
          break matchResult5;
        } catch (e) {
          break matchResult5;
        }
      }
      throw new $c_s_MatchError(x$1);
    }
  })), $m_s_concurrent_ExecutionContext$().ek());
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailDiskCache$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailDiskCache$, "org.jpablo.graphexplorer.viewer.state.ThumbnailDiskCache$", ({
  Ex: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailDiskCache$;
function $m_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailDiskCache$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailDiskCache$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailDiskCache$ = new $c_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailDiskCache$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailDiskCache$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$__onIdle__F0__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, thunk, x$2) {
  var p = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
  var w = window;
  var run = (() => {
    $f_s_concurrent_Promise__complete__s_util_Try__s_concurrent_Promise(p, $m_s_util_Try$().aM9(thunk));
  });
  if (((typeof w.requestIdleCallback) === "function")) {
    w.requestIdleCallback(run, $m_sjs_js_special_package$().eA($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("timeout", 400)]))));
  } else {
    (window.setTimeout(run, 0.0) | 0);
  }
  return p;
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$__skeletonSvg__Lcom_raquo_laminar_nodes_ReactiveSvgElement($thiz) {
  return $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("skeleton"), $m_Lcom_raquo_laminar_api_package$().b.j().bh().n("100"), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n("100")])));
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$__log$1__sci_Seq__T__sci_Seq__V($thiz, telemetryContext$1, name, extra) {
  $m_Lorg_jpablo_graphexplorer_viewer_telemetry_Telemetry$().r7(name, telemetryContext$1.gU(extra));
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$__cacheFields$1__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat__sci_Seq($thiz, format$1) {
  return new $c_sci_$colon$colon(new $c_T2("format", format$1.m()), new $c_sci_$colon$colon(new $c_T2("cacheSize", $m_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$().aa()), $m_sci_Nil$()));
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$__adopt$1__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat__Lorg_jpablo_graphexplorer_viewer_formats_dot_DotText__sci_Seq__T__Lcom_raquo_laminar_nodes_ReactiveSvgElement($thiz, format$2, dot$1, telemetryContext$2, svgHtml) {
  var proto = $m_Lorg_jpablo_graphexplorer_viewer_domUtils_SvgParser$package$().XH(svgHtml).e8;
  $m_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$().b73(format$2, dot$1.o6, proto);
  $p_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$__log$1__sci_Seq__T__sci_Seq__V($thiz, telemetryContext$2, "thumb.cache.store", $p_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$__cacheFields$1__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat__sci_Seq($thiz, format$2));
  return $m_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$().aMJ(proto);
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$__renderDot$1__Lorg_jpablo_graphexplorer_viewer_backends_graphviz_Graphviz__Lorg_jpablo_graphexplorer_viewer_formats_dot_DotText__s_concurrent_ExecutionContext__sci_Seq__D__s_concurrent_Future($thiz, graphviz$1, dot$2, x$4$1, telemetryContext$3, startedAt) {
  return $p_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$__onIdle__F0__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    var svgStartedAt = $m_Lorg_jpablo_graphexplorer_viewer_telemetry_Telemetry$().uc();
    var resultTry = graphviz$1.b9U(dot$2);
    $p_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$__log$1__sci_Seq__T__sci_Seq__V($thiz, telemetryContext$3, "thumb.dot.textToSvg", $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("dtMs", ($m_Lorg_jpablo_graphexplorer_viewer_telemetry_Telemetry$().uc() - svgStartedAt)), new $c_T2("ok", resultTry.Xe())])));
    $p_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$__log$1__sci_Seq__T__sci_Seq__V($thiz, telemetryContext$3, "thumb.dot.total", $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("dtMs", ($m_Lorg_jpablo_graphexplorer_viewer_telemetry_Telemetry$().uc() - startedAt)), new $c_T2("ok", resultTry.Xe())])));
    return resultTry.d().outerHTML;
  })), x$4$1);
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$__renderMermaid$1__Lorg_jpablo_graphexplorer_viewer_formats_dot_DotText__s_concurrent_ExecutionContext__sci_Seq__D__s_concurrent_Future($thiz, dot$4, x$4$2, telemetryContext$5, startedAt) {
  $p_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$__log$1__sci_Seq__T__sci_Seq__V($thiz, telemetryContext$5, "thumb.mermaid.start", $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("sourceChars", dot$4.o6.length)])));
  return $p_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$__onIdle__F0__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((backend) => (() => backend.aSM(dot$4.o6)))(($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$(), new $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend(x$4$2)))), x$4$2).IX(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x) => x)), x$4$2).jX(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((r) => {
    $p_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$__log$1__sci_Seq__T__sci_Seq__V($thiz, telemetryContext$5, "thumb.mermaid.done", $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("dtMs", ($m_Lorg_jpablo_graphexplorer_viewer_telemetry_Telemetry$().uc() - startedAt)), new $c_T2("ok", true)])));
    return r.Lr.e8.outerHTML;
  })), x$4$2);
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$() {
  this.aUY = 0;
  this.aUY = 400;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$.prototype = $p;
$p.aRa = (function(graphviz, dot, telemetryContext, x$4) {
  var format = $m_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$().Pg(dot.o6);
  var x8 = $m_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$().b1Z(format, dot.o6);
  if ((x8 instanceof $c_s_Some)) {
    var proto = x8.J;
    $p_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$__log$1__sci_Seq__T__sci_Seq__V(this, telemetryContext, "thumb.cache.hit", $p_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$__cacheFields$1__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat__sci_Seq(this, format));
    return $m_Lcom_raquo_airstream_state_Val$().iT($m_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$().aMJ(proto));
  }
  if (($m_s_None$() === x8)) {
    $p_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$__log$1__sci_Seq__T__sci_Seq__V(this, telemetryContext, "thumb.cache.miss", $p_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$__cacheFields$1__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat__sci_Seq(this, format));
    var startedAt = $m_Lorg_jpablo_graphexplorer_viewer_telemetry_Telemetry$().uc();
    var html = $m_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailDiskCache$().b20(format, dot.o6).IX(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
      if ((x$1 instanceof $c_s_Some)) {
        var stored = x$1.J;
        $p_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$__log$1__sci_Seq__T__sci_Seq__V(this, telemetryContext, "thumb.disk.hit", $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("format", format.m()), new $c_T2("bytes", stored.length)])));
        return $m_s_concurrent_Future$().m4(stored);
      }
      if (($m_s_None$() === x$1)) {
        $p_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$__log$1__sci_Seq__T__sci_Seq__V(this, telemetryContext, "thumb.disk.miss", $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("format", format.m())])));
        matchResult1: {
          var rendered;
          var x$3 = $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__DOT__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat();
          if (((x$3 === null) ? (format === null) : (x$3 === format))) {
            var rendered = $p_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$__renderDot$1__Lorg_jpablo_graphexplorer_viewer_backends_graphviz_Graphviz__Lorg_jpablo_graphexplorer_viewer_formats_dot_DotText__s_concurrent_ExecutionContext__sci_Seq__D__s_concurrent_Future(this, graphviz, dot, x$4, telemetryContext, startedAt);
            break matchResult1;
          }
          var x$5 = $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__Mermaid__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat();
          if (((x$5 === null) ? (format === null) : (x$5 === format))) {
            var rendered = $p_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$__renderMermaid$1__Lorg_jpablo_graphexplorer_viewer_formats_dot_DotText__s_concurrent_ExecutionContext__sci_Seq__D__s_concurrent_Future(this, dot, x$4, telemetryContext, startedAt);
            break matchResult1;
          }
          throw new $c_s_MatchError(format);
        }
        rendered.oB(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => {
          $m_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailDiskCache$().b72(format, dot.o6, _$1);
        })), x$4);
        return rendered;
      }
      throw new $c_s_MatchError(x$1);
    })), x$4);
    matchResult5: {
      var safe;
      var x$3$1 = $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__Mermaid__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat();
      if (((x$3$1 === null) ? (format === null) : (x$3$1 === format))) {
        var safe = html.jX(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((svgHtml) => $p_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$__adopt$1__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat__Lorg_jpablo_graphexplorer_viewer_formats_dot_DotText__sci_Seq__T__Lcom_raquo_laminar_nodes_ReactiveSvgElement(this, format, dot, telemetryContext, svgHtml))), x$4).AC(new $c_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$$anon$1(), x$4);
        break matchResult5;
      }
      var x$6 = $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__DOT__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat();
      if (((x$6 === null) ? (format === null) : (x$6 === format))) {
        var safe = html.jX(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((svgHtml$2) => $p_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$__adopt$1__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat__Lorg_jpablo_graphexplorer_viewer_formats_dot_DotText__sci_Seq__T__Lcom_raquo_laminar_nodes_ReactiveSvgElement(this, format, dot, telemetryContext, svgHtml$2))), x$4);
        break matchResult5;
      }
      throw new $c_s_MatchError(format);
    }
    return $f_Lcom_raquo_airstream_core_EventStream__toSignal__F0__Z__Lcom_raquo_airstream_core_Signal(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_airstream_core_EventStream$()).aOB(safe, false, x$4), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $p_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$__skeletonSvg__Lcom_raquo_laminar_nodes_ReactiveSvgElement($m_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$()))), false);
  }
  throw new $c_s_MatchError(x8);
});
$p.b6c = (function() {
  return $m_Lcom_raquo_laminar_api_package$().b.j().bo().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().bh().n("100"), $m_Lcom_raquo_laminar_api_package$().b.j().bg().n("100"), $m_Lcom_raquo_laminar_api_package$().b.j().a4U().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().Eq().n("50"), $m_Lcom_raquo_laminar_api_package$().b.j().Er().n("50"), $m_Lcom_raquo_laminar_api_package$().b.j().a4V().n("middle"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "No preview", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$, "org.jpablo.graphexplorer.viewer.state.ThumbnailRenderer$", ({
  Ez: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$;
function $m_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$ = new $c_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$__keyFor__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat__T__Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$Key($thiz, format, source) {
  return new $c_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$Key(format, $m_s_util_hashing_MurmurHash3$().aSu(source, (-137723950)), source.length);
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$__touch__Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$Key__Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$Entry__V($thiz, key, entry) {
  $thiz.CC.AD(key);
  $thiz.CC.ue(key, entry);
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$__evictIfNeeded__V($thiz) {
  while (($thiz.CC.e0 > $thiz.aG1)) {
    $thiz.CC.AD($thiz.CC.agp().g());
  }
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$() {
  this.aG1 = 0;
  this.CC = null;
  $n_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$ = this;
  this.aG1 = 64;
  this.CC = new $c_scm_LinkedHashMap();
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$.prototype = $p;
$p.aa = (function() {
  return this.CC.e0;
});
$p.b1Z = (function(format, source) {
  var key = $p_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$__keyFor__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat__T__Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$Key(this, format, source);
  var this$1 = this.CC.r(key);
  var this$2 = ((this$1.c() || (this$1.d().TO === source)) ? this$1 : $m_s_None$());
  if (this$2.c()) {
    return $m_s_None$();
  } else {
    var x0$1 = this$2.d();
    $p_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$__touch__Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$Key__Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$Entry__V($m_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$(), key, x0$1);
    return new $c_s_Some(x0$1.TN);
  }
});
$p.b73 = (function(format, source, proto) {
  $p_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$__touch__Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$Key__Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$Entry__V(this, $p_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$__keyFor__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat__T__Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$Key(this, format, source), new $c_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$Entry(source, proto));
  $p_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$__evictIfNeeded__V(this);
});
$p.aMJ = (function(proto) {
  var cloned = proto.cloneNode(true);
  return $f_Lcom_raquo_laminar_api_Laminar__foreignSvgElement__Lcom_raquo_laminar_tags_SvgTag__Lorg_scalajs_dom_SVGElement__Lcom_raquo_laminar_nodes_ReactiveSvgElement($m_Lcom_raquo_laminar_api_package$().b, $m_Lcom_raquo_laminar_api_package$().b.j().bo(), cloned);
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$, "org.jpablo.graphexplorer.viewer.state.ThumbnailSvgCache$", ({
  EB: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$;
function $m_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$ = new $c_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$;
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_UIState__$init$__V($thiz) {
  $thiz.qs = $m_Lcom_raquo_airstream_state_Var$().bx($thiz.MY);
  $thiz.abi = $m_Lcom_raquo_airstream_state_Var$().bx(false);
  $thiz.H7 = $m_Lcom_raquo_airstream_state_Var$().bx($thiz.MX);
  $thiz.CE = new $c_Lcom_raquo_airstream_eventbus_EventBus();
  $thiz.abf = $m_Lcom_raquo_airstream_state_Var$().bx(false);
  $thiz.abo = $m_Lcom_raquo_airstream_state_Var$().bx(false);
  $thiz.CI = $m_Lcom_raquo_airstream_state_Var$().bx(false);
  $thiz.H9 = $m_Lcom_raquo_airstream_state_Var$().bx($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$().a0X);
  $thiz.H4 = $m_Lcom_raquo_airstream_state_Var$().bx(false);
  $thiz.N5 = $m_Lcom_raquo_airstream_state_Var$().bx(false);
  $thiz.CJ = $m_Lcom_raquo_airstream_state_Var$().bx(false);
  $thiz.H5 = $m_Lcom_raquo_airstream_state_Var$().bx(false);
  $thiz.abt = $m_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$().li($thiz.CJ.P(), $thiz.H5.P(), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((_$1, _$2) => {
    var _$1$1 = (!(!_$1));
    var _$2$1 = (!(!_$2));
    return (_$1$1 && _$2$1);
  })));
  $thiz.H6 = $m_Lcom_raquo_airstream_state_Var$().bx($m_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$().Cq);
  $thiz.TV = $m_Lcom_raquo_airstream_state_Var$().bx(true);
  $thiz.abh = new $c_Lcom_raquo_airstream_eventbus_EventBus();
  $thiz.TT = $m_Lcom_raquo_airstream_state_Var$().bx(false);
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_UIState__view3DActiveNow__Z($thiz) {
  return ((!(!$thiz.CJ.P().aq().d())) && (!(!$thiz.H5.P().aq().d())));
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_UIState__isSectionActive__Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection__Lcom_raquo_airstream_core_Signal($thiz, section) {
  return $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), $thiz.qs.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3) => ((_$3 === null) ? (section === null) : (_$3 === section)))), $m_s_None$());
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerState$formatOption$(outer) {
  this.U6 = null;
  this.aH0 = null;
  this.aGZ = null;
  this.abw = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.abw = outer;
  this.U6 = "Auto";
  this.aH0 = $m_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$().li(outer.CD.P(), outer.CG.P(), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((isAuto, format) => ((!(!isAuto)) ? this.U6 : format.m()))));
  this.aGZ = $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), outer.a0Z, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((format$2) => ((this.U6 + " \u2014 ") + outer.afY(format$2).FP))), $m_s_None$());
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerState$formatOption$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerState$formatOption$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_ViewerState$formatOption$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_ViewerState$formatOption$.prototype = $p;
$p.b8i = (function(value) {
  if ((value === this.U6)) {
    $f_Lcom_raquo_airstream_state_Var__set__O__V(this.abw.CD, true);
  } else {
    this.abw.aS5($m_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$().a5d(value));
  }
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_ViewerState$formatOption$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_ViewerState$formatOption$, "org.jpablo.graphexplorer.viewer.state.ViewerState$formatOption$", ({
  EJ: 1
}));
function $f_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__isElementVisible__Lorg_jpablo_graphexplorer_viewer_models_ElementId__Lcom_raquo_airstream_core_Signal($thiz, id) {
  return $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), $thiz.il().N6, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((ids) => (!$m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().mJ(((ids === null) ? null : ids.aS), id)))), $m_s_None$());
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__showOnlyGroup__V($thiz) {
  $thiz.aH().aRX();
  $f_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__hideNonSelectedNodes__V($thiz);
  $thiz.aH().ie();
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__keepRootsOnly__V($thiz) {
  $thiz.il().zI.i(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds($m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().tS(((v1 === null) ? null : v1.aS), $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__fullGraphObs__Lcom_raquo_airstream_state_OwnedSignal($thiz)).d().j8.jv($f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__fullGraphObs__Lcom_raquo_airstream_state_OwnedSignal($thiz)).d().b7Y()))))));
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__hideAllNodes__V($thiz) {
  $thiz.il().zI.i(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds($m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().tS(((v1 === null) ? null : v1.aS), $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__fullGraphObs__Lcom_raquo_airstream_state_OwnedSignal($thiz)).d().j8)))));
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__deleteHiddenElements__V($thiz) {
  var hidden = $thiz.il().cL();
  if (hidden.c()) {
    $thiz.od.dn.bA("No hidden elements to delete");
  } else {
    var kinds = $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().gV(hidden);
    var summary = (((((("Delete hidden: " + kinds.gg.aa()) + " nodes, ") + kinds.gf.aa()) + " arrows, ") + kinds.f3.aa()) + " groups. Continue?");
    if ((!(!window.confirm(summary)))) {
      var applies = $thiz.d4.u5();
      $f_Lcom_raquo_airstream_state_Var__update__F1__V($thiz.d4.jI, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$5) => _$5.a4t(hidden))));
      if (applies) {
        $thiz.il().ie();
        $thiz.aH().XR(hidden);
        $thiz.od.dn.bA("Hidden elements deleted");
      }
    }
  }
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__hideNonSelectedNodes__V($thiz) {
  $p_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__updateHiddenFromSelection__F3__V($thiz, new $c_sr_AbstractFunction3_$$Lambda$d1e06cbab540de4f9f09e7182f18ea80659b9825(((v1, v2, v3) => {
    var h = ((v1 === null) ? null : v1.aS);
    var sel = ((v2 === null) ? null : v2.aS);
    return new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds($m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().tS(h, v3.j8.jv($m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().io(sel))));
  })));
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__showAllSuccessors__V($thiz) {
  $p_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__updateHiddenFromSelection__F3__V($thiz, new $c_sr_AbstractFunction3_$$Lambda$d1e06cbab540de4f9f09e7182f18ea80659b9825(((v1, v2, v3) => {
    var h = ((v1 === null) ? null : v1.aS);
    var sel = ((v2 === null) ? null : v2.aS);
    var sub = v3.aLW().i($m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().io(sel));
    return new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds($m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().yk($m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().yk(h, sub.j8), sub.qn));
  })));
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__showDirectSuccessors__V($thiz) {
  var view = $p_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__collapsedViewNow__Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$CollapsedView($thiz);
  var sel = $thiz.aH().cL();
  var sub = view.xe.aNu().i($m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().io(sel));
  var newlyShownNodes = sub.j8.J3($m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().io(view.Cp));
  $thiz.il().zI.i(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds($m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().yk($m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().yk(((v1 === null) ? null : v1.aS), view.ahk(sub.qn)), $p_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__boxAwareIds__sci_Set__sci_Set($thiz, sub.j8))))));
  if ((!newlyShownNodes.c())) {
    $thiz.aH().gC(newlyShownNodes);
  }
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__showAllPredecessors__V($thiz) {
  $p_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__updateHiddenFromSelection__F3__V($thiz, new $c_sr_AbstractFunction3_$$Lambda$d1e06cbab540de4f9f09e7182f18ea80659b9825(((v1, v2, v3) => {
    var h = ((v1 === null) ? null : v1.aS);
    var sel = ((v2 === null) ? null : v2.aS);
    var sub = v3.aLV().i($m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().io(sel));
    return new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds($m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().yk($m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().yk(h, sub.j8), sub.qn));
  })));
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__showDirectPredecessors__V($thiz) {
  var view = $p_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__collapsedViewNow__Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$CollapsedView($thiz);
  var sub = view.xe.aNs().i($m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().io($thiz.aH().cL()));
  $thiz.il().zI.i(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds($m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().yk($m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().yk(((v1 === null) ? null : v1.aS), view.ahk(sub.qn)), $p_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__boxAwareIds__sci_Set__sci_Set($thiz, sub.j8))))));
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__contractSelection__Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction__Z__V($thiz, dir, recursive) {
  var selNodes = $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().io($thiz.aH().cL());
  if ((!selNodes.c())) {
    var view = $p_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__collapsedViewNow__Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$CollapsedView($thiz);
    matchResult1: {
      var \u03b41$___1;
      var \u03b41$___2;
      var x1 = $m_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$().aZ5(view.xe, view.Cp, selNodes, dir, recursive);
      if ((x1 !== null)) {
        var \u03b41$___1 = x1.g();
        var \u03b41$___2 = x1.h();
        break matchResult1;
      }
      throw new $c_s_MatchError(x1);
    }
    var arrows$2 = \u03b41$___1;
    var nodes$2 = \u03b41$___2;
    if (((!arrows$2.c()) || (!nodes$2.c()))) {
      $thiz.il().zI.i(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds($m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().tS($m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().tS(((v1 === null) ? null : v1.aS), view.ahk(arrows$2)), $p_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__boxAwareIds__sci_Set__sci_Set($thiz, nodes$2))))));
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__collapsedViewNow__Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$CollapsedView($thiz) {
  return $f_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps__collapsedView__sci_Set__sci_Set__Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$CollapsedView($f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__fullGraphObs__Lcom_raquo_airstream_state_OwnedSignal($thiz)).d(), $thiz.gn().nh.P().aq().d(), $thiz.il().cL());
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__boxAwareIds__sci_Set__sci_Set($thiz, viewNodes) {
  var view = $p_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__collapsedViewNow__Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$CollapsedView($thiz).xe;
  var g = $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__fullGraphObs__Lcom_raquo_airstream_state_OwnedSignal($thiz)).d();
  return viewNodes.c5(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n) => {
    var x4 = $f_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps__proxyOrigin__Lorg_jpablo_graphexplorer_viewer_models_ElementId__s_Option(view, n);
    if ((x4 instanceof $c_s_Some)) {
      var grp = x4.J;
      return $m_sci_Set$().af($f_Lorg_jpablo_graphexplorer_viewer_graph_GroupsOps__getAllChildren__sci_Set__sci_Set(g, $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_GroupId.r().C)([grp]))))).hQ(grp);
    }
    if (($m_s_None$() === x4)) {
      return $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_ElementId.r().C)([n])));
    }
    throw new $c_s_MatchError(x4);
  })));
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__concealedFor__sci_Set__Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction__sci_Set($thiz, ids, dir) {
  var view = $p_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__collapsedViewNow__Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$CollapsedView($thiz);
  return ids.c5(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$9) => $m_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$().af9(view.xe, view.Cp, _$9, dir))));
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__concealedCountsNow__sci_Map($thiz) {
  var view = $p_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__collapsedViewNow__Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$CollapsedView($thiz);
  return $m_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$().aYX(view.xe, view.Cp);
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__toggleSuccessors__sci_Set__V($thiz, ids) {
  if ((!ids.c())) {
    if ((!$p_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__concealedFor__sci_Set__Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction__sci_Set($thiz, ids, $s_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$__Successors__Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction()).c())) {
      var x = $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().io($thiz.aH().cL());
      if ((!((x === null) ? (ids === null) : x.e(ids)))) {
        $thiz.aH().gC(ids);
      }
      $f_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__showDirectSuccessors__V($thiz);
    } else {
      var x$1 = $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().io($thiz.aH().cL());
      if ((!((x$1 === null) ? (ids === null) : x$1.e(ids)))) {
        $thiz.aH().gC(ids);
      }
      $p_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__contractSelection__Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction__Z__V($thiz, $s_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$__Successors__Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction(), false);
    }
  }
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__toggleSuccessors$default$1__sci_Set($thiz) {
  return $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().io($thiz.aH().cL());
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__togglePredecessors__sci_Set__V($thiz, ids) {
  if ((!ids.c())) {
    if ((!$p_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__concealedFor__sci_Set__Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction__sci_Set($thiz, ids, $s_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$__Predecessors__Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction()).c())) {
      var x = $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().io($thiz.aH().cL());
      if ((!((x === null) ? (ids === null) : x.e(ids)))) {
        $thiz.aH().gC(ids);
      }
      $f_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__showDirectPredecessors__V($thiz);
    } else {
      var x$1 = $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().io($thiz.aH().cL());
      if ((!((x$1 === null) ? (ids === null) : x$1.e(ids)))) {
        $thiz.aH().gC(ids);
      }
      $p_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__contractSelection__Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction__Z__V($thiz, $s_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$__Predecessors__Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction(), false);
    }
  }
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__togglePredecessors$default$1__sci_Set($thiz) {
  return $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().io($thiz.aH().cL());
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__updateHiddenFromSelection__F3__V($thiz, f) {
  $thiz.il().zI.i(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => {
    var _$10 = ((v1 === null) ? null : v1.aS);
    var ev$2 = f.DH(new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds(_$10), new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds($thiz.aH().cL()), $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__fullGraphObs__Lcom_raquo_airstream_state_OwnedSignal($thiz)).d());
    return new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds(((ev$2 === null) ? null : ev$2.aS));
  })));
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps$hiddenElements$(outer) {
  this.Ha = null;
  this.zI = null;
  this.N6 = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Ha = outer.gn().CB;
  this.zI = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((mod) => {
    $f_Lcom_raquo_airstream_state_Var__update__F1__V(this.Ha, mod);
  }));
  this.N6 = this.Ha.P();
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps$hiddenElements$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps$hiddenElements$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps$hiddenElements$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps$hiddenElements$.prototype = $p;
$p.cL = (function() {
  var ev$1 = this.Ha.P().aq().d();
  return ((ev$1 === null) ? null : ev$1.aS);
});
$p.OU = (function(ss) {
  $f_Lcom_raquo_airstream_state_Var__update__F1__V(this.Ha, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds($m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().tS(((v1 === null) ? null : v1.aS), ss)))));
});
$p.XR = (function(ss) {
  $f_Lcom_raquo_airstream_state_Var__update__F1__V(this.Ha, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds($m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().yk(((v1 === null) ? null : v1.aS), ss)))));
});
$p.ie = (function() {
  $f_Lcom_raquo_airstream_state_Var__set__O__V(this.Ha, new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds($m_sci_Set$EmptySet$()));
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps$hiddenElements$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps$hiddenElements$, "org.jpablo.graphexplorer.viewer.state.VisibilityOps$hiddenElements$", ({
  EL: 1
}));
function $f_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_AddNewArrowOps__$init$__V($thiz) {
  $thiz.aGd = $m_sc_ArrayOps$().kX($m_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$().bbj());
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_AddNewArrowOps__handleAddNewArrowMouseUp__Lorg_scalajs_dom_MouseEvent__Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$AddNewArrowAction__V($thiz, ev, action) {
  var current = $thiz.aH().cL();
  var start = action.zJ;
  var _1 = (+ev.clientX);
  var _2 = (+ev.clientY);
  var bbox = start.dD().getBoundingClientRect();
  var isMouseInsideSourceNode = ((((_1 >= (+bbox.left)) && (_1 <= (+bbox.right))) && (_2 >= (+bbox.top))) && (_2 <= (+bbox.bottom)));
  if (((current.aa() === 1) && isMouseInsideSourceNode)) {
    var this$4 = $f_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement__nodeId__s_Option(start);
    if ((!this$4.c())) {
      var x0 = this$4.d();
      var dropCell = $thiz.du().Wq(x0, (+ev.clientX), (+ev.clientY));
      $thiz.aeC(x0, x0, action.CK, dropCell);
    }
  } else if ((current.aa() === 2)) {
    var this$7 = $f_Lorg_jpablo_graphexplorer_viewer_models_ElementId__asNodeId__s_Option($m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().aem(current, start.lj()).t());
    if ((!this$7.c())) {
      var x0$1 = this$7.d();
      var dropCell$1 = $thiz.du().Wq(x0$1, (+ev.clientX), (+ev.clientY));
      matchResult1: {
        var x1 = action.Hb;
        var x = $s_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$__forward__Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection();
        if (((x === null) ? (x1 === null) : (x === x1))) {
          $thiz.aeC($f_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement__nodeId__s_Option(start).d(), x0$1, action.CK, dropCell$1);
          break matchResult1;
        }
        var x$3 = $s_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$__backward__Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection();
        if (((x$3 === null) ? (x1 === null) : (x$3 === x1))) {
          $thiz.aeC(x0$1, $f_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement__nodeId__s_Option(start).d(), dropCell$1, action.CK);
          break matchResult1;
        }
        throw new $c_s_MatchError(x1);
      }
    }
  }
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_AddNewArrowOps__onAddNewArrowAction__Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$AddNewArrowAction__V($thiz, action) {
  $f_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_AddNewArrowOps__selectWithClosestNode__Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement__sjs_js_Array__V($thiz, action.zJ, $m_Lorg_jpablo_graphexplorer_viewer_domUtils_DomUtils$package$().a3d(document, action.ts.jK.fi, action.ts.jK.fj));
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_AddNewArrowOps__selectWithClosestNode__Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement__sjs_js_Array__V($thiz, start, elementsFromRectEnd) {
  var strategy = $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__selectionStrategyObs__Lcom_raquo_airstream_state_OwnedSignal($thiz)).d();
  matchResult2: {
    var x2 = $m_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$().WO(elementsFromRectEnd, strategy, new $c_s_Some(strategy.Jc()));
    if ((x2 instanceof $c_s_Some)) {
      var elementId = x2.J;
      $thiz.aH().gC($m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_ElementId.r().C)([start.lj(), elementId]))));
      break matchResult2;
    }
    if (($m_s_None$() === x2)) {
      $thiz.aH().gC($m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_ElementId.r().C)([start.lj()]))));
      break matchResult2;
    }
    throw new $c_s_MatchError(x2);
  }
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_AddNewArrowOps__handleNewArrowControls__Lorg_scalajs_dom_SVGGElement__s_Option__Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction__V($thiz, parent, selection, action) {
  var concealed$lzy1 = new $c_sr_LazyRef();
  var controls = $m_s_Option$().m2(selection).iz().c5(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((concealed$lzy1$2) => ((elem) => $thiz.aGd.c5(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((elem$2) => ((_$1) => $f_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_AddNewArrowOps__buildNewArrowControl__Lorg_scalajs_dom_SVGGElement__Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement__Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction__Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection__sci_Map__s_Option($thiz, parent, elem$2, action, _$1, $p_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_AddNewArrowOps__concealed$2__sr_LazyRef__sci_Map($thiz, concealed$lzy1$2))))(elem)))))(concealed$lzy1)));
  var this$3 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(parent.querySelectorAll("g.new-arrow-control"));
  var it = this$3.o();
  while (it.p()) {
    var x0 = it.q();
    x0.remove();
  }
  controls.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((newChild) => parent.appendChild(newChild))));
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_AddNewArrowOps__buildNewArrowControl__Lorg_scalajs_dom_SVGGElement__Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement__Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction__Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection__sci_Map__s_Option($thiz, parent, selectedElem, action, direction, concealed) {
  var x = $s_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$__Inactive__Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction();
  if (((x === null) ? (action === null) : x.e(action))) {
    var showControl = true;
  } else {
    var showControl = ((action instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$AddNewArrowAction) && action.ts.c());
  }
  if ((selectedElem instanceof $c_Lorg_jpablo_graphexplorer_viewer_components_selection_NodeElement)) {
    if (showControl) {
      var parentCtm = $m_s_Option$().as(parent.getScreenCTM());
      matchResult4: {
        var \u03b41$___1;
        var \u03b41$___2;
        var this$1 = $f_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement__nodeId__s_Option(selectedElem);
        if (this$1.c()) {
          var $x_1 = $m_s_None$();
        } else {
          var x0 = this$1.d();
          var $x_1 = concealed.r(x0);
        }
        var this$2 = $x_1;
        var x7 = (this$2.c() ? new $c_T2(0, 0) : this$2.d());
        if ((x7 !== null)) {
          var \u03b41$___1 = (x7.g() | 0);
          var \u03b41$___2 = (x7.h() | 0);
          break matchResult4;
        }
        throw new $c_s_MatchError(x7);
      }
      var succ$2 = (\u03b41$___1 | 0);
      var pred$2 = (\u03b41$___2 | 0);
      var this$6 = $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_NewArrowControl$package$();
      var clientSize = $thiz.H3;
      var _1 = (pred$2 > 0);
      var _2 = (succ$2 > 0);
      var svgMods = $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([]));
      var fallbackBBox = selectedElem.T1.getBBox();
      var elemCtm = $m_s_Option$().as(selectedElem.T1.getScreenCTM());
      var rootCtm = (parentCtm.c() ? elemCtm : parentCtm);
      matchResult1: {
        var \u03b41$$1___1;
        var \u03b41$$1___2;
        var \u03b41$$1___3;
        var \u03b41$$1___4;
        if ((rootCtm instanceof $c_s_Some)) {
          var rootMatrix = rootCtm.J;
          if ((elemCtm instanceof $c_s_Some)) {
            var elemMatrix = elemCtm.J;
            var inv = rootMatrix.inverse();
            var p1 = $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_NewArrowControl$package$__toParent$1__Lorg_scalajs_dom_SVGMatrix__Lorg_scalajs_dom_SVGMatrix__D__D__Lorg_jpablo_graphexplorer_viewer_domUtils_DOMPoint(this$6, elemMatrix, inv, (+fallbackBBox.x), (+fallbackBBox.y));
            var p2 = $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_NewArrowControl$package$__toParent$1__Lorg_scalajs_dom_SVGMatrix__Lorg_scalajs_dom_SVGMatrix__D__D__Lorg_jpablo_graphexplorer_viewer_domUtils_DOMPoint(this$6, elemMatrix, inv, ((+fallbackBBox.x) + (+fallbackBBox.width)), (+fallbackBBox.y));
            var p3 = $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_NewArrowControl$package$__toParent$1__Lorg_scalajs_dom_SVGMatrix__Lorg_scalajs_dom_SVGMatrix__D__D__Lorg_jpablo_graphexplorer_viewer_domUtils_DOMPoint(this$6, elemMatrix, inv, (+fallbackBBox.x), ((+fallbackBBox.y) + (+fallbackBBox.height)));
            var p4 = $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_NewArrowControl$package$__toParent$1__Lorg_scalajs_dom_SVGMatrix__Lorg_scalajs_dom_SVGMatrix__D__D__Lorg_jpablo_graphexplorer_viewer_domUtils_DOMPoint(this$6, elemMatrix, inv, ((+fallbackBBox.x) + (+fallbackBBox.width)), ((+fallbackBBox.y) + (+fallbackBBox.height)));
            var minX = (+$f_sc_IterableOnceOps__min__s_math_Ordering__O(new $c_sci_$colon$colon((+p1.x), new $c_sci_$colon$colon((+p2.x), new $c_sci_$colon$colon((+p3.x), new $c_sci_$colon$colon((+p4.x), $m_sci_Nil$())))), $m_s_math_Ordering$DeprecatedDoubleOrdering$()));
            var minY = (+$f_sc_IterableOnceOps__min__s_math_Ordering__O(new $c_sci_$colon$colon((+p1.y), new $c_sci_$colon$colon((+p2.y), new $c_sci_$colon$colon((+p3.y), new $c_sci_$colon$colon((+p4.y), $m_sci_Nil$())))), $m_s_math_Ordering$DeprecatedDoubleOrdering$()));
            var \u03b41$$1___1 = minX;
            var \u03b41$$1___2 = minY;
            var \u03b41$$1___3 = ((+$f_sc_IterableOnceOps__max__s_math_Ordering__O(new $c_sci_$colon$colon((+p1.x), new $c_sci_$colon$colon((+p2.x), new $c_sci_$colon$colon((+p3.x), new $c_sci_$colon$colon((+p4.x), $m_sci_Nil$())))), $m_s_math_Ordering$DeprecatedDoubleOrdering$())) - minX);
            var \u03b41$$1___4 = ((+$f_sc_IterableOnceOps__max__s_math_Ordering__O(new $c_sci_$colon$colon((+p1.y), new $c_sci_$colon$colon((+p2.y), new $c_sci_$colon$colon((+p3.y), new $c_sci_$colon$colon((+p4.y), $m_sci_Nil$())))), $m_s_math_Ordering$DeprecatedDoubleOrdering$())) - minY);
            break matchResult1;
          }
        }
        var \u03b41$$1___1 = (+fallbackBBox.x);
        var \u03b41$$1___2 = (+fallbackBBox.y);
        var \u03b41$$1___3 = (+fallbackBBox.width);
        var \u03b41$$1___4 = (+fallbackBBox.height);
      }
      var bboxX = (+\u03b41$$1___1);
      var bboxY = (+\u03b41$$1___2);
      var bboxWidth = (+\u03b41$$1___3);
      var bboxHeight = (+\u03b41$$1___4);
      matchResult2: {
        var currentClientSize;
        var x$1 = $s_Lorg_jpablo_graphexplorer_viewer_models_ClientSize$__Small__Lorg_jpablo_graphexplorer_viewer_models_ClientSize();
        if (((x$1 === null) ? (clientSize === null) : (x$1 === clientSize))) {
          var currentClientSize = 32.0;
          break matchResult2;
        }
        var x$3 = $s_Lorg_jpablo_graphexplorer_viewer_models_ClientSize$__Normal__Lorg_jpablo_graphexplorer_viewer_models_ClientSize();
        if (((x$3 === null) ? (clientSize === null) : (x$3 === clientSize))) {
          var currentClientSize = 16.0;
          break matchResult2;
        }
        throw new $c_s_MatchError(clientSize);
      }
      if (rootCtm.c()) {
        var this$16 = $m_s_None$();
      } else {
        var x0$1 = rootCtm.d();
        var x$2 = (+x0$1.a);
        var this$16 = new $c_s_Some((1.0 / (+Math.abs(x$2))));
      }
      if (this$16.c()) {
        var $x_2 = true;
      } else {
        var x0$2 = this$16.d();
        var _$1 = (+x0$2);
        var $x_2 = ((_$1 === _$1) && (!((_$1 === Infinity) || (_$1 === (-Infinity)))));
      }
      if ($x_2) {
        var this$20 = this$16;
      } else {
        var this$20 = $m_s_None$();
      }
      var userPerPx = (+(this$20.c() ? 1.0 : this$20.d()));
      var edgeGapPx = (0.25 * currentClientSize);
      var rankdir = $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__graphRankDirObs__Lcom_raquo_airstream_state_OwnedSignal($thiz)).d();
      var nodeCenterX = (bboxX + (0.5 * bboxWidth));
      var nodeCenterY = (bboxY + (0.5 * bboxHeight));
      var posAbove = new $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$Anchored(nodeCenterX, bboxY, (0.5 * (-currentClientSize)), ((-currentClientSize) - edgeGapPx), currentClientSize, 16.0);
      var posBelow = new $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$Anchored(nodeCenterX, (bboxY + bboxHeight), (0.5 * (-currentClientSize)), edgeGapPx, currentClientSize, 16.0);
      var posLeft = new $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$Anchored(bboxX, nodeCenterY, ((-currentClientSize) - $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_NewArrowControl$package$__sideGapPx$1__D__D__Z__D(this$6, edgeGapPx, 12.0, _1)), (0.5 * (-currentClientSize)), currentClientSize, 16.0);
      var posRight = new $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$Anchored((bboxX + bboxWidth), nodeCenterY, $p_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_NewArrowControl$package$__sideGapPx$1__D__D__Z__D(this$6, edgeGapPx, 12.0, _2), (0.5 * (-currentClientSize)), currentClientSize, 16.0);
      matchResult3$1: {
        var anchored;
        var x9 = new $c_T2(rankdir, direction);
        var x24 = x9.bi;
        var x25 = x9.be;
        var x$5 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$__TB__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir();
        if (((x$5 === null) ? (x24 === null) : (x$5 === x24))) {
          var x$7 = $s_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$__forward__Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection();
          if (((x$7 === null) ? (x25 === null) : (x$7 === x25))) {
            var anchored = posBelow;
            break matchResult3$1;
          }
          var x$9 = $s_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$__backward__Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection();
          if (((x$9 === null) ? (x25 === null) : (x$9 === x25))) {
            var anchored = posAbove;
            break matchResult3$1;
          }
        }
        var x$11 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$__LR__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir();
        if (((x$11 === null) ? (x24 === null) : (x$11 === x24))) {
          var x$13 = $s_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$__forward__Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection();
          if (((x$13 === null) ? (x25 === null) : (x$13 === x25))) {
            var anchored = posRight;
            break matchResult3$1;
          }
          var x$15 = $s_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$__backward__Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection();
          if (((x$15 === null) ? (x25 === null) : (x$15 === x25))) {
            var anchored = posLeft;
            break matchResult3$1;
          }
        }
        var x$17 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$__BT__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir();
        if (((x$17 === null) ? (x24 === null) : (x$17 === x24))) {
          var x$19 = $s_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$__forward__Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection();
          if (((x$19 === null) ? (x25 === null) : (x$19 === x25))) {
            var anchored = posAbove;
            break matchResult3$1;
          }
          var x$21 = $s_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$__backward__Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection();
          if (((x$21 === null) ? (x25 === null) : (x$21 === x25))) {
            var anchored = posBelow;
            break matchResult3$1;
          }
        }
        var x$23 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$__RL__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir();
        if (((x$23 === null) ? (x24 === null) : (x$23 === x24))) {
          var x$25 = $s_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$__forward__Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection();
          if (((x$25 === null) ? (x25 === null) : (x$25 === x25))) {
            var anchored = posLeft;
            break matchResult3$1;
          }
          var x$27 = $s_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$__backward__Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection();
          if (((x$27 === null) ? (x25 === null) : (x$27 === x25))) {
            var anchored = posRight;
            break matchResult3$1;
          }
        }
        throw new $c_s_MatchError(x9);
      }
      matchResult4$1: {
        var rotation;
        var x$29 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$__TB__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir();
        if (((x$29 === null) ? (rankdir === null) : (x$29 === rankdir))) {
          var rotation = 0;
          break matchResult4$1;
        }
        var x$31 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$__LR__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir();
        if (((x$31 === null) ? (rankdir === null) : (x$31 === rankdir))) {
          var rotation = 270;
          break matchResult4$1;
        }
        var x$33 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$__BT__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir();
        if (((x$33 === null) ? (rankdir === null) : (x$33 === rankdir))) {
          var rotation = 180;
          break matchResult4$1;
        }
        var x$35 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$__RL__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir();
        if (((x$35 === null) ? (rankdir === null) : (x$35 === rankdir))) {
          var rotation = 90;
          break matchResult4$1;
        }
        throw new $c_s_MatchError(rankdir);
      }
      var arrowGroup = $m_Lcom_raquo_laminar_api_package$().b.j().dm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().mZ().n((("rotate(" + rotation) + ", 8, 8)")), $m_Lcom_raquo_laminar_api_package$().b.j().pC().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().qV().n("M8.5 4.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293z")])))])));
      var control = $m_Lcom_raquo_laminar_api_package$().b.j().dm().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().ar.s("new-arrow-control"), $m_Lcom_raquo_laminar_api_package$().b.j().ahu().n("all"), $m_Lcom_raquo_laminar_api_package$().b.j().DP().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().Ee().n("8"), $m_Lcom_raquo_laminar_api_package$().b.j().y6().n("8"), $m_Lcom_raquo_laminar_api_package$().b.j().y7().n("8")]))), arrowGroup, $f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$().aQm(anchored, userPerPx), $m_s_$less$colon$less$().b1, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$()), $f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, svgMods, $m_s_$less$colon$less$().b1, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())]))).e8;
      control.addEventListener("mousedown", ((elem$2) => ((ev) => {
        ev.stopPropagation();
        var pos = new $c_Lorg_jpablo_graphexplorer_viewer_utils_ClientPoint((+ev.clientX), (+ev.clientY));
        var this$39 = $thiz.gs.P().aq().d();
        if (this$39.c()) {
          var $x_3 = true;
        } else {
          var x0$3 = this$39.d();
          var x$6 = x0$3.bT;
          var x$2$1 = elem$2.aNE();
          var $x_3 = ((x$6 === null) ? (x$2$1 === null) : x$6.e(x$2$1));
        }
        if ($x_3) {
          var this$40 = this$39;
        } else {
          var this$40 = $m_s_None$();
        }
        var sourceCell = (this$40.c() ? $m_s_None$() : new $c_s_Some(this$40.d().f4));
        var this$43 = $thiz.H8;
        var mouseAction = new $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$AddNewArrowAction(new $c_Lorg_jpablo_graphexplorer_viewer_utils_MouseActionRect(pos, pos, false), selectedElem, direction, sourceCell);
        $f_Lcom_raquo_airstream_state_Var__set__O__V(this$43.zN, mouseAction);
      }))(selectedElem));
      control.addEventListener("mouseup", ((ev$2) => {
        ev$2.stopPropagation();
        $f_Lcom_raquo_airstream_state_Var__set__O__V($thiz.H8.zN, $s_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$__Inactive__Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction());
        $thiz.a33($m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV, direction);
      }));
      return new $c_s_Some(control);
    }
  }
  return $m_s_None$();
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_AddNewArrowOps__addArrowFromSourceToPointer__Lorg_scalajs_dom_SVGGElement__Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$AddNewArrowAction__V($thiz, rootGroup, action) {
  rootGroup.appendChild($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowFromSourceToPointer$package$().aVC(action, rootGroup).e8);
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_AddNewArrowOps__concealed$lzyINIT1$1__sr_LazyRef__sci_Map($thiz, concealed$lzy1$1) {
  return (concealed$lzy1$1.ci ? concealed$lzy1$1.cj : concealed$lzy1$1.h3($f_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__concealedCountsNow__sci_Map($thiz)));
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_AddNewArrowOps__concealed$2__sr_LazyRef__sci_Map($thiz, concealed$lzy1$2) {
  return (concealed$lzy1$2.ci ? concealed$lzy1$2.cj : $p_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_AddNewArrowOps__concealed$lzyINIT1$1__sr_LazyRef__sci_Map($thiz, concealed$lzy1$2));
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ExtendSelectionOps__onExtendSelectionAction__sci_Seq__Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$ExtendSelectionAction__V($thiz, selectableElements, action) {
  var this$1 = $thiz.aH();
  var rect = action.zK;
  if (rect.c()) {
    matchResult6: {
      var x26 = $m_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$().WO($m_Lorg_jpablo_graphexplorer_viewer_domUtils_DomUtils$package$().a3d(document, action.zK.jK.fi, action.zK.jK.fj), $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__selectionStrategyObs__Lcom_raquo_airstream_state_OwnedSignal(this$1.di)).d(), $m_s_None$());
      if ((x26 instanceof $c_s_Some)) {
        this$1.a57(x26.J, rect.CL);
        break matchResult6;
      }
      if (($m_s_None$() === x26)) {
        this$1.ie();
        break matchResult6;
      }
      throw new $c_s_MatchError(x26);
    }
  } else {
    var nodesInRect = $m_sci_Set$().af(selectableElements.bw(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$12) => this$1.b3l(_$12, rect)))).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$13) => _$13.lj()))));
    if ((!nodesInRect.c())) {
      if (rect.CL) {
        this$1.aeE(nodesInRect);
      } else {
        this$1.gC(nodesInRect);
      }
    } else if ((!rect.CL)) {
      this$1.ie();
    }
  }
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ExtendSelectionOps__SelectionRect__F0__Lcom_raquo_laminar_nodes_ReactiveSvgElement($thiz, screenCtm) {
  var bbox = $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), $thiz.H8.Hc, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => ((x$1 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$ExtendSelectionAction) ? new $c_s_Some($f_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ExtendSelectionOps__selectionRectBBox__Lorg_scalajs_dom_SVGMatrix__Lorg_jpablo_graphexplorer_viewer_utils_MouseActionRect__T4($thiz, screenCtm.a3(), x$1.zK)) : $m_s_None$()))), $m_s_None$());
  return $m_Lcom_raquo_laminar_api_package$().b.j().a4s().O($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.j().Pt().n("selection-rectangle"), $m_Lcom_raquo_laminar_api_package$().b.j().Eq().bj($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), bbox, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => {
    var this$4 = (_$1.c() ? $m_s_None$() : new $c_s_Some(_$1.d().bO));
    return (this$4.c() ? "0" : this$4.d());
  })), $m_s_None$())), $m_Lcom_raquo_laminar_api_package$().b.j().Er().bj($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), bbox, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3) => {
    var this$5 = (_$3.c() ? $m_s_None$() : new $c_s_Some(_$3.d().bs));
    return (this$5.c() ? "0" : this$5.d());
  })), $m_s_None$())), $m_Lcom_raquo_laminar_api_package$().b.j().bh().bj($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), bbox, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$5) => {
    var this$6 = (_$5.c() ? $m_s_None$() : new $c_s_Some(_$5.d().ch));
    return (this$6.c() ? "0" : this$6.d());
  })), $m_s_None$())), $m_Lcom_raquo_laminar_api_package$().b.j().bg().bj($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), bbox, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$7) => {
    var this$7 = (_$7.c() ? $m_s_None$() : new $c_s_Some(_$7.d().ca));
    return (this$7.c() ? "0" : this$7.d());
  })), $m_s_None$()))])));
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ExtendSelectionOps__selectionRectBBox__Lorg_scalajs_dom_SVGMatrix__Lorg_jpablo_graphexplorer_viewer_utils_MouseActionRect__T4($thiz, screenCtm, rect) {
  matchResult2: {
    var \u03b41$___1;
    var \u03b41$___2;
    var x3 = $m_Lorg_jpablo_graphexplorer_viewer_components_SvgElementOps$package$().bae(rect, screenCtm);
    if ((x3 !== null)) {
      var \u03b41$___1 = x3.g();
      var \u03b41$___2 = x3.h();
      break matchResult2;
    }
    throw new $c_s_MatchError(x3);
  }
  var start$2 = \u03b41$___1;
  var end$2 = \u03b41$___2;
  var x = start$2.gI;
  var that = end$2.gI;
  var $x_3 = Math.min(x, that);
  var x$1 = start$2.gJ;
  var that$1 = end$2.gJ;
  var $x_2 = Math.min(x$1, that$1);
  var x$2 = (end$2.gI - start$2.gI);
  var $x_1 = Math.abs(x$2);
  var x$3 = (end$2.gJ - start$2.gJ);
  return new $c_T4(("" + (+$x_3)), ("" + (+$x_2)), ("" + (+$x_1)), ("" + (+Math.abs(x$3))));
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseActionVar(initial) {
  this.zN = null;
  this.Hc = null;
  this.zN = new $c_Lcom_raquo_airstream_state_SourceVar(new $c_s_util_Success(initial));
  this.Hc = $f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable(this.zN.QG);
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseActionVar.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseActionVar;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseActionVar() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseActionVar.prototype = $p;
$p.baV = (function(end, shift) {
  $f_Lcom_raquo_airstream_state_Var__update__F1__V(this.zN, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var x = $s_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$__Inactive__Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction();
    if (((x === null) ? (x$1 === null) : x.e(x$1))) {
      return $s_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$__Inactive__Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction();
    }
    if ((x$1 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$ExtendSelectionAction)) {
      var this$3 = new $c_Lcom_softwaremill_quicklens_package$PathModify(x$1, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((a$2) => ((x$3) => new $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$ExtendSelectionAction(x$3.i(a$2.zK))))(x$1)));
      var mod = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => new $c_Lorg_jpablo_graphexplorer_viewer_utils_MouseActionRect(_$2.oe, end, shift)));
      return this$3.eF.i(mod);
    }
    if ((x$1 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$AddNewArrowAction)) {
      var this$6 = new $c_Lcom_softwaremill_quicklens_package$PathModify(x$1, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((a$4) => ((x$4) => new $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$AddNewArrowAction(x$4.i(a$4.ts), a$4.zJ, a$4.Hb, a$4.CK)))(x$1)));
      var mod$1 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4) => new $c_Lorg_jpablo_graphexplorer_viewer_utils_MouseActionRect(_$4.oe, end, shift)));
      return this$6.eF.i(mod$1);
    }
    if ((x$1 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$MoveArrowEndpointAction)) {
      var this$9 = new $c_Lcom_softwaremill_quicklens_package$PathModify(x$1, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((a$6) => ((x$5) => new $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$MoveArrowEndpointAction(x$5.i(a$6.tt), a$6.zM, a$6.zL)))(x$1)));
      var mod$2 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6) => new $c_Lorg_jpablo_graphexplorer_viewer_utils_MouseActionRect(_$6.oe, end, shift)));
      return this$9.eF.i(mod$2);
    }
    throw new $c_s_MatchError(x$1);
  })));
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseActionVar = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseActionVar, "org.jpablo.graphexplorer.viewer.state.mouseActions.MouseActionVar", ({
  ES: 1
}));
function $f_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MoveArrowEndpointOps__handleArrowEndpointControl__Lorg_scalajs_dom_SVGGElement__s_Option__Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction__sci_Map__V($thiz, parent, elem, action, edgePositions) {
  var x = $s_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$__Inactive__Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction();
  if (((x === null) ? (action === null) : x.e(action))) {
    var showControl = true;
  } else {
    var showControl = ((action instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$MoveArrowEndpointAction) && action.tt.c());
  }
  var xs = $m_s_Option$().m2(elem).nG(new $c_s_reflect_ClassTag$GenericClassTag($d_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement.l()));
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var i = 0;
  while ((i < xs.a.length)) {
    var x1 = i;
    var x0 = xs.a[x1];
    var $x_13 = $m_s_Predef$();
    matchResult5: {
      var $x_1;
      if ((x0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_components_selection_EdgeElement)) {
        if (showControl) {
          var x5 = $m_Lorg_jpablo_graphexplorer_viewer_models_Arrow$().aOy(x0.a3c());
          if ((x5 instanceof $c_s_Some)) {
            var arrow = x5.J;
            var nodeIds = $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_NodeId.r().C)([arrow.bX, arrow.c0])));
            var selectableElements = $m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().Ed(parent, nodeIds, $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__selectionStrategyObs__Lcom_raquo_airstream_state_OwnedSignal($thiz)).d());
            var nodeElementsMap = selectableElements.ct(new $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MoveArrowEndpointOps$$anon$1()).eX($m_s_$less$colon$less$().b1);
            var xs$1 = $m_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint$().bbk();
            var f = ((arrow, nodeElementsMap, edge$2, edgePositions) => ((endpoint) => {
              var x$2 = $s_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint$__source__Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint();
              if (((endpoint === null) ? (x$2 === null) : (endpoint === x$2))) {
                var endpointNodeId = arrow.bX;
              } else {
                var endpointNodeId = arrow.c0;
              }
              var endpointElement = nodeElementsMap.r(endpointNodeId);
              var elem$1 = $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowEndpointControl$package$().aVB(edge$2, endpoint, $thiz.H3, endpointElement, edgePositions, $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([]))).e8;
              elem$1.addEventListener("mousedown", ((endpoint$2) => ((ev) => {
                ev.stopPropagation();
                var pos = $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasContainer$package$().aeY(ev).g();
                var this$16 = $thiz.H8;
                var mouseAction = new $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$MoveArrowEndpointAction(new $c_Lorg_jpablo_graphexplorer_viewer_utils_MouseActionRect(pos, pos, false), edge$2, endpoint$2);
                $f_Lcom_raquo_airstream_state_Var__set__O__V(this$16.zN, mouseAction);
              }))(endpoint));
              elem$1.addEventListener("mouseup", ((ev$2) => {
                ev$2.stopPropagation();
                $f_Lcom_raquo_airstream_state_Var__set__O__V($thiz.H8.zN, $s_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$__Inactive__Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction());
              }));
              return elem$1;
            }))(arrow, nodeElementsMap, x0, edgePositions);
            var len = xs$1.a.length;
            var ys = new ($d_Lorg_scalajs_dom_SVGGElement.r().C)(len);
            if ((len > 0)) {
              var i$1 = 0;
              if ((xs$1 !== null)) {
                while ((i$1 < len)) {
                  var $x_2 = i$1;
                  var x0$1 = xs$1.a[i$1];
                  ys.a[$x_2] = f(x0$1);
                  i$1 = ((1 + i$1) | 0);
                }
              } else if ((xs$1 instanceof $ac_I)) {
                while ((i$1 < len)) {
                  var $x_3 = i$1;
                  var x0$2 = xs$1.a[i$1];
                  ys.a[$x_3] = f(x0$2);
                  i$1 = ((1 + i$1) | 0);
                }
              } else if ((xs$1 instanceof $ac_D)) {
                while ((i$1 < len)) {
                  var $x_4 = i$1;
                  var x0$3 = xs$1.a[i$1];
                  ys.a[$x_4] = f(x0$3);
                  i$1 = ((1 + i$1) | 0);
                }
              } else if ((xs$1 instanceof $ac_J)) {
                while ((i$1 < len)) {
                  var $x_7 = i$1;
                  var $x_5 = xs$1.a;
                  var $x_6 = (i$1 << 1);
                  var x0$4_$_lo = $x_5[$x_6];
                  var x0$4_$_hi = $x_5[(($x_6 + 1) | 0)];
                  ys.a[$x_7] = f($bL(x0$4_$_lo, x0$4_$_hi));
                  i$1 = ((1 + i$1) | 0);
                }
              } else if ((xs$1 instanceof $ac_F)) {
                while ((i$1 < len)) {
                  var $x_8 = i$1;
                  var x0$5 = xs$1.a[i$1];
                  ys.a[$x_8] = f(x0$5);
                  i$1 = ((1 + i$1) | 0);
                }
              } else if ((xs$1 instanceof $ac_C)) {
                while ((i$1 < len)) {
                  var $x_9 = i$1;
                  var x0$6 = xs$1.a[i$1];
                  ys.a[$x_9] = f($bC(x0$6));
                  i$1 = ((1 + i$1) | 0);
                }
              } else if ((xs$1 instanceof $ac_B)) {
                while ((i$1 < len)) {
                  var $x_10 = i$1;
                  var x0$7 = xs$1.a[i$1];
                  ys.a[$x_10] = f(x0$7);
                  i$1 = ((1 + i$1) | 0);
                }
              } else if ((xs$1 instanceof $ac_S)) {
                while ((i$1 < len)) {
                  var $x_11 = i$1;
                  var x0$8 = xs$1.a[i$1];
                  ys.a[$x_11] = f(x0$8);
                  i$1 = ((1 + i$1) | 0);
                }
              } else if ((xs$1 instanceof $ac_Z)) {
                while ((i$1 < len)) {
                  var $x_12 = i$1;
                  var x0$9 = xs$1.a[i$1];
                  ys.a[$x_12] = f(x0$9);
                  i$1 = ((1 + i$1) | 0);
                }
              } else {
                throw new $c_s_MatchError(xs$1);
              }
            }
            var $x_1 = ys;
            break matchResult5;
          }
          if (($m_s_None$() === x5)) {
            var $x_1 = new ($d_Lorg_scalajs_dom_SVGGElement.r().C)(0);
            break matchResult5;
          }
          throw new $c_s_MatchError(x5);
        }
      }
      var $x_1 = new ($d_Lorg_scalajs_dom_SVGGElement.r().C)(0);
    }
    var elems$1 = $x_13.fB($x_1);
    var it = $ct_sc_ArrayOps$ArrayIterator__O__(new $c_sc_ArrayOps$ArrayIterator(), elems$1.tK);
    while (it.p()) {
      var elem$2 = it.q();
      var unboxedElem = ((elem$2 === null) ? null : elem$2);
      jsElems.push(unboxedElem);
    }
    i = ((1 + i) | 0);
  }
  var controls = new ($d_Lorg_scalajs_dom_SVGGElement.r().C)(jsElems);
  var this$30 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(parent.querySelectorAll("g.edge-endpoint-disk"));
  var it$1 = this$30.o();
  while (it$1.p()) {
    var x0$11 = it$1.q();
    x0$11.remove();
  }
  var len$1 = controls.a.length;
  var i$2 = 0;
  while ((i$2 < len$1)) {
    var x0$12 = controls.a[i$2];
    parent.appendChild(x0$12);
    i$2 = ((1 + i$2) | 0);
  }
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MoveArrowEndpointOps__onMoveArrowSourceAction__Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$MoveArrowEndpointAction__V($thiz, action) {
  var start = action.zM;
  var neighbors = $m_Lorg_jpablo_graphexplorer_viewer_domUtils_DomUtils$package$().a3d(document, action.tt.jK.fi, action.tt.jK.fj);
  var strategy = $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__selectionStrategyObs__Lcom_raquo_airstream_state_OwnedSignal($thiz)).d();
  matchResult7: {
    var x15 = $m_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$().WO(neighbors, strategy, new $c_s_Some(strategy.Jc()));
    if ((x15 instanceof $c_s_Some)) {
      var targetElementId = x15.J;
      matchResult6: {
        var $x_1;
        if ((start instanceof $c_Lorg_jpablo_graphexplorer_viewer_components_selection_EdgeElement)) {
          if ((targetElementId instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId)) {
            var this$4 = $m_Lorg_jpablo_graphexplorer_viewer_models_Arrow$().aOy(start.a3c());
            if ((!this$4.c())) {
              var x0 = this$4.d();
              if (action.zL.aPr()) {
                var x = x0.bX;
                var $x_1 = ((x === null) ? (targetElementId === null) : x.e(targetElementId));
                break matchResult6;
              } else {
                var x$3 = x0.c0;
                var $x_1 = ((x$3 === null) ? (targetElementId === null) : x$3.e(targetElementId));
                break matchResult6;
              }
            } else {
              var $x_1 = false;
              break matchResult6;
            }
          }
        }
        var $x_1 = false;
      }
      if ((!$x_1)) {
        $thiz.aH().gC($m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_ElementId.r().C)([start.lj(), targetElementId]))));
        break matchResult7;
      } else {
        $thiz.aH().gC($m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_ElementId.r().C)([start.lj()]))));
        break matchResult7;
      }
    }
    if (($m_s_None$() === x15)) {
      $thiz.aH().gC($m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_ElementId.r().C)([start.lj()]))));
      break matchResult7;
    }
    throw new $c_s_MatchError(x15);
  }
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MoveArrowEndpointOps__handleMoveArrowStartMouseUp__Lorg_scalajs_dom_MouseEvent__Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$MoveArrowEndpointAction__V($thiz, ev, action) {
  var selectionNow = $thiz.aH().cL();
  var originator = action.zM;
  var _1 = (+ev.clientX);
  var _2 = (+ev.clientY);
  var bbox = originator.dD().getBoundingClientRect();
  var isMouseInsideSourceNode = ((((_1 >= (+bbox.left)) && (_1 <= (+bbox.right))) && (_2 >= (+bbox.top))) && (_2 <= (+bbox.bottom)));
  if (((selectionNow.aa() === 2) && (!isMouseInsideSourceNode))) {
    var this$5 = $f_Lorg_jpablo_graphexplorer_viewer_models_ElementId__asNodeId__s_Option($m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().aem(selectionNow, originator.lj()).t());
    if ((!this$5.c())) {
      var x0 = this$5.d();
      var dropCell = $thiz.du().Wq(x0, (+ev.clientX), (+ev.clientY));
      var $x_2 = $f_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement__arrowId__s_Option(originator).d();
      matchResult8: {
        var $x_1;
        var x18 = action.zL;
        var x = $s_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint$__source__Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint();
        if (((x === null) ? (x18 === null) : (x === x18))) {
          var $x_1 = new $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowEndpointId$SourceId(x0);
          break matchResult8;
        }
        var x$3 = $s_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint$__target__Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint();
        if (((x$3 === null) ? (x18 === null) : (x$3 === x18))) {
          var $x_1 = new $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowEndpointId$TargetId(x0);
          break matchResult8;
        }
        throw new $c_s_MatchError(x18);
      }
      $thiz.b4v($x_2, $x_1, dropCell);
    }
  }
}
function $f_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MoveArrowEndpointOps__addArrowBetweenPointerAndEndpoint__Lorg_scalajs_dom_SVGGElement__Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$MoveArrowEndpointAction__V($thiz, rootGroup, action) {
  rootGroup.appendChild($m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ArrowWithEndpoint$package$().aVA(action, rootGroup).e8);
}
function $p_Lorg_jpablo_graphexplorer_viewer_telemetry_Telemetry$__asJson__sci_Seq__T($thiz, fields) {
  return JSON.stringify($m_sjs_js_special_package$().eA(fields.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var k = x$1.g();
    var v = x$1.h();
    $m_Lorg_jpablo_graphexplorer_viewer_telemetry_Telemetry$();
    return new $c_T2(k, v);
  })))));
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_telemetry_Telemetry$() {
  this.U7 = null;
  this.abz = null;
  this.aH2 = false;
  this.aH3 = false;
  $n_Lorg_jpablo_graphexplorer_viewer_telemetry_Telemetry$ = this;
  this.U7 = "[telemetry]";
  this.abz = (this.U7 + ".enabled");
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_telemetry_Telemetry$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_telemetry_Telemetry$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_telemetry_Telemetry$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_telemetry_Telemetry$.prototype = $p;
$p.a3f = (function() {
  if ((!this.aH3)) {
    if (((typeof window) !== "undefined")) {
      var this$1 = $m_s_Option$().as(window.sessionStorage.getItem(this.abz));
      var fromSession = ((!this$1.c()) && (this$1.d() === "1"));
      var params = new URLSearchParams(window.location.search);
      var this$2 = $m_s_Option$().as(params.get("telemetry"));
      if ((!this$2.c())) {
        var x0$1 = this$2.d();
        if ((x0$1 === "1")) {
          var $x_2 = true;
        } else {
          _return: {
            var len = x0$1.length;
            if ((len === 4)) {
              var i = 0;
              while ((i !== len)) {
                var thisCP = $f_T__codePointAt__I__I(x0$1, i);
                if (($m_jl_Character$().iy($m_jl_Character$().j0(thisCP)) !== $m_jl_Character$().iy($m_jl_Character$().j0($f_T__codePointAt__I__I("true", i))))) {
                  var $x_2 = false;
                  break _return;
                }
                i = ((i + ((thisCP >= 65536) ? 2 : 1)) | 0);
              }
              var $x_2 = true;
            } else {
              var $x_2 = false;
            }
          }
        }
        if ($x_2) {
          var fromQuery = true;
        } else {
          _return$1: {
            var len$1 = x0$1.length;
            if ((len$1 === 2)) {
              var i$1 = 0;
              while ((i$1 !== len$1)) {
                var thisCP$1 = $f_T__codePointAt__I__I(x0$1, i$1);
                if (($m_jl_Character$().iy($m_jl_Character$().j0(thisCP$1)) !== $m_jl_Character$().iy($m_jl_Character$().j0($f_T__codePointAt__I__I("on", i$1))))) {
                  var fromQuery = false;
                  break _return$1;
                }
                i$1 = ((i$1 + ((thisCP$1 >= 65536) ? 2 : 1)) | 0);
              }
              var fromQuery = true;
            } else {
              var fromQuery = false;
            }
          }
        }
      } else {
        var fromQuery = false;
      }
      if (fromQuery) {
        window.sessionStorage.setItem(this.abz, "1");
      }
      var $x_1 = (fromSession || fromQuery);
    } else {
      var $x_1 = false;
    }
    this.aH2 = $x_1;
    this.aH3 = true;
  }
  return this.aH2;
});
$p.uc = (function() {
  return ((((typeof window) !== "undefined") && ((typeof window.performance) !== "undefined")) ? (+window.performance.now()) : (+new Date().getTime()));
});
$p.r7 = (function(event, fields) {
  if (this.a3f()) {
    console.log(this.U7, $p_Lorg_jpablo_graphexplorer_viewer_telemetry_Telemetry$__asJson__sci_Seq__T(this, new $c_sci_$colon$colon(new $c_T2("event", event), new $c_sci_$colon$colon(new $c_T2("tMs", this.uc()), $m_sci_Nil$())).hK(fields)));
  }
});
$p.b4l = (function(path) {
  if (this.a3f()) {
    window.sessionStorage.setItem(((this.U7 + ".navStart:") + path), ("" + this.uc()));
    this.r7("nav.start", $m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("path", path)])));
  }
});
$p.aYZ = (function(path) {
  if ((!this.a3f())) {
    return $m_s_None$();
  } else {
    var key = ((this.U7 + ".navStart:") + path);
    var this$1 = $m_s_Option$().as(window.sessionStorage.getItem(key));
    if (this$1.c()) {
      var this$5 = $m_s_None$();
    } else {
      var x0 = this$1.d();
      var this$5 = ($m_sc_StringParsers$().c1(x0) ? new $c_s_Some($m_jl_Double$().bd(x0)) : $m_s_None$());
    }
    if (this$5.c()) {
      return $m_s_None$();
    } else {
      var x0$1 = this$5.d();
      var startedAt = (+x0$1);
      window.sessionStorage.removeItem(key);
      return new $c_s_Some(($m_Lorg_jpablo_graphexplorer_viewer_telemetry_Telemetry$().uc() - startedAt));
    }
  }
});
var $d_Lorg_jpablo_graphexplorer_viewer_telemetry_Telemetry$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_telemetry_Telemetry$, "org.jpablo.graphexplorer.viewer.telemetry.Telemetry$", ({
  EV: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_telemetry_Telemetry$;
function $m_Lorg_jpablo_graphexplorer_viewer_telemetry_Telemetry$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_telemetry_Telemetry$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_telemetry_Telemetry$ = new $c_Lorg_jpablo_graphexplorer_viewer_telemetry_Telemetry$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_telemetry_Telemetry$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_utils_ShareUrl$__encode__T__T($thiz, value) {
  return encodeURIComponent(value);
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_utils_ShareUrl$() {
  this.aV0 = null;
  this.aV1 = null;
  this.aV0 = "dot";
  this.aV1 = "https://graph-explorer.net";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_utils_ShareUrl$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_utils_ShareUrl$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_utils_ShareUrl$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_utils_ShareUrl$.prototype = $p;
$p.aY6 = (function(projectId, dot) {
  return ((((((((!$p_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$__invoker__s_Option($m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$()).c()) ? "https://graph-explorer.net" : window.location.origin) + "/") + $m_Lorg_jpablo_graphexplorer_router_Router$().So) + "/") + projectId.cv) + "?dot=") + $p_Lorg_jpablo_graphexplorer_viewer_utils_ShareUrl$__encode__T__T(this, dot));
});
$p.aRm = (function() {
  var params = new URLSearchParams(window.location.search);
  return $m_s_Option$().as(params.get("dot"));
});
$p.b7d = (function() {
  var this$6 = $m_sci_Nil$().b6($m_s_Predef$().fB($f_T__split__T__I__AT(window.location.pathname, "/", 0)));
  var f = ((_$1) => (_$1 !== ""));
  var l = this$6;
  block: {
    var result;
    while (true) {
      if (l.c()) {
        var result = $m_sci_Nil$();
        break;
      } else {
        var h = l.t();
        var t = l.v();
        if ((!(!(!f(h))))) {
          l = t;
          continue;
        }
        var start = l;
        var remaining = t;
        while (true) {
          if (remaining.c()) {
            var result = start;
            break block;
          } else {
            var x = remaining.t();
            if ((!(!f(x)))) {
              remaining = remaining.v();
              continue;
            }
            var firstMiss = remaining;
            var newHead = new $c_sci_$colon$colon(start.t(), $m_sci_Nil$());
            var toProcess = start.v();
            var currentLast = newHead;
            while ((toProcess !== firstMiss)) {
              var newElem = new $c_sci_$colon$colon(toProcess.t(), $m_sci_Nil$());
              currentLast.U = newElem;
              currentLast = newElem;
              toProcess = toProcess.v();
            }
            var next = firstMiss.v();
            var nextToCopy = next;
            while ((!next.c())) {
              var head = next.t();
              if ((!(!f(head)))) {
                next = next.v();
              } else {
                while ((nextToCopy !== next)) {
                  var newElem$2 = new $c_sci_$colon$colon(nextToCopy.t(), $m_sci_Nil$());
                  currentLast.U = newElem$2;
                  currentLast = newElem$2;
                  nextToCopy = nextToCopy.v();
                }
                nextToCopy = next.v();
                next = next.v();
              }
            }
            if ((!nextToCopy.c())) {
              currentLast.U = nextToCopy;
            }
            var result = newHead;
            break block;
          }
        }
      }
    }
  }
  if ((result instanceof $c_sci_$colon$colon)) {
    var x4 = result.U;
    var seg = result.er;
    if ((x4 instanceof $c_sci_$colon$colon)) {
      var x7 = x4.U;
      var id = x4.er;
      if (($m_sci_Nil$().e(x7) && (seg === $m_Lorg_jpablo_graphexplorer_router_Router$().So))) {
        return new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_state_ProjectId(id));
      }
    }
  }
  return $m_s_None$();
});
var $d_Lorg_jpablo_graphexplorer_viewer_utils_ShareUrl$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_utils_ShareUrl$, "org.jpablo.graphexplorer.viewer.utils.ShareUrl$", ({
  EZ: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_utils_ShareUrl$;
function $m_Lorg_jpablo_graphexplorer_viewer_utils_ShareUrl$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_utils_ShareUrl$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_utils_ShareUrl$ = new $c_Lorg_jpablo_graphexplorer_viewer_utils_ShareUrl$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_utils_ShareUrl$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_utils_Utils$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_utils_Utils$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_utils_Utils$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_utils_Utils$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_utils_Utils$package$.prototype = $p;
$p.a3P = (function(xs, a) {
  if ($m_sci_Nil$().e(xs)) {
    return $m_sci_Nil$();
  }
  if ((xs instanceof $c_sci_$colon$colon)) {
    var x7 = xs.er;
    var x8 = xs.U;
    if ($m_sci_Nil$().e(x8)) {
      return $m_sci_Nil$().b6($m_sr_ScalaRunTime$().hP(new $ac_O([x7])));
    }
    return new $c_sci_$colon$colon(x7, new $c_sci_$colon$colon(a, $m_Lorg_jpablo_graphexplorer_viewer_utils_Utils$package$().a3P(x8, a)));
  }
  throw new $c_s_MatchError(xs);
});
var $d_Lorg_jpablo_graphexplorer_viewer_utils_Utils$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_utils_Utils$package$, "org.jpablo.graphexplorer.viewer.utils.Utils$package$", ({
  F3: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_utils_Utils$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_utils_Utils$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_utils_Utils$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_utils_Utils$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_utils_Utils$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_utils_Utils$package$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_widgets_Actions$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_widgets_Actions$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_widgets_Actions$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_widgets_Actions$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_widgets_Actions$package$.prototype = $p;
$p.OO = (function(mods) {
  return $m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$().AB($m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$().iZ($m_Lorg_jpablo_graphexplorer_viewer_widgets_Button$package$().hH($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.wl().n("button"), $f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, mods, $m_s_$less$colon$less$().b1, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())])))));
});
$p.aVz = (function(mods) {
  return $m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$().iZ($m_Lorg_jpablo_graphexplorer_viewer_widgets_Button$package$().hH($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("btn-soft"), $m_Lcom_raquo_laminar_api_package$().b.wl().n("button"), $f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, mods, $m_s_$less$colon$less$().b1, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())]))));
});
$p.Ix = (function(mods) {
  return $m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$().u4($m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$().iZ($m_Lorg_jpablo_graphexplorer_viewer_widgets_Button$package$().hH($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.wl().n("button"), $f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, mods, $m_s_$less$colon$less$().b1, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())])))));
});
var $d_Lorg_jpablo_graphexplorer_viewer_widgets_Actions$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_widgets_Actions$package$, "org.jpablo.graphexplorer.viewer.widgets.Actions$package$", ({
  F5: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_widgets_Actions$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_widgets_Actions$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_widgets_Actions$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_widgets_Actions$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_widgets_Actions$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_widgets_Actions$package$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_widgets_Alert$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_widgets_Alert$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_widgets_Alert$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_widgets_Alert$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_widgets_Alert$package$.prototype = $p;
$p.aep = (function(tone, mods) {
  return $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.XU().s("alert"), $m_Lcom_raquo_laminar_api_package$().b.y.s(("alert " + tone.U8)), $f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, mods, $m_s_$less$colon$less$().b1, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())])));
});
$p.aLF = (function(mods) {
  return $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("toast toast-end z-50"), $f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, mods, $m_s_$less$colon$less$().b1, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_widgets_Alert$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_widgets_Alert$package$, "org.jpablo.graphexplorer.viewer.widgets.Alert$package$", ({
  F6: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_widgets_Alert$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_widgets_Alert$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_widgets_Alert$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_widgets_Alert$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_widgets_Alert$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_widgets_Alert$package$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_widgets_Button$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_widgets_Button$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_widgets_Button$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_widgets_Button$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_widgets_Button$package$.prototype = $p;
$p.hH = (function(mods) {
  return $m_Lcom_raquo_laminar_api_package$().b.IF().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("btn"), $f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, mods, $m_s_$less$colon$less$().b1, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_widgets_Button$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_widgets_Button$package$, "org.jpablo.graphexplorer.viewer.widgets.Button$package$", ({
  Fb: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_widgets_Button$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_widgets_Button$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_widgets_Button$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_widgets_Button$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_widgets_Button$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_widgets_Button$package$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_widgets_Dialog$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_widgets_Dialog$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_widgets_Dialog$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_widgets_Dialog$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_widgets_Dialog$package$.prototype = $p;
$p.Iw = (function(onDismiss, mods, contents, action) {
  var $x_6 = $m_Lorg_jpablo_graphexplorer_viewer_domUtils_DomUtils$package$().ayQ;
  var $x_5 = $m_sr_ScalaRunTime$();
  var $x_4 = $m_Lcom_raquo_laminar_api_package$().b.y.s("modal");
  var $x_3 = $f_Lcom_raquo_laminar_api_MountHooks__onMountCallback__F1__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((ctx) => {
    var el = ctx.JW.en;
    if ((!(!el.open))) {
      el.close();
    }
    el.showModal();
  })));
  var $x_2 = $f_Lcom_raquo_laminar_api_MountHooks__onUnmountCallback__F1__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => {
    _$1.en.close();
  })));
  var this$4 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.m1(), false, false)).pt(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => (_$2.key === "Escape")))).jY();
  $m_Lcom_raquo_laminar_api_package$features$().cz();
  var $x_1 = new $c_Lcom_raquo_laminar_modifiers_EventListener(this$4, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2$1) => {
    onDismiss.a3();
  })));
  var this$6 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lorg_jpablo_graphexplorer_viewer_domUtils_DomUtils$package$().ayR, false, false));
  $m_Lcom_raquo_laminar_api_package$features$().cz();
  return $x_6.w($x_5.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_4, $x_3, $x_2, $x_1, new $c_Lcom_raquo_laminar_modifiers_EventListener(this$6, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2$2) => {
    onDismiss.a3();
  }))), $f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, mods, $m_s_$less$colon$less$().b1, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$()), $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("modal-box"), $f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, contents, $m_s_$less$colon$less$().b1, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$()), $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("modal-action"), $m_Lcom_raquo_laminar_api_package$().b.aOj().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.b4r().n("dialog"), $f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, action, $m_s_$less$colon$less$().b1, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())])))])))])))])));
});
$p.aeu = (function(open, contents) {
  var $x_10 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_9 = $m_sr_ScalaRunTime$();
  $m_Lcom_raquo_laminar_api_package$();
  var $x_8 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Dialog$package$();
  var $x_7 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lcom_raquo_airstream_state_Var__set__O__V(open, false);
  }));
  var $x_6 = $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([]));
  var $x_5 = $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, contents, $m_s_$less$colon$less$().b1, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())]));
  var $x_4 = $m_sr_ScalaRunTime$();
  var $x_3 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_Actions$package$();
  var $x_2 = $m_sr_ScalaRunTime$();
  var $x_1 = $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, "Close", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7);
  var this$6 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false));
  var onNext = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lcom_raquo_airstream_state_Var__set__O__V(open, false);
  }));
  $m_Lcom_raquo_laminar_api_package$features$().cz();
  return $x_10.w($x_9.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([new $c_Lcom_raquo_laminar_receivers_LockedChildReceiver($x_8.Iw($x_7, $x_6, $x_5, $x_4.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_3.Ix($x_2.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_1, new $c_Lcom_raquo_laminar_modifiers_EventListener(this$6, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => {
    onNext.a3();
  })))])))])))).gR(open)])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_widgets_Dialog$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_widgets_Dialog$package$, "org.jpablo.graphexplorer.viewer.widgets.Dialog$package$", ({
  Fc: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_widgets_Dialog$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_widgets_Dialog$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_widgets_Dialog$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_widgets_Dialog$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_widgets_Dialog$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_widgets_Dialog$package$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$.prototype = $p;
$p.AB = (function(elem) {
  return $f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement(elem, $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("btn-primary")])));
});
$p.ai5 = (function(elem) {
  return $f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement(elem, $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("btn-sm")])));
});
$p.iZ = (function(elem) {
  return $f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement(elem, $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("btn-xs")])));
});
$p.u4 = (function(elem) {
  return $f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement(elem, $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("btn-ghost")])));
});
$p.b91 = (function(elem) {
  return $f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement(elem, $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("btn-soft")])));
});
$p.aLL = (function(elem, flag) {
  return $f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement(elem, $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("btn-active").bj(flag)])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$, "org.jpablo.graphexplorer.viewer.widgets.ExtensionMethods$package$", ({
  Fd: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_widgets_IconButton$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_widgets_IconButton$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_widgets_IconButton$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_widgets_IconButton$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_widgets_IconButton$package$.prototype = $p;
$p.Ae = (function(icon, tip, tipPos, mods, action) {
  var $x_5 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_IconButton$package$();
  var $x_4 = $m_Lcom_raquo_laminar_api_package$().b.IF();
  var $x_3 = $m_sr_ScalaRunTime$();
  var $x_2 = $m_Lcom_raquo_laminar_api_package$().b.wl().n("button");
  var $x_1 = $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s(icon)])));
  var this$2 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false));
  $m_Lcom_raquo_laminar_api_package$features$().cz();
  return $x_5.aPa(tip, tipPos, $x_4.w($x_3.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_2, $x_1, new $c_Lcom_raquo_laminar_modifiers_EventListener(this$2, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => {
    action.a3();
  })))]))), mods);
});
$p.ON = (function(icon, tip, flag, tipPos, mods) {
  var $x_6 = $m_Lorg_jpablo_graphexplorer_viewer_widgets_IconButton$package$();
  var $x_5 = $m_Lcom_raquo_laminar_api_package$().b.IF();
  var $x_4 = $m_sr_ScalaRunTime$();
  var $x_3 = $m_Lcom_raquo_laminar_api_package$().b.wl().n("button");
  var $x_2 = $m_Lcom_raquo_laminar_api_package$().b.y.s("active").bj(flag.P());
  var $x_1 = $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s(icon)])));
  var this$3 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false));
  var onNext = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lcom_raquo_airstream_state_Var__update__F1__V(flag, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => (!(!(!_$1))))));
  }));
  $m_Lcom_raquo_laminar_api_package$features$().cz();
  return $x_6.aPa(tip, tipPos, $x_5.w($x_4.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_3, $x_2, $x_1, new $c_Lcom_raquo_laminar_modifiers_EventListener(this$3, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => {
    onNext.a3();
  })))]))), mods);
});
$p.aVY = (function(icon, tip, mods, action) {
  var $x_7 = $m_Lcom_raquo_laminar_api_package$().b.IF();
  var $x_6 = $m_sr_ScalaRunTime$();
  var $x_5 = $m_Lcom_raquo_laminar_api_package$().b.y.s("gx-icon-btn");
  var $x_4 = $m_Lcom_raquo_laminar_api_package$().b.wl().n("button");
  var $x_3 = $m_Lcom_raquo_laminar_api_package$().b.eW().n(tip);
  var $x_2 = $m_Lcom_raquo_laminar_api_package$().b.Af().Aq().n(tip);
  var $x_1 = $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s(icon)])));
  var this$2 = ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false));
  $m_Lcom_raquo_laminar_api_package$features$().cz();
  return $x_7.w($x_6.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_5, $x_4, $x_3, $x_2, $x_1, new $c_Lcom_raquo_laminar_modifiers_EventListener(this$2, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => {
    action.a3();
  }))), $f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, mods, $m_s_$less$colon$less$().b1, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())])));
});
$p.aPa = (function(tip, tipPos, control, mods) {
  return $m_Lorg_jpablo_graphexplorer_viewer_widgets_Tooltip$package$().Iz(tip, $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s(tipPos), $f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement(control, $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("gx-icon-btn"), $m_Lcom_raquo_laminar_api_package$().b.Af().Aq().n(tip), $f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, mods, $m_s_$less$colon$less$().b1, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())])))])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_widgets_IconButton$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_widgets_IconButton$package$, "org.jpablo.graphexplorer.viewer.widgets.IconButton$package$", ({
  Fe: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_widgets_IconButton$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_widgets_IconButton$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_widgets_IconButton$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_widgets_IconButton$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_widgets_IconButton$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_widgets_IconButton$package$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_widgets_Icons$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_widgets_Icons$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_widgets_Icons$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_widgets_Icons$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_widgets_Icons$.prototype = $p;
$p.aeS = (function(elem) {
  return $f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement(elem, $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("bi bi-x-lg")])));
});
$p.aZw = (function(elem) {
  return $f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement(elem, $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("bi bi-dash")])));
});
$p.b1b = (function(elem) {
  return $f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement(elem, $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("bi bi-file-code")])));
});
$p.aOf = (function(elem) {
  return $f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement(elem, $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("bi bi-folder")])));
});
$p.b49 = (function(elem) {
  return $f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement(elem, $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("bi bi-list")])));
});
$p.b6J = (function(elem) {
  return $f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement(elem, $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("bi bi-plus-circle")])));
});
$p.b6K = (function(elem) {
  return $f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement(elem, $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("bi bi-plus")])));
});
$p.aSQ = (function(elem) {
  return $f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement(elem, $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("bi bi-three-dots-vertical")])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_widgets_Icons$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_widgets_Icons$, "org.jpablo.graphexplorer.viewer.widgets.Icons$", ({
  Ff: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_widgets_Icons$;
function $m_Lorg_jpablo_graphexplorer_viewer_widgets_Icons$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_widgets_Icons$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_widgets_Icons$ = new $c_Lorg_jpablo_graphexplorer_viewer_widgets_Icons$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_widgets_Icons$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputVariant$() {
  this.aH6 = null;
  this.aH5 = null;
  this.aH4 = null;
  $n_Lorg_jpablo_graphexplorer_viewer_widgets_InputVariant$ = this;
  this.aH6 = $m_Lcom_raquo_laminar_api_package$().b.y.s("input-xs");
  this.aH5 = $m_Lcom_raquo_laminar_api_package$().b.y.s("input-sm");
  this.aH4 = $m_Lcom_raquo_laminar_api_package$().b.y.s("input-ghost");
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputVariant$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputVariant$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_widgets_InputVariant$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_widgets_InputVariant$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_viewer_widgets_InputVariant$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_widgets_InputVariant$, "org.jpablo.graphexplorer.viewer.widgets.InputVariant$", ({
  Fi: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_widgets_InputVariant$;
function $m_Lorg_jpablo_graphexplorer_viewer_widgets_InputVariant$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_widgets_InputVariant$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_widgets_InputVariant$ = new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputVariant$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_widgets_InputVariant$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$.prototype = $p;
$p.aWh = (function(placeholderText, options, mods) {
  var $x_5 = $m_Lcom_raquo_laminar_api_package$().b.ahU();
  var $x_4 = $m_sr_ScalaRunTime$();
  var $x_3 = $m_Lcom_raquo_laminar_api_package$().b.y.s("select select-xs");
  var $x_2 = $m_Lcom_raquo_laminar_api_package$().b;
  if (placeholderText.c()) {
    var $x_1 = $m_s_None$();
  } else {
    var x0 = placeholderText.d();
    var $x_1 = new $c_s_Some($m_Lcom_raquo_laminar_api_package$().b.Jd().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, x0, $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7), $m_Lcom_raquo_laminar_api_package$().b.aNw().n(true), $m_Lcom_raquo_laminar_api_package$().b.b8o().n(true)]))));
  }
  return $x_5.w($x_4.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_3, $f_Lcom_raquo_laminar_api_Implicits__nodeOptionToModifier__s_Option__Lcom_raquo_laminar_modifiers_Modifier($x_2, $x_1), $f_Lcom_raquo_laminar_api_Implicits__nodeSeqToModifier__O__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, options.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var name = x$1.g();
    var id = x$1.h();
    return $m_Lcom_raquo_laminar_api_package$().b.Jd().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, name, $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7), $m_Lcom_raquo_laminar_api_package$().b.jx().n(id)])));
  }))), $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$()), $f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, mods, $m_s_$less$colon$less$().b1, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())])));
});
$p.aet = (function(mods) {
  return $m_Lcom_raquo_laminar_api_package$().b.ahU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("select"), $f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, mods, $m_s_$less$colon$less$().b1, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())])));
});
$p.aLv = (function(mods) {
  return $m_Lcom_raquo_laminar_api_package$().b.Xp().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("input"), $f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, mods, $m_s_$less$colon$less$().b1, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())])));
});
$p.aWc = (function(mods) {
  return $m_Lcom_raquo_laminar_api_package$().b.w7().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.yo().n("range"), $m_Lcom_raquo_laminar_api_package$().b.y.s("range range-xs"), $f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, mods, $m_s_$less$colon$less$().b1, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())])));
});
$p.aLG = (function(flag, mods) {
  return $m_Lcom_raquo_laminar_api_package$().b.w7().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.yo().n("checkbox"), $m_Lcom_raquo_laminar_api_package$().b.y.s("toggle toggle-sm"), $m_Lcom_raquo_laminar_api_package$().b.Wr().bj(flag), new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.Eb(), false, false)).agZ(), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => {
    flag.jA().bA(_$1);
  }))), $f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, mods, $m_s_$less$colon$less$().b1, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())])));
});
$p.a2s = (function(mods) {
  return $m_Lcom_raquo_laminar_api_package$().b.aSI().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("textarea w-full"), $f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, mods, $m_s_$less$colon$less$().b1, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())])));
});
$p.aVO = (function(mods) {
  return $m_Lcom_raquo_laminar_api_package$().b.w7().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.yo().n("text"), $m_Lcom_raquo_laminar_api_package$().b.y.s("input w-full"), $f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, mods, $m_s_$less$colon$less$().b1, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())])));
});
$p.aLC = (function(active, onIcon, offIcon) {
  return $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("swap swap-rotate"), $m_Lcom_raquo_laminar_api_package$().b.y.s("swap-active").bj(active), $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s(("swap-on " + onIcon))]))), $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s(("swap-off " + offIcon))])))])));
});
$p.aLu = (function(groupName, options, labelOf, selected, resetTitle, x$6) {
  return $m_Lcom_raquo_laminar_api_package$().b.aOj().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("filter flex-nowrap"), $m_Lcom_raquo_laminar_api_package$().b.w7().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("btn btn-sm btn-square"), $m_Lcom_raquo_laminar_api_package$().b.yo().n("reset"), $m_Lcom_raquo_laminar_api_package$().b.jx().n("\u00d7"), $m_Lcom_raquo_laminar_api_package$().b.eW().n(resetTitle), new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => {
    $f_Lcom_raquo_airstream_state_Var__set__O__V(selected, $m_s_None$());
  })))]))), $f_Lcom_raquo_laminar_api_Implicits__nodeSeqToModifier__O__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, options.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((opt) => $m_Lcom_raquo_laminar_api_package$().b.w7().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("btn btn-sm"), $m_Lcom_raquo_laminar_api_package$().b.yo().n("radio"), $m_Lcom_raquo_laminar_api_package$().b.b4H().n(groupName), $m_Lorg_jpablo_graphexplorer_viewer_domUtils_DomUtils$package$().a9X.n(labelOf.i(opt)), $m_Lcom_raquo_laminar_api_package$().b.Wr().bj($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), selected.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3) => _$3.E(opt))), $m_s_None$())), new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.Eb(), false, false)).Xv(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => new $c_s_Some(opt)))), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => {
    selected.jA().bA(_$1);
  })))])))))), $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())])));
});
$p.aVZ = (function(options, selected, x$3) {
  return $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("join"), $f_Lcom_raquo_laminar_api_Implicits__nodeSeqToModifier__O__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, options.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var value = x$1.bH;
    var icon = x$1.bU;
    var label = x$1.c3;
    return $m_Lcom_raquo_laminar_api_package$().b.IF().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.wl().n("button"), $m_Lcom_raquo_laminar_api_package$().b.y.s("join-item btn btn-sm btn-square"), $m_Lcom_raquo_laminar_api_package$().b.eW().n(label), $m_Lorg_jpablo_graphexplorer_viewer_domUtils_DomUtils$package$().a9X.n(label), $m_Lcom_raquo_laminar_api_package$().b.y.s("btn-active").bj($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), selected.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4) => $m_sr_BoxesRunTime$().Q(_$4, value))), $m_s_None$())), $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s(icon)]))), new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$5) => {
      $f_Lcom_raquo_airstream_state_Var__set__O__V(selected, value);
    })))])));
  }))), $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())])));
});
$p.aW4 = (function(options, onClickHandler) {
  return $m_Lcom_raquo_laminar_api_package$().b.Q6().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.wj().n(0), $m_Lcom_raquo_laminar_api_package$().b.y.s("menu menu-xs bg-base-100 rounded-box z-1 shadow-lg p-1 border border-base-300"), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_inserters_ChildrenInserter$().IB($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), options, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((opts) => opts.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((entry) => {
    if ((entry instanceof $c_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$MenuOption)) {
      var x12 = entry.Ud;
      var x13 = entry.Uf;
      var x14 = entry.Uc;
      var x15 = entry.Ue;
      matchResult5: {
        var nameMod;
        if ($is_Lcom_raquo_laminar_modifiers_Modifier(x12)) {
          var nameMod = x12;
          break matchResult5;
        }
        if (((typeof x12) === "string")) {
          var nameMod = $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, x12, $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])));
          break matchResult5;
        }
        throw new $c_s_MatchError(x12);
      }
      var $x_11 = $m_Lcom_raquo_laminar_api_package$().b.yc();
      var $x_10 = $m_sr_ScalaRunTime$();
      var $x_9 = $m_Lcom_raquo_laminar_api_package$().b.DD();
      var $x_8 = $m_sr_ScalaRunTime$();
      var $x_7 = $m_Lcom_raquo_laminar_api_package$().b.y.s("rounded-field");
      var $x_6 = $m_Lcom_raquo_laminar_api_package$().b.y.s("flex justify-between");
      var $x_5 = $m_Lcom_raquo_laminar_api_package$().b.eW().b4o(x14);
      var $x_4 = $m_Lcom_raquo_laminar_api_package$().b;
      if (x15.c()) {
        var $x_1 = $m_s_None$();
      } else {
        var x0 = x15.d();
        var $x_3 = $m_Lorg_jpablo_graphexplorer_viewer_utils_Utils$package$();
        var f = ((s) => $m_Lcom_raquo_laminar_api_package$().b.oD().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("kbd kbd-sm opacity-60"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, s, $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))));
        if ((x0 === $m_sci_Nil$())) {
          var $x_2 = $m_sci_Nil$();
        } else {
          var x0$1 = x0.t();
          var h = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
          var t = h;
          var rest = x0.v();
          while ((rest !== $m_sci_Nil$())) {
            var x0$2 = rest.t();
            var nx = new $c_sci_$colon$colon(f(x0$2), $m_sci_Nil$());
            t.U = nx;
            t = nx;
            rest = rest.v();
          }
          var $x_2 = h;
        }
        var $x_1 = new $c_s_Some($x_3.a3P($x_2, $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, " + ", $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))));
      }
      return $x_11.w($x_10.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_9.w($x_8.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_7, $x_6, $x_5, nameMod, $f_Lcom_raquo_laminar_api_Implicits__optionToModifier__s_Option__F1__Lcom_raquo_laminar_modifiers_Modifier($x_4, $x_1, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((nodes) => $f_Lcom_raquo_laminar_api_Implicits__nodeSeqToModifier__O__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, nodes, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())))), onClickHandler.i(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false)).Xv(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => x13))))])))])));
    }
    var x = $s_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$__Sep__Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry();
    if (((x === null) ? (entry === null) : x.e(entry))) {
      return $m_Lcom_raquo_laminar_api_package$().b.yc().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([])));
    }
    throw new $c_s_MatchError(entry);
  }))))), $m_s_None$()), $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$(), $m_Lcom_raquo_laminar_modifiers_RenderableNode$().ht, (void 0)))])));
});
$p.aR2 = (function(row, rowOption) {
  var $x_5 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_4 = $m_sr_ScalaRunTime$();
  var $x_3 = $m_Lcom_raquo_laminar_api_package$().b.y.s("p-1");
  var $x_2 = $m_Lcom_raquo_laminar_api_package$().b.y.s("bg-base-200").bj($m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$().b3o(row, rowOption));
  var $x_1 = $m_Lcom_raquo_laminar_api_package$().b.eW().n(rowOption.x5);
  var this$2 = rowOption.Ga;
  return $x_5.w($x_4.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_3, $x_2, $x_1, (this$2.c() ? $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, rowOption.x5, $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))) : this$2.d().a3()), new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false)).Xv(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => rowOption.zh))), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((sink) => ((_$1) => {
    sink.jA().bA(_$1);
  }))(row.cl)))])));
});
$p.aLx = (function(row, options, cardClass) {
  var $x_6 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_5 = $m_sr_ScalaRunTime$();
  var $x_4 = $m_Lcom_raquo_laminar_api_package$().b.wj().n(0);
  var $x_3 = $m_Lcom_raquo_laminar_api_package$().b.y.s("dropdown-content card card-xs popup-card");
  var $x_2 = $m_Lcom_raquo_laminar_api_package$().b;
  if (cardClass.c()) {
    var $x_1 = $m_s_None$();
  } else {
    var x0 = cardClass.d();
    var $x_1 = new $c_s_Some($m_Lcom_raquo_laminar_api_package$().b.y.s(x0));
  }
  return $x_6.w($x_5.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_4, $x_3, $f_Lcom_raquo_laminar_api_Implicits__optionToSetter__s_Option__Lcom_raquo_laminar_modifiers_Setter($x_2, $x_1), $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("card-body p-0"), $m_Lcom_raquo_laminar_api_package$().b.Q6().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.wj().n(0), $m_Lcom_raquo_laminar_api_package$().b.y.s("p-0 m-0 menu menu-horizontal [&:before]:hidden"), $f_Lcom_raquo_laminar_api_Implicits__nodeSeqToModifier__O__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, options.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((option) => $m_Lcom_raquo_laminar_api_package$().b.yc().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().aR2(row, option)])))))), $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())])))])))])));
});
$p.aLw = (function(row, initial, dir, cardClass) {
  var initialOptions = row.j6.Jt(initial);
  var extraOptions = row.j6.ds(initial);
  var $x_15 = $m_Lcom_raquo_laminar_api_package$().b.Q6();
  var $x_14 = $m_sr_ScalaRunTime$();
  var $x_13 = $m_Lcom_raquo_laminar_api_package$().b.wj().n(0);
  var $x_12 = $m_Lcom_raquo_laminar_api_package$().b.y.s("menu-with-extra-dropdown menu menu-horizontal bg-base-100 rounded-box p-0");
  var $x_11 = $m_Lcom_raquo_laminar_api_package$().b.y.s("justify-between").xV((!extraOptions.c()));
  var $x_10 = $f_Lcom_raquo_laminar_api_Implicits__nodeSeqToModifier__O__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, initialOptions.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((option) => $m_Lcom_raquo_laminar_api_package$().b.yc().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().aR2(row, option)])))))), $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$());
  var $x_9 = $m_Lcom_raquo_laminar_api_package$().b.yc();
  var $x_8 = $m_sr_ScalaRunTime$();
  var $x_7 = $m_Lcom_raquo_laminar_api_package$().b.y.s("justify-center");
  var $x_6 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_5 = $m_sr_ScalaRunTime$();
  var $x_4 = $m_Lcom_raquo_laminar_api_package$().b.y.s("dropdown dropdown-bottom p-0 m-0");
  var $x_3 = $m_Lcom_raquo_laminar_api_package$().b.y.s("dropdown-start");
  var x$2 = $s_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$__start__Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection();
  var $x_2 = $x_3.xV(((dir === null) ? (x$2 === null) : (dir === x$2)));
  var $x_1 = $m_Lcom_raquo_laminar_api_package$().b.y.s("dropdown-end");
  var x$4 = $s_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$__end__Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection();
  return $x_15.w($x_14.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_13, $x_12, $x_11, $x_10, $x_9.w($x_8.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_7, $x_6.w($x_5.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_4, $x_2, $x_1.xV(((dir === null) ? (x$4 === null) : (dir === x$4))), (extraOptions.c() ? $m_Lcom_raquo_laminar_api_package$().b.JU : $f_Lcom_raquo_laminar_api_Implicits__nodeSeqToModifier__O__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, new $c_sci_$colon$colon($m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.wj().n(0), $m_Lcom_raquo_laminar_api_package$().b.XU().s("button"), $m_Lcom_raquo_laminar_api_package$().b.y.s("btn btn-ghost btn-xs px-1"), $m_Lorg_jpablo_graphexplorer_viewer_widgets_Icons$().aSQ($m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([]))))]))), new $c_sci_$colon$colon($m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().aLx(row, extraOptions, cardClass), $m_sci_Nil$())), $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$()))])))])))])));
});
$p.aVQ = (function(row, dir, cardClass, open) {
  var $x_17 = $m_Lcom_raquo_laminar_api_package$().b.a8();
  var $x_16 = $m_sr_ScalaRunTime$();
  var $x_15 = $m_Lcom_raquo_laminar_api_package$().b.y.s("menu dropdown dropdown-bottom p-0 m-0");
  var $x_14 = $m_Lcom_raquo_laminar_api_package$().b.y.s("dropdown-open").xV(open);
  var $x_13 = $m_Lcom_raquo_laminar_api_package$().b.y.s("dropdown-start");
  var x$2 = $s_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$__start__Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection();
  var $x_12 = $x_13.xV(((dir === null) ? (x$2 === null) : (dir === x$2)));
  var $x_11 = $m_Lcom_raquo_laminar_api_package$().b.y.s("dropdown-end");
  var x$4 = $s_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$__end__Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection();
  var $x_10 = $x_11.xV(((dir === null) ? (x$4 === null) : (dir === x$4)));
  if (row.j6.c()) {
    var $x_1 = $m_Lcom_raquo_laminar_api_package$().b.JU;
  } else {
    var $x_9 = $m_Lcom_raquo_laminar_api_package$().b;
    var $x_8 = $m_Lcom_raquo_laminar_api_package$().b.a8();
    var $x_7 = $m_sr_ScalaRunTime$();
    var $x_6 = $m_Lcom_raquo_laminar_api_package$().b.wj().n(0);
    var $x_5 = $m_Lcom_raquo_laminar_api_package$().b.XU().s("button");
    var $x_4 = $m_Lcom_raquo_laminar_api_package$().b.y.s("btn btn-ghost btn-xs p-1 ml-1");
    matchResult7: {
      var $x_2;
      var x16 = row.eI;
      if ((x16 instanceof $c_s_Some)) {
        var glyph = x16.J;
        var $x_2 = $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("gx-color-trigger"), glyph.a3(), $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("gx-color-bar"), $m_Lcom_raquo_laminar_api_package$().b.y.s("gx-color-bar-none").bj($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$().y3(row), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v) => ((v === "none") || (v === "")))), $m_s_None$())), $m_Lcom_raquo_laminar_api_package$().b.PZ().bj($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$().y3(row), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v$2) => {
          if (((v$2 === "none") || (v$2 === ""))) {
            return "";
          } else {
            try {
              var $x_3 = new $c_s_util_Success(("background-color: " + $m_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$().Y7($m_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$().ag7(v$2)).C4));
            } catch (e) {
              var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
              matchEnd8: {
                var $x_3;
                if ($m_s_util_control_NonFatal$().ew(e$2)) {
                  var $x_3 = new $c_s_util_Failure(e$2);
                  break matchEnd8;
                }
                throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
              }
            }
            return $x_3.X2(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => "")));
          }
        })), $m_s_None$()))])))])));
        break matchResult7;
      }
      if (($m_s_None$() === x16)) {
        $m_Lcom_raquo_laminar_api_package$();
        var $x_2 = $m_Lcom_raquo_laminar_inserters_ChildInserter$().nv($m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$().ahW(row), $m_Lcom_raquo_laminar_modifiers_RenderableNode$().ht, (void 0));
        break matchResult7;
      }
      throw new $c_s_MatchError(x16);
    }
    var $x_1 = $f_Lcom_raquo_laminar_api_Implicits__nodeSeqToModifier__O__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($x_9, new $c_sci_$colon$colon($x_8.w($x_7.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_6, $x_5, $x_4, $x_2]))), new $c_sci_$colon$colon($m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().aLx(row, row.j6, cardClass), $m_sci_Nil$())), $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$());
  }
  return $x_17.w($x_16.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_15, $x_14, $x_12, $x_10, $x_1])));
});
$p.aLr = (function(row) {
  return $f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement($m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().DB($m_Lcom_raquo_laminar_api_package$().b.Af().Aq().n(row.cF), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_airstream_state_Val$().iT(row.j6.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((o) => {
    var this$2 = o.Ga;
    return new $c_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$MenuOption((this$2.c() ? new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((o$1$2) => (() => $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, o$1$2.x5, $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])))))(o)) : this$2.d()).a3(), o.zh, new $c_s_Some(o.x5), $m_s_None$());
  }))))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$7) => new $c_Lcom_raquo_laminar_modifiers_EventListener(_$7, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((attrValue) => {
    $f_Lcom_raquo_airstream_state_Var__set__O__V(row.cl, attrValue);
  }))))), ($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_inserters_ChildInserter$().nv($m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$().ahW(row), $m_Lcom_raquo_laminar_modifiers_RenderableNode$().ht, (void 0))), false, "items-center"), $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("dropdown-center")])));
});
$p.DB = (function(title, options, onClickHandler, icon, join, menuCls) {
  return $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().aeq(title, icon, join, $f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement($m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().aW4(options, onClickHandler), $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s(menuCls)]))));
});
$p.a2t = (function() {
  return $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("bi bi-chevron-down")])));
});
$p.aeq = (function(title, icon, join, body) {
  return $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("dropdown"), $m_Lorg_jpablo_graphexplorer_viewer_widgets_ExtensionMethods$package$().iZ($m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.wj().n(0), $m_Lcom_raquo_laminar_api_package$().b.XU().s("button"), $m_Lcom_raquo_laminar_api_package$().b.y.s("btn whitespace-nowrap btn-ghost p-1 ml-1"), $m_Lcom_raquo_laminar_api_package$().b.y.s("join-item").xV(join), title, icon])))), $f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement(body, $m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("dropdown-content"), $m_Lcom_raquo_laminar_api_package$().b.wj().n(0)])))])));
});
$p.aLs = (function() {
  return $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("bi bi-chevron-down")])));
});
$p.aLA = (function(row, mods) {
  var $x_5 = $m_Lcom_raquo_laminar_api_package$().b.ahU();
  var $x_4 = $m_sr_ScalaRunTime$();
  var $x_3 = $m_Lcom_raquo_laminar_api_package$().b.y.s("select select-xs");
  var $x_2 = $m_Lcom_raquo_laminar_api_package$().b.y.s(("cls-" + new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId(row.da)));
  var $x_1 = $f_Lcom_raquo_laminar_api_Implicits__nodeSeqToModifier__O__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, row.j6.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((o) => $m_Lcom_raquo_laminar_api_package$().b.Jd().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, o.x5, $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7), $m_Lcom_raquo_laminar_api_package$().b.jx().n(o.zh.m())])))))), $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$());
  $m_Lcom_raquo_laminar_api_package$();
  var updater = $m_Lcom_raquo_laminar_api_package$().b.jx().bj($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$().a2y(row), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var v = x$1.g();
    var d = x$1.h();
    return $dp_toString__T(v.a3D(d));
  })), $m_s_None$()));
  var listener = new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.Eb(), false, false)).nC().E9(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v$1) => new $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single(($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(v$1)))))), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((sink) => ((_$1) => {
    sink.jA().bA(_$1);
  }))(row.cl)));
  return $x_5.w($x_4.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_3, $x_2, $x_1, $m_Lcom_raquo_laminar_inputs_InputController$().qU(listener, updater), $f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, mods, $m_s_$less$colon$less$().b1, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())])));
});
$p.aes = (function(row, setFocus) {
  matchResult8: {
    var extra;
    var x19 = row.cJ;
    if ((x19 instanceof $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$number)) {
      var x27 = x19.Ua;
      var x28 = x19.U9;
      var x29 = x19.Ub;
      var $x_6 = $m_Lcom_raquo_laminar_api_package$().b.y.s("input input-xs text-right");
      var $x_5 = $m_Lcom_raquo_laminar_api_package$().b.ah3();
      var this$3 = (x27.c() ? $m_s_None$() : new $c_s_Some(("" + (+x27.d()))));
      var $x_4 = $x_5.n((this$3.c() ? "" : this$3.d()));
      var $x_3 = $m_Lcom_raquo_laminar_api_package$().b.ah0();
      var this$5 = (x28.c() ? $m_s_None$() : new $c_s_Some(("" + (+x28.d()))));
      var $x_2 = $x_3.n((this$5.c() ? "" : this$5.d()));
      var $x_1 = $m_Lcom_raquo_laminar_api_package$().b.ai8();
      var this$7 = (x29.c() ? $m_s_None$() : new $c_s_Some(("" + (+x29.d()))));
      var extra = new $c_sci_$colon$colon($x_6, new $c_sci_$colon$colon($x_4, new $c_sci_$colon$colon($x_2, new $c_sci_$colon$colon($x_1.n((this$7.c() ? "" : this$7.d())), $m_sci_Nil$()))));
      break matchResult8;
    }
    if ((x19 instanceof $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$range)) {
      var x22 = x19.Nb;
      var x23 = x19.Na;
      var x24 = x19.Nc;
      var $x_12 = $m_Lcom_raquo_laminar_api_package$().b.y.s("range range-xs input-ghost");
      var $x_11 = $m_Lcom_raquo_laminar_api_package$().b.ah3();
      var this$10 = (x22.c() ? $m_s_None$() : new $c_s_Some(("" + (+x22.d()))));
      var $x_10 = $x_11.n((this$10.c() ? "" : this$10.d()));
      var $x_9 = $m_Lcom_raquo_laminar_api_package$().b.ah0();
      var this$12 = (x23.c() ? $m_s_None$() : new $c_s_Some(("" + (+x23.d()))));
      var $x_8 = $x_9.n((this$12.c() ? "" : this$12.d()));
      var $x_7 = $m_Lcom_raquo_laminar_api_package$().b.ai8();
      var this$14 = (x24.c() ? $m_s_None$() : new $c_s_Some(("" + (+x24.d()))));
      var extra = new $c_sci_$colon$colon($x_12, new $c_sci_$colon$colon($x_10, new $c_sci_$colon$colon($x_8, new $c_sci_$colon$colon($x_7.n((this$14.c() ? "" : this$14.d())), $m_sci_Nil$()))));
      break matchResult8;
    }
    var extra = new $c_sci_$colon$colon($m_Lcom_raquo_laminar_api_package$().b.y.s("input input-xs input-ghost hover"), $m_sci_Nil$());
  }
  var colorType = $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$().y3(row), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((s) => $m_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$().ag7(s))), $m_s_None$());
  matchResult9: {
    var valueSignal;
    var x30 = row.cJ;
    var x = $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__color__Lorg_jpablo_graphexplorer_viewer_widgets_InputType();
    if (((x === null) ? (x30 === null) : x.e(x30))) {
      var valueSignal = $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), colorType, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((c) => $m_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$().ba8(c).C4)), $m_s_None$());
      break matchResult9;
    }
    var valueSignal = $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$().y3(row);
  }
  matchResult10: {
    var inputType;
    var x31 = row.cJ;
    if ((x31 instanceof $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$number)) {
      $m_Lcom_raquo_laminar_api_package$();
      var inputType = $m_Lcom_raquo_airstream_state_Val$().iT("number");
      break matchResult10;
    }
    if ((x31 instanceof $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$range)) {
      $m_Lcom_raquo_laminar_api_package$();
      var inputType = $m_Lcom_raquo_airstream_state_Val$().iT("range");
      break matchResult10;
    }
    $m_Lcom_raquo_laminar_api_package$();
    var inputType = $m_Lcom_raquo_airstream_state_Val$().iT(row.cJ.m());
  }
  return $m_Lcom_raquo_laminar_api_package$().b.w7().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.yo().bj(inputType), $m_Lcom_raquo_laminar_api_package$().b.ud().n(row.d3), $m_Lcom_raquo_laminar_api_package$().b.jx().bj(valueSignal), new $c_Lcom_raquo_laminar_keys_LockedEventKey(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.oE(), false, false)).nC().E9(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v) => new $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single(($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabels$().w8(v) ? new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq(v, true) : v))))))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$14) => new $c_Lcom_raquo_airstream_timing_ThrottleStream(_$14, 50, true)))).Iv(row.cl), (setFocus ? $m_Lcom_raquo_laminar_api_package$().b.AR : $m_Lcom_raquo_laminar_api_package$().b.JU), $f_Lcom_raquo_laminar_api_Implicits__seqToSetter__O__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Setter($m_Lcom_raquo_laminar_api_package$().b, extra, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())])));
});
$p.aLE = (function(row, default$1, setFocus) {
  var rawText = $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$().aSX(row.cl, default$1);
  var $x_5 = $m_Lcom_raquo_laminar_api_package$().b.aSI();
  var $x_4 = $m_sr_ScalaRunTime$();
  var $x_3 = $m_Lcom_raquo_laminar_api_package$().b.y.s("textarea textarea-xs min-h-[2rem] h-auto w-full p-1");
  var $x_2 = $m_Lcom_raquo_laminar_api_package$().b.ud().n(row.d3);
  var $x_1 = $m_Lcom_raquo_laminar_api_package$().b.jx().bj(rawText.P());
  var this$3 = new $c_Lcom_raquo_laminar_keys_LockedEventKey(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.oE(), false, false)).nC(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$15) => new $c_Lcom_raquo_airstream_timing_DebounceStream(_$15, 300))));
  var onNext = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((value) => {
    $f_Lcom_raquo_airstream_state_Var__set__O__V(rawText, value);
  }));
  return $x_5.w($x_4.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_3, $x_2, $x_1, this$3.Iv($m_Lcom_raquo_airstream_core_Observer$().wo(onNext, $m_s_PartialFunction$().gt, true)), (setFocus ? $m_Lcom_raquo_laminar_api_package$().b.AR : $m_Lcom_raquo_laminar_api_package$().b.JU)])));
});
$p.aLp = (function(row) {
  var $x_5 = $m_Lcom_raquo_laminar_api_package$().b.w7();
  var $x_4 = $m_sr_ScalaRunTime$();
  var $x_3 = $m_Lcom_raquo_laminar_api_package$().b.y.s("toggle toggle-xs");
  var $x_2 = $m_Lcom_raquo_laminar_api_package$().b.yo().n($s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__checkbox__Lorg_jpablo_graphexplorer_viewer_widgets_InputType().m());
  var $x_1 = $m_Lcom_raquo_laminar_api_package$().b.ud().n(row.d3);
  $m_Lcom_raquo_laminar_api_package$();
  var updater = $m_Lcom_raquo_laminar_api_package$().b.Wr().bj($m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$().aYE(row));
  var listener = new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.oE(), false, false)).agZ().E9(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((b) => {
    var b$1 = (!(!b));
    return new $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single(($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(("" + b$1))));
  }))), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((sink) => ((_$1) => {
    sink.jA().bA(_$1);
  }))(row.cl)));
  return $x_5.w($x_4.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_3, $x_2, $x_1, $m_Lcom_raquo_laminar_inputs_InputController$().qU(listener, updater)])));
});
$p.aLz = (function(row) {
  return $m_Lcom_raquo_laminar_api_package$().b.IF().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("attr-changed"), $m_Lcom_raquo_laminar_api_package$().b.wl().n("button"), $m_Lcom_raquo_laminar_api_package$().b.eW().n(("Reset " + row.cF)), $m_Lcom_raquo_laminar_api_package$().b.Af().Aq().n(("Reset " + row.cF)), new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false)).AG(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((ev) => {
    var this$2 = $m_s_Option$().as(ev.currentTarget.closest(".dropdown-content"));
    if ((!this$2.c())) {
      var x0 = this$2.d();
      x0.focus();
    }
    $f_Lcom_raquo_airstream_state_Var__set__O__V(row.cl, $s_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$__Missing__Lorg_jpablo_graphexplorer_viewer_models_AttrStatus());
  })))])));
});
$p.a2v = (function(row) {
  var multipleValues = $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), row.cl.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$17) => {
    var x$2 = $s_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$__Multiple__Lorg_jpablo_graphexplorer_viewer_models_AttrStatus();
    return ((_$17 === null) ? (x$2 === null) : _$17.e(x$2));
  })), $m_s_None$());
  return $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("flex items-center justify-start text-nowrap"), $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.eW().n(((row.cF + " \u2014 ") + new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId(row.da))), $m_Lcom_raquo_laminar_api_package$().b.y.s("font-bold").bj($m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$().a3Q(row)), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, row.cF, $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))), $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("w-6 flex items-center justify-center").bj($m_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$().li(multipleValues, $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$().a3Q(row), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((_$18, _$19) => {
    var _$18$1 = (!(!_$18));
    var _$19$1 = (!(!_$19));
    return (_$18$1 || _$19$1);
  })))), ($m_Lcom_raquo_laminar_api_package$(), new $c_Lcom_raquo_laminar_receivers_LockedChildReceiver($m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.eW().n("Multiple values"), $m_Lcom_raquo_laminar_api_package$().b.cS().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("bi bi-exclamation-triangle text-warning")])))]))))).gR(multipleValues), ($m_Lcom_raquo_laminar_api_package$(), new $c_Lcom_raquo_laminar_receivers_LockedChildReceiver($m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$().aLz(row))).gR($m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$().a3Q(row))])))])));
});
$p.aWg = (function(mods) {
  return $m_Lcom_raquo_laminar_api_package$().b.w7().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.yo().n($s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__search__Lorg_jpablo_graphexplorer_viewer_widgets_InputType().m()), $m_Lcom_raquo_laminar_api_package$().b.y.s("input  input-xs input-primary"), $f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, mods, $m_s_$less$colon$less$().b1, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())])));
});
$p.aW1 = (function(id, labelStr, isChecked, isDisabled, toggle) {
  var $x_12 = $m_Lcom_raquo_laminar_api_package$().b.Xp();
  var $x_11 = $m_sr_ScalaRunTime$();
  var $x_10 = $m_Lcom_raquo_laminar_api_package$().b.b1w().n(id);
  var $x_9 = $m_Lcom_raquo_laminar_api_package$().b.y.s("label cursor-pointer");
  var $x_8 = $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("pr-1"), $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, labelStr, $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)])));
  var $x_7 = $m_Lcom_raquo_laminar_api_package$().b.w7();
  var $x_6 = $m_sr_ScalaRunTime$();
  var $x_5 = $m_Lcom_raquo_laminar_api_package$().b.gz().n(id);
  var $x_4 = $m_Lorg_jpablo_graphexplorer_viewer_domUtils_DomUtils$package$().ayO.n("off");
  var $x_3 = $m_Lcom_raquo_laminar_api_package$().b.yo().n($s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__checkbox__Lorg_jpablo_graphexplorer_viewer_widgets_InputType().m());
  var $x_2 = $m_Lcom_raquo_laminar_api_package$().b.aNw().bj(isDisabled);
  var $x_1 = $m_Lcom_raquo_laminar_api_package$().b.y.s((toggle ? "toggle toggle-xs" : "checkbox checkbox-xs"));
  $m_Lcom_raquo_laminar_api_package$();
  var updater = $m_Lcom_raquo_laminar_api_package$().b.Wr().bj(isChecked);
  var listener = new $c_Lcom_raquo_laminar_modifiers_EventListener(($m_Lcom_raquo_laminar_api_package$(), $m_Lcom_raquo_laminar_keys_EventProcessor$().az($m_Lcom_raquo_laminar_api_package$().b.bR(), false, false)).agZ(), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => {
    isChecked.jA().bA(_$1);
  })));
  return $x_12.w($x_11.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_10, $x_9, $x_8, $x_7.w($x_6.f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_5, $x_4, $x_3, $x_2, $x_1, $m_Lcom_raquo_laminar_inputs_InputController$().qU(listener, updater)])))])));
});
$p.aW2 = (function() {
  $m_Lcom_raquo_laminar_api_package$();
  return $m_Lcom_raquo_airstream_state_Val$().iT(false);
});
var $d_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$, "org.jpablo.graphexplorer.viewer.widgets.Inputs$package$", ({
  Fj: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_widgets_Inputs$package$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_widgets_SelectVariant$() {
  this.abE = null;
  this.aH7 = null;
  this.abD = null;
  $n_Lorg_jpablo_graphexplorer_viewer_widgets_SelectVariant$ = this;
  this.abE = $m_Lcom_raquo_laminar_api_package$().b.y.s("select-xs");
  this.aH7 = $m_Lcom_raquo_laminar_api_package$().b.y.s("select-sm");
  this.abD = $m_Lcom_raquo_laminar_api_package$().b.y.s("select-ghost");
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_widgets_SelectVariant$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_widgets_SelectVariant$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_widgets_SelectVariant$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_widgets_SelectVariant$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_viewer_widgets_SelectVariant$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_widgets_SelectVariant$, "org.jpablo.graphexplorer.viewer.widgets.SelectVariant$", ({
  Fp: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_widgets_SelectVariant$;
function $m_Lorg_jpablo_graphexplorer_viewer_widgets_SelectVariant$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_widgets_SelectVariant$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_widgets_SelectVariant$ = new $c_Lorg_jpablo_graphexplorer_viewer_widgets_SelectVariant$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_widgets_SelectVariant$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_widgets_Tooltip$package$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_widgets_Tooltip$package$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_widgets_Tooltip$package$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_widgets_Tooltip$package$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_widgets_Tooltip$package$.prototype = $p;
$p.Iz = (function(text, mods) {
  return $m_Lcom_raquo_laminar_api_package$().b.a8().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$m_Lcom_raquo_laminar_api_package$().b.y.s("flex-none tooltip"), $m_Lorg_jpablo_graphexplorer_viewer_domUtils_DomUtils$package$().ayP.n(text), $f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($m_Lcom_raquo_laminar_api_package$().b, mods, $m_s_$less$colon$less$().b1, $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_widgets_Tooltip$package$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_widgets_Tooltip$package$, "org.jpablo.graphexplorer.viewer.widgets.Tooltip$package$", ({
  Fq: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_widgets_Tooltip$package$;
function $m_Lorg_jpablo_graphexplorer_viewer_widgets_Tooltip$package$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_widgets_Tooltip$package$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_widgets_Tooltip$package$ = new $c_Lorg_jpablo_graphexplorer_viewer_widgets_Tooltip$package$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_widgets_Tooltip$package$;
}
function $s_RTLong__remainderUnsigned__I__I__I__I__J(alo, ahi, blo, bhi) {
  return $m_RTLong$().b7o(alo, ahi, blo, bhi);
}
function $s_RTLong__remainder__I__I__I__I__J(alo, ahi, blo, bhi) {
  return $m_RTLong$().b7n(alo, ahi, blo, bhi);
}
function $s_RTLong__divideUnsigned__I__I__I__I__J(alo, ahi, blo, bhi) {
  return $m_RTLong$().a38(alo, ahi, blo, bhi);
}
function $s_RTLong__divide__I__I__I__I__J(alo, ahi, blo, bhi) {
  return $m_RTLong$().afk(alo, ahi, blo, bhi);
}
function $s_RTLong__fromDoubleBits__D__O__J(value, fpBitsDataView) {
  fpBitsDataView.setFloat64(0, value, true);
  var lo = (fpBitsDataView.getInt32(0, true) | 0);
  var hi = (fpBitsDataView.getInt32(4, true) | 0);
  return $bL(lo, hi);
}
function $s_RTLong__fromDouble__D__J(value) {
  return $m_RTLong$().d1(value);
}
function $s_RTLong__fromUnsignedInt__I__J(value) {
  return $bL(value, 0);
}
function $s_RTLong__fromInt__I__J(value) {
  var hi = (value >> 31);
  return $bL(value, hi);
}
function $s_RTLong__clz__I__I__I(lo, hi) {
  return ((hi !== 0) ? Math.clz32(hi) : ((32 + Math.clz32(lo)) | 0));
}
function $s_RTLong__toFloat__I__I__F(lo, hi) {
  return Math.fround(((4.294967296E9 * hi) + ((((((-2097152) & (hi ^ (hi >> 10))) === 0) || ((65535 & lo) === 0)) ? lo : (32768 | ((-32768) & lo))) >>> 0.0)));
}
function $s_RTLong__toDouble__I__I__D(lo, hi) {
  return ((4.294967296E9 * hi) + (lo >>> 0.0));
}
function $s_RTLong__toInt__I__I__I(lo, hi) {
  return lo;
}
function $s_RTLong__toString__I__I__T(lo, hi) {
  return $m_RTLong$().kY(lo, hi);
}
function $s_RTLong__bitsToDouble__I__I__O__D(lo, hi, fpBitsDataView) {
  fpBitsDataView.setInt32(0, lo, true);
  fpBitsDataView.setInt32(4, hi, true);
  return (+fpBitsDataView.getFloat64(0, true));
}
function $s_RTLong__mul__I__I__I__I__J(alo, ahi, blo, bhi) {
  var a0 = (65535 & alo);
  var a1 = ((alo >>> 16) | 0);
  var b0 = (65535 & blo);
  var b1 = ((blo >>> 16) | 0);
  var a0b0 = Math.imul(a0, b0);
  var a1b0 = Math.imul(a1, b0);
  var a0b1 = Math.imul(a0, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi = ((((((((Math.imul(alo, bhi) + Math.imul(ahi, blo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  return $bL(lo, hi);
}
function $s_RTLong__sub__I__I__I__I__J(alo, ahi, blo, bhi) {
  var lo = ((alo - blo) | 0);
  var hi = ((((ahi - bhi) | 0) - (((lo >>> 0) > (alo >>> 0)) | 0)) | 0);
  return $bL(lo, hi);
}
function $s_RTLong__add__I__I__I__I__J(alo, ahi, blo, bhi) {
  var lo = ((alo + blo) | 0);
  var hi = ((((ahi + bhi) | 0) + (((lo >>> 0) < (alo >>> 0)) | 0)) | 0);
  return $bL(lo, hi);
}
function $s_RTLong__sar__I__I__I__J(lo, hi, n) {
  var lo$1 = (((32 & n) === 0) ? (((lo >>> n) | 0) | ((hi << 1) << (~n))) : (hi >> n));
  var hi$1 = (((32 & n) === 0) ? (hi >> n) : (hi >> 31));
  return $bL(lo$1, hi$1);
}
function $s_RTLong__shr__I__I__I__J(lo, hi, n) {
  var lo$1 = (((32 & n) === 0) ? (((lo >>> n) | 0) | ((hi << 1) << (~n))) : ((hi >>> n) | 0));
  var hi$1 = (((32 & n) === 0) ? ((hi >>> n) | 0) : 0);
  return $bL(lo$1, hi$1);
}
function $s_RTLong__shl__I__I__I__J(lo, hi, n) {
  var lo$1 = (((32 & n) === 0) ? (lo << n) : 0);
  var hi$1 = (((32 & n) === 0) ? (((((lo >>> 1) | 0) >>> (~n)) | 0) | (hi << n)) : (lo << n));
  return $bL(lo$1, hi$1);
}
function $s_RTLong__xor__I__I__I__I__J(alo, ahi, blo, bhi) {
  var lo = (alo ^ blo);
  var hi = (ahi ^ bhi);
  return $bL(lo, hi);
}
function $s_RTLong__and__I__I__I__I__J(alo, ahi, blo, bhi) {
  var lo = (alo & blo);
  var hi = (ahi & bhi);
  return $bL(lo, hi);
}
function $s_RTLong__or__I__I__I__I__J(alo, ahi, blo, bhi) {
  var lo = (alo | blo);
  var hi = (ahi | bhi);
  return $bL(lo, hi);
}
function $s_RTLong__geu__I__I__I__I__Z(alo, ahi, blo, bhi) {
  return ((ahi === bhi) ? ((alo >>> 0) >= (blo >>> 0)) : ((ahi >>> 0) > (bhi >>> 0)));
}
function $s_RTLong__gtu__I__I__I__I__Z(alo, ahi, blo, bhi) {
  return ((ahi === bhi) ? ((alo >>> 0) > (blo >>> 0)) : ((ahi >>> 0) > (bhi >>> 0)));
}
function $s_RTLong__leu__I__I__I__I__Z(alo, ahi, blo, bhi) {
  return ((ahi === bhi) ? ((alo >>> 0) <= (blo >>> 0)) : ((ahi >>> 0) < (bhi >>> 0)));
}
function $s_RTLong__ltu__I__I__I__I__Z(alo, ahi, blo, bhi) {
  return ((ahi === bhi) ? ((alo >>> 0) < (blo >>> 0)) : ((ahi >>> 0) < (bhi >>> 0)));
}
function $s_RTLong__ge__I__I__I__I__Z(alo, ahi, blo, bhi) {
  return ((ahi === bhi) ? ((alo >>> 0) >= (blo >>> 0)) : (ahi > bhi));
}
function $s_RTLong__gt__I__I__I__I__Z(alo, ahi, blo, bhi) {
  return ((ahi === bhi) ? ((alo >>> 0) > (blo >>> 0)) : (ahi > bhi));
}
function $s_RTLong__le__I__I__I__I__Z(alo, ahi, blo, bhi) {
  return ((ahi === bhi) ? ((alo >>> 0) <= (blo >>> 0)) : (ahi < bhi));
}
function $s_RTLong__lt__I__I__I__I__Z(alo, ahi, blo, bhi) {
  return ((ahi === bhi) ? ((alo >>> 0) < (blo >>> 0)) : (ahi < bhi));
}
function $s_RTLong__notEquals__I__I__I__I__Z(alo, ahi, blo, bhi) {
  return (((alo ^ blo) | (ahi ^ bhi)) !== 0);
}
function $s_RTLong__equals__I__I__I__I__Z(alo, ahi, blo, bhi) {
  return (((alo ^ blo) | (ahi ^ bhi)) === 0);
}
/** @constructor */
function $c_RTLong$() {
}
$p = $c_RTLong$.prototype = new $h_O();
$p.constructor = $c_RTLong$;
/** @constructor */
function $h_RTLong$() {
}
$h_RTLong$.prototype = $p;
$p.kY = (function(lo, hi) {
  if ((hi === (lo >> 31))) {
    return ("" + lo);
  } else if ((((-2097152) & (hi ^ (hi >> 10))) === 0)) {
    return ("" + ((4.294967296E9 * hi) + (lo >>> 0.0)));
  } else {
    var sign = (hi >> 31);
    var xlo = (lo ^ sign);
    var rlo = ((xlo - sign) | 0);
    var rhi = (((hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
    var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
    var qHat = (+Math.floor((1.0000000000000265E-9 * aHat)));
    var rHat = ((rlo - Math.imul(1000000000, (qHat | 0.0))) | 0);
    if ((rHat < 0)) {
      qHat = (qHat - 1.0);
      rHat = ((1000000000 + rHat) | 0);
    }
    var this$7 = rHat;
    var remStr = ("" + this$7);
    var $x_1 = qHat;
    var start = remStr.length;
    var s = ((("" + $x_1) + "000000000".substring(start)) + remStr);
    return ((hi < 0) ? ("-" + s) : s);
  }
});
$p.d1 = (function(value) {
  if ((value < (-9.223372036854776E18))) {
    return $bL(0, (-2147483648));
  } else if ((value >= 9.223372036854776E18)) {
    return $bL((-1), 2147483647);
  } else {
    var rawLo = (value | 0.0);
    var rawHi = ((2.3283064365386963E-10 * value) | 0.0);
    var hi = (((value < 0.0) && (rawLo !== 0)) ? ((rawHi - 1) | 0) : rawHi);
    return $bL(rawLo, hi);
  }
});
$p.afk = (function(alo, ahi, blo, bhi) {
  var sign = (ahi >> 31);
  var xlo = (alo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((ahi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var sign$1 = (bhi >> 31);
  var xlo$1 = (blo ^ sign$1);
  var rlo$1 = ((xlo$1 - sign$1) | 0);
  var rhi$1 = (((bhi ^ sign$1) + (((rlo$1 >>> 0) < (xlo$1 >>> 0)) | 0)) | 0);
  if (((rhi$1 | ((-2097152) & rlo$1)) === 0)) {
    var quotHi = (((rhi >>> 0) / ($checkIntDivisor(rlo$1) >>> 0)) | 0);
    var k = ((rhi - Math.imul(rlo$1, quotHi)) | 0);
    var quotLo = ((((4.294967296E9 * k) + (rlo >>> 0.0)) / rlo$1) | 0.0);
    var absR_$_lo = quotLo;
    var absR_$_hi = quotHi;
  } else {
    var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
    var bHat = ((4.294967296E9 * (rhi$1 >>> 0.0)) + (rlo$1 >>> 0.0));
    var x$1 = ((aHat / bHat) + 0.00390625);
    var lo = (x$1 | 0.0);
    var hi = ((2.3283064365386963E-10 * x$1) | 0.0);
    var a0 = (65535 & rlo$1);
    var a1 = ((rlo$1 >>> 16) | 0);
    var b0 = (65535 & lo);
    var b1 = ((lo >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    if ((((((rhi - ((((((((Math.imul(rlo$1, hi) + Math.imul(rhi$1, lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0)) | 0) - (((((rlo - lo$1) | 0) >>> 0) > (rlo >>> 0)) | 0)) | 0) < 0)) {
      var lo$3 = ((lo - 1) | 0);
      var hi$3 = ((((hi - 1) | 0) + ((lo$3 !== (-1)) | 0)) | 0);
      var absR_$_lo = lo$3;
      var absR_$_hi = hi$3;
    } else {
      var absR_$_lo = lo;
      var absR_$_hi = hi;
    }
  }
  if (((ahi ^ bhi) >= 0)) {
    return $bL(absR_$_lo, absR_$_hi);
  } else {
    var lo$4 = ((-absR_$_lo) | 0);
    var hi$4 = ((((-absR_$_hi) | 0) - ((lo$4 !== 0) | 0)) | 0);
    return $bL(lo$4, hi$4);
  }
});
$p.a38 = (function(alo, ahi, blo, bhi) {
  if (((bhi | ((-2097152) & blo)) === 0)) {
    var quotHi = (((ahi >>> 0) / ($checkIntDivisor(blo) >>> 0)) | 0);
    var k = ((ahi - Math.imul(blo, quotHi)) | 0);
    var quotLo = ((((4.294967296E9 * k) + (alo >>> 0.0)) / blo) | 0.0);
    return $bL(quotLo, quotHi);
  } else if ((bhi >= 0)) {
    var aHat = ((4.294967296E9 * (ahi >>> 0.0)) + (alo >>> 0.0));
    var bHat = ((4.294967296E9 * (bhi >>> 0.0)) + (blo >>> 0.0));
    var x$1 = ((aHat / bHat) + 0.00390625);
    var lo = (x$1 | 0.0);
    var hi = ((2.3283064365386963E-10 * x$1) | 0.0);
    var a0 = (65535 & blo);
    var a1 = ((blo >>> 16) | 0);
    var b0 = (65535 & lo);
    var b1 = ((lo >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    if ((((((ahi - ((((((((Math.imul(blo, hi) + Math.imul(bhi, lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0)) | 0) - (((((alo - lo$1) | 0) >>> 0) > (alo >>> 0)) | 0)) | 0) < 0)) {
      var lo$3 = ((lo - 1) | 0);
      var hi$3 = ((((hi - 1) | 0) + ((lo$3 !== (-1)) | 0)) | 0);
      return $bL(lo$3, hi$3);
    } else {
      return $bL(lo, hi);
    }
  } else if (((ahi === bhi) ? ((alo >>> 0) < (blo >>> 0)) : ((ahi >>> 0) < (bhi >>> 0)))) {
    return $bL(0, 0);
  } else {
    return $bL(1, 0);
  }
});
$p.b7n = (function(alo, ahi, blo, bhi) {
  var sign = (ahi >> 31);
  var xlo = (alo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((ahi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var sign$1 = (bhi >> 31);
  var xlo$1 = (blo ^ sign$1);
  var rlo$1 = ((xlo$1 - sign$1) | 0);
  var rhi$1 = (((bhi ^ sign$1) + (((rlo$1 >>> 0) < (xlo$1 >>> 0)) | 0)) | 0);
  if (((rhi$1 | ((-2097152) & rlo$1)) === 0)) {
    var k$2 = (((rhi >>> 0) % ($checkIntDivisor(rlo$1) >>> 0)) | 0);
    var quotLo$2 = ((((4.294967296E9 * k$2) + (rlo >>> 0.0)) / rlo$1) | 0.0);
    var remLo = ((rlo - Math.imul(rlo$1, quotLo$2)) | 0);
    var absR_$_lo = remLo;
    var absR_$_hi = 0;
  } else {
    var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
    var bHat = ((4.294967296E9 * (rhi$1 >>> 0.0)) + (rlo$1 >>> 0.0));
    var x$1 = ((aHat / bHat) + 0.00390625);
    var lo = (x$1 | 0.0);
    var hi = ((2.3283064365386963E-10 * x$1) | 0.0);
    var a0 = (65535 & rlo$1);
    var a1 = ((rlo$1 >>> 16) | 0);
    var b0 = (65535 & lo);
    var b1 = ((lo >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$1 = ((((((((Math.imul(rlo$1, hi) + Math.imul(rhi$1, lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var lo$2 = ((rlo - lo$1) | 0);
    var hi$2 = ((((rhi - hi$1) | 0) - (((lo$2 >>> 0) > (rlo >>> 0)) | 0)) | 0);
    if ((hi$2 < 0)) {
      var lo$3 = ((lo$2 + rlo$1) | 0);
      var hi$3 = ((((hi$2 + rhi$1) | 0) + (((lo$3 >>> 0) < (lo$2 >>> 0)) | 0)) | 0);
      var absR_$_lo = lo$3;
      var absR_$_hi = hi$3;
    } else {
      var absR_$_lo = lo$2;
      var absR_$_hi = hi$2;
    }
  }
  if ((ahi < 0)) {
    var lo$4 = ((-absR_$_lo) | 0);
    var hi$4 = ((((-absR_$_hi) | 0) - ((lo$4 !== 0) | 0)) | 0);
    return $bL(lo$4, hi$4);
  } else {
    return $bL(absR_$_lo, absR_$_hi);
  }
});
$p.b7o = (function(alo, ahi, blo, bhi) {
  if (((bhi | ((-2097152) & blo)) === 0)) {
    var k$2 = (((ahi >>> 0) % ($checkIntDivisor(blo) >>> 0)) | 0);
    var quotLo$2 = ((((4.294967296E9 * k$2) + (alo >>> 0.0)) / blo) | 0.0);
    var remLo = ((alo - Math.imul(blo, quotLo$2)) | 0);
    return $bL(remLo, 0);
  } else if ((bhi >= 0)) {
    var aHat = ((4.294967296E9 * (ahi >>> 0.0)) + (alo >>> 0.0));
    var bHat = ((4.294967296E9 * (bhi >>> 0.0)) + (blo >>> 0.0));
    var x$1 = ((aHat / bHat) + 0.00390625);
    var lo = (x$1 | 0.0);
    var hi = ((2.3283064365386963E-10 * x$1) | 0.0);
    var a0 = (65535 & blo);
    var a1 = ((blo >>> 16) | 0);
    var b0 = (65535 & lo);
    var b1 = ((lo >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$1 = ((((((((Math.imul(blo, hi) + Math.imul(bhi, lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var lo$2 = ((alo - lo$1) | 0);
    var hi$2 = ((((ahi - hi$1) | 0) - (((lo$2 >>> 0) > (alo >>> 0)) | 0)) | 0);
    if ((hi$2 < 0)) {
      var lo$3 = ((lo$2 + blo) | 0);
      var hi$3 = ((((hi$2 + bhi) | 0) + (((lo$3 >>> 0) < (lo$2 >>> 0)) | 0)) | 0);
      return $bL(lo$3, hi$3);
    } else {
      return $bL(lo$2, hi$2);
    }
  } else if (((ahi === bhi) ? ((alo >>> 0) < (blo >>> 0)) : ((ahi >>> 0) < (bhi >>> 0)))) {
    return $bL(alo, ahi);
  } else {
    var lo$4 = ((alo - blo) | 0);
    var hi$4 = ((((ahi - bhi) | 0) - (((lo$4 >>> 0) > (alo >>> 0)) | 0)) | 0);
    return $bL(lo$4, hi$4);
  }
});
var $d_RTLong$ = new $TypeData().i($c_RTLong$, "org.scalajs.linker.runtime.RuntimeLong$", ({
  FH: 1
}));
var $n_RTLong$;
function $m_RTLong$() {
  if ((!$n_RTLong$)) {
    $n_RTLong$ = new $c_RTLong$();
  }
  return $n_RTLong$;
}
/** @constructor */
function $c_Lpprint_ProductSupport$() {
}
$p = $c_Lpprint_ProductSupport$.prototype = new $h_O();
$p.constructor = $c_Lpprint_ProductSupport$;
/** @constructor */
function $h_Lpprint_ProductSupport$() {
}
$h_Lpprint_ProductSupport$.prototype = $p;
$p.baw = (function(x, walker, escapeUnicode, showFieldNames) {
  return ((!showFieldNames) ? new $c_sc_Iterator$$anon$9(x.H(), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$2) => walker.yr(x$2, escapeUnicode, showFieldNames)))) : new $c_sc_Iterator$$anon$9(new $c_sc_Iterator$$anon$16(new $c_s_Product$$anon$2(x)), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    if ((x$1 !== null)) {
      var name = x$1.g();
      var i = (x$1.h() | 0);
      var elem = x.A(i);
      return new $c_Lpprint_Tree$KeyValue(name, walker.yr(elem, escapeUnicode, showFieldNames));
    }
    throw new $c_s_MatchError(x$1);
  }))));
});
var $d_Lpprint_ProductSupport$ = new $TypeData().i($c_Lpprint_ProductSupport$, "pprint.ProductSupport$", ({
  FI: 1
}));
var $n_Lpprint_ProductSupport$;
function $m_Lpprint_ProductSupport$() {
  if ((!$n_Lpprint_ProductSupport$)) {
    $n_Lpprint_ProductSupport$ = new $c_Lpprint_ProductSupport$();
  }
  return $n_Lpprint_ProductSupport$;
}
function $p_Lpprint_Renderer__applyHeader$1__T__sc_Iterator($thiz, prefix$1) {
  var $x_1 = $m_sr_ScalaRunTime$();
  var this$2 = $thiz.abG;
  var s = $m_Lfansi_Str$().iS(prefix$1, $m_Lfansi_ErrorMode$Throw$());
  return $x_1.f(new ($d_Lfansi_Str.r().C)([s.PG(this$2, 0, s.fC.a.length), $m_Lpprint_Renderer$().aHb])).o();
}
function $ps_Lpprint_Renderer__separator$1__Lfansi_Str__sc_Iterator(indentPlusOne$1) {
  return $m_sr_ScalaRunTime$().f(new ($d_Lfansi_Str.r().C)([$m_Lpprint_Renderer$().aH9, indentPlusOne$1])).o();
}
function $ps_Lpprint_Renderer__bufferedFragments$1__scm_Buffer__sr_ObjectRef__Lfansi_Str__Lpprint_Util$ConcatIterator(buffer$2, lastChildIter$1, indentPlusOne$2) {
  $m_Lpprint_Renderer$();
  return new $c_Lpprint_Util$ConcatIterator(new $c_sc_Iterator$$anon$9(new $c_sc_Iterator$$anon$6(new $c_sc_Iterator$$anon$16(buffer$2.o()), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => ((x$1 !== null) && (x$1.g(), (x$1.h() | 0), true)))), false), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$2) => {
    if ((x$1$2 !== null)) {
      var v$1 = x$1$2.g();
      return (((x$1$2.h() | 0) < ((buffer$2.C() - 1) | 0)) ? v$1.o() : v$1.o().lS(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => lastChildIter$1.aD))));
    }
    throw new $c_s_MatchError(x$1$2);
  }))), new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $ps_Lpprint_Renderer__separator$1__Lfansi_Str__sc_Iterator(indentPlusOne$2))));
}
function $p_Lpprint_Renderer__nonBufferedFragments$1__I__sc_Iterator__Lfansi_Str__Lpprint_Util$ConcatIterator($thiz, indentCount$2, body$1, indentPlusOne$3) {
  $m_Lpprint_Renderer$();
  return new $c_Lpprint_Util$ConcatIterator(new $c_sc_Iterator$$anon$9(body$1, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((c) => $thiz.PM(c, Math.imul(((1 + indentCount$2) | 0), $thiz.CR), ((1 + indentCount$2) | 0)).qt))), new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $ps_Lpprint_Renderer__separator$1__Lfansi_Str__sc_Iterator(indentPlusOne$3))));
}
function $p_Lpprint_Renderer__allFragments$1__I__sc_Iterator__scm_Buffer__sr_ObjectRef__Lfansi_Str__Lpprint_Util$ConcatIterator($thiz, indentCount$4, body$2, buffer$4, lastChildIter$4, indentPlusOne$4) {
  return (buffer$4.c() ? $p_Lpprint_Renderer__nonBufferedFragments$1__I__sc_Iterator__Lfansi_Str__Lpprint_Util$ConcatIterator($thiz, indentCount$4, body$2, indentPlusOne$4) : ((!body$2.p()) ? $ps_Lpprint_Renderer__bufferedFragments$1__scm_Buffer__sr_ObjectRef__Lfansi_Str__Lpprint_Util$ConcatIterator(buffer$4, lastChildIter$4, indentPlusOne$4) : ($m_Lpprint_Renderer$(), new $c_Lpprint_Util$ConcatIterator($m_sr_ScalaRunTime$().f(new ($d_Lpprint_Util$ConcatIterator.r().C)([$ps_Lpprint_Renderer__bufferedFragments$1__scm_Buffer__sr_ObjectRef__Lfansi_Str__Lpprint_Util$ConcatIterator(buffer$4, lastChildIter$4, indentPlusOne$4), $p_Lpprint_Renderer__nonBufferedFragments$1__I__sc_Iterator__Lfansi_Str__Lpprint_Util$ConcatIterator($thiz, indentCount$4, body$2, indentPlusOne$4)])).o(), new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $ps_Lpprint_Renderer__separator$1__Lfansi_Str__sc_Iterator(indentPlusOne$4)))))));
}
function $p_Lpprint_Renderer__iter$1__I__T__sc_Iterator__scm_Buffer__sr_ObjectRef__Lfansi_Str__Lpprint_Util$ConcatIterator($thiz, indentCount$5, prefix$2, body$3, buffer$5, lastChildIter$5, indentPlusOne$5) {
  return $m_Lpprint_Util$().a2Y($m_sr_ScalaRunTime$().f(new ($d_F0.r().C)([new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $p_Lpprint_Renderer__applyHeader$1__T__sc_Iterator($thiz, prefix$2))), new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $m_sr_ScalaRunTime$().f(new ($d_Lfansi_Str.r().C)([$m_Lpprint_Renderer$().a16, indentPlusOne$5])).o())), new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $p_Lpprint_Renderer__allFragments$1__I__sc_Iterator__scm_Buffer__sr_ObjectRef__Lfansi_Str__Lpprint_Util$ConcatIterator($thiz, indentCount$5, body$3, buffer$5, lastChildIter$5, indentPlusOne$5))), new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $m_sr_ScalaRunTime$().f(new ($d_Lfansi_Str.r().C)([$m_Lpprint_Renderer$().a16, $m_Lpprint_Renderer$().agv(Math.imul(indentCount$5, $thiz.CR)), $m_Lpprint_Renderer$().a15])).o()))])));
}
function $p_Lpprint_Renderer__str$lzyINIT1$1__I__I__Lpprint_Tree$Lazy__sr_LazyRef__sc_Iterator($thiz, leftOffset$1, indentCount$10, t$1, str$lzy1$1) {
  if ((str$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return (str$lzy1$1.ci ? str$lzy1$1.cj : str$lzy1$1.h3(t$1.Uu.i(new $c_Lpprint_Tree$Ctx($thiz.Hl, leftOffset$1, indentCount$10, $thiz.CR, $thiz.abH, $thiz.abG))));
}
function $p_Lpprint_Renderer__str$1__I__I__Lpprint_Tree$Lazy__sr_LazyRef__sc_Iterator($thiz, leftOffset$2, indentCount$11, t$2, str$lzy1$2) {
  return (str$lzy1$2.ci ? str$lzy1$2.cj : $p_Lpprint_Renderer__str$lzyINIT1$1__I__I__Lpprint_Tree$Lazy__sr_LazyRef__sc_Iterator($thiz, leftOffset$2, indentCount$11, t$2, str$lzy1$2));
}
/** @constructor */
function $c_Lpprint_Renderer(maxWidth, colorApplyPrefix, colorLiteral, indentStep) {
  this.Hl = 0;
  this.abG = null;
  this.abH = null;
  this.CR = 0;
  this.Hl = maxWidth;
  this.abG = colorApplyPrefix;
  this.abH = colorLiteral;
  this.CR = indentStep;
}
$p = $c_Lpprint_Renderer.prototype = new $h_O();
$p.constructor = $c_Lpprint_Renderer;
/** @constructor */
function $h_Lpprint_Renderer() {
}
$h_Lpprint_Renderer.prototype = $p;
$p.PM = (function(x, leftOffset, indentCount) {
  if ((x instanceof $c_Lpprint_Tree$Apply)) {
    var x21 = x.Ui;
    var x22 = x.Uh;
    var nonEmpty = x22.p();
    var totalHorizontalWidth = ((2 + ((leftOffset + x21.length) | 0)) | 0);
    var buffer = $m_scm_Buffer$().f7();
    var lastChildIter = new $c_sr_ObjectRef($m_sr_ScalaRunTime$().f(new ($d_Lfansi_Str.r().C)([])).o());
    var childCompletedLineCount = new $c_sr_IntRef(0);
    while (((x22.p() && (totalHorizontalWidth <= this.Hl)) && (childCompletedLineCount.an === 0))) {
      var child = x22.q();
      var childRes = this.PM(child, Math.imul(((1 + indentCount) | 0), this.CR), ((1 + indentCount) | 0));
      var childBuffer = $m_scm_Buffer$().f7();
      while ((childRes.qt.p() && (totalHorizontalWidth < this.Hl))) {
        var next = childRes.qt.q();
        childBuffer.Y(next);
        totalHorizontalWidth = ((totalHorizontalWidth + next.fC.a.length) | 0);
      }
      if (x22.p()) {
        totalHorizontalWidth = ((2 + totalHorizontalWidth) | 0);
      }
      if ((!childRes.qt.p())) {
        var ev$1 = ((childCompletedLineCount.an + childRes.Pa()) | 0);
        childCompletedLineCount.an = ev$1;
      } else {
        var ev$2 = childRes.qt;
        lastChildIter.aD = ev$2;
        ev$2 = null;
      }
      buffer.Y($m_sci_Seq$().fw(childBuffer));
    }
    var indentPlusOne = $m_Lpprint_Renderer$().agv(Math.imul(((1 + indentCount) | 0), this.CR));
    return ((((totalHorizontalWidth <= this.Hl) && (childCompletedLineCount.an === 0)) && (!lastChildIter.aD.p())) ? new $c_Lpprint_Result($m_Lpprint_Util$().a2Y($m_sr_ScalaRunTime$().f(new ($d_F0.r().C)([new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $p_Lpprint_Renderer__applyHeader$1__T__sc_Iterator(this, x21))), new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
      $m_Lpprint_Renderer$();
      return new $c_Lpprint_Util$ConcatIterator(new $c_sc_Iterator$$anon$9(buffer.o(), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => _$1.o()))), new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $m_sr_ScalaRunTime$().f(new ($d_Lfansi_Str.r().C)([$m_Lpprint_Renderer$().aHa])).o())));
    })), new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $m_sr_ScalaRunTime$().f(new ($d_Lfansi_Str.r().C)([$m_Lpprint_Renderer$().a15])).o()))]))), new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => 0)), new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d(((length) => (() => length))(($f_sc_IterableOnceOps__sum__s_math_Numeric__O(new $c_sc_Iterator$$anon$9(buffer.o(), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => ($f_sc_IterableOnceOps__sum__s_math_Numeric__O(new $c_sc_Iterator$$anon$9(_$2.o(), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$3) => _$3.fC.a.length))), $m_s_math_Numeric$IntIsIntegral$()) | 0)))), $m_s_math_Numeric$IntIsIntegral$()) | 0)))) : (((!nonEmpty) && (totalHorizontalWidth > this.Hl)) ? new $c_Lpprint_Result($m_Lpprint_Util$().a2Y($m_sr_ScalaRunTime$().f(new ($d_F0.r().C)([new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $p_Lpprint_Renderer__applyHeader$1__T__sc_Iterator(this, x21))), new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $m_sr_ScalaRunTime$().f(new ($d_Lfansi_Str.r().C)([$m_Lpprint_Renderer$().a16, $m_Lpprint_Renderer$().agv(Math.imul(indentCount, this.CR)), $m_Lpprint_Renderer$().a15])).o()))]))), new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => 0)), new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d(((length$3) => (() => length$3))(($f_sc_IterableOnceOps__sum__s_math_Numeric__O(new $c_sc_Iterator$$anon$9(buffer.o(), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$4) => ($f_sc_IterableOnceOps__sum__s_math_Numeric__O(new $c_sc_Iterator$$anon$9(_$4.o(), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$5) => _$5.fC.a.length))), $m_s_math_Numeric$IntIsIntegral$()) | 0)))), $m_s_math_Numeric$IntIsIntegral$()) | 0)))) : new $c_Lpprint_Result($p_Lpprint_Renderer__iter$1__I__T__sc_Iterator__scm_Buffer__sr_ObjectRef__Lfansi_Str__Lpprint_Util$ConcatIterator(this, indentCount, x21, x22, buffer, lastChildIter, indentPlusOne), new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => ((2 + childCompletedLineCount.an) | 0))), new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => ((1 + Math.imul(indentCount, this.CR)) | 0))))));
  }
  if ((x instanceof $c_Lpprint_Tree$Infix)) {
    var x16 = x.Up;
    var x17 = x.Uq;
    var x18 = x.Ur;
    return this.PM(x16, leftOffset, indentCount).afS(new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((lhsNewline, lhsLastLineLength) => {
      var lhsLastLineLength$1 = (lhsLastLineLength | 0);
      return $m_Lpprint_Result$().ag8(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $m_Lfansi_Str$().iS(((" " + x17) + " "), $m_Lfansi_ErrorMode$Throw$())))).afS(new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((_$6, _$7) => this.PM(x18, lhsLastLineLength$1, indentCount))));
    })));
  }
  if ((x instanceof $c_Lpprint_Tree$Lazy)) {
    return new $c_Lpprint_Truncated(new $c_sc_Iterator$$anon$9($p_Lpprint_Renderer__str$1__I__I__Lpprint_Tree$Lazy__sr_LazyRef__sc_Iterator(this, leftOffset, indentCount, x, new $c_sr_LazyRef()), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$8) => $m_Lfansi_Str$().iS(_$8, ($m_Lfansi_Str$(), $m_Lfansi_ErrorMode$Throw$()))))), this.Hl, 99999999, "...").baa();
  }
  if ((x instanceof $c_Lpprint_Tree$Literal)) {
    return $m_Lpprint_Result$().ag8(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d(((t$3) => (() => {
      var this$24 = this.abH;
      var s = $m_Lfansi_Str$().iS(t$3.Uv, $m_Lfansi_ErrorMode$Throw$());
      return s.PG(this$24, 0, s.fC.a.length);
    }))(x)));
  }
  if ((x instanceof $c_Lpprint_Tree$KeyValue)) {
    var x10 = x.Us;
    var x11 = x.Ut;
    var prefix$4 = (x10 + " = ");
    return $m_Lpprint_Result$().ag8(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $m_Lfansi_Str$().iS(prefix$4, $m_Lfansi_ErrorMode$Throw$())))).afS(new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((_$9, _$10) => this.PM(x11, ((leftOffset + prefix$4.length) | 0), indentCount))));
  }
  throw new $c_s_MatchError(x);
});
var $d_Lpprint_Renderer = new $TypeData().i($c_Lpprint_Renderer, "pprint.Renderer", ({
  FJ: 1
}));
/** @constructor */
function $c_Lpprint_Renderer$() {
  this.aHb = null;
  this.a15 = null;
  this.aHa = null;
  this.a16 = null;
  this.aH9 = null;
  this.aH8 = null;
  $n_Lpprint_Renderer$ = this;
  this.aHb = $m_Lfansi_Str$().iS("(", ($m_Lfansi_Str$(), $m_Lfansi_ErrorMode$Throw$()));
  this.a15 = $m_Lfansi_Str$().iS(")", ($m_Lfansi_Str$(), $m_Lfansi_ErrorMode$Throw$()));
  this.aHa = $m_Lfansi_Str$().iS(", ", ($m_Lfansi_Str$(), $m_Lfansi_ErrorMode$Throw$()));
  this.a16 = $m_Lfansi_Str$().iS("\n", ($m_Lfansi_Str$(), $m_Lfansi_ErrorMode$Throw$()));
  this.aH9 = $m_Lfansi_Str$().iS(",\n", ($m_Lfansi_Str$(), $m_Lfansi_ErrorMode$Throw$()));
  var array = new ($d_Lfansi_Str.r().C)(64);
  var i = 0;
  while ((i < 64)) {
    var $x_1 = i;
    var x0 = i;
    array.a[$x_1] = $m_Lfansi_Str$().iS($m_sc_StringOps$().tR(" ", x0), ($m_Lfansi_Str$(), $m_Lfansi_ErrorMode$Throw$()));
    i = ((1 + i) | 0);
  }
  this.aH8 = array;
}
$p = $c_Lpprint_Renderer$.prototype = new $h_O();
$p.constructor = $c_Lpprint_Renderer$;
/** @constructor */
function $h_Lpprint_Renderer$() {
}
$h_Lpprint_Renderer$.prototype = $p;
$p.agv = (function(n) {
  return ((n < 64) ? this.aH8.a[n] : $m_Lfansi_Str$().iS($m_sc_StringOps$().tR(" ", n), ($m_Lfansi_Str$(), $m_Lfansi_ErrorMode$Throw$())));
});
var $d_Lpprint_Renderer$ = new $TypeData().i($c_Lpprint_Renderer$, "pprint.Renderer$", ({
  FK: 1
}));
var $n_Lpprint_Renderer$;
function $m_Lpprint_Renderer$() {
  if ((!$n_Lpprint_Renderer$)) {
    $n_Lpprint_Renderer$ = new $c_Lpprint_Renderer$();
  }
  return $n_Lpprint_Renderer$;
}
/** @constructor */
function $c_Lpprint_Result(iter, completedLineCount0, lastLineLength0) {
  this.qt = null;
  this.abI = null;
  this.abJ = null;
  this.aHc = 0;
  this.aHd = false;
  this.aHe = 0;
  this.aHf = false;
  this.qt = iter;
  this.abI = completedLineCount0;
  this.abJ = lastLineLength0;
}
$p = $c_Lpprint_Result.prototype = new $h_O();
$p.constructor = $c_Lpprint_Result;
/** @constructor */
function $h_Lpprint_Result() {
}
$h_Lpprint_Result.prototype = $p;
$p.Pa = (function() {
  if ((!this.aHd)) {
    this.aHc = ($m_s_Predef$().PQ((!this.qt.p())), (this.abI.a3() | 0));
    this.aHd = true;
    this.abI = null;
  }
  return this.aHc;
});
$p.a45 = (function() {
  if ((!this.aHf)) {
    this.aHe = ($m_s_Predef$().PQ((!this.qt.p())), (this.abJ.a3() | 0));
    this.aHf = true;
  }
  return this.aHe;
});
$p.afS = (function(f) {
  var newCompletedLineCount = new $c_sr_IntRef(0);
  var newLastLineLength = new $c_sr_IntRef(0);
  return new $c_Lpprint_Result($m_Lpprint_Util$().a2Y($m_sr_ScalaRunTime$().f(new ($d_F0.r().C)([new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => this.qt)), new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
    $m_s_Predef$().PQ((!this.qt.p()));
    var newResult = f.R(this.Pa(), this.abJ.a3());
    return new $c_sc_Iterator$$anon$9(newResult.qt, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x) => {
      if ((!newResult.qt.p())) {
        var ev$2 = newResult.Pa();
        newCompletedLineCount.an = ev$2;
        var ev$3 = newResult.a45();
        newLastLineLength.an = ev$3;
      }
      return x;
    })));
  }))]))), new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => ((newCompletedLineCount.an + this.Pa()) | 0))), new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => ((newCompletedLineCount.an > 0) ? newLastLineLength.an : ((newLastLineLength.an + this.a45()) | 0)))));
});
var $d_Lpprint_Result = new $TypeData().i($c_Lpprint_Result, "pprint.Result", ({
  FL: 1
}));
function $p_Lpprint_Result$__lines$lzyINIT1$1__F0__sr_LazyRef__AT($thiz, s$1, lines$lzy1$1) {
  if ((lines$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if (lines$lzy1$1.ci) {
    var $x_1 = lines$lzy1$1.cj;
  } else {
    var this$5 = new $c_sc_StringOps$$anon$1(s$1.a3().b6H(), true);
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    while ((this$5.kd < this$5.zV)) {
      var elem = this$5.wa();
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem);
    }
    var $x_1 = lines$lzy1$1.h3(new ($d_T.r().C)(jsElems));
  }
  return $x_1;
}
function $p_Lpprint_Result$__lines$1__F0__sr_LazyRef__AT($thiz, s$2, lines$lzy1$2) {
  return (lines$lzy1$2.ci ? lines$lzy1$2.cj : $p_Lpprint_Result$__lines$lzyINIT1$1__F0__sr_LazyRef__AT($thiz, s$2, lines$lzy1$2));
}
/** @constructor */
function $c_Lpprint_Result$() {
}
$p = $c_Lpprint_Result$.prototype = new $h_O();
$p.constructor = $c_Lpprint_Result$;
/** @constructor */
function $h_Lpprint_Result$() {
}
$h_Lpprint_Result$.prototype = $p;
$p.ag8 = (function(s) {
  var lines$lzy1 = new $c_sr_LazyRef();
  return new $c_Lpprint_Result($m_sr_ScalaRunTime$().f(new ($d_Lfansi_Str.r().C)([s.a3()])).o(), new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d(((lines$lzy1$2) => (() => (($p_Lpprint_Result$__lines$1__F0__sr_LazyRef__AT(this, s, lines$lzy1$2).a.length - 1) | 0)))(lines$lzy1)), new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d(((lines$lzy1$3) => (() => $m_sc_ArrayOps$().a44($p_Lpprint_Result$__lines$1__F0__sr_LazyRef__AT(this, s, lines$lzy1$3)).length))(lines$lzy1)));
});
var $d_Lpprint_Result$ = new $TypeData().i($c_Lpprint_Result$, "pprint.Result$", ({
  FM: 1
}));
var $n_Lpprint_Result$;
function $m_Lpprint_Result$() {
  if ((!$n_Lpprint_Result$)) {
    $n_Lpprint_Result$ = new $c_Lpprint_Result$();
  }
  return $n_Lpprint_Result$;
}
/** @constructor */
function $c_Lpprint_Truncated$Internal$(outer) {
  this.CS = null;
  this.a17 = false;
  this.a18 = false;
  this.Ux = false;
  this.Uw = null;
  this.xu = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.xu = outer;
  this.CS = new $c_sc_Iterator$$anon$6(outer.aHi, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => (_$1.fC.a.length > 0))), false);
  this.a17 = false;
  this.a18 = false;
  this.Ux = false;
  this.Uw = $m_Lfansi_Str$().iS("", ($m_Lfansi_Str$(), $m_Lfansi_ErrorMode$Throw$()));
}
$p = $c_Lpprint_Truncated$Internal$.prototype = new $h_O();
$p.constructor = $c_Lpprint_Truncated$Internal$;
/** @constructor */
function $h_Lpprint_Truncated$Internal$() {
}
$h_Lpprint_Truncated$Internal$.prototype = $p;
$p.b2o = (function(char) {
  this.a17 = false;
  this.a18 = false;
  if ((((char === 10) && this.a18) || ((char === 13) && this.a17))) {
    return (void 0);
  } else if ((char === 10)) {
    this.a17 = true;
    return this.xu.qu.Y(0);
  } else if ((char === 13)) {
    this.a18 = true;
    return this.xu.qu.Y(0);
  } else if (((this.xu.qu.bJ() | 0) === this.xu.aHj)) {
    return this.xu.qu.Y(1);
  } else {
    var i$1 = ((this.xu.qu.C() - 1) | 0);
    this.xu.qu.cM(i$1, ((1 + (this.xu.qu.l(i$1) | 0)) | 0));
    return (void 0);
  }
});
$p.a2W = (function() {
  return ((this.xu.qu.C() - 1) | 0);
});
$p.afa = (function(chunk, lineLimit) {
  var i = 0;
  var this$1 = chunk.fC;
  var chars = this$1.ae();
  while (((i < chars.a.length) && (this.a2W() < lineLimit))) {
    this.b2o(chars.a[i]);
    i = ((1 + i) | 0);
  }
  return ((i === chunk.fC.a.length) ? $m_s_None$() : new $c_s_Some(i));
});
var $d_Lpprint_Truncated$Internal$ = new $TypeData().i($c_Lpprint_Truncated$Internal$, "pprint.Truncated$Internal$", ({
  FO: 1
}));
/** @constructor */
function $c_Lpprint_Util$() {
}
$p = $c_Lpprint_Util$.prototype = new $h_O();
$p.constructor = $c_Lpprint_Util$;
/** @constructor */
function $h_Lpprint_Util$() {
}
$h_Lpprint_Util$.prototype = $p;
$p.a2Y = (function(is) {
  return new $c_Lpprint_Util$ConcatIterator(new $c_sc_Iterator$$anon$9(is.o(), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => _$1.a3()))), new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $m_sc_Iterator$().b8)));
});
$p.b3n = (function(ident) {
  if ((ident.length > 0)) {
    switch (ident.charCodeAt(0)) {
      case 60:
      case 126:
      case 33:
      case 64:
      case 35:
      case 37:
      case 94:
      case 42:
      case 43:
      case 45:
      case 62:
      case 63:
      case 58:
      case 61:
      case 38:
      case 124:
      case 47:
      case 92: {
        return true;
        break;
      }
      default: {
        return false;
      }
    }
  } else {
    return false;
  }
});
$p.aNQ = (function(c, sb, unicode) {
  switch (c) {
    case 34: {
      return sb.ei("\\\"");
      break;
    }
    case 92: {
      return sb.ei("\\\\");
      break;
    }
    case 8: {
      return sb.ei("\\b");
      break;
    }
    case 12: {
      return sb.ei("\\f");
      break;
    }
    case 10: {
      return sb.ei("\\n");
      break;
    }
    case 13: {
      return sb.ei("\\r");
      break;
    }
    case 9: {
      return sb.ei("\\t");
      break;
    }
    default: {
      return (((c < 32) || ((c > 126) && unicode)) ? sb.ei($m_sc_StringOps$().u0("\\u%04x", $m_sr_ScalaRunTime$().hP(new $ac_O([c])))) : sb.jl(c));
    }
  }
});
$p.a47 = (function(s, unicode) {
  var sb = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  sb.jl(34);
  var i = 0;
  var len = s.C();
  while ((i < len)) {
    $m_Lpprint_Util$().aNQ($uC(s.l(i)), sb, unicode);
    i = ((1 + i) | 0);
  }
  sb.jl(34);
  return sb.bP.ah;
});
var $d_Lpprint_Util$ = new $TypeData().i($c_Lpprint_Util$, "pprint.Util$", ({
  FP: 1
}));
var $n_Lpprint_Util$;
function $m_Lpprint_Util$() {
  if ((!$n_Lpprint_Util$)) {
    $n_Lpprint_Util$ = new $c_Lpprint_Util$();
  }
  return $n_Lpprint_Util$;
}
function $ct_Lpprint_Walker__($thiz) {
  $thiz.Uy = "scala.Tuple";
  return $thiz;
}
/** @constructor */
function $c_Lpprint_Walker() {
  this.Uy = null;
}
$p = $c_Lpprint_Walker.prototype = new $h_O();
$p.constructor = $c_Lpprint_Walker;
/** @constructor */
function $h_Lpprint_Walker() {
}
$h_Lpprint_Walker.prototype = $p;
$p.yr = (function(x, escapeUnicode, showFieldNames) {
  var this$1 = this.Hh.Ar().i(x);
  if (this$1.c()) {
    if ((x === null)) {
      var $x_2 = new $c_Lpprint_Tree$Literal("null");
    } else if (((typeof x) === "boolean")) {
      var $x_2 = new $c_Lpprint_Tree$Literal(("" + (!(!x))));
    } else if ((x instanceof $Char)) {
      var x$2 = $uC(x);
      var sb = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
      sb.jl(39);
      $m_Lpprint_Util$().aNQ(x$2, sb, escapeUnicode);
      sb.jl(39);
      var $x_2 = new $c_Lpprint_Tree$Literal(sb.bP.ah);
    } else if ($isByte(x)) {
      var $x_2 = new $c_Lpprint_Tree$Literal(("" + (x | 0)));
    } else if ($isShort(x)) {
      var $x_2 = new $c_Lpprint_Tree$Literal(("" + (x | 0)));
    } else if ($isInt(x)) {
      var $x_2 = new $c_Lpprint_Tree$Literal(("" + (x | 0)));
    } else if ((x instanceof $Long)) {
      var $x_3 = $uJ(x);
      var x$6_$_lo = $x_3.l;
      var x$6_$_hi = $x_3.h;
      var $x_2 = new $c_Lpprint_Tree$Literal(($m_RTLong$().kY(x$6_$_lo, x$6_$_hi) + "L"));
    } else if ($isFloat(x)) {
      var $x_2 = new $c_Lpprint_Tree$Literal((Math.fround(x) + "F"));
    } else if (((typeof x) === "number")) {
      var $x_2 = new $c_Lpprint_Tree$Literal(("" + (+x)));
    } else if (((typeof x) === "string")) {
      _return: {
        var len = x.length;
        var i = 0;
        while ((i < len)) {
          var index = i;
          var x0 = x.charCodeAt(index);
          if (((x0 === 10) || (x0 === 13))) {
            var $x_4 = i;
            break _return;
          }
          i = ((1 + i) | 0);
        }
        var $x_4 = (-1);
      }
      if (($x_4 !== (-1))) {
        var $x_2 = new $c_Lpprint_Tree$Literal((("\"\"\"" + x) + "\"\"\""));
      } else {
        var $x_2 = new $c_Lpprint_Tree$Literal($m_Lpprint_Util$().a47($m_s_Predef$().JL(x), escapeUnicode));
      }
    } else if ((x instanceof $c_s_Symbol)) {
      var $x_2 = new $c_Lpprint_Tree$Literal(("'" + x.UE));
    } else if ($is_sc_Map(x)) {
      var $x_2 = new $c_Lpprint_Tree$Apply(x.hM(), new $c_sc_Iterator$$anon$10(x.o(), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$2) => {
        if ((x$1$2 !== null)) {
          var k = x$1$2.g();
          var v = x$1$2.h();
          return $m_sci_Seq$().kM($m_sr_ScalaRunTime$().f(new ($d_Lpprint_Tree$Infix.r().C)([new $c_Lpprint_Tree$Infix(this.yr(k, escapeUnicode, showFieldNames), "->", this.yr(v, escapeUnicode, showFieldNames))])));
        }
        throw new $c_s_MatchError(x$1$2);
      }))));
    } else if ($is_sc_Iterable(x)) {
      var $x_2 = new $c_Lpprint_Tree$Apply(x.hM(), new $c_sc_Iterator$$anon$9(x.o(), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$13) => this.yr(x$13, escapeUnicode, showFieldNames)))));
    } else if (($m_s_None$() === x)) {
      var $x_2 = new $c_Lpprint_Tree$Literal("None");
    } else if ($is_sc_Iterator(x)) {
      var $x_2 = ((!x.p()) ? new $c_Lpprint_Tree$Literal("empty iterator") : new $c_Lpprint_Tree$Literal("non-empty iterator"));
    } else if ($m_sr_ScalaRunTime$().b34(x, 1)) {
      var $x_2 = new $c_Lpprint_Tree$Apply("Array", new $c_sc_Iterator$$anon$9($m_sc_ArrayOps$().u8(x), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$17) => this.yr(x$17, escapeUnicode, showFieldNames)))));
    } else if ($is_s_Product(x)) {
      var className = $objectClassName(x);
      if ((x.z() === 0)) {
        var $x_2 = new $c_Lpprint_Tree$Lazy(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$19) => ((ctx) => $m_sr_ScalaRunTime$().f(new ($d_T.r().C)([x$19.m()])).o()))(x)));
      } else if (((x.z() === 2) && $m_Lpprint_Util$().b3n(x.B()))) {
        var $x_2 = new $c_Lpprint_Tree$Infix(this.yr(x.A(0), escapeUnicode, showFieldNames), x.B(), this.yr(x.A(1), escapeUnicode, showFieldNames));
      } else {
        matchResult21: {
          var $x_2;
          var prefix$2 = this.Uy;
          var _1 = (!(!className.startsWith(prefix$2)));
          var _2 = new $c_s_PartialFunction$Lifted($m_s_Predef$().JL(className)).as(this.Uy.length);
          if ((_1 && (_2 instanceof $c_s_Some))) {
            matchAlts1: {
              switch ($uC(_2.J)) {
                case 50: {
                  break;
                }
                case 51: {
                  break;
                }
                case 52: {
                  break;
                }
                case 53: {
                  break;
                }
                case 54: {
                  break;
                }
                case 55: {
                  break;
                }
                case 56: {
                  break;
                }
                case 57: {
                  break;
                }
                default: {
                  break matchAlts1;
                }
              }
              var $x_2 = new $c_Lpprint_Tree$Apply("", new $c_sc_Iterator$$anon$9(x.H(), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$20) => this.yr(x$20, escapeUnicode, showFieldNames)))));
              break matchResult21;
            }
          }
          var $x_2 = new $c_Lpprint_Tree$Apply(x.B(), $m_Lpprint_ProductSupport$().baw(x, this, escapeUnicode, showFieldNames));
        }
      }
    } else {
      var $x_2 = new $c_Lpprint_Tree$Lazy(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((ctx$2) => {
        var $x_6 = $m_sr_ScalaRunTime$();
        matchResult22: {
          var $x_5;
          var x39 = $dp_toString__T(x);
          if ((x39 === null)) {
            var $x_5 = "null";
            break matchResult22;
          }
          var $x_5 = x39;
        }
        return $x_6.f(new ($d_T.r().C)([$x_5])).o();
      })));
    }
    var $x_1 = $x_2;
  } else {
    var $x_1 = this$1.d();
  }
  return $x_1;
});
/** @constructor */
function $c_s_Array$EmptyArrays$() {
  this.Uz = null;
  this.abL = null;
  $n_s_Array$EmptyArrays$ = this;
  this.Uz = new $ac_I(0);
  this.abL = new $ac_O(0);
}
$p = $c_s_Array$EmptyArrays$.prototype = new $h_O();
$p.constructor = $c_s_Array$EmptyArrays$;
/** @constructor */
function $h_s_Array$EmptyArrays$() {
}
$h_s_Array$EmptyArrays$.prototype = $p;
var $d_s_Array$EmptyArrays$ = new $TypeData().i($c_s_Array$EmptyArrays$, "scala.Array$EmptyArrays$", ({
  FY: 1
}));
var $n_s_Array$EmptyArrays$;
function $m_s_Array$EmptyArrays$() {
  if ((!$n_s_Array$EmptyArrays$)) {
    $n_s_Array$EmptyArrays$ = new $c_s_Array$EmptyArrays$();
  }
  return $n_s_Array$EmptyArrays$;
}
/** @constructor */
function $c_s_Array$UnapplySeqWrapper$() {
}
$p = $c_s_Array$UnapplySeqWrapper$.prototype = new $h_O();
$p.constructor = $c_s_Array$UnapplySeqWrapper$;
/** @constructor */
function $h_s_Array$UnapplySeqWrapper$() {
}
$h_s_Array$UnapplySeqWrapper$.prototype = $p;
$p.u9 = (function(this$, len) {
  return $m_sc_ArrayOps$().u9(this$, len);
});
var $d_s_Array$UnapplySeqWrapper$ = new $TypeData().i($c_s_Array$UnapplySeqWrapper$, "scala.Array$UnapplySeqWrapper$", ({
  FZ: 1
}));
var $n_s_Array$UnapplySeqWrapper$;
function $m_s_Array$UnapplySeqWrapper$() {
  if ((!$n_s_Array$UnapplySeqWrapper$)) {
    $n_s_Array$UnapplySeqWrapper$ = new $c_s_Array$UnapplySeqWrapper$();
  }
  return $n_s_Array$UnapplySeqWrapper$;
}
var $d_F0 = new $TypeData().i(1, "scala.Function0", ({
  du: 1
}));
var $d_F1 = new $TypeData().i(1, "scala.Function1", ({
  h: 1
}));
function $f_F2__tupled__F1($thiz) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x0$1$2$2) => {
    if ((x0$1$2$2 !== null)) {
      return $thiz.R(x0$1$2$2.g(), x0$1$2$2.h());
    } else {
      throw new $c_s_MatchError(x0$1$2$2);
    }
  }));
}
function $ct_s_JSUniquenessCache__($thiz) {
  $thiz.abN = ({});
  return $thiz;
}
/** @constructor */
function $c_s_JSUniquenessCache() {
  this.abN = null;
}
$p = $c_s_JSUniquenessCache.prototype = new $h_O();
$p.constructor = $c_s_JSUniquenessCache;
/** @constructor */
function $h_s_JSUniquenessCache() {
}
$h_s_JSUniquenessCache.prototype = $p;
$p.aeK = (function(name) {
  var dict = this.abN;
  if ((!(!$m_sjs_js_WrappedDictionary$Cache$().vL.call(dict, name)))) {
    return dict[name];
  } else {
    var v = new $c_s_Symbol(name);
    dict[name] = v;
    return v;
  }
});
/** @constructor */
function $c_s_LowPriorityImplicits2() {
}
$p = $c_s_LowPriorityImplicits2.prototype = new $h_O();
$p.constructor = $c_s_LowPriorityImplicits2;
/** @constructor */
function $h_s_LowPriorityImplicits2() {
}
$h_s_LowPriorityImplicits2.prototype = $p;
/** @constructor */
function $c_s_Option$WithFilter(outer, p) {
  this.tv = null;
  this.tu = null;
  this.tv = p;
  this.tu = outer;
}
$p = $c_s_Option$WithFilter.prototype = new $h_O();
$p.constructor = $c_s_Option$WithFilter;
/** @constructor */
function $h_s_Option$WithFilter() {
}
$h_s_Option$WithFilter.prototype = $p;
$p.b4f = (function(f) {
  var this$1 = this.tu;
  var p = this.tv;
  var this$2 = ((this$1.c() || (!(!p.i(this$1.d())))) ? this$1 : $m_s_None$());
  return (this$2.c() ? $m_s_None$() : new $c_s_Some(f.i(this$2.d())));
});
$p.bbT = (function(q) {
  return new $c_s_Option$WithFilter(this.tu, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2$2) => ((!(!this.tv.i(x$2$2))) && (!(!q.i(x$2$2)))))));
});
var $d_s_Option$WithFilter = new $TypeData().i($c_s_Option$WithFilter, "scala.Option$WithFilter", ({
  Gf: 1
}));
/** @constructor */
function $c_s_PartialFunction$() {
  this.UB = null;
  this.aHn = null;
  this.gt = null;
  $n_s_PartialFunction$ = this;
  this.UB = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2$2$2) => $m_s_PartialFunction$().UB));
  this.aHn = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$3$2$2) => false));
  this.gt = new $c_s_PartialFunction$$anon$1();
}
$p = $c_s_PartialFunction$.prototype = new $h_O();
$p.constructor = $c_s_PartialFunction$;
/** @constructor */
function $h_s_PartialFunction$() {
}
$h_s_PartialFunction$.prototype = $p;
$p.aRQ = (function(x) {
  return (this.UB === x);
});
$p.baE = (function(f) {
  return ((f instanceof $c_s_PartialFunction$Lifted) ? f.abQ : new $c_s_PartialFunction$Unlifted(f));
});
var $d_s_PartialFunction$ = new $TypeData().i($c_s_PartialFunction$, "scala.PartialFunction$", ({
  Gg: 1
}));
var $n_s_PartialFunction$;
function $m_s_PartialFunction$() {
  if ((!$n_s_PartialFunction$)) {
    $n_s_PartialFunction$ = new $c_s_PartialFunction$();
  }
  return $n_s_PartialFunction$;
}
function $f_s_Proxy__toString__T($thiz) {
  return ("" + $thiz.ahX());
}
function $ps_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(len$1, \u03b4this$2, ord$1) {
  if ((len$1 < 300)) {
    var a = $m_sr_ScalaRunTime$().aMm(\u03b4this$2);
    $m_s_util_Sorting$().Y5(a, 0, $m_jl_reflect_Array$().c6(a), ord$1);
    return a;
  } else {
    if ($d_O.R($objectGetClass(\u03b4this$2).ba.Q().ba)) {
      var a$2 = $m_ju_Arrays$().WA(\u03b4this$2, len$1, $d_O.r().l());
    } else {
      var dest = new $ac_O(len$1);
      $m_s_Array$().fv(\u03b4this$2, 0, dest, 0, $m_jl_reflect_Array$().c6(\u03b4this$2));
      var a$2 = dest;
    }
    $m_ju_Arrays$().Jn(a$2, ord$1);
    return $m_s_Array$().aZg(a$2, len$1, $m_s_reflect_ClassTag$().y0($objectGetClass(\u03b4this$2).ba.Q()));
  }
}
/** @constructor */
function $c_sc_ArrayOps$() {
  this.aHt = null;
  $n_sc_ArrayOps$ = this;
  this.aHt = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$2) => $m_sc_ArrayOps$().aHt));
}
$p = $c_sc_ArrayOps$.prototype = new $h_O();
$p.constructor = $c_sc_ArrayOps$;
/** @constructor */
function $h_sc_ArrayOps$() {
}
$h_sc_ArrayOps$.prototype = $p;
$p.aP6 = (function(this$) {
  if (($m_jl_reflect_Array$().c6(this$) !== 0)) {
    return $m_sr_ScalaRunTime$().f6(this$, 0);
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "head of empty array");
  }
});
$p.a44 = (function(this$) {
  if (($m_jl_reflect_Array$().c6(this$) !== 0)) {
    return $m_sr_ScalaRunTime$().f6(this$, (($m_jl_reflect_Array$().c6(this$) - 1) | 0));
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "last of empty array");
  }
});
$p.X7 = (function(this$) {
  return (($m_jl_reflect_Array$().c6(this$) === 0) ? $m_s_None$() : new $c_s_Some($m_sc_ArrayOps$().aP6(this$)));
});
$p.b41 = (function(this$) {
  return (($m_jl_reflect_Array$().c6(this$) === 0) ? $m_s_None$() : new $c_s_Some($m_sc_ArrayOps$().a44(this$)));
});
$p.u9 = (function(this$, len) {
  var x = $m_jl_reflect_Array$().c6(this$);
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$p.ls = (function(this$, from, until) {
  var lo = ((from > 0) ? from : 0);
  var b = $m_jl_reflect_Array$().c6(this$);
  var hi = ((until < b) ? until : b);
  if ((hi > lo)) {
    if ((this$ instanceof $ac_O)) {
      return $m_ju_Arrays$().d7(this$, lo, hi);
    } else if ((this$ instanceof $ac_I)) {
      return $m_ju_Arrays$().aZm(this$, lo, hi);
    } else if ((this$ instanceof $ac_D)) {
      return $m_ju_Arrays$().aZk(this$, lo, hi);
    } else if ((this$ instanceof $ac_J)) {
      return $m_ju_Arrays$().afe(this$, lo, hi);
    } else if ((this$ instanceof $ac_F)) {
      return $m_ju_Arrays$().aZl(this$, lo, hi);
    } else if ((this$ instanceof $ac_C)) {
      return $m_ju_Arrays$().afd(this$, lo, hi);
    } else if ((this$ instanceof $ac_B)) {
      return $m_ju_Arrays$().aZj(this$, lo, hi);
    } else if ((this$ instanceof $ac_S)) {
      return $m_ju_Arrays$().aZn(this$, lo, hi);
    } else if ((this$ instanceof $ac_Z)) {
      return $m_ju_Arrays$().aZo(this$, lo, hi);
    } else {
      throw new $c_s_MatchError(this$);
    }
  } else {
    return $m_s_reflect_ClassTag$().y0($objectGetClass(this$).ba.Q()).b2(0);
  }
});
$p.aSG = (function(this$) {
  if (($m_jl_reflect_Array$().c6(this$) === 0)) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "tail of empty array");
  } else {
    return $m_sc_ArrayOps$().ls(this$, 1, $m_jl_reflect_Array$().c6(this$));
  }
});
$p.aNB = (function(this$, n) {
  return $m_sc_ArrayOps$().ls(this$, n, $m_jl_reflect_Array$().c6(this$));
});
$p.b0e = (function(this$, n) {
  return $m_sc_ArrayOps$().ls(this$, 0, (($m_jl_reflect_Array$().c6(this$) - ((n > 0) ? n : 0)) | 0));
});
$p.u8 = (function(this$) {
  if ((this$ instanceof $ac_O)) {
    return $ct_sc_ArrayOps$ArrayIterator__O__(new $c_sc_ArrayOps$ArrayIterator(), this$);
  } else if ((this$ instanceof $ac_I)) {
    return new $c_sc_ArrayOps$ArrayIterator$mcI$sp(this$);
  } else if ((this$ instanceof $ac_D)) {
    return new $c_sc_ArrayOps$ArrayIterator$mcD$sp(this$);
  } else if ((this$ instanceof $ac_J)) {
    return new $c_sc_ArrayOps$ArrayIterator$mcJ$sp(this$);
  } else if ((this$ instanceof $ac_F)) {
    return new $c_sc_ArrayOps$ArrayIterator$mcF$sp(this$);
  } else if ((this$ instanceof $ac_C)) {
    return new $c_sc_ArrayOps$ArrayIterator$mcC$sp(this$);
  } else if ((this$ instanceof $ac_B)) {
    return new $c_sc_ArrayOps$ArrayIterator$mcB$sp(this$);
  } else if ((this$ instanceof $ac_S)) {
    return new $c_sc_ArrayOps$ArrayIterator$mcS$sp(this$);
  } else if ((this$ instanceof $ac_Z)) {
    return new $c_sc_ArrayOps$ArrayIterator$mcZ$sp(this$);
  } else if ($isArrayOf_jl_Void(this$, 1)) {
    return new $c_sc_ArrayOps$ArrayIterator$mcV$sp(this$);
  } else if ((this$ === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  } else {
    throw new $c_s_MatchError(this$);
  }
});
$p.b9f = (function(this$, ord) {
  var len = $m_jl_reflect_Array$().c6(this$);
  if ((len <= 1)) {
    return $m_sr_ScalaRunTime$().aMm(this$);
  } else if ((this$ instanceof $ac_O)) {
    var a = $m_ju_Arrays$().ex(this$, len);
    $m_ju_Arrays$().Jn(a, ord);
    return a;
  } else if ((this$ instanceof $ac_I)) {
    if ((ord === $m_s_math_Ordering$Int$())) {
      var a$2 = $m_ju_Arrays$().aN9(this$, len);
      $m_ju_Arrays$().aSh(a$2);
      return a$2;
    } else {
      return $ps_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(len, this$, ord);
    }
  } else if ((this$ instanceof $ac_J)) {
    if ((ord === $m_s_math_Ordering$Long$())) {
      var a$3 = $m_ju_Arrays$().aNa(this$, len);
      $m_ju_Arrays$().aSi(a$3);
      return a$3;
    } else {
      return $ps_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(len, this$, ord);
    }
  } else if ((this$ instanceof $ac_C)) {
    if ((ord === $m_s_math_Ordering$Char$())) {
      var a$4 = $m_ju_Arrays$().a31(this$, len);
      $m_ju_Arrays$().aSg(a$4);
      return a$4;
    } else {
      return $ps_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(len, this$, ord);
    }
  } else if ((this$ instanceof $ac_B)) {
    if ((ord === $m_s_math_Ordering$Byte$())) {
      var a$5 = $m_ju_Arrays$().aN8(this$, len);
      $m_ju_Arrays$().aSf(a$5);
      return a$5;
    } else {
      return $ps_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(len, this$, ord);
    }
  } else if ((this$ instanceof $ac_S)) {
    if ((ord === $m_s_math_Ordering$Short$())) {
      var a$6 = $m_ju_Arrays$().aNb(this$, len);
      $m_ju_Arrays$().aSj(a$6);
      return a$6;
    } else {
      return $ps_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(len, this$, ord);
    }
  } else if ((this$ instanceof $ac_Z)) {
    if ((ord === $m_s_math_Ordering$Boolean$())) {
      var a$7 = $m_ju_Arrays$().aNc(this$, len);
      $m_s_util_Sorting$().Y5(a$7, 0, a$7.a.length, $m_s_math_Ordering$Boolean$());
      return a$7;
    } else {
      return $ps_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(len, this$, ord);
    }
  } else {
    return $ps_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(len, this$, ord);
  }
});
$p.b2K = (function(this$, p, from) {
  var i = from;
  while ((i < $m_jl_reflect_Array$().c6(this$))) {
    if ((!(!p.i($m_sr_ScalaRunTime$().f6(this$, i))))) {
      return i;
    }
    i = ((1 + i) | 0);
  }
  return (-1);
});
$p.b1i = (function(this$, p) {
  var idx = $m_sc_ArrayOps$().b2K(this$, p, 0);
  return ((idx === (-1)) ? $m_s_None$() : new $c_s_Some($m_sr_ScalaRunTime$().f6(this$, idx)));
});
$p.afc = (function(this$, elem) {
  _return: {
    var i = 0;
    while ((i < $m_jl_reflect_Array$().c6(this$))) {
      if ($m_sr_BoxesRunTime$().Q($m_sr_ScalaRunTime$().f6(this$, i), elem)) {
        var $x_1 = i;
        break _return;
      }
      i = ((1 + i) | 0);
    }
    var $x_1 = (-1);
  }
  return ($x_1 >= 0);
});
$p.aOh = (function(this$, f) {
  var len = $m_jl_reflect_Array$().c6(this$);
  var i = 0;
  if ((this$ instanceof $ac_O)) {
    while ((i < len)) {
      f.i(this$.a[i]);
      i = ((1 + i) | 0);
    }
  } else if ((this$ instanceof $ac_I)) {
    while ((i < len)) {
      f.i(this$.a[i]);
      i = ((1 + i) | 0);
    }
  } else if ((this$ instanceof $ac_D)) {
    while ((i < len)) {
      f.i(this$.a[i]);
      i = ((1 + i) | 0);
    }
  } else if ((this$ instanceof $ac_J)) {
    while ((i < len)) {
      var $x_2 = this$.a;
      var $x_3 = (i << 1);
      var $x_1_$_lo = $x_2[$x_3];
      var $x_1_$_hi = $x_2[(($x_3 + 1) | 0)];
      f.i($bL($x_1_$_lo, $x_1_$_hi));
      i = ((1 + i) | 0);
    }
  } else if ((this$ instanceof $ac_F)) {
    while ((i < len)) {
      f.i(this$.a[i]);
      i = ((1 + i) | 0);
    }
  } else if ((this$ instanceof $ac_C)) {
    while ((i < len)) {
      f.i($bC(this$.a[i]));
      i = ((1 + i) | 0);
    }
  } else if ((this$ instanceof $ac_B)) {
    while ((i < len)) {
      f.i(this$.a[i]);
      i = ((1 + i) | 0);
    }
  } else if ((this$ instanceof $ac_S)) {
    while ((i < len)) {
      f.i(this$.a[i]);
      i = ((1 + i) | 0);
    }
  } else if ((this$ instanceof $ac_Z)) {
    while ((i < len)) {
      f.i(this$.a[i]);
      i = ((1 + i) | 0);
    }
  } else {
    throw new $c_s_MatchError(this$);
  }
});
$p.b2M = (function(this$) {
  return new $c_sci_Range$Exclusive(0, $m_jl_reflect_Array$().c6(this$), 1);
});
$p.kX = (function(this$) {
  return $m_sci_ArraySeq$().n0($m_s_Array$().y4(this$, $m_jl_reflect_Array$().c6(this$)));
});
var $d_sc_ArrayOps$ = new $TypeData().i($c_sc_ArrayOps$, "scala.collection.ArrayOps$", ({
  Gu: 1
}));
var $n_sc_ArrayOps$;
function $m_sc_ArrayOps$() {
  if ((!$n_sc_ArrayOps$)) {
    $n_sc_ArrayOps$ = new $c_sc_ArrayOps$();
  }
  return $n_sc_ArrayOps$;
}
/** @constructor */
function $c_sc_Hashing$() {
}
$p = $c_sc_Hashing$.prototype = new $h_O();
$p.constructor = $c_sc_Hashing$;
/** @constructor */
function $h_sc_Hashing$() {
}
$h_sc_Hashing$.prototype = $p;
$p.bz = (function(hcode) {
  var h = ((hcode + (~(hcode << 9))) | 0);
  h = (h ^ ((h >>> 14) | 0));
  h = ((h + (h << 4)) | 0);
  return (h ^ ((h >>> 10) | 0));
});
var $d_sc_Hashing$ = new $TypeData().i($c_sc_Hashing$, "scala.collection.Hashing$", ({
  GM: 1
}));
var $n_sc_Hashing$;
function $m_sc_Hashing$() {
  if ((!$n_sc_Hashing$)) {
    $n_sc_Hashing$ = new $c_sc_Hashing$();
  }
  return $n_sc_Hashing$;
}
function $f_sc_IterableOnceOps__foreach__F1__V($thiz, f) {
  var it = $thiz.o();
  while (it.p()) {
    f.i(it.q());
  }
}
function $f_sc_IterableOnceOps__forall__F1__Z($thiz, p) {
  var res = true;
  var it = $thiz.o();
  while ((res && it.p())) {
    res = (!(!p.i(it.q())));
  }
  return res;
}
function $f_sc_IterableOnceOps__exists__F1__Z($thiz, p) {
  var res = false;
  var it = $thiz.o();
  while (((!res) && it.p())) {
    res = (!(!p.i(it.q())));
  }
  return res;
}
function $f_sc_IterableOnceOps__find__F1__s_Option($thiz, p) {
  var it = $thiz.o();
  while (it.p()) {
    var a = it.q();
    if ((!(!p.i(a)))) {
      return new $c_s_Some(a);
    }
  }
  return $m_s_None$();
}
function $f_sc_IterableOnceOps__foldLeft__O__F2__O($thiz, z, op) {
  if ($is_sc_IndexedSeq($thiz)) {
    return $p_sc_IterableOnceOps__loop$1__I__I__O__F2__sc_IndexedSeq__O($thiz, 0, $thiz.C(), z, op, $thiz);
  } else {
    var result = z;
    var it = $thiz.o();
    while (it.p()) {
      result = op.R(result, it.q());
    }
    return result;
  }
}
function $f_sc_IterableOnceOps__reduceLeft__F2__O($thiz, op) {
  if ($is_sc_IndexedSeq($thiz)) {
    if (($thiz.C() > 0)) {
      var z = $thiz.l(0);
      return $p_sc_IterableOnceOps__loop$1__I__I__O__F2__sc_IndexedSeq__O($thiz, 1, $thiz.C(), z, op, $thiz);
    }
  }
  if (($thiz.V() === 0)) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.reduceLeft");
  }
  var it = $thiz.o();
  if (it.p()) {
    var acc = it.q();
    while (it.p()) {
      acc = op.R(acc, it.q());
    }
    return acc;
  } else {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.reduceLeft");
  }
}
function $f_sc_IterableOnceOps__isEmpty__Z($thiz) {
  switch ($thiz.V()) {
    case (-1): {
      return (!$thiz.o().p());
      break;
    }
    case 0: {
      return true;
      break;
    }
    default: {
      return false;
    }
  }
}
function $f_sc_IterableOnceOps__size__I($thiz) {
  if (($thiz.V() >= 0)) {
    return $thiz.V();
  } else {
    var it = $thiz.o();
    var len = 0;
    while (it.p()) {
      len = ((1 + len) | 0);
      it.q();
    }
    return len;
  }
}
function $f_sc_IterableOnceOps__copyToArray__O__I__I__I($thiz, dest, start, n) {
  var it = $thiz.o();
  var i = start;
  var x1 = $thiz.V();
  var srclen = ((x1 === (-1)) ? $m_jl_reflect_Array$().c6(dest) : x1);
  var destLen = $m_jl_reflect_Array$().c6(dest);
  var limit = ((n < srclen) ? n : srclen);
  var capacity = ((start < 0) ? destLen : ((destLen - start) | 0));
  var total = ((capacity < limit) ? capacity : limit);
  var end = ((start + ((total < 0) ? 0 : total)) | 0);
  while (((i < end) && it.p())) {
    $m_sr_ScalaRunTime$().kn(dest, i, it.q());
    i = ((1 + i) | 0);
  }
  return ((i - start) | 0);
}
function $f_sc_IterableOnceOps__sum__s_math_Numeric__O($thiz, num) {
  switch ($thiz.V()) {
    case (-1): {
      return $thiz.hO(num.Po(0), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((x$2$2, y$2$2) => num.XK(x$2$2, y$2$2))));
      break;
    }
    case 0: {
      return num.Po(0);
      break;
    }
    default: {
      return $thiz.kT(new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((x$2$2$1, y$2$2$1) => num.XK(x$2$2$1, y$2$2$1))));
    }
  }
}
function $f_sc_IterableOnceOps__min__s_math_Ordering__O($thiz, ord) {
  switch ($thiz.V()) {
    case (-1): {
      var it = $thiz.o();
      if (it.p()) {
        var acc = it.q();
        while (it.p()) {
          var x0 = acc;
          var x1$1 = it.q();
          acc = ord.kR(x0, x1$1);
        }
        return acc;
      } else {
        throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.min");
      }
      break;
    }
    case 0: {
      throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.min");
      break;
    }
    default: {
      return $thiz.kT(new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((x$2$2, y$2$2) => ord.kR(x$2$2, y$2$2))));
    }
  }
}
function $f_sc_IterableOnceOps__minOption__s_math_Ordering__s_Option($thiz, ord) {
  switch ($thiz.V()) {
    case (-1): {
      var it = $thiz.o();
      if (it.p()) {
        var acc = it.q();
        while (it.p()) {
          var x0 = acc;
          var x1$1 = it.q();
          acc = ord.kR(x0, x1$1);
        }
        return new $c_s_Some(acc);
      } else {
        return $m_s_None$();
      }
      break;
    }
    case 0: {
      return $m_s_None$();
      break;
    }
    default: {
      return new $c_s_Some($thiz.kT(new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((x$2$2, y$2$2) => ord.kR(x$2$2, y$2$2)))));
    }
  }
}
function $f_sc_IterableOnceOps__max__s_math_Ordering__O($thiz, ord) {
  switch ($thiz.V()) {
    case (-1): {
      var it = $thiz.o();
      if (it.p()) {
        var acc = it.q();
        while (it.p()) {
          var x0 = acc;
          var x1$1 = it.q();
          acc = ord.kQ(x0, x1$1);
        }
        return acc;
      } else {
        throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.max");
      }
      break;
    }
    case 0: {
      throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.max");
      break;
    }
    default: {
      return $thiz.kT(new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((x$2$2, y$2$2) => ord.kQ(x$2$2, y$2$2))));
    }
  }
}
function $f_sc_IterableOnceOps__maxOption__s_math_Ordering__s_Option($thiz, ord) {
  switch ($thiz.V()) {
    case (-1): {
      var it = $thiz.o();
      if (it.p()) {
        var acc = it.q();
        while (it.p()) {
          var x0 = acc;
          var x1$1 = it.q();
          acc = ord.kQ(x0, x1$1);
        }
        return new $c_s_Some(acc);
      } else {
        return $m_s_None$();
      }
      break;
    }
    case 0: {
      return $m_s_None$();
      break;
    }
    default: {
      return new $c_s_Some($thiz.kT(new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((x$2$2, y$2$2) => ord.kQ(x$2$2, y$2$2)))));
    }
  }
}
function $f_sc_IterableOnceOps__maxBy__F1__s_math_Ordering__O($thiz, f, ord) {
  if (($thiz.V() === 0)) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.maxBy");
  } else {
    return $thiz.hO(new $c_sc_IterableOnceOps$Maximized($thiz, "maxBy", f, new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((x$2$2, y$2$2) => ord.mL(x$2$2, y$2$2)))), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((m$2$2, a$2$2) => m$2$2.a2L(m$2$2, a$2$2)))).aR();
  }
}
function $f_sc_IterableOnceOps__minBy__F1__s_math_Ordering__O($thiz, f, ord) {
  if (($thiz.V() === 0)) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.minBy");
  } else {
    return $thiz.hO(new $c_sc_IterableOnceOps$Maximized($thiz, "minBy", f, new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((x$2$2, y$2$2) => ord.lZ(x$2$2, y$2$2)))), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((m$2$2, a$2$2) => m$2$2.a2L(m$2$2, a$2$2)))).aR();
  }
}
function $f_sc_IterableOnceOps__minByOption__F1__s_math_Ordering__s_Option($thiz, f, ord) {
  return (($thiz.V() === 0) ? $m_s_None$() : $thiz.hO(new $c_sc_IterableOnceOps$Maximized($thiz, "minBy", f, new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((x$2$2, y$2$2) => ord.lZ(x$2$2, y$2$2)))), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((m$2$2, a$2$2) => m$2$2.a2L(m$2$2, a$2$2)))).rg());
}
function $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option($thiz, pf) {
  var sentinel = new $c_sc_IterableOnceOps$$anon$1($thiz);
  var it = $thiz.o();
  while (it.p()) {
    var x = pf.aC(it.q(), sentinel);
    if ((x !== sentinel)) {
      return new $c_s_Some(x);
    }
  }
  return $m_s_None$();
}
function $f_sc_IterableOnceOps__mkString__T__T__T__T($thiz, start, sep, end) {
  return (($thiz.V() === 0) ? (("" + start) + end) : $thiz.lf($ct_scm_StringBuilder__(new $c_scm_StringBuilder()), start, sep, end).bP.ah);
}
function $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder($thiz, b, start, sep, end) {
  var jsb = b.bP;
  if ((start.length !== 0)) {
    jsb.ah = (("" + jsb.ah) + start);
  }
  var it = $thiz.o();
  if (it.p()) {
    var obj = it.q();
    jsb.ah = (("" + jsb.ah) + obj);
    while (it.p()) {
      if ((sep.length !== 0)) {
        jsb.ah = (("" + jsb.ah) + sep);
      }
      var obj$1 = it.q();
      jsb.ah = (("" + jsb.ah) + obj$1);
    }
  }
  if ((end.length !== 0)) {
    jsb.ah = (("" + jsb.ah) + end);
  }
  return b;
}
function $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O($thiz, evidence$2) {
  if (($thiz.V() >= 0)) {
    var destination = evidence$2.b2($thiz.V());
    $thiz.cR(destination, 0, 2147483647);
    return destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    var elementClass = evidence$2.h8();
    capacity = 0;
    size = 0;
    var isCharArrayBuilder = (elementClass === $d_C.l());
    jsElems = [];
    var it = $thiz.o();
    while (it.p()) {
      var elem = it.q();
      var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? elementClass.ba.z : elem));
      jsElems.push(unboxedElem);
    }
    var elemRuntimeClass = ((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass));
    return elemRuntimeClass.ba.r().w(jsElems);
  }
}
function $f_sc_IterableOnceOps__reversed__sc_Iterable($thiz) {
  var xs = $m_sci_Nil$();
  var it = $thiz.o();
  while (it.p()) {
    xs = new $c_sci_$colon$colon(it.q(), xs);
  }
  return xs;
}
function $p_sc_IterableOnceOps__loop$1__I__I__O__F2__sc_IndexedSeq__O($thiz, at, end, acc, op$1, seq$1) {
  while (true) {
    if ((at === end)) {
      return acc;
    } else {
      var temp$at = ((1 + at) | 0);
      var temp$acc = op$1.R(acc, seq$1.l(at));
      at = temp$at;
      acc = temp$acc;
    }
  }
}
/** @constructor */
function $c_sc_Iterator$ConcatIteratorCell(head, tail) {
  this.aHS = null;
  this.UP = null;
  this.aHS = head;
  this.UP = tail;
}
$p = $c_sc_Iterator$ConcatIteratorCell.prototype = new $h_O();
$p.constructor = $c_sc_Iterator$ConcatIteratorCell;
/** @constructor */
function $h_sc_Iterator$ConcatIteratorCell() {
}
$h_sc_Iterator$ConcatIteratorCell.prototype = $p;
$p.b2y = (function() {
  return this.aHS.a3().o();
});
var $d_sc_Iterator$ConcatIteratorCell = new $TypeData().i($c_sc_Iterator$ConcatIteratorCell, "scala.collection.Iterator$ConcatIteratorCell", ({
  Hf: 1
}));
/** @constructor */
function $c_sc_StringOps$() {
  this.aHW = null;
  $n_sc_StringOps$ = this;
  this.aHW = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$2) => $m_sc_StringOps$().aHW));
}
$p = $c_sc_StringOps$.prototype = new $h_O();
$p.constructor = $c_sc_StringOps$;
/** @constructor */
function $h_sc_StringOps$() {
}
$h_sc_StringOps$.prototype = $p;
$p.IJ = (function(this$, elem) {
  return ($f_T__indexOf__I__I(this$, elem) >= 0);
});
$p.a4J = (function(this$, from, until) {
  var start = ((from > 0) ? from : 0);
  var that = this$.length;
  var end = ((until < that) ? until : that);
  return ((start >= end) ? "" : this$.substring(start, end));
});
$p.tR = (function(this$, n) {
  if ((n <= 0)) {
    return "";
  } else {
    var sb = $ct_jl_StringBuilder__I__(new $c_jl_StringBuilder(), Math.imul(this$.length, n));
    var i = 0;
    while ((i < n)) {
      sb.ah = (("" + sb.ah) + this$);
      i = ((1 + i) | 0);
    }
    return sb.ah;
  }
});
$p.wg = (function(this$, prefix) {
  if ((!(!this$.startsWith(prefix)))) {
    var beginIndex = prefix.length;
    return this$.substring(beginIndex);
  } else {
    return this$;
  }
});
$p.wh = (function(this$, suffix) {
  if ((!(!this$.endsWith(suffix)))) {
    var endIndex = ((this$.length - suffix.length) | 0);
    return this$.substring(0, endIndex);
  } else {
    return this$;
  }
});
$p.aSv = (function(this$, marginChar) {
  var sb = $ct_jl_StringBuilder__I__(new $c_jl_StringBuilder(), this$.length);
  var this$3 = new $c_sc_StringOps$$anon$1(this$, false);
  while ((this$3.kd < this$3.zV)) {
    var x0 = this$3.wa();
    var len = x0.length;
    var index = 0;
    while (((index < len) && (x0.charCodeAt(index) <= 32))) {
      index = ((1 + index) | 0);
    }
    if (((index < len) && (x0.charCodeAt(index) === marginChar))) {
      var beginIndex = ((1 + index) | 0);
      var stripped = x0.substring(beginIndex);
    } else {
      var stripped = x0;
    }
    sb.ah = (("" + sb.ah) + stripped);
  }
  return sb.ah;
});
$p.b0O = (function(this$, ch) {
  return (((((((ch - 97) | 0) >>> 0) <= 25) || ((((ch - 65) | 0) >>> 0) <= 25)) || ((((ch - 48) | 0) >>> 0) <= 9)) ? ("" + $cToS(ch)) : ("\\" + $cToS(ch)));
});
$p.Ej = (function(this$, separator) {
  return $f_T__split__T__I__AT(this$, $m_sc_StringOps$().b0O(this$, separator), 0);
});
$p.ba2 = (function(this$, s) {
  if ((s === null)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "For input string: \"null\"");
  } else {
    _return: {
      var len = s.length;
      if ((len === 4)) {
        var i = 0;
        while ((i !== len)) {
          var thisCP = $f_T__codePointAt__I__I(s, i);
          if (($m_jl_Character$().iy($m_jl_Character$().j0(thisCP)) !== $m_jl_Character$().iy($m_jl_Character$().j0($f_T__codePointAt__I__I("true", i))))) {
            var $x_1 = false;
            break _return;
          }
          i = ((i + ((thisCP >= 65536) ? 2 : 1)) | 0);
        }
        var $x_1 = true;
      } else {
        var $x_1 = false;
      }
    }
    if ($x_1) {
      return true;
    } else {
      _return$1: {
        var len$1 = s.length;
        if ((len$1 === 5)) {
          var i$1 = 0;
          while ((i$1 !== len$1)) {
            var thisCP$1 = $f_T__codePointAt__I__I(s, i$1);
            if (($m_jl_Character$().iy($m_jl_Character$().j0(thisCP$1)) !== $m_jl_Character$().iy($m_jl_Character$().j0($f_T__codePointAt__I__I("false", i$1))))) {
              var $x_2 = false;
              break _return$1;
            }
            i$1 = ((i$1 + ((thisCP$1 >= 65536) ? 2 : 1)) | 0);
          }
          var $x_2 = true;
        } else {
          var $x_2 = false;
        }
      }
      if ((!$x_2)) {
        throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("For input string: \"" + s) + "\""));
      }
      return false;
    }
  }
});
$p.baL = (function(this$, arg) {
  return ((arg instanceof $c_s_math_ScalaNumber) ? arg.aT9() : arg);
});
$p.u0 = (function(this$, args) {
  return $m_jl_String$().b1B(this$, args.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((arg$2$2) => $m_sc_StringOps$().baL(this$, arg$2$2)))).nG($m_s_reflect_ManifestFactory$ObjectManifest$()));
});
$p.pw = (function(this$) {
  if ((this$ === "")) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "head of empty String");
  } else {
    return this$.charCodeAt(0);
  }
});
$p.X8 = (function(this$) {
  return ((this$ === "") ? $m_s_None$() : new $c_s_Some($bC(this$.charCodeAt(0))));
});
$p.b40 = (function(this$) {
  if ((this$ === "")) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "last of empty String");
  } else {
    return this$.charCodeAt(((this$.length - 1) | 0));
  }
});
$p.a4z = (function(this$) {
  return $ct_jl_StringBuilder__T__(new $c_jl_StringBuilder(), this$).b7S().ah;
});
$p.b9I = (function(this$) {
  if ((this$ === "")) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "tail of empty String");
  } else {
    return $m_sc_StringOps$().a4J(this$, 1, this$.length);
  }
});
$p.a4R = (function(this$, n) {
  var $x_1 = $m_sc_StringOps$();
  var y = this$.length;
  return $x_1.a4J(this$, 0, ((n < y) ? n : y));
});
$p.kp = (function(this$, n) {
  var $x_1 = $m_sc_StringOps$();
  var y = this$.length;
  return $x_1.a4J(this$, ((n < y) ? n : y), this$.length);
});
$p.WF = (function(this$, n) {
  return $m_sc_StringOps$().a4R(this$, ((this$.length - ((n > 0) ? n : 0)) | 0));
});
var $d_sc_StringOps$ = new $TypeData().i($c_sc_StringOps$, "scala.collection.StringOps$", ({
  HF: 1
}));
var $n_sc_StringOps$;
function $m_sc_StringOps$() {
  if ((!$n_sc_StringOps$)) {
    $n_sc_StringOps$ = new $c_sc_StringOps$();
  }
  return $n_sc_StringOps$;
}
function $p_sc_StringParsers$__step$1__I__I__Z__I__T__s_Option($thiz, i, agg, isPositive, len$2, from$2) {
  while (true) {
    if ((i === len$2)) {
      return ((!isPositive) ? new $c_s_Some(agg) : ((agg === (-2147483648)) ? $m_s_None$() : new $c_s_Some(((-agg) | 0))));
    } else if ((agg < (-214748364))) {
      return $m_s_None$();
    } else {
      var digit = $m_jl_Character$().WE(from$2.charCodeAt(i), 10);
      if (((digit === (-1)) || ((((-214748364) ^ agg) | (9 ^ digit)) === 0))) {
        return $m_s_None$();
      } else {
        var temp$i = ((1 + i) | 0);
        var temp$agg = ((Math.imul(10, agg) - digit) | 0);
        i = temp$i;
        agg = temp$agg;
      }
    }
  }
}
function $ps_sc_StringParsers$__isHexDigit$1__C__Z(ch) {
  return ((((((ch - 48) | 0) >>> 0) <= 9) || ((((ch - 97) | 0) >>> 0) <= 5)) || ((((ch - 65) | 0) >>> 0) <= 5));
}
function $p_sc_StringParsers$__prefixOK$1__I__I__T__Z($thiz, startIndex, endIndex, format$1) {
  var len = ((endIndex - startIndex) | 0);
  if ((len > 0)) {
    if ((format$1.charCodeAt(startIndex) === 46)) {
      if ((len > 1)) {
        var start = ((1 + startIndex) | 0);
        var i = start;
        while (true) {
          if ((i >= endIndex)) {
            return true;
          } else {
            if ($ps_sc_StringParsers$__isHexDigit$1__C__Z(format$1.charCodeAt(i))) {
              i = ((1 + i) | 0);
              continue;
            }
            return false;
          }
        }
      } else {
        return false;
      }
    } else {
      var i$1 = startIndex;
      while (((i$1 < endIndex) && $ps_sc_StringParsers$__isHexDigit$1__C__Z(format$1.charCodeAt(i$1)))) {
        i$1 = ((1 + i$1) | 0);
      }
      var noLeading = i$1;
      if ((noLeading >= endIndex)) {
        return true;
      } else if ((format$1.charCodeAt(noLeading) === 46)) {
        var start$1 = ((1 + noLeading) | 0);
        var i$2 = start$1;
        while (true) {
          if ((i$2 >= endIndex)) {
            return true;
          } else {
            if ($ps_sc_StringParsers$__isHexDigit$1__C__Z(format$1.charCodeAt(i$2))) {
              i$2 = ((1 + i$2) | 0);
              continue;
            }
            return false;
          }
        }
      } else {
        return false;
      }
    }
  } else {
    return false;
  }
}
function $p_sc_StringParsers$__postfixOK$1__I__I__T__Z($thiz, startIndex, endIndex, format$1) {
  if ((startIndex < endIndex)) {
    var i = startIndex;
    var $x_1;
    while (true) {
      if ((i >= endIndex)) {
        var $x_1 = true;
        break;
      } else {
        if (((((format$1.charCodeAt(i) - 48) | 0) >>> 0) <= 9)) {
          i = ((1 + i) | 0);
          continue;
        }
        var $x_1 = false;
        break;
      }
    }
    if ($x_1) {
      return true;
    } else {
      var startchar = format$1.charCodeAt(startIndex);
      if ((((startchar === 43) || (startchar === 45)) && (((endIndex - startIndex) | 0) > 1))) {
        var start = ((1 + startIndex) | 0);
        var i$1 = start;
        while (true) {
          if ((i$1 >= endIndex)) {
            return true;
          } else {
            if (((((format$1.charCodeAt(i$1) - 48) | 0) >>> 0) <= 9)) {
              i$1 = ((1 + i$1) | 0);
              continue;
            }
            return false;
          }
        }
      } else {
        return false;
      }
    }
  } else {
    return false;
  }
}
function $p_sc_StringParsers$__isHexFloatLiteral$1__I__I__T__Z($thiz, startIndex, endIndex, format$1) {
  _return: {
    var len = format$1.length;
    var i = startIndex;
    while ((i < len)) {
      var index = i;
      var x0 = format$1.charCodeAt(index);
      if (((x0 === 80) || (x0 === 112))) {
        var pIndex = i;
        break _return;
      }
      i = ((1 + i) | 0);
    }
    var pIndex = (-1);
  }
  return (((pIndex <= endIndex) && $p_sc_StringParsers$__prefixOK$1__I__I__T__Z($thiz, startIndex, pIndex, format$1)) && $p_sc_StringParsers$__postfixOK$1__I__I__T__Z($thiz, ((1 + pIndex) | 0), endIndex, format$1));
}
function $ps_sc_StringParsers$__isExp$1__C__Z(c) {
  return ((c === 69) || (c === 101));
}
function $p_sc_StringParsers$__expOK$1__I__I__T__Z($thiz, startIndex, endIndex, format$1) {
  if ((startIndex < endIndex)) {
    var startChar = format$1.charCodeAt(startIndex);
    if (((startChar === 43) || (startChar === 45))) {
      if ((endIndex > ((1 + startIndex) | 0))) {
        var from = ((1 + startIndex) | 0);
        var i = from;
        while (((i < endIndex) && ((((format$1.charCodeAt(i) - 48) | 0) >>> 0) <= 9))) {
          i = ((1 + i) | 0);
        }
        return (i === endIndex);
      } else {
        return false;
      }
    } else {
      var i$1 = startIndex;
      while (((i$1 < endIndex) && ((((format$1.charCodeAt(i$1) - 48) | 0) >>> 0) <= 9))) {
        i$1 = ((1 + i$1) | 0);
      }
      return (i$1 === endIndex);
    }
  } else {
    return false;
  }
}
function $p_sc_StringParsers$__isDecFloatLiteral$1__I__I__T__Z($thiz, startIndex, endIndex, format$1) {
  var startChar = format$1.charCodeAt(startIndex);
  if ((startChar === 46)) {
    var from = ((1 + startIndex) | 0);
    var i = from;
    while (((i < endIndex) && ((((format$1.charCodeAt(i) - 48) | 0) >>> 0) <= 9))) {
      i = ((1 + i) | 0);
    }
    var noSignificant = i;
    return ((noSignificant > ((1 + startIndex) | 0)) && ((noSignificant >= endIndex) || ($ps_sc_StringParsers$__isExp$1__C__Z(format$1.charCodeAt(noSignificant)) && $p_sc_StringParsers$__expOK$1__I__I__T__Z($thiz, ((1 + noSignificant) | 0), endIndex, format$1))));
  } else if (((((startChar - 48) | 0) >>> 0) <= 9)) {
    var i$1 = startIndex;
    while (((i$1 < endIndex) && ((((format$1.charCodeAt(i$1) - 48) | 0) >>> 0) <= 9))) {
      i$1 = ((1 + i$1) | 0);
    }
    var noInt = i$1;
    if ((noInt === endIndex)) {
      return true;
    } else if ((format$1.charCodeAt(noInt) === 46)) {
      var from$1 = ((1 + noInt) | 0);
      var i$2 = from$1;
      while (((i$2 < endIndex) && ((((format$1.charCodeAt(i$2) - 48) | 0) >>> 0) <= 9))) {
        i$2 = ((1 + i$2) | 0);
      }
      var noSignificant$2 = i$2;
      return ((noSignificant$2 >= endIndex) || ($ps_sc_StringParsers$__isExp$1__C__Z(format$1.charCodeAt(noSignificant$2)) && $p_sc_StringParsers$__expOK$1__I__I__T__Z($thiz, ((1 + noSignificant$2) | 0), endIndex, format$1)));
    } else {
      return ($ps_sc_StringParsers$__isExp$1__C__Z(format$1.charCodeAt(noInt)) && $p_sc_StringParsers$__expOK$1__I__I__T__Z($thiz, ((1 + noInt) | 0), endIndex, format$1));
    }
  } else {
    return false;
  }
}
/** @constructor */
function $c_sc_StringParsers$() {
}
$p = $c_sc_StringParsers$.prototype = new $h_O();
$p.constructor = $c_sc_StringParsers$;
/** @constructor */
function $h_sc_StringParsers$() {
}
$h_sc_StringParsers$.prototype = $p;
$p.hT = (function(from) {
  var len = from.length;
  if ((len === 0)) {
    return $m_s_None$();
  } else {
    var first = from.charCodeAt(0);
    var v = $m_jl_Character$().WE(first, 10);
    return ((len === 1) ? ((v > (-1)) ? new $c_s_Some(v) : $m_s_None$()) : ((v > (-1)) ? $p_sc_StringParsers$__step$1__I__I__Z__I__T__s_Option(this, 1, ((-v) | 0), true, len, from) : ((first === 43) ? $p_sc_StringParsers$__step$1__I__I__Z__I__T__s_Option(this, 1, 0, true, len, from) : ((first === 45) ? $p_sc_StringParsers$__step$1__I__I__Z__I__T__s_Option(this, 1, 0, false, len, from) : $m_s_None$()))));
  }
});
$p.c1 = (function(format) {
  _return: {
    var len = format.length;
    var i = 0;
    while ((i < len)) {
      if ((format.charCodeAt(i) > 32)) {
        var unspacedStart = i;
        break _return;
      }
      i = ((1 + i) | 0);
    }
    var unspacedStart = (-1);
  }
  _return$1: {
    var len$1 = format.length;
    var i$1 = ((len$1 - 1) | 0);
    while ((i$1 >= 0)) {
      if ((format.charCodeAt(i$1) > 32)) {
        var $x_1 = i$1;
        break _return$1;
      }
      i$1 = ((i$1 - 1) | 0);
    }
    var $x_1 = (-1);
  }
  var unspacedEnd = ((1 + $x_1) | 0);
  if ((!(((unspacedStart === (-1)) || (unspacedStart >= unspacedEnd)) || (unspacedEnd <= 0)))) {
    var startchar = format.charCodeAt(unspacedStart);
    var unsigned = (((startchar === 43) || (startchar === 45)) ? ((1 + unspacedStart) | 0) : unspacedStart);
    if ((unsigned < unspacedEnd)) {
      if ((format.charCodeAt(unsigned) === 78)) {
        return (format.substring(unsigned, unspacedEnd) === "NaN");
      } else if ((format.charCodeAt(unsigned) === 73)) {
        return (format.substring(unsigned, unspacedEnd) === "Infinity");
      } else {
        var index$2 = ((unspacedEnd - 1) | 0);
        var endchar = format.charCodeAt(index$2);
        var desuffixed = (((((endchar === 70) || (endchar === 102)) || (endchar === 100)) || (endchar === 68)) ? ((unspacedEnd - 1) | 0) : unspacedEnd);
        var len$2 = ((desuffixed - unsigned) | 0);
        return ((len$2 > 0) && (((len$2 >= 2) && ((format.charCodeAt(((1 + unsigned) | 0)) === 120) || (format.charCodeAt(((1 + unsigned) | 0)) === 88))) ? ((format.charCodeAt(unsigned) === 48) && $p_sc_StringParsers$__isHexFloatLiteral$1__I__I__T__Z(this, ((2 + unsigned) | 0), desuffixed, format)) : $p_sc_StringParsers$__isDecFloatLiteral$1__I__I__T__Z(this, unsigned, desuffixed, format)));
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
});
var $d_sc_StringParsers$ = new $TypeData().i($c_sc_StringParsers$, "scala.collection.StringParsers$", ({
  HH: 1
}));
var $n_sc_StringParsers$;
function $m_sc_StringParsers$() {
  if ((!$n_sc_StringParsers$)) {
    $n_sc_StringParsers$ = new $c_sc_StringParsers$();
  }
  return $n_sc_StringParsers$;
}
function $f_scg_BitOperations$Int__zero__I__I__Z($thiz, i, mask) {
  return ((i & mask) === 0);
}
function $f_scg_BitOperations$Int__mask__I__I__I($thiz, i, mask) {
  return (i & ($f_scg_BitOperations$Int__complement__I__I($thiz, ((mask - 1) | 0)) ^ mask));
}
function $f_scg_BitOperations$Int__hasMatch__I__I__I__Z($thiz, key, prefix, m) {
  return ($f_scg_BitOperations$Int__mask__I__I__I($thiz, key, m) === prefix);
}
function $f_scg_BitOperations$Int__complement__I__I($thiz, i) {
  return (~i);
}
/** @constructor */
function $c_scg_CommonErrors$() {
}
$p = $c_scg_CommonErrors$.prototype = new $h_O();
$p.constructor = $c_scg_CommonErrors$;
/** @constructor */
function $h_scg_CommonErrors$() {
}
$h_scg_CommonErrors$.prototype = $p;
$p.h2 = (function(index, max) {
  return $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((index + " is out of bounds (min 0, max ") + max) + ")"));
});
$p.b2J = (function(index) {
  return $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (index + " is out of bounds (min 0, max unknown)"));
});
var $d_scg_CommonErrors$ = new $TypeData().i($c_scg_CommonErrors$, "scala.collection.generic.CommonErrors$", ({
  I5: 1
}));
var $n_scg_CommonErrors$;
function $m_scg_CommonErrors$() {
  if ((!$n_scg_CommonErrors$)) {
    $n_scg_CommonErrors$ = new $c_scg_CommonErrors$();
  }
  return $n_scg_CommonErrors$;
}
function $ps_sci_IndexedSeqDefaults$__liftedTree1$1__I() {
  try {
    return $m_jl_Integer$().gc($m_jl_System$SystemProperties$().agd("scala.collection.immutable.IndexedSeq.defaultApplyPreferredMaxLength", "64"), 10, 214748364);
  } catch (e) {
    if (false) {
      return 64;
    } else {
      throw e;
    }
  }
}
/** @constructor */
function $c_sci_IndexedSeqDefaults$() {
  this.aIj = 0;
  $n_sci_IndexedSeqDefaults$ = this;
  this.aIj = $ps_sci_IndexedSeqDefaults$__liftedTree1$1__I();
}
$p = $c_sci_IndexedSeqDefaults$.prototype = new $h_O();
$p.constructor = $c_sci_IndexedSeqDefaults$;
/** @constructor */
function $h_sci_IndexedSeqDefaults$() {
}
$h_sci_IndexedSeqDefaults$.prototype = $p;
var $d_sci_IndexedSeqDefaults$ = new $TypeData().i($c_sci_IndexedSeqDefaults$, "scala.collection.immutable.IndexedSeqDefaults$", ({
  If: 1
}));
var $n_sci_IndexedSeqDefaults$;
function $m_sci_IndexedSeqDefaults$() {
  if ((!$n_sci_IndexedSeqDefaults$)) {
    $n_sci_IndexedSeqDefaults$ = new $c_sci_IndexedSeqDefaults$();
  }
  return $n_sci_IndexedSeqDefaults$;
}
/** @constructor */
function $c_sci_LazyList$EmptyMarker$() {
}
$p = $c_sci_LazyList$EmptyMarker$.prototype = new $h_O();
$p.constructor = $c_sci_LazyList$EmptyMarker$;
/** @constructor */
function $h_sci_LazyList$EmptyMarker$() {
}
$h_sci_LazyList$EmptyMarker$.prototype = $p;
var $d_sci_LazyList$EmptyMarker$ = new $TypeData().i($c_sci_LazyList$EmptyMarker$, "scala.collection.immutable.LazyList$EmptyMarker$", ({
  Ii: 1
}));
var $n_sci_LazyList$EmptyMarker$;
function $m_sci_LazyList$EmptyMarker$() {
  if ((!$n_sci_LazyList$EmptyMarker$)) {
    $n_sci_LazyList$EmptyMarker$ = new $c_sci_LazyList$EmptyMarker$();
  }
  return $n_sci_LazyList$EmptyMarker$;
}
/** @constructor */
function $c_sci_LazyList$LazyBuilder$DeferredState() {
  this.acE = null;
}
$p = $c_sci_LazyList$LazyBuilder$DeferredState.prototype = new $h_O();
$p.constructor = $c_sci_LazyList$LazyBuilder$DeferredState;
/** @constructor */
function $h_sci_LazyList$LazyBuilder$DeferredState() {
}
$h_sci_LazyList$LazyBuilder$DeferredState.prototype = $p;
$p.afz = (function() {
  var state = this.acE;
  if ((state === null)) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "uninitialized");
  }
  return state.a3();
});
$p.agx = (function(state) {
  if ((this.acE !== null)) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "already initialized");
  }
  this.acE = state;
});
var $d_sci_LazyList$LazyBuilder$DeferredState = new $TypeData().i($c_sci_LazyList$LazyBuilder$DeferredState, "scala.collection.immutable.LazyList$LazyBuilder$DeferredState", ({
  Ik: 1
}));
/** @constructor */
function $c_sci_LazyList$MidEvaluation$() {
}
$p = $c_sci_LazyList$MidEvaluation$.prototype = new $h_O();
$p.constructor = $c_sci_LazyList$MidEvaluation$;
/** @constructor */
function $h_sci_LazyList$MidEvaluation$() {
}
$h_sci_LazyList$MidEvaluation$.prototype = $p;
var $d_sci_LazyList$MidEvaluation$ = new $TypeData().i($c_sci_LazyList$MidEvaluation$, "scala.collection.immutable.LazyList$MidEvaluation$", ({
  Im: 1
}));
var $n_sci_LazyList$MidEvaluation$;
function $m_sci_LazyList$MidEvaluation$() {
  if ((!$n_sci_LazyList$MidEvaluation$)) {
    $n_sci_LazyList$MidEvaluation$ = new $c_sci_LazyList$MidEvaluation$();
  }
  return $n_sci_LazyList$MidEvaluation$;
}
/** @constructor */
function $c_sci_MapNode$() {
  this.NY = null;
  $n_sci_MapNode$ = this;
  this.NY = new $c_sci_BitmapIndexedMapNode(0, 0, new $ac_O(0), new $ac_I(0), 0, 0);
}
$p = $c_sci_MapNode$.prototype = new $h_O();
$p.constructor = $c_sci_MapNode$;
/** @constructor */
function $h_sci_MapNode$() {
}
$h_sci_MapNode$.prototype = $p;
var $d_sci_MapNode$ = new $TypeData().i($c_sci_MapNode$, "scala.collection.immutable.MapNode$", ({
  IK: 1
}));
var $n_sci_MapNode$;
function $m_sci_MapNode$() {
  if ((!$n_sci_MapNode$)) {
    $n_sci_MapNode$ = new $c_sci_MapNode$();
  }
  return $n_sci_MapNode$;
}
function $p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException($thiz, as, ix) {
  return $ct_jl_ArrayIndexOutOfBoundsException__T__(new $c_jl_ArrayIndexOutOfBoundsException(), ((ix + " is out of bounds (min 0, max ") + (($m_jl_reflect_Array$().c6(as) - 1) | 0)));
}
/** @constructor */
function $c_sci_Node() {
}
$p = $c_sci_Node.prototype = new $h_O();
$p.constructor = $c_sci_Node;
/** @constructor */
function $h_sci_Node() {
}
$h_sci_Node.prototype = $p;
$p.Jh = (function(as, ix) {
  if ((ix < 0)) {
    throw $p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException(this, as, ix);
  }
  if ((ix > ((as.a.length - 1) | 0))) {
    throw $p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException(this, as, ix);
  }
  var result = new $ac_I(((as.a.length - 1) | 0));
  as.av(0, result, 0, ix);
  var srcPos = ((1 + ix) | 0);
  var length = ((((as.a.length - ix) | 0) - 1) | 0);
  as.av(srcPos, result, ix, length);
  return result;
});
$p.J2 = (function(as, ix, elem) {
  if ((ix < 0)) {
    throw $p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException(this, as, ix);
  }
  if ((ix > as.a.length)) {
    throw $p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException(this, as, ix);
  }
  var result = new $ac_I(((1 + as.a.length) | 0));
  as.av(0, result, 0, ix);
  result.a[ix] = elem;
  var destPos = ((1 + ix) | 0);
  var length = ((as.a.length - ix) | 0);
  as.av(ix, result, destPos, length);
  return result;
});
var $d_sci_Node = new $TypeData().i(0, "scala.collection.immutable.Node", ({
  c1: 1
}));
/** @constructor */
function $c_sci_Node$() {
  this.V6 = 0;
  $n_sci_Node$ = this;
  this.V6 = $doubleToInt((+Math.ceil(6.4)));
}
$p = $c_sci_Node$.prototype = new $h_O();
$p.constructor = $c_sci_Node$;
/** @constructor */
function $h_sci_Node$() {
}
$h_sci_Node$.prototype = $p;
$p.fR = (function(hash, shift) {
  return (31 & ((hash >>> shift) | 0));
});
$p.d6 = (function(mask) {
  return (1 << mask);
});
$p.w6 = (function(bitmap, bitpos) {
  return $m_jl_Integer$().dz((bitmap & ((bitpos - 1) | 0)));
});
$p.h1 = (function(bitmap, mask, bitpos) {
  return ((bitmap === (-1)) ? mask : this.w6(bitmap, bitpos));
});
var $d_sci_Node$ = new $TypeData().i($c_sci_Node$, "scala.collection.immutable.Node$", ({
  IP: 1
}));
var $n_sci_Node$;
function $m_sci_Node$() {
  if ((!$n_sci_Node$)) {
    $n_sci_Node$ = new $c_sci_Node$();
  }
  return $n_sci_Node$;
}
/** @constructor */
function $c_sci_SetNode$() {
  this.HG = null;
  $n_sci_SetNode$ = this;
  this.HG = new $c_sci_BitmapIndexedSetNode(0, 0, new $ac_O(0), new $ac_I(0), 0, 0);
}
$p = $c_sci_SetNode$.prototype = new $h_O();
$p.constructor = $c_sci_SetNode$;
/** @constructor */
function $h_sci_SetNode$() {
}
$h_sci_SetNode$.prototype = $p;
var $d_sci_SetNode$ = new $TypeData().i($c_sci_SetNode$, "scala.collection.immutable.SetNode$", ({
  J7: 1
}));
var $n_sci_SetNode$;
function $m_sci_SetNode$() {
  if ((!$n_sci_SetNode$)) {
    $n_sci_SetNode$ = new $c_sci_SetNode$();
  }
  return $n_sci_SetNode$;
}
/** @constructor */
function $c_sci_TreeSeqMap$Ordering() {
}
$p = $c_sci_TreeSeqMap$Ordering.prototype = new $h_O();
$p.constructor = $c_sci_TreeSeqMap$Ordering;
/** @constructor */
function $h_sci_TreeSeqMap$Ordering() {
}
$h_sci_TreeSeqMap$Ordering.prototype = $p;
$p.m = (function() {
  return this.b1D();
});
$p.b1D = (function() {
  var sb = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  this.WU(sb, "", "");
  return sb.bP.ah;
});
$p.t = (function() {
  var _$this = this;
  while (true) {
    var x1 = _$this;
    if ($m_sci_TreeSeqMap$Ordering$Zero$().e(x1)) {
      throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "head of empty map");
    } else if ((x1 instanceof $c_sci_TreeSeqMap$Ordering$Tip)) {
      return x1.vE;
    } else if ((x1 instanceof $c_sci_TreeSeqMap$Ordering$Bin)) {
      var l = x1.qC;
      _$this = l;
    } else {
      throw new $c_s_MatchError(x1);
    }
  }
});
$p.dt = (function() {
  var _$this = this;
  while (true) {
    var x1 = _$this;
    if ($m_sci_TreeSeqMap$Ordering$Zero$().e(x1)) {
      return $m_s_None$();
    } else if ((x1 instanceof $c_sci_TreeSeqMap$Ordering$Tip)) {
      return new $c_s_Some(x1.vE);
    } else if ((x1 instanceof $c_sci_TreeSeqMap$Ordering$Bin)) {
      var l = x1.qC;
      _$this = l;
    } else {
      throw new $c_s_MatchError(x1);
    }
  }
});
$p.bJ = (function() {
  var _$this = this;
  while (true) {
    var x1 = _$this;
    if ($m_sci_TreeSeqMap$Ordering$Zero$().e(x1)) {
      throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "last of empty map");
    } else if ((x1 instanceof $c_sci_TreeSeqMap$Ordering$Tip)) {
      return x1.vE;
    } else if ((x1 instanceof $c_sci_TreeSeqMap$Ordering$Bin)) {
      var r = x1.nm;
      _$this = r;
    } else {
      throw new $c_s_MatchError(x1);
    }
  }
});
$p.ahh = (function() {
  var _$this = this;
  while (true) {
    var x1 = _$this;
    if ($m_sci_TreeSeqMap$Ordering$Zero$().e(x1)) {
      return 0;
    } else {
      if ((!(x1 instanceof $c_sci_TreeSeqMap$Ordering$Tip))) {
        if ((x1 instanceof $c_sci_TreeSeqMap$Ordering$Bin)) {
          var r = x1.nm;
          _$this = r;
          continue;
        }
        throw new $c_s_MatchError(x1);
      }
      return x1.qD;
    }
  }
});
$p.PA = (function() {
  return ($m_sci_TreeSeqMap$Ordering$Zero$().e(this) ? $m_sci_TreeSeqMap$Ordering$Iterator$().aIv : new $c_sci_TreeSeqMap$Ordering$Iterator(this));
});
$p.agt = (function(ordinal, value) {
  if ($m_sci_TreeSeqMap$Ordering$Zero$().e(this)) {
    return new $c_sci_TreeSeqMap$Ordering$Tip(ordinal, value);
  } else if ((this instanceof $c_sci_TreeSeqMap$Ordering$Tip)) {
    var o = this.qD;
    return ((ordinal === o) ? new $c_sci_TreeSeqMap$Ordering$Tip(ordinal, value) : $m_sci_TreeSeqMap$Ordering$().Jl(ordinal, new $c_sci_TreeSeqMap$Ordering$Tip(ordinal, value), o, this));
  } else if ((this instanceof $c_sci_TreeSeqMap$Ordering$Bin)) {
    var p = this.xI;
    var m = this.xH;
    var l = this.qC;
    var r = this.nm;
    return ((!$f_scg_BitOperations$Int__hasMatch__I__I__I__Z($m_scg_BitOperations$Int$(), ordinal, p, m)) ? $m_sci_TreeSeqMap$Ordering$().Jl(ordinal, new $c_sci_TreeSeqMap$Ordering$Tip(ordinal, value), p, this) : ($f_scg_BitOperations$Int__zero__I__I__Z($m_scg_BitOperations$Int$(), ordinal, m) ? new $c_sci_TreeSeqMap$Ordering$Bin(p, m, l.agt(ordinal, value), r) : new $c_sci_TreeSeqMap$Ordering$Bin(p, m, l, r.agt(ordinal, value))));
  } else {
    throw new $c_s_MatchError(this);
  }
});
$p.W8 = (function(ordinal, value) {
  if ($m_sci_TreeSeqMap$Ordering$Zero$().e(this)) {
    return new $c_sci_TreeSeqMap$Ordering$Tip(ordinal, value);
  } else if ((this instanceof $c_sci_TreeSeqMap$Ordering$Tip)) {
    var o = this.qD;
    return ((ordinal === o) ? new $c_sci_TreeSeqMap$Ordering$Tip(ordinal, value) : $m_sci_TreeSeqMap$Ordering$().Jl(ordinal, new $c_sci_TreeSeqMap$Ordering$Tip(ordinal, value), o, this));
  } else if ((this instanceof $c_sci_TreeSeqMap$Ordering$Bin)) {
    var p = this.xI;
    var m = this.xH;
    var l = this.qC;
    var r = this.nm;
    if ((!$f_scg_BitOperations$Int__hasMatch__I__I__I__Z($m_scg_BitOperations$Int$(), ordinal, p, m))) {
      return $m_sci_TreeSeqMap$Ordering$().Jl(ordinal, new $c_sci_TreeSeqMap$Ordering$Tip(ordinal, value), p, this);
    } else if ($f_scg_BitOperations$Int__zero__I__I__Z($m_scg_BitOperations$Int$(), ordinal, m)) {
      throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((("Append called with ordinal out of range: " + ordinal) + " is not greater than current max ordinal ") + this.ahh()));
    } else {
      return new $c_sci_TreeSeqMap$Ordering$Bin(p, m, l, r.W8(ordinal, value));
    }
  } else {
    throw new $c_s_MatchError(this);
  }
});
$p.aeH = (function(parent, ordinal, value) {
  var rc12 = false;
  var x3 = null;
  if ($m_sci_TreeSeqMap$Ordering$Zero$().e(this)) {
    return new $c_sci_TreeSeqMap$Ordering$Tip(ordinal, value);
  }
  if ((this instanceof $c_sci_TreeSeqMap$Ordering$Tip)) {
    rc12 = true;
    x3 = this;
    var o = x3.qD;
    if ((o >= ordinal)) {
      throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((("Append called with ordinal out of range: " + o) + " is not greater than current max ordinal ") + this.ahh()));
    }
  }
  if (rc12) {
    var o$2 = x3.qD;
    if ((parent === null)) {
      return $m_sci_TreeSeqMap$Ordering$().Jl(ordinal, new $c_sci_TreeSeqMap$Ordering$Tip(ordinal, value), o$2, this);
    }
  }
  if (rc12) {
    var o$3 = x3.qD;
    parent.nm = $m_sci_TreeSeqMap$Ordering$().Jl(ordinal, new $c_sci_TreeSeqMap$Ordering$Tip(ordinal, value), o$3, this);
    return parent;
  }
  if ((this instanceof $c_sci_TreeSeqMap$Ordering$Bin)) {
    var p = this.xI;
    var m = this.xH;
    var r = this.nm;
    if ((!$f_scg_BitOperations$Int__hasMatch__I__I__I__Z($m_scg_BitOperations$Int$(), ordinal, p, m))) {
      var b2 = $m_sci_TreeSeqMap$Ordering$().Jl(ordinal, new $c_sci_TreeSeqMap$Ordering$Tip(ordinal, value), p, this);
      if ((parent !== null)) {
        parent.nm = b2;
        return parent;
      } else {
        return b2;
      }
    } else if ($f_scg_BitOperations$Int__zero__I__I__Z($m_scg_BitOperations$Int$(), ordinal, m)) {
      throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((("Append called with ordinal out of range: " + ordinal) + " is not greater than current max ordinal ") + this.ahh()));
    } else {
      r.aeH(this, ordinal, value);
      return this;
    }
  }
  throw new $c_s_MatchError(this);
});
$p.Pi = (function(ordinal) {
  if ($m_sci_TreeSeqMap$Ordering$Zero$().e(this)) {
    return $m_sci_TreeSeqMap$Ordering$Zero$();
  } else if ((this instanceof $c_sci_TreeSeqMap$Ordering$Tip)) {
    return ((ordinal === this.qD) ? $m_sci_TreeSeqMap$Ordering$Zero$() : this);
  } else if ((this instanceof $c_sci_TreeSeqMap$Ordering$Bin)) {
    var p = this.xI;
    var m = this.xH;
    var l = this.qC;
    var r = this.nm;
    return ((!$f_scg_BitOperations$Int__hasMatch__I__I__I__Z($m_scg_BitOperations$Int$(), ordinal, p, m)) ? this : ($f_scg_BitOperations$Int__zero__I__I__Z($m_scg_BitOperations$Int$(), ordinal, m) ? $m_sci_TreeSeqMap$Ordering$().aRV(p, m, l.Pi(ordinal), r) : $m_sci_TreeSeqMap$Ordering$().aRV(p, m, l, r.Pi(ordinal))));
  } else {
    throw new $c_s_MatchError(this);
  }
});
function $isArrayOf_sci_TreeSeqMap$Ordering(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.cQ)));
}
function $p_sci_TreeSeqMap$Ordering$__branchMask__I__I__I($thiz, i, j) {
  var j$1 = (i ^ j);
  return (((-2147483648) >> Math.clz32(j$1)) & j$1);
}
/** @constructor */
function $c_sci_TreeSeqMap$Ordering$() {
}
$p = $c_sci_TreeSeqMap$Ordering$.prototype = new $h_O();
$p.constructor = $c_sci_TreeSeqMap$Ordering$;
/** @constructor */
function $h_sci_TreeSeqMap$Ordering$() {
}
$h_sci_TreeSeqMap$Ordering$.prototype = $p;
$p.Jl = (function(p1, t1, p2, t2) {
  var m = $p_sci_TreeSeqMap$Ordering$__branchMask__I__I__I(this, p1, p2);
  var p = $f_scg_BitOperations$Int__mask__I__I__I($m_scg_BitOperations$Int$(), p1, m);
  return ($f_scg_BitOperations$Int__zero__I__I__Z($m_scg_BitOperations$Int$(), p1, m) ? new $c_sci_TreeSeqMap$Ordering$Bin(p, m, t1, t2) : new $c_sci_TreeSeqMap$Ordering$Bin(p, m, t2, t1));
});
$p.aRV = (function(prefix, mask, left, right) {
  return ($m_sci_TreeSeqMap$Ordering$Zero$().e(right) ? left : ($m_sci_TreeSeqMap$Ordering$Zero$().e(left) ? right : new $c_sci_TreeSeqMap$Ordering$Bin(prefix, mask, left, right)));
});
var $d_sci_TreeSeqMap$Ordering$ = new $TypeData().i($c_sci_TreeSeqMap$Ordering$, "scala.collection.immutable.TreeSeqMap$Ordering$", ({
  Jh: 1
}));
var $n_sci_TreeSeqMap$Ordering$;
function $m_sci_TreeSeqMap$Ordering$() {
  if ((!$n_sci_TreeSeqMap$Ordering$)) {
    $n_sci_TreeSeqMap$Ordering$ = new $c_sci_TreeSeqMap$Ordering$();
  }
  return $n_sci_TreeSeqMap$Ordering$;
}
function $p_sci_TreeSeqMap$Ordering$Iterator__pop__sci_TreeSeqMap$Ordering($thiz) {
  $thiz.D4 = (($thiz.D4 - 1) | 0);
  return $thiz.acN.a[$thiz.D4];
}
function $p_sci_TreeSeqMap$Ordering$Iterator__push__sci_TreeSeqMap$Ordering__V($thiz, x) {
  $thiz.acN.a[$thiz.D4] = x;
  $thiz.D4 = ((1 + $thiz.D4) | 0);
}
/** @constructor */
function $c_sci_TreeSeqMap$Ordering$Iterator(it) {
  this.D4 = 0;
  this.acN = null;
  this.D4 = 0;
  this.acN = new $ac_O(33);
  var x$2 = $m_sci_TreeSeqMap$Ordering$Zero$();
  if ((!((it !== null) && it.e(x$2)))) {
    $p_sci_TreeSeqMap$Ordering$Iterator__push__sci_TreeSeqMap$Ordering__V(this, it);
  }
}
$p = $c_sci_TreeSeqMap$Ordering$Iterator.prototype = new $h_O();
$p.constructor = $c_sci_TreeSeqMap$Ordering$Iterator;
/** @constructor */
function $h_sci_TreeSeqMap$Ordering$Iterator() {
}
$h_sci_TreeSeqMap$Ordering$Iterator.prototype = $p;
$p.p = (function() {
  return (this.D4 > 0);
});
$p.q = (function() {
  while (true) {
    if ((!this.p())) {
      return $m_sc_Iterator$().b8.q();
    } else {
      var rc15 = false;
      var x2 = null;
      var x1 = $p_sci_TreeSeqMap$Ordering$Iterator__pop__sci_TreeSeqMap$Ordering(this);
      if ((x1 instanceof $c_sci_TreeSeqMap$Ordering$Bin)) {
        rc15 = true;
        x2 = x1;
        var p5 = x2.qC;
        var right = x2.nm;
        if ((p5 instanceof $c_sci_TreeSeqMap$Ordering$Tip)) {
          var v = p5.vE;
          $p_sci_TreeSeqMap$Ordering$Iterator__push__sci_TreeSeqMap$Ordering__V(this, right);
          return v;
        }
      }
      if (rc15) {
        var left = x2.qC;
        $p_sci_TreeSeqMap$Ordering$Iterator__push__sci_TreeSeqMap$Ordering__V(this, x2.nm);
        $p_sci_TreeSeqMap$Ordering$Iterator__push__sci_TreeSeqMap$Ordering__V(this, left);
        continue;
      }
      if ((x1 instanceof $c_sci_TreeSeqMap$Ordering$Tip)) {
        return x1.vE;
      }
      if ($m_sci_TreeSeqMap$Ordering$Zero$().e(x1)) {
        throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "empty subtree not allowed");
      }
      throw new $c_s_MatchError(x1);
    }
  }
});
var $d_sci_TreeSeqMap$Ordering$Iterator = new $TypeData().i($c_sci_TreeSeqMap$Ordering$Iterator, "scala.collection.immutable.TreeSeqMap$Ordering$Iterator", ({
  Ji: 1
}));
/** @constructor */
function $c_sci_TreeSeqMap$Ordering$Iterator$() {
  this.aIv = null;
  $n_sci_TreeSeqMap$Ordering$Iterator$ = this;
  this.aIv = new $c_sci_TreeSeqMap$Ordering$Iterator($m_sci_TreeSeqMap$Ordering$Zero$());
}
$p = $c_sci_TreeSeqMap$Ordering$Iterator$.prototype = new $h_O();
$p.constructor = $c_sci_TreeSeqMap$Ordering$Iterator$;
/** @constructor */
function $h_sci_TreeSeqMap$Ordering$Iterator$() {
}
$h_sci_TreeSeqMap$Ordering$Iterator$.prototype = $p;
var $d_sci_TreeSeqMap$Ordering$Iterator$ = new $TypeData().i($c_sci_TreeSeqMap$Ordering$Iterator$, "scala.collection.immutable.TreeSeqMap$Ordering$Iterator$", ({
  Jj: 1
}));
var $n_sci_TreeSeqMap$Ordering$Iterator$;
function $m_sci_TreeSeqMap$Ordering$Iterator$() {
  if ((!$n_sci_TreeSeqMap$Ordering$Iterator$)) {
    $n_sci_TreeSeqMap$Ordering$Iterator$ = new $c_sci_TreeSeqMap$Ordering$Iterator$();
  }
  return $n_sci_TreeSeqMap$Ordering$Iterator$;
}
function $p_sci_VectorSliceBuilder__addSlice__I__AO__I__I__V($thiz, n, a, lo, hi) {
  while (true) {
    if ((n === 1)) {
      var a$1 = a;
      var start = lo;
      var end = hi;
      $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, 1, (((start | (end ^ a$1.a.length)) === 0) ? a$1 : $m_ju_Arrays$().d7(a$1, start, end)));
    } else {
      var bitsN = Math.imul(5, ((n - 1) | 0));
      var widthN = (1 << bitsN);
      var loN = ((lo >>> bitsN) | 0);
      var hiN = ((hi >>> bitsN) | 0);
      var loRest = (lo & ((widthN - 1) | 0));
      var hiRest = (hi & ((widthN - 1) | 0));
      if ((loRest === 0)) {
        if ((hiRest === 0)) {
          var $x_1 = n;
          var a$2 = a;
          $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, $x_1, (((loN | (hiN ^ a$2.a.length)) === 0) ? a$2 : $m_ju_Arrays$().d7(a$2, loN, hiN)));
        } else {
          if ((hiN > loN)) {
            var $x_2 = n;
            var a$3 = a;
            $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, $x_2, (((loN | (hiN ^ a$3.a.length)) === 0) ? a$3 : $m_ju_Arrays$().d7(a$3, loN, hiN)));
          }
          var temp$n = ((n - 1) | 0);
          var temp$a = a.a[hiN];
          n = temp$n;
          a = temp$a;
          lo = 0;
          hi = hiRest;
          continue;
        }
      } else if ((hiN === loN)) {
        var temp$n$2 = ((n - 1) | 0);
        var temp$a$2 = a.a[loN];
        n = temp$n$2;
        a = temp$a$2;
        lo = loRest;
        hi = hiRest;
        continue;
      } else {
        $p_sci_VectorSliceBuilder__addSlice__I__AO__I__I__V($thiz, ((n - 1) | 0), a.a[loN], loRest, widthN);
        if ((hiRest === 0)) {
          if ((hiN > ((1 + loN) | 0))) {
            var $x_3 = n;
            var a$4 = a;
            var start$1 = ((1 + loN) | 0);
            $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, $x_3, (((start$1 | (hiN ^ a$4.a.length)) === 0) ? a$4 : $m_ju_Arrays$().d7(a$4, start$1, hiN)));
          }
        } else {
          if ((hiN > ((1 + loN) | 0))) {
            var $x_4 = n;
            var a$5 = a;
            var start$2 = ((1 + loN) | 0);
            $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, $x_4, (((start$2 | (hiN ^ a$5.a.length)) === 0) ? a$5 : $m_ju_Arrays$().d7(a$5, start$2, hiN)));
          }
          var temp$n$3 = ((n - 1) | 0);
          var temp$a$3 = a.a[hiN];
          n = temp$n$3;
          a = temp$a$3;
          lo = 0;
          hi = hiRest;
          continue;
        }
      }
    }
    return (void 0);
  }
}
function $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, n, a) {
  if ((n <= $thiz.oq)) {
    var idx = ((11 - n) | 0);
  } else {
    $thiz.oq = n;
    var idx = ((n - 1) | 0);
  }
  $thiz.cb.a[idx] = a;
}
function $p_sci_VectorSliceBuilder__balancePrefix__I__V($thiz, n) {
  if (($thiz.cb.a[((n - 1) | 0)] === null)) {
    if ((n === $thiz.oq)) {
      $thiz.cb.a[((n - 1) | 0)] = $thiz.cb.a[((11 - n) | 0)];
      $thiz.cb.a[((11 - n) | 0)] = null;
    } else {
      $p_sci_VectorSliceBuilder__balancePrefix__I__V($thiz, ((1 + n) | 0));
      var preN1 = $thiz.cb.a[((((1 + n) | 0) - 1) | 0)];
      $thiz.cb.a[((n - 1) | 0)] = preN1.a[0];
      if ((preN1.a.length === 1)) {
        $thiz.cb.a[((((1 + n) | 0) - 1) | 0)] = null;
        if ((($thiz.oq === ((1 + n) | 0)) && ($thiz.cb.a[((11 - ((1 + n) | 0)) | 0)] === null))) {
          $thiz.oq = n;
        }
      } else {
        $thiz.cb.a[((((1 + n) | 0) - 1) | 0)] = $m_ju_Arrays$().d7(preN1, 1, preN1.a.length);
      }
    }
  }
}
function $p_sci_VectorSliceBuilder__balanceSuffix__I__V($thiz, n) {
  if (($thiz.cb.a[((11 - n) | 0)] === null)) {
    if ((n === $thiz.oq)) {
      $thiz.cb.a[((11 - n) | 0)] = $thiz.cb.a[((n - 1) | 0)];
      $thiz.cb.a[((n - 1) | 0)] = null;
    } else {
      $p_sci_VectorSliceBuilder__balanceSuffix__I__V($thiz, ((1 + n) | 0));
      var sufN1 = $thiz.cb.a[((11 - ((1 + n) | 0)) | 0)];
      $thiz.cb.a[((11 - n) | 0)] = sufN1.a[((sufN1.a.length - 1) | 0)];
      if ((sufN1.a.length === 1)) {
        $thiz.cb.a[((11 - ((1 + n) | 0)) | 0)] = null;
        if ((($thiz.oq === ((1 + n) | 0)) && ($thiz.cb.a[((((1 + n) | 0) - 1) | 0)] === null))) {
          $thiz.oq = n;
        }
      } else {
        $thiz.cb.a[((11 - ((1 + n) | 0)) | 0)] = $m_ju_Arrays$().d7(sufN1, 0, ((sufN1.a.length - 1) | 0));
      }
    }
  }
}
/** @constructor */
function $c_sci_VectorSliceBuilder(lo, hi) {
  this.acR = 0;
  this.acQ = 0;
  this.cb = null;
  this.vF = 0;
  this.O9 = 0;
  this.oq = 0;
  this.acR = lo;
  this.acQ = hi;
  this.cb = new ($d_O.r().r().C)(11);
  this.vF = 0;
  this.O9 = 0;
  this.oq = 0;
}
$p = $c_sci_VectorSliceBuilder.prototype = new $h_O();
$p.constructor = $c_sci_VectorSliceBuilder;
/** @constructor */
function $h_sci_VectorSliceBuilder() {
}
$h_sci_VectorSliceBuilder.prototype = $p;
$p.eT = (function(n, a) {
  var count = Math.imul(a.a.length, (1 << Math.imul(5, ((n - 1) | 0))));
  var a$1 = ((this.acR - this.O9) | 0);
  var lo0 = ((a$1 > 0) ? a$1 : 0);
  var a$2 = ((this.acQ - this.O9) | 0);
  var hi0 = ((a$2 < count) ? a$2 : count);
  if ((hi0 > lo0)) {
    $p_sci_VectorSliceBuilder__addSlice__I__AO__I__I__V(this, n, a, lo0, hi0);
    this.vF = ((this.vF + ((hi0 - lo0) | 0)) | 0);
  }
  this.O9 = ((this.O9 + count) | 0);
});
$p.bY = (function() {
  if ((this.vF <= 32)) {
    if ((this.vF === 0)) {
      return $m_sci_Vector0$();
    } else {
      var prefix1 = this.cb.a[0];
      var suffix1 = this.cb.a[10];
      if ((prefix1 !== null)) {
        if ((suffix1 !== null)) {
          var dest = $m_ju_Arrays$().ex(prefix1, ((prefix1.a.length + suffix1.a.length) | 0));
          var destPos = prefix1.a.length;
          var length = suffix1.a.length;
          suffix1.av(0, dest, destPos, length);
          var $x_1 = dest;
        } else {
          var $x_1 = prefix1;
        }
      } else if ((suffix1 !== null)) {
        var $x_1 = suffix1;
      } else {
        var prefix2 = this.cb.a[1];
        var $x_1 = ((prefix2 !== null) ? prefix2.a[0] : this.cb.a[9].a[0]);
      }
      return new $c_sci_Vector1($x_1);
    }
  } else {
    $p_sci_VectorSliceBuilder__balancePrefix__I__V(this, 1);
    $p_sci_VectorSliceBuilder__balanceSuffix__I__V(this, 1);
    var resultDim = this.oq;
    if ((resultDim < 6)) {
      var pre = this.cb.a[((this.oq - 1) | 0)];
      var suf = this.cb.a[((11 - this.oq) | 0)];
      if (((pre !== null) && (suf !== null))) {
        if ((((pre.a.length + suf.a.length) | 0) <= 30)) {
          var $x_3 = this.cb;
          var $x_2 = this.oq;
          var dest$1 = $m_ju_Arrays$().ex(pre, ((pre.a.length + suf.a.length) | 0));
          var destPos$1 = pre.a.length;
          var length$1 = suf.a.length;
          suf.av(0, dest$1, destPos$1, length$1);
          $x_3.a[(($x_2 - 1) | 0)] = dest$1;
          this.cb.a[((11 - this.oq) | 0)] = null;
        } else {
          resultDim = ((1 + resultDim) | 0);
        }
      } else if ((((pre !== null) ? pre : suf).a.length > 30)) {
        resultDim = ((1 + resultDim) | 0);
      }
    }
    var prefix1$2 = this.cb.a[0];
    var suffix1$2 = this.cb.a[10];
    var len1 = prefix1$2.a.length;
    var x1 = resultDim;
    switch (x1) {
      case 2: {
        var a$1 = $m_sci_VectorStatics$().eg;
        var p = this.cb.a[1];
        if ((p !== null)) {
          var $x_4 = p;
        } else {
          var s = this.cb.a[9];
          var $x_4 = ((s !== null) ? s : a$1);
        }
        return new $c_sci_Vector2(prefix1$2, len1, $x_4, suffix1$2, this.vF);
        break;
      }
      case 3: {
        var a$2 = $m_sci_VectorStatics$().eg;
        var p$1 = this.cb.a[1];
        var prefix2$2 = ((p$1 !== null) ? p$1 : a$2);
        var a$3 = $m_sci_VectorStatics$().hz;
        var p$2 = this.cb.a[2];
        if ((p$2 !== null)) {
          var $x_5 = p$2;
        } else {
          var s$1 = this.cb.a[8];
          var $x_5 = ((s$1 !== null) ? s$1 : a$3);
        }
        var a$4 = $m_sci_VectorStatics$().eg;
        var s$2 = this.cb.a[9];
        return new $c_sci_Vector3(prefix1$2, len1, prefix2$2, ((len1 + (prefix2$2.a.length << 5)) | 0), $x_5, ((s$2 !== null) ? s$2 : a$4), suffix1$2, this.vF);
        break;
      }
      case 4: {
        var a$5 = $m_sci_VectorStatics$().eg;
        var p$3 = this.cb.a[1];
        var prefix2$3 = ((p$3 !== null) ? p$3 : a$5);
        var a$6 = $m_sci_VectorStatics$().hz;
        var p$4 = this.cb.a[2];
        var prefix3 = ((p$4 !== null) ? p$4 : a$6);
        var a$7 = $m_sci_VectorStatics$().nn;
        var p$5 = this.cb.a[3];
        if ((p$5 !== null)) {
          var $x_6 = p$5;
        } else {
          var s$3 = this.cb.a[7];
          var $x_6 = ((s$3 !== null) ? s$3 : a$7);
        }
        var data4 = $x_6;
        var a$8 = $m_sci_VectorStatics$().hz;
        var s$4 = this.cb.a[8];
        var suffix3 = ((s$4 !== null) ? s$4 : a$8);
        var a$9 = $m_sci_VectorStatics$().eg;
        var s$5 = this.cb.a[9];
        var suffix2$3 = ((s$5 !== null) ? s$5 : a$9);
        var len12$2 = ((len1 + (prefix2$3.a.length << 5)) | 0);
        return new $c_sci_Vector4(prefix1$2, len1, prefix2$3, len12$2, prefix3, ((len12$2 + (prefix3.a.length << 10)) | 0), data4, suffix3, suffix2$3, suffix1$2, this.vF);
        break;
      }
      case 5: {
        var a$10 = $m_sci_VectorStatics$().eg;
        var p$6 = this.cb.a[1];
        var prefix2$4 = ((p$6 !== null) ? p$6 : a$10);
        var a$11 = $m_sci_VectorStatics$().hz;
        var p$7 = this.cb.a[2];
        var prefix3$2 = ((p$7 !== null) ? p$7 : a$11);
        var a$12 = $m_sci_VectorStatics$().nn;
        var p$8 = this.cb.a[3];
        var prefix4 = ((p$8 !== null) ? p$8 : a$12);
        var a$13 = $m_sci_VectorStatics$().D5;
        var p$9 = this.cb.a[4];
        if ((p$9 !== null)) {
          var $x_7 = p$9;
        } else {
          var s$6 = this.cb.a[6];
          var $x_7 = ((s$6 !== null) ? s$6 : a$13);
        }
        var data5 = $x_7;
        var a$14 = $m_sci_VectorStatics$().nn;
        var s$7 = this.cb.a[7];
        var suffix4 = ((s$7 !== null) ? s$7 : a$14);
        var a$15 = $m_sci_VectorStatics$().hz;
        var s$8 = this.cb.a[8];
        var suffix3$2 = ((s$8 !== null) ? s$8 : a$15);
        var a$16 = $m_sci_VectorStatics$().eg;
        var s$9 = this.cb.a[9];
        var suffix2$4 = ((s$9 !== null) ? s$9 : a$16);
        var len12$3 = ((len1 + (prefix2$4.a.length << 5)) | 0);
        var len123$2 = ((len12$3 + (prefix3$2.a.length << 10)) | 0);
        return new $c_sci_Vector5(prefix1$2, len1, prefix2$4, len12$3, prefix3$2, len123$2, prefix4, ((len123$2 + (prefix4.a.length << 15)) | 0), data5, suffix4, suffix3$2, suffix2$4, suffix1$2, this.vF);
        break;
      }
      case 6: {
        var a$17 = $m_sci_VectorStatics$().eg;
        var p$10 = this.cb.a[1];
        var prefix2$5 = ((p$10 !== null) ? p$10 : a$17);
        var a$18 = $m_sci_VectorStatics$().hz;
        var p$11 = this.cb.a[2];
        var prefix3$3 = ((p$11 !== null) ? p$11 : a$18);
        var a$19 = $m_sci_VectorStatics$().nn;
        var p$12 = this.cb.a[3];
        var prefix4$2 = ((p$12 !== null) ? p$12 : a$19);
        var a$20 = $m_sci_VectorStatics$().D5;
        var p$13 = this.cb.a[4];
        var prefix5 = ((p$13 !== null) ? p$13 : a$20);
        var a$21 = $m_sci_VectorStatics$().a1R;
        var p$14 = this.cb.a[5];
        if ((p$14 !== null)) {
          var $x_8 = p$14;
        } else {
          var s$10 = this.cb.a[5];
          var $x_8 = ((s$10 !== null) ? s$10 : a$21);
        }
        var data6 = $x_8;
        var a$22 = $m_sci_VectorStatics$().D5;
        var s$11 = this.cb.a[6];
        var suffix5 = ((s$11 !== null) ? s$11 : a$22);
        var a$23 = $m_sci_VectorStatics$().nn;
        var s$12 = this.cb.a[7];
        var suffix4$2 = ((s$12 !== null) ? s$12 : a$23);
        var a$24 = $m_sci_VectorStatics$().hz;
        var s$13 = this.cb.a[8];
        var suffix3$3 = ((s$13 !== null) ? s$13 : a$24);
        var a$25 = $m_sci_VectorStatics$().eg;
        var s$14 = this.cb.a[9];
        var suffix2$5 = ((s$14 !== null) ? s$14 : a$25);
        var len12$4 = ((len1 + (prefix2$5.a.length << 5)) | 0);
        var len123$3 = ((len12$4 + (prefix3$3.a.length << 10)) | 0);
        var len1234$2 = ((len123$3 + (prefix4$2.a.length << 15)) | 0);
        return new $c_sci_Vector6(prefix1$2, len1, prefix2$5, len12$4, prefix3$3, len123$3, prefix4$2, len1234$2, prefix5, ((len1234$2 + (prefix5.a.length << 20)) | 0), data6, suffix5, suffix4$2, suffix3$3, suffix2$5, suffix1$2, this.vF);
        break;
      }
      default: {
        throw new $c_s_MatchError(x1);
      }
    }
  }
});
$p.m = (function() {
  return (((((((((("VectorSliceBuilder(lo=" + this.acR) + ", hi=") + this.acQ) + ", len=") + this.vF) + ", pos=") + this.O9) + ", maxDim=") + this.oq) + ")");
});
var $d_sci_VectorSliceBuilder = new $TypeData().i($c_sci_VectorSliceBuilder, "scala.collection.immutable.VectorSliceBuilder", ({
  Js: 1
}));
/** @constructor */
function $c_sci_VectorStatics$() {
  this.acS = null;
  this.eg = null;
  this.hz = null;
  this.nn = null;
  this.D5 = null;
  this.a1R = null;
  $n_sci_VectorStatics$ = this;
  this.acS = new $ac_O(0);
  this.eg = new ($d_O.r().r().C)(0);
  this.hz = new ($d_O.r().r().r().C)(0);
  this.nn = new ($d_O.r().r().r().r().C)(0);
  this.D5 = new ($d_O.r().r().r().r().r().C)(0);
  this.a1R = new ($d_O.r().r().r().r().r().r().C)(0);
}
$p = $c_sci_VectorStatics$.prototype = new $h_O();
$p.constructor = $c_sci_VectorStatics$;
/** @constructor */
function $h_sci_VectorStatics$() {
}
$h_sci_VectorStatics$.prototype = $p;
$p.Pc = (function(a, elem) {
  var alen = a.a.length;
  var ac = new $ac_O(((1 + alen) | 0));
  a.av(0, ac, 0, alen);
  ac.a[alen] = elem;
  return ac;
});
$p.dO = (function(a, elem) {
  var ac = $m_ju_Arrays$().ex(a, ((1 + a.a.length) | 0));
  ac.a[((ac.a.length - 1) | 0)] = elem;
  return ac;
});
$p.Pd = (function(elem, a) {
  var ac = new $ac_O(((1 + a.a.length) | 0));
  var length = a.a.length;
  a.av(0, ac, 1, length);
  ac.a[0] = elem;
  return ac;
});
$p.cQ = (function(elem, a) {
  var ac = $objectGetClass(a).ba.Q().ba.U(((1 + a.a.length) | 0));
  var length$1 = a.a.length;
  a.av(0, ac, 1, length$1);
  ac.a[0] = elem;
  return ac;
});
$p.a3r = (function(level, a, f) {
  var i = 0;
  var len = a.a.length;
  if ((level === 0)) {
    while ((i < len)) {
      f.i(a.a[i]);
      i = ((1 + i) | 0);
    }
  } else {
    var l = ((level - 1) | 0);
    while ((i < len)) {
      this.a3r(l, a.a[i], f);
      i = ((1 + i) | 0);
    }
  }
});
$p.ub = (function(a, f) {
  var i = 0;
  while ((i < a.a.length)) {
    var v1 = a.a[i];
    var v2 = f.i(v1);
    if ((!Object.is(v1, v2))) {
      return this.b4i(a, f, i, v2);
    }
    i = ((1 + i) | 0);
  }
  return a;
});
$p.b4i = (function(a, f, at, v2) {
  var ac = new $ac_O(a.a.length);
  if ((at > 0)) {
    a.av(0, ac, 0, at);
  }
  ac.a[at] = v2;
  var i = ((1 + at) | 0);
  while ((i < a.a.length)) {
    ac.a[i] = f.i(a.a[i]);
    i = ((1 + i) | 0);
  }
  return ac;
});
$p.ho = (function(n, a, f) {
  if ((n === 1)) {
    return this.ub(a, f);
  } else {
    var i = 0;
    while ((i < a.a.length)) {
      var v1 = a.a[i];
      var v2 = this.ho(((n - 1) | 0), v1, f);
      if ((v1 !== v2)) {
        return this.b4j(n, a, f, i, v2);
      }
      i = ((1 + i) | 0);
    }
    return a;
  }
});
$p.b4j = (function(n, a, f, at, v2) {
  var ac = $objectGetClass(a).ba.Q().ba.U(a.a.length);
  if ((at > 0)) {
    a.av(0, ac, 0, at);
  }
  ac.a[at] = v2;
  var i = ((1 + at) | 0);
  while ((i < a.a.length)) {
    ac.a[i] = this.ho(((n - 1) | 0), a.a[i], f);
    i = ((1 + i) | 0);
  }
  return ac;
});
$p.OX = (function(suffix1, xs) {
  if ($is_sci_Iterable(xs)) {
    if ((xs.nE(((32 - suffix1.a.length) | 0)) <= 0)) {
      var x1$2 = xs.aa();
      switch (x1$2) {
        case 0: {
          return null;
          break;
        }
        case 1: {
          return this.dO(suffix1, xs.t());
          break;
        }
        default: {
          var suffix1b = $m_ju_Arrays$().ex(suffix1, ((suffix1.a.length + x1$2) | 0));
          xs.cR(suffix1b, suffix1.a.length, 2147483647);
          return suffix1b;
        }
      }
    } else {
      return null;
    }
  } else {
    var s = xs.V();
    if (((s > 0) && (s <= ((32 - suffix1.a.length) | 0)))) {
      var suffix1b$2 = $m_ju_Arrays$().ex(suffix1, ((suffix1.a.length + s) | 0));
      xs.o().cR(suffix1b$2, suffix1.a.length, 2147483647);
      return suffix1b$2;
    } else {
      return null;
    }
  }
});
var $d_sci_VectorStatics$ = new $TypeData().i($c_sci_VectorStatics$, "scala.collection.immutable.VectorStatics$", ({
  Jt: 1
}));
var $n_sci_VectorStatics$;
function $m_sci_VectorStatics$() {
  if ((!$n_sci_VectorStatics$)) {
    $n_sci_VectorStatics$ = new $c_sci_VectorStatics$();
  }
  return $n_sci_VectorStatics$;
}
/** @constructor */
function $c_scm_HashMap$Node(_key, _hash, _value, _next) {
  this.np = null;
  this.or = 0;
  this.b9 = null;
  this.fr = null;
  this.np = _key;
  this.or = _hash;
  this.b9 = _value;
  this.fr = _next;
}
$p = $c_scm_HashMap$Node.prototype = new $h_O();
$p.constructor = $c_scm_HashMap$Node;
/** @constructor */
function $h_scm_HashMap$Node() {
}
$h_scm_HashMap$Node.prototype = $p;
$p.by = (function(k, h) {
  var _$this = this;
  while (true) {
    if (((h === _$this.or) && $m_sr_BoxesRunTime$().Q(k, _$this.np))) {
      return _$this;
    } else if (((_$this.fr === null) || (_$this.or > h))) {
      return null;
    } else {
      _$this = _$this.fr;
    }
  }
});
$p.F = (function(f) {
  var _$this = this;
  while (true) {
    f.i(new $c_T2(_$this.np, _$this.b9));
    if ((_$this.fr !== null)) {
      _$this = _$this.fr;
      continue;
    }
    break;
  }
});
$p.pu = (function(f) {
  var _$this = this;
  while (true) {
    f.R(_$this.np, _$this.b9);
    if ((_$this.fr !== null)) {
      _$this = _$this.fr;
      continue;
    }
    break;
  }
});
$p.m = (function() {
  return ((((((("Node(" + this.np) + ", ") + this.b9) + ", ") + this.or) + ") -> ") + this.fr);
});
var $d_scm_HashMap$Node = new $TypeData().i($c_scm_HashMap$Node, "scala.collection.mutable.HashMap$Node", ({
  JU: 1
}));
/** @constructor */
function $c_scm_HashSet$Node(_key, _hash, _next) {
  this.pc = null;
  this.mD = 0;
  this.hA = null;
  this.pc = _key;
  this.mD = _hash;
  this.hA = _next;
}
$p = $c_scm_HashSet$Node.prototype = new $h_O();
$p.constructor = $c_scm_HashSet$Node;
/** @constructor */
function $h_scm_HashSet$Node() {
}
$h_scm_HashSet$Node.prototype = $p;
$p.b1l = (function(k, h) {
  var _$this = this;
  while (true) {
    if (((h === _$this.mD) && $m_sr_BoxesRunTime$().Q(k, _$this.pc))) {
      return _$this;
    } else if (((_$this.hA === null) || (_$this.mD > h))) {
      return null;
    } else {
      _$this = _$this.hA;
    }
  }
});
$p.F = (function(f) {
  var _$this = this;
  while (true) {
    f.i(_$this.pc);
    if ((_$this.hA !== null)) {
      _$this = _$this.hA;
      continue;
    }
    break;
  }
});
$p.m = (function() {
  return ((((("Node(" + this.pc) + ", ") + this.mD) + ") -> ") + this.hA);
});
var $d_scm_HashSet$Node = new $TypeData().i($c_scm_HashSet$Node, "scala.collection.mutable.HashSet$Node", ({
  K0: 1
}));
/** @constructor */
function $c_scm_LinkedHashMap$LinkedEntry(key, hash, value) {
  this.nq = null;
  this.pd = 0;
  this.fs = null;
  this.D9 = null;
  this.vH = null;
  this.i7 = null;
  this.nq = key;
  this.pd = hash;
  this.fs = value;
  this.D9 = null;
  this.vH = null;
  this.i7 = null;
}
$p = $c_scm_LinkedHashMap$LinkedEntry.prototype = new $h_O();
$p.constructor = $c_scm_LinkedHashMap$LinkedEntry;
/** @constructor */
function $h_scm_LinkedHashMap$LinkedEntry() {
}
$h_scm_LinkedHashMap$LinkedEntry.prototype = $p;
$p.ij = (function(k, h) {
  var _$this = this;
  while (true) {
    if (((h === _$this.pd) && $m_sr_BoxesRunTime$().Q(k, _$this.nq))) {
      return _$this;
    } else if (((_$this.i7 === null) || (_$this.pd > h))) {
      return null;
    } else {
      _$this = _$this.i7;
    }
  }
});
var $d_scm_LinkedHashMap$LinkedEntry = new $TypeData().i($c_scm_LinkedHashMap$LinkedEntry, "scala.collection.mutable.LinkedHashMap$LinkedEntry", ({
  Ka: 1
}));
/** @constructor */
function $c_scm_LinkedHashSet$Entry(key, hash) {
  this.pf = null;
  this.pe = 0;
  this.Da = null;
  this.vI = null;
  this.i8 = null;
  this.pf = key;
  this.pe = hash;
  this.Da = null;
  this.vI = null;
  this.i8 = null;
}
$p = $c_scm_LinkedHashSet$Entry.prototype = new $h_O();
$p.constructor = $c_scm_LinkedHashSet$Entry;
/** @constructor */
function $h_scm_LinkedHashSet$Entry() {
}
$h_scm_LinkedHashSet$Entry.prototype = $p;
$p.b1k = (function(k, h) {
  var _$this = this;
  while (true) {
    if (((h === _$this.pe) && $m_sr_BoxesRunTime$().Q(k, _$this.pf))) {
      return _$this;
    } else if (((_$this.i8 === null) || (_$this.pe > h))) {
      return null;
    } else {
      _$this = _$this.i8;
    }
  }
});
var $d_scm_LinkedHashSet$Entry = new $TypeData().i($c_scm_LinkedHashSet$Entry, "scala.collection.mutable.LinkedHashSet$Entry", ({
  Kg: 1
}));
/** @constructor */
function $c_scm_MutationTracker$() {
}
$p = $c_scm_MutationTracker$.prototype = new $h_O();
$p.constructor = $c_scm_MutationTracker$;
/** @constructor */
function $h_scm_MutationTracker$() {
}
$h_scm_MutationTracker$.prototype = $p;
$p.aeX = (function(expectedCount, actualCount, message) {
  if ((actualCount !== expectedCount)) {
    throw new $c_ju_ConcurrentModificationException(message);
  }
});
var $d_scm_MutationTracker$ = new $TypeData().i($c_scm_MutationTracker$, "scala.collection.mutable.MutationTracker$", ({
  Kk: 1
}));
var $n_scm_MutationTracker$;
function $m_scm_MutationTracker$() {
  if ((!$n_scm_MutationTracker$)) {
    $n_scm_MutationTracker$ = new $c_scm_MutationTracker$();
  }
  return $n_scm_MutationTracker$;
}
/** @constructor */
function $c_sc_package$$colon$plus$() {
}
$p = $c_sc_package$$colon$plus$.prototype = new $h_O();
$p.constructor = $c_sc_package$$colon$plus$;
/** @constructor */
function $h_sc_package$$colon$plus$() {
}
$h_sc_package$$colon$plus$.prototype = $p;
$p.Y9 = (function(t) {
  return (t.c() ? $m_s_None$() : new $c_s_Some(new $c_T2(t.lX(), t.bJ())));
});
var $d_sc_package$$colon$plus$ = new $TypeData().i($c_sc_package$$colon$plus$, "scala.collection.package$$colon$plus$", ({
  Ks: 1
}));
var $n_sc_package$$colon$plus$;
function $m_sc_package$$colon$plus$() {
  if ((!$n_sc_package$$colon$plus$)) {
    $n_sc_package$$colon$plus$ = new $c_sc_package$$colon$plus$();
  }
  return $n_sc_package$$colon$plus$;
}
function $p_s_concurrent_BatchingExecutor$AbstractBatch__ensureCapacity__I__Ajl_Runnable($thiz, curSize) {
  var curOther = $thiz.Vh;
  var curLen = curOther.a.length;
  if ((curSize <= curLen)) {
    return curOther;
  } else {
    var newLen = ((curLen === 0) ? 4 : (curLen << 1));
    if ((newLen <= curLen)) {
      throw new $c_jl_StackOverflowError(("Space limit of asynchronous stack reached: " + curLen));
    }
    var newOther = new ($d_jl_Runnable.r().C)(newLen);
    curOther.av(0, newOther, 0, curLen);
    $thiz.Vh = newOther;
    return newOther;
  }
}
function $ct_s_concurrent_BatchingExecutor$AbstractBatch__s_concurrent_BatchingExecutor__jl_Runnable__Ajl_Runnable__I__($thiz, outer, first, other, size) {
  $thiz.Vg = first;
  $thiz.Vh = other;
  $thiz.Dc = size;
  $thiz.aIN = outer;
  return $thiz;
}
/** @constructor */
function $c_s_concurrent_BatchingExecutor$AbstractBatch() {
  this.Vg = null;
  this.Vh = null;
  this.Dc = 0;
  this.aIN = null;
}
$p = $c_s_concurrent_BatchingExecutor$AbstractBatch.prototype = new $h_O();
$p.constructor = $c_s_concurrent_BatchingExecutor$AbstractBatch;
/** @constructor */
function $h_s_concurrent_BatchingExecutor$AbstractBatch() {
}
$h_s_concurrent_BatchingExecutor$AbstractBatch.prototype = $p;
$p.b6Z = (function(r) {
  var sz = this.Dc;
  if ((sz === 0)) {
    this.Vg = r;
  } else {
    $p_s_concurrent_BatchingExecutor$AbstractBatch__ensureCapacity__I__Ajl_Runnable(this, sz).a[((sz - 1) | 0)] = r;
  }
  this.Dc = ((1 + sz) | 0);
});
$p.b83 = (function(n) {
  while (true) {
    if ((n > 0)) {
      var x1 = this.Dc;
      switch (x1) {
        case 0: {
          break;
        }
        case 1: {
          var next = this.Vg;
          this.Vg = null;
          this.Dc = 0;
          next.Jk();
          n = ((n - 1) | 0);
          continue;
          break;
        }
        default: {
          var o = this.Vh;
          var next$2 = o.a[((x1 - 2) | 0)];
          o.a[((x1 - 2) | 0)] = null;
          this.Dc = ((x1 - 1) | 0);
          next$2.Jk();
          n = ((n - 1) | 0);
          continue;
        }
      }
    }
    return (void 0);
  }
});
/** @constructor */
function $c_s_concurrent_BatchingExecutorStatics$() {
  this.aIO = null;
  $n_s_concurrent_BatchingExecutorStatics$ = this;
  this.aIO = new ($d_jl_Runnable.r().C)(0);
}
$p = $c_s_concurrent_BatchingExecutorStatics$.prototype = new $h_O();
$p.constructor = $c_s_concurrent_BatchingExecutorStatics$;
/** @constructor */
function $h_s_concurrent_BatchingExecutorStatics$() {
}
$h_s_concurrent_BatchingExecutorStatics$.prototype = $p;
var $d_s_concurrent_BatchingExecutorStatics$ = new $TypeData().i($c_s_concurrent_BatchingExecutorStatics$, "scala.concurrent.BatchingExecutorStatics$", ({
  Kv: 1
}));
var $n_s_concurrent_BatchingExecutorStatics$;
function $m_s_concurrent_BatchingExecutorStatics$() {
  if ((!$n_s_concurrent_BatchingExecutorStatics$)) {
    $n_s_concurrent_BatchingExecutorStatics$ = new $c_s_concurrent_BatchingExecutorStatics$();
  }
  return $n_s_concurrent_BatchingExecutorStatics$;
}
function $p_s_concurrent_ExecutionContext$__global$lzycompute__s_concurrent_ExecutionContextExecutor($thiz) {
  if ((!$thiz.ad8)) {
    $thiz.ad9 = $m_sjs_concurrent_JSExecutionContext$().aJa;
    $thiz.ad8 = true;
  }
  return $thiz.ad9;
}
/** @constructor */
function $c_s_concurrent_ExecutionContext$() {
  this.ad9 = null;
  this.Od = null;
  this.ad8 = false;
  $n_s_concurrent_ExecutionContext$ = this;
  this.Od = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$2) => {
    x$1$2$2.XL($m_jl_System$Streams$().K7);
  }));
}
$p = $c_s_concurrent_ExecutionContext$.prototype = new $h_O();
$p.constructor = $c_s_concurrent_ExecutionContext$;
/** @constructor */
function $h_s_concurrent_ExecutionContext$() {
}
$h_s_concurrent_ExecutionContext$.prototype = $p;
$p.ek = (function() {
  return ((!this.ad8) ? $p_s_concurrent_ExecutionContext$__global$lzycompute__s_concurrent_ExecutionContextExecutor(this) : this.ad9);
});
var $d_s_concurrent_ExecutionContext$ = new $TypeData().i($c_s_concurrent_ExecutionContext$, "scala.concurrent.ExecutionContext$", ({
  Kw: 1
}));
var $n_s_concurrent_ExecutionContext$;
function $m_s_concurrent_ExecutionContext$() {
  if ((!$n_s_concurrent_ExecutionContext$)) {
    $n_s_concurrent_ExecutionContext$ = new $c_s_concurrent_ExecutionContext$();
  }
  return $n_s_concurrent_ExecutionContext$;
}
/** @constructor */
function $c_s_concurrent_Future$() {
  this.aIR = null;
  this.aIT = null;
  this.adb = null;
  this.aIS = null;
  this.aIQ = null;
  this.adc = null;
  this.aIU = null;
  this.ada = null;
  this.aIV = null;
  $n_s_concurrent_Future$ = this;
  $m_sci_Map$().ao($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [new $c_T2($d_Z.l(), $d_jl_Boolean.l()), new $c_T2($d_B.l(), $d_jl_Byte.l()), new $c_T2($d_C.l(), $d_jl_Character.l()), new $c_T2($d_S.l(), $d_jl_Short.l()), new $c_T2($d_I.l(), $d_jl_Integer.l()), new $c_T2($d_J.l(), $d_jl_Long.l()), new $c_T2($d_F.l(), $d_jl_Float.l()), new $c_T2($d_D.l(), $d_jl_Double.l()), new $c_T2($d_V.l(), $d_jl_Void.l())]));
  this.aIR = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((t$2$2) => {
    throw new $c_s_concurrent_Future$$anon$1(t$2$2);
  }));
  this.aIT = new $c_s_util_Failure(new $c_s_concurrent_Future$$anon$2());
  this.adb = new $c_s_util_Failure(new $c_s_concurrent_Future$$anon$3());
  this.aIS = this.aga(this.adb);
  this.aIQ = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v$2$2) => ((v$2$2 instanceof $c_s_util_Failure) ? new $c_s_util_Success(v$2$2.le) : $m_s_concurrent_Future$().adb)));
  this.adc = this.WL(new $c_s_concurrent_Future$$anon$4());
  this.aIU = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((t$2$2$1) => $m_s_concurrent_Future$().adc));
  this.ada = new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((b$2$2, e$2$2) => b$2$2.Y(e$2$2)));
  this.aIV = this.aga(new $c_s_util_Success((void 0)));
}
$p = $c_s_concurrent_Future$.prototype = new $h_O();
$p.constructor = $c_s_concurrent_Future$;
/** @constructor */
function $h_s_concurrent_Future$() {
}
$h_s_concurrent_Future$.prototype = $p;
$p.WL = (function(exception) {
  return $m_s_concurrent_Promise$().b18(exception);
});
$p.m4 = (function(result) {
  return $m_s_concurrent_Promise$().b9v(result);
});
$p.aga = (function(result) {
  return $ct_s_concurrent_impl_Promise$DefaultPromise__s_util_Try__(new $c_s_concurrent_impl_Promise$DefaultPromise(), result);
});
$p.b8v = (function(in$1, bf, executor) {
  var this$1 = in$1.o();
  var z = this.m4(bf.aQq(in$1));
  var f = ((fr$2$2, fa$2$2) => fr$2$2.aTw(fa$2$2, $m_s_concurrent_Future$().ada, executor));
  if ($is_sc_IndexedSeq(this$1)) {
    var at = 0;
    var end = this$1.C();
    var acc = z;
    var $x_1;
    while (true) {
      if ((at !== end)) {
        var temp$at = ((1 + at) | 0);
        var x0 = acc;
        var x1 = this$1.l(at);
        var temp$acc = f(x0, x1);
        at = temp$at;
        acc = temp$acc;
        continue;
      }
      var $x_1 = acc;
      break;
    }
  } else {
    var result = z;
    while (this$1.p()) {
      var x0$1 = result;
      var x1$1 = this$1.q();
      result = f(x0$1, x1$1);
    }
    var $x_1 = result;
  }
  return $x_1.jX(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$6$2$2) => x$6$2$2.aR())), ($is_s_concurrent_BatchingExecutor(executor) ? executor : $m_s_concurrent_ExecutionContext$parasitic$()));
});
$p.bav = (function(in$1, fn, bf, executor) {
  var this$1 = in$1.o();
  var z = this.m4(bf.aQq(in$1));
  var f = ((fr$2$2, a$2$2) => fr$2$2.aTw(fn.i(a$2$2), $m_s_concurrent_Future$().ada, executor));
  if ($is_sc_IndexedSeq(this$1)) {
    var at = 0;
    var end = this$1.C();
    var acc = z;
    var $x_1;
    while (true) {
      if ((at !== end)) {
        var temp$at = ((1 + at) | 0);
        var x0 = acc;
        var x1 = this$1.l(at);
        var temp$acc = f(x0, x1);
        at = temp$at;
        acc = temp$acc;
        continue;
      }
      var $x_1 = acc;
      break;
    }
  } else {
    var result = z;
    while (this$1.p()) {
      var x0$1 = result;
      var x1$1 = this$1.q();
      result = f(x0$1, x1$1);
    }
    var $x_1 = result;
  }
  return $x_1.jX(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$10$2$2) => x$10$2$2.aR())), ($is_s_concurrent_BatchingExecutor(executor) ? executor : $m_s_concurrent_ExecutionContext$parasitic$()));
});
var $d_s_concurrent_Future$ = new $TypeData().i($c_s_concurrent_Future$, "scala.concurrent.Future$", ({
  Ky: 1
}));
var $n_s_concurrent_Future$;
function $m_s_concurrent_Future$() {
  if ((!$n_s_concurrent_Future$)) {
    $n_s_concurrent_Future$ = new $c_s_concurrent_Future$();
  }
  return $n_s_concurrent_Future$;
}
function $f_s_concurrent_Promise__complete__s_util_Try__s_concurrent_Promise($thiz, result) {
  if ($thiz.El(result)) {
    return $thiz;
  } else {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "Promise already completed.");
  }
}
function $f_s_concurrent_Promise__success__O__s_concurrent_Promise($thiz, value) {
  return $f_s_concurrent_Promise__complete__s_util_Try__s_concurrent_Promise($thiz, new $c_s_util_Success(value));
}
function $f_s_concurrent_Promise__trySuccess__O__Z($thiz, value) {
  return $thiz.El(new $c_s_util_Success(value));
}
function $f_s_concurrent_Promise__failure__jl_Throwable__s_concurrent_Promise($thiz, cause) {
  return $f_s_concurrent_Promise__complete__s_util_Try__s_concurrent_Promise($thiz, new $c_s_util_Failure(cause));
}
function $f_s_concurrent_Promise__tryFailure__jl_Throwable__Z($thiz, cause) {
  return $thiz.El(new $c_s_util_Failure(cause));
}
/** @constructor */
function $c_s_concurrent_Promise$() {
}
$p = $c_s_concurrent_Promise$.prototype = new $h_O();
$p.constructor = $c_s_concurrent_Promise$;
/** @constructor */
function $h_s_concurrent_Promise$() {
}
$h_s_concurrent_Promise$.prototype = $p;
$p.b18 = (function(exception) {
  return $ct_s_concurrent_impl_Promise$DefaultPromise__s_util_Try__(new $c_s_concurrent_impl_Promise$DefaultPromise(), new $c_s_util_Failure(exception));
});
$p.b9v = (function(result) {
  return $ct_s_concurrent_impl_Promise$DefaultPromise__s_util_Try__(new $c_s_concurrent_impl_Promise$DefaultPromise(), new $c_s_util_Success(result));
});
var $d_s_concurrent_Promise$ = new $TypeData().i($c_s_concurrent_Promise$, "scala.concurrent.Promise$", ({
  KD: 1
}));
var $n_s_concurrent_Promise$;
function $m_s_concurrent_Promise$() {
  if ((!$n_s_concurrent_Promise$)) {
    $n_s_concurrent_Promise$ = new $c_s_concurrent_Promise$();
  }
  return $n_s_concurrent_Promise$;
}
/** @constructor */
function $c_s_concurrent_impl_Promise$() {
  this.Vi = null;
  $n_s_concurrent_impl_Promise$ = this;
  this.Vi = $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__(new $c_s_concurrent_impl_Promise$Transformation(), 0, null, $m_s_concurrent_ExecutionContext$parasitic$());
}
$p = $c_s_concurrent_impl_Promise$.prototype = new $h_O();
$p.constructor = $c_s_concurrent_impl_Promise$;
/** @constructor */
function $h_s_concurrent_impl_Promise$() {
}
$h_s_concurrent_impl_Promise$.prototype = $p;
$p.XX = (function(value) {
  if ((value instanceof $c_s_util_Success)) {
    return value;
  } else {
    var t = value.le;
    return (((false || false) || (t instanceof $c_jl_Error)) ? (false ? new $c_s_util_Success(t.bdl()) : new $c_s_util_Failure(new $c_ju_concurrent_ExecutionException("Boxed Exception", t))) : value);
  }
});
var $d_s_concurrent_impl_Promise$ = new $TypeData().i($c_s_concurrent_impl_Promise$, "scala.concurrent.impl.Promise$", ({
  KI: 1
}));
var $n_s_concurrent_impl_Promise$;
function $m_s_concurrent_impl_Promise$() {
  if ((!$n_s_concurrent_impl_Promise$)) {
    $n_s_concurrent_impl_Promise$ = new $c_s_concurrent_impl_Promise$();
  }
  return $n_s_concurrent_impl_Promise$;
}
function $is_s_concurrent_impl_Promise$Callbacks(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.cT)));
}
function $isArrayOf_s_concurrent_impl_Promise$Callbacks(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.cT)));
}
function $f_s_math_ScalaNumericAnyConversions__isValidByte__Z($thiz) {
  return ($thiz.Ap() && ($thiz.lm() === $thiz.P2()));
}
function $f_s_math_ScalaNumericAnyConversions__isValidShort__Z($thiz) {
  return ($thiz.Ap() && ($thiz.lm() === $thiz.PT()));
}
function $f_s_math_ScalaNumericAnyConversions__isValidChar__Z($thiz) {
  return ($thiz.Ap() && (($thiz.lm() >= 0) && ($thiz.lm() <= 65535)));
}
function $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveHashcode__I($thiz) {
  var $x_1 = $thiz.lY();
  var lv_$_lo = $x_1.l;
  var lv_$_hi = $x_1.h;
  return ((((lv_$_hi === (-1)) ? ((lv_$_lo >>> 0) >= 2147483648) : (lv_$_hi > (-1))) && ((lv_$_hi === 0) ? ((lv_$_lo >>> 0) <= 2147483647) : (lv_$_hi < 0))) ? lv_$_lo : $m_sr_Statics$().jt(lv_$_lo, lv_$_hi));
}
function $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveEquals__O__Z($thiz, x) {
  if ((x instanceof $Char)) {
    var x2 = $uC(x);
    return ($thiz.Xg() && ($thiz.lm() === x2));
  } else if ($isByte(x)) {
    var x3 = (x | 0);
    return ($thiz.Xf() && ($thiz.P2() === x3));
  } else if ($isShort(x)) {
    var x4 = (x | 0);
    return ($thiz.Xi() && ($thiz.PT() === x4));
  } else if ($isInt(x)) {
    var x5 = (x | 0);
    return ($thiz.Pz() && ($thiz.lm() === x5));
  } else if ((x instanceof $Long)) {
    var $x_1 = $uJ(x);
    var x6_$_lo = $x_1.l;
    var x6_$_hi = $x_1.h;
    var $x_2 = $thiz.lY();
    var x$1_$_lo = $x_2.l;
    var x$1_$_hi = $x_2.h;
    return (((x$1_$_lo ^ x6_$_lo) | (x$1_$_hi ^ x6_$_hi)) === 0);
  } else if ($isFloat(x)) {
    var x7 = Math.fround(x);
    return ($thiz.DX() === x7);
  } else if (((typeof x) === "number")) {
    var x8 = (+x);
    return ($thiz.vY() === x8);
  } else {
    return false;
  }
}
function $p_s_package$__BigDecimal$lzycompute__s_math_BigDecimal$($thiz) {
  if (((((1 & $thiz.De) << 24) >> 24) === 0)) {
    $thiz.adn = $m_s_math_BigDecimal$();
    $thiz.De = (((1 | $thiz.De) << 24) >> 24);
  }
  return $thiz.adn;
}
function $p_s_package$__BigInt$lzycompute__s_math_BigInt$($thiz) {
  if (((((2 & $thiz.De) << 24) >> 24) === 0)) {
    $thiz.ado = $m_s_math_BigInt$();
    $thiz.De = (((2 | $thiz.De) << 24) >> 24);
  }
  return $thiz.ado;
}
/** @constructor */
function $c_s_package$() {
  this.adn = null;
  this.ado = null;
  this.aV8 = null;
  this.aVe = null;
  this.aV9 = null;
  this.aVb = null;
  this.aVc = null;
  this.aV7 = null;
  this.aVf = null;
  this.aVa = null;
  this.aVd = null;
  this.De = 0;
  $n_s_package$ = this;
  this.aV8 = $m_sc_Iterable$();
  this.aVe = $m_sci_Seq$();
  $m_sci_IndexedSeq$();
  this.aV9 = $m_sc_Iterator$();
  this.aVb = $m_sci_List$();
  this.aVc = $m_sci_Nil$();
  this.aV7 = $m_sc_package$$colon$plus$();
  $m_sci_LazyList$();
  this.aVf = $m_sci_Vector$();
  this.aVa = $m_s_util_Left$();
  this.aVd = $m_s_util_Right$();
}
$p = $c_s_package$.prototype = new $h_O();
$p.constructor = $c_s_package$;
/** @constructor */
function $h_s_package$() {
}
$h_s_package$.prototype = $p;
$p.oz = (function() {
  return (((((1 & this.De) << 24) >> 24) === 0) ? $p_s_package$__BigDecimal$lzycompute__s_math_BigDecimal$(this) : this.adn);
});
$p.aVI = (function() {
  return (((((2 & this.De) << 24) >> 24) === 0) ? $p_s_package$__BigInt$lzycompute__s_math_BigInt$(this) : this.ado);
});
var $d_s_package$ = new $TypeData().i($c_s_package$, "scala.package$", ({
  Ld: 1
}));
var $n_s_package$;
function $m_s_package$() {
  if ((!$n_s_package$)) {
    $n_s_package$ = new $c_s_package$();
  }
  return $n_s_package$;
}
/** @constructor */
function $c_sr_BoxesRunTime$() {
}
$p = $c_sr_BoxesRunTime$.prototype = new $h_O();
$p.constructor = $c_sr_BoxesRunTime$;
/** @constructor */
function $h_sr_BoxesRunTime$() {
}
$h_sr_BoxesRunTime$.prototype = $p;
$p.Q = (function(x, y) {
  return ((x === y) || ($is_jl_Number(x) ? this.qX(x, y) : ((x instanceof $Char) ? this.b0M(x, y) : ((x === null) ? (y === null) : $dp_equals__O__Z(x, y)))));
});
$p.qX = (function(xn, y) {
  if ($is_jl_Number(y)) {
    return this.afx(xn, y);
  } else if ((y instanceof $Char)) {
    if (((typeof xn) === "number")) {
      return ((+xn) === y.c);
    } else if ((xn instanceof $Long)) {
      var $x_1 = $uJ(xn);
      var x3_$_lo = $x_1.l;
      var x3_$_hi = $x_1.h;
      var value = y.c;
      var hi = (value >> 31);
      return (((x3_$_lo ^ value) | (x3_$_hi ^ hi)) === 0);
    } else {
      return ((xn === null) ? (y === null) : $dp_equals__O__Z(xn, y));
    }
  } else {
    return ((xn === null) ? (y === null) : $dp_equals__O__Z(xn, y));
  }
});
$p.afx = (function(xn, yn) {
  if (((typeof xn) === "number")) {
    var x2 = (+xn);
    if (((typeof yn) === "number")) {
      return (x2 === (+yn));
    } else if ((yn instanceof $Long)) {
      var $x_1 = $uJ(yn);
      var x3_$_lo = $x_1.l;
      var x3_$_hi = $x_1.h;
      return (x2 === ((4.294967296E9 * x3_$_hi) + (x3_$_lo >>> 0.0)));
    } else {
      return ((yn instanceof $c_s_math_ScalaNumber) && yn.e(x2));
    }
  } else if ((xn instanceof $Long)) {
    var $x_2 = $uJ(xn);
    var x3$2_$_lo = $x_2.l;
    var x3$2_$_hi = $x_2.h;
    if ((yn instanceof $Long)) {
      var $x_3 = $uJ(yn);
      var x2$3_$_lo = $x_3.l;
      var x2$3_$_hi = $x_3.h;
      return (((x3$2_$_lo ^ x2$3_$_lo) | (x3$2_$_hi ^ x2$3_$_hi)) === 0);
    } else if (((typeof yn) === "number")) {
      var x3$3 = (+yn);
      return (((4.294967296E9 * x3$2_$_hi) + (x3$2_$_lo >>> 0.0)) === x3$3);
    } else {
      return ((yn instanceof $c_s_math_ScalaNumber) && yn.e($bL(x3$2_$_lo, x3$2_$_hi)));
    }
  } else {
    return ((xn === null) ? (yn === null) : $dp_equals__O__Z(xn, yn));
  }
});
$p.b0M = (function(xc, y) {
  if ((y instanceof $Char)) {
    return (xc.c === y.c);
  } else if ($is_jl_Number(y)) {
    if (((typeof y) === "number")) {
      return ((+y) === xc.c);
    } else if ((y instanceof $Long)) {
      var $x_1 = $uJ(y);
      var x3_$_lo = $x_1.l;
      var x3_$_hi = $x_1.h;
      var value = xc.c;
      var hi = (value >> 31);
      return (((x3_$_lo ^ value) | (x3_$_hi ^ hi)) === 0);
    } else {
      return ((y === null) ? (xc === null) : $dp_equals__O__Z(y, xc));
    }
  } else {
    return ((xc === null) && (y === null));
  }
});
var $d_sr_BoxesRunTime$ = new $TypeData().i($c_sr_BoxesRunTime$, "scala.runtime.BoxesRunTime$", ({
  LM: 1
}));
var $n_sr_BoxesRunTime$;
function $m_sr_BoxesRunTime$() {
  if ((!$n_sr_BoxesRunTime$)) {
    $n_sr_BoxesRunTime$ = new $c_sr_BoxesRunTime$();
  }
  return $n_sr_BoxesRunTime$;
}
var $d_sr_Null$ = new $TypeData().i(0, "scala.runtime.Null$", ({
  LV: 1
}));
/** @constructor */
function $c_sr_RichDouble$() {
}
$p = $c_sr_RichDouble$.prototype = new $h_O();
$p.constructor = $c_sr_RichDouble$;
/** @constructor */
function $h_sr_RichDouble$() {
}
$h_sr_RichDouble$.prototype = $p;
$p.b3B = (function(this$) {
  var $x_1 = $m_RTLong$().d1(this$);
  var l_$_lo = $x_1.l;
  var l_$_hi = $x_1.h;
  return (((((4.294967296E9 * l_$_hi) + (l_$_lo >>> 0.0)) === this$) || ((((~l_$_lo) | (2147483647 ^ l_$_hi)) === 0) && (this$ < Infinity))) || (((l_$_lo | ((-2147483648) ^ l_$_hi)) === 0) && (this$ > (-Infinity))));
});
$p.b3r = (function(this$) {
  return ((($doubleToInt(this$) << 24) >> 24) === this$);
});
$p.b3z = (function(this$) {
  return ((($doubleToInt(this$) << 16) >> 16) === this$);
});
$p.b3t = (function(this$) {
  return ((65535 & $doubleToInt(this$)) === this$);
});
$p.b3x = (function(this$) {
  return ($doubleToInt(this$) === this$);
});
$p.b0H = (function(this$, x$1) {
  return ((x$1 instanceof $c_sr_RichDouble) && (this$ === x$1.kk));
});
var $d_sr_RichDouble$ = new $TypeData().i($c_sr_RichDouble$, "scala.runtime.RichDouble$", ({
  LX: 1
}));
var $n_sr_RichDouble$;
function $m_sr_RichDouble$() {
  if ((!$n_sr_RichDouble$)) {
    $n_sr_RichDouble$ = new $c_sr_RichDouble$();
  }
  return $n_sr_RichDouble$;
}
/** @constructor */
function $c_sr_RichInt$() {
}
$p = $c_sr_RichInt$.prototype = new $h_O();
$p.constructor = $c_sr_RichInt$;
/** @constructor */
function $h_sr_RichInt$() {
}
$h_sr_RichInt$.prototype = $p;
$p.b0I = (function(this$, x$1) {
  return ((x$1 instanceof $c_sr_RichInt) && (this$ === x$1.ns));
});
var $d_sr_RichInt$ = new $TypeData().i($c_sr_RichInt$, "scala.runtime.RichInt$", ({
  LY: 1
}));
var $n_sr_RichInt$;
function $m_sr_RichInt$() {
  if ((!$n_sr_RichInt$)) {
    $n_sr_RichInt$ = new $c_sr_RichInt$();
  }
  return $n_sr_RichInt$;
}
/** @constructor */
function $c_sr_RichLong$() {
}
$p = $c_sr_RichLong$.prototype = new $h_O();
$p.constructor = $c_sr_RichLong$;
/** @constructor */
function $h_sr_RichLong$() {
}
$h_sr_RichLong$.prototype = $p;
$p.b3s = (function(this$_$_lo, this$_$_hi) {
  var value = ((this$_$_lo << 24) >> 24);
  return (((value ^ this$_$_lo) | ((value >> 31) ^ this$_$_hi)) === 0);
});
$p.b3A = (function(this$_$_lo, this$_$_hi) {
  var value = ((this$_$_lo << 16) >> 16);
  return (((value ^ this$_$_lo) | ((value >> 31) ^ this$_$_hi)) === 0);
});
$p.b3u = (function(this$_$_lo, this$_$_hi) {
  var value = (65535 & this$_$_lo);
  return (((value ^ this$_$_lo) | ((value >> 31) ^ this$_$_hi)) === 0);
});
$p.b3y = (function(this$_$_lo, this$_$_hi) {
  return (((this$_$_lo ^ this$_$_lo) | ((this$_$_lo >> 31) ^ this$_$_hi)) === 0);
});
$p.b0J = (function(this$_$_lo, this$_$_hi, x$1) {
  if ((x$1 instanceof $c_sr_RichLong)) {
    var $x_1 = x$1;
    var RichLong$1_$_lo = $x_1.mG;
    var RichLong$1_$_hi = $x_1.mH;
    return (((this$_$_lo ^ RichLong$1_$_lo) | (this$_$_hi ^ RichLong$1_$_hi)) === 0);
  } else {
    return false;
  }
});
var $d_sr_RichLong$ = new $TypeData().i($c_sr_RichLong$, "scala.runtime.RichLong$", ({
  LZ: 1
}));
var $n_sr_RichLong$;
function $m_sr_RichLong$() {
  if ((!$n_sr_RichLong$)) {
    $n_sr_RichLong$ = new $c_sr_RichLong$();
  }
  return $n_sr_RichLong$;
}
/** @constructor */
function $c_sr_Scala3RunTime$() {
}
$p = $c_sr_Scala3RunTime$.prototype = new $h_O();
$p.constructor = $c_sr_Scala3RunTime$;
/** @constructor */
function $h_sr_Scala3RunTime$() {
}
$h_sr_Scala3RunTime$.prototype = $p;
$p.aeQ = (function(message) {
  throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), ("assertion failed: " + message));
});
$p.Wl = (function() {
  throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "assertion failed");
});
var $d_sr_Scala3RunTime$ = new $TypeData().i($c_sr_Scala3RunTime$, "scala.runtime.Scala3RunTime$", ({
  M0: 1
}));
var $n_sr_Scala3RunTime$;
function $m_sr_Scala3RunTime$() {
  if ((!$n_sr_Scala3RunTime$)) {
    $n_sr_Scala3RunTime$ = new $c_sr_Scala3RunTime$();
  }
  return $n_sr_Scala3RunTime$;
}
function $p_sr_ScalaRunTime$__isArrayClass__jl_Class__I__Z($thiz, clazz, atLevel) {
  while (true) {
    if (((clazz !== null) && clazz.ba.Z)) {
      if ((atLevel !== 1)) {
        var this$2 = clazz;
        var temp$clazz = this$2.ba.Q();
        var temp$atLevel = ((atLevel - 1) | 0);
        clazz = temp$clazz;
        atLevel = temp$atLevel;
        continue;
      }
      return true;
    } else {
      return false;
    }
  }
}
/** @constructor */
function $c_sr_ScalaRunTime$() {
}
$p = $c_sr_ScalaRunTime$.prototype = new $h_O();
$p.constructor = $c_sr_ScalaRunTime$;
/** @constructor */
function $h_sr_ScalaRunTime$() {
}
$h_sr_ScalaRunTime$.prototype = $p;
$p.b34 = (function(x, atLevel) {
  return ((x !== null) && $p_sr_ScalaRunTime$__isArrayClass__jl_Class__I__Z(this, $objectGetClass(x), atLevel));
});
$p.f6 = (function(xs, idx) {
  if ((xs instanceof $ac_O)) {
    return xs.a[idx];
  } else if ((xs instanceof $ac_I)) {
    return xs.a[idx];
  } else if ((xs instanceof $ac_D)) {
    return xs.a[idx];
  } else if ((xs instanceof $ac_J)) {
    var $x_1 = xs.a;
    var $x_2 = (idx << 1);
    return $bL($x_1[$x_2], $x_1[(($x_2 + 1) | 0)]);
  } else if ((xs instanceof $ac_F)) {
    return xs.a[idx];
  } else if ((xs instanceof $ac_C)) {
    return $bC(xs.a[idx]);
  } else if ((xs instanceof $ac_B)) {
    return xs.a[idx];
  } else if ((xs instanceof $ac_S)) {
    return xs.a[idx];
  } else if ((xs instanceof $ac_Z)) {
    return xs.a[idx];
  } else if ((xs === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  } else {
    throw new $c_s_MatchError(xs);
  }
});
$p.kn = (function(xs, idx, value) {
  if ((xs instanceof $ac_O)) {
    xs.a[idx] = value;
  } else if ((xs instanceof $ac_I)) {
    xs.a[idx] = (value | 0);
  } else if ((xs instanceof $ac_D)) {
    xs.a[idx] = (+value);
  } else if ((xs instanceof $ac_J)) {
    var $x_1 = $uJ(value);
    var $x_2 = xs.a;
    var $x_3 = (idx << 1);
    $x_2[$x_3] = $x_1.l;
    $x_2[(($x_3 + 1) | 0)] = $x_1.h;
  } else if ((xs instanceof $ac_F)) {
    xs.a[idx] = Math.fround(value);
  } else if ((xs instanceof $ac_C)) {
    xs.a[idx] = $uC(value);
  } else if ((xs instanceof $ac_B)) {
    xs.a[idx] = (value | 0);
  } else if ((xs instanceof $ac_S)) {
    xs.a[idx] = (value | 0);
  } else if ((xs instanceof $ac_Z)) {
    xs.a[idx] = (!(!value));
  } else if ((xs === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  } else {
    throw new $c_s_MatchError(xs);
  }
});
$p.aMm = (function(xs) {
  if ((xs instanceof $ac_O)) {
    return xs.ae();
  } else if ((xs instanceof $ac_I)) {
    return xs.ae();
  } else if ((xs instanceof $ac_D)) {
    return xs.ae();
  } else if ((xs instanceof $ac_J)) {
    return xs.ae();
  } else if ((xs instanceof $ac_F)) {
    return xs.ae();
  } else if ((xs instanceof $ac_C)) {
    return xs.ae();
  } else if ((xs instanceof $ac_B)) {
    return xs.ae();
  } else if ((xs instanceof $ac_S)) {
    return xs.ae();
  } else if ((xs instanceof $ac_Z)) {
    return xs.ae();
  } else if ((xs === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  } else {
    throw new $c_s_MatchError(xs);
  }
});
$p.M = (function(x) {
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(x.H(), (x.B() + "("), ",", ")");
});
$p.hP = (function(xs) {
  return ((xs === null) ? null : $m_sci_ArraySeq$().n0(xs));
});
$p.f = (function(xs) {
  return ((xs === null) ? null : ((xs.a.length === 0) ? $p_sci_ArraySeq$__emptyImpl__sci_ArraySeq$ofRef($m_sci_ArraySeq$()) : new $c_sci_ArraySeq$ofRef(xs)));
});
$p.a5i = (function(xs) {
  return ((xs !== null) ? new $c_sci_ArraySeq$ofInt(xs) : null);
});
$p.Yi = (function(xs) {
  return ((xs !== null) ? new $c_sci_ArraySeq$ofFloat(xs) : null);
});
$p.bc3 = (function(xs) {
  return ((xs !== null) ? new $c_sci_ArraySeq$ofChar(xs) : null);
});
var $d_sr_ScalaRunTime$ = new $TypeData().i($c_sr_ScalaRunTime$, "scala.runtime.ScalaRunTime$", ({
  M1: 1
}));
var $n_sr_ScalaRunTime$;
function $m_sr_ScalaRunTime$() {
  if ((!$n_sr_ScalaRunTime$)) {
    $n_sr_ScalaRunTime$ = new $c_sr_ScalaRunTime$();
  }
  return $n_sr_ScalaRunTime$;
}
/** @constructor */
function $c_sr_Statics$() {
}
$p = $c_sr_Statics$.prototype = new $h_O();
$p.constructor = $c_sr_Statics$;
/** @constructor */
function $h_sr_Statics$() {
}
$h_sr_Statics$.prototype = $p;
$p.k = (function(hash, data) {
  var h = this.r8(hash, data);
  var i = h;
  h = ((i << 13) | ((i >>> 19) | 0));
  return ((Math.imul(5, h) - 430675100) | 0);
});
$p.r8 = (function(hash, data) {
  var k = data;
  k = Math.imul((-862048943), k);
  var i = k;
  k = ((i << 15) | ((i >>> 17) | 0));
  k = Math.imul(461845907, k);
  return (hash ^ k);
});
$p.Z = (function(hash, length) {
  return this.aXS((hash ^ length));
});
$p.aXS = (function(h0) {
  var h = h0;
  h = (h ^ ((h >>> 16) | 0));
  h = Math.imul((-2048144789), h);
  h = (h ^ ((h >>> 13) | 0));
  h = Math.imul((-1028477387), h);
  h = (h ^ ((h >>> 16) | 0));
  return h;
});
$p.jt = (function(lv_$_lo, lv_$_hi) {
  return ((lv_$_hi === (lv_$_lo >> 31)) ? lv_$_lo : (lv_$_lo ^ lv_$_hi));
});
$p.ax = (function(dv) {
  var iv = $doubleToInt(dv);
  if ((iv === dv)) {
    return iv;
  } else {
    var $x_1 = $m_RTLong$().d1(dv);
    var lv_$_lo = $x_1.l;
    var lv_$_hi = $x_1.h;
    if ((((4.294967296E9 * lv_$_hi) + (lv_$_lo >>> 0.0)) === dv)) {
      return (lv_$_lo ^ lv_$_hi);
    } else {
      var valueInt = (dv | 0);
      if (((valueInt === dv) && ((1.0 / dv) !== (-Infinity)))) {
        return valueInt;
      } else if ((dv !== dv)) {
        return 2146959360;
      } else {
        var fpBitsDataView = $fpBitsDataView;
        fpBitsDataView.setFloat64(0, dv, true);
        return ((fpBitsDataView.getInt32(0, true) | 0) ^ (fpBitsDataView.getInt32(4, true) | 0));
      }
    }
  }
});
$p.u = (function(x) {
  if ((x === null)) {
    return 0;
  } else if (((typeof x) === "number")) {
    return this.ax((+x));
  } else if ((x instanceof $Long)) {
    var $x_1 = $uJ(x);
    return this.jt($x_1.l, $x_1.h);
  } else {
    return $dp_hashCode__I(x);
  }
});
$p.ey = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_sr_Statics$ = new $TypeData().i($c_sr_Statics$, "scala.runtime.Statics$", ({
  M4: 1
}));
var $n_sr_Statics$;
function $m_sr_Statics$() {
  if ((!$n_sr_Statics$)) {
    $n_sr_Statics$ = new $c_sr_Statics$();
  }
  return $n_sr_Statics$;
}
/** @constructor */
function $c_sr_Statics$PFMarker$() {
}
$p = $c_sr_Statics$PFMarker$.prototype = new $h_O();
$p.constructor = $c_sr_Statics$PFMarker$;
/** @constructor */
function $h_sr_Statics$PFMarker$() {
}
$h_sr_Statics$PFMarker$.prototype = $p;
var $d_sr_Statics$PFMarker$ = new $TypeData().i($c_sr_Statics$PFMarker$, "scala.runtime.Statics$PFMarker$", ({
  M5: 1
}));
var $n_sr_Statics$PFMarker$;
function $m_sr_Statics$PFMarker$() {
  if ((!$n_sr_Statics$PFMarker$)) {
    $n_sr_Statics$PFMarker$ = new $c_sr_Statics$PFMarker$();
  }
  return $n_sr_Statics$PFMarker$;
}
/** @constructor */
function $c_sr_TupleXXL$() {
}
$p = $c_sr_TupleXXL$.prototype = new $h_O();
$p.constructor = $c_sr_TupleXXL$;
/** @constructor */
function $h_sr_TupleXXL$() {
}
$h_sr_TupleXXL$.prototype = $p;
$p.a2M = (function(elems) {
  var array = new $ac_O(elems.C());
  var iterator = elems.o();
  var i = 0;
  while (iterator.p()) {
    array.a[i] = iterator.q();
    i = ((1 + i) | 0);
  }
  return new $c_sr_TupleXXL(array);
});
var $d_sr_TupleXXL$ = new $TypeData().i($c_sr_TupleXXL$, "scala.runtime.TupleXXL$", ({
  M6: 1
}));
var $n_sr_TupleXXL$;
function $m_sr_TupleXXL$() {
  if ((!$n_sr_TupleXXL$)) {
    $n_sr_TupleXXL$ = new $c_sr_TupleXXL$();
  }
  return $n_sr_TupleXXL$;
}
/** @constructor */
function $c_sjs_concurrent_JSExecutionContext$() {
  this.aJa = null;
  $n_sjs_concurrent_JSExecutionContext$ = this;
  this.aJa = $m_sjs_concurrent_QueueExecutionContext$().aXx();
}
$p = $c_sjs_concurrent_JSExecutionContext$.prototype = new $h_O();
$p.constructor = $c_sjs_concurrent_JSExecutionContext$;
/** @constructor */
function $h_sjs_concurrent_JSExecutionContext$() {
}
$h_sjs_concurrent_JSExecutionContext$.prototype = $p;
var $d_sjs_concurrent_JSExecutionContext$ = new $TypeData().i($c_sjs_concurrent_JSExecutionContext$, "scala.scalajs.concurrent.JSExecutionContext$", ({
  M7: 1
}));
var $n_sjs_concurrent_JSExecutionContext$;
function $m_sjs_concurrent_JSExecutionContext$() {
  if ((!$n_sjs_concurrent_JSExecutionContext$)) {
    $n_sjs_concurrent_JSExecutionContext$ = new $c_sjs_concurrent_JSExecutionContext$();
  }
  return $n_sjs_concurrent_JSExecutionContext$;
}
/** @constructor */
function $c_sjs_concurrent_QueueExecutionContext$() {
}
$p = $c_sjs_concurrent_QueueExecutionContext$.prototype = new $h_O();
$p.constructor = $c_sjs_concurrent_QueueExecutionContext$;
/** @constructor */
function $h_sjs_concurrent_QueueExecutionContext$() {
}
$h_sjs_concurrent_QueueExecutionContext$.prototype = $p;
$p.aXx = (function() {
  return (((typeof Promise) === "undefined") ? new $c_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext() : new $c_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext());
});
var $d_sjs_concurrent_QueueExecutionContext$ = new $TypeData().i($c_sjs_concurrent_QueueExecutionContext$, "scala.scalajs.concurrent.QueueExecutionContext$", ({
  M8: 1
}));
var $n_sjs_concurrent_QueueExecutionContext$;
function $m_sjs_concurrent_QueueExecutionContext$() {
  if ((!$n_sjs_concurrent_QueueExecutionContext$)) {
    $n_sjs_concurrent_QueueExecutionContext$ = new $c_sjs_concurrent_QueueExecutionContext$();
  }
  return $n_sjs_concurrent_QueueExecutionContext$;
}
function $ps_sjs_js_ArrayOps$__d$1__O__sr_BooleanRef__O(x, matched$1) {
  matched$1.dy = false;
  return null;
}
function $ps_sjs_js_ArrayOps$__d$2__O__sr_BooleanRef__O(x, matched$2) {
  matched$2.dy = false;
  return null;
}
/** @constructor */
function $c_sjs_js_ArrayOps$() {
}
$p = $c_sjs_js_ArrayOps$.prototype = new $h_O();
$p.constructor = $c_sjs_js_ArrayOps$;
/** @constructor */
function $h_sjs_js_ArrayOps$() {
}
$h_sjs_js_ArrayOps$.prototype = $p;
$p.aP7 = (function(this$) {
  return (((this$.length | 0) === 0) ? $m_s_None$() : new $c_s_Some(this$[0]));
});
$p.aYw = (function(this$, pf) {
  var matched = new $c_sr_BooleanRef(true);
  var b = [];
  var len = (this$.length | 0);
  var i = 0;
  while ((i < len)) {
    var x0 = this$[i];
    matched.dy = true;
    var v = pf.aC(x0, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((matched) => ((x$2$2) => $ps_sjs_js_ArrayOps$__d$1__O__sr_BooleanRef__O(x$2$2, matched)))(matched)));
    if (matched.dy) {
      (b.push(v) | 0);
    }
    i = ((1 + i) | 0);
  }
  return b;
});
$p.aYy = (function(this$, f) {
  var i = 0;
  var matched = new $c_sr_BooleanRef(true);
  var len = (this$.length | 0);
  while ((i < len)) {
    matched.dy = true;
    var v = f.aC(this$[i], new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((matched) => ((x$2$2) => $ps_sjs_js_ArrayOps$__d$2__O__sr_BooleanRef__O(x$2$2, matched)))(matched)));
    if (matched.dy) {
      return new $c_s_Some(v);
    }
    i = ((1 + i) | 0);
  }
  return $m_s_None$();
});
$p.b01 = (function(this$) {
  return $m_sjs_js_ArrayOps$().b02(this$, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2$2) => x$2$2)));
});
$p.b02 = (function(this$, f) {
  var result = [];
  $m_sjs_js_ArrayOps$().aLP(result, new $c_sc_Iterator$$anon$8(new $c_sjs_js_ArrayOps$ArrayIterator(this$), f));
  return result;
});
$p.aLP = (function(this$, ys) {
  var this$1 = ys.o();
  while (this$1.p()) {
    var x0 = this$1.q();
    this$.push(x0);
  }
  return this$;
});
var $d_sjs_js_ArrayOps$ = new $TypeData().i($c_sjs_js_ArrayOps$, "scala.scalajs.js.ArrayOps$", ({
  Mc: 1
}));
var $n_sjs_js_ArrayOps$;
function $m_sjs_js_ArrayOps$() {
  if ((!$n_sjs_js_ArrayOps$)) {
    $n_sjs_js_ArrayOps$ = new $c_sjs_js_ArrayOps$();
  }
  return $n_sjs_js_ArrayOps$;
}
/** @constructor */
function $c_sjs_js_JSConverters$JSRichFuture$() {
}
$p = $c_sjs_js_JSConverters$JSRichFuture$.prototype = new $h_O();
$p.constructor = $c_sjs_js_JSConverters$JSRichFuture$;
/** @constructor */
function $h_sjs_js_JSConverters$JSRichFuture$() {
}
$h_sjs_js_JSConverters$JSRichFuture$.prototype = $p;
$p.aST = (function(this$, ec) {
  return new Promise(((arg1$2, arg2$2) => {
    this$.XC(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x0$1$2$2) => {
      if ((x0$1$2$2 instanceof $c_s_util_Success)) {
        var value = x0$1$2$2.fM;
        return arg1$2(value);
      } else if ((x0$1$2$2 instanceof $c_s_util_Failure)) {
        var th = x0$1$2$2.le;
        var $x_2 = th;
        var $x_1 = (($x_2 instanceof $c_sjs_js_JavaScriptException) ? $x_2.bf : $x_2);
        return arg2$2($x_1);
      } else {
        throw new $c_s_MatchError(x0$1$2$2);
      }
    })), ec);
  }));
});
var $d_sjs_js_JSConverters$JSRichFuture$ = new $TypeData().i($c_sjs_js_JSConverters$JSRichFuture$, "scala.scalajs.js.JSConverters$JSRichFuture$", ({
  Me: 1
}));
var $n_sjs_js_JSConverters$JSRichFuture$;
function $m_sjs_js_JSConverters$JSRichFuture$() {
  if ((!$n_sjs_js_JSConverters$JSRichFuture$)) {
    $n_sjs_js_JSConverters$JSRichFuture$ = new $c_sjs_js_JSConverters$JSRichFuture$();
  }
  return $n_sjs_js_JSConverters$JSRichFuture$;
}
/** @constructor */
function $c_sjs_js_Thenable$Implicits$() {
}
$p = $c_sjs_js_Thenable$Implicits$.prototype = new $h_O();
$p.constructor = $c_sjs_js_Thenable$Implicits$;
/** @constructor */
function $h_sjs_js_Thenable$Implicits$() {
}
$h_sjs_js_Thenable$Implicits$.prototype = $p;
$p.aSP = (function(p) {
  return $m_sjs_js_Thenable$ThenableOps$().a50(p);
});
var $d_sjs_js_Thenable$Implicits$ = new $TypeData().i($c_sjs_js_Thenable$Implicits$, "scala.scalajs.js.Thenable$Implicits$", ({
  Mi: 1
}));
var $n_sjs_js_Thenable$Implicits$;
function $m_sjs_js_Thenable$Implicits$() {
  if ((!$n_sjs_js_Thenable$Implicits$)) {
    $n_sjs_js_Thenable$Implicits$ = new $c_sjs_js_Thenable$Implicits$();
  }
  return $n_sjs_js_Thenable$Implicits$;
}
/** @constructor */
function $c_sjs_js_Thenable$ThenableOps$() {
}
$p = $c_sjs_js_Thenable$ThenableOps$.prototype = new $h_O();
$p.constructor = $c_sjs_js_Thenable$ThenableOps$;
/** @constructor */
function $h_sjs_js_Thenable$ThenableOps$() {
}
$h_sjs_js_Thenable$ThenableOps$.prototype = $p;
$p.a50 = (function(this$) {
  var p2 = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
  this$.then(((arg1$2) => {
    $f_s_concurrent_Promise__success__O__s_concurrent_Promise(p2, arg1$2);
  }), $m_sjs_js_defined$().Wd(((arg1$2$1) => {
    $f_s_concurrent_Promise__failure__jl_Throwable__s_concurrent_Promise(p2, ((arg1$2$1 instanceof $c_jl_Throwable) ? arg1$2$1 : new $c_sjs_js_JavaScriptException(arg1$2$1)));
  })));
  return p2;
});
var $d_sjs_js_Thenable$ThenableOps$ = new $TypeData().i($c_sjs_js_Thenable$ThenableOps$, "scala.scalajs.js.Thenable$ThenableOps$", ({
  Mj: 1
}));
var $n_sjs_js_Thenable$ThenableOps$;
function $m_sjs_js_Thenable$ThenableOps$() {
  if ((!$n_sjs_js_Thenable$ThenableOps$)) {
    $n_sjs_js_Thenable$ThenableOps$ = new $c_sjs_js_Thenable$ThenableOps$();
  }
  return $n_sjs_js_Thenable$ThenableOps$;
}
/** @constructor */
function $c_sjs_js_WrappedDictionary$Cache$() {
  this.vL = null;
  $n_sjs_js_WrappedDictionary$Cache$ = this;
  this.vL = Object.prototype.hasOwnProperty;
}
$p = $c_sjs_js_WrappedDictionary$Cache$.prototype = new $h_O();
$p.constructor = $c_sjs_js_WrappedDictionary$Cache$;
/** @constructor */
function $h_sjs_js_WrappedDictionary$Cache$() {
}
$h_sjs_js_WrappedDictionary$Cache$.prototype = $p;
var $d_sjs_js_WrappedDictionary$Cache$ = new $TypeData().i($c_sjs_js_WrappedDictionary$Cache$, "scala.scalajs.js.WrappedDictionary$Cache$", ({
  Mn: 1
}));
var $n_sjs_js_WrappedDictionary$Cache$;
function $m_sjs_js_WrappedDictionary$Cache$() {
  if ((!$n_sjs_js_WrappedDictionary$Cache$)) {
    $n_sjs_js_WrappedDictionary$Cache$ = new $c_sjs_js_WrappedDictionary$Cache$();
  }
  return $n_sjs_js_WrappedDictionary$Cache$;
}
/** @constructor */
function $c_sjs_js_defined$() {
}
$p = $c_sjs_js_defined$.prototype = new $h_O();
$p.constructor = $c_sjs_js_defined$;
/** @constructor */
function $h_sjs_js_defined$() {
}
$h_sjs_js_defined$.prototype = $p;
$p.Wd = (function(a) {
  return a;
});
var $d_sjs_js_defined$ = new $TypeData().i($c_sjs_js_defined$, "scala.scalajs.js.defined$", ({
  Mq: 1
}));
var $n_sjs_js_defined$;
function $m_sjs_js_defined$() {
  if ((!$n_sjs_js_defined$)) {
    $n_sjs_js_defined$ = new $c_sjs_js_defined$();
  }
  return $n_sjs_js_defined$;
}
/** @constructor */
function $c_sjs_js_special_package$() {
}
$p = $c_sjs_js_special_package$.prototype = new $h_O();
$p.constructor = $c_sjs_js_special_package$;
/** @constructor */
function $h_sjs_js_special_package$() {
}
$h_sjs_js_special_package$.prototype = $p;
$p.eA = (function(properties) {
  var result = ({});
  properties.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((pair$2$2) => {
    result[pair$2$2.g()] = pair$2$2.h();
  })));
  return result;
});
var $d_sjs_js_special_package$ = new $TypeData().i($c_sjs_js_special_package$, "scala.scalajs.js.special.package$", ({
  Mr: 1
}));
var $n_sjs_js_special_package$;
function $m_sjs_js_special_package$() {
  if ((!$n_sjs_js_special_package$)) {
    $n_sjs_js_special_package$ = new $c_sjs_js_special_package$();
  }
  return $n_sjs_js_special_package$;
}
/** @constructor */
function $c_sjs_js_timers_package$() {
}
$p = $c_sjs_js_timers_package$.prototype = new $h_O();
$p.constructor = $c_sjs_js_timers_package$;
/** @constructor */
function $h_sjs_js_timers_package$() {
}
$h_sjs_js_timers_package$.prototype = $p;
$p.ym = (function(interval, body) {
  return setTimeout((() => {
    body.a3();
  }), interval);
});
$p.IH = (function(handle) {
  clearTimeout(handle);
});
var $d_sjs_js_timers_package$ = new $TypeData().i($c_sjs_js_timers_package$, "scala.scalajs.js.timers.package$", ({
  Mt: 1
}));
var $n_sjs_js_timers_package$;
function $m_sjs_js_timers_package$() {
  if ((!$n_sjs_js_timers_package$)) {
    $n_sjs_js_timers_package$ = new $c_sjs_js_timers_package$();
  }
  return $n_sjs_js_timers_package$;
}
/** @constructor */
function $c_sjsr_Compat$() {
}
$p = $c_sjsr_Compat$.prototype = new $h_O();
$p.constructor = $c_sjsr_Compat$;
/** @constructor */
function $h_sjsr_Compat$() {
}
$h_sjsr_Compat$.prototype = $p;
$p.Y8 = (function(seq) {
  if ((seq instanceof $c_sjsr_WrappedVarArgs)) {
    return seq.a1X;
  } else {
    var result = [];
    seq.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2$2) => (result.push(x$2$2) | 0))));
    return result;
  }
});
var $d_sjsr_Compat$ = new $TypeData().i($c_sjsr_Compat$, "scala.scalajs.runtime.Compat$", ({
  MI: 1
}));
var $n_sjsr_Compat$;
function $m_sjsr_Compat$() {
  if ((!$n_sjsr_Compat$)) {
    $n_sjsr_Compat$ = new $c_sjsr_Compat$();
  }
  return $n_sjsr_Compat$;
}
/** @constructor */
function $c_s_sys_package$() {
}
$p = $c_s_sys_package$.prototype = new $h_O();
$p.constructor = $c_s_sys_package$;
/** @constructor */
function $h_s_sys_package$() {
}
$h_s_sys_package$.prototype = $p;
$p.b0N = (function(message) {
  throw $ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), message);
});
var $d_s_sys_package$ = new $TypeData().i($c_s_sys_package$, "scala.sys.package$", ({
  MK: 1
}));
var $n_s_sys_package$;
function $m_s_sys_package$() {
  if ((!$n_s_sys_package$)) {
    $n_s_sys_package$ = new $c_s_sys_package$();
  }
  return $n_s_sys_package$;
}
/** @constructor */
function $c_s_util_DynamicVariable(init) {
  this.adq = null;
  this.adq = init;
}
$p = $c_s_util_DynamicVariable.prototype = new $h_O();
$p.constructor = $c_s_util_DynamicVariable;
/** @constructor */
function $h_s_util_DynamicVariable() {
}
$h_s_util_DynamicVariable.prototype = $p;
$p.m = (function() {
  return (("DynamicVariable(" + this.adq) + ")");
});
var $d_s_util_DynamicVariable = new $TypeData().i($c_s_util_DynamicVariable, "scala.util.DynamicVariable", ({
  ML: 1
}));
/** @constructor */
function $c_s_util_Sorting$() {
}
$p = $c_s_util_Sorting$.prototype = new $h_O();
$p.constructor = $c_s_util_Sorting$;
/** @constructor */
function $h_s_util_Sorting$() {
}
$h_s_util_Sorting$.prototype = $p;
$p.iw = (function(a, i0, iN, ord) {
  var n = ((iN - i0) | 0);
  if ((n < 2)) {
    return (void 0);
  }
  if ((ord.dA($m_sr_ScalaRunTime$().f6(a, i0), $m_sr_ScalaRunTime$().f6(a, ((1 + i0) | 0))) > 0)) {
    var temp = $m_sr_ScalaRunTime$().f6(a, i0);
    $m_sr_ScalaRunTime$().kn(a, i0, $m_sr_ScalaRunTime$().f6(a, ((1 + i0) | 0)));
    $m_sr_ScalaRunTime$().kn(a, ((1 + i0) | 0), temp);
  }
  var m = 2;
  while ((m < n)) {
    var next = $m_sr_ScalaRunTime$().f6(a, ((i0 + m) | 0));
    if ((ord.dA(next, $m_sr_ScalaRunTime$().f6(a, ((((i0 + m) | 0) - 1) | 0))) < 0)) {
      var iA = i0;
      var iB = ((((i0 + m) | 0) - 1) | 0);
      while ((((iB - iA) | 0) > 1)) {
        var ix = ((((iA + iB) | 0) >>> 1) | 0);
        if ((ord.dA(next, $m_sr_ScalaRunTime$().f6(a, ix)) < 0)) {
          iB = ix;
        } else {
          iA = ix;
        }
      }
      var ix$2 = ((iA + ((ord.dA(next, $m_sr_ScalaRunTime$().f6(a, iA)) >= 0) | 0)) | 0);
      var i = ((i0 + m) | 0);
      while ((i > ix$2)) {
        $m_sr_ScalaRunTime$().kn(a, i, $m_sr_ScalaRunTime$().f6(a, ((i - 1) | 0)));
        i = ((i - 1) | 0);
      }
      $m_sr_ScalaRunTime$().kn(a, ix$2, next);
    }
    m = ((1 + m) | 0);
  }
});
$p.f8 = (function(a, i0, iN, ord, scratch, evidence$2) {
  if ((((iN - i0) | 0) < 32)) {
    this.iw(a, i0, iN, ord);
  } else {
    var iK = ((((i0 + iN) | 0) >>> 1) | 0);
    var sc = ((scratch === null) ? evidence$2.b2(((iK - i0) | 0)) : scratch);
    this.f8(a, i0, iK, ord, sc, evidence$2);
    this.f8(a, iK, iN, ord, sc, evidence$2);
    this.ix(a, i0, iK, iN, ord, sc);
  }
});
$p.ix = (function(a, i0, iK, iN, ord, scratch) {
  if ((ord.dA($m_sr_ScalaRunTime$().f6(a, ((iK - 1) | 0)), $m_sr_ScalaRunTime$().f6(a, iK)) > 0)) {
    var i = i0;
    var jN = ((iK - i0) | 0);
    var j = 0;
    while ((i < iK)) {
      $m_sr_ScalaRunTime$().kn(scratch, j, $m_sr_ScalaRunTime$().f6(a, i));
      i = ((1 + i) | 0);
      j = ((1 + j) | 0);
    }
    var k = i0;
    j = 0;
    while (((i < iN) && (j < jN))) {
      if ((ord.dA($m_sr_ScalaRunTime$().f6(a, i), $m_sr_ScalaRunTime$().f6(scratch, j)) < 0)) {
        $m_sr_ScalaRunTime$().kn(a, k, $m_sr_ScalaRunTime$().f6(a, i));
        i = ((1 + i) | 0);
      } else {
        $m_sr_ScalaRunTime$().kn(a, k, $m_sr_ScalaRunTime$().f6(scratch, j));
        j = ((1 + j) | 0);
      }
      k = ((1 + k) | 0);
    }
    while ((j < jN)) {
      $m_sr_ScalaRunTime$().kn(a, k, $m_sr_ScalaRunTime$().f6(scratch, j));
      j = ((1 + j) | 0);
      k = ((1 + k) | 0);
    }
  }
});
$p.b8c = (function(a, from, until) {
  var i = from;
  var n = 0;
  while ((i < until)) {
    if ((!a.a[i])) {
      n = ((1 + n) | 0);
    }
    i = ((1 + i) | 0);
  }
  i = 0;
  while ((i < n)) {
    a.a[((from + i) | 0)] = false;
    i = ((1 + i) | 0);
  }
  while ((((from + i) | 0) < until)) {
    a.a[((from + i) | 0)] = true;
    i = ((1 + i) | 0);
  }
});
$p.Y5 = (function(a, from, until, evidence$4) {
  if ((a instanceof $ac_O)) {
    if ((($m_jl_reflect_Array$().c6(a) > 1) && (evidence$4 === null))) {
      throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "Ordering");
    }
    $m_ju_Arrays$().b9a(a, from, until, evidence$4);
  } else if ((a instanceof $ac_I)) {
    if ((evidence$4 === $m_s_math_Ordering$Int$())) {
      $m_ju_Arrays$().b97(a, from, until);
    } else {
      var evidence$2 = $m_s_reflect_ManifestFactory$IntManifest$();
      if ((((until - from) | 0) < 32)) {
        this.iw(a, from, until, evidence$4);
      } else {
        var iK = ((((from + until) | 0) >>> 1) | 0);
        var sc = new $ac_I(((iK - from) | 0));
        if ((((iK - from) | 0) < 32)) {
          this.iw(a, from, iK, evidence$4);
        } else {
          var iK$1 = ((((from + iK) | 0) >>> 1) | 0);
          this.f8(a, from, iK$1, evidence$4, sc, evidence$2);
          this.f8(a, iK$1, iK, evidence$4, sc, evidence$2);
          this.ix(a, from, iK$1, iK, evidence$4, sc);
        }
        if ((((until - iK) | 0) < 32)) {
          this.iw(a, iK, until, evidence$4);
        } else {
          var iK$2 = ((((iK + until) | 0) >>> 1) | 0);
          this.f8(a, iK, iK$2, evidence$4, sc, evidence$2);
          this.f8(a, iK$2, until, evidence$4, sc, evidence$2);
          this.ix(a, iK, iK$2, until, evidence$4, sc);
        }
        this.ix(a, from, iK, until, evidence$4, sc);
      }
    }
  } else if ((a instanceof $ac_D)) {
    var evidence$2$1 = $m_s_reflect_ManifestFactory$DoubleManifest$();
    if ((((until - from) | 0) < 32)) {
      this.iw(a, from, until, evidence$4);
    } else {
      var iK$3 = ((((from + until) | 0) >>> 1) | 0);
      var sc$1 = new $ac_D(((iK$3 - from) | 0));
      if ((((iK$3 - from) | 0) < 32)) {
        this.iw(a, from, iK$3, evidence$4);
      } else {
        var iK$4 = ((((from + iK$3) | 0) >>> 1) | 0);
        this.f8(a, from, iK$4, evidence$4, sc$1, evidence$2$1);
        this.f8(a, iK$4, iK$3, evidence$4, sc$1, evidence$2$1);
        this.ix(a, from, iK$4, iK$3, evidence$4, sc$1);
      }
      if ((((until - iK$3) | 0) < 32)) {
        this.iw(a, iK$3, until, evidence$4);
      } else {
        var iK$5 = ((((iK$3 + until) | 0) >>> 1) | 0);
        this.f8(a, iK$3, iK$5, evidence$4, sc$1, evidence$2$1);
        this.f8(a, iK$5, until, evidence$4, sc$1, evidence$2$1);
        this.ix(a, iK$3, iK$5, until, evidence$4, sc$1);
      }
      this.ix(a, from, iK$3, until, evidence$4, sc$1);
    }
  } else if ((a instanceof $ac_J)) {
    if ((evidence$4 === $m_s_math_Ordering$Long$())) {
      $m_ju_Arrays$().b98(a, from, until);
    } else {
      var evidence$2$2 = $m_s_reflect_ManifestFactory$LongManifest$();
      if ((((until - from) | 0) < 32)) {
        this.iw(a, from, until, evidence$4);
      } else {
        var iK$6 = ((((from + until) | 0) >>> 1) | 0);
        var sc$2 = new $ac_J(((iK$6 - from) | 0));
        if ((((iK$6 - from) | 0) < 32)) {
          this.iw(a, from, iK$6, evidence$4);
        } else {
          var iK$7 = ((((from + iK$6) | 0) >>> 1) | 0);
          this.f8(a, from, iK$7, evidence$4, sc$2, evidence$2$2);
          this.f8(a, iK$7, iK$6, evidence$4, sc$2, evidence$2$2);
          this.ix(a, from, iK$7, iK$6, evidence$4, sc$2);
        }
        if ((((until - iK$6) | 0) < 32)) {
          this.iw(a, iK$6, until, evidence$4);
        } else {
          var iK$8 = ((((iK$6 + until) | 0) >>> 1) | 0);
          this.f8(a, iK$6, iK$8, evidence$4, sc$2, evidence$2$2);
          this.f8(a, iK$8, until, evidence$4, sc$2, evidence$2$2);
          this.ix(a, iK$6, iK$8, until, evidence$4, sc$2);
        }
        this.ix(a, from, iK$6, until, evidence$4, sc$2);
      }
    }
  } else if ((a instanceof $ac_F)) {
    var evidence$2$3 = $m_s_reflect_ManifestFactory$FloatManifest$();
    if ((((until - from) | 0) < 32)) {
      this.iw(a, from, until, evidence$4);
    } else {
      var iK$9 = ((((from + until) | 0) >>> 1) | 0);
      var sc$3 = new $ac_F(((iK$9 - from) | 0));
      if ((((iK$9 - from) | 0) < 32)) {
        this.iw(a, from, iK$9, evidence$4);
      } else {
        var iK$10 = ((((from + iK$9) | 0) >>> 1) | 0);
        this.f8(a, from, iK$10, evidence$4, sc$3, evidence$2$3);
        this.f8(a, iK$10, iK$9, evidence$4, sc$3, evidence$2$3);
        this.ix(a, from, iK$10, iK$9, evidence$4, sc$3);
      }
      if ((((until - iK$9) | 0) < 32)) {
        this.iw(a, iK$9, until, evidence$4);
      } else {
        var iK$11 = ((((iK$9 + until) | 0) >>> 1) | 0);
        this.f8(a, iK$9, iK$11, evidence$4, sc$3, evidence$2$3);
        this.f8(a, iK$11, until, evidence$4, sc$3, evidence$2$3);
        this.ix(a, iK$9, iK$11, until, evidence$4, sc$3);
      }
      this.ix(a, from, iK$9, until, evidence$4, sc$3);
    }
  } else if ((a instanceof $ac_C)) {
    if ((evidence$4 === $m_s_math_Ordering$Char$())) {
      $m_ju_Arrays$().b96(a, from, until);
    } else {
      var evidence$2$4 = $m_s_reflect_ManifestFactory$CharManifest$();
      if ((((until - from) | 0) < 32)) {
        this.iw(a, from, until, evidence$4);
      } else {
        var iK$12 = ((((from + until) | 0) >>> 1) | 0);
        var sc$4 = new $ac_C(((iK$12 - from) | 0));
        if ((((iK$12 - from) | 0) < 32)) {
          this.iw(a, from, iK$12, evidence$4);
        } else {
          var iK$13 = ((((from + iK$12) | 0) >>> 1) | 0);
          this.f8(a, from, iK$13, evidence$4, sc$4, evidence$2$4);
          this.f8(a, iK$13, iK$12, evidence$4, sc$4, evidence$2$4);
          this.ix(a, from, iK$13, iK$12, evidence$4, sc$4);
        }
        if ((((until - iK$12) | 0) < 32)) {
          this.iw(a, iK$12, until, evidence$4);
        } else {
          var iK$14 = ((((iK$12 + until) | 0) >>> 1) | 0);
          this.f8(a, iK$12, iK$14, evidence$4, sc$4, evidence$2$4);
          this.f8(a, iK$14, until, evidence$4, sc$4, evidence$2$4);
          this.ix(a, iK$12, iK$14, until, evidence$4, sc$4);
        }
        this.ix(a, from, iK$12, until, evidence$4, sc$4);
      }
    }
  } else if ((a instanceof $ac_B)) {
    if ((evidence$4 === $m_s_math_Ordering$Byte$())) {
      $m_ju_Arrays$().b95(a, from, until);
    } else {
      var evidence$2$5 = $m_s_reflect_ManifestFactory$ByteManifest$();
      if ((((until - from) | 0) < 32)) {
        this.iw(a, from, until, evidence$4);
      } else {
        var iK$15 = ((((from + until) | 0) >>> 1) | 0);
        var sc$5 = new $ac_B(((iK$15 - from) | 0));
        if ((((iK$15 - from) | 0) < 32)) {
          this.iw(a, from, iK$15, evidence$4);
        } else {
          var iK$16 = ((((from + iK$15) | 0) >>> 1) | 0);
          this.f8(a, from, iK$16, evidence$4, sc$5, evidence$2$5);
          this.f8(a, iK$16, iK$15, evidence$4, sc$5, evidence$2$5);
          this.ix(a, from, iK$16, iK$15, evidence$4, sc$5);
        }
        if ((((until - iK$15) | 0) < 32)) {
          this.iw(a, iK$15, until, evidence$4);
        } else {
          var iK$17 = ((((iK$15 + until) | 0) >>> 1) | 0);
          this.f8(a, iK$15, iK$17, evidence$4, sc$5, evidence$2$5);
          this.f8(a, iK$17, until, evidence$4, sc$5, evidence$2$5);
          this.ix(a, iK$15, iK$17, until, evidence$4, sc$5);
        }
        this.ix(a, from, iK$15, until, evidence$4, sc$5);
      }
    }
  } else if ((a instanceof $ac_S)) {
    if ((evidence$4 === $m_s_math_Ordering$Short$())) {
      $m_ju_Arrays$().b99(a, from, until);
    } else {
      var evidence$2$6 = $m_s_reflect_ManifestFactory$ShortManifest$();
      if ((((until - from) | 0) < 32)) {
        this.iw(a, from, until, evidence$4);
      } else {
        var iK$18 = ((((from + until) | 0) >>> 1) | 0);
        var sc$6 = new $ac_S(((iK$18 - from) | 0));
        if ((((iK$18 - from) | 0) < 32)) {
          this.iw(a, from, iK$18, evidence$4);
        } else {
          var iK$19 = ((((from + iK$18) | 0) >>> 1) | 0);
          this.f8(a, from, iK$19, evidence$4, sc$6, evidence$2$6);
          this.f8(a, iK$19, iK$18, evidence$4, sc$6, evidence$2$6);
          this.ix(a, from, iK$19, iK$18, evidence$4, sc$6);
        }
        if ((((until - iK$18) | 0) < 32)) {
          this.iw(a, iK$18, until, evidence$4);
        } else {
          var iK$20 = ((((iK$18 + until) | 0) >>> 1) | 0);
          this.f8(a, iK$18, iK$20, evidence$4, sc$6, evidence$2$6);
          this.f8(a, iK$20, until, evidence$4, sc$6, evidence$2$6);
          this.ix(a, iK$18, iK$20, until, evidence$4, sc$6);
        }
        this.ix(a, from, iK$18, until, evidence$4, sc$6);
      }
    }
  } else if ((a instanceof $ac_Z)) {
    if ((evidence$4 === $m_s_math_Ordering$Boolean$())) {
      this.b8c(a, from, until);
    } else {
      var evidence$2$7 = $m_s_reflect_ManifestFactory$BooleanManifest$();
      if ((((until - from) | 0) < 32)) {
        this.iw(a, from, until, evidence$4);
      } else {
        var iK$21 = ((((from + until) | 0) >>> 1) | 0);
        var sc$7 = new $ac_Z(((iK$21 - from) | 0));
        if ((((iK$21 - from) | 0) < 32)) {
          this.iw(a, from, iK$21, evidence$4);
        } else {
          var iK$22 = ((((from + iK$21) | 0) >>> 1) | 0);
          this.f8(a, from, iK$22, evidence$4, sc$7, evidence$2$7);
          this.f8(a, iK$22, iK$21, evidence$4, sc$7, evidence$2$7);
          this.ix(a, from, iK$22, iK$21, evidence$4, sc$7);
        }
        if ((((until - iK$21) | 0) < 32)) {
          this.iw(a, iK$21, until, evidence$4);
        } else {
          var iK$23 = ((((iK$21 + until) | 0) >>> 1) | 0);
          this.f8(a, iK$21, iK$23, evidence$4, sc$7, evidence$2$7);
          this.f8(a, iK$23, until, evidence$4, sc$7, evidence$2$7);
          this.ix(a, iK$21, iK$23, until, evidence$4, sc$7);
        }
        this.ix(a, from, iK$21, until, evidence$4, sc$7);
      }
    }
  } else if ((a === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  } else {
    throw new $c_s_MatchError(a);
  }
});
var $d_s_util_Sorting$ = new $TypeData().i($c_s_util_Sorting$, "scala.util.Sorting$", ({
  MO: 1
}));
var $n_s_util_Sorting$;
function $m_s_util_Sorting$() {
  if ((!$n_s_util_Sorting$)) {
    $n_s_util_Sorting$ = new $c_s_util_Sorting$();
  }
  return $n_s_util_Sorting$;
}
function $f_s_util_control_NoStackTrace__fillInStackTrace__jl_Throwable($thiz) {
  return ($m_s_util_control_NoStackTrace$().aJk ? $c_jl_Throwable.prototype.IU.call($thiz) : $thiz);
}
/** @constructor */
function $c_s_util_control_NonFatal$() {
}
$p = $c_s_util_control_NonFatal$.prototype = new $h_O();
$p.constructor = $c_s_util_control_NonFatal$;
/** @constructor */
function $h_s_util_control_NonFatal$() {
}
$h_s_util_control_NonFatal$.prototype = $p;
$p.ew = (function(t) {
  return (!((t instanceof $c_jl_VirtualMachineError) || (false || (false || (false || false)))));
});
$p.wm = (function(t) {
  return (this.ew(t) ? new $c_s_Some(t) : $m_s_None$());
});
var $d_s_util_control_NonFatal$ = new $TypeData().i($c_s_util_control_NonFatal$, "scala.util.control.NonFatal$", ({
  MS: 1
}));
var $n_s_util_control_NonFatal$;
function $m_s_util_control_NonFatal$() {
  if ((!$n_s_util_control_NonFatal$)) {
    $n_s_util_control_NonFatal$ = new $c_s_util_control_NonFatal$();
  }
  return $n_s_util_control_NonFatal$;
}
/** @constructor */
function $c_s_util_hashing_MurmurHash3() {
}
$p = $c_s_util_hashing_MurmurHash3.prototype = new $h_O();
$p.constructor = $c_s_util_hashing_MurmurHash3;
/** @constructor */
function $h_s_util_hashing_MurmurHash3() {
}
$h_s_util_hashing_MurmurHash3.prototype = $p;
$p.k = (function(hash, data) {
  var h = this.r8(hash, data);
  var i = h;
  h = ((i << 13) | ((i >>> 19) | 0));
  return ((Math.imul(5, h) - 430675100) | 0);
});
$p.r8 = (function(hash, data) {
  var k = data;
  k = Math.imul((-862048943), k);
  var i = k;
  k = ((i << 15) | ((i >>> 17) | 0));
  k = Math.imul(461845907, k);
  return (hash ^ k);
});
$p.Z = (function(hash, length) {
  return this.pF((hash ^ length));
});
$p.pF = (function(hash) {
  var h = hash;
  h = (h ^ ((h >>> 16) | 0));
  h = Math.imul((-2048144789), h);
  h = (h ^ ((h >>> 13) | 0));
  h = Math.imul((-1028477387), h);
  h = (h ^ ((h >>> 16) | 0));
  return h;
});
$p.aT6 = (function(x, y, seed) {
  var h = seed;
  h = this.k(h, $f_T__hashCode__I("Tuple2"));
  h = this.k(h, x);
  h = this.k(h, y);
  return this.Z(h, 2);
});
$p.ab = (function(x, seed, ignorePrefix) {
  var arr = x.z();
  if ((arr === 0)) {
    return ((!ignorePrefix) ? $f_T__hashCode__I(x.B()) : seed);
  } else {
    var h = seed;
    if ((!ignorePrefix)) {
      h = this.k(h, $f_T__hashCode__I(x.B()));
    }
    var i = 0;
    while ((i < arr)) {
      h = this.k(h, $m_sr_Statics$().u(x.A(i)));
      i = ((1 + i) | 0);
    }
    return this.Z(h, arr);
  }
});
$p.eN = (function(x, seed, caseClassName) {
  var arr = x.z();
  var aye = $f_T__hashCode__I(((caseClassName !== null) ? caseClassName : x.B()));
  if ((arr === 0)) {
    return aye;
  } else {
    var h = seed;
    h = this.k(h, aye);
    var i = 0;
    while ((i < arr)) {
      h = this.k(h, $m_sr_Statics$().u(x.A(i)));
      i = ((1 + i) | 0);
    }
    return this.Z(h, arr);
  }
});
$p.aSu = (function(str, seed) {
  var h = seed;
  var i = 0;
  while ((((1 + i) | 0) < str.length)) {
    var data = (((str.charCodeAt(i) << 16) + str.charCodeAt(((1 + i) | 0))) | 0);
    h = this.k(h, data);
    i = ((2 + i) | 0);
  }
  if ((i < str.length)) {
    h = this.r8(h, str.charCodeAt(i));
  }
  return this.Z(h, str.length);
});
$p.Em = (function(xs, seed) {
  var a = 0;
  var b = 0;
  var n = 0;
  var c = 1;
  var iterator = xs.o();
  while (iterator.p()) {
    var x = iterator.q();
    var h = $m_sr_Statics$().u(x);
    a = ((a + h) | 0);
    b = (b ^ h);
    c = Math.imul(c, (1 | h));
    n = ((1 + n) | 0);
  }
  var h$2 = seed;
  h$2 = this.k(h$2, a);
  h$2 = this.k(h$2, b);
  h$2 = this.r8(h$2, c);
  return this.Z(h$2, n);
});
$p.b5m = (function(xs, seed) {
  var it = xs.o();
  var h = seed;
  if ((!it.p())) {
    return this.Z(h, 0);
  }
  var x0 = it.q();
  if ((!it.p())) {
    return this.Z(this.k(h, $m_sr_Statics$().u(x0)), 1);
  }
  var x1 = it.q();
  var initial = $m_sr_Statics$().u(x0);
  h = this.k(h, initial);
  var h0 = h;
  var prev = $m_sr_Statics$().u(x1);
  var rangeDiff = ((prev - initial) | 0);
  var i = 2;
  while (it.p()) {
    h = this.k(h, prev);
    var hash = $m_sr_Statics$().u(it.q());
    if (((rangeDiff !== ((hash - prev) | 0)) || (rangeDiff === 0))) {
      h = this.k(h, hash);
      i = ((1 + i) | 0);
      while (it.p()) {
        h = this.k(h, $m_sr_Statics$().u(it.q()));
        i = ((1 + i) | 0);
      }
      return this.Z(h, i);
    }
    prev = hash;
    i = ((1 + i) | 0);
  }
  return this.pF(this.k(this.k(h0, rangeDiff), prev));
});
$p.aMc = (function(a, seed) {
  var h = seed;
  var l = $m_jl_reflect_Array$().c6(a);
  switch (l) {
    case 0: {
      return this.Z(h, 0);
      break;
    }
    case 1: {
      return this.Z(this.k(h, $m_sr_Statics$().u($m_sr_ScalaRunTime$().f6(a, 0))), 1);
      break;
    }
    default: {
      var initial = $m_sr_Statics$().u($m_sr_ScalaRunTime$().f6(a, 0));
      h = this.k(h, initial);
      var h0 = h;
      var prev = $m_sr_Statics$().u($m_sr_ScalaRunTime$().f6(a, 1));
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.k(h, prev);
        var hash = $m_sr_Statics$().u($m_sr_ScalaRunTime$().f6(a, i));
        if (((rangeDiff !== ((hash - prev) | 0)) || (rangeDiff === 0))) {
          h = this.k(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.k(h, $m_sr_Statics$().u($m_sr_ScalaRunTime$().f6(a, i)));
            i = ((1 + i) | 0);
          }
          return this.Z(h, l);
        }
        prev = hash;
        i = ((1 + i) | 0);
      }
      return this.pF(this.k(this.k(h0, rangeDiff), prev));
    }
  }
});
$p.aRj = (function(start, step, last, seed) {
  return this.pF(this.k(this.k(this.k(seed, start), step), last));
});
$p.b2L = (function(a, seed) {
  var h = seed;
  var l = a.C();
  switch (l) {
    case 0: {
      return this.Z(h, 0);
      break;
    }
    case 1: {
      return this.Z(this.k(h, $m_sr_Statics$().u(a.l(0))), 1);
      break;
    }
    default: {
      var initial = $m_sr_Statics$().u(a.l(0));
      h = this.k(h, initial);
      var h0 = h;
      var prev = $m_sr_Statics$().u(a.l(1));
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.k(h, prev);
        var hash = $m_sr_Statics$().u(a.l(i));
        if (((rangeDiff !== ((hash - prev) | 0)) || (rangeDiff === 0))) {
          h = this.k(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.k(h, $m_sr_Statics$().u(a.l(i)));
            i = ((1 + i) | 0);
          }
          return this.Z(h, l);
        }
        prev = hash;
        i = ((1 + i) | 0);
      }
      return this.pF(this.k(this.k(h0, rangeDiff), prev));
    }
  }
});
$p.b48 = (function(xs, seed) {
  var n = 0;
  var h = seed;
  var rangeState = 0;
  var rangeDiff = 0;
  var prev = 0;
  var initial = 0;
  var elems = xs;
  while ((!elems.c())) {
    var head = elems.t();
    var tail = elems.v();
    var hash = $m_sr_Statics$().u(head);
    h = this.k(h, hash);
    switch (rangeState) {
      case 0: {
        initial = hash;
        rangeState = 1;
        break;
      }
      case 1: {
        rangeDiff = ((hash - prev) | 0);
        rangeState = 2;
        break;
      }
      case 2: {
        if (((rangeDiff !== ((hash - prev) | 0)) || (rangeDiff === 0))) {
          rangeState = 3;
        }
        break;
      }
    }
    prev = hash;
    n = ((1 + n) | 0);
    elems = tail;
  }
  return ((rangeState === 2) ? this.aRj(initial, rangeDiff, prev, seed) : this.Z(h, n));
});
$p.aMl = (function(a, seed) {
  var h = seed;
  var l = a.a.length;
  switch (l) {
    case 0: {
      return this.Z(h, 0);
      break;
    }
    case 1: {
      return this.Z(this.k(h, (a.a[0] ? 1231 : 1237)), 1);
      break;
    }
    default: {
      var initial = (a.a[0] ? 1231 : 1237);
      h = this.k(h, initial);
      var h0 = h;
      var prev = (a.a[1] ? 1231 : 1237);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.k(h, prev);
        var hash = (a.a[i] ? 1231 : 1237);
        if (((rangeDiff !== ((hash - prev) | 0)) || (rangeDiff === 0))) {
          h = this.k(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.k(h, (a.a[i] ? 1231 : 1237));
            i = ((1 + i) | 0);
          }
          return this.Z(h, l);
        }
        prev = hash;
        i = ((1 + i) | 0);
      }
      return this.pF(this.k(this.k(h0, rangeDiff), prev));
    }
  }
});
$p.aMd = (function(a, seed) {
  var h = seed;
  var l = a.a.length;
  switch (l) {
    case 0: {
      return this.Z(h, 0);
      break;
    }
    case 1: {
      return this.Z(this.k(h, a.a[0]), 1);
      break;
    }
    default: {
      var initial = a.a[0];
      h = this.k(h, initial);
      var h0 = h;
      var prev = a.a[1];
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.k(h, prev);
        var hash = a.a[i];
        if (((rangeDiff !== ((hash - prev) | 0)) || (rangeDiff === 0))) {
          h = this.k(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.k(h, a.a[i]);
            i = ((1 + i) | 0);
          }
          return this.Z(h, l);
        }
        prev = hash;
        i = ((1 + i) | 0);
      }
      return this.pF(this.k(this.k(h0, rangeDiff), prev));
    }
  }
});
$p.aMe = (function(a, seed) {
  var h = seed;
  var l = a.a.length;
  switch (l) {
    case 0: {
      return this.Z(h, 0);
      break;
    }
    case 1: {
      return this.Z(this.k(h, a.a[0]), 1);
      break;
    }
    default: {
      var initial = a.a[0];
      h = this.k(h, initial);
      var h0 = h;
      var prev = a.a[1];
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.k(h, prev);
        var hash = a.a[i];
        if (((rangeDiff !== ((hash - prev) | 0)) || (rangeDiff === 0))) {
          h = this.k(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.k(h, a.a[i]);
            i = ((1 + i) | 0);
          }
          return this.Z(h, l);
        }
        prev = hash;
        i = ((1 + i) | 0);
      }
      return this.pF(this.k(this.k(h0, rangeDiff), prev));
    }
  }
});
$p.aMf = (function(a, seed) {
  var h = seed;
  var l = a.a.length;
  switch (l) {
    case 0: {
      return this.Z(h, 0);
      break;
    }
    case 1: {
      return this.Z(this.k(h, $m_sr_Statics$().ax(a.a[0])), 1);
      break;
    }
    default: {
      var initial = $m_sr_Statics$().ax(a.a[0]);
      h = this.k(h, initial);
      var h0 = h;
      var prev = $m_sr_Statics$().ax(a.a[1]);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.k(h, prev);
        var hash = $m_sr_Statics$().ax(a.a[i]);
        if (((rangeDiff !== ((hash - prev) | 0)) || (rangeDiff === 0))) {
          h = this.k(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.k(h, $m_sr_Statics$().ax(a.a[i]));
            i = ((1 + i) | 0);
          }
          return this.Z(h, l);
        }
        prev = hash;
        i = ((1 + i) | 0);
      }
      return this.pF(this.k(this.k(h0, rangeDiff), prev));
    }
  }
});
$p.aMg = (function(a, seed) {
  var h = seed;
  var l = a.a.length;
  switch (l) {
    case 0: {
      return this.Z(h, 0);
      break;
    }
    case 1: {
      return this.Z(this.k(h, $m_sr_Statics$().ax(a.a[0])), 1);
      break;
    }
    default: {
      var initial = $m_sr_Statics$().ax(a.a[0]);
      h = this.k(h, initial);
      var h0 = h;
      var prev = $m_sr_Statics$().ax(a.a[1]);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.k(h, prev);
        var hash = $m_sr_Statics$().ax(a.a[i]);
        if (((rangeDiff !== ((hash - prev) | 0)) || (rangeDiff === 0))) {
          h = this.k(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.k(h, $m_sr_Statics$().ax(a.a[i]));
            i = ((1 + i) | 0);
          }
          return this.Z(h, l);
        }
        prev = hash;
        i = ((1 + i) | 0);
      }
      return this.pF(this.k(this.k(h0, rangeDiff), prev));
    }
  }
});
$p.aMh = (function(a, seed) {
  var h = seed;
  var l = a.a.length;
  switch (l) {
    case 0: {
      return this.Z(h, 0);
      break;
    }
    case 1: {
      return this.Z(this.k(h, a.a[0]), 1);
      break;
    }
    default: {
      var initial = a.a[0];
      h = this.k(h, initial);
      var h0 = h;
      var prev = a.a[1];
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.k(h, prev);
        var hash = a.a[i];
        if (((rangeDiff !== ((hash - prev) | 0)) || (rangeDiff === 0))) {
          h = this.k(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.k(h, a.a[i]);
            i = ((1 + i) | 0);
          }
          return this.Z(h, l);
        }
        prev = hash;
        i = ((1 + i) | 0);
      }
      return this.pF(this.k(this.k(h0, rangeDiff), prev));
    }
  }
});
$p.aMi = (function(a, seed) {
  var h = seed;
  var l = ((a.a.length >>> 1) | 0);
  switch (l) {
    case 0: {
      return this.Z(h, 0);
      break;
    }
    case 1: {
      var $x_4 = h;
      var $x_3 = $m_sr_Statics$();
      var $x_2 = a.a;
      var $x_1_$_lo = $x_2[0];
      var $x_1_$_hi = $x_2[1];
      return this.Z(this.k($x_4, $x_3.jt($x_1_$_lo, $x_1_$_hi)), 1);
      break;
    }
    default: {
      var $x_7 = $m_sr_Statics$();
      var $x_6 = a.a;
      var $x_5_$_lo = $x_6[0];
      var $x_5_$_hi = $x_6[1];
      var initial = $x_7.jt($x_5_$_lo, $x_5_$_hi);
      h = this.k(h, initial);
      var h0 = h;
      var $x_10 = $m_sr_Statics$();
      var $x_9 = a.a;
      var $x_8_$_lo = $x_9[2];
      var $x_8_$_hi = $x_9[3];
      var prev = $x_10.jt($x_8_$_lo, $x_8_$_hi);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.k(h, prev);
        var $x_14 = $m_sr_Statics$();
        var $x_12 = a.a;
        var $x_13 = (i << 1);
        var $x_11_$_lo = $x_12[$x_13];
        var $x_11_$_hi = $x_12[(($x_13 + 1) | 0)];
        var hash = $x_14.jt($x_11_$_lo, $x_11_$_hi);
        if (((rangeDiff !== ((hash - prev) | 0)) || (rangeDiff === 0))) {
          h = this.k(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            var $x_19 = h;
            var $x_18 = $m_sr_Statics$();
            var $x_16 = a.a;
            var $x_17 = (i << 1);
            var $x_15_$_lo = $x_16[$x_17];
            var $x_15_$_hi = $x_16[(($x_17 + 1) | 0)];
            h = this.k($x_19, $x_18.jt($x_15_$_lo, $x_15_$_hi));
            i = ((1 + i) | 0);
          }
          return this.Z(h, l);
        }
        prev = hash;
        i = ((1 + i) | 0);
      }
      return this.pF(this.k(this.k(h0, rangeDiff), prev));
    }
  }
});
$p.aMj = (function(a, seed) {
  var h = seed;
  var l = a.a.length;
  switch (l) {
    case 0: {
      return this.Z(h, 0);
      break;
    }
    case 1: {
      return this.Z(this.k(h, a.a[0]), 1);
      break;
    }
    default: {
      var initial = a.a[0];
      h = this.k(h, initial);
      var h0 = h;
      var prev = a.a[1];
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.k(h, prev);
        var hash = a.a[i];
        if (((rangeDiff !== ((hash - prev) | 0)) || (rangeDiff === 0))) {
          h = this.k(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.k(h, a.a[i]);
            i = ((1 + i) | 0);
          }
          return this.Z(h, l);
        }
        prev = hash;
        i = ((1 + i) | 0);
      }
      return this.pF(this.k(this.k(h0, rangeDiff), prev));
    }
  }
});
$p.aMk = (function(a, seed) {
  var h = seed;
  var l = a.a.length;
  switch (l) {
    case 0: {
      return this.Z(h, 0);
      break;
    }
    case 1: {
      return this.Z(this.k(h, 0), 1);
      break;
    }
    default: {
      h = this.k(h, 0);
      var h0 = h;
      var prev = 0;
      var rangeDiff = prev;
      var i = 2;
      while ((i < l)) {
        h = this.k(h, prev);
        if (((rangeDiff !== ((-prev) | 0)) || (rangeDiff === 0))) {
          h = this.k(h, 0);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.k(h, 0);
            i = ((1 + i) | 0);
          }
          return this.Z(h, l);
        }
        prev = 0;
        i = ((1 + i) | 0);
      }
      return this.pF(this.k(this.k(h0, rangeDiff), prev));
    }
  }
});
function $f_s_util_matching_Regex$MatchData__matched__T($thiz) {
  return (($thiz.AF() >= 0) ? $dp_toString__T($dp_subSequence__I__I__jl_CharSequence($thiz.ai7(), $thiz.AF(), $thiz.Ak())) : null);
}
function $f_s_util_matching_Regex$MatchData__group__I__T($thiz, i) {
  return (($thiz.PX(i) >= 0) ? $dp_toString__T($dp_subSequence__I__I__jl_CharSequence($thiz.ai7(), $thiz.PX(i), $thiz.WG(i))) : null);
}
function $f_s_util_parsing_combinator_Parsers__selectLastFailure__s_Option__s_Option__s_Option($thiz, failure0, failure1) {
  if ((failure0 instanceof $c_s_Some)) {
    var x61 = failure0.J;
    if ((failure1 instanceof $c_s_Some)) {
      var f1 = failure1.J;
      var this$2 = x61.xN;
      var $x_1 = new $c_s_util_parsing_input_OffsetPosition(this$2.pi, this$2.ph);
      var this$3 = f1.xN;
      if ($x_1.aLh(new $c_s_util_parsing_input_OffsetPosition(this$3.pi, this$3.ph))) {
        return new $c_s_Some(f1);
      } else {
        return new $c_s_Some(x61);
      }
    }
    return new $c_s_Some(x61);
  }
  if ((failure1 instanceof $c_s_Some)) {
    return new $c_s_Some(failure1.J);
  }
  return $m_s_None$();
}
function $f_s_util_parsing_combinator_Parsers__success__O__s_util_parsing_combinator_Parsers$Parser($thiz, v) {
  return new $c_s_util_parsing_combinator_Parsers$$anon$1(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((in$1) => new $c_s_util_parsing_combinator_Parsers$$anon$2(v, in$1, $m_s_None$(), $thiz))), $thiz);
}
function $f_s_util_parsing_combinator_Parsers__rep1__F0__F0__s_util_parsing_combinator_Parsers$Parser($thiz, first, p0) {
  return new $c_s_util_parsing_combinator_Parsers$$anon$1(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((in$1) => {
    var p$lzy7 = new $c_sr_LazyRef();
    var elems = new $c_scm_ListBuffer();
    var x138 = first.a3().lh(in$1);
    if (((x138 instanceof $c_s_util_parsing_combinator_Parsers$Success) && (x138.lQ === $thiz))) {
      $thiz.OQ();
      var x142 = x138.qL;
      var x143 = x138.pg;
      elems.bb(x142);
      return $p_s_util_parsing_combinator_Parsers__continue$1__scm_ListBuffer__sr_LazyRef__F0__s_util_parsing_input_Reader__s_Option__s_util_parsing_combinator_Parsers$ParseResult($thiz, elems, p$lzy7, p0, x143, x138.Aa);
    }
    if (((x138 instanceof $c_s_util_parsing_combinator_Parsers$NoSuccess) && (x138.a24 === $thiz))) {
      return x138;
    }
    throw new $c_s_MatchError(x138);
  })), $thiz);
}
function $ps_s_util_parsing_combinator_Parsers__p$lzyINIT1$1__sr_LazyRef__F0__s_util_parsing_combinator_Parsers$Parser(p$lzy1$1, p0$1) {
  if ((p$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return (p$lzy1$1.ci ? p$lzy1$1.cj : p$lzy1$1.h3(p0$1.a3()));
}
function $ps_s_util_parsing_combinator_Parsers__p$27__sr_LazyRef__F0__s_util_parsing_combinator_Parsers$Parser(p$lzy1$2, p0$2) {
  return (p$lzy1$2.ci ? p$lzy1$2.cj : $ps_s_util_parsing_combinator_Parsers__p$lzyINIT1$1__sr_LazyRef__F0__s_util_parsing_combinator_Parsers$Parser(p$lzy1$2, p0$2));
}
function $ps_s_util_parsing_combinator_Parsers__p$lzyINIT2$1__sr_LazyRef__F0__s_util_parsing_combinator_Parsers$Parser(p$lzy2$1, q$1) {
  if ((p$lzy2$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return (p$lzy2$1.ci ? p$lzy2$1.cj : p$lzy2$1.h3(q$1.a3()));
}
function $s_s_util_parsing_combinator_Parsers__scala$util$parsing$combinator$Parsers$Parser$$_$p$28__sr_LazyRef__F0__s_util_parsing_combinator_Parsers$Parser(p$lzy2$2, q$2) {
  return (p$lzy2$2.ci ? p$lzy2$2.cj : $ps_s_util_parsing_combinator_Parsers__p$lzyINIT2$1__sr_LazyRef__F0__s_util_parsing_combinator_Parsers$Parser(p$lzy2$2, q$2));
}
function $ps_s_util_parsing_combinator_Parsers__p$lzyINIT3$1__sr_LazyRef__F0__s_util_parsing_combinator_Parsers$Parser(p$lzy3$1, q$3) {
  if ((p$lzy3$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return (p$lzy3$1.ci ? p$lzy3$1.cj : p$lzy3$1.h3(q$3.a3()));
}
function $ps_s_util_parsing_combinator_Parsers__p$29__sr_LazyRef__F0__s_util_parsing_combinator_Parsers$Parser(p$lzy3$2, q$4) {
  return (p$lzy3$2.ci ? p$lzy3$2.cj : $ps_s_util_parsing_combinator_Parsers__p$lzyINIT3$1__sr_LazyRef__F0__s_util_parsing_combinator_Parsers$Parser(p$lzy3$2, q$4));
}
function $ps_s_util_parsing_combinator_Parsers__p$lzyINIT4$1__sr_LazyRef__F0__s_util_parsing_combinator_Parsers$Parser(p$lzy4$1, q$5) {
  if ((p$lzy4$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return (p$lzy4$1.ci ? p$lzy4$1.cj : p$lzy4$1.h3(q$5.a3()));
}
function $ps_s_util_parsing_combinator_Parsers__p$30__sr_LazyRef__F0__s_util_parsing_combinator_Parsers$Parser(p$lzy4$2, q$6) {
  return (p$lzy4$2.ci ? p$lzy4$2.cj : $ps_s_util_parsing_combinator_Parsers__p$lzyINIT4$1__sr_LazyRef__F0__s_util_parsing_combinator_Parsers$Parser(p$lzy4$2, q$6));
}
function $ps_s_util_parsing_combinator_Parsers__p$lzyINIT7$1__sr_LazyRef__F0__s_util_parsing_combinator_Parsers$Parser(p$lzy7$1, p0$4) {
  if ((p$lzy7$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return (p$lzy7$1.ci ? p$lzy7$1.cj : p$lzy7$1.h3(p0$4.a3()));
}
function $ps_s_util_parsing_combinator_Parsers__p$33__sr_LazyRef__F0__s_util_parsing_combinator_Parsers$Parser(p$lzy7$2, p0$6) {
  return (p$lzy7$2.ci ? p$lzy7$2.cj : $ps_s_util_parsing_combinator_Parsers__p$lzyINIT7$1__sr_LazyRef__F0__s_util_parsing_combinator_Parsers$Parser(p$lzy7$2, p0$6));
}
function $p_s_util_parsing_combinator_Parsers__applyp$1__s_util_parsing_combinator_Parsers$Parser__scm_ListBuffer__s_util_parsing_input_Reader__s_Option__s_util_parsing_combinator_Parsers$ParseResult($thiz, p0$7, elems$1, in0, failure) {
  var failure$tailLocal1 = failure;
  var in0$tailLocal1 = in0;
  while (true) {
    var x128 = p0$7.lh(in0$tailLocal1);
    if (((x128 instanceof $c_s_util_parsing_combinator_Parsers$Success) && (x128.lQ === $thiz))) {
      $thiz.OQ();
      var x136 = x128.qL;
      var x137 = x128.pg;
      var selectedFailure = $f_s_util_parsing_combinator_Parsers__selectLastFailure__s_Option__s_Option__s_Option($thiz, x128.Aa, failure$tailLocal1);
      elems$1.bb(x136);
      in0$tailLocal1 = x137;
      failure$tailLocal1 = selectedFailure;
      continue;
    }
    if ((false && (x128.b8d() === $thiz))) {
      $thiz.aVV();
      x128.bd1();
      x128.bd2();
      return x128;
    }
    if (((x128 instanceof $c_s_util_parsing_combinator_Parsers$Failure) && (x128.xM === $thiz))) {
      var selectedFailure$2 = $f_s_util_parsing_combinator_Parsers__selectLastFailure__s_Option__s_Option__s_Option($thiz, failure$tailLocal1, new $c_s_Some(x128));
      return new $c_s_util_parsing_combinator_Parsers$$anon$2(elems$1.bM(), in0$tailLocal1, selectedFailure$2, $thiz);
    }
    throw new $c_s_MatchError(x128);
  }
}
function $p_s_util_parsing_combinator_Parsers__continue$1__scm_ListBuffer__sr_LazyRef__F0__s_util_parsing_input_Reader__s_Option__s_util_parsing_combinator_Parsers$ParseResult($thiz, elems$2, p$lzy7$3, p0$8, in$1, failure) {
  return $p_s_util_parsing_combinator_Parsers__applyp$1__s_util_parsing_combinator_Parsers$Parser__scm_ListBuffer__s_util_parsing_input_Reader__s_Option__s_util_parsing_combinator_Parsers$ParseResult($thiz, $ps_s_util_parsing_combinator_Parsers__p$33__sr_LazyRef__F0__s_util_parsing_combinator_Parsers$Parser(p$lzy7$3, p0$8), elems$2, in$1, failure);
}
function $ct_s_util_parsing_combinator_Parsers$ParseResult__s_util_parsing_combinator_Parsers__($thiz, outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return $thiz;
}
/** @constructor */
function $c_s_util_parsing_combinator_Parsers$ParseResult() {
}
$p = $c_s_util_parsing_combinator_Parsers$ParseResult.prototype = new $h_O();
$p.constructor = $c_s_util_parsing_combinator_Parsers$ParseResult;
/** @constructor */
function $h_s_util_parsing_combinator_Parsers$ParseResult() {
}
$h_s_util_parsing_combinator_Parsers$ParseResult.prototype = $p;
function $f_s_util_parsing_input_Position__longString__T($thiz) {
  var $x_2 = $thiz.aPW();
  var x$1 = $m_sc_StringOps$().a4R($thiz.aPW(), (($thiz.P6() - 1) | 0));
  var len = x$1.length;
  var dst = new $ac_C(len);
  var i = 0;
  while ((i < len)) {
    var $x_1 = i;
    var index = i;
    var x0 = x$1.charCodeAt(index);
    dst.a[$x_1] = ((x0 === 9) ? x0 : 32);
    i = ((1 + i) | 0);
  }
  return ((($x_2 + "\n") + $m_jl_String$().kS(dst, 0, dst.a.length)) + "^");
}
function $f_s_util_parsing_input_Position__equals__O__Z($thiz, other) {
  return ($is_s_util_parsing_input_Position(other) && (($thiz.yd() === other.yd()) && ($thiz.P6() === other.P6())));
}
function $is_s_util_parsing_input_Position(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.e1)));
}
function $isArrayOf_s_util_parsing_input_Position(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.e1)));
}
/** @constructor */
function $c_s_util_parsing_input_Reader() {
}
$p = $c_s_util_parsing_input_Reader.prototype = new $h_O();
$p.constructor = $c_s_util_parsing_input_Reader;
/** @constructor */
function $h_s_util_parsing_input_Reader() {
}
$h_s_util_parsing_input_Reader.prototype = $p;
function $ct_Lsourcecode_SourceCompanion__F1__($thiz, build) {
  $thiz.VF = build;
  return $thiz;
}
/** @constructor */
function $c_Lsourcecode_SourceCompanion() {
  this.VF = null;
}
$p = $c_Lsourcecode_SourceCompanion.prototype = new $h_O();
$p.constructor = $c_Lsourcecode_SourceCompanion;
/** @constructor */
function $h_Lsourcecode_SourceCompanion() {
}
$h_Lsourcecode_SourceCompanion.prototype = $p;
$p.a5h = (function(s) {
  return this.VF.i(s);
});
/** @constructor */
function $c_Lsourcecode_SourceValue() {
}
$p = $c_Lsourcecode_SourceValue.prototype = new $h_O();
$p.constructor = $c_Lsourcecode_SourceValue;
/** @constructor */
function $h_Lsourcecode_SourceValue() {
}
$h_Lsourcecode_SourceValue.prototype = $p;
function $p_Lujson_BaseCharRenderer$__appendIntString0__I__I__AC__I($thiz, i0, index, arr) {
  var i = i0;
  var q = 0;
  var r = 0;
  var charPos = index;
  var negative = (i < 0);
  if ((!negative)) {
    i = ((-i) | 0);
  }
  while ((i <= (-100))) {
    q = ((i / 100) | 0);
    r = ((Math.imul(100, q) - i) | 0);
    i = q;
    charPos = ((charPos - 1) | 0);
    arr.a[charPos] = $thiz.a2a.a[r];
    charPos = ((charPos - 1) | 0);
    arr.a[charPos] = $thiz.a2b.a[r];
  }
  q = ((i / 10) | 0);
  r = ((Math.imul(10, q) - i) | 0);
  charPos = ((charPos - 1) | 0);
  arr.a[charPos] = (65535 & ((48 + r) | 0));
  if ((q < 0)) {
    charPos = ((charPos - 1) | 0);
    arr.a[charPos] = (65535 & ((48 - q) | 0));
  }
  if (negative) {
    charPos = ((charPos - 1) | 0);
    arr.a[charPos] = 45;
  }
  return charPos;
}
function $p_Lujson_BaseCharRenderer$__appendLongString0__J__I__AC__I($thiz, i0_$_lo, i0_$_hi, index, buf) {
  var i_$_lo = i0_$_lo;
  var i_$_hi = i0_$_hi;
  var q_$_lo = 0;
  var q_$_hi = 0;
  var r = 0;
  var charPos = index;
  var x_$_lo = i_$_lo;
  var x_$_hi = i_$_hi;
  var negative = (x_$_hi < 0);
  if ((!negative)) {
    var x$1_$_lo = i_$_lo;
    var x$1_$_hi = i_$_hi;
    var lo = ((-x$1_$_lo) | 0);
    var hi = ((((-x$1_$_hi) | 0) - ((lo !== 0) | 0)) | 0);
    i_$_lo = lo;
    i_$_hi = hi;
  }
  while (true) {
    var x$2_$_lo = i_$_lo;
    var x$2_$_hi = i_$_hi;
    if (((x$2_$_hi === (-1)) ? ((x$2_$_lo >>> 0) <= 2147483648) : (x$2_$_hi < (-1)))) {
      var num_$_lo = i_$_lo;
      var num_$_hi = i_$_hi;
      var sign = (num_$_hi >> 31);
      var xlo = (num_$_lo ^ sign);
      var rlo = ((xlo - sign) | 0);
      var rhi = (((num_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
      var quotHi = (((rhi >>> 0) / 100) | 0);
      var k = ((rhi - Math.imul(100, quotHi)) | 0);
      var quotLo = ((0.010000000000000004 * ((4.294967296E9 * k) + (rlo >>> 0.0))) | 0.0);
      if ((num_$_hi < 0)) {
        var lo$1 = ((-quotLo) | 0);
        var hi$1 = ((((-quotHi) | 0) - ((lo$1 !== 0) | 0)) | 0);
        q_$_lo = lo$1;
        q_$_hi = hi$1;
      } else {
        q_$_lo = quotLo;
        q_$_hi = quotHi;
      }
      var x$4_$_lo = q_$_lo;
      var x$4_$_hi = q_$_hi;
      r = ((((Math.imul(100, (65535 & x$4_$_lo)) + (Math.imul(100, ((x$4_$_lo >>> 16) | 0)) << 16)) | 0) - i_$_lo) | 0);
      i_$_lo = q_$_lo;
      i_$_hi = q_$_hi;
      charPos = ((charPos - 1) | 0);
      buf.a[charPos] = $thiz.a2a.a[r];
      charPos = ((charPos - 1) | 0);
      buf.a[charPos] = $thiz.a2b.a[r];
    } else {
      break;
    }
  }
  var q2 = 0;
  var i2 = i_$_lo;
  while ((i2 <= (-100))) {
    q2 = ((i2 / 100) | 0);
    r = ((Math.imul(100, q2) - i2) | 0);
    i2 = q2;
    charPos = ((charPos - 1) | 0);
    buf.a[charPos] = $thiz.a2a.a[r];
    charPos = ((charPos - 1) | 0);
    buf.a[charPos] = $thiz.a2b.a[r];
  }
  q2 = ((i2 / 10) | 0);
  r = ((Math.imul(10, q2) - i2) | 0);
  charPos = ((charPos - 1) | 0);
  buf.a[charPos] = (65535 & ((48 + r) | 0));
  if ((q2 < 0)) {
    charPos = ((charPos - 1) | 0);
    buf.a[charPos] = (65535 & ((48 - q2) | 0));
  }
  if (negative) {
    charPos = ((charPos - 1) | 0);
    buf.a[charPos] = 45;
  }
  return charPos;
}
function $p_Lujson_BaseCharRenderer$__appendNull0__AC__I__V($thiz, arr, arrOffset) {
  arr.a[arrOffset] = 110;
  arr.a[((1 + arrOffset) | 0)] = 117;
  arr.a[((2 + arrOffset) | 0)] = 108;
  arr.a[((3 + arrOffset) | 0)] = 108;
}
function $p_Lujson_BaseCharRenderer$__appendTrue0__AC__I__V($thiz, arr, arrOffset) {
  arr.a[arrOffset] = 116;
  arr.a[((1 + arrOffset) | 0)] = 114;
  arr.a[((2 + arrOffset) | 0)] = 117;
  arr.a[((3 + arrOffset) | 0)] = 101;
}
function $p_Lujson_BaseCharRenderer$__appendFalse0__AC__I__V($thiz, arr, arrOffset) {
  arr.a[arrOffset] = 102;
  arr.a[((1 + arrOffset) | 0)] = 97;
  arr.a[((2 + arrOffset) | 0)] = 108;
  arr.a[((3 + arrOffset) | 0)] = 115;
  arr.a[((4 + arrOffset) | 0)] = 101;
}
function $p_Lujson_BaseCharRenderer$__appendKnownAsciiString0__AC__I__jl_CharSequence__I__V($thiz, arr, arrOffset, s, sLength) {
  var i = 0;
  while ((i < sLength)) {
    arr.a[((arrOffset + i) | 0)] = $dp_charAt__I__C(s, i);
    i = ((1 + i) | 0);
  }
}
/** @constructor */
function $c_Lujson_BaseCharRenderer$() {
  this.a2b = null;
  this.a2a = null;
  $n_Lujson_BaseCharRenderer$ = this;
  this.a2b = $constArrRaw_C(100, "l44D4474l44D4474l44D4474l4HD4874m4HD4874m4HD4874m4HD4@74n4XD4@74n4XD4@74n4XD4@74o4lD4D74o4lD4D74o4lD4D74o44E4H74p44E4H74p44E4H74p44E4L74q4HE4L74q4HE4L74q4HE4L74r4XE4P74r4XE4P74r4XE4P74r4lE4T74s4lE4T74s4lE4T74s4lE4X74t44F4X74t44F4X74t44F4X74u4HF4`74u4HF4`74u4HF4`74u444");
  this.a2a = $constArrRaw_C(100, "l4HD4@74o44E4L74r4lE4X74u44D4874n4lD4H74q4XE4T74t4HF4474m4XD4D74p4HE4P74s44F4`74l4HD4@74o44E4L74r4lE4X74u44D4874n4lD4H74q4XE4T74t4HF4474m4XD4D74p4HE4P74s44F4`74l4HD4@74o44E4L74r4lE4X74u44D4874n4lD4H74q4XE4T74t4HF4474m4XD4D74p4HE4P74s44F4`74l4HD4@74o44E4L74r4lE4X74u444");
}
$p = $c_Lujson_BaseCharRenderer$.prototype = new $h_O();
$p.constructor = $c_Lujson_BaseCharRenderer$;
/** @constructor */
function $h_Lujson_BaseCharRenderer$() {
}
$h_Lujson_BaseCharRenderer$.prototype = $p;
$p.baC = (function(arr, length, i0) {
  var i = i0;
  arr.a[length] = 10;
  while ((i > 0)) {
    arr.a[((length + i) | 0)] = 32;
    i = ((i - 1) | 0);
  }
});
$p.baz = (function(eb, i0) {
  var size = $m_Lupickle_core_RenderUtils$().b30(i0);
  var newLength = ((eb.cD + size) | 0);
  eb.ps(size);
  $p_Lujson_BaseCharRenderer$__appendIntString0__I__I__AC__I(this, i0, newLength, eb.gx);
  eb.cD = newLength;
});
$p.aT8 = (function(eb, i0_$_lo, i0_$_hi) {
  var size = $m_Lupickle_core_RenderUtils$().b4b(i0_$_lo, i0_$_hi);
  var newLength = ((eb.cD + size) | 0);
  eb.ps(size);
  $p_Lujson_BaseCharRenderer$__appendLongString0__J__I__AC__I(this, i0_$_lo, i0_$_hi, newLength, eb.gx);
  eb.cD = newLength;
});
$p.baA = (function(eb) {
  eb.ps(4);
  $p_Lujson_BaseCharRenderer$__appendNull0__AC__I__V(this, eb.gx, eb.cD);
  eb.cD = ((4 + eb.cD) | 0);
});
$p.baB = (function(eb) {
  eb.ps(4);
  $p_Lujson_BaseCharRenderer$__appendTrue0__AC__I__V(this, eb.gx, eb.cD);
  eb.cD = ((4 + eb.cD) | 0);
});
$p.bay = (function(eb) {
  eb.ps(5);
  $p_Lujson_BaseCharRenderer$__appendFalse0__AC__I__V(this, eb.gx, eb.cD);
  eb.cD = ((5 + eb.cD) | 0);
});
$p.aim = (function(eb, s) {
  var sLength = $dp_length__I(s);
  eb.ps(sLength);
  $p_Lujson_BaseCharRenderer$__appendKnownAsciiString0__AC__I__jl_CharSequence__I__V(this, eb.gx, eb.cD, s, sLength);
  eb.cD = ((eb.cD + sLength) | 0);
});
var $d_Lujson_BaseCharRenderer$ = new $TypeData().i($c_Lujson_BaseCharRenderer$, "ujson.BaseCharRenderer$", ({
  Nt: 1
}));
var $n_Lujson_BaseCharRenderer$;
function $m_Lujson_BaseCharRenderer$() {
  if ((!$n_Lujson_BaseCharRenderer$)) {
    $n_Lujson_BaseCharRenderer$ = new $c_Lujson_BaseCharRenderer$();
  }
  return $n_Lujson_BaseCharRenderer$;
}
/** @constructor */
function $c_Lujson_MathUtilsChar$() {
}
$p = $c_Lujson_MathUtilsChar$.prototype = new $h_O();
$p.constructor = $c_Lujson_MathUtilsChar$;
/** @constructor */
function $h_Lujson_MathUtilsChar$() {
}
$h_Lujson_MathUtilsChar$.prototype = $p;
$p.aSY = (function(bytes, index, s) {
  var len = s.length;
  var i = 0;
  while ((i < len)) {
    bytes.a[((index + i) | 0)] = s.charCodeAt(i);
    i = ((1 + i) | 0);
  }
  return len;
});
var $d_Lujson_MathUtilsChar$ = new $TypeData().i($c_Lujson_MathUtilsChar$, "ujson.MathUtilsChar$", ({
  NA: 1
}));
var $n_Lujson_MathUtilsChar$;
function $m_Lujson_MathUtilsChar$() {
  if ((!$n_Lujson_MathUtilsChar$)) {
    $n_Lujson_MathUtilsChar$ = new $c_Lujson_MathUtilsChar$();
  }
  return $n_Lujson_MathUtilsChar$;
}
/** @constructor */
function $c_Lujson_package$() {
}
$p = $c_Lujson_package$.prototype = new $h_O();
$p.constructor = $c_Lujson_package$;
/** @constructor */
function $h_Lujson_package$() {
}
$h_Lujson_package$.prototype = $p;
$p.ahw = (function(s, trace) {
  var v = $m_Lujson_Value$();
  var f = ((_$1) => $m_Lupickle_core_BufferedValue$().a4b($m_Lujson_Readable$(), s, false, _$1));
  if ((!trace)) {
    var $x_1 = f(v);
  } else {
    var wrapper = new $c_Lupickle_core_TraceVisitor$Wrapper();
    try {
      var x0 = $ct_Lupickle_core_TraceVisitor__Lupickle_core_Visitor__Lupickle_core_TraceVisitor$HasPath__Lupickle_core_TraceVisitor$Wrapper__(new $c_Lupickle_core_TraceVisitor(), v, $m_Lupickle_core_TraceVisitor$RootHasPath$(), wrapper);
      var $x_1 = f(x0);
    } catch (e) {
      var $x_1;
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      var x2 = $m_s_util_control_NonFatal$().wm(e$2);
      if ((!x2.c())) {
        var x3 = x2.d();
        throw new $c_Lupickle_core_TraceVisitor$TraceException($f_Lupickle_core_TraceVisitor$HasPath__path__T(wrapper.Ih), x3);
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
    }
  }
  return $x_1;
});
$p.bc5 = (function(t, indent, escapeUnicode, sortKeys) {
  var writer = new $c_Ljava_io_StringWriter();
  $m_Lujson_package$().bcA(t, writer, indent, escapeUnicode, sortKeys);
  return writer.m();
});
$p.bcA = (function(t, out, indent, escapeUnicode, sortKeys) {
  $m_Lupickle_core_BufferedValue$().a4b($m_Lujson_Readable$(), t, sortKeys, new $c_Lujson_Renderer(out, indent, escapeUnicode));
});
var $d_Lujson_package$ = new $TypeData().i($c_Lujson_package$, "ujson.package$", ({
  NJ: 1
}));
var $n_Lujson_package$;
function $m_Lujson_package$() {
  if ((!$n_Lujson_package$)) {
    $n_Lujson_package$ = new $c_Lujson_package$();
  }
  return $n_Lujson_package$;
}
/** @constructor */
function $c_Lupickle_Api$transform$(outer) {
  this.aJG = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aJG = outer;
}
$p = $c_Lupickle_Api$transform$.prototype = new $h_O();
$p.constructor = $c_Lupickle_Api$transform$;
/** @constructor */
function $h_Lupickle_Api$transform$() {
}
$h_Lupickle_Api$transform$.prototype = $p;
$p.aXj = (function(t, evidence$1) {
  return new $c_Lupickle_Api$transform(this.aJG, t, evidence$1);
});
$p.m = (function() {
  return "transform";
});
var $d_Lupickle_Api$transform$ = new $TypeData().i($c_Lupickle_Api$transform$, "upickle.Api$transform$", ({
  NT: 1
}));
function $f_Lupickle_LowPriReadWriters__JsValueR__Lupickle_core_Types$Reader($thiz) {
  return $ct_Lupickle_core_Types$Reader$Delegate__Lupickle_core_Types$Reader$__Lupickle_core_Visitor__(new $c_Lupickle_core_Types$Reader$Delegate(), $thiz.OP(), $m_Lujson_Value$());
}
function $f_Lupickle_core_BufferingCharParser__$init$__V($thiz) {
  $thiz.Dl = null;
  $thiz.HO = 0;
  $thiz.xO = 0;
  $thiz.HP = 2147483647;
}
function $f_Lupickle_core_BufferingCharParser__getCharUnsafe__I__C($thiz, i) {
  return $thiz.Dl.a[((i - $thiz.HO) | 0)];
}
function $f_Lupickle_core_BufferingCharParser__requestUntil__I__Z($thiz, until) {
  return ((until >= $thiz.xO) && ((until >= $thiz.HP) || $p_Lupickle_core_BufferingCharParser__requestUntil0__I__Z($thiz, until)));
}
function $f_Lupickle_core_BufferingCharParser__requestUntilGetSafeIndex__I__I($thiz, until) {
  return ((until < $thiz.xO) ? $thiz.xO : ((until >= $thiz.HP) ? $thiz.HP : ($p_Lupickle_core_BufferingCharParser__requestUntil0__I__Z($thiz, until) ? $thiz.HP : $thiz.xO)));
}
function $p_Lupickle_core_BufferingCharParser__requestUntil0__I__Z($thiz, until) {
  var bufferOffset = (($thiz.xO - $thiz.HO) | 0);
  matchResult1: {
    var \u03b41$___1;
    var \u03b41$___2;
    var \u03b41$___3;
    var x1 = $thiz.b7b($thiz.Dl, bufferOffset);
    if ((x1 !== null)) {
      var \u03b41$___1 = x1.bH;
      var \u03b41$___2 = (!(!x1.bU));
      var \u03b41$___3 = (x1.c3 | 0);
      break matchResult1;
    }
    throw new $c_s_MatchError(x1);
  }
  var newBuffer$2 = \u03b41$___1;
  var newDone$2 = (!(!\u03b41$___2));
  var n$2 = (\u03b41$___3 | 0);
  $thiz.Dl = newBuffer$2;
  if ((n$2 !== (-1))) {
    $thiz.xO = (($thiz.xO + n$2) | 0);
  }
  if (newDone$2) {
    $thiz.HP = $thiz.xO;
  }
  return newDone$2;
}
function $f_Lupickle_core_BufferingCharParser__unsafeCharSeqForRange__I__I__Lupickle_core_WrapCharArrayCharSeq($thiz, start, length) {
  return new $c_Lupickle_core_WrapCharArrayCharSeq($thiz.Dl, ((start - $thiz.HO) | 0), length);
}
function $f_Lupickle_core_BufferingCharParser__appendCharsToBuilder__Lupickle_core_CharBuilder__I__I__V($thiz, chars, charsStart, charsLength) {
  chars.aX3($thiz.Dl, ((charsStart - $thiz.HO) | 0), charsLength);
}
/** @constructor */
function $c_Lupickle_core_CharAppendC() {
}
$p = $c_Lupickle_core_CharAppendC.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_CharAppendC;
/** @constructor */
function $h_Lupickle_core_CharAppendC() {
}
$h_Lupickle_core_CharAppendC.prototype = $p;
/** @constructor */
function $c_Lupickle_core_CharOps$() {
}
$p = $c_Lupickle_core_CharOps$.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_CharOps$;
/** @constructor */
function $h_Lupickle_core_CharOps$() {
}
$h_Lupickle_core_CharOps$.prototype = $p;
$p.Qc = (function(c1, c2, c3) {
  return ((c2 >= c1) && (c2 <= c3));
});
var $d_Lupickle_core_CharOps$ = new $TypeData().i($c_Lupickle_core_CharOps$, "upickle.core.CharOps$", ({
  Ok: 1
}));
var $n_Lupickle_core_CharOps$;
function $m_Lupickle_core_CharOps$() {
  if ((!$n_Lupickle_core_CharOps$)) {
    $n_Lupickle_core_CharOps$ = new $c_Lupickle_core_CharOps$();
  }
  return $n_Lupickle_core_CharOps$;
}
function $p_Lupickle_core_CharUtils$__appendSimpleStringSection0__AC__I__I__I__jl_CharSequence__I($thiz, arr, arrOffset, i0, len, s) {
  var i = i0;
  while (true) {
    if ((i < len)) {
      var c2 = $dp_charAt__I__C(s, i);
      if ((!(((c2 < 32) || (c2 === 34)) || (c2 === 92)))) {
        arr.a[((((arrOffset + i) | 0) - i0) | 0)] = c2;
        i = ((1 + i) | 0);
        var $x_1 = true;
      } else {
        var $x_1 = false;
      }
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
    } else {
      break;
    }
  }
  return ((i - 1) | 0);
}
function $p_Lupickle_core_CharUtils$__appendSimpleStringSectionNoUnicode0__AC__I__I__I__jl_CharSequence__I($thiz, arr, arrOffset, i0, len, s) {
  var i = i0;
  while (true) {
    if ((i < len)) {
      var c2 = $dp_charAt__I__C(s, i);
      if ((!((((((c2 - 32) | 0) >>> 0) > 95) || (c2 === 34)) || (c2 === 92)))) {
        arr.a[((((arrOffset + i) | 0) - i0) | 0)] = c2;
        i = ((1 + i) | 0);
        var $x_1 = true;
      } else {
        var $x_1 = false;
      }
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
    } else {
      break;
    }
  }
  return ((i - 1) | 0);
}
/** @constructor */
function $c_Lupickle_core_CharUtils$() {
}
$p = $c_Lupickle_core_CharUtils$.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_CharUtils$;
/** @constructor */
function $h_Lupickle_core_CharUtils$() {
}
$h_Lupickle_core_CharUtils$.prototype = $p;
$p.aM2 = (function(charBuilder, c, i) {
  switch (c) {
    case 34: {
      this.IS(charBuilder, i, 34);
      return true;
      break;
    }
    case 92: {
      this.IS(charBuilder, i, 92);
      return true;
      break;
    }
    case 8: {
      this.IS(charBuilder, i, 98);
      return true;
      break;
    }
    case 12: {
      this.IS(charBuilder, i, 102);
      return true;
      break;
    }
    case 10: {
      this.IS(charBuilder, i, 110);
      return true;
      break;
    }
    case 13: {
      this.IS(charBuilder, i, 114);
      return true;
      break;
    }
    case 9: {
      this.IS(charBuilder, i, 116);
      return true;
      break;
    }
    default: {
      return false;
    }
  }
});
$p.IS = (function(charBuilder, i, c) {
  charBuilder.ps(2);
  var length = charBuilder.cD;
  var arr = charBuilder.gx;
  arr.a[length] = 92;
  arr.a[((1 + length) | 0)] = c;
  charBuilder.cD = ((2 + charBuilder.cD) | 0);
});
$p.aNT = (function(charBuilder, i, c) {
  charBuilder.ps(6);
  var arr = charBuilder.gx;
  var length = charBuilder.cD;
  arr.a[length] = 92;
  arr.a[((1 + length) | 0)] = 117;
  arr.a[((2 + length) | 0)] = $m_Lupickle_core_RenderUtils$().a51((15 & (c >> 12)));
  arr.a[((3 + length) | 0)] = $m_Lupickle_core_RenderUtils$().a51((15 & (c >> 8)));
  arr.a[((4 + length) | 0)] = $m_Lupickle_core_RenderUtils$().a51((15 & (c >> 4)));
  arr.a[((5 + length) | 0)] = $m_Lupickle_core_RenderUtils$().a51((15 & c));
  charBuilder.cD = ((6 + charBuilder.cD) | 0);
});
$p.aX5 = (function(charBuilder, i0, len, s) {
  charBuilder.ps(((len - i0) | 0));
  var i = $p_Lupickle_core_CharUtils$__appendSimpleStringSection0__AC__I__I__I__jl_CharSequence__I(this, charBuilder.gx, charBuilder.cD, i0, len, s);
  charBuilder.cD = ((1 + ((charBuilder.cD + ((i - i0) | 0)) | 0)) | 0);
  return i;
});
$p.aX6 = (function(charBuilder, i0, len, s) {
  charBuilder.ps(((len - i0) | 0));
  var i = $p_Lupickle_core_CharUtils$__appendSimpleStringSectionNoUnicode0__AC__I__I__I__jl_CharSequence__I(this, charBuilder.gx, charBuilder.cD, i0, len, s);
  charBuilder.cD = ((1 + ((charBuilder.cD + ((i - i0) | 0)) | 0)) | 0);
  return i;
});
$p.XG = (function(arr, arrOffset, arrLength, decIndex, expIndex) {
  if ((expIndex === (-1))) {
    var expMul = 1;
  } else {
    var mult = 1;
    var $x_1 = this.a4n(arr, ((1 + ((arrOffset + expIndex) | 0)) | 0), ((arrOffset + arrLength) | 0));
    var e_$_lo = $x_1.l;
    var e_$_hi = $x_1.h;
    var i = 0;
    while (true) {
      var value = i;
      var hi = (value >> 31);
      if (((hi === e_$_hi) ? ((value >>> 0) < (e_$_lo >>> 0)) : (hi < e_$_hi))) {
        var value$1 = mult;
        var hi$1 = (value$1 >> 31);
        if (((hi$1 === 214748364) ? ((value$1 >>> 0) >= 3435973836) : (hi$1 > 214748364))) {
          throw new $c_Lupickle_core_Abort("expected integer");
        }
        mult = Math.imul(10, mult);
        i = ((1 + i) | 0);
      } else {
        break;
      }
    }
    var expMul = mult;
  }
  var end = ((decIndex !== (-1)) ? decIndex : ((expIndex !== (-1)) ? expIndex : arrLength));
  var $x_2 = this.a4n(arr, arrOffset, ((arrOffset + end) | 0));
  var x_$_lo = $x_2.l;
  var x_$_hi = $x_2.h;
  var hi$2 = (expMul >> 31);
  var a0 = (65535 & x_$_lo);
  var a1 = ((x_$_lo >>> 16) | 0);
  var b0 = (65535 & expMul);
  var b1 = ((expMul >>> 16) | 0);
  var a0b0 = Math.imul(a0, b0);
  var a1b0 = Math.imul(a1, b0);
  var a0b1 = Math.imul(a0, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$3 = ((((((((Math.imul(x_$_lo, hi$2) + Math.imul(x_$_hi, expMul)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  if ((decIndex === (-1))) {
    var decPortion_$_lo = 0;
    var decPortion_$_hi = 0;
  } else {
    var end$2 = ((expIndex !== (-1)) ? expIndex : arrLength);
    var $x_3 = this.a4n(arr, ((1 + ((arrOffset + decIndex) | 0)) | 0), ((arrOffset + end$2) | 0));
    var x$1_$_lo = $x_3.l;
    var x$1_$_hi = $x_3.h;
    var hi$4 = (expMul >> 31);
    var a0$1 = (65535 & x$1_$_lo);
    var a1$1 = ((x$1_$_lo >>> 16) | 0);
    var b0$1 = (65535 & expMul);
    var b1$1 = ((expMul >>> 16) | 0);
    var a0b0$1 = Math.imul(a0$1, b0$1);
    var a1b0$1 = Math.imul(a1$1, b0$1);
    var a0b1$1 = Math.imul(a0$1, b1$1);
    var lo$1 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
    var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
    var hi$5 = ((((((((Math.imul(x$1_$_lo, hi$4) + Math.imul(x$1_$_hi, expMul)) | 0) + Math.imul(a1$1, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
    var value$2_$_lo = lo$1;
    var value$2_$_hi = hi$5;
    var i$2 = ((end$2 - ((1 + decIndex) | 0)) | 0);
    while ((i$2 > 0)) {
      var num_$_lo = value$2_$_lo;
      var num_$_hi = value$2_$_hi;
      var sign = (num_$_hi >> 31);
      var xlo = (num_$_lo ^ sign);
      var rlo = ((xlo - sign) | 0);
      var rhi = (((num_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
      var quotHi = (((rhi >>> 0) / 10) | 0);
      var k = ((rhi - Math.imul(10, quotHi)) | 0);
      var quotLo = ((0.10000000000000005 * ((4.294967296E9 * k) + (rlo >>> 0.0))) | 0.0);
      if ((num_$_hi < 0)) {
        var lo$2 = ((-quotLo) | 0);
        var hi$6 = ((((-quotHi) | 0) - ((lo$2 !== 0) | 0)) | 0);
        value$2_$_lo = lo$2;
        value$2_$_hi = hi$6;
      } else {
        value$2_$_lo = quotLo;
        value$2_$_hi = quotHi;
      }
      i$2 = ((i$2 - 1) | 0);
    }
    if ((arr.a[arrOffset] === 45)) {
      var x$3_$_lo = value$2_$_lo;
      var x$3_$_hi = value$2_$_hi;
      var lo$3 = ((-x$3_$_lo) | 0);
      var hi$7 = ((((-x$3_$_hi) | 0) - ((lo$3 !== 0) | 0)) | 0);
      var decPortion_$_lo = lo$3;
      var decPortion_$_hi = hi$7;
    } else {
      var decPortion_$_lo = value$2_$_lo;
      var decPortion_$_hi = value$2_$_hi;
    }
  }
  var lo$4 = ((lo + decPortion_$_lo) | 0);
  var hi$8 = ((((hi$3 + decPortion_$_hi) | 0) + (((lo$4 >>> 0) < (lo >>> 0)) | 0)) | 0);
  return $bL(lo$4, hi$8);
});
$p.a4n = (function(cs0, start0, end0) {
  if (((((start0 | end0) | ((end0 - start0) | 0)) | ((cs0.a.length - end0) | 0)) < 0)) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
  var cs = $m_jl_reflect_Array$().m0($d_C.l(), new $ac_I(new Int32Array([((end0 - start0) | 0)])));
  var length = ((end0 - start0) | 0);
  cs0.av(start0, cs, 0, length);
  var inverseSum_$_lo = 0;
  var inverseSum_$_hi = 0;
  var inverseSign_$_lo = (-1);
  var inverseSign_$_hi = (-1);
  var i = 0;
  var end = ((end0 - start0) | 0);
  if ((cs.a[0] === 45)) {
    inverseSign_$_lo = 1;
    inverseSign_$_hi = 0;
    i = ((1 + i) | 0);
  }
  var size = ((end - i) | 0);
  if (((((size - 1) | 0) >>> 0) > 18)) {
    throw new $c_jl_NumberFormatException($m_jl_String$().kS(cs, 0, cs.a.length));
  }
  while ((i < end)) {
    var digit = ((cs.a[i] - 48) | 0);
    if (((digit >>> 0) > 9)) {
      throw new $c_jl_NumberFormatException($m_jl_String$().kS(cs, 0, cs.a.length));
    }
    var x_$_lo = inverseSum_$_lo;
    var x_$_hi = inverseSum_$_hi;
    var b0 = (65535 & x_$_lo);
    var b1 = ((x_$_lo >>> 16) | 0);
    var a0b0 = Math.imul(10, b0);
    var a0b1 = Math.imul(10, b1);
    var lo = ((a0b0 + (a0b1 << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi = ((Math.imul(10, x_$_hi) + ((c1part >>> 16) | 0)) | 0);
    var hi$1 = (digit >> 31);
    var lo$1 = ((lo - digit) | 0);
    var hi$2 = ((((hi - hi$1) | 0) - (((lo$1 >>> 0) > (lo >>> 0)) | 0)) | 0);
    inverseSum_$_lo = lo$1;
    inverseSum_$_hi = hi$2;
    i = ((1 + i) | 0);
  }
  if ((size === 19)) {
    var x$1_$_lo = inverseSum_$_lo;
    var x$1_$_hi = inverseSum_$_hi;
    if ((x$1_$_hi >= 0)) {
      var $x_1 = true;
    } else {
      var x$2_$_lo = inverseSum_$_lo;
      var x$2_$_hi = inverseSum_$_hi;
      if (((x$2_$_lo | ((-2147483648) ^ x$2_$_hi)) === 0)) {
        var x$3_$_lo = inverseSign_$_lo;
        var x$3_$_hi = inverseSign_$_hi;
        var $x_1 = (x$3_$_hi < 0);
      } else {
        var $x_1 = false;
      }
    }
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    throw new $c_jl_NumberFormatException($m_jl_String$().kS(cs, 0, cs.a.length));
  }
  var x$4_$_lo = inverseSum_$_lo;
  var x$4_$_hi = inverseSum_$_hi;
  var x$5_$_lo = inverseSign_$_lo;
  var x$5_$_hi = inverseSign_$_hi;
  var a0 = (65535 & x$4_$_lo);
  var a1 = ((x$4_$_lo >>> 16) | 0);
  var b0$1 = (65535 & x$5_$_lo);
  var b1$1 = ((x$5_$_lo >>> 16) | 0);
  var a0b0$1 = Math.imul(a0, b0$1);
  var a1b0 = Math.imul(a1, b0$1);
  var a0b1$1 = Math.imul(a0, b1$1);
  var lo$2 = ((a0b0$1 + (((a1b0 + a0b1$1) | 0) << 16)) | 0);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$3 = ((((((((Math.imul(x$4_$_lo, x$5_$_hi) + Math.imul(x$4_$_hi, x$5_$_lo)) | 0) + Math.imul(a1, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0) | 0) >>> 16) | 0)) | 0);
  return $bL(lo$2, hi$3);
});
var $d_Lupickle_core_CharUtils$ = new $TypeData().i($c_Lupickle_core_CharUtils$, "upickle.core.CharUtils$", ({
  Ol: 1
}));
var $n_Lupickle_core_CharUtils$;
function $m_Lupickle_core_CharUtils$() {
  if ((!$n_Lupickle_core_CharUtils$)) {
    $n_Lupickle_core_CharUtils$ = new $c_Lupickle_core_CharUtils$();
  }
  return $n_Lupickle_core_CharUtils$;
}
/** @constructor */
function $c_Lupickle_core_LinkedHashMap$() {
}
$p = $c_Lupickle_core_LinkedHashMap$.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_LinkedHashMap$;
/** @constructor */
function $h_Lupickle_core_LinkedHashMap$() {
}
$h_Lupickle_core_LinkedHashMap$.prototype = $p;
$p.aXq = (function(items) {
  var map = new $c_Lupickle_core_LinkedHashMap($ct_ju_LinkedHashMap__(new $c_ju_LinkedHashMap()));
  var this$3 = items.o();
  while (this$3.p()) {
    var x0 = this$3.q();
    matchResult1: {
      if ((x0 !== null)) {
        map.air(x0.g(), x0.h());
        break matchResult1;
      }
      throw new $c_s_MatchError(x0);
    }
  }
  return map;
});
var $d_Lupickle_core_LinkedHashMap$ = new $TypeData().i($c_Lupickle_core_LinkedHashMap$, "upickle.core.LinkedHashMap$", ({
  Oo: 1
}));
var $n_Lupickle_core_LinkedHashMap$;
function $m_Lupickle_core_LinkedHashMap$() {
  if ((!$n_Lupickle_core_LinkedHashMap$)) {
    $n_Lupickle_core_LinkedHashMap$ = new $c_Lupickle_core_LinkedHashMap$();
  }
  return $n_Lupickle_core_LinkedHashMap$;
}
/** @constructor */
function $c_Lupickle_core_ParseUtils$() {
}
$p = $c_Lupickle_core_ParseUtils$.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_ParseUtils$;
/** @constructor */
function $h_Lupickle_core_ParseUtils$() {
}
$h_Lupickle_core_ParseUtils$.prototype = $p;
$p.PI = (function(s, decIndex, expIndex, index) {
  var arr = $f_T__toCharArray__AC($dp_toString__T(s));
  return $m_Lupickle_core_CharUtils$().XG(arr, 0, arr.a.length, decIndex, expIndex);
});
$p.b6u = (function(cs, start, end) {
  return $m_Lupickle_core_CharUtils$().a4n($f_T__toCharArray__AC($dp_toString__T(cs)), start, end);
});
var $d_Lupickle_core_ParseUtils$ = new $TypeData().i($c_Lupickle_core_ParseUtils$, "upickle.core.ParseUtils$", ({
  Ot: 1
}));
var $n_Lupickle_core_ParseUtils$;
function $m_Lupickle_core_ParseUtils$() {
  if ((!$n_Lupickle_core_ParseUtils$)) {
    $n_Lupickle_core_ParseUtils$ = new $c_Lupickle_core_ParseUtils$();
  }
  return $n_Lupickle_core_ParseUtils$;
}
/** @constructor */
function $c_Lupickle_core_RenderUtils$() {
  this.aJM = null;
  $n_Lupickle_core_RenderUtils$ = this;
  var arr = $m_jl_reflect_Array$().m0($d_I.l(), new $ac_I(new Int32Array([128])));
  var i = 0;
  while ((i < 10)) {
    arr.a[((48 + i) | 0)] = i;
    i = ((1 + i) | 0);
  }
  i = 0;
  while ((i < 16)) {
    arr.a[((97 + i) | 0)] = ((10 + i) | 0);
    arr.a[((65 + i) | 0)] = ((10 + i) | 0);
    i = ((1 + i) | 0);
  }
  this.aJM = arr;
}
$p = $c_Lupickle_core_RenderUtils$.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_RenderUtils$;
/** @constructor */
function $h_Lupickle_core_RenderUtils$() {
}
$h_Lupickle_core_RenderUtils$.prototype = $p;
$p.a3K = (function(i) {
  return this.aJM.a[i];
});
$p.a51 = (function(nibble) {
  return (65535 & ((nibble + ((nibble >= 10) ? 87 : 48)) | 0));
});
$p.aNR = (function(unicodeCharBuilder, sb, s, escapeUnicode, wrapQuotes) {
  var len = $dp_length__I(s);
  if (wrapQuotes) {
    sb.jS(34);
  }
  return this.b0Q(0, len, sb, s, escapeUnicode, wrapQuotes);
});
$p.b0Q = (function(i0, len, sb, s, escapeUnicode, wrapQuotes) {
  var i = i0;
  if (escapeUnicode) {
    while ((i < len)) {
      var c = $dp_charAt__I__C(s, i);
      if ((!$m_Lupickle_core_CharUtils$().aM2(sb, c, i))) {
        if (((((c - 32) | 0) >>> 0) > 95)) {
          $m_Lupickle_core_CharUtils$().aNT(sb, i, c);
        } else {
          i = $m_Lupickle_core_CharUtils$().aX6(sb, i, len, s);
        }
      }
      i = ((1 + i) | 0);
    }
  } else {
    while ((i < len)) {
      var c$2 = $dp_charAt__I__C(s, i);
      if ((!$m_Lupickle_core_CharUtils$().aM2(sb, c$2, i))) {
        if ((c$2 < 32)) {
          $m_Lupickle_core_CharUtils$().aNT(sb, i, c$2);
        } else {
          i = $m_Lupickle_core_CharUtils$().aX5(sb, i, len, s);
        }
      }
      i = ((1 + i) | 0);
    }
  }
  if (wrapQuotes) {
    sb.jS(34);
  }
  return sb;
});
$p.b30 = (function(x0) {
  var x = x0;
  var d = 1;
  if ((x >= 0)) {
    d = 0;
    x = ((-x) | 0);
  }
  var p = (-10);
  var i = 1;
  while ((i <= 10)) {
    if ((x > p)) {
      return ((i + d) | 0);
    }
    p = Math.imul(10, p);
    i = ((1 + i) | 0);
  }
  return ((10 + d) | 0);
});
$p.b4b = (function(x0_$_lo, x0_$_hi) {
  var x_$_lo = x0_$_lo;
  var x_$_hi = x0_$_hi;
  var d = 1;
  var x$1_$_lo = x_$_lo;
  var x$1_$_hi = x_$_hi;
  if ((x$1_$_hi >= 0)) {
    d = 0;
    var x$2_$_lo = x_$_lo;
    var x$2_$_hi = x_$_hi;
    var lo = ((-x$2_$_lo) | 0);
    var hi = ((((-x$2_$_hi) | 0) - ((lo !== 0) | 0)) | 0);
    x_$_lo = lo;
    x_$_hi = hi;
  }
  var p_$_lo = (-10);
  var p_$_hi = (-1);
  var i = 1;
  while ((i <= 18)) {
    var x$3_$_lo = x_$_lo;
    var x$3_$_hi = x_$_hi;
    var x$4_$_lo = p_$_lo;
    var x$4_$_hi = p_$_hi;
    if (((x$3_$_hi === x$4_$_hi) ? ((x$3_$_lo >>> 0) > (x$4_$_lo >>> 0)) : (x$3_$_hi > x$4_$_hi))) {
      return ((i + d) | 0);
    }
    var x$5_$_lo = p_$_lo;
    var x$5_$_hi = p_$_hi;
    var b0 = (65535 & x$5_$_lo);
    var b1 = ((x$5_$_lo >>> 16) | 0);
    var a0b0 = Math.imul(10, b0);
    var a0b1 = Math.imul(10, b1);
    var lo$1 = ((a0b0 + (a0b1 << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$1 = ((Math.imul(10, x$5_$_hi) + ((c1part >>> 16) | 0)) | 0);
    p_$_lo = lo$1;
    p_$_hi = hi$1;
    i = ((1 + i) | 0);
  }
  return ((19 + d) | 0);
});
var $d_Lupickle_core_RenderUtils$ = new $TypeData().i($c_Lupickle_core_RenderUtils$, "upickle.core.RenderUtils$", ({
  Ov: 1
}));
var $n_Lupickle_core_RenderUtils$;
function $m_Lupickle_core_RenderUtils$() {
  if ((!$n_Lupickle_core_RenderUtils$)) {
    $n_Lupickle_core_RenderUtils$ = new $c_Lupickle_core_RenderUtils$();
  }
  return $n_Lupickle_core_RenderUtils$;
}
function $p_Lupickle_core_TraceVisitor$HasPath__components__sci_List($thiz) {
  return $p_Lupickle_core_TraceVisitor$HasPath__listPath$1__s_Option__sci_List__sci_List($thiz, $thiz.a4l(), new $c_sci_$colon$colon($thiz, $m_sci_Nil$()));
}
function $f_Lupickle_core_TraceVisitor$HasPath__path__T($thiz) {
  return ("$" + $f_sc_IterableOnceOps__mkString__T__T__T__T(new $c_sc_Iterator$$anon$9(new $c_sc_Iterator$$anon$10($p_Lupickle_core_TraceVisitor$HasPath__components__sci_List($thiz).o(), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => _$1.ahr()))), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => (("[" + _$2) + "]")))), "", "", ""));
}
function $p_Lupickle_core_TraceVisitor$HasPath__listPath$1__s_Option__sci_List__sci_List($thiz, o, list) {
  var list$tailLocal1 = list;
  var o$tailLocal1 = o;
  while (true) {
    var x5 = o$tailLocal1;
    if ((x5 instanceof $c_s_Some)) {
      var p = x5.J;
      var o$tailLocal1$tmp1 = p.a4l();
      var list$tailLocal1$tmp1 = new $c_sci_$colon$colon(p, list$tailLocal1);
      o$tailLocal1 = o$tailLocal1$tmp1;
      list$tailLocal1 = list$tailLocal1$tmp1;
      continue;
    }
    if (($m_s_None$() === x5)) {
      return list$tailLocal1;
    }
    throw new $c_s_MatchError(x5);
  }
}
/** @constructor */
function $c_Lupickle_core_TraceVisitor$Wrapper() {
  this.Ih = null;
  this.Ih = $m_Lupickle_core_TraceVisitor$RootHasPath$();
}
$p = $c_Lupickle_core_TraceVisitor$Wrapper.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_TraceVisitor$Wrapper;
/** @constructor */
function $h_Lupickle_core_TraceVisitor$Wrapper() {
}
$h_Lupickle_core_TraceVisitor$Wrapper.prototype = $p;
var $d_Lupickle_core_TraceVisitor$Wrapper = new $TypeData().i($c_Lupickle_core_TraceVisitor$Wrapper, "upickle.core.TraceVisitor$Wrapper", ({
  OC: 1
}));
function $f_Lupickle_core_Types__taggedArrayContext__Lupickle_core_Types$TaggedReader__I__Lupickle_core_ArrVisitor($thiz, taggedReader, index) {
  throw new $c_Lupickle_core_Abort("expected dictionary");
}
/** @constructor */
function $c_Lupickle_core_Types$ReadWriter$(outer) {
  this.tN = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.tN = outer;
}
$p = $c_Lupickle_core_Types$ReadWriter$.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_Types$ReadWriter$;
/** @constructor */
function $h_Lupickle_core_Types$ReadWriter$() {
}
$h_Lupickle_core_Types$ReadWriter$.prototype = $p;
$p.ez = (function(r0, w0) {
  matchResult1: {
    var $x_1;
    if (($is_Lupickle_core_Types$TaggedReader(r0) && (r0.ais() === this.tN))) {
      if (($is_Lupickle_core_Types$TaggedWriter(w0) && (w0.a5b() === this.tN))) {
        var $x_1 = new $c_Lupickle_core_Types$$anon$2(r0, w0, w0, this);
        break matchResult1;
      }
    }
    var $x_1 = new $c_Lupickle_core_Types$$anon$3(r0, w0, this);
  }
  return $x_1;
});
var $d_Lupickle_core_Types$ReadWriter$ = new $TypeData().i($c_Lupickle_core_Types$ReadWriter$, "upickle.core.Types$ReadWriter$", ({
  OI: 1
}));
/** @constructor */
function $c_Lupickle_core_Types$Reader$(outer) {
  this.a2l = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.a2l = outer;
}
$p = $c_Lupickle_core_Types$Reader$.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_Types$Reader$;
/** @constructor */
function $h_Lupickle_core_Types$Reader$() {
}
$h_Lupickle_core_Types$Reader$.prototype = $p;
$p.aQf = (function(tagKey, readers0) {
  if ((!readers0.lV(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$3) => $is_Lupickle_core_Types$TaggedReader(_$3)))))) {
    $m_sr_Scala3RunTime$().aeQ(("Can only merge Readers of case classes, not " + readers0.cE(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$4) => $is_Lupickle_core_Types$TaggedReader(_$4))))));
  }
  return new $c_Lupickle_core_Types$TaggedReader$Node(this.a2l.Iy(), tagKey, readers0);
});
var $d_Lupickle_core_Types$Reader$ = new $TypeData().i($c_Lupickle_core_Types$Reader$, "upickle.core.Types$Reader$", ({
  OK: 1
}));
/** @constructor */
function $c_Lupickle_core_Types$TaggedReader$(outer) {
  this.W3 = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.W3 = outer;
}
$p = $c_Lupickle_core_Types$TaggedReader$.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_Types$TaggedReader$;
/** @constructor */
function $h_Lupickle_core_Types$TaggedReader$() {
}
$h_Lupickle_core_Types$TaggedReader$.prototype = $p;
var $d_Lupickle_core_Types$TaggedReader$ = new $TypeData().i($c_Lupickle_core_Types$TaggedReader$, "upickle.core.Types$TaggedReader$", ({
  ON: 1
}));
/** @constructor */
function $c_Lupickle_core_Types$TaggedWriter$(outer) {
  this.adV = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.adV = outer;
}
$p = $c_Lupickle_core_Types$TaggedWriter$.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_Types$TaggedWriter$;
/** @constructor */
function $h_Lupickle_core_Types$TaggedWriter$() {
}
$h_Lupickle_core_Types$TaggedWriter$.prototype = $p;
var $d_Lupickle_core_Types$TaggedWriter$ = new $TypeData().i($c_Lupickle_core_Types$TaggedWriter$, "upickle.core.Types$TaggedWriter$", ({
  OQ: 1
}));
/** @constructor */
function $c_Lupickle_core_Types$Writer$(outer) {
  this.aK2 = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aK2 = outer;
}
$p = $c_Lupickle_core_Types$Writer$.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_Types$Writer$;
/** @constructor */
function $h_Lupickle_core_Types$Writer$() {
}
$h_Lupickle_core_Types$Writer$.prototype = $p;
$p.aQg = (function(writers) {
  if ((!writers.lV(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$5) => $is_Lupickle_core_Types$TaggedWriter(_$5)))))) {
    $m_sr_Scala3RunTime$().aeQ(("Can only merge Writers of case classes, not " + writers.cE(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$6) => $is_Lupickle_core_Types$TaggedWriter(_$6))))));
  }
  return new $c_Lupickle_core_Types$TaggedWriter$Node(this.aK2.aLD(), writers);
});
var $d_Lupickle_core_Types$Writer$ = new $TypeData().i($c_Lupickle_core_Types$Writer$, "upickle.core.Types$Writer$", ({
  OT: 1
}));
function $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O($thiz, s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $thiz.eD($m_jl_String$().kS(s, arrOffset, arrLength), decIndex, expIndex, index);
}
/** @constructor */
function $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension(outer, r) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension;
/** @constructor */
function $h_Lupickle_implicits_MacroImplicits$ReadWriterExtension() {
}
$h_Lupickle_implicits_MacroImplicits$ReadWriterExtension.prototype = $p;
var $d_Lupickle_implicits_MacroImplicits$ReadWriterExtension = new $TypeData().i($c_Lupickle_implicits_MacroImplicits$ReadWriterExtension, "upickle.implicits.MacroImplicits$ReadWriterExtension", ({
  P9: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$JavaReader$(outer) {
  this.aKR = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aKR = outer;
}
$p = $c_Lupickle_implicits_Readers$JavaReader$.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$JavaReader$;
/** @constructor */
function $h_Lupickle_implicits_Readers$JavaReader$() {
}
$h_Lupickle_implicits_Readers$JavaReader$.prototype = $p;
$p.DI = (function(evidence$1) {
  return new $c_Lupickle_implicits_Readers$JavaReader(this.aKR, evidence$1);
});
$p.m = (function() {
  return "JavaReader";
});
var $d_Lupickle_implicits_Readers$JavaReader$ = new $TypeData().i($c_Lupickle_implicits_Readers$JavaReader$, "upickle.implicits.Readers$JavaReader$", ({
  Py: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Writers$JavaWriter$(outer) {
  this.aL9 = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aL9 = outer;
}
$p = $c_Lupickle_implicits_Writers$JavaWriter$.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Writers$JavaWriter$;
/** @constructor */
function $h_Lupickle_implicits_Writers$JavaWriter$() {
}
$h_Lupickle_implicits_Writers$JavaWriter$.prototype = $p;
$p.DJ = (function(evidence$1) {
  return new $c_Lupickle_implicits_Writers$JavaWriter(this.aL9, evidence$1);
});
$p.m = (function() {
  return "JavaWriter";
});
var $d_Lupickle_implicits_Writers$JavaWriter$ = new $TypeData().i($c_Lupickle_implicits_Writers$JavaWriter$, "upickle.implicits.Writers$JavaWriter$", ({
  PZ: 1
}));
/** @constructor */
function $c_Lapp_tulz_tuplez_Composition\uff3fPri0$$anon$1() {
}
$p = $c_Lapp_tulz_tuplez_Composition\uff3fPri0$$anon$1.prototype = new $h_Lapp_tulz_tuplez_Composition();
$p.constructor = $c_Lapp_tulz_tuplez_Composition\uff3fPri0$$anon$1;
/** @constructor */
function $h_Lapp_tulz_tuplez_Composition\uff3fPri0$$anon$1() {
}
$h_Lapp_tulz_tuplez_Composition\uff3fPri0$$anon$1.prototype = $p;
$p.a2X = (function(a, b) {
  return new $c_T2(a, b);
});
var $d_Lapp_tulz_tuplez_Composition\uff3fPri0$$anon$1 = new $TypeData().i($c_Lapp_tulz_tuplez_Composition\uff3fPri0$$anon$1, "app.tulz.tuplez.Composition_Pri0$$anon$1", ({
  nv: 1,
  d0: 1
}));
/** @constructor */
function $c_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$18() {
}
$p = $c_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$18.prototype = new $h_Lapp_tulz_tuplez_Composition();
$p.constructor = $c_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$18;
/** @constructor */
function $h_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$18() {
}
$h_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$18.prototype = $p;
$p.a2X = (function(a, b) {
  return new $c_T10(a.Nz, a.NA, a.NB, a.NC, a.ND, a.NE, a.NF, a.NG, a.NH, b);
});
var $d_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$18 = new $TypeData().i($c_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$18, "app.tulz.tuplez.Composition_Pri7$$anon$18", ({
  nw: 1,
  d0: 1
}));
/** @constructor */
function $c_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$4() {
}
$p = $c_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$4.prototype = new $h_Lapp_tulz_tuplez_Composition();
$p.constructor = $c_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$4;
/** @constructor */
function $h_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$4() {
}
$h_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$4.prototype = $p;
$p.a2X = (function(a, b) {
  return new $c_T3(a.g(), a.h(), b);
});
var $d_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$4 = new $TypeData().i($c_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$4, "app.tulz.tuplez.Composition_Pri7$$anon$4", ({
  nx: 1,
  d0: 1
}));
function $f_Lcom_raquo_airstream_common_InternalNextErrorObserver__onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V($thiz, nextValue, transaction) {
  nextValue.kO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => {
    $thiz.iq(_$1, transaction);
  })), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => {
    $thiz.iY(_$2, transaction);
  })));
}
var $d_Lcom_raquo_airstream_common_InternalParentObserver = new $TypeData().i(1, "com.raquo.airstream.common.InternalParentObserver", ({
  e8: 1,
  a3: 1
}));
function $f_Lcom_raquo_airstream_common_InternalTryObserver__onNext__O__Lcom_raquo_airstream_core_Transaction__V($thiz, nextValue, transaction) {
  $thiz.it(new $c_s_util_Success(nextValue), transaction);
}
function $f_Lcom_raquo_airstream_common_InternalTryObserver__onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V($thiz, nextError, transaction) {
  $thiz.it(new $c_s_util_Failure(nextError), transaction);
}
/** @constructor */
function $c_Lcom_raquo_airstream_core_InternalObserver$$anon$1() {
}
$p = $c_Lcom_raquo_airstream_core_InternalObserver$$anon$1.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_core_InternalObserver$$anon$1;
/** @constructor */
function $h_Lcom_raquo_airstream_core_InternalObserver$$anon$1() {
}
$h_Lcom_raquo_airstream_core_InternalObserver$$anon$1.prototype = $p;
$p.iY = (function(nextValue, transaction) {
});
$p.iq = (function(nextError, transaction) {
});
$p.it = (function(nextValue, transaction) {
});
var $d_Lcom_raquo_airstream_core_InternalObserver$$anon$1 = new $TypeData().i($c_Lcom_raquo_airstream_core_InternalObserver$$anon$1, "com.raquo.airstream.core.InternalObserver$$anon$1", ({
  nM: 1,
  a3: 1
}));
/** @constructor */
function $c_Lcom_raquo_airstream_core_InternalObserver$$anon$2(onNextParam$2, onErrorParam$2, outer) {
  this.aj6 = null;
  this.aj5 = null;
  this.aj6 = onNextParam$2;
  this.aj5 = onErrorParam$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_raquo_airstream_core_InternalObserver$$anon$2.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_core_InternalObserver$$anon$2;
/** @constructor */
function $h_Lcom_raquo_airstream_core_InternalObserver$$anon$2() {
}
$h_Lcom_raquo_airstream_core_InternalObserver$$anon$2.prototype = $p;
$p.iY = (function(nextValue, transaction) {
  this.aj6.R(nextValue, transaction);
});
$p.iq = (function(nextError, transaction) {
  this.aj5.R(nextError, transaction);
});
$p.it = (function(nextValue, transaction) {
  nextValue.kO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => {
    this.iq(_$1, transaction);
  })), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => {
    this.iY(_$2, transaction);
  })));
});
var $d_Lcom_raquo_airstream_core_InternalObserver$$anon$2 = new $TypeData().i($c_Lcom_raquo_airstream_core_InternalObserver$$anon$2, "com.raquo.airstream.core.InternalObserver$$anon$2", ({
  nN: 1,
  a3: 1
}));
/** @constructor */
function $c_Lcom_raquo_airstream_core_InternalObserver$$anon$3(onTryParam$2, outer) {
  this.aj7 = null;
  this.aj7 = onTryParam$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_raquo_airstream_core_InternalObserver$$anon$3.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_core_InternalObserver$$anon$3;
/** @constructor */
function $h_Lcom_raquo_airstream_core_InternalObserver$$anon$3() {
}
$h_Lcom_raquo_airstream_core_InternalObserver$$anon$3.prototype = $p;
$p.iY = (function(nextValue, transaction) {
  this.it(new $c_s_util_Success(nextValue), transaction);
});
$p.iq = (function(nextError, transaction) {
  this.it(new $c_s_util_Failure(nextError), transaction);
});
$p.it = (function(nextValue, transaction) {
  this.aj7.R(nextValue, transaction);
});
var $d_Lcom_raquo_airstream_core_InternalObserver$$anon$3 = new $TypeData().i($c_Lcom_raquo_airstream_core_InternalObserver$$anon$3, "com.raquo.airstream.core.InternalObserver$$anon$3", ({
  nO: 1,
  a3: 1
}));
/** @constructor */
function $c_Lcom_raquo_airstream_ownership_ManualOwner() {
  this.alg = null;
  $f_Lcom_raquo_airstream_ownership_Owner__$init$__V(this);
}
$p = $c_Lcom_raquo_airstream_ownership_ManualOwner.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_ownership_ManualOwner;
/** @constructor */
function $h_Lcom_raquo_airstream_ownership_ManualOwner() {
}
$h_Lcom_raquo_airstream_ownership_ManualOwner.prototype = $p;
$p.Jq = (function() {
  return this.alg;
});
$p.af1 = (function(x$0) {
  this.alg = x$0;
});
$p.ahm = (function(subscription) {
  $f_Lcom_raquo_airstream_ownership_Owner__own__Lcom_raquo_airstream_ownership_Subscription__V(this, subscription);
});
$p.agM = (function() {
  $f_Lcom_raquo_airstream_ownership_Owner__killSubscriptions__V(this);
});
var $d_Lcom_raquo_airstream_ownership_ManualOwner = new $TypeData().i($c_Lcom_raquo_airstream_ownership_ManualOwner, "com.raquo.airstream.ownership.ManualOwner", ({
  ox: 1,
  d4: 1
}));
/** @constructor */
function $c_Lcom_raquo_airstream_ownership_OneTimeOwner(onAccessAfterKilled) {
  this.ali = null;
  this.alh = null;
  this.a5V = false;
  this.alh = onAccessAfterKilled;
  $f_Lcom_raquo_airstream_ownership_Owner__$init$__V(this);
  this.a5V = false;
}
$p = $c_Lcom_raquo_airstream_ownership_OneTimeOwner.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_ownership_OneTimeOwner;
/** @constructor */
function $h_Lcom_raquo_airstream_ownership_OneTimeOwner() {
}
$h_Lcom_raquo_airstream_ownership_OneTimeOwner.prototype = $p;
$p.Jq = (function() {
  return this.ali;
});
$p.af1 = (function(x$0) {
  this.ali = x$0;
});
$p.ahm = (function(subscription) {
  if (this.a5V) {
    $p_Lcom_raquo_airstream_ownership_Subscription__safeCleanup__V(subscription);
    this.alh.a3();
  } else {
    $f_Lcom_raquo_airstream_ownership_Owner__own__Lcom_raquo_airstream_ownership_Subscription__V(this, subscription);
  }
});
$p.agM = (function() {
  $f_Lcom_raquo_airstream_ownership_Owner__killSubscriptions__V(this);
  this.a5V = true;
});
var $d_Lcom_raquo_airstream_ownership_OneTimeOwner = new $TypeData().i($c_Lcom_raquo_airstream_ownership_OneTimeOwner, "com.raquo.airstream.ownership.OneTimeOwner", ({
  oy: 1,
  d4: 1
}));
function $ps_Lcom_raquo_airstream_web_FetchStream$__FetchStream$$superArg$1__F1() {
  return new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x) => x));
}
function $ps_Lcom_raquo_airstream_web_FetchStream$__FetchStream$$superArg$2__F1() {
  return new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((response) => {
    $m_Lcom_raquo_airstream_core_EventStream$();
    return new $c_Lcom_raquo_airstream_timing_JsPromiseStream(response.text(), ($m_Lcom_raquo_airstream_core_EventStream$(), false));
  }));
}
/** @constructor */
function $c_Lcom_raquo_airstream_web_FetchStream$() {
  this.a6i = null;
  this.a6h = null;
  $ct_Lcom_raquo_airstream_web_FetchBuilder__F1__F1__(this, $ps_Lcom_raquo_airstream_web_FetchStream$__FetchStream$$superArg$1__F1(), $ps_Lcom_raquo_airstream_web_FetchStream$__FetchStream$$superArg$2__F1());
}
$p = $c_Lcom_raquo_airstream_web_FetchStream$.prototype = new $h_Lcom_raquo_airstream_web_FetchBuilder();
$p.constructor = $c_Lcom_raquo_airstream_web_FetchStream$;
/** @constructor */
function $h_Lcom_raquo_airstream_web_FetchStream$() {
}
$h_Lcom_raquo_airstream_web_FetchStream$.prototype = $p;
var $d_Lcom_raquo_airstream_web_FetchStream$ = new $TypeData().i($c_Lcom_raquo_airstream_web_FetchStream$, "com.raquo.airstream.web.FetchStream$", ({
  p1: 1,
  oY: 1
}));
var $n_Lcom_raquo_airstream_web_FetchStream$;
function $m_Lcom_raquo_airstream_web_FetchStream$() {
  if ((!$n_Lcom_raquo_airstream_web_FetchStream$)) {
    $n_Lcom_raquo_airstream_web_FetchStream$ = new $c_Lcom_raquo_airstream_web_FetchStream$();
  }
  return $n_Lcom_raquo_airstream_web_FetchStream$;
}
/** @constructor */
function $c_Lcom_raquo_laminar_api_Laminar$aria$(outer) {
  this.an7 = null;
  this.an8 = false;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_raquo_laminar_api_Laminar$aria$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_api_Laminar$aria$;
/** @constructor */
function $h_Lcom_raquo_laminar_api_Laminar$aria$() {
}
$h_Lcom_raquo_laminar_api_Laminar$aria$.prototype = $p;
$p.Aq = (function() {
  if ((!this.an8)) {
    this.an7 = new $c_Lcom_raquo_laminar_keys_AriaAttr("label", $m_Lcom_raquo_laminar_codecs_package$().bW);
    this.an8 = true;
  }
  return this.an7;
});
var $d_Lcom_raquo_laminar_api_Laminar$aria$ = new $TypeData().i($c_Lcom_raquo_laminar_api_Laminar$aria$, "com.raquo.laminar.api.Laminar$aria$", ({
  pe: 1,
  pr: 1
}));
/** @constructor */
function $c_Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$(outer) {
  this.aoJ = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $f_Lcom_raquo_airstream_ownership_Owner__$init$__V(this);
}
$p = $c_Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$;
/** @constructor */
function $h_Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$() {
}
$h_Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$.prototype = $p;
$p.Jq = (function() {
  return this.aoJ;
});
$p.af1 = (function(x$0) {
  this.aoJ = x$0;
});
$p.agM = (function() {
  $f_Lcom_raquo_airstream_ownership_Owner__killSubscriptions__V(this);
});
$p.ahm = (function(subscription) {
  $f_Lcom_raquo_airstream_ownership_Owner__own__Lcom_raquo_airstream_ownership_Subscription__V(this, subscription);
});
var $d_Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$ = new $TypeData().i($c_Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$, "com.raquo.laminar.api.Laminar$unsafeWindowOwner$", ({
  pg: 1,
  d4: 1
}));
/** @constructor */
function $c_Lcom_raquo_laminar_api_package$features$$anon$3(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_raquo_laminar_api_package$features$$anon$3.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_api_package$features$$anon$3;
/** @constructor */
function $h_Lcom_raquo_laminar_api_package$features$$anon$3() {
}
$h_Lcom_raquo_laminar_api_package$features$$anon$3.prototype = $p;
var $d_Lcom_raquo_laminar_api_package$features$$anon$3 = new $TypeData().i($c_Lcom_raquo_laminar_api_package$features$$anon$3, "com.raquo.laminar.api.package$features$$anon$3", ({
  pn: 1,
  pl: 1
}));
/** @constructor */
function $c_Lcom_raquo_laminar_codecs_package$$anon$1() {
}
$p = $c_Lcom_raquo_laminar_codecs_package$$anon$1.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_codecs_package$$anon$1;
/** @constructor */
function $h_Lcom_raquo_laminar_codecs_package$$anon$1() {
}
$h_Lcom_raquo_laminar_codecs_package$$anon$1.prototype = $p;
$p.aZD = (function(domValue) {
  return (domValue !== null);
});
$p.b0y = (function(scalaValue) {
  return (scalaValue ? "" : null);
});
$p.a37 = (function(domValue) {
  return this.aZD(domValue);
});
$p.IQ = (function(scalaValue) {
  return this.b0y((!(!scalaValue)));
});
var $d_Lcom_raquo_laminar_codecs_package$$anon$1 = new $TypeData().i($c_Lcom_raquo_laminar_codecs_package$$anon$1, "com.raquo.laminar.codecs.package$$anon$1", ({
  pp: 1,
  d6: 1
}));
/** @constructor */
function $c_Lcom_raquo_laminar_codecs_package$$anon$2(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_raquo_laminar_codecs_package$$anon$2.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_codecs_package$$anon$2;
/** @constructor */
function $h_Lcom_raquo_laminar_codecs_package$$anon$2() {
}
$h_Lcom_raquo_laminar_codecs_package$$anon$2.prototype = $p;
$p.IQ = (function(scalaValue) {
  return scalaValue;
});
$p.a37 = (function(domValue) {
  return domValue;
});
var $d_Lcom_raquo_laminar_codecs_package$$anon$2 = new $TypeData().i($c_Lcom_raquo_laminar_codecs_package$$anon$2, "com.raquo.laminar.codecs.package$$anon$2", ({
  pq: 1,
  d6: 1
}));
/** @constructor */
function $c_Lcom_raquo_laminar_keys_AriaAttr(suffix, codec) {
  this.arr = null;
  this.a6v = null;
  this.arr = codec;
  this.a6v = ("aria-" + suffix);
}
$p = $c_Lcom_raquo_laminar_keys_AriaAttr.prototype = new $h_Lcom_raquo_laminar_keys_Key();
$p.constructor = $c_Lcom_raquo_laminar_keys_AriaAttr;
/** @constructor */
function $h_Lcom_raquo_laminar_keys_AriaAttr() {
}
$h_Lcom_raquo_laminar_keys_AriaAttr.prototype = $p;
$p.n = (function(value) {
  return new $c_Lcom_raquo_laminar_modifiers_KeySetter(this, value, new $c_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96(((element, attr, value$2) => {
    $m_Lcom_raquo_laminar_DomApi$().b8z(element, attr, value$2);
  })));
});
var $d_Lcom_raquo_laminar_keys_AriaAttr = new $TypeData().i($c_Lcom_raquo_laminar_keys_AriaAttr, "com.raquo.laminar.keys.AriaAttr", ({
  pN: 1,
  bx: 1
}));
/** @constructor */
function $c_Lcom_raquo_laminar_keys_CompositeKey(name, getRawDomValue, setRawDomValue, separator) {
  this.ars = null;
  this.art = null;
  this.YU = null;
  this.a6w = null;
  this.ars = getRawDomValue;
  this.art = setRawDomValue;
  this.YU = separator;
  this.a6w = new $c_Lcom_raquo_laminar_keys_CompositeKey$CompositeCodec(separator);
}
$p = $c_Lcom_raquo_laminar_keys_CompositeKey.prototype = new $h_Lcom_raquo_laminar_keys_Key();
$p.constructor = $c_Lcom_raquo_laminar_keys_CompositeKey;
/** @constructor */
function $h_Lcom_raquo_laminar_keys_CompositeKey() {
}
$h_Lcom_raquo_laminar_keys_CompositeKey.prototype = $p;
$p.s = (function(items) {
  return new $c_Lcom_raquo_laminar_modifiers_CompositeKeySetter(this, ($m_Lcom_raquo_laminar_api_package$().b.aew(), $m_Lcom_raquo_laminar_keys_CompositeKey$().a4g(items, this.YU)));
});
$p.aLg = (function(value, mapper) {
  return new $c_Lcom_raquo_laminar_modifiers_CompositeKeySetter(this, mapper.aif(value, this.YU));
});
$p.ael = (function(items, valueMapper) {
  return new $c_Lcom_raquo_laminar_modifiers_KeyUpdater(this, items.dM(), new $c_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96(((element, nextRawItems, thisBinder) => {
    var currentNormalizedItems = $f_Lcom_raquo_laminar_nodes_ReactiveElement__compositeValueItems__Lcom_raquo_laminar_keys_CompositeKey__Lcom_raquo_laminar_modifiers_Modifier__sci_List(element, this, thisBinder);
    var nextNormalizedItems = valueMapper.aif(nextRawItems, this.YU);
    var f = ((elem) => currentNormalizedItems.E(elem));
    var l = nextNormalizedItems;
    block: {
      var result;
      while (true) {
        if (l.c()) {
          var result = $m_sci_Nil$();
          break;
        } else {
          var h = l.t();
          var t = l.v();
          if ((!(!f(h)))) {
            l = t;
            continue;
          }
          var start = l;
          var remaining = t;
          while (true) {
            if (remaining.c()) {
              var result = start;
              break block;
            } else {
              var x = remaining.t();
              if ((!(!(!f(x))))) {
                remaining = remaining.v();
                continue;
              }
              var firstMiss = remaining;
              var newHead = new $c_sci_$colon$colon(start.t(), $m_sci_Nil$());
              var toProcess = start.v();
              var currentLast = newHead;
              while ((toProcess !== firstMiss)) {
                var newElem = new $c_sci_$colon$colon(toProcess.t(), $m_sci_Nil$());
                currentLast.U = newElem;
                currentLast = newElem;
                toProcess = toProcess.v();
              }
              var next = firstMiss.v();
              var nextToCopy = next;
              while ((!next.c())) {
                var head = next.t();
                if ((!(!(!f(head))))) {
                  next = next.v();
                } else {
                  while ((nextToCopy !== next)) {
                    var newElem$2 = new $c_sci_$colon$colon(nextToCopy.t(), $m_sci_Nil$());
                    currentLast.U = newElem$2;
                    currentLast = newElem$2;
                    nextToCopy = nextToCopy.v();
                  }
                  nextToCopy = next.v();
                  next = next.v();
                }
              }
              if ((!nextToCopy.c())) {
                currentLast.U = nextToCopy;
              }
              var result = newHead;
              break block;
            }
          }
        }
      }
    }
    var f$1 = ((elem$2) => nextNormalizedItems.E(elem$2));
    var l$1 = currentNormalizedItems;
    block$2: {
      var $x_1;
      while (true) {
        if (l$1.c()) {
          var $x_1 = $m_sci_Nil$();
          break;
        } else {
          var h$1 = l$1.t();
          var t$1 = l$1.v();
          if ((!(!f$1(h$1)))) {
            l$1 = t$1;
            continue;
          }
          var start$1 = l$1;
          var remaining$1 = t$1;
          while (true) {
            if (remaining$1.c()) {
              var $x_1 = start$1;
              break block$2;
            } else {
              var x$1 = remaining$1.t();
              if ((!(!(!f$1(x$1))))) {
                remaining$1 = remaining$1.v();
                continue;
              }
              var firstMiss$1 = remaining$1;
              var newHead$1 = new $c_sci_$colon$colon(start$1.t(), $m_sci_Nil$());
              var toProcess$1 = start$1.v();
              var currentLast$1 = newHead$1;
              while ((toProcess$1 !== firstMiss$1)) {
                var newElem$1 = new $c_sci_$colon$colon(toProcess$1.t(), $m_sci_Nil$());
                currentLast$1.U = newElem$1;
                currentLast$1 = newElem$1;
                toProcess$1 = toProcess$1.v();
              }
              var next$1 = firstMiss$1.v();
              var nextToCopy$1 = next$1;
              while ((!next$1.c())) {
                var head$1 = next$1.t();
                if ((!(!(!f$1(head$1))))) {
                  next$1 = next$1.v();
                } else {
                  while ((nextToCopy$1 !== next$1)) {
                    var newElem$2$1 = new $c_sci_$colon$colon(nextToCopy$1.t(), $m_sci_Nil$());
                    currentLast$1.U = newElem$2$1;
                    currentLast$1 = newElem$2$1;
                    nextToCopy$1 = nextToCopy$1.v();
                  }
                  nextToCopy$1 = next$1.v();
                  next$1 = next$1.v();
                }
              }
              if ((!nextToCopy$1.c())) {
                currentLast$1.U = nextToCopy$1;
              }
              var $x_1 = newHead$1;
              break block$2;
            }
          }
        }
      }
    }
    $f_Lcom_raquo_laminar_nodes_ReactiveElement__updateCompositeValue__Lcom_raquo_laminar_keys_CompositeKey__Lcom_raquo_laminar_modifiers_Modifier__sci_List__sci_List__V(element, this, thisBinder, result, $x_1);
  })));
});
var $d_Lcom_raquo_laminar_keys_CompositeKey = new $TypeData().i($c_Lcom_raquo_laminar_keys_CompositeKey, "com.raquo.laminar.keys.CompositeKey", ({
  pO: 1,
  bx: 1
}));
/** @constructor */
function $c_Lcom_raquo_laminar_keys_CompositeKey$CompositeCodec(separator) {
  this.a6x = null;
  this.a6x = separator;
}
$p = $c_Lcom_raquo_laminar_keys_CompositeKey$CompositeCodec.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_keys_CompositeKey$CompositeCodec;
/** @constructor */
function $h_Lcom_raquo_laminar_keys_CompositeKey$CompositeCodec() {
}
$h_Lcom_raquo_laminar_keys_CompositeKey$CompositeCodec.prototype = $p;
$p.aNk = (function(domValue) {
  return $m_Lcom_raquo_laminar_keys_CompositeKey$().a4g(domValue, this.a6x);
});
$p.aNI = (function(scalaValue) {
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(scalaValue, "", this.a6x, "");
});
$p.a37 = (function(domValue) {
  return this.aNk(domValue);
});
$p.IQ = (function(scalaValue) {
  return this.aNI(scalaValue);
});
var $d_Lcom_raquo_laminar_keys_CompositeKey$CompositeCodec = new $TypeData().i($c_Lcom_raquo_laminar_keys_CompositeKey$CompositeCodec, "com.raquo.laminar.keys.CompositeKey$CompositeCodec", ({
  pQ: 1,
  d6: 1
}));
/** @constructor */
function $c_Lcom_raquo_laminar_keys_CompositeKey$CompositeValueMappers$StringSeqValueMapper$(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_raquo_laminar_keys_CompositeKey$CompositeValueMappers$StringSeqValueMapper$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_keys_CompositeKey$CompositeValueMappers$StringSeqValueMapper$;
/** @constructor */
function $h_Lcom_raquo_laminar_keys_CompositeKey$CompositeValueMappers$StringSeqValueMapper$() {
}
$h_Lcom_raquo_laminar_keys_CompositeKey$CompositeValueMappers$StringSeqValueMapper$.prototype = $p;
$p.ba9 = (function(items, separator) {
  var this$1 = items.bM();
  var rest = this$1;
  var h = null;
  var t = null;
  while ((rest !== $m_sci_Nil$())) {
    var it = $m_Lcom_raquo_laminar_keys_CompositeKey$().a4g(rest.t(), separator).o();
    while (it.p()) {
      var nx = new $c_sci_$colon$colon(it.q(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        t.U = nx;
      }
      t = nx;
    }
    rest = rest.v();
  }
  return ((h === null) ? $m_sci_Nil$() : h);
});
$p.aif = (function(value, separator) {
  return this.ba9(value, separator);
});
var $d_Lcom_raquo_laminar_keys_CompositeKey$CompositeValueMappers$StringSeqValueMapper$ = new $TypeData().i($c_Lcom_raquo_laminar_keys_CompositeKey$CompositeValueMappers$StringSeqValueMapper$, "com.raquo.laminar.keys.CompositeKey$CompositeValueMappers$StringSeqValueMapper$", ({
  pR: 1,
  em: 1
}));
/** @constructor */
function $c_Lcom_raquo_laminar_keys_CompositeKey$CompositeValueMappers$StringValueMapper$(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_raquo_laminar_keys_CompositeKey$CompositeValueMappers$StringValueMapper$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_keys_CompositeKey$CompositeValueMappers$StringValueMapper$;
/** @constructor */
function $h_Lcom_raquo_laminar_keys_CompositeKey$CompositeValueMappers$StringValueMapper$() {
}
$h_Lcom_raquo_laminar_keys_CompositeKey$CompositeValueMappers$StringValueMapper$.prototype = $p;
$p.aif = (function(value, separator) {
  return $m_Lcom_raquo_laminar_keys_CompositeKey$().a4g(value, separator);
});
var $d_Lcom_raquo_laminar_keys_CompositeKey$CompositeValueMappers$StringValueMapper$ = new $TypeData().i($c_Lcom_raquo_laminar_keys_CompositeKey$CompositeValueMappers$StringValueMapper$, "com.raquo.laminar.keys.CompositeKey$CompositeValueMappers$StringValueMapper$", ({
  pS: 1,
  em: 1
}));
/** @constructor */
function $c_Lcom_raquo_laminar_keys_EventProp(name) {
  this.m8 = null;
  this.m8 = name;
}
$p = $c_Lcom_raquo_laminar_keys_EventProp.prototype = new $h_Lcom_raquo_laminar_keys_Key();
$p.constructor = $c_Lcom_raquo_laminar_keys_EventProp;
/** @constructor */
function $h_Lcom_raquo_laminar_keys_EventProp() {
}
$h_Lcom_raquo_laminar_keys_EventProp.prototype = $p;
var $d_Lcom_raquo_laminar_keys_EventProp = new $TypeData().i($c_Lcom_raquo_laminar_keys_EventProp, "com.raquo.laminar.keys.EventProp", ({
  pV: 1,
  bx: 1
}));
/** @constructor */
function $c_Lcom_raquo_laminar_keys_HtmlAttr(name, codec) {
  this.QO = null;
  this.a6y = null;
  this.QO = name;
  this.a6y = codec;
}
$p = $c_Lcom_raquo_laminar_keys_HtmlAttr.prototype = new $h_Lcom_raquo_laminar_keys_Key();
$p.constructor = $c_Lcom_raquo_laminar_keys_HtmlAttr;
/** @constructor */
function $h_Lcom_raquo_laminar_keys_HtmlAttr() {
}
$h_Lcom_raquo_laminar_keys_HtmlAttr.prototype = $p;
$p.n = (function(value) {
  return new $c_Lcom_raquo_laminar_modifiers_KeySetter(this, value, new $c_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96(((element, attr, value$2) => {
    $m_Lcom_raquo_laminar_DomApi$().ahZ(element, attr, value$2);
  })));
});
$p.bj = (function(values) {
  return new $c_Lcom_raquo_laminar_modifiers_KeyUpdater(this, values.dM(), new $c_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96(((el, v, _$1) => {
    $m_Lcom_raquo_laminar_DomApi$().ahZ(el, this, v);
  })));
});
var $d_Lcom_raquo_laminar_keys_HtmlAttr = new $TypeData().i($c_Lcom_raquo_laminar_keys_HtmlAttr, "com.raquo.laminar.keys.HtmlAttr", ({
  pW: 1,
  bx: 1
}));
/** @constructor */
function $c_Lcom_raquo_laminar_keys_HtmlProp(name, codec) {
  this.oK = null;
  this.a6z = null;
  this.oK = name;
  this.a6z = codec;
}
$p = $c_Lcom_raquo_laminar_keys_HtmlProp.prototype = new $h_Lcom_raquo_laminar_keys_Key();
$p.constructor = $c_Lcom_raquo_laminar_keys_HtmlProp;
/** @constructor */
function $h_Lcom_raquo_laminar_keys_HtmlProp() {
}
$h_Lcom_raquo_laminar_keys_HtmlProp.prototype = $p;
$p.n = (function(value) {
  return new $c_Lcom_raquo_laminar_modifiers_KeySetter(this, value, new $c_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96(((element, prop, value$2) => {
    $m_Lcom_raquo_laminar_DomApi$().aS6(element, prop, value$2);
  })));
});
$p.b4o = (function(value) {
  return $f_Lcom_raquo_laminar_api_Implicits__optionToSetter__s_Option__Lcom_raquo_laminar_modifiers_Setter($m_Lcom_raquo_laminar_api_package$().b, (value.c() ? $m_s_None$() : new $c_s_Some(this.n(value.d()))));
});
$p.bj = (function(values) {
  var update = ((this.oK === "value") ? new $c_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96(((element, nextValue, reason) => {
    var nextDomValue = this.a6z.IQ(nextValue);
    var x = $m_Lcom_raquo_laminar_DomApi$().b25(element, this);
    if ((!((x !== (void 0)) && $m_sr_BoxesRunTime$().Q(nextDomValue, x)))) {
      $m_Lcom_raquo_laminar_DomApi$().aS7(element, this, nextDomValue);
    }
  })) : new $c_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96(((element$2, nextValue$2, reason$2) => {
    $m_Lcom_raquo_laminar_DomApi$().aS6(element$2, this, nextValue$2);
  })));
  return new $c_Lcom_raquo_laminar_modifiers_KeyUpdater(this, values.dM(), update);
});
function $isArrayOf_Lcom_raquo_laminar_keys_HtmlProp(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eo)));
}
var $d_Lcom_raquo_laminar_keys_HtmlProp = new $TypeData().i($c_Lcom_raquo_laminar_keys_HtmlProp, "com.raquo.laminar.keys.HtmlProp", ({
  eo: 1,
  bx: 1
}));
/** @constructor */
function $c_Lcom_raquo_laminar_keys_SvgAttr(localName, codec, namespacePrefix) {
  this.a6B = null;
  this.a6A = null;
  this.QP = null;
  this.YV = null;
  this.a6B = localName;
  this.a6A = codec;
  var this$1 = (namespacePrefix.c() ? $m_s_None$() : new $c_s_Some(((namespacePrefix.d() + ":") + localName)));
  this.QP = (this$1.c() ? localName : this$1.d());
  this.YV = (namespacePrefix.c() ? $m_s_None$() : new $c_s_Some($m_Lcom_raquo_laminar_keys_SvgAttr$().b4J(namespacePrefix.d())));
}
$p = $c_Lcom_raquo_laminar_keys_SvgAttr.prototype = new $h_Lcom_raquo_laminar_keys_Key();
$p.constructor = $c_Lcom_raquo_laminar_keys_SvgAttr;
/** @constructor */
function $h_Lcom_raquo_laminar_keys_SvgAttr() {
}
$h_Lcom_raquo_laminar_keys_SvgAttr.prototype = $p;
$p.n = (function(value) {
  return new $c_Lcom_raquo_laminar_modifiers_KeySetter(this, value, new $c_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96(((element, attr, value$2) => {
    $m_Lcom_raquo_laminar_DomApi$().ai0(element, attr, value$2);
  })));
});
$p.bj = (function(values) {
  return new $c_Lcom_raquo_laminar_modifiers_KeyUpdater(this, values.dM(), new $c_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96(((el, v, _$2) => {
    $m_Lcom_raquo_laminar_DomApi$().ai0(el, this, v);
  })));
});
var $d_Lcom_raquo_laminar_keys_SvgAttr = new $TypeData().i($c_Lcom_raquo_laminar_keys_SvgAttr, "com.raquo.laminar.keys.SvgAttr", ({
  pY: 1,
  bx: 1
}));
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_Modifier$$anon$1() {
}
$p = $c_Lcom_raquo_laminar_modifiers_Modifier$$anon$1.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_modifiers_Modifier$$anon$1;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_Modifier$$anon$1() {
}
$h_Lcom_raquo_laminar_modifiers_Modifier$$anon$1.prototype = $p;
$p.kL = (function(element) {
});
var $d_Lcom_raquo_laminar_modifiers_Modifier$$anon$1 = new $TypeData().i($c_Lcom_raquo_laminar_modifiers_Modifier$$anon$1, "com.raquo.laminar.modifiers.Modifier$$anon$1", ({
  q8: 1,
  ar: 1
}));
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_Modifier$$anon$2(f$2, outer) {
  this.arD = null;
  this.arD = f$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_raquo_laminar_modifiers_Modifier$$anon$2.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_modifiers_Modifier$$anon$2;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_Modifier$$anon$2() {
}
$h_Lcom_raquo_laminar_modifiers_Modifier$$anon$2.prototype = $p;
$p.kL = (function(element) {
  var this$2 = $m_Lcom_raquo_airstream_core_Transaction$onStart$();
  var f = (() => {
    this.arD.i(element);
  });
  $m_Lcom_raquo_airstream_core_Transaction$onStart$();
  var when = true;
  if ((this$2.ky || (!when))) {
    f();
  } else {
    this$2.ky = true;
    try {
      f();
    } finally {
      this$2.ky = false;
      $p_Lcom_raquo_airstream_core_Transaction$onStart$__resolve__V(this$2);
    }
  }
});
var $d_Lcom_raquo_laminar_modifiers_Modifier$$anon$2 = new $TypeData().i($c_Lcom_raquo_laminar_modifiers_Modifier$$anon$2, "com.raquo.laminar.modifiers.Modifier$$anon$2", ({
  q9: 1,
  ar: 1
}));
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_RenderableNode$$anon$1() {
}
$p = $c_Lcom_raquo_laminar_modifiers_RenderableNode$$anon$1.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_modifiers_RenderableNode$$anon$1;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_RenderableNode$$anon$1() {
}
$h_Lcom_raquo_laminar_modifiers_RenderableNode$$anon$1.prototype = $p;
var $d_Lcom_raquo_laminar_modifiers_RenderableNode$$anon$1 = new $TypeData().i($c_Lcom_raquo_laminar_modifiers_RenderableNode$$anon$1, "com.raquo.laminar.modifiers.RenderableNode$$anon$1", ({
  qc: 1,
  qa: 1
}));
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$() {
}
$p = $c_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$() {
}
$h_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$.prototype = $p;
$p.Q3 = (function(values) {
  $m_Lcom_raquo_laminar_Seq$();
  return new $c_Lcom_raquo_laminar_Seq(values, null, null);
});
var $d_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$ = new $TypeData().i($c_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$, "com.raquo.laminar.modifiers.RenderableSeq$collectionSeqRenderable$", ({
  qd: 1,
  ep: 1
}));
var $n_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$;
function $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$() {
  if ((!$n_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$)) {
    $n_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$ = new $c_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$();
  }
  return $n_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$;
}
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_RenderableSeq$laminarSeqRenderable$() {
}
$p = $c_Lcom_raquo_laminar_modifiers_RenderableSeq$laminarSeqRenderable$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_modifiers_RenderableSeq$laminarSeqRenderable$;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_RenderableSeq$laminarSeqRenderable$() {
}
$h_Lcom_raquo_laminar_modifiers_RenderableSeq$laminarSeqRenderable$.prototype = $p;
$p.Q3 = (function(values) {
  return values;
});
var $d_Lcom_raquo_laminar_modifiers_RenderableSeq$laminarSeqRenderable$ = new $TypeData().i($c_Lcom_raquo_laminar_modifiers_RenderableSeq$laminarSeqRenderable$, "com.raquo.laminar.modifiers.RenderableSeq$laminarSeqRenderable$", ({
  qe: 1,
  ep: 1
}));
var $n_Lcom_raquo_laminar_modifiers_RenderableSeq$laminarSeqRenderable$;
function $m_Lcom_raquo_laminar_modifiers_RenderableSeq$laminarSeqRenderable$() {
  if ((!$n_Lcom_raquo_laminar_modifiers_RenderableSeq$laminarSeqRenderable$)) {
    $n_Lcom_raquo_laminar_modifiers_RenderableSeq$laminarSeqRenderable$ = new $c_Lcom_raquo_laminar_modifiers_RenderableSeq$laminarSeqRenderable$();
  }
  return $n_Lcom_raquo_laminar_modifiers_RenderableSeq$laminarSeqRenderable$;
}
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(render$2, outer) {
  this.arE = null;
  this.arE = render$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1() {
}
$h_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1.prototype = $p;
$p.aeP = (function(value) {
  return this.arE.i(value);
});
var $d_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1 = new $TypeData().i($c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1, "com.raquo.laminar.modifiers.RenderableText$$anon$1", ({
  qh: 1,
  qf: 1
}));
function $f_Lcom_raquo_laminar_nodes_ParentNode__$init$__V($thiz) {
  $thiz.af3(new $c_Lcom_raquo_airstream_ownership_DynamicOwner(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
    throw $ct_jl_Exception__T__(new $c_jl_Exception(), ("Attempting to use owner of unmounted element: " + $f_sc_IterableOnceOps__mkString__T__T__T__T($m_Lcom_raquo_laminar_DomApi$().aZz($thiz.ed(), ($m_Lcom_raquo_laminar_DomApi$(), $m_sci_Nil$())), "", " > ", "")));
  }))));
}
/** @constructor */
function $c_Lcom_raquo_laminar_tags_HtmlTag(name, void$1) {
  this.Z0 = null;
  this.Z0 = name;
}
$p = $c_Lcom_raquo_laminar_tags_HtmlTag.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_tags_HtmlTag;
/** @constructor */
function $h_Lcom_raquo_laminar_tags_HtmlTag() {
}
$h_Lcom_raquo_laminar_tags_HtmlTag.prototype = $p;
$p.bE = (function() {
  return this.Z0;
});
$p.w = (function(modifiers) {
  var element = this.aY2();
  modifiers.F(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((modifier) => {
    modifier.kL(element);
  })));
  return element;
});
$p.aY2 = (function() {
  return new $c_Lcom_raquo_laminar_nodes_ReactiveHtmlElement(this, $m_Lcom_raquo_laminar_DomApi$().aZs(this));
});
var $d_Lcom_raquo_laminar_tags_HtmlTag = new $TypeData().i($c_Lcom_raquo_laminar_tags_HtmlTag, "com.raquo.laminar.tags.HtmlTag", ({
  qA: 1,
  es: 1
}));
/** @constructor */
function $c_Lcom_raquo_laminar_tags_SvgTag(name, void$1) {
  this.Z1 = null;
  this.Z1 = name;
}
$p = $c_Lcom_raquo_laminar_tags_SvgTag.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_tags_SvgTag;
/** @constructor */
function $h_Lcom_raquo_laminar_tags_SvgTag() {
}
$h_Lcom_raquo_laminar_tags_SvgTag.prototype = $p;
$p.bE = (function() {
  return this.Z1;
});
$p.O = (function(modifiers) {
  var element = this.aY3();
  modifiers.F(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((modifier) => {
    modifier.kL(element);
  })));
  return element;
});
$p.aY3 = (function() {
  return new $c_Lcom_raquo_laminar_nodes_ReactiveSvgElement(this, $m_Lcom_raquo_laminar_DomApi$().aNd(this));
});
var $d_Lcom_raquo_laminar_tags_SvgTag = new $TypeData().i($c_Lcom_raquo_laminar_tags_SvgTag, "com.raquo.laminar.tags.SvgTag", ({
  qB: 1,
  es: 1
}));
/** @constructor */
function $c_Lcom_softwaremill_quicklens_package$QuicklensFunctor$given\uff3fQuicklensFunctor\uff3fS() {
}
$p = $c_Lcom_softwaremill_quicklens_package$QuicklensFunctor$given\uff3fQuicklensFunctor\uff3fS.prototype = new $h_O();
$p.constructor = $c_Lcom_softwaremill_quicklens_package$QuicklensFunctor$given\uff3fQuicklensFunctor\uff3fS;
/** @constructor */
function $h_Lcom_softwaremill_quicklens_package$QuicklensFunctor$given\uff3fQuicklensFunctor\uff3fS() {
}
$h_Lcom_softwaremill_quicklens_package$QuicklensFunctor$given\uff3fQuicklensFunctor\uff3fS.prototype = $p;
var $d_Lcom_softwaremill_quicklens_package$QuicklensFunctor$given\uff3fQuicklensFunctor\uff3fS = new $TypeData().i($c_Lcom_softwaremill_quicklens_package$QuicklensFunctor$given\uff3fQuicklensFunctor\uff3fS, "com.softwaremill.quicklens.package$QuicklensFunctor$given_QuicklensFunctor_S", ({
  qD: 1,
  qC: 1
}));
function $is_Lfansi_Attr(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.bN)));
}
function $isArrayOf_Lfansi_Attr(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bN)));
}
var $d_Lfansi_Attr = new $TypeData().i(1, "fansi.Attr", ({
  bN: 1,
  ch: 1
}));
/** @constructor */
function $c_Lfansi_Attrs$Multiple(resetMask_$_lo, resetMask_$_hi, applyMask_$_lo, applyMask_$_hi, attrs) {
  this.aLc = 0;
  this.aLd = 0;
  this.aLa = 0;
  this.aLb = 0;
  this.yx = null;
  this.aLc = resetMask_$_lo;
  this.aLd = resetMask_$_hi;
  this.aLa = applyMask_$_lo;
  this.aLb = applyMask_$_hi;
  this.yx = attrs;
  if ((attrs.C() === 1)) {
    $m_sr_Scala3RunTime$().Wl();
  }
}
$p = $c_Lfansi_Attrs$Multiple.prototype = new $h_O();
$p.constructor = $c_Lfansi_Attrs$Multiple;
/** @constructor */
function $h_Lfansi_Attrs$Multiple() {
}
$h_Lfansi_Attrs$Multiple.prototype = $p;
$p.XT = (function() {
  return $bL(this.aLc, this.aLd);
});
$p.OY = (function() {
  return $bL(this.aLa, this.aLb);
});
$p.x = (function() {
  return this.yx.x();
});
$p.e = (function(other) {
  if ($is_Lfansi_Attr(this)) {
    if ($is_Lfansi_Attr(other)) {
      return (this === other);
    }
    if ((other instanceof $c_Lfansi_Attrs$Multiple)) {
      if ((other.yx.C() === 1)) {
        return (this === other.yx.l(0));
      }
    }
  }
  if ($is_Lfansi_Attr(other)) {
    if ((this.yx.C() === 1)) {
      return (this.yx.l(0) === other);
    }
  }
  if ((other instanceof $c_Lfansi_Attrs$Multiple)) {
    return (this.yx === other.yx);
  }
  return false;
});
$p.m = (function() {
  return (("Attrs(" + $f_sc_IterableOnceOps__mkString__T__T__T__T(this.yx, "", ",", "")) + ")");
});
function $isArrayOf_Lfansi_Attrs$Multiple(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eu)));
}
var $d_Lfansi_Attrs$Multiple = new $TypeData().i($c_Lfansi_Attrs$Multiple, "fansi.Attrs$Multiple", ({
  eu: 1,
  ch: 1
}));
/** @constructor */
function $c_Lfansi_Bold$() {
  this.pK = 0;
  this.yz = 0;
  this.yy = null;
  this.AT = null;
  this.AU = false;
  this.asb = null;
  this.asa = null;
  this.asc = null;
  $ct_Lfansi_Category__I__I__Lsourcecode_Name__(this, 0, 1, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Bold")));
  $n_Lfansi_Bold$ = this;
  this.asb = this.dV("\u001b[1m", 1, 0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("On")));
  this.asa = this.b4e(0, 0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Off")));
  this.asc = $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lfansi_Attr.r().C)([this.asb, this.asa])));
}
$p = $c_Lfansi_Bold$.prototype = new $h_Lfansi_Category();
$p.constructor = $c_Lfansi_Bold$;
/** @constructor */
function $h_Lfansi_Bold$() {
}
$h_Lfansi_Bold$.prototype = $p;
$p.OW = (function() {
  return this.asc;
});
var $d_Lfansi_Bold$ = new $TypeData().i($c_Lfansi_Bold$, "fansi.Bold$", ({
  qH: 1,
  by: 1
}));
var $n_Lfansi_Bold$;
function $m_Lfansi_Bold$() {
  if ((!$n_Lfansi_Bold$)) {
    $n_Lfansi_Bold$ = new $c_Lfansi_Bold$();
  }
  return $n_Lfansi_Bold$;
}
function $ct_Lfansi_ColorCategory__I__I__I__Lsourcecode_Name__($thiz, offset, width, colorCode, catName) {
  $thiz.QV = offset;
  $thiz.Z5 = colorCode;
  $ct_Lfansi_Category__I__I__Lsourcecode_Name__($thiz, offset, width, catName);
  var b = $m_sci_IndexedSeq$().b5();
  var it = new $c_sci_RangeIterator(0, 1, 255, false);
  while (it.g0) {
    var x0 = it.hp();
    var x = ((17 + x0) | 0);
    var hi = (x >> 31);
    b.Y($thiz.dV((((("\u001b[" + colorCode) + ";5;") + x0) + "m"), x, hi, $m_Lsourcecode_Name$().a5h((("Full(" + x0) + ")"))));
  }
  $thiz.QU = b.aR();
  return $thiz;
}
function $p_Lfansi_ColorCategory__True0__I__I__I__I__Lfansi_EscapeAttr($thiz, r, g, b, index) {
  var $x_1 = $thiz.aT4(r, g, b);
  var x = ((273 + index) | 0);
  var hi = (x >> 31);
  return $thiz.dV($x_1, x, hi, $m_Lsourcecode_Name$().a5h((((((("True(" + r) + ",") + g) + ",") + b) + ")")));
}
/** @constructor */
function $c_Lfansi_ColorCategory() {
  this.pK = 0;
  this.yz = 0;
  this.yy = null;
  this.AT = null;
  this.AU = false;
  this.QV = 0;
  this.Z5 = 0;
  this.QU = null;
}
$p = $c_Lfansi_ColorCategory.prototype = new $h_Lfansi_Category();
$p.constructor = $c_Lfansi_ColorCategory;
/** @constructor */
function $h_Lfansi_ColorCategory() {
}
$h_Lfansi_ColorCategory.prototype = $p;
$p.aT4 = (function(r, g, b) {
  return (((((((("\u001b[" + this.Z5) + ";2;") + r) + ";") + g) + ";") + b) + "m");
});
$p.aWr = (function(index) {
  if ((!((index >>> 0) <= 16777216))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("requirement failed: " + "True parameter `index` must be 273 <= index <= 16777488, not ") + index));
  }
  return $p_Lfansi_ColorCategory__True0__I__I__I__I__Lfansi_EscapeAttr(this, (index >> 16), (255 & (index >> 8)), (255 & index), index);
});
$p.bax = (function(r, g, b) {
  if ((!((r >>> 0) <= 255))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("requirement failed: " + "True parameter `r` must be 0 <= r < 256, not ") + r));
  }
  if ((!((g >>> 0) <= 255))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("requirement failed: " + "True parameter `g` must be 0 <= r < 256, not ") + g));
  }
  if ((!((b >>> 0) <= 255))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("requirement failed: " + "True parameter `b` must be 0 <= r < 256, not ") + b));
  }
  return (((r << 16) | (g << 8)) | b);
});
$p.agX = (function(applyState_$_lo, applyState_$_hi) {
  var n = this.QV;
  var lo = (((32 & n) === 0) ? (((applyState_$_lo >>> n) | 0) | ((applyState_$_hi << 1) << (~n))) : (applyState_$_hi >> n));
  if ((lo < 273)) {
    return $c_Lfansi_Category.prototype.agX.call(this, applyState_$_lo, applyState_$_hi);
  } else {
    var index = ((lo - 273) | 0);
    return this.aT4((index >> 16), (255 & (index >> 8)), (255 & index));
  }
});
$p.aQ1 = (function(applyState_$_lo, applyState_$_hi) {
  var n = this.QV;
  var lo = (((32 & n) === 0) ? (((applyState_$_lo >>> n) | 0) | ((applyState_$_hi << 1) << (~n))) : (applyState_$_hi >> n));
  return ((lo < 273) ? this.aQ2().a[lo] : this.aWr(((lo - 273) | 0)));
});
$p.aQ3 = (function() {
  return 273;
});
/** @constructor */
function $c_Lfansi_Reversed$() {
  this.pK = 0;
  this.yz = 0;
  this.yy = null;
  this.AT = null;
  this.AU = false;
  this.asw = null;
  this.asv = null;
  this.asx = null;
  $ct_Lfansi_Category__I__I__Lsourcecode_Name__(this, 1, 1, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Reversed")));
  $n_Lfansi_Reversed$ = this;
  this.asw = this.dV("\u001b[7m", 1, 0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("On")));
  this.asv = this.dV("\u001b[27m", 0, 0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Off")));
  this.asx = $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lfansi_EscapeAttr.r().C)([this.asw, this.asv])));
}
$p = $c_Lfansi_Reversed$.prototype = new $h_Lfansi_Category();
$p.constructor = $c_Lfansi_Reversed$;
/** @constructor */
function $h_Lfansi_Reversed$() {
}
$h_Lfansi_Reversed$.prototype = $p;
$p.OW = (function() {
  return this.asx;
});
var $d_Lfansi_Reversed$ = new $TypeData().i($c_Lfansi_Reversed$, "fansi.Reversed$", ({
  qL: 1,
  by: 1
}));
var $n_Lfansi_Reversed$;
function $m_Lfansi_Reversed$() {
  if ((!$n_Lfansi_Reversed$)) {
    $n_Lfansi_Reversed$ = new $c_Lfansi_Reversed$();
  }
  return $n_Lfansi_Reversed$;
}
/** @constructor */
function $c_Lfansi_Underlined$() {
  this.pK = 0;
  this.yz = 0;
  this.yy = null;
  this.AT = null;
  this.AU = false;
  this.asF = null;
  this.asE = null;
  this.asG = null;
  $ct_Lfansi_Category__I__I__Lsourcecode_Name__(this, 2, 1, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Underlined")));
  $n_Lfansi_Underlined$ = this;
  this.asF = this.dV("\u001b[4m", 1, 0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("On")));
  this.asE = this.dV("\u001b[24m", 0, 0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Off")));
  this.asG = $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lfansi_EscapeAttr.r().C)([this.asF, this.asE])));
}
$p = $c_Lfansi_Underlined$.prototype = new $h_Lfansi_Category();
$p.constructor = $c_Lfansi_Underlined$;
/** @constructor */
function $h_Lfansi_Underlined$() {
}
$h_Lfansi_Underlined$.prototype = $p;
$p.OW = (function() {
  return this.asG;
});
var $d_Lfansi_Underlined$ = new $TypeData().i($c_Lfansi_Underlined$, "fansi.Underlined$", ({
  qO: 1,
  by: 1
}));
var $n_Lfansi_Underlined$;
function $m_Lfansi_Underlined$() {
  if ((!$n_Lfansi_Underlined$)) {
    $n_Lfansi_Underlined$ = new $c_Lfansi_Underlined$();
  }
  return $n_Lfansi_Underlined$;
}
/** @constructor */
function $c_Lfastparse_Implicits$LowPriOptioner$GenericOptionerImplicit0$(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lfastparse_Implicits$LowPriOptioner$GenericOptionerImplicit0$.prototype = new $h_O();
$p.constructor = $c_Lfastparse_Implicits$LowPriOptioner$GenericOptionerImplicit0$;
/** @constructor */
function $h_Lfastparse_Implicits$LowPriOptioner$GenericOptionerImplicit0$() {
}
$h_Lfastparse_Implicits$LowPriOptioner$GenericOptionerImplicit0$.prototype = $p;
var $d_Lfastparse_Implicits$LowPriOptioner$GenericOptionerImplicit0$ = new $TypeData().i($c_Lfastparse_Implicits$LowPriOptioner$GenericOptionerImplicit0$, "fastparse.Implicits$LowPriOptioner$GenericOptionerImplicit0$", ({
  qQ: 1,
  qW: 1
}));
/** @constructor */
function $c_Lfastparse_Implicits$LowPriRepeater$GenericRepeatedImplicit0$(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lfastparse_Implicits$LowPriRepeater$GenericRepeatedImplicit0$.prototype = new $h_O();
$p.constructor = $c_Lfastparse_Implicits$LowPriRepeater$GenericRepeatedImplicit0$;
/** @constructor */
function $h_Lfastparse_Implicits$LowPriRepeater$GenericRepeatedImplicit0$() {
}
$h_Lfastparse_Implicits$LowPriRepeater$GenericRepeatedImplicit0$.prototype = $p;
$p.qQ = (function(t, acc) {
  acc.Y(t);
});
$p.ra = (function(acc) {
  return $m_sci_Seq$().fw(acc);
});
var $d_Lfastparse_Implicits$LowPriRepeater$GenericRepeatedImplicit0$ = new $TypeData().i($c_Lfastparse_Implicits$LowPriRepeater$GenericRepeatedImplicit0$, "fastparse.Implicits$LowPriRepeater$GenericRepeatedImplicit0$", ({
  qS: 1,
  ez: 1
}));
/** @constructor */
function $c_Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$.prototype = new $h_O();
$p.constructor = $c_Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$;
/** @constructor */
function $h_Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$() {
}
$h_Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$.prototype = $p;
$p.R = (function(t, v) {
  return t;
});
var $d_Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$ = new $TypeData().i($c_Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$, "fastparse.Implicits$LowPriSequencer$UnitSequencer0$", ({
  qU: 1,
  eA: 1
}));
/** @constructor */
function $c_Lfastparse_Implicits$Optioner$() {
  this.asH = null;
  this.asI = false;
}
$p = $c_Lfastparse_Implicits$Optioner$.prototype = new $h_O();
$p.constructor = $c_Lfastparse_Implicits$Optioner$;
/** @constructor */
function $h_Lfastparse_Implicits$Optioner$() {
}
$h_Lfastparse_Implicits$Optioner$.prototype = $p;
$p.W7 = (function() {
  if ((!this.asI)) {
    this.asH = new $c_Lfastparse_Implicits$LowPriOptioner$GenericOptionerImplicit0$(this);
    this.asI = true;
  }
  return this.asH;
});
var $d_Lfastparse_Implicits$Optioner$ = new $TypeData().i($c_Lfastparse_Implicits$Optioner$, "fastparse.Implicits$Optioner$", ({
  qX: 1,
  qP: 1
}));
var $n_Lfastparse_Implicits$Optioner$;
function $m_Lfastparse_Implicits$Optioner$() {
  if ((!$n_Lfastparse_Implicits$Optioner$)) {
    $n_Lfastparse_Implicits$Optioner$ = new $c_Lfastparse_Implicits$Optioner$();
  }
  return $n_Lfastparse_Implicits$Optioner$;
}
/** @constructor */
function $c_Lfastparse_Implicits$Repeater$() {
  this.asJ = null;
  this.asK = false;
}
$p = $c_Lfastparse_Implicits$Repeater$.prototype = new $h_O();
$p.constructor = $c_Lfastparse_Implicits$Repeater$;
/** @constructor */
function $h_Lfastparse_Implicits$Repeater$() {
}
$h_Lfastparse_Implicits$Repeater$.prototype = $p;
$p.Ad = (function() {
  if ((!this.asK)) {
    this.asJ = new $c_Lfastparse_Implicits$LowPriRepeater$GenericRepeatedImplicit0$(this);
    this.asK = true;
  }
  return this.asJ;
});
var $d_Lfastparse_Implicits$Repeater$ = new $TypeData().i($c_Lfastparse_Implicits$Repeater$, "fastparse.Implicits$Repeater$", ({
  qY: 1,
  qR: 1
}));
var $n_Lfastparse_Implicits$Repeater$;
function $m_Lfastparse_Implicits$Repeater$() {
  if ((!$n_Lfastparse_Implicits$Repeater$)) {
    $n_Lfastparse_Implicits$Repeater$ = new $c_Lfastparse_Implicits$Repeater$();
  }
  return $n_Lfastparse_Implicits$Repeater$;
}
/** @constructor */
function $c_Lfastparse_Implicits$Repeater$UnitRepeater$() {
}
$p = $c_Lfastparse_Implicits$Repeater$UnitRepeater$.prototype = new $h_O();
$p.constructor = $c_Lfastparse_Implicits$Repeater$UnitRepeater$;
/** @constructor */
function $h_Lfastparse_Implicits$Repeater$UnitRepeater$() {
}
$h_Lfastparse_Implicits$Repeater$UnitRepeater$.prototype = $p;
$p.qQ = (function(t, acc) {
});
$p.ra = (function(acc) {
  return (void 0);
});
var $d_Lfastparse_Implicits$Repeater$UnitRepeater$ = new $TypeData().i($c_Lfastparse_Implicits$Repeater$UnitRepeater$, "fastparse.Implicits$Repeater$UnitRepeater$", ({
  qZ: 1,
  ez: 1
}));
var $n_Lfastparse_Implicits$Repeater$UnitRepeater$;
function $m_Lfastparse_Implicits$Repeater$UnitRepeater$() {
  if ((!$n_Lfastparse_Implicits$Repeater$UnitRepeater$)) {
    $n_Lfastparse_Implicits$Repeater$UnitRepeater$ = new $c_Lfastparse_Implicits$Repeater$UnitRepeater$();
  }
  return $n_Lfastparse_Implicits$Repeater$UnitRepeater$;
}
/** @constructor */
function $c_Lfastparse_Implicits$Sequencer$NarySequencer(f) {
  this.asO = null;
  this.asO = f;
}
$p = $c_Lfastparse_Implicits$Sequencer$NarySequencer.prototype = new $h_O();
$p.constructor = $c_Lfastparse_Implicits$Sequencer$NarySequencer;
/** @constructor */
function $h_Lfastparse_Implicits$Sequencer$NarySequencer() {
}
$h_Lfastparse_Implicits$Sequencer$NarySequencer.prototype = $p;
$p.R = (function(t, v) {
  return this.asO.R(t, v);
});
var $d_Lfastparse_Implicits$Sequencer$NarySequencer = new $TypeData().i($c_Lfastparse_Implicits$Sequencer$NarySequencer, "fastparse.Implicits$Sequencer$NarySequencer", ({
  r1: 1,
  eA: 1
}));
/** @constructor */
function $c_Lfastparse_Parsed$Failure(label, index, extra) {
  this.a6T = null;
  this.EG = 0;
  this.AV = null;
  this.a6T = label;
  this.EG = index;
  this.AV = extra;
  $ct_Lfastparse_Parsed__Z__(this, false);
}
$p = $c_Lfastparse_Parsed$Failure.prototype = new $h_Lfastparse_Parsed();
$p.constructor = $c_Lfastparse_Parsed$Failure;
/** @constructor */
function $h_Lfastparse_Parsed$Failure() {
}
$h_Lfastparse_Parsed$Failure.prototype = $p;
$p.m = (function() {
  return (("Parsed.Failure(" + this.b4B()) + ")");
});
$p.b4B = (function() {
  var x5 = this.a6T;
  if ((x5 === "")) {
    return ((("Position " + this.AV.JY.aR7(this.EG)) + ", found ") + $m_Lfastparse_Parsed$Failure$().aOn(this.AV.JY, this.EG));
  }
  return $m_Lfastparse_Parsed$Failure$().aOm(this.AV.JY, $m_sci_Nil$().b6($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2(x5, this.EG)]))), this.EG);
});
$p.b4a = (function() {
  if ((!this.AV.a6S.c())) {
    return $m_Lfastparse_Parsed$Failure$().aOm(this.AV.JY, this.AV.a6S.hK($m_sci_Nil$().b6($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2(this.a6T, this.EG)])))), this.EG);
  } else {
    throw $ct_jl_Exception__T__(new $c_jl_Exception(), "`.longMsg` requires the parser to be run with `verboseFailures = true`, or to be called via `.trace().longMsg` or `.trace().longAggregateMsg`");
  }
});
function $isArrayOf_Lfastparse_Parsed$Failure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eD)));
}
var $d_Lfastparse_Parsed$Failure = new $TypeData().i($c_Lfastparse_Parsed$Failure, "fastparse.Parsed$Failure", ({
  eD: 1,
  eC: 1
}));
/** @constructor */
function $c_Lfastparse_ParserInput() {
}
$p = $c_Lfastparse_ParserInput.prototype = new $h_O();
$p.constructor = $c_Lfastparse_ParserInput;
/** @constructor */
function $h_Lfastparse_ParserInput() {
}
$h_Lfastparse_ParserInput.prototype = $p;
/** @constructor */
function $c_Lfastparse_ParserInputSource$fromParserInput(t, conv) {
  this.asV = null;
  this.asU = null;
  this.asV = t;
  this.asU = conv;
}
$p = $c_Lfastparse_ParserInputSource$fromParserInput.prototype = new $h_O();
$p.constructor = $c_Lfastparse_ParserInputSource$fromParserInput;
/** @constructor */
function $h_Lfastparse_ParserInputSource$fromParserInput() {
}
$h_Lfastparse_ParserInputSource$fromParserInput.prototype = $p;
var $d_Lfastparse_ParserInputSource$fromParserInput = new $TypeData().i($c_Lfastparse_ParserInputSource$fromParserInput, "fastparse.ParserInputSource$fromParserInput", ({
  ra: 1,
  r9: 1
}));
function $f_Lfastparse_SequencerGen__$init$__V($thiz) {
  $thiz.a6R = new $c_Lfastparse_Implicits$Sequencer$NarySequencer(new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((t, d) => new $c_T3(t.g(), t.h(), d))));
  $thiz.asL = new $c_Lfastparse_Implicits$Sequencer$NarySequencer(new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((t$2, d$2) => new $c_T4(t$2.bH, t$2.bU, t$2.c3, d$2))));
}
/** @constructor */
function $c_Lfastparse_package$() {
}
$p = $c_Lfastparse_package$.prototype = new $h_O();
$p.constructor = $c_Lfastparse_package$;
/** @constructor */
function $h_Lfastparse_package$() {
}
$h_Lfastparse_package$.prototype = $p;
var $d_Lfastparse_package$ = new $TypeData().i($c_Lfastparse_package$, "fastparse.package$", ({
  ri: 1,
  rd: 1
}));
var $n_Lfastparse_package$;
function $m_Lfastparse_package$() {
  if ((!$n_Lfastparse_package$)) {
    $n_Lfastparse_package$ = new $c_Lfastparse_package$();
  }
  return $n_Lfastparse_package$;
}
/** @constructor */
function $c_jl_Character$() {
  this.Z9 = null;
  $n_jl_Character$ = this;
  this.Z9 = $constArrUDiffs_I(67, "1C]4m6m=c4]4]4]4]4]4]4]4]4]3g4]2m9]2m1Jm1m9s4g5mm6]3]4mm12>mEm1m6m1]3]=]DI]1<m24mIs4g2c4w9];]4]<]3m3m=m3mH]8]2m=mBHm3]4mK3{gggg2:g=m@]13]4E]");
}
$p = $c_jl_Character$.prototype = new $h_O();
$p.constructor = $c_jl_Character$;
/** @constructor */
function $h_jl_Character$() {
}
$h_jl_Character$.prototype = $p;
$p.Q4 = (function(codePoint) {
  if (((codePoint >>> 0) > 1114111)) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  }
  return String.fromCodePoint(codePoint);
});
$p.WE = (function(codePoint, radix) {
  if ((codePoint < 256)) {
    var value = (((((codePoint - 48) | 0) >>> 0) <= 9) ? ((codePoint - 48) | 0) : (((((codePoint - 65) | 0) >>> 0) <= 25) ? ((codePoint - 55) | 0) : (((((codePoint - 97) | 0) >>> 0) <= 25) ? ((codePoint - 87) | 0) : (-1))));
  } else if (((((codePoint - 65313) | 0) >>> 0) <= 25)) {
    var value = ((codePoint - 65303) | 0);
  } else if (((((codePoint - 65345) | 0) >>> 0) <= 25)) {
    var value = ((codePoint - 65335) | 0);
  } else {
    var p = $m_ju_Arrays$().aMv(this.Z9, codePoint);
    var zeroCodePointIndex = ((p < 0) ? (((-2) - p) | 0) : p);
    if ((zeroCodePointIndex < 0)) {
      var value = (-1);
    } else {
      var v = ((codePoint - this.Z9.a[zeroCodePointIndex]) | 0);
      var value = ((v > 9) ? (-1) : v);
    }
  }
  return ((value < radix) ? value : (-1));
});
$p.b3C = (function(ch) {
  return ((ch < 256) ? (ch === 48) : ($m_ju_Arrays$().aMv(this.Z9, ch) >= 0));
});
$p.b1t = (function(digit, radix) {
  if ((((((radix - 2) | 0) >>> 0) > 34) || ((digit >>> 0) >= (radix >>> 0)))) {
    return 0;
  } else {
    var overBaseTen = ((digit - 10) | 0);
    return (65535 & ((overBaseTen < 0) ? ((48 + digit) | 0) : ((97 + overBaseTen) | 0)));
  }
});
$p.j0 = (function(codePoint) {
  switch (codePoint) {
    case 8115:
    case 8131:
    case 8179: {
      return ((9 + codePoint) | 0);
      break;
    }
    default: {
      if (((((codePoint - 8064) | 0) >>> 0) <= 47)) {
        return (8 | codePoint);
      } else {
        var this$1 = this.Q4(codePoint);
        var upperChars = this$1.toUpperCase();
        switch (upperChars.length) {
          case 1: {
            return upperChars.charCodeAt(0);
            break;
          }
          case 2: {
            var high = upperChars.charCodeAt(0);
            var low = upperChars.charCodeAt(1);
            return ((((-67044352) & ((high << 16) | low)) === (-671032320)) ? ((((64 + (1023 & high)) | 0) << 10) | (1023 & low)) : codePoint);
            break;
          }
          default: {
            return codePoint;
          }
        }
      }
    }
  }
});
$p.aSU = (function(ch) {
  return (65535 & this.iy(ch));
});
$p.iy = (function(codePoint) {
  if ((codePoint === 304)) {
    return 105;
  } else {
    var this$1 = this.Q4(codePoint);
    var lowerChars = this$1.toLowerCase();
    switch (lowerChars.length) {
      case 1: {
        return lowerChars.charCodeAt(0);
        break;
      }
      case 2: {
        var high = lowerChars.charCodeAt(0);
        var low = lowerChars.charCodeAt(1);
        return ((((-67044352) & ((high << 16) | low)) === (-671032320)) ? ((((64 + (1023 & high)) | 0) << 10) | (1023 & low)) : codePoint);
        break;
      }
      default: {
        return codePoint;
      }
    }
  }
});
var $d_jl_Character$ = new $TypeData().i($c_jl_Character$, "java.lang.Character$", ({
  rY: 1,
  a: 1
}));
var $n_jl_Character$;
function $m_jl_Character$() {
  if ((!$n_jl_Character$)) {
    $n_jl_Character$ = new $c_jl_Character$();
  }
  return $n_jl_Character$;
}
function $p_jl_Double$__doubleStrPat$lzycompute__O($thiz) {
  if (((((1 & $thiz.AW) << 24) >> 24) === 0)) {
    $thiz.a70 = new RegExp("^[\\x00-\\x20]*([+-]?(?:NaN|Infinity|(?:\\d+\\.?\\d*|\\.\\d+)(?:[eE][+-]?\\d+)?)[fFdD]?)[\\x00-\\x20]*$");
    $thiz.AW = (((1 | $thiz.AW) << 24) >> 24);
  }
  return $thiz.a70;
}
function $p_jl_Double$__doubleStrPat__O($thiz) {
  return (((((1 & $thiz.AW) << 24) >> 24) === 0) ? $p_jl_Double$__doubleStrPat$lzycompute__O($thiz) : $thiz.a70);
}
function $p_jl_Double$__doubleStrHexPat$lzycompute__O($thiz) {
  if (((((2 & $thiz.AW) << 24) >> 24) === 0)) {
    $thiz.a6Z = new RegExp("^[\\x00-\\x20]*([+-]?)0[xX]([0-9A-Fa-f]*)\\.?([0-9A-Fa-f]*)[pP]([+-]?\\d+)[fFdD]?[\\x00-\\x20]*$");
    $thiz.AW = (((2 | $thiz.AW) << 24) >> 24);
  }
  return $thiz.a6Z;
}
function $p_jl_Double$__doubleStrHexPat__O($thiz) {
  return (((((2 & $thiz.AW) << 24) >> 24) === 0) ? $p_jl_Double$__doubleStrHexPat$lzycompute__O($thiz) : $thiz.a6Z);
}
function $p_jl_Double$__parseDoubleSlowPath__T__D($thiz, s) {
  var groups = $p_jl_Double$__doubleStrHexPat__O($thiz).exec(s);
  if ((groups === null)) {
    $ps_jl_Double$__fail$1__T__E(s);
  }
  var x = groups[1];
  var x$1 = groups[2];
  var x$2 = groups[3];
  var x$3 = groups[4];
  if (((x$1 === "") && (x$2 === ""))) {
    $ps_jl_Double$__fail$1__T__E(s);
  }
  var absResult = $thiz.aQW(x$1, x$2, x$3, 15);
  return ((x === "-") ? (-absResult) : absResult);
}
function $ps_jl_Double$__fail$1__T__E(s$1) {
  throw new $c_jl_NumberFormatException((("For input string: \"" + s$1) + "\""));
}
/** @constructor */
function $c_jl_Double$() {
  this.a70 = null;
  this.a6Z = null;
  this.AW = 0;
}
$p = $c_jl_Double$.prototype = new $h_O();
$p.constructor = $c_jl_Double$;
/** @constructor */
function $h_jl_Double$() {
}
$h_jl_Double$.prototype = $p;
$p.bd = (function(s) {
  var groups = $p_jl_Double$__doubleStrPat__O(this).exec(s);
  return ((groups !== null) ? (+parseFloat(groups[1])) : $p_jl_Double$__parseDoubleSlowPath__T__D(this, s));
});
$p.aQW = (function(integralPartStr, fractionalPartStr, binaryExpStr, maxPrecisionChars) {
  var mantissaStr0 = (("" + integralPartStr) + fractionalPartStr);
  var correction1 = ((-(fractionalPartStr.length << 2)) | 0);
  var limit = ((mantissaStr0.length - 1) | 0);
  var i = 0;
  while (((i !== limit) && (mantissaStr0.charCodeAt(i) === 48))) {
    i = ((1 + i) | 0);
  }
  var beginIndex = i;
  var mantissaStr = mantissaStr0.substring(beginIndex);
  var mantissaStrLen = mantissaStr.length;
  var needsCorrection2 = (mantissaStrLen > maxPrecisionChars);
  if (needsCorrection2) {
    var hasNonZeroChar = false;
    var j = maxPrecisionChars;
    while (((!hasNonZeroChar) && (j !== mantissaStrLen))) {
      if ((mantissaStr.charCodeAt(j) !== 48)) {
        hasNonZeroChar = true;
      }
      j = ((1 + j) | 0);
    }
    var compressedTail = (hasNonZeroChar ? "1" : "0");
    var truncatedMantissaStr = (mantissaStr.substring(0, maxPrecisionChars) + compressedTail);
  } else {
    var truncatedMantissaStr = mantissaStr;
  }
  var correction2 = (needsCorrection2 ? (((mantissaStr.length - ((1 + maxPrecisionChars) | 0)) | 0) << 2) : 0);
  var fullCorrection = ((correction1 + correction2) | 0);
  return $m_jl_Math$().b8e((+parseInt(truncatedMantissaStr, 16)), (($doubleToInt((+parseInt(binaryExpStr, 10))) + fullCorrection) | 0));
});
$p.P9 = (function(a, b) {
  if ((a !== a)) {
    return ((b === b) | 0);
  } else if ((b !== b)) {
    return (-1);
  } else if ((a === b)) {
    if ((a === 0.0)) {
      var ainf = (1.0 / a);
      return ((ainf === (1.0 / b)) ? 0 : ((ainf < 0.0) ? (-1) : 1));
    } else {
      return 0;
    }
  } else {
    return ((a < b) ? (-1) : 1);
  }
});
var $d_jl_Double$ = new $TypeData().i($c_jl_Double$, "java.lang.Double$", ({
  s0: 1,
  a: 1
}));
var $n_jl_Double$;
function $m_jl_Double$() {
  if ((!$n_jl_Double$)) {
    $n_jl_Double$ = new $c_jl_Double$();
  }
  return $n_jl_Double$;
}
function $p_jl_Float$__parseFloatRegExp$lzycompute__O($thiz) {
  if ((!$thiz.a71)) {
    $thiz.a72 = new RegExp("^[\\x00-\\x20]*([+-]?)(?:(NaN)|(Infinity)|(?:((?:(\\d+)(?:\\.(\\d*))?|\\.(\\d+))(?:[eE]([+-]?\\d+))?)|(0[xX](?:([0-9A-Fa-f]+)(?:\\.([0-9A-Fa-f]*))?|\\.([0-9A-Fa-f]+))[pP]([+-]?\\d+)))[fFdD]?)[\\x00-\\x20]*$");
    $thiz.a71 = true;
  }
  return $thiz.a72;
}
function $p_jl_Float$__parseFloatRegExp__O($thiz) {
  return ((!$thiz.a71) ? $p_jl_Float$__parseFloatRegExp$lzycompute__O($thiz) : $thiz.a72);
}
function $p_jl_Float$__parseFloatDecimal__T__T__T__T__F($thiz, fullNumberStr, integralPartStr, fractionalPartStr, exponentStr) {
  var z0 = (+parseFloat(fullNumberStr));
  var z = Math.fround(z0);
  var zDouble = z;
  if ((zDouble === z0)) {
    return z;
  } else if ((zDouble === Infinity)) {
    return ((z0 === 3.4028235677973366E38) ? $p_jl_Float$__parseFloatDecimalCorrection__T__T__T__F__F__D__F($thiz, integralPartStr, fractionalPartStr, exponentStr, 3.4028234663852886E38, z, 3.4028235677973366E38) : z);
  } else if ((zDouble < z0)) {
    var zUp = $m_jl_Math$().b53(z);
    var mid$2 = (0.5 * (zDouble + zUp));
    return ((z0 === mid$2) ? $p_jl_Float$__parseFloatDecimalCorrection__T__T__T__F__F__D__F($thiz, integralPartStr, fractionalPartStr, exponentStr, z, zUp, mid$2) : z);
  } else {
    var zDown = $m_jl_Math$().b51(z);
    var mid$3 = (0.5 * (zDouble + zDown));
    return ((z0 === mid$3) ? $p_jl_Float$__parseFloatDecimalCorrection__T__T__T__F__F__D__F($thiz, integralPartStr, fractionalPartStr, exponentStr, zDown, z, mid$3) : z);
  }
}
function $p_jl_Float$__parseFloatDecimalCorrection__T__T__T__F__F__D__F($thiz, integralPartStr, fractionalPartStr, exponentStr, zDown, zUp, mid) {
  var f = $ct_Ljava_math_BigInteger__T__(new $c_Ljava_math_BigInteger(), (("" + integralPartStr) + fractionalPartStr));
  var e = (($m_jl_Integer$().gc(exponentStr, 10, 214748364) - fractionalPartStr.length) | 0);
  var fpBitsDataView = $fpBitsDataView;
  fpBitsDataView.setFloat64(0, mid, true);
  var lo = (fpBitsDataView.getInt32(0, true) | 0);
  var hi = (fpBitsDataView.getInt32(4, true) | 0);
  var lo$1 = (hi >> 20);
  if ((lo$1 === 0)) {
    throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), ("parseFloatCorrection was given a subnormal mid: " + mid));
  }
  var hi$2 = (1048575 & hi);
  var hi$3 = (1048576 | hi$2);
  var m = $m_Ljava_math_BigInteger$().oI(lo, hi$3);
  var k = ((lo$1 - 1075) | 0);
  if ((e >= 0)) {
    if ((k >= 0)) {
      var x = f.mR($m_Ljava_math_BigInteger$().yC.AA(e));
      var y = m.uh(k);
      var cmp = x.Ah(y);
    } else {
      var v = f.mR($m_Ljava_math_BigInteger$().yC.AA(e));
      var e$1 = ((-k) | 0);
      var cmp = v.uh(e$1).Ah(m);
    }
  } else if ((k >= 0)) {
    var e$2 = ((-e) | 0);
    var cmp = f.Ah(m.mR($m_Ljava_math_BigInteger$().yC.AA(e$2)).uh(k));
  } else {
    var x$2 = f.uh(((-k) | 0));
    var e$4 = ((-e) | 0);
    var y$2 = m.mR($m_Ljava_math_BigInteger$().yC.AA(e$4));
    var cmp = x$2.Ah(y$2);
  }
  return ((cmp < 0) ? zDown : ((cmp > 0) ? zUp : (((1 & $floatToBits(zDown)) === 0) ? zDown : zUp)));
}
function $p_jl_Float$__parseFloatHexadecimal__T__T__T__F($thiz, integralPartStr, fractionalPartStr, binaryExpStr) {
  return Math.fround($m_jl_Double$().aQW(integralPartStr, fractionalPartStr, binaryExpStr, 7));
}
/** @constructor */
function $c_jl_Float$() {
  this.a72 = null;
  this.a71 = false;
}
$p = $c_jl_Float$.prototype = new $h_O();
$p.constructor = $c_jl_Float$;
/** @constructor */
function $h_jl_Float$() {
}
$h_jl_Float$.prototype = $p;
$p.a4m = (function(s) {
  var groups = $p_jl_Float$__parseFloatRegExp__O(this).exec(s);
  if ((groups === null)) {
    throw new $c_jl_NumberFormatException((("For input string: \"" + s) + "\""));
  }
  if ((groups[2] !== (void 0))) {
    var absResult = (NaN);
  } else if ((groups[3] !== (void 0))) {
    var absResult = Infinity;
  } else if ((groups[4] !== (void 0))) {
    var $x_1 = groups[4];
    var x$4 = groups[5];
    var x$5 = groups[6];
    var x$6 = groups[7];
    var x$7 = groups[8];
    var absResult = $p_jl_Float$__parseFloatDecimal__T__T__T__T__F(this, $x_1, ((x$4 !== (void 0)) ? x$4 : ""), (("" + ((x$5 !== (void 0)) ? x$5 : "")) + ((x$6 !== (void 0)) ? x$6 : "")), ((x$7 !== (void 0)) ? x$7 : "0"));
  } else {
    var x$8 = groups[10];
    var x$9 = groups[11];
    var x$10 = groups[12];
    var absResult = $p_jl_Float$__parseFloatHexadecimal__T__T__T__F(this, ((x$8 !== (void 0)) ? x$8 : ""), (("" + ((x$9 !== (void 0)) ? x$9 : "")) + ((x$10 !== (void 0)) ? x$10 : "")), groups[13]);
  }
  return ((groups[1] === "-") ? Math.fround((-absResult)) : absResult);
});
var $d_jl_Float$ = new $TypeData().i($c_jl_Float$, "java.lang.Float$", ({
  s1: 1,
  a: 1
}));
var $n_jl_Float$;
function $m_jl_Float$() {
  if ((!$n_jl_Float$)) {
    $n_jl_Float$ = new $c_jl_Float$();
  }
  return $n_jl_Float$;
}
/** @constructor */
function $c_jl_Integer$() {
}
$p = $c_jl_Integer$.prototype = new $h_O();
$p.constructor = $c_jl_Integer$;
/** @constructor */
function $h_jl_Integer$() {
}
$h_jl_Integer$.prototype = $p;
$p.pB = (function(s) {
  throw new $c_jl_NumberFormatException((("For input string: \"" + s) + "\""));
});
$p.gc = (function(s, radix, overflowBarrier) {
  if ((s === null)) {
    $m_jl_Integer$().pB(s);
  }
  var len = s.length;
  if ((len === 0)) {
    $m_jl_Integer$().pB(s);
  }
  var character = $m_jl_Character$();
  var firstChar = s.charCodeAt(0);
  var negative = (firstChar === 45);
  var sign = (negative ? (-1) : 0);
  var i = ((negative || (firstChar === 43)) | 0);
  if ((i >= len)) {
    $m_jl_Integer$().pB(s);
  }
  var java$lang$IntFloatBits$Int32Box$$value = 0;
  java$lang$IntFloatBits$Int32Box$$value = 0;
  while ((i !== len)) {
    var x = character.WE(s.charCodeAt(i), radix);
    if (((x < 0) || ((java$lang$IntFloatBits$Int32Box$$value >>> 0) > (overflowBarrier >>> 0)))) {
      $m_jl_Integer$().pB(s);
    }
    var x$2 = java$lang$IntFloatBits$Int32Box$$value;
    var x$3 = Math.imul(x$2, radix);
    var v = ((x$3 + x) | 0);
    java$lang$IntFloatBits$Int32Box$$value = v;
    i = ((1 + i) | 0);
  }
  if (((java$lang$IntFloatBits$Int32Box$$value >>> 0) > (((2147483647 - sign) | 0) >>> 0))) {
    $m_jl_Integer$().pB(s);
  }
  return (((java$lang$IntFloatBits$Int32Box$$value ^ sign) - sign) | 0);
});
$p.dz = (function(i) {
  var t1 = ((i - (1431655765 & (i >> 1))) | 0);
  var t2 = (((858993459 & t1) + (858993459 & (t1 >> 2))) | 0);
  return (Math.imul(16843009, (252645135 & ((t2 + (t2 >> 4)) | 0))) >> 24);
});
var $d_jl_Integer$ = new $TypeData().i($c_jl_Integer$, "java.lang.Integer$", ({
  s2: 1,
  a: 1
}));
var $n_jl_Integer$;
function $m_jl_Integer$() {
  if ((!$n_jl_Integer$)) {
    $n_jl_Integer$ = new $c_jl_Integer$();
  }
  return $n_jl_Integer$;
}
function $p_jl_Long$__java$lang$Long$$StringRadixInfos$lzycompute__O($thiz) {
  if ((!$thiz.a73)) {
    var r = [];
    var i = 0;
    while ((i < 2)) {
      r.push(null);
      i = ((1 + i) | 0);
    }
    var i$1 = 2;
    while ((i$1 <= 36)) {
      var value$1 = i$1;
      var barrier = ((1073741824 / ($checkIntDivisor(value$1) >>> 0)) | 0);
      var radixPowLength = value$1;
      var chunkLength = 1;
      var paddingZeros = "0";
      while ((radixPowLength <= barrier)) {
        radixPowLength = Math.imul(radixPowLength, value$1);
        chunkLength = ((1 + chunkLength) | 0);
        paddingZeros = (paddingZeros + "0");
      }
      var mHat = ((1.0 / radixPowLength) + 2.6469779601696886E-23);
      var $x_1 = $m_RTLong$().a38((-1), (-1), radixPowLength, 0);
      var overflowBarrier_$_lo = $x_1.l;
      var overflowBarrier_$_hi = $x_1.h;
      r.push(new $c_jl_Long$StringRadixInfo(chunkLength, radixPowLength, mHat, paddingZeros, overflowBarrier_$_lo, overflowBarrier_$_hi));
      i$1 = ((1 + i$1) | 0);
    }
    $thiz.a74 = r;
    $thiz.a73 = true;
  }
  return $thiz.a74;
}
function $p_jl_Long$__parseChunkAsUInt$1__I__I__T__I__I($thiz, chunkStart, chunkEnd, s$1, radix$1) {
  var result = 0;
  var i = chunkStart;
  while ((i !== chunkEnd)) {
    var digit = $m_jl_Character$().WE(s$1.charCodeAt(i), radix$1);
    if ((digit === (-1))) {
      $m_jl_Integer$().pB(s$1);
    }
    result = ((Math.imul(result, radix$1) + digit) | 0);
    i = ((1 + i) | 0);
  }
  return result;
}
/** @constructor */
function $c_jl_Long$() {
  this.a74 = null;
  this.a73 = false;
}
$p = $c_jl_Long$.prototype = new $h_O();
$p.constructor = $c_jl_Long$;
/** @constructor */
function $h_jl_Long$() {
}
$h_jl_Long$.prototype = $p;
$p.agG = (function() {
  return ((!this.a73) ? $p_jl_Long$__java$lang$Long$$StringRadixInfos$lzycompute__O(this) : this.a74);
});
$p.b3F = (function(i_$_lo, i_$_hi, radix) {
  if (((i_$_lo >> 31) === i_$_hi)) {
    return i_$_lo.toString(radix);
  } else if ((((-2097152) & (i_$_hi ^ (i_$_hi >> 10))) === 0)) {
    return ((4.294967296E9 * i_$_hi) + (i_$_lo >>> 0.0)).toString(radix);
  } else {
    var sign = (i_$_hi >> 31);
    var xlo = (i_$_lo ^ sign);
    var rlo = ((xlo - sign) | 0);
    var rhi = (((i_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
    var radixInfo = this.agG()[radix];
    var d = radixInfo.Za;
    var mHat = radixInfo.a75;
    var paddingZeros = radixInfo.a76;
    var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
    var a = (aHat * mHat);
    var qHat = (+Math.floor(a));
    var rHat = ((rlo - Math.imul(d, (qHat | 0.0))) | 0);
    if ((rHat < 0)) {
      qHat = (qHat - 1.0);
      rHat = ((rHat + d) | 0);
    }
    var remStr = rHat.toString(radix);
    var s = ((("" + qHat.toString(radix)) + paddingZeros.substring(remStr.length)) + remStr);
    return ((i_$_hi < 0) ? ("-" + s) : s);
  }
});
$p.b3G = (function(i_$_lo, i_$_hi, radix) {
  if ((i_$_hi === 0)) {
    return (i_$_lo >>> 0.0).toString(radix);
  } else if ((((-2097152) & i_$_hi) === 0)) {
    return ((4.294967296E9 * i_$_hi) + (i_$_lo >>> 0.0)).toString(radix);
  } else {
    var radixInfo = this.agG()[radix];
    var d = radixInfo.Za;
    var mHat = radixInfo.a75;
    var paddingZeros = radixInfo.a76;
    var aHat = ((4.294967296E9 * (i_$_hi >>> 0.0)) + (i_$_lo >>> 0.0));
    var a = (aHat * mHat);
    var qHat = (+Math.floor(a));
    var rHat = ((i_$_lo - Math.imul(d, (qHat | 0.0))) | 0);
    if ((rHat < 0)) {
      qHat = (qHat - 1.0);
      rHat = ((rHat + d) | 0);
    }
    var remStr = rHat.toString(radix);
    return ((("" + qHat.toString(radix)) + paddingZeros.substring(remStr.length)) + remStr);
  }
});
$p.b6v = (function(s, radix) {
  if ((s === "")) {
    $m_jl_Integer$().pB(s);
  }
  var start = 0;
  var neg = false;
  switch (s.charCodeAt(0)) {
    case 43: {
      start = 1;
      break;
    }
    case 45: {
      start = 1;
      neg = true;
      break;
    }
  }
  var $x_1 = this.b6E(s, radix, start);
  var unsignedResult_$_lo = $x_1.l;
  var unsignedResult_$_hi = $x_1.h;
  if (neg) {
    var lo = ((-unsignedResult_$_lo) | 0);
    var hi = ((((-unsignedResult_$_hi) | 0) - ((lo !== 0) | 0)) | 0);
    if (((hi === 0) ? (lo !== 0) : (hi > 0))) {
      $m_jl_Integer$().pB(s);
    }
    return $bL(lo, hi);
  } else {
    if ((unsignedResult_$_hi < 0)) {
      $m_jl_Integer$().pB(s);
    }
    return $bL(unsignedResult_$_lo, unsignedResult_$_hi);
  }
});
$p.b6E = (function(s, radix, start) {
  var length = s.length;
  if ((start >= length)) {
    $m_jl_Integer$().pB(s);
  } else {
    var radixInfo = this.agG()[radix];
    var chunkLen = radixInfo.at1;
    var firstChunkStart = start;
    while (((firstChunkStart < length) && $m_jl_Character$().b3C(s.charCodeAt(firstChunkStart)))) {
      firstChunkStart = ((1 + firstChunkStart) | 0);
    }
    if ((((length - firstChunkStart) | 0) > Math.imul(3, chunkLen))) {
      $m_jl_Integer$().pB(s);
    }
    var firstChunkLength = ((1 + ((((((length - firstChunkStart) | 0) - 1) | 0) % $checkIntDivisor(chunkLen)) | 0)) | 0);
    var firstChunkEnd = ((firstChunkStart + firstChunkLength) | 0);
    var chunkStart = firstChunkStart;
    var x = $p_jl_Long$__parseChunkAsUInt$1__I__I__T__I__I(this, chunkStart, firstChunkEnd, s, radix);
    if ((firstChunkEnd === length)) {
      return $bL(x, 0);
    } else {
      var x$1 = radixInfo.Za;
      var secondChunkEnd = ((firstChunkEnd + chunkLen) | 0);
      var a0 = (65535 & x);
      var a1 = ((x >>> 16) | 0);
      var b0 = (65535 & x$1);
      var b1 = ((x$1 >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      var x$2 = $p_jl_Long$__parseChunkAsUInt$1__I__I__T__I__I(this, firstChunkEnd, secondChunkEnd, s, radix);
      var lo$1 = ((lo + x$2) | 0);
      var hi$1 = ((hi + (((lo$1 >>> 0) < (lo >>> 0)) | 0)) | 0);
      if ((secondChunkEnd === length)) {
        return $bL(lo$1, hi$1);
      } else {
        var overflowBarrier_$_lo = radixInfo.aLe;
        var overflowBarrier_$_hi = radixInfo.aLf;
        var x$3 = $p_jl_Long$__parseChunkAsUInt$1__I__I__T__I__I(this, secondChunkEnd, length, s, radix);
        if (((hi$1 === overflowBarrier_$_hi) ? ((lo$1 >>> 0) > (overflowBarrier_$_lo >>> 0)) : (hi$1 > overflowBarrier_$_hi))) {
          $m_jl_Integer$().pB(s);
        }
        var a0$1 = (65535 & lo$1);
        var a1$1 = ((lo$1 >>> 16) | 0);
        var b0$1 = (65535 & x$1);
        var b1$1 = ((x$1 >>> 16) | 0);
        var a0b0$1 = Math.imul(a0$1, b0$1);
        var a1b0$1 = Math.imul(a1$1, b0$1);
        var a0b1$1 = Math.imul(a0$1, b1$1);
        var lo$2 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
        var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
        var hi$2 = ((((((Math.imul(hi$1, x$1) + Math.imul(a1$1, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
        var lo$3 = ((lo$2 + x$3) | 0);
        var hi$3 = ((hi$2 + (((lo$3 >>> 0) < (lo$2 >>> 0)) | 0)) | 0);
        if (((hi$3 === 0) && ((lo$3 >>> 0) < (x$3 >>> 0)))) {
          $m_jl_Integer$().pB(s);
        }
        return $bL(lo$3, hi$3);
      }
    }
  }
});
$p.aPw = (function(lo, hi) {
  if ((hi !== 0)) {
    var $x_1 = (hi >>> 0.0).toString(16);
    var s = (lo >>> 0.0).toString(16);
    var beginIndex = s.length;
    return ($x_1 + (("" + "00000000".substring(beginIndex)) + s));
  } else {
    return (lo >>> 0.0).toString(16);
  }
});
$p.b3E = (function(lo, hi) {
  var lp = (1073741823 & lo);
  var mp = (1073741823 & ((((lo >>> 30) | 0) + (hi << 2)) | 0));
  var hp = ((hi >>> 28) | 0);
  if ((hp !== 0)) {
    var $x_2 = (hp >>> 0.0).toString(8);
    var s = (mp >>> 0.0).toString(8);
    var beginIndex = s.length;
    var $x_1 = "0000000000".substring(beginIndex);
    var s$1 = (lp >>> 0.0).toString(8);
    var beginIndex$1 = s$1.length;
    return (($x_2 + (("" + $x_1) + s)) + (("" + "0000000000".substring(beginIndex$1)) + s$1));
  } else if ((mp !== 0)) {
    var $x_3 = (mp >>> 0.0).toString(8);
    var s$2 = (lp >>> 0.0).toString(8);
    var beginIndex$2 = s$2.length;
    return ($x_3 + (("" + "0000000000".substring(beginIndex$2)) + s$2));
  } else {
    return (lp >>> 0.0).toString(8);
  }
});
var $d_jl_Long$ = new $TypeData().i($c_jl_Long$, "java.lang.Long$", ({
  s7: 1,
  a: 1
}));
var $n_jl_Long$;
function $m_jl_Long$() {
  if ((!$n_jl_Long$)) {
    $n_jl_Long$ = new $c_jl_Long$();
  }
  return $n_jl_Long$;
}
/** @constructor */
function $c_jl_Number() {
}
$p = $c_jl_Number.prototype = new $h_O();
$p.constructor = $c_jl_Number;
/** @constructor */
function $h_jl_Number() {
}
$h_jl_Number.prototype = $p;
function $is_jl_Number(obj) {
  return (((obj instanceof $c_jl_Number) || ((typeof obj) === "number")) || (obj instanceof $Long));
}
function $isArrayOf_jl_Number(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.aP)));
}
/** @constructor */
function $c_jl_StackTraceElement(declaringClass, methodName, fileName, lineNumber, columnNumber) {
  this.K4 = null;
  this.QY = null;
  this.K5 = null;
  this.K6 = 0;
  this.K3 = 0;
  this.K4 = declaringClass;
  this.QY = methodName;
  this.K5 = fileName;
  this.K6 = lineNumber;
  this.K3 = columnNumber;
}
$p = $c_jl_StackTraceElement.prototype = new $h_O();
$p.constructor = $c_jl_StackTraceElement;
/** @constructor */
function $h_jl_StackTraceElement() {
}
$h_jl_StackTraceElement.prototype = $p;
$p.e = (function(that) {
  return ((that instanceof $c_jl_StackTraceElement) && (((((this.K5 === that.K5) && (this.K6 === that.K6)) && (this.K3 === that.K3)) && (this.K4 === that.K4)) && (this.QY === that.QY)));
});
$p.m = (function() {
  var result = "";
  if ((this.K4 !== "<jscode>")) {
    result = ((("" + result) + this.K4) + ".");
  }
  result = (("" + result) + this.QY);
  if ((this.K5 === null)) {
    result = (result + "(Unknown Source)");
  } else {
    result = ((result + "(") + this.K5);
    if ((this.K6 >= 0)) {
      result = ((result + ":") + this.K6);
      if ((this.K3 >= 0)) {
        result = ((result + ":") + this.K3);
      }
    }
    result = (result + ")");
  }
  return result;
});
$p.x = (function() {
  return (((($f_T__hashCode__I(this.K4) ^ $f_T__hashCode__I(this.QY)) ^ $f_T__hashCode__I(this.K5)) ^ this.K6) ^ this.K3);
});
function $isArrayOf_jl_StackTraceElement(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eW)));
}
var $d_jl_StackTraceElement = new $TypeData().i($c_jl_StackTraceElement, "java.lang.StackTraceElement", ({
  eW: 1,
  a: 1
}));
/** @constructor */
function $c_jl_String$() {
}
$p = $c_jl_String$.prototype = new $h_O();
$p.constructor = $c_jl_String$;
/** @constructor */
function $h_jl_String$() {
}
$h_jl_String$.prototype = $p;
$p.kS = (function(value, offset, count) {
  var endOffset = ((offset + count) | 0);
  var result = "";
  var i = offset;
  while ((i !== endOffset)) {
    result = (result + ("" + $cToS(value.a[i])));
    i = ((1 + i) | 0);
  }
  return result;
});
$p.b4N = (function(bytes, charset) {
  var bb = $m_Ljava_nio_HeapByteBuffer$().aiD(bytes, 0, bytes.a.length, 0, bytes.a.length, false);
  return $p_Ljava_nio_charset_Charset__cachedDecoder__Ljava_nio_charset_CharsetDecoder(charset).aNl(bb).m();
});
$p.aQo = (function(bytes, offset, length, charset) {
  var bb = $m_Ljava_nio_HeapByteBuffer$().aiD(bytes, 0, bytes.a.length, offset, length, false);
  return $p_Ljava_nio_charset_Charset__cachedDecoder__Ljava_nio_charset_CharsetDecoder(charset).aNl(bb).m();
});
$p.b1B = (function(format, args) {
  return $ct_ju_Formatter__(new $c_ju_Formatter()).b1C(format, args).m();
});
var $d_jl_String$ = new $TypeData().i($c_jl_String$, "java.lang.String$", ({
  sf: 1,
  a: 1
}));
var $n_jl_String$;
function $m_jl_String$() {
  if ((!$n_jl_String$)) {
    $n_jl_String$ = new $c_jl_String$();
  }
  return $n_jl_String$;
}
function $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, e, enableSuppression, writableStackTrace) {
  $thiz.at6 = s;
  $thiz.QZ = e;
  $thiz.at7 = writableStackTrace;
  if (writableStackTrace) {
    $thiz.IU();
  }
  return $thiz;
}
class $c_jl_Throwable extends Error {
  constructor() {
    super();
    this.at6 = null;
    this.QZ = null;
    this.at7 = false;
    this.at5 = null;
    this.EJ = null;
  }
  a3L(cause) {
    this.QZ = cause;
    return this;
  }
  e3() {
    return this.at6;
  }
  IU() {
    var reference = ((this instanceof $c_sjs_js_JavaScriptException) ? this.bf : this);
    this.at5 = ((Object.prototype.toString.call(reference) === "[object Error]") ? reference : (((Error.captureStackTrace === (void 0)) || (!(!Object.isSealed(this)))) ? new Error() : (Error.captureStackTrace(this), this)));
    return this;
  }
  a3G() {
    if ((this.EJ === null)) {
      if (this.at7) {
        this.EJ = $m_jl_StackTrace$().b11(this.at5);
      } else {
        this.EJ = new ($d_jl_StackTraceElement.r().C)(0);
      }
    }
    return this.EJ;
  }
  XL(s) {
    this.a3G();
    var t = this.m();
    s.Jg(t);
    if ((this.EJ.a.length !== 0)) {
      var i = 0;
      while ((i < this.EJ.a.length)) {
        var t$1 = ("  at " + this.EJ.a[i]);
        s.Jg(t$1);
        i = ((1 + i) | 0);
      }
    } else {
      s.Jg("  <no stack trace available>");
    }
    var wCause = this;
    while (((wCause !== wCause.QZ) && (wCause.QZ !== null))) {
      var parentTrace = wCause.a3G();
      wCause = wCause.QZ;
      var thisTrace = wCause.a3G();
      var thisLength = thisTrace.a.length;
      var parentLength = parentTrace.a.length;
      var t$2 = ("Caused by: " + wCause);
      s.Jg(t$2);
      if ((thisLength !== 0)) {
        var sameFrameCount = 0;
        while (true) {
          if (((sameFrameCount < thisLength) && (sameFrameCount < parentLength))) {
            var x = thisTrace.a[((((thisLength - sameFrameCount) | 0) - 1) | 0)];
            var x$2 = parentTrace.a[((((parentLength - sameFrameCount) | 0) - 1) | 0)];
            var $x_1 = ((x === null) ? (x$2 === null) : x.e(x$2));
          } else {
            var $x_1 = false;
          }
          if ($x_1) {
            sameFrameCount = ((1 + sameFrameCount) | 0);
          } else {
            break;
          }
        }
        if ((sameFrameCount > 0)) {
          sameFrameCount = ((sameFrameCount - 1) | 0);
        }
        var lengthToPrint = ((thisLength - sameFrameCount) | 0);
        var i$2 = 0;
        while ((i$2 < lengthToPrint)) {
          var t$3 = ("  at " + thisTrace.a[i$2]);
          s.Jg(t$3);
          i$2 = ((1 + i$2) | 0);
        }
        if ((sameFrameCount > 0)) {
          var t$4 = (("  ... " + sameFrameCount) + " more");
          s.Jg(t$4);
        }
      } else {
        s.Jg("  <no stack trace available>");
      }
    }
  }
  m() {
    var className = $objectClassName(this);
    var message = this.e3();
    return ((message === null) ? className : ((className + ": ") + message));
  }
  x() {
    return $c_O.prototype.x.call(this);
  }
  e(that) {
    return $c_O.prototype.e.call(this, that);
  }
  get "message"() {
    var m = this.e3();
    return ((m === null) ? "" : m);
  }
  get "name"() {
    return $objectClassName(this);
  }
  "toString"() {
    return this.m();
  }
}
function $isArrayOf_jl_Throwable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.y)));
}
/** @constructor */
function $c_Ljava_math_BigDecimal$() {
  this.atb = null;
  this.a7d = null;
  this.yB = null;
  this.atc = null;
  this.ata = null;
  this.a7c = null;
  this.K9 = null;
  $n_Ljava_math_BigDecimal$ = this;
  this.atb = $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 0, 0);
  $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 1, 0);
  $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 10, 0);
  this.a7d = this.aQp(28, 5);
  var len = ((this.a7d.a.length >>> 1) | 0);
  var result = new $ac_I(len);
  var i = 0;
  while ((i < len)) {
    var value = i;
    var $x_4 = $m_Ljava_math_BigDecimal$();
    var $x_2 = $m_Ljava_math_BigDecimal$().a7d.a;
    var $x_3 = (value << 1);
    var $x_1_$_lo = $x_2[$x_3];
    var $x_1_$_hi = $x_2[(($x_3 + 1) | 0)];
    result.a[value] = $x_4.Wo($x_1_$_lo, $x_1_$_hi);
    i = ((1 + i) | 0);
  }
  this.yB = this.aQp(19, 10);
  var len$2 = ((this.yB.a.length >>> 1) | 0);
  var result$2 = new $ac_I(len$2);
  var i$1 = 0;
  while ((i$1 < len$2)) {
    var value$1 = i$1;
    var $x_8 = $m_Ljava_math_BigDecimal$();
    var $x_6 = $m_Ljava_math_BigDecimal$().yB.a;
    var $x_7 = (value$1 << 1);
    var $x_5_$_lo = $x_6[$x_7];
    var $x_5_$_hi = $x_6[(($x_7 + 1) | 0)];
    result$2.a[value$1] = $x_8.Wo($x_5_$_lo, $x_5_$_hi);
    i$1 = ((1 + i$1) | 0);
  }
  this.atc = result$2;
  var result$3 = new ($d_Ljava_math_BigDecimal.r().C)(11);
  var i$2 = 0;
  while ((i$2 < 11)) {
    var value$2 = i$2;
    result$3.a[value$2] = $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), value$2, 0);
    i$2 = ((1 + i$2) | 0);
  }
  this.ata = result$3;
  var result$4 = new ($d_Ljava_math_BigDecimal.r().C)(11);
  var i$3 = 0;
  while ((i$3 < 11)) {
    var value$3 = i$3;
    result$4.a[value$3] = $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 0, value$3);
    i$3 = ((1 + i$3) | 0);
  }
  this.a7c = result$4;
  this.K9 = "0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000";
}
$p = $c_Ljava_math_BigDecimal$.prototype = new $h_O();
$p.constructor = $c_Ljava_math_BigDecimal$;
/** @constructor */
function $h_Ljava_math_BigDecimal$() {
}
$h_Ljava_math_BigDecimal$.prototype = $p;
$p.Yh = (function(unscaledVal_$_lo, unscaledVal_$_hi, scale) {
  return ((scale === 0) ? this.bb0(unscaledVal_$_lo, unscaledVal_$_hi) : (((((unscaledVal_$_lo | unscaledVal_$_hi) === 0) && (scale >= 0)) && (scale < this.a7c.a.length)) ? this.a7c.a[scale] : $ct_Ljava_math_BigDecimal__J__I__(new $c_Ljava_math_BigDecimal(), unscaledVal_$_lo, unscaledVal_$_hi, scale)));
});
$p.bb0 = (function(unscaledVal_$_lo, unscaledVal_$_hi) {
  return (((unscaledVal_$_hi >= 0) && ((unscaledVal_$_hi === 0) ? ((unscaledVal_$_lo >>> 0) < 11) : (unscaledVal_$_hi < 0))) ? this.ata.a[unscaledVal_$_lo] : $ct_Ljava_math_BigDecimal__J__I__(new $c_Ljava_math_BigDecimal(), unscaledVal_$_lo, unscaledVal_$_hi, 0));
});
$p.b3I = (function(scaledDividend, scaledDivisor, scale, roundingMode) {
  var qr = scaledDividend.afm(scaledDivisor);
  if ((qr.Kb.bS === 0)) {
    return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), qr.yD, scale);
  } else {
    var sign = Math.imul(scaledDividend.bS, scaledDivisor.bS);
    var parityBit = (qr.yD.Y6(0) | 0);
    if (($m_Ljava_math_BitLevel$().DM(scaledDivisor) < 63)) {
      var $x_1 = qr.Kb.lY();
      var rem_$_lo = $x_1.l;
      var rem_$_hi = $x_1.h;
      var $x_2 = scaledDivisor.lY();
      var divisor_$_lo = $x_2.l;
      var divisor_$_hi = $x_2.h;
      var sign$1 = (rem_$_hi >> 31);
      var xlo = (rem_$_lo ^ sign$1);
      var rlo = ((xlo - sign$1) | 0);
      var rhi = (((rem_$_hi ^ sign$1) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
      var lo = (rlo << 1);
      var hi = (((rlo >>> 31) | 0) | (rhi << 1));
      var sign$2 = (divisor_$_hi >> 31);
      var xlo$1 = (divisor_$_lo ^ sign$2);
      var rlo$1 = ((xlo$1 - sign$2) | 0);
      var rhi$1 = (((divisor_$_hi ^ sign$2) + (((rlo$1 >>> 0) < (xlo$1 >>> 0)) | 0)) | 0);
      var compRem$3 = this.Xk(parityBit, Math.imul(sign, ((5 + this.agH(lo, hi, rlo$1, rhi$1)) | 0)), roundingMode);
    } else {
      var compRem$3 = this.Xk(parityBit, Math.imul(sign, ((5 + qr.Kb.a2A().aSb().Ah(scaledDivisor.a2A())) | 0)), roundingMode);
    }
    if ((compRem$3 !== 0)) {
      if (($m_Ljava_math_BitLevel$().DM(qr.yD) < 63)) {
        var $x_3 = qr.yD.lY();
        var x_$_lo = $x_3.l;
        var x_$_hi = $x_3.h;
        var hi$1 = (compRem$3 >> 31);
        var lo$1 = ((x_$_lo + compRem$3) | 0);
        var hi$2 = ((((x_$_hi + hi$1) | 0) + (((lo$1 >>> 0) < (x_$_lo >>> 0)) | 0)) | 0);
        return this.Yh(lo$1, hi$2, scale);
      } else {
        var $x_6 = $m_Ljava_math_Elementary$();
        var $x_5 = qr.yD;
        var $x_4 = $m_Ljava_math_BigInteger$();
        var hi$3 = (compRem$3 >> 31);
        return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), $x_6.OT($x_5, $x_4.oI(compRem$3, hi$3)), scale);
      }
    } else {
      return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), qr.yD, scale);
    }
  }
});
$p.b3J = (function(scaledDividend_$_lo, scaledDividend_$_hi, scaledDivisor_$_lo, scaledDivisor_$_hi, scale, roundingMode) {
  var $x_1 = $m_RTLong$().afk(scaledDividend_$_lo, scaledDividend_$_hi, scaledDivisor_$_lo, scaledDivisor_$_hi);
  var q_$_lo = $x_1.l;
  var q_$_hi = $x_1.h;
  var a0 = (65535 & scaledDivisor_$_lo);
  var a1 = ((scaledDivisor_$_lo >>> 16) | 0);
  var b0 = (65535 & q_$_lo);
  var b1 = ((q_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(a0, b0);
  var a1b0 = Math.imul(a1, b0);
  var a0b1 = Math.imul(a0, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi = ((((((((Math.imul(scaledDivisor_$_lo, q_$_hi) + Math.imul(scaledDivisor_$_hi, q_$_lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var lo$1 = ((scaledDividend_$_lo - lo) | 0);
  var hi$1 = ((((scaledDividend_$_hi - hi) | 0) - (((lo$1 >>> 0) > (scaledDividend_$_lo >>> 0)) | 0)) | 0);
  var lo$2 = (scaledDividend_$_hi >> 31);
  var lo$3 = ((-scaledDividend_$_lo) | 0);
  var lo$6 = (scaledDivisor_$_hi >> 31);
  var lo$7 = ((-scaledDivisor_$_lo) | 0);
  var sign = Math.imul((lo$2 | ((((((-scaledDividend_$_hi) | 0) - ((lo$3 !== 0) | 0)) | 0) >>> 31) | 0)), (lo$6 | ((((((-scaledDivisor_$_hi) | 0) - ((lo$7 !== 0) | 0)) | 0) >>> 31) | 0)));
  if (((lo$1 | hi$1) !== 0)) {
    var sign$1 = (hi$1 >> 31);
    var xlo = (lo$1 ^ sign$1);
    var rlo = ((xlo - sign$1) | 0);
    var rhi = (((hi$1 ^ sign$1) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
    var lo$10 = (rlo << 1);
    var hi$6 = (((rlo >>> 31) | 0) | (rhi << 1));
    var sign$2 = (scaledDivisor_$_hi >> 31);
    var xlo$1 = (scaledDivisor_$_lo ^ sign$2);
    var rlo$1 = ((xlo$1 - sign$2) | 0);
    var rhi$1 = (((scaledDivisor_$_hi ^ sign$2) + (((rlo$1 >>> 0) < (xlo$1 >>> 0)) | 0)) | 0);
    var compRem = this.agH(lo$10, hi$6, rlo$1, rhi$1);
    var value = this.Xk((1 & q_$_lo), Math.imul(sign, ((5 + compRem) | 0)), roundingMode);
    var hi$7 = (value >> 31);
    var lo$11 = ((q_$_lo + value) | 0);
    var hi$8 = ((((q_$_hi + hi$7) | 0) + (((lo$11 >>> 0) < (q_$_lo >>> 0)) | 0)) | 0);
    var $x_2_$_lo = lo$11;
    var $x_2_$_hi = hi$8;
  } else {
    var $x_2_$_lo = q_$_lo;
    var $x_2_$_hi = q_$_hi;
  }
  return this.Yh($x_2_$_lo, $x_2_$_hi, scale);
});
$p.agH = (function(value1_$_lo, value1_$_hi, value2_$_lo, value2_$_hi) {
  return (((value1_$_hi === value2_$_hi) ? ((value1_$_lo >>> 0) > (value2_$_lo >>> 0)) : (value1_$_hi > value2_$_hi)) ? 1 : (((value1_$_hi === value2_$_hi) ? ((value1_$_lo >>> 0) < (value2_$_lo >>> 0)) : (value1_$_hi < value2_$_hi)) ? (-1) : 0));
});
$p.aQp = (function(len, pow) {
  var result = new $ac_J(len);
  var $x_1 = result.a;
  $x_1[0] = 1;
  $x_1[1] = 0;
  var i = 1;
  while ((i < len)) {
    var value = i;
    var $x_2 = result.a;
    var $x_3 = (((value - 1) | 0) << 1);
    var x_$_lo = $x_2[$x_3];
    var x_$_hi = $x_2[(($x_3 + 1) | 0)];
    var hi = (pow >> 31);
    var a0 = (65535 & x_$_lo);
    var a1 = ((x_$_lo >>> 16) | 0);
    var b0 = (65535 & pow);
    var b1 = ((pow >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$1 = ((((((((Math.imul(x_$_lo, hi) + Math.imul(x_$_hi, pow)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var $x_4 = result.a;
    var $x_5 = (value << 1);
    $x_4[$x_5] = lo;
    $x_4[(($x_5 + 1) | 0)] = hi$1;
    i = ((1 + i) | 0);
  }
  return result;
});
$p.Xk = (function(parityBit, fraction, roundingMode) {
  var sign = (fraction >> 31);
  var absFraction = (((fraction ^ sign) - sign) | 0);
  var sigFraction = ((fraction >> 31) | ((((-fraction) | 0) >>> 31) | 0));
  var x = $m_Ljava_math_RoundingMode$().Zi;
  if (((x === null) ? (roundingMode === null) : (x === roundingMode))) {
    return sigFraction;
  } else {
    var x$3 = $m_Ljava_math_RoundingMode$().Ze;
    if (((x$3 === null) ? (roundingMode === null) : (x$3 === roundingMode))) {
      return 0;
    } else {
      var x$5 = $m_Ljava_math_RoundingMode$().Zd;
      if (((x$5 === null) ? (roundingMode === null) : (x$5 === roundingMode))) {
        return ((sigFraction > 0) ? sigFraction : 0);
      } else {
        var x$7 = $m_Ljava_math_RoundingMode$().Zf;
        if (((x$7 === null) ? (roundingMode === null) : (x$7 === roundingMode))) {
          return ((sigFraction < 0) ? sigFraction : 0);
        } else {
          var x$9 = $m_Ljava_math_RoundingMode$().R0;
          if (((x$9 === null) ? (roundingMode === null) : (x$9 === roundingMode))) {
            return ((absFraction >= 5) ? sigFraction : 0);
          } else {
            var x$11 = $m_Ljava_math_RoundingMode$().Zg;
            if (((x$11 === null) ? (roundingMode === null) : (x$11 === roundingMode))) {
              return ((absFraction > 5) ? sigFraction : 0);
            } else {
              var x$13 = $m_Ljava_math_RoundingMode$().B2;
              if (((x$13 === null) ? (roundingMode === null) : (x$13 === roundingMode))) {
                return ((((absFraction + parityBit) | 0) > 5) ? sigFraction : 0);
              } else {
                var x$15 = $m_Ljava_math_RoundingMode$().Zh;
                if ((!((x$15 === null) ? (roundingMode === null) : (x$15 === roundingMode)))) {
                  throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), roundingMode);
                }
                if ((fraction !== 0)) {
                  throw new $c_jl_ArithmeticException("Rounding necessary");
                }
                return 0;
              }
            }
          }
        }
      }
    }
  }
});
$p.Xl = (function(longValue_$_lo, longValue_$_hi) {
  if ((((longValue_$_hi === (-1)) ? ((longValue_$_lo >>> 0) < 2147483648) : (longValue_$_hi < (-1))) || ((longValue_$_hi === 0) ? ((longValue_$_lo >>> 0) > 2147483647) : (longValue_$_hi > 0)))) {
    throw new $c_jl_ArithmeticException(("Out of int range: " + $s_RTLong__toString__I__I__T(longValue_$_lo, longValue_$_hi)));
  }
  return longValue_$_lo;
});
$p.b3K = (function(longScale_$_lo, longScale_$_hi) {
  var hi = (longScale_$_lo >> 31);
  if ((((longScale_$_lo ^ longScale_$_lo) | (longScale_$_hi ^ hi)) === 0)) {
    return this.Yh(0, 0, longScale_$_lo);
  } else {
    return ((longScale_$_hi >= 0) ? $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 0, 2147483647) : $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 0, (-2147483648)));
  }
});
$p.Wo = (function(sValue_$_lo, sValue_$_hi) {
  if ((sValue_$_hi < 0)) {
    var lo = (~sValue_$_lo);
    var hi = (~sValue_$_hi);
    var smallValue_$_lo = lo;
    var smallValue_$_hi = hi;
  } else {
    var smallValue_$_lo = sValue_$_lo;
    var smallValue_$_hi = sValue_$_hi;
  }
  return ((64 - ((smallValue_$_hi !== 0) ? Math.clz32(smallValue_$_hi) : ((32 + Math.clz32(smallValue_$_lo)) | 0))) | 0);
});
$p.b3H = (function(sValue) {
  return ((32 - Math.clz32(((sValue < 0) ? (~sValue) : sValue))) | 0);
});
$p.aPx = (function(c, cs) {
  return (!this.a3W(c, cs));
});
$p.a3W = (function(c, cs) {
  var len = cs.a.length;
  var i = 0;
  while ((i !== len)) {
    if ((cs.a[i] === c)) {
      return true;
    }
    i = ((1 + i) | 0);
  }
  return false;
});
var $d_Ljava_math_BigDecimal$ = new $TypeData().i($c_Ljava_math_BigDecimal$, "java.math.BigDecimal$", ({
  sp: 1,
  a: 1
}));
var $n_Ljava_math_BigDecimal$;
function $m_Ljava_math_BigDecimal$() {
  if ((!$n_Ljava_math_BigDecimal$)) {
    $n_Ljava_math_BigDecimal$ = new $c_Ljava_math_BigDecimal$();
  }
  return $n_Ljava_math_BigDecimal$;
}
/** @constructor */
function $c_Ljava_math_BigInteger$() {
  this.Ka = null;
  this.yC = null;
  this.ws = null;
  this.Zc = null;
  this.atd = null;
  this.a7e = null;
  $n_Ljava_math_BigInteger$ = this;
  this.Ka = $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 1);
  this.yC = $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 10);
  this.ws = $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 0, 0);
  this.Zc = $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), (-1), 1);
  this.atd = new ($d_Ljava_math_BigInteger.r().C)([this.ws, this.Ka, $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 2), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 3), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 4), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 5), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 6), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 7), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 8), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 9), this.yC]);
  var result = new ($d_Ljava_math_BigInteger.r().C)(32);
  var i = 0;
  while ((i < 32)) {
    var value = i;
    var $x_1 = $m_Ljava_math_BigInteger$();
    var lo = (((32 & value) === 0) ? (1 << value) : 0);
    var hi = (((32 & value) === 0) ? 0 : (1 << value));
    result.a[value] = $x_1.oI(lo, hi);
    i = ((1 + i) | 0);
  }
  this.a7e = result;
}
$p = $c_Ljava_math_BigInteger$.prototype = new $h_O();
$p.constructor = $c_Ljava_math_BigInteger$;
/** @constructor */
function $h_Ljava_math_BigInteger$() {
}
$h_Ljava_math_BigInteger$.prototype = $p;
$p.oI = (function(lVal_$_lo, lVal_$_hi) {
  if ((lVal_$_hi < 0)) {
    if ((((~lVal_$_lo) | (~lVal_$_hi)) !== 0)) {
      var lo = ((-lVal_$_lo) | 0);
      var hi = ((((-lVal_$_hi) | 0) - ((lo !== 0) | 0)) | 0);
      return $ct_Ljava_math_BigInteger__I__J__(new $c_Ljava_math_BigInteger(), (-1), lo, hi);
    } else {
      return this.Zc;
    }
  } else {
    return (((lVal_$_hi === 0) ? ((lVal_$_lo >>> 0) <= 10) : (lVal_$_hi < 0)) ? this.atd.a[lVal_$_lo] : $ct_Ljava_math_BigInteger__I__J__(new $c_Ljava_math_BigInteger(), 1, lVal_$_lo, lVal_$_hi));
  }
});
$p.b28 = (function(exp) {
  if ((exp < this.a7e.a.length)) {
    return this.a7e.a[exp];
  } else {
    var intCount = (exp >> 5);
    var bitN = (31 & exp);
    var resDigits = new $ac_I(((1 + intCount) | 0));
    resDigits.a[intCount] = (1 << bitN);
    return $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), 1, ((1 + intCount) | 0), resDigits);
  }
});
$p.aYi = (function(byteLength) {
  if (((byteLength >>> 0) > 67108863)) {
    throw new $c_jl_ArithmeticException("BigInteger would overflow supported range");
  }
});
var $d_Ljava_math_BigInteger$ = new $TypeData().i($c_Ljava_math_BigInteger$, "java.math.BigInteger$", ({
  sq: 1,
  a: 1
}));
var $n_Ljava_math_BigInteger$;
function $m_Ljava_math_BigInteger$() {
  if ((!$n_Ljava_math_BigInteger$)) {
    $n_Ljava_math_BigInteger$ = new $c_Ljava_math_BigInteger$();
  }
  return $n_Ljava_math_BigInteger$;
}
/** @constructor */
function $c_Ljava_math_RoundingMode$() {
  this.Zi = null;
  this.Ze = null;
  this.Zd = null;
  this.Zf = null;
  this.R0 = null;
  this.Zg = null;
  this.B2 = null;
  this.Zh = null;
  $n_Ljava_math_RoundingMode$ = this;
  this.Zi = new $c_Ljava_math_RoundingMode("UP", 0);
  this.Ze = new $c_Ljava_math_RoundingMode("DOWN", 1);
  this.Zd = new $c_Ljava_math_RoundingMode("CEILING", 2);
  this.Zf = new $c_Ljava_math_RoundingMode("FLOOR", 3);
  this.R0 = new $c_Ljava_math_RoundingMode("HALF_UP", 4);
  this.Zg = new $c_Ljava_math_RoundingMode("HALF_DOWN", 5);
  this.B2 = new $c_Ljava_math_RoundingMode("HALF_EVEN", 6);
  this.Zh = new $c_Ljava_math_RoundingMode("UNNECESSARY", 7);
}
$p = $c_Ljava_math_RoundingMode$.prototype = new $h_O();
$p.constructor = $c_Ljava_math_RoundingMode$;
/** @constructor */
function $h_Ljava_math_RoundingMode$() {
}
$h_Ljava_math_RoundingMode$.prototype = $p;
$p.baZ = (function(mode) {
  switch (mode) {
    case 2: {
      return this.Zd;
      break;
    }
    case 1: {
      return this.Ze;
      break;
    }
    case 3: {
      return this.Zf;
      break;
    }
    case 5: {
      return this.Zg;
      break;
    }
    case 6: {
      return this.B2;
      break;
    }
    case 4: {
      return this.R0;
      break;
    }
    case 7: {
      return this.Zh;
      break;
    }
    case 0: {
      return this.Zi;
      break;
    }
    default: {
      throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Invalid rounding mode");
    }
  }
});
var $d_Ljava_math_RoundingMode$ = new $TypeData().i($c_Ljava_math_RoundingMode$, "java.math.RoundingMode$", ({
  sz: 1,
  a: 1
}));
var $n_Ljava_math_RoundingMode$;
function $m_Ljava_math_RoundingMode$() {
  if ((!$n_Ljava_math_RoundingMode$)) {
    $n_Ljava_math_RoundingMode$ = new $c_Ljava_math_RoundingMode$();
  }
  return $n_Ljava_math_RoundingMode$;
}
function $p_Ljava_nio_charset_Charset__cachedDecoder$lzycompute__Ljava_nio_charset_CharsetDecoder($thiz) {
  if (((((2 & $thiz.yF) << 24) >> 24) === 0)) {
    $thiz.Zk = new $c_Ljava_nio_charset_UTF\uff3f8$Decoder().b5d($m_Ljava_nio_charset_CodingErrorAction$().EQ).b5g($m_Ljava_nio_charset_CodingErrorAction$().EQ);
    $thiz.yF = (((2 | $thiz.yF) << 24) >> 24);
  }
  return $thiz.Zk;
}
function $p_Ljava_nio_charset_Charset__cachedDecoder__Ljava_nio_charset_CharsetDecoder($thiz) {
  return (((((2 & $thiz.yF) << 24) >> 24) === 0) ? $p_Ljava_nio_charset_Charset__cachedDecoder$lzycompute__Ljava_nio_charset_CharsetDecoder($thiz) : $thiz.Zk);
}
function $p_Ljava_nio_charset_Charset__cachedEncoder$lzycompute__Ljava_nio_charset_CharsetEncoder($thiz) {
  if (((((4 & $thiz.yF) << 24) >> 24) === 0)) {
    $thiz.Zl = new $c_Ljava_nio_charset_UTF\uff3f8$Encoder().b5e($m_Ljava_nio_charset_CodingErrorAction$().EQ).b5h($m_Ljava_nio_charset_CodingErrorAction$().EQ);
    $thiz.yF = (((4 | $thiz.yF) << 24) >> 24);
  }
  return $thiz.Zl;
}
function $p_Ljava_nio_charset_Charset__cachedEncoder__Ljava_nio_charset_CharsetEncoder($thiz) {
  return (((((4 & $thiz.yF) << 24) >> 24) === 0) ? $p_Ljava_nio_charset_Charset__cachedEncoder$lzycompute__Ljava_nio_charset_CharsetEncoder($thiz) : $thiz.Zl);
}
function $ct_Ljava_nio_charset_Charset__T__AT__($thiz, canonicalName, _aliases) {
  $thiz.B3 = canonicalName;
  return $thiz;
}
/** @constructor */
function $c_Ljava_nio_charset_Charset() {
  this.Zk = null;
  this.Zl = null;
  this.B3 = null;
  this.yF = 0;
}
$p = $c_Ljava_nio_charset_Charset.prototype = new $h_O();
$p.constructor = $c_Ljava_nio_charset_Charset;
/** @constructor */
function $h_Ljava_nio_charset_Charset() {
}
$h_Ljava_nio_charset_Charset.prototype = $p;
$p.e = (function(that) {
  return ((that instanceof $c_Ljava_nio_charset_Charset) && (this.B3 === that.B3));
});
$p.m = (function() {
  return this.B3;
});
$p.x = (function() {
  return $f_T__hashCode__I(this.B3);
});
$p.b0z = (function(str) {
  var cb = $m_Ljava_nio_CharBuffer$().aTv(str, 0, str.length);
  return $p_Ljava_nio_charset_Charset__cachedEncoder__Ljava_nio_charset_CharsetEncoder(this).b0B(cb);
});
$p.pp = (function(o) {
  return $f_T__compareToIgnoreCase__T__I(this.B3, o.B3);
});
function $isArrayOf_Ljava_nio_charset_Charset(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.f8)));
}
function $p_Ljava_nio_charset_UTF\uff3f8$Decoder__decodeLoopArray__Ljava_nio_ByteBuffer__Ljava_nio_CharBuffer__Ljava_nio_charset_CoderResult($thiz, in$1, out) {
  var a = in$1.m9;
  if ((a === null)) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  }
  if (in$1.wt) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var o = in$1.nL;
  if ((o === (-1))) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  }
  if (in$1.wt) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var inStart = ((in$1.b3 + o) | 0);
  var inEnd = ((in$1.c2 + o) | 0);
  var a$1 = out.lx;
  if ((a$1 === null)) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  }
  if (out.E6()) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var o$1 = out.nM;
  if ((o$1 === (-1))) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  }
  if (out.E6()) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var outStart = ((out.b3 + o$1) | 0);
  var outEnd = ((out.c2 + o$1) | 0);
  var inPos = inStart;
  var outPos = outStart;
  while (true) {
    if ((inPos === inEnd)) {
      var result = $m_Ljava_nio_charset_CoderResult$().mb;
      var inPos$1 = inPos;
      var outPos$1 = outPos;
      $c_Ljava_nio_Buffer.prototype.cX.call(in$1, ((inPos$1 - o) | 0));
      $c_Ljava_nio_Buffer.prototype.cX.call(out, ((outPos$1 - o$1) | 0));
      return result;
    } else {
      var leading = a.a[inPos];
      if ((leading >= 0)) {
        if ((outPos === outEnd)) {
          var result$1 = $m_Ljava_nio_charset_CoderResult$().ma;
          var inPos$1$1 = inPos;
          var outPos$1$1 = outPos;
          $c_Ljava_nio_Buffer.prototype.cX.call(in$1, ((inPos$1$1 - o) | 0));
          $c_Ljava_nio_Buffer.prototype.cX.call(out, ((outPos$1$1 - o$1) | 0));
          return result$1;
        } else {
          a$1.a[outPos] = (65535 & leading);
          var temp$inPos = ((1 + inPos) | 0);
          var temp$outPos = ((1 + outPos) | 0);
          inPos = temp$inPos;
          outPos = temp$outPos;
        }
      } else {
        var length = $m_Ljava_nio_charset_UTF\uff3f8$().a7n.a[(127 & leading)];
        if ((length === (-1))) {
          var result$2 = $m_Ljava_nio_charset_CoderResult$().mc;
          var inPos$1$2 = inPos;
          var outPos$1$2 = outPos;
          $c_Ljava_nio_Buffer.prototype.cX.call(in$1, ((inPos$1$2 - o) | 0));
          $c_Ljava_nio_Buffer.prototype.cX.call(out, ((outPos$1$2 - o$1) | 0));
          return result$2;
        } else {
          if ((((1 + inPos) | 0) >= inEnd)) {
            var decoded__failure = $m_Ljava_nio_charset_CoderResult$().mb;
            var decoded__high = 0;
            var decoded__low = 0;
          } else {
            var b2 = a.a[((1 + inPos) | 0)];
            if (((192 & b2) !== 128)) {
              var decoded__failure = $m_Ljava_nio_charset_CoderResult$().mc;
              var decoded__high = 0;
              var decoded__low = 0;
            } else if ((length === 2)) {
              var b2$1 = b2;
              var codePoint = (((31 & leading) << 6) | (63 & b2$1));
              if ((codePoint < 128)) {
                var decoded__failure = $m_Ljava_nio_charset_CoderResult$().mc;
                var decoded__high = 0;
                var decoded__low = 0;
              } else {
                var decoded__failure = null;
                var decoded__high = (65535 & codePoint);
                var decoded__low = 0;
              }
            } else if ((((2 + inPos) | 0) >= inEnd)) {
              var decoded__failure = $m_Ljava_nio_charset_CoderResult$().mb;
              var decoded__high = 0;
              var decoded__low = 0;
            } else {
              var b3 = a.a[((2 + inPos) | 0)];
              if (((192 & b3) !== 128)) {
                var decoded__failure = $m_Ljava_nio_charset_CoderResult$().R1;
                var decoded__high = 0;
                var decoded__low = 0;
              } else if ((length === 3)) {
                var b2$2 = b2;
                var b3$1 = b3;
                var codePoint$1 = ((((15 & leading) << 12) | ((63 & b2$2) << 6)) | (63 & b3$1));
                if ((codePoint$1 < 2048)) {
                  var decoded__failure = $m_Ljava_nio_charset_CoderResult$().mc;
                  var decoded__high = 0;
                  var decoded__low = 0;
                } else if (((((codePoint$1 - 55296) | 0) >>> 0) <= 2047)) {
                  var decoded__failure = $m_Ljava_nio_charset_CoderResult$().EP;
                  var decoded__high = 0;
                  var decoded__low = 0;
                } else {
                  var decoded__failure = null;
                  var decoded__high = (65535 & codePoint$1);
                  var decoded__low = 0;
                }
              } else if ((((3 + inPos) | 0) >= inEnd)) {
                var decoded__failure = $m_Ljava_nio_charset_CoderResult$().mb;
                var decoded__high = 0;
                var decoded__low = 0;
              } else {
                var b4 = a.a[((3 + inPos) | 0)];
                if (((192 & b4) !== 128)) {
                  var decoded__failure = $m_Ljava_nio_charset_CoderResult$().EP;
                  var decoded__high = 0;
                  var decoded__low = 0;
                } else {
                  var b2$3 = b2;
                  var b3$2 = b3;
                  var b4$1 = b4;
                  var codePoint$2 = (((((7 & leading) << 18) | ((63 & b2$3) << 12)) | ((63 & b3$2) << 6)) | (63 & b4$1));
                  if (((((codePoint$2 - 65536) | 0) >>> 0) > 1048575)) {
                    var decoded__failure = $m_Ljava_nio_charset_CoderResult$().mc;
                    var decoded__high = 0;
                    var decoded__low = 0;
                  } else {
                    var offsetCodePoint = ((codePoint$2 - 65536) | 0);
                    var decoded__failure = null;
                    var decoded__high = (65535 & (55296 | (offsetCodePoint >> 10)));
                    var decoded__low = (65535 & (56320 | (1023 & offsetCodePoint)));
                  }
                }
              }
            }
          }
          if ((decoded__failure !== null)) {
            var result$3 = decoded__failure;
            var inPos$1$3 = inPos;
            var outPos$1$3 = outPos;
            $c_Ljava_nio_Buffer.prototype.cX.call(in$1, ((inPos$1$3 - o) | 0));
            $c_Ljava_nio_Buffer.prototype.cX.call(out, ((outPos$1$3 - o$1) | 0));
            return result$3;
          } else if ((decoded__low === 0)) {
            if ((outPos === outEnd)) {
              var result$4 = $m_Ljava_nio_charset_CoderResult$().ma;
              var inPos$1$4 = inPos;
              var outPos$1$4 = outPos;
              $c_Ljava_nio_Buffer.prototype.cX.call(in$1, ((inPos$1$4 - o) | 0));
              $c_Ljava_nio_Buffer.prototype.cX.call(out, ((outPos$1$4 - o$1) | 0));
              return result$4;
            } else {
              a$1.a[outPos] = decoded__high;
              var temp$inPos$2 = ((inPos + length) | 0);
              var temp$outPos$2 = ((1 + outPos) | 0);
              inPos = temp$inPos$2;
              outPos = temp$outPos$2;
            }
          } else if ((((2 + outPos) | 0) > outEnd)) {
            var result$5 = $m_Ljava_nio_charset_CoderResult$().ma;
            var inPos$1$5 = inPos;
            var outPos$1$5 = outPos;
            $c_Ljava_nio_Buffer.prototype.cX.call(in$1, ((inPos$1$5 - o) | 0));
            $c_Ljava_nio_Buffer.prototype.cX.call(out, ((outPos$1$5 - o$1) | 0));
            return result$5;
          } else {
            a$1.a[outPos] = decoded__high;
            a$1.a[((1 + outPos) | 0)] = decoded__low;
            var temp$inPos$3 = ((inPos + length) | 0);
            var temp$outPos$3 = ((2 + outPos) | 0);
            inPos = temp$inPos$3;
            outPos = temp$outPos$3;
          }
        }
      }
    }
  }
}
/** @constructor */
function $c_Ljava_nio_charset_UTF\uff3f8$Decoder() {
  this.a7i = 0.0;
  this.Zn = null;
  this.Zm = null;
  this.Zo = null;
  this.B4 = 0;
  $ct_Ljava_nio_charset_CharsetDecoder__Ljava_nio_charset_Charset__F__F__(this, $m_Ljava_nio_charset_UTF\uff3f8$(), 1.0, 1.0);
}
$p = $c_Ljava_nio_charset_UTF\uff3f8$Decoder.prototype = new $h_Ljava_nio_charset_CharsetDecoder();
$p.constructor = $c_Ljava_nio_charset_UTF\uff3f8$Decoder;
/** @constructor */
function $h_Ljava_nio_charset_UTF\uff3f8$Decoder() {
}
$h_Ljava_nio_charset_UTF\uff3f8$Decoder.prototype = $p;
$p.aZG = (function(in$1, out) {
  if ((((in$1.m9 !== null) && (!in$1.wt)) && ((out.lx !== null) && (!out.E6())))) {
    return $p_Ljava_nio_charset_UTF\uff3f8$Decoder__decodeLoopArray__Ljava_nio_ByteBuffer__Ljava_nio_CharBuffer__Ljava_nio_charset_CoderResult(this, in$1, out);
  } else {
    while (true) {
      var startPosition = in$1.b3;
      if ((in$1.b3 === in$1.c2)) {
        return $m_Ljava_nio_charset_CoderResult$().mb;
      } else {
        var leading = in$1.a3z();
        if ((leading >= 0)) {
          if ((out.b3 === out.c2)) {
            var result = $m_Ljava_nio_charset_CoderResult$().ma;
            $c_Ljava_nio_Buffer.prototype.cX.call(in$1, startPosition);
            return result;
          } else {
            out.XO((65535 & leading));
          }
        } else {
          var length = $m_Ljava_nio_charset_UTF\uff3f8$().a7n.a[(127 & leading)];
          if ((length === (-1))) {
            var result$1 = $m_Ljava_nio_charset_CoderResult$().mc;
            $c_Ljava_nio_Buffer.prototype.cX.call(in$1, startPosition);
            return result$1;
          } else {
            if ((in$1.b3 !== in$1.c2)) {
              var b2 = in$1.a3z();
              if (((192 & b2) !== 128)) {
                var decoded__failure = $m_Ljava_nio_charset_CoderResult$().mc;
                var decoded__high = 0;
                var decoded__low = 0;
              } else if ((length === 2)) {
                var b2$1 = b2;
                var codePoint = (((31 & leading) << 6) | (63 & b2$1));
                if ((codePoint < 128)) {
                  var decoded__failure = $m_Ljava_nio_charset_CoderResult$().mc;
                  var decoded__high = 0;
                  var decoded__low = 0;
                } else {
                  var decoded__failure = null;
                  var decoded__high = (65535 & codePoint);
                  var decoded__low = 0;
                }
              } else if ((in$1.b3 !== in$1.c2)) {
                var b3 = in$1.a3z();
                if (((192 & b3) !== 128)) {
                  var decoded__failure = $m_Ljava_nio_charset_CoderResult$().R1;
                  var decoded__high = 0;
                  var decoded__low = 0;
                } else if ((length === 3)) {
                  var b2$2 = b2;
                  var b3$1 = b3;
                  var codePoint$1 = ((((15 & leading) << 12) | ((63 & b2$2) << 6)) | (63 & b3$1));
                  if ((codePoint$1 < 2048)) {
                    var decoded__failure = $m_Ljava_nio_charset_CoderResult$().mc;
                    var decoded__high = 0;
                    var decoded__low = 0;
                  } else if (((((codePoint$1 - 55296) | 0) >>> 0) <= 2047)) {
                    var decoded__failure = $m_Ljava_nio_charset_CoderResult$().EP;
                    var decoded__high = 0;
                    var decoded__low = 0;
                  } else {
                    var decoded__failure = null;
                    var decoded__high = (65535 & codePoint$1);
                    var decoded__low = 0;
                  }
                } else if ((in$1.b3 !== in$1.c2)) {
                  var b4 = in$1.a3z();
                  if (((192 & b4) !== 128)) {
                    var decoded__failure = $m_Ljava_nio_charset_CoderResult$().EP;
                    var decoded__high = 0;
                    var decoded__low = 0;
                  } else {
                    var b2$3 = b2;
                    var b3$2 = b3;
                    var b4$1 = b4;
                    var codePoint$2 = (((((7 & leading) << 18) | ((63 & b2$3) << 12)) | ((63 & b3$2) << 6)) | (63 & b4$1));
                    if (((((codePoint$2 - 65536) | 0) >>> 0) > 1048575)) {
                      var decoded__failure = $m_Ljava_nio_charset_CoderResult$().mc;
                      var decoded__high = 0;
                      var decoded__low = 0;
                    } else {
                      var offsetCodePoint = ((codePoint$2 - 65536) | 0);
                      var decoded__failure = null;
                      var decoded__high = (65535 & (55296 | (offsetCodePoint >> 10)));
                      var decoded__low = (65535 & (56320 | (1023 & offsetCodePoint)));
                    }
                  }
                } else {
                  var decoded__failure = $m_Ljava_nio_charset_CoderResult$().mb;
                  var decoded__high = 0;
                  var decoded__low = 0;
                }
              } else {
                var decoded__failure = $m_Ljava_nio_charset_CoderResult$().mb;
                var decoded__high = 0;
                var decoded__low = 0;
              }
            } else {
              var decoded__failure = $m_Ljava_nio_charset_CoderResult$().mb;
              var decoded__high = 0;
              var decoded__low = 0;
            }
            if ((decoded__failure !== null)) {
              var result$2 = decoded__failure;
              $c_Ljava_nio_Buffer.prototype.cX.call(in$1, startPosition);
              return result$2;
            } else if ((decoded__low === 0)) {
              if ((out.b3 === out.c2)) {
                var result$3 = $m_Ljava_nio_charset_CoderResult$().ma;
                $c_Ljava_nio_Buffer.prototype.cX.call(in$1, startPosition);
                return result$3;
              } else {
                out.XO(decoded__high);
              }
            } else if ((((out.c2 - out.b3) | 0) < 2)) {
              var result$4 = $m_Ljava_nio_charset_CoderResult$().ma;
              $c_Ljava_nio_Buffer.prototype.cX.call(in$1, startPosition);
              return result$4;
            } else {
              out.XO(decoded__high);
              out.XO(decoded__low);
            }
          }
        }
      }
    }
  }
});
var $d_Ljava_nio_charset_UTF\uff3f8$Decoder = new $TypeData().i($c_Ljava_nio_charset_UTF\uff3f8$Decoder, "java.nio.charset.UTF_8$Decoder", ({
  sR: 1,
  sI: 1
}));
function $p_Ljava_nio_charset_UTF\uff3f8$Encoder__encodeLoopArray__Ljava_nio_CharBuffer__Ljava_nio_ByteBuffer__Ljava_nio_charset_CoderResult($thiz, in$1, out) {
  var a = in$1.lx;
  if ((a === null)) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  }
  if (in$1.E6()) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var o = in$1.nM;
  if ((o === (-1))) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  }
  if (in$1.E6()) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var inStart = ((in$1.b3 + o) | 0);
  var inEnd = ((in$1.c2 + o) | 0);
  var a$1 = out.m9;
  if ((a$1 === null)) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  }
  if (out.wt) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var o$1 = out.nL;
  if ((o$1 === (-1))) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  }
  if (out.wt) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var outStart = ((out.b3 + o$1) | 0);
  var outEnd = ((out.c2 + o$1) | 0);
  var inPos = inStart;
  var outPos = outStart;
  while (true) {
    if ((inPos === inEnd)) {
      var result = $m_Ljava_nio_charset_CoderResult$().mb;
      var inPos$2 = inPos;
      var outPos$2 = outPos;
      $c_Ljava_nio_Buffer.prototype.cX.call(in$1, ((inPos$2 - o) | 0));
      $c_Ljava_nio_Buffer.prototype.cX.call(out, ((outPos$2 - o$1) | 0));
      return result;
    } else {
      var c1 = a.a[inPos];
      if ((c1 < 128)) {
        if ((outPos === outEnd)) {
          var result$1 = $m_Ljava_nio_charset_CoderResult$().ma;
          var inPos$2$1 = inPos;
          var outPos$2$1 = outPos;
          $c_Ljava_nio_Buffer.prototype.cX.call(in$1, ((inPos$2$1 - o) | 0));
          $c_Ljava_nio_Buffer.prototype.cX.call(out, ((outPos$2$1 - o$1) | 0));
          return result$1;
        } else {
          a$1.a[outPos] = ((c1 << 24) >> 24);
          var temp$inPos = ((1 + inPos) | 0);
          var temp$outPos = ((1 + outPos) | 0);
          inPos = temp$inPos;
          outPos = temp$outPos;
        }
      } else if ((c1 < 2048)) {
        if ((((2 + outPos) | 0) > outEnd)) {
          var result$2 = $m_Ljava_nio_charset_CoderResult$().ma;
          var inPos$2$2 = inPos;
          var outPos$2$2 = outPos;
          $c_Ljava_nio_Buffer.prototype.cX.call(in$1, ((inPos$2$2 - o) | 0));
          $c_Ljava_nio_Buffer.prototype.cX.call(out, ((outPos$2$2 - o$1) | 0));
          return result$2;
        } else {
          a$1.a[outPos] = (((192 | (c1 >> 6)) << 24) >> 24);
          a$1.a[((1 + outPos) | 0)] = (((128 | (63 & c1)) << 24) >> 24);
          var temp$inPos$2 = ((1 + inPos) | 0);
          var temp$outPos$2 = ((2 + outPos) | 0);
          inPos = temp$inPos$2;
          outPos = temp$outPos$2;
        }
      } else if ((!($m_Ljava_nio_charset_UTF\uff3f8$(), ((63488 & c1) === 55296)))) {
        if ((((3 + outPos) | 0) > outEnd)) {
          var result$3 = $m_Ljava_nio_charset_CoderResult$().ma;
          var inPos$2$3 = inPos;
          var outPos$2$3 = outPos;
          $c_Ljava_nio_Buffer.prototype.cX.call(in$1, ((inPos$2$3 - o) | 0));
          $c_Ljava_nio_Buffer.prototype.cX.call(out, ((outPos$2$3 - o$1) | 0));
          return result$3;
        } else {
          a$1.a[outPos] = (((224 | (c1 >> 12)) << 24) >> 24);
          a$1.a[((1 + outPos) | 0)] = (((128 | (63 & (c1 >> 6))) << 24) >> 24);
          a$1.a[((2 + outPos) | 0)] = (((128 | (63 & c1)) << 24) >> 24);
          var temp$inPos$3 = ((1 + inPos) | 0);
          var temp$outPos$3 = ((3 + outPos) | 0);
          inPos = temp$inPos$3;
          outPos = temp$outPos$3;
        }
      } else if (((64512 & c1) === 55296)) {
        if ((((1 + inPos) | 0) === inEnd)) {
          var result$4 = $m_Ljava_nio_charset_CoderResult$().mb;
          var inPos$2$4 = inPos;
          var outPos$2$4 = outPos;
          $c_Ljava_nio_Buffer.prototype.cX.call(in$1, ((inPos$2$4 - o) | 0));
          $c_Ljava_nio_Buffer.prototype.cX.call(out, ((outPos$2$4 - o$1) | 0));
          return result$4;
        } else {
          var c2 = a.a[((1 + inPos) | 0)];
          if (((64512 & c2) !== 56320)) {
            var result$5 = $m_Ljava_nio_charset_CoderResult$().mc;
            var inPos$2$5 = inPos;
            var outPos$2$5 = outPos;
            $c_Ljava_nio_Buffer.prototype.cX.call(in$1, ((inPos$2$5 - o) | 0));
            $c_Ljava_nio_Buffer.prototype.cX.call(out, ((outPos$2$5 - o$1) | 0));
            return result$5;
          } else if ((((4 + outPos) | 0) > outEnd)) {
            var result$6 = $m_Ljava_nio_charset_CoderResult$().ma;
            var inPos$2$6 = inPos;
            var outPos$2$6 = outPos;
            $c_Ljava_nio_Buffer.prototype.cX.call(in$1, ((inPos$2$6 - o) | 0));
            $c_Ljava_nio_Buffer.prototype.cX.call(out, ((outPos$2$6 - o$1) | 0));
            return result$6;
          } else {
            var cp = ((((64 + (1023 & c1)) | 0) << 10) | (1023 & c2));
            a$1.a[outPos] = (((240 | (cp >> 18)) << 24) >> 24);
            a$1.a[((1 + outPos) | 0)] = (((128 | (63 & (cp >> 12))) << 24) >> 24);
            a$1.a[((2 + outPos) | 0)] = (((128 | (63 & (cp >> 6))) << 24) >> 24);
            a$1.a[((3 + outPos) | 0)] = (((128 | (63 & cp)) << 24) >> 24);
            var temp$inPos$4 = ((2 + inPos) | 0);
            var temp$outPos$4 = ((4 + outPos) | 0);
            inPos = temp$inPos$4;
            outPos = temp$outPos$4;
          }
        }
      } else {
        var result$7 = $m_Ljava_nio_charset_CoderResult$().mc;
        var inPos$2$7 = inPos;
        var outPos$2$7 = outPos;
        $c_Ljava_nio_Buffer.prototype.cX.call(in$1, ((inPos$2$7 - o) | 0));
        $c_Ljava_nio_Buffer.prototype.cX.call(out, ((outPos$2$7 - o$1) | 0));
        return result$7;
      }
    }
  }
}
/** @constructor */
function $c_Ljava_nio_charset_UTF\uff3f8$Encoder() {
  this.a7j = 0.0;
  this.Zq = null;
  this.Zp = null;
  this.Zr = null;
  this.B5 = 0;
  $ct_Ljava_nio_charset_CharsetEncoder__Ljava_nio_charset_Charset__F__F__(this, $m_Ljava_nio_charset_UTF\uff3f8$(), 1.100000023841858, 3.0);
}
$p = $c_Ljava_nio_charset_UTF\uff3f8$Encoder.prototype = new $h_Ljava_nio_charset_CharsetEncoder();
$p.constructor = $c_Ljava_nio_charset_UTF\uff3f8$Encoder;
/** @constructor */
function $h_Ljava_nio_charset_UTF\uff3f8$Encoder() {
}
$h_Ljava_nio_charset_UTF\uff3f8$Encoder.prototype = $p;
$p.b0C = (function(in$1, out) {
  if ((((in$1.lx !== null) && (!in$1.E6())) && ((out.m9 !== null) && (!out.wt)))) {
    return $p_Ljava_nio_charset_UTF\uff3f8$Encoder__encodeLoopArray__Ljava_nio_CharBuffer__Ljava_nio_ByteBuffer__Ljava_nio_charset_CoderResult(this, in$1, out);
  } else {
    while (true) {
      if ((in$1.b3 === in$1.c2)) {
        return $m_Ljava_nio_charset_CoderResult$().mb;
      } else {
        var c1 = in$1.agc();
        if ((c1 < 128)) {
          if ((out.b3 === out.c2)) {
            var result = $m_Ljava_nio_charset_CoderResult$().ma;
            $c_Ljava_nio_Buffer.prototype.cX.call(in$1, ((in$1.b3 - 1) | 0));
            return result;
          } else {
            out.yj(((c1 << 24) >> 24));
          }
        } else if ((c1 < 2048)) {
          if ((((out.c2 - out.b3) | 0) < 2)) {
            var result$1 = $m_Ljava_nio_charset_CoderResult$().ma;
            $c_Ljava_nio_Buffer.prototype.cX.call(in$1, ((in$1.b3 - 1) | 0));
            return result$1;
          } else {
            out.yj((((192 | (c1 >> 6)) << 24) >> 24));
            out.yj((((128 | (63 & c1)) << 24) >> 24));
          }
        } else if ((!($m_Ljava_nio_charset_UTF\uff3f8$(), ((63488 & c1) === 55296)))) {
          if ((((out.c2 - out.b3) | 0) < 3)) {
            var result$2 = $m_Ljava_nio_charset_CoderResult$().ma;
            $c_Ljava_nio_Buffer.prototype.cX.call(in$1, ((in$1.b3 - 1) | 0));
            return result$2;
          } else {
            out.yj((((224 | (c1 >> 12)) << 24) >> 24));
            out.yj((((128 | (63 & (c1 >> 6))) << 24) >> 24));
            out.yj((((128 | (63 & c1)) << 24) >> 24));
          }
        } else if (((64512 & c1) === 55296)) {
          if ((in$1.b3 === in$1.c2)) {
            var result$3 = $m_Ljava_nio_charset_CoderResult$().mb;
            $c_Ljava_nio_Buffer.prototype.cX.call(in$1, ((in$1.b3 - 1) | 0));
            return result$3;
          } else {
            var c2 = in$1.agc();
            if (((64512 & c2) !== 56320)) {
              var result$4 = $m_Ljava_nio_charset_CoderResult$().mc;
              $c_Ljava_nio_Buffer.prototype.cX.call(in$1, ((in$1.b3 - 2) | 0));
              return result$4;
            } else if ((((out.c2 - out.b3) | 0) < 4)) {
              var result$5 = $m_Ljava_nio_charset_CoderResult$().ma;
              $c_Ljava_nio_Buffer.prototype.cX.call(in$1, ((in$1.b3 - 2) | 0));
              return result$5;
            } else {
              var cp = ((((64 + (1023 & c1)) | 0) << 10) | (1023 & c2));
              out.yj((((240 | (cp >> 18)) << 24) >> 24));
              out.yj((((128 | (63 & (cp >> 12))) << 24) >> 24));
              out.yj((((128 | (63 & (cp >> 6))) << 24) >> 24));
              out.yj((((128 | (63 & cp)) << 24) >> 24));
            }
          }
        } else {
          var result$6 = $m_Ljava_nio_charset_CoderResult$().mc;
          $c_Ljava_nio_Buffer.prototype.cX.call(in$1, ((in$1.b3 - 1) | 0));
          return result$6;
        }
      }
    }
  }
});
var $d_Ljava_nio_charset_UTF\uff3f8$Encoder = new $TypeData().i($c_Ljava_nio_charset_UTF\uff3f8$Encoder, "java.nio.charset.UTF_8$Encoder", ({
  sS: 1,
  sJ: 1
}));
/** @constructor */
function $c_ju_AbstractMap() {
}
$p = $c_ju_AbstractMap.prototype = new $h_O();
$p.constructor = $c_ju_AbstractMap;
/** @constructor */
function $h_ju_AbstractMap() {
}
$h_ju_AbstractMap.prototype = $p;
$p.aa = (function() {
  return this.Ph().aa();
});
$p.agb = (function(key) {
  var _\uff3fself = this.Ph();
  var _\uff3fself$1 = _\uff3fself.r4();
  while (_\uff3fself$1.p()) {
    var x = _\uff3fself$1.q();
    var b = x.rl;
    if (((key === null) ? (b === null) : $dp_equals__O__Z(key, b))) {
      return x.nO;
    }
  }
  return null;
});
$p.e = (function(o) {
  if ((o === this)) {
    return true;
  } else if ($is_ju_Map(o)) {
    if ((this.aa() === o.aa())) {
      var _\uff3fself = this.Ph();
      var _\uff3fself$1 = _\uff3fself.r4();
      _return: {
        while (_\uff3fself$1.p()) {
          var t = _\uff3fself$1.q();
          var a = o.agb(t.rl);
          var b = t.nO;
          if ((!((a === null) ? (b === null) : $dp_equals__O__Z(a, b)))) {
            var $x_1 = true;
            break _return;
          }
        }
        var $x_1 = false;
      }
      return (!$x_1);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.x = (function() {
  var _\uff3fself = this.Ph();
  var _\uff3fself$1 = _\uff3fself.r4();
  var result = 0;
  while (_\uff3fself$1.p()) {
    var t = result;
    var u = _\uff3fself$1.q();
    var t$1 = (t | 0);
    result = ((u.x() + t$1) | 0);
  }
  return (result | 0);
});
$p.m = (function() {
  var result = "{";
  var first = true;
  var iter = this.Ph().r4();
  while (iter.p()) {
    var entry = iter.q();
    if (first) {
      first = false;
    } else {
      result = (result + ", ");
    }
    result = (((("" + result) + entry.rl) + "=") + entry.nO);
  }
  return (result + "}");
});
/** @constructor */
function $c_ju_Arrays$NaturalComparator$() {
}
$p = $c_ju_Arrays$NaturalComparator$.prototype = new $h_O();
$p.constructor = $c_ju_Arrays$NaturalComparator$;
/** @constructor */
function $h_ju_Arrays$NaturalComparator$() {
}
$h_ju_Arrays$NaturalComparator$.prototype = $p;
$p.dA = (function(o1, o2) {
  return $dp_compareTo__O__I(o1, o2);
});
var $d_ju_Arrays$NaturalComparator$ = new $TypeData().i($c_ju_Arrays$NaturalComparator$, "java.util.Arrays$NaturalComparator$", ({
  sV: 1,
  ad: 1
}));
var $n_ju_Arrays$NaturalComparator$;
function $m_ju_Arrays$NaturalComparator$() {
  if ((!$n_ju_Arrays$NaturalComparator$)) {
    $n_ju_Arrays$NaturalComparator$ = new $c_ju_Arrays$NaturalComparator$();
  }
  return $n_ju_Arrays$NaturalComparator$;
}
function $is_ju_Collection(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.bA)));
}
function $isArrayOf_ju_Collection(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bA)));
}
/** @constructor */
function $c_ju_Collections$EmptyIterator() {
}
$p = $c_ju_Collections$EmptyIterator.prototype = new $h_O();
$p.constructor = $c_ju_Collections$EmptyIterator;
/** @constructor */
function $h_ju_Collections$EmptyIterator() {
}
$h_ju_Collections$EmptyIterator.prototype = $p;
$p.p = (function() {
  return false;
});
$p.q = (function() {
  throw $ct_ju_NoSuchElementException__(new $c_ju_NoSuchElementException());
});
var $d_ju_Collections$EmptyIterator = new $TypeData().i($c_ju_Collections$EmptyIterator, "java.util.Collections$EmptyIterator", ({
  sY: 1,
  cm: 1
}));
/** @constructor */
function $c_ju_Formatter$RootLocaleInfo$() {
}
$p = $c_ju_Formatter$RootLocaleInfo$.prototype = new $h_ju_Formatter$LocaleInfo();
$p.constructor = $c_ju_Formatter$RootLocaleInfo$;
/** @constructor */
function $h_ju_Formatter$RootLocaleInfo$() {
}
$h_ju_Formatter$RootLocaleInfo$.prototype = $p;
var $d_ju_Formatter$RootLocaleInfo$ = new $TypeData().i($c_ju_Formatter$RootLocaleInfo$, "java.util.Formatter$RootLocaleInfo$", ({
  te: 1,
  td: 1
}));
var $n_ju_Formatter$RootLocaleInfo$;
function $m_ju_Formatter$RootLocaleInfo$() {
  if ((!$n_ju_Formatter$RootLocaleInfo$)) {
    $n_ju_Formatter$RootLocaleInfo$ = new $c_ju_Formatter$RootLocaleInfo$();
  }
  return $n_ju_Formatter$RootLocaleInfo$;
}
function $ct_ju_HashMap$Node__O__I__O__ju_HashMap$Node__ju_HashMap$Node__($thiz, key, hash, value, previous, next) {
  $thiz.rl = key;
  $thiz.B9 = hash;
  $thiz.nO = value;
  $thiz.ET = previous;
  $thiz.rm = next;
  return $thiz;
}
/** @constructor */
function $c_ju_HashMap$Node() {
  this.rl = null;
  this.B9 = 0;
  this.nO = null;
  this.ET = null;
  this.rm = null;
}
$p = $c_ju_HashMap$Node.prototype = new $h_O();
$p.constructor = $c_ju_HashMap$Node;
/** @constructor */
function $h_ju_HashMap$Node() {
}
$h_ju_HashMap$Node.prototype = $p;
$p.e = (function(that) {
  if ($is_ju_Map$Entry(that)) {
    var a = this.rl;
    var b = that.rl;
    if (((a === null) ? (b === null) : $dp_equals__O__Z(a, b))) {
      var a$1 = this.nO;
      var b$1 = that.nO;
      return ((a$1 === null) ? (b$1 === null) : $dp_equals__O__Z(a$1, b$1));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.x = (function() {
  var improvedHash = this.B9;
  var o = this.nO;
  return ((improvedHash ^ ((improvedHash >>> 16) | 0)) ^ ((o === null) ? 0 : $dp_hashCode__I(o)));
});
$p.m = (function() {
  return ((this.rl + "=") + this.nO);
});
var $d_ju_HashMap$Node = new $TypeData().i(0, "java.util.HashMap$Node", ({
  fb: 1,
  co: 1
}));
function $ct_ju_LinkedHashMap$AbstractLinkedHashMapIterator__ju_LinkedHashMap__($thiz, outer) {
  $thiz.Kc = outer.a7s;
  return $thiz;
}
/** @constructor */
function $c_ju_LinkedHashMap$AbstractLinkedHashMapIterator() {
  this.Kc = null;
}
$p = $c_ju_LinkedHashMap$AbstractLinkedHashMapIterator.prototype = new $h_O();
$p.constructor = $c_ju_LinkedHashMap$AbstractLinkedHashMapIterator;
/** @constructor */
function $h_ju_LinkedHashMap$AbstractLinkedHashMapIterator() {
}
$h_ju_LinkedHashMap$AbstractLinkedHashMapIterator.prototype = $p;
$p.p = (function() {
  return (this.Kc !== null);
});
$p.q = (function() {
  if ((!this.p())) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "next on empty iterator");
  }
  var node = this.Kc;
  this.Kc = node.EU;
  return this.aNW(node);
});
function $ps_ju_UUID$__fail$1__T__E(name$1) {
  throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Invalid UUID string: " + name$1));
}
/** @constructor */
function $c_ju_UUID$() {
}
$p = $c_ju_UUID$.prototype = new $h_O();
$p.constructor = $c_ju_UUID$;
/** @constructor */
function $h_ju_UUID$() {
}
$h_ju_UUID$.prototype = $p;
$p.b1S = (function(name) {
  if ((((((name.length !== 36) || (name.charCodeAt(8) !== 45)) || (name.charCodeAt(13) !== 45)) || (name.charCodeAt(18) !== 45)) || (name.charCodeAt(23) !== 45))) {
    $ps_ju_UUID$__fail$1__T__E(name);
  }
  try {
    var his = name.substring(0, 4);
    var los = name.substring(4, 8);
    var i1 = (($m_jl_Integer$().gc(his, 16, 134217728) << 16) | $m_jl_Integer$().gc(los, 16, 134217728));
    var his$1 = name.substring(9, 13);
    var los$1 = name.substring(14, 18);
    var i2 = (($m_jl_Integer$().gc(his$1, 16, 134217728) << 16) | $m_jl_Integer$().gc(los$1, 16, 134217728));
    var his$2 = name.substring(19, 23);
    var los$2 = name.substring(24, 28);
    var i3 = (($m_jl_Integer$().gc(his$2, 16, 134217728) << 16) | $m_jl_Integer$().gc(los$2, 16, 134217728));
    var his$3 = name.substring(28, 32);
    var los$3 = name.substring(32, 36);
    var i4 = (($m_jl_Integer$().gc(his$3, 16, 134217728) << 16) | $m_jl_Integer$().gc(los$3, 16, 134217728));
    return new $c_ju_UUID(i2, i1, i4, i3);
  } catch (e) {
    if ((e instanceof $c_jl_NumberFormatException)) {
      $ps_ju_UUID$__fail$1__T__E(name);
    } else {
      throw e;
    }
  }
});
var $d_ju_UUID$ = new $TypeData().i($c_ju_UUID$, "java.util.UUID$", ({
  tw: 1,
  a: 1
}));
var $n_ju_UUID$;
function $m_ju_UUID$() {
  if ((!$n_ju_UUID$)) {
    $n_ju_UUID$ = new $c_ju_UUID$();
  }
  return $n_ju_UUID$;
}
/** @constructor */
function $c_ju_concurrent_TimeUnit$() {
  this.Zx = null;
  this.a7v = null;
  this.a7w = null;
  this.a7y = null;
  this.a7x = null;
  this.a7u = null;
  this.R2 = null;
  $n_ju_concurrent_TimeUnit$ = this;
  this.Zx = new $c_ju_concurrent_TimeUnit$$anon$1();
  this.a7v = new $c_ju_concurrent_TimeUnit$$anon$2();
  this.a7w = new $c_ju_concurrent_TimeUnit$$anon$3();
  this.a7y = new $c_ju_concurrent_TimeUnit$$anon$4();
  this.a7x = new $c_ju_concurrent_TimeUnit$$anon$5();
  this.a7u = new $c_ju_concurrent_TimeUnit$$anon$6();
  this.R2 = new $c_ju_concurrent_TimeUnit$$anon$7();
}
$p = $c_ju_concurrent_TimeUnit$.prototype = new $h_O();
$p.constructor = $c_ju_concurrent_TimeUnit$;
/** @constructor */
function $h_ju_concurrent_TimeUnit$() {
}
$h_ju_concurrent_TimeUnit$.prototype = $p;
$p.kt = (function(a_$_lo, a_$_hi, b_$_lo, b_$_hi, max_$_lo, max_$_hi) {
  if (((a_$_hi === max_$_hi) ? ((a_$_lo >>> 0) > (max_$_lo >>> 0)) : (a_$_hi > max_$_hi))) {
    return $bL((-1), 2147483647);
  } else {
    var lo = ((-max_$_lo) | 0);
    var hi = ((((-max_$_hi) | 0) - ((lo !== 0) | 0)) | 0);
    if (((a_$_hi === hi) ? ((a_$_lo >>> 0) < (lo >>> 0)) : (a_$_hi < hi))) {
      return $bL(1, (-2147483648));
    } else {
      var a0 = (65535 & a_$_lo);
      var a1 = ((a_$_lo >>> 16) | 0);
      var b0 = (65535 & b_$_lo);
      var b1 = ((b_$_lo >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$1 = ((((((((Math.imul(a_$_lo, b_$_hi) + Math.imul(a_$_hi, b_$_lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      return $bL(lo$1, hi$1);
    }
  }
});
var $d_ju_concurrent_TimeUnit$ = new $TypeData().i($c_ju_concurrent_TimeUnit$, "java.util.concurrent.TimeUnit$", ({
  tz: 1,
  a: 1
}));
var $n_ju_concurrent_TimeUnit$;
function $m_ju_concurrent_TimeUnit$() {
  if ((!$n_ju_concurrent_TimeUnit$)) {
    $n_ju_concurrent_TimeUnit$ = new $c_ju_concurrent_TimeUnit$();
  }
  return $n_ju_concurrent_TimeUnit$;
}
function $ct_ju_concurrent_atomic_AtomicReference__O__($thiz, value) {
  $thiz.eo = value;
  return $thiz;
}
function $ct_ju_concurrent_atomic_AtomicReference__($thiz) {
  $ct_ju_concurrent_atomic_AtomicReference__O__($thiz, null);
  return $thiz;
}
/** @constructor */
function $c_ju_concurrent_atomic_AtomicReference() {
  this.eo = null;
}
$p = $c_ju_concurrent_atomic_AtomicReference.prototype = new $h_O();
$p.constructor = $c_ju_concurrent_atomic_AtomicReference;
/** @constructor */
function $h_ju_concurrent_atomic_AtomicReference() {
}
$h_ju_concurrent_atomic_AtomicReference.prototype = $p;
$p.Wv = (function(expect, update) {
  if (Object.is(expect, this.eo)) {
    this.eo = update;
    return true;
  } else {
    return false;
  }
});
$p.aON = (function(newValue) {
  var old = this.eo;
  this.eo = newValue;
  return old;
});
$p.m = (function() {
  return ("" + this.eo);
});
var $d_ju_concurrent_atomic_AtomicReference = new $TypeData().i($c_ju_concurrent_atomic_AtomicReference, "java.util.concurrent.atomic.AtomicReference", ({
  cr: 1,
  a: 1
}));
/** @constructor */
function $c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$() {
}
$p = $c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$.prototype = new $h_O();
$p.constructor = $c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$;
/** @constructor */
function $h_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$() {
}
$h_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$.prototype = $p;
$p.wf = (function(a, i, v) {
  a.a[i] = v;
});
$p.nA = (function(a, i) {
  return a.a[i];
});
var $d_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$ = new $TypeData().i($c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$, "java.util.internal.GenericArrayOps$ReusableAnyRefArrayOps$", ({
  tM: 1,
  bB: 1
}));
var $n_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$;
function $m_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$() {
  if ((!$n_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$)) {
    $n_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$ = new $c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$();
  }
  return $n_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$;
}
/** @constructor */
function $c_ju_regex_IndicesBuilder$AlternativesNode(alternatives) {
  this.rn = 0;
  this.EV = null;
  this.EV = alternatives;
}
$p = $c_ju_regex_IndicesBuilder$AlternativesNode.prototype = new $h_ju_regex_IndicesBuilder$Node();
$p.constructor = $c_ju_regex_IndicesBuilder$AlternativesNode;
/** @constructor */
function $h_ju_regex_IndicesBuilder$AlternativesNode() {
}
$h_ju_regex_IndicesBuilder$AlternativesNode.prototype = $p;
$p.nD = (function(newGroupIndex) {
  var nextIndex = $c_ju_regex_IndicesBuilder$Node.prototype.nD.call(this, newGroupIndex);
  var len = (this.EV.length | 0);
  var i = 0;
  while ((i !== len)) {
    nextIndex = this.EV[i].nD(nextIndex);
    i = ((1 + i) | 0);
  }
  return nextIndex;
});
$p.tU = (function(groupNodeMap) {
  var result = "(";
  var len = (this.EV.length | 0);
  var i = 0;
  while ((i !== len)) {
    if ((i !== 0)) {
      result = (result + "|");
    }
    result = (("" + result) + this.EV[i].tU(groupNodeMap));
    i = ((1 + i) | 0);
  }
  return (result + ")");
});
$p.wb = (function(matchResult, indices, start, end) {
  var len = (this.EV.length | 0);
  var i = 0;
  while ((i !== len)) {
    this.EV[i].wb(matchResult, indices, start, end);
    i = ((1 + i) | 0);
  }
});
var $d_ju_regex_IndicesBuilder$AlternativesNode = new $TypeData().i($c_ju_regex_IndicesBuilder$AlternativesNode, "java.util.regex.IndicesBuilder$AlternativesNode", ({
  tR: 1,
  bn: 1
}));
/** @constructor */
function $c_ju_regex_IndicesBuilder$BackReferenceNode(groupNumber) {
  this.rn = 0;
  this.a7z = 0;
  this.a7z = groupNumber;
}
$p = $c_ju_regex_IndicesBuilder$BackReferenceNode.prototype = new $h_ju_regex_IndicesBuilder$Node();
$p.constructor = $c_ju_regex_IndicesBuilder$BackReferenceNode;
/** @constructor */
function $h_ju_regex_IndicesBuilder$BackReferenceNode() {
}
$h_ju_regex_IndicesBuilder$BackReferenceNode.prototype = $p;
$p.tU = (function(groupNodeMap) {
  return (("(\\" + ((this.a7z >= (groupNodeMap.length | 0)) ? 0 : groupNodeMap[this.a7z].rn)) + ")");
});
$p.wb = (function(matchResult, indices, start, end) {
});
var $d_ju_regex_IndicesBuilder$BackReferenceNode = new $TypeData().i($c_ju_regex_IndicesBuilder$BackReferenceNode, "java.util.regex.IndicesBuilder$BackReferenceNode", ({
  tS: 1,
  bn: 1
}));
/** @constructor */
function $c_ju_regex_IndicesBuilder$GroupNode(number, inner) {
  this.rn = 0;
  this.atF = 0;
  this.Zz = null;
  this.atF = number;
  this.Zz = inner;
}
$p = $c_ju_regex_IndicesBuilder$GroupNode.prototype = new $h_ju_regex_IndicesBuilder$Node();
$p.constructor = $c_ju_regex_IndicesBuilder$GroupNode;
/** @constructor */
function $h_ju_regex_IndicesBuilder$GroupNode() {
}
$h_ju_regex_IndicesBuilder$GroupNode.prototype = $p;
$p.nD = (function(newGroupIndex) {
  return this.Zz.nD($c_ju_regex_IndicesBuilder$Node.prototype.nD.call(this, newGroupIndex));
});
$p.tU = (function(groupNodeMap) {
  return (("(" + this.Zz.tU(groupNodeMap)) + ")");
});
$p.wb = (function(matchResult, indices, start, end) {
  if ((matchResult[this.rn] !== (void 0))) {
    indices[this.atF] = [start, end];
  }
  this.Zz.wb(matchResult, indices, start, end);
});
var $d_ju_regex_IndicesBuilder$GroupNode = new $TypeData().i($c_ju_regex_IndicesBuilder$GroupNode, "java.util.regex.IndicesBuilder$GroupNode", ({
  tT: 1,
  bn: 1
}));
/** @constructor */
function $c_ju_regex_IndicesBuilder$LeafRegexNode(regex) {
  this.rn = 0;
  this.ZA = null;
  this.ZA = regex;
}
$p = $c_ju_regex_IndicesBuilder$LeafRegexNode.prototype = new $h_ju_regex_IndicesBuilder$Node();
$p.constructor = $c_ju_regex_IndicesBuilder$LeafRegexNode;
/** @constructor */
function $h_ju_regex_IndicesBuilder$LeafRegexNode() {
}
$h_ju_regex_IndicesBuilder$LeafRegexNode.prototype = $p;
$p.tU = (function(groupNodeMap) {
  return (("(" + this.ZA) + ")");
});
$p.wb = (function(matchResult, indices, start, end) {
});
function $isArrayOf_ju_regex_IndicesBuilder$LeafRegexNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fe)));
}
var $d_ju_regex_IndicesBuilder$LeafRegexNode = new $TypeData().i($c_ju_regex_IndicesBuilder$LeafRegexNode, "java.util.regex.IndicesBuilder$LeafRegexNode", ({
  fe: 1,
  bn: 1
}));
/** @constructor */
function $c_ju_regex_IndicesBuilder$LookAroundNode(isLookBehind, indicator, inner) {
  this.rn = 0;
  this.atH = false;
  this.atG = null;
  this.R3 = null;
  this.atH = isLookBehind;
  this.atG = indicator;
  this.R3 = inner;
}
$p = $c_ju_regex_IndicesBuilder$LookAroundNode.prototype = new $h_ju_regex_IndicesBuilder$Node();
$p.constructor = $c_ju_regex_IndicesBuilder$LookAroundNode;
/** @constructor */
function $h_ju_regex_IndicesBuilder$LookAroundNode() {
}
$h_ju_regex_IndicesBuilder$LookAroundNode.prototype = $p;
$p.nD = (function(newGroupIndex) {
  return this.R3.nD($c_ju_regex_IndicesBuilder$Node.prototype.nD.call(this, newGroupIndex));
});
$p.tU = (function(groupNodeMap) {
  return ((("((" + this.atG) + this.R3.tU(groupNodeMap)) + "))");
});
$p.wb = (function(matchResult, indices, start, end) {
  if (this.atH) {
    this.R3.aRd(matchResult, indices, end);
  } else {
    this.R3.aRe(matchResult, indices, start);
  }
});
var $d_ju_regex_IndicesBuilder$LookAroundNode = new $TypeData().i($c_ju_regex_IndicesBuilder$LookAroundNode, "java.util.regex.IndicesBuilder$LookAroundNode", ({
  tU: 1,
  bn: 1
}));
/** @constructor */
function $c_ju_regex_IndicesBuilder$RepeatedNode(inner, repeater) {
  this.rn = 0;
  this.ZB = null;
  this.atI = null;
  this.ZB = inner;
  this.atI = repeater;
}
$p = $c_ju_regex_IndicesBuilder$RepeatedNode.prototype = new $h_ju_regex_IndicesBuilder$Node();
$p.constructor = $c_ju_regex_IndicesBuilder$RepeatedNode;
/** @constructor */
function $h_ju_regex_IndicesBuilder$RepeatedNode() {
}
$h_ju_regex_IndicesBuilder$RepeatedNode.prototype = $p;
$p.nD = (function(newGroupIndex) {
  return this.ZB.nD($c_ju_regex_IndicesBuilder$Node.prototype.nD.call(this, newGroupIndex));
});
$p.tU = (function(groupNodeMap) {
  return ((("(" + this.ZB.tU(groupNodeMap)) + this.atI) + ")");
});
$p.wb = (function(matchResult, indices, start, end) {
  this.ZB.aRd(matchResult, indices, end);
});
var $d_ju_regex_IndicesBuilder$RepeatedNode = new $TypeData().i($c_ju_regex_IndicesBuilder$RepeatedNode, "java.util.regex.IndicesBuilder$RepeatedNode", ({
  tW: 1,
  bn: 1
}));
/** @constructor */
function $c_ju_regex_IndicesBuilder$SequenceNode(sequence) {
  this.rn = 0;
  this.EW = null;
  this.EW = sequence;
}
$p = $c_ju_regex_IndicesBuilder$SequenceNode.prototype = new $h_ju_regex_IndicesBuilder$Node();
$p.constructor = $c_ju_regex_IndicesBuilder$SequenceNode;
/** @constructor */
function $h_ju_regex_IndicesBuilder$SequenceNode() {
}
$h_ju_regex_IndicesBuilder$SequenceNode.prototype = $p;
$p.nD = (function(newGroupIndex) {
  var nextIndex = $c_ju_regex_IndicesBuilder$Node.prototype.nD.call(this, newGroupIndex);
  var len = (this.EW.length | 0);
  var i = 0;
  while ((i !== len)) {
    nextIndex = this.EW[i].nD(nextIndex);
    i = ((1 + i) | 0);
  }
  return nextIndex;
});
$p.tU = (function(groupNodeMap) {
  var result = "(";
  var len = (this.EW.length | 0);
  var i = 0;
  while ((i !== len)) {
    result = (("" + result) + this.EW[i].tU(groupNodeMap));
    i = ((1 + i) | 0);
  }
  return (result + ")");
});
$p.wb = (function(matchResult, indices, start, end) {
  var len = (this.EW.length | 0);
  var i = 0;
  var nextStart = start;
  while ((i !== len)) {
    nextStart = this.EW[i].aRe(matchResult, indices, nextStart);
    i = ((1 + i) | 0);
  }
});
var $d_ju_regex_IndicesBuilder$SequenceNode = new $TypeData().i($c_ju_regex_IndicesBuilder$SequenceNode, "java.util.regex.IndicesBuilder$SequenceNode", ({
  tX: 1,
  bn: 1
}));
function $p_ju_regex_Matcher__resetMatch__ju_regex_Matcher($thiz) {
  $thiz.R5 = 0;
  $thiz.yK = null;
  $thiz.Ke = 0;
  return $thiz;
}
function $p_ju_regex_Matcher__ensureLastMatch__O($thiz) {
  if (($thiz.yK === null)) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "No match available");
  }
  return $thiz.yK;
}
function $p_ju_regex_Matcher__startInternal__I__I($thiz, compiledGroup) {
  var x = $thiz.us.aOT($p_ju_regex_Matcher__ensureLastMatch__O($thiz), $thiz.R4)[compiledGroup];
  return ((x !== (void 0)) ? (((x[0] | 0) + $thiz.R6) | 0) : (-1));
}
function $p_ju_regex_Matcher__endInternal__I__I($thiz, compiledGroup) {
  var x = $thiz.us.aOT($p_ju_regex_Matcher__ensureLastMatch__O($thiz), $thiz.R4)[compiledGroup];
  return ((x !== (void 0)) ? (((x[1] | 0) + $thiz.R6) | 0) : (-1));
}
/** @constructor */
function $c_ju_regex_Matcher(pattern0, input0) {
  this.us = null;
  this.a7A = null;
  this.R6 = 0;
  this.yJ = null;
  this.R5 = 0;
  this.yK = null;
  this.R4 = false;
  this.Ke = 0;
  this.us = pattern0;
  this.a7A = input0;
  this.R6 = 0;
  this.yJ = this.a7A;
  this.R5 = 0;
  this.yK = null;
  this.R4 = false;
  this.Ke = 0;
}
$p = $c_ju_regex_Matcher.prototype = new $h_O();
$p.constructor = $c_ju_regex_Matcher;
/** @constructor */
function $h_ju_regex_Matcher() {
}
$h_ju_regex_Matcher.prototype = $p;
$p.aQd = (function() {
  $p_ju_regex_Matcher__resetMatch__ju_regex_Matcher(this);
  this.yK = this.us.b0W(this.yJ);
  this.R4 = true;
  return (this.yK !== null);
});
$p.aQ0 = (function() {
  $p_ju_regex_Matcher__resetMatch__ju_regex_Matcher(this);
  this.IV();
  if (((this.yK !== null) && (($p_ju_regex_Matcher__ensureLastMatch__O(this).index | 0) !== 0))) {
    $p_ju_regex_Matcher__resetMatch__ju_regex_Matcher(this);
  }
  return (this.yK !== null);
});
$p.IV = (function() {
  var this$1 = this.us;
  var input = this.yJ;
  var start = this.R5;
  var mtch = this$1.b3P(input, start);
  var end = (this$1.R9.lastIndex | 0);
  this.R5 = ((mtch !== null) ? ((end === (mtch.index | 0)) ? ((1 + end) | 0) : end) : ((1 + this.yJ.length) | 0));
  this.yK = mtch;
  this.R4 = false;
  return (mtch !== null);
});
$p.b1h = (function(start) {
  this.ahG();
  this.R5 = start;
  return this.IV();
});
$p.aM3 = (function(sb, replacement) {
  var this$1 = this.yJ;
  var beginIndex = this.Ke;
  var endIndex = this.AF();
  var csq = this$1.substring(beginIndex, endIndex);
  sb.ah = (("" + sb.ah) + csq);
  var len = replacement.length;
  var i = 0;
  while ((i < len)) {
    var index = i;
    var x1 = replacement.charCodeAt(index);
    switch (x1) {
      case 36: {
        i = ((1 + i) | 0);
        var j = i;
        while (((i < len) && ((((replacement.charCodeAt(i) - 48) | 0) >>> 0) <= 9))) {
          i = ((1 + i) | 0);
        }
        var $x_1 = $m_jl_Integer$();
        var endIndex$1 = i;
        var group = $x_1.gc(replacement.substring(j, endIndex$1), 10, 214748364);
        var replaced = this.aP1(group);
        if ((replaced !== null)) {
          sb.ah = (("" + sb.ah) + replaced);
        }
        break;
      }
      case 92: {
        i = ((1 + i) | 0);
        if ((i < len)) {
          var index$2 = i;
          var c$1 = replacement.charCodeAt(index$2);
          var str = ("" + $cToS(c$1));
          sb.ah = (sb.ah + str);
        }
        i = ((1 + i) | 0);
        break;
      }
      default: {
        var str$1 = ("" + $cToS(x1));
        sb.ah = (sb.ah + str$1);
        i = ((1 + i) | 0);
      }
    }
  }
  this.Ke = this.Ak();
  return this;
});
$p.aM4 = (function(sb) {
  var this$1 = this.yJ;
  var beginIndex = this.Ke;
  var str = this$1.substring(beginIndex);
  sb.ah = (("" + sb.ah) + str);
  this.Ke = this.yJ.length;
  return sb;
});
$p.b7F = (function(replacement) {
  this.ahG();
  if (this.IV()) {
    var sb = $ct_jl_StringBuilder__(new $c_jl_StringBuilder());
    this.aM3(sb, replacement);
    this.aM4(sb);
    return sb.ah;
  } else {
    return this.yJ;
  }
});
$p.aRG = (function(replacement) {
  this.ahG();
  var sb = $ct_jl_StringBuilder__(new $c_jl_StringBuilder());
  while (this.IV()) {
    this.aM3(sb, replacement);
  }
  this.aM4(sb);
  return sb.ah;
});
$p.ahG = (function() {
  this.R6 = 0;
  this.yJ = this.a7A;
  return $p_ju_regex_Matcher__resetMatch__ju_regex_Matcher(this);
});
$p.AF = (function() {
  return ((($p_ju_regex_Matcher__ensureLastMatch__O(this).index | 0) + this.R6) | 0);
});
$p.Ak = (function() {
  return ((this.AF() + this.agl().length) | 0);
});
$p.agl = (function() {
  return $p_ju_regex_Matcher__ensureLastMatch__O(this)[0];
});
$p.PX = (function(group) {
  return $p_ju_regex_Matcher__startInternal__I__I(this, this.us.ah8(group));
});
$p.WG = (function(group) {
  return $p_ju_regex_Matcher__endInternal__I__I(this, this.us.ah8(group));
});
$p.aP1 = (function(group) {
  var x = $p_ju_regex_Matcher__ensureLastMatch__O(this)[this.us.ah8(group)];
  return ((x !== (void 0)) ? x : null);
});
var $d_ju_regex_Matcher = new $TypeData().i($c_ju_regex_Matcher, "java.util.regex.Matcher", ({
  tZ: 1,
  tY: 1
}));
function $p_ju_regex_Pattern__indicesBuilder$lzycompute__ju_regex_IndicesBuilder($thiz) {
  if ((!$thiz.a7C)) {
    $thiz.a7E = $m_ju_regex_IndicesBuilder$().aXk($thiz.ZC, $thiz.R8);
    $thiz.a7C = true;
  }
  return $thiz.a7E;
}
function $p_ju_regex_Pattern__indicesBuilder__ju_regex_IndicesBuilder($thiz) {
  return ((!$thiz.a7C) ? $p_ju_regex_Pattern__indicesBuilder$lzycompute__ju_regex_IndicesBuilder($thiz) : $thiz.a7E);
}
/** @constructor */
function $c_ju_regex_Pattern(_pattern, _flags, jsPattern, jsFlags, sticky, groupCount, groupNumberMap, namedGroups) {
  this.a7E = null;
  this.a7B = null;
  this.ZC = null;
  this.R8 = null;
  this.a7F = false;
  this.R7 = 0;
  this.atJ = null;
  this.a7D = false;
  this.R9 = null;
  this.ZD = null;
  this.a7C = false;
  this.a7B = _pattern;
  this.ZC = jsPattern;
  this.R8 = jsFlags;
  this.a7F = sticky;
  this.R7 = groupCount;
  this.atJ = groupNumberMap;
  this.a7D = false;
  this.R9 = new RegExp(jsPattern, (this.R8 + (this.a7F ? "gy" : "g")));
  this.ZD = new RegExp((("^(?:" + jsPattern) + ")$"), jsFlags);
}
$p = $c_ju_regex_Pattern.prototype = new $h_O();
$p.constructor = $c_ju_regex_Pattern;
/** @constructor */
function $h_ju_regex_Pattern() {
}
$h_ju_regex_Pattern.prototype = $p;
$p.b0W = (function(input) {
  return this.ZD.exec(input);
});
$p.b3P = (function(input, start) {
  var regexp = this.R9;
  regexp.lastIndex = start;
  return regexp.exec(input);
});
$p.ah8 = (function(group) {
  var length = this.R7;
  if (((group >>> 0) > (length >>> 0))) {
    $m_jl_BoundsChecks$().b3D(group, length);
  }
  return (this.atJ[group] | 0);
});
$p.aOT = (function(lastMatch, forMatches) {
  if ((lastMatch.indices === (void 0))) {
    if ($m_ju_regex_PatternCompiler$().atP) {
      if ((!this.a7D)) {
        this.R9 = new RegExp(this.ZC, ((this.R8 + (this.a7F ? "gy" : "g")) + "d"));
        this.ZD = new RegExp((("^(?:" + this.ZC) + ")$"), (this.R8 + "d"));
        this.a7D = true;
      }
      var regexp = (forMatches ? this.ZD : this.R9);
      regexp.lastIndex = (lastMatch.index | 0);
      lastMatch.indices = regexp.exec(lastMatch.input).indices;
    } else {
      lastMatch.indices = $p_ju_regex_Pattern__indicesBuilder__ju_regex_IndicesBuilder(this).aXd(forMatches, lastMatch.input, (lastMatch.index | 0));
    }
  }
  return lastMatch.indices;
});
$p.m = (function() {
  return this.a7B;
});
$p.b3Q = (function(inputStr, limit) {
  if ((inputStr === "")) {
    return new ($d_T.r().C)([""]);
  } else {
    var lim = ((limit > 0) ? limit : 2147483647);
    var matcher = new $c_ju_regex_Matcher(this, inputStr);
    var result = [];
    var prevEnd = 0;
    while ((((result.length | 0) < ((lim - 1) | 0)) && matcher.IV())) {
      if ((matcher.Ak() !== 0)) {
        var beginIndex = prevEnd;
        var endIndex = matcher.AF();
        var $x_1 = result.push(inputStr.substring(beginIndex, endIndex));
      }
      prevEnd = matcher.Ak();
    }
    var beginIndex$1 = prevEnd;
    result.push(inputStr.substring(beginIndex$1));
    var actualLength = (result.length | 0);
    if ((limit === 0)) {
      while (true) {
        if ((actualLength !== 0)) {
          var x = result[((actualLength - 1) | 0)];
          var $x_2 = ((x !== null) && $dp_equals__O__Z(x, ""));
        } else {
          var $x_2 = false;
        }
        if ($x_2) {
          actualLength = ((actualLength - 1) | 0);
        } else {
          break;
        }
      }
    }
    var r = new ($d_T.r().C)(actualLength);
    var end = actualLength;
    var i = 0;
    while ((i < end)) {
      var value = i;
      r.a[value] = result[value];
      i = ((1 + i) | 0);
    }
    return r;
  }
});
var $d_ju_regex_Pattern = new $TypeData().i($c_ju_regex_Pattern, "java.util.regex.Pattern", ({
  u0: 1,
  a: 1
}));
/** @constructor */
function $c_ju_regex_Pattern$() {
}
$p = $c_ju_regex_Pattern$.prototype = new $h_O();
$p.constructor = $c_ju_regex_Pattern$;
/** @constructor */
function $h_ju_regex_Pattern$() {
}
$h_ju_regex_Pattern$.prototype = $p;
$p.agK = (function(regex, input) {
  return new $c_ju_regex_Matcher($m_ju_regex_PatternCompiler$().Wy(regex, 0), input).aQd();
});
var $d_ju_regex_Pattern$ = new $TypeData().i($c_ju_regex_Pattern$, "java.util.regex.Pattern$", ({
  u1: 1,
  a: 1
}));
var $n_ju_regex_Pattern$;
function $m_ju_regex_Pattern$() {
  if ((!$n_ju_regex_Pattern$)) {
    $n_ju_regex_Pattern$ = new $c_ju_regex_Pattern$();
  }
  return $n_ju_regex_Pattern$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$$anon$1() {
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$$anon$1.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$$anon$1.prototype = $p;
$p.aXf = (function(ctx) {
  return $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$__org$jpablo$graphexplorer$graphviz$dotlang$DotParser$$anon$1$$_$rec$1__Lfastparse_ParserInput__Lfastparse_ParsingRun__I__I__Lfastparse_ParsingRun(ctx.b0, ctx, ctx.G, 0);
});
var $d_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$$anon$1, "org.jpablo.graphexplorer.graphviz.dotlang.DotParser$$anon$1", ({
  uo: 1,
  re: 1
}));
function $p_Lorg_jpablo_graphexplorer_projects_DesktopLibrary__indexByOrigin__sci_Map__sci_Map($thiz, byId) {
  var this$1 = byId.e6().bM();
  var rest = this$1;
  var h = null;
  var t = null;
  while ((rest !== $m_sci_Nil$())) {
    var x0 = rest.t();
    var this$2 = x0.q3;
    if (this$2.c()) {
      var $x_1 = $m_s_None$();
    } else {
      var x0$1 = this$2.d();
      var this$3 = $m_Lorg_jpablo_graphexplorer_gxcore_model_OriginUri$package$OriginUri$().aO1(x0$1.wS);
      if (this$3.c()) {
        var $x_1 = $m_s_None$();
      } else {
        var x0$2 = this$3.d();
        var $x_1 = new $c_s_Some(new $c_T2(x0$2.split("\\").join("/"), new $c_Lorg_jpablo_graphexplorer_projects_BoundRecord(new $c_Lorg_jpablo_graphexplorer_viewer_state_ProjectId(x0.jE.kD), x0.kC, x0$1)));
      }
    }
    var it = $x_1.o();
    while (it.p()) {
      var nx = new $c_sci_$colon$colon(it.q(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        t.U = nx;
      }
      t = nx;
    }
    rest = rest.v();
  }
  var this$10 = ((h === null) ? $m_sci_Nil$() : h);
  var m = $m_scm_Map$().aO();
  var these = this$10;
  while ((!these.c())) {
    var x0$3 = these.t();
    var k = x0$3.g();
    m.ec(k, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => new $c_scm_ListBuffer()))).Y(x0$3.h());
    these = these.v();
  }
  var result = new $c_sc_IterableOps$Result$1(this$10);
  m.F(result);
  return result.zS;
}
function $p_Lorg_jpablo_graphexplorer_projects_DesktopLibrary__toDirectory__sci_Map__Lorg_jpablo_graphexplorer_projects_ProjectsDirectory($thiz, byId) {
  var this$3 = byId.e6().bM();
  var f = ((d) => {
    var $x_5 = new $c_Lorg_jpablo_graphexplorer_viewer_state_ProjectId(d.jE.kD);
    var $x_4 = d.n8;
    var $x_3 = d;
    var $x_2_$_lo = $x_3.xR;
    var $x_2_$_hi = $x_3.xS;
    var $x_1 = d;
    return new $c_Lorg_jpablo_graphexplorer_projects_ProjectInfo($x_5, $x_4, $x_2_$_lo, $x_2_$_hi, $x_1.tP, $x_1.tQ);
  });
  if ((this$3 === $m_sci_Nil$())) {
    var $x_6 = $m_sci_Nil$();
  } else {
    var x0 = this$3.t();
    var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
    var t = h;
    var rest = this$3.v();
    while ((rest !== $m_sci_Nil$())) {
      var x0$1 = rest.t();
      var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
      t.U = nx;
      t = nx;
      rest = rest.v();
    }
    var $x_6 = h;
  }
  return new $c_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O($x_6, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4) => {
    var $x_7 = _$4;
    var x_$_lo = $x_7.vP;
    var x_$_hi = $x_7.vQ;
    var lo = ((-x_$_lo) | 0);
    var hi = ((((-x_$_hi) | 0) - ((lo !== 0) | 0)) | 0);
    return $bL(lo, hi);
  })), $m_s_math_Ordering$Long$()));
}
function $p_Lorg_jpablo_graphexplorer_projects_DesktopLibrary__externalBus__T__Lcom_raquo_airstream_eventbus_EventBus($thiz, id) {
  return $thiz.auX.ec(id, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $m_Lcom_raquo_laminar_api_package$();
    return new $c_Lcom_raquo_airstream_eventbus_EventBus();
  })));
}
function $p_Lorg_jpablo_graphexplorer_projects_DesktopLibrary__writeNow__Lorg_jpablo_graphexplorer_viewer_state_ProjectId__Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState__Lorg_jpablo_graphexplorer_projects_LibraryMapping$Unparsed__V($thiz, id, state, unparsed) {
  var latest = $thiz.n9.P().aq().d().r(id.cv);
  var $x_3 = $m_Lorg_jpablo_graphexplorer_projects_LibraryMapping$();
  var $x_2 = new $c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId(id.cv);
  var $x_1 = $m_RTLong$().d1((+Date.now()));
  var diagram = $x_3.ba6($x_2, state, latest, unparsed, $x_1.l, $x_1.h);
  if ((!latest.c())) {
    var x0 = latest.d();
    var $x_14 = diagram.jE;
    var $x_13 = diagram.n8;
    var $x_12 = diagram.uG;
    var $x_11 = diagram.ru;
    var $x_10 = diagram.kC;
    var $x_9 = diagram.q3;
    var $x_8 = diagram.o4;
    var $x_7 = diagram;
    var $x_6_$_lo = $x_7.tP;
    var $x_6_$_hi = $x_7.tQ;
    var $x_5 = x0;
    var $x_4 = new $c_Lorg_jpablo_graphexplorer_gxcore_model_Diagram($x_14, $x_13, $x_12, $x_11, $x_10, $x_9, $x_8, $x_6_$_lo, $x_6_$_hi, $x_5.xR, $x_5.xS).e(x0);
  } else {
    var $x_4 = false;
  }
  if ((!$x_4)) {
    $p_Lorg_jpablo_graphexplorer_projects_DesktopLibrary__put__Lorg_jpablo_graphexplorer_gxcore_model_Diagram__V($thiz, diagram);
  }
}
function $p_Lorg_jpablo_graphexplorer_projects_DesktopLibrary__put__Lorg_jpablo_graphexplorer_gxcore_model_Diagram__V($thiz, d) {
  $f_Lcom_raquo_airstream_state_Var__update__F1__V($thiz.n9, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$10) => _$10.bN(d.jE.kD, d))));
  var json = $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($m_Lupickle_default$(), d, 2, ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lorg_jpablo_graphexplorer_gxcore_model_Diagram$().bm());
  $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$().u7("library_write", $m_sjs_js_special_package$().eA($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("name", ($m_Lorg_jpablo_graphexplorer_gxcore_store_DiagramFileName$().ah9(d.jE.kD) + ".json")), new $c_T2("json", json)])))).IT().oB(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e) => {
    console.error(((("could not save " + d.jE.kD) + ": ") + e.e3()));
  })), $m_s_concurrent_ExecutionContext$().ek());
}
function $p_Lorg_jpablo_graphexplorer_projects_DesktopLibrary__fileNameFor__Lorg_jpablo_graphexplorer_viewer_state_ProjectId__T($thiz, id) {
  return ($m_Lorg_jpablo_graphexplorer_gxcore_store_DiagramFileName$().ah9(id.cv) + ".json");
}
function $p_Lorg_jpablo_graphexplorer_projects_DesktopLibrary__schedule__Lorg_jpablo_graphexplorer_viewer_state_ProjectId__Lorg_jpablo_graphexplorer_projects_LibraryMapping$Unparsed__V($thiz, id, unparsed) {
  var this$1 = $thiz.BH.r(id.cv);
  if ((!this$1.c())) {
    var x0 = this$1.d();
    var handle = (x0 | 0);
    window.clearTimeout(handle);
  }
  var handle$1 = (window.setTimeout((() => {
    $thiz.BH = $thiz.BH.fz(id.cv);
    var this$4 = $thiz.uH.r(id.cv);
    if ((!this$4.c())) {
      var x0$1 = this$4.d();
      $thiz.uH = $thiz.uH.fz(id.cv);
      $p_Lorg_jpablo_graphexplorer_projects_DesktopLibrary__writeNow__Lorg_jpablo_graphexplorer_viewer_state_ProjectId__Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState__Lorg_jpablo_graphexplorer_projects_LibraryMapping$Unparsed__V($thiz, id, x0$1, unparsed);
    }
  }), 400.0) | 0);
  $thiz.BH = $thiz.BH.bN(id.cv, handle$1);
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_projects_DesktopLibrary(seed) {
  this.auY = null;
  this.auZ = false;
  this.n9 = null;
  this.uH = null;
  this.x0 = null;
  this.auW = null;
  this.auX = null;
  this.BH = null;
  this.n9 = $m_Lcom_raquo_laminar_api_package$().b.ff.bx(seed.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((d) => new $c_T2(d.jE.kD, d)))).eX($m_s_$less$colon$less$().b1));
  this.uH = $m_sci_Map$EmptyMap$();
  this.x0 = $m_sci_Map$EmptyMap$();
  window.addEventListener("ge:library.changed", ((_$1) => {
    this.b7l();
  }));
  var this$8 = $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), this.n9.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((byId) => $p_Lorg_jpablo_graphexplorer_projects_DesktopLibrary__indexByOrigin__sci_Map__sci_Map(this, byId))), $m_s_None$());
  var owner = this.Aw();
  this.auW = new $c_Lcom_raquo_airstream_state_ObservedSignal(this$8, $m_Lcom_raquo_airstream_core_Observer$().m5, owner);
  this.auX = $m_scm_Map$().aO();
  this.BH = $m_sci_Map$EmptyMap$();
}
$p = $c_Lorg_jpablo_graphexplorer_projects_DesktopLibrary.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_projects_DesktopLibrary;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_projects_DesktopLibrary() {
}
$h_Lorg_jpablo_graphexplorer_projects_DesktopLibrary.prototype = $p;
$p.Aw = (function() {
  if ((!this.auZ)) {
    this.auY = $m_Lcom_raquo_laminar_api_package$().b.a55();
    this.auZ = true;
  }
  return this.auY;
});
$p.IP = (function() {
  return $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), this.n9.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((byId) => $p_Lorg_jpablo_graphexplorer_projects_DesktopLibrary__toDirectory__sci_Map__Lorg_jpablo_graphexplorer_projects_ProjectsDirectory(this, byId))), $m_s_None$());
});
$p.XN = (function(id) {
  return this.n9.P().aq().d().E(id.cv);
});
$p.a4r = (function(id) {
  return $p_Lorg_jpablo_graphexplorer_projects_DesktopLibrary__externalBus__T__Lcom_raquo_airstream_eventbus_EventBus(this, id.cv).k5;
});
$p.XP = (function(path) {
  return this.auW.aq().d().ay(path.split("\\").join("/"), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_Nil$())));
});
$p.XE = (function(id) {
  var this$3 = this.n9.P().aq().d().r(id.cv);
  var this$4 = (this$3.c() ? $m_s_None$() : this$3.d().q3);
  return (this$4.c() ? $m_s_None$() : $m_Lorg_jpablo_graphexplorer_gxcore_model_OriginUri$package$OriginUri$().aO1(this$4.d().wS));
});
$p.a3E = (function(id) {
  return $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), this.n9.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$7) => {
    var this$1 = _$7.r(id.cv);
    var this$2 = (this$1.c() ? $m_s_None$() : new $c_s_Some(this$1.d().kC));
    return (this$2.c() ? $m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$().GZ : this$2.d());
  })), $m_s_None$());
});
$p.a3n = (function(dot) {
  return this.n9.P().aq().d().e6().nw(new $c_Lorg_jpablo_graphexplorer_projects_DesktopLibrary$$anon$1(dot));
});
$p.XM = (function(id, languages) {
  var this$3 = this.n9.P().aq().d().r(id.cv);
  if (this$3.c()) {
    return $m_s_None$();
  } else {
    var x0 = this$3.d();
    var s = x0.ru;
    try {
      var $x_1 = new $c_s_util_Success($m_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$().a5d(s));
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      matchEnd8: {
        var $x_1;
        if ($m_s_util_control_NonFatal$().ew(e$2)) {
          var $x_1 = new $c_s_util_Failure(e$2);
          break matchEnd8;
        }
        throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
      }
    }
    var this$5 = $x_1.rg();
    var format = (this$5.c() ? $m_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$().Pg(x0.kC) : this$5.d());
    var backend = languages.w3(format);
    if ((($f_T__trim__T(x0.n8) !== "") && (x0.n8 !== $m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$().GY))) {
      var $x_2 = x0.n8;
    } else {
      var this$8 = backend.a3l(x0.kC);
      var $x_2 = (this$8.c() ? x0.n8 : this$8.d());
    }
    return new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_projects_ProjectCardInfo(format, $x_2, backend.Aj(x0.kC)));
  }
});
$p.IM = (function(name) {
  var this$2 = $m_Lorg_jpablo_graphexplorer_viewer_utils_Utils$();
  var this$3 = $f_Lorg_jpablo_graphexplorer_viewer_utils_UtilsPlatform__randomUUID__T(this$2);
  var id = new $c_Lorg_jpablo_graphexplorer_viewer_state_ProjectId(this$3.split("-").join(""));
  var $x_1 = $m_RTLong$().d1((+Date.now()));
  var now_$_lo = $x_1.l;
  var now_$_hi = $x_1.h;
  $p_Lorg_jpablo_graphexplorer_projects_DesktopLibrary__put__Lorg_jpablo_graphexplorer_gxcore_model_Diagram__V(this, new $c_Lorg_jpablo_graphexplorer_gxcore_model_Diagram(new $c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId(id.cv), name, $m_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath$().a03, "", $m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$().GZ, $m_s_None$(), $m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$().auO, now_$_lo, now_$_hi, now_$_lo, now_$_hi));
  return id;
});
$p.a32 = (function(name, source) {
  var id = this.IM(name);
  var this$3 = this.n9.P().aq().d().r(id.cv);
  if ((!this$3.c())) {
    var x0 = this$3.d();
    var $x_1 = $m_RTLong$().d1((+Date.now()));
    var updatedAt$1_$_lo = $x_1.l;
    var updatedAt$1_$_hi = $x_1.h;
    var $x_8 = x0.jE;
    var $x_7 = x0.n8;
    var $x_6 = x0.uG;
    var $x_5 = x0.ru;
    var $x_4 = x0.q3;
    var $x_3 = x0.o4;
    var $x_2 = x0;
    $p_Lorg_jpablo_graphexplorer_projects_DesktopLibrary__put__Lorg_jpablo_graphexplorer_gxcore_model_Diagram__V(this, new $c_Lorg_jpablo_graphexplorer_gxcore_model_Diagram($x_8, $x_7, $x_6, $x_5, source, $x_4, $x_3, $x_2.tP, $x_2.tQ, updatedAt$1_$_lo, updatedAt$1_$_hi));
  }
  return id;
});
$p.WD = (function(id) {
  $f_Lcom_raquo_airstream_state_Var__update__F1__V(this.n9, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$9) => _$9.fz(id.cv))));
  this.uH = this.uH.fz(id.cv);
  this.x0 = this.x0.fz(id.cv);
  $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$().u7("library_delete", $m_sjs_js_special_package$().eA($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("name", $p_Lorg_jpablo_graphexplorer_projects_DesktopLibrary__fileNameFor__Lorg_jpablo_graphexplorer_viewer_state_ProjectId__T(this, id))])))).IT().oB(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e) => {
    console.error(((("could not delete " + id.cv) + ": ") + e.e3()));
  })), $m_s_concurrent_ExecutionContext$().ek());
});
$p.a34 = (function(id, initialSource) {
  var existing = this.n9.P().aq().d().r(id.cv);
  matchResult4: {
    var \u03b41$___1;
    var \u03b41$___2;
    matchResult3$1: {
      var x6;
      if ((existing instanceof $c_s_Some)) {
        var x6 = $m_Lorg_jpablo_graphexplorer_projects_LibraryMapping$().aSW(existing.J);
        break matchResult3$1;
      }
      if (($m_s_None$() === existing)) {
        var x6 = new $c_T2($m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$().Jb(initialSource), $m_Lorg_jpablo_graphexplorer_projects_LibraryMapping$Unparsed$().a8l);
        break matchResult3$1;
      }
      throw new $c_s_MatchError(existing);
    }
    if ((x6 !== null)) {
      var \u03b41$___1 = x6.g();
      var \u03b41$___2 = x6.h();
      break matchResult4;
    }
    throw new $c_s_MatchError(x6);
  }
  var initial$2 = \u03b41$___1;
  var unparsed$2 = \u03b41$___2;
  this.x0 = this.x0.bN(id.cv, initial$2.hf);
  var state = $m_Lcom_raquo_laminar_api_package$().b.ff.bx(initial$2);
  $f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription(new $c_Lcom_raquo_airstream_misc_StreamFromSignal($f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable(state.P()), true), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((next) => {
    this.uH = this.uH.bN(id.cv, next);
    $p_Lorg_jpablo_graphexplorer_projects_DesktopLibrary__schedule__Lorg_jpablo_graphexplorer_viewer_state_ProjectId__Lorg_jpablo_graphexplorer_projects_LibraryMapping$Unparsed__V(this, id, unparsed$2);
  })), this.Aw());
  $f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription(new $c_Lcom_raquo_airstream_misc_StreamFromSignal(this.n9.P(), true), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((byId) => {
    var this$15 = byId.r(id.cv);
    if ((!this$15.c())) {
      var x0 = this$15.d();
      if ((!this.uH.E(id.cv))) {
        matchResult5: {
          var fresh$2;
          var x9 = $m_Lorg_jpablo_graphexplorer_projects_LibraryMapping$().aSW(x0);
          if ((x9 !== null)) {
            var fresh$2 = x9.g();
            break matchResult5;
          }
          throw new $c_s_MatchError(x9);
        }
        var x$2 = state.P().aq().d();
        if ((!((fresh$2 === null) ? (x$2 === null) : fresh$2.e(x$2)))) {
          this.x0 = this.x0.bN(id.cv, fresh$2.hf);
          $f_Lcom_raquo_airstream_state_Var__set__O__V(state, fresh$2);
          $p_Lorg_jpablo_graphexplorer_projects_DesktopLibrary__externalBus__T__Lcom_raquo_airstream_eventbus_EventBus(this, id.cv).dn.bA(fresh$2);
        }
      } else if ((x0.kC !== this.x0.ay(id.cv, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((latest$2) => (() => latest$2.kC))(x0))))) {
        console.warn((("[library] " + id.cv) + " was edited on disk while you were typing; the on-screen version was kept."));
        this.x0 = this.x0.bN(id.cv, x0.kC);
      }
    }
  })), this.Aw());
  return state;
});
$p.Ef = (function(id, text, base) {
  var this$3 = this.n9.P().aq().d().r(id.cv);
  if ((!this$3.c())) {
    var x0 = this$3.d();
    var this$4 = x0.q3;
    if ((!this$4.c())) {
      var x0$1 = this$4.d();
      var $x_1 = $m_RTLong$().d1((+Date.now()));
      var at_$_lo = $x_1.l;
      var at_$_hi = $x_1.h;
      var text$1 = (text.c() ? x0.kC : text.d());
      var binding$2 = new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_gxcore_model_Binding(x0$1.wS, x0$1.z9, base, at_$_lo, at_$_hi));
      if ((!text.c())) {
        var updatedAt$2_$_lo = at_$_lo;
        var updatedAt$2_$_hi = at_$_hi;
      } else {
        var $x_2 = x0;
        var updatedAt$2_$_lo = $x_2.xR;
        var updatedAt$2_$_hi = $x_2.xS;
      }
      var $x_8 = x0.jE;
      var $x_7 = x0.n8;
      var $x_6 = x0.uG;
      var $x_5 = x0.ru;
      var $x_4 = x0.o4;
      var $x_3 = x0;
      $p_Lorg_jpablo_graphexplorer_projects_DesktopLibrary__put__Lorg_jpablo_graphexplorer_gxcore_model_Diagram__V(this, new $c_Lorg_jpablo_graphexplorer_gxcore_model_Diagram($x_8, $x_7, $x_6, $x_5, text$1, binding$2, $x_4, $x_3.tP, $x_3.tQ, updatedAt$2_$_lo, updatedAt$2_$_hi));
    }
  }
});
$p.WT = (function() {
  var outstanding = this.uH;
  this.uH = $m_sci_Map$EmptyMap$();
  this.BH.e6().F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => {
    var handle = (v1 | 0);
    window.clearTimeout(handle);
  })));
  this.BH = $m_sci_Map$EmptyMap$();
  outstanding.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    $p_Lorg_jpablo_graphexplorer_projects_DesktopLibrary__writeNow__Lorg_jpablo_graphexplorer_viewer_state_ProjectId__Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState__Lorg_jpablo_graphexplorer_projects_LibraryMapping$Unparsed__V(this, new $c_Lorg_jpablo_graphexplorer_viewer_state_ProjectId(x$1.g()), x$1.h(), $m_Lorg_jpablo_graphexplorer_projects_LibraryMapping$Unparsed$().a8l);
  })));
});
$p.b7l = (function() {
  return $m_Lorg_jpablo_graphexplorer_projects_DesktopLibrary$().agW().jX(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((loaded) => {
    $f_Lcom_raquo_airstream_state_Var__set__O__V(this.n9, loaded.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((d) => new $c_T2(d.jE.kD, d)))).eX($m_s_$less$colon$less$().b1));
  })), $m_s_concurrent_ExecutionContext$().ek());
});
var $d_Lorg_jpablo_graphexplorer_projects_DesktopLibrary = new $TypeData().i($c_Lorg_jpablo_graphexplorer_projects_DesktopLibrary, "org.jpablo.graphexplorer.projects.DesktopLibrary", ({
  wu: 1,
  h5: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_projects_DesktopMigration$CollectingSink(existing) {
  this.av1 = null;
  this.a05 = null;
  this.av1 = existing;
  this.a05 = $m_scm_Buffer$().f7();
}
$p = $c_Lorg_jpablo_graphexplorer_projects_DesktopMigration$CollectingSink.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_projects_DesktopMigration$CollectingSink;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_projects_DesktopMigration$CollectingSink() {
}
$h_Lorg_jpablo_graphexplorer_projects_DesktopMigration$CollectingSink.prototype = $p;
$p.aZ1 = (function(id) {
  if (this.av1.E(id.kD)) {
    return true;
  } else {
    var this$1 = this.a05;
    var res = false;
    var it = this$1.o();
    while (((!res) && it.p())) {
      res = (it.q().jE.kD === id.kD);
    }
    return res;
  }
});
$p.bc4 = (function(diagram) {
  this.a05.Y(diagram);
  return new $c_s_util_Right(diagram);
});
var $d_Lorg_jpablo_graphexplorer_projects_DesktopMigration$CollectingSink = new $TypeData().i($c_Lorg_jpablo_graphexplorer_projects_DesktopMigration$CollectingSink, "org.jpablo.graphexplorer.projects.DesktopMigration$CollectingSink", ({
  wA: 1,
  ws: 1
}));
function $p_Lorg_jpablo_graphexplorer_projects_ProjectStorage$__directoryStorage__Lio_laminext_core_StoredString($thiz) {
  if ((!$thiz.ava)) {
    $thiz.av7 = ($m_Lio_laminext_syntax_core$(), new $c_Lio_laminext_core_StoredString("graph-explorer.projects", $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($m_Lupickle_default$(), new $c_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory($m_sci_Nil$()), ($m_Lupickle_default$(), (-1)), ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory$().bm())));
    $thiz.ava = true;
  }
  return $thiz.av7;
}
function $p_Lorg_jpablo_graphexplorer_projects_ProjectStorage$__settingsStorage__Lio_laminext_core_StoredString($thiz) {
  if ((!$thiz.avh)) {
    $thiz.ave = ($m_Lio_laminext_syntax_core$(), new $c_Lio_laminext_core_StoredString($thiz.a8n, $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($m_Lupickle_default$(), $m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$().a0Y, ($m_Lupickle_default$(), (-1)), ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$().bm())));
    $thiz.avh = true;
    $thiz.a8n = null;
  }
  return $thiz.ave;
}
function $p_Lorg_jpablo_graphexplorer_projects_ProjectStorage$__directoryStorageNow__Lcom_raquo_airstream_state_OwnedSignal($thiz) {
  if ((!$thiz.av9)) {
    var this$1 = $p_Lorg_jpablo_graphexplorer_projects_ProjectStorage$__directoryStorage__Lio_laminext_core_StoredString($thiz).K2;
    var owner = $thiz.Aw();
    $thiz.av8 = new $c_Lcom_raquo_airstream_state_ObservedSignal(this$1, $m_Lcom_raquo_airstream_core_Observer$().m5, owner);
    $thiz.av9 = true;
  }
  return $thiz.av8;
}
function $p_Lorg_jpablo_graphexplorer_projects_ProjectStorage$__settingsStorageNow__Lcom_raquo_airstream_state_OwnedSignal($thiz) {
  if ((!$thiz.avg)) {
    var this$1 = $p_Lorg_jpablo_graphexplorer_projects_ProjectStorage$__settingsStorage__Lio_laminext_core_StoredString($thiz).K2;
    var owner = $thiz.Aw();
    $thiz.avf = new $c_Lcom_raquo_airstream_state_ObservedSignal(this$1, $m_Lcom_raquo_airstream_core_Observer$().m5, owner);
    $thiz.avg = true;
  }
  return $thiz.avf;
}
function $p_Lorg_jpablo_graphexplorer_projects_ProjectStorage$__rawKey__T__T($thiz, key) {
  return ("[StoredString]" + key);
}
function $p_Lorg_jpablo_graphexplorer_projects_ProjectStorage$__writeLocalStorage__T__T__V($thiz, key, value) {
  window.localStorage.setItem($p_Lorg_jpablo_graphexplorer_projects_ProjectStorage$__rawKey__T__T($thiz, key), value);
}
function $p_Lorg_jpablo_graphexplorer_projects_ProjectStorage$__removeLocalStorage__T__V($thiz, key) {
  window.localStorage.removeItem($p_Lorg_jpablo_graphexplorer_projects_ProjectStorage$__rawKey__T__T($thiz, key));
}
function $p_Lorg_jpablo_graphexplorer_projects_ProjectStorage$__storedProjectPayloadsExist__Z($thiz) {
  var prefix = $p_Lorg_jpablo_graphexplorer_projects_ProjectStorage$__rawKey__T__T($thiz, "graph-explorer.project.");
  var end = (window.localStorage.length | 0);
  var isEmpty = (end <= 0);
  var scala$collection$immutable$Range$$lastElement = ((end - 1) | 0);
  var res = false;
  var it = new $c_sci_RangeIterator(0, 1, scala$collection$immutable$Range$$lastElement, isEmpty);
  while (((!res) && it.g0)) {
    var x0 = it.hp();
    var this$5 = $m_s_Option$().as(window.localStorage.key(x0));
    if ((!this$5.c())) {
      var x0$1 = this$5.d();
      if ((!(!x0$1.startsWith(prefix)))) {
        var this$6 = $m_s_Option$().as(window.localStorage.getItem(x0$1));
        res = ((!this$6.c()) && (this$6.d().length > 2));
      } else {
        res = false;
      }
    } else {
      res = false;
    }
  }
  return res;
}
function $p_Lorg_jpablo_graphexplorer_projects_ProjectStorage$__projectKey__Lorg_jpablo_graphexplorer_viewer_state_ProjectId__T($thiz, id) {
  return ("graph-explorer.project." + id.cv);
}
function $p_Lorg_jpablo_graphexplorer_projects_ProjectStorage$__storedPayloadName$1__Lcom_raquo_airstream_state_OwnedSignal__T($thiz, projectStorageNow$1) {
  try {
    return $f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer($f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(projectStorageNow$1).d(), $m_Lujson_StringParser$()), ($m_Lupickle_default$(), false), $m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$().bm()).oc;
  } catch (e) {
    return "";
  }
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_projects_ProjectStorage$() {
  this.avc = null;
  this.avd = false;
  this.aU2 = null;
  this.a8n = null;
  this.av7 = null;
  this.ava = false;
  this.ave = null;
  this.avh = false;
  this.av8 = null;
  this.av9 = false;
  this.avf = null;
  this.avg = false;
  this.av6 = null;
  this.avb = false;
  this.FM = false;
  this.aU2 = "graph-explorer.projects";
  this.a8n = "graph-explorer.settings";
  this.FM = false;
}
$p = $c_Lorg_jpablo_graphexplorer_projects_ProjectStorage$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_projects_ProjectStorage$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_projects_ProjectStorage$() {
}
$h_Lorg_jpablo_graphexplorer_projects_ProjectStorage$.prototype = $p;
$p.XP = (function(path) {
  return $m_sci_Nil$();
});
$p.a4r = (function(id) {
  return $m_Lcom_raquo_airstream_core_EventStream$().Qr;
});
$p.XE = (function(id) {
  return $m_s_None$();
});
$p.Ef = (function(id, text, base) {
});
$p.WT = (function() {
});
$p.Aw = (function() {
  if ((!this.avd)) {
    this.avc = $m_Lcom_raquo_laminar_api_package$().b.a55();
    this.avd = true;
  }
  return this.avc;
});
$p.IP = (function() {
  if ((!this.avb)) {
    this.av6 = $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), $p_Lorg_jpablo_graphexplorer_projects_ProjectStorage$__directoryStorage__Lio_laminext_core_StoredString(this).K2, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => $f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer(_$1, $m_Lujson_StringParser$()), ($m_Lupickle_default$(), false), $m_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory$().bm()))), $m_s_None$());
    this.avb = true;
  }
  return this.av6;
});
$p.a34 = (function(id, initialSource) {
  var initialState = $m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$().Jb(initialSource);
  $m_Lio_laminext_syntax_core$();
  var projectStorage = new $c_Lio_laminext_core_StoredString($p_Lorg_jpablo_graphexplorer_projects_ProjectStorage$__projectKey__Lorg_jpablo_graphexplorer_viewer_state_ProjectId__T(this, id), $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($m_Lupickle_default$(), initialState, ($m_Lupickle_default$(), (-1)), ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$().bm()));
  var this$6 = projectStorage.K2;
  var owner = this.Aw();
  var projectStorageNow = new $c_Lcom_raquo_airstream_state_ObservedSignal(this$6, $m_Lcom_raquo_airstream_core_Observer$().m5, owner);
  try {
    var persistedDiagramState = $m_Lcom_raquo_laminar_api_package$().b.ff.bx($f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer($f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(projectStorageNow).d(), $m_Lujson_StringParser$()), ($m_Lupickle_default$(), false), $m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$().bm()));
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    console.error((("Error reading state: " + e$2) + ", defaulting to initial state"));
    var persistedDiagramState = $m_Lcom_raquo_laminar_api_package$().b.ff.bx(initialState);
  }
  $f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription(new $c_Lcom_raquo_airstream_misc_StreamFromSignal($f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable(persistedDiagramState.P()), true), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((state) => {
    var incoming = state.oc;
    if (($f_T__trim__T(incoming) !== "")) {
      var projectName$1 = incoming;
    } else {
      var storedName = $p_Lorg_jpablo_graphexplorer_projects_ProjectStorage$__storedPayloadName$1__Lcom_raquo_airstream_state_OwnedSignal__T(this, projectStorageNow);
      var projectName$1 = (($f_T__trim__T(storedName) !== "") ? storedName : incoming);
    }
    var guarded = new $c_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState(state.ob, state.oa, projectName$1, state.hf, state.nf, state.o9);
    projectStorage.Y0($f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($m_Lupickle_default$(), guarded, ($m_Lupickle_default$(), (-1)), ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$().bm()));
    var currentDir = $f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer($f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_projects_ProjectStorage$__directoryStorageNow__Lcom_raquo_airstream_state_OwnedSignal(this)).d(), $m_Lujson_StringParser$()), ($m_Lupickle_default$(), false), $m_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory$().bm());
    var this$33 = new $c_Lcom_softwaremill_quicklens_package$PathModify(currentDir, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2) => new $c_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory($f_Lcom_softwaremill_quicklens_package$QuicklensFunctor__eachWhere__O__F1__F1__O(new $c_Lcom_softwaremill_quicklens_package$QuicklensFunctor$given\uff3fQuicklensFunctor\uff3fS(), currentDir.hY, x$2, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3) => {
      var x$3 = _$3.eG;
      return ((x$3 === null) ? (id === null) : x$3.e(id));
    })))))));
    var mod = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((entry) => {
      var $x_1 = $m_RTLong$().d1((+Date.now()));
      var lastModified$1_$_lo = $x_1.l;
      var lastModified$1_$_hi = $x_1.h;
      var incoming$1 = guarded.oc;
      if (($f_T__trim__T(incoming$1) !== "")) {
        var name$1 = incoming$1;
      } else {
        var storedName$1 = entry.nb;
        var name$1 = (($f_T__trim__T(storedName$1) !== "") ? storedName$1 : incoming$1);
      }
      var $x_3 = entry.eG;
      var $x_2 = entry;
      return new $c_Lorg_jpablo_graphexplorer_projects_ProjectInfo($x_3, name$1, lastModified$1_$_lo, lastModified$1_$_hi, $x_2.ox, $x_2.oy);
    }));
    var updated = this$33.eF.i(mod);
    if (((currentDir.hY.c() && updated.hY.c()) && $p_Lorg_jpablo_graphexplorer_projects_ProjectStorage$__storedProjectPayloadsExist__Z(this))) {
      if ((!this.FM)) {
        this.FM = true;
        console.warn("The projects directory read as empty while project payloads exist in storage. No write was needed, but if the library looks empty in the UI this is the bug to chase. (Reported once per session.)");
      }
    } else {
      $p_Lorg_jpablo_graphexplorer_projects_ProjectStorage$__directoryStorage__Lio_laminext_core_StoredString(this).Y0($f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($m_Lupickle_default$(), updated, ($m_Lupickle_default$(), (-1)), ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory$().bm()));
    }
  })), this.Aw());
  return persistedDiagramState;
});
$p.aPY = (function() {
  try {
    var viewerSettings = $m_Lcom_raquo_laminar_api_package$().b.ff.bx($f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer($f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_projects_ProjectStorage$__settingsStorageNow__Lcom_raquo_airstream_state_OwnedSignal(this)).d(), $m_Lujson_StringParser$()), ($m_Lupickle_default$(), false), $m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$().bm()));
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    console.error(("Error reading viewer settings: " + e$2));
    var viewerSettings = $m_Lcom_raquo_laminar_api_package$().b.ff.bx($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$().a0Y);
  }
  $f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription(new $c_Lcom_raquo_airstream_misc_StreamFromSignal($f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable(viewerSettings.P()), true), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((settings) => {
    $p_Lorg_jpablo_graphexplorer_projects_ProjectStorage$__settingsStorage__Lio_laminext_core_StoredString($m_Lorg_jpablo_graphexplorer_projects_ProjectStorage$()).Y0($f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($m_Lupickle_default$(), settings, ($m_Lupickle_default$(), (-1)), ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$().bm()));
  })), this.Aw());
  return viewerSettings;
});
$p.b7f = (function() {
  try {
    return $f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer($f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_projects_ProjectStorage$__settingsStorageNow__Lcom_raquo_airstream_state_OwnedSignal(this)).d(), $m_Lujson_StringParser$()), ($m_Lupickle_default$(), false), $m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$().bm());
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    console.error(("Error reading viewer settings: " + e$2));
    return $m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$().a0Y;
  }
});
$p.IM = (function(name) {
  var $x_1 = $m_RTLong$().d1((+Date.now()));
  var now_$_lo = $x_1.l;
  var now_$_hi = $x_1.h;
  var this$3 = $m_Lorg_jpablo_graphexplorer_viewer_utils_Utils$();
  var this$4 = $f_Lorg_jpablo_graphexplorer_viewer_utils_UtilsPlatform__randomUUID__T(this$3);
  var projectInfo = new $c_Lorg_jpablo_graphexplorer_projects_ProjectInfo(new $c_Lorg_jpablo_graphexplorer_viewer_state_ProjectId(this$4.split("-").join("")), name, now_$_lo, now_$_hi, now_$_lo, now_$_hi);
  var currentDir = $f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer($f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_projects_ProjectStorage$__directoryStorageNow__Lcom_raquo_airstream_state_OwnedSignal(this)).d(), $m_Lujson_StringParser$()), ($m_Lupickle_default$(), false), $m_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory$().bm());
  var this$12 = new $c_Lcom_softwaremill_quicklens_package$PathModify(currentDir, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x) => new $c_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory(x.i(currentDir.hY)))));
  var mod = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6) => new $c_sci_$colon$colon(projectInfo, _$6)));
  var updated = this$12.eF.i(mod);
  if (((currentDir.hY.c() && updated.hY.c()) && $p_Lorg_jpablo_graphexplorer_projects_ProjectStorage$__storedProjectPayloadsExist__Z(this))) {
    if ((!this.FM)) {
      this.FM = true;
      console.warn("The projects directory read as empty while project payloads exist in storage. No write was needed, but if the library looks empty in the UI this is the bug to chase. (Reported once per session.)");
    }
  } else {
    $p_Lorg_jpablo_graphexplorer_projects_ProjectStorage$__directoryStorage__Lio_laminext_core_StoredString(this).Y0($f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($m_Lupickle_default$(), updated, ($m_Lupickle_default$(), (-1)), ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory$().bm()));
  }
  return projectInfo.eG;
});
$p.a32 = (function(name, source) {
  var id = this.IM(name);
  var $x_2 = $p_Lorg_jpablo_graphexplorer_projects_ProjectStorage$__projectKey__Lorg_jpablo_graphexplorer_viewer_state_ProjectId__T(this, id);
  var $x_1 = $m_Lupickle_default$();
  var \u03b41$ = $m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$().Jb(new $c_s_Some(source));
  $p_Lorg_jpablo_graphexplorer_projects_ProjectStorage$__writeLocalStorage__T__T__V(this, $x_2, $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($x_1, new $c_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState(\u03b41$.ob, \u03b41$.oa, name, \u03b41$.hf, \u03b41$.nf, \u03b41$.o9), ($m_Lupickle_default$(), (-1)), ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$().bm()));
  return id;
});
$p.WD = (function(id) {
  $p_Lorg_jpablo_graphexplorer_projects_ProjectStorage$__removeLocalStorage__T__V(this, $p_Lorg_jpablo_graphexplorer_projects_ProjectStorage$__projectKey__Lorg_jpablo_graphexplorer_viewer_state_ProjectId__T(this, id));
  var currentDir = $f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer($f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_projects_ProjectStorage$__directoryStorageNow__Lcom_raquo_airstream_state_OwnedSignal(this)).d(), $m_Lujson_StringParser$()), ($m_Lupickle_default$(), false), $m_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory$().bm());
  var this$5 = currentDir.hY;
  var f = ((_$7) => {
    var x = _$7.eG;
    return ((x === null) ? (id === null) : x.e(id));
  });
  var l = this$5;
  block: {
    var $x_1;
    while (true) {
      if (l.c()) {
        var $x_1 = $m_sci_Nil$();
        break;
      } else {
        var h = l.t();
        var t = l.v();
        if ((!(!f(h)))) {
          l = t;
          continue;
        }
        var start = l;
        var remaining = t;
        while (true) {
          if (remaining.c()) {
            var $x_1 = start;
            break block;
          } else {
            var x$1 = remaining.t();
            if ((!(!(!f(x$1))))) {
              remaining = remaining.v();
              continue;
            }
            var firstMiss = remaining;
            var newHead = new $c_sci_$colon$colon(start.t(), $m_sci_Nil$());
            var toProcess = start.v();
            var currentLast = newHead;
            while ((toProcess !== firstMiss)) {
              var newElem = new $c_sci_$colon$colon(toProcess.t(), $m_sci_Nil$());
              currentLast.U = newElem;
              currentLast = newElem;
              toProcess = toProcess.v();
            }
            var next = firstMiss.v();
            var nextToCopy = next;
            while ((!next.c())) {
              var head = next.t();
              if ((!(!(!f(head))))) {
                next = next.v();
              } else {
                while ((nextToCopy !== next)) {
                  var newElem$2 = new $c_sci_$colon$colon(nextToCopy.t(), $m_sci_Nil$());
                  currentLast.U = newElem$2;
                  currentLast = newElem$2;
                  nextToCopy = nextToCopy.v();
                }
                nextToCopy = next.v();
                next = next.v();
              }
            }
            if ((!nextToCopy.c())) {
              currentLast.U = nextToCopy;
            }
            var $x_1 = newHead;
            break block;
          }
        }
      }
    }
  }
  var updated = new $c_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory($x_1);
  if (((currentDir.hY.c() && updated.hY.c()) && $p_Lorg_jpablo_graphexplorer_projects_ProjectStorage$__storedProjectPayloadsExist__Z(this))) {
    if ((!this.FM)) {
      this.FM = true;
      console.warn("The projects directory read as empty while project payloads exist in storage. No write was needed, but if the library looks empty in the UI this is the bug to chase. (Reported once per session.)");
    }
  } else {
    $p_Lorg_jpablo_graphexplorer_projects_ProjectStorage$__directoryStorage__Lio_laminext_core_StoredString(this).Y0($f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($m_Lupickle_default$(), updated, ($m_Lupickle_default$(), (-1)), ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory$().bm()));
  }
});
$p.a3E = (function(id) {
  return $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), ($m_Lio_laminext_syntax_core$(), new $c_Lio_laminext_core_StoredString($p_Lorg_jpablo_graphexplorer_projects_ProjectStorage$__projectKey__Lorg_jpablo_graphexplorer_viewer_state_ProjectId__T(this, id), $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($m_Lupickle_default$(), $m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$().a0S, ($m_Lupickle_default$(), (-1)), ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$().bm()))).K2, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((stateStr) => {
    try {
      return $f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer(stateStr, $m_Lujson_StringParser$()), ($m_Lupickle_default$(), false), $m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$().bm()).hf;
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      console.error(("Error reading state: " + e$2));
      return $m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$().GZ;
    }
  })), $m_s_None$());
});
$p.b79 = (function() {
  var this$1 = $m_s_Option$().as(window.localStorage.getItem($p_Lorg_jpablo_graphexplorer_projects_ProjectStorage$__rawKey__T__T(this, "graph-explorer.projects")));
  return (this$1.c() ? $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($m_Lupickle_default$(), new $c_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory($m_sci_Nil$()), ($m_Lupickle_default$(), (-1)), ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory$().bm()) : this$1.d());
});
$p.b7a = (function(projectId) {
  return $m_s_Option$().as(window.localStorage.getItem($p_Lorg_jpablo_graphexplorer_projects_ProjectStorage$__rawKey__T__T(this, ("graph-explorer.project." + projectId))));
});
$p.b7c = (function(key) {
  return $m_s_Option$().as(window.localStorage.getItem($p_Lorg_jpablo_graphexplorer_projects_ProjectStorage$__rawKey__T__T(this, key)));
});
$p.aNv = (function() {
  return $f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer($f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_projects_ProjectStorage$__directoryStorageNow__Lcom_raquo_airstream_state_OwnedSignal(this)).d(), $m_Lujson_StringParser$()), ($m_Lupickle_default$(), false), $m_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory$().bm());
});
$p.XM = (function(id, languages) {
  try {
    var $x_1 = $m_Lupickle_default$();
    var key = $p_Lorg_jpablo_graphexplorer_projects_ProjectStorage$__projectKey__Lorg_jpablo_graphexplorer_viewer_state_ProjectId__T(this, id);
    var this$1 = $m_s_Option$().as(window.localStorage.getItem($p_Lorg_jpablo_graphexplorer_projects_ProjectStorage$__rawKey__T__T(this, key)));
    var state = $f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($x_1, new $c_Lujson_Readable$fromTransformer((this$1.c() ? $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($m_Lupickle_default$(), $m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$().a0S, ($m_Lupickle_default$(), (-1)), ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$().bm()) : this$1.d()), $m_Lujson_StringParser$()), ($m_Lupickle_default$(), false), $m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$().bm());
    var this$9 = state.nf;
    if (this$9.c()) {
      var $x_2 = $m_s_None$();
    } else {
      var x0 = this$9.d();
      try {
        var $x_3 = new $c_s_util_Success($m_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$().a5d(x0));
      } catch (e) {
        var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
        matchEnd8: {
          var $x_3;
          if ($m_s_util_control_NonFatal$().ew(e$2)) {
            var $x_3 = new $c_s_util_Failure(e$2);
            break matchEnd8;
          }
          throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
        }
      }
      var $x_2 = $x_3.rg();
    }
    var this$11 = $x_2;
    var format = (this$11.c() ? $m_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$().Pg(state.hf) : this$11.d());
    var name = state.oc;
    var backend = languages.w3(format);
    if ((($f_T__trim__T(name) !== "") && (name !== $m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$().GY))) {
      var $x_4 = name;
    } else {
      var this$14 = backend.a3l(state.hf);
      var $x_4 = (this$14.c() ? name : this$14.d());
    }
    return new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_projects_ProjectCardInfo(format, $x_4, backend.Aj(state.hf)));
  } catch (e$1) {
    return $m_s_None$();
  }
});
$p.XN = (function(id) {
  var this$1 = this.aNv().hY;
  var these = this$1;
  while ((!these.c())) {
    var x0 = these.t();
    var x = x0.eG;
    if (((x === null) ? (id === null) : x.e(id))) {
      return true;
    }
    these = these.v();
  }
  return false;
});
$p.a3n = (function(dot) {
  return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this.aNv().hY, $m_s_PartialFunction$().baE(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((info) => {
    try {
      var $x_1 = $m_Lupickle_default$();
      var this$1 = $m_Lorg_jpablo_graphexplorer_projects_ProjectStorage$();
      var key = $p_Lorg_jpablo_graphexplorer_projects_ProjectStorage$__projectKey__Lorg_jpablo_graphexplorer_viewer_state_ProjectId__T($m_Lorg_jpablo_graphexplorer_projects_ProjectStorage$(), info.eG);
      var this$2 = $m_s_Option$().as(window.localStorage.getItem($p_Lorg_jpablo_graphexplorer_projects_ProjectStorage$__rawKey__T__T(this$1, key)));
      if (($f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($x_1, new $c_Lujson_Readable$fromTransformer((this$2.c() ? $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($m_Lupickle_default$(), $m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$().a0S, ($m_Lupickle_default$(), (-1)), ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$().bm()) : this$2.d()), $m_Lujson_StringParser$()), ($m_Lupickle_default$(), false), $m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$().bm()).hf === dot)) {
        return new $c_s_Some(info.eG);
      } else {
        return $m_s_None$();
      }
    } catch (e) {
      return $m_s_None$();
    }
  }))));
});
var $d_Lorg_jpablo_graphexplorer_projects_ProjectStorage$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_projects_ProjectStorage$, "org.jpablo.graphexplorer.projects.ProjectStorage$", ({
  wN: 1,
  h5: 1
}));
var $n_Lorg_jpablo_graphexplorer_projects_ProjectStorage$;
function $m_Lorg_jpablo_graphexplorer_projects_ProjectStorage$() {
  if ((!$n_Lorg_jpablo_graphexplorer_projects_ProjectStorage$)) {
    $n_Lorg_jpablo_graphexplorer_projects_ProjectStorage$ = new $c_Lorg_jpablo_graphexplorer_projects_ProjectStorage$();
  }
  return $n_Lorg_jpablo_graphexplorer_projects_ProjectStorage$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_DefaultDiagramLanguages(graphviz, x$2) {
  this.a8v = null;
  this.a8w = null;
  this.a8v = new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_GraphvizBackend(graphviz);
  this.a8w = ($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$(), new $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend(x$2));
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_DefaultDiagramLanguages.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_DefaultDiagramLanguages;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_DefaultDiagramLanguages() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_DefaultDiagramLanguages.prototype = $p;
$p.aWU = (function() {
  return new $c_sci_$colon$colon(this.a8w, new $c_sci_$colon$colon(this.a8v, $m_sci_Nil$()));
});
$p.w3 = (function(format) {
  var x = $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__DOT__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat();
  if (((x === null) ? (format === null) : (x === format))) {
    return this.a8v;
  }
  var x$3 = $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__Mermaid__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat();
  if (((x$3 === null) ? (format === null) : (x$3 === format))) {
    return this.a8w;
  }
  throw new $c_s_MatchError(format);
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_DefaultDiagramLanguages = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_DefaultDiagramLanguages, "org.jpablo.graphexplorer.viewer.backends.DefaultDiagramLanguages", ({
  x0: 1,
  x3: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_GraphvizBackend(graphviz) {
  this.a8D = null;
  this.a8D = graphviz;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_GraphvizBackend.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_GraphvizBackend;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_GraphvizBackend() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_GraphvizBackend.prototype = $p;
$p.aOk = (function() {
  return $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__DOT__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat();
});
$p.agw = (function() {
  return new $c_Lorg_jpablo_graphexplorer_viewer_backends_DiagramLanguageInfo("Graphviz (DOT)", "DOT source", "https://www.graphviz.org/documentation/", "Visit the Graphviz documentation for more information");
});
$p.aSK = (function(text) {
  return $m_s_concurrent_Future$().aga(this.a8D.aSL(text).ua(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((simpleGraph) => $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ToViewerGraph$package$().baf(simpleGraph)))));
});
$p.X3 = (function(graph, omitInternal) {
  return $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$().aiz(graph, omitInternal);
});
$p.a3l = (function(text) {
  return $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$().b2g(text);
});
$p.Aj = (function(text) {
  return $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$().Aj(text);
});
$p.aS0 = (function() {
  return $m_Lorg_jpablo_graphexplorer_viewer_components_selection_GraphvizSelectionStrategy$();
});
$p.aRD = (function(inputs) {
  return $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), inputs.Lo, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((dot) => this.a8D.b9T(new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_DotText(dot)).rg())), $m_s_None$());
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_GraphvizBackend = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_GraphvizBackend, "org.jpablo.graphexplorer.viewer.backends.graphviz.GraphvizBackend", ({
  xm: 1,
  hf: 1
}));
function $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend__parseMermaid__T__s_concurrent_Future($thiz, text) {
  var promise = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
  var completed = new $c_sr_BooleanRef(false);
  console.info(("[mermaid] getDiagramFromText start len=" + text.length));
  $m_sjs_js_timers_package$().ym(2000.0, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    if ((!completed.dy)) {
      console.warn("[mermaid] getDiagramFromText still pending after 2s");
    }
  })));
  $i_mermaid.default.mermaidAPI.getDiagramFromText(text).then(((diagram) => {
    completed.dy = true;
    try {
      var this$4 = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$().b8n(diagram);
      if (this$4.c()) {
        throw new $c_Lorg_jpablo_graphexplorer_viewer_backends_RenderOnlyDiagram(diagram.type, (("\u201c" + diagram.type) + "\u201d diagrams are render-only: the canvas draws and live-updates from the source, but selection and editing are available for flowcharts only."));
      }
      var yy = this$4.d();
      var vertices = $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend__convertVertices__sjs_js_Dictionary__sci_Map($thiz, $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$().aPC(yy.getVertices()));
      var jsEdges = yy.getEdges();
      var edges = $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend__convertEdges__Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidEdgesJS__sci_List($thiz, jsEdges);
      var edgesWithSourceLabels = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidEdgeLabelFallback$().bbX(text, edges);
      var subgraphs = $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend__convertSubgraphs__sjs_js_Array__sci_List($thiz, yy.getSubGraphs());
      matchResult3: {
        var \u03b41$___1;
        var \u03b41$___2;
        var x3 = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassAssignmentFallback$().bbV(text, vertices, subgraphs);
        if ((x3 !== null)) {
          var \u03b41$___1 = x3.g();
          var \u03b41$___2 = x3.h();
          break matchResult3;
        }
        throw new $c_s_MatchError(x3);
      }
      var verticesWithSourceClasses$2 = \u03b41$___1;
      var subgraphsWithSourceClasses$2 = \u03b41$___2;
      var verticesWithSourceLabels = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidVertexLabelFallback$().bbY(text, verticesWithSourceClasses$2);
      var verticesWithSourceCoverage = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidMissingVertexFallback$().bbZ(text, verticesWithSourceLabels, edgesWithSourceLabels, subgraphsWithSourceClasses$2);
      var classDefs = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassDefFallback$().bbW(text, $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend__convertClassDefs__sjs_js_Dictionary__sci_Map($thiz, $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$().aPC(yy.getClasses())));
      var x = jsEdges.defaultStyle;
      var this$12 = ((x === (void 0)) ? $m_s_None$() : new $c_s_Some(x));
      var this$16 = (this$12.c() ? $m_s_None$() : new $c_s_Some($m_sci_Nil$().b6($ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), this$12.d()))));
      var defaultEdgeStyle = (this$16.c() ? $m_sci_Nil$() : this$16.d());
      var x$1 = jsEdges.defaultInterpolate;
      var defaultEdgeInterpolate = ((x$1 === (void 0)) ? $m_s_None$() : new $c_s_Some(x$1));
      var x$2 = yy.getDirection();
      var direction = ((x$2 === (void 0)) ? $m_s_None$() : new $c_s_Some(x$2));
      var x$3 = yy.getDiagramTitle();
      var this$32 = ((x$3 === (void 0)) ? $m_s_None$() : new $c_s_Some(x$3));
      var this$35 = ((this$32.c() || (this$32.d() !== "")) ? this$32 : $m_s_None$());
      if (this$35.c()) {
        var x$4 = yy.getAccTitle();
        var this$41 = ((x$4 === (void 0)) ? $m_s_None$() : new $c_s_Some(x$4));
        var title = ((this$41.c() || (this$41.d() !== "")) ? this$41 : $m_s_None$());
      } else {
        var title = this$35;
      }
      console.info(((((((((((((("[mermaid] parsed vertices=" + vertices.aa()) + " edges=") + edges.C()) + " subgraphs=") + subgraphs.C()) + " classDefs=") + classDefs.aa()) + " defaultEdgeStyle=") + (!defaultEdgeStyle.c())) + " dir=") + (direction.c() ? "" : direction.d())) + " title=") + (title.c() ? "" : title.d())));
      $f_s_concurrent_Promise__success__O__s_concurrent_Promise(promise, new $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidGraph(verticesWithSourceCoverage, edgesWithSourceLabels, subgraphsWithSourceClasses$2, direction, title, classDefs, defaultEdgeStyle, defaultEdgeInterpolate));
      return (void 0);
    } catch (e) {
      $f_s_concurrent_Promise__failure__jl_Throwable__s_concurrent_Promise(promise, ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e)));
      return (void 0);
    }
  }), ((error) => {
    completed.dy = true;
    $f_s_concurrent_Promise__failure__jl_Throwable__s_concurrent_Promise(promise, $ct_jl_Exception__T__(new $c_jl_Exception(), $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$().aNV("parsing", error, text)));
  }));
  return promise;
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend__renderMermaid__T__T__s_concurrent_Future($thiz, id, text) {
  var promise = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
  $i_mermaid.default.render(id, text).then(((renderResult) => $f_s_concurrent_Promise__success__O__s_concurrent_Promise(promise, renderResult.svg)), ((error) => $f_s_concurrent_Promise__failure__jl_Throwable__s_concurrent_Promise(promise, $ct_jl_Exception__T__(new $c_jl_Exception(), $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$().aNV("rendering", error, text)))));
  return promise;
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend__extractEdgePositions__Lorg_scalajs_dom_SVGSVGElement__sci_Map($thiz, svg) {
  var nodeList = svg.querySelectorAll($m_Lorg_jpablo_graphexplorer_viewer_components_selection_MermaidSelectionStrategy$().a3a());
  var positions = $m_scm_Map$().dr($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([])));
  var end = (nodeList.length | 0);
  var isEmpty = (end <= 0);
  var scala$collection$immutable$Range$$lastElement = ((end - 1) | 0);
  if ((!isEmpty)) {
    var i = 0;
    while (true) {
      var x0 = i;
      var elem = nodeList.item(x0);
      if ((!(!(elem instanceof SVGPathElement)))) {
        var pathOpt = new $c_s_Some(elem);
      } else {
        var this$6 = $m_s_Option$().as(elem.querySelector("path"));
        var pf = new $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$$anon$2();
        var pathOpt = ((!this$6.c()) ? new $c_s_PartialFunction$Lifted(pf).as(this$6.d()) : $m_s_None$());
      }
      if ((!pathOpt.c())) {
        var x0$1 = pathOpt.d();
        try {
          var total = (+x0$1.getTotalLength());
          var start = x0$1.getPointAtLength(0.0);
          var end$1 = x0$1.getPointAtLength(total);
          var startPoint = new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_Point((+start.x), (-(+start.y)));
          var endPoint = new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_Point((+end$1.x), (-(+end$1.y)));
          var arrowId = $m_Lorg_jpablo_graphexplorer_viewer_components_selection_MermaidSelectionStrategy$().afE(x0$1).l3;
          positions.cY(arrowId, new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ArrowPosition(startPoint, endPoint, $m_sci_Nil$()));
        } catch (e) {
        }
      }
      if ((i === scala$collection$immutable$Range$$lastElement)) {
        break;
      }
      i = ((1 + i) | 0);
    }
  }
  return $m_sci_Map$().ao(positions);
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend__convertVertices__sjs_js_Dictionary__sci_Map($thiz, jsVertices) {
  var $x_1 = $m_sci_Map$();
  var b = new $c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder();
  var it = new $c_sjs_js_WrappedDictionary$DictionaryIterator(jsVertices);
  while (it.p()) {
    var x0 = it.dC();
    matchResult7: {
      var elem___1;
      var elem___2;
      if ((x0 !== null)) {
        var id = x0.g();
        var v = x0.h();
        var id$1 = v.id;
        var text = v.text;
        var x = v.labelType;
        var labelType = ((x === (void 0)) ? $m_s_None$() : new $c_s_Some(x));
        var x$1 = v.domId;
        var domId = ((x$1 === (void 0)) ? $m_s_None$() : new $c_s_Some(x$1));
        var x$2 = v.styles;
        var this$18 = ((x$2 === (void 0)) ? $m_s_None$() : new $c_s_Some(x$2));
        var this$22 = (this$18.c() ? $m_s_None$() : new $c_s_Some($m_sci_Nil$().b6($ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), this$18.d()))));
        var styles = (this$22.c() ? $m_sci_Nil$() : this$22.d());
        var x$3 = v.classes;
        var this$28 = ((x$3 === (void 0)) ? $m_s_None$() : new $c_s_Some(x$3));
        var this$32 = (this$28.c() ? $m_s_None$() : new $c_s_Some($m_sci_Nil$().b6($ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), this$28.d()))));
        var classes = (this$32.c() ? $m_sci_Nil$() : this$32.d());
        var x$4 = v.type;
        var elem___1 = id;
        var elem___2 = new $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidVertex(id$1, text, labelType, domId, styles, classes, ((x$4 === (void 0)) ? $m_s_None$() : new $c_s_Some(x$4)));
        break matchResult7;
      }
      throw new $c_s_MatchError(x0);
    }
    var dict = b.Vw;
    var key = elem___1;
    var value = elem___2;
    dict[key] = value;
  }
  return $x_1.ao(b.ahK());
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend__convertEdges__Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidEdgesJS__sci_List($thiz, jsEdges) {
  var $x_2 = $m_sci_Nil$();
  var len = (jsEdges.length | 0);
  var res = new Array(len);
  var i = 0;
  while ((i < len)) {
    var $x_1 = i;
    var x0 = jsEdges[i];
    var start = x0.start;
    var end = x0.end;
    var x = x0.type;
    var edgeType = ((x === (void 0)) ? $m_s_None$() : new $c_s_Some(x));
    var x$1 = x0.text;
    var this$13 = ((x$1 === (void 0)) ? $m_s_None$() : new $c_s_Some(x$1));
    var text = ((this$13.c() || (this$13.d() !== "")) ? this$13 : $m_s_None$());
    var x$2 = x0.labelType;
    var labelType = ((x$2 === (void 0)) ? $m_s_None$() : new $c_s_Some(x$2));
    var x$3 = x0.stroke;
    var stroke = ((x$3 === (void 0)) ? $m_s_None$() : new $c_s_Some(x$3));
    var x$4 = x0.style;
    var this$31 = ((x$4 === (void 0)) ? $m_s_None$() : new $c_s_Some(x$4));
    var this$35 = (this$31.c() ? $m_s_None$() : new $c_s_Some($m_sci_Nil$().b6($ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), this$31.d()))));
    var styles = (this$35.c() ? $m_sci_Nil$() : this$35.d());
    var x$5 = x0.interpolate;
    res[$x_1] = new $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidEdge(start, end, edgeType, text, labelType, stroke, styles, ((x$5 === (void 0)) ? $m_s_None$() : new $c_s_Some(x$5)));
    i = ((1 + i) | 0);
  }
  return $x_2.b6($ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), res));
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend__convertSubgraphs__sjs_js_Array__sci_List($thiz, jsSubgraphs) {
  var $x_4 = $m_sci_Nil$();
  var len = (jsSubgraphs.length | 0);
  var res = new Array(len);
  var i = 0;
  while ((i < len)) {
    var $x_3 = i;
    var x0 = jsSubgraphs[i];
    var id = x0.id;
    var x = x0.title;
    var $x_2 = ((x === (void 0)) ? $m_s_None$() : new $c_s_Some(x));
    var x$1 = x0.nodes;
    var this$13 = ((x$1 === (void 0)) ? $m_s_None$() : new $c_s_Some(x$1));
    var this$17 = (this$13.c() ? $m_s_None$() : new $c_s_Some($m_sci_Nil$().b6($ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), this$13.d()))));
    var $x_1 = (this$17.c() ? $m_sci_Nil$() : this$17.d());
    var x$2 = x0.classes;
    var this$23 = ((x$2 === (void 0)) ? $m_s_None$() : new $c_s_Some(x$2));
    var this$27 = (this$23.c() ? $m_s_None$() : new $c_s_Some($m_sci_Nil$().b6($ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), this$23.d()))));
    res[$x_3] = new $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSubgraph(id, $x_2, $x_1, (this$27.c() ? $m_sci_Nil$() : this$27.d()));
    i = ((1 + i) | 0);
  }
  return $x_4.b6($ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), res));
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend__convertClassDefs__sjs_js_Dictionary__sci_Map($thiz, jsClasses) {
  var $x_2 = $m_sci_Map$();
  var b = new $c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder();
  var it = new $c_sjs_js_WrappedDictionary$DictionaryIterator(jsClasses);
  while (it.p()) {
    var x0 = it.dC();
    matchResult8: {
      var elem___1;
      var elem___2;
      if ((x0 !== null)) {
        var id = x0.g();
        var cd = x0.h();
        var x = cd.styles;
        var this$8 = ((x === (void 0)) ? $m_s_None$() : new $c_s_Some(x));
        var this$12 = (this$8.c() ? $m_s_None$() : new $c_s_Some($m_sci_Nil$().b6($ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), this$8.d()))));
        var $x_1 = (this$12.c() ? $m_sci_Nil$() : this$12.d());
        var x$1 = cd.textStyles;
        var this$18 = ((x$1 === (void 0)) ? $m_s_None$() : new $c_s_Some(x$1));
        var this$22 = (this$18.c() ? $m_s_None$() : new $c_s_Some($m_sci_Nil$().b6($ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), this$18.d()))));
        var elem___1 = id;
        var elem___2 = new $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassDef($x_1, (this$22.c() ? $m_sci_Nil$() : this$22.d()));
        break matchResult8;
      }
      throw new $c_s_MatchError(x0);
    }
    var dict = b.Vw;
    var key = elem___1;
    var value = elem___2;
    dict[key] = value;
  }
  return $x_2.ao(b.ahK());
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend(x$1) {
  this.BX = null;
  this.BX = x$1;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend.prototype = $p;
$p.aOk = (function() {
  return $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__Mermaid__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat();
});
$p.agw = (function() {
  return new $c_Lorg_jpablo_graphexplorer_viewer_backends_DiagramLanguageInfo("MermaidJS", "Mermaid source", "https://mermaid.js.org/intro/", "Visit the Mermaid documentation for more information");
});
$p.aSK = (function(text) {
  $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$().aNJ();
  return $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$().aQL(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend__parseMermaid__T__s_concurrent_Future(this, text).jX(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((mermaidGraph) => $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_ToViewerGraph$package$().bag(mermaidGraph))), this.BX))), this.BX);
});
$p.aSM = (function(text) {
  $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$().aNJ();
  return $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$().aQL(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    var renderId = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$().b52();
    var defaultEdgeMarkerColor = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$().b13(text);
    console.info(((("[mermaid] textToSvg start id=" + renderId) + " len=") + text.length));
    return $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend__renderMermaid__T__T__s_concurrent_Future(this, renderId, text).jX(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((svgString) => {
      var svg = $m_Lorg_jpablo_graphexplorer_viewer_domUtils_SvgParser$package$().XH($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$().aZB(svgString));
      $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$().b59(svg.e8, defaultEdgeMarkerColor);
      var edgePositions = $p_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend__extractEdgePositions__Lorg_scalajs_dom_SVGSVGElement__sci_Map(this, svg.e8);
      $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$().aeD(svg.e8);
      console.info(((("[mermaid] textToSvg complete id=" + renderId) + " edges=") + edgePositions.aa()));
      return new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_SvgWithPositions(svg, edgePositions);
    })), this.BX);
  })), this.BX);
});
$p.X3 = (function(graph, omitInternal) {
  return $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$().bbo(graph);
});
$p.a3l = (function(text) {
  return $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$().aZV(text);
});
$p.Aj = (function(text) {
  return $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$().Aj(text);
});
$p.aS0 = (function() {
  return $m_Lorg_jpablo_graphexplorer_viewer_components_selection_MermaidSelectionStrategy$();
});
$p.aRD = (function(inputs) {
  var this$1 = inputs.Su;
  var project = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((differs) => ((!(!differs)) ? inputs.Lo : inputs.St)));
  var this$7 = $f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable($m_Lcom_raquo_airstream_core_Observable$().AL.mK($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), this$1, project, $m_s_None$())));
  var project$1 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((mermaidText) => {
    if (($f_T__trim__T(mermaidText) === "")) {
      return $m_Lcom_raquo_airstream_state_Val$().iT(new $c_s_Some($m_s_None$()));
    } else {
      var detected = $m_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$().Pg(mermaidText);
      var x$2 = $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__Mermaid__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat();
      if ((!((detected === null) ? (x$2 === null) : (detected === x$2)))) {
        console.warn((("[mermaid] Text does not look like Mermaid (detected: " + detected) + "); attempting render anyway"));
      }
      return $m_Lcom_raquo_airstream_core_Signal$().b1L(this.aSM(mermaidText).jX(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => new $c_s_Some(_$1))), this.BX).AC(new $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$$anon$1(), this.BX), this.BX);
    }
  }));
  return $f_Lcom_raquo_airstream_core_Signal__scanLeft__F1__F2__Lcom_raquo_airstream_core_Signal($m_Lcom_raquo_airstream_core_Observable$().AL.mK(this$7.fQ(project$1)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((first) => (first.c() ? $m_s_None$() : first.d()))), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((last, next) => (next.c() ? last : next.d()))));
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend, "org.jpablo.graphexplorer.viewer.backends.mermaid.MermaidBackend", ({
  xR: 1,
  hf: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_selection_GraphvizSelectionStrategy$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_selection_GraphvizSelectionStrategy$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_selection_GraphvizSelectionStrategy$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_selection_GraphvizSelectionStrategy$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_selection_GraphvizSelectionStrategy$.prototype = $p;
$p.aPo = (function(e) {
  return $f_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElementStrategy__isEdge__Lorg_scalajs_dom_Element__Z(this, e);
});
$p.Jc = (function() {
  return "g.node";
});
$p.a3a = (function() {
  return "g.edge";
});
$p.Ws = (function() {
  return "g.cluster";
});
$p.aPb = (function(elems) {
  var selectors = elems.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((id) => (("[id='" + id.kx()) + "']"))));
  return ((!selectors.c()) ? new $c_s_Some($f_sc_IterableOnceOps__mkString__T__T__T__T(selectors, "", ",", "")) : $m_s_None$());
});
$p.afF = (function(e) {
  var title = e.querySelector("title");
  return ((title !== null) ? ($m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$(), new $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId(title.textContent)) : ($m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$(), new $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId(e.id)));
});
$p.afE = (function(e) {
  var svgId = e.id;
  var this$1 = $m_Lorg_jpablo_graphexplorer_viewer_models_Arrow$().WZ(svgId);
  if (this$1.c()) {
    var title = e.querySelector("title");
    var $x_1 = ((title !== null) ? ($m_Lorg_jpablo_graphexplorer_viewer_models_ArrowId$(), new $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowId(title.textContent)) : ($m_Lorg_jpablo_graphexplorer_viewer_models_ArrowId$(), new $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowId(svgId)));
  } else {
    var $x_1 = this$1.d();
  }
  return $x_1;
});
$p.a3k = (function(e) {
  var svgId = e.id;
  var this$1 = $m_Lorg_jpablo_graphexplorer_viewer_models_GroupId$().WZ(svgId);
  if (this$1.c()) {
    var title = e.querySelector("title");
    var $x_1 = ((title !== null) ? ($m_Lorg_jpablo_graphexplorer_viewer_models_GroupId$(), new $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId(title.textContent)) : ($m_Lorg_jpablo_graphexplorer_viewer_models_GroupId$(), new $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId(svgId)));
  } else {
    var $x_1 = this$1.d();
  }
  return $x_1;
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_selection_GraphvizSelectionStrategy$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_selection_GraphvizSelectionStrategy$, "org.jpablo.graphexplorer.viewer.components.selection.GraphvizSelectionStrategy$", ({
  zt: 1,
  hZ: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_selection_GraphvizSelectionStrategy$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_selection_GraphvizSelectionStrategy$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_selection_GraphvizSelectionStrategy$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_selection_GraphvizSelectionStrategy$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_selection_GraphvizSelectionStrategy$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_selection_GraphvizSelectionStrategy$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_selection_MermaidSelectionStrategy$__classList__Lorg_scalajs_dom_Element__sci_Seq($thiz, e) {
  var end = (e.classList.length | 0);
  var isEmpty = (end <= 0);
  var scala$collection$immutable$Range$$lastElement = ((end - 1) | 0);
  var b = $m_sci_IndexedSeq$().b5();
  var it = new $c_sci_RangeIterator(0, 1, scala$collection$immutable$Range$$lastElement, isEmpty);
  while (it.g0) {
    var x0 = it.hp();
    b.dG($m_s_Option$().as(e.classList.item(x0)));
  }
  return b.aR();
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_selection_MermaidSelectionStrategy$__classPrefixed__Lorg_scalajs_dom_Element__T__s_Option($thiz, e, prefix) {
  return $p_Lorg_jpablo_graphexplorer_viewer_components_selection_MermaidSelectionStrategy$__classList__Lorg_scalajs_dom_Element__sci_Seq($thiz, e).nw(new $c_Lorg_jpablo_graphexplorer_viewer_components_selection_MermaidSelectionStrategy$$anon$1(prefix));
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_selection_MermaidSelectionStrategy$__dataAttr__Lorg_scalajs_dom_Element__T__s_Option($thiz, e, name) {
  var this$1 = $m_s_Option$().as(e.getAttribute(name));
  return ((this$1.c() || (this$1.d() !== "")) ? this$1 : $m_s_None$());
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_selection_MermaidSelectionStrategy$__arrowIdFromElement$1__Lorg_scalajs_dom_Element__s_Option($thiz, edgeElem) {
  var this$1 = $p_Lorg_jpablo_graphexplorer_viewer_components_selection_MermaidSelectionStrategy$__dataAttr__Lorg_scalajs_dom_Element__T__s_Option($thiz, edgeElem, "data-edge-id");
  var domId = (this$1.c() ? edgeElem.id : this$1.d());
  matchResult4: {
    var idParts;
    if ((domId !== null)) {
      var x18 = $thiz.ayg.jw(domId);
      if ((!x18.c())) {
        var x19 = x18.d();
        if ((x19.bL(1) === 0)) {
          var x20 = $f_sc_LinearSeqOps__apply__I__O(x19, 0);
          var idParts = new $c_s_Some(new $c_T3(x20, x20, 1));
          break matchResult4;
        }
      }
      var x13 = $thiz.aye.jw(domId);
      if ((!x13.c())) {
        var x14 = x13.d();
        if ((x14.bL(3) === 0)) {
          var idParts = new $c_s_Some(new $c_T3($f_sc_LinearSeqOps__apply__I__O(x14, 0), $f_sc_LinearSeqOps__apply__I__O(x14, 1), ((1 + $m_jl_Integer$().gc($f_sc_LinearSeqOps__apply__I__O(x14, 2), 10, 214748364)) | 0)));
          break matchResult4;
        }
      }
      var x8 = $thiz.ayd.jw(domId);
      if ((!x8.c())) {
        var x9 = x8.d();
        if ((x9.bL(3) === 0)) {
          var idParts = new $c_s_Some(new $c_T3($f_sc_LinearSeqOps__apply__I__O(x9, 0), $f_sc_LinearSeqOps__apply__I__O(x9, 1), ((1 + $m_jl_Integer$().gc($f_sc_LinearSeqOps__apply__I__O(x9, 2), 10, 214748364)) | 0)));
          break matchResult4;
        }
      }
    }
    var idParts = $m_s_None$();
  }
  var this$14 = $p_Lorg_jpablo_graphexplorer_viewer_components_selection_MermaidSelectionStrategy$__classPrefixed__Lorg_scalajs_dom_Element__T__s_Option($thiz, edgeElem, "LS-");
  var source = (this$14.c() ? (idParts.c() ? $m_s_None$() : new $c_s_Some(idParts.d().bH)) : this$14);
  var this$15 = $p_Lorg_jpablo_graphexplorer_viewer_components_selection_MermaidSelectionStrategy$__classPrefixed__Lorg_scalajs_dom_Element__T__s_Option($thiz, edgeElem, "LE-");
  var target = (this$15.c() ? (idParts.c() ? $m_s_None$() : new $c_s_Some(idParts.d().bU)) : this$15);
  var seq = (idParts.c() ? 1 : (idParts.d().c3 | 0));
  if ((source instanceof $c_s_Some)) {
    var s$3 = source.J;
    if ((target instanceof $c_s_Some)) {
      var t$3 = target.J;
      return new $c_s_Some(($m_Lorg_jpablo_graphexplorer_viewer_models_ArrowId$(), new $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowId(((((("" + s$3) + $m_Lorg_jpablo_graphexplorer_viewer_models_Arrow$().a0P) + t$3) + $m_Lorg_jpablo_graphexplorer_viewer_models_Arrow$().a0O) + seq))));
    }
  }
  return $m_s_None$();
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_selection_MermaidSelectionStrategy$() {
  this.ayf = null;
  this.ayd = null;
  this.aye = null;
  this.ayg = null;
  $n_Lorg_jpablo_graphexplorer_viewer_components_selection_MermaidSelectionStrategy$ = this;
  this.ayf = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "flowchart-(.+)-\\d+", $m_sci_Nil$());
  this.ayd = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "L-(.+)-(.+)-(\\d+)", $m_sci_Nil$());
  this.aye = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "L_(.+)_(.+)_(\\d+)", $m_sci_Nil$());
  this.ayg = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "(.+)-cyclic-special-(?:\\d+|mid)", $m_sci_Nil$());
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_selection_MermaidSelectionStrategy$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_selection_MermaidSelectionStrategy$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_selection_MermaidSelectionStrategy$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_selection_MermaidSelectionStrategy$.prototype = $p;
$p.aPb = (function(elems) {
  return $m_s_None$();
});
$p.Jc = (function() {
  return "g.node";
});
$p.a3a = (function() {
  return ("g.edgePath, g.edge, path.flowchart-link, path.edgePath, rect." + $m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().a0u);
});
$p.Ws = (function() {
  return "g.cluster";
});
$p.afF = (function(e) {
  var this$1 = $p_Lorg_jpablo_graphexplorer_viewer_components_selection_MermaidSelectionStrategy$__dataAttr__Lorg_scalajs_dom_Element__T__s_Option(this, e, "data-id");
  var this$2 = (this$1.c() ? $p_Lorg_jpablo_graphexplorer_viewer_components_selection_MermaidSelectionStrategy$__dataAttr__Lorg_scalajs_dom_Element__T__s_Option($m_Lorg_jpablo_graphexplorer_viewer_components_selection_MermaidSelectionStrategy$(), e, "data-node-id") : this$1);
  if (this$2.c()) {
    var this$4 = $m_s_None$();
  } else {
    var x0 = this$2.d();
    $m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$();
    var this$4 = new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId(x0));
  }
  if (this$4.c()) {
    var svgId = e.id;
    matchResult3: {
      var $x_1;
      if ((svgId !== null)) {
        var x4 = $m_Lorg_jpablo_graphexplorer_viewer_components_selection_MermaidSelectionStrategy$().ayf.jw(svgId);
        if ((!x4.c())) {
          var x5 = x4.d();
          if ((x5.bL(1) === 0)) {
            var x6 = $f_sc_LinearSeqOps__apply__I__O(x5, 0);
            $m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$();
            var $x_1 = new $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId(x6);
            break matchResult3;
          }
        }
      }
      if ((svgId !== "")) {
        $m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$();
        var $x_1 = new $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId(svgId);
        break matchResult3;
      }
      var title = e.querySelector("title");
      var $x_1 = ((title !== null) ? ($m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$(), new $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId(title.textContent)) : ($m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$(), new $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId(("node-" + $dp_hashCode__I(e)))));
    }
  } else {
    var $x_1 = this$4.d();
  }
  return $x_1;
});
$p.afE = (function(e) {
  if ((!(!(e instanceof SVGGElement)))) {
    var $x_1 = new $c_s_Some(e);
    var this$2 = $m_s_Option$().as(e.querySelector("path"));
    var candidates = $f_sc_StrictOptimizedIterableOps__flatten__F1__O(new $c_sci_$colon$colon($x_1, new $c_sci_$colon$colon((this$2.c() ? $m_s_None$() : new $c_s_Some(this$2.d())), $m_sci_Nil$())), $m_s_$less$colon$less$().b1);
  } else {
    var $x_2 = new $c_s_Some(e);
    var this$7 = $m_s_Option$().as(e.querySelector("path"));
    var candidates = $f_sc_StrictOptimizedIterableOps__flatten__F1__O(new $c_sci_$colon$colon($x_2, new $c_sci_$colon$colon((this$7.c() ? $m_s_None$() : new $c_s_Some(this$7.d())), $m_sci_Nil$())), $m_s_$less$colon$less$().b1);
  }
  var this$12 = $f_sc_IterableOps__flatMap__F1__O(candidates.JI(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((edgeElem) => $p_Lorg_jpablo_graphexplorer_viewer_components_selection_MermaidSelectionStrategy$__arrowIdFromElement$1__Lorg_scalajs_dom_Element__s_Option(this, edgeElem)))).dt();
  if (this$12.c()) {
    var this$15 = new $c_sc_Iterator$$anon$10(candidates.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((elem) => {
      var this$13 = $m_s_Option$().as(elem.querySelector("title"));
      if (this$13.c()) {
        return $m_s_None$();
      } else {
        var x0$2 = this$13.d();
        return new $c_s_Some(x0$2.textContent);
      }
    })));
    _return: {
      while (this$15.p()) {
        var a = this$15.q();
        if ((a !== "")) {
          var titleOpt = new $c_s_Some(a);
          break _return;
        }
      }
      var titleOpt = $m_s_None$();
    }
    if (titleOpt.c()) {
      var this$19 = $m_s_None$();
    } else {
      var x0$3 = titleOpt.d();
      $m_Lorg_jpablo_graphexplorer_viewer_models_ArrowId$();
      var this$19 = new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowId(x0$3));
    }
    var $x_3 = (this$19.c() ? ($m_Lorg_jpablo_graphexplorer_viewer_models_ArrowId$(), new $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowId(("edge-" + $dp_hashCode__I(e)))) : this$19.d());
  } else {
    var $x_3 = this$12.d();
  }
  return $x_3;
});
$p.a3k = (function(e) {
  var this$1 = $p_Lorg_jpablo_graphexplorer_viewer_components_selection_MermaidSelectionStrategy$__dataAttr__Lorg_scalajs_dom_Element__T__s_Option(this, e, "data-id");
  var this$2 = (this$1.c() ? $p_Lorg_jpablo_graphexplorer_viewer_components_selection_MermaidSelectionStrategy$__dataAttr__Lorg_scalajs_dom_Element__T__s_Option($m_Lorg_jpablo_graphexplorer_viewer_components_selection_MermaidSelectionStrategy$(), e, "data-group-id") : this$1);
  if (this$2.c()) {
    var this$4 = $m_s_None$();
  } else {
    var x0 = this$2.d();
    $m_Lorg_jpablo_graphexplorer_viewer_models_GroupId$();
    var this$4 = new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId(x0));
  }
  if (this$4.c()) {
    var svgId = e.id;
    if ((svgId !== "")) {
      $m_Lorg_jpablo_graphexplorer_viewer_models_GroupId$();
      var $x_1 = new $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId(svgId);
    } else {
      var title = e.querySelector("title");
      var $x_1 = ((title !== null) ? ($m_Lorg_jpablo_graphexplorer_viewer_models_GroupId$(), new $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId(title.textContent)) : ($m_Lorg_jpablo_graphexplorer_viewer_models_GroupId$(), new $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId(("group-" + $dp_hashCode__I(e)))));
    }
  } else {
    var $x_1 = this$4.d();
  }
  return $x_1;
});
$p.aPo = (function(e) {
  return ((((!(!e.classList.contains("edge"))) || (!(!e.classList.contains("edgePath")))) || (!(!e.classList.contains("flowchart-link")))) || (!(!e.classList.contains($m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().a0u))));
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_selection_MermaidSelectionStrategy$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_selection_MermaidSelectionStrategy$, "org.jpablo.graphexplorer.viewer.components.selection.MermaidSelectionStrategy$", ({
  zu: 1,
  hZ: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_selection_MermaidSelectionStrategy$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_selection_MermaidSelectionStrategy$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_selection_MermaidSelectionStrategy$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_selection_MermaidSelectionStrategy$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_selection_MermaidSelectionStrategy$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_selection_MermaidSelectionStrategy$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_desktop_LooseFilePersistence(session) {
  this.a9V = null;
  this.ayK = null;
  this.ayL = false;
  this.a9V = session;
  this.Pw();
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_desktop_LooseFilePersistence.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_desktop_LooseFilePersistence;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_desktop_LooseFilePersistence() {
}
$h_Lorg_jpablo_graphexplorer_viewer_desktop_LooseFilePersistence.prototype = $p;
$p.Pw = (function() {
  if ((!this.ayL)) {
    matchResult1: {
      var $x_1;
      var x1 = $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$().IY(this.a9V);
      if ((x1 instanceof $c_s_Some)) {
        var open = x1.J;
        var \u03b41$ = $m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$().Jb(new $c_s_Some(open.tj));
        var projectName$1 = open.aXV();
        var $x_1 = new $c_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState(\u03b41$.ob, \u03b41$.oa, projectName$1, \u03b41$.hf, \u03b41$.nf, \u03b41$.o9);
        break matchResult1;
      }
      if (($m_s_None$() === x1)) {
        var $x_1 = $m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$().Jb(($m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$(), $m_s_None$()));
        break matchResult1;
      }
      throw new $c_s_MatchError(x1);
    }
    this.ayK = $x_1;
    this.ayL = true;
  }
  return this.ayK;
});
$p.afB = (function() {
  return $m_Lcom_raquo_airstream_core_EventStream$().Qr;
});
$p.a56 = (function(next) {
});
$p.a4B = (function(next, x$2) {
  var x15 = $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$().IY(this.a9V);
  if (($m_s_None$() === x15)) {
    return $m_s_concurrent_Future$().m4(new $c_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$Failed("this document session is no longer open"));
  }
  if ((x15 instanceof $c_s_Some)) {
    var open = x15.J;
    return $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$().aRP(open.vl, next.hf, open.Cm, x$2).jX(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
      if ((x$1 instanceof $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$Saved)) {
        var x13 = x$1.Tc;
        var x14 = x$1.M7;
        $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$().aRn(x13, x14, next.hf);
        return $s_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$__Saved__Lorg_jpablo_graphexplorer_viewer_state_SaveResult();
      }
      if ((x$1 instanceof $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$Conflict)) {
        return new $c_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$Conflict("The file changed on disk. Reload it and try again.");
      }
      if ((x$1 instanceof $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$Failed)) {
        return new $c_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$Failed(x$1.Tb);
      }
      var x$3 = $s_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$__Unavailable__Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome();
      if (((x$3 === null) ? (x$1 === null) : x$3.e(x$1))) {
        return new $c_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$Unsupported("Saving a file needs the desktop app");
      }
      throw new $c_s_MatchError(x$1);
    })), x$2);
  }
  throw new $c_s_MatchError(x15);
});
$p.aeZ = (function() {
});
var $d_Lorg_jpablo_graphexplorer_viewer_desktop_LooseFilePersistence = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_desktop_LooseFilePersistence, "org.jpablo.graphexplorer.viewer.desktop.LooseFilePersistence", ({
  zZ: 1,
  dr: 1
}));
function $is_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttributeEnum(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.a1)));
}
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttributeEnum(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.a1)));
}
function $is_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttributeSimple(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.v)));
}
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttributeSimple(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.v)));
}
function $p_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$__maxDistanceToTargets__sci_Map__sci_Map__D($thiz, positions, targets) {
  if (targets.c()) {
    return 0.0;
  } else {
    var this$5 = $f_sc_IterableOnceOps__maxOption__s_math_Ordering__s_Option(new $c_sc_Iterator$$anon$9(targets.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
      var nodeId = x$1.g();
      var t = x$1.h();
      var this$1 = positions.r(nodeId);
      if (this$1.c()) {
        var this$2 = $m_s_None$();
      } else {
        var x0 = this$1.d();
        var this$2 = new $c_s_Some(t.fN(x0).js());
      }
      return (+(this$2.c() ? 0.0 : this$2.d()));
    }))), $m_s_math_Ordering$DeprecatedDoubleOrdering$());
    return (+(this$5.c() ? 0.0 : this$5.d()));
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$__sharesEndpoint__T2__T2__Z($thiz, a, b) {
  return ((($m_sr_BoxesRunTime$().Q(a.g(), b.g()) || $m_sr_BoxesRunTime$().Q(a.g(), b.h())) || $m_sr_BoxesRunTime$().Q(a.h(), b.g())) || $m_sr_BoxesRunTime$().Q(a.h(), b.h()));
}
function $p_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$__segmentsCross__T2__T2__T2__T2__Z($thiz, p1, p2, p3, p4) {
  var d1 = $p_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$__orient$1__T2__T2__T2__D($thiz, p3, p4, p1);
  var d2 = $p_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$__orient$1__T2__T2__T2__D($thiz, p3, p4, p2);
  var d3 = $p_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$__orient$1__T2__T2__T2__D($thiz, p1, p2, p3);
  var d4 = $p_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$__orient$1__T2__T2__T2__D($thiz, p1, p2, p4);
  return ((((d1 > 0.0) && (d2 < 0.0)) || ((d1 < 0.0) && (d2 > 0.0))) && (((d3 > 0.0) && (d4 < 0.0)) || ((d3 < 0.0) && (d4 > 0.0))));
}
function $p_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$__centerOf__Lorg_jpablo_graphexplorer_viewer_layout3d_PlanarHints__T2($thiz, h) {
  if (h.xg.c()) {
    return new $c_T2(0.0, 0.0);
  } else {
    var this$3 = new $c_sc_Iterator$$anon$9(h.xg.hr(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => (+_$2.g()))));
    var xs = $m_sci_Vector$().X(this$3);
    var this$5 = new $c_sc_Iterator$$anon$9(h.xg.hr(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3) => (+_$3.h()))));
    var ys = $m_sci_Vector$().X(this$5);
    return new $c_T2((0.5 * ((+$f_sc_IterableOnceOps__min__s_math_Ordering__O(xs, $m_s_math_Ordering$DeprecatedDoubleOrdering$())) + (+$f_sc_IterableOnceOps__max__s_math_Ordering__O(xs, $m_s_math_Ordering$DeprecatedDoubleOrdering$())))), (0.5 * ((+$f_sc_IterableOnceOps__min__s_math_Ordering__O(ys, $m_s_math_Ordering$DeprecatedDoubleOrdering$())) + (+$f_sc_IterableOnceOps__max__s_math_Ordering__O(ys, $m_s_math_Ordering$DeprecatedDoubleOrdering$())))));
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$__levelAt$1__I__I($thiz, k) {
  if ((k === 0)) {
    return 0;
  } else {
    var t = ((k >>> 31) | 0);
    if (((((1 & ((k + t) | 0)) - t) | 0) === 1)) {
      var num = ((1 + k) | 0);
      return (((num + ((num >>> 31) | 0)) | 0) >> 1);
    } else {
      var num$1 = ((-k) | 0);
      return (((num$1 + ((num$1 >>> 31) | 0)) | 0) >> 1);
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$__orient$1__T2__T2__T2__D($thiz, a, b, c) {
  return ((((+b.g()) - (+a.g())) * ((+c.h()) - (+a.h()))) - (((+b.h()) - (+a.h())) * ((+c.g()) - (+a.g()))));
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$() {
  this.GI = null;
  this.aaJ = null;
  this.aaI = null;
  this.Tw = 0.0;
  this.Mv = null;
  $n_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$ = this;
  this.GI = "dotplanar";
  this.aaJ = "Flat (dot)";
  this.aaI = new $c_sci_$colon$colon(new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Knob3D("depth", "Depth", 0.0, 1.2, 0.05, 0.35), $m_sci_Nil$());
  this.Tw = 0.013888888888888888;
  this.Mv = new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$Params(0.35, $m_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$().Tw, 0.18, 0.002);
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$.prototype = $p;
$p.u6 = (function() {
  return this.GI;
});
$p.aI = (function() {
  return this.aaJ;
});
$p.E8 = (function() {
  return this.aaI;
});
$p.Qb = (function() {
  return true;
});
$p.b6m = (function(values) {
  return new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$Params((+values.ay("depth", new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$().Mv.GJ)))), $m_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$().Tw, 0.18, 0.002);
});
$p.AK = (function(values) {
  return new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$Configured(this.b6m(values));
});
$p.Pv = (function(graph) {
  return this.aPg(graph, this.Mv);
});
$p.aPg = (function(graph, params) {
  var t = this.a4S(graph, params);
  var edgeOffsets$1 = this.ahd(graph, params);
  var pinned$1 = $m_sci_Set$EmptySet$();
  var motion$1 = $m_sci_Map$EmptyMap$();
  return new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayoutState3D(this.GI, graph, t, 0.0, 0, t, pinned$1, motion$1, edgeOffsets$1);
});
$p.Jr = (function(state, newGraph) {
  return this.aSC(state, newGraph, this.Mv);
});
$p.aSC = (function(state, newGraph, params) {
  var x = state.he;
  if ((((x === null) ? (newGraph === null) : x.e(newGraph)) && (state.l2 === this.GI))) {
    return state;
  } else {
    var t = this.a4S(newGraph, params);
    var positions = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$9(newGraph.l1.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((nodeId) => new $c_T2(nodeId, state.fF.ay(nodeId, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((nodeId$2) => (() => t.i(nodeId$2)))(nodeId))))))));
    var off = this.ahd(newGraph, params);
    var temperature = $p_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$__maxDistanceToTargets__sci_Map__sci_Map__D(this, positions, t);
    return ((temperature <= params.GK) ? new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayoutState3D(this.GI, newGraph, t, 0.0, 0, t, $m_sci_Set$EmptySet$(), $m_sci_Map$EmptyMap$(), off) : new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayoutState3D(this.GI, newGraph, positions, temperature, 0, t, $m_sci_Set$EmptySet$(), $m_sci_Map$EmptyMap$(), off));
  }
});
$p.PO = (function(state) {
  return this.aRs(state, this.Mv);
});
$p.aRs = (function(state, params) {
  var t = this.a4S(state.he, params);
  var edgeOffsets$2 = this.ahd(state.he, params);
  var temperature$1 = $p_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$__maxDistanceToTargets__sci_Map__sci_Map__D(this, state.fF, t);
  return new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayoutState3D(state.l2, state.he, state.fF, temperature$1, state.mk, t, state.lG, state.nc, edgeOffsets$2);
});
$p.Jo = (function(state) {
  return this.aSn(state, this.Mv);
});
$p.aSn = (function(state, params) {
  if (state.DU()) {
    return state;
  } else {
    var moved = state.fF.kP(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
      var nodeId = x$1.g();
      var p = x$1.h();
      if (state.lG.E(nodeId)) {
        return new $c_T2(nodeId, p);
      } else {
        var x5 = state.kE.r(nodeId);
        if ((x5 instanceof $c_s_Some)) {
          var t = x5.J;
          return new $c_T2(nodeId, p.iQ(t.fN(p).dj(params.Mw)));
        }
        if (($m_s_None$() === x5)) {
          return new $c_T2(nodeId, p);
        }
        throw new $c_s_MatchError(x5);
      }
    })));
    var remaining = $p_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$__maxDistanceToTargets__sci_Map__sci_Map__D(this, moved, state.kE);
    if ((remaining <= params.GK)) {
      var iteration$2 = ((1 + state.mk) | 0);
      var algoId$2 = state.l2;
      var graph$2 = state.he;
      var targets$1 = state.kE;
      var pinned$3 = state.lG;
      var motion$3 = state.nc;
      var edgeOffsets$3 = state.lF;
      return new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayoutState3D(algoId$2, graph$2, state.kE, 0.0, iteration$2, targets$1, pinned$3, motion$3, edgeOffsets$3);
    } else {
      var iteration$3 = ((1 + state.mk) | 0);
      return new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayoutState3D(state.l2, state.he, moved, remaining, iteration$3, state.kE, state.lG, state.nc, state.lF);
    }
  }
});
$p.a4S = (function(graph, params) {
  var x14 = graph.GR;
  if (($m_s_None$() === x14)) {
    return $m_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$().a4T(graph, $m_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$().Cu);
  }
  if ((x14 instanceof $c_s_Some)) {
    var h = x14.J;
    matchResult5: {
      var \u03b41$___1;
      var \u03b41$___2;
      var x8 = $p_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$__centerOf__Lorg_jpablo_graphexplorer_viewer_layout3d_PlanarHints__T2(this, h);
      if ((x8 !== null)) {
        var \u03b41$___1 = (+x8.g());
        var \u03b41$___2 = (+x8.h());
        break matchResult5;
      }
      throw new $c_s_MatchError(x8);
    }
    var cx$2 = (+\u03b41$___1);
    var cy$2 = (+\u03b41$___2);
    return $m_sci_Map$().ao(new $c_sc_Iterator$$anon$9(graph.l1.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((nodeId) => {
      matchResult6: {
        var \u03b42$___1;
        var \u03b42$___2;
        var x11 = h.xg.ay(nodeId, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => new $c_T2(cx$2, cy$2))));
        if ((x11 !== null)) {
          var \u03b42$___1 = (+x11.g());
          var \u03b42$___2 = (+x11.h());
          break matchResult6;
        }
        throw new $c_s_MatchError(x11);
      }
      var x$2 = (+\u03b42$___1);
      var y$2 = (+\u03b42$___2);
      return new $c_T2(nodeId, ($m_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$(), new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3(((x$2 - cx$2) * params.zs), ((y$2 - cy$2) * params.zs), 0.0)));
    }))));
  }
  throw new $c_s_MatchError(x14);
});
$p.aZu = (function(graph, hints) {
  var chords = graph.hv.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var s = x$1.g();
    var t = x$1.h();
    if (((s === null) ? (t === null) : s.e(t))) {
      return $m_s_None$();
    } else {
      var this$1 = hints.xg.r(s);
      if (this$1.c()) {
        return $m_s_None$();
      } else {
        var x0 = this$1.d();
        var this$2 = hints.xg.r(t);
        return (this$2.c() ? $m_s_None$() : new $c_s_Some(new $c_T2(x0, this$2.d())));
      }
    }
  })));
  var n = graph.hv.C();
  if ((n <= 0)) {
    var crossing = new ($d_sci_List.r().C)(0);
  } else {
    var array = new ($d_sci_List.r().C)(n);
    var i = 0;
    while ((i < n)) {
      array.a[i] = $m_sci_Nil$();
      i = ((1 + i) | 0);
    }
    var crossing = array;
  }
  var this$10 = graph.hv;
  var end = this$10.C();
  var isEmpty = (end <= 0);
  var scala$collection$immutable$Range$$lastElement = ((end - 1) | 0);
  if ((!isEmpty)) {
    var i$1 = 0;
    while (true) {
      var x0$2 = i$1;
      var x = ((1 + x0$2) | 0);
      var end$1 = graph.hv.C();
      var isEmpty$1 = (x >= end$1);
      var scala$collection$immutable$Range$$lastElement$1 = ((end$1 - 1) | 0);
      if ((!isEmpty$1)) {
        var i$2 = x;
        while (true) {
          var x0$3 = i$2;
          var this$18 = chords.l(x0$2);
          if ((!this$18.c())) {
            var x0$4 = this$18.d();
            var this$20 = new $c_s_Option$WithFilter(chords.l(x0$3), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((graph, x0$2, x0$3) => ((cj) => (!$p_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$__sharesEndpoint__T2__T2__Z($m_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$(), graph.hv.l(x0$2), graph.hv.l(x0$3)))))(graph, x0$2, x0$3))).bbT(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((ci$2) => ((cj$2) => $p_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$__segmentsCross__T2__T2__T2__T2__Z($m_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$(), ci$2.g(), ci$2.h(), cj$2.g(), cj$2.h())))(x0$4)));
            var this$21 = this$20.tu;
            var p$1 = this$20.tv;
            var this$22 = ((this$21.c() || (!(!p$1.i(this$21.d())))) ? this$21 : $m_s_None$());
            if ((!this$22.c())) {
              this$22.d();
              crossing.a[x0$2] = new $c_sci_$colon$colon(x0$3, crossing.a[x0$2]);
              crossing.a[x0$3] = new $c_sci_$colon$colon(x0$2, crossing.a[x0$3]);
            }
          }
          if ((i$2 === scala$collection$immutable$Range$$lastElement$1)) {
            break;
          }
          i$2 = ((1 + i$2) | 0);
        }
      }
      if ((i$1 === scala$collection$immutable$Range$$lastElement)) {
        break;
      }
      i$1 = ((1 + i$1) | 0);
    }
  }
  var n$1 = graph.hv.C();
  if ((n$1 <= 0)) {
    var levels = new $ac_I(0);
  } else {
    var array$1 = new $ac_I(n$1);
    var i$3 = 0;
    while ((i$3 < n$1)) {
      array$1.a[i$3] = 0;
      i$3 = ((1 + i$3) | 0);
    }
    var levels = array$1;
  }
  var n$2 = graph.hv.C();
  if ((n$2 <= 0)) {
    var assigned = new $ac_Z(0);
  } else {
    var array$2 = new $ac_Z(n$2);
    var i$4 = 0;
    while ((i$4 < n$2)) {
      array$2.a[i$4] = false;
      i$4 = ((1 + i$4) | 0);
    }
    var assigned = array$2;
  }
  var this$31 = graph.hv;
  var end$2 = this$31.C();
  var isEmpty$2 = (end$2 <= 0);
  var scala$collection$immutable$Range$$lastElement$2 = ((end$2 - 1) | 0);
  if ((!isEmpty$2)) {
    var i$5 = 0;
    while (true) {
      var x0$6 = i$5;
      var taken = $m_sci_Set$().af($p_sci_List__filterCommon__F1__Z__sci_List(crossing.a[x0$6], $m_s_Predef$().bc1(assigned), false).As($m_s_Predef$().a5j(levels)));
      var end$3 = graph.hv.C();
      var this$43 = new $c_sc_Iterator$$anon$9(new $c_sci_RangeIterator(0, 1, end$3, (end$3 < 0)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((k) => $p_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$__levelAt$1__I__I(this, (k | 0)))));
      _return$3: {
        while (this$43.p()) {
          var a = this$43.q();
          var _$1 = (a | 0);
          if ((!taken.E(_$1))) {
            var this$44 = new $c_s_Some(a);
            break _return$3;
          }
        }
        var this$44 = $m_s_None$();
      }
      levels.a[x0$6] = ((this$44.c() ? 0 : this$44.d()) | 0);
      assigned.a[x0$6] = true;
      if ((i$5 === scala$collection$immutable$Range$$lastElement$2)) {
        break;
      }
      i$5 = ((1 + i$5) | 0);
    }
  }
  var this$45 = $m_s_Predef$().a5j(levels);
  return $m_sci_Vector$().X(this$45);
});
$p.ahd = (function(graph, params) {
  var x30 = graph.GR;
  if (($m_s_None$() === x30)) {
    $m_sci_Vector$();
    return $m_sci_Vector0$();
  }
  if ((x30 instanceof $c_s_Some)) {
    var h = x30.J;
    matchResult8: {
      var \u03b43$___1;
      var \u03b43$___2;
      var x17 = $p_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$__centerOf__Lorg_jpablo_graphexplorer_viewer_layout3d_PlanarHints__T2(this, h);
      if ((x17 !== null)) {
        var \u03b43$___1 = (+x17.g());
        var \u03b43$___2 = (+x17.h());
        break matchResult8;
      }
      throw new $c_s_MatchError(x17);
    }
    var cx$2 = (+\u03b43$___1);
    var cy$2 = (+\u03b43$___2);
    var t = this.a4S(graph, params);
    var levels = this.aZu(graph, h);
    return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(graph.hv).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
      var edge = x$1.g();
      var i = (x$1.h() | 0);
      matchResult9: {
        var \u03b44$___1;
        var \u03b44$___2;
        if ((edge !== null)) {
          var \u03b44$___1 = edge.g();
          var \u03b44$___2 = edge.h();
          break matchResult9;
        }
        throw new $c_s_MatchError(edge);
      }
      var s$2 = \u03b44$___1;
      var e$2 = \u03b44$___2;
      var path = ((i < h.MH.C()) ? h.MH.l(i) : ($m_sci_Vector$(), $m_sci_Vector0$()));
      var _1 = t.r(s$2);
      var _2 = t.r(e$2);
      if ((_1 instanceof $c_s_Some)) {
        var a = _1.J;
        if ((_2 instanceof $c_s_Some)) {
          var b = _2.J;
          if ((path.C() >= 2)) {
            var n = path.C();
            $m_sci_Vector$();
            var b$1 = new $c_sci_VectorBuilder();
            var i$1 = 0;
            while ((i$1 < n)) {
              var x0 = i$1;
              var tt = (x0 / ((n - 1) | 0));
              var chord = a.iQ(b.fN(a).dj(tt));
              if (((x0 === 0) || (x0 === ((n - 1) | 0)))) {
                var bow = 0.0;
              } else {
                var x$2 = (3.141592653589793 * tt);
                var s$1 = (+Math.sin(x$2));
                var bow = ((((levels.l(i) | 0) * params.GJ) * s$1) * s$1);
              }
              b$1.ck(($m_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$(), new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3((((+path.l(x0).g()) - cx$2) * params.zs), (((+path.l(x0).h()) - cy$2) * params.zs), bow)).fN(chord));
              i$1 = ((1 + i$1) | 0);
            }
            return b$1.bY();
          }
        }
      }
      $m_sci_Vector$();
      return $m_sci_Vector0$();
    })));
  }
  throw new $c_s_MatchError(x30);
});
var $d_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$, "org.jpablo.graphexplorer.viewer.layout3d.DotPlanar3D$", ({
  CO: 1,
  bC: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$;
function $m_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$ = new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$Configured(params) {
  this.Tx = null;
  this.Tx = params;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$Configured.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$Configured;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$Configured() {
}
$h_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$Configured.prototype = $p;
$p.u6 = (function() {
  return $m_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$().GI;
});
$p.aI = (function() {
  return $m_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$().aaJ;
});
$p.E8 = (function() {
  return $m_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$().aaI;
});
$p.Qb = (function() {
  return true;
});
$p.AK = (function(values) {
  return $m_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$().AK(values);
});
$p.Pv = (function(graph) {
  return $m_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$().aPg(graph, this.Tx);
});
$p.Jr = (function(state, newGraph) {
  return $m_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$().aSC(state, newGraph, this.Tx);
});
$p.Jo = (function(state) {
  return $m_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$().aSn(state, this.Tx);
});
$p.PO = (function(state) {
  return $m_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$().aRs(state, this.Tx);
});
var $d_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$Configured = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$Configured, "org.jpablo.graphexplorer.viewer.layout3d.DotPlanar3D$Configured", ({
  CP: 1,
  bC: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$() {
  this.Cq = null;
  this.aaL = null;
  this.aaK = null;
  this.zt = null;
  $n_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$ = this;
  this.Cq = "force";
  this.aaL = "Force";
  this.aaK = new $c_sci_$colon$colon(new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Knob3D("k", "Edge length", 0.4, 3.0, 0.05, 1.0), new $c_sci_$colon$colon(new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Knob3D("gravity", "Gravity", 0.0, 0.3, 0.005, 0.05), new $c_sci_$colon$colon(new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Knob3D("cohesion", "Cohesion", 0.0, 0.6, 0.01, 0.15), new $c_sci_$colon$colon(new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Knob3D("repulsionRange", "Spread", 1.5, 6.0, 0.1, 2.5), $m_sci_Nil$()))));
  this.zt = new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$Params(1.0, 0.05, 0.15, 2.5, 0.3, 0.96, 0.002);
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$.prototype = $p;
$p.Qb = (function() {
  return false;
});
$p.u6 = (function() {
  return this.Cq;
});
$p.aI = (function() {
  return this.aaL;
});
$p.E8 = (function() {
  return this.aaK;
});
$p.b6n = (function(values) {
  return new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$Params((+values.ay("k", new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$().zt.vo)))), (+values.ay("gravity", new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$().zt.GM)))), (+values.ay("cohesion", new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$().zt.Cr)))), (+values.ay("repulsionRange", new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$().zt.Cs)))), 0.3, 0.96, 0.002);
});
$p.AK = (function(values) {
  return new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$Configured(this.b6n(values));
});
$p.PO = (function(state) {
  return this.aRt(state, this.zt);
});
$p.aRt = (function(state, params) {
  var x = state.vq;
  var y = (0.35 * params.vo);
  var temperature$1 = (+Math.max(x, y));
  return new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayoutState3D(state.l2, state.he, state.fF, temperature$1, state.mk, state.kE, state.lG, state.nc, state.lF);
});
$p.aRi = (function(n, k) {
  return (k * $m_jl_Math$().a2R(((n > 1) ? n : 1)));
});
$p.afG = (function(i, n) {
  var goldenAngle = (3.141592653589793 * (3.0 - (+Math.sqrt(5.0))));
  var y = (1.0 - (2.0 * ((i + 0.5) / ((n > 1) ? n : 1))));
  var y$1 = (1.0 - (y * y));
  var x = (+Math.max(0.0, y$1));
  var r = (+Math.sqrt(x));
  var theta = (goldenAngle * i);
  $m_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$();
  return new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3(((+Math.cos(theta)) * r), y, ((+Math.sin(theta)) * r));
});
$p.Pv = (function(graph) {
  return this.aPh(graph, this.zt);
});
$p.aPh = (function(graph, params) {
  var n = graph.l1.C();
  var r = this.aRi(n, params.vo);
  var positions = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$9(new $c_sc_Iterator$$anon$16(graph.l1.o()), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var nodeId = x$1.g();
    var i = (x$1.h() | 0);
    return new $c_T2(nodeId, $m_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$().afG(i, n).dj(r));
  }))));
  return new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayoutState3D(this.Cq, graph, positions, (r * params.GN), 0, $m_sci_Map$EmptyMap$(), $m_sci_Set$EmptySet$(), $m_sci_Map$EmptyMap$(), ($m_sci_Vector$(), $m_sci_Vector0$()));
});
$p.Jr = (function(state, newGraph) {
  return this.aSD(state, newGraph, this.zt);
});
$p.aSD = (function(state, newGraph, params) {
  var x = state.he;
  if ((((x === null) ? (newGraph === null) : x.e(newGraph)) && (state.l2 === this.Cq))) {
    return state;
  } else {
    var n = newGraph.l1.C();
    var r = this.aRi(n, params.vo);
    var nodeSet = $m_sci_Set$().af(newGraph.l1);
    var kept = state.fF.bw(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
      var nodeId = x$1.g();
      x$1.h();
      return nodeSet.E(nodeId);
    })));
    var this$4 = new $c_sc_Iterator$$anon$16(newGraph.l1.o());
    var result = kept;
    while (this$4.p()) {
      var x0 = result;
      var x1 = this$4.dC();
      matchResult6: {
        var x15 = new $c_T2(x0, x1);
        var x17 = x15.be;
        var acc = x15.bi;
        if ((x17 !== null)) {
          var nodeId$1 = x17.g();
          var i = (x17.h() | 0);
          if (acc.E(nodeId$1)) {
            result = acc;
            break matchResult6;
          } else {
            var this$7 = new $c_sc_Iterator$$anon$7(newGraph.hv.o(), new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$$anon$1(nodeId$1, acc));
            var placedNeighbors = $m_sci_Vector$().X(this$7);
            if ($f_sc_SeqOps__isEmpty__Z(placedNeighbors)) {
              var pos = this.afG(i, n).dj(r);
            } else {
              var f = ((_$2, _$3) => _$2.iQ(_$3));
              matchEnd4: {
                var $x_1;
                if ((placedNeighbors.C() > 0)) {
                  var z = placedNeighbors.l(0);
                  var at = 1;
                  var end = placedNeighbors.C();
                  var acc$1 = z;
                  while (true) {
                    if ((at !== end)) {
                      var temp$at = ((1 + at) | 0);
                      var x0$1 = acc$1;
                      var x1$1 = placedNeighbors.l(at);
                      var temp$acc = f(x0$1, x1$1);
                      at = temp$at;
                      acc$1 = temp$acc;
                      continue;
                    }
                    var $x_1 = acc$1;
                    break matchEnd4;
                  }
                }
                if ((placedNeighbors.C() === 0)) {
                  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.reduceLeft");
                }
                var it = placedNeighbors.o();
                if ((!it.p())) {
                  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.reduceLeft");
                }
                var acc$2 = it.q();
                while (it.p()) {
                  var x0$2 = acc$2;
                  var x1$2 = it.q();
                  acc$2 = f(x0$2, x1$2);
                }
                var $x_1 = acc$2;
              }
              var pos = $x_1.dj((1.0 / placedNeighbors.C())).iQ(this.afG(i, ((n > 2) ? n : 2)).dj((0.5 * params.vo)));
            }
            result = acc.bN(nodeId$1, pos);
            break matchResult6;
          }
        }
        throw new $c_s_MatchError(x15);
      }
    }
    var positions = result;
    return new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayoutState3D(this.Cq, newGraph, positions, (0.5 * (r * params.GN)), 0, $m_sci_Map$EmptyMap$(), $m_sci_Set$EmptySet$(), $m_sci_Map$EmptyMap$(), ($m_sci_Vector$(), $m_sci_Vector0$()));
  }
});
$p.Jo = (function(state) {
  return this.aSo(state, this.zt);
});
$p.aSo = (function(state, params) {
  var nodes = state.he.l1;
  var n = nodes.C();
  if (state.DU()) {
    return state;
  } else if ((n === 0)) {
    return new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayoutState3D(state.l2, state.he, state.fF, 0.0, state.mk, state.kE, state.lG, state.nc, state.lF);
  } else {
    var k = params.vo;
    var idx = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$16(nodes.o()));
    var this$6 = new $c_sc_Iterator$$anon$9(nodes.o(), state.fF);
    if ((this$6.V() >= 0)) {
      var destination = new ($d_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3.r().C)(this$6.V());
      $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$6, destination, 0, 2147483647);
      var pos = destination;
    } else {
      var capacity = 0;
      var size = 0;
      var jsElems = null;
      capacity = 0;
      size = 0;
      jsElems = [];
      while (this$6.p()) {
        var elem = this$6.q();
        var unboxedElem = ((elem === null) ? null : elem);
        jsElems.push(unboxedElem);
      }
      var pos = new ($d_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3.r().C)(jsElems);
    }
    if ((n <= 0)) {
      var disp = new ($d_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3.r().C)(0);
    } else {
      var array = new ($d_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3.r().C)(n);
      var i = 0;
      while ((i < n)) {
        array.a[i] = $m_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$().zv;
        i = ((1 + i) | 0);
      }
      var disp = array;
    }
    var rangeSq = ((params.Cs * k) * (params.Cs * k));
    var i$1 = 0;
    while ((i$1 < n)) {
      var j = ((1 + i$1) | 0);
      while ((j < n)) {
        var delta = pos.a[i$1].fN(pos.a[j]);
        var distSq = (((delta.cq * delta.cq) + (delta.cr * delta.cr)) + (delta.cg * delta.cg));
        if ((distSq < rangeSq)) {
          var x = (+Math.sqrt(distSq));
          var d = (+Math.max(x, 1.0E-4));
          var push = delta.dj(((k * k) / (d * d)));
          disp.a[i$1] = disp.a[i$1].iQ(push);
          disp.a[j] = disp.a[j].fN(push);
        }
        j = ((1 + j) | 0);
      }
      i$1 = ((1 + i$1) | 0);
    }
    var this$21 = $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(new $c_sc_IterableOps$WithFilter(), state.he.hv, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
      if ((x$1 !== null)) {
        var s = x$1.g();
        var t = x$1.h();
        return (!((s === null) ? (t === null) : s.e(t)));
      }
      throw new $c_s_MatchError(x$1);
    })));
    var f$1 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
      matchResult8: {
        if ((x$1$2 !== null)) {
          var s$1 = x$1$2.g();
          var t$1 = x$1$2.h();
          var si = (idx.i(s$1) | 0);
          var ti = (idx.i(t$1) | 0);
          var delta$1 = pos.a[si].fN(pos.a[ti]);
          var x$2 = delta$1.js();
          var d$1 = (+Math.max(x$2, 1.0E-4));
          var pull = delta$1.dj((d$1 / k));
          disp.a[si] = disp.a[si].fN(pull);
          disp.a[ti] = disp.a[ti].iQ(pull);
          break matchResult8;
        }
        throw new $c_s_MatchError(x$1$2);
      }
    }));
    this$21.qY().F(f$1);
    if ((params.Cr > 0.0)) {
      var this$27 = $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(new $c_sc_IterableOps$WithFilter(), state.he.MG, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((members) => (members.C() >= 2))));
      var f$2 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((members$2) => {
        var idxs = members$2.L(idx);
        var bx = new $c_sr_DoubleRef(0.0);
        var by = new $c_sr_DoubleRef(0.0);
        var bz = new $c_sr_DoubleRef(0.0);
        idxs.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => {
          var i$2 = (v1 | 0);
          bx.T = (bx.T + pos.a[i$2].cq);
          by.T = (by.T + pos.a[i$2].cr);
          bz.T = (bz.T + pos.a[i$2].cg);
        })));
        $m_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$();
        var bary = new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3((bx.T / idxs.C()), (by.T / idxs.C()), (bz.T / idxs.C()));
        idxs.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1$2) => {
          var i$3 = (v1$2 | 0);
          disp.a[i$3] = disp.a[i$3].fN(pos.a[i$3].fN(bary).dj(params.Cr));
        })));
      }));
      this$27.qY().F(f$2);
    }
    var t$2 = state.vq;
    var motionB = new $c_sci_MapBuilderImpl();
    var newPositions = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$9(new $c_sc_Iterator$$anon$16(nodes.o()), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3) => {
      var nodeId = x$1$3.g();
      var i$4 = (x$1$3.h() | 0);
      if (state.lG.E(nodeId)) {
        motionB.lR(nodeId, new $c_T2($m_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$().zv, 1.0));
        return new $c_T2(nodeId, pos.a[i$4]);
      } else {
        var d$2 = disp.a[i$4].fN(pos.a[i$4].dj(params.GM));
        var len$1 = d$2.js();
        matchResult9: {
          var \u03b41$___1;
          var \u03b41$___2;
          var x26 = state.nc.ay(nodeId, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => new $c_T2($m_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$().zv, 1.0))));
          if ((x26 !== null)) {
            var \u03b41$___1 = x26.g();
            var \u03b41$___2 = (+x26.h());
            break matchResult9;
          }
          throw new $c_s_MatchError(x26);
        }
        var lastMove$2 = \u03b41$___1;
        var scale0$2 = (+\u03b41$___2);
        var reversed = (d$2.qW(lastMove$2) < 0.0);
        if (reversed) {
          var y$3 = (0.5 * scale0$2);
          var scale = (+Math.max(0.05, y$3));
        } else {
          var y$4 = (1.15 * scale0$2);
          var scale = (+Math.min(1.0, y$4));
        }
        var cap = (t$2 * scale);
        var move = ((len$1 <= cap) ? d$2 : d$2.dj((cap / len$1)));
        motionB.lR(nodeId, new $c_T2(move, scale));
        return new $c_T2(nodeId, pos.a[i$4].iQ(move));
      }
    }))));
    var floor = (k * params.My);
    var cooled = (t$2 * params.Mx);
    var temperature$2 = ((cooled < floor) ? 0.0 : cooled);
    var iteration$2 = ((1 + state.mk) | 0);
    var motion$2 = motionB.oG();
    return new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayoutState3D(state.l2, state.he, newPositions, temperature$2, iteration$2, state.kE, state.lG, motion$2, state.lF);
  }
});
var $d_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$, "org.jpablo.graphexplorer.viewer.layout3d.ForceLayout3D$", ({
  CQ: 1,
  bC: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$;
function $m_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$ = new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$Configured(params) {
  this.Tz = null;
  this.Tz = params;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$Configured.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$Configured;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$Configured() {
}
$h_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$Configured.prototype = $p;
$p.Qb = (function() {
  return false;
});
$p.u6 = (function() {
  return $m_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$().Cq;
});
$p.aI = (function() {
  return $m_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$().aaL;
});
$p.E8 = (function() {
  return $m_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$().aaK;
});
$p.AK = (function(values) {
  return $m_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$().AK(values);
});
$p.Pv = (function(graph) {
  return $m_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$().aPh(graph, this.Tz);
});
$p.Jr = (function(state, newGraph) {
  return $m_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$().aSD(state, newGraph, this.Tz);
});
$p.Jo = (function(state) {
  return $m_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$().aSo(state, this.Tz);
});
$p.PO = (function(state) {
  return $m_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$().aRt(state, this.Tz);
});
var $d_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$Configured = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$Configured, "org.jpablo.graphexplorer.viewer.layout3d.ForceLayout3D$Configured", ({
  CS: 1,
  bC: 1
}));
function $p_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$__maxDistanceToTargets__sci_Map__sci_Map__D($thiz, positions, targets) {
  if (targets.c()) {
    return 0.0;
  } else {
    var this$5 = $f_sc_IterableOnceOps__maxOption__s_math_Ordering__s_Option(new $c_sc_Iterator$$anon$9(targets.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
      var nodeId = x$1.g();
      var t = x$1.h();
      var this$1 = positions.r(nodeId);
      if (this$1.c()) {
        var this$2 = $m_s_None$();
      } else {
        var x0 = this$1.d();
        var this$2 = new $c_s_Some(t.fN(x0).js());
      }
      return (+(this$2.c() ? 0.0 : this$2.d()));
    }))), $m_s_math_Ordering$DeprecatedDoubleOrdering$());
    return (+(this$5.c() ? 0.0 : this$5.d()));
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$__acyclicEdges__Lorg_jpablo_graphexplorer_viewer_layout3d_LayoutGraph__sci_Map__AZ($thiz, graph, index) {
  var n = graph.hv.C();
  if ((n <= 0)) {
    var keep = new $ac_Z(0);
  } else {
    var array = new $ac_Z(n);
    var i = 0;
    while ((i < n)) {
      array.a[i] = true;
      i = ((1 + i) | 0);
    }
    var keep = array;
  }
  var n$1 = graph.l1.C();
  if ((n$1 <= 0)) {
    var outEdges = new ($d_sci_Vector.r().C)(0);
  } else {
    var array$1 = new ($d_sci_Vector.r().C)(n$1);
    var i$1 = 0;
    while ((i$1 < n$1)) {
      array$1.a[i$1] = ($m_sci_Vector$(), $m_sci_Vector0$());
      i$1 = ((1 + i$1) | 0);
    }
    var outEdges = array$1;
  }
  var this$9 = graph.hv;
  var end = this$9.C();
  var isEmpty = (end <= 0);
  var scala$collection$immutable$Range$$lastElement = ((end - 1) | 0);
  if ((!isEmpty)) {
    var i$2 = 0;
    while (true) {
      var x0 = i$2;
      matchResult6: {
        var \u03b42$___1;
        var \u03b42$___2;
        var x11 = graph.hv.l(x0);
        if ((x11 !== null)) {
          var \u03b42$___1 = x11.g();
          var \u03b42$___2 = x11.h();
          break matchResult6;
        }
        throw new $c_s_MatchError(x11);
      }
      var s$2 = \u03b42$___1;
      var t$2 = \u03b42$___2;
      if (((s$2 === null) ? (t$2 === null) : s$2.e(t$2))) {
        keep.a[x0] = false;
      } else {
        outEdges.a[(index.i(s$2) | 0)] = outEdges.a[(index.i(s$2) | 0)].bv(x0);
      }
      if ((i$2 === scala$collection$immutable$Range$$lastElement)) {
        break;
      }
      i$2 = ((1 + i$2) | 0);
    }
  }
  var n$2 = graph.l1.C();
  if ((n$2 <= 0)) {
    var color = new $ac_I(0);
  } else {
    var array$2 = new $ac_I(n$2);
    var i$3 = 0;
    while ((i$3 < n$2)) {
      array$2.a[i$3] = 0;
      i$3 = ((1 + i$3) | 0);
    }
    var color = array$2;
  }
  var stack = $ct_scm_Stack__I__(new $c_scm_Stack(), 16);
  var this$24 = $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(new $c_sc_IterableOps$WithFilter(), new $c_sci_Range$Exclusive(0, graph.l1.C(), 1), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((root) => (color.a[(root | 0)] === 0))));
  var f = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1$2) => {
    var root$2 = (v1$2 | 0);
    color.a[root$2] = 1;
    stack.gm(new $c_T2(root$2, outEdges.a[root$2].o()));
    while ((!stack.c())) {
      matchResult7: {
        var \u03b43$___1;
        var \u03b43$___2;
        var x14 = $f_sc_IndexedSeqOps__head__O(stack);
        if ((x14 !== null)) {
          var \u03b43$___1 = (x14.g() | 0);
          var \u03b43$___2 = x14.h();
          break matchResult7;
        }
        throw new $c_s_MatchError(x14);
      }
      var u$2 = (\u03b43$___1 | 0);
      var it$2 = \u03b43$___2;
      if (it$2.p()) {
        var ei = (it$2.q() | 0);
        var v = (index.i(graph.hv.l(ei).h()) | 0);
        if ((color.a[v] === 1)) {
          keep.a[ei] = false;
        } else if ((color.a[v] === 0)) {
          color.a[v] = 1;
          stack.gm(new $c_T2(v, outEdges.a[v].o()));
        }
      } else {
        stack.h7(false);
        color.a[u$2] = 2;
      }
    }
  }));
  this$24.qY().F(f);
  return keep;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$() {
  this.GO = null;
  this.aaN = null;
  this.aaM = null;
  this.Cu = null;
  this.a0N = 0.0;
  $n_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$ = this;
  this.GO = "layers";
  this.aaN = "Layers";
  this.aaM = new $c_sci_$colon$colon(new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Knob3D("layerGap", "Layer gap", 0.6, 4.0, 0.05, 1.6), new $c_sci_$colon$colon(new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Knob3D("k", "Spacing", 0.4, 3.0, 0.05, 1.0), $m_sci_Nil$()));
  this.Cu = new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$Params(1.0, 1.6, 40, 0.9, 0.18, 0.002);
  this.a0N = (3.141592653589793 * (3.0 - (+Math.sqrt(5.0))));
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$.prototype = $p;
$p.Qb = (function() {
  return false;
});
$p.u6 = (function() {
  return this.GO;
});
$p.aI = (function() {
  return this.aaN;
});
$p.E8 = (function() {
  return this.aaM;
});
$p.b6o = (function(values) {
  return new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$Params((+values.ay("k", new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$().Cu.vp)))), (+values.ay("layerGap", new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$().Cu.GP)))), 40, 0.9, 0.18, 0.002);
});
$p.AK = (function(values) {
  return new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$Configured(this.b6o(values));
});
$p.PO = (function(state) {
  return this.aRu(state, this.Cu);
});
$p.aRu = (function(state, params) {
  var t = this.a4T(state.he, params);
  var temperature$1 = $p_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$__maxDistanceToTargets__sci_Map__sci_Map__D(this, state.fF, t);
  return new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayoutState3D(state.l2, state.he, state.fF, temperature$1, state.mk, t, state.lG, state.nc, state.lF);
});
$p.Pv = (function(graph) {
  return this.aPi(graph, this.Cu);
});
$p.aPi = (function(graph, params) {
  var t = this.a4T(graph, params);
  return new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayoutState3D(this.GO, graph, t, 0.0, 0, t, $m_sci_Set$EmptySet$(), $m_sci_Map$EmptyMap$(), ($m_sci_Vector$(), $m_sci_Vector0$()));
});
$p.Jr = (function(state, newGraph) {
  return this.aSE(state, newGraph, this.Cu);
});
$p.aSE = (function(state, newGraph, params) {
  var x = state.he;
  if ((((x === null) ? (newGraph === null) : x.e(newGraph)) && (state.l2 === this.GO))) {
    return state;
  } else {
    var t = this.a4T(newGraph, params);
    var positions = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$9(newGraph.l1.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((nodeId) => new $c_T2(nodeId, state.fF.ay(nodeId, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((nodeId$2) => (() => t.i(nodeId$2)))(nodeId))))))));
    var temperature = $p_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$__maxDistanceToTargets__sci_Map__sci_Map__D(this, positions, t);
    return ((temperature <= (params.vp * params.GQ)) ? new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayoutState3D(this.GO, newGraph, t, 0.0, 0, t, $m_sci_Set$EmptySet$(), $m_sci_Map$EmptyMap$(), ($m_sci_Vector$(), $m_sci_Vector0$())) : new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayoutState3D(this.GO, newGraph, positions, temperature, 0, t, $m_sci_Set$EmptySet$(), $m_sci_Map$EmptyMap$(), ($m_sci_Vector$(), $m_sci_Vector0$())));
  }
});
$p.Jo = (function(state) {
  return this.aSp(state, this.Cu);
});
$p.aSp = (function(state, params) {
  if (state.DU()) {
    return state;
  } else {
    var moved = state.fF.kP(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
      var nodeId = x$1.g();
      var p = x$1.h();
      if (state.lG.E(nodeId)) {
        return new $c_T2(nodeId, p);
      } else {
        var x5 = state.kE.r(nodeId);
        if ((x5 instanceof $c_s_Some)) {
          var t = x5.J;
          return new $c_T2(nodeId, p.iQ(t.fN(p).dj(params.MF)));
        }
        if (($m_s_None$() === x5)) {
          return new $c_T2(nodeId, p);
        }
        throw new $c_s_MatchError(x5);
      }
    })));
    var remaining = $p_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$__maxDistanceToTargets__sci_Map__sci_Map__D(this, moved, state.kE);
    if ((remaining <= (params.vp * params.GQ))) {
      var iteration$2 = ((1 + state.mk) | 0);
      var algoId$2 = state.l2;
      var graph$2 = state.he;
      var targets$1 = state.kE;
      var pinned$2 = state.lG;
      var motion$2 = state.nc;
      var edgeOffsets$2 = state.lF;
      return new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayoutState3D(algoId$2, graph$2, state.kE, 0.0, iteration$2, targets$1, pinned$2, motion$2, edgeOffsets$2);
    } else {
      var iteration$3 = ((1 + state.mk) | 0);
      return new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayoutState3D(state.l2, state.he, moved, remaining, iteration$3, state.kE, state.lG, state.nc, state.lF);
    }
  }
});
$p.b78 = (function(graph) {
  var nodes = graph.l1;
  var index = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$16(nodes.o()));
  var keep = $p_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$__acyclicEdges__Lorg_jpablo_graphexplorer_viewer_layout3d_LayoutGraph__sci_Map__AZ(this, graph, index);
  var n = nodes.C();
  if ((n <= 0)) {
    var outEdges = new ($d_sci_Vector.r().C)(0);
  } else {
    var array = new ($d_sci_Vector.r().C)(n);
    var i = 0;
    while ((i < n)) {
      array.a[i] = ($m_sci_Vector$(), $m_sci_Vector0$());
      i = ((1 + i) | 0);
    }
    var outEdges = array;
  }
  var n$1 = nodes.C();
  if ((n$1 <= 0)) {
    var indegree = new $ac_I(0);
  } else {
    var array$1 = new $ac_I(n$1);
    var i$1 = 0;
    while ((i$1 < n$1)) {
      array$1.a[i$1] = 0;
      i$1 = ((1 + i$1) | 0);
    }
    var indegree = array$1;
  }
  var this$16 = $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(new $c_sc_IterableOps$WithFilter(), new $c_sci_Range$Exclusive(0, graph.hv.C(), 1), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((ei) => {
    var ei$1 = (ei | 0);
    return keep.a[ei$1];
  })));
  var f = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => {
    var ei$2 = (v1 | 0);
    matchResult5: {
      var \u03b41$___1;
      var \u03b41$___2;
      var x8 = graph.hv.l(ei$2);
      if ((x8 !== null)) {
        var \u03b41$___1 = x8.g();
        var \u03b41$___2 = x8.h();
        break matchResult5;
      }
      throw new $c_s_MatchError(x8);
    }
    var s$2 = \u03b41$___1;
    var t$2 = \u03b41$___2;
    outEdges.a[(index.i(s$2) | 0)] = outEdges.a[(index.i(s$2) | 0)].bv(ei$2);
    var i$1$1 = (index.i(t$2) | 0);
    indegree.a[i$1$1] = ((1 + indegree.a[i$1$1]) | 0);
  }));
  this$16.qY().F(f);
  var n$2 = nodes.C();
  if ((n$2 <= 0)) {
    var rank = new $ac_I(0);
  } else {
    var array$2 = new $ac_I(n$2);
    var i$2 = 0;
    while ((i$2 < n$2)) {
      array$2.a[i$2] = 0;
      i$2 = ((1 + i$2) | 0);
    }
    var rank = array$2;
  }
  var end$1 = nodes.C();
  var isEmpty = (end$1 <= 0);
  var scala$collection$immutable$Range$$lastElement = ((end$1 - 1) | 0);
  var b = $m_sci_IndexedSeq$().b5();
  var it = new $c_sci_RangeIterator(0, 1, scala$collection$immutable$Range$$lastElement, isEmpty);
  while (it.g0) {
    var elem = it.hp();
    if ((indegree.a[elem] === 0)) {
      b.Y(elem);
    }
  }
  var source = b.aR();
  var queue = $ct_scm_Queue__I__(new $c_scm_Queue(), 16).kl(source);
  while ((!queue.c())) {
    var u = (queue.h7(false) | 0);
    outEdges.a[u].F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((index, graph, rank, u, indegree, queue) => ((v1$2) => {
      var ei$3 = (v1$2 | 0);
      var v = (index.i(graph.hv.l(ei$3).h()) | 0);
      var x = rank.a[v];
      var y = ((1 + rank.a[u]) | 0);
      rank.a[v] = ((x > y) ? x : y);
      indegree.a[v] = ((indegree.a[v] - 1) | 0);
      if ((indegree.a[v] === 0)) {
        queue.km(v);
      }
    }))(index, graph, rank, u, indegree, queue)));
  }
  return $m_sci_Map$().ao(new $c_sc_Iterator$$anon$9(new $c_sc_Iterator$$anon$16(nodes.o()), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => new $c_T2(x$1.g(), rank.a[(x$1.h() | 0)])))));
});
$p.a4T = (function(graph, params) {
  var nodes = graph.l1;
  if ($f_sc_SeqOps__isEmpty__Z(nodes)) {
    return $m_sci_Map$EmptyMap$();
  } else {
    var index = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$16(nodes.o()));
    var rankOf = this.b78(graph);
    var maxRank = ($f_sc_IterableOnceOps__max__s_math_Ordering__O(rankOf.hr(), $m_s_math_Ordering$Int$()) | 0);
    var gap = (params.GP * params.vp);
    var this$6 = new $c_sci_Range$Exclusive(0, nodes.C(), 1);
    var this$7 = $m_sci_Vector$().X(this$6);
    var m = $m_scm_Map$().aO();
    var it = this$7.o();
    while (it.p()) {
      var elem = it.q();
      var i = (elem | 0);
      var key = (rankOf.i(nodes.l(i)) | 0);
      m.ec(key, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
        $m_sci_Vector$();
        return new $c_sci_VectorBuilder();
      }))).Y(elem);
    }
    var result = $m_sci_HashMap$().fk;
    var mapIt = m.o();
    while (mapIt.p()) {
      var x1 = mapIt.q();
      if ((x1 === null)) {
        throw new $c_s_MatchError(x1);
      }
      var k = x1.g();
      var v = x1.h();
      result = result.hq(k, v.aR());
    }
    var layers = result;
    var n = nodes.C();
    if ((n <= 0)) {
      var xs = new $ac_D(0);
    } else {
      var array = new $ac_D(n);
      var i$1 = 0;
      while ((i$1 < n)) {
        array.a[i$1] = 0.0;
        i$1 = ((1 + i$1) | 0);
      }
      var xs = array;
    }
    var n$1 = nodes.C();
    if ((n$1 <= 0)) {
      var zs = new $ac_D(0);
    } else {
      var array$1 = new $ac_D(n$1);
      var i$2 = 0;
      while ((i$2 < n$1)) {
        array$1.a[i$2] = 0.0;
        i$2 = ((1 + i$2) | 0);
      }
      var zs = array$1;
    }
    var f = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
      matchResult9: {
        if ((x$1 !== null)) {
          $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(x$1.h()).F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
            matchResult8: {
              if ((x$1$2 !== null)) {
                var i$3 = (x$1$2.g() | 0);
                var j = (x$1$2.h() | 0);
                var $x_1 = params.vp;
                var x = j;
                var radius = ((0.7 * $x_1) * (+Math.sqrt(x)));
                var theta = (j * $m_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$().a0N);
                xs.a[i$3] = ((+Math.cos(theta)) * radius);
                zs.a[i$3] = ((+Math.sin(theta)) * radius);
                break matchResult8;
              }
              throw new $c_s_MatchError(x$1$2);
            }
          })));
          break matchResult9;
        }
        throw new $c_s_MatchError(x$1);
      }
    }));
    layers.cP.F(f);
    var n$2 = nodes.C();
    if ((n$2 <= 0)) {
      var neighbors = new ($d_sci_Vector.r().C)(0);
    } else {
      var array$2 = new ($d_sci_Vector.r().C)(n$2);
      var i$4 = 0;
      while ((i$4 < n$2)) {
        array$2.a[i$4] = ($m_sci_Vector$(), $m_sci_Vector0$());
        i$4 = ((1 + i$4) | 0);
      }
      var neighbors = array$2;
    }
    var this$28 = $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(new $c_sc_IterableOps$WithFilter(), graph.hv, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$1) => {
      if ((x$1$2$1 !== null)) {
        var s = x$1$2$1.g();
        var t = x$1$2$1.h();
        return (!((s === null) ? (t === null) : s.e(t)));
      }
      throw new $c_s_MatchError(x$1$2$1);
    })));
    var f$1 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3) => {
      matchResult11: {
        if ((x$1$3 !== null)) {
          var s$1 = x$1$3.g();
          var t$1 = x$1$3.h();
          neighbors.a[(index.i(s$1) | 0)] = neighbors.a[(index.i(s$1) | 0)].bv(index.i(t$1));
          neighbors.a[(index.i(t$1) | 0)] = neighbors.a[(index.i(t$1) | 0)].bv(index.i(s$1));
          break matchResult11;
        }
        throw new $c_s_MatchError(x$1$3);
      }
    }));
    this$28.qY().F(f$1);
    var minSep = (params.vp * params.MD);
    var end$1 = params.ME;
    if ((!(end$1 < 1))) {
      var i$5 = 1;
      while (true) {
        var this$36 = $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(new $c_sc_IterableOps$WithFilter(), new $c_sci_Range$Exclusive(0, nodes.C(), 1), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((neighbors) => ((i$6) => (!$f_sc_SeqOps__isEmpty__Z(neighbors.a[(i$6 | 0)]))))(neighbors)));
        var f$2 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((neighbors, xs, zs) => ((v1) => {
          var i$8 = (v1 | 0);
          var ns = neighbors.a[i$8];
          var bx = ((+ns.L($m_s_Predef$().ys(xs)).k2($m_s_math_Numeric$DoubleIsFractional$())) / ns.C());
          var bz = ((+ns.L($m_s_Predef$().ys(zs)).k2($m_s_math_Numeric$DoubleIsFractional$())) / ns.C());
          xs.a[i$8] = (0.5 * (xs.a[i$8] + bx));
          zs.a[i$8] = (0.5 * (zs.a[i$8] + bz));
        }))(neighbors, xs, zs));
        this$36.qY().F(f$2);
        if ((!(maxRank < 0))) {
          var i$9 = 0;
          while (true) {
            var x0$1 = i$9;
            var members$1 = layers.ay(x0$1, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
              $m_sci_Vector$();
              return $m_sci_Vector0$();
            })));
            var end$3 = members$1.C();
            var isEmpty$2 = (end$3 <= 0);
            var scala$collection$immutable$Range$$lastElement = ((end$3 - 1) | 0);
            if ((!isEmpty$2)) {
              var i$10 = 0;
              while (true) {
                var x0$2 = i$10;
                var x$2 = ((1 + x0$2) | 0);
                var end$4 = members$1.C();
                var isEmpty$3 = (x$2 >= end$4);
                var scala$collection$immutable$Range$$lastElement$1 = ((end$4 - 1) | 0);
                if ((!isEmpty$3)) {
                  var i$11 = x$2;
                  while (true) {
                    var x0$3 = i$11;
                    var i$12 = (members$1.l(x0$2) | 0);
                    var j$1 = (members$1.l(x0$3) | 0);
                    var dx = (xs.a[j$1] - xs.a[i$12]);
                    var dz = (zs.a[j$1] - zs.a[i$12]);
                    var d = $m_jl_Math$().ga(dx, dz);
                    if ((d < minSep)) {
                      if ((d < 1.0E-9)) {
                        var x$3 = (j$1 * $m_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$().a0N);
                        var $x_2 = Math.cos(x$3);
                        var x$4 = (j$1 * $m_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$().a0N);
                        var \u03b44$___1 = (+$x_2);
                        var \u03b44$___2 = (+Math.sin(x$4));
                      } else {
                        var \u03b44$___1 = (dx / d);
                        var \u03b44$___2 = (dz / d);
                      }
                      var ux = (+\u03b44$___1);
                      var uz = (+\u03b44$___2);
                      var push = (0.5 * (minSep - d));
                      xs.a[i$12] = (xs.a[i$12] - (ux * push));
                      zs.a[i$12] = (zs.a[i$12] - (uz * push));
                      xs.a[j$1] = (xs.a[j$1] + (ux * push));
                      zs.a[j$1] = (zs.a[j$1] + (uz * push));
                    }
                    if ((i$11 === scala$collection$immutable$Range$$lastElement$1)) {
                      break;
                    }
                    i$11 = ((1 + i$11) | 0);
                  }
                }
                if ((i$10 === scala$collection$immutable$Range$$lastElement)) {
                  break;
                }
                i$10 = ((1 + i$10) | 0);
              }
            }
            if ((i$9 === maxRank)) {
              break;
            }
            i$9 = ((1 + i$9) | 0);
          }
        }
        if ((i$5 === end$1)) {
          break;
        }
        i$5 = ((1 + i$5) | 0);
      }
    }
    var cx = ((+$f_sc_IterableOnceOps__sum__s_math_Numeric__O($m_s_Predef$().ys(xs), $m_s_math_Numeric$DoubleIsFractional$())) / nodes.C());
    var cz = ((+$f_sc_IterableOnceOps__sum__s_math_Numeric__O($m_s_Predef$().ys(zs), $m_s_math_Numeric$DoubleIsFractional$())) / nodes.C());
    return $m_sci_Map$().ao(new $c_sc_Iterator$$anon$9(new $c_sc_Iterator$$anon$16(nodes.o()), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$4) => {
      var nodeId = x$1$4.g();
      var i$13 = (x$1$4.h() | 0);
      var y = (((0.5 * maxRank) - (rankOf.i(nodeId) | 0)) * gap);
      return new $c_T2(nodeId, ($m_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$(), new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3((xs.a[i$13] - cx), y, (zs.a[i$13] - cz))));
    }))));
  }
});
var $d_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$, "org.jpablo.graphexplorer.viewer.layout3d.LayeredLayout3D$", ({
  CT: 1,
  bC: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$;
function $m_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$ = new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$Configured(params) {
  this.TA = null;
  this.TA = params;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$Configured.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$Configured;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$Configured() {
}
$h_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$Configured.prototype = $p;
$p.Qb = (function() {
  return false;
});
$p.u6 = (function() {
  return $m_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$().GO;
});
$p.aI = (function() {
  return $m_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$().aaN;
});
$p.E8 = (function() {
  return $m_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$().aaM;
});
$p.AK = (function(values) {
  return $m_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$().AK(values);
});
$p.Pv = (function(graph) {
  return $m_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$().aPi(graph, this.TA);
});
$p.Jr = (function(state, newGraph) {
  return $m_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$().aSE(state, newGraph, this.TA);
});
$p.Jo = (function(state) {
  return $m_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$().aSp(state, this.TA);
});
$p.PO = (function(state) {
  return $m_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$().aRu(state, this.TA);
});
var $d_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$Configured = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$Configured, "org.jpablo.graphexplorer.viewer.layout3d.LayeredLayout3D$Configured", ({
  CU: 1,
  bC: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_AttributePair$$anon$3(p$2) {
  this.aaR = null;
  this.aaR = p$2;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_AttributePair$$anon$3.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_AttributePair$$anon$3;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_AttributePair$$anon$3() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_AttributePair$$anon$3.prototype = $p;
$p.aSZ = (function() {
  return new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId(this.aaR.g().aN()), ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue($dp_toString__T(this.aaR.h()))));
});
var $d_Lorg_jpablo_graphexplorer_viewer_models_AttributePair$$anon$3 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_AttributePair$$anon$3, "org.jpablo.graphexplorer.viewer.models.AttributePair$$anon$3", ({
  Dc: 1,
  jm: 1
}));
function $is_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.cC)));
}
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.cC)));
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_EphemeralPersistence(initial, unsupportedMessage) {
  this.aFD = null;
  this.aFE = null;
  this.aFD = initial;
  this.aFE = unsupportedMessage;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_EphemeralPersistence.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_EphemeralPersistence;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_EphemeralPersistence() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_EphemeralPersistence.prototype = $p;
$p.Pw = (function() {
  return this.aFD;
});
$p.afB = (function() {
  return $m_Lcom_raquo_airstream_core_EventStream$().Qr;
});
$p.a56 = (function(next) {
});
$p.a4B = (function(next, x$2) {
  return $m_s_concurrent_Future$().m4(new $c_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$Unsupported(this.aFE));
});
$p.aeZ = (function() {
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_EphemeralPersistence = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_EphemeralPersistence, "org.jpablo.graphexplorer.viewer.state.EphemeralPersistence", ({
  DT: 1,
  dr: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_LibraryDiagramPersistence(id, initialSource) {
  this.aFP = null;
  this.ab6 = null;
  this.aFQ = null;
  this.aFR = false;
  this.aFP = id;
  this.ab6 = $m_Lorg_jpablo_graphexplorer_projects_Library$().a34(id, initialSource);
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_LibraryDiagramPersistence.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_LibraryDiagramPersistence;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_LibraryDiagramPersistence() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_LibraryDiagramPersistence.prototype = $p;
$p.Pw = (function() {
  if ((!this.aFR)) {
    this.aFQ = this.ab6.P().aq().d();
    this.aFR = true;
  }
  return this.aFQ;
});
$p.afB = (function() {
  return $m_Lorg_jpablo_graphexplorer_projects_Library$().a4r(this.aFP);
});
$p.a56 = (function(next) {
  $f_Lcom_raquo_airstream_state_Var__set__O__V(this.ab6, next);
});
$p.a4B = (function(next, x$2) {
  this.a56(next);
  $m_Lorg_jpablo_graphexplorer_projects_Library$().WT();
  return $m_s_concurrent_Future$().m4($s_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$__Saved__Lorg_jpablo_graphexplorer_viewer_state_SaveResult());
});
$p.aeZ = (function() {
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_LibraryDiagramPersistence = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_LibraryDiagramPersistence, "org.jpablo.graphexplorer.viewer.state.LibraryDiagramPersistence", ({
  E7: 1,
  dr: 1
}));
function $f_Lorg_jpablo_graphexplorer_viewer_utils_UtilsPlatform__randomUUID__T($thiz) {
  return (0, $i_uuid.v4)();
}
/** @constructor */
function $c_s_$less$colon$less$() {
  this.b1 = null;
  $n_s_$less$colon$less$ = this;
  this.b1 = new $c_s_$less$colon$less$$anon$1();
}
$p = $c_s_$less$colon$less$.prototype = new $h_O();
$p.constructor = $c_s_$less$colon$less$;
/** @constructor */
function $h_s_$less$colon$less$() {
}
$h_s_$less$colon$less$.prototype = $p;
var $d_s_$less$colon$less$ = new $TypeData().i($c_s_$less$colon$less$, "scala.$less$colon$less$", ({
  FV: 1,
  a: 1
}));
var $n_s_$less$colon$less$;
function $m_s_$less$colon$less$() {
  if ((!$n_s_$less$colon$less$)) {
    $n_s_$less$colon$less$ = new $c_s_$less$colon$less$();
  }
  return $n_s_$less$colon$less$;
}
function $p_s_Array$__slowcopy__O__I__O__I__I__V($thiz, src, srcPos, dest, destPos, length) {
  var i = srcPos;
  var j = destPos;
  var srcUntil = ((srcPos + length) | 0);
  while ((i < srcUntil)) {
    $m_sr_ScalaRunTime$().kn(dest, j, $m_sr_ScalaRunTime$().f6(src, i));
    i = ((1 + i) | 0);
    j = ((1 + j) | 0);
  }
}
function $p_s_Array$__newUnitArray__I__Ajl_Void($thiz, len) {
  var result = new ($d_jl_Void.r().C)(len);
  $m_ju_Arrays$().WM(result, (void 0));
  return result;
}
/** @constructor */
function $c_s_Array$() {
}
$p = $c_s_Array$.prototype = new $h_O();
$p.constructor = $c_s_Array$;
/** @constructor */
function $h_s_Array$() {
}
$h_s_Array$.prototype = $p;
$p.aOp = (function(it, evidence$3) {
  var n = it.V();
  if ((n > (-1))) {
    var elements = evidence$3.b2(n);
    var iterator = it.o();
    var i = 0;
    while ((i < n)) {
      $m_sr_ScalaRunTime$().kn(elements, i, iterator.q());
      i = ((1 + i) | 0);
    }
    return elements;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    var elementClass = evidence$3.h8();
    capacity = 0;
    size = 0;
    var isCharArrayBuilder = (elementClass === $d_C.l());
    jsElems = [];
    var iterator$2 = it.o();
    while (iterator$2.p()) {
      var elem = iterator$2.q();
      var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? elementClass.ba.z : elem));
      jsElems.push(unboxedElem);
    }
    var elemRuntimeClass = ((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass));
    return elemRuntimeClass.ba.r().w(jsElems);
  }
});
$p.fv = (function(src, srcPos, dest, destPos, length) {
  var srcClass = $objectGetClass(src);
  if ((srcClass.ba.Z && $objectGetClass(dest).ba.R(srcClass.ba))) {
    src.av(srcPos, dest, destPos, length);
  } else {
    $p_s_Array$__slowcopy__O__I__O__I__I__V(this, src, srcPos, dest, destPos, length);
  }
});
$p.y4 = (function(original, newLength) {
  if ($isArrayOf_jl_Void(original, 1)) {
    return $p_s_Array$__newUnitArray__I__Ajl_Void(this, newLength);
  } else if ((original instanceof $ac_O)) {
    return $m_ju_Arrays$().ex(original, newLength);
  } else if ((original instanceof $ac_I)) {
    return $m_ju_Arrays$().aN9(original, newLength);
  } else if ((original instanceof $ac_D)) {
    return $m_ju_Arrays$().aZh(original, newLength);
  } else if ((original instanceof $ac_J)) {
    return $m_ju_Arrays$().aNa(original, newLength);
  } else if ((original instanceof $ac_F)) {
    return $m_ju_Arrays$().aZi(original, newLength);
  } else if ((original instanceof $ac_C)) {
    return $m_ju_Arrays$().a31(original, newLength);
  } else if ((original instanceof $ac_B)) {
    return $m_ju_Arrays$().aN8(original, newLength);
  } else if ((original instanceof $ac_S)) {
    return $m_ju_Arrays$().aNb(original, newLength);
  } else if ((original instanceof $ac_Z)) {
    return $m_ju_Arrays$().aNc(original, newLength);
  } else {
    throw new $c_s_MatchError(original);
  }
});
$p.aZg = (function(original, newLength, ct) {
  var runtimeClass = ct.h8();
  if (((runtimeClass !== null) && (runtimeClass === $d_V.l()))) {
    return $p_s_Array$__newUnitArray__I__Ajl_Void(this, newLength);
  } else if (runtimeClass.ba.R($objectGetClass(original).ba.Q().ba)) {
    return (runtimeClass.ba.X ? this.y4(original, newLength) : $m_ju_Arrays$().WA(original, newLength, $objectGetClass(runtimeClass.ba.U(0))));
  } else {
    var dest = ct.b2(newLength);
    $m_s_Array$().fv(original, 0, dest, 0, $m_jl_reflect_Array$().c6(original));
    return dest;
  }
});
$p.aNO = (function(xs, ys) {
  if ((xs === ys)) {
    return true;
  }
  if ((xs.a.length !== ys.a.length)) {
    return false;
  }
  var len = xs.a.length;
  var i = 0;
  while ((i < len)) {
    if ((!$m_sr_BoxesRunTime$().Q(xs.a[i], ys.a[i]))) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
var $d_s_Array$ = new $TypeData().i($c_s_Array$, "scala.Array$", ({
  FX: 1,
  a: 1
}));
var $n_s_Array$;
function $m_s_Array$() {
  if ((!$n_s_Array$)) {
    $n_s_Array$ = new $c_s_Array$();
  }
  return $n_s_Array$;
}
/** @constructor */
function $c_s_CanEqual$derived$() {
}
$p = $c_s_CanEqual$derived$.prototype = new $h_O();
$p.constructor = $c_s_CanEqual$derived$;
/** @constructor */
function $h_s_CanEqual$derived$() {
}
$h_s_CanEqual$derived$.prototype = $p;
var $d_s_CanEqual$derived$ = new $TypeData().i($c_s_CanEqual$derived$, "scala.CanEqual$derived$", ({
  G1: 1,
  G0: 1
}));
var $n_s_CanEqual$derived$;
function $m_s_CanEqual$derived$() {
  if ((!$n_s_CanEqual$derived$)) {
    $n_s_CanEqual$derived$ = new $c_s_CanEqual$derived$();
  }
  return $n_s_CanEqual$derived$;
}
/** @constructor */
function $c_s_Console$() {
  this.aHm = null;
  $n_s_Console$ = this;
  this.aHm = new $c_s_util_DynamicVariable($m_jl_System$Streams$().at2);
}
$p = $c_s_Console$.prototype = new $h_O();
$p.constructor = $c_s_Console$;
/** @constructor */
function $h_s_Console$() {
}
$h_s_Console$.prototype = $p;
$p.ahl = (function() {
  return this.aHm.adq;
});
var $d_s_Console$ = new $TypeData().i($c_s_Console$, "scala.Console$", ({
  G2: 1,
  KJ: 1
}));
var $n_s_Console$;
function $m_s_Console$() {
  if ((!$n_s_Console$)) {
    $n_s_Console$ = new $c_s_Console$();
  }
  return $n_s_Console$;
}
/** @constructor */
function $c_s_Conversion() {
}
$p = $c_s_Conversion.prototype = new $h_O();
$p.constructor = $c_s_Conversion;
/** @constructor */
function $h_s_Conversion() {
}
$h_s_Conversion.prototype = $p;
$p.m = (function() {
  return "<function1>";
});
$p.iU = (function(v1) {
  return (!(!this.i(v1)));
});
function $ct_s_Enumeration__I__($thiz, initial) {
  $thiz.a1c = $ct_scm_HashMap__(new $c_scm_HashMap());
  $ct_scm_HashMap__(new $c_scm_HashMap());
  $thiz.UA = initial;
  $thiz.a1b = initial;
  $thiz.a1a = ((initial < 0) ? initial : 0);
  return $thiz;
}
/** @constructor */
function $c_s_Enumeration() {
  this.a1c = null;
  this.UA = 0;
  this.i1 = null;
  this.a1b = 0;
  this.a1a = 0;
}
$p = $c_s_Enumeration.prototype = new $h_O();
$p.constructor = $c_s_Enumeration;
/** @constructor */
function $h_s_Enumeration() {
}
$h_s_Enumeration.prototype = $p;
$p.m = (function() {
  return $m_sc_ArrayOps$().a44($m_sc_StringOps$().Ej($m_sc_ArrayOps$().a44($m_sc_StringOps$().Ej($m_sc_StringOps$().wh($objectClassName(this), "$"), 46)), 36));
});
/** @constructor */
function $c_s_LowPriorityImplicits() {
}
$p = $c_s_LowPriorityImplicits.prototype = new $h_s_LowPriorityImplicits2();
$p.constructor = $c_s_LowPriorityImplicits;
/** @constructor */
function $h_s_LowPriorityImplicits() {
}
$h_s_LowPriorityImplicits.prototype = $p;
$p.fB = (function(xs) {
  return ((xs === null) ? null : ((xs.a.length === 0) ? $m_scm_ArraySeq$().a1S : new $c_scm_ArraySeq$ofRef(xs)));
});
$p.a5j = (function(xs) {
  return ((xs !== null) ? new $c_scm_ArraySeq$ofInt(xs) : null);
});
$p.ys = (function(xs) {
  return ((xs !== null) ? new $c_scm_ArraySeq$ofDouble(xs) : null);
});
$p.bc2 = (function(xs) {
  return ((xs !== null) ? new $c_scm_ArraySeq$ofByte(xs) : null);
});
$p.bc1 = (function(xs) {
  return ((xs !== null) ? new $c_scm_ArraySeq$ofBoolean(xs) : null);
});
$p.JL = (function(s) {
  return ((s !== null) ? new $c_sci_WrappedString(s) : null);
});
/** @constructor */
function $c_s_Option$() {
}
$p = $c_s_Option$.prototype = new $h_O();
$p.constructor = $c_s_Option$;
/** @constructor */
function $h_s_Option$() {
}
$h_s_Option$.prototype = $p;
$p.m2 = (function(xo) {
  return (xo.c() ? $m_sc_Iterable$().aO() : new $c_sc_Iterable$$anon$1(xo.d()));
});
$p.as = (function(x) {
  return ((x === null) ? $m_s_None$() : new $c_s_Some(x));
});
var $d_s_Option$ = new $TypeData().i($c_s_Option$, "scala.Option$", ({
  Ge: 1,
  a: 1
}));
var $n_s_Option$;
function $m_s_Option$() {
  if ((!$n_s_Option$)) {
    $n_s_Option$ = new $c_s_Option$();
  }
  return $n_s_Option$;
}
function $f_s_PartialFunction__applyOrElse__O__F1__O($thiz, x, default$1) {
  return ($thiz.aM(x) ? $thiz.i(x) : default$1.i(x));
}
function $f_s_PartialFunction__runWith__F1__F1($thiz, action) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2$2) => {
    var z = $thiz.aC(x$2$2, $m_s_PartialFunction$().UB);
    return ((!$m_s_PartialFunction$().aRQ(z)) && (action.i(z), true));
  }));
}
function $f_s_Product__productElementName__I__T($thiz, n) {
  if (((n >= 0) && (n < $thiz.z()))) {
    return "";
  } else {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((n + " is out of bounds (min 0, max ") + (($thiz.z() - 1) | 0)) + ")"));
  }
}
function $is_s_Product(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.c)));
}
function $isArrayOf_s_Product(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.c)));
}
/** @constructor */
function $c_s_Symbol(name) {
  this.UE = null;
  this.UE = name;
}
$p = $c_s_Symbol.prototype = new $h_O();
$p.constructor = $c_s_Symbol;
/** @constructor */
function $h_s_Symbol() {
}
$h_s_Symbol.prototype = $p;
$p.m = (function() {
  return (("Symbol(" + this.UE) + ")");
});
$p.x = (function() {
  return $f_T__hashCode__I(this.UE);
});
$p.e = (function(other) {
  return (this === other);
});
function $isArrayOf_s_Symbol(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kv)));
}
var $d_s_Symbol = new $TypeData().i($c_s_Symbol, "scala.Symbol", ({
  kv: 1,
  a: 1
}));
/** @constructor */
function $c_sc_BuildFromLowPriority2$$anon$11(outer) {
}
$p = $c_sc_BuildFromLowPriority2$$anon$11.prototype = new $h_O();
$p.constructor = $c_sc_BuildFromLowPriority2$$anon$11;
/** @constructor */
function $h_sc_BuildFromLowPriority2$$anon$11() {
}
$h_sc_BuildFromLowPriority2$$anon$11.prototype = $p;
$p.aQq = (function(from) {
  return from.cd().b5();
});
var $d_sc_BuildFromLowPriority2$$anon$11 = new $TypeData().i($c_sc_BuildFromLowPriority2$$anon$11, "scala.collection.BuildFromLowPriority2$$anon$11", ({
  GI: 1,
  GE: 1
}));
function $f_sc_IterableFactory__unfold__O__F1__O($thiz, init, f) {
  return $thiz.cc(new $c_sc_View$Unfold(init, f));
}
/** @constructor */
function $c_sc_WithFilter() {
}
$p = $c_sc_WithFilter.prototype = new $h_O();
$p.constructor = $c_sc_WithFilter;
/** @constructor */
function $h_sc_WithFilter() {
}
$h_sc_WithFilter.prototype = $p;
/** @constructor */
function $c_scg_BitOperations$Int$() {
}
$p = $c_scg_BitOperations$Int$.prototype = new $h_O();
$p.constructor = $c_scg_BitOperations$Int$;
/** @constructor */
function $h_scg_BitOperations$Int$() {
}
$h_scg_BitOperations$Int$.prototype = $p;
var $d_scg_BitOperations$Int$ = new $TypeData().i($c_scg_BitOperations$Int$, "scala.collection.generic.BitOperations$Int$", ({
  I4: 1,
  I3: 1
}));
var $n_scg_BitOperations$Int$;
function $m_scg_BitOperations$Int$() {
  if ((!$n_scg_BitOperations$Int$)) {
    $n_scg_BitOperations$Int$ = new $c_scg_BitOperations$Int$();
  }
  return $n_scg_BitOperations$Int$;
}
/** @constructor */
function $c_sci_LazyList$Uninitialized$() {
}
$p = $c_sci_LazyList$Uninitialized$.prototype = new $h_O();
$p.constructor = $c_sci_LazyList$Uninitialized$;
/** @constructor */
function $h_sci_LazyList$Uninitialized$() {
}
$h_sci_LazyList$Uninitialized$.prototype = $p;
var $d_sci_LazyList$Uninitialized$ = new $TypeData().i($c_sci_LazyList$Uninitialized$, "scala.collection.immutable.LazyList$Uninitialized$", ({
  In: 1,
  a: 1
}));
var $n_sci_LazyList$Uninitialized$;
function $m_sci_LazyList$Uninitialized$() {
  if ((!$n_sci_LazyList$Uninitialized$)) {
    $n_sci_LazyList$Uninitialized$ = new $c_sci_LazyList$Uninitialized$();
  }
  return $n_sci_LazyList$Uninitialized$;
}
/** @constructor */
function $c_sci_List$$anon$1() {
}
$p = $c_sci_List$$anon$1.prototype = new $h_O();
$p.constructor = $c_sci_List$$anon$1;
/** @constructor */
function $h_sci_List$$anon$1() {
}
$h_sci_List$$anon$1.prototype = $p;
$p.iU = (function(v1) {
  return this;
});
$p.m = (function() {
  return "<function1>";
});
$p.i = (function(x) {
  return this;
});
var $d_sci_List$$anon$1 = new $TypeData().i($c_sci_List$$anon$1, "scala.collection.immutable.List$$anon$1", ({
  Iq: 1,
  h: 1
}));
/** @constructor */
function $c_sci_MapNode() {
}
$p = $c_sci_MapNode.prototype = new $h_sci_Node();
$p.constructor = $c_sci_MapNode;
/** @constructor */
function $h_sci_MapNode() {
}
$h_sci_MapNode.prototype = $p;
function $p_sci_Range$__description__I__I__I__Z__T($thiz, start, end, step, isInclusive) {
  return ((((start + (isInclusive ? " to " : " until ")) + end) + " by ") + step);
}
/** @constructor */
function $c_sci_Range$() {
}
$p = $c_sci_Range$.prototype = new $h_O();
$p.constructor = $c_sci_Range$;
/** @constructor */
function $h_sci_Range$() {
}
$h_sci_Range$.prototype = $p;
$p.ug = (function(start, end, step, isInclusive) {
  throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ($p_sci_Range$__description__I__I__I__Z__T(this, start, end, step, isInclusive) + ": seqs cannot contain more than Int.MaxValue elements."));
});
$p.a4D = (function(what) {
  return $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), (what + " on empty Range"));
});
var $d_sci_Range$ = new $TypeData().i($c_sci_Range$, "scala.collection.immutable.Range$", ({
  IQ: 1,
  a: 1
}));
var $n_sci_Range$;
function $m_sci_Range$() {
  if ((!$n_sci_Range$)) {
    $n_sci_Range$ = new $c_sci_Range$();
  }
  return $n_sci_Range$;
}
/** @constructor */
function $c_sci_SetNode() {
}
$p = $c_sci_SetNode.prototype = new $h_sci_Node();
$p.constructor = $c_sci_SetNode;
/** @constructor */
function $h_sci_SetNode() {
}
$h_sci_SetNode.prototype = $p;
function $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable($thiz, elems) {
  if ((elems === $thiz)) {
    $thiz.dG($m_scm_Buffer$().Al(elems));
  } else {
    var it = elems.o();
    while (it.p()) {
      $thiz.Y(it.q());
    }
  }
  return $thiz;
}
function $f_s_concurrent_BatchingExecutor__submitSyncBatched__jl_Runnable__V($thiz, runnable) {
  var tl = $thiz.aIP;
  var b = tl.d();
  if ((b instanceof $c_s_concurrent_BatchingExecutor$SyncBatch)) {
    b.b6Z(runnable);
  } else {
    var i = ((b !== null) ? b : 0);
    if ((i < 16)) {
      tl.XZ(((1 + i) | 0));
      try {
        runnable.Jk();
      } catch (e) {
        var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
        if (false) {
          $m_s_concurrent_ExecutionContext$().Od.i(e$2);
        } else if ($m_s_util_control_NonFatal$().ew(e$2)) {
          $m_s_concurrent_ExecutionContext$().Od.i(e$2);
        } else {
          throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
        }
      } finally {
        tl.XZ(b);
      }
    } else {
      var batch = new $c_s_concurrent_BatchingExecutor$SyncBatch($thiz, runnable);
      tl.XZ(batch);
      batch.Jk();
      tl.XZ(b);
    }
  }
}
function $is_s_concurrent_BatchingExecutor(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.dS)));
}
function $isArrayOf_s_concurrent_BatchingExecutor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dS)));
}
function $p_s_concurrent_duration_Duration$__words__T__sci_List($thiz, s) {
  return $m_sci_Nil$().b6($m_s_Predef$().fB($f_T__split__T__I__AT($f_T__trim__T(s), "\\s+", 0)));
}
function $p_s_concurrent_duration_Duration$__expandLabels__T__sci_List($thiz, labels) {
  var x1 = $p_s_concurrent_duration_Duration$__words__T__sci_List($thiz, labels);
  if ((!(x1 instanceof $c_sci_$colon$colon))) {
    throw new $c_s_MatchError(x1);
  }
  var hd = x1.er;
  var rest = x1.U;
  var rest$1 = rest;
  var h = null;
  var t = null;
  while ((rest$1 !== $m_sci_Nil$())) {
    var x0 = rest$1.t();
    var it = $m_sci_Nil$().b6($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [x0, (x0 + "s")])).o();
    while (it.p()) {
      var nx = new $c_sci_$colon$colon(it.q(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        t.U = nx;
      }
      t = nx;
    }
    rest$1 = rest$1.v();
  }
  return new $c_sci_$colon$colon(hd, ((h === null) ? $m_sci_Nil$() : h));
}
/** @constructor */
function $c_s_concurrent_duration_Duration$() {
  this.adf = null;
  this.aIW = null;
  this.a1T = null;
  this.add = null;
  this.ade = null;
  $n_s_concurrent_duration_Duration$ = this;
  this.adf = $m_sci_Nil$().b6($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [new $c_T2($m_ju_concurrent_TimeUnit$().R2, "d day"), new $c_T2($m_ju_concurrent_TimeUnit$().a7u, "h hr hour"), new $c_T2($m_ju_concurrent_TimeUnit$().a7x, "m min minute"), new $c_T2($m_ju_concurrent_TimeUnit$().a7y, "s sec second"), new $c_T2($m_ju_concurrent_TimeUnit$().a7w, "ms milli millisecond"), new $c_T2($m_ju_concurrent_TimeUnit$().a7v, "\u00b5s micro microsecond"), new $c_T2($m_ju_concurrent_TimeUnit$().Zx, "ns nano nanosecond")]));
  this.aIW = $m_sci_Map$().ao(new $c_sc_MapView$MapValues(new $c_sc_MapView$Id($m_sci_Map$().ao(this.adf)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((s$2$2) => $p_s_concurrent_duration_Duration$__words__T__sci_List($m_s_concurrent_duration_Duration$(), s$2$2).bJ()))));
  var $x_2 = $m_sci_Map$();
  var this$25 = this.adf;
  var rest = this$25;
  var h = null;
  var t = null;
  while ((rest !== $m_sci_Nil$())) {
    var x0$1 = rest.t();
    if ((x0$1 === null)) {
      throw new $c_s_MatchError(x0$1);
    }
    var unit = x0$1.g();
    var names = x0$1.h();
    var this$28 = $p_s_concurrent_duration_Duration$__expandLabels__T__sci_List($m_s_concurrent_duration_Duration$(), names);
    var f$1 = ((unit) => ((x$5$2$2) => new $c_T2(x$5$2$2, unit)))(unit);
    if ((this$28 === $m_sci_Nil$())) {
      var $x_1 = $m_sci_Nil$();
    } else {
      var x0$2 = this$28.t();
      var h$1 = new $c_sci_$colon$colon(f$1(x0$2), $m_sci_Nil$());
      var t$1 = h$1;
      var rest$1 = this$28.v();
      while ((rest$1 !== $m_sci_Nil$())) {
        var x0$3 = rest$1.t();
        var nx = new $c_sci_$colon$colon(f$1(x0$3), $m_sci_Nil$());
        t$1.U = nx;
        t$1 = nx;
        rest$1 = rest$1.v();
      }
      var $x_1 = h$1;
    }
    var it = $x_1.o();
    while (it.p()) {
      var nx$1 = new $c_sci_$colon$colon(it.q(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx$1;
      } else {
        t.U = nx$1;
      }
      t = nx$1;
    }
    rest = rest.v();
  }
  $x_2.ao(((h === null) ? $m_sci_Nil$() : h));
  new $c_s_concurrent_duration_FiniteDuration(0, 0, $m_ju_concurrent_TimeUnit$().R2);
  this.a1T = new $c_s_concurrent_duration_Duration$$anon$1();
  this.add = new $c_s_concurrent_duration_Duration$$anon$2();
  this.ade = new $c_s_concurrent_duration_Duration$$anon$3();
}
$p = $c_s_concurrent_duration_Duration$.prototype = new $h_O();
$p.constructor = $c_s_concurrent_duration_Duration$;
/** @constructor */
function $h_s_concurrent_duration_Duration$() {
}
$h_s_concurrent_duration_Duration$.prototype = $p;
var $d_s_concurrent_duration_Duration$ = new $TypeData().i($c_s_concurrent_duration_Duration$, "scala.concurrent.duration.Duration$", ({
  KE: 1,
  a: 1
}));
var $n_s_concurrent_duration_Duration$;
function $m_s_concurrent_duration_Duration$() {
  if ((!$n_s_concurrent_duration_Duration$)) {
    $n_s_concurrent_duration_Duration$ = new $c_s_concurrent_duration_Duration$();
  }
  return $n_s_concurrent_duration_Duration$;
}
/** @constructor */
function $c_s_concurrent_impl_Promise$ManyCallbacks(first, rest) {
  this.adg = null;
  this.adh = null;
  this.adg = first;
  this.adh = rest;
}
$p = $c_s_concurrent_impl_Promise$ManyCallbacks.prototype = new $h_O();
$p.constructor = $c_s_concurrent_impl_Promise$ManyCallbacks;
/** @constructor */
function $h_s_concurrent_impl_Promise$ManyCallbacks() {
}
$h_s_concurrent_impl_Promise$ManyCallbacks.prototype = $p;
$p.m = (function() {
  return "ManyCallbacks";
});
function $isArrayOf_s_concurrent_impl_Promise$ManyCallbacks(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.m2)));
}
var $d_s_concurrent_impl_Promise$ManyCallbacks = new $TypeData().i($c_s_concurrent_impl_Promise$ManyCallbacks, "scala.concurrent.impl.Promise$ManyCallbacks", ({
  m2: 1,
  cT: 1
}));
/** @constructor */
function $c_s_math_BigDecimal$() {
  this.qI = null;
  $n_s_math_BigDecimal$ = this;
  this.qI = $m_Ljava_math_MathContext$().ate;
}
$p = $c_s_math_BigDecimal$.prototype = new $h_O();
$p.constructor = $c_s_math_BigDecimal$;
/** @constructor */
function $h_s_math_BigDecimal$() {
}
$h_s_math_BigDecimal$.prototype = $p;
$p.y8 = (function(d, mc) {
  return new $c_s_math_BigDecimal($ct_Ljava_math_BigDecimal__T__Ljava_math_MathContext__(new $c_Ljava_math_BigDecimal(), ("" + d), mc), mc);
});
$p.b0S = (function(repr) {
  return new $c_s_math_BigDecimal(repr, ((repr.PJ() <= this.qI.yE) ? this.qI : new $c_Ljava_math_MathContext(repr.PJ(), $m_Ljava_math_RoundingMode$().B2)));
});
$p.b0R = (function(s) {
  return this.b0S($ct_Ljava_math_BigDecimal__T__(new $c_Ljava_math_BigDecimal(), s));
});
var $d_s_math_BigDecimal$ = new $TypeData().i($c_s_math_BigDecimal$, "scala.math.BigDecimal$", ({
  KK: 1,
  a: 1
}));
var $n_s_math_BigDecimal$;
function $m_s_math_BigDecimal$() {
  if ((!$n_s_math_BigDecimal$)) {
    $n_s_math_BigDecimal$ = new $c_s_math_BigDecimal$();
  }
  return $n_s_math_BigDecimal$;
}
function $p_s_math_BigInt$__getCached__I__s_math_BigInt($thiz, i) {
  var offset = ((i - $thiz.a1W) | 0);
  var n = $thiz.adj.a[offset];
  if ((n === null)) {
    var hi = (i >> 31);
    n = $ct_s_math_BigInt__Ljava_math_BigInteger__J__(new $c_s_math_BigInt(), null, i, hi);
    $thiz.adj.a[offset] = n;
  }
  return n;
}
/** @constructor */
function $c_s_math_BigInt$() {
  this.adl = null;
  this.a1W = 0;
  this.adk = 0;
  this.adj = null;
  this.aIY = null;
  $n_s_math_BigInt$ = this;
  this.adl = $m_Ljava_math_BigInteger$().oI(0, (-2147483648));
  $ct_s_math_BigInt__Ljava_math_BigInteger__J__(new $c_s_math_BigInt(), this.adl, 0, (-2147483648));
  this.a1W = (-1024);
  this.adk = 1024;
  this.adj = new ($d_s_math_BigInt.r().C)(((1 + ((this.adk - this.a1W) | 0)) | 0));
  this.aIY = $m_Ljava_math_BigInteger$().oI((-1), (-1));
}
$p = $c_s_math_BigInt$.prototype = new $h_O();
$p.constructor = $c_s_math_BigInt$;
/** @constructor */
function $h_s_math_BigInt$() {
}
$h_s_math_BigInt$.prototype = $p;
$p.aXl = (function(x) {
  return this.aXm($ct_Ljava_math_BigInteger__T__(new $c_Ljava_math_BigInteger(), x));
});
$p.aXm = (function(x) {
  if (($m_Ljava_math_BitLevel$().DM(x) <= 63)) {
    var $x_1 = x.lY();
    var l_$_lo = $x_1.l;
    var l_$_hi = $x_1.h;
    var value = this.a1W;
    var hi = (value >> 31);
    if (((hi === l_$_hi) ? ((value >>> 0) <= (l_$_lo >>> 0)) : (hi < l_$_hi))) {
      var value$1 = this.adk;
      var hi$1 = (value$1 >> 31);
      var $x_2 = ((l_$_hi === hi$1) ? ((l_$_lo >>> 0) <= (value$1 >>> 0)) : (l_$_hi < hi$1));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      return $p_s_math_BigInt$__getCached__I__s_math_BigInt(this, l_$_lo);
    } else {
      return $ct_s_math_BigInt__Ljava_math_BigInteger__J__(new $c_s_math_BigInt(), x, l_$_lo, l_$_hi);
    }
  } else {
    return $ct_s_math_BigInt__Ljava_math_BigInteger__J__(new $c_s_math_BigInt(), x, 0, (-2147483648));
  }
});
var $d_s_math_BigInt$ = new $TypeData().i($c_s_math_BigInt$, "scala.math.BigInt$", ({
  KM: 1,
  a: 1
}));
var $n_s_math_BigInt$;
function $m_s_math_BigInt$() {
  if ((!$n_s_math_BigInt$)) {
    $n_s_math_BigInt$ = new $c_s_math_BigInt$();
  }
  return $n_s_math_BigInt$;
}
/** @constructor */
function $c_s_reflect_ClassTag$() {
  this.aVj = null;
  this.aVs = null;
  this.aVk = null;
  this.aVn = null;
  this.aVo = null;
  this.aVm = null;
  this.aVl = null;
  this.aVi = null;
  this.aVt = null;
  this.aVg = null;
  this.aVr = null;
  this.aVh = null;
  this.aVp = null;
  this.aVq = null;
  $n_s_reflect_ClassTag$ = this;
  this.aVj = $m_s_reflect_ManifestFactory$ByteManifest$();
  this.aVs = $m_s_reflect_ManifestFactory$ShortManifest$();
  this.aVk = $m_s_reflect_ManifestFactory$CharManifest$();
  this.aVn = $m_s_reflect_ManifestFactory$IntManifest$();
  this.aVo = $m_s_reflect_ManifestFactory$LongManifest$();
  this.aVm = $m_s_reflect_ManifestFactory$FloatManifest$();
  this.aVl = $m_s_reflect_ManifestFactory$DoubleManifest$();
  this.aVi = $m_s_reflect_ManifestFactory$BooleanManifest$();
  this.aVt = $m_s_reflect_ManifestFactory$UnitManifest$();
  this.aVg = $m_s_reflect_ManifestFactory$AnyManifest$();
  this.aVr = $m_s_reflect_ManifestFactory$ObjectManifest$();
  this.aVh = $m_s_reflect_ManifestFactory$ObjectManifest$();
  this.aVp = $m_s_reflect_ManifestFactory$NothingManifest$();
  this.aVq = $m_s_reflect_ManifestFactory$NullManifest$();
}
$p = $c_s_reflect_ClassTag$.prototype = new $h_O();
$p.constructor = $c_s_reflect_ClassTag$;
/** @constructor */
function $h_s_reflect_ClassTag$() {
}
$h_s_reflect_ClassTag$.prototype = $p;
$p.y0 = (function(runtimeClass1) {
  return ((runtimeClass1 === $d_B.l()) ? $m_s_reflect_ManifestFactory$ByteManifest$() : ((runtimeClass1 === $d_S.l()) ? $m_s_reflect_ManifestFactory$ShortManifest$() : ((runtimeClass1 === $d_C.l()) ? $m_s_reflect_ManifestFactory$CharManifest$() : ((runtimeClass1 === $d_I.l()) ? $m_s_reflect_ManifestFactory$IntManifest$() : ((runtimeClass1 === $d_J.l()) ? $m_s_reflect_ManifestFactory$LongManifest$() : ((runtimeClass1 === $d_F.l()) ? $m_s_reflect_ManifestFactory$FloatManifest$() : ((runtimeClass1 === $d_D.l()) ? $m_s_reflect_ManifestFactory$DoubleManifest$() : ((runtimeClass1 === $d_Z.l()) ? $m_s_reflect_ManifestFactory$BooleanManifest$() : ((runtimeClass1 === $d_V.l()) ? $m_s_reflect_ManifestFactory$UnitManifest$() : ((runtimeClass1 === $d_O.l()) ? $m_s_reflect_ManifestFactory$ObjectManifest$() : ((runtimeClass1 === $d_sr_Nothing$.l()) ? $m_s_reflect_ManifestFactory$NothingManifest$() : ((runtimeClass1 === $d_sr_Null$.l()) ? $m_s_reflect_ManifestFactory$NullManifest$() : new $c_s_reflect_ClassTag$GenericClassTag(runtimeClass1)))))))))))));
});
var $d_s_reflect_ClassTag$ = new $TypeData().i($c_s_reflect_ClassTag$, "scala.reflect.ClassTag$", ({
  Le: 1,
  a: 1
}));
var $n_s_reflect_ClassTag$;
function $m_s_reflect_ClassTag$() {
  if ((!$n_s_reflect_ClassTag$)) {
    $n_s_reflect_ClassTag$ = new $c_s_reflect_ClassTag$();
  }
  return $n_s_reflect_ClassTag$;
}
/** @constructor */
function $c_sr_AbstractFunction0() {
}
$p = $c_sr_AbstractFunction0.prototype = new $h_O();
$p.constructor = $c_sr_AbstractFunction0;
/** @constructor */
function $h_sr_AbstractFunction0() {
}
$h_sr_AbstractFunction0.prototype = $p;
$p.m = (function() {
  return "<function0>";
});
/** @constructor */
function $c_sr_AbstractFunction1() {
}
$p = $c_sr_AbstractFunction1.prototype = new $h_O();
$p.constructor = $c_sr_AbstractFunction1;
/** @constructor */
function $h_sr_AbstractFunction1() {
}
$h_sr_AbstractFunction1.prototype = $p;
$p.iU = (function(v1) {
  return (!(!this.i(v1)));
});
$p.m = (function() {
  return "<function1>";
});
/** @constructor */
function $c_sr_AbstractFunction2() {
}
$p = $c_sr_AbstractFunction2.prototype = new $h_O();
$p.constructor = $c_sr_AbstractFunction2;
/** @constructor */
function $h_sr_AbstractFunction2() {
}
$h_sr_AbstractFunction2.prototype = $p;
$p.m = (function() {
  return "<function2>";
});
/** @constructor */
function $c_sr_AbstractFunction3() {
}
$p = $c_sr_AbstractFunction3.prototype = new $h_O();
$p.constructor = $c_sr_AbstractFunction3;
/** @constructor */
function $h_sr_AbstractFunction3() {
}
$h_sr_AbstractFunction3.prototype = $p;
$p.m = (function() {
  return "<function3>";
});
/** @constructor */
function $c_sr_AbstractFunction4() {
}
$p = $c_sr_AbstractFunction4.prototype = new $h_O();
$p.constructor = $c_sr_AbstractFunction4;
/** @constructor */
function $h_sr_AbstractFunction4() {
}
$h_sr_AbstractFunction4.prototype = $p;
$p.m = (function() {
  return "<function4>";
});
/** @constructor */
function $c_sr_AbstractFunction5() {
}
$p = $c_sr_AbstractFunction5.prototype = new $h_O();
$p.constructor = $c_sr_AbstractFunction5;
/** @constructor */
function $h_sr_AbstractFunction5() {
}
$h_sr_AbstractFunction5.prototype = $p;
$p.m = (function() {
  return "<function5>";
});
/** @constructor */
function $c_sr_AbstractFunction6() {
}
$p = $c_sr_AbstractFunction6.prototype = new $h_O();
$p.constructor = $c_sr_AbstractFunction6;
/** @constructor */
function $h_sr_AbstractFunction6() {
}
$h_sr_AbstractFunction6.prototype = $p;
$p.m = (function() {
  return "<function6>";
});
/** @constructor */
function $c_sr_AbstractFunction9() {
}
$p = $c_sr_AbstractFunction9.prototype = new $h_O();
$p.constructor = $c_sr_AbstractFunction9;
/** @constructor */
function $h_sr_AbstractFunction9() {
}
$h_sr_AbstractFunction9.prototype = $p;
$p.m = (function() {
  return "<function9>";
});
/** @constructor */
function $c_sr_BooleanRef(elem) {
  this.dy = false;
  this.dy = elem;
}
$p = $c_sr_BooleanRef.prototype = new $h_O();
$p.constructor = $c_sr_BooleanRef;
/** @constructor */
function $h_sr_BooleanRef() {
}
$h_sr_BooleanRef.prototype = $p;
$p.m = (function() {
  return ("" + this.dy);
});
var $d_sr_BooleanRef = new $TypeData().i($c_sr_BooleanRef, "scala.runtime.BooleanRef", ({
  LL: 1,
  a: 1
}));
/** @constructor */
function $c_sr_DoubleRef(elem) {
  this.T = 0.0;
  this.T = elem;
}
$p = $c_sr_DoubleRef.prototype = new $h_O();
$p.constructor = $c_sr_DoubleRef;
/** @constructor */
function $h_sr_DoubleRef() {
}
$h_sr_DoubleRef.prototype = $p;
$p.m = (function() {
  return ("" + this.T);
});
var $d_sr_DoubleRef = new $TypeData().i($c_sr_DoubleRef, "scala.runtime.DoubleRef", ({
  LN: 1,
  a: 1
}));
/** @constructor */
function $c_sr_IntRef(elem) {
  this.an = 0;
  this.an = elem;
}
$p = $c_sr_IntRef.prototype = new $h_O();
$p.constructor = $c_sr_IntRef;
/** @constructor */
function $h_sr_IntRef() {
}
$h_sr_IntRef.prototype = $p;
$p.m = (function() {
  return ("" + this.an);
});
var $d_sr_IntRef = new $TypeData().i($c_sr_IntRef, "scala.runtime.IntRef", ({
  LP: 1,
  a: 1
}));
/** @constructor */
function $c_sr_LazyRef() {
  this.ci = false;
  this.cj = null;
}
$p = $c_sr_LazyRef.prototype = new $h_O();
$p.constructor = $c_sr_LazyRef;
/** @constructor */
function $h_sr_LazyRef() {
}
$h_sr_LazyRef.prototype = $p;
$p.h3 = (function(value) {
  this.cj = value;
  this.ci = true;
  return value;
});
$p.m = (function() {
  return ("LazyRef " + (this.ci ? ("of: " + this.cj) : "thunk"));
});
var $d_sr_LazyRef = new $TypeData().i($c_sr_LazyRef, "scala.runtime.LazyRef", ({
  LR: 1,
  a: 1
}));
/** @constructor */
function $c_sr_LongRef(elem_$_lo, elem_$_hi) {
  this.ji = 0;
  this.jj = 0;
  this.ji = elem_$_lo;
  this.jj = elem_$_hi;
}
$p = $c_sr_LongRef.prototype = new $h_O();
$p.constructor = $c_sr_LongRef;
/** @constructor */
function $h_sr_LongRef() {
}
$h_sr_LongRef.prototype = $p;
$p.m = (function() {
  var l_$_lo = this.ji;
  var l_$_hi = this.jj;
  return $m_RTLong$().kY(l_$_lo, l_$_hi);
});
var $d_sr_LongRef = new $TypeData().i($c_sr_LongRef, "scala.runtime.LongRef", ({
  LS: 1,
  a: 1
}));
/** @constructor */
function $c_sr_ObjectRef(elem) {
  this.aD = null;
  this.aD = elem;
}
$p = $c_sr_ObjectRef.prototype = new $h_O();
$p.constructor = $c_sr_ObjectRef;
/** @constructor */
function $h_sr_ObjectRef() {
}
$h_sr_ObjectRef.prototype = $p;
$p.m = (function() {
  return ("" + this.aD);
});
var $d_sr_ObjectRef = new $TypeData().i($c_sr_ObjectRef, "scala.runtime.ObjectRef", ({
  LW: 1,
  a: 1
}));
var $d_sjs_js_timers_SetTimeoutHandle = new $TypeData().i(2, "scala.scalajs.js.timers.SetTimeoutHandle", ({
  Ms: 1,
  mm: 1
}), $noIsInstance);
/** @constructor */
function $c_s_util_Left$() {
}
$p = $c_s_util_Left$.prototype = new $h_O();
$p.constructor = $c_s_util_Left$;
/** @constructor */
function $h_s_util_Left$() {
}
$h_s_util_Left$.prototype = $p;
$p.m = (function() {
  return "Left";
});
var $d_s_util_Left$ = new $TypeData().i($c_s_util_Left$, "scala.util.Left$", ({
  MM: 1,
  a: 1
}));
var $n_s_util_Left$;
function $m_s_util_Left$() {
  if ((!$n_s_util_Left$)) {
    $n_s_util_Left$ = new $c_s_util_Left$();
  }
  return $n_s_util_Left$;
}
/** @constructor */
function $c_s_util_Right$() {
}
$p = $c_s_util_Right$.prototype = new $h_O();
$p.constructor = $c_s_util_Right$;
/** @constructor */
function $h_s_util_Right$() {
}
$h_s_util_Right$.prototype = $p;
$p.m = (function() {
  return "Right";
});
var $d_s_util_Right$ = new $TypeData().i($c_s_util_Right$, "scala.util.Right$", ({
  MN: 1,
  a: 1
}));
var $n_s_util_Right$;
function $m_s_util_Right$() {
  if ((!$n_s_util_Right$)) {
    $n_s_util_Right$ = new $c_s_util_Right$();
  }
  return $n_s_util_Right$;
}
/** @constructor */
function $c_s_util_Try$() {
}
$p = $c_s_util_Try$.prototype = new $h_O();
$p.constructor = $c_s_util_Try$;
/** @constructor */
function $h_s_util_Try$() {
}
$h_s_util_Try$.prototype = $p;
$p.aM9 = (function(r) {
  try {
    return new $c_s_util_Success(r.a3());
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if ($m_s_util_control_NonFatal$().ew(e$2)) {
      return new $c_s_util_Failure(e$2);
    }
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
  }
});
var $d_s_util_Try$ = new $TypeData().i($c_s_util_Try$, "scala.util.Try$", ({
  MP: 1,
  a: 1
}));
var $n_s_util_Try$;
function $m_s_util_Try$() {
  if ((!$n_s_util_Try$)) {
    $n_s_util_Try$ = new $c_s_util_Try$();
  }
  return $n_s_util_Try$;
}
/** @constructor */
function $c_s_util_control_NoStackTrace$() {
  this.aJk = false;
  this.aJk = false;
}
$p = $c_s_util_control_NoStackTrace$.prototype = new $h_O();
$p.constructor = $c_s_util_control_NoStackTrace$;
/** @constructor */
function $h_s_util_control_NoStackTrace$() {
}
$h_s_util_control_NoStackTrace$.prototype = $p;
var $d_s_util_control_NoStackTrace$ = new $TypeData().i($c_s_util_control_NoStackTrace$, "scala.util.control.NoStackTrace$", ({
  MR: 1,
  a: 1
}));
var $n_s_util_control_NoStackTrace$;
function $m_s_util_control_NoStackTrace$() {
  if ((!$n_s_util_control_NoStackTrace$)) {
    $n_s_util_control_NoStackTrace$ = new $c_s_util_control_NoStackTrace$();
  }
  return $n_s_util_control_NoStackTrace$;
}
/** @constructor */
function $c_s_util_hashing_MurmurHash3$() {
  this.ib = 0;
  this.xL = 0;
  this.Vy = 0;
  this.Vx = 0;
  $n_s_util_hashing_MurmurHash3$ = this;
  this.ib = $f_T__hashCode__I("Seq");
  this.xL = $f_T__hashCode__I("Map");
  this.Vy = $f_T__hashCode__I("Set");
  this.Vx = this.Em($m_sci_Nil$(), this.xL);
}
$p = $c_s_util_hashing_MurmurHash3$.prototype = new $h_s_util_hashing_MurmurHash3();
$p.constructor = $c_s_util_hashing_MurmurHash3$;
/** @constructor */
function $h_s_util_hashing_MurmurHash3$() {
}
$h_s_util_hashing_MurmurHash3$.prototype = $p;
$p.ri = (function(x, y) {
  return this.aT6($m_sr_Statics$().u(x), $m_sr_Statics$().u(y), (-889275714));
});
$p.a4G = (function(xs) {
  return ($is_sc_IndexedSeq(xs) ? this.b2L(xs, this.ib) : ((xs instanceof $c_sci_List) ? this.b48(xs, this.ib) : this.b5m(xs, this.ib)));
});
$p.aQ6 = (function(xs) {
  if (xs.c()) {
    return this.Vx;
  } else {
    var accum = new $c_s_util_hashing_MurmurHash3$accum$1();
    var h = this.xL;
    xs.pu(accum);
    h = this.k(h, accum.a1Y);
    h = this.k(h, accum.a1Z);
    h = this.r8(h, accum.a20);
    return this.Z(h, accum.a21);
  }
});
var $d_s_util_hashing_MurmurHash3$ = new $TypeData().i($c_s_util_hashing_MurmurHash3$, "scala.util.hashing.MurmurHash3$", ({
  MU: 1,
  MT: 1
}));
var $n_s_util_hashing_MurmurHash3$;
function $m_s_util_hashing_MurmurHash3$() {
  if ((!$n_s_util_hashing_MurmurHash3$)) {
    $n_s_util_hashing_MurmurHash3$ = new $c_s_util_hashing_MurmurHash3$();
  }
  return $n_s_util_hashing_MurmurHash3$;
}
/** @constructor */
function $c_s_util_hashing_MurmurHash3$accum$1() {
  this.a1Y = 0;
  this.a1Z = 0;
  this.a21 = 0;
  this.a20 = 0;
  this.a1Y = 0;
  this.a1Z = 0;
  this.a21 = 0;
  this.a20 = 1;
}
$p = $c_s_util_hashing_MurmurHash3$accum$1.prototype = new $h_O();
$p.constructor = $c_s_util_hashing_MurmurHash3$accum$1;
/** @constructor */
function $h_s_util_hashing_MurmurHash3$accum$1() {
}
$h_s_util_hashing_MurmurHash3$accum$1.prototype = $p;
$p.m = (function() {
  return "<function2>";
});
$p.a2J = (function(k, v) {
  var h = $m_s_util_hashing_MurmurHash3$().ri(k, v);
  this.a1Y = ((this.a1Y + h) | 0);
  this.a1Z = (this.a1Z ^ h);
  this.a20 = Math.imul(this.a20, (1 | h));
  this.a21 = ((1 + this.a21) | 0);
});
$p.R = (function(v1, v2) {
  this.a2J(v1, v2);
});
var $d_s_util_hashing_MurmurHash3$accum$1 = new $TypeData().i($c_s_util_hashing_MurmurHash3$accum$1, "scala.util.hashing.MurmurHash3$accum$1", ({
  MV: 1,
  bE: 1
}));
function $ct_s_util_matching_Regex__ju_regex_Pattern__sci_Seq__($thiz, pattern, groupNames) {
  $thiz.A8 = pattern;
  $thiz.a22 = groupNames;
  return $thiz;
}
function $ct_s_util_matching_Regex__T__sci_Seq__($thiz, regex, groupNames) {
  $ct_s_util_matching_Regex__ju_regex_Pattern__sci_Seq__($thiz, $m_ju_regex_PatternCompiler$().Wy(regex, 0), groupNames);
  return $thiz;
}
/** @constructor */
function $c_s_util_matching_Regex() {
  this.A8 = null;
  this.a22 = null;
}
$p = $c_s_util_matching_Regex.prototype = new $h_O();
$p.constructor = $c_s_util_matching_Regex;
/** @constructor */
function $h_s_util_matching_Regex() {
}
$h_s_util_matching_Regex.prototype = $p;
$p.jw = (function(s) {
  var m = new $c_ju_regex_Matcher(this.A8, $dp_toString__T(s));
  if (m.aQd()) {
    var n = m.us.R7;
    var b = new $c_scm_ListBuffer();
    var i = 0;
    while ((i < n)) {
      b.bb(m.aP1(((1 + i) | 0)));
      i = ((1 + i) | 0);
    }
    return new $c_s_Some(b.bM());
  } else {
    return $m_s_None$();
  }
});
$p.b1j = (function(source) {
  return new $c_s_util_matching_Regex$MatchIterator(source, this, this.a22);
});
$p.afQ = (function(source) {
  return new $c_s_util_matching_Regex$$anon$1(this, this.b1j(source));
});
$p.afR = (function(source) {
  var m = new $c_ju_regex_Matcher(this.A8, $dp_toString__T(source));
  return (m.IV() ? new $c_s_Some(new $c_s_util_matching_Regex$Match(source, m, this.a22)) : $m_s_None$());
});
$p.b1m = (function(source) {
  var m = new $c_ju_regex_Matcher(this.A8, $dp_toString__T(source));
  return (m.aQ0() ? new $c_s_Some(m.agl()) : $m_s_None$());
});
$p.Pk = (function(source) {
  var m = new $c_ju_regex_Matcher(this.A8, $dp_toString__T(source));
  return (m.aQ0() ? new $c_s_Some(new $c_s_util_matching_Regex$Match(source, m, this.a22)) : $m_s_None$());
});
$p.ahE = (function(target, replacement) {
  return new $c_ju_regex_Matcher(this.A8, $dp_toString__T(target)).aRG(replacement);
});
$p.m = (function() {
  return this.A8.a7B;
});
var $d_s_util_matching_Regex = new $TypeData().i($c_s_util_matching_Regex, "scala.util.matching.Regex", ({
  MW: 1,
  a: 1
}));
function $p_s_util_matching_Regex$Match__starts$lzycompute__AI($thiz) {
  if (((((1 & $thiz.Dg) << 24) >> 24) === 0)) {
    var n = ((1 + $thiz.Vz.us.R7) | 0);
    if ((n <= 0)) {
      var $x_1 = new $ac_I(0);
    } else {
      var array = new $ac_I(n);
      var i = 0;
      while ((i < n)) {
        var $x_2 = i;
        var x0 = i;
        array.a[$x_2] = $thiz.Vz.PX(x0);
        i = ((1 + i) | 0);
      }
      var $x_1 = array;
    }
    $thiz.ads = $x_1;
    $thiz.Dg = (((1 | $thiz.Dg) << 24) >> 24);
  }
  return $thiz.ads;
}
function $p_s_util_matching_Regex$Match__starts__AI($thiz) {
  return (((((1 & $thiz.Dg) << 24) >> 24) === 0) ? $p_s_util_matching_Regex$Match__starts$lzycompute__AI($thiz) : $thiz.ads);
}
function $p_s_util_matching_Regex$Match__ends$lzycompute__AI($thiz) {
  if (((((2 & $thiz.Dg) << 24) >> 24) === 0)) {
    var n = ((1 + $thiz.Vz.us.R7) | 0);
    if ((n <= 0)) {
      var $x_1 = new $ac_I(0);
    } else {
      var array = new $ac_I(n);
      var i = 0;
      while ((i < n)) {
        var $x_2 = i;
        var x0 = i;
        array.a[$x_2] = $thiz.Vz.WG(x0);
        i = ((1 + i) | 0);
      }
      var $x_1 = array;
    }
    $thiz.adr = $x_1;
    $thiz.Dg = (((2 | $thiz.Dg) << 24) >> 24);
  }
  return $thiz.adr;
}
function $p_s_util_matching_Regex$Match__ends__AI($thiz) {
  return (((((2 & $thiz.Dg) << 24) >> 24) === 0) ? $p_s_util_matching_Regex$Match__ends$lzycompute__AI($thiz) : $thiz.adr);
}
/** @constructor */
function $c_s_util_matching_Regex$Match(source, matcher, _groupNames) {
  this.ads = null;
  this.adr = null;
  this.aJl = null;
  this.Vz = null;
  this.VA = 0;
  this.HL = 0;
  this.Dg = 0;
  this.aJl = source;
  this.Vz = matcher;
  this.VA = matcher.AF();
  this.HL = matcher.Ak();
}
$p = $c_s_util_matching_Regex$Match.prototype = new $h_O();
$p.constructor = $c_s_util_matching_Regex$Match;
/** @constructor */
function $h_s_util_matching_Regex$Match() {
}
$h_s_util_matching_Regex$Match.prototype = $p;
$p.m = (function() {
  return $f_s_util_matching_Regex$MatchData__matched__T(this);
});
$p.ai7 = (function() {
  return this.aJl;
});
$p.AF = (function() {
  return this.VA;
});
$p.Ak = (function() {
  return this.HL;
});
$p.PX = (function(i) {
  return $p_s_util_matching_Regex$Match__starts__AI(this).a[i];
});
$p.WG = (function(i) {
  return $p_s_util_matching_Regex$Match__ends__AI(this).a[i];
});
$p.b1A = (function() {
  $p_s_util_matching_Regex$Match__starts__AI(this);
  $p_s_util_matching_Regex$Match__ends__AI(this);
  return this;
});
var $d_s_util_matching_Regex$Match = new $TypeData().i($c_s_util_matching_Regex$Match, "scala.util.matching.Regex$Match", ({
  MY: 1,
  mv: 1
}));
function $ct_s_util_parsing_combinator_Parsers$NoSuccess__s_util_parsing_combinator_Parsers__T__s_util_parsing_input_Reader__($thiz, outer, msg, next) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $thiz.a24 = outer;
  $ct_s_util_parsing_combinator_Parsers$ParseResult__s_util_parsing_combinator_Parsers__($thiz, outer);
  return $thiz;
}
/** @constructor */
function $c_s_util_parsing_combinator_Parsers$NoSuccess() {
  this.a24 = null;
}
$p = $c_s_util_parsing_combinator_Parsers$NoSuccess.prototype = new $h_s_util_parsing_combinator_Parsers$ParseResult();
$p.constructor = $c_s_util_parsing_combinator_Parsers$NoSuccess;
/** @constructor */
function $h_s_util_parsing_combinator_Parsers$NoSuccess() {
}
$h_s_util_parsing_combinator_Parsers$NoSuccess.prototype = $p;
$p.agY = (function(f) {
  return this;
});
$p.aOe = (function(f) {
  return this;
});
function $isArrayOf_s_util_parsing_combinator_Parsers$NoSuccess(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.my)));
}
function $ct_s_util_parsing_combinator_Parsers$Parser__s_util_parsing_combinator_Parsers__($thiz, outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $thiz.vM = outer;
  $thiz.Di = "";
  return $thiz;
}
/** @constructor */
function $c_s_util_parsing_combinator_Parsers$Parser() {
  this.Di = null;
  this.vM = null;
}
$p = $c_s_util_parsing_combinator_Parsers$Parser.prototype = new $h_O();
$p.constructor = $c_s_util_parsing_combinator_Parsers$Parser;
/** @constructor */
function $h_s_util_parsing_combinator_Parsers$Parser() {
}
$h_s_util_parsing_combinator_Parsers$Parser.prototype = $p;
$p.PF = (function(n) {
  this.Di = n;
  return this;
});
$p.m = (function() {
  return (("Parser (" + this.Di) + ")");
});
$p.tY = (function(f) {
  return new $c_s_util_parsing_combinator_Parsers$$anon$1(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((in$1) => this.lh(in$1).aOe(f))), this.vM);
});
$p.a49 = (function(f) {
  return new $c_s_util_parsing_combinator_Parsers$$anon$1(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((in$1) => this.lh(in$1).agY(f))), this.vM);
});
$p.aX0 = (function(p0) {
  return new $c_s_util_parsing_combinator_Parsers$$anon$1(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((p$lzy1$2) => ((in$1) => this.lh(in$1).aLZ(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d(((in$2) => (() => $ps_s_util_parsing_combinator_Parsers__p$27__sr_LazyRef__F0__s_util_parsing_combinator_Parsers$Parser(p$lzy1$2, p0).lh(in$2)))(in$1)))))(new $c_sr_LazyRef())), this.vM);
});
$p.xW = (function(q) {
  return this.tY(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((p$lzy2$2) => ((a) => $s_s_util_parsing_combinator_Parsers__scala$util$parsing$combinator$Parsers$Parser$$_$p$28__sr_LazyRef__F0__s_util_parsing_combinator_Parsers$Parser(p$lzy2$2, q).a49(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((b) => new $c_s_util_parsing_combinator_Parsers$$tilde(this.vM, a, b))))))(new $c_sr_LazyRef()))).PF("~");
});
$p.aLn = (function(q) {
  return this.tY(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((p$lzy3$2) => ((x$1) => $ps_s_util_parsing_combinator_Parsers__p$29__sr_LazyRef__F0__s_util_parsing_combinator_Parsers$Parser(p$lzy3$2, q).a49(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((b) => b)))))(new $c_sr_LazyRef()))).PF("~>");
});
$p.aVv = (function(q) {
  return this.tY(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((p$lzy4$2) => ((a) => $ps_s_util_parsing_combinator_Parsers__p$30__sr_LazyRef__F0__s_util_parsing_combinator_Parsers$Parser(p$lzy4$2, q).a49(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => a)))))(new $c_sr_LazyRef()))).PF("<~");
});
$p.jQ = (function(q) {
  return this.aX0(q).PF("|");
});
$p.qO = (function(f) {
  return this.a49(f).PF((this.m() + "^^"));
});
$p.aeo = (function(v) {
  return new $c_s_util_parsing_combinator_Parsers$$anon$5(v, this).PF((this.m() + "^^^"));
});
$p.iU = (function(v1) {
  return (!(!this.lh(null)));
});
function $f_s_util_parsing_combinator_RegexParsers__$init$__V($thiz) {
  $thiz.aEH = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "\\s+", $m_sci_Nil$());
}
function $f_s_util_parsing_combinator_RegexParsers__handleWhiteSpace__jl_CharSequence__I__I($thiz, source, offset) {
  var x1 = $thiz.aEH.Pk($ct_s_util_parsing_combinator_SubSequence__jl_CharSequence__I__(new $c_s_util_parsing_combinator_SubSequence(), source, offset));
  if ((x1 instanceof $c_s_Some)) {
    return ((offset + x1.J.HL) | 0);
  }
  if (($m_s_None$() === x1)) {
    return offset;
  }
  throw new $c_s_MatchError(x1);
}
function $f_s_util_parsing_combinator_RegexParsers__phrase__s_util_parsing_combinator_Parsers$Parser__s_util_parsing_combinator_Parsers$Parser($thiz, p) {
  return new $c_s_util_parsing_combinator_Parsers$$anon$6(p.aVv(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => new $c_s_util_parsing_combinator_RegexParsers$$anon$2($ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "", $m_sci_Nil$()), $thiz)))), $thiz);
}
function $f_s_util_parsing_combinator_RegexParsers__parse__s_util_parsing_combinator_Parsers$Parser__jl_CharSequence__s_util_parsing_combinator_Parsers$ParseResult($thiz, p, in$1) {
  return p.lh($ct_s_util_parsing_input_CharSequenceReader__jl_CharSequence__(new $c_s_util_parsing_input_CharSequenceReader(), in$1));
}
function $f_s_util_parsing_combinator_RegexParsers__parseAll__s_util_parsing_combinator_Parsers$Parser__jl_CharSequence__s_util_parsing_combinator_Parsers$ParseResult($thiz, p, in$1) {
  return $f_s_util_parsing_combinator_RegexParsers__parse__s_util_parsing_combinator_Parsers$Parser__jl_CharSequence__s_util_parsing_combinator_Parsers$ParseResult($thiz, $f_s_util_parsing_combinator_RegexParsers__phrase__s_util_parsing_combinator_Parsers$Parser__s_util_parsing_combinator_Parsers$Parser($thiz, p), in$1);
}
function $ct_s_util_parsing_combinator_SubSequence__jl_CharSequence__I__I__($thiz, s, start, length) {
  $thiz.a27 = s;
  $thiz.VD = start;
  $thiz.HM = length;
  return $thiz;
}
function $ct_s_util_parsing_combinator_SubSequence__jl_CharSequence__I__($thiz, s, start) {
  $ct_s_util_parsing_combinator_SubSequence__jl_CharSequence__I__I__($thiz, s, start, (($dp_length__I(s) - start) | 0));
  return $thiz;
}
/** @constructor */
function $c_s_util_parsing_combinator_SubSequence() {
  this.a27 = null;
  this.VD = 0;
  this.HM = 0;
}
$p = $c_s_util_parsing_combinator_SubSequence.prototype = new $h_O();
$p.constructor = $c_s_util_parsing_combinator_SubSequence;
/** @constructor */
function $h_s_util_parsing_combinator_SubSequence() {
}
$h_s_util_parsing_combinator_SubSequence.prototype = $p;
$p.C = (function() {
  return this.HM;
});
$p.y1 = (function(i) {
  if (((i >= 0) && (i < this.HM))) {
    return $dp_charAt__I__C(this.a27, ((this.VD + i) | 0));
  } else {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ((("index: " + i) + ", length: ") + this.HM));
  }
});
$p.Jp = (function(_start, _end) {
  if (((((_start < 0) || (_end < 0)) || (_end > this.HM)) || (_start > _end))) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ((((("start: " + _start) + ", end: ") + _end) + ", length: ") + this.HM));
  }
  return $ct_s_util_parsing_combinator_SubSequence__jl_CharSequence__I__I__(new $c_s_util_parsing_combinator_SubSequence(), this.a27, ((this.VD + _start) | 0), ((_end - _start) | 0));
});
$p.m = (function() {
  return $dp_toString__T($dp_subSequence__I__I__jl_CharSequence(this.a27, this.VD, ((this.VD + this.HM) | 0)));
});
var $d_s_util_parsing_combinator_SubSequence = new $TypeData().i($c_s_util_parsing_combinator_SubSequence, "scala.util.parsing.combinator.SubSequence", ({
  Nd: 1,
  aX: 1
}));
function $ct_s_util_parsing_input_CharSequenceReader__jl_CharSequence__I__($thiz, source, offset) {
  $thiz.pi = source;
  $thiz.ph = offset;
  return $thiz;
}
function $ct_s_util_parsing_input_CharSequenceReader__jl_CharSequence__($thiz, source) {
  $ct_s_util_parsing_input_CharSequenceReader__jl_CharSequence__I__($thiz, source, 0);
  return $thiz;
}
/** @constructor */
function $c_s_util_parsing_input_CharSequenceReader() {
  this.pi = null;
  this.ph = 0;
}
$p = $c_s_util_parsing_input_CharSequenceReader.prototype = new $h_s_util_parsing_input_Reader();
$p.constructor = $c_s_util_parsing_input_CharSequenceReader;
/** @constructor */
function $h_s_util_parsing_input_CharSequenceReader() {
}
$h_s_util_parsing_input_CharSequenceReader.prototype = $p;
$p.b1o = (function() {
  return ((this.ph < $dp_length__I(this.pi)) ? $dp_charAt__I__C(this.pi, this.ph) : 26);
});
$p.aMt = (function() {
  return (this.ph >= $dp_length__I(this.pi));
});
$p.a39 = (function(n) {
  return $ct_s_util_parsing_input_CharSequenceReader__jl_CharSequence__I__(new $c_s_util_parsing_input_CharSequenceReader(), this.pi, ((this.ph + n) | 0));
});
$p.m = (function() {
  return (("CharSequenceReader(" + (this.aMt() ? "" : (("'" + $cToS(this.b1o())) + "', ..."))) + ")");
});
var $d_s_util_parsing_input_CharSequenceReader = new $TypeData().i($c_s_util_parsing_input_CharSequenceReader, "scala.util.parsing.input.CharSequenceReader", ({
  Ne: 1,
  Ni: 1
}));
function $ct_Lujson_CharParser__($thiz) {
  $f_Lupickle_core_BufferingCharParser__$init$__V($thiz);
  $thiz.Dk = $m_Lupickle_core_CharOps$();
  $thiz.mF = new $c_Lupickle_core_CharBuilder(32);
  return $thiz;
}
/** @constructor */
function $c_Lujson_CharParser() {
  this.Dl = null;
  this.HO = 0;
  this.xO = 0;
  this.HP = 0;
  this.Dk = null;
  this.mF = null;
}
$p = $c_Lujson_CharParser.prototype = new $h_O();
$p.constructor = $c_Lujson_CharParser;
/** @constructor */
function $h_Lujson_CharParser() {
}
$h_Lujson_CharParser.prototype = $p;
$p.P4 = (function(j) {
  var newSafeIndex = $f_Lupickle_core_BufferingCharParser__requestUntilGetSafeIndex__I__I(this, j);
  if ((newSafeIndex === j)) {
    throw new $c_Lujson_IncompleteParseException("exhausted input");
  }
  return newSafeIndex;
});
$p.hn = (function(i) {
  this.P4(i);
  return $f_Lupickle_core_BufferingCharParser__getCharUnsafe__I__C(this, i);
});
$p.b6s = (function(facade) {
  matchResult1: {
    var \u03b41$___1;
    var \u03b41$___2;
    var x1 = this.b6C(0, facade);
    if ((x1 !== null)) {
      var \u03b41$___1 = x1.g();
      var \u03b41$___2 = (x1.h() | 0);
      break matchResult1;
    }
    throw new $c_s_MatchError(x1);
  }
  var value$2 = \u03b41$___1;
  var i$2 = (\u03b41$___2 | 0);
  var j = i$2;
  while ((!$f_Lupickle_core_BufferingCharParser__requestUntil__I__Z(this, j))) {
    switch (this.hn(j)) {
      case 10:
      case 32:
      case 9:
      case 13: {
        j = ((1 + j) | 0);
        break;
      }
      default: {
        this.ny(j, "expected whitespace or eof");
      }
    }
  }
  if ((!$f_Lupickle_core_BufferingCharParser__requestUntil__I__Z(this, j))) {
    this.ny(j, "expected eof");
  }
  return value$2;
});
$p.ny = (function(i, msg) {
  var out = new $c_Lupickle_core_CharBuilder(32);
  var $x_2 = $m_Lupickle_core_RenderUtils$();
  var $x_1 = new $c_Lupickle_core_CharBuilder(32);
  var array = new $ac_C(new Uint16Array([(65535 & this.hn(i))]));
  var length = array.a.length;
  var capacity = array.a.length;
  var length$1 = array.a.length;
  if ((((capacity | capacity) | ((length$1 - capacity) | 0)) < 0)) {
    $m_jl_BoundsChecks$().r5(0, capacity, length$1);
  }
  if ((((length | length) | ((capacity - length) | 0)) < 0)) {
    $m_jl_BoundsChecks$().r5(0, length, capacity);
  }
  $x_2.aNR($x_1, out, new $c_Ljava_nio_HeapCharBuffer(capacity, array, 0, 0, length, false), false, true);
  throw new $c_Lujson_ParseException($m_sc_StringOps$().u0("%s got %s", $m_sr_ScalaRunTime$().hP(new $ac_O([msg, $m_jl_String$().kS(out.gx, 0, out.cD)]))), i);
});
$p.b6w = (function(i, ctxt, facade) {
  var j = i;
  var c = this.hn(j);
  var decIndex = (-1);
  var expIndex = (-1);
  if ((c === 45)) {
    j = ((1 + j) | 0);
    c = this.hn(j);
  }
  if ((c === 48)) {
    j = ((1 + j) | 0);
    c = this.hn(j);
  } else {
    var j0 = j;
    while (this.Dk.Qc(48, c, 57)) {
      j = ((1 + j) | 0);
      c = this.hn(j);
    }
    if ((j === j0)) {
      this.ny(i, "expected digit");
    }
  }
  if ((c === 46)) {
    decIndex = ((j - i) | 0);
    j = ((1 + j) | 0);
    c = this.hn(j);
    var j0$2 = j;
    while (this.Dk.Qc(48, c, 57)) {
      j = ((1 + j) | 0);
      c = this.hn(j);
    }
    if ((j0$2 === j)) {
      this.ny(i, "expected digit");
    }
  }
  if (((c === 69) || (c === 101))) {
    expIndex = ((j - i) | 0);
    j = ((1 + j) | 0);
    c = this.hn(j);
    if (((c === 43) || (c === 45))) {
      j = ((1 + j) | 0);
      c = this.hn(j);
    }
    var j0$3 = j;
    while (this.Dk.Qc(48, c, 57)) {
      j = ((1 + j) | 0);
      c = this.hn(j);
    }
    if ((j0$3 === j)) {
      this.ny(i, "expected digit");
    }
  }
  ctxt.cU(this.Qa(facade, decIndex, expIndex, i, j), i);
  return j;
});
$p.Qa = (function(facade, decIndex, expIndex, i, j) {
  return facade.ge(this.Dl, ((i - this.HO) | 0), ((j - i) | 0), decIndex, expIndex, i);
});
$p.b6x = (function(i, facade) {
  var j = i;
  var c = this.hn(j);
  var decIndex = (-1);
  var expIndex = (-1);
  if ((c === 45)) {
    j = ((1 + j) | 0);
    c = this.hn(j);
  }
  if ((c === 48)) {
    j = ((1 + j) | 0);
    if ($f_Lupickle_core_BufferingCharParser__requestUntil__I__Z(this, j)) {
      return new $c_T2(this.Qa(facade, decIndex, expIndex, i, j), j);
    }
    c = this.hn(j);
  } else {
    var j0 = j;
    while (this.Dk.Qc(48, c, 57)) {
      j = ((1 + j) | 0);
      if ($f_Lupickle_core_BufferingCharParser__requestUntil__I__Z(this, j)) {
        return new $c_T2(this.Qa(facade, decIndex, expIndex, i, j), j);
      }
      c = this.hn(j);
    }
    if ((j0 === j)) {
      this.ny(i, "expected digit");
    }
  }
  if ((c === 46)) {
    decIndex = ((j - i) | 0);
    j = ((1 + j) | 0);
    c = this.hn(j);
    var j0$2 = j;
    while (this.Dk.Qc(48, c, 57)) {
      j = ((1 + j) | 0);
      if ($f_Lupickle_core_BufferingCharParser__requestUntil__I__Z(this, j)) {
        return new $c_T2(this.Qa(facade, decIndex, expIndex, i, j), j);
      }
      c = this.hn(j);
    }
    if ((j0$2 === j)) {
      this.ny(i, "expected digit");
    }
  }
  if (((c === 69) || (c === 101))) {
    expIndex = ((j - i) | 0);
    j = ((1 + j) | 0);
    c = this.hn(j);
    if (((c === 43) || (c === 45))) {
      j = ((1 + j) | 0);
      c = this.hn(j);
    }
    var j0$3 = j;
    while (this.Dk.Qc(48, c, 57)) {
      j = ((1 + j) | 0);
      if ($f_Lupickle_core_BufferingCharParser__requestUntil__I__Z(this, j)) {
        return new $c_T2(this.Qa(facade, decIndex, expIndex, i, j), j);
      }
      c = this.hn(j);
    }
    if ((j0$3 === j)) {
      this.ny(i, "expected digit");
    }
  }
  return new $c_T2(this.Qa(facade, decIndex, expIndex, i, j), j);
});
$p.aZQ = (function(i) {
  var x = 0;
  x = ((x << 4) | $m_Lupickle_core_RenderUtils$().a3K(this.hn(((2 + i) | 0))));
  x = ((x << 4) | $m_Lupickle_core_RenderUtils$().a3K(this.hn(((3 + i) | 0))));
  x = ((x << 4) | $m_Lupickle_core_RenderUtils$().a3K(this.hn(((4 + i) | 0))));
  x = ((x << 4) | $m_Lupickle_core_RenderUtils$().a3K(this.hn(((5 + i) | 0))));
  return (65535 & x);
});
$p.aR0 = (function(i, facade) {
  this.P4(((3 + i) | 0));
  return (((($f_Lupickle_core_BufferingCharParser__getCharUnsafe__I__C(this, ((1 + i) | 0)) === 114) && ($f_Lupickle_core_BufferingCharParser__getCharUnsafe__I__C(this, ((2 + i) | 0)) === 117)) && ($f_Lupickle_core_BufferingCharParser__getCharUnsafe__I__C(this, ((3 + i) | 0)) === 101)) ? facade.eE(i) : this.ny(i, "expected true"));
});
$p.aQV = (function(i, facade) {
  this.P4(((4 + i) | 0));
  return ((((($f_Lupickle_core_BufferingCharParser__getCharUnsafe__I__C(this, ((1 + i) | 0)) === 97) && ($f_Lupickle_core_BufferingCharParser__getCharUnsafe__I__C(this, ((2 + i) | 0)) === 108)) && ($f_Lupickle_core_BufferingCharParser__getCharUnsafe__I__C(this, ((3 + i) | 0)) === 115)) && ($f_Lupickle_core_BufferingCharParser__getCharUnsafe__I__C(this, ((4 + i) | 0)) === 101)) ? facade.eC(i) : this.ny(i, "expected false"));
});
$p.aQZ = (function(i, facade) {
  this.P4(((3 + i) | 0));
  return (((($f_Lupickle_core_BufferingCharParser__getCharUnsafe__I__C(this, ((1 + i) | 0)) === 117) && ($f_Lupickle_core_BufferingCharParser__getCharUnsafe__I__C(this, ((2 + i) | 0)) === 108)) && ($f_Lupickle_core_BufferingCharParser__getCharUnsafe__I__C(this, ((3 + i) | 0)) === 108)) ? facade.c8(i) : this.ny(i, "expected null"));
});
$p.b6C = (function(i, facade) {
  try {
    return this.b6D(i, facade);
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    var \u03b42$ = new $c_Lujson_CharParser$$anon$1(i);
    if (\u03b42$.e5(e$2)) {
      return \u03b42$.e2(e$2, $m_s_PartialFunction$().gt);
    } else {
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
    }
  }
});
$p.b6D = (function(i, facade) {
  var i$tailLocal1 = i;
  while (true) {
    switch (this.hn(i$tailLocal1)) {
      case 32:
      case 9:
      case 114: {
        i$tailLocal1 = ((1 + i$tailLocal1) | 0);
        break;
      }
      case 10: {
        i$tailLocal1 = ((1 + i$tailLocal1) | 0);
        break;
      }
      case 91: {
        return this.aQY(6, ((1 + i$tailLocal1) | 0), facade.cZ((-1), i$tailLocal1), $m_sci_Nil$());
        break;
      }
      case 123: {
        return this.aQY(7, ((1 + i$tailLocal1) | 0), facade.bQ((-1), true, i$tailLocal1), $m_sci_Nil$());
        break;
      }
      case 45:
      case 48:
      case 49:
      case 50:
      case 51:
      case 52:
      case 53:
      case 54:
      case 55:
      case 56:
      case 57: {
        return this.b6x(i$tailLocal1, facade);
        break;
      }
      case 34: {
        return this.b6A(i$tailLocal1, facade);
        break;
      }
      case 116: {
        return new $c_T2(this.aR0(i$tailLocal1, facade), ((4 + i$tailLocal1) | 0));
        break;
      }
      case 102: {
        return new $c_T2(this.aQV(i$tailLocal1, facade), ((5 + i$tailLocal1) | 0));
        break;
      }
      case 110: {
        return new $c_T2(this.aQZ(i$tailLocal1, facade), ((4 + i$tailLocal1) | 0));
        break;
      }
      default: {
        this.ny(i$tailLocal1, "expected json value");
      }
    }
  }
});
$p.aQY = (function(state, i, stackHead, stackTail) {
  var stackTail$tailLocal1 = stackTail;
  var stackHead$tailLocal1 = stackHead;
  var state$tailLocal1 = state;
  var i$tailLocal2 = i;
  while (true) {
    switch (this.hn(i$tailLocal2)) {
      case 32:
      case 9:
      case 13:
      case 10: {
        i$tailLocal2 = ((1 + i$tailLocal2) | 0);
        break;
      }
      case 34: {
        switch (state$tailLocal1) {
          case 2:
          case 7: {
            try {
              var nextJ = this.b6z(i$tailLocal2, stackHead$tailLocal1);
            } catch (e) {
              var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
              var \u03b43$ = new $c_Lujson_CharParser$$anon$1(i$tailLocal2);
              if (\u03b43$.e5(e$2)) {
                var nextJ = (\u03b43$.e2(e$2, $m_s_PartialFunction$().gt) | 0);
              } else {
                var nextJ;
                throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
              }
            }
            state$tailLocal1 = 3;
            i$tailLocal2 = nextJ;
            break;
          }
          case 1:
          case 6: {
            try {
              var nextJ$2 = this.b6B(i$tailLocal2, stackHead$tailLocal1);
            } catch (e$3) {
              var e$4 = ((e$3 instanceof $c_jl_Throwable) ? e$3 : new $c_sjs_js_JavaScriptException(e$3));
              var \u03b44$ = new $c_Lujson_CharParser$$anon$1(i$tailLocal2);
              if (\u03b44$.e5(e$4)) {
                var nextJ$2 = (\u03b44$.e2(e$4, $m_s_PartialFunction$().gt) | 0);
              } else {
                var nextJ$2;
                throw ((e$4 instanceof $c_sjs_js_JavaScriptException) ? e$4.bf : e$4);
              }
            }
            var state$tailLocal1$tmp2 = this.II(stackHead$tailLocal1);
            state$tailLocal1 = state$tailLocal1$tmp2;
            i$tailLocal2 = nextJ$2;
            break;
          }
          default: {
            this.IO(i$tailLocal2, state$tailLocal1);
          }
        }
        break;
      }
      case 58: {
        if ((state$tailLocal1 === 3)) {
          var i$tailLocal2$tmp3 = ((1 + i$tailLocal2) | 0);
          state$tailLocal1 = 1;
          i$tailLocal2 = i$tailLocal2$tmp3;
          break;
        }
        this.IO(i$tailLocal2, state$tailLocal1);
        break;
      }
      case 91: {
        this.Pj(state$tailLocal1, i$tailLocal2);
        try {
          var ctx = stackHead$tailLocal1.d9().cZ((-1), i$tailLocal2);
        } catch (e$5) {
          var e$6 = ((e$5 instanceof $c_jl_Throwable) ? e$5 : new $c_sjs_js_JavaScriptException(e$5));
          var \u03b45$ = new $c_Lujson_CharParser$$anon$1(i$tailLocal2);
          if (\u03b45$.e5(e$6)) {
            var ctx = \u03b45$.e2(e$6, $m_s_PartialFunction$().gt);
          } else {
            var ctx;
            throw ((e$6 instanceof $c_sjs_js_JavaScriptException) ? e$6.bf : e$6);
          }
        }
        var i$tailLocal2$tmp4 = ((1 + i$tailLocal2) | 0);
        var stackTail$tailLocal1$tmp1 = new $c_sci_$colon$colon(stackHead$tailLocal1, stackTail$tailLocal1);
        state$tailLocal1 = 6;
        i$tailLocal2 = i$tailLocal2$tmp4;
        stackHead$tailLocal1 = ctx;
        stackTail$tailLocal1 = stackTail$tailLocal1$tmp1;
        break;
      }
      case 123: {
        this.Pj(state$tailLocal1, i$tailLocal2);
        try {
          var ctx$2 = stackHead$tailLocal1.d9().bQ((-1), true, i$tailLocal2);
        } catch (e$7) {
          var e$8 = ((e$7 instanceof $c_jl_Throwable) ? e$7 : new $c_sjs_js_JavaScriptException(e$7));
          var \u03b46$ = new $c_Lujson_CharParser$$anon$1(i$tailLocal2);
          if (\u03b46$.e5(e$8)) {
            var ctx$2 = \u03b46$.e2(e$8, $m_s_PartialFunction$().gt);
          } else {
            var ctx$2;
            throw ((e$8 instanceof $c_sjs_js_JavaScriptException) ? e$8.bf : e$8);
          }
        }
        var i$tailLocal2$tmp5 = ((1 + i$tailLocal2) | 0);
        var stackTail$tailLocal1$tmp2 = new $c_sci_$colon$colon(stackHead$tailLocal1, stackTail$tailLocal1);
        state$tailLocal1 = 7;
        i$tailLocal2 = i$tailLocal2$tmp5;
        stackHead$tailLocal1 = ctx$2;
        stackTail$tailLocal1 = stackTail$tailLocal1$tmp2;
        break;
      }
      case 45:
      case 48:
      case 49:
      case 50:
      case 51:
      case 52:
      case 53:
      case 54:
      case 55:
      case 56:
      case 57: {
        this.Pj(state$tailLocal1, i$tailLocal2);
        try {
          var ctx$3 = this.b6w(i$tailLocal2, stackHead$tailLocal1.h6(), stackHead$tailLocal1.d9());
        } catch (e$9) {
          var e$10 = ((e$9 instanceof $c_jl_Throwable) ? e$9 : new $c_sjs_js_JavaScriptException(e$9));
          var \u03b47$ = new $c_Lujson_CharParser$$anon$1(i$tailLocal2);
          if (\u03b47$.e5(e$10)) {
            var ctx$3 = (\u03b47$.e2(e$10, $m_s_PartialFunction$().gt) | 0);
          } else {
            var ctx$3;
            throw ((e$10 instanceof $c_sjs_js_JavaScriptException) ? e$10.bf : e$10);
          }
        }
        var state$tailLocal1$tmp6 = this.II(stackHead$tailLocal1);
        state$tailLocal1 = state$tailLocal1$tmp6;
        i$tailLocal2 = ctx$3;
        break;
      }
      case 116: {
        this.Pj(state$tailLocal1, i$tailLocal2);
        try {
          stackHead$tailLocal1.h6().cU(this.aR0(i$tailLocal2, stackHead$tailLocal1.d9()), i$tailLocal2);
        } catch (e$11) {
          var e$12 = ((e$11 instanceof $c_jl_Throwable) ? e$11 : new $c_sjs_js_JavaScriptException(e$11));
          var \u03b48$ = new $c_Lujson_CharParser$$anon$1(i$tailLocal2);
          if (\u03b48$.e5(e$12)) {
            \u03b48$.e2(e$12, $m_s_PartialFunction$().gt);
          } else {
            throw ((e$12 instanceof $c_sjs_js_JavaScriptException) ? e$12.bf : e$12);
          }
        }
        var state$tailLocal1$tmp7 = this.II(stackHead$tailLocal1);
        var i$tailLocal2$tmp7 = ((4 + i$tailLocal2) | 0);
        state$tailLocal1 = state$tailLocal1$tmp7;
        i$tailLocal2 = i$tailLocal2$tmp7;
        break;
      }
      case 102: {
        this.Pj(state$tailLocal1, i$tailLocal2);
        try {
          stackHead$tailLocal1.h6().cU(this.aQV(i$tailLocal2, stackHead$tailLocal1.d9()), i$tailLocal2);
        } catch (e$13) {
          var e$14 = ((e$13 instanceof $c_jl_Throwable) ? e$13 : new $c_sjs_js_JavaScriptException(e$13));
          var \u03b49$ = new $c_Lujson_CharParser$$anon$1(i$tailLocal2);
          if (\u03b49$.e5(e$14)) {
            \u03b49$.e2(e$14, $m_s_PartialFunction$().gt);
          } else {
            throw ((e$14 instanceof $c_sjs_js_JavaScriptException) ? e$14.bf : e$14);
          }
        }
        var state$tailLocal1$tmp8 = this.II(stackHead$tailLocal1);
        var i$tailLocal2$tmp8 = ((5 + i$tailLocal2) | 0);
        state$tailLocal1 = state$tailLocal1$tmp8;
        i$tailLocal2 = i$tailLocal2$tmp8;
        break;
      }
      case 110: {
        this.Pj(state$tailLocal1, i$tailLocal2);
        try {
          stackHead$tailLocal1.h6().cU(this.aQZ(i$tailLocal2, stackHead$tailLocal1.d9()), i$tailLocal2);
        } catch (e$15) {
          var e$16 = ((e$15 instanceof $c_jl_Throwable) ? e$15 : new $c_sjs_js_JavaScriptException(e$15));
          var \u03b410$ = new $c_Lujson_CharParser$$anon$1(i$tailLocal2);
          if (\u03b410$.e5(e$16)) {
            \u03b410$.e2(e$16, $m_s_PartialFunction$().gt);
          } else {
            throw ((e$16 instanceof $c_sjs_js_JavaScriptException) ? e$16.bf : e$16);
          }
        }
        var state$tailLocal1$tmp9 = this.II(stackHead$tailLocal1);
        var i$tailLocal2$tmp9 = ((4 + i$tailLocal2) | 0);
        state$tailLocal1 = state$tailLocal1$tmp9;
        i$tailLocal2 = i$tailLocal2$tmp9;
        break;
      }
      case 44: {
        var x12 = state$tailLocal1;
        if ((x12 === 4)) {
          var i$tailLocal2$tmp10 = ((1 + i$tailLocal2) | 0);
          state$tailLocal1 = 1;
          i$tailLocal2 = i$tailLocal2$tmp10;
          break;
        }
        if ((x12 === 5)) {
          var i$tailLocal2$tmp11 = ((1 + i$tailLocal2) | 0);
          state$tailLocal1 = 2;
          i$tailLocal2 = i$tailLocal2$tmp11;
          break;
        }
        this.IO(i$tailLocal2, state$tailLocal1);
        break;
      }
      case 93: {
        var x16 = state$tailLocal1;
        matchAlts11: {
          matchAlts12: {
            if ((x16 === 4)) {
              break matchAlts12;
            }
            if ((x16 === 6)) {
              break matchAlts12;
            }
            break matchAlts11;
          }
          var x13 = this.aT5(stackHead$tailLocal1, stackTail$tailLocal1, i$tailLocal2);
          if ((x13 instanceof $c_s_Some)) {
            return x13.J;
          }
          if (($m_s_None$() === x13)) {
            var stackTailHead = stackTail$tailLocal1.t();
            var state$tailLocal1$tmp12 = this.II(stackTailHead);
            var i$tailLocal2$tmp12 = ((1 + i$tailLocal2) | 0);
            var stackTail$tailLocal1$tmp3 = stackTail$tailLocal1.v();
            state$tailLocal1 = state$tailLocal1$tmp12;
            i$tailLocal2 = i$tailLocal2$tmp12;
            stackHead$tailLocal1 = stackTailHead;
            stackTail$tailLocal1 = stackTail$tailLocal1$tmp3;
            break;
          }
          throw new $c_s_MatchError(x13);
        }
        this.IO(i$tailLocal2, state$tailLocal1);
        break;
      }
      case 125: {
        var x20 = state$tailLocal1;
        matchAlts13: {
          matchAlts14: {
            if ((x20 === 5)) {
              break matchAlts14;
            }
            if ((x20 === 7)) {
              break matchAlts14;
            }
            break matchAlts13;
          }
          var x17 = this.aT5(stackHead$tailLocal1, stackTail$tailLocal1, i$tailLocal2);
          if ((x17 instanceof $c_s_Some)) {
            return x17.J;
          }
          if (($m_s_None$() === x17)) {
            var stackTailHead$2 = stackTail$tailLocal1.t();
            var state$tailLocal1$tmp13 = this.II(stackTailHead$2);
            var i$tailLocal2$tmp13 = ((1 + i$tailLocal2) | 0);
            var stackTail$tailLocal1$tmp4 = stackTail$tailLocal1.v();
            state$tailLocal1 = state$tailLocal1$tmp13;
            i$tailLocal2 = i$tailLocal2$tmp13;
            stackHead$tailLocal1 = stackTailHead$2;
            stackTail$tailLocal1 = stackTail$tailLocal1$tmp4;
            break;
          }
          throw new $c_s_MatchError(x17);
        }
        this.IO(i$tailLocal2, state$tailLocal1);
        break;
      }
      default: {
        this.IO(i$tailLocal2, state$tailLocal1);
      }
    }
  }
});
$p.IO = (function(i, state) {
  var $x_1;
  switch (state) {
    case 6: {
      var $x_1 = "json value or ]";
      break;
    }
    case 7: {
      var $x_1 = "json value or }";
      break;
    }
    case 1: {
      var $x_1 = "json value";
      break;
    }
    case 2: {
      var $x_1 = "json string key";
      break;
    }
    case 3: {
      var $x_1 = ":";
      break;
    }
    case 4: {
      var $x_1 = ", or ]";
      break;
    }
    case 5: {
      var $x_1 = ", or }";
      break;
    }
    default: {
      throw new $c_s_MatchError(state);
    }
  }
  this.ny(i, ("expected " + $x_1));
});
$p.Pj = (function(state, i) {
  matchAlts19: {
    matchAlts20: {
      if ((state === 1)) {
        break matchAlts20;
      }
      if ((state === 6)) {
        break matchAlts20;
      }
      break matchAlts19;
    }
    return (void 0);
  }
  this.IO(i, state);
});
$p.aT5 = (function(stackHead, stackTail, i) {
  if (stackTail.c()) {
    try {
      var $x_1 = stackHead.bV(i);
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      var \u03b411$ = new $c_Lujson_CharParser$$anon$1(i);
      if (\u03b411$.e5(e$2)) {
        var $x_1 = \u03b411$.e2(e$2, $m_s_PartialFunction$().gt);
      } else {
        var $x_1;
        throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
      }
    }
    return new $c_s_Some(new $c_T2($x_1, ((1 + i) | 0)));
  } else {
    var ctxt2 = stackTail.t().h6();
    try {
      ctxt2.cU(stackHead.bV(i), i);
    } catch (e$3) {
      var e$4 = ((e$3 instanceof $c_jl_Throwable) ? e$3 : new $c_sjs_js_JavaScriptException(e$3));
      var \u03b412$ = new $c_Lujson_CharParser$$anon$1(i);
      if (\u03b412$.e5(e$4)) {
        \u03b412$.e2(e$4, $m_s_PartialFunction$().gt);
      } else {
        throw ((e$4 instanceof $c_sjs_js_JavaScriptException) ? e$4.bf : e$4);
      }
    }
    return $m_s_None$();
  }
});
$p.II = (function(stackHead) {
  return (stackHead.jr() ? 5 : 4);
});
$p.a4o = (function(i, safeIndex0) {
  var j = i;
  var safeIndex = safeIndex0;
  while (true) {
    if ((j >= safeIndex)) {
      safeIndex = this.P4(j);
    }
    var c = $f_Lupickle_core_BufferingCharParser__getCharUnsafe__I__C(this, j);
    switch (c) {
      case 34: {
        return ((1 + j) | 0);
        break;
      }
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
      case 8:
      case 9:
      case 10:
      case 11:
      case 12:
      case 13:
      case 14:
      case 15:
      case 16:
      case 17:
      case 18:
      case 19:
      case 20:
      case 21:
      case 22:
      case 23:
      case 24:
      case 25:
      case 26:
      case 27:
      case 28:
      case 29:
      case 30:
      case 31: {
        this.ny(j, (("control char (" + c) + ") in string"));
        break;
      }
      case 92: {
        return (~j);
        break;
      }
      default: {
        j = ((1 + j) | 0);
      }
    }
  }
});
$p.b6y = (function(i0, safeIndex0) {
  var i = i0;
  var safeIndex = safeIndex0;
  while (true) {
    var c = this.hn(i);
    var c$1 = c;
    if ((c$1 === 34)) {
      return ((1 + i) | 0);
    } else if ((c$1 < 32)) {
      this.ny(i, (("control char (" + c$1) + ") in string"));
    } else if ((c$1 === 92)) {
      if ((((1 + i) | 0) >= safeIndex)) {
        safeIndex = this.P4(((1 + i) | 0));
      }
      switch ($f_Lupickle_core_BufferingCharParser__getCharUnsafe__I__C(this, ((1 + i) | 0))) {
        case 98: {
          this.mF.jS(8);
          i = ((2 + i) | 0);
          break;
        }
        case 102: {
          this.mF.jS(12);
          i = ((2 + i) | 0);
          break;
        }
        case 110: {
          this.mF.jS(10);
          i = ((2 + i) | 0);
          break;
        }
        case 114: {
          this.mF.jS(13);
          i = ((2 + i) | 0);
          break;
        }
        case 116: {
          this.mF.jS(9);
          i = ((2 + i) | 0);
          break;
        }
        case 34: {
          this.mF.jS(34);
          i = ((2 + i) | 0);
          break;
        }
        case 47: {
          this.mF.jS(47);
          i = ((2 + i) | 0);
          break;
        }
        case 92: {
          this.mF.jS(92);
          i = ((2 + i) | 0);
          break;
        }
        case 117: {
          this.mF.jS(this.aZQ(i));
          i = ((6 + i) | 0);
          break;
        }
        default: {
          this.ny(((1 + i) | 0), "illegal escape sequence after \\");
        }
      }
    } else {
      var k = this.a4o(i, safeIndex);
      var normalizedK = ((k >= 0) ? k : ((-k) | 0));
      $f_Lupickle_core_BufferingCharParser__appendCharsToBuilder__Lupickle_core_CharBuilder__I__I__V(this, this.mF, i, ((((normalizedK - i) | 0) - 1) | 0));
      i = ((normalizedK - 1) | 0);
    }
  }
});
$p.b6B = (function(i, stackHead) {
  var k = this.a4o(((1 + i) | 0), 0);
  if ((k >= 0)) {
    this.aTp(i, $f_Lupickle_core_BufferingCharParser__unsafeCharSeqForRange__I__I__Lupickle_core_WrapCharArrayCharSeq(this, ((1 + i) | 0), ((((k - i) | 0) - 2) | 0)), stackHead);
    return k;
  } else {
    var k2 = this.ahq(i, k);
    var this$1 = this.mF;
    this.aTp(i, $m_jl_String$().kS(this$1.gx, 0, this$1.cD), stackHead);
    return k2;
  }
});
$p.b6z = (function(i, stackHead) {
  var k = this.a4o(((1 + i) | 0), 0);
  if ((k >= 0)) {
    this.aTr(i, $f_Lupickle_core_BufferingCharParser__unsafeCharSeqForRange__I__I__Lupickle_core_WrapCharArrayCharSeq(this, ((1 + i) | 0), ((((k - i) | 0) - 2) | 0)), stackHead);
    return k;
  } else {
    var k2 = this.ahq(i, k);
    var this$1 = this.mF;
    this.aTr(i, $m_jl_String$().kS(this$1.gx, 0, this$1.cD), stackHead);
    return k2;
  }
});
$p.ahq = (function(i, k) {
  var this$1 = this.mF;
  this$1.cD = 0;
  $f_Lupickle_core_BufferingCharParser__appendCharsToBuilder__Lupickle_core_CharBuilder__I__I__V(this, this.mF, ((1 + i) | 0), (((((-2) - k) | 0) - i) | 0));
  return this.b6y((~k), 0);
});
$p.aTp = (function(i, s, stackHead) {
  var v = stackHead.d9().cN(s, i);
  stackHead.h6().cU(v, i);
});
$p.aTr = (function(i, s, stackHead) {
  var keyVisitor = stackHead.jy(i);
  stackHead.jz(keyVisitor.cN(s, i));
});
$p.b6A = (function(i, facade) {
  var k = this.a4o(((1 + i) | 0), 0);
  if ((k >= 0)) {
    return new $c_T2(facade.cN($f_Lupickle_core_BufferingCharParser__unsafeCharSeqForRange__I__I__Lupickle_core_WrapCharArrayCharSeq(this, ((1 + i) | 0), ((((k - i) | 0) - 2) | 0)), i), k);
  } else {
    var k2 = this.ahq(i, k);
    var this$2 = this.mF;
    return new $c_T2(facade.cN($m_jl_String$().kS(this$2.gx, 0, this$2.cD), i), k2);
  }
});
function $f_Lujson_JsVisitor__visitFloat32__F__I__O($thiz, d, index) {
  if ((d === Infinity)) {
    return $thiz.cN("Infinity", index);
  } else if ((d === (-Infinity))) {
    return $thiz.cN("-Infinity", index);
  } else {
    var $x_1 = $m_RTLong$().d1(d);
    var i_$_lo = $x_1.l;
    var i_$_hi = $x_1.h;
    var compressedLo = (((((-2097152) & (i_$_hi ^ (i_$_hi >> 10))) === 0) || ((65535 & i_$_lo) === 0)) ? i_$_lo : (32768 | ((-32768) & i_$_lo)));
    if ((Math.fround(((4.294967296E9 * i_$_hi) + (compressedLo >>> 0.0))) === d)) {
      return $thiz.eD($m_RTLong$().kY(i_$_lo, i_$_hi), (-1), (-1), index);
    } else {
      return $f_Lujson_JsVisitor__visitFloat64String__T__I__O($thiz, ("" + d), index);
    }
  }
}
function $f_Lujson_JsVisitor__visitInt32__I__I__O($thiz, i, index) {
  return $thiz.e7(i, index);
}
function $f_Lujson_JsVisitor__visitInt64__J__I__O($thiz, i_$_lo, i_$_hi, index) {
  var sign = (i_$_hi >> 31);
  var xlo = (i_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((i_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  if ((((rhi === 2097152) ? (rlo !== 0) : (rhi > 2097152)) || ((i_$_lo | ((-2147483648) ^ i_$_hi)) === 0))) {
    return $thiz.cN($m_RTLong$().kY(i_$_lo, i_$_hi), index);
  } else {
    return $thiz.e7(((4.294967296E9 * i_$_hi) + (i_$_lo >>> 0.0)), index);
  }
}
function $f_Lujson_JsVisitor__visitUInt64__J__I__O($thiz, i_$_lo, i_$_hi, index) {
  return ((((i_$_hi === 2097152) ? (i_$_lo !== 0) : (i_$_hi > 2097152)) || (i_$_hi < 0)) ? $thiz.cN($m_jl_Long$().b3G(i_$_lo, i_$_hi, 10), index) : $thiz.e7(((4.294967296E9 * i_$_hi) + (i_$_lo >>> 0.0)), index));
}
function $f_Lujson_JsVisitor__visitFloat64String__T__I__O($thiz, s, index) {
  var $x_2 = $f_T__indexOf__I__I(s, 46);
  matchResult1: {
    var $x_1;
    var x1 = $f_T__indexOf__I__I(s, 69);
    if ((x1 === (-1))) {
      var $x_1 = $f_T__indexOf__I__I(s, 101);
      break matchResult1;
    }
    var $x_1 = x1;
  }
  return $thiz.eD(s, $x_2, $x_1, (-1));
}
function $f_Lujson_JsVisitor__visitBinary__AB__I__I__I__O($thiz, bytes, offset, len, index) {
  var arr = $thiz.cZ(len, index);
  var i = 0;
  while ((i < len)) {
    arr.cU(arr.d9().em(bytes.a[((offset + i) | 0)], index), index);
    i = ((1 + i) | 0);
  }
  return arr.bV(index);
}
function $f_Lujson_JsVisitor__visitExt__B__AB__I__I__I__O($thiz, tag, bytes, offset, len, index) {
  var arr = $thiz.cZ((-1), index);
  arr.cU($thiz.e7(tag, index), (-1));
  arr.cU($f_Lujson_JsVisitor__visitBinary__AB__I__I__I__O($thiz, bytes, offset, len, index), (-1));
  return arr.bV((-1));
}
function $f_Lujson_JsVisitor__visitObject__I__Z__I__Lupickle_core_ObjVisitor($thiz, length, jsonableKeys, index) {
  return (jsonableKeys ? $thiz.aTn(length, index) : new $c_Lujson_JsVisitor$$anon$1(length, index, $thiz));
}
function $f_Lupack_MsgVisitor__visitFloat64String__T__I__O($thiz, s, index) {
  return new $c_Lupack_Float64($m_jl_Double$().bd(s));
}
function $f_Lupack_MsgVisitor__visitFloat64StringParts__jl_CharSequence__I__I__I__O($thiz, s, decIndex, expIndex, index) {
  return new $c_Lupack_Float64($m_jl_Double$().bd($dp_toString__T(s)));
}
/** @constructor */
function $c_Lupickle_core_BufferedValue$Builder$() {
}
$p = $c_Lupickle_core_BufferedValue$Builder$.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_BufferedValue$Builder$;
/** @constructor */
function $h_Lupickle_core_BufferedValue$Builder$() {
}
$h_Lupickle_core_BufferedValue$Builder$.prototype = $p;
$p.ge = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.cZ = (function(length, i) {
  return new $c_Lupickle_core_BufferedValue$Builder$$anon$9(i);
});
$p.bQ = (function(length, jsonableKeys, i) {
  return new $c_Lupickle_core_BufferedValue$Builder$$anon$10(jsonableKeys, i);
});
$p.c8 = (function(index) {
  return new $c_Lupickle_core_BufferedValue$Null(index);
});
$p.eC = (function(index) {
  return new $c_Lupickle_core_BufferedValue$False(index);
});
$p.eE = (function(index) {
  return new $c_Lupickle_core_BufferedValue$True(index);
});
$p.eD = (function(s, decIndex, expIndex, index) {
  return new $c_Lupickle_core_BufferedValue$Num(s, decIndex, expIndex, index);
});
$p.e7 = (function(d, index) {
  return new $c_Lupickle_core_BufferedValue$NumRaw(d, index);
});
$p.cN = (function(s, index) {
  return new $c_Lupickle_core_BufferedValue$Str(s, index);
});
$p.fb = (function(bytes, offset, len, index) {
  return new $c_Lupickle_core_BufferedValue$Binary(bytes, offset, len, index);
});
$p.fc = (function(s, index) {
  return new $c_Lupickle_core_BufferedValue$Char(s, index);
});
$p.fd = (function(tag, bytes, offset, len, index) {
  return new $c_Lupickle_core_BufferedValue$Ext(tag, bytes, offset, len, index);
});
$p.eY = (function(d, index) {
  return new $c_Lupickle_core_BufferedValue$Float32(d, index);
});
$p.fA = (function(s, index) {
  return new $c_Lupickle_core_BufferedValue$Float64String(s, index);
});
$p.em = (function(i, index) {
  return new $c_Lupickle_core_BufferedValue$Int32(i, index);
});
$p.eZ = (function(i_$_lo, i_$_hi, index) {
  return new $c_Lupickle_core_BufferedValue$Int64(i_$_lo, i_$_hi, index);
});
$p.fe = (function(i_$_lo, i_$_hi, index) {
  return new $c_Lupickle_core_BufferedValue$UInt64(i_$_lo, i_$_hi, index);
});
var $d_Lupickle_core_BufferedValue$Builder$ = new $TypeData().i($c_Lupickle_core_BufferedValue$Builder$, "upickle.core.BufferedValue$Builder$", ({
  Oe: 1,
  x: 1
}));
var $n_Lupickle_core_BufferedValue$Builder$;
function $m_Lupickle_core_BufferedValue$Builder$() {
  if ((!$n_Lupickle_core_BufferedValue$Builder$)) {
    $n_Lupickle_core_BufferedValue$Builder$ = new $c_Lupickle_core_BufferedValue$Builder$();
  }
  return $n_Lupickle_core_BufferedValue$Builder$;
}
/** @constructor */
function $c_Lupickle_core_CharBuilder(startSize) {
  this.gx = null;
  this.cD = 0;
  this.gx = $m_jl_reflect_Array$().m0($d_C.l(), new $ac_I(new Int32Array([startSize])));
  this.cD = 0;
}
$p = $c_Lupickle_core_CharBuilder.prototype = new $h_Lupickle_core_CharAppendC();
$p.constructor = $c_Lupickle_core_CharBuilder;
/** @constructor */
function $h_Lupickle_core_CharBuilder() {
}
$h_Lupickle_core_CharBuilder.prototype = $p;
$p.ps = (function(increment) {
  var multiple = this.gx.a.length;
  var targetLength = ((this.cD + increment) | 0);
  while ((multiple < targetLength)) {
    multiple = (multiple << 1);
  }
  if ((multiple !== this.gx.a.length)) {
    this.gx = $m_ju_Arrays$().a31(this.gx, multiple);
  }
});
$p.jS = (function(x) {
  if ((this.cD === this.gx.a.length)) {
    this.gx = $m_ju_Arrays$().a31(this.gx, (this.gx.a.length << 1));
  }
  this.gx.a[this.cD] = x;
  this.cD = ((1 + this.cD) | 0);
});
$p.aX3 = (function(chars, charsStart, charsLength) {
  this.ps(charsLength);
  var dest = this.gx;
  var destPos = this.cD;
  chars.av(charsStart, dest, destPos, charsLength);
  this.cD = ((this.cD + charsLength) | 0);
});
$p.bcy = (function(writer, threshold) {
  if ((this.cD > threshold)) {
    writer.bc6(this.gx, 0, this.cD);
    this.cD = 0;
  }
});
var $d_Lupickle_core_CharBuilder = new $TypeData().i($c_Lupickle_core_CharBuilder, "upickle.core.CharBuilder", ({
  Oj: 1,
  Oi: 1
}));
/** @constructor */
function $c_Lupickle_core_NoOpVisitor$() {
}
$p = $c_Lupickle_core_NoOpVisitor$.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_NoOpVisitor$;
/** @constructor */
function $h_Lupickle_core_NoOpVisitor$() {
}
$h_Lupickle_core_NoOpVisitor$.prototype = $p;
$p.ge = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.cZ = (function(length, index) {
  return new $c_Lupickle_core_NoOpVisitor$$anon$1();
});
$p.bQ = (function(length, jsonableKeys, index) {
  return new $c_Lupickle_core_NoOpVisitor$$anon$2();
});
$p.c8 = (function(index) {
  return (void 0);
});
$p.eC = (function(index) {
  return (void 0);
});
$p.eE = (function(index) {
  return (void 0);
});
$p.eD = (function(s, decIndex, expIndex, index) {
  return (void 0);
});
$p.cN = (function(s, index) {
  return (void 0);
});
$p.e7 = (function(d, index) {
  return (void 0);
});
$p.eY = (function(d, index) {
  return (void 0);
});
$p.em = (function(i, index) {
  return (void 0);
});
$p.eZ = (function(i_$_lo, i_$_hi, index) {
  return (void 0);
});
$p.fe = (function(i_$_lo, i_$_hi, index) {
  return (void 0);
});
$p.fA = (function(s, index) {
  return (void 0);
});
$p.fb = (function(bytes, offset, len, index) {
  return (void 0);
});
$p.fd = (function(tag, bytes, offset, len, index) {
  return (void 0);
});
$p.fc = (function(s, index) {
  return (void 0);
});
var $d_Lupickle_core_NoOpVisitor$ = new $TypeData().i($c_Lupickle_core_NoOpVisitor$, "upickle.core.NoOpVisitor$", ({
  Oq: 1,
  x: 1
}));
var $n_Lupickle_core_NoOpVisitor$;
function $m_Lupickle_core_NoOpVisitor$() {
  if ((!$n_Lupickle_core_NoOpVisitor$)) {
    $n_Lupickle_core_NoOpVisitor$ = new $c_Lupickle_core_NoOpVisitor$();
  }
  return $n_Lupickle_core_NoOpVisitor$;
}
function $f_Lupickle_core_SimpleVisitor__visitTrue__I__O($thiz, index) {
  throw new $c_Lupickle_core_Abort(($thiz.ej() + " got boolean"));
}
function $f_Lupickle_core_SimpleVisitor__visitFalse__I__O($thiz, index) {
  throw new $c_Lupickle_core_Abort(($thiz.ej() + " got boolean"));
}
function $f_Lupickle_core_SimpleVisitor__visitString__jl_CharSequence__I__O($thiz, s, index) {
  throw new $c_Lupickle_core_Abort(($thiz.ej() + " got string"));
}
function $f_Lupickle_core_SimpleVisitor__visitFloat64StringParts__jl_CharSequence__I__I__I__O($thiz, s, decIndex, expIndex, index) {
  throw new $c_Lupickle_core_Abort(($thiz.ej() + " got number"));
}
function $f_Lupickle_core_SimpleVisitor__visitObject__I__Z__I__Lupickle_core_ObjVisitor($thiz, length, jsonableKeys, index) {
  throw new $c_Lupickle_core_Abort(($thiz.ej() + " got dictionary"));
}
function $f_Lupickle_core_SimpleVisitor__visitArray__I__I__Lupickle_core_ArrVisitor($thiz, length, index) {
  throw new $c_Lupickle_core_Abort(($thiz.ej() + " got sequence"));
}
function $f_Lupickle_core_SimpleVisitor__visitFloat64__D__I__O($thiz, d, index) {
  throw new $c_Lupickle_core_Abort(($thiz.ej() + " got float64"));
}
function $f_Lupickle_core_SimpleVisitor__visitFloat32__F__I__O($thiz, d, index) {
  throw new $c_Lupickle_core_Abort(($thiz.ej() + " got float32"));
}
function $f_Lupickle_core_SimpleVisitor__visitInt32__I__I__O($thiz, i, index) {
  throw new $c_Lupickle_core_Abort(($thiz.ej() + " got int32"));
}
function $f_Lupickle_core_SimpleVisitor__visitInt64__J__I__O($thiz, i_$_lo, i_$_hi, index) {
  throw new $c_Lupickle_core_Abort(($thiz.ej() + " got int64"));
}
function $f_Lupickle_core_SimpleVisitor__visitUInt64__J__I__O($thiz, i_$_lo, i_$_hi, index) {
  throw new $c_Lupickle_core_Abort(($thiz.ej() + " got uint64"));
}
function $f_Lupickle_core_SimpleVisitor__visitFloat64String__T__I__O($thiz, s, index) {
  throw new $c_Lupickle_core_Abort(($thiz.ej() + " got float64 string"));
}
function $f_Lupickle_core_SimpleVisitor__visitChar__C__I__O($thiz, s, index) {
  throw new $c_Lupickle_core_Abort(($thiz.ej() + " got char"));
}
function $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O($thiz, bytes, offset, len, index) {
  throw new $c_Lupickle_core_Abort(($thiz.ej() + " got binary"));
}
function $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O($thiz, tag, bytes, offset, len, index) {
  throw new $c_Lupickle_core_Abort(($thiz.ej() + " got ext"));
}
/** @constructor */
function $c_Lupickle_core_TraceVisitor$RootHasPath$() {
}
$p = $c_Lupickle_core_TraceVisitor$RootHasPath$.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_TraceVisitor$RootHasPath$;
/** @constructor */
function $h_Lupickle_core_TraceVisitor$RootHasPath$() {
}
$h_Lupickle_core_TraceVisitor$RootHasPath$.prototype = $p;
$p.m = (function() {
  return $f_Lupickle_core_TraceVisitor$HasPath__path__T(this);
});
$p.ahr = (function() {
  return $m_s_None$();
});
$p.a4l = (function() {
  return $m_s_None$();
});
var $d_Lupickle_core_TraceVisitor$RootHasPath$ = new $TypeData().i($c_Lupickle_core_TraceVisitor$RootHasPath$, "upickle.core.TraceVisitor$RootHasPath$", ({
  OA: 1,
  e6: 1
}));
var $n_Lupickle_core_TraceVisitor$RootHasPath$;
function $m_Lupickle_core_TraceVisitor$RootHasPath$() {
  if ((!$n_Lupickle_core_TraceVisitor$RootHasPath$)) {
    $n_Lupickle_core_TraceVisitor$RootHasPath$ = new $c_Lupickle_core_TraceVisitor$RootHasPath$();
  }
  return $n_Lupickle_core_TraceVisitor$RootHasPath$;
}
var $d_Lupickle_core_Types$Reader = new $TypeData().i(1, "upickle.core.Types$Reader", ({
  D: 1,
  x: 1
}));
function $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O($thiz, out, v) {
  return ((v === null) ? out.c8((-1)) : $thiz.d0(out, v));
}
function $ct_Lupickle_core_Visitor$Delegate__Lupickle_core_Visitor__($thiz, delegatedReader) {
  $thiz.iH = delegatedReader;
  return $thiz;
}
/** @constructor */
function $c_Lupickle_core_Visitor$Delegate() {
  this.iH = null;
}
$p = $c_Lupickle_core_Visitor$Delegate.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_Visitor$Delegate;
/** @constructor */
function $h_Lupickle_core_Visitor$Delegate() {
}
$h_Lupickle_core_Visitor$Delegate.prototype = $p;
$p.ge = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.c8 = (function(index) {
  return this.iH.c8(index);
});
$p.eE = (function(index) {
  return this.iH.eE(index);
});
$p.eC = (function(index) {
  return this.iH.eC(index);
});
$p.cN = (function(s, index) {
  return this.iH.cN(s, index);
});
$p.eD = (function(s, decIndex, expIndex, index) {
  return this.iH.eD(s, decIndex, expIndex, index);
});
$p.e7 = (function(d, index) {
  return this.iH.e7(d, index);
});
$p.bQ = (function(length, jsonableKeys, index) {
  return this.iH.bQ(length, jsonableKeys, index);
});
$p.cZ = (function(length, index) {
  return this.iH.cZ(length, index);
});
$p.eY = (function(d, index) {
  return this.iH.eY(d, index);
});
$p.em = (function(i, index) {
  return this.iH.em(i, index);
});
$p.eZ = (function(i_$_lo, i_$_hi, index) {
  return this.iH.eZ(i_$_lo, i_$_hi, index);
});
$p.fe = (function(i_$_lo, i_$_hi, index) {
  return this.iH.fe(i_$_lo, i_$_hi, index);
});
$p.fA = (function(s, index) {
  return this.iH.fA(s, index);
});
$p.fc = (function(s, index) {
  return this.iH.fc(s, index);
});
$p.fb = (function(bytes, offset, len, index) {
  return this.iH.fb(bytes, offset, len, index);
});
$p.fd = (function(tag, bytes, offset, len, index) {
  return this.iH.fd(tag, bytes, offset, len, index);
});
function $ct_Lupickle_core_Visitor$MapReader__Lupickle_core_Visitor__($thiz, delegatedReader) {
  $thiz.kJ = delegatedReader;
  return $thiz;
}
/** @constructor */
function $c_Lupickle_core_Visitor$MapReader() {
  this.kJ = null;
}
$p = $c_Lupickle_core_Visitor$MapReader.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_Visitor$MapReader;
/** @constructor */
function $h_Lupickle_core_Visitor$MapReader() {
}
$h_Lupickle_core_Visitor$MapReader.prototype = $p;
$p.ge = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.pz = (function(v) {
  return ((v === null) ? null : this.a4a(v));
});
$p.eC = (function(index) {
  return this.pz(this.kJ.eC(index));
});
$p.c8 = (function(index) {
  return this.pz(this.kJ.c8(index));
});
$p.eD = (function(s, decIndex, expIndex, index) {
  return this.pz(this.kJ.eD(s, decIndex, expIndex, index));
});
$p.e7 = (function(d, index) {
  return this.pz(this.kJ.e7(d, index));
});
$p.cN = (function(s, index) {
  return this.pz(this.kJ.cN(s, index));
});
$p.eE = (function(index) {
  return this.pz(this.kJ.eE(index));
});
$p.bQ = (function(length, jsonableKeys, index) {
  return new $c_Lupickle_core_Visitor$MapObjContext(this.kJ.bQ(length, jsonableKeys, index), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((t) => this.a4a(t))));
});
$p.cZ = (function(length, index) {
  return new $c_Lupickle_core_Visitor$MapArrContext(this.kJ.cZ(length, index), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((t) => this.a4a(t))));
});
$p.eY = (function(d, index) {
  return this.pz(this.kJ.eY(d, index));
});
$p.em = (function(i, index) {
  return this.pz(this.kJ.em(i, index));
});
$p.eZ = (function(i_$_lo, i_$_hi, index) {
  return this.pz(this.kJ.eZ(i_$_lo, i_$_hi, index));
});
$p.fe = (function(i_$_lo, i_$_hi, index) {
  return this.pz(this.kJ.fe(i_$_lo, i_$_hi, index));
});
$p.fA = (function(s, index) {
  return this.pz(this.kJ.fA(s, index));
});
$p.fc = (function(s, index) {
  return this.pz(this.kJ.fc(s, index));
});
$p.fb = (function(bytes, offset, len, index) {
  return this.pz(this.kJ.fb(bytes, offset, len, index));
});
$p.fd = (function(tag, bytes, offset, len, index) {
  return this.pz(this.kJ.fd(tag, bytes, offset, len, index));
});
/** @constructor */
function $c_Lupickle_core_WrapCharArrayCharSeq(arr, start, length0) {
  this.adZ = null;
  this.ae0 = 0;
  this.aK5 = 0;
  this.a2n = null;
  this.adZ = arr;
  this.ae0 = start;
  this.aK5 = length0;
  this.a2n = null;
}
$p = $c_Lupickle_core_WrapCharArrayCharSeq.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_WrapCharArrayCharSeq;
/** @constructor */
function $h_Lupickle_core_WrapCharArrayCharSeq() {
}
$h_Lupickle_core_WrapCharArrayCharSeq.prototype = $p;
$p.C = (function() {
  return this.m().length;
});
$p.y1 = (function(index) {
  return this.m().charCodeAt(index);
});
$p.Jp = (function(newStart, newEnd) {
  return new $c_Lupickle_core_WrapCharArrayCharSeq(this.adZ, ((this.ae0 + newStart) | 0), ((newEnd - newStart) | 0));
});
$p.m = (function() {
  if ((this.a2n !== null)) {
    return this.a2n;
  } else {
    var res = $m_jl_String$().kS(this.adZ, this.ae0, this.aK5);
    this.a2n = res;
    return res;
  }
});
var $d_Lupickle_core_WrapCharArrayCharSeq = new $TypeData().i($c_Lupickle_core_WrapCharArrayCharSeq, "upickle.core.WrapCharArrayCharSeq", ({
  OW: 1,
  aX: 1
}));
/** @constructor */
function $c_Lupickle_core_compat_LinkedHashMapCompat$$anon$1() {
}
$p = $c_Lupickle_core_compat_LinkedHashMapCompat$$anon$1.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_compat_LinkedHashMapCompat$$anon$1;
/** @constructor */
function $h_Lupickle_core_compat_LinkedHashMapCompat$$anon$1() {
}
$h_Lupickle_core_compat_LinkedHashMapCompat$$anon$1.prototype = $p;
$p.b5 = (function() {
  return new $c_Lupickle_core_compat_LinkedHashMapCompat$$anon$2();
});
var $d_Lupickle_core_compat_LinkedHashMapCompat$$anon$1 = new $TypeData().i($c_Lupickle_core_compat_LinkedHashMapCompat$$anon$1, "upickle.core.compat.LinkedHashMapCompat$$anon$1", ({
  OY: 1,
  bX: 1
}));
class $c_Lcom_raquo_airstream_core_AirstreamError extends $c_jl_Throwable {
}
/** @constructor */
function $c_Lcom_raquo_airstream_core_AirstreamError$() {
  this.a5r = null;
  this.aj3 = null;
  this.aj4 = null;
  $n_Lcom_raquo_airstream_core_AirstreamError$ = this;
  this.a5r = $m_scm_Buffer$().kM($m_sr_ScalaRunTime$().f(new ($d_F1.r().C)([])));
  this.aj3 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((err) => {
    try {
      console.error(((this.E1(err) + "\n") + this.b29(err, "\n")));
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      console.error("Error in AirstreamError.consoleErrorCallback:");
      console.error(e$2);
    }
  }));
  this.aj4 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((err$2) => {
    console.warn("Using unsafe rethrow error callback. Note: other registered error callbacks might not run. Use with caution.");
    var $x_1 = err$2;
    throw (($x_1 instanceof $c_sjs_js_JavaScriptException) ? $x_1.bf : $x_1);
  }));
  this.aRr(this.aj3);
}
$p = $c_Lcom_raquo_airstream_core_AirstreamError$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_core_AirstreamError$;
/** @constructor */
function $h_Lcom_raquo_airstream_core_AirstreamError$() {
}
$h_Lcom_raquo_airstream_core_AirstreamError$.prototype = $p;
$p.E1 = (function(e) {
  try {
    var errorMessage = e.e3();
  } catch (e$2) {
    var errorMessage = "(Unable to get the message for this error - exception occurred in its getMessage)";
  }
  return (($objectGetClass(e).a3F() + ": ") + errorMessage);
});
$p.b29 = (function(err, newline) {
  try {
    return $f_sc_IterableOnceOps__mkString__T__T__T__T($m_s_Predef$().fB(err.a3G()), "", newline, "");
  } catch (e) {
    return "(Unable to get the stacktrace for this error - exception occurred in its getStackTrace)";
  }
});
$p.aYA = (function(message, cause) {
  return ((message + "; cause: ") + (cause.c() ? $m_s_None$() : new $c_s_Some(this.E1(cause.d()))));
});
$p.aYz = (function(causes) {
  return ("CombinedError: " + $f_sc_IterableOnceOps__mkString__T__T__T__T(causes.dk($m_s_$less$colon$less$().b1).L(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((e) => this.E1(e)))), "", "; ", ""));
});
$p.aRr = (function(fn) {
  this.a5r.Y(fn);
});
$p.rc = (function(err) {
  var this$1 = this.a5r;
  var it = this$1.o();
  while (it.p()) {
    var x0 = it.q();
    try {
      x0.i(err);
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      var x$2 = this.aj4;
      if (((x0 === null) ? (x$2 === null) : x0.e(x$2))) {
        throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
      }
      console.warn("Error processing an unhandled error callback:");
      $m_sjs_js_timers_package$().ym(0.0, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d(((e$2) => (() => {
        throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
      }))(e$2)));
    }
  }
});
var $d_Lcom_raquo_airstream_core_AirstreamError$ = new $TypeData().i($c_Lcom_raquo_airstream_core_AirstreamError$, "com.raquo.airstream.core.AirstreamError$", ({
  nJ: 1,
  d: 1,
  u: 1
}));
var $n_Lcom_raquo_airstream_core_AirstreamError$;
function $m_Lcom_raquo_airstream_core_AirstreamError$() {
  if ((!$n_Lcom_raquo_airstream_core_AirstreamError$)) {
    $n_Lcom_raquo_airstream_core_AirstreamError$ = new $c_Lcom_raquo_airstream_core_AirstreamError$();
  }
  return $n_Lcom_raquo_airstream_core_AirstreamError$;
}
function $f_Lcom_raquo_airstream_core_BaseObservable__$init$__V($thiz) {
  $thiz.gb(true);
  $thiz.hS((void 0));
}
function $f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable($thiz) {
  return $f_Lcom_raquo_airstream_core_BaseObservable__distinctByFn__F2__Lcom_raquo_airstream_core_Observable($thiz, new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((_$17, _$18) => $m_sr_BoxesRunTime$().Q(_$17, _$18))));
}
function $f_Lcom_raquo_airstream_core_BaseObservable__distinctByFn__F2__Lcom_raquo_airstream_core_Observable($thiz, isSame) {
  return $thiz.ii(new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((x$1, x$2) => {
    if ((x$1 instanceof $c_s_util_Success)) {
      var prev = x$1.fM;
      if ((x$2 instanceof $c_s_util_Success)) {
        var next = x$2.fM;
        return (!(!isSame.R(prev, next)));
      }
    }
    return false;
  })));
}
function $f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription($thiz, onNext, owner) {
  return $f_Lcom_raquo_airstream_core_WritableObservable__addObserver__Lcom_raquo_airstream_core_Observer__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription($thiz, $m_Lcom_raquo_airstream_core_Observer$().wo(onNext, $m_s_PartialFunction$().gt, true), owner);
}
function $f_Lcom_raquo_airstream_core_BaseObservable__removeExternalObserver__Lcom_raquo_airstream_core_Observer__V($thiz, observer) {
  if ($thiz.hR()) {
    $f_Lcom_raquo_airstream_core_WritableObservable__removeExternalObserverNow__Lcom_raquo_airstream_core_Observer__V($thiz, observer);
  } else {
    $f_Lcom_raquo_airstream_core_BaseObservable__getOrCreatePendingObserverRemovals__Lcom_raquo_ew_JsArray($thiz).push(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
      $f_Lcom_raquo_airstream_core_WritableObservable__removeExternalObserverNow__Lcom_raquo_airstream_core_Observer__V($thiz, observer);
    })));
  }
}
function $f_Lcom_raquo_airstream_core_BaseObservable__removeInternalObserver__Lcom_raquo_airstream_core_InternalObserver__V($thiz, observer) {
  if ($thiz.hR()) {
    $f_Lcom_raquo_airstream_core_WritableObservable__removeInternalObserverNow__Lcom_raquo_airstream_core_InternalObserver__V($thiz, observer);
  } else {
    $f_Lcom_raquo_airstream_core_BaseObservable__getOrCreatePendingObserverRemovals__Lcom_raquo_ew_JsArray($thiz).push(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
      $f_Lcom_raquo_airstream_core_WritableObservable__removeInternalObserverNow__Lcom_raquo_airstream_core_InternalObserver__V($thiz, observer);
    })));
  }
}
function $f_Lcom_raquo_airstream_core_BaseObservable__isStarted__Z($thiz) {
  return ($f_Lcom_raquo_airstream_core_WritableObservable__numAllObservers__I($thiz) > 0);
}
function $f_Lcom_raquo_airstream_core_BaseObservable__getOrCreatePendingObserverRemovals__Lcom_raquo_ew_JsArray($thiz) {
  var x = $thiz.h5();
  if ((x === (void 0))) {
    var newArray = $m_Lcom_raquo_ew_JsArray$().fu($m_sr_ScalaRunTime$().f(new ($d_F0.r().C)([])));
    $thiz.hS(newArray);
    return newArray;
  } else {
    return x;
  }
}
/** @constructor */
function $c_Lcom_raquo_airstream_core_Observable$() {
  this.AM = null;
  this.aj8 = null;
  this.AL = null;
  $n_Lcom_raquo_airstream_core_Observable$ = this;
  this.AM = $m_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchStreamStrategy$();
  this.aj8 = $m_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStreamStrategy$();
  this.AL = $m_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStrategy$();
}
$p = $c_Lcom_raquo_airstream_core_Observable$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_core_Observable$;
/** @constructor */
function $h_Lcom_raquo_airstream_core_Observable$() {
}
$h_Lcom_raquo_airstream_core_Observable$.prototype = $p;
var $d_Lcom_raquo_airstream_core_Observable$ = new $TypeData().i($c_Lcom_raquo_airstream_core_Observable$, "com.raquo.airstream.core.Observable$", ({
  nP: 1,
  nR: 1,
  nQ: 1
}));
var $n_Lcom_raquo_airstream_core_Observable$;
function $m_Lcom_raquo_airstream_core_Observable$() {
  if ((!$n_Lcom_raquo_airstream_core_Observable$)) {
    $n_Lcom_raquo_airstream_core_Observable$ = new $c_Lcom_raquo_airstream_core_Observable$();
  }
  return $n_Lcom_raquo_airstream_core_Observable$;
}
function $f_Lcom_raquo_airstream_core_Observer__contramap__F1__Lcom_raquo_airstream_core_Observer($thiz, project) {
  return $m_Lcom_raquo_airstream_core_Observer$().wo(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((nextValue) => {
    $thiz.bA(project.i(nextValue));
  })), new $c_Lcom_raquo_airstream_core_Observer$$anon$1($thiz), ($m_Lcom_raquo_airstream_core_Observer$(), true));
}
var $d_Lcom_raquo_airstream_core_Observer = new $TypeData().i(1, "com.raquo.airstream.core.Observer", ({
  bL: 1,
  b7: 1,
  O: 1
}));
/** @constructor */
function $c_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStrategy$() {
}
$p = $c_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStrategy$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStrategy$;
/** @constructor */
function $h_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStrategy$() {
}
$h_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStrategy$.prototype = $p;
$p.mK = (function(parent) {
  return new $c_Lcom_raquo_airstream_flatten_SwitchSignal(parent);
});
var $d_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStrategy$ = new $TypeData().i($c_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStrategy$, "com.raquo.airstream.flatten.FlattenStrategy$SwitchSignalStrategy$", ({
  oh: 1,
  d1: 1,
  d2: 1
}));
var $n_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStrategy$;
function $m_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStrategy$() {
  if ((!$n_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStrategy$)) {
    $n_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStrategy$ = new $c_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStrategy$();
  }
  return $n_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStrategy$;
}
/** @constructor */
function $c_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStreamStrategy$() {
}
$p = $c_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStreamStrategy$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStreamStrategy$;
/** @constructor */
function $h_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStreamStrategy$() {
}
$h_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStreamStrategy$.prototype = $p;
$p.mK = (function(parent) {
  return new $c_Lcom_raquo_airstream_flatten_SwitchSignalStream(parent);
});
var $d_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStreamStrategy$ = new $TypeData().i($c_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStreamStrategy$, "com.raquo.airstream.flatten.FlattenStrategy$SwitchSignalStreamStrategy$", ({
  oi: 1,
  d1: 1,
  d2: 1
}));
var $n_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStreamStrategy$;
function $m_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStreamStrategy$() {
  if ((!$n_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStreamStrategy$)) {
    $n_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStreamStrategy$ = new $c_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStreamStrategy$();
  }
  return $n_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchSignalStreamStrategy$;
}
/** @constructor */
function $c_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchStreamStrategy$() {
}
$p = $c_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchStreamStrategy$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchStreamStrategy$;
/** @constructor */
function $h_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchStreamStrategy$() {
}
$h_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchStreamStrategy$.prototype = $p;
$p.b1q = (function(parent) {
  return new $c_Lcom_raquo_airstream_flatten_SwitchStream(parent, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x) => x)));
});
$p.mK = (function(parent) {
  return this.b1q(parent);
});
var $d_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchStreamStrategy$ = new $TypeData().i($c_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchStreamStrategy$, "com.raquo.airstream.flatten.FlattenStrategy$SwitchStreamStrategy$", ({
  oj: 1,
  d1: 1,
  d2: 1
}));
var $n_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchStreamStrategy$;
function $m_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchStreamStrategy$() {
  if ((!$n_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchStreamStrategy$)) {
    $n_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchStreamStrategy$ = new $c_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchStreamStrategy$();
  }
  return $n_Lcom_raquo_airstream_flatten_FlattenStrategy$SwitchStreamStrategy$;
}
function $f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($thiz, value, r) {
  return new $c_Lcom_raquo_laminar_nodes_TextNode(r.aeP(value));
}
function $f_Lcom_raquo_laminar_api_Implicits__optionToSetter__s_Option__Lcom_raquo_laminar_modifiers_Setter($thiz, maybeSetter) {
  return new $c_Lcom_raquo_laminar_modifiers_Setter$$anon$2(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((element) => {
    if ((!maybeSetter.c())) {
      maybeSetter.d().kL(element);
    }
  })), $m_Lcom_raquo_laminar_modifiers_Setter$());
}
function $f_Lcom_raquo_laminar_api_Implicits__seqToSetter__O__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Setter($thiz, setters, renderableSeq) {
  return new $c_Lcom_raquo_laminar_modifiers_Setter$$anon$2(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((element) => {
    renderableSeq.Q3(setters).F(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((element$2) => ((_$3) => {
      _$3.kL(element$2);
    }))(element)));
  })), $m_Lcom_raquo_laminar_modifiers_Setter$());
}
function $f_Lcom_raquo_laminar_api_Implicits__optionToModifier__s_Option__F1__Lcom_raquo_laminar_modifiers_Modifier($thiz, maybeModifier, asModifier) {
  return new $c_Lcom_raquo_laminar_modifiers_Modifier$$anon$2(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((element) => {
    if ((!maybeModifier.c())) {
      var x0 = maybeModifier.d();
      asModifier.i(x0).kL(element);
    }
  })), $m_Lcom_raquo_laminar_modifiers_Modifier$());
}
function $f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($thiz, modifiers, asModifier, renderableSeq) {
  return new $c_Lcom_raquo_laminar_modifiers_Modifier$$anon$2(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((element) => {
    renderableSeq.Q3(modifiers).F(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((element$2) => ((_$6) => {
      asModifier.i(_$6).kL(element$2);
    }))(element)));
  })), $m_Lcom_raquo_laminar_modifiers_Modifier$());
}
function $f_Lcom_raquo_laminar_api_Implicits__nodeOptionToModifier__s_Option__Lcom_raquo_laminar_modifiers_Modifier($thiz, nodes) {
  return new $c_Lcom_raquo_laminar_modifiers_Modifier$$anon$2(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((element) => {
    if ((!nodes.c())) {
      $m_Lcom_raquo_laminar_nodes_ParentNode$().DF(element, nodes.d(), (void 0));
    }
  })), $m_Lcom_raquo_laminar_modifiers_Modifier$());
}
function $f_Lcom_raquo_laminar_api_Implicits__nodeSeqToModifier__O__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($thiz, nodes, renderableSeq) {
  return new $c_Lcom_raquo_laminar_modifiers_Modifier$$anon$2(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((element) => {
    renderableSeq.Q3(nodes).F(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((element$2) => ((_$9) => {
      $m_Lcom_raquo_laminar_nodes_ParentNode$().DF(element$2, _$9, (void 0));
    }))(element)));
  })), $m_Lcom_raquo_laminar_modifiers_Modifier$());
}
/** @constructor */
function $c_Lcom_raquo_laminar_api_Laminar$$anon$1() {
  this.amP = null;
  this.amQ = false;
  this.amR = null;
  this.amS = false;
  this.amN = null;
  this.amO = false;
  this.amT = null;
  this.amU = false;
  this.amL = null;
  this.amM = false;
}
$p = $c_Lcom_raquo_laminar_api_Laminar$$anon$1.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_api_Laminar$$anon$1;
/** @constructor */
function $h_Lcom_raquo_laminar_api_Laminar$$anon$1() {
}
$h_Lcom_raquo_laminar_api_Laminar$$anon$1.prototype = $p;
$p.a4i = (function() {
  if ((!this.amQ)) {
    this.amP = new $c_Lcom_raquo_laminar_keys_EventProp("mousemove");
    this.amQ = true;
  }
  return this.amP;
});
$p.a4j = (function() {
  if ((!this.amS)) {
    this.amR = new $c_Lcom_raquo_laminar_keys_EventProp("mouseup");
    this.amS = true;
  }
  return this.amR;
});
$p.m1 = (function() {
  if ((!this.amO)) {
    this.amN = new $c_Lcom_raquo_laminar_keys_EventProp("keydown");
    this.amO = true;
  }
  return this.amN;
});
$p.ahf = (function() {
  if ((!this.amU)) {
    this.amT = new $c_Lcom_raquo_laminar_keys_EventProp("resize");
    this.amU = true;
  }
  return this.amT;
});
$p.ahe = (function() {
  if ((!this.amM)) {
    this.amL = new $c_Lcom_raquo_laminar_keys_EventProp("error");
    this.amM = true;
  }
  return this.amL;
});
var $d_Lcom_raquo_laminar_api_Laminar$$anon$1 = new $TypeData().i($c_Lcom_raquo_laminar_api_Laminar$$anon$1, "com.raquo.laminar.api.Laminar$$anon$1", ({
  pc: 1,
  d7: 1,
  pw: 1
}));
/** @constructor */
function $c_Lcom_raquo_laminar_api_Laminar$$anon$2() {
  this.amZ = null;
  this.an0 = false;
  this.an1 = null;
  this.an2 = false;
  this.amX = null;
  this.amY = false;
  this.an5 = null;
  this.an6 = false;
  this.amV = null;
  this.amW = false;
  this.an3 = null;
  this.an4 = false;
}
$p = $c_Lcom_raquo_laminar_api_Laminar$$anon$2.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_api_Laminar$$anon$2;
/** @constructor */
function $h_Lcom_raquo_laminar_api_Laminar$$anon$2() {
}
$h_Lcom_raquo_laminar_api_Laminar$$anon$2.prototype = $p;
$p.a4i = (function() {
  if ((!this.an0)) {
    this.amZ = new $c_Lcom_raquo_laminar_keys_EventProp("mousemove");
    this.an0 = true;
  }
  return this.amZ;
});
$p.a4j = (function() {
  if ((!this.an2)) {
    this.an1 = new $c_Lcom_raquo_laminar_keys_EventProp("mouseup");
    this.an2 = true;
  }
  return this.an1;
});
$p.m1 = (function() {
  if ((!this.amY)) {
    this.amX = new $c_Lcom_raquo_laminar_keys_EventProp("keydown");
    this.amY = true;
  }
  return this.amX;
});
$p.ahf = (function() {
  if ((!this.an6)) {
    this.an5 = new $c_Lcom_raquo_laminar_keys_EventProp("resize");
    this.an6 = true;
  }
  return this.an5;
});
$p.ahe = (function() {
  if ((!this.amW)) {
    this.amV = new $c_Lcom_raquo_laminar_keys_EventProp("error");
    this.amW = true;
  }
  return this.amV;
});
$p.aQJ = (function() {
  if ((!this.an4)) {
    this.an3 = new $c_Lcom_raquo_laminar_keys_EventProp("popstate");
    this.an4 = true;
  }
  return this.an3;
});
var $d_Lcom_raquo_laminar_api_Laminar$$anon$2 = new $TypeData().i($c_Lcom_raquo_laminar_api_Laminar$$anon$2, "com.raquo.laminar.api.Laminar$$anon$2", ({
  pd: 1,
  d7: 1,
  px: 1
}));
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_Binder$$anon$1(fn$3, outer) {
  this.arw = null;
  this.arw = fn$3;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_raquo_laminar_modifiers_Binder$$anon$1.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_modifiers_Binder$$anon$1;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_Binder$$anon$1() {
}
$h_Lcom_raquo_laminar_modifiers_Binder$$anon$1.prototype = $p;
$p.kL = (function(element) {
  this.Wn(element);
});
$p.Wn = (function(element) {
  return this.arw.i(element);
});
var $d_Lcom_raquo_laminar_modifiers_Binder$$anon$1 = new $TypeData().i($c_Lcom_raquo_laminar_modifiers_Binder$$anon$1, "com.raquo.laminar.modifiers.Binder$$anon$1", ({
  q2: 1,
  ar: 1,
  d8: 1
}));
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_CompositeKeySetter(key, itemsToAdd) {
  this.QR = null;
  this.QQ = null;
  this.QR = key;
  this.QQ = itemsToAdd;
}
$p = $c_Lcom_raquo_laminar_modifiers_CompositeKeySetter.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_modifiers_CompositeKeySetter;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_CompositeKeySetter() {
}
$h_Lcom_raquo_laminar_modifiers_CompositeKeySetter.prototype = $p;
$p.kL = (function(element) {
  if ((!this.QQ.c())) {
    $f_Lcom_raquo_laminar_nodes_ReactiveElement__updateCompositeValue__Lcom_raquo_laminar_keys_CompositeKey__Lcom_raquo_laminar_modifiers_Modifier__sci_List__sci_List__V(element, this.QR, null, this.QQ, $m_sci_Nil$());
  }
});
$p.xV = (function(include) {
  return (include ? this.QR.aLg(this.QQ, $m_Lcom_raquo_laminar_api_package$().aev()) : this.QR.aLg($m_sr_ScalaRunTime$().f(new ($d_T.r().C)([])), $m_Lcom_raquo_laminar_api_package$().aev()));
});
$p.bj = (function(include) {
  return this.QR.ael(include.dM().fQ(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((include$2) => ((!(!include$2)) ? this.QQ : $m_sci_Nil$())))), $m_Lcom_raquo_laminar_api_package$().aev());
});
var $d_Lcom_raquo_laminar_modifiers_CompositeKeySetter = new $TypeData().i($c_Lcom_raquo_laminar_modifiers_CompositeKeySetter, "com.raquo.laminar.modifiers.CompositeKeySetter", ({
  q3: 1,
  ar: 1,
  d9: 1
}));
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_EventListener(eventProcessor, callback) {
  this.uo = null;
  this.arx = null;
  this.a6C = null;
  this.a6D = null;
  this.uo = eventProcessor;
  this.arx = callback;
  this.a6C = ((ev) => {
    var processor = eventProcessor.m6;
    var this$2 = processor.i(ev);
    if ((!this$2.c())) {
      callback.i(this$2.d());
    }
  });
  this.a6D = (() => {
    var outer = null;
    outer = this;
    var this$3 = ({});
    if ((outer === null)) {
      throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
    }
    this$3.capture = outer.uo.m7;
    this$3.passive = outer.uo.wq;
    return this$3;
  })();
}
$p = $c_Lcom_raquo_laminar_modifiers_EventListener.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_modifiers_EventListener;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_EventListener() {
}
$h_Lcom_raquo_laminar_modifiers_EventListener.prototype = $p;
$p.kL = (function(element) {
  this.aeT(element, false);
});
$p.aeT = (function(element, unsafePrepend) {
  if (($f_Lcom_raquo_laminar_nodes_ReactiveElement__indexOfEventListener__Lcom_raquo_laminar_modifiers_EventListener__I(element, this) === (-1))) {
    var subscribe = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((ctx) => {
      $m_Lcom_raquo_laminar_DomApi$().aLQ(element.ed(), this);
      return new $c_Lcom_raquo_airstream_ownership_Subscription(ctx.rj, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
        var listenerIndex = $f_Lcom_raquo_laminar_nodes_ReactiveElement__indexOfEventListener__Lcom_raquo_laminar_modifiers_EventListener__I(element, this);
        if ((listenerIndex !== (-1))) {
          $f_Lcom_raquo_laminar_nodes_ReactiveElement__removeEventListener__I__V(element, listenerIndex);
          $m_Lcom_raquo_laminar_DomApi$().aRw(element.ed(), this);
        }
      })));
    }));
    var sub = (unsafePrepend ? $m_Lcom_raquo_laminar_nodes_ReactiveElement$().baH(element, subscribe) : $m_Lcom_raquo_airstream_ownership_DynamicSubscription$().AI(element.kq(), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((owner) => subscribe.i(new $c_Lcom_raquo_laminar_lifecycle_MountContext(element, owner)))), false));
    $f_Lcom_raquo_laminar_nodes_ReactiveElement__addEventListener__Lcom_raquo_laminar_modifiers_EventListener__Z__V(element, this, unsafePrepend);
    return sub;
  } else {
    var activate = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => (void 0)));
    return $m_Lcom_raquo_airstream_ownership_DynamicSubscription$().aSz(element.kq(), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((owner$1) => {
      activate.i(new $c_Lcom_raquo_laminar_lifecycle_MountContext(element, owner$1));
    })), false);
  }
});
$p.m = (function() {
  return (("EventListener(" + this.uo.j1.m8) + ")");
});
var $d_Lcom_raquo_laminar_modifiers_EventListener = new $TypeData().i($c_Lcom_raquo_laminar_modifiers_EventListener, "com.raquo.laminar.modifiers.EventListener", ({
  q4: 1,
  ar: 1,
  d8: 1
}));
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_KeySetter(key, value, action) {
  this.arz = null;
  this.arA = null;
  this.ary = null;
  this.arz = key;
  this.arA = value;
  this.ary = action;
}
$p = $c_Lcom_raquo_laminar_modifiers_KeySetter.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_modifiers_KeySetter;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_KeySetter() {
}
$h_Lcom_raquo_laminar_modifiers_KeySetter.prototype = $p;
$p.kL = (function(element) {
  this.ary.DH(element, this.arz, this.arA);
});
var $d_Lcom_raquo_laminar_modifiers_KeySetter = new $TypeData().i($c_Lcom_raquo_laminar_modifiers_KeySetter, "com.raquo.laminar.modifiers.KeySetter", ({
  q5: 1,
  ar: 1,
  d9: 1
}));
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_KeyUpdater(key, values, update) {
  this.EF = null;
  this.a6E = null;
  this.arB = null;
  this.EF = key;
  this.a6E = values;
  this.arB = update;
}
$p = $c_Lcom_raquo_laminar_modifiers_KeyUpdater.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_modifiers_KeyUpdater;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_KeyUpdater() {
}
$h_Lcom_raquo_laminar_modifiers_KeyUpdater.prototype = $p;
$p.kL = (function(element) {
  this.Wn(element);
});
$p.Wn = (function(element) {
  element.aQF(this.EF);
  var observable = this.a6E;
  var onNext = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((value) => {
    this.arB.DH(element, value, this);
  }));
  return $m_Lcom_raquo_airstream_ownership_DynamicSubscription$().a4O(element.kq(), observable, onNext);
});
var $d_Lcom_raquo_laminar_modifiers_KeyUpdater = new $TypeData().i($c_Lcom_raquo_laminar_modifiers_KeyUpdater, "com.raquo.laminar.modifiers.KeyUpdater", ({
  q6: 1,
  ar: 1,
  d8: 1
}));
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_Setter$$anon$2(fn$2, outer) {
  this.arF = null;
  this.arF = fn$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_raquo_laminar_modifiers_Setter$$anon$2.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_modifiers_Setter$$anon$2;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_Setter$$anon$2() {
}
$h_Lcom_raquo_laminar_modifiers_Setter$$anon$2.prototype = $p;
$p.kL = (function(element) {
  this.arF.i(element);
});
var $d_Lcom_raquo_laminar_modifiers_Setter$$anon$2 = new $TypeData().i($c_Lcom_raquo_laminar_modifiers_Setter$$anon$2, "com.raquo.laminar.modifiers.Setter$$anon$2", ({
  qj: 1,
  ar: 1,
  d9: 1
}));
/** @constructor */
function $c_Lcom_raquo_laminar_nodes_RootNode(container, child) {
  this.a6K = null;
  this.arN = null;
  this.arO = null;
  this.arN = child;
  $f_Lcom_raquo_laminar_nodes_ParentNode__$init$__V(this);
  if ((container === null)) {
    throw $ct_jl_Exception__T__(new $c_jl_Exception(), "Unable to mount Laminar RootNode into a null container. See https://laminar.dev/documentation#waiting-for-the-dom-to-load");
  }
  if ((!$m_Lcom_raquo_laminar_DomApi$().b3h(container, document))) {
    throw $ct_jl_Exception__T__(new $c_jl_Exception(), "Unable to mount Laminar RootNode into an unmounted container. See https://laminar.dev/documentation#rendering");
  }
  this.arO = container;
  this.b4u();
}
$p = $c_Lcom_raquo_laminar_nodes_RootNode.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_nodes_RootNode;
/** @constructor */
function $h_Lcom_raquo_laminar_nodes_RootNode() {
}
$h_Lcom_raquo_laminar_nodes_RootNode.prototype = $p;
$p.kq = (function() {
  return this.a6K;
});
$p.af3 = (function(x$0) {
  this.a6K = x$0;
});
$p.b4u = (function() {
  this.a6K.aLK();
  return $m_Lcom_raquo_laminar_nodes_ParentNode$().DF(this, this.arN, (void 0));
});
$p.ed = (function() {
  return this.arO;
});
var $d_Lcom_raquo_laminar_nodes_RootNode = new $TypeData().i($c_Lcom_raquo_laminar_nodes_RootNode, "com.raquo.laminar.nodes.RootNode", ({
  qp: 1,
  bM: 1,
  da: 1
}));
function $isArrayOf_Lcom_raquo_laminar_tags_CustomHtmlTag(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.qz)));
}
/** @constructor */
function $c_Lfansi_Back$() {
  this.pK = 0;
  this.yz = 0;
  this.yy = null;
  this.AT = null;
  this.AU = false;
  this.QV = 0;
  this.Z5 = 0;
  this.QU = null;
  this.as6 = null;
  this.arS = null;
  this.as5 = null;
  this.arW = null;
  this.as8 = null;
  this.arT = null;
  this.as4 = null;
  this.arU = null;
  this.arZ = null;
  this.arV = null;
  this.as2 = null;
  this.as0 = null;
  this.as3 = null;
  this.arX = null;
  this.as1 = null;
  this.arY = null;
  this.as7 = null;
  this.as9 = null;
  $ct_Lfansi_ColorCategory__I__I__I__Lsourcecode_Name__(this, 28, 25, 48, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Back")));
  $n_Lfansi_Back$ = this;
  this.as6 = this.dV("\u001b[49m", 0, 0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Reset")));
  this.arS = this.dV("\u001b[40m", 1, 0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Black")));
  this.as5 = this.dV("\u001b[41m", 2, 0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Red")));
  this.arW = this.dV("\u001b[42m", 3, 0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Green")));
  this.as8 = this.dV("\u001b[43m", 4, 0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Yellow")));
  this.arT = this.dV("\u001b[44m", 5, 0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Blue")));
  this.as4 = this.dV("\u001b[45m", 6, 0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Magenta")));
  this.arU = this.dV("\u001b[46m", 7, 0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Cyan")));
  this.arZ = this.dV("\u001b[47m", 8, 0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("LightGray")));
  this.arV = this.dV("\u001b[100m", 9, 0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("DarkGray")));
  this.as2 = this.dV("\u001b[101m", 10, 0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("LightRed")));
  this.as0 = this.dV("\u001b[102m", 11, 0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("LightGreen")));
  this.as3 = this.dV("\u001b[103m", 12, 0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("LightYellow")));
  this.arX = this.dV("\u001b[104m", 13, 0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("LightBlue")));
  this.as1 = this.dV("\u001b[105m", 14, 0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("LightMagenta")));
  this.arY = this.dV("\u001b[106m", 15, 0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("LightCyan")));
  this.as7 = this.dV("\u001b[107m", 16, 0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("White")));
  this.as9 = $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lfansi_EscapeAttr.r().C)([this.as6, this.arS, this.as5, this.arW, this.as8, this.arT, this.as4, this.arU, this.arZ, this.arV, this.as2, this.as0, this.as3, this.arX, this.as1, this.arY, this.as7]))).iR(this.QU);
}
$p = $c_Lfansi_Back$.prototype = new $h_Lfansi_ColorCategory();
$p.constructor = $c_Lfansi_Back$;
/** @constructor */
function $h_Lfansi_Back$() {
}
$h_Lfansi_Back$.prototype = $p;
$p.OW = (function() {
  return this.as9;
});
var $d_Lfansi_Back$ = new $TypeData().i($c_Lfansi_Back$, "fansi.Back$", ({
  qG: 1,
  ev: 1,
  by: 1
}));
var $n_Lfansi_Back$;
function $m_Lfansi_Back$() {
  if ((!$n_Lfansi_Back$)) {
    $n_Lfansi_Back$ = new $c_Lfansi_Back$();
  }
  return $n_Lfansi_Back$;
}
/** @constructor */
function $c_Lfansi_Color$() {
  this.pK = 0;
  this.yz = 0;
  this.yy = null;
  this.AT = null;
  this.AU = false;
  this.QV = 0;
  this.Z5 = 0;
  this.QU = null;
  this.aso = null;
  this.asd = null;
  this.asn = null;
  this.Z4 = null;
  this.a6O = null;
  this.ase = null;
  this.a6N = null;
  this.Z3 = null;
  this.asi = null;
  this.asf = null;
  this.asl = null;
  this.asj = null;
  this.asm = null;
  this.asg = null;
  this.ask = null;
  this.ash = null;
  this.asp = null;
  this.asq = null;
  $ct_Lfansi_ColorCategory__I__I__I__Lsourcecode_Name__(this, 3, 25, 38, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Color")));
  $n_Lfansi_Color$ = this;
  this.aso = this.dV("\u001b[39m", 0, 0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Reset")));
  this.asd = this.dV("\u001b[30m", 1, 0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Black")));
  this.asn = this.dV("\u001b[31m", 2, 0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Red")));
  this.Z4 = this.dV("\u001b[32m", 3, 0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Green")));
  this.a6O = this.dV("\u001b[33m", 4, 0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Yellow")));
  this.ase = this.dV("\u001b[34m", 5, 0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Blue")));
  this.a6N = this.dV("\u001b[35m", 6, 0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Magenta")));
  this.Z3 = this.dV("\u001b[36m", 7, 0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("Cyan")));
  this.asi = this.dV("\u001b[37m", 8, 0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("LightGray")));
  this.asf = this.dV("\u001b[90m", 9, 0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("DarkGray")));
  this.asl = this.dV("\u001b[91m", 10, 0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("LightRed")));
  this.asj = this.dV("\u001b[92m", 11, 0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("LightGreen")));
  this.asm = this.dV("\u001b[93m", 12, 0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("LightYellow")));
  this.asg = this.dV("\u001b[94m", 13, 0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("LightBlue")));
  this.ask = this.dV("\u001b[95m", 14, 0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("LightMagenta")));
  this.ash = this.dV("\u001b[96m", 15, 0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("LightCyan")));
  this.asp = this.dV("\u001b[97m", 16, 0, ($m_Lsourcecode_Name$(), new $c_Lsourcecode_Name("White")));
  this.asq = $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lfansi_EscapeAttr.r().C)([this.aso, this.asd, this.asn, this.Z4, this.a6O, this.ase, this.a6N, this.Z3, this.asi, this.asf, this.asl, this.asj, this.asm, this.asg, this.ask, this.ash, this.asp]))).iR(this.QU);
}
$p = $c_Lfansi_Color$.prototype = new $h_Lfansi_ColorCategory();
$p.constructor = $c_Lfansi_Color$;
/** @constructor */
function $h_Lfansi_Color$() {
}
$h_Lfansi_Color$.prototype = $p;
$p.OW = (function() {
  return this.asq;
});
var $d_Lfansi_Color$ = new $TypeData().i($c_Lfansi_Color$, "fansi.Color$", ({
  qI: 1,
  ev: 1,
  by: 1
}));
var $n_Lfansi_Color$;
function $m_Lfansi_Color$() {
  if ((!$n_Lfansi_Color$)) {
    $n_Lfansi_Color$ = new $c_Lfansi_Color$();
  }
  return $n_Lfansi_Color$;
}
/** @constructor */
function $c_Lfastparse_Parsed$TracedFailure$() {
}
$p = $c_Lfastparse_Parsed$TracedFailure$.prototype = new $h_O();
$p.constructor = $c_Lfastparse_Parsed$TracedFailure$;
/** @constructor */
function $h_Lfastparse_Parsed$TracedFailure$() {
}
$h_Lfastparse_Parsed$TracedFailure$.prototype = $p;
$p.b1R = (function(p) {
  if (p.K) {
    $m_sr_Scala3RunTime$().Wl();
  }
  return new $c_Lfastparse_Parsed$TracedFailure(p.K1, p.a0, $m_Lfastparse_Parsed$().aOC(p));
});
var $d_Lfastparse_Parsed$TracedFailure$ = new $TypeData().i($c_Lfastparse_Parsed$TracedFailure$, "fastparse.Parsed$TracedFailure$", ({
  r7: 1,
  d: 1,
  j: 1
}));
var $n_Lfastparse_Parsed$TracedFailure$;
function $m_Lfastparse_Parsed$TracedFailure$() {
  if ((!$n_Lfastparse_Parsed$TracedFailure$)) {
    $n_Lfastparse_Parsed$TracedFailure$ = new $c_Lfastparse_Parsed$TracedFailure$();
  }
  return $n_Lfastparse_Parsed$TracedFailure$;
}
/** @constructor */
function $c_Lfastparse_internal_Msgs$() {
  this.yA = null;
  $n_Lfastparse_internal_Msgs$ = this;
  this.yA = ($m_Lfastparse_internal_Msgs$(), new $c_Lfastparse_internal_Msgs($m_sci_Nil$()));
}
$p = $c_Lfastparse_internal_Msgs$.prototype = new $h_O();
$p.constructor = $c_Lfastparse_internal_Msgs$;
/** @constructor */
function $h_Lfastparse_internal_Msgs$() {
}
$h_Lfastparse_internal_Msgs$.prototype = $p;
$p.bn = (function(msgToSet) {
  $m_Lfastparse_internal_Msgs$();
  return new $c_Lfastparse_internal_Msgs(new $c_sci_$colon$colon(new $c_Lfastparse_internal_Lazy(msgToSet), $m_sci_Nil$()));
});
var $d_Lfastparse_internal_Msgs$ = new $TypeData().i($c_Lfastparse_internal_Msgs$, "fastparse.internal.Msgs$", ({
  rg: 1,
  d: 1,
  j: 1
}));
var $n_Lfastparse_internal_Msgs$;
function $m_Lfastparse_internal_Msgs$() {
  if ((!$n_Lfastparse_internal_Msgs$)) {
    $n_Lfastparse_internal_Msgs$ = new $c_Lfastparse_internal_Msgs$();
  }
  return $n_Lfastparse_internal_Msgs$;
}
function $p_jl_Class__computeCachedSimpleNameBestEffort__T($thiz) {
  if ($thiz.ba.Z) {
    return ($thiz.ba.Q().a3F() + "[]");
  } else {
    var name = $thiz.ba.N;
    var idx = ((name.length - 1) | 0);
    while (((idx >= 0) && (name.charCodeAt(idx) === 36))) {
      idx = ((idx - 1) | 0);
    }
    if (((idx >= 0) && ((((name.charCodeAt(idx) - 48) | 0) >>> 0) <= 9))) {
      idx = ((idx - 1) | 0);
      while (((idx >= 0) && ((((name.charCodeAt(idx) - 48) | 0) >>> 0) <= 9))) {
        idx = ((idx - 1) | 0);
      }
      while (((idx >= 0) && (name.charCodeAt(idx) === 36))) {
        idx = ((idx - 1) | 0);
      }
    }
    while (true) {
      if ((idx >= 0)) {
        var index$4 = idx;
        var currChar = name.charCodeAt(index$4);
        var $x_1 = ((currChar !== 36) && (currChar !== 46));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        idx = ((idx - 1) | 0);
      } else {
        break;
      }
    }
    var beginIndex = ((1 + idx) | 0);
    return name.substring(beginIndex);
  }
}
/** @constructor */
function $c_jl_Class($data) {
  this.a6Y = null;
  this.ba = $data;
}
$p = $c_jl_Class.prototype = new $h_O();
$p.constructor = $c_jl_Class;
/** @constructor */
function $h_jl_Class() {
}
$h_jl_Class.prototype = $p;
$p.m = (function() {
  return ((this.ba.Y ? "interface " : (this.ba.X ? "" : "class ")) + this.ba.N);
});
$p.a3F = (function() {
  if ((this.a6Y === null)) {
    this.a6Y = $p_jl_Class__computeCachedSimpleNameBestEffort__T(this);
  }
  return this.a6Y;
});
var $d_jl_Class = new $TypeData().i($c_jl_Class, "java.lang.Class", ({
  rZ: 1,
  a: 1,
  aY: 1
}));
function $ct_jl_Enum__T__I__($thiz, _name, _ordinal) {
  $thiz.up = _name;
  $thiz.k6 = _ordinal;
  return $thiz;
}
/** @constructor */
function $c_jl_Enum() {
  this.up = null;
  this.k6 = 0;
}
$p = $c_jl_Enum.prototype = new $h_O();
$p.constructor = $c_jl_Enum;
/** @constructor */
function $h_jl_Enum() {
}
$h_jl_Enum.prototype = $p;
$p.m = (function() {
  return this.up;
});
$p.e = (function(that) {
  return (this === that);
});
$p.x = (function() {
  return $systemIdentityHashCode(this);
});
$p.aYO = (function(o) {
  var x = this.k6;
  var y = o.k6;
  return ((x === y) ? 0 : ((x < y) ? (-1) : 1));
});
$p.pp = (function(o) {
  return this.aYO(o);
});
function $ct_jl_Error__jl_Throwable__($thiz, e) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, ((e === null) ? null : e.m()), e, true, true);
  return $thiz;
}
class $c_jl_Error extends $c_jl_Throwable {
}
function $isArrayOf_jl_Error(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bO)));
}
function $ct_jl_Exception__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
class $c_jl_Exception extends $c_jl_Throwable {
}
function $isArrayOf_jl_Exception(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.G)));
}
var $d_jl_Exception = new $TypeData().i($c_jl_Exception, "java.lang.Exception", ({
  G: 1,
  y: 1,
  a: 1
}));
function $ct_Ljava_nio_ByteBuffer__I__AB__I__($thiz, _capacity, _array, _arrayOffset) {
  $thiz.m9 = _array;
  $thiz.nL = _arrayOffset;
  $ct_Ljava_nio_Buffer__I__($thiz, _capacity);
  return $thiz;
}
/** @constructor */
function $c_Ljava_nio_ByteBuffer() {
  this.nK = 0;
  this.c2 = 0;
  this.b3 = 0;
  this.ur = 0;
  this.m9 = null;
  this.nL = 0;
}
$p = $c_Ljava_nio_ByteBuffer.prototype = new $h_Ljava_nio_Buffer();
$p.constructor = $c_Ljava_nio_ByteBuffer;
/** @constructor */
function $h_Ljava_nio_ByteBuffer() {
}
$h_Ljava_nio_ByteBuffer.prototype = $p;
$p.b71 = (function(src) {
  if ((src === this)) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  }
  if (this.wt) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var srcLimit = src.c2;
  var srcPos = src.b3;
  var length = ((srcLimit - srcPos) | 0);
  var p = this.b3;
  var newPos = ((p + length) | 0);
  if ((newPos > this.c2)) {
    throw new $c_Ljava_nio_BufferOverflowException();
  }
  this.b3 = newPos;
  var selfPos = p;
  $c_Ljava_nio_Buffer.prototype.cX.call(src, srcLimit);
  var srcArray = src.m9;
  if ((srcArray !== null)) {
    var startIndex = selfPos;
    var offset = ((src.nL + srcPos) | 0);
    var x2 = this.m9;
    var x3 = ((this.nL + startIndex) | 0);
    srcArray.av(offset, x2, x3, length);
  } else {
    while ((srcPos !== srcLimit)) {
      var index$1 = selfPos;
      var index = srcPos;
      var a = src.m9;
      var i = ((src.nL + index) | 0);
      var elem = a.a[i];
      var a$1 = this.m9;
      var i$1 = ((this.nL + index$1) | 0);
      a$1.a[i$1] = elem;
      srcPos = ((1 + srcPos) | 0);
      selfPos = ((1 + selfPos) | 0);
    }
  }
  return this;
});
$p.x = (function() {
  var start = this.b3;
  var end = this.c2;
  var h = (-547316498);
  var i = start;
  while ((i !== end)) {
    var $x_2 = $m_ju_internal_MurmurHash3$();
    var $x_1 = h;
    var index = i;
    var a = this.m9;
    var i$1 = ((this.nL + index) | 0);
    h = $x_2.k($x_1, a.a[i$1]);
    i = ((1 + i) | 0);
  }
  return $m_ju_internal_MurmurHash3$().Z(h, ((end - start) | 0));
});
$p.e = (function(that) {
  return ((that instanceof $c_Ljava_nio_ByteBuffer) && (this.aMR(that) === 0));
});
$p.aMR = (function(that) {
  if ((this === that)) {
    return 0;
  } else {
    var thisStart = this.b3;
    var thisRemaining = ((this.c2 - thisStart) | 0);
    var thatStart = that.b3;
    var thatRemaining = ((that.c2 - thatStart) | 0);
    var shortestLength = ((thisRemaining < thatRemaining) ? thisRemaining : thatRemaining);
    var i = 0;
    while ((i !== shortestLength)) {
      var index = ((thisStart + i) | 0);
      var a = this.m9;
      var i$1 = ((this.nL + index) | 0);
      var t = a.a[i$1];
      var index$1 = ((thatStart + i) | 0);
      var a$1 = that.m9;
      var i$2 = ((that.nL + index$1) | 0);
      var u = a$1.a[i$2];
      var cmp = ((t - u) | 0);
      if ((cmp !== 0)) {
        return cmp;
      }
      i = ((1 + i) | 0);
    }
    return ((thisRemaining === thatRemaining) ? 0 : ((thisRemaining < thatRemaining) ? (-1) : 1));
  }
});
$p.pp = (function(o) {
  return this.aMR(o);
});
function $isArrayOf_Ljava_nio_ByteBuffer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.f6)));
}
/** @constructor */
function $c_Ljava_nio_charset_UTF\uff3f8$() {
  this.Zk = null;
  this.Zl = null;
  this.B3 = null;
  this.yF = 0;
  this.a7n = null;
  $ct_Ljava_nio_charset_Charset__T__AT__(this, "UTF-8", new ($d_T.r().C)(["UTF8", "unicode-1-1-utf-8"]));
  $n_Ljava_nio_charset_UTF\uff3f8$ = this;
  this.a7n = $constArrSVals_I(128, "||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||________________________________````````````````aaaaaaaa||||||||");
}
$p = $c_Ljava_nio_charset_UTF\uff3f8$.prototype = new $h_Ljava_nio_charset_Charset();
$p.constructor = $c_Ljava_nio_charset_UTF\uff3f8$;
/** @constructor */
function $h_Ljava_nio_charset_UTF\uff3f8$() {
}
$h_Ljava_nio_charset_UTF\uff3f8$.prototype = $p;
var $d_Ljava_nio_charset_UTF\uff3f8$ = new $TypeData().i($c_Ljava_nio_charset_UTF\uff3f8$, "java.nio.charset.UTF_8$", ({
  sQ: 1,
  f8: 1,
  Q: 1
}));
var $n_Ljava_nio_charset_UTF\uff3f8$;
function $m_Ljava_nio_charset_UTF\uff3f8$() {
  if ((!$n_Ljava_nio_charset_UTF\uff3f8$)) {
    $n_Ljava_nio_charset_UTF\uff3f8$ = new $c_Ljava_nio_charset_UTF\uff3f8$();
  }
  return $n_Ljava_nio_charset_UTF\uff3f8$;
}
/** @constructor */
function $c_ju_AbstractCollection() {
}
$p = $c_ju_AbstractCollection.prototype = new $h_O();
$p.constructor = $c_ju_AbstractCollection;
/** @constructor */
function $h_ju_AbstractCollection() {
}
$h_ju_AbstractCollection.prototype = $p;
$p.E = (function(o) {
  var _\uff3fself = this.r4();
  while (_\uff3fself.p()) {
    var t = _\uff3fself.q();
    if (((o === null) ? (t === null) : $dp_equals__O__Z(o, t))) {
      return true;
    }
  }
  return false;
});
$p.aZ2 = (function(c) {
  var _\uff3fself = c.r4();
  _return: {
    while (_\uff3fself.p()) {
      if ((!this.E(_\uff3fself.q()))) {
        var $x_1 = true;
        break _return;
      }
    }
    var $x_1 = false;
  }
  return (!$x_1);
});
$p.m = (function() {
  var _\uff3fself = this.r4();
  var result = "[";
  var first = true;
  while (_\uff3fself.p()) {
    if (first) {
      first = false;
    } else {
      result = (result + ", ");
    }
    result = (("" + result) + _\uff3fself.q());
  }
  return (result + "]");
});
/** @constructor */
function $c_ju_Collections$UnmodifiableIterator(inner) {
  this.a7q = null;
  this.a7q = inner;
}
$p = $c_ju_Collections$UnmodifiableIterator.prototype = new $h_O();
$p.constructor = $c_ju_Collections$UnmodifiableIterator;
/** @constructor */
function $h_ju_Collections$UnmodifiableIterator() {
}
$h_ju_Collections$UnmodifiableIterator.prototype = $p;
$p.p = (function() {
  return this.a7q.p();
});
$p.q = (function() {
  return this.a7q.q();
});
var $d_ju_Collections$UnmodifiableIterator = new $TypeData().i($c_ju_Collections$UnmodifiableIterator, "java.util.Collections$UnmodifiableIterator", ({
  t1: 1,
  t5: 1,
  cm: 1
}));
/** @constructor */
function $c_ju_LinkedHashMap$KeyIterator(outer) {
  this.Kc = null;
  $ct_ju_LinkedHashMap$AbstractLinkedHashMapIterator__ju_LinkedHashMap__(this, outer);
}
$p = $c_ju_LinkedHashMap$KeyIterator.prototype = new $h_ju_LinkedHashMap$AbstractLinkedHashMapIterator();
$p.constructor = $c_ju_LinkedHashMap$KeyIterator;
/** @constructor */
function $h_ju_LinkedHashMap$KeyIterator() {
}
$h_ju_LinkedHashMap$KeyIterator.prototype = $p;
$p.aNW = (function(node) {
  return node.rl;
});
var $d_ju_LinkedHashMap$KeyIterator = new $TypeData().i($c_ju_LinkedHashMap$KeyIterator, "java.util.LinkedHashMap$KeyIterator", ({
  tq: 1,
  fc: 1,
  cm: 1
}));
/** @constructor */
function $c_ju_LinkedHashMap$Node(key, hash, value, previous, next, older, younger) {
  this.rl = null;
  this.B9 = 0;
  this.nO = null;
  this.ET = null;
  this.rm = null;
  this.Zw = null;
  this.EU = null;
  this.Zw = older;
  this.EU = younger;
  $ct_ju_HashMap$Node__O__I__O__ju_HashMap$Node__ju_HashMap$Node__(this, key, hash, value, previous, next);
}
$p = $c_ju_LinkedHashMap$Node.prototype = new $h_ju_HashMap$Node();
$p.constructor = $c_ju_LinkedHashMap$Node;
/** @constructor */
function $h_ju_LinkedHashMap$Node() {
}
$h_ju_LinkedHashMap$Node.prototype = $p;
var $d_ju_LinkedHashMap$Node = new $TypeData().i($c_ju_LinkedHashMap$Node, "java.util.LinkedHashMap$Node", ({
  tr: 1,
  fb: 1,
  co: 1
}));
/** @constructor */
function $c_ju_LinkedHashMap$NodeIterator(outer) {
  this.Kc = null;
  $ct_ju_LinkedHashMap$AbstractLinkedHashMapIterator__ju_LinkedHashMap__(this, outer);
}
$p = $c_ju_LinkedHashMap$NodeIterator.prototype = new $h_ju_LinkedHashMap$AbstractLinkedHashMapIterator();
$p.constructor = $c_ju_LinkedHashMap$NodeIterator;
/** @constructor */
function $h_ju_LinkedHashMap$NodeIterator() {
}
$h_ju_LinkedHashMap$NodeIterator.prototype = $p;
$p.aNW = (function(node) {
  return node;
});
var $d_ju_LinkedHashMap$NodeIterator = new $TypeData().i($c_ju_LinkedHashMap$NodeIterator, "java.util.LinkedHashMap$NodeIterator", ({
  ts: 1,
  fc: 1,
  cm: 1
}));
/** @constructor */
function $c_ju_UUID(mostSigBits_$_lo, mostSigBits_$_hi, leastSigBits_$_lo, leastSigBits_$_hi) {
  this.In = 0;
  this.Io = 0;
  this.Il = 0;
  this.Im = 0;
  this.In = mostSigBits_$_lo;
  this.Io = mostSigBits_$_hi;
  this.Il = leastSigBits_$_lo;
  this.Im = leastSigBits_$_hi;
}
$p = $c_ju_UUID.prototype = new $h_O();
$p.constructor = $c_ju_UUID;
/** @constructor */
function $h_ju_UUID() {
}
$h_ju_UUID.prototype = $p;
$p.m = (function() {
  var mostSigBits_$_lo = this.In;
  var mostSigBits_$_hi = this.Io;
  var leastSigBits_$_lo = this.Il;
  var leastSigBits_$_hi = this.Im;
  var s = (mostSigBits_$_hi >>> 0.0).toString(16);
  var beginIndex = s.length;
  var $x_5 = "00000000".substring(beginIndex);
  var i = (65535 & (((mostSigBits_$_lo >>> 16) | 0) | (mostSigBits_$_hi << 16)));
  var s$1 = (i >>> 0.0).toString(16);
  var beginIndex$1 = s$1.length;
  var $x_4 = "0000".substring(beginIndex$1);
  var i$1 = (65535 & mostSigBits_$_lo);
  var s$2 = (i$1 >>> 0.0).toString(16);
  var beginIndex$2 = s$2.length;
  var $x_3 = "0000".substring(beginIndex$2);
  var i$2 = (65535 & ((leastSigBits_$_hi >>> 16) | 0));
  var s$3 = (i$2 >>> 0.0).toString(16);
  var beginIndex$3 = s$3.length;
  var $x_2 = "0000".substring(beginIndex$3);
  var i$3 = (65535 & leastSigBits_$_hi);
  var s$4 = (i$3 >>> 0.0).toString(16);
  var beginIndex$4 = s$4.length;
  var $x_1 = "0000".substring(beginIndex$4);
  var s$5 = (leastSigBits_$_lo >>> 0.0).toString(16);
  var beginIndex$5 = s$5.length;
  return ((((((((((("" + $x_5) + s) + "-") + (("" + $x_4) + s$1)) + "-") + (("" + $x_3) + s$2)) + "-") + (("" + $x_2) + s$3)) + "-") + (("" + $x_1) + s$4)) + (("" + "00000000".substring(beginIndex$5)) + s$5));
});
$p.x = (function() {
  var value_$_lo = this.In;
  var value_$_hi = this.Io;
  var value$1_$_lo = this.Il;
  var value$1_$_hi = this.Im;
  return ((value_$_lo ^ value_$_hi) ^ (value$1_$_lo ^ value$1_$_hi));
});
$p.e = (function(that) {
  if ((that instanceof $c_ju_UUID)) {
    var x_$_lo = this.In;
    var x_$_hi = this.Io;
    var $x_1 = that;
    var x$1_$_lo = $x_1.In;
    var x$1_$_hi = $x_1.Io;
    if ((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0)) {
      var x$2_$_lo = this.Il;
      var x$2_$_hi = this.Im;
      var $x_2 = that;
      var x$3_$_lo = $x_2.Il;
      var x$3_$_hi = $x_2.Im;
      return (((x$2_$_lo ^ x$3_$_lo) | (x$2_$_hi ^ x$3_$_hi)) === 0);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.aYP = (function(that) {
  var thisHi_$_lo = this.In;
  var thisHi_$_hi = this.Io;
  var $x_1 = that;
  var thatHi_$_lo = $x_1.In;
  var thatHi_$_hi = $x_1.Io;
  if ((((thisHi_$_lo ^ thatHi_$_lo) | (thisHi_$_hi ^ thatHi_$_hi)) !== 0)) {
    return (((thisHi_$_hi === thatHi_$_hi) ? ((thisHi_$_lo >>> 0) < (thatHi_$_lo >>> 0)) : (thisHi_$_hi < thatHi_$_hi)) ? (-1) : 1);
  } else {
    var thisLo_$_lo = this.Il;
    var thisLo_$_hi = this.Im;
    var $x_2 = that;
    var thatLo_$_lo = $x_2.Il;
    var thatLo_$_hi = $x_2.Im;
    return ((((thisLo_$_lo ^ thatLo_$_lo) | (thisLo_$_hi ^ thatLo_$_hi)) !== 0) ? (((thisLo_$_hi === thatLo_$_hi) ? ((thisLo_$_lo >>> 0) < (thatLo_$_lo >>> 0)) : (thisLo_$_hi < thatLo_$_hi)) ? (-1) : 1) : 0);
  }
});
$p.pp = (function(o) {
  return this.aYP(o);
});
function $isArrayOf_ju_UUID(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fd)));
}
var $d_ju_UUID = new $TypeData().i($c_ju_UUID, "java.util.UUID", ({
  fd: 1,
  a: 1,
  Q: 1
}));
/** @constructor */
function $c_ju_concurrent_atomic_AtomicInteger(value) {
  this.Zy = 0;
  this.Zy = value;
}
$p = $c_ju_concurrent_atomic_AtomicInteger.prototype = new $h_jl_Number();
$p.constructor = $c_ju_concurrent_atomic_AtomicInteger;
/** @constructor */
function $h_ju_concurrent_atomic_AtomicInteger() {
}
$h_ju_concurrent_atomic_AtomicInteger.prototype = $p;
$p.m = (function() {
  return ("" + this.Zy);
});
var $d_ju_concurrent_atomic_AtomicInteger = new $TypeData().i($c_ju_concurrent_atomic_AtomicInteger, "java.util.concurrent.atomic.AtomicInteger", ({
  tH: 1,
  aP: 1,
  a: 1
}));
function $s_Lorg_jpablo_graphexplorer_graphviz_Format$__DotJson__Lorg_jpablo_graphexplorer_graphviz_Format() {
  $m_Lorg_jpablo_graphexplorer_graphviz_Format$();
  return $t_Lorg_jpablo_graphexplorer_graphviz_Format$__DotJson;
}
function $s_Lorg_jpablo_graphexplorer_graphviz_Format$__Json0__Lorg_jpablo_graphexplorer_graphviz_Format() {
  $m_Lorg_jpablo_graphexplorer_graphviz_Format$();
  return $t_Lorg_jpablo_graphexplorer_graphviz_Format$__Json0;
}
function $s_Lorg_jpablo_graphexplorer_graphviz_Format$__Svg__Lorg_jpablo_graphexplorer_graphviz_Format() {
  $m_Lorg_jpablo_graphexplorer_graphviz_Format$();
  return $t_Lorg_jpablo_graphexplorer_graphviz_Format$__Svg;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_Format$() {
  this.atX = null;
  this.aTN = null;
  $n_Lorg_jpablo_graphexplorer_graphviz_Format$ = this;
  $t_Lorg_jpablo_graphexplorer_graphviz_Format$__DotJson = new $c_Lorg_jpablo_graphexplorer_graphviz_Format$$anon$1();
  $t_Lorg_jpablo_graphexplorer_graphviz_Format$__Json0 = new $c_Lorg_jpablo_graphexplorer_graphviz_Format$$anon$2();
  $t_Lorg_jpablo_graphexplorer_graphviz_Format$__Svg = new $c_Lorg_jpablo_graphexplorer_graphviz_Format$$anon$3();
  this.atX = new ($d_Lorg_jpablo_graphexplorer_graphviz_Format.r().C)([$s_Lorg_jpablo_graphexplorer_graphviz_Format$__DotJson__Lorg_jpablo_graphexplorer_graphviz_Format(), $s_Lorg_jpablo_graphexplorer_graphviz_Format$__Json0__Lorg_jpablo_graphexplorer_graphviz_Format(), $s_Lorg_jpablo_graphexplorer_graphviz_Format$__Svg__Lorg_jpablo_graphexplorer_graphviz_Format()]);
  this.aTN = $m_sci_Set$().af(new $c_sc_Iterator$$anon$9($m_sc_ArrayOps$().u8(this.aTg()), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => _$2.Kf))));
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_Format$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_Format$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_Format$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_Format$.prototype = $p;
$p.aTg = (function() {
  return this.atX.ae();
});
$p.b1P = (function(s) {
  var xs = this.aTg();
  _return: {
    var i = 0;
    while ((i < xs.a.length)) {
      var x1 = i;
      if ((xs.a[x1].Kf === s)) {
        var idx = i;
        break _return;
      }
      i = ((1 + i) | 0);
    }
    var idx = (-1);
  }
  return ((idx === (-1)) ? $m_s_None$() : new $c_s_Some(xs.a[idx]));
});
var $d_Lorg_jpablo_graphexplorer_graphviz_Format$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_Format$, "org.jpablo.graphexplorer.graphviz.Format$", ({
  u8: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_graphviz_Format$;
function $m_Lorg_jpablo_graphexplorer_graphviz_Format$() {
  if ((!$n_Lorg_jpablo_graphexplorer_graphviz_Format$)) {
    $n_Lorg_jpablo_graphexplorer_graphviz_Format$ = new $c_Lorg_jpablo_graphexplorer_graphviz_Format$();
  }
  return $n_Lorg_jpablo_graphexplorer_graphviz_Format$;
}
function $s_Lorg_jpablo_graphexplorer_graphviz_RenderStatus$__Success__Lorg_jpablo_graphexplorer_graphviz_RenderStatus() {
  $m_Lorg_jpablo_graphexplorer_graphviz_RenderStatus$();
  return $t_Lorg_jpablo_graphexplorer_graphviz_RenderStatus$__Success;
}
function $s_Lorg_jpablo_graphexplorer_graphviz_RenderStatus$__Failure__Lorg_jpablo_graphexplorer_graphviz_RenderStatus() {
  $m_Lorg_jpablo_graphexplorer_graphviz_RenderStatus$();
  return $t_Lorg_jpablo_graphexplorer_graphviz_RenderStatus$__Failure;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_RenderStatus$() {
  $n_Lorg_jpablo_graphexplorer_graphviz_RenderStatus$ = this;
  $t_Lorg_jpablo_graphexplorer_graphviz_RenderStatus$__Success = new $c_Lorg_jpablo_graphexplorer_graphviz_RenderStatus$$anon$4();
  $t_Lorg_jpablo_graphexplorer_graphviz_RenderStatus$__Failure = new $c_Lorg_jpablo_graphexplorer_graphviz_RenderStatus$$anon$5();
  $s_Lorg_jpablo_graphexplorer_graphviz_RenderStatus$__Success__Lorg_jpablo_graphexplorer_graphviz_RenderStatus();
  $s_Lorg_jpablo_graphexplorer_graphviz_RenderStatus$__Failure__Lorg_jpablo_graphexplorer_graphviz_RenderStatus();
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_RenderStatus$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_RenderStatus$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_RenderStatus$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_RenderStatus$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_graphviz_RenderStatus$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_RenderStatus$, "org.jpablo.graphexplorer.graphviz.RenderStatus$", ({
  uf: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_graphviz_RenderStatus$;
function $m_Lorg_jpablo_graphexplorer_graphviz_RenderStatus$() {
  if ((!$n_Lorg_jpablo_graphexplorer_graphviz_RenderStatus$)) {
    $n_Lorg_jpablo_graphexplorer_graphviz_RenderStatus$ = new $c_Lorg_jpablo_graphexplorer_graphviz_RenderStatus$();
  }
  return $n_Lorg_jpablo_graphexplorer_graphviz_RenderStatus$;
}
function $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$__Graph__Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget() {
  $m_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$();
  return $t_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$__Graph;
}
function $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$__Node__Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget() {
  $m_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$();
  return $t_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$__Node;
}
function $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$__Edge__Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget() {
  $m_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$();
  return $t_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$__Edge;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$() {
  $n_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$ = this;
  $t_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$__Graph = new $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$$anon$2("Graph", 0);
  $t_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$__Node = new $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$$anon$2("Node", 1);
  $t_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$__Edge = new $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$$anon$2("Edge", 2);
  $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$__Graph__Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget();
  $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$__Node__Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget();
  $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$__Edge__Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget();
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$, "org.jpablo.graphexplorer.graphviz.dotlang.AttrTarget$", ({
  uj: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$;
function $m_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$() {
  if ((!$n_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$)) {
    $n_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$ = new $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$();
  }
  return $n_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$;
}
function $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__N__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass() {
  $m_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$();
  return $t_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__N;
}
function $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__NE__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass() {
  $m_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$();
  return $t_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__NE;
}
function $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__E__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass() {
  $m_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$();
  return $t_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__E;
}
function $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__SE__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass() {
  $m_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$();
  return $t_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__SE;
}
function $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__S__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass() {
  $m_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$();
  return $t_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__S;
}
function $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__SW__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass() {
  $m_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$();
  return $t_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__SW;
}
function $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__W__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass() {
  $m_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$();
  return $t_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__W;
}
function $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__NW__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass() {
  $m_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$();
  return $t_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__NW;
}
function $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__C__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass() {
  $m_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$();
  return $t_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__C;
}
function $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__Underscore__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass() {
  $m_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$();
  return $t_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__Underscore;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$() {
  $n_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$ = this;
  $t_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__N = new $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$$anon$1("N", 0);
  $t_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__NE = new $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$$anon$1("NE", 1);
  $t_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__E = new $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$$anon$1("E", 2);
  $t_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__SE = new $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$$anon$1("SE", 3);
  $t_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__S = new $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$$anon$1("S", 4);
  $t_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__SW = new $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$$anon$1("SW", 5);
  $t_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__W = new $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$$anon$1("W", 6);
  $t_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__NW = new $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$$anon$1("NW", 7);
  $t_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__C = new $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$$anon$1("C", 8);
  $t_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__Underscore = new $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$$anon$1("Underscore", 9);
  $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__N__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass();
  $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__NE__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass();
  $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__E__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass();
  $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__SE__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass();
  $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__S__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass();
  $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__SW__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass();
  $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__W__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass();
  $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__NW__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass();
  $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__C__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass();
  $s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__Underscore__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass();
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$.prototype = $p;
$p.Pm = (function(s) {
  switch (s) {
    case "n": {
      return new $c_s_Some($s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__N__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass());
      break;
    }
    case "ne": {
      return new $c_s_Some($s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__NE__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass());
      break;
    }
    case "e": {
      return new $c_s_Some($s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__E__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass());
      break;
    }
    case "se": {
      return new $c_s_Some($s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__SE__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass());
      break;
    }
    case "s": {
      return new $c_s_Some($s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__S__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass());
      break;
    }
    case "sw": {
      return new $c_s_Some($s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__SW__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass());
      break;
    }
    case "w": {
      return new $c_s_Some($s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__W__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass());
      break;
    }
    case "nw": {
      return new $c_s_Some($s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__NW__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass());
      break;
    }
    case "c": {
      return new $c_s_Some($s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__C__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass());
      break;
    }
    case "_": {
      return new $c_s_Some($s_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__Underscore__Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass());
      break;
    }
    default: {
      return $m_s_None$();
    }
  }
});
var $d_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$, "org.jpablo.graphexplorer.graphviz.dotlang.Compass$", ({
  ul: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$;
function $m_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$() {
  if ((!$n_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$)) {
    $n_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$ = new $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$();
  }
  return $n_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$;
}
function $s_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$__Left__Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign() {
  $m_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$();
  return $t_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$__Left;
}
function $s_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$__Center__Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign() {
  $m_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$();
  return $t_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$__Center;
}
function $s_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$__Right__Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign() {
  $m_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$();
  return $t_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$__Right;
}
function $s_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$__Text___Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign() {
  $m_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$();
  return $t_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$__Text_;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$() {
  $n_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$ = this;
  $t_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$__Left = new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$$anon$1("Left", 0);
  $t_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$__Center = new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$$anon$1("Center", 1);
  $t_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$__Right = new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$$anon$1("Right", 2);
  $t_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$__Text_ = new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$$anon$1("Text_", 3);
  $s_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$__Left__Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign();
  $s_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$__Center__Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign();
  $s_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$__Right__Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign();
  $s_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$__Text___Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign();
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$, "org.jpablo.graphexplorer.graphviz.html.HtmlAlign$", ({
  ur: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$;
function $m_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$() {
  if ((!$n_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$)) {
    $n_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$ = new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$();
  }
  return $n_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$Info$3$() {
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$Info$3$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$Info$3$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$Info$3$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$Info$3$.prototype = $p;
$p.m = (function() {
  return "Info";
});
var $d_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$Info$3$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$Info$3$, "org.jpablo.graphexplorer.graphviz.html.HtmlTableLayout$Info$3$", ({
  uA: 1,
  d: 1,
  j: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_html_ImageDim$() {
  this.Rv = null;
  $n_Lorg_jpablo_graphexplorer_graphviz_html_ImageDim$ = this;
  this.Rv = $m_sci_Map$EmptyMap$();
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_html_ImageDim$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_html_ImageDim$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_html_ImageDim$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_html_ImageDim$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_graphviz_html_ImageDim$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_html_ImageDim$, "org.jpablo.graphexplorer.graphviz.html.ImageDim$", ({
  uB: 1,
  d: 1,
  j: 1
}));
var $n_Lorg_jpablo_graphexplorer_graphviz_html_ImageDim$;
function $m_Lorg_jpablo_graphexplorer_graphviz_html_ImageDim$() {
  if ((!$n_Lorg_jpablo_graphexplorer_graphviz_html_ImageDim$)) {
    $n_Lorg_jpablo_graphexplorer_graphviz_html_ImageDim$ = new $c_Lorg_jpablo_graphexplorer_graphviz_html_ImageDim$();
  }
  return $n_Lorg_jpablo_graphexplorer_graphviz_html_ImageDim$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$() {
  this.auc = null;
  this.aud = false;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$.prototype = $p;
$p.b1O = (function(s) {
  if ((!(!s.startsWith("__v")))) {
    var rest = $m_sc_StringOps$().kp(s, 3);
    var sep = $f_T__indexOf__I__I(rest, 95);
    if ((sep > 0)) {
      var _1 = $m_sc_StringParsers$().hT(rest.substring(0, sep));
      var $x_1 = $m_sc_StringParsers$();
      var beginIndex = ((1 + sep) | 0);
      var _2 = $x_1.hT(rest.substring(beginIndex));
      if ((_1 instanceof $c_s_Some)) {
        var e = (_1.J | 0);
        if ((_2 instanceof $c_s_Some)) {
          return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Virtual(e, (_2.J | 0));
        }
      }
      return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real(s);
    } else {
      return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real(s);
    }
  } else if ((!(!s.startsWith("__fl")))) {
    var this$16 = $m_sc_StringParsers$().hT($m_sc_StringOps$().kp(s, 4));
    var this$18 = (this$16.c() ? $m_s_None$() : new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$FlatLabel((this$16.d() | 0))));
    return (this$18.c() ? new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real(s) : this$18.d());
  } else if ((!(!s.startsWith("__cln")))) {
    var this$23 = $m_sc_StringParsers$().hT($m_sc_StringOps$().kp(s, 5));
    var this$25 = (this$23.c() ? $m_s_None$() : new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ClusterLn((this$23.d() | 0))));
    return (this$25.c() ? new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real(s) : this$25.d());
  } else if ((!(!s.startsWith("__crn")))) {
    var this$30 = $m_sc_StringParsers$().hT($m_sc_StringOps$().kp(s, 5));
    var this$32 = (this$30.c() ? $m_s_None$() : new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ClusterRn((this$30.d() | 0))));
    return (this$32.c() ? new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real(s) : this$32.d());
  } else if ((!(!s.startsWith("__s")))) {
    var this$37 = $m_sc_StringParsers$().hT($m_sc_StringOps$().kp(s, 3));
    var this$39 = (this$37.c() ? $m_s_None$() : new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Slack((this$37.d() | 0))));
    return (this$39.c() ? new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real(s) : this$39.d());
  } else {
    return new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real(s);
  }
});
$p.nx = (function() {
  if ((!this.aud)) {
    this.auc = $m_s_CanEqual$derived$();
    this.aud = true;
  }
  return this.auc;
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$, "org.jpablo.graphexplorer.graphviz.layout.LayoutNode$", ({
  uL: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$;
function $m_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$() {
  if ((!$n_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$)) {
    $n_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$();
  }
  return $n_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$;
}
function $s_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$__None__Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance() {
  $m_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$();
  return $t_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$__None;
}
function $s_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$__TopBottom__Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance() {
  $m_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$();
  return $t_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$__TopBottom;
}
function $s_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$__LeftRight__Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance() {
  $m_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$();
  return $t_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$__LeftRight;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$() {
  $n_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$ = this;
  $t_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$__None = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$$anon$1();
  $t_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$__TopBottom = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$$anon$2();
  $t_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$__LeftRight = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$$anon$3();
  $s_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$__None__Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance();
  $s_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$__TopBottom__Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance();
  $s_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$__LeftRight__Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance();
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$, "org.jpablo.graphexplorer.graphviz.layout.NSBalance$", ({
  uN: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$;
function $m_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$() {
  if ((!$n_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$)) {
    $n_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$ = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$();
  }
  return $n_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$;
}
function $s_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$__Ordinary__Lorg_jpablo_graphexplorer_graphviz_layout_NSClass() {
  $m_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$();
  return $t_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$__Ordinary;
}
function $s_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$__Singleton__Lorg_jpablo_graphexplorer_graphviz_layout_NSClass() {
  $m_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$();
  return $t_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$__Singleton;
}
function $s_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$__Virtual__Lorg_jpablo_graphexplorer_graphviz_layout_NSClass() {
  $m_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$();
  return $t_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$__Virtual;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$() {
  this.aue = null;
  $n_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$ = this;
  $t_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$__Ordinary = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$$anon$1();
  $t_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$__Singleton = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$$anon$2();
  $t_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$__Virtual = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$$anon$3();
  $s_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$__Ordinary__Lorg_jpablo_graphexplorer_graphviz_layout_NSClass();
  $s_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$__Singleton__Lorg_jpablo_graphexplorer_graphviz_layout_NSClass();
  $s_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$__Virtual__Lorg_jpablo_graphexplorer_graphviz_layout_NSClass();
  var xs = $m_sr_ScalaRunTime$().f(new ($d_I.r().r().C)([new $ac_I(new Int32Array([1, 1, 1])), new $ac_I(new Int32Array([1, 2, 2])), new $ac_I(new Int32Array([1, 2, 4]))]));
  var array = new ($d_I.r().r().C)(xs.C());
  var iterator = xs.o();
  var i = 0;
  while (iterator.p()) {
    array.a[i] = iterator.q();
    i = ((1 + i) | 0);
  }
  this.aue = array;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$, "org.jpablo.graphexplorer.graphviz.layout.NSClass$", ({
  uR: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$;
function $m_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$() {
  if ((!$n_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$)) {
    $n_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$ = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$();
  }
  return $n_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$() {
  this.auk = null;
  this.aul = false;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$.prototype = $p;
$p.nx = (function() {
  if ((!this.aul)) {
    this.auk = $m_s_CanEqual$derived$();
    this.aul = true;
  }
  return this.auk;
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$, "org.jpablo.graphexplorer.graphviz.layout.Order$CNode$", ({
  v4: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$;
function $m_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$() {
  if ((!$n_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$)) {
    $n_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$ = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$();
  }
  return $n_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts$() {
  this.Fk = null;
  $n_Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts$ = this;
  this.Fk = ($m_Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts$(), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts(0.0, 0, 0.0, 0));
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts$, "org.jpablo.graphexplorer.graphviz.layout.Order$SegPorts$", ({
  v5: 1,
  d: 1,
  j: 1
}));
var $n_Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts$;
function $m_Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts$() {
  if ((!$n_Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts$)) {
    $n_Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts$ = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts$();
  }
  return $n_Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts$;
}
function $s_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen$__Star__Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen() {
  $m_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen$();
  return $t_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen$__Star;
}
function $s_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen$__Cylinder__Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen() {
  $m_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen$();
  return $t_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen$__Cylinder;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen$() {
  $n_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen$ = this;
  $t_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen$__Star = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen$$anon$1("Star", 0);
  $t_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen$__Cylinder = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen$$anon$1("Cylinder", 1);
  $s_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen$__Star__Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen();
  $s_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen$__Cylinder__Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen();
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen$, "org.jpablo.graphexplorer.graphviz.layout.Polygon$Gen$", ({
  v8: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen$;
function $m_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen$() {
  if ((!$n_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen$)) {
    $n_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen$ = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen$();
  }
  return $n_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort$() {
  this.RO = null;
  $n_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort$ = this;
  this.RO = ($m_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort$(), new $c_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort(0.0, 0.0, (-1.0), false, true, 0, false, false, $m_s_None$()));
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort$, "org.jpablo.graphexplorer.graphviz.layout.PortAnchor$GvPort$", ({
  vc: 1,
  d: 1,
  j: 1
}));
var $n_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort$;
function $m_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort$() {
  if ((!$n_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort$)) {
    $n_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort$ = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort$();
  }
  return $n_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort$;
}
function $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__TB__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir() {
  $m_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$();
  return $t_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__TB;
}
function $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__LR__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir() {
  $m_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$();
  return $t_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__LR;
}
function $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__BT__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir() {
  $m_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$();
  return $t_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__BT;
}
function $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__RL__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir() {
  $m_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$();
  return $t_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__RL;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$() {
  $n_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$ = this;
  $t_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__TB = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$$anon$1();
  $t_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__LR = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$$anon$2();
  $t_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__BT = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$$anon$3();
  $t_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__RL = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$$anon$4();
  $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__TB__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
  $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__LR__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
  $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__BT__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
  $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__RL__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$.prototype = $p;
$p.b1I = (function(s) {
  if (s.c()) {
    var x2 = $m_s_None$();
  } else {
    var x0 = s.d();
    var x2 = new $c_s_Some(x0.toUpperCase());
  }
  if ((x2 instanceof $c_s_Some)) {
    var x8 = x2.J;
    if ((x8 === "LR")) {
      return $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__LR__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
    }
    if ((x8 === "BT")) {
      return $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__BT__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
    }
    if ((x8 === "RL")) {
      return $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__RL__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
    }
  }
  return $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__TB__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$, "org.jpablo.graphexplorer.graphviz.layout.RankDir$", ({
  ve: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$;
function $m_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$() {
  if ((!$n_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$)) {
    $n_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$ = new $c_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$();
  }
  return $n_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$FlatBump$3$() {
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$FlatBump$3$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$FlatBump$3$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$FlatBump$3$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$FlatBump$3$.prototype = $p;
$p.m = (function() {
  return "FlatBump";
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$FlatBump$3$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$FlatBump$3$, "org.jpablo.graphexplorer.graphviz.layout.XCoord$FlatBump$3$", ({
  vs: 1,
  d: 1,
  j: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_model_Attrs$() {
  this.RY = null;
  $n_Lorg_jpablo_graphexplorer_graphviz_model_Attrs$ = this;
  this.RY = ($m_Lorg_jpablo_graphexplorer_graphviz_model_Attrs$(), new $c_Lorg_jpablo_graphexplorer_graphviz_model_Attrs($m_sci_Map$EmptyMap$(), ($m_Lorg_jpablo_graphexplorer_graphviz_model_Attrs$(), $m_sci_Set$EmptySet$())));
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_model_Attrs$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_model_Attrs$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_model_Attrs$() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_model_Attrs$.prototype = $p;
$p.ahb = (function(ps) {
  var resolved = ps.hO($m_sci_Map$EmptyMap$(), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((x$1, x$2) => {
    var x5 = new $c_T2(x$1, x$2);
    var x7 = x5.be;
    var acc = x5.bi;
    if ((x7 !== null)) {
      var k = x7.g();
      var v = x7.h();
      return acc.bN(k.fU, new $c_T2(v.fU, v.EY));
    }
    throw new $c_s_MatchError(x5);
  })));
  $m_Lorg_jpablo_graphexplorer_graphviz_model_Attrs$();
  return new $c_Lorg_jpablo_graphexplorer_graphviz_model_Attrs($m_sci_Map$().ao(new $c_sc_MapView$MapValues(new $c_sc_MapView$Id(resolved), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => _$1.g())))), $m_sci_Set$().af(resolved.ct(new $c_Lorg_jpablo_graphexplorer_graphviz_model_Attrs$$anon$1())));
});
var $d_Lorg_jpablo_graphexplorer_graphviz_model_Attrs$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_model_Attrs$, "org.jpablo.graphexplorer.graphviz.model.Attrs$", ({
  vz: 1,
  d: 1,
  j: 1
}));
var $n_Lorg_jpablo_graphexplorer_graphviz_model_Attrs$;
function $m_Lorg_jpablo_graphexplorer_graphviz_model_Attrs$() {
  if ((!$n_Lorg_jpablo_graphexplorer_graphviz_model_Attrs$)) {
    $n_Lorg_jpablo_graphexplorer_graphviz_model_Attrs$ = new $c_Lorg_jpablo_graphexplorer_graphviz_model_Attrs$();
  }
  return $n_Lorg_jpablo_graphexplorer_graphviz_model_Attrs$;
}
function $s_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$__ListNodes__Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand() {
  $m_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$();
  return $t_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$__ListNodes;
}
function $s_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$__ListArrows__Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand() {
  $m_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$();
  return $t_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$__ListArrows;
}
function $s_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$__ListGroups__Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand() {
  $m_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$();
  return $t_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$__ListGroups;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$() {
  $n_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$ = this;
  $t_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$__ListNodes = new $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$$anon$2("ListNodes", 8);
  $t_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$__ListArrows = new $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$$anon$2("ListArrows", 9);
  $t_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$__ListGroups = new $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$$anon$2("ListGroups", 10);
  $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_T.r().C)(["set-attribute", "remove-attribute", "reset-attributes", "group", "ungroup", "combine-into-record", "split-record", "transpose-record", "list-nodes", "list-arrows", "list-groups", "get-attributes"])));
  $s_Lorg_jpablo_graphexplorer_gxcore_command_Tier$__Document__Lorg_jpablo_graphexplorer_gxcore_command_Tier();
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$.prototype = $p;
$p.a4d = (function(command) {
  if (false) {
    command.pl();
    command.DC();
    command.aLI();
    return "set-attribute";
  }
  if (false) {
    command.pl();
    command.DC();
    return "remove-attribute";
  }
  if (false) {
    command.pl();
    return "reset-attributes";
  }
  if (false) {
    command.pl();
    command.DC();
    return "group";
  }
  if ((command instanceof $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$Ungroup)) {
    return "ungroup";
  }
  if ((command instanceof $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$CombineIntoRecord)) {
    return "combine-into-record";
  }
  if ((command instanceof $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$SplitRecord)) {
    return "split-record";
  }
  if ((command instanceof $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$TransposeRecord)) {
    return "transpose-record";
  }
  var x = $s_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$__ListNodes__Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand();
  if (((x === null) ? (command === null) : x.e(command))) {
    return "list-nodes";
  }
  var x$3 = $s_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$__ListArrows__Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand();
  if (((x$3 === null) ? (command === null) : x$3.e(command))) {
    return "list-arrows";
  }
  var x$5 = $s_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$__ListGroups__Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand();
  if (((x$5 === null) ? (command === null) : x$5.e(command))) {
    return "list-groups";
  }
  if (false) {
    command.pl();
    return "get-attributes";
  }
  throw new $c_s_MatchError(command);
});
var $d_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$, "org.jpablo.graphexplorer.gxcore.command.DocumentCommand$", ({
  vF: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$;
function $m_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$() {
  if ((!$n_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$)) {
    $n_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$ = new $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$();
  }
  return $n_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$;
}
function $s_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$__ClearSelection__Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand() {
  $m_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$();
  return $t_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$__ClearSelection;
}
function $s_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$__ResetView__Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand() {
  $m_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$();
  return $t_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$__ResetView;
}
function $s_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$__WhatIsSelected__Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand() {
  $m_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$();
  return $t_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$__WhatIsSelected;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$() {
  $n_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$ = this;
  $t_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$__ClearSelection = new $c_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$$anon$1("ClearSelection", 2);
  $t_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$__ResetView = new $c_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$$anon$1("ResetView", 3);
  $t_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$__WhatIsSelected = new $c_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$$anon$1("WhatIsSelected", 5);
  $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_T.r().C)(["select", "add-to-selection", "clear-selection", "reset-view", "push-text", "what-is-selected"])));
  $s_Lorg_jpablo_graphexplorer_gxcore_command_Tier$__Session__Lorg_jpablo_graphexplorer_gxcore_command_Tier();
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$.prototype = $p;
$p.b4I = (function(command) {
  if ((command instanceof $c_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$Select)) {
    return "select";
  }
  if ((command instanceof $c_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$AddToSelection)) {
    return "add-to-selection";
  }
  var x = $s_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$__ClearSelection__Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand();
  if (((x === null) ? (command === null) : x.e(command))) {
    return "clear-selection";
  }
  var x$3 = $s_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$__ResetView__Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand();
  if (((x$3 === null) ? (command === null) : x$3.e(command))) {
    return "reset-view";
  }
  if ((command instanceof $c_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$PushText)) {
    return "push-text";
  }
  var x$5 = $s_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$__WhatIsSelected__Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand();
  if (((x$5 === null) ? (command === null) : x$5.e(command))) {
    return "what-is-selected";
  }
  throw new $c_s_MatchError(command);
});
var $d_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$, "org.jpablo.graphexplorer.gxcore.command.SessionCommand$", ({
  vP: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$;
function $m_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$() {
  if ((!$n_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$)) {
    $n_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$ = new $c_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$();
  }
  return $n_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$;
}
function $s_Lorg_jpablo_graphexplorer_gxcore_command_Tier$__Document__Lorg_jpablo_graphexplorer_gxcore_command_Tier() {
  $m_Lorg_jpablo_graphexplorer_gxcore_command_Tier$();
  return $t_Lorg_jpablo_graphexplorer_gxcore_command_Tier$__Document;
}
function $s_Lorg_jpablo_graphexplorer_gxcore_command_Tier$__Record__Lorg_jpablo_graphexplorer_gxcore_command_Tier() {
  $m_Lorg_jpablo_graphexplorer_gxcore_command_Tier$();
  return $t_Lorg_jpablo_graphexplorer_gxcore_command_Tier$__Record;
}
function $s_Lorg_jpablo_graphexplorer_gxcore_command_Tier$__Session__Lorg_jpablo_graphexplorer_gxcore_command_Tier() {
  $m_Lorg_jpablo_graphexplorer_gxcore_command_Tier$();
  return $t_Lorg_jpablo_graphexplorer_gxcore_command_Tier$__Session;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_command_Tier$() {
  $n_Lorg_jpablo_graphexplorer_gxcore_command_Tier$ = this;
  $t_Lorg_jpablo_graphexplorer_gxcore_command_Tier$__Document = new $c_Lorg_jpablo_graphexplorer_gxcore_command_Tier$$anon$1("Document", 0);
  $t_Lorg_jpablo_graphexplorer_gxcore_command_Tier$__Record = new $c_Lorg_jpablo_graphexplorer_gxcore_command_Tier$$anon$1("Record", 1);
  $t_Lorg_jpablo_graphexplorer_gxcore_command_Tier$__Session = new $c_Lorg_jpablo_graphexplorer_gxcore_command_Tier$$anon$1("Session", 2);
  $s_Lorg_jpablo_graphexplorer_gxcore_command_Tier$__Document__Lorg_jpablo_graphexplorer_gxcore_command_Tier();
  $s_Lorg_jpablo_graphexplorer_gxcore_command_Tier$__Record__Lorg_jpablo_graphexplorer_gxcore_command_Tier();
  $s_Lorg_jpablo_graphexplorer_gxcore_command_Tier$__Session__Lorg_jpablo_graphexplorer_gxcore_command_Tier();
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_command_Tier$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_command_Tier$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_command_Tier$() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_command_Tier$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_gxcore_command_Tier$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_command_Tier$, "org.jpablo.graphexplorer.gxcore.command.Tier$", ({
  vS: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_gxcore_command_Tier$;
function $m_Lorg_jpablo_graphexplorer_gxcore_command_Tier$() {
  if ((!$n_Lorg_jpablo_graphexplorer_gxcore_command_Tier$)) {
    $n_Lorg_jpablo_graphexplorer_gxcore_command_Tier$ = new $c_Lorg_jpablo_graphexplorer_gxcore_command_Tier$();
  }
  return $n_Lorg_jpablo_graphexplorer_gxcore_command_Tier$;
}
function $s_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$__Lf__Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding() {
  $m_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$();
  return $t_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$__Lf;
}
function $s_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$__Crlf__Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding() {
  $m_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$();
  return $t_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$__Crlf;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$() {
  $n_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$ = this;
  $t_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$__Lf = new $c_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$$anon$1();
  $t_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$__Crlf = new $c_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$$anon$2();
  $s_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$__Lf__Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding();
  $s_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$__Crlf__Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding();
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$.prototype = $p;
$p.aZS = (function(text) {
  var crlf = 0;
  var lf = 0;
  var i = 0;
  while ((i < text.length)) {
    if ((text.charCodeAt(i) === 10)) {
      if (((i > 0) && (text.charCodeAt(((i - 1) | 0)) === 13))) {
        crlf = ((1 + crlf) | 0);
      } else {
        lf = ((1 + lf) | 0);
      }
    }
    i = ((1 + i) | 0);
  }
  return ((crlf > lf) ? $s_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$__Crlf__Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding() : $s_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$__Lf__Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding());
});
$p.aXH = (function(e, text) {
  var normalized = text.split("\r\n").join("\n");
  var x = $s_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$__Lf__Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding();
  if (((x === null) ? (e === null) : (x === e))) {
    return normalized;
  }
  var x$3 = $s_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$__Crlf__Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding();
  if (((x$3 === null) ? (e === null) : (x$3 === e))) {
    return normalized.split("\n").join("\r\n");
  }
  throw new $c_s_MatchError(e);
});
var $d_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$, "org.jpablo.graphexplorer.gxcore.fs.LineEnding$", ({
  vU: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$;
function $m_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$() {
  if ((!$n_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$)) {
    $n_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$ = new $c_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$();
  }
  return $n_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_model_Binding$() {
  this.auE = null;
  this.auF = false;
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_model_Binding$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_model_Binding$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_model_Binding$() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_model_Binding$.prototype = $p;
$p.m = (function() {
  return "Binding";
});
$p.bm = (function() {
  if ((!this.auF)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().cw());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.auE = MacroImplicits_this.cw().ez(new $c_Lorg_jpablo_graphexplorer_gxcore_model_Binding$$anon$7(MacroImplicits_this, 4, this), new $c_Lorg_jpablo_graphexplorer_gxcore_model_Binding$$anon$8(MacroImplicits_this, this));
    this.auF = true;
  }
  return this.auE;
});
$p.b5p = (function(ReadersVersionSpecific_this$11) {
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.eO();
  }
  return true;
});
$p.b5q = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params, collection) => {
    var $x_4 = params.a[0];
    var $x_3 = params.a[1];
    var $x_2 = params.a[2];
    var $x_1 = $uJ(params.a[3]);
    return new $c_Lorg_jpablo_graphexplorer_gxcore_model_Binding($x_4, $x_3, $x_2, $x_1.l, $x_1.h);
  }));
});
var $d_Lorg_jpablo_graphexplorer_gxcore_model_Binding$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_model_Binding$, "org.jpablo.graphexplorer.gxcore.model.Binding$", ({
  vX: 1,
  d: 1,
  j: 1
}));
var $n_Lorg_jpablo_graphexplorer_gxcore_model_Binding$;
function $m_Lorg_jpablo_graphexplorer_gxcore_model_Binding$() {
  if ((!$n_Lorg_jpablo_graphexplorer_gxcore_model_Binding$)) {
    $n_Lorg_jpablo_graphexplorer_gxcore_model_Binding$ = new $c_Lorg_jpablo_graphexplorer_gxcore_model_Binding$();
  }
  return $n_Lorg_jpablo_graphexplorer_gxcore_model_Binding$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_model_Diagram$() {
  this.auI = null;
  this.auJ = false;
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_model_Diagram$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_model_Diagram$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_model_Diagram$() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_model_Diagram$.prototype = $p;
$p.m = (function() {
  return "Diagram";
});
$p.bm = (function() {
  if ((!this.auJ)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().cw());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.auI = MacroImplicits_this.cw().ez(new $c_Lorg_jpablo_graphexplorer_gxcore_model_Diagram$$anon$9(MacroImplicits_this, 9, this), new $c_Lorg_jpablo_graphexplorer_gxcore_model_Diagram$$anon$10(MacroImplicits_this, this));
    this.auJ = true;
  }
  return this.auI;
});
$p.b5s = (function(ReadersVersionSpecific_this$14) {
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.eO();
  }
  return true;
});
$p.b5r = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params, collection) => {
    var $x_9 = params.a[0];
    var $x_8 = params.a[1];
    var $x_7 = params.a[2];
    var $x_6 = params.a[3];
    var $x_5 = params.a[4];
    var $x_4 = params.a[5];
    var $x_3 = params.a[6];
    var $x_2 = $uJ(params.a[7]);
    var $x_1 = $uJ(params.a[8]);
    return new $c_Lorg_jpablo_graphexplorer_gxcore_model_Diagram($x_9, $x_8, $x_7, $x_6, $x_5, $x_4, $x_3, $x_2.l, $x_2.h, $x_1.l, $x_1.h);
  }));
});
var $d_Lorg_jpablo_graphexplorer_gxcore_model_Diagram$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_model_Diagram$, "org.jpablo.graphexplorer.gxcore.model.Diagram$", ({
  w1: 1,
  d: 1,
  j: 1
}));
var $n_Lorg_jpablo_graphexplorer_gxcore_model_Diagram$;
function $m_Lorg_jpablo_graphexplorer_gxcore_model_Diagram$() {
  if ((!$n_Lorg_jpablo_graphexplorer_gxcore_model_Diagram$)) {
    $n_Lorg_jpablo_graphexplorer_gxcore_model_Diagram$ = new $c_Lorg_jpablo_graphexplorer_gxcore_model_Diagram$();
  }
  return $n_Lorg_jpablo_graphexplorer_gxcore_model_Diagram$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId$() {
  this.auK = null;
  this.auL = false;
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId$() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId$.prototype = $p;
$p.aZP = (function(namespace, key) {
  return new $c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId(((namespace + "-") + key));
});
$p.bm = (function() {
  if ((!this.auL)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().cw());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.auK = MacroImplicits_this.cw().ez(new $c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId$$anon$1(MacroImplicits_this, 1, this), new $c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId$$anon$2(MacroImplicits_this, this));
    this.auL = true;
  }
  return this.auK;
});
$p.b5t = (function(ReadersVersionSpecific_this$2) {
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.eO();
  }
  return true;
});
$p.b5u = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params, collection) => new $c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId(params.a[0])));
});
var $d_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId$, "org.jpablo.graphexplorer.gxcore.model.DiagramId$", ({
  w4: 1,
  d: 1,
  j: 1
}));
var $n_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId$;
function $m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId$() {
  if ((!$n_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId$)) {
    $n_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId$ = new $c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId$();
  }
  return $n_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$() {
  this.auO = null;
  this.auM = null;
  this.auN = false;
  $n_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$ = this;
  this.auO = ($m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$(), new $c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata(($m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$(), $m_sci_Set$EmptySet$()), ($m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$(), $m_sci_Set$EmptySet$()), ($m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$(), $m_sci_Nil$()), ($m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$(), ""), ($m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$(), $m_s_None$())));
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$.prototype = $p;
$p.bm = (function() {
  if ((!this.auN)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().cw());
    var MacroImplicits_this = $m_Lupickle_default$();
    $m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$();
    this.auM = MacroImplicits_this.cw().ez(new $c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$$anon$5(MacroImplicits_this, 5, this), new $c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$$anon$6(MacroImplicits_this, this));
    this.auN = true;
  }
  return this.auM;
});
$p.b5v = (function(ReadersVersionSpecific_this$8) {
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.eO();
  }
  return true;
});
$p.b5w = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params, collection) => {
    $m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$();
    return new $c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata(params.a[0], params.a[1], params.a[2], params.a[3], params.a[4]);
  }));
});
var $d_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$, "org.jpablo.graphexplorer.gxcore.model.DiagramMetadata$", ({
  w7: 1,
  d: 1,
  j: 1
}));
var $n_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$;
function $m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$() {
  if ((!$n_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$)) {
    $n_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$ = new $c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$();
  }
  return $n_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath$() {
  this.a03 = null;
  this.auP = null;
  this.auQ = false;
  $n_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath$ = this;
  this.a03 = ($m_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath$(), new $c_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath($m_sci_Nil$()));
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath$() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath$.prototype = $p;
$p.bm = (function() {
  if ((!this.auQ)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().cw());
    var MacroImplicits_this = $m_Lupickle_default$();
    $m_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath$();
    this.auP = MacroImplicits_this.cw().ez(new $c_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath$$anon$3(MacroImplicits_this, 1, this), new $c_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath$$anon$4(MacroImplicits_this, this));
    this.auQ = true;
  }
  return this.auP;
});
$p.b5x = (function(ReadersVersionSpecific_this$5) {
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.eO();
  }
  return true;
});
$p.b5y = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params, collection) => {
    $m_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath$();
    return new $c_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath(params.a[0]);
  }));
});
var $d_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath$, "org.jpablo.graphexplorer.gxcore.model.FolderPath$", ({
  wa: 1,
  d: 1,
  j: 1
}));
var $n_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath$;
function $m_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath$() {
  if ((!$n_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath$)) {
    $n_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath$ = new $c_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath$();
  }
  return $n_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath$;
}
function $s_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$__DoNothing__Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction() {
  $m_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$();
  return $t_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$__DoNothing;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$() {
  $n_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$ = this;
  $t_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$__DoNothing = new $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$$anon$1("DoNothing", 0);
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$, "org.jpablo.graphexplorer.gxcore.model.ReconcileAction$", ({
  we: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$;
function $m_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$() {
  if ((!$n_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$)) {
    $n_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$ = new $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$();
  }
  return $n_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$;
}
function $s_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$__Unbound__Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan() {
  $m_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$();
  return $t_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$__Unbound;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$() {
  $n_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$ = this;
  $t_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$__Unbound = new $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$$anon$2("Unbound", 0);
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$.prototype = $p;
$p.PY = (function(plan) {
  var x = $s_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$__Unbound__Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan();
  if (((x === null) ? (plan === null) : x.e(plan))) {
    return $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__InSync__Lorg_jpablo_graphexplorer_gxcore_model_SyncState();
  }
  if ((plan instanceof $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$Bound)) {
    return plan.Sh;
  }
  throw new $c_s_MatchError(plan);
});
$p.aWw = (function(plan) {
  var x = $s_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$__Unbound__Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan();
  if (((x === null) ? (plan === null) : x.e(plan))) {
    return $s_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$__DoNothing__Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction();
  }
  if ((plan instanceof $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$Bound)) {
    return plan.Sg;
  }
  throw new $c_s_MatchError(plan);
});
var $d_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$, "org.jpablo.graphexplorer.gxcore.model.ReconcilePlan$", ({
  wg: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$;
function $m_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$() {
  if ((!$n_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$)) {
    $n_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$ = new $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$();
  }
  return $n_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$;
}
function $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$__Pull__Lorg_jpablo_graphexplorer_gxcore_model_SyncAction() {
  $m_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$();
  return $t_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$__Pull;
}
function $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$__Push__Lorg_jpablo_graphexplorer_gxcore_model_SyncAction() {
  $m_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$();
  return $t_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$__Push;
}
function $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$__AdvanceBase__Lorg_jpablo_graphexplorer_gxcore_model_SyncAction() {
  $m_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$();
  return $t_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$__AdvanceBase;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$() {
  $n_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$ = this;
  $t_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$__Pull = new $c_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$$anon$2("Pull", 0);
  $t_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$__Push = new $c_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$$anon$2("Push", 1);
  $t_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$__AdvanceBase = new $c_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$$anon$2("AdvanceBase", 2);
  $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$__Pull__Lorg_jpablo_graphexplorer_gxcore_model_SyncAction();
  $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$__Push__Lorg_jpablo_graphexplorer_gxcore_model_SyncAction();
  $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$__AdvanceBase__Lorg_jpablo_graphexplorer_gxcore_model_SyncAction();
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$, "org.jpablo.graphexplorer.gxcore.model.SyncAction$", ({
  wk: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$;
function $m_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$() {
  if ((!$n_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$)) {
    $n_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$ = new $c_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$();
  }
  return $n_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$;
}
function $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$__Detached__Lorg_jpablo_graphexplorer_gxcore_model_SyncMode() {
  $m_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$();
  return $t_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$__Detached;
}
function $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$__Pull__Lorg_jpablo_graphexplorer_gxcore_model_SyncMode() {
  $m_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$();
  return $t_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$__Pull;
}
function $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$__Push__Lorg_jpablo_graphexplorer_gxcore_model_SyncMode() {
  $m_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$();
  return $t_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$__Push;
}
function $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$__Sync__Lorg_jpablo_graphexplorer_gxcore_model_SyncMode() {
  $m_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$();
  return $t_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$__Sync;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$() {
  this.auT = null;
  this.auU = null;
  this.auV = false;
  $n_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$ = this;
  $t_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$__Detached = new $c_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$$anon$1("Detached", 0);
  $t_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$__Pull = new $c_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$$anon$1("Pull", 1);
  $t_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$__Push = new $c_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$$anon$1("Push", 2);
  $t_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$__Sync = new $c_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$$anon$1("Sync", 3);
  this.auT = new ($d_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode.r().C)([$s_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$__Detached__Lorg_jpablo_graphexplorer_gxcore_model_SyncMode(), $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$__Pull__Lorg_jpablo_graphexplorer_gxcore_model_SyncMode(), $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$__Push__Lorg_jpablo_graphexplorer_gxcore_model_SyncMode(), $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$__Sync__Lorg_jpablo_graphexplorer_gxcore_model_SyncMode()]);
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$.prototype = $p;
$p.bb3 = (function() {
  return this.auT.ae();
});
$p.agj = (function() {
  if ((!this.auV)) {
    this.auU = ($m_Lupickle_default$(), new $c_Lupickle_core_Types$$anon$1(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => _$1.m())), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((s) => {
      var xs = $m_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$().bb3();
      _return: {
        var i = 0;
        while ((i < xs.a.length)) {
          var x1 = i;
          if ((xs.a[x1].m() === s)) {
            var idx = i;
            break _return;
          }
          i = ((1 + i) | 0);
        }
        var idx = (-1);
      }
      var this$6 = ((idx === (-1)) ? $m_s_None$() : new $c_s_Some(xs.a[idx]));
      return (this$6.c() ? $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$__Detached__Lorg_jpablo_graphexplorer_gxcore_model_SyncMode() : this$6.d());
    })), $m_Lupickle_default$().cw().ez($m_Lupickle_default$().a5, $m_Lupickle_default$().I)));
    this.auV = true;
  }
  return this.auU;
});
$p.b6Y = (function(m) {
  matchAlts3: {
    matchAlts4: {
      var x = $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$__Pull__Lorg_jpablo_graphexplorer_gxcore_model_SyncMode();
      if (((x === null) ? (m === null) : (x === m))) {
        break matchAlts4;
      }
      var x$3 = $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$__Sync__Lorg_jpablo_graphexplorer_gxcore_model_SyncMode();
      if (((x$3 === null) ? (m === null) : (x$3 === m))) {
        break matchAlts4;
      }
      break matchAlts3;
    }
    return true;
  }
  matchAlts1: {
    matchAlts2: {
      var x$5 = $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$__Detached__Lorg_jpablo_graphexplorer_gxcore_model_SyncMode();
      if (((x$5 === null) ? (m === null) : (x$5 === m))) {
        break matchAlts2;
      }
      var x$7 = $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$__Push__Lorg_jpablo_graphexplorer_gxcore_model_SyncMode();
      if (((x$7 === null) ? (m === null) : (x$7 === m))) {
        break matchAlts2;
      }
      break matchAlts1;
    }
    return false;
  }
  throw new $c_s_MatchError(m);
});
$p.b70 = (function(m) {
  matchAlts7: {
    matchAlts8: {
      var x = $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$__Push__Lorg_jpablo_graphexplorer_gxcore_model_SyncMode();
      if (((x === null) ? (m === null) : (x === m))) {
        break matchAlts8;
      }
      var x$3 = $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$__Sync__Lorg_jpablo_graphexplorer_gxcore_model_SyncMode();
      if (((x$3 === null) ? (m === null) : (x$3 === m))) {
        break matchAlts8;
      }
      break matchAlts7;
    }
    return true;
  }
  matchAlts5: {
    matchAlts6: {
      var x$5 = $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$__Detached__Lorg_jpablo_graphexplorer_gxcore_model_SyncMode();
      if (((x$5 === null) ? (m === null) : (x$5 === m))) {
        break matchAlts6;
      }
      var x$7 = $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$__Pull__Lorg_jpablo_graphexplorer_gxcore_model_SyncMode();
      if (((x$7 === null) ? (m === null) : (x$7 === m))) {
        break matchAlts6;
      }
      break matchAlts5;
    }
    return false;
  }
  throw new $c_s_MatchError(m);
});
$p.aXP = (function(m, state) {
  var x = $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__InSync__Lorg_jpablo_graphexplorer_gxcore_model_SyncState();
  if (((x === null) ? (state === null) : (x === state))) {
    return $m_s_None$();
  }
  var x$3 = $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__Converged__Lorg_jpablo_graphexplorer_gxcore_model_SyncState();
  if (((x$3 === null) ? (state === null) : (x$3 === state))) {
    return new $c_s_Some($s_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$__AdvanceBase__Lorg_jpablo_graphexplorer_gxcore_model_SyncAction());
  }
  var x$5 = $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__Ahead__Lorg_jpablo_graphexplorer_gxcore_model_SyncState();
  if (((x$5 === null) ? (state === null) : (x$5 === state))) {
    return (this.b70(m) ? new $c_s_Some($s_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$__Push__Lorg_jpablo_graphexplorer_gxcore_model_SyncAction()) : $m_s_None$());
  }
  var x$7 = $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__Behind__Lorg_jpablo_graphexplorer_gxcore_model_SyncState();
  if (((x$7 === null) ? (state === null) : (x$7 === state))) {
    return (this.b6Y(m) ? new $c_s_Some($s_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$__Pull__Lorg_jpablo_graphexplorer_gxcore_model_SyncAction()) : $m_s_None$());
  }
  var x$9 = $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__Diverged__Lorg_jpablo_graphexplorer_gxcore_model_SyncState();
  if (((x$9 === null) ? (state === null) : (x$9 === state))) {
    return $m_s_None$();
  }
  var x$11 = $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__OriginMissing__Lorg_jpablo_graphexplorer_gxcore_model_SyncState();
  if (((x$11 === null) ? (state === null) : (x$11 === state))) {
    return $m_s_None$();
  }
  throw new $c_s_MatchError(state);
});
var $d_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$, "org.jpablo.graphexplorer.gxcore.model.SyncMode$", ({
  wm: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$;
function $m_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$() {
  if ((!$n_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$)) {
    $n_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$ = new $c_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$();
  }
  return $n_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$;
}
function $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__InSync__Lorg_jpablo_graphexplorer_gxcore_model_SyncState() {
  $m_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$();
  return $t_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__InSync;
}
function $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__Ahead__Lorg_jpablo_graphexplorer_gxcore_model_SyncState() {
  $m_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$();
  return $t_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__Ahead;
}
function $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__Behind__Lorg_jpablo_graphexplorer_gxcore_model_SyncState() {
  $m_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$();
  return $t_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__Behind;
}
function $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__Diverged__Lorg_jpablo_graphexplorer_gxcore_model_SyncState() {
  $m_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$();
  return $t_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__Diverged;
}
function $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__Converged__Lorg_jpablo_graphexplorer_gxcore_model_SyncState() {
  $m_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$();
  return $t_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__Converged;
}
function $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__OriginMissing__Lorg_jpablo_graphexplorer_gxcore_model_SyncState() {
  $m_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$();
  return $t_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__OriginMissing;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$() {
  $n_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$ = this;
  $t_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__InSync = new $c_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$$anon$1("InSync", 0);
  $t_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__Ahead = new $c_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$$anon$1("Ahead", 1);
  $t_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__Behind = new $c_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$$anon$1("Behind", 2);
  $t_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__Diverged = new $c_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$$anon$1("Diverged", 3);
  $t_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__Converged = new $c_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$$anon$1("Converged", 4);
  $t_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__OriginMissing = new $c_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$$anon$1("OriginMissing", 5);
  $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__InSync__Lorg_jpablo_graphexplorer_gxcore_model_SyncState();
  $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__Ahead__Lorg_jpablo_graphexplorer_gxcore_model_SyncState();
  $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__Behind__Lorg_jpablo_graphexplorer_gxcore_model_SyncState();
  $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__Diverged__Lorg_jpablo_graphexplorer_gxcore_model_SyncState();
  $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__Converged__Lorg_jpablo_graphexplorer_gxcore_model_SyncState();
  $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__OriginMissing__Lorg_jpablo_graphexplorer_gxcore_model_SyncState();
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$.prototype = $p;
$p.b5c = (function(base, local, remote) {
  if (($m_s_None$() === remote)) {
    return $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__OriginMissing__Lorg_jpablo_graphexplorer_gxcore_model_SyncState();
  }
  if ((remote instanceof $c_s_Some)) {
    var remote$2 = remote.J;
    var localMoved = (local !== base);
    var remoteMoved = (remote$2 !== base);
    var x2 = new $c_T2(localMoved, remoteMoved);
    var x9 = (!(!x2.bi));
    var x10 = (!(!x2.be));
    if (((!x9) && (!x10))) {
      return $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__InSync__Lorg_jpablo_graphexplorer_gxcore_model_SyncState();
    }
    if ((x9 && (!x10))) {
      return $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__Ahead__Lorg_jpablo_graphexplorer_gxcore_model_SyncState();
    }
    if (((!x9) && x10)) {
      return $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__Behind__Lorg_jpablo_graphexplorer_gxcore_model_SyncState();
    }
    if ((x9 && x10)) {
      return ((local === remote$2) ? $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__Converged__Lorg_jpablo_graphexplorer_gxcore_model_SyncState() : $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__Diverged__Lorg_jpablo_graphexplorer_gxcore_model_SyncState());
    }
    throw new $c_s_MatchError(x2);
  }
  throw new $c_s_MatchError(remote);
});
$p.b4L = (function(s) {
  matchAlts3: {
    matchAlts4: {
      var x = $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__Diverged__Lorg_jpablo_graphexplorer_gxcore_model_SyncState();
      if (((x === null) ? (s === null) : (x === s))) {
        break matchAlts4;
      }
      var x$3 = $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__OriginMissing__Lorg_jpablo_graphexplorer_gxcore_model_SyncState();
      if (((x$3 === null) ? (s === null) : (x$3 === s))) {
        break matchAlts4;
      }
      break matchAlts3;
    }
    return true;
  }
  matchAlts1: {
    matchAlts2: {
      var x$5 = $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__InSync__Lorg_jpablo_graphexplorer_gxcore_model_SyncState();
      if (((x$5 === null) ? (s === null) : (x$5 === s))) {
        break matchAlts2;
      }
      var x$7 = $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__Ahead__Lorg_jpablo_graphexplorer_gxcore_model_SyncState();
      if (((x$7 === null) ? (s === null) : (x$7 === s))) {
        break matchAlts2;
      }
      var x$9 = $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__Behind__Lorg_jpablo_graphexplorer_gxcore_model_SyncState();
      if (((x$9 === null) ? (s === null) : (x$9 === s))) {
        break matchAlts2;
      }
      var x$11 = $s_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__Converged__Lorg_jpablo_graphexplorer_gxcore_model_SyncState();
      if (((x$11 === null) ? (s === null) : (x$11 === s))) {
        break matchAlts2;
      }
      break matchAlts1;
    }
    return false;
  }
  throw new $c_s_MatchError(s);
});
var $d_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$, "org.jpablo.graphexplorer.gxcore.model.SyncState$", ({
  wp: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$;
function $m_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$() {
  if ((!$n_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$)) {
    $n_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$ = new $c_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$();
  }
  return $n_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_projects_LibraryMapping$Unparsed$() {
  this.a8l = null;
  $n_Lorg_jpablo_graphexplorer_projects_LibraryMapping$Unparsed$ = this;
  this.a8l = ($m_Lorg_jpablo_graphexplorer_projects_LibraryMapping$Unparsed$(), new $c_Lorg_jpablo_graphexplorer_projects_LibraryMapping$Unparsed($m_sci_Set$EmptySet$(), $m_sci_Set$EmptySet$()));
}
$p = $c_Lorg_jpablo_graphexplorer_projects_LibraryMapping$Unparsed$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_projects_LibraryMapping$Unparsed$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_projects_LibraryMapping$Unparsed$() {
}
$h_Lorg_jpablo_graphexplorer_projects_LibraryMapping$Unparsed$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_projects_LibraryMapping$Unparsed$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_projects_LibraryMapping$Unparsed$, "org.jpablo.graphexplorer.projects.LibraryMapping$Unparsed$", ({
  wG: 1,
  d: 1,
  j: 1
}));
var $n_Lorg_jpablo_graphexplorer_projects_LibraryMapping$Unparsed$;
function $m_Lorg_jpablo_graphexplorer_projects_LibraryMapping$Unparsed$() {
  if ((!$n_Lorg_jpablo_graphexplorer_projects_LibraryMapping$Unparsed$)) {
    $n_Lorg_jpablo_graphexplorer_projects_LibraryMapping$Unparsed$ = new $c_Lorg_jpablo_graphexplorer_projects_LibraryMapping$Unparsed$();
  }
  return $n_Lorg_jpablo_graphexplorer_projects_LibraryMapping$Unparsed$;
}
function $s_Lorg_jpablo_graphexplorer_projects_LibraryViewMode$__Cards__Lorg_jpablo_graphexplorer_projects_LibraryViewMode() {
  $m_Lorg_jpablo_graphexplorer_projects_LibraryViewMode$();
  return $t_Lorg_jpablo_graphexplorer_projects_LibraryViewMode$__Cards;
}
function $s_Lorg_jpablo_graphexplorer_projects_LibraryViewMode$__Rows__Lorg_jpablo_graphexplorer_projects_LibraryViewMode() {
  $m_Lorg_jpablo_graphexplorer_projects_LibraryViewMode$();
  return $t_Lorg_jpablo_graphexplorer_projects_LibraryViewMode$__Rows;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_projects_LibraryViewMode$() {
  this.av2 = null;
  this.av3 = false;
  $n_Lorg_jpablo_graphexplorer_projects_LibraryViewMode$ = this;
  $t_Lorg_jpablo_graphexplorer_projects_LibraryViewMode$__Cards = new $c_Lorg_jpablo_graphexplorer_projects_LibraryViewMode$$anon$2("Cards", 0);
  $t_Lorg_jpablo_graphexplorer_projects_LibraryViewMode$__Rows = new $c_Lorg_jpablo_graphexplorer_projects_LibraryViewMode$$anon$2("Rows", 1);
  $s_Lorg_jpablo_graphexplorer_projects_LibraryViewMode$__Cards__Lorg_jpablo_graphexplorer_projects_LibraryViewMode();
  $s_Lorg_jpablo_graphexplorer_projects_LibraryViewMode$__Rows__Lorg_jpablo_graphexplorer_projects_LibraryViewMode();
}
$p = $c_Lorg_jpablo_graphexplorer_projects_LibraryViewMode$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_projects_LibraryViewMode$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_projects_LibraryViewMode$() {
}
$h_Lorg_jpablo_graphexplorer_projects_LibraryViewMode$.prototype = $p;
$p.nx = (function() {
  if ((!this.av3)) {
    this.av2 = $m_s_CanEqual$derived$();
    this.av3 = true;
  }
  return this.av2;
});
var $d_Lorg_jpablo_graphexplorer_projects_LibraryViewMode$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_projects_LibraryViewMode$, "org.jpablo.graphexplorer.projects.LibraryViewMode$", ({
  wI: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_projects_LibraryViewMode$;
function $m_Lorg_jpablo_graphexplorer_projects_LibraryViewMode$() {
  if ((!$n_Lorg_jpablo_graphexplorer_projects_LibraryViewMode$)) {
    $n_Lorg_jpablo_graphexplorer_projects_LibraryViewMode$ = new $c_Lorg_jpablo_graphexplorer_projects_LibraryViewMode$();
  }
  return $n_Lorg_jpablo_graphexplorer_projects_LibraryViewMode$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_projects_ProjectInfo$() {
  this.av4 = null;
  this.av5 = false;
}
$p = $c_Lorg_jpablo_graphexplorer_projects_ProjectInfo$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_projects_ProjectInfo$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_projects_ProjectInfo$() {
}
$h_Lorg_jpablo_graphexplorer_projects_ProjectInfo$.prototype = $p;
$p.m = (function() {
  return "ProjectInfo";
});
$p.bm = (function() {
  if ((!this.av5)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().cw());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.av4 = MacroImplicits_this.cw().ez(new $c_Lorg_jpablo_graphexplorer_projects_ProjectInfo$$anon$1(MacroImplicits_this, 4, this), new $c_Lorg_jpablo_graphexplorer_projects_ProjectInfo$$anon$2(MacroImplicits_this, this));
    this.av5 = true;
  }
  return this.av4;
});
$p.b5A = (function(ReadersVersionSpecific_this$2) {
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.eO();
  }
  return true;
});
$p.b5B = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params, collection) => {
    var $x_4 = params.a[0];
    var $x_3 = params.a[1];
    var $x_2 = $uJ(params.a[2]);
    var $x_1 = $uJ(params.a[3]);
    return new $c_Lorg_jpablo_graphexplorer_projects_ProjectInfo($x_4, $x_3, $x_2.l, $x_2.h, $x_1.l, $x_1.h);
  }));
});
var $d_Lorg_jpablo_graphexplorer_projects_ProjectInfo$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_projects_ProjectInfo$, "org.jpablo.graphexplorer.projects.ProjectInfo$", ({
  wK: 1,
  d: 1,
  j: 1
}));
var $n_Lorg_jpablo_graphexplorer_projects_ProjectInfo$;
function $m_Lorg_jpablo_graphexplorer_projects_ProjectInfo$() {
  if ((!$n_Lorg_jpablo_graphexplorer_projects_ProjectInfo$)) {
    $n_Lorg_jpablo_graphexplorer_projects_ProjectInfo$ = new $c_Lorg_jpablo_graphexplorer_projects_ProjectInfo$();
  }
  return $n_Lorg_jpablo_graphexplorer_projects_ProjectInfo$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory$() {
  this.avi = null;
  this.avj = false;
}
$p = $c_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory$() {
}
$h_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory$.prototype = $p;
$p.m = (function() {
  return "ProjectsDirectory";
});
$p.bm = (function() {
  if ((!this.avj)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().cw());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.avi = MacroImplicits_this.cw().ez(new $c_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory$$anon$3(MacroImplicits_this, 1, this), new $c_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory$$anon$4(MacroImplicits_this, this));
    this.avj = true;
  }
  return this.avi;
});
$p.b5C = (function(ReadersVersionSpecific_this$5) {
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.eO();
  }
  return true;
});
$p.b5D = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params, collection) => new $c_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory(params.a[0])));
});
var $d_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory$, "org.jpablo.graphexplorer.projects.ProjectsDirectory$", ({
  wO: 1,
  d: 1,
  j: 1
}));
var $n_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory$;
function $m_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory$() {
  if ((!$n_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory$)) {
    $n_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory$ = new $c_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory$();
  }
  return $n_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory$;
}
function $s_Lorg_jpablo_graphexplorer_projects_SortOption$__LastModified__Lorg_jpablo_graphexplorer_projects_SortOption() {
  $m_Lorg_jpablo_graphexplorer_projects_SortOption$();
  return $t_Lorg_jpablo_graphexplorer_projects_SortOption$__LastModified;
}
function $s_Lorg_jpablo_graphexplorer_projects_SortOption$__Title__Lorg_jpablo_graphexplorer_projects_SortOption() {
  $m_Lorg_jpablo_graphexplorer_projects_SortOption$();
  return $t_Lorg_jpablo_graphexplorer_projects_SortOption$__Title;
}
function $s_Lorg_jpablo_graphexplorer_projects_SortOption$__CreationDate__Lorg_jpablo_graphexplorer_projects_SortOption() {
  $m_Lorg_jpablo_graphexplorer_projects_SortOption$();
  return $t_Lorg_jpablo_graphexplorer_projects_SortOption$__CreationDate;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_projects_SortOption$() {
  this.avl = null;
  this.avm = null;
  $n_Lorg_jpablo_graphexplorer_projects_SortOption$ = this;
  $t_Lorg_jpablo_graphexplorer_projects_SortOption$__LastModified = new $c_Lorg_jpablo_graphexplorer_projects_SortOption$$anon$1("LastModified", 0);
  $t_Lorg_jpablo_graphexplorer_projects_SortOption$__Title = new $c_Lorg_jpablo_graphexplorer_projects_SortOption$$anon$1("Title", 1);
  $t_Lorg_jpablo_graphexplorer_projects_SortOption$__CreationDate = new $c_Lorg_jpablo_graphexplorer_projects_SortOption$$anon$1("CreationDate", 2);
  this.avl = new ($d_Lorg_jpablo_graphexplorer_projects_SortOption.r().C)([$s_Lorg_jpablo_graphexplorer_projects_SortOption$__LastModified__Lorg_jpablo_graphexplorer_projects_SortOption(), $s_Lorg_jpablo_graphexplorer_projects_SortOption$__Title__Lorg_jpablo_graphexplorer_projects_SortOption(), $s_Lorg_jpablo_graphexplorer_projects_SortOption$__CreationDate__Lorg_jpablo_graphexplorer_projects_SortOption()]);
  this.avm = $s_Lorg_jpablo_graphexplorer_projects_SortOption$__CreationDate__Lorg_jpablo_graphexplorer_projects_SortOption();
}
$p = $c_Lorg_jpablo_graphexplorer_projects_SortOption$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_projects_SortOption$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_projects_SortOption$() {
}
$h_Lorg_jpablo_graphexplorer_projects_SortOption$.prototype = $p;
$p.aTh = (function() {
  return this.avl.ae();
});
$p.bb1 = (function(\u03b4name) {
  switch (\u03b4name) {
    case "LastModified": {
      return $s_Lorg_jpablo_graphexplorer_projects_SortOption$__LastModified__Lorg_jpablo_graphexplorer_projects_SortOption();
      break;
    }
    case "Title": {
      return $s_Lorg_jpablo_graphexplorer_projects_SortOption$__Title__Lorg_jpablo_graphexplorer_projects_SortOption();
      break;
    }
    case "CreationDate": {
      return $s_Lorg_jpablo_graphexplorer_projects_SortOption$__CreationDate__Lorg_jpablo_graphexplorer_projects_SortOption();
      break;
    }
    default: {
      throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("enum org.jpablo.graphexplorer.projects.SortOption has no case with name: " + \u03b4name));
    }
  }
});
$p.b6q = (function(stored) {
  if (stored.c()) {
    var this$4 = $m_s_None$();
  } else {
    var x0 = stored.d();
    var xs = $m_Lorg_jpablo_graphexplorer_projects_SortOption$().aTh();
    _return: {
      var i = 0;
      while ((i < xs.a.length)) {
        var x1 = i;
        if ((xs.a[x1].m() === x0)) {
          var idx = i;
          break _return;
        }
        i = ((1 + i) | 0);
      }
      var idx = (-1);
    }
    var this$4 = ((idx === (-1)) ? $m_s_None$() : new $c_s_Some(xs.a[idx]));
  }
  return (this$4.c() ? $m_Lorg_jpablo_graphexplorer_projects_SortOption$().avm : this$4.d());
});
var $d_Lorg_jpablo_graphexplorer_projects_SortOption$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_projects_SortOption$, "org.jpablo.graphexplorer.projects.SortOption$", ({
  wS: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_projects_SortOption$;
function $m_Lorg_jpablo_graphexplorer_projects_SortOption$() {
  if ((!$n_Lorg_jpablo_graphexplorer_projects_SortOption$)) {
    $n_Lorg_jpablo_graphexplorer_projects_SortOption$ = new $c_Lorg_jpablo_graphexplorer_projects_SortOption$();
  }
  return $n_Lorg_jpablo_graphexplorer_projects_SortOption$;
}
function $s_Lorg_jpablo_graphexplorer_router_Route$__Home__Lorg_jpablo_graphexplorer_router_Route() {
  $m_Lorg_jpablo_graphexplorer_router_Route$();
  return $t_Lorg_jpablo_graphexplorer_router_Route$__Home;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_router_Route$() {
  $n_Lorg_jpablo_graphexplorer_router_Route$ = this;
  $t_Lorg_jpablo_graphexplorer_router_Route$__Home = new $c_Lorg_jpablo_graphexplorer_router_Route$$anon$1("Home", 0);
}
$p = $c_Lorg_jpablo_graphexplorer_router_Route$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_router_Route$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_router_Route$() {
}
$h_Lorg_jpablo_graphexplorer_router_Route$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_router_Route$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_router_Route$, "org.jpablo.graphexplorer.router.Route$", ({
  wU: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_router_Route$;
function $m_Lorg_jpablo_graphexplorer_router_Route$() {
  if ((!$n_Lorg_jpablo_graphexplorer_router_Route$)) {
    $n_Lorg_jpablo_graphexplorer_router_Route$ = new $c_Lorg_jpablo_graphexplorer_router_Route$();
  }
  return $n_Lorg_jpablo_graphexplorer_router_Route$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes$() {
  this.a06 = null;
  this.Sp = null;
  $n_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes$ = this;
  this.a06 = $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute.r().C)([$m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillStyle$(), $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BoldStyle$(), $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_InvisibleStyle$(), $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$(), $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$()]))).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId(_$1.aN()))));
  $m_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes$();
  var fill = new $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillStyle$().aab);
  var bold = new $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BoldStyle$().aa1);
  var invisible = new $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_InvisibleStyle$().aai);
  var border = new $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$().a0F);
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$();
  this.Sp = ($m_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes$(), new $c_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes(($m_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes$(), $s_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$__Missing__Lorg_jpablo_graphexplorer_viewer_models_AttrStatus()), ($m_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes$(), $s_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$__Missing__Lorg_jpablo_graphexplorer_viewer_models_AttrStatus()), ($m_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes$(), $s_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$__Missing__Lorg_jpablo_graphexplorer_viewer_models_AttrStatus()), ($m_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes$(), $s_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$__Missing__Lorg_jpablo_graphexplorer_viewer_models_AttrStatus()), ($m_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes$(), $s_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$__Missing__Lorg_jpablo_graphexplorer_viewer_models_AttrStatus())));
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes$.prototype = $p;
$p.WY = (function(attrs) {
  var this$1 = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().qZ(attrs, $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$());
  var borderStr = (this$1.c() ? $m_s_None$() : new $c_s_Some(this$1.d().m()));
  var this$2 = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().qZ(attrs, $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$());
  var cornerStr = (this$2.c() ? $m_s_None$() : new $c_s_Some(this$2.d().m()));
  var xs = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$().aix();
  _return: {
    var i = 0;
    while ((i < xs.a.length)) {
      var x1 = i;
      if (borderStr.E(xs.a[x1].m())) {
        var idx = i;
        break _return;
      }
      i = ((1 + i) | 0);
    }
    var idx = (-1);
  }
  var border = ((idx === (-1)) ? $m_s_None$() : new $c_s_Some(xs.a[idx]));
  var xs$1 = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$().aiy();
  _return$1: {
    var i$1 = 0;
    while ((i$1 < xs$1.a.length)) {
      var x1$1 = i$1;
      if (cornerStr.E(xs$1.a[x1$1].m())) {
        var idx$1 = i$1;
        break _return$1;
      }
      i$1 = ((1 + i$1) | 0);
    }
    var idx$1 = (-1);
  }
  var corner = ((idx$1 === (-1)) ? $m_s_None$() : new $c_s_Some(xs$1.a[idx$1]));
  var this$9 = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().qZ(attrs, $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillStyle$());
  var fillFromStyle = (this$9.c() ? $m_s_None$() : new $c_s_Some(this$9.d().a3T()));
  if (fillFromStyle.E(true)) {
    var this$10 = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().qZ(attrs, $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillColor$());
    if (((!this$10.c()) && (this$10.d().m() === $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillColor$().a0G))) {
      var fillIsNone = true;
    } else {
      var this$11 = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().qZ(attrs, $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Color$());
      var fillIsNone = ((!this$11.c()) && (this$11.d().m() === "none"));
    }
  } else {
    var fillIsNone = false;
  }
  var fillStatus = (fillIsNone ? new $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single(false) : (fillFromStyle.c() ? $s_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$__Missing__Lorg_jpablo_graphexplorer_viewer_models_AttrStatus() : new $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single((!(!fillFromStyle.d())))));
  $m_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes$();
  var this$14 = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().qZ(attrs, $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BoldStyle$());
  var this$15 = (this$14.c() ? $m_s_None$() : new $c_s_Some(this$14.d().a3T()));
  var $x_3 = (this$15.c() ? $s_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$__Missing__Lorg_jpablo_graphexplorer_viewer_models_AttrStatus() : new $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single((!(!this$15.d()))));
  var this$17 = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().qZ(attrs, $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_InvisibleStyle$());
  var this$18 = (this$17.c() ? $m_s_None$() : new $c_s_Some(this$17.d().a3T()));
  var $x_2 = (this$18.c() ? $s_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$__Missing__Lorg_jpablo_graphexplorer_viewer_models_AttrStatus() : new $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single((!(!this$18.d()))));
  var this$21 = (border.c() ? $m_s_None$() : new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single(border.d())));
  var $x_1 = (this$21.c() ? $s_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$__Missing__Lorg_jpablo_graphexplorer_viewer_models_AttrStatus() : this$21.d());
  var this$23 = (corner.c() ? $m_s_None$() : new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single(corner.d())));
  return new $c_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes(fillStatus, $x_3, $x_2, $x_1, (this$23.c() ? $s_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$__Missing__Lorg_jpablo_graphexplorer_viewer_models_AttrStatus() : this$23.d()));
});
$p.b1U = (function(styleStr) {
  matchAlts1: {
    matchAlts2: {
      if (($m_s_None$() === styleStr)) {
        break matchAlts2;
      }
      if (((styleStr instanceof $c_s_Some) && (styleStr.J === ""))) {
        break matchAlts2;
      }
      break matchAlts1;
    }
    return this.Sp;
  }
  if ((styleStr instanceof $c_s_Some)) {
    var str = styleStr.J;
    var $x_13 = $m_sci_Set$();
    var $x_12 = $m_s_Predef$();
    var xs = $f_T__split__T__I__AT(str, ",", 0);
    var f = ((_$14) => $f_T__trim__T(_$14));
    var len = xs.a.length;
    var ys = new ($d_T.r().C)(len);
    if ((len > 0)) {
      var i = 0;
      if ((xs !== null)) {
        while ((i < len)) {
          var $x_1 = i;
          var x0 = xs.a[i];
          ys.a[$x_1] = f(x0);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_I)) {
        while ((i < len)) {
          var $x_2 = i;
          var x0$1 = xs.a[i];
          ys.a[$x_2] = f(x0$1);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_D)) {
        while ((i < len)) {
          var $x_3 = i;
          var x0$2 = xs.a[i];
          ys.a[$x_3] = f(x0$2);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_J)) {
        while ((i < len)) {
          var $x_6 = i;
          var $x_4 = xs.a;
          var $x_5 = (i << 1);
          var x0$3_$_lo = $x_4[$x_5];
          var x0$3_$_hi = $x_4[(($x_5 + 1) | 0)];
          ys.a[$x_6] = f($bL(x0$3_$_lo, x0$3_$_hi));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_F)) {
        while ((i < len)) {
          var $x_7 = i;
          var x0$4 = xs.a[i];
          ys.a[$x_7] = f(x0$4);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_C)) {
        while ((i < len)) {
          var $x_8 = i;
          var x0$5 = xs.a[i];
          ys.a[$x_8] = f($bC(x0$5));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_B)) {
        while ((i < len)) {
          var $x_9 = i;
          var x0$6 = xs.a[i];
          ys.a[$x_9] = f(x0$6);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_S)) {
        while ((i < len)) {
          var $x_10 = i;
          var x0$7 = xs.a[i];
          ys.a[$x_10] = f(x0$7);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_Z)) {
        while ((i < len)) {
          var $x_11 = i;
          var x0$8 = xs.a[i];
          ys.a[$x_11] = f(x0$8);
          i = ((1 + i) | 0);
        }
      } else {
        throw new $c_s_MatchError(xs);
      }
    }
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var i$1 = 0;
    while ((i$1 < ys.a.length)) {
      var x$1 = ys.a[i$1];
      if ((x$1 !== "")) {
        var unboxedElem = ((x$1 === null) ? null : x$1);
        jsElems.push(unboxedElem);
      }
      i$1 = ((1 + i$1) | 0);
    }
    var parts = $x_13.af($x_12.fB(new ($d_T.r().C)(jsElems)));
    if (parts.c()) {
      return this.Sp;
    } else {
      $m_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes$();
      var a$proxy1 = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$().aCg.m();
      if (parts.E(a$proxy1)) {
        var $x_17 = new $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single(true);
      } else {
        var $x_17 = $s_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$__Missing__Lorg_jpablo_graphexplorer_viewer_models_AttrStatus();
      }
      var a$proxy2 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__bold__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle().m();
      if (parts.E(a$proxy2)) {
        var $x_16 = new $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single(true);
      } else {
        var $x_16 = $s_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$__Missing__Lorg_jpablo_graphexplorer_viewer_models_AttrStatus();
      }
      var a$proxy3 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__invis__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle().m();
      if (parts.E(a$proxy3)) {
        var $x_15 = new $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single(true);
      } else {
        var $x_15 = $s_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$__Missing__Lorg_jpablo_graphexplorer_viewer_models_AttrStatus();
      }
      var xs$1 = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$().aix();
      _return: {
        var i$2 = 0;
        while ((i$2 < xs$1.a.length)) {
          var x1 = i$2;
          var x0$9 = xs$1.a[x1];
          var a$proxy4 = x0$9.m();
          if (parts.E(a$proxy4)) {
            var idx = i$2;
            break _return;
          }
          i$2 = ((1 + i$2) | 0);
        }
        var idx = (-1);
      }
      var this$19 = ((idx === (-1)) ? $m_s_None$() : new $c_s_Some(xs$1.a[idx]));
      var this$21 = (this$19.c() ? $m_s_None$() : new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single(this$19.d())));
      var $x_14 = (this$21.c() ? $s_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$__Missing__Lorg_jpablo_graphexplorer_viewer_models_AttrStatus() : this$21.d());
      var xs$2 = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$().aiy();
      _return$1: {
        var i$3 = 0;
        while ((i$3 < xs$2.a.length)) {
          var x1$1 = i$3;
          var x0$11 = xs$2.a[x1$1];
          var a$proxy5 = x0$11.m();
          if (parts.E(a$proxy5)) {
            var idx$1 = i$3;
            break _return$1;
          }
          i$3 = ((1 + i$3) | 0);
        }
        var idx$1 = (-1);
      }
      var this$25 = ((idx$1 === (-1)) ? $m_s_None$() : new $c_s_Some(xs$2.a[idx$1]));
      var this$27 = (this$25.c() ? $m_s_None$() : new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single(this$25.d())));
      return new $c_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes($x_17, $x_16, $x_15, $x_14, (this$27.c() ? $s_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$__Missing__Lorg_jpablo_graphexplorer_viewer_models_AttrStatus() : this$27.d()));
    }
  }
  throw new $c_s_MatchError(styleStr);
});
$p.b7v = (function(attrs, subAttrs) {
  return (((!$m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().qZ(attrs, $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillColor$()).c()) && (!subAttrs.x1.Py(true, $m_s_CanEqual$derived$()))) ? $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().W6(attrs, $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillColor$()) : attrs);
});
var $d_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes$, "org.jpablo.graphexplorer.viewer.attributes.styleSubAttributes.StyleSubAttributes$", ({
  wZ: 1,
  d: 1,
  j: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes$;
function $m_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes$ = new $c_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes$;
}
function $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__DOT__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat() {
  $m_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$();
  return $t_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__DOT;
}
function $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__Mermaid__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat() {
  $m_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$();
  return $t_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__Mermaid;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$() {
  this.avp = null;
  this.avq = null;
  this.avr = false;
  $n_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$ = this;
  $t_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__DOT = new $c_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$$anon$1("DOT", 0);
  $t_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__Mermaid = new $c_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$$anon$1("Mermaid", 1);
  this.avp = new ($d_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat.r().C)([$s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__DOT__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat(), $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__Mermaid__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat()]);
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$.prototype = $p;
$p.aTi = (function() {
  return this.avp.ae();
});
$p.a5d = (function(\u03b4name) {
  if ((\u03b4name === "DOT")) {
    return $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__DOT__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat();
  }
  if ((\u03b4name === "Mermaid")) {
    return $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__Mermaid__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat();
  }
  throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("enum org.jpablo.graphexplorer.viewer.backends.DiagramFormat has no case with name: " + \u03b4name));
});
$p.Pg = (function(text) {
  var this$1 = this.WB(text);
  return (this$1.c() ? $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__DOT__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat() : this$1.d());
});
$p.WB = (function(text) {
  return ($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$().b4c(text) ? new $c_s_Some($s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__Mermaid__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat()) : ((!$m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$().Aj(text).c()) ? new $c_s_Some($s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__DOT__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat()) : $m_s_None$()));
});
$p.nx = (function() {
  if ((!this.avr)) {
    this.avq = $m_s_CanEqual$derived$();
    this.avr = true;
  }
  return this.avq;
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$, "org.jpablo.graphexplorer.viewer.backends.DiagramFormat$", ({
  x1: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$;
function $m_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$ = new $c_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_PastedDiagram$__unfence__T__T2($thiz, text) {
  var this$4 = new $c_sc_StringOps$$anon$1(text, true);
  var lines = $m_sci_Vector$().X(this$4);
  var opening = $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(new $c_sc_Iterator$$anon$16(lines.o()), new $c_Lorg_jpablo_graphexplorer_viewer_backends_PastedDiagram$$anon$1());
  if (($m_s_None$() === opening)) {
    return new $c_T2(text, $m_s_None$());
  }
  if ((opening instanceof $c_s_Some)) {
    var x29 = opening.J;
    if ((x29 !== null)) {
      var start = (x29.bH | 0);
      var marker = x29.bU;
      var info = x29.c3;
      var from = ((1 + start) | 0);
      var this$8 = lines.o();
      _return: {
        var i = ((from > 0) ? from : 0);
        var dropped = this$8.iV(from);
        while (dropped.p()) {
          if ($p_Lorg_jpablo_graphexplorer_viewer_backends_PastedDiagram$__isClosing$1__T__T__Z($thiz, marker, dropped.q())) {
            var end = i;
            break _return;
          }
          i = ((1 + i) | 0);
        }
        var end = (-1);
      }
      return new $c_T2($f_sc_IterableOnceOps__mkString__T__T__T__T(((end >= 0) ? lines.pH(((1 + start) | 0), end) : lines.pH(((1 + start) | 0), lines.C())), "", "\n", ""), $thiz.avs.r(info.toLowerCase()));
    }
  }
  throw new $c_s_MatchError(opening);
}
function $p_Lorg_jpablo_graphexplorer_viewer_backends_PastedDiagram$__isClosing$1__T__T__Z($thiz, marker$1, line) {
  if ((line !== null)) {
    var x23 = $thiz.a07.jw(line);
    if ((!x23.c())) {
      var x24 = x23.d();
      if ((x24.bL(2) === 0)) {
        var x25 = $f_sc_LinearSeqOps__apply__I__O(x24, 0);
        if (($f_sc_LinearSeqOps__apply__I__O(x24, 1) === "")) {
          return (($m_sc_StringOps$().pw(x25) === $m_sc_StringOps$().pw(marker$1)) && (x25.length >= marker$1.length));
        }
      }
    }
  }
  return false;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_PastedDiagram$() {
  this.avs = null;
  this.a07 = null;
  $n_Lorg_jpablo_graphexplorer_viewer_backends_PastedDiagram$ = this;
  this.avs = $m_sci_Map$().ao($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("mermaid", $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__Mermaid__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat()), new $c_T2("mmd", $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__Mermaid__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat()), new $c_T2("dot", $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__DOT__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat()), new $c_T2("gv", $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__DOT__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat()), new $c_T2("graphviz", $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__DOT__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat())])));
  this.a07 = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "^\\s*(`{3,}|~{3,})\\s*([A-Za-z0-9_+#.-]*)\\s*$", $m_sci_Nil$());
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_PastedDiagram$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_PastedDiagram$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_PastedDiagram$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_PastedDiagram$.prototype = $p;
$p.Pm = (function(raw) {
  var this$1 = raw.split("\r\n").join("\n");
  var text = this$1.split("\r").join("\n");
  matchResult4: {
    var \u03b41$___1;
    var \u03b41$___2;
    var x5 = $p_Lorg_jpablo_graphexplorer_viewer_backends_PastedDiagram$__unfence__T__T2(this, text);
    if ((x5 !== null)) {
      var \u03b41$___1 = x5.g();
      var \u03b41$___2 = x5.h();
      break matchResult4;
    }
    throw new $c_s_MatchError(x5);
  }
  var body$2 = \u03b41$___1;
  var hint$2 = \u03b41$___2;
  if (($f_T__trim__T(body$2) !== "")) {
    var fromBody = $m_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$().WB(body$2);
    $m_Lorg_jpablo_graphexplorer_viewer_backends_PastedDiagram$();
    var this$6 = (hint$2.c() ? fromBody : hint$2);
    return new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_backends_PastedDiagram(body$2, (this$6.c() ? $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__DOT__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat() : this$6.d()), (!(hint$2.c() ? fromBody : hint$2).c())));
  } else {
    return $m_s_None$();
  }
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_PastedDiagram$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_PastedDiagram$, "org.jpablo.graphexplorer.viewer.backends.PastedDiagram$", ({
  x4: 1,
  d: 1,
  j: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_backends_PastedDiagram$;
function $m_Lorg_jpablo_graphexplorer_viewer_backends_PastedDiagram$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_backends_PastedDiagram$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_backends_PastedDiagram$ = new $c_Lorg_jpablo_graphexplorer_viewer_backends_PastedDiagram$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_backends_PastedDiagram$;
}
function $s_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$__Comments__Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent() {
  $m_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$();
  return $t_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$__Comments;
}
function $s_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$__StrictKeyword__Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent() {
  $m_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$();
  return $t_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$__StrictKeyword;
}
function $s_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$__Directives__Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent() {
  $m_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$();
  return $t_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$__Directives;
}
function $s_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$__ClickHandlers__Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent() {
  $m_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$();
  return $t_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$__ClickHandlers;
}
function $s_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$__AccessibilityText__Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent() {
  $m_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$();
  return $t_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$__AccessibilityText;
}
function $s_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$__SubgraphDirection__Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent() {
  $m_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$();
  return $t_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$__SubgraphDirection;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$() {
  this.avz = null;
  $n_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$ = this;
  $t_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$__Comments = new $c_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$1();
  $t_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$__StrictKeyword = new $c_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$2();
  $t_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$__Directives = new $c_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$3();
  $t_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$__ClickHandlers = new $c_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$4();
  $t_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$__AccessibilityText = new $c_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$5();
  $t_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$__SubgraphDirection = new $c_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$6();
  this.avz = new ($d_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent.r().C)([$s_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$__Comments__Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent(), $s_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$__StrictKeyword__Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent(), $s_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$__Directives__Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent(), $s_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$__ClickHandlers__Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent(), $s_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$__AccessibilityText__Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent(), $s_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$__SubgraphDirection__Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent()]);
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$.prototype = $p;
$p.bb4 = (function() {
  return this.avz.ae();
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$, "org.jpablo.graphexplorer.viewer.backends.UnmodeledContent$", ({
  x9: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$;
function $m_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$ = new $c_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$Scan$() {
  this.avE = null;
  $n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$Scan$ = this;
  this.avE = ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$Scan$(), new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$Scan(0, false, $m_s_None$()));
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$Scan$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$Scan$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$Scan$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$Scan$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$Scan$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$Scan$, "org.jpablo.graphexplorer.viewer.backends.graphviz.DotSourceScan$Scan$", ({
  xj: 1,
  d: 1,
  j: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$Scan$;
function $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$Scan$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$Scan$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$Scan$ = new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$Scan$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$Scan$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$() {
  this.avG = null;
  this.avH = false;
  $n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$ = this;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var directed = true;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var objects = $m_s_None$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var edges = $m_s_None$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var fontname = $m_s_None$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var fontsize = $m_s_None$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var label = $m_s_None$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var labelloc = $m_s_None$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var lp = $m_s_None$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var lheight = $m_s_None$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var lwidth = $m_s_None$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var rankdir = $m_s_None$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var layout = $m_s_None$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var bgcolor = $m_s_None$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var nodesep = $m_s_None$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var pad = $m_s_None$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var ranksep = $m_s_None$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var ratio = $m_s_None$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var splines = $m_s_None$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var overlap = $m_s_None$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var normalize = $m_s_None$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var start = $m_s_None$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var beautify = $m_s_None$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var Damping = $m_s_None$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var defaultdist = $m_s_None$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var dim = $m_s_None$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var dimen = $m_s_None$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var diredgeconstraints = $m_s_None$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var dpi = $m_s_None$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var epsilon = $m_s_None$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var esep = $m_s_None$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var fontnames = $m_s_None$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var fontpath = $m_s_None$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var K = $m_s_None$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var label_scheme = $m_s_None$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var labeljust = $m_s_None$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var landscape = $m_s_None$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var layerlistsep = $m_s_None$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var layers = $m_s_None$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var layerselect = $m_s_None$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var layersep = $m_s_None$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var nojustify = $m_s_None$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var notranslate = $m_s_None$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var target = $m_s_None$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var TBbalance = $m_s_None$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var tooltip = $m_s_None$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var truecolor = $m_s_None$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var URL = $m_s_None$();
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$.prototype = $p;
$p.a3I = (function() {
  if ((!this.avH)) {
    var get$proxy4 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$5) => _$5.rx));
    var set$proxy4 = new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((g, e) => new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph(g.zf, g.rw, g.o5, g.q5, g.ry, g.rz, g.rA, g.rB, g.rE, g.rD, g.rF, g.rK, g.rC, g.rv, g.rG, g.rJ, g.rL, g.rM, g.rN, g.rI, g.rH, g.rO, g.uM, g.uI, g.uN, g.uO, g.uP, g.uQ, g.uR, g.uS, g.uT, g.uU, g.uV, g.uJ, g.uW, g.uX, g.uY, g.uZ, g.v0, g.v1, g.v2, g.v3, g.v4, g.v5, g.uK, g.v6, g.v7, g.uL, e)));
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var Tuple_this = $m_sr_TupleXXL$().a2M($m_sr_ScalaRunTime$().f(new $ac_O(["name", "directed", "objects", "edges", "fontname", "fontsize", "label", "labelloc", "lp", "lheight", "lwidth", "rankdir", "layout", "bgcolor", "nodesep", "pad", "ranksep", "ratio", "splines", "overlap", "normalize", "start", "beautify", "Damping", "defaultdist", "dim", "dimen", "diredgeconstraints", "dpi", "epsilon", "esep", "fontnames", "fontpath", "K", "label_scheme", "labeljust", "landscape", "layerlistsep", "layers", "layerselect", "layersep", "nojustify", "notranslate", "target", "TBbalance", "tooltip", "truecolor", "URL", "extraAttrs"])));
    var this$4 = $m_sci_Nil$().b6(new $c_s_Product$$anon$1(Tuple_this));
    var f = ((_$1) => _$1);
    var $x_2 = $m_sci_Set$();
    if ((this$4 === $m_sci_Nil$())) {
      var $x_1 = $m_sci_Nil$();
    } else {
      var x0 = this$4.t();
      var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
      var t = h;
      var rest = this$4.v();
      while ((rest !== $m_sci_Nil$())) {
        var x0$1 = rest.t();
        var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
        t.U = nx;
        t = nx;
        rest = rest.v();
      }
      var $x_1 = h;
    }
    var knownKeys = $x_2.af($x_1);
    var MacroImplicits_this = $m_Lupickle_default$();
    var base = MacroImplicits_this.cw().ez(new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$$anon$9(MacroImplicits_this, 49, this), new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$$anon$10(MacroImplicits_this, this));
    $m_Lupickle_default$();
    this.avG = new $c_Lupickle_core_Types$$anon$1(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((t$1) => $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ExtraAttrs$().a4c($f_Lupickle_Api__writeJs__O__Lupickle_core_Types$Writer__Lujson_Value($m_Lupickle_default$(), t$1, base), get$proxy4.i(t$1)))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((js) => set$proxy4.R($f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), js, ($m_Lupickle_default$(), false), base), $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ExtraAttrs$().a2Q(js, knownKeys)))), $m_Lupickle_default$().cw().ez($f_Lupickle_LowPriReadWriters__JsValueR__Lupickle_core_Types$Reader($m_Lupickle_default$()), new $c_Lupickle_LowPriReadWriters$$anon$1($m_Lupickle_default$())));
    this.avH = true;
  }
  return this.avG;
});
$p.b5H = (function(ReadersVersionSpecific_this$11) {
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.eO();
  }
  return true;
});
$p.b5I = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params, collection) => {
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    return new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph(params.a[0], (!(!params.a[1])), params.a[2], params.a[3], params.a[4], params.a[5], params.a[6], params.a[7], params.a[8], params.a[9], params.a[10], params.a[11], params.a[12], params.a[13], params.a[14], params.a[15], params.a[16], params.a[17], params.a[18], params.a[19], params.a[20], params.a[21], params.a[22], params.a[23], params.a[24], params.a[25], params.a[26], params.a[27], params.a[28], params.a[29], params.a[30], params.a[31], params.a[32], params.a[33], params.a[34], params.a[35], params.a[36], params.a[37], params.a[38], params.a[39], params.a[40], params.a[41], params.a[42], params.a[43], params.a[44], params.a[45], params.a[46], params.a[47], params.a[48]);
  }));
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$, "org.jpablo.graphexplorer.viewer.backends.graphviz.vizjs.simplegraph.SimpleGraph$", ({
  xq: 1,
  d: 1,
  j: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$;
function $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$ = new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphCluster$() {
  this.avI = null;
  this.avJ = false;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphCluster$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphCluster$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphCluster$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphCluster$.prototype = $p;
$p.aOX = (function() {
  if ((!this.avJ)) {
    var get$proxy2 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3) => _$3.rV));
    var set$proxy2 = new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((c, e) => new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphCluster(c.v8, c.p1, c.q7, c.s0, c.q6, c.q8, c.rY, c.rZ, c.rX, c.rT, c.s8, c.s9, c.rQ, c.rW, c.sd, c.s1, c.s2, c.s3, c.s4, c.s5, c.v9, c.s6, c.sc, c.s7, c.rS, c.va, c.sa, c.sb, c.se, c.sf, c.rP, c.rR, c.rU, e)));
    var Tuple_this = $m_sr_TupleXXL$().a2M($m_sr_ScalaRunTime$().f(new $ac_O(["_gvid", "name", "nodes", "label", "edges", "subgraphs", "fontname", "fontsize", "fontcolor", "color", "pencolor", "penwidth", "bgcolor", "fillcolor", "style", "labeljust", "labelloc", "lheight", "lp", "lwidth", "layout", "normalize", "start", "overlap", "cluster", "rankdir", "rank", "splines", "target", "tooltip", "URL", "class", "colorscheme", "extraAttrs"])));
    var this$4 = $m_sci_Nil$().b6(new $c_s_Product$$anon$1(Tuple_this));
    var f = ((_$1) => _$1);
    var $x_2 = $m_sci_Set$();
    if ((this$4 === $m_sci_Nil$())) {
      var $x_1 = $m_sci_Nil$();
    } else {
      var x0 = this$4.t();
      var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
      var t = h;
      var rest = this$4.v();
      while ((rest !== $m_sci_Nil$())) {
        var x0$1 = rest.t();
        var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
        t.U = nx;
        t = nx;
        rest = rest.v();
      }
      var $x_1 = h;
    }
    var knownKeys = $x_2.af($x_1);
    var MacroImplicits_this = $m_Lupickle_default$();
    var base = MacroImplicits_this.cw().ez(new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphCluster$$anon$4(MacroImplicits_this, 34, this), new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphCluster$$anon$5(MacroImplicits_this, this));
    $m_Lupickle_default$();
    this.avI = new $c_Lupickle_core_Types$$anon$1(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((t$1) => $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ExtraAttrs$().a4c($f_Lupickle_Api__writeJs__O__Lupickle_core_Types$Writer__Lujson_Value($m_Lupickle_default$(), t$1, base), get$proxy2.i(t$1)))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((js) => set$proxy2.R($f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), js, ($m_Lupickle_default$(), false), base), $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ExtraAttrs$().a2Q(js, knownKeys)))), $m_Lupickle_default$().cw().ez($f_Lupickle_LowPriReadWriters__JsValueR__Lupickle_core_Types$Reader($m_Lupickle_default$()), new $c_Lupickle_LowPriReadWriters$$anon$1($m_Lupickle_default$())));
    this.avJ = true;
  }
  return this.avI;
});
$p.b5J = (function(ReadersVersionSpecific_this$5) {
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.eO();
  }
  return true;
});
$p.b5K = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params, collection) => new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphCluster((params.a[0] | 0), params.a[1], params.a[2], params.a[3], params.a[4], params.a[5], params.a[6], params.a[7], params.a[8], params.a[9], params.a[10], params.a[11], params.a[12], params.a[13], params.a[14], params.a[15], params.a[16], params.a[17], params.a[18], params.a[19], params.a[20], params.a[21], params.a[22], params.a[23], params.a[24], params.a[25], params.a[26], params.a[27], params.a[28], params.a[29], params.a[30], params.a[31], params.a[32], params.a[33])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphCluster$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphCluster$, "org.jpablo.graphexplorer.viewer.backends.graphviz.vizjs.simplegraph.SimpleGraphCluster$", ({
  xu: 1,
  d: 1,
  j: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphCluster$;
function $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphCluster$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphCluster$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphCluster$ = new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphCluster$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphCluster$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge$() {
  this.avK = null;
  this.avL = false;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge$.prototype = $p;
$p.agh = (function() {
  if ((!this.avL)) {
    var get$proxy3 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4) => _$4.so));
    var set$proxy3 = new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((ed, e) => new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge(ed.vb, ed.qd, ed.q9, ed.qc, ed.qb, ed.ss, ed.sp, ed.sq, ed.sk, ed.sB, ed.sF, ed.sz, ed.sy, ed.sm, ed.sr, ed.qa, ed.qe, ed.sg, ed.si, ed.sh, ed.sn, ed.sj, ed.sl, ed.sx, ed.sA, ed.sC, ed.sD, ed.sE, ed.sH, ed.sI, ed.sL, ed.sM, ed.st, ed.su, ed.sv, ed.sw, ed.sJ, ed.sK, ed.sG, e)));
    var Tuple_this = $m_sr_TupleXXL$().a2M($m_sr_ScalaRunTime$().f(new $ac_O(["_gvid", "tail", "head", "pos", "id", "label", "fontname", "fontsize", "color", "penwidth", "style", "lp", "len", "constraint", "forcelabels", "headport", "tailport", "arrowhead", "arrowtail", "arrowsize", "dir", "class", "colorscheme", "layer", "nojustify", "samehead", "sametail", "showboxes", "tail_lp", "tailclip", "target", "tooltip", "labeldistance", "labelfloat", "labelfontcolor", "labelfontname", "tailtarget", "tailtooltip", "tailURL", "extraAttrs"])));
    var this$4 = $m_sci_Nil$().b6(new $c_s_Product$$anon$1(Tuple_this));
    var f = ((_$1) => _$1);
    var $x_2 = $m_sci_Set$();
    if ((this$4 === $m_sci_Nil$())) {
      var $x_1 = $m_sci_Nil$();
    } else {
      var x0 = this$4.t();
      var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
      var t = h;
      var rest = this$4.v();
      while ((rest !== $m_sci_Nil$())) {
        var x0$1 = rest.t();
        var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
        t.U = nx;
        t = nx;
        rest = rest.v();
      }
      var $x_1 = h;
    }
    var knownKeys = $x_2.af($x_1);
    var MacroImplicits_this = $m_Lupickle_default$();
    var base = MacroImplicits_this.cw().ez(new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge$$anon$6(MacroImplicits_this, 40, this), new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge$$anon$7(MacroImplicits_this, this));
    $m_Lupickle_default$();
    this.avK = new $c_Lupickle_core_Types$$anon$1(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((t$1) => $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ExtraAttrs$().a4c($f_Lupickle_Api__writeJs__O__Lupickle_core_Types$Writer__Lujson_Value($m_Lupickle_default$(), t$1, base), get$proxy3.i(t$1)))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((js) => set$proxy3.R($f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), js, ($m_Lupickle_default$(), false), base), $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ExtraAttrs$().a2Q(js, knownKeys)))), $m_Lupickle_default$().cw().ez($f_Lupickle_LowPriReadWriters__JsValueR__Lupickle_core_Types$Reader($m_Lupickle_default$()), new $c_Lupickle_LowPriReadWriters$$anon$1($m_Lupickle_default$())));
    this.avL = true;
  }
  return this.avK;
});
$p.b5L = (function(ReadersVersionSpecific_this$8) {
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.eO();
  }
  return true;
});
$p.b5M = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params, collection) => new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge((params.a[0] | 0), (params.a[1] | 0), (params.a[2] | 0), params.a[3], params.a[4], params.a[5], params.a[6], params.a[7], params.a[8], params.a[9], params.a[10], params.a[11], params.a[12], params.a[13], params.a[14], params.a[15], params.a[16], params.a[17], params.a[18], params.a[19], params.a[20], params.a[21], params.a[22], params.a[23], params.a[24], params.a[25], params.a[26], params.a[27], params.a[28], params.a[29], params.a[30], params.a[31], params.a[32], params.a[33], params.a[34], params.a[35], params.a[36], params.a[37], params.a[38], params.a[39])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge$, "org.jpablo.graphexplorer.viewer.backends.graphviz.vizjs.simplegraph.SimpleGraphEdge$", ({
  xx: 1,
  d: 1,
  j: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge$;
function $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge$ = new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphNode$() {
  this.avM = null;
  this.avN = false;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphNode$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphNode$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphNode$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphNode$.prototype = $p;
$p.aOY = (function() {
  if ((!this.avN)) {
    var get$proxy1 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => _$2.sS));
    var set$proxy1 = new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((n, e) => new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphNode(n.vc, n.p2, n.zg, n.qg, n.qf, n.qh, n.t8, n.sW, n.sX, n.sV, n.sQ, n.sT, n.ta, n.t4, n.t6, n.t9, n.t5, n.sU, n.t7, n.t3, n.sN, n.sO, n.sP, n.sR, n.tb, n.tc, n.td, n.sY, n.sZ, n.t0, n.t1, n.t2, e)));
    var Tuple_this = $m_sr_TupleXXL$().a2M($m_sr_ScalaRunTime$().f(new $ac_O(["_gvid", "name", "label", "pos", "height", "width", "shape", "fontname", "fontsize", "fontcolor", "color", "fillcolor", "style", "penwidth", "rects", "sides", "peripheries", "fixedsize", "regular", "orientation", "URL", "area", "class", "colorscheme", "target", "tooltip", "vertices", "image", "imagepath", "imagepos", "margin", "nojustify", "extraAttrs"])));
    var this$4 = $m_sci_Nil$().b6(new $c_s_Product$$anon$1(Tuple_this));
    var f = ((_$1) => _$1);
    var $x_2 = $m_sci_Set$();
    if ((this$4 === $m_sci_Nil$())) {
      var $x_1 = $m_sci_Nil$();
    } else {
      var x0 = this$4.t();
      var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
      var t = h;
      var rest = this$4.v();
      while ((rest !== $m_sci_Nil$())) {
        var x0$1 = rest.t();
        var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
        t.U = nx;
        t = nx;
        rest = rest.v();
      }
      var $x_1 = h;
    }
    var knownKeys = $x_2.af($x_1);
    var MacroImplicits_this = $m_Lupickle_default$();
    var base = MacroImplicits_this.cw().ez(new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphNode$$anon$2(MacroImplicits_this, 33, this), new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphNode$$anon$3(MacroImplicits_this, this));
    $m_Lupickle_default$();
    this.avM = new $c_Lupickle_core_Types$$anon$1(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((t$1) => $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ExtraAttrs$().a4c($f_Lupickle_Api__writeJs__O__Lupickle_core_Types$Writer__Lujson_Value($m_Lupickle_default$(), t$1, base), get$proxy1.i(t$1)))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((js) => set$proxy1.R($f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), js, ($m_Lupickle_default$(), false), base), $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ExtraAttrs$().a2Q(js, knownKeys)))), $m_Lupickle_default$().cw().ez($f_Lupickle_LowPriReadWriters__JsValueR__Lupickle_core_Types$Reader($m_Lupickle_default$()), new $c_Lupickle_LowPriReadWriters$$anon$1($m_Lupickle_default$())));
    this.avN = true;
  }
  return this.avM;
});
$p.b5N = (function(ReadersVersionSpecific_this$2) {
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.eO();
  }
  return true;
});
$p.b5O = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params, collection) => new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphNode((params.a[0] | 0), params.a[1], params.a[2], params.a[3], params.a[4], params.a[5], params.a[6], params.a[7], params.a[8], params.a[9], params.a[10], params.a[11], params.a[12], params.a[13], params.a[14], params.a[15], params.a[16], params.a[17], params.a[18], params.a[19], params.a[20], params.a[21], params.a[22], params.a[23], params.a[24], params.a[25], params.a[26], params.a[27], params.a[28], params.a[29], params.a[30], params.a[31], params.a[32])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphNode$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphNode$, "org.jpablo.graphexplorer.viewer.backends.graphviz.vizjs.simplegraph.SimpleGraphNode$", ({
  xA: 1,
  d: 1,
  j: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphNode$;
function $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphNode$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphNode$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphNode$ = new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphNode$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphNode$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject$() {
  this.avO = null;
  this.avP = false;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject$.prototype = $p;
$p.agi = (function() {
  if ((!this.avP)) {
    this.avO = ($m_Lupickle_default$(), new $c_Lupickle_core_Types$$anon$1(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
      if ((x$1 instanceof $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject$Node)) {
        var x42 = x$1.BU;
        return $f_Lupickle_Api__writeJs__O__Lupickle_core_Types$Writer__Lujson_Value($m_Lupickle_default$(), x42, $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphNode$().aOY());
      }
      if ((x$1 instanceof $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject$Cluster)) {
        var x39 = x$1.FU;
        return $f_Lupickle_Api__writeJs__O__Lupickle_core_Types$Writer__Lujson_Value($m_Lupickle_default$(), x39, $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphCluster$().aOX());
      }
      throw new $c_s_MatchError(x$1);
    })), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((jsValue) => (($f_sc_MapOps__contains__O__Z($f_Lujson_Value__obj__Lupickle_core_LinkedHashMap(jsValue), "nodes") || $f_sc_MapOps__contains__O__Z($f_Lujson_Value__obj__Lupickle_core_LinkedHashMap(jsValue), "cluster")) ? new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject$Cluster($f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), jsValue, ($m_Lupickle_default$(), false), $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphCluster$().aOX())) : new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject$Node($f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), jsValue, ($m_Lupickle_default$(), false), $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphNode$().aOY()))))), $m_Lupickle_default$().cw().ez($f_Lupickle_LowPriReadWriters__JsValueR__Lupickle_core_Types$Reader($m_Lupickle_default$()), new $c_Lupickle_LowPriReadWriters$$anon$1($m_Lupickle_default$()))));
    this.avP = true;
  }
  return this.avO;
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject$, "org.jpablo.graphexplorer.viewer.backends.graphviz.vizjs.simplegraph.SimpleGraphObject$", ({
  xD: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject$;
function $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject$ = new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$.prototype = $p;
$p.bcX = (function(color) {
  var this$1 = $m_Lorg_jpablo_graphexplorer_viewer_color_X11Colors$package$().aw7;
  var key = color.toLowerCase();
  var x1 = this$1.r(key);
  if ((x1 instanceof $c_s_Some)) {
    var $x_1 = x1.J;
  } else {
    if ((!($m_s_None$() === x1))) {
      throw new $c_s_MatchError(x1);
    }
    var $x_1 = "#000000";
  }
  return $x_1;
});
$p.aQC = (function(oklch) {
  matchResult16: {
    var \u03b41$___1;
    var \u03b41$___2;
    var \u03b41$___3;
    if ((oklch !== null)) {
      var \u03b41$___1 = oklch.LB;
      var \u03b41$___2 = oklch.Lz;
      var \u03b41$___3 = oklch.LA;
      break matchResult16;
    }
    throw new $c_s_MatchError(oklch);
  }
  var l$2 = (+\u03b41$___1);
  var c$2 = (+\u03b41$___2);
  var h$2 = (+\u03b41$___3);
  var hRad = ((3.141592653589793 * h$2) / 180.0);
  var a = (c$2 * (+Math.cos(hRad)));
  var bLab = (c$2 * (+Math.sin(hRad)));
  var l_ = ((l$2 + (0.3963377774 * a)) + (0.2158037573 * bLab));
  var m_ = ((l$2 - (0.1055613458 * a)) - (0.0638541728 * bLab));
  var s_ = ((l$2 - (0.0894841775 * a)) - (1.291485548 * bLab));
  var l_cubed = ((l_ * l_) * l_);
  var m_cubed = ((m_ * m_) * m_);
  var s_cubed = ((s_ * s_) * s_);
  var linearR = (((4.0767416621 * l_cubed) - (3.3077115913 * m_cubed)) + (0.2309699292 * s_cubed));
  var linearG = ((((-1.2684380046) * l_cubed) + (2.6097574011 * m_cubed)) - (0.3413193965 * s_cubed));
  var linearB = ((((-0.0041960863) * l_cubed) - (0.7034186147 * m_cubed)) + (1.707614701 * s_cubed));
  return new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$RGB(this.agU(linearR), this.agU(linearG), this.agU(linearB));
});
$p.agU = (function(c) {
  if ((c <= 0.0)) {
    var v = 0;
  } else if ((c >= 1.0)) {
    var v = 255;
  } else {
    var srgb = ((c <= 0.0031308) ? (12.92 * c) : ((1.055 * (+Math.pow(c, 0.4166666666666667))) - 0.055));
    var a = (255.0 * srgb);
    var $x_1 = $m_RTLong$().d1((+Math.round(a)));
    var v = $s_RTLong__toInt__I__I__I($x_1.l, $x_1.h);
  }
  var b = ((v > 255) ? 255 : v);
  return ((b < 0) ? 0 : b);
});
$p.Y7 = (function(color) {
  var color$tailLocal1 = color;
  while (true) {
    var x26 = color$tailLocal1;
    if ((x26 instanceof $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$RGB)) {
      return new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$Hex($m_sc_StringOps$().u0("#%02x%02x%02x", $m_sr_ScalaRunTime$().hP(new $ac_O([x26.G4, x26.G3, x26.G2]))));
    }
    if ((x26 instanceof $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$RGBA)) {
      var x34 = x26.G7;
      var x35 = x26.G6;
      var x36 = x26.G5;
      var x37 = x26.LC;
      var $x_3 = $m_sc_StringOps$();
      var $x_2 = $m_sr_ScalaRunTime$();
      var a = (255.0 * x37);
      var $x_1 = $m_RTLong$().d1((+Math.round(a)));
      return new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$Hex($x_3.u0("#%02x%02x%02x%02x", $x_2.hP(new $ac_O([x34, x35, x36, $s_RTLong__toInt__I__I__I($x_1.l, $x_1.h)]))));
    }
    if ((x26 instanceof $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$named)) {
      return new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$Hex(this.bcX(x26.SF));
    }
    if ((x26 instanceof $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH)) {
      color$tailLocal1 = this.aQC(x26);
      continue;
    }
    if ((x26 instanceof $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$Hex)) {
      return x26;
    }
    throw new $c_s_MatchError(x26);
  }
});
$p.ba8 = (function(color) {
  matchAlts1: {
    matchAlts2: {
      if ((color instanceof $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$RGB)) {
        break matchAlts2;
      }
      if ((color instanceof $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$named)) {
        break matchAlts2;
      }
      if ((color instanceof $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH)) {
        break matchAlts2;
      }
      if ((color instanceof $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$Hex)) {
        break matchAlts2;
      }
      break matchAlts1;
    }
    return this.Y7(color);
  }
  if ((color instanceof $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$RGBA)) {
    return this.Y7(new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$RGB(color.G7, color.G6, color.G5));
  }
  throw new $c_s_MatchError(color);
});
$p.ag7 = (function(s) {
  var trimmed = $f_T__trim__T(s);
  if ($m_ju_regex_Pattern$().agK("^#[0-9a-fA-F]{6}$", trimmed)) {
    var hex = trimmed.substring(1);
    return new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$RGB($m_jl_Integer$().gc(hex.substring(0, 2), 16, 134217728), $m_jl_Integer$().gc(hex.substring(2, 4), 16, 134217728), $m_jl_Integer$().gc(hex.substring(4, 6), 16, 134217728));
  } else if ($m_ju_regex_Pattern$().agK("^#[0-9a-fA-F]{3}$", trimmed)) {
    var hex$2 = trimmed.substring(1);
    return new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$RGB($m_jl_Integer$().gc($m_sc_StringOps$().tR(hex$2.substring(0, 1), 2), 16, 134217728), $m_jl_Integer$().gc($m_sc_StringOps$().tR(hex$2.substring(1, 2), 2), 16, 134217728), $m_jl_Integer$().gc($m_sc_StringOps$().tR(hex$2.substring(2, 3), 2), 16, 134217728));
  } else if ($m_ju_regex_Pattern$().agK("^#[0-9a-fA-F]{8}$", trimmed)) {
    var hex$3 = trimmed.substring(1);
    return new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$RGBA($m_jl_Integer$().gc(hex$3.substring(0, 2), 16, 134217728), $m_jl_Integer$().gc(hex$3.substring(2, 4), 16, 134217728), $m_jl_Integer$().gc(hex$3.substring(4, 6), 16, 134217728), ($m_jl_Integer$().gc(hex$3.substring(6, 8), 16, 134217728) / 255.0));
  } else {
    return new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$named(trimmed);
  }
});
var $d_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$, "org.jpablo.graphexplorer.viewer.color.ColorFormat$", ({
  yh: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$;
function $m_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$ = new $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$;
}
function $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__red__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName() {
  $m_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$();
  return $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__red;
}
function $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__orange__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName() {
  $m_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$();
  return $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__orange;
}
function $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__amber__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName() {
  $m_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$();
  return $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__amber;
}
function $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__yellow__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName() {
  $m_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$();
  return $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__yellow;
}
function $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__lime__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName() {
  $m_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$();
  return $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__lime;
}
function $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__green__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName() {
  $m_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$();
  return $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__green;
}
function $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__emerald__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName() {
  $m_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$();
  return $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__emerald;
}
function $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__teal__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName() {
  $m_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$();
  return $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__teal;
}
function $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__cyan__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName() {
  $m_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$();
  return $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__cyan;
}
function $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__sky__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName() {
  $m_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$();
  return $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__sky;
}
function $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__blue__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName() {
  $m_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$();
  return $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__blue;
}
function $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__indigo__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName() {
  $m_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$();
  return $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__indigo;
}
function $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__violet__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName() {
  $m_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$();
  return $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__violet;
}
function $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__purple__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName() {
  $m_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$();
  return $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__purple;
}
function $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__fuchsia__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName() {
  $m_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$();
  return $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__fuchsia;
}
function $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__pink__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName() {
  $m_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$();
  return $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__pink;
}
function $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__rose__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName() {
  $m_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$();
  return $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__rose;
}
function $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__slate__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName() {
  $m_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$();
  return $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__slate;
}
function $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__gray__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName() {
  $m_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$();
  return $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__gray;
}
function $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__zinc__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName() {
  $m_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$();
  return $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__zinc;
}
function $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__neutral__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName() {
  $m_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$();
  return $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__neutral;
}
function $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__stone__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName() {
  $m_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$();
  return $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__stone;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$() {
  $n_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$ = this;
  $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__red = new $c_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$$anon$1("red", 0);
  $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__orange = new $c_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$$anon$1("orange", 1);
  $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__amber = new $c_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$$anon$1("amber", 2);
  $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__yellow = new $c_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$$anon$1("yellow", 3);
  $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__lime = new $c_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$$anon$1("lime", 4);
  $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__green = new $c_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$$anon$1("green", 5);
  $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__emerald = new $c_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$$anon$1("emerald", 6);
  $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__teal = new $c_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$$anon$1("teal", 7);
  $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__cyan = new $c_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$$anon$1("cyan", 8);
  $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__sky = new $c_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$$anon$1("sky", 9);
  $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__blue = new $c_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$$anon$1("blue", 10);
  $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__indigo = new $c_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$$anon$1("indigo", 11);
  $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__violet = new $c_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$$anon$1("violet", 12);
  $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__purple = new $c_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$$anon$1("purple", 13);
  $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__fuchsia = new $c_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$$anon$1("fuchsia", 14);
  $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__pink = new $c_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$$anon$1("pink", 15);
  $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__rose = new $c_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$$anon$1("rose", 16);
  $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__slate = new $c_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$$anon$1("slate", 17);
  $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__gray = new $c_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$$anon$1("gray", 18);
  $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__zinc = new $c_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$$anon$1("zinc", 19);
  $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__neutral = new $c_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$$anon$1("neutral", 20);
  $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__stone = new $c_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$$anon$1("stone", 21);
  $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__red__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName();
  $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__orange__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName();
  $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__amber__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName();
  $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__yellow__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName();
  $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__lime__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName();
  $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__green__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName();
  $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__emerald__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName();
  $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__teal__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName();
  $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__cyan__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName();
  $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__sky__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName();
  $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__blue__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName();
  $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__indigo__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName();
  $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__violet__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName();
  $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__purple__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName();
  $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__fuchsia__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName();
  $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__pink__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName();
  $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__rose__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName();
  $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__slate__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName();
  $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__gray__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName();
  $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__zinc__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName();
  $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__neutral__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName();
  $s_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__stone__Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName();
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$, "org.jpablo.graphexplorer.viewer.color.TailWindColors$ColorName$", ({
  yj: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$;
function $m_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$ = new $c_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$() {
  this.aw8 = null;
  this.aw9 = false;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$.prototype = $p;
$p.bp = (function() {
  if ((!this.aw9)) {
    this.aw8 = new $c_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$$anon$2();
    this.aw9 = true;
  }
  return this.aw8;
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$, "org.jpablo.graphexplorer.viewer.components.CmdAction$", ({
  yo: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$$anon$2() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$$anon$2.prototype = new $h_s_Conversion();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$$anon$2.prototype = $p;
$p.i = (function(x) {
  return new $c_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$NoArg(x);
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$$anon$2, "org.jpablo.graphexplorer.viewer.components.CmdAction$$anon$2", ({
  yp: 1,
  G3: 1,
  h: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_Command$() {
  this.ep = null;
  $n_Lorg_jpablo_graphexplorer_viewer_components_Command$ = this;
  this.ep = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => true));
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_Command$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_Command$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_Command$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_Command$.prototype = $p;
$p.kK = (function() {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((selection) => (!((selection === null) ? null : selection.aS).c())));
});
$p.aQA = (function(pred, selection) {
  return (!(!(!pred.i(new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds(selection)))));
});
$p.aLX = (function(p, q, selection) {
  return ((!(!p.i(new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds(selection)))) && (!(!q.i(new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds(selection)))));
});
$p.b8T = (function(selection) {
  return (selection.aa() === 1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_Command$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_Command$, "org.jpablo.graphexplorer.viewer.components.Command$", ({
  yq: 1,
  d: 1,
  j: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_Command$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_Command$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_Command$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_Command$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_Command$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_Command$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$.prototype = $p;
$p.a2y = (function(row) {
  return $m_Lcom_raquo_airstream_combine_generated_CombinableSignal$().vV(row.cl.P(), row.dg, new $c_Lapp_tulz_tuplez_Composition\uff3fPri0$$anon$1());
});
$p.aSX = (function(inputVar, default$1) {
  return $f_Lcom_raquo_airstream_state_Var__bimap__F1__F1__Lcom_raquo_airstream_state_Var(inputVar, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((dotText) => {
    var raw = $dp_toString__T(dotText.a3D(default$1));
    return ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabels$().w8(raw) ? raw : $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_TextUtils$().ain(raw));
  })), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((uiText) => new $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single(($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_HtmlLabels$().w8(uiText) ? new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq(uiText, true) : $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_TextUtils$().a3j(uiText))))))));
});
$p.a3Q = (function(row) {
  return $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), this.a2y(row), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var attr = x$1.g();
    var d = x$1.h();
    return ((attr instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single) && (attr.nd.m() !== d));
  })), $m_s_None$());
});
$p.b3o = (function(row, rowOption) {
  return $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), this.a2y(row), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var sv = x$1.g();
    var d = x$1.h();
    return rowOption.b2t($dp_toString__T(sv.a3D(d)));
  })), $m_s_None$());
});
$p.y3 = (function(row) {
  return $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), this.a2y(row), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var v = x$1.g();
    var d = x$1.h();
    return $dp_toString__T(v.a3D(d));
  })), $m_s_None$());
});
$p.aYE = (function(row) {
  return $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), this.y3(row), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => (_$2 === "true"))), $m_s_None$());
});
$p.ahW = (function(row) {
  return $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), this.y3(row), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((attrValueStr) => {
    var this$1 = row.j6.iW(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((attrValueStr$2) => ((_$3) => (_$3.zh.m() === attrValueStr$2)))(attrValueStr)));
    if (this$1.c()) {
      var this$4 = $m_s_None$();
    } else {
      var x0 = this$1.d();
      var this$2 = x0.Ga;
      var this$4 = new $c_s_Some((this$2.c() ? $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, x0.x5, $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))) : this$2.d().a3()));
    }
    if (this$4.c()) {
      var this$5 = row.eH;
      var this$6 = (this$5.c() ? $m_s_None$() : new $c_s_Some(this$5.d().i(attrValueStr)));
    } else {
      var this$6 = this$4;
    }
    return (this$6.c() ? $m_Lcom_raquo_laminar_api_package$().b.aU().w($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($m_Lcom_raquo_laminar_api_package$().b, attrValueStr, $m_Lcom_raquo_laminar_modifiers_RenderableText$().a7)]))) : this$6.d());
  })), $m_s_None$());
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$, "org.jpablo.graphexplorer.viewer.components.attributes.rows.AttributeRow$", ({
  yY: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputElement$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputElement$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputElement$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputElement$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputElement$.prototype = $p;
$p.m = (function() {
  return "InputElement";
});
$p.hG = (function() {
  $m_Lcom_raquo_laminar_api_package$();
  return $m_Lcom_raquo_airstream_state_Val$().iT(false);
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputElement$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputElement$, "org.jpablo.graphexplorer.viewer.components.attributes.rows.AttributeRow$InputElement$", ({
  yZ: 1,
  d: 1,
  j: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputElement$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputElement$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputElement$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputElement$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputElement$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputElement$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader$.prototype = $p;
$p.m = (function() {
  return "SectionHeader";
});
$p.hG = (function() {
  $m_Lcom_raquo_laminar_api_package$();
  return $m_Lcom_raquo_airstream_state_Val$().iT(false);
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader$, "org.jpablo.graphexplorer.viewer.components.attributes.rows.AttributeRow$SectionHeader$", ({
  z0: 1,
  d: 1,
  j: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader$;
}
function $s_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$__Nodes__Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind() {
  $m_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$();
  return $t_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$__Nodes;
}
function $s_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$__Arrows__Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind() {
  $m_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$();
  return $t_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$__Arrows;
}
function $s_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$__Groups__Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind() {
  $m_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$();
  return $t_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$__Groups;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$() {
  this.axM = null;
  this.axN = null;
  this.axO = false;
  $n_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$ = this;
  $t_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$__Nodes = new $c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$$anon$1("Nodes", 0);
  $t_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$__Arrows = new $c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$$anon$1("Arrows", 1);
  $t_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$__Groups = new $c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$$anon$1("Groups", 2);
  this.axM = new ($d_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind.r().C)([$s_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$__Nodes__Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind(), $s_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$__Arrows__Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind(), $s_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$__Groups__Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind()]);
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$.prototype = $p;
$p.bb5 = (function() {
  return this.axM.ae();
});
$p.nx = (function() {
  if ((!this.axO)) {
    this.axN = $m_s_CanEqual$derived$();
    this.axO = true;
  }
  return this.axN;
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$, "org.jpablo.graphexplorer.viewer.components.rightPanel.ElementKind$", ({
  zg: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D$NodeSprite$(outer) {
  this.ay5 = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.ay5 = outer;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D$NodeSprite$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D$NodeSprite$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D$NodeSprite$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D$NodeSprite$.prototype = $p;
$p.aM7 = (function(obj, texture, label, planar, setMap, setTint, disposeMaterial) {
  return new $c_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D$NodeSprite(this.ay5, obj, texture, label, planar, setMap, setTint, disposeMaterial);
});
$p.m = (function() {
  return "NodeSprite";
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D$NodeSprite$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D$NodeSprite$, "org.jpablo.graphexplorer.viewer.components.scene3d.GraphScene3D$NodeSprite$", ({
  zr: 1,
  d: 1,
  j: 1
}));
function $p_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$__boxAttr__T__Lcom_raquo_laminar_keys_SvgAttr($thiz, name) {
  $m_Lcom_raquo_laminar_api_package$().b.j();
  return new $c_Lcom_raquo_laminar_keys_SvgAttr(name, $m_Lcom_raquo_laminar_codecs_package$().bW, $m_s_None$());
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$() {
  this.T3 = null;
  this.a0x = null;
  this.a0w = null;
  this.a9J = null;
  this.zm = null;
  this.xa = null;
  this.a0y = null;
  this.a9K = 0.0;
  this.a0u = null;
  this.a0v = null;
  $n_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$ = this;
  this.T3 = "gx-decoration";
  this.a0x = "selected-border";
  this.a0w = "selection-casing";
  this.a9J = "gx-casing-on";
  this.zm = new $c_T4("data-bx", "data-by", "data-bw", "data-bh");
  this.xa = "edge-hit-area";
  this.a0y = (("path:not(." + this.xa) + ")");
  this.a9K = 14.0;
  this.a0u = "edge-label-hit";
  this.a0v = "gx-exit-ghost";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$.prototype = $p;
$p.aXU = (function(bbox) {
  return new $c_sci_$colon$colon($p_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$__boxAttr__T__Lcom_raquo_laminar_keys_SvgAttr(this, this.zm.bO).n(("" + (+bbox.x))), new $c_sci_$colon$colon($p_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$__boxAttr__T__Lcom_raquo_laminar_keys_SvgAttr(this, this.zm.bs).n(("" + (+bbox.y))), new $c_sci_$colon$colon($p_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$__boxAttr__T__Lcom_raquo_laminar_keys_SvgAttr(this, this.zm.ch).n(("" + (+bbox.width))), new $c_sci_$colon$colon($p_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$__boxAttr__T__Lcom_raquo_laminar_keys_SvgAttr(this, this.zm.ca).n(("" + (+bbox.height))), $m_sci_Nil$()))));
});
$p.b2D = (function() {
  return (("fill:none;stroke:transparent;stroke-width:" + $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$().a4N(this.a9K)) + "px;stroke-dasharray:none;stroke-linecap:round;pointer-events:stroke;vector-effect:non-scaling-stroke");
});
$p.aP9 = (function(path) {
  var hit = path.cloneNode(false);
  hit.removeAttribute("id");
  hit.setAttribute("class", this.xa);
  hit.setAttribute("style", this.b2D());
  return hit;
});
$p.ag4 = (function(e, strategy) {
  return ($f_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElementStrategy__isNode__Lorg_scalajs_dom_Element__Z(strategy, e) ? ((!(!(e instanceof SVGGElement))) ? new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_components_selection_NodeElement(e, strategy)) : $m_s_None$()) : (strategy.aPo(e) ? ((!(!(e instanceof SVGElement))) ? new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_components_selection_EdgeElement(e, strategy)) : $m_s_None$()) : ($f_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElementStrategy__isCluster__Lorg_scalajs_dom_Element__Z(strategy, e) ? ((!(!(e instanceof SVGGElement))) ? new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_components_selection_ClusterElement(e, strategy)) : $m_s_None$()) : $m_s_None$())));
});
$p.DW = (function(ref, strategy) {
  return $m_Lorg_jpablo_graphexplorer_viewer_domUtils_QuerySelector$package$().m3(ref, $f_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElementStrategy__allSelector__T(strategy)).cE(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4) => (!(!_$4.classList.contains($m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().xa)))))).cE(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$5) => (_$5.closest(("." + $m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().a0v)) !== null)))).c5(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6) => $m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().ag4(_$6, strategy))));
});
$p.Ed = (function(ref, elems, strategy) {
  if (elems.c()) {
    return $m_sci_Seq$().f7();
  } else {
    var x13 = strategy.aPb(elems);
    if ((x13 instanceof $c_s_Some)) {
      return $m_Lorg_jpablo_graphexplorer_viewer_domUtils_QuerySelector$package$().m3(ref, x13.J).c5(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$7) => $m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$().ag4(_$7, strategy))));
    }
    if (($m_s_None$() === x13)) {
      return this.DW(ref, strategy).bw(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((elem) => $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().mJ(elems, elem.lj()))));
    }
    throw new $c_s_MatchError(x13);
  }
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$, "org.jpablo.graphexplorer.viewer.components.selection.SelectableElement$", ({
  zw: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$;
function $m_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$ = new $c_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement$;
}
function $s_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$__Unavailable__Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome() {
  $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$();
  return $t_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$__Unavailable;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$() {
  $n_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$ = this;
  $t_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$__Unavailable = new $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$$anon$1("Unavailable", 3);
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$, "org.jpablo.graphexplorer.viewer.desktop.DesktopIpc$SaveOutcome$", ({
  zT: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$;
function $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$ = new $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$;
}
function $s_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$__Waiting__Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation() {
  $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$();
  return $t_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$__Waiting;
}
function $s_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$__Displayed__Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation() {
  $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$();
  return $t_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$__Displayed;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$() {
  $n_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$ = this;
  $t_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$__Waiting = new $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$$anon$1("Waiting", 0);
  $t_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$__Displayed = new $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$$anon$1("Displayed", 1);
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$, "org.jpablo.graphexplorer.viewer.desktop.DesktopOpenRequests$Activation$", ({
  zW: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$;
function $m_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$ = new $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$__fromField__Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$Field__Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree($thiz, f) {
  var this$1 = f.ZV;
  var this$2 = (this$1.c() ? $m_s_None$() : new $c_s_Some($f_T__trim__T(this$1.d())));
  var port = ((this$2.c() || (this$2.d() !== "")) ? this$2 : $m_s_None$());
  if ($f_sc_SeqOps__isEmpty__Z(f.hX)) {
    var this$6 = f.L2;
    if (this$6.c()) {
      var this$7 = $m_s_None$();
    } else {
      var x0$2 = this$6.d();
      var this$7 = new $c_s_Some(((x0$2 === " ") ? "" : x0$2));
    }
    var $x_1 = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Leaf(port, $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$__dropUnpairedTrailingBackslash__T__T($thiz, $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$__collapseUnescapedSpaces__T__T($thiz, (this$7.c() ? "" : this$7.d()))));
  } else {
    var $x_1 = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group(port, f.hX.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((f$2) => $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$__fromField__Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$Field__Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$(), f$2)))));
  }
  return $x_1;
}
function $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$__serializeField__Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree__T($thiz, t) {
  if ((t instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Leaf)) {
    var x27 = t.vm;
    var x28 = t.tl;
    var x9 = new $c_T2(x27, x28);
    var x18 = x9.bi;
    var x19 = x9.be;
    if (($m_s_None$() === x18)) {
      return x19;
    }
    if ((x18 instanceof $c_s_Some)) {
      var x17 = x18.J;
      if ((x19 === "")) {
        return (("<" + x17) + ">");
      }
      return ((("<" + x17) + "> ") + x19);
    }
    throw new $c_s_MatchError(x9);
  }
  if ((t instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group)) {
    var x23 = t.tk;
    var x24 = t.gG;
    var inner = $f_sc_IterableOnceOps__mkString__T__T__T__T(x24.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((t$2) => $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$__serializeField__Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$(), t$2)))), "", " | ", "");
    return (x23.c() ? (("{" + inner) + "}") : (((("<" + x23.d()) + ">{") + inner) + "}"));
  }
  throw new $c_s_MatchError(t);
}
function $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$__removeIn__Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group__sci_List__s_Option($thiz, g, path) {
  matchResult22: {
    var newChildren;
    if ($m_sci_Nil$().e(path)) {
      var newChildren = g.gG;
      break matchResult22;
    }
    if ((path instanceof $c_sci_$colon$colon)) {
      var x104 = (path.er | 0);
      var x105 = path.U;
      if ($m_sci_Nil$().e(x105)) {
        var newChildren = $f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(g.gG, x104, ($m_sci_Vector$(), $m_sci_Vector0$()), 1);
        break matchResult22;
      }
      var x95 = new $c_s_PartialFunction$Lifted(g.gG).as(x104);
      if ((x95 instanceof $c_s_Some)) {
        var x97 = x95.J;
        if ((x97 instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group)) {
          var x92 = $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$__removeIn__Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group__sci_List__s_Option($thiz, x97, x105);
          if ((x92 instanceof $c_s_Some)) {
            var updated = x92.J;
            var newChildren = g.gG.nI(x104, $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$__normalizeGroup__Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group__Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree($thiz, updated));
            break matchResult22;
          }
          if (($m_s_None$() === x92)) {
            var newChildren = $f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(g.gG, x104, ($m_sci_Vector$(), $m_sci_Vector0$()), 1);
            break matchResult22;
          }
          throw new $c_s_MatchError(x92);
        }
      }
      var newChildren = g.gG;
      break matchResult22;
    }
    throw new $c_s_MatchError(path);
  }
  return ($f_sc_SeqOps__isEmpty__Z(newChildren) ? $m_s_None$() : new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group(g.tk, newChildren)));
}
function $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$__normalizeGroup__Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group__Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree($thiz, g) {
  matchResult23: {
    var $x_1;
    var x106 = g.gG;
    if ((x106 !== null)) {
      $m_sci_Vector$();
      var x = x106.C();
      if ((((x === 1) ? 0 : ((x < 1) ? (-1) : 1)) === 0)) {
        var x108 = x106.l(0);
        if ((x108 instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Leaf)) {
          var $x_1 = ((!x108.vm.c()) ? x108 : new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Leaf(g.tk, x108.tl));
          break matchResult23;
        }
      }
    }
    var $x_1 = g;
  }
  return $x_1;
}
function $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$__modifyGroupAt__Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group__sci_List__F1__Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group($thiz, root, path, f) {
  if ($m_sci_Nil$().e(path)) {
    return f.i(root);
  }
  if ((path instanceof $c_sci_$colon$colon)) {
    var x117 = path.U;
    var i = (path.er | 0);
    var x110 = new $c_s_PartialFunction$Lifted(root.gG).as(i);
    if ((x110 instanceof $c_s_Some)) {
      var x112 = x110.J;
      if ((x112 instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group)) {
        var children$2 = root.gG.nI(i, $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$__modifyGroupAt__Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group__sci_List__F1__Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group($thiz, x112, x117, f));
        return new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group(root.tk, children$2);
      }
    }
    return root;
  }
  throw new $c_s_MatchError(path);
}
function $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$__modifyCellAt__Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group__sci_List__F1__Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group($thiz, root, path, f) {
  return ($m_sci_Nil$().e(path) ? root : $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$__modifyGroupAt__Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group__sci_List__F1__Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group($thiz, root, path.lX(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((g) => {
    var i = (path.bJ() | 0);
    var this$1 = g.gG;
    var end = this$1.C();
    var isEmpty = (end <= 0);
    var scala$collection$immutable$Range$$lastElement = ((end - 1) | 0);
    if (((!isEmpty) && (!((i < 0) || (i > scala$collection$immutable$Range$$lastElement))))) {
      var children$3 = g.gG.nI(i, f.i(g.gG.l(i)));
      return new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group(g.tk, children$3);
    } else {
      return g;
    }
  }))));
}
function $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$__unescapeWith__T__Z__T($thiz, stored, newlineAsChar) {
  var sb = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  var i = 0;
  while ((i < stored.length)) {
    var index = i;
    var c = stored.charCodeAt(index);
    if (((c === 92) && (((1 + i) | 0) < stored.length))) {
      var index$1 = ((1 + i) | 0);
      var n = stored.charCodeAt(index$1);
      if ($thiz.a9Z.E($bC(n))) {
        sb.id(n);
      } else if (((n === 110) && newlineAsChar)) {
        sb.id(10);
      } else {
        sb.id(c);
        sb.id(n);
      }
      i = ((2 + i) | 0);
    } else {
      sb.id(c);
      i = ((1 + i) | 0);
    }
  }
  return sb.bP.ah;
}
function $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$__collapseUnescapedSpaces__T__T($thiz, s) {
  var sb = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  var i = 0;
  var lastWasUnescapedSpace = false;
  while ((i < s.length)) {
    var index = i;
    var c = s.charCodeAt(index);
    if (((c === 92) && (((1 + i) | 0) < s.length))) {
      sb.id(c);
      sb.id(s.charCodeAt(((1 + i) | 0)));
      i = ((2 + i) | 0);
      lastWasUnescapedSpace = false;
    } else {
      if ((c === 32)) {
        if ((!lastWasUnescapedSpace)) {
          sb.id(c);
        }
        lastWasUnescapedSpace = true;
      } else {
        sb.id(c);
        lastWasUnescapedSpace = false;
      }
      i = ((1 + i) | 0);
    }
  }
  var collapsed = sb.bP.ah;
  return $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$__trimTrailingUnescapedSpaces__T__T($thiz, ((!(!collapsed.startsWith(" "))) ? $m_sc_StringOps$().kp(collapsed, 1) : collapsed));
}
function $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$__dropUnpairedTrailingBackslash__T__T($thiz, s) {
  var i = 0;
  while ((i < s.length)) {
    if ((s.charCodeAt(i) === 92)) {
      if ((((1 + i) | 0) < s.length)) {
        i = ((2 + i) | 0);
      } else {
        return $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$__trimTrailingUnescapedSpaces__T__T($thiz, $m_sc_StringOps$().WF(s, 1));
      }
    } else {
      i = ((1 + i) | 0);
    }
  }
  return s;
}
function $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$__trimTrailingUnescapedSpaces__T__T($thiz, s) {
  var end = s.length;
  while ((((end > 0) && (s.charCodeAt(((end - 1) | 0)) === 32)) && (!$p_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$__isEscaped__T__I__Z($thiz, s, ((end - 1) | 0))))) {
    end = ((end - 1) | 0);
  }
  var endIndex = end;
  return s.substring(0, endIndex);
}
function $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$__isEscaped__T__I__Z($thiz, s, index) {
  var backslashes = 0;
  var i = ((index - 1) | 0);
  while (((i >= 0) && (s.charCodeAt(i) === 92))) {
    backslashes = ((1 + backslashes) | 0);
    i = ((i - 1) | 0);
  }
  var num = backslashes;
  var t = ((num >>> 31) | 0);
  return ((((1 & ((num + t) | 0)) - t) | 0) === 1);
}
function $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$__go$2__Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree__sci_Vector($thiz, t) {
  if ((t instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Leaf)) {
    return $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Leaf.r().C)([t])));
  }
  if ((t instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group)) {
    var x45 = t.gG;
    $m_sci_Vector$();
    var b = new $c_sci_VectorBuilder();
    var it = x45.o();
    while (it.p()) {
      b.fO($p_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$__go$2__Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree__sci_Vector($thiz, it.q()));
    }
    return b.bY();
  }
  throw new $c_s_MatchError(t);
}
function $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$__firstLeaf$1__Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree__sci_List__sci_List($thiz, t, acc) {
  if ((t instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Leaf)) {
    return acc.Jj();
  }
  if ((t instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group)) {
    var x51 = t.gG;
    var this$2 = $f_sc_IndexedSeqOps__headOption__s_Option(x51);
    return (this$2.c() ? acc.Jj() : $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$__firstLeaf$1__Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree__sci_List__sci_List($thiz, this$2.d(), new $c_sci_$colon$colon(0, acc)));
  }
  throw new $c_s_MatchError(t);
}
function $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$__go$3__Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree__sci_List__sci_List__sci_List($thiz, t, p, acc) {
  var acc$tailLocal1 = acc;
  var p$tailLocal1 = p;
  var t$tailLocal1 = t;
  while (true) {
    var x56 = new $c_T2(t$tailLocal1, p$tailLocal1);
    var x69 = x56.bi;
    var x70 = x56.be;
    if ((x69 instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Leaf)) {
      return acc$tailLocal1.Jj();
    }
    if ((x69 instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group)) {
      if ($m_sci_Nil$().e(x70)) {
        return $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$__firstLeaf$1__Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree__sci_List__sci_List($thiz, x69, acc$tailLocal1);
      }
      var x65 = x69.gG;
      if ((x70 instanceof $c_sci_$colon$colon)) {
        var x61 = x70.U;
        var i = (x70.er | 0);
        var x53 = $f_sc_IndexedSeqOps__headOption__s_Option(x65);
        if (($m_s_None$() === x53)) {
          return acc$tailLocal1.Jj();
        }
        if ((x53 instanceof $c_s_Some)) {
          var x$1 = ((i > 0) ? i : 0);
          var that = ((x65.C() - 1) | 0);
          var j = ((x$1 < that) ? x$1 : that);
          var t$tailLocal1$tmp1 = x65.l(j);
          var p$tailLocal1$tmp1 = ((j === i) ? x61 : $m_sci_Nil$());
          var acc$tailLocal1$tmp1 = new $c_sci_$colon$colon(j, acc$tailLocal1);
          t$tailLocal1 = t$tailLocal1$tmp1;
          p$tailLocal1 = p$tailLocal1$tmp1;
          acc$tailLocal1 = acc$tailLocal1$tmp1;
          continue;
        }
        throw new $c_s_MatchError(x53);
      }
    }
    throw new $c_s_MatchError(x56);
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$__go$4__Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree__sci_Set($thiz, t) {
  if ((t instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Leaf)) {
    return $m_sci_Set$().af($m_s_Option$().m2(t.vm));
  }
  if ((t instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group)) {
    var x82 = t.tk;
    var x83 = t.gG;
    var $x_1 = $m_sci_Set$().af($m_s_Option$().m2(x82));
    $m_sci_Vector$();
    var b = new $c_sci_VectorBuilder();
    var it = x83.o();
    while (it.p()) {
      b.fO($p_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$__go$4__Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree__sci_Set($thiz, it.q()));
    }
    return $x_1.dI(b.bY());
  }
  throw new $c_s_MatchError(t);
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$() {
  this.a9Z = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$ = this;
  this.a9Z = $m_sci_Set$().af($m_sr_ScalaRunTime$().bc3(new $ac_C(new Uint16Array([123, 125, 124, 60, 62]))));
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$.prototype = $p;
$p.Je = (function(label) {
  return new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group($m_s_None$(), $m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$().aQU(label, true, ($m_Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$(), false)).hX.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((f) => $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$__fromField__Lorg_jpablo_graphexplorer_graphviz_layout_RecordLabel$Field__Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$(), f)))));
});
$p.a4H = (function(root) {
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(root.gG.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((t) => $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$__serializeField__Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$(), t)))), "", " | ", "");
});
$p.P1 = (function(root, path) {
  var z = $m_s_Option$().as(root);
  var acc = z;
  var these = path;
  while ((!these.c())) {
    var x0 = acc;
    var x1 = these.t();
    var i = (x1 | 0);
    if (x0.c()) {
      acc = $m_s_None$();
    } else {
      var x0$1 = x0.d();
      matchResult9: {
        if ((x0$1 instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group)) {
          acc = new $c_s_PartialFunction$Lifted(x0$1.gG).as(i);
          break matchResult9;
        }
        if ((x0$1 instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Leaf)) {
          acc = $m_s_None$();
          break matchResult9;
        }
        throw new $c_s_MatchError(x0$1);
      }
    }
    these = these.v();
  }
  return acc;
});
$p.agS = (function(root) {
  var this$1 = root.gG;
  $m_sci_Vector$();
  var b = new $c_sci_VectorBuilder();
  var it = this$1.o();
  while (it.p()) {
    b.fO($p_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$__go$2__Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree__sci_Vector(this, it.q()));
  }
  return b.bY();
});
$p.b6p = (function(path, topLR) {
  var num = ((path.C() - 1) | 0);
  var t = ((num >>> 31) | 0);
  if (((((1 & ((num + t) | 0)) - t) | 0) === 0)) {
    return topLR;
  } else {
    return (!topLR);
  }
});
$p.bao = (function(rankdir) {
  matchAlts3: {
    matchAlts4: {
      var x = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$__TB__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir();
      if (((x === null) ? (rankdir === null) : (x === rankdir))) {
        break matchAlts4;
      }
      var x$3 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$__BT__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir();
      if (((x$3 === null) ? (rankdir === null) : (x$3 === rankdir))) {
        break matchAlts4;
      }
      break matchAlts3;
    }
    return true;
  }
  matchAlts1: {
    matchAlts2: {
      var x$5 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$__LR__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir();
      if (((x$5 === null) ? (rankdir === null) : (x$5 === rankdir))) {
        break matchAlts2;
      }
      var x$7 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$__RL__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir();
      if (((x$7 === null) ? (rankdir === null) : (x$7 === rankdir))) {
        break matchAlts2;
      }
      break matchAlts1;
    }
    return false;
  }
  throw new $c_s_MatchError(rankdir);
});
$p.b8N = (function(root, path, display) {
  return $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$__modifyCellAt__Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group__sci_List__F1__Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group(this, root, path, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    matchResult16: {
      var $x_1;
      if ((x$1 instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Leaf)) {
        var text$1 = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$().aSt(display);
        var $x_1 = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Leaf(x$1.vm, text$1);
        break matchResult16;
      }
      if ((x$1 instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group)) {
        var $x_1 = x$1;
        break matchResult16;
      }
      throw new $c_s_MatchError(x$1);
    }
    return $x_1;
  })));
});
$p.b8I = (function(root, path, port) {
  var this$1 = (port.c() ? $m_s_None$() : new $c_s_Some($f_T__trim__T(port.d())));
  return $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$__modifyCellAt__Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group__sci_List__F1__Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group(this, root, path, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((clean) => ((x$1) => {
    matchResult17: {
      var $x_1;
      if ((x$1 instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Leaf)) {
        var $x_1 = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Leaf(clean, x$1.tl);
        break matchResult17;
      }
      if ((x$1 instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group)) {
        var $x_1 = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group(clean, x$1.gG);
        break matchResult17;
      }
      throw new $c_s_MatchError(x$1);
    }
    return $x_1;
  }))(((this$1.c() || (this$1.d() !== "")) ? this$1 : $m_s_None$()))));
});
$p.b2W = (function(root, path, after) {
  if ((path.c() || this.P1(root, path).c())) {
    return new $c_T2(root, path);
  } else {
    var parent = path.lX();
    var idx = (after ? ((1 + (path.bJ() | 0)) | 0) : (path.bJ() | 0));
    return new $c_T2($p_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$__modifyGroupAt__Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group__sci_List__F1__Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group(this, root, parent, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((g) => {
      var children$1 = $f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(g.gG, idx, $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Leaf.r().C)([new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Leaf($m_s_None$(), "")]))), 0);
      return new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group(g.tk, children$1);
    }))), $f_sc_StrictOptimizedSeqOps__appended__O__O(parent, idx));
  }
});
$p.b9h = (function(root, path) {
  var x88 = this.P1(root, path);
  if ((x88 instanceof $c_s_Some)) {
    var x90 = x88.J;
    if ((x90 instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Leaf)) {
      return new $c_T2($p_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$__modifyCellAt__Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group__sci_List__F1__Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group(this, root, path, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((l$2) => ((_$5) => new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group($m_s_None$(), $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Leaf.r().C)([l$2, new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Leaf($m_s_None$(), "")]))))))(x90))), $f_sc_StrictOptimizedSeqOps__appended__O__O(path, 1));
    }
  }
  return new $c_T2(root, path);
});
$p.b7s = (function(root, path) {
  if ((path.c() || this.P1(root, path).c())) {
    return new $c_T2(root, path);
  } else {
    var this$2 = $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$__removeIn__Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group__sci_List__s_Option(this, root, path);
    var newRoot = (this$2.c() ? new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group($m_s_None$(), $m_sci_Vector$().X($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Leaf.r().C)([new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Leaf($m_s_None$(), "")])))) : this$2.d());
    return new $c_T2(newRoot, $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$__go$3__Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree__sci_List__sci_List__sci_List(this, newRoot, path, $m_sci_Nil$()));
  }
});
$p.aSt = (function(display) {
  var this$1 = display.split("\r\n").join("\n");
  var normalized = this$1.split("\r").join("\n");
  var sb = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  var len = normalized.length;
  var i = 0;
  while ((i < len)) {
    var index = i;
    var x0 = normalized.charCodeAt(index);
    if ((x0 === 10)) {
      sb.ad("\\n");
    } else if ((x0 >= 32)) {
      if ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$().a9Z.E($bC(x0))) {
        sb.id(92);
        sb.id(x0);
      } else {
        sb.id(x0);
      }
    }
    i = ((1 + i) | 0);
  }
  return $p_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$__dropUnpairedTrailingBackslash__T__T(this, $f_T__replaceAll__T__T__T($f_T__trim__T(sb.bP.ah), " {2,}", " "));
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$, "org.jpablo.graphexplorer.viewer.formats.dot.RecordTree$", ({
  Aa: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq$() {
  this.ayS = null;
  this.ayT = false;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq$.prototype = $p;
$p.m = (function() {
  return "AttrEq";
});
$p.bm = (function() {
  if ((!this.ayT)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().cw());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.ayS = MacroImplicits_this.cw().ez(new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq$$anon$4(MacroImplicits_this, 2, this), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq$$anon$5(MacroImplicits_this, this));
    this.ayT = true;
  }
  return this.ayS;
});
$p.b5Q = (function(ReadersVersionSpecific_this$5) {
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.eO();
  }
  return true;
});
$p.b5R = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params, collection) => new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq(params.a[0], (!(!params.a[1])))));
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq$, "org.jpablo.graphexplorer.viewer.formats.dot.ast.AttrEq$", ({
  Ac: 1,
  d: 1,
  j: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$() {
  this.ayW = null;
  this.ayX = null;
  this.ayY = false;
  this.ayZ = null;
  this.az0 = false;
  this.ayU = null;
  this.ayV = false;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$ = this;
  this.ayW = ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(""));
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$.prototype = $p;
$p.b2d = (function() {
  if ((!this.ayY)) {
    this.ayX = ($m_Lupickle_default$(), new $c_Lupickle_core_Types$$anon$1(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
      if (((typeof x$1) === "string")) {
        return $f_Lupickle_Api__writeJs__O__Lupickle_core_Types$Writer__Lujson_Value($m_Lupickle_default$(), x$1, $m_Lupickle_default$().I);
      }
      if ((x$1 instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq)) {
        return $f_Lupickle_Api__writeJs__O__Lupickle_core_Types$Writer__Lujson_Value($m_Lupickle_default$(), x$1, $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq$().bm());
      }
      throw new $c_s_MatchError(x$1);
    })), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => ((x$1$2 instanceof $c_Lujson_Str) ? x$1$2.xP : $f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), x$1$2, ($m_Lupickle_default$(), false), $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq$().bm())))), $m_Lupickle_default$().cw().ez($f_Lupickle_LowPriReadWriters__JsValueR__Lupickle_core_Types$Reader($m_Lupickle_default$()), new $c_Lupickle_LowPriReadWriters$$anon$1($m_Lupickle_default$()))));
    this.ayY = true;
  }
  return this.ayX;
});
$p.aOV = (function() {
  if ((!this.az0)) {
    this.ayZ = ($m_Lupickle_default$(), new $c_Lupickle_core_Types$$anon$1(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => _$1.GA)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => {
      $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$();
      return new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(_$2);
    })), this.b2d()));
    this.az0 = true;
  }
  return this.ayZ;
});
$p.nx = (function() {
  if ((!this.ayV)) {
    this.ayU = $m_s_CanEqual$derived$();
    this.ayV = true;
  }
  return this.ayU;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$, "org.jpablo.graphexplorer.viewer.formats.dot.ast.AttrValue$", ({
  Af: 1,
  d: 1,
  j: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Area$() {
  this.az3 = null;
  this.az2 = null;
  this.az1 = 0.0;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Area$ = this;
  this.az3 = $m_s_reflect_ManifestFactory$DoubleManifest$();
  this.az2 = "Area";
  this.az1 = 1.0;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Area$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Area$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Area$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Area$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aZ = (function() {
  return "";
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.az3.b2(0);
});
$p.aI = (function() {
  return this.az2;
});
$p.aT = (function() {
  return this.az1;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Area$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Area$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Area$", ({
  Ag: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Area$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Area$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Area$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Area$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Area$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Area$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowHead$() {
  this.az4 = null;
  this.az5 = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowHead$ = this;
  this.az4 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__vee__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType();
  this.az5 = "Head";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowHead$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowHead$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowHead$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowHead$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aZ = (function() {
  return "";
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aI = (function() {
  return this.az5;
});
$p.aT = (function() {
  return this.az4;
});
$p.aW = (function() {
  return $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$().aiw();
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowHead$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowHead$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.ArrowHead$", ({
  Ah: 1,
  o: 1,
  a1: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowHead$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowHead$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowHead$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowHead$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowHead$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowHead$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowSize$() {
  this.az8 = null;
  this.az7 = null;
  this.az6 = 0.0;
  this.az9 = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowSize$ = this;
  this.az8 = $m_s_reflect_ManifestFactory$DoubleManifest$();
  this.az7 = "Arrow Size";
  this.az6 = 1.0;
  this.az9 = "Enter arrow size here";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowSize$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowSize$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowSize$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowSize$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.az8.b2(0);
});
$p.aI = (function() {
  return this.az7;
});
$p.aZ = (function() {
  return this.az9;
});
$p.aT = (function() {
  return this.az6;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowSize$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowSize$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.ArrowSize$", ({
  Ai: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowSize$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowSize$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowSize$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowSize$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowSize$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowSize$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowTail$() {
  this.aza = null;
  this.azb = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowTail$ = this;
  this.aza = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__none__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType();
  this.azb = "Tail";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowTail$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowTail$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowTail$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowTail$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aZ = (function() {
  return "";
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aI = (function() {
  return this.azb;
});
$p.aT = (function() {
  return this.aza;
});
$p.aW = (function() {
  return $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$().aiw();
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowTail$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowTail$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.ArrowTail$", ({
  Aj: 1,
  o: 1,
  a1: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowTail$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowTail$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowTail$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowTail$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowTail$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowTail$;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__none__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__none;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__vee__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__vee;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__normal__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__normal;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__onormal__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__onormal;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__odot__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__odot;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__box__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__box;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__crow__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__crow;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__curve__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__curve;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__diamond__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__diamond;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__dot__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__dot;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__inv__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__inv;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__tee__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__tee;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__obox__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__obox;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__odiamond__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__odiamond;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__halfvee__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__halfvee;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$() {
  this.azc = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$ = this;
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__none = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$$anon$1("none", 0);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__vee = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$$anon$1("vee", 1);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__normal = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$$anon$1("normal", 2);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__onormal = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$$anon$1("onormal", 3);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__odot = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$$anon$1("odot", 4);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__box = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$$anon$1("box", 5);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__crow = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$$anon$1("crow", 6);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__curve = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$$anon$1("curve", 7);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__diamond = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$$anon$1("diamond", 8);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__dot = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$$anon$1("dot", 9);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__inv = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$$anon$1("inv", 10);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__tee = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$$anon$1("tee", 11);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__obox = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$$anon$1("obox", 12);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__odiamond = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$$anon$1("odiamond", 13);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__halfvee = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$$anon$1("halfvee", 14);
  this.azc = new ($d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType.r().C)([$s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__none__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__vee__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__normal__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__onormal__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__odot__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__box__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__crow__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__curve__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__diamond__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__dot__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__inv__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__tee__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__obox__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__odiamond__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__halfvee__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType()]);
  $m_sci_Map$().ao($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([])));
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$.prototype = $p;
$p.aiw = (function() {
  return this.azc.ae();
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.ArrowType$", ({
  Ak: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BgColor$() {
  this.azf = null;
  this.aze = null;
  this.azd = null;
  this.azg = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BgColor$ = this;
  this.azf = new $c_s_reflect_ClassTag$GenericClassTag($d_T.l());
  this.aze = "Background color";
  this.azd = "#ffffff";
  this.azg = "Enter background color here";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BgColor$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BgColor$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BgColor$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BgColor$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.azf.b2(0);
});
$p.aI = (function() {
  return this.aze;
});
$p.aZ = (function() {
  return this.azg;
});
$p.aT = (function() {
  return this.azd;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BgColor$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BgColor$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.BgColor$", ({
  Am: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BgColor$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BgColor$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BgColor$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BgColor$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BgColor$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BgColor$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BoldStyle$() {
  this.azj = null;
  this.aa1 = false;
  this.azi = null;
  this.azh = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BoldStyle$ = this;
  this.azj = $m_s_reflect_ManifestFactory$BooleanManifest$();
  this.aa1 = false;
  this.azi = "Bold";
  this.azh = "bold";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BoldStyle$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BoldStyle$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BoldStyle$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BoldStyle$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aZ = (function() {
  return "";
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.azj.b2(0);
});
$p.aI = (function() {
  return this.azi;
});
$p.aT = (function() {
  return this.aa1;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BoldStyle$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BoldStyle$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.BoldStyle$", ({
  An: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BoldStyle$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BoldStyle$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BoldStyle$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BoldStyle$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BoldStyle$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BoldStyle$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellAlign$() {
  this.azp = null;
  this.azo = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellAlign$ = this;
  this.azp = "Horizontal alignment";
  this.azo = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$__center__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign();
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellAlign$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellAlign$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellAlign$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellAlign$.prototype = $p;
$p.aZ = (function() {
  return "";
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aN = (function() {
  return "align";
});
$p.aI = (function() {
  return this.azp;
});
$p.aT = (function() {
  return this.azo;
});
$p.aW = (function() {
  return $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$().bb9();
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellAlign$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellAlign$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.CellAlign$", ({
  Aq: 1,
  o: 1,
  a1: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellAlign$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellAlign$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellAlign$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellAlign$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellAlign$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellAlign$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellBgColor$() {
  this.azs = null;
  this.azr = null;
  this.azq = null;
  this.azt = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellBgColor$ = this;
  this.azs = new $c_s_reflect_ClassTag$GenericClassTag($d_T.l());
  this.azr = "Cell fill";
  this.azq = "#ffffff";
  this.azt = "Enter cell background color";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellBgColor$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellBgColor$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellBgColor$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellBgColor$.prototype = $p;
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.azs.b2(0);
});
$p.aN = (function() {
  return "bgcolor";
});
$p.aI = (function() {
  return this.azr;
});
$p.aZ = (function() {
  return this.azt;
});
$p.aT = (function() {
  return this.azq;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellBgColor$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellBgColor$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.CellBgColor$", ({
  Ar: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellBgColor$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellBgColor$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellBgColor$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellBgColor$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellBgColor$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellBgColor$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellBorder$() {
  this.azw = null;
  this.azv = null;
  this.azu = 0;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellBorder$ = this;
  this.azw = $m_s_reflect_ManifestFactory$IntManifest$();
  this.azv = "Cell border width";
  this.azu = 1;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellBorder$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellBorder$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellBorder$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellBorder$.prototype = $p;
$p.aZ = (function() {
  return "";
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.azw.b2(0);
});
$p.aN = (function() {
  return "border";
});
$p.aI = (function() {
  return this.azv;
});
$p.aT = (function() {
  return this.azu;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellBorder$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellBorder$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.CellBorder$", ({
  As: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellBorder$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellBorder$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellBorder$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellBorder$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellBorder$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellBorder$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellColSpan$() {
  this.azz = null;
  this.azy = null;
  this.azx = 0;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellColSpan$ = this;
  this.azz = $m_s_reflect_ManifestFactory$IntManifest$();
  this.azy = "Columns spanned";
  this.azx = 1;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellColSpan$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellColSpan$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellColSpan$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellColSpan$.prototype = $p;
$p.aZ = (function() {
  return "";
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.azz.b2(0);
});
$p.aN = (function() {
  return "colspan";
});
$p.aI = (function() {
  return this.azy;
});
$p.aT = (function() {
  return this.azx;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellColSpan$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellColSpan$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.CellColSpan$", ({
  At: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellColSpan$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellColSpan$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellColSpan$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellColSpan$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellColSpan$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellColSpan$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellColor$() {
  this.azC = null;
  this.azB = null;
  this.azA = null;
  this.azD = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellColor$ = this;
  this.azC = new $c_s_reflect_ClassTag$GenericClassTag($d_T.l());
  this.azB = "Cell border color";
  this.azA = "#000000";
  this.azD = "Enter cell border color";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellColor$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellColor$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellColor$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellColor$.prototype = $p;
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.azC.b2(0);
});
$p.aN = (function() {
  return "color";
});
$p.aI = (function() {
  return this.azB;
});
$p.aZ = (function() {
  return this.azD;
});
$p.aT = (function() {
  return this.azA;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellColor$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellColor$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.CellColor$", ({
  Au: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellColor$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellColor$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellColor$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellColor$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellColor$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellColor$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellPadding$() {
  this.azG = null;
  this.azF = null;
  this.azE = 0;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellPadding$ = this;
  this.azG = $m_s_reflect_ManifestFactory$IntManifest$();
  this.azF = "Cell padding";
  this.azE = 2;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellPadding$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellPadding$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellPadding$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellPadding$.prototype = $p;
$p.aZ = (function() {
  return "";
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.azG.b2(0);
});
$p.aN = (function() {
  return "cellpadding";
});
$p.aI = (function() {
  return this.azF;
});
$p.aT = (function() {
  return this.azE;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellPadding$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellPadding$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.CellPadding$", ({
  Av: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellPadding$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellPadding$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellPadding$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellPadding$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellPadding$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellPadding$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellPort$() {
  this.azJ = null;
  this.azI = null;
  this.azH = null;
  this.azK = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellPort$ = this;
  this.azJ = new $c_s_reflect_ClassTag$GenericClassTag($d_T.l());
  this.azI = "Port name";
  this.azH = "";
  this.azK = "Port name (edges attach here)";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellPort$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellPort$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellPort$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellPort$.prototype = $p;
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.azJ.b2(0);
});
$p.aN = (function() {
  return "port";
});
$p.aI = (function() {
  return this.azI;
});
$p.aZ = (function() {
  return this.azK;
});
$p.aT = (function() {
  return this.azH;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellPort$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellPort$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.CellPort$", ({
  Aw: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellPort$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellPort$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellPort$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellPort$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellPort$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellPort$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellRowSpan$() {
  this.azN = null;
  this.azM = null;
  this.azL = 0;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellRowSpan$ = this;
  this.azN = $m_s_reflect_ManifestFactory$IntManifest$();
  this.azM = "Rows spanned";
  this.azL = 1;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellRowSpan$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellRowSpan$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellRowSpan$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellRowSpan$.prototype = $p;
$p.aZ = (function() {
  return "";
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.azN.b2(0);
});
$p.aN = (function() {
  return "rowspan";
});
$p.aI = (function() {
  return this.azM;
});
$p.aT = (function() {
  return this.azL;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellRowSpan$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellRowSpan$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.CellRowSpan$", ({
  Ax: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellRowSpan$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellRowSpan$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellRowSpan$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellRowSpan$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellRowSpan$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellRowSpan$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellVAlign$() {
  this.azP = null;
  this.azO = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellVAlign$ = this;
  this.azP = "Vertical alignment";
  this.azO = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$__middle__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign();
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellVAlign$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellVAlign$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellVAlign$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellVAlign$.prototype = $p;
$p.aZ = (function() {
  return "";
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aN = (function() {
  return "valign";
});
$p.aI = (function() {
  return this.azP;
});
$p.aT = (function() {
  return this.azO;
});
$p.aW = (function() {
  return $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$().bba();
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellVAlign$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellVAlign$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.CellVAlign$", ({
  Ay: 1,
  o: 1,
  a1: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellVAlign$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellVAlign$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellVAlign$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellVAlign$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellVAlign$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CellVAlign$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Class$() {
  this.azS = null;
  this.azR = null;
  this.azQ = null;
  this.azT = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Class$ = this;
  this.azS = new $c_s_reflect_ClassTag$GenericClassTag($d_T.l());
  this.azR = "CSS Class";
  this.azQ = "";
  this.azT = "Enter CSS class name";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Class$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Class$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Class$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Class$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.azS.b2(0);
});
$p.aI = (function() {
  return this.azR;
});
$p.aZ = (function() {
  return this.azT;
});
$p.aT = (function() {
  return this.azQ;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Class$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Class$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Class$", ({
  Az: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Class$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Class$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Class$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Class$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Class$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Class$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Cluster$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Cluster$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Cluster$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Cluster$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Cluster$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aZ = (function() {
  return "";
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aI = (function() {
  return "Cluster";
});
$p.bb2 = (function() {
  return new $ac_Z([true, false]);
});
$p.aT = (function() {
  return false;
});
$p.aW = (function() {
  return this.bb2();
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Cluster$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Cluster$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Cluster$", ({
  AA: 1,
  o: 1,
  a1: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Cluster$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Cluster$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Cluster$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Cluster$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Cluster$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Cluster$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Color$() {
  this.azX = null;
  this.azW = null;
  this.azV = null;
  this.azY = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Color$ = this;
  this.azX = new $c_s_reflect_ClassTag$GenericClassTag($d_T.l());
  this.azW = "Border";
  this.azV = "#000000";
  this.azY = "Enter color here";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Color$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Color$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Color$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Color$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.azX.b2(0);
});
$p.aI = (function() {
  return this.azW;
});
$p.aZ = (function() {
  return this.azY;
});
$p.aT = (function() {
  return this.azV;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Color$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Color$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Color$", ({
  AC: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Color$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Color$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Color$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Color$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Color$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Color$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ColorScheme$() {
  this.aA1 = null;
  this.aA0 = null;
  this.azZ = null;
  this.aA2 = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ColorScheme$ = this;
  this.aA1 = new $c_s_reflect_ClassTag$GenericClassTag($d_T.l());
  this.aA0 = "Color Scheme";
  this.azZ = "";
  this.aA2 = "Enter color scheme";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ColorScheme$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ColorScheme$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ColorScheme$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ColorScheme$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aA1.b2(0);
});
$p.aI = (function() {
  return this.aA0;
});
$p.aZ = (function() {
  return this.aA2;
});
$p.aT = (function() {
  return this.azZ;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ColorScheme$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ColorScheme$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.ColorScheme$", ({
  AD: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ColorScheme$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ColorScheme$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ColorScheme$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ColorScheme$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ColorScheme$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ColorScheme$;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__n__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__n;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__ne__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__ne;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__e__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__e;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__se__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__se;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__s__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__s;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__sw__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__sw;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__w__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__w;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__nw__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__nw;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__c__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__c;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$() {
  this.aA3 = null;
  this.aa5 = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$ = this;
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__n = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$$anon$7("n", 0);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__ne = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$$anon$7("ne", 1);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__e = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$$anon$7("e", 2);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__se = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$$anon$7("se", 3);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__s = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$$anon$7("s", 4);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__sw = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$$anon$7("sw", 5);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__w = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$$anon$7("w", 6);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__nw = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$$anon$7("nw", 7);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__c = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$$anon$7("c", 8);
  this.aA3 = new ($d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint.r().C)([$s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__n__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__ne__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__e__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__se__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__s__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__sw__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__w__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__nw__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__c__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint()]);
  this.aa5 = new ($d_T2.r().C)([new $c_T2("North", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__n__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint()), new $c_T2("North East", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__ne__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint()), new $c_T2("East", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__e__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint()), new $c_T2("South East", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__se__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint()), new $c_T2("South", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__s__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint()), new $c_T2("South West", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__sw__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint()), new $c_T2("West", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__w__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint()), new $c_T2("North West", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__nw__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint()), new $c_T2("Center", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__c__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint())]);
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$.prototype = $p;
$p.aTj = (function() {
  return this.aA3.ae();
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.CompassPoint$", ({
  AE: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Concentrate$() {
  this.aA6 = null;
  this.aA5 = null;
  this.aA4 = false;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Concentrate$ = this;
  this.aA6 = $m_s_reflect_ManifestFactory$BooleanManifest$();
  this.aA5 = "Concentrate";
  this.aA4 = false;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Concentrate$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Concentrate$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Concentrate$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Concentrate$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aZ = (function() {
  return "";
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aA6.b2(0);
});
$p.aI = (function() {
  return this.aA5;
});
$p.aT = (function() {
  return this.aA4;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Concentrate$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Concentrate$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Concentrate$", ({
  AG: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Concentrate$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Concentrate$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Concentrate$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Concentrate$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Concentrate$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Concentrate$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Constraint$() {
  this.aA9 = null;
  this.aA8 = null;
  this.aA7 = false;
  this.aAa = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Constraint$ = this;
  this.aA9 = $m_s_reflect_ManifestFactory$BooleanManifest$();
  this.aA8 = "Constraint";
  this.aA7 = true;
  this.aAa = $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout.r().C)([$s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__dot__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout()])));
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Constraint$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Constraint$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Constraint$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Constraint$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aZ = (function() {
  return "";
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aA9.b2(0);
});
$p.aI = (function() {
  return this.aA8;
});
$p.aV = (function() {
  return this.aAa;
});
$p.aT = (function() {
  return this.aA7;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Constraint$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Constraint$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Constraint$", ({
  AH: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Constraint$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Constraint$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Constraint$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Constraint$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Constraint$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Constraint$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Decorate$() {
  this.aAh = null;
  this.aAg = null;
  this.aAf = false;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Decorate$ = this;
  this.aAh = $m_s_reflect_ManifestFactory$BooleanManifest$();
  this.aAg = "Decorate";
  this.aAf = false;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Decorate$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Decorate$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Decorate$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Decorate$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aZ = (function() {
  return "";
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aAh.b2(0);
});
$p.aI = (function() {
  return this.aAg;
});
$p.aT = (function() {
  return this.aAf;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Decorate$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Decorate$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Decorate$", ({
  AK: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Decorate$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Decorate$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Decorate$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Decorate$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Decorate$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Decorate$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Dir$() {
  this.aAi = null;
  this.aAj = null;
  this.aAk = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Dir$ = this;
  this.aAi = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$__forward__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType();
  this.aAj = "Direction";
  this.aAk = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$().bb6();
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Dir$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Dir$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Dir$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Dir$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aZ = (function() {
  return "";
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aI = (function() {
  return this.aAj;
});
$p.aP = (function() {
  return new ($d_T2.r().C)([new $c_T2("Forward", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$__forward__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType()), new $c_T2("Back", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$__back__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType()), new $c_T2("Both", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$__both__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType()), new $c_T2("None", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$__none__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType())]);
});
$p.aT = (function() {
  return this.aAi;
});
$p.aW = (function() {
  return this.aAk;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Dir$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Dir$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Dir$", ({
  AL: 1,
  o: 1,
  a1: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Dir$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Dir$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Dir$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Dir$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Dir$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Dir$;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$__forward__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$__forward;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$__back__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$__back;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$__both__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$__both;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$__none__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$__none;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$() {
  this.aAl = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$ = this;
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$__forward = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$$anon$3("forward", 0);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$__back = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$$anon$3("back", 1);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$__both = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$$anon$3("both", 2);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$__none = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$$anon$3("none", 3);
  this.aAl = new ($d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType.r().C)([$s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$__forward__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$__back__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$__both__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$__none__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType()]);
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$.prototype = $p;
$p.bb6 = (function() {
  return this.aAl.ae();
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.DirType$", ({
  AM: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillColor$() {
  this.aAr = null;
  this.aAq = null;
  this.a0G = null;
  this.aAp = null;
  this.aAs = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillColor$ = this;
  this.aAr = new $c_s_reflect_ClassTag$GenericClassTag($d_T.l());
  this.aAq = "Fill";
  this.a0G = "none";
  this.aAp = this.a0G;
  this.aAs = "Enter fill color here";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillColor$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillColor$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillColor$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillColor$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aAr.b2(0);
});
$p.aI = (function() {
  return this.aAq;
});
$p.aZ = (function() {
  return this.aAs;
});
$p.aT = (function() {
  return this.aAp;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillColor$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillColor$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.FillColor$", ({
  AQ: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillColor$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillColor$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillColor$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillColor$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillColor$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillColor$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillStyle$() {
  this.aAv = null;
  this.aab = false;
  this.aAu = null;
  this.aAt = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillStyle$ = this;
  this.aAv = $m_s_reflect_ManifestFactory$BooleanManifest$();
  this.aab = false;
  this.aAu = "Filled";
  this.aAt = "filled";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillStyle$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillStyle$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillStyle$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillStyle$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aZ = (function() {
  return "";
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aAv.b2(0);
});
$p.aI = (function() {
  return this.aAu;
});
$p.aT = (function() {
  return this.aab;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillStyle$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillStyle$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.FillStyle$", ({
  AR: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillStyle$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillStyle$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillStyle$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillStyle$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillStyle$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillStyle$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FixedSize$() {
  this.aAx = null;
  this.aAw = false;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FixedSize$ = this;
  this.aAx = $m_s_reflect_ManifestFactory$BooleanManifest$();
  this.aAw = false;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FixedSize$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FixedSize$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FixedSize$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FixedSize$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aZ = (function() {
  return "";
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aAx.b2(0);
});
$p.aI = (function() {
  return "Fixed size";
});
$p.aT = (function() {
  return this.aAw;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FixedSize$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FixedSize$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.FixedSize$", ({
  AS: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FixedSize$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FixedSize$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FixedSize$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FixedSize$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FixedSize$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FixedSize$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontColor$() {
  this.aAA = null;
  this.aAz = null;
  this.aAy = null;
  this.aAB = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontColor$ = this;
  this.aAA = new $c_s_reflect_ClassTag$GenericClassTag($d_T.l());
  this.aAz = "Font Color";
  this.aAy = "#000000";
  this.aAB = "Enter font color here";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontColor$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontColor$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontColor$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontColor$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aAA.b2(0);
});
$p.aI = (function() {
  return this.aAz;
});
$p.aZ = (function() {
  return this.aAB;
});
$p.aT = (function() {
  return this.aAy;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontColor$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontColor$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.FontColor$", ({
  AT: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontColor$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontColor$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontColor$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontColor$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontColor$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontColor$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontName$() {
  this.aUF = null;
  this.aAD = null;
  this.aAC = null;
  this.aAE = null;
  this.aAF = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontName$ = this;
  this.aUF = new $c_s_reflect_ClassTag$GenericClassTag($d_T.l());
  this.aAD = "Font Family";
  this.aAC = "Times New Roman";
  this.aAE = "Enter font name here";
  this.aAF = new ($d_T.r().C)(["Arial", "Courier New", "Georgia", "Lucida Console", "Times New Roman", "Verdana"]);
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontName$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontName$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontName$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontName$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aI = (function() {
  return this.aAD;
});
$p.aZ = (function() {
  return this.aAE;
});
$p.aT = (function() {
  return this.aAC;
});
$p.aW = (function() {
  return this.aAF;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontName$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontName$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.FontName$", ({
  AU: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontName$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontName$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontName$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontName$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontName$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontName$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontSize$() {
  this.aAH = null;
  this.aAG = null;
  this.aAI = null;
  this.aac = 0.0;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontSize$ = this;
  this.aAH = $m_s_reflect_ManifestFactory$DoubleManifest$();
  this.aAG = "Font Size";
  this.aAI = "Enter font size here";
  this.aac = 14.0;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontSize$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontSize$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontSize$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontSize$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aAH.b2(0);
});
$p.aI = (function() {
  return this.aAG;
});
$p.aZ = (function() {
  return this.aAI;
});
$p.aT = (function() {
  return this.aac;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontSize$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontSize$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.FontSize$", ({
  AV: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontSize$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontSize$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontSize$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontSize$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontSize$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FontSize$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ForceLabels$() {
  this.aAL = null;
  this.aAK = null;
  this.aAJ = false;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ForceLabels$ = this;
  this.aAL = $m_s_reflect_ManifestFactory$BooleanManifest$();
  this.aAK = "Force Labels";
  this.aAJ = true;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ForceLabels$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ForceLabels$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ForceLabels$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ForceLabels$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aZ = (function() {
  return "";
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aAL.b2(0);
});
$p.aI = (function() {
  return this.aAK;
});
$p.aT = (function() {
  return this.aAJ;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ForceLabels$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ForceLabels$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.ForceLabels$", ({
  AW: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ForceLabels$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ForceLabels$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ForceLabels$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ForceLabels$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ForceLabels$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ForceLabels$;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc$__t__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc$__t;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc$__b__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc$__b;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc$() {
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc$ = this;
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc$__t = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc$$anon$6("t", 0);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc$__b = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc$$anon$6("b", 1);
  $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc$__t__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc();
  $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc$__b__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc();
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.GroupLabelLoc$", ({
  AZ: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc$;
}
function $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLocT__$init$__V($thiz) {
  $thiz.aQP("labelloc");
  $thiz.aQQ("Vertical alignment");
  $thiz.aQR(new ($d_T2.r().C)([new $c_T2("Top", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc$__t__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc()), new $c_T2("Bottom", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc$__b__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc())]));
}
function $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLocT__values__ALorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc($thiz) {
  return new ($d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc.r().C)([$s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc$__t__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc$__b__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc()]);
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GvId$() {
  this.aAR = null;
  this.xd = null;
  this.aAQ = null;
  this.aAP = 0;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GvId$ = this;
  this.aAR = $m_s_reflect_ManifestFactory$IntManifest$();
  this.xd = "_gvid";
  this.aAQ = "Graphviz Id";
  this.aAP = 0;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GvId$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GvId$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GvId$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GvId$.prototype = $p;
$p.aZ = (function() {
  return "";
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aAR.b2(0);
});
$p.aN = (function() {
  return this.xd;
});
$p.aI = (function() {
  return this.aAQ;
});
$p.aT = (function() {
  return this.aAP;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GvId$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GvId$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.GvId$", ({
  B1: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GvId$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GvId$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GvId$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GvId$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GvId$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GvId$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Head$() {
  this.aAU = null;
  this.aAT = null;
  this.aAS = 0;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Head$ = this;
  this.aAU = $m_s_reflect_ManifestFactory$IntManifest$();
  this.aAT = "Head Node Id";
  this.aAS = 0;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Head$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Head$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Head$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Head$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aZ = (function() {
  return "";
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aAU.b2(0);
});
$p.aI = (function() {
  return this.aAT;
});
$p.aT = (function() {
  return this.aAS;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Head$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Head$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Head$", ({
  B2: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Head$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Head$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Head$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Head$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Head$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Head$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HeadPort$() {
  this.aAV = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HeadPort$ = this;
  this.aAV = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$().aa5;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HeadPort$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HeadPort$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HeadPort$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HeadPort$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aZ = (function() {
  return "";
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aI = (function() {
  return "Head Port";
});
$p.aP = (function() {
  return this.aAV;
});
$p.aT = (function() {
  return $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__c__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint();
});
$p.aW = (function() {
  return $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$().aTj();
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HeadPort$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HeadPort$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.HeadPort$", ({
  B3: 1,
  o: 1,
  a1: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HeadPort$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HeadPort$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HeadPort$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HeadPort$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HeadPort$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HeadPort$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Height$() {
  this.aAX = null;
  this.aaf = 0.0;
  this.aAW = 0.0;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Height$ = this;
  this.aAX = $m_s_reflect_ManifestFactory$DoubleManifest$();
  this.aaf = 0.5;
  this.aAW = 0.02;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Height$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Height$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Height$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Height$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aZ = (function() {
  return "";
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aAX.b2(0);
});
$p.aI = (function() {
  return "Height";
});
$p.aT = (function() {
  return this.aaf;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Height$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Height$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Height$", ({
  B4: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Height$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Height$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Height$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Height$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Height$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Height$;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$__left__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$__left;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$__center__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$__center;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$__right__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$__right;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$__text__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$__text;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$() {
  this.aAY = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$ = this;
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$__left = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$$anon$1("left", 0);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$__center = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$$anon$1("center", 1);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$__right = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$$anon$1("right", 2);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$__text = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$$anon$1("text", 3);
  this.aAY = new ($d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign.r().C)([$s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$__left__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$__center__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$__right__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$__text__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign()]);
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$.prototype = $p;
$p.bb9 = (function() {
  return this.aAY.ae();
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.HtmlCellAlign$", ({
  B5: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$__top__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$__top;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$__middle__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$__middle;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$__bottom__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$__bottom;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$() {
  this.aAZ = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$ = this;
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$__top = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$$anon$2("top", 0);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$__middle = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$$anon$2("middle", 1);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$__bottom = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$$anon$2("bottom", 2);
  this.aAZ = new ($d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign.r().C)([$s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$__top__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$__middle__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$__bottom__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign()]);
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$.prototype = $p;
$p.bba = (function() {
  return this.aAZ.ae();
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.HtmlCellVAlign$", ({
  B7: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Id$() {
  this.aB2 = null;
  this.aB1 = null;
  this.aB0 = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Id$ = this;
  this.aB2 = new $c_s_reflect_ClassTag$GenericClassTag($d_T.l());
  this.aB1 = "Id";
  this.aB0 = "";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Id$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Id$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Id$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Id$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aZ = (function() {
  return "";
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aB2.b2(0);
});
$p.aI = (function() {
  return this.aB1;
});
$p.aT = (function() {
  return this.aB0;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Id$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Id$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Id$", ({
  B9: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Id$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Id$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Id$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Id$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Id$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Id$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Image$() {
  this.aB5 = null;
  this.aB4 = null;
  this.aB3 = null;
  this.aB6 = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Image$ = this;
  this.aB5 = new $c_s_reflect_ClassTag$GenericClassTag($d_T.l());
  this.aB4 = "Image";
  this.aB3 = "";
  this.aB6 = "Enter image file path";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Image$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Image$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Image$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Image$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aB5.b2(0);
});
$p.aI = (function() {
  return this.aB4;
});
$p.aZ = (function() {
  return this.aB6;
});
$p.aT = (function() {
  return this.aB3;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Image$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Image$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Image$", ({
  Ba: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Image$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Image$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Image$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Image$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Image$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Image$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ImagePath$() {
  this.aB9 = null;
  this.aB8 = null;
  this.aB7 = null;
  this.aBa = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ImagePath$ = this;
  this.aB9 = new $c_s_reflect_ClassTag$GenericClassTag($d_T.l());
  this.aB8 = "Image Path";
  this.aB7 = "";
  this.aBa = "Enter image search path";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ImagePath$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ImagePath$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ImagePath$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ImagePath$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aB9.b2(0);
});
$p.aI = (function() {
  return this.aB8;
});
$p.aZ = (function() {
  return this.aBa;
});
$p.aT = (function() {
  return this.aB7;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ImagePath$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ImagePath$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.ImagePath$", ({
  Bb: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ImagePath$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ImagePath$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ImagePath$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ImagePath$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ImagePath$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ImagePath$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ImagePos$() {
  this.aBd = null;
  this.aBc = null;
  this.aBb = null;
  this.aBe = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ImagePos$ = this;
  this.aBd = new $c_s_reflect_ClassTag$GenericClassTag($d_T.l());
  this.aBc = "Image Position";
  this.aBb = "mc";
  this.aBe = "Enter image position (e.g., mc, tl, br)";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ImagePos$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ImagePos$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ImagePos$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ImagePos$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aBd.b2(0);
});
$p.aI = (function() {
  return this.aBc;
});
$p.aZ = (function() {
  return this.aBe;
});
$p.aT = (function() {
  return this.aBb;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ImagePos$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ImagePos$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.ImagePos$", ({
  Bc: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ImagePos$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ImagePos$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ImagePos$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ImagePos$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ImagePos$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ImagePos$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_InvisibleStyle$() {
  this.aBh = null;
  this.aai = false;
  this.aBg = null;
  this.aBf = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_InvisibleStyle$ = this;
  this.aBh = $m_s_reflect_ManifestFactory$BooleanManifest$();
  this.aai = false;
  this.aBg = "Invisible";
  this.aBf = "invis";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_InvisibleStyle$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_InvisibleStyle$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_InvisibleStyle$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_InvisibleStyle$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aZ = (function() {
  return "";
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aBh.b2(0);
});
$p.aI = (function() {
  return this.aBg;
});
$p.aT = (function() {
  return this.aai;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_InvisibleStyle$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_InvisibleStyle$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.InvisibleStyle$", ({
  Bd: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_InvisibleStyle$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_InvisibleStyle$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_InvisibleStyle$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_InvisibleStyle$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_InvisibleStyle$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_InvisibleStyle$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LHeight$() {
  this.aBk = null;
  this.aBj = null;
  this.aBi = 0.0;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LHeight$ = this;
  this.aBk = $m_s_reflect_ManifestFactory$DoubleManifest$();
  this.aBj = "Label Height";
  this.aBi = 0.0;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LHeight$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LHeight$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LHeight$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LHeight$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aZ = (function() {
  return "";
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aBk.b2(0);
});
$p.aI = (function() {
  return this.aBj;
});
$p.aT = (function() {
  return this.aBi;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LHeight$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LHeight$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.LHeight$", ({
  Be: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LHeight$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LHeight$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LHeight$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LHeight$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LHeight$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LHeight$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LWidth$() {
  this.aBn = null;
  this.aBm = null;
  this.aBl = 0.0;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LWidth$ = this;
  this.aBn = $m_s_reflect_ManifestFactory$DoubleManifest$();
  this.aBm = "Label Width";
  this.aBl = 0.0;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LWidth$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LWidth$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LWidth$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LWidth$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aZ = (function() {
  return "";
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aBn.b2(0);
});
$p.aI = (function() {
  return this.aBm;
});
$p.aT = (function() {
  return this.aBl;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LWidth$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LWidth$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.LWidth$", ({
  Bf: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LWidth$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LWidth$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LWidth$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LWidth$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LWidth$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LWidth$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Label$() {
  this.aBq = null;
  this.aBp = null;
  this.aBo = null;
  this.aBr = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Label$ = this;
  this.aBq = new $c_s_reflect_ClassTag$GenericClassTag($d_T.l());
  this.aBp = "Label";
  this.aBo = "";
  this.aBr = "Enter label here";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Label$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Label$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Label$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Label$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aBq.b2(0);
});
$p.aI = (function() {
  return this.aBp;
});
$p.aZ = (function() {
  return this.aBr;
});
$p.aT = (function() {
  return this.aBo;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Label$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Label$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Label$", ({
  Bg: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Label$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Label$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Label$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Label$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Label$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Label$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelDistance$() {
  this.aBu = null;
  this.aBt = null;
  this.aBs = 0.0;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelDistance$ = this;
  this.aBu = $m_s_reflect_ManifestFactory$DoubleManifest$();
  this.aBt = "Label Distance";
  this.aBs = 1.0;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelDistance$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelDistance$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelDistance$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelDistance$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aZ = (function() {
  return "";
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aBu.b2(0);
});
$p.aI = (function() {
  return this.aBt;
});
$p.aT = (function() {
  return this.aBs;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelDistance$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelDistance$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.LabelDistance$", ({
  Bh: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelDistance$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelDistance$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelDistance$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelDistance$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelDistance$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelDistance$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelFloat$() {
  this.aBx = null;
  this.aBw = null;
  this.aBv = false;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelFloat$ = this;
  this.aBx = $m_s_reflect_ManifestFactory$BooleanManifest$();
  this.aBw = "Label Float";
  this.aBv = false;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelFloat$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelFloat$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelFloat$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelFloat$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aZ = (function() {
  return "";
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aBx.b2(0);
});
$p.aI = (function() {
  return this.aBw;
});
$p.aT = (function() {
  return this.aBv;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelFloat$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelFloat$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.LabelFloat$", ({
  Bi: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelFloat$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelFloat$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelFloat$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelFloat$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelFloat$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelFloat$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelFontColor$() {
  this.aBA = null;
  this.aBz = null;
  this.aBy = null;
  this.aBB = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelFontColor$ = this;
  this.aBA = new $c_s_reflect_ClassTag$GenericClassTag($d_T.l());
  this.aBz = "Label Font Color";
  this.aBy = "#000000";
  this.aBB = "Enter label font color";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelFontColor$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelFontColor$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelFontColor$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelFontColor$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aBA.b2(0);
});
$p.aI = (function() {
  return this.aBz;
});
$p.aZ = (function() {
  return this.aBB;
});
$p.aT = (function() {
  return this.aBy;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelFontColor$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelFontColor$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.LabelFontColor$", ({
  Bj: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelFontColor$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelFontColor$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelFontColor$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelFontColor$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelFontColor$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelFontColor$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelFontName$() {
  this.aBE = null;
  this.aBD = null;
  this.aBC = null;
  this.aBF = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelFontName$ = this;
  this.aBE = new $c_s_reflect_ClassTag$GenericClassTag($d_T.l());
  this.aBD = "Label Font Name";
  this.aBC = "Times-Roman";
  this.aBF = "Enter label font name";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelFontName$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelFontName$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelFontName$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelFontName$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aBE.b2(0);
});
$p.aI = (function() {
  return this.aBD;
});
$p.aZ = (function() {
  return this.aBF;
});
$p.aT = (function() {
  return this.aBC;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelFontName$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelFontName$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.LabelFontName$", ({
  Bk: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelFontName$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelFontName$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelFontName$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelFontName$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelFontName$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelFontName$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layer$() {
  this.aBK = null;
  this.aBJ = null;
  this.aBI = null;
  this.aBL = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layer$ = this;
  this.aBK = new $c_s_reflect_ClassTag$GenericClassTag($d_T.l());
  this.aBJ = "Layer";
  this.aBI = "";
  this.aBL = "Enter layer name or range";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layer$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layer$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layer$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layer$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aBK.b2(0);
});
$p.aI = (function() {
  return this.aBJ;
});
$p.aZ = (function() {
  return this.aBL;
});
$p.aT = (function() {
  return this.aBI;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layer$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layer$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Layer$", ({
  Bn: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layer$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layer$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layer$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layer$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layer$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layer$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Len$() {
  this.aBS = null;
  this.aBR = null;
  this.aBQ = 0.0;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Len$ = this;
  this.aBS = $m_s_reflect_ManifestFactory$DoubleManifest$();
  this.aBR = "Length";
  this.aBQ = 1.0;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Len$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Len$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Len$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Len$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aZ = (function() {
  return "";
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aBS.b2(0);
});
$p.aI = (function() {
  return this.aBR;
});
$p.aT = (function() {
  return this.aBQ;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Len$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Len$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Len$", ({
  Bq: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Len$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Len$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Len$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Len$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Len$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Len$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Lp$() {
  this.aBV = null;
  this.aBU = null;
  this.aBT = null;
  this.aBW = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Lp$ = this;
  this.aBV = new $c_s_reflect_ClassTag$GenericClassTag($d_T.l());
  this.aBU = "Label Position";
  this.aBT = "";
  this.aBW = "Enter label position (x,y)";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Lp$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Lp$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Lp$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Lp$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aBV.b2(0);
});
$p.aI = (function() {
  return this.aBU;
});
$p.aZ = (function() {
  return this.aBW;
});
$p.aT = (function() {
  return this.aBT;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Lp$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Lp$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Lp$", ({
  Br: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Lp$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Lp$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Lp$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Lp$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Lp$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Lp$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Name$() {
  this.aC3 = null;
  this.aC2 = null;
  this.aC1 = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Name$ = this;
  this.aC3 = new $c_s_reflect_ClassTag$GenericClassTag($d_T.l());
  this.aC2 = "Name";
  this.aC1 = "";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Name$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Name$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Name$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Name$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aZ = (function() {
  return "";
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aC3.b2(0);
});
$p.aI = (function() {
  return this.aC2;
});
$p.aT = (function() {
  return this.aC1;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Name$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Name$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Name$", ({
  Bt: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Name$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Name$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Name$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Name$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Name$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Name$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NoJustify$() {
  this.aC6 = null;
  this.aC5 = null;
  this.aC4 = false;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NoJustify$ = this;
  this.aC6 = $m_s_reflect_ManifestFactory$BooleanManifest$();
  this.aC5 = "No Justify";
  this.aC4 = false;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NoJustify$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NoJustify$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NoJustify$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NoJustify$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aZ = (function() {
  return "";
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aC6.b2(0);
});
$p.aI = (function() {
  return this.aC5;
});
$p.aT = (function() {
  return this.aC4;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NoJustify$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NoJustify$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.NoJustify$", ({
  Bu: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NoJustify$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NoJustify$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NoJustify$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NoJustify$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NoJustify$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NoJustify$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeSep$() {
  this.aCc = null;
  this.aCb = null;
  this.aCa = 0.0;
  this.aCd = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeSep$ = this;
  this.aCc = $m_s_reflect_ManifestFactory$DoubleManifest$();
  this.aCb = "Node Separation";
  this.aCa = 0.25;
  this.aCd = "Enter node separation here";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeSep$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeSep$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeSep$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeSep$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aCc.b2(0);
});
$p.aI = (function() {
  return this.aCb;
});
$p.aZ = (function() {
  return this.aCd;
});
$p.aT = (function() {
  return this.aCa;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeSep$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeSep$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.NodeSep$", ({
  Bx: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeSep$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeSep$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeSep$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeSep$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeSep$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeSep$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Normalize$() {
  this.aCk = null;
  this.aCj = null;
  this.aCi = false;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Normalize$ = this;
  this.aCk = $m_s_reflect_ManifestFactory$BooleanManifest$();
  this.aCj = "Normalize";
  this.aCi = false;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Normalize$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Normalize$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Normalize$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Normalize$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aZ = (function() {
  return "";
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aCk.b2(0);
});
$p.aI = (function() {
  return this.aCj;
});
$p.aT = (function() {
  return this.aCi;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Normalize$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Normalize$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Normalize$", ({
  BA: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Normalize$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Normalize$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Normalize$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Normalize$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Normalize$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Normalize$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Orientation$() {
  this.aCn = null;
  this.aCm = null;
  this.aCl = 0.0;
  this.aCo = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Orientation$ = this;
  this.aCn = $m_s_reflect_ManifestFactory$DoubleManifest$();
  this.aCm = "Orientation";
  this.aCl = 0.0;
  this.aCo = "Enter orientation here";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Orientation$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Orientation$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Orientation$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Orientation$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aCn.b2(0);
});
$p.aI = (function() {
  return this.aCm;
});
$p.aZ = (function() {
  return this.aCo;
});
$p.aT = (function() {
  return this.aCl;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Orientation$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Orientation$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Orientation$", ({
  BB: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Orientation$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Orientation$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Orientation$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Orientation$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Orientation$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Orientation$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Pad$() {
  this.aCu = null;
  this.aCt = null;
  this.aCs = 0.0;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Pad$ = this;
  this.aCu = $m_s_reflect_ManifestFactory$DoubleManifest$();
  this.aCt = "Padding";
  this.aCs = 0.0555;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Pad$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Pad$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Pad$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Pad$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aZ = (function() {
  return "";
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aCu.b2(0);
});
$p.aI = (function() {
  return this.aCt;
});
$p.aT = (function() {
  return this.aCs;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Pad$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Pad$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Pad$", ({
  BE: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Pad$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Pad$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Pad$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Pad$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Pad$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Pad$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_PenColor$() {
  this.aCx = null;
  this.aCw = null;
  this.aCv = null;
  this.aCy = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_PenColor$ = this;
  this.aCx = new $c_s_reflect_ClassTag$GenericClassTag($d_T.l());
  this.aCw = "Border";
  this.aCv = "#000000";
  this.aCy = "Enter border color here";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_PenColor$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_PenColor$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_PenColor$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_PenColor$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aCx.b2(0);
});
$p.aI = (function() {
  return this.aCw;
});
$p.aZ = (function() {
  return this.aCy;
});
$p.aT = (function() {
  return this.aCv;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_PenColor$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_PenColor$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.PenColor$", ({
  BF: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_PenColor$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_PenColor$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_PenColor$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_PenColor$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_PenColor$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_PenColor$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_PenWidth$() {
  this.aCB = null;
  this.aCA = null;
  this.aCz = 0.0;
  this.aCC = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_PenWidth$ = this;
  this.aCB = $m_s_reflect_ManifestFactory$DoubleManifest$();
  this.aCA = "Width";
  this.aCz = 1.0;
  this.aCC = "Enter pen width here";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_PenWidth$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_PenWidth$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_PenWidth$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_PenWidth$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aCB.b2(0);
});
$p.aI = (function() {
  return this.aCA;
});
$p.aZ = (function() {
  return this.aCC;
});
$p.aT = (function() {
  return this.aCz;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_PenWidth$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_PenWidth$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.PenWidth$", ({
  BG: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_PenWidth$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_PenWidth$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_PenWidth$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_PenWidth$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_PenWidth$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_PenWidth$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Peripheries$() {
  this.aCF = null;
  this.aCE = null;
  this.aCD = 0;
  this.aCG = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Peripheries$ = this;
  this.aCF = $m_s_reflect_ManifestFactory$IntManifest$();
  this.aCE = "Peripheries";
  this.aCD = 1;
  this.aCG = "Enter peripheries here";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Peripheries$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Peripheries$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Peripheries$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Peripheries$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aCF.b2(0);
});
$p.aI = (function() {
  return this.aCE;
});
$p.aZ = (function() {
  return this.aCG;
});
$p.aT = (function() {
  return this.aCD;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Peripheries$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Peripheries$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Peripheries$", ({
  BH: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Peripheries$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Peripheries$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Peripheries$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Peripheries$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Peripheries$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Peripheries$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Pos$() {
  this.aCJ = null;
  this.aCI = null;
  this.aCH = null;
  this.aCK = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Pos$ = this;
  this.aCJ = new $c_s_reflect_ClassTag$GenericClassTag($d_T.l());
  this.aCI = "Position";
  this.aCH = "";
  this.aCK = "Enter position (x,y)";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Pos$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Pos$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Pos$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Pos$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aCJ.b2(0);
});
$p.aI = (function() {
  return this.aCI;
});
$p.aZ = (function() {
  return this.aCK;
});
$p.aT = (function() {
  return this.aCH;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Pos$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Pos$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Pos$", ({
  BI: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Pos$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Pos$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Pos$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Pos$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Pos$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Pos$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rank$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rank$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rank$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rank$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rank$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aZ = (function() {
  return "";
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aI = (function() {
  return "Rank";
});
$p.aP = (function() {
  return new ($d_T2.r().C)([new $c_T2("None", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$__none__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType()), new $c_T2("Same", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$__same__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType()), new $c_T2("Minimum", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$__min__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType()), new $c_T2("Source", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$__source__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType()), new $c_T2("Maximum", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$__max__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType()), new $c_T2("Sink", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$__sink__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType())]);
});
$p.aT = (function() {
  return $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$__none__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType();
});
$p.aW = (function() {
  return $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$().bbf();
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rank$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rank$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Rank$", ({
  BJ: 1,
  o: 1,
  a1: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rank$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rank$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rank$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rank$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rank$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rank$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankSep$() {
  this.aCN = null;
  this.aCM = null;
  this.aCL = 0.0;
  this.aCP = null;
  this.aCO = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankSep$ = this;
  this.aCN = $m_s_reflect_ManifestFactory$DoubleManifest$();
  this.aCM = "Rank Separation";
  this.aCL = 0.5;
  this.aCP = $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout.r().C)([$s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__dot__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__twopi__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout()])));
  this.aCO = "Enter rank separation here";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankSep$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankSep$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankSep$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankSep$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aCN.b2(0);
});
$p.aI = (function() {
  return this.aCM;
});
$p.aV = (function() {
  return this.aCP;
});
$p.aZ = (function() {
  return this.aCO;
});
$p.aT = (function() {
  return this.aCL;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankSep$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankSep$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.RankSep$", ({
  BK: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankSep$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankSep$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankSep$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankSep$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankSep$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankSep$;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$__none__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$__none;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$__same__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$__same;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$__min__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$__min;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$__source__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$__source;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$__max__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$__max;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$__sink__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$__sink;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$() {
  this.aCQ = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$ = this;
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$__none = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$$anon$16("none", 0);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$__same = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$$anon$16("same", 1);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$__min = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$$anon$16("min", 2);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$__source = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$$anon$16("source", 3);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$__max = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$$anon$16("max", 4);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$__sink = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$$anon$16("sink", 5);
  this.aCQ = new ($d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType.r().C)([$s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$__none__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$__same__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$__min__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$__source__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$__max__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$__sink__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType()]);
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$.prototype = $p;
$p.bbf = (function() {
  return this.aCQ.ae();
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.RankType$", ({
  BL: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Ratio$() {
  this.aCX = null;
  this.aCW = null;
  this.aCV = null;
  this.aCY = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Ratio$ = this;
  this.aCX = new $c_s_reflect_ClassTag$GenericClassTag($d_T.l());
  this.aCW = "Aspect Ratio";
  this.aCV = "";
  this.aCY = "Enter aspect ratio or 'fill', 'compress', 'auto'";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Ratio$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Ratio$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Ratio$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Ratio$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aCX.b2(0);
});
$p.aI = (function() {
  return this.aCW;
});
$p.aZ = (function() {
  return this.aCY;
});
$p.aT = (function() {
  return this.aCV;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Ratio$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Ratio$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Ratio$", ({
  BP: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Ratio$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Ratio$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Ratio$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Ratio$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Ratio$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Ratio$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rects$() {
  this.aD1 = null;
  this.aD0 = null;
  this.aCZ = null;
  this.aD2 = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rects$ = this;
  this.aD1 = new $c_s_reflect_ClassTag$GenericClassTag($d_T.l());
  this.aD0 = "Rectangles";
  this.aCZ = "";
  this.aD2 = "Record field rectangles (write only)";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rects$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rects$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rects$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rects$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aD1.b2(0);
});
$p.aI = (function() {
  return this.aD0;
});
$p.aZ = (function() {
  return this.aD2;
});
$p.aT = (function() {
  return this.aCZ;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rects$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rects$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Rects$", ({
  BQ: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rects$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rects$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rects$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rects$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rects$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rects$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Regular$() {
  this.aD5 = null;
  this.aD3 = false;
  this.aD4 = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Regular$ = this;
  this.aD5 = $m_s_reflect_ManifestFactory$BooleanManifest$();
  this.aD3 = false;
  this.aD4 = "Regular";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Regular$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Regular$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Regular$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Regular$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aZ = (function() {
  return "";
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aD5.b2(0);
});
$p.aI = (function() {
  return this.aD4;
});
$p.aT = (function() {
  return this.aD3;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Regular$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Regular$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Regular$", ({
  BR: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Regular$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Regular$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Regular$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Regular$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Regular$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Regular$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_SameHead$() {
  this.aDa = null;
  this.aD9 = null;
  this.aD8 = null;
  this.aDb = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_SameHead$ = this;
  this.aDa = new $c_s_reflect_ClassTag$GenericClassTag($d_T.l());
  this.aD9 = "Same Head";
  this.aD8 = "";
  this.aDb = "Group edges with same head";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_SameHead$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_SameHead$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_SameHead$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_SameHead$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aDa.b2(0);
});
$p.aI = (function() {
  return this.aD9;
});
$p.aZ = (function() {
  return this.aDb;
});
$p.aT = (function() {
  return this.aD8;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_SameHead$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_SameHead$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.SameHead$", ({
  BT: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_SameHead$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_SameHead$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_SameHead$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_SameHead$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_SameHead$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_SameHead$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_SameTail$() {
  this.aDe = null;
  this.aDd = null;
  this.aDc = null;
  this.aDf = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_SameTail$ = this;
  this.aDe = new $c_s_reflect_ClassTag$GenericClassTag($d_T.l());
  this.aDd = "Same Tail";
  this.aDc = "";
  this.aDf = "Group edges with same tail";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_SameTail$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_SameTail$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_SameTail$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_SameTail$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aDe.b2(0);
});
$p.aI = (function() {
  return this.aDd;
});
$p.aZ = (function() {
  return this.aDf;
});
$p.aT = (function() {
  return this.aDc;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_SameTail$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_SameTail$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.SameTail$", ({
  BU: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_SameTail$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_SameTail$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_SameTail$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_SameTail$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_SameTail$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_SameTail$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ShowBoxes$() {
  this.aDu = null;
  this.aDt = null;
  this.aDs = 0;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ShowBoxes$ = this;
  this.aDu = $m_s_reflect_ManifestFactory$IntManifest$();
  this.aDt = "Show Boxes";
  this.aDs = 0;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ShowBoxes$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ShowBoxes$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ShowBoxes$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ShowBoxes$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aZ = (function() {
  return "";
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aDu.b2(0);
});
$p.aI = (function() {
  return this.aDt;
});
$p.aT = (function() {
  return this.aDs;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ShowBoxes$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ShowBoxes$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.ShowBoxes$", ({
  BX: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ShowBoxes$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ShowBoxes$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ShowBoxes$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ShowBoxes$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ShowBoxes$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ShowBoxes$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Sides$() {
  this.aDx = null;
  this.aDv = 0;
  this.aDw = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Sides$ = this;
  this.aDx = $m_s_reflect_ManifestFactory$IntManifest$();
  this.aDv = 5;
  this.aDw = "Sides";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Sides$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Sides$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Sides$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Sides$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aZ = (function() {
  return "";
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aDx.b2(0);
});
$p.aI = (function() {
  return this.aDw;
});
$p.aT = (function() {
  return this.aDv;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Sides$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Sides$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Sides$", ({
  BY: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Sides$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Sides$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Sides$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Sides$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Sides$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Sides$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Size$() {
  this.aDA = null;
  this.aDz = null;
  this.aDy = 0.0;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Size$ = this;
  this.aDA = $m_s_reflect_ManifestFactory$DoubleManifest$();
  this.aDz = "Size";
  this.aDy = 0.0;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Size$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Size$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Size$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Size$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aZ = (function() {
  return "";
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aDA.b2(0);
});
$p.aI = (function() {
  return this.aDz;
});
$p.aT = (function() {
  return this.aDy;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Size$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Size$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Size$", ({
  BZ: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Size$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Size$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Size$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Size$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Size$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Size$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Start$() {
  this.aDH = null;
  this.aDG = null;
  this.aDF = null;
  this.aDI = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Start$ = this;
  this.aDH = new $c_s_reflect_ClassTag$GenericClassTag($d_T.l());
  this.aDG = "Start";
  this.aDF = "";
  this.aDI = "Random seed for layout";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Start$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Start$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Start$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Start$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aDH.b2(0);
});
$p.aI = (function() {
  return this.aDG;
});
$p.aZ = (function() {
  return this.aDI;
});
$p.aT = (function() {
  return this.aDF;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Start$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Start$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Start$", ({
  C2: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Start$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Start$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Start$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Start$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Start$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Start$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Tail$() {
  this.aDO = null;
  this.aDN = null;
  this.aDM = 0;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Tail$ = this;
  this.aDO = $m_s_reflect_ManifestFactory$IntManifest$();
  this.aDN = "Tail Node Id";
  this.aDM = 0;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Tail$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Tail$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Tail$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Tail$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aZ = (function() {
  return "";
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aDO.b2(0);
});
$p.aI = (function() {
  return this.aDN;
});
$p.aT = (function() {
  return this.aDM;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Tail$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Tail$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Tail$", ({
  C5: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Tail$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Tail$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Tail$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Tail$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Tail$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Tail$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailClip$() {
  this.aDR = null;
  this.aDQ = null;
  this.aDP = false;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailClip$ = this;
  this.aDR = $m_s_reflect_ManifestFactory$BooleanManifest$();
  this.aDQ = "Tail Clip";
  this.aDP = true;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailClip$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailClip$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailClip$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailClip$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aZ = (function() {
  return "";
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aDR.b2(0);
});
$p.aI = (function() {
  return this.aDQ;
});
$p.aT = (function() {
  return this.aDP;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailClip$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailClip$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.TailClip$", ({
  C6: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailClip$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailClip$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailClip$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailClip$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailClip$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailClip$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailLp$() {
  this.aDU = null;
  this.aay = null;
  this.aDT = null;
  this.aDS = null;
  this.aDV = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailLp$ = this;
  this.aDU = new $c_s_reflect_ClassTag$GenericClassTag($d_T.l());
  this.aay = "tail_lp";
  this.aDT = "Tail Label Position";
  this.aDS = "";
  this.aDV = "Tail label position (x,y)";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailLp$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailLp$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailLp$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailLp$.prototype = $p;
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aDU.b2(0);
});
$p.aN = (function() {
  return this.aay;
});
$p.aI = (function() {
  return this.aDT;
});
$p.aZ = (function() {
  return this.aDV;
});
$p.aT = (function() {
  return this.aDS;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailLp$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailLp$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.TailLp$", ({
  C7: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailLp$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailLp$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailLp$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailLp$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailLp$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailLp$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailPort$() {
  this.aDW = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailPort$ = this;
  this.aDW = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$().aa5;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailPort$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailPort$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailPort$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailPort$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aZ = (function() {
  return "";
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aI = (function() {
  return "Tail Port";
});
$p.aP = (function() {
  return this.aDW;
});
$p.aT = (function() {
  return $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__c__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint();
});
$p.aW = (function() {
  return $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$().aTj();
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailPort$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailPort$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.TailPort$", ({
  C8: 1,
  o: 1,
  a1: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailPort$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailPort$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailPort$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailPort$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailPort$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailPort$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailTarget$() {
  this.aDZ = null;
  this.aDY = null;
  this.aDX = null;
  this.aE0 = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailTarget$ = this;
  this.aDZ = new $c_s_reflect_ClassTag$GenericClassTag($d_T.l());
  this.aDY = "Tail Target";
  this.aDX = "";
  this.aE0 = "Target for tail URL";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailTarget$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailTarget$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailTarget$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailTarget$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aDZ.b2(0);
});
$p.aI = (function() {
  return this.aDY;
});
$p.aZ = (function() {
  return this.aE0;
});
$p.aT = (function() {
  return this.aDX;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailTarget$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailTarget$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.TailTarget$", ({
  C9: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailTarget$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailTarget$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailTarget$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailTarget$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailTarget$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailTarget$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailTooltip$() {
  this.aE3 = null;
  this.aE2 = null;
  this.aE1 = null;
  this.aE4 = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailTooltip$ = this;
  this.aE3 = new $c_s_reflect_ClassTag$GenericClassTag($d_T.l());
  this.aE2 = "Tail Tooltip";
  this.aE1 = "";
  this.aE4 = "Tooltip for edge tail";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailTooltip$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailTooltip$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailTooltip$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailTooltip$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aE3.b2(0);
});
$p.aI = (function() {
  return this.aE2;
});
$p.aZ = (function() {
  return this.aE4;
});
$p.aT = (function() {
  return this.aE1;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailTooltip$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailTooltip$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.TailTooltip$", ({
  Ca: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailTooltip$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailTooltip$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailTooltip$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailTooltip$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailTooltip$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailTooltip$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailURL$() {
  this.aE7 = null;
  this.aaz = null;
  this.aE6 = null;
  this.aE5 = null;
  this.aE8 = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailURL$ = this;
  this.aE7 = new $c_s_reflect_ClassTag$GenericClassTag($d_T.l());
  this.aaz = "tailURL";
  this.aE6 = "Tail URL";
  this.aE5 = "";
  this.aE8 = "URL for edge tail";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailURL$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailURL$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailURL$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailURL$.prototype = $p;
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aE7.b2(0);
});
$p.aN = (function() {
  return this.aaz;
});
$p.aI = (function() {
  return this.aE6;
});
$p.aZ = (function() {
  return this.aE8;
});
$p.aT = (function() {
  return this.aE5;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailURL$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailURL$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.TailURL$", ({
  Cb: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailURL$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailURL$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailURL$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailURL$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailURL$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_TailURL$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Target$() {
  this.aEb = null;
  this.aEa = null;
  this.aE9 = null;
  this.aEc = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Target$ = this;
  this.aEb = new $c_s_reflect_ClassTag$GenericClassTag($d_T.l());
  this.aEa = "URL Target";
  this.aE9 = "";
  this.aEc = "Enter target window name";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Target$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Target$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Target$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Target$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aEb.b2(0);
});
$p.aI = (function() {
  return this.aEa;
});
$p.aZ = (function() {
  return this.aEc;
});
$p.aT = (function() {
  return this.aE9;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Target$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Target$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Target$", ({
  Cc: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Target$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Target$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Target$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Target$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Target$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Target$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Tooltip$() {
  this.aEf = null;
  this.aEe = null;
  this.aEd = null;
  this.aEg = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Tooltip$ = this;
  this.aEf = new $c_s_reflect_ClassTag$GenericClassTag($d_T.l());
  this.aEe = "Tooltip";
  this.aEd = "";
  this.aEg = "Enter tooltip text";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Tooltip$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Tooltip$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Tooltip$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Tooltip$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aEf.b2(0);
});
$p.aI = (function() {
  return this.aEe;
});
$p.aZ = (function() {
  return this.aEg;
});
$p.aT = (function() {
  return this.aEd;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Tooltip$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Tooltip$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Tooltip$", ({
  Cd: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Tooltip$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Tooltip$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Tooltip$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Tooltip$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Tooltip$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Tooltip$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_URL$() {
  this.aEj = null;
  this.a0H = null;
  this.aEi = null;
  this.aEh = null;
  this.aEk = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_URL$ = this;
  this.aEj = new $c_s_reflect_ClassTag$GenericClassTag($d_T.l());
  this.a0H = "URL";
  this.aEi = "URL";
  this.aEh = "";
  this.aEk = "Enter URL here";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_URL$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_URL$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_URL$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_URL$.prototype = $p;
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aEj.b2(0);
});
$p.aN = (function() {
  return this.a0H;
});
$p.aI = (function() {
  return this.aEi;
});
$p.aZ = (function() {
  return this.aEk;
});
$p.aT = (function() {
  return this.aEh;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_URL$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_URL$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.URL$", ({
  Ce: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_URL$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_URL$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_URL$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_URL$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_URL$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_URL$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Vertices$() {
  this.aEn = null;
  this.aEm = null;
  this.aEl = null;
  this.aEo = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Vertices$ = this;
  this.aEn = new $c_s_reflect_ClassTag$GenericClassTag($d_T.l());
  this.aEm = "Vertices";
  this.aEl = "";
  this.aEo = "Polygon vertex coordinates";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Vertices$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Vertices$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Vertices$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Vertices$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aEn.b2(0);
});
$p.aI = (function() {
  return this.aEm;
});
$p.aZ = (function() {
  return this.aEo;
});
$p.aT = (function() {
  return this.aEl;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Vertices$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Vertices$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Vertices$", ({
  Cf: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Vertices$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Vertices$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Vertices$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Vertices$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Vertices$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Vertices$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Weight$() {
  this.aEr = null;
  this.aEq = null;
  this.aEp = 0.0;
  this.aEs = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Weight$ = this;
  this.aEr = $m_s_reflect_ManifestFactory$DoubleManifest$();
  this.aEq = "Weight";
  this.aEp = 1.0;
  this.aEs = "Enter weight here";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Weight$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Weight$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Weight$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Weight$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aEr.b2(0);
});
$p.aI = (function() {
  return this.aEq;
});
$p.aZ = (function() {
  return this.aEs;
});
$p.aT = (function() {
  return this.aEp;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Weight$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Weight$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Weight$", ({
  Cg: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Weight$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Weight$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Weight$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Weight$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Weight$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Weight$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Width$() {
  this.aEu = null;
  this.aaA = 0.0;
  this.aEt = 0.0;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Width$ = this;
  this.aEu = $m_s_reflect_ManifestFactory$DoubleManifest$();
  this.aaA = 0.75;
  this.aEt = 0.01;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Width$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Width$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Width$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Width$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aZ = (function() {
  return "";
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aEu.b2(0);
});
$p.aI = (function() {
  return "Width";
});
$p.aT = (function() {
  return this.aaA;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Width$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Width$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Width$", ({
  Ch: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Width$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Width$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Width$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Width$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Width$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Width$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_XLabel$() {
  this.aEx = null;
  this.aEw = null;
  this.aEv = null;
  this.aEy = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_XLabel$ = this;
  this.aEx = new $c_s_reflect_ClassTag$GenericClassTag($d_T.l());
  this.aEw = "External label";
  this.aEv = "";
  this.aEy = "Enter label here";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_XLabel$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_XLabel$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_XLabel$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_XLabel$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aW = (function() {
  return this.aEx.b2(0);
});
$p.aI = (function() {
  return this.aEw;
});
$p.aZ = (function() {
  return this.aEy;
});
$p.aT = (function() {
  return this.aEv;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_XLabel$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_XLabel$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.XLabel$", ({
  Ci: 1,
  o: 1,
  v: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_XLabel$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_XLabel$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_XLabel$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_XLabel$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_XLabel$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_XLabel$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$.prototype = $p;
$p.ba4 = (function(commands) {
  var f = ((_$1) => _$1.aXJ());
  if ((commands === $m_sci_Nil$())) {
    var $x_1 = $m_sci_Nil$();
  } else {
    var x0 = commands.t();
    var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
    var t = h;
    var rest = commands.v();
    while ((rest !== $m_sci_Nil$())) {
      var x0$1 = rest.t();
      var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
      t.U = nx;
      t = nx;
      rest = rest.v();
    }
    var $x_1 = h;
  }
  return $f_sc_IterableOnceOps__mkString__T__T__T__T($x_1, "", " ", "");
});
$p.b4z = (function(commands, point) {
  matchResult36: {
    var trimmed;
    if ((commands !== null)) {
      var x97 = $m_sc_package$$colon$plus$().Y9(commands);
      if ((!x97.c())) {
        var x98 = x97.d();
        var x99 = x98.g();
        var x100 = x98.h();
        if ((x99 !== null)) {
          var x108 = $m_sc_package$$colon$plus$().Y9(x99);
          if ((!x108.c())) {
            var x109 = x108.d();
            var x111 = x109.h();
            var init = x109.g();
            if ((x111 instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$CurveTo)) {
              if ((x100 instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$LineTo)) {
                var x104 = x100.zr;
                if ((x104 instanceof $c_sci_$colon$colon)) {
                  if ($m_sci_Nil$().e(x104.U)) {
                    var trimmed = $f_sc_StrictOptimizedSeqOps__appended__O__O(init, x111);
                    break matchResult36;
                  }
                }
              }
            }
          }
        }
      }
    }
    var trimmed = commands;
  }
  if ((trimmed !== null)) {
    var x126 = $m_sc_package$$colon$plus$().Y9(trimmed);
    if ((!x126.c())) {
      var x127 = x126.d();
      var x128 = x127.g();
      var x129 = x127.h();
      if ((x129 instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$LineTo)) {
        return $f_sc_StrictOptimizedSeqOps__appended__O__O(x128, new $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$LineTo(x129.GE, x129.zr.lX().bv(point)));
      }
      if ((x129 instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$CurveTo)) {
        var x124 = x129.GC;
        var x125 = x129.GD;
        matchResult37: {
          var \u03b41$___1;
          var \u03b41$___2;
          var x113 = x125.bJ();
          if ((x113 !== null)) {
            var \u03b41$___1 = x113.bH;
            var \u03b41$___2 = x113.bU;
            break matchResult37;
          }
          throw new $c_s_MatchError(x113);
        }
        var c1$2 = \u03b41$___1;
        var c2$2 = \u03b41$___2;
        return $f_sc_StrictOptimizedSeqOps__appended__O__O(x128, new $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$CurveTo(x124, x125.lX().bv(new $c_T3(c1$2, c2$2, point))));
      }
    }
  }
  return trimmed;
});
$p.b4y = (function(commands, point) {
  matchResult39: {
    var trimmed;
    if ((commands instanceof $c_sci_$colon$colon)) {
      var x136 = commands.er;
      var x137 = commands.U;
      if ((x136 instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$MoveTo)) {
        if ((x137 instanceof $c_sci_$colon$colon)) {
          var x139 = x137.er;
          var x140 = x137.U;
          if ((x139 instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$LineTo)) {
            var x148 = x139.zr;
            if ((x148 instanceof $c_sci_$colon$colon)) {
              if (($m_sci_Nil$().e(x148.U) && (x140 instanceof $c_sci_$colon$colon))) {
                var x142 = x140.er;
                var x143 = x140.U;
                if ((x142 instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$CurveTo)) {
                  var trimmed = new $c_sci_$colon$colon(x136, new $c_sci_$colon$colon(x142, x143));
                  break matchResult39;
                }
              }
            }
          }
        }
      }
    }
    var trimmed = commands;
  }
  if ((trimmed instanceof $c_sci_$colon$colon)) {
    var x155 = trimmed.er;
    var x156 = trimmed.U;
    if ((x155 instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$MoveTo)) {
      var x159 = x155.GF;
      var x160 = x155.GG;
      if ((x160 instanceof $c_sci_$colon$colon)) {
        return new $c_sci_$colon$colon(new $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$MoveTo(x159, new $c_sci_$colon$colon(point, x160.U)), x156);
      }
    }
  }
  return trimmed;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$, "org.jpablo.graphexplorer.viewer.formats.svg.PathCommand$", ({
  Cj: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_SVGPathParser() {
  this.aEF = null;
  this.aEG = false;
  this.aED = null;
  this.aEE = false;
  this.aEB = null;
  this.aEC = false;
  this.aEz = null;
  this.aEA = false;
  this.aEH = null;
  $f_s_util_parsing_combinator_RegexParsers__$init$__V(this);
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_SVGPathParser.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_SVGPathParser;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_svg_SVGPathParser() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_svg_SVGPathParser.prototype = $p;
$p.OQ = (function() {
  if ((!this.aEG)) {
    this.aEF = new $c_s_util_parsing_combinator_Parsers$Success$(this);
    this.aEG = true;
  }
  return this.aEF;
});
$p.aer = (function() {
  if ((!this.aEE)) {
    this.aED = new $c_s_util_parsing_combinator_Parsers$Failure$(this);
    this.aEE = true;
  }
  return this.aED;
});
$p.aVV = (function() {
  if ((!this.aEC)) {
    this.aEB = new $c_s_util_parsing_combinator_Parsers$Error$(this);
    this.aEC = true;
  }
  return this.aEB;
});
$p.xX = (function() {
  if ((!this.aEA)) {
    this.aEz = new $c_s_util_parsing_combinator_Parsers$$tilde$(this);
    this.aEA = true;
  }
  return this.aEz;
});
$p.b5b = (function() {
  return new $c_s_util_parsing_combinator_RegexParsers$$anon$2($ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "-?(\\d+(\\.\\d*)?|\\.\\d+)([eE][+-]?\\d+)?", $m_sci_Nil$()), this).qO(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => $m_jl_Double$().bd(_$2))));
});
$p.IL = (function() {
  return new $c_s_util_parsing_combinator_RegexParsers$$anon$1(",", this).qO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x) => new $c_s_Some(x)))).jQ(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $f_s_util_parsing_combinator_Parsers__success__O__s_util_parsing_combinator_Parsers$Parser(this, $m_s_None$())))).aLn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.b5b())));
});
$p.aOb = (function() {
  return new $c_s_util_parsing_combinator_RegexParsers$$anon$1(",", this).qO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x) => new $c_s_Some(x)))).jQ(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $f_s_util_parsing_combinator_Parsers__success__O__s_util_parsing_combinator_Parsers$Parser(this, $m_s_None$())))).aLn(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => new $c_s_util_parsing_combinator_RegexParsers$$anon$1("0", this).aeo(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => false))).jQ(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => new $c_s_util_parsing_combinator_RegexParsers$$anon$1("1", this).aeo(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => true)))))))));
});
$p.vW = (function() {
  return this.IL().xW(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.IL()))).qO(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    if ((x$1 !== null)) {
      this.xX();
      return new $c_T2((+x$1.ot), (+x$1.ou));
    }
    throw new $c_s_MatchError(x$1);
  })));
});
$p.b4A = (function() {
  return new $c_s_util_parsing_combinator_RegexParsers$$anon$1("M", this).jQ(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => new $c_s_util_parsing_combinator_RegexParsers$$anon$1("m", this)))).tY(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((cmdChar) => {
    var p = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.vW()));
    return $f_s_util_parsing_combinator_Parsers__rep1__F0__F0__s_util_parsing_combinator_Parsers$Parser(this, p, p).qO(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((cmdChar$2) => ((pairs) => new $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$MoveTo($m_jl_UnicodeData$().Ao($m_sc_StringOps$().pw(cmdChar$2)), pairs)))(cmdChar)));
  })));
});
$p.aYp = (function() {
  return new $c_s_util_parsing_combinator_RegexParsers$$anon$1("Z", this).jQ(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => new $c_s_util_parsing_combinator_RegexParsers$$anon$1("z", this)))).aeo(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => new $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$ClosePath())));
});
$p.b46 = (function() {
  return new $c_s_util_parsing_combinator_RegexParsers$$anon$1("L", this).jQ(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => new $c_s_util_parsing_combinator_RegexParsers$$anon$1("l", this)))).tY(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((cmdChar) => {
    var p = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.vW()));
    return $f_s_util_parsing_combinator_Parsers__rep1__F0__F0__s_util_parsing_combinator_Parsers$Parser(this, p, p).qO(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((cmdChar$2) => ((pairs) => new $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$LineTo($m_jl_UnicodeData$().Ao($m_sc_StringOps$().pw(cmdChar$2)), pairs)))(cmdChar)));
  })));
});
$p.b2E = (function() {
  return new $c_s_util_parsing_combinator_RegexParsers$$anon$1("H", this).jQ(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => new $c_s_util_parsing_combinator_RegexParsers$$anon$1("h", this)))).tY(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((cmdChar) => {
    var p = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.IL()));
    return $f_s_util_parsing_combinator_Parsers__rep1__F0__F0__s_util_parsing_combinator_Parsers$Parser(this, p, p).qO(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((cmdChar$2) => ((coords) => new $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$HorizontalLineTo($m_jl_UnicodeData$().Ao($m_sc_StringOps$().pw(cmdChar$2)), coords)))(cmdChar)));
  })));
});
$p.bbm = (function() {
  return new $c_s_util_parsing_combinator_RegexParsers$$anon$1("V", this).jQ(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => new $c_s_util_parsing_combinator_RegexParsers$$anon$1("v", this)))).tY(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((cmdChar) => {
    var p = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.IL()));
    return $f_s_util_parsing_combinator_Parsers__rep1__F0__F0__s_util_parsing_combinator_Parsers$Parser(this, p, p).qO(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((cmdChar$2) => ((coords) => new $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$VerticalLineTo($m_jl_UnicodeData$().Ao($m_sc_StringOps$().pw(cmdChar$2)), coords)))(cmdChar)));
  })));
});
$p.aZv = (function() {
  return new $c_s_util_parsing_combinator_RegexParsers$$anon$1("C", this).jQ(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => new $c_s_util_parsing_combinator_RegexParsers$$anon$1("c", this)))).tY(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((cmdChar) => {
    var p = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.vW().xW(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.vW()))).xW(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.vW())))));
    return $f_s_util_parsing_combinator_Parsers__rep1__F0__F0__s_util_parsing_combinator_Parsers$Parser(this, p, p).qO(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((cmdChar$2) => ((triplets) => {
      var f = ((x$1) => {
        if ((x$1 !== null)) {
          this.xX();
          var x170 = x$1.ot;
          if ((x170 !== null)) {
            this.xX();
            return new $c_T3(x170.ot, x170.ou, x$1.ou);
          }
        }
        throw new $c_s_MatchError(x$1);
      });
      if ((triplets === $m_sci_Nil$())) {
        var points = $m_sci_Nil$();
      } else {
        var x0 = triplets.t();
        var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
        var t = h;
        var rest = triplets.v();
        while ((rest !== $m_sci_Nil$())) {
          var x0$1 = rest.t();
          var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
          t.U = nx;
          t = nx;
          rest = rest.v();
        }
        var points = h;
      }
      return new $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$CurveTo($m_jl_UnicodeData$().Ao($m_sc_StringOps$().pw(cmdChar$2)), points);
    }))(cmdChar)));
  })));
});
$p.b8Z = (function() {
  return new $c_s_util_parsing_combinator_RegexParsers$$anon$1("S", this).jQ(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => new $c_s_util_parsing_combinator_RegexParsers$$anon$1("s", this)))).tY(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((cmdChar) => {
    var p = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.vW().xW(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.vW())))));
    return $f_s_util_parsing_combinator_Parsers__rep1__F0__F0__s_util_parsing_combinator_Parsers$Parser(this, p, p).qO(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((cmdChar$2) => ((doubles) => {
      var f = ((x$1) => {
        if ((x$1 !== null)) {
          this.xX();
          return new $c_T2(x$1.ot, x$1.ou);
        }
        throw new $c_s_MatchError(x$1);
      });
      if ((doubles === $m_sci_Nil$())) {
        var points = $m_sci_Nil$();
      } else {
        var x0 = doubles.t();
        var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
        var t = h;
        var rest = doubles.v();
        while ((rest !== $m_sci_Nil$())) {
          var x0$1 = rest.t();
          var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
          t.U = nx;
          t = nx;
          rest = rest.v();
        }
        var points = h;
      }
      return new $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$SmoothCurveTo($m_jl_UnicodeData$().Ao($m_sc_StringOps$().pw(cmdChar$2)), points);
    }))(cmdChar)));
  })));
});
$p.b76 = (function() {
  return new $c_s_util_parsing_combinator_RegexParsers$$anon$1("Q", this).jQ(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => new $c_s_util_parsing_combinator_RegexParsers$$anon$1("q", this)))).tY(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((cmdChar) => {
    var p = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.vW().xW(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.vW())))));
    return $f_s_util_parsing_combinator_Parsers__rep1__F0__F0__s_util_parsing_combinator_Parsers$Parser(this, p, p).qO(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((cmdChar$2) => ((doubles) => {
      var f = ((x$1) => {
        if ((x$1 !== null)) {
          this.xX();
          return new $c_T2(x$1.ot, x$1.ou);
        }
        throw new $c_s_MatchError(x$1);
      });
      if ((doubles === $m_sci_Nil$())) {
        var points = $m_sci_Nil$();
      } else {
        var x0 = doubles.t();
        var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
        var t = h;
        var rest = doubles.v();
        while ((rest !== $m_sci_Nil$())) {
          var x0$1 = rest.t();
          var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
          t.U = nx;
          t = nx;
          rest = rest.v();
        }
        var points = h;
      }
      return new $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$QuadraticBezierCurveTo($m_jl_UnicodeData$().Ao($m_sc_StringOps$().pw(cmdChar$2)), points);
    }))(cmdChar)));
  })));
});
$p.b90 = (function() {
  return new $c_s_util_parsing_combinator_RegexParsers$$anon$1("T", this).jQ(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => new $c_s_util_parsing_combinator_RegexParsers$$anon$1("t", this)))).tY(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((cmdChar) => {
    var p = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.vW()));
    return $f_s_util_parsing_combinator_Parsers__rep1__F0__F0__s_util_parsing_combinator_Parsers$Parser(this, p, p).qO(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((cmdChar$2) => ((pairs) => new $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$SmoothQuadraticBezierCurveTo($m_jl_UnicodeData$().Ao($m_sc_StringOps$().pw(cmdChar$2)), pairs)))(cmdChar)));
  })));
});
$p.b0r = (function() {
  return new $c_s_util_parsing_combinator_RegexParsers$$anon$1("A", this).jQ(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => new $c_s_util_parsing_combinator_RegexParsers$$anon$1("a", this)))).tY(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((cmdChar) => {
    var p = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.IL().xW(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.IL()))).xW(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.IL()))).xW(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.aOb()))).xW(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.aOb()))).xW(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.vW())))));
    return $f_s_util_parsing_combinator_Parsers__rep1__F0__F0__s_util_parsing_combinator_Parsers$Parser(this, p, p).qO(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((cmdChar$2) => ((args) => {
      var f = ((x$1) => {
        if ((x$1 !== null)) {
          this.xX();
          var x185 = x$1.ot;
          if ((x185 !== null)) {
            this.xX();
            var x188 = x185.ot;
            if ((x188 !== null)) {
              this.xX();
              var x191 = x188.ot;
              if ((x191 !== null)) {
                this.xX();
                var x194 = x191.ot;
                if ((x194 !== null)) {
                  this.xX();
                  return new $c_T6((+x194.ot), (+x194.ou), (+x191.ou), (!(!x188.ou)), (!(!x185.ou)), x$1.ou);
                }
              }
            }
          }
        }
        throw new $c_s_MatchError(x$1);
      });
      if ((args === $m_sci_Nil$())) {
        var points = $m_sci_Nil$();
      } else {
        var x0 = args.t();
        var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
        var t = h;
        var rest = args.v();
        while ((rest !== $m_sci_Nil$())) {
          var x0$1 = rest.t();
          var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
          t.U = nx;
          t = nx;
          rest = rest.v();
        }
        var points = h;
      }
      return new $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$EllipticalArc($m_jl_UnicodeData$().Ao($m_sc_StringOps$().pw(cmdChar$2)), points);
    }))(cmdChar)));
  })));
});
$p.aYJ = (function() {
  return this.b4A().jQ(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.aYp()))).jQ(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.b46()))).jQ(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.b2E()))).jQ(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.bbm()))).jQ(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.aZv()))).jQ(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.b8Z()))).jQ(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.b76()))).jQ(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.b90()))).jQ(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.b0r())));
});
$p.b9z = (function() {
  var p = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.aYJ()));
  return $f_s_util_parsing_combinator_RegexParsers__phrase__s_util_parsing_combinator_Parsers$Parser__s_util_parsing_combinator_Parsers$Parser(this, $f_s_util_parsing_combinator_Parsers__rep1__F0__F0__s_util_parsing_combinator_Parsers$Parser(this, p, p));
});
$p.PH = (function(input) {
  var x199 = $f_s_util_parsing_combinator_RegexParsers__parseAll__s_util_parsing_combinator_Parsers$Parser__jl_CharSequence__s_util_parsing_combinator_Parsers$ParseResult(this, this.b9z(), input);
  if (((x199 instanceof $c_s_util_parsing_combinator_Parsers$Success) && (x199.lQ === this))) {
    this.OQ();
    return new $c_s_util_Right(x199.qL);
  }
  return new $c_s_util_Left(("Error parsing path: " + x199));
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_svg_SVGPathParser = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_svg_SVGPathParser, "org.jpablo.graphexplorer.viewer.formats.svg.SVGPathParser", ({
  Ck: 1,
  N0: 1,
  Na: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex$() {
  $n_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex$ = this;
  $m_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex$();
  var classDefs = $m_sci_Map$EmptyMap$();
  var classDefTexts = $m_sci_Map$EmptyMap$();
  $m_sci_VectorMap$();
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex$.prototype = $p;
$p.b1M = (function(graphAttrs) {
  var classDefs = graphAttrs.DQ(new $c_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex$$anon$1());
  var classDefTexts = graphAttrs.DQ(new $c_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex$$anon$2());
  var this$1 = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().X0(graphAttrs, $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$().a08);
  var this$2 = (this$1.c() ? $m_s_None$() : new $c_s_Some($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidStyleDeclarations$().Az(this$1.d().m())));
  var defaultEdgeStyles = (this$2.c() ? $m_sci_VectorMap$().jg : this$2.d());
  $m_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex$();
  return new $c_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex(classDefs, classDefTexts, defaultEdgeStyles);
});
var $d_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex$, "org.jpablo.graphexplorer.viewer.graph.AttributesOps$MermaidStyleIndex$", ({
  Cn: 1,
  d: 1,
  j: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex$;
function $m_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex$ = new $c_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$__toBase26$1__I__sci_List($thiz, n) {
  if ((n === 0)) {
    return $m_sci_Nil$();
  } else {
    var adjusted = ((n - 1) | 0);
    var quotient = ((adjusted / 26) | 0);
    return new $c_sci_$colon$colon(((adjusted % 26) | 0), ((quotient > 0) ? $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$__toBase26$1__I__sci_List($thiz, quotient) : $m_sci_Nil$()));
  }
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$() {
  this.aaG = null;
  this.aF5 = null;
  this.aF4 = null;
  this.a0L = null;
  $n_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$ = this;
  this.aaG = $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_T.r().C)([$m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GvId$().xd, "width", "pos", "height"])));
  this.aF5 = this.aaG.dI($m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_T.r().C)(["lp", "lwidth", "lheight"]))));
  this.aF4 = ($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$(), new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$(), $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$().aF8), ($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$(), $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$().p4.dR), ($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$(), $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$().GB), ($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$(), 0), ($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$(), 0), ($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$(), $m_sci_Map$EmptyMap$())));
  $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$();
  var graphAttributes$3 = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().aQB($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("directed", "true")])));
  $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$();
  var nodes$3 = $m_sci_VectorMap$().jg;
  $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$();
  var arrows$3 = $m_sci_Map$EmptyMap$();
  $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$();
  var memberships$3 = $m_sci_Map$EmptyMap$();
  $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$();
  var arrowMemberships$3 = $m_sci_Map$EmptyMap$();
  $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$();
  var groups$3 = $m_sci_Map$EmptyMap$();
  $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$();
  var defaultNodeAttributes$3 = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV;
  $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$();
  var defaultArrowAttributes$3 = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV;
  $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$();
  this.a0L = new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements(nodes$3, arrows$3, memberships$3, arrowMemberships$3, groups$3, graphAttributes$3, defaultNodeAttributes$3, defaultArrowAttributes$3), ($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$(), $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$().p4.dR), ($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$(), $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$().GB), ($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$(), 0), ($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$(), 0), ($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$(), $m_sci_Map$EmptyMap$()));
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$.prototype = $p;
$p.aiz = (function(graph, omitInternal) {
  return $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$().bbn($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$().aYG(graph.aA), graph.j7, graph.iC, omitInternal);
});
$p.b5S = (function(n) {
  if ((n <= 0)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Node ID number must be positive");
  } else {
    var this$1 = $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$__toBase26$1__I__sci_List(this, n).Jj();
    var f = ((i) => $bC((65535 & ((97 + (i | 0)) | 0))));
    if ((this$1 === $m_sci_Nil$())) {
      var $x_1 = $m_sci_Nil$();
    } else {
      var x0 = this$1.t();
      var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
      var t = h;
      var rest = this$1.v();
      while ((rest !== $m_sci_Nil$())) {
        var x0$1 = rest.t();
        var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
        t.U = nx;
        t = nx;
        rest = rest.v();
      }
      var $x_1 = h;
    }
    return $f_sc_IterableOnceOps__mkString__T__T__T__T($x_1, "", "", "");
  }
});
var $d_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$, "org.jpablo.graphexplorer.viewer.graph.ViewerGraph$", ({
  CB: 1,
  d: 1,
  j: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$;
function $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$ = new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$__combineAttributes__sci_Map__sci_Map($thiz, expandedAttrs) {
  return $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$__addStyle__sci_Map__s_Option__sci_Map($thiz, expandedAttrs, $p_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes__styleTokens__Z__s_Option($m_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes$().WY(expandedAttrs), true));
}
function $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$__combineAttributes__sci_Map__Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes__sci_Map($thiz, expandedAttrs, defaults) {
  var elementSubAttrs = $m_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes$().WY(expandedAttrs);
  var effectiveSubAttr = elementSubAttrs.aYD(defaults);
  var this$1 = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().qZ(expandedAttrs, $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillColor$());
  var hasFillColor = (!this$1.c());
  var effectiveFilled = effectiveSubAttr.x1.Py(true, $m_s_CanEqual$derived$());
  if ((hasFillColor && (!effectiveFilled))) {
    $m_sr_Scala3RunTime$().aeQ(("Invalid attributes: 'fillcolor' present without 'filled' style in element: " + expandedAttrs));
  }
  var x$2 = $m_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes$().Sp;
  if ((!((elementSubAttrs === null) ? (x$2 === null) : elementSubAttrs.e(x$2)))) {
    var this$3 = $p_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes__styleTokens__Z__s_Option(effectiveSubAttr, true);
    var $x_1 = (this$3.c() ? new $c_s_Some("") : this$3);
  } else {
    var $x_1 = $m_s_None$();
  }
  return $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$__addStyle__sci_Map__s_Option__sci_Map($thiz, expandedAttrs, $x_1);
}
function $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$__addStyle__sci_Map__s_Option__sci_Map($thiz, expandedAttrs, styleOpt) {
  if (($m_s_None$() === styleOpt)) {
    return $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().aen(expandedAttrs, $m_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes$().a06);
  }
  if ((styleOpt instanceof $c_s_Some)) {
    var style = styleOpt.J;
    $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$();
    var this$ = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().aen(expandedAttrs, $m_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes$().a06);
    var self = new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId($f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$()));
    $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$();
    var y = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(style);
    $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$();
    return this$.bN(self, y);
  }
  throw new $c_s_MatchError(styleOpt);
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$() {
  this.a0M = null;
  this.p4 = null;
  this.aF8 = null;
  this.aF6 = null;
  this.aF7 = false;
  $n_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$ = this;
  $m_Lupickle_default$();
  var $x_4 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => {
    $m_sci_VectorMap$();
    var b = new $c_sci_VectorMapBuilder();
    var it = new $c_sci_VectorMap$$anon$1(_$1);
    while (it.p()) {
      var x0 = it.dC();
      matchResult4: {
        var elem___1;
        var elem___2;
        if ((x0 !== null)) {
          var k = x0.g();
          var v = x0.h();
          var elem___1 = k.dE;
          var elem___2 = v;
          break matchResult4;
        }
        throw new $c_s_MatchError(x0);
      }
      b.pm(elem___1, elem___2);
    }
    return b.rb();
  }));
  var $x_3 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((map) => $m_sci_VectorMap$().u3(map.kP(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    if ((x$1 !== null)) {
      var k$1 = x$1.g();
      var v$1 = x$1.h();
      return new $c_T2(($m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$(), new $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId(k$1)), v$1);
    }
    throw new $c_s_MatchError(x$1);
  }))))));
  var $x_2 = $m_Lupickle_default$().cw();
  var $x_1 = $f_Lupickle_implicits_Readers__MapReader2__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5, $m_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$().bm());
  var this$2 = $m_Lupickle_default$();
  this.a0M = new $c_Lupickle_core_Types$$anon$1($x_4, $x_3, $x_2.ez($x_1, new $c_Lupickle_implicits_Writers$$anon$20($m_Lupickle_default$().I, $m_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$().bm(), this$2)));
  this.p4 = ($m_Lorg_jpablo_graphexplorer_viewer_models_GroupId$(), new $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId("G"));
  this.aF8 = ($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$(), new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements(($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$(), $m_sci_VectorMap$().jg), ($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$(), $m_sci_Map$EmptyMap$()), ($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$(), $m_sci_Map$EmptyMap$()), ($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$(), $m_sci_Map$EmptyMap$()), ($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$(), $m_sci_Map$EmptyMap$()), ($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$(), $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV), ($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$(), $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV), ($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$(), $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV)));
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$.prototype = $p;
$p.aYG = (function(elements) {
  var nodeDefaultsSubAttrs = $m_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes$().WY(elements.fE);
  var arrowDefaultsSubAttrs = $m_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes$().WY(elements.fD);
  $m_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes$().WY(elements.dW);
  var this$1 = elements.gr;
  $m_sci_VectorMap$();
  var b = new $c_sci_VectorMapBuilder();
  var it = new $c_sci_VectorMap$$anon$1(this$1);
  while (it.p()) {
    var x0 = it.dC();
    if ((x0 === null)) {
      throw new $c_s_MatchError(x0);
    }
    var k = x0.g();
    var v = x0.h();
    var this$3 = v.yg();
    var mod = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((nodeDefaultsSubAttrs) => ((v1) => {
      var attrs = ((v1 === null) ? null : v1.ce);
      return new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes($p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$__combineAttributes__sci_Map__Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes__sci_Map($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$(), attrs, nodeDefaultsSubAttrs));
    }))(nodeDefaultsSubAttrs));
    b.pm(k, this$3.eF.i(mod));
  }
  var nodes$1 = b.rb();
  var arrows$1 = elements.gH.wk(new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((_$3, a) => {
    var this$4 = a.yg();
    var mod$1 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1$1) => {
      var attrs$1 = ((v1$1 === null) ? null : v1$1.ce);
      return new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes($p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$__combineAttributes__sci_Map__Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes__sci_Map($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$(), attrs$1, arrowDefaultsSubAttrs));
    }));
    return this$4.eF.i(mod$1);
  })));
  var groups$1 = elements.fh.wk(new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((_$4, g) => {
    var this$5 = g.yg();
    var mod$2 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1$2) => {
      var expandedAttrs = ((v1$2 === null) ? null : v1$2.ce);
      return new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes($p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$__combineAttributes__sci_Map__sci_Map($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$(), expandedAttrs));
    }));
    return this$5.eF.i(mod$2);
  })));
  var graphAttributes$1 = $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$__combineAttributes__sci_Map__sci_Map(this, elements.dW);
  var defaultNodeAttributes$1 = $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$__addStyle__sci_Map__s_Option__sci_Map(this, elements.fE, $p_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes__styleTokens__Z__s_Option(nodeDefaultsSubAttrs, false));
  var defaultArrowAttributes$1 = $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$__addStyle__sci_Map__s_Option__sci_Map(this, elements.fD, $p_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes__styleTokens__Z__s_Option(arrowDefaultsSubAttrs, false));
  return new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements(nodes$1, arrows$1, elements.gq, elements.gp, groups$1, graphAttributes$1, defaultNodeAttributes$1, defaultArrowAttributes$1);
});
$p.bm = (function() {
  if ((!this.aF7)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().cw());
    var MacroImplicits_this = $m_Lupickle_default$();
    $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$();
    this.aF6 = MacroImplicits_this.cw().ez(new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$$anon$1(MacroImplicits_this, 8, this), new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$$anon$2(MacroImplicits_this, this));
    this.aF7 = true;
  }
  return this.aF6;
});
$p.b5T = (function(ReadersVersionSpecific_this$2) {
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.eO();
  }
  return true;
});
$p.b5U = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params, collection) => {
    $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$();
    var nodes = params.a[0];
    var arrows = params.a[1];
    var memberships = params.a[2];
    var arrowMemberships = params.a[3];
    var groups = params.a[4];
    var ev$4 = params.a[5];
    var graphAttributes = ((ev$4 === null) ? null : ev$4.ce);
    var ev$5 = params.a[6];
    var defaultNodeAttributes = ((ev$5 === null) ? null : ev$5.ce);
    var ev$6 = params.a[7];
    return new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements(nodes, arrows, memberships, arrowMemberships, groups, graphAttributes, defaultNodeAttributes, ((ev$6 === null) ? null : ev$6.ce));
  }));
});
var $d_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$, "org.jpablo.graphexplorer.viewer.graph.ViewerGraphElements$", ({
  CC: 1,
  d: 1,
  j: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$;
function $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$ = new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$;
}
function $s_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$__Successors__Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction() {
  $m_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$();
  return $t_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$__Successors;
}
function $s_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$__Predecessors__Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction() {
  $m_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$();
  return $t_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$__Predecessors;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$() {
  $n_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$ = this;
  $t_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$__Successors = new $c_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$$anon$1("Successors", 0);
  $t_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$__Predecessors = new $c_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$$anon$1("Predecessors", 1);
  $s_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$__Successors__Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction();
  $s_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$__Predecessors__Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction();
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$, "org.jpablo.graphexplorer.viewer.graph.VisibilityRules$Direction$", ({
  CL: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$;
function $m_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$ = new $c_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_graph_VizViewerGraphElements$() {
  $n_Lorg_jpablo_graphexplorer_viewer_graph_VizViewerGraphElements$ = this;
  $m_Lorg_jpablo_graphexplorer_viewer_models_GroupId$();
  $m_Lorg_jpablo_graphexplorer_viewer_graph_VizViewerGraphElements$();
  $m_Lorg_jpablo_graphexplorer_viewer_graph_VizViewerGraphElements$();
  var nodes = $m_sci_VectorMap$().jg;
  $m_Lorg_jpablo_graphexplorer_viewer_graph_VizViewerGraphElements$();
  var arrows = $m_sci_Map$EmptyMap$();
  $m_Lorg_jpablo_graphexplorer_viewer_graph_VizViewerGraphElements$();
  var memberships = $m_sci_Map$EmptyMap$();
  $m_Lorg_jpablo_graphexplorer_viewer_graph_VizViewerGraphElements$();
  var arrowMemberships = $m_sci_Map$EmptyMap$();
  $m_Lorg_jpablo_graphexplorer_viewer_graph_VizViewerGraphElements$();
  var groups = $m_sci_Map$EmptyMap$();
  $m_Lorg_jpablo_graphexplorer_viewer_graph_VizViewerGraphElements$();
  $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$();
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_graph_VizViewerGraphElements$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_graph_VizViewerGraphElements$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_graph_VizViewerGraphElements$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_graph_VizViewerGraphElements$.prototype = $p;
$p.a4k = (function(attrs) {
  var cleaned = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().aen(attrs, $m_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes$().a06);
  var this$1 = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().qZ(cleaned, $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$());
  var this$2 = (this$1.c() ? $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().qZ(cleaned, $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$()) : this$1);
  var style = (this$2.c() ? $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().qZ(cleaned, $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$()) : this$2);
  var styleSubAttrs = $m_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes$().b1U((style.c() ? $m_s_None$() : new $c_s_Some(style.d().m())));
  return $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().a2r($m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().W6($m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().W6($m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().W6($m_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes$().b7v(cleaned, styleSubAttrs), $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$()), $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$()), $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$()), styleSubAttrs.b9Z());
});
var $d_Lorg_jpablo_graphexplorer_viewer_graph_VizViewerGraphElements$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_graph_VizViewerGraphElements$, "org.jpablo.graphexplorer.viewer.graph.VizViewerGraphElements$", ({
  CN: 1,
  d: 1,
  j: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_graph_VizViewerGraphElements$;
function $m_Lorg_jpablo_graphexplorer_viewer_graph_VizViewerGraphElements$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_graph_VizViewerGraphElements$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_graph_VizViewerGraphElements$ = new $c_Lorg_jpablo_graphexplorer_viewer_graph_VizViewerGraphElements$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_graph_VizViewerGraphElements$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_layout3d_PlanarHints$__fromSimpleGraph__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph__Lorg_jpablo_graphexplorer_viewer_layout3d_PlanarHints($thiz, g, sg) {
  var positions = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$10(sg.aQu().o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n) => {
    var this$1 = n.qg;
    var this$2 = (this$1.c() ? $m_s_None$() : $p_Lorg_jpablo_graphexplorer_viewer_layout3d_PlanarHints$__parsePoint__T__s_Option($m_Lorg_jpablo_graphexplorer_viewer_layout3d_PlanarHints$(), this$1.d()));
    if (this$2.c()) {
      return $m_s_None$();
    } else {
      var x0$1 = this$2.d();
      return new $c_s_Some(new $c_T2(($m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$(), new $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId(n.p2)), x0$1));
    }
  }))));
  var sizes = $m_sci_Map$().ao(new $c_sc_Iterator$$anon$10(sg.aQu().o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((node) => {
    var this$9 = node.qh;
    if (this$9.c()) {
      var $x_1 = $m_s_None$();
    } else {
      var x0$2 = this$9.d();
      try {
        var $x_2 = new $c_s_util_Success($m_jl_Double$().bd(x0$2));
      } catch (e) {
        var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
        matchEnd8: {
          var $x_2;
          if ($m_s_util_control_NonFatal$().ew(e$2)) {
            var $x_2 = new $c_s_util_Failure(e$2);
            break matchEnd8;
          }
          throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
        }
      }
      var $x_1 = $x_2.rg();
    }
    var this$13 = $x_1;
    if (this$13.c()) {
      return $m_s_None$();
    } else {
      var x0$3 = this$13.d();
      var w = (+x0$3);
      var this$14 = node.qf;
      if (this$14.c()) {
        var $x_3 = $m_s_None$();
      } else {
        var x0$4 = this$14.d();
        try {
          var $x_4 = new $c_s_util_Success($m_jl_Double$().bd(x0$4));
        } catch (e$1) {
          var e$2$1 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
          matchEnd8$1: {
            var $x_4;
            if ($m_s_util_control_NonFatal$().ew(e$2$1)) {
              var $x_4 = new $c_s_util_Failure(e$2$1);
              break matchEnd8$1;
            }
            throw ((e$2$1 instanceof $c_sjs_js_JavaScriptException) ? e$2$1.bf : e$2$1);
          }
        }
        var $x_3 = $x_4.rg();
      }
      var this$18 = $x_3;
      if (this$18.c()) {
        return $m_s_None$();
      } else {
        var x0$5 = this$18.d();
        var h = (+x0$5);
        return new $c_s_Some(new $c_T2(($m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$(), new $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId(node.p2)), new $c_T2((72.0 * w), (72.0 * h))));
      }
    }
  }))));
  var edgePos = $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_package$().aOR(sg);
  var this$26 = g.fX;
  return new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_PlanarHints(positions, $m_sci_Vector$().X(this$26).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var arrowId = x$1.g();
    var arrow = x$1.h();
    var this$27 = edgePos.r(arrowId.l3);
    var found = (this$27.c() ? edgePos.r(((arrow.bX.dE + "->") + arrow.c0.dE)) : this$27);
    var x12 = (found.c() ? $m_s_None$() : new $c_s_Some($p_Lorg_jpablo_graphexplorer_viewer_layout3d_PlanarHints$__samplePath__Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ArrowPosition__sci_Vector($m_Lorg_jpablo_graphexplorer_viewer_layout3d_PlanarHints$(), found.d())));
    if ((x12 instanceof $c_s_Some)) {
      return x12.J;
    }
    if (($m_s_None$() === x12)) {
      var _1$1 = positions.r(arrow.bX);
      var _2$1 = positions.r(arrow.c0);
      if ((_1$1 instanceof $c_s_Some)) {
        var a = _1$1.J;
        if ((_2$1 instanceof $c_s_Some)) {
          var b = _2$1.J;
          $m_sci_Vector$();
          var b$1 = new $c_sci_VectorBuilder();
          var i = 0;
          while ((i < 9)) {
            var x0$7 = i;
            var t = (0.125 * x0$7);
            b$1.ck(new $c_T2(((+a.g()) + (((+b.g()) - (+a.g())) * t)), ((+a.h()) + (((+b.h()) - (+a.h())) * t))));
            i = ((1 + i) | 0);
          }
          return b$1.bY();
        }
      }
      $m_sci_Vector$();
      return $m_sci_Vector0$();
    }
    throw new $c_s_MatchError(x12);
  }))), sizes);
}
function $p_Lorg_jpablo_graphexplorer_viewer_layout3d_PlanarHints$__parsePoint__T__s_Option($thiz, s) {
  var x15 = $f_T__split__T__I__AT($m_sc_StringOps$().wh(s, "!"), ",", 0);
  if ((x15 !== null)) {
    if (($m_s_Array$UnapplySeqWrapper$().u9(x15, 2) === 0)) {
      var x17 = x15.a[0];
      var x18 = x15.a[1];
      try {
        var $x_1 = new $c_s_util_Success(new $c_T2($m_jl_Double$().bd(x17), $m_jl_Double$().bd(x18)));
      } catch (e) {
        var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
        matchEnd8: {
          var $x_1;
          if ($m_s_util_control_NonFatal$().ew(e$2)) {
            var $x_1 = new $c_s_util_Failure(e$2);
            break matchEnd8;
          }
          throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
        }
      }
      return $x_1.rg();
    }
  }
  return $m_s_None$();
}
function $p_Lorg_jpablo_graphexplorer_viewer_layout3d_PlanarHints$__samplePath__Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ArrowPosition__sci_Vector($thiz, ap) {
  var this$1 = ap.Sz;
  var this$3 = new $c_sci_$colon$colon(ap.Ls, this$1);
  var f = ((p) => new $c_T2(p.BS, p.BT));
  if ((this$3 === $m_sci_Nil$())) {
    var this$4 = $m_sci_Nil$();
  } else {
    var x0 = this$3.er;
    var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
    var t = h;
    var rest = this$3.U;
    while ((rest !== $m_sci_Nil$())) {
      var x0$1 = rest.t();
      var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
      t.U = nx;
      t = nx;
      rest = rest.v();
    }
    var this$4 = h;
  }
  var spline = $m_sci_Vector$().X(this$4);
  if (((spline.C() >= 4) && (((spline.C() % 3) | 0) === 1))) {
    var segments = ((((spline.C() - 1) | 0) / 3) | 0);
    $m_sci_Vector$();
    var buf = new $c_sci_VectorBuilder();
    var isEmpty = (segments <= 0);
    var scala$collection$immutable$Range$$lastElement = ((segments - 1) | 0);
    if ((!isEmpty)) {
      var i = 0;
      while (true) {
        var x0$2 = i;
        var p0 = spline.l(Math.imul(3, x0$2));
        var p1 = spline.l(((1 + Math.imul(3, x0$2)) | 0));
        var p2 = spline.l(((2 + Math.imul(3, x0$2)) | 0));
        var p3 = spline.l(((3 + Math.imul(3, x0$2)) | 0));
        var from = ((x0$2 !== 0) | 0);
        if ((!(from > 8))) {
          var i$1 = from;
          while (true) {
            buf.ck($p_Lorg_jpablo_graphexplorer_viewer_layout3d_PlanarHints$__cubic__T2__T2__T2__T2__D__T2($m_Lorg_jpablo_graphexplorer_viewer_layout3d_PlanarHints$(), p0, p1, p2, p3, (0.125 * i$1)));
            if ((i$1 === 8)) {
              break;
            }
            i$1 = ((1 + i$1) | 0);
          }
        }
        if ((i === scala$collection$immutable$Range$$lastElement)) {
          break;
        }
        i = ((1 + i) | 0);
      }
    }
    var $x_1 = buf.bY();
  } else {
    var $x_1 = spline;
  }
  return $p_Lorg_jpablo_graphexplorer_viewer_layout3d_PlanarHints$__resample__sci_Vector__I__sci_Vector($thiz, $x_1.bv(new $c_T2(ap.FT.BS, ap.FT.BT)), 9);
}
function $p_Lorg_jpablo_graphexplorer_viewer_layout3d_PlanarHints$__cubic__T2__T2__T2__T2__D__T2($thiz, p0, p1, p2, p3, t) {
  var u = (1.0 - t);
  var _1 = ((u * u) * u);
  var _2 = (((3.0 * u) * u) * t);
  var _3 = (((3.0 * u) * t) * t);
  var _4 = ((t * t) * t);
  return new $c_T2(((((_1 * (+p0.g())) + (_2 * (+p1.g()))) + (_3 * (+p2.g()))) + (_4 * (+p3.g()))), ((((_1 * (+p0.h())) + (_2 * (+p1.h()))) + (_3 * (+p2.h()))) + (_4 * (+p3.h()))));
}
function $p_Lorg_jpablo_graphexplorer_viewer_layout3d_PlanarHints$__resample__sci_Vector__I__sci_Vector($thiz, pts, n) {
  if ((pts.C() < 2)) {
    $m_sci_Vector$();
    var b = new $c_sci_VectorBuilder();
    var i = 0;
    while ((i < n)) {
      var this$2 = $f_sc_IndexedSeqOps__headOption__s_Option(pts);
      b.ck((this$2.c() ? new $c_T2(0.0, 0.0) : this$2.d()));
      i = ((1 + i) | 0);
    }
    return b.bY();
  } else {
    var this$12 = new $c_sc_Iterator$$anon$3($f_sc_IndexedSeqOps__sliding__I__I__sc_Iterator(pts, 2, 1), 0.0, new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((x$1, x$2) => {
      var x$1$1 = (+x$1);
      if ((x$2 !== null)) {
        var x = x$2.C();
        if ((((x === 2) ? 0 : ((x < 2) ? (-1) : 1)) === 0)) {
          var x25 = x$2.l(0);
          var x26 = x$2.l(1);
          return (x$1$1 + $m_jl_Math$().ga(((+x26.g()) - (+x25.g())), ((+x26.h()) - (+x25.h()))));
        }
      }
      return x$1$1;
    })));
    var cum = $m_sci_Vector$().X(this$12);
    var total = (+cum.bJ());
    if ((total <= 1.0E-9)) {
      $m_sci_Vector$();
      var b$1 = new $c_sci_VectorBuilder();
      var i$1 = 0;
      while ((i$1 < n)) {
        b$1.ck(pts.t());
        i$1 = ((1 + i$1) | 0);
      }
      return b$1.bY();
    } else {
      $m_sci_Vector$();
      var b$2 = new $c_sci_VectorBuilder();
      var i$2 = 0;
      while ((i$2 < n)) {
        var x0 = i$2;
        var target = ((total * x0) / ((n - 1) | 0));
        var i$3 = ((cum.C() - 1) | 0);
        var it = $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), new $c_sc_IndexedSeqView$Id(cum));
        while (((it.kc > 0) && (!((+it.q()) <= target)))) {
          i$3 = ((i$3 - 1) | 0);
        }
        var x$4 = i$3;
        var x$5 = ((x$4 > 0) ? x$4 : 0);
        var that = ((pts.C() - 2) | 0);
        var i$4 = ((x$5 < that) ? x$5 : that);
        var span = ((+cum.l(((1 + i$4) | 0))) - (+cum.l(i$4)));
        var t = ((span <= 1.0E-9) ? 0.0 : ((target - (+cum.l(i$4))) / span));
        var _1 = pts.l(i$4);
        var _2 = pts.l(((1 + i$4) | 0));
        b$2.ck(new $c_T2(((+_1.g()) + (((+_2.g()) - (+_1.g())) * t)), ((+_1.h()) + (((+_2.h()) - (+_1.h())) * t))));
        i$2 = ((1 + i$2) | 0);
      }
      return b$2.bY();
    }
  }
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_layout3d_PlanarHints$() {
  this.aUH = 0;
  this.aUH = 9;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_layout3d_PlanarHints$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_layout3d_PlanarHints$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_layout3d_PlanarHints$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_layout3d_PlanarHints$.prototype = $p;
$p.b1W = (function(g) {
  var dot = $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$().aiz(g, false);
  var result = $m_Lorg_jpablo_graphexplorer_graphviz_Graphviz$().aRF(dot, new $c_sci_$colon$colon("json0", $m_sci_Nil$()));
  var this$2 = new $c_s_Option$WithFilter(result.Kg.r("json0"), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((json) => (result.Kh === "success"))));
  var this$3 = this$2.tu;
  var p$1 = this$2.tv;
  var this$4 = ((this$3.c() || (!(!p$1.i(this$3.d())))) ? this$3 : $m_s_None$());
  if (this$4.c()) {
    return $m_s_None$();
  } else {
    var x0 = this$4.d();
    try {
      var $x_1 = new $c_s_util_Success($f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer(x0, $m_Lujson_StringParser$()), ($m_Lupickle_default$(), false), $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$().a3I()));
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      matchEnd8: {
        var $x_1;
        if ($m_s_util_control_NonFatal$().ew(e$2)) {
          var $x_1 = new $c_s_util_Failure(e$2);
          break matchEnd8;
        }
        throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
      }
    }
    var this$9 = $x_1.rg();
    return (this$9.c() ? $m_s_None$() : new $c_s_Some($p_Lorg_jpablo_graphexplorer_viewer_layout3d_PlanarHints$__fromSimpleGraph__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph__Lorg_jpablo_graphexplorer_viewer_layout3d_PlanarHints($m_Lorg_jpablo_graphexplorer_viewer_layout3d_PlanarHints$(), g, this$9.d())));
  }
});
var $d_Lorg_jpablo_graphexplorer_viewer_layout3d_PlanarHints$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_layout3d_PlanarHints$, "org.jpablo.graphexplorer.viewer.layout3d.PlanarHints$", ({
  CW: 1,
  d: 1,
  j: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_layout3d_PlanarHints$;
function $m_Lorg_jpablo_graphexplorer_viewer_layout3d_PlanarHints$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_layout3d_PlanarHints$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_layout3d_PlanarHints$ = new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_PlanarHints$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_layout3d_PlanarHints$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$() {
  this.zv = null;
  $n_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$ = this;
  this.zv = ($m_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$(), new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3(0.0, 0.0, 0.0));
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$, "org.jpablo.graphexplorer.viewer.layout3d.Vec3$", ({
  CX: 1,
  d: 1,
  j: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$;
function $m_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$ = new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$;
}
function $s_Lorg_jpablo_graphexplorer_viewer_logging_Level$__Debug__Lorg_jpablo_graphexplorer_viewer_logging_Level() {
  $m_Lorg_jpablo_graphexplorer_viewer_logging_Level$();
  return $t_Lorg_jpablo_graphexplorer_viewer_logging_Level$__Debug;
}
function $s_Lorg_jpablo_graphexplorer_viewer_logging_Level$__Info__Lorg_jpablo_graphexplorer_viewer_logging_Level() {
  $m_Lorg_jpablo_graphexplorer_viewer_logging_Level$();
  return $t_Lorg_jpablo_graphexplorer_viewer_logging_Level$__Info;
}
function $s_Lorg_jpablo_graphexplorer_viewer_logging_Level$__Warn__Lorg_jpablo_graphexplorer_viewer_logging_Level() {
  $m_Lorg_jpablo_graphexplorer_viewer_logging_Level$();
  return $t_Lorg_jpablo_graphexplorer_viewer_logging_Level$__Warn;
}
function $s_Lorg_jpablo_graphexplorer_viewer_logging_Level$__Error__Lorg_jpablo_graphexplorer_viewer_logging_Level() {
  $m_Lorg_jpablo_graphexplorer_viewer_logging_Level$();
  return $t_Lorg_jpablo_graphexplorer_viewer_logging_Level$__Error;
}
function $s_Lorg_jpablo_graphexplorer_viewer_logging_Level$__None__Lorg_jpablo_graphexplorer_viewer_logging_Level() {
  $m_Lorg_jpablo_graphexplorer_viewer_logging_Level$();
  return $t_Lorg_jpablo_graphexplorer_viewer_logging_Level$__None;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_logging_Level$() {
  $n_Lorg_jpablo_graphexplorer_viewer_logging_Level$ = this;
  $t_Lorg_jpablo_graphexplorer_viewer_logging_Level$__Debug = new $c_Lorg_jpablo_graphexplorer_viewer_logging_Level$$anon$1("Debug", 0);
  $t_Lorg_jpablo_graphexplorer_viewer_logging_Level$__Info = new $c_Lorg_jpablo_graphexplorer_viewer_logging_Level$$anon$1("Info", 1);
  $t_Lorg_jpablo_graphexplorer_viewer_logging_Level$__Warn = new $c_Lorg_jpablo_graphexplorer_viewer_logging_Level$$anon$1("Warn", 2);
  $t_Lorg_jpablo_graphexplorer_viewer_logging_Level$__Error = new $c_Lorg_jpablo_graphexplorer_viewer_logging_Level$$anon$1("Error", 3);
  $t_Lorg_jpablo_graphexplorer_viewer_logging_Level$__None = new $c_Lorg_jpablo_graphexplorer_viewer_logging_Level$$anon$1("None", 4);
  $s_Lorg_jpablo_graphexplorer_viewer_logging_Level$__Debug__Lorg_jpablo_graphexplorer_viewer_logging_Level();
  $s_Lorg_jpablo_graphexplorer_viewer_logging_Level$__Info__Lorg_jpablo_graphexplorer_viewer_logging_Level();
  $s_Lorg_jpablo_graphexplorer_viewer_logging_Level$__Warn__Lorg_jpablo_graphexplorer_viewer_logging_Level();
  $s_Lorg_jpablo_graphexplorer_viewer_logging_Level$__Error__Lorg_jpablo_graphexplorer_viewer_logging_Level();
  $s_Lorg_jpablo_graphexplorer_viewer_logging_Level$__None__Lorg_jpablo_graphexplorer_viewer_logging_Level();
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_logging_Level$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_logging_Level$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_logging_Level$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_logging_Level$.prototype = $p;
$p.b1T = (function(s) {
  switch (s.toLowerCase()) {
    case "debug": {
      return $s_Lorg_jpablo_graphexplorer_viewer_logging_Level$__Debug__Lorg_jpablo_graphexplorer_viewer_logging_Level();
      break;
    }
    case "info": {
      return $s_Lorg_jpablo_graphexplorer_viewer_logging_Level$__Info__Lorg_jpablo_graphexplorer_viewer_logging_Level();
      break;
    }
    case "warn": {
      return $s_Lorg_jpablo_graphexplorer_viewer_logging_Level$__Warn__Lorg_jpablo_graphexplorer_viewer_logging_Level();
      break;
    }
    case "error": {
      return $s_Lorg_jpablo_graphexplorer_viewer_logging_Level$__Error__Lorg_jpablo_graphexplorer_viewer_logging_Level();
      break;
    }
    case "none": {
      return $s_Lorg_jpablo_graphexplorer_viewer_logging_Level$__None__Lorg_jpablo_graphexplorer_viewer_logging_Level();
      break;
    }
    default: {
      return $s_Lorg_jpablo_graphexplorer_viewer_logging_Level$__Info__Lorg_jpablo_graphexplorer_viewer_logging_Level();
    }
  }
});
var $d_Lorg_jpablo_graphexplorer_viewer_logging_Level$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_logging_Level$, "org.jpablo.graphexplorer.viewer.logging.Level$", ({
  CZ: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_logging_Level$;
function $m_Lorg_jpablo_graphexplorer_viewer_logging_Level$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_logging_Level$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_logging_Level$ = new $c_Lorg_jpablo_graphexplorer_viewer_logging_Level$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_logging_Level$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_Arrow$() {
  this.a0P = null;
  this.a0O = null;
  this.aFc = null;
  this.aF9 = null;
  this.aFa = null;
  this.aFb = false;
  $n_Lorg_jpablo_graphexplorer_viewer_models_Arrow$ = this;
  this.a0P = "->";
  this.a0O = "/";
  this.aFc = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), (((("(.+)" + this.a0P) + "(.+)") + this.a0O) + "(\\d+)"), $m_sci_Nil$());
  this.aF9 = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "arrow:(.+)", $m_sci_Nil$());
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_Arrow$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_Arrow$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_Arrow$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_Arrow$.prototype = $p;
$p.aOy = (function(arrowId) {
  var x26 = arrowId.l3;
  if ((x26 !== null)) {
    var x27 = this.aFc.jw(x26);
    if ((!x27.c())) {
      var x28 = x27.d();
      if ((x28.bL(3) === 0)) {
        var x29 = $f_sc_LinearSeqOps__apply__I__O(x28, 0);
        var x30 = $f_sc_LinearSeqOps__apply__I__O(x28, 1);
        var x31 = $f_sc_LinearSeqOps__apply__I__O(x28, 2);
        if ((($f_T__trim__T(x29) !== "") && ($f_T__trim__T(x30) !== ""))) {
          var self = $f_T__trim__T(x29);
          var y = $f_T__trim__T(x30);
          var seq$1 = $m_jl_Integer$().gc(x31, 10, 214748364);
          var attrs$1 = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV;
          var sourcePort$1 = $m_s_None$();
          var targetPort$1 = $m_s_None$();
          return new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_models_Arrow(($m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$(), new $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId(self)), ($m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$(), new $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId(y)), attrs$1, sourcePort$1, targetPort$1, seq$1));
        }
      }
    }
  }
  return $m_s_None$();
});
$p.WZ = (function(idAttr) {
  if ((idAttr !== null)) {
    var x33 = this.aF9.jw(idAttr);
    if ((!x33.c())) {
      var x34 = x33.d();
      if ((x34.bL(1) === 0)) {
        var x35 = $f_sc_LinearSeqOps__apply__I__O(x34, 0);
        return new $c_s_Some(($m_Lorg_jpablo_graphexplorer_viewer_models_ArrowId$(), new $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowId(x35)));
      }
    }
  }
  return $m_s_None$();
});
$p.bm = (function() {
  if ((!this.aFb)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().cw());
    var MacroImplicits_this = $m_Lupickle_default$();
    $m_Lorg_jpablo_graphexplorer_viewer_models_Arrow$();
    var $x_1 = MacroImplicits_this.cw();
    var reader = new $c_Lorg_jpablo_graphexplorer_viewer_models_Arrow$$anon$4(MacroImplicits_this, 6, this);
    this.aFa = $x_1.ez(new $c_Lupickle_core_Types$TaggedReader$Leaf(MacroImplicits_this.Iy(), "$type", "org.jpablo.graphexplorer.viewer.models.Arrow", "Arrow", reader), $f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(MacroImplicits_this, new $c_Lorg_jpablo_graphexplorer_viewer_models_Arrow$$anon$5(MacroImplicits_this, this), "$type", "org.jpablo.graphexplorer.viewer.models.Arrow", "Arrow", new $c_Lupickle_core_Annotator$Checker$Cls($d_Lorg_jpablo_graphexplorer_viewer_models_Arrow.l())));
    this.aFb = true;
  }
  return this.aFa;
});
$p.b5V = (function(ReadersVersionSpecific_this$5) {
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.eO();
  }
  return true;
});
$p.b5W = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params, collection) => {
    $m_Lorg_jpablo_graphexplorer_viewer_models_Arrow$();
    var source = params.a[0];
    var target = params.a[1];
    var ev$14 = params.a[2];
    return new $c_Lorg_jpablo_graphexplorer_viewer_models_Arrow(source, target, ((ev$14 === null) ? null : ev$14.ce), params.a[3], params.a[4], (params.a[5] | 0));
  }));
});
var $d_Lorg_jpablo_graphexplorer_viewer_models_Arrow$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_Arrow$, "org.jpablo.graphexplorer.viewer.models.Arrow$", ({
  D2: 1,
  d: 1,
  j: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_models_Arrow$;
function $m_Lorg_jpablo_graphexplorer_viewer_models_Arrow$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_models_Arrow$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_models_Arrow$ = new $c_Lorg_jpablo_graphexplorer_viewer_models_Arrow$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_models_Arrow$;
}
function $s_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$__forward__Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection() {
  $m_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$();
  return $t_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$__forward;
}
function $s_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$__backward__Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection() {
  $m_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$();
  return $t_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$__backward;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$() {
  this.aFd = null;
  $n_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$ = this;
  $t_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$__forward = new $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$$anon$3("forward", 0);
  $t_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$__backward = new $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$$anon$3("backward", 1);
  this.aFd = new ($d_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection.r().C)([$s_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$__forward__Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection(), $s_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$__backward__Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection()]);
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$.prototype = $p;
$p.bbj = (function() {
  return this.aFd.ae();
});
var $d_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$, "org.jpablo.graphexplorer.viewer.models.ArrowDirection$", ({
  D5: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$;
function $m_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$ = new $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowId$() {
  this.aFf = null;
  this.aFg = false;
  this.aFe = null;
  $n_Lorg_jpablo_graphexplorer_viewer_models_ArrowId$ = this;
  this.aFe = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "arrow:(.+)", $m_sci_Nil$());
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowId$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowId$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_ArrowId$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_ArrowId$.prototype = $p;
$p.Pp = (function() {
  if ((!this.aFg)) {
    var this$4 = $m_Lupickle_default$();
    this.aFf = new $c_Lupickle_Api$$anon$3(($m_Lupickle_default$(), new $c_Lupickle_core_Types$$anon$1(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => _$1.l3)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => {
      $m_Lorg_jpablo_graphexplorer_viewer_models_ArrowId$();
      return new $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowId(_$2);
    })), $m_Lupickle_default$().cw().ez($m_Lupickle_default$().a5, $m_Lupickle_default$().I))), this$4);
    this.aFg = true;
  }
  return this.aFf;
});
$p.WZ = (function(idAttr) {
  if ((idAttr !== null)) {
    var x38 = this.aFe.jw(idAttr);
    if ((!x38.c())) {
      var x39 = x38.d();
      if ((x39.bL(1) === 0)) {
        var x40 = $f_sc_LinearSeqOps__apply__I__O(x39, 0);
        return new $c_s_Some(($m_Lorg_jpablo_graphexplorer_viewer_models_ArrowId$(), new $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowId(x40)));
      }
    }
  }
  return $m_s_None$();
});
var $d_Lorg_jpablo_graphexplorer_viewer_models_ArrowId$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_ArrowId$, "org.jpablo.graphexplorer.viewer.models.ArrowId$", ({
  D7: 1,
  d: 1,
  j: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_models_ArrowId$;
function $m_Lorg_jpablo_graphexplorer_viewer_models_ArrowId$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_models_ArrowId$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_models_ArrowId$ = new $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowId$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_models_ArrowId$;
}
function $s_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$__Multiple__Lorg_jpablo_graphexplorer_viewer_models_AttrStatus() {
  $m_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$();
  return $t_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$__Multiple;
}
function $s_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$__Missing__Lorg_jpablo_graphexplorer_viewer_models_AttrStatus() {
  $m_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$();
  return $t_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$__Missing;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$() {
  $n_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$ = this;
  $t_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$__Multiple = new $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$$anon$1();
  $t_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$__Missing = new $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$$anon$2();
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$, "org.jpablo.graphexplorer.viewer.models.AttrStatus$", ({
  D8: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$;
function $m_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$ = new $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeUpdates$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeUpdates$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeUpdates$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_AttributeUpdates$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_AttributeUpdates$.prototype = $p;
$p.aRv = (function(keys) {
  return new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeUpdates(keys.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$9) => new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId(((_$9 === null) ? null : _$9.fY)), $s_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$__Missing__Lorg_jpablo_graphexplorer_viewer_models_AttrStatus())))).eX($m_s_$less$colon$less$().b1));
});
var $d_Lorg_jpablo_graphexplorer_viewer_models_AttributeUpdates$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_AttributeUpdates$, "org.jpablo.graphexplorer.viewer.models.AttributeUpdates$", ({
  Dd: 1,
  d: 1,
  j: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_models_AttributeUpdates$;
function $m_Lorg_jpablo_graphexplorer_viewer_models_AttributeUpdates$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_models_AttributeUpdates$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_models_AttributeUpdates$ = new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeUpdates$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_models_AttributeUpdates$;
}
function $s_Lorg_jpablo_graphexplorer_viewer_models_ClientSize$__Normal__Lorg_jpablo_graphexplorer_viewer_models_ClientSize() {
  $m_Lorg_jpablo_graphexplorer_viewer_models_ClientSize$();
  return $t_Lorg_jpablo_graphexplorer_viewer_models_ClientSize$__Normal;
}
function $s_Lorg_jpablo_graphexplorer_viewer_models_ClientSize$__Small__Lorg_jpablo_graphexplorer_viewer_models_ClientSize() {
  $m_Lorg_jpablo_graphexplorer_viewer_models_ClientSize$();
  return $t_Lorg_jpablo_graphexplorer_viewer_models_ClientSize$__Small;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_ClientSize$() {
  $n_Lorg_jpablo_graphexplorer_viewer_models_ClientSize$ = this;
  $t_Lorg_jpablo_graphexplorer_viewer_models_ClientSize$__Normal = new $c_Lorg_jpablo_graphexplorer_viewer_models_ClientSize$$anon$1("Normal", 0);
  $t_Lorg_jpablo_graphexplorer_viewer_models_ClientSize$__Small = new $c_Lorg_jpablo_graphexplorer_viewer_models_ClientSize$$anon$1("Small", 1);
  $s_Lorg_jpablo_graphexplorer_viewer_models_ClientSize$__Normal__Lorg_jpablo_graphexplorer_viewer_models_ClientSize();
  $s_Lorg_jpablo_graphexplorer_viewer_models_ClientSize$__Small__Lorg_jpablo_graphexplorer_viewer_models_ClientSize();
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_ClientSize$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_ClientSize$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_ClientSize$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_ClientSize$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_viewer_models_ClientSize$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_ClientSize$, "org.jpablo.graphexplorer.viewer.models.ClientSize$", ({
  Dg: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_models_ClientSize$;
function $m_Lorg_jpablo_graphexplorer_viewer_models_ClientSize$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_models_ClientSize$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_models_ClientSize$ = new $c_Lorg_jpablo_graphexplorer_viewer_models_ClientSize$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_models_ClientSize$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_models_ElementId$__x1$lzyINIT1$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__Lupickle_core_Types$Reader($thiz, x1$lzy1$1, ReadersVersionSpecific_this$1, x0$lzy1$1) {
  if (x1$lzy1$1.ci) {
    var $x_1 = x1$lzy1$1.cj;
  } else {
    var readers = $m_sci_Nil$().b6(new $c_sr_ScalaRunTime$$anon$1(new $c_T2($m_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$().bm(), $p_Lorg_jpablo_graphexplorer_viewer_models_ElementId$__x0$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x0$lzy1$1, ReadersVersionSpecific_this$1))));
    var $x_1 = x1$lzy1$1.h3(ReadersVersionSpecific_this$1.OP().aQf("$type", readers));
  }
  return $x_1;
}
function $p_Lorg_jpablo_graphexplorer_viewer_models_ElementId$__x1$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__Lupickle_core_Types$Reader($thiz, x1$lzy1$2, ReadersVersionSpecific_this$2, x0$lzy1$2) {
  return (x1$lzy1$2.ci ? x1$lzy1$2.cj : $p_Lorg_jpablo_graphexplorer_viewer_models_ElementId$__x1$lzyINIT1$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__Lupickle_core_Types$Reader($thiz, x1$lzy1$2, ReadersVersionSpecific_this$2, x0$lzy1$2));
}
function $p_Lorg_jpablo_graphexplorer_viewer_models_ElementId$__x0$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x0$lzy1$3, ReadersVersionSpecific_this$3) {
  if (x0$lzy1$3.ci) {
    var $x_1 = x0$lzy1$3.cj;
  } else {
    $m_Lorg_jpablo_graphexplorer_viewer_models_ArrowId$();
    var reader = new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementId$$anon$1(ReadersVersionSpecific_this$3, 1, $thiz);
    var $x_1 = x0$lzy1$3.h3(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$3.Iy(), "$type", "org.jpablo.graphexplorer.viewer.models.ArrowId", "ArrowId", reader));
  }
  return $x_1;
}
function $p_Lorg_jpablo_graphexplorer_viewer_models_ElementId$__x0$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x0$lzy1$4, ReadersVersionSpecific_this$7) {
  return (x0$lzy1$4.ci ? x0$lzy1$4.cj : $p_Lorg_jpablo_graphexplorer_viewer_models_ElementId$__x0$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x0$lzy1$4, ReadersVersionSpecific_this$7));
}
function $p_Lorg_jpablo_graphexplorer_viewer_models_ElementId$__x1$lzyINIT2$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__Lupickle_core_Types$Writer($thiz, x1$lzy2$1, WritersVersionSpecific_this$1, x0$lzy2$1) {
  if (x1$lzy2$1.ci) {
    var $x_1 = x1$lzy2$1.cj;
  } else {
    var writers = $m_sci_Nil$().b6(new $c_sr_ScalaRunTime$$anon$1(new $c_T2($m_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$().bm(), $p_Lorg_jpablo_graphexplorer_viewer_models_ElementId$__x0$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x0$lzy2$1, WritersVersionSpecific_this$1))));
    var $x_1 = x1$lzy2$1.h3(WritersVersionSpecific_this$1.aLH().aQg(writers));
  }
  return $x_1;
}
function $p_Lorg_jpablo_graphexplorer_viewer_models_ElementId$__x1$2__sr_LazyRef__Lupickle_default$__sr_LazyRef__Lupickle_core_Types$Writer($thiz, x1$lzy2$2, WritersVersionSpecific_this$2, x0$lzy2$2) {
  return (x1$lzy2$2.ci ? x1$lzy2$2.cj : $p_Lorg_jpablo_graphexplorer_viewer_models_ElementId$__x1$lzyINIT2$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__Lupickle_core_Types$Writer($thiz, x1$lzy2$2, WritersVersionSpecific_this$2, x0$lzy2$2));
}
function $p_Lorg_jpablo_graphexplorer_viewer_models_ElementId$__x0$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x0$lzy2$3, WritersVersionSpecific_this$3) {
  return (x0$lzy2$3.ci ? x0$lzy2$3.cj : x0$lzy2$3.h3(($m_Lorg_jpablo_graphexplorer_viewer_models_ArrowId$(), $f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$3, new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementId$$anon$2(WritersVersionSpecific_this$3, $thiz), "$type", "org.jpablo.graphexplorer.viewer.models.ArrowId", "ArrowId", new $c_Lupickle_core_Annotator$Checker$Cls($d_Lorg_jpablo_graphexplorer_viewer_models_ArrowId.l())))));
}
function $p_Lorg_jpablo_graphexplorer_viewer_models_ElementId$__x0$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x0$lzy2$4, WritersVersionSpecific_this$6) {
  return (x0$lzy2$4.ci ? x0$lzy2$4.cj : $p_Lorg_jpablo_graphexplorer_viewer_models_ElementId$__x0$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x0$lzy2$4, WritersVersionSpecific_this$6));
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_ElementId$() {
  this.aFl = null;
  this.aFm = false;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_ElementId$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_ElementId$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_ElementId$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_ElementId$.prototype = $p;
$p.bm = (function() {
  if ((!this.aFm)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().cw());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.aFl = MacroImplicits_this.cw().ez($p_Lorg_jpablo_graphexplorer_viewer_models_ElementId$__x1$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__Lupickle_core_Types$Reader(this, new $c_sr_LazyRef(), MacroImplicits_this, new $c_sr_LazyRef()), $p_Lorg_jpablo_graphexplorer_viewer_models_ElementId$__x1$2__sr_LazyRef__Lupickle_default$__sr_LazyRef__Lupickle_core_Types$Writer(this, new $c_sr_LazyRef(), MacroImplicits_this, new $c_sr_LazyRef()));
    this.aFm = true;
  }
  return this.aFl;
});
$p.b5X = (function(ReadersVersionSpecific_this$5) {
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.eO();
  }
  return true;
});
$p.b5Y = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params, collection) => {
    $m_Lorg_jpablo_graphexplorer_viewer_models_ArrowId$();
    return new $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowId(params.a[0]);
  }));
});
var $d_Lorg_jpablo_graphexplorer_viewer_models_ElementId$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_ElementId$, "org.jpablo.graphexplorer.viewer.models.ElementId$", ({
  Di: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_models_ElementId$;
function $m_Lorg_jpablo_graphexplorer_viewer_models_ElementId$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_models_ElementId$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_models_ElementId$ = new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementId$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_models_ElementId$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId$() {
  this.aFp = null;
  this.aFq = null;
  this.aFr = false;
  this.aFs = null;
  $n_Lorg_jpablo_graphexplorer_viewer_models_GroupId$ = this;
  this.aFp = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "cluster(.+)", $m_sci_Nil$());
  this.aFs = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "group:(.+)", $m_sci_Nil$());
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_GroupId$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_GroupId$.prototype = $p;
$p.oC = (function() {
  if ((!this.aFr)) {
    this.aFq = ($m_Lupickle_default$(), new $c_Lupickle_core_Types$$anon$1(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3) => _$3.dR)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4) => {
      $m_Lorg_jpablo_graphexplorer_viewer_models_GroupId$();
      return new $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId(_$4);
    })), $m_Lupickle_default$().cw().ez($m_Lupickle_default$().a5, $m_Lupickle_default$().I)));
    this.aFr = true;
  }
  return this.aFq;
});
$p.WX = (function(cluster) {
  if ((cluster !== null)) {
    var x42 = this.aFp.jw(cluster);
    if ((!x42.c())) {
      var x43 = x42.d();
      if ((x43.bL(1) === 0)) {
        var x44 = $f_sc_LinearSeqOps__apply__I__O(x43, 0);
        var cleanId = ((!(!x44.startsWith("_"))) ? $m_sc_StringOps$().kp(x44, 1) : x44);
        return new $c_T2(($m_Lorg_jpablo_graphexplorer_viewer_models_GroupId$(), new $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId(cleanId)), true);
      }
    }
  }
  return new $c_T2(($m_Lorg_jpablo_graphexplorer_viewer_models_GroupId$(), new $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId(cluster)), false);
});
$p.WZ = (function(idAttr) {
  if ((idAttr !== null)) {
    var x46 = this.aFs.jw(idAttr);
    if ((!x46.c())) {
      var x47 = x46.d();
      if ((x47.bL(1) === 0)) {
        var x48 = $f_sc_LinearSeqOps__apply__I__O(x47, 0);
        return new $c_s_Some(($m_Lorg_jpablo_graphexplorer_viewer_models_GroupId$(), new $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId(x48)));
      }
    }
  }
  return $m_s_None$();
});
var $d_Lorg_jpablo_graphexplorer_viewer_models_GroupId$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_GroupId$, "org.jpablo.graphexplorer.viewer.models.GroupId$", ({
  Dn: 1,
  d: 1,
  j: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_models_GroupId$;
function $m_Lorg_jpablo_graphexplorer_viewer_models_GroupId$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_models_GroupId$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_models_GroupId$ = new $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_models_GroupId$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$__x2$lzyINIT1$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader($thiz, x2$lzy1$1, ReadersVersionSpecific_this$8, x0$lzy3$1, x1$lzy3$1) {
  if (x2$lzy1$1.ci) {
    var $x_1 = x2$lzy1$1.cj;
  } else {
    var readers = $m_sci_Nil$().b6(new $c_sr_ScalaRunTime$$anon$1(new $c_T2($p_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$__x0$3__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x0$lzy3$1, ReadersVersionSpecific_this$8), $p_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$__x1$3__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x1$lzy3$1, ReadersVersionSpecific_this$8))));
    var $x_1 = x2$lzy1$1.h3(ReadersVersionSpecific_this$8.OP().aQf("$type", readers));
  }
  return $x_1;
}
function $p_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$__x2$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader($thiz, x2$lzy1$2, ReadersVersionSpecific_this$9, x0$lzy3$2, x1$lzy3$2) {
  return (x2$lzy1$2.ci ? x2$lzy1$2.cj : $p_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$__x2$lzyINIT1$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader($thiz, x2$lzy1$2, ReadersVersionSpecific_this$9, x0$lzy3$2, x1$lzy3$2));
}
function $p_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$__x1$lzyINIT3$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x1$lzy3$3, ReadersVersionSpecific_this$10) {
  if (x1$lzy3$3.ci) {
    var $x_1 = x1$lzy3$3.cj;
  } else {
    $m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$();
    var reader = new $c_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$$anon$3(ReadersVersionSpecific_this$10, 1, $thiz);
    var $x_1 = x1$lzy3$3.h3(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$10.Iy(), "$type", "org.jpablo.graphexplorer.viewer.models.NodeId", "NodeId", reader));
  }
  return $x_1;
}
function $p_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$__x1$3__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x1$lzy3$4, ReadersVersionSpecific_this$14) {
  return (x1$lzy3$4.ci ? x1$lzy3$4.cj : $p_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$__x1$lzyINIT3$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x1$lzy3$4, ReadersVersionSpecific_this$14));
}
function $p_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$__x0$lzyINIT3$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x0$lzy3$3, ReadersVersionSpecific_this$15) {
  if (x0$lzy3$3.ci) {
    var $x_1 = x0$lzy3$3.cj;
  } else {
    $m_Lorg_jpablo_graphexplorer_viewer_models_GroupId$();
    var reader = new $c_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$$anon$4(ReadersVersionSpecific_this$15, 1, $thiz);
    var $x_1 = x0$lzy3$3.h3(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$15.Iy(), "$type", "org.jpablo.graphexplorer.viewer.models.GroupId", "GroupId", reader));
  }
  return $x_1;
}
function $p_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$__x0$3__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x0$lzy3$4, ReadersVersionSpecific_this$19) {
  return (x0$lzy3$4.ci ? x0$lzy3$4.cj : $p_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$__x0$lzyINIT3$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x0$lzy3$4, ReadersVersionSpecific_this$19));
}
function $p_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$__x2$lzyINIT2$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer($thiz, x2$lzy2$1, WritersVersionSpecific_this$7, x0$lzy4$1, x1$lzy4$1) {
  if (x2$lzy2$1.ci) {
    var $x_1 = x2$lzy2$1.cj;
  } else {
    var writers = $m_sci_Nil$().b6(new $c_sr_ScalaRunTime$$anon$1(new $c_T2($p_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$__x0$4__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x0$lzy4$1, WritersVersionSpecific_this$7), $p_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$__x1$4__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x1$lzy4$1, WritersVersionSpecific_this$7))));
    var $x_1 = x2$lzy2$1.h3(WritersVersionSpecific_this$7.aLH().aQg(writers));
  }
  return $x_1;
}
function $p_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$__x2$2__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer($thiz, x2$lzy2$2, WritersVersionSpecific_this$8, x0$lzy4$2, x1$lzy4$2) {
  return (x2$lzy2$2.ci ? x2$lzy2$2.cj : $p_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$__x2$lzyINIT2$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer($thiz, x2$lzy2$2, WritersVersionSpecific_this$8, x0$lzy4$2, x1$lzy4$2));
}
function $p_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$__x1$lzyINIT4$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x1$lzy4$3, WritersVersionSpecific_this$9) {
  return (x1$lzy4$3.ci ? x1$lzy4$3.cj : x1$lzy4$3.h3(($m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$(), $f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$9, new $c_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$$anon$5(WritersVersionSpecific_this$9, $thiz), "$type", "org.jpablo.graphexplorer.viewer.models.NodeId", "NodeId", new $c_Lupickle_core_Annotator$Checker$Cls($d_Lorg_jpablo_graphexplorer_viewer_models_NodeId.l())))));
}
function $p_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$__x1$4__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x1$lzy4$4, WritersVersionSpecific_this$12) {
  return (x1$lzy4$4.ci ? x1$lzy4$4.cj : $p_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$__x1$lzyINIT4$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x1$lzy4$4, WritersVersionSpecific_this$12));
}
function $p_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$__x0$lzyINIT4$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x0$lzy4$3, WritersVersionSpecific_this$13) {
  return (x0$lzy4$3.ci ? x0$lzy4$3.cj : x0$lzy4$3.h3(($m_Lorg_jpablo_graphexplorer_viewer_models_GroupId$(), $f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$13, new $c_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$$anon$6(WritersVersionSpecific_this$13, $thiz), "$type", "org.jpablo.graphexplorer.viewer.models.GroupId", "GroupId", new $c_Lupickle_core_Annotator$Checker$Cls($d_Lorg_jpablo_graphexplorer_viewer_models_GroupId.l())))));
}
function $p_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$__x0$4__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x0$lzy4$4, WritersVersionSpecific_this$16) {
  return (x0$lzy4$4.ci ? x0$lzy4$4.cj : $p_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$__x0$lzyINIT4$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x0$lzy4$4, WritersVersionSpecific_this$16));
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$() {
  this.aFt = null;
  this.aFu = false;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$.prototype = $p;
$p.aYj = (function(ids) {
  var z = new $c_Lorg_jpablo_graphexplorer_viewer_models_IdsByKind($m_sci_Set$EmptySet$(), $m_sci_Set$EmptySet$(), $m_sci_Set$EmptySet$());
  var f = ((acc, eId) => {
    if ((eId instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId)) {
      return new $c_Lorg_jpablo_graphexplorer_viewer_models_IdsByKind(acc.f3.hQ(eId), acc.gg, acc.gf);
    }
    if ((eId instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId)) {
      var nodes$1$1 = acc.gg.hQ(eId);
      return new $c_Lorg_jpablo_graphexplorer_viewer_models_IdsByKind(acc.f3, nodes$1$1, acc.gf);
    }
    throw new $c_s_MatchError(eId);
  });
  if ($is_sc_IndexedSeq(ids)) {
    var at = 0;
    var end = ids.C();
    var acc$1 = z;
    var $x_1;
    while (true) {
      if ((at !== end)) {
        var temp$at = ((1 + at) | 0);
        var x0 = acc$1;
        var x1 = ids.l(at);
        var temp$acc = f(x0, x1);
        at = temp$at;
        acc$1 = temp$acc;
        continue;
      }
      var $x_1 = acc$1;
      break;
    }
  } else {
    var result = z;
    var it = ids.o();
    while (it.p()) {
      var x0$1 = result;
      var x1$1 = it.q();
      result = f(x0$1, x1$1);
    }
    var $x_1 = result;
  }
  return $x_1;
});
$p.bm = (function() {
  if ((!this.aFu)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().cw());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.aFt = MacroImplicits_this.cw().ez($p_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$__x2$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader(this, new $c_sr_LazyRef(), MacroImplicits_this, new $c_sr_LazyRef(), new $c_sr_LazyRef()), $p_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$__x2$2__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer(this, new $c_sr_LazyRef(), MacroImplicits_this, new $c_sr_LazyRef(), new $c_sr_LazyRef()));
    this.aFu = true;
  }
  return this.aFt;
});
$p.b5Z = (function(ReadersVersionSpecific_this$12) {
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.eO();
  }
  return true;
});
$p.b60 = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params, collection) => {
    $m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$();
    return new $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId(params.a[0]);
  }));
});
$p.b61 = (function(ReadersVersionSpecific_this$17) {
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.eO();
  }
  return true;
});
$p.b62 = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params, collection) => {
    $m_Lorg_jpablo_graphexplorer_viewer_models_GroupId$();
    return new $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId(params.a[0]);
  }));
});
var $d_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$, "org.jpablo.graphexplorer.viewer.models.GroupMemberId$", ({
  Do: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$;
function $m_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$ = new $c_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId$() {
  this.aFv = null;
  this.aFw = false;
  $n_Lorg_jpablo_graphexplorer_viewer_models_NodeId$ = this;
  $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "node:(.+)", $m_sci_Nil$());
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_NodeId$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_NodeId$.prototype = $p;
$p.An = (function() {
  if ((!this.aFw)) {
    var this$4 = $m_Lupickle_default$();
    this.aFv = new $c_Lupickle_Api$$anon$3(($m_Lupickle_default$(), new $c_Lupickle_core_Types$$anon$1(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$5) => _$5.dE)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6) => {
      $m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$();
      return new $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId(_$6);
    })), $m_Lupickle_default$().cw().ez($m_Lupickle_default$().a5, $m_Lupickle_default$().I))), this$4);
    this.aFw = true;
  }
  return this.aFv;
});
var $d_Lorg_jpablo_graphexplorer_viewer_models_NodeId$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_NodeId$, "org.jpablo.graphexplorer.viewer.models.NodeId$", ({
  Dt: 1,
  d: 1,
  j: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_models_NodeId$;
function $m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_models_NodeId$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_models_NodeId$ = new $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_models_NodeId$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$() {
  this.aaT = null;
  this.aFx = null;
  this.aFy = false;
  $n_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$ = this;
  this.aaT = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().Au($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_AttributePair.r().C)([new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributePair$$anon$3(new $c_T2($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Label$(), "")), new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributePair$$anon$3(new $c_T2($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ClusterLabelLoc$(), ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ClusterLabelLoc$(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc$__t__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc()))), new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributePair$$anon$3(new $c_T2($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$(), $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$().aaj)), new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributePair$$anon$3(new $c_T2($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Cluster$(), true))])));
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$.prototype = $p;
$p.a3J = (function(groupId, attributes) {
  $m_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$();
  return new $c_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup(groupId, $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().a2r(this.aaT, attributes));
});
$p.bm = (function() {
  if ((!this.aFy)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().cw());
    var MacroImplicits_this = $m_Lupickle_default$();
    $m_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$();
    var $x_1 = MacroImplicits_this.cw();
    var reader = new $c_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$$anon$6(MacroImplicits_this, 2, this);
    this.aFx = $x_1.ez(new $c_Lupickle_core_Types$TaggedReader$Leaf(MacroImplicits_this.Iy(), "$type", "org.jpablo.graphexplorer.viewer.models.ViewerGroup", "ViewerGroup", reader), $f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(MacroImplicits_this, new $c_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$$anon$7(MacroImplicits_this, this), "$type", "org.jpablo.graphexplorer.viewer.models.ViewerGroup", "ViewerGroup", new $c_Lupickle_core_Annotator$Checker$Cls($d_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup.l())));
    this.aFy = true;
  }
  return this.aFx;
});
$p.b63 = (function(ReadersVersionSpecific_this$8) {
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.eO();
  }
  return true;
});
$p.b64 = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params, collection) => {
    $m_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$();
    var id = params.a[0];
    var ev$17 = params.a[1];
    return new $c_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup(id, ((ev$17 === null) ? null : ev$17.ce));
  }));
});
var $d_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$, "org.jpablo.graphexplorer.viewer.models.ViewerGroup$", ({
  Du: 1,
  d: 1,
  j: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$;
function $m_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$ = new $c_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$() {
  this.aFz = null;
  this.aFA = null;
  this.aFB = false;
  $n_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$ = this;
  this.aFz = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().Au($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_AttributePair.r().C)([new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributePair$$anon$3(new $c_T2($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Label$(), ""))])));
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$.prototype = $p;
$p.a4f = (function(nodeId, attributes) {
  $m_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$();
  return new $c_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode(nodeId, $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().a2r(this.aFz, attributes), ($m_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$(), $m_s_None$()));
});
$p.bm = (function() {
  if ((!this.aFB)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().cw());
    var MacroImplicits_this = $m_Lupickle_default$();
    $m_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$();
    var $x_1 = MacroImplicits_this.cw();
    var reader = new $c_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$$anon$1(MacroImplicits_this, 3, this);
    this.aFA = $x_1.ez(new $c_Lupickle_core_Types$TaggedReader$Leaf(MacroImplicits_this.Iy(), "$type", "org.jpablo.graphexplorer.viewer.models.ViewerNode", "ViewerNode", reader), $f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(MacroImplicits_this, new $c_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$$anon$2(MacroImplicits_this, this), "$type", "org.jpablo.graphexplorer.viewer.models.ViewerNode", "ViewerNode", new $c_Lupickle_core_Annotator$Checker$Cls($d_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode.l())));
    this.aFB = true;
  }
  return this.aFA;
});
$p.b65 = (function(ReadersVersionSpecific_this$2) {
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.eO();
  }
  return true;
});
$p.b66 = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params, collection) => {
    $m_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$();
    var id = params.a[0];
    var ev$11 = params.a[1];
    return new $c_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode(id, ((ev$11 === null) ? null : ev$11.ce), params.a[2]);
  }));
});
var $d_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$, "org.jpablo.graphexplorer.viewer.models.ViewerNode$", ({
  Dx: 1,
  d: 1,
  j: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$;
function $m_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$ = new $c_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$;
}
function $s_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$__Nodes__Lorg_jpablo_graphexplorer_viewer_selection_ElementKind() {
  $m_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$();
  return $t_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$__Nodes;
}
function $s_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$__Edges__Lorg_jpablo_graphexplorer_viewer_selection_ElementKind() {
  $m_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$();
  return $t_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$__Edges;
}
function $s_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$__Groups__Lorg_jpablo_graphexplorer_viewer_selection_ElementKind() {
  $m_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$();
  return $t_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$__Groups;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$() {
  $n_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$ = this;
  $t_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$__Nodes = new $c_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$$anon$1("Nodes", 0);
  $t_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$__Edges = new $c_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$$anon$1("Edges", 1);
  $t_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$__Groups = new $c_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$$anon$1("Groups", 2);
  $s_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$__Nodes__Lorg_jpablo_graphexplorer_viewer_selection_ElementKind();
  $s_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$__Edges__Lorg_jpablo_graphexplorer_viewer_selection_ElementKind();
  $s_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$__Groups__Lorg_jpablo_graphexplorer_viewer_selection_ElementKind();
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$.prototype = $p;
$p.b1N = (function(id) {
  switch (id) {
    case "nodes": {
      return new $c_s_Some($s_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$__Nodes__Lorg_jpablo_graphexplorer_viewer_selection_ElementKind());
      break;
    }
    case "edges": {
      return new $c_s_Some($s_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$__Edges__Lorg_jpablo_graphexplorer_viewer_selection_ElementKind());
      break;
    }
    case "groups": {
      return new $c_s_Some($s_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$__Groups__Lorg_jpablo_graphexplorer_viewer_selection_ElementKind());
      break;
    }
    default: {
      return $m_s_None$();
    }
  }
});
var $d_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$, "org.jpablo.graphexplorer.viewer.selection.ElementKind$", ({
  DB: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$;
function $m_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$ = new $c_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$;
}
function $s_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$__Loading__Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus() {
  $m_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$();
  return $t_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$__Loading;
}
function $s_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$__Ready__Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus() {
  $m_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$();
  return $t_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$__Ready;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$() {
  $n_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$ = this;
  $t_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$__Loading = new $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$$anon$1("Loading", 0);
  $t_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$__Ready = new $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$$anon$1("Ready", 1);
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$, "org.jpablo.graphexplorer.viewer.state.DiagramLoadStatus$", ({
  DE: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$;
function $m_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$ = new $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_DocumentSessionId$() {
  this.aUO = null;
  this.aUO = "doc-";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_DocumentSessionId$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_DocumentSessionId$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_DocumentSessionId$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_DocumentSessionId$.prototype = $p;
$p.b77 = (function() {
  var this$1 = $m_Lorg_jpablo_graphexplorer_viewer_utils_Utils$();
  var this$2 = $f_Lorg_jpablo_graphexplorer_viewer_utils_UtilsPlatform__randomUUID__T(this$1);
  return new $c_Lorg_jpablo_graphexplorer_viewer_state_DocumentSessionId(("doc-" + this$2.split("-").join("")));
});
$p.mU = (function(text) {
  var trimmed = $f_T__trim__T(text);
  return (((!(!trimmed.startsWith("doc-"))) && (trimmed.length > 4)) ? new $c_s_Some(new $c_Lorg_jpablo_graphexplorer_viewer_state_DocumentSessionId(trimmed)) : $m_s_None$());
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_DocumentSessionId$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_DocumentSessionId$, "org.jpablo.graphexplorer.viewer.state.DocumentSessionId$", ({
  DN: 1,
  d: 1,
  j: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_state_DocumentSessionId$;
function $m_Lorg_jpablo_graphexplorer_viewer_state_DocumentSessionId$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_state_DocumentSessionId$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_state_DocumentSessionId$ = new $c_Lorg_jpablo_graphexplorer_viewer_state_DocumentSessionId$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_state_DocumentSessionId$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$.prototype = $p;
$p.b1E = (function(actual, selected) {
  return new $c_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice($s_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level$__Error__Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level(), (((("This looks like a " + actual.DT()) + " diagram, but ") + selected.DT()) + " is selected."), new $c_s_Some(actual));
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$, "org.jpablo.graphexplorer.viewer.state.EditorNotice$", ({
  DO: 1,
  d: 1,
  j: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$;
function $m_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$ = new $c_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$;
}
function $s_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level$__Info__Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level() {
  $m_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level$();
  return $t_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level$__Info;
}
function $s_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level$__Error__Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level() {
  $m_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level$();
  return $t_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level$__Error;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level$() {
  $n_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level$ = this;
  $t_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level$__Info = new $c_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level$$anon$1("Info", 0);
  $t_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level$__Error = new $c_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level$$anon$1("Error", 1);
  $s_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level$__Info__Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level();
  $s_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level$__Error__Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level();
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level$, "org.jpablo.graphexplorer.viewer.state.EditorNotice$Level$", ({
  DQ: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level$;
function $m_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level$ = new $c_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$NavContext$(outer) {
  this.aFI = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aFI = outer;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$NavContext$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$NavContext$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$NavContext$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$NavContext$.prototype = $p;
$p.aXo = (function(origin, dir) {
  return new $c_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$NavContext(this.aFI, origin, dir);
});
$p.m = (function() {
  return "NavContext";
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$NavContext$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$NavContext$, "org.jpablo.graphexplorer.viewer.state.KeyboardNavOps$NavContext$", ({
  E0: 1,
  d: 1,
  j: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$Cand$(outer) {
  this.aFN = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aFN = outer;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$Cand$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$Cand$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$Cand$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$Cand$.prototype = $p;
$p.aXn = (function(arrow, far, center) {
  return new $c_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$Cand(this.aFN, arrow, far, center);
});
$p.m = (function() {
  return "Cand";
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$Cand$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$Cand$, "org.jpablo.graphexplorer.viewer.state.KeyboardNavOps$keyboardNav$Cand$", ({
  E2: 1,
  d: 1,
  j: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$NavBox$(outer) {
  this.aFO = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aFO = outer;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$NavBox$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$NavBox$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$NavBox$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$NavBox$.prototype = $p;
$p.aXc = (function(l, t, r, b) {
  return new $c_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$NavBox(this.aFO, l, t, r, b);
});
$p.m = (function() {
  return "NavBox";
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$NavBox$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$NavBox$, "org.jpablo.graphexplorer.viewer.state.KeyboardNavOps$keyboardNav$NavBox$", ({
  E3: 1,
  d: 1,
  j: 1
}));
function $s_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent$__CloseWindow__Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent() {
  $m_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent$();
  return $t_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent$__CloseWindow;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent$() {
  $n_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent$ = this;
  $t_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent$__CloseWindow = new $c_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent$$anon$1("CloseWindow", 1);
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent$, "org.jpablo.graphexplorer.viewer.state.LeaveIntent$", ({
  E5: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent$;
function $m_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent$ = new $c_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent$;
}
function $s_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$__NavLeft__Lorg_jpablo_graphexplorer_viewer_state_NavDirection() {
  $m_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$();
  return $t_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$__NavLeft;
}
function $s_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$__NavRight__Lorg_jpablo_graphexplorer_viewer_state_NavDirection() {
  $m_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$();
  return $t_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$__NavRight;
}
function $s_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$__NavUp__Lorg_jpablo_graphexplorer_viewer_state_NavDirection() {
  $m_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$();
  return $t_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$__NavUp;
}
function $s_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$__NavDown__Lorg_jpablo_graphexplorer_viewer_state_NavDirection() {
  $m_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$();
  return $t_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$__NavDown;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$() {
  $n_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$ = this;
  $t_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$__NavLeft = new $c_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$$anon$1();
  $t_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$__NavRight = new $c_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$$anon$2();
  $t_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$__NavUp = new $c_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$$anon$3();
  $t_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$__NavDown = new $c_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$$anon$4();
  $s_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$__NavLeft__Lorg_jpablo_graphexplorer_viewer_state_NavDirection();
  $s_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$__NavRight__Lorg_jpablo_graphexplorer_viewer_state_NavDirection();
  $s_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$__NavUp__Lorg_jpablo_graphexplorer_viewer_state_NavDirection();
  $s_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$__NavDown__Lorg_jpablo_graphexplorer_viewer_state_NavDirection();
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$, "org.jpablo.graphexplorer.viewer.state.NavDirection$", ({
  E8: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$;
function $m_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$ = new $c_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$() {
  this.GZ = null;
  this.GY = null;
  this.a0S = null;
  this.aFS = null;
  this.aFT = false;
  $n_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$ = this;
  this.GZ = "digraph G {\n}";
  this.GY = "Untitled";
  this.a0S = this.Jb($m_s_None$());
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$.prototype = $p;
$p.Jb = (function(source) {
  $m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$();
  return new $c_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState($m_sci_Set$EmptySet$(), $m_sci_Set$EmptySet$(), this.GY, (source.c() ? $m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$().GZ : source.d()), $m_s_None$(), ($m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$(), $m_s_None$()));
});
$p.bm = (function() {
  if ((!this.aFT)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().cw());
    var MacroImplicits_this = $m_Lupickle_default$();
    $m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$();
    this.aFS = MacroImplicits_this.cw().ez(new $c_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$$anon$2(MacroImplicits_this, 6, this), new $c_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$$anon$3(MacroImplicits_this, this));
    this.aFT = true;
  }
  return this.aFS;
});
$p.b68 = (function(ReadersVersionSpecific_this$2) {
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.eO();
  }
  return true;
});
$p.b69 = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params, collection) => {
    $m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$();
    var ev$19 = params.a[0];
    return new $c_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState(((ev$19 === null) ? null : ev$19.aS), params.a[1], params.a[2], params.a[3], params.a[4], params.a[5]);
  }));
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$, "org.jpablo.graphexplorer.viewer.state.PersistedDiagramState$", ({
  Ed: 1,
  d: 1,
  j: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$;
function $m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$ = new $c_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_ProjectId$() {
  this.aFU = null;
  this.aFV = false;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_ProjectId$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_ProjectId$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_ProjectId$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_ProjectId$.prototype = $p;
$p.bm = (function() {
  if ((!this.aFV)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().cw());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.aFU = MacroImplicits_this.cw().ez(new $c_Lorg_jpablo_graphexplorer_viewer_state_ProjectId$$anon$1(MacroImplicits_this, 1, this), new $c_Lorg_jpablo_graphexplorer_viewer_state_ProjectId$$anon$2(MacroImplicits_this, this));
    this.aFV = true;
  }
  return this.aFU;
});
$p.b6a = (function(ReadersVersionSpecific_this$2) {
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.eO();
  }
  return true;
});
$p.b6b = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params, collection) => new $c_Lorg_jpablo_graphexplorer_viewer_state_ProjectId(params.a[0])));
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_ProjectId$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_ProjectId$, "org.jpablo.graphexplorer.viewer.state.ProjectId$", ({
  Eh: 1,
  d: 1,
  j: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_state_ProjectId$;
function $m_Lorg_jpablo_graphexplorer_viewer_state_ProjectId$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_state_ProjectId$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_state_ProjectId$ = new $c_Lorg_jpablo_graphexplorer_viewer_state_ProjectId$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_state_ProjectId$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$CellKind$(outer) {
  this.xo = null;
  this.qr = null;
  this.aFY = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aFY = outer;
  this.xo = new $c_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$$anon$1("Record", 0, this);
  this.qr = new $c_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$$anon$1("Html", 1, this);
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$CellKind$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$CellKind$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$CellKind$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$CellKind$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$CellKind$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$CellKind$, "org.jpablo.graphexplorer.viewer.state.RecordCellOps$recordCells$CellKind$", ({
  Eq: 1,
  d: 1,
  u: 1
}));
function $s_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$__none__Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection() {
  $m_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$();
  return $t_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$__none;
}
function $s_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$__diagramAttributes__Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection() {
  $m_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$();
  return $t_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$__diagramAttributes;
}
function $s_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$__elements__Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection() {
  $m_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$();
  return $t_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$__elements;
}
function $s_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$__sources__Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection() {
  $m_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$();
  return $t_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$__sources;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$() {
  this.aFZ = null;
  $n_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$ = this;
  $t_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$__none = new $c_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$$anon$1("none", 0);
  $t_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$__diagramAttributes = new $c_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$$anon$1("diagramAttributes", 1);
  $t_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$__elements = new $c_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$$anon$1("elements", 2);
  $t_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$__sources = new $c_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$$anon$1("sources", 3);
  this.aFZ = new ($d_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection.r().C)([$s_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$__none__Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection(), $s_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$__diagramAttributes__Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection(), $s_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$__elements__Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection(), $s_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$__sources__Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection()]);
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$.prototype = $p;
$p.b1Q = (function(ordinal) {
  try {
    return this.aFZ.a[ordinal];
  } catch (e) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), (("enum org.jpablo.graphexplorer.viewer.state.RightPanelSection has no case with ordinal: " + "") + ordinal));
  }
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$, "org.jpablo.graphexplorer.viewer.state.RightPanelSection$", ({
  Er: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$;
function $m_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$ = new $c_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$;
}
function $s_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$__Saved__Lorg_jpablo_graphexplorer_viewer_state_SaveResult() {
  $m_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$();
  return $t_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$__Saved;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$() {
  $n_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$ = this;
  $t_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$__Saved = new $c_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$$anon$1("Saved", 0);
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$, "org.jpablo.graphexplorer.viewer.state.SaveResult$", ({
  Et: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$;
function $m_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$ = new $c_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$.prototype = $p;
$p.b44 = (function(id) {
  return new $c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$LibraryDiagram(new $c_Lorg_jpablo_graphexplorer_viewer_state_ProjectId(id));
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$, "org.jpablo.graphexplorer.viewer.state.ViewTarget$", ({
  ED: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$;
function $m_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$ = new $c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$() {
  this.H2 = 0;
  this.a0X = 0;
  this.abe = 0;
  this.aG4 = 0.0;
  this.a0Y = null;
  this.aG2 = null;
  this.aG3 = false;
  $n_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$ = this;
  this.H2 = 2;
  this.a0X = 320;
  this.abe = 240;
  this.aG4 = 0.6;
  this.a0Y = ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), new $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings(($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), true), ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), 0), ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), $m_s_None$()), ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), true), ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), $m_s_None$()), ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), false), ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), false), ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), false), ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), false), ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), $m_s_None$()), ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), true), ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), false), ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), false), ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), $m_s_None$()), ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), $m_s_None$()), ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), $m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$().H2)));
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$.prototype = $p;
$p.aMH = (function(px, viewportWidth) {
  if ((viewportWidth > 0.0)) {
    var x = this.abe;
    var y = (viewportWidth * this.aG4);
    var upper = (+Math.max(x, y));
  } else {
    var upper = 1.7976931348623157E308;
  }
  var y$1 = this.abe;
  var x$1 = (+Math.max(px, y$1));
  var x$2 = (+Math.min(x$1, upper));
  var $x_1 = $m_RTLong$().d1((+Math.round(x$2)));
  return $s_RTLong__toInt__I__I__I($x_1.l, $x_1.h);
});
$p.bm = (function() {
  if ((!this.aG3)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().cw());
    var MacroImplicits_this = $m_Lupickle_default$();
    $m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$();
    this.aG2 = MacroImplicits_this.cw().ez(new $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$$anon$4(MacroImplicits_this, 16, this), new $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$$anon$5(MacroImplicits_this, this));
    this.aG3 = true;
  }
  return this.aG2;
});
$p.b6d = (function(ReadersVersionSpecific_this$5) {
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.eO();
  }
  return true;
});
$p.b6e = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params, collection) => {
    $m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$();
    return new $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings((!(!params.a[0])), (params.a[1] | 0), params.a[2], (!(!params.a[3])), params.a[4], (!(!params.a[5])), (!(!params.a[6])), (!(!params.a[7])), (!(!params.a[8])), params.a[9], (!(!params.a[10])), (!(!params.a[11])), (!(!params.a[12])), params.a[13], params.a[14], (params.a[15] | 0));
  }));
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$, "org.jpablo.graphexplorer.viewer.state.ViewerSettings$", ({
  EE: 1,
  d: 1,
  j: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$;
function $m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$ = new $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerState$PendingNewGroup$(outer) {
  this.aGX = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aGX = outer;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerState$PendingNewGroup$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerState$PendingNewGroup$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_ViewerState$PendingNewGroup$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_ViewerState$PendingNewGroup$.prototype = $p;
$p.aXv = (function(elementIds) {
  return new $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerState$PendingNewGroup(this.aGX, elementIds);
});
$p.m = (function() {
  return "PendingNewGroup";
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_ViewerState$PendingNewGroup$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_ViewerState$PendingNewGroup$, "org.jpablo.graphexplorer.viewer.state.ViewerState$PendingNewGroup$", ({
  EH: 1,
  d: 1,
  j: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerState$PendingNewNode$(outer) {
  this.aGY = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aGY = outer;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerState$PendingNewNode$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerState$PendingNewNode$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_ViewerState$PendingNewNode$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_ViewerState$PendingNewNode$.prototype = $p;
$p.aXr = (function(attributes, direction) {
  return new $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerState$PendingNewNode(this.aGY, attributes, direction);
});
$p.m = (function() {
  return "PendingNewNode";
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_ViewerState$PendingNewNode$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_ViewerState$PendingNewNode$, "org.jpablo.graphexplorer.viewer.state.ViewerState$PendingNewNode$", ({
  EI: 1,
  d: 1,
  j: 1
}));
function $s_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint$__source__Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint() {
  $m_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint$();
  return $t_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint$__source;
}
function $s_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint$__target__Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint() {
  $m_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint$();
  return $t_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint$__target;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint$() {
  this.aH1 = null;
  $n_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint$ = this;
  $t_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint$__source = new $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint$$anon$1("source", 0);
  $t_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint$__target = new $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint$$anon$1("target", 1);
  this.aH1 = new ($d_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint.r().C)([$s_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint$__source__Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint(), $s_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint$__target__Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint()]);
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint$.prototype = $p;
$p.bbk = (function() {
  return this.aH1.ae();
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint$, "org.jpablo.graphexplorer.viewer.state.mouseActions.ArrowEndpoint$", ({
  EN: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint$;
function $m_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint$ = new $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint$;
}
function $s_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$__Inactive__Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction() {
  $m_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$();
  return $t_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$__Inactive;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$() {
  $n_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$ = this;
  $t_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$__Inactive = new $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$$anon$2("Inactive", 0);
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$, "org.jpablo.graphexplorer.viewer.state.mouseActions.MouseAction$", ({
  EQ: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$;
function $m_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$ = new $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$;
}
function $s_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin$__CodeMirror__Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin() {
  $m_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin$();
  return $t_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin$__CodeMirror;
}
function $s_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin$__Graph__Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin() {
  $m_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin$();
  return $t_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin$__Graph;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin$() {
  $n_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin$ = this;
  $t_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin$__CodeMirror = new $c_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin$$anon$1("CodeMirror", 0);
  $t_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin$__Graph = new $c_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin$$anon$1("Graph", 1);
  $s_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin$__CodeMirror__Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin();
  $s_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin$__Graph__Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin();
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin$, "org.jpablo.graphexplorer.viewer.utils.ChangeOrigin$", ({
  EX: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin$;
function $m_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin$ = new $c_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint$() {
  this.Hd = null;
  $n_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint$ = this;
  this.Hd = ($m_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint$(), new $c_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint(0.0, 0.0));
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint$.prototype = $p;
$p.aLj = (function(a, b) {
  $m_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint$();
  return new $c_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint((a.gI - b.gI), (a.gJ - b.gJ));
});
var $d_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint$, "org.jpablo.graphexplorer.viewer.utils.SvgPoint$", ({
  F0: 1,
  d: 1,
  j: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint$;
function $m_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint$ = new $c_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_utils_Utils$() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_utils_Utils$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_utils_Utils$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_utils_Utils$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_utils_Utils$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_viewer_utils_Utils$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_utils_Utils$, "org.jpablo.graphexplorer.viewer.utils.Utils$", ({
  F2: 1,
  F1: 1,
  F4: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_utils_Utils$;
function $m_Lorg_jpablo_graphexplorer_viewer_utils_Utils$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_utils_Utils$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_utils_Utils$ = new $c_Lorg_jpablo_graphexplorer_viewer_utils_Utils$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_utils_Utils$;
}
function $s_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$__Success__Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone() {
  $m_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$();
  return $t_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$__Success;
}
function $s_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$__Error__Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone() {
  $m_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$();
  return $t_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$__Error;
}
function $s_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$__Info__Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone() {
  $m_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$();
  return $t_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$__Info;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$() {
  $n_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$ = this;
  $t_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$__Success = new $c_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$$anon$1();
  $t_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$__Error = new $c_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$$anon$2();
  $t_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$__Info = new $c_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$$anon$3();
  $s_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$__Success__Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone();
  $s_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$__Error__Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone();
  $s_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$__Info__Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone();
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$, "org.jpablo.graphexplorer.viewer.widgets.AlertTone$", ({
  F7: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$;
function $m_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$ = new $c_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$;
}
function $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__select__Lorg_jpablo_graphexplorer_viewer_widgets_InputType() {
  $m_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$();
  return $t_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__select;
}
function $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__dropdown__Lorg_jpablo_graphexplorer_viewer_widgets_InputType() {
  $m_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$();
  return $t_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__dropdown;
}
function $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__text__Lorg_jpablo_graphexplorer_viewer_widgets_InputType() {
  $m_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$();
  return $t_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__text;
}
function $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__color__Lorg_jpablo_graphexplorer_viewer_widgets_InputType() {
  $m_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$();
  return $t_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__color;
}
function $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__checkbox__Lorg_jpablo_graphexplorer_viewer_widgets_InputType() {
  $m_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$();
  return $t_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__checkbox;
}
function $s_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__search__Lorg_jpablo_graphexplorer_viewer_widgets_InputType() {
  $m_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$();
  return $t_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__search;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$() {
  $n_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$ = this;
  $t_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__select = new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$$anon$2("select", 0);
  $t_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__dropdown = new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$$anon$2("dropdown", 1);
  $t_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__text = new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$$anon$2("text", 2);
  $t_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__color = new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$$anon$2("color", 3);
  $t_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__checkbox = new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$$anon$2("checkbox", 4);
  $t_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__search = new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$$anon$2("search", 21);
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$, "org.jpablo.graphexplorer.viewer.widgets.InputType$", ({
  Fg: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$;
function $m_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$ = new $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$;
}
function $s_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$__start__Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection() {
  $m_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$();
  return $t_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$__start;
}
function $s_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$__end__Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection() {
  $m_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$();
  return $t_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$__end;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$() {
  $n_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$ = this;
  $t_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$__start = new $c_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$$anon$1("start", 0);
  $t_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$__end = new $c_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$$anon$1("end", 1);
  $s_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$__start__Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection();
  $s_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$__end__Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection();
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$, "org.jpablo.graphexplorer.viewer.widgets.MenuDirection$", ({
  Fl: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$;
function $m_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$ = new $c_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$;
}
function $s_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$__Sep__Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry() {
  $m_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$();
  return $t_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$__Sep;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$() {
  $n_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$ = this;
  $t_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$__Sep = new $c_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$$anon$1();
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$.prototype = $p;
var $d_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$, "org.jpablo.graphexplorer.viewer.widgets.MenuEntry$", ({
  Fn: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$;
function $m_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$ = new $c_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$;
}
/** @constructor */
function $c_s_$less$colon$less() {
}
$p = $c_s_$less$colon$less.prototype = new $h_O();
$p.constructor = $c_s_$less$colon$less;
/** @constructor */
function $h_s_$less$colon$less() {
}
$h_s_$less$colon$less.prototype = $p;
$p.iU = (function(v1) {
});
/** @constructor */
function $c_s_Predef$() {
  this.aV2 = null;
  this.aV3 = null;
  $n_s_Predef$ = this;
  this.aV2 = $m_sci_Map$();
  this.aV3 = $m_sci_Set$();
}
$p = $c_s_Predef$.prototype = new $h_s_LowPriorityImplicits();
$p.constructor = $c_s_Predef$;
/** @constructor */
function $h_s_Predef$() {
}
$h_s_Predef$.prototype = $p;
$p.PQ = (function(requirement) {
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed");
  }
});
var $d_s_Predef$ = new $TypeData().i($c_s_Predef$, "scala.Predef$", ({
  Gj: 1,
  G9: 1,
  Ga: 1
}));
var $n_s_Predef$;
function $m_s_Predef$() {
  if ((!$n_s_Predef$)) {
    $n_s_Predef$ = new $c_s_Predef$();
  }
  return $n_s_Predef$;
}
function $f_s_Product10__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.Ne;
      break;
    }
    case 1: {
      return $thiz.Ng;
      break;
    }
    case 2: {
      return $thiz.Nh;
      break;
    }
    case 3: {
      return $thiz.Ni;
      break;
    }
    case 4: {
      return $thiz.Nj;
      break;
    }
    case 5: {
      return $thiz.Nk;
      break;
    }
    case 6: {
      return $thiz.Nl;
      break;
    }
    case 7: {
      return $thiz.Nm;
      break;
    }
    case 8: {
      return $thiz.Nn;
      break;
    }
    case 9: {
      return $thiz.Nf;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 9)"));
    }
  }
}
function $f_s_Product2__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.g();
      break;
    }
    case 1: {
      return $thiz.h();
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 1)"));
    }
  }
}
function $f_s_Product3__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.bH;
      break;
    }
    case 1: {
      return $thiz.bU;
      break;
    }
    case 2: {
      return $thiz.c3;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 2)"));
    }
  }
}
function $f_s_Product4__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.bO;
      break;
    }
    case 1: {
      return $thiz.bs;
      break;
    }
    case 2: {
      return $thiz.ch;
      break;
    }
    case 3: {
      return $thiz.ca;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 3)"));
    }
  }
}
function $f_s_Product5__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.No;
      break;
    }
    case 1: {
      return $thiz.Np;
      break;
    }
    case 2: {
      return $thiz.Nq;
      break;
    }
    case 3: {
      return $thiz.Nr;
      break;
    }
    case 4: {
      return $thiz.Ns;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 4)"));
    }
  }
}
function $f_s_Product6__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.Nt;
      break;
    }
    case 1: {
      return $thiz.Nu;
      break;
    }
    case 2: {
      return $thiz.Nv;
      break;
    }
    case 3: {
      return $thiz.Nw;
      break;
    }
    case 4: {
      return $thiz.Nx;
      break;
    }
    case 5: {
      return $thiz.Ny;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 5)"));
    }
  }
}
function $f_s_Product9__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.Nz;
      break;
    }
    case 1: {
      return $thiz.NA;
      break;
    }
    case 2: {
      return $thiz.NB;
      break;
    }
    case 3: {
      return $thiz.NC;
      break;
    }
    case 4: {
      return $thiz.ND;
      break;
    }
    case 5: {
      return $thiz.NE;
      break;
    }
    case 6: {
      return $thiz.NF;
      break;
    }
    case 7: {
      return $thiz.NG;
      break;
    }
    case 8: {
      return $thiz.NH;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 8)"));
    }
  }
}
/** @constructor */
function $c_s_Symbol$() {
  this.abN = null;
  $ct_s_JSUniquenessCache__(this);
}
$p = $c_s_Symbol$.prototype = new $h_s_JSUniquenessCache();
$p.constructor = $c_s_Symbol$;
/** @constructor */
function $h_s_Symbol$() {
}
$h_s_Symbol$.prototype = $p;
var $d_s_Symbol$ = new $TypeData().i($c_s_Symbol$, "scala.Symbol$", ({
  Gt: 1,
  G8: 1,
  a: 1
}));
var $n_s_Symbol$;
function $m_s_Symbol$() {
  if ((!$n_s_Symbol$)) {
    $n_s_Symbol$ = new $c_s_Symbol$();
  }
  return $n_s_Symbol$;
}
/** @constructor */
function $c_sc_BuildFrom$() {
}
$p = $c_sc_BuildFrom$.prototype = new $h_O();
$p.constructor = $c_sc_BuildFrom$;
/** @constructor */
function $h_sc_BuildFrom$() {
}
$h_sc_BuildFrom$.prototype = $p;
var $d_sc_BuildFrom$ = new $TypeData().i($c_sc_BuildFrom$, "scala.collection.BuildFrom$", ({
  GF: 1,
  GG: 1,
  GH: 1
}));
var $n_sc_BuildFrom$;
function $m_sc_BuildFrom$() {
  if ((!$n_sc_BuildFrom$)) {
    $n_sc_BuildFrom$ = new $c_sc_BuildFrom$();
  }
  return $n_sc_BuildFrom$;
}
function $ct_sc_ClassTagIterableFactory$AnyIterableDelegate__sc_ClassTagIterableFactory__($thiz, delegate) {
  $thiz.NI = delegate;
  return $thiz;
}
/** @constructor */
function $c_sc_ClassTagIterableFactory$AnyIterableDelegate() {
  this.NI = null;
}
$p = $c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype = new $h_O();
$p.constructor = $c_sc_ClassTagIterableFactory$AnyIterableDelegate;
/** @constructor */
function $h_sc_ClassTagIterableFactory$AnyIterableDelegate() {
}
$h_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype = $p;
$p.aO = (function() {
  return this.NI.aNG($m_s_reflect_ManifestFactory$AnyManifest$());
});
$p.cc = (function(it) {
  return this.NI.ag0(it, $m_s_reflect_ManifestFactory$AnyManifest$());
});
$p.b5 = (function() {
  return this.NI.a4e($m_s_reflect_ManifestFactory$AnyManifest$());
});
$p.dr = (function(elems) {
  return this.NI.ag0(elems, $m_s_reflect_ManifestFactory$AnyManifest$());
});
/** @constructor */
function $c_sc_Factory$ArrayFactory(evidence$2) {
  this.aHv = null;
  this.aHv = evidence$2;
}
$p = $c_sc_Factory$ArrayFactory.prototype = new $h_O();
$p.constructor = $c_sc_Factory$ArrayFactory;
/** @constructor */
function $h_sc_Factory$ArrayFactory() {
}
$h_sc_Factory$ArrayFactory.prototype = $p;
$p.b5 = (function() {
  return new $c_scm_ArrayBuilder$generic(this.aHv.h8());
});
var $d_sc_Factory$ArrayFactory = new $TypeData().i($c_sc_Factory$ArrayFactory, "scala.collection.Factory$ArrayFactory", ({
  GL: 1,
  bX: 1,
  a: 1
}));
function $ct_sc_IterableFactory$Delegate__sc_IterableFactory__($thiz, delegate) {
  $thiz.xv = delegate;
  return $thiz;
}
/** @constructor */
function $c_sc_IterableFactory$Delegate() {
  this.xv = null;
}
$p = $c_sc_IterableFactory$Delegate.prototype = new $h_O();
$p.constructor = $c_sc_IterableFactory$Delegate;
/** @constructor */
function $h_sc_IterableFactory$Delegate() {
}
$h_sc_IterableFactory$Delegate.prototype = $p;
$p.dr = (function(elems) {
  return this.xv.dr(elems);
});
$p.aO = (function() {
  return this.xv.aO();
});
$p.cc = (function(it) {
  return this.xv.cc(it);
});
$p.b5 = (function() {
  return this.xv.b5();
});
/** @constructor */
function $c_sc_IterableFactory$ToFactory(factory) {
  this.ac4 = null;
  this.ac4 = factory;
}
$p = $c_sc_IterableFactory$ToFactory.prototype = new $h_O();
$p.constructor = $c_sc_IterableFactory$ToFactory;
/** @constructor */
function $h_sc_IterableFactory$ToFactory() {
}
$h_sc_IterableFactory$ToFactory.prototype = $p;
$p.fP = (function(it) {
  return this.ac4.cc(it);
});
$p.b5 = (function() {
  return this.ac4.b5();
});
var $d_sc_IterableFactory$ToFactory = new $TypeData().i($c_sc_IterableFactory$ToFactory, "scala.collection.IterableFactory$ToFactory", ({
  GU: 1,
  bX: 1,
  a: 1
}));
/** @constructor */
function $c_sc_IterableOnceOps$$anon$1(outer) {
}
$p = $c_sc_IterableOnceOps$$anon$1.prototype = new $h_sr_AbstractFunction1();
$p.constructor = $c_sc_IterableOnceOps$$anon$1;
/** @constructor */
function $h_sc_IterableOnceOps$$anon$1() {
}
$h_sc_IterableOnceOps$$anon$1.prototype = $p;
$p.i = (function(v1) {
  return this;
});
var $d_sc_IterableOnceOps$$anon$1 = new $TypeData().i($c_sc_IterableOnceOps$$anon$1, "scala.collection.IterableOnceOps$$anon$1", ({
  GV: 1,
  c8: 1,
  h: 1
}));
/** @constructor */
function $c_sc_IterableOnceOps$Maximized(outer, descriptor, f, cmp) {
  this.aHC = null;
  this.ac5 = null;
  this.aHB = null;
  this.UF = null;
  this.a1h = null;
  this.UG = false;
  this.aHC = descriptor;
  this.ac5 = f;
  this.aHB = cmp;
  this.UF = null;
  this.a1h = null;
  this.UG = false;
}
$p = $c_sc_IterableOnceOps$Maximized.prototype = new $h_sr_AbstractFunction2();
$p.constructor = $c_sc_IterableOnceOps$Maximized;
/** @constructor */
function $h_sc_IterableOnceOps$Maximized() {
}
$h_sc_IterableOnceOps$Maximized.prototype = $p;
$p.rg = (function() {
  return (this.UG ? new $c_s_Some(this.UF) : $m_s_None$());
});
$p.aR = (function() {
  if (this.UG) {
    return this.UF;
  } else {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), ("empty." + this.aHC));
  }
});
$p.a2L = (function(m, a) {
  if (m.UG) {
    var fa = this.ac5.i(a);
    if ((!(!this.aHB.R(fa, this.a1h)))) {
      this.a1h = fa;
      this.UF = a;
    }
    return m;
  } else {
    m.UG = true;
    m.UF = a;
    m.a1h = this.ac5.i(a);
    return m;
  }
});
$p.R = (function(v1, v2) {
  return this.a2L(v1, v2);
});
var $d_sc_IterableOnceOps$Maximized = new $TypeData().i($c_sc_IterableOnceOps$Maximized, "scala.collection.IterableOnceOps$Maximized", ({
  GW: 1,
  c9: 1,
  bE: 1
}));
function $f_sc_IterableOps__headOption__s_Option($thiz) {
  var it = $thiz.o();
  return (it.p() ? new $c_s_Some(it.q()) : $m_s_None$());
}
function $f_sc_IterableOps__last__O($thiz) {
  var it = $thiz.o();
  var lst = it.q();
  while (it.p()) {
    lst = it.q();
  }
  return lst;
}
function $f_sc_IterableOps__lastOption__s_Option($thiz) {
  return ($thiz.c() ? $m_s_None$() : new $c_s_Some($thiz.bJ()));
}
function $f_sc_IterableOps__sizeCompare__I__I($thiz, otherSize) {
  if ((otherSize < 0)) {
    return 1;
  } else {
    var known = $thiz.V();
    if ((known >= 0)) {
      return ((known === otherSize) ? 0 : ((known < otherSize) ? (-1) : 1));
    } else {
      var i = 0;
      var it = $thiz.o();
      while (it.p()) {
        if ((i === otherSize)) {
          return 1;
        }
        it.q();
        i = ((1 + i) | 0);
      }
      return ((i - otherSize) | 0);
    }
  }
}
function $f_sc_IterableOps__filter__F1__O($thiz, pred) {
  return $thiz.fP(new $c_sc_View$Filter($thiz, pred, false));
}
function $f_sc_IterableOps__filterNot__F1__O($thiz, pred) {
  return $thiz.fP(new $c_sc_View$Filter($thiz, pred, true));
}
function $f_sc_IterableOps__partition__F1__T2($thiz, p) {
  var first = new $c_sc_View$Filter($thiz, p, false);
  var second = new $c_sc_View$Filter($thiz, p, true);
  return new $c_T2($thiz.fP(first), $thiz.fP(second));
}
function $f_sc_IterableOps__takeWhile__F1__O($thiz, p) {
  return $thiz.fP(new $c_sc_View$TakeWhile($thiz, p));
}
function $f_sc_IterableOps__span__F1__T2($thiz, p) {
  return new $c_T2($thiz.uj(p), $thiz.tW(p));
}
function $f_sc_IterableOps__drop__I__O($thiz, n) {
  return $thiz.fP($ct_sc_View$Drop__sc_IterableOps__I__(new $c_sc_View$Drop(), $thiz, n));
}
function $f_sc_IterableOps__dropRight__I__O($thiz, n) {
  return $thiz.fP($ct_sc_View$DropRight__sc_IterableOps__I__(new $c_sc_View$DropRight(), $thiz, n));
}
function $f_sc_IterableOps__dropWhile__F1__O($thiz, p) {
  return $thiz.fP(new $c_sc_View$DropWhile($thiz, p));
}
function $f_sc_IterableOps__tail__O($thiz) {
  if ($thiz.c()) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  }
  return $thiz.ds(1);
}
function $f_sc_IterableOps__init__O($thiz) {
  if ($thiz.c()) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  }
  return $thiz.cn(1);
}
function $f_sc_IterableOps__groupBy__F1__sci_Map($thiz, f) {
  var m = $m_scm_Map$().aO();
  var it = $thiz.o();
  while (it.p()) {
    var elem = it.q();
    var key = f.i(elem);
    m.ec(key, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $thiz.fS()))).Y(elem);
  }
  var result = $m_sci_HashMap$().fk;
  var mapIt = m.o();
  while (mapIt.p()) {
    var x1 = mapIt.q();
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1);
    }
    var k = x1.g();
    var v = x1.h();
    result = result.hq(k, v.aR());
  }
  return result;
}
function $f_sc_IterableOps__groupMap__F1__F1__sci_Map($thiz, key, f) {
  var m = $m_scm_Map$().aO();
  $thiz.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((elem$2$2) => {
    var k = key.i(elem$2$2);
    return m.ec(k, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $thiz.cd().b5()))).Y(f.i(elem$2$2));
  })));
  var result = new $c_sc_IterableOps$Result$1($thiz);
  m.F(result);
  return result.zS;
}
function $f_sc_IterableOps__groupMapReduce__F1__F1__F2__sci_Map($thiz, key, f, reduce) {
  var m = $m_scm_Map$().aO();
  $thiz.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((elem$2$2) => {
    var k = key.i(elem$2$2);
    var x1 = m.r(k);
    if ((x1 instanceof $c_s_Some)) {
      var b = x1.J;
      var v = reduce.R(b, f.i(elem$2$2));
    } else {
      if ((!($m_s_None$() === x1))) {
        throw new $c_s_MatchError(x1);
      }
      var v = f.i(elem$2$2);
    }
    return m.ue(k, v);
  })));
  return new $c_sc_MapFactory$ToFactory($m_sci_Map$()).fP(m);
}
function $f_sc_IterableOps__map__F1__O($thiz, f) {
  return $thiz.cd().cc($ct_sc_View$Map__sc_IterableOps__F1__(new $c_sc_View$Map(), $thiz, f));
}
function $f_sc_IterableOps__flatMap__F1__O($thiz, f) {
  return $thiz.cd().cc(new $c_sc_View$FlatMap($thiz, f));
}
function $f_sc_IterableOps__collect__s_PartialFunction__O($thiz, pf) {
  return $thiz.cd().cc(new $c_sc_View$Collect($thiz, pf));
}
function $f_sc_IterableOps__partitionMap__F1__T2($thiz, f) {
  var left = new $c_sc_View$LeftPartitionMapped($thiz, f);
  var right = new $c_sc_View$RightPartitionMapped($thiz, f);
  return new $c_T2($thiz.cd().cc(left), $thiz.cd().cc(right));
}
function $f_sc_IterableOps__concat__sc_IterableOnce__O($thiz, suffix) {
  return $thiz.cd().cc(($is_sc_Iterable(suffix) ? new $c_sc_View$Concat($thiz, suffix) : $thiz.o().lS(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => suffix.o())))));
}
function $f_sc_IterableOps__zipWithIndex__O($thiz) {
  return $thiz.cd().cc(new $c_sc_View$ZipWithIndex($thiz));
}
function $f_sc_IterableOps__unzip__F1__T2($thiz, asPair) {
  var first = $ct_sc_View$Map__sc_IterableOps__F1__(new $c_sc_View$Map(), $thiz, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$3$2$2) => asPair.i(x$3$2$2).g())));
  var second = $ct_sc_View$Map__sc_IterableOps__F1__(new $c_sc_View$Map(), $thiz, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$4$2$2) => asPair.i(x$4$2$2).h())));
  return new $c_T2($thiz.cd().cc(first), $thiz.cd().cc(second));
}
/** @constructor */
function $c_sc_IterableOps$Result$1(outer) {
  this.zS = null;
  this.zS = $m_sci_Map$EmptyMap$();
}
$p = $c_sc_IterableOps$Result$1.prototype = new $h_sr_AbstractFunction1();
$p.constructor = $c_sc_IterableOps$Result$1;
/** @constructor */
function $h_sc_IterableOps$Result$1() {
}
$h_sc_IterableOps$Result$1.prototype = $p;
$p.aXp = (function(kv) {
  this.zS = this.zS.bN(kv.g(), kv.h().aR());
});
$p.i = (function(v1) {
  this.aXp(v1);
});
var $d_sc_IterableOps$Result$1 = new $TypeData().i($c_sc_IterableOps$Result$1, "scala.collection.IterableOps$Result$1", ({
  GX: 1,
  c8: 1,
  h: 1
}));
function $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__($thiz, self, p) {
  $thiz.UH = self;
  $thiz.ac6 = p;
  return $thiz;
}
/** @constructor */
function $c_sc_IterableOps$WithFilter() {
  this.UH = null;
  this.ac6 = null;
}
$p = $c_sc_IterableOps$WithFilter.prototype = new $h_sc_WithFilter();
$p.constructor = $c_sc_IterableOps$WithFilter;
/** @constructor */
function $h_sc_IterableOps$WithFilter() {
}
$h_sc_IterableOps$WithFilter.prototype = $p;
$p.qY = (function() {
  return new $c_sc_View$Filter(this.UH, this.ac6, false);
});
$p.L = (function(f) {
  return this.UH.cd().cc($ct_sc_View$Map__sc_IterableOps__F1__(new $c_sc_View$Map(), this.qY(), f));
});
$p.c5 = (function(f) {
  return this.UH.cd().cc(new $c_sc_View$FlatMap(this.qY(), f));
});
$p.F = (function(f) {
  this.qY().F(f);
});
var $d_sc_IterableOps$WithFilter = new $TypeData().i($c_sc_IterableOps$WithFilter, "scala.collection.IterableOps$WithFilter", ({
  kN: 1,
  dF: 1,
  a: 1
}));
function $f_sc_Iterator__nextOption__s_Option($thiz) {
  return ($thiz.p() ? new $c_s_Some($thiz.q()) : $m_s_None$());
}
function $f_sc_Iterator__contains__O__Z($thiz, elem) {
  var res = false;
  while (((!res) && $thiz.p())) {
    res = $m_sr_BoxesRunTime$().Q($thiz.q(), elem);
  }
  return res;
}
function $f_sc_Iterator__indexWhere__F1__I__I($thiz, p, from) {
  var i = ((from > 0) ? from : 0);
  var dropped = $thiz.iV(from);
  while (dropped.p()) {
    if ((!(!p.i(dropped.q())))) {
      return i;
    }
    i = ((1 + i) | 0);
  }
  return (-1);
}
function $f_sc_Iterator__distinct__sc_Iterator($thiz) {
  return new $c_sc_Iterator$$anon$8($thiz, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2$2) => x$2$2)));
}
function $f_sc_Iterator__concat__F0__sc_Iterator($thiz, xs) {
  return new $c_sc_Iterator$ConcatIterator($thiz).lS(xs);
}
function $f_sc_Iterator__take__I__sc_Iterator($thiz, n) {
  return $thiz.ui(0, ((n > 0) ? n : 0));
}
function $f_sc_Iterator__sliceIterator__I__I__sc_Iterator($thiz, from, until) {
  var lo = ((from > 0) ? from : 0);
  var rest = ((until < 0) ? (-1) : ((until <= lo) ? 0 : ((until - lo) | 0)));
  return ((rest === 0) ? $m_sc_Iterator$().b8 : new $c_sc_Iterator$SliceIterator($thiz, lo, rest));
}
function $f_sc_Iterator__sameElements__sc_IterableOnce__Z($thiz, that) {
  var those = that.o();
  while ($thiz.p()) {
    if ((!those.p())) {
      return false;
    }
    if ((!$m_sr_BoxesRunTime$().Q($thiz.q(), those.q()))) {
      return false;
    }
  }
  return (!those.p());
}
function $is_sc_Iterator(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.p)));
}
function $isArrayOf_sc_Iterator(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.p)));
}
/** @constructor */
function $c_sc_Iterator$() {
  this.b8 = null;
  $n_sc_Iterator$ = this;
  this.b8 = new $c_sc_Iterator$$anon$19();
}
$p = $c_sc_Iterator$.prototype = new $h_O();
$p.constructor = $c_sc_Iterator$;
/** @constructor */
function $h_sc_Iterator$() {
}
$h_sc_Iterator$.prototype = $p;
$p.b5 = (function() {
  return new $c_sc_Iterator$$anon$21();
});
$p.dr = (function(elems) {
  return elems.o();
});
$p.aO = (function() {
  return this.b8;
});
$p.cc = (function(source) {
  return source.o();
});
var $d_sc_Iterator$ = new $TypeData().i($c_sc_Iterator$, "scala.collection.Iterator$", ({
  GY: 1,
  a0: 1,
  a: 1
}));
var $n_sc_Iterator$;
function $m_sc_Iterator$() {
  if ((!$n_sc_Iterator$)) {
    $n_sc_Iterator$ = new $c_sc_Iterator$();
  }
  return $n_sc_Iterator$;
}
function $ct_sc_MapFactory$Delegate__sc_MapFactory__($thiz, delegate) {
  $thiz.Hq = delegate;
  return $thiz;
}
/** @constructor */
function $c_sc_MapFactory$Delegate() {
  this.Hq = null;
}
$p = $c_sc_MapFactory$Delegate.prototype = new $h_O();
$p.constructor = $c_sc_MapFactory$Delegate;
/** @constructor */
function $h_sc_MapFactory$Delegate() {
}
$h_sc_MapFactory$Delegate.prototype = $p;
$p.dr = (function(elems) {
  return this.Hq.dr(elems);
});
$p.cc = (function(it) {
  return this.Hq.cc(it);
});
$p.aO = (function() {
  return this.Hq.aO();
});
$p.b5 = (function() {
  return this.Hq.b5();
});
/** @constructor */
function $c_sc_MapFactory$ToFactory(factory) {
  this.acc = null;
  this.acc = factory;
}
$p = $c_sc_MapFactory$ToFactory.prototype = new $h_O();
$p.constructor = $c_sc_MapFactory$ToFactory;
/** @constructor */
function $h_sc_MapFactory$ToFactory() {
}
$h_sc_MapFactory$ToFactory.prototype = $p;
$p.fP = (function(it) {
  return this.acc.cc(it);
});
$p.b5 = (function() {
  return this.acc.b5();
});
var $d_sc_MapFactory$ToFactory = new $TypeData().i($c_sc_MapFactory$ToFactory, "scala.collection.MapFactory$ToFactory", ({
  Hj: 1,
  bX: 1,
  a: 1
}));
/** @constructor */
function $c_sc_View$() {
}
$p = $c_sc_View$.prototype = new $h_O();
$p.constructor = $c_sc_View$;
/** @constructor */
function $h_sc_View$() {
}
$h_sc_View$.prototype = $p;
$p.WV = (function(it) {
  return ($is_sc_View(it) ? it : ($is_sc_Iterable(it) ? new $c_sc_View$$anon$1(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((x3) => (() => x3.o()))(it))) : $ct_sc_SeqView$Id__sc_SeqOps__(new $c_sc_SeqView$Id(), $m_sci_LazyList$().a3v(it))));
});
$p.b5 = (function() {
  return new $c_scm_Builder$$anon$1(($m_scm_ArrayBuffer$(), new $c_scm_ArrayBuffer$$anon$1()), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((it$2$2) => $m_sc_View$().WV(it$2$2))));
});
$p.b0f = (function(it, n) {
  if ((n <= 0)) {
    return it;
  } else {
    var k = it.V();
    return ((k >= 0) ? it.Ju(((k - n) | 0)) : new $c_sc_View$DropRightIterator(it, n));
  }
});
$p.dr = (function(elems) {
  return new $c_sc_View$Elems(elems);
});
$p.aO = (function() {
  return $m_sc_View$Empty$();
});
$p.cc = (function(source) {
  return this.WV(source);
});
var $d_sc_View$ = new $TypeData().i($c_sc_View$, "scala.collection.View$", ({
  HI: 1,
  a0: 1,
  a: 1
}));
var $n_sc_View$;
function $m_sc_View$() {
  if ((!$n_sc_View$)) {
    $n_sc_View$ = new $c_sc_View$();
  }
  return $n_sc_View$;
}
/** @constructor */
function $c_sci_BitmapIndexedMapNode(dataMap, nodeMap, content, originalHashes, size, cachedJavaKeySetHashCode) {
  this.cm = 0;
  this.db = 0;
  this.eJ = null;
  this.i2 = null;
  this.dS = 0;
  this.jL = 0;
  this.cm = dataMap;
  this.db = nodeMap;
  this.eJ = content;
  this.i2 = originalHashes;
  this.dS = size;
  this.jL = cachedJavaKeySetHashCode;
}
$p = $c_sci_BitmapIndexedMapNode.prototype = new $h_sci_MapNode();
$p.constructor = $c_sci_BitmapIndexedMapNode;
/** @constructor */
function $h_sci_BitmapIndexedMapNode() {
}
$h_sci_BitmapIndexedMapNode.prototype = $p;
$p.aa = (function() {
  return this.dS;
});
$p.dH = (function() {
  return this.jL;
});
$p.gy = (function(index) {
  return this.eJ.a[(index << 1)];
});
$p.h0 = (function(index) {
  return this.eJ.a[((1 + (index << 1)) | 0)];
});
$p.IZ = (function(index) {
  return new $c_T2(this.eJ.a[(index << 1)], this.eJ.a[((1 + (index << 1)) | 0)]);
});
$p.cK = (function(index) {
  return this.i2.a[index];
});
$p.jp = (function(index) {
  return this.eJ.a[((((this.eJ.a.length - 1) | 0) - index) | 0)];
});
$p.aeI = (function(key, originalHash, keyHash, shift) {
  var mask = $m_sci_Node$().fR(keyHash, shift);
  var bitpos = $m_sci_Node$().d6(mask);
  if (((this.cm & bitpos) !== 0)) {
    var index = $m_sci_Node$().h1(this.cm, mask, bitpos);
    if ($m_sr_BoxesRunTime$().Q(key, this.gy(index))) {
      return this.h0(index);
    } else {
      throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key));
    }
  } else if (((this.db & bitpos) !== 0)) {
    return this.jp($m_sci_Node$().h1(this.db, mask, bitpos)).aeI(key, originalHash, keyHash, ((5 + shift) | 0));
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key));
  }
});
$p.a3y = (function(key, originalHash, keyHash, shift) {
  var mask = $m_sci_Node$().fR(keyHash, shift);
  var bitpos = $m_sci_Node$().d6(mask);
  if (((this.cm & bitpos) !== 0)) {
    var index = $m_sci_Node$().h1(this.cm, mask, bitpos);
    return ($m_sr_BoxesRunTime$().Q(key, this.gy(index)) ? new $c_s_Some(this.h0(index)) : $m_s_None$());
  } else {
    return (((this.db & bitpos) !== 0) ? this.jp($m_sci_Node$().h1(this.db, mask, bitpos)).a3y(key, originalHash, keyHash, ((5 + shift) | 0)) : $m_s_None$());
  }
});
$p.a3B = (function(key, originalHash, keyHash, shift, f) {
  var mask = $m_sci_Node$().fR(keyHash, shift);
  var bitpos = $m_sci_Node$().d6(mask);
  if (((this.cm & bitpos) !== 0)) {
    var index = $m_sci_Node$().h1(this.cm, mask, bitpos);
    return ($m_sr_BoxesRunTime$().Q(key, this.gy(index)) ? this.h0(index) : f.a3());
  } else {
    return (((this.db & bitpos) !== 0) ? this.jp($m_sci_Node$().h1(this.db, mask, bitpos)).a3B(key, originalHash, keyHash, ((5 + shift) | 0), f) : f.a3());
  }
});
$p.a30 = (function(key, originalHash, keyHash, shift) {
  var mask = $m_sci_Node$().fR(keyHash, shift);
  var bitpos = $m_sci_Node$().d6(mask);
  if (((this.cm & bitpos) !== 0)) {
    var index = $m_sci_Node$().h1(this.cm, mask, bitpos);
    return ((this.i2.a[index] === originalHash) && $m_sr_BoxesRunTime$().Q(key, this.gy(index)));
  } else {
    return (((this.db & bitpos) !== 0) && this.jp($m_sci_Node$().h1(this.db, mask, bitpos)).a30(key, originalHash, keyHash, ((5 + shift) | 0)));
  }
});
$p.JF = (function(key, value, originalHash, keyHash, shift, replaceValue) {
  var mask = $m_sci_Node$().fR(keyHash, shift);
  var bitpos = $m_sci_Node$().d6(mask);
  if (((this.cm & bitpos) !== 0)) {
    var index = $m_sci_Node$().h1(this.cm, mask, bitpos);
    var key0 = this.gy(index);
    var key0UnimprovedHash = this.cK(index);
    if (((key0UnimprovedHash === originalHash) && $m_sr_BoxesRunTime$().Q(key0, key))) {
      if (replaceValue) {
        var value0 = this.h0(index);
        return ((Object.is(key0, key) && Object.is(value0, value)) ? this : this.aZf(bitpos, key, value));
      } else {
        return this;
      }
    } else {
      var value0$2 = this.h0(index);
      var key0Hash = $m_sc_Hashing$().bz(key0UnimprovedHash);
      return this.aZ9(bitpos, key0Hash, this.Xx(key0, value0$2, key0UnimprovedHash, key0Hash, key, value, originalHash, keyHash, ((5 + shift) | 0)));
    }
  } else if (((this.db & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().h1(this.db, mask, bitpos);
    var subNode = this.jp(index$2);
    var subNodeNew$2 = subNode.Yd(key, value, originalHash, keyHash, ((5 + shift) | 0), replaceValue);
    return ((subNodeNew$2 === subNode) ? this : this.aN6(bitpos, subNode, subNodeNew$2));
  } else {
    return this.aZ7(bitpos, key, originalHash, keyHash, value);
  }
});
$p.a59 = (function(key, value, originalHash, keyHash, shift, shallowlyMutableNodeMap) {
  var mask = $m_sci_Node$().fR(keyHash, shift);
  var bitpos = $m_sci_Node$().d6(mask);
  if (((this.cm & bitpos) !== 0)) {
    var index = $m_sci_Node$().h1(this.cm, mask, bitpos);
    var key0 = this.gy(index);
    var key0UnimprovedHash = this.cK(index);
    if (((key0UnimprovedHash === originalHash) && $m_sr_BoxesRunTime$().Q(key0, key))) {
      var value0 = this.h0(index);
      if ((!(Object.is(key0, key) && Object.is(value0, value)))) {
        var dataIx = this.kN(bitpos);
        var idx = (dataIx << 1);
        this.eJ.a[((1 + idx) | 0)] = value;
      }
      return shallowlyMutableNodeMap;
    } else {
      var value0$2 = this.h0(index);
      var key0Hash = $m_sc_Hashing$().bz(key0UnimprovedHash);
      this.aQk(bitpos, key0Hash, this.Xx(key0, value0$2, key0UnimprovedHash, key0Hash, key, value, originalHash, keyHash, ((5 + shift) | 0)));
      return (shallowlyMutableNodeMap | bitpos);
    }
  } else if (((this.db & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().h1(this.db, mask, bitpos);
    var subNode = this.jp(index$2);
    var subNodeSize = subNode.aa();
    var subNodeHashCode = subNode.dH();
    var returnMutableNodeMap = shallowlyMutableNodeMap;
    matchEnd4: {
      var subNodeNew$2;
      if ((subNode instanceof $c_sci_BitmapIndexedMapNode)) {
        if (((bitpos & shallowlyMutableNodeMap) !== 0)) {
          subNode.a59(key, value, originalHash, keyHash, ((5 + shift) | 0), 0);
          var subNodeNew$2 = subNode;
          break matchEnd4;
        }
      }
      var result = subNode.Yd(key, value, originalHash, keyHash, ((5 + shift) | 0), true);
      if ((result !== subNode)) {
        returnMutableNodeMap = (returnMutableNodeMap | bitpos);
      }
      var subNodeNew$2 = result;
    }
    this.eJ.a[((((this.eJ.a.length - 1) | 0) - this.r9(bitpos)) | 0)] = subNodeNew$2;
    this.dS = ((((this.dS - subNodeSize) | 0) + subNodeNew$2.aa()) | 0);
    this.jL = ((((this.jL - subNodeHashCode) | 0) + subNodeNew$2.dH()) | 0);
    return returnMutableNodeMap;
  } else {
    var dataIx$2 = this.kN(bitpos);
    var idx$2 = (dataIx$2 << 1);
    var src = this.eJ;
    var dst = new $ac_O(((2 + src.a.length) | 0));
    src.av(0, dst, 0, idx$2);
    dst.a[idx$2] = key;
    dst.a[((1 + idx$2) | 0)] = value;
    var destPos = ((2 + idx$2) | 0);
    var length = ((src.a.length - idx$2) | 0);
    src.av(idx$2, dst, destPos, length);
    this.cm = (this.cm | bitpos);
    this.eJ = dst;
    this.i2 = this.J2(this.i2, dataIx$2, originalHash);
    this.dS = ((1 + this.dS) | 0);
    this.jL = ((this.jL + keyHash) | 0);
    return shallowlyMutableNodeMap;
  }
});
$p.PP = (function(key, originalHash, keyHash, shift) {
  var mask = $m_sci_Node$().fR(keyHash, shift);
  var bitpos = $m_sci_Node$().d6(mask);
  if (((this.cm & bitpos) !== 0)) {
    var index = $m_sci_Node$().h1(this.cm, mask, bitpos);
    if ($m_sr_BoxesRunTime$().Q(this.gy(index), key)) {
      if ((($m_jl_Integer$().dz(this.cm) === 2) && ($m_jl_Integer$().dz(this.db) === 0))) {
        var newDataMap = ((shift === 0) ? (this.cm ^ bitpos) : $m_sci_Node$().d6($m_sci_Node$().fR(keyHash, 0)));
        return ((index === 0) ? new $c_sci_BitmapIndexedMapNode(newDataMap, 0, new $ac_O([this.gy(1), this.h0(1)]), new $ac_I(new Int32Array([this.i2.a[1]])), 1, $m_sc_Hashing$().bz(this.cK(1))) : new $c_sci_BitmapIndexedMapNode(newDataMap, 0, new $ac_O([this.gy(0), this.h0(0)]), new $ac_I(new Int32Array([this.i2.a[0]])), 1, $m_sc_Hashing$().bz(this.cK(0))));
      } else {
        return this.aZd(bitpos, keyHash);
      }
    } else {
      return this;
    }
  } else if (((this.db & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().h1(this.db, mask, bitpos);
    var subNode = this.jp(index$2);
    var subNodeNew = subNode.aRB(key, originalHash, keyHash, ((5 + shift) | 0));
    if ((subNodeNew === subNode)) {
      return this;
    }
    var subNodeNewSize = subNodeNew.aa();
    return ((subNodeNewSize === 1) ? ((this.dS === subNode.aa()) ? subNodeNew : this.aZc(bitpos, subNode, subNodeNew)) : ((subNodeNewSize > 1) ? this.aN6(bitpos, subNode, subNodeNew) : this));
  } else {
    return this;
  }
});
$p.Xx = (function(key0, value0, originalHash0, keyHash0, key1, value1, originalHash1, keyHash1, shift) {
  if ((shift >= 32)) {
    return new $c_sci_HashCollisionMapNode(originalHash0, keyHash0, $m_sci_Vector$().X($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [new $c_T2(key0, value0), new $c_T2(key1, value1)])));
  } else {
    var mask0 = $m_sci_Node$().fR(keyHash0, shift);
    var mask1 = $m_sci_Node$().fR(keyHash1, shift);
    var newCachedHash = ((keyHash0 + keyHash1) | 0);
    if ((mask0 !== mask1)) {
      var dataMap = ($m_sci_Node$().d6(mask0) | $m_sci_Node$().d6(mask1));
      return ((mask0 < mask1) ? new $c_sci_BitmapIndexedMapNode(dataMap, 0, new $ac_O([key0, value0, key1, value1]), new $ac_I(new Int32Array([originalHash0, originalHash1])), 2, newCachedHash) : new $c_sci_BitmapIndexedMapNode(dataMap, 0, new $ac_O([key1, value1, key0, value0]), new $ac_I(new Int32Array([originalHash1, originalHash0])), 2, newCachedHash));
    } else {
      var nodeMap = $m_sci_Node$().d6(mask0);
      var node = this.Xx(key0, value0, originalHash0, keyHash0, key1, value1, originalHash1, keyHash1, ((5 + shift) | 0));
      return new $c_sci_BitmapIndexedMapNode(0, nodeMap, new $ac_O([node]), $m_s_Array$EmptyArrays$().Uz, node.aa(), node.dH());
    }
  }
});
$p.X6 = (function() {
  return (this.db !== 0);
});
$p.XA = (function() {
  return $m_jl_Integer$().dz(this.db);
});
$p.Ps = (function() {
  return (this.cm !== 0);
});
$p.XI = (function() {
  return $m_jl_Integer$().dz(this.cm);
});
$p.kN = (function(bitpos) {
  return $m_jl_Integer$().dz((this.cm & ((bitpos - 1) | 0)));
});
$p.r9 = (function(bitpos) {
  return $m_jl_Integer$().dz((this.db & ((bitpos - 1) | 0)));
});
$p.aZf = (function(bitpos, newKey, newValue) {
  var dataIx = this.kN(bitpos);
  var idx = (dataIx << 1);
  var src = this.eJ;
  var dst = new $ac_O(src.a.length);
  var length = src.a.length;
  src.av(0, dst, 0, length);
  dst.a[((1 + idx) | 0)] = newValue;
  return new $c_sci_BitmapIndexedMapNode(this.cm, this.db, dst, this.i2, this.dS, this.jL);
});
$p.aN6 = (function(bitpos, oldNode, newNode) {
  var idx = ((((this.eJ.a.length - 1) | 0) - this.r9(bitpos)) | 0);
  var src = this.eJ;
  var dst = new $ac_O(src.a.length);
  var length = src.a.length;
  src.av(0, dst, 0, length);
  dst.a[idx] = newNode;
  return new $c_sci_BitmapIndexedMapNode(this.cm, this.db, dst, this.i2, ((((this.dS - oldNode.aa()) | 0) + newNode.aa()) | 0), ((((this.jL - oldNode.dH()) | 0) + newNode.dH()) | 0));
});
$p.aZ7 = (function(bitpos, key, originalHash, keyHash, value) {
  var dataIx = this.kN(bitpos);
  var idx = (dataIx << 1);
  var src = this.eJ;
  var dst = new $ac_O(((2 + src.a.length) | 0));
  src.av(0, dst, 0, idx);
  dst.a[idx] = key;
  dst.a[((1 + idx) | 0)] = value;
  var destPos = ((2 + idx) | 0);
  var length = ((src.a.length - idx) | 0);
  src.av(idx, dst, destPos, length);
  var dstHashes = this.J2(this.i2, dataIx, originalHash);
  return new $c_sci_BitmapIndexedMapNode((this.cm | bitpos), this.db, dst, dstHashes, ((1 + this.dS) | 0), ((this.jL + keyHash) | 0));
});
$p.aZd = (function(bitpos, keyHash) {
  var dataIx = this.kN(bitpos);
  var idx = (dataIx << 1);
  var src = this.eJ;
  var dst = new $ac_O(((src.a.length - 2) | 0));
  src.av(0, dst, 0, idx);
  var srcPos = ((2 + idx) | 0);
  var length = ((((src.a.length - idx) | 0) - 2) | 0);
  src.av(srcPos, dst, idx, length);
  var dstHashes = this.Jh(this.i2, dataIx);
  return new $c_sci_BitmapIndexedMapNode((this.cm ^ bitpos), this.db, dst, dstHashes, ((this.dS - 1) | 0), ((this.jL - keyHash) | 0));
});
$p.aQk = (function(bitpos, keyHash, node) {
  var dataIx = this.kN(bitpos);
  var idxOld = (dataIx << 1);
  var idxNew = ((((this.eJ.a.length - 2) | 0) - this.r9(bitpos)) | 0);
  var src = this.eJ;
  var dst = new $ac_O(((src.a.length - 1) | 0));
  src.av(0, dst, 0, idxOld);
  var srcPos = ((2 + idxOld) | 0);
  var length = ((idxNew - idxOld) | 0);
  src.av(srcPos, dst, idxOld, length);
  dst.a[idxNew] = node;
  var srcPos$1 = ((2 + idxNew) | 0);
  var destPos = ((1 + idxNew) | 0);
  var length$1 = ((((src.a.length - idxNew) | 0) - 2) | 0);
  src.av(srcPos$1, dst, destPos, length$1);
  var dstHashes = this.Jh(this.i2, dataIx);
  this.cm = (this.cm ^ bitpos);
  this.db = (this.db | bitpos);
  this.eJ = dst;
  this.i2 = dstHashes;
  this.dS = ((((this.dS - 1) | 0) + node.aa()) | 0);
  this.jL = ((((this.jL - keyHash) | 0) + node.dH()) | 0);
  return this;
});
$p.aZ9 = (function(bitpos, keyHash, node) {
  var dataIx = this.kN(bitpos);
  var idxOld = (dataIx << 1);
  var idxNew = ((((this.eJ.a.length - 2) | 0) - this.r9(bitpos)) | 0);
  var src = this.eJ;
  var dst = new $ac_O(((src.a.length - 1) | 0));
  src.av(0, dst, 0, idxOld);
  var srcPos = ((2 + idxOld) | 0);
  var length = ((idxNew - idxOld) | 0);
  src.av(srcPos, dst, idxOld, length);
  dst.a[idxNew] = node;
  var srcPos$1 = ((2 + idxNew) | 0);
  var destPos = ((1 + idxNew) | 0);
  var length$1 = ((((src.a.length - idxNew) | 0) - 2) | 0);
  src.av(srcPos$1, dst, destPos, length$1);
  var dstHashes = this.Jh(this.i2, dataIx);
  return new $c_sci_BitmapIndexedMapNode((this.cm ^ bitpos), (this.db | bitpos), dst, dstHashes, ((((this.dS - 1) | 0) + node.aa()) | 0), ((((this.jL - keyHash) | 0) + node.dH()) | 0));
});
$p.aZc = (function(bitpos, oldNode, node) {
  var idxOld = ((((this.eJ.a.length - 1) | 0) - this.r9(bitpos)) | 0);
  var dataIxNew = this.kN(bitpos);
  var idxNew = (dataIxNew << 1);
  var key = node.gy(0);
  var value = node.h0(0);
  var src = this.eJ;
  var dst = new $ac_O(((1 + src.a.length) | 0));
  src.av(0, dst, 0, idxNew);
  dst.a[idxNew] = key;
  dst.a[((1 + idxNew) | 0)] = value;
  var destPos = ((2 + idxNew) | 0);
  var length = ((idxOld - idxNew) | 0);
  src.av(idxNew, dst, destPos, length);
  var srcPos = ((1 + idxOld) | 0);
  var destPos$1 = ((2 + idxOld) | 0);
  var length$1 = ((((src.a.length - idxOld) | 0) - 1) | 0);
  src.av(srcPos, dst, destPos$1, length$1);
  var hash = node.cK(0);
  var dstHashes = this.J2(this.i2, dataIxNew, hash);
  return new $c_sci_BitmapIndexedMapNode((this.cm | bitpos), (this.db ^ bitpos), dst, dstHashes, ((1 + ((this.dS - oldNode.aa()) | 0)) | 0), ((((this.jL - oldNode.dH()) | 0) + node.dH()) | 0));
});
$p.F = (function(f) {
  var iN = $m_jl_Integer$().dz(this.cm);
  var i$1 = 0;
  while ((i$1 < iN)) {
    f.i(this.IZ(i$1));
    i$1 = ((1 + i$1) | 0);
  }
  var jN = $m_jl_Integer$().dz(this.db);
  var j = 0;
  while ((j < jN)) {
    this.jp(j).F(f);
    j = ((1 + j) | 0);
  }
});
$p.pu = (function(f) {
  var iN = $m_jl_Integer$().dz(this.cm);
  var i$1 = 0;
  while ((i$1 < iN)) {
    f.R(this.gy(i$1), this.h0(i$1));
    i$1 = ((1 + i$1) | 0);
  }
  var jN = $m_jl_Integer$().dz(this.db);
  var j = 0;
  while ((j < jN)) {
    this.jp(j).pu(f);
    j = ((1 + j) | 0);
  }
});
$p.afW = (function(f) {
  var i = 0;
  var iN = $m_jl_Integer$().dz(this.cm);
  while ((i < iN)) {
    f.DH(this.gy(i), this.h0(i), this.cK(i));
    i = ((1 + i) | 0);
  }
  var jN = $m_jl_Integer$().dz(this.db);
  var j = 0;
  while ((j < jN)) {
    this.jp(j).afW(f);
    j = ((1 + j) | 0);
  }
});
$p.aT1 = (function(f) {
  var newContent = null;
  var iN = $m_jl_Integer$().dz(this.cm);
  var jN = $m_jl_Integer$().dz(this.db);
  var newContentLength = this.eJ.a.length;
  var i$2 = 0;
  while ((i$2 < iN)) {
    var key = this.gy(i$2);
    var value = this.h0(i$2);
    var newValue = f.R(key, value);
    if ((newContent === null)) {
      if ((!Object.is(newValue, value))) {
        newContent = this.eJ.ae();
        newContent.a[((1 + (i$2 << 1)) | 0)] = newValue;
      }
    } else {
      newContent.a[((1 + (i$2 << 1)) | 0)] = newValue;
    }
    i$2 = ((1 + i$2) | 0);
  }
  var j = 0;
  while ((j < jN)) {
    var node = this.jp(j);
    var newNode = node.aT2(f);
    if ((newContent === null)) {
      if ((newNode !== node)) {
        newContent = this.eJ.ae();
        newContent.a[((((newContentLength - j) | 0) - 1) | 0)] = newNode;
      }
    } else {
      newContent.a[((((newContentLength - j) | 0) - 1) | 0)] = newNode;
    }
    j = ((1 + j) | 0);
  }
  return ((newContent === null) ? this : new $c_sci_BitmapIndexedMapNode(this.cm, this.db, newContent, this.i2, this.dS, this.jL));
});
$p.e = (function(that) {
  if ((that instanceof $c_sci_BitmapIndexedMapNode)) {
    if ((this === that)) {
      return true;
    } else if ((((((this.jL === that.jL) && (this.db === that.db)) && (this.cm === that.cm)) && (this.dS === that.dS)) && $m_ju_Arrays$().a3h(this.i2, that.i2))) {
      var a1 = this.eJ;
      var a2 = that.eJ;
      var length = this.eJ.a.length;
      if ((a1 === a2)) {
        return true;
      } else {
        var isEqual = true;
        var i = 0;
        while ((isEqual && (i < length))) {
          isEqual = $m_sr_BoxesRunTime$().Q(a1.a[i], a2.a[i]);
          i = ((1 + i) | 0);
        }
        return isEqual;
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.x = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Trie nodes do not support hashing.");
});
$p.m = (function() {
  var i = $systemIdentityHashCode(this);
  return (($objectClassName(this) + "@") + (i >>> 0.0).toString(16));
});
$p.aMU = (function(that, shift) {
  if ((that instanceof $c_sci_BitmapIndexedMapNode)) {
    if ((this.dS === 0)) {
      return that;
    } else if (((that.dS === 0) || (that === this))) {
      return this;
    } else if ((that.dS === 1)) {
      var originalHash = that.cK(0);
      return this.JF(that.gy(0), that.h0(0), originalHash, $m_sc_Hashing$().bz(originalHash), shift, true);
    }
    var anyChangesMadeSoFar = false;
    var allMap = (((this.cm | that.cm) | this.db) | that.db);
    var minimumBitPos = $m_sci_Node$().d6(((32 - Math.clz32(((~allMap) & ((allMap - 1) | 0)))) | 0));
    var maximumBitPos = $m_sci_Node$().d6(((31 - Math.clz32(allMap)) | 0));
    var leftNodeRightNode = 0;
    var leftDataRightNode = 0;
    var leftNodeRightData = 0;
    var leftDataOnly = 0;
    var rightDataOnly = 0;
    var leftNodeOnly = 0;
    var rightNodeOnly = 0;
    var leftDataRightDataMigrateToNode = 0;
    var leftDataRightDataRightOverwrites = 0;
    var dataToNodeMigrationTargets = 0;
    var bitpos = minimumBitPos;
    var leftIdx = 0;
    var rightIdx = 0;
    var finished = false;
    while ((!finished)) {
      if (((bitpos & this.cm) !== 0)) {
        if (((bitpos & that.cm) !== 0)) {
          var leftOriginalHash = this.cK(leftIdx);
          if (((leftOriginalHash === that.cK(rightIdx)) && $m_sr_BoxesRunTime$().Q(this.gy(leftIdx), that.gy(rightIdx)))) {
            leftDataRightDataRightOverwrites = (leftDataRightDataRightOverwrites | bitpos);
          } else {
            leftDataRightDataMigrateToNode = (leftDataRightDataMigrateToNode | bitpos);
            dataToNodeMigrationTargets = (dataToNodeMigrationTargets | $m_sci_Node$().d6($m_sci_Node$().fR($m_sc_Hashing$().bz(leftOriginalHash), shift)));
          }
          rightIdx = ((1 + rightIdx) | 0);
        } else if (((bitpos & that.db) !== 0)) {
          leftDataRightNode = (leftDataRightNode | bitpos);
        } else {
          leftDataOnly = (leftDataOnly | bitpos);
        }
        leftIdx = ((1 + leftIdx) | 0);
      } else if (((bitpos & this.db) !== 0)) {
        if (((bitpos & that.cm) !== 0)) {
          leftNodeRightData = (leftNodeRightData | bitpos);
          rightIdx = ((1 + rightIdx) | 0);
        } else if (((bitpos & that.db) !== 0)) {
          leftNodeRightNode = (leftNodeRightNode | bitpos);
        } else {
          leftNodeOnly = (leftNodeOnly | bitpos);
        }
      } else if (((bitpos & that.cm) !== 0)) {
        rightDataOnly = (rightDataOnly | bitpos);
        rightIdx = ((1 + rightIdx) | 0);
      } else if (((bitpos & that.db) !== 0)) {
        rightNodeOnly = (rightNodeOnly | bitpos);
      }
      if ((bitpos === maximumBitPos)) {
        finished = true;
      } else {
        bitpos = (bitpos << 1);
      }
    }
    var newDataMap = ((leftDataOnly | rightDataOnly) | leftDataRightDataRightOverwrites);
    var newNodeMap = (((((leftNodeRightNode | leftDataRightNode) | leftNodeRightData) | leftNodeOnly) | rightNodeOnly) | dataToNodeMigrationTargets);
    if (((newDataMap === (rightDataOnly | leftDataRightDataRightOverwrites)) && (newNodeMap === rightNodeOnly))) {
      return that;
    }
    var newDataSize = $m_jl_Integer$().dz(newDataMap);
    var newContentSize = (((newDataSize << 1) + $m_jl_Integer$().dz(newNodeMap)) | 0);
    var newContent = new $ac_O(newContentSize);
    var newOriginalHashes = new $ac_I(newDataSize);
    var newSize = 0;
    var newCachedHashCode = 0;
    var leftDataIdx = 0;
    var rightDataIdx = 0;
    var leftNodeIdx = 0;
    var rightNodeIdx = 0;
    var nextShift = ((5 + shift) | 0);
    var compressedDataIdx = 0;
    var compressedNodeIdx = 0;
    var bitpos$2 = minimumBitPos;
    var finished$2 = false;
    while ((!finished$2)) {
      if (((bitpos$2 & leftNodeRightNode) !== 0)) {
        var rightNode = that.jp(rightNodeIdx);
        var newNode = this.jp(leftNodeIdx).aMV(rightNode, nextShift);
        if ((rightNode !== newNode)) {
          anyChangesMadeSoFar = true;
        }
        newContent.a[((((newContentSize - compressedNodeIdx) | 0) - 1) | 0)] = newNode;
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        rightNodeIdx = ((1 + rightNodeIdx) | 0);
        leftNodeIdx = ((1 + leftNodeIdx) | 0);
        newSize = ((newSize + newNode.aa()) | 0);
        newCachedHashCode = ((newCachedHashCode + newNode.dH()) | 0);
      } else if (((bitpos$2 & leftDataRightNode) !== 0)) {
        var n = that.jp(rightNodeIdx);
        var leftKey = this.gy(leftDataIdx);
        var leftValue = this.h0(leftDataIdx);
        var leftOriginalHash$2 = this.cK(leftDataIdx);
        var leftImproved = $m_sc_Hashing$().bz(leftOriginalHash$2);
        var updated = n.Yd(leftKey, leftValue, leftOriginalHash$2, leftImproved, nextShift, false);
        if ((updated !== n)) {
          anyChangesMadeSoFar = true;
        }
        newContent.a[((((newContentSize - compressedNodeIdx) | 0) - 1) | 0)] = updated;
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        rightNodeIdx = ((1 + rightNodeIdx) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
        newSize = ((newSize + updated.aa()) | 0);
        newCachedHashCode = ((newCachedHashCode + updated.dH()) | 0);
      } else if (((bitpos$2 & leftNodeRightData) !== 0)) {
        anyChangesMadeSoFar = true;
        var rightOriginalHash = that.cK(rightDataIdx);
        var newNode$3 = this.jp(leftNodeIdx).Yd(that.gy(rightDataIdx), that.h0(rightDataIdx), that.cK(rightDataIdx), $m_sc_Hashing$().bz(rightOriginalHash), nextShift, true);
        newContent.a[((((newContentSize - compressedNodeIdx) | 0) - 1) | 0)] = newNode$3;
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        leftNodeIdx = ((1 + leftNodeIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((newSize + newNode$3.aa()) | 0);
        newCachedHashCode = ((newCachedHashCode + newNode$3.dH()) | 0);
      } else if (((bitpos$2 & leftDataOnly) !== 0)) {
        anyChangesMadeSoFar = true;
        var originalHash$2 = this.i2.a[leftDataIdx];
        newContent.a[(compressedDataIdx << 1)] = this.gy(leftDataIdx);
        newContent.a[((1 + (compressedDataIdx << 1)) | 0)] = this.h0(leftDataIdx);
        newOriginalHashes.a[compressedDataIdx] = originalHash$2;
        compressedDataIdx = ((1 + compressedDataIdx) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
        newSize = ((1 + newSize) | 0);
        newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().bz(originalHash$2)) | 0);
      } else if (((bitpos$2 & rightDataOnly) !== 0)) {
        var originalHash$3 = that.i2.a[rightDataIdx];
        newContent.a[(compressedDataIdx << 1)] = that.gy(rightDataIdx);
        newContent.a[((1 + (compressedDataIdx << 1)) | 0)] = that.h0(rightDataIdx);
        newOriginalHashes.a[compressedDataIdx] = originalHash$3;
        compressedDataIdx = ((1 + compressedDataIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((1 + newSize) | 0);
        newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().bz(originalHash$3)) | 0);
      } else if (((bitpos$2 & leftNodeOnly) !== 0)) {
        anyChangesMadeSoFar = true;
        var newNode$4 = this.jp(leftNodeIdx);
        newContent.a[((((newContentSize - compressedNodeIdx) | 0) - 1) | 0)] = newNode$4;
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        leftNodeIdx = ((1 + leftNodeIdx) | 0);
        newSize = ((newSize + newNode$4.aa()) | 0);
        newCachedHashCode = ((newCachedHashCode + newNode$4.dH()) | 0);
      } else if (((bitpos$2 & rightNodeOnly) !== 0)) {
        var newNode$5 = that.jp(rightNodeIdx);
        newContent.a[((((newContentSize - compressedNodeIdx) | 0) - 1) | 0)] = newNode$5;
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        rightNodeIdx = ((1 + rightNodeIdx) | 0);
        newSize = ((newSize + newNode$5.aa()) | 0);
        newCachedHashCode = ((newCachedHashCode + newNode$5.dH()) | 0);
      } else if (((bitpos$2 & leftDataRightDataMigrateToNode) !== 0)) {
        anyChangesMadeSoFar = true;
        var leftOriginalHash$3 = this.cK(leftDataIdx);
        var rightOriginalHash$2 = that.cK(rightDataIdx);
        var newNode$6 = that.Xx(this.gy(leftDataIdx), this.h0(leftDataIdx), leftOriginalHash$3, $m_sc_Hashing$().bz(leftOriginalHash$3), that.gy(rightDataIdx), that.h0(rightDataIdx), rightOriginalHash$2, $m_sc_Hashing$().bz(rightOriginalHash$2), nextShift);
        newContent.a[((((newContentSize - compressedNodeIdx) | 0) - 1) | 0)] = newNode$6;
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((newSize + newNode$6.aa()) | 0);
        newCachedHashCode = ((newCachedHashCode + newNode$6.dH()) | 0);
      } else if (((bitpos$2 & leftDataRightDataRightOverwrites) !== 0)) {
        var originalHash$4 = that.i2.a[rightDataIdx];
        newContent.a[(compressedDataIdx << 1)] = that.gy(rightDataIdx);
        newContent.a[((1 + (compressedDataIdx << 1)) | 0)] = that.h0(rightDataIdx);
        newOriginalHashes.a[compressedDataIdx] = originalHash$4;
        compressedDataIdx = ((1 + compressedDataIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((1 + newSize) | 0);
        newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().bz(originalHash$4)) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
      }
      if ((bitpos$2 === maximumBitPos)) {
        finished$2 = true;
      } else {
        bitpos$2 = (bitpos$2 << 1);
      }
    }
    return (anyChangesMadeSoFar ? new $c_sci_BitmapIndexedMapNode(newDataMap, newNodeMap, newContent, newOriginalHashes, newSize, newCachedHashCode) : that);
  } else {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Cannot concatenate a HashCollisionMapNode with a BitmapIndexedMapNode");
  }
});
$p.aN2 = (function() {
  var this$1 = this.eJ;
  var contentClone = this$1.ae();
  var contentLength = contentClone.a.length;
  var i$1 = ($m_jl_Integer$().dz(this.cm) << 1);
  while ((i$1 < contentLength)) {
    contentClone.a[i$1] = contentClone.a[i$1].aN4();
    i$1 = ((1 + i$1) | 0);
  }
  return new $c_sci_BitmapIndexedMapNode(this.cm, this.db, contentClone, this.i2.ae(), this.dS, this.jL);
});
$p.aO3 = (function(pred, flipped) {
  if ((this.dS === 0)) {
    return this;
  } else if ((this.dS === 1)) {
    return (((!(!pred.i(this.IZ(0)))) !== flipped) ? this : $m_sci_MapNode$().NY);
  } else if ((this.db === 0)) {
    var i = this.cm;
    var minimumIndex = ((32 - Math.clz32(((~i) & ((i - 1) | 0)))) | 0);
    var maximumIndex = ((32 - Math.clz32(this.cm)) | 0);
    var newDataMap = 0;
    var newCachedHashCode = 0;
    var dataIndex = 0;
    var i$3 = minimumIndex;
    while ((i$3 < maximumIndex)) {
      var bitpos = $m_sci_Node$().d6(i$3);
      if (((bitpos & this.cm) !== 0)) {
        var payload = this.IZ(dataIndex);
        if (((!(!pred.i(payload))) !== flipped)) {
          newDataMap = (newDataMap | bitpos);
          newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().bz(this.cK(dataIndex))) | 0);
        }
        dataIndex = ((1 + dataIndex) | 0);
      }
      i$3 = ((1 + i$3) | 0);
    }
    if ((newDataMap === 0)) {
      return $m_sci_MapNode$().NY;
    } else if ((newDataMap === this.cm)) {
      return this;
    } else {
      var newSize = $m_jl_Integer$().dz(newDataMap);
      var newContent = new $ac_O((newSize << 1));
      var newOriginalHashCodes = new $ac_I(newSize);
      var newMaximumIndex = ((32 - Math.clz32(newDataMap)) | 0);
      var i$6 = newDataMap;
      var j = ((32 - Math.clz32(((~i$6) & ((i$6 - 1) | 0)))) | 0);
      var newDataIndex = 0;
      while ((j < newMaximumIndex)) {
        var bitpos$2 = $m_sci_Node$().d6(j);
        if (((bitpos$2 & newDataMap) !== 0)) {
          var oldIndex = $m_sci_Node$().w6(this.cm, bitpos$2);
          newContent.a[(newDataIndex << 1)] = this.eJ.a[(oldIndex << 1)];
          newContent.a[((1 + (newDataIndex << 1)) | 0)] = this.eJ.a[((1 + (oldIndex << 1)) | 0)];
          newOriginalHashCodes.a[newDataIndex] = this.i2.a[oldIndex];
          newDataIndex = ((1 + newDataIndex) | 0);
        }
        j = ((1 + j) | 0);
      }
      return new $c_sci_BitmapIndexedMapNode(newDataMap, 0, newContent, newOriginalHashCodes, newSize, newCachedHashCode);
    }
  } else {
    var allMap = (this.cm | this.db);
    var minimumIndex$2 = ((32 - Math.clz32(((~allMap) & ((allMap - 1) | 0)))) | 0);
    var maximumIndex$2 = ((32 - Math.clz32(allMap)) | 0);
    var oldDataPassThrough = 0;
    var nodeMigrateToDataTargetMap = 0;
    var nodesToMigrateToData = null;
    var nodesToPassThroughMap = 0;
    var mapOfNewNodes = 0;
    var newNodes = null;
    var newDataMap$2 = 0;
    var newNodeMap = 0;
    var newSize$2 = 0;
    var newCachedHashCode$2 = 0;
    var dataIndex$2 = 0;
    var nodeIndex = 0;
    var i$2$1 = minimumIndex$2;
    while ((i$2$1 < maximumIndex$2)) {
      var bitpos$3 = $m_sci_Node$().d6(i$2$1);
      if (((bitpos$3 & this.cm) !== 0)) {
        var payload$2 = this.IZ(dataIndex$2);
        if (((!(!pred.i(payload$2))) !== flipped)) {
          newDataMap$2 = (newDataMap$2 | bitpos$3);
          oldDataPassThrough = (oldDataPassThrough | bitpos$3);
          newSize$2 = ((1 + newSize$2) | 0);
          newCachedHashCode$2 = ((newCachedHashCode$2 + $m_sc_Hashing$().bz(this.cK(dataIndex$2))) | 0);
        }
        dataIndex$2 = ((1 + dataIndex$2) | 0);
      } else if (((bitpos$3 & this.db) !== 0)) {
        var oldSubNode = this.jp(nodeIndex);
        var newSubNode = oldSubNode.aO5(pred, flipped);
        newSize$2 = ((newSize$2 + newSubNode.aa()) | 0);
        newCachedHashCode$2 = ((newCachedHashCode$2 + newSubNode.dH()) | 0);
        if ((newSubNode.aa() > 1)) {
          newNodeMap = (newNodeMap | bitpos$3);
          if ((oldSubNode === newSubNode)) {
            nodesToPassThroughMap = (nodesToPassThroughMap | bitpos$3);
          } else {
            mapOfNewNodes = (mapOfNewNodes | bitpos$3);
            if ((newNodes === null)) {
              newNodes = $ct_scm_Queue__I__(new $c_scm_Queue(), 16);
            }
            newNodes.km(newSubNode);
          }
        } else if ((newSubNode.aa() === 1)) {
          newDataMap$2 = (newDataMap$2 | bitpos$3);
          nodeMigrateToDataTargetMap = (nodeMigrateToDataTargetMap | bitpos$3);
          if ((nodesToMigrateToData === null)) {
            var elems = $m_sci_Nil$();
            nodesToMigrateToData = $ct_scm_Queue__I__(new $c_scm_Queue(), 16).kl(elems);
          }
          nodesToMigrateToData.km(newSubNode);
        }
        nodeIndex = ((1 + nodeIndex) | 0);
      }
      i$2$1 = ((1 + i$2$1) | 0);
    }
    if ((newSize$2 === 0)) {
      return $m_sci_MapNode$().NY;
    } else if ((newSize$2 === this.dS)) {
      return this;
    } else {
      var newDataSize = $m_jl_Integer$().dz(newDataMap$2);
      var newContentSize = (((newDataSize << 1) + $m_jl_Integer$().dz(newNodeMap)) | 0);
      var newContent$2 = new $ac_O(newContentSize);
      var newOriginalHashes = new $ac_I(newDataSize);
      var newAllMap = (newDataMap$2 | newNodeMap);
      var maxIndex = ((32 - Math.clz32(newAllMap)) | 0);
      var i$3$1 = minimumIndex$2;
      var oldDataIndex = 0;
      var oldNodeIndex = 0;
      var newDataIndex$2 = 0;
      var newNodeIndex = 0;
      while ((i$3$1 < maxIndex)) {
        var bitpos$4 = $m_sci_Node$().d6(i$3$1);
        if (((bitpos$4 & oldDataPassThrough) !== 0)) {
          newContent$2.a[(newDataIndex$2 << 1)] = this.gy(oldDataIndex);
          newContent$2.a[((1 + (newDataIndex$2 << 1)) | 0)] = this.h0(oldDataIndex);
          newOriginalHashes.a[newDataIndex$2] = this.cK(oldDataIndex);
          newDataIndex$2 = ((1 + newDataIndex$2) | 0);
          oldDataIndex = ((1 + oldDataIndex) | 0);
        } else if (((bitpos$4 & nodesToPassThroughMap) !== 0)) {
          newContent$2.a[((((newContentSize - newNodeIndex) | 0) - 1) | 0)] = this.jp(oldNodeIndex);
          newNodeIndex = ((1 + newNodeIndex) | 0);
          oldNodeIndex = ((1 + oldNodeIndex) | 0);
        } else if (((bitpos$4 & nodeMigrateToDataTargetMap) !== 0)) {
          var node = nodesToMigrateToData.h7(false);
          newContent$2.a[(newDataIndex$2 << 1)] = node.gy(0);
          newContent$2.a[((1 + (newDataIndex$2 << 1)) | 0)] = node.h0(0);
          newOriginalHashes.a[newDataIndex$2] = node.cK(0);
          newDataIndex$2 = ((1 + newDataIndex$2) | 0);
          oldNodeIndex = ((1 + oldNodeIndex) | 0);
        } else if (((bitpos$4 & mapOfNewNodes) !== 0)) {
          newContent$2.a[((((newContentSize - newNodeIndex) | 0) - 1) | 0)] = newNodes.h7(false);
          newNodeIndex = ((1 + newNodeIndex) | 0);
          oldNodeIndex = ((1 + oldNodeIndex) | 0);
        } else if (((bitpos$4 & this.cm) !== 0)) {
          oldDataIndex = ((1 + oldDataIndex) | 0);
        } else if (((bitpos$4 & this.db) !== 0)) {
          oldNodeIndex = ((1 + oldNodeIndex) | 0);
        }
        i$3$1 = ((1 + i$3$1) | 0);
      }
      return new $c_sci_BitmapIndexedMapNode(newDataMap$2, newNodeMap, newContent$2, newOriginalHashes, newSize$2, newCachedHashCode$2);
    }
  }
});
$p.aO5 = (function(pred, isFlipped) {
  return this.aO3(pred, isFlipped);
});
$p.aN4 = (function() {
  return this.aN2();
});
$p.aMV = (function(that, shift) {
  return this.aMU(that, shift);
});
$p.aT2 = (function(f) {
  return this.aT1(f);
});
$p.aRB = (function(key, originalHash, hash, shift) {
  return this.PP(key, originalHash, hash, shift);
});
$p.Yd = (function(key, value, originalHash, hash, shift, replaceValue) {
  return this.JF(key, value, originalHash, hash, shift, replaceValue);
});
$p.X1 = (function(index) {
  return this.jp(index);
});
function $isArrayOf_sci_BitmapIndexedMapNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.l6)));
}
var $d_sci_BitmapIndexedMapNode = new $TypeData().i($c_sci_BitmapIndexedMapNode, "scala.collection.immutable.BitmapIndexedMapNode", ({
  l6: 1,
  li: 1,
  c1: 1
}));
function $p_sci_BitmapIndexedSetNode__newNodeFrom__I__I__I__I__I__I__I__scm_Queue__I__scm_Queue__I__sci_BitmapIndexedSetNode($thiz, newSize, newDataMap, newNodeMap, minimumIndex, oldDataPassThrough, nodesToPassThroughMap, nodeMigrateToDataTargetMap, nodesToMigrateToData, mapOfNewNodes, newNodes, newCachedHashCode) {
  if ((newSize === 0)) {
    return $m_sci_SetNode$().HG;
  } else if ((newSize === $thiz.cC)) {
    return $thiz;
  } else {
    var newDataSize = $m_jl_Integer$().dz(newDataMap);
    var newContentSize = ((newDataSize + $m_jl_Integer$().dz(newNodeMap)) | 0);
    var newContent = new $ac_O(newContentSize);
    var newOriginalHashes = new $ac_I(newDataSize);
    var newAllMap = (newDataMap | newNodeMap);
    var maxIndex = ((32 - Math.clz32(newAllMap)) | 0);
    var i = minimumIndex;
    var oldDataIndex = 0;
    var oldNodeIndex = 0;
    var newDataIndex = 0;
    var newNodeIndex = 0;
    while ((i < maxIndex)) {
      var bitpos = $m_sci_Node$().d6(i);
      if (((bitpos & oldDataPassThrough) !== 0)) {
        newContent.a[newDataIndex] = $thiz.e4(oldDataIndex);
        newOriginalHashes.a[newDataIndex] = $thiz.cK(oldDataIndex);
        newDataIndex = ((1 + newDataIndex) | 0);
        oldDataIndex = ((1 + oldDataIndex) | 0);
      } else if (((bitpos & nodesToPassThroughMap) !== 0)) {
        newContent.a[((((newContentSize - newNodeIndex) | 0) - 1) | 0)] = $thiz.iX(oldNodeIndex);
        newNodeIndex = ((1 + newNodeIndex) | 0);
        oldNodeIndex = ((1 + oldNodeIndex) | 0);
      } else if (((bitpos & nodeMigrateToDataTargetMap) !== 0)) {
        var node = nodesToMigrateToData.h7(false);
        newContent.a[newDataIndex] = node.e4(0);
        newOriginalHashes.a[newDataIndex] = node.cK(0);
        newDataIndex = ((1 + newDataIndex) | 0);
        oldNodeIndex = ((1 + oldNodeIndex) | 0);
      } else if (((bitpos & mapOfNewNodes) !== 0)) {
        newContent.a[((((newContentSize - newNodeIndex) | 0) - 1) | 0)] = newNodes.h7(false);
        newNodeIndex = ((1 + newNodeIndex) | 0);
        oldNodeIndex = ((1 + oldNodeIndex) | 0);
      } else if (((bitpos & $thiz.bI) !== 0)) {
        oldDataIndex = ((1 + oldDataIndex) | 0);
      } else if (((bitpos & $thiz.cs) !== 0)) {
        oldNodeIndex = ((1 + oldNodeIndex) | 0);
      }
      i = ((1 + i) | 0);
    }
    return new $c_sci_BitmapIndexedSetNode(newDataMap, newNodeMap, newContent, newOriginalHashes, newSize, newCachedHashCode);
  }
}
/** @constructor */
function $c_sci_BitmapIndexedSetNode(dataMap, nodeMap, content, originalHashes, size, cachedJavaKeySetHashCode) {
  this.bI = 0;
  this.cs = 0;
  this.dX = null;
  this.eP = null;
  this.cC = 0;
  this.fZ = 0;
  this.bI = dataMap;
  this.cs = nodeMap;
  this.dX = content;
  this.eP = originalHashes;
  this.cC = size;
  this.fZ = cachedJavaKeySetHashCode;
}
$p = $c_sci_BitmapIndexedSetNode.prototype = new $h_sci_SetNode();
$p.constructor = $c_sci_BitmapIndexedSetNode;
/** @constructor */
function $h_sci_BitmapIndexedSetNode() {
}
$h_sci_BitmapIndexedSetNode.prototype = $p;
$p.aa = (function() {
  return this.cC;
});
$p.dH = (function() {
  return this.fZ;
});
$p.e4 = (function(index) {
  return this.dX.a[index];
});
$p.cK = (function(index) {
  return this.eP.a[index];
});
$p.iX = (function(index) {
  return this.dX.a[((((this.dX.a.length - 1) | 0) - index) | 0)];
});
$p.Ai = (function(element, originalHash, elementHash, shift) {
  var mask = $m_sci_Node$().fR(elementHash, shift);
  var bitpos = $m_sci_Node$().d6(mask);
  if (((this.bI & bitpos) !== 0)) {
    var index = $m_sci_Node$().h1(this.bI, mask, bitpos);
    return ((this.eP.a[index] === originalHash) && $m_sr_BoxesRunTime$().Q(element, this.e4(index)));
  }
  if (((this.cs & bitpos) !== 0)) {
    return this.iX($m_sci_Node$().h1(this.cs, mask, bitpos)).Ai(element, originalHash, elementHash, ((5 + shift) | 0));
  }
  return false;
});
$p.Q7 = (function(element, originalHash, elementHash, shift) {
  var mask = $m_sci_Node$().fR(elementHash, shift);
  var bitpos = $m_sci_Node$().d6(mask);
  if (((this.bI & bitpos) !== 0)) {
    var index = $m_sci_Node$().h1(this.bI, mask, bitpos);
    var element0 = this.e4(index);
    if (Object.is(element0, element)) {
      return this;
    } else {
      var element0UnimprovedHash = this.cK(index);
      var element0Hash = $m_sc_Hashing$().bz(element0UnimprovedHash);
      if (((originalHash === element0UnimprovedHash) && $m_sr_BoxesRunTime$().Q(element0, element))) {
        return this;
      } else {
        return this.aZa(bitpos, element0Hash, this.Xw(element0, element0UnimprovedHash, element0Hash, element, originalHash, elementHash, ((5 + shift) | 0)));
      }
    }
  }
  if (((this.cs & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().h1(this.cs, mask, bitpos);
    var subNode = this.iX(index$2);
    var subNodeNew$2 = subNode.Yc(element, originalHash, elementHash, ((5 + shift) | 0));
    if ((subNode === subNodeNew$2)) {
      return this;
    } else {
      return this.aN7(bitpos, subNode, subNodeNew$2);
    }
  }
  return this.aZ8(bitpos, element, originalHash, elementHash);
});
$p.a58 = (function(element, originalHash, elementHash, shift, shallowlyMutableNodeMap) {
  var mask = $m_sci_Node$().fR(elementHash, shift);
  var bitpos = $m_sci_Node$().d6(mask);
  if (((this.bI & bitpos) !== 0)) {
    var index = $m_sci_Node$().h1(this.bI, mask, bitpos);
    var element0 = this.e4(index);
    var element0UnimprovedHash = this.cK(index);
    if (((element0UnimprovedHash === originalHash) && $m_sr_BoxesRunTime$().Q(element0, element))) {
      return shallowlyMutableNodeMap;
    } else {
      var element0Hash = $m_sc_Hashing$().bz(element0UnimprovedHash);
      this.aQl(bitpos, element0Hash, this.Xw(element0, element0UnimprovedHash, element0Hash, element, originalHash, elementHash, ((5 + shift) | 0)));
      return (shallowlyMutableNodeMap | bitpos);
    }
  } else if (((this.cs & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().h1(this.cs, mask, bitpos);
    var subNode = this.iX(index$2);
    var subNodeSize = subNode.aa();
    var subNodeCachedJavaKeySetHashCode = subNode.dH();
    var returnNodeMap = shallowlyMutableNodeMap;
    matchEnd4: {
      var subNodeNew$3;
      if ((subNode instanceof $c_sci_BitmapIndexedSetNode)) {
        if (((bitpos & shallowlyMutableNodeMap) !== 0)) {
          subNode.a58(element, originalHash, elementHash, ((5 + shift) | 0), 0);
          var subNodeNew$3 = subNode;
          break matchEnd4;
        }
      }
      var subNodeNew$2 = subNode.Yc(element, originalHash, elementHash, ((5 + shift) | 0));
      if ((subNodeNew$2 !== subNode)) {
        returnNodeMap = (returnNodeMap | bitpos);
      }
      var subNodeNew$3 = subNodeNew$2;
    }
    this.dX.a[((((this.dX.a.length - 1) | 0) - this.r9(bitpos)) | 0)] = subNodeNew$3;
    this.cC = ((((this.cC - subNodeSize) | 0) + subNodeNew$3.aa()) | 0);
    this.fZ = ((((this.fZ - subNodeCachedJavaKeySetHashCode) | 0) + subNodeNew$3.dH()) | 0);
    return returnNodeMap;
  } else {
    var dataIx = this.kN(bitpos);
    var src = this.dX;
    var dst = new $ac_O(((1 + src.a.length) | 0));
    src.av(0, dst, 0, dataIx);
    dst.a[dataIx] = element;
    var destPos = ((1 + dataIx) | 0);
    var length = ((src.a.length - dataIx) | 0);
    src.av(dataIx, dst, destPos, length);
    var dstHashes = this.J2(this.eP, dataIx, originalHash);
    this.bI = (this.bI | bitpos);
    this.dX = dst;
    this.eP = dstHashes;
    this.cC = ((1 + this.cC) | 0);
    this.fZ = ((this.fZ + elementHash) | 0);
    return shallowlyMutableNodeMap;
  }
});
$p.a4u = (function(element, originalHash, elementHash, shift) {
  var mask = $m_sci_Node$().fR(elementHash, shift);
  var bitpos = $m_sci_Node$().d6(mask);
  if (((this.bI & bitpos) !== 0)) {
    var index = $m_sci_Node$().h1(this.bI, mask, bitpos);
    if ($m_sr_BoxesRunTime$().Q(this.e4(index), element)) {
      if ((($m_jl_Integer$().dz(this.bI) === 2) && ($m_jl_Integer$().dz(this.cs) === 0))) {
        var newDataMap = ((shift === 0) ? (this.bI ^ bitpos) : $m_sci_Node$().d6($m_sci_Node$().fR(elementHash, 0)));
        return ((index === 0) ? new $c_sci_BitmapIndexedSetNode(newDataMap, 0, new $ac_O([this.e4(1)]), new $ac_I(new Int32Array([this.eP.a[1]])), ((this.cC - 1) | 0), $m_sc_Hashing$().bz(this.eP.a[1])) : new $c_sci_BitmapIndexedSetNode(newDataMap, 0, new $ac_O([this.e4(0)]), new $ac_I(new Int32Array([this.eP.a[0]])), ((this.cC - 1) | 0), $m_sc_Hashing$().bz(this.eP.a[0])));
      } else {
        return this.aZe(bitpos, elementHash);
      }
    } else {
      return this;
    }
  } else if (((this.cs & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().h1(this.cs, mask, bitpos);
    var subNode = this.iX(index$2);
    var subNodeNew = subNode.a4v(element, originalHash, elementHash, ((5 + shift) | 0));
    if ((subNodeNew === subNode)) {
      return this;
    } else {
      var x1 = subNodeNew.aa();
      return ((x1 === 1) ? ((this.cC === subNode.aa()) ? subNodeNew : this.aZb(bitpos, elementHash, subNode, subNodeNew)) : ((x1 > 1) ? this.aN7(bitpos, subNode, subNodeNew) : this));
    }
  } else {
    return this;
  }
});
$p.aRA = (function(element, originalHash, elementHash) {
  var mask = $m_sci_Node$().fR(elementHash, 0);
  var bitpos = $m_sci_Node$().d6(mask);
  if (((this.bI & bitpos) !== 0)) {
    var index = $m_sci_Node$().h1(this.bI, mask, bitpos);
    if ($m_sr_BoxesRunTime$().Q(this.e4(index), element)) {
      if ((($m_jl_Integer$().dz(this.bI) === 2) && ($m_jl_Integer$().dz(this.cs) === 0))) {
        var newDataMap = (this.bI ^ bitpos);
        if ((index === 0)) {
          var newContent = new $ac_O([this.e4(1)]);
          var newOriginalHashes = new $ac_I(new Int32Array([this.eP.a[1]]));
          var newCachedJavaKeySetHashCode = $m_sc_Hashing$().bz(this.cK(1));
          this.dX = newContent;
          this.eP = newOriginalHashes;
          this.fZ = newCachedJavaKeySetHashCode;
        } else {
          var newContent$2 = new $ac_O([this.e4(0)]);
          var newOriginalHashes$2 = new $ac_I(new Int32Array([this.eP.a[0]]));
          var newCachedJavaKeySetHashCode$2 = $m_sc_Hashing$().bz(this.cK(0));
          this.dX = newContent$2;
          this.eP = newOriginalHashes$2;
          this.fZ = newCachedJavaKeySetHashCode$2;
        }
        this.bI = newDataMap;
        this.cs = 0;
        this.cC = 1;
        return this;
      } else {
        var dataIx = this.kN(bitpos);
        var src = this.dX;
        var dst = new $ac_O(((src.a.length - 1) | 0));
        src.av(0, dst, 0, dataIx);
        var srcPos = ((1 + dataIx) | 0);
        var length = ((((src.a.length - dataIx) | 0) - 1) | 0);
        src.av(srcPos, dst, dataIx, length);
        var dstHashes = this.Jh(this.eP, dataIx);
        this.bI = (this.bI ^ bitpos);
        this.dX = dst;
        this.eP = dstHashes;
        this.cC = ((this.cC - 1) | 0);
        this.fZ = ((this.fZ - elementHash) | 0);
        return this;
      }
    } else {
      return this;
    }
  } else if (((this.cs & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().h1(this.cs, mask, bitpos);
    var subNode = this.iX(index$2);
    var subNodeNew = subNode.a4v(element, originalHash, elementHash, 5);
    if ((subNodeNew === subNode)) {
      return this;
    }
    if ((subNodeNew.cC === 1)) {
      if ((($m_jl_Integer$().dz(this.bI) === 0) && ($m_jl_Integer$().dz(this.cs) === 1))) {
        this.bI = subNodeNew.bI;
        this.cs = subNodeNew.cs;
        this.dX = subNodeNew.dX;
        this.eP = subNodeNew.eP;
        this.cC = subNodeNew.cC;
        this.fZ = subNodeNew.fZ;
        return this;
      } else {
        this.b4s(bitpos, originalHash, elementHash, subNode, subNodeNew);
        return this;
      }
    } else {
      this.dX.a[((((this.dX.a.length - 1) | 0) - this.r9(bitpos)) | 0)] = subNodeNew;
      this.cC = ((this.cC - 1) | 0);
      this.fZ = ((((this.fZ - subNode.dH()) | 0) + subNodeNew.fZ) | 0);
      return this;
    }
  } else {
    return this;
  }
});
$p.Xw = (function(key0, originalKeyHash0, keyHash0, key1, originalKeyHash1, keyHash1, shift) {
  if ((shift >= 32)) {
    return new $c_sci_HashCollisionSetNode(originalKeyHash0, keyHash0, $m_sci_Vector$().X($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [key0, key1])));
  } else {
    var mask0 = $m_sci_Node$().fR(keyHash0, shift);
    var mask1 = $m_sci_Node$().fR(keyHash1, shift);
    if ((mask0 !== mask1)) {
      var dataMap = ($m_sci_Node$().d6(mask0) | $m_sci_Node$().d6(mask1));
      var newCachedHashCode = ((keyHash0 + keyHash1) | 0);
      return ((mask0 < mask1) ? new $c_sci_BitmapIndexedSetNode(dataMap, 0, new $ac_O([key0, key1]), new $ac_I(new Int32Array([originalKeyHash0, originalKeyHash1])), 2, newCachedHashCode) : new $c_sci_BitmapIndexedSetNode(dataMap, 0, new $ac_O([key1, key0]), new $ac_I(new Int32Array([originalKeyHash1, originalKeyHash0])), 2, newCachedHashCode));
    } else {
      var nodeMap = $m_sci_Node$().d6(mask0);
      var node = this.Xw(key0, originalKeyHash0, keyHash0, key1, originalKeyHash1, keyHash1, ((5 + shift) | 0));
      return new $c_sci_BitmapIndexedSetNode(0, nodeMap, new $ac_O([node]), $m_s_Array$EmptyArrays$().Uz, node.aa(), node.dH());
    }
  }
});
$p.Ps = (function() {
  return (this.bI !== 0);
});
$p.XI = (function() {
  return $m_jl_Integer$().dz(this.bI);
});
$p.X6 = (function() {
  return (this.cs !== 0);
});
$p.XA = (function() {
  return $m_jl_Integer$().dz(this.cs);
});
$p.kN = (function(bitpos) {
  return $m_jl_Integer$().dz((this.bI & ((bitpos - 1) | 0)));
});
$p.r9 = (function(bitpos) {
  return $m_jl_Integer$().dz((this.cs & ((bitpos - 1) | 0)));
});
$p.aN7 = (function(bitpos, oldNode, newNode) {
  var idx = ((((this.dX.a.length - 1) | 0) - this.r9(bitpos)) | 0);
  var src = this.dX;
  var dst = new $ac_O(src.a.length);
  var length = src.a.length;
  src.av(0, dst, 0, length);
  dst.a[idx] = newNode;
  return new $c_sci_BitmapIndexedSetNode(this.bI, this.cs, dst, this.eP, ((((this.cC - oldNode.aa()) | 0) + newNode.aa()) | 0), ((((this.fZ - oldNode.dH()) | 0) + newNode.dH()) | 0));
});
$p.aZ8 = (function(bitpos, key, originalHash, elementHash) {
  var dataIx = this.kN(bitpos);
  var src = this.dX;
  var dst = new $ac_O(((1 + src.a.length) | 0));
  src.av(0, dst, 0, dataIx);
  dst.a[dataIx] = key;
  var destPos = ((1 + dataIx) | 0);
  var length = ((src.a.length - dataIx) | 0);
  src.av(dataIx, dst, destPos, length);
  var dstHashes = this.J2(this.eP, dataIx, originalHash);
  return new $c_sci_BitmapIndexedSetNode((this.bI | bitpos), this.cs, dst, dstHashes, ((1 + this.cC) | 0), ((this.fZ + elementHash) | 0));
});
$p.aZe = (function(bitpos, elementHash) {
  var dataIx = this.kN(bitpos);
  var src = this.dX;
  var dst = new $ac_O(((src.a.length - 1) | 0));
  src.av(0, dst, 0, dataIx);
  var srcPos = ((1 + dataIx) | 0);
  var length = ((((src.a.length - dataIx) | 0) - 1) | 0);
  src.av(srcPos, dst, dataIx, length);
  var dstHashes = this.Jh(this.eP, dataIx);
  return new $c_sci_BitmapIndexedSetNode((this.bI ^ bitpos), this.cs, dst, dstHashes, ((this.cC - 1) | 0), ((this.fZ - elementHash) | 0));
});
$p.aZa = (function(bitpos, elementHash, node) {
  var dataIx = this.kN(bitpos);
  var idxNew = ((((this.dX.a.length - 1) | 0) - this.r9(bitpos)) | 0);
  var src = this.dX;
  var dst = new $ac_O(src.a.length);
  src.av(0, dst, 0, dataIx);
  var srcPos = ((1 + dataIx) | 0);
  var length = ((idxNew - dataIx) | 0);
  src.av(srcPos, dst, dataIx, length);
  dst.a[idxNew] = node;
  var srcPos$1 = ((1 + idxNew) | 0);
  var destPos = ((1 + idxNew) | 0);
  var length$1 = ((((src.a.length - idxNew) | 0) - 1) | 0);
  src.av(srcPos$1, dst, destPos, length$1);
  var dstHashes = this.Jh(this.eP, dataIx);
  return new $c_sci_BitmapIndexedSetNode((this.bI ^ bitpos), (this.cs | bitpos), dst, dstHashes, ((((this.cC - 1) | 0) + node.aa()) | 0), ((((this.fZ - elementHash) | 0) + node.dH()) | 0));
});
$p.aQl = (function(bitpos, keyHash, node) {
  var dataIx = this.kN(bitpos);
  var idxNew = ((((this.dX.a.length - 1) | 0) - this.r9(bitpos)) | 0);
  var src = this.dX;
  var srcPos = ((1 + dataIx) | 0);
  var dest = this.dX;
  var length = ((idxNew - dataIx) | 0);
  src.av(srcPos, dest, dataIx, length);
  this.dX.a[idxNew] = node;
  this.bI = (this.bI ^ bitpos);
  this.cs = (this.cs | bitpos);
  this.eP = this.Jh(this.eP, dataIx);
  this.cC = ((((this.cC - 1) | 0) + node.aa()) | 0);
  this.fZ = ((((this.fZ - keyHash) | 0) + node.dH()) | 0);
  return this;
});
$p.aZb = (function(bitpos, elementHash, oldNode, node) {
  var idxOld = ((((this.dX.a.length - 1) | 0) - this.r9(bitpos)) | 0);
  var dataIxNew = this.kN(bitpos);
  var src = this.dX;
  var dst = new $ac_O(src.a.length);
  src.av(0, dst, 0, dataIxNew);
  dst.a[dataIxNew] = node.e4(0);
  var destPos = ((1 + dataIxNew) | 0);
  var length = ((idxOld - dataIxNew) | 0);
  src.av(dataIxNew, dst, destPos, length);
  var srcPos = ((1 + idxOld) | 0);
  var destPos$1 = ((1 + idxOld) | 0);
  var length$1 = ((((src.a.length - idxOld) | 0) - 1) | 0);
  src.av(srcPos, dst, destPos$1, length$1);
  var hash = node.cK(0);
  var dstHashes = this.J2(this.eP, dataIxNew, hash);
  return new $c_sci_BitmapIndexedSetNode((this.bI | bitpos), (this.cs ^ bitpos), dst, dstHashes, ((1 + ((this.cC - oldNode.aa()) | 0)) | 0), ((((this.fZ - oldNode.dH()) | 0) + node.dH()) | 0));
});
$p.b4s = (function(bitpos, originalHash, elementHash, oldNode, node) {
  var idxOld = ((((this.dX.a.length - 1) | 0) - this.r9(bitpos)) | 0);
  var dataIxNew = this.kN(bitpos);
  var element = node.e4(0);
  var src = this.dX;
  var dest = this.dX;
  var destPos = ((1 + dataIxNew) | 0);
  var length = ((idxOld - dataIxNew) | 0);
  src.av(dataIxNew, dest, destPos, length);
  this.dX.a[dataIxNew] = element;
  var hash = node.cK(0);
  var dstHashes = this.J2(this.eP, dataIxNew, hash);
  this.bI = (this.bI | bitpos);
  this.cs = (this.cs ^ bitpos);
  this.eP = dstHashes;
  this.cC = ((1 + ((this.cC - oldNode.aa()) | 0)) | 0);
  this.fZ = ((((this.fZ - oldNode.dH()) | 0) + node.dH()) | 0);
});
$p.F = (function(f) {
  var thisPayloadArity = $m_jl_Integer$().dz(this.bI);
  var i$1 = 0;
  while ((i$1 < thisPayloadArity)) {
    f.i(this.e4(i$1));
    i$1 = ((1 + i$1) | 0);
  }
  var thisNodeArity = $m_jl_Integer$().dz(this.cs);
  var j = 0;
  while ((j < thisNodeArity)) {
    this.iX(j).F(f);
    j = ((1 + j) | 0);
  }
});
$p.aib = (function(that, shift) {
  if ((this === that)) {
    return true;
  } else if ((!(that instanceof $c_sci_HashCollisionSetNode))) {
    if ((!(that instanceof $c_sci_BitmapIndexedSetNode))) {
      throw new $c_s_MatchError(that);
    }
    var thisBitmap = (this.bI | this.cs);
    var nodeBitmap = (that.bI | that.cs);
    if (((thisBitmap | nodeBitmap) !== nodeBitmap)) {
      return false;
    }
    var bitmap = (thisBitmap & nodeBitmap);
    var i = bitmap;
    var bitsToSkip = ((32 - Math.clz32(((~i) & ((i - 1) | 0)))) | 0);
    var isValidSubset = true;
    while ((isValidSubset && (bitsToSkip < 32))) {
      var bitpos = $m_sci_Node$().d6(bitsToSkip);
      if (((this.bI & bitpos) !== 0)) {
        if (((that.bI & bitpos) !== 0)) {
          isValidSubset = $m_sr_BoxesRunTime$().Q(this.e4($m_sci_Node$().w6(this.bI, bitpos)), that.e4($m_sci_Node$().w6(that.bI, bitpos)));
        } else {
          var thisDataIndex = $m_sci_Node$().w6(this.bI, bitpos);
          var payload = this.e4(thisDataIndex);
          var subNode = that.iX($m_sci_Node$().w6(that.cs, bitpos));
          var elementUnimprovedHash = this.cK(thisDataIndex);
          var elementHash = $m_sc_Hashing$().bz(elementUnimprovedHash);
          isValidSubset = subNode.Ai(payload, elementUnimprovedHash, elementHash, ((5 + shift) | 0));
        }
      } else if (((that.bI & bitpos) === 0)) {
        var subNode0 = this.iX($m_sci_Node$().w6(this.cs, bitpos));
        var subNode1 = that.iX($m_sci_Node$().w6(that.cs, bitpos));
        isValidSubset = subNode0.aib(subNode1, ((5 + shift) | 0));
      } else {
        isValidSubset = false;
      }
      var newBitmap = (bitmap ^ bitpos);
      bitmap = newBitmap;
      bitsToSkip = ((32 - Math.clz32(((~newBitmap) & ((newBitmap - 1) | 0)))) | 0);
    }
    return isValidSubset;
  } else {
    return false;
  }
});
$p.aO4 = (function(pred, flipped) {
  if ((this.cC === 0)) {
    return this;
  } else if ((this.cC === 1)) {
    return (((!(!pred.i(this.e4(0)))) !== flipped) ? this : $m_sci_SetNode$().HG);
  } else if ((this.cs === 0)) {
    var i = this.bI;
    var minimumIndex = ((32 - Math.clz32(((~i) & ((i - 1) | 0)))) | 0);
    var maximumIndex = ((32 - Math.clz32(this.bI)) | 0);
    var newDataMap = 0;
    var newCachedHashCode = 0;
    var dataIndex = 0;
    var i$3 = minimumIndex;
    while ((i$3 < maximumIndex)) {
      var bitpos = $m_sci_Node$().d6(i$3);
      if (((bitpos & this.bI) !== 0)) {
        var payload = this.e4(dataIndex);
        if (((!(!pred.i(payload))) !== flipped)) {
          newDataMap = (newDataMap | bitpos);
          newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().bz(this.cK(dataIndex))) | 0);
        }
        dataIndex = ((1 + dataIndex) | 0);
      }
      i$3 = ((1 + i$3) | 0);
    }
    if ((newDataMap === 0)) {
      return $m_sci_SetNode$().HG;
    } else if ((newDataMap === this.bI)) {
      return this;
    } else {
      var newSize = $m_jl_Integer$().dz(newDataMap);
      var newContent = new $ac_O(newSize);
      var newOriginalHashCodes = new $ac_I(newSize);
      var newMaximumIndex = ((32 - Math.clz32(newDataMap)) | 0);
      var i$6 = newDataMap;
      var j = ((32 - Math.clz32(((~i$6) & ((i$6 - 1) | 0)))) | 0);
      var newDataIndex = 0;
      while ((j < newMaximumIndex)) {
        var bitpos$2 = $m_sci_Node$().d6(j);
        if (((bitpos$2 & newDataMap) !== 0)) {
          var oldIndex = $m_sci_Node$().w6(this.bI, bitpos$2);
          newContent.a[newDataIndex] = this.dX.a[oldIndex];
          newOriginalHashCodes.a[newDataIndex] = this.eP.a[oldIndex];
          newDataIndex = ((1 + newDataIndex) | 0);
        }
        j = ((1 + j) | 0);
      }
      return new $c_sci_BitmapIndexedSetNode(newDataMap, 0, newContent, newOriginalHashCodes, newSize, newCachedHashCode);
    }
  } else {
    var allMap = (this.bI | this.cs);
    var minimumIndex$2 = ((32 - Math.clz32(((~allMap) & ((allMap - 1) | 0)))) | 0);
    var maximumIndex$2 = ((32 - Math.clz32(allMap)) | 0);
    var oldDataPassThrough = 0;
    var nodeMigrateToDataTargetMap = 0;
    var nodesToMigrateToData = null;
    var nodesToPassThroughMap = 0;
    var mapOfNewNodes = 0;
    var newNodes = null;
    var newDataMap$2 = 0;
    var newNodeMap = 0;
    var newSize$2 = 0;
    var newCachedHashCode$2 = 0;
    var dataIndex$2 = 0;
    var nodeIndex = 0;
    var i$2$1 = minimumIndex$2;
    while ((i$2$1 < maximumIndex$2)) {
      var bitpos$3 = $m_sci_Node$().d6(i$2$1);
      if (((bitpos$3 & this.bI) !== 0)) {
        var payload$2 = this.e4(dataIndex$2);
        if (((!(!pred.i(payload$2))) !== flipped)) {
          newDataMap$2 = (newDataMap$2 | bitpos$3);
          oldDataPassThrough = (oldDataPassThrough | bitpos$3);
          newSize$2 = ((1 + newSize$2) | 0);
          newCachedHashCode$2 = ((newCachedHashCode$2 + $m_sc_Hashing$().bz(this.cK(dataIndex$2))) | 0);
        }
        dataIndex$2 = ((1 + dataIndex$2) | 0);
      } else if (((bitpos$3 & this.cs) !== 0)) {
        var oldSubNode = this.iX(nodeIndex);
        var newSubNode = oldSubNode.afL(pred, flipped);
        newSize$2 = ((newSize$2 + newSubNode.aa()) | 0);
        newCachedHashCode$2 = ((newCachedHashCode$2 + newSubNode.dH()) | 0);
        if ((newSubNode.aa() > 1)) {
          newNodeMap = (newNodeMap | bitpos$3);
          if ((oldSubNode === newSubNode)) {
            nodesToPassThroughMap = (nodesToPassThroughMap | bitpos$3);
          } else {
            mapOfNewNodes = (mapOfNewNodes | bitpos$3);
            if ((newNodes === null)) {
              newNodes = $ct_scm_Queue__I__(new $c_scm_Queue(), 16);
            }
            newNodes.km(newSubNode);
          }
        } else if ((newSubNode.aa() === 1)) {
          newDataMap$2 = (newDataMap$2 | bitpos$3);
          nodeMigrateToDataTargetMap = (nodeMigrateToDataTargetMap | bitpos$3);
          if ((nodesToMigrateToData === null)) {
            nodesToMigrateToData = $ct_scm_Queue__I__(new $c_scm_Queue(), 16);
          }
          nodesToMigrateToData.km(newSubNode);
        }
        nodeIndex = ((1 + nodeIndex) | 0);
      }
      i$2$1 = ((1 + i$2$1) | 0);
    }
    return $p_sci_BitmapIndexedSetNode__newNodeFrom__I__I__I__I__I__I__I__scm_Queue__I__scm_Queue__I__sci_BitmapIndexedSetNode(this, newSize$2, newDataMap$2, newNodeMap, minimumIndex$2, oldDataPassThrough, nodesToPassThroughMap, nodeMigrateToDataTargetMap, nodesToMigrateToData, mapOfNewNodes, newNodes, newCachedHashCode$2);
  }
});
$p.afj = (function(that, shift) {
  if ((that instanceof $c_sci_BitmapIndexedSetNode)) {
    if ((this.cC === 0)) {
      return this;
    } else if ((this.cC === 1)) {
      var h = this.cK(0);
      return (that.Ai(this.e4(0), h, $m_sc_Hashing$().bz(h), shift) ? $m_sci_SetNode$().HG : this);
    } else {
      var allMap = (this.bI | this.cs);
      var minimumIndex = ((32 - Math.clz32(((~allMap) & ((allMap - 1) | 0)))) | 0);
      var maximumIndex = ((32 - Math.clz32(allMap)) | 0);
      var oldDataPassThrough = 0;
      var nodeMigrateToDataTargetMap = 0;
      var nodesToMigrateToData = null;
      var nodesToPassThroughMap = 0;
      var mapOfNewNodes = 0;
      var newNodes = null;
      var newDataMap = 0;
      var newNodeMap = 0;
      var newSize = 0;
      var newCachedHashCode = 0;
      var dataIndex = 0;
      var nodeIndex = 0;
      var i$1 = minimumIndex;
      while ((i$1 < maximumIndex)) {
        var bitpos = $m_sci_Node$().d6(i$1);
        if (((bitpos & this.bI) !== 0)) {
          var payload = this.e4(dataIndex);
          var originalHash = this.cK(dataIndex);
          var hash = $m_sc_Hashing$().bz(originalHash);
          if ((!that.Ai(payload, originalHash, hash, shift))) {
            newDataMap = (newDataMap | bitpos);
            oldDataPassThrough = (oldDataPassThrough | bitpos);
            newSize = ((1 + newSize) | 0);
            newCachedHashCode = ((newCachedHashCode + hash) | 0);
          }
          dataIndex = ((1 + dataIndex) | 0);
        } else if (((bitpos & this.cs) !== 0)) {
          var oldSubNode = this.iX(nodeIndex);
          if (((bitpos & that.bI) !== 0)) {
            var thatDataIndex = $m_sci_Node$().w6(that.bI, bitpos);
            var thatPayload = that.e4(thatDataIndex);
            var thatOriginalHash = that.cK(thatDataIndex);
            var thatHash = $m_sc_Hashing$().bz(thatOriginalHash);
            var newSubNode = oldSubNode.a4v(thatPayload, thatOriginalHash, thatHash, ((5 + shift) | 0));
          } else {
            var newSubNode = (((bitpos & that.cs) !== 0) ? oldSubNode.aNq(that.iX($m_sci_Node$().w6(that.cs, bitpos)), ((5 + shift) | 0)) : oldSubNode);
          }
          newSize = ((newSize + newSubNode.aa()) | 0);
          newCachedHashCode = ((newCachedHashCode + newSubNode.dH()) | 0);
          if ((newSubNode.aa() > 1)) {
            newNodeMap = (newNodeMap | bitpos);
            if ((oldSubNode === newSubNode)) {
              nodesToPassThroughMap = (nodesToPassThroughMap | bitpos);
            } else {
              mapOfNewNodes = (mapOfNewNodes | bitpos);
              if ((newNodes === null)) {
                newNodes = $ct_scm_Queue__I__(new $c_scm_Queue(), 16);
              }
              newNodes.km(newSubNode);
            }
          } else if ((newSubNode.aa() === 1)) {
            newDataMap = (newDataMap | bitpos);
            nodeMigrateToDataTargetMap = (nodeMigrateToDataTargetMap | bitpos);
            if ((nodesToMigrateToData === null)) {
              nodesToMigrateToData = $ct_scm_Queue__I__(new $c_scm_Queue(), 16);
            }
            nodesToMigrateToData.km(newSubNode);
          }
          nodeIndex = ((1 + nodeIndex) | 0);
        }
        i$1 = ((1 + i$1) | 0);
      }
      return $p_sci_BitmapIndexedSetNode__newNodeFrom__I__I__I__I__I__I__I__scm_Queue__I__scm_Queue__I__sci_BitmapIndexedSetNode(this, newSize, newDataMap, newNodeMap, minimumIndex, oldDataPassThrough, nodesToPassThroughMap, nodeMigrateToDataTargetMap, nodesToMigrateToData, mapOfNewNodes, newNodes, newCachedHashCode);
    }
  } else if ((that instanceof $c_sci_HashCollisionSetNode)) {
    throw $ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), "BitmapIndexedSetNode diff HashCollisionSetNode");
  } else {
    throw new $c_s_MatchError(that);
  }
});
$p.e = (function(that) {
  if ((that instanceof $c_sci_BitmapIndexedSetNode)) {
    if ((this === that)) {
      return true;
    } else if ((((((this.fZ === that.fZ) && (this.cs === that.cs)) && (this.bI === that.bI)) && (this.cC === that.cC)) && $m_ju_Arrays$().a3h(this.eP, that.eP))) {
      var a1 = this.dX;
      var a2 = that.dX;
      var length = this.dX.a.length;
      if ((a1 === a2)) {
        return true;
      } else {
        var isEqual = true;
        var i = 0;
        while ((isEqual && (i < length))) {
          isEqual = $m_sr_BoxesRunTime$().Q(a1.a[i], a2.a[i]);
          i = ((1 + i) | 0);
        }
        return isEqual;
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.x = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Trie nodes do not support hashing.");
});
$p.m = (function() {
  return $m_sc_StringOps$().u0("BitmapIndexedSetNode(size=%s, dataMap=%x, nodeMap=%x)", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [this.cC, this.bI, this.cs]));
});
$p.aN3 = (function() {
  var this$1 = this.dX;
  var contentClone = this$1.ae();
  var contentLength = contentClone.a.length;
  var i$1 = $m_jl_Integer$().dz(this.bI);
  while ((i$1 < contentLength)) {
    contentClone.a[i$1] = contentClone.a[i$1].aN5();
    i$1 = ((1 + i$1) | 0);
  }
  return new $c_sci_BitmapIndexedSetNode(this.bI, this.cs, contentClone, this.eP.ae(), this.cC, this.fZ);
});
$p.aMW = (function(that, shift) {
  if ((that instanceof $c_sci_BitmapIndexedSetNode)) {
    if ((this.cC === 0)) {
      return that;
    } else if (((that.cC === 0) || (that === this))) {
      return this;
    } else if ((that.cC === 1)) {
      var originalHash = that.cK(0);
      return this.Q7(that.e4(0), originalHash, $m_sc_Hashing$().bz(originalHash), shift);
    }
    var anyChangesMadeSoFar = false;
    var allMap = (((this.bI | that.bI) | this.cs) | that.cs);
    var minimumBitPos = $m_sci_Node$().d6(((32 - Math.clz32(((~allMap) & ((allMap - 1) | 0)))) | 0));
    var maximumBitPos = $m_sci_Node$().d6(((31 - Math.clz32(allMap)) | 0));
    var leftNodeRightNode = 0;
    var leftDataRightNode = 0;
    var leftNodeRightData = 0;
    var leftDataOnly = 0;
    var rightDataOnly = 0;
    var leftNodeOnly = 0;
    var rightNodeOnly = 0;
    var leftDataRightDataMigrateToNode = 0;
    var leftDataRightDataLeftOverwrites = 0;
    var dataToNodeMigrationTargets = 0;
    var bitpos = minimumBitPos;
    var leftIdx = 0;
    var rightIdx = 0;
    var finished = false;
    while ((!finished)) {
      if (((bitpos & this.bI) !== 0)) {
        if (((bitpos & that.bI) !== 0)) {
          if (((this.cK(leftIdx) === that.cK(rightIdx)) && $m_sr_BoxesRunTime$().Q(this.e4(leftIdx), that.e4(rightIdx)))) {
            leftDataRightDataLeftOverwrites = (leftDataRightDataLeftOverwrites | bitpos);
          } else {
            leftDataRightDataMigrateToNode = (leftDataRightDataMigrateToNode | bitpos);
            dataToNodeMigrationTargets = (dataToNodeMigrationTargets | $m_sci_Node$().d6($m_sci_Node$().fR($m_sc_Hashing$().bz(this.cK(leftIdx)), shift)));
          }
          rightIdx = ((1 + rightIdx) | 0);
        } else if (((bitpos & that.cs) !== 0)) {
          leftDataRightNode = (leftDataRightNode | bitpos);
        } else {
          leftDataOnly = (leftDataOnly | bitpos);
        }
        leftIdx = ((1 + leftIdx) | 0);
      } else if (((bitpos & this.cs) !== 0)) {
        if (((bitpos & that.bI) !== 0)) {
          leftNodeRightData = (leftNodeRightData | bitpos);
          rightIdx = ((1 + rightIdx) | 0);
        } else if (((bitpos & that.cs) !== 0)) {
          leftNodeRightNode = (leftNodeRightNode | bitpos);
        } else {
          leftNodeOnly = (leftNodeOnly | bitpos);
        }
      } else if (((bitpos & that.bI) !== 0)) {
        rightDataOnly = (rightDataOnly | bitpos);
        rightIdx = ((1 + rightIdx) | 0);
      } else if (((bitpos & that.cs) !== 0)) {
        rightNodeOnly = (rightNodeOnly | bitpos);
      }
      if ((bitpos === maximumBitPos)) {
        finished = true;
      } else {
        bitpos = (bitpos << 1);
      }
    }
    var newDataMap = ((leftDataOnly | rightDataOnly) | leftDataRightDataLeftOverwrites);
    var newNodeMap = (((((leftNodeRightNode | leftDataRightNode) | leftNodeRightData) | leftNodeOnly) | rightNodeOnly) | dataToNodeMigrationTargets);
    if (((newDataMap === (leftDataOnly | leftDataRightDataLeftOverwrites)) && (newNodeMap === leftNodeOnly))) {
      return this;
    }
    var newDataSize = $m_jl_Integer$().dz(newDataMap);
    var newContentSize = ((newDataSize + $m_jl_Integer$().dz(newNodeMap)) | 0);
    var newContent = new $ac_O(newContentSize);
    var newOriginalHashes = new $ac_I(newDataSize);
    var newSize = 0;
    var newCachedHashCode = 0;
    var leftDataIdx = 0;
    var rightDataIdx = 0;
    var leftNodeIdx = 0;
    var rightNodeIdx = 0;
    var nextShift = ((5 + shift) | 0);
    var compressedDataIdx = 0;
    var compressedNodeIdx = 0;
    var bitpos$2 = minimumBitPos;
    var finished$2 = false;
    while ((!finished$2)) {
      if (((bitpos$2 & leftNodeRightNode) !== 0)) {
        var leftNode = this.iX(leftNodeIdx);
        var newNode = leftNode.aMX(that.iX(rightNodeIdx), nextShift);
        if ((leftNode !== newNode)) {
          anyChangesMadeSoFar = true;
        }
        newContent.a[((((newContentSize - compressedNodeIdx) | 0) - 1) | 0)] = newNode;
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        rightNodeIdx = ((1 + rightNodeIdx) | 0);
        leftNodeIdx = ((1 + leftNodeIdx) | 0);
        newSize = ((newSize + newNode.aa()) | 0);
        newCachedHashCode = ((newCachedHashCode + newNode.dH()) | 0);
      } else if (((bitpos$2 & leftDataRightNode) !== 0)) {
        anyChangesMadeSoFar = true;
        var n = that.iX(rightNodeIdx);
        var leftPayload = this.e4(leftDataIdx);
        var leftOriginalHash = this.cK(leftDataIdx);
        var leftImproved = $m_sc_Hashing$().bz(leftOriginalHash);
        var newNode$2 = n.Yc(leftPayload, leftOriginalHash, leftImproved, nextShift);
        newContent.a[((((newContentSize - compressedNodeIdx) | 0) - 1) | 0)] = newNode$2;
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        rightNodeIdx = ((1 + rightNodeIdx) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
        newSize = ((newSize + newNode$2.aa()) | 0);
        newCachedHashCode = ((newCachedHashCode + newNode$2.dH()) | 0);
      } else if (((bitpos$2 & leftNodeRightData) !== 0)) {
        var rightOriginalHash = that.cK(rightDataIdx);
        var leftNode$2 = this.iX(leftNodeIdx);
        var updated = leftNode$2.Yc(that.e4(rightDataIdx), that.cK(rightDataIdx), $m_sc_Hashing$().bz(rightOriginalHash), nextShift);
        if ((updated !== leftNode$2)) {
          anyChangesMadeSoFar = true;
        }
        newContent.a[((((newContentSize - compressedNodeIdx) | 0) - 1) | 0)] = updated;
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        leftNodeIdx = ((1 + leftNodeIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((newSize + updated.aa()) | 0);
        newCachedHashCode = ((newCachedHashCode + updated.dH()) | 0);
      } else if (((bitpos$2 & leftDataOnly) !== 0)) {
        var originalHash$2 = this.eP.a[leftDataIdx];
        newContent.a[compressedDataIdx] = this.e4(leftDataIdx);
        newOriginalHashes.a[compressedDataIdx] = originalHash$2;
        compressedDataIdx = ((1 + compressedDataIdx) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
        newSize = ((1 + newSize) | 0);
        newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().bz(originalHash$2)) | 0);
      } else if (((bitpos$2 & rightDataOnly) !== 0)) {
        anyChangesMadeSoFar = true;
        var originalHash$3 = that.eP.a[rightDataIdx];
        newContent.a[compressedDataIdx] = that.e4(rightDataIdx);
        newOriginalHashes.a[compressedDataIdx] = originalHash$3;
        compressedDataIdx = ((1 + compressedDataIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((1 + newSize) | 0);
        newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().bz(originalHash$3)) | 0);
      } else if (((bitpos$2 & leftNodeOnly) !== 0)) {
        var newNode$4 = this.iX(leftNodeIdx);
        newContent.a[((((newContentSize - compressedNodeIdx) | 0) - 1) | 0)] = newNode$4;
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        leftNodeIdx = ((1 + leftNodeIdx) | 0);
        newSize = ((newSize + newNode$4.aa()) | 0);
        newCachedHashCode = ((newCachedHashCode + newNode$4.dH()) | 0);
      } else if (((bitpos$2 & rightNodeOnly) !== 0)) {
        anyChangesMadeSoFar = true;
        var newNode$5 = that.iX(rightNodeIdx);
        newContent.a[((((newContentSize - compressedNodeIdx) | 0) - 1) | 0)] = newNode$5;
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        rightNodeIdx = ((1 + rightNodeIdx) | 0);
        newSize = ((newSize + newNode$5.aa()) | 0);
        newCachedHashCode = ((newCachedHashCode + newNode$5.dH()) | 0);
      } else if (((bitpos$2 & leftDataRightDataMigrateToNode) !== 0)) {
        anyChangesMadeSoFar = true;
        var leftOriginalHash$2 = this.cK(leftDataIdx);
        var rightOriginalHash$2 = that.cK(rightDataIdx);
        var newNode$6 = that.Xw(this.e4(leftDataIdx), leftOriginalHash$2, $m_sc_Hashing$().bz(leftOriginalHash$2), that.e4(rightDataIdx), rightOriginalHash$2, $m_sc_Hashing$().bz(rightOriginalHash$2), nextShift);
        newContent.a[((((newContentSize - compressedNodeIdx) | 0) - 1) | 0)] = newNode$6;
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((newSize + newNode$6.aa()) | 0);
        newCachedHashCode = ((newCachedHashCode + newNode$6.dH()) | 0);
      } else if (((bitpos$2 & leftDataRightDataLeftOverwrites) !== 0)) {
        var originalHash$4 = that.eP.a[rightDataIdx];
        newContent.a[compressedDataIdx] = that.e4(rightDataIdx);
        newOriginalHashes.a[compressedDataIdx] = originalHash$4;
        compressedDataIdx = ((1 + compressedDataIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((1 + newSize) | 0);
        newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().bz(originalHash$4)) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
      }
      if ((bitpos$2 === maximumBitPos)) {
        finished$2 = true;
      } else {
        bitpos$2 = (bitpos$2 << 1);
      }
    }
    return (anyChangesMadeSoFar ? new $c_sci_BitmapIndexedSetNode(newDataMap, newNodeMap, newContent, newOriginalHashes, newSize, newCachedHashCode) : this);
  } else {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Cannot concatenate a HashCollisionSetNode with a BitmapIndexedSetNode");
  }
});
$p.afV = (function(f) {
  var iN = $m_jl_Integer$().dz(this.bI);
  var i$1 = 0;
  while ((i$1 < iN)) {
    f.R(this.e4(i$1), this.cK(i$1));
    i$1 = ((1 + i$1) | 0);
  }
  var jN = $m_jl_Integer$().dz(this.cs);
  var j = 0;
  while ((j < jN)) {
    this.iX(j).afV(f);
    j = ((1 + j) | 0);
  }
});
$p.aMX = (function(that, shift) {
  return this.aMW(that, shift);
});
$p.aN5 = (function() {
  return this.aN3();
});
$p.aNq = (function(that, shift) {
  return this.afj(that, shift);
});
$p.afL = (function(pred, flipped) {
  return this.aO4(pred, flipped);
});
$p.a4v = (function(element, originalHash, hash, shift) {
  return this.a4u(element, originalHash, hash, shift);
});
$p.Yc = (function(element, originalHash, hash, shift) {
  return this.Q7(element, originalHash, hash, shift);
});
$p.X1 = (function(index) {
  return this.iX(index);
});
function $isArrayOf_sci_BitmapIndexedSetNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.l7)));
}
var $d_sci_BitmapIndexedSetNode = new $TypeData().i($c_sci_BitmapIndexedSetNode, "scala.collection.immutable.BitmapIndexedSetNode", ({
  l7: 1,
  lo: 1,
  c1: 1
}));
/** @constructor */
function $c_sci_HashCollisionMapNode(originalHash, hash, content) {
  this.CY = 0;
  this.qz = 0;
  this.fI = null;
  this.CY = originalHash;
  this.qz = hash;
  this.fI = content;
  $m_s_Predef$().PQ((this.fI.C() >= 2));
}
$p = $c_sci_HashCollisionMapNode.prototype = new $h_sci_MapNode();
$p.constructor = $c_sci_HashCollisionMapNode;
/** @constructor */
function $h_sci_HashCollisionMapNode() {
}
$h_sci_HashCollisionMapNode.prototype = $p;
$p.J1 = (function(key) {
  var iter = this.fI.o();
  var i = 0;
  while (iter.p()) {
    if ($m_sr_BoxesRunTime$().Q(iter.q().g(), key)) {
      return i;
    }
    i = ((1 + i) | 0);
  }
  return (-1);
});
$p.aa = (function() {
  return this.fI.C();
});
$p.aeI = (function(key, originalHash, hash, shift) {
  var this$1 = this.a3y(key, originalHash, hash, shift);
  if (this$1.c()) {
    $m_sc_Iterator$().b8.q();
    throw new $c_jl_ClassCastException();
  } else {
    return this$1.d();
  }
});
$p.a3y = (function(key, originalHash, hash, shift) {
  if ((this.qz === hash)) {
    var index = this.J1(key);
    return ((index >= 0) ? new $c_s_Some(this.fI.l(index).h()) : $m_s_None$());
  } else {
    return $m_s_None$();
  }
});
$p.a3B = (function(key, originalHash, hash, shift, f) {
  if ((this.qz === hash)) {
    var x1 = this.J1(key);
    return ((x1 === (-1)) ? f.a3() : this.fI.l(x1).h());
  } else {
    return f.a3();
  }
});
$p.a30 = (function(key, originalHash, hash, shift) {
  return ((this.qz === hash) && (this.J1(key) >= 0));
});
$p.Yd = (function(key, value, originalHash, hash, shift, replaceValue) {
  var index = this.J1(key);
  return ((index >= 0) ? (replaceValue ? (Object.is(this.fI.l(index).h(), value) ? this : new $c_sci_HashCollisionMapNode(originalHash, hash, this.fI.nI(index, new $c_T2(key, value)))) : this) : new $c_sci_HashCollisionMapNode(originalHash, hash, this.fI.lg(new $c_T2(key, value))));
});
$p.aRB = (function(key, originalHash, hash, shift) {
  if ((!this.a30(key, originalHash, hash, shift))) {
    return this;
  } else {
    var updatedContent = this.fI.d8(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((keyValuePair$2$2) => $m_sr_BoxesRunTime$().Q(keyValuePair$2$2.g(), key))), true);
    if ((updatedContent.C() === 1)) {
      var x1$2 = updatedContent.l(0);
      if ((x1$2 === null)) {
        throw new $c_s_MatchError(x1$2);
      }
      var k = x1$2.g();
      var v = x1$2.h();
      return new $c_sci_BitmapIndexedMapNode($m_sci_Node$().d6($m_sci_Node$().fR(hash, 0)), 0, new $ac_O([k, v]), new $ac_I(new Int32Array([originalHash])), 1, hash);
    } else {
      return new $c_sci_HashCollisionMapNode(originalHash, hash, updatedContent);
    }
  }
});
$p.X6 = (function() {
  return false;
});
$p.XA = (function() {
  return 0;
});
$p.jp = (function(index) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), "No sub-nodes present in hash-collision leaf node.");
});
$p.Ps = (function() {
  return true;
});
$p.XI = (function() {
  return this.fI.C();
});
$p.gy = (function(index) {
  return this.fI.l(index).g();
});
$p.h0 = (function(index) {
  return this.fI.l(index).h();
});
$p.IZ = (function(index) {
  return this.fI.l(index);
});
$p.cK = (function(index) {
  return this.CY;
});
$p.F = (function(f) {
  this.fI.F(f);
});
$p.pu = (function(f) {
  this.fI.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x0$1$2$2) => {
    if ((x0$1$2$2 !== null)) {
      var k = x0$1$2$2.g();
      var v = x0$1$2$2.h();
      return f.R(k, v);
    } else {
      throw new $c_s_MatchError(x0$1$2$2);
    }
  })));
});
$p.afW = (function(f) {
  var iter = this.fI.o();
  while (iter.p()) {
    var next = iter.q();
    f.DH(next.g(), next.h(), this.CY);
  }
});
$p.bar = (function(f) {
  $m_sci_Vector$();
  var newContent = new $c_sci_VectorBuilder();
  var contentIter = this.fI.o();
  var anyChanges = false;
  while (contentIter.p()) {
    var x1 = contentIter.q();
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1);
    }
    var k = x1.g();
    var v = x1.h();
    var newValue = f.R(k, v);
    newContent.ck(new $c_T2(k, newValue));
    anyChanges = (anyChanges || (!Object.is(v, newValue)));
  }
  return (anyChanges ? new $c_sci_HashCollisionMapNode(this.CY, this.qz, newContent.bY()) : this);
});
$p.e = (function(that) {
  if ((that instanceof $c_sci_HashCollisionMapNode)) {
    if ((this === that)) {
      return true;
    } else if (((this.qz === that.qz) && (this.fI.C() === that.fI.C()))) {
      var iter = this.fI.o();
      while (iter.p()) {
        var x1$2 = iter.q();
        if ((x1$2 === null)) {
          throw new $c_s_MatchError(x1$2);
        }
        var key = x1$2.g();
        var value = x1$2.h();
        var index = that.J1(key);
        if (((index < 0) || (!$m_sr_BoxesRunTime$().Q(value, that.fI.l(index).h())))) {
          return false;
        }
      }
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.aYW = (function(that, shift) {
  if ((that instanceof $c_sci_HashCollisionMapNode)) {
    if ((that === this)) {
      return this;
    } else {
      var newContent = null;
      var iter = this.fI.o();
      while (iter.p()) {
        var nextPayload = iter.q();
        if ((that.J1(nextPayload.g()) < 0)) {
          if ((newContent === null)) {
            newContent = new $c_sci_VectorBuilder();
            newContent.fO(that.fI);
          }
          newContent.ck(nextPayload);
        }
      }
      return ((newContent === null) ? that : new $c_sci_HashCollisionMapNode(this.CY, this.qz, newContent.bY()));
    }
  } else if ((that instanceof $c_sci_BitmapIndexedMapNode)) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Cannot concatenate a HashCollisionMapNode with a BitmapIndexedMapNode");
  } else {
    throw new $c_s_MatchError(that);
  }
});
$p.aO5 = (function(pred, flipped) {
  var newContent = this.fI.d8(pred, flipped);
  var newContentLength = newContent.C();
  if ((newContentLength === 0)) {
    return $m_sci_MapNode$().NY;
  } else if ((newContentLength === 1)) {
    var x1 = newContent.t();
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1);
    }
    var k = x1.g();
    var v = x1.h();
    return new $c_sci_BitmapIndexedMapNode($m_sci_Node$().d6($m_sci_Node$().fR(this.qz, 0)), 0, new $ac_O([k, v]), new $ac_I(new Int32Array([this.CY])), 1, this.qz);
  } else {
    return ((newContentLength === this.fI.C()) ? this : new $c_sci_HashCollisionMapNode(this.CY, this.qz, newContent));
  }
});
$p.x = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Trie nodes do not support hashing.");
});
$p.m = (function() {
  var i = $systemIdentityHashCode(this);
  return (($objectClassName(this) + "@") + (i >>> 0.0).toString(16));
});
$p.dH = (function() {
  return Math.imul(this.fI.C(), this.qz);
});
$p.aN4 = (function() {
  return new $c_sci_HashCollisionMapNode(this.CY, this.qz, this.fI);
});
$p.aMV = (function(that, shift) {
  return this.aYW(that, shift);
});
$p.aT2 = (function(f) {
  return this.bar(f);
});
$p.X1 = (function(index) {
  return this.jp(index);
});
function $isArrayOf_sci_HashCollisionMapNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.l8)));
}
var $d_sci_HashCollisionMapNode = new $TypeData().i($c_sci_HashCollisionMapNode, "scala.collection.immutable.HashCollisionMapNode", ({
  l8: 1,
  li: 1,
  c1: 1
}));
/** @constructor */
function $c_sci_HashCollisionSetNode(originalHash, hash, content) {
  this.CZ = 0;
  this.vz = 0;
  this.gh = null;
  this.CZ = originalHash;
  this.vz = hash;
  this.gh = content;
  $m_s_Predef$().PQ((this.gh.C() >= 2));
}
$p = $c_sci_HashCollisionSetNode.prototype = new $h_sci_SetNode();
$p.constructor = $c_sci_HashCollisionSetNode;
/** @constructor */
function $h_sci_HashCollisionSetNode() {
}
$h_sci_HashCollisionSetNode.prototype = $p;
$p.Ai = (function(element, originalHash, hash, shift) {
  return ((this.vz === hash) && $f_sc_SeqOps__contains__O__Z(this.gh, element));
});
$p.Yc = (function(element, originalHash, hash, shift) {
  return (this.Ai(element, originalHash, hash, shift) ? this : new $c_sci_HashCollisionSetNode(originalHash, hash, this.gh.lg(element)));
});
$p.a4v = (function(element, originalHash, hash, shift) {
  if ((!this.Ai(element, originalHash, hash, shift))) {
    return this;
  } else {
    var updatedContent = this.gh.d8(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((element0$2$2) => $m_sr_BoxesRunTime$().Q(element0$2$2, element))), true);
    return ((updatedContent.C() === 1) ? new $c_sci_BitmapIndexedSetNode($m_sci_Node$().d6($m_sci_Node$().fR(hash, 0)), 0, new $ac_O([updatedContent.l(0)]), new $ac_I(new Int32Array([originalHash])), 1, hash) : new $c_sci_HashCollisionSetNode(originalHash, hash, updatedContent));
  }
});
$p.X6 = (function() {
  return false;
});
$p.XA = (function() {
  return 0;
});
$p.iX = (function(index) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), "No sub-nodes present in hash-collision leaf node.");
});
$p.Ps = (function() {
  return true;
});
$p.XI = (function() {
  return this.gh.C();
});
$p.e4 = (function(index) {
  return this.gh.l(index);
});
$p.cK = (function(index) {
  return this.CZ;
});
$p.aa = (function() {
  return this.gh.C();
});
$p.F = (function(f) {
  var iter = this.gh.o();
  while (iter.p()) {
    f.i(iter.q());
  }
});
$p.dH = (function() {
  return Math.imul(this.gh.C(), this.vz);
});
$p.aib = (function(that, shift) {
  if ((this === that)) {
    return true;
  } else if ((that instanceof $c_sci_HashCollisionSetNode)) {
    if ((this.gh.C() <= that.gh.C())) {
      var this$1 = this.gh;
      var eta$0$1 = that.gh;
      var res = true;
      var it = this$1.o();
      while ((res && it.p())) {
        res = $f_sc_SeqOps__contains__O__Z(eta$0$1, it.q());
      }
      return res;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.afL = (function(pred, flipped) {
  var newContent = this.gh.d8(pred, flipped);
  var newContentLength = newContent.C();
  return ((newContentLength === 0) ? $m_sci_SetNode$().HG : ((newContentLength === 1) ? new $c_sci_BitmapIndexedSetNode($m_sci_Node$().d6($m_sci_Node$().fR(this.vz, 0)), 0, new $ac_O([newContent.t()]), new $ac_I(new Int32Array([this.CZ])), 1, this.vz) : ((newContent.C() === this.gh.C()) ? this : new $c_sci_HashCollisionSetNode(this.CZ, this.vz, newContent))));
});
$p.aNq = (function(that, shift) {
  return this.afL(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$2) => that.Ai(x$1$2$2, this.CZ, this.vz, shift))), true);
});
$p.e = (function(that) {
  if ((that instanceof $c_sci_HashCollisionSetNode)) {
    if ((this === that)) {
      return true;
    } else if (((this.vz === that.vz) && (this.gh.C() === that.gh.C()))) {
      var this$3 = this.gh;
      var eta$0$1 = that.gh;
      var res = true;
      var it = this$3.o();
      while ((res && it.p())) {
        res = $f_sc_SeqOps__contains__O__Z(eta$0$1, it.q());
      }
      return res;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.x = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Trie nodes do not support hashing.");
});
$p.aMX = (function(that, shift) {
  if ((that instanceof $c_sci_HashCollisionSetNode)) {
    if ((that === this)) {
      return this;
    } else {
      var newContent = null;
      var iter = that.gh.o();
      while (iter.p()) {
        var nextPayload = iter.q();
        if ((!$f_sc_SeqOps__contains__O__Z(this.gh, nextPayload))) {
          if ((newContent === null)) {
            newContent = new $c_sci_VectorBuilder();
            newContent.fO(this.gh);
          }
          newContent.ck(nextPayload);
        }
      }
      return ((newContent === null) ? this : new $c_sci_HashCollisionSetNode(this.CZ, this.vz, newContent.bY()));
    }
  } else if ((that instanceof $c_sci_BitmapIndexedSetNode)) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Cannot concatenate a HashCollisionSetNode with a BitmapIndexedSetNode");
  } else {
    throw new $c_s_MatchError(that);
  }
});
$p.afV = (function(f) {
  var iter = this.gh.o();
  while (iter.p()) {
    var next = iter.q();
    f.R(next, this.CZ);
  }
});
$p.aN5 = (function() {
  return new $c_sci_HashCollisionSetNode(this.CZ, this.vz, this.gh);
});
$p.X1 = (function(index) {
  return this.iX(index);
});
function $isArrayOf_sci_HashCollisionSetNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.l9)));
}
var $d_sci_HashCollisionSetNode = new $TypeData().i($c_sci_HashCollisionSetNode, "scala.collection.immutable.HashCollisionSetNode", ({
  l9: 1,
  lo: 1,
  c1: 1
}));
/** @constructor */
function $c_sci_HashMap$() {
  this.fk = null;
  $n_sci_HashMap$ = this;
  this.fk = new $c_sci_HashMap($m_sci_MapNode$().NY);
}
$p = $c_sci_HashMap$.prototype = new $h_O();
$p.constructor = $c_sci_HashMap$;
/** @constructor */
function $h_sci_HashMap$() {
}
$h_sci_HashMap$.prototype = $p;
$p.dr = (function(elems) {
  return this.aOq(elems);
});
$p.aOq = (function(source) {
  return ((source instanceof $c_sci_HashMap) ? source : new $c_sci_HashMapBuilder().aey(source).a4x());
});
$p.b5 = (function() {
  return new $c_sci_HashMapBuilder();
});
$p.cc = (function(it) {
  return this.aOq(it);
});
$p.aO = (function() {
  return this.fk;
});
var $d_sci_HashMap$ = new $TypeData().i($c_sci_HashMap$, "scala.collection.immutable.HashMap$", ({
  I7: 1,
  b9: 1,
  a: 1
}));
var $n_sci_HashMap$;
function $m_sci_HashMap$() {
  if ((!$n_sci_HashMap$)) {
    $n_sci_HashMap$ = new $c_sci_HashMap$();
  }
  return $n_sci_HashMap$;
}
/** @constructor */
function $c_sci_HashSet$() {
  this.vA = null;
  $n_sci_HashSet$ = this;
  this.vA = new $c_sci_HashSet($m_sci_SetNode$().HG);
}
$p = $c_sci_HashSet$.prototype = new $h_O();
$p.constructor = $c_sci_HashSet$;
/** @constructor */
function $h_sci_HashSet$() {
}
$h_sci_HashSet$.prototype = $p;
$p.dr = (function(elems) {
  return this.aOr(elems);
});
$p.aOr = (function(source) {
  return ((source instanceof $c_sci_HashSet) ? source : ((source.V() === 0) ? this.vA : new $c_sci_HashSetBuilder().aez(source).ahI()));
});
$p.b5 = (function() {
  return new $c_sci_HashSetBuilder();
});
$p.cc = (function(source) {
  return this.aOr(source);
});
$p.aO = (function() {
  return this.vA;
});
var $d_sci_HashSet$ = new $TypeData().i($c_sci_HashSet$, "scala.collection.immutable.HashSet$", ({
  Ib: 1,
  a0: 1,
  a: 1
}));
var $n_sci_HashSet$;
function $m_sci_HashSet$() {
  if ((!$n_sci_HashSet$)) {
    $n_sci_HashSet$ = new $c_sci_HashSet$();
  }
  return $n_sci_HashSet$;
}
/** @constructor */
function $c_sci_LazyList$WithFilter(lazyList, p) {
  this.acF = null;
  this.acF = lazyList.afJ(p);
}
$p = $c_sci_LazyList$WithFilter.prototype = new $h_sc_WithFilter();
$p.constructor = $c_sci_LazyList$WithFilter;
/** @constructor */
function $h_sci_LazyList$WithFilter() {
}
$h_sci_LazyList$WithFilter.prototype = $p;
$p.WQ = (function(f) {
  return this.acF.WQ(f);
});
$p.F = (function(f) {
  this.acF.F(f);
});
$p.c5 = (function(f) {
  return this.WQ(f);
});
var $d_sci_LazyList$WithFilter = new $TypeData().i($c_sci_LazyList$WithFilter, "scala.collection.immutable.LazyList$WithFilter", ({
  Io: 1,
  dF: 1,
  a: 1
}));
/** @constructor */
function $c_sci_Map$() {
}
$p = $c_sci_Map$.prototype = new $h_O();
$p.constructor = $c_sci_Map$;
/** @constructor */
function $h_sci_Map$() {
}
$h_sci_Map$.prototype = $p;
$p.dr = (function(elems) {
  return this.ao(elems);
});
$p.ao = (function(it) {
  if ($is_sci_Iterable(it)) {
    if (it.c()) {
      return $m_sci_Map$EmptyMap$();
    }
  }
  if ((it instanceof $c_sci_HashMap)) {
    return it;
  }
  if ((it instanceof $c_sci_Map$Map1)) {
    return it;
  }
  if ((it instanceof $c_sci_Map$Map2)) {
    return it;
  }
  if ((it instanceof $c_sci_Map$Map3)) {
    return it;
  }
  if ((it instanceof $c_sci_Map$Map4)) {
    return it;
  }
  if (false) {
    return it;
  }
  if ((it instanceof $c_sci_TreeSeqMap)) {
    return it;
  }
  if ((it instanceof $c_sci_VectorMap)) {
    return it;
  }
  if (false) {
    return it;
  }
  if (false) {
    return it;
  }
  if (false) {
    return it;
  }
  if (false) {
    return it;
  }
  return new $c_sci_MapBuilderImpl().aeA(it).oG();
});
$p.b5 = (function() {
  return new $c_sci_MapBuilderImpl();
});
$p.cc = (function(it) {
  return this.ao(it);
});
$p.aO = (function() {
  return $m_sci_Map$EmptyMap$();
});
var $d_sci_Map$ = new $TypeData().i($c_sci_Map$, "scala.collection.immutable.Map$", ({
  It: 1,
  b9: 1,
  a: 1
}));
var $n_sci_Map$;
function $m_sci_Map$() {
  if ((!$n_sci_Map$)) {
    $n_sci_Map$ = new $c_sci_Map$();
  }
  return $n_sci_Map$;
}
/** @constructor */
function $c_sci_Set$() {
}
$p = $c_sci_Set$.prototype = new $h_O();
$p.constructor = $c_sci_Set$;
/** @constructor */
function $h_sci_Set$() {
}
$h_sci_Set$.prototype = $p;
$p.dr = (function(elems) {
  return this.af(elems);
});
$p.af = (function(it) {
  return ((it.V() === 0) ? $m_sci_Set$EmptySet$() : ((it instanceof $c_sci_HashSet) ? it : (false ? it : ((it instanceof $c_sci_Set$Set1) ? it : ((it instanceof $c_sci_Set$Set2) ? it : ((it instanceof $c_sci_Set$Set3) ? it : ((it instanceof $c_sci_Set$Set4) ? it : ((it instanceof $c_sci_HashMap$HashKeySet) ? it : ((it instanceof $c_sci_MapOps$ImmutableKeySet) ? it : new $c_sci_SetBuilderImpl().aLM(it).ahJ())))))))));
});
$p.b5 = (function() {
  return new $c_sci_SetBuilderImpl();
});
$p.cc = (function(source) {
  return this.af(source);
});
$p.aO = (function() {
  return $m_sci_Set$EmptySet$();
});
var $d_sci_Set$ = new $TypeData().i($c_sci_Set$, "scala.collection.immutable.Set$", ({
  IZ: 1,
  a0: 1,
  a: 1
}));
var $n_sci_Set$;
function $m_sci_Set$() {
  if ((!$n_sci_Set$)) {
    $n_sci_Set$ = new $c_sci_Set$();
  }
  return $n_sci_Set$;
}
/** @constructor */
function $c_sci_TreeSeqMap$() {
  this.aIr = null;
  this.aIs = null;
  $n_sci_TreeSeqMap$ = this;
  this.aIr = new $c_sci_TreeSeqMap($m_sci_TreeSeqMap$Ordering$Zero$(), $m_sci_HashMap$().fk, 0, $m_sci_TreeSeqMap$OrderBy$Insertion$());
  this.aIs = new $c_sci_TreeSeqMap($m_sci_TreeSeqMap$Ordering$Zero$(), $m_sci_HashMap$().fk, 0, $m_sci_TreeSeqMap$OrderBy$Modification$());
}
$p = $c_sci_TreeSeqMap$.prototype = new $h_O();
$p.constructor = $c_sci_TreeSeqMap$;
/** @constructor */
function $h_sci_TreeSeqMap$() {
}
$h_sci_TreeSeqMap$.prototype = $p;
$p.dr = (function(elems) {
  return this.aOt(elems);
});
$p.afr = (function(orderBy) {
  var x$2 = $m_sci_TreeSeqMap$OrderBy$Modification$();
  if (((orderBy !== null) && (orderBy === x$2))) {
    return this.aIs;
  } else {
    return this.aIr;
  }
});
$p.aOt = (function(it) {
  return ((it instanceof $c_sci_TreeSeqMap) ? it : $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(new $c_sci_TreeSeqMap$Builder($m_sci_TreeSeqMap$OrderBy$Insertion$()), it).aR());
});
$p.b5 = (function() {
  return new $c_sci_TreeSeqMap$Builder($m_sci_TreeSeqMap$OrderBy$Insertion$());
});
$p.cc = (function(it) {
  return this.aOt(it);
});
$p.aO = (function() {
  return this.afr($m_sci_TreeSeqMap$OrderBy$Insertion$());
});
var $d_sci_TreeSeqMap$ = new $TypeData().i($c_sci_TreeSeqMap$, "scala.collection.immutable.TreeSeqMap$", ({
  Ja: 1,
  b9: 1,
  a: 1
}));
var $n_sci_TreeSeqMap$;
function $m_sci_TreeSeqMap$() {
  if ((!$n_sci_TreeSeqMap$)) {
    $n_sci_TreeSeqMap$ = new $c_sci_TreeSeqMap$();
  }
  return $n_sci_TreeSeqMap$;
}
/** @constructor */
function $c_sci_VectorMap$() {
  this.jg = null;
  $n_sci_VectorMap$ = this;
  this.jg = $ct_sci_VectorMap__sci_Vector__sci_Map__(new $c_sci_VectorMap(), ($m_sci_Vector$(), $m_sci_Vector0$()), $m_sci_HashMap$().fk);
}
$p = $c_sci_VectorMap$.prototype = new $h_O();
$p.constructor = $c_sci_VectorMap$;
/** @constructor */
function $h_sci_VectorMap$() {
}
$h_sci_VectorMap$.prototype = $p;
$p.dr = (function(elems) {
  return this.u3(elems);
});
$p.u3 = (function(it) {
  return ((it instanceof $c_sci_VectorMap) ? it : $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(new $c_sci_VectorMapBuilder(), it).aR());
});
$p.b5 = (function() {
  return new $c_sci_VectorMapBuilder();
});
$p.cc = (function(it) {
  return this.u3(it);
});
$p.aO = (function() {
  return this.jg;
});
var $d_sci_VectorMap$ = new $TypeData().i($c_sci_VectorMap$, "scala.collection.immutable.VectorMap$", ({
  Jo: 1,
  b9: 1,
  a: 1
}));
var $n_sci_VectorMap$;
function $m_sci_VectorMap$() {
  if ((!$n_sci_VectorMap$)) {
    $n_sci_VectorMap$ = new $c_sci_VectorMap$();
  }
  return $n_sci_VectorMap$;
}
function $f_scm_Builder__sizeHint__sc_IterableOnce__I__V($thiz, coll, delta) {
  var x1 = coll.V();
  if ((x1 !== (-1))) {
    var that = ((x1 + delta) | 0);
    $thiz.f9(((that < 0) ? 0 : that));
  }
}
/** @constructor */
function $c_scm_HashMap$() {
}
$p = $c_scm_HashMap$.prototype = new $h_O();
$p.constructor = $c_scm_HashMap$;
/** @constructor */
function $h_scm_HashMap$() {
}
$h_scm_HashMap$.prototype = $p;
$p.dr = (function(elems) {
  return this.DY(elems);
});
$p.DY = (function(it) {
  var k = it.V();
  return $ct_scm_HashMap__I__D__(new $c_scm_HashMap(), ((k > 0) ? $doubleToInt((((1 + k) | 0) / 0.75)) : 16), 0.75).aLN(it);
});
$p.b5 = (function() {
  return new $c_scm_HashMap$$anon$6(16, 0.75);
});
$p.cc = (function(it) {
  return this.DY(it);
});
$p.aO = (function() {
  return $ct_scm_HashMap__(new $c_scm_HashMap());
});
var $d_scm_HashMap$ = new $TypeData().i($c_scm_HashMap$, "scala.collection.mutable.HashMap$", ({
  JN: 1,
  b9: 1,
  a: 1
}));
var $n_scm_HashMap$;
function $m_scm_HashMap$() {
  if ((!$n_scm_HashMap$)) {
    $n_scm_HashMap$ = new $c_scm_HashMap$();
  }
  return $n_scm_HashMap$;
}
/** @constructor */
function $c_scm_HashSet$() {
}
$p = $c_scm_HashSet$.prototype = new $h_O();
$p.constructor = $c_scm_HashSet$;
/** @constructor */
function $h_scm_HashSet$() {
}
$h_scm_HashSet$.prototype = $p;
$p.dr = (function(elems) {
  return this.aOv(elems);
});
$p.aOv = (function(it) {
  var k = it.V();
  return $ct_scm_HashSet__I__D__(new $c_scm_HashSet(), ((k > 0) ? $doubleToInt((((1 + k) | 0) / 0.75)) : 16), 0.75).aLO(it);
});
$p.b5 = (function() {
  return new $c_scm_HashSet$$anon$4(16, 0.75);
});
$p.aO = (function() {
  return $ct_scm_HashSet__(new $c_scm_HashSet());
});
$p.cc = (function(source) {
  return this.aOv(source);
});
var $d_scm_HashSet$ = new $TypeData().i($c_scm_HashSet$, "scala.collection.mutable.HashSet$", ({
  JV: 1,
  a0: 1,
  a: 1
}));
var $n_scm_HashSet$;
function $m_scm_HashSet$() {
  if ((!$n_scm_HashSet$)) {
    $n_scm_HashSet$ = new $c_scm_HashSet$();
  }
  return $n_scm_HashSet$;
}
/** @constructor */
function $c_scm_LinkedHashMap$() {
}
$p = $c_scm_LinkedHashMap$.prototype = new $h_O();
$p.constructor = $c_scm_LinkedHashMap$;
/** @constructor */
function $h_scm_LinkedHashMap$() {
}
$h_scm_LinkedHashMap$.prototype = $p;
$p.dr = (function(elems) {
  return this.a3w(elems);
});
$p.a3w = (function(it) {
  var newlhm = new $c_scm_LinkedHashMap();
  $f_scm_Builder__sizeHint__sc_IterableOnce__I__V(newlhm, it, 0);
  $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(newlhm, it);
  return newlhm;
});
$p.b5 = (function() {
  return $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), new $c_scm_LinkedHashMap());
});
$p.cc = (function(it) {
  return this.a3w(it);
});
$p.aO = (function() {
  return new $c_scm_LinkedHashMap();
});
var $d_scm_LinkedHashMap$ = new $TypeData().i($c_scm_LinkedHashMap$, "scala.collection.mutable.LinkedHashMap$", ({
  K4: 1,
  b9: 1,
  a: 1
}));
var $n_scm_LinkedHashMap$;
function $m_scm_LinkedHashMap$() {
  if ((!$n_scm_LinkedHashMap$)) {
    $n_scm_LinkedHashMap$ = new $c_scm_LinkedHashMap$();
  }
  return $n_scm_LinkedHashMap$;
}
/** @constructor */
function $c_scm_LinkedHashSet$() {
}
$p = $c_scm_LinkedHashSet$.prototype = new $h_O();
$p.constructor = $c_scm_LinkedHashSet$;
/** @constructor */
function $h_scm_LinkedHashSet$() {
}
$h_scm_LinkedHashSet$.prototype = $p;
$p.dr = (function(elems) {
  return this.aOw(elems);
});
$p.aOw = (function(it) {
  var newlhs = new $c_scm_LinkedHashSet();
  $f_scm_Builder__sizeHint__sc_IterableOnce__I__V(newlhs, it, 0);
  $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(newlhs, it);
  return newlhs;
});
$p.b5 = (function() {
  return $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), new $c_scm_LinkedHashSet());
});
$p.cc = (function(source) {
  return this.aOw(source);
});
$p.aO = (function() {
  return new $c_scm_LinkedHashSet();
});
var $d_scm_LinkedHashSet$ = new $TypeData().i($c_scm_LinkedHashSet$, "scala.collection.mutable.LinkedHashSet$", ({
  Kc: 1,
  a0: 1,
  a: 1
}));
var $n_scm_LinkedHashSet$;
function $m_scm_LinkedHashSet$() {
  if ((!$n_scm_LinkedHashSet$)) {
    $n_scm_LinkedHashSet$ = new $c_scm_LinkedHashSet$();
  }
  return $n_scm_LinkedHashSet$;
}
/** @constructor */
function $c_s_concurrent_BatchingExecutor$SyncBatch(outer, runnable) {
  this.Vg = null;
  this.Vh = null;
  this.Dc = 0;
  this.aIN = null;
  $ct_s_concurrent_BatchingExecutor$AbstractBatch__s_concurrent_BatchingExecutor__jl_Runnable__Ajl_Runnable__I__(this, outer, runnable, $m_s_concurrent_BatchingExecutorStatics$().aIO, 1);
}
$p = $c_s_concurrent_BatchingExecutor$SyncBatch.prototype = new $h_s_concurrent_BatchingExecutor$AbstractBatch();
$p.constructor = $c_s_concurrent_BatchingExecutor$SyncBatch;
/** @constructor */
function $h_s_concurrent_BatchingExecutor$SyncBatch() {
}
$h_s_concurrent_BatchingExecutor$SyncBatch.prototype = $p;
$p.Jk = (function() {
  while (true) {
    try {
      this.b83(1024);
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      if (false) {
        $m_s_concurrent_ExecutionContext$().Od.i(e$2);
      } else if ($m_s_util_control_NonFatal$().ew(e$2)) {
        $m_s_concurrent_ExecutionContext$().Od.i(e$2);
      } else {
        throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
      }
    }
    if ((this.Dc > 0)) {
      continue;
    }
    return (void 0);
  }
});
function $isArrayOf_s_concurrent_BatchingExecutor$SyncBatch(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.lX)));
}
var $d_s_concurrent_BatchingExecutor$SyncBatch = new $TypeData().i($c_s_concurrent_BatchingExecutor$SyncBatch, "scala.concurrent.BatchingExecutor$SyncBatch", ({
  lX: 1,
  Ku: 1,
  dc: 1
}));
/** @constructor */
function $c_s_concurrent_impl_Promise$Link(to) {
  this.eo = null;
  $ct_ju_concurrent_atomic_AtomicReference__O__(this, to);
}
$p = $c_s_concurrent_impl_Promise$Link.prototype = new $h_ju_concurrent_atomic_AtomicReference();
$p.constructor = $c_s_concurrent_impl_Promise$Link;
/** @constructor */
function $h_s_concurrent_impl_Promise$Link() {
}
$h_s_concurrent_impl_Promise$Link.prototype = $p;
$p.PK = (function(owner) {
  var c = this.eo;
  var current = c;
  var target = c;
  while (true) {
    var value = target.eo;
    if ($is_s_concurrent_impl_Promise$Callbacks(value)) {
      if (this.Wv(current, target)) {
        return target;
      } else {
        current = this.eo;
      }
    } else if ((value instanceof $c_s_concurrent_impl_Promise$Link)) {
      target = value.eo;
    } else {
      owner.baF(value);
      return owner;
    }
  }
});
function $isArrayOf_s_concurrent_impl_Promise$Link(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.m1)));
}
var $d_s_concurrent_impl_Promise$Link = new $TypeData().i($c_s_concurrent_impl_Promise$Link, "scala.concurrent.impl.Promise$Link", ({
  m1: 1,
  cr: 1,
  a: 1
}));
/** @constructor */
function $c_s_math_BigDecimal$RoundingMode$() {
  this.a1c = null;
  this.UA = 0;
  this.i1 = null;
  this.a1b = 0;
  this.a1a = 0;
  this.Oe = null;
  this.adi = null;
  $ct_s_Enumeration__I__(this, 0);
  $n_s_math_BigDecimal$RoundingMode$ = this;
  new $c_s_Enumeration$Val(this, $m_Ljava_math_RoundingMode$().Zi.k6, (((this.i1 !== null) && this.i1.p()) ? this.i1.q() : "UP"));
  new $c_s_Enumeration$Val(this, $m_Ljava_math_RoundingMode$().Ze.k6, (((this.i1 !== null) && this.i1.p()) ? this.i1.q() : "DOWN"));
  new $c_s_Enumeration$Val(this, $m_Ljava_math_RoundingMode$().Zd.k6, (((this.i1 !== null) && this.i1.p()) ? this.i1.q() : "CEILING"));
  new $c_s_Enumeration$Val(this, $m_Ljava_math_RoundingMode$().Zf.k6, (((this.i1 !== null) && this.i1.p()) ? this.i1.q() : "FLOOR"));
  this.Oe = new $c_s_Enumeration$Val(this, $m_Ljava_math_RoundingMode$().R0.k6, (((this.i1 !== null) && this.i1.p()) ? this.i1.q() : "HALF_UP"));
  new $c_s_Enumeration$Val(this, $m_Ljava_math_RoundingMode$().Zg.k6, (((this.i1 !== null) && this.i1.p()) ? this.i1.q() : "HALF_DOWN"));
  this.adi = new $c_s_Enumeration$Val(this, $m_Ljava_math_RoundingMode$().B2.k6, (((this.i1 !== null) && this.i1.p()) ? this.i1.q() : "HALF_EVEN"));
  new $c_s_Enumeration$Val(this, $m_Ljava_math_RoundingMode$().Zh.k6, (((this.i1 !== null) && this.i1.p()) ? this.i1.q() : "UNNECESSARY"));
}
$p = $c_s_math_BigDecimal$RoundingMode$.prototype = new $h_s_Enumeration();
$p.constructor = $c_s_math_BigDecimal$RoundingMode$;
/** @constructor */
function $h_s_math_BigDecimal$RoundingMode$() {
}
$h_s_math_BigDecimal$RoundingMode$.prototype = $p;
var $d_s_math_BigDecimal$RoundingMode$ = new $TypeData().i($c_s_math_BigDecimal$RoundingMode$, "scala.math.BigDecimal$RoundingMode$", ({
  KL: 1,
  G4: 1,
  a: 1
}));
var $n_s_math_BigDecimal$RoundingMode$;
function $m_s_math_BigDecimal$RoundingMode$() {
  if ((!$n_s_math_BigDecimal$RoundingMode$)) {
    $n_s_math_BigDecimal$RoundingMode$ = new $c_s_math_BigDecimal$RoundingMode$();
  }
  return $n_s_math_BigDecimal$RoundingMode$;
}
/** @constructor */
function $c_s_math_ScalaNumber() {
}
$p = $c_s_math_ScalaNumber.prototype = new $h_jl_Number();
$p.constructor = $c_s_math_ScalaNumber;
/** @constructor */
function $h_s_math_ScalaNumber() {
}
$h_s_math_ScalaNumber.prototype = $p;
function $isArrayOf_s_math_ScalaNumber(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dY)));
}
/** @constructor */
function $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(f) {
  this.aJ1 = null;
  this.aJ1 = f;
}
$p = $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c.prototype = new $h_sr_AbstractFunction0();
$p.constructor = $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c;
/** @constructor */
function $h_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c() {
}
$h_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c.prototype = $p;
$p.a3 = (function() {
  return (0, this.aJ1)();
});
var $d_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c = new $TypeData().i($c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c, "scala.runtime.AbstractFunction0.$$Lambda$07eded5776954a9c145e92c329afd52873ad179c", ({
  LC: 1,
  md: 1,
  du: 1
}));
/** @constructor */
function $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(f) {
  this.aJ2 = null;
  this.aJ2 = f;
}
$p = $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919.prototype = new $h_sr_AbstractFunction1();
$p.constructor = $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919;
/** @constructor */
function $h_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919() {
}
$h_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919.prototype = $p;
$p.i = (function(x0) {
  return (0, this.aJ2)(x0);
});
var $d_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919 = new $TypeData().i($c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919, "scala.runtime.AbstractFunction1.$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919", ({
  LD: 1,
  c8: 1,
  h: 1
}));
/** @constructor */
function $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(f) {
  this.aJ3 = null;
  this.aJ3 = f;
}
$p = $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8.prototype = new $h_sr_AbstractFunction2();
$p.constructor = $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8;
/** @constructor */
function $h_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8() {
}
$h_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8.prototype = $p;
$p.R = (function(x0, x1) {
  return (0, this.aJ3)(x0, x1);
});
var $d_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8 = new $TypeData().i($c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8, "scala.runtime.AbstractFunction2.$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8", ({
  LE: 1,
  c9: 1,
  bE: 1
}));
/** @constructor */
function $c_sr_AbstractFunction3_$$Lambda$d1e06cbab540de4f9f09e7182f18ea80659b9825(f) {
  this.aJ4 = null;
  this.aJ4 = f;
}
$p = $c_sr_AbstractFunction3_$$Lambda$d1e06cbab540de4f9f09e7182f18ea80659b9825.prototype = new $h_sr_AbstractFunction3();
$p.constructor = $c_sr_AbstractFunction3_$$Lambda$d1e06cbab540de4f9f09e7182f18ea80659b9825;
/** @constructor */
function $h_sr_AbstractFunction3_$$Lambda$d1e06cbab540de4f9f09e7182f18ea80659b9825() {
}
$h_sr_AbstractFunction3_$$Lambda$d1e06cbab540de4f9f09e7182f18ea80659b9825.prototype = $p;
$p.DH = (function(x0, x1, x2) {
  return (0, this.aJ4)(x0, x1, x2);
});
var $d_sr_AbstractFunction3_$$Lambda$d1e06cbab540de4f9f09e7182f18ea80659b9825 = new $TypeData().i($c_sr_AbstractFunction3_$$Lambda$d1e06cbab540de4f9f09e7182f18ea80659b9825, "scala.runtime.AbstractFunction3.$$Lambda$d1e06cbab540de4f9f09e7182f18ea80659b9825", ({
  LF: 1,
  me: 1,
  kq: 1
}));
/** @constructor */
function $c_sr_AbstractFunction4_$$Lambda$451042f443265710aa66de6985cba67480d9b00a(f) {
  this.aJ5 = null;
  this.aJ5 = f;
}
$p = $c_sr_AbstractFunction4_$$Lambda$451042f443265710aa66de6985cba67480d9b00a.prototype = new $h_sr_AbstractFunction4();
$p.constructor = $c_sr_AbstractFunction4_$$Lambda$451042f443265710aa66de6985cba67480d9b00a;
/** @constructor */
function $h_sr_AbstractFunction4_$$Lambda$451042f443265710aa66de6985cba67480d9b00a() {
}
$h_sr_AbstractFunction4_$$Lambda$451042f443265710aa66de6985cba67480d9b00a.prototype = $p;
$p.a2I = (function(x0, x1, x2, x3) {
  return (0, this.aJ5)(x0, x1, x2, x3);
});
var $d_sr_AbstractFunction4_$$Lambda$451042f443265710aa66de6985cba67480d9b00a = new $TypeData().i($c_sr_AbstractFunction4_$$Lambda$451042f443265710aa66de6985cba67480d9b00a, "scala.runtime.AbstractFunction4.$$Lambda$451042f443265710aa66de6985cba67480d9b00a", ({
  LG: 1,
  mf: 1,
  kr: 1
}));
/** @constructor */
function $c_sr_AbstractFunction5_$$Lambda$e688b1adbc65539969b4b8c5192c202236fd1078(f) {
  this.aJ6 = null;
  this.aJ6 = f;
}
$p = $c_sr_AbstractFunction5_$$Lambda$e688b1adbc65539969b4b8c5192c202236fd1078.prototype = new $h_sr_AbstractFunction5();
$p.constructor = $c_sr_AbstractFunction5_$$Lambda$e688b1adbc65539969b4b8c5192c202236fd1078;
/** @constructor */
function $h_sr_AbstractFunction5_$$Lambda$e688b1adbc65539969b4b8c5192c202236fd1078() {
}
$h_sr_AbstractFunction5_$$Lambda$e688b1adbc65539969b4b8c5192c202236fd1078.prototype = $p;
$p.aXh = (function(x0, x1, x2, x3, x4) {
  return (0, this.aJ6)(x0, x1, x2, x3, x4);
});
var $d_sr_AbstractFunction5_$$Lambda$e688b1adbc65539969b4b8c5192c202236fd1078 = new $TypeData().i($c_sr_AbstractFunction5_$$Lambda$e688b1adbc65539969b4b8c5192c202236fd1078, "scala.runtime.AbstractFunction5.$$Lambda$e688b1adbc65539969b4b8c5192c202236fd1078", ({
  LI: 1,
  LH: 1,
  G6: 1
}));
/** @constructor */
function $c_sr_AbstractFunction6_$$Lambda$70739abafae35d0aa747e9aa55a42abdab2f8361(f) {
  this.aJ7 = null;
  this.aJ7 = f;
}
$p = $c_sr_AbstractFunction6_$$Lambda$70739abafae35d0aa747e9aa55a42abdab2f8361.prototype = new $h_sr_AbstractFunction6();
$p.constructor = $c_sr_AbstractFunction6_$$Lambda$70739abafae35d0aa747e9aa55a42abdab2f8361;
/** @constructor */
function $h_sr_AbstractFunction6_$$Lambda$70739abafae35d0aa747e9aa55a42abdab2f8361() {
}
$h_sr_AbstractFunction6_$$Lambda$70739abafae35d0aa747e9aa55a42abdab2f8361.prototype = $p;
$p.aM6 = (function(x0, x1, x2, x3, x4, x5) {
  return (0, this.aJ7)(x0, x1, x2, x3, x4, x5);
});
var $d_sr_AbstractFunction6_$$Lambda$70739abafae35d0aa747e9aa55a42abdab2f8361 = new $TypeData().i($c_sr_AbstractFunction6_$$Lambda$70739abafae35d0aa747e9aa55a42abdab2f8361, "scala.runtime.AbstractFunction6.$$Lambda$70739abafae35d0aa747e9aa55a42abdab2f8361", ({
  LJ: 1,
  mg: 1,
  ks: 1
}));
/** @constructor */
function $c_sr_AbstractPartialFunction() {
}
$p = $c_sr_AbstractPartialFunction.prototype = new $h_O();
$p.constructor = $c_sr_AbstractPartialFunction;
/** @constructor */
function $h_sr_AbstractPartialFunction() {
}
$h_sr_AbstractPartialFunction.prototype = $p;
$p.Ar = (function() {
  return new $c_s_PartialFunction$Lifted(this);
});
$p.Eg = (function(action) {
  return $f_s_PartialFunction__runWith__F1__F1(this, action);
});
$p.m = (function() {
  return "<function1>";
});
$p.i = (function(x) {
  return this.aC(x, $m_s_PartialFunction$().gt);
});
$p.iU = (function(x) {
  return (!(!this.aC(x, $m_s_PartialFunction$().gt)));
});
var $d_sr_Nothing$ = new $TypeData().i(0, "scala.runtime.Nothing$", ({
  LU: 1,
  y: 1,
  a: 1
}));
/** @constructor */
function $c_sr_TupleXXL(es) {
  this.vK = null;
  this.vK = es;
  if ((es.a.length <= 22)) {
    $m_sr_Scala3RunTime$().Wl();
  }
}
$p = $c_sr_TupleXXL.prototype = new $h_O();
$p.constructor = $c_sr_TupleXXL;
/** @constructor */
function $h_sr_TupleXXL() {
}
$h_sr_TupleXXL.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.D = (function(n) {
  return $f_s_Product__productElementName__I__T(this, n);
});
$p.A = (function(n) {
  return this.vK.a[n];
});
$p.z = (function() {
  return this.vK.a.length;
});
$p.B = (function() {
  return "Tuple";
});
$p.m = (function() {
  return $f_sc_IterableOnceOps__mkString__T__T__T__T($m_s_Predef$().fB(this.vK), "(", ",", ")");
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().eN(this, (-889275714), null);
});
$p.e = (function(that) {
  if ((that instanceof $c_sr_TupleXXL)) {
    if ((this.vK === that.vK)) {
      return true;
    } else {
      if ((this.vK.a.length !== that.vK.a.length)) {
        return false;
      }
      var i = 0;
      while ((i < this.vK.a.length)) {
        var $x_2 = $m_sr_BoxesRunTime$();
        var arr$3 = this.vK;
        var n = i;
        var $x_1 = arr$3.a[n];
        var arr$4 = that.vK;
        var n$1 = i;
        if ((!$x_2.Q($x_1, arr$4.a[n$1]))) {
          return false;
        }
        i = ((1 + i) | 0);
      }
      return true;
    }
  } else {
    return false;
  }
});
function $isArrayOf_sr_TupleXXL(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ml)));
}
var $d_sr_TupleXXL = new $TypeData().i($c_sr_TupleXXL, "scala.runtime.TupleXXL", ({
  ml: 1,
  b: 1,
  c: 1
}));
/** @constructor */
function $c_sjs_js_Any$() {
}
$p = $c_sjs_js_Any$.prototype = new $h_O();
$p.constructor = $c_sjs_js_Any$;
/** @constructor */
function $h_sjs_js_Any$() {
}
$h_sjs_js_Any$.prototype = $p;
$p.ag5 = (function(f) {
  return (() => f.a3());
});
$p.Pn = (function(f) {
  return ((arg1$2) => f.i(arg1$2));
});
$p.b1K = (function(f) {
  return ((arg1$2, arg2$2) => f.R(arg1$2, arg2$2));
});
var $d_sjs_js_Any$ = new $TypeData().i($c_sjs_js_Any$, "scala.scalajs.js.Any$", ({
  Mb: 1,
  Mf: 1,
  Mg: 1
}));
var $n_sjs_js_Any$;
function $m_sjs_js_Any$() {
  if ((!$n_sjs_js_Any$)) {
    $n_sjs_js_Any$ = new $c_sjs_js_Any$();
  }
  return $n_sjs_js_Any$;
}
/** @constructor */
function $c_sjsr_AnonFunction0() {
}
$p = $c_sjsr_AnonFunction0.prototype = new $h_sr_AbstractFunction0();
$p.constructor = $c_sjsr_AnonFunction0;
/** @constructor */
function $h_sjsr_AnonFunction0() {
}
$h_sjsr_AnonFunction0.prototype = $p;
/** @constructor */
function $c_sjsr_AnonFunction1() {
}
$p = $c_sjsr_AnonFunction1.prototype = new $h_sr_AbstractFunction1();
$p.constructor = $c_sjsr_AnonFunction1;
/** @constructor */
function $h_sjsr_AnonFunction1() {
}
$h_sjsr_AnonFunction1.prototype = $p;
/** @constructor */
function $c_sjsr_AnonFunction2() {
}
$p = $c_sjsr_AnonFunction2.prototype = new $h_sr_AbstractFunction2();
$p.constructor = $c_sjsr_AnonFunction2;
/** @constructor */
function $h_sjsr_AnonFunction2() {
}
$h_sjsr_AnonFunction2.prototype = $p;
/** @constructor */
function $c_sjsr_AnonFunction3() {
}
$p = $c_sjsr_AnonFunction3.prototype = new $h_sr_AbstractFunction3();
$p.constructor = $c_sjsr_AnonFunction3;
/** @constructor */
function $h_sjsr_AnonFunction3() {
}
$h_sjsr_AnonFunction3.prototype = $p;
/** @constructor */
function $c_sjsr_AnonFunction4() {
}
$p = $c_sjsr_AnonFunction4.prototype = new $h_sr_AbstractFunction4();
$p.constructor = $c_sjsr_AnonFunction4;
/** @constructor */
function $h_sjsr_AnonFunction4() {
}
$h_sjsr_AnonFunction4.prototype = $p;
/** @constructor */
function $c_sjsr_AnonFunction6() {
}
$p = $c_sjsr_AnonFunction6.prototype = new $h_sr_AbstractFunction6();
$p.constructor = $c_sjsr_AnonFunction6;
/** @constructor */
function $h_sjsr_AnonFunction6() {
}
$h_sjsr_AnonFunction6.prototype = $p;
/** @constructor */
function $c_sjsr_AnonFunction9() {
}
$p = $c_sjsr_AnonFunction9.prototype = new $h_sr_AbstractFunction9();
$p.constructor = $c_sjsr_AnonFunction9;
/** @constructor */
function $h_sjsr_AnonFunction9() {
}
$h_sjsr_AnonFunction9.prototype = $p;
function $isArrayOf_s_util_control_ControlThrowable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.MQ)));
}
/** @constructor */
function $c_s_util_parsing_combinator_Parsers$$anon$1(f$7, outer) {
  this.Di = null;
  this.vM = null;
  this.aJn = null;
  this.aJn = f$7;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_s_util_parsing_combinator_Parsers$Parser__s_util_parsing_combinator_Parsers__(this, outer);
}
$p = $c_s_util_parsing_combinator_Parsers$$anon$1.prototype = new $h_s_util_parsing_combinator_Parsers$Parser();
$p.constructor = $c_s_util_parsing_combinator_Parsers$$anon$1;
/** @constructor */
function $h_s_util_parsing_combinator_Parsers$$anon$1() {
}
$h_s_util_parsing_combinator_Parsers$$anon$1.prototype = $p;
$p.lh = (function(in$1) {
  return this.aJn.i(in$1);
});
$p.i = (function(v1) {
  return this.lh(v1);
});
var $d_s_util_parsing_combinator_Parsers$$anon$1 = new $TypeData().i($c_s_util_parsing_combinator_Parsers$$anon$1, "scala.util.parsing.combinator.Parsers$$anon$1", ({
  N1: 1,
  cb: 1,
  h: 1
}));
/** @constructor */
function $c_s_util_parsing_combinator_Parsers$$anon$5(v$3, outer) {
  this.Di = null;
  this.vM = null;
  this.aJp = null;
  this.aJq = null;
  this.aJr = false;
  this.aJo = null;
  this.aJp = v$3;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aJo = outer;
  $ct_s_util_parsing_combinator_Parsers$Parser__s_util_parsing_combinator_Parsers__(this, outer.vM);
}
$p = $c_s_util_parsing_combinator_Parsers$$anon$5.prototype = new $h_s_util_parsing_combinator_Parsers$Parser();
$p.constructor = $c_s_util_parsing_combinator_Parsers$$anon$5;
/** @constructor */
function $h_s_util_parsing_combinator_Parsers$$anon$5() {
}
$h_s_util_parsing_combinator_Parsers$$anon$5.prototype = $p;
$p.baY = (function() {
  if ((!this.aJr)) {
    this.aJq = this.aJp.a3();
    this.aJr = true;
  }
  return this.aJq;
});
$p.lh = (function(in$1) {
  return this.aJo.lh(in$1).agY(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => this.baY())));
});
$p.i = (function(v1) {
  return this.lh(v1);
});
var $d_s_util_parsing_combinator_Parsers$$anon$5 = new $TypeData().i($c_s_util_parsing_combinator_Parsers$$anon$5, "scala.util.parsing.combinator.Parsers$$anon$5", ({
  N3: 1,
  cb: 1,
  h: 1
}));
/** @constructor */
function $c_s_util_parsing_combinator_Parsers$$anon$6(p$26, outer) {
  this.Di = null;
  this.vM = null;
  this.aJs = null;
  this.a23 = null;
  this.aJs = p$26;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.a23 = outer;
  $ct_s_util_parsing_combinator_Parsers$Parser__s_util_parsing_combinator_Parsers__(this, outer);
}
$p = $c_s_util_parsing_combinator_Parsers$$anon$6.prototype = new $h_s_util_parsing_combinator_Parsers$Parser();
$p.constructor = $c_s_util_parsing_combinator_Parsers$$anon$6;
/** @constructor */
function $h_s_util_parsing_combinator_Parsers$$anon$6() {
}
$h_s_util_parsing_combinator_Parsers$$anon$6.prototype = $p;
$p.lh = (function(in$1) {
  var x212 = this.aJs.lh(in$1);
  if (((x212 instanceof $c_s_util_parsing_combinator_Parsers$Success) && (x212.lQ === this.a23))) {
    this.a23.OQ();
    var x216 = x212.pg;
    if (x216.aMt()) {
      var $x_1 = x212;
    } else {
      matchResult38: {
        var $x_1;
        var x209 = x212.Aa;
        if ((x209 instanceof $c_s_Some)) {
          var $x_1 = x209.J;
          break matchResult38;
        }
        var $x_1 = this.a23.aer().aeJ("end of input expected", x216);
      }
    }
    return $x_1;
  }
  return x212;
});
$p.i = (function(v1) {
  return this.lh(v1);
});
var $d_s_util_parsing_combinator_Parsers$$anon$6 = new $TypeData().i($c_s_util_parsing_combinator_Parsers$$anon$6, "scala.util.parsing.combinator.Parsers$$anon$6", ({
  N4: 1,
  cb: 1,
  h: 1
}));
/** @constructor */
function $c_s_util_parsing_combinator_Parsers$$tilde$(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_s_util_parsing_combinator_Parsers$$tilde$.prototype = new $h_O();
$p.constructor = $c_s_util_parsing_combinator_Parsers$$tilde$;
/** @constructor */
function $h_s_util_parsing_combinator_Parsers$$tilde$() {
}
$h_s_util_parsing_combinator_Parsers$$tilde$.prototype = $p;
$p.m = (function() {
  return "~";
});
var $d_s_util_parsing_combinator_Parsers$$tilde$ = new $TypeData().i($c_s_util_parsing_combinator_Parsers$$tilde$, "scala.util.parsing.combinator.Parsers$$tilde$", ({
  N5: 1,
  d: 1,
  j: 1
}));
/** @constructor */
function $c_s_util_parsing_combinator_Parsers$Error$(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_s_util_parsing_combinator_Parsers$Error$.prototype = new $h_O();
$p.constructor = $c_s_util_parsing_combinator_Parsers$Error$;
/** @constructor */
function $h_s_util_parsing_combinator_Parsers$Error$() {
}
$h_s_util_parsing_combinator_Parsers$Error$.prototype = $p;
$p.m = (function() {
  return "Error";
});
var $d_s_util_parsing_combinator_Parsers$Error$ = new $TypeData().i($c_s_util_parsing_combinator_Parsers$Error$, "scala.util.parsing.combinator.Parsers$Error$", ({
  N7: 1,
  d: 1,
  j: 1
}));
/** @constructor */
function $c_s_util_parsing_combinator_Parsers$Failure$(outer) {
  this.aJt = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aJt = outer;
}
$p = $c_s_util_parsing_combinator_Parsers$Failure$.prototype = new $h_O();
$p.constructor = $c_s_util_parsing_combinator_Parsers$Failure$;
/** @constructor */
function $h_s_util_parsing_combinator_Parsers$Failure$() {
}
$h_s_util_parsing_combinator_Parsers$Failure$.prototype = $p;
$p.aeJ = (function(msg, next) {
  return new $c_s_util_parsing_combinator_Parsers$Failure(this.aJt, msg, next);
});
$p.m = (function() {
  return "Failure";
});
var $d_s_util_parsing_combinator_Parsers$Failure$ = new $TypeData().i($c_s_util_parsing_combinator_Parsers$Failure$, "scala.util.parsing.combinator.Parsers$Failure$", ({
  N8: 1,
  d: 1,
  j: 1
}));
/** @constructor */
function $c_s_util_parsing_combinator_Parsers$Success$(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_s_util_parsing_combinator_Parsers$Success$.prototype = new $h_O();
$p.constructor = $c_s_util_parsing_combinator_Parsers$Success$;
/** @constructor */
function $h_s_util_parsing_combinator_Parsers$Success$() {
}
$h_s_util_parsing_combinator_Parsers$Success$.prototype = $p;
$p.m = (function() {
  return "Success";
});
var $d_s_util_parsing_combinator_Parsers$Success$ = new $TypeData().i($c_s_util_parsing_combinator_Parsers$Success$, "scala.util.parsing.combinator.Parsers$Success$", ({
  N9: 1,
  d: 1,
  j: 1
}));
/** @constructor */
function $c_s_util_parsing_combinator_RegexParsers$$anon$1(s$2, outer) {
  this.Di = null;
  this.vM = null;
  this.VC = null;
  this.a25 = null;
  this.VC = s$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.a25 = outer;
  $ct_s_util_parsing_combinator_Parsers$Parser__s_util_parsing_combinator_Parsers__(this, outer);
}
$p = $c_s_util_parsing_combinator_RegexParsers$$anon$1.prototype = new $h_s_util_parsing_combinator_Parsers$Parser();
$p.constructor = $c_s_util_parsing_combinator_RegexParsers$$anon$1;
/** @constructor */
function $h_s_util_parsing_combinator_RegexParsers$$anon$1() {
}
$h_s_util_parsing_combinator_RegexParsers$$anon$1.prototype = $p;
$p.lh = (function(in$1) {
  var source = in$1.pi;
  var offset = in$1.ph;
  var start = $f_s_util_parsing_combinator_RegexParsers__handleWhiteSpace__jl_CharSequence__I__I(this.a25, source, offset);
  var i = 0;
  var j = start;
  while ((((i < this.VC.length) && (j < $dp_length__I(source))) && (this.VC.charCodeAt(i) === $dp_charAt__I__C(source, j)))) {
    i = ((1 + i) | 0);
    j = ((1 + j) | 0);
  }
  if ((i === this.VC.length)) {
    var this$5 = this.a25;
    return new $c_s_util_parsing_combinator_Parsers$$anon$2($dp_toString__T($dp_subSequence__I__I__jl_CharSequence(source, start, j)), in$1.a39(((j - offset) | 0)), $m_s_None$(), this$5);
  } else {
    var found = ((start === $dp_length__I(source)) ? "end of source" : (("'" + $cToS($dp_charAt__I__C(source, start))) + "'"));
    return this.a25.aer().aeJ((((("'" + this.VC) + "' expected but ") + found) + " found"), in$1.a39(((start - offset) | 0)));
  }
});
$p.i = (function(v1) {
  return this.lh(v1);
});
var $d_s_util_parsing_combinator_RegexParsers$$anon$1 = new $TypeData().i($c_s_util_parsing_combinator_RegexParsers$$anon$1, "scala.util.parsing.combinator.RegexParsers$$anon$1", ({
  Nb: 1,
  cb: 1,
  h: 1
}));
/** @constructor */
function $c_s_util_parsing_combinator_RegexParsers$$anon$2(r$2, outer) {
  this.Di = null;
  this.vM = null;
  this.adv = null;
  this.a26 = null;
  this.adv = r$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.a26 = outer;
  $ct_s_util_parsing_combinator_Parsers$Parser__s_util_parsing_combinator_Parsers__(this, outer);
}
$p = $c_s_util_parsing_combinator_RegexParsers$$anon$2.prototype = new $h_s_util_parsing_combinator_Parsers$Parser();
$p.constructor = $c_s_util_parsing_combinator_RegexParsers$$anon$2;
/** @constructor */
function $h_s_util_parsing_combinator_RegexParsers$$anon$2() {
}
$h_s_util_parsing_combinator_RegexParsers$$anon$2.prototype = $p;
$p.lh = (function(in$1) {
  var source = in$1.pi;
  var offset = in$1.ph;
  var start = $f_s_util_parsing_combinator_RegexParsers__handleWhiteSpace__jl_CharSequence__I__I(this.a26, source, offset);
  var x4 = this.adv.Pk($ct_s_util_parsing_combinator_SubSequence__jl_CharSequence__I__(new $c_s_util_parsing_combinator_SubSequence(), source, start));
  if ((x4 instanceof $c_s_Some)) {
    var matched = x4.J;
    var this$2 = this.a26;
    return new $c_s_util_parsing_combinator_Parsers$$anon$2($dp_toString__T($dp_subSequence__I__I__jl_CharSequence(source, start, ((start + matched.HL) | 0))), in$1.a39(((((start + matched.HL) | 0) - offset) | 0)), $m_s_None$(), this$2);
  }
  if (($m_s_None$() === x4)) {
    var found = ((start === $dp_length__I(source)) ? "end of source" : (("'" + $cToS($dp_charAt__I__C(source, start))) + "'"));
    return this.a26.aer().aeJ((((("string matching regex '" + this.adv) + "' expected but ") + found) + " found"), in$1.a39(((start - offset) | 0)));
  }
  throw new $c_s_MatchError(x4);
});
$p.i = (function(v1) {
  return this.lh(v1);
});
var $d_s_util_parsing_combinator_RegexParsers$$anon$2 = new $TypeData().i($c_s_util_parsing_combinator_RegexParsers$$anon$2, "scala.util.parsing.combinator.RegexParsers$$anon$2", ({
  Nc: 1,
  cb: 1,
  h: 1
}));
/** @constructor */
function $c_s_util_parsing_input_PositionCache$$anon$1() {
}
$p = $c_s_util_parsing_input_PositionCache$$anon$1.prototype = new $h_ju_AbstractMap();
$p.constructor = $c_s_util_parsing_input_PositionCache$$anon$1;
/** @constructor */
function $h_s_util_parsing_input_PositionCache$$anon$1() {
}
$h_s_util_parsing_input_PositionCache$$anon$1.prototype = $p;
$p.Ph = (function() {
  return $m_ju_Collections$().aVR();
});
$p.aRf = (function(x$0, x$1) {
  return null;
});
var $d_s_util_parsing_input_PositionCache$$anon$1 = new $TypeData().i($c_s_util_parsing_input_PositionCache$$anon$1, "scala.util.parsing.input.PositionCache$$anon$1", ({
  Nh: 1,
  f9: 1,
  cn: 1
}));
/** @constructor */
function $c_Lujson_Arr$() {
}
$p = $c_Lujson_Arr$.prototype = new $h_O();
$p.constructor = $c_Lujson_Arr$;
/** @constructor */
function $h_Lujson_Arr$() {
}
$h_Lujson_Arr$.prototype = $p;
$p.a3u = (function(items, conv) {
  var buf = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  var this$2 = items.o();
  while (this$2.p()) {
    var x0 = this$2.q();
    buf.aw(conv.i(x0));
  }
  return new $c_Lujson_Arr(buf);
});
$p.aXu = (function(items) {
  var buf = $ct_scm_ArrayBuffer__I__(new $c_scm_ArrayBuffer(), items.C());
  items.F(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((item) => buf.aw(item))));
  return new $c_Lujson_Arr(buf);
});
var $d_Lujson_Arr$ = new $TypeData().i($c_Lujson_Arr$, "ujson.Arr$", ({
  Np: 1,
  d: 1,
  j: 1
}));
var $n_Lujson_Arr$;
function $m_Lujson_Arr$() {
  if ((!$n_Lujson_Arr$)) {
    $n_Lujson_Arr$ = new $c_Lujson_Arr$();
  }
  return $n_Lujson_Arr$;
}
/** @constructor */
function $c_Lujson_AstTransformer$AstArrVisitor(outer, build, factory) {
  this.aJz = null;
  this.adw = null;
  this.aJy = null;
  this.aJz = build;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aJy = outer;
  this.adw = factory.b5();
}
$p = $c_Lujson_AstTransformer$AstArrVisitor.prototype = new $h_O();
$p.constructor = $c_Lujson_AstTransformer$AstArrVisitor;
/** @constructor */
function $h_Lujson_AstTransformer$AstArrVisitor() {
}
$h_Lujson_AstTransformer$AstArrVisitor.prototype = $p;
$p.jr = (function() {
  return false;
});
$p.h6 = (function() {
  return this;
});
$p.d9 = (function() {
  return this.aJy;
});
$p.cU = (function(v, index) {
  this.adw.Y(v);
});
$p.bV = (function(index) {
  return this.aJz.i(this.adw.aR());
});
var $d_Lujson_AstTransformer$AstArrVisitor = new $TypeData().i($c_Lujson_AstTransformer$AstArrVisitor, "ujson.AstTransformer$AstArrVisitor", ({
  Nr: 1,
  ab: 1,
  b5: 1
}));
/** @constructor */
function $c_Lujson_AstTransformer$AstObjVisitor(outer, build, factory) {
  this.aJB = null;
  this.adx = null;
  this.ady = null;
  this.aJA = null;
  this.aJB = build;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aJA = outer;
  this.adx = null;
  this.ady = factory.b5();
}
$p = $c_Lujson_AstTransformer$AstObjVisitor.prototype = new $h_O();
$p.constructor = $c_Lujson_AstTransformer$AstObjVisitor;
/** @constructor */
function $h_Lujson_AstTransformer$AstObjVisitor() {
}
$h_Lujson_AstTransformer$AstObjVisitor.prototype = $p;
$p.jr = (function() {
  return true;
});
$p.d9 = (function() {
  return this.aJA;
});
$p.jy = (function(index) {
  return $m_Lupickle_core_StringVisitor$();
});
$p.jz = (function(s) {
  this.adx = $dp_toString__T(s);
});
$p.cU = (function(v, index) {
  this.ady.Y(new $c_T2(this.adx, v));
});
$p.bV = (function(index) {
  return this.aJB.i(this.ady.aR());
});
$p.h6 = (function() {
  return this;
});
var $d_Lujson_AstTransformer$AstObjVisitor = new $TypeData().i($c_Lujson_AstTransformer$AstObjVisitor, "ujson.AstTransformer$AstObjVisitor", ({
  Ns: 1,
  ab: 1,
  aO: 1
}));
function $ct_Lujson_BaseCharRenderer__Ljava_io_Writer__I__Z__($thiz, out, indent, escapeUnicode) {
  $thiz.nu = out;
  $thiz.Oj = indent;
  $thiz.a28 = escapeUnicode;
  $thiz.e1 = new $c_Lupickle_core_CharBuilder(32);
  $thiz.a29 = new $c_Lupickle_core_CharBuilder(32);
  $thiz.qM = 0;
  $thiz.Ol = false;
  $thiz.vN = false;
  $thiz.qN = false;
  $thiz.Ok = false;
  return $thiz;
}
/** @constructor */
function $c_Lujson_BaseCharRenderer() {
  this.nu = null;
  this.Oj = 0;
  this.a28 = false;
  this.e1 = null;
  this.a29 = null;
  this.qM = 0;
  this.Ol = false;
  this.vN = false;
  this.qN = false;
  this.Ok = false;
}
$p = $c_Lujson_BaseCharRenderer.prototype = new $h_O();
$p.constructor = $c_Lujson_BaseCharRenderer;
/** @constructor */
function $h_Lujson_BaseCharRenderer() {
}
$h_Lujson_BaseCharRenderer.prototype = $p;
$p.ge = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.fA = (function(s, index) {
  return $f_Lujson_JsVisitor__visitFloat64String__T__I__O(this, s, index);
});
$p.fb = (function(bytes, offset, len, index) {
  return $f_Lujson_JsVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.fd = (function(tag, bytes, offset, len, index) {
  return $f_Lujson_JsVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.fc = (function(s, index) {
  return this.aTq(("" + $cToS(s)), index);
});
$p.bQ = (function(length, jsonableKeys, index) {
  return $f_Lujson_JsVisitor__visitObject__I__Z__I__Lupickle_core_ObjVisitor(this, length, jsonableKeys, index);
});
$p.w2 = (function() {
  this.e1.bcy(this.nu, ((this.qM === 0) ? 0 : 1000));
});
$p.tZ = (function() {
  if (this.vN) {
    this.vN = false;
    this.e1.jS(44);
  }
  if (this.qN) {
    this.qN = false;
    this.ahD();
  }
  if (this.Ok) {
    this.Ok = false;
    this.e1.jS(34);
  }
});
$p.cZ = (function(length, index) {
  return new $c_Lujson_BaseCharRenderer$$anon$1(this);
});
$p.aTn = (function(length, index) {
  return new $c_Lujson_BaseCharRenderer$$anon$2(this);
});
$p.aTo = (function(index) {
  this.tZ();
  $m_Lujson_BaseCharRenderer$().baA(this.e1);
  this.w2();
  return this.nu;
});
$p.bbv = (function(index) {
  this.tZ();
  $m_Lujson_BaseCharRenderer$().bay(this.e1);
  this.w2();
  return this.nu;
});
$p.bbN = (function(index) {
  this.tZ();
  $m_Lujson_BaseCharRenderer$().baB(this.e1);
  this.w2();
  return this.nu;
});
$p.bbJ = (function(s, decIndex, expIndex, index) {
  this.tZ();
  $m_Lujson_BaseCharRenderer$().aim(this.e1, s);
  this.w2();
  return this.nu;
});
$p.bbw = (function(d, index) {
  if ((Infinity === d)) {
    this.JJ("Infinity", (-1));
  } else if (((-Infinity) === d)) {
    this.JJ("-Infinity", (-1));
  } else if ((d !== d)) {
    this.JJ("NaN", (-1));
  } else {
    var i = $doubleToInt(d);
    if ((d === Math.fround(i))) {
      this.a5f(i, index);
    } else {
      var $x_1 = $m_RTLong$().d1(d);
      var i$2_$_lo = $x_1.l;
      var i$2_$_hi = $x_1.h;
      this.tZ();
      var compressedLo = (((((-2097152) & (i$2_$_hi ^ (i$2_$_hi >> 10))) === 0) || ((65535 & i$2_$_lo) === 0)) ? i$2_$_lo : (32768 | ((-32768) & i$2_$_lo)));
      if ((Math.fround(((4.294967296E9 * i$2_$_hi) + (compressedLo >>> 0.0))) === d)) {
        $m_Lujson_BaseCharRenderer$().aim(this.e1, ("" + d));
      } else {
        this.e1.ps(15);
        this.e1.cD = ((this.e1.cD + $m_Lujson_MathUtilsChar$().aSY(this.e1.gx, this.e1.cD, ("" + d))) | 0);
      }
      this.w2();
    }
  }
  return this.nu;
});
$p.bby = (function(d, index) {
  if ((Infinity === d)) {
    this.JJ("Infinity", (-1));
  } else if (((-Infinity) === d)) {
    this.JJ("-Infinity", (-1));
  } else if ((d !== d)) {
    this.JJ("NaN", (-1));
  } else {
    var i = $doubleToInt(d);
    if ((d === i)) {
      this.a5f(i, index);
    } else {
      var $x_1 = $m_RTLong$().d1(d);
      var i$2_$_lo = $x_1.l;
      var i$2_$_hi = $x_1.h;
      this.tZ();
      if ((((4.294967296E9 * i$2_$_hi) + (i$2_$_lo >>> 0.0)) === d)) {
        $m_Lujson_BaseCharRenderer$().aim(this.e1, $m_RTLong$().kY(i$2_$_lo, i$2_$_hi));
      } else {
        this.e1.ps(24);
        this.e1.cD = ((this.e1.cD + $m_Lujson_MathUtilsChar$().aSY(this.e1.gx, this.e1.cD, ("" + d))) | 0);
      }
      this.w2();
    }
  }
  return this.nu;
});
$p.a5f = (function(i, index) {
  this.tZ();
  $m_Lujson_BaseCharRenderer$().baz(this.e1, i);
  this.w2();
  return this.nu;
});
$p.bbL = (function(i_$_lo, i_$_hi, index) {
  this.tZ();
  var sign = (i_$_hi >> 31);
  var xlo = (i_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((i_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  if ((((rhi === 2097152) ? (rlo !== 0) : (rhi > 2097152)) || ((i_$_lo | ((-2147483648) ^ i_$_hi)) === 0))) {
    this.e1.jS(34);
    $m_Lujson_BaseCharRenderer$().aT8(this.e1, i_$_lo, i_$_hi);
    this.e1.jS(34);
  } else {
    $m_Lujson_BaseCharRenderer$().aT8(this.e1, i_$_lo, i_$_hi);
  }
  this.w2();
  return this.nu;
});
$p.bbO = (function(i_$_lo, i_$_hi, index) {
  if ((((i_$_lo ^ i_$_lo) | ((i_$_lo >> 31) ^ i_$_hi)) === 0)) {
    this.a5f(i_$_lo, index);
  } else {
    $f_Lujson_JsVisitor__visitUInt64__J__I__O(this, i_$_lo, i_$_hi, index);
  }
  return this.nu;
});
$p.aTq = (function(s, index) {
  return ((s === null) ? this.aTo(index) : this.JJ(s, index));
});
$p.JJ = (function(s, index) {
  this.tZ();
  $m_Lupickle_core_RenderUtils$().aNR(this.a29, this.e1, s, this.a28, (!this.Ol));
  this.w2();
  return this.nu;
});
$p.ahD = (function() {
  if ((this.Oj !== (-1))) {
    var i = Math.imul(this.Oj, this.qM);
    this.e1.ps(((1 + i) | 0));
    $m_Lujson_BaseCharRenderer$().baC(this.e1.gx, this.e1.cD, i);
    this.e1.cD = ((this.e1.cD + ((1 + i) | 0)) | 0);
  }
});
$p.c8 = (function(index) {
  return this.aTo(index);
});
$p.eC = (function(index) {
  return this.bbv(index);
});
$p.eE = (function(index) {
  return this.bbN(index);
});
$p.eD = (function(s, decIndex, expIndex, index) {
  return this.bbJ(s, decIndex, expIndex, index);
});
$p.eY = (function(d, index) {
  return this.bbw(d, index);
});
$p.e7 = (function(d, index) {
  return this.bby(d, index);
});
$p.em = (function(i, index) {
  return this.a5f(i, index);
});
$p.eZ = (function(i_$_lo, i_$_hi, index) {
  return this.bbL(i_$_lo, i_$_hi, index);
});
$p.fe = (function(i_$_lo, i_$_hi, index) {
  return this.bbO(i_$_lo, i_$_hi, index);
});
$p.cN = (function(s, index) {
  return this.aTq(s, index);
});
/** @constructor */
function $c_Lujson_BaseCharRenderer$$anon$1(outer) {
  this.ov = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.ov = outer;
  outer.tZ();
  outer.e1.jS(91);
  outer.qM = ((1 + outer.qM) | 0);
  outer.qN = true;
}
$p = $c_Lujson_BaseCharRenderer$$anon$1.prototype = new $h_O();
$p.constructor = $c_Lujson_BaseCharRenderer$$anon$1;
/** @constructor */
function $h_Lujson_BaseCharRenderer$$anon$1() {
}
$h_Lujson_BaseCharRenderer$$anon$1.prototype = $p;
$p.jr = (function() {
  return false;
});
$p.h6 = (function() {
  return this;
});
$p.d9 = (function() {
  return this.ov;
});
$p.aiB = (function(v, index) {
  this.ov.tZ();
  this.ov.vN = true;
  this.ov.qN = true;
});
$p.aiA = (function(index) {
  this.ov.qM = ((this.ov.qM - 1) | 0);
  if ((this.ov.qN && this.ov.vN)) {
    this.ov.ahD();
  }
  this.ov.vN = false;
  this.ov.qN = false;
  this.ov.e1.jS(93);
  this.ov.w2();
  return this.ov.nu;
});
$p.cU = (function(v, index) {
  this.aiB(v, index);
});
$p.bV = (function(index) {
  return this.aiA(index);
});
var $d_Lujson_BaseCharRenderer$$anon$1 = new $TypeData().i($c_Lujson_BaseCharRenderer$$anon$1, "ujson.BaseCharRenderer$$anon$1", ({
  Nu: 1,
  ab: 1,
  b5: 1
}));
/** @constructor */
function $c_Lujson_BaseCharRenderer$$anon$2(outer) {
  this.jP = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.jP = outer;
  outer.tZ();
  outer.e1.jS(123);
  outer.qM = ((1 + outer.qM) | 0);
  outer.qN = true;
}
$p = $c_Lujson_BaseCharRenderer$$anon$2.prototype = new $h_O();
$p.constructor = $c_Lujson_BaseCharRenderer$$anon$2;
/** @constructor */
function $h_Lujson_BaseCharRenderer$$anon$2() {
}
$h_Lujson_BaseCharRenderer$$anon$2.prototype = $p;
$p.jr = (function() {
  return true;
});
$p.d9 = (function() {
  return this.jP;
});
$p.jy = (function(index) {
  this.jP.Ok = true;
  this.jP.Ol = true;
  return this.jP;
});
$p.jz = (function(s) {
  this.jP.e1.jS(34);
  this.jP.Ol = false;
  this.jP.e1.jS(58);
  if ((this.jP.Oj !== (-1))) {
    this.jP.e1.jS(32);
  }
});
$p.aiB = (function(v, index) {
  this.jP.vN = true;
  this.jP.qN = true;
});
$p.aiA = (function(index) {
  this.jP.qM = ((this.jP.qM - 1) | 0);
  if ((this.jP.qN && this.jP.vN)) {
    this.jP.ahD();
  }
  this.jP.vN = false;
  this.jP.qN = false;
  this.jP.e1.jS(125);
  this.jP.w2();
  return this.jP.nu;
});
$p.cU = (function(v, index) {
  this.aiB(v, index);
});
$p.bV = (function(index) {
  return this.aiA(index);
});
$p.h6 = (function() {
  return this;
});
var $d_Lujson_BaseCharRenderer$$anon$2 = new $TypeData().i($c_Lujson_BaseCharRenderer$$anon$2, "ujson.BaseCharRenderer$$anon$2", ({
  Nv: 1,
  ab: 1,
  aO: 1
}));
/** @constructor */
function $c_Lujson_JsVisitor$$anon$1(length$1, index$1, outer) {
  this.a2d = null;
  this.adA = 0;
  this.VH = null;
  this.adz = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.adz = outer;
  this.a2d = outer.cZ(length$1, index$1);
  this.adA = (-1);
  this.VH = null;
}
$p = $c_Lujson_JsVisitor$$anon$1.prototype = new $h_O();
$p.constructor = $c_Lujson_JsVisitor$$anon$1;
/** @constructor */
function $h_Lujson_JsVisitor$$anon$1() {
}
$h_Lujson_JsVisitor$$anon$1.prototype = $p;
$p.jr = (function() {
  return true;
});
$p.d9 = (function() {
  return this.adz;
});
$p.jy = (function(index) {
  this.VH = this.a2d.d9().cZ(2, index);
  this.adA = index;
  return this.adz;
});
$p.jz = (function(s) {
  this.VH.cU(s, this.adA);
});
$p.cU = (function(v, index) {
  this.VH.cU(v, index);
  this.a2d.cU(this.VH.bV(index), index);
});
$p.bV = (function(index) {
  return this.a2d.bV(index);
});
$p.h6 = (function() {
  return this;
});
var $d_Lujson_JsVisitor$$anon$1 = new $TypeData().i($c_Lujson_JsVisitor$$anon$1, "ujson.JsVisitor$$anon$1", ({
  Nz: 1,
  ab: 1,
  aO: 1
}));
/** @constructor */
function $c_Lujson_Obj$() {
}
$p = $c_Lujson_Obj$.prototype = new $h_O();
$p.constructor = $c_Lujson_Obj$;
/** @constructor */
function $h_Lujson_Obj$() {
}
$h_Lujson_Obj$.prototype = $p;
$p.ag3 = (function(items) {
  return new $c_Lujson_Obj($m_Lupickle_core_LinkedHashMap$().aXq(items));
});
var $d_Lujson_Obj$ = new $TypeData().i($c_Lujson_Obj$, "ujson.Obj$", ({
  NC: 1,
  d: 1,
  j: 1
}));
var $n_Lujson_Obj$;
function $m_Lujson_Obj$() {
  if ((!$n_Lujson_Obj$)) {
    $n_Lujson_Obj$ = new $c_Lujson_Obj$();
  }
  return $n_Lujson_Obj$;
}
/** @constructor */
function $c_Lujson_StringParser(s) {
  this.Dl = null;
  this.HO = 0;
  this.xO = 0;
  this.HP = 0;
  this.Dk = null;
  this.mF = null;
  this.aJD = null;
  this.adB = 0;
  this.aJD = s;
  $ct_Lujson_CharParser__(this);
  this.adB = s.length;
}
$p = $c_Lujson_StringParser.prototype = new $h_Lujson_CharParser();
$p.constructor = $c_Lujson_StringParser;
/** @constructor */
function $h_Lujson_StringParser() {
}
$h_Lujson_StringParser.prototype = $p;
$p.b7b = (function(buffer, bufferOffset) {
  return ((buffer === null) ? new $c_T3($f_T__toCharArray__AC(this.aJD), (this.adB === 0), this.adB) : new $c_T3(buffer, true, (-1)));
});
var $d_Lujson_StringParser = new $TypeData().i($c_Lujson_StringParser, "ujson.StringParser", ({
  NF: 1,
  Nw: 1,
  Oh: 1
}));
/** @constructor */
function $c_Lujson_StringParser$() {
}
$p = $c_Lujson_StringParser$.prototype = new $h_O();
$p.constructor = $c_Lujson_StringParser$;
/** @constructor */
function $h_Lujson_StringParser$() {
}
$h_Lujson_StringParser$.prototype = $p;
$p.baq = (function(j, f) {
  return new $c_Lujson_StringParser(j).b6s(f);
});
$p.cy = (function(j, f) {
  return this.baq(j, f);
});
var $d_Lujson_StringParser$ = new $TypeData().i($c_Lujson_StringParser$, "ujson.StringParser$", ({
  NG: 1,
  B: 1,
  e5: 1
}));
var $n_Lujson_StringParser$;
function $m_Lujson_StringParser$() {
  if ((!$n_Lujson_StringParser$)) {
    $n_Lujson_StringParser$ = new $c_Lujson_StringParser$();
  }
  return $n_Lujson_StringParser$;
}
function $f_Lujson_Value__strOpt__s_Option($thiz) {
  return (($thiz instanceof $c_Lujson_Str) ? new $c_s_Some($thiz.xP) : $m_s_None$());
}
function $f_Lujson_Value__obj__Lupickle_core_LinkedHashMap($thiz) {
  if (($thiz instanceof $c_Lujson_Obj)) {
    return $thiz.tM;
  }
  throw new $c_Lujson_Value$InvalidData($thiz, "Expected ujson.Obj");
}
function $f_Lujson_Value__objOpt__s_Option($thiz) {
  return (($thiz instanceof $c_Lujson_Obj) ? new $c_s_Some($thiz.tM) : $m_s_None$());
}
function $f_Lujson_Value__arr__scm_ArrayBuffer($thiz) {
  if (($thiz instanceof $c_Lujson_Arr)) {
    return $thiz.Dj;
  }
  throw new $c_Lujson_Value$InvalidData($thiz, "Expected ujson.Arr");
}
function $f_Lujson_Value__arrOpt__s_Option($thiz) {
  return (($thiz instanceof $c_Lujson_Arr) ? new $c_s_Some($thiz.Dj) : $m_s_None$());
}
function $f_Lujson_Value__numOpt__s_Option($thiz) {
  return (($thiz instanceof $c_Lujson_Num) ? new $c_s_Some($thiz.HQ) : $m_s_None$());
}
function $f_Lujson_Value__render__I__Z__T($thiz, indent, escapeUnicode) {
  return $m_Lujson_Value$().yp($thiz, new $c_Lujson_StringRenderer(indent, escapeUnicode)).m();
}
var $d_Lujson_Value = new $TypeData().i(1, "ujson.Value", ({
  bk: 1,
  b4: 1,
  ac: 1
}));
var $d_Lupack_Msg = new $TypeData().i(1, "upack.Msg", ({
  aJ: 1,
  aC: 1,
  ac: 1
}));
/** @constructor */
function $c_Lupack_Msg$$anon$1() {
  this.adC = null;
  this.adC = $m_scm_ArrayBuffer$().y9($m_sr_ScalaRunTime$().f(new ($d_Lupack_Msg.r().C)([])));
}
$p = $c_Lupack_Msg$$anon$1.prototype = new $h_O();
$p.constructor = $c_Lupack_Msg$$anon$1;
/** @constructor */
function $h_Lupack_Msg$$anon$1() {
}
$h_Lupack_Msg$$anon$1.prototype = $p;
$p.jr = (function() {
  return false;
});
$p.h6 = (function() {
  return this;
});
$p.d9 = (function() {
  return $m_Lupack_Msg$();
});
$p.cU = (function(v, index) {
  this.adC.aw(v);
});
$p.bV = (function(index) {
  return new $c_Lupack_Arr(this.adC);
});
var $d_Lupack_Msg$$anon$1 = new $TypeData().i($c_Lupack_Msg$$anon$1, "upack.Msg$$anon$1", ({
  NM: 1,
  ab: 1,
  b5: 1
}));
/** @constructor */
function $c_Lupack_Msg$$anon$2() {
  this.adE = null;
  this.adD = null;
  this.adE = new $c_Lupickle_core_LinkedHashMap($ct_ju_LinkedHashMap__(new $c_ju_LinkedHashMap()));
  this.adD = null;
}
$p = $c_Lupack_Msg$$anon$2.prototype = new $h_O();
$p.constructor = $c_Lupack_Msg$$anon$2;
/** @constructor */
function $h_Lupack_Msg$$anon$2() {
}
$h_Lupack_Msg$$anon$2.prototype = $p;
$p.jr = (function() {
  return true;
});
$p.d9 = (function() {
  return $m_Lupack_Msg$();
});
$p.jy = (function(index) {
  return $m_Lupack_Msg$();
});
$p.jz = (function(s) {
  this.adD = s;
});
$p.cU = (function(v, index) {
  $f_scm_MapOps__update__O__O__V(this.adE, this.adD, v);
});
$p.bV = (function(index) {
  return new $c_Lupack_Obj(this.adE);
});
$p.h6 = (function() {
  return this;
});
var $d_Lupack_Msg$$anon$2 = new $TypeData().i($c_Lupack_Msg$$anon$2, "upack.Msg$$anon$2", ({
  NN: 1,
  ab: 1,
  aO: 1
}));
function $p_Lupickle_AttributeTagged$$anon$6__missingKeyMsg$1__T($thiz) {
  return (("Missing key \"" + $thiz.HR.Js()) + "\" for tagged dictionary");
}
/** @constructor */
function $c_Lupickle_AttributeTagged$$anon$6(taggedReader$4, index$2, outer) {
  this.HR = null;
  this.adH = 0;
  this.adG = false;
  this.pj = null;
  this.a2g = null;
  this.HR = taggedReader$4;
  this.adH = index$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.a2g = outer;
  this.adG = false;
  this.pj = null;
}
$p = $c_Lupickle_AttributeTagged$$anon$6.prototype = new $h_O();
$p.constructor = $c_Lupickle_AttributeTagged$$anon$6;
/** @constructor */
function $h_Lupickle_AttributeTagged$$anon$6() {
}
$h_Lupickle_AttributeTagged$$anon$6.prototype = $p;
$p.jr = (function() {
  return true;
});
$p.d9 = (function() {
  return ((this.pj === null) ? $m_Lupickle_core_StringVisitor$() : this.pj.d9());
});
$p.jy = (function(index) {
  return ((this.pj !== null) ? this.pj.jy(index) : $m_Lupickle_core_StringVisitor$());
});
$p.jz = (function(s) {
  if ((this.pj !== null)) {
    this.pj.jz(s);
  } else if ((!$f_Lupickle_AttributeTagged__upickle$AttributeTagged$$isTagName__T__O__Z(this.a2g, this.HR.Js(), s))) {
    var this$3 = new $c_Lupickle_core_BufferedValue$Builder$$anon$10(true, this.adH);
    var xxx = new $c_Lupickle_core_BufferedValue$Str($dp_toString__T(s), this.adH);
    this$3.adI = xxx;
    this.pj = this$3;
  }
});
$p.cU = (function(v, index) {
  if ((this.pj !== null)) {
    this.pj.cU(v, index);
  } else {
    var s = $dp_toString__T(v);
    var facade0 = this.HR.IW(s);
    if ((facade0 === null)) {
      throw new $c_Lupickle_core_Abort(("invalid tag for tagged object: " + s));
    }
    var fastCtx = facade0.bQ((-1), true, index);
    this.pj = fastCtx;
    this.adG = true;
  }
});
$p.bV = (function(index) {
  if ((this.pj === null)) {
    throw new $c_Lupickle_core_Abort($p_Lupickle_AttributeTagged$$anon$6__missingKeyMsg$1__T(this));
  } else if (this.adG) {
    return this.pj.bV(index);
  } else {
    var x = this.pj.bV(index);
    var this$1 = x.xQ;
    _return: {
      var it = this$1.bB().o();
      while (it.p()) {
        var a = it.q();
        if ($f_Lupickle_AttributeTagged__upickle$AttributeTagged$$isTagName__T__O__Z(this.a2g, this.HR.Js(), a.g())) {
          var this$3 = new $c_s_Some(a);
          break _return;
        }
      }
      var this$3 = $m_s_None$();
    }
    if (this$3.c()) {
      throw new $c_Lupickle_core_Abort($p_Lupickle_AttributeTagged$$anon$6__missingKeyMsg$1__T(this));
    }
    var keyAttr = this$3.d().h();
    var key = $dp_toString__T(keyAttr.Ab);
    var delegate = this.HR.IW(key);
    if ((delegate === null)) {
      throw new $c_Lupickle_core_AbortException(("invalid tag for tagged object: " + key), keyAttr.kr(), (-1), (-1), null);
    }
    var ctx2 = delegate.bQ((-1), true, (-1));
    var this$4 = x.xQ;
    var it$1 = this$4.bB().o();
    while (it$1.p()) {
      var x0 = it$1.q();
      matchResult17: {
        var \u03b41$___1;
        var \u03b41$___2;
        if ((x0 !== null)) {
          var \u03b41$___1 = x0.g();
          var \u03b41$___2 = x0.h();
          break matchResult17;
        }
        throw new $c_s_MatchError(x0);
      }
      var k0$2 = \u03b41$___1;
      var v$2 = \u03b41$___2;
      if ((!$f_Lupickle_AttributeTagged__upickle$AttributeTagged$$isTagName__T__O__Z(this.a2g, this.HR.Js(), k0$2))) {
        var keyVisitor = ctx2.jy((-1));
        ctx2.jz($m_Lupickle_core_BufferedValue$().JC(k0$2, keyVisitor));
        ctx2.cU($m_Lupickle_core_BufferedValue$().JC(v$2, ctx2.d9()), (-1));
      }
    }
    return ctx2.bV(index);
  }
});
$p.h6 = (function() {
  return this;
});
var $d_Lupickle_AttributeTagged$$anon$6 = new $TypeData().i($c_Lupickle_AttributeTagged$$anon$6, "upickle.AttributeTagged$$anon$6", ({
  NV: 1,
  ab: 1,
  aO: 1
}));
/** @constructor */
function $c_Lupickle_LowPriReadWriters$$anon$1(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lupickle_LowPriReadWriters$$anon$1.prototype = new $h_O();
$p.constructor = $c_Lupickle_LowPriReadWriters$$anon$1;
/** @constructor */
function $h_Lupickle_LowPriReadWriters$$anon$1() {
}
$h_Lupickle_LowPriReadWriters$$anon$1.prototype = $p;
$p.cT = (function() {
  return false;
});
$p.cW = (function() {
  return this;
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.d0 = (function(out, v) {
  return $m_Lupickle_core_BufferedValue$().a4b($m_Lujson_Readable$(), v, false, out);
});
var $d_Lupickle_LowPriReadWriters$$anon$1 = new $TypeData().i($c_Lupickle_LowPriReadWriters$$anon$1, "upickle.LowPriReadWriters$$anon$1", ({
  NY: 1,
  B: 1,
  E: 1
}));
/** @constructor */
function $c_Lupickle_MsgReadWriters$$anon$1(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lupickle_MsgReadWriters$$anon$1.prototype = new $h_O();
$p.constructor = $c_Lupickle_MsgReadWriters$$anon$1;
/** @constructor */
function $h_Lupickle_MsgReadWriters$$anon$1() {
}
$h_Lupickle_MsgReadWriters$$anon$1.prototype = $p;
$p.cT = (function() {
  return false;
});
$p.cW = (function() {
  return this;
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.d0 = (function(out, v) {
  return $m_Lupack_Msg$().a54(v, out);
});
var $d_Lupickle_MsgReadWriters$$anon$1 = new $TypeData().i($c_Lupickle_MsgReadWriters$$anon$1, "upickle.MsgReadWriters$$anon$1", ({
  O0: 1,
  B: 1,
  E: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$Builder$$anon$10(jsonableKeys$2, i$6) {
  this.aJI = false;
  this.aJH = 0;
  this.adJ = null;
  this.adI = null;
  this.aJI = jsonableKeys$2;
  this.aJH = i$6;
  this.adJ = ($m_scm_ArrayBuffer$(), $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer()));
}
$p = $c_Lupickle_core_BufferedValue$Builder$$anon$10.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_BufferedValue$Builder$$anon$10;
/** @constructor */
function $h_Lupickle_core_BufferedValue$Builder$$anon$10() {
}
$h_Lupickle_core_BufferedValue$Builder$$anon$10.prototype = $p;
$p.jr = (function() {
  return true;
});
$p.d9 = (function() {
  return $m_Lupickle_core_BufferedValue$Builder$();
});
$p.jy = (function(index) {
  return $m_Lupickle_core_BufferedValue$Builder$();
});
$p.jz = (function(s) {
  this.adI = s;
});
$p.bbP = (function(v, index) {
  this.adJ.aw(new $c_T2(this.adI, v));
});
$p.bbt = (function(index) {
  return new $c_Lupickle_core_BufferedValue$Obj(this.adJ, this.aJI, this.aJH);
});
$p.cU = (function(v, index) {
  this.bbP(v, index);
});
$p.bV = (function(index) {
  return this.bbt(index);
});
$p.h6 = (function() {
  return this;
});
var $d_Lupickle_core_BufferedValue$Builder$$anon$10 = new $TypeData().i($c_Lupickle_core_BufferedValue$Builder$$anon$10, "upickle.core.BufferedValue$Builder$$anon$10", ({
  Of: 1,
  ab: 1,
  aO: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$Builder$$anon$9(i$5) {
  this.aJJ = 0;
  this.adK = null;
  this.aJJ = i$5;
  this.adK = ($m_scm_ArrayBuffer$(), $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer()));
}
$p = $c_Lupickle_core_BufferedValue$Builder$$anon$9.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_BufferedValue$Builder$$anon$9;
/** @constructor */
function $h_Lupickle_core_BufferedValue$Builder$$anon$9() {
}
$h_Lupickle_core_BufferedValue$Builder$$anon$9.prototype = $p;
$p.jr = (function() {
  return false;
});
$p.h6 = (function() {
  return this;
});
$p.d9 = (function() {
  return $m_Lupickle_core_BufferedValue$Builder$();
});
$p.bbs = (function(index) {
  return new $c_Lupickle_core_BufferedValue$Arr(this.adK, this.aJJ);
});
$p.cU = (function(v, index) {
  this.adK.aw(v);
});
$p.bV = (function(index) {
  return this.bbs(index);
});
var $d_Lupickle_core_BufferedValue$Builder$$anon$9 = new $TypeData().i($c_Lupickle_core_BufferedValue$Builder$$anon$9, "upickle.core.BufferedValue$Builder$$anon$9", ({
  Og: 1,
  ab: 1,
  b5: 1
}));
/** @constructor */
function $c_Lupickle_core_NoOpVisitor$$anon$1() {
}
$p = $c_Lupickle_core_NoOpVisitor$$anon$1.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_NoOpVisitor$$anon$1;
/** @constructor */
function $h_Lupickle_core_NoOpVisitor$$anon$1() {
}
$h_Lupickle_core_NoOpVisitor$$anon$1.prototype = $p;
$p.jr = (function() {
  return false;
});
$p.h6 = (function() {
  return this;
});
$p.d9 = (function() {
  return $m_Lupickle_core_NoOpVisitor$();
});
$p.cU = (function(v, index) {
});
$p.bV = (function(index) {
  return (void 0);
});
var $d_Lupickle_core_NoOpVisitor$$anon$1 = new $TypeData().i($c_Lupickle_core_NoOpVisitor$$anon$1, "upickle.core.NoOpVisitor$$anon$1", ({
  Or: 1,
  ab: 1,
  b5: 1
}));
/** @constructor */
function $c_Lupickle_core_NoOpVisitor$$anon$2() {
}
$p = $c_Lupickle_core_NoOpVisitor$$anon$2.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_NoOpVisitor$$anon$2;
/** @constructor */
function $h_Lupickle_core_NoOpVisitor$$anon$2() {
}
$h_Lupickle_core_NoOpVisitor$$anon$2.prototype = $p;
$p.jr = (function() {
  return true;
});
$p.d9 = (function() {
  return $m_Lupickle_core_NoOpVisitor$();
});
$p.jy = (function(index) {
  return $m_Lupickle_core_NoOpVisitor$();
});
$p.jz = (function(s) {
});
$p.cU = (function(v, index) {
});
$p.bV = (function(index) {
  return (void 0);
});
$p.h6 = (function() {
  return this;
});
var $d_Lupickle_core_NoOpVisitor$$anon$2 = new $TypeData().i($c_Lupickle_core_NoOpVisitor$$anon$2, "upickle.core.NoOpVisitor$$anon$2", ({
  Os: 1,
  ab: 1,
  aO: 1
}));
/** @constructor */
function $c_Lupickle_core_StringVisitor$() {
}
$p = $c_Lupickle_core_StringVisitor$.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_StringVisitor$;
/** @constructor */
function $h_Lupickle_core_StringVisitor$() {
}
$h_Lupickle_core_StringVisitor$.prototype = $p;
$p.ge = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.c8 = (function(index) {
  return null;
});
$p.eD = (function(s, decIndex, expIndex, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64StringParts__jl_CharSequence__I__I__I__O(this, s, decIndex, expIndex, index);
});
$p.bQ = (function(length, jsonableKeys, index) {
  return $f_Lupickle_core_SimpleVisitor__visitObject__I__Z__I__Lupickle_core_ObjVisitor(this, length, jsonableKeys, index);
});
$p.cZ = (function(length, index) {
  return $f_Lupickle_core_SimpleVisitor__visitArray__I__I__Lupickle_core_ArrVisitor(this, length, index);
});
$p.fA = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64String__T__I__O(this, s, index);
});
$p.fb = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.fd = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.ej = (function() {
  return "expected string";
});
$p.cN = (function(s, index) {
  return $dp_toString__T(s);
});
$p.em = (function(d, index) {
  return ("" + d);
});
$p.eZ = (function(d_$_lo, d_$_hi, index) {
  return $m_RTLong$().kY(d_$_lo, d_$_hi);
});
$p.fe = (function(d_$_lo, d_$_hi, index) {
  return $m_RTLong$().kY(d_$_lo, d_$_hi);
});
$p.eY = (function(d, index) {
  var i = $doubleToInt(d);
  return ((d === Math.fround(i)) ? ("" + i) : ("" + d));
});
$p.e7 = (function(d, index) {
  var i = $doubleToInt(d);
  return ((d === i) ? ("" + i) : ("" + d));
});
$p.eE = (function(index) {
  return "true";
});
$p.eC = (function(index) {
  return "false";
});
$p.fc = (function(s, index) {
  return ("" + $cToS(s));
});
var $d_Lupickle_core_StringVisitor$ = new $TypeData().i($c_Lupickle_core_StringVisitor$, "upickle.core.StringVisitor$", ({
  Ow: 1,
  x: 1,
  J: 1
}));
var $n_Lupickle_core_StringVisitor$;
function $m_Lupickle_core_StringVisitor$() {
  if ((!$n_Lupickle_core_StringVisitor$)) {
    $n_Lupickle_core_StringVisitor$ = new $c_Lupickle_core_StringVisitor$();
  }
  return $n_Lupickle_core_StringVisitor$;
}
function $ct_Lupickle_core_TraceVisitor__Lupickle_core_Visitor__Lupickle_core_TraceVisitor$HasPath__Lupickle_core_TraceVisitor$Wrapper__($thiz, delegate, parentPath, wrapper) {
  $thiz.adM = delegate;
  $thiz.Ig = parentPath;
  $thiz.Ds = wrapper;
  $ct_Lupickle_core_Visitor$Delegate__Lupickle_core_Visitor__($thiz, delegate);
  wrapper.Ih = parentPath;
  return $thiz;
}
/** @constructor */
function $c_Lupickle_core_TraceVisitor() {
  this.iH = null;
  this.adM = null;
  this.Ig = null;
  this.Ds = null;
}
$p = $c_Lupickle_core_TraceVisitor.prototype = new $h_Lupickle_core_Visitor$Delegate();
$p.constructor = $c_Lupickle_core_TraceVisitor;
/** @constructor */
function $h_Lupickle_core_TraceVisitor() {
}
$h_Lupickle_core_TraceVisitor.prototype = $p;
$p.bQ = (function(length, jsonableKeys, index) {
  return new $c_Lupickle_core_TraceVisitor$$anon$1($c_Lupickle_core_Visitor$Delegate.prototype.bQ.call(this, length, jsonableKeys, index), this);
});
$p.cZ = (function(length, index) {
  return new $c_Lupickle_core_TraceVisitor$$anon$3($c_Lupickle_core_Visitor$Delegate.prototype.cZ.call(this, length, index), this);
});
$p.m = (function() {
  return $f_Lupickle_core_TraceVisitor$HasPath__path__T(this.Ig);
});
var $d_Lupickle_core_TraceVisitor = new $TypeData().i($c_Lupickle_core_TraceVisitor, "upickle.core.TraceVisitor", ({
  no: 1,
  bJ: 1,
  x: 1
}));
function $f_Lupickle_core_Types$TaggedWriter__write0__Lupickle_core_Visitor__O__O($thiz, out, v) {
  matchResult3: {
    var \u03b41$___1;
    var \u03b41$___2;
    var \u03b41$___3;
    var x7 = $thiz.WP(v);
    if ((x7 !== null)) {
      var \u03b41$___1 = x7.bH;
      var \u03b41$___2 = x7.bU;
      var \u03b41$___3 = x7.c3;
      break matchResult3;
    }
    throw new $c_s_MatchError(x7);
  }
  var tagKey$2 = \u03b41$___1;
  var tagValue$2 = \u03b41$___2;
  var w$2 = \u03b41$___3;
  return $f_Lupickle_AttributeTagged__taggedWrite__Lupickle_core_Types$ObjectWriter__T__T__Lupickle_core_Visitor__O__O($thiz.a5b(), w$2, tagKey$2, tagValue$2, out, v);
}
function $is_Lupickle_core_Types$TaggedWriter(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.cd)));
}
function $isArrayOf_Lupickle_core_Types$TaggedWriter(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.cd)));
}
/** @constructor */
function $c_Lupickle_core_Visitor$MapArrContext(src, f) {
  this.a2m = null;
  this.aK3 = null;
  this.a2m = src;
  this.aK3 = f;
}
$p = $c_Lupickle_core_Visitor$MapArrContext.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_Visitor$MapArrContext;
/** @constructor */
function $h_Lupickle_core_Visitor$MapArrContext() {
}
$h_Lupickle_core_Visitor$MapArrContext.prototype = $p;
$p.jr = (function() {
  return false;
});
$p.h6 = (function() {
  return this;
});
$p.d9 = (function() {
  return this.a2m.d9();
});
$p.cU = (function(v, index) {
  this.a2m.cU(v, index);
});
$p.bV = (function(index) {
  return this.aK3.i(this.a2m.bV(index));
});
var $d_Lupickle_core_Visitor$MapArrContext = new $TypeData().i($c_Lupickle_core_Visitor$MapArrContext, "upickle.core.Visitor$MapArrContext", ({
  OU: 1,
  ab: 1,
  b5: 1
}));
/** @constructor */
function $c_Lupickle_core_Visitor$MapObjContext(src, f) {
  this.OA = null;
  this.aK4 = null;
  this.OA = src;
  this.aK4 = f;
}
$p = $c_Lupickle_core_Visitor$MapObjContext.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_Visitor$MapObjContext;
/** @constructor */
function $h_Lupickle_core_Visitor$MapObjContext() {
}
$h_Lupickle_core_Visitor$MapObjContext.prototype = $p;
$p.jr = (function() {
  return true;
});
$p.d9 = (function() {
  return this.OA.d9();
});
$p.jy = (function(index) {
  return this.OA.jy(index);
});
$p.jz = (function(s) {
  this.OA.jz(s);
});
$p.cU = (function(v, index) {
  this.OA.cU(v, index);
});
$p.bV = (function(index) {
  return this.aK4.i(this.OA.bV(index));
});
$p.h6 = (function() {
  return this;
});
var $d_Lupickle_core_Visitor$MapObjContext = new $TypeData().i($c_Lupickle_core_Visitor$MapObjContext, "upickle.core.Visitor$MapObjContext", ({
  OV: 1,
  ab: 1,
  aO: 1
}));
function $f_Lupickle_implicits_Generated__Tuple2Reader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader__Lupickle_implicits_TupleReadWriters$TupleNReader($thiz, evidence$1, evidence$2) {
  return new $c_Lupickle_implicits_TupleReadWriters$TupleNReader($thiz, new ($d_Lupickle_core_Types$Reader.r().C)([evidence$1, evidence$2]), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x) => new $c_T2(x.a[0], x.a[1]))));
}
/** @constructor */
function $c_Lupickle_implicits_LowPriWriters$$anon$22(r$4, outer) {
  this.aKw = null;
  this.aKw = r$4;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lupickle_implicits_LowPriWriters$$anon$22.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_LowPriWriters$$anon$22;
/** @constructor */
function $h_Lupickle_implicits_LowPriWriters$$anon$22() {
}
$h_Lupickle_implicits_LowPriWriters$$anon$22.prototype = $p;
$p.cT = (function() {
  return false;
});
$p.cW = (function() {
  return this;
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.bcw = (function(out, v) {
  var ctx = out.cZ(v.aa(), (-1));
  var x = v.o();
  while (x.p()) {
    var next = x.q();
    ctx.cU($f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this.aKw, ctx.d9(), next), (-1));
  }
  return ctx.bV((-1));
});
$p.d0 = (function(out, v) {
  return this.bcw(out, v);
});
var $d_Lupickle_implicits_LowPriWriters$$anon$22 = new $TypeData().i($c_Lupickle_implicits_LowPriWriters$$anon$22, "upickle.implicits.LowPriWriters$$anon$22", ({
  P7: 1,
  B: 1,
  E: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$17$$anon$18(outer) {
  this.ae7 = null;
  this.ae8 = null;
  this.a2p = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.a2p = outer;
  this.ae7 = $m_scm_Buffer$().f7();
  this.ae8 = $m_scm_Buffer$().f7();
}
$p = $c_Lupickle_implicits_Readers$$anon$17$$anon$18.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$17$$anon$18;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$17$$anon$18() {
}
$h_Lupickle_implicits_Readers$$anon$17$$anon$18.prototype = $p;
$p.jr = (function() {
  return true;
});
$p.d9 = (function() {
  return this.a2p.ae6;
});
$p.jy = (function(index) {
  return this.a2p.ae4;
});
$p.jz = (function(s) {
  this.ae7.Y(s);
});
$p.cU = (function(v, index) {
  this.ae8.Y(v);
});
$p.bbr = (function(index) {
  return this.a2p.ae5.i($f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this.ae7, this.ae8));
});
$p.bV = (function(index) {
  return this.bbr(index);
});
$p.h6 = (function() {
  return this;
});
var $d_Lupickle_implicits_Readers$$anon$17$$anon$18 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$17$$anon$18, "upickle.implicits.Readers$$anon$17$$anon$18", ({
  Pl: 1,
  ab: 1,
  aO: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$19$$anon$20(outer) {
  this.ae9 = null;
  this.aKH = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aKH = outer;
  this.ae9 = $m_s_None$();
}
$p = $c_Lupickle_implicits_Readers$$anon$19$$anon$20.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$19$$anon$20;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$19$$anon$20() {
}
$h_Lupickle_implicits_Readers$$anon$19$$anon$20.prototype = $p;
$p.jr = (function() {
  return false;
});
$p.h6 = (function() {
  return this;
});
$p.cU = (function(v, index) {
  this.ae9 = new $c_s_Some(v);
});
$p.d9 = (function() {
  return this.aKH.aKG;
});
$p.bV = (function(index) {
  return this.ae9;
});
var $d_Lupickle_implicits_Readers$$anon$19$$anon$20 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$19$$anon$20, "upickle.implicits.Readers$$anon$19$$anon$20", ({
  Pn: 1,
  ab: 1,
  b5: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$2() {
}
$p = $c_Lupickle_implicits_Readers$$anon$2.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$2;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$2() {
}
$h_Lupickle_implicits_Readers$$anon$2.prototype = $p;
$p.jr = (function() {
  return true;
});
$p.d9 = (function() {
  return $m_Lupickle_core_NoOpVisitor$();
});
$p.cU = (function(v, index) {
});
$p.jy = (function(index) {
  return $m_Lupickle_core_NoOpVisitor$();
});
$p.jz = (function(v) {
});
$p.bV = (function(index) {
  return (void 0);
});
$p.h6 = (function() {
  return this;
});
var $d_Lupickle_implicits_Readers$$anon$2 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$2, "upickle.implicits.Readers$$anon$2", ({
  Po: 1,
  ab: 1,
  aO: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$26(outer) {
  this.aea = null;
  this.aKI = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aKI = outer;
  this.aea = outer.aKT.b5();
}
$p = $c_Lupickle_implicits_Readers$$anon$26.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$26;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$26() {
}
$h_Lupickle_implicits_Readers$$anon$26.prototype = $p;
$p.jr = (function() {
  return false;
});
$p.h6 = (function() {
  return this;
});
$p.cU = (function(v, index) {
  this.aea.Y(v);
});
$p.bV = (function(index) {
  return this.aea.aR();
});
$p.d9 = (function() {
  return this.aKI.aKU;
});
var $d_Lupickle_implicits_Readers$$anon$26 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$26, "upickle.implicits.Readers$$anon$26", ({
  Pq: 1,
  ab: 1,
  b5: 1
}));
function $is_Lupickle_implicits_Readers$OptionReader(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.cY)));
}
function $isArrayOf_Lupickle_implicits_Readers$OptionReader(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.cY)));
}
/** @constructor */
function $c_Lupickle_implicits_TupleReadWriters$$anon$1(outer) {
  this.aee = null;
  this.Du = 0;
  this.aef = 0;
  this.Ij = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Ij = outer;
  this.aee = $m_jl_reflect_Array$().m0($d_O.l(), new $ac_I(new Int32Array([outer.Ik.a.length])));
  this.Du = 0;
  this.aef = this.Du;
}
$p = $c_Lupickle_implicits_TupleReadWriters$$anon$1.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_TupleReadWriters$$anon$1;
/** @constructor */
function $h_Lupickle_implicits_TupleReadWriters$$anon$1() {
}
$h_Lupickle_implicits_TupleReadWriters$$anon$1.prototype = $p;
$p.jr = (function() {
  return false;
});
$p.h6 = (function() {
  return this;
});
$p.cU = (function(v, index) {
  this.aee.a[((this.Du % $checkIntDivisor(this.Ij.Ik.a.length)) | 0)] = v;
  this.Du = ((1 + this.Du) | 0);
});
$p.bV = (function(index) {
  var lengthSoFar = ((this.Du - this.aef) | 0);
  if ((lengthSoFar !== this.Ij.Ik.a.length)) {
    throw new $c_Lupickle_core_Abort(((("expected " + this.Ij.Ik.a.length) + " items in sequence, found ") + lengthSoFar));
  }
  this.aef = this.Du;
  return this.Ij.aL4.i(this.aee);
});
$p.d9 = (function() {
  return this.Ij.Ik.a[((this.Du % $checkIntDivisor(this.Ij.Ik.a.length)) | 0)];
});
var $d_Lupickle_implicits_TupleReadWriters$$anon$1 = new $TypeData().i($c_Lupickle_implicits_TupleReadWriters$$anon$1, "upickle.implicits.TupleReadWriters$$anon$1", ({
  PE: 1,
  ab: 1,
  b5: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Writers$$anon$11(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lupickle_implicits_Writers$$anon$11.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Writers$$anon$11;
/** @constructor */
function $h_Lupickle_implicits_Writers$$anon$11() {
}
$h_Lupickle_implicits_Writers$$anon$11.prototype = $p;
$p.cW = (function() {
  return this;
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.cT = (function() {
  return true;
});
$p.d0 = (function(out, v) {
  var $x_1 = $uJ(v);
  var v$1_$_lo = $x_1.l;
  var v$1_$_hi = $x_1.h;
  return out.eZ(v$1_$_lo, v$1_$_hi, (-1));
});
var $d_Lupickle_implicits_Writers$$anon$11 = new $TypeData().i($c_Lupickle_implicits_Writers$$anon$11, "upickle.implicits.Writers$$anon$11", ({
  PJ: 1,
  B: 1,
  E: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Writers$$anon$2(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lupickle_implicits_Writers$$anon$2.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Writers$$anon$2;
/** @constructor */
function $h_Lupickle_implicits_Writers$$anon$2() {
}
$h_Lupickle_implicits_Writers$$anon$2.prototype = $p;
$p.cW = (function() {
  return this;
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.cT = (function() {
  return true;
});
$p.d0 = (function(out, v) {
  return out.c8((-1));
});
var $d_Lupickle_implicits_Writers$$anon$2 = new $TypeData().i($c_Lupickle_implicits_Writers$$anon$2, "upickle.implicits.Writers$$anon$2", ({
  PQ: 1,
  B: 1,
  E: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Writers$$anon$20(kw$2, vw$2, outer) {
  this.aeg = null;
  this.aL7 = null;
  this.aeg = kw$2;
  this.aL7 = vw$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lupickle_implicits_Writers$$anon$20.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Writers$$anon$20;
/** @constructor */
function $h_Lupickle_implicits_Writers$$anon$20() {
}
$h_Lupickle_implicits_Writers$$anon$20.prototype = $p;
$p.cT = (function() {
  return false;
});
$p.cW = (function() {
  return this;
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.bcx = (function(out, v) {
  var ctx = out.bQ(v.aa(), this.aeg.cT(), (-1));
  v.F(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((pair) => {
    matchResult4: {
      var \u03b41$___1;
      var \u03b41$___2;
      if ((pair !== null)) {
        var \u03b41$___1 = pair.g();
        var \u03b41$___2 = pair.h();
        break matchResult4;
      }
      throw new $c_s_MatchError(pair);
    }
    var k1$2 = \u03b41$___1;
    var v1$2 = \u03b41$___2;
    var keyVisitor = ctx.jy((-1));
    ctx.jz($f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this.aeg, keyVisitor, k1$2));
    ctx.cU($f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this.aL7, ctx.d9(), v1$2), (-1));
  })));
  return ctx.bV((-1));
});
$p.d0 = (function(out, v) {
  return this.bcx(out, v);
});
var $d_Lupickle_implicits_Writers$$anon$20 = new $TypeData().i($c_Lupickle_implicits_Writers$$anon$20, "upickle.implicits.Writers$$anon$20", ({
  PR: 1,
  B: 1,
  E: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Writers$$anon$3(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lupickle_implicits_Writers$$anon$3.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Writers$$anon$3;
/** @constructor */
function $h_Lupickle_implicits_Writers$$anon$3() {
}
$h_Lupickle_implicits_Writers$$anon$3.prototype = $p;
$p.cW = (function() {
  return this;
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.cT = (function() {
  return true;
});
$p.d0 = (function(out, v) {
  var v$1 = (+v);
  return out.e7(v$1, (-1));
});
var $d_Lupickle_implicits_Writers$$anon$3 = new $TypeData().i($c_Lupickle_implicits_Writers$$anon$3, "upickle.implicits.Writers$$anon$3", ({
  PS: 1,
  B: 1,
  E: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Writers$$anon$4(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lupickle_implicits_Writers$$anon$4.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Writers$$anon$4;
/** @constructor */
function $h_Lupickle_implicits_Writers$$anon$4() {
}
$h_Lupickle_implicits_Writers$$anon$4.prototype = $p;
$p.cW = (function() {
  return this;
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.cT = (function() {
  return true;
});
$p.d0 = (function(out, v) {
  var v$1 = (v | 0);
  return out.em(v$1, (-1));
});
var $d_Lupickle_implicits_Writers$$anon$4 = new $TypeData().i($c_Lupickle_implicits_Writers$$anon$4, "upickle.implicits.Writers$$anon$4", ({
  PT: 1,
  B: 1,
  E: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Writers$$anon$5(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lupickle_implicits_Writers$$anon$5.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Writers$$anon$5;
/** @constructor */
function $h_Lupickle_implicits_Writers$$anon$5() {
}
$h_Lupickle_implicits_Writers$$anon$5.prototype = $p;
$p.cW = (function() {
  return this;
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.cT = (function() {
  return true;
});
$p.d0 = (function(out, v) {
  var v$1 = Math.fround(v);
  return out.eY(v$1, (-1));
});
var $d_Lupickle_implicits_Writers$$anon$5 = new $TypeData().i($c_Lupickle_implicits_Writers$$anon$5, "upickle.implicits.Writers$$anon$5", ({
  PU: 1,
  B: 1,
  E: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Writers$$anon$6(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lupickle_implicits_Writers$$anon$6.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Writers$$anon$6;
/** @constructor */
function $h_Lupickle_implicits_Writers$$anon$6() {
}
$h_Lupickle_implicits_Writers$$anon$6.prototype = $p;
$p.cW = (function() {
  return this;
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.cT = (function() {
  return true;
});
$p.bc8 = (function(out, v) {
  return out.em(v, (-1));
});
$p.d0 = (function(out, v) {
  return this.bc8(out, (v | 0));
});
var $d_Lupickle_implicits_Writers$$anon$6 = new $TypeData().i($c_Lupickle_implicits_Writers$$anon$6, "upickle.implicits.Writers$$anon$6", ({
  PV: 1,
  B: 1,
  E: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Writers$$anon$7(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lupickle_implicits_Writers$$anon$7.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Writers$$anon$7;
/** @constructor */
function $h_Lupickle_implicits_Writers$$anon$7() {
}
$h_Lupickle_implicits_Writers$$anon$7.prototype = $p;
$p.cW = (function() {
  return this;
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.cT = (function() {
  return true;
});
$p.bc7 = (function(out, v) {
  return out.em(v, (-1));
});
$p.d0 = (function(out, v) {
  return this.bc7(out, (v | 0));
});
var $d_Lupickle_implicits_Writers$$anon$7 = new $TypeData().i($c_Lupickle_implicits_Writers$$anon$7, "upickle.implicits.Writers$$anon$7", ({
  PW: 1,
  B: 1,
  E: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Writers$$anon$8(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lupickle_implicits_Writers$$anon$8.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Writers$$anon$8;
/** @constructor */
function $h_Lupickle_implicits_Writers$$anon$8() {
}
$h_Lupickle_implicits_Writers$$anon$8.prototype = $p;
$p.cW = (function() {
  return this;
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.cT = (function() {
  return true;
});
$p.bc9 = (function(out, v) {
  return (v ? out.eE((-1)) : out.eC((-1)));
});
$p.d0 = (function(out, v) {
  return this.bc9(out, (!(!v)));
});
var $d_Lupickle_implicits_Writers$$anon$8 = new $TypeData().i($c_Lupickle_implicits_Writers$$anon$8, "upickle.implicits.Writers$$anon$8", ({
  PX: 1,
  B: 1,
  E: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Writers$$anon$9(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lupickle_implicits_Writers$$anon$9.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Writers$$anon$9;
/** @constructor */
function $h_Lupickle_implicits_Writers$$anon$9() {
}
$h_Lupickle_implicits_Writers$$anon$9.prototype = $p;
$p.cW = (function() {
  return this;
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.cT = (function() {
  return true;
});
$p.d0 = (function(out, v) {
  var v$1 = $uC(v);
  return out.fc(v$1, (-1));
});
var $d_Lupickle_implicits_Writers$$anon$9 = new $TypeData().i($c_Lupickle_implicits_Writers$$anon$9, "upickle.implicits.Writers$$anon$9", ({
  PY: 1,
  B: 1,
  E: 1
}));
function $is_Lupickle_implicits_Writers$OptionWriter(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.cZ)));
}
function $isArrayOf_Lupickle_implicits_Writers$OptionWriter(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.cZ)));
}
function $f_Lupickle_implicits_Writers$SimpleMapKeyWriter__write0__Lupickle_core_Visitor__O__O($thiz, out, v) {
  return out.cN($thiz.Qd(v), (-1));
}
/** @constructor */
function $c_Lcom_raquo_airstream_common_InternalParentObserver$$anon$2(parentParam$2, onTryParam$1, outer) {
  this.aj2 = null;
  this.a5q = null;
  this.aj2 = onTryParam$1;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.a5q = parentParam$2;
}
$p = $c_Lcom_raquo_airstream_common_InternalParentObserver$$anon$2.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_common_InternalParentObserver$$anon$2;
/** @constructor */
function $h_Lcom_raquo_airstream_common_InternalParentObserver$$anon$2() {
}
$h_Lcom_raquo_airstream_common_InternalParentObserver$$anon$2.prototype = $p;
$p.iY = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_common_InternalTryObserver__onNext__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.iq = (function(nextError, transaction) {
  $f_Lcom_raquo_airstream_common_InternalTryObserver__onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$p.it = (function(nextValue, transaction) {
  this.aj2.R(nextValue, transaction);
});
var $d_Lcom_raquo_airstream_common_InternalParentObserver$$anon$2 = new $TypeData().i($c_Lcom_raquo_airstream_common_InternalParentObserver$$anon$2, "com.raquo.airstream.common.InternalParentObserver$$anon$2", ({
  nG: 1,
  a3: 1,
  e8: 1,
  aK: 1
}));
var $d_Lcom_raquo_airstream_core_Observable = new $TypeData().i(1, "com.raquo.airstream.core.Observable", ({
  V: 1,
  P: 1,
  O: 1,
  U: 1
}));
/** @constructor */
function $c_Lcom_raquo_airstream_core_Observer$$anon$10(observers$2, outer) {
  this.Yk = null;
  this.aja = null;
  this.Yk = observers$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aja = (void 0);
}
$p = $c_Lcom_raquo_airstream_core_Observer$$anon$10.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_core_Observer$$anon$10;
/** @constructor */
function $h_Lcom_raquo_airstream_core_Observer$$anon$10() {
}
$h_Lcom_raquo_airstream_core_Observer$$anon$10.prototype = $p;
$p.fx = (function() {
  return this.aja;
});
$p.eU = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$p.m = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.Ek = (function() {
  return this;
});
$p.bA = (function(nextValue) {
  this.Yk.F(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$5) => {
    _$5.bA(nextValue);
  })));
});
$p.yh = (function(err) {
  this.Yk.F(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$6) => {
    _$6.yh(err);
  })));
});
$p.mT = (function(nextValue) {
  this.Yk.F(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$7) => {
    _$7.mT(nextValue);
  })));
});
var $d_Lcom_raquo_airstream_core_Observer$$anon$10 = new $TypeData().i($c_Lcom_raquo_airstream_core_Observer$$anon$10, "com.raquo.airstream.core.Observer$$anon$10", ({
  nU: 1,
  b7: 1,
  O: 1,
  bL: 1
}));
/** @constructor */
function $c_Lcom_raquo_airstream_core_Observer$$anon$8(onNextParam$2, handleObserverErrors$3, onErrorParam$2, outer) {
  this.ajd = null;
  this.ajb = false;
  this.a5s = null;
  this.ajc = null;
  this.ajd = onNextParam$2;
  this.ajb = handleObserverErrors$3;
  this.a5s = onErrorParam$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.ajc = (void 0);
}
$p = $c_Lcom_raquo_airstream_core_Observer$$anon$8.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_core_Observer$$anon$8;
/** @constructor */
function $h_Lcom_raquo_airstream_core_Observer$$anon$8() {
}
$h_Lcom_raquo_airstream_core_Observer$$anon$8.prototype = $p;
$p.fx = (function() {
  return this.ajc;
});
$p.eU = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$p.m = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.Ek = (function() {
  return this;
});
$p.bA = (function(nextValue) {
  try {
    this.ajd.i(nextValue);
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if (this.ajb) {
      this.yh(new $c_Lcom_raquo_airstream_core_AirstreamError$ObserverError(e$2));
    } else {
      $m_Lcom_raquo_airstream_core_AirstreamError$().rc(new $c_Lcom_raquo_airstream_core_AirstreamError$ObserverError(e$2));
    }
  }
});
$p.yh = (function(error) {
  try {
    if (this.a5s.aM(error)) {
      this.a5s.i(error);
    } else {
      $m_Lcom_raquo_airstream_core_AirstreamError$().rc(error);
    }
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    $m_Lcom_raquo_airstream_core_AirstreamError$().rc(new $c_Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError(e$2, error));
  }
});
$p.mT = (function(nextValue) {
  nextValue.kO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((error) => {
    this.yh(error);
  })), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((nextValue$2) => {
    this.bA(nextValue$2);
  })));
});
var $d_Lcom_raquo_airstream_core_Observer$$anon$8 = new $TypeData().i($c_Lcom_raquo_airstream_core_Observer$$anon$8, "com.raquo.airstream.core.Observer$$anon$8", ({
  nV: 1,
  b7: 1,
  O: 1,
  bL: 1
}));
/** @constructor */
function $c_Lcom_raquo_airstream_core_Observer$$anon$9(onTryParam$2, handleObserverErrors$4, outer) {
  this.a5t = null;
  this.aje = false;
  this.ajf = null;
  this.a5t = onTryParam$2;
  this.aje = handleObserverErrors$4;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.ajf = (void 0);
}
$p = $c_Lcom_raquo_airstream_core_Observer$$anon$9.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_core_Observer$$anon$9;
/** @constructor */
function $h_Lcom_raquo_airstream_core_Observer$$anon$9() {
}
$h_Lcom_raquo_airstream_core_Observer$$anon$9.prototype = $p;
$p.fx = (function() {
  return this.ajf;
});
$p.eU = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$p.m = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.Ek = (function() {
  return this;
});
$p.bA = (function(nextValue) {
  this.mT(new $c_s_util_Success(nextValue));
});
$p.yh = (function(error) {
  this.mT(new $c_s_util_Failure(error));
});
$p.mT = (function(nextValue) {
  try {
    if (this.a5t.aM(nextValue)) {
      this.a5t.i(nextValue);
    } else {
      nextValue.kO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((err) => {
        $m_Lcom_raquo_airstream_core_AirstreamError$().rc(err);
      })), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$3) => (void 0))));
    }
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if ((this.aje && nextValue.Xe())) {
      this.yh(new $c_Lcom_raquo_airstream_core_AirstreamError$ObserverError(e$2));
    } else {
      nextValue.kO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((originalError) => {
        $m_Lcom_raquo_airstream_core_AirstreamError$().rc(new $c_Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError(e$2, originalError));
      })), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$4) => {
        $m_Lcom_raquo_airstream_core_AirstreamError$().rc(new $c_Lcom_raquo_airstream_core_AirstreamError$ObserverError(e$2));
      })));
    }
  }
});
var $d_Lcom_raquo_airstream_core_Observer$$anon$9 = new $TypeData().i($c_Lcom_raquo_airstream_core_Observer$$anon$9, "com.raquo.airstream.core.Observer$$anon$9", ({
  nW: 1,
  b7: 1,
  O: 1,
  bL: 1
}));
/** @constructor */
function $c_Lcom_raquo_airstream_eventbus_WriteBus(parentDisplayName, displayNameSuffix) {
  this.ajS = null;
  this.ajT = null;
  this.ajR = null;
  this.JP = null;
  this.ajT = parentDisplayName;
  this.ajR = displayNameSuffix;
  this.ajS = (void 0);
  this.JP = new $c_Lcom_raquo_airstream_eventbus_EventBusStream(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $f_Lcom_raquo_airstream_core_Named__displayName__T(this))));
}
$p = $c_Lcom_raquo_airstream_eventbus_WriteBus.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_eventbus_WriteBus;
/** @constructor */
function $h_Lcom_raquo_airstream_eventbus_WriteBus() {
}
$h_Lcom_raquo_airstream_eventbus_WriteBus.prototype = $p;
$p.fx = (function() {
  return this.ajS;
});
$p.m = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.Ek = (function() {
  return this;
});
$p.bA = (function(nextValue) {
  if ($f_Lcom_raquo_airstream_core_BaseObservable__isStarted__Z(this.JP)) {
    this.JP.iY(nextValue, null);
  }
});
$p.yh = (function(nextError) {
  if ($f_Lcom_raquo_airstream_core_BaseObservable__isStarted__Z(this.JP)) {
    this.JP.iq(nextError, null);
  }
});
$p.mT = (function(nextValue) {
  nextValue.kO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((nextError) => {
    this.yh(nextError);
  })), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((nextValue$2) => {
    this.bA(nextValue$2);
  })));
});
$p.eU = (function() {
  return (("" + this.ajT.a3()) + this.ajR);
});
var $d_Lcom_raquo_airstream_eventbus_WriteBus = new $TypeData().i($c_Lcom_raquo_airstream_eventbus_WriteBus, "com.raquo.airstream.eventbus.WriteBus", ({
  of: 1,
  b7: 1,
  O: 1,
  bL: 1
}));
/** @constructor */
function $c_Lcom_raquo_laminar_api_Laminar$svg$(outer) {
  this.an9 = null;
  this.ana = false;
  this.anh = null;
  this.ani = false;
  this.anj = null;
  this.ank = false;
  this.anr = null;
  this.ans = false;
  this.anx = null;
  this.any = false;
  this.anz = null;
  this.anI = false;
  this.anL = null;
  this.anM = false;
  this.anR = null;
  this.anS = false;
  this.anT = null;
  this.anU = false;
  this.anZ = null;
  this.ao0 = false;
  this.aoh = null;
  this.aoi = false;
  this.aoj = null;
  this.aom = false;
  this.anb = null;
  this.anc = false;
  this.and = null;
  this.ane = false;
  this.anf = null;
  this.ang = false;
  this.anl = null;
  this.anm = false;
  this.ann = null;
  this.ano = false;
  this.anp = null;
  this.anq = false;
  this.ant = null;
  this.anu = false;
  this.anv = null;
  this.anw = false;
  this.anA = null;
  this.anB = false;
  this.anE = null;
  this.anF = false;
  this.anC = null;
  this.anD = false;
  this.anG = null;
  this.anH = false;
  this.anJ = null;
  this.anK = false;
  this.anN = null;
  this.anO = false;
  this.anP = null;
  this.anQ = false;
  this.anV = null;
  this.anW = false;
  this.anX = null;
  this.anY = false;
  this.ao1 = null;
  this.ao2 = false;
  this.ao3 = null;
  this.ao4 = false;
  this.ao5 = null;
  this.ao6 = false;
  this.ao7 = null;
  this.ao8 = false;
  this.ao9 = null;
  this.aoe = false;
  this.aoa = null;
  this.aob = false;
  this.aoc = null;
  this.aod = false;
  this.aof = null;
  this.aog = false;
  this.aok = null;
  this.aol = false;
  this.aon = null;
  this.aoo = false;
  this.aop = null;
  this.aoq = false;
  this.aor = null;
  this.aos = false;
  this.aot = null;
  this.aoy = false;
  this.aou = null;
  this.aov = false;
  this.aow = null;
  this.aox = false;
  this.aoz = null;
  this.aoC = false;
  this.aoA = null;
  this.aoB = false;
  this.aoD = null;
  this.aoI = false;
  this.aoE = null;
  this.aoF = false;
  this.aoG = null;
  this.aoH = false;
  this.a6n = null;
  this.ar = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $f_Lcom_raquo_laminar_defs_complex_ComplexSvgKeys__$init$__V(this);
}
$p = $c_Lcom_raquo_laminar_api_Laminar$svg$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_api_Laminar$svg$;
/** @constructor */
function $h_Lcom_raquo_laminar_api_Laminar$svg$() {
}
$h_Lcom_raquo_laminar_api_Laminar$svg$.prototype = $p;
$p.DP = (function() {
  if ((!this.ana)) {
    this.an9 = new $c_Lcom_raquo_laminar_tags_SvgTag("circle", false);
    this.ana = true;
  }
  return this.an9;
});
$p.aNm = (function() {
  if ((!this.ani)) {
    this.anh = new $c_Lcom_raquo_laminar_tags_SvgTag("defs", false);
    this.ani = true;
  }
  return this.anh;
});
$p.afq = (function() {
  if ((!this.ank)) {
    this.anj = new $c_Lcom_raquo_laminar_tags_SvgTag("ellipse", false);
    this.ank = true;
  }
  return this.anj;
});
$p.dm = (function() {
  if ((!this.ans)) {
    this.anr = new $c_Lcom_raquo_laminar_tags_SvgTag("g", false);
    this.ans = true;
  }
  return this.anr;
});
$p.lp = (function() {
  if ((!this.any)) {
    this.anx = new $c_Lcom_raquo_laminar_tags_SvgTag("line", false);
    this.any = true;
  }
  return this.anx;
});
$p.aQ7 = (function() {
  if ((!this.anI)) {
    this.anz = new $c_Lcom_raquo_laminar_tags_SvgTag("marker", false);
    this.anI = true;
  }
  return this.anz;
});
$p.pC = (function() {
  if ((!this.anM)) {
    this.anL = new $c_Lcom_raquo_laminar_tags_SvgTag("path", false);
    this.anM = true;
  }
  return this.anL;
});
$p.co = (function() {
  if ((!this.anS)) {
    this.anR = new $c_Lcom_raquo_laminar_tags_SvgTag("polygon", false);
    this.anS = true;
  }
  return this.anR;
});
$p.dd = (function() {
  if ((!this.anU)) {
    this.anT = new $c_Lcom_raquo_laminar_tags_SvgTag("polyline", false);
    this.anU = true;
  }
  return this.anT;
});
$p.a4s = (function() {
  if ((!this.ao0)) {
    this.anZ = new $c_Lcom_raquo_laminar_tags_SvgTag("rect", false);
    this.ao0 = true;
  }
  return this.anZ;
});
$p.bo = (function() {
  if ((!this.aoi)) {
    this.aoh = new $c_Lcom_raquo_laminar_tags_SvgTag("svg", false);
    this.aoi = true;
  }
  return this.aoh;
});
$p.a4U = (function() {
  if ((!this.aom)) {
    this.aoj = new $c_Lcom_raquo_laminar_tags_SvgTag("text", false);
    this.aom = true;
  }
  return this.aoj;
});
$p.y6 = (function() {
  if ((!this.anc)) {
    this.anb = new $c_Lcom_raquo_laminar_keys_SvgAttr("cx", $m_Lcom_raquo_laminar_codecs_package$().bW, $m_s_None$());
    this.anc = true;
  }
  return this.anb;
});
$p.y7 = (function() {
  if ((!this.ane)) {
    this.and = new $c_Lcom_raquo_laminar_keys_SvgAttr("cy", $m_Lcom_raquo_laminar_codecs_package$().bW, $m_s_None$());
    this.ane = true;
  }
  return this.and;
});
$p.qV = (function() {
  if ((!this.ang)) {
    this.anf = new $c_Lcom_raquo_laminar_keys_SvgAttr("d", $m_Lcom_raquo_laminar_codecs_package$().bW, $m_s_None$());
    this.ang = true;
  }
  return this.anf;
});
$p.b1d = (function() {
  if ((!this.anm)) {
    this.anl = new $c_Lcom_raquo_laminar_keys_SvgAttr("fill", $m_Lcom_raquo_laminar_codecs_package$().bW, $m_s_None$());
    this.anm = true;
  }
  return this.anl;
});
$p.afT = (function() {
  if ((!this.ano)) {
    this.ann = new $c_Lcom_raquo_laminar_keys_SvgAttr("font-family", $m_Lcom_raquo_laminar_codecs_package$().bW, $m_s_None$());
    this.ano = true;
  }
  return this.ann;
});
$p.afU = (function() {
  if ((!this.anq)) {
    this.anp = new $c_Lcom_raquo_laminar_keys_SvgAttr("font-size", $m_Lcom_raquo_laminar_codecs_package$().bW, $m_s_None$());
    this.anq = true;
  }
  return this.anp;
});
$p.bg = (function() {
  if ((!this.anu)) {
    this.ant = new $c_Lcom_raquo_laminar_keys_SvgAttr("height", $m_Lcom_raquo_laminar_codecs_package$().bW, $m_s_None$());
    this.anu = true;
  }
  return this.ant;
});
$p.Pt = (function() {
  if ((!this.anw)) {
    this.anv = new $c_Lcom_raquo_laminar_keys_SvgAttr("id", $m_Lcom_raquo_laminar_codecs_package$().bW, $m_s_None$());
    this.anw = true;
  }
  return this.anv;
});
$p.aQ8 = (function() {
  if ((!this.anB)) {
    this.anA = new $c_Lcom_raquo_laminar_keys_SvgAttr("marker-end", $m_Lcom_raquo_laminar_codecs_package$().bW, $m_s_None$());
    this.anB = true;
  }
  return this.anA;
});
$p.aQa = (function() {
  if ((!this.anF)) {
    this.anE = new $c_Lcom_raquo_laminar_keys_SvgAttr("marker-start", $m_Lcom_raquo_laminar_codecs_package$().bW, $m_s_None$());
    this.anF = true;
  }
  return this.anE;
});
$p.aQ9 = (function() {
  if ((!this.anD)) {
    this.anC = new $c_Lcom_raquo_laminar_keys_SvgAttr("markerHeight", $m_Lcom_raquo_laminar_codecs_package$().bW, $m_s_None$());
    this.anD = true;
  }
  return this.anC;
});
$p.aQb = (function() {
  if ((!this.anH)) {
    this.anG = new $c_Lcom_raquo_laminar_keys_SvgAttr("markerWidth", $m_Lcom_raquo_laminar_codecs_package$().bW, $m_s_None$());
    this.anH = true;
  }
  return this.anG;
});
$p.aQS = (function() {
  if ((!this.anK)) {
    this.anJ = new $c_Lcom_raquo_laminar_keys_SvgAttr("orient", $m_Lcom_raquo_laminar_codecs_package$().bW, $m_s_None$());
    this.anK = true;
  }
  return this.anJ;
});
$p.ahu = (function() {
  if ((!this.anO)) {
    this.anN = new $c_Lcom_raquo_laminar_keys_SvgAttr("pointer-events", $m_Lcom_raquo_laminar_codecs_package$().bW, $m_s_None$());
    this.anO = true;
  }
  return this.anN;
});
$p.aQ = (function() {
  if ((!this.anQ)) {
    this.anP = new $c_Lcom_raquo_laminar_keys_SvgAttr("points", $m_Lcom_raquo_laminar_codecs_package$().bW, $m_s_None$());
    this.anQ = true;
  }
  return this.anP;
});
$p.aR6 = (function() {
  if ((!this.anW)) {
    this.anV = new $c_Lcom_raquo_laminar_keys_SvgAttr("preserveAspectRatio", $m_Lcom_raquo_laminar_codecs_package$().bW, $m_s_None$());
    this.anW = true;
  }
  return this.anV;
});
$p.Ee = (function() {
  if ((!this.anY)) {
    this.anX = new $c_Lcom_raquo_laminar_keys_SvgAttr("r", $m_Lcom_raquo_laminar_codecs_package$().bW, $m_s_None$());
    this.anY = true;
  }
  return this.anX;
});
$p.aRo = (function() {
  if ((!this.ao2)) {
    this.ao1 = new $c_Lcom_raquo_laminar_keys_SvgAttr("refX", $m_Lcom_raquo_laminar_codecs_package$().bW, $m_s_None$());
    this.ao2 = true;
  }
  return this.ao1;
});
$p.aRp = (function() {
  if ((!this.ao4)) {
    this.ao3 = new $c_Lcom_raquo_laminar_keys_SvgAttr("refY", $m_Lcom_raquo_laminar_codecs_package$().bW, $m_s_None$());
    this.ao4 = true;
  }
  return this.ao3;
});
$p.ahO = (function() {
  if ((!this.ao6)) {
    this.ao5 = new $c_Lcom_raquo_laminar_keys_SvgAttr("rx", $m_Lcom_raquo_laminar_codecs_package$().bW, $m_s_None$());
    this.ao6 = true;
  }
  return this.ao5;
});
$p.ahP = (function() {
  if ((!this.ao8)) {
    this.ao7 = new $c_Lcom_raquo_laminar_keys_SvgAttr("ry", $m_Lcom_raquo_laminar_codecs_package$().bW, $m_s_None$());
    this.ao8 = true;
  }
  return this.ao7;
});
$p.wi = (function() {
  if ((!this.aoe)) {
    this.ao9 = new $c_Lcom_raquo_laminar_keys_SvgAttr("stroke", $m_Lcom_raquo_laminar_codecs_package$().bW, $m_s_None$());
    this.aoe = true;
  }
  return this.ao9;
});
$p.a4M = (function() {
  if ((!this.aob)) {
    this.aoa = new $c_Lcom_raquo_laminar_keys_SvgAttr("stroke-dasharray", $m_Lcom_raquo_laminar_codecs_package$().bW, $m_s_None$());
    this.aob = true;
  }
  return this.aoa;
});
$p.AH = (function() {
  if ((!this.aod)) {
    this.aoc = new $c_Lcom_raquo_laminar_keys_SvgAttr("stroke-width", $m_Lcom_raquo_laminar_codecs_package$().bW, $m_s_None$());
    this.aod = true;
  }
  return this.aoc;
});
$p.pI = (function() {
  if ((!this.aog)) {
    this.aof = new $c_Lcom_raquo_laminar_keys_SvgAttr("style", $m_Lcom_raquo_laminar_codecs_package$().bW, $m_s_None$());
    this.aog = true;
  }
  return this.aof;
});
$p.a4V = (function() {
  if ((!this.aol)) {
    this.aok = new $c_Lcom_raquo_laminar_keys_SvgAttr("text-anchor", $m_Lcom_raquo_laminar_codecs_package$().bW, $m_s_None$());
    this.aol = true;
  }
  return this.aok;
});
$p.mZ = (function() {
  if ((!this.aoo)) {
    this.aon = new $c_Lcom_raquo_laminar_keys_SvgAttr("transform", $m_Lcom_raquo_laminar_codecs_package$().bW, $m_s_None$());
    this.aoo = true;
  }
  return this.aon;
});
$p.bK = (function() {
  if ((!this.aoq)) {
    this.aop = new $c_Lcom_raquo_laminar_keys_SvgAttr("viewBox", $m_Lcom_raquo_laminar_codecs_package$().bW, $m_s_None$());
    this.aoq = true;
  }
  return this.aop;
});
$p.bh = (function() {
  if ((!this.aos)) {
    this.aor = new $c_Lcom_raquo_laminar_keys_SvgAttr("width", $m_Lcom_raquo_laminar_codecs_package$().bW, $m_s_None$());
    this.aos = true;
  }
  return this.aor;
});
$p.Eq = (function() {
  if ((!this.aoy)) {
    this.aot = new $c_Lcom_raquo_laminar_keys_SvgAttr("x", $m_Lcom_raquo_laminar_codecs_package$().bW, $m_s_None$());
    this.aoy = true;
  }
  return this.aot;
});
$p.lt = (function() {
  if ((!this.aov)) {
    this.aou = new $c_Lcom_raquo_laminar_keys_SvgAttr("x1", $m_Lcom_raquo_laminar_codecs_package$().bW, $m_s_None$());
    this.aov = true;
  }
  return this.aou;
});
$p.lu = (function() {
  if ((!this.aox)) {
    this.aow = new $c_Lcom_raquo_laminar_keys_SvgAttr("x2", $m_Lcom_raquo_laminar_codecs_package$().bW, $m_s_None$());
    this.aox = true;
  }
  return this.aow;
});
$p.a5l = (function() {
  if ((!this.aoC)) {
    this.aoz = new $c_Lcom_raquo_laminar_keys_SvgAttr("xmlns", $m_Lcom_raquo_laminar_codecs_package$().bW, $m_s_None$());
    this.aoC = true;
  }
  return this.aoz;
});
$p.bcY = (function() {
  if ((!this.aoB)) {
    this.aoA = new $c_Lcom_raquo_laminar_keys_SvgAttr("xlink", $m_Lcom_raquo_laminar_codecs_package$().bW, new $c_s_Some("xmlns"));
    this.aoB = true;
  }
  return this.aoA;
});
$p.Er = (function() {
  if ((!this.aoI)) {
    this.aoD = new $c_Lcom_raquo_laminar_keys_SvgAttr("y", $m_Lcom_raquo_laminar_codecs_package$().bW, $m_s_None$());
    this.aoI = true;
  }
  return this.aoD;
});
$p.lv = (function() {
  if ((!this.aoF)) {
    this.aoE = new $c_Lcom_raquo_laminar_keys_SvgAttr("y1", $m_Lcom_raquo_laminar_codecs_package$().bW, $m_s_None$());
    this.aoF = true;
  }
  return this.aoE;
});
$p.lw = (function() {
  if ((!this.aoH)) {
    this.aoG = new $c_Lcom_raquo_laminar_keys_SvgAttr("y2", $m_Lcom_raquo_laminar_codecs_package$().bW, $m_s_None$());
    this.aoH = true;
  }
  return this.aoG;
});
var $d_Lcom_raquo_laminar_api_Laminar$svg$ = new $TypeData().i($c_Lcom_raquo_laminar_api_Laminar$svg$, "com.raquo.laminar.api.Laminar$svg$", ({
  pf: 1,
  pB: 1,
  pt: 1,
  pv: 1
}));
/** @constructor */
function $c_Lcom_raquo_laminar_api_package$() {
  this.aoK = null;
  this.aoL = false;
  this.b = null;
  $n_Lcom_raquo_laminar_api_package$ = this;
  this.b = new $c_Lcom_raquo_laminar_api_package$$anon$1();
}
$p = $c_Lcom_raquo_laminar_api_package$.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_api_package$;
/** @constructor */
function $h_Lcom_raquo_laminar_api_package$() {
}
$h_Lcom_raquo_laminar_api_package$.prototype = $p;
$p.aev = (function() {
  if ((!this.aoL)) {
    this.aoK = new $c_Lcom_raquo_laminar_keys_CompositeKey$CompositeValueMappers$StringSeqValueMapper$(this);
    this.aoL = true;
  }
  return this.aoK;
});
var $d_Lcom_raquo_laminar_api_package$ = new $TypeData().i($c_Lcom_raquo_laminar_api_package$, "com.raquo.laminar.api.package$", ({
  pj: 1,
  el: 1,
  en: 1,
  ek: 1
}));
var $n_Lcom_raquo_laminar_api_package$;
function $m_Lcom_raquo_laminar_api_package$() {
  if ((!$n_Lcom_raquo_laminar_api_package$)) {
    $n_Lcom_raquo_laminar_api_package$ = new $c_Lcom_raquo_laminar_api_package$();
  }
  return $n_Lcom_raquo_laminar_api_package$;
}
/** @constructor */
function $c_Lcom_raquo_laminar_inserters_DynamicInserter(initialContext, preferStrictMode, insertFn, hooks) {
  this.aro = null;
  this.arq = false;
  this.arp = null;
  this.a6u = null;
  this.aro = initialContext;
  this.arq = preferStrictMode;
  this.arp = insertFn;
  this.a6u = hooks;
}
$p = $c_Lcom_raquo_laminar_inserters_DynamicInserter.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_inserters_DynamicInserter;
/** @constructor */
function $h_Lcom_raquo_laminar_inserters_DynamicInserter() {
}
$h_Lcom_raquo_laminar_inserters_DynamicInserter.prototype = $p;
$p.Wn = (function(element) {
  var this$1 = this.aro;
  var insertContext = (this$1.c() ? $m_Lcom_raquo_laminar_inserters_InsertContext$().b7G(element, this.arq, this.a6u) : this$1.d());
  var subscribe = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((mountContext) => this.arp.DH(insertContext, mountContext.rj, this.a6u)));
  return $m_Lcom_raquo_airstream_ownership_DynamicSubscription$().AI(element.kq(), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((owner) => subscribe.i(new $c_Lcom_raquo_laminar_lifecycle_MountContext(element, owner)))), false);
});
$p.kL = (function(element) {
  this.Wn(element);
});
var $d_Lcom_raquo_laminar_inserters_DynamicInserter = new $TypeData().i($c_Lcom_raquo_laminar_inserters_DynamicInserter, "com.raquo.laminar.inserters.DynamicInserter", ({
  pI: 1,
  ar: 1,
  pM: 1,
  pJ: 1
}));
/** @constructor */
function $c_Lcom_raquo_laminar_nodes_CommentNode(initialText) {
  this.a6F = null;
  this.a6G = null;
  this.a6F = $m_s_None$();
  this.a6G = $m_Lcom_raquo_laminar_DomApi$().aZp(initialText);
}
$p = $c_Lcom_raquo_laminar_nodes_CommentNode.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_nodes_CommentNode;
/** @constructor */
function $h_Lcom_raquo_laminar_nodes_CommentNode() {
}
$h_Lcom_raquo_laminar_nodes_CommentNode.prototype = $p;
$p.P7 = (function() {
  return this.a6F;
});
$p.Ei = (function(maybeNextParent) {
  this.a6F = maybeNextParent;
});
$p.Ep = (function(maybeNextParent) {
});
$p.kL = (function(parentNode) {
  $m_Lcom_raquo_laminar_nodes_ParentNode$().DF(parentNode, this, (void 0));
});
$p.ed = (function() {
  return this.a6G;
});
var $d_Lcom_raquo_laminar_nodes_CommentNode = new $TypeData().i($c_Lcom_raquo_laminar_nodes_CommentNode, "com.raquo.laminar.nodes.CommentNode", ({
  qk: 1,
  bM: 1,
  ar: 1,
  cg: 1
}));
/** @constructor */
function $c_Lcom_raquo_laminar_nodes_TextNode(initialText) {
  this.a6L = null;
  this.YZ = null;
  this.a6L = $m_s_None$();
  this.YZ = $m_Lcom_raquo_laminar_DomApi$().aZt(initialText);
}
$p = $c_Lcom_raquo_laminar_nodes_TextNode.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_nodes_TextNode;
/** @constructor */
function $h_Lcom_raquo_laminar_nodes_TextNode() {
}
$h_Lcom_raquo_laminar_nodes_TextNode.prototype = $p;
$p.P7 = (function() {
  return this.a6L;
});
$p.Ei = (function(maybeNextParent) {
  this.a6L = maybeNextParent;
});
$p.Ep = (function(maybeNextParent) {
});
$p.kL = (function(parentNode) {
  $m_Lcom_raquo_laminar_nodes_ParentNode$().DF(parentNode, this, (void 0));
});
$p.b9S = (function() {
  return this.YZ.data;
});
$p.ed = (function() {
  return this.YZ;
});
var $d_Lcom_raquo_laminar_nodes_TextNode = new $TypeData().i($c_Lcom_raquo_laminar_nodes_TextNode, "com.raquo.laminar.nodes.TextNode", ({
  qq: 1,
  bM: 1,
  ar: 1,
  cg: 1
}));
/** @constructor */
function $c_Lcom_softwaremill_quicklens_package$PathModify(obj, f) {
  this.Z2 = null;
  this.eF = null;
  this.Z2 = obj;
  this.eF = f;
}
$p = $c_Lcom_softwaremill_quicklens_package$PathModify.prototype = new $h_O();
$p.constructor = $c_Lcom_softwaremill_quicklens_package$PathModify;
/** @constructor */
function $h_Lcom_softwaremill_quicklens_package$PathModify() {
}
$h_Lcom_softwaremill_quicklens_package$PathModify.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().eN(this, (-889275714), null);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_softwaremill_quicklens_package$PathModify)) {
    if ($m_sr_BoxesRunTime$().Q(this.Z2, x$0.Z2)) {
      var x$1 = this.eF;
      var x$2 = x$0.eF;
      return ((x$1 === null) ? (x$2 === null) : x$1.e(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "PathModify";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Z2;
  }
  if ((n === 1)) {
    return this.eF;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "obj";
  }
  if ((n === 1)) {
    return "f";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.Y3 = (function(v) {
  return this.eF.i(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((y) => v)));
});
function $isArrayOf_Lcom_softwaremill_quicklens_package$PathModify(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.et)));
}
var $d_Lcom_softwaremill_quicklens_package$PathModify = new $TypeData().i($c_Lcom_softwaremill_quicklens_package$PathModify, "com.softwaremill.quicklens.package$PathModify", ({
  et: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lfastparse_Parsed$TracedFailure(terminals, groups, failure) {
  this.Z7 = null;
  this.Z6 = null;
  this.QW = null;
  this.Z7 = terminals;
  this.Z6 = groups;
  this.QW = failure;
}
$p = $c_Lfastparse_Parsed$TracedFailure.prototype = new $h_O();
$p.constructor = $c_Lfastparse_Parsed$TracedFailure;
/** @constructor */
function $h_Lfastparse_Parsed$TracedFailure() {
}
$h_Lfastparse_Parsed$TracedFailure.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().eN(this, (-889275714), null);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfastparse_Parsed$TracedFailure)) {
    var x = this.Z7;
    var x$2 = x$0.Z7;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      var x$3 = this.Z6;
      var x$4 = x$0.Z6;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.QW;
      var x$6 = x$0.QW;
      return ((x$5 === null) ? (x$6 === null) : (x$5 === x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 3;
});
$p.B = (function() {
  return "TracedFailure";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.Z7;
      break;
    }
    case 1: {
      return this.Z6;
      break;
    }
    case 2: {
      return this.QW;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "terminals";
      break;
    }
    case 1: {
      return "groups";
      break;
    }
    case 2: {
      return "failure";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lfastparse_Parsed$TracedFailure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eF)));
}
var $d_Lfastparse_Parsed$TracedFailure = new $TypeData().i($c_Lfastparse_Parsed$TracedFailure, "fastparse.Parsed$TracedFailure", ({
  eF: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lfastparse_internal_Msgs(value) {
  this.j3 = null;
  this.j3 = value;
}
$p = $c_Lfastparse_internal_Msgs.prototype = new $h_O();
$p.constructor = $c_Lfastparse_internal_Msgs;
/** @constructor */
function $h_Lfastparse_internal_Msgs() {
}
$h_Lfastparse_internal_Msgs.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().eN(this, (-889275714), null);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfastparse_internal_Msgs)) {
    var x = this.j3;
    var x$2 = x$0.j3;
    return ((x === null) ? (x$2 === null) : x.e(x$2));
  } else {
    return false;
  }
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Msgs";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.j3;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.bl = (function(other) {
  $m_Lfastparse_internal_Msgs$();
  return new $c_Lfastparse_internal_Msgs(this.j3.aek(other.j3));
});
$p.m = (function() {
  return $m_Lfastparse_internal_Util$().pA(this.j3);
});
function $isArrayOf_Lfastparse_internal_Msgs(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eG)));
}
var $d_Lfastparse_internal_Msgs = new $TypeData().i($c_Lfastparse_internal_Msgs, "fastparse.internal.Msgs", ({
  eG: 1,
  b: 1,
  c: 1,
  a: 1
}));
class $c_Ljava_io_IOException extends $c_jl_Exception {
}
function $isArrayOf_Ljava_io_IOException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.db)));
}
/** @constructor */
function $c_Ljava_io_OutputStream() {
}
$p = $c_Ljava_io_OutputStream.prototype = new $h_O();
$p.constructor = $c_Ljava_io_OutputStream;
/** @constructor */
function $h_Ljava_io_OutputStream() {
}
$h_Ljava_io_OutputStream.prototype = $p;
function $ct_jl_AssertionError__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz;
}
function $ct_jl_AssertionError__O__($thiz, detailMessage) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, ("" + detailMessage), ((detailMessage instanceof $c_jl_Throwable) ? detailMessage : null), true, true);
  return $thiz;
}
class $c_jl_AssertionError extends $c_jl_Error {
}
var $d_jl_AssertionError = new $TypeData().i($c_jl_AssertionError, "java.lang.AssertionError", ({
  rW: 1,
  bO: 1,
  y: 1,
  a: 1
}));
function $f_jl_Boolean__equals__O__Z($thiz, that) {
  return ($thiz === that);
}
function $f_jl_Boolean__hashCode__I($thiz) {
  return ($thiz ? 1231 : 1237);
}
function $f_jl_Boolean__toString__T($thiz) {
  return ("" + $thiz);
}
function $f_jl_Boolean__compareTo__O__I($thiz, o) {
  return (($thiz === o) ? 0 : ($thiz ? 1 : (-1)));
}
function $isArrayOf_jl_Boolean(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eJ)));
}
var $d_jl_Boolean = new $TypeData().i(0, "java.lang.Boolean", ({
  eJ: 1,
  a: 1,
  Q: 1,
  aY: 1
}), ((x) => ((typeof x) === "boolean")));
function $f_jl_Character__hashCode__I($thiz) {
  return $thiz;
}
function $f_jl_Character__equals__O__Z($thiz, that) {
  return ((that instanceof $Char) && ($thiz === that.c));
}
function $f_jl_Character__toString__T($thiz) {
  return ("" + $cToS($thiz));
}
function $f_jl_Character__compareTo__O__I($thiz, o) {
  return (($thiz - o.c) | 0);
}
function $isArrayOf_jl_Character(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eL)));
}
var $d_jl_Character = new $TypeData().i(0, "java.lang.Character", ({
  eL: 1,
  a: 1,
  Q: 1,
  aY: 1
}), ((x) => (x instanceof $Char)));
function $isArrayOf_jl_InterruptedException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.s3)));
}
function $isArrayOf_jl_LinkageError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.s6)));
}
function $ct_jl_RuntimeException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
class $c_jl_RuntimeException extends $c_jl_Exception {
}
var $d_jl_RuntimeException = new $TypeData().i($c_jl_RuntimeException, "java.lang.RuntimeException", ({
  R: 1,
  G: 1,
  y: 1,
  a: 1
}));
function $ct_jl_StringBuffer__jl_StringBuilder__($thiz, builder) {
  $thiz.EI = builder;
  return $thiz;
}
function $ct_jl_StringBuffer__($thiz) {
  $ct_jl_StringBuffer__jl_StringBuilder__($thiz, $ct_jl_StringBuilder__(new $c_jl_StringBuilder()));
  return $thiz;
}
/** @constructor */
function $c_jl_StringBuffer() {
  this.EI = null;
}
$p = $c_jl_StringBuffer.prototype = new $h_O();
$p.constructor = $c_jl_StringBuffer;
/** @constructor */
function $h_jl_StringBuffer() {
}
$h_jl_StringBuffer.prototype = $p;
$p.C = (function() {
  return this.EI.C();
});
$p.y1 = (function(index) {
  return this.EI.y1(index);
});
$p.aLY = (function(s) {
  var this$1 = this.EI;
  this$1.ah = (("" + this$1.ah) + s);
  return this;
});
$p.aX1 = (function(str, offset, len) {
  this.EI.aX2(str, offset, len);
  return this;
});
$p.Jp = (function(start, end) {
  return this.EI.aic(start, end);
});
$p.m = (function() {
  return this.EI.ah;
});
$p.W9 = (function(csq) {
  return this.aLY(csq);
});
var $d_jl_StringBuffer = new $TypeData().i($c_jl_StringBuffer, "java.lang.StringBuffer", ({
  sg: 1,
  aX: 1,
  bz: 1,
  a: 1
}));
function $ct_jl_StringBuilder__($thiz) {
  $thiz.ah = "";
  return $thiz;
}
function $ct_jl_StringBuilder__T__($thiz, str) {
  $ct_jl_StringBuilder__($thiz);
  $thiz.ah = str;
  return $thiz;
}
function $ct_jl_StringBuilder__I__($thiz, initialCapacity) {
  $ct_jl_StringBuilder__($thiz);
  return $thiz;
}
/** @constructor */
function $c_jl_StringBuilder() {
  this.ah = null;
}
$p = $c_jl_StringBuilder.prototype = new $h_O();
$p.constructor = $c_jl_StringBuilder;
/** @constructor */
function $h_jl_StringBuilder() {
}
$h_jl_StringBuilder.prototype = $p;
$p.aM0 = (function(str) {
  var str$1 = $m_jl_String$().kS(str, 0, str.a.length);
  this.ah = (("" + this.ah) + str$1);
  return this;
});
$p.aX2 = (function(str, offset, len) {
  var length = str.a.length;
  var endOffset = ((offset + len) | 0);
  if (((((offset | len) | endOffset) | ((length - endOffset) | 0)) < 0)) {
    $m_jl_BoundsChecks$().r5(offset, len, length);
  }
  var str$1 = $m_jl_String$().kS(str, offset, len);
  this.ah = (("" + this.ah) + str$1);
  return this;
});
$p.b7S = (function() {
  var original = this.ah;
  var result = "";
  var i = ((original.length - 1) | 0);
  while ((i > 0)) {
    var index = i;
    var c = original.charCodeAt(index);
    if (((64512 & c) === 56320)) {
      var index$1 = ((i - 1) | 0);
      var c2 = original.charCodeAt(index$1);
      if (((64512 & c2) === 55296)) {
        result = ((((result + "") + $cToS(c2)) + "") + $cToS(c));
        i = ((i - 2) | 0);
      } else {
        result = ((result + "") + $cToS(c));
        i = ((i - 1) | 0);
      }
    } else {
      result = ((result + "") + $cToS(c));
      i = ((i - 1) | 0);
    }
  }
  if ((i === 0)) {
    result = (result + ("" + $cToS(original.charCodeAt(0))));
  }
  this.ah = result;
  return this;
});
$p.m = (function() {
  return this.ah;
});
$p.C = (function() {
  return this.ah.length;
});
$p.PS = (function(newLength) {
  var newContent = this.ah;
  var currentLength = newContent.length;
  if ((newLength >= currentLength)) {
    while ((currentLength !== newLength)) {
      newContent = (newContent + "\u0000");
      currentLength = ((1 + currentLength) | 0);
    }
    this.ah = newContent;
  } else {
    var this$2 = newContent;
    this.ah = this$2.substring(0, newLength);
  }
});
$p.y1 = (function(index) {
  return this.ah.charCodeAt(index);
});
$p.aOP = (function(srcBegin, srcEnd, dst, dstBegin) {
  $f_T__getChars__I__I__AC__I__V(this.ah, srcBegin, srcEnd, dst, dstBegin);
});
$p.aS4 = (function(index, ch) {
  var oldContent = this.ah;
  var $x_1 = oldContent.substring(0, index);
  var beginIndex = ((1 + index) | 0);
  this.ah = (($x_1 + $cToS(ch)) + oldContent.substring(beginIndex));
});
$p.Jp = (function(start, end) {
  return this.aic(start, end);
});
$p.aic = (function(start, end) {
  var this$1 = this.ah;
  return this$1.substring(start, end);
});
$p.W9 = (function(csq) {
  this.ah = (("" + this.ah) + csq);
  return this;
});
var $d_jl_StringBuilder = new $TypeData().i($c_jl_StringBuilder, "java.lang.StringBuilder", ({
  sh: 1,
  aX: 1,
  bz: 1,
  a: 1
}));
function $isArrayOf_jl_ThreadDeath(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.sk)));
}
class $c_jl_VirtualMachineError extends $c_jl_Error {
}
function $isArrayOf_jl_VirtualMachineError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eZ)));
}
function $p_Ljava_math_BigDecimal__decimalDigitsInLong__J__I($thiz, value_$_lo, value_$_hi) {
  if (((value_$_lo | ((-2147483648) ^ value_$_hi)) === 0)) {
    return 19;
  } else {
    var $x_2 = $m_ju_Arrays$();
    var $x_1 = $m_Ljava_math_BigDecimal$().yB;
    var sign = (value_$_hi >> 31);
    var xlo = (value_$_lo ^ sign);
    var rlo = ((xlo - sign) | 0);
    var rhi = (((value_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
    var index = $x_2.aXY($x_1, rlo, rhi);
    return ((index < 0) ? (~index) : ((1 + index) | 0));
  }
}
function $p_Ljava_math_BigDecimal__inplaceRound__Ljava_math_MathContext__V($thiz, mc) {
  var mcPrecision = mc.yE;
  var discardedPrecision = (($thiz.PJ() - mcPrecision) | 0);
  if ((!((($p_Ljava_math_BigDecimal__approxPrecision__I($thiz) < mcPrecision) || (mcPrecision === 0)) || (discardedPrecision <= 0)))) {
    if (($thiz.jB < 64)) {
      $p_Ljava_math_BigDecimal__smallRound__Ljava_math_MathContext__I__V($thiz, mc, discardedPrecision);
    } else {
      var $x_1 = $m_Ljava_math_Multiplication$();
      var hi = (discardedPrecision >> 31);
      var sizeOfFraction = $x_1.yi(discardedPrecision, hi);
      var integerAndFraction = $thiz.jU().aNy(sizeOfFraction);
      var value = $thiz.c9;
      var hi$1 = (value >> 31);
      var hi$2 = (discardedPrecision >> 31);
      var lo = ((value - discardedPrecision) | 0);
      var hi$3 = ((((hi$1 - hi$2) | 0) - (((lo >>> 0) > (value >>> 0)) | 0)) | 0);
      if ((integerAndFraction.a[1].bS !== 0)) {
        var absBi = integerAndFraction.a[1].a2A();
        var compRem = absBi.aSb().Ah(sizeOfFraction);
        var parityBit = (integerAndFraction.a[0].Y6(0) | 0);
        var frac = Math.imul(integerAndFraction.a[1].bS, ((5 + compRem) | 0));
        var carry = $m_Ljava_math_BigDecimal$().Xk(parityBit, frac, mc.EL);
        if ((carry !== 0)) {
          var $x_2 = $m_Ljava_math_BigInteger$();
          var hi$4 = (carry >> 31);
          var bi = $x_2.oI(carry, hi$4);
          integerAndFraction.a[0] = $m_Ljava_math_Elementary$().OT(integerAndFraction.a[0], bi);
        }
        if (($ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__(new $c_Ljava_math_BigDecimal(), integerAndFraction.a[0]).PJ() > mcPrecision)) {
          integerAndFraction.a[0] = integerAndFraction.a[0].afl($m_Ljava_math_BigInteger$().yC);
          var lo$1 = ((lo - 1) | 0);
          var hi$5 = ((((hi$3 - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
          var newScale_$_lo = lo$1;
          var newScale_$_hi = hi$5;
        } else {
          var newScale_$_lo = lo;
          var newScale_$_hi = hi$3;
        }
      } else {
        var newScale_$_lo = lo;
        var newScale_$_hi = hi$3;
      }
      $thiz.c9 = $m_Ljava_math_BigDecimal$().Xl(newScale_$_lo, newScale_$_hi);
      $thiz.AY = mcPrecision;
      $p_Ljava_math_BigDecimal__setUnscaledValue__Ljava_math_BigInteger__V($thiz, integerAndFraction.a[0]);
    }
  }
}
function $p_Ljava_math_BigDecimal__isZero__Z($thiz) {
  if (($thiz.jB === 0)) {
    var x_$_lo = $thiz.hC;
    var x_$_hi = $thiz.hD;
    return (((~x_$_lo) | (~x_$_hi)) !== 0);
  } else {
    return false;
  }
}
function $p_Ljava_math_BigDecimal__smallRound__Ljava_math_MathContext__I__V($thiz, mc, discardedPrecision) {
  var $x_1 = $m_Ljava_math_BigDecimal$().yB.a;
  var $x_2 = (discardedPrecision << 1);
  var sizeOfFraction_$_lo = $x_1[$x_2];
  var sizeOfFraction_$_hi = $x_1[(($x_2 + 1) | 0)];
  var value = $thiz.c9;
  var hi = (value >> 31);
  var hi$1 = (discardedPrecision >> 31);
  var lo = ((value - discardedPrecision) | 0);
  var hi$2 = ((((hi - hi$1) | 0) - (((lo >>> 0) > (value >>> 0)) | 0)) | 0);
  var unscaledVal_$_lo = $thiz.hC;
  var unscaledVal_$_hi = $thiz.hD;
  var $x_3 = $m_RTLong$().afk(unscaledVal_$_lo, unscaledVal_$_hi, sizeOfFraction_$_lo, sizeOfFraction_$_hi);
  var intPart0_$_lo = $x_3.l;
  var intPart0_$_hi = $x_3.h;
  var a0 = (65535 & sizeOfFraction_$_lo);
  var a1 = ((sizeOfFraction_$_lo >>> 16) | 0);
  var b0 = (65535 & intPart0_$_lo);
  var b1 = ((intPart0_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(a0, b0);
  var a1b0 = Math.imul(a1, b0);
  var a0b1 = Math.imul(a0, b1);
  var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$3 = ((((((((Math.imul(sizeOfFraction_$_lo, intPart0_$_hi) + Math.imul(sizeOfFraction_$_hi, intPart0_$_lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((unscaledVal_$_lo - lo$1) | 0);
  var hi$4 = ((((unscaledVal_$_hi - hi$3) | 0) - (((lo$2 >>> 0) > (unscaledVal_$_lo >>> 0)) | 0)) | 0);
  if (((lo$2 | hi$4) !== 0)) {
    var $x_4 = $m_Ljava_math_BigDecimal$();
    var sign = (hi$4 >> 31);
    var xlo = (lo$2 ^ sign);
    var rlo = ((xlo - sign) | 0);
    var rhi = (((hi$4 ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
    var lo$3 = (rlo << 1);
    var hi$5 = (((rlo >>> 31) | 0) | (rhi << 1));
    var compRem = $x_4.agH(lo$3, hi$5, sizeOfFraction_$_lo, sizeOfFraction_$_hi);
    var frac = Math.imul(((hi$4 >> 31) | ((((((-hi$4) | 0) - ((((-lo$2) | 0) !== 0) | 0)) | 0) >>> 31) | 0)), ((5 + compRem) | 0));
    var value$1 = $m_Ljava_math_BigDecimal$().Xk((1 & intPart0_$_lo), frac, mc.EL);
    var hi$8 = (value$1 >> 31);
    var lo$8 = ((intPart0_$_lo + value$1) | 0);
    var hi$9 = ((((intPart0_$_hi + hi$8) | 0) + (((lo$8 >>> 0) < (intPart0_$_lo >>> 0)) | 0)) | 0);
    var sign$1 = (hi$9 >> 31);
    var xlo$1 = (lo$8 ^ sign$1);
    var rlo$1 = ((xlo$1 - sign$1) | 0);
    var rhi$1 = (((hi$9 ^ sign$1) + (((rlo$1 >>> 0) < (xlo$1 >>> 0)) | 0)) | 0);
    var a = ((4.294967296E9 * rhi$1) + (rlo$1 >>> 0.0));
    if (((+Math.log10(a)) >= mc.yE)) {
      var lo$9 = ((lo - 1) | 0);
      var hi$10 = ((((hi$2 - 1) | 0) + ((lo$9 !== (-1)) | 0)) | 0);
      var sign$2 = (hi$9 >> 31);
      var xlo$2 = (lo$8 ^ sign$2);
      var rlo$2 = ((xlo$2 - sign$2) | 0);
      var rhi$2 = (((hi$9 ^ sign$2) + (((rlo$2 >>> 0) < (xlo$2 >>> 0)) | 0)) | 0);
      var quotHi = (((rhi$2 >>> 0) / 10) | 0);
      var k = ((rhi$2 - Math.imul(10, quotHi)) | 0);
      var quotLo = ((0.10000000000000005 * ((4.294967296E9 * k) + (rlo$2 >>> 0.0))) | 0.0);
      if ((hi$9 < 0)) {
        var lo$10 = ((-quotLo) | 0);
        var hi$11 = ((((-quotHi) | 0) - ((lo$10 !== 0) | 0)) | 0);
        var _2_$_lo = lo$10;
        var _2_$_hi = hi$11;
      } else {
        var _2_$_lo = quotLo;
        var _2_$_hi = quotHi;
      }
      var x1___1 = $bL(lo$9, hi$10);
      var x1___2 = $bL(_2_$_lo, _2_$_hi);
    } else {
      var x1___1 = $bL(lo, hi$2);
      var x1___2 = $bL(lo$8, hi$9);
    }
  } else {
    var x1___1 = $bL(lo, hi$2);
    var x1___2 = $bL(intPart0_$_lo, intPart0_$_hi);
  }
  var $x_5 = $uJ(x1___1);
  var newScale_$_lo = $x_5.l;
  var newScale_$_hi = $x_5.h;
  var $x_6 = $uJ(x1___2);
  var intPart_$_lo = $x_6.l;
  var intPart_$_hi = $x_6.h;
  $thiz.c9 = $m_Ljava_math_BigDecimal$().Xl(newScale_$_lo, newScale_$_hi);
  $thiz.AY = mc.yE;
  $thiz.hC = intPart_$_lo;
  $thiz.hD = intPart_$_hi;
  $thiz.jB = $m_Ljava_math_BigDecimal$().Wo(intPart_$_lo, intPart_$_hi);
  $thiz.AX = null;
}
function $p_Ljava_math_BigDecimal__valueExact__I__J($thiz, bitLengthOfType) {
  var value = $thiz.c9;
  var hi = (value >> 31);
  var lo = ((-value) | 0);
  var hi$1 = ((((-hi) | 0) - ((lo !== 0) | 0)) | 0);
  var value$1 = $p_Ljava_math_BigDecimal__approxPrecision__I($thiz);
  var hi$2 = (value$1 >> 31);
  var lo$1 = ((lo + value$1) | 0);
  var hi$3 = ((((hi$1 + hi$2) | 0) + (((lo$1 >>> 0) < (lo >>> 0)) | 0)) | 0);
  if (((hi$3 === 0) ? ((lo$1 >>> 0) > 19) : (hi$3 > 0))) {
    throw new $c_jl_ArithmeticException("Rounding necessary");
  }
  var bigInteger = $thiz.aSR();
  if (($m_Ljava_math_BitLevel$().DM(bigInteger) < bitLengthOfType)) {
    return bigInteger.lY();
  } else {
    throw new $c_jl_ArithmeticException("Rounding necessary");
  }
}
function $p_Ljava_math_BigDecimal__approxPrecision__I($thiz) {
  return (($thiz.AY > 0) ? $thiz.AY : ((1 + $doubleToInt((0.3010299956639812 * (($thiz.jB - 1) | 0)))) | 0));
}
function $p_Ljava_math_BigDecimal__setUnscaledValue__Ljava_math_BigInteger__V($thiz, unscaledVal) {
  $thiz.AX = unscaledVal;
  $thiz.jB = $m_Ljava_math_BitLevel$().DM(unscaledVal);
  if (($thiz.jB < 64)) {
    var $x_1 = unscaledVal.lY();
    $thiz.hC = $x_1.l;
    $thiz.hD = $x_1.h;
  }
}
function $p_Ljava_math_BigDecimal__cmp$1__J__I($thiz, diffScale$6_$_lo, diffScale$6_$_hi) {
  return (($thiz.jB + $m_Ljava_math_BigDecimal$().atc.a[diffScale$6_$_lo]) | 0);
}
function $ct_Ljava_math_BigDecimal__($thiz) {
  $thiz.EK = null;
  $thiz.uq = 0;
  $thiz.jB = 0;
  $thiz.hC = 0;
  $thiz.hD = 0;
  $thiz.c9 = 0;
  $thiz.AY = 0;
  return $thiz;
}
function $ct_Ljava_math_BigDecimal__J__I__($thiz, smallValue_$_lo, smallValue_$_hi, scale) {
  $ct_Ljava_math_BigDecimal__($thiz);
  $thiz.hC = smallValue_$_lo;
  $thiz.hD = smallValue_$_hi;
  $thiz.c9 = scale;
  $thiz.jB = $m_Ljava_math_BigDecimal$().Wo(smallValue_$_lo, smallValue_$_hi);
  return $thiz;
}
function $ct_Ljava_math_BigDecimal__I__I__($thiz, smallValue, scale) {
  $ct_Ljava_math_BigDecimal__($thiz);
  var hi = (smallValue >> 31);
  $thiz.hC = smallValue;
  $thiz.hD = hi;
  $thiz.c9 = scale;
  $thiz.jB = $m_Ljava_math_BigDecimal$().b3H(smallValue);
  return $thiz;
}
function $ct_Ljava_math_BigDecimal__AC__I__I__($thiz, in$1, offset, len) {
  $ct_Ljava_math_BigDecimal__($thiz);
  var endOffset = ((offset + len) | 0);
  var last = ((endOffset - 1) | 0);
  if (((((offset | len) | endOffset) | ((in$1.a.length - endOffset) | 0)) < 0)) {
    throw new $c_jl_NumberFormatException(((((("Bad offset/length: offset=" + offset) + " len=") + len) + " in.length=") + in$1.a.length));
  }
  var index = offset;
  if (((offset <= last) && (in$1.a[offset] === 43))) {
    index = ((1 + index) | 0);
    if (((index < last) && $m_Ljava_math_BigDecimal$().a3W(in$1.a[index], new $ac_C(new Uint16Array([43, 45]))))) {
      throw new $c_jl_NumberFormatException(("For input string: " + in$1.m()));
    }
  } else {
    var isMinus = ((index <= last) && (in$1.a[index] === 45));
    var nextIsSign = ((((1 + index) | 0) < last) && $m_Ljava_math_BigDecimal$().a3W(in$1.a[((1 + index) | 0)], new $ac_C(new Uint16Array([43, 45]))));
    if ((isMinus && nextIsSign)) {
      throw new $c_jl_NumberFormatException(("For input string: " + in$1.m()));
    }
  }
  var begin = index;
  var counter = 0;
  var wasNonZero = false;
  while (((index <= last) && $m_Ljava_math_BigDecimal$().aPx(in$1.a[index], new $ac_C(new Uint16Array([46, 101, 69]))))) {
    if ((!wasNonZero)) {
      if ((in$1.a[index] === 48)) {
        counter = ((1 + counter) | 0);
      } else {
        wasNonZero = true;
      }
    }
    index = ((1 + index) | 0);
  }
  var u = $m_jl_String$().kS(in$1, begin, ((index - begin) | 0));
  var b = ((index - begin) | 0);
  if (((index <= last) && (in$1.a[index] === 46))) {
    index = ((1 + index) | 0);
    var begin$2 = index;
    while (((index <= last) && $m_Ljava_math_BigDecimal$().aPx(in$1.a[index], new $ac_C(new Uint16Array([101, 69]))))) {
      if ((!wasNonZero)) {
        if ((in$1.a[index] === 48)) {
          counter = ((1 + counter) | 0);
        } else {
          wasNonZero = true;
        }
      }
      index = ((1 + index) | 0);
    }
    $thiz.c9 = ((index - begin$2) | 0);
    var x1___1 = (("" + u) + $m_jl_String$().kS(in$1, begin$2, $thiz.c9));
    var x1___2 = ((b + $thiz.c9) | 0);
  } else {
    $thiz.c9 = 0;
    var x1___1 = u;
    var x1___2 = b;
  }
  var unscaled = x1___1;
  var bufLength = (x1___2 | 0);
  if (((index <= last) && $m_Ljava_math_BigDecimal$().a3W(in$1.a[index], new $ac_C(new Uint16Array([101, 69]))))) {
    index = ((1 + index) | 0);
    var indexIsPlus = ((index <= last) && (in$1.a[index] === 43));
    var nextIsNotMinus = ((((1 + index) | 0) <= last) && (in$1.a[((1 + index) | 0)] !== 45));
    var begin$3 = ((indexIsPlus && nextIsNotMinus) ? ((1 + index) | 0) : index);
    var scaleString = $m_jl_String$().kS(in$1, begin$3, ((((1 + last) | 0) - begin$3) | 0));
    var value = $thiz.c9;
    var hi = (value >> 31);
    var value$1 = $m_jl_Integer$().gc(scaleString, 10, 214748364);
    var hi$1 = (value$1 >> 31);
    var lo = ((value - value$1) | 0);
    var hi$2 = ((((hi - hi$1) | 0) - (((lo >>> 0) > (value >>> 0)) | 0)) | 0);
    $thiz.c9 = lo;
    var value$2 = $thiz.c9;
    if ((((lo ^ value$2) | (hi$2 ^ (value$2 >> 31))) !== 0)) {
      throw new $c_jl_NumberFormatException("Scale out of range");
    }
  }
  if ((bufLength < 19)) {
    var $x_1 = $m_jl_Long$().b6v(unscaled, 10);
    $thiz.hC = $x_1.l;
    $thiz.hD = $x_1.h;
    $thiz.jB = $m_Ljava_math_BigDecimal$().Wo($thiz.hC, $thiz.hD);
  } else {
    $p_Ljava_math_BigDecimal__setUnscaledValue__Ljava_math_BigInteger__V($thiz, $ct_Ljava_math_BigInteger__T__(new $c_Ljava_math_BigInteger(), unscaled));
  }
  return $thiz;
}
function $ct_Ljava_math_BigDecimal__T__($thiz, sVal) {
  $ct_Ljava_math_BigDecimal__AC__I__I__($thiz, $f_T__toCharArray__AC(sVal), 0, sVal.length);
  return $thiz;
}
function $ct_Ljava_math_BigDecimal__T__Ljava_math_MathContext__($thiz, sVal, mc) {
  $ct_Ljava_math_BigDecimal__AC__I__I__($thiz, $f_T__toCharArray__AC(sVal), 0, sVal.length);
  $p_Ljava_math_BigDecimal__inplaceRound__Ljava_math_MathContext__V($thiz, mc);
  return $thiz;
}
function $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__($thiz, unscaledVal, scale) {
  $ct_Ljava_math_BigDecimal__($thiz);
  $thiz.c9 = scale;
  $p_Ljava_math_BigDecimal__setUnscaledValue__Ljava_math_BigInteger__V($thiz, unscaledVal);
  return $thiz;
}
function $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__($thiz, bi) {
  $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__($thiz, bi, 0);
  return $thiz;
}
/** @constructor */
function $c_Ljava_math_BigDecimal() {
  this.EK = null;
  this.uq = 0;
  this.AX = null;
  this.jB = 0;
  this.hC = 0;
  this.hD = 0;
  this.c9 = 0;
  this.AY = 0;
}
$p = $c_Ljava_math_BigDecimal.prototype = new $h_jl_Number();
$p.constructor = $c_Ljava_math_BigDecimal;
/** @constructor */
function $h_Ljava_math_BigDecimal() {
}
$h_Ljava_math_BigDecimal.prototype = $p;
$p.ai3 = (function() {
  if ((this.jB < 64)) {
    var x_$_lo = this.hC;
    var x_$_hi = this.hD;
    if ((x_$_hi < 0)) {
      return (-1);
    } else {
      var x$1_$_lo = this.hC;
      var x$1_$_hi = this.hD;
      return (((x$1_$_hi === 0) ? (x$1_$_lo !== 0) : (x$1_$_hi > 0)) | 0);
    }
  } else {
    return this.jU().bS;
  }
});
$p.PJ = (function() {
  if ((this.AY === 0)) {
    if ((this.jB === 0)) {
      var $x_1 = 1;
    } else if ((this.jB < 64)) {
      var $x_1 = $p_Ljava_math_BigDecimal__decimalDigitsInLong__J__I(this, this.hC, this.hD);
    } else {
      var decimalDigits = ((1 + $doubleToInt((0.3010299956639812 * ((this.jB - 1) | 0)))) | 0);
      var $x_3 = this.jU();
      var $x_2 = $m_Ljava_math_Multiplication$();
      var hi = (decimalDigits >> 31);
      if (($x_3.afl($x_2.yi(decimalDigits, hi)).bS !== 0)) {
        var $x_1 = ((1 + decimalDigits) | 0);
      } else {
        var $x_1 = decimalDigits;
      }
    }
    this.AY = $x_1;
  }
  return this.AY;
});
$p.b8J = (function(newScale, roundingMode) {
  var hi = (newScale >> 31);
  var value = this.c9;
  var hi$1 = (value >> 31);
  var lo = ((newScale - value) | 0);
  var hi$2 = ((((hi - hi$1) | 0) - (((lo >>> 0) > (newScale >>> 0)) | 0)) | 0);
  if (((lo | hi$2) === 0)) {
    return this;
  } else if (((hi$2 === 0) ? (lo !== 0) : (hi$2 > 0))) {
    var value$1 = (($m_Ljava_math_BigDecimal$().yB.a.length >>> 1) | 0);
    var hi$3 = (value$1 >> 31);
    if ((((hi$2 === hi$3) ? ((lo >>> 0) < (value$1 >>> 0)) : (hi$2 < hi$3)) && ($p_Ljava_math_BigDecimal__cmp$1__J__I(this, lo, hi$2) < 64))) {
      var $x_3 = $m_Ljava_math_BigDecimal$();
      var x_$_lo = this.hC;
      var x_$_hi = this.hD;
      var $x_1 = $m_Ljava_math_BigDecimal$().yB.a;
      var $x_2 = (lo << 1);
      var x$1_$_lo = $x_1[$x_2];
      var x$1_$_hi = $x_1[(($x_2 + 1) | 0)];
      var a0 = (65535 & x_$_lo);
      var a1 = ((x_$_lo >>> 16) | 0);
      var b0 = (65535 & x$1_$_lo);
      var b1 = ((x$1_$_lo >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$4 = ((((((((Math.imul(x_$_lo, x$1_$_hi) + Math.imul(x_$_hi, x$1_$_lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      return $x_3.Yh(lo$1, hi$4, newScale);
    } else {
      var $x_5 = $m_Ljava_math_Multiplication$();
      var $x_4 = this.jU();
      var hi$5 = (lo >> 31);
      return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), $x_5.b4F($x_4, lo, hi$5), newScale);
    }
  } else {
    if ((this.jB < 64)) {
      var lo$2 = ((-lo) | 0);
      var hi$6 = ((((-hi$2) | 0) - ((lo$2 !== 0) | 0)) | 0);
      var value$2 = (($m_Ljava_math_BigDecimal$().yB.a.length >>> 1) | 0);
      var hi$7 = (value$2 >> 31);
      var $x_6 = ((hi$6 === hi$7) ? ((lo$2 >>> 0) < (value$2 >>> 0)) : (hi$6 < hi$7));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var $x_7 = $m_Ljava_math_BigDecimal$().yB.a;
      var $x_8 = (((-lo) | 0) << 1);
      var lpt_$_lo = $x_7[$x_8];
      var lpt_$_hi = $x_7[(($x_8 + 1) | 0)];
      return $m_Ljava_math_BigDecimal$().b3J(this.hC, this.hD, lpt_$_lo, lpt_$_hi, newScale, roundingMode);
    } else {
      var $x_9 = $m_Ljava_math_Multiplication$();
      var lo$3 = ((-lo) | 0);
      var hi$8 = ((((-hi$2) | 0) - ((lo$3 !== 0) | 0)) | 0);
      var powTen = $x_9.yi(lo$3, hi$8);
      return $m_Ljava_math_BigDecimal$().b3I(this.jU(), powTen, newScale, roundingMode);
    }
  }
});
$p.b8f = (function(n) {
  var value = this.c9;
  var hi = (value >> 31);
  var hi$1 = (n >> 31);
  var lo = ((value - n) | 0);
  var hi$2 = ((((hi - hi$1) | 0) - (((lo >>> 0) > (value >>> 0)) | 0)) | 0);
  if ((this.jB < 64)) {
    var x_$_lo = this.hC;
    var x_$_hi = this.hD;
    if (((x_$_lo | x_$_hi) === 0)) {
      return $m_Ljava_math_BigDecimal$().b3K(lo, hi$2);
    } else {
      return $m_Ljava_math_BigDecimal$().Yh(this.hC, this.hD, $m_Ljava_math_BigDecimal$().Xl(lo, hi$2));
    }
  } else {
    return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), this.jU(), $m_Ljava_math_BigDecimal$().Xl(lo, hi$2));
  }
});
$p.aSw = (function() {
  if ($p_Ljava_math_BigDecimal__isZero__Z(this)) {
    return $m_Ljava_math_BigDecimal$().atb;
  } else {
    var lastPow = (($m_Ljava_math_Multiplication$().B1.a.length - 1) | 0);
    var i = 1;
    var strippedBI = this.jU();
    var value = this.c9;
    var hi = (value >> 31);
    var scale_$_lo = value;
    var scale_$_hi = hi;
    var x1___1;
    var x1___2;
    while (true) {
      if ((!strippedBI.Y6(0))) {
        var qr = strippedBI.afm($m_Ljava_math_Multiplication$().B1.a[i]);
        if ((qr.Kb.bS === 0)) {
          var temp$i = ((i < lastPow) ? ((1 + i) | 0) : i);
          var temp$strippedBI = qr.yD;
          var x_$_lo = scale_$_lo;
          var x_$_hi = scale_$_hi;
          var value$1 = i;
          var hi$1 = (value$1 >> 31);
          var lo = ((x_$_lo - value$1) | 0);
          var hi$2 = ((((x_$_hi - hi$1) | 0) - (((lo >>> 0) > (x_$_lo >>> 0)) | 0)) | 0);
          i = temp$i;
          strippedBI = temp$strippedBI;
          scale_$_lo = lo;
          scale_$_hi = hi$2;
          continue;
        }
        if ((i !== 1)) {
          i = 1;
          continue;
        }
        var x1___1 = strippedBI;
        var x1___2 = $bL(scale_$_lo, scale_$_hi);
        break;
      } else {
        var x1___1 = strippedBI;
        var x1___2 = $bL(scale_$_lo, scale_$_hi);
        break;
      }
    }
    var strippedBI$1 = x1___1;
    var $x_1 = $uJ(x1___2);
    var newScale_$_lo = $x_1.l;
    var newScale_$_hi = $x_1.h;
    return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), strippedBI$1, $m_Ljava_math_BigDecimal$().Xl(newScale_$_lo, newScale_$_hi));
  }
});
$p.af7 = (function(bi) {
  var thisSign = this.ai3();
  var valueSign = bi.ai3();
  if ((thisSign === valueSign)) {
    if ((((this.c9 === bi.c9) && (this.jB < 64)) && (bi.jB < 64))) {
      var x_$_lo = this.hC;
      var x_$_hi = this.hD;
      var x$1_$_lo = bi.hC;
      var x$1_$_hi = bi.hD;
      if (((x_$_hi === x$1_$_hi) ? ((x_$_lo >>> 0) < (x$1_$_lo >>> 0)) : (x_$_hi < x$1_$_hi))) {
        return (-1);
      } else {
        var x$2_$_lo = this.hC;
        var x$2_$_hi = this.hD;
        var x$3_$_lo = bi.hC;
        var x$3_$_hi = bi.hD;
        return (((x$2_$_hi === x$3_$_hi) ? ((x$2_$_lo >>> 0) > (x$3_$_lo >>> 0)) : (x$2_$_hi > x$3_$_hi)) | 0);
      }
    } else {
      var value = this.c9;
      var hi = (value >> 31);
      var value$1 = bi.c9;
      var hi$1 = (value$1 >> 31);
      var lo = ((value - value$1) | 0);
      var hi$2 = ((((hi - hi$1) | 0) - (((lo >>> 0) > (value >>> 0)) | 0)) | 0);
      var diffPrecision = (($p_Ljava_math_BigDecimal__approxPrecision__I(this) - $p_Ljava_math_BigDecimal__approxPrecision__I(bi)) | 0);
      var hi$3 = (diffPrecision >> 31);
      var lo$1 = ((1 + lo) | 0);
      var hi$4 = ((hi$2 + ((lo$1 === 0) | 0)) | 0);
      if (((hi$3 === hi$4) ? ((diffPrecision >>> 0) > (lo$1 >>> 0)) : (hi$3 > hi$4))) {
        return thisSign;
      } else {
        var hi$5 = (diffPrecision >> 31);
        var lo$2 = ((lo - 1) | 0);
        var hi$6 = ((((hi$2 - 1) | 0) + ((lo$2 !== (-1)) | 0)) | 0);
        if (((hi$5 === hi$6) ? ((diffPrecision >>> 0) < (lo$2 >>> 0)) : (hi$5 < hi$6))) {
          return ((-thisSign) | 0);
        } else {
          var t = this.jU();
          var v = bi.jU();
          if ((hi$2 < 0)) {
            var $x_1 = $m_Ljava_math_Multiplication$();
            var lo$3 = ((-lo) | 0);
            var hi$7 = ((((-hi$2) | 0) - ((lo$3 !== 0) | 0)) | 0);
            var x1___1 = t.mR($x_1.yi(lo$3, hi$7));
            var x1___2 = v;
          } else if (((hi$2 === 0) ? (lo !== 0) : (hi$2 > 0))) {
            var x1___1 = t;
            var x1___2 = v.mR($m_Ljava_math_Multiplication$().yi(lo, hi$2));
          } else {
            var x1___1 = t;
            var x1___2 = v;
          }
          var thisUnscaled = x1___1;
          var valUnscaled = x1___2;
          return thisUnscaled.Ah(valUnscaled);
        }
      }
    }
  } else {
    return ((thisSign < valueSign) ? (-1) : 1);
  }
});
$p.e = (function(x) {
  if ((x instanceof $c_Ljava_math_BigDecimal)) {
    if ((x.c9 === this.c9)) {
      if ((this.jB < 64)) {
        var $x_1 = x;
        var x$1_$_lo = $x_1.hC;
        var x$1_$_hi = $x_1.hD;
        var x$2_$_lo = this.hC;
        var x$2_$_hi = this.hD;
        return (((x$1_$_lo ^ x$2_$_lo) | (x$1_$_hi ^ x$2_$_hi)) === 0);
      } else {
        return this.AX.e(x.AX);
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.x = (function() {
  if ((this.uq !== 0)) {
    return this.uq;
  } else if ((this.jB < 64)) {
    this.uq = $s_RTLong__toInt__I__I__I(this.hC, this.hD);
    var $x_1 = this.uq;
    var x$1_$_lo = this.hC;
    var x$1_$_hi = this.hD;
    this.uq = ((Math.imul(33, $x_1) + x$1_$_hi) | 0);
    this.uq = ((Math.imul(17, this.uq) + this.c9) | 0);
    return this.uq;
  } else {
    this.uq = ((Math.imul(17, this.AX.x()) + this.c9) | 0);
    return this.uq;
  }
});
$p.m = (function() {
  if ((this.EK !== null)) {
    return this.EK;
  } else if ((this.jB < 32)) {
    this.EK = $m_Ljava_math_Conversion$().ba5(this.hC, this.hD, this.c9);
    return this.EK;
  } else {
    var intString = $m_Ljava_math_Conversion$().yn(this.jU());
    if ((this.c9 === 0)) {
      return intString;
    } else {
      var begin = ((this.jU().bS < 0) ? 2 : 1);
      var end = intString.length;
      var value = this.c9;
      var hi = (value >> 31);
      var lo = ((-value) | 0);
      var hi$1 = ((((-hi) | 0) - ((lo !== 0) | 0)) | 0);
      var hi$2 = (end >> 31);
      var lo$1 = ((lo + end) | 0);
      var hi$3 = ((((hi$1 + hi$2) | 0) + (((lo$1 >>> 0) < (lo >>> 0)) | 0)) | 0);
      var hi$4 = (begin >> 31);
      var lo$2 = ((lo$1 - begin) | 0);
      var hi$5 = ((((hi$3 - hi$4) | 0) - (((lo$2 >>> 0) > (lo$1 >>> 0)) | 0)) | 0);
      if (((this.c9 > 0) && ((hi$5 === (-1)) ? ((lo$2 >>> 0) >= 4294967290) : (hi$5 > (-1))))) {
        if ((hi$5 >= 0)) {
          $m_Ljava_math_BigDecimal$();
          var pos = ((end - this.c9) | 0);
          $m_Ljava_math_BigDecimal$();
          var result = ((intString.substring(0, pos) + ".") + intString.substring(pos));
        } else {
          $m_Ljava_math_BigDecimal$();
          $m_Ljava_math_BigDecimal$();
          var pos$1 = ((begin - 1) | 0);
          $m_Ljava_math_BigDecimal$();
          var s = ((intString.substring(0, pos$1) + "0.") + intString.substring(pos$1));
          var pos$2 = ((1 + begin) | 0);
          var s2 = $m_Ljava_math_BigDecimal$().K9;
          var s2Len = (~lo$2);
          $m_Ljava_math_BigDecimal$();
          var s2$1 = s2.substring(0, s2Len);
          var result = ((("" + s.substring(0, pos$2)) + s2$1) + s.substring(pos$2));
        }
      } else {
        var r0 = ((((end - begin) | 0) >= 1) ? ($m_Ljava_math_BigDecimal$(), $m_Ljava_math_BigDecimal$(), ((intString.substring(0, begin) + ".") + intString.substring(begin))) : intString);
        var r1 = (r0 + "E");
        var result = ((((hi$5 === 0) ? (lo$2 !== 0) : (hi$5 > 0)) ? (r1 + "+") : r1) + $m_RTLong$().kY(lo$2, hi$5));
      }
      this.EK = result;
      return this.EK;
    }
  }
});
$p.Q2 = (function() {
  var intStr = $m_Ljava_math_Conversion$().yn(this.jU());
  if (((this.c9 === 0) || ($p_Ljava_math_BigDecimal__isZero__Z(this) && (this.c9 < 0)))) {
    return intStr;
  } else {
    var begin = ((this.ai3() < 0) | 0);
    var delta = this.c9;
    var result = ((begin === 1) ? "-" : "");
    if ((this.c9 > 0)) {
      delta = ((delta - ((intStr.length - begin) | 0)) | 0);
      if ((delta >= 0)) {
        result = (result + "0.");
        while ((delta > 100)) {
          result = (("" + result) + $m_Ljava_math_BigDecimal$().K9);
          delta = ((delta - 100) | 0);
        }
        var $x_1 = result;
        var this$2 = $m_Ljava_math_BigDecimal$().K9;
        var endIndex = delta;
        result = ((("" + $x_1) + this$2.substring(0, endIndex)) + intStr.substring(begin));
      } else {
        delta = ((begin - delta) | 0);
        var $x_3 = result;
        var endIndex$1 = delta;
        var $x_2 = intStr.substring(begin, endIndex$1);
        var beginIndex = delta;
        result = (($x_3 + ($x_2 + ".")) + intStr.substring(beginIndex));
      }
    } else {
      result = (("" + result) + intStr.substring(begin));
      while ((delta < (-100))) {
        result = (("" + result) + $m_Ljava_math_BigDecimal$().K9);
        delta = ((100 + delta) | 0);
      }
      var $x_4 = result;
      var this$11 = $m_Ljava_math_BigDecimal$().K9;
      var endIndex$2 = ((-delta) | 0);
      result = (("" + $x_4) + this$11.substring(0, endIndex$2));
    }
    return result;
  }
});
$p.a4Z = (function() {
  if (((this.c9 === 0) || $p_Ljava_math_BigDecimal__isZero__Z(this))) {
    return this.jU();
  } else if ((this.c9 < 0)) {
    var $x_2 = this.jU();
    var $x_1 = $m_Ljava_math_Multiplication$();
    var value = this.c9;
    var hi = (value >> 31);
    var lo = ((-value) | 0);
    var hi$1 = ((((-hi) | 0) - ((lo !== 0) | 0)) | 0);
    return $x_2.mR($x_1.yi(lo, hi$1));
  } else {
    var $x_4 = this.jU();
    var $x_3 = $m_Ljava_math_Multiplication$();
    var value$1 = this.c9;
    var hi$2 = (value$1 >> 31);
    return $x_4.afl($x_3.yi(value$1, hi$2));
  }
});
$p.aSR = (function() {
  if (((this.c9 === 0) || $p_Ljava_math_BigDecimal__isZero__Z(this))) {
    return this.jU();
  } else if ((this.c9 < 0)) {
    var $x_2 = this.jU();
    var $x_1 = $m_Ljava_math_Multiplication$();
    var value = this.c9;
    var hi = (value >> 31);
    var lo = ((-value) | 0);
    var hi$1 = ((((-hi) | 0) - ((lo !== 0) | 0)) | 0);
    return $x_2.mR($x_1.yi(lo, hi$1));
  } else {
    if (((this.c9 > $p_Ljava_math_BigDecimal__approxPrecision__I(this)) || (this.c9 > this.jU().aOU()))) {
      throw new $c_jl_ArithmeticException("Rounding necessary");
    }
    var $x_4 = this.jU();
    var $x_3 = $m_Ljava_math_Multiplication$();
    var value$1 = this.c9;
    var hi$2 = (value$1 >> 31);
    var integerAndFraction = $x_4.aNy($x_3.yi(value$1, hi$2));
    if ((integerAndFraction.a[1].bS !== 0)) {
      throw new $c_jl_ArithmeticException("Rounding necessary");
    }
    return integerAndFraction.a[0];
  }
});
$p.lY = (function() {
  if (((this.c9 <= (-64)) || (this.c9 > $p_Ljava_math_BigDecimal__approxPrecision__I(this)))) {
    return $bL(0, 0);
  } else {
    return this.a4Z().lY();
  }
});
$p.lm = (function() {
  return (((this.c9 <= (-32)) || (this.c9 > $p_Ljava_math_BigDecimal__approxPrecision__I(this))) ? 0 : this.a4Z().lm());
});
$p.agy = (function() {
  var $x_1 = $p_Ljava_math_BigDecimal__valueExact__I__J(this, 32);
  return $s_RTLong__toInt__I__I__I($x_1.l, $x_1.h);
});
$p.b8Q = (function() {
  var $x_1 = $p_Ljava_math_BigDecimal__valueExact__I__J(this, 16);
  return (($s_RTLong__toInt__I__I__I($x_1.l, $x_1.h) << 16) >> 16);
});
$p.aYa = (function() {
  var $x_1 = $p_Ljava_math_BigDecimal__valueExact__I__J(this, 8);
  return (($s_RTLong__toInt__I__I__I($x_1.l, $x_1.h) << 24) >> 24);
});
$p.DX = (function() {
  return $m_jl_Float$().a4m(((this.jU() + "e") + ((-this.c9) | 0)));
});
$p.vY = (function() {
  return $m_jl_Double$().bd(((this.jU() + "e") + ((-this.c9) | 0)));
});
$p.jU = (function() {
  if ((this.AX === null)) {
    this.AX = $m_Ljava_math_BigInteger$().oI(this.hC, this.hD);
  }
  return this.AX;
});
$p.pp = (function(o) {
  return this.af7(o);
});
function $isArrayOf_Ljava_math_BigDecimal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.f1)));
}
var $d_Ljava_math_BigDecimal = new $TypeData().i($c_Ljava_math_BigDecimal, "java.math.BigDecimal", ({
  f1: 1,
  aP: 1,
  a: 1,
  Q: 1
}));
function $p_Ljava_math_BigInteger__setFromString__T__I__V($thiz, s, radix) {
  if ((((s === "") || (s === "+")) || (s === "-"))) {
    throw new $c_jl_NumberFormatException("Zero length BigInteger");
  }
  var stringLength0 = s.length;
  if ((s.charCodeAt(0) === 45)) {
    var x1___1 = (-1);
    var x1___2 = 1;
    var x1___3 = ((stringLength0 - 1) | 0);
  } else if ((s.charCodeAt(0) === 43)) {
    var x1___1 = 1;
    var x1___2 = 1;
    var x1___3 = ((stringLength0 - 1) | 0);
  } else {
    var x1___1 = 1;
    var x1___2 = 0;
    var x1___3 = stringLength0;
  }
  var _sign = (x1___1 | 0);
  var startChar = (x1___2 | 0);
  var stringLength = (x1___3 | 0);
  var i = startChar;
  while ((i < stringLength0)) {
    var value = i;
    var c = s.charCodeAt(value);
    if (((c === 43) || (c === 45))) {
      throw new $c_jl_NumberFormatException("Illegal embedded sign character");
    }
    i = ((1 + i) | 0);
  }
  var charsPerInt = $m_Ljava_math_Conversion$().a7g.a[radix];
  var bigRadixDigitsLength = ((stringLength / $checkIntDivisor(charsPerInt)) | 0);
  var topChars = ((stringLength % $checkIntDivisor(charsPerInt)) | 0);
  if ((topChars !== 0)) {
    bigRadixDigitsLength = ((1 + bigRadixDigitsLength) | 0);
  }
  var _digits = new $ac_I(bigRadixDigitsLength);
  var bigRadix = $m_Ljava_math_Conversion$().a7f.a[((radix - 2) | 0)];
  var digitIndex = 0;
  var substrEnd = ((startChar + ((topChars === 0) ? charsPerInt : topChars)) | 0);
  var newDigit = 0;
  var substrStart = startChar;
  while ((substrStart < stringLength0)) {
    var this$4 = $m_jl_Integer$();
    var beginIndex = substrStart;
    var endIndex = substrEnd;
    var s$1 = s.substring(beginIndex, endIndex);
    if (((((radix - 2) | 0) >>> 0) > 34)) {
      this$4.pB(s$1);
    }
    var bigRadixDigit = this$4.gc(s$1, radix, ((2147483648 / ($checkIntDivisor(radix) >>> 0)) | 0));
    newDigit = $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I($m_Ljava_math_Multiplication$(), _digits, _digits, digitIndex, bigRadix);
    newDigit = ((newDigit + $m_Ljava_math_Elementary$().b2R(_digits, digitIndex, bigRadixDigit)) | 0);
    _digits.a[digitIndex] = newDigit;
    digitIndex = ((1 + digitIndex) | 0);
    substrStart = substrEnd;
    substrEnd = ((substrStart + charsPerInt) | 0);
  }
  $thiz.bS = _sign;
  $thiz.cp = digitIndex;
  $thiz.bC = _digits;
  $thiz.pq();
}
function $ct_Ljava_math_BigInteger__($thiz) {
  $thiz.Zb = (-2);
  $thiz.AZ = 0;
  return $thiz;
}
function $ct_Ljava_math_BigInteger__T__I__($thiz, s, radix) {
  $ct_Ljava_math_BigInteger__($thiz);
  if (((((radix - 2) | 0) >>> 0) > 34)) {
    throw new $c_jl_NumberFormatException("Radix out of range");
  }
  if ((s === "")) {
    throw new $c_jl_NumberFormatException("Zero length BigInteger");
  }
  $p_Ljava_math_BigInteger__setFromString__T__I__V($thiz, s, radix);
  return $thiz;
}
function $ct_Ljava_math_BigInteger__T__($thiz, s) {
  $ct_Ljava_math_BigInteger__T__I__($thiz, s, 10);
  return $thiz;
}
function $ct_Ljava_math_BigInteger__I__I__($thiz, sign, value) {
  $ct_Ljava_math_BigInteger__($thiz);
  $thiz.bS = sign;
  $thiz.cp = 1;
  $thiz.bC = new $ac_I(new Int32Array([value]));
  return $thiz;
}
function $ct_Ljava_math_BigInteger__I__AI__($thiz, signum, digits) {
  $ct_Ljava_math_BigInteger__($thiz);
  if ((digits.a.length === 0)) {
    $thiz.bS = 0;
    $thiz.cp = 1;
    $thiz.bC = new $ac_I(new Int32Array([0]));
  } else {
    $thiz.bS = signum;
    $thiz.cp = digits.a.length;
    $thiz.bC = digits;
    $thiz.pq();
  }
  return $thiz;
}
function $ct_Ljava_math_BigInteger__I__I__AI__($thiz, sign, numberLength, digits) {
  $ct_Ljava_math_BigInteger__($thiz);
  $thiz.bS = sign;
  $thiz.cp = numberLength;
  $thiz.bC = digits;
  return $thiz;
}
function $ct_Ljava_math_BigInteger__I__J__($thiz, sign, lVal_$_lo, lVal_$_hi) {
  $ct_Ljava_math_BigInteger__($thiz);
  $thiz.bS = sign;
  if ((lVal_$_hi === 0)) {
    $thiz.cp = 1;
    $thiz.bC = new $ac_I(new Int32Array([lVal_$_lo]));
  } else {
    $thiz.cp = 2;
    $thiz.bC = new $ac_I(new Int32Array([lVal_$_lo, lVal_$_hi]));
  }
  return $thiz;
}
/** @constructor */
function $c_Ljava_math_BigInteger() {
  this.bC = null;
  this.cp = 0;
  this.bS = 0;
  this.Zb = 0;
  this.AZ = 0;
}
$p = $c_Ljava_math_BigInteger.prototype = new $h_jl_Number();
$p.constructor = $c_Ljava_math_BigInteger;
/** @constructor */
function $h_Ljava_math_BigInteger() {
}
$h_Ljava_math_BigInteger.prototype = $p;
$p.a2A = (function() {
  return ((this.bS < 0) ? $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), 1, this.cp, this.bC) : this);
});
$p.Ah = (function(bi) {
  return ((this.bS > bi.bS) ? 1 : ((this.bS < bi.bS) ? (-1) : ((this.cp > bi.cp) ? this.bS : ((this.cp < bi.cp) ? ((-bi.bS) | 0) : Math.imul(this.bS, $m_Ljava_math_Elementary$().Ww(this.bC, bi.bC, this.cp))))));
});
$p.afl = (function(divisor) {
  if ((divisor.bS === 0)) {
    throw new $c_jl_ArithmeticException("BigInteger divide by zero");
  }
  var divisorSign = divisor.bS;
  if (divisor.b3m()) {
    return ((divisor.bS > 0) ? this : this.aQn());
  } else {
    var thisSign = this.bS;
    var thisLen = this.cp;
    var divisorLen = divisor.cp;
    if ((((thisLen + divisorLen) | 0) === 2)) {
      var dividend = this.bC.a[0];
      var divisor$1 = divisor.bC.a[0];
      var x = (((dividend >>> 0) / ($checkIntDivisor(divisor$1) >>> 0)) | 0);
      if ((thisSign !== divisorSign)) {
        var lo = ((-x) | 0);
        var hi = ((-((lo !== 0) | 0)) | 0);
        var bi_$_lo = lo;
        var bi_$_hi = hi;
      } else {
        var bi_$_lo = x;
        var bi_$_hi = 0;
      }
      return $m_Ljava_math_BigInteger$().oI(bi_$_lo, bi_$_hi);
    } else {
      var cmp = ((thisLen !== divisorLen) ? ((thisLen > divisorLen) ? 1 : (-1)) : $m_Ljava_math_Elementary$().Ww(this.bC, divisor.bC, thisLen));
      if ((cmp === 0)) {
        return ((thisSign === divisorSign) ? $m_Ljava_math_BigInteger$().Ka : $m_Ljava_math_BigInteger$().Zc);
      } else if ((cmp === (-1))) {
        return $m_Ljava_math_BigInteger$().ws;
      } else {
        var resLength = ((1 + ((thisLen - divisorLen) | 0)) | 0);
        var resDigits = new $ac_I(resLength);
        var resSign = ((thisSign === divisorSign) ? 1 : (-1));
        if ((divisorLen === 1)) {
          $m_Ljava_math_Division$().afn(resDigits, this.bC, thisLen, divisor.bC.a[0]);
        } else {
          $m_Ljava_math_Division$().aNx(resDigits, resLength, this.bC, thisLen, divisor.bC, divisorLen);
        }
        var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, resLength, resDigits);
        result.pq();
        return result;
      }
    }
  }
});
$p.aNy = (function(divisor) {
  return this.afm(divisor).b9Y();
});
$p.afm = (function(divisor) {
  var divisorSign = divisor.bS;
  if ((divisorSign === 0)) {
    throw new $c_jl_ArithmeticException("BigInteger divide by zero");
  }
  var divisorLen = divisor.cp;
  var divisorDigits = divisor.bC;
  if ((divisorLen === 1)) {
    return $m_Ljava_math_Division$().b03(this, divisorDigits.a[0], divisorSign);
  } else {
    var thisDigits = this.bC;
    var thisLen = this.cp;
    if ((((thisLen !== divisorLen) ? ((thisLen > divisorLen) ? 1 : (-1)) : $m_Ljava_math_Elementary$().Ww(thisDigits, divisorDigits, thisLen)) < 0)) {
      return new $c_Ljava_math_BigInteger$QuotAndRem($m_Ljava_math_BigInteger$().ws, this);
    } else {
      var thisSign = this.bS;
      var quotientLength = ((1 + ((thisLen - divisorLen) | 0)) | 0);
      var quotientSign = ((thisSign === divisorSign) ? 1 : (-1));
      var quotientDigits = new $ac_I(quotientLength);
      var remainderDigits = $m_Ljava_math_Division$().aNx(quotientDigits, quotientLength, thisDigits, thisLen, divisorDigits, divisorLen);
      var result0 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), quotientSign, quotientLength, quotientDigits);
      var result1 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), thisSign, divisorLen, remainderDigits);
      result0.pq();
      result1.pq();
      return new $c_Ljava_math_BigInteger$QuotAndRem(result0, result1);
    }
  }
});
$p.e = (function(x) {
  return ((x instanceof $c_Ljava_math_BigInteger) && (((this.bS === x.bS) && (this.cp === x.cp)) && this.b0L(x.bC)));
});
$p.aOU = (function() {
  if ((this.bS === 0)) {
    return (-1);
  } else {
    var i = this.a3A();
    var i$1 = this.bC.a[i];
    return (((i << 5) + ((32 - Math.clz32(((~i$1) & ((i$1 - 1) | 0)))) | 0)) | 0);
  }
});
$p.x = (function() {
  if ((this.AZ !== 0)) {
    return this.AZ;
  } else {
    var end = this.cp;
    var i = 0;
    while ((i < end)) {
      var value = i;
      this.AZ = ((Math.imul(33, this.AZ) + this.bC.a[value]) | 0);
      i = ((1 + i) | 0);
    }
    this.AZ = Math.imul(this.AZ, this.bS);
    return this.AZ;
  }
});
$p.lm = (function() {
  return Math.imul(this.bS, this.bC.a[0]);
});
$p.lY = (function() {
  if ((this.cp > 1)) {
    var value = this.bC.a[1];
    var value$1 = this.bC.a[0];
    var value$3_$_lo = value$1;
    var value$3_$_hi = value;
  } else {
    var value$2 = this.bC.a[0];
    var value$3_$_lo = value$2;
    var value$3_$_hi = 0;
  }
  var value$4 = this.bS;
  var hi$3 = (value$4 >> 31);
  var a0 = (65535 & value$4);
  var a1 = ((value$4 >>> 16) | 0);
  var b0 = (65535 & value$3_$_lo);
  var b1 = ((value$3_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(a0, b0);
  var a1b0 = Math.imul(a1, b0);
  var a0b1 = Math.imul(a0, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$4 = ((((((((Math.imul(value$4, value$3_$_hi) + Math.imul(hi$3, value$3_$_lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  return $bL(lo, hi$4);
});
$p.mR = (function(bi) {
  return (((bi.bS === 0) || (this.bS === 0)) ? $m_Ljava_math_BigInteger$().ws : $m_Ljava_math_Multiplication$().a40(this, bi));
});
$p.aQn = (function() {
  return ((this.bS === 0) ? this : $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), ((-this.bS) | 0), this.cp, this.bC));
});
$p.AA = (function(exp) {
  if ((exp < 0)) {
    throw new $c_jl_ArithmeticException("Negative exponent");
  } else if ((exp === 0)) {
    return $m_Ljava_math_BigInteger$().Ka;
  } else if ((((exp === 1) || this.e($m_Ljava_math_BigInteger$().Ka)) || this.e($m_Ljava_math_BigInteger$().ws))) {
    return this;
  } else if ((!this.Y6(0))) {
    var x = 1;
    while ((!this.Y6(x))) {
      x = ((1 + x) | 0);
    }
    return $m_Ljava_math_BigInteger$().b28(Math.imul(x, exp)).mR(this.a4I(x).AA(exp));
  } else {
    return $m_Ljava_math_Multiplication$().b6L(this, exp);
  }
});
$p.uh = (function(n) {
  return (((n === 0) || (this.bS === 0)) ? this : ((n > 0) ? $m_Ljava_math_BitLevel$().aS9(this, n) : $m_Ljava_math_BitLevel$().aSc(this, ((-n) | 0))));
});
$p.a4I = (function(n) {
  return (((n === 0) || (this.bS === 0)) ? this : ((n > 0) ? $m_Ljava_math_BitLevel$().aSc(this, n) : $m_Ljava_math_BitLevel$().aS9(this, ((-n) | 0))));
});
$p.Y6 = (function(n) {
  var intCount = (n >> 5);
  if ((n === 0)) {
    return ((1 & this.bC.a[0]) !== 0);
  } else {
    if ((n < 0)) {
      throw new $c_jl_ArithmeticException("Negative bit address");
    }
    if ((intCount >= this.cp)) {
      return (this.bS < 0);
    } else if ((!((this.bS < 0) && (intCount < this.a3A())))) {
      var digit = this.bC.a[intCount];
      if ((this.bS < 0)) {
        digit = ((this.a3A() === intCount) ? ((-digit) | 0) : (~digit));
      }
      return ((digit & (1 << n)) !== 0);
    } else {
      return false;
    }
  }
});
$p.m = (function() {
  return $m_Ljava_math_Conversion$().yn(this);
});
$p.pq = (function() {
  while (true) {
    if ((this.cp > 0)) {
      this.cp = ((this.cp - 1) | 0);
      if ((this.bC.a[this.cp] === 0)) {
        continue;
      }
    }
    break;
  }
  if ((this.bC.a[this.cp] === 0)) {
    this.bS = 0;
  }
  this.cp = ((1 + this.cp) | 0);
});
$p.b0L = (function(b) {
  var i = 0;
  while ((i !== this.cp)) {
    if ((this.bC.a[i] !== b.a[i])) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
$p.a3A = (function() {
  if ((this.Zb === (-2))) {
    if ((this.bS === 0)) {
      var $x_1 = (-1);
    } else {
      var i = 0;
      while ((this.bC.a[i] === 0)) {
        i = ((1 + i) | 0);
      }
      var $x_1 = i;
    }
    this.Zb = $x_1;
  }
  return this.Zb;
});
$p.b3m = (function() {
  return ((this.cp === 1) && (this.bC.a[0] === 1));
});
$p.aSb = (function() {
  return ((this.bS === 0) ? this : $m_Ljava_math_BitLevel$().b8P(this));
});
$p.pp = (function(o) {
  return this.Ah(o);
});
function $isArrayOf_Ljava_math_BigInteger(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.f2)));
}
var $d_Ljava_math_BigInteger = new $TypeData().i($c_Ljava_math_BigInteger, "java.math.BigInteger", ({
  f2: 1,
  aP: 1,
  a: 1,
  Q: 1
}));
/** @constructor */
function $c_Ljava_math_RoundingMode(name, ordinal) {
  this.up = null;
  this.k6 = 0;
  $ct_jl_Enum__T__I__(this, name, ordinal);
}
$p = $c_Ljava_math_RoundingMode.prototype = new $h_jl_Enum();
$p.constructor = $c_Ljava_math_RoundingMode;
/** @constructor */
function $h_Ljava_math_RoundingMode() {
}
$h_Ljava_math_RoundingMode.prototype = $p;
var $d_Ljava_math_RoundingMode = new $TypeData().i($c_Ljava_math_RoundingMode, "java.math.RoundingMode", ({
  sy: 1,
  bf: 1,
  Q: 1,
  a: 1
}));
/** @constructor */
function $c_Ljava_nio_HeapByteBuffer(_capacity, _array0, _arrayOffset0, _initialPosition, _initialLimit, _readOnly, _isDirect) {
  this.nK = 0;
  this.c2 = 0;
  this.b3 = 0;
  this.ur = 0;
  this.m9 = null;
  this.nL = 0;
  this.wt = false;
  this.wt = _readOnly;
  $ct_Ljava_nio_ByteBuffer__I__AB__I__(this, _capacity, _array0, _arrayOffset0);
  $c_Ljava_nio_Buffer.prototype.cX.call(this, _initialPosition);
  $c_Ljava_nio_Buffer.prototype.agT.call(this, _initialLimit);
}
$p = $c_Ljava_nio_HeapByteBuffer.prototype = new $h_Ljava_nio_ByteBuffer();
$p.constructor = $c_Ljava_nio_HeapByteBuffer;
/** @constructor */
function $h_Ljava_nio_HeapByteBuffer() {
}
$h_Ljava_nio_HeapByteBuffer.prototype = $p;
$p.a3z = (function() {
  var p = this.b3;
  if ((p === this.c2)) {
    throw new $c_Ljava_nio_BufferUnderflowException();
  }
  this.b3 = ((1 + p) | 0);
  var a = this.m9;
  var i = ((this.nL + p) | 0);
  return a.a[i];
});
$p.yj = (function(b) {
  if (this.wt) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var p = this.b3;
  if ((p === this.c2)) {
    throw new $c_Ljava_nio_BufferOverflowException();
  }
  this.b3 = ((1 + p) | 0);
  var a = this.m9;
  var i = ((this.nL + p) | 0);
  a.a[i] = b;
  return this;
});
$p.b21 = (function(dst, offset, length) {
  var length$1 = dst.a.length;
  var endOffset = ((offset + length) | 0);
  if (((((offset | length) | endOffset) | ((length$1 - endOffset) | 0)) < 0)) {
    $m_jl_BoundsChecks$().r5(offset, length, length$1);
  }
  var p = this.b3;
  var newPos = ((p + length) | 0);
  if ((newPos > this.c2)) {
    throw new $c_Ljava_nio_BufferUnderflowException();
  }
  this.b3 = newPos;
  var x0 = this.m9;
  var x1 = ((this.nL + p) | 0);
  x0.av(x1, dst, offset, length);
  return this;
});
$p.b74 = (function(src, offset, length) {
  if (this.wt) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var length$1 = src.a.length;
  var endOffset = ((offset + length) | 0);
  if (((((offset | length) | endOffset) | ((length$1 - endOffset) | 0)) < 0)) {
    $m_jl_BoundsChecks$().r5(offset, length, length$1);
  }
  var p = this.b3;
  var newPos = ((p + length) | 0);
  if ((newPos > this.c2)) {
    throw new $c_Ljava_nio_BufferOverflowException();
  }
  this.b3 = newPos;
  var x2 = this.m9;
  var x3 = ((this.nL + p) | 0);
  src.av(offset, x2, x3, length);
  return this;
});
var $d_Ljava_nio_HeapByteBuffer = new $TypeData().i($c_Ljava_nio_HeapByteBuffer, "java.nio.HeapByteBuffer", ({
  sC: 1,
  f6: 1,
  dd: 1,
  Q: 1
}));
class $c_Ljava_nio_charset_CoderMalfunctionError extends $c_jl_Error {
  constructor(cause) {
    super();
    $ct_jl_Error__jl_Throwable__(this, cause);
  }
}
var $d_Ljava_nio_charset_CoderMalfunctionError = new $TypeData().i($c_Ljava_nio_charset_CoderMalfunctionError, "java.nio.charset.CoderMalfunctionError", ({
  sK: 1,
  bO: 1,
  y: 1,
  a: 1
}));
function $p_ju_Formatter__sendToDest__T__V($thiz, s) {
  if (($thiz.ES === null)) {
    $thiz.B8 = (("" + $thiz.B8) + s);
  } else {
    $p_ju_Formatter__sendToDestSlowPath__O__V($thiz, [s]);
  }
}
function $p_ju_Formatter__sendToDest__T__T__V($thiz, s1, s2) {
  if (($thiz.ES === null)) {
    $thiz.B8 = ((("" + $thiz.B8) + s1) + s2);
  } else {
    $p_ju_Formatter__sendToDestSlowPath__O__V($thiz, [s1, s2]);
  }
}
function $p_ju_Formatter__sendToDest__T__T__T__V($thiz, s1, s2, s3) {
  if (($thiz.ES === null)) {
    $thiz.B8 = (($thiz.B8 + (("" + s1) + s2)) + s3);
  } else {
    $p_ju_Formatter__sendToDestSlowPath__O__V($thiz, [s1, s2, s3]);
  }
}
function $p_ju_Formatter__sendToDestSlowPath__O__V($thiz, ss) {
  try {
    var len = (ss.length | 0);
    var i = 0;
    while ((i !== len)) {
      var t = ss[i];
      $thiz.ES.W9(t);
      i = ((1 + i) | 0);
    }
  } catch (e) {
    if ((!(e instanceof $c_Ljava_io_IOException))) {
      throw e;
    }
  }
}
function $p_ju_Formatter__format__ju_Formatter$LocaleInfo__T__AO__ju_Formatter($thiz, localeInfo, format, args) {
  if ($thiz.a7r) {
    throw new $c_ju_FormatterClosedException();
  }
  var lastImplicitArgIndex = 0;
  var lastArgIndex = 0;
  var fmtLength = format.length;
  var fmtIndex = 0;
  while ((fmtIndex !== fmtLength)) {
    var fromIndex = fmtIndex;
    var nextPercentIndex = (format.indexOf("%", fromIndex) | 0);
    if ((nextPercentIndex < 0)) {
      var beginIndex = fmtIndex;
      $p_ju_Formatter__sendToDest__T__V($thiz, format.substring(beginIndex));
      return $thiz;
    }
    var beginIndex$1 = fmtIndex;
    $p_ju_Formatter__sendToDest__T__V($thiz, format.substring(beginIndex$1, nextPercentIndex));
    var formatSpecifierIndex = ((1 + nextPercentIndex) | 0);
    var re = $m_ju_Formatter$().atn;
    re.lastIndex = formatSpecifierIndex;
    var execResult = re.exec(format);
    if (((execResult === null) || ((execResult.index | 0) !== formatSpecifierIndex))) {
      $p_ju_Formatter__throwUnknownFormatConversionException__C__E($thiz, ((formatSpecifierIndex === fmtLength) ? 37 : format.charCodeAt(formatSpecifierIndex)));
    }
    fmtIndex = (re.lastIndex | 0);
    var index = ((fmtIndex - 1) | 0);
    var conversion$2 = format.charCodeAt(index);
    var flags = $p_ju_Formatter__parseFlags__T__C__I($thiz, execResult[2], conversion$2);
    var width = $p_ju_Formatter__parsePositiveInt__O__I($thiz, execResult[3]);
    var precision = $p_ju_Formatter__parsePositiveInt__O__I($thiz, execResult[4]);
    if ((width === (-2))) {
      $p_ju_Formatter__throwIllegalFormatWidthException__I__E($thiz, (-2147483648));
    }
    if ((precision === (-2))) {
      $p_ju_Formatter__throwIllegalFormatPrecisionException__I__E($thiz, (-2147483648));
    }
    if ((conversion$2 === 110)) {
      if ((precision !== (-1))) {
        $p_ju_Formatter__throwIllegalFormatPrecisionException__I__E($thiz, precision);
      }
      if ((width !== (-1))) {
        $p_ju_Formatter__throwIllegalFormatWidthException__I__E($thiz, width);
      }
      if ((flags !== 0)) {
        $thiz.agJ(flags);
      }
      $p_ju_Formatter__sendToDest__T__V($thiz, "\n");
    } else if ((conversion$2 === 37)) {
      if ((precision !== (-1))) {
        $p_ju_Formatter__throwIllegalFormatPrecisionException__I__E($thiz, precision);
      }
      if ((((17 & flags) === 17) || ((12 & flags) === 12))) {
        $thiz.agJ(flags);
      }
      if ((((1 & flags) !== 0) && (width === (-1)))) {
        $p_ju_Formatter__throwMissingFormatWidthException__T__E($thiz, $ps_ju_Formatter__fullFormatSpecifier$1__O__T(execResult));
      }
      if ((((-2) & flags) !== 0)) {
        $thiz.a3X(37, flags, (-2));
      }
      $p_ju_Formatter__padAndSendToDestNoZeroPad__I__I__T__V($thiz, flags, width, "%");
    } else {
      var conversionLower = (((256 & flags) !== 0) ? (65535 & ((32 + conversion$2) | 0)) : conversion$2);
      var illegalFlags = $m_ju_Formatter$().atm.a[((conversionLower - 97) | 0)];
      if (((illegalFlags === (-1)) || (((256 & flags) & illegalFlags) !== 0))) {
        $p_ju_Formatter__throwUnknownFormatConversionException__C__E($thiz, conversion$2);
      }
      if ((((17 & flags) !== 0) && (width === (-1)))) {
        $p_ju_Formatter__throwMissingFormatWidthException__T__E($thiz, $ps_ju_Formatter__fullFormatSpecifier$1__O__T(execResult));
      }
      if ((((17 & flags) === 17) || ((12 & flags) === 12))) {
        $thiz.agJ(flags);
      }
      if (((precision !== (-1)) && ((512 & illegalFlags) !== 0))) {
        $p_ju_Formatter__throwIllegalFormatPrecisionException__I__E($thiz, precision);
      }
      if (((flags & illegalFlags) !== 0)) {
        $thiz.a3X(conversionLower, flags, illegalFlags);
      }
      if (((128 & flags) !== 0)) {
        var argIndex = lastArgIndex;
      } else {
        var i = $p_ju_Formatter__parsePositiveInt__O__I($thiz, execResult[1]);
        if ((i === (-1))) {
          lastImplicitArgIndex = ((1 + lastImplicitArgIndex) | 0);
          var argIndex = lastImplicitArgIndex;
        } else {
          if ((i <= 0)) {
            $p_ju_Formatter__throwIllegalFormatArgumentIndexException__I__E($thiz, i);
          }
          var argIndex = i;
        }
      }
      if (((argIndex <= 0) || (argIndex > args.a.length))) {
        $p_ju_Formatter__throwMissingFormatArgumentException__T__E($thiz, $ps_ju_Formatter__fullFormatSpecifier$1__O__T(execResult));
      }
      lastArgIndex = argIndex;
      var arg = args.a[((argIndex - 1) | 0)];
      if ((((arg === null) && (conversionLower !== 98)) && (conversionLower !== 115))) {
        $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, $m_ju_Formatter$RootLocaleInfo$(), flags, width, precision, "null");
      } else {
        $p_ju_Formatter__formatArg__ju_Formatter$LocaleInfo__O__C__I__I__I__V($thiz, localeInfo, arg, conversionLower, flags, width, precision);
      }
    }
  }
  return $thiz;
}
function $p_ju_Formatter__parseFlags__T__C__I($thiz, flags, conversion) {
  var bits = (((((conversion - 65) | 0) >>> 0) <= 25) ? 256 : 0);
  var len = flags.length;
  var i = 0;
  while ((i !== len)) {
    var index = i;
    var f = flags.charCodeAt(index);
    switch (f) {
      case 45: {
        var bit = 1;
        break;
      }
      case 35: {
        var bit = 2;
        break;
      }
      case 43: {
        var bit = 4;
        break;
      }
      case 32: {
        var bit = 8;
        break;
      }
      case 48: {
        var bit = 16;
        break;
      }
      case 44: {
        var bit = 32;
        break;
      }
      case 40: {
        var bit = 64;
        break;
      }
      case 60: {
        var bit = 128;
        break;
      }
      default: {
        var bit;
        throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), $bC(f));
      }
    }
    if (((bits & bit) !== 0)) {
      $p_ju_Formatter__throwDuplicateFormatFlagsException__C__E($thiz, f);
    }
    bits = (bits | bit);
    i = ((1 + i) | 0);
  }
  return bits;
}
function $p_ju_Formatter__parsePositiveInt__O__I($thiz, capture) {
  if ((capture !== (void 0))) {
    var x = (+parseInt(capture, 10));
    return ((x <= 2.147483647E9) ? $doubleToInt(x) : (-2));
  } else {
    return (-1);
  }
}
function $p_ju_Formatter__formatArg__ju_Formatter$LocaleInfo__O__C__I__I__I__V($thiz, localeInfo, arg, conversionLower, flags, width, precision) {
  switch (conversionLower) {
    case 98: {
      $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, $m_ju_Formatter$RootLocaleInfo$(), flags, width, precision, (((arg === false) || (arg === null)) ? "false" : "true"));
      break;
    }
    case 104: {
      var $x_1 = $m_ju_Formatter$RootLocaleInfo$();
      var i = $dp_hashCode__I(arg);
      $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, $x_1, flags, width, precision, (i >>> 0.0).toString(16));
      break;
    }
    case 115: {
      if ($is_ju_Formattable(arg)) {
        var formattableFlags = (((((1 & flags) !== 0) | 0) | (((2 & flags) !== 0) ? 4 : 0)) | (((256 & flags) !== 0) ? 2 : 0));
        arg.bda($thiz, formattableFlags, width, precision);
      } else {
        if (((2 & flags) !== 0)) {
          $thiz.a3X(conversionLower, flags, 2);
        }
        $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, localeInfo, flags, width, precision, ("" + arg));
      }
      break;
    }
    case 99: {
      if ((arg instanceof $Char)) {
        var $x_2 = ("" + $cToS($uC(arg)));
      } else {
        if ((!$isInt(arg))) {
          $thiz.Xm(conversionLower, arg);
        }
        var x3 = (arg | 0);
        if (((x3 >>> 0) > 1114111)) {
          $p_ju_Formatter__throwIllegalFormatCodePointException__I__E($thiz, x3);
        }
        var $x_2 = $m_jl_Character$().Q4(x3);
      }
      $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, localeInfo, flags, width, (-1), $x_2);
      break;
    }
    case 100: {
      if ($isInt(arg)) {
        var $x_3 = ("" + (arg | 0));
      } else if ((arg instanceof $Long)) {
        var $x_4 = $uJ(arg);
        var x3$2_$_lo = $x_4.l;
        var x3$2_$_hi = $x_4.h;
        var $x_3 = $m_RTLong$().kY(x3$2_$_lo, x3$2_$_hi);
      } else {
        if ((!(arg instanceof $c_Ljava_math_BigInteger))) {
          $thiz.Xm(conversionLower, arg);
        }
        var $x_3 = $m_Ljava_math_Conversion$().yn(arg);
      }
      $p_ju_Formatter__formatNumericString__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, localeInfo, flags, width, $x_3, "");
      break;
    }
    case 111:
    case 120: {
      var isOctal = (conversionLower === 111);
      var prefix = (((2 & flags) === 0) ? "" : (isOctal ? "0" : (((256 & flags) !== 0) ? "0X" : "0x")));
      if ((arg instanceof $c_Ljava_math_BigInteger)) {
        $p_ju_Formatter__formatNumericString__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, $m_ju_Formatter$RootLocaleInfo$(), flags, width, $m_Ljava_math_Conversion$().aXX(arg, (isOctal ? 8 : 16)), prefix);
      } else {
        if ($isInt(arg)) {
          var x2$5 = (arg | 0);
          var str$6 = (isOctal ? (x2$5 >>> 0.0).toString(8) : (x2$5 >>> 0.0).toString(16));
        } else {
          if ((!(arg instanceof $Long))) {
            $thiz.Xm(conversionLower, arg);
          }
          var $x_5 = $uJ(arg);
          var x3$3_$_lo = $x_5.l;
          var x3$3_$_hi = $x_5.h;
          var str$6 = (isOctal ? $m_jl_Long$().b3E(x3$3_$_lo, x3$3_$_hi) : $m_jl_Long$().aPw(x3$3_$_lo, x3$3_$_hi));
        }
        if (((76 & flags) !== 0)) {
          $thiz.a3X(conversionLower, flags, 76);
        }
        $p_ju_Formatter__padAndSendToDest__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, $m_ju_Formatter$RootLocaleInfo$(), flags, width, prefix, $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, str$6));
      }
      break;
    }
    case 101:
    case 102:
    case 103: {
      if (((typeof arg) === "number")) {
        var x2$6 = (+arg);
        if (((x2$6 !== x2$6) || ((x2$6 === Infinity) || (x2$6 === (-Infinity))))) {
          $p_ju_Formatter__formatNaNOrInfinite__I__I__D__V($thiz, flags, width, x2$6);
        } else {
          $p_ju_Formatter__formatDecimal$1__ju_Formatter$Decimal__I__I__C__ju_Formatter$LocaleInfo__I__V($thiz, $m_ju_Formatter$().b3M(x2$6), flags, precision, conversionLower, localeInfo, width);
        }
      } else if ((arg instanceof $c_Ljava_math_BigDecimal)) {
        $p_ju_Formatter__formatDecimal$1__ju_Formatter$Decimal__I__I__C__ju_Formatter$LocaleInfo__I__V($thiz, $m_ju_Formatter$().b3L(arg), flags, precision, conversionLower, localeInfo, width);
      } else {
        $thiz.Xm(conversionLower, arg);
      }
      break;
    }
    case 97: {
      if (((typeof arg) === "number")) {
        $p_ju_Formatter__formatHexFloatingPoint__I__I__I__D__V($thiz, flags, width, precision, (+arg));
      } else {
        $thiz.Xm(conversionLower, arg);
      }
      break;
    }
    default: {
      throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), (("Unknown conversion '" + $cToS(conversionLower)) + "' was not rejected earlier"));
    }
  }
}
function $p_ju_Formatter__flagsToString__I__T($thiz, flags) {
  return ((((((((((1 & flags) !== 0) ? "-" : "") + (((2 & flags) !== 0) ? "#" : "")) + (((4 & flags) !== 0) ? "+" : "")) + (((8 & flags) !== 0) ? " " : "")) + (((16 & flags) !== 0) ? "0" : "")) + (((32 & flags) !== 0) ? "," : "")) + (((64 & flags) !== 0) ? "(" : "")) + (((128 & flags) !== 0) ? "<" : ""));
}
function $p_ju_Formatter__computerizedScientificNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, digitsAfterDot, forceDecimalSep) {
  var rounded = x.aRN(((1 + digitsAfterDot) | 0));
  var signStr = (rounded.yG ? "-" : "");
  var intStr = rounded.yH;
  var fractionalDigitCount = ((intStr.length - 1) | 0);
  var missingZeros = ((digitsAfterDot - fractionalDigitCount) | 0);
  var integerPart = intStr.substring(0, 1);
  var fractionalPart = (("" + intStr.substring(1)) + $m_ju_Formatter$().agI(missingZeros));
  var significandStr = (((fractionalPart === "") && (!forceDecimalSep)) ? integerPart : ((integerPart + ".") + fractionalPart));
  var exponent = ((fractionalDigitCount - rounded.wu) | 0);
  var exponentSign = ((exponent < 0) ? "-" : "+");
  var sign = (exponent >> 31);
  var this$5 = (((exponent ^ sign) - sign) | 0);
  var exponentAbsStr0 = ("" + this$5);
  var exponentAbsStr = ((exponentAbsStr0.length === 1) ? ("0" + exponentAbsStr0) : exponentAbsStr0);
  return ((((signStr + significandStr) + "e") + exponentSign) + exponentAbsStr);
}
function $p_ju_Formatter__decimalNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, scale, forceDecimalSep) {
  var rounded = x.b8K(scale);
  var signStr = (rounded.yG ? "-" : "");
  var intStr = rounded.yH;
  var intStrLen = intStr.length;
  var minDigits = ((1 + scale) | 0);
  var expandedIntStr = ((intStrLen >= minDigits) ? intStr : (("" + $m_ju_Formatter$().agI(((minDigits - intStrLen) | 0))) + intStr));
  var dotPos = ((expandedIntStr.length - scale) | 0);
  var integerPart = (signStr + expandedIntStr.substring(0, dotPos));
  return (((scale === 0) && (!forceDecimalSep)) ? integerPart : ((integerPart + ".") + expandedIntStr.substring(dotPos)));
}
function $p_ju_Formatter__generalScientificNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, precision, forceDecimalSep) {
  var p = ((precision === 0) ? 1 : precision);
  var rounded = x.aRN(p);
  var orderOfMagnitude = ((((rounded.yH.length - 1) | 0) - rounded.wu) | 0);
  if (((orderOfMagnitude >= (-4)) && (orderOfMagnitude < p))) {
    var b = ((((p - orderOfMagnitude) | 0) - 1) | 0);
    return $p_ju_Formatter__decimalNotation__ju_Formatter$Decimal__I__Z__T($thiz, rounded, ((b < 0) ? 0 : b), forceDecimalSep);
  } else {
    return $p_ju_Formatter__computerizedScientificNotation__ju_Formatter$Decimal__I__Z__T($thiz, rounded, ((p - 1) | 0), forceDecimalSep);
  }
}
function $p_ju_Formatter__formatHexFloatingPoint__I__I__I__D__V($thiz, flags, width, precision, arg) {
  if (((arg !== arg) || ((arg === Infinity) || (arg === (-Infinity))))) {
    $p_ju_Formatter__formatNaNOrInfinite__I__I__D__V($thiz, flags, width, arg);
  } else {
    var fpBitsDataView = $fpBitsDataView;
    fpBitsDataView.setFloat64(0, arg, true);
    var lo = (fpBitsDataView.getInt32(0, true) | 0);
    var hi = (fpBitsDataView.getInt32(4, true) | 0);
    var negative = (hi < 0);
    var hi$1 = (1048575 & hi);
    var biasedExponent = (2047 & ((hi >>> 20) | 0));
    var actualPrecision = ((precision === 0) ? 1 : ((precision > 12) ? (-1) : precision));
    var signStr = (negative ? "-" : (((4 & flags) !== 0) ? "+" : (((8 & flags) !== 0) ? " " : "")));
    if ((biasedExponent === 0)) {
      if (((lo | hi$1) === 0)) {
        var x1___1 = "0";
        var x1___2 = $bL(0, 0);
        var x1___3 = 0;
      } else if ((actualPrecision === (-1))) {
        var x1___1 = "0";
        var x1___2 = $bL(lo, hi$1);
        var x1___3 = (-1022);
      } else {
        var leadingZeros = ((hi$1 !== 0) ? Math.clz32(hi$1) : ((32 + Math.clz32(lo)) | 0));
        var shift = ((leadingZeros - 11) | 0);
        var lo$2 = (((32 & shift) === 0) ? (lo << shift) : 0);
        var hi$2 = (((32 & shift) === 0) ? (((((lo >>> 1) | 0) >>> (~shift)) | 0) | (hi$1 << shift)) : (lo << shift));
        var hi$3 = (1048575 & hi$2);
        var normalizedExponent = (((-1022) - shift) | 0);
        var x1___1 = "1";
        var x1___2 = $bL(lo$2, hi$3);
        var x1___3 = normalizedExponent;
      }
    } else {
      var _3 = ((biasedExponent - 1023) | 0);
      var x1___1 = "1";
      var x1___2 = $bL(lo, hi$1);
      var x1___3 = _3;
    }
    var implicitBitStr = x1___1;
    var $x_1 = $uJ(x1___2);
    var mantissa_$_lo = $x_1.l;
    var mantissa_$_hi = $x_1.h;
    var exponent = (x1___3 | 0);
    if ((actualPrecision === (-1))) {
      var roundedMantissa_$_lo = mantissa_$_lo;
      var roundedMantissa_$_hi = mantissa_$_hi;
    } else {
      var n = ((52 - (actualPrecision << 2)) | 0);
      var lo$3 = (((32 & n) === 0) ? (1 << n) : 0);
      var hi$4 = (((32 & n) === 0) ? 0 : (1 << n));
      var lo$4 = ((lo$3 - 1) | 0);
      var hi$5 = ((((hi$4 - 1) | 0) + ((lo$4 !== (-1)) | 0)) | 0);
      var lo$5 = (((lo$3 >>> 1) | 0) | (hi$4 << 31));
      var hi$6 = (hi$4 >> 1);
      var lo$6 = (~lo$4);
      var hi$7 = (~hi$5);
      var lo$7 = (mantissa_$_lo & lo$6);
      var hi$8 = (mantissa_$_hi & hi$7);
      var lo$8 = (mantissa_$_lo & lo$4);
      var hi$9 = (mantissa_$_hi & hi$5);
      if (((hi$9 === hi$6) ? ((lo$8 >>> 0) < (lo$5 >>> 0)) : (hi$9 < hi$6))) {
        var roundedMantissa_$_lo = lo$7;
        var roundedMantissa_$_hi = hi$8;
      } else if (((hi$9 === hi$6) ? ((lo$8 >>> 0) > (lo$5 >>> 0)) : (hi$9 > hi$6))) {
        var lo$9 = ((lo$7 + lo$3) | 0);
        var hi$10 = ((((hi$8 + hi$4) | 0) + (((lo$9 >>> 0) < (lo$7 >>> 0)) | 0)) | 0);
        var roundedMantissa_$_lo = lo$9;
        var roundedMantissa_$_hi = hi$10;
      } else if ((((lo$7 & lo$3) | (hi$8 & hi$4)) === 0)) {
        var roundedMantissa_$_lo = lo$7;
        var roundedMantissa_$_hi = hi$8;
      } else {
        var lo$11 = ((lo$7 + lo$3) | 0);
        var hi$12 = ((((hi$8 + hi$4) | 0) + (((lo$11 >>> 0) < (lo$7 >>> 0)) | 0)) | 0);
        var roundedMantissa_$_lo = lo$11;
        var roundedMantissa_$_hi = hi$12;
      }
    }
    var baseStr = $m_jl_Long$().aPw(roundedMantissa_$_lo, roundedMantissa_$_hi);
    var beginIndex = baseStr.length;
    var padded = (("" + "0000000000000".substring(beginIndex)) + baseStr);
    $m_ju_Formatter$();
    if ((!(padded.length === 13))) {
      throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "padded mantissa does not have the right number of bits");
    }
    var minLength = ((actualPrecision < 1) ? 1 : actualPrecision);
    var len = padded.length;
    while (((len > minLength) && (padded.charCodeAt(((len - 1) | 0)) === 48))) {
      len = ((len - 1) | 0);
    }
    var endIndex = len;
    var mantissaStr = padded.substring(0, endIndex);
    var exponentStr = ("" + exponent);
    $p_ju_Formatter__padAndSendToDest__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, $m_ju_Formatter$RootLocaleInfo$(), flags, width, (signStr + (((256 & flags) !== 0) ? "0X" : "0x")), $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, ((((implicitBitStr + ".") + mantissaStr) + "p") + exponentStr)));
  }
}
function $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, localeInfo, flags, width, precision, str) {
  $p_ju_Formatter__padAndSendToDestNoZeroPad__I__I__T__V($thiz, flags, width, $p_ju_Formatter__applyUpperCase__ju_Formatter$LocaleInfo__I__T__T($thiz, localeInfo, flags, (((precision >>> 0) >= (str.length >>> 0)) ? str : str.substring(0, precision))));
}
function $p_ju_Formatter__formatNaNOrInfinite__I__I__D__V($thiz, flags, width, x) {
  $p_ju_Formatter__padAndSendToDestNoZeroPad__I__I__T__V($thiz, flags, width, $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, ((x !== x) ? "NaN" : ((x > 0.0) ? (((4 & flags) !== 0) ? "+Infinity" : (((8 & flags) !== 0) ? " Infinity" : "Infinity")) : (((64 & flags) !== 0) ? "(Infinity)" : "-Infinity")))));
}
function $p_ju_Formatter__formatNumericString__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, localeInfo, flags, width, str, basePrefix) {
  if (((str.length >= width) && ((110 & flags) === 0))) {
    $p_ju_Formatter__sendToDest__T__V($thiz, $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, str));
  } else if (((126 & flags) === 0)) {
    $p_ju_Formatter__padAndSendToDestNoZeroPad__I__I__T__V($thiz, flags, width, $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, str));
  } else {
    if ((str.charCodeAt(0) !== 45)) {
      if (((4 & flags) !== 0)) {
        var x1___1 = "+";
        var x1___2 = str;
      } else if (((8 & flags) !== 0)) {
        var x1___1 = " ";
        var x1___2 = str;
      } else {
        var x1___1 = "";
        var x1___2 = str;
      }
    } else if (((64 & flags) !== 0)) {
      var x1___1 = "(";
      var x1___2 = (str.substring(1) + ")");
    } else {
      var x1___1 = "-";
      var x1___2 = str.substring(1);
    }
    var numberPrefix = x1___1;
    var rest0 = x1___2;
    $p_ju_Formatter__padAndSendToDest__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, localeInfo, flags, width, (("" + numberPrefix) + basePrefix), $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, (((32 & flags) !== 0) ? $p_ju_Formatter__insertGroupingCommas__ju_Formatter$LocaleInfo__T__T($thiz, localeInfo, rest0) : rest0)));
  }
}
function $p_ju_Formatter__insertGroupingCommas__ju_Formatter$LocaleInfo__T__T($thiz, localeInfo, s) {
  var len = s.length;
  var index = 0;
  while (((index !== len) && ((((s.charCodeAt(index) - 48) | 0) >>> 0) <= 9))) {
    index = ((1 + index) | 0);
  }
  index = ((index - 3) | 0);
  if ((index <= 0)) {
    return s;
  } else {
    var beginIndex = index;
    var result = s.substring(beginIndex);
    while ((index > 3)) {
      var next = ((index - 3) | 0);
      var endIndex = index;
      result = ((s.substring(next, endIndex) + ",") + result);
      index = next;
    }
    var endIndex$1 = index;
    return ((s.substring(0, endIndex$1) + ",") + result);
  }
}
function $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, str) {
  return (((256 & flags) !== 0) ? str.toUpperCase() : str);
}
function $p_ju_Formatter__applyUpperCase__ju_Formatter$LocaleInfo__I__T__T($thiz, localeInfo, flags, str) {
  return (((256 & flags) !== 0) ? str.toUpperCase() : str);
}
function $p_ju_Formatter__padAndSendToDestNoZeroPad__I__I__T__V($thiz, flags, width, str) {
  var len = str.length;
  if ((len >= width)) {
    $p_ju_Formatter__sendToDest__T__V($thiz, str);
  } else if (((1 & flags) !== 0)) {
    $p_ju_Formatter__sendToDest__T__T__V($thiz, str, $p_ju_Formatter__strRepeat__T__I__T($thiz, " ", ((width - len) | 0)));
  } else {
    $p_ju_Formatter__sendToDest__T__T__V($thiz, $p_ju_Formatter__strRepeat__T__I__T($thiz, " ", ((width - len) | 0)), str);
  }
}
function $p_ju_Formatter__padAndSendToDest__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, localeInfo, flags, width, prefix, str) {
  var len = ((prefix.length + str.length) | 0);
  if ((len >= width)) {
    $p_ju_Formatter__sendToDest__T__T__V($thiz, prefix, str);
  } else if (((16 & flags) !== 0)) {
    $p_ju_Formatter__sendToDest__T__T__T__V($thiz, prefix, $p_ju_Formatter__strRepeat__T__I__T($thiz, "0", ((width - len) | 0)), str);
  } else if (((1 & flags) !== 0)) {
    $p_ju_Formatter__sendToDest__T__T__T__V($thiz, prefix, str, $p_ju_Formatter__strRepeat__T__I__T($thiz, " ", ((width - len) | 0)));
  } else {
    $p_ju_Formatter__sendToDest__T__T__T__V($thiz, $p_ju_Formatter__strRepeat__T__I__T($thiz, " ", ((width - len) | 0)), prefix, str);
  }
}
function $p_ju_Formatter__strRepeat__T__I__T($thiz, s, times) {
  var result = "";
  var i = 0;
  while ((i !== times)) {
    result = (("" + result) + s);
    i = ((1 + i) | 0);
  }
  return result;
}
function $p_ju_Formatter__throwDuplicateFormatFlagsException__C__E($thiz, flag) {
  throw new $c_ju_DuplicateFormatFlagsException(("" + $cToS(flag)));
}
function $p_ju_Formatter__throwUnknownFormatConversionException__C__E($thiz, conversion) {
  throw new $c_ju_UnknownFormatConversionException(("" + $cToS(conversion)));
}
function $p_ju_Formatter__throwIllegalFormatPrecisionException__I__E($thiz, precision) {
  throw new $c_ju_IllegalFormatPrecisionException(precision);
}
function $p_ju_Formatter__throwIllegalFormatWidthException__I__E($thiz, width) {
  throw new $c_ju_IllegalFormatWidthException(width);
}
function $p_ju_Formatter__throwIllegalFormatArgumentIndexException__I__E($thiz, index) {
  throw new $c_ju_IllegalFormatArgumentIndexException(((index === 0) ? "Illegal format argument index = 0" : "Format argument index: (not representable as int)"));
}
function $p_ju_Formatter__throwMissingFormatWidthException__T__E($thiz, fullFormatSpecifier) {
  throw new $c_ju_MissingFormatWidthException(fullFormatSpecifier);
}
function $p_ju_Formatter__throwMissingFormatArgumentException__T__E($thiz, fullFormatSpecifier) {
  throw new $c_ju_MissingFormatArgumentException(fullFormatSpecifier);
}
function $p_ju_Formatter__throwIllegalFormatCodePointException__I__E($thiz, arg) {
  throw new $c_ju_IllegalFormatCodePointException(arg);
}
function $ps_ju_Formatter__fullFormatSpecifier$1__O__T(execResult$1) {
  return ("%" + execResult$1[0]);
}
function $p_ju_Formatter__formatDecimal$1__ju_Formatter$Decimal__I__I__C__ju_Formatter$LocaleInfo__I__V($thiz, x, flags$1, precision$1, conversionLower$1, localeInfo$1, width$1) {
  var forceDecimalSep = ((2 & flags$1) !== 0);
  var actualPrecision = ((precision$1 >= 0) ? precision$1 : 6);
  switch (conversionLower$1) {
    case 101: {
      var $x_1 = $p_ju_Formatter__computerizedScientificNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, actualPrecision, forceDecimalSep);
      break;
    }
    case 102: {
      var $x_1 = $p_ju_Formatter__decimalNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, actualPrecision, forceDecimalSep);
      break;
    }
    default: {
      var $x_1 = $p_ju_Formatter__generalScientificNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, actualPrecision, forceDecimalSep);
    }
  }
  $p_ju_Formatter__formatNumericString__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, localeInfo$1, flags$1, width$1, $x_1, "");
}
function $ct_ju_Formatter__jl_Appendable__ju_Formatter$LocaleInfo__($thiz, dest, formatterLocaleInfo) {
  $thiz.ES = dest;
  $thiz.atl = formatterLocaleInfo;
  $thiz.B8 = "";
  $thiz.a7r = false;
  return $thiz;
}
function $ct_ju_Formatter__($thiz) {
  $ct_ju_Formatter__jl_Appendable__ju_Formatter$LocaleInfo__($thiz, null, $m_ju_Formatter$RootLocaleInfo$());
  return $thiz;
}
/** @constructor */
function $c_ju_Formatter() {
  this.ES = null;
  this.atl = null;
  this.B8 = null;
  this.a7r = false;
}
$p = $c_ju_Formatter.prototype = new $h_O();
$p.constructor = $c_ju_Formatter;
/** @constructor */
function $h_ju_Formatter() {
}
$h_ju_Formatter.prototype = $p;
$p.b1C = (function(format, args) {
  return $p_ju_Formatter__format__ju_Formatter$LocaleInfo__T__AO__ju_Formatter(this, this.atl, format, args);
});
$p.m = (function() {
  if (this.a7r) {
    throw new $c_ju_FormatterClosedException();
  }
  return ((this.ES === null) ? this.B8 : this.ES.m());
});
$p.agJ = (function(flags) {
  throw new $c_ju_IllegalFormatFlagsException($p_ju_Formatter__flagsToString__I__T(this, flags));
});
$p.a3X = (function(conversionLower, flags, illegalFlags) {
  throw new $c_ju_FormatFlagsConversionMismatchException($p_ju_Formatter__flagsToString__I__T(this, (flags & illegalFlags)), conversionLower);
});
$p.Xm = (function(conversionLower, arg) {
  throw new $c_ju_IllegalFormatConversionException(conversionLower, $objectGetClass(arg));
});
var $d_ju_Formatter = new $TypeData().i($c_ju_Formatter, "java.util.Formatter", ({
  ta: 1,
  ci: 1,
  ck: 1,
  cj: 1
}));
class $c_ju_concurrent_ExecutionException extends $c_jl_Exception {
  constructor(message, cause) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, message, cause, true, true);
  }
}
var $d_ju_concurrent_ExecutionException = new $TypeData().i($c_ju_concurrent_ExecutionException, "java.util.concurrent.ExecutionException", ({
  ty: 1,
  G: 1,
  y: 1,
  a: 1
}));
/** @constructor */
function $c_ju_concurrent_TimeUnit() {
  this.up = null;
  this.k6 = 0;
}
$p = $c_ju_concurrent_TimeUnit.prototype = new $h_jl_Enum();
$p.constructor = $c_ju_concurrent_TimeUnit;
/** @constructor */
function $h_ju_concurrent_TimeUnit() {
}
$h_ju_concurrent_TimeUnit.prototype = $p;
/** @constructor */
function $c_ju_internal_GenericArrayOps$ByteArrayOps$() {
}
$p = $c_ju_internal_GenericArrayOps$ByteArrayOps$.prototype = new $h_O();
$p.constructor = $c_ju_internal_GenericArrayOps$ByteArrayOps$;
/** @constructor */
function $h_ju_internal_GenericArrayOps$ByteArrayOps$() {
}
$h_ju_internal_GenericArrayOps$ByteArrayOps$.prototype = $p;
$p.dA = (function(o1, o2) {
  return (((o1 | 0) - (o2 | 0)) | 0);
});
$p.wf = (function(a, i, v) {
  var v$1 = (v | 0);
  a.a[i] = v$1;
});
$p.nA = (function(a, i) {
  return a.a[i];
});
var $d_ju_internal_GenericArrayOps$ByteArrayOps$ = new $TypeData().i($c_ju_internal_GenericArrayOps$ByteArrayOps$, "java.util.internal.GenericArrayOps$ByteArrayOps$", ({
  tI: 1,
  bB: 1,
  bQ: 1,
  ad: 1
}));
var $n_ju_internal_GenericArrayOps$ByteArrayOps$;
function $m_ju_internal_GenericArrayOps$ByteArrayOps$() {
  if ((!$n_ju_internal_GenericArrayOps$ByteArrayOps$)) {
    $n_ju_internal_GenericArrayOps$ByteArrayOps$ = new $c_ju_internal_GenericArrayOps$ByteArrayOps$();
  }
  return $n_ju_internal_GenericArrayOps$ByteArrayOps$;
}
/** @constructor */
function $c_ju_internal_GenericArrayOps$CharArrayOps$() {
}
$p = $c_ju_internal_GenericArrayOps$CharArrayOps$.prototype = new $h_O();
$p.constructor = $c_ju_internal_GenericArrayOps$CharArrayOps$;
/** @constructor */
function $h_ju_internal_GenericArrayOps$CharArrayOps$() {
}
$h_ju_internal_GenericArrayOps$CharArrayOps$.prototype = $p;
$p.dA = (function(o1, o2) {
  return (($uC(o1) - $uC(o2)) | 0);
});
$p.wf = (function(a, i, v) {
  var v$1 = $uC(v);
  a.a[i] = v$1;
});
$p.nA = (function(a, i) {
  return $bC(a.a[i]);
});
var $d_ju_internal_GenericArrayOps$CharArrayOps$ = new $TypeData().i($c_ju_internal_GenericArrayOps$CharArrayOps$, "java.util.internal.GenericArrayOps$CharArrayOps$", ({
  tJ: 1,
  bB: 1,
  bQ: 1,
  ad: 1
}));
var $n_ju_internal_GenericArrayOps$CharArrayOps$;
function $m_ju_internal_GenericArrayOps$CharArrayOps$() {
  if ((!$n_ju_internal_GenericArrayOps$CharArrayOps$)) {
    $n_ju_internal_GenericArrayOps$CharArrayOps$ = new $c_ju_internal_GenericArrayOps$CharArrayOps$();
  }
  return $n_ju_internal_GenericArrayOps$CharArrayOps$;
}
/** @constructor */
function $c_ju_internal_GenericArrayOps$IntArrayOps$() {
}
$p = $c_ju_internal_GenericArrayOps$IntArrayOps$.prototype = new $h_O();
$p.constructor = $c_ju_internal_GenericArrayOps$IntArrayOps$;
/** @constructor */
function $h_ju_internal_GenericArrayOps$IntArrayOps$() {
}
$h_ju_internal_GenericArrayOps$IntArrayOps$.prototype = $p;
$p.dA = (function(o1, o2) {
  var x = (o1 | 0);
  var y = (o2 | 0);
  return ((x === y) ? 0 : ((x < y) ? (-1) : 1));
});
$p.wf = (function(a, i, v) {
  var v$1 = (v | 0);
  a.a[i] = v$1;
});
$p.nA = (function(a, i) {
  return a.a[i];
});
var $d_ju_internal_GenericArrayOps$IntArrayOps$ = new $TypeData().i($c_ju_internal_GenericArrayOps$IntArrayOps$, "java.util.internal.GenericArrayOps$IntArrayOps$", ({
  tK: 1,
  bB: 1,
  bQ: 1,
  ad: 1
}));
var $n_ju_internal_GenericArrayOps$IntArrayOps$;
function $m_ju_internal_GenericArrayOps$IntArrayOps$() {
  if ((!$n_ju_internal_GenericArrayOps$IntArrayOps$)) {
    $n_ju_internal_GenericArrayOps$IntArrayOps$ = new $c_ju_internal_GenericArrayOps$IntArrayOps$();
  }
  return $n_ju_internal_GenericArrayOps$IntArrayOps$;
}
/** @constructor */
function $c_ju_internal_GenericArrayOps$LongArrayOps$() {
}
$p = $c_ju_internal_GenericArrayOps$LongArrayOps$.prototype = new $h_O();
$p.constructor = $c_ju_internal_GenericArrayOps$LongArrayOps$;
/** @constructor */
function $h_ju_internal_GenericArrayOps$LongArrayOps$() {
}
$h_ju_internal_GenericArrayOps$LongArrayOps$.prototype = $p;
$p.dA = (function(o1, o2) {
  var $x_1 = $uJ(o1);
  var x_$_lo = $x_1.l;
  var x_$_hi = $x_1.h;
  var $x_2 = $uJ(o2);
  var y_$_lo = $x_2.l;
  var y_$_hi = $x_2.h;
  return ((x_$_hi === y_$_hi) ? ((x_$_lo === y_$_lo) ? 0 : (((x_$_lo >>> 0) < (y_$_lo >>> 0)) ? (-1) : 1)) : ((x_$_hi < y_$_hi) ? (-1) : 1));
});
$p.wf = (function(a, i, v) {
  var $x_1 = $uJ(v);
  var v$1_$_lo = $x_1.l;
  var v$1_$_hi = $x_1.h;
  var $x_2 = a.a;
  var $x_3 = (i << 1);
  $x_2[$x_3] = v$1_$_lo;
  $x_2[(($x_3 + 1) | 0)] = v$1_$_hi;
});
$p.nA = (function(a, i) {
  var $x_1 = a.a;
  var $x_2 = (i << 1);
  return $bL($x_1[$x_2], $x_1[(($x_2 + 1) | 0)]);
});
var $d_ju_internal_GenericArrayOps$LongArrayOps$ = new $TypeData().i($c_ju_internal_GenericArrayOps$LongArrayOps$, "java.util.internal.GenericArrayOps$LongArrayOps$", ({
  tL: 1,
  bB: 1,
  bQ: 1,
  ad: 1
}));
var $n_ju_internal_GenericArrayOps$LongArrayOps$;
function $m_ju_internal_GenericArrayOps$LongArrayOps$() {
  if ((!$n_ju_internal_GenericArrayOps$LongArrayOps$)) {
    $n_ju_internal_GenericArrayOps$LongArrayOps$ = new $c_ju_internal_GenericArrayOps$LongArrayOps$();
  }
  return $n_ju_internal_GenericArrayOps$LongArrayOps$;
}
/** @constructor */
function $c_ju_internal_GenericArrayOps$ShortArrayOps$() {
}
$p = $c_ju_internal_GenericArrayOps$ShortArrayOps$.prototype = new $h_O();
$p.constructor = $c_ju_internal_GenericArrayOps$ShortArrayOps$;
/** @constructor */
function $h_ju_internal_GenericArrayOps$ShortArrayOps$() {
}
$h_ju_internal_GenericArrayOps$ShortArrayOps$.prototype = $p;
$p.dA = (function(o1, o2) {
  return (((o1 | 0) - (o2 | 0)) | 0);
});
$p.wf = (function(a, i, v) {
  var v$1 = (v | 0);
  a.a[i] = v$1;
});
$p.nA = (function(a, i) {
  return a.a[i];
});
var $d_ju_internal_GenericArrayOps$ShortArrayOps$ = new $TypeData().i($c_ju_internal_GenericArrayOps$ShortArrayOps$, "java.util.internal.GenericArrayOps$ShortArrayOps$", ({
  tN: 1,
  bB: 1,
  bQ: 1,
  ad: 1
}));
var $n_ju_internal_GenericArrayOps$ShortArrayOps$;
function $m_ju_internal_GenericArrayOps$ShortArrayOps$() {
  if ((!$n_ju_internal_GenericArrayOps$ShortArrayOps$)) {
    $n_ju_internal_GenericArrayOps$ShortArrayOps$ = new $c_ju_internal_GenericArrayOps$ShortArrayOps$();
  }
  return $n_ju_internal_GenericArrayOps$ShortArrayOps$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_Graphviz$MultipleRenderResult(status, output, errors) {
  this.Kh = null;
  this.Kg = null;
  this.Rc = null;
  this.Kh = status;
  this.Kg = output;
  this.Rc = errors;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_Graphviz$MultipleRenderResult.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_Graphviz$MultipleRenderResult;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_Graphviz$MultipleRenderResult() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_Graphviz$MultipleRenderResult.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-403634897), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_Graphviz$MultipleRenderResult)) {
    if ((this.Kh === x$0.Kh)) {
      var x = this.Kg;
      var x$2 = x$0.Kg;
      var $x_1 = ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.Rc;
      var x$4 = x$0.Rc;
      return ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 3;
});
$p.B = (function() {
  return "MultipleRenderResult";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.Kh;
      break;
    }
    case 1: {
      return this.Kg;
      break;
    }
    case 2: {
      return this.Rc;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "status";
      break;
    }
    case 1: {
      return "output";
      break;
    }
    case 2: {
      return "errors";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_Graphviz$MultipleRenderResult(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ff)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_Graphviz$MultipleRenderResult = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_Graphviz$MultipleRenderResult, "org.jpablo.graphexplorer.graphviz.Graphviz$MultipleRenderResult", ({
  ff: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_Graphviz$RenderError(level, message) {
  this.ZG = null;
  this.Rd = null;
  this.ZG = level;
  this.Rd = message;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_Graphviz$RenderError.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_Graphviz$RenderError;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_Graphviz$RenderError() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_Graphviz$RenderError.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-680056384), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_Graphviz$RenderError)) {
    var x = this.ZG;
    var x$2 = x$0.ZG;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      return (this.Rd === x$0.Rd);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "RenderError";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.ZG;
  }
  if ((n === 1)) {
    return this.Rd;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "level";
  }
  if ((n === 1)) {
    return "message";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_Graphviz$RenderError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fg)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_Graphviz$RenderError = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_Graphviz$RenderError, "org.jpablo.graphexplorer.graphviz.Graphviz$RenderError", ({
  fg: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Graph(strict, directed, id, stmts) {
  this.Km = false;
  this.Kk = false;
  this.EX = null;
  this.Kl = null;
  this.Km = strict;
  this.Kk = directed;
  this.EX = id;
  this.Kl = stmts;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Graph.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Graph;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_dotlang_Graph() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_dotlang_Graph.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 69062958);
  acc = $m_sr_Statics$().k(acc, (this.Km ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, (this.Kk ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.EX));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Kl));
  return $m_sr_Statics$().Z(acc, 4);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Graph)) {
    if (((this.Km === x$0.Km) && (this.Kk === x$0.Kk))) {
      var x = this.EX;
      var x$2 = x$0.EX;
      var $x_1 = ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.Kl;
      var x$4 = x$0.Kl;
      return ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 4;
});
$p.B = (function() {
  return "Graph";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.Km;
      break;
    }
    case 1: {
      return this.Kk;
      break;
    }
    case 2: {
      return this.EX;
      break;
    }
    case 3: {
      return this.Kl;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "strict";
      break;
    }
    case 1: {
      return "directed";
      break;
    }
    case 2: {
      return "id";
      break;
    }
    case 3: {
      return "stmts";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_dotlang_Graph(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fp)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_dotlang_Graph = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Graph, "org.jpablo.graphexplorer.graphviz.dotlang.Graph", ({
  fp: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Id(value, html) {
  this.fU = null;
  this.EY = false;
  this.fU = value;
  this.EY = html;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Id.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Id;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_dotlang_Id() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_dotlang_Id.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 2363);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.fU));
  acc = $m_sr_Statics$().k(acc, (this.EY ? 1231 : 1237));
  return $m_sr_Statics$().Z(acc, 2);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Id) && ((this.EY === x$0.EY) && (this.fU === x$0.fU))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "Id";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.fU;
  }
  if ((n === 1)) {
    return this.EY;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  if ((n === 1)) {
    return "html";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_dotlang_Id(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fq)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_dotlang_Id = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Id, "org.jpablo.graphexplorer.graphviz.dotlang.Id", ({
  fq: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_NodeId(id, port) {
  this.Ba = null;
  this.Rh = null;
  this.Ba = id;
  this.Rh = port;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_NodeId.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_NodeId;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_dotlang_NodeId() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_dotlang_NodeId.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 666538553, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_NodeId)) {
    var x = this.Ba;
    var x$2 = x$0.Ba;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      var x$3 = this.Rh;
      var x$4 = x$0.Rh;
      return ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "NodeId";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Ba;
  }
  if ((n === 1)) {
    return this.Rh;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "id";
  }
  if ((n === 1)) {
    return "port";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_dotlang_NodeId(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fr)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_dotlang_NodeId = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_dotlang_NodeId, "org.jpablo.graphexplorer.graphviz.dotlang.NodeId", ({
  fr: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Port(name, compass) {
  this.wx = null;
  this.ww = null;
  this.wx = name;
  this.ww = compass;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Port.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Port;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_dotlang_Port() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_dotlang_Port.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 2010473375, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Port)) {
    var x = this.wx;
    var x$2 = x$0.wx;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      var x$3 = this.ww;
      var x$4 = x$0.ww;
      return ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "Port";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.wx;
  }
  if ((n === 1)) {
    return this.ww;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "name";
  }
  if ((n === 1)) {
    return "compass";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_dotlang_Port(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fs)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_dotlang_Port = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Port, "org.jpablo.graphexplorer.graphviz.dotlang.Port", ({
  fs: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Subgraph(id, stmts) {
  this.Rr = null;
  this.Rs = null;
  this.Rr = id;
  this.Rs = stmts;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Subgraph.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Subgraph;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_dotlang_Subgraph() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_dotlang_Subgraph.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 62033666, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Subgraph)) {
    var x = this.Rr;
    var x$2 = x$0.Rr;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      var x$3 = this.Rs;
      var x$4 = x$0.Rs;
      return ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "Subgraph";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Rr;
  }
  if ((n === 1)) {
    return this.Rs;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "id";
  }
  if ((n === 1)) {
    return "stmts";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_dotlang_Subgraph(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fy)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_dotlang_Subgraph = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Subgraph, "org.jpablo.graphexplorer.graphviz.dotlang.Subgraph", ({
  fy: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlCell(content, attrs) {
  this.oL = null;
  this.gE = null;
  this.oL = content;
  this.gE = attrs;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlCell.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlCell;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlCell() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlCell.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 247139314, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlCell)) {
    var x = this.oL;
    var x$2 = x$0.oL;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      var x$3 = this.gE;
      var x$4 = x$0.gE;
      return ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "HtmlCell";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.oL;
  }
  if ((n === 1)) {
    return this.gE;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "content";
  }
  if ((n === 1)) {
    return "attrs";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_html_HtmlCell(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fz)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_html_HtmlCell = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlCell, "org.jpablo.graphexplorer.graphviz.html.HtmlCell", ({
  fz: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlFont(size, name, color, bold, italic, underline, strike, sub, sup) {
  this.kZ = null;
  this.n1 = null;
  this.oM = null;
  this.nP = false;
  this.nQ = false;
  this.oP = false;
  this.pN = false;
  this.oN = false;
  this.oO = false;
  this.kZ = size;
  this.n1 = name;
  this.oM = color;
  this.nP = bold;
  this.nQ = italic;
  this.oP = underline;
  this.pN = strike;
  this.oN = sub;
  this.oO = sup;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlFont.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlFont;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlFont() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlFont.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, (-272949574));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.kZ));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.n1));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.oM));
  acc = $m_sr_Statics$().k(acc, (this.nP ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, (this.nQ ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, (this.oP ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, (this.pN ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, (this.oN ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, (this.oO ? 1231 : 1237));
  return $m_sr_Statics$().Z(acc, 9);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlFont)) {
    if (((((((this.nP === x$0.nP) && (this.nQ === x$0.nQ)) && (this.oP === x$0.oP)) && (this.pN === x$0.pN)) && (this.oN === x$0.oN)) && (this.oO === x$0.oO))) {
      var x = this.kZ;
      var x$2 = x$0.kZ;
      var $x_2 = ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.n1;
      var x$4 = x$0.n1;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.oM;
      var x$6 = x$0.oM;
      return ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 9;
});
$p.B = (function() {
  return "HtmlFont";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.kZ;
      break;
    }
    case 1: {
      return this.n1;
      break;
    }
    case 2: {
      return this.oM;
      break;
    }
    case 3: {
      return this.nP;
      break;
    }
    case 4: {
      return this.nQ;
      break;
    }
    case 5: {
      return this.oP;
      break;
    }
    case 6: {
      return this.pN;
      break;
    }
    case 7: {
      return this.oN;
      break;
    }
    case 8: {
      return this.oO;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "size";
      break;
    }
    case 1: {
      return "name";
      break;
    }
    case 2: {
      return "color";
      break;
    }
    case 3: {
      return "bold";
      break;
    }
    case 4: {
      return "italic";
      break;
    }
    case 5: {
      return "underline";
      break;
    }
    case 6: {
      return "strike";
      break;
    }
    case 7: {
      return "sub";
      break;
    }
    case 8: {
      return "sup";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_html_HtmlFont(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fA)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_html_HtmlFont = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlFont, "org.jpablo.graphexplorer.graphviz.html.HtmlFont", ({
  fA: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlItem(str, font) {
  this.pO = null;
  this.hb = null;
  this.pO = str;
  this.hb = font;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlItem.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlItem;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlItem() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlItem.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-623570104), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlItem)) {
    if ((this.pO === x$0.pO)) {
      var x = this.hb;
      var x$2 = x$0.hb;
      return ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "HtmlItem";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.pO;
  }
  if ((n === 1)) {
    return this.hb;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "str";
  }
  if ((n === 1)) {
    return "font";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_html_HtmlItem(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fB)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_html_HtmlItem = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlItem, "org.jpablo.graphexplorer.graphviz.html.HtmlItem", ({
  fB: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$HtmlLine(width, lsize, lfsize) {
  this.F0 = 0.0;
  this.Rt = 0.0;
  this.Kn = 0.0;
  this.F0 = width;
  this.Rt = lsize;
  this.Kn = lfsize;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$HtmlLine.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$HtmlLine;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$HtmlLine() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$HtmlLine.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, (-272776609));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.F0));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.Rt));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.Kn));
  return $m_sr_Statics$().Z(acc, 3);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$HtmlLine) && (((this.F0 === x$0.F0) && (this.Rt === x$0.Rt)) && (this.Kn === x$0.Kn))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 3;
});
$p.B = (function() {
  return "HtmlLine";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.F0;
      break;
    }
    case 1: {
      return this.Rt;
      break;
    }
    case 2: {
      return this.Kn;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "width";
      break;
    }
    case 1: {
      return "lsize";
      break;
    }
    case 2: {
      return "lfsize";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$HtmlLine(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fF)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$HtmlLine = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$HtmlLine, "org.jpablo.graphexplorer.graphviz.html.HtmlLayout$HtmlLine", ({
  fF: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$HtmlTextLayout(width, height, simple, lines) {
  this.Kq = 0.0;
  this.F1 = 0.0;
  this.Kp = false;
  this.Ko = null;
  this.Kq = width;
  this.F1 = height;
  this.Kp = simple;
  this.Ko = lines;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$HtmlTextLayout.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$HtmlTextLayout;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$HtmlTextLayout() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$HtmlTextLayout.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, (-1994969886));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.Kq));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.F1));
  acc = $m_sr_Statics$().k(acc, (this.Kp ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Ko));
  return $m_sr_Statics$().Z(acc, 4);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$HtmlTextLayout)) {
    if ((((this.Kq === x$0.Kq) && (this.F1 === x$0.F1)) && (this.Kp === x$0.Kp))) {
      var x = this.Ko;
      var x$2 = x$0.Ko;
      return ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 4;
});
$p.B = (function() {
  return "HtmlTextLayout";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.Kq;
      break;
    }
    case 1: {
      return this.F1;
      break;
    }
    case 2: {
      return this.Kp;
      break;
    }
    case 3: {
      return this.Ko;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "width";
      break;
    }
    case 1: {
      return "height";
      break;
    }
    case 2: {
      return "simple";
      break;
    }
    case 3: {
      return "lines";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$HtmlTextLayout(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fG)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$HtmlTextLayout = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLayout$HtmlTextLayout, "org.jpablo.graphexplorer.graphviz.html.HtmlLayout$HtmlTextLayout", ({
  fG: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlSpan(items, align) {
  this.lz = null;
  this.yM = null;
  this.lz = items;
  this.yM = align;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlSpan.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlSpan;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlSpan() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlSpan.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-334437489), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlSpan)) {
    var x = this.lz;
    var x$2 = x$0.lz;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      var x$3 = this.yM;
      var x$4 = x$0.yM;
      return ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "HtmlSpan";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.lz;
  }
  if ((n === 1)) {
    return this.yM;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "items";
  }
  if ((n === 1)) {
    return "align";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_html_HtmlSpan(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fK)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_html_HtmlSpan = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlSpan, "org.jpablo.graphexplorer.graphviz.html.HtmlSpan", ({
  fK: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTable(rows, border, cellborder, cellspacing, cellpadding, align, attrs, hrAfter, vrAfter) {
  this.fg = null;
  this.F3 = 0;
  this.F4 = null;
  this.Bb = 0;
  this.F5 = 0;
  this.Ru = null;
  this.nR = null;
  this.oR = null;
  this.oS = null;
  this.fg = rows;
  this.F3 = border;
  this.F4 = cellborder;
  this.Bb = cellspacing;
  this.F5 = cellpadding;
  this.Ru = align;
  this.nR = attrs;
  this.oR = hrAfter;
  this.oS = vrAfter;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTable.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTable;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTable() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTable.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 140998339);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.fg));
  acc = $m_sr_Statics$().k(acc, this.F3);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.F4));
  acc = $m_sr_Statics$().k(acc, this.Bb);
  acc = $m_sr_Statics$().k(acc, this.F5);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Ru));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.nR));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.oR));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.oS));
  return $m_sr_Statics$().Z(acc, 9);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTable)) {
    if ((((this.F3 === x$0.F3) && (this.Bb === x$0.Bb)) && (this.F5 === x$0.F5))) {
      var x = this.fg;
      var x$2 = x$0.fg;
      var $x_5 = ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$3 = this.F4;
      var x$4 = x$0.F4;
      var $x_4 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$5 = this.Ru;
      var x$6 = x$0.Ru;
      var $x_3 = ((x$5 === null) ? (x$6 === null) : (x$5 === x$6));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$7 = this.nR;
      var x$8 = x$0.nR;
      var $x_2 = ((x$7 === null) ? (x$8 === null) : x$7.e(x$8));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$9 = this.oR;
      var x$10 = x$0.oR;
      var $x_1 = ((x$9 === null) ? (x$10 === null) : x$9.e(x$10));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$11 = this.oS;
      var x$12 = x$0.oS;
      return ((x$11 === null) ? (x$12 === null) : x$11.e(x$12));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 9;
});
$p.B = (function() {
  return "HtmlTable";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.fg;
      break;
    }
    case 1: {
      return this.F3;
      break;
    }
    case 2: {
      return this.F4;
      break;
    }
    case 3: {
      return this.Bb;
      break;
    }
    case 4: {
      return this.F5;
      break;
    }
    case 5: {
      return this.Ru;
      break;
    }
    case 6: {
      return this.nR;
      break;
    }
    case 7: {
      return this.oR;
      break;
    }
    case 8: {
      return this.oS;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "rows";
      break;
    }
    case 1: {
      return "border";
      break;
    }
    case 2: {
      return "cellborder";
      break;
    }
    case 3: {
      return "cellspacing";
      break;
    }
    case 4: {
      return "cellpadding";
      break;
    }
    case 5: {
      return "align";
      break;
    }
    case 6: {
      return "attrs";
      break;
    }
    case 7: {
      return "hrAfter";
      break;
    }
    case 8: {
      return "vrAfter";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fL)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTable = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTable, "org.jpablo.graphexplorer.graphviz.html.HtmlTable", ({
  fL: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$BoxLocal(llx, lly, urx, ury) {
  this.lA = 0.0;
  this.me = 0.0;
  this.lB = 0.0;
  this.mf = 0.0;
  this.lA = llx;
  this.me = lly;
  this.lB = urx;
  this.mf = ury;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$BoxLocal.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$BoxLocal;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$BoxLocal() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$BoxLocal.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, (-1995850624));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.lA));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.me));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.lB));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.mf));
  return $m_sr_Statics$().Z(acc, 4);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$BoxLocal) && ((((this.lA === x$0.lA) && (this.me === x$0.me)) && (this.lB === x$0.lB)) && (this.mf === x$0.mf))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 4;
});
$p.B = (function() {
  return "BoxLocal";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.lA;
      break;
    }
    case 1: {
      return this.me;
      break;
    }
    case 2: {
      return this.lB;
      break;
    }
    case 3: {
      return this.mf;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "llx";
      break;
    }
    case 1: {
      return "lly";
      break;
    }
    case 2: {
      return "urx";
      break;
    }
    case 3: {
      return "ury";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.aNj = (function() {
  return (0.5 * (this.lA + this.lB));
});
$p.aff = (function() {
  return (0.5 * (this.me + this.mf));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$BoxLocal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fM)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$BoxLocal = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$BoxLocal, "org.jpablo.graphexplorer.graphviz.html.HtmlTableLayout$BoxLocal", ({
  fM: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$Info$1(row, col, colspan, rowspan, cellW, cellH, cell) {
  this.oU = 0;
  this.oT = 0;
  this.pP = 0;
  this.pQ = 0;
  this.Bd = 0.0;
  this.Bc = 0.0;
  this.yN = null;
  this.oU = row;
  this.oT = col;
  this.pP = colspan;
  this.pQ = rowspan;
  this.Bd = cellW;
  this.Bc = cellH;
  this.yN = cell;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$Info$1.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$Info$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$Info$1() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$Info$1.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 2283726);
  acc = $m_sr_Statics$().k(acc, this.oU);
  acc = $m_sr_Statics$().k(acc, this.oT);
  acc = $m_sr_Statics$().k(acc, this.pP);
  acc = $m_sr_Statics$().k(acc, this.pQ);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.Bd));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.Bc));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.yN));
  return $m_sr_Statics$().Z(acc, 7);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$Info$1)) {
    if (((((((this.oU === x$0.oU) && (this.oT === x$0.oT)) && (this.pP === x$0.pP)) && (this.pQ === x$0.pQ)) && (this.Bd === x$0.Bd)) && (this.Bc === x$0.Bc))) {
      var x = this.yN;
      var x$2 = x$0.yN;
      return ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 7;
});
$p.B = (function() {
  return "Info";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.oU;
      break;
    }
    case 1: {
      return this.oT;
      break;
    }
    case 2: {
      return this.pP;
      break;
    }
    case 3: {
      return this.pQ;
      break;
    }
    case 4: {
      return this.Bd;
      break;
    }
    case 5: {
      return this.Bc;
      break;
    }
    case 6: {
      return this.yN;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "row";
      break;
    }
    case 1: {
      return "col";
      break;
    }
    case 2: {
      return "colspan";
      break;
    }
    case 3: {
      return "rowspan";
      break;
    }
    case 4: {
      return "cellW";
      break;
    }
    case 5: {
      return "cellH";
      break;
    }
    case 6: {
      return "cell";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$Info$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fN)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$Info$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$Info$1, "org.jpablo.graphexplorer.graphviz.html.HtmlTableLayout$Info$1", ({
  fN: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$Laid(width, height, border, cells, hrs, vrs, nrows, ncols) {
  this.wB = 0.0;
  this.wA = 0.0;
  this.F6 = 0;
  this.Be = null;
  this.Ks = null;
  this.Kv = null;
  this.Ku = 0;
  this.Kt = 0;
  this.wB = width;
  this.wA = height;
  this.F6 = border;
  this.Be = cells;
  this.Ks = hrs;
  this.Kv = vrs;
  this.Ku = nrows;
  this.Kt = ncols;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$Laid.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$Laid;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$Laid() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$Laid.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 2360688);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.wB));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.wA));
  acc = $m_sr_Statics$().k(acc, this.F6);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Be));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Ks));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Kv));
  acc = $m_sr_Statics$().k(acc, this.Ku);
  acc = $m_sr_Statics$().k(acc, this.Kt);
  return $m_sr_Statics$().Z(acc, 8);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$Laid)) {
    if ((((((this.wB === x$0.wB) && (this.wA === x$0.wA)) && (this.F6 === x$0.F6)) && (this.Ku === x$0.Ku)) && (this.Kt === x$0.Kt))) {
      var x = this.Be;
      var x$2 = x$0.Be;
      var $x_2 = ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Ks;
      var x$4 = x$0.Ks;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Kv;
      var x$6 = x$0.Kv;
      return ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 8;
});
$p.B = (function() {
  return "Laid";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.wB;
      break;
    }
    case 1: {
      return this.wA;
      break;
    }
    case 2: {
      return this.F6;
      break;
    }
    case 3: {
      return this.Be;
      break;
    }
    case 4: {
      return this.Ks;
      break;
    }
    case 5: {
      return this.Kv;
      break;
    }
    case 6: {
      return this.Ku;
      break;
    }
    case 7: {
      return this.Kt;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "width";
      break;
    }
    case 1: {
      return "height";
      break;
    }
    case 2: {
      return "border";
      break;
    }
    case 3: {
      return "cells";
      break;
    }
    case 4: {
      return "hrs";
      break;
    }
    case 5: {
      return "vrs";
      break;
    }
    case 6: {
      return "nrows";
      break;
    }
    case 7: {
      return "ncols";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$Laid(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fO)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$Laid = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$Laid, "org.jpablo.graphexplorer.graphviz.html.HtmlTableLayout$Laid", ({
  fO: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$PlacedCell(box, contentBox, cellBorder, cell, row, col, rowspan, colspan) {
  this.nS = null;
  this.hW = null;
  this.F7 = 0;
  this.oV = null;
  this.F9 = 0;
  this.F8 = 0;
  this.Kx = 0;
  this.Kw = 0;
  this.nS = box;
  this.hW = contentBox;
  this.F7 = cellBorder;
  this.oV = cell;
  this.F9 = row;
  this.F8 = col;
  this.Kx = rowspan;
  this.Kw = colspan;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$PlacedCell.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$PlacedCell;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$PlacedCell() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$PlacedCell.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 1730657119);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.nS));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.hW));
  acc = $m_sr_Statics$().k(acc, this.F7);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.oV));
  acc = $m_sr_Statics$().k(acc, this.F9);
  acc = $m_sr_Statics$().k(acc, this.F8);
  acc = $m_sr_Statics$().k(acc, this.Kx);
  acc = $m_sr_Statics$().k(acc, this.Kw);
  return $m_sr_Statics$().Z(acc, 8);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$PlacedCell)) {
    if ((((((this.F7 === x$0.F7) && (this.F9 === x$0.F9)) && (this.F8 === x$0.F8)) && (this.Kx === x$0.Kx)) && (this.Kw === x$0.Kw))) {
      var x = this.nS;
      var x$2 = x$0.nS;
      var $x_2 = ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.hW;
      var x$4 = x$0.hW;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.oV;
      var x$6 = x$0.oV;
      return ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 8;
});
$p.B = (function() {
  return "PlacedCell";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.nS;
      break;
    }
    case 1: {
      return this.hW;
      break;
    }
    case 2: {
      return this.F7;
      break;
    }
    case 3: {
      return this.oV;
      break;
    }
    case 4: {
      return this.F9;
      break;
    }
    case 5: {
      return this.F8;
      break;
    }
    case 6: {
      return this.Kx;
      break;
    }
    case 7: {
      return this.Kw;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "box";
      break;
    }
    case 1: {
      return "contentBox";
      break;
    }
    case 2: {
      return "cellBorder";
      break;
    }
    case 3: {
      return "cell";
      break;
    }
    case 4: {
      return "row";
      break;
    }
    case 5: {
      return "col";
      break;
    }
    case 6: {
      return "rowspan";
      break;
    }
    case 7: {
      return "colspan";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$PlacedCell(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fP)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$PlacedCell = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlTableLayout$PlacedCell, "org.jpablo.graphexplorer.graphviz.html.HtmlTableLayout$PlacedCell", ({
  fP: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlText(spans) {
  this.oW = null;
  this.oW = spans;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlText.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlText;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlText() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlText.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 689365392, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlText)) {
    var x = this.oW;
    var x$2 = x$0.oW;
    return ((x === null) ? (x$2 === null) : x.e(x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "HtmlText";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.oW;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "spans";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_html_HtmlText(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fQ)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_html_HtmlText = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlText, "org.jpablo.graphexplorer.graphviz.html.HtmlText", ({
  fQ: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$BB(llx, lly, urx, ury) {
  this.nW = 0.0;
  this.pR = 0.0;
  this.nX = 0.0;
  this.pS = 0.0;
  this.nW = llx;
  this.pR = lly;
  this.nX = urx;
  this.pS = ury;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$BB.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$BB;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$BB() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$BB.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 2112);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.nW));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.pR));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.nX));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.pS));
  return $m_sr_Statics$().Z(acc, 4);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$BB) && ((((this.nW === x$0.nW) && (this.pR === x$0.pR)) && (this.nX === x$0.nX)) && (this.pS === x$0.pS))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 4;
});
$p.B = (function() {
  return "BB";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.nW;
      break;
    }
    case 1: {
      return this.pR;
      break;
    }
    case 2: {
      return this.nX;
      break;
    }
    case 3: {
      return this.pS;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "llx";
      break;
    }
    case 1: {
      return "lly";
      break;
    }
    case 2: {
      return "urx";
      break;
    }
    case 3: {
      return "ury";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$BB(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fV)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$BB = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$BB, "org.jpablo.graphexplorer.graphviz.layout.Cluster$BB", ({
  fV: 1,
  b: 1,
  c: 1,
  a: 1
}));
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$CInfo__padX__D($thiz) {
  return ($thiz.Fe + (4.0 * $m_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$().a7R));
}
function $p_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$CInfo__padY__D($thiz) {
  return ($thiz.Fd + (2.0 * $m_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$().a7R));
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$CInfo(name, label, parent, nodeIds, members, minRank, maxRank, lwidthPt, lheightPt, labelTop, labelJust, fontSize, fontName, fontColor) {
  this.yO = null;
  this.Fb = null;
  this.yP = 0;
  this.Bg = null;
  this.n3 = null;
  this.jC = 0;
  this.l0 = 0;
  this.Fe = 0.0;
  this.Fd = 0.0;
  this.mg = false;
  this.Fc = 0;
  this.KH = 0.0;
  this.KG = null;
  this.KF = null;
  this.yO = name;
  this.Fb = label;
  this.yP = parent;
  this.Bg = nodeIds;
  this.n3 = members;
  this.jC = minRank;
  this.l0 = maxRank;
  this.Fe = lwidthPt;
  this.Fd = lheightPt;
  this.mg = labelTop;
  this.Fc = labelJust;
  this.KH = fontSize;
  this.KG = fontName;
  this.KF = fontColor;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$CInfo.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$CInfo;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$CInfo() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$CInfo.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 64159633);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.yO));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Fb));
  acc = $m_sr_Statics$().k(acc, this.yP);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Bg));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.n3));
  acc = $m_sr_Statics$().k(acc, this.jC);
  acc = $m_sr_Statics$().k(acc, this.l0);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.Fe));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.Fd));
  acc = $m_sr_Statics$().k(acc, (this.mg ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, this.Fc);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.KH));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.KG));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.KF));
  return $m_sr_Statics$().Z(acc, 14);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$CInfo)) {
    if (((((((((((this.yP === x$0.yP) && (this.jC === x$0.jC)) && (this.l0 === x$0.l0)) && (this.Fe === x$0.Fe)) && (this.Fd === x$0.Fd)) && (this.mg === x$0.mg)) && (this.Fc === x$0.Fc)) && (this.KH === x$0.KH)) && (this.yO === x$0.yO)) && (this.Fb === x$0.Fb))) {
      var x = this.Bg;
      var x$2 = x$0.Bg;
      var $x_2 = ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.n3;
      var x$4 = x$0.n3;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_1 = false;
    }
    if (($x_1 && (this.KG === x$0.KG))) {
      return (this.KF === x$0.KF);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 14;
});
$p.B = (function() {
  return "CInfo";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.yO;
      break;
    }
    case 1: {
      return this.Fb;
      break;
    }
    case 2: {
      return this.yP;
      break;
    }
    case 3: {
      return this.Bg;
      break;
    }
    case 4: {
      return this.n3;
      break;
    }
    case 5: {
      return this.jC;
      break;
    }
    case 6: {
      return this.l0;
      break;
    }
    case 7: {
      return this.Fe;
      break;
    }
    case 8: {
      return this.Fd;
      break;
    }
    case 9: {
      return this.mg;
      break;
    }
    case 10: {
      return $bC(this.Fc);
      break;
    }
    case 11: {
      return this.KH;
      break;
    }
    case 12: {
      return this.KG;
      break;
    }
    case 13: {
      return this.KF;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "name";
      break;
    }
    case 1: {
      return "label";
      break;
    }
    case 2: {
      return "parent";
      break;
    }
    case 3: {
      return "nodeIds";
      break;
    }
    case 4: {
      return "members";
      break;
    }
    case 5: {
      return "minRank";
      break;
    }
    case 6: {
      return "maxRank";
      break;
    }
    case 7: {
      return "lwidthPt";
      break;
    }
    case 8: {
      return "lheightPt";
      break;
    }
    case 9: {
      return "labelTop";
      break;
    }
    case 10: {
      return "labelJust";
      break;
    }
    case 11: {
      return "fontSize";
      break;
    }
    case 12: {
      return "fontName";
      break;
    }
    case 13: {
      return "fontColor";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.pv = (function() {
  return (this.Fb !== "");
});
$p.aMA = (function() {
  return ((this.pv() && this.mg) ? $p_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$CInfo__padX__D(this) : 0.0);
});
$p.aMB = (function() {
  return ((this.pv() && this.mg) ? $p_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$CInfo__padY__D(this) : 0.0);
});
$p.aMw = (function() {
  return ((this.pv() && (!this.mg)) ? $p_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$CInfo__padX__D(this) : 0.0);
});
$p.aMx = (function() {
  return ((this.pv() && (!this.mg)) ? $p_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$CInfo__padY__D(this) : 0.0);
});
$p.aeW = (function(flip) {
  return (((flip && this.pv()) && this.mg) ? $p_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$CInfo__padY__D(this) : 0.0);
});
$p.aMz = (function(flip) {
  return (((flip && this.pv()) && this.mg) ? $p_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$CInfo__padX__D(this) : 0.0);
});
$p.aeV = (function(flip) {
  return (((flip && this.pv()) && (!this.mg)) ? $p_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$CInfo__padY__D(this) : 0.0);
});
$p.aMy = (function(flip) {
  return (((flip && this.pv()) && (!this.mg)) ? $p_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$CInfo__padX__D(this) : 0.0);
});
$p.aPG = (function(bb, flip) {
  if (flip) {
    if (this.mg) {
      var d___1 = this.aeW(flip);
      var d___2 = this.aMz(flip);
    } else {
      var d___1 = this.aeV(flip);
      var d___2 = this.aMy(flip);
    }
    var $x_2 = (this.mg ? (bb.nX - (0.5 * (+d___1))) : (bb.nW + (0.5 * (+d___1))));
    matchResult4: {
      var $x_1;
      var x5 = this.Fc;
      if ((x5 === 114)) {
        var $x_1 = (bb.pR + (0.5 * (+d___2)));
        break matchResult4;
      }
      if ((x5 === 108)) {
        var $x_1 = (bb.pS - (0.5 * (+d___2)));
        break matchResult4;
      }
      var $x_1 = (0.5 * (bb.pR + bb.pS));
    }
    return new $c_T2($x_2, $x_1);
  } else {
    if (this.mg) {
      var d$2___1 = this.aMA();
      var d$2___2 = this.aMB();
    } else {
      var d$2___1 = this.aMw();
      var d$2___2 = this.aMx();
    }
    var y$2 = (this.mg ? (bb.pS - (0.5 * (+d$2___2))) : (bb.pR + (0.5 * (+d$2___2))));
    matchResult5: {
      var $x_3;
      var x6 = this.Fc;
      if ((x6 === 114)) {
        var $x_3 = (bb.nX - (0.5 * (+d$2___1)));
        break matchResult5;
      }
      if ((x6 === 108)) {
        var $x_3 = (bb.nW + (0.5 * (+d$2___1)));
        break matchResult5;
      }
      var $x_3 = (0.5 * (bb.nW + bb.nX));
    }
    return new $c_T2($x_3, y$2);
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$CInfo(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fW)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$CInfo = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$CInfo, "org.jpablo.graphexplorer.graphviz.layout.Cluster$CInfo", ({
  fW: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo(ranks, yOf, ht1, ht2, rootHt1, rootHt2, clHt1, clHt2) {
  this.KM = null;
  this.Bh = null;
  this.KK = null;
  this.KL = null;
  this.KN = 0.0;
  this.KO = 0.0;
  this.KI = null;
  this.KJ = null;
  this.KM = ranks;
  this.Bh = yOf;
  this.KK = ht1;
  this.KL = ht2;
  this.KN = rootHt1;
  this.KO = rootHt2;
  this.KI = clHt1;
  this.KJ = clHt2;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 84477095);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.KM));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Bh));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.KK));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.KL));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.KN));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.KO));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.KI));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.KJ));
  return $m_sr_Statics$().Z(acc, 8);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo)) {
    if (((this.KN === x$0.KN) && (this.KO === x$0.KO))) {
      var x = this.KM;
      var x$2 = x$0.KM;
      var $x_5 = ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$3 = this.Bh;
      var x$4 = x$0.Bh;
      var $x_4 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$5 = this.KK;
      var x$6 = x$0.KK;
      var $x_3 = ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$7 = this.KL;
      var x$8 = x$0.KL;
      var $x_2 = ((x$7 === null) ? (x$8 === null) : x$7.e(x$8));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$9 = this.KI;
      var x$10 = x$0.KI;
      var $x_1 = ((x$9 === null) ? (x$10 === null) : x$9.e(x$10));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$11 = this.KJ;
      var x$12 = x$0.KJ;
      return ((x$11 === null) ? (x$12 === null) : x$11.e(x$12));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 8;
});
$p.B = (function() {
  return "YInfo";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.KM;
      break;
    }
    case 1: {
      return this.Bh;
      break;
    }
    case 2: {
      return this.KK;
      break;
    }
    case 3: {
      return this.KL;
      break;
    }
    case 4: {
      return this.KN;
      break;
    }
    case 5: {
      return this.KO;
      break;
    }
    case 6: {
      return this.KI;
      break;
    }
    case 7: {
      return this.KJ;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "ranks";
      break;
    }
    case 1: {
      return "yOf";
      break;
    }
    case 2: {
      return "ht1";
      break;
    }
    case 3: {
      return "ht2";
      break;
    }
    case 4: {
      return "rootHt1";
      break;
    }
    case 5: {
      return "rootHt2";
      break;
    }
    case 6: {
      return "clHt1";
      break;
    }
    case 7: {
      return "clHt2";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fX)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_Coord$YInfo, "org.jpablo.graphexplorer.graphviz.layout.Coord$YInfo", ({
  fX: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$NSEdge(tail, head, minlen, weight) {
  this.pT = null;
  this.rp = null;
  this.ut = 0;
  this.uu = 0;
  this.pT = tail;
  this.rp = head;
  this.ut = minlen;
  this.uu = weight;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$NSEdge.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$NSEdge;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$NSEdge() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$NSEdge.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, (-1983086302));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.pT));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.rp));
  acc = $m_sr_Statics$().k(acc, this.ut);
  acc = $m_sr_Statics$().k(acc, this.uu);
  return $m_sr_Statics$().Z(acc, 4);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$NSEdge) && ((((this.ut === x$0.ut) && (this.uu === x$0.uu)) && (this.pT === x$0.pT)) && (this.rp === x$0.rp))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 4;
});
$p.B = (function() {
  return "NSEdge";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.pT;
      break;
    }
    case 1: {
      return this.rp;
      break;
    }
    case 2: {
      return this.ut;
      break;
    }
    case 3: {
      return this.uu;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "tail";
      break;
    }
    case 1: {
      return "head";
      break;
    }
    case 2: {
      return "minlen";
      break;
    }
    case 3: {
      return "weight";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$NSEdge(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.g4)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$NSEdge = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_NetworkSimplex$NSEdge, "org.jpablo.graphexplorer.graphviz.layout.NetworkSimplex$NSEdge", ({
  g4: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$Metrics(dimenX, dimenY, minW, minH, valignCentered) {
  this.yR = 0.0;
  this.uv = 0.0;
  this.yS = 0.0;
  this.nY = 0.0;
  this.yT = false;
  this.yR = dimenX;
  this.uv = dimenY;
  this.yS = minW;
  this.nY = minH;
  this.yT = valignCentered;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$Metrics.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$Metrics;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$Metrics() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$Metrics.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, (-1674487645));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.yR));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.uv));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.yS));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.nY));
  acc = $m_sr_Statics$().k(acc, (this.yT ? 1231 : 1237));
  return $m_sr_Statics$().Z(acc, 5);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$Metrics) && (((((this.yR === x$0.yR) && (this.uv === x$0.uv)) && (this.yS === x$0.yS)) && (this.nY === x$0.nY)) && (this.yT === x$0.yT))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 5;
});
$p.B = (function() {
  return "Metrics";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.yR;
      break;
    }
    case 1: {
      return this.uv;
      break;
    }
    case 2: {
      return this.yS;
      break;
    }
    case 3: {
      return this.nY;
      break;
    }
    case 4: {
      return this.yT;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "dimenX";
      break;
    }
    case 1: {
      return "dimenY";
      break;
    }
    case 2: {
      return "minW";
      break;
    }
    case 3: {
      return "minH";
      break;
    }
    case 4: {
      return "valignCentered";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$Metrics(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.g5)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$Metrics = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$Metrics, "org.jpablo.graphexplorer.graphviz.layout.NodeSize$Metrics", ({
  g5: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$ShapeKind(box, regular, plain, supported, peripheries) {
  this.yU = false;
  this.wE = false;
  this.uw = false;
  this.yV = false;
  this.Bi = 0;
  this.yU = box;
  this.wE = regular;
  this.uw = plain;
  this.yV = supported;
  this.Bi = peripheries;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$ShapeKind.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$ShapeKind;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$ShapeKind() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$ShapeKind.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 364406453);
  acc = $m_sr_Statics$().k(acc, (this.yU ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, (this.wE ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, (this.uw ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, (this.yV ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, this.Bi);
  return $m_sr_Statics$().Z(acc, 5);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$ShapeKind) && (((((this.yU === x$0.yU) && (this.wE === x$0.wE)) && (this.uw === x$0.uw)) && (this.yV === x$0.yV)) && (this.Bi === x$0.Bi))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 5;
});
$p.B = (function() {
  return "ShapeKind";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.yU;
      break;
    }
    case 1: {
      return this.wE;
      break;
    }
    case 2: {
      return this.uw;
      break;
    }
    case 3: {
      return this.yV;
      break;
    }
    case 4: {
      return this.Bi;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "box";
      break;
    }
    case 1: {
      return "regular";
      break;
    }
    case 2: {
      return "plain";
      break;
    }
    case 3: {
      return "supported";
      break;
    }
    case 4: {
      return "peripheries";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$ShapeKind(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.g6)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$ShapeKind = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$ShapeKind, "org.jpablo.graphexplorer.graphviz.layout.NodeSize$ShapeKind", ({
  g6: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$Size(width, height) {
  this.Bk = 0.0;
  this.Bj = 0.0;
  this.Bk = width;
  this.Bj = height;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$Size.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$Size;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$Size() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$Size.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-567997917), true);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$Size) && ((this.Bk === x$0.Bk) && (this.Bj === x$0.Bj))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "Size";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Bk;
  }
  if ((n === 1)) {
    return this.Bj;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "width";
  }
  if ((n === 1)) {
    return "height";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$Size(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.g7)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$Size = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_NodeSize$Size, "org.jpablo.graphexplorer.graphviz.layout.NodeSize$Size", ({
  g7: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$Result(rank, order, crossings_$_lo, crossings_$_hi, segments, segOwner, mergedInto, flatLabels, nlist) {
  this.Bn = null;
  this.oX = null;
  this.W4 = 0;
  this.W5 = 0;
  this.yW = null;
  this.Fj = null;
  this.pV = null;
  this.Fi = null;
  this.Bm = null;
  this.Bn = rank;
  this.oX = order;
  this.W4 = crossings_$_lo;
  this.W5 = crossings_$_hi;
  this.yW = segments;
  this.Fj = segOwner;
  this.pV = mergedInto;
  this.Fi = flatLabels;
  this.Bm = nlist;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$Result.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$Result;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_Order$Result() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_Order$Result.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, (-1850559427));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Bn));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.oX));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().jt(this.W4, this.W5));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.yW));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Fj));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.pV));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Fi));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Bm));
  return $m_sr_Statics$().Z(acc, 8);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$Result)) {
    var x_$_lo = this.W4;
    var x_$_hi = this.W5;
    var $x_7 = x$0;
    var x$1_$_lo = $x_7.W4;
    var x$1_$_hi = $x_7.W5;
    if ((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0)) {
      var x$2 = this.Bn;
      var x$2$1 = x$0.Bn;
      var $x_6 = ((x$2 === null) ? (x$2$1 === null) : x$2.e(x$2$1));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$3 = this.oX;
      var x$4 = x$0.oX;
      var $x_5 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$5 = this.yW;
      var x$6 = x$0.yW;
      var $x_4 = ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$7 = this.Fj;
      var x$8 = x$0.Fj;
      var $x_3 = ((x$7 === null) ? (x$8 === null) : x$7.e(x$8));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$9 = this.pV;
      var x$10 = x$0.pV;
      var $x_2 = ((x$9 === null) ? (x$10 === null) : x$9.e(x$10));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$11 = this.Fi;
      var x$12 = x$0.Fi;
      var $x_1 = ((x$11 === null) ? (x$12 === null) : x$11.e(x$12));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$13 = this.Bm;
      var x$14 = x$0.Bm;
      return ((x$13 === null) ? (x$14 === null) : x$13.e(x$14));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 8;
});
$p.B = (function() {
  return "Result";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.Bn;
      break;
    }
    case 1: {
      return this.oX;
      break;
    }
    case 2: {
      return $bL(this.W4, this.W5);
      break;
    }
    case 3: {
      return this.yW;
      break;
    }
    case 4: {
      return this.Fj;
      break;
    }
    case 5: {
      return this.pV;
      break;
    }
    case 6: {
      return this.Fi;
      break;
    }
    case 7: {
      return this.Bm;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "rank";
      break;
    }
    case 1: {
      return "order";
      break;
    }
    case 2: {
      return "crossings";
      break;
    }
    case 3: {
      return "segments";
      break;
    }
    case 4: {
      return "segOwner";
      break;
    }
    case 5: {
      return "mergedInto";
      break;
    }
    case 6: {
      return "flatLabels";
      break;
    }
    case 7: {
      return "nlist";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_layout_Order$Result(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gb)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_Order$Result = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$Result, "org.jpablo.graphexplorer.graphviz.layout.Order$Result", ({
  gb: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts(tailPX, tailOrd, headPX, headOrd) {
  this.o0 = 0.0;
  this.Bp = 0;
  this.nZ = 0.0;
  this.Bo = 0;
  this.o0 = tailPX;
  this.Bp = tailOrd;
  this.nZ = headPX;
  this.Bo = headOrd;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 1094032605);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.o0));
  acc = $m_sr_Statics$().k(acc, this.Bp);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.nZ));
  acc = $m_sr_Statics$().k(acc, this.Bo);
  return $m_sr_Statics$().Z(acc, 4);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts) && ((((this.o0 === x$0.o0) && (this.Bp === x$0.Bp)) && (this.nZ === x$0.nZ)) && (this.Bo === x$0.Bo))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 4;
});
$p.B = (function() {
  return "SegPorts";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.o0;
      break;
    }
    case 1: {
      return this.Bp;
      break;
    }
    case 2: {
      return this.nZ;
      break;
    }
    case 3: {
      return this.Bo;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "tailPX";
      break;
    }
    case 1: {
      return "tailOrd";
      break;
    }
    case 2: {
      return "headPX";
      break;
    }
    case 3: {
      return "headOrd";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gc)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$SegPorts, "org.jpablo.graphexplorer.graphviz.layout.Order$SegPorts", ({
  gc: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Desc(sides, peripheries, orientation, distortion, skew, regular, gen) {
  this.wF = 0;
  this.Br = 0;
  this.Fl = 0.0;
  this.Bq = 0.0;
  this.Bt = 0.0;
  this.Bs = false;
  this.yX = null;
  this.wF = sides;
  this.Br = peripheries;
  this.Fl = orientation;
  this.Bq = distortion;
  this.Bt = skew;
  this.Bs = regular;
  this.yX = gen;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Desc.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Desc;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Desc() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Desc.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 2126513);
  acc = $m_sr_Statics$().k(acc, this.wF);
  acc = $m_sr_Statics$().k(acc, this.Br);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.Fl));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.Bq));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.Bt));
  acc = $m_sr_Statics$().k(acc, (this.Bs ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.yX));
  return $m_sr_Statics$().Z(acc, 7);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Desc)) {
    if (((((((this.wF === x$0.wF) && (this.Br === x$0.Br)) && (this.Fl === x$0.Fl)) && (this.Bq === x$0.Bq)) && (this.Bt === x$0.Bt)) && (this.Bs === x$0.Bs))) {
      var x = this.yX;
      var x$2 = x$0.yX;
      return ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 7;
});
$p.B = (function() {
  return "Desc";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.wF;
      break;
    }
    case 1: {
      return this.Br;
      break;
    }
    case 2: {
      return this.Fl;
      break;
    }
    case 3: {
      return this.Bq;
      break;
    }
    case 4: {
      return this.Bt;
      break;
    }
    case 5: {
      return this.Bs;
      break;
    }
    case 6: {
      return this.yX;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "sides";
      break;
    }
    case 1: {
      return "peripheries";
      break;
    }
    case 2: {
      return "orientation";
      break;
    }
    case 3: {
      return "distortion";
      break;
    }
    case 4: {
      return "skew";
      break;
    }
    case 5: {
      return "regular";
      break;
    }
    case 6: {
      return "gen";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Desc(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gd)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Desc = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Desc, "org.jpablo.graphexplorer.graphviz.layout.Polygon$Desc", ({
  gd: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Poly(bbX, bbY, rings, outline) {
  this.KU = 0.0;
  this.KV = 0.0;
  this.wG = null;
  this.KW = null;
  this.KU = bbX;
  this.KV = bbY;
  this.wG = rings;
  this.KW = outline;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Poly.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Poly;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Poly() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Poly.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 2493420);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.KU));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.KV));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.wG));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.KW));
  return $m_sr_Statics$().Z(acc, 4);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Poly)) {
    if (((this.KU === x$0.KU) && (this.KV === x$0.KV))) {
      var x = this.wG;
      var x$2 = x$0.wG;
      var $x_1 = ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.KW;
      var x$4 = x$0.KW;
      return ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 4;
});
$p.B = (function() {
  return "Poly";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.KU;
      break;
    }
    case 1: {
      return this.KV;
      break;
    }
    case 2: {
      return this.wG;
      break;
    }
    case 3: {
      return this.KW;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "bbX";
      break;
    }
    case 1: {
      return "bbY";
      break;
    }
    case 2: {
      return "rings";
      break;
    }
    case 3: {
      return "outline";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Poly(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ge)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Poly = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Poly, "org.jpablo.graphexplorer.graphviz.layout.Polygon$Poly", ({
  ge: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$Anchor(x, y, clip, constrained, theta) {
  this.KX = 0.0;
  this.KY = 0.0;
  this.RL = false;
  this.RM = false;
  this.RN = 0.0;
  this.KX = x;
  this.KY = y;
  this.RL = clip;
  this.RM = constrained;
  this.RN = theta;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$Anchor.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$Anchor;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$Anchor() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$Anchor.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 1965534933);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.KX));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.KY));
  acc = $m_sr_Statics$().k(acc, (this.RL ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, (this.RM ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.RN));
  return $m_sr_Statics$().Z(acc, 5);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$Anchor) && (((((this.RL === x$0.RL) && (this.RM === x$0.RM)) && (this.RN === x$0.RN)) && (this.KX === x$0.KX)) && (this.KY === x$0.KY))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 5;
});
$p.B = (function() {
  return "Anchor";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.KX;
      break;
    }
    case 1: {
      return this.KY;
      break;
    }
    case 2: {
      return this.RL;
      break;
    }
    case 3: {
      return this.RM;
      break;
    }
    case 4: {
      return this.RN;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "x";
      break;
    }
    case 1: {
      return "y";
      break;
    }
    case 2: {
      return "clip";
      break;
    }
    case 3: {
      return "constrained";
      break;
    }
    case 4: {
      return "theta";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$Anchor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gf)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$Anchor = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$Anchor, "org.jpablo.graphexplorer.graphviz.layout.PortAnchor$Anchor", ({
  gf: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort(px, py, theta, constrained, clip, side, defined, dyna, bp) {
  this.pW = 0.0;
  this.uB = 0.0;
  this.pX = 0.0;
  this.uA = false;
  this.rq = false;
  this.fV = 0;
  this.o1 = false;
  this.Bu = false;
  this.z0 = null;
  this.pW = px;
  this.uB = py;
  this.pX = theta;
  this.uA = constrained;
  this.rq = clip;
  this.fV = side;
  this.o1 = defined;
  this.Bu = dyna;
  this.z0 = bp;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 2144138800);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.pW));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.uB));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.pX));
  acc = $m_sr_Statics$().k(acc, (this.uA ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, (this.rq ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, this.fV);
  acc = $m_sr_Statics$().k(acc, (this.o1 ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, (this.Bu ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.z0));
  return $m_sr_Statics$().Z(acc, 9);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort)) {
    if (((((((((this.pW === x$0.pW) && (this.uB === x$0.uB)) && (this.pX === x$0.pX)) && (this.uA === x$0.uA)) && (this.rq === x$0.rq)) && (this.fV === x$0.fV)) && (this.o1 === x$0.o1)) && (this.Bu === x$0.Bu))) {
      var x = this.z0;
      var x$2 = x$0.z0;
      return ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 9;
});
$p.B = (function() {
  return "GvPort";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.pW;
      break;
    }
    case 1: {
      return this.uB;
      break;
    }
    case 2: {
      return this.pX;
      break;
    }
    case 3: {
      return this.uA;
      break;
    }
    case 4: {
      return this.rq;
      break;
    }
    case 5: {
      return this.fV;
      break;
    }
    case 6: {
      return this.o1;
      break;
    }
    case 7: {
      return this.Bu;
      break;
    }
    case 8: {
      return this.z0;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "px";
      break;
    }
    case 1: {
      return "py";
      break;
    }
    case 2: {
      return "theta";
      break;
    }
    case 3: {
      return "constrained";
      break;
    }
    case 4: {
      return "clip";
      break;
    }
    case 5: {
      return "side";
      break;
    }
    case 6: {
      return "defined";
      break;
    }
    case 7: {
      return "dyna";
      break;
    }
    case 8: {
      return "bp";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gg)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$GvPort, "org.jpablo.graphexplorer.graphviz.layout.PortAnchor$GvPort", ({
  gg: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$DEdge(tail, head, minlen) {
  this.oY = null;
  this.pY = null;
  this.Bv = 0;
  this.oY = tail;
  this.pY = head;
  this.Bv = minlen;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$DEdge.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$DEdge;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$DEdge() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$DEdge.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 64954401);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.oY));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.pY));
  acc = $m_sr_Statics$().k(acc, this.Bv);
  return $m_sr_Statics$().Z(acc, 3);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$DEdge) && (((this.Bv === x$0.Bv) && (this.oY === x$0.oY)) && (this.pY === x$0.pY))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 3;
});
$p.B = (function() {
  return "DEdge";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.oY;
      break;
    }
    case 1: {
      return this.pY;
      break;
    }
    case 2: {
      return this.Bv;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "tail";
      break;
    }
    case 1: {
      return "head";
      break;
    }
    case 2: {
      return "minlen";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$DEdge(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gh)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$DEdge = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$DEdge, "org.jpablo.graphexplorer.graphviz.layout.Rank$DEdge", ({
  gh: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$RankSets(leader, minset, maxset, slenX, slenY) {
  this.KZ = null;
  this.wI = null;
  this.wH = null;
  this.L0 = 0;
  this.L1 = 0;
  this.KZ = leader;
  this.wI = minset;
  this.wH = maxset;
  this.L0 = slenX;
  this.L1 = slenY;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$RankSets.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$RankSets;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$RankSets() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$RankSets.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 320667325);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.KZ));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.wI));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.wH));
  acc = $m_sr_Statics$().k(acc, this.L0);
  acc = $m_sr_Statics$().k(acc, this.L1);
  return $m_sr_Statics$().Z(acc, 5);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$RankSets)) {
    if (((this.L0 === x$0.L0) && (this.L1 === x$0.L1))) {
      var x = this.KZ;
      var x$2 = x$0.KZ;
      var $x_2 = ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.wI;
      var x$4 = x$0.wI;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.wH;
      var x$6 = x$0.wH;
      return ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 5;
});
$p.B = (function() {
  return "RankSets";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.KZ;
      break;
    }
    case 1: {
      return this.wI;
      break;
    }
    case 2: {
      return this.wH;
      break;
    }
    case 3: {
      return this.L0;
      break;
    }
    case 4: {
      return this.L1;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "leader";
      break;
    }
    case 1: {
      return "minset";
      break;
    }
    case 2: {
      return "maxset";
      break;
    }
    case 3: {
      return "slenX";
      break;
    }
    case 4: {
      return "slenY";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$RankSets(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gi)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$RankSets = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_Rank$RankSets, "org.jpablo.graphexplorer.graphviz.layout.Rank$RankSets", ({
  gi: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box(llx, lly, urx, ury) {
  this.aJ = 0.0;
  this.bZ = 0.0;
  this.aF = 0.0;
  this.bG = 0.0;
  this.aJ = llx;
  this.bZ = lly;
  this.aF = urx;
  this.bG = ury;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 66987);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.aJ));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.bZ));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.aF));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.bG));
  return $m_sr_Statics$().Z(acc, 4);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box) && ((((this.aJ === x$0.aJ) && (this.bZ === x$0.bZ)) && (this.aF === x$0.aF)) && (this.bG === x$0.bG))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 4;
});
$p.B = (function() {
  return "Box";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.aJ;
      break;
    }
    case 1: {
      return this.bZ;
      break;
    }
    case 2: {
      return this.aF;
      break;
    }
    case 3: {
      return this.bG;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "llx";
      break;
    }
    case 1: {
      return "lly";
      break;
    }
    case 2: {
      return "urx";
      break;
    }
    case 3: {
      return "ury";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gl)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$Box, "org.jpablo.graphexplorer.graphviz.layout.Spline$Box", ({
  gl: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$ESpline(pts, ep, sp) {
  this.wM = null;
  this.Fo = null;
  this.Fp = null;
  this.wM = pts;
  this.Fo = ep;
  this.Fp = sp;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$ESpline.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$ESpline;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$ESpline() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$ESpline.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 811958114, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$ESpline)) {
    var x = this.wM;
    var x$2 = x$0.wM;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      var x$3 = this.Fo;
      var x$4 = x$0.Fo;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Fp;
      var x$6 = x$0.Fp;
      return ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 3;
});
$p.B = (function() {
  return "ESpline";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.wM;
      break;
    }
    case 1: {
      return this.Fo;
      break;
    }
    case 2: {
      return this.Fp;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "pts";
      break;
    }
    case 1: {
      return "ep";
      break;
    }
    case 2: {
      return "sp";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$ESpline(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gm)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$ESpline = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$ESpline, "org.jpablo.graphexplorer.graphviz.layout.Spline$ESpline", ({
  gm: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(x, y) {
  this.W = 0.0;
  this.a6 = 0.0;
  this.W = x;
  this.a6 = y;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 2817);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.W));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.a6));
  return $m_sr_Statics$().Z(acc, 2);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY) && ((this.W === x$0.W) && (this.a6 === x$0.a6))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "XY";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.W;
  }
  if ((n === 1)) {
    return this.a6;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "x";
  }
  if ((n === 1)) {
    return "y";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gn)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$XY, "org.jpablo.graphexplorer.graphviz.layout.Spline$XY", ({
  gn: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$FlatBump$1(minlenAttr, dist, weight) {
  this.z2 = 0;
  this.z1 = 0.0;
  this.z3 = 0;
  this.z2 = minlenAttr;
  this.z1 = dist;
  this.z3 = weight;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$FlatBump$1.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$FlatBump$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$FlatBump$1() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$FlatBump$1.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 1690027119);
  acc = $m_sr_Statics$().k(acc, this.z2);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.z1));
  acc = $m_sr_Statics$().k(acc, this.z3);
  return $m_sr_Statics$().Z(acc, 3);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$FlatBump$1) && (((this.z2 === x$0.z2) && (this.z1 === x$0.z1)) && (this.z3 === x$0.z3))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 3;
});
$p.B = (function() {
  return "FlatBump";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.z2;
      break;
    }
    case 1: {
      return this.z1;
      break;
    }
    case 2: {
      return this.z3;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "minlenAttr";
      break;
    }
    case 1: {
      return "dist";
      break;
    }
    case 2: {
      return "weight";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$FlatBump$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.go)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$FlatBump$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_XCoord$FlatBump$1, "org.jpablo.graphexplorer.graphviz.layout.XCoord$FlatBump$1", ({
  go: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Placed(cx, cy, w, h) {
  this.uD = 0.0;
  this.uE = 0.0;
  this.BA = 0.0;
  this.Bz = 0.0;
  this.uD = cx;
  this.uE = cy;
  this.BA = w;
  this.Bz = h;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Placed.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Placed;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Placed() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Placed.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, (-1901906851));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.uD));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.uE));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.BA));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.Bz));
  return $m_sr_Statics$().Z(acc, 4);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Placed) && ((((this.uD === x$0.uD) && (this.uE === x$0.uE)) && (this.BA === x$0.BA)) && (this.Bz === x$0.Bz))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 4;
});
$p.B = (function() {
  return "Placed";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.uD;
      break;
    }
    case 1: {
      return this.uE;
      break;
    }
    case 2: {
      return this.BA;
      break;
    }
    case 3: {
      return this.Bz;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "cx";
      break;
    }
    case 1: {
      return "cy";
      break;
    }
    case 2: {
      return "w";
      break;
    }
    case 3: {
      return "h";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Placed(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gp)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Placed = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Placed, "org.jpablo.graphexplorer.graphviz.layout.XLabels$Placed", ({
  gp: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Result(nodes, edges) {
  this.Fr = null;
  this.Fq = null;
  this.Fr = nodes;
  this.Fq = edges;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Result.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Result;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Result() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Result.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-1995001512), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Result)) {
    var x = this.Fr;
    var x$2 = x$0.Fr;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      var x$3 = this.Fq;
      var x$4 = x$0.Fq;
      return ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "Result";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Fr;
  }
  if ((n === 1)) {
    return this.Fq;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "nodes";
  }
  if ((n === 1)) {
    return "edges";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Result(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gq)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Result = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_XLabels$Result, "org.jpablo.graphexplorer.graphviz.layout.XLabels$Result", ({
  gq: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_metrics_FontFamilyMetrics(names, unitsPerEm, regular, bold, italic, boldItalic) {
  this.L8 = null;
  this.La = 0;
  this.L9 = null;
  this.L5 = null;
  this.L7 = null;
  this.L6 = null;
  this.L8 = names;
  this.La = unitsPerEm;
  this.L9 = regular;
  this.L5 = bold;
  this.L7 = italic;
  this.L6 = boldItalic;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_metrics_FontFamilyMetrics.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_metrics_FontFamilyMetrics;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_metrics_FontFamilyMetrics() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_metrics_FontFamilyMetrics.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, (-845528944));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.L8));
  acc = $m_sr_Statics$().k(acc, this.La);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.L9));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.L5));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.L7));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.L6));
  return $m_sr_Statics$().Z(acc, 6);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_metrics_FontFamilyMetrics)) {
    if ((this.La === x$0.La)) {
      var x = this.L8;
      var x$2 = x$0.L8;
      var $x_4 = ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$3 = this.L9;
      var x$4 = x$0.L9;
      var $x_3 = ((x$3 === null) ? (x$4 === null) : (x$3 === x$4));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$5 = this.L5;
      var x$6 = x$0.L5;
      var $x_2 = ((x$5 === null) ? (x$6 === null) : (x$5 === x$6));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$7 = this.L7;
      var x$8 = x$0.L7;
      var $x_1 = ((x$7 === null) ? (x$8 === null) : (x$7 === x$8));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$9 = this.L6;
      var x$10 = x$0.L6;
      return ((x$9 === null) ? (x$10 === null) : (x$9 === x$10));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 6;
});
$p.B = (function() {
  return "FontFamilyMetrics";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.L8;
      break;
    }
    case 1: {
      return this.La;
      break;
    }
    case 2: {
      return this.L9;
      break;
    }
    case 3: {
      return this.L5;
      break;
    }
    case 4: {
      return this.L7;
      break;
    }
    case 5: {
      return this.L6;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "names";
      break;
    }
    case 1: {
      return "unitsPerEm";
      break;
    }
    case 2: {
      return "regular";
      break;
    }
    case 3: {
      return "bold";
      break;
    }
    case 4: {
      return "italic";
      break;
    }
    case 5: {
      return "boldItalic";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_metrics_FontFamilyMetrics(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gr)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_metrics_FontFamilyMetrics = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_metrics_FontFamilyMetrics, "org.jpablo.graphexplorer.graphviz.metrics.FontFamilyMetrics", ({
  gr: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$Collected(nodeIds, edgeIdxs, children, label, rank, graphAttrs) {
  this.RW = null;
  this.RT = null;
  this.Lb = null;
  this.RV = null;
  this.RX = null;
  this.RU = null;
  this.RW = nodeIds;
  this.RT = edgeIdxs;
  this.Lb = children;
  this.RV = label;
  this.RX = rank;
  this.RU = graphAttrs;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$Collected.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$Collected;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$Collected() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$Collected.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-1142687538), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$Collected)) {
    var x = this.RW;
    var x$2 = x$0.RW;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      var x$3 = this.RT;
      var x$4 = x$0.RT;
      var $x_3 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$5 = this.Lb;
      var x$6 = x$0.Lb;
      var $x_2 = ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      var $x_2 = false;
    }
    if (($x_2 && (this.RV === x$0.RV))) {
      var x$7 = this.RX;
      var x$8 = x$0.RX;
      var $x_1 = ((x$7 === null) ? (x$8 === null) : x$7.e(x$8));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$9 = this.RU;
      var x$10 = x$0.RU;
      return ((x$9 === null) ? (x$10 === null) : x$9.e(x$10));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 6;
});
$p.B = (function() {
  return "Collected";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.RW;
      break;
    }
    case 1: {
      return this.RT;
      break;
    }
    case 2: {
      return this.Lb;
      break;
    }
    case 3: {
      return this.RV;
      break;
    }
    case 4: {
      return this.RX;
      break;
    }
    case 5: {
      return this.RU;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "nodeIds";
      break;
    }
    case 1: {
      return "edgeIdxs";
      break;
    }
    case 2: {
      return "children";
      break;
    }
    case 3: {
      return "label";
      break;
    }
    case 4: {
      return "rank";
      break;
    }
    case 5: {
      return "graphAttrs";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$Collected(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gs)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$Collected = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$Collected, "org.jpablo.graphexplorer.graphviz.model.AttrResolver$Collected", ({
  gs: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$Scope(node, edge, graph) {
  this.wO = null;
  this.z4 = null;
  this.z5 = null;
  this.wO = node;
  this.z4 = edge;
  this.z5 = graph;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$Scope.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$Scope;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$Scope() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$Scope.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 883142905, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$Scope)) {
    var x = this.wO;
    var x$2 = x$0.wO;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      var x$3 = this.z4;
      var x$4 = x$0.z4;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.z5;
      var x$6 = x$0.z5;
      return ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 3;
});
$p.B = (function() {
  return "Scope";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.wO;
      break;
    }
    case 1: {
      return this.z4;
      break;
    }
    case 2: {
      return this.z5;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "node";
      break;
    }
    case 1: {
      return "edge";
      break;
    }
    case 2: {
      return "graph";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$Scope(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gt)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$Scope = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_model_AttrResolver$Scope, "org.jpablo.graphexplorer.graphviz.model.AttrResolver$Scope", ({
  gt: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_model_Attrs(toMap, htmlKeys) {
  this.ag = null;
  this.n7 = null;
  this.ag = toMap;
  this.n7 = htmlKeys;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_model_Attrs.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_model_Attrs;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_model_Attrs() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_model_Attrs.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-692072474), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_model_Attrs)) {
    var x = this.ag;
    var x$2 = x$0.ag;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      var x$3 = this.n7;
      var x$4 = x$0.n7;
      return ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "Attrs";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.ag;
  }
  if ((n === 1)) {
    return this.n7;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "toMap";
  }
  if ((n === 1)) {
    return "htmlKeys";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.dL = (function(k, d) {
  return this.ag.ay(k, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => d)));
});
$p.DA = (function(o) {
  $m_Lorg_jpablo_graphexplorer_graphviz_model_Attrs$();
  return new $c_Lorg_jpablo_graphexplorer_graphviz_model_Attrs(this.ag.hN(o.ag), this.n7.jv(o.ag.ln()).dI(o.n7));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_model_Attrs(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gu)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_model_Attrs = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_model_Attrs, "org.jpablo.graphexplorer.graphviz.model.Attrs", ({
  gu: 1,
  b: 1,
  c: 1,
  a: 1
}));
function $p_Lorg_jpablo_graphexplorer_graphviz_model_REdge__portStr__Lorg_jpablo_graphexplorer_graphviz_dotlang_Port__T($thiz, p) {
  var this$1 = p.ww;
  if (this$1.c()) {
    var c = $m_s_None$();
  } else {
    var x0 = this$1.d();
    var this$2 = x0.m();
    var this$3 = this$2.toLowerCase();
    var c = new $c_s_Some(this$3.split("underscore").join("_"));
  }
  var this$4 = p.wx;
  var x28 = new $c_T2((this$4.c() ? $m_s_None$() : new $c_s_Some(this$4.d().fU)), c);
  var x39 = x28.bi;
  var x40 = x28.be;
  if ((x39 instanceof $c_s_Some)) {
    var x44 = x39.J;
    if ((x40 instanceof $c_s_Some)) {
      var cp = x40.J;
      return ((x44 + ":") + cp);
    }
    if (($m_s_None$() === x40)) {
      return x44;
    }
  }
  if (($m_s_None$() === x39)) {
    if ((x40 instanceof $c_s_Some)) {
      return x40.J;
    }
    if (($m_s_None$() === x40)) {
      return "";
    }
  }
  throw new $c_s_MatchError(x28);
}
function $p_Lorg_jpablo_graphexplorer_graphviz_model_REdge__portName__Lorg_jpablo_graphexplorer_graphviz_dotlang_Port__T($thiz, p) {
  var this$1 = p.ww;
  if (this$1.c()) {
    var this$4 = $m_s_None$();
  } else {
    var x0 = this$1.d();
    var this$2 = x0.m();
    var this$3 = this$2.toLowerCase();
    var this$4 = new $c_s_Some(this$3.split("underscore").join("_"));
  }
  if (this$4.c()) {
    var this$5 = p.wx;
    var this$6 = (this$5.c() ? $m_s_None$() : new $c_s_Some(this$5.d().fU));
  } else {
    var this$6 = this$4;
  }
  return (this$6.c() ? "" : this$6.d());
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_model_REdge(tail, head, attrs, tailPort, headPort) {
  this.ai = null;
  this.ak = null;
  this.b4 = null;
  this.ka = null;
  this.k9 = null;
  this.ai = tail;
  this.ak = head;
  this.b4 = attrs;
  this.ka = tailPort;
  this.k9 = headPort;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_model_REdge.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_model_REdge;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_model_REdge() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_model_REdge.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-1334079210), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_model_REdge)) {
    if (((this.ai === x$0.ai) && (this.ak === x$0.ak))) {
      var x = this.b4;
      var x$2 = x$0.b4;
      var $x_2 = ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.ka;
      var x$4 = x$0.ka;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.k9;
      var x$6 = x$0.k9;
      return ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 5;
});
$p.B = (function() {
  return "REdge";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.ai;
      break;
    }
    case 1: {
      return this.ak;
      break;
    }
    case 2: {
      return this.b4;
      break;
    }
    case 3: {
      return this.ka;
      break;
    }
    case 4: {
      return this.k9;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "tail";
      break;
    }
    case 1: {
      return "head";
      break;
    }
    case 2: {
      return "attrs";
      break;
    }
    case 3: {
      return "tailPort";
      break;
    }
    case 4: {
      return "headPort";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.b9K = (function() {
  var this$1 = this.ka;
  var this$2 = (this$1.c() ? $m_s_None$() : new $c_s_Some($p_Lorg_jpablo_graphexplorer_graphviz_model_REdge__portStr__Lorg_jpablo_graphexplorer_graphviz_dotlang_Port__T(this, this$1.d())));
  return ((this$2.c() || (this$2.d() !== "")) ? this$2 : $m_s_None$());
});
$p.b2B = (function() {
  var this$1 = this.k9;
  var this$2 = (this$1.c() ? $m_s_None$() : new $c_s_Some($p_Lorg_jpablo_graphexplorer_graphviz_model_REdge__portStr__Lorg_jpablo_graphexplorer_graphviz_dotlang_Port__T(this, this$1.d())));
  return ((this$2.c() || (this$2.d() !== "")) ? this$2 : $m_s_None$());
});
$p.b9J = (function() {
  var this$1 = this.ka;
  var this$2 = (this$1.c() ? $m_s_None$() : new $c_s_Some($p_Lorg_jpablo_graphexplorer_graphviz_model_REdge__portName__Lorg_jpablo_graphexplorer_graphviz_dotlang_Port__T(this, this$1.d())));
  return ((this$2.c() || (this$2.d() !== "")) ? this$2 : $m_s_None$());
});
$p.b2A = (function() {
  var this$1 = this.k9;
  var this$2 = (this$1.c() ? $m_s_None$() : new $c_s_Some($p_Lorg_jpablo_graphexplorer_graphviz_model_REdge__portName__Lorg_jpablo_graphexplorer_graphviz_dotlang_Port__T(this, this$1.d())));
  return ((this$2.c() || (this$2.d() !== "")) ? this$2 : $m_s_None$());
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_model_REdge(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gv)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_model_REdge = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_model_REdge, "org.jpablo.graphexplorer.graphviz.model.REdge", ({
  gv: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_model_RGraph(strict, directed, name, rootAttrs, nodes, edges, subgraphs, graphAttrKeys, images) {
  this.Lc = false;
  this.z6 = false;
  this.j5 = null;
  this.f2 = null;
  this.cB = null;
  this.cu = null;
  this.uF = null;
  this.BB = null;
  this.mj = null;
  this.Lc = strict;
  this.z6 = directed;
  this.j5 = name;
  this.f2 = rootAttrs;
  this.cB = nodes;
  this.cu = edges;
  this.uF = subgraphs;
  this.BB = graphAttrKeys;
  this.mj = images;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_model_RGraph.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_model_RGraph;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_model_RGraph() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_model_RGraph.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, (-1878313956));
  acc = $m_sr_Statics$().k(acc, (this.Lc ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, (this.z6 ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.j5));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.f2));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.cB));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.cu));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.uF));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.BB));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.mj));
  return $m_sr_Statics$().Z(acc, 9);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_model_RGraph)) {
    if (((this.Lc === x$0.Lc) && (this.z6 === x$0.z6))) {
      var x = this.j5;
      var x$2 = x$0.j5;
      var $x_6 = ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$3 = this.f2;
      var x$4 = x$0.f2;
      var $x_5 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$5 = this.cB;
      var x$6 = x$0.cB;
      var $x_4 = ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$7 = this.cu;
      var x$8 = x$0.cu;
      var $x_3 = ((x$7 === null) ? (x$8 === null) : x$7.e(x$8));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$9 = this.uF;
      var x$10 = x$0.uF;
      var $x_2 = ((x$9 === null) ? (x$10 === null) : x$9.e(x$10));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$11 = this.BB;
      var x$12 = x$0.BB;
      var $x_1 = ((x$11 === null) ? (x$12 === null) : x$11.e(x$12));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$13 = this.mj;
      var x$14 = x$0.mj;
      return ((x$13 === null) ? (x$14 === null) : x$13.e(x$14));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 9;
});
$p.B = (function() {
  return "RGraph";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.Lc;
      break;
    }
    case 1: {
      return this.z6;
      break;
    }
    case 2: {
      return this.j5;
      break;
    }
    case 3: {
      return this.f2;
      break;
    }
    case 4: {
      return this.cB;
      break;
    }
    case 5: {
      return this.cu;
      break;
    }
    case 6: {
      return this.uF;
      break;
    }
    case 7: {
      return this.BB;
      break;
    }
    case 8: {
      return this.mj;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "strict";
      break;
    }
    case 1: {
      return "directed";
      break;
    }
    case 2: {
      return "name";
      break;
    }
    case 3: {
      return "rootAttrs";
      break;
    }
    case 4: {
      return "nodes";
      break;
    }
    case 5: {
      return "edges";
      break;
    }
    case 6: {
      return "subgraphs";
      break;
    }
    case 7: {
      return "graphAttrKeys";
      break;
    }
    case 8: {
      return "images";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_model_RGraph(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gw)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_model_RGraph = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_model_RGraph, "org.jpablo.graphexplorer.graphviz.model.RGraph", ({
  gw: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_model_RNode(id, attrs) {
  this.br = null;
  this.aK = null;
  this.br = id;
  this.aK = attrs;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_model_RNode.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_model_RNode;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_model_RNode() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_model_RNode.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-560703696), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_model_RNode)) {
    if ((this.br === x$0.br)) {
      var x = this.aK;
      var x$2 = x$0.aK;
      return ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "RNode";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.br;
  }
  if ((n === 1)) {
    return this.aK;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "id";
  }
  if ((n === 1)) {
    return "attrs";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_model_RNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gx)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_model_RNode = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_model_RNode, "org.jpablo.graphexplorer.graphviz.model.RNode", ({
  gx: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph(id, label, isCluster, rank, nodeIds, edgeIdxs, children, attrs) {
  this.z7 = null;
  this.wQ = null;
  this.wP = false;
  this.BC = null;
  this.rs = null;
  this.Ft = null;
  this.lD = null;
  this.q2 = null;
  this.z7 = id;
  this.wQ = label;
  this.wP = isCluster;
  this.BC = rank;
  this.rs = nodeIds;
  this.Ft = edgeIdxs;
  this.lD = children;
  this.q2 = attrs;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 104979840);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.z7));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.wQ));
  acc = $m_sr_Statics$().k(acc, (this.wP ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.BC));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.rs));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Ft));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.lD));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.q2));
  return $m_sr_Statics$().Z(acc, 8);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph)) {
    if ((((this.wP === x$0.wP) && (this.z7 === x$0.z7)) && (this.wQ === x$0.wQ))) {
      var x = this.BC;
      var x$2 = x$0.BC;
      var $x_4 = ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$3 = this.rs;
      var x$4 = x$0.rs;
      var $x_3 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$5 = this.Ft;
      var x$6 = x$0.Ft;
      var $x_2 = ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$7 = this.lD;
      var x$8 = x$0.lD;
      var $x_1 = ((x$7 === null) ? (x$8 === null) : x$7.e(x$8));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$9 = this.q2;
      var x$10 = x$0.q2;
      return ((x$9 === null) ? (x$10 === null) : x$9.e(x$10));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 8;
});
$p.B = (function() {
  return "RSubgraph";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.z7;
      break;
    }
    case 1: {
      return this.wQ;
      break;
    }
    case 2: {
      return this.wP;
      break;
    }
    case 3: {
      return this.BC;
      break;
    }
    case 4: {
      return this.rs;
      break;
    }
    case 5: {
      return this.Ft;
      break;
    }
    case 6: {
      return this.lD;
      break;
    }
    case 7: {
      return this.q2;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "id";
      break;
    }
    case 1: {
      return "label";
      break;
    }
    case 2: {
      return "isCluster";
      break;
    }
    case 3: {
      return "rank";
      break;
    }
    case 4: {
      return "nodeIds";
      break;
    }
    case 5: {
      return "edgeIdxs";
      break;
    }
    case 6: {
      return "children";
      break;
    }
    case 7: {
      return "attrs";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gy)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_model_RSubgraph, "org.jpablo.graphexplorer.graphviz.model.RSubgraph", ({
  gy: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_output_Output$Doc(name, directed, strict, rootAttrs, sgCnt, subgraphs, nodes, edges) {
  this.Fv = null;
  this.Fu = false;
  this.Fz = false;
  this.Fx = null;
  this.Fy = 0;
  this.FA = null;
  this.Fw = null;
  this.wR = null;
  this.Fv = name;
  this.Fu = directed;
  this.Fz = strict;
  this.Fx = rootAttrs;
  this.Fy = sgCnt;
  this.FA = subgraphs;
  this.Fw = nodes;
  this.wR = edges;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_output_Output$Doc.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_output_Output$Doc;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_output_Output$Doc() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_output_Output$Doc.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 68888);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Fv));
  acc = $m_sr_Statics$().k(acc, (this.Fu ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, (this.Fz ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Fx));
  acc = $m_sr_Statics$().k(acc, this.Fy);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.FA));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Fw));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.wR));
  return $m_sr_Statics$().Z(acc, 8);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_output_Output$Doc)) {
    if (((((this.Fu === x$0.Fu) && (this.Fz === x$0.Fz)) && (this.Fy === x$0.Fy)) && (this.Fv === x$0.Fv))) {
      var x = this.Fx;
      var x$2 = x$0.Fx;
      var $x_3 = ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$3 = this.FA;
      var x$4 = x$0.FA;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.Fw;
      var x$6 = x$0.Fw;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$7 = this.wR;
      var x$8 = x$0.wR;
      return ((x$7 === null) ? (x$8 === null) : x$7.e(x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 8;
});
$p.B = (function() {
  return "Doc";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.Fv;
      break;
    }
    case 1: {
      return this.Fu;
      break;
    }
    case 2: {
      return this.Fz;
      break;
    }
    case 3: {
      return this.Fx;
      break;
    }
    case 4: {
      return this.Fy;
      break;
    }
    case 5: {
      return this.FA;
      break;
    }
    case 6: {
      return this.Fw;
      break;
    }
    case 7: {
      return this.wR;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "name";
      break;
    }
    case 1: {
      return "directed";
      break;
    }
    case 2: {
      return "strict";
      break;
    }
    case 3: {
      return "rootAttrs";
      break;
    }
    case 4: {
      return "sgCnt";
      break;
    }
    case 5: {
      return "subgraphs";
      break;
    }
    case 6: {
      return "nodes";
      break;
    }
    case 7: {
      return "edges";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_output_Output$Doc(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gz)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_output_Output$Doc = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_output_Output$Doc, "org.jpablo.graphexplorer.graphviz.output.Output$Doc", ({
  gz: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_output_Output$Doc$E(gv, t, h, tp, hp, idx) {
  this.BD = 0;
  this.FD = 0;
  this.FB = 0;
  this.FE = null;
  this.FC = null;
  this.rt = 0;
  this.BD = gv;
  this.FD = t;
  this.FB = h;
  this.FE = tp;
  this.FC = hp;
  this.rt = idx;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_output_Output$Doc$E.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_output_Output$Doc$E;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_output_Output$Doc$E() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_output_Output$Doc$E.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 69);
  acc = $m_sr_Statics$().k(acc, this.BD);
  acc = $m_sr_Statics$().k(acc, this.FD);
  acc = $m_sr_Statics$().k(acc, this.FB);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.FE));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.FC));
  acc = $m_sr_Statics$().k(acc, this.rt);
  return $m_sr_Statics$().Z(acc, 6);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_output_Output$Doc$E)) {
    if (((((this.BD === x$0.BD) && (this.FD === x$0.FD)) && (this.FB === x$0.FB)) && (this.rt === x$0.rt))) {
      var x = this.FE;
      var x$2 = x$0.FE;
      var $x_1 = ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.FC;
      var x$4 = x$0.FC;
      return ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 6;
});
$p.B = (function() {
  return "E";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.BD;
      break;
    }
    case 1: {
      return this.FD;
      break;
    }
    case 2: {
      return this.FB;
      break;
    }
    case 3: {
      return this.FE;
      break;
    }
    case 4: {
      return this.FC;
      break;
    }
    case 5: {
      return this.rt;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "gv";
      break;
    }
    case 1: {
      return "t";
      break;
    }
    case 2: {
      return "h";
      break;
    }
    case 3: {
      return "tp";
      break;
    }
    case 4: {
      return "hp";
      break;
    }
    case 5: {
      return "idx";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_output_Output$Doc$E(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gA)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_output_Output$Doc$E = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_output_Output$Doc$E, "org.jpablo.graphexplorer.graphviz.output.Output$Doc$E", ({
  gA: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_output_Output$Doc$SG(gvid, name, label, rank, nodeGvids, edgeGvids, subgraphGvids, emitLabel, attrs) {
  this.Ld = 0;
  this.FH = null;
  this.Le = null;
  this.FJ = null;
  this.FI = null;
  this.FF = null;
  this.FK = null;
  this.FG = false;
  this.BE = null;
  this.Ld = gvid;
  this.FH = name;
  this.Le = label;
  this.FJ = rank;
  this.FI = nodeGvids;
  this.FF = edgeGvids;
  this.FK = subgraphGvids;
  this.FG = emitLabel;
  this.BE = attrs;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_output_Output$Doc$SG.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_output_Output$Doc$SG;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_output_Output$Doc$SG() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_output_Output$Doc$SG.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 2644);
  acc = $m_sr_Statics$().k(acc, this.Ld);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.FH));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Le));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.FJ));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.FI));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.FF));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.FK));
  acc = $m_sr_Statics$().k(acc, (this.FG ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.BE));
  return $m_sr_Statics$().Z(acc, 9);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_output_Output$Doc$SG)) {
    if (((((this.Ld === x$0.Ld) && (this.FG === x$0.FG)) && (this.FH === x$0.FH)) && (this.Le === x$0.Le))) {
      var x = this.FJ;
      var x$2 = x$0.FJ;
      var $x_4 = ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$3 = this.FI;
      var x$4 = x$0.FI;
      var $x_3 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$5 = this.FF;
      var x$6 = x$0.FF;
      var $x_2 = ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$7 = this.FK;
      var x$8 = x$0.FK;
      var $x_1 = ((x$7 === null) ? (x$8 === null) : x$7.e(x$8));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$9 = this.BE;
      var x$10 = x$0.BE;
      return ((x$9 === null) ? (x$10 === null) : x$9.e(x$10));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 9;
});
$p.B = (function() {
  return "SG";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.Ld;
      break;
    }
    case 1: {
      return this.FH;
      break;
    }
    case 2: {
      return this.Le;
      break;
    }
    case 3: {
      return this.FJ;
      break;
    }
    case 4: {
      return this.FI;
      break;
    }
    case 5: {
      return this.FF;
      break;
    }
    case 6: {
      return this.FK;
      break;
    }
    case 7: {
      return this.FG;
      break;
    }
    case 8: {
      return this.BE;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "gvid";
      break;
    }
    case 1: {
      return "name";
      break;
    }
    case 2: {
      return "label";
      break;
    }
    case 3: {
      return "rank";
      break;
    }
    case 4: {
      return "nodeGvids";
      break;
    }
    case 5: {
      return "edgeGvids";
      break;
    }
    case 6: {
      return "subgraphGvids";
      break;
    }
    case 7: {
      return "emitLabel";
      break;
    }
    case 8: {
      return "attrs";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_output_Output$Doc$SG(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gB)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_output_Output$Doc$SG = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_output_Output$Doc$SG, "org.jpablo.graphexplorer.graphviz.output.Output$Doc$SG", ({
  gB: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_model_Binding(origin, mode, baseHash, lastSyncAt_$_lo, lastSyncAt_$_hi) {
  this.wS = null;
  this.z9 = null;
  this.z8 = null;
  this.Ip = 0;
  this.Iq = 0;
  this.wS = origin;
  this.z9 = mode;
  this.z8 = baseHash;
  this.Ip = lastSyncAt_$_lo;
  this.Iq = lastSyncAt_$_hi;
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_model_Binding.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_model_Binding;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_model_Binding() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_model_Binding.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 1556432485);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.wS));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.z9));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.z8));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().jt(this.Ip, this.Iq));
  return $m_sr_Statics$().Z(acc, 4);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_gxcore_model_Binding)) {
    var x_$_lo = this.Ip;
    var x_$_hi = this.Iq;
    var $x_2 = x$0;
    var x$1_$_lo = $x_2.Ip;
    var x$1_$_hi = $x_2.Iq;
    if (((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0) && (this.wS === x$0.wS))) {
      var x$2 = this.z9;
      var x$2$1 = x$0.z9;
      var $x_1 = ((x$2 === null) ? (x$2$1 === null) : (x$2 === x$2$1));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return (this.z8 === x$0.z8);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 4;
});
$p.B = (function() {
  return "Binding";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.wS;
      break;
    }
    case 1: {
      return this.z9;
      break;
    }
    case 2: {
      return this.z8;
      break;
    }
    case 3: {
      return $bL(this.Ip, this.Iq);
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "origin";
      break;
    }
    case 1: {
      return "mode";
      break;
    }
    case 2: {
      return "baseHash";
      break;
    }
    case 3: {
      return "lastSyncAt";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_gxcore_model_Binding(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gQ)));
}
var $d_Lorg_jpablo_graphexplorer_gxcore_model_Binding = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_model_Binding, "org.jpablo.graphexplorer.gxcore.model.Binding", ({
  gQ: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_model_Diagram(id, name, folder, format, text, binding, metadata, createdAt_$_lo, createdAt_$_hi, updatedAt_$_lo, updatedAt_$_hi) {
  this.jE = null;
  this.n8 = null;
  this.uG = null;
  this.ru = null;
  this.kC = null;
  this.q3 = null;
  this.o4 = null;
  this.tP = 0;
  this.tQ = 0;
  this.xR = 0;
  this.xS = 0;
  this.jE = id;
  this.n8 = name;
  this.uG = folder;
  this.ru = format;
  this.kC = text;
  this.q3 = binding;
  this.o4 = metadata;
  this.tP = createdAt_$_lo;
  this.tQ = createdAt_$_hi;
  this.xR = updatedAt_$_lo;
  this.xS = updatedAt_$_hi;
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_model_Diagram.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_model_Diagram;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_model_Diagram() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_model_Diagram.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, (-975435597));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.jE));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.n8));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.uG));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.ru));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.kC));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.q3));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.o4));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().jt(this.tP, this.tQ));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().jt(this.xR, this.xS));
  return $m_sr_Statics$().Z(acc, 9);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_gxcore_model_Diagram)) {
    var x_$_lo = this.tP;
    var x_$_hi = this.tQ;
    var $x_5 = x$0;
    var x$1_$_lo = $x_5.tP;
    var x$1_$_hi = $x_5.tQ;
    if ((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0)) {
      var x$2_$_lo = this.xR;
      var x$2_$_hi = this.xS;
      var $x_6 = x$0;
      var x$3_$_lo = $x_6.xR;
      var x$3_$_hi = $x_6.xS;
      var $x_4 = (((x$2_$_lo ^ x$3_$_lo) | (x$2_$_hi ^ x$3_$_hi)) === 0);
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$4 = this.jE;
      var x$2$1 = x$0.jE;
      var $x_3 = ((x$4 === null) ? (x$2$1 === null) : x$4.e(x$2$1));
    } else {
      var $x_3 = false;
    }
    if (($x_3 && (this.n8 === x$0.n8))) {
      var x$3$1 = this.uG;
      var x$4$1 = x$0.uG;
      var $x_2 = ((x$3$1 === null) ? (x$4$1 === null) : x$3$1.e(x$4$1));
    } else {
      var $x_2 = false;
    }
    if ((($x_2 && (this.ru === x$0.ru)) && (this.kC === x$0.kC))) {
      var x$5 = this.q3;
      var x$6 = x$0.q3;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$7 = this.o4;
      var x$8 = x$0.o4;
      return ((x$7 === null) ? (x$8 === null) : x$7.e(x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 9;
});
$p.B = (function() {
  return "Diagram";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.jE;
      break;
    }
    case 1: {
      return this.n8;
      break;
    }
    case 2: {
      return this.uG;
      break;
    }
    case 3: {
      return this.ru;
      break;
    }
    case 4: {
      return this.kC;
      break;
    }
    case 5: {
      return this.q3;
      break;
    }
    case 6: {
      return this.o4;
      break;
    }
    case 7: {
      return $bL(this.tP, this.tQ);
      break;
    }
    case 8: {
      return $bL(this.xR, this.xS);
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "id";
      break;
    }
    case 1: {
      return "name";
      break;
    }
    case 2: {
      return "folder";
      break;
    }
    case 3: {
      return "format";
      break;
    }
    case 4: {
      return "text";
      break;
    }
    case 5: {
      return "binding";
      break;
    }
    case 6: {
      return "metadata";
      break;
    }
    case 7: {
      return "createdAt";
      break;
    }
    case 8: {
      return "updatedAt";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_gxcore_model_Diagram(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gR)));
}
var $d_Lorg_jpablo_graphexplorer_gxcore_model_Diagram = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_model_Diagram, "org.jpablo.graphexplorer.gxcore.model.Diagram", ({
  gR: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId(value) {
  this.kD = null;
  this.kD = value;
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 1924880990, true);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId) && (this.kD === x$0.kD)));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "DiagramId";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.kD;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gS)));
}
var $d_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId, "org.jpablo.graphexplorer.gxcore.model.DiagramId", ({
  gS: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata(hiddenElements, collapsedGroups, tags, notes, autoDetectFormat) {
  this.wV = null;
  this.wU = null;
  this.wX = null;
  this.wW = null;
  this.wT = null;
  this.wV = hiddenElements;
  this.wU = collapsedGroups;
  this.wX = tags;
  this.wW = notes;
  this.wT = autoDetectFormat;
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 1208759783, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata)) {
    var x = this.wV;
    var x$2 = x$0.wV;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      var x$3 = this.wU;
      var x$4 = x$0.wU;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.wX;
      var x$6 = x$0.wX;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      var $x_1 = false;
    }
    if (($x_1 && (this.wW === x$0.wW))) {
      var x$7 = this.wT;
      var x$8 = x$0.wT;
      return ((x$7 === null) ? (x$8 === null) : x$7.e(x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 5;
});
$p.B = (function() {
  return "DiagramMetadata";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.wV;
      break;
    }
    case 1: {
      return this.wU;
      break;
    }
    case 2: {
      return this.wX;
      break;
    }
    case 3: {
      return this.wW;
      break;
    }
    case 4: {
      return this.wT;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "hiddenElements";
      break;
    }
    case 1: {
      return "collapsedGroups";
      break;
    }
    case 2: {
      return "tags";
      break;
    }
    case 3: {
      return "notes";
      break;
    }
    case 4: {
      return "autoDetectFormat";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gT)));
}
var $d_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata, "org.jpablo.graphexplorer.gxcore.model.DiagramMetadata", ({
  gT: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath(segments) {
  this.Lj = null;
  this.Lj = segments;
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-1708793581), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath)) {
    var x = this.Lj;
    var x$2 = x$0.Lj;
    return ((x === null) ? (x$2 === null) : x.e(x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "FolderPath";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Lj;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "segments";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gU)));
}
var $d_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath, "org.jpablo.graphexplorer.gxcore.model.FolderPath", ({
  gU: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_model_OriginSnapshot(text, hash, lineEnding) {
  this.Lk = null;
  this.BG = null;
  this.Sa = null;
  this.Lk = text;
  this.BG = hash;
  this.Sa = lineEnding;
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_model_OriginSnapshot.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_model_OriginSnapshot;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_model_OriginSnapshot() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_model_OriginSnapshot.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-939844542), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_gxcore_model_OriginSnapshot)) {
    if (((this.Lk === x$0.Lk) && (this.BG === x$0.BG))) {
      var x = this.Sa;
      var x$2 = x$0.Sa;
      return ((x === null) ? (x$2 === null) : (x === x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 3;
});
$p.B = (function() {
  return "OriginSnapshot";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.Lk;
      break;
    }
    case 1: {
      return this.BG;
      break;
    }
    case 2: {
      return this.Sa;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "text";
      break;
    }
    case 1: {
      return "hash";
      break;
    }
    case 2: {
      return "lineEnding";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_gxcore_model_OriginSnapshot(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gV)));
}
var $d_Lorg_jpablo_graphexplorer_gxcore_model_OriginSnapshot = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_model_OriginSnapshot, "org.jpablo.graphexplorer.gxcore.model.OriginSnapshot", ({
  gV: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_store_LocalStorageMigration$LegacyProject(id, name, lastModified_$_lo, lastModified_$_hi, createdAt_$_lo, createdAt_$_hi) {
  this.wY = null;
  this.Ll = null;
  this.It = 0;
  this.Iu = 0;
  this.Ir = 0;
  this.Is = 0;
  this.wY = id;
  this.Ll = name;
  this.It = lastModified_$_lo;
  this.Iu = lastModified_$_hi;
  this.Ir = createdAt_$_lo;
  this.Is = createdAt_$_hi;
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_store_LocalStorageMigration$LegacyProject.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_store_LocalStorageMigration$LegacyProject;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_store_LocalStorageMigration$LegacyProject() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_store_LocalStorageMigration$LegacyProject.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 276953840);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.wY));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Ll));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().jt(this.It, this.Iu));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().jt(this.Ir, this.Is));
  return $m_sr_Statics$().Z(acc, 4);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_gxcore_store_LocalStorageMigration$LegacyProject)) {
    var x_$_lo = this.It;
    var x_$_hi = this.Iu;
    var $x_2 = x$0;
    var x$1_$_lo = $x_2.It;
    var x$1_$_hi = $x_2.Iu;
    if ((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0)) {
      var x$2_$_lo = this.Ir;
      var x$2_$_hi = this.Is;
      var $x_3 = x$0;
      var x$3_$_lo = $x_3.Ir;
      var x$3_$_hi = $x_3.Is;
      var $x_1 = (((x$2_$_lo ^ x$3_$_lo) | (x$2_$_hi ^ x$3_$_hi)) === 0);
    } else {
      var $x_1 = false;
    }
    if (($x_1 && (this.wY === x$0.wY))) {
      return (this.Ll === x$0.Ll);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 4;
});
$p.B = (function() {
  return "LegacyProject";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.wY;
      break;
    }
    case 1: {
      return this.Ll;
      break;
    }
    case 2: {
      return $bL(this.It, this.Iu);
      break;
    }
    case 3: {
      return $bL(this.Ir, this.Is);
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "id";
      break;
    }
    case 1: {
      return "name";
      break;
    }
    case 2: {
      return "lastModified";
      break;
    }
    case 3: {
      return "createdAt";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_gxcore_store_LocalStorageMigration$LegacyProject(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.h2)));
}
var $d_Lorg_jpablo_graphexplorer_gxcore_store_LocalStorageMigration$LegacyProject = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_store_LocalStorageMigration$LegacyProject, "org.jpablo.graphexplorer.gxcore.store.LocalStorageMigration$LegacyProject", ({
  h2: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_store_MigrationReport(imported, skipped, failed) {
  this.zb = null;
  this.zc = null;
  this.za = null;
  this.zb = imported;
  this.zc = skipped;
  this.za = failed;
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_store_MigrationReport.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_store_MigrationReport;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_store_MigrationReport() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_store_MigrationReport.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 644636799, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_gxcore_store_MigrationReport)) {
    var x = this.zb;
    var x$2 = x$0.zb;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      var x$3 = this.zc;
      var x$4 = x$0.zc;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.za;
      var x$6 = x$0.za;
      return ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 3;
});
$p.B = (function() {
  return "MigrationReport";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.zb;
      break;
    }
    case 1: {
      return this.zc;
      break;
    }
    case 2: {
      return this.za;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "imported";
      break;
    }
    case 1: {
      return "skipped";
      break;
    }
    case 2: {
      return "failed";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_gxcore_store_MigrationReport(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.h3)));
}
var $d_Lorg_jpablo_graphexplorer_gxcore_store_MigrationReport = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_store_MigrationReport, "org.jpablo.graphexplorer.gxcore.store.MigrationReport", ({
  h3: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_projects_BoundRecord(id, text, binding) {
  this.wZ = null;
  this.Lm = null;
  this.Si = null;
  this.wZ = id;
  this.Lm = text;
  this.Si = binding;
}
$p = $c_Lorg_jpablo_graphexplorer_projects_BoundRecord.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_projects_BoundRecord;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_projects_BoundRecord() {
}
$h_Lorg_jpablo_graphexplorer_projects_BoundRecord.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 352460049, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_projects_BoundRecord)) {
    var x = this.wZ;
    var x$2 = x$0.wZ;
    if ((((x === null) ? (x$2 === null) : x.e(x$2)) && (this.Lm === x$0.Lm))) {
      var x$3 = this.Si;
      var x$4 = x$0.Si;
      return ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 3;
});
$p.B = (function() {
  return "BoundRecord";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.wZ;
      break;
    }
    case 1: {
      return this.Lm;
      break;
    }
    case 2: {
      return this.Si;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "id";
      break;
    }
    case 1: {
      return "text";
      break;
    }
    case 2: {
      return "binding";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_projects_BoundRecord(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.h4)));
}
var $d_Lorg_jpablo_graphexplorer_projects_BoundRecord = new $TypeData().i($c_Lorg_jpablo_graphexplorer_projects_BoundRecord, "org.jpablo.graphexplorer.projects.BoundRecord", ({
  h4: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_projects_LibraryMapping$Unparsed(hidden, collapsed) {
  this.Sk = null;
  this.Sj = null;
  this.Sk = hidden;
  this.Sj = collapsed;
}
$p = $c_Lorg_jpablo_graphexplorer_projects_LibraryMapping$Unparsed.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_projects_LibraryMapping$Unparsed;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_projects_LibraryMapping$Unparsed() {
}
$h_Lorg_jpablo_graphexplorer_projects_LibraryMapping$Unparsed.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 514745357, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_projects_LibraryMapping$Unparsed)) {
    var x = this.Sk;
    var x$2 = x$0.Sk;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      var x$3 = this.Sj;
      var x$4 = x$0.Sj;
      return ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "Unparsed";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Sk;
  }
  if ((n === 1)) {
    return this.Sj;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "hidden";
  }
  if ((n === 1)) {
    return "collapsed";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_projects_LibraryMapping$Unparsed(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.h6)));
}
var $d_Lorg_jpablo_graphexplorer_projects_LibraryMapping$Unparsed = new $TypeData().i($c_Lorg_jpablo_graphexplorer_projects_LibraryMapping$Unparsed, "org.jpablo.graphexplorer.projects.LibraryMapping$Unparsed", ({
  h6: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_projects_ProjectCardInfo(format, displayName, diagramKind) {
  this.FL = null;
  this.BI = null;
  this.Sl = null;
  this.FL = format;
  this.BI = displayName;
  this.Sl = diagramKind;
}
$p = $c_Lorg_jpablo_graphexplorer_projects_ProjectCardInfo.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_projects_ProjectCardInfo;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_projects_ProjectCardInfo() {
}
$h_Lorg_jpablo_graphexplorer_projects_ProjectCardInfo.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 921842760, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_projects_ProjectCardInfo)) {
    var x = this.FL;
    var x$2 = x$0.FL;
    if ((((x === null) ? (x$2 === null) : (x === x$2)) && (this.BI === x$0.BI))) {
      var x$3 = this.Sl;
      var x$4 = x$0.Sl;
      return ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 3;
});
$p.B = (function() {
  return "ProjectCardInfo";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.FL;
      break;
    }
    case 1: {
      return this.BI;
      break;
    }
    case 2: {
      return this.Sl;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "format";
      break;
    }
    case 1: {
      return "displayName";
      break;
    }
    case 2: {
      return "diagramKind";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_projects_ProjectCardInfo(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.h7)));
}
var $d_Lorg_jpablo_graphexplorer_projects_ProjectCardInfo = new $TypeData().i($c_Lorg_jpablo_graphexplorer_projects_ProjectCardInfo, "org.jpablo.graphexplorer.projects.ProjectCardInfo", ({
  h7: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_projects_ProjectInfo(id, name, lastModified_$_lo, lastModified_$_hi, createdAt_$_lo, createdAt_$_hi) {
  this.eG = null;
  this.nb = null;
  this.vP = 0;
  this.vQ = 0;
  this.ox = 0;
  this.oy = 0;
  this.eG = id;
  this.nb = name;
  this.vP = lastModified_$_lo;
  this.vQ = lastModified_$_hi;
  this.ox = createdAt_$_lo;
  this.oy = createdAt_$_hi;
}
$p = $c_Lorg_jpablo_graphexplorer_projects_ProjectInfo.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_projects_ProjectInfo;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_projects_ProjectInfo() {
}
$h_Lorg_jpablo_graphexplorer_projects_ProjectInfo.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 727684935);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.eG));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.nb));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().jt(this.vP, this.vQ));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().jt(this.ox, this.oy));
  return $m_sr_Statics$().Z(acc, 4);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_projects_ProjectInfo)) {
    var x_$_lo = this.vP;
    var x_$_hi = this.vQ;
    var $x_3 = x$0;
    var x$1_$_lo = $x_3.vP;
    var x$1_$_hi = $x_3.vQ;
    if ((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0)) {
      var x$2_$_lo = this.ox;
      var x$2_$_hi = this.oy;
      var $x_4 = x$0;
      var x$3_$_lo = $x_4.ox;
      var x$3_$_hi = $x_4.oy;
      var $x_2 = (((x$2_$_lo ^ x$3_$_lo) | (x$2_$_hi ^ x$3_$_hi)) === 0);
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$4 = this.eG;
      var x$2$1 = x$0.eG;
      var $x_1 = ((x$4 === null) ? (x$2$1 === null) : x$4.e(x$2$1));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return (this.nb === x$0.nb);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 4;
});
$p.B = (function() {
  return "ProjectInfo";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.eG;
      break;
    }
    case 1: {
      return this.nb;
      break;
    }
    case 2: {
      return $bL(this.vP, this.vQ);
      break;
    }
    case 3: {
      return $bL(this.ox, this.oy);
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "id";
      break;
    }
    case 1: {
      return "name";
      break;
    }
    case 2: {
      return "lastModified";
      break;
    }
    case 3: {
      return "createdAt";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_projects_ProjectInfo(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.h8)));
}
var $d_Lorg_jpablo_graphexplorer_projects_ProjectInfo = new $TypeData().i($c_Lorg_jpablo_graphexplorer_projects_ProjectInfo, "org.jpablo.graphexplorer.projects.ProjectInfo", ({
  h8: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory(projects) {
  this.hY = null;
  this.hY = projects;
}
$p = $c_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory() {
}
$h_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-1778834072), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory)) {
    var x = this.hY;
    var x$2 = x$0.hY;
    return ((x === null) ? (x$2 === null) : x.e(x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "ProjectsDirectory";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.hY;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "projects";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.h9)));
}
var $d_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory = new $TypeData().i($c_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory, "org.jpablo.graphexplorer.projects.ProjectsDirectory", ({
  h9: 1,
  b: 1,
  c: 1,
  a: 1
}));
function $p_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes__toKV__T__Lorg_jpablo_graphexplorer_viewer_models_AttrStatus__s_CanEqual__s_Option($thiz, attrId, status, x$3) {
  if ((status instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single)) {
    var x8 = status.nd;
    return new $c_s_Some(new $c_T2(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId(attrId), ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue($dp_toString__T(x8)))));
  } else {
    return $m_s_None$();
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes__styleTokens__Z__s_Option($thiz, dropDefaults) {
  if ($thiz.e($m_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes$().Sp)) {
    return $m_s_None$();
  } else {
    $m_scm_ArrayBuffer$();
    var parts = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
    if ($thiz.x1.Py(true, $m_s_CanEqual$derived$())) {
      parts.aw($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillStyle$().aAt);
    }
    if ($thiz.BK.Py(true, $m_s_CanEqual$derived$())) {
      parts.aw($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BoldStyle$().azh);
    }
    if ($thiz.BN.Py(true, $m_s_CanEqual$derived$())) {
      parts.aw($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_InvisibleStyle$().aBf);
    }
    matchResult5: {
      var x9 = $thiz.BM;
      if ((x9 instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single)) {
        var x12 = x9.nd;
        if ((!dropDefaults)) {
          var $x_1 = true;
        } else {
          var x$4 = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$().aa7;
          var $x_1 = (!((x12 === null) ? (x$4 === null) : (x12 === x$4)));
        }
        if ($x_1) {
          parts.aw(x12.m());
          break matchResult5;
        }
      }
    }
    matchResult6: {
      var x13 = $thiz.BL;
      if ((x13 instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single)) {
        var x16 = x13.nd;
        if ((!dropDefaults)) {
          var $x_2 = true;
        } else {
          var x$6 = $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$().a0F;
          var $x_2 = (!((x16 === null) ? (x$6 === null) : (x16 === x$6)));
        }
        if ($x_2) {
          parts.aw(x16.m());
          break matchResult6;
        }
      }
    }
    return ($f_sc_SeqOps__isEmpty__Z(parts) ? $m_s_None$() : new $c_s_Some($f_sc_IterableOnceOps__mkString__T__T__T__T(parts, "", ",", "")));
  }
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes(fill, bold, invisible, border, corner) {
  this.x1 = null;
  this.BK = null;
  this.BN = null;
  this.BL = null;
  this.BM = null;
  this.x1 = fill;
  this.BK = bold;
  this.BN = invisible;
  this.BL = border;
  this.BM = corner;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes() {
}
$h_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 1908966065, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes)) {
    var x = this.x1;
    var x$2 = x$0.x1;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      var x$3 = this.BK;
      var x$4 = x$0.BK;
      var $x_3 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$5 = this.BN;
      var x$6 = x$0.BN;
      var $x_2 = ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$7 = this.BL;
      var x$8 = x$0.BL;
      var $x_1 = ((x$7 === null) ? (x$8 === null) : x$7.e(x$8));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$9 = this.BM;
      var x$10 = x$0.BM;
      return ((x$9 === null) ? (x$10 === null) : x$9.e(x$10));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 5;
});
$p.B = (function() {
  return "StyleSubAttributes";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.x1;
      break;
    }
    case 1: {
      return this.BK;
      break;
    }
    case 2: {
      return this.BN;
      break;
    }
    case 3: {
      return this.BL;
      break;
    }
    case 4: {
      return this.BM;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "fill";
      break;
    }
    case 1: {
      return "bold";
      break;
    }
    case 2: {
      return "invisible";
      break;
    }
    case 3: {
      return "border";
      break;
    }
    case 4: {
      return "corner";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.aYD = (function(other) {
  $m_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes$();
  return new $c_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes(this.x1.XD(other.x1), this.BK.XD(other.BK), this.BN.XD(other.BN), this.BL.XD(other.BL), this.BM.XD(other.BM));
});
$p.b9Z = (function() {
  $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$();
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(new $c_sci_$colon$colon($p_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes__toKV__T__Lorg_jpablo_graphexplorer_viewer_models_AttrStatus__s_CanEqual__s_Option(this, $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_FillStyle$()), this.x1, $m_s_CanEqual$derived$()), new $c_sci_$colon$colon($p_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes__toKV__T__Lorg_jpablo_graphexplorer_viewer_models_AttrStatus__s_CanEqual__s_Option(this, $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BoldStyle$()), this.BK, $m_s_CanEqual$derived$()), new $c_sci_$colon$colon($p_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes__toKV__T__Lorg_jpablo_graphexplorer_viewer_models_AttrStatus__s_CanEqual__s_Option(this, $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_InvisibleStyle$()), this.BN, $m_s_CanEqual$derived$()), new $c_sci_$colon$colon($p_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes__toKV__T__Lorg_jpablo_graphexplorer_viewer_models_AttrStatus__s_CanEqual__s_Option(this, $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$()), this.BL, $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$().nx()), new $c_sci_$colon$colon($p_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes__toKV__T__Lorg_jpablo_graphexplorer_viewer_models_AttrStatus__s_CanEqual__s_Option(this, $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$()), this.BM, $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$().nx()), $m_sci_Nil$()))))), $m_s_$less$colon$less$().b1).eX($m_s_$less$colon$less$().b1);
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.he)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_attributes_styleSubAttributes_StyleSubAttributes, "org.jpablo.graphexplorer.viewer.attributes.styleSubAttributes.StyleSubAttributes", ({
  he: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_DiagramLanguageInfo(selectorLabel, editorPlaceholder, documentationUrl, documentationTitle) {
  this.FP = null;
  this.Ss = null;
  this.Sr = null;
  this.Sq = null;
  this.FP = selectorLabel;
  this.Ss = editorPlaceholder;
  this.Sr = documentationUrl;
  this.Sq = documentationTitle;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_DiagramLanguageInfo.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_DiagramLanguageInfo;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_DiagramLanguageInfo() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_DiagramLanguageInfo.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 1010372342, true);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_backends_DiagramLanguageInfo) && ((((this.FP === x$0.FP) && (this.Ss === x$0.Ss)) && (this.Sr === x$0.Sr)) && (this.Sq === x$0.Sq))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 4;
});
$p.B = (function() {
  return "DiagramLanguageInfo";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.FP;
      break;
    }
    case 1: {
      return this.Ss;
      break;
    }
    case 2: {
      return this.Sr;
      break;
    }
    case 3: {
      return this.Sq;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "selectorLabel";
      break;
    }
    case 1: {
      return "editorPlaceholder";
      break;
    }
    case 2: {
      return "documentationUrl";
      break;
    }
    case 3: {
      return "documentationTitle";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_backends_DiagramLanguageInfo(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hh)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_backends_DiagramLanguageInfo = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_DiagramLanguageInfo, "org.jpablo.graphexplorer.viewer.backends.DiagramLanguageInfo", ({
  hh: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_DiagramRenderInputs(visibleText, sourceText, viewDiffersFromSource) {
  this.Lo = null;
  this.St = null;
  this.Su = null;
  this.Lo = visibleText;
  this.St = sourceText;
  this.Su = viewDiffersFromSource;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_DiagramRenderInputs.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_DiagramRenderInputs;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_DiagramRenderInputs() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_DiagramRenderInputs.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-1716484600), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_backends_DiagramRenderInputs)) {
    var x = this.Lo;
    var x$2 = x$0.Lo;
    if (((x === null) ? (x$2 === null) : (x === x$2))) {
      var x$3 = this.St;
      var x$4 = x$0.St;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : (x$3 === x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Su;
      var x$6 = x$0.Su;
      return ((x$5 === null) ? (x$6 === null) : (x$5 === x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 3;
});
$p.B = (function() {
  return "DiagramRenderInputs";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.Lo;
      break;
    }
    case 1: {
      return this.St;
      break;
    }
    case 2: {
      return this.Su;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "visibleText";
      break;
    }
    case 1: {
      return "sourceText";
      break;
    }
    case 2: {
      return "viewDiffersFromSource";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_backends_DiagramRenderInputs(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hi)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_backends_DiagramRenderInputs = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_DiagramRenderInputs, "org.jpablo.graphexplorer.viewer.backends.DiagramRenderInputs", ({
  hi: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_PastedDiagram(source, format, declared) {
  this.Lq = null;
  this.FQ = null;
  this.Lp = false;
  this.Lq = source;
  this.FQ = format;
  this.Lp = declared;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_PastedDiagram.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_PastedDiagram;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_PastedDiagram() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_PastedDiagram.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, (-535389374));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Lq));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.FQ));
  acc = $m_sr_Statics$().k(acc, (this.Lp ? 1231 : 1237));
  return $m_sr_Statics$().Z(acc, 3);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_backends_PastedDiagram)) {
    if (((this.Lp === x$0.Lp) && (this.Lq === x$0.Lq))) {
      var x = this.FQ;
      var x$2 = x$0.FQ;
      return ((x === null) ? (x$2 === null) : (x === x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 3;
});
$p.B = (function() {
  return "PastedDiagram";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.Lq;
      break;
    }
    case 1: {
      return this.FQ;
      break;
    }
    case 2: {
      return this.Lp;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "source";
      break;
    }
    case 1: {
      return "format";
      break;
    }
    case 2: {
      return "declared";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_backends_PastedDiagram(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hj)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_backends_PastedDiagram = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_PastedDiagram, "org.jpablo.graphexplorer.viewer.backends.PastedDiagram", ({
  hj: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ExampleSource(path, format) {
  this.q4 = null;
  this.Sx = null;
  this.q4 = path;
  this.Sx = format;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ExampleSource.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ExampleSource;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ExampleSource() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ExampleSource.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 389632367, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ExampleSource)) {
    if ((this.q4 === x$0.q4)) {
      var x = this.Sx;
      var x$2 = x$0.Sx;
      return ((x === null) ? (x$2 === null) : (x === x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "ExampleSource";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.q4;
  }
  if ((n === 1)) {
    return this.Sx;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "path";
  }
  if ((n === 1)) {
    return "format";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ExampleSource(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hl)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ExampleSource = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotExamples$ExampleSource, "org.jpablo.graphexplorer.viewer.backends.graphviz.DotExamples$ExampleSource", ({
  hl: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$Scan(depth, inGraphAttrs, title) {
  this.BP = 0;
  this.FR = false;
  this.FS = null;
  this.BP = depth;
  this.FR = inGraphAttrs;
  this.FS = title;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$Scan.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$Scan;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$Scan() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$Scan.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 2570909);
  acc = $m_sr_Statics$().k(acc, this.BP);
  acc = $m_sr_Statics$().k(acc, (this.FR ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.FS));
  return $m_sr_Statics$().Z(acc, 3);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$Scan)) {
    if (((this.BP === x$0.BP) && (this.FR === x$0.FR))) {
      var x = this.FS;
      var x$2 = x$0.FS;
      return ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 3;
});
$p.B = (function() {
  return "Scan";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.BP;
      break;
    }
    case 1: {
      return this.FR;
      break;
    }
    case 2: {
      return this.FS;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "depth";
      break;
    }
    case 1: {
      return "inGraphAttrs";
      break;
    }
    case 2: {
      return "title";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.b4O = (function(line) {
  var opensGraphAttrs = ((this.BP === 0) && $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$().b5G(line));
  if ((this.BP === 0)) {
    matchResult6: {
      var candidate;
      if ((line !== null)) {
        var x14 = $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$().a8B.jw(line);
        if ((!x14.c())) {
          var x15 = x14.d();
          if ((x15.bL(1) === 0)) {
            var candidate = new $c_s_Some($f_sc_LinearSeqOps__apply__I__O(x15, 0));
            break matchResult6;
          }
        }
      }
      if (opensGraphAttrs) {
        var this$2 = $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$().avD.afR(line);
        var candidate = (this$2.c() ? $m_s_None$() : new $c_s_Some($f_s_util_matching_Regex$MatchData__group__I__T(this$2.d(), 1)));
        break matchResult6;
      }
      var candidate = $m_s_None$();
    }
  } else if (this.FR) {
    matchResult7: {
      var candidate;
      if ((line !== null)) {
        var x18 = $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$().a8B.jw(line);
        if ((!x18.c())) {
          var x19 = x18.d();
          if ((x19.bL(1) === 0)) {
            var candidate = new $c_s_Some($f_sc_LinearSeqOps__apply__I__O(x19, 0));
            break matchResult7;
          }
        }
      }
      var candidate = $m_s_None$();
    }
  } else {
    var candidate = $m_s_None$();
  }
  var that = ((this.BP + $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$().b5F(line)) | 0);
  var newDepth = ((that < 0) ? 0 : that);
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$Scan$();
  var inGraphAttrs = ((newDepth > 0) && (this.FR || opensGraphAttrs));
  var this$8 = this.FS;
  if (this$8.c()) {
    var this$9 = (candidate.c() ? $m_s_None$() : new $c_s_Some($f_T__trim__T(candidate.d())));
    var $x_1 = ((this$9.c() || (this$9.d() !== "")) ? this$9 : $m_s_None$());
  } else {
    var $x_1 = this$8;
  }
  return new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$Scan(newDepth, inGraphAttrs, $x_1);
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$Scan(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hm)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$Scan = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$Scan, "org.jpablo.graphexplorer.viewer.backends.graphviz.DotSourceScan$Scan", ({
  hm: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_RenderOutputs(status, output, errors) {
  this.ze = null;
  this.BR = null;
  this.BQ = null;
  this.ze = status;
  this.BR = output;
  this.BQ = errors;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_RenderOutputs.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_RenderOutputs;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_RenderOutputs() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_RenderOutputs.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-1903679248), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_RenderOutputs)) {
    if ((this.ze === x$0.ze)) {
      var x = this.BR;
      var x$2 = x$0.BR;
      var $x_1 = ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return (this.BQ === x$0.BQ);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 3;
});
$p.B = (function() {
  return "RenderOutputs";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.ze;
      break;
    }
    case 1: {
      return this.BR;
      break;
    }
    case 2: {
      return this.BQ;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "status";
      break;
    }
    case 1: {
      return "output";
      break;
    }
    case 2: {
      return "errors";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_RenderOutputs(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hn)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_RenderOutputs = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_RenderOutputs, "org.jpablo.graphexplorer.viewer.backends.graphviz.RenderOutputs", ({
  hn: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_SvgWithPositions(svg, edgePositions) {
  this.Lr = null;
  this.Sy = null;
  this.Lr = svg;
  this.Sy = edgePositions;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_SvgWithPositions.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_SvgWithPositions;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_SvgWithPositions() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_SvgWithPositions.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-55803246), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_SvgWithPositions)) {
    var x = this.Lr;
    var x$2 = x$0.Lr;
    if (((x === null) ? (x$2 === null) : (x === x$2))) {
      var x$3 = this.Sy;
      var x$4 = x$0.Sy;
      return ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "SvgWithPositions";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Lr;
  }
  if ((n === 1)) {
    return this.Sy;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "svg";
  }
  if ((n === 1)) {
    return "edgePositions";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_SvgWithPositions(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ho)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_SvgWithPositions = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_SvgWithPositions, "org.jpablo.graphexplorer.viewer.backends.graphviz.SvgWithPositions", ({
  ho: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ArrowPosition(startPoint, endPoint, controlPoints) {
  this.Ls = null;
  this.FT = null;
  this.Sz = null;
  this.Ls = startPoint;
  this.FT = endPoint;
  this.Sz = controlPoints;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ArrowPosition.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ArrowPosition;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ArrowPosition() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ArrowPosition.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 270570947, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ArrowPosition)) {
    var x = this.Ls;
    var x$2 = x$0.Ls;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      var x$3 = this.FT;
      var x$4 = x$0.FT;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Sz;
      var x$6 = x$0.Sz;
      return ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 3;
});
$p.B = (function() {
  return "ArrowPosition";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.Ls;
      break;
    }
    case 1: {
      return this.FT;
      break;
    }
    case 2: {
      return this.Sz;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "startPoint";
      break;
    }
    case 1: {
      return "endPoint";
      break;
    }
    case 2: {
      return "controlPoints";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ArrowPosition(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hp)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ArrowPosition = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ArrowPosition, "org.jpablo.graphexplorer.viewer.backends.graphviz.vizjs.simplegraph.ArrowPosition", ({
  hp: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_Point(x, y) {
  this.BS = 0.0;
  this.BT = 0.0;
  this.BS = x;
  this.BT = y;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_Point.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_Point;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_Point() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_Point.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 77292912);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.BS));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.BT));
  return $m_sr_Statics$().Z(acc, 2);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_Point) && ((this.BS === x$0.BS) && (this.BT === x$0.BT))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "Point";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.BS;
  }
  if ((n === 1)) {
    return this.BT;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "x";
  }
  if ((n === 1)) {
    return "y";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_Point(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hq)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_Point = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_Point, "org.jpablo.graphexplorer.viewer.backends.graphviz.vizjs.simplegraph.Point", ({
  hq: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph(name, directed, objects, edges, fontname, fontsize, label, labelloc, lp, lheight, lwidth, rankdir, layout, bgcolor, nodesep, pad, ranksep, ratio, splines, overlap, normalize, start, beautify, Damping, defaultdist, dim, dimen, diredgeconstraints, dpi, epsilon, esep, fontnames, fontpath, K, label_scheme, labeljust, landscape, layerlistsep, layers, layerselect, layersep, nojustify, notranslate, target, TBbalance, tooltip, truecolor, URL, extraAttrs) {
  this.zf = null;
  this.rw = false;
  this.o5 = null;
  this.q5 = null;
  this.ry = null;
  this.rz = null;
  this.rA = null;
  this.rB = null;
  this.rE = null;
  this.rD = null;
  this.rF = null;
  this.rK = null;
  this.rC = null;
  this.rv = null;
  this.rG = null;
  this.rJ = null;
  this.rL = null;
  this.rM = null;
  this.rN = null;
  this.rI = null;
  this.rH = null;
  this.rO = null;
  this.uM = null;
  this.uI = null;
  this.uN = null;
  this.uO = null;
  this.uP = null;
  this.uQ = null;
  this.uR = null;
  this.uS = null;
  this.uT = null;
  this.uU = null;
  this.uV = null;
  this.uJ = null;
  this.uW = null;
  this.uX = null;
  this.uY = null;
  this.uZ = null;
  this.v0 = null;
  this.v1 = null;
  this.v2 = null;
  this.v3 = null;
  this.v4 = null;
  this.v5 = null;
  this.uK = null;
  this.v6 = null;
  this.v7 = null;
  this.uL = null;
  this.rx = null;
  this.zf = name;
  this.rw = directed;
  this.o5 = objects;
  this.q5 = edges;
  this.ry = fontname;
  this.rz = fontsize;
  this.rA = label;
  this.rB = labelloc;
  this.rE = lp;
  this.rD = lheight;
  this.rF = lwidth;
  this.rK = rankdir;
  this.rC = layout;
  this.rv = bgcolor;
  this.rG = nodesep;
  this.rJ = pad;
  this.rL = ranksep;
  this.rM = ratio;
  this.rN = splines;
  this.rI = overlap;
  this.rH = normalize;
  this.rO = start;
  this.uM = beautify;
  this.uI = Damping;
  this.uN = defaultdist;
  this.uO = dim;
  this.uP = dimen;
  this.uQ = diredgeconstraints;
  this.uR = dpi;
  this.uS = epsilon;
  this.uT = esep;
  this.uU = fontnames;
  this.uV = fontpath;
  this.uJ = K;
  this.uW = label_scheme;
  this.uX = labeljust;
  this.uY = landscape;
  this.uZ = layerlistsep;
  this.v0 = layers;
  this.v1 = layerselect;
  this.v2 = layersep;
  this.v3 = nojustify;
  this.v4 = notranslate;
  this.v5 = target;
  this.uK = TBbalance;
  this.v6 = tooltip;
  this.v7 = truecolor;
  this.uL = URL;
  this.rx = extraAttrs;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 226789020);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.zf));
  acc = $m_sr_Statics$().k(acc, (this.rw ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.o5));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.q5));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.ry));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.rz));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.rA));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.rB));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.rE));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.rD));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.rF));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.rK));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.rC));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.rv));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.rG));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.rJ));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.rL));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.rM));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.rN));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.rI));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.rH));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.rO));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.uM));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.uI));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.uN));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.uO));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.uP));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.uQ));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.uR));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.uS));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.uT));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.uU));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.uV));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.uJ));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.uW));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.uX));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.uY));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.uZ));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.v0));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.v1));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.v2));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.v3));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.v4));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.v5));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.uK));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.v6));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.v7));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.uL));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.rx));
  return $m_sr_Statics$().Z(acc, 49);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph)) {
    if (((this.rw === x$0.rw) && (this.zf === x$0.zf))) {
      var x = this.o5;
      var x$2 = x$0.o5;
      var $x_46 = ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      var $x_46 = false;
    }
    if ($x_46) {
      var x$3 = this.q5;
      var x$4 = x$0.q5;
      var $x_45 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_45 = false;
    }
    if ($x_45) {
      var x$5 = this.ry;
      var x$6 = x$0.ry;
      var $x_44 = ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      var $x_44 = false;
    }
    if ($x_44) {
      var x$7 = this.rz;
      var x$8 = x$0.rz;
      var $x_43 = ((x$7 === null) ? (x$8 === null) : x$7.e(x$8));
    } else {
      var $x_43 = false;
    }
    if ($x_43) {
      var x$9 = this.rA;
      var x$10 = x$0.rA;
      var $x_42 = ((x$9 === null) ? (x$10 === null) : x$9.e(x$10));
    } else {
      var $x_42 = false;
    }
    if ($x_42) {
      var x$11 = this.rB;
      var x$12 = x$0.rB;
      var $x_41 = ((x$11 === null) ? (x$12 === null) : x$11.e(x$12));
    } else {
      var $x_41 = false;
    }
    if ($x_41) {
      var x$13 = this.rE;
      var x$14 = x$0.rE;
      var $x_40 = ((x$13 === null) ? (x$14 === null) : x$13.e(x$14));
    } else {
      var $x_40 = false;
    }
    if ($x_40) {
      var x$15 = this.rD;
      var x$16 = x$0.rD;
      var $x_39 = ((x$15 === null) ? (x$16 === null) : x$15.e(x$16));
    } else {
      var $x_39 = false;
    }
    if ($x_39) {
      var x$17 = this.rF;
      var x$18 = x$0.rF;
      var $x_38 = ((x$17 === null) ? (x$18 === null) : x$17.e(x$18));
    } else {
      var $x_38 = false;
    }
    if ($x_38) {
      var x$19 = this.rK;
      var x$20 = x$0.rK;
      var $x_37 = ((x$19 === null) ? (x$20 === null) : x$19.e(x$20));
    } else {
      var $x_37 = false;
    }
    if ($x_37) {
      var x$21 = this.rC;
      var x$22 = x$0.rC;
      var $x_36 = ((x$21 === null) ? (x$22 === null) : x$21.e(x$22));
    } else {
      var $x_36 = false;
    }
    if ($x_36) {
      var x$23 = this.rv;
      var x$24 = x$0.rv;
      var $x_35 = ((x$23 === null) ? (x$24 === null) : x$23.e(x$24));
    } else {
      var $x_35 = false;
    }
    if ($x_35) {
      var x$25 = this.rG;
      var x$26 = x$0.rG;
      var $x_34 = ((x$25 === null) ? (x$26 === null) : x$25.e(x$26));
    } else {
      var $x_34 = false;
    }
    if ($x_34) {
      var x$27 = this.rJ;
      var x$28 = x$0.rJ;
      var $x_33 = ((x$27 === null) ? (x$28 === null) : x$27.e(x$28));
    } else {
      var $x_33 = false;
    }
    if ($x_33) {
      var x$29 = this.rL;
      var x$30 = x$0.rL;
      var $x_32 = ((x$29 === null) ? (x$30 === null) : x$29.e(x$30));
    } else {
      var $x_32 = false;
    }
    if ($x_32) {
      var x$31 = this.rM;
      var x$32 = x$0.rM;
      var $x_31 = ((x$31 === null) ? (x$32 === null) : x$31.e(x$32));
    } else {
      var $x_31 = false;
    }
    if ($x_31) {
      var x$33 = this.rN;
      var x$34 = x$0.rN;
      var $x_30 = ((x$33 === null) ? (x$34 === null) : x$33.e(x$34));
    } else {
      var $x_30 = false;
    }
    if ($x_30) {
      var x$35 = this.rI;
      var x$36 = x$0.rI;
      var $x_29 = ((x$35 === null) ? (x$36 === null) : x$35.e(x$36));
    } else {
      var $x_29 = false;
    }
    if ($x_29) {
      var x$37 = this.rH;
      var x$38 = x$0.rH;
      var $x_28 = ((x$37 === null) ? (x$38 === null) : x$37.e(x$38));
    } else {
      var $x_28 = false;
    }
    if ($x_28) {
      var x$39 = this.rO;
      var x$40 = x$0.rO;
      var $x_27 = ((x$39 === null) ? (x$40 === null) : x$39.e(x$40));
    } else {
      var $x_27 = false;
    }
    if ($x_27) {
      var x$41 = this.uM;
      var x$42 = x$0.uM;
      var $x_26 = ((x$41 === null) ? (x$42 === null) : x$41.e(x$42));
    } else {
      var $x_26 = false;
    }
    if ($x_26) {
      var x$43 = this.uI;
      var x$44 = x$0.uI;
      var $x_25 = ((x$43 === null) ? (x$44 === null) : x$43.e(x$44));
    } else {
      var $x_25 = false;
    }
    if ($x_25) {
      var x$45 = this.uN;
      var x$46 = x$0.uN;
      var $x_24 = ((x$45 === null) ? (x$46 === null) : x$45.e(x$46));
    } else {
      var $x_24 = false;
    }
    if ($x_24) {
      var x$47 = this.uO;
      var x$48 = x$0.uO;
      var $x_23 = ((x$47 === null) ? (x$48 === null) : x$47.e(x$48));
    } else {
      var $x_23 = false;
    }
    if ($x_23) {
      var x$49 = this.uP;
      var x$50 = x$0.uP;
      var $x_22 = ((x$49 === null) ? (x$50 === null) : x$49.e(x$50));
    } else {
      var $x_22 = false;
    }
    if ($x_22) {
      var x$51 = this.uQ;
      var x$52 = x$0.uQ;
      var $x_21 = ((x$51 === null) ? (x$52 === null) : x$51.e(x$52));
    } else {
      var $x_21 = false;
    }
    if ($x_21) {
      var x$53 = this.uR;
      var x$54 = x$0.uR;
      var $x_20 = ((x$53 === null) ? (x$54 === null) : x$53.e(x$54));
    } else {
      var $x_20 = false;
    }
    if ($x_20) {
      var x$55 = this.uS;
      var x$56 = x$0.uS;
      var $x_19 = ((x$55 === null) ? (x$56 === null) : x$55.e(x$56));
    } else {
      var $x_19 = false;
    }
    if ($x_19) {
      var x$57 = this.uT;
      var x$58 = x$0.uT;
      var $x_18 = ((x$57 === null) ? (x$58 === null) : x$57.e(x$58));
    } else {
      var $x_18 = false;
    }
    if ($x_18) {
      var x$59 = this.uU;
      var x$60 = x$0.uU;
      var $x_17 = ((x$59 === null) ? (x$60 === null) : x$59.e(x$60));
    } else {
      var $x_17 = false;
    }
    if ($x_17) {
      var x$61 = this.uV;
      var x$62 = x$0.uV;
      var $x_16 = ((x$61 === null) ? (x$62 === null) : x$61.e(x$62));
    } else {
      var $x_16 = false;
    }
    if ($x_16) {
      var x$63 = this.uJ;
      var x$64 = x$0.uJ;
      var $x_15 = ((x$63 === null) ? (x$64 === null) : x$63.e(x$64));
    } else {
      var $x_15 = false;
    }
    if ($x_15) {
      var x$65 = this.uW;
      var x$66 = x$0.uW;
      var $x_14 = ((x$65 === null) ? (x$66 === null) : x$65.e(x$66));
    } else {
      var $x_14 = false;
    }
    if ($x_14) {
      var x$67 = this.uX;
      var x$68 = x$0.uX;
      var $x_13 = ((x$67 === null) ? (x$68 === null) : x$67.e(x$68));
    } else {
      var $x_13 = false;
    }
    if ($x_13) {
      var x$69 = this.uY;
      var x$70 = x$0.uY;
      var $x_12 = ((x$69 === null) ? (x$70 === null) : x$69.e(x$70));
    } else {
      var $x_12 = false;
    }
    if ($x_12) {
      var x$71 = this.uZ;
      var x$72 = x$0.uZ;
      var $x_11 = ((x$71 === null) ? (x$72 === null) : x$71.e(x$72));
    } else {
      var $x_11 = false;
    }
    if ($x_11) {
      var x$73 = this.v0;
      var x$74 = x$0.v0;
      var $x_10 = ((x$73 === null) ? (x$74 === null) : x$73.e(x$74));
    } else {
      var $x_10 = false;
    }
    if ($x_10) {
      var x$75 = this.v1;
      var x$76 = x$0.v1;
      var $x_9 = ((x$75 === null) ? (x$76 === null) : x$75.e(x$76));
    } else {
      var $x_9 = false;
    }
    if ($x_9) {
      var x$77 = this.v2;
      var x$78 = x$0.v2;
      var $x_8 = ((x$77 === null) ? (x$78 === null) : x$77.e(x$78));
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$79 = this.v3;
      var x$80 = x$0.v3;
      var $x_7 = ((x$79 === null) ? (x$80 === null) : x$79.e(x$80));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$81 = this.v4;
      var x$82 = x$0.v4;
      var $x_6 = ((x$81 === null) ? (x$82 === null) : x$81.e(x$82));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$83 = this.v5;
      var x$84 = x$0.v5;
      var $x_5 = ((x$83 === null) ? (x$84 === null) : x$83.e(x$84));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$85 = this.uK;
      var x$86 = x$0.uK;
      var $x_4 = ((x$85 === null) ? (x$86 === null) : x$85.e(x$86));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$87 = this.v6;
      var x$88 = x$0.v6;
      var $x_3 = ((x$87 === null) ? (x$88 === null) : x$87.e(x$88));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$89 = this.v7;
      var x$90 = x$0.v7;
      var $x_2 = ((x$89 === null) ? (x$90 === null) : x$89.e(x$90));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$91 = this.uL;
      var x$92 = x$0.uL;
      var $x_1 = ((x$91 === null) ? (x$92 === null) : x$91.e(x$92));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$93 = this.rx;
      var x$94 = x$0.rx;
      return ((x$93 === null) ? (x$94 === null) : x$93.e(x$94));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 49;
});
$p.B = (function() {
  return "SimpleGraph";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.zf;
      break;
    }
    case 1: {
      return this.rw;
      break;
    }
    case 2: {
      return this.o5;
      break;
    }
    case 3: {
      return this.q5;
      break;
    }
    case 4: {
      return this.ry;
      break;
    }
    case 5: {
      return this.rz;
      break;
    }
    case 6: {
      return this.rA;
      break;
    }
    case 7: {
      return this.rB;
      break;
    }
    case 8: {
      return this.rE;
      break;
    }
    case 9: {
      return this.rD;
      break;
    }
    case 10: {
      return this.rF;
      break;
    }
    case 11: {
      return this.rK;
      break;
    }
    case 12: {
      return this.rC;
      break;
    }
    case 13: {
      return this.rv;
      break;
    }
    case 14: {
      return this.rG;
      break;
    }
    case 15: {
      return this.rJ;
      break;
    }
    case 16: {
      return this.rL;
      break;
    }
    case 17: {
      return this.rM;
      break;
    }
    case 18: {
      return this.rN;
      break;
    }
    case 19: {
      return this.rI;
      break;
    }
    case 20: {
      return this.rH;
      break;
    }
    case 21: {
      return this.rO;
      break;
    }
    case 22: {
      return this.uM;
      break;
    }
    case 23: {
      return this.uI;
      break;
    }
    case 24: {
      return this.uN;
      break;
    }
    case 25: {
      return this.uO;
      break;
    }
    case 26: {
      return this.uP;
      break;
    }
    case 27: {
      return this.uQ;
      break;
    }
    case 28: {
      return this.uR;
      break;
    }
    case 29: {
      return this.uS;
      break;
    }
    case 30: {
      return this.uT;
      break;
    }
    case 31: {
      return this.uU;
      break;
    }
    case 32: {
      return this.uV;
      break;
    }
    case 33: {
      return this.uJ;
      break;
    }
    case 34: {
      return this.uW;
      break;
    }
    case 35: {
      return this.uX;
      break;
    }
    case 36: {
      return this.uY;
      break;
    }
    case 37: {
      return this.uZ;
      break;
    }
    case 38: {
      return this.v0;
      break;
    }
    case 39: {
      return this.v1;
      break;
    }
    case 40: {
      return this.v2;
      break;
    }
    case 41: {
      return this.v3;
      break;
    }
    case 42: {
      return this.v4;
      break;
    }
    case 43: {
      return this.v5;
      break;
    }
    case 44: {
      return this.uK;
      break;
    }
    case 45: {
      return this.v6;
      break;
    }
    case 46: {
      return this.v7;
      break;
    }
    case 47: {
      return this.uL;
      break;
    }
    case 48: {
      return this.rx;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "name";
      break;
    }
    case 1: {
      return "directed";
      break;
    }
    case 2: {
      return "objects";
      break;
    }
    case 3: {
      return "edges";
      break;
    }
    case 4: {
      return "fontname";
      break;
    }
    case 5: {
      return "fontsize";
      break;
    }
    case 6: {
      return "label";
      break;
    }
    case 7: {
      return "labelloc";
      break;
    }
    case 8: {
      return "lp";
      break;
    }
    case 9: {
      return "lheight";
      break;
    }
    case 10: {
      return "lwidth";
      break;
    }
    case 11: {
      return "rankdir";
      break;
    }
    case 12: {
      return "layout";
      break;
    }
    case 13: {
      return "bgcolor";
      break;
    }
    case 14: {
      return "nodesep";
      break;
    }
    case 15: {
      return "pad";
      break;
    }
    case 16: {
      return "ranksep";
      break;
    }
    case 17: {
      return "ratio";
      break;
    }
    case 18: {
      return "splines";
      break;
    }
    case 19: {
      return "overlap";
      break;
    }
    case 20: {
      return "normalize";
      break;
    }
    case 21: {
      return "start";
      break;
    }
    case 22: {
      return "beautify";
      break;
    }
    case 23: {
      return "Damping";
      break;
    }
    case 24: {
      return "defaultdist";
      break;
    }
    case 25: {
      return "dim";
      break;
    }
    case 26: {
      return "dimen";
      break;
    }
    case 27: {
      return "diredgeconstraints";
      break;
    }
    case 28: {
      return "dpi";
      break;
    }
    case 29: {
      return "epsilon";
      break;
    }
    case 30: {
      return "esep";
      break;
    }
    case 31: {
      return "fontnames";
      break;
    }
    case 32: {
      return "fontpath";
      break;
    }
    case 33: {
      return "K";
      break;
    }
    case 34: {
      return "label_scheme";
      break;
    }
    case 35: {
      return "labeljust";
      break;
    }
    case 36: {
      return "landscape";
      break;
    }
    case 37: {
      return "layerlistsep";
      break;
    }
    case 38: {
      return "layers";
      break;
    }
    case 39: {
      return "layerselect";
      break;
    }
    case 40: {
      return "layersep";
      break;
    }
    case 41: {
      return "nojustify";
      break;
    }
    case 42: {
      return "notranslate";
      break;
    }
    case 43: {
      return "target";
      break;
    }
    case 44: {
      return "TBbalance";
      break;
    }
    case 45: {
      return "tooltip";
      break;
    }
    case 46: {
      return "truecolor";
      break;
    }
    case 47: {
      return "URL";
      break;
    }
    case 48: {
      return "extraAttrs";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.aQu = (function() {
  var x55 = this.o5;
  if ((x55 instanceof $c_s_Some)) {
    return x55.J.Ag(new $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$$anon$8());
  }
  if (($m_s_None$() === x55)) {
    return $m_sci_Nil$();
  }
  throw new $c_s_MatchError(x55);
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hr)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph, "org.jpablo.graphexplorer.viewer.backends.graphviz.vizjs.simplegraph.SimpleGraph", ({
  hr: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphCluster(_gvid, name, nodes, label, edges, subgraphs, fontname, fontsize, fontcolor, color, pencolor, penwidth, bgcolor, fillcolor, style, labeljust, labelloc, lheight, lp, lwidth, layout, normalize, start, overlap, cluster, rankdir, rank, splines, target, tooltip, URL, class$1, colorscheme, extraAttrs) {
  this.v8 = 0;
  this.p1 = null;
  this.q7 = null;
  this.s0 = null;
  this.q6 = null;
  this.q8 = null;
  this.rY = null;
  this.rZ = null;
  this.rX = null;
  this.rT = null;
  this.s8 = null;
  this.s9 = null;
  this.rQ = null;
  this.rW = null;
  this.sd = null;
  this.s1 = null;
  this.s2 = null;
  this.s3 = null;
  this.s4 = null;
  this.s5 = null;
  this.v9 = null;
  this.s6 = null;
  this.sc = null;
  this.s7 = null;
  this.rS = null;
  this.va = null;
  this.sa = null;
  this.sb = null;
  this.se = null;
  this.sf = null;
  this.rP = null;
  this.rR = null;
  this.rU = null;
  this.rV = null;
  this.v8 = _gvid;
  this.p1 = name;
  this.q7 = nodes;
  this.s0 = label;
  this.q6 = edges;
  this.q8 = subgraphs;
  this.rY = fontname;
  this.rZ = fontsize;
  this.rX = fontcolor;
  this.rT = color;
  this.s8 = pencolor;
  this.s9 = penwidth;
  this.rQ = bgcolor;
  this.rW = fillcolor;
  this.sd = style;
  this.s1 = labeljust;
  this.s2 = labelloc;
  this.s3 = lheight;
  this.s4 = lp;
  this.s5 = lwidth;
  this.v9 = layout;
  this.s6 = normalize;
  this.sc = start;
  this.s7 = overlap;
  this.rS = cluster;
  this.va = rankdir;
  this.sa = rank;
  this.sb = splines;
  this.se = target;
  this.sf = tooltip;
  this.rP = URL;
  this.rR = class$1;
  this.rU = colorscheme;
  this.rV = extraAttrs;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphCluster.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphCluster;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphCluster() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphCluster.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 937671614);
  acc = $m_sr_Statics$().k(acc, this.v8);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.p1));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.q7));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.s0));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.q6));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.q8));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.rY));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.rZ));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.rX));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.rT));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.s8));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.s9));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.rQ));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.rW));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.sd));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.s1));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.s2));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.s3));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.s4));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.s5));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.v9));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.s6));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.sc));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.s7));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.rS));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.va));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.sa));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.sb));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.se));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.sf));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.rP));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.rR));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.rU));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.rV));
  return $m_sr_Statics$().Z(acc, 34);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphCluster)) {
    if (((this.v8 === x$0.v8) && (this.p1 === x$0.p1))) {
      var x = this.q7;
      var x$2 = x$0.q7;
      var $x_31 = ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      var $x_31 = false;
    }
    if ($x_31) {
      var x$3 = this.s0;
      var x$4 = x$0.s0;
      var $x_30 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_30 = false;
    }
    if ($x_30) {
      var x$5 = this.q6;
      var x$6 = x$0.q6;
      var $x_29 = ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      var $x_29 = false;
    }
    if ($x_29) {
      var x$7 = this.q8;
      var x$8 = x$0.q8;
      var $x_28 = ((x$7 === null) ? (x$8 === null) : x$7.e(x$8));
    } else {
      var $x_28 = false;
    }
    if ($x_28) {
      var x$9 = this.rY;
      var x$10 = x$0.rY;
      var $x_27 = ((x$9 === null) ? (x$10 === null) : x$9.e(x$10));
    } else {
      var $x_27 = false;
    }
    if ($x_27) {
      var x$11 = this.rZ;
      var x$12 = x$0.rZ;
      var $x_26 = ((x$11 === null) ? (x$12 === null) : x$11.e(x$12));
    } else {
      var $x_26 = false;
    }
    if ($x_26) {
      var x$13 = this.rX;
      var x$14 = x$0.rX;
      var $x_25 = ((x$13 === null) ? (x$14 === null) : x$13.e(x$14));
    } else {
      var $x_25 = false;
    }
    if ($x_25) {
      var x$15 = this.rT;
      var x$16 = x$0.rT;
      var $x_24 = ((x$15 === null) ? (x$16 === null) : x$15.e(x$16));
    } else {
      var $x_24 = false;
    }
    if ($x_24) {
      var x$17 = this.s8;
      var x$18 = x$0.s8;
      var $x_23 = ((x$17 === null) ? (x$18 === null) : x$17.e(x$18));
    } else {
      var $x_23 = false;
    }
    if ($x_23) {
      var x$19 = this.s9;
      var x$20 = x$0.s9;
      var $x_22 = ((x$19 === null) ? (x$20 === null) : x$19.e(x$20));
    } else {
      var $x_22 = false;
    }
    if ($x_22) {
      var x$21 = this.rQ;
      var x$22 = x$0.rQ;
      var $x_21 = ((x$21 === null) ? (x$22 === null) : x$21.e(x$22));
    } else {
      var $x_21 = false;
    }
    if ($x_21) {
      var x$23 = this.rW;
      var x$24 = x$0.rW;
      var $x_20 = ((x$23 === null) ? (x$24 === null) : x$23.e(x$24));
    } else {
      var $x_20 = false;
    }
    if ($x_20) {
      var x$25 = this.sd;
      var x$26 = x$0.sd;
      var $x_19 = ((x$25 === null) ? (x$26 === null) : x$25.e(x$26));
    } else {
      var $x_19 = false;
    }
    if ($x_19) {
      var x$27 = this.s1;
      var x$28 = x$0.s1;
      var $x_18 = ((x$27 === null) ? (x$28 === null) : x$27.e(x$28));
    } else {
      var $x_18 = false;
    }
    if ($x_18) {
      var x$29 = this.s2;
      var x$30 = x$0.s2;
      var $x_17 = ((x$29 === null) ? (x$30 === null) : x$29.e(x$30));
    } else {
      var $x_17 = false;
    }
    if ($x_17) {
      var x$31 = this.s3;
      var x$32 = x$0.s3;
      var $x_16 = ((x$31 === null) ? (x$32 === null) : x$31.e(x$32));
    } else {
      var $x_16 = false;
    }
    if ($x_16) {
      var x$33 = this.s4;
      var x$34 = x$0.s4;
      var $x_15 = ((x$33 === null) ? (x$34 === null) : x$33.e(x$34));
    } else {
      var $x_15 = false;
    }
    if ($x_15) {
      var x$35 = this.s5;
      var x$36 = x$0.s5;
      var $x_14 = ((x$35 === null) ? (x$36 === null) : x$35.e(x$36));
    } else {
      var $x_14 = false;
    }
    if ($x_14) {
      var x$37 = this.v9;
      var x$38 = x$0.v9;
      var $x_13 = ((x$37 === null) ? (x$38 === null) : x$37.e(x$38));
    } else {
      var $x_13 = false;
    }
    if ($x_13) {
      var x$39 = this.s6;
      var x$40 = x$0.s6;
      var $x_12 = ((x$39 === null) ? (x$40 === null) : x$39.e(x$40));
    } else {
      var $x_12 = false;
    }
    if ($x_12) {
      var x$41 = this.sc;
      var x$42 = x$0.sc;
      var $x_11 = ((x$41 === null) ? (x$42 === null) : x$41.e(x$42));
    } else {
      var $x_11 = false;
    }
    if ($x_11) {
      var x$43 = this.s7;
      var x$44 = x$0.s7;
      var $x_10 = ((x$43 === null) ? (x$44 === null) : x$43.e(x$44));
    } else {
      var $x_10 = false;
    }
    if ($x_10) {
      var x$45 = this.rS;
      var x$46 = x$0.rS;
      var $x_9 = ((x$45 === null) ? (x$46 === null) : x$45.e(x$46));
    } else {
      var $x_9 = false;
    }
    if ($x_9) {
      var x$47 = this.va;
      var x$48 = x$0.va;
      var $x_8 = ((x$47 === null) ? (x$48 === null) : x$47.e(x$48));
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$49 = this.sa;
      var x$50 = x$0.sa;
      var $x_7 = ((x$49 === null) ? (x$50 === null) : x$49.e(x$50));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$51 = this.sb;
      var x$52 = x$0.sb;
      var $x_6 = ((x$51 === null) ? (x$52 === null) : x$51.e(x$52));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$53 = this.se;
      var x$54 = x$0.se;
      var $x_5 = ((x$53 === null) ? (x$54 === null) : x$53.e(x$54));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$55 = this.sf;
      var x$56 = x$0.sf;
      var $x_4 = ((x$55 === null) ? (x$56 === null) : x$55.e(x$56));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$57 = this.rP;
      var x$58 = x$0.rP;
      var $x_3 = ((x$57 === null) ? (x$58 === null) : x$57.e(x$58));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$59 = this.rR;
      var x$60 = x$0.rR;
      var $x_2 = ((x$59 === null) ? (x$60 === null) : x$59.e(x$60));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$61 = this.rU;
      var x$62 = x$0.rU;
      var $x_1 = ((x$61 === null) ? (x$62 === null) : x$61.e(x$62));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$63 = this.rV;
      var x$64 = x$0.rV;
      return ((x$63 === null) ? (x$64 === null) : x$63.e(x$64));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 34;
});
$p.B = (function() {
  return "SimpleGraphCluster";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.v8;
      break;
    }
    case 1: {
      return this.p1;
      break;
    }
    case 2: {
      return this.q7;
      break;
    }
    case 3: {
      return this.s0;
      break;
    }
    case 4: {
      return this.q6;
      break;
    }
    case 5: {
      return this.q8;
      break;
    }
    case 6: {
      return this.rY;
      break;
    }
    case 7: {
      return this.rZ;
      break;
    }
    case 8: {
      return this.rX;
      break;
    }
    case 9: {
      return this.rT;
      break;
    }
    case 10: {
      return this.s8;
      break;
    }
    case 11: {
      return this.s9;
      break;
    }
    case 12: {
      return this.rQ;
      break;
    }
    case 13: {
      return this.rW;
      break;
    }
    case 14: {
      return this.sd;
      break;
    }
    case 15: {
      return this.s1;
      break;
    }
    case 16: {
      return this.s2;
      break;
    }
    case 17: {
      return this.s3;
      break;
    }
    case 18: {
      return this.s4;
      break;
    }
    case 19: {
      return this.s5;
      break;
    }
    case 20: {
      return this.v9;
      break;
    }
    case 21: {
      return this.s6;
      break;
    }
    case 22: {
      return this.sc;
      break;
    }
    case 23: {
      return this.s7;
      break;
    }
    case 24: {
      return this.rS;
      break;
    }
    case 25: {
      return this.va;
      break;
    }
    case 26: {
      return this.sa;
      break;
    }
    case 27: {
      return this.sb;
      break;
    }
    case 28: {
      return this.se;
      break;
    }
    case 29: {
      return this.sf;
      break;
    }
    case 30: {
      return this.rP;
      break;
    }
    case 31: {
      return this.rR;
      break;
    }
    case 32: {
      return this.rU;
      break;
    }
    case 33: {
      return this.rV;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "_gvid";
      break;
    }
    case 1: {
      return "name";
      break;
    }
    case 2: {
      return "nodes";
      break;
    }
    case 3: {
      return "label";
      break;
    }
    case 4: {
      return "edges";
      break;
    }
    case 5: {
      return "subgraphs";
      break;
    }
    case 6: {
      return "fontname";
      break;
    }
    case 7: {
      return "fontsize";
      break;
    }
    case 8: {
      return "fontcolor";
      break;
    }
    case 9: {
      return "color";
      break;
    }
    case 10: {
      return "pencolor";
      break;
    }
    case 11: {
      return "penwidth";
      break;
    }
    case 12: {
      return "bgcolor";
      break;
    }
    case 13: {
      return "fillcolor";
      break;
    }
    case 14: {
      return "style";
      break;
    }
    case 15: {
      return "labeljust";
      break;
    }
    case 16: {
      return "labelloc";
      break;
    }
    case 17: {
      return "lheight";
      break;
    }
    case 18: {
      return "lp";
      break;
    }
    case 19: {
      return "lwidth";
      break;
    }
    case 20: {
      return "layout";
      break;
    }
    case 21: {
      return "normalize";
      break;
    }
    case 22: {
      return "start";
      break;
    }
    case 23: {
      return "overlap";
      break;
    }
    case 24: {
      return "cluster";
      break;
    }
    case 25: {
      return "rankdir";
      break;
    }
    case 26: {
      return "rank";
      break;
    }
    case 27: {
      return "splines";
      break;
    }
    case 28: {
      return "target";
      break;
    }
    case 29: {
      return "tooltip";
      break;
    }
    case 30: {
      return "URL";
      break;
    }
    case 31: {
      return "class";
      break;
    }
    case 32: {
      return "colorscheme";
      break;
    }
    case 33: {
      return "extraAttrs";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphCluster(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hs)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphCluster = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphCluster, "org.jpablo.graphexplorer.viewer.backends.graphviz.vizjs.simplegraph.SimpleGraphCluster", ({
  hs: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge(_gvid, tail, head, pos, id, label, fontname, fontsize, color, penwidth, style, lp, len, constraint, forcelabels, headport, tailport, arrowhead, arrowtail, arrowsize, dir, class$1, colorscheme, layer, nojustify, samehead, sametail, showboxes, tail_lp, tailclip, target, tooltip, labeldistance, labelfloat, labelfontcolor, labelfontname, tailtarget, tailtooltip, tailURL, extraAttrs) {
  this.vb = 0;
  this.qd = 0;
  this.q9 = 0;
  this.qc = null;
  this.qb = null;
  this.ss = null;
  this.sp = null;
  this.sq = null;
  this.sk = null;
  this.sB = null;
  this.sF = null;
  this.sz = null;
  this.sy = null;
  this.sm = null;
  this.sr = null;
  this.qa = null;
  this.qe = null;
  this.sg = null;
  this.si = null;
  this.sh = null;
  this.sn = null;
  this.sj = null;
  this.sl = null;
  this.sx = null;
  this.sA = null;
  this.sC = null;
  this.sD = null;
  this.sE = null;
  this.sH = null;
  this.sI = null;
  this.sL = null;
  this.sM = null;
  this.st = null;
  this.su = null;
  this.sv = null;
  this.sw = null;
  this.sJ = null;
  this.sK = null;
  this.sG = null;
  this.so = null;
  this.vb = _gvid;
  this.qd = tail;
  this.q9 = head;
  this.qc = pos;
  this.qb = id;
  this.ss = label;
  this.sp = fontname;
  this.sq = fontsize;
  this.sk = color;
  this.sB = penwidth;
  this.sF = style;
  this.sz = lp;
  this.sy = len;
  this.sm = constraint;
  this.sr = forcelabels;
  this.qa = headport;
  this.qe = tailport;
  this.sg = arrowhead;
  this.si = arrowtail;
  this.sh = arrowsize;
  this.sn = dir;
  this.sj = class$1;
  this.sl = colorscheme;
  this.sx = layer;
  this.sA = nojustify;
  this.sC = samehead;
  this.sD = sametail;
  this.sE = showboxes;
  this.sH = tail_lp;
  this.sI = tailclip;
  this.sL = target;
  this.sM = tooltip;
  this.st = labeldistance;
  this.su = labelfloat;
  this.sv = labelfontcolor;
  this.sw = labelfontname;
  this.sJ = tailtarget;
  this.sK = tailtooltip;
  this.sG = tailURL;
  this.so = extraAttrs;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 344504953);
  acc = $m_sr_Statics$().k(acc, this.vb);
  acc = $m_sr_Statics$().k(acc, this.qd);
  acc = $m_sr_Statics$().k(acc, this.q9);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.qc));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.qb));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.ss));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.sp));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.sq));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.sk));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.sB));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.sF));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.sz));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.sy));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.sm));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.sr));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.qa));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.qe));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.sg));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.si));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.sh));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.sn));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.sj));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.sl));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.sx));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.sA));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.sC));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.sD));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.sE));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.sH));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.sI));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.sL));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.sM));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.st));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.su));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.sv));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.sw));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.sJ));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.sK));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.sG));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.so));
  return $m_sr_Statics$().Z(acc, 40);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge)) {
    if ((((this.vb === x$0.vb) && (this.qd === x$0.qd)) && (this.q9 === x$0.q9))) {
      var x = this.qc;
      var x$2 = x$0.qc;
      var $x_36 = ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      var $x_36 = false;
    }
    if ($x_36) {
      var x$3 = this.qb;
      var x$4 = x$0.qb;
      var $x_35 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_35 = false;
    }
    if ($x_35) {
      var x$5 = this.ss;
      var x$6 = x$0.ss;
      var $x_34 = ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      var $x_34 = false;
    }
    if ($x_34) {
      var x$7 = this.sp;
      var x$8 = x$0.sp;
      var $x_33 = ((x$7 === null) ? (x$8 === null) : x$7.e(x$8));
    } else {
      var $x_33 = false;
    }
    if ($x_33) {
      var x$9 = this.sq;
      var x$10 = x$0.sq;
      var $x_32 = ((x$9 === null) ? (x$10 === null) : x$9.e(x$10));
    } else {
      var $x_32 = false;
    }
    if ($x_32) {
      var x$11 = this.sk;
      var x$12 = x$0.sk;
      var $x_31 = ((x$11 === null) ? (x$12 === null) : x$11.e(x$12));
    } else {
      var $x_31 = false;
    }
    if ($x_31) {
      var x$13 = this.sB;
      var x$14 = x$0.sB;
      var $x_30 = ((x$13 === null) ? (x$14 === null) : x$13.e(x$14));
    } else {
      var $x_30 = false;
    }
    if ($x_30) {
      var x$15 = this.sF;
      var x$16 = x$0.sF;
      var $x_29 = ((x$15 === null) ? (x$16 === null) : x$15.e(x$16));
    } else {
      var $x_29 = false;
    }
    if ($x_29) {
      var x$17 = this.sz;
      var x$18 = x$0.sz;
      var $x_28 = ((x$17 === null) ? (x$18 === null) : x$17.e(x$18));
    } else {
      var $x_28 = false;
    }
    if ($x_28) {
      var x$19 = this.sy;
      var x$20 = x$0.sy;
      var $x_27 = ((x$19 === null) ? (x$20 === null) : x$19.e(x$20));
    } else {
      var $x_27 = false;
    }
    if ($x_27) {
      var x$21 = this.sm;
      var x$22 = x$0.sm;
      var $x_26 = ((x$21 === null) ? (x$22 === null) : x$21.e(x$22));
    } else {
      var $x_26 = false;
    }
    if ($x_26) {
      var x$23 = this.sr;
      var x$24 = x$0.sr;
      var $x_25 = ((x$23 === null) ? (x$24 === null) : x$23.e(x$24));
    } else {
      var $x_25 = false;
    }
    if ($x_25) {
      var x$25 = this.qa;
      var x$26 = x$0.qa;
      var $x_24 = ((x$25 === null) ? (x$26 === null) : x$25.e(x$26));
    } else {
      var $x_24 = false;
    }
    if ($x_24) {
      var x$27 = this.qe;
      var x$28 = x$0.qe;
      var $x_23 = ((x$27 === null) ? (x$28 === null) : x$27.e(x$28));
    } else {
      var $x_23 = false;
    }
    if ($x_23) {
      var x$29 = this.sg;
      var x$30 = x$0.sg;
      var $x_22 = ((x$29 === null) ? (x$30 === null) : x$29.e(x$30));
    } else {
      var $x_22 = false;
    }
    if ($x_22) {
      var x$31 = this.si;
      var x$32 = x$0.si;
      var $x_21 = ((x$31 === null) ? (x$32 === null) : x$31.e(x$32));
    } else {
      var $x_21 = false;
    }
    if ($x_21) {
      var x$33 = this.sh;
      var x$34 = x$0.sh;
      var $x_20 = ((x$33 === null) ? (x$34 === null) : x$33.e(x$34));
    } else {
      var $x_20 = false;
    }
    if ($x_20) {
      var x$35 = this.sn;
      var x$36 = x$0.sn;
      var $x_19 = ((x$35 === null) ? (x$36 === null) : x$35.e(x$36));
    } else {
      var $x_19 = false;
    }
    if ($x_19) {
      var x$37 = this.sj;
      var x$38 = x$0.sj;
      var $x_18 = ((x$37 === null) ? (x$38 === null) : x$37.e(x$38));
    } else {
      var $x_18 = false;
    }
    if ($x_18) {
      var x$39 = this.sl;
      var x$40 = x$0.sl;
      var $x_17 = ((x$39 === null) ? (x$40 === null) : x$39.e(x$40));
    } else {
      var $x_17 = false;
    }
    if ($x_17) {
      var x$41 = this.sx;
      var x$42 = x$0.sx;
      var $x_16 = ((x$41 === null) ? (x$42 === null) : x$41.e(x$42));
    } else {
      var $x_16 = false;
    }
    if ($x_16) {
      var x$43 = this.sA;
      var x$44 = x$0.sA;
      var $x_15 = ((x$43 === null) ? (x$44 === null) : x$43.e(x$44));
    } else {
      var $x_15 = false;
    }
    if ($x_15) {
      var x$45 = this.sC;
      var x$46 = x$0.sC;
      var $x_14 = ((x$45 === null) ? (x$46 === null) : x$45.e(x$46));
    } else {
      var $x_14 = false;
    }
    if ($x_14) {
      var x$47 = this.sD;
      var x$48 = x$0.sD;
      var $x_13 = ((x$47 === null) ? (x$48 === null) : x$47.e(x$48));
    } else {
      var $x_13 = false;
    }
    if ($x_13) {
      var x$49 = this.sE;
      var x$50 = x$0.sE;
      var $x_12 = ((x$49 === null) ? (x$50 === null) : x$49.e(x$50));
    } else {
      var $x_12 = false;
    }
    if ($x_12) {
      var x$51 = this.sH;
      var x$52 = x$0.sH;
      var $x_11 = ((x$51 === null) ? (x$52 === null) : x$51.e(x$52));
    } else {
      var $x_11 = false;
    }
    if ($x_11) {
      var x$53 = this.sI;
      var x$54 = x$0.sI;
      var $x_10 = ((x$53 === null) ? (x$54 === null) : x$53.e(x$54));
    } else {
      var $x_10 = false;
    }
    if ($x_10) {
      var x$55 = this.sL;
      var x$56 = x$0.sL;
      var $x_9 = ((x$55 === null) ? (x$56 === null) : x$55.e(x$56));
    } else {
      var $x_9 = false;
    }
    if ($x_9) {
      var x$57 = this.sM;
      var x$58 = x$0.sM;
      var $x_8 = ((x$57 === null) ? (x$58 === null) : x$57.e(x$58));
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$59 = this.st;
      var x$60 = x$0.st;
      var $x_7 = ((x$59 === null) ? (x$60 === null) : x$59.e(x$60));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$61 = this.su;
      var x$62 = x$0.su;
      var $x_6 = ((x$61 === null) ? (x$62 === null) : x$61.e(x$62));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$63 = this.sv;
      var x$64 = x$0.sv;
      var $x_5 = ((x$63 === null) ? (x$64 === null) : x$63.e(x$64));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$65 = this.sw;
      var x$66 = x$0.sw;
      var $x_4 = ((x$65 === null) ? (x$66 === null) : x$65.e(x$66));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$67 = this.sJ;
      var x$68 = x$0.sJ;
      var $x_3 = ((x$67 === null) ? (x$68 === null) : x$67.e(x$68));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$69 = this.sK;
      var x$70 = x$0.sK;
      var $x_2 = ((x$69 === null) ? (x$70 === null) : x$69.e(x$70));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$71 = this.sG;
      var x$72 = x$0.sG;
      var $x_1 = ((x$71 === null) ? (x$72 === null) : x$71.e(x$72));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$73 = this.so;
      var x$74 = x$0.so;
      return ((x$73 === null) ? (x$74 === null) : x$73.e(x$74));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 40;
});
$p.B = (function() {
  return "SimpleGraphEdge";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.vb;
      break;
    }
    case 1: {
      return this.qd;
      break;
    }
    case 2: {
      return this.q9;
      break;
    }
    case 3: {
      return this.qc;
      break;
    }
    case 4: {
      return this.qb;
      break;
    }
    case 5: {
      return this.ss;
      break;
    }
    case 6: {
      return this.sp;
      break;
    }
    case 7: {
      return this.sq;
      break;
    }
    case 8: {
      return this.sk;
      break;
    }
    case 9: {
      return this.sB;
      break;
    }
    case 10: {
      return this.sF;
      break;
    }
    case 11: {
      return this.sz;
      break;
    }
    case 12: {
      return this.sy;
      break;
    }
    case 13: {
      return this.sm;
      break;
    }
    case 14: {
      return this.sr;
      break;
    }
    case 15: {
      return this.qa;
      break;
    }
    case 16: {
      return this.qe;
      break;
    }
    case 17: {
      return this.sg;
      break;
    }
    case 18: {
      return this.si;
      break;
    }
    case 19: {
      return this.sh;
      break;
    }
    case 20: {
      return this.sn;
      break;
    }
    case 21: {
      return this.sj;
      break;
    }
    case 22: {
      return this.sl;
      break;
    }
    case 23: {
      return this.sx;
      break;
    }
    case 24: {
      return this.sA;
      break;
    }
    case 25: {
      return this.sC;
      break;
    }
    case 26: {
      return this.sD;
      break;
    }
    case 27: {
      return this.sE;
      break;
    }
    case 28: {
      return this.sH;
      break;
    }
    case 29: {
      return this.sI;
      break;
    }
    case 30: {
      return this.sL;
      break;
    }
    case 31: {
      return this.sM;
      break;
    }
    case 32: {
      return this.st;
      break;
    }
    case 33: {
      return this.su;
      break;
    }
    case 34: {
      return this.sv;
      break;
    }
    case 35: {
      return this.sw;
      break;
    }
    case 36: {
      return this.sJ;
      break;
    }
    case 37: {
      return this.sK;
      break;
    }
    case 38: {
      return this.sG;
      break;
    }
    case 39: {
      return this.so;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "_gvid";
      break;
    }
    case 1: {
      return "tail";
      break;
    }
    case 2: {
      return "head";
      break;
    }
    case 3: {
      return "pos";
      break;
    }
    case 4: {
      return "id";
      break;
    }
    case 5: {
      return "label";
      break;
    }
    case 6: {
      return "fontname";
      break;
    }
    case 7: {
      return "fontsize";
      break;
    }
    case 8: {
      return "color";
      break;
    }
    case 9: {
      return "penwidth";
      break;
    }
    case 10: {
      return "style";
      break;
    }
    case 11: {
      return "lp";
      break;
    }
    case 12: {
      return "len";
      break;
    }
    case 13: {
      return "constraint";
      break;
    }
    case 14: {
      return "forcelabels";
      break;
    }
    case 15: {
      return "headport";
      break;
    }
    case 16: {
      return "tailport";
      break;
    }
    case 17: {
      return "arrowhead";
      break;
    }
    case 18: {
      return "arrowtail";
      break;
    }
    case 19: {
      return "arrowsize";
      break;
    }
    case 20: {
      return "dir";
      break;
    }
    case 21: {
      return "class";
      break;
    }
    case 22: {
      return "colorscheme";
      break;
    }
    case 23: {
      return "layer";
      break;
    }
    case 24: {
      return "nojustify";
      break;
    }
    case 25: {
      return "samehead";
      break;
    }
    case 26: {
      return "sametail";
      break;
    }
    case 27: {
      return "showboxes";
      break;
    }
    case 28: {
      return "tail_lp";
      break;
    }
    case 29: {
      return "tailclip";
      break;
    }
    case 30: {
      return "target";
      break;
    }
    case 31: {
      return "tooltip";
      break;
    }
    case 32: {
      return "labeldistance";
      break;
    }
    case 33: {
      return "labelfloat";
      break;
    }
    case 34: {
      return "labelfontcolor";
      break;
    }
    case 35: {
      return "labelfontname";
      break;
    }
    case 36: {
      return "tailtarget";
      break;
    }
    case 37: {
      return "tailtooltip";
      break;
    }
    case 38: {
      return "tailURL";
      break;
    }
    case 39: {
      return "extraAttrs";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ht)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge, "org.jpablo.graphexplorer.viewer.backends.graphviz.vizjs.simplegraph.SimpleGraphEdge", ({
  ht: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphNode(_gvid, name, label, pos, height, width, shape, fontname, fontsize, fontcolor, color, fillcolor, style, penwidth, rects, sides, peripheries, fixedsize, regular, orientation, URL, area, class$1, colorscheme, target, tooltip, vertices, image, imagepath, imagepos, margin, nojustify, extraAttrs) {
  this.vc = 0;
  this.p2 = null;
  this.zg = null;
  this.qg = null;
  this.qf = null;
  this.qh = null;
  this.t8 = null;
  this.sW = null;
  this.sX = null;
  this.sV = null;
  this.sQ = null;
  this.sT = null;
  this.ta = null;
  this.t4 = null;
  this.t6 = null;
  this.t9 = null;
  this.t5 = null;
  this.sU = null;
  this.t7 = null;
  this.t3 = null;
  this.sN = null;
  this.sO = null;
  this.sP = null;
  this.sR = null;
  this.tb = null;
  this.tc = null;
  this.td = null;
  this.sY = null;
  this.sZ = null;
  this.t0 = null;
  this.t1 = null;
  this.t2 = null;
  this.sS = null;
  this.vc = _gvid;
  this.p2 = name;
  this.zg = label;
  this.qg = pos;
  this.qf = height;
  this.qh = width;
  this.t8 = shape;
  this.sW = fontname;
  this.sX = fontsize;
  this.sV = fontcolor;
  this.sQ = color;
  this.sT = fillcolor;
  this.ta = style;
  this.t4 = penwidth;
  this.t6 = rects;
  this.t9 = sides;
  this.t5 = peripheries;
  this.sU = fixedsize;
  this.t7 = regular;
  this.t3 = orientation;
  this.sN = URL;
  this.sO = area;
  this.sP = class$1;
  this.sR = colorscheme;
  this.tb = target;
  this.tc = tooltip;
  this.td = vertices;
  this.sY = image;
  this.sZ = imagepath;
  this.t0 = imagepos;
  this.t1 = margin;
  this.t2 = nojustify;
  this.sS = extraAttrs;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphNode.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphNode;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphNode() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphNode.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 344783550);
  acc = $m_sr_Statics$().k(acc, this.vc);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.p2));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.zg));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.qg));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.qf));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.qh));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.t8));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.sW));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.sX));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.sV));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.sQ));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.sT));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.ta));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.t4));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.t6));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.t9));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.t5));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.sU));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.t7));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.t3));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.sN));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.sO));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.sP));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.sR));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.tb));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.tc));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.td));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.sY));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.sZ));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.t0));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.t1));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.t2));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.sS));
  return $m_sr_Statics$().Z(acc, 33);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphNode)) {
    if ((((this.vc === x$0.vc) && (this.p2 === x$0.p2)) && (this.zg === x$0.zg))) {
      var x = this.qg;
      var x$2 = x$0.qg;
      var $x_29 = ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      var $x_29 = false;
    }
    if ($x_29) {
      var x$3 = this.qf;
      var x$4 = x$0.qf;
      var $x_28 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_28 = false;
    }
    if ($x_28) {
      var x$5 = this.qh;
      var x$6 = x$0.qh;
      var $x_27 = ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      var $x_27 = false;
    }
    if ($x_27) {
      var x$7 = this.t8;
      var x$8 = x$0.t8;
      var $x_26 = ((x$7 === null) ? (x$8 === null) : x$7.e(x$8));
    } else {
      var $x_26 = false;
    }
    if ($x_26) {
      var x$9 = this.sW;
      var x$10 = x$0.sW;
      var $x_25 = ((x$9 === null) ? (x$10 === null) : x$9.e(x$10));
    } else {
      var $x_25 = false;
    }
    if ($x_25) {
      var x$11 = this.sX;
      var x$12 = x$0.sX;
      var $x_24 = ((x$11 === null) ? (x$12 === null) : x$11.e(x$12));
    } else {
      var $x_24 = false;
    }
    if ($x_24) {
      var x$13 = this.sV;
      var x$14 = x$0.sV;
      var $x_23 = ((x$13 === null) ? (x$14 === null) : x$13.e(x$14));
    } else {
      var $x_23 = false;
    }
    if ($x_23) {
      var x$15 = this.sQ;
      var x$16 = x$0.sQ;
      var $x_22 = ((x$15 === null) ? (x$16 === null) : x$15.e(x$16));
    } else {
      var $x_22 = false;
    }
    if ($x_22) {
      var x$17 = this.sT;
      var x$18 = x$0.sT;
      var $x_21 = ((x$17 === null) ? (x$18 === null) : x$17.e(x$18));
    } else {
      var $x_21 = false;
    }
    if ($x_21) {
      var x$19 = this.ta;
      var x$20 = x$0.ta;
      var $x_20 = ((x$19 === null) ? (x$20 === null) : x$19.e(x$20));
    } else {
      var $x_20 = false;
    }
    if ($x_20) {
      var x$21 = this.t4;
      var x$22 = x$0.t4;
      var $x_19 = ((x$21 === null) ? (x$22 === null) : x$21.e(x$22));
    } else {
      var $x_19 = false;
    }
    if ($x_19) {
      var x$23 = this.t6;
      var x$24 = x$0.t6;
      var $x_18 = ((x$23 === null) ? (x$24 === null) : x$23.e(x$24));
    } else {
      var $x_18 = false;
    }
    if ($x_18) {
      var x$25 = this.t9;
      var x$26 = x$0.t9;
      var $x_17 = ((x$25 === null) ? (x$26 === null) : x$25.e(x$26));
    } else {
      var $x_17 = false;
    }
    if ($x_17) {
      var x$27 = this.t5;
      var x$28 = x$0.t5;
      var $x_16 = ((x$27 === null) ? (x$28 === null) : x$27.e(x$28));
    } else {
      var $x_16 = false;
    }
    if ($x_16) {
      var x$29 = this.sU;
      var x$30 = x$0.sU;
      var $x_15 = ((x$29 === null) ? (x$30 === null) : x$29.e(x$30));
    } else {
      var $x_15 = false;
    }
    if ($x_15) {
      var x$31 = this.t7;
      var x$32 = x$0.t7;
      var $x_14 = ((x$31 === null) ? (x$32 === null) : x$31.e(x$32));
    } else {
      var $x_14 = false;
    }
    if ($x_14) {
      var x$33 = this.t3;
      var x$34 = x$0.t3;
      var $x_13 = ((x$33 === null) ? (x$34 === null) : x$33.e(x$34));
    } else {
      var $x_13 = false;
    }
    if ($x_13) {
      var x$35 = this.sN;
      var x$36 = x$0.sN;
      var $x_12 = ((x$35 === null) ? (x$36 === null) : x$35.e(x$36));
    } else {
      var $x_12 = false;
    }
    if ($x_12) {
      var x$37 = this.sO;
      var x$38 = x$0.sO;
      var $x_11 = ((x$37 === null) ? (x$38 === null) : x$37.e(x$38));
    } else {
      var $x_11 = false;
    }
    if ($x_11) {
      var x$39 = this.sP;
      var x$40 = x$0.sP;
      var $x_10 = ((x$39 === null) ? (x$40 === null) : x$39.e(x$40));
    } else {
      var $x_10 = false;
    }
    if ($x_10) {
      var x$41 = this.sR;
      var x$42 = x$0.sR;
      var $x_9 = ((x$41 === null) ? (x$42 === null) : x$41.e(x$42));
    } else {
      var $x_9 = false;
    }
    if ($x_9) {
      var x$43 = this.tb;
      var x$44 = x$0.tb;
      var $x_8 = ((x$43 === null) ? (x$44 === null) : x$43.e(x$44));
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$45 = this.tc;
      var x$46 = x$0.tc;
      var $x_7 = ((x$45 === null) ? (x$46 === null) : x$45.e(x$46));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$47 = this.td;
      var x$48 = x$0.td;
      var $x_6 = ((x$47 === null) ? (x$48 === null) : x$47.e(x$48));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$49 = this.sY;
      var x$50 = x$0.sY;
      var $x_5 = ((x$49 === null) ? (x$50 === null) : x$49.e(x$50));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$51 = this.sZ;
      var x$52 = x$0.sZ;
      var $x_4 = ((x$51 === null) ? (x$52 === null) : x$51.e(x$52));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$53 = this.t0;
      var x$54 = x$0.t0;
      var $x_3 = ((x$53 === null) ? (x$54 === null) : x$53.e(x$54));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$55 = this.t1;
      var x$56 = x$0.t1;
      var $x_2 = ((x$55 === null) ? (x$56 === null) : x$55.e(x$56));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$57 = this.t2;
      var x$58 = x$0.t2;
      var $x_1 = ((x$57 === null) ? (x$58 === null) : x$57.e(x$58));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$59 = this.sS;
      var x$60 = x$0.sS;
      return ((x$59 === null) ? (x$60 === null) : x$59.e(x$60));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 33;
});
$p.B = (function() {
  return "SimpleGraphNode";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.vc;
      break;
    }
    case 1: {
      return this.p2;
      break;
    }
    case 2: {
      return this.zg;
      break;
    }
    case 3: {
      return this.qg;
      break;
    }
    case 4: {
      return this.qf;
      break;
    }
    case 5: {
      return this.qh;
      break;
    }
    case 6: {
      return this.t8;
      break;
    }
    case 7: {
      return this.sW;
      break;
    }
    case 8: {
      return this.sX;
      break;
    }
    case 9: {
      return this.sV;
      break;
    }
    case 10: {
      return this.sQ;
      break;
    }
    case 11: {
      return this.sT;
      break;
    }
    case 12: {
      return this.ta;
      break;
    }
    case 13: {
      return this.t4;
      break;
    }
    case 14: {
      return this.t6;
      break;
    }
    case 15: {
      return this.t9;
      break;
    }
    case 16: {
      return this.t5;
      break;
    }
    case 17: {
      return this.sU;
      break;
    }
    case 18: {
      return this.t7;
      break;
    }
    case 19: {
      return this.t3;
      break;
    }
    case 20: {
      return this.sN;
      break;
    }
    case 21: {
      return this.sO;
      break;
    }
    case 22: {
      return this.sP;
      break;
    }
    case 23: {
      return this.sR;
      break;
    }
    case 24: {
      return this.tb;
      break;
    }
    case 25: {
      return this.tc;
      break;
    }
    case 26: {
      return this.td;
      break;
    }
    case 27: {
      return this.sY;
      break;
    }
    case 28: {
      return this.sZ;
      break;
    }
    case 29: {
      return this.t0;
      break;
    }
    case 30: {
      return this.t1;
      break;
    }
    case 31: {
      return this.t2;
      break;
    }
    case 32: {
      return this.sS;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "_gvid";
      break;
    }
    case 1: {
      return "name";
      break;
    }
    case 2: {
      return "label";
      break;
    }
    case 3: {
      return "pos";
      break;
    }
    case 4: {
      return "height";
      break;
    }
    case 5: {
      return "width";
      break;
    }
    case 6: {
      return "shape";
      break;
    }
    case 7: {
      return "fontname";
      break;
    }
    case 8: {
      return "fontsize";
      break;
    }
    case 9: {
      return "fontcolor";
      break;
    }
    case 10: {
      return "color";
      break;
    }
    case 11: {
      return "fillcolor";
      break;
    }
    case 12: {
      return "style";
      break;
    }
    case 13: {
      return "penwidth";
      break;
    }
    case 14: {
      return "rects";
      break;
    }
    case 15: {
      return "sides";
      break;
    }
    case 16: {
      return "peripheries";
      break;
    }
    case 17: {
      return "fixedsize";
      break;
    }
    case 18: {
      return "regular";
      break;
    }
    case 19: {
      return "orientation";
      break;
    }
    case 20: {
      return "URL";
      break;
    }
    case 21: {
      return "area";
      break;
    }
    case 22: {
      return "class";
      break;
    }
    case 23: {
      return "colorscheme";
      break;
    }
    case 24: {
      return "target";
      break;
    }
    case 25: {
      return "tooltip";
      break;
    }
    case 26: {
      return "vertices";
      break;
    }
    case 27: {
      return "image";
      break;
    }
    case 28: {
      return "imagepath";
      break;
    }
    case 29: {
      return "imagepos";
      break;
    }
    case 30: {
      return "margin";
      break;
    }
    case 31: {
      return "nojustify";
      break;
    }
    case 32: {
      return "extraAttrs";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hu)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphNode = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphNode, "org.jpablo.graphexplorer.viewer.backends.graphviz.vizjs.simplegraph.SimpleGraphNode", ({
  hu: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassDef(styles, textStyles) {
  this.BY = null;
  this.FW = null;
  this.BY = styles;
  this.FW = textStyles;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassDef.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassDef;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassDef() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassDef.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 713756440, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassDef)) {
    var x = this.BY;
    var x$2 = x$0.BY;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      var x$3 = this.FW;
      var x$4 = x$0.FW;
      return ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "MermaidClassDef";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.BY;
  }
  if ((n === 1)) {
    return this.FW;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "styles";
  }
  if ((n === 1)) {
    return "textStyles";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassDef(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hy)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassDef = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidClassDef, "org.jpablo.graphexplorer.viewer.backends.mermaid.MermaidClassDef", ({
  hy: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidEdge(start, end, edgeType, text, labelType, stroke, styles, interpolate) {
  this.ve = null;
  this.vd = null;
  this.FX = null;
  this.FZ = null;
  this.SA = null;
  this.Lu = null;
  this.FY = null;
  this.Lt = null;
  this.ve = start;
  this.vd = end;
  this.FX = edgeType;
  this.FZ = text;
  this.SA = labelType;
  this.Lu = stroke;
  this.FY = styles;
  this.Lt = interpolate;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidEdge.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidEdge;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidEdge() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidEdge.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-324564696), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidEdge)) {
    if (((this.ve === x$0.ve) && (this.vd === x$0.vd))) {
      var x = this.FX;
      var x$2 = x$0.FX;
      var $x_5 = ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$3 = this.FZ;
      var x$4 = x$0.FZ;
      var $x_4 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$5 = this.SA;
      var x$6 = x$0.SA;
      var $x_3 = ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$7 = this.Lu;
      var x$8 = x$0.Lu;
      var $x_2 = ((x$7 === null) ? (x$8 === null) : x$7.e(x$8));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$9 = this.FY;
      var x$10 = x$0.FY;
      var $x_1 = ((x$9 === null) ? (x$10 === null) : x$9.e(x$10));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$11 = this.Lt;
      var x$12 = x$0.Lt;
      return ((x$11 === null) ? (x$12 === null) : x$11.e(x$12));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 8;
});
$p.B = (function() {
  return "MermaidEdge";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.ve;
      break;
    }
    case 1: {
      return this.vd;
      break;
    }
    case 2: {
      return this.FX;
      break;
    }
    case 3: {
      return this.FZ;
      break;
    }
    case 4: {
      return this.SA;
      break;
    }
    case 5: {
      return this.Lu;
      break;
    }
    case 6: {
      return this.FY;
      break;
    }
    case 7: {
      return this.Lt;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "start";
      break;
    }
    case 1: {
      return "end";
      break;
    }
    case 2: {
      return "edgeType";
      break;
    }
    case 3: {
      return "text";
      break;
    }
    case 4: {
      return "labelType";
      break;
    }
    case 5: {
      return "stroke";
      break;
    }
    case 6: {
      return "styles";
      break;
    }
    case 7: {
      return "interpolate";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidEdge(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hz)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidEdge = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidEdge, "org.jpablo.graphexplorer.viewer.backends.mermaid.MermaidEdge", ({
  hz: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidGraph(vertices, edges, subgraphs, direction, title, classDefs, defaultEdgeStyle, defaultEdgeInterpolate) {
  this.Lx = null;
  this.Lw = null;
  this.BZ = null;
  this.SD = null;
  this.SE = null;
  this.SB = null;
  this.Lv = null;
  this.SC = null;
  this.Lx = vertices;
  this.Lw = edges;
  this.BZ = subgraphs;
  this.SD = direction;
  this.SE = title;
  this.SB = classDefs;
  this.Lv = defaultEdgeStyle;
  this.SC = defaultEdgeInterpolate;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidGraph.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidGraph;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidGraph() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidGraph.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 1143408270, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidGraph)) {
    var x = this.Lx;
    var x$2 = x$0.Lx;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      var x$3 = this.Lw;
      var x$4 = x$0.Lw;
      var $x_6 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$5 = this.BZ;
      var x$6 = x$0.BZ;
      var $x_5 = ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$7 = this.SD;
      var x$8 = x$0.SD;
      var $x_4 = ((x$7 === null) ? (x$8 === null) : x$7.e(x$8));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$9 = this.SE;
      var x$10 = x$0.SE;
      var $x_3 = ((x$9 === null) ? (x$10 === null) : x$9.e(x$10));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$11 = this.SB;
      var x$12 = x$0.SB;
      var $x_2 = ((x$11 === null) ? (x$12 === null) : x$11.e(x$12));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$13 = this.Lv;
      var x$14 = x$0.Lv;
      var $x_1 = ((x$13 === null) ? (x$14 === null) : x$13.e(x$14));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$15 = this.SC;
      var x$16 = x$0.SC;
      return ((x$15 === null) ? (x$16 === null) : x$15.e(x$16));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 8;
});
$p.B = (function() {
  return "MermaidGraph";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.Lx;
      break;
    }
    case 1: {
      return this.Lw;
      break;
    }
    case 2: {
      return this.BZ;
      break;
    }
    case 3: {
      return this.SD;
      break;
    }
    case 4: {
      return this.SE;
      break;
    }
    case 5: {
      return this.SB;
      break;
    }
    case 6: {
      return this.Lv;
      break;
    }
    case 7: {
      return this.SC;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "vertices";
      break;
    }
    case 1: {
      return "edges";
      break;
    }
    case 2: {
      return "subgraphs";
      break;
    }
    case 3: {
      return "direction";
      break;
    }
    case 4: {
      return "title";
      break;
    }
    case 5: {
      return "classDefs";
      break;
    }
    case 6: {
      return "defaultEdgeStyle";
      break;
    }
    case 7: {
      return "defaultEdgeInterpolate";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidGraph(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hA)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidGraph = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidGraph, "org.jpablo.graphexplorer.viewer.backends.mermaid.MermaidGraph", ({
  hA: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSubgraph(id, title, nodes, classes) {
  this.x2 = null;
  this.Ly = null;
  this.C0 = null;
  this.G0 = null;
  this.x2 = id;
  this.Ly = title;
  this.C0 = nodes;
  this.G0 = classes;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSubgraph.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSubgraph;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSubgraph() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSubgraph.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 251687705, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSubgraph)) {
    if ((this.x2 === x$0.x2)) {
      var x = this.Ly;
      var x$2 = x$0.Ly;
      var $x_2 = ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.C0;
      var x$4 = x$0.C0;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.G0;
      var x$6 = x$0.G0;
      return ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 4;
});
$p.B = (function() {
  return "MermaidSubgraph";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.x2;
      break;
    }
    case 1: {
      return this.Ly;
      break;
    }
    case 2: {
      return this.C0;
      break;
    }
    case 3: {
      return this.G0;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "id";
      break;
    }
    case 1: {
      return "title";
      break;
    }
    case 2: {
      return "nodes";
      break;
    }
    case 3: {
      return "classes";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSubgraph(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hB)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSubgraph = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSubgraph, "org.jpablo.graphexplorer.viewer.backends.mermaid.MermaidSubgraph", ({
  hB: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidVertex(id, text, labelType, domId, styles, classes, shape) {
  this.qi = null;
  this.x3 = null;
  this.G1 = null;
  this.C2 = null;
  this.vf = null;
  this.C1 = null;
  this.C3 = null;
  this.qi = id;
  this.x3 = text;
  this.G1 = labelType;
  this.C2 = domId;
  this.vf = styles;
  this.C1 = classes;
  this.C3 = shape;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidVertex.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidVertex;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidVertex() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidVertex.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-213856119), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidVertex)) {
    if (((this.qi === x$0.qi) && (this.x3 === x$0.x3))) {
      var x = this.G1;
      var x$2 = x$0.G1;
      var $x_4 = ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$3 = this.C2;
      var x$4 = x$0.C2;
      var $x_3 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$5 = this.vf;
      var x$6 = x$0.vf;
      var $x_2 = ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$7 = this.C1;
      var x$8 = x$0.C1;
      var $x_1 = ((x$7 === null) ? (x$8 === null) : x$7.e(x$8));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$9 = this.C3;
      var x$10 = x$0.C3;
      return ((x$9 === null) ? (x$10 === null) : x$9.e(x$10));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 7;
});
$p.B = (function() {
  return "MermaidVertex";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.qi;
      break;
    }
    case 1: {
      return this.x3;
      break;
    }
    case 2: {
      return this.G1;
      break;
    }
    case 3: {
      return this.C2;
      break;
    }
    case 4: {
      return this.vf;
      break;
    }
    case 5: {
      return this.C1;
      break;
    }
    case 6: {
      return this.C3;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "id";
      break;
    }
    case 1: {
      return "text";
      break;
    }
    case 2: {
      return "labelType";
      break;
    }
    case 3: {
      return "domId";
      break;
    }
    case 4: {
      return "styles";
      break;
    }
    case 5: {
      return "classes";
      break;
    }
    case 6: {
      return "shape";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidVertex(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hC)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidVertex = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidVertex, "org.jpablo.graphexplorer.viewer.backends.mermaid.MermaidVertex", ({
  hC: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_Command(shortLabel, action, isVisible, shortcut, description) {
  this.lE = null;
  this.LD = null;
  this.G8 = null;
  this.x4 = null;
  this.vg = null;
  this.lE = shortLabel;
  this.LD = action;
  this.G8 = isVisible;
  this.x4 = shortcut;
  this.vg = description;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_Command.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_Command;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_Command() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_Command.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-521564786), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_components_Command)) {
    if ((this.lE === x$0.lE)) {
      var x = this.LD;
      var x$2 = x$0.LD;
      var $x_3 = ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$3 = this.G8;
      var x$4 = x$0.G8;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.x4;
      var x$6 = x$0.x4;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$7 = this.vg;
      var x$8 = x$0.vg;
      return ((x$7 === null) ? (x$8 === null) : x$7.e(x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 5;
});
$p.B = (function() {
  return "Command";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.lE;
      break;
    }
    case 1: {
      return this.LD;
      break;
    }
    case 2: {
      return this.G8;
      break;
    }
    case 3: {
      return this.x4;
      break;
    }
    case 4: {
      return this.vg;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "shortLabel";
      break;
    }
    case 1: {
      return "action";
      break;
    }
    case 2: {
      return "isVisible";
      break;
    }
    case 3: {
      return "shortcut";
      break;
    }
    case 4: {
      return "description";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.Xr = (function() {
  var this$1 = this.vg;
  var $x_1 = (this$1.c() ? this.lE : this$1.d());
  var this$2 = this.x4;
  return ($x_1 + (this$2.c() ? "" : ((" (" + $f_sc_IterableOnceOps__mkString__T__T__T__T(this$2.d().bM(), "", " + ", "")) + ")")));
});
$p.gZ = (function(arg, logEvent) {
  if (logEvent) {
    var this$1 = this.vg;
    var commandIdentifier = (this$1.c() ? this.lE : this$1.d());
    var p = $m_sjs_js_special_package$().eA($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("command_label", commandIdentifier), new $c_T2("event_category", "Command"), new $c_T2("event_label", commandIdentifier)])));
    var gtag$1 = gtag;
    if (((typeof gtag$1) === "function")) {
      gtag$1("event", "command_executed", p);
    }
  }
  this.LD.aNU(arg);
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_components_Command(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hM)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_components_Command = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_Command, "org.jpablo.graphexplorer.viewer.components.Command", ({
  hM: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_Shortcut(key, shift, meta, alt, ctrl) {
  this.te = null;
  this.G9 = false;
  this.C7 = false;
  this.C5 = false;
  this.C6 = false;
  this.te = key;
  this.G9 = shift;
  this.C7 = meta;
  this.C5 = alt;
  this.C6 = ctrl;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_Shortcut.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_Shortcut;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_Shortcut() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_Shortcut.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, (-277856154));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.te));
  acc = $m_sr_Statics$().k(acc, (this.G9 ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, (this.C7 ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, (this.C5 ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, (this.C6 ? 1231 : 1237));
  return $m_sr_Statics$().Z(acc, 5);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_components_Shortcut) && (((((this.G9 === x$0.G9) && (this.C7 === x$0.C7)) && (this.C5 === x$0.C5)) && (this.C6 === x$0.C6)) && (this.te === x$0.te))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 5;
});
$p.B = (function() {
  return "Shortcut";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.te;
      break;
    }
    case 1: {
      return this.G9;
      break;
    }
    case 2: {
      return this.C7;
      break;
    }
    case 3: {
      return this.C5;
      break;
    }
    case 4: {
      return this.C6;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "key";
      break;
    }
    case 1: {
      return "shift";
      break;
    }
    case 2: {
      return "meta";
      break;
    }
    case 3: {
      return "alt";
      break;
    }
    case 4: {
      return "ctrl";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.bM = (function() {
  return new $c_sci_$colon$colon(new $c_T2("Control", this.C6), new $c_sci_$colon$colon(new $c_T2("Alt", this.C5), new $c_sci_$colon$colon(new $c_T2("Shift", this.G9), new $c_sci_$colon$colon(new $c_T2("Meta", this.C7), new $c_sci_$colon$colon(new $c_T2(this.te, true), $m_sci_Nil$()))))).Ag(new $c_Lorg_jpablo_graphexplorer_viewer_components_Shortcut$$anon$1());
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_components_Shortcut(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hN)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_components_Shortcut = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_Shortcut, "org.jpablo.graphexplorer.viewer.components.Shortcut", ({
  hN: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$RowOption(name, value, elem) {
  this.x5 = null;
  this.zh = null;
  this.Ga = null;
  this.x5 = name;
  this.zh = value;
  this.Ga = elem;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$RowOption.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$RowOption;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$RowOption() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$RowOption.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 805486827, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$RowOption)) {
    if ((this.x5 === x$0.x5)) {
      var x = this.zh;
      var x$2 = x$0.zh;
      var $x_1 = ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.Ga;
      var x$4 = x$0.Ga;
      return ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 3;
});
$p.B = (function() {
  return "RowOption";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.x5;
      break;
    }
    case 1: {
      return this.zh;
      break;
    }
    case 2: {
      return this.Ga;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "name";
      break;
    }
    case 1: {
      return "value";
      break;
    }
    case 2: {
      return "elem";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.b2t = (function(s) {
  var this$1 = this.zh;
  return ((this$1 instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single) && (this$1.nd.m() === s));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$RowOption(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hQ)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$RowOption = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$RowOption, "org.jpablo.graphexplorer.viewer.components.attributes.rows.AttributeRow$RowOption", ({
  hQ: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_codeMirror_EditorEdit(text, fromHistory) {
  this.Gc = null;
  this.LH = false;
  this.Gc = text;
  this.LH = fromHistory;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_codeMirror_EditorEdit.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_codeMirror_EditorEdit;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_codeMirror_EditorEdit() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_codeMirror_EditorEdit.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 436625719);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Gc));
  acc = $m_sr_Statics$().k(acc, (this.LH ? 1231 : 1237));
  return $m_sr_Statics$().Z(acc, 2);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_components_codeMirror_EditorEdit) && ((this.LH === x$0.LH) && (this.Gc === x$0.Gc))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "EditorEdit";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Gc;
  }
  if ((n === 1)) {
    return this.LH;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "text";
  }
  if ((n === 1)) {
    return "fromHistory";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_components_codeMirror_EditorEdit(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hS)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_components_codeMirror_EditorEdit = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_codeMirror_EditorEdit, "org.jpablo.graphexplorer.viewer.components.codeMirror.EditorEdit", ({
  hS: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_PanelDrag(startX, startWidth) {
  this.LJ = 0.0;
  this.LI = 0;
  this.LJ = startX;
  this.LI = startWidth;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_PanelDrag.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_PanelDrag;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_PanelDrag() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_PanelDrag.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 521021752);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.LJ));
  acc = $m_sr_Statics$().k(acc, this.LI);
  return $m_sr_Statics$().Z(acc, 2);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_PanelDrag) && ((this.LJ === x$0.LJ) && (this.LI === x$0.LI))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "PanelDrag";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.LJ;
  }
  if ((n === 1)) {
    return this.LI;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "startX";
  }
  if ((n === 1)) {
    return "startWidth";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_PanelDrag(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hU)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_PanelDrag = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_PanelDrag, "org.jpablo.graphexplorer.viewer.components.rightPanel.PanelDrag", ({
  hU: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D$NodeSprite(outer, obj, texture, label, planar, setMap, setTint, disposeMaterial) {
  this.p3 = null;
  this.Cf = null;
  this.ql = null;
  this.Cd = false;
  this.zk = null;
  this.Ce = null;
  this.Cc = null;
  this.a0p = null;
  this.p3 = obj;
  this.Cf = texture;
  this.ql = label;
  this.Cd = planar;
  this.zk = setMap;
  this.Ce = setTint;
  this.Cc = disposeMaterial;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.a0p = outer;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D$NodeSprite.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D$NodeSprite;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D$NodeSprite() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D$NodeSprite.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, (-1093046393));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.p3));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Cf));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.ql));
  acc = $m_sr_Statics$().k(acc, (this.Cd ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.zk));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Ce));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Cc));
  return $m_sr_Statics$().Z(acc, 7);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if (((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D$NodeSprite) && (x$0.a0p === this.a0p))) {
    if ((((this.Cd === x$0.Cd) && $m_sr_BoxesRunTime$().Q(this.p3, x$0.p3)) && $m_sr_BoxesRunTime$().Q(this.Cf, x$0.Cf))) {
      var x$2 = this.ql;
      var x$2$1 = x$0.ql;
      var $x_3 = ((x$2 === null) ? (x$2$1 === null) : x$2.e(x$2$1));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$3 = this.zk;
      var x$4 = x$0.zk;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.Ce;
      var x$6 = x$0.Ce;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : (x$5 === x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$7 = this.Cc;
      var x$8 = x$0.Cc;
      return ((x$7 === null) ? (x$8 === null) : (x$7 === x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 7;
});
$p.B = (function() {
  return "NodeSprite";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.p3;
      break;
    }
    case 1: {
      return this.Cf;
      break;
    }
    case 2: {
      return this.ql;
      break;
    }
    case 3: {
      return this.Cd;
      break;
    }
    case 4: {
      return this.zk;
      break;
    }
    case 5: {
      return this.Ce;
      break;
    }
    case 6: {
      return this.Cc;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "obj";
      break;
    }
    case 1: {
      return "texture";
      break;
    }
    case 2: {
      return "label";
      break;
    }
    case 3: {
      return "planar";
      break;
    }
    case 4: {
      return "setMap";
      break;
    }
    case 5: {
      return "setTint";
      break;
    }
    case 6: {
      return "disposeMaterial";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.aN1 = (function(obj, texture, label, planar, setMap, setTint, disposeMaterial) {
  return new $c_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D$NodeSprite(this.a0p, obj, texture, label, planar, setMap, setTint, disposeMaterial);
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D$NodeSprite(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hV)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D$NodeSprite = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D$NodeSprite, "org.jpablo.graphexplorer.viewer.components.scene3d.GraphScene3D$NodeSprite", ({
  hV: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$BoxTween(g, base, inv, cfx, cfy, oldC, newC, kx0, ky0) {
  this.Gj = null;
  this.Gi = null;
  this.LV = null;
  this.LT = 0.0;
  this.LU = 0.0;
  this.zn = null;
  this.Gm = null;
  this.Gk = 0.0;
  this.Gl = 0.0;
  this.Gj = g;
  this.Gi = base;
  this.LV = inv;
  this.LT = cfx;
  this.LU = cfy;
  this.zn = oldC;
  this.Gm = newC;
  this.Gk = kx0;
  this.Gl = ky0;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$BoxTween.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$BoxTween;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$BoxTween() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$BoxTween.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, (-1988222080));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Gj));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Gi));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.LV));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.LT));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.LU));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.zn));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Gm));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.Gk));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.Gl));
  return $m_sr_Statics$().Z(acc, 9);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$BoxTween)) {
    if (((((((this.LT === x$0.LT) && (this.LU === x$0.LU)) && (this.Gk === x$0.Gk)) && (this.Gl === x$0.Gl)) && $m_sr_BoxesRunTime$().Q(this.Gj, x$0.Gj)) && (this.Gi === x$0.Gi))) {
      var x$1 = this.LV;
      var x$2 = x$0.LV;
      var $x_2 = ((x$1 === null) ? (x$2 === null) : x$1.e(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.zn;
      var x$4 = x$0.zn;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Gm;
      var x$6 = x$0.Gm;
      return ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 9;
});
$p.B = (function() {
  return "BoxTween";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.Gj;
      break;
    }
    case 1: {
      return this.Gi;
      break;
    }
    case 2: {
      return this.LV;
      break;
    }
    case 3: {
      return this.LT;
      break;
    }
    case 4: {
      return this.LU;
      break;
    }
    case 5: {
      return this.zn;
      break;
    }
    case 6: {
      return this.Gm;
      break;
    }
    case 7: {
      return this.Gk;
      break;
    }
    case 8: {
      return this.Gl;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "g";
      break;
    }
    case 1: {
      return "base";
      break;
    }
    case 2: {
      return "inv";
      break;
    }
    case 3: {
      return "cfx";
      break;
    }
    case 4: {
      return "cfy";
      break;
    }
    case 5: {
      return "oldC";
      break;
    }
    case 6: {
      return "newC";
      break;
    }
    case 7: {
      return "kx0";
      break;
    }
    case 8: {
      return "ky0";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$BoxTween(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.i0)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$BoxTween = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$BoxTween, "org.jpablo.graphexplorer.viewer.components.svgCanvas.LayoutTransition$BoxTween", ({
  i0: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$Ctm(a, d, e, f) {
  this.zo = 0.0;
  this.zp = 0.0;
  this.Gn = 0.0;
  this.Go = 0.0;
  this.zo = a;
  this.zp = d;
  this.Gn = e;
  this.Go = f;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$Ctm.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$Ctm;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$Ctm() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$Ctm.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 68092);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.zo));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.zp));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.Gn));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.Go));
  return $m_sr_Statics$().Z(acc, 4);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$Ctm) && ((((this.zo === x$0.zo) && (this.zp === x$0.zp)) && (this.Gn === x$0.Gn)) && (this.Go === x$0.Go))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 4;
});
$p.B = (function() {
  return "Ctm";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.zo;
      break;
    }
    case 1: {
      return this.zp;
      break;
    }
    case 2: {
      return this.Gn;
      break;
    }
    case 3: {
      return this.Go;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "a";
      break;
    }
    case 1: {
      return "d";
      break;
    }
    case 2: {
      return "e";
      break;
    }
    case 3: {
      return "f";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.ba3 = (function(x, y) {
  return new $c_T2(((this.zo * x) + this.Gn), ((this.zp * y) + this.Go));
});
$p.Q1 = (function(cx, cy) {
  return new $c_T2(((cx - this.Gn) / this.zo), ((cy - this.Go) / this.zp));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$Ctm(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.i1)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$Ctm = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$Ctm, "org.jpablo.graphexplorer.viewer.components.svgCanvas.LayoutTransition$Ctm", ({
  i1: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$EdgeTween(path, finalD, from, to) {
  this.LX = null;
  this.T4 = null;
  this.LW = null;
  this.T5 = null;
  this.LX = path;
  this.T4 = finalD;
  this.LW = from;
  this.T5 = to;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$EdgeTween.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$EdgeTween;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$EdgeTween() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$EdgeTween.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-715953216), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$EdgeTween)) {
    if (($m_sr_BoxesRunTime$().Q(this.LX, x$0.LX) && (this.T4 === x$0.T4))) {
      var x$1 = this.LW;
      var x$2 = x$0.LW;
      var $x_1 = ((x$1 === null) ? (x$2 === null) : x$1.e(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.T5;
      var x$4 = x$0.T5;
      return ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 4;
});
$p.B = (function() {
  return "EdgeTween";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.LX;
      break;
    }
    case 1: {
      return this.T4;
      break;
    }
    case 2: {
      return this.LW;
      break;
    }
    case 3: {
      return this.T5;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "path";
      break;
    }
    case 1: {
      return "finalD";
      break;
    }
    case 2: {
      return "from";
      break;
    }
    case 3: {
      return "to";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$EdgeTween(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.i2)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$EdgeTween = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$EdgeTween, "org.jpablo.graphexplorer.viewer.components.svgCanvas.LayoutTransition$EdgeTween", ({
  i2: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$GhostTween(wrap, cx, cy, tx, ty, kgx, kgy) {
  this.xb = null;
  this.Gp = 0.0;
  this.Gq = 0.0;
  this.Gt = 0.0;
  this.Gu = 0.0;
  this.Gr = 0.0;
  this.Gs = 0.0;
  this.xb = wrap;
  this.Gp = cx;
  this.Gq = cy;
  this.Gt = tx;
  this.Gu = ty;
  this.Gr = kgx;
  this.Gs = kgy;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$GhostTween.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$GhostTween;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$GhostTween() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$GhostTween.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, (-1794897604));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.xb));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.Gp));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.Gq));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.Gt));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.Gu));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.Gr));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.Gs));
  return $m_sr_Statics$().Z(acc, 7);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$GhostTween) && (((((((this.Gp === x$0.Gp) && (this.Gq === x$0.Gq)) && (this.Gt === x$0.Gt)) && (this.Gu === x$0.Gu)) && (this.Gr === x$0.Gr)) && (this.Gs === x$0.Gs)) && $m_sr_BoxesRunTime$().Q(this.xb, x$0.xb))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 7;
});
$p.B = (function() {
  return "GhostTween";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.xb;
      break;
    }
    case 1: {
      return this.Gp;
      break;
    }
    case 2: {
      return this.Gq;
      break;
    }
    case 3: {
      return this.Gt;
      break;
    }
    case 4: {
      return this.Gu;
      break;
    }
    case 5: {
      return this.Gr;
      break;
    }
    case 6: {
      return this.Gs;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "wrap";
      break;
    }
    case 1: {
      return "cx";
      break;
    }
    case 2: {
      return "cy";
      break;
    }
    case 3: {
      return "tx";
      break;
    }
    case 4: {
      return "ty";
      break;
    }
    case 5: {
      return "kgx";
      break;
    }
    case 6: {
      return "kgy";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.aT3 = (function(t) {
  var kx = (this.Gr + ((1.0 - this.Gr) * t));
  var ky = (this.Gs + ((1.0 - this.Gs) * t));
  var px = (this.Gt + ((this.Gp - this.Gt) * t));
  var py = (this.Gu + ((this.Gq - this.Gu) * t));
  return (((((((("translate(" + (px - (kx * this.Gp))) + " ") + (py - (ky * this.Gq))) + ") scale(") + kx) + " ") + ky) + ")");
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$GhostTween(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.i3)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$GhostTween = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$GhostTween, "org.jpablo.graphexplorer.viewer.components.svgCanvas.LayoutTransition$GhostTween", ({
  i3: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$SheetTween(el, inv, flx, fly, oldR, newR) {
  this.Gv = null;
  this.M0 = null;
  this.LY = 0.0;
  this.LZ = 0.0;
  this.qm = null;
  this.vj = null;
  this.Gv = el;
  this.M0 = inv;
  this.LY = flx;
  this.LZ = fly;
  this.qm = oldR;
  this.vj = newR;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$SheetTween.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$SheetTween;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$SheetTween() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$SheetTween.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 353523820);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Gv));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.M0));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.LY));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.LZ));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.qm));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.vj));
  return $m_sr_Statics$().Z(acc, 6);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$SheetTween)) {
    if ((((this.LY === x$0.LY) && (this.LZ === x$0.LZ)) && $m_sr_BoxesRunTime$().Q(this.Gv, x$0.Gv))) {
      var x$1 = this.M0;
      var x$2 = x$0.M0;
      var $x_2 = ((x$1 === null) ? (x$2 === null) : x$1.e(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.qm;
      var x$4 = x$0.qm;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.vj;
      var x$6 = x$0.vj;
      return ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 6;
});
$p.B = (function() {
  return "SheetTween";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.Gv;
      break;
    }
    case 1: {
      return this.M0;
      break;
    }
    case 2: {
      return this.LY;
      break;
    }
    case 3: {
      return this.LZ;
      break;
    }
    case 4: {
      return this.qm;
      break;
    }
    case 5: {
      return this.vj;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "el";
      break;
    }
    case 1: {
      return "inv";
      break;
    }
    case 2: {
      return "flx";
      break;
    }
    case 3: {
      return "fly";
      break;
    }
    case 4: {
      return "oldR";
      break;
    }
    case 5: {
      return "newR";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$SheetTween(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.i4)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$SheetTween = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$SheetTween, "org.jpablo.graphexplorer.viewer.components.svgCanvas.LayoutTransition$SheetTween", ({
  i4: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$Snapshot(boxes, edges, edgeParts, ghosts, ghostBBoxes, sheet) {
  this.zq = null;
  this.M2 = null;
  this.M1 = null;
  this.T7 = null;
  this.T6 = null;
  this.T8 = null;
  this.zq = boxes;
  this.M2 = edges;
  this.M1 = edgeParts;
  this.T7 = ghosts;
  this.T6 = ghostBBoxes;
  this.T8 = sheet;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$Snapshot.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$Snapshot;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$Snapshot() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$Snapshot.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 1512649425, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$Snapshot)) {
    var x = this.zq;
    var x$2 = x$0.zq;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      var x$3 = this.M2;
      var x$4 = x$0.M2;
      var $x_4 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$5 = this.M1;
      var x$6 = x$0.M1;
      var $x_3 = ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$7 = this.T7;
      var x$8 = x$0.T7;
      var $x_2 = ((x$7 === null) ? (x$8 === null) : x$7.e(x$8));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$9 = this.T6;
      var x$10 = x$0.T6;
      var $x_1 = ((x$9 === null) ? (x$10 === null) : x$9.e(x$10));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$11 = this.T8;
      var x$12 = x$0.T8;
      return ((x$11 === null) ? (x$12 === null) : x$11.e(x$12));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 6;
});
$p.B = (function() {
  return "Snapshot";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.zq;
      break;
    }
    case 1: {
      return this.M2;
      break;
    }
    case 2: {
      return this.M1;
      break;
    }
    case 3: {
      return this.T7;
      break;
    }
    case 4: {
      return this.T6;
      break;
    }
    case 5: {
      return this.T8;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "boxes";
      break;
    }
    case 1: {
      return "edges";
      break;
    }
    case 2: {
      return "edgeParts";
      break;
    }
    case 3: {
      return "ghosts";
      break;
    }
    case 4: {
      return "ghostBBoxes";
      break;
    }
    case 5: {
      return "sheet";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.c = (function() {
  return (this.zq.c() && this.M2.c());
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$Snapshot(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.i5)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$Snapshot = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_LayoutTransition$Snapshot, "org.jpablo.graphexplorer.viewer.components.svgCanvas.LayoutTransition$Snapshot", ({
  i5: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$Anchored(ax, ay, oxPx, oyPx, sizePx, designBox) {
  this.Cg = 0.0;
  this.Ch = 0.0;
  this.Cj = 0.0;
  this.Ck = 0.0;
  this.Cl = 0.0;
  this.Ci = 0.0;
  this.Cg = ax;
  this.Ch = ay;
  this.Cj = oxPx;
  this.Ck = oyPx;
  this.Cl = sizePx;
  this.Ci = designBox;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$Anchored.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$Anchored;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$Anchored() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$Anchored.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, (-906536396));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.Cg));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.Ch));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.Cj));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.Ck));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.Cl));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.Ci));
  return $m_sr_Statics$().Z(acc, 6);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$Anchored) && ((((((this.Cg === x$0.Cg) && (this.Ch === x$0.Ch)) && (this.Cj === x$0.Cj)) && (this.Ck === x$0.Ck)) && (this.Cl === x$0.Cl)) && (this.Ci === x$0.Ci))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 6;
});
$p.B = (function() {
  return "Anchored";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.Cg;
      break;
    }
    case 1: {
      return this.Ch;
      break;
    }
    case 2: {
      return this.Cj;
      break;
    }
    case 3: {
      return this.Ck;
      break;
    }
    case 4: {
      return this.Cl;
      break;
    }
    case 5: {
      return this.Ci;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "ax";
      break;
    }
    case 1: {
      return "ay";
      break;
    }
    case 2: {
      return "oxPx";
      break;
    }
    case 3: {
      return "oyPx";
      break;
    }
    case 4: {
      return "sizePx";
      break;
    }
    case 5: {
      return "designBox";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$Anchored(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.i6)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$Anchored = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_ScreenConstant$Anchored, "org.jpablo.graphexplorer.viewer.components.svgCanvas.ScreenConstant$Anchored", ({
  i6: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopBridge$DesktopMessage(text, path, revision) {
  this.M6 = null;
  this.M4 = null;
  this.M5 = null;
  this.M6 = text;
  this.M4 = path;
  this.M5 = revision;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopBridge$DesktopMessage.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopBridge$DesktopMessage;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopBridge$DesktopMessage() {
}
$h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopBridge$DesktopMessage.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 1951432435, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopBridge$DesktopMessage)) {
    if ((this.M6 === x$0.M6)) {
      var x = this.M4;
      var x$2 = x$0.M4;
      var $x_1 = ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.M5;
      var x$4 = x$0.M5;
      return ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 3;
});
$p.B = (function() {
  return "DesktopMessage";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.M6;
      break;
    }
    case 1: {
      return this.M4;
      break;
    }
    case 2: {
      return this.M5;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "text";
      break;
    }
    case 1: {
      return "path";
      break;
    }
    case 2: {
      return "revision";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopBridge$DesktopMessage(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.i7)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopBridge$DesktopMessage = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopBridge$DesktopMessage, "org.jpablo.graphexplorer.viewer.desktop.DesktopBridge$DesktopMessage", ({
  i7: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$Conflict(revision, text) {
  this.Ta = null;
  this.Gx = null;
  this.Ta = revision;
  this.Gx = text;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$Conflict.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$Conflict;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$Conflict() {
}
$h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$Conflict.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-1586631846), true);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$Conflict) && ((this.Ta === x$0.Ta) && (this.Gx === x$0.Gx))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "Conflict";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Ta;
  }
  if ((n === 1)) {
    return this.Gx;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "revision";
  }
  if ((n === 1)) {
    return "text";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$Conflict(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.i8)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$Conflict = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$Conflict, "org.jpablo.graphexplorer.viewer.desktop.DesktopDocumentRegistry$Conflict", ({
  i8: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$Session(id, path, revision, sourceText, conflict) {
  this.vk = null;
  this.vl = null;
  this.Cm = null;
  this.tj = null;
  this.Gy = null;
  this.vk = id;
  this.vl = path;
  this.Cm = revision;
  this.tj = sourceText;
  this.Gy = conflict;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$Session.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$Session;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$Session() {
}
$h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$Session.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 1165068026, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$Session)) {
    var x = this.vk;
    var x$2 = x$0.vk;
    if ((((((x === null) ? (x$2 === null) : x.e(x$2)) && (this.vl === x$0.vl)) && (this.Cm === x$0.Cm)) && (this.tj === x$0.tj))) {
      var x$3 = this.Gy;
      var x$4 = x$0.Gy;
      return ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 5;
});
$p.B = (function() {
  return "Session";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.vk;
      break;
    }
    case 1: {
      return this.vl;
      break;
    }
    case 2: {
      return this.Cm;
      break;
    }
    case 3: {
      return this.tj;
      break;
    }
    case 4: {
      return this.Gy;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "id";
      break;
    }
    case 1: {
      return "path";
      break;
    }
    case 2: {
      return "revision";
      break;
    }
    case 3: {
      return "sourceText";
      break;
    }
    case 4: {
      return "conflict";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.aXV = (function() {
  var $x_1 = $m_sc_ArrayOps$();
  var xs = $f_T__split__T__I__AT(this.vl, "[/\\\\]", 0);
  var evidence$1 = $m_s_reflect_ClassTag$().y0($objectGetClass(xs).ba.Q());
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1.h8();
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var i = 0;
  while ((i < xs.a.length)) {
    var x1 = i;
    var x = xs.a[x1];
    if ((x !== "")) {
      var unboxedElem = (isCharArrayBuilder ? $uC(x) : ((x === null) ? elementClass.ba.z : x));
      jsElems.push(unboxedElem);
    }
    i = ((1 + i) | 0);
  }
  var elemRuntimeClass = ((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass));
  var this$11 = $x_1.b41(elemRuntimeClass.ba.r().w(jsElems));
  return (this$11.c() ? this.vl : this$11.d());
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$Session(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.i9)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$Session = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopDocumentRegistry$Session, "org.jpablo.graphexplorer.viewer.desktop.DesktopDocumentRegistry$Session", ({
  i9: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Pending(route, view) {
  this.Tk = null;
  this.Tl = null;
  this.Tk = route;
  this.Tl = view;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Pending.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Pending;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Pending() {
}
$h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Pending.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 222573613, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Pending)) {
    var x = this.Tk;
    var x$2 = x$0.Tk;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      return $m_sr_BoxesRunTime$().Q(this.Tl, x$0.Tl);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "Pending";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Tk;
  }
  if ((n === 1)) {
    return this.Tl;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "route";
  }
  if ((n === 1)) {
    return "view";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Pending(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ij)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Pending = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Pending, "org.jpablo.graphexplorer.viewer.desktop.DesktopOpenRequests$Pending", ({
  ij: 1,
  b: 1,
  c: 1,
  a: 1
}));
class $c_Lorg_jpablo_graphexplorer_viewer_desktop_IpcUnavailable$ extends $c_jl_Exception {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, "desktop IPC is unavailable", null, true, true);
  }
}
var $d_Lorg_jpablo_graphexplorer_viewer_desktop_IpcUnavailable$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_desktop_IpcUnavailable$, "org.jpablo.graphexplorer.viewer.desktop.IpcUnavailable$", ({
  zY: 1,
  G: 1,
  y: 1,
  a: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_desktop_IpcUnavailable$;
function $m_Lorg_jpablo_graphexplorer_viewer_desktop_IpcUnavailable$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_desktop_IpcUnavailable$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_desktop_IpcUnavailable$ = new $c_Lorg_jpablo_graphexplorer_viewer_desktop_IpcUnavailable$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_desktop_IpcUnavailable$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$Unresolved(state, origin) {
  this.Tm = null;
  this.Gz = null;
  this.Tm = state;
  this.Gz = origin;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$Unresolved.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$Unresolved;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$Unresolved() {
}
$h_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$Unresolved.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-789120614), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$Unresolved)) {
    var x = this.Tm;
    var x$2 = x$0.Tm;
    if (((x === null) ? (x$2 === null) : (x === x$2))) {
      var x$3 = this.Gz;
      var x$4 = x$0.Gz;
      return ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "Unresolved";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Tm;
  }
  if ((n === 1)) {
    return this.Gz;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "state";
  }
  if ((n === 1)) {
    return "origin";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$Unresolved(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ik)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$Unresolved = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$Unresolved, "org.jpablo.graphexplorer.viewer.desktop.OriginReconciler$Unresolved", ({
  ik: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_desktop_SessionCommands$Refusal(code, message) {
  this.To = null;
  this.Tp = null;
  this.To = code;
  this.Tp = message;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_desktop_SessionCommands$Refusal.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_desktop_SessionCommands$Refusal;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_desktop_SessionCommands$Refusal() {
}
$h_Lorg_jpablo_graphexplorer_viewer_desktop_SessionCommands$Refusal.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 1458254702, true);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_desktop_SessionCommands$Refusal) && ((this.To === x$0.To) && (this.Tp === x$0.Tp))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "Refusal";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.To;
  }
  if ((n === 1)) {
    return this.Tp;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "code";
  }
  if ((n === 1)) {
    return "message";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_desktop_SessionCommands$Refusal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.il)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_desktop_SessionCommands$Refusal = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_desktop_SessionCommands$Refusal, "org.jpablo.graphexplorer.viewer.desktop.SessionCommands$Refusal", ({
  il: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_DotText(value) {
  this.o6 = null;
  this.o6 = value;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_DotText.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_DotText;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_DotText() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_DotText.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 2064122519, true);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_DotText) && (this.o6 === x$0.o6)));
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "DotText";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.o6;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.m = (function() {
  return this.o6;
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_formats_dot_DotText(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.im)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_DotText = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_DotText, "org.jpablo.graphexplorer.viewer.formats.dot.DotText", ({
  im: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_Attr(id, attrEq) {
  this.Tq = null;
  this.a0E = null;
  this.Tq = id;
  this.a0E = attrEq;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_Attr.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_Attr;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_Attr() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_Attr.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-195397372), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_Attr)) {
    if ((this.Tq === x$0.Tq)) {
      var x = this.a0E;
      var x$2 = x$0.a0E;
      return ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "Attr";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Tq;
  }
  if ((n === 1)) {
    return this.a0E;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "id";
  }
  if ((n === 1)) {
    return "attrEq";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_Attr(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ir)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_Attr = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_Attr, "org.jpablo.graphexplorer.viewer.formats.dot.ast.Attr", ({
  ir: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq(value, html) {
  this.Co = null;
  this.vn = false;
  this.Co = value;
  this.vn = html;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 1971590813);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Co));
  acc = $m_sr_Statics$().k(acc, (this.vn ? 1231 : 1237));
  return $m_sr_Statics$().Z(acc, 2);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq) && ((this.vn === x$0.vn) && (this.Co === x$0.Co))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "AttrEq";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Co;
  }
  if ((n === 1)) {
    return this.vn;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  if ((n === 1)) {
    return "html";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.is)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq, "org.jpablo.graphexplorer.viewer.formats.dot.ast.AttrEq", ({
  is: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(value) {
  this.GA = null;
  this.GA = value;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 1409692751, true);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue) && $m_sr_BoxesRunTime$().Q(this.GA, x$0.GA)));
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "AttrValue";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.GA;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.m = (function() {
  var x6 = this.GA;
  if (((typeof x6) === "string")) {
    return x6;
  }
  if ((x6 instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq)) {
    return x6.Co;
  }
  throw new $c_s_MatchError(x6);
});
$p.a3T = (function() {
  return (this.m() === "true");
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.it)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrValue, "org.jpablo.graphexplorer.viewer.formats.dot.ast.AttrValue", ({
  it: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ClusterLabelLoc$() {
  this.aa3 = null;
  this.azU = null;
  this.aa4 = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ClusterLabelLoc$ = this;
  $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLocT__$init$__V(this);
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ClusterLabelLoc$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ClusterLabelLoc$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ClusterLabelLoc$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ClusterLabelLoc$.prototype = $p;
$p.aZ = (function() {
  return "";
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aN = (function() {
  return this.aa3;
});
$p.aI = (function() {
  return this.azU;
});
$p.aP = (function() {
  return this.aa4;
});
$p.aQP = (function(x$0) {
  this.aa3 = x$0;
});
$p.aQQ = (function(x$0) {
  this.azU = x$0;
});
$p.aQR = (function(x$0) {
  this.aa4 = x$0;
});
$p.aT = (function() {
  return $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc$__t__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc();
});
$p.aW = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLocT__values__ALorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc(this);
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ClusterLabelLoc$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ClusterLabelLoc$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.ClusterLabelLoc$", ({
  AB: 1,
  o: 1,
  a1: 1,
  iC: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ClusterLabelLoc$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ClusterLabelLoc$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ClusterLabelLoc$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ClusterLabelLoc$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ClusterLabelLoc$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ClusterLabelLoc$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Margin(x, y) {
  this.Tr = 0.0;
  this.Ts = 0.0;
  this.Tr = x;
  this.Ts = y;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Margin.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Margin;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Margin() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Margin.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, (-1997442610));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.Tr));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.Ts));
  return $m_sr_Statics$().Z(acc, 2);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Margin) && ((this.Tr === x$0.Tr) && (this.Ts === x$0.Ts))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "Margin";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Tr;
  }
  if ((n === 1)) {
    return this.Ts;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "x";
  }
  if ((n === 1)) {
    return "y";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Margin(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iH)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Margin = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Margin, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Margin", ({
  iH: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RootGraphLabelLoc$() {
  this.aau = null;
  this.aD6 = null;
  this.aD7 = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RootGraphLabelLoc$ = this;
  $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLocT__$init$__V(this);
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RootGraphLabelLoc$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RootGraphLabelLoc$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RootGraphLabelLoc$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RootGraphLabelLoc$.prototype = $p;
$p.aZ = (function() {
  return "";
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aN = (function() {
  return this.aau;
});
$p.aI = (function() {
  return this.aD6;
});
$p.aP = (function() {
  return this.aD7;
});
$p.aQP = (function(x$0) {
  this.aau = x$0;
});
$p.aQQ = (function(x$0) {
  this.aD6 = x$0;
});
$p.aQR = (function(x$0) {
  this.aD7 = x$0;
});
$p.aT = (function() {
  return $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc$__b__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc();
});
$p.aW = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLocT__values__ALorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc(this);
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RootGraphLabelLoc$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RootGraphLabelLoc$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.RootGraphLabelLoc$", ({
  BS: 1,
  o: 1,
  a1: 1,
  iC: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RootGraphLabelLoc$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RootGraphLabelLoc$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RootGraphLabelLoc$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RootGraphLabelLoc$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RootGraphLabelLoc$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RootGraphLabelLoc$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex(classDefs, classDefTexts, defaultEdgeStyles) {
  this.Ml = null;
  this.Mk = null;
  this.Tt = null;
  this.Ml = classDefs;
  this.Mk = classDefTexts;
  this.Tt = defaultEdgeStyles;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex() {
}
$h_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-394933979), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex)) {
    var x = this.Ml;
    var x$2 = x$0.Ml;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      var x$3 = this.Mk;
      var x$4 = x$0.Mk;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Tt;
      var x$6 = x$0.Tt;
      return ((x$5 === null) ? (x$6 === null) : $f_sc_Map__equals__O__Z(x$5, x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 3;
});
$p.B = (function() {
  return "MermaidStyleIndex";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.Ml;
      break;
    }
    case 1: {
      return this.Mk;
      break;
    }
    case 2: {
      return this.Tt;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "classDefs";
      break;
    }
    case 1: {
      return "classDefTexts";
      break;
    }
    case 2: {
      return "defaultEdgeStyles";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.j0)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex, "org.jpablo.graphexplorer.viewer.graph.AttributesOps$MermaidStyleIndex", ({
  j0: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$CollapsedView(graph, hidden, underlyingArrows) {
  this.xe = null;
  this.Cp = null;
  this.Tu = null;
  this.xe = graph;
  this.Cp = hidden;
  this.Tu = underlyingArrows;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$CollapsedView.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$CollapsedView;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$CollapsedView() {
}
$h_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$CollapsedView.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 929992750, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$CollapsedView)) {
    var x = this.xe;
    var x$2 = x$0.xe;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      var x$3 = this.Cp;
      var x$4 = x$0.Cp;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Tu;
      var x$6 = x$0.Tu;
      return ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 3;
});
$p.B = (function() {
  return "CollapsedView";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.xe;
      break;
    }
    case 1: {
      return new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds(this.Cp);
      break;
    }
    case 2: {
      return this.Tu;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "graph";
      break;
    }
    case 1: {
      return "hidden";
      break;
    }
    case 2: {
      return "underlyingArrows";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.ahk = (function(ids) {
  return ids.c5(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((id) => this.Tu.ay(id, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((id$2) => (() => $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_ArrowId.r().C)([id$2])))))(id))))));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$CollapsedView(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.j1)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$CollapsedView = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$CollapsedView, "org.jpablo.graphexplorer.viewer.graph.CollapseOps$CollapsedView", ({
  j1: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$Summary(nodes, arrows, groups) {
  this.Mo = 0;
  this.Mn = 0;
  this.Tv = 0;
  this.Mo = nodes;
  this.Mn = arrows;
  this.Tv = groups;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$Summary.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$Summary;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$Summary() {
}
$h_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$Summary.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, (-192987258));
  acc = $m_sr_Statics$().k(acc, this.Mo);
  acc = $m_sr_Statics$().k(acc, this.Mn);
  acc = $m_sr_Statics$().k(acc, this.Tv);
  return $m_sr_Statics$().Z(acc, 3);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$Summary) && (((this.Mo === x$0.Mo) && (this.Mn === x$0.Mn)) && (this.Tv === x$0.Tv))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 3;
});
$p.B = (function() {
  return "Summary";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.Mo;
      break;
    }
    case 1: {
      return this.Mn;
      break;
    }
    case 2: {
      return this.Tv;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "nodes";
      break;
    }
    case 1: {
      return "arrows";
      break;
    }
    case 2: {
      return "groups";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$Summary(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.j3)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$Summary = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$Summary, "org.jpablo.graphexplorer.viewer.graph.ViewerGraph$Summary", ({
  j3: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements(nodes, arrows, memberships, arrowMemberships, groups, graphAttributes, defaultNodeAttributes, defaultArrowAttributes) {
  this.gr = null;
  this.gH = null;
  this.gq = null;
  this.gp = null;
  this.fh = null;
  this.dW = null;
  this.fE = null;
  this.fD = null;
  this.gr = nodes;
  this.gH = arrows;
  this.gq = memberships;
  this.gp = arrowMemberships;
  this.fh = groups;
  this.dW = graphAttributes;
  this.fE = defaultNodeAttributes;
  this.fD = defaultArrowAttributes;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements() {
}
$h_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 1878090302, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements)) {
    var x = this.gr;
    var x$2 = x$0.gr;
    if (((x === null) ? (x$2 === null) : $f_sc_Map__equals__O__Z(x, x$2))) {
      var x$3 = this.gH;
      var x$4 = x$0.gH;
      var $x_6 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$5 = this.gq;
      var x$6 = x$0.gq;
      var $x_5 = ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$7 = this.gp;
      var x$8 = x$0.gp;
      var $x_4 = ((x$7 === null) ? (x$8 === null) : x$7.e(x$8));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$9 = this.fh;
      var x$10 = x$0.fh;
      var $x_3 = ((x$9 === null) ? (x$10 === null) : x$9.e(x$10));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$11 = this.dW;
      var x$12 = x$0.dW;
      var $x_2 = ((x$11 === null) ? (x$12 === null) : x$11.e(x$12));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$13 = this.fE;
      var x$14 = x$0.fE;
      var $x_1 = ((x$13 === null) ? (x$14 === null) : x$13.e(x$14));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$15 = this.fD;
      var x$16 = x$0.fD;
      return ((x$15 === null) ? (x$16 === null) : x$15.e(x$16));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 8;
});
$p.B = (function() {
  return "ViewerGraphElements";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.gr;
      break;
    }
    case 1: {
      return this.gH;
      break;
    }
    case 2: {
      return this.gq;
      break;
    }
    case 3: {
      return this.gp;
      break;
    }
    case 4: {
      return this.fh;
      break;
    }
    case 5: {
      return new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(this.dW);
      break;
    }
    case 6: {
      return new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(this.fE);
      break;
    }
    case 7: {
      return new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(this.fD);
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "nodes";
      break;
    }
    case 1: {
      return "arrows";
      break;
    }
    case 2: {
      return "memberships";
      break;
    }
    case 3: {
      return "arrowMemberships";
      break;
    }
    case 4: {
      return "groups";
      break;
    }
    case 5: {
      return "graphAttributes";
      break;
    }
    case 6: {
      return "defaultNodeAttributes";
      break;
    }
    case 7: {
      return "defaultArrowAttributes";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.j4)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements, "org.jpablo.graphexplorer.viewer.graph.ViewerGraphElements", ({
  j4: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_graph_VizViewerGraphElements(nodes, arrows, memberships, arrowMemberships, groups, graphAttributes) {
  this.Mu = null;
  this.Mq = null;
  this.Mt = null;
  this.Mp = null;
  this.Ms = null;
  this.Mr = null;
  this.Mu = nodes;
  this.Mq = arrows;
  this.Mt = memberships;
  this.Mp = arrowMemberships;
  this.Ms = groups;
  this.Mr = graphAttributes;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_graph_VizViewerGraphElements.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_graph_VizViewerGraphElements;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_graph_VizViewerGraphElements() {
}
$h_Lorg_jpablo_graphexplorer_viewer_graph_VizViewerGraphElements.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 358810315, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_graph_VizViewerGraphElements)) {
    var x = this.Mu;
    var x$2 = x$0.Mu;
    if (((x === null) ? (x$2 === null) : $f_sc_Map__equals__O__Z(x, x$2))) {
      var x$3 = this.Mq;
      var x$4 = x$0.Mq;
      var $x_4 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$5 = this.Mt;
      var x$6 = x$0.Mt;
      var $x_3 = ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$7 = this.Mp;
      var x$8 = x$0.Mp;
      var $x_2 = ((x$7 === null) ? (x$8 === null) : x$7.e(x$8));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$9 = this.Ms;
      var x$10 = x$0.Ms;
      var $x_1 = ((x$9 === null) ? (x$10 === null) : x$9.e(x$10));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$11 = this.Mr;
      var x$12 = x$0.Mr;
      return ((x$11 === null) ? (x$12 === null) : x$11.e(x$12));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 6;
});
$p.B = (function() {
  return "VizViewerGraphElements";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.Mu;
      break;
    }
    case 1: {
      return this.Mq;
      break;
    }
    case 2: {
      return this.Mt;
      break;
    }
    case 3: {
      return this.Mp;
      break;
    }
    case 4: {
      return this.Ms;
      break;
    }
    case 5: {
      return new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(this.Mr);
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "nodes";
      break;
    }
    case 1: {
      return "arrows";
      break;
    }
    case 2: {
      return "memberships";
      break;
    }
    case 3: {
      return "arrowMemberships";
      break;
    }
    case 4: {
      return "groups";
      break;
    }
    case 5: {
      return "graphAttributes";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.b0Z = (function() {
  var this$1 = this.Mu;
  $m_sci_VectorMap$();
  var b = new $c_sci_VectorMapBuilder();
  var it = new $c_sci_VectorMap$$anon$1(this$1);
  while (it.p()) {
    var x0 = it.dC();
    if ((x0 === null)) {
      throw new $c_s_MatchError(x0);
    }
    var k = x0.g();
    var v = x0.h();
    var this$3 = v.yg();
    var mod = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1) => {
      var attrs = ((v1 === null) ? null : v1.ce);
      return new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes($m_Lorg_jpablo_graphexplorer_viewer_graph_VizViewerGraphElements$().a4k(attrs));
    }));
    b.pm(k, this$3.eF.i(mod));
  }
  var nodes$1 = b.rb();
  var groups$1 = this.Ms.wk(new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((_$2, g) => {
    var this$4 = g.yg();
    var mod$1 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1$1) => {
      var attrs$1 = ((v1$1 === null) ? null : v1$1.ce);
      return new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes($m_Lorg_jpablo_graphexplorer_viewer_graph_VizViewerGraphElements$().a4k(attrs$1));
    }));
    return this$4.eF.i(mod$1);
  })));
  var arrows$1 = this.Mq.wk(new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((_$3, a) => {
    var this$5 = a.yg();
    var mod$2 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1$2) => {
      var attrs$2 = ((v1$2 === null) ? null : v1$2.ce);
      return new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes($m_Lorg_jpablo_graphexplorer_viewer_graph_VizViewerGraphElements$().a4k(attrs$2));
    }));
    return this$5.eF.i(mod$2);
  })));
  var graphAttributes$1 = $m_Lorg_jpablo_graphexplorer_viewer_graph_VizViewerGraphElements$().a4k(this.Mr);
  return new $c_Lorg_jpablo_graphexplorer_viewer_graph_VizViewerGraphElements(nodes$1, arrows$1, this.Mt, this.Mp, groups$1, graphAttributes$1);
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_graph_VizViewerGraphElements(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.j5)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_graph_VizViewerGraphElements = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_graph_VizViewerGraphElements, "org.jpablo.graphexplorer.viewer.graph.VizViewerGraphElements", ({
  j5: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$Params(depth, ptToWorld, tweenRate, settleEps) {
  this.GJ = 0.0;
  this.zs = 0.0;
  this.Mw = 0.0;
  this.GK = 0.0;
  this.GJ = depth;
  this.zs = ptToWorld;
  this.Mw = tweenRate;
  this.GK = settleEps;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$Params.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$Params;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$Params() {
}
$h_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$Params.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, (-1911560794));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.GJ));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.zs));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.Mw));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.GK));
  return $m_sr_Statics$().Z(acc, 4);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$Params) && ((((this.GJ === x$0.GJ) && (this.zs === x$0.zs)) && (this.Mw === x$0.Mw)) && (this.GK === x$0.GK))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 4;
});
$p.B = (function() {
  return "Params";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.GJ;
      break;
    }
    case 1: {
      return this.zs;
      break;
    }
    case 2: {
      return this.Mw;
      break;
    }
    case 3: {
      return this.GK;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "depth";
      break;
    }
    case 1: {
      return "ptToWorld";
      break;
    }
    case 2: {
      return "tweenRate";
      break;
    }
    case 3: {
      return "settleEps";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$Params(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.j6)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$Params = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_layout3d_DotPlanar3D$Params, "org.jpablo.graphexplorer.viewer.layout3d.DotPlanar3D$Params", ({
  j6: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$Params(k, gravity, cohesion, repulsionRange, initialTempFactor, cooling, minTempFactor) {
  this.vo = 0.0;
  this.GM = 0.0;
  this.Cr = 0.0;
  this.Cs = 0.0;
  this.GN = 0.0;
  this.Mx = 0.0;
  this.My = 0.0;
  this.vo = k;
  this.GM = gravity;
  this.Cr = cohesion;
  this.Cs = repulsionRange;
  this.GN = initialTempFactor;
  this.Mx = cooling;
  this.My = minTempFactor;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$Params.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$Params;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$Params() {
}
$h_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$Params.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, (-1911560794));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.vo));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.GM));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.Cr));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.Cs));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.GN));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.Mx));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.My));
  return $m_sr_Statics$().Z(acc, 7);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$Params) && (((((((this.vo === x$0.vo) && (this.GM === x$0.GM)) && (this.Cr === x$0.Cr)) && (this.Cs === x$0.Cs)) && (this.GN === x$0.GN)) && (this.Mx === x$0.Mx)) && (this.My === x$0.My))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 7;
});
$p.B = (function() {
  return "Params";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.vo;
      break;
    }
    case 1: {
      return this.GM;
      break;
    }
    case 2: {
      return this.Cr;
      break;
    }
    case 3: {
      return this.Cs;
      break;
    }
    case 4: {
      return this.GN;
      break;
    }
    case 5: {
      return this.Mx;
      break;
    }
    case 6: {
      return this.My;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "k";
      break;
    }
    case 1: {
      return "gravity";
      break;
    }
    case 2: {
      return "cohesion";
      break;
    }
    case 3: {
      return "repulsionRange";
      break;
    }
    case 4: {
      return "initialTempFactor";
      break;
    }
    case 5: {
      return "cooling";
      break;
    }
    case 6: {
      return "minTempFactor";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$Params(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.j7)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$Params = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$Params, "org.jpablo.graphexplorer.viewer.layout3d.ForceLayout3D$Params", ({
  j7: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Knob3D(id, label, min, max, step, default$1) {
  this.zu = null;
  this.Mz = null;
  this.MB = 0.0;
  this.MA = 0.0;
  this.MC = 0.0;
  this.Ct = 0.0;
  this.zu = id;
  this.Mz = label;
  this.MB = min;
  this.MA = max;
  this.MC = step;
  this.Ct = default$1;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Knob3D.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Knob3D;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_layout3d_Knob3D() {
}
$h_Lorg_jpablo_graphexplorer_viewer_layout3d_Knob3D.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, (-2042791033));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.zu));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Mz));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.MB));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.MA));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.MC));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.Ct));
  return $m_sr_Statics$().Z(acc, 6);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Knob3D) && ((((((this.MB === x$0.MB) && (this.MA === x$0.MA)) && (this.MC === x$0.MC)) && (this.Ct === x$0.Ct)) && (this.zu === x$0.zu)) && (this.Mz === x$0.Mz))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 6;
});
$p.B = (function() {
  return "Knob3D";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.zu;
      break;
    }
    case 1: {
      return this.Mz;
      break;
    }
    case 2: {
      return this.MB;
      break;
    }
    case 3: {
      return this.MA;
      break;
    }
    case 4: {
      return this.MC;
      break;
    }
    case 5: {
      return this.Ct;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "id";
      break;
    }
    case 1: {
      return "label";
      break;
    }
    case 2: {
      return "min";
      break;
    }
    case 3: {
      return "max";
      break;
    }
    case 4: {
      return "step";
      break;
    }
    case 5: {
      return "default";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_layout3d_Knob3D(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.j8)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_layout3d_Knob3D = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_layout3d_Knob3D, "org.jpablo.graphexplorer.viewer.layout3d.Knob3D", ({
  j8: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$Params(k, layerGap, sweeps, minSepFactor, tweenRate, settleEpsFactor) {
  this.vp = 0.0;
  this.GP = 0.0;
  this.ME = 0;
  this.MD = 0.0;
  this.MF = 0.0;
  this.GQ = 0.0;
  this.vp = k;
  this.GP = layerGap;
  this.ME = sweeps;
  this.MD = minSepFactor;
  this.MF = tweenRate;
  this.GQ = settleEpsFactor;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$Params.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$Params;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$Params() {
}
$h_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$Params.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, (-1911560794));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.vp));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.GP));
  acc = $m_sr_Statics$().k(acc, this.ME);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.MD));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.MF));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.GQ));
  return $m_sr_Statics$().Z(acc, 6);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$Params) && ((((((this.vp === x$0.vp) && (this.GP === x$0.GP)) && (this.ME === x$0.ME)) && (this.MD === x$0.MD)) && (this.MF === x$0.MF)) && (this.GQ === x$0.GQ))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 6;
});
$p.B = (function() {
  return "Params";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.vp;
      break;
    }
    case 1: {
      return this.GP;
      break;
    }
    case 2: {
      return this.ME;
      break;
    }
    case 3: {
      return this.MD;
      break;
    }
    case 4: {
      return this.MF;
      break;
    }
    case 5: {
      return this.GQ;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "k";
      break;
    }
    case 1: {
      return "layerGap";
      break;
    }
    case 2: {
      return "sweeps";
      break;
    }
    case 3: {
      return "minSepFactor";
      break;
    }
    case 4: {
      return "tweenRate";
      break;
    }
    case 5: {
      return "settleEpsFactor";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$Params(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.j9)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$Params = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayeredLayout3D$Params, "org.jpablo.graphexplorer.viewer.layout3d.LayeredLayout3D$Params", ({
  j9: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayoutGraph(nodes, edges, clusters, hints) {
  this.l1 = null;
  this.hv = null;
  this.MG = null;
  this.GR = null;
  this.l1 = nodes;
  this.hv = edges;
  this.MG = clusters;
  this.GR = hints;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayoutGraph.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayoutGraph;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_layout3d_LayoutGraph() {
}
$h_Lorg_jpablo_graphexplorer_viewer_layout3d_LayoutGraph.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-210684819), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayoutGraph)) {
    var x = this.l1;
    var x$2 = x$0.l1;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      var x$3 = this.hv;
      var x$4 = x$0.hv;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.MG;
      var x$6 = x$0.MG;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$7 = this.GR;
      var x$8 = x$0.GR;
      return ((x$7 === null) ? (x$8 === null) : x$7.e(x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 4;
});
$p.B = (function() {
  return "LayoutGraph";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.l1;
      break;
    }
    case 1: {
      return this.hv;
      break;
    }
    case 2: {
      return this.MG;
      break;
    }
    case 3: {
      return this.GR;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "nodes";
      break;
    }
    case 1: {
      return "edges";
      break;
    }
    case 2: {
      return "clusters";
      break;
    }
    case 3: {
      return "hints";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_layout3d_LayoutGraph(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ja)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_layout3d_LayoutGraph = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayoutGraph, "org.jpablo.graphexplorer.viewer.layout3d.LayoutGraph", ({
  ja: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayoutState3D(algoId, graph, positions, temperature, iteration, targets, pinned, motion, edgeOffsets) {
  this.l2 = null;
  this.he = null;
  this.fF = null;
  this.vq = 0.0;
  this.mk = 0;
  this.kE = null;
  this.lG = null;
  this.nc = null;
  this.lF = null;
  this.l2 = algoId;
  this.he = graph;
  this.fF = positions;
  this.vq = temperature;
  this.mk = iteration;
  this.kE = targets;
  this.lG = pinned;
  this.nc = motion;
  this.lF = edgeOffsets;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayoutState3D.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayoutState3D;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_layout3d_LayoutState3D() {
}
$h_Lorg_jpablo_graphexplorer_viewer_layout3d_LayoutState3D.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, (-862342120));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.l2));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.he));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.fF));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.vq));
  acc = $m_sr_Statics$().k(acc, this.mk);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.kE));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.lG));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.nc));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.lF));
  return $m_sr_Statics$().Z(acc, 9);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayoutState3D)) {
    if ((((this.vq === x$0.vq) && (this.mk === x$0.mk)) && (this.l2 === x$0.l2))) {
      var x = this.he;
      var x$2 = x$0.he;
      var $x_5 = ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$3 = this.fF;
      var x$4 = x$0.fF;
      var $x_4 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$5 = this.kE;
      var x$6 = x$0.kE;
      var $x_3 = ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$7 = this.lG;
      var x$8 = x$0.lG;
      var $x_2 = ((x$7 === null) ? (x$8 === null) : x$7.e(x$8));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$9 = this.nc;
      var x$10 = x$0.nc;
      var $x_1 = ((x$9 === null) ? (x$10 === null) : x$9.e(x$10));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$11 = this.lF;
      var x$12 = x$0.lF;
      return ((x$11 === null) ? (x$12 === null) : x$11.e(x$12));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 9;
});
$p.B = (function() {
  return "LayoutState3D";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.l2;
      break;
    }
    case 1: {
      return this.he;
      break;
    }
    case 2: {
      return this.fF;
      break;
    }
    case 3: {
      return this.vq;
      break;
    }
    case 4: {
      return this.mk;
      break;
    }
    case 5: {
      return this.kE;
      break;
    }
    case 6: {
      return this.lG;
      break;
    }
    case 7: {
      return this.nc;
      break;
    }
    case 8: {
      return this.lF;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "algoId";
      break;
    }
    case 1: {
      return "graph";
      break;
    }
    case 2: {
      return "positions";
      break;
    }
    case 3: {
      return "temperature";
      break;
    }
    case 4: {
      return "iteration";
      break;
    }
    case 5: {
      return "targets";
      break;
    }
    case 6: {
      return "pinned";
      break;
    }
    case 7: {
      return "motion";
      break;
    }
    case 8: {
      return "edgeOffsets";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.DU = (function() {
  return (this.vq <= 0.0);
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_layout3d_LayoutState3D(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jb)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_layout3d_LayoutState3D = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_layout3d_LayoutState3D, "org.jpablo.graphexplorer.viewer.layout3d.LayoutState3D", ({
  jb: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_layout3d_PlanarHints(positions, edgePaths, sizes) {
  this.xg = null;
  this.MH = null;
  this.TB = null;
  this.xg = positions;
  this.MH = edgePaths;
  this.TB = sizes;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_layout3d_PlanarHints.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_layout3d_PlanarHints;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_layout3d_PlanarHints() {
}
$h_Lorg_jpablo_graphexplorer_viewer_layout3d_PlanarHints.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-1940556639), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_layout3d_PlanarHints)) {
    var x = this.xg;
    var x$2 = x$0.xg;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      var x$3 = this.MH;
      var x$4 = x$0.MH;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.TB;
      var x$6 = x$0.TB;
      return ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 3;
});
$p.B = (function() {
  return "PlanarHints";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.xg;
      break;
    }
    case 1: {
      return this.MH;
      break;
    }
    case 2: {
      return this.TB;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "positions";
      break;
    }
    case 1: {
      return "edgePaths";
      break;
    }
    case 2: {
      return "sizes";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_layout3d_PlanarHints(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jc)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_layout3d_PlanarHints = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_layout3d_PlanarHints, "org.jpablo.graphexplorer.viewer.layout3d.PlanarHints", ({
  jc: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3(x, y, z) {
  this.cq = 0.0;
  this.cr = 0.0;
  this.cg = 0.0;
  this.cq = x;
  this.cr = y;
  this.cg = z;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3() {
}
$h_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 2662207);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.cq));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.cr));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.cg));
  return $m_sr_Statics$().Z(acc, 3);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3) && (((this.cq === x$0.cq) && (this.cr === x$0.cr)) && (this.cg === x$0.cg))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 3;
});
$p.B = (function() {
  return "Vec3";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.cq;
      break;
    }
    case 1: {
      return this.cr;
      break;
    }
    case 2: {
      return this.cg;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "x";
      break;
    }
    case 1: {
      return "y";
      break;
    }
    case 2: {
      return "z";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.iQ = (function(o) {
  $m_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$();
  return new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3((this.cq + o.cq), (this.cr + o.cr), (this.cg + o.cg));
});
$p.fN = (function(o) {
  $m_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$();
  return new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3((this.cq - o.cq), (this.cr - o.cr), (this.cg - o.cg));
});
$p.dj = (function(k) {
  $m_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$();
  return new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3((this.cq * k), (this.cr * k), (this.cg * k));
});
$p.qW = (function(o) {
  return (((this.cq * o.cq) + (this.cr * o.cr)) + (this.cg * o.cg));
});
$p.IN = (function(o) {
  $m_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3$();
  return new $c_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3(((this.cr * o.cg) - (this.cg * o.cr)), ((this.cg * o.cq) - (this.cq * o.cg)), ((this.cq * o.cr) - (this.cr * o.cq)));
});
$p.ahM = (function(axis, angle) {
  var cosA = (+Math.cos(angle));
  var sinA = (+Math.sin(angle));
  return this.dj(cosA).iQ(axis.IN(this).dj(sinA)).iQ(axis.dj((axis.qW(this) * (1.0 - cosA))));
});
$p.js = (function() {
  var x = (((this.cq * this.cq) + (this.cr * this.cr)) + (this.cg * this.cg));
  return (+Math.sqrt(x));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jd)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_layout3d_Vec3, "org.jpablo.graphexplorer.viewer.layout3d.Vec3", ({
  jd: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId(value) {
  this.fY = null;
  this.fY = value;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_AttributeId() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_AttributeId.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $f_T__hashCode__I(this.fY);
});
$p.e = (function(x$0) {
  return $m_Lorg_jpablo_graphexplorer_viewer_models_AttributeId$().b0K(this.fY, x$0);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "AttributeId";
});
$p.A = (function(n) {
  return $m_Lorg_jpablo_graphexplorer_viewer_models_AttributeId$().b6N(this.fY, n);
});
$p.D = (function(n) {
  return $m_Lorg_jpablo_graphexplorer_viewer_models_AttributeId$().b6Q(this.fY, n);
});
$p.m = (function() {
  return this.fY;
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_models_AttributeId(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jl)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_models_AttributeId = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId, "org.jpablo.graphexplorer.viewer.models.AttributeId", ({
  jl: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeUpdates(statuses) {
  this.GS = null;
  this.GS = statuses;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeUpdates.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeUpdates;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_AttributeUpdates() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_AttributeUpdates.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 1716888611, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeUpdates)) {
    var x = this.GS;
    var x$2 = x$0.GS;
    return ((x === null) ? (x$2 === null) : x.e(x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "AttributeUpdates";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.GS;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "statuses";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.Wk = (function(attrs) {
  $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$();
  var this$5 = this.GS;
  var f = ((x$1, x$2) => {
    var x50 = new $c_T2(x$1, x$2);
    var x52 = x50.be;
    var attrs$1 = x50.bi;
    if ((x52 !== null)) {
      var attrId = ((x52.g() === null) ? null : x52.g().fY);
      var status = x52.h();
      if ((status instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single)) {
        return attrs$1.bN(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId(attrId), status.nd);
      }
      var x = $s_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$__Multiple__Lorg_jpablo_graphexplorer_viewer_models_AttrStatus();
      if (((x === null) ? (status === null) : x.e(status))) {
        return attrs$1;
      }
      var x$4 = $s_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$__Missing__Lorg_jpablo_graphexplorer_viewer_models_AttrStatus();
      if (((x$4 === null) ? (status === null) : x$4.e(status))) {
        return attrs$1.fz(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId(attrId));
      }
      throw new $c_s_MatchError(status);
    }
    throw new $c_s_MatchError(x50);
  });
  if ($is_sc_IndexedSeq(this$5)) {
    var at = 0;
    var end = this$5.C();
    var acc = attrs;
    var $x_1;
    while (true) {
      if ((at !== end)) {
        var temp$at = ((1 + at) | 0);
        var x0 = acc;
        var x1 = this$5.l(at);
        var temp$acc = f(x0, x1);
        at = temp$at;
        acc = temp$acc;
        continue;
      }
      var $x_1 = acc;
      break;
    }
  } else {
    var result = attrs;
    var it = this$5.o();
    while (it.p()) {
      var x0$1 = result;
      var x1$1 = it.q();
      result = f(x0$1, x1$1);
    }
    var $x_1 = result;
  }
  return $x_1;
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_models_AttributeUpdates(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jn)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_models_AttributeUpdates = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_AttributeUpdates, "org.jpablo.graphexplorer.viewer.models.AttributeUpdates", ({
  jn: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(values) {
  this.ce = null;
  this.ce = values;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_Attributes() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_Attributes.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$();
  return this.ce.x();
});
$p.e = (function(x$0) {
  return $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().lk(this.ce, x$0);
});
$p.m = (function() {
  return $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().bac(this.ce);
});
$p.z = (function() {
  $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$();
  return 1;
});
$p.B = (function() {
  $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$();
  return "Attributes";
});
$p.A = (function(n) {
  return $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().b6O(this.ce, n);
});
$p.D = (function(n) {
  return $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().b6R(this.ce, n);
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_models_Attributes(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jo)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_models_Attributes = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_Attributes, "org.jpablo.graphexplorer.viewer.models.Attributes", ({
  jo: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds(ids) {
  this.aS = null;
  this.aS = ids;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_ElementIds() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_ElementIds.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return this.aS.x();
});
$p.e = (function(x$0) {
  return $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().a3i(this.aS, x$0);
});
$p.m = (function() {
  return $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().bad(this.aS);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "ElementIds";
});
$p.A = (function(n) {
  return $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().b6P(this.aS, n);
});
$p.D = (function(n) {
  return $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().b6S(this.aS, n);
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_models_ElementIds(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jp)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_models_ElementIds = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds, "org.jpablo.graphexplorer.viewer.models.ElementIds", ({
  jp: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_IdsByKind(groups, nodes, arrows) {
  this.f3 = null;
  this.gg = null;
  this.gf = null;
  this.f3 = groups;
  this.gg = nodes;
  this.gf = arrows;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_IdsByKind.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_IdsByKind;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_IdsByKind() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_IdsByKind.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 161533845, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_IdsByKind)) {
    var x = this.f3;
    var x$2 = x$0.f3;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      var x$3 = this.gg;
      var x$4 = x$0.gg;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.gf;
      var x$6 = x$0.gf;
      return ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 3;
});
$p.B = (function() {
  return "IdsByKind";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.f3;
      break;
    }
    case 1: {
      return this.gg;
      break;
    }
    case 2: {
      return this.gf;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "groups";
      break;
    }
    case 1: {
      return "nodes";
      break;
    }
    case 2: {
      return "arrows";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_models_IdsByKind(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jr)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_models_IdsByKind = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_IdsByKind, "org.jpablo.graphexplorer.viewer.models.IdsByKind", ({
  jr: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_Lens(get, update) {
  this.MK = null;
  this.ML = null;
  this.MK = get;
  this.ML = update;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_Lens.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_Lens;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_Lens() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_Lens.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-2100438154), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_Lens)) {
    var x = this.MK;
    var x$2 = x$0.MK;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      var x$3 = this.ML;
      var x$4 = x$0.ML;
      return ((x$3 === null) ? (x$4 === null) : (x$3 === x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "Lens";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.MK;
  }
  if ((n === 1)) {
    return this.ML;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "get";
  }
  if ((n === 1)) {
    return "update";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_models_Lens(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.js)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_models_Lens = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_Lens, "org.jpablo.graphexplorer.viewer.models.Lens", ({
  js: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_selection_SelectByKind$MenuOption(label, kind, count) {
  this.MN = null;
  this.MM = null;
  this.TD = 0;
  this.MN = label;
  this.MM = kind;
  this.TD = count;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_selection_SelectByKind$MenuOption.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_selection_SelectByKind$MenuOption;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_selection_SelectByKind$MenuOption() {
}
$h_Lorg_jpablo_graphexplorer_viewer_selection_SelectByKind$MenuOption.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 1447076564);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.MN));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.MM));
  acc = $m_sr_Statics$().k(acc, this.TD);
  return $m_sr_Statics$().Z(acc, 3);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_selection_SelectByKind$MenuOption)) {
    if (((this.TD === x$0.TD) && (this.MN === x$0.MN))) {
      var x = this.MM;
      var x$2 = x$0.MM;
      return ((x === null) ? (x$2 === null) : (x === x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 3;
});
$p.B = (function() {
  return "MenuOption";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.MN;
      break;
    }
    case 1: {
      return this.MM;
      break;
    }
    case 2: {
      return this.TD;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "label";
      break;
    }
    case 1: {
      return "kind";
      break;
    }
    case 2: {
      return "count";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_selection_SelectByKind$MenuOption(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jw)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_selection_SelectByKind$MenuOption = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_selection_SelectByKind$MenuOption, "org.jpablo.graphexplorer.viewer.selection.SelectByKind$MenuOption", ({
  jw: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramOptions(showFields, showSignatures) {
  this.TF = false;
  this.TG = false;
  this.TF = showFields;
  this.TG = showSignatures;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramOptions.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramOptions;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_DiagramOptions() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_DiagramOptions.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, (-281250197));
  acc = $m_sr_Statics$().k(acc, (this.TF ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, (this.TG ? 1231 : 1237));
  return $m_sr_Statics$().Z(acc, 2);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramOptions) && ((this.TF === x$0.TF) && (this.TG === x$0.TG))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "DiagramOptions";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.TF;
  }
  if ((n === 1)) {
    return this.TG;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "showFields";
  }
  if ((n === 1)) {
    return "showSignatures";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_state_DiagramOptions(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jz)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_state_DiagramOptions = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_DiagramOptions, "org.jpablo.graphexplorer.viewer.state.DiagramOptions", ({
  jz: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_DocumentSessionId(value) {
  this.Cv = null;
  this.Cv = value;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_DocumentSessionId.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_DocumentSessionId;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_DocumentSessionId() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_DocumentSessionId.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 1839036188, true);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_DocumentSessionId) && (this.Cv === x$0.Cv)));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "DocumentSessionId";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Cv;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_state_DocumentSessionId(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jA)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_state_DocumentSessionId = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_DocumentSessionId, "org.jpablo.graphexplorer.viewer.state.DocumentSessionId", ({
  jA: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice(level, message, suggestedFormat) {
  this.TH = null;
  this.Cw = null;
  this.TI = null;
  this.TH = level;
  this.Cw = message;
  this.TI = suggestedFormat;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 189203163, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice)) {
    var x = this.TH;
    var x$2 = x$0.TH;
    if ((((x === null) ? (x$2 === null) : (x === x$2)) && (this.Cw === x$0.Cw))) {
      var x$3 = this.TI;
      var x$4 = x$0.TI;
      return ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 3;
});
$p.B = (function() {
  return "EditorNotice";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.TH;
      break;
    }
    case 1: {
      return this.Cw;
      break;
    }
    case 2: {
      return this.TI;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "level";
      break;
    }
    case 1: {
      return "message";
      break;
    }
    case 2: {
      return "suggestedFormat";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.J6 = (function() {
  var x = this.TH;
  var x$2 = $s_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level$__Error__Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level();
  return ((x === null) ? (x$2 === null) : (x === x$2));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jB)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice, "org.jpablo.graphexplorer.viewer.state.EditorNotice", ({
  jB: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_GraphState(text, viewerGraph, format, lastOrigin, graphInSync) {
  this.qo = null;
  this.qp = null;
  this.vr = null;
  this.zw = null;
  this.xi = false;
  this.qo = text;
  this.qp = viewerGraph;
  this.vr = format;
  this.zw = lastOrigin;
  this.xi = graphInSync;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_GraphState.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_GraphState;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_GraphState() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_GraphState.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, (-31223805));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.qo));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.qp));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.vr));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.zw));
  acc = $m_sr_Statics$().k(acc, (this.xi ? 1231 : 1237));
  return $m_sr_Statics$().Z(acc, 5);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_GraphState)) {
    if (((this.xi === x$0.xi) && (this.qo === x$0.qo))) {
      var x = this.qp;
      var x$2 = x$0.qp;
      var $x_2 = ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.vr;
      var x$4 = x$0.vr;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : (x$3 === x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.zw;
      var x$6 = x$0.zw;
      return ((x$5 === null) ? (x$6 === null) : (x$5 === x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 5;
});
$p.B = (function() {
  return "GraphState";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.qo;
      break;
    }
    case 1: {
      return this.qp;
      break;
    }
    case 2: {
      return this.vr;
      break;
    }
    case 3: {
      return this.zw;
      break;
    }
    case 4: {
      return this.xi;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "text";
      break;
    }
    case 1: {
      return "viewerGraph";
      break;
    }
    case 2: {
      return "format";
      break;
    }
    case 3: {
      return "lastOrigin";
      break;
    }
    case 4: {
      return "graphInSync";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_state_GraphState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jC)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_state_GraphState = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_GraphState, "org.jpablo.graphexplorer.viewer.state.GraphState", ({
  jC: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$NavContext(outer, origin, dir) {
  this.MP = null;
  this.GT = null;
  this.ab2 = null;
  this.MP = origin;
  this.GT = dir;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.ab2 = outer;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$NavContext.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$NavContext;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$NavContext() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$NavContext.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 1026848706, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if (((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$NavContext) && (x$0.ab2 === this.ab2))) {
    var x = this.MP;
    var x$2 = x$0.MP;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      var x$3 = this.GT;
      var x$4 = x$0.GT;
      return ((x$3 === null) ? (x$4 === null) : (x$3 === x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "NavContext";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.MP;
  }
  if ((n === 1)) {
    return this.GT;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "origin";
  }
  if ((n === 1)) {
    return "dir";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$NavContext(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jD)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$NavContext = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$NavContext, "org.jpablo.graphexplorer.viewer.state.KeyboardNavOps$NavContext", ({
  jD: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$Cand(outer, arrow, far, center) {
  this.GU = null;
  this.GV = null;
  this.tn = null;
  this.ab3 = null;
  this.GU = arrow;
  this.GV = far;
  this.tn = center;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.ab3 = outer;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$Cand.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$Cand;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$Cand() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$Cand.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-582094287), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if (((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$Cand) && (x$0.ab3 === this.ab3))) {
    var x = this.GU;
    var x$2 = x$0.GU;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      var x$3 = this.GV;
      var x$4 = x$0.GV;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.tn;
      var x$6 = x$0.tn;
      return ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 3;
});
$p.B = (function() {
  return "Cand";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.GU;
      break;
    }
    case 1: {
      return this.GV;
      break;
    }
    case 2: {
      return this.tn;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "arrow";
      break;
    }
    case 1: {
      return "far";
      break;
    }
    case 2: {
      return "center";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$Cand(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jE)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$Cand = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$Cand, "org.jpablo.graphexplorer.viewer.state.KeyboardNavOps$keyboardNav$Cand", ({
  jE: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$NavBox(outer, l, t, r, b) {
  this.xk = 0.0;
  this.xm = 0.0;
  this.xl = 0.0;
  this.xj = 0.0;
  this.ab4 = null;
  this.xk = l;
  this.xm = t;
  this.xl = r;
  this.xj = b;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.ab4 = outer;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$NavBox.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$NavBox;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$NavBox() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$NavBox.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, (-1968729656));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.xk));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.xm));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.xl));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.xj));
  return $m_sr_Statics$().Z(acc, 4);
});
$p.e = (function(x$0) {
  return ((this === x$0) || (((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$NavBox) && (x$0.ab4 === this.ab4)) && ((((this.xk === x$0.xk) && (this.xm === x$0.xm)) && (this.xl === x$0.xl)) && (this.xj === x$0.xj))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 4;
});
$p.B = (function() {
  return "NavBox";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.xk;
      break;
    }
    case 1: {
      return this.xm;
      break;
    }
    case 2: {
      return this.xl;
      break;
    }
    case 3: {
      return this.xj;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "l";
      break;
    }
    case 1: {
      return "t";
      break;
    }
    case 2: {
      return "r";
      break;
    }
    case 3: {
      return "b";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.aYg = (function() {
  return new $c_Lorg_jpablo_graphexplorer_viewer_utils_ClientPoint((0.5 * (this.xk + this.xl)), (0.5 * (this.xm + this.xj)));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$NavBox(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jF)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$NavBox = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$NavBox, "org.jpablo.graphexplorer.viewer.state.KeyboardNavOps$keyboardNav$NavBox", ({
  jF: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_Page(id, hiddenElements, collapsedGroups, diagramOptions) {
  this.MR = null;
  this.GX = null;
  this.GW = null;
  this.MQ = null;
  this.MR = id;
  this.GX = hiddenElements;
  this.GW = collapsedGroups;
  this.MQ = diagramOptions;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_Page.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_Page;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_Page() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_Page.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 531910433, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_Page)) {
    if ((this.MR === x$0.MR)) {
      var x = this.GX;
      var x$2 = x$0.GX;
      var $x_2 = ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.GW;
      var x$4 = x$0.GW;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.MQ;
      var x$6 = x$0.MQ;
      return ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 4;
});
$p.B = (function() {
  return "Page";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.MR;
      break;
    }
    case 1: {
      return new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds(this.GX);
      break;
    }
    case 2: {
      return this.GW;
      break;
    }
    case 3: {
      return this.MQ;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "id";
      break;
    }
    case 1: {
      return "hiddenElements";
      break;
    }
    case 2: {
      return "collapsedGroups";
      break;
    }
    case 3: {
      return "diagramOptions";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_state_Page(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jI)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_state_Page = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_Page, "org.jpablo.graphexplorer.viewer.state.Page", ({
  jI: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState(hiddenElements, collapsedGroups, projectName, source, format, autoDetectFormat) {
  this.ob = null;
  this.oa = null;
  this.oc = null;
  this.hf = null;
  this.nf = null;
  this.o9 = null;
  this.ob = hiddenElements;
  this.oa = collapsedGroups;
  this.oc = projectName;
  this.hf = source;
  this.nf = format;
  this.o9 = autoDetectFormat;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-2134525444), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState)) {
    var x = this.ob;
    var x$2 = x$0.ob;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      var x$3 = this.oa;
      var x$4 = x$0.oa;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_2 = false;
    }
    if ((($x_2 && (this.oc === x$0.oc)) && (this.hf === x$0.hf))) {
      var x$5 = this.nf;
      var x$6 = x$0.nf;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$7 = this.o9;
      var x$8 = x$0.o9;
      return ((x$7 === null) ? (x$8 === null) : x$7.e(x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 6;
});
$p.B = (function() {
  return "PersistedDiagramState";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds(this.ob);
      break;
    }
    case 1: {
      return this.oa;
      break;
    }
    case 2: {
      return this.oc;
      break;
    }
    case 3: {
      return this.hf;
      break;
    }
    case 4: {
      return this.nf;
      break;
    }
    case 5: {
      return this.o9;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "hiddenElements";
      break;
    }
    case 1: {
      return "collapsedGroups";
      break;
    }
    case 2: {
      return "projectName";
      break;
    }
    case 3: {
      return "source";
      break;
    }
    case 4: {
      return "format";
      break;
    }
    case 5: {
      return "autoDetectFormat";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jJ)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState, "org.jpablo.graphexplorer.viewer.state.PersistedDiagramState", ({
  jJ: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_Project(id, name, advancedMode, projectSettings, page) {
  this.xn = null;
  this.Cz = null;
  this.Cy = false;
  this.CA = null;
  this.ng = null;
  this.xn = id;
  this.Cz = name;
  this.Cy = advancedMode;
  this.CA = projectSettings;
  this.ng = page;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_Project.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_Project;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_Project() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_Project.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 1355342585);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.xn));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Cz));
  acc = $m_sr_Statics$().k(acc, (this.Cy ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.CA));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.ng));
  return $m_sr_Statics$().Z(acc, 5);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_Project)) {
    if ((this.Cy === x$0.Cy)) {
      var x = this.xn;
      var x$2 = x$0.xn;
      var $x_2 = ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      var $x_2 = false;
    }
    if (($x_2 && (this.Cz === x$0.Cz))) {
      var x$3 = this.CA;
      var x$4 = x$0.CA;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.ng;
      var x$6 = x$0.ng;
      return ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 5;
});
$p.B = (function() {
  return "Project";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.xn;
      break;
    }
    case 1: {
      return this.Cz;
      break;
    }
    case 2: {
      return this.Cy;
      break;
    }
    case 3: {
      return this.CA;
      break;
    }
    case 4: {
      return this.ng;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "id";
      break;
    }
    case 1: {
      return "name";
      break;
    }
    case 2: {
      return "advancedMode";
      break;
    }
    case 3: {
      return "projectSettings";
      break;
    }
    case 4: {
      return "page";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_state_Project(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jK)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_state_Project = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_Project, "org.jpablo.graphexplorer.viewer.state.Project", ({
  jK: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_ProjectId(value) {
  this.cv = null;
  this.cv = value;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_ProjectId.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_ProjectId;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_ProjectId() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_ProjectId.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 646282719, true);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_ProjectId) && (this.cv === x$0.cv)));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "ProjectId";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.cv;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_state_ProjectId(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jL)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_state_ProjectId = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_ProjectId, "org.jpablo.graphexplorer.viewer.state.ProjectId", ({
  jL: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_ProjectOps(project, x$2) {
  this.a0T = null;
  this.ab7 = null;
  this.H0 = null;
  this.CB = null;
  this.nh = null;
  this.a0T = project;
  this.ab7 = project.P();
  this.H0 = $f_Lcom_raquo_airstream_state_Var__distinct__Lcom_raquo_airstream_state_Var($f_Lcom_raquo_airstream_state_Var__zoomLazy__F1__F2__Lcom_raquo_airstream_state_Var(project, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => _$1.Cz)), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((p, n) => new $c_Lorg_jpablo_graphexplorer_viewer_state_Project(p.xn, n, p.Cy, p.CA, p.ng)))));
  this.CB = $f_Lcom_raquo_airstream_state_Var__distinct__Lcom_raquo_airstream_state_Var($f_Lcom_raquo_airstream_state_Var__zoomLazy__F1__F2__Lcom_raquo_airstream_state_Var(project, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds(_$2.ng.GX))), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((p$2, s) => new $c_Lcom_softwaremill_quicklens_package$PathModify(p$2, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((p$2$1) => ((x) => {
    var $x_4 = p$2$1.xn;
    var $x_3 = p$2$1.Cz;
    var $x_2 = p$2$1.Cy;
    var $x_1 = p$2$1.CA;
    var id$1 = p$2$1.ng.MR;
    var ev$1 = x.i(new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds(p$2$1.ng.GX));
    return new $c_Lorg_jpablo_graphexplorer_viewer_state_Project($x_4, $x_3, $x_2, $x_1, new $c_Lorg_jpablo_graphexplorer_viewer_state_Page(id$1, ((ev$1 === null) ? null : ev$1.aS), p$2$1.ng.GW, p$2$1.ng.MQ));
  }))(p$2))).Y3(new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds(((s === null) ? null : s.aS)))))));
  this.nh = $f_Lcom_raquo_airstream_state_Var__distinct__Lcom_raquo_airstream_state_Var($f_Lcom_raquo_airstream_state_Var__zoomLazy__F1__F2__Lcom_raquo_airstream_state_Var(project, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4) => _$4.ng.GW)), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((p$3, s$2) => new $c_Lcom_softwaremill_quicklens_package$PathModify(p$3, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((p$2$2) => ((x$1) => new $c_Lorg_jpablo_graphexplorer_viewer_state_Project(p$2$2.xn, p$2$2.Cz, p$2$2.Cy, p$2$2.CA, new $c_Lorg_jpablo_graphexplorer_viewer_state_Page(p$2$2.ng.MR, p$2$2.ng.GX, x$1.i(p$2$2.ng.GW), p$2$2.ng.MQ))))(p$3))).Y3(s$2)))));
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_ProjectOps.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_ProjectOps;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_ProjectOps() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_ProjectOps.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-79822553), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_ProjectOps)) {
    var x = this.a0T;
    var x$2 = x$0.a0T;
    return ((x === null) ? (x$2 === null) : (x === x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "ProjectOps";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.a0T;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "project";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_state_ProjectOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jM)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_state_ProjectOps = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_ProjectOps, "org.jpablo.graphexplorer.viewer.state.ProjectOps", ({
  jM: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_ProjectSettings(basePaths, hiddenFields, hiddenNodeIds) {
  this.a0U = null;
  this.a0V = null;
  this.a0W = null;
  this.a0U = basePaths;
  this.a0V = hiddenFields;
  this.a0W = hiddenNodeIds;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_ProjectSettings.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_ProjectSettings;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_ProjectSettings() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_ProjectSettings.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-60293183), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_ProjectSettings)) {
    var x = this.a0U;
    var x$2 = x$0.a0U;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      var x$3 = this.a0V;
      var x$4 = x$0.a0V;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.a0W;
      var x$6 = x$0.a0W;
      return ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 3;
});
$p.B = (function() {
  return "ProjectSettings";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.a0U;
      break;
    }
    case 1: {
      return this.a0V;
      break;
    }
    case 2: {
      return this.a0W;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "basePaths";
      break;
    }
    case 1: {
      return "hiddenFields";
      break;
    }
    case 2: {
      return "hiddenNodeIds";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_state_ProjectSettings(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jN)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_state_ProjectSettings = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_ProjectSettings, "org.jpablo.graphexplorer.viewer.state.ProjectSettings", ({
  jN: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_RecordCellBox(path, port, llx, lly, urx, ury) {
  this.qq = null;
  this.H1 = null;
  this.to = 0.0;
  this.zz = 0.0;
  this.zA = 0.0;
  this.tp = 0.0;
  this.qq = path;
  this.H1 = port;
  this.to = llx;
  this.zz = lly;
  this.zA = urx;
  this.tp = ury;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_RecordCellBox.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_RecordCellBox;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_RecordCellBox() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_RecordCellBox.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 344291160);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.qq));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.H1));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.to));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.zz));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.zA));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.tp));
  return $m_sr_Statics$().Z(acc, 6);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_RecordCellBox)) {
    if (((((this.to === x$0.to) && (this.zz === x$0.zz)) && (this.zA === x$0.zA)) && (this.tp === x$0.tp))) {
      var x = this.qq;
      var x$2 = x$0.qq;
      var $x_1 = ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.H1;
      var x$4 = x$0.H1;
      return ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 6;
});
$p.B = (function() {
  return "RecordCellBox";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.qq;
      break;
    }
    case 1: {
      return this.H1;
      break;
    }
    case 2: {
      return this.to;
      break;
    }
    case 3: {
      return this.zz;
      break;
    }
    case 4: {
      return this.zA;
      break;
    }
    case 5: {
      return this.tp;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "path";
      break;
    }
    case 1: {
      return "port";
      break;
    }
    case 2: {
      return "llx";
      break;
    }
    case 3: {
      return "lly";
      break;
    }
    case 4: {
      return "urx";
      break;
    }
    case 5: {
      return "ury";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.aTs = (function() {
  return (this.zA - this.to);
});
$p.aP8 = (function() {
  return (this.tp - this.zz);
});
$p.aZ0 = (function(x, y) {
  return ((((x >= this.to) && (x <= this.zA)) && (y >= this.zz)) && (y <= this.tp));
});
$p.b00 = (function(x, y) {
  var $x_2 = $m_jl_Math$();
  var x$1 = (this.to - x);
  var y$1 = (x - this.zA);
  var y$2 = (+Math.max(x$1, y$1));
  var $x_1 = Math.max(0.0, y$2);
  var x$2 = (this.zz - y);
  var y$3 = (y - this.tp);
  var y$4 = (+Math.max(x$2, y$3));
  return $x_2.ga((+$x_1), (+Math.max(0.0, y$4)));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_state_RecordCellBox(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jO)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_state_RecordCellBox = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_RecordCellBox, "org.jpablo.graphexplorer.viewer.state.RecordCellBox", ({
  jO: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_SelectedCell(nodeId, path) {
  this.bT = null;
  this.f4 = null;
  this.bT = nodeId;
  this.f4 = path;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_SelectedCell.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_SelectedCell;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_SelectedCell() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_SelectedCell.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 961018445, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_SelectedCell)) {
    var x = this.bT;
    var x$2 = x$0.bT;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      var x$3 = this.f4;
      var x$4 = x$0.f4;
      return ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "SelectedCell";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.bT;
  }
  if ((n === 1)) {
    return this.f4;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "nodeId";
  }
  if ((n === 1)) {
    return "path";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_state_SelectedCell(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jT)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_state_SelectedCell = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_SelectedCell, "org.jpablo.graphexplorer.viewer.state.SelectedCell", ({
  jT: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$Entry(source, proto) {
  this.TO = null;
  this.TN = null;
  this.TO = source;
  this.TN = proto;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$Entry.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$Entry;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$Entry() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$Entry.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 1909400236, true);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$Entry) && ((this.TO === x$0.TO) && $m_sr_BoxesRunTime$().Q(this.TN, x$0.TN))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "Entry";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.TO;
  }
  if ((n === 1)) {
    return this.TN;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "source";
  }
  if ((n === 1)) {
    return "proto";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$Entry(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jU)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$Entry = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$Entry, "org.jpablo.graphexplorer.viewer.state.ThumbnailSvgCache$Entry", ({
  jU: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$Key(format, hash, len) {
  this.TP = null;
  this.TQ = 0;
  this.TR = 0;
  this.TP = format;
  this.TQ = hash;
  this.TR = len;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$Key.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$Key;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$Key() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$Key.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 75327);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.TP));
  acc = $m_sr_Statics$().k(acc, this.TQ);
  acc = $m_sr_Statics$().k(acc, this.TR);
  return $m_sr_Statics$().Z(acc, 3);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$Key)) {
    if (((this.TQ === x$0.TQ) && (this.TR === x$0.TR))) {
      var x = this.TP;
      var x$2 = x$0.TP;
      return ((x === null) ? (x$2 === null) : (x === x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 3;
});
$p.B = (function() {
  return "Key";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.TP;
      break;
    }
    case 1: {
      return this.TQ;
      break;
    }
    case 2: {
      return this.TR;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "format";
      break;
    }
    case 1: {
      return "hash";
      break;
    }
    case 2: {
      return "len";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$Key(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jV)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$Key = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailSvgCache$Key, "org.jpablo.graphexplorer.viewer.state.ThumbnailSvgCache$Key", ({
  jV: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings(leftPanelVisible, rightPanelTabIndex, currentTheme, promptLabelBeforeNewNode, rightPanelWidth, wrapSourceLines, elementsPinned, view3D, enable3D, layout3D, nav3DTrackpad, label3DBillboard, libraryListMode, librarySort, libraryFormatFilter, schemaVersion) {
  this.mp = false;
  this.mv = 0;
  this.lH = null;
  this.mu = false;
  this.mw = null;
  this.my = false;
  this.ml = false;
  this.mx = false;
  this.mm = false;
  this.mo = null;
  this.mt = false;
  this.mn = false;
  this.mr = false;
  this.ms = null;
  this.mq = null;
  this.ni = 0;
  this.mp = leftPanelVisible;
  this.mv = rightPanelTabIndex;
  this.lH = currentTheme;
  this.mu = promptLabelBeforeNewNode;
  this.mw = rightPanelWidth;
  this.my = wrapSourceLines;
  this.ml = elementsPinned;
  this.mx = view3D;
  this.mm = enable3D;
  this.mo = layout3D;
  this.mt = nav3DTrackpad;
  this.mn = label3DBillboard;
  this.mr = libraryListMode;
  this.ms = librarySort;
  this.mq = libraryFormatFilter;
  this.ni = schemaVersion;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, (-1267405707));
  acc = $m_sr_Statics$().k(acc, (this.mp ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, this.mv);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.lH));
  acc = $m_sr_Statics$().k(acc, (this.mu ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.mw));
  acc = $m_sr_Statics$().k(acc, (this.my ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, (this.ml ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, (this.mx ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, (this.mm ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.mo));
  acc = $m_sr_Statics$().k(acc, (this.mt ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, (this.mn ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, (this.mr ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.ms));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.mq));
  acc = $m_sr_Statics$().k(acc, this.ni);
  return $m_sr_Statics$().Z(acc, 16);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings)) {
    if ((((((((((((this.mp === x$0.mp) && (this.mv === x$0.mv)) && (this.mu === x$0.mu)) && (this.my === x$0.my)) && (this.ml === x$0.ml)) && (this.mx === x$0.mx)) && (this.mm === x$0.mm)) && (this.mt === x$0.mt)) && (this.mn === x$0.mn)) && (this.mr === x$0.mr)) && (this.ni === x$0.ni))) {
      var x = this.lH;
      var x$2 = x$0.lH;
      var $x_4 = ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$3 = this.mw;
      var x$4 = x$0.mw;
      var $x_3 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$5 = this.mo;
      var x$6 = x$0.mo;
      var $x_2 = ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$7 = this.ms;
      var x$8 = x$0.ms;
      var $x_1 = ((x$7 === null) ? (x$8 === null) : x$7.e(x$8));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$9 = this.mq;
      var x$10 = x$0.mq;
      return ((x$9 === null) ? (x$10 === null) : x$9.e(x$10));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 16;
});
$p.B = (function() {
  return "ViewerSettings";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.mp;
      break;
    }
    case 1: {
      return this.mv;
      break;
    }
    case 2: {
      return this.lH;
      break;
    }
    case 3: {
      return this.mu;
      break;
    }
    case 4: {
      return this.mw;
      break;
    }
    case 5: {
      return this.my;
      break;
    }
    case 6: {
      return this.ml;
      break;
    }
    case 7: {
      return this.mx;
      break;
    }
    case 8: {
      return this.mm;
      break;
    }
    case 9: {
      return this.mo;
      break;
    }
    case 10: {
      return this.mt;
      break;
    }
    case 11: {
      return this.mn;
      break;
    }
    case 12: {
      return this.mr;
      break;
    }
    case 13: {
      return this.ms;
      break;
    }
    case 14: {
      return this.mq;
      break;
    }
    case 15: {
      return this.ni;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "leftPanelVisible";
      break;
    }
    case 1: {
      return "rightPanelTabIndex";
      break;
    }
    case 2: {
      return "currentTheme";
      break;
    }
    case 3: {
      return "promptLabelBeforeNewNode";
      break;
    }
    case 4: {
      return "rightPanelWidth";
      break;
    }
    case 5: {
      return "wrapSourceLines";
      break;
    }
    case 6: {
      return "elementsPinned";
      break;
    }
    case 7: {
      return "view3D";
      break;
    }
    case 8: {
      return "enable3D";
      break;
    }
    case 9: {
      return "layout3D";
      break;
    }
    case 10: {
      return "nav3DTrackpad";
      break;
    }
    case 11: {
      return "label3DBillboard";
      break;
    }
    case 12: {
      return "libraryListMode";
      break;
    }
    case 13: {
      return "librarySort";
      break;
    }
    case 14: {
      return "libraryFormatFilter";
      break;
    }
    case 15: {
      return "schemaVersion";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jZ)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings, "org.jpablo.graphexplorer.viewer.state.ViewerSettings", ({
  jZ: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerState$PendingNewGroup(outer, elementIds) {
  this.U3 = null;
  this.abu = null;
  this.U3 = elementIds;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.abu = outer;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerState$PendingNewGroup.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerState$PendingNewGroup;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_ViewerState$PendingNewGroup() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_ViewerState$PendingNewGroup.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-35352168), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if (((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerState$PendingNewGroup) && (x$0.abu === this.abu))) {
    var x = this.U3;
    var x$2 = x$0.U3;
    return ((x === null) ? (x$2 === null) : x.e(x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "PendingNewGroup";
});
$p.A = (function(n) {
  matchResult11: {
    var $x_1;
    if ((n === 0)) {
      var $x_1 = this.U3;
      break matchResult11;
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  return new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds($x_1);
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "elementIds";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_state_ViewerState$PendingNewGroup(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.k1)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_state_ViewerState$PendingNewGroup = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_ViewerState$PendingNewGroup, "org.jpablo.graphexplorer.viewer.state.ViewerState$PendingNewGroup", ({
  k1: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerState$PendingNewNode(outer, attributes, direction) {
  this.U4 = null;
  this.U5 = null;
  this.abv = null;
  this.U4 = attributes;
  this.U5 = direction;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.abv = outer;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerState$PendingNewNode.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerState$PendingNewNode;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_ViewerState$PendingNewNode() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_ViewerState$PendingNewNode.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-332131043), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if (((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerState$PendingNewNode) && (x$0.abv === this.abv))) {
    var x = this.U4;
    var x$2 = x$0.U4;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      var x$3 = this.U5;
      var x$4 = x$0.U5;
      return ((x$3 === null) ? (x$4 === null) : (x$3 === x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "PendingNewNode";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(this.U4);
  }
  if ((n === 1)) {
    return this.U5;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "attributes";
  }
  if ((n === 1)) {
    return "direction";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_state_ViewerState$PendingNewNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.k2)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_state_ViewerState$PendingNewNode = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_ViewerState$PendingNewNode, "org.jpablo.graphexplorer.viewer.state.ViewerState$PendingNewNode", ({
  k2: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_utils_BBox(x, y, width, height) {
  this.xt = 0.0;
  this.vu = 0.0;
  this.zP = 0.0;
  this.zO = 0.0;
  this.xt = x;
  this.vu = y;
  this.zP = width;
  this.zO = height;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_utils_BBox.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_utils_BBox;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_utils_BBox() {
}
$h_Lorg_jpablo_graphexplorer_viewer_utils_BBox.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 2033193);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.xt));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.vu));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.zP));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.zO));
  return $m_sr_Statics$().Z(acc, 4);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_utils_BBox) && ((((this.xt === x$0.xt) && (this.vu === x$0.vu)) && (this.zP === x$0.zP)) && (this.zO === x$0.zO))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 4;
});
$p.B = (function() {
  return "BBox";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.xt;
      break;
    }
    case 1: {
      return this.vu;
      break;
    }
    case 2: {
      return this.zP;
      break;
    }
    case 3: {
      return this.zO;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "x";
      break;
    }
    case 1: {
      return "y";
      break;
    }
    case 2: {
      return "width";
      break;
    }
    case 3: {
      return "height";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_utils_BBox(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.k7)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_utils_BBox = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_utils_BBox, "org.jpablo.graphexplorer.viewer.utils.BBox", ({
  k7: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_utils_ClientPoint(x, y) {
  this.fi = 0.0;
  this.fj = 0.0;
  this.fi = x;
  this.fj = y;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_utils_ClientPoint.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_utils_ClientPoint;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_utils_ClientPoint() {
}
$h_Lorg_jpablo_graphexplorer_viewer_utils_ClientPoint.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 1480179813);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.fi));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.fj));
  return $m_sr_Statics$().Z(acc, 2);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_utils_ClientPoint) && ((this.fi === x$0.fi) && (this.fj === x$0.fj))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "ClientPoint";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.fi;
  }
  if ((n === 1)) {
    return this.fj;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "x";
  }
  if ((n === 1)) {
    return "y";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_utils_ClientPoint(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.k8)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_utils_ClientPoint = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_utils_ClientPoint, "org.jpablo.graphexplorer.viewer.utils.ClientPoint", ({
  k8: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_utils_MouseActionRect(start, end, shift) {
  this.oe = null;
  this.jK = null;
  this.CL = false;
  this.oe = start;
  this.jK = end;
  this.CL = shift;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_utils_MouseActionRect.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_utils_MouseActionRect;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_utils_MouseActionRect() {
}
$h_Lorg_jpablo_graphexplorer_viewer_utils_MouseActionRect.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 272975775);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.oe));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.jK));
  acc = $m_sr_Statics$().k(acc, (this.CL ? 1231 : 1237));
  return $m_sr_Statics$().Z(acc, 3);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_utils_MouseActionRect)) {
    if ((this.CL === x$0.CL)) {
      var x = this.oe;
      var x$2 = x$0.oe;
      var $x_1 = ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.jK;
      var x$4 = x$0.jK;
      return ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 3;
});
$p.B = (function() {
  return "MouseActionRect";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.oe;
      break;
    }
    case 1: {
      return this.jK;
      break;
    }
    case 2: {
      return this.CL;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "start";
      break;
    }
    case 1: {
      return "end";
      break;
    }
    case 2: {
      return "shift";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.c = (function() {
  return ((this.oe.fi === this.jK.fi) && (this.oe.fj === this.jK.fj));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_utils_MouseActionRect(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.k9)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_utils_MouseActionRect = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_utils_MouseActionRect, "org.jpablo.graphexplorer.viewer.utils.MouseActionRect", ({
  k9: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint(x, y) {
  this.gI = 0.0;
  this.gJ = 0.0;
  this.gI = x;
  this.gJ = y;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint() {
}
$h_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, (-998282836));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.gI));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.gJ));
  return $m_sr_Statics$().Z(acc, 2);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint) && ((this.gI === x$0.gI) && (this.gJ === x$0.gJ))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "SvgPoint";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.gI;
  }
  if ((n === 1)) {
    return this.gJ;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "x";
  }
  if ((n === 1)) {
    return "y";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ka)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_utils_SvgPoint, "org.jpablo.graphexplorer.viewer.utils.SvgPoint", ({
  ka: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_scalajs_dom_DOMList$DOMListIterator(domList) {
  this.abF = null;
  this.Ug = 0;
  this.abF = domList;
  this.Ug = 0;
}
$p = $c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype = new $h_O();
$p.constructor = $c_Lorg_scalajs_dom_DOMList$DOMListIterator;
/** @constructor */
function $h_Lorg_scalajs_dom_DOMList$DOMListIterator() {
}
$h_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype = $p;
$p.V = (function() {
  return (-1);
});
$p.F = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f);
});
$p.iW = (function(p) {
  return $f_sc_IterableOnceOps__find__F1__s_Option(this, p);
});
$p.hO = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$p.kT = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$p.aa = (function() {
  return $f_sc_IterableOnceOps__size__I(this);
});
$p.cR = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
});
$p.k2 = (function(num) {
  return $f_sc_IterableOnceOps__sum__s_math_Numeric__O(this, num);
});
$p.lr = (function(ord) {
  return $f_sc_IterableOnceOps__min__s_math_Ordering__O(this, ord);
});
$p.lq = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord);
});
$p.nw = (function(pf) {
  return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this, pf);
});
$p.lf = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$p.bM = (function() {
  return $m_sci_Nil$().b6(this);
});
$p.d2 = (function() {
  return $m_sci_Vector$().X(this);
});
$p.eX = (function(ev) {
  return $m_sci_Map$().ao(this);
});
$p.iz = (function() {
  return $m_sci_Seq$().fw(this);
});
$p.nG = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$p.o = (function() {
  return this;
});
$p.c = (function() {
  return (!this.p());
});
$p.lS = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs);
});
$p.Ju = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n);
});
$p.iV = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1));
});
$p.ui = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until);
});
$p.m = (function() {
  return "<iterator>";
});
$p.p = (function() {
  return (this.Ug < (this.abF.length | 0));
});
$p.q = (function() {
  var res = this.abF[this.Ug];
  this.Ug = ((1 + this.Ug) | 0);
  return res;
});
var $d_Lorg_scalajs_dom_DOMList$DOMListIterator = new $TypeData().i($c_Lorg_scalajs_dom_DOMList$DOMListIterator, "org.scalajs.dom.DOMList$DOMListIterator", ({
  Fr: 1,
  e: 1,
  f: 1,
  p: 1
}));
/** @constructor */
function $c_Lpprint_Tree$Ctx(width, leftOffset, indentCount, indentStep, literalColor, applyPrefixColor) {
  this.Uo = 0;
  this.Um = 0;
  this.Uk = 0;
  this.Ul = 0;
  this.Un = null;
  this.Uj = null;
  this.Uo = width;
  this.Um = leftOffset;
  this.Uk = indentCount;
  this.Ul = indentStep;
  this.Un = literalColor;
  this.Uj = applyPrefixColor;
}
$p = $c_Lpprint_Tree$Ctx.prototype = new $h_O();
$p.constructor = $c_Lpprint_Tree$Ctx;
/** @constructor */
function $h_Lpprint_Tree$Ctx() {
}
$h_Lpprint_Tree$Ctx.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, $f_T__hashCode__I("Ctx"));
  acc = $m_sr_Statics$().k(acc, this.Uo);
  acc = $m_sr_Statics$().k(acc, this.Um);
  acc = $m_sr_Statics$().k(acc, this.Uk);
  acc = $m_sr_Statics$().k(acc, this.Ul);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Un));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Uj));
  return $m_sr_Statics$().Z(acc, 6);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpprint_Tree$Ctx)) {
    if (((((this.Uo === x$0.Uo) && (this.Um === x$0.Um)) && (this.Uk === x$0.Uk)) && (this.Ul === x$0.Ul))) {
      var x = this.Un;
      var x$2 = x$0.Un;
      var $x_1 = ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.Uj;
      var x$4 = x$0.Uj;
      return ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 6;
});
$p.B = (function() {
  return "Ctx";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.Uo;
      break;
    }
    case 1: {
      return this.Um;
      break;
    }
    case 2: {
      return this.Uk;
      break;
    }
    case 3: {
      return this.Ul;
      break;
    }
    case 4: {
      return this.Un;
      break;
    }
    case 5: {
      return this.Uj;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "width";
      break;
    }
    case 1: {
      return "leftOffset";
      break;
    }
    case 2: {
      return "indentCount";
      break;
    }
    case 3: {
      return "indentStep";
      break;
    }
    case 4: {
      return "literalColor";
      break;
    }
    case 5: {
      return "applyPrefixColor";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpprint_Tree$Ctx(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kk)));
}
var $d_Lpprint_Tree$Ctx = new $TypeData().i($c_Lpprint_Tree$Ctx, "pprint.Tree$Ctx", ({
  kk: 1,
  b: 1,
  c: 1,
  a: 1
}));
function $p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$($thiz) {
  if ((!$thiz.aHh)) {
    $thiz.aHg = new $c_Lpprint_Truncated$Internal$($thiz);
    $thiz.aHh = true;
  }
  return $thiz.aHg;
}
/** @constructor */
function $c_Lpprint_Truncated(chunks0, width, height, truncationMarker) {
  this.aHi = null;
  this.aHj = 0;
  this.Hm = 0;
  this.aHk = null;
  this.qu = null;
  this.aHg = null;
  this.aHh = false;
  this.aHi = chunks0;
  this.aHj = width;
  this.Hm = height;
  this.aHk = truncationMarker;
  this.qu = $m_scm_Buffer$().kM($m_sr_ScalaRunTime$().a5i(new $ac_I(new Int32Array([0]))));
}
$p = $c_Lpprint_Truncated.prototype = new $h_O();
$p.constructor = $c_Lpprint_Truncated;
/** @constructor */
function $h_Lpprint_Truncated() {
}
$h_Lpprint_Truncated.prototype = $p;
$p.V = (function() {
  return (-1);
});
$p.F = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f);
});
$p.iW = (function(p) {
  return $f_sc_IterableOnceOps__find__F1__s_Option(this, p);
});
$p.hO = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$p.kT = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$p.aa = (function() {
  return $f_sc_IterableOnceOps__size__I(this);
});
$p.cR = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
});
$p.k2 = (function(num) {
  return $f_sc_IterableOnceOps__sum__s_math_Numeric__O(this, num);
});
$p.lr = (function(ord) {
  return $f_sc_IterableOnceOps__min__s_math_Ordering__O(this, ord);
});
$p.lq = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord);
});
$p.nw = (function(pf) {
  return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this, pf);
});
$p.lf = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$p.bM = (function() {
  return $m_sci_Nil$().b6(this);
});
$p.d2 = (function() {
  return $m_sci_Vector$().X(this);
});
$p.eX = (function(ev) {
  return $m_sci_Map$().ao(this);
});
$p.iz = (function() {
  return $m_sci_Seq$().fw(this);
});
$p.nG = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$p.o = (function() {
  return this;
});
$p.c = (function() {
  return (!this.p());
});
$p.lS = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs);
});
$p.Ju = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n);
});
$p.iV = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1));
});
$p.ui = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until);
});
$p.m = (function() {
  return "<iterator>";
});
$p.Pa = (function() {
  if (this.p()) {
    $m_sr_Scala3RunTime$().Wl();
  }
  return ((this.qu.C() - 1) | 0);
});
$p.a45 = (function() {
  if (this.p()) {
    $m_sr_Scala3RunTime$().Wl();
  }
  return (this.qu.l(((this.qu.C() - 1) | 0)) | 0);
});
$p.baa = (function() {
  return new $c_Lpprint_Result(this, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => this.Pa())), new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => this.a45())));
});
$p.p = (function() {
  return (($p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$(this).CS.p() && ($p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$(this).a2W() < ((this.Hm - 1) | 0))) || (!$p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$(this).Ux));
});
$p.b4P = (function() {
  if (($p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$(this).CS.p() && ($p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$(this).a2W() < ((this.Hm - 1) | 0)))) {
    var chunk = $p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$(this).CS.q();
    var x1 = $p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$(this).afa(chunk, ((this.Hm - 1) | 0));
    if (($m_s_None$() === x1)) {
      if ((!$p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$(this).CS.p())) {
        $p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$(this).Ux = true;
      }
      return chunk;
    }
    if ((x1 instanceof $c_s_Some)) {
      var i = (x1.J | 0);
      var splitPoint = (((this.qu.bJ() | 0) !== 0) ? ((i - 1) | 0) : i);
      $p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$(this).Uw = chunk.a4P(splitPoint, chunk.fC.a.length);
      return chunk.a4P(0, splitPoint);
    }
    throw new $c_s_MatchError(x1);
  } else if ((!$p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$(this).Ux)) {
    var buffer = $m_scm_Buffer$().f7();
    var charsLeftOver = false;
    matchResult2: {
      var x4 = $p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$(this).afa($p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$(this).Uw, this.Hm);
      if (($m_s_None$() === x4)) {
        buffer.Y($p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$(this).Uw);
        break matchResult2;
      }
      if ((x4 instanceof $c_s_Some)) {
        var i$2 = (x4.J | 0);
        charsLeftOver = true;
        buffer.Y($p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$(this).Uw.a4P(0, ((i$2 - 1) | 0)));
        break matchResult2;
      }
      throw new $c_s_MatchError(x4);
    }
    while (($p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$(this).CS.p() && ($p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$(this).a2W() < this.Hm))) {
      var chunk$2 = $p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$(this).CS.q();
      matchResult3: {
        var x7 = $p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$(this).afa(chunk$2, this.Hm);
        if (($m_s_None$() === x7)) {
          buffer.Y(chunk$2);
          break matchResult3;
        }
        if ((x7 instanceof $c_s_Some)) {
          var i$3 = (x7.J | 0);
          charsLeftOver = true;
          buffer.Y(chunk$2.a4P(0, i$3));
          break matchResult3;
        }
        throw new $c_s_MatchError(x7);
      }
    }
    $p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$(this).Ux = true;
    return ((charsLeftOver || $p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$(this).CS.p()) ? ($p_Lpprint_Truncated__Internal__Lpprint_Truncated$Internal$(this), $m_Lfansi_Str$().iS(this.aHk, ($m_Lfansi_Str$(), $m_Lfansi_ErrorMode$Throw$()))) : $m_Lfansi_Str$().iS($f_sc_IterableOnceOps__mkString__T__T__T__T(buffer.L(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => _$2.aRE()))), "", "", ""), $m_Lfansi_ErrorMode$Throw$()));
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "next on empty iterator");
  }
});
$p.q = (function() {
  return this.b4P();
});
var $d_Lpprint_Truncated = new $TypeData().i($c_Lpprint_Truncated, "pprint.Truncated", ({
  FN: 1,
  e: 1,
  f: 1,
  p: 1
}));
function $p_Lpprint_Util$ConcatIterator__check__Z($thiz) {
  while (true) {
    if ((($thiz.Nd !== null) && $thiz.Nd.p())) {
      return true;
    } else {
      if ($thiz.abK.p()) {
        var num = $thiz.a19;
        var t = ((num >>> 31) | 0);
        if (((((1 & ((num + t) | 0)) - t) | 0) === 0)) {
          $thiz.Nd = $thiz.abK.q();
        } else {
          $thiz.Nd = $thiz.aHl.a3();
        }
        $thiz.a19 = ((1 + $thiz.a19) | 0);
        continue;
      }
      return false;
    }
  }
}
/** @constructor */
function $c_Lpprint_Util$ConcatIterator(it0, joiner) {
  this.abK = null;
  this.aHl = null;
  this.Nd = null;
  this.a19 = 0;
  this.abK = it0;
  this.aHl = joiner;
  this.Nd = null;
  this.a19 = 0;
}
$p = $c_Lpprint_Util$ConcatIterator.prototype = new $h_O();
$p.constructor = $c_Lpprint_Util$ConcatIterator;
/** @constructor */
function $h_Lpprint_Util$ConcatIterator() {
}
$h_Lpprint_Util$ConcatIterator.prototype = $p;
$p.V = (function() {
  return (-1);
});
$p.F = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f);
});
$p.iW = (function(p) {
  return $f_sc_IterableOnceOps__find__F1__s_Option(this, p);
});
$p.hO = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$p.kT = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$p.aa = (function() {
  return $f_sc_IterableOnceOps__size__I(this);
});
$p.cR = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
});
$p.k2 = (function(num) {
  return $f_sc_IterableOnceOps__sum__s_math_Numeric__O(this, num);
});
$p.lr = (function(ord) {
  return $f_sc_IterableOnceOps__min__s_math_Ordering__O(this, ord);
});
$p.lq = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord);
});
$p.nw = (function(pf) {
  return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this, pf);
});
$p.lf = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$p.bM = (function() {
  return $m_sci_Nil$().b6(this);
});
$p.d2 = (function() {
  return $m_sci_Vector$().X(this);
});
$p.eX = (function(ev) {
  return $m_sci_Map$().ao(this);
});
$p.iz = (function() {
  return $m_sci_Seq$().fw(this);
});
$p.nG = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$p.o = (function() {
  return this;
});
$p.c = (function() {
  return (!$p_Lpprint_Util$ConcatIterator__check__Z(this));
});
$p.lS = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs);
});
$p.Ju = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n);
});
$p.iV = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1));
});
$p.ui = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until);
});
$p.m = (function() {
  return "<iterator>";
});
$p.p = (function() {
  return $p_Lpprint_Util$ConcatIterator__check__Z(this);
});
$p.q = (function() {
  $p_Lpprint_Util$ConcatIterator__check__Z(this);
  return this.Nd.q();
});
var $d_Lpprint_Util$ConcatIterator = new $TypeData().i($c_Lpprint_Util$ConcatIterator, "pprint.Util$ConcatIterator", ({
  FQ: 1,
  e: 1,
  f: 1,
  p: 1
}));
/** @constructor */
function $c_s_$eq$colon$eq() {
}
$p = $c_s_$eq$colon$eq.prototype = new $h_s_$less$colon$less();
$p.constructor = $c_s_$eq$colon$eq;
/** @constructor */
function $h_s_$eq$colon$eq() {
}
$h_s_$eq$colon$eq.prototype = $p;
function $ct_s_Enumeration$Value__s_Enumeration__($thiz, outer) {
  $thiz.a1d = outer;
  return $thiz;
}
/** @constructor */
function $c_s_Enumeration$Value() {
  this.a1d = null;
}
$p = $c_s_Enumeration$Value.prototype = new $h_O();
$p.constructor = $c_s_Enumeration$Value;
/** @constructor */
function $h_s_Enumeration$Value() {
}
$h_s_Enumeration$Value.prototype = $p;
$p.pp = (function(that) {
  return this.aYK(that);
});
$p.aYK = (function(that) {
  return ((this.vv < that.vv) ? (-1) : ((this.vv !== that.vv) | 0));
});
$p.e = (function(other) {
  return ((other instanceof $c_s_Enumeration$Value) && ((this.a1d === other.a1d) && (this.vv === other.vv)));
});
$p.x = (function() {
  return this.vv;
});
function $isArrayOf_s_Enumeration$Value(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kp)));
}
class $c_s_NotImplementedError extends $c_jl_Error {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, "an implementation is missing", null, true, true);
  }
}
var $d_s_NotImplementedError = new $TypeData().i($c_s_NotImplementedError, "scala.NotImplementedError", ({
  Gd: 1,
  bO: 1,
  y: 1,
  a: 1
}));
/** @constructor */
function $c_s_PartialFunction$$anon$1() {
  this.aHo = null;
  this.aHo = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2$2) => $m_s_None$()));
}
$p = $c_s_PartialFunction$$anon$1.prototype = new $h_O();
$p.constructor = $c_s_PartialFunction$$anon$1;
/** @constructor */
function $h_s_PartialFunction$$anon$1() {
}
$h_s_PartialFunction$$anon$1.prototype = $p;
$p.aC = (function(x, default$1) {
  return $f_s_PartialFunction__applyOrElse__O__F1__O(this, x, default$1);
});
$p.iU = (function(v1) {
  this.a2K(v1);
});
$p.m = (function() {
  return "<function1>";
});
$p.aM = (function(x) {
  return false;
});
$p.a2K = (function(x) {
  throw new $c_s_MatchError(x);
});
$p.Ar = (function() {
  return this.aHo;
});
$p.Eg = (function(action) {
  return $m_s_PartialFunction$().aHn;
});
$p.i = (function(v1) {
  this.a2K(v1);
});
var $d_s_PartialFunction$$anon$1 = new $TypeData().i($c_s_PartialFunction$$anon$1, "scala.PartialFunction$$anon$1", ({
  Gh: 1,
  i: 1,
  h: 1,
  a: 1
}));
/** @constructor */
function $c_s_PartialFunction$Lifted(pf) {
  this.abQ = null;
  this.abQ = pf;
}
$p = $c_s_PartialFunction$Lifted.prototype = new $h_sr_AbstractFunction1();
$p.constructor = $c_s_PartialFunction$Lifted;
/** @constructor */
function $h_s_PartialFunction$Lifted() {
}
$h_s_PartialFunction$Lifted.prototype = $p;
$p.as = (function(x) {
  var z = this.abQ.aC(x, $m_s_PartialFunction$().UB);
  return ((!$m_s_PartialFunction$().aRQ(z)) ? new $c_s_Some(z) : $m_s_None$());
});
$p.i = (function(v1) {
  return this.as(v1);
});
function $isArrayOf_s_PartialFunction$Lifted(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kt)));
}
var $d_s_PartialFunction$Lifted = new $TypeData().i($c_s_PartialFunction$Lifted, "scala.PartialFunction$Lifted", ({
  kt: 1,
  c8: 1,
  h: 1,
  a: 1
}));
/** @constructor */
function $c_sc_AbstractIterator() {
}
$p = $c_sc_AbstractIterator.prototype = new $h_O();
$p.constructor = $c_sc_AbstractIterator;
/** @constructor */
function $h_sc_AbstractIterator() {
}
$h_sc_AbstractIterator.prototype = $p;
$p.o = (function() {
  return this;
});
$p.c = (function() {
  return (!this.p());
});
$p.lS = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs);
});
$p.Ju = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n);
});
$p.iV = (function(n) {
  return this.ui(n, (-1));
});
$p.ui = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until);
});
$p.m = (function() {
  return "<iterator>";
});
$p.F = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f);
});
$p.iW = (function(p) {
  return $f_sc_IterableOnceOps__find__F1__s_Option(this, p);
});
$p.hO = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$p.kT = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$p.aa = (function() {
  return $f_sc_IterableOnceOps__size__I(this);
});
$p.cR = (function(dest, start, n) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, dest, start, n);
});
$p.k2 = (function(num) {
  return $f_sc_IterableOnceOps__sum__s_math_Numeric__O(this, num);
});
$p.lr = (function(ord) {
  return $f_sc_IterableOnceOps__min__s_math_Ordering__O(this, ord);
});
$p.lq = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord);
});
$p.nw = (function(pf) {
  return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this, pf);
});
$p.lf = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$p.bM = (function() {
  return $m_sci_Nil$().b6(this);
});
$p.d2 = (function() {
  return $m_sci_Vector$().X(this);
});
$p.eX = (function(ev) {
  return $m_sci_Map$().ao(this);
});
$p.iz = (function() {
  return $m_sci_Seq$().fw(this);
});
$p.nG = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$p.V = (function() {
  return (-1);
});
/** @constructor */
function $c_sc_Iterable$() {
  this.xv = null;
  $ct_sc_IterableFactory$Delegate__sc_IterableFactory__(this, $m_sci_Iterable$());
}
$p = $c_sc_Iterable$.prototype = new $h_sc_IterableFactory$Delegate();
$p.constructor = $c_sc_Iterable$;
/** @constructor */
function $h_sc_Iterable$() {
}
$h_sc_Iterable$.prototype = $p;
var $d_sc_Iterable$ = new $TypeData().i($c_sc_Iterable$, "scala.collection.Iterable$", ({
  GS: 1,
  bY: 1,
  a0: 1,
  a: 1
}));
var $n_sc_Iterable$;
function $m_sc_Iterable$() {
  if ((!$n_sc_Iterable$)) {
    $n_sc_Iterable$ = new $c_sc_Iterable$();
  }
  return $n_sc_Iterable$;
}
/** @constructor */
function $c_sc_Map$() {
  this.Hq = null;
  this.aHU = null;
  this.aHV = null;
  $ct_sc_MapFactory$Delegate__sc_MapFactory__(this, $m_sci_Map$());
  $n_sc_Map$ = this;
  this.aHU = $ct_O__(new $c_O());
  this.aHV = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sc_Map$().aHU));
}
$p = $c_sc_Map$.prototype = new $h_sc_MapFactory$Delegate();
$p.constructor = $c_sc_Map$;
/** @constructor */
function $h_sc_Map$() {
}
$h_sc_Map$.prototype = $p;
var $d_sc_Map$ = new $TypeData().i($c_sc_Map$, "scala.collection.Map$", ({
  Hi: 1,
  kP: 1,
  b9: 1,
  a: 1
}));
var $n_sc_Map$;
function $m_sc_Map$() {
  if ((!$n_sc_Map$)) {
    $n_sc_Map$ = new $c_sc_Map$();
  }
  return $n_sc_Map$;
}
/** @constructor */
function $c_sc_MapOps$WithFilter(self, p) {
  this.UH = null;
  this.ac6 = null;
  $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(this, self, p);
}
$p = $c_sc_MapOps$WithFilter.prototype = new $h_sc_IterableOps$WithFilter();
$p.constructor = $c_sc_MapOps$WithFilter;
/** @constructor */
function $h_sc_MapOps$WithFilter() {
}
$h_sc_MapOps$WithFilter.prototype = $p;
var $d_sc_MapOps$WithFilter = new $TypeData().i($c_sc_MapOps$WithFilter, "scala.collection.MapOps$WithFilter", ({
  Hn: 1,
  kN: 1,
  dF: 1,
  a: 1
}));
/** @constructor */
function $c_sc_MapView$() {
  this.a1u = null;
  $n_sc_MapView$ = this;
  this.a1u = new $c_sc_MapView$$anon$1();
}
$p = $c_sc_MapView$.prototype = new $h_O();
$p.constructor = $c_sc_MapView$;
/** @constructor */
function $h_sc_MapView$() {
}
$h_sc_MapView$.prototype = $p;
$p.b5 = (function() {
  return new $c_scm_Builder$$anon$1(new $c_scm_HashMap$$anon$6(16, 0.75), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$2) => new $c_sc_MapView$Id(x$1$2$2))));
});
$p.b1H = (function(it) {
  return ($is_sc_MapView(it) ? it : new $c_sc_MapView$Id(it));
});
$p.aXt = (function(elems) {
  return this.b1H($m_sci_Map$().ao(elems));
});
$p.dr = (function(elems) {
  return this.aXt(elems);
});
$p.cc = (function(it) {
  return $m_sc_View$().WV(it);
});
$p.aO = (function() {
  return this.a1u;
});
var $d_sc_MapView$ = new $TypeData().i($c_sc_MapView$, "scala.collection.MapView$", ({
  Ho: 1,
  Hv: 1,
  b9: 1,
  a: 1
}));
var $n_sc_MapView$;
function $m_sc_MapView$() {
  if ((!$n_sc_MapView$)) {
    $n_sc_MapView$ = new $c_sc_MapView$();
  }
  return $n_sc_MapView$;
}
function $ct_sc_SeqFactory$Delegate__sc_SeqFactory__($thiz, delegate) {
  $thiz.xw = delegate;
  return $thiz;
}
/** @constructor */
function $c_sc_SeqFactory$Delegate() {
  this.xw = null;
}
$p = $c_sc_SeqFactory$Delegate.prototype = new $h_O();
$p.constructor = $c_sc_SeqFactory$Delegate;
/** @constructor */
function $h_sc_SeqFactory$Delegate() {
}
$h_sc_SeqFactory$Delegate.prototype = $p;
$p.kM = (function(elems) {
  return this.xw.dr(elems);
});
$p.f7 = (function() {
  return this.xw.aO();
});
$p.Al = (function(it) {
  return this.xw.cc(it);
});
$p.b5 = (function() {
  return this.xw.b5();
});
$p.cc = (function(source) {
  return this.Al(source);
});
$p.aO = (function() {
  return this.f7();
});
$p.dr = (function(elems) {
  return this.kM(elems);
});
function $f_sc_SeqOps__appended__O__O($thiz, elem) {
  return $thiz.cd().cc($ct_sc_View$Appended__sc_IterableOps__O__(new $c_sc_View$Appended(), $thiz, elem));
}
function $f_sc_SeqOps__distinct__O($thiz) {
  return $thiz.ko(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2$2) => x$2$2)));
}
function $f_sc_SeqOps__distinctBy__F1__O($thiz, f) {
  return $thiz.fP(new $c_sc_View$DistinctBy($thiz, f));
}
function $f_sc_SeqOps__isDefinedAt__I__Z($thiz, idx) {
  return ((idx >= 0) && ($thiz.bL(idx) > 0));
}
function $f_sc_SeqOps__indexOf__O__I__I($thiz, elem, from) {
  return $thiz.px(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$2) => $m_sr_BoxesRunTime$().Q(elem, x$1$2$2))), from);
}
function $f_sc_SeqOps__contains__O__Z($thiz, elem) {
  return $thiz.lU(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$3$2$2) => $m_sr_BoxesRunTime$().Q(x$3$2$2, elem))));
}
function $f_sc_SeqOps__sorted__s_math_Ordering__O($thiz, ord) {
  var len = $thiz.C();
  var b = $thiz.fS();
  if ((len === 1)) {
    b.Y($thiz.t());
  } else if ((len > 1)) {
    b.f9(len);
    var arr = new $ac_O(len);
    $thiz.cR(arr, 0, 2147483647);
    $m_ju_Arrays$().Jn(arr, ord);
    var i = 0;
    while ((i < len)) {
      b.Y(arr.a[i]);
      i = ((1 + i) | 0);
    }
  }
  return b.aR();
}
function $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O($thiz, f, ord) {
  return $thiz.h9(new $c_s_math_Ordering$$anon$1(ord, f));
}
function $f_sc_SeqOps__isEmpty__Z($thiz) {
  return ($thiz.bL(0) === 0);
}
function $f_sc_SeqOps__sameElements__sc_IterableOnce__Z($thiz, that) {
  var thisKnownSize = $thiz.V();
  if ((thisKnownSize !== (-1))) {
    var thatKnownSize = that.V();
    if ((thatKnownSize !== (-1))) {
      if ((thisKnownSize !== thatKnownSize)) {
        return false;
      }
      if ((thisKnownSize === 0)) {
        return true;
      }
    }
  }
  return $f_sc_Iterator__sameElements__sc_IterableOnce__Z($thiz.o(), that);
}
/** @constructor */
function $c_sc_Set$() {
  this.xv = null;
  $ct_sc_IterableFactory$Delegate__sc_IterableFactory__(this, $m_sci_Set$());
}
$p = $c_sc_Set$.prototype = new $h_sc_IterableFactory$Delegate();
$p.constructor = $c_sc_Set$;
/** @constructor */
function $h_sc_Set$() {
}
$h_sc_Set$.prototype = $p;
var $d_sc_Set$ = new $TypeData().i($c_sc_Set$, "scala.collection.Set$", ({
  HB: 1,
  bY: 1,
  a0: 1,
  a: 1
}));
var $n_sc_Set$;
function $m_sc_Set$() {
  if ((!$n_sc_Set$)) {
    $n_sc_Set$ = new $c_sc_Set$();
  }
  return $n_sc_Set$;
}
function $f_sc_StrictOptimizedIterableOps__partition__F1__T2($thiz, p) {
  var l = $thiz.fS();
  var r = $thiz.fS();
  var this$1 = $thiz.o();
  while (this$1.p()) {
    var x0 = this$1.q();
    ((!(!p.i(x0))) ? l : r).Y(x0);
  }
  return new $c_T2(l.aR(), r.aR());
}
function $f_sc_StrictOptimizedIterableOps__span__F1__T2($thiz, p) {
  var first = $thiz.fS();
  var second = $thiz.fS();
  var it = $thiz.o();
  var inFirst = true;
  while ((it.p() && inFirst)) {
    var a = it.q();
    if ((!(!p.i(a)))) {
      first.Y(a);
    } else {
      second.Y(a);
      inFirst = false;
    }
  }
  while (it.p()) {
    second.Y(it.q());
  }
  return new $c_T2(first.aR(), second.aR());
}
function $f_sc_StrictOptimizedIterableOps__unzip__F1__T2($thiz, asPair) {
  var first = $thiz.cd().b5();
  var second = $thiz.cd().b5();
  $thiz.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((a$2$2) => {
    var pair = asPair.i(a$2$2);
    first.Y(pair.g());
    return second.Y(pair.h());
  })));
  return new $c_T2(first.aR(), second.aR());
}
function $f_sc_StrictOptimizedIterableOps__map__F1__O($thiz, f) {
  var b = $thiz.cd().b5();
  var it = $thiz.o();
  while (it.p()) {
    b.Y(f.i(it.q()));
  }
  return b.aR();
}
function $f_sc_StrictOptimizedIterableOps__flatMap__F1__O($thiz, f) {
  var b = $thiz.cd().b5();
  var it = $thiz.o();
  while (it.p()) {
    b.dG(f.i(it.q()));
  }
  return b.aR();
}
function $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O($thiz, pf) {
  var b = $thiz.cd().b5();
  var marker = $m_sr_Statics$PFMarker$();
  var it = $thiz.o();
  while (it.p()) {
    var elem = it.q();
    var v = pf.aC(elem, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((marker) => ((x$2$2) => marker))(marker)));
    if ((marker !== v)) {
      b.Y(v);
    }
  }
  return b.aR();
}
function $f_sc_StrictOptimizedIterableOps__flatten__F1__O($thiz, toIterableOnce) {
  var b = $thiz.cd().b5();
  var it = $thiz.o();
  while (it.p()) {
    b.dG(toIterableOnce.i(it.q()));
  }
  return b.aR();
}
function $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O($thiz, that) {
  var b = $thiz.cd().b5();
  var it1 = $thiz.o();
  var it2 = that.o();
  while ((it1.p() && it2.p())) {
    b.Y(new $c_T2(it1.q(), it2.q()));
  }
  return b.aR();
}
function $f_sc_StrictOptimizedIterableOps__zipWithIndex__O($thiz) {
  var b = $thiz.cd().b5();
  var i = 0;
  var it = $thiz.o();
  while (it.p()) {
    b.Y(new $c_T2(it.q(), i));
    i = ((1 + i) | 0);
  }
  return b.aR();
}
function $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O($thiz, pred, isFlipped) {
  var b = $thiz.fS();
  var it = $thiz.o();
  while (it.p()) {
    var elem = it.q();
    if (((!(!pred.i(elem))) !== isFlipped)) {
      b.Y(elem);
    }
  }
  return b.aR();
}
function $f_sc_StrictOptimizedIterableOps__partitionMap__F1__T2($thiz, f) {
  var l = $thiz.cd().b5();
  var r = $thiz.cd().b5();
  $thiz.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2$2) => {
    var x1 = f.i(x$2$2);
    if ((x1 instanceof $c_s_util_Left)) {
      return l.Y(x1.lP);
    } else if ((x1 instanceof $c_s_util_Right)) {
      return r.Y(x1.hm);
    } else {
      throw new $c_s_MatchError(x1);
    }
  })));
  return new $c_T2(l.aR(), r.aR());
}
function $f_sc_StrictOptimizedIterableOps__dropRight__I__O($thiz, n) {
  var b = $thiz.fS();
  if ((n >= 0)) {
    $f_scm_Builder__sizeHint__sc_IterableOnce__I__V(b, $thiz, ((-n) | 0));
  }
  var lead = $thiz.o().iV(n);
  var it = $thiz.o();
  while (lead.p()) {
    b.Y(it.q());
    lead.q();
  }
  return b.aR();
}
function $f_sc_StrictOptimizedSeqFactory__concat__sci_Seq__sc_SeqOps($thiz, xss) {
  var b = $thiz.b5();
  var knownSizes = xss.JI().h4(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$13$2$2) => x$13$2$2.V())));
  var res = true;
  var it = knownSizes.o();
  while ((res && it.p())) {
    res = ((it.q() | 0) >= 0);
  }
  if (res) {
    b.f9(($f_sc_IterableOnceOps__sum__s_math_Numeric__O(knownSizes, $m_s_math_Numeric$IntIsIntegral$()) | 0));
  }
  xss.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((xs$2$2) => b.dG(xs$2$2))));
  return b.aR();
}
/** @constructor */
function $c_sci_HashMap$accum$1(outer) {
  this.acC = false;
  this.a1M = 0;
  this.Hz = null;
  this.aIi = null;
  this.aIi = outer;
  this.acC = false;
  this.a1M = 0;
  this.Hz = outer.cP;
}
$p = $c_sci_HashMap$accum$1.prototype = new $h_sr_AbstractFunction2();
$p.constructor = $c_sci_HashMap$accum$1;
/** @constructor */
function $h_sci_HashMap$accum$1() {
}
$h_sci_HashMap$accum$1.prototype = $p;
$p.iU = (function(v1) {
});
$p.m = (function() {
  return "<function1>";
});
$p.a2J = (function(key, value) {
  var originalHash = $m_sr_Statics$().u(key);
  var improved = $m_sc_Hashing$().bz(originalHash);
  if ((!this.acC)) {
    this.Hz = this.Hz.JF(key, value, originalHash, improved, 0, true);
    if ((this.Hz !== this.aIi.cP)) {
      this.acC = true;
      this.a1M = $m_sci_Node$().d6($m_sci_Node$().fR(improved, 0));
    }
  } else {
    this.a1M = this.Hz.a59(key, value, originalHash, improved, 0, this.a1M);
  }
});
$p.R = (function(v1, v2) {
  this.a2J(v1, v2);
});
$p.i = (function(v1) {
  this.a2J(v1.g(), v1.h());
});
var $d_sci_HashMap$accum$1 = new $TypeData().i($c_sci_HashMap$accum$1, "scala.collection.immutable.HashMap$accum$1", ({
  I8: 1,
  c9: 1,
  bE: 1,
  h: 1
}));
/** @constructor */
function $c_sci_Iterable$() {
  this.xv = null;
  $ct_sc_IterableFactory$Delegate__sc_IterableFactory__(this, $m_sci_List$());
}
$p = $c_sci_Iterable$.prototype = new $h_sc_IterableFactory$Delegate();
$p.constructor = $c_sci_Iterable$;
/** @constructor */
function $h_sci_Iterable$() {
}
$h_sci_Iterable$.prototype = $p;
$p.aOs = (function(it) {
  return ($is_sci_Iterable(it) ? it : $c_sc_IterableFactory$Delegate.prototype.cc.call(this, it));
});
$p.cc = (function(it) {
  return this.aOs(it);
});
var $d_sci_Iterable$ = new $TypeData().i($c_sci_Iterable$, "scala.collection.immutable.Iterable$", ({
  Ig: 1,
  bY: 1,
  a0: 1,
  a: 1
}));
var $n_sci_Iterable$;
function $m_sci_Iterable$() {
  if ((!$n_sci_Iterable$)) {
    $n_sci_Iterable$ = new $c_sci_Iterable$();
  }
  return $n_sci_Iterable$;
}
/** @constructor */
function $c_sci_LazyList$() {
  this.bD = null;
  this.acD = null;
  $n_sci_LazyList$ = this;
  this.bD = $ct_sci_LazyList__O__(new $c_sci_LazyList(), $m_sci_LazyList$EmptyMarker$());
  this.acD = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$10$2$2) => $m_sr_Statics$PFMarker$()));
}
$p = $c_sci_LazyList$.prototype = new $h_O();
$p.constructor = $c_sci_LazyList$;
/** @constructor */
function $h_sci_LazyList$() {
}
$h_sci_LazyList$.prototype = $p;
$p.dr = (function(elems) {
  return this.a3v(elems);
});
$p.ahS = (function(ll, p, isFlipped) {
  return $ct_sci_LazyList__O__(new $c_sci_LazyList(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((restRef) => (() => {
    var elem = null;
    var found = false;
    var rest = restRef.aD;
    while (((!found) && (!(rest.df() === $m_sci_LazyList$().bD)))) {
      elem = rest.t();
      found = ((!(!p.i(elem))) !== isFlipped);
      rest = rest.eV();
      restRef.aD = rest;
    }
    return (found ? ($m_sci_LazyList$(), $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), elem, $m_sci_LazyList$().ahS(rest, p, isFlipped))) : $m_sci_LazyList$().bD);
  }))(new $c_sr_ObjectRef(ll))));
});
$p.aRS = (function(ll, pf) {
  return $ct_sci_LazyList__O__(new $c_sci_LazyList(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((restRef) => (() => {
    var marker = $m_sr_Statics$PFMarker$();
    var toMarker = $m_sci_LazyList$().acD;
    var res = marker;
    var rest = restRef.aD;
    while (((res === marker) && (!(rest.df() === $m_sci_LazyList$().bD)))) {
      res = pf.aC(rest.t(), toMarker);
      rest = rest.eV();
      restRef.aD = rest;
    }
    return ((res === marker) ? $m_sci_LazyList$().bD : ($m_sci_LazyList$(), $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), res, $m_sci_LazyList$().aRS(rest, pf))));
  }))(new $c_sr_ObjectRef(ll))));
});
$p.aRT = (function(ll, f) {
  return $ct_sci_LazyList__O__(new $c_sci_LazyList(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((restRef) => (() => {
    var it = new $c_sr_ObjectRef(null);
    var itHasNext = false;
    var rest = new $c_sr_ObjectRef(restRef.aD);
    while (((!itHasNext) && (!(rest.aD.df() === $m_sci_LazyList$().bD)))) {
      it.aD = f.i(rest.aD.t()).o();
      itHasNext = it.aD.p();
      if ((!itHasNext)) {
        rest.aD = rest.aD.eV();
        restRef.aD = rest.aD;
      }
    }
    if (itHasNext) {
      var head = it.aD.q();
      rest.aD = rest.aD.eV();
      restRef.aD = rest.aD;
      $m_sci_LazyList$();
      return $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), head, ($m_sci_LazyList$(), $ct_sci_LazyList__O__(new $c_sci_LazyList(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_LazyList$().ahR(it.aD, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_LazyList$().aRT(rest.aD, f)))))))));
    } else {
      return $m_sci_LazyList$().bD;
    }
  }))(new $c_sr_ObjectRef(ll))));
});
$p.b85 = (function(ll, n) {
  return $ct_sci_LazyList__O__(new $c_sci_LazyList(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((restRef, iRef) => (() => {
    var rest = restRef.aD;
    var i = iRef.an;
    while (((i > 0) && (!(rest.df() === $m_sci_LazyList$().bD)))) {
      rest = rest.eV();
      restRef.aD = rest;
      i = ((i - 1) | 0);
      iRef.an = i;
    }
    return rest;
  }))(new $c_sr_ObjectRef(ll), new $c_sr_IntRef(n))));
});
$p.b86 = (function(ll, p) {
  return $ct_sci_LazyList__O__(new $c_sci_LazyList(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((restRef) => (() => {
    var rest = restRef.aD;
    while (((!(rest.df() === $m_sci_LazyList$().bD)) && (!(!p.i(rest.t()))))) {
      rest = rest.eV();
      restRef.aD = rest;
    }
    return rest;
  }))(new $c_sr_ObjectRef(ll))));
});
$p.a3v = (function(coll) {
  return ((coll instanceof $c_sci_LazyList) ? coll : ((coll.V() === 0) ? this.bD : $ct_sci_LazyList__O__(new $c_sci_LazyList(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_LazyList$().ahQ(coll.o()))))));
});
$p.ahR = (function(it, suffix) {
  return (it.p() ? $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), it.q(), $ct_sci_LazyList__O__(new $c_sci_LazyList(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_LazyList$().ahR(it, suffix))))) : suffix.a3());
});
$p.ahQ = (function(it) {
  return (it.p() ? $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), it.q(), $ct_sci_LazyList__O__(new $c_sci_LazyList(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_LazyList$().ahQ(it))))) : this.bD);
});
$p.aOo = (function(start, step) {
  return $ct_sci_LazyList__O__(new $c_sci_LazyList(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $m_sci_LazyList$();
    return $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), start, $m_sci_LazyList$().aOo(((start + step) | 0), step));
  })));
});
$p.b5 = (function() {
  return new $c_sci_LazyList$LazyBuilder();
});
$p.aO = (function() {
  return this.bD;
});
$p.cc = (function(source) {
  return this.a3v(source);
});
var $d_sci_LazyList$ = new $TypeData().i($c_sci_LazyList$, "scala.collection.immutable.LazyList$", ({
  Ih: 1,
  at: 1,
  a0: 1,
  a: 1
}));
var $n_sci_LazyList$;
function $m_sci_LazyList$() {
  if ((!$n_sci_LazyList$)) {
    $n_sci_LazyList$ = new $c_sci_LazyList$();
  }
  return $n_sci_LazyList$;
}
/** @constructor */
function $c_sci_TreeSeqMap$Builder(orderedBy) {
  this.a1P = null;
  this.O2 = null;
  this.O3 = null;
  this.xG = 0;
  this.O1 = null;
  this.a1P = orderedBy;
  this.O2 = new $c_sci_MapBuilderImpl();
  this.O3 = $m_sci_TreeSeqMap$Ordering$Zero$();
  this.xG = 0;
}
$p = $c_sci_TreeSeqMap$Builder.prototype = new $h_O();
$p.constructor = $c_sci_TreeSeqMap$Builder;
/** @constructor */
function $h_sci_TreeSeqMap$Builder() {
}
$h_sci_TreeSeqMap$Builder.prototype = $p;
$p.f9 = (function(size) {
});
$p.dG = (function(elems) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, elems);
});
$p.a2E = (function(key, value) {
  if ((this.O1 !== null)) {
    this.O1 = this.O1.aiq(key, value);
  } else {
    var x1 = this.O2.a3C(key, null);
    if ((x1 !== null)) {
      var o = x1.xY();
      var v = x1.h();
      var x = this.a1P;
      var x$2 = $m_sci_TreeSeqMap$OrderBy$Insertion$();
      if ((((x !== null) && (x === x$2)) && (!$m_sr_BoxesRunTime$().Q(v, value)))) {
        this.O2.lR(key, new $c_T2(o, value));
      } else {
        var x$3 = this.a1P;
        var x$4 = $m_sci_TreeSeqMap$OrderBy$Modification$();
        if (((x$3 !== null) && (x$3 === x$4))) {
          this.O2.lR(key, new $c_T2(this.xG, value));
          this.O3 = this.O3.Pi(o).aeH(null, this.xG, key);
          $m_sci_TreeSeqMap$();
          var ord = this.xG;
          this.xG = ((ord === 2147483647) ? (-2147483648) : ((1 + ord) | 0));
        }
      }
    } else if ((x1 === null)) {
      this.O2.lR(key, new $c_T2(this.xG, value));
      this.O3 = this.O3.aeH(null, this.xG, key);
      $m_sci_TreeSeqMap$();
      var ord$1 = this.xG;
      this.xG = ((ord$1 === 2147483647) ? (-2147483648) : ((1 + ord$1) | 0));
    } else {
      throw new $c_s_MatchError(x1);
    }
  }
  return this;
});
$p.a4y = (function() {
  if ((this.O1 === null)) {
    this.O1 = new $c_sci_TreeSeqMap(this.O3, this.O2.oG(), this.xG, this.a1P);
  }
  return this.O1;
});
$p.aR = (function() {
  return this.a4y();
});
$p.Y = (function(elem) {
  return this.a2E(elem.g(), elem.h());
});
var $d_sci_TreeSeqMap$Builder = new $TypeData().i($c_sci_TreeSeqMap$Builder, "scala.collection.immutable.TreeSeqMap$Builder", ({
  Je: 1,
  Y: 1,
  T: 1,
  S: 1
}));
/** @constructor */
function $c_sci_VectorMap$Tombstone(distance) {
  this.qE = 0;
  this.qE = distance;
}
$p = $c_sci_VectorMap$Tombstone.prototype = new $h_O();
$p.constructor = $c_sci_VectorMap$Tombstone;
/** @constructor */
function $h_sci_VectorMap$Tombstone() {
}
$h_sci_VectorMap$Tombstone.prototype = $p;
$p.B = (function() {
  return "Tombstone";
});
$p.z = (function() {
  return 1;
});
$p.A = (function(x$1) {
  return ((x$1 === 0) ? this.qE : $m_sr_Statics$().ey(x$1));
});
$p.H = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$p.D = (function(x$1) {
  return ((x$1 === 0) ? "distance" : $m_sr_Statics$().ey(x$1));
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, (-454819595));
  acc = $m_sr_Statics$().k(acc, this.qE);
  return $m_sr_Statics$().Z(acc, 1);
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.e = (function(x$1) {
  return ((this === x$1) || ((x$1 instanceof $c_sci_VectorMap$Tombstone) && (this.qE === x$1.qE)));
});
function $isArrayOf_sci_VectorMap$Tombstone(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.lA)));
}
var $d_sci_VectorMap$Tombstone = new $TypeData().i($c_sci_VectorMap$Tombstone, "scala.collection.immutable.VectorMap$Tombstone", ({
  lA: 1,
  c: 1,
  b: 1,
  a: 1
}));
/** @constructor */
function $c_sci_VectorMapBuilder() {
  this.a1Q = null;
  this.Va = null;
  this.O8 = null;
  this.a1Q = new $c_sci_VectorBuilder();
  this.Va = new $c_sci_MapBuilderImpl();
}
$p = $c_sci_VectorMapBuilder.prototype = new $h_O();
$p.constructor = $c_sci_VectorMapBuilder;
/** @constructor */
function $h_sci_VectorMapBuilder() {
}
$h_sci_VectorMapBuilder.prototype = $p;
$p.f9 = (function(size) {
});
$p.dG = (function(elems) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, elems);
});
$p.rb = (function() {
  if ((this.O8 === null)) {
    this.O8 = $ct_sci_VectorMap__sci_Vector__sci_Map__(new $c_sci_VectorMap(), this.a1Q.bY(), this.Va.oG());
  }
  return this.O8;
});
$p.pm = (function(key, value) {
  if ((this.O8 !== null)) {
    this.O8 = this.O8.AJ(key, value);
  } else {
    var x1 = this.Va.a3C(key, null);
    if ((x1 !== null)) {
      var slot = x1.xY();
      this.Va.lR(key, new $c_T2(slot, value));
    } else if ((x1 === null)) {
      var vectorSize = this.a1Q.V();
      this.a1Q.ck(key);
      this.Va.lR(key, new $c_T2(vectorSize, value));
    } else {
      throw new $c_s_MatchError(x1);
    }
  }
  return this;
});
$p.Y = (function(elem) {
  return this.pm(elem.g(), elem.h());
});
$p.aR = (function() {
  return this.rb();
});
var $d_sci_VectorMapBuilder = new $TypeData().i($c_sci_VectorMapBuilder, "scala.collection.immutable.VectorMapBuilder", ({
  Jr: 1,
  Y: 1,
  T: 1,
  S: 1
}));
/** @constructor */
function $c_sci_WrappedString$() {
  this.acT = null;
  $n_sci_WrappedString$ = this;
  this.acT = new $c_sci_WrappedString("");
}
$p = $c_sci_WrappedString$.prototype = new $h_O();
$p.constructor = $c_sci_WrappedString$;
/** @constructor */
function $h_sci_WrappedString$() {
}
$h_sci_WrappedString$.prototype = $p;
$p.aOE = (function(it) {
  var b = this.b5();
  $f_scm_Builder__sizeHint__sc_IterableOnce__I__V(b, it, 0);
  b.dG(it);
  return b.aR();
});
$p.b5 = (function() {
  return new $c_scm_Builder$$anon$1($ct_scm_StringBuilder__(new $c_scm_StringBuilder()), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2$2) => new $c_sci_WrappedString(x$2$2))));
});
var $d_sci_WrappedString$ = new $TypeData().i($c_sci_WrappedString$, "scala.collection.immutable.WrappedString$", ({
  Ju: 1,
  HC: 1,
  bX: 1,
  a: 1
}));
var $n_sci_WrappedString$;
function $m_sci_WrappedString$() {
  if ((!$n_sci_WrappedString$)) {
    $n_sci_WrappedString$ = new $c_sci_WrappedString$();
  }
  return $n_sci_WrappedString$;
}
/** @constructor */
function $c_scm_Builder$$anon$1(outer, f$1) {
  this.Vb = null;
  this.aIB = null;
  this.Vb = outer;
  this.aIB = f$1;
}
$p = $c_scm_Builder$$anon$1.prototype = new $h_O();
$p.constructor = $c_scm_Builder$$anon$1;
/** @constructor */
function $h_scm_Builder$$anon$1() {
}
$h_scm_Builder$$anon$1.prototype = $p;
$p.aWK = (function(x) {
  this.Vb.Y(x);
  return this;
});
$p.aWB = (function(xs) {
  this.Vb.dG(xs);
  return this;
});
$p.f9 = (function(size) {
  this.Vb.f9(size);
});
$p.aR = (function() {
  return this.aIB.i(this.Vb.aR());
});
$p.dG = (function(elems) {
  return this.aWB(elems);
});
$p.Y = (function(elem) {
  return this.aWK(elem);
});
var $d_scm_Builder$$anon$1 = new $TypeData().i($c_scm_Builder$$anon$1, "scala.collection.mutable.Builder$$anon$1", ({
  JE: 1,
  Y: 1,
  T: 1,
  S: 1
}));
function $ct_scm_GrowableBuilder__scm_Growable__($thiz, elems) {
  $thiz.gj = elems;
  return $thiz;
}
/** @constructor */
function $c_scm_GrowableBuilder() {
  this.gj = null;
}
$p = $c_scm_GrowableBuilder.prototype = new $h_O();
$p.constructor = $c_scm_GrowableBuilder;
/** @constructor */
function $h_scm_GrowableBuilder() {
}
$h_scm_GrowableBuilder.prototype = $p;
$p.f9 = (function(size) {
});
$p.mI = (function(elem) {
  this.gj.Y(elem);
  return this;
});
$p.a2B = (function(xs) {
  this.gj.dG(xs);
  return this;
});
$p.dG = (function(elems) {
  return this.a2B(elems);
});
$p.Y = (function(elem) {
  return this.mI(elem);
});
$p.aR = (function() {
  return this.gj;
});
var $d_scm_GrowableBuilder = new $TypeData().i($c_scm_GrowableBuilder, "scala.collection.mutable.GrowableBuilder", ({
  c2: 1,
  Y: 1,
  T: 1,
  S: 1
}));
/** @constructor */
function $c_scm_Iterable$() {
  this.xv = null;
  $ct_sc_IterableFactory$Delegate__sc_IterableFactory__(this, $m_scm_ArrayBuffer$());
}
$p = $c_scm_Iterable$.prototype = new $h_sc_IterableFactory$Delegate();
$p.constructor = $c_scm_Iterable$;
/** @constructor */
function $h_scm_Iterable$() {
}
$h_scm_Iterable$.prototype = $p;
var $d_scm_Iterable$ = new $TypeData().i($c_scm_Iterable$, "scala.collection.mutable.Iterable$", ({
  K3: 1,
  bY: 1,
  a0: 1,
  a: 1
}));
var $n_scm_Iterable$;
function $m_scm_Iterable$() {
  if ((!$n_scm_Iterable$)) {
    $n_scm_Iterable$ = new $c_scm_Iterable$();
  }
  return $n_scm_Iterable$;
}
/** @constructor */
function $c_scm_Map$() {
  this.Hq = null;
  $ct_sc_MapFactory$Delegate__sc_MapFactory__(this, $m_scm_HashMap$());
}
$p = $c_scm_Map$.prototype = new $h_sc_MapFactory$Delegate();
$p.constructor = $c_scm_Map$;
/** @constructor */
function $h_scm_Map$() {
}
$h_scm_Map$.prototype = $p;
var $d_scm_Map$ = new $TypeData().i($c_scm_Map$, "scala.collection.mutable.Map$", ({
  Ki: 1,
  kP: 1,
  b9: 1,
  a: 1
}));
var $n_scm_Map$;
function $m_scm_Map$() {
  if ((!$n_scm_Map$)) {
    $n_scm_Map$ = new $c_scm_Map$();
  }
  return $n_scm_Map$;
}
/** @constructor */
function $c_scm_Set$() {
  this.xv = null;
  $ct_sc_IterableFactory$Delegate__sc_IterableFactory__(this, $m_scm_HashSet$());
}
$p = $c_scm_Set$.prototype = new $h_sc_IterableFactory$Delegate();
$p.constructor = $c_scm_Set$;
/** @constructor */
function $h_scm_Set$() {
}
$h_scm_Set$.prototype = $p;
var $d_scm_Set$ = new $TypeData().i($c_scm_Set$, "scala.collection.mutable.Set$", ({
  Kp: 1,
  bY: 1,
  a0: 1,
  a: 1
}));
var $n_scm_Set$;
function $m_scm_Set$() {
  if ((!$n_scm_Set$)) {
    $n_scm_Set$ = new $c_scm_Set$();
  }
  return $n_scm_Set$;
}
class $c_s_concurrent_Future$$anon$4 extends $c_jl_Throwable {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  IU() {
    return $f_s_util_control_NoStackTrace__fillInStackTrace__jl_Throwable(this);
  }
}
var $d_s_concurrent_Future$$anon$4 = new $TypeData().i($c_s_concurrent_Future$$anon$4, "scala.concurrent.Future$$anon$4", ({
  KC: 1,
  y: 1,
  a: 1,
  ca: 1
}));
/** @constructor */
function $c_s_concurrent_duration_Duration() {
}
$p = $c_s_concurrent_duration_Duration.prototype = new $h_O();
$p.constructor = $c_s_concurrent_duration_Duration;
/** @constructor */
function $h_s_concurrent_duration_Duration() {
}
$h_s_concurrent_duration_Duration.prototype = $p;
$p.pp = (function(that) {
  return this.Wu(that);
});
function $f_sr_EnumValue__productElement__I__O($thiz, n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
}
function $f_sr_EnumValue__productElementName__I__T($thiz, n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
}
function $isArrayOf_sr_NonLocalReturnControl(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.LT)));
}
/** @constructor */
function $c_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext() {
  this.aJb = null;
  this.aJb = Promise.resolve((void 0));
}
$p = $c_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext.prototype = new $h_O();
$p.constructor = $c_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext;
/** @constructor */
function $h_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext() {
}
$h_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext.prototype = $p;
$p.afA = (function(runnable) {
  this.aJb.then(((arg1$2) => {
    try {
      runnable.Jk();
    } catch (e) {
      ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e)).XL($m_jl_System$Streams$().K7);
    }
  }));
});
$p.ahF = (function(t) {
  t.XL($m_jl_System$Streams$().K7);
});
var $d_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext = new $TypeData().i($c_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext, "scala.scalajs.concurrent.QueueExecutionContext$PromisesExecutionContext", ({
  M9: 1,
  dU: 1,
  dT: 1,
  dh: 1
}));
/** @constructor */
function $c_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext() {
}
$p = $c_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext.prototype = new $h_O();
$p.constructor = $c_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext;
/** @constructor */
function $h_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext() {
}
$h_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext.prototype = $p;
$p.afA = (function(runnable) {
  setTimeout($m_sjs_js_Any$().ag5(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    try {
      runnable.Jk();
    } catch (e) {
      ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e)).XL($m_jl_System$Streams$().K7);
    }
  }))), 0);
});
$p.ahF = (function(t) {
  t.XL($m_jl_System$Streams$().K7);
});
var $d_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext = new $TypeData().i($c_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext, "scala.scalajs.concurrent.QueueExecutionContext$TimeoutsExecutionContext", ({
  Ma: 1,
  dU: 1,
  dT: 1,
  dh: 1
}));
/** @constructor */
function $c_sjs_js_WrappedDictionary$DictionaryIterator(dict) {
  this.aJc = null;
  this.adp = null;
  this.Vv = 0;
  this.aJc = dict;
  this.adp = Object.keys(dict);
  this.Vv = 0;
}
$p = $c_sjs_js_WrappedDictionary$DictionaryIterator.prototype = new $h_O();
$p.constructor = $c_sjs_js_WrappedDictionary$DictionaryIterator;
/** @constructor */
function $h_sjs_js_WrappedDictionary$DictionaryIterator() {
}
$h_sjs_js_WrappedDictionary$DictionaryIterator.prototype = $p;
$p.o = (function() {
  return this;
});
$p.c = (function() {
  return (!this.p());
});
$p.lS = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs);
});
$p.Ju = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n);
});
$p.iV = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1));
});
$p.ui = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until);
});
$p.m = (function() {
  return "<iterator>";
});
$p.F = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f);
});
$p.iW = (function(p) {
  return $f_sc_IterableOnceOps__find__F1__s_Option(this, p);
});
$p.hO = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$p.kT = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$p.aa = (function() {
  return $f_sc_IterableOnceOps__size__I(this);
});
$p.cR = (function(dest, start, n) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, dest, start, n);
});
$p.k2 = (function(num) {
  return $f_sc_IterableOnceOps__sum__s_math_Numeric__O(this, num);
});
$p.lr = (function(ord) {
  return $f_sc_IterableOnceOps__min__s_math_Ordering__O(this, ord);
});
$p.lq = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord);
});
$p.nw = (function(pf) {
  return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this, pf);
});
$p.lf = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$p.bM = (function() {
  return $m_sci_Nil$().b6(this);
});
$p.d2 = (function() {
  return $m_sci_Vector$().X(this);
});
$p.eX = (function(ev) {
  return $m_sci_Map$().ao(this);
});
$p.iz = (function() {
  return $m_sci_Seq$().fw(this);
});
$p.nG = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$p.V = (function() {
  return (-1);
});
$p.p = (function() {
  return (this.Vv < (this.adp.length | 0));
});
$p.dC = (function() {
  var key = this.adp[this.Vv];
  this.Vv = ((1 + this.Vv) | 0);
  var dict = this.aJc;
  if ((!(!$m_sjs_js_WrappedDictionary$Cache$().vL.call(dict, key)))) {
    var $x_1 = dict[key];
  } else {
    var $x_1;
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key));
  }
  return new $c_T2(key, $x_1);
});
$p.q = (function() {
  return this.dC();
});
var $d_sjs_js_WrappedDictionary$DictionaryIterator = new $TypeData().i($c_sjs_js_WrappedDictionary$DictionaryIterator, "scala.scalajs.js.WrappedDictionary$DictionaryIterator", ({
  Mo: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder() {
  this.Vw = null;
  this.Vw = ({});
}
$p = $c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype = new $h_O();
$p.constructor = $c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder;
/** @constructor */
function $h_sjs_js_WrappedDictionary$WrappedDictionaryBuilder() {
}
$h_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype = $p;
$p.f9 = (function(size) {
});
$p.dG = (function(elems) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, elems);
});
$p.aWP = (function(elem) {
  var dict = this.Vw;
  var key = elem.g();
  var value = elem.h();
  dict[key] = value;
  return this;
});
$p.ahK = (function() {
  return new $c_sjs_js_WrappedDictionary(this.Vw);
});
$p.aR = (function() {
  return this.ahK();
});
$p.Y = (function(elem) {
  return this.aWP(elem);
});
var $d_sjs_js_WrappedDictionary$WrappedDictionaryBuilder = new $TypeData().i($c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder, "scala.scalajs.js.WrappedDictionary$WrappedDictionaryBuilder", ({
  Mp: 1,
  Y: 1,
  T: 1,
  S: 1
}));
/** @constructor */
function $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d(f) {
  this.aJd = null;
  this.aJd = f;
}
$p = $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d.prototype = new $h_sjsr_AnonFunction0();
$p.constructor = $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d;
/** @constructor */
function $h_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d() {
}
$h_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d.prototype = $p;
$p.a3 = (function() {
  return (0, this.aJd)();
});
var $d_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d = new $TypeData().i($c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d, "scala.scalajs.runtime.AnonFunction0.$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d", ({
  Mv: 1,
  Mu: 1,
  md: 1,
  du: 1
}));
/** @constructor */
function $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(f) {
  this.aJe = null;
  this.aJe = f;
}
$p = $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1.prototype = new $h_sjsr_AnonFunction1();
$p.constructor = $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1;
/** @constructor */
function $h_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1() {
}
$h_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1.prototype = $p;
$p.i = (function(x0) {
  return (0, this.aJe)(x0);
});
var $d_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1 = new $TypeData().i($c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1, "scala.scalajs.runtime.AnonFunction1.$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1", ({
  Mx: 1,
  Mw: 1,
  c8: 1,
  h: 1
}));
/** @constructor */
function $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(f) {
  this.aJf = null;
  this.aJf = f;
}
$p = $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7.prototype = new $h_sjsr_AnonFunction2();
$p.constructor = $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7;
/** @constructor */
function $h_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7() {
}
$h_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7.prototype = $p;
$p.R = (function(x0, x1) {
  return (0, this.aJf)(x0, x1);
});
var $d_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7 = new $TypeData().i($c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7, "scala.scalajs.runtime.AnonFunction2.$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7", ({
  Mz: 1,
  My: 1,
  c9: 1,
  bE: 1
}));
/** @constructor */
function $c_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96(f) {
  this.aJg = null;
  this.aJg = f;
}
$p = $c_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96.prototype = new $h_sjsr_AnonFunction3();
$p.constructor = $c_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96;
/** @constructor */
function $h_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96() {
}
$h_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96.prototype = $p;
$p.DH = (function(x0, x1, x2) {
  return (0, this.aJg)(x0, x1, x2);
});
var $d_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96 = new $TypeData().i($c_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96, "scala.scalajs.runtime.AnonFunction3.$$Lambda$73f37e31ba038fe839c174212837da323f140c96", ({
  MB: 1,
  MA: 1,
  me: 1,
  kq: 1
}));
/** @constructor */
function $c_sjsr_AnonFunction4_$$Lambda$120c664e6fb20e1c3552e9e8baf775b7682c102c(f) {
  this.aJh = null;
  this.aJh = f;
}
$p = $c_sjsr_AnonFunction4_$$Lambda$120c664e6fb20e1c3552e9e8baf775b7682c102c.prototype = new $h_sjsr_AnonFunction4();
$p.constructor = $c_sjsr_AnonFunction4_$$Lambda$120c664e6fb20e1c3552e9e8baf775b7682c102c;
/** @constructor */
function $h_sjsr_AnonFunction4_$$Lambda$120c664e6fb20e1c3552e9e8baf775b7682c102c() {
}
$h_sjsr_AnonFunction4_$$Lambda$120c664e6fb20e1c3552e9e8baf775b7682c102c.prototype = $p;
$p.a2I = (function(x0, x1, x2, x3) {
  return (0, this.aJh)(x0, x1, x2, x3);
});
var $d_sjsr_AnonFunction4_$$Lambda$120c664e6fb20e1c3552e9e8baf775b7682c102c = new $TypeData().i($c_sjsr_AnonFunction4_$$Lambda$120c664e6fb20e1c3552e9e8baf775b7682c102c, "scala.scalajs.runtime.AnonFunction4.$$Lambda$120c664e6fb20e1c3552e9e8baf775b7682c102c", ({
  MD: 1,
  MC: 1,
  mf: 1,
  kr: 1
}));
/** @constructor */
function $c_sjsr_AnonFunction6_$$Lambda$39017dae4a967fbe8fca0cd4c8f04f299a6cfb7e(f) {
  this.aJi = null;
  this.aJi = f;
}
$p = $c_sjsr_AnonFunction6_$$Lambda$39017dae4a967fbe8fca0cd4c8f04f299a6cfb7e.prototype = new $h_sjsr_AnonFunction6();
$p.constructor = $c_sjsr_AnonFunction6_$$Lambda$39017dae4a967fbe8fca0cd4c8f04f299a6cfb7e;
/** @constructor */
function $h_sjsr_AnonFunction6_$$Lambda$39017dae4a967fbe8fca0cd4c8f04f299a6cfb7e() {
}
$h_sjsr_AnonFunction6_$$Lambda$39017dae4a967fbe8fca0cd4c8f04f299a6cfb7e.prototype = $p;
$p.aM6 = (function(x0, x1, x2, x3, x4, x5) {
  return (0, this.aJi)(x0, x1, x2, x3, x4, x5);
});
var $d_sjsr_AnonFunction6_$$Lambda$39017dae4a967fbe8fca0cd4c8f04f299a6cfb7e = new $TypeData().i($c_sjsr_AnonFunction6_$$Lambda$39017dae4a967fbe8fca0cd4c8f04f299a6cfb7e, "scala.scalajs.runtime.AnonFunction6.$$Lambda$39017dae4a967fbe8fca0cd4c8f04f299a6cfb7e", ({
  MF: 1,
  ME: 1,
  mg: 1,
  ks: 1
}));
/** @constructor */
function $c_sjsr_AnonFunction9_$$Lambda$bec0fa2ea8c2338588bd1e26523619ac4d96b108(f) {
  this.aJj = null;
  this.aJj = f;
}
$p = $c_sjsr_AnonFunction9_$$Lambda$bec0fa2ea8c2338588bd1e26523619ac4d96b108.prototype = new $h_sjsr_AnonFunction9();
$p.constructor = $c_sjsr_AnonFunction9_$$Lambda$bec0fa2ea8c2338588bd1e26523619ac4d96b108;
/** @constructor */
function $h_sjsr_AnonFunction9_$$Lambda$bec0fa2ea8c2338588bd1e26523619ac4d96b108() {
}
$h_sjsr_AnonFunction9_$$Lambda$bec0fa2ea8c2338588bd1e26523619ac4d96b108.prototype = $p;
$p.aXg = (function(x0, x1, x2, x3, x4, x5, x6, x7, x8) {
  return (0, this.aJj)(x0, x1, x2, x3, x4, x5, x6, x7, x8);
});
var $d_sjsr_AnonFunction9_$$Lambda$bec0fa2ea8c2338588bd1e26523619ac4d96b108 = new $TypeData().i($c_sjsr_AnonFunction9_$$Lambda$bec0fa2ea8c2338588bd1e26523619ac4d96b108, "scala.scalajs.runtime.AnonFunction9.$$Lambda$bec0fa2ea8c2338588bd1e26523619ac4d96b108", ({
  MH: 1,
  MG: 1,
  LK: 1,
  G7: 1
}));
/** @constructor */
function $c_s_util_Either() {
}
$p = $c_s_util_Either.prototype = new $h_O();
$p.constructor = $c_s_util_Either;
/** @constructor */
function $h_s_util_Either() {
}
$h_s_util_Either.prototype = $p;
/** @constructor */
function $c_s_util_Either$LeftProjection(e) {
  this.Of = null;
  this.Of = e;
}
$p = $c_s_util_Either$LeftProjection.prototype = new $h_O();
$p.constructor = $c_s_util_Either$LeftProjection;
/** @constructor */
function $h_s_util_Either$LeftProjection() {
}
$h_s_util_Either$LeftProjection.prototype = $p;
$p.B = (function() {
  return "LeftProjection";
});
$p.z = (function() {
  return 1;
});
$p.A = (function(x$1) {
  return ((x$1 === 0) ? this.Of : $m_sr_Statics$().ey(x$1));
});
$p.H = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$p.D = (function(x$1) {
  return ((x$1 === 0) ? "e" : $m_sr_Statics$().ey(x$1));
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-44939558), true);
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.e = (function(x$1) {
  if ((this === x$1)) {
    return true;
  } else if ((x$1 instanceof $c_s_util_Either$LeftProjection)) {
    var x = this.Of;
    var x$2 = x$1.Of;
    return ((x === null) ? (x$2 === null) : x.e(x$2));
  } else {
    return false;
  }
});
function $isArrayOf_s_util_Either$LeftProjection(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.mq)));
}
var $d_s_util_Either$LeftProjection = new $TypeData().i($c_s_util_Either$LeftProjection, "scala.util.Either$LeftProjection", ({
  mq: 1,
  c: 1,
  b: 1,
  a: 1
}));
/** @constructor */
function $c_s_util_Try() {
}
$p = $c_s_util_Try.prototype = new $h_O();
$p.constructor = $c_s_util_Try;
/** @constructor */
function $h_s_util_Try() {
}
$h_s_util_Try.prototype = $p;
function $isArrayOf_s_util_Try(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.cW)));
}
var $d_s_util_Try = new $TypeData().i(0, "scala.util.Try", ({
  cW: 1,
  c: 1,
  b: 1,
  a: 1
}));
/** @constructor */
function $c_s_util_parsing_combinator_Parsers$$tilde(outer, _1, _2) {
  this.ot = null;
  this.ou = null;
  this.adu = null;
  this.ot = _1;
  this.ou = _2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.adu = outer;
}
$p = $c_s_util_parsing_combinator_Parsers$$tilde.prototype = new $h_O();
$p.constructor = $c_s_util_parsing_combinator_Parsers$$tilde;
/** @constructor */
function $h_s_util_parsing_combinator_Parsers$$tilde() {
}
$h_s_util_parsing_combinator_Parsers$$tilde.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().eN(this, (-889275714), null);
});
$p.e = (function(x$0) {
  return ((this === x$0) || (((x$0 instanceof $c_s_util_parsing_combinator_Parsers$$tilde) && (x$0.adu === this.adu)) && ($m_sr_BoxesRunTime$().Q(this.ot, x$0.ot) && $m_sr_BoxesRunTime$().Q(this.ou, x$0.ou))));
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "~";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.ot;
  }
  if ((n === 1)) {
    return this.ou;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "_1";
  }
  if ((n === 1)) {
    return "_2";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.m = (function() {
  return (((("(" + this.ot) + "~") + this.ou) + ")");
});
function $isArrayOf_s_util_parsing_combinator_Parsers$$tilde(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.mw)));
}
var $d_s_util_parsing_combinator_Parsers$$tilde = new $TypeData().i($c_s_util_parsing_combinator_Parsers$$tilde, "scala.util.parsing.combinator.Parsers$$tilde", ({
  mw: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lsourcecode_Text(value, source) {
  this.Oi = null;
  this.VG = null;
  this.Oi = value;
  this.VG = source;
}
$p = $c_Lsourcecode_Text.prototype = new $h_O();
$p.constructor = $c_Lsourcecode_Text;
/** @constructor */
function $h_Lsourcecode_Text() {
}
$h_Lsourcecode_Text.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().eN(this, (-889275714), null);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lsourcecode_Text) && ($m_sr_BoxesRunTime$().Q(this.Oi, x$0.Oi) && (this.VG === x$0.VG))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "Text";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Oi;
  }
  if ((n === 1)) {
    return this.VG;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  if ((n === 1)) {
    return "source";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lsourcecode_Text(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.mF)));
}
var $d_Lsourcecode_Text = new $TypeData().i($c_Lsourcecode_Text, "sourcecode.Text", ({
  mF: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lujson_Bool() {
}
$p = $c_Lujson_Bool.prototype = new $h_O();
$p.constructor = $c_Lujson_Bool;
/** @constructor */
function $h_Lujson_Bool() {
}
$h_Lujson_Bool.prototype = $p;
$p.yq = (function(f) {
  return $m_Lujson_Value$().yp(this, f);
});
$p.m = (function() {
  return $f_Lujson_Value__render__I__Z__T(this, (-1), false);
});
/** @constructor */
function $c_Lujson_Readable$() {
}
$p = $c_Lujson_Readable$.prototype = new $h_O();
$p.constructor = $c_Lujson_Readable$;
/** @constructor */
function $h_Lujson_Readable$() {
}
$h_Lujson_Readable$.prototype = $p;
$p.cy = (function(j, f) {
  return j.yq(f);
});
var $d_Lujson_Readable$ = new $TypeData().i($c_Lujson_Readable$, "ujson.Readable$", ({
  ND: 1,
  NE: 1,
  B: 1,
  e5: 1
}));
var $n_Lujson_Readable$;
function $m_Lujson_Readable$() {
  if ((!$n_Lujson_Readable$)) {
    $n_Lujson_Readable$ = new $c_Lujson_Readable$();
  }
  return $n_Lujson_Readable$;
}
/** @constructor */
function $c_Lupack_Bool() {
}
$p = $c_Lupack_Bool.prototype = new $h_O();
$p.constructor = $c_Lupack_Bool;
/** @constructor */
function $h_Lupack_Bool() {
}
$h_Lupack_Bool.prototype = $p;
function $p_Lupickle_core_BufferedValue$__rec$1__Lupickle_core_BufferedValue__V($thiz, x) {
  if ((x instanceof $c_Lupickle_core_BufferedValue$Arr)) {
    var x183 = x.Dm;
    $m_scm_ArrayBuffer$();
    var b = new $c_scm_ArrayBuffer$$anon$1();
    var it = x183.bB().o();
    while (it.p()) {
      b.mI(($p_Lupickle_core_BufferedValue$__rec$1__Lupickle_core_BufferedValue__V($thiz, it.q()), (void 0)));
    }
  } else if ((x instanceof $c_Lupickle_core_BufferedValue$Obj)) {
    var x178 = x.xQ;
    matchResult19: {
      $m_scm_ArrayBuffer$();
      var builder = new $c_scm_ArrayBuffer$$anon$1();
      var seen = $ct_scm_HashSet__(new $c_scm_HashSet());
      var it$1 = x178.bB().o();
      while (it$1.p()) {
        var next = it$1.q();
        if (seen.oA($objectGetClass(next.g()))) {
          builder.mI(next);
        }
      }
      var x136 = builder.gj;
      if ((x136 !== null)) {
        if ((x136.bL(1) === 0)) {
          var x168 = x136.l(0);
          if ((x168 !== null)) {
            var x169 = x168.g();
            if ((x169 instanceof $c_Lupickle_core_BufferedValue$Num)) {
              $f_scm_IndexedSeqOps__sortInPlaceBy__F1__s_math_Ordering__scm_IndexedSeqOps(x178, new $c_Lupickle_core_BufferedValue$$anon$1(), $m_s_math_Ordering$DeprecatedDoubleOrdering$());
              break matchResult19;
            }
            if ((x169 instanceof $c_Lupickle_core_BufferedValue$Float32)) {
              $f_scm_IndexedSeqOps__sortInPlaceBy__F1__s_math_Ordering__scm_IndexedSeqOps(x178, new $c_Lupickle_core_BufferedValue$$anon$2(), $m_s_math_Ordering$DeprecatedFloatOrdering$());
              break matchResult19;
            }
            if ((x169 instanceof $c_Lupickle_core_BufferedValue$Float64String)) {
              $f_scm_IndexedSeqOps__sortInPlaceBy__F1__s_math_Ordering__scm_IndexedSeqOps(x178, new $c_Lupickle_core_BufferedValue$$anon$3(), $m_s_math_Ordering$DeprecatedDoubleOrdering$());
              break matchResult19;
            }
            if ((x169 instanceof $c_Lupickle_core_BufferedValue$Int32)) {
              $f_scm_IndexedSeqOps__sortInPlaceBy__F1__s_math_Ordering__scm_IndexedSeqOps(x178, new $c_Lupickle_core_BufferedValue$$anon$4(), $m_s_math_Ordering$Int$());
              break matchResult19;
            }
            if ((x169 instanceof $c_Lupickle_core_BufferedValue$Int64)) {
              $f_scm_IndexedSeqOps__sortInPlaceBy__F1__s_math_Ordering__scm_IndexedSeqOps(x178, new $c_Lupickle_core_BufferedValue$$anon$5(), $m_s_math_Ordering$Long$());
              break matchResult19;
            }
            if ((x169 instanceof $c_Lupickle_core_BufferedValue$NumRaw)) {
              $f_scm_IndexedSeqOps__sortInPlaceBy__F1__s_math_Ordering__scm_IndexedSeqOps(x178, new $c_Lupickle_core_BufferedValue$$anon$6(), $m_s_math_Ordering$DeprecatedDoubleOrdering$());
              break matchResult19;
            }
            if ((x169 instanceof $c_Lupickle_core_BufferedValue$UInt64)) {
              $f_scm_IndexedSeqOps__sortInPlaceBy__F1__s_math_Ordering__scm_IndexedSeqOps(x178, new $c_Lupickle_core_BufferedValue$$anon$7(), $m_s_math_Ordering$Long$());
              break matchResult19;
            }
          }
        }
      }
      $f_scm_IndexedSeqOps__sortInPlaceBy__F1__s_math_Ordering__scm_IndexedSeqOps(x178, new $c_Lupickle_core_BufferedValue$$anon$8(), $m_s_math_Ordering$String$());
    }
    var it$2 = x178.bB().o();
    while (it$2.p()) {
      var x0$1 = it$2.q();
      matchResult20: {
        if ((x0$1 !== null)) {
          var c = x0$1.g();
          $p_Lupickle_core_BufferedValue$__rec$1__Lupickle_core_BufferedValue__V($thiz, x0$1.h());
          break matchResult20;
        }
        throw new $c_s_MatchError(x0$1);
      }
    }
  }
}
/** @constructor */
function $c_Lupickle_core_BufferedValue$() {
}
$p = $c_Lupickle_core_BufferedValue$.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_BufferedValue$;
/** @constructor */
function $h_Lupickle_core_BufferedValue$() {
}
$h_Lupickle_core_BufferedValue$.prototype = $p;
$p.a5e = (function(b) {
  if ((b instanceof $c_Lupickle_core_BufferedValue$Null)) {
    return "null";
  }
  if ((b instanceof $c_Lupickle_core_BufferedValue$True)) {
    return "true";
  }
  if ((b instanceof $c_Lupickle_core_BufferedValue$False)) {
    return "false";
  }
  if ((b instanceof $c_Lupickle_core_BufferedValue$Str)) {
    return $dp_toString__T(b.Ab);
  }
  if ((b instanceof $c_Lupickle_core_BufferedValue$Num)) {
    return $dp_toString__T(b.Dq);
  }
  if ((b instanceof $c_Lupickle_core_BufferedValue$Char)) {
    return ("" + $cToS(b.HY));
  }
  if ((b instanceof $c_Lupickle_core_BufferedValue$Binary)) {
    return $m_jl_String$().aQo(b.HT, b.HW, b.HV, $m_Ljava_nio_charset_UTF\uff3f8$());
  }
  if ((b instanceof $c_Lupickle_core_BufferedValue$Ext)) {
    return (("" + b.I3) + $m_jl_String$().aQo(b.HZ, b.I2, b.I1, $m_Ljava_nio_charset_UTF\uff3f8$()));
  }
  if ((b instanceof $c_Lupickle_core_BufferedValue$Float32)) {
    return ("" + b.Dn);
  }
  if ((b instanceof $c_Lupickle_core_BufferedValue$Float64String)) {
    return b.Do;
  }
  if ((b instanceof $c_Lupickle_core_BufferedValue$Int32)) {
    return ("" + b.Dp);
  }
  if ((b instanceof $c_Lupickle_core_BufferedValue$Int64)) {
    var $x_1 = b;
    var x24_$_lo = $x_1.Dv;
    var x24_$_hi = $x_1.Dw;
    return $m_RTLong$().kY(x24_$_lo, x24_$_hi);
  }
  if ((b instanceof $c_Lupickle_core_BufferedValue$NumRaw)) {
    return ("" + b.Dr);
  }
  if ((b instanceof $c_Lupickle_core_BufferedValue$UInt64)) {
    var $x_2 = b;
    var x16_$_lo = $x_2.Dx;
    var x16_$_hi = $x_2.Dy;
    return $m_RTLong$().kY(x16_$_lo, x16_$_hi);
  }
  if ((b instanceof $c_Lupickle_core_BufferedValue$Arr)) {
    var x12 = b.Dm;
    $m_scm_ArrayBuffer$();
    var b$1 = new $c_scm_ArrayBuffer$$anon$1();
    var it = x12.bB().o();
    while (it.p()) {
      b$1.mI($m_Lupickle_core_BufferedValue$().a5e(it.q()));
    }
    return $f_sc_IterableOnceOps__mkString__T__T__T__T(b$1.gj, "", "", "");
  }
  if ((b instanceof $c_Lupickle_core_BufferedValue$Obj)) {
    var x7 = b.xQ;
    $m_scm_ArrayBuffer$();
    var b$2 = new $c_scm_ArrayBuffer$$anon$1();
    var it$1 = x7.bB().o();
    while (it$1.p()) {
      var x0$1 = it$1.q();
      matchResult1: {
        var $x_3;
        if ((x0$1 !== null)) {
          var k = x0$1.g();
          var v = x0$1.h();
          var $x_3 = (("" + $m_Lupickle_core_BufferedValue$().a5e(k)) + $m_Lupickle_core_BufferedValue$().a5e(v));
          break matchResult1;
        }
        throw new $c_s_MatchError(x0$1);
      }
      b$2.mI($x_3);
    }
    return $f_sc_IterableOnceOps__mkString__T__T__T__T(b$2.gj, "", "", "");
  }
  throw new $c_s_MatchError(b);
});
$p.a4b = (function(tr, t, sortKeys, f) {
  if (sortKeys) {
    var buffered = tr.cy(t, $m_Lupickle_core_BufferedValue$Builder$());
    $p_Lupickle_core_BufferedValue$__rec$1__Lupickle_core_BufferedValue__V(this, buffered);
    return $m_Lupickle_core_BufferedValue$().JC(buffered, f);
  } else {
    return tr.cy(t, f);
  }
});
$p.JC = (function(j, f) {
  try {
    if ((j instanceof $c_Lupickle_core_BufferedValue$Null)) {
      var x324 = j.I9;
      return f.c8(x324);
    }
    if ((j instanceof $c_Lupickle_core_BufferedValue$True)) {
      var x321 = j.Ie;
      return f.eE(x321);
    }
    if ((j instanceof $c_Lupickle_core_BufferedValue$False)) {
      var x318 = j.I4;
      return f.eC(x318);
    }
    if ((j instanceof $c_Lupickle_core_BufferedValue$Str)) {
      var x314 = j.Ab;
      var x315 = j.Id;
      return f.cN(x314, x315);
    }
    if ((j instanceof $c_Lupickle_core_BufferedValue$Num)) {
      var x308 = j.Dq;
      var x309 = j.Os;
      var x310 = j.Ot;
      var x311 = j.Ia;
      return f.eD(x308, x309, x310, x311);
    }
    if ((j instanceof $c_Lupickle_core_BufferedValue$NumRaw)) {
      var x304 = j.Dr;
      var x305 = j.Ib;
      return f.e7(x304, x305);
    }
    if ((j instanceof $c_Lupickle_core_BufferedValue$Arr)) {
      var x300 = j.Dm;
      var x301 = j.HS;
      var ctx = f.cZ(x300.a1, x301);
      var it = x300.bB().o();
      while (it.p()) {
        var x0 = it.q();
        try {
          ctx.cU($m_Lupickle_core_BufferedValue$().JC(x0, ctx.d9()), x0.kr());
        } catch (e) {
          var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
          $m_Lupickle_core_ParseUtils$();
          var \u03b42$ = new $c_Lupickle_core_ParseUtils$$anon$1(x0.kr());
          if (\u03b42$.e5(e$2)) {
            \u03b42$.e2(e$2, $m_s_PartialFunction$().gt);
          } else {
            throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
          }
        }
      }
      return ctx.bV(x301);
    }
    if ((j instanceof $c_Lupickle_core_BufferedValue$Obj)) {
      var x295 = j.xQ;
      var x296 = j.Ou;
      var x297 = j.Ic;
      var ctx$3 = f.bQ(x295.a1, x296, x297);
      var this$12 = $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(new $c_sc_IterableOps$WithFilter(), x295, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => ((x$1 !== null) && (x$1.g(), x$1.h(), true)))));
      var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$2) => {
        matchResult71: {
          if ((x$1$2 !== null)) {
            var k$1 = x$1$2.g();
            var item$1 = x$1$2.h();
            var $x_2 = $m_Lupickle_core_BufferedValue$();
            try {
              var $x_1 = ctx$3.jy(x297);
            } catch (e$1) {
              var e$2$1 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
              $m_Lupickle_core_ParseUtils$();
              var \u03b43$ = new $c_Lupickle_core_ParseUtils$$anon$1(x297);
              if (\u03b43$.e5(e$2$1)) {
                var $x_1 = \u03b43$.e2(e$2$1, $m_s_PartialFunction$().gt);
              } else {
                var $x_1;
                throw ((e$2$1 instanceof $c_sjs_js_JavaScriptException) ? e$2$1.bf : e$2$1);
              }
            }
            ctx$3.jz($x_2.JC(k$1, $x_1));
            try {
              ctx$3.cU($m_Lupickle_core_BufferedValue$().JC(item$1, ctx$3.d9()), item$1.kr());
              break matchResult71;
            } catch (e$3) {
              var e$4 = ((e$3 instanceof $c_jl_Throwable) ? e$3 : new $c_sjs_js_JavaScriptException(e$3));
              $m_Lupickle_core_ParseUtils$();
              var \u03b44$ = new $c_Lupickle_core_ParseUtils$$anon$1(item$1.kr());
              if (\u03b44$.e5(e$4)) {
                \u03b44$.e2(e$4, $m_s_PartialFunction$().gt);
                break matchResult71;
              } else {
                throw ((e$4 instanceof $c_sjs_js_JavaScriptException) ? e$4.bf : e$4);
              }
            }
          }
          throw new $c_s_MatchError(x$1$2);
        }
      }));
      this$12.qY().F(f$1);
      return ctx$3.bV(x297);
    }
    if ((j instanceof $c_Lupickle_core_BufferedValue$Binary)) {
      var x289 = j.HT;
      var x290 = j.HW;
      var x291 = j.HV;
      var x292 = j.HU;
      return f.fb(x289, x290, x291, x292);
    }
    if ((j instanceof $c_Lupickle_core_BufferedValue$Char)) {
      var x285 = j.HY;
      var x286 = j.HX;
      return f.fc(x285, x286);
    }
    if ((j instanceof $c_Lupickle_core_BufferedValue$Ext)) {
      var x278 = j.I3;
      var x279 = j.HZ;
      var x280 = j.I2;
      var x281 = j.I1;
      var x282 = j.I0;
      return f.fd(x278, x279, x280, x281, x282);
    }
    if ((j instanceof $c_Lupickle_core_BufferedValue$Float32)) {
      var x274 = j.Dn;
      var x275 = j.I5;
      return f.eY(x274, x275);
    }
    if ((j instanceof $c_Lupickle_core_BufferedValue$Float64String)) {
      var x270 = j.Do;
      var x271 = j.I6;
      return f.fA(x270, x271);
    }
    if ((j instanceof $c_Lupickle_core_BufferedValue$Int32)) {
      var x266 = j.Dp;
      var x267 = j.I7;
      return f.em(x266, x267);
    }
    if ((j instanceof $c_Lupickle_core_BufferedValue$Int64)) {
      var $x_3 = j;
      var x262_$_lo = $x_3.Dv;
      var x262_$_hi = $x_3.Dw;
      var x263 = j.I8;
      return f.eZ(x262_$_lo, x262_$_hi, x263);
    }
    if ((j instanceof $c_Lupickle_core_BufferedValue$UInt64)) {
      var $x_4 = j;
      var x258_$_lo = $x_4.Dx;
      var x258_$_hi = $x_4.Dy;
      var x259 = j.If;
      return f.fe(x258_$_lo, x258_$_hi, x259);
    }
    throw new $c_s_MatchError(j);
  } catch (e$2$2) {
    var e$3$1 = ((e$2$2 instanceof $c_jl_Throwable) ? e$2$2 : new $c_sjs_js_JavaScriptException(e$2$2));
    $m_Lupickle_core_ParseUtils$();
    var \u03b41$ = new $c_Lupickle_core_ParseUtils$$anon$1(j.kr());
    if (\u03b41$.e5(e$3$1)) {
      return \u03b41$.e2(e$3$1, $m_s_PartialFunction$().gt);
    } else {
      throw ((e$3$1 instanceof $c_sjs_js_JavaScriptException) ? e$3$1.bf : e$3$1);
    }
  }
});
$p.cy = (function(j, f) {
  return this.JC(j, f);
});
var $d_Lupickle_core_BufferedValue$ = new $TypeData().i($c_Lupickle_core_BufferedValue$, "upickle.core.BufferedValue$", ({
  O5: 1,
  B: 1,
  d: 1,
  u: 1
}));
var $n_Lupickle_core_BufferedValue$;
function $m_Lupickle_core_BufferedValue$() {
  if ((!$n_Lupickle_core_BufferedValue$)) {
    $n_Lupickle_core_BufferedValue$ = new $c_Lupickle_core_BufferedValue$();
  }
  return $n_Lupickle_core_BufferedValue$;
}
/** @constructor */
function $c_Lupickle_core_LinkedHashMap$$anon$1(it$2, outer) {
  this.adL = null;
  this.aJK = null;
  this.adL = it$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aJK = outer;
}
$p = $c_Lupickle_core_LinkedHashMap$$anon$1.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_LinkedHashMap$$anon$1;
/** @constructor */
function $h_Lupickle_core_LinkedHashMap$$anon$1() {
}
$h_Lupickle_core_LinkedHashMap$$anon$1.prototype = $p;
$p.V = (function() {
  return (-1);
});
$p.F = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f);
});
$p.iW = (function(p) {
  return $f_sc_IterableOnceOps__find__F1__s_Option(this, p);
});
$p.hO = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$p.kT = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$p.aa = (function() {
  return $f_sc_IterableOnceOps__size__I(this);
});
$p.cR = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
});
$p.k2 = (function(num) {
  return $f_sc_IterableOnceOps__sum__s_math_Numeric__O(this, num);
});
$p.lr = (function(ord) {
  return $f_sc_IterableOnceOps__min__s_math_Ordering__O(this, ord);
});
$p.lq = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord);
});
$p.nw = (function(pf) {
  return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this, pf);
});
$p.lf = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$p.bM = (function() {
  return $m_sci_Nil$().b6(this);
});
$p.d2 = (function() {
  return $m_sci_Vector$().X(this);
});
$p.eX = (function(ev) {
  return $m_sci_Map$().ao(this);
});
$p.iz = (function() {
  return $m_sci_Seq$().fw(this);
});
$p.nG = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$p.o = (function() {
  return this;
});
$p.c = (function() {
  return (!this.p());
});
$p.lS = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs);
});
$p.Ju = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n);
});
$p.iV = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1));
});
$p.ui = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until);
});
$p.m = (function() {
  return "<iterator>";
});
$p.p = (function() {
  return this.adL.p();
});
$p.dC = (function() {
  var key = this.adL.q();
  return new $c_T2(key, $p_ju_HashMap__getOrDefaultImpl__O__O__O(this.aJK.Ov, key, null));
});
$p.q = (function() {
  return this.dC();
});
var $d_Lupickle_core_LinkedHashMap$$anon$1 = new $TypeData().i($c_Lupickle_core_LinkedHashMap$$anon$1, "upickle.core.LinkedHashMap$$anon$1", ({
  Op: 1,
  e: 1,
  f: 1,
  p: 1
}));
/** @constructor */
function $c_Lupickle_core_TraceVisitor$$anon$1(objVisitor$3, outer) {
  this.Ox = null;
  this.Oy = null;
  this.Ow = null;
  this.Ox = objVisitor$3;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Ow = outer;
}
$p = $c_Lupickle_core_TraceVisitor$$anon$1.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_TraceVisitor$$anon$1;
/** @constructor */
function $h_Lupickle_core_TraceVisitor$$anon$1() {
}
$h_Lupickle_core_TraceVisitor$$anon$1.prototype = $p;
$p.jr = (function() {
  return true;
});
$p.m = (function() {
  return $f_Lupickle_core_TraceVisitor$HasPath__path__T(this);
});
$p.jy = (function(index) {
  return new $c_Lupickle_core_TraceVisitor$$anon$2(this.Ox, index, this);
});
$p.jz = (function(v) {
  if ((this.Oy === null)) {
    this.Oy = "?";
  }
  this.Ox.jz(v);
});
$p.d9 = (function() {
  return $ct_Lupickle_core_TraceVisitor__Lupickle_core_Visitor__Lupickle_core_TraceVisitor$HasPath__Lupickle_core_TraceVisitor$Wrapper__(new $c_Lupickle_core_TraceVisitor(), this.Ox.d9(), this, this.Ow.Ds);
});
$p.cU = (function(v, index) {
  this.Oy = null;
  this.Ox.cU(v, index);
});
$p.bV = (function(index) {
  this.Ow.Ds.Ih = this.Ow.Ig;
  return this.Ox.bV(index);
});
$p.ahr = (function() {
  var this$1 = $m_s_Option$().as(this.Oy);
  if (this$1.c()) {
    return $m_s_None$();
  } else {
    var x0 = this$1.d();
    return new $c_s_Some((("'" + x0.split("'").join("\\'")) + "'"));
  }
});
$p.a4l = (function() {
  return new $c_s_Some(this.Ow.Ig);
});
$p.h6 = (function() {
  return this;
});
var $d_Lupickle_core_TraceVisitor$$anon$1 = new $TypeData().i($c_Lupickle_core_TraceVisitor$$anon$1, "upickle.core.TraceVisitor$$anon$1", ({
  Ox: 1,
  ab: 1,
  aO: 1,
  e6: 1
}));
/** @constructor */
function $c_Lupickle_core_TraceVisitor$$anon$2(objVisitor$2, index$1, outer) {
  this.iH = null;
  this.adM = null;
  this.Ig = null;
  this.Ds = null;
  this.adN = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.adN = outer;
  $ct_Lupickle_core_TraceVisitor__Lupickle_core_Visitor__Lupickle_core_TraceVisitor$HasPath__Lupickle_core_TraceVisitor$Wrapper__(this, objVisitor$2.jy(index$1), outer, outer.Ow.Ds);
}
$p = $c_Lupickle_core_TraceVisitor$$anon$2.prototype = new $h_Lupickle_core_TraceVisitor();
$p.constructor = $c_Lupickle_core_TraceVisitor$$anon$2;
/** @constructor */
function $h_Lupickle_core_TraceVisitor$$anon$2() {
}
$h_Lupickle_core_TraceVisitor$$anon$2.prototype = $p;
$p.cN = (function(s, index) {
  this.adN.Oy = $dp_toString__T(s);
  return this.adM.cN(this.adN.Oy, index);
});
var $d_Lupickle_core_TraceVisitor$$anon$2 = new $TypeData().i($c_Lupickle_core_TraceVisitor$$anon$2, "upickle.core.TraceVisitor$$anon$2", ({
  Oy: 1,
  no: 1,
  bJ: 1,
  x: 1
}));
/** @constructor */
function $c_Lupickle_core_TraceVisitor$$anon$3(arrVisitor$2, outer) {
  this.a2h = null;
  this.a2i = 0;
  this.W2 = null;
  this.a2h = arrVisitor$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.W2 = outer;
  this.a2i = 0;
  outer.Ds.Ih = this;
}
$p = $c_Lupickle_core_TraceVisitor$$anon$3.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_TraceVisitor$$anon$3;
/** @constructor */
function $h_Lupickle_core_TraceVisitor$$anon$3() {
}
$h_Lupickle_core_TraceVisitor$$anon$3.prototype = $p;
$p.jr = (function() {
  return false;
});
$p.h6 = (function() {
  return this;
});
$p.m = (function() {
  return $f_Lupickle_core_TraceVisitor$HasPath__path__T(this);
});
$p.d9 = (function() {
  return $ct_Lupickle_core_TraceVisitor__Lupickle_core_Visitor__Lupickle_core_TraceVisitor$HasPath__Lupickle_core_TraceVisitor$Wrapper__(new $c_Lupickle_core_TraceVisitor(), this.a2h.d9(), this, this.W2.Ds);
});
$p.cU = (function(v, index) {
  this.a2h.cU(v, index);
  this.a2i = ((1 + this.a2i) | 0);
});
$p.bV = (function(index) {
  this.W2.Ds.Ih = this.W2.Ig;
  return this.a2h.bV(index);
});
$p.ahr = (function() {
  return new $c_s_Some(("" + this.a2i));
});
$p.a4l = (function() {
  return new $c_s_Some(this.W2.Ig);
});
var $d_Lupickle_core_TraceVisitor$$anon$3 = new $TypeData().i($c_Lupickle_core_TraceVisitor$$anon$3, "upickle.core.TraceVisitor$$anon$3", ({
  Oz: 1,
  ab: 1,
  b5: 1,
  e6: 1
}));
function $ct_Lupickle_core_Types$Reader$Delegate__Lupickle_core_Types$Reader$__Lupickle_core_Visitor__($thiz, outer, delegatedReader) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $thiz.adR = outer;
  $ct_Lupickle_core_Visitor$Delegate__Lupickle_core_Visitor__($thiz, delegatedReader);
  return $thiz;
}
/** @constructor */
function $c_Lupickle_core_Types$Reader$Delegate() {
  this.iH = null;
  this.adR = null;
}
$p = $c_Lupickle_core_Types$Reader$Delegate.prototype = new $h_Lupickle_core_Visitor$Delegate();
$p.constructor = $c_Lupickle_core_Types$Reader$Delegate;
/** @constructor */
function $h_Lupickle_core_Types$Reader$Delegate() {
}
$h_Lupickle_core_Types$Reader$Delegate.prototype = $p;
$p.gB = (function() {
  return this;
});
$p.bQ = (function(length, jsonableKeys, index) {
  return $c_Lupickle_core_Visitor$Delegate.prototype.bQ.call(this, length, jsonableKeys, index);
});
$p.cZ = (function(length, index) {
  return $c_Lupickle_core_Visitor$Delegate.prototype.cZ.call(this, length, index);
});
$p.oH = (function() {
  return this.adR.a2l;
});
$p.ha = (function() {
  return this.oH();
});
var $d_Lupickle_core_Types$Reader$Delegate = new $TypeData().i($c_Lupickle_core_Types$Reader$Delegate, "upickle.core.Types$Reader$Delegate", ({
  np: 1,
  bJ: 1,
  x: 1,
  D: 1
}));
function $ct_Lupickle_core_Types$Reader$MapReader__Lupickle_core_Types$Reader$__Lupickle_core_Visitor__($thiz, outer, delegatedReader) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $thiz.adS = outer;
  $ct_Lupickle_core_Visitor$MapReader__Lupickle_core_Visitor__($thiz, delegatedReader);
  return $thiz;
}
/** @constructor */
function $c_Lupickle_core_Types$Reader$MapReader() {
  this.kJ = null;
  this.adS = null;
}
$p = $c_Lupickle_core_Types$Reader$MapReader.prototype = new $h_Lupickle_core_Visitor$MapReader();
$p.constructor = $c_Lupickle_core_Types$Reader$MapReader;
/** @constructor */
function $h_Lupickle_core_Types$Reader$MapReader() {
}
$h_Lupickle_core_Types$Reader$MapReader.prototype = $p;
$p.gB = (function() {
  return this;
});
$p.bQ = (function(length, jsonableKeys, index) {
  return $c_Lupickle_core_Visitor$MapReader.prototype.bQ.call(this, length, jsonableKeys, index);
});
$p.cZ = (function(length, index) {
  return $c_Lupickle_core_Visitor$MapReader.prototype.cZ.call(this, length, index);
});
$p.oH = (function() {
  return this.adS.a2l;
});
$p.ha = (function() {
  return this.oH();
});
/** @constructor */
function $c_Lupickle_core_Types$TaggedWriter$Leaf(outer, checker, tagKey, tagValue, r) {
  this.aJZ = null;
  this.adX = null;
  this.adY = null;
  this.adW = null;
  this.aJY = null;
  this.aJZ = checker;
  this.adX = tagKey;
  this.adY = tagValue;
  this.adW = r;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aJY = outer;
}
$p = $c_Lupickle_core_Types$TaggedWriter$Leaf.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_Types$TaggedWriter$Leaf;
/** @constructor */
function $h_Lupickle_core_Types$TaggedWriter$Leaf() {
}
$h_Lupickle_core_Types$TaggedWriter$Leaf.prototype = $p;
$p.cT = (function() {
  return false;
});
$p.cW = (function() {
  return this;
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.d0 = (function(out, v) {
  return $f_Lupickle_core_Types$TaggedWriter__write0__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.WP = (function(v) {
  var x11 = this.aJZ;
  if ((x11 instanceof $c_Lupickle_core_Annotator$Checker$Cls)) {
    if (x11.W1.ba.I(v)) {
      return new $c_T3(this.adX, this.adY, this.adW);
    }
  }
  if (false) {
    if ($m_sr_BoxesRunTime$().Q(x11.g(), v)) {
      return new $c_T3(this.adX, this.adY, this.adW);
    }
  }
  return null;
});
$p.Yf = (function() {
  return this.aJY.adV;
});
$p.a5b = (function() {
  return this.Yf();
});
var $d_Lupickle_core_Types$TaggedWriter$Leaf = new $TypeData().i($c_Lupickle_core_Types$TaggedWriter$Leaf, "upickle.core.Types$TaggedWriter$Leaf", ({
  OR: 1,
  B: 1,
  E: 1,
  cd: 1
}));
/** @constructor */
function $c_Lupickle_core_Types$TaggedWriter$Node(outer, rs) {
  this.aK1 = null;
  this.aK0 = null;
  this.aK1 = rs;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aK0 = outer;
}
$p = $c_Lupickle_core_Types$TaggedWriter$Node.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_Types$TaggedWriter$Node;
/** @constructor */
function $h_Lupickle_core_Types$TaggedWriter$Node() {
}
$h_Lupickle_core_Types$TaggedWriter$Node.prototype = $p;
$p.cT = (function() {
  return false;
});
$p.cW = (function() {
  return this;
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.d0 = (function(out, v) {
  return $f_Lupickle_core_Types$TaggedWriter__write0__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.WP = (function(v) {
  var xs = this.aK1;
  var x = null;
  var i = xs.o();
  while (((x === null) && i.p())) {
    var t = i.q().WP(v);
    if ((t !== null)) {
      x = t;
    }
  }
  return x;
});
$p.Yf = (function() {
  return this.aK0.adV;
});
$p.a5b = (function() {
  return this.Yf();
});
var $d_Lupickle_core_Types$TaggedWriter$Node = new $TypeData().i($c_Lupickle_core_Types$TaggedWriter$Node, "upickle.core.Types$TaggedWriter$Node", ({
  OS: 1,
  B: 1,
  E: 1,
  cd: 1
}));
/** @constructor */
function $c_Lupickle_core_compat_LinkedHashMapCompat$$anon$2() {
  this.ae1 = null;
  this.ae1 = new $c_Lupickle_core_LinkedHashMap($ct_ju_LinkedHashMap__(new $c_ju_LinkedHashMap()));
}
$p = $c_Lupickle_core_compat_LinkedHashMapCompat$$anon$2.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_compat_LinkedHashMapCompat$$anon$2;
/** @constructor */
function $h_Lupickle_core_compat_LinkedHashMapCompat$$anon$2() {
}
$h_Lupickle_core_compat_LinkedHashMapCompat$$anon$2.prototype = $p;
$p.dG = (function(elems) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, elems);
});
$p.f9 = (function(size) {
});
$p.aWQ = (function(elem) {
  this.ae1.aLU(elem);
  return this;
});
$p.Y = (function(elem) {
  return this.aWQ(elem);
});
$p.aR = (function() {
  return this.ae1;
});
var $d_Lupickle_core_compat_LinkedHashMapCompat$$anon$2 = new $TypeData().i($c_Lupickle_core_compat_LinkedHashMapCompat$$anon$2, "upickle.core.compat.LinkedHashMapCompat$$anon$2", ({
  OZ: 1,
  S: 1,
  T: 1,
  Y: 1
}));
function $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V($thiz, ctx, mappedArgsI, w, value) {
  var keyVisitor = ctx.jy((-1));
  ctx.jz(keyVisitor.cN(mappedArgsI, (-1)));
  ctx.cU($f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(w, ctx.d9(), value), (-1));
}
function $ct_Lupickle_implicits_CaseObjectContext__I__($thiz, fieldCount) {
  $thiz.Ac = (-1);
  $thiz.xT = 0;
  $thiz.xU = 0;
  return $thiz;
}
/** @constructor */
function $c_Lupickle_implicits_CaseObjectContext() {
  this.Ac = 0;
  this.xT = 0;
  this.xU = 0;
}
$p = $c_Lupickle_implicits_CaseObjectContext.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_CaseObjectContext;
/** @constructor */
function $h_Lupickle_implicits_CaseObjectContext() {
}
$h_Lupickle_implicits_CaseObjectContext.prototype = $p;
$p.jr = (function() {
  return true;
});
$p.a36 = (function() {
  return this.Ac;
});
$p.aNg = (function(x$1) {
  this.Ac = x$1;
});
$p.a2 = (function(i, v) {
  var x_$_lo = this.xT;
  var x_$_hi = this.xU;
  var lo = (((32 & i) === 0) ? (1 << i) : 0);
  var hi = (((32 & i) === 0) ? 0 : (1 << i));
  if ((((x_$_lo & lo) | (x_$_hi & hi)) === 0)) {
    var x$1_$_lo = this.xT;
    var x$1_$_hi = this.xU;
    var lo$2 = (((32 & i) === 0) ? (1 << i) : 0);
    var hi$2 = (((32 & i) === 0) ? 0 : (1 << i));
    var lo$3 = (x$1_$_lo | lo$2);
    var hi$3 = (x$1_$_hi | hi$2);
    this.xT = lo$3;
    this.xU = hi$3;
    $f_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2$ObjectContext__storeAggregatedValue__I__O__V(this, i, v);
  }
});
$p.aNP = (function(rawArgsLength, mappedArgs) {
  throw new $c_Lupickle_core_Abort(("missing keys in dictionary: " + $f_sc_IterableOnceOps__mkString__T__T__T__T($ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(new $c_sc_IterableOps$WithFilter(), new $c_sci_Range$Exclusive(0, rawArgsLength, 1), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((i) => {
    var i$1 = (i | 0);
    var x_$_lo = this.xT;
    var x_$_hi = this.xU;
    var lo = (((32 & i$1) === 0) ? (1 << i$1) : 0);
    var hi = (((32 & i$1) === 0) ? 0 : (1 << i$1));
    return (((x_$_lo & lo) | (x_$_hi & hi)) === 0);
  }))).L(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((i$2) => {
    var i$3 = (i$2 | 0);
    return mappedArgs.a[i$3];
  }))), "", ", ", "")));
});
$p.aMG = (function(rawArgsBitset_$_lo, rawArgsBitset_$_hi) {
  var x_$_lo = this.xT;
  var x_$_hi = this.xU;
  return (((x_$_lo ^ rawArgsBitset_$_lo) | (x_$_hi ^ rawArgsBitset_$_hi)) !== 0);
});
$p.jy = (function(index) {
  return $m_Lupickle_core_StringVisitor$();
});
$p.h6 = (function() {
  return this;
});
function $ct_Lupickle_implicits_HugeCaseObjectContext__I__($thiz, fieldCount) {
  $thiz.vO = (-1);
  $thiz.Dt = $m_jl_reflect_Array$().m0($d_J.l(), new $ac_I(new Int32Array([((1 + (((fieldCount + (((fieldCount >> 5) >>> 26) | 0)) | 0) >> 6)) | 0)])));
  return $thiz;
}
/** @constructor */
function $c_Lupickle_implicits_HugeCaseObjectContext() {
  this.vO = 0;
  this.Dt = null;
}
$p = $c_Lupickle_implicits_HugeCaseObjectContext.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_HugeCaseObjectContext;
/** @constructor */
function $h_Lupickle_implicits_HugeCaseObjectContext() {
}
$h_Lupickle_implicits_HugeCaseObjectContext.prototype = $p;
$p.jr = (function() {
  return true;
});
$p.a36 = (function() {
  return this.vO;
});
$p.aNg = (function(x$1) {
  this.vO = x$1;
});
$p.a2 = (function(i, v) {
  var $x_1 = this.Dt.a;
  var $x_2 = ((((i + (((i >> 5) >>> 26) | 0)) | 0) >> 6) << 1);
  var x_$_lo = $x_1[$x_2];
  var x_$_hi = $x_1[(($x_2 + 1) | 0)];
  var lo = (((32 & i) === 0) ? (1 << i) : 0);
  var hi = (((32 & i) === 0) ? 0 : (1 << i));
  if ((((x_$_lo & lo) | (x_$_hi & hi)) === 0)) {
    var \u03b42$ = this.Dt;
    var i$2 = (((i + (((i >> 5) >>> 26) | 0)) | 0) >> 6);
    var $x_3 = \u03b42$.a;
    var $x_4 = (i$2 << 1);
    var x$1_$_lo = $x_3[$x_4];
    var x$1_$_hi = $x_3[(($x_4 + 1) | 0)];
    var lo$2 = (((32 & i) === 0) ? (1 << i) : 0);
    var hi$2 = (((32 & i) === 0) ? 0 : (1 << i));
    var lo$3 = (x$1_$_lo | lo$2);
    var hi$3 = (x$1_$_hi | hi$2);
    var $x_5 = \u03b42$.a;
    var $x_6 = (i$2 << 1);
    $x_5[$x_6] = lo$3;
    $x_5[(($x_6 + 1) | 0)] = hi$3;
    $f_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2$ObjectContext__storeAggregatedValue__I__O__V(this, i, v);
  }
});
$p.aNP = (function(rawArgsLength, mappedArgs) {
  throw new $c_Lupickle_core_Abort(("missing keys in dictionary: " + $f_sc_IterableOnceOps__mkString__T__T__T__T($ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(new $c_sc_IterableOps$WithFilter(), new $c_sci_Range$Exclusive(0, rawArgsLength, 1), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((i) => {
    var i$1 = (i | 0);
    var $x_1 = this.Dt.a;
    var $x_2 = ((((i$1 + (((i$1 >> 5) >>> 26) | 0)) | 0) >> 6) << 1);
    var x_$_lo = $x_1[$x_2];
    var x_$_hi = $x_1[(($x_2 + 1) | 0)];
    var lo = (((32 & i$1) === 0) ? (1 << i$1) : 0);
    var hi = (((32 & i$1) === 0) ? 0 : (1 << i$1));
    return (((x_$_lo & lo) | (x_$_hi & hi)) === 0);
  }))).L(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((i$2) => {
    var i$3 = (i$2 | 0);
    return mappedArgs.a[i$3];
  }))), "", ", ", "")));
});
$p.aMG = (function(rawArgsLength_$_lo, rawArgsLength_$_hi) {
  var bits = new $c_sr_IntRef(0);
  var xs = this.Dt;
  var f = ((v1) => {
    var $x_1 = $uJ(v1);
    var v_$_lo = $x_1.l;
    var v_$_hi = $x_1.h;
    bits.an = ((bits.an + (($m_jl_Integer$().dz(v_$_lo) + $m_jl_Integer$().dz(v_$_hi)) | 0)) | 0);
  });
  var len = ((xs.a.length >>> 1) | 0);
  var i = 0;
  if ((xs instanceof $ac_O)) {
    while ((i < len)) {
      var x0 = xs.a[i];
      f(x0);
      i = ((1 + i) | 0);
    }
  } else if ((xs instanceof $ac_I)) {
    while ((i < len)) {
      var x0$1 = xs.a[i];
      f(x0$1);
      i = ((1 + i) | 0);
    }
  } else if ((xs instanceof $ac_D)) {
    while ((i < len)) {
      var x0$2 = xs.a[i];
      f(x0$2);
      i = ((1 + i) | 0);
    }
  } else if ((xs !== null)) {
    while ((i < len)) {
      var $x_2 = xs.a;
      var $x_3 = (i << 1);
      var x0$3_$_lo = $x_2[$x_3];
      var x0$3_$_hi = $x_2[(($x_3 + 1) | 0)];
      f($bL(x0$3_$_lo, x0$3_$_hi));
      i = ((1 + i) | 0);
    }
  } else if ((xs instanceof $ac_F)) {
    while ((i < len)) {
      var x0$4 = xs.a[i];
      f(x0$4);
      i = ((1 + i) | 0);
    }
  } else if ((xs instanceof $ac_C)) {
    while ((i < len)) {
      var x0$5 = xs.a[i];
      f($bC(x0$5));
      i = ((1 + i) | 0);
    }
  } else if ((xs instanceof $ac_B)) {
    while ((i < len)) {
      var x0$6 = xs.a[i];
      f(x0$6);
      i = ((1 + i) | 0);
    }
  } else if ((xs instanceof $ac_S)) {
    while ((i < len)) {
      var x0$7 = xs.a[i];
      f(x0$7);
      i = ((1 + i) | 0);
    }
  } else if ((xs instanceof $ac_Z)) {
    while ((i < len)) {
      var x0$8 = xs.a[i];
      f(x0$8);
      i = ((1 + i) | 0);
    }
  } else {
    throw new $c_s_MatchError(xs);
  }
  var value = bits.an;
  return (((value ^ rawArgsLength_$_lo) | ((value >> 31) ^ rawArgsLength_$_hi)) !== 0);
});
$p.jy = (function(index) {
  return $m_Lupickle_core_StringVisitor$();
});
$p.h6 = (function() {
  return this;
});
/** @constructor */
function $c_Lupickle_implicits_Readers$JavaReader(outer, evidence$1) {
  this.aKQ = null;
  this.aeb = null;
  this.aKQ = evidence$1;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aeb = outer;
}
$p = $c_Lupickle_implicits_Readers$JavaReader.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$JavaReader;
/** @constructor */
function $h_Lupickle_implicits_Readers$JavaReader() {
}
$h_Lupickle_implicits_Readers$JavaReader.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().eN(this, (-889275714), null);
});
$p.e = (function(x$0) {
  return ((this === x$0) || (((x$0 instanceof $c_Lupickle_implicits_Readers$JavaReader) && (x$0.aeb === this.aeb)) || false));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 0;
});
$p.B = (function() {
  return "JavaReader";
});
$p.A = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.DR = (function() {
  return this.aKQ;
});
function $isArrayOf_Lupickle_implicits_Readers$JavaReader(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ns)));
}
var $d_Lupickle_implicits_Readers$JavaReader = new $TypeData().i($c_Lupickle_implicits_Readers$JavaReader, "upickle.implicits.Readers$JavaReader", ({
  ns: 1,
  b: 1,
  c: 1,
  a: 1
}));
function $f_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2$ObjectContext__$init$__V($thiz) {
  $thiz.aTe($m_jl_reflect_Array$().m0($d_O.l(), new $ac_I(new Int32Array([$thiz.pJ().gQ]))));
  $thiz.aTd(new $c_scm_ListBuffer());
  $thiz.aiu("");
  $thiz.a4L(false);
}
function $f_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2$ObjectContext__storeAggregatedValue__I__O__V($thiz, currentIndex, v) {
  if ((currentIndex === (-1))) {
    if ($thiz.aSs()) {
      $thiz.ait().bb(new $c_T2($thiz.a5c(), v));
    }
  } else {
    $thiz.aiv().a[currentIndex] = v;
  }
}
function $f_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2$ObjectContext__subVisitor__Lupickle_core_Visitor($thiz) {
  return (($thiz.a36() === (-1)) ? ($thiz.pJ().aP4() ? $p_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2__$1$__T2($thiz.pJ()).g() : $m_Lupickle_core_NoOpVisitor$()) : $p_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2__$1$__T2($thiz.pJ()).h().a[$thiz.a36()]);
}
function $f_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2$ObjectContext__visitKeyValue__O__V($thiz, v) {
  $thiz.a4L(false);
  $thiz.aiu(($thiz.pJ(), $dp_toString__T(v)));
  $thiz.aNg($thiz.pJ().jV($thiz.a5c()));
  if (($thiz.a36() === (-1))) {
    if ($thiz.pJ().aP4()) {
      $thiz.a4L(true);
    } else if ((!$thiz.pJ().iM)) {
      throw new $c_Lupickle_core_Abort(("Unknown Key: " + $thiz.a5c()));
    }
  }
}
function $f_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2$ObjectContext__visitEnd__I__O($thiz, index) {
  $thiz.pJ().k1($thiz);
  var $x_1 = $thiz.pJ();
  if ($thiz.aMG($x_1.iO, $x_1.iP)) {
    $thiz.aNP($thiz.pJ().gQ, $thiz.pJ().jR());
  }
  return $thiz.pJ().iN.R($thiz.aiv(), $thiz.ait());
}
/** @constructor */
function $c_Lupickle_implicits_Writers$$anon$1(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lupickle_implicits_Writers$$anon$1.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Writers$$anon$1;
/** @constructor */
function $h_Lupickle_implicits_Writers$$anon$1() {
}
$h_Lupickle_implicits_Writers$$anon$1.prototype = $p;
$p.cW = (function() {
  return this;
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.cT = (function() {
  return true;
});
$p.d0 = (function(out, v) {
  return $f_Lupickle_implicits_Writers$SimpleMapKeyWriter__write0__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.Qd = (function(v) {
  return v;
});
var $d_Lupickle_implicits_Writers$$anon$1 = new $TypeData().i($c_Lupickle_implicits_Writers$$anon$1, "upickle.implicits.Writers$$anon$1", ({
  PH: 1,
  B: 1,
  E: 1,
  bK: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Writers$$anon$10(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lupickle_implicits_Writers$$anon$10.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Writers$$anon$10;
/** @constructor */
function $h_Lupickle_implicits_Writers$$anon$10() {
}
$h_Lupickle_implicits_Writers$$anon$10.prototype = $p;
$p.cW = (function() {
  return this;
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.cT = (function() {
  return true;
});
$p.d0 = (function(out, v) {
  return $f_Lupickle_implicits_Writers$SimpleMapKeyWriter__write0__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.Qd = (function(v) {
  return v.m();
});
var $d_Lupickle_implicits_Writers$$anon$10 = new $TypeData().i($c_Lupickle_implicits_Writers$$anon$10, "upickle.implicits.Writers$$anon$10", ({
  PI: 1,
  B: 1,
  E: 1,
  bK: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Writers$$anon$12(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lupickle_implicits_Writers$$anon$12.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Writers$$anon$12;
/** @constructor */
function $h_Lupickle_implicits_Writers$$anon$12() {
}
$h_Lupickle_implicits_Writers$$anon$12.prototype = $p;
$p.cW = (function() {
  return this;
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.cT = (function() {
  return true;
});
$p.d0 = (function(out, v) {
  return $f_Lupickle_implicits_Writers$SimpleMapKeyWriter__write0__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.Qd = (function(v) {
  return v.m();
});
var $d_Lupickle_implicits_Writers$$anon$12 = new $TypeData().i($c_Lupickle_implicits_Writers$$anon$12, "upickle.implicits.Writers$$anon$12", ({
  PK: 1,
  B: 1,
  E: 1,
  bK: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Writers$$anon$13(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lupickle_implicits_Writers$$anon$13.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Writers$$anon$13;
/** @constructor */
function $h_Lupickle_implicits_Writers$$anon$13() {
}
$h_Lupickle_implicits_Writers$$anon$13.prototype = $p;
$p.cW = (function() {
  return this;
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.cT = (function() {
  return true;
});
$p.d0 = (function(out, v) {
  return $f_Lupickle_implicits_Writers$SimpleMapKeyWriter__write0__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.Qd = (function(v) {
  return v.dN.m();
});
var $d_Lupickle_implicits_Writers$$anon$13 = new $TypeData().i($c_Lupickle_implicits_Writers$$anon$13, "upickle.implicits.Writers$$anon$13", ({
  PL: 1,
  B: 1,
  E: 1,
  bK: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Writers$$anon$14(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lupickle_implicits_Writers$$anon$14.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Writers$$anon$14;
/** @constructor */
function $h_Lupickle_implicits_Writers$$anon$14() {
}
$h_Lupickle_implicits_Writers$$anon$14.prototype = $p;
$p.cW = (function() {
  return this;
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.cT = (function() {
  return true;
});
$p.d0 = (function(out, v) {
  return $f_Lupickle_implicits_Writers$SimpleMapKeyWriter__write0__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.Qd = (function(v) {
  return v.UE;
});
var $d_Lupickle_implicits_Writers$$anon$14 = new $TypeData().i($c_Lupickle_implicits_Writers$$anon$14, "upickle.implicits.Writers$$anon$14", ({
  PM: 1,
  B: 1,
  E: 1,
  bK: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Writers$$anon$15(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lupickle_implicits_Writers$$anon$15.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Writers$$anon$15;
/** @constructor */
function $h_Lupickle_implicits_Writers$$anon$15() {
}
$h_Lupickle_implicits_Writers$$anon$15.prototype = $p;
$p.cW = (function() {
  return this;
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.cT = (function() {
  return true;
});
$p.d0 = (function(out, v) {
  return $f_Lupickle_implicits_Writers$SimpleMapKeyWriter__write0__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.bcz = (function(v) {
  var x = $m_s_concurrent_duration_Duration$().add;
  if (((x === null) ? (v === null) : x.e(v))) {
    return "inf";
  } else {
    var x$3 = $m_s_concurrent_duration_Duration$().ade;
    if (((x$3 === null) ? (v === null) : x$3.e(v))) {
      return "-inf";
    } else if ((v === $m_s_concurrent_duration_Duration$().a1T)) {
      return "undef";
    } else {
      var $x_1 = v.aSV();
      var this$1_$_lo = $x_1.l;
      var this$1_$_hi = $x_1.h;
      return $m_RTLong$().kY(this$1_$_lo, this$1_$_hi);
    }
  }
});
$p.Qd = (function(v) {
  return this.bcz(v);
});
var $d_Lupickle_implicits_Writers$$anon$15 = new $TypeData().i($c_Lupickle_implicits_Writers$$anon$15, "upickle.implicits.Writers$$anon$15", ({
  PN: 1,
  B: 1,
  E: 1,
  bK: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Writers$$anon$16(inner$3, outer) {
  this.aL5 = null;
  this.aL5 = inner$3;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lupickle_implicits_Writers$$anon$16.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Writers$$anon$16;
/** @constructor */
function $h_Lupickle_implicits_Writers$$anon$16() {
}
$h_Lupickle_implicits_Writers$$anon$16.prototype = $p;
$p.cT = (function() {
  return false;
});
$p.cW = (function() {
  return this;
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aiE = (function(out, v) {
  var ctx = out.cZ($m_s_Option$().m2(v).aa(), (-1));
  matchResult1: {
    if (($m_s_None$() === v)) {
      break matchResult1;
    }
    if ((v instanceof $c_s_Some)) {
      var next = v.J;
      ctx.cU($f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this.aL5, ctx.d9(), next), (-1));
      break matchResult1;
    }
    throw new $c_s_MatchError(v);
  }
  return ctx.bV((-1));
});
$p.d0 = (function(out, v) {
  return this.aiE(out, v);
});
var $d_Lupickle_implicits_Writers$$anon$16 = new $TypeData().i($c_Lupickle_implicits_Writers$$anon$16, "upickle.implicits.Writers$$anon$16", ({
  PO: 1,
  B: 1,
  E: 1,
  cZ: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Writers$$anon$17(inner$4, outer) {
  this.aL6 = null;
  this.aL6 = inner$4;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lupickle_implicits_Writers$$anon$17.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Writers$$anon$17;
/** @constructor */
function $h_Lupickle_implicits_Writers$$anon$17() {
}
$h_Lupickle_implicits_Writers$$anon$17.prototype = $p;
$p.cT = (function() {
  return false;
});
$p.cW = (function() {
  return this;
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aiE = (function(out, v) {
  if (($m_s_None$() === v)) {
    return out.c8((-1));
  }
  if ((v instanceof $c_s_Some)) {
    var next = v.J;
    return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this.aL6, out, next);
  }
  throw new $c_s_MatchError(v);
});
$p.d0 = (function(out, v) {
  return this.aiE(out, v);
});
var $d_Lupickle_implicits_Writers$$anon$17 = new $TypeData().i($c_Lupickle_implicits_Writers$$anon$17, "upickle.implicits.Writers$$anon$17", ({
  PP: 1,
  B: 1,
  E: 1,
  cZ: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Writers$JavaWriter(outer, evidence$1) {
  this.aL8 = null;
  this.aeh = null;
  this.aL8 = evidence$1;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aeh = outer;
}
$p = $c_Lupickle_implicits_Writers$JavaWriter.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Writers$JavaWriter;
/** @constructor */
function $h_Lupickle_implicits_Writers$JavaWriter() {
}
$h_Lupickle_implicits_Writers$JavaWriter.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().eN(this, (-889275714), null);
});
$p.e = (function(x$0) {
  return ((this === x$0) || (((x$0 instanceof $c_Lupickle_implicits_Writers$JavaWriter) && (x$0.aeh === this.aeh)) || false));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 0;
});
$p.B = (function() {
  return "JavaWriter";
});
$p.A = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.DS = (function() {
  return this.aL8;
});
function $isArrayOf_Lupickle_implicits_Writers$JavaWriter(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.nu)));
}
var $d_Lupickle_implicits_Writers$JavaWriter = new $TypeData().i($c_Lupickle_implicits_Writers$JavaWriter, "upickle.implicits.Writers$JavaWriter", ({
  nu: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_raquo_airstream_core_Observer$$anon$1(outer) {
  this.aj9 = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aj9 = outer;
}
$p = $c_Lcom_raquo_airstream_core_Observer$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_raquo_airstream_core_Observer$$anon$1;
/** @constructor */
function $h_Lcom_raquo_airstream_core_Observer$$anon$1() {
}
$h_Lcom_raquo_airstream_core_Observer$$anon$1.prototype = $p;
$p.e5 = (function(x) {
  return true;
});
$p.e2 = (function(x, default$1) {
  this.aj9.yh(x);
});
$p.aM = (function(x) {
  return this.e5(x);
});
$p.aC = (function(x, default$1) {
  return this.e2(x, default$1);
});
var $d_Lcom_raquo_airstream_core_Observer$$anon$1 = new $TypeData().i($c_Lcom_raquo_airstream_core_Observer$$anon$1, "com.raquo.airstream.core.Observer$$anon$1", ({
  nT: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
function $f_Lcom_raquo_airstream_core_WritableObservable__$init$__V($thiz) {
  $thiz.ig($m_Lcom_raquo_ew_JsArray$().fu($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_airstream_core_Observer.r().C)([]))));
  $thiz.ih($m_Lcom_raquo_ew_JsArray$().fu($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_airstream_core_InternalObserver.r().C)([]))));
  $thiz.hs(false);
}
function $f_Lcom_raquo_airstream_core_WritableObservable__addObserver__Lcom_raquo_airstream_core_Observer__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription($thiz, observer, owner) {
  var this$2 = $m_Lcom_raquo_airstream_core_Transaction$onStart$();
  var f = (() => {
    $f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V($thiz);
    var subscription = $f_Lcom_raquo_airstream_core_WritableObservable__addExternalObserver__Lcom_raquo_airstream_core_Observer__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription($thiz, observer, owner);
    $thiz.ip(observer);
    $p_Lcom_raquo_airstream_core_WritableObservable__maybeStart__V($thiz);
    return subscription;
  });
  var when = (!$f_Lcom_raquo_airstream_core_BaseObservable__isStarted__Z($thiz));
  if ((this$2.ky || (!when))) {
    var $x_1 = f();
  } else {
    this$2.ky = true;
    try {
      var $x_1 = f();
    } finally {
      this$2.ky = false;
      $p_Lcom_raquo_airstream_core_Transaction$onStart$__resolve__V(this$2);
    }
  }
  return $x_1;
}
function $f_Lcom_raquo_airstream_core_WritableObservable__addExternalObserver__Lcom_raquo_airstream_core_Observer__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription($thiz, observer, owner) {
  var subscription = new $c_Lcom_raquo_airstream_ownership_Subscription(owner, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
    $f_Lcom_raquo_airstream_core_BaseObservable__removeExternalObserver__Lcom_raquo_airstream_core_Observer__V($thiz, observer);
  })));
  var this$ = $thiz.gk();
  this$.push(observer);
  return subscription;
}
function $f_Lcom_raquo_airstream_core_WritableObservable__addInternalObserver__Lcom_raquo_airstream_core_InternalObserver__Z__V($thiz, observer, shouldCallMaybeWillStart) {
  var this$3 = $m_Lcom_raquo_airstream_core_Transaction$onStart$();
  var f = (() => {
    if (((!$f_Lcom_raquo_airstream_core_BaseObservable__isStarted__Z($thiz)) && shouldCallMaybeWillStart)) {
      $f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V($thiz);
    }
    var this$ = $thiz.gl();
    this$.push(observer);
    $p_Lcom_raquo_airstream_core_WritableObservable__maybeStart__V($thiz);
  });
  var when = (!$f_Lcom_raquo_airstream_core_BaseObservable__isStarted__Z($thiz));
  if ((this$3.ky || (!when))) {
    f();
  } else {
    this$3.ky = true;
    try {
      f();
    } finally {
      this$3.ky = false;
      $p_Lcom_raquo_airstream_core_Transaction$onStart$__resolve__V(this$3);
    }
  }
}
function $f_Lcom_raquo_airstream_core_WritableObservable__removeInternalObserverNow__Lcom_raquo_airstream_core_InternalObserver__V($thiz, observer) {
  if ($m_Lcom_raquo_airstream_core_ObserverList$().aRx($thiz.gl(), observer)) {
    $p_Lcom_raquo_airstream_core_WritableObservable__maybeStop__V($thiz);
  }
}
function $f_Lcom_raquo_airstream_core_WritableObservable__removeExternalObserverNow__Lcom_raquo_airstream_core_Observer__V($thiz, observer) {
  if ($m_Lcom_raquo_airstream_core_ObserverList$().aRx($thiz.gk(), observer)) {
    $p_Lcom_raquo_airstream_core_WritableObservable__maybeStop__V($thiz);
  }
}
function $f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V($thiz) {
  if ((!$thiz.iA())) {
    $thiz.iu();
    $thiz.hs(true);
  }
}
function $p_Lcom_raquo_airstream_core_WritableObservable__maybeStart__V($thiz) {
  if (($f_Lcom_raquo_airstream_core_WritableObservable__numAllObservers__I($thiz) === 1)) {
    $thiz.ir();
  }
}
function $p_Lcom_raquo_airstream_core_WritableObservable__maybeStop__V($thiz) {
  if ((!$f_Lcom_raquo_airstream_core_BaseObservable__isStarted__Z($thiz))) {
    $thiz.is();
    $thiz.hs(false);
  }
}
function $f_Lcom_raquo_airstream_core_WritableObservable__numAllObservers__I($thiz) {
  var this$ = $thiz.gk();
  var $x_1 = this$.length;
  var this$$1 = $thiz.gl();
  return ((($x_1 | 0) + (this$$1.length | 0)) | 0);
}
/** @constructor */
function $c_Lcom_raquo_airstream_custom_CustomSource$$anon$1(outer) {
  this.ajh = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.ajh = outer;
}
$p = $c_Lcom_raquo_airstream_custom_CustomSource$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_raquo_airstream_custom_CustomSource$$anon$1;
/** @constructor */
function $h_Lcom_raquo_airstream_custom_CustomSource$$anon$1() {
}
$h_Lcom_raquo_airstream_custom_CustomSource$$anon$1.prototype = $p;
$p.e5 = (function(x) {
  return ((x !== null) || false);
});
$p.e2 = (function(x, default$1) {
  return ((x !== null) ? (new $c_Lcom_raquo_airstream_core_Transaction(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => {
    $f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this.ajh, x, _$1);
  }))), (void 0)) : default$1.i(x));
});
$p.aM = (function(x) {
  return this.e5(x);
});
$p.aC = (function(x, default$1) {
  return this.e2(x, default$1);
});
var $d_Lcom_raquo_airstream_custom_CustomSource$$anon$1 = new $TypeData().i($c_Lcom_raquo_airstream_custom_CustomSource$$anon$1, "com.raquo.airstream.custom.CustomSource$$anon$1", ({
  o6: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_raquo_airstream_eventbus_EventBus() {
  this.ajI = null;
  this.dn = null;
  this.k5 = null;
  this.ajI = (void 0);
  this.dn = new $c_Lcom_raquo_airstream_eventbus_WriteBus(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $f_Lcom_raquo_airstream_core_Named__displayName__T(this))), ".writer");
  this.k5 = this.dn.JP;
}
$p = $c_Lcom_raquo_airstream_eventbus_EventBus.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_eventbus_EventBus;
/** @constructor */
function $h_Lcom_raquo_airstream_eventbus_EventBus() {
}
$h_Lcom_raquo_airstream_eventbus_EventBus.prototype = $p;
$p.fx = (function() {
  return this.ajI;
});
$p.eU = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$p.m = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.mY = (function() {
  return this.k5;
});
$p.Ek = (function() {
  return this.dn;
});
$p.dM = (function() {
  return this.k5;
});
var $d_Lcom_raquo_airstream_eventbus_EventBus = new $TypeData().i($c_Lcom_raquo_airstream_eventbus_EventBus, "com.raquo.airstream.eventbus.EventBus", ({
  oc: 1,
  P: 1,
  al: 1,
  b7: 1,
  O: 1
}));
function $f_Lcom_raquo_airstream_state_Var__$init$__V($thiz) {
  $thiz.af2($m_Lcom_raquo_airstream_core_Observer$().b1V(new $c_Lcom_raquo_airstream_state_Var$$anon$1($thiz), ($m_Lcom_raquo_airstream_core_Observer$(), true)));
}
function $f_Lcom_raquo_airstream_state_Var__zoomLazy__F1__F2__Lcom_raquo_airstream_state_Var($thiz, in$1, out) {
  return new $c_Lcom_raquo_airstream_state_LazyDerivedVar($thiz, new $c_Lcom_raquo_airstream_state_LazyStrictSignal($thiz.P(), in$1, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $f_Lcom_raquo_airstream_core_Named__displayName__T($thiz))), ".zoomLazy.signal"), out, ".zoomLazy");
}
function $f_Lcom_raquo_airstream_state_Var__bimap__F1__F1__Lcom_raquo_airstream_state_Var($thiz, getThis, getParent) {
  return new $c_Lcom_raquo_airstream_state_LazyDerivedVar2($thiz, new $c_Lcom_raquo_airstream_state_LazyStrictSignal($thiz.P(), getThis, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $f_Lcom_raquo_airstream_core_Named__displayName__T($thiz))), ".bimap.signal"), new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((_$2, nextZoomedValueTry) => new $c_s_Some(nextZoomedValueTry.ua(getParent)))), ".bimap");
}
function $f_Lcom_raquo_airstream_state_Var__distinct__Lcom_raquo_airstream_state_Var($thiz) {
  return $f_Lcom_raquo_airstream_state_Var__distinctByFn__F2__Lcom_raquo_airstream_state_Var($thiz, new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((_$3, _$4) => $m_sr_BoxesRunTime$().Q(_$3, _$4))));
}
function $f_Lcom_raquo_airstream_state_Var__distinctByFn__F2__Lcom_raquo_airstream_state_Var($thiz, isSame) {
  return $f_Lcom_raquo_airstream_state_Var__distinctTry__F2__Lcom_raquo_airstream_state_Var($thiz, new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((x$1, x$2) => {
    if ((x$1 instanceof $c_s_util_Success)) {
      var prev = x$1.fM;
      if ((x$2 instanceof $c_s_util_Success)) {
        var next = x$2.fM;
        return (!(!isSame.R(prev, next)));
      }
    }
    return false;
  })));
}
function $f_Lcom_raquo_airstream_state_Var__distinctTry__F2__Lcom_raquo_airstream_state_Var($thiz, isSame) {
  return new $c_Lcom_raquo_airstream_state_LazyDerivedVar2($thiz, new $c_Lcom_raquo_airstream_state_LazyStrictSignal(new $c_Lcom_raquo_airstream_distinct_DistinctSignal($thiz.P(), isSame, false), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x) => x)), new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $f_Lcom_raquo_airstream_core_Named__displayName__T($thiz))), ".distinct*.signal"), new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((currValue, nextValue) => ((!(!isSame.R(currValue, nextValue))) ? $m_s_None$() : new $c_s_Some(nextValue)))), ".distinct*");
}
function $f_Lcom_raquo_airstream_state_Var__set__O__V($thiz, value) {
  var tryValue = new $c_s_util_Success(value);
  $thiz.jA().mT(tryValue);
}
function $f_Lcom_raquo_airstream_state_Var__update__F1__V($thiz, mod) {
  new $c_Lcom_raquo_airstream_core_Transaction(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((trx) => {
    matchResult12: {
      var x36 = $thiz.P().aq();
      if ((x36 instanceof $c_s_util_Success)) {
        var currentValue = x36.fM;
        try {
          var $x_1 = new $c_s_util_Success(mod.i(currentValue));
        } catch (e) {
          var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
          matchEnd8: {
            var $x_1;
            if ($m_s_util_control_NonFatal$().ew(e$2)) {
              var $x_1 = new $c_s_util_Failure(e$2);
              break matchEnd8;
            }
            throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
          }
        }
        $thiz.Eh($x_1, trx);
        break matchResult12;
      }
      if ((x36 instanceof $c_s_util_Failure)) {
        var err = x36.le;
        $m_Lcom_raquo_airstream_core_AirstreamError$().rc(new $c_Lcom_raquo_airstream_core_AirstreamError$VarError("Unable to update a failed Var. Consider Var#tryUpdate instead.", new $c_s_Some(err)));
        break matchResult12;
      }
      throw new $c_s_MatchError(x36);
    }
  })));
}
/** @constructor */
function $c_Lcom_raquo_airstream_state_Var$$anon$1(outer) {
  this.alE = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.alE = outer;
}
$p = $c_Lcom_raquo_airstream_state_Var$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_raquo_airstream_state_Var$$anon$1;
/** @constructor */
function $h_Lcom_raquo_airstream_state_Var$$anon$1() {
}
$h_Lcom_raquo_airstream_state_Var$$anon$1.prototype = $p;
$p.b3g = (function(x) {
  return true;
});
$p.aXG = (function(x, default$1) {
  new $c_Lcom_raquo_airstream_core_Transaction(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => {
    this.alE.Eh(x, _$1);
  })));
});
$p.aM = (function(x) {
  return this.b3g(x);
});
$p.aC = (function(x, default$1) {
  return this.aXG(x, default$1);
});
var $d_Lcom_raquo_airstream_state_Var$$anon$1 = new $TypeData().i($c_Lcom_raquo_airstream_state_Var$$anon$1, "com.raquo.airstream.state.Var$$anon$1", ({
  oK: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_raquo_laminar_DomApi$$anon$1(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_raquo_laminar_DomApi$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_raquo_laminar_DomApi$$anon$1;
/** @constructor */
function $h_Lcom_raquo_laminar_DomApi$$anon$1() {
}
$h_Lcom_raquo_laminar_DomApi$$anon$1.prototype = $p;
$p.aM = (function(x) {
  return (((typeof x) === "boolean") && true);
});
$p.aC = (function(x, default$1) {
  return (((typeof x) === "boolean") ? (!(!x)) : default$1.i(x));
});
var $d_Lcom_raquo_laminar_DomApi$$anon$1 = new $TypeData().i($c_Lcom_raquo_laminar_DomApi$$anon$1, "com.raquo.laminar.DomApi$$anon$1", ({
  p5: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_raquo_laminar_DomApi$$anon$2(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_raquo_laminar_DomApi$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_raquo_laminar_DomApi$$anon$2;
/** @constructor */
function $h_Lcom_raquo_laminar_DomApi$$anon$2() {
}
$h_Lcom_raquo_laminar_DomApi$$anon$2.prototype = $p;
$p.aM = (function(x) {
  return (((typeof x) === "string") || false);
});
$p.aC = (function(x, default$1) {
  return (((typeof x) === "string") ? x : default$1.i(x));
});
var $d_Lcom_raquo_laminar_DomApi$$anon$2 = new $TypeData().i($c_Lcom_raquo_laminar_DomApi$$anon$2, "com.raquo.laminar.DomApi$$anon$2", ({
  p6: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
function $f_Lcom_raquo_laminar_nodes_ReactiveElement__$init$__V($thiz) {
  $thiz.aMN(new $c_Lcom_raquo_airstream_ownership_TransferableSubscription(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
    $thiz.kq().aLK();
  })), new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
    $thiz.kq().aZx();
  }))));
  $thiz.af5((void 0));
  $thiz.af4($m_sci_Map$EmptyMap$());
}
function $f_Lcom_raquo_laminar_nodes_ReactiveElement__addEventListener__Lcom_raquo_laminar_modifiers_EventListener__Z__V($thiz, listener, unsafePrepend) {
  if (($thiz.P8() === (void 0))) {
    $thiz.af5($m_Lcom_raquo_ew_JsArray$().fu($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_modifiers_EventListener.r().C)([listener]))));
  } else if (unsafePrepend) {
    var x$1 = $thiz.P8();
    if ((x$1 === (void 0))) {
      var $x_1;
      throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "undefined.get");
    } else {
      var $x_1 = x$1;
    }
    $x_1.unshift(listener);
  } else {
    var x$2 = $thiz.P8();
    if ((x$2 === (void 0))) {
      var $x_2;
      throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "undefined.get");
    } else {
      var $x_2 = x$2;
    }
    $x_2.push(listener);
  }
}
function $f_Lcom_raquo_laminar_nodes_ReactiveElement__removeEventListener__I__V($thiz, index) {
  var x = $thiz.P8();
  if ((x !== (void 0))) {
    x.splice(index, 1);
  }
}
function $f_Lcom_raquo_laminar_nodes_ReactiveElement__indexOfEventListener__Lcom_raquo_laminar_modifiers_EventListener__I($thiz, listener) {
  var x = $thiz.P8();
  if ((x === (void 0))) {
    return (-1);
  } else {
    var found = false;
    var ix = 0;
    while (((!found) && (ix < (x.length | 0)))) {
      var x$1 = x[ix];
      if (((x$1 === null) ? (listener === null) : $dp_equals__O__Z(x$1, listener))) {
        found = true;
      } else {
        ix = ((1 + ix) | 0);
      }
    }
    return (found ? ix : (-1));
  }
}
function $f_Lcom_raquo_laminar_nodes_ReactiveElement__compositeValueItems__Lcom_raquo_laminar_keys_CompositeKey__Lcom_raquo_laminar_modifiers_Modifier__sci_List($thiz, prop, reason) {
  return $thiz.Wt().ay(prop, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $m_sci_Nil$()))).Ag(new $c_Lcom_raquo_laminar_nodes_ReactiveElement$$anon$1(reason));
}
function $f_Lcom_raquo_laminar_nodes_ReactiveElement__updateCompositeValue__Lcom_raquo_laminar_keys_CompositeKey__Lcom_raquo_laminar_modifiers_Modifier__sci_List__sci_List__V($thiz, key, reason, addItems, removeItems) {
  var keyItemsWithReason = $thiz.Wt().ay(key, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $m_sci_Nil$())));
  var f = ((item) => {
    var these = keyItemsWithReason;
    while ((!these.c())) {
      var x0 = these.t();
      var x = x0.g();
      if (((x === null) ? (item === null) : $dp_equals__O__Z(x, item))) {
        var x$3 = x0.h();
        if ((!((x$3 === null) ? (reason === null) : $dp_equals__O__Z(x$3, reason)))) {
          var $x_1 = true;
        } else {
          var $x_1 = (reason === null);
        }
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        return true;
      }
      these = these.v();
    }
    return false;
  });
  var itemsToAdd = $f_sc_SeqOps__distinct__O(addItems);
  var l = removeItems;
  block: {
    var result;
    while (true) {
      if (l.c()) {
        var result = $m_sci_Nil$();
        break;
      } else {
        var h = l.t();
        var t = l.v();
        if ((!(!f(h)))) {
          l = t;
          continue;
        }
        var start = l;
        var remaining = t;
        while (true) {
          if (remaining.c()) {
            var result = start;
            break block;
          } else {
            var x$1 = remaining.t();
            if ((!(!(!f(x$1))))) {
              remaining = remaining.v();
              continue;
            }
            var firstMiss = remaining;
            var newHead = new $c_sci_$colon$colon(start.t(), $m_sci_Nil$());
            var toProcess = start.v();
            var currentLast = newHead;
            while ((toProcess !== firstMiss)) {
              var newElem = new $c_sci_$colon$colon(toProcess.t(), $m_sci_Nil$());
              currentLast.U = newElem;
              currentLast = newElem;
              toProcess = toProcess.v();
            }
            var next = firstMiss.v();
            var nextToCopy = next;
            while ((!next.c())) {
              var head = next.t();
              if ((!(!(!f(head))))) {
                next = next.v();
              } else {
                while ((nextToCopy !== next)) {
                  var newElem$2 = new $c_sci_$colon$colon(nextToCopy.t(), $m_sci_Nil$());
                  currentLast.U = newElem$2;
                  currentLast = newElem$2;
                  nextToCopy = nextToCopy.v();
                }
                nextToCopy = next.v();
                next = next.v();
              }
            }
            if ((!nextToCopy.c())) {
              currentLast.U = nextToCopy;
            }
            var result = newHead;
            break block;
          }
        }
      }
    }
  }
  var this$1 = $thiz.Wt().ay(key, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $m_sci_Nil$())));
  var f$1 = ((t$1) => result.E(t$1.g()));
  var l$1 = this$1;
  block$2: {
    var result$1;
    while (true) {
      if (l$1.c()) {
        var result$1 = $m_sci_Nil$();
        break;
      } else {
        var h$1 = l$1.t();
        var t$2 = l$1.v();
        if ((!(!f$1(h$1)))) {
          l$1 = t$2;
          continue;
        }
        var start$1 = l$1;
        var remaining$1 = t$2;
        while (true) {
          if (remaining$1.c()) {
            var result$1 = start$1;
            break block$2;
          } else {
            var x$2 = remaining$1.t();
            if ((!(!(!f$1(x$2))))) {
              remaining$1 = remaining$1.v();
              continue;
            }
            var firstMiss$1 = remaining$1;
            var newHead$1 = new $c_sci_$colon$colon(start$1.t(), $m_sci_Nil$());
            var toProcess$1 = start$1.v();
            var currentLast$1 = newHead$1;
            while ((toProcess$1 !== firstMiss$1)) {
              var newElem$1 = new $c_sci_$colon$colon(toProcess$1.t(), $m_sci_Nil$());
              currentLast$1.U = newElem$1;
              currentLast$1 = newElem$1;
              toProcess$1 = toProcess$1.v();
            }
            var next$1 = firstMiss$1.v();
            var nextToCopy$1 = next$1;
            while ((!next$1.c())) {
              var head$1 = next$1.t();
              if ((!(!(!f$1(head$1))))) {
                next$1 = next$1.v();
              } else {
                while ((nextToCopy$1 !== next$1)) {
                  var newElem$2$1 = new $c_sci_$colon$colon(nextToCopy$1.t(), $m_sci_Nil$());
                  currentLast$1.U = newElem$2$1;
                  currentLast$1 = newElem$2$1;
                  nextToCopy$1 = nextToCopy$1.v();
                }
                nextToCopy$1 = next$1.v();
                next$1 = next$1.v();
              }
            }
            if ((!nextToCopy$1.c())) {
              currentLast$1.U = nextToCopy$1;
            }
            var result$1 = newHead$1;
            break block$2;
          }
        }
      }
    }
  }
  var f$2 = ((_$2) => new $c_T2(_$2, reason));
  if ((itemsToAdd === $m_sci_Nil$())) {
    var $x_2 = $m_sci_Nil$();
  } else {
    var x0$1 = itemsToAdd.t();
    var h$2 = new $c_sci_$colon$colon(f$2(x0$1), $m_sci_Nil$());
    var t$3 = h$2;
    var rest = itemsToAdd.v();
    while ((rest !== $m_sci_Nil$())) {
      var x0$2 = rest.t();
      var nx = new $c_sci_$colon$colon(f$2(x0$2), $m_sci_Nil$());
      t$3.U = nx;
      t$3 = nx;
      rest = rest.v();
    }
    var $x_2 = h$2;
  }
  var newItems = result$1.hK($x_2);
  var domValues = key.a6w.aNk(key.ars.i($thiz));
  var f$3 = ((elem) => result.E(elem));
  var l$2 = domValues;
  block$4: {
    var $x_4;
    while (true) {
      if (l$2.c()) {
        var $x_4 = $m_sci_Nil$();
        break;
      } else {
        var h$3 = l$2.t();
        var t$4 = l$2.v();
        if ((!(!f$3(h$3)))) {
          l$2 = t$4;
          continue;
        }
        var start$2 = l$2;
        var remaining$2 = t$4;
        while (true) {
          if (remaining$2.c()) {
            var $x_4 = start$2;
            break block$4;
          } else {
            var x$4 = remaining$2.t();
            if ((!(!(!f$3(x$4))))) {
              remaining$2 = remaining$2.v();
              continue;
            }
            var firstMiss$2 = remaining$2;
            var newHead$2 = new $c_sci_$colon$colon(start$2.t(), $m_sci_Nil$());
            var toProcess$2 = start$2.v();
            var currentLast$2 = newHead$2;
            while ((toProcess$2 !== firstMiss$2)) {
              var newElem$3 = new $c_sci_$colon$colon(toProcess$2.t(), $m_sci_Nil$());
              currentLast$2.U = newElem$3;
              currentLast$2 = newElem$3;
              toProcess$2 = toProcess$2.v();
            }
            var next$2 = firstMiss$2.v();
            var nextToCopy$2 = next$2;
            while ((!next$2.c())) {
              var head$2 = next$2.t();
              if ((!(!(!f$3(head$2))))) {
                next$2 = next$2.v();
              } else {
                while ((nextToCopy$2 !== next$2)) {
                  var newElem$2$2 = new $c_sci_$colon$colon(nextToCopy$2.t(), $m_sci_Nil$());
                  currentLast$2.U = newElem$2$2;
                  currentLast$2 = newElem$2$2;
                  nextToCopy$2 = nextToCopy$2.v();
                }
                nextToCopy$2 = next$2.v();
                next$2 = next$2.v();
              }
            }
            if ((!nextToCopy$2.c())) {
              currentLast$2.U = nextToCopy$2;
            }
            var $x_4 = newHead$2;
            break block$4;
          }
        }
      }
    }
  }
  var l$3 = itemsToAdd;
  block$6: {
    var $x_3;
    while (true) {
      if (l$3.c()) {
        var $x_3 = $m_sci_Nil$();
        break;
      } else {
        var h$4 = l$3.t();
        var t$5 = l$3.v();
        if ((!(!f(h$4)))) {
          l$3 = t$5;
          continue;
        }
        var start$3 = l$3;
        var remaining$3 = t$5;
        while (true) {
          if (remaining$3.c()) {
            var $x_3 = start$3;
            break block$6;
          } else {
            var x$5 = remaining$3.t();
            if ((!(!(!f(x$5))))) {
              remaining$3 = remaining$3.v();
              continue;
            }
            var firstMiss$3 = remaining$3;
            var newHead$3 = new $c_sci_$colon$colon(start$3.t(), $m_sci_Nil$());
            var toProcess$3 = start$3.v();
            var currentLast$3 = newHead$3;
            while ((toProcess$3 !== firstMiss$3)) {
              var newElem$4 = new $c_sci_$colon$colon(toProcess$3.t(), $m_sci_Nil$());
              currentLast$3.U = newElem$4;
              currentLast$3 = newElem$4;
              toProcess$3 = toProcess$3.v();
            }
            var next$3 = firstMiss$3.v();
            var nextToCopy$3 = next$3;
            while ((!next$3.c())) {
              var head$3 = next$3.t();
              if ((!(!(!f(head$3))))) {
                next$3 = next$3.v();
              } else {
                while ((nextToCopy$3 !== next$3)) {
                  var newElem$2$3 = new $c_sci_$colon$colon(nextToCopy$3.t(), $m_sci_Nil$());
                  currentLast$3.U = newElem$2$3;
                  currentLast$3 = newElem$2$3;
                  nextToCopy$3 = nextToCopy$3.v();
                }
                nextToCopy$3 = next$3.v();
                next$3 = next$3.v();
              }
            }
            if ((!nextToCopy$3.c())) {
              currentLast$3.U = nextToCopy$3;
            }
            var $x_3 = newHead$3;
            break block$6;
          }
        }
      }
    }
  }
  var nextDomValues = $x_4.hK($x_3);
  $thiz.af4($thiz.Wt().bN(key, newItems));
  key.art.R($thiz, key.a6w.aNI(nextDomValues));
}
function $f_Lcom_raquo_laminar_nodes_ReactiveElement__events__Lcom_raquo_laminar_keys_EventProcessor__Lcom_raquo_airstream_core_EventStream($thiz, prop) {
  var eventBus = new $c_Lcom_raquo_airstream_eventbus_EventBus();
  new $c_Lcom_raquo_laminar_modifiers_EventListener(prop, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((nextValue) => {
    eventBus.dn.bA(nextValue);
  }))).aeT($thiz, false);
  return eventBus.k5;
}
function $f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement($thiz, mods) {
  var this$2 = $m_Lcom_raquo_airstream_core_Transaction$onStart$();
  var f = (() => {
    mods.F(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((mod) => {
      mod.kL($thiz);
    })));
    return $thiz;
  });
  $m_Lcom_raquo_airstream_core_Transaction$onStart$();
  var when = true;
  if ((this$2.ky || (!when))) {
    var $x_1 = f();
  } else {
    this$2.ky = true;
    try {
      var $x_1 = f();
    } finally {
      this$2.ky = false;
      $p_Lcom_raquo_airstream_core_Transaction$onStart$__resolve__V(this$2);
    }
  }
  return $x_1;
}
function $f_Lcom_raquo_laminar_nodes_ReactiveElement__willSetParent__s_Option__V($thiz, maybeNextParent) {
  if ($p_Lcom_raquo_laminar_nodes_ReactiveElement__isUnmounting__s_Option__s_Option__Z($thiz, $thiz.P7(), maybeNextParent)) {
    $p_Lcom_raquo_laminar_nodes_ReactiveElement__setPilotSubscriptionOwner__s_Option__V($thiz, maybeNextParent);
  }
}
function $f_Lcom_raquo_laminar_nodes_ReactiveElement__setParent__s_Option__V($thiz, maybeNextParent) {
  var maybePrevParent = $thiz.P7();
  $thiz.aMM(maybeNextParent);
  if ((!$p_Lcom_raquo_laminar_nodes_ReactiveElement__isUnmounting__s_Option__s_Option__Z($thiz, maybePrevParent, maybeNextParent))) {
    $p_Lcom_raquo_laminar_nodes_ReactiveElement__setPilotSubscriptionOwner__s_Option__V($thiz, maybeNextParent);
  }
}
function $p_Lcom_raquo_laminar_nodes_ReactiveElement__isUnmounting__s_Option__s_Option__Z($thiz, maybePrevParent, maybeNextParent) {
  var isPrevParentActive = ((!maybePrevParent.c()) && (!maybePrevParent.d().kq().oJ.c()));
  var isNextParentActive = ((!maybeNextParent.c()) && (!maybeNextParent.d().kq().oJ.c()));
  return (isPrevParentActive && (!isNextParentActive));
}
function $p_Lcom_raquo_laminar_nodes_ReactiveElement__setPilotSubscriptionOwner__s_Option__V($thiz, maybeNextParent) {
  $f_Lcom_raquo_laminar_nodes_ReactiveElement__unsafeSetPilotSubscriptionOwner__s_Option__V($thiz, (maybeNextParent.c() ? $m_s_None$() : new $c_s_Some(maybeNextParent.d().kq())));
}
function $f_Lcom_raquo_laminar_nodes_ReactiveElement__unsafeSetPilotSubscriptionOwner__s_Option__V($thiz, maybeNextOwner) {
  if (maybeNextOwner.c()) {
    $thiz.af6().aYn();
  } else {
    var x0 = maybeNextOwner.d();
    $thiz.af6().b8H(x0);
  }
}
/** @constructor */
function $c_Lcom_raquo_laminar_nodes_ReactiveElement$$anon$1(reason$5) {
  this.a6H = null;
  this.a6H = reason$5;
}
$p = $c_Lcom_raquo_laminar_nodes_ReactiveElement$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_raquo_laminar_nodes_ReactiveElement$$anon$1;
/** @constructor */
function $h_Lcom_raquo_laminar_nodes_ReactiveElement$$anon$1() {
}
$h_Lcom_raquo_laminar_nodes_ReactiveElement$$anon$1.prototype = $p;
$p.bu = (function(x) {
  if ((x !== null)) {
    x.g();
    var r = x.h();
    var x$3 = this.a6H;
    if (((r === null) ? (x$3 === null) : (r === x$3))) {
      return true;
    }
  }
  return false;
});
$p.bt = (function(x, default$1) {
  if ((x !== null)) {
    var item = x.g();
    var r = x.h();
    var x$3 = this.a6H;
    if (((r === null) ? (x$3 === null) : (r === x$3))) {
      return item;
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.bu(x);
});
$p.aC = (function(x, default$1) {
  return this.bt(x, default$1);
});
var $d_Lcom_raquo_laminar_nodes_ReactiveElement$$anon$1 = new $TypeData().i($c_Lcom_raquo_laminar_nodes_ReactiveElement$$anon$1, "com.raquo.laminar.nodes.ReactiveElement$$anon$1", ({
  qn: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lfastparse_Implicits$Sequencer$() {
  this.a6R = null;
  this.asL = null;
  this.asM = null;
  this.asN = false;
  $n_Lfastparse_Implicits$Sequencer$ = this;
  $f_Lfastparse_SequencerGen__$init$__V(this);
}
$p = $c_Lfastparse_Implicits$Sequencer$.prototype = new $h_O();
$p.constructor = $c_Lfastparse_Implicits$Sequencer$;
/** @constructor */
function $h_Lfastparse_Implicits$Sequencer$() {
}
$h_Lfastparse_Implicits$Sequencer$.prototype = $p;
$p.qP = (function() {
  if ((!this.asN)) {
    this.asM = new $c_Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$(this);
    this.asN = true;
  }
  return this.asM;
});
var $d_Lfastparse_Implicits$Sequencer$ = new $TypeData().i($c_Lfastparse_Implicits$Sequencer$, "fastparse.Implicits$Sequencer$", ({
  r0: 1,
  r3: 1,
  rc: 1,
  qV: 1,
  qT: 1
}));
var $n_Lfastparse_Implicits$Sequencer$;
function $m_Lfastparse_Implicits$Sequencer$() {
  if ((!$n_Lfastparse_Implicits$Sequencer$)) {
    $n_Lfastparse_Implicits$Sequencer$ = new $c_Lfastparse_Implicits$Sequencer$();
  }
  return $n_Lfastparse_Implicits$Sequencer$;
}
/** @constructor */
function $c_Lfastparse_Parsed$Success(value, index) {
  this.EH = null;
  this.JZ = 0;
  this.EH = value;
  this.JZ = index;
  $ct_Lfastparse_Parsed__Z__(this, true);
}
$p = $c_Lfastparse_Parsed$Success.prototype = new $h_Lfastparse_Parsed();
$p.constructor = $c_Lfastparse_Parsed$Success;
/** @constructor */
function $h_Lfastparse_Parsed$Success() {
}
$h_Lfastparse_Parsed$Success.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, $f_T__hashCode__I("Success"));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.EH));
  acc = $m_sr_Statics$().k(acc, this.JZ);
  return $m_sr_Statics$().Z(acc, 2);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lfastparse_Parsed$Success) && ((this.JZ === x$0.JZ) && $m_sr_BoxesRunTime$().Q(this.EH, x$0.EH))));
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "Success";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.EH;
  }
  if ((n === 1)) {
    return this.JZ;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  if ((n === 1)) {
    return "index";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.m = (function() {
  return (((("Parsed.Success(" + this.EH) + ", ") + this.JZ) + ")");
});
function $isArrayOf_Lfastparse_Parsed$Success(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eE)));
}
var $d_Lfastparse_Parsed$Success = new $TypeData().i($c_Lfastparse_Parsed$Success, "fastparse.Parsed$Success", ({
  eE: 1,
  eC: 1,
  b: 1,
  c: 1,
  a: 1
}));
function $ct_Ljava_io_FilterOutputStream__Ljava_io_OutputStream__($thiz, out) {
  return $thiz;
}
/** @constructor */
function $c_Ljava_io_FilterOutputStream() {
}
$p = $c_Ljava_io_FilterOutputStream.prototype = new $h_Ljava_io_OutputStream();
$p.constructor = $c_Ljava_io_FilterOutputStream;
/** @constructor */
function $h_Ljava_io_FilterOutputStream() {
}
$h_Ljava_io_FilterOutputStream.prototype = $p;
function $ct_Ljava_io_Writer__($thiz) {
  return $thiz;
}
/** @constructor */
function $c_Ljava_io_Writer() {
}
$p = $c_Ljava_io_Writer.prototype = new $h_O();
$p.constructor = $c_Ljava_io_Writer;
/** @constructor */
function $h_Ljava_io_Writer() {
}
$h_Ljava_io_Writer.prototype = $p;
class $c_jl_ArithmeticException extends $c_jl_RuntimeException {
  constructor(s) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true);
  }
}
function $isArrayOf_jl_ArithmeticException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eI)));
}
var $d_jl_ArithmeticException = new $TypeData().i($c_jl_ArithmeticException, "java.lang.ArithmeticException", ({
  eI: 1,
  R: 1,
  G: 1,
  y: 1,
  a: 1
}));
function $f_jl_Byte__equals__O__Z($thiz, that) {
  return Object.is($thiz, that);
}
function $f_jl_Byte__hashCode__I($thiz) {
  return $thiz;
}
function $f_jl_Byte__toString__T($thiz) {
  return ("" + $thiz);
}
function $f_jl_Byte__compareTo__O__I($thiz, o) {
  return (($thiz - o) | 0);
}
function $isArrayOf_jl_Byte(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eK)));
}
var $d_jl_Byte = new $TypeData().i(0, "java.lang.Byte", ({
  eK: 1,
  aP: 1,
  a: 1,
  Q: 1,
  aY: 1
}), ((x) => $isByte(x)));
class $c_jl_ClassCastException extends $c_jl_RuntimeException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
}
function $isArrayOf_jl_ClassCastException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eM)));
}
var $d_jl_ClassCastException = new $TypeData().i($c_jl_ClassCastException, "java.lang.ClassCastException", ({
  eM: 1,
  R: 1,
  G: 1,
  y: 1,
  a: 1
}));
function $ct_jl_IllegalArgumentException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
function $ct_jl_IllegalArgumentException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz;
}
class $c_jl_IllegalArgumentException extends $c_jl_RuntimeException {
}
var $d_jl_IllegalArgumentException = new $TypeData().i($c_jl_IllegalArgumentException, "java.lang.IllegalArgumentException", ({
  aE: 1,
  R: 1,
  G: 1,
  y: 1,
  a: 1
}));
function $ct_jl_IllegalStateException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
function $ct_jl_IllegalStateException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz;
}
class $c_jl_IllegalStateException extends $c_jl_RuntimeException {
}
var $d_jl_IllegalStateException = new $TypeData().i($c_jl_IllegalStateException, "java.lang.IllegalStateException", ({
  eP: 1,
  R: 1,
  G: 1,
  y: 1,
  a: 1
}));
function $ct_jl_IndexOutOfBoundsException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
function $ct_jl_IndexOutOfBoundsException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz;
}
class $c_jl_IndexOutOfBoundsException extends $c_jl_RuntimeException {
}
var $d_jl_IndexOutOfBoundsException = new $TypeData().i($c_jl_IndexOutOfBoundsException, "java.lang.IndexOutOfBoundsException", ({
  eQ: 1,
  R: 1,
  G: 1,
  y: 1,
  a: 1
}));
/** @constructor */
function $c_jl_JSConsoleBasedPrintStream$DummyOutputStream() {
}
$p = $c_jl_JSConsoleBasedPrintStream$DummyOutputStream.prototype = new $h_Ljava_io_OutputStream();
$p.constructor = $c_jl_JSConsoleBasedPrintStream$DummyOutputStream;
/** @constructor */
function $h_jl_JSConsoleBasedPrintStream$DummyOutputStream() {
}
$h_jl_JSConsoleBasedPrintStream$DummyOutputStream.prototype = $p;
var $d_jl_JSConsoleBasedPrintStream$DummyOutputStream = new $TypeData().i($c_jl_JSConsoleBasedPrintStream$DummyOutputStream, "java.lang.JSConsoleBasedPrintStream$DummyOutputStream", ({
  s5: 1,
  eH: 1,
  ci: 1,
  ck: 1,
  cj: 1
}));
function $ct_jl_NullPointerException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
function $ct_jl_NullPointerException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz;
}
class $c_jl_NullPointerException extends $c_jl_RuntimeException {
}
var $d_jl_NullPointerException = new $TypeData().i($c_jl_NullPointerException, "java.lang.NullPointerException", ({
  sa: 1,
  R: 1,
  G: 1,
  y: 1,
  a: 1
}));
function $isArrayOf_jl_SecurityException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.sb)));
}
function $f_jl_Short__equals__O__Z($thiz, that) {
  return Object.is($thiz, that);
}
function $f_jl_Short__hashCode__I($thiz) {
  return $thiz;
}
function $f_jl_Short__toString__T($thiz) {
  return ("" + $thiz);
}
function $f_jl_Short__compareTo__O__I($thiz, o) {
  return (($thiz - o) | 0);
}
function $isArrayOf_jl_Short(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eV)));
}
var $d_jl_Short = new $TypeData().i(0, "java.lang.Short", ({
  eV: 1,
  aP: 1,
  a: 1,
  Q: 1,
  aY: 1
}), ((x) => $isShort(x)));
class $c_jl_StackOverflowError extends $c_jl_VirtualMachineError {
  constructor(s) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true);
  }
}
var $d_jl_StackOverflowError = new $TypeData().i($c_jl_StackOverflowError, "java.lang.StackOverflowError", ({
  sc: 1,
  eZ: 1,
  bO: 1,
  y: 1,
  a: 1
}));
function $ct_jl_UnsupportedOperationException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz;
}
function $ct_jl_UnsupportedOperationException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
class $c_jl_UnsupportedOperationException extends $c_jl_RuntimeException {
}
var $d_jl_UnsupportedOperationException = new $TypeData().i($c_jl_UnsupportedOperationException, "java.lang.UnsupportedOperationException", ({
  eY: 1,
  R: 1,
  G: 1,
  y: 1,
  a: 1
}));
class $c_Ljava_nio_BufferOverflowException extends $c_jl_RuntimeException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
}
function $isArrayOf_Ljava_nio_BufferOverflowException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.f4)));
}
var $d_Ljava_nio_BufferOverflowException = new $TypeData().i($c_Ljava_nio_BufferOverflowException, "java.nio.BufferOverflowException", ({
  f4: 1,
  R: 1,
  G: 1,
  y: 1,
  a: 1
}));
class $c_Ljava_nio_BufferUnderflowException extends $c_jl_RuntimeException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
}
function $isArrayOf_Ljava_nio_BufferUnderflowException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.f5)));
}
var $d_Ljava_nio_BufferUnderflowException = new $TypeData().i($c_Ljava_nio_BufferUnderflowException, "java.nio.BufferUnderflowException", ({
  f5: 1,
  R: 1,
  G: 1,
  y: 1,
  a: 1
}));
class $c_Ljava_nio_charset_CharacterCodingException extends $c_Ljava_io_IOException {
}
/** @constructor */
function $c_ju_AbstractSet() {
}
$p = $c_ju_AbstractSet.prototype = new $h_ju_AbstractCollection();
$p.constructor = $c_ju_AbstractSet;
/** @constructor */
function $h_ju_AbstractSet() {
}
$h_ju_AbstractSet.prototype = $p;
$p.e = (function(that) {
  return ((that === this) || ($is_ju_Collection(that) && ((that.aa() === this.aa()) && this.aZ2(that))));
});
$p.x = (function() {
  var _\uff3fself = this.r4();
  var result = 0;
  while (_\uff3fself.p()) {
    var t = result;
    var u = _\uff3fself.q();
    var t$1 = (t | 0);
    result = (($dp_hashCode__I(u) + t$1) | 0);
  }
  return (result | 0);
});
function $ct_ju_Collections$UnmodifiableCollection__ju_Collection__($thiz, inner) {
  $thiz.B7 = inner;
  return $thiz;
}
/** @constructor */
function $c_ju_Collections$UnmodifiableCollection() {
  this.B7 = null;
}
$p = $c_ju_Collections$UnmodifiableCollection.prototype = new $h_O();
$p.constructor = $c_ju_Collections$UnmodifiableCollection;
/** @constructor */
function $h_ju_Collections$UnmodifiableCollection() {
}
$h_ju_Collections$UnmodifiableCollection.prototype = $p;
$p.aa = (function() {
  return this.B7.aa();
});
$p.m = (function() {
  return this.B7.m();
});
$p.r4 = (function() {
  return new $c_ju_Collections$UnmodifiableIterator(this.B7.r4());
});
class $c_ju_ConcurrentModificationException extends $c_jl_RuntimeException {
  constructor(s) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true);
  }
}
var $d_ju_ConcurrentModificationException = new $TypeData().i($c_ju_ConcurrentModificationException, "java.util.ConcurrentModificationException", ({
  t7: 1,
  R: 1,
  G: 1,
  y: 1,
  a: 1
}));
function $p_ju_HashMap__getOrDefaultImpl__O__O__O($thiz, key, defaultValue) {
  if ((key === null)) {
    var hash = 0;
  } else {
    var originalHash = $dp_hashCode__I(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  }
  var node = $thiz.a3Y(key, hash, (hash & (($thiz.nN.a.length - 1) | 0)));
  return ((node === null) ? defaultValue : ($thiz.aQt(node), node.nO));
}
function $p_ju_HashMap__growTable__V($thiz) {
  var oldTable = $thiz.nN;
  var oldlen = oldTable.a.length;
  var newlen = (oldlen << 1);
  var newTable = new ($d_ju_HashMap$Node.r().C)(newlen);
  $thiz.nN = newTable;
  $thiz.Zt = $doubleToInt((newlen * $thiz.Zs));
  var i = 0;
  while ((i < oldlen)) {
    var lastLow = null;
    var lastHigh = null;
    var node = oldTable.a[i];
    while ((node !== null)) {
      if (((node.B9 & oldlen) === 0)) {
        node.ET = lastLow;
        if ((lastLow === null)) {
          newTable.a[i] = node;
        } else {
          lastLow.rm = node;
        }
        lastLow = node;
      } else {
        node.ET = lastHigh;
        if ((lastHigh === null)) {
          newTable.a[((oldlen + i) | 0)] = node;
        } else {
          lastHigh.rm = node;
        }
        lastHigh = node;
      }
      node = node.rm;
    }
    if ((lastLow !== null)) {
      lastLow.rm = null;
    }
    if ((lastHigh !== null)) {
      lastHigh.rm = null;
    }
    i = ((1 + i) | 0);
  }
}
function $ct_ju_HashMap__I__F__($thiz, initialCapacity, loadFactor) {
  $thiz.Zs = loadFactor;
  if ((initialCapacity < 0)) {
    $m_jl_BoundsChecks$().agF(initialCapacity);
  }
  if ((loadFactor <= 0.0)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "loadFactor <= 0.0");
  }
  var a = ((initialCapacity - 1) | 0);
  var i = ((a > 4) ? a : 4);
  var a$1 = ((((-2147483648) >> Math.clz32(i)) & i) << 1);
  $thiz.nN = new ($d_ju_HashMap$Node.r().C)(((a$1 < 1073741824) ? a$1 : 1073741824));
  $thiz.Zt = $doubleToInt(($thiz.nN.a.length * $thiz.Zs));
  $thiz.yI = 0;
  return $thiz;
}
/** @constructor */
function $c_ju_HashMap() {
  this.Zs = 0.0;
  this.nN = null;
  this.Zt = 0;
  this.yI = 0;
}
$p = $c_ju_HashMap.prototype = new $h_ju_AbstractMap();
$p.constructor = $c_ju_HashMap;
/** @constructor */
function $h_ju_HashMap() {
}
$h_ju_HashMap.prototype = $p;
$p.aa = (function() {
  return this.yI;
});
$p.agb = (function(key) {
  return $p_ju_HashMap__getOrDefaultImpl__O__O__O(this, key, null);
});
$p.aZ3 = (function(key) {
  if ((key === null)) {
    var hash = 0;
  } else {
    var originalHash = $dp_hashCode__I(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  }
  return (this.a3Y(key, hash, (hash & ((this.nN.a.length - 1) | 0))) !== null);
});
$p.aRf = (function(key, value) {
  if ((key === null)) {
    var $x_1 = 0;
  } else {
    var originalHash = $dp_hashCode__I(key);
    var $x_1 = (originalHash ^ ((originalHash >>> 16) | 0));
  }
  return this.aPz(key, value, $x_1, false);
});
$p.b7p = (function(key) {
  var node = this.b3N(key);
  return ((node === null) ? null : node.nO);
});
$p.Ph = (function() {
  return new $c_ju_HashMap$EntrySet(this);
});
$p.a3Y = (function(key, hash, idx) {
  var node = this.nN.a[idx];
  while (true) {
    if ((node === null)) {
      return null;
    } else {
      if ((hash === node.B9)) {
        var b = node.rl;
        var $x_1 = ((key === null) ? (b === null) : $dp_equals__O__Z(key, b));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        return node;
      } else if ((hash < node.B9)) {
        return null;
      } else {
        node = node.rm;
      }
    }
  }
});
$p.aPz = (function(key, value, hash, ifAbsent) {
  var newContentSize = ((1 + this.yI) | 0);
  if ((newContentSize >= this.Zt)) {
    $p_ju_HashMap__growTable__V(this);
  }
  var idx = (hash & ((this.nN.a.length - 1) | 0));
  var x1 = this.nN.a[idx];
  if ((x1 === null)) {
    var newNode = new $c_ju_LinkedHashMap$Node(key, hash, value, null, null, null, null);
    this.nN.a[idx] = newNode;
    var newNode$3 = newNode;
  } else {
    var prev = null;
    var n = x1;
    while (((n !== null) && (n.B9 <= hash))) {
      if ((n.B9 === hash)) {
        var b = n.rl;
        var $x_1 = ((key === null) ? (b === null) : $dp_equals__O__Z(key, b));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        this.aQt(n);
        var old = n.nO;
        if (((!ifAbsent) || (old === null))) {
          n.nO = value;
        }
        return old;
      }
      prev = n;
      n = n.rm;
    }
    var newNode$2 = new $c_ju_LinkedHashMap$Node(key, hash, value, prev, n, null, null);
    if ((prev === null)) {
      this.nN.a[idx] = newNode$2;
    } else {
      prev.rm = newNode$2;
    }
    if ((n !== null)) {
      n.ET = newNode$2;
    }
    var newNode$3 = newNode$2;
  }
  this.yI = newContentSize;
  this.b55(newNode$3);
  return null;
});
$p.b3N = (function(key) {
  if ((key === null)) {
    var hash = 0;
  } else {
    var originalHash = $dp_hashCode__I(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  }
  var idx = (hash & ((this.nN.a.length - 1) | 0));
  var node = this.a3Y(key, hash, idx);
  if ((node !== null)) {
    this.b3O(node, idx);
  }
  return node;
});
$p.b3O = (function(node, idx) {
  var previous = node.ET;
  var next = node.rm;
  if ((previous === null)) {
    this.nN.a[idx] = next;
  } else {
    previous.rm = next;
  }
  if ((next !== null)) {
    next.ET = previous;
  }
  this.yI = ((this.yI - 1) | 0);
  this.b56(node);
});
function $ct_ju_NoSuchElementException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
function $ct_ju_NoSuchElementException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz;
}
class $c_ju_NoSuchElementException extends $c_jl_RuntimeException {
}
var $d_ju_NoSuchElementException = new $TypeData().i($c_ju_NoSuchElementException, "java.util.NoSuchElementException", ({
  cp: 1,
  R: 1,
  G: 1,
  y: 1,
  a: 1
}));
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$1() {
  this.up = null;
  this.k6 = 0;
  $ct_jl_Enum__T__I__(this, "NANOSECONDS", 0);
}
$p = $c_ju_concurrent_TimeUnit$$anon$1.prototype = new $h_ju_concurrent_TimeUnit();
$p.constructor = $c_ju_concurrent_TimeUnit$$anon$1;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$1() {
}
$h_ju_concurrent_TimeUnit$$anon$1.prototype = $p;
$p.IK = (function(a_$_lo, a_$_hi, u) {
  return u.rf(a_$_lo, a_$_hi);
});
$p.rf = (function(a_$_lo, a_$_hi) {
  return $bL(a_$_lo, a_$_hi);
});
$p.Jx = (function(a_$_lo, a_$_hi) {
  var sign = (a_$_hi >> 31);
  var xlo = (a_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((a_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var quotHi = (((rhi >>> 0) / 1000) | 0);
  var k = ((rhi - Math.imul(1000, quotHi)) | 0);
  var quotLo = ((0.0010000000000000005 * ((4.294967296E9 * k) + (rlo >>> 0.0))) | 0.0);
  if ((a_$_hi < 0)) {
    var lo = ((-quotLo) | 0);
    var hi = ((((-quotHi) | 0) - ((lo !== 0) | 0)) | 0);
    return $bL(lo, hi);
  } else {
    return $bL(quotLo, quotHi);
  }
});
$p.Jy = (function(a_$_lo, a_$_hi) {
  var sign = (a_$_hi >> 31);
  var xlo = (a_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((a_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
  var x = (1.0000000000000016E-6 * aHat);
  var lo = (x | 0.0);
  var hi = ((2.3283064365386963E-10 * x) | 0.0);
  var rHat = ((rlo - Math.imul(1000000, lo)) | 0);
  if ((rHat < 0)) {
    var lo$1 = ((lo - 1) | 0);
    var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
    var absR_$_lo = lo$1;
    var absR_$_hi = hi$1;
  } else {
    var absR_$_lo = lo;
    var absR_$_hi = hi;
  }
  if ((a_$_hi < 0)) {
    var lo$2 = ((-absR_$_lo) | 0);
    var hi$2 = ((((-absR_$_hi) | 0) - ((lo$2 !== 0) | 0)) | 0);
    return $bL(lo$2, hi$2);
  } else {
    return $bL(absR_$_lo, absR_$_hi);
  }
});
$p.JA = (function(a_$_lo, a_$_hi) {
  var sign = (a_$_hi >> 31);
  var xlo = (a_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((a_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
  var x = (1.0000000000000017E-9 * aHat);
  var lo = (x | 0.0);
  var hi = ((2.3283064365386963E-10 * x) | 0.0);
  var rHat = ((rlo - Math.imul(1000000000, lo)) | 0);
  if ((rHat < 0)) {
    var lo$1 = ((lo - 1) | 0);
    var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
    var absR_$_lo = lo$1;
    var absR_$_hi = hi$1;
  } else {
    var absR_$_lo = lo;
    var absR_$_hi = hi;
  }
  if ((a_$_hi < 0)) {
    var lo$2 = ((-absR_$_lo) | 0);
    var hi$2 = ((((-absR_$_hi) | 0) - ((lo$2 !== 0) | 0)) | 0);
    return $bL(lo$2, hi$2);
  } else {
    return $bL(absR_$_lo, absR_$_hi);
  }
});
$p.Jz = (function(a_$_lo, a_$_hi) {
  var sign = (a_$_hi >> 31);
  var xlo = (a_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((a_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
  var x = (1.6666666666666693E-11 * aHat);
  var lo = (x | 0.0);
  var hi = ((2.3283064365386963E-10 * x) | 0.0);
  var b0 = (65535 & lo);
  var b1 = ((lo >>> 16) | 0);
  var a0b0 = Math.imul(22528, b0);
  var a1b0 = Math.imul(63559, b0);
  var a0b1 = Math.imul(22528, b1);
  var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((((((Math.imul((-129542144), hi) + Math.imul(13, lo)) | 0) + Math.imul(63559, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((rlo - lo$1) | 0);
  var hi$2 = ((((rhi - hi$1) | 0) - (((lo$2 >>> 0) > (rlo >>> 0)) | 0)) | 0);
  if ((hi$2 < 0)) {
    var lo$3 = ((lo - 1) | 0);
    var hi$3 = ((((hi - 1) | 0) + ((lo$3 !== (-1)) | 0)) | 0);
    var absR_$_lo = lo$3;
    var absR_$_hi = hi$3;
  } else {
    var absR_$_lo = lo;
    var absR_$_hi = hi;
  }
  if ((a_$_hi < 0)) {
    var lo$4 = ((-absR_$_lo) | 0);
    var hi$4 = ((((-absR_$_hi) | 0) - ((lo$4 !== 0) | 0)) | 0);
    return $bL(lo$4, hi$4);
  } else {
    return $bL(absR_$_lo, absR_$_hi);
  }
});
$p.Jw = (function(a_$_lo, a_$_hi) {
  var sign = (a_$_hi >> 31);
  var xlo = (a_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((a_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
  var x = (2.777777777777782E-13 * aHat);
  var lo = (x | 0.0);
  var hi = ((2.3283064365386963E-10 * x) | 0.0);
  var b0 = (65535 & lo);
  var b1 = ((lo >>> 16) | 0);
  var a0b0 = Math.imul(40960, b0);
  var a1b0 = Math.imul(12472, b0);
  var a0b1 = Math.imul(40960, b1);
  var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((((((Math.imul(817405952, hi) + Math.imul(838, lo)) | 0) + Math.imul(12472, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((rlo - lo$1) | 0);
  var hi$2 = ((((rhi - hi$1) | 0) - (((lo$2 >>> 0) > (rlo >>> 0)) | 0)) | 0);
  if ((hi$2 < 0)) {
    var lo$3 = ((lo - 1) | 0);
    var hi$3 = ((((hi - 1) | 0) + ((lo$3 !== (-1)) | 0)) | 0);
    var absR_$_lo = lo$3;
    var absR_$_hi = hi$3;
  } else {
    var absR_$_lo = lo;
    var absR_$_hi = hi;
  }
  if ((a_$_hi < 0)) {
    var lo$4 = ((-absR_$_lo) | 0);
    var hi$4 = ((((-absR_$_hi) | 0) - ((lo$4 !== 0) | 0)) | 0);
    return $bL(lo$4, hi$4);
  } else {
    return $bL(absR_$_lo, absR_$_hi);
  }
});
$p.Jv = (function(a_$_lo, a_$_hi) {
  var sign = (a_$_hi >> 31);
  var xlo = (a_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((a_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
  var x = (1.1574074074074086E-14 * aHat);
  var lo = (x | 0.0);
  var hi = ((2.3283064365386963E-10 * x) | 0.0);
  var b0 = (65535 & lo);
  var b1 = ((lo >>> 16) | 0);
  var a1b0 = Math.imul(37199, b0);
  var lo$1 = (a1b0 << 16);
  var hi$1 = ((((((Math.imul((-1857093632), hi) + Math.imul(20116, lo)) | 0) + Math.imul(37199, b1)) | 0) + ((a1b0 >>> 16) | 0)) | 0);
  var lo$2 = ((rlo - lo$1) | 0);
  var hi$2 = ((((rhi - hi$1) | 0) - (((lo$2 >>> 0) > (rlo >>> 0)) | 0)) | 0);
  if ((hi$2 < 0)) {
    var lo$3 = ((lo - 1) | 0);
    var hi$3 = ((((hi - 1) | 0) + ((lo$3 !== (-1)) | 0)) | 0);
    var absR_$_lo = lo$3;
    var absR_$_hi = hi$3;
  } else {
    var absR_$_lo = lo;
    var absR_$_hi = hi;
  }
  if ((a_$_hi < 0)) {
    var lo$4 = ((-absR_$_lo) | 0);
    var hi$4 = ((((-absR_$_hi) | 0) - ((lo$4 !== 0) | 0)) | 0);
    return $bL(lo$4, hi$4);
  } else {
    return $bL(absR_$_lo, absR_$_hi);
  }
});
var $d_ju_concurrent_TimeUnit$$anon$1 = new $TypeData().i($c_ju_concurrent_TimeUnit$$anon$1, "java.util.concurrent.TimeUnit$$anon$1", ({
  tA: 1,
  bm: 1,
  bf: 1,
  Q: 1,
  a: 1
}));
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$2() {
  this.up = null;
  this.k6 = 0;
  $ct_jl_Enum__T__I__(this, "MICROSECONDS", 1);
}
$p = $c_ju_concurrent_TimeUnit$$anon$2.prototype = new $h_ju_concurrent_TimeUnit();
$p.constructor = $c_ju_concurrent_TimeUnit$$anon$2;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$2() {
}
$h_ju_concurrent_TimeUnit$$anon$2.prototype = $p;
$p.IK = (function(a_$_lo, a_$_hi, u) {
  return u.Jx(a_$_lo, a_$_hi);
});
$p.rf = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().kt(a_$_lo, a_$_hi, 1000, 0, (-1511828489), 2147483);
});
$p.Jx = (function(a_$_lo, a_$_hi) {
  return $bL(a_$_lo, a_$_hi);
});
$p.Jy = (function(a_$_lo, a_$_hi) {
  var sign = (a_$_hi >> 31);
  var xlo = (a_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((a_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var quotHi = (((rhi >>> 0) / 1000) | 0);
  var k = ((rhi - Math.imul(1000, quotHi)) | 0);
  var quotLo = ((0.0010000000000000005 * ((4.294967296E9 * k) + (rlo >>> 0.0))) | 0.0);
  if ((a_$_hi < 0)) {
    var lo = ((-quotLo) | 0);
    var hi = ((((-quotHi) | 0) - ((lo !== 0) | 0)) | 0);
    return $bL(lo, hi);
  } else {
    return $bL(quotLo, quotHi);
  }
});
$p.JA = (function(a_$_lo, a_$_hi) {
  var sign = (a_$_hi >> 31);
  var xlo = (a_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((a_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
  var x = (1.0000000000000016E-6 * aHat);
  var lo = (x | 0.0);
  var hi = ((2.3283064365386963E-10 * x) | 0.0);
  var rHat = ((rlo - Math.imul(1000000, lo)) | 0);
  if ((rHat < 0)) {
    var lo$1 = ((lo - 1) | 0);
    var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
    var absR_$_lo = lo$1;
    var absR_$_hi = hi$1;
  } else {
    var absR_$_lo = lo;
    var absR_$_hi = hi;
  }
  if ((a_$_hi < 0)) {
    var lo$2 = ((-absR_$_lo) | 0);
    var hi$2 = ((((-absR_$_hi) | 0) - ((lo$2 !== 0) | 0)) | 0);
    return $bL(lo$2, hi$2);
  } else {
    return $bL(absR_$_lo, absR_$_hi);
  }
});
$p.Jz = (function(a_$_lo, a_$_hi) {
  var sign = (a_$_hi >> 31);
  var xlo = (a_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((a_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
  var x = (1.6666666666666693E-8 * aHat);
  var lo = (x | 0.0);
  var hi = ((2.3283064365386963E-10 * x) | 0.0);
  var rHat = ((rlo - Math.imul(60000000, lo)) | 0);
  if ((rHat < 0)) {
    var lo$1 = ((lo - 1) | 0);
    var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
    var absR_$_lo = lo$1;
    var absR_$_hi = hi$1;
  } else {
    var absR_$_lo = lo;
    var absR_$_hi = hi;
  }
  if ((a_$_hi < 0)) {
    var lo$2 = ((-absR_$_lo) | 0);
    var hi$2 = ((((-absR_$_hi) | 0) - ((lo$2 !== 0) | 0)) | 0);
    return $bL(lo$2, hi$2);
  } else {
    return $bL(absR_$_lo, absR_$_hi);
  }
});
$p.Jw = (function(a_$_lo, a_$_hi) {
  var sign = (a_$_hi >> 31);
  var xlo = (a_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((a_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
  var x = (2.777777777777782E-10 * aHat);
  var lo = (x | 0.0);
  var hi = ((2.3283064365386963E-10 * x) | 0.0);
  var b0 = (65535 & lo);
  var b1 = ((lo >>> 16) | 0);
  var a0b0 = Math.imul(41984, b0);
  var a1b0 = Math.imul(54931, b0);
  var a0b1 = Math.imul(41984, b1);
  var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((((Math.imul((-694967296), hi) + Math.imul(54931, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((rlo - lo$1) | 0);
  var hi$2 = ((((rhi - hi$1) | 0) - (((lo$2 >>> 0) > (rlo >>> 0)) | 0)) | 0);
  if ((hi$2 < 0)) {
    var lo$3 = ((lo - 1) | 0);
    var hi$3 = ((((hi - 1) | 0) + ((lo$3 !== (-1)) | 0)) | 0);
    var absR_$_lo = lo$3;
    var absR_$_hi = hi$3;
  } else {
    var absR_$_lo = lo;
    var absR_$_hi = hi;
  }
  if ((a_$_hi < 0)) {
    var lo$4 = ((-absR_$_lo) | 0);
    var hi$4 = ((((-absR_$_hi) | 0) - ((lo$4 !== 0) | 0)) | 0);
    return $bL(lo$4, hi$4);
  } else {
    return $bL(absR_$_lo, absR_$_hi);
  }
});
$p.Jv = (function(a_$_lo, a_$_hi) {
  var sign = (a_$_hi >> 31);
  var xlo = (a_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((a_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
  var x = (1.1574074074074087E-11 * aHat);
  var lo = (x | 0.0);
  var hi = ((2.3283064365386963E-10 * x) | 0.0);
  var b0 = (65535 & lo);
  var b1 = ((lo >>> 16) | 0);
  var a0b0 = Math.imul(24576, b0);
  var a1b0 = Math.imul(7639, b0);
  var a0b1 = Math.imul(24576, b1);
  var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((((((Math.imul(500654080, hi) + Math.imul(20, lo)) | 0) + Math.imul(7639, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((rlo - lo$1) | 0);
  var hi$2 = ((((rhi - hi$1) | 0) - (((lo$2 >>> 0) > (rlo >>> 0)) | 0)) | 0);
  if ((hi$2 < 0)) {
    var lo$3 = ((lo - 1) | 0);
    var hi$3 = ((((hi - 1) | 0) + ((lo$3 !== (-1)) | 0)) | 0);
    var absR_$_lo = lo$3;
    var absR_$_hi = hi$3;
  } else {
    var absR_$_lo = lo;
    var absR_$_hi = hi;
  }
  if ((a_$_hi < 0)) {
    var lo$4 = ((-absR_$_lo) | 0);
    var hi$4 = ((((-absR_$_hi) | 0) - ((lo$4 !== 0) | 0)) | 0);
    return $bL(lo$4, hi$4);
  } else {
    return $bL(absR_$_lo, absR_$_hi);
  }
});
var $d_ju_concurrent_TimeUnit$$anon$2 = new $TypeData().i($c_ju_concurrent_TimeUnit$$anon$2, "java.util.concurrent.TimeUnit$$anon$2", ({
  tB: 1,
  bm: 1,
  bf: 1,
  Q: 1,
  a: 1
}));
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$3() {
  this.up = null;
  this.k6 = 0;
  $ct_jl_Enum__T__I__(this, "MILLISECONDS", 2);
}
$p = $c_ju_concurrent_TimeUnit$$anon$3.prototype = new $h_ju_concurrent_TimeUnit();
$p.constructor = $c_ju_concurrent_TimeUnit$$anon$3;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$3() {
}
$h_ju_concurrent_TimeUnit$$anon$3.prototype = $p;
$p.IK = (function(a_$_lo, a_$_hi, u) {
  return u.Jy(a_$_lo, a_$_hi);
});
$p.rf = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().kt(a_$_lo, a_$_hi, 1000000, 0, 2077252342, 2147);
});
$p.Jx = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().kt(a_$_lo, a_$_hi, 1000, 0, (-1511828489), 2147483);
});
$p.Jy = (function(a_$_lo, a_$_hi) {
  return $bL(a_$_lo, a_$_hi);
});
$p.JA = (function(a_$_lo, a_$_hi) {
  var sign = (a_$_hi >> 31);
  var xlo = (a_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((a_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var quotHi = (((rhi >>> 0) / 1000) | 0);
  var k = ((rhi - Math.imul(1000, quotHi)) | 0);
  var quotLo = ((0.0010000000000000005 * ((4.294967296E9 * k) + (rlo >>> 0.0))) | 0.0);
  if ((a_$_hi < 0)) {
    var lo = ((-quotLo) | 0);
    var hi = ((((-quotHi) | 0) - ((lo !== 0) | 0)) | 0);
    return $bL(lo, hi);
  } else {
    return $bL(quotLo, quotHi);
  }
});
$p.Jz = (function(a_$_lo, a_$_hi) {
  var sign = (a_$_hi >> 31);
  var xlo = (a_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((a_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var quotHi = (((rhi >>> 0) / 60000) | 0);
  var k = ((rhi - Math.imul(60000, quotHi)) | 0);
  var quotLo = ((1.6666666666666674E-5 * ((4.294967296E9 * k) + (rlo >>> 0.0))) | 0.0);
  if ((a_$_hi < 0)) {
    var lo = ((-quotLo) | 0);
    var hi = ((((-quotHi) | 0) - ((lo !== 0) | 0)) | 0);
    return $bL(lo, hi);
  } else {
    return $bL(quotLo, quotHi);
  }
});
$p.Jw = (function(a_$_lo, a_$_hi) {
  var sign = (a_$_hi >> 31);
  var xlo = (a_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((a_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
  var x = (2.777777777777782E-7 * aHat);
  var lo = (x | 0.0);
  var hi = ((2.3283064365386963E-10 * x) | 0.0);
  var rHat = ((rlo - Math.imul(3600000, lo)) | 0);
  if ((rHat < 0)) {
    var lo$1 = ((lo - 1) | 0);
    var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
    var absR_$_lo = lo$1;
    var absR_$_hi = hi$1;
  } else {
    var absR_$_lo = lo;
    var absR_$_hi = hi;
  }
  if ((a_$_hi < 0)) {
    var lo$2 = ((-absR_$_lo) | 0);
    var hi$2 = ((((-absR_$_hi) | 0) - ((lo$2 !== 0) | 0)) | 0);
    return $bL(lo$2, hi$2);
  } else {
    return $bL(absR_$_lo, absR_$_hi);
  }
});
$p.Jv = (function(a_$_lo, a_$_hi) {
  var sign = (a_$_hi >> 31);
  var xlo = (a_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((a_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
  var x = (1.1574074074074087E-8 * aHat);
  var lo = (x | 0.0);
  var hi = ((2.3283064365386963E-10 * x) | 0.0);
  var rHat = ((rlo - Math.imul(86400000, lo)) | 0);
  if ((rHat < 0)) {
    var lo$1 = ((lo - 1) | 0);
    var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
    var absR_$_lo = lo$1;
    var absR_$_hi = hi$1;
  } else {
    var absR_$_lo = lo;
    var absR_$_hi = hi;
  }
  if ((a_$_hi < 0)) {
    var lo$2 = ((-absR_$_lo) | 0);
    var hi$2 = ((((-absR_$_hi) | 0) - ((lo$2 !== 0) | 0)) | 0);
    return $bL(lo$2, hi$2);
  } else {
    return $bL(absR_$_lo, absR_$_hi);
  }
});
var $d_ju_concurrent_TimeUnit$$anon$3 = new $TypeData().i($c_ju_concurrent_TimeUnit$$anon$3, "java.util.concurrent.TimeUnit$$anon$3", ({
  tC: 1,
  bm: 1,
  bf: 1,
  Q: 1,
  a: 1
}));
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$4() {
  this.up = null;
  this.k6 = 0;
  $ct_jl_Enum__T__I__(this, "SECONDS", 3);
}
$p = $c_ju_concurrent_TimeUnit$$anon$4.prototype = new $h_ju_concurrent_TimeUnit();
$p.constructor = $c_ju_concurrent_TimeUnit$$anon$4;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$4() {
}
$h_ju_concurrent_TimeUnit$$anon$4.prototype = $p;
$p.IK = (function(a_$_lo, a_$_hi, u) {
  return u.JA(a_$_lo, a_$_hi);
});
$p.rf = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().kt(a_$_lo, a_$_hi, 1000000000, 0, 633437444, 2);
});
$p.Jx = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().kt(a_$_lo, a_$_hi, 1000000, 0, 2077252342, 2147);
});
$p.Jy = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().kt(a_$_lo, a_$_hi, 1000, 0, (-1511828489), 2147483);
});
$p.JA = (function(a_$_lo, a_$_hi) {
  return $bL(a_$_lo, a_$_hi);
});
$p.Jz = (function(a_$_lo, a_$_hi) {
  var sign = (a_$_hi >> 31);
  var xlo = (a_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((a_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var quotHi = (((rhi >>> 0) / 60) | 0);
  var k = ((rhi - Math.imul(60, quotHi)) | 0);
  var quotLo = ((0.016666666666666673 * ((4.294967296E9 * k) + (rlo >>> 0.0))) | 0.0);
  if ((a_$_hi < 0)) {
    var lo = ((-quotLo) | 0);
    var hi = ((((-quotHi) | 0) - ((lo !== 0) | 0)) | 0);
    return $bL(lo, hi);
  } else {
    return $bL(quotLo, quotHi);
  }
});
$p.Jw = (function(a_$_lo, a_$_hi) {
  var sign = (a_$_hi >> 31);
  var xlo = (a_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((a_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var quotHi = (((rhi >>> 0) / 3600) | 0);
  var k = ((rhi - Math.imul(3600, quotHi)) | 0);
  var quotLo = ((2.777777777777779E-4 * ((4.294967296E9 * k) + (rlo >>> 0.0))) | 0.0);
  if ((a_$_hi < 0)) {
    var lo = ((-quotLo) | 0);
    var hi = ((((-quotHi) | 0) - ((lo !== 0) | 0)) | 0);
    return $bL(lo, hi);
  } else {
    return $bL(quotLo, quotHi);
  }
});
$p.Jv = (function(a_$_lo, a_$_hi) {
  var sign = (a_$_hi >> 31);
  var xlo = (a_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((a_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var quotHi = (((rhi >>> 0) / 86400) | 0);
  var k = ((rhi - Math.imul(86400, quotHi)) | 0);
  var quotLo = ((1.1574074074074079E-5 * ((4.294967296E9 * k) + (rlo >>> 0.0))) | 0.0);
  if ((a_$_hi < 0)) {
    var lo = ((-quotLo) | 0);
    var hi = ((((-quotHi) | 0) - ((lo !== 0) | 0)) | 0);
    return $bL(lo, hi);
  } else {
    return $bL(quotLo, quotHi);
  }
});
var $d_ju_concurrent_TimeUnit$$anon$4 = new $TypeData().i($c_ju_concurrent_TimeUnit$$anon$4, "java.util.concurrent.TimeUnit$$anon$4", ({
  tD: 1,
  bm: 1,
  bf: 1,
  Q: 1,
  a: 1
}));
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$5() {
  this.up = null;
  this.k6 = 0;
  $ct_jl_Enum__T__I__(this, "MINUTES", 4);
}
$p = $c_ju_concurrent_TimeUnit$$anon$5.prototype = new $h_ju_concurrent_TimeUnit();
$p.constructor = $c_ju_concurrent_TimeUnit$$anon$5;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$5() {
}
$h_ju_concurrent_TimeUnit$$anon$5.prototype = $p;
$p.IK = (function(a_$_lo, a_$_hi, u) {
  return u.Jz(a_$_lo, a_$_hi);
});
$p.rf = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().kt(a_$_lo, a_$_hi, (-129542144), 13, 153722867, 0);
});
$p.Jx = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().kt(a_$_lo, a_$_hi, 60000000, 0, (-895955376), 35);
});
$p.Jy = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().kt(a_$_lo, a_$_hi, 60000, 0, 1692789776, 35791);
});
$p.JA = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().kt(a_$_lo, a_$_hi, 60, 0, 572662306, 35791394);
});
$p.Jz = (function(a_$_lo, a_$_hi) {
  return $bL(a_$_lo, a_$_hi);
});
$p.Jw = (function(a_$_lo, a_$_hi) {
  var sign = (a_$_hi >> 31);
  var xlo = (a_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((a_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var quotHi = (((rhi >>> 0) / 60) | 0);
  var k = ((rhi - Math.imul(60, quotHi)) | 0);
  var quotLo = ((0.016666666666666673 * ((4.294967296E9 * k) + (rlo >>> 0.0))) | 0.0);
  if ((a_$_hi < 0)) {
    var lo = ((-quotLo) | 0);
    var hi = ((((-quotHi) | 0) - ((lo !== 0) | 0)) | 0);
    return $bL(lo, hi);
  } else {
    return $bL(quotLo, quotHi);
  }
});
$p.Jv = (function(a_$_lo, a_$_hi) {
  var sign = (a_$_hi >> 31);
  var xlo = (a_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((a_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var quotHi = (((rhi >>> 0) / 1440) | 0);
  var k = ((rhi - Math.imul(1440, quotHi)) | 0);
  var quotLo = ((6.944444444444448E-4 * ((4.294967296E9 * k) + (rlo >>> 0.0))) | 0.0);
  if ((a_$_hi < 0)) {
    var lo = ((-quotLo) | 0);
    var hi = ((((-quotHi) | 0) - ((lo !== 0) | 0)) | 0);
    return $bL(lo, hi);
  } else {
    return $bL(quotLo, quotHi);
  }
});
var $d_ju_concurrent_TimeUnit$$anon$5 = new $TypeData().i($c_ju_concurrent_TimeUnit$$anon$5, "java.util.concurrent.TimeUnit$$anon$5", ({
  tE: 1,
  bm: 1,
  bf: 1,
  Q: 1,
  a: 1
}));
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$6() {
  this.up = null;
  this.k6 = 0;
  $ct_jl_Enum__T__I__(this, "HOURS", 5);
}
$p = $c_ju_concurrent_TimeUnit$$anon$6.prototype = new $h_ju_concurrent_TimeUnit();
$p.constructor = $c_ju_concurrent_TimeUnit$$anon$6;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$6() {
}
$h_ju_concurrent_TimeUnit$$anon$6.prototype = $p;
$p.IK = (function(a_$_lo, a_$_hi, u) {
  return u.Jw(a_$_lo, a_$_hi);
});
$p.rf = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().kt(a_$_lo, a_$_hi, 817405952, 838, 2562047, 0);
});
$p.Jx = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().kt(a_$_lo, a_$_hi, (-694967296), 0, (-1732919508), 0);
});
$p.Jy = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().kt(a_$_lo, a_$_hi, 3600000, 0, (-2047687697), 596);
});
$p.JA = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().kt(a_$_lo, a_$_hi, 3600, 0, 1011703407, 596523);
});
$p.Jz = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().kt(a_$_lo, a_$_hi, 60, 0, 572662306, 35791394);
});
$p.Jw = (function(a_$_lo, a_$_hi) {
  return $bL(a_$_lo, a_$_hi);
});
$p.Jv = (function(a_$_lo, a_$_hi) {
  var sign = (a_$_hi >> 31);
  var xlo = (a_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((a_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var quotHi = (((rhi >>> 0) / 24) | 0);
  var k = ((rhi - Math.imul(24, quotHi)) | 0);
  var quotLo = ((0.041666666666666685 * ((4.294967296E9 * k) + (rlo >>> 0.0))) | 0.0);
  if ((a_$_hi < 0)) {
    var lo = ((-quotLo) | 0);
    var hi = ((((-quotHi) | 0) - ((lo !== 0) | 0)) | 0);
    return $bL(lo, hi);
  } else {
    return $bL(quotLo, quotHi);
  }
});
var $d_ju_concurrent_TimeUnit$$anon$6 = new $TypeData().i($c_ju_concurrent_TimeUnit$$anon$6, "java.util.concurrent.TimeUnit$$anon$6", ({
  tF: 1,
  bm: 1,
  bf: 1,
  Q: 1,
  a: 1
}));
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$7() {
  this.up = null;
  this.k6 = 0;
  $ct_jl_Enum__T__I__(this, "DAYS", 6);
}
$p = $c_ju_concurrent_TimeUnit$$anon$7.prototype = new $h_ju_concurrent_TimeUnit();
$p.constructor = $c_ju_concurrent_TimeUnit$$anon$7;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$7() {
}
$h_ju_concurrent_TimeUnit$$anon$7.prototype = $p;
$p.IK = (function(a_$_lo, a_$_hi, u) {
  return u.Jv(a_$_lo, a_$_hi);
});
$p.rf = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().kt(a_$_lo, a_$_hi, (-1857093632), 20116, 106751, 0);
});
$p.Jx = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().kt(a_$_lo, a_$_hi, 500654080, 20, 106751991, 0);
});
$p.Jy = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().kt(a_$_lo, a_$_hi, 86400000, 0, (-622191233), 24);
});
$p.JA = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().kt(a_$_lo, a_$_hi, 86400, 0, 579025220, 24855);
});
$p.Jz = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().kt(a_$_lo, a_$_hi, 1440, 0, 381774870, 1491308);
});
$p.Jw = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().kt(a_$_lo, a_$_hi, 24, 0, 1431655765, 89478485);
});
$p.Jv = (function(a_$_lo, a_$_hi) {
  return $bL(a_$_lo, a_$_hi);
});
var $d_ju_concurrent_TimeUnit$$anon$7 = new $TypeData().i($c_ju_concurrent_TimeUnit$$anon$7, "java.util.concurrent.TimeUnit$$anon$7", ({
  tG: 1,
  bm: 1,
  bf: 1,
  Q: 1,
  a: 1
}));
function $ct_Lorg_jpablo_graphexplorer_graphviz_Format__T__($thiz, name) {
  $thiz.Kf = name;
  return $thiz;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_Format() {
  this.Kf = null;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_Format.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_Format;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_Format() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_Format.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
var $d_Lorg_jpablo_graphexplorer_graphviz_Format = new $TypeData().i(0, "org.jpablo.graphexplorer.graphviz.Format", ({
  cs: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_Graphviz$$anon$1() {
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_Graphviz$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_Graphviz$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_Graphviz$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_Graphviz$$anon$1.prototype = $p;
$p.bu = (function(x) {
  if ((x !== null)) {
    x.g();
    if (($m_s_None$() === x.h())) {
      return true;
    }
  }
  return false;
});
$p.bt = (function(x, default$1) {
  if ((x !== null)) {
    var name = x.g();
    if (($m_s_None$() === x.h())) {
      return name;
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.bu(x);
});
$p.aC = (function(x, default$1) {
  return this.bt(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_graphviz_Graphviz$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_Graphviz$$anon$1, "org.jpablo.graphexplorer.graphviz.Graphviz$$anon$1", ({
  ud: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_Graphviz$$anon$2(g$2) {
  this.atY = null;
  this.atY = g$2;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_Graphviz$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_Graphviz$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_Graphviz$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_Graphviz$$anon$2.prototype = $p;
$p.bu = (function(x) {
  if ((x !== null)) {
    var x23 = x.h();
    x.g();
    if ((x23 instanceof $c_s_Some)) {
      return true;
    }
  }
  return false;
});
$p.bt = (function(x, default$1) {
  if ((x !== null)) {
    var x28 = x.h();
    var name = x.g();
    if ((x28 instanceof $c_s_Some)) {
      var fmt = x28.J;
      return new $c_T2(name, $m_Lorg_jpablo_graphexplorer_graphviz_Graphviz$().b5n(fmt, this.atY));
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.bu(x);
});
$p.aC = (function(x, default$1) {
  return this.bt(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_graphviz_Graphviz$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_Graphviz$$anon$2, "org.jpablo.graphexplorer.graphviz.Graphviz$$anon$2", ({
  ue: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
function $ct_Lorg_jpablo_graphexplorer_graphviz_RenderStatus__T__($thiz, wire) {
  $thiz.Re = wire;
  return $thiz;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_RenderStatus() {
  this.Re = null;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_RenderStatus.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_RenderStatus;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_RenderStatus() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_RenderStatus.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget() {
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass() {
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
var $d_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass = new $TypeData().i(0, "org.jpablo.graphexplorer.graphviz.dotlang.Compass", ({
  fi: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$RawEnd() {
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$RawEnd.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$RawEnd;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$RawEnd() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$RawEnd.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_EdgeEnd() {
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_EdgeEnd.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_EdgeEnd;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_dotlang_EdgeEnd() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_dotlang_EdgeEnd.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt() {
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign() {
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel() {
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$$anon$1() {
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$$anon$1.prototype = $p;
$p.Xb = (function(x) {
  return ((x instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Open) || false);
});
$p.Wh = (function(x, default$1) {
  return ((x instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Open) ? x.md : default$1.i(x));
});
$p.aM = (function(x) {
  return this.Xb(x);
});
$p.aC = (function(x, default$1) {
  return this.Wh(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$$anon$1, "org.jpablo.graphexplorer.graphviz.html.HtmlParser$$anon$1", ({
  uv: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$$anon$2() {
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$$anon$2.prototype = $p;
$p.Xb = (function(x) {
  if ((x instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Open)) {
    if ((x.md === "img")) {
      return true;
    }
  }
  return false;
});
$p.Wh = (function(x, default$1) {
  if ((x instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Open)) {
    var x45 = x.md;
    var x46 = x.yL;
    if ((x45 === "img")) {
      return new $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Image(x46.ay("src", new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => ""))), x46.r("scale"));
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.Xb(x);
});
$p.aC = (function(x, default$1) {
  return this.Wh(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$$anon$2, "org.jpablo.graphexplorer.graphviz.html.HtmlParser$$anon$2", ({
  uw: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$$anon$3() {
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$$anon$3.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$$anon$3;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$$anon$3() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$$anon$3.prototype = $p;
$p.r2 = (function(x) {
  switch (x) {
    case "left": {
      return true;
      break;
    }
    case "right": {
      return true;
      break;
    }
    case "center": {
      return true;
      break;
    }
    case "text": {
      return true;
      break;
    }
    default: {
      return false;
    }
  }
});
$p.qR = (function(x, default$1) {
  switch (x) {
    case "left": {
      return $s_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$__Left__Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign();
      break;
    }
    case "right": {
      return $s_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$__Right__Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign();
      break;
    }
    case "center": {
      return $s_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$__Center__Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign();
      break;
    }
    case "text": {
      return $s_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$__Text___Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign();
      break;
    }
    default: {
      return default$1.i(x);
    }
  }
});
$p.aM = (function(x) {
  return this.r2(x);
});
$p.aC = (function(x, default$1) {
  return this.qR(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$$anon$3 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$$anon$3, "org.jpablo.graphexplorer.graphviz.html.HtmlParser$$anon$3", ({
  ux: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$$anon$4() {
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$$anon$4.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$$anon$4;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$$anon$4() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$$anon$4.prototype = $p;
$p.Xb = (function(x) {
  if ((x instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Open)) {
    if ((x.md === "img")) {
      return true;
    }
  }
  return false;
});
$p.Wh = (function(x, default$1) {
  if ((x instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Open)) {
    if ((x.md === "img")) {
      return (void 0);
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.Xb(x);
});
$p.aC = (function(x, default$1) {
  return this.Wh(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$$anon$4 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$$anon$4, "org.jpablo.graphexplorer.graphviz.html.HtmlParser$$anon$4", ({
  uy: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok() {
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
var $d_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok = new $TypeData().i(0, "org.jpablo.graphexplorer.graphviz.html.HtmlParser$Tok", ({
  ct: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim() {
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$$anon$1(ci$13) {
  this.a7S = 0;
  this.a7S = ci$13;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$$anon$1.prototype = $p;
$p.bu = (function(x) {
  if ((x !== null)) {
    x.g();
    if (((x.h() | 0) === this.a7S)) {
      return true;
    }
  }
  return false;
});
$p.bt = (function(x, default$1) {
  if ((x !== null)) {
    var nm = x.g();
    if (((x.h() | 0) === this.a7S)) {
      return nm;
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.bu(x);
});
$p.aC = (function(x, default$1) {
  return this.bt(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$$anon$1, "org.jpablo.graphexplorer.graphviz.layout.Cluster$$anon$1", ({
  uE: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$$anon$2(ci$14) {
  this.a7T = 0;
  this.a7T = ci$14;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$$anon$2.prototype = $p;
$p.bu = (function(x) {
  if ((x !== null)) {
    var c = x.g();
    (x.h() | 0);
    if ((c.yP === this.a7T)) {
      return true;
    }
  }
  return false;
});
$p.bt = (function(x, default$1) {
  if ((x !== null)) {
    var c = x.g();
    var i = (x.h() | 0);
    if ((c.yP === this.a7T)) {
      return i;
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.bu(x);
});
$p.aC = (function(x, default$1) {
  return this.bt(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_Cluster$$anon$2, "org.jpablo.graphexplorer.graphviz.layout.Cluster$$anon$2", ({
  uF: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode() {
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.bE = (function() {
  if ((this instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real)) {
    return this.mh;
  }
  if ((this instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Virtual)) {
    var x16 = this.kB;
    var x17 = this.wD;
    return ((("__v" + x16) + "_") + x17);
  }
  if ((this instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Slack)) {
    return ("__s" + this.KR);
  }
  if ((this instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ClusterLn)) {
    return ("__cln" + this.KP);
  }
  if ((this instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ClusterRn)) {
    return ("__crn" + this.KQ);
  }
  if ((this instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$FlatLabel)) {
    return ("__fl" + this.yQ);
  }
  throw new $c_s_MatchError(this);
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode = new $TypeData().i(0, "org.jpablo.graphexplorer.graphviz.layout.LayoutNode", ({
  bo: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
function $ct_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance__I__($thiz, ord) {
  return $thiz;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance() {
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
function $ct_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass__I__($thiz, ord) {
  $thiz.KS = ord;
  return $thiz;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass() {
  this.KS = 0;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$$anon$2() {
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_Order$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_Order$$anon$2.prototype = $p;
$p.agB = (function(x) {
  return ((x instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Virtual) || false);
});
$p.aeL = (function(x, default$1) {
  return ((x instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Virtual) ? x : default$1.i(x));
});
$p.aM = (function(x) {
  return this.agB(x);
});
$p.aC = (function(x, default$1) {
  return this.aeL(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_Order$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$$anon$2, "org.jpablo.graphexplorer.graphviz.layout.Order$$anon$2", ({
  uZ: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$$anon$3(rankOf$32) {
  this.auj = null;
  this.auj = rankOf$32;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$$anon$3.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$$anon$3;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_Order$$anon$3() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_Order$$anon$3.prototype = $p;
$p.bu = (function(x) {
  if ((x !== null)) {
    var x96 = x.g();
    if ((x96 instanceof $c_s_Some)) {
      x.h();
      return true;
    }
  }
  return false;
});
$p.bt = (function(x, default$1) {
  if ((x !== null)) {
    var x101 = x.g();
    if ((x101 instanceof $c_s_Some)) {
      var ci = (x101.J | 0);
      var ns = x.h();
      var rs = ns.L(this.auj);
      return new $c_T2(ci, new $c_T2($f_sc_IterableOnceOps__min__s_math_Ordering__O(rs, $m_s_math_Ordering$Int$()), $f_sc_IterableOnceOps__max__s_math_Ordering__O(rs, $m_s_math_Ordering$Int$())));
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.bu(x);
});
$p.aC = (function(x, default$1) {
  return this.bt(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_Order$$anon$3 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$$anon$3, "org.jpablo.graphexplorer.graphviz.layout.Order$$anon$3", ({
  v0: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$$anon$4() {
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$$anon$4.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$$anon$4;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_Order$$anon$4() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_Order$$anon$4.prototype = $p;
$p.agB = (function(x) {
  return ((x instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Virtual) || false);
});
$p.aeL = (function(x, default$1) {
  return ((x instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Virtual) ? x : default$1.i(x));
});
$p.aM = (function(x) {
  return this.agB(x);
});
$p.aC = (function(x, default$1) {
  return this.aeL(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_Order$$anon$4 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$$anon$4, "org.jpablo.graphexplorer.graphviz.layout.Order$$anon$4", ({
  v1: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$$anon$5() {
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$$anon$5.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$$anon$5;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_Order$$anon$5() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_Order$$anon$5.prototype = $p;
$p.agC = (function(x) {
  return ((x instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Nd) || false);
});
$p.aeM = (function(x, default$1) {
  return ((x instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Nd) ? x.Bl : default$1.i(x));
});
$p.aM = (function(x) {
  return this.agC(x);
});
$p.aC = (function(x, default$1) {
  return this.aeM(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_Order$$anon$5 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$$anon$5, "org.jpablo.graphexplorer.graphviz.layout.Order$$anon$5", ({
  v2: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$$anon$6() {
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$$anon$6.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$$anon$6;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_Order$$anon$6() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_Order$$anon$6.prototype = $p;
$p.agC = (function(x) {
  return ((x instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Nd) || false);
});
$p.aeM = (function(x, default$1) {
  return ((x instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Nd) ? x.Bl : default$1.i(x));
});
$p.aM = (function(x) {
  return this.agC(x);
});
$p.aC = (function(x, default$1) {
  return this.aeM(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_Order$$anon$6 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$$anon$6, "org.jpablo.graphexplorer.graphviz.layout.Order$$anon$6", ({
  v3: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode() {
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen() {
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$$anon$1() {
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$$anon$1.prototype = $p;
$p.b38 = (function(x) {
  return ((x instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Table) || false);
});
$p.aXy = (function(x, default$1) {
  return ((x instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Table) ? x.k8 : default$1.i(x));
});
$p.aM = (function(x) {
  return this.b38(x);
});
$p.aC = (function(x, default$1) {
  return this.aXy(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_PortAnchor$$anon$1, "org.jpablo.graphexplorer.graphviz.layout.PortAnchor$$anon$1", ({
  vb: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
function $ct_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir__I__($thiz, ord) {
  return $thiz;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir() {
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.b3j = (function() {
  return ((this === $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__LR__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir()) || (this === $s_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__RL__Lorg_jpablo_graphexplorer_graphviz_layout_RankDir()));
});
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$Op() {
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$Op.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$Op;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$Op() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$Op.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$Op = new $TypeData().i(0, "org.jpablo.graphexplorer.graphviz.layout.RoundCorners$Op", ({
  dl: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$$anon$1() {
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$$anon$1.prototype = $p;
$p.bu = (function(x) {
  if ((x !== null)) {
    var x54 = x.g();
    if ((x54 !== null)) {
      var lo = (x54.ch | 0);
      var hi = (x54.ca | 0);
      (x.h() | 0);
      if ((lo !== hi)) {
        return true;
      }
    }
  }
  return false;
});
$p.bt = (function(x, default$1) {
  if ((x !== null)) {
    var x61 = x.g();
    if ((x61 !== null)) {
      var wt = x61.bO;
      var wh = x61.bs;
      var lo = (x61.ch | 0);
      var hi = (x61.ca | 0);
      var d = (x.h() | 0);
      if ((lo !== hi)) {
        return new $c_T2(wt, new $c_T2(wt, ((((1 + lo) | 0) <= ((hi - 1) | 0)) ? new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Virtual(d, ((1 + lo) | 0)).bE() : wh)));
      }
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.bu(x);
});
$p.aC = (function(x, default$1) {
  return this.bt(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$$anon$1, "org.jpablo.graphexplorer.graphviz.layout.Spline$$anon$1", ({
  vo: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$$anon$2() {
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$$anon$2.prototype = $p;
$p.bu = (function(x) {
  if ((x !== null)) {
    var x68 = x.g();
    if ((x68 !== null)) {
      var lo = (x68.ch | 0);
      var hi = (x68.ca | 0);
      (x.h() | 0);
      if ((lo !== hi)) {
        return true;
      }
    }
  }
  return false;
});
$p.bt = (function(x, default$1) {
  if ((x !== null)) {
    var x75 = x.g();
    if ((x75 !== null)) {
      var wt = x75.bO;
      var wh = x75.bs;
      var lo = (x75.ch | 0);
      var hi = (x75.ca | 0);
      var d = (x.h() | 0);
      if ((lo !== hi)) {
        return new $c_T2(wh, new $c_T2(((((hi - 1) | 0) >= ((1 + lo) | 0)) ? new $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Virtual(d, ((hi - 1) | 0)).bE() : wt), wh));
      }
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.bu(x);
});
$p.aC = (function(x, default$1) {
  return this.bt(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$$anon$2, "org.jpablo.graphexplorer.graphviz.layout.Spline$$anon$2", ({
  vp: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$$anon$4() {
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$$anon$4.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$$anon$4;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$$anon$4() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$$anon$4.prototype = $p;
$p.bu = (function(x) {
  if ((x !== null)) {
    var e = x.g();
    (x.h() | 0);
    if ((e.ai !== e.ak)) {
      return true;
    }
  }
  return false;
});
$p.bt = (function(x, default$1) {
  if ((x !== null)) {
    var e = x.g();
    var oi = (x.h() | 0);
    if ((e.ai !== e.ak)) {
      return oi;
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.bu(x);
});
$p.aC = (function(x, default$1) {
  return this.bt(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$$anon$4 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_Spline$$anon$4, "org.jpablo.graphexplorer.graphviz.layout.Spline$$anon$4", ({
  vq: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_model_Attrs$$anon$1() {
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_model_Attrs$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_model_Attrs$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_model_Attrs$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_model_Attrs$$anon$1.prototype = $p;
$p.bu = (function(x) {
  if ((x !== null)) {
    var x12 = x.h();
    x.g();
    if (((x12 !== null) && (!(!x12.h())))) {
      return true;
    }
  }
  return false;
});
$p.bt = (function(x, default$1) {
  if ((x !== null)) {
    var x17 = x.h();
    var k = x.g();
    if (((x17 !== null) && (!(!x17.h())))) {
      return k;
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.bu(x);
});
$p.aC = (function(x, default$1) {
  return this.bt(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_graphviz_model_Attrs$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_model_Attrs$$anon$1, "org.jpablo.graphexplorer.graphviz.model.Attrs$$anon$1", ({
  vA: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_output_Output$$anon$1(memSet$3, edgeGvidByIdx$3) {
  this.RZ = null;
  this.auz = null;
  this.RZ = memSet$3;
  this.auz = edgeGvidByIdx$3;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_output_Output$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_output_Output$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_output_Output$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_output_Output$$anon$1.prototype = $p;
$p.bu = (function(x) {
  if ((x !== null)) {
    var e = x.g();
    (x.h() | 0);
    if ((this.RZ.E(e.ai) && this.RZ.E(e.ak))) {
      return true;
    }
  }
  return false;
});
$p.bt = (function(x, default$1) {
  if ((x !== null)) {
    var e = x.g();
    var ix = (x.h() | 0);
    if ((this.RZ.E(e.ai) && this.RZ.E(e.ak))) {
      return this.auz.i(ix);
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.bu(x);
});
$p.aC = (function(x, default$1) {
  return this.bt(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_graphviz_output_Output$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_output_Output$$anon$1, "org.jpablo.graphexplorer.graphviz.output.Output$$anon$1", ({
  vC: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandError() {
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandError.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandError;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_command_CommandError() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_command_CommandError.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.aQj = (function() {
  if ((this instanceof $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandError$UnknownCommand)) {
    return (("unknown command '" + this.S4) + "'");
  }
  if ((this instanceof $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandError$BadArgument)) {
    var x9 = this.S0;
    var x10 = this.S1;
    return ((x9 + ": ") + x10);
  }
  if ((this instanceof $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandError$NotApplicable)) {
    var x5 = this.S2;
    var x6 = this.S3;
    return ((x5 + ": ") + x6);
  }
  throw new $c_s_MatchError(this);
});
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandResult() {
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandResult.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandResult;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_command_CommandResult() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_command_CommandResult.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand() {
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand() {
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_command_Tier() {
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_command_Tier.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_command_Tier;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_command_Tier() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_command_Tier.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
function $ct_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding__T__($thiz, chars) {
  return $thiz;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding() {
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_model_Binding$$anon$8(WritersVersionSpecific_this$14, outer) {
  this.aTS = null;
  this.aTS = WritersVersionSpecific_this$14;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_model_Binding$$anon$8.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_model_Binding$$anon$8;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_model_Binding$$anon$8() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_model_Binding$$anon$8.prototype = $p;
$p.cT = (function() {
  return false;
});
$p.cW = (function() {
  return this;
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.bca = (function(out, v) {
  if ((v === null)) {
    return out.c8((-1));
  } else {
    var ctx = out.bQ(4, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "origin", $m_Lorg_jpablo_graphexplorer_gxcore_model_OriginUri$package$OriginUri$().agg(), v.wS);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "mode", $m_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$().agj(), v.z9);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "baseHash", $m_Lorg_jpablo_graphexplorer_gxcore_model_ContentHash$package$ContentHash$().agf(), v.z8);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "lastSyncAt", $m_Lupickle_default$().tO, $bL(v.Ip, v.Iq));
    return ctx.bV((-1));
  }
});
$p.bcB = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "origin", $m_Lorg_jpablo_graphexplorer_gxcore_model_OriginUri$package$OriginUri$().agg(), v.wS);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "mode", $m_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$().agj(), v.z9);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "baseHash", $m_Lorg_jpablo_graphexplorer_gxcore_model_ContentHash$package$ContentHash$().agf(), v.z8);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "lastSyncAt", $m_Lupickle_default$().tO, $bL(v.Ip, v.Iq));
});
$p.jW = (function(v) {
  return 4;
});
$p.d0 = (function(out, v) {
  return this.bca(out, v);
});
$p.k4 = (function(ctx, v) {
  this.bcB(ctx, v);
});
var $d_Lorg_jpablo_graphexplorer_gxcore_model_Binding$$anon$8 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_model_Binding$$anon$8, "org.jpablo.graphexplorer.gxcore.model.Binding$$anon$8", ({
  vZ: 1,
  B: 1,
  E: 1,
  af: 1,
  ah: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_model_Diagram$$anon$10(WritersVersionSpecific_this$15, outer) {
  this.aTT = null;
  this.aTT = WritersVersionSpecific_this$15;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_model_Diagram$$anon$10.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_model_Diagram$$anon$10;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_model_Diagram$$anon$10() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_model_Diagram$$anon$10.prototype = $p;
$p.cT = (function() {
  return false;
});
$p.cW = (function() {
  return this;
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.bcb = (function(out, v) {
  if ((v === null)) {
    return out.c8((-1));
  } else {
    var ctx = out.bQ(9, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId$().bm(), v.jE);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "name", $m_Lupickle_default$().I, v.n8);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "folder", $m_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath$().bm(), v.uG);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "format", $m_Lupickle_default$().I, v.ru);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "text", $m_Lupickle_default$().I, v.kC);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "binding", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lorg_jpablo_graphexplorer_gxcore_model_Binding$().bm()), v.q3);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "metadata", $m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$().bm(), v.o4);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "createdAt", $m_Lupickle_default$().tO, $bL(v.tP, v.tQ));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "updatedAt", $m_Lupickle_default$().tO, $bL(v.xR, v.xS));
    return ctx.bV((-1));
  }
});
$p.bcC = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId$().bm(), v.jE);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "name", $m_Lupickle_default$().I, v.n8);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "folder", $m_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath$().bm(), v.uG);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "format", $m_Lupickle_default$().I, v.ru);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "text", $m_Lupickle_default$().I, v.kC);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "binding", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lorg_jpablo_graphexplorer_gxcore_model_Binding$().bm()), v.q3);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "metadata", $m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$().bm(), v.o4);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "createdAt", $m_Lupickle_default$().tO, $bL(v.tP, v.tQ));
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "updatedAt", $m_Lupickle_default$().tO, $bL(v.xR, v.xS));
});
$p.jW = (function(v) {
  return 9;
});
$p.d0 = (function(out, v) {
  return this.bcb(out, v);
});
$p.k4 = (function(ctx, v) {
  this.bcC(ctx, v);
});
var $d_Lorg_jpablo_graphexplorer_gxcore_model_Diagram$$anon$10 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_model_Diagram$$anon$10, "org.jpablo.graphexplorer.gxcore.model.Diagram$$anon$10", ({
  w2: 1,
  B: 1,
  E: 1,
  af: 1,
  ah: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId$$anon$2(WritersVersionSpecific_this$11, outer) {
  this.aTU = null;
  this.aTU = WritersVersionSpecific_this$11;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId$$anon$2.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId$$anon$2.prototype = $p;
$p.cT = (function() {
  return false;
});
$p.cW = (function() {
  return this;
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.bcc = (function(out, v) {
  if ((v === null)) {
    return out.c8((-1));
  } else {
    var ctx = out.bQ(1, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "value", $m_Lupickle_default$().I, v.kD);
    return ctx.bV((-1));
  }
});
$p.bcD = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "value", $m_Lupickle_default$().I, v.kD);
});
$p.jW = (function(v) {
  return 1;
});
$p.d0 = (function(out, v) {
  return this.bcc(out, v);
});
$p.k4 = (function(ctx, v) {
  this.bcD(ctx, v);
});
var $d_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId$$anon$2, "org.jpablo.graphexplorer.gxcore.model.DiagramId$$anon$2", ({
  w6: 1,
  B: 1,
  E: 1,
  af: 1,
  ah: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$$anon$6(WritersVersionSpecific_this$13, outer) {
  this.aTV = null;
  this.aTV = WritersVersionSpecific_this$13;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$$anon$6.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$$anon$6;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$$anon$6() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$$anon$6.prototype = $p;
$p.cT = (function() {
  return false;
});
$p.cW = (function() {
  return this;
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aPI = (function(v) {
  var x = v.wV;
  $m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$();
  var x$2 = $m_sci_Set$EmptySet$();
  var $x_4 = ((x !== null) && x.e(x$2));
  var x$3 = v.wU;
  $m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$();
  var x$4 = $m_sci_Set$EmptySet$();
  var $x_3 = ((x$3 !== null) && x$3.e(x$4));
  var x$5 = v.wX;
  $m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$();
  var x$6 = $m_sci_Nil$();
  var $x_2 = ((x$5 !== null) && x$5.e(x$6));
  var $x_1 = v.wW;
  $m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$();
  var x$7 = v.wT;
  $m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$();
  var x$8 = $m_s_None$();
  return ((((((((((!$x_4) | 0) + ((!$x_3) | 0)) | 0) + ((!$x_2) | 0)) | 0) + (($x_1 !== "") | 0)) | 0) + ((!((x$7 !== null) && x$7.e(x$8))) | 0)) | 0);
});
$p.bcd = (function(out, v) {
  if ((v === null)) {
    return out.c8((-1));
  } else {
    var ctx = out.bQ(this.aPI(v), true, (-1));
    var x = v.wV;
    $m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$();
    var x$2 = $m_sci_Set$EmptySet$();
    if ((!((x !== null) && x.e(x$2)))) {
      var this$5 = $m_Lupickle_default$();
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "hiddenElements", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().I, this$5), v.wV);
    }
    var x$3 = v.wU;
    $m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$();
    var x$4 = $m_sci_Set$EmptySet$();
    if ((!((x$3 !== null) && x$3.e(x$4)))) {
      var this$10 = $m_Lupickle_default$();
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "collapsedGroups", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().I, this$10), v.wU);
    }
    var x$5 = v.wX;
    $m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$();
    var x$6 = $m_sci_Nil$();
    if ((!((x$5 !== null) && x$5.e(x$6)))) {
      var this$14 = $m_Lupickle_default$();
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tags", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().I, this$14), v.wX);
    }
    if ((v.wW !== ($m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$(), ""))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "notes", $m_Lupickle_default$().I, v.wW);
    }
    var x$7 = v.wT;
    $m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$();
    var x$8 = $m_s_None$();
    if ((!((x$7 !== null) && x$7.e(x$8)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "autoDetectFormat", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().gP), v.wT);
    }
    return ctx.bV((-1));
  }
});
$p.bcE = (function(ctx, v) {
  var x = v.wV;
  $m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$();
  var x$2 = $m_sci_Set$EmptySet$();
  if ((!((x !== null) && x.e(x$2)))) {
    var this$5 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "hiddenElements", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().I, this$5), v.wV);
  }
  var x$3 = v.wU;
  $m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$();
  var x$4 = $m_sci_Set$EmptySet$();
  if ((!((x$3 !== null) && x$3.e(x$4)))) {
    var this$10 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "collapsedGroups", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().I, this$10), v.wU);
  }
  var x$5 = v.wX;
  $m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$();
  var x$6 = $m_sci_Nil$();
  if ((!((x$5 !== null) && x$5.e(x$6)))) {
    var this$14 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tags", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().I, this$14), v.wX);
  }
  if ((v.wW !== ($m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$(), ""))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "notes", $m_Lupickle_default$().I, v.wW);
  }
  var x$7 = v.wT;
  $m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$();
  var x$8 = $m_s_None$();
  if ((!((x$7 !== null) && x$7.e(x$8)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "autoDetectFormat", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().gP), v.wT);
  }
});
$p.jW = (function(v) {
  return this.aPI(v);
});
$p.d0 = (function(out, v) {
  return this.bcd(out, v);
});
$p.k4 = (function(ctx, v) {
  this.bcE(ctx, v);
});
var $d_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$$anon$6 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$$anon$6, "org.jpablo.graphexplorer.gxcore.model.DiagramMetadata$$anon$6", ({
  w9: 1,
  B: 1,
  E: 1,
  af: 1,
  ah: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath$$anon$4(WritersVersionSpecific_this$12, outer) {
  this.aTW = null;
  this.aTW = WritersVersionSpecific_this$12;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath$$anon$4.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath$$anon$4;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath$$anon$4() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath$$anon$4.prototype = $p;
$p.cT = (function() {
  return false;
});
$p.cW = (function() {
  return this;
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.bce = (function(out, v) {
  if ((v === null)) {
    return out.c8((-1));
  } else {
    var ctx = out.bQ(1, true, (-1));
    var this$2 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "segments", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().I, this$2), v.Lj);
    return ctx.bV((-1));
  }
});
$p.bcF = (function(ctx, v) {
  var this$2 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "segments", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().I, this$2), v.Lj);
});
$p.jW = (function(v) {
  return 1;
});
$p.d0 = (function(out, v) {
  return this.bce(out, v);
});
$p.k4 = (function(ctx, v) {
  this.bcF(ctx, v);
});
var $d_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath$$anon$4 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath$$anon$4, "org.jpablo.graphexplorer.gxcore.model.FolderPath$$anon$4", ({
  wc: 1,
  B: 1,
  E: 1,
  af: 1,
  ah: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction() {
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan() {
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction() {
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode() {
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
var $d_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode = new $TypeData().i(0, "org.jpablo.graphexplorer.gxcore.model.SyncMode", ({
  h1: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_model_SyncState() {
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_model_SyncState.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_model_SyncState;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_model_SyncState() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_model_SyncState.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_projects_DesktopLibrary$$anon$1(dot$2) {
  this.a8k = null;
  this.a8k = dot$2;
}
$p = $c_Lorg_jpablo_graphexplorer_projects_DesktopLibrary$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_projects_DesktopLibrary$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_projects_DesktopLibrary$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_projects_DesktopLibrary$$anon$1.prototype = $p;
$p.b39 = (function(x) {
  return ((x.kC === this.a8k) || false);
});
$p.aXz = (function(x, default$1) {
  return ((x.kC === this.a8k) ? new $c_Lorg_jpablo_graphexplorer_viewer_state_ProjectId(x.jE.kD) : default$1.i(x));
});
$p.aM = (function(x) {
  return this.b39(x);
});
$p.aC = (function(x, default$1) {
  return this.aXz(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_projects_DesktopLibrary$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_projects_DesktopLibrary$$anon$1, "org.jpablo.graphexplorer.projects.DesktopLibrary$$anon$1", ({
  ww: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_projects_DesktopLibrary$$anon$2() {
}
$p = $c_Lorg_jpablo_graphexplorer_projects_DesktopLibrary$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_projects_DesktopLibrary$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_projects_DesktopLibrary$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_projects_DesktopLibrary$$anon$2.prototype = $p;
$p.e5 = (function(x) {
  if ((x !== null)) {
    var x17 = $m_s_util_control_NonFatal$().wm(x);
    if ((!x17.c())) {
      x17.d();
      return true;
    }
  }
  return false;
});
$p.e2 = (function(x, default$1) {
  if ((x !== null)) {
    var x21 = $m_s_util_control_NonFatal$().wm(x);
    if ((!x21.c())) {
      var x22 = x21.d();
      console.error(("[library] could not be listed: " + x22.e3()));
      $m_sci_Vector$();
      return $m_sci_Vector0$();
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.e5(x);
});
$p.aC = (function(x, default$1) {
  return this.e2(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_projects_DesktopLibrary$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_projects_DesktopLibrary$$anon$2, "org.jpablo.graphexplorer.projects.DesktopLibrary$$anon$2", ({
  wx: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_projects_DesktopMigration$$anon$1(d$2) {
  this.av0 = null;
  this.av0 = d$2;
}
$p = $c_Lorg_jpablo_graphexplorer_projects_DesktopMigration$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_projects_DesktopMigration$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_projects_DesktopMigration$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_projects_DesktopMigration$$anon$1.prototype = $p;
$p.e5 = (function(x) {
  if ((x !== null)) {
    var x7 = $m_s_util_control_NonFatal$().wm(x);
    if ((!x7.c())) {
      x7.d();
      return true;
    }
  }
  return false;
});
$p.e2 = (function(x, default$1) {
  if ((x !== null)) {
    var x11 = $m_s_util_control_NonFatal$().wm(x);
    if ((!x11.c())) {
      var x12 = x11.d();
      return new $c_s_Some(((this.av0.jE.kD + ": ") + x12.e3()));
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.e5(x);
});
$p.aC = (function(x, default$1) {
  return this.e2(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_projects_DesktopMigration$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_projects_DesktopMigration$$anon$1, "org.jpablo.graphexplorer.projects.DesktopMigration$$anon$1", ({
  wz: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_projects_LibraryMapping$$anon$1() {
}
$p = $c_Lorg_jpablo_graphexplorer_projects_LibraryMapping$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_projects_LibraryMapping$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_projects_LibraryMapping$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_projects_LibraryMapping$$anon$1.prototype = $p;
$p.Xd = (function(x) {
  return ((x instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId) || false);
});
$p.Wj = (function(x, default$1) {
  return ((x instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId) ? x : default$1.i(x));
});
$p.aM = (function(x) {
  return this.Xd(x);
});
$p.aC = (function(x, default$1) {
  return this.Wj(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_projects_LibraryMapping$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_projects_LibraryMapping$$anon$1, "org.jpablo.graphexplorer.projects.LibraryMapping$$anon$1", ({
  wD: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_projects_LibraryMapping$$anon$2() {
}
$p = $c_Lorg_jpablo_graphexplorer_projects_LibraryMapping$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_projects_LibraryMapping$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_projects_LibraryMapping$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_projects_LibraryMapping$$anon$2.prototype = $p;
$p.bu = (function(x) {
  if ((x !== null)) {
    var x17 = x.h();
    if ((x17 instanceof $c_s_util_Right)) {
      return true;
    }
  }
  return false;
});
$p.bt = (function(x, default$1) {
  if ((x !== null)) {
    var x22 = x.h();
    if ((x22 instanceof $c_s_util_Right)) {
      return x22.hm;
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.bu(x);
});
$p.aC = (function(x, default$1) {
  return this.bt(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_projects_LibraryMapping$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_projects_LibraryMapping$$anon$2, "org.jpablo.graphexplorer.projects.LibraryMapping$$anon$2", ({
  wE: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_projects_LibraryMapping$$anon$3() {
}
$p = $c_Lorg_jpablo_graphexplorer_projects_LibraryMapping$$anon$3.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_projects_LibraryMapping$$anon$3;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_projects_LibraryMapping$$anon$3() {
}
$h_Lorg_jpablo_graphexplorer_projects_LibraryMapping$$anon$3.prototype = $p;
$p.bu = (function(x) {
  if ((x !== null)) {
    x.g();
    if ((x.h() instanceof $c_s_util_Left)) {
      return true;
    }
  }
  return false;
});
$p.bt = (function(x, default$1) {
  if ((x !== null)) {
    var raw = x.g();
    if ((x.h() instanceof $c_s_util_Left)) {
      return raw;
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.bu(x);
});
$p.aC = (function(x, default$1) {
  return this.bt(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_projects_LibraryMapping$$anon$3 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_projects_LibraryMapping$$anon$3, "org.jpablo.graphexplorer.projects.LibraryMapping$$anon$3", ({
  wF: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_projects_LibraryViewMode() {
}
$p = $c_Lorg_jpablo_graphexplorer_projects_LibraryViewMode.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_projects_LibraryViewMode;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_projects_LibraryViewMode() {
}
$h_Lorg_jpablo_graphexplorer_projects_LibraryViewMode.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_projects_ProjectInfo$$anon$2(WritersVersionSpecific_this$5, outer) {
  this.aU1 = null;
  this.aU1 = WritersVersionSpecific_this$5;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lorg_jpablo_graphexplorer_projects_ProjectInfo$$anon$2.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_projects_ProjectInfo$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_projects_ProjectInfo$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_projects_ProjectInfo$$anon$2.prototype = $p;
$p.cT = (function() {
  return false;
});
$p.cW = (function() {
  return this;
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aPJ = (function(v) {
  var $x_3 = $m_sr_BoxesRunTime$();
  var $x_2_$_lo = v.ox;
  var $x_2_$_hi = v.oy;
  var $x_1 = $m_RTLong$().d1((+Date.now()));
  return ((3 + ((!$x_3.qX($bL($x_2_$_lo, $x_2_$_hi), $x_1)) | 0)) | 0);
});
$p.bcf = (function(out, v) {
  if ((v === null)) {
    return out.c8((-1));
  } else {
    var ctx = out.bQ(this.aPJ(v), true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lorg_jpablo_graphexplorer_viewer_state_ProjectId$().bm(), v.eG);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "name", $m_Lupickle_default$().I, v.nb);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "lastModified", $m_Lupickle_default$().tO, $bL(v.vP, v.vQ));
    var $x_3 = $m_sr_BoxesRunTime$();
    var $x_2_$_lo = v.ox;
    var $x_2_$_hi = v.oy;
    var $x_1 = $m_RTLong$().d1((+Date.now()));
    if ((!$x_3.qX($bL($x_2_$_lo, $x_2_$_hi), $x_1))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "createdAt", $m_Lupickle_default$().tO, $bL(v.ox, v.oy));
    }
    return ctx.bV((-1));
  }
});
$p.bcG = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lorg_jpablo_graphexplorer_viewer_state_ProjectId$().bm(), v.eG);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "name", $m_Lupickle_default$().I, v.nb);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "lastModified", $m_Lupickle_default$().tO, $bL(v.vP, v.vQ));
  var $x_3 = $m_sr_BoxesRunTime$();
  var $x_2_$_lo = v.ox;
  var $x_2_$_hi = v.oy;
  var $x_1 = $m_RTLong$().d1((+Date.now()));
  if ((!$x_3.qX($bL($x_2_$_lo, $x_2_$_hi), $x_1))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "createdAt", $m_Lupickle_default$().tO, $bL(v.ox, v.oy));
  }
});
$p.jW = (function(v) {
  return this.aPJ(v);
});
$p.d0 = (function(out, v) {
  return this.bcf(out, v);
});
$p.k4 = (function(ctx, v) {
  this.bcG(ctx, v);
});
var $d_Lorg_jpablo_graphexplorer_projects_ProjectInfo$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_projects_ProjectInfo$$anon$2, "org.jpablo.graphexplorer.projects.ProjectInfo$$anon$2", ({
  wM: 1,
  B: 1,
  E: 1,
  af: 1,
  ah: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory$$anon$4(WritersVersionSpecific_this$6, outer) {
  this.aU3 = null;
  this.aU3 = WritersVersionSpecific_this$6;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory$$anon$4.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory$$anon$4;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory$$anon$4() {
}
$h_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory$$anon$4.prototype = $p;
$p.cT = (function() {
  return false;
});
$p.cW = (function() {
  return this;
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aPK = (function(v) {
  var x = v.hY;
  var x$2 = $m_sci_Nil$();
  return ((!((x !== null) && x.e(x$2))) | 0);
});
$p.bcg = (function(out, v) {
  if ((v === null)) {
    return out.c8((-1));
  } else {
    var ctx = out.bQ(this.aPK(v), true, (-1));
    var x = v.hY;
    var x$2 = $m_sci_Nil$();
    if ((!((x !== null) && x.e(x$2)))) {
      var this$4 = $m_Lupickle_default$();
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "projects", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lorg_jpablo_graphexplorer_projects_ProjectInfo$().bm(), this$4), v.hY);
    }
    return ctx.bV((-1));
  }
});
$p.bcH = (function(ctx, v) {
  var x = v.hY;
  var x$2 = $m_sci_Nil$();
  if ((!((x !== null) && x.e(x$2)))) {
    var this$4 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "projects", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lorg_jpablo_graphexplorer_projects_ProjectInfo$().bm(), this$4), v.hY);
  }
});
$p.jW = (function(v) {
  return this.aPK(v);
});
$p.d0 = (function(out, v) {
  return this.bcg(out, v);
});
$p.k4 = (function(ctx, v) {
  this.bcH(ctx, v);
});
var $d_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory$$anon$4 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory$$anon$4, "org.jpablo.graphexplorer.projects.ProjectsDirectory$$anon$4", ({
  wQ: 1,
  B: 1,
  E: 1,
  af: 1,
  ah: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_projects_SortOption() {
}
$p = $c_Lorg_jpablo_graphexplorer_projects_SortOption.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_projects_SortOption;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_projects_SortOption() {
}
$h_Lorg_jpablo_graphexplorer_projects_SortOption.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.aI = (function() {
  var x = $s_Lorg_jpablo_graphexplorer_projects_SortOption$__LastModified__Lorg_jpablo_graphexplorer_projects_SortOption();
  if (((x !== null) && (x === this))) {
    return "Last Modified";
  }
  var x$3 = $s_Lorg_jpablo_graphexplorer_projects_SortOption$__Title__Lorg_jpablo_graphexplorer_projects_SortOption();
  if (((x$3 !== null) && (x$3 === this))) {
    return "Title";
  }
  var x$5 = $s_Lorg_jpablo_graphexplorer_projects_SortOption$__CreationDate__Lorg_jpablo_graphexplorer_projects_SortOption();
  if (((x$5 !== null) && (x$5 === this))) {
    return "Creation Date";
  }
  throw new $c_s_MatchError(this);
});
var $d_Lorg_jpablo_graphexplorer_projects_SortOption = new $TypeData().i(0, "org.jpablo.graphexplorer.projects.SortOption", ({
  ha: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_router_Route() {
}
$p = $c_Lorg_jpablo_graphexplorer_router_Route.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_router_Route;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_router_Route() {
}
$h_Lorg_jpablo_graphexplorer_router_Route.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.DT = (function() {
  var x = $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__DOT__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat();
  if (((x !== null) && (x === this))) {
    return "DOT/Graphviz";
  }
  var x$3 = $s_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__Mermaid__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat();
  if (((x$3 !== null) && (x$3 === this))) {
    return "Mermaid";
  }
  throw new $c_s_MatchError(this);
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat = new $TypeData().i(0, "org.jpablo.graphexplorer.viewer.backends.DiagramFormat", ({
  hg: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_PastedDiagram$$anon$1() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_PastedDiagram$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_PastedDiagram$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_PastedDiagram$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_PastedDiagram$$anon$1.prototype = $p;
$p.bu = (function(x) {
  if ((x !== null)) {
    var x9 = x.g();
    if ((x9 !== null)) {
      var x11 = $m_Lorg_jpablo_graphexplorer_viewer_backends_PastedDiagram$().a07.jw(x9);
      if ((!x11.c())) {
        var x12 = x11.d();
        if ((x12.bL(2) === 0)) {
          $f_sc_LinearSeqOps__apply__I__O(x12, 0);
          $f_sc_LinearSeqOps__apply__I__O(x12, 1);
          (x.h() | 0);
          return true;
        }
      }
    }
  }
  return false;
});
$p.bt = (function(x, default$1) {
  if ((x !== null)) {
    var x16 = x.g();
    if ((x16 !== null)) {
      var x18 = $m_Lorg_jpablo_graphexplorer_viewer_backends_PastedDiagram$().a07.jw(x16);
      if ((!x18.c())) {
        var x19 = x18.d();
        if ((x19.bL(2) === 0)) {
          var x20 = $f_sc_LinearSeqOps__apply__I__O(x19, 0);
          var x21 = $f_sc_LinearSeqOps__apply__I__O(x19, 1);
          return new $c_T3((x.h() | 0), x20, x21);
        }
      }
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.bu(x);
});
$p.aC = (function(x, default$1) {
  return this.bt(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_PastedDiagram$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_PastedDiagram$$anon$1, "org.jpablo.graphexplorer.viewer.backends.PastedDiagram$$anon$1", ({
  x5: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
function $ct_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent__T__($thiz, label) {
  $thiz.BO = label;
  return $thiz;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent() {
  this.BO = null;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent = new $TypeData().i(0, "org.jpablo.graphexplorer.viewer.backends.UnmodeledContent", ({
  bp: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$$anon$1() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$$anon$1.prototype = $p;
$p.r2 = (function(x) {
  if ((x !== null)) {
    var x2 = $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$().a8C.jw(x);
    if ((!x2.c())) {
      var x3 = x2.d();
      if ((x3.bL(1) === 0)) {
        $f_sc_LinearSeqOps__apply__I__O(x3, 0);
        return true;
      }
    }
  }
  return false;
});
$p.qR = (function(x, default$1) {
  if ((x !== null)) {
    var x6 = $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$().a8C.jw(x);
    if ((!x6.c())) {
      var x7 = x6.d();
      if ((x7.bL(1) === 0)) {
        var x8 = $f_sc_LinearSeqOps__apply__I__O(x7, 0);
        return x8.toLowerCase();
      }
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.r2(x);
});
$p.aC = (function(x, default$1) {
  return this.qR(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_DotSourceScan$$anon$1, "org.jpablo.graphexplorer.viewer.backends.graphviz.DotSourceScan$$anon$1", ({
  xi: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ExtraAttrs$$anon$1(knownKeys$6) {
  this.a8F = null;
  this.a8F = knownKeys$6;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ExtraAttrs$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ExtraAttrs$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ExtraAttrs$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ExtraAttrs$$anon$1.prototype = $p;
$p.bu = (function(x) {
  if ((x !== null)) {
    var x3 = x.h();
    var k = x.g();
    if ((x3 instanceof $c_Lujson_Str)) {
      if (((!this.a8F.E(k)) && (!$m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ExtraAttrs$().a8E.E(k)))) {
        return true;
      }
    }
  }
  return false;
});
$p.bt = (function(x, default$1) {
  if ((x !== null)) {
    var x9 = x.h();
    var k = x.g();
    if ((x9 instanceof $c_Lujson_Str)) {
      var x12 = x9.xP;
      if (((!this.a8F.E(k)) && (!$m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ExtraAttrs$().a8E.E(k)))) {
        return new $c_T2(k, x12);
      }
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.bu(x);
});
$p.aC = (function(x, default$1) {
  return this.bt(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ExtraAttrs$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ExtraAttrs$$anon$1, "org.jpablo.graphexplorer.viewer.backends.graphviz.vizjs.simplegraph.ExtraAttrs$$anon$1", ({
  xp: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$$anon$10(WritersVersionSpecific_this$12, outer) {
  this.aU4 = null;
  this.aU4 = WritersVersionSpecific_this$12;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$$anon$10.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$$anon$10;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$$anon$10() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$$anon$10.prototype = $p;
$p.cT = (function() {
  return false;
});
$p.cW = (function() {
  return this;
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aPL = (function(v) {
  var $x_47 = $m_sr_BoxesRunTime$().Q(v.rw, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), true));
  var x$1 = v.o5;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$2 = $m_s_None$();
  var $x_46 = ((x$1 !== null) && x$1.e(x$2));
  var x$3 = v.q5;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$4 = $m_s_None$();
  var $x_45 = ((x$3 !== null) && x$3.e(x$4));
  var x$5 = v.ry;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$6 = $m_s_None$();
  var $x_44 = ((x$5 !== null) && x$5.e(x$6));
  var x$7 = v.rz;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$8 = $m_s_None$();
  var $x_43 = ((x$7 !== null) && x$7.e(x$8));
  var x$9 = v.rA;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$10 = $m_s_None$();
  var $x_42 = ((x$9 !== null) && x$9.e(x$10));
  var x$11 = v.rB;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$12 = $m_s_None$();
  var $x_41 = ((x$11 !== null) && x$11.e(x$12));
  var x$13 = v.rE;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$14 = $m_s_None$();
  var $x_40 = ((x$13 !== null) && x$13.e(x$14));
  var x$15 = v.rD;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$16 = $m_s_None$();
  var $x_39 = ((x$15 !== null) && x$15.e(x$16));
  var x$17 = v.rF;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$18 = $m_s_None$();
  var $x_38 = ((x$17 !== null) && x$17.e(x$18));
  var x$19 = v.rK;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$20 = $m_s_None$();
  var $x_37 = ((x$19 !== null) && x$19.e(x$20));
  var x$21 = v.rC;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$22 = $m_s_None$();
  var $x_36 = ((x$21 !== null) && x$21.e(x$22));
  var x$23 = v.rv;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$24 = $m_s_None$();
  var $x_35 = ((x$23 !== null) && x$23.e(x$24));
  var x$25 = v.rG;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$26 = $m_s_None$();
  var $x_34 = ((x$25 !== null) && x$25.e(x$26));
  var x$27 = v.rJ;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$28 = $m_s_None$();
  var $x_33 = ((x$27 !== null) && x$27.e(x$28));
  var x$29 = v.rL;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$30 = $m_s_None$();
  var $x_32 = ((x$29 !== null) && x$29.e(x$30));
  var x$31 = v.rM;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$32 = $m_s_None$();
  var $x_31 = ((x$31 !== null) && x$31.e(x$32));
  var x$33 = v.rN;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$34 = $m_s_None$();
  var $x_30 = ((x$33 !== null) && x$33.e(x$34));
  var x$35 = v.rI;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$36 = $m_s_None$();
  var $x_29 = ((x$35 !== null) && x$35.e(x$36));
  var x$37 = v.rH;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$38 = $m_s_None$();
  var $x_28 = ((x$37 !== null) && x$37.e(x$38));
  var x$39 = v.rO;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$40 = $m_s_None$();
  var $x_27 = ((x$39 !== null) && x$39.e(x$40));
  var x$41 = v.uM;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$42 = $m_s_None$();
  var $x_26 = ((x$41 !== null) && x$41.e(x$42));
  var x$43 = v.uI;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$44 = $m_s_None$();
  var $x_25 = ((x$43 !== null) && x$43.e(x$44));
  var x$45 = v.uN;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$46 = $m_s_None$();
  var $x_24 = ((x$45 !== null) && x$45.e(x$46));
  var x$47 = v.uO;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$48 = $m_s_None$();
  var $x_23 = ((x$47 !== null) && x$47.e(x$48));
  var x$49 = v.uP;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$50 = $m_s_None$();
  var $x_22 = ((x$49 !== null) && x$49.e(x$50));
  var x$51 = v.uQ;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$52 = $m_s_None$();
  var $x_21 = ((x$51 !== null) && x$51.e(x$52));
  var x$53 = v.uR;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$54 = $m_s_None$();
  var $x_20 = ((x$53 !== null) && x$53.e(x$54));
  var x$55 = v.uS;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$56 = $m_s_None$();
  var $x_19 = ((x$55 !== null) && x$55.e(x$56));
  var x$57 = v.uT;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$58 = $m_s_None$();
  var $x_18 = ((x$57 !== null) && x$57.e(x$58));
  var x$59 = v.uU;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$60 = $m_s_None$();
  var $x_17 = ((x$59 !== null) && x$59.e(x$60));
  var x$61 = v.uV;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$62 = $m_s_None$();
  var $x_16 = ((x$61 !== null) && x$61.e(x$62));
  var x$63 = v.uJ;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$64 = $m_s_None$();
  var $x_15 = ((x$63 !== null) && x$63.e(x$64));
  var x$65 = v.uW;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$66 = $m_s_None$();
  var $x_14 = ((x$65 !== null) && x$65.e(x$66));
  var x$67 = v.uX;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$68 = $m_s_None$();
  var $x_13 = ((x$67 !== null) && x$67.e(x$68));
  var x$69 = v.uY;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$70 = $m_s_None$();
  var $x_12 = ((x$69 !== null) && x$69.e(x$70));
  var x$71 = v.uZ;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$72 = $m_s_None$();
  var $x_11 = ((x$71 !== null) && x$71.e(x$72));
  var x$73 = v.v0;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$74 = $m_s_None$();
  var $x_10 = ((x$73 !== null) && x$73.e(x$74));
  var x$75 = v.v1;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$76 = $m_s_None$();
  var $x_9 = ((x$75 !== null) && x$75.e(x$76));
  var x$77 = v.v2;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$78 = $m_s_None$();
  var $x_8 = ((x$77 !== null) && x$77.e(x$78));
  var x$79 = v.v3;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$80 = $m_s_None$();
  var $x_7 = ((x$79 !== null) && x$79.e(x$80));
  var x$81 = v.v4;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$82 = $m_s_None$();
  var $x_6 = ((x$81 !== null) && x$81.e(x$82));
  var x$83 = v.v5;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$84 = $m_s_None$();
  var $x_5 = ((x$83 !== null) && x$83.e(x$84));
  var x$85 = v.uK;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$86 = $m_s_None$();
  var $x_4 = ((x$85 !== null) && x$85.e(x$86));
  var x$87 = v.v6;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$88 = $m_s_None$();
  var $x_3 = ((x$87 !== null) && x$87.e(x$88));
  var x$89 = v.v7;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$90 = $m_s_None$();
  var $x_2 = ((x$89 !== null) && x$89.e(x$90));
  var x$91 = v.uL;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$92 = $m_s_None$();
  var $x_1 = ((x$91 !== null) && x$91.e(x$92));
  var x$93 = v.rx;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$94 = $m_sci_Map$EmptyMap$();
  return ((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((1 + ((!$x_47) | 0)) | 0) + ((!$x_46) | 0)) | 0) + ((!$x_45) | 0)) | 0) + ((!$x_44) | 0)) | 0) + ((!$x_43) | 0)) | 0) + ((!$x_42) | 0)) | 0) + ((!$x_41) | 0)) | 0) + ((!$x_40) | 0)) | 0) + ((!$x_39) | 0)) | 0) + ((!$x_38) | 0)) | 0) + ((!$x_37) | 0)) | 0) + ((!$x_36) | 0)) | 0) + ((!$x_35) | 0)) | 0) + ((!$x_34) | 0)) | 0) + ((!$x_33) | 0)) | 0) + ((!$x_32) | 0)) | 0) + ((!$x_31) | 0)) | 0) + ((!$x_30) | 0)) | 0) + ((!$x_29) | 0)) | 0) + ((!$x_28) | 0)) | 0) + ((!$x_27) | 0)) | 0) + ((!$x_26) | 0)) | 0) + ((!$x_25) | 0)) | 0) + ((!$x_24) | 0)) | 0) + ((!$x_23) | 0)) | 0) + ((!$x_22) | 0)) | 0) + ((!$x_21) | 0)) | 0) + ((!$x_20) | 0)) | 0) + ((!$x_19) | 0)) | 0) + ((!$x_18) | 0)) | 0) + ((!$x_17) | 0)) | 0) + ((!$x_16) | 0)) | 0) + ((!$x_15) | 0)) | 0) + ((!$x_14) | 0)) | 0) + ((!$x_13) | 0)) | 0) + ((!$x_12) | 0)) | 0) + ((!$x_11) | 0)) | 0) + ((!$x_10) | 0)) | 0) + ((!$x_9) | 0)) | 0) + ((!$x_8) | 0)) | 0) + ((!$x_7) | 0)) | 0) + ((!$x_6) | 0)) | 0) + ((!$x_5) | 0)) | 0) + ((!$x_4) | 0)) | 0) + ((!$x_3) | 0)) | 0) + ((!$x_2) | 0)) | 0) + ((!$x_1) | 0)) | 0) + ((!((x$93 !== null) && x$93.e(x$94))) | 0)) | 0);
});
$p.bch = (function(out, v) {
  if ((v === null)) {
    return out.c8((-1));
  } else {
    var ctx = out.bQ(this.aPL(v), true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "name", $m_Lupickle_default$().I, v.zf);
    if ((!$m_sr_BoxesRunTime$().Q(v.rw, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), true)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "directed", $m_Lupickle_default$().gP, v.rw);
    }
    var x$1 = v.o5;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$2 = $m_s_None$();
    if ((!((x$1 !== null) && x$1.e(x$2)))) {
      var $x_1 = $m_Lupickle_default$();
      var this$7 = $m_Lupickle_default$();
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "objects", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($x_1, new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject$().agi(), this$7)), v.o5);
    }
    var x$3 = v.q5;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$4 = $m_s_None$();
    if ((!((x$3 !== null) && x$3.e(x$4)))) {
      var $x_2 = $m_Lupickle_default$();
      var this$12 = $m_Lupickle_default$();
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "edges", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($x_2, new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge$().agh(), this$12)), v.q5);
    }
    var x$5 = v.ry;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$6 = $m_s_None$();
    if ((!((x$5 !== null) && x$5.e(x$6)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "fontname", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.ry);
    }
    var x$7 = v.rz;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$8 = $m_s_None$();
    if ((!((x$7 !== null) && x$7.e(x$8)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "fontsize", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rz);
    }
    var x$9 = v.rA;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$10 = $m_s_None$();
    if ((!((x$9 !== null) && x$9.e(x$10)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "label", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rA);
    }
    var x$11 = v.rB;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$12 = $m_s_None$();
    if ((!((x$11 !== null) && x$11.e(x$12)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "labelloc", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rB);
    }
    var x$13 = v.rE;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$14 = $m_s_None$();
    if ((!((x$13 !== null) && x$13.e(x$14)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "lp", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rE);
    }
    var x$15 = v.rD;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$16 = $m_s_None$();
    if ((!((x$15 !== null) && x$15.e(x$16)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "lheight", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rD);
    }
    var x$17 = v.rF;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$18 = $m_s_None$();
    if ((!((x$17 !== null) && x$17.e(x$18)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "lwidth", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rF);
    }
    var x$19 = v.rK;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$20 = $m_s_None$();
    if ((!((x$19 !== null) && x$19.e(x$20)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rankdir", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rK);
    }
    var x$21 = v.rC;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$22 = $m_s_None$();
    if ((!((x$21 !== null) && x$21.e(x$22)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "layout", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rC);
    }
    var x$23 = v.rv;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$24 = $m_s_None$();
    if ((!((x$23 !== null) && x$23.e(x$24)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "bgcolor", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rv);
    }
    var x$25 = v.rG;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$26 = $m_s_None$();
    if ((!((x$25 !== null) && x$25.e(x$26)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "nodesep", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rG);
    }
    var x$27 = v.rJ;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$28 = $m_s_None$();
    if ((!((x$27 !== null) && x$27.e(x$28)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "pad", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rJ);
    }
    var x$29 = v.rL;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$30 = $m_s_None$();
    if ((!((x$29 !== null) && x$29.e(x$30)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "ranksep", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rL);
    }
    var x$31 = v.rM;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$32 = $m_s_None$();
    if ((!((x$31 !== null) && x$31.e(x$32)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "ratio", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rM);
    }
    var x$33 = v.rN;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$34 = $m_s_None$();
    if ((!((x$33 !== null) && x$33.e(x$34)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "splines", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rN);
    }
    var x$35 = v.rI;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$36 = $m_s_None$();
    if ((!((x$35 !== null) && x$35.e(x$36)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "overlap", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rI);
    }
    var x$37 = v.rH;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$38 = $m_s_None$();
    if ((!((x$37 !== null) && x$37.e(x$38)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "normalize", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rH);
    }
    var x$39 = v.rO;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$40 = $m_s_None$();
    if ((!((x$39 !== null) && x$39.e(x$40)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "start", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rO);
    }
    var x$41 = v.uM;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$42 = $m_s_None$();
    if ((!((x$41 !== null) && x$41.e(x$42)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "beautify", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.uM);
    }
    var x$43 = v.uI;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$44 = $m_s_None$();
    if ((!((x$43 !== null) && x$43.e(x$44)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "Damping", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.uI);
    }
    var x$45 = v.uN;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$46 = $m_s_None$();
    if ((!((x$45 !== null) && x$45.e(x$46)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "defaultdist", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.uN);
    }
    var x$47 = v.uO;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$48 = $m_s_None$();
    if ((!((x$47 !== null) && x$47.e(x$48)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "dim", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.uO);
    }
    var x$49 = v.uP;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$50 = $m_s_None$();
    if ((!((x$49 !== null) && x$49.e(x$50)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "dimen", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.uP);
    }
    var x$51 = v.uQ;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$52 = $m_s_None$();
    if ((!((x$51 !== null) && x$51.e(x$52)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "diredgeconstraints", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.uQ);
    }
    var x$53 = v.uR;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$54 = $m_s_None$();
    if ((!((x$53 !== null) && x$53.e(x$54)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "dpi", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.uR);
    }
    var x$55 = v.uS;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$56 = $m_s_None$();
    if ((!((x$55 !== null) && x$55.e(x$56)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "epsilon", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.uS);
    }
    var x$57 = v.uT;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$58 = $m_s_None$();
    if ((!((x$57 !== null) && x$57.e(x$58)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "esep", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.uT);
    }
    var x$59 = v.uU;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$60 = $m_s_None$();
    if ((!((x$59 !== null) && x$59.e(x$60)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "fontnames", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.uU);
    }
    var x$61 = v.uV;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$62 = $m_s_None$();
    if ((!((x$61 !== null) && x$61.e(x$62)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "fontpath", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.uV);
    }
    var x$63 = v.uJ;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$64 = $m_s_None$();
    if ((!((x$63 !== null) && x$63.e(x$64)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "K", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.uJ);
    }
    var x$65 = v.uW;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$66 = $m_s_None$();
    if ((!((x$65 !== null) && x$65.e(x$66)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "label_scheme", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.uW);
    }
    var x$67 = v.uX;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$68 = $m_s_None$();
    if ((!((x$67 !== null) && x$67.e(x$68)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "labeljust", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.uX);
    }
    var x$69 = v.uY;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$70 = $m_s_None$();
    if ((!((x$69 !== null) && x$69.e(x$70)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "landscape", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.uY);
    }
    var x$71 = v.uZ;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$72 = $m_s_None$();
    if ((!((x$71 !== null) && x$71.e(x$72)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "layerlistsep", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.uZ);
    }
    var x$73 = v.v0;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$74 = $m_s_None$();
    if ((!((x$73 !== null) && x$73.e(x$74)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "layers", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.v0);
    }
    var x$75 = v.v1;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$76 = $m_s_None$();
    if ((!((x$75 !== null) && x$75.e(x$76)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "layerselect", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.v1);
    }
    var x$77 = v.v2;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$78 = $m_s_None$();
    if ((!((x$77 !== null) && x$77.e(x$78)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "layersep", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.v2);
    }
    var x$79 = v.v3;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$80 = $m_s_None$();
    if ((!((x$79 !== null) && x$79.e(x$80)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "nojustify", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.v3);
    }
    var x$81 = v.v4;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$82 = $m_s_None$();
    if ((!((x$81 !== null) && x$81.e(x$82)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "notranslate", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.v4);
    }
    var x$83 = v.v5;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$84 = $m_s_None$();
    if ((!((x$83 !== null) && x$83.e(x$84)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "target", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.v5);
    }
    var x$85 = v.uK;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$86 = $m_s_None$();
    if ((!((x$85 !== null) && x$85.e(x$86)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "TBbalance", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.uK);
    }
    var x$87 = v.v6;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$88 = $m_s_None$();
    if ((!((x$87 !== null) && x$87.e(x$88)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tooltip", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.v6);
    }
    var x$89 = v.v7;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$90 = $m_s_None$();
    if ((!((x$89 !== null) && x$89.e(x$90)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "truecolor", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.v7);
    }
    var x$91 = v.uL;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$92 = $m_s_None$();
    if ((!((x$91 !== null) && x$91.e(x$92)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "URL", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.uL);
    }
    var x$93 = v.rx;
    $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
    var x$94 = $m_sci_Map$EmptyMap$();
    if ((!((x$93 !== null) && x$93.e(x$94)))) {
      var this$194 = $m_Lupickle_default$();
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "extraAttrs", new $c_Lupickle_implicits_Writers$$anon$20($m_Lupickle_default$().I, $m_Lupickle_default$().I, this$194), v.rx);
    }
    return ctx.bV((-1));
  }
});
$p.bcI = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "name", $m_Lupickle_default$().I, v.zf);
  if ((!$m_sr_BoxesRunTime$().Q(v.rw, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), true)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "directed", $m_Lupickle_default$().gP, v.rw);
  }
  var x$1 = v.o5;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$2 = $m_s_None$();
  if ((!((x$1 !== null) && x$1.e(x$2)))) {
    var $x_1 = $m_Lupickle_default$();
    var this$7 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "objects", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($x_1, new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject$().agi(), this$7)), v.o5);
  }
  var x$3 = v.q5;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$4 = $m_s_None$();
  if ((!((x$3 !== null) && x$3.e(x$4)))) {
    var $x_2 = $m_Lupickle_default$();
    var this$12 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "edges", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($x_2, new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge$().agh(), this$12)), v.q5);
  }
  var x$5 = v.ry;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$6 = $m_s_None$();
  if ((!((x$5 !== null) && x$5.e(x$6)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "fontname", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.ry);
  }
  var x$7 = v.rz;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$8 = $m_s_None$();
  if ((!((x$7 !== null) && x$7.e(x$8)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "fontsize", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rz);
  }
  var x$9 = v.rA;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$10 = $m_s_None$();
  if ((!((x$9 !== null) && x$9.e(x$10)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "label", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rA);
  }
  var x$11 = v.rB;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$12 = $m_s_None$();
  if ((!((x$11 !== null) && x$11.e(x$12)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "labelloc", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rB);
  }
  var x$13 = v.rE;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$14 = $m_s_None$();
  if ((!((x$13 !== null) && x$13.e(x$14)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "lp", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rE);
  }
  var x$15 = v.rD;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$16 = $m_s_None$();
  if ((!((x$15 !== null) && x$15.e(x$16)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "lheight", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rD);
  }
  var x$17 = v.rF;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$18 = $m_s_None$();
  if ((!((x$17 !== null) && x$17.e(x$18)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "lwidth", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rF);
  }
  var x$19 = v.rK;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$20 = $m_s_None$();
  if ((!((x$19 !== null) && x$19.e(x$20)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rankdir", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rK);
  }
  var x$21 = v.rC;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$22 = $m_s_None$();
  if ((!((x$21 !== null) && x$21.e(x$22)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "layout", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rC);
  }
  var x$23 = v.rv;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$24 = $m_s_None$();
  if ((!((x$23 !== null) && x$23.e(x$24)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "bgcolor", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rv);
  }
  var x$25 = v.rG;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$26 = $m_s_None$();
  if ((!((x$25 !== null) && x$25.e(x$26)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "nodesep", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rG);
  }
  var x$27 = v.rJ;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$28 = $m_s_None$();
  if ((!((x$27 !== null) && x$27.e(x$28)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "pad", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rJ);
  }
  var x$29 = v.rL;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$30 = $m_s_None$();
  if ((!((x$29 !== null) && x$29.e(x$30)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "ranksep", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rL);
  }
  var x$31 = v.rM;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$32 = $m_s_None$();
  if ((!((x$31 !== null) && x$31.e(x$32)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "ratio", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rM);
  }
  var x$33 = v.rN;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$34 = $m_s_None$();
  if ((!((x$33 !== null) && x$33.e(x$34)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "splines", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rN);
  }
  var x$35 = v.rI;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$36 = $m_s_None$();
  if ((!((x$35 !== null) && x$35.e(x$36)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "overlap", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rI);
  }
  var x$37 = v.rH;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$38 = $m_s_None$();
  if ((!((x$37 !== null) && x$37.e(x$38)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "normalize", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rH);
  }
  var x$39 = v.rO;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$40 = $m_s_None$();
  if ((!((x$39 !== null) && x$39.e(x$40)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "start", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rO);
  }
  var x$41 = v.uM;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$42 = $m_s_None$();
  if ((!((x$41 !== null) && x$41.e(x$42)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "beautify", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.uM);
  }
  var x$43 = v.uI;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$44 = $m_s_None$();
  if ((!((x$43 !== null) && x$43.e(x$44)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "Damping", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.uI);
  }
  var x$45 = v.uN;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$46 = $m_s_None$();
  if ((!((x$45 !== null) && x$45.e(x$46)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "defaultdist", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.uN);
  }
  var x$47 = v.uO;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$48 = $m_s_None$();
  if ((!((x$47 !== null) && x$47.e(x$48)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "dim", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.uO);
  }
  var x$49 = v.uP;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$50 = $m_s_None$();
  if ((!((x$49 !== null) && x$49.e(x$50)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "dimen", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.uP);
  }
  var x$51 = v.uQ;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$52 = $m_s_None$();
  if ((!((x$51 !== null) && x$51.e(x$52)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "diredgeconstraints", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.uQ);
  }
  var x$53 = v.uR;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$54 = $m_s_None$();
  if ((!((x$53 !== null) && x$53.e(x$54)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "dpi", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.uR);
  }
  var x$55 = v.uS;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$56 = $m_s_None$();
  if ((!((x$55 !== null) && x$55.e(x$56)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "epsilon", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.uS);
  }
  var x$57 = v.uT;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$58 = $m_s_None$();
  if ((!((x$57 !== null) && x$57.e(x$58)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "esep", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.uT);
  }
  var x$59 = v.uU;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$60 = $m_s_None$();
  if ((!((x$59 !== null) && x$59.e(x$60)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "fontnames", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.uU);
  }
  var x$61 = v.uV;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$62 = $m_s_None$();
  if ((!((x$61 !== null) && x$61.e(x$62)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "fontpath", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.uV);
  }
  var x$63 = v.uJ;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$64 = $m_s_None$();
  if ((!((x$63 !== null) && x$63.e(x$64)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "K", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.uJ);
  }
  var x$65 = v.uW;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$66 = $m_s_None$();
  if ((!((x$65 !== null) && x$65.e(x$66)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "label_scheme", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.uW);
  }
  var x$67 = v.uX;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$68 = $m_s_None$();
  if ((!((x$67 !== null) && x$67.e(x$68)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "labeljust", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.uX);
  }
  var x$69 = v.uY;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$70 = $m_s_None$();
  if ((!((x$69 !== null) && x$69.e(x$70)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "landscape", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.uY);
  }
  var x$71 = v.uZ;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$72 = $m_s_None$();
  if ((!((x$71 !== null) && x$71.e(x$72)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "layerlistsep", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.uZ);
  }
  var x$73 = v.v0;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$74 = $m_s_None$();
  if ((!((x$73 !== null) && x$73.e(x$74)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "layers", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.v0);
  }
  var x$75 = v.v1;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$76 = $m_s_None$();
  if ((!((x$75 !== null) && x$75.e(x$76)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "layerselect", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.v1);
  }
  var x$77 = v.v2;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$78 = $m_s_None$();
  if ((!((x$77 !== null) && x$77.e(x$78)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "layersep", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.v2);
  }
  var x$79 = v.v3;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$80 = $m_s_None$();
  if ((!((x$79 !== null) && x$79.e(x$80)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "nojustify", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.v3);
  }
  var x$81 = v.v4;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$82 = $m_s_None$();
  if ((!((x$81 !== null) && x$81.e(x$82)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "notranslate", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.v4);
  }
  var x$83 = v.v5;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$84 = $m_s_None$();
  if ((!((x$83 !== null) && x$83.e(x$84)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "target", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.v5);
  }
  var x$85 = v.uK;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$86 = $m_s_None$();
  if ((!((x$85 !== null) && x$85.e(x$86)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "TBbalance", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.uK);
  }
  var x$87 = v.v6;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$88 = $m_s_None$();
  if ((!((x$87 !== null) && x$87.e(x$88)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tooltip", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.v6);
  }
  var x$89 = v.v7;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$90 = $m_s_None$();
  if ((!((x$89 !== null) && x$89.e(x$90)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "truecolor", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.v7);
  }
  var x$91 = v.uL;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$92 = $m_s_None$();
  if ((!((x$91 !== null) && x$91.e(x$92)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "URL", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.uL);
  }
  var x$93 = v.rx;
  $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$();
  var x$94 = $m_sci_Map$EmptyMap$();
  if ((!((x$93 !== null) && x$93.e(x$94)))) {
    var this$194 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "extraAttrs", new $c_Lupickle_implicits_Writers$$anon$20($m_Lupickle_default$().I, $m_Lupickle_default$().I, this$194), v.rx);
  }
});
$p.jW = (function(v) {
  return this.aPL(v);
});
$p.d0 = (function(out, v) {
  return this.bch(out, v);
});
$p.k4 = (function(ctx, v) {
  this.bcI(ctx, v);
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$$anon$10 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$$anon$10, "org.jpablo.graphexplorer.viewer.backends.graphviz.vizjs.simplegraph.SimpleGraph$$anon$10", ({
  xr: 1,
  B: 1,
  E: 1,
  af: 1,
  ah: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$$anon$8() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$$anon$8.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$$anon$8;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$$anon$8() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$$anon$8.prototype = $p;
$p.Xc = (function(x) {
  return ((x instanceof $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject$Node) || false);
});
$p.Wi = (function(x, default$1) {
  return ((x instanceof $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject$Node) ? x.BU : default$1.i(x));
});
$p.aM = (function(x) {
  return this.Xc(x);
});
$p.aC = (function(x, default$1) {
  return this.Wi(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$$anon$8 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$$anon$8, "org.jpablo.graphexplorer.viewer.backends.graphviz.vizjs.simplegraph.SimpleGraph$$anon$8", ({
  xs: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphCluster$$anon$5(WritersVersionSpecific_this$10, outer) {
  this.aU5 = null;
  this.aU5 = WritersVersionSpecific_this$10;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphCluster$$anon$5.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphCluster$$anon$5;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphCluster$$anon$5() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphCluster$$anon$5.prototype = $p;
$p.cT = (function() {
  return false;
});
$p.cW = (function() {
  return this;
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aPM = (function(v) {
  var x = v.q7;
  var x$2 = $m_s_None$();
  var $x_31 = ((x !== null) && x.e(x$2));
  var x$3 = v.s0;
  var x$4 = $m_s_None$();
  var $x_30 = ((x$3 !== null) && x$3.e(x$4));
  var x$5 = v.q6;
  var x$6 = $m_s_None$();
  var $x_29 = ((x$5 !== null) && x$5.e(x$6));
  var x$7 = v.q8;
  var x$8 = $m_s_None$();
  var $x_28 = ((x$7 !== null) && x$7.e(x$8));
  var x$9 = v.rY;
  var x$10 = $m_s_None$();
  var $x_27 = ((x$9 !== null) && x$9.e(x$10));
  var x$11 = v.rZ;
  var x$12 = $m_s_None$();
  var $x_26 = ((x$11 !== null) && x$11.e(x$12));
  var x$13 = v.rX;
  var x$14 = $m_s_None$();
  var $x_25 = ((x$13 !== null) && x$13.e(x$14));
  var x$15 = v.rT;
  var x$16 = $m_s_None$();
  var $x_24 = ((x$15 !== null) && x$15.e(x$16));
  var x$17 = v.s8;
  var x$18 = $m_s_None$();
  var $x_23 = ((x$17 !== null) && x$17.e(x$18));
  var x$19 = v.s9;
  var x$20 = $m_s_None$();
  var $x_22 = ((x$19 !== null) && x$19.e(x$20));
  var x$21 = v.rQ;
  var x$22 = $m_s_None$();
  var $x_21 = ((x$21 !== null) && x$21.e(x$22));
  var x$23 = v.rW;
  var x$24 = $m_s_None$();
  var $x_20 = ((x$23 !== null) && x$23.e(x$24));
  var x$25 = v.sd;
  var x$26 = $m_s_None$();
  var $x_19 = ((x$25 !== null) && x$25.e(x$26));
  var x$27 = v.s1;
  var x$28 = $m_s_None$();
  var $x_18 = ((x$27 !== null) && x$27.e(x$28));
  var x$29 = v.s2;
  var x$30 = $m_s_None$();
  var $x_17 = ((x$29 !== null) && x$29.e(x$30));
  var x$31 = v.s3;
  var x$32 = $m_s_None$();
  var $x_16 = ((x$31 !== null) && x$31.e(x$32));
  var x$33 = v.s4;
  var x$34 = $m_s_None$();
  var $x_15 = ((x$33 !== null) && x$33.e(x$34));
  var x$35 = v.s5;
  var x$36 = $m_s_None$();
  var $x_14 = ((x$35 !== null) && x$35.e(x$36));
  var x$37 = v.v9;
  var x$38 = $m_s_None$();
  var $x_13 = ((x$37 !== null) && x$37.e(x$38));
  var x$39 = v.s6;
  var x$40 = $m_s_None$();
  var $x_12 = ((x$39 !== null) && x$39.e(x$40));
  var x$41 = v.sc;
  var x$42 = $m_s_None$();
  var $x_11 = ((x$41 !== null) && x$41.e(x$42));
  var x$43 = v.s7;
  var x$44 = $m_s_None$();
  var $x_10 = ((x$43 !== null) && x$43.e(x$44));
  var x$45 = v.rS;
  var x$46 = $m_s_None$();
  var $x_9 = ((x$45 !== null) && x$45.e(x$46));
  var x$47 = v.va;
  var x$48 = $m_s_None$();
  var $x_8 = ((x$47 !== null) && x$47.e(x$48));
  var x$49 = v.sa;
  var x$50 = $m_s_None$();
  var $x_7 = ((x$49 !== null) && x$49.e(x$50));
  var x$51 = v.sb;
  var x$52 = $m_s_None$();
  var $x_6 = ((x$51 !== null) && x$51.e(x$52));
  var x$53 = v.se;
  var x$54 = $m_s_None$();
  var $x_5 = ((x$53 !== null) && x$53.e(x$54));
  var x$55 = v.sf;
  var x$56 = $m_s_None$();
  var $x_4 = ((x$55 !== null) && x$55.e(x$56));
  var x$57 = v.rP;
  var x$58 = $m_s_None$();
  var $x_3 = ((x$57 !== null) && x$57.e(x$58));
  var x$59 = v.rR;
  var x$60 = $m_s_None$();
  var $x_2 = ((x$59 !== null) && x$59.e(x$60));
  var x$61 = v.rU;
  var x$62 = $m_s_None$();
  var $x_1 = ((x$61 !== null) && x$61.e(x$62));
  var x$63 = v.rV;
  var x$64 = $m_sci_Map$EmptyMap$();
  return ((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((2 + ((!$x_31) | 0)) | 0) + ((!$x_30) | 0)) | 0) + ((!$x_29) | 0)) | 0) + ((!$x_28) | 0)) | 0) + ((!$x_27) | 0)) | 0) + ((!$x_26) | 0)) | 0) + ((!$x_25) | 0)) | 0) + ((!$x_24) | 0)) | 0) + ((!$x_23) | 0)) | 0) + ((!$x_22) | 0)) | 0) + ((!$x_21) | 0)) | 0) + ((!$x_20) | 0)) | 0) + ((!$x_19) | 0)) | 0) + ((!$x_18) | 0)) | 0) + ((!$x_17) | 0)) | 0) + ((!$x_16) | 0)) | 0) + ((!$x_15) | 0)) | 0) + ((!$x_14) | 0)) | 0) + ((!$x_13) | 0)) | 0) + ((!$x_12) | 0)) | 0) + ((!$x_11) | 0)) | 0) + ((!$x_10) | 0)) | 0) + ((!$x_9) | 0)) | 0) + ((!$x_8) | 0)) | 0) + ((!$x_7) | 0)) | 0) + ((!$x_6) | 0)) | 0) + ((!$x_5) | 0)) | 0) + ((!$x_4) | 0)) | 0) + ((!$x_3) | 0)) | 0) + ((!$x_2) | 0)) | 0) + ((!$x_1) | 0)) | 0) + ((!((x$63 !== null) && x$63.e(x$64))) | 0)) | 0);
});
$p.bci = (function(out, v) {
  if ((v === null)) {
    return out.c8((-1));
  } else {
    var ctx = out.bQ(this.aPM(v), true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "_gvid", $m_Lupickle_default$().hB, v.v8);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "name", $m_Lupickle_default$().I, v.p1);
    var x = v.q7;
    var x$2 = $m_s_None$();
    if ((!((x !== null) && x.e(x$2)))) {
      var $x_1 = $m_Lupickle_default$();
      var this$6 = $m_Lupickle_default$();
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "nodes", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($x_1, new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().hB, this$6)), v.q7);
    }
    var x$3 = v.s0;
    var x$4 = $m_s_None$();
    if ((!((x$3 !== null) && x$3.e(x$4)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "label", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.s0);
    }
    var x$5 = v.q6;
    var x$6 = $m_s_None$();
    if ((!((x$5 !== null) && x$5.e(x$6)))) {
      var $x_2 = $m_Lupickle_default$();
      var this$15 = $m_Lupickle_default$();
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "edges", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($x_2, new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().hB, this$15)), v.q6);
    }
    var x$7 = v.q8;
    var x$8 = $m_s_None$();
    if ((!((x$7 !== null) && x$7.e(x$8)))) {
      var $x_3 = $m_Lupickle_default$();
      var this$20 = $m_Lupickle_default$();
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "subgraphs", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($x_3, new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().hB, this$20)), v.q8);
    }
    var x$9 = v.rY;
    var x$10 = $m_s_None$();
    if ((!((x$9 !== null) && x$9.e(x$10)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "fontname", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rY);
    }
    var x$11 = v.rZ;
    var x$12 = $m_s_None$();
    if ((!((x$11 !== null) && x$11.e(x$12)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "fontsize", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rZ);
    }
    var x$13 = v.rX;
    var x$14 = $m_s_None$();
    if ((!((x$13 !== null) && x$13.e(x$14)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "fontcolor", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rX);
    }
    var x$15 = v.rT;
    var x$16 = $m_s_None$();
    if ((!((x$15 !== null) && x$15.e(x$16)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "color", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rT);
    }
    var x$17 = v.s8;
    var x$18 = $m_s_None$();
    if ((!((x$17 !== null) && x$17.e(x$18)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "pencolor", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.s8);
    }
    var x$19 = v.s9;
    var x$20 = $m_s_None$();
    if ((!((x$19 !== null) && x$19.e(x$20)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "penwidth", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.s9);
    }
    var x$21 = v.rQ;
    var x$22 = $m_s_None$();
    if ((!((x$21 !== null) && x$21.e(x$22)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "bgcolor", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rQ);
    }
    var x$23 = v.rW;
    var x$24 = $m_s_None$();
    if ((!((x$23 !== null) && x$23.e(x$24)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "fillcolor", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rW);
    }
    var x$25 = v.sd;
    var x$26 = $m_s_None$();
    if ((!((x$25 !== null) && x$25.e(x$26)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "style", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sd);
    }
    var x$27 = v.s1;
    var x$28 = $m_s_None$();
    if ((!((x$27 !== null) && x$27.e(x$28)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "labeljust", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.s1);
    }
    var x$29 = v.s2;
    var x$30 = $m_s_None$();
    if ((!((x$29 !== null) && x$29.e(x$30)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "labelloc", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.s2);
    }
    var x$31 = v.s3;
    var x$32 = $m_s_None$();
    if ((!((x$31 !== null) && x$31.e(x$32)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "lheight", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.s3);
    }
    var x$33 = v.s4;
    var x$34 = $m_s_None$();
    if ((!((x$33 !== null) && x$33.e(x$34)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "lp", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.s4);
    }
    var x$35 = v.s5;
    var x$36 = $m_s_None$();
    if ((!((x$35 !== null) && x$35.e(x$36)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "lwidth", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.s5);
    }
    var x$37 = v.v9;
    var x$38 = $m_s_None$();
    if ((!((x$37 !== null) && x$37.e(x$38)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "layout", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.v9);
    }
    var x$39 = v.s6;
    var x$40 = $m_s_None$();
    if ((!((x$39 !== null) && x$39.e(x$40)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "normalize", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.s6);
    }
    var x$41 = v.sc;
    var x$42 = $m_s_None$();
    if ((!((x$41 !== null) && x$41.e(x$42)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "start", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sc);
    }
    var x$43 = v.s7;
    var x$44 = $m_s_None$();
    if ((!((x$43 !== null) && x$43.e(x$44)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "overlap", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.s7);
    }
    var x$45 = v.rS;
    var x$46 = $m_s_None$();
    if ((!((x$45 !== null) && x$45.e(x$46)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "cluster", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rS);
    }
    var x$47 = v.va;
    var x$48 = $m_s_None$();
    if ((!((x$47 !== null) && x$47.e(x$48)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rankdir", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.va);
    }
    var x$49 = v.sa;
    var x$50 = $m_s_None$();
    if ((!((x$49 !== null) && x$49.e(x$50)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rank", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sa);
    }
    var x$51 = v.sb;
    var x$52 = $m_s_None$();
    if ((!((x$51 !== null) && x$51.e(x$52)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "splines", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sb);
    }
    var x$53 = v.se;
    var x$54 = $m_s_None$();
    if ((!((x$53 !== null) && x$53.e(x$54)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "target", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.se);
    }
    var x$55 = v.sf;
    var x$56 = $m_s_None$();
    if ((!((x$55 !== null) && x$55.e(x$56)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tooltip", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sf);
    }
    var x$57 = v.rP;
    var x$58 = $m_s_None$();
    if ((!((x$57 !== null) && x$57.e(x$58)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "URL", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rP);
    }
    var x$59 = v.rR;
    var x$60 = $m_s_None$();
    if ((!((x$59 !== null) && x$59.e(x$60)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "class", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rR);
    }
    var x$61 = v.rU;
    var x$62 = $m_s_None$();
    if ((!((x$61 !== null) && x$61.e(x$62)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "colorscheme", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rU);
    }
    var x$63 = v.rV;
    var x$64 = $m_sci_Map$EmptyMap$();
    if ((!((x$63 !== null) && x$63.e(x$64)))) {
      var this$134 = $m_Lupickle_default$();
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "extraAttrs", new $c_Lupickle_implicits_Writers$$anon$20($m_Lupickle_default$().I, $m_Lupickle_default$().I, this$134), v.rV);
    }
    return ctx.bV((-1));
  }
});
$p.bcJ = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "_gvid", $m_Lupickle_default$().hB, v.v8);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "name", $m_Lupickle_default$().I, v.p1);
  var x = v.q7;
  var x$2 = $m_s_None$();
  if ((!((x !== null) && x.e(x$2)))) {
    var $x_1 = $m_Lupickle_default$();
    var this$6 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "nodes", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($x_1, new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().hB, this$6)), v.q7);
  }
  var x$3 = v.s0;
  var x$4 = $m_s_None$();
  if ((!((x$3 !== null) && x$3.e(x$4)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "label", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.s0);
  }
  var x$5 = v.q6;
  var x$6 = $m_s_None$();
  if ((!((x$5 !== null) && x$5.e(x$6)))) {
    var $x_2 = $m_Lupickle_default$();
    var this$15 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "edges", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($x_2, new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().hB, this$15)), v.q6);
  }
  var x$7 = v.q8;
  var x$8 = $m_s_None$();
  if ((!((x$7 !== null) && x$7.e(x$8)))) {
    var $x_3 = $m_Lupickle_default$();
    var this$20 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "subgraphs", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($x_3, new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().hB, this$20)), v.q8);
  }
  var x$9 = v.rY;
  var x$10 = $m_s_None$();
  if ((!((x$9 !== null) && x$9.e(x$10)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "fontname", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rY);
  }
  var x$11 = v.rZ;
  var x$12 = $m_s_None$();
  if ((!((x$11 !== null) && x$11.e(x$12)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "fontsize", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rZ);
  }
  var x$13 = v.rX;
  var x$14 = $m_s_None$();
  if ((!((x$13 !== null) && x$13.e(x$14)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "fontcolor", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rX);
  }
  var x$15 = v.rT;
  var x$16 = $m_s_None$();
  if ((!((x$15 !== null) && x$15.e(x$16)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "color", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rT);
  }
  var x$17 = v.s8;
  var x$18 = $m_s_None$();
  if ((!((x$17 !== null) && x$17.e(x$18)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "pencolor", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.s8);
  }
  var x$19 = v.s9;
  var x$20 = $m_s_None$();
  if ((!((x$19 !== null) && x$19.e(x$20)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "penwidth", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.s9);
  }
  var x$21 = v.rQ;
  var x$22 = $m_s_None$();
  if ((!((x$21 !== null) && x$21.e(x$22)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "bgcolor", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rQ);
  }
  var x$23 = v.rW;
  var x$24 = $m_s_None$();
  if ((!((x$23 !== null) && x$23.e(x$24)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "fillcolor", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rW);
  }
  var x$25 = v.sd;
  var x$26 = $m_s_None$();
  if ((!((x$25 !== null) && x$25.e(x$26)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "style", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sd);
  }
  var x$27 = v.s1;
  var x$28 = $m_s_None$();
  if ((!((x$27 !== null) && x$27.e(x$28)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "labeljust", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.s1);
  }
  var x$29 = v.s2;
  var x$30 = $m_s_None$();
  if ((!((x$29 !== null) && x$29.e(x$30)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "labelloc", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.s2);
  }
  var x$31 = v.s3;
  var x$32 = $m_s_None$();
  if ((!((x$31 !== null) && x$31.e(x$32)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "lheight", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.s3);
  }
  var x$33 = v.s4;
  var x$34 = $m_s_None$();
  if ((!((x$33 !== null) && x$33.e(x$34)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "lp", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.s4);
  }
  var x$35 = v.s5;
  var x$36 = $m_s_None$();
  if ((!((x$35 !== null) && x$35.e(x$36)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "lwidth", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.s5);
  }
  var x$37 = v.v9;
  var x$38 = $m_s_None$();
  if ((!((x$37 !== null) && x$37.e(x$38)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "layout", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.v9);
  }
  var x$39 = v.s6;
  var x$40 = $m_s_None$();
  if ((!((x$39 !== null) && x$39.e(x$40)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "normalize", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.s6);
  }
  var x$41 = v.sc;
  var x$42 = $m_s_None$();
  if ((!((x$41 !== null) && x$41.e(x$42)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "start", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sc);
  }
  var x$43 = v.s7;
  var x$44 = $m_s_None$();
  if ((!((x$43 !== null) && x$43.e(x$44)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "overlap", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.s7);
  }
  var x$45 = v.rS;
  var x$46 = $m_s_None$();
  if ((!((x$45 !== null) && x$45.e(x$46)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "cluster", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rS);
  }
  var x$47 = v.va;
  var x$48 = $m_s_None$();
  if ((!((x$47 !== null) && x$47.e(x$48)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rankdir", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.va);
  }
  var x$49 = v.sa;
  var x$50 = $m_s_None$();
  if ((!((x$49 !== null) && x$49.e(x$50)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rank", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sa);
  }
  var x$51 = v.sb;
  var x$52 = $m_s_None$();
  if ((!((x$51 !== null) && x$51.e(x$52)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "splines", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sb);
  }
  var x$53 = v.se;
  var x$54 = $m_s_None$();
  if ((!((x$53 !== null) && x$53.e(x$54)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "target", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.se);
  }
  var x$55 = v.sf;
  var x$56 = $m_s_None$();
  if ((!((x$55 !== null) && x$55.e(x$56)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tooltip", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sf);
  }
  var x$57 = v.rP;
  var x$58 = $m_s_None$();
  if ((!((x$57 !== null) && x$57.e(x$58)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "URL", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rP);
  }
  var x$59 = v.rR;
  var x$60 = $m_s_None$();
  if ((!((x$59 !== null) && x$59.e(x$60)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "class", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rR);
  }
  var x$61 = v.rU;
  var x$62 = $m_s_None$();
  if ((!((x$61 !== null) && x$61.e(x$62)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "colorscheme", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.rU);
  }
  var x$63 = v.rV;
  var x$64 = $m_sci_Map$EmptyMap$();
  if ((!((x$63 !== null) && x$63.e(x$64)))) {
    var this$134 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "extraAttrs", new $c_Lupickle_implicits_Writers$$anon$20($m_Lupickle_default$().I, $m_Lupickle_default$().I, this$134), v.rV);
  }
});
$p.jW = (function(v) {
  return this.aPM(v);
});
$p.d0 = (function(out, v) {
  return this.bci(out, v);
});
$p.k4 = (function(ctx, v) {
  this.bcJ(ctx, v);
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphCluster$$anon$5 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphCluster$$anon$5, "org.jpablo.graphexplorer.viewer.backends.graphviz.vizjs.simplegraph.SimpleGraphCluster$$anon$5", ({
  xw: 1,
  B: 1,
  E: 1,
  af: 1,
  ah: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge$$anon$7(WritersVersionSpecific_this$11, outer) {
  this.aU6 = null;
  this.aU6 = WritersVersionSpecific_this$11;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge$$anon$7.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge$$anon$7;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge$$anon$7() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge$$anon$7.prototype = $p;
$p.cT = (function() {
  return false;
});
$p.cW = (function() {
  return this;
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aPN = (function(v) {
  var x = v.qc;
  var x$2 = $m_s_None$();
  var $x_36 = ((x !== null) && x.e(x$2));
  var x$3 = v.qb;
  var x$4 = $m_s_None$();
  var $x_35 = ((x$3 !== null) && x$3.e(x$4));
  var x$5 = v.ss;
  var x$6 = $m_s_None$();
  var $x_34 = ((x$5 !== null) && x$5.e(x$6));
  var x$7 = v.sp;
  var x$8 = $m_s_None$();
  var $x_33 = ((x$7 !== null) && x$7.e(x$8));
  var x$9 = v.sq;
  var x$10 = $m_s_None$();
  var $x_32 = ((x$9 !== null) && x$9.e(x$10));
  var x$11 = v.sk;
  var x$12 = $m_s_None$();
  var $x_31 = ((x$11 !== null) && x$11.e(x$12));
  var x$13 = v.sB;
  var x$14 = $m_s_None$();
  var $x_30 = ((x$13 !== null) && x$13.e(x$14));
  var x$15 = v.sF;
  var x$16 = $m_s_None$();
  var $x_29 = ((x$15 !== null) && x$15.e(x$16));
  var x$17 = v.sz;
  var x$18 = $m_s_None$();
  var $x_28 = ((x$17 !== null) && x$17.e(x$18));
  var x$19 = v.sy;
  var x$20 = $m_s_None$();
  var $x_27 = ((x$19 !== null) && x$19.e(x$20));
  var x$21 = v.sm;
  var x$22 = $m_s_None$();
  var $x_26 = ((x$21 !== null) && x$21.e(x$22));
  var x$23 = v.sr;
  var x$24 = $m_s_None$();
  var $x_25 = ((x$23 !== null) && x$23.e(x$24));
  var x$25 = v.qa;
  var x$26 = $m_s_None$();
  var $x_24 = ((x$25 !== null) && x$25.e(x$26));
  var x$27 = v.qe;
  var x$28 = $m_s_None$();
  var $x_23 = ((x$27 !== null) && x$27.e(x$28));
  var x$29 = v.sg;
  var x$30 = $m_s_None$();
  var $x_22 = ((x$29 !== null) && x$29.e(x$30));
  var x$31 = v.si;
  var x$32 = $m_s_None$();
  var $x_21 = ((x$31 !== null) && x$31.e(x$32));
  var x$33 = v.sh;
  var x$34 = $m_s_None$();
  var $x_20 = ((x$33 !== null) && x$33.e(x$34));
  var x$35 = v.sn;
  var x$36 = $m_s_None$();
  var $x_19 = ((x$35 !== null) && x$35.e(x$36));
  var x$37 = v.sj;
  var x$38 = $m_s_None$();
  var $x_18 = ((x$37 !== null) && x$37.e(x$38));
  var x$39 = v.sl;
  var x$40 = $m_s_None$();
  var $x_17 = ((x$39 !== null) && x$39.e(x$40));
  var x$41 = v.sx;
  var x$42 = $m_s_None$();
  var $x_16 = ((x$41 !== null) && x$41.e(x$42));
  var x$43 = v.sA;
  var x$44 = $m_s_None$();
  var $x_15 = ((x$43 !== null) && x$43.e(x$44));
  var x$45 = v.sC;
  var x$46 = $m_s_None$();
  var $x_14 = ((x$45 !== null) && x$45.e(x$46));
  var x$47 = v.sD;
  var x$48 = $m_s_None$();
  var $x_13 = ((x$47 !== null) && x$47.e(x$48));
  var x$49 = v.sE;
  var x$50 = $m_s_None$();
  var $x_12 = ((x$49 !== null) && x$49.e(x$50));
  var x$51 = v.sH;
  var x$52 = $m_s_None$();
  var $x_11 = ((x$51 !== null) && x$51.e(x$52));
  var x$53 = v.sI;
  var x$54 = $m_s_None$();
  var $x_10 = ((x$53 !== null) && x$53.e(x$54));
  var x$55 = v.sL;
  var x$56 = $m_s_None$();
  var $x_9 = ((x$55 !== null) && x$55.e(x$56));
  var x$57 = v.sM;
  var x$58 = $m_s_None$();
  var $x_8 = ((x$57 !== null) && x$57.e(x$58));
  var x$59 = v.st;
  var x$60 = $m_s_None$();
  var $x_7 = ((x$59 !== null) && x$59.e(x$60));
  var x$61 = v.su;
  var x$62 = $m_s_None$();
  var $x_6 = ((x$61 !== null) && x$61.e(x$62));
  var x$63 = v.sv;
  var x$64 = $m_s_None$();
  var $x_5 = ((x$63 !== null) && x$63.e(x$64));
  var x$65 = v.sw;
  var x$66 = $m_s_None$();
  var $x_4 = ((x$65 !== null) && x$65.e(x$66));
  var x$67 = v.sJ;
  var x$68 = $m_s_None$();
  var $x_3 = ((x$67 !== null) && x$67.e(x$68));
  var x$69 = v.sK;
  var x$70 = $m_s_None$();
  var $x_2 = ((x$69 !== null) && x$69.e(x$70));
  var x$71 = v.sG;
  var x$72 = $m_s_None$();
  var $x_1 = ((x$71 !== null) && x$71.e(x$72));
  var x$73 = v.so;
  var x$74 = $m_sci_Map$EmptyMap$();
  return ((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((3 + ((!$x_36) | 0)) | 0) + ((!$x_35) | 0)) | 0) + ((!$x_34) | 0)) | 0) + ((!$x_33) | 0)) | 0) + ((!$x_32) | 0)) | 0) + ((!$x_31) | 0)) | 0) + ((!$x_30) | 0)) | 0) + ((!$x_29) | 0)) | 0) + ((!$x_28) | 0)) | 0) + ((!$x_27) | 0)) | 0) + ((!$x_26) | 0)) | 0) + ((!$x_25) | 0)) | 0) + ((!$x_24) | 0)) | 0) + ((!$x_23) | 0)) | 0) + ((!$x_22) | 0)) | 0) + ((!$x_21) | 0)) | 0) + ((!$x_20) | 0)) | 0) + ((!$x_19) | 0)) | 0) + ((!$x_18) | 0)) | 0) + ((!$x_17) | 0)) | 0) + ((!$x_16) | 0)) | 0) + ((!$x_15) | 0)) | 0) + ((!$x_14) | 0)) | 0) + ((!$x_13) | 0)) | 0) + ((!$x_12) | 0)) | 0) + ((!$x_11) | 0)) | 0) + ((!$x_10) | 0)) | 0) + ((!$x_9) | 0)) | 0) + ((!$x_8) | 0)) | 0) + ((!$x_7) | 0)) | 0) + ((!$x_6) | 0)) | 0) + ((!$x_5) | 0)) | 0) + ((!$x_4) | 0)) | 0) + ((!$x_3) | 0)) | 0) + ((!$x_2) | 0)) | 0) + ((!$x_1) | 0)) | 0) + ((!((x$73 !== null) && x$73.e(x$74))) | 0)) | 0);
});
$p.bcj = (function(out, v) {
  if ((v === null)) {
    return out.c8((-1));
  } else {
    var ctx = out.bQ(this.aPN(v), true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "_gvid", $m_Lupickle_default$().hB, v.vb);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tail", $m_Lupickle_default$().hB, v.qd);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "head", $m_Lupickle_default$().hB, v.q9);
    var x = v.qc;
    var x$2 = $m_s_None$();
    if ((!((x !== null) && x.e(x$2)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "pos", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.qc);
    }
    var x$3 = v.qb;
    var x$4 = $m_s_None$();
    if ((!((x$3 !== null) && x$3.e(x$4)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.qb);
    }
    var x$5 = v.ss;
    var x$6 = $m_s_None$();
    if ((!((x$5 !== null) && x$5.e(x$6)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "label", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.ss);
    }
    var x$7 = v.sp;
    var x$8 = $m_s_None$();
    if ((!((x$7 !== null) && x$7.e(x$8)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "fontname", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sp);
    }
    var x$9 = v.sq;
    var x$10 = $m_s_None$();
    if ((!((x$9 !== null) && x$9.e(x$10)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "fontsize", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sq);
    }
    var x$11 = v.sk;
    var x$12 = $m_s_None$();
    if ((!((x$11 !== null) && x$11.e(x$12)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "color", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sk);
    }
    var x$13 = v.sB;
    var x$14 = $m_s_None$();
    if ((!((x$13 !== null) && x$13.e(x$14)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "penwidth", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sB);
    }
    var x$15 = v.sF;
    var x$16 = $m_s_None$();
    if ((!((x$15 !== null) && x$15.e(x$16)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "style", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sF);
    }
    var x$17 = v.sz;
    var x$18 = $m_s_None$();
    if ((!((x$17 !== null) && x$17.e(x$18)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "lp", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sz);
    }
    var x$19 = v.sy;
    var x$20 = $m_s_None$();
    if ((!((x$19 !== null) && x$19.e(x$20)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "len", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sy);
    }
    var x$21 = v.sm;
    var x$22 = $m_s_None$();
    if ((!((x$21 !== null) && x$21.e(x$22)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "constraint", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sm);
    }
    var x$23 = v.sr;
    var x$24 = $m_s_None$();
    if ((!((x$23 !== null) && x$23.e(x$24)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "forcelabels", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sr);
    }
    var x$25 = v.qa;
    var x$26 = $m_s_None$();
    if ((!((x$25 !== null) && x$25.e(x$26)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "headport", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.qa);
    }
    var x$27 = v.qe;
    var x$28 = $m_s_None$();
    if ((!((x$27 !== null) && x$27.e(x$28)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tailport", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.qe);
    }
    var x$29 = v.sg;
    var x$30 = $m_s_None$();
    if ((!((x$29 !== null) && x$29.e(x$30)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "arrowhead", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sg);
    }
    var x$31 = v.si;
    var x$32 = $m_s_None$();
    if ((!((x$31 !== null) && x$31.e(x$32)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "arrowtail", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.si);
    }
    var x$33 = v.sh;
    var x$34 = $m_s_None$();
    if ((!((x$33 !== null) && x$33.e(x$34)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "arrowsize", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sh);
    }
    var x$35 = v.sn;
    var x$36 = $m_s_None$();
    if ((!((x$35 !== null) && x$35.e(x$36)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "dir", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sn);
    }
    var x$37 = v.sj;
    var x$38 = $m_s_None$();
    if ((!((x$37 !== null) && x$37.e(x$38)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "class", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sj);
    }
    var x$39 = v.sl;
    var x$40 = $m_s_None$();
    if ((!((x$39 !== null) && x$39.e(x$40)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "colorscheme", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sl);
    }
    var x$41 = v.sx;
    var x$42 = $m_s_None$();
    if ((!((x$41 !== null) && x$41.e(x$42)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "layer", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sx);
    }
    var x$43 = v.sA;
    var x$44 = $m_s_None$();
    if ((!((x$43 !== null) && x$43.e(x$44)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "nojustify", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sA);
    }
    var x$45 = v.sC;
    var x$46 = $m_s_None$();
    if ((!((x$45 !== null) && x$45.e(x$46)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "samehead", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sC);
    }
    var x$47 = v.sD;
    var x$48 = $m_s_None$();
    if ((!((x$47 !== null) && x$47.e(x$48)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "sametail", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sD);
    }
    var x$49 = v.sE;
    var x$50 = $m_s_None$();
    if ((!((x$49 !== null) && x$49.e(x$50)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "showboxes", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sE);
    }
    var x$51 = v.sH;
    var x$52 = $m_s_None$();
    if ((!((x$51 !== null) && x$51.e(x$52)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tail_lp", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sH);
    }
    var x$53 = v.sI;
    var x$54 = $m_s_None$();
    if ((!((x$53 !== null) && x$53.e(x$54)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tailclip", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sI);
    }
    var x$55 = v.sL;
    var x$56 = $m_s_None$();
    if ((!((x$55 !== null) && x$55.e(x$56)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "target", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sL);
    }
    var x$57 = v.sM;
    var x$58 = $m_s_None$();
    if ((!((x$57 !== null) && x$57.e(x$58)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tooltip", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sM);
    }
    var x$59 = v.st;
    var x$60 = $m_s_None$();
    if ((!((x$59 !== null) && x$59.e(x$60)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "labeldistance", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.st);
    }
    var x$61 = v.su;
    var x$62 = $m_s_None$();
    if ((!((x$61 !== null) && x$61.e(x$62)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "labelfloat", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.su);
    }
    var x$63 = v.sv;
    var x$64 = $m_s_None$();
    if ((!((x$63 !== null) && x$63.e(x$64)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "labelfontcolor", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sv);
    }
    var x$65 = v.sw;
    var x$66 = $m_s_None$();
    if ((!((x$65 !== null) && x$65.e(x$66)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "labelfontname", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sw);
    }
    var x$67 = v.sJ;
    var x$68 = $m_s_None$();
    if ((!((x$67 !== null) && x$67.e(x$68)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tailtarget", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sJ);
    }
    var x$69 = v.sK;
    var x$70 = $m_s_None$();
    if ((!((x$69 !== null) && x$69.e(x$70)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tailtooltip", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sK);
    }
    var x$71 = v.sG;
    var x$72 = $m_s_None$();
    if ((!((x$71 !== null) && x$71.e(x$72)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tailURL", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sG);
    }
    var x$73 = v.so;
    var x$74 = $m_sci_Map$EmptyMap$();
    if ((!((x$73 !== null) && x$73.e(x$74)))) {
      var this$152 = $m_Lupickle_default$();
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "extraAttrs", new $c_Lupickle_implicits_Writers$$anon$20($m_Lupickle_default$().I, $m_Lupickle_default$().I, this$152), v.so);
    }
    return ctx.bV((-1));
  }
});
$p.bcK = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "_gvid", $m_Lupickle_default$().hB, v.vb);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tail", $m_Lupickle_default$().hB, v.qd);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "head", $m_Lupickle_default$().hB, v.q9);
  var x = v.qc;
  var x$2 = $m_s_None$();
  if ((!((x !== null) && x.e(x$2)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "pos", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.qc);
  }
  var x$3 = v.qb;
  var x$4 = $m_s_None$();
  if ((!((x$3 !== null) && x$3.e(x$4)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.qb);
  }
  var x$5 = v.ss;
  var x$6 = $m_s_None$();
  if ((!((x$5 !== null) && x$5.e(x$6)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "label", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.ss);
  }
  var x$7 = v.sp;
  var x$8 = $m_s_None$();
  if ((!((x$7 !== null) && x$7.e(x$8)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "fontname", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sp);
  }
  var x$9 = v.sq;
  var x$10 = $m_s_None$();
  if ((!((x$9 !== null) && x$9.e(x$10)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "fontsize", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sq);
  }
  var x$11 = v.sk;
  var x$12 = $m_s_None$();
  if ((!((x$11 !== null) && x$11.e(x$12)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "color", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sk);
  }
  var x$13 = v.sB;
  var x$14 = $m_s_None$();
  if ((!((x$13 !== null) && x$13.e(x$14)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "penwidth", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sB);
  }
  var x$15 = v.sF;
  var x$16 = $m_s_None$();
  if ((!((x$15 !== null) && x$15.e(x$16)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "style", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sF);
  }
  var x$17 = v.sz;
  var x$18 = $m_s_None$();
  if ((!((x$17 !== null) && x$17.e(x$18)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "lp", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sz);
  }
  var x$19 = v.sy;
  var x$20 = $m_s_None$();
  if ((!((x$19 !== null) && x$19.e(x$20)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "len", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sy);
  }
  var x$21 = v.sm;
  var x$22 = $m_s_None$();
  if ((!((x$21 !== null) && x$21.e(x$22)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "constraint", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sm);
  }
  var x$23 = v.sr;
  var x$24 = $m_s_None$();
  if ((!((x$23 !== null) && x$23.e(x$24)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "forcelabels", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sr);
  }
  var x$25 = v.qa;
  var x$26 = $m_s_None$();
  if ((!((x$25 !== null) && x$25.e(x$26)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "headport", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.qa);
  }
  var x$27 = v.qe;
  var x$28 = $m_s_None$();
  if ((!((x$27 !== null) && x$27.e(x$28)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tailport", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.qe);
  }
  var x$29 = v.sg;
  var x$30 = $m_s_None$();
  if ((!((x$29 !== null) && x$29.e(x$30)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "arrowhead", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sg);
  }
  var x$31 = v.si;
  var x$32 = $m_s_None$();
  if ((!((x$31 !== null) && x$31.e(x$32)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "arrowtail", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.si);
  }
  var x$33 = v.sh;
  var x$34 = $m_s_None$();
  if ((!((x$33 !== null) && x$33.e(x$34)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "arrowsize", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sh);
  }
  var x$35 = v.sn;
  var x$36 = $m_s_None$();
  if ((!((x$35 !== null) && x$35.e(x$36)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "dir", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sn);
  }
  var x$37 = v.sj;
  var x$38 = $m_s_None$();
  if ((!((x$37 !== null) && x$37.e(x$38)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "class", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sj);
  }
  var x$39 = v.sl;
  var x$40 = $m_s_None$();
  if ((!((x$39 !== null) && x$39.e(x$40)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "colorscheme", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sl);
  }
  var x$41 = v.sx;
  var x$42 = $m_s_None$();
  if ((!((x$41 !== null) && x$41.e(x$42)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "layer", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sx);
  }
  var x$43 = v.sA;
  var x$44 = $m_s_None$();
  if ((!((x$43 !== null) && x$43.e(x$44)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "nojustify", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sA);
  }
  var x$45 = v.sC;
  var x$46 = $m_s_None$();
  if ((!((x$45 !== null) && x$45.e(x$46)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "samehead", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sC);
  }
  var x$47 = v.sD;
  var x$48 = $m_s_None$();
  if ((!((x$47 !== null) && x$47.e(x$48)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "sametail", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sD);
  }
  var x$49 = v.sE;
  var x$50 = $m_s_None$();
  if ((!((x$49 !== null) && x$49.e(x$50)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "showboxes", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sE);
  }
  var x$51 = v.sH;
  var x$52 = $m_s_None$();
  if ((!((x$51 !== null) && x$51.e(x$52)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tail_lp", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sH);
  }
  var x$53 = v.sI;
  var x$54 = $m_s_None$();
  if ((!((x$53 !== null) && x$53.e(x$54)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tailclip", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sI);
  }
  var x$55 = v.sL;
  var x$56 = $m_s_None$();
  if ((!((x$55 !== null) && x$55.e(x$56)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "target", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sL);
  }
  var x$57 = v.sM;
  var x$58 = $m_s_None$();
  if ((!((x$57 !== null) && x$57.e(x$58)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tooltip", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sM);
  }
  var x$59 = v.st;
  var x$60 = $m_s_None$();
  if ((!((x$59 !== null) && x$59.e(x$60)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "labeldistance", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.st);
  }
  var x$61 = v.su;
  var x$62 = $m_s_None$();
  if ((!((x$61 !== null) && x$61.e(x$62)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "labelfloat", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.su);
  }
  var x$63 = v.sv;
  var x$64 = $m_s_None$();
  if ((!((x$63 !== null) && x$63.e(x$64)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "labelfontcolor", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sv);
  }
  var x$65 = v.sw;
  var x$66 = $m_s_None$();
  if ((!((x$65 !== null) && x$65.e(x$66)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "labelfontname", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sw);
  }
  var x$67 = v.sJ;
  var x$68 = $m_s_None$();
  if ((!((x$67 !== null) && x$67.e(x$68)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tailtarget", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sJ);
  }
  var x$69 = v.sK;
  var x$70 = $m_s_None$();
  if ((!((x$69 !== null) && x$69.e(x$70)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tailtooltip", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sK);
  }
  var x$71 = v.sG;
  var x$72 = $m_s_None$();
  if ((!((x$71 !== null) && x$71.e(x$72)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tailURL", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sG);
  }
  var x$73 = v.so;
  var x$74 = $m_sci_Map$EmptyMap$();
  if ((!((x$73 !== null) && x$73.e(x$74)))) {
    var this$152 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "extraAttrs", new $c_Lupickle_implicits_Writers$$anon$20($m_Lupickle_default$().I, $m_Lupickle_default$().I, this$152), v.so);
  }
});
$p.jW = (function(v) {
  return this.aPN(v);
});
$p.d0 = (function(out, v) {
  return this.bcj(out, v);
});
$p.k4 = (function(ctx, v) {
  this.bcK(ctx, v);
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge$$anon$7 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge$$anon$7, "org.jpablo.graphexplorer.viewer.backends.graphviz.vizjs.simplegraph.SimpleGraphEdge$$anon$7", ({
  xz: 1,
  B: 1,
  E: 1,
  af: 1,
  ah: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphNode$$anon$3(WritersVersionSpecific_this$9, outer) {
  this.aU7 = null;
  this.aU7 = WritersVersionSpecific_this$9;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphNode$$anon$3.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphNode$$anon$3;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphNode$$anon$3() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphNode$$anon$3.prototype = $p;
$p.cT = (function() {
  return false;
});
$p.cW = (function() {
  return this;
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aPO = (function(v) {
  var x = v.qg;
  var x$2 = $m_s_None$();
  var $x_29 = ((x !== null) && x.e(x$2));
  var x$3 = v.qf;
  var x$4 = $m_s_None$();
  var $x_28 = ((x$3 !== null) && x$3.e(x$4));
  var x$5 = v.qh;
  var x$6 = $m_s_None$();
  var $x_27 = ((x$5 !== null) && x$5.e(x$6));
  var x$7 = v.t8;
  var x$8 = $m_s_None$();
  var $x_26 = ((x$7 !== null) && x$7.e(x$8));
  var x$9 = v.sW;
  var x$10 = $m_s_None$();
  var $x_25 = ((x$9 !== null) && x$9.e(x$10));
  var x$11 = v.sX;
  var x$12 = $m_s_None$();
  var $x_24 = ((x$11 !== null) && x$11.e(x$12));
  var x$13 = v.sV;
  var x$14 = $m_s_None$();
  var $x_23 = ((x$13 !== null) && x$13.e(x$14));
  var x$15 = v.sQ;
  var x$16 = $m_s_None$();
  var $x_22 = ((x$15 !== null) && x$15.e(x$16));
  var x$17 = v.sT;
  var x$18 = $m_s_None$();
  var $x_21 = ((x$17 !== null) && x$17.e(x$18));
  var x$19 = v.ta;
  var x$20 = $m_s_None$();
  var $x_20 = ((x$19 !== null) && x$19.e(x$20));
  var x$21 = v.t4;
  var x$22 = $m_s_None$();
  var $x_19 = ((x$21 !== null) && x$21.e(x$22));
  var x$23 = v.t6;
  var x$24 = $m_s_None$();
  var $x_18 = ((x$23 !== null) && x$23.e(x$24));
  var x$25 = v.t9;
  var x$26 = $m_s_None$();
  var $x_17 = ((x$25 !== null) && x$25.e(x$26));
  var x$27 = v.t5;
  var x$28 = $m_s_None$();
  var $x_16 = ((x$27 !== null) && x$27.e(x$28));
  var x$29 = v.sU;
  var x$30 = $m_s_None$();
  var $x_15 = ((x$29 !== null) && x$29.e(x$30));
  var x$31 = v.t7;
  var x$32 = $m_s_None$();
  var $x_14 = ((x$31 !== null) && x$31.e(x$32));
  var x$33 = v.t3;
  var x$34 = $m_s_None$();
  var $x_13 = ((x$33 !== null) && x$33.e(x$34));
  var x$35 = v.sN;
  var x$36 = $m_s_None$();
  var $x_12 = ((x$35 !== null) && x$35.e(x$36));
  var x$37 = v.sO;
  var x$38 = $m_s_None$();
  var $x_11 = ((x$37 !== null) && x$37.e(x$38));
  var x$39 = v.sP;
  var x$40 = $m_s_None$();
  var $x_10 = ((x$39 !== null) && x$39.e(x$40));
  var x$41 = v.sR;
  var x$42 = $m_s_None$();
  var $x_9 = ((x$41 !== null) && x$41.e(x$42));
  var x$43 = v.tb;
  var x$44 = $m_s_None$();
  var $x_8 = ((x$43 !== null) && x$43.e(x$44));
  var x$45 = v.tc;
  var x$46 = $m_s_None$();
  var $x_7 = ((x$45 !== null) && x$45.e(x$46));
  var x$47 = v.td;
  var x$48 = $m_s_None$();
  var $x_6 = ((x$47 !== null) && x$47.e(x$48));
  var x$49 = v.sY;
  var x$50 = $m_s_None$();
  var $x_5 = ((x$49 !== null) && x$49.e(x$50));
  var x$51 = v.sZ;
  var x$52 = $m_s_None$();
  var $x_4 = ((x$51 !== null) && x$51.e(x$52));
  var x$53 = v.t0;
  var x$54 = $m_s_None$();
  var $x_3 = ((x$53 !== null) && x$53.e(x$54));
  var x$55 = v.t1;
  var x$56 = $m_s_None$();
  var $x_2 = ((x$55 !== null) && x$55.e(x$56));
  var x$57 = v.t2;
  var x$58 = $m_s_None$();
  var $x_1 = ((x$57 !== null) && x$57.e(x$58));
  var x$59 = v.sS;
  var x$60 = $m_sci_Map$EmptyMap$();
  return ((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((3 + ((!$x_29) | 0)) | 0) + ((!$x_28) | 0)) | 0) + ((!$x_27) | 0)) | 0) + ((!$x_26) | 0)) | 0) + ((!$x_25) | 0)) | 0) + ((!$x_24) | 0)) | 0) + ((!$x_23) | 0)) | 0) + ((!$x_22) | 0)) | 0) + ((!$x_21) | 0)) | 0) + ((!$x_20) | 0)) | 0) + ((!$x_19) | 0)) | 0) + ((!$x_18) | 0)) | 0) + ((!$x_17) | 0)) | 0) + ((!$x_16) | 0)) | 0) + ((!$x_15) | 0)) | 0) + ((!$x_14) | 0)) | 0) + ((!$x_13) | 0)) | 0) + ((!$x_12) | 0)) | 0) + ((!$x_11) | 0)) | 0) + ((!$x_10) | 0)) | 0) + ((!$x_9) | 0)) | 0) + ((!$x_8) | 0)) | 0) + ((!$x_7) | 0)) | 0) + ((!$x_6) | 0)) | 0) + ((!$x_5) | 0)) | 0) + ((!$x_4) | 0)) | 0) + ((!$x_3) | 0)) | 0) + ((!$x_2) | 0)) | 0) + ((!$x_1) | 0)) | 0) + ((!((x$59 !== null) && x$59.e(x$60))) | 0)) | 0);
});
$p.bck = (function(out, v) {
  if ((v === null)) {
    return out.c8((-1));
  } else {
    var ctx = out.bQ(this.aPO(v), true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "_gvid", $m_Lupickle_default$().hB, v.vc);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "name", $m_Lupickle_default$().I, v.p2);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "label", $m_Lupickle_default$().I, v.zg);
    var x = v.qg;
    var x$2 = $m_s_None$();
    if ((!((x !== null) && x.e(x$2)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "pos", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.qg);
    }
    var x$3 = v.qf;
    var x$4 = $m_s_None$();
    if ((!((x$3 !== null) && x$3.e(x$4)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "height", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.qf);
    }
    var x$5 = v.qh;
    var x$6 = $m_s_None$();
    if ((!((x$5 !== null) && x$5.e(x$6)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "width", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.qh);
    }
    var x$7 = v.t8;
    var x$8 = $m_s_None$();
    if ((!((x$7 !== null) && x$7.e(x$8)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "shape", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.t8);
    }
    var x$9 = v.sW;
    var x$10 = $m_s_None$();
    if ((!((x$9 !== null) && x$9.e(x$10)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "fontname", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sW);
    }
    var x$11 = v.sX;
    var x$12 = $m_s_None$();
    if ((!((x$11 !== null) && x$11.e(x$12)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "fontsize", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sX);
    }
    var x$13 = v.sV;
    var x$14 = $m_s_None$();
    if ((!((x$13 !== null) && x$13.e(x$14)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "fontcolor", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sV);
    }
    var x$15 = v.sQ;
    var x$16 = $m_s_None$();
    if ((!((x$15 !== null) && x$15.e(x$16)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "color", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sQ);
    }
    var x$17 = v.sT;
    var x$18 = $m_s_None$();
    if ((!((x$17 !== null) && x$17.e(x$18)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "fillcolor", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sT);
    }
    var x$19 = v.ta;
    var x$20 = $m_s_None$();
    if ((!((x$19 !== null) && x$19.e(x$20)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "style", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.ta);
    }
    var x$21 = v.t4;
    var x$22 = $m_s_None$();
    if ((!((x$21 !== null) && x$21.e(x$22)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "penwidth", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.t4);
    }
    var x$23 = v.t6;
    var x$24 = $m_s_None$();
    if ((!((x$23 !== null) && x$23.e(x$24)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rects", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.t6);
    }
    var x$25 = v.t9;
    var x$26 = $m_s_None$();
    if ((!((x$25 !== null) && x$25.e(x$26)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "sides", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.t9);
    }
    var x$27 = v.t5;
    var x$28 = $m_s_None$();
    if ((!((x$27 !== null) && x$27.e(x$28)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "peripheries", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.t5);
    }
    var x$29 = v.sU;
    var x$30 = $m_s_None$();
    if ((!((x$29 !== null) && x$29.e(x$30)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "fixedsize", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sU);
    }
    var x$31 = v.t7;
    var x$32 = $m_s_None$();
    if ((!((x$31 !== null) && x$31.e(x$32)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "regular", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.t7);
    }
    var x$33 = v.t3;
    var x$34 = $m_s_None$();
    if ((!((x$33 !== null) && x$33.e(x$34)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "orientation", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.t3);
    }
    var x$35 = v.sN;
    var x$36 = $m_s_None$();
    if ((!((x$35 !== null) && x$35.e(x$36)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "URL", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sN);
    }
    var x$37 = v.sO;
    var x$38 = $m_s_None$();
    if ((!((x$37 !== null) && x$37.e(x$38)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "area", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sO);
    }
    var x$39 = v.sP;
    var x$40 = $m_s_None$();
    if ((!((x$39 !== null) && x$39.e(x$40)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "class", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sP);
    }
    var x$41 = v.sR;
    var x$42 = $m_s_None$();
    if ((!((x$41 !== null) && x$41.e(x$42)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "colorscheme", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sR);
    }
    var x$43 = v.tb;
    var x$44 = $m_s_None$();
    if ((!((x$43 !== null) && x$43.e(x$44)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "target", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.tb);
    }
    var x$45 = v.tc;
    var x$46 = $m_s_None$();
    if ((!((x$45 !== null) && x$45.e(x$46)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tooltip", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.tc);
    }
    var x$47 = v.td;
    var x$48 = $m_s_None$();
    if ((!((x$47 !== null) && x$47.e(x$48)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "vertices", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.td);
    }
    var x$49 = v.sY;
    var x$50 = $m_s_None$();
    if ((!((x$49 !== null) && x$49.e(x$50)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "image", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sY);
    }
    var x$51 = v.sZ;
    var x$52 = $m_s_None$();
    if ((!((x$51 !== null) && x$51.e(x$52)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "imagepath", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sZ);
    }
    var x$53 = v.t0;
    var x$54 = $m_s_None$();
    if ((!((x$53 !== null) && x$53.e(x$54)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "imagepos", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.t0);
    }
    var x$55 = v.t1;
    var x$56 = $m_s_None$();
    if ((!((x$55 !== null) && x$55.e(x$56)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "margin", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.t1);
    }
    var x$57 = v.t2;
    var x$58 = $m_s_None$();
    if ((!((x$57 !== null) && x$57.e(x$58)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "nojustify", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.t2);
    }
    var x$59 = v.sS;
    var x$60 = $m_sci_Map$EmptyMap$();
    if ((!((x$59 !== null) && x$59.e(x$60)))) {
      var this$124 = $m_Lupickle_default$();
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "extraAttrs", new $c_Lupickle_implicits_Writers$$anon$20($m_Lupickle_default$().I, $m_Lupickle_default$().I, this$124), v.sS);
    }
    return ctx.bV((-1));
  }
});
$p.bcL = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "_gvid", $m_Lupickle_default$().hB, v.vc);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "name", $m_Lupickle_default$().I, v.p2);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "label", $m_Lupickle_default$().I, v.zg);
  var x = v.qg;
  var x$2 = $m_s_None$();
  if ((!((x !== null) && x.e(x$2)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "pos", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.qg);
  }
  var x$3 = v.qf;
  var x$4 = $m_s_None$();
  if ((!((x$3 !== null) && x$3.e(x$4)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "height", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.qf);
  }
  var x$5 = v.qh;
  var x$6 = $m_s_None$();
  if ((!((x$5 !== null) && x$5.e(x$6)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "width", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.qh);
  }
  var x$7 = v.t8;
  var x$8 = $m_s_None$();
  if ((!((x$7 !== null) && x$7.e(x$8)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "shape", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.t8);
  }
  var x$9 = v.sW;
  var x$10 = $m_s_None$();
  if ((!((x$9 !== null) && x$9.e(x$10)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "fontname", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sW);
  }
  var x$11 = v.sX;
  var x$12 = $m_s_None$();
  if ((!((x$11 !== null) && x$11.e(x$12)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "fontsize", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sX);
  }
  var x$13 = v.sV;
  var x$14 = $m_s_None$();
  if ((!((x$13 !== null) && x$13.e(x$14)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "fontcolor", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sV);
  }
  var x$15 = v.sQ;
  var x$16 = $m_s_None$();
  if ((!((x$15 !== null) && x$15.e(x$16)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "color", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sQ);
  }
  var x$17 = v.sT;
  var x$18 = $m_s_None$();
  if ((!((x$17 !== null) && x$17.e(x$18)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "fillcolor", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sT);
  }
  var x$19 = v.ta;
  var x$20 = $m_s_None$();
  if ((!((x$19 !== null) && x$19.e(x$20)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "style", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.ta);
  }
  var x$21 = v.t4;
  var x$22 = $m_s_None$();
  if ((!((x$21 !== null) && x$21.e(x$22)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "penwidth", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.t4);
  }
  var x$23 = v.t6;
  var x$24 = $m_s_None$();
  if ((!((x$23 !== null) && x$23.e(x$24)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rects", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.t6);
  }
  var x$25 = v.t9;
  var x$26 = $m_s_None$();
  if ((!((x$25 !== null) && x$25.e(x$26)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "sides", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.t9);
  }
  var x$27 = v.t5;
  var x$28 = $m_s_None$();
  if ((!((x$27 !== null) && x$27.e(x$28)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "peripheries", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.t5);
  }
  var x$29 = v.sU;
  var x$30 = $m_s_None$();
  if ((!((x$29 !== null) && x$29.e(x$30)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "fixedsize", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sU);
  }
  var x$31 = v.t7;
  var x$32 = $m_s_None$();
  if ((!((x$31 !== null) && x$31.e(x$32)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "regular", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.t7);
  }
  var x$33 = v.t3;
  var x$34 = $m_s_None$();
  if ((!((x$33 !== null) && x$33.e(x$34)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "orientation", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.t3);
  }
  var x$35 = v.sN;
  var x$36 = $m_s_None$();
  if ((!((x$35 !== null) && x$35.e(x$36)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "URL", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sN);
  }
  var x$37 = v.sO;
  var x$38 = $m_s_None$();
  if ((!((x$37 !== null) && x$37.e(x$38)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "area", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sO);
  }
  var x$39 = v.sP;
  var x$40 = $m_s_None$();
  if ((!((x$39 !== null) && x$39.e(x$40)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "class", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sP);
  }
  var x$41 = v.sR;
  var x$42 = $m_s_None$();
  if ((!((x$41 !== null) && x$41.e(x$42)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "colorscheme", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sR);
  }
  var x$43 = v.tb;
  var x$44 = $m_s_None$();
  if ((!((x$43 !== null) && x$43.e(x$44)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "target", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.tb);
  }
  var x$45 = v.tc;
  var x$46 = $m_s_None$();
  if ((!((x$45 !== null) && x$45.e(x$46)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tooltip", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.tc);
  }
  var x$47 = v.td;
  var x$48 = $m_s_None$();
  if ((!((x$47 !== null) && x$47.e(x$48)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "vertices", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.td);
  }
  var x$49 = v.sY;
  var x$50 = $m_s_None$();
  if ((!((x$49 !== null) && x$49.e(x$50)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "image", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sY);
  }
  var x$51 = v.sZ;
  var x$52 = $m_s_None$();
  if ((!((x$51 !== null) && x$51.e(x$52)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "imagepath", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.sZ);
  }
  var x$53 = v.t0;
  var x$54 = $m_s_None$();
  if ((!((x$53 !== null) && x$53.e(x$54)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "imagepos", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.t0);
  }
  var x$55 = v.t1;
  var x$56 = $m_s_None$();
  if ((!((x$55 !== null) && x$55.e(x$56)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "margin", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.t1);
  }
  var x$57 = v.t2;
  var x$58 = $m_s_None$();
  if ((!((x$57 !== null) && x$57.e(x$58)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "nojustify", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.t2);
  }
  var x$59 = v.sS;
  var x$60 = $m_sci_Map$EmptyMap$();
  if ((!((x$59 !== null) && x$59.e(x$60)))) {
    var this$124 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "extraAttrs", new $c_Lupickle_implicits_Writers$$anon$20($m_Lupickle_default$().I, $m_Lupickle_default$().I, this$124), v.sS);
  }
});
$p.jW = (function(v) {
  return this.aPO(v);
});
$p.d0 = (function(out, v) {
  return this.bck(out, v);
});
$p.k4 = (function(ctx, v) {
  this.bcL(ctx, v);
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphNode$$anon$3 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphNode$$anon$3, "org.jpablo.graphexplorer.viewer.backends.graphviz.vizjs.simplegraph.SimpleGraphNode$$anon$3", ({
  xC: 1,
  B: 1,
  E: 1,
  af: 1,
  ah: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ToViewerGraph$package$$anon$1() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ToViewerGraph$package$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ToViewerGraph$package$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ToViewerGraph$package$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ToViewerGraph$package$$anon$1.prototype = $p;
$p.Xc = (function(x) {
  return ((x instanceof $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject$Cluster) || false);
});
$p.Wi = (function(x, default$1) {
  return ((x instanceof $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject$Cluster) ? x.FU : default$1.i(x));
});
$p.aM = (function(x) {
  return this.Xc(x);
});
$p.aC = (function(x, default$1) {
  return this.Wi(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ToViewerGraph$package$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_ToViewerGraph$package$$anon$1, "org.jpablo.graphexplorer.viewer.backends.graphviz.vizjs.simplegraph.ToViewerGraph$package$$anon$1", ({
  xF: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_package$$anon$1() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_package$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_package$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_package$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_package$$anon$1.prototype = $p;
$p.Xc = (function(x) {
  return ((x instanceof $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject$Node) || false);
});
$p.Wi = (function(x, default$1) {
  if ((x instanceof $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject$Node)) {
    var x8 = x.BU;
    return new $c_T2(x8.vc, x8.p2);
  } else {
    return default$1.i(x);
  }
});
$p.aM = (function(x) {
  return this.Xc(x);
});
$p.aC = (function(x, default$1) {
  return this.Wi(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_package$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_package$$anon$1, "org.jpablo.graphexplorer.viewer.backends.graphviz.vizjs.simplegraph.package$$anon$1", ({
  xH: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$1() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$1.prototype = $p;
$p.bu = (function(x) {
  if ((x !== null)) {
    if ((x.g() instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId)) {
      x.h();
      return true;
    }
  }
  return false;
});
$p.bt = (function(x, default$1) {
  if ((x !== null)) {
    var x6 = x.g();
    if ((x6 instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId)) {
      return new $c_T2(x.h(), x6);
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.bu(x);
});
$p.aC = (function(x, default$1) {
  return this.bt(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$1, "org.jpablo.graphexplorer.viewer.backends.mermaid.FromViewerGraph$package$$anon$1", ({
  xK: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$2(rootGroupId$6, graph$8) {
  this.a8I = null;
  this.a8H = null;
  this.a8I = rootGroupId$6;
  this.a8H = graph$8;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$2.prototype = $p;
$p.bu = (function(x) {
  if ((x !== null)) {
    if ((x.g() instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId)) {
      var parentId = x.h();
      var x$3 = this.a8I;
      if (((!((parentId === null) ? (x$3 === null) : parentId.e(x$3))) && this.a8H.hu.E(parentId))) {
        return true;
      }
    }
  }
  return false;
});
$p.bt = (function(x, default$1) {
  if ((x !== null)) {
    var x14 = x.g();
    if ((x14 instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId)) {
      var parentId = x.h();
      var x$3 = this.a8I;
      if (((!((parentId === null) ? (x$3 === null) : parentId.e(x$3))) && this.a8H.hu.E(parentId))) {
        return new $c_T2(parentId, x14);
      }
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.bu(x);
});
$p.aC = (function(x, default$1) {
  return this.bt(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$2, "org.jpablo.graphexplorer.viewer.backends.mermaid.FromViewerGraph$package$$anon$2", ({
  xL: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$3() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$3.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$3;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$3() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$3.prototype = $p;
$p.bu = (function(x) {
  if ((x !== null)) {
    var attrId = ((x.g() === null) ? null : x.g().fY);
    x.h();
    var prefix = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$().BV;
    if ((!(!attrId.startsWith(prefix)))) {
      return true;
    }
  }
  return false;
});
$p.bt = (function(x, default$1) {
  if ((x !== null)) {
    var attrId = ((x.g() === null) ? null : x.g().fY);
    var value = x.h();
    var prefix = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$().BV;
    if ((!(!attrId.startsWith(prefix)))) {
      return new $c_T2($m_sc_StringOps$().wg(attrId, $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$().BV), value.m());
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.bu(x);
});
$p.aC = (function(x, default$1) {
  return this.bt(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$3 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$3, "org.jpablo.graphexplorer.viewer.backends.mermaid.FromViewerGraph$package$$anon$3", ({
  xM: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$4() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$4.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$4;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$4() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$4.prototype = $p;
$p.bu = (function(x) {
  if ((x !== null)) {
    var attrId = ((x.g() === null) ? null : x.g().fY);
    x.h();
    var prefix = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$().BW;
    if ((!(!attrId.startsWith(prefix)))) {
      return true;
    }
  }
  return false;
});
$p.bt = (function(x, default$1) {
  if ((x !== null)) {
    var attrId = ((x.g() === null) ? null : x.g().fY);
    var value = x.h();
    var prefix = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$().BW;
    if ((!(!attrId.startsWith(prefix)))) {
      return new $c_T2($m_sc_StringOps$().wg(attrId, $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$().BW), value.m());
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.bu(x);
});
$p.aC = (function(x, default$1) {
  return this.bt(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$4 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$4, "org.jpablo.graphexplorer.viewer.backends.mermaid.FromViewerGraph$package$$anon$4", ({
  xN: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$5() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$5.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$5;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$5() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$5.prototype = $p;
$p.r2 = (function(x) {
  return ((x === "dashed") || ((x === "dotted") || false));
});
$p.qR = (function(x, default$1) {
  return ((x === "dashed") ? "6 4" : ((x === "dotted") ? "2 2" : default$1.i(x)));
});
$p.aM = (function(x) {
  return this.r2(x);
});
$p.aC = (function(x, default$1) {
  return this.qR(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$5 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$5, "org.jpablo.graphexplorer.viewer.backends.mermaid.FromViewerGraph$package$$anon$5", ({
  xO: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$6() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$6.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$6;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$6() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$6.prototype = $p;
$p.r2 = (function(x) {
  return ((x === "true") || false);
});
$p.qR = (function(x, default$1) {
  return ((x === "true") ? "0" : default$1.i(x));
});
$p.aM = (function(x) {
  return this.r2(x);
});
$p.aC = (function(x, default$1) {
  return this.qR(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$6 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_FromViewerGraph$package$$anon$6, "org.jpablo.graphexplorer.viewer.backends.mermaid.FromViewerGraph$package$$anon$6", ({
  xP: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$$anon$1() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$$anon$1.prototype = $p;
$p.e5 = (function(x) {
  return true;
});
$p.e2 = (function(x, default$1) {
  console.error(("[mermaid] render pipeline failed: " + x.e3()));
  return $m_s_None$();
});
$p.aM = (function(x) {
  return this.e5(x);
});
$p.aC = (function(x, default$1) {
  return this.e2(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$$anon$1, "org.jpablo.graphexplorer.viewer.backends.mermaid.MermaidBackend$$anon$1", ({
  xT: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$$anon$2() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$$anon$2.prototype = $p;
$p.J5 = (function(x) {
  return ((!(!(x instanceof SVGPathElement))) || false);
});
$p.IE = (function(x, default$1) {
  return ((!(!(x instanceof SVGPathElement))) ? x : default$1.i(x));
});
$p.aM = (function(x) {
  return this.J5(x);
});
$p.aC = (function(x, default$1) {
  return this.IE(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$$anon$2, "org.jpablo.graphexplorer.viewer.backends.mermaid.MermaidBackend$$anon$2", ({
  xU: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$$anon$3() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$$anon$3.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$$anon$3;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$$anon$3() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$$anon$3.prototype = $p;
$p.e5 = (function(x) {
  return true;
});
$p.e2 = (function(x, default$1) {
  return (void 0);
});
$p.aM = (function(x) {
  return this.e5(x);
});
$p.aC = (function(x, default$1) {
  return this.e2(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$$anon$3 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$$anon$3, "org.jpablo.graphexplorer.viewer.backends.mermaid.MermaidBackend$$anon$3", ({
  xV: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$$anon$4() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$$anon$4.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$$anon$4;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$$anon$4() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$$anon$4.prototype = $p;
$p.e5 = (function(x) {
  return true;
});
$p.e2 = (function(x, default$1) {
  return (void 0);
});
$p.aM = (function(x) {
  return this.e5(x);
});
$p.aC = (function(x, default$1) {
  return this.e2(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$$anon$4 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$$anon$4, "org.jpablo.graphexplorer.viewer.backends.mermaid.MermaidBackend$$anon$4", ({
  xW: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$$anon$5(target$2) {
  this.a8N = null;
  this.a8N = target$2;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$$anon$5.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$$anon$5;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$$anon$5() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$$anon$5.prototype = $p;
$p.bu = (function(x) {
  if ((x !== null)) {
    var declKey = x.g();
    x.h();
    if ((declKey === this.a8N)) {
      return true;
    }
  }
  return false;
});
$p.bt = (function(x, default$1) {
  if ((x !== null)) {
    var declKey = x.g();
    var value = x.h();
    if ((declKey === this.a8N)) {
      return value;
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.bu(x);
});
$p.aC = (function(x, default$1) {
  return this.bt(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$$anon$5 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidBackend$$anon$5, "org.jpablo.graphexplorer.viewer.backends.mermaid.MermaidBackend$$anon$5", ({
  xX: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidEdgeLabelFallback$$anon$1() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidEdgeLabelFallback$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidEdgeLabelFallback$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidEdgeLabelFallback$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidEdgeLabelFallback$$anon$1.prototype = $p;
$p.b3f = (function(x) {
  if ((x !== null)) {
    if ((x.c3 !== "")) {
      return true;
    }
  }
  return false;
});
$p.aXF = (function(x, default$1) {
  if ((x !== null)) {
    var s = x.bH;
    var t = x.bU;
    var label = x.c3;
    if ((label !== "")) {
      return new $c_T3(s, t, new $c_s_Some(label));
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.b3f(x);
});
$p.aC = (function(x, default$1) {
  return this.aXF(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidEdgeLabelFallback$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidEdgeLabelFallback$$anon$1, "org.jpablo.graphexplorer.viewer.backends.mermaid.MermaidEdgeLabelFallback$$anon$1", ({
  y2: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$$anon$1(header$3) {
  this.a8O = null;
  this.a8O = header$3;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$$anon$1.prototype = $p;
$p.bu = (function(x) {
  if ((x !== null)) {
    var prefix = x.g();
    x.h();
    if ($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$().aQM(this.a8O, prefix)) {
      return true;
    }
  }
  return false;
});
$p.bt = (function(x, default$1) {
  if ((x !== null)) {
    var prefix = x.g();
    var kind = x.h();
    if ($m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$().aQM(this.a8O, prefix)) {
      return kind;
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.bu(x);
});
$p.aC = (function(x, default$1) {
  return this.bt(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$$anon$1, "org.jpablo.graphexplorer.viewer.backends.mermaid.MermaidSourceScan$$anon$1", ({
  y6: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$$anon$2() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$$anon$2.prototype = $p;
$p.r2 = (function(x) {
  return ((!(!x.startsWith("title:"))) || false);
});
$p.qR = (function(x, default$1) {
  return ((!(!x.startsWith("title:"))) ? $f_T__trim__T($m_sc_StringOps$().kp(x, 6)) : default$1.i(x));
});
$p.aM = (function(x) {
  return this.r2(x);
});
$p.aC = (function(x, default$1) {
  return this.qR(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$$anon$2, "org.jpablo.graphexplorer.viewer.backends.mermaid.MermaidSourceScan$$anon$2", ({
  y7: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$$anon$3() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$$anon$3.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$$anon$3;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$$anon$3() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$$anon$3.prototype = $p;
$p.r2 = (function(x) {
  return ((!(!x.startsWith("title "))) || false);
});
$p.qR = (function(x, default$1) {
  return ((!(!x.startsWith("title "))) ? $f_T__trim__T($m_sc_StringOps$().kp(x, 6)) : default$1.i(x));
});
$p.aM = (function(x) {
  return this.r2(x);
});
$p.aC = (function(x, default$1) {
  return this.qR(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$$anon$3 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidSourceScan$$anon$3, "org.jpablo.graphexplorer.viewer.backends.mermaid.MermaidSourceScan$$anon$3", ({
  y8: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidVertexLabelFallback$$anon$1() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidVertexLabelFallback$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidVertexLabelFallback$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidVertexLabelFallback$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidVertexLabelFallback$$anon$1.prototype = $p;
$p.bu = (function(x) {
  if ((x !== null)) {
    if ((x.h() !== "")) {
      return true;
    }
  }
  return false;
});
$p.bt = (function(x, default$1) {
  if ((x !== null)) {
    if ((x.h() !== "")) {
      return x;
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.bu(x);
});
$p.aC = (function(x, default$1) {
  return this.bt(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidVertexLabelFallback$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidVertexLabelFallback$$anon$1, "org.jpablo.graphexplorer.viewer.backends.mermaid.MermaidVertexLabelFallback$$anon$1", ({
  yb: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat() {
}
$h_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName() {
}
$h_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
var $d_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName = new $TypeData().i(0, "org.jpablo.graphexplorer.viewer.color.TailWindColors$ColorName", ({
  hI: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_CmdAction() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_CmdAction.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_CmdAction;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_CmdAction() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_CmdAction.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.aNU = (function(a) {
  if ((this instanceof $c_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$NoArg)) {
    this.SG.a3();
    return (void 0);
  }
  if ((this instanceof $c_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$OneArg)) {
    var x18 = this.SH;
    if ((a instanceof $c_s_Some)) {
      var v = a.J;
      x18.i(v);
      return (void 0);
    }
  }
  throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "argument required");
});
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_Commands$$anon$4(outer) {
  this.awg = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.awg = outer;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_Commands$$anon$4.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_Commands$$anon$4;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_Commands$$anon$4() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_Commands$$anon$4.prototype = $p;
$p.b3a = (function(x) {
  if ((x !== null)) {
    var x44 = x.x4;
    if ((x44 instanceof $c_s_Some)) {
      return true;
    }
  }
  return false;
});
$p.aXA = (function(x, default$1) {
  if ((x !== null)) {
    var x53 = x.x4;
    if ((x53 instanceof $c_s_Some)) {
      var sh = x53.J;
      return new $c_T2(this.awg.aQN(sh), x);
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.b3a(x);
});
$p.aC = (function(x, default$1) {
  return this.aXA(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_Commands$$anon$4 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_Commands$$anon$4, "org.jpablo.graphexplorer.viewer.components.Commands$$anon$4", ({
  ys: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_Shortcut$$anon$1() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_Shortcut$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_Shortcut$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_Shortcut$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_Shortcut$$anon$1.prototype = $p;
$p.bu = (function(x) {
  if ((x !== null)) {
    x.g();
    if ((!(!x.h()))) {
      return true;
    }
  }
  return false;
});
$p.bt = (function(x, default$1) {
  if ((x !== null)) {
    var str = x.g();
    if ((!(!x.h()))) {
      return str;
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.bu(x);
});
$p.aC = (function(x, default$1) {
  return this.bt(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_Shortcut$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_Shortcut$$anon$1, "org.jpablo.graphexplorer.viewer.components.Shortcut$$anon$1", ({
  yK: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute(attrId, label, placeholder, inputType, inputVar, options, default$1, validLayouts, hidden, singleRow, missingRowOption, unit, triggerGlyph) {
  this.da = null;
  this.cF = null;
  this.d3 = null;
  this.cJ = null;
  this.cl = null;
  this.j6 = null;
  this.dg = null;
  this.dq = null;
  this.hd = null;
  this.dp = false;
  this.eH = null;
  this.dh = null;
  this.eI = null;
  this.da = attrId;
  this.cF = label;
  this.d3 = placeholder;
  this.cJ = inputType;
  this.cl = inputVar;
  this.j6 = options;
  this.dg = default$1;
  this.dq = validLayouts;
  this.hd = hidden;
  this.dp = singleRow;
  this.eH = missingRowOption;
  this.dh = unit;
  this.eI = triggerGlyph;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 2018140690);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId(this.da)));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.cF));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.d3));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.cJ));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.cl));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.j6));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.dg));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.dq));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.hd));
  acc = $m_sr_Statics$().k(acc, (this.dp ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.eH));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.dh));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.eI));
  return $m_sr_Statics$().Z(acc, 13);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute)) {
    if (((((this.dp === x$0.dp) && (this.da === x$0.da)) && (this.cF === x$0.cF)) && (this.d3 === x$0.d3))) {
      var x = this.cJ;
      var x$2 = x$0.cJ;
      var $x_8 = ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$3 = this.cl;
      var x$4 = x$0.cl;
      var $x_7 = ((x$3 === null) ? (x$4 === null) : (x$3 === x$4));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$5 = this.j6;
      var x$6 = x$0.j6;
      var $x_6 = ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$7 = this.dg;
      var x$8 = x$0.dg;
      var $x_5 = ((x$7 === null) ? (x$8 === null) : (x$7 === x$8));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$9 = this.dq;
      var x$10 = x$0.dq;
      var $x_4 = ((x$9 === null) ? (x$10 === null) : x$9.e(x$10));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$11 = this.hd;
      var x$12 = x$0.hd;
      var $x_3 = ((x$11 === null) ? (x$12 === null) : (x$11 === x$12));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$13 = this.eH;
      var x$14 = x$0.eH;
      var $x_2 = ((x$13 === null) ? (x$14 === null) : x$13.e(x$14));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$15 = this.dh;
      var x$16 = x$0.dh;
      var $x_1 = ((x$15 === null) ? (x$16 === null) : x$15.e(x$16));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$17 = this.eI;
      var x$18 = x$0.eI;
      return ((x$17 === null) ? (x$18 === null) : x$17.e(x$18));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 13;
});
$p.B = (function() {
  return "InputAttribute";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributeId(this.da);
      break;
    }
    case 1: {
      return this.cF;
      break;
    }
    case 2: {
      return this.d3;
      break;
    }
    case 3: {
      return this.cJ;
      break;
    }
    case 4: {
      return this.cl;
      break;
    }
    case 5: {
      return this.j6;
      break;
    }
    case 6: {
      return this.dg;
      break;
    }
    case 7: {
      return this.dq;
      break;
    }
    case 8: {
      return this.hd;
      break;
    }
    case 9: {
      return this.dp;
      break;
    }
    case 10: {
      return this.eH;
      break;
    }
    case 11: {
      return this.dh;
      break;
    }
    case 12: {
      return this.eI;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "attrId";
      break;
    }
    case 1: {
      return "label";
      break;
    }
    case 2: {
      return "placeholder";
      break;
    }
    case 3: {
      return "inputType";
      break;
    }
    case 4: {
      return "inputVar";
      break;
    }
    case 5: {
      return "options";
      break;
    }
    case 6: {
      return "default";
      break;
    }
    case 7: {
      return "validLayouts";
      break;
    }
    case 8: {
      return "hidden";
      break;
    }
    case 9: {
      return "singleRow";
      break;
    }
    case 10: {
      return "missingRowOption";
      break;
    }
    case 11: {
      return "unit";
      break;
    }
    case 12: {
      return "triggerGlyph";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.agr = (function() {
  return this.hd;
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hO)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute, "org.jpablo.graphexplorer.viewer.components.attributes.rows.AttributeRow$InputAttribute", ({
  hO: 1,
  bU: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputElement(element, hidden) {
  this.SM = null;
  this.SN = null;
  this.SM = element;
  this.SN = hidden;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputElement.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputElement;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputElement() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputElement.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-436229169), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputElement)) {
    var x = this.SM;
    var x$2 = x$0.SM;
    if (((x === null) ? (x$2 === null) : (x === x$2))) {
      var x$3 = this.SN;
      var x$4 = x$0.SN;
      return ((x$3 === null) ? (x$4 === null) : (x$3 === x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "InputElement";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.SM;
  }
  if ((n === 1)) {
    return this.SN;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "element";
  }
  if ((n === 1)) {
    return "hidden";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.agr = (function() {
  return this.SN;
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputElement(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hP)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputElement = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputElement, "org.jpablo.graphexplorer.viewer.components.attributes.rows.AttributeRow$InputElement", ({
  hP: 1,
  bU: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader(title, hidden) {
  this.LG = null;
  this.SO = null;
  this.LG = title;
  this.SO = hidden;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-581690036), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader)) {
    if ((this.LG === x$0.LG)) {
      var x = this.SO;
      var x$2 = x$0.SO;
      return ((x === null) ? (x$2 === null) : (x === x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "SectionHeader";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.LG;
  }
  if ((n === 1)) {
    return this.SO;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "title";
  }
  if ((n === 1)) {
    return "hidden";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.agr = (function() {
  return this.SO;
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hR)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$SectionHeader, "org.jpablo.graphexplorer.viewer.components.attributes.rows.AttributeRow$SectionHeader", ({
  hR: 1,
  bU: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_VerticalAttributesView$package$$anon$1() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_VerticalAttributesView$package$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_VerticalAttributesView$package$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_VerticalAttributesView$package$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_VerticalAttributesView$package$$anon$1.prototype = $p;
$p.b3b = (function(x) {
  return ((x instanceof $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute) || false);
});
$p.aXB = (function(x, default$1) {
  return ((x instanceof $c_Lorg_jpablo_graphexplorer_viewer_components_attributes_rows_AttributeRow$InputAttribute) ? x : default$1.i(x));
});
$p.aM = (function(x) {
  return this.b3b(x);
});
$p.aC = (function(x, default$1) {
  return this.aXB(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_VerticalAttributesView$package$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_attributes_views_VerticalAttributesView$package$$anon$1, "org.jpablo.graphexplorer.viewer.components.attributes.views.VerticalAttributesView$package$$anon$1", ({
  z7: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind = new $TypeData().i(0, "org.jpablo.graphexplorer.viewer.components.rightPanel.ElementKind", ({
  hT: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$$anon$2() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$$anon$2.prototype = $p;
$p.bu = (function(x) {
  if ((x !== null)) {
    x.g();
    if ((x.h().C() > 1)) {
      return true;
    }
  }
  return false;
});
$p.bt = (function(x, default$1) {
  if ((x !== null)) {
    var lbl = x.g();
    if ((x.h().C() > 1)) {
      return lbl;
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.bu(x);
});
$p.aC = (function(x, default$1) {
  return this.bt(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$$anon$2, "org.jpablo.graphexplorer.viewer.components.rightPanel.ElementsList$package$$anon$2", ({
  zj: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$$anon$3() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$$anon$3.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$$anon$3;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$$anon$3() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$$anon$3.prototype = $p;
$p.r3 = (function(x) {
  return ($f_Lorg_jpablo_graphexplorer_viewer_models_ElementId__isGroupId__Z(x) || false);
});
$p.qS = (function(x, default$1) {
  return ($f_Lorg_jpablo_graphexplorer_viewer_models_ElementId__isGroupId__Z(x) ? ($m_Lorg_jpablo_graphexplorer_viewer_models_GroupId$(), new $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId(x.Q9())) : default$1.i(x));
});
$p.aM = (function(x) {
  return this.r3(x);
});
$p.aC = (function(x, default$1) {
  return this.qS(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$$anon$3 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$$anon$3, "org.jpablo.graphexplorer.viewer.components.rightPanel.ElementsList$package$$anon$3", ({
  zk: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$$anon$4() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$$anon$4.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$$anon$4;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$$anon$4() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$$anon$4.prototype = $p;
$p.r3 = (function(x) {
  return ($f_Lorg_jpablo_graphexplorer_viewer_models_ElementId__isNodeId__Z(x) || false);
});
$p.qS = (function(x, default$1) {
  return ($f_Lorg_jpablo_graphexplorer_viewer_models_ElementId__isNodeId__Z(x) ? ($m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$(), new $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId(x.Q9())) : default$1.i(x));
});
$p.aM = (function(x) {
  return this.r3(x);
});
$p.aC = (function(x, default$1) {
  return this.qS(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$$anon$4 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementsList$package$$anon$4, "org.jpablo.graphexplorer.viewer.components.rightPanel.ElementsList$package$$anon$4", ({
  zl: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D$$anon$1(visible$2) {
  this.a9H = null;
  this.a9H = visible$2;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D$$anon$1.prototype = $p;
$p.bu = (function(x) {
  if ((x !== null)) {
    var x14 = x.g();
    if ((x14 instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId)) {
      var gid = x.h();
      var x$3 = $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$().p4;
      if (((!((gid === null) ? (x$3 === null) : gid.e(x$3))) && this.a9H.E(x14))) {
        return true;
      }
    }
  }
  return false;
});
$p.bt = (function(x, default$1) {
  if ((x !== null)) {
    var x18 = x.g();
    if ((x18 instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId)) {
      var gid = x.h();
      var x$3 = $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$().p4;
      if (((!((gid === null) ? (x$3 === null) : gid.e(x$3))) && this.a9H.E(x18))) {
        return new $c_T2(gid, x18);
      }
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.bu(x);
});
$p.aC = (function(x, default$1) {
  return this.bt(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D$$anon$1, "org.jpablo.graphexplorer.viewer.components.scene3d.GraphScene3D$$anon$1", ({
  zp: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D$$anon$2() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D$$anon$2.prototype = $p;
$p.Xd = (function(x) {
  return ((x instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId) || false);
});
$p.Wj = (function(x, default$1) {
  return ((x instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId) ? x : default$1.i(x));
});
$p.aM = (function(x) {
  return this.Xd(x);
});
$p.aC = (function(x, default$1) {
  return this.Wj(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_scene3d_GraphScene3D$$anon$2, "org.jpablo.graphexplorer.viewer.components.scene3d.GraphScene3D$$anon$2", ({
  zq: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_selection_ClusterElement(ref0, strat) {
  this.a9I = null;
  this.ay9 = null;
  this.a0q = null;
  this.SZ = null;
  this.ay8 = null;
  this.ay6 = null;
  this.ay7 = false;
  this.a0q = ref0;
  this.SZ = strat;
  this.a9I = ref0;
  $f_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement__$init$__V(this);
  this.ay8 = "selected";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_selection_ClusterElement.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_selection_ClusterElement;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_selection_ClusterElement() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_selection_ClusterElement.prototype = $p;
$p.dD = (function() {
  return this.a9I;
});
$p.PR = (function() {
  return this.ay9;
});
$p.ahj = (function(x$0) {
});
$p.ahi = (function(x$0) {
  this.ay9 = x$0;
});
$p.aio = (function() {
  $f_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement__unselect__V(this);
});
$p.a4E = (function() {
  $f_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement__select__V(this);
});
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 1123206579, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_components_selection_ClusterElement)) {
    if ($m_sr_BoxesRunTime$().Q(this.a0q, x$0.a0q)) {
      var x$1 = this.SZ;
      var x$2 = x$0.SZ;
      return ((x$1 === null) ? (x$2 === null) : (x$1 === x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "ClusterElement";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.a0q;
  }
  if ((n === 1)) {
    return this.SZ;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "ref0";
  }
  if ((n === 1)) {
    return "strat";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.a4F = (function() {
  return this.ay8;
});
$p.b0q = (function() {
  if ((!this.ay7)) {
    this.ay6 = this.SZ.a3k(this.a9I);
    this.ay7 = true;
  }
  return this.ay6;
});
$p.lj = (function() {
  return this.b0q();
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_components_selection_ClusterElement(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hW)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_components_selection_ClusterElement = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_selection_ClusterElement, "org.jpablo.graphexplorer.viewer.components.selection.ClusterElement", ({
  hW: 1,
  cz: 1,
  b: 1,
  c: 1,
  a: 1
}));
function $p_Lorg_jpablo_graphexplorer_viewer_components_selection_EdgeElement__toggleEdgeLabelSelection__Z__V($thiz, add) {
  var domId = $thiz.zl.id;
  if ((domId !== "")) {
    var this$3 = $m_s_Option$().as($thiz.zl.ownerSVGElement);
    if ((!this$3.c())) {
      var x0 = this$3.d();
      var inner = x0.querySelector((("g.label[data-id=\"" + CSS.escape(domId)) + "\"]"));
      if ((inner !== null)) {
        var labelGroup = inner.closest(".edgeLabel");
        if ((labelGroup !== null)) {
          if (add) {
            labelGroup.classList.add($thiz.LS);
          } else {
            labelGroup.classList.remove($thiz.LS);
          }
        }
      }
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_components_selection_EdgeElement__styleMarkerForSelection__Z__V($thiz, selected) {
  var x28 = $thiz.zl;
  if ((!(!(x28 instanceof SVGPathElement)))) {
    var this$1 = $m_s_Option$().as(x28.getAttribute("marker-end"));
    var markerEnd = ((this$1.c() || (this$1.d() !== "")) ? this$1 : $m_s_None$());
    if ((!markerEnd.c())) {
      var x0$1 = markerEnd.d();
      var markerId = $m_sc_StringOps$().wh($m_sc_StringOps$().wg(x0$1, "url(#"), ")");
      if (selected) {
        if ((!(!(!markerId.endsWith("-selected"))))) {
          var selectedMarkerId = (markerId + "-selected");
          var svgRoot = x28.ownerSVGElement;
          if ((svgRoot !== null)) {
            var originalMarker = svgRoot.querySelector(("#" + CSS.escape(markerId)));
            if ((originalMarker !== null)) {
              var markerParent = originalMarker.parentNode;
              if ((markerParent !== null)) {
                if ((svgRoot.querySelector(("#" + CSS.escape(selectedMarkerId))) === null)) {
                  var clonedMarker = originalMarker.cloneNode(true);
                  clonedMarker.setAttribute("id", selectedMarkerId);
                  var markerPath = clonedMarker.querySelector("path");
                  if ((markerPath !== null)) {
                    markerPath.setAttribute("fill", "#2c70ff");
                    markerPath.setAttribute("stroke", "#2c70ff");
                  }
                  markerParent.appendChild(clonedMarker);
                }
                x28.setAttribute("marker-end", (("url(#" + selectedMarkerId) + ")"));
                return (void 0);
              } else {
                return (void 0);
              }
            } else {
              return (void 0);
            }
          } else {
            return (void 0);
          }
        } else {
          return (void 0);
        }
      } else if ((!(!markerId.endsWith("-selected")))) {
        var originalMarkerId = $m_sc_StringOps$().wh(markerId, "-selected");
        x28.setAttribute("marker-end", (("url(#" + originalMarkerId) + ")"));
        return (void 0);
      } else {
        return (void 0);
      }
    } else {
      return (void 0);
    }
  }
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_selection_EdgeElement(ref0, strat) {
  this.zl = null;
  this.ayc = null;
  this.a0r = null;
  this.T0 = null;
  this.LS = null;
  this.aya = null;
  this.ayb = false;
  this.a0r = ref0;
  this.T0 = strat;
  this.zl = ref0;
  $f_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement__$init$__V(this);
  this.LS = "selected";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_selection_EdgeElement.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_selection_EdgeElement;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_selection_EdgeElement() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_selection_EdgeElement.prototype = $p;
$p.dD = (function() {
  return this.zl;
});
$p.PR = (function() {
  return this.ayc;
});
$p.ahj = (function(x$0) {
});
$p.ahi = (function(x$0) {
  this.ayc = x$0;
});
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-1759584375), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_components_selection_EdgeElement)) {
    if ($m_sr_BoxesRunTime$().Q(this.a0r, x$0.a0r)) {
      var x$1 = this.T0;
      var x$2 = x$0.T0;
      return ((x$1 === null) ? (x$2 === null) : (x$1 === x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "EdgeElement";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.a0r;
  }
  if ((n === 1)) {
    return this.T0;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "ref0";
  }
  if ((n === 1)) {
    return "strat";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.a4F = (function() {
  return this.LS;
});
$p.a3c = (function() {
  if ((!this.ayb)) {
    this.aya = this.T0.afE(this.zl);
    this.ayb = true;
  }
  return this.aya;
});
$p.a4E = (function() {
  this.zl.classList.add(this.LS);
  $p_Lorg_jpablo_graphexplorer_viewer_components_selection_EdgeElement__styleMarkerForSelection__Z__V(this, true);
  $p_Lorg_jpablo_graphexplorer_viewer_components_selection_EdgeElement__toggleEdgeLabelSelection__Z__V(this, true);
});
$p.aio = (function() {
  this.zl.classList.remove(this.LS);
  $p_Lorg_jpablo_graphexplorer_viewer_components_selection_EdgeElement__styleMarkerForSelection__Z__V(this, false);
  $p_Lorg_jpablo_graphexplorer_viewer_components_selection_EdgeElement__toggleEdgeLabelSelection__Z__V(this, false);
});
$p.lj = (function() {
  return this.a3c();
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_components_selection_EdgeElement(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hX)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_components_selection_EdgeElement = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_selection_EdgeElement, "org.jpablo.graphexplorer.viewer.components.selection.EdgeElement", ({
  hX: 1,
  cz: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_selection_MermaidSelectionStrategy$$anon$1(prefix$2) {
  this.a0s = null;
  this.a0s = prefix$2;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_selection_MermaidSelectionStrategy$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_selection_MermaidSelectionStrategy$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_selection_MermaidSelectionStrategy$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_selection_MermaidSelectionStrategy$$anon$1.prototype = $p;
$p.r2 = (function(x) {
  var prefix = this.a0s;
  if ((!(!x.startsWith(prefix)))) {
    return true;
  } else {
    return false;
  }
});
$p.qR = (function(x, default$1) {
  var prefix = this.a0s;
  if ((!(!x.startsWith(prefix)))) {
    return $m_sc_StringOps$().kp(x, this.a0s.length);
  } else {
    return default$1.i(x);
  }
});
$p.aM = (function(x) {
  return this.r2(x);
});
$p.aC = (function(x, default$1) {
  return this.qR(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_selection_MermaidSelectionStrategy$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_selection_MermaidSelectionStrategy$$anon$1, "org.jpablo.graphexplorer.viewer.components.selection.MermaidSelectionStrategy$$anon$1", ({
  zv: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_selection_NodeElement(ref0, strat) {
  this.T1 = null;
  this.ayk = null;
  this.a0t = null;
  this.T2 = null;
  this.ayj = null;
  this.ayh = null;
  this.ayi = false;
  this.a0t = ref0;
  this.T2 = strat;
  this.T1 = ref0;
  $f_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement__$init$__V(this);
  this.ayj = "selected";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_selection_NodeElement.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_selection_NodeElement;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_selection_NodeElement() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_selection_NodeElement.prototype = $p;
$p.dD = (function() {
  return this.T1;
});
$p.PR = (function() {
  return this.ayk;
});
$p.ahj = (function(x$0) {
});
$p.ahi = (function(x$0) {
  this.ayk = x$0;
});
$p.aio = (function() {
  $f_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement__unselect__V(this);
});
$p.a4E = (function() {
  $f_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement__select__V(this);
});
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 721937730, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_components_selection_NodeElement)) {
    if ($m_sr_BoxesRunTime$().Q(this.a0t, x$0.a0t)) {
      var x$1 = this.T2;
      var x$2 = x$0.T2;
      return ((x$1 === null) ? (x$2 === null) : (x$1 === x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "NodeElement";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.a0t;
  }
  if ((n === 1)) {
    return this.T2;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "ref0";
  }
  if ((n === 1)) {
    return "strat";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.a4F = (function() {
  return this.ayj;
});
$p.aNE = (function() {
  if ((!this.ayi)) {
    this.ayh = this.T2.afF(this.T1);
    this.ayi = true;
  }
  return this.ayh;
});
$p.lj = (function() {
  return this.aNE();
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_components_selection_NodeElement(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hY)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_components_selection_NodeElement = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_selection_NodeElement, "org.jpablo.graphexplorer.viewer.components.selection.NodeElement", ({
  hY: 1,
  cz: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasRoot$$anon$1() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasRoot$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasRoot$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasRoot$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasRoot$$anon$1.prototype = $p;
$p.J5 = (function(x) {
  return ((!(!(x instanceof SVGGElement))) || false);
});
$p.IE = (function(x, default$1) {
  return ((!(!(x instanceof SVGGElement))) ? x : default$1.i(x));
});
$p.aM = (function(x) {
  return this.J5(x);
});
$p.aC = (function(x, default$1) {
  return this.IE(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasRoot$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_CanvasRoot$$anon$1, "org.jpablo.graphexplorer.viewer.components.svgCanvas.CanvasRoot$$anon$1", ({
  zD: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$$anon$2(path$5) {
  this.ayG = null;
  this.ayG = path$5;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$$anon$2.prototype = $p;
$p.e5 = (function(x) {
  return true;
});
$p.e2 = (function(x, default$1) {
  console.warn(((("[origin] could not watch " + this.ayG) + ": ") + x.e3()));
});
$p.aM = (function(x) {
  return this.e5(x);
});
$p.aC = (function(x, default$1) {
  return this.e2(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$$anon$2, "org.jpablo.graphexplorer.viewer.desktop.DesktopIpc$$anon$2", ({
  zQ: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$$anon$3() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$$anon$3.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$$anon$3;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$$anon$3() {
}
$h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$$anon$3.prototype = $p;
$p.agD = (function(x) {
  return (((typeof x) === "string") || false);
});
$p.aeN = (function(x, default$1) {
  return (((typeof x) === "string") ? x : default$1.i(x));
});
$p.aM = (function(x) {
  return this.agD(x);
});
$p.aC = (function(x, default$1) {
  return this.aeN(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$$anon$3 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$$anon$3, "org.jpablo.graphexplorer.viewer.desktop.DesktopIpc$$anon$3", ({
  zR: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$$anon$4() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$$anon$4.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$$anon$4;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$$anon$4() {
}
$h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$$anon$4.prototype = $p;
$p.agD = (function(x) {
  return (((typeof x) === "number") || false);
});
$p.aeN = (function(x, default$1) {
  if (((typeof x) === "number")) {
    return $m_RTLong$().d1((+x));
  } else {
    return default$1.i(x);
  }
});
$p.aM = (function(x) {
  return this.agD(x);
});
$p.aC = (function(x, default$1) {
  return this.aeN(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$$anon$4 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$$anon$4, "org.jpablo.graphexplorer.viewer.desktop.DesktopIpc$$anon$4", ({
  zS: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome() {
}
$h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation() {
}
$h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Decision() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Decision.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Decision;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Decision() {
}
$h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Decision.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$$anon$1(record$5, origin$8) {
  this.ayN = null;
  this.ayM = null;
  this.ayN = record$5;
  this.ayM = origin$8;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$$anon$1.prototype = $p;
$p.e5 = (function(x) {
  return true;
});
$p.e2 = (function(x, default$1) {
  console.warn(((("[origin] could not reconcile " + this.ayN.wZ.cv) + ": ") + x.e3()));
  return new $c_T2($s_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__Diverged__Lorg_jpablo_graphexplorer_gxcore_model_SyncState(), new $c_s_Some(this.ayM));
});
$p.aM = (function(x) {
  return this.e5(x);
});
$p.aC = (function(x, default$1) {
  return this.e2(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_desktop_OriginReconciler$$anon$1, "org.jpablo.graphexplorer.viewer.desktop.OriginReconciler$$anon$1", ({
  A1: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group(port, children) {
  this.tk = null;
  this.gG = null;
  this.tk = port;
  this.gG = children;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 1649369945, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group)) {
    var x = this.tk;
    var x$2 = x$0.tk;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      var x$3 = this.gG;
      var x$4 = x$0.gG;
      return ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "Group";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.tk;
  }
  if ((n === 1)) {
    return this.gG;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "port";
  }
  if ((n === 1)) {
    return "children";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ip)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Group, "org.jpablo.graphexplorer.viewer.formats.dot.RecordTree$Group", ({
  ip: 1,
  io: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Leaf(port, text) {
  this.vm = null;
  this.tl = null;
  this.vm = port;
  this.tl = text;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Leaf.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Leaf;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Leaf() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Leaf.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-907382045), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Leaf)) {
    var x = this.vm;
    var x$2 = x$0.vm;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      return (this.tl === x$0.tl);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "Leaf";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.vm;
  }
  if ((n === 1)) {
    return this.tl;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "port";
  }
  if ((n === 1)) {
    return "text";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Leaf(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iq)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Leaf = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Leaf, "org.jpablo.graphexplorer.viewer.formats.dot.RecordTree$Leaf", ({
  iq: 1,
  io: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq$$anon$5(WritersVersionSpecific_this$6, outer) {
  this.aUE = null;
  this.aUE = WritersVersionSpecific_this$6;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq$$anon$5.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq$$anon$5;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq$$anon$5() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq$$anon$5.prototype = $p;
$p.cT = (function() {
  return false;
});
$p.cW = (function() {
  return this;
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aPP = (function(v) {
  return ((1 + ((!$m_sr_BoxesRunTime$().Q(v.vn, false)) | 0)) | 0);
});
$p.bcl = (function(out, v) {
  if ((v === null)) {
    return out.c8((-1));
  } else {
    var ctx = out.bQ(this.aPP(v), true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "value", $m_Lupickle_default$().I, v.Co);
    if ((!$m_sr_BoxesRunTime$().Q(v.vn, false))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "html", $m_Lupickle_default$().gP, v.vn);
    }
    return ctx.bV((-1));
  }
});
$p.bcM = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "value", $m_Lupickle_default$().I, v.Co);
  if ((!$m_sr_BoxesRunTime$().Q(v.vn, false))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "html", $m_Lupickle_default$().gP, v.vn);
  }
});
$p.jW = (function(v) {
  return this.aPP(v);
});
$p.d0 = (function(out, v) {
  return this.bcl(out, v);
});
$p.k4 = (function(ctx, v) {
  this.bcM(ctx, v);
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq$$anon$5 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq$$anon$5, "org.jpablo.graphexplorer.viewer.formats.dot.ast.AttrEq$$anon$5", ({
  Ae: 1,
  B: 1,
  E: 1,
  af: 1,
  ah: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType = new $TypeData().i(0, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.ArrowType", ({
  iu: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle = new $TypeData().i(0, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.BorderStyle", ({
  iv: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$__solid__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$__solid;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$__dashed__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$__dashed;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$__dotted__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$__dotted;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$() {
  this.azk = null;
  this.a0F = null;
  this.azn = null;
  this.azl = null;
  this.azm = false;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$ = this;
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$__solid = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$$anon$1("solid", 0);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$__dashed = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$$anon$1("dashed", 1);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$__dotted = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$$anon$1("dotted", 2);
  this.azk = new ($d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle.r().C)([$s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$__solid__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$__dashed__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$__dotted__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle()]);
  this.a0F = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$__solid__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle();
  this.azn = "Style";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aZ = (function() {
  return "";
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aix = (function() {
  return this.azk.ae();
});
$p.aI = (function() {
  return this.azn;
});
$p.aP = (function() {
  return new ($d_T2.r().C)([new $c_T2("Solid", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$__solid__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle()), new $c_T2("Dashed", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$__dashed__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle()), new $c_T2("Dotted", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$__dotted__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle())]);
});
$p.nx = (function() {
  if ((!this.azm)) {
    this.azl = $m_s_CanEqual$derived$();
    this.azm = true;
  }
  return this.azl;
});
$p.aW = (function() {
  return this.aix();
});
$p.aT = (function() {
  return this.a0F;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.BorderStyle$", ({
  Ao: 1,
  o: 1,
  a1: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint = new $TypeData().i(0, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.CompassPoint", ({
  iw: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle = new $TypeData().i(0, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.CornerStyle", ({
  ix: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$__rounded__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$__rounded;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$__diagonals__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$__diagonals;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$__normal__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$__normal;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$() {
  this.aAb = null;
  this.aa7 = null;
  this.aAe = null;
  this.aAc = null;
  this.aAd = false;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$ = this;
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$__rounded = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$$anon$2("rounded", 0);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$__diagonals = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$$anon$2("diagonals", 1);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$__normal = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$$anon$2("normal", 2);
  this.aAb = new ($d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle.r().C)([$s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$__rounded__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$__diagonals__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$__normal__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle()]);
  this.aa7 = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$__normal__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle();
  this.aAe = "Corner";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aZ = (function() {
  return "";
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aiy = (function() {
  return this.aAb.ae();
});
$p.aI = (function() {
  return this.aAe;
});
$p.aP = (function() {
  return new ($d_T2.r().C)([new $c_T2("Normal", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$__normal__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle()), new $c_T2("Rounded", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$__rounded__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle()), new $c_T2("Diagonals", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$__diagonals__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle())]);
});
$p.nx = (function() {
  if ((!this.aAd)) {
    this.aAc = $m_s_CanEqual$derived$();
    this.aAd = true;
  }
  return this.aAc;
});
$p.aW = (function() {
  return this.aiy();
});
$p.aT = (function() {
  return this.aa7;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.CornerStyle$", ({
  AI: 1,
  o: 1,
  a1: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType = new $TypeData().i(0, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.DirType", ({
  iy: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle = new $TypeData().i(0, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.EdgeStyle", ({
  iz: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$__dashed__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$__dashed;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$__dotted__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$__dotted;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$__solid__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$__solid;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$__bold__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$__bold;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$__invis__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$__invis;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$__tapered__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$__tapered;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$() {
  this.aAm = null;
  this.aAn = null;
  this.aAo = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$ = this;
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$__dashed = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$$anon$4("dashed", 0);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$__dotted = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$$anon$4("dotted", 1);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$__solid = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$$anon$4("solid", 2);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$__bold = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$$anon$4("bold", 3);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$__invis = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$$anon$4("invis", 4);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$__tapered = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$$anon$4("tapered", 5);
  this.aAm = new ($d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle.r().C)([$s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$__dashed__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$__dotted__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$__solid__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$__bold__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$__invis__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$__tapered__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle()]);
  this.aAn = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$__solid__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle();
  this.aAo = "Style";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$.prototype = $p;
$p.aZ = (function() {
  return "";
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.bb7 = (function() {
  return this.aAm.ae();
});
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$());
});
$p.aI = (function() {
  return this.aAo;
});
$p.aP = (function() {
  return new ($d_T2.r().C)([new $c_T2("Solid", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$__solid__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle()), new $c_T2("Dashed", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$__dashed__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle()), new $c_T2("Dotted", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$__dotted__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle()), new $c_T2("Bold", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$__bold__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle()), new $c_T2("Tapered", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$__tapered__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle()), new $c_T2("Invisible", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$__invis__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle())]);
});
$p.aW = (function() {
  return this.bb7();
});
$p.aT = (function() {
  return this.aAn;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.EdgeStyle$", ({
  AO: 1,
  o: 1,
  a1: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.aPn = (function() {
  return (this === $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$__digraph__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType());
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType = new $TypeData().i(0, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.GraphType", ({
  iA: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$__graph__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$__graph;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$__digraph__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$__digraph;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$() {
  this.aAM = null;
  this.GB = null;
  this.aAN = null;
  this.aAO = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$ = this;
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$__graph = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$$anon$5("graph", 0);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$__digraph = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$$anon$5("digraph", 1);
  this.aAM = new ($d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType.r().C)([$s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$__graph__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$__digraph__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType()]);
  this.GB = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$__digraph__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType();
  this.aAN = "Graph Type";
  this.aAO = new ($d_T2.r().C)([new $c_T2("Undirected graph", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$__graph__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType()), new $c_T2("Directed graph", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$__digraph__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType())]);
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aZ = (function() {
  return "";
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.bb8 = (function() {
  return this.aAM.ae();
});
$p.aI = (function() {
  return this.aAN;
});
$p.aP = (function() {
  return this.aAO;
});
$p.b1J = (function(isDirected) {
  return (isDirected ? $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$__digraph__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType() : $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$__graph__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType());
});
$p.aW = (function() {
  return this.bb8();
});
$p.aT = (function() {
  return this.GB;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.GraphType$", ({
  AX: 1,
  o: 1,
  a1: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc = new $TypeData().i(0, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.GroupLabelLoc", ({
  iB: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign = new $TypeData().i(0, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.HtmlCellAlign", ({
  iD: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign = new $TypeData().i(0, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.HtmlCellVAlign", ({
  iE: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust = new $TypeData().i(0, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.LabelJust", ({
  iF: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$__l__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$__l;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$__c__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$__c;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$__r__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$__r;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$() {
  this.aBG = null;
  this.aaj = null;
  this.aBH = null;
  this.aak = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$ = this;
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$__l = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$$anon$9("l", 0);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$__c = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$$anon$9("c", 1);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$__r = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$$anon$9("r", 2);
  this.aBG = new ($d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust.r().C)([$s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$__l__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$__c__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$__r__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust()]);
  this.aaj = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$__c__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust();
  this.aBH = "Horizontal alignment";
  this.aak = new ($d_T2.r().C)([new $c_T2("Left", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$__l__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust()), new $c_T2("Center", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$__c__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust()), new $c_T2("Right", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$__r__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust())]);
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aZ = (function() {
  return "";
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.bbb = (function() {
  return this.aBG.ae();
});
$p.aI = (function() {
  return this.aBH;
});
$p.aP = (function() {
  return this.aak;
});
$p.aW = (function() {
  return this.bbb();
});
$p.aT = (function() {
  return this.aaj;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.LabelJust$", ({
  Bl: 1,
  o: 1,
  a1: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout = new $TypeData().i(0, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Layout", ({
  iG: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__dot__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__dot;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__neato__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__neato;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__fdp__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__fdp;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__sfdp__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__sfdp;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__twopi__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__twopi;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__circo__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__circo;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__osage__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__osage;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__patchwork__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__patchwork;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$() {
  this.aBM = null;
  this.aBN = null;
  this.aBO = null;
  this.aBP = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$ = this;
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__dot = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$$anon$10("dot", 0);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__neato = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$$anon$10("neato", 1);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__fdp = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$$anon$10("fdp", 2);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__sfdp = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$$anon$10("sfdp", 3);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__twopi = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$$anon$10("twopi", 4);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__circo = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$$anon$10("circo", 5);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__osage = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$$anon$10("osage", 6);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__patchwork = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$$anon$10("patchwork", 7);
  this.aBM = new ($d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout.r().C)([$s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__dot__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__neato__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__fdp__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__sfdp__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__twopi__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__circo__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__osage__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__patchwork__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout()]);
  this.aBN = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__dot__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout();
  this.aBO = "Layout";
  this.aBP = new ($d_T2.r().C)([new $c_T2("Hierarchical", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__dot__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout()), new $c_T2("Spring model", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__neato__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout()), new $c_T2("Force-directed placement", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__fdp__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout()), new $c_T2("Multilevel force-directed placement", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__sfdp__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout()), new $c_T2("Radial", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__twopi__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout()), new $c_T2("Circular", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__circo__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout()), new $c_T2("Clustered", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__osage__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout()), new $c_T2("Squarified treemap", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__patchwork__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout())]);
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aZ = (function() {
  return "";
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aTk = (function() {
  return this.aBM.ae();
});
$p.aI = (function() {
  return this.aBO;
});
$p.aP = (function() {
  return this.aBP;
});
$p.aW = (function() {
  return this.aTk();
});
$p.aT = (function() {
  return this.aBN;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Layout$", ({
  Bo: 1,
  o: 1,
  a1: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Margin$() {
  this.aBZ = null;
  this.aBY = null;
  this.aBX = null;
  this.aC0 = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Margin$ = this;
  this.aBZ = new $c_s_reflect_ClassTag$GenericClassTag($d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Margin.l());
  this.aBY = "Margin";
  this.aBX = ($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Margin$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Margin(0.11, 0.055));
  this.aC0 = "Enter margin as x,y";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Margin$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Margin$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Margin$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Margin$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aW = (function() {
  return this.aBZ.b2(0);
});
$p.aI = (function() {
  return this.aBY;
});
$p.aZ = (function() {
  return this.aC0;
});
$p.aY = (function(s) {
  var x15 = $f_T__split__T__I__AT(s, ",", 0);
  if ((x15 !== null)) {
    if (($m_s_Array$UnapplySeqWrapper$().u9(x15, 2) === 0)) {
      var x17 = x15.a[0];
      var x18 = x15.a[1];
      try {
        var $x_1 = new $c_s_util_Success(($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Margin$(), new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Margin($m_jl_Double$().bd(x17), $m_jl_Double$().bd(x18))));
      } catch (e) {
        var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
        matchEnd8: {
          var $x_1;
          if ($m_s_util_control_NonFatal$().ew(e$2)) {
            var $x_1 = new $c_s_util_Failure(e$2);
            break matchEnd8;
          }
          throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
        }
      }
      return $x_1.rg();
    }
  }
  return $m_s_None$();
});
$p.aT = (function() {
  return this.aBX;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Margin$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Margin$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Margin$", ({
  Bs: 1,
  o: 1,
  v: 1,
  d: 1,
  j: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Margin$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Margin$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Margin$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Margin$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Margin$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Margin$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc = new $TypeData().i(0, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.NodeLabelLoc", ({
  iI: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$__t__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$__t;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$__c__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$__c;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$__b__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$__b;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$() {
  this.aC7 = null;
  this.aC8 = null;
  this.aC9 = null;
  this.aan = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$ = this;
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$__t = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$$anon$11("t", 0);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$__c = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$$anon$11("c", 1);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$__b = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$$anon$11("b", 2);
  this.aC7 = new ($d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc.r().C)([$s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$__t__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$__c__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$__b__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc()]);
  this.aC8 = "labelloc";
  this.aC9 = "Vertical alignment";
  this.aan = new ($d_T2.r().C)([new $c_T2("Top", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$__t__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc()), new $c_T2("Center", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$__c__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc()), new $c_T2("Bottom", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$__b__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc())]);
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$.prototype = $p;
$p.aZ = (function() {
  return "";
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.bbc = (function() {
  return this.aC7.ae();
});
$p.aN = (function() {
  return this.aC8;
});
$p.aI = (function() {
  return this.aC9;
});
$p.aP = (function() {
  return this.aan;
});
$p.aW = (function() {
  return this.bbc();
});
$p.aT = (function() {
  return $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$__c__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc();
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.NodeLabelLoc$", ({
  Bv: 1,
  o: 1,
  a1: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle = new $TypeData().i(0, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.NodeStyle", ({
  iJ: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__dashed__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__dashed;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__dotted__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__dotted;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__solid__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__solid;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__bold__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__bold;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__invis__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__invis;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__striped__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__striped;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__wedged__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__wedged;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__diagonals__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__diagonals;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__rounded__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__rounded;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$() {
  this.aCe = null;
  this.aCf = null;
  this.aCh = null;
  this.aCg = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$ = this;
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__dashed = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$$anon$12("dashed", 0);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__dotted = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$$anon$12("dotted", 1);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__solid = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$$anon$12("solid", 2);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__bold = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$$anon$12("bold", 3);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__invis = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$$anon$12("invis", 4);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__striped = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$$anon$12("striped", 5);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__wedged = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$$anon$12("wedged", 6);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__diagonals = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$$anon$12("diagonals", 7);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__rounded = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$$anon$12("rounded", 8);
  this.aCe = new ($d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle.r().C)([$s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__dashed__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__dotted__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__solid__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__bold__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__invis__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__striped__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__wedged__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__diagonals__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__rounded__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle()]);
  this.aCf = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__solid__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle();
  this.aCh = "Node Style";
  this.aCg = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__filled__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style();
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$.prototype = $p;
$p.aZ = (function() {
  return "";
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.bbd = (function() {
  return this.aCe.ae();
});
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$());
});
$p.aI = (function() {
  return this.aCh;
});
$p.aP = (function() {
  return new ($d_T2.r().C)([new $c_T2("Dashed", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__dashed__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle()), new $c_T2("Dotted", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__dotted__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle()), new $c_T2("Solid", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__solid__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle()), new $c_T2("Bold", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__bold__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle()), new $c_T2("Invisible", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__invis__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle()), new $c_T2("Striped", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__striped__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle()), new $c_T2("Wedged", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__wedged__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle()), new $c_T2("Diagonals", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__diagonals__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle()), new $c_T2("Rounded", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__rounded__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle())]);
});
$p.aW = (function() {
  return this.bbd();
});
$p.aT = (function() {
  return this.aCf;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.NodeStyle$", ({
  By: 1,
  o: 1,
  a1: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap = new $TypeData().i(0, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Overlap", ({
  iK: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap$__false__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap$__false;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap$__scale__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap$__scale;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap$__compress__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap$__compress;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap$() {
  this.aCp = null;
  this.aCq = null;
  this.aCr = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap$ = this;
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap$__false = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap$$anon$14("false", 0);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap$__scale = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap$$anon$14("scale", 1);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap$__compress = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap$$anon$14("compress", 2);
  this.aCp = new ($d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap.r().C)([$s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap$__false__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap$__scale__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap$__compress__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap()]);
  this.aCq = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap$__false__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap();
  this.aCr = "Overlap";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aZ = (function() {
  return "";
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.bbe = (function() {
  return this.aCp.ae();
});
$p.aI = (function() {
  return this.aCr;
});
$p.aW = (function() {
  return this.bbe();
});
$p.aT = (function() {
  return this.aCq;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Overlap$", ({
  BC: 1,
  o: 1,
  a1: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType = new $TypeData().i(0, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.RankType", ({
  iL: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir = new $TypeData().i(0, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Rankdir", ({
  iM: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$__TB__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$__TB;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$__LR__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$__LR;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$__BT__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$__BT;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$__RL__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$__RL;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$() {
  this.aCR = null;
  this.aCS = null;
  this.aCT = null;
  this.aCU = null;
  this.aas = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$ = this;
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$__TB = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$$anon$15("TB", 0);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$__LR = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$$anon$15("LR", 1);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$__BT = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$$anon$15("BT", 2);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$__RL = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$$anon$15("RL", 3);
  this.aCR = new ($d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir.r().C)([$s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$__TB__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$__LR__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$__BT__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$__RL__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir()]);
  this.aCS = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$__TB__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir();
  this.aCT = "Diagram Direction";
  this.aCU = $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout.r().C)([$s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__dot__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout()])));
  this.aas = new ($d_T2.r().C)([new $c_T2("Top to Bottom", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$__TB__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir()), new $c_T2("Left to Right", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$__LR__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir()), new $c_T2("Bottom to Top", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$__BT__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir()), new $c_T2("Right to Left", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$__RL__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir())]);
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aZ = (function() {
  return "";
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.aTl = (function() {
  return this.aCR.ae();
});
$p.aI = (function() {
  return this.aCT;
});
$p.aV = (function() {
  return this.aCU;
});
$p.aP = (function() {
  return this.aas;
});
$p.aW = (function() {
  return this.aTl();
});
$p.aT = (function() {
  return this.aCS;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Rankdir$", ({
  BN: 1,
  o: 1,
  a1: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape = new $TypeData().i(0, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Shape", ({
  iN: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__box__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__box;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__rectangle__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__rectangle;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__rect__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__rect;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__square__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__square;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__circle__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__circle;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__ellipse__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__ellipse;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__oval__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__oval;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__point__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__point;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__none__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__none;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__polygon__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__polygon;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__pentagon__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__pentagon;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__hexagon__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__hexagon;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__septagon__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__septagon;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__octagon__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__octagon;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__triangle__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__triangle;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__diamond__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__diamond;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__star__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__star;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__invtriangle__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__invtriangle;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__invtrapezium__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__invtrapezium;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__invhouse__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__invhouse;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__trapezium__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__trapezium;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__parallelogram__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__parallelogram;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__house__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__house;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__doublecircle__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__doublecircle;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__doubleoctagon__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__doubleoctagon;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__tripleoctagon__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__tripleoctagon;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__Mdiamond__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__Mdiamond;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__Msquare__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__Msquare;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__Mcircle__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__Mcircle;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__Mrecord__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__Mrecord;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__plaintext__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__plaintext;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__plain__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__plain;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__record__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__record;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__underline__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__underline;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__box3d__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__box3d;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__cylinder__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__cylinder;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__note__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__note;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__tab__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__tab;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__folder__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__folder;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__rarrow__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__rarrow;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__larrow__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__larrow;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__component__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__component;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__egg__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__egg;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__signature__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__signature;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__assembly__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__assembly;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__promoter__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__promoter;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__lpromoter__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__lpromoter;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__rpromoter__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__rpromoter;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__cds__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__cds;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__terminator__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__terminator;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__utr__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__utr;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__insulator__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__insulator;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__ribosite__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__ribosite;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__rnastab__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__rnastab;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__proteasesite__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__proteasesite;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__proteinstab__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__proteinstab;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__primersite__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__primersite;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__restrictionsite__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__restrictionsite;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__fivepoverhang__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__fivepoverhang;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__threepoverhang__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__threepoverhang;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__noverhang__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__noverhang;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$() {
  this.aDg = null;
  this.aDi = null;
  this.aDm = null;
  this.aDh = null;
  this.aDp = null;
  this.aDl = null;
  this.aDn = null;
  this.aDq = null;
  this.aDk = null;
  this.aDj = null;
  this.aDo = null;
  this.aDr = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$ = this;
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__box = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("box", 0);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__rectangle = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("rectangle", 1);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__rect = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("rect", 2);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__square = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("square", 3);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__circle = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("circle", 4);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__ellipse = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("ellipse", 5);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__oval = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("oval", 6);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__point = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("point", 7);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__none = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("none", 8);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__polygon = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("polygon", 9);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__pentagon = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("pentagon", 10);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__hexagon = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("hexagon", 11);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__septagon = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("septagon", 12);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__octagon = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("octagon", 13);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__triangle = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("triangle", 14);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__diamond = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("diamond", 15);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__star = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("star", 16);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__invtriangle = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("invtriangle", 17);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__invtrapezium = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("invtrapezium", 18);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__invhouse = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("invhouse", 19);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__trapezium = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("trapezium", 20);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__parallelogram = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("parallelogram", 21);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__house = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("house", 22);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__doublecircle = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("doublecircle", 23);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__doubleoctagon = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("doubleoctagon", 24);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__tripleoctagon = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("tripleoctagon", 25);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__Mdiamond = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("Mdiamond", 26);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__Msquare = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("Msquare", 27);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__Mcircle = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("Mcircle", 28);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__Mrecord = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("Mrecord", 29);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__plaintext = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("plaintext", 30);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__plain = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("plain", 31);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__record = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("record", 32);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__underline = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("underline", 33);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__box3d = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("box3d", 34);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__cylinder = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("cylinder", 35);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__note = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("note", 36);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__tab = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("tab", 37);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__folder = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("folder", 38);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__rarrow = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("rarrow", 39);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__larrow = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("larrow", 40);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__component = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("component", 41);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__egg = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("egg", 42);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__signature = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("signature", 43);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__assembly = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("assembly", 44);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__promoter = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("promoter", 45);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__lpromoter = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("lpromoter", 46);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__rpromoter = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("rpromoter", 47);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__cds = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("cds", 48);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__terminator = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("terminator", 49);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__utr = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("utr", 50);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__insulator = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("insulator", 51);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__ribosite = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("ribosite", 52);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__rnastab = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("rnastab", 53);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__proteasesite = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("proteasesite", 54);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__proteinstab = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("proteinstab", 55);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__primersite = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("primersite", 56);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__restrictionsite = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("restrictionsite", 57);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__fivepoverhang = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("fivepoverhang", 58);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__threepoverhang = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("threepoverhang", 59);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__noverhang = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17("noverhang", 60);
  this.aDg = new ($d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape.r().C)([$s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__box__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__rectangle__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__rect__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__square__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__circle__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__ellipse__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__oval__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__point__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__none__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__polygon__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__pentagon__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__hexagon__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__septagon__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__octagon__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__triangle__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__diamond__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__star__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__invtriangle__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__invtrapezium__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__invhouse__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__trapezium__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__parallelogram__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__house__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__doublecircle__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__doubleoctagon__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__tripleoctagon__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__Mdiamond__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__Msquare__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__Mcircle__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__Mrecord__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__plaintext__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__plain__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__record__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__underline__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__box3d__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__cylinder__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__note__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__tab__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__folder__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__rarrow__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__larrow__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__component__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__egg__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__signature__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__assembly__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__promoter__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__lpromoter__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__rpromoter__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__cds__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__terminator__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__utr__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__insulator__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__ribosite__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__rnastab__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__proteasesite__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__proteinstab__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__primersite__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__restrictionsite__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__fivepoverhang__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__threepoverhang__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__noverhang__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape()]);
  this.aDi = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__box__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
  this.aDm = "Shape";
  this.aDh = new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__box__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__ellipse__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__circle__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__diamond__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $m_sci_Nil$()))));
  this.aDp = new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__polygon__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__pentagon__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__hexagon__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__septagon__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__octagon__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $m_sci_Nil$())))));
  this.aDl = new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__invtriangle__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__invtrapezium__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__invhouse__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $m_sci_Nil$())));
  this.aDn = new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__Mdiamond__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__Msquare__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__Mcircle__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__Mrecord__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $m_sci_Nil$()))));
  this.aDq = new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__Mrecord__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__tab__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__note__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__tab__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__folder__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__box3d__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $m_sci_Nil$()))))));
  this.aDk = new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__invhouse__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__invtriangle__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__invtrapezium__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $m_sci_Nil$())));
  this.aDj = new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__invhouse__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__invtriangle__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), new $c_sci_$colon$colon($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__invtrapezium__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $m_sci_Nil$())));
  this.aDo = $m_sci_Nil$().b6($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape.r().C)([$s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__component__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__promoter__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__cds__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__terminator__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__utr__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__primersite__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__restrictionsite__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__fivepoverhang__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__threepoverhang__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__noverhang__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__assembly__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__signature__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__insulator__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__ribosite__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__rnastab__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__proteasesite__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__proteinstab__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__rarrow__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__larrow__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__lpromoter__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__rpromoter__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape()])));
  this.aDh.hK(this.aDp).hK(this.aDl).hK(this.aDn).hK(this.aDq).hK(this.aDk).hK(this.aDj).hK(this.aDo);
  this.aDr = $m_sci_Map$().ao($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__rectangle__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__box__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape()), new $c_T2($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__rect__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__box__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape()), new $c_T2($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__none__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__plaintext__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape()), new $c_T2($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__oval__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__ellipse__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape()), new $c_T2($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__pentagon__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__polygon__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape()), new $c_T2($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__hexagon__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__polygon__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape()), new $c_T2($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__septagon__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__polygon__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape()), new $c_T2($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__octagon__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__polygon__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape()), new $c_T2($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__doublecircle__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__circle__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape()), new $c_T2($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__doubleoctagon__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__polygon__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape()), new $c_T2($s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__tripleoctagon__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__polygon__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape())])));
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aZ = (function() {
  return "";
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.bbg = (function() {
  return this.aDg.ae();
});
$p.aI = (function() {
  return this.aDm;
});
$p.aW = (function() {
  return this.bbg();
});
$p.aT = (function() {
  return this.aDi;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Shape$", ({
  BV: 1,
  o: 1,
  a1: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines = new $TypeData().i(0, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Splines", ({
  iO: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__line__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__line;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__spline__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__spline;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__polyline__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__polyline;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__ortho__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__ortho;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__curved__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__curved;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__true__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__true;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__false__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__false;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__none__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__none;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$() {
  this.aDB = null;
  this.aDC = null;
  this.aDD = null;
  this.aDE = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$ = this;
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__line = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$$anon$18("line", 0);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__spline = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$$anon$18("spline", 1);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__polyline = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$$anon$18("polyline", 2);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__ortho = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$$anon$18("ortho", 3);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__curved = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$$anon$18("curved", 4);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__true = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$$anon$18("true", 5);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__false = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$$anon$18("false", 6);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__none = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$$anon$18("none", 7);
  this.aDB = new ($d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines.r().C)([$s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__line__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__spline__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__polyline__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__ortho__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__curved__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__true__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__false__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__none__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines()]);
  this.aDC = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__spline__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines();
  this.aDD = "Curve style";
  this.aDE = new ($d_T2.r().C)([new $c_T2("Spline", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__spline__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines()), new $c_T2("Line", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__line__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines()), new $c_T2("Polyline", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__polyline__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines()), new $c_T2("Orthogonal", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__ortho__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines()), new $c_T2("Curved", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__curved__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines()), new $c_T2("None", $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__none__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines())]);
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aZ = (function() {
  return "";
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.bbh = (function() {
  return this.aDB.ae();
});
$p.aI = (function() {
  return this.aDD;
});
$p.aP = (function() {
  return this.aDE;
});
$p.aW = (function() {
  return this.bbh();
});
$p.aT = (function() {
  return this.aDC;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Splines$", ({
  C0: 1,
  o: 1,
  a1: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style = new $TypeData().i(0, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Style", ({
  iP: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__filled__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__filled;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__dashed__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__dashed;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__dotted__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__dotted;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__solid__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__solid;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__bold__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__bold;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__invis__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__invis;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__diagonals__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__diagonals;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__rounded__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__rounded;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__striped__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__striped;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__wedged__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__wedged;
}
function $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__tapered__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style() {
  $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$();
  return $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__tapered;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$() {
  this.aDJ = null;
  this.aDK = null;
  this.aDL = null;
  $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$ = this;
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__filled = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$$anon$19("filled", 0);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__dashed = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$$anon$19("dashed", 1);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__dotted = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$$anon$19("dotted", 2);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__solid = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$$anon$19("solid", 3);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__bold = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$$anon$19("bold", 4);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__invis = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$$anon$19("invis", 5);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__diagonals = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$$anon$19("diagonals", 6);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__rounded = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$$anon$19("rounded", 7);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__striped = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$$anon$19("striped", 8);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__wedged = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$$anon$19("wedged", 9);
  $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__tapered = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$$anon$19("tapered", 10);
  this.aDJ = new ($d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style.r().C)([$s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__filled__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__dashed__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__dotted__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__solid__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__bold__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__invis__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__diagonals__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__rounded__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__striped__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__wedged__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style(), $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__tapered__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style()]);
  this.aDK = $s_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__solid__Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style();
  this.aDL = "Style";
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$.prototype = $p;
$p.aN = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T(this);
});
$p.aZ = (function() {
  return "";
});
$p.aP = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__valuesWithLabel__AT2(this);
});
$p.aV = (function() {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__validLayouts__sci_Set(this);
});
$p.aY = (function(s) {
  return $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__fromString__T__s_Option(this, s);
});
$p.bbi = (function() {
  return this.aDJ.ae();
});
$p.aI = (function() {
  return this.aDL;
});
$p.aW = (function() {
  return this.bbi();
});
$p.aT = (function() {
  return this.aDK;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$ = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Style$", ({
  C3: 1,
  o: 1,
  a1: 1,
  d: 1,
  u: 1
}));
var $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$;
function $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$() {
  if ((!$n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$)) {
    $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$ = new $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$();
  }
  return $n_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$;
}
function $p_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand__formatPair__T2__T($thiz, p) {
  return (((+p.g()) + ",") + (+p.h()));
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.aXJ = (function() {
  if ((this instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$MoveTo)) {
    var x54 = this.GF;
    var x55 = this.GG;
    var f = ((p) => $p_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand__formatPair__T2__T(this, p));
    if ((x55 === $m_sci_Nil$())) {
      var $x_1 = $m_sci_Nil$();
    } else {
      var x0 = x55.t();
      var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
      var t = h;
      var rest = x55.v();
      while ((rest !== $m_sci_Nil$())) {
        var x0$1 = rest.t();
        var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
        t.U = nx;
        t = nx;
        rest = rest.v();
      }
      var $x_1 = h;
    }
    return ((x54 ? "M" : "m") + $f_sc_IterableOnceOps__mkString__T__T__T__T($x_1, "", " ", ""));
  }
  if ((this instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$ClosePath)) {
    return "Z";
  }
  if ((this instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$LineTo)) {
    var x49 = this.GE;
    var x50 = this.zr;
    var f$1 = ((p$2) => $p_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand__formatPair__T2__T(this, p$2));
    if ((x50 === $m_sci_Nil$())) {
      var $x_2 = $m_sci_Nil$();
    } else {
      var x0$2 = x50.t();
      var h$1 = new $c_sci_$colon$colon(f$1(x0$2), $m_sci_Nil$());
      var t$1 = h$1;
      var rest$1 = x50.v();
      while ((rest$1 !== $m_sci_Nil$())) {
        var x0$3 = rest$1.t();
        var nx$1 = new $c_sci_$colon$colon(f$1(x0$3), $m_sci_Nil$());
        t$1.U = nx$1;
        t$1 = nx$1;
        rest$1 = rest$1.v();
      }
      var $x_2 = h$1;
    }
    return ((x49 ? "L" : "l") + $f_sc_IterableOnceOps__mkString__T__T__T__T($x_2, "", " ", ""));
  }
  if ((this instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$HorizontalLineTo)) {
    var x45 = this.Ma;
    var x46 = this.Mb;
    return ((x45 ? "H" : "h") + $f_sc_IterableOnceOps__mkString__T__T__T__T(x46, "", " ", ""));
  }
  if ((this instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$VerticalLineTo)) {
    var x41 = this.Mi;
    var x42 = this.Mj;
    return ((x41 ? "V" : "v") + $f_sc_IterableOnceOps__mkString__T__T__T__T(x42, "", " ", ""));
  }
  if ((this instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$CurveTo)) {
    var x37 = this.GC;
    var x38 = this.GD;
    var f$2 = ((x$1) => {
      if ((x$1 !== null)) {
        var p1 = x$1.bH;
        var p2 = x$1.bU;
        var p3 = x$1.c3;
        return (((($p_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand__formatPair__T2__T(this, p1) + " ") + $p_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand__formatPair__T2__T(this, p2)) + " ") + $p_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand__formatPair__T2__T(this, p3));
      }
      throw new $c_s_MatchError(x$1);
    });
    if ((x38 === $m_sci_Nil$())) {
      var $x_3 = $m_sci_Nil$();
    } else {
      var x0$4 = x38.t();
      var h$2 = new $c_sci_$colon$colon(f$2(x0$4), $m_sci_Nil$());
      var t$2 = h$2;
      var rest$2 = x38.v();
      while ((rest$2 !== $m_sci_Nil$())) {
        var x0$5 = rest$2.t();
        var nx$2 = new $c_sci_$colon$colon(f$2(x0$5), $m_sci_Nil$());
        t$2.U = nx$2;
        t$2 = nx$2;
        rest$2 = rest$2.v();
      }
      var $x_3 = h$2;
    }
    return ((x37 ? "C" : "c") + $f_sc_IterableOnceOps__mkString__T__T__T__T($x_3, "", " ", ""));
  }
  if ((this instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$SmoothCurveTo)) {
    var x33 = this.Me;
    var x34 = this.Mf;
    var f$3 = ((x$1$2) => {
      if ((x$1$2 !== null)) {
        var p1$1 = x$1$2.g();
        var p2$1 = x$1$2.h();
        return (($p_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand__formatPair__T2__T(this, p1$1) + " ") + $p_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand__formatPair__T2__T(this, p2$1));
      }
      throw new $c_s_MatchError(x$1$2);
    });
    if ((x34 === $m_sci_Nil$())) {
      var $x_4 = $m_sci_Nil$();
    } else {
      var x0$6 = x34.t();
      var h$3 = new $c_sci_$colon$colon(f$3(x0$6), $m_sci_Nil$());
      var t$3 = h$3;
      var rest$3 = x34.v();
      while ((rest$3 !== $m_sci_Nil$())) {
        var x0$7 = rest$3.t();
        var nx$3 = new $c_sci_$colon$colon(f$3(x0$7), $m_sci_Nil$());
        t$3.U = nx$3;
        t$3 = nx$3;
        rest$3 = rest$3.v();
      }
      var $x_4 = h$3;
    }
    return ((x33 ? "S" : "s") + $f_sc_IterableOnceOps__mkString__T__T__T__T($x_4, "", " ", ""));
  }
  if ((this instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$QuadraticBezierCurveTo)) {
    var x29 = this.Mc;
    var x30 = this.Md;
    var f$4 = ((x$1$3) => {
      if ((x$1$3 !== null)) {
        var p1$2 = x$1$3.g();
        var p2$2 = x$1$3.h();
        return (($p_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand__formatPair__T2__T(this, p1$2) + " ") + $p_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand__formatPair__T2__T(this, p2$2));
      }
      throw new $c_s_MatchError(x$1$3);
    });
    if ((x30 === $m_sci_Nil$())) {
      var $x_5 = $m_sci_Nil$();
    } else {
      var x0$8 = x30.t();
      var h$4 = new $c_sci_$colon$colon(f$4(x0$8), $m_sci_Nil$());
      var t$4 = h$4;
      var rest$4 = x30.v();
      while ((rest$4 !== $m_sci_Nil$())) {
        var x0$9 = rest$4.t();
        var nx$4 = new $c_sci_$colon$colon(f$4(x0$9), $m_sci_Nil$());
        t$4.U = nx$4;
        t$4 = nx$4;
        rest$4 = rest$4.v();
      }
      var $x_5 = h$4;
    }
    return ((x29 ? "Q" : "q") + $f_sc_IterableOnceOps__mkString__T__T__T__T($x_5, "", " ", ""));
  }
  if ((this instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$SmoothQuadraticBezierCurveTo)) {
    var x25 = this.Mg;
    var x26 = this.Mh;
    var f$5 = ((p$3) => $p_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand__formatPair__T2__T(this, p$3));
    if ((x26 === $m_sci_Nil$())) {
      var $x_6 = $m_sci_Nil$();
    } else {
      var x0$10 = x26.t();
      var h$5 = new $c_sci_$colon$colon(f$5(x0$10), $m_sci_Nil$());
      var t$5 = h$5;
      var rest$5 = x26.v();
      while ((rest$5 !== $m_sci_Nil$())) {
        var x0$11 = rest$5.t();
        var nx$5 = new $c_sci_$colon$colon(f$5(x0$11), $m_sci_Nil$());
        t$5.U = nx$5;
        t$5 = nx$5;
        rest$5 = rest$5.v();
      }
      var $x_6 = h$5;
    }
    return ((x25 ? "T" : "t") + $f_sc_IterableOnceOps__mkString__T__T__T__T($x_6, "", " ", ""));
  }
  if ((this instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$EllipticalArc)) {
    var x21 = this.M8;
    var x22 = this.M9;
    var f$6 = ((x$1$4) => {
      if ((x$1$4 !== null)) {
        var rx = (+x$1$4.Nt);
        var ry = (+x$1$4.Nu);
        var angle = (+x$1$4.Nv);
        var largeArc = (!(!x$1$4.Nw));
        var sweep = (!(!x$1$4.Nx));
        var point = x$1$4.Ny;
        return ((((((((((rx + " ") + ry) + " ") + angle) + " ") + (largeArc | 0)) + " ") + (sweep | 0)) + " ") + $p_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand__formatPair__T2__T(this, point));
      }
      throw new $c_s_MatchError(x$1$4);
    });
    if ((x22 === $m_sci_Nil$())) {
      var $x_7 = $m_sci_Nil$();
    } else {
      var x0$12 = x22.t();
      var h$6 = new $c_sci_$colon$colon(f$6(x0$12), $m_sci_Nil$());
      var t$6 = h$6;
      var rest$6 = x22.v();
      while ((rest$6 !== $m_sci_Nil$())) {
        var x0$13 = rest$6.t();
        var nx$6 = new $c_sci_$colon$colon(f$6(x0$13), $m_sci_Nil$());
        t$6.U = nx$6;
        t$6 = nx$6;
        rest$6 = rest$6.v();
      }
      var $x_7 = h$6;
    }
    return ((x21 ? "A" : "a") + $f_sc_IterableOnceOps__mkString__T__T__T__T($x_7, "", " ", ""));
  }
  throw new $c_s_MatchError(this);
});
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex$$anon$1() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex$$anon$1.prototype = $p;
$p.bu = (function(x) {
  if ((x !== null)) {
    var attrId = ((x.g() === null) ? null : x.g().fY);
    x.h();
    var prefix = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$().BV;
    if ((!(!attrId.startsWith(prefix)))) {
      return true;
    }
  }
  return false;
});
$p.bt = (function(x, default$1) {
  if ((x !== null)) {
    var attrId = ((x.g() === null) ? null : x.g().fY);
    var attrValue = x.h();
    var prefix = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$().BV;
    if ((!(!attrId.startsWith(prefix)))) {
      return new $c_T2($m_sc_StringOps$().wg(attrId, $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$().BV), $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidStyleDeclarations$().Az(attrValue.m()));
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.bu(x);
});
$p.aC = (function(x, default$1) {
  return this.bt(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex$$anon$1, "org.jpablo.graphexplorer.viewer.graph.AttributesOps$MermaidStyleIndex$$anon$1", ({
  Co: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex$$anon$2() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex$$anon$2.prototype = $p;
$p.bu = (function(x) {
  if ((x !== null)) {
    var attrId = ((x.g() === null) ? null : x.g().fY);
    x.h();
    var prefix = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$().BW;
    if ((!(!attrId.startsWith(prefix)))) {
      return true;
    }
  }
  return false;
});
$p.bt = (function(x, default$1) {
  if ((x !== null)) {
    var attrId = ((x.g() === null) ? null : x.g().fY);
    var attrValue = x.h();
    var prefix = $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$().BW;
    if ((!(!attrId.startsWith(prefix)))) {
      return new $c_T2($m_sc_StringOps$().wg(attrId, $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidAttrKeys$().BW), $m_Lorg_jpablo_graphexplorer_viewer_backends_mermaid_MermaidStyleDeclarations$().Az(attrValue.m()));
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.bu(x);
});
$p.aC = (function(x, default$1) {
  return this.bt(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$MermaidStyleIndex$$anon$2, "org.jpablo.graphexplorer.viewer.graph.AttributesOps$MermaidStyleIndex$$anon$2", ({
  Cp: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$$anon$1(hiddenArrowIds$2) {
  this.aaB = null;
  this.aaB = hiddenArrowIds$2;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$$anon$1.prototype = $p;
$p.bu = (function(x) {
  if ((x !== null)) {
    x.g();
    if (x.h().Q0(this.aaB)) {
      return true;
    }
  }
  return false;
});
$p.bt = (function(x, default$1) {
  if ((x !== null)) {
    var vid = x.g();
    if (x.h().Q0(this.aaB)) {
      return vid;
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.bu(x);
});
$p.aC = (function(x, default$1) {
  return this.bt(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$$anon$1, "org.jpablo.graphexplorer.viewer.graph.CollapseOps$$anon$1", ({
  Cs: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$$anon$2() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$$anon$2.prototype = $p;
$p.r3 = (function(x) {
  return ((x instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId) || false);
});
$p.qS = (function(x, default$1) {
  return ((x instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId) ? x : default$1.i(x));
});
$p.aM = (function(x) {
  return this.r3(x);
});
$p.aC = (function(x, default$1) {
  return this.qS(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$$anon$2, "org.jpablo.graphexplorer.viewer.graph.CollapseOps$$anon$2", ({
  Ct: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$$anon$3(proxy$2) {
  this.aEJ = null;
  this.aEJ = proxy$2;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$$anon$3.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$$anon$3;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$$anon$3() {
}
$h_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$$anon$3.prototype = $p;
$p.r3 = (function(x) {
  return ((x instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId) || false);
});
$p.qS = (function(x, default$1) {
  return ((x instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId) ? new $c_T2(x, this.aEJ) : default$1.i(x));
});
$p.aM = (function(x) {
  return this.r3(x);
});
$p.aC = (function(x, default$1) {
  return this.qS(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$$anon$3 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$$anon$3, "org.jpablo.graphexplorer.viewer.graph.CollapseOps$$anon$3", ({
  Cu: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$$anon$4() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$$anon$4.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$$anon$4;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$$anon$4() {
}
$h_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$$anon$4.prototype = $p;
$p.r3 = (function(x) {
  return ((x instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId) || false);
});
$p.qS = (function(x, default$1) {
  return ((x instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId) ? x : default$1.i(x));
});
$p.aM = (function(x) {
  return this.r3(x);
});
$p.aC = (function(x, default$1) {
  return this.qS(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$$anon$4 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps$$anon$4, "org.jpablo.graphexplorer.viewer.graph.CollapseOps$$anon$4", ({
  Cv: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_graph_GroupsOps$$anon$1(groupIds$2) {
  this.aaC = null;
  this.aaC = groupIds$2;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_graph_GroupsOps$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_graph_GroupsOps$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_graph_GroupsOps$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_graph_GroupsOps$$anon$1.prototype = $p;
$p.bu = (function(x) {
  if ((x !== null)) {
    x.g();
    var gId = x.h();
    if (this.aaC.E(gId)) {
      return true;
    }
  }
  return false;
});
$p.bt = (function(x, default$1) {
  if ((x !== null)) {
    var memId = x.g();
    var gId = x.h();
    if (this.aaC.E(gId)) {
      return memId;
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.bu(x);
});
$p.aC = (function(x, default$1) {
  return this.bt(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_graph_GroupsOps$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_graph_GroupsOps$$anon$1, "org.jpablo.graphexplorer.viewer.graph.GroupsOps$$anon$1", ({
  Cy: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_graph_GroupsOps$$anon$2(outer) {
  this.aaD = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aaD = outer;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_graph_GroupsOps$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_graph_GroupsOps$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_graph_GroupsOps$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_viewer_graph_GroupsOps$$anon$2.prototype = $p;
$p.r3 = (function(x) {
  if ((x instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId)) {
    if (this.aaD.hu.E(x)) {
      return true;
    }
  }
  return false;
});
$p.qS = (function(x, default$1) {
  if ((x instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId)) {
    if (this.aaD.hu.E(x)) {
      return x;
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.r3(x);
});
$p.aC = (function(x, default$1) {
  return this.qS(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_graph_GroupsOps$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_graph_GroupsOps$$anon$2, "org.jpablo.graphexplorer.viewer.graph.GroupsOps$$anon$2", ({
  Cz: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$$anon$2(WritersVersionSpecific_this$3, outer) {
  this.aUG = null;
  this.aUG = WritersVersionSpecific_this$3;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$$anon$2.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$$anon$2.prototype = $p;
$p.cT = (function() {
  return false;
});
$p.cW = (function() {
  return this;
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aPQ = (function(v) {
  var x = v.gr;
  $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$();
  var x$2 = $m_sci_VectorMap$().jg;
  var $x_7 = ((x === null) ? (x$2 === null) : $f_sc_Map__equals__O__Z(x, x$2));
  var x$3 = v.gH;
  $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$();
  var x$4 = $m_sci_Map$EmptyMap$();
  var $x_6 = ((x$3 !== null) && x$3.e(x$4));
  var x$5 = v.gq;
  $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$();
  var x$6 = $m_sci_Map$EmptyMap$();
  var $x_5 = ((x$5 !== null) && x$5.e(x$6));
  var x$7 = v.gp;
  $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$();
  var x$8 = $m_sci_Map$EmptyMap$();
  var $x_4 = ((x$7 !== null) && x$7.e(x$8));
  var x$9 = v.fh;
  $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$();
  var x$10 = $m_sci_Map$EmptyMap$();
  var $x_3 = ((x$9 !== null) && x$9.e(x$10));
  var x$11 = new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(v.dW);
  var x$12 = new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$(), $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV));
  var $x_2 = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().lk(x$11.ce, x$12);
  var x$13 = new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(v.fE);
  var x$14 = new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$(), $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV));
  var $x_1 = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().lk(x$13.ce, x$14);
  var x$15 = new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(v.fD);
  var x$16 = new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$(), $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV));
  return ((((((((((((((((!$x_7) | 0) + ((!$x_6) | 0)) | 0) + ((!$x_5) | 0)) | 0) + ((!$x_4) | 0)) | 0) + ((!$x_3) | 0)) | 0) + ((!$x_2) | 0)) | 0) + ((!$x_1) | 0)) | 0) + ((!$m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().lk(x$15.ce, x$16)) | 0)) | 0);
});
$p.bcm = (function(out, v) {
  if ((v === null)) {
    return out.c8((-1));
  } else {
    var ctx = out.bQ(this.aPQ(v), true, (-1));
    var x = v.gr;
    $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$();
    var x$2 = $m_sci_VectorMap$().jg;
    if ((!((x === null) ? (x$2 === null) : $f_sc_Map__equals__O__Z(x, x$2)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "nodes", $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$().a0M, v.gr);
    }
    var x$3 = v.gH;
    $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$();
    var x$4 = $m_sci_Map$EmptyMap$();
    if ((!((x$3 !== null) && x$3.e(x$4)))) {
      var this$8 = $m_Lupickle_default$();
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "arrows", new $c_Lupickle_implicits_Writers$$anon$20($m_Lorg_jpablo_graphexplorer_viewer_models_ArrowId$().Pp(), $m_Lorg_jpablo_graphexplorer_viewer_models_Arrow$().bm(), this$8), v.gH);
    }
    var x$5 = v.gq;
    $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$();
    var x$6 = $m_sci_Map$EmptyMap$();
    if ((!((x$5 !== null) && x$5.e(x$6)))) {
      var this$13 = $m_Lupickle_default$();
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "memberships", new $c_Lupickle_implicits_Writers$$anon$20($m_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$().bm(), $m_Lorg_jpablo_graphexplorer_viewer_models_GroupId$().oC(), this$13), v.gq);
    }
    var x$7 = v.gp;
    $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$();
    var x$8 = $m_sci_Map$EmptyMap$();
    if ((!((x$7 !== null) && x$7.e(x$8)))) {
      var this$18 = $m_Lupickle_default$();
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "arrowMemberships", new $c_Lupickle_implicits_Writers$$anon$20($m_Lorg_jpablo_graphexplorer_viewer_models_ArrowId$().Pp(), $m_Lorg_jpablo_graphexplorer_viewer_models_GroupId$().oC(), this$18), v.gp);
    }
    var x$9 = v.fh;
    $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$();
    var x$10 = $m_sci_Map$EmptyMap$();
    if ((!((x$9 !== null) && x$9.e(x$10)))) {
      var this$23 = $m_Lupickle_default$();
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "groups", new $c_Lupickle_implicits_Writers$$anon$20($m_Lorg_jpablo_graphexplorer_viewer_models_GroupId$().oC(), $m_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$().bm(), this$23), v.fh);
    }
    var x$11 = new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(v.dW);
    var x$12 = new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$(), $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV));
    if ((!$m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().lk(x$11.ce, x$12))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "graphAttributes", $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().lW(), new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(v.dW));
    }
    var x$13 = new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(v.fE);
    var x$14 = new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$(), $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV));
    if ((!$m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().lk(x$13.ce, x$14))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "defaultNodeAttributes", $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().lW(), new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(v.fE));
    }
    var x$15 = new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(v.fD);
    var x$16 = new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$(), $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV));
    if ((!$m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().lk(x$15.ce, x$16))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "defaultArrowAttributes", $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().lW(), new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(v.fD));
    }
    return ctx.bV((-1));
  }
});
$p.bcN = (function(ctx, v) {
  var x = v.gr;
  $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$();
  var x$2 = $m_sci_VectorMap$().jg;
  if ((!((x === null) ? (x$2 === null) : $f_sc_Map__equals__O__Z(x, x$2)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "nodes", $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$().a0M, v.gr);
  }
  var x$3 = v.gH;
  $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$();
  var x$4 = $m_sci_Map$EmptyMap$();
  if ((!((x$3 !== null) && x$3.e(x$4)))) {
    var this$8 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "arrows", new $c_Lupickle_implicits_Writers$$anon$20($m_Lorg_jpablo_graphexplorer_viewer_models_ArrowId$().Pp(), $m_Lorg_jpablo_graphexplorer_viewer_models_Arrow$().bm(), this$8), v.gH);
  }
  var x$5 = v.gq;
  $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$();
  var x$6 = $m_sci_Map$EmptyMap$();
  if ((!((x$5 !== null) && x$5.e(x$6)))) {
    var this$13 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "memberships", new $c_Lupickle_implicits_Writers$$anon$20($m_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$().bm(), $m_Lorg_jpablo_graphexplorer_viewer_models_GroupId$().oC(), this$13), v.gq);
  }
  var x$7 = v.gp;
  $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$();
  var x$8 = $m_sci_Map$EmptyMap$();
  if ((!((x$7 !== null) && x$7.e(x$8)))) {
    var this$18 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "arrowMemberships", new $c_Lupickle_implicits_Writers$$anon$20($m_Lorg_jpablo_graphexplorer_viewer_models_ArrowId$().Pp(), $m_Lorg_jpablo_graphexplorer_viewer_models_GroupId$().oC(), this$18), v.gp);
  }
  var x$9 = v.fh;
  $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$();
  var x$10 = $m_sci_Map$EmptyMap$();
  if ((!((x$9 !== null) && x$9.e(x$10)))) {
    var this$23 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "groups", new $c_Lupickle_implicits_Writers$$anon$20($m_Lorg_jpablo_graphexplorer_viewer_models_GroupId$().oC(), $m_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$().bm(), this$23), v.fh);
  }
  var x$11 = new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(v.dW);
  var x$12 = new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$(), $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV));
  if ((!$m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().lk(x$11.ce, x$12))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "graphAttributes", $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().lW(), new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(v.dW));
  }
  var x$13 = new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(v.fE);
  var x$14 = new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$(), $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV));
  if ((!$m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().lk(x$13.ce, x$14))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "defaultNodeAttributes", $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().lW(), new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(v.fE));
  }
  var x$15 = new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(v.fD);
  var x$16 = new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$(), $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV));
  if ((!$m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().lk(x$15.ce, x$16))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "defaultArrowAttributes", $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().lW(), new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(v.fD));
  }
});
$p.jW = (function(v) {
  return this.aPQ(v);
});
$p.d0 = (function(out, v) {
  return this.bcm(out, v);
});
$p.k4 = (function(ctx, v) {
  this.bcN(ctx, v);
});
var $d_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$$anon$2, "org.jpablo.graphexplorer.viewer.graph.ViewerGraphElements$$anon$2", ({
  CE: 1,
  B: 1,
  E: 1,
  af: 1,
  ah: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$$anon$1() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$$anon$1.prototype = $p;
$p.bu = (function(x) {
  if ((x !== null)) {
    if ((x.g() instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId)) {
      x.h();
      return true;
    }
  }
  return false;
});
$p.bt = (function(x, default$1) {
  if ((x !== null)) {
    var x36 = x.g();
    if ((x36 instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId)) {
      return new $c_T2(x.h(), x36);
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.bu(x);
});
$p.aC = (function(x, default$1) {
  return this.bt(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$$anon$1, "org.jpablo.graphexplorer.viewer.graph.ViewerGraphElementsToText$package$$anon$1", ({
  CG: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$$anon$2() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$$anon$2.prototype = $p;
$p.bu = (function(x) {
  if ((x !== null)) {
    if ((x.g() instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId)) {
      x.h();
      return true;
    }
  }
  return false;
});
$p.bt = (function(x, default$1) {
  if ((x !== null)) {
    var x44 = x.g();
    if ((x44 instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId)) {
      return new $c_T2(x.h(), x44);
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.bu(x);
});
$p.aC = (function(x, default$1) {
  return this.bt(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElementsToText$package$$anon$2, "org.jpablo.graphexplorer.viewer.graph.ViewerGraphElementsToText$package$$anon$2", ({
  CH: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$$anon$2() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$$anon$2.prototype = $p;
$p.r3 = (function(x) {
  if ((x !== null)) {
    if ($f_Lorg_jpablo_graphexplorer_viewer_models_ElementId__isNodeId__Z(x)) {
      return true;
    }
  }
  return false;
});
$p.qS = (function(x, default$1) {
  if ((x !== null)) {
    if ($f_Lorg_jpablo_graphexplorer_viewer_models_ElementId__isNodeId__Z(x)) {
      $m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$();
      return new $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId(x.Q9());
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.r3(x);
});
$p.aC = (function(x, default$1) {
  return this.qS(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$$anon$2, "org.jpablo.graphexplorer.viewer.graph.VisibilityRules$$anon$2", ({
  CJ: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction() {
}
$h_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$$anon$1(nodeId$2, acc$2) {
  this.Ty = null;
  this.GL = null;
  this.Ty = nodeId$2;
  this.GL = acc$2;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$$anon$1.prototype = $p;
$p.bu = (function(x) {
  if ((x !== null)) {
    var x8 = x.g();
    var x9 = x.h();
    var x$3 = this.Ty;
    if ((((x8 === null) ? (x$3 === null) : x8.e(x$3)) && this.GL.E(x9))) {
      return true;
    }
    var x$5 = this.Ty;
    if ((((x9 === null) ? (x$5 === null) : x9.e(x$5)) && this.GL.E(x8))) {
      return true;
    }
  }
  return false;
});
$p.bt = (function(x, default$1) {
  if ((x !== null)) {
    var x13 = x.g();
    var x14 = x.h();
    var x$3 = this.Ty;
    if ((((x13 === null) ? (x$3 === null) : x13.e(x$3)) && this.GL.E(x14))) {
      return this.GL.i(x14);
    }
    var x$5 = this.Ty;
    if ((((x14 === null) ? (x$5 === null) : x14.e(x$5)) && this.GL.E(x13))) {
      return this.GL.i(x13);
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.bu(x);
});
$p.aC = (function(x, default$1) {
  return this.bt(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_layout3d_ForceLayout3D$$anon$1, "org.jpablo.graphexplorer.viewer.layout3d.ForceLayout3D$$anon$1", ({
  CR: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_logging_Level() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_logging_Level.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_logging_Level;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_logging_Level() {
}
$h_Lorg_jpablo_graphexplorer_viewer_logging_Level.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.nH = (function() {
  var x = $s_Lorg_jpablo_graphexplorer_viewer_logging_Level$__Debug__Lorg_jpablo_graphexplorer_viewer_logging_Level();
  if (((x !== null) && (x === this))) {
    return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => {
      console.debug(_$1);
    }));
  }
  var x$3 = $s_Lorg_jpablo_graphexplorer_viewer_logging_Level$__Info__Lorg_jpablo_graphexplorer_viewer_logging_Level();
  if (((x$3 !== null) && (x$3 === this))) {
    return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => {
      console.info(_$2);
    }));
  }
  var x$5 = $s_Lorg_jpablo_graphexplorer_viewer_logging_Level$__Warn__Lorg_jpablo_graphexplorer_viewer_logging_Level();
  if (((x$5 !== null) && (x$5 === this))) {
    return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3) => {
      console.warn(_$3);
    }));
  }
  var x$7 = $s_Lorg_jpablo_graphexplorer_viewer_logging_Level$__Error__Lorg_jpablo_graphexplorer_viewer_logging_Level();
  if (((x$7 !== null) && (x$7 === this))) {
    return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4) => {
      console.error(_$4);
    }));
  }
  var x$9 = $s_Lorg_jpablo_graphexplorer_viewer_logging_Level$__None__Lorg_jpablo_graphexplorer_viewer_logging_Level();
  if (((x$9 !== null) && (x$9 === this))) {
    return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$5) => (void 0)));
  }
  throw new $c_s_MatchError(this);
});
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_Arrow(source, target, attributes, sourcePort, targetPort, seq) {
  this.bX = null;
  this.c0 = null;
  this.fG = null;
  this.iD = null;
  this.iE = null;
  this.jH = 0;
  this.dw = null;
  this.bX = source;
  this.c0 = target;
  this.fG = attributes;
  this.iD = sourcePort;
  this.iE = targetPort;
  this.jH = seq;
  var this$1 = (sourcePort.c() ? $m_s_None$() : new $c_s_Some((":" + sourcePort.d())));
  var sp = (this$1.c() ? "" : this$1.d());
  var this$2 = (targetPort.c() ? $m_s_None$() : new $c_s_Some((":" + targetPort.d())));
  var tp = (this$2.c() ? "" : this$2.d());
  $m_Lorg_jpablo_graphexplorer_viewer_models_ArrowId$();
  this.dw = new $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowId(((((((("" + source.dE) + sp) + $m_Lorg_jpablo_graphexplorer_viewer_models_Arrow$().a0P) + target.dE) + tp) + $m_Lorg_jpablo_graphexplorer_viewer_models_Arrow$().a0O) + seq));
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_Arrow.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_Arrow;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_Arrow() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_Arrow.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 63538153);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.bX));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.c0));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(this.fG)));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.iD));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.iE));
  acc = $m_sr_Statics$().k(acc, this.jH);
  return $m_sr_Statics$().Z(acc, 6);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_Arrow)) {
    if ((this.jH === x$0.jH)) {
      var x = this.bX;
      var x$2 = x$0.bX;
      var $x_4 = ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$3 = this.c0;
      var x$4 = x$0.c0;
      var $x_3 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$5 = this.fG;
      var x$6 = x$0.fG;
      var $x_2 = ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$7 = this.iD;
      var x$8 = x$0.iD;
      var $x_1 = ((x$7 === null) ? (x$8 === null) : x$7.e(x$8));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$9 = this.iE;
      var x$10 = x$0.iE;
      return ((x$9 === null) ? (x$10 === null) : x$9.e(x$10));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 6;
});
$p.B = (function() {
  return "Arrow";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.bX;
      break;
    }
    case 1: {
      return this.c0;
      break;
    }
    case 2: {
      return new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(this.fG);
      break;
    }
    case 3: {
      return this.iD;
      break;
    }
    case 4: {
      return this.iE;
      break;
    }
    case 5: {
      return this.jH;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "source";
      break;
    }
    case 1: {
      return "target";
      break;
    }
    case 2: {
      return "attributes";
      break;
    }
    case 3: {
      return "sourcePort";
      break;
    }
    case 4: {
      return "targetPort";
      break;
    }
    case 5: {
      return "seq";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.aeR = (function() {
  return this.fG;
});
$p.yg = (function() {
  return new $c_Lcom_softwaremill_quicklens_package$PathModify(this, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x) => {
    var source = this.bX;
    var target = this.c0;
    var ev$13 = x.i(new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(this.fG));
    return new $c_Lorg_jpablo_graphexplorer_viewer_models_Arrow(source, target, ((ev$13 === null) ? null : ev$13.ce), this.iD, this.iE, this.jH);
  })));
});
$p.kx = (function() {
  return ("arrow:" + this.dw);
});
$p.aft = (function() {
  return new $c_sci_$colon$colon(this.bX, new $c_sci_$colon$colon(this.c0, $m_sci_Nil$()));
});
$p.b6f = (function(n) {
  var x = this.bX;
  if (((x === null) ? (n === null) : x.e(n))) {
    return this.c0;
  } else {
    return this.bX;
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_models_Arrow(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.je)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_models_Arrow = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_Arrow, "org.jpablo.graphexplorer.viewer.models.Arrow", ({
  je: 1,
  dp: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_Arrow$$anon$5(WritersVersionSpecific_this$8, outer) {
  this.aUI = null;
  this.aUI = WritersVersionSpecific_this$8;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_Arrow$$anon$5.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_Arrow$$anon$5;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_Arrow$$anon$5() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_Arrow$$anon$5.prototype = $p;
$p.cT = (function() {
  return false;
});
$p.cW = (function() {
  return this;
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aPR = (function(v) {
  var x = new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(v.fG);
  var x$2 = new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(($m_Lorg_jpablo_graphexplorer_viewer_models_Arrow$(), $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV));
  var $x_2 = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().lk(x.ce, x$2);
  var x$3 = v.iD;
  $m_Lorg_jpablo_graphexplorer_viewer_models_Arrow$();
  var x$4 = $m_s_None$();
  var $x_1 = ((x$3 !== null) && x$3.e(x$4));
  var x$5 = v.iE;
  $m_Lorg_jpablo_graphexplorer_viewer_models_Arrow$();
  var x$6 = $m_s_None$();
  return ((((((((2 + ((!$x_2) | 0)) | 0) + ((!$x_1) | 0)) | 0) + ((!((x$5 !== null) && x$5.e(x$6))) | 0)) | 0) + ((!$m_sr_BoxesRunTime$().qX(v.jH, ($m_Lorg_jpablo_graphexplorer_viewer_models_Arrow$(), 1))) | 0)) | 0);
});
$p.bcn = (function(out, v) {
  if ((v === null)) {
    return out.c8((-1));
  } else {
    var ctx = out.bQ(this.aPR(v), true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "source", $m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$().An(), v.bX);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "target", $m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$().An(), v.c0);
    var x = new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(v.fG);
    var x$2 = new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(($m_Lorg_jpablo_graphexplorer_viewer_models_Arrow$(), $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV));
    if ((!$m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().lk(x.ce, x$2))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "attributes", $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().lW(), new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(v.fG));
    }
    var x$3 = v.iD;
    $m_Lorg_jpablo_graphexplorer_viewer_models_Arrow$();
    var x$4 = $m_s_None$();
    if ((!((x$3 !== null) && x$3.e(x$4)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "sourcePort", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.iD);
    }
    var x$5 = v.iE;
    $m_Lorg_jpablo_graphexplorer_viewer_models_Arrow$();
    var x$6 = $m_s_None$();
    if ((!((x$5 !== null) && x$5.e(x$6)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "targetPort", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.iE);
    }
    if ((!$m_sr_BoxesRunTime$().qX(v.jH, ($m_Lorg_jpablo_graphexplorer_viewer_models_Arrow$(), 1)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "seq", $m_Lupickle_default$().hB, v.jH);
    }
    return ctx.bV((-1));
  }
});
$p.bcO = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "source", $m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$().An(), v.bX);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "target", $m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$().An(), v.c0);
  var x = new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(v.fG);
  var x$2 = new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(($m_Lorg_jpablo_graphexplorer_viewer_models_Arrow$(), $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV));
  if ((!$m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().lk(x.ce, x$2))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "attributes", $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().lW(), new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(v.fG));
  }
  var x$3 = v.iD;
  $m_Lorg_jpablo_graphexplorer_viewer_models_Arrow$();
  var x$4 = $m_s_None$();
  if ((!((x$3 !== null) && x$3.e(x$4)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "sourcePort", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.iD);
  }
  var x$5 = v.iE;
  $m_Lorg_jpablo_graphexplorer_viewer_models_Arrow$();
  var x$6 = $m_s_None$();
  if ((!((x$5 !== null) && x$5.e(x$6)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "targetPort", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.iE);
  }
  if ((!$m_sr_BoxesRunTime$().qX(v.jH, ($m_Lorg_jpablo_graphexplorer_viewer_models_Arrow$(), 1)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "seq", $m_Lupickle_default$().hB, v.jH);
  }
});
$p.jW = (function(v) {
  return this.aPR(v);
});
$p.d0 = (function(out, v) {
  return this.bcn(out, v);
});
$p.k4 = (function(ctx, v) {
  this.bcO(ctx, v);
});
var $d_Lorg_jpablo_graphexplorer_viewer_models_Arrow$$anon$5 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_Arrow$$anon$5, "org.jpablo.graphexplorer.viewer.models.Arrow$$anon$5", ({
  D4: 1,
  B: 1,
  E: 1,
  af: 1,
  ah: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
var $d_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection = new $TypeData().i(0, "org.jpablo.graphexplorer.viewer.models.ArrowDirection", ({
  jf: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowEndpointId() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowEndpointId.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowEndpointId;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_ArrowEndpointId() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_ArrowEndpointId.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowId(value) {
  this.l3 = null;
  this.l3 = value;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowId.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowId;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_ArrowId() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_ArrowId.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 1637810248, true);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowId) && (this.l3 === x$0.l3)));
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "ArrowId";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.l3;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.Q9 = (function() {
  return this.l3;
});
$p.m = (function() {
  return this.l3;
});
$p.kx = (function() {
  return ("arrow:" + this.l3);
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_models_ArrowId(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jj)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_models_ArrowId = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_ArrowId, "org.jpablo.graphexplorer.viewer.models.ArrowId", ({
  jj: 1,
  cB: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.m = (function() {
  if ((this instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single)) {
    return $dp_toString__T(this.nd);
  }
  var x = $s_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$__Multiple__Lorg_jpablo_graphexplorer_viewer_models_AttrStatus();
  if (((x !== null) && x.e(this))) {
    return "Multiple";
  }
  var x$3 = $s_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$__Missing__Lorg_jpablo_graphexplorer_viewer_models_AttrStatus();
  if (((x$3 !== null) && x$3.e(this))) {
    return "Missing";
  }
  throw new $c_s_MatchError(this);
});
$p.a3D = (function(default$1) {
  return ((this instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single) ? this.nd : default$1);
});
$p.XD = (function(other) {
  return ((this instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single) ? this : other);
});
$p.Py = (function(a, x$2) {
  return ((this instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single) && $m_sr_BoxesRunTime$().Q(a, this.nd));
});
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_ClientSize() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_ClientSize.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_ClientSize;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_ClientSize() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_ClientSize.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_ElementId$$anon$2(WritersVersionSpecific_this$17, outer) {
  this.aUJ = null;
  this.aUJ = WritersVersionSpecific_this$17;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_ElementId$$anon$2.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_ElementId$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_ElementId$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_ElementId$$anon$2.prototype = $p;
$p.cT = (function() {
  return false;
});
$p.cW = (function() {
  return this;
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.bco = (function(out, v) {
  if ((v === null)) {
    return out.c8((-1));
  } else {
    var ctx = out.bQ(1, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "value", $m_Lupickle_default$().I, v.l3);
    return ctx.bV((-1));
  }
});
$p.bcP = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "value", $m_Lupickle_default$().I, v.l3);
});
$p.jW = (function(v) {
  return 1;
});
$p.d0 = (function(out, v) {
  return this.bco(out, v);
});
$p.k4 = (function(ctx, v) {
  this.bcP(ctx, v);
});
var $d_Lorg_jpablo_graphexplorer_viewer_models_ElementId$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_ElementId$$anon$2, "org.jpablo.graphexplorer.viewer.models.ElementId$$anon$2", ({
  Dk: 1,
  B: 1,
  E: 1,
  af: 1,
  ah: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$$anon$1() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$$anon$1.prototype = $p;
$p.Xd = (function(x) {
  return ($is_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId(x) || false);
});
$p.Wj = (function(x, default$1) {
  return ($is_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId(x) ? x : default$1.i(x));
});
$p.aM = (function(x) {
  return this.Xd(x);
});
$p.aC = (function(x, default$1) {
  return this.Wj(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$$anon$1, "org.jpablo.graphexplorer.viewer.models.ElementIds$$anon$1", ({
  Dm: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$$anon$5(WritersVersionSpecific_this$18, outer) {
  this.aUK = null;
  this.aUK = WritersVersionSpecific_this$18;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$$anon$5.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$$anon$5;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$$anon$5() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$$anon$5.prototype = $p;
$p.cT = (function() {
  return false;
});
$p.cW = (function() {
  return this;
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.bcq = (function(out, v) {
  if ((v === null)) {
    return out.c8((-1));
  } else {
    var ctx = out.bQ(1, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "value", $m_Lupickle_default$().I, v.dE);
    return ctx.bV((-1));
  }
});
$p.bcR = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "value", $m_Lupickle_default$().I, v.dE);
});
$p.jW = (function(v) {
  return 1;
});
$p.d0 = (function(out, v) {
  return this.bcq(out, v);
});
$p.k4 = (function(ctx, v) {
  this.bcR(ctx, v);
});
var $d_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$$anon$5 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$$anon$5, "org.jpablo.graphexplorer.viewer.models.GroupMemberId$$anon$5", ({
  Dr: 1,
  B: 1,
  E: 1,
  af: 1,
  ah: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$$anon$6(WritersVersionSpecific_this$19, outer) {
  this.aUL = null;
  this.aUL = WritersVersionSpecific_this$19;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$$anon$6.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$$anon$6;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$$anon$6() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$$anon$6.prototype = $p;
$p.cT = (function() {
  return false;
});
$p.cW = (function() {
  return this;
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.bcp = (function(out, v) {
  if ((v === null)) {
    return out.c8((-1));
  } else {
    var ctx = out.bQ(1, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "value", $m_Lupickle_default$().I, v.dR);
    return ctx.bV((-1));
  }
});
$p.bcQ = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "value", $m_Lupickle_default$().I, v.dR);
});
$p.jW = (function(v) {
  return 1;
});
$p.d0 = (function(out, v) {
  return this.bcp(out, v);
});
$p.k4 = (function(ctx, v) {
  this.bcQ(ctx, v);
});
var $d_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$$anon$6 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$$anon$6, "org.jpablo.graphexplorer.viewer.models.GroupMemberId$$anon$6", ({
  Ds: 1,
  B: 1,
  E: 1,
  af: 1,
  ah: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup(id, attributes) {
  this.tm = null;
  this.kb = null;
  this.tm = id;
  this.kb = attributes;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 435701872, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup)) {
    var x = this.tm;
    var x$2 = x$0.tm;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      var x$3 = this.kb;
      var x$4 = x$0.kb;
      return ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "ViewerGroup";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.tm;
  }
  if ((n === 1)) {
    return new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(this.kb);
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "id";
  }
  if ((n === 1)) {
    return "attributes";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.aeR = (function() {
  return this.kb;
});
$p.yg = (function() {
  return new $c_Lcom_softwaremill_quicklens_package$PathModify(this, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x) => {
    var id = this.tm;
    var ev$16 = x.i(new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(this.kb));
    return new $c_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup(id, ((ev$16 === null) ? null : ev$16.ce));
  })));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ju)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup, "org.jpablo.graphexplorer.viewer.models.ViewerGroup", ({
  ju: 1,
  dp: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$$anon$7(WritersVersionSpecific_this$9, outer) {
  this.aUM = null;
  this.aUM = WritersVersionSpecific_this$9;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$$anon$7.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$$anon$7;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$$anon$7() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$$anon$7.prototype = $p;
$p.cT = (function() {
  return false;
});
$p.cW = (function() {
  return this;
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aPS = (function(v) {
  var x = new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(v.kb);
  var x$2 = new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(($m_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$(), $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV));
  return ((1 + ((!$m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().lk(x.ce, x$2)) | 0)) | 0);
});
$p.bcr = (function(out, v) {
  if ((v === null)) {
    return out.c8((-1));
  } else {
    var ctx = out.bQ(this.aPS(v), true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lorg_jpablo_graphexplorer_viewer_models_GroupId$().oC(), v.tm);
    var x = new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(v.kb);
    var x$2 = new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(($m_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$(), $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV));
    if ((!$m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().lk(x.ce, x$2))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "attributes", $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().lW(), new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(v.kb));
    }
    return ctx.bV((-1));
  }
});
$p.bcS = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lorg_jpablo_graphexplorer_viewer_models_GroupId$().oC(), v.tm);
  var x = new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(v.kb);
  var x$2 = new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(($m_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$(), $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV));
  if ((!$m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().lk(x.ce, x$2))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "attributes", $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().lW(), new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(v.kb));
  }
});
$p.jW = (function(v) {
  return this.aPS(v);
});
$p.d0 = (function(out, v) {
  return this.bcr(out, v);
});
$p.k4 = (function(ctx, v) {
  this.bcS(ctx, v);
});
var $d_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$$anon$7 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$$anon$7, "org.jpablo.graphexplorer.viewer.models.ViewerGroup$$anon$7", ({
  Dw: 1,
  B: 1,
  E: 1,
  af: 1,
  ah: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode(id, attributes, kind) {
  this.o7 = null;
  this.fH = null;
  this.xh = null;
  this.o7 = id;
  this.fH = attributes;
  this.xh = kind;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-2121554489), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode)) {
    var x = this.o7;
    var x$2 = x$0.o7;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      var x$3 = this.fH;
      var x$4 = x$0.fH;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.xh;
      var x$6 = x$0.xh;
      return ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 3;
});
$p.B = (function() {
  return "ViewerNode";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.o7;
      break;
    }
    case 1: {
      return new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(this.fH);
      break;
    }
    case 2: {
      return this.xh;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "id";
      break;
    }
    case 1: {
      return "attributes";
      break;
    }
    case 2: {
      return "kind";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.aeR = (function() {
  return this.fH;
});
$p.yg = (function() {
  return new $c_Lcom_softwaremill_quicklens_package$PathModify(this, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x) => {
    var id = this.o7;
    var ev$10 = x.i(new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(this.fH));
    return new $c_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode(id, ((ev$10 === null) ? null : ev$10.ce), this.xh);
  })));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jv)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode, "org.jpablo.graphexplorer.viewer.models.ViewerNode", ({
  jv: 1,
  dp: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$$anon$2(WritersVersionSpecific_this$7, outer) {
  this.aUN = null;
  this.aUN = WritersVersionSpecific_this$7;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$$anon$2.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$$anon$2.prototype = $p;
$p.cT = (function() {
  return false;
});
$p.cW = (function() {
  return this;
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aPT = (function(v) {
  var x = new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(v.fH);
  var x$2 = new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(($m_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$(), $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV));
  var $x_1 = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().lk(x.ce, x$2);
  var x$3 = v.xh;
  $m_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$();
  var x$4 = $m_s_None$();
  return ((((1 + ((!$x_1) | 0)) | 0) + ((!((x$3 !== null) && x$3.e(x$4))) | 0)) | 0);
});
$p.bcs = (function(out, v) {
  if ((v === null)) {
    return out.c8((-1));
  } else {
    var ctx = out.bQ(this.aPT(v), true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$().An(), v.o7);
    var x = new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(v.fH);
    var x$2 = new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(($m_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$(), $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV));
    if ((!$m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().lk(x.ce, x$2))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "attributes", $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().lW(), new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(v.fH));
    }
    var x$3 = v.xh;
    $m_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$();
    var x$4 = $m_s_None$();
    if ((!((x$3 !== null) && x$3.e(x$4)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "kind", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.xh);
    }
    return ctx.bV((-1));
  }
});
$p.bcT = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$().An(), v.o7);
  var x = new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(v.fH);
  var x$2 = new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(($m_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$(), $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV));
  if ((!$m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().lk(x.ce, x$2))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "attributes", $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().lW(), new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(v.fH));
  }
  var x$3 = v.xh;
  $m_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$();
  var x$4 = $m_s_None$();
  if ((!((x$3 !== null) && x$3.e(x$4)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "kind", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.xh);
  }
});
$p.jW = (function(v) {
  return this.aPT(v);
});
$p.d0 = (function(out, v) {
  return this.bcs(out, v);
});
$p.k4 = (function(ctx, v) {
  this.bcT(ctx, v);
});
var $d_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$$anon$2, "org.jpablo.graphexplorer.viewer.models.ViewerNode$$anon$2", ({
  Dz: 1,
  B: 1,
  E: 1,
  af: 1,
  ah: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind() {
}
$h_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.u6 = (function() {
  var x = $s_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$__Nodes__Lorg_jpablo_graphexplorer_viewer_selection_ElementKind();
  if (((x !== null) && (x === this))) {
    return "nodes";
  }
  var x$3 = $s_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$__Edges__Lorg_jpablo_graphexplorer_viewer_selection_ElementKind();
  if (((x$3 !== null) && (x$3 === this))) {
    return "edges";
  }
  var x$5 = $s_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$__Groups__Lorg_jpablo_graphexplorer_viewer_selection_ElementKind();
  if (((x$5 !== null) && (x$5 === this))) {
    return "groups";
  }
  throw new $c_s_MatchError(this);
});
$p.aI = (function() {
  var x = $s_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$__Nodes__Lorg_jpablo_graphexplorer_viewer_selection_ElementKind();
  if (((x !== null) && (x === this))) {
    return "Nodes";
  }
  var x$3 = $s_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$__Edges__Lorg_jpablo_graphexplorer_viewer_selection_ElementKind();
  if (((x$3 !== null) && (x$3 === this))) {
    return "Arrows";
  }
  var x$5 = $s_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$__Groups__Lorg_jpablo_graphexplorer_viewer_selection_ElementKind();
  if (((x$5 !== null) && (x$5 === this))) {
    return "Groups";
  }
  throw new $c_s_MatchError(this);
});
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$$anon$1() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$$anon$1.prototype = $p;
$p.J5 = (function(x) {
  return ((x !== null) || false);
});
$p.IE = (function(x, default$1) {
  return ((x !== null) ? x : default$1.i(x));
});
$p.aM = (function(x) {
  return this.J5(x);
});
$p.aC = (function(x, default$1) {
  return this.IE(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$$anon$1, "org.jpablo.graphexplorer.viewer.state.DiagramSelectionOps$$anon$1", ({
  DJ: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$$anon$2() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$$anon$2.prototype = $p;
$p.b3e = (function(x) {
  return ((x instanceof $c_s_Some) || false);
});
$p.aXE = (function(x, default$1) {
  return ((x instanceof $c_s_Some) ? x.J.lj() : default$1.i(x));
});
$p.aM = (function(x) {
  return this.b3e(x);
});
$p.aC = (function(x, default$1) {
  return this.aXE(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$$anon$2, "org.jpablo.graphexplorer.viewer.state.DiagramSelectionOps$$anon$2", ({
  DK: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
function $ct_Lorg_jpablo_graphexplorer_viewer_state_NavDirection__D__D__($thiz, dx, dy) {
  $thiz.Cx = dx;
  $thiz.zy = dy;
  return $thiz;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_NavDirection() {
  this.Cx = 0.0;
  this.zy = 0.0;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_NavDirection.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_NavDirection;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_NavDirection() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_NavDirection.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.X9 = (function() {
  return (this.zy === 0.0);
});
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$$anon$3(WritersVersionSpecific_this$5, outer) {
  this.aUS = null;
  this.aUS = WritersVersionSpecific_this$5;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$$anon$3.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$$anon$3;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$$anon$3() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$$anon$3.prototype = $p;
$p.cT = (function() {
  return false;
});
$p.cW = (function() {
  return this;
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aPU = (function(v) {
  var x = new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds(v.ob);
  var x$2 = new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds(($m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$(), $m_sci_Set$EmptySet$()));
  var $x_5 = $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().a3i(x.aS, x$2);
  var x$3 = v.oa;
  $m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$();
  var x$4 = $m_sci_Set$EmptySet$();
  var $x_4 = ((x$3 !== null) && x$3.e(x$4));
  var $x_3 = v.oc;
  $m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$();
  var $x_2 = v.hf;
  $m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$();
  var x$5 = v.nf;
  $m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$();
  var x$6 = $m_s_None$();
  var $x_1 = ((x$5 !== null) && x$5.e(x$6));
  var x$7 = v.o9;
  $m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$();
  var x$8 = $m_s_None$();
  return ((((((((((((!$x_5) | 0) + ((!$x_4) | 0)) | 0) + (($x_3 !== "") | 0)) | 0) + (($x_2 !== "") | 0)) | 0) + ((!$x_1) | 0)) | 0) + ((!((x$7 !== null) && x$7.e(x$8))) | 0)) | 0);
});
$p.bct = (function(out, v) {
  if ((v === null)) {
    return out.c8((-1));
  } else {
    var ctx = out.bQ(this.aPU(v), true, (-1));
    var x = new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds(v.ob);
    var x$2 = new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds(($m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$(), $m_sci_Set$EmptySet$()));
    if ((!$m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().a3i(x.aS, x$2))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "hiddenElements", $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().ahN(), new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds(v.ob));
    }
    var x$3 = v.oa;
    $m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$();
    var x$4 = $m_sci_Set$EmptySet$();
    if ((!((x$3 !== null) && x$3.e(x$4)))) {
      var this$11 = $m_Lupickle_default$();
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "collapsedGroups", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lorg_jpablo_graphexplorer_viewer_models_GroupId$().oC(), this$11), v.oa);
    }
    if ((v.oc !== ($m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$(), ""))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "projectName", $m_Lupickle_default$().I, v.oc);
    }
    if ((v.hf !== ($m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$(), ""))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "source", $m_Lupickle_default$().I, v.hf);
    }
    var x$5 = v.nf;
    $m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$();
    var x$6 = $m_s_None$();
    if ((!((x$5 !== null) && x$5.e(x$6)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "format", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.nf);
    }
    var x$7 = v.o9;
    $m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$();
    var x$8 = $m_s_None$();
    if ((!((x$7 !== null) && x$7.e(x$8)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "autoDetectFormat", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().gP), v.o9);
    }
    return ctx.bV((-1));
  }
});
$p.bcU = (function(ctx, v) {
  var x = new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds(v.ob);
  var x$2 = new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds(($m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$(), $m_sci_Set$EmptySet$()));
  if ((!$m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().a3i(x.aS, x$2))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "hiddenElements", $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().ahN(), new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds(v.ob));
  }
  var x$3 = v.oa;
  $m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$();
  var x$4 = $m_sci_Set$EmptySet$();
  if ((!((x$3 !== null) && x$3.e(x$4)))) {
    var this$11 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "collapsedGroups", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lorg_jpablo_graphexplorer_viewer_models_GroupId$().oC(), this$11), v.oa);
  }
  if ((v.oc !== ($m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$(), ""))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "projectName", $m_Lupickle_default$().I, v.oc);
  }
  if ((v.hf !== ($m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$(), ""))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "source", $m_Lupickle_default$().I, v.hf);
  }
  var x$5 = v.nf;
  $m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$();
  var x$6 = $m_s_None$();
  if ((!((x$5 !== null) && x$5.e(x$6)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "format", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.nf);
  }
  var x$7 = v.o9;
  $m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$();
  var x$8 = $m_s_None$();
  if ((!((x$7 !== null) && x$7.e(x$8)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "autoDetectFormat", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().gP), v.o9);
  }
});
$p.jW = (function(v) {
  return this.aPU(v);
});
$p.d0 = (function(out, v) {
  return this.bct(out, v);
});
$p.k4 = (function(ctx, v) {
  this.bcU(ctx, v);
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$$anon$3 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$$anon$3, "org.jpablo.graphexplorer.viewer.state.PersistedDiagramState$$anon$3", ({
  Ef: 1,
  B: 1,
  E: 1,
  af: 1,
  ah: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_ProjectId$$anon$2(WritersVersionSpecific_this$3, outer) {
  this.aUT = null;
  this.aUT = WritersVersionSpecific_this$3;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_ProjectId$$anon$2.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_ProjectId$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_ProjectId$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_ProjectId$$anon$2.prototype = $p;
$p.cT = (function() {
  return false;
});
$p.cW = (function() {
  return this;
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.bcu = (function(out, v) {
  if ((v === null)) {
    return out.c8((-1));
  } else {
    var ctx = out.bQ(1, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "value", $m_Lupickle_default$().I, v.cv);
    return ctx.bV((-1));
  }
});
$p.bcV = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "value", $m_Lupickle_default$().I, v.cv);
});
$p.jW = (function(v) {
  return 1;
});
$p.d0 = (function(out, v) {
  return this.bcu(out, v);
});
$p.k4 = (function(ctx, v) {
  this.bcV(ctx, v);
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_ProjectId$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_ProjectId$$anon$2, "org.jpablo.graphexplorer.viewer.state.ProjectId$$anon$2", ({
  Ej: 1,
  B: 1,
  E: 1,
  af: 1,
  ah: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$$anon$2() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$$anon$2.prototype = $p;
$p.J5 = (function(x) {
  return ((!(!(x instanceof SVGGElement))) || false);
});
$p.IE = (function(x, default$1) {
  return ((!(!(x instanceof SVGGElement))) ? x : default$1.i(x));
});
$p.aM = (function(x) {
  return this.J5(x);
});
$p.aC = (function(x, default$1) {
  return this.IE(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$$anon$2, "org.jpablo.graphexplorer.viewer.state.RecordCellOps$$anon$2", ({
  Em: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$$anon$3() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$$anon$3.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$$anon$3;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$$anon$3() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$$anon$3.prototype = $p;
$p.b3d = (function(x) {
  return ((x instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Leaf) || false);
});
$p.aXD = (function(x, default$1) {
  return ((x instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_RecordTree$Leaf) ? x : default$1.i(x));
});
$p.aM = (function(x) {
  return this.b3d(x);
});
$p.aC = (function(x, default$1) {
  return this.aXD(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$$anon$3 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$$anon$3, "org.jpablo.graphexplorer.viewer.state.RecordCellOps$$anon$3", ({
  En: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
function $ct_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$CellKind__Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__($thiz, outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return $thiz;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$CellKind() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$CellKind.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$CellKind;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$CellKind() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$CellKind.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.a3U = (function() {
  return (!(this === $s_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$__none__Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection()));
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection = new $TypeData().i(0, "org.jpablo.graphexplorer.viewer.state.RightPanelSection", ({
  jP: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_SaveResult() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_SaveResult.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_SaveResult;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_SaveResult() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_SaveResult.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailDiskCache$$anon$1() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailDiskCache$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailDiskCache$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailDiskCache$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailDiskCache$$anon$1.prototype = $p;
$p.e5 = (function(x) {
  return true;
});
$p.e2 = (function(x, default$1) {
  return $m_s_None$();
});
$p.aM = (function(x) {
  return this.e5(x);
});
$p.aC = (function(x, default$1) {
  return this.e2(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailDiskCache$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailDiskCache$$anon$1, "org.jpablo.graphexplorer.viewer.state.ThumbnailDiskCache$$anon$1", ({
  Ey: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$$anon$1() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$$anon$1.prototype = $p;
$p.e5 = (function(x) {
  return true;
});
$p.e2 = (function(x, default$1) {
  return $m_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$().b6c();
});
$p.aM = (function(x) {
  return this.e5(x);
});
$p.aC = (function(x, default$1) {
  return this.e2(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_ThumbnailRenderer$$anon$1, "org.jpablo.graphexplorer.viewer.state.ThumbnailRenderer$$anon$1", ({
  EA: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$$anon$5(WritersVersionSpecific_this$6, outer) {
  this.aUZ = null;
  this.aUZ = WritersVersionSpecific_this$6;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$$anon$5.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$$anon$5;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$$anon$5() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$$anon$5.prototype = $p;
$p.cT = (function() {
  return false;
});
$p.cW = (function() {
  return this;
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aPV = (function(v) {
  var $x_14 = $m_sr_BoxesRunTime$().Q(v.mp, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), true));
  var $x_13 = $m_sr_BoxesRunTime$().qX(v.mv, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), 0));
  var x$1 = v.lH;
  $m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$();
  var x$2 = $m_s_None$();
  var $x_12 = ((x$1 !== null) && x$1.e(x$2));
  var $x_11 = $m_sr_BoxesRunTime$().Q(v.mu, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), true));
  var x$3$1 = v.mw;
  $m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$();
  var x$4 = $m_s_None$();
  var $x_10 = ((x$3$1 !== null) && x$3$1.e(x$4));
  var $x_9 = $m_sr_BoxesRunTime$().Q(v.my, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), false));
  var $x_8 = $m_sr_BoxesRunTime$().Q(v.ml, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), false));
  var $x_7 = $m_sr_BoxesRunTime$().Q(v.mx, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), false));
  var $x_6 = $m_sr_BoxesRunTime$().Q(v.mm, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), false));
  var x$5$1 = v.mo;
  $m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$();
  var x$6$1 = $m_s_None$();
  var $x_5 = ((x$5$1 !== null) && x$5$1.e(x$6$1));
  var $x_4 = $m_sr_BoxesRunTime$().Q(v.mt, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), true));
  var $x_3 = $m_sr_BoxesRunTime$().Q(v.mn, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), false));
  var $x_2 = $m_sr_BoxesRunTime$().Q(v.mr, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), false));
  var x$7$1 = v.ms;
  $m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$();
  var x$8$1 = $m_s_None$();
  var $x_1 = ((x$7$1 !== null) && x$7$1.e(x$8$1));
  var x$9$1 = v.mq;
  $m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$();
  var x$10$1 = $m_s_None$();
  return ((((((((((((((((((((((((((((((((!$x_14) | 0) + ((!$x_13) | 0)) | 0) + ((!$x_12) | 0)) | 0) + ((!$x_11) | 0)) | 0) + ((!$x_10) | 0)) | 0) + ((!$x_9) | 0)) | 0) + ((!$x_8) | 0)) | 0) + ((!$x_7) | 0)) | 0) + ((!$x_6) | 0)) | 0) + ((!$x_5) | 0)) | 0) + ((!$x_4) | 0)) | 0) + ((!$x_3) | 0)) | 0) + ((!$x_2) | 0)) | 0) + ((!$x_1) | 0)) | 0) + ((!((x$9$1 !== null) && x$9$1.e(x$10$1))) | 0)) | 0) + ((!$m_sr_BoxesRunTime$().qX(v.ni, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), $m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$().H2))) | 0)) | 0);
});
$p.bcv = (function(out, v) {
  if ((v === null)) {
    return out.c8((-1));
  } else {
    var ctx = out.bQ(this.aPV(v), true, (-1));
    if ((!$m_sr_BoxesRunTime$().Q(v.mp, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), true)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "leftPanelVisible", $m_Lupickle_default$().gP, v.mp);
    }
    if ((!$m_sr_BoxesRunTime$().qX(v.mv, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), 0)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rightPanelTabIndex", $m_Lupickle_default$().hB, v.mv);
    }
    var x$1 = v.lH;
    $m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$();
    var x$2 = $m_s_None$();
    if ((!((x$1 !== null) && x$1.e(x$2)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "currentTheme", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.lH);
    }
    if ((!$m_sr_BoxesRunTime$().Q(v.mu, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), true)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "promptLabelBeforeNewNode", $m_Lupickle_default$().gP, v.mu);
    }
    var x$3$1 = v.mw;
    $m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$();
    var x$4 = $m_s_None$();
    if ((!((x$3$1 !== null) && x$3$1.e(x$4)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rightPanelWidth", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().hB), v.mw);
    }
    if ((!$m_sr_BoxesRunTime$().Q(v.my, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), false)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "wrapSourceLines", $m_Lupickle_default$().gP, v.my);
    }
    if ((!$m_sr_BoxesRunTime$().Q(v.ml, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), false)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "elementsPinned", $m_Lupickle_default$().gP, v.ml);
    }
    if ((!$m_sr_BoxesRunTime$().Q(v.mx, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), false)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "view3D", $m_Lupickle_default$().gP, v.mx);
    }
    if ((!$m_sr_BoxesRunTime$().Q(v.mm, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), false)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "enable3D", $m_Lupickle_default$().gP, v.mm);
    }
    var x$5$1 = v.mo;
    $m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$();
    var x$6$1 = $m_s_None$();
    if ((!((x$5$1 !== null) && x$5$1.e(x$6$1)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "layout3D", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.mo);
    }
    if ((!$m_sr_BoxesRunTime$().Q(v.mt, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), true)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "nav3DTrackpad", $m_Lupickle_default$().gP, v.mt);
    }
    if ((!$m_sr_BoxesRunTime$().Q(v.mn, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), false)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "label3DBillboard", $m_Lupickle_default$().gP, v.mn);
    }
    if ((!$m_sr_BoxesRunTime$().Q(v.mr, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), false)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "libraryListMode", $m_Lupickle_default$().gP, v.mr);
    }
    var x$7$1 = v.ms;
    $m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$();
    var x$8$1 = $m_s_None$();
    if ((!((x$7$1 !== null) && x$7$1.e(x$8$1)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "librarySort", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.ms);
    }
    var x$9$1 = v.mq;
    $m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$();
    var x$10$1 = $m_s_None$();
    if ((!((x$9$1 !== null) && x$9$1.e(x$10$1)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "libraryFormatFilter", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.mq);
    }
    if ((!$m_sr_BoxesRunTime$().qX(v.ni, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), $m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$().H2)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "schemaVersion", $m_Lupickle_default$().hB, v.ni);
    }
    return ctx.bV((-1));
  }
});
$p.bcW = (function(ctx, v) {
  if ((!$m_sr_BoxesRunTime$().Q(v.mp, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), true)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "leftPanelVisible", $m_Lupickle_default$().gP, v.mp);
  }
  if ((!$m_sr_BoxesRunTime$().qX(v.mv, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), 0)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rightPanelTabIndex", $m_Lupickle_default$().hB, v.mv);
  }
  var x$1 = v.lH;
  $m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$();
  var x$2 = $m_s_None$();
  if ((!((x$1 !== null) && x$1.e(x$2)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "currentTheme", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.lH);
  }
  if ((!$m_sr_BoxesRunTime$().Q(v.mu, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), true)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "promptLabelBeforeNewNode", $m_Lupickle_default$().gP, v.mu);
  }
  var x$3$1 = v.mw;
  $m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$();
  var x$4 = $m_s_None$();
  if ((!((x$3$1 !== null) && x$3$1.e(x$4)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rightPanelWidth", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().hB), v.mw);
  }
  if ((!$m_sr_BoxesRunTime$().Q(v.my, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), false)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "wrapSourceLines", $m_Lupickle_default$().gP, v.my);
  }
  if ((!$m_sr_BoxesRunTime$().Q(v.ml, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), false)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "elementsPinned", $m_Lupickle_default$().gP, v.ml);
  }
  if ((!$m_sr_BoxesRunTime$().Q(v.mx, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), false)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "view3D", $m_Lupickle_default$().gP, v.mx);
  }
  if ((!$m_sr_BoxesRunTime$().Q(v.mm, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), false)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "enable3D", $m_Lupickle_default$().gP, v.mm);
  }
  var x$5$1 = v.mo;
  $m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$();
  var x$6$1 = $m_s_None$();
  if ((!((x$5$1 !== null) && x$5$1.e(x$6$1)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "layout3D", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.mo);
  }
  if ((!$m_sr_BoxesRunTime$().Q(v.mt, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), true)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "nav3DTrackpad", $m_Lupickle_default$().gP, v.mt);
  }
  if ((!$m_sr_BoxesRunTime$().Q(v.mn, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), false)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "label3DBillboard", $m_Lupickle_default$().gP, v.mn);
  }
  if ((!$m_sr_BoxesRunTime$().Q(v.mr, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), false)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "libraryListMode", $m_Lupickle_default$().gP, v.mr);
  }
  var x$7$1 = v.ms;
  $m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$();
  var x$8$1 = $m_s_None$();
  if ((!((x$7$1 !== null) && x$7$1.e(x$8$1)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "librarySort", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.ms);
  }
  var x$9$1 = v.mq;
  $m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$();
  var x$10$1 = $m_s_None$();
  if ((!((x$9$1 !== null) && x$9$1.e(x$10$1)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "libraryFormatFilter", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().I), v.mq);
  }
  if ((!$m_sr_BoxesRunTime$().qX(v.ni, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), $m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$().H2)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "schemaVersion", $m_Lupickle_default$().hB, v.ni);
  }
});
$p.jW = (function(v) {
  return this.aPV(v);
});
$p.d0 = (function(out, v) {
  return this.bcv(out, v);
});
$p.k4 = (function(ctx, v) {
  this.bcW(ctx, v);
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$$anon$5 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$$anon$5, "org.jpablo.graphexplorer.viewer.state.ViewerSettings$$anon$5", ({
  EG: 1,
  B: 1,
  E: 1,
  af: 1,
  ah: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.aPr = (function() {
  return (this === $s_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint$__source__Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint());
});
$p.b3p = (function() {
  return (this === $s_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint$__target__Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint());
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint = new $TypeData().i(0, "org.jpablo.graphexplorer.viewer.state.mouseActions.ArrowEndpoint", ({
  k3: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MoveArrowEndpointOps$$anon$1() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MoveArrowEndpointOps$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MoveArrowEndpointOps$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MoveArrowEndpointOps$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MoveArrowEndpointOps$$anon$1.prototype = $p;
$p.b3c = (function(x) {
  return ((!$f_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement__nodeId__s_Option(x).c()) || false);
});
$p.aXC = (function(x, default$1) {
  return ((!$f_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement__nodeId__s_Option(x).c()) ? new $c_T2($f_Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElement__nodeId__s_Option(x).d(), x) : default$1.i(x));
});
$p.aM = (function(x) {
  return this.b3c(x);
});
$p.aC = (function(x, default$1) {
  return this.aXC(x, default$1);
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MoveArrowEndpointOps$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MoveArrowEndpointOps$$anon$1, "org.jpablo.graphexplorer.viewer.state.mouseActions.MoveArrowEndpointOps$$anon$1", ({
  EU: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin() {
}
$h_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
function $ct_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone__T__($thiz, cls) {
  $thiz.U8 = cls;
  return $thiz;
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone() {
  this.U8 = null;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone() {
}
$h_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_widgets_InputType() {
}
$h_Lorg_jpablo_graphexplorer_viewer_widgets_InputType.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection() {
}
$h_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry() {
}
$h_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
function $ct_Lpprint_PPrinter__I__I__I__Z__Z__Lfansi_Attrs__Lfansi_Attrs__s_PartialFunction__($thiz, defaultWidth, defaultHeight, defaultIndent, defaultEscapeUnicode, defaultShowFieldNames, colorLiteral, colorApplyPrefix, additionalHandlers) {
  $thiz.CQ = defaultWidth;
  $thiz.CO = defaultHeight;
  $thiz.CP = defaultIndent;
  $thiz.CN = defaultEscapeUnicode;
  $thiz.Hk = defaultShowFieldNames;
  $thiz.Hj = colorLiteral;
  $thiz.Hi = colorApplyPrefix;
  $thiz.Hh = additionalHandlers;
  $ct_Lpprint_Walker__($thiz);
  return $thiz;
}
/** @constructor */
function $c_Lpprint_PPrinter() {
  this.Uy = null;
  this.CQ = 0;
  this.CO = 0;
  this.CP = 0;
  this.CN = false;
  this.Hk = false;
  this.Hj = null;
  this.Hi = null;
  this.Hh = null;
}
$p = $c_Lpprint_PPrinter.prototype = new $h_Lpprint_Walker();
$p.constructor = $c_Lpprint_PPrinter;
/** @constructor */
function $h_Lpprint_PPrinter() {
}
$h_Lpprint_PPrinter.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, $f_T__hashCode__I("PPrinter"));
  acc = $m_sr_Statics$().k(acc, this.CQ);
  acc = $m_sr_Statics$().k(acc, this.CO);
  acc = $m_sr_Statics$().k(acc, this.CP);
  acc = $m_sr_Statics$().k(acc, (this.CN ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, (this.Hk ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Hj));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Hi));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Hh));
  return $m_sr_Statics$().Z(acc, 8);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpprint_PPrinter)) {
    if ((((((this.CQ === x$0.CQ) && (this.CO === x$0.CO)) && (this.CP === x$0.CP)) && (this.CN === x$0.CN)) && (this.Hk === x$0.Hk))) {
      var x = this.Hj;
      var x$2 = x$0.Hj;
      var $x_2 = ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Hi;
      var x$4 = x$0.Hi;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Hh;
      var x$6 = x$0.Hh;
      return ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 8;
});
$p.B = (function() {
  return "PPrinter";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.CQ;
      break;
    }
    case 1: {
      return this.CO;
      break;
    }
    case 2: {
      return this.CP;
      break;
    }
    case 3: {
      return this.CN;
      break;
    }
    case 4: {
      return this.Hk;
      break;
    }
    case 5: {
      return this.Hj;
      break;
    }
    case 6: {
      return this.Hi;
      break;
    }
    case 7: {
      return this.Hh;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "defaultWidth";
      break;
    }
    case 1: {
      return "defaultHeight";
      break;
    }
    case 2: {
      return "defaultIndent";
      break;
    }
    case 3: {
      return "defaultEscapeUnicode";
      break;
    }
    case 4: {
      return "defaultShowFieldNames";
      break;
    }
    case 5: {
      return "colorLiteral";
      break;
    }
    case 6: {
      return "colorApplyPrefix";
      break;
    }
    case 7: {
      return "additionalHandlers";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.aR4 = (function(x, tag, width, height, indent, escapeUnicode, showFieldNames, out, line, fileName) {
  if ((tag === "")) {
    var tagStrs = $m_sci_Seq$().kM($m_sr_ScalaRunTime$().hP(new ($d_sr_Nothing$.r().C)([])));
  } else {
    var $x_2 = $m_sci_Seq$();
    var $x_1 = $m_sr_ScalaRunTime$();
    var this$2 = $m_Lfansi_Color$().Z3;
    var s = $m_Lfansi_Str$().iS(tag, $m_Lfansi_ErrorMode$Throw$());
    var tagStrs = $x_2.kM($x_1.f(new ($d_Lfansi_Str.r().C)([s.PG(this$2, 0, s.fC.a.length), $m_Lfansi_Str$().iS(" ", ($m_Lfansi_Str$(), $m_Lfansi_ErrorMode$Throw$()))])));
  }
  var $x_8 = $m_sci_Seq$();
  var $x_7 = $m_sr_ScalaRunTime$();
  var this$5 = $m_Lfansi_Color$().a6N;
  var s$1 = $m_Lfansi_Str$().iS(fileName.VE, $m_Lfansi_ErrorMode$Throw$());
  var $x_6 = s$1.PG(this$5, 0, s$1.fC.a.length);
  var $x_5 = $m_Lfansi_Str$().iS(":", ($m_Lfansi_Str$(), $m_Lfansi_ErrorMode$Throw$()));
  var this$10 = $m_Lfansi_Color$().Z4;
  var s$2 = $m_Lfansi_Str$().iS(("" + line.Oh), $m_Lfansi_ErrorMode$Throw$());
  var $x_4 = s$2.PG(this$10, 0, s$2.fC.a.length);
  var $x_3 = $m_Lfansi_Str$().iS(" ", ($m_Lfansi_Str$(), $m_Lfansi_ErrorMode$Throw$()));
  var this$13 = $m_Lfansi_Color$().Z3;
  var s$3 = $m_Lfansi_Str$().iS(x.VG, $m_Lfansi_ErrorMode$Throw$());
  var prefix = $x_8.kM($x_7.f(new ($d_Lfansi_Str.r().C)([$x_6, $x_5, $x_4, $x_3, s$3.PG(this$13, 0, s$3.fC.a.length), $m_Lfansi_Str$().iS(": ", ($m_Lfansi_Str$(), $m_Lfansi_ErrorMode$Throw$()))]))).gU(tagStrs);
  out.a3V(($m_Lfansi_Str$().b3R(prefix.gU($m_sci_Seq$().fw(this.ban(x.Oi, width, height, indent, 0, escapeUnicode, showFieldNames))), ($m_Lfansi_Str$(), $m_Lfansi_Str$().iS("", ($m_Lfansi_Str$(), $m_Lfansi_ErrorMode$Throw$())))) + "\n"));
  return x.Oi;
});
$p.ban = (function(x, width, height, indent, initialOffset, escapeUnicode, showFieldNames) {
  var tree = this.yr(x, escapeUnicode, showFieldNames);
  return new $c_Lpprint_Truncated(new $c_Lpprint_Renderer(width, this.Hi, this.Hj, indent).PM(tree, initialOffset, 0).qt, width, height, "...");
});
function $isArrayOf_Lpprint_PPrinter(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ki)));
}
/** @constructor */
function $c_Lpprint_Tree$Apply(prefix, body) {
  this.Ui = null;
  this.Uh = null;
  this.Ui = prefix;
  this.Uh = body;
}
$p = $c_Lpprint_Tree$Apply.prototype = new $h_O();
$p.constructor = $c_Lpprint_Tree$Apply;
/** @constructor */
function $h_Lpprint_Tree$Apply() {
}
$h_Lpprint_Tree$Apply.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().eN(this, (-889275714), null);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpprint_Tree$Apply)) {
    if ((this.Ui === x$0.Ui)) {
      var x = this.Uh;
      var x$2 = x$0.Uh;
      return ((x === null) ? (x$2 === null) : (x === x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "Apply";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Ui;
  }
  if ((n === 1)) {
    return this.Uh;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "prefix";
  }
  if ((n === 1)) {
    return "body";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpprint_Tree$Apply(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kj)));
}
var $d_Lpprint_Tree$Apply = new $TypeData().i($c_Lpprint_Tree$Apply, "pprint.Tree$Apply", ({
  kj: 1,
  bV: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lpprint_Tree$Infix(lhs, op, rhs) {
  this.Up = null;
  this.Uq = null;
  this.Ur = null;
  this.Up = lhs;
  this.Uq = op;
  this.Ur = rhs;
}
$p = $c_Lpprint_Tree$Infix.prototype = new $h_O();
$p.constructor = $c_Lpprint_Tree$Infix;
/** @constructor */
function $h_Lpprint_Tree$Infix() {
}
$h_Lpprint_Tree$Infix.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().eN(this, (-889275714), null);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpprint_Tree$Infix)) {
    var x = this.Up;
    var x$2 = x$0.Up;
    if ((((x === null) ? (x$2 === null) : x.e(x$2)) && (this.Uq === x$0.Uq))) {
      var x$3 = this.Ur;
      var x$4 = x$0.Ur;
      return ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 3;
});
$p.B = (function() {
  return "Infix";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.Up;
      break;
    }
    case 1: {
      return this.Uq;
      break;
    }
    case 2: {
      return this.Ur;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "lhs";
      break;
    }
    case 1: {
      return "op";
      break;
    }
    case 2: {
      return "rhs";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpprint_Tree$Infix(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kl)));
}
var $d_Lpprint_Tree$Infix = new $TypeData().i($c_Lpprint_Tree$Infix, "pprint.Tree$Infix", ({
  kl: 1,
  bV: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lpprint_Tree$KeyValue(key, value) {
  this.Us = null;
  this.Ut = null;
  this.Us = key;
  this.Ut = value;
}
$p = $c_Lpprint_Tree$KeyValue.prototype = new $h_O();
$p.constructor = $c_Lpprint_Tree$KeyValue;
/** @constructor */
function $h_Lpprint_Tree$KeyValue() {
}
$h_Lpprint_Tree$KeyValue.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().eN(this, (-889275714), null);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpprint_Tree$KeyValue)) {
    if ((this.Us === x$0.Us)) {
      var x = this.Ut;
      var x$2 = x$0.Ut;
      return ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "KeyValue";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Us;
  }
  if ((n === 1)) {
    return this.Ut;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "key";
  }
  if ((n === 1)) {
    return "value";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpprint_Tree$KeyValue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.km)));
}
var $d_Lpprint_Tree$KeyValue = new $TypeData().i($c_Lpprint_Tree$KeyValue, "pprint.Tree$KeyValue", ({
  km: 1,
  bV: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lpprint_Tree$Lazy(body0) {
  this.Uu = null;
  this.Uu = body0;
}
$p = $c_Lpprint_Tree$Lazy.prototype = new $h_O();
$p.constructor = $c_Lpprint_Tree$Lazy;
/** @constructor */
function $h_Lpprint_Tree$Lazy() {
}
$h_Lpprint_Tree$Lazy.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().eN(this, (-889275714), null);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpprint_Tree$Lazy)) {
    var x = this.Uu;
    var x$2 = x$0.Uu;
    return ((x === null) ? (x$2 === null) : x.e(x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Lazy";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Uu;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "body0";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpprint_Tree$Lazy(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kn)));
}
var $d_Lpprint_Tree$Lazy = new $TypeData().i($c_Lpprint_Tree$Lazy, "pprint.Tree$Lazy", ({
  kn: 1,
  bV: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lpprint_Tree$Literal(body) {
  this.Uv = null;
  this.Uv = body;
  var len = body.length;
  var i = 0;
  while ((i < len)) {
    var index = i;
    var x0 = body.charCodeAt(index);
    if (((x0 === 10) || (x0 === 13))) {
      break;
    }
    i = ((1 + i) | 0);
  }
}
$p = $c_Lpprint_Tree$Literal.prototype = new $h_O();
$p.constructor = $c_Lpprint_Tree$Literal;
/** @constructor */
function $h_Lpprint_Tree$Literal() {
}
$h_Lpprint_Tree$Literal.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().eN(this, (-889275714), null);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpprint_Tree$Literal) && (this.Uv === x$0.Uv)));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Literal";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Uv;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "body";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpprint_Tree$Literal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ko)));
}
var $d_Lpprint_Tree$Literal = new $TypeData().i($c_Lpprint_Tree$Literal, "pprint.Tree$Literal", ({
  ko: 1,
  bV: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_s_$less$colon$less$$anon$1() {
}
$p = $c_s_$less$colon$less$$anon$1.prototype = new $h_s_$eq$colon$eq();
$p.constructor = $c_s_$less$colon$less$$anon$1;
/** @constructor */
function $h_s_$less$colon$less$$anon$1() {
}
$h_s_$less$colon$less$$anon$1.prototype = $p;
$p.i = (function(x) {
  return x;
});
$p.m = (function() {
  return "generalized constraint";
});
var $d_s_$less$colon$less$$anon$1 = new $TypeData().i($c_s_$less$colon$less$$anon$1, "scala.$less$colon$less$$anon$1", ({
  FW: 1,
  FT: 1,
  FU: 1,
  h: 1,
  a: 1
}));
/** @constructor */
function $c_s_Enumeration$Val(outer, i, name) {
  this.a1d = null;
  this.vv = 0;
  this.abM = null;
  this.vv = i;
  this.abM = name;
  $ct_s_Enumeration$Value__s_Enumeration__(this, outer);
  if ((!(!outer.a1c.E(i)))) {
    throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), (("assertion failed: " + "Duplicate id: ") + this.vv));
  }
  outer.a1c.cY(i, this);
  outer.UA = ((1 + i) | 0);
  if ((outer.UA > outer.a1b)) {
    outer.a1b = outer.UA;
  }
  if ((i < outer.a1a)) {
    outer.a1a = i;
  }
}
$p = $c_s_Enumeration$Val.prototype = new $h_s_Enumeration$Value();
$p.constructor = $c_s_Enumeration$Val;
/** @constructor */
function $h_s_Enumeration$Val() {
}
$h_s_Enumeration$Val.prototype = $p;
$p.m = (function() {
  return ((this.abM !== null) ? this.abM : (((("<Unknown name for enum field #" + this.vv) + " of class ") + $objectGetClass(this)) + ">"));
});
var $d_s_Enumeration$Val = new $TypeData().i($c_s_Enumeration$Val, "scala.Enumeration$Val", ({
  G5: 1,
  kp: 1,
  b3: 1,
  Q: 1,
  a: 1
}));
function $p_s_MatchError__objString$lzycompute__T($thiz) {
  if ((!$thiz.abO)) {
    if (($thiz.a1e === null)) {
      var $x_1 = "null";
    } else {
      var this$1 = $thiz.a1e;
      var cls = $objectGetClass(this$1);
      var $x_1 = $p_s_MatchError__liftedTree1$1__T__T($thiz, ((cls === null) ? "of a JS class" : ("of class " + cls.ba.N)));
    }
    $thiz.abP = $x_1;
    $thiz.abO = true;
  }
  return $thiz.abP;
}
function $p_s_MatchError__objString__T($thiz) {
  return ((!$thiz.abO) ? $p_s_MatchError__objString$lzycompute__T($thiz) : $thiz.abP);
}
function $p_s_MatchError__liftedTree1$1__T__T($thiz, ofClass$1) {
  try {
    return ((($thiz.a1e + " (") + ofClass$1) + ")");
  } catch (e) {
    return ("an instance " + ofClass$1);
  }
}
class $c_s_MatchError extends $c_jl_RuntimeException {
  constructor(obj) {
    super();
    this.abP = null;
    this.a1e = null;
    this.abO = false;
    this.a1e = obj;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  e3() {
    return $p_s_MatchError__objString__T(this);
  }
}
var $d_s_MatchError = new $TypeData().i($c_s_MatchError, "scala.MatchError", ({
  Gb: 1,
  R: 1,
  G: 1,
  y: 1,
  a: 1
}));
/** @constructor */
function $c_s_Option() {
}
$p = $c_s_Option.prototype = new $h_O();
$p.constructor = $c_s_Option;
/** @constructor */
function $h_s_Option() {
}
$h_s_Option.prototype = $p;
$p.D = (function(n) {
  return $f_s_Product__productElementName__I__T(this, n);
});
$p.c = (function() {
  return (this === $m_s_None$());
});
$p.V = (function() {
  return ((!this.c()) | 0);
});
$p.WS = (function(ev) {
  return (this.c() ? $m_s_None$() : this.d());
});
$p.E = (function(elem) {
  return ((!this.c()) && $m_sr_BoxesRunTime$().Q(this.d(), elem));
});
$p.o = (function() {
  return (this.c() ? $m_sc_Iterator$().b8 : new $c_sc_Iterator$$anon$20(this.d()));
});
$p.bM = (function() {
  return (this.c() ? $m_sci_Nil$() : new $c_sci_$colon$colon(this.d(), $m_sci_Nil$()));
});
var $d_s_Option = new $TypeData().i(0, "scala.Option", ({
  dv: 1,
  e: 1,
  c: 1,
  b: 1,
  a: 1
}));
/** @constructor */
function $c_s_PartialFunction$Unlifted(f) {
  this.a1f = null;
  this.a1f = f;
}
$p = $c_s_PartialFunction$Unlifted.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_s_PartialFunction$Unlifted;
/** @constructor */
function $h_s_PartialFunction$Unlifted() {
}
$h_s_PartialFunction$Unlifted.prototype = $p;
$p.aM = (function(x) {
  return (!this.a1f.i(x).c());
});
$p.aC = (function(x, default$1) {
  var this$1 = this.a1f.i(x);
  return (this$1.c() ? default$1.i(x) : this$1.d());
});
$p.Ar = (function() {
  return this.a1f;
});
var $d_s_PartialFunction$Unlifted = new $TypeData().i($c_s_PartialFunction$Unlifted, "scala.PartialFunction$Unlifted", ({
  Gi: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_s_Product$$anon$1(outer) {
  this.UC = 0;
  this.aHq = 0;
  this.aHp = null;
  this.aHp = outer;
  this.UC = 0;
  this.aHq = outer.z();
}
$p = $c_s_Product$$anon$1.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_s_Product$$anon$1;
/** @constructor */
function $h_s_Product$$anon$1() {
}
$h_s_Product$$anon$1.prototype = $p;
$p.p = (function() {
  return (this.UC < this.aHq);
});
$p.q = (function() {
  var result = this.aHp.A(this.UC);
  this.UC = ((1 + this.UC) | 0);
  return result;
});
var $d_s_Product$$anon$1 = new $TypeData().i($c_s_Product$$anon$1, "scala.Product$$anon$1", ({
  Gk: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_s_Product$$anon$2(outer) {
  this.UD = 0;
  this.aHs = 0;
  this.aHr = null;
  this.aHr = outer;
  this.UD = 0;
  this.aHs = outer.z();
}
$p = $c_s_Product$$anon$2.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_s_Product$$anon$2;
/** @constructor */
function $h_s_Product$$anon$2() {
}
$h_s_Product$$anon$2.prototype = $p;
$p.p = (function() {
  return (this.UD < this.aHs);
});
$p.wa = (function() {
  var result = this.aHr.D(this.UD);
  this.UD = ((1 + this.UD) | 0);
  return result;
});
$p.q = (function() {
  return this.wa();
});
var $d_s_Product$$anon$2 = new $TypeData().i($c_s_Product$$anon$2, "scala.Product$$anon$2", ({
  Gl: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_T10(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10) {
  this.Ne = null;
  this.Ng = null;
  this.Nh = null;
  this.Ni = null;
  this.Nj = null;
  this.Nk = null;
  this.Nl = null;
  this.Nm = null;
  this.Nn = null;
  this.Nf = null;
  this.Ne = _1;
  this.Ng = _2;
  this.Nh = _3;
  this.Ni = _4;
  this.Nj = _5;
  this.Nk = _6;
  this.Nl = _7;
  this.Nm = _8;
  this.Nn = _9;
  this.Nf = _10;
}
$p = $c_T10.prototype = new $h_O();
$p.constructor = $c_T10;
/** @constructor */
function $h_T10() {
}
$h_T10.prototype = $p;
$p.z = (function() {
  return 10;
});
$p.A = (function(n) {
  return $f_s_Product10__productElement__I__O(this, n);
});
$p.m = (function() {
  return (((((((((((((((((((("(" + this.Ne) + ",") + this.Ng) + ",") + this.Nh) + ",") + this.Ni) + ",") + this.Nj) + ",") + this.Nk) + ",") + this.Nl) + ",") + this.Nm) + ",") + this.Nn) + ",") + this.Nf) + ")");
});
$p.B = (function() {
  return "Tuple10";
});
$p.H = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$p.D = (function(x$1) {
  switch (x$1) {
    case 0: {
      return "_1";
      break;
    }
    case 1: {
      return "_2";
      break;
    }
    case 2: {
      return "_3";
      break;
    }
    case 3: {
      return "_4";
      break;
    }
    case 4: {
      return "_5";
      break;
    }
    case 5: {
      return "_6";
      break;
    }
    case 6: {
      return "_7";
      break;
    }
    case 7: {
      return "_8";
      break;
    }
    case 8: {
      return "_9";
      break;
    }
    case 9: {
      return "_10";
      break;
    }
    default: {
      return $m_sr_Statics$().ey(x$1);
    }
  }
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 2104595240, true);
});
$p.e = (function(x$1) {
  return ((this === x$1) || ((x$1 instanceof $c_T10) && ((($m_sr_BoxesRunTime$().Q(this.Ne, x$1.Ne) && $m_sr_BoxesRunTime$().Q(this.Ng, x$1.Ng)) && ($m_sr_BoxesRunTime$().Q(this.Nh, x$1.Nh) && ($m_sr_BoxesRunTime$().Q(this.Ni, x$1.Ni) && $m_sr_BoxesRunTime$().Q(this.Nj, x$1.Nj)))) && (($m_sr_BoxesRunTime$().Q(this.Nk, x$1.Nk) && $m_sr_BoxesRunTime$().Q(this.Nl, x$1.Nl)) && ($m_sr_BoxesRunTime$().Q(this.Nm, x$1.Nm) && ($m_sr_BoxesRunTime$().Q(this.Nn, x$1.Nn) && $m_sr_BoxesRunTime$().Q(this.Nf, x$1.Nf)))))));
});
function $isArrayOf_T10(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kw)));
}
var $d_T10 = new $TypeData().i($c_T10, "scala.Tuple10", ({
  kw: 1,
  Gm: 1,
  c: 1,
  b: 1,
  a: 1
}));
/** @constructor */
function $c_T2(_1, _2) {
  this.bi = null;
  this.be = null;
  this.bi = _1;
  this.be = _2;
}
$p = $c_T2.prototype = new $h_O();
$p.constructor = $c_T2;
/** @constructor */
function $h_T2() {
}
$h_T2.prototype = $p;
$p.z = (function() {
  return 2;
});
$p.A = (function(n) {
  return $f_s_Product2__productElement__I__O(this, n);
});
$p.g = (function() {
  return this.bi;
});
$p.h = (function() {
  return this.be;
});
$p.m = (function() {
  return (((("(" + this.g()) + ",") + this.h()) + ")");
});
$p.b9A = (function() {
  return new $c_T2(this.h(), this.g());
});
$p.Pb = (function() {
  return this.h();
});
$p.B = (function() {
  return "Tuple2";
});
$p.H = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$p.D = (function(x$1) {
  switch (x$1) {
    case 0: {
      return "_1";
      break;
    }
    case 1: {
      return "_2";
      break;
    }
    default: {
      return $m_sr_Statics$().ey(x$1);
    }
  }
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-116390334), true);
});
$p.e = (function(x$1) {
  return ((this === x$1) || ((x$1 instanceof $c_T2) && ($m_sr_BoxesRunTime$().Q(this.g(), x$1.g()) && $m_sr_BoxesRunTime$().Q(this.h(), x$1.h()))));
});
$p.xY = (function() {
  return (this.g() | 0);
});
function $isArrayOf_T2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kx)));
}
var $d_T2 = new $TypeData().i($c_T2, "scala.Tuple2", ({
  kx: 1,
  Gn: 1,
  c: 1,
  b: 1,
  a: 1
}));
/** @constructor */
function $c_T3(_1, _2, _3) {
  this.bH = null;
  this.bU = null;
  this.c3 = null;
  this.bH = _1;
  this.bU = _2;
  this.c3 = _3;
}
$p = $c_T3.prototype = new $h_O();
$p.constructor = $c_T3;
/** @constructor */
function $h_T3() {
}
$h_T3.prototype = $p;
$p.z = (function() {
  return 3;
});
$p.A = (function(n) {
  return $f_s_Product3__productElement__I__O(this, n);
});
$p.m = (function() {
  return (((((("(" + this.bH) + ",") + this.bU) + ",") + this.c3) + ")");
});
$p.B = (function() {
  return "Tuple3";
});
$p.H = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$p.D = (function(x$1) {
  switch (x$1) {
    case 0: {
      return "_1";
      break;
    }
    case 1: {
      return "_2";
      break;
    }
    case 2: {
      return "_3";
      break;
    }
    default: {
      return $m_sr_Statics$().ey(x$1);
    }
  }
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-192629203), true);
});
$p.e = (function(x$1) {
  return ((this === x$1) || ((x$1 instanceof $c_T3) && ($m_sr_BoxesRunTime$().Q(this.bH, x$1.bH) && ($m_sr_BoxesRunTime$().Q(this.bU, x$1.bU) && $m_sr_BoxesRunTime$().Q(this.c3, x$1.c3)))));
});
function $isArrayOf_T3(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ky)));
}
var $d_T3 = new $TypeData().i($c_T3, "scala.Tuple3", ({
  ky: 1,
  Go: 1,
  c: 1,
  b: 1,
  a: 1
}));
/** @constructor */
function $c_T4(_1, _2, _3, _4) {
  this.bO = null;
  this.bs = null;
  this.ch = null;
  this.ca = null;
  this.bO = _1;
  this.bs = _2;
  this.ch = _3;
  this.ca = _4;
}
$p = $c_T4.prototype = new $h_O();
$p.constructor = $c_T4;
/** @constructor */
function $h_T4() {
}
$h_T4.prototype = $p;
$p.z = (function() {
  return 4;
});
$p.A = (function(n) {
  return $f_s_Product4__productElement__I__O(this, n);
});
$p.m = (function() {
  return (((((((("(" + this.bO) + ",") + this.bs) + ",") + this.ch) + ",") + this.ca) + ")");
});
$p.B = (function() {
  return "Tuple4";
});
$p.H = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$p.D = (function(x$1) {
  switch (x$1) {
    case 0: {
      return "_1";
      break;
    }
    case 1: {
      return "_2";
      break;
    }
    case 2: {
      return "_3";
      break;
    }
    case 3: {
      return "_4";
      break;
    }
    default: {
      return $m_sr_Statics$().ey(x$1);
    }
  }
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-1542739752), true);
});
$p.e = (function(x$1) {
  return ((this === x$1) || ((x$1 instanceof $c_T4) && (($m_sr_BoxesRunTime$().Q(this.bO, x$1.bO) && $m_sr_BoxesRunTime$().Q(this.bs, x$1.bs)) && ($m_sr_BoxesRunTime$().Q(this.ch, x$1.ch) && $m_sr_BoxesRunTime$().Q(this.ca, x$1.ca)))));
});
function $isArrayOf_T4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kz)));
}
var $d_T4 = new $TypeData().i($c_T4, "scala.Tuple4", ({
  kz: 1,
  Gp: 1,
  c: 1,
  b: 1,
  a: 1
}));
/** @constructor */
function $c_T5(_1, _2, _3, _4, _5) {
  this.No = null;
  this.Np = null;
  this.Nq = null;
  this.Nr = null;
  this.Ns = null;
  this.No = _1;
  this.Np = _2;
  this.Nq = _3;
  this.Nr = _4;
  this.Ns = _5;
}
$p = $c_T5.prototype = new $h_O();
$p.constructor = $c_T5;
/** @constructor */
function $h_T5() {
}
$h_T5.prototype = $p;
$p.z = (function() {
  return 5;
});
$p.A = (function(n) {
  return $f_s_Product5__productElement__I__O(this, n);
});
$p.m = (function() {
  return (((((((((("(" + this.No) + ",") + this.Np) + ",") + this.Nq) + ",") + this.Nr) + ",") + this.Ns) + ")");
});
$p.B = (function() {
  return "Tuple5";
});
$p.H = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$p.D = (function(x$1) {
  switch (x$1) {
    case 0: {
      return "_1";
      break;
    }
    case 1: {
      return "_2";
      break;
    }
    case 2: {
      return "_3";
      break;
    }
    case 3: {
      return "_4";
      break;
    }
    case 4: {
      return "_5";
      break;
    }
    default: {
      return $m_sr_Statics$().ey(x$1);
    }
  }
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 417360321, true);
});
$p.e = (function(x$1) {
  return ((this === x$1) || ((x$1 instanceof $c_T5) && (($m_sr_BoxesRunTime$().Q(this.No, x$1.No) && $m_sr_BoxesRunTime$().Q(this.Np, x$1.Np)) && ($m_sr_BoxesRunTime$().Q(this.Nq, x$1.Nq) && ($m_sr_BoxesRunTime$().Q(this.Nr, x$1.Nr) && $m_sr_BoxesRunTime$().Q(this.Ns, x$1.Ns))))));
});
function $isArrayOf_T5(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kA)));
}
var $d_T5 = new $TypeData().i($c_T5, "scala.Tuple5", ({
  kA: 1,
  Gq: 1,
  c: 1,
  b: 1,
  a: 1
}));
/** @constructor */
function $c_T6(_1, _2, _3, _4, _5, _6) {
  this.Nt = null;
  this.Nu = null;
  this.Nv = null;
  this.Nw = null;
  this.Nx = null;
  this.Ny = null;
  this.Nt = _1;
  this.Nu = _2;
  this.Nv = _3;
  this.Nw = _4;
  this.Nx = _5;
  this.Ny = _6;
}
$p = $c_T6.prototype = new $h_O();
$p.constructor = $c_T6;
/** @constructor */
function $h_T6() {
}
$h_T6.prototype = $p;
$p.z = (function() {
  return 6;
});
$p.A = (function(n) {
  return $f_s_Product6__productElement__I__O(this, n);
});
$p.m = (function() {
  return (((((((((((("(" + this.Nt) + ",") + this.Nu) + ",") + this.Nv) + ",") + this.Nw) + ",") + this.Nx) + ",") + this.Ny) + ")");
});
$p.B = (function() {
  return "Tuple6";
});
$p.H = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$p.D = (function(x$1) {
  switch (x$1) {
    case 0: {
      return "_1";
      break;
    }
    case 1: {
      return "_2";
      break;
    }
    case 2: {
      return "_3";
      break;
    }
    case 3: {
      return "_4";
      break;
    }
    case 4: {
      return "_5";
      break;
    }
    case 5: {
      return "_6";
      break;
    }
    default: {
      return $m_sr_Statics$().ey(x$1);
    }
  }
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-1037607828), true);
});
$p.e = (function(x$1) {
  return ((this === x$1) || ((x$1 instanceof $c_T6) && (($m_sr_BoxesRunTime$().Q(this.Nt, x$1.Nt) && ($m_sr_BoxesRunTime$().Q(this.Nu, x$1.Nu) && $m_sr_BoxesRunTime$().Q(this.Nv, x$1.Nv))) && ($m_sr_BoxesRunTime$().Q(this.Nw, x$1.Nw) && ($m_sr_BoxesRunTime$().Q(this.Nx, x$1.Nx) && $m_sr_BoxesRunTime$().Q(this.Ny, x$1.Ny))))));
});
function $isArrayOf_T6(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kB)));
}
var $d_T6 = new $TypeData().i($c_T6, "scala.Tuple6", ({
  kB: 1,
  Gr: 1,
  c: 1,
  b: 1,
  a: 1
}));
/** @constructor */
function $c_T9(_1, _2, _3, _4, _5, _6, _7, _8, _9) {
  this.Nz = null;
  this.NA = null;
  this.NB = null;
  this.NC = null;
  this.ND = null;
  this.NE = null;
  this.NF = null;
  this.NG = null;
  this.NH = null;
  this.Nz = _1;
  this.NA = _2;
  this.NB = _3;
  this.NC = _4;
  this.ND = _5;
  this.NE = _6;
  this.NF = _7;
  this.NG = _8;
  this.NH = _9;
}
$p = $c_T9.prototype = new $h_O();
$p.constructor = $c_T9;
/** @constructor */
function $h_T9() {
}
$h_T9.prototype = $p;
$p.z = (function() {
  return 9;
});
$p.A = (function(n) {
  return $f_s_Product9__productElement__I__O(this, n);
});
$p.m = (function() {
  return (((((((((((((((((("(" + this.Nz) + ",") + this.NA) + ",") + this.NB) + ",") + this.NC) + ",") + this.ND) + ",") + this.NE) + ",") + this.NF) + ",") + this.NG) + ",") + this.NH) + ")");
});
$p.B = (function() {
  return "Tuple9";
});
$p.H = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$p.D = (function(x$1) {
  switch (x$1) {
    case 0: {
      return "_1";
      break;
    }
    case 1: {
      return "_2";
      break;
    }
    case 2: {
      return "_3";
      break;
    }
    case 3: {
      return "_4";
      break;
    }
    case 4: {
      return "_5";
      break;
    }
    case 5: {
      return "_6";
      break;
    }
    case 6: {
      return "_7";
      break;
    }
    case 7: {
      return "_8";
      break;
    }
    case 8: {
      return "_9";
      break;
    }
    default: {
      return $m_sr_Statics$().ey(x$1);
    }
  }
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-1807911176), true);
});
$p.e = (function(x$1) {
  return ((this === x$1) || ((x$1 instanceof $c_T9) && ((($m_sr_BoxesRunTime$().Q(this.Nz, x$1.Nz) && $m_sr_BoxesRunTime$().Q(this.NA, x$1.NA)) && ($m_sr_BoxesRunTime$().Q(this.NB, x$1.NB) && $m_sr_BoxesRunTime$().Q(this.NC, x$1.NC))) && (($m_sr_BoxesRunTime$().Q(this.ND, x$1.ND) && $m_sr_BoxesRunTime$().Q(this.NE, x$1.NE)) && ($m_sr_BoxesRunTime$().Q(this.NF, x$1.NF) && ($m_sr_BoxesRunTime$().Q(this.NG, x$1.NG) && $m_sr_BoxesRunTime$().Q(this.NH, x$1.NH)))))));
});
function $isArrayOf_T9(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kC)));
}
var $d_T9 = new $TypeData().i($c_T9, "scala.Tuple9", ({
  kC: 1,
  Gs: 1,
  c: 1,
  b: 1,
  a: 1
}));
/** @constructor */
function $c_sc_ClassTagSeqFactory$AnySeqDelegate(delegate) {
  this.NI = null;
  $ct_sc_ClassTagIterableFactory$AnyIterableDelegate__sc_ClassTagIterableFactory__(this, delegate);
}
$p = $c_sc_ClassTagSeqFactory$AnySeqDelegate.prototype = new $h_sc_ClassTagIterableFactory$AnyIterableDelegate();
$p.constructor = $c_sc_ClassTagSeqFactory$AnySeqDelegate;
/** @constructor */
function $h_sc_ClassTagSeqFactory$AnySeqDelegate() {
}
$h_sc_ClassTagSeqFactory$AnySeqDelegate.prototype = $p;
var $d_sc_ClassTagSeqFactory$AnySeqDelegate = new $TypeData().i($c_sc_ClassTagSeqFactory$AnySeqDelegate, "scala.collection.ClassTagSeqFactory$AnySeqDelegate", ({
  GK: 1,
  GJ: 1,
  a0: 1,
  a: 1,
  at: 1
}));
function $f_sc_IndexedSeqOps__prepended__O__O($thiz, elem) {
  return $thiz.cd().cc(new $c_sc_IndexedSeqView$Prepended(elem, $thiz));
}
function $f_sc_IndexedSeqOps__take__I__O($thiz, n) {
  return $thiz.fP(new $c_sc_IndexedSeqView$Take($thiz, n));
}
function $f_sc_IndexedSeqOps__drop__I__O($thiz, n) {
  return $thiz.fP($ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), $thiz, n));
}
function $f_sc_IndexedSeqOps__dropRight__I__O($thiz, n) {
  return $thiz.fP($ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), $thiz, n));
}
function $f_sc_IndexedSeqOps__map__F1__O($thiz, f) {
  return $thiz.cd().cc($ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), $thiz, f));
}
function $f_sc_IndexedSeqOps__reverse__O($thiz) {
  return $thiz.fP($ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), $thiz));
}
function $f_sc_IndexedSeqOps__slice__I__I__O($thiz, from, until) {
  return $thiz.fP(new $c_sc_IndexedSeqView$Slice($thiz, from, until));
}
function $f_sc_IndexedSeqOps__sliding__I__I__sc_Iterator($thiz, size, step) {
  if ((!((size >= 1) && (step >= 1)))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("requirement failed: " + $m_sc_StringOps$().u0("size=%d and step=%d, but both must be positive", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [size, step]))));
  }
  return new $c_sc_IndexedSeqSlidingIterator($thiz, size, step);
}
function $f_sc_IndexedSeqOps__head__O($thiz) {
  if ((!$thiz.c())) {
    return $thiz.l(0);
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("head of empty " + ($is_sc_IndexedSeq($thiz) ? $thiz.hM() : $thiz.m())));
  }
}
function $f_sc_IndexedSeqOps__headOption__s_Option($thiz) {
  return ($thiz.c() ? $m_s_None$() : new $c_s_Some($thiz.t()));
}
function $f_sc_IndexedSeqOps__last__O($thiz) {
  if ((!$thiz.c())) {
    return $thiz.l((($thiz.C() - 1) | 0));
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("last of empty " + ($is_sc_IndexedSeq($thiz) ? $thiz.hM() : $thiz.m())));
  }
}
function $p_sc_IndexedSeqSlidingIterator__chklen__Z($thiz) {
  if (($thiz.zQ === $thiz.abZ.C())) {
    return true;
  } else {
    throw new $c_ju_ConcurrentModificationException("collection size changed during iteration");
  }
}
/** @constructor */
function $c_sc_IndexedSeqSlidingIterator(s, size, step) {
  this.abZ = null;
  this.aHw = 0;
  this.aHx = 0;
  this.zQ = 0;
  this.NJ = 0;
  this.abZ = s;
  this.aHw = size;
  this.aHx = step;
  this.zQ = s.C();
  this.NJ = 0;
}
$p = $c_sc_IndexedSeqSlidingIterator.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_IndexedSeqSlidingIterator;
/** @constructor */
function $h_sc_IndexedSeqSlidingIterator() {
}
$h_sc_IndexedSeqSlidingIterator.prototype = $p;
$p.p = (function() {
  return ($p_sc_IndexedSeqSlidingIterator__chklen__Z(this) && (this.NJ < this.zQ));
});
$p.q = (function() {
  if (((!$p_sc_IndexedSeqSlidingIterator__chklen__Z(this)) || (!this.p()))) {
    return $m_sc_Iterator$().b8.q();
  } else {
    var x = ((this.NJ + this.aHw) | 0);
    var end = (((x < 0) || (x > this.zQ)) ? this.zQ : x);
    var slice = this.abZ.hV(this.NJ, end);
    if ((end >= this.zQ)) {
      var $x_1 = this.zQ;
    } else {
      var x$2 = ((this.NJ + this.aHx) | 0);
      var $x_1 = (((x$2 < 0) || (x$2 > this.zQ)) ? this.zQ : x$2);
    }
    this.NJ = $x_1;
    return slice;
  }
});
var $d_sc_IndexedSeqSlidingIterator = new $TypeData().i($c_sc_IndexedSeqSlidingIterator, "scala.collection.IndexedSeqSlidingIterator", ({
  GN: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
function $f_sc_Iterable__toString__T($thiz) {
  return $f_sc_IterableOnceOps__mkString__T__T__T__T($thiz, ($thiz.hM() + "("), ", ", ")");
}
function $is_sc_Iterable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.k)));
}
function $isArrayOf_sc_Iterable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.k)));
}
var $d_sc_Iterable = new $TypeData().i(1, "scala.collection.Iterable", ({
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1
}));
function $p_sc_Iterator$$anon$10__nextCur__V($thiz) {
  $thiz.NK = $m_sc_Iterator$().b8;
  $thiz.NK = $thiz.aHD.i($thiz.ac7.q()).o();
  $thiz.Ho = (-1);
}
/** @constructor */
function $c_sc_Iterator$$anon$10(outer, f$3) {
  this.NK = null;
  this.Ho = 0;
  this.ac7 = null;
  this.aHD = null;
  this.ac7 = outer;
  this.aHD = f$3;
  this.NK = $m_sc_Iterator$().b8;
  this.Ho = (-1);
}
$p = $c_sc_Iterator$$anon$10.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_Iterator$$anon$10;
/** @constructor */
function $h_sc_Iterator$$anon$10() {
}
$h_sc_Iterator$$anon$10.prototype = $p;
$p.p = (function() {
  if ((this.Ho === (-1))) {
    while ((!this.NK.p())) {
      if ((!this.ac7.p())) {
        this.Ho = 0;
        this.NK = $m_sc_Iterator$().b8;
        return false;
      }
      $p_sc_Iterator$$anon$10__nextCur__V(this);
    }
    this.Ho = 1;
    return true;
  } else {
    return (this.Ho === 1);
  }
});
$p.q = (function() {
  if (this.p()) {
    this.Ho = (-1);
  }
  return this.NK.q();
});
var $d_sc_Iterator$$anon$10 = new $TypeData().i($c_sc_Iterator$$anon$10, "scala.collection.Iterator$$anon$10", ({
  GZ: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$11(outer, p$2) {
  this.ac8 = null;
  this.UI = false;
  this.a1i = null;
  this.aHE = null;
  this.aHE = p$2;
  this.UI = false;
  this.a1i = outer;
}
$p = $c_sc_Iterator$$anon$11.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_Iterator$$anon$11;
/** @constructor */
function $h_sc_Iterator$$anon$11() {
}
$h_sc_Iterator$$anon$11.prototype = $p;
$p.p = (function() {
  if (this.UI) {
    return true;
  } else if (this.a1i.p()) {
    this.ac8 = this.a1i.q();
    if ((!(!this.aHE.i(this.ac8)))) {
      this.UI = true;
    } else {
      this.a1i = $m_sc_Iterator$().b8;
    }
    return this.UI;
  } else {
    return false;
  }
});
$p.q = (function() {
  if (this.p()) {
    this.UI = false;
    return this.ac8;
  } else {
    return $m_sc_Iterator$().b8.q();
  }
});
var $d_sc_Iterator$$anon$11 = new $TypeData().i($c_sc_Iterator$$anon$11, "scala.collection.Iterator$$anon$11", ({
  H0: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$12(outer, p$3) {
  this.Hp = 0;
  this.aHF = null;
  this.UJ = null;
  this.aHG = null;
  this.UJ = outer;
  this.aHG = p$3;
  this.Hp = (-1);
}
$p = $c_sc_Iterator$$anon$12.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_Iterator$$anon$12;
/** @constructor */
function $h_sc_Iterator$$anon$12() {
}
$h_sc_Iterator$$anon$12.prototype = $p;
$p.p = (function() {
  if ((this.Hp === 1)) {
    return this.UJ.p();
  } else if ((this.Hp === 0)) {
    return true;
  } else {
    while (this.UJ.p()) {
      var a = this.UJ.q();
      if ((!(!(!this.aHG.i(a))))) {
        this.aHF = a;
        this.Hp = 0;
        return true;
      }
    }
    this.Hp = 1;
    return false;
  }
});
$p.q = (function() {
  if (this.p()) {
    if ((this.Hp === 1)) {
      return this.UJ.q();
    } else {
      this.Hp = 1;
      return this.aHF;
    }
  } else {
    return $m_sc_Iterator$().b8.q();
  }
});
var $d_sc_Iterator$$anon$12 = new $TypeData().i($c_sc_Iterator$$anon$12, "scala.collection.Iterator$$anon$12", ({
  H1: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$14(outer, that$1) {
  this.a1k = null;
  this.a1j = null;
  this.a1j = outer;
  this.a1k = that$1.o();
}
$p = $c_sc_Iterator$$anon$14.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_Iterator$$anon$14;
/** @constructor */
function $h_sc_Iterator$$anon$14() {
}
$h_sc_Iterator$$anon$14.prototype = $p;
$p.V = (function() {
  var x = this.a1j.V();
  var that = this.a1k.V();
  return ((x < that) ? x : that);
});
$p.p = (function() {
  return (this.a1j.p() && this.a1k.p());
});
$p.dC = (function() {
  return new $c_T2(this.a1j.q(), this.a1k.q());
});
$p.q = (function() {
  return this.dC();
});
var $d_sc_Iterator$$anon$14 = new $TypeData().i($c_sc_Iterator$$anon$14, "scala.collection.Iterator$$anon$14", ({
  H2: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$16(outer) {
  this.a1m = 0;
  this.a1l = null;
  this.a1l = outer;
  this.a1m = 0;
}
$p = $c_sc_Iterator$$anon$16.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_Iterator$$anon$16;
/** @constructor */
function $h_sc_Iterator$$anon$16() {
}
$h_sc_Iterator$$anon$16.prototype = $p;
$p.V = (function() {
  return this.a1l.V();
});
$p.p = (function() {
  return this.a1l.p();
});
$p.dC = (function() {
  var ret = new $c_T2(this.a1l.q(), this.a1m);
  this.a1m = ((1 + this.a1m) | 0);
  return ret;
});
$p.q = (function() {
  return this.dC();
});
var $d_sc_Iterator$$anon$16 = new $TypeData().i($c_sc_Iterator$$anon$16, "scala.collection.Iterator$$anon$16", ({
  H3: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$19() {
}
$p = $c_sc_Iterator$$anon$19.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_Iterator$$anon$19;
/** @constructor */
function $h_sc_Iterator$$anon$19() {
}
$h_sc_Iterator$$anon$19.prototype = $p;
$p.p = (function() {
  return false;
});
$p.Xz = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "next on empty iterator");
});
$p.V = (function() {
  return 0;
});
$p.ui = (function(from, until) {
  return this;
});
$p.q = (function() {
  this.Xz();
});
var $d_sc_Iterator$$anon$19 = new $TypeData().i($c_sc_Iterator$$anon$19, "scala.collection.Iterator$$anon$19", ({
  H4: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$20(a$1) {
  this.UK = false;
  this.aHH = null;
  this.aHH = a$1;
  this.UK = false;
}
$p = $c_sc_Iterator$$anon$20.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_Iterator$$anon$20;
/** @constructor */
function $h_sc_Iterator$$anon$20() {
}
$h_sc_Iterator$$anon$20.prototype = $p;
$p.p = (function() {
  return (!this.UK);
});
$p.q = (function() {
  if (this.UK) {
    return $m_sc_Iterator$().b8.q();
  } else {
    this.UK = true;
    return this.aHH;
  }
});
$p.ui = (function(from, until) {
  return (((this.UK || (from > 0)) || (until === 0)) ? $m_sc_Iterator$().b8 : this);
});
var $d_sc_Iterator$$anon$20 = new $TypeData().i($c_sc_Iterator$$anon$20, "scala.collection.Iterator$$anon$20", ({
  H5: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$24(start$1, step$1) {
  this.a1n = 0;
  this.aHI = 0;
  this.aHI = step$1;
  this.a1n = start$1;
}
$p = $c_sc_Iterator$$anon$24.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_Iterator$$anon$24;
/** @constructor */
function $h_sc_Iterator$$anon$24() {
}
$h_sc_Iterator$$anon$24.prototype = $p;
$p.p = (function() {
  return true;
});
$p.hp = (function() {
  var result = this.a1n;
  this.a1n = ((this.a1n + this.aHI) | 0);
  return result;
});
$p.q = (function() {
  return this.hp();
});
var $d_sc_Iterator$$anon$24 = new $TypeData().i($c_sc_Iterator$$anon$24, "scala.collection.Iterator$$anon$24", ({
  H7: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$3(outer, z$1, op$1) {
  this.UM = null;
  this.UL = null;
  this.ac9 = null;
  this.aHJ = null;
  this.UL = outer;
  this.ac9 = z$1;
  this.aHJ = op$1;
  this.UM = new $c_sc_Iterator$$anon$3$$anon$4(this);
}
$p = $c_sc_Iterator$$anon$3.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_Iterator$$anon$3;
/** @constructor */
function $h_sc_Iterator$$anon$3() {
}
$h_sc_Iterator$$anon$3.prototype = $p;
$p.V = (function() {
  return this.UM.V();
});
$p.q = (function() {
  return this.UM.q();
});
$p.p = (function() {
  return this.UM.p();
});
var $d_sc_Iterator$$anon$3 = new $TypeData().i($c_sc_Iterator$$anon$3, "scala.collection.Iterator$$anon$3", ({
  H8: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$3$$anon$4(outer) {
  this.zT = null;
  this.zT = outer;
}
$p = $c_sc_Iterator$$anon$3$$anon$4.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_Iterator$$anon$3$$anon$4;
/** @constructor */
function $h_sc_Iterator$$anon$3$$anon$4() {
}
$h_sc_Iterator$$anon$3$$anon$4.prototype = $p;
$p.V = (function() {
  var thisSize = this.zT.UL.V();
  return ((thisSize < 0) ? (-1) : ((1 + thisSize) | 0));
});
$p.p = (function() {
  return true;
});
$p.q = (function() {
  this.zT.UM = new $c_sc_Iterator$$anon$3$$anon$4$$anon$5(this);
  return this.zT.ac9;
});
var $d_sc_Iterator$$anon$3$$anon$4 = new $TypeData().i($c_sc_Iterator$$anon$3$$anon$4, "scala.collection.Iterator$$anon$3$$anon$4", ({
  H9: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$3$$anon$4$$anon$5(outer) {
  this.a1o = null;
  this.UN = null;
  this.UN = outer;
  this.a1o = outer.zT.ac9;
}
$p = $c_sc_Iterator$$anon$3$$anon$4$$anon$5.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_Iterator$$anon$3$$anon$4$$anon$5;
/** @constructor */
function $h_sc_Iterator$$anon$3$$anon$4$$anon$5() {
}
$h_sc_Iterator$$anon$3$$anon$4$$anon$5.prototype = $p;
$p.q = (function() {
  this.a1o = this.UN.zT.aHJ.R(this.a1o, this.UN.zT.UL.q());
  return this.a1o;
});
$p.p = (function() {
  return this.UN.zT.UL.p();
});
$p.V = (function() {
  return this.UN.zT.UL.V();
});
var $d_sc_Iterator$$anon$3$$anon$4$$anon$5 = new $TypeData().i($c_sc_Iterator$$anon$3$$anon$4$$anon$5, "scala.collection.Iterator$$anon$3$$anon$4$$anon$5", ({
  Ha: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$6(outer, p$1, isFlipped$1) {
  this.a1p = null;
  this.a1q = false;
  this.UO = null;
  this.aHL = null;
  this.aHK = false;
  this.UO = outer;
  this.aHL = p$1;
  this.aHK = isFlipped$1;
  this.a1q = false;
}
$p = $c_sc_Iterator$$anon$6.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_Iterator$$anon$6;
/** @constructor */
function $h_sc_Iterator$$anon$6() {
}
$h_sc_Iterator$$anon$6.prototype = $p;
$p.p = (function() {
  if (this.a1q) {
    return true;
  } else {
    if ((!this.UO.p())) {
      return false;
    }
    this.a1p = this.UO.q();
    while (((!(!this.aHL.i(this.a1p))) === this.aHK)) {
      if ((!this.UO.p())) {
        return false;
      }
      this.a1p = this.UO.q();
    }
    this.a1q = true;
    return true;
  }
});
$p.q = (function() {
  if (this.p()) {
    this.a1q = false;
    return this.a1p;
  } else {
    return $m_sc_Iterator$().b8.q();
  }
});
var $d_sc_Iterator$$anon$6 = new $TypeData().i($c_sc_Iterator$$anon$6, "scala.collection.Iterator$$anon$6", ({
  Hb: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$8(outer, f$1) {
  this.aHQ = null;
  this.a1r = false;
  this.aHP = null;
  this.acb = null;
  this.aHO = null;
  this.acb = outer;
  this.aHO = f$1;
  this.aHQ = $ct_scm_HashSet__(new $c_scm_HashSet());
  this.a1r = false;
}
$p = $c_sc_Iterator$$anon$8.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_Iterator$$anon$8;
/** @constructor */
function $h_sc_Iterator$$anon$8() {
}
$h_sc_Iterator$$anon$8.prototype = $p;
$p.p = (function() {
  while (true) {
    if (this.a1r) {
      return true;
    } else if (this.acb.p()) {
      var a = this.acb.q();
      if ((!this.aHQ.oA(this.aHO.i(a)))) {
        continue;
      }
      this.aHP = a;
      this.a1r = true;
      return true;
    } else {
      return false;
    }
  }
});
$p.q = (function() {
  if (this.p()) {
    this.a1r = false;
    return this.aHP;
  } else {
    return $m_sc_Iterator$().b8.q();
  }
});
var $d_sc_Iterator$$anon$8 = new $TypeData().i($c_sc_Iterator$$anon$8, "scala.collection.Iterator$$anon$8", ({
  Hd: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$9(outer, f$2) {
  this.a1s = null;
  this.aHR = null;
  this.a1s = outer;
  this.aHR = f$2;
}
$p = $c_sc_Iterator$$anon$9.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_Iterator$$anon$9;
/** @constructor */
function $h_sc_Iterator$$anon$9() {
}
$h_sc_Iterator$$anon$9.prototype = $p;
$p.V = (function() {
  return this.a1s.V();
});
$p.p = (function() {
  return this.a1s.p();
});
$p.q = (function() {
  return this.aHR.i(this.a1s.q());
});
var $d_sc_Iterator$$anon$9 = new $TypeData().i($c_sc_Iterator$$anon$9, "scala.collection.Iterator$$anon$9", ({
  He: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
function $p_sc_Iterator$ConcatIterator__merge$1__V($thiz) {
  while (true) {
    if (($thiz.p7 instanceof $c_sc_Iterator$ConcatIterator)) {
      var c = $thiz.p7;
      $thiz.p7 = c.p7;
      $thiz.CT = c.CT;
      if ((c.tx !== null)) {
        if (($thiz.tw === null)) {
          $thiz.tw = c.tw;
        }
        c.tw.UP = $thiz.tx;
        $thiz.tx = c.tx;
      }
      continue;
    }
    return (void 0);
  }
}
function $p_sc_Iterator$ConcatIterator__advance$1__Z($thiz) {
  while (true) {
    if (($thiz.tx === null)) {
      $thiz.p7 = null;
      $thiz.tw = null;
      return false;
    } else {
      $thiz.p7 = $thiz.tx.b2y();
      if (($thiz.tw === $thiz.tx)) {
        $thiz.tw = $thiz.tw.UP;
      }
      $thiz.tx = $thiz.tx.UP;
      $p_sc_Iterator$ConcatIterator__merge$1__V($thiz);
      if ($thiz.CT) {
        return true;
      } else {
        if ((!(($thiz.p7 !== null) && $thiz.p7.p()))) {
          continue;
        }
        $thiz.CT = true;
        return true;
      }
    }
  }
}
/** @constructor */
function $c_sc_Iterator$ConcatIterator(current) {
  this.p7 = null;
  this.tx = null;
  this.tw = null;
  this.CT = false;
  this.p7 = current;
  this.tx = null;
  this.tw = null;
  this.CT = false;
}
$p = $c_sc_Iterator$ConcatIterator.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_Iterator$ConcatIterator;
/** @constructor */
function $h_sc_Iterator$ConcatIterator() {
}
$h_sc_Iterator$ConcatIterator.prototype = $p;
$p.p = (function() {
  if (this.CT) {
    return true;
  } else if ((this.p7 !== null)) {
    if (this.p7.p()) {
      this.CT = true;
      return true;
    } else {
      return $p_sc_Iterator$ConcatIterator__advance$1__Z(this);
    }
  } else {
    return false;
  }
});
$p.q = (function() {
  if (this.p()) {
    this.CT = false;
    return this.p7.q();
  } else {
    return $m_sc_Iterator$().b8.q();
  }
});
$p.lS = (function(that) {
  var c = new $c_sc_Iterator$ConcatIteratorCell(that, null);
  if ((this.tx === null)) {
    this.tx = c;
    this.tw = c;
  } else {
    this.tw.UP = c;
    this.tw = c;
  }
  if ((this.p7 === null)) {
    this.p7 = $m_sc_Iterator$().b8;
  }
  return this;
});
function $isArrayOf_sc_Iterator$ConcatIterator(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kO)));
}
var $d_sc_Iterator$ConcatIterator = new $TypeData().i($c_sc_Iterator$ConcatIterator, "scala.collection.Iterator$ConcatIterator", ({
  kO: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
function $p_sc_Iterator$SliceIterator__skip__V($thiz) {
  while (($thiz.zU > 0)) {
    if ($thiz.CU.p()) {
      $thiz.CU.q();
      $thiz.zU = (($thiz.zU - 1) | 0);
    } else {
      $thiz.zU = 0;
    }
  }
}
function $p_sc_Iterator$SliceIterator__adjustedBound$1__I__I($thiz, lo$1) {
  if (($thiz.qx < 0)) {
    return (-1);
  } else {
    var that = (($thiz.qx - lo$1) | 0);
    return ((that < 0) ? 0 : that);
  }
}
/** @constructor */
function $c_sc_Iterator$SliceIterator(underlying, start, limit) {
  this.CU = null;
  this.qx = 0;
  this.zU = 0;
  this.CU = underlying;
  this.qx = limit;
  this.zU = start;
}
$p = $c_sc_Iterator$SliceIterator.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_Iterator$SliceIterator;
/** @constructor */
function $h_sc_Iterator$SliceIterator() {
}
$h_sc_Iterator$SliceIterator.prototype = $p;
$p.V = (function() {
  var size = this.CU.V();
  if ((size < 0)) {
    return (-1);
  } else {
    var that = ((size - this.zU) | 0);
    var dropSize = ((that < 0) ? 0 : that);
    if ((this.qx < 0)) {
      return dropSize;
    } else {
      var x = this.qx;
      return ((x < dropSize) ? x : dropSize);
    }
  }
});
$p.p = (function() {
  $p_sc_Iterator$SliceIterator__skip__V(this);
  return ((this.qx !== 0) && this.CU.p());
});
$p.q = (function() {
  $p_sc_Iterator$SliceIterator__skip__V(this);
  if ((this.qx > 0)) {
    this.qx = ((this.qx - 1) | 0);
    return this.CU.q();
  } else {
    return ((this.qx < 0) ? this.CU.q() : $m_sc_Iterator$().b8.q());
  }
});
$p.ui = (function(from, until) {
  var lo = ((from > 0) ? from : 0);
  if ((until < 0)) {
    var rest = $p_sc_Iterator$SliceIterator__adjustedBound$1__I__I(this, lo);
  } else if ((until <= lo)) {
    var rest = 0;
  } else if ((this.qx < 0)) {
    var rest = ((until - lo) | 0);
  } else {
    var x = $p_sc_Iterator$SliceIterator__adjustedBound$1__I__I(this, lo);
    var that = ((until - lo) | 0);
    var rest = ((x < that) ? x : that);
  }
  var sum = ((this.zU + lo) | 0);
  if ((rest === 0)) {
    return $m_sc_Iterator$().b8;
  } else if ((sum < 0)) {
    this.zU = 2147483647;
    this.qx = 0;
    return $f_sc_Iterator__concat__F0__sc_Iterator(this, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => new $c_sc_Iterator$SliceIterator(this.CU, ((sum - 2147483647) | 0), rest))));
  } else {
    this.zU = sum;
    this.qx = rest;
    return this;
  }
});
var $d_sc_Iterator$SliceIterator = new $TypeData().i($c_sc_Iterator$SliceIterator, "scala.collection.Iterator$SliceIterator", ({
  Hg: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_sc_Iterator$UnfoldIterator(init, f) {
  this.aHT = null;
  this.a1t = null;
  this.NM = null;
  this.aHT = f;
  this.a1t = init;
  this.NM = null;
}
$p = $c_sc_Iterator$UnfoldIterator.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_Iterator$UnfoldIterator;
/** @constructor */
function $h_sc_Iterator$UnfoldIterator() {
}
$h_sc_Iterator$UnfoldIterator.prototype = $p;
$p.p = (function() {
  if ((this.NM === null)) {
    var res = this.aHT.i(this.a1t);
    if ((res === null)) {
      throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "null during unfold");
    }
    this.NM = res;
    this.a1t = null;
  }
  return (!this.NM.c());
});
$p.q = (function() {
  if (this.p()) {
    var x1 = this.NM.d();
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1);
    }
    var value = x1.g();
    var newState = x1.h();
    this.a1t = newState;
    this.NM = null;
    return value;
  } else {
    return $m_sc_Iterator$().b8.q();
  }
});
var $d_sc_Iterator$UnfoldIterator = new $TypeData().i($c_sc_Iterator$UnfoldIterator, "scala.collection.Iterator$UnfoldIterator", ({
  Hh: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
function $f_sc_LinearSeqOps__headOption__s_Option($thiz) {
  return ($thiz.c() ? $m_s_None$() : new $c_s_Some($thiz.t()));
}
function $f_sc_LinearSeqOps__length__I($thiz) {
  var these = $thiz;
  var len = 0;
  while ((!these.c())) {
    len = ((1 + len) | 0);
    these = these.v();
  }
  return len;
}
function $f_sc_LinearSeqOps__last__O($thiz) {
  if ($thiz.c()) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "LinearSeq.last");
  } else {
    var these = $thiz;
    var scout = $thiz.v();
    while ((!scout.c())) {
      these = scout;
      scout = scout.v();
    }
    return these.t();
  }
}
function $f_sc_LinearSeqOps__lengthCompare__I__I($thiz, len) {
  return ((len < 0) ? 1 : $p_sc_LinearSeqOps__loop$1__I__sc_LinearSeq__I__I($thiz, 0, $thiz, len));
}
function $f_sc_LinearSeqOps__isDefinedAt__I__Z($thiz, x) {
  return ((x >= 0) && ($thiz.bL(x) > 0));
}
function $f_sc_LinearSeqOps__apply__I__O($thiz, n) {
  if ((n < 0)) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  var skipped = $thiz.ds(n);
  if (skipped.c()) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  return skipped.t();
}
function $f_sc_LinearSeqOps__forall__F1__Z($thiz, p) {
  var these = $thiz;
  while ((!these.c())) {
    if ((!(!(!p.i(these.t()))))) {
      return false;
    }
    these = these.v();
  }
  return true;
}
function $f_sc_LinearSeqOps__exists__F1__Z($thiz, p) {
  var these = $thiz;
  while ((!these.c())) {
    if ((!(!p.i(these.t())))) {
      return true;
    }
    these = these.v();
  }
  return false;
}
function $f_sc_LinearSeqOps__contains__O__Z($thiz, elem) {
  var these = $thiz;
  while ((!these.c())) {
    if ($m_sr_BoxesRunTime$().Q(these.t(), elem)) {
      return true;
    }
    these = these.v();
  }
  return false;
}
function $f_sc_LinearSeqOps__foldLeft__O__F2__O($thiz, z, op) {
  var acc = z;
  var these = $thiz;
  while ((!these.c())) {
    acc = op.R(acc, these.t());
    these = these.v();
  }
  return acc;
}
function $f_sc_LinearSeqOps__sameElements__sc_IterableOnce__Z($thiz, that) {
  return ($is_sc_LinearSeq(that) ? $p_sc_LinearSeqOps__linearSeqEq$1__sc_LinearSeq__sc_LinearSeq__Z($thiz, $thiz, that) : $f_sc_SeqOps__sameElements__sc_IterableOnce__Z($thiz, that));
}
function $f_sc_LinearSeqOps__indexWhere__F1__I__I($thiz, p, from) {
  var i = ((from > 0) ? from : 0);
  var these = $thiz.ds(from);
  while ((!these.c())) {
    if ((!(!p.i(these.t())))) {
      return i;
    }
    i = ((1 + i) | 0);
    these = these.v();
  }
  return (-1);
}
function $p_sc_LinearSeqOps__loop$1__I__sc_LinearSeq__I__I($thiz, i, xs, len$1) {
  while (true) {
    if ((i === len$1)) {
      return ((!xs.c()) | 0);
    } else {
      if ((!xs.c())) {
        var temp$i = ((1 + i) | 0);
        var temp$xs = xs.v();
        i = temp$i;
        xs = temp$xs;
        continue;
      }
      return (-1);
    }
  }
}
function $p_sc_LinearSeqOps__linearSeqEq$1__sc_LinearSeq__sc_LinearSeq__Z($thiz, a, b) {
  while (true) {
    if ((a === b)) {
      return true;
    } else {
      if ((((!a.c()) && (!b.c())) && $m_sr_BoxesRunTime$().Q(a.t(), b.t()))) {
        var temp$a = a.v();
        var temp$b = b.v();
        a = temp$a;
        b = temp$b;
        continue;
      }
      return (a.c() && b.c());
    }
  }
}
/** @constructor */
function $c_sc_MapOps$$anon$2(outer) {
  this.ace = null;
  this.ace = outer.o();
}
$p = $c_sc_MapOps$$anon$2.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_MapOps$$anon$2;
/** @constructor */
function $h_sc_MapOps$$anon$2() {
}
$h_sc_MapOps$$anon$2.prototype = $p;
$p.p = (function() {
  return this.ace.p();
});
$p.q = (function() {
  return this.ace.q().g();
});
var $d_sc_MapOps$$anon$2 = new $TypeData().i($c_sc_MapOps$$anon$2, "scala.collection.MapOps$$anon$2", ({
  Hl: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_sc_MapOps$$anon$3(outer) {
  this.acf = null;
  this.acf = outer.o();
}
$p = $c_sc_MapOps$$anon$3.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_MapOps$$anon$3;
/** @constructor */
function $h_sc_MapOps$$anon$3() {
}
$h_sc_MapOps$$anon$3.prototype = $p;
$p.p = (function() {
  return this.acf.p();
});
$p.q = (function() {
  return this.acf.q().h();
});
var $d_sc_MapOps$$anon$3 = new $TypeData().i($c_sc_MapOps$$anon$3, "scala.collection.MapOps$$anon$3", ({
  Hm: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_sc_Seq$() {
  this.xw = null;
  $ct_sc_SeqFactory$Delegate__sc_SeqFactory__(this, $m_sci_Seq$());
}
$p = $c_sc_Seq$.prototype = new $h_sc_SeqFactory$Delegate();
$p.constructor = $c_sc_Seq$;
/** @constructor */
function $h_sc_Seq$() {
}
$h_sc_Seq$.prototype = $p;
var $d_sc_Seq$ = new $TypeData().i($c_sc_Seq$, "scala.collection.Seq$", ({
  Hw: 1,
  bZ: 1,
  at: 1,
  a0: 1,
  a: 1
}));
var $n_sc_Seq$;
function $m_sc_Seq$() {
  if ((!$n_sc_Seq$)) {
    $n_sc_Seq$ = new $c_sc_Seq$();
  }
  return $n_sc_Seq$;
}
function $f_sc_SetOps__concat__sc_IterableOnce__sc_SetOps($thiz, that) {
  if ((($thiz instanceof $c_sci_Set$Set1) || (($thiz instanceof $c_sci_Set$Set2) || (($thiz instanceof $c_sci_Set$Set3) || ($thiz instanceof $c_sci_Set$Set4))))) {
    var result = $thiz;
    var it = that.o();
    while (it.p()) {
      result = result.hQ(it.q());
    }
    return result;
  } else {
    return $thiz.w4(($is_sc_Iterable(that) ? new $c_sc_View$Concat($thiz, that) : $thiz.o().lS(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => that.o())))));
  }
}
/** @constructor */
function $c_sc_StrictOptimizedLinearSeqOps$$anon$1(outer) {
  this.UV = null;
  this.UV = outer;
}
$p = $c_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_StrictOptimizedLinearSeqOps$$anon$1;
/** @constructor */
function $h_sc_StrictOptimizedLinearSeqOps$$anon$1() {
}
$h_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype = $p;
$p.p = (function() {
  return (!this.UV.c());
});
$p.q = (function() {
  var r = this.UV.t();
  this.UV = this.UV.v();
  return r;
});
var $d_sc_StrictOptimizedLinearSeqOps$$anon$1 = new $TypeData().i($c_sc_StrictOptimizedLinearSeqOps$$anon$1, "scala.collection.StrictOptimizedLinearSeqOps$$anon$1", ({
  HD: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
function $p_sc_StringOps$$anon$1__advance__T($thiz) {
  var start = $thiz.kd;
  while (true) {
    if (($thiz.kd < $thiz.zV)) {
      var this$ = $thiz.UW;
      var i = $thiz.kd;
      var c = this$.charCodeAt(i);
      var $x_1 = (!((c === 10) || (c === 13)));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $thiz.kd = ((1 + $thiz.kd) | 0);
    } else {
      break;
    }
  }
  var end = $thiz.kd;
  if (($thiz.kd < $thiz.zV)) {
    var this$$2 = $thiz.UW;
    var i$1 = $thiz.kd;
    var c$1 = this$$2.charCodeAt(i$1);
    $thiz.kd = ((1 + $thiz.kd) | 0);
    if ((($thiz.kd < $thiz.zV) && (((13 ^ c$1) | (10 ^ $thiz.UW.charCodeAt($thiz.kd))) === 0))) {
      $thiz.kd = ((1 + $thiz.kd) | 0);
    }
    if ((!$thiz.aHX)) {
      end = $thiz.kd;
    }
  }
  var this$6 = $thiz.UW;
  var endIndex = end;
  return this$6.substring(start, endIndex);
}
/** @constructor */
function $c_sc_StringOps$$anon$1(\u03b4this$2, stripped$1) {
  this.zV = 0;
  this.kd = 0;
  this.UW = null;
  this.aHX = false;
  this.UW = \u03b4this$2;
  this.aHX = stripped$1;
  this.zV = \u03b4this$2.length;
  this.kd = 0;
}
$p = $c_sc_StringOps$$anon$1.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_StringOps$$anon$1;
/** @constructor */
function $h_sc_StringOps$$anon$1() {
}
$h_sc_StringOps$$anon$1.prototype = $p;
$p.p = (function() {
  return (this.kd < this.zV);
});
$p.wa = (function() {
  return ((this.kd >= this.zV) ? $m_sc_Iterator$().b8.q() : $p_sc_StringOps$$anon$1__advance__T(this));
});
$p.q = (function() {
  return this.wa();
});
var $d_sc_StringOps$$anon$1 = new $TypeData().i($c_sc_StringOps$$anon$1, "scala.collection.StringOps$$anon$1", ({
  HG: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_sc_View$DropRightIterator(underlying, maxlen) {
  this.NT = null;
  this.a1G = 0;
  this.CW = 0;
  this.vw = 0;
  this.V1 = null;
  this.NT = underlying;
  this.a1G = maxlen;
  this.CW = (-1);
  this.vw = 0;
}
$p = $c_sc_View$DropRightIterator.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_View$DropRightIterator;
/** @constructor */
function $h_sc_View$DropRightIterator() {
}
$h_sc_View$DropRightIterator.prototype = $p;
$p.b2O = (function() {
  if ((this.V1 === null)) {
    var x = this.a1G;
    this.V1 = $ct_scm_ArrayBuffer__I__(new $c_scm_ArrayBuffer(), ((x < 256) ? x : 256));
    while (((this.vw < this.a1G) && this.NT.p())) {
      this.V1.aw(this.NT.q());
      this.vw = ((1 + this.vw) | 0);
    }
    if ((!this.NT.p())) {
      this.CW = 0;
    }
    this.vw = 0;
  }
});
$p.V = (function() {
  return this.CW;
});
$p.p = (function() {
  this.b2O();
  return (this.CW !== 0);
});
$p.q = (function() {
  if ((!this.p())) {
    return $m_sc_Iterator$().b8.q();
  } else {
    var x = this.V1.l(this.vw);
    if ((this.CW === (-1))) {
      this.V1.cM(this.vw, this.NT.q());
      if ((!this.NT.p())) {
        this.CW = 0;
      }
    } else {
      this.CW = ((this.CW - 1) | 0);
    }
    this.vw = ((1 + this.vw) | 0);
    if ((this.vw === this.a1G)) {
      this.vw = 0;
    }
    return x;
  }
});
var $d_sc_View$DropRightIterator = new $TypeData().i($c_sc_View$DropRightIterator, "scala.collection.View$DropRightIterator", ({
  HN: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
function $p_sc_View$LeftPartitionMapped$$anon$2__findNext$1__Z($thiz) {
  while (true) {
    if ($thiz.acu.p()) {
      var x1 = $thiz.aI8.aI6.i($thiz.acu.q());
      if ((!(x1 instanceof $c_s_util_Left))) {
        if ((x1 instanceof $c_s_util_Right)) {
          continue;
        }
        throw new $c_s_MatchError(x1);
      }
      var a1 = x1.lP;
      $thiz.aI9 = a1;
      $thiz.a1I = true;
      return true;
    } else {
      return false;
    }
  }
}
/** @constructor */
function $c_sc_View$LeftPartitionMapped$$anon$2(outer) {
  this.acu = null;
  this.aI9 = null;
  this.a1I = false;
  this.aI8 = null;
  this.aI8 = outer;
  this.acu = outer.aI7.o();
  this.a1I = false;
}
$p = $c_sc_View$LeftPartitionMapped$$anon$2.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_View$LeftPartitionMapped$$anon$2;
/** @constructor */
function $h_sc_View$LeftPartitionMapped$$anon$2() {
}
$h_sc_View$LeftPartitionMapped$$anon$2.prototype = $p;
$p.p = (function() {
  return (this.a1I || $p_sc_View$LeftPartitionMapped$$anon$2__findNext$1__Z(this));
});
$p.q = (function() {
  if (this.p()) {
    this.a1I = false;
    return this.aI9;
  } else {
    return $m_sc_Iterator$().b8.q();
  }
});
var $d_sc_View$LeftPartitionMapped$$anon$2 = new $TypeData().i($c_sc_View$LeftPartitionMapped$$anon$2, "scala.collection.View$LeftPartitionMapped$$anon$2", ({
  HU: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
function $p_sc_View$RightPartitionMapped$$anon$3__findNext$2__Z($thiz) {
  while (true) {
    if ($thiz.acx.p()) {
      var x1 = $thiz.aIc.aIa.i($thiz.acx.q());
      if ((x1 instanceof $c_s_util_Left)) {
        continue;
      }
      if ((!(x1 instanceof $c_s_util_Right))) {
        throw new $c_s_MatchError(x1);
      }
      var a2 = x1.hm;
      $thiz.aId = a2;
      $thiz.a1J = true;
      return true;
    } else {
      return false;
    }
  }
}
/** @constructor */
function $c_sc_View$RightPartitionMapped$$anon$3(outer) {
  this.acx = null;
  this.aId = null;
  this.a1J = false;
  this.aIc = null;
  this.aIc = outer;
  this.acx = outer.aIb.o();
  this.a1J = false;
}
$p = $c_sc_View$RightPartitionMapped$$anon$3.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_View$RightPartitionMapped$$anon$3;
/** @constructor */
function $h_sc_View$RightPartitionMapped$$anon$3() {
}
$h_sc_View$RightPartitionMapped$$anon$3.prototype = $p;
$p.p = (function() {
  return (this.a1J || $p_sc_View$RightPartitionMapped$$anon$3__findNext$2__Z(this));
});
$p.q = (function() {
  if (this.p()) {
    this.a1J = false;
    return this.aId;
  } else {
    return $m_sc_Iterator$().b8.q();
  }
});
var $d_sc_View$RightPartitionMapped$$anon$3 = new $TypeData().i($c_sc_View$RightPartitionMapped$$anon$3, "scala.collection.View$RightPartitionMapped$$anon$3", ({
  HX: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
function $p_sci_ChampBaseIterator__initNodes__V($thiz) {
  if (($thiz.og === null)) {
    $thiz.og = new $ac_I(($m_sci_Node$().V6 << 1));
    $thiz.vy = new ($d_sci_Node.r().C)($m_sci_Node$().V6);
  }
}
function $p_sci_ChampBaseIterator__setupPayloadNode__sci_Node__V($thiz, node) {
  $thiz.ke = node;
  $thiz.ea = 0;
  $thiz.vx = node.XI();
}
function $p_sci_ChampBaseIterator__pushNode__sci_Node__V($thiz, node) {
  $p_sci_ChampBaseIterator__initNodes__V($thiz);
  $thiz.kF = ((1 + $thiz.kF) | 0);
  var cursorIndex = ($thiz.kF << 1);
  var lengthIndex = ((1 + ($thiz.kF << 1)) | 0);
  $thiz.vy.a[$thiz.kF] = node;
  $thiz.og.a[cursorIndex] = 0;
  $thiz.og.a[lengthIndex] = node.XA();
}
function $p_sci_ChampBaseIterator__popNode__V($thiz) {
  $thiz.kF = (($thiz.kF - 1) | 0);
}
function $p_sci_ChampBaseIterator__searchNextValueNode__Z($thiz) {
  while (($thiz.kF >= 0)) {
    var cursorIndex = ($thiz.kF << 1);
    var lengthIndex = ((1 + ($thiz.kF << 1)) | 0);
    var nodeCursor = $thiz.og.a[cursorIndex];
    if ((nodeCursor < $thiz.og.a[lengthIndex])) {
      var ev$1 = $thiz.og;
      ev$1.a[cursorIndex] = ((1 + ev$1.a[cursorIndex]) | 0);
      var nextNode = $thiz.vy.a[$thiz.kF].X1(nodeCursor);
      if (nextNode.X6()) {
        $p_sci_ChampBaseIterator__pushNode__sci_Node__V($thiz, nextNode);
      }
      if (nextNode.Ps()) {
        $p_sci_ChampBaseIterator__setupPayloadNode__sci_Node__V($thiz, nextNode);
        return true;
      }
    } else {
      $p_sci_ChampBaseIterator__popNode__V($thiz);
    }
  }
  return false;
}
function $ct_sci_ChampBaseIterator__($thiz) {
  $thiz.ea = 0;
  $thiz.vx = 0;
  $thiz.kF = (-1);
  return $thiz;
}
function $ct_sci_ChampBaseIterator__sci_Node__($thiz, rootNode) {
  $ct_sci_ChampBaseIterator__($thiz);
  if (rootNode.X6()) {
    $p_sci_ChampBaseIterator__pushNode__sci_Node__V($thiz, rootNode);
  }
  if (rootNode.Ps()) {
    $p_sci_ChampBaseIterator__setupPayloadNode__sci_Node__V($thiz, rootNode);
  }
  return $thiz;
}
/** @constructor */
function $c_sci_ChampBaseIterator() {
  this.ea = 0;
  this.vx = 0;
  this.ke = null;
  this.kF = 0;
  this.og = null;
  this.vy = null;
}
$p = $c_sci_ChampBaseIterator.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sci_ChampBaseIterator;
/** @constructor */
function $h_sci_ChampBaseIterator() {
}
$h_sci_ChampBaseIterator.prototype = $p;
$p.p = (function() {
  return ((this.ea < this.vx) || $p_sci_ChampBaseIterator__searchNextValueNode__Z(this));
});
function $p_sci_ChampBaseReverseIterator__setupPayloadNode__sci_Node__V($thiz, node) {
  $thiz.CX = node;
  $thiz.nj = ((node.XI() - 1) | 0);
}
function $p_sci_ChampBaseReverseIterator__pushNode__sci_Node__V($thiz, node) {
  $thiz.oh = ((1 + $thiz.oh) | 0);
  $thiz.Hy.a[$thiz.oh] = node;
  $thiz.Hx.a[$thiz.oh] = ((node.XA() - 1) | 0);
}
function $p_sci_ChampBaseReverseIterator__popNode__V($thiz) {
  $thiz.oh = (($thiz.oh - 1) | 0);
}
function $p_sci_ChampBaseReverseIterator__searchNextValueNode__Z($thiz) {
  while (($thiz.oh >= 0)) {
    var nodeCursor = $thiz.Hx.a[$thiz.oh];
    $thiz.Hx.a[$thiz.oh] = ((nodeCursor - 1) | 0);
    if ((nodeCursor >= 0)) {
      $p_sci_ChampBaseReverseIterator__pushNode__sci_Node__V($thiz, $thiz.Hy.a[$thiz.oh].X1(nodeCursor));
    } else {
      var currNode = $thiz.Hy.a[$thiz.oh];
      $p_sci_ChampBaseReverseIterator__popNode__V($thiz);
      if (currNode.Ps()) {
        $p_sci_ChampBaseReverseIterator__setupPayloadNode__sci_Node__V($thiz, currNode);
        return true;
      }
    }
  }
  return false;
}
function $ct_sci_ChampBaseReverseIterator__($thiz) {
  $thiz.nj = (-1);
  $thiz.oh = (-1);
  $thiz.Hx = new $ac_I(((1 + $m_sci_Node$().V6) | 0));
  $thiz.Hy = new ($d_sci_Node.r().C)(((1 + $m_sci_Node$().V6) | 0));
  return $thiz;
}
function $ct_sci_ChampBaseReverseIterator__sci_Node__($thiz, rootNode) {
  $ct_sci_ChampBaseReverseIterator__($thiz);
  $p_sci_ChampBaseReverseIterator__pushNode__sci_Node__V($thiz, rootNode);
  $p_sci_ChampBaseReverseIterator__searchNextValueNode__Z($thiz);
  return $thiz;
}
/** @constructor */
function $c_sci_ChampBaseReverseIterator() {
  this.nj = 0;
  this.CX = null;
  this.oh = 0;
  this.Hx = null;
  this.Hy = null;
}
$p = $c_sci_ChampBaseReverseIterator.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sci_ChampBaseReverseIterator;
/** @constructor */
function $h_sci_ChampBaseReverseIterator() {
}
$h_sci_ChampBaseReverseIterator.prototype = $p;
$p.p = (function() {
  return ((this.nj >= 0) || $p_sci_ChampBaseReverseIterator__searchNextValueNode__Z(this));
});
function $p_sci_HashMapBuilder__isAliased__Z($thiz) {
  return ($thiz.NU !== null);
}
function $p_sci_HashMapBuilder__insertElement__AI__I__I__AI($thiz, as, ix, elem) {
  if ((ix < 0)) {
    throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException());
  }
  if ((ix > as.a.length)) {
    throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException());
  }
  var result = new $ac_I(((1 + as.a.length) | 0));
  as.av(0, result, 0, ix);
  result.a[ix] = elem;
  var destPos = ((1 + ix) | 0);
  var length = ((as.a.length - ix) | 0);
  as.av(ix, result, destPos, length);
  return result;
}
function $p_sci_HashMapBuilder__insertValue__sci_BitmapIndexedMapNode__I__O__I__I__O__V($thiz, bm, bitpos, key, originalHash, keyHash, value) {
  var dataIx = bm.kN(bitpos);
  var idx = (dataIx << 1);
  var src = bm.eJ;
  var dst = new $ac_O(((2 + src.a.length) | 0));
  src.av(0, dst, 0, idx);
  dst.a[idx] = key;
  dst.a[((1 + idx) | 0)] = value;
  var destPos = ((2 + idx) | 0);
  var length = ((src.a.length - idx) | 0);
  src.av(idx, dst, destPos, length);
  var dstHashes = $p_sci_HashMapBuilder__insertElement__AI__I__I__AI($thiz, bm.i2, dataIx, originalHash);
  bm.cm = (bm.cm | bitpos);
  bm.eJ = dst;
  bm.i2 = dstHashes;
  bm.dS = ((1 + bm.dS) | 0);
  bm.jL = ((bm.jL + keyHash) | 0);
}
function $p_sci_HashMapBuilder__ensureUnaliased__V($thiz) {
  if ($p_sci_HashMapBuilder__isAliased__Z($thiz)) {
    $p_sci_HashMapBuilder__copyElems__V($thiz);
  }
  $thiz.NU = null;
}
function $p_sci_HashMapBuilder__copyElems__V($thiz) {
  $thiz.qA = $thiz.qA.aN2();
}
/** @constructor */
function $c_sci_HashMapBuilder() {
  this.NU = null;
  this.qA = null;
  this.qA = new $c_sci_BitmapIndexedMapNode(0, 0, $m_s_Array$EmptyArrays$().abL, $m_s_Array$EmptyArrays$().Uz, 0, 0);
}
$p = $c_sci_HashMapBuilder.prototype = new $h_O();
$p.constructor = $c_sci_HashMapBuilder;
/** @constructor */
function $h_sci_HashMapBuilder() {
}
$h_sci_HashMapBuilder.prototype = $p;
$p.f9 = (function(size) {
});
$p.a3C = (function(key, value) {
  if ((this.qA.dS === 0)) {
    return value;
  } else {
    var originalHash = $m_sr_Statics$().u(key);
    return this.qA.a3B(key, originalHash, $m_sc_Hashing$().bz(originalHash), 0, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => value)));
  }
});
$p.JE = (function(mapNode, key, value, originalHash, keyHash, shift) {
  if ((mapNode instanceof $c_sci_BitmapIndexedMapNode)) {
    var mask = $m_sci_Node$().fR(keyHash, shift);
    var bitpos = $m_sci_Node$().d6(mask);
    if (((mapNode.cm & bitpos) !== 0)) {
      var index = $m_sci_Node$().h1(mapNode.cm, mask, bitpos);
      var key0 = mapNode.gy(index);
      var key0UnimprovedHash = mapNode.cK(index);
      if (((key0UnimprovedHash === originalHash) && $m_sr_BoxesRunTime$().Q(key0, key))) {
        mapNode.eJ.a[((1 + (index << 1)) | 0)] = value;
      } else {
        var value0 = mapNode.h0(index);
        var key0Hash = $m_sc_Hashing$().bz(key0UnimprovedHash);
        var subNodeNew = mapNode.Xx(key0, value0, key0UnimprovedHash, key0Hash, key, value, originalHash, keyHash, ((5 + shift) | 0));
        mapNode.aQk(bitpos, key0Hash, subNodeNew);
      }
    } else if (((mapNode.db & bitpos) !== 0)) {
      var index$2 = $m_sci_Node$().h1(mapNode.db, mask, bitpos);
      var subNode = mapNode.jp(index$2);
      var beforeSize = subNode.aa();
      var beforeHash = subNode.dH();
      this.JE(subNode, key, value, originalHash, keyHash, ((5 + shift) | 0));
      mapNode.dS = ((mapNode.dS + ((subNode.aa() - beforeSize) | 0)) | 0);
      mapNode.jL = ((mapNode.jL + ((subNode.dH() - beforeHash) | 0)) | 0);
    } else {
      $p_sci_HashMapBuilder__insertValue__sci_BitmapIndexedMapNode__I__O__I__I__O__V(this, mapNode, bitpos, key, originalHash, keyHash, value);
    }
  } else if ((mapNode instanceof $c_sci_HashCollisionMapNode)) {
    var index$3 = mapNode.J1(key);
    if ((index$3 < 0)) {
      mapNode.fI = mapNode.fI.lg(new $c_T2(key, value));
    } else {
      mapNode.fI = mapNode.fI.nI(index$3, new $c_T2(key, value));
    }
  } else {
    throw new $c_s_MatchError(mapNode);
  }
});
$p.a4x = (function() {
  if ((this.qA.dS === 0)) {
    return $m_sci_HashMap$().fk;
  } else if ((this.NU !== null)) {
    return this.NU;
  } else {
    this.NU = new $c_sci_HashMap(this.qA);
    return this.NU;
  }
});
$p.aLT = (function(elem) {
  $p_sci_HashMapBuilder__ensureUnaliased__V(this);
  var h = $m_sr_Statics$().u(elem.g());
  var im = $m_sc_Hashing$().bz(h);
  this.JE(this.qA, elem.g(), elem.h(), h, im, 0);
  return this;
});
$p.IA = (function(key, value) {
  $p_sci_HashMapBuilder__ensureUnaliased__V(this);
  var originalHash = $m_sr_Statics$().u(key);
  this.JE(this.qA, key, value, originalHash, $m_sc_Hashing$().bz(originalHash), 0);
  return this;
});
$p.aey = (function(xs) {
  $p_sci_HashMapBuilder__ensureUnaliased__V(this);
  if ((xs instanceof $c_sci_HashMap)) {
    new $c_sci_HashMapBuilder$$anon$1(this, xs);
  } else if ((xs instanceof $c_scm_HashMap)) {
    var iter = xs.ah5();
    while (iter.p()) {
      var next = iter.q();
      var improvedHash = next.or;
      var originalHash = (improvedHash ^ ((improvedHash >>> 16) | 0));
      var hash = $m_sc_Hashing$().bz(originalHash);
      this.JE(this.qA, next.np, next.b9, originalHash, hash, 0);
    }
  } else if ((xs instanceof $c_scm_LinkedHashMap)) {
    var iter$2 = xs.afu();
    while (iter$2.p()) {
      var next$2 = iter$2.q();
      var improvedHash$1 = next$2.pd;
      var originalHash$2 = (improvedHash$1 ^ ((improvedHash$1 >>> 16) | 0));
      var hash$2 = $m_sc_Hashing$().bz(originalHash$2);
      this.JE(this.qA, next$2.nq, next$2.fs, originalHash$2, hash$2, 0);
    }
  } else if ($is_sci_Map(xs)) {
    xs.pu(new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((key$2$2, value$2$2) => this.IA(key$2$2, value$2$2))));
  } else {
    var it = xs.o();
    while (it.p()) {
      this.aLT(it.q());
    }
  }
  return this;
});
$p.dG = (function(elems) {
  return this.aey(elems);
});
$p.Y = (function(elem) {
  return this.aLT(elem);
});
$p.aR = (function() {
  return this.a4x();
});
var $d_sci_HashMapBuilder = new $TypeData().i($c_sci_HashMapBuilder, "scala.collection.immutable.HashMapBuilder", ({
  I9: 1,
  b2: 1,
  Y: 1,
  T: 1,
  S: 1
}));
function $p_sci_HashSetBuilder__isAliased__Z($thiz) {
  return ($thiz.NV !== null);
}
function $p_sci_HashSetBuilder__insertElement__AI__I__I__AI($thiz, as, ix, elem) {
  if ((ix < 0)) {
    throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException());
  }
  if ((ix > as.a.length)) {
    throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException());
  }
  var result = new $ac_I(((1 + as.a.length) | 0));
  as.av(0, result, 0, ix);
  result.a[ix] = elem;
  var destPos = ((1 + ix) | 0);
  var length = ((as.a.length - ix) | 0);
  as.av(ix, result, destPos, length);
  return result;
}
function $p_sci_HashSetBuilder__insertValue__sci_BitmapIndexedSetNode__I__O__I__I__V($thiz, bm, bitpos, key, originalHash, keyHash) {
  var dataIx = bm.kN(bitpos);
  var src = bm.dX;
  var dst = new $ac_O(((1 + src.a.length) | 0));
  src.av(0, dst, 0, dataIx);
  dst.a[dataIx] = key;
  var destPos = ((1 + dataIx) | 0);
  var length = ((src.a.length - dataIx) | 0);
  src.av(dataIx, dst, destPos, length);
  var dstHashes = $p_sci_HashSetBuilder__insertElement__AI__I__I__AI($thiz, bm.eP, dataIx, originalHash);
  bm.bI = (bm.bI | bitpos);
  bm.dX = dst;
  bm.eP = dstHashes;
  bm.cC = ((1 + bm.cC) | 0);
  bm.fZ = ((bm.fZ + keyHash) | 0);
}
function $p_sci_HashSetBuilder__setValue__sci_BitmapIndexedSetNode__I__O__V($thiz, bm, bitpos, elem) {
  var dataIx = bm.kN(bitpos);
  bm.dX.a[dataIx] = elem;
}
function $p_sci_HashSetBuilder__ensureUnaliased__V($thiz) {
  if ($p_sci_HashSetBuilder__isAliased__Z($thiz)) {
    $p_sci_HashSetBuilder__copyElems__V($thiz);
  }
  $thiz.NV = null;
}
function $p_sci_HashSetBuilder__copyElems__V($thiz) {
  $thiz.HA = $thiz.HA.aN3();
}
/** @constructor */
function $c_sci_HashSetBuilder() {
  this.NV = null;
  this.HA = null;
  this.HA = new $c_sci_BitmapIndexedSetNode(0, 0, $m_s_Array$EmptyArrays$().abL, $m_s_Array$EmptyArrays$().Uz, 0, 0);
}
$p = $c_sci_HashSetBuilder.prototype = new $h_O();
$p.constructor = $c_sci_HashSetBuilder;
/** @constructor */
function $h_sci_HashSetBuilder() {
}
$h_sci_HashSetBuilder.prototype = $p;
$p.f9 = (function(size) {
});
$p.aip = (function(setNode, element, originalHash, elementHash, shift) {
  if ((setNode instanceof $c_sci_BitmapIndexedSetNode)) {
    var mask = $m_sci_Node$().fR(elementHash, shift);
    var bitpos = $m_sci_Node$().d6(mask);
    if (((setNode.bI & bitpos) !== 0)) {
      var index = $m_sci_Node$().h1(setNode.bI, mask, bitpos);
      var element0 = setNode.e4(index);
      var element0UnimprovedHash = setNode.cK(index);
      if (((element0UnimprovedHash === originalHash) && $m_sr_BoxesRunTime$().Q(element0, element))) {
        $p_sci_HashSetBuilder__setValue__sci_BitmapIndexedSetNode__I__O__V(this, setNode, bitpos, element0);
      } else {
        var element0Hash = $m_sc_Hashing$().bz(element0UnimprovedHash);
        var subNodeNew = setNode.Xw(element0, element0UnimprovedHash, element0Hash, element, originalHash, elementHash, ((5 + shift) | 0));
        setNode.aQl(bitpos, element0Hash, subNodeNew);
      }
    } else if (((setNode.cs & bitpos) !== 0)) {
      var index$2 = $m_sci_Node$().h1(setNode.cs, mask, bitpos);
      var subNode = setNode.iX(index$2);
      var beforeSize = subNode.aa();
      var beforeHashCode = subNode.dH();
      this.aip(subNode, element, originalHash, elementHash, ((5 + shift) | 0));
      setNode.cC = ((setNode.cC + ((subNode.aa() - beforeSize) | 0)) | 0);
      setNode.fZ = ((setNode.fZ + ((subNode.dH() - beforeHashCode) | 0)) | 0);
    } else {
      $p_sci_HashSetBuilder__insertValue__sci_BitmapIndexedSetNode__I__O__I__I__V(this, setNode, bitpos, element, originalHash, elementHash);
    }
  } else if ((setNode instanceof $c_sci_HashCollisionSetNode)) {
    var index$3 = $f_sc_SeqOps__indexOf__O__I__I(setNode.gh, element, 0);
    if ((index$3 < 0)) {
      setNode.gh = setNode.gh.lg(element);
    } else {
      setNode.gh = setNode.gh.nI(index$3, element);
    }
  } else {
    throw new $c_s_MatchError(setNode);
  }
});
$p.ahI = (function() {
  if ((this.HA.cC === 0)) {
    return $m_sci_HashSet$().vA;
  } else if ((this.NV !== null)) {
    return this.NV;
  } else {
    this.NV = new $c_sci_HashSet(this.HA);
    return this.NV;
  }
});
$p.a2F = (function(elem) {
  $p_sci_HashSetBuilder__ensureUnaliased__V(this);
  var h = $m_sr_Statics$().u(elem);
  var im = $m_sc_Hashing$().bz(h);
  this.aip(this.HA, elem, h, im, 0);
  return this;
});
$p.aez = (function(xs) {
  $p_sci_HashSetBuilder__ensureUnaliased__V(this);
  if ((xs instanceof $c_sci_HashSet)) {
    new $c_sci_HashSetBuilder$$anon$1(this, xs);
  } else {
    var it = xs.o();
    while (it.p()) {
      this.a2F(it.q());
    }
  }
  return this;
});
$p.dG = (function(elems) {
  return this.aez(elems);
});
$p.Y = (function(elem) {
  return this.a2F(elem);
});
$p.aR = (function() {
  return this.ahI();
});
var $d_sci_HashSetBuilder = new $TypeData().i($c_sci_HashSetBuilder, "scala.collection.immutable.HashSetBuilder", ({
  Ic: 1,
  b2: 1,
  Y: 1,
  T: 1,
  S: 1
}));
/** @constructor */
function $c_sci_IndexedSeq$() {
  this.xw = null;
  $ct_sc_SeqFactory$Delegate__sc_SeqFactory__(this, $m_sci_Vector$());
}
$p = $c_sci_IndexedSeq$.prototype = new $h_sc_SeqFactory$Delegate();
$p.constructor = $c_sci_IndexedSeq$;
/** @constructor */
function $h_sci_IndexedSeq$() {
}
$h_sci_IndexedSeq$.prototype = $p;
$p.WW = (function(it) {
  return ($is_sci_IndexedSeq(it) ? it : $c_sc_SeqFactory$Delegate.prototype.Al.call(this, it));
});
$p.cc = (function(source) {
  return this.WW(source);
});
$p.Al = (function(it) {
  return this.WW(it);
});
var $d_sci_IndexedSeq$ = new $TypeData().i($c_sci_IndexedSeq$, "scala.collection.immutable.IndexedSeq$", ({
  Ie: 1,
  bZ: 1,
  at: 1,
  a0: 1,
  a: 1
}));
var $n_sci_IndexedSeq$;
function $m_sci_IndexedSeq$() {
  if ((!$n_sci_IndexedSeq$)) {
    $n_sci_IndexedSeq$ = new $c_sci_IndexedSeq$();
  }
  return $n_sci_IndexedSeq$;
}
/** @constructor */
function $c_sci_LazyList$LazyBuilder() {
  this.NW = null;
  this.aIk = null;
  this.ie();
}
$p = $c_sci_LazyList$LazyBuilder.prototype = new $h_O();
$p.constructor = $c_sci_LazyList$LazyBuilder;
/** @constructor */
function $h_sci_LazyList$LazyBuilder() {
}
$h_sci_LazyList$LazyBuilder.prototype = $p;
$p.f9 = (function(size) {
});
$p.ie = (function() {
  var deferred = new $c_sci_LazyList$LazyBuilder$DeferredState();
  this.aIk = ($m_sci_LazyList$(), $ct_sci_LazyList__O__(new $c_sci_LazyList(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => deferred.afz()))));
  this.NW = deferred;
});
$p.b7R = (function() {
  this.NW.agx(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_LazyList$().bD)));
  return this.aIk;
});
$p.aWJ = (function(elem) {
  var deferred = new $c_sci_LazyList$LazyBuilder$DeferredState();
  this.NW.agx(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $m_sci_LazyList$();
    return $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), elem, ($m_sci_LazyList$(), $ct_sci_LazyList__O__(new $c_sci_LazyList(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => deferred.afz())))));
  })));
  this.NW = deferred;
  return this;
});
$p.aWz = (function(xs) {
  if ((xs.V() !== 0)) {
    var deferred = new $c_sci_LazyList$LazyBuilder$DeferredState();
    this.NW.agx(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_LazyList$().ahR(xs.o(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => deferred.afz()))))));
    this.NW = deferred;
  }
  return this;
});
$p.dG = (function(elems) {
  return this.aWz(elems);
});
$p.Y = (function(elem) {
  return this.aWJ(elem);
});
$p.aR = (function() {
  return this.b7R();
});
var $d_sci_LazyList$LazyBuilder = new $TypeData().i($c_sci_LazyList$LazyBuilder, "scala.collection.immutable.LazyList$LazyBuilder", ({
  Ij: 1,
  b2: 1,
  Y: 1,
  T: 1,
  S: 1
}));
/** @constructor */
function $c_sci_LazyList$LazyIterator(lazyList) {
  this.NX = null;
  this.NX = lazyList;
}
$p = $c_sci_LazyList$LazyIterator.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sci_LazyList$LazyIterator;
/** @constructor */
function $h_sci_LazyList$LazyIterator() {
}
$h_sci_LazyList$LazyIterator.prototype = $p;
$p.p = (function() {
  return (!(this.NX.df() === $m_sci_LazyList$().bD));
});
$p.q = (function() {
  if ((this.NX.df() === $m_sci_LazyList$().bD)) {
    return $m_sc_Iterator$().b8.q();
  } else {
    var res = this.NX.t();
    this.NX = this.NX.eV();
    return res;
  }
});
var $d_sci_LazyList$LazyIterator = new $TypeData().i($c_sci_LazyList$LazyIterator, "scala.collection.immutable.LazyList$LazyIterator", ({
  Il: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_sci_List$() {
  this.acG = null;
  this.V3 = null;
  $n_sci_List$ = this;
  this.acG = new $c_T2($m_sci_Nil$(), $m_sci_Nil$());
  this.V3 = new $c_sci_List$$anon$1();
}
$p = $c_sci_List$.prototype = new $h_O();
$p.constructor = $c_sci_List$;
/** @constructor */
function $h_sci_List$() {
}
$h_sci_List$.prototype = $p;
$p.dr = (function(elems) {
  return $m_sci_Nil$().b6(elems);
});
$p.b5 = (function() {
  return new $c_scm_ListBuffer();
});
$p.aO = (function() {
  return $m_sci_Nil$();
});
$p.cc = (function(source) {
  return $m_sci_Nil$().b6(source);
});
var $d_sci_List$ = new $TypeData().i($c_sci_List$, "scala.collection.immutable.List$", ({
  Ip: 1,
  ba: 1,
  at: 1,
  a0: 1,
  a: 1
}));
var $n_sci_List$;
function $m_sci_List$() {
  if ((!$n_sci_List$)) {
    $n_sci_List$ = new $c_sci_List$();
  }
  return $n_sci_List$;
}
function $ct_sci_Map$Map2$Map2Iterator__sci_Map$Map2__($thiz, outer) {
  $thiz.D0 = outer;
  $thiz.xA = 0;
  return $thiz;
}
/** @constructor */
function $c_sci_Map$Map2$Map2Iterator() {
  this.xA = 0;
  this.D0 = null;
}
$p = $c_sci_Map$Map2$Map2Iterator.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sci_Map$Map2$Map2Iterator;
/** @constructor */
function $h_sci_Map$Map2$Map2Iterator() {
}
$h_sci_Map$Map2$Map2Iterator.prototype = $p;
$p.p = (function() {
  return (this.xA < 2);
});
$p.q = (function() {
  switch (this.xA) {
    case 0: {
      var result = this.mS(this.D0.kG, this.D0.nk);
      break;
    }
    case 1: {
      var result = this.mS(this.D0.kH, this.D0.nl);
      break;
    }
    default: {
      var result = $m_sc_Iterator$().b8.q();
    }
  }
  this.xA = ((1 + this.xA) | 0);
  return result;
});
$p.iV = (function(n) {
  this.xA = ((this.xA + n) | 0);
  return this;
});
function $ct_sci_Map$Map3$Map3Iterator__sci_Map$Map3__($thiz, outer) {
  $thiz.xB = outer;
  $thiz.xC = 0;
  return $thiz;
}
/** @constructor */
function $c_sci_Map$Map3$Map3Iterator() {
  this.xC = 0;
  this.xB = null;
}
$p = $c_sci_Map$Map3$Map3Iterator.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sci_Map$Map3$Map3Iterator;
/** @constructor */
function $h_sci_Map$Map3$Map3Iterator() {
}
$h_sci_Map$Map3$Map3Iterator.prototype = $p;
$p.p = (function() {
  return (this.xC < 3);
});
$p.q = (function() {
  switch (this.xC) {
    case 0: {
      var result = this.mS(this.xB.jM, this.xB.lK);
      break;
    }
    case 1: {
      var result = this.mS(this.xB.ja, this.xB.l4);
      break;
    }
    case 2: {
      var result = this.mS(this.xB.jb, this.xB.l5);
      break;
    }
    default: {
      var result = $m_sc_Iterator$().b8.q();
    }
  }
  this.xC = ((1 + this.xC) | 0);
  return result;
});
$p.iV = (function(n) {
  this.xC = ((this.xC + n) | 0);
  return this;
});
function $ct_sci_Map$Map4$Map4Iterator__sci_Map$Map4__($thiz, outer) {
  $thiz.tG = outer;
  $thiz.xD = 0;
  return $thiz;
}
/** @constructor */
function $c_sci_Map$Map4$Map4Iterator() {
  this.xD = 0;
  this.tG = null;
}
$p = $c_sci_Map$Map4$Map4Iterator.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sci_Map$Map4$Map4Iterator;
/** @constructor */
function $h_sci_Map$Map4$Map4Iterator() {
}
$h_sci_Map$Map4$Map4Iterator.prototype = $p;
$p.p = (function() {
  return (this.xD < 4);
});
$p.q = (function() {
  switch (this.xD) {
    case 0: {
      var result = this.mS(this.tG.i3, this.tG.kf);
      break;
    }
    case 1: {
      var result = this.mS(this.tG.hw, this.tG.jN);
      break;
    }
    case 2: {
      var result = this.mS(this.tG.hg, this.tG.jc);
      break;
    }
    case 3: {
      var result = this.mS(this.tG.hh, this.tG.jd);
      break;
    }
    default: {
      var result = $m_sc_Iterator$().b8.q();
    }
  }
  this.xD = ((1 + this.xD) | 0);
  return result;
});
$p.iV = (function(n) {
  this.xD = ((this.xD + n) | 0);
  return this;
});
/** @constructor */
function $c_sci_MapBuilderImpl() {
  this.xE = null;
  this.V4 = false;
  this.zW = null;
  this.xE = $m_sci_Map$EmptyMap$();
  this.V4 = false;
}
$p = $c_sci_MapBuilderImpl.prototype = new $h_O();
$p.constructor = $c_sci_MapBuilderImpl;
/** @constructor */
function $h_sci_MapBuilderImpl() {
}
$h_sci_MapBuilderImpl.prototype = $p;
$p.f9 = (function(size) {
});
$p.a3C = (function(key, value) {
  return ((this.zW !== null) ? this.zW.a3C(key, value) : this.xE.ay(key, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => value))));
});
$p.oG = (function() {
  return (this.V4 ? this.zW.a4x() : this.xE);
});
$p.lR = (function(key, value) {
  if (this.V4) {
    this.zW.IA(key, value);
  } else if ((this.xE.aa() < 4)) {
    this.xE = this.xE.bN(key, value);
  } else if (this.xE.E(key)) {
    this.xE = this.xE.bN(key, value);
  } else {
    this.V4 = true;
    if ((this.zW === null)) {
      this.zW = new $c_sci_HashMapBuilder();
    }
    this.xE.aY7(this.zW);
    this.zW.IA(key, value);
  }
  return this;
});
$p.aeA = (function(xs) {
  return (this.V4 ? (this.zW.aey(xs), this) : $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs));
});
$p.dG = (function(elems) {
  return this.aeA(elems);
});
$p.Y = (function(elem) {
  return this.lR(elem.g(), elem.h());
});
$p.aR = (function() {
  return this.oG();
});
var $d_sci_MapBuilderImpl = new $TypeData().i($c_sci_MapBuilderImpl, "scala.collection.immutable.MapBuilderImpl", ({
  IF: 1,
  b2: 1,
  Y: 1,
  T: 1,
  S: 1
}));
/** @constructor */
function $c_sci_Seq$() {
  this.xw = null;
  $ct_sc_SeqFactory$Delegate__sc_SeqFactory__(this, $m_sci_List$());
}
$p = $c_sci_Seq$.prototype = new $h_sc_SeqFactory$Delegate();
$p.constructor = $c_sci_Seq$;
/** @constructor */
function $h_sci_Seq$() {
}
$h_sci_Seq$.prototype = $p;
$p.fw = (function(it) {
  return ($is_sci_Seq(it) ? it : $c_sc_SeqFactory$Delegate.prototype.Al.call(this, it));
});
$p.cc = (function(source) {
  return this.fw(source);
});
$p.Al = (function(it) {
  return this.fw(it);
});
var $d_sci_Seq$ = new $TypeData().i($c_sci_Seq$, "scala.collection.immutable.Seq$", ({
  IU: 1,
  bZ: 1,
  at: 1,
  a0: 1,
  a: 1
}));
var $n_sci_Seq$;
function $m_sci_Seq$() {
  if ((!$n_sci_Seq$)) {
    $n_sci_Seq$ = new $c_sci_Seq$();
  }
  return $n_sci_Seq$;
}
/** @constructor */
function $c_sci_SetBuilderImpl() {
  this.HE = null;
  this.V7 = false;
  this.HF = null;
  this.HE = $m_sci_Set$EmptySet$();
  this.V7 = false;
}
$p = $c_sci_SetBuilderImpl.prototype = new $h_O();
$p.constructor = $c_sci_SetBuilderImpl;
/** @constructor */
function $h_sci_SetBuilderImpl() {
}
$h_sci_SetBuilderImpl.prototype = $p;
$p.f9 = (function(size) {
});
$p.ahJ = (function() {
  return (this.V7 ? this.HF.ahI() : this.HE);
});
$p.DE = (function(elem) {
  if (this.V7) {
    this.HF.a2F(elem);
  } else if ((this.HE.aa() < 4)) {
    this.HE = this.HE.hQ(elem);
  } else if ((!this.HE.E(elem))) {
    this.V7 = true;
    if ((this.HF === null)) {
      this.HF = new $c_sci_HashSetBuilder();
    }
    this.HE.aY8(this.HF);
    this.HF.a2F(elem);
  }
  return this;
});
$p.aLM = (function(xs) {
  return (this.V7 ? (this.HF.aez(xs), this) : $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs));
});
$p.dG = (function(elems) {
  return this.aLM(elems);
});
$p.Y = (function(elem) {
  return this.DE(elem);
});
$p.aR = (function() {
  return this.ahJ();
});
var $d_sci_SetBuilderImpl = new $TypeData().i($c_sci_SetBuilderImpl, "scala.collection.immutable.SetBuilderImpl", ({
  J4: 1,
  b2: 1,
  Y: 1,
  T: 1,
  S: 1
}));
/** @constructor */
function $c_sci_TreeSeqMap$$anon$1(outer) {
  this.acK = null;
  this.aIt = null;
  this.aIt = outer;
  this.acK = outer.op.PA();
}
$p = $c_sci_TreeSeqMap$$anon$1.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sci_TreeSeqMap$$anon$1;
/** @constructor */
function $h_sci_TreeSeqMap$$anon$1() {
}
$h_sci_TreeSeqMap$$anon$1.prototype = $p;
$p.p = (function() {
  return this.acK.p();
});
$p.dC = (function() {
  var this$1 = this.aIt;
  var k = this.acK.q();
  return new $c_T2(k, this$1.lN.i(k).Pb());
});
$p.q = (function() {
  return this.dC();
});
var $d_sci_TreeSeqMap$$anon$1 = new $TypeData().i($c_sci_TreeSeqMap$$anon$1, "scala.collection.immutable.TreeSeqMap$$anon$1", ({
  Jb: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_sci_TreeSeqMap$$anon$2(outer) {
  this.acL = null;
  this.acL = outer.op.PA();
}
$p = $c_sci_TreeSeqMap$$anon$2.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sci_TreeSeqMap$$anon$2;
/** @constructor */
function $h_sci_TreeSeqMap$$anon$2() {
}
$h_sci_TreeSeqMap$$anon$2.prototype = $p;
$p.p = (function() {
  return this.acL.p();
});
$p.q = (function() {
  return this.acL.q();
});
var $d_sci_TreeSeqMap$$anon$2 = new $TypeData().i($c_sci_TreeSeqMap$$anon$2, "scala.collection.immutable.TreeSeqMap$$anon$2", ({
  Jc: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_sci_TreeSeqMap$$anon$3(outer) {
  this.acM = null;
  this.aIu = null;
  this.aIu = outer;
  this.acM = outer.op.PA();
}
$p = $c_sci_TreeSeqMap$$anon$3.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sci_TreeSeqMap$$anon$3;
/** @constructor */
function $h_sci_TreeSeqMap$$anon$3() {
}
$h_sci_TreeSeqMap$$anon$3.prototype = $p;
$p.p = (function() {
  return this.acM.p();
});
$p.q = (function() {
  var this$1 = this.aIu;
  var k = this.acM.q();
  return this$1.lN.i(k).Pb();
});
var $d_sci_TreeSeqMap$$anon$3 = new $TypeData().i($c_sci_TreeSeqMap$$anon$3, "scala.collection.immutable.TreeSeqMap$$anon$3", ({
  Jd: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_sci_TreeSeqMap$OrderBy$Insertion$() {
}
$p = $c_sci_TreeSeqMap$OrderBy$Insertion$.prototype = new $h_O();
$p.constructor = $c_sci_TreeSeqMap$OrderBy$Insertion$;
/** @constructor */
function $h_sci_TreeSeqMap$OrderBy$Insertion$() {
}
$h_sci_TreeSeqMap$OrderBy$Insertion$.prototype = $p;
$p.D = (function(n) {
  return $f_s_Product__productElementName__I__T(this, n);
});
$p.B = (function() {
  return "Insertion";
});
$p.z = (function() {
  return 0;
});
$p.A = (function(x$1) {
  return $m_sr_Statics$().ey(x$1);
});
$p.H = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$p.x = (function() {
  return 1619512975;
});
$p.m = (function() {
  return "Insertion";
});
var $d_sci_TreeSeqMap$OrderBy$Insertion$ = new $TypeData().i($c_sci_TreeSeqMap$OrderBy$Insertion$, "scala.collection.immutable.TreeSeqMap$OrderBy$Insertion$", ({
  Jf: 1,
  lq: 1,
  c: 1,
  b: 1,
  a: 1
}));
var $n_sci_TreeSeqMap$OrderBy$Insertion$;
function $m_sci_TreeSeqMap$OrderBy$Insertion$() {
  if ((!$n_sci_TreeSeqMap$OrderBy$Insertion$)) {
    $n_sci_TreeSeqMap$OrderBy$Insertion$ = new $c_sci_TreeSeqMap$OrderBy$Insertion$();
  }
  return $n_sci_TreeSeqMap$OrderBy$Insertion$;
}
/** @constructor */
function $c_sci_TreeSeqMap$OrderBy$Modification$() {
}
$p = $c_sci_TreeSeqMap$OrderBy$Modification$.prototype = new $h_O();
$p.constructor = $c_sci_TreeSeqMap$OrderBy$Modification$;
/** @constructor */
function $h_sci_TreeSeqMap$OrderBy$Modification$() {
}
$h_sci_TreeSeqMap$OrderBy$Modification$.prototype = $p;
$p.D = (function(n) {
  return $f_s_Product__productElementName__I__T(this, n);
});
$p.B = (function() {
  return "Modification";
});
$p.z = (function() {
  return 0;
});
$p.A = (function(x$1) {
  return $m_sr_Statics$().ey(x$1);
});
$p.H = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$p.x = (function() {
  return (-520280644);
});
$p.m = (function() {
  return "Modification";
});
var $d_sci_TreeSeqMap$OrderBy$Modification$ = new $TypeData().i($c_sci_TreeSeqMap$OrderBy$Modification$, "scala.collection.immutable.TreeSeqMap$OrderBy$Modification$", ({
  Jg: 1,
  lq: 1,
  c: 1,
  b: 1,
  a: 1
}));
var $n_sci_TreeSeqMap$OrderBy$Modification$;
function $m_sci_TreeSeqMap$OrderBy$Modification$() {
  if ((!$n_sci_TreeSeqMap$OrderBy$Modification$)) {
    $n_sci_TreeSeqMap$OrderBy$Modification$ = new $c_sci_TreeSeqMap$OrderBy$Modification$();
  }
  return $n_sci_TreeSeqMap$OrderBy$Modification$;
}
/** @constructor */
function $c_sci_TreeSeqMap$Ordering$Bin(prefix, mask, left, right) {
  this.xI = 0;
  this.xH = 0;
  this.qC = null;
  this.nm = null;
  this.xI = prefix;
  this.xH = mask;
  this.qC = left;
  this.nm = right;
}
$p = $c_sci_TreeSeqMap$Ordering$Bin.prototype = new $h_sci_TreeSeqMap$Ordering();
$p.constructor = $c_sci_TreeSeqMap$Ordering$Bin;
/** @constructor */
function $h_sci_TreeSeqMap$Ordering$Bin() {
}
$h_sci_TreeSeqMap$Ordering$Bin.prototype = $p;
$p.WU = (function(sb, prefix, subPrefix) {
  var i = this.xI;
  var $x_1 = (i >>> 0.0).toString(2);
  var i$1 = this.xH;
  sb.ad((((((prefix + "Bin(") + ((i + "/") + $x_1)) + ":") + ((i$1 + "/") + (i$1 >>> 0.0).toString(2))) + ")\n"));
  this.qC.WU(sb, (subPrefix + "\u251c\u2500\u2500 "), (subPrefix + "\u2502   "));
  this.nm.WU(sb, (subPrefix + "\u2514\u2500\u2500 "), (subPrefix + "    "));
});
$p.B = (function() {
  return "Bin";
});
$p.z = (function() {
  return 4;
});
$p.A = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.xI;
      break;
    }
    case 1: {
      return this.xH;
      break;
    }
    case 2: {
      return this.qC;
      break;
    }
    case 3: {
      return this.nm;
      break;
    }
    default: {
      return $m_sr_Statics$().ey(x$1);
    }
  }
});
$p.H = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$p.D = (function(x$1) {
  switch (x$1) {
    case 0: {
      return "prefix";
      break;
    }
    case 1: {
      return "mask";
      break;
    }
    case 2: {
      return "left";
      break;
    }
    case 3: {
      return "right";
      break;
    }
    default: {
      return $m_sr_Statics$().ey(x$1);
    }
  }
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 66791);
  acc = $m_sr_Statics$().k(acc, this.xI);
  acc = $m_sr_Statics$().k(acc, this.xH);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.qC));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.nm));
  return $m_sr_Statics$().Z(acc, 4);
});
$p.e = (function(x$1) {
  if ((this === x$1)) {
    return true;
  } else if ((x$1 instanceof $c_sci_TreeSeqMap$Ordering$Bin)) {
    if (((this.xI === x$1.xI) && (this.xH === x$1.xH))) {
      var x = this.qC;
      var x$2 = x$1.qC;
      if (((x === null) ? (x$2 === null) : x.e(x$2))) {
        var x$3 = this.nm;
        var x$4 = x$1.nm;
        return ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
      } else {
        return false;
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
});
function $isArrayOf_sci_TreeSeqMap$Ordering$Bin(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.lr)));
}
var $d_sci_TreeSeqMap$Ordering$Bin = new $TypeData().i($c_sci_TreeSeqMap$Ordering$Bin, "scala.collection.immutable.TreeSeqMap$Ordering$Bin", ({
  lr: 1,
  cQ: 1,
  c: 1,
  b: 1,
  a: 1
}));
/** @constructor */
function $c_sci_TreeSeqMap$Ordering$Tip(ord, value) {
  this.qD = 0;
  this.vE = null;
  this.qD = ord;
  this.vE = value;
}
$p = $c_sci_TreeSeqMap$Ordering$Tip.prototype = new $h_sci_TreeSeqMap$Ordering();
$p.constructor = $c_sci_TreeSeqMap$Ordering$Tip;
/** @constructor */
function $h_sci_TreeSeqMap$Ordering$Tip() {
}
$h_sci_TreeSeqMap$Ordering$Tip.prototype = $p;
$p.WU = (function(sb, prefix, subPrefix) {
  var i = this.qD;
  sb.ad((((((prefix + "Tip(") + ((i + "/") + (i >>> 0.0).toString(2))) + " -> ") + this.vE) + ")\n"));
});
$p.B = (function() {
  return "Tip";
});
$p.z = (function() {
  return 2;
});
$p.A = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.qD;
      break;
    }
    case 1: {
      return this.vE;
      break;
    }
    default: {
      return $m_sr_Statics$().ey(x$1);
    }
  }
});
$p.H = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$p.D = (function(x$1) {
  switch (x$1) {
    case 0: {
      return "ord";
      break;
    }
    case 1: {
      return "value";
      break;
    }
    default: {
      return $m_sr_Statics$().ey(x$1);
    }
  }
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 84091);
  acc = $m_sr_Statics$().k(acc, this.qD);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.vE));
  return $m_sr_Statics$().Z(acc, 2);
});
$p.e = (function(x$1) {
  return ((this === x$1) || ((x$1 instanceof $c_sci_TreeSeqMap$Ordering$Tip) && ((this.qD === x$1.qD) && $m_sr_BoxesRunTime$().Q(this.vE, x$1.vE))));
});
function $isArrayOf_sci_TreeSeqMap$Ordering$Tip(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ls)));
}
var $d_sci_TreeSeqMap$Ordering$Tip = new $TypeData().i($c_sci_TreeSeqMap$Ordering$Tip, "scala.collection.immutable.TreeSeqMap$Ordering$Tip", ({
  ls: 1,
  cQ: 1,
  c: 1,
  b: 1,
  a: 1
}));
/** @constructor */
function $c_sci_TreeSeqMap$Ordering$Zero$() {
}
$p = $c_sci_TreeSeqMap$Ordering$Zero$.prototype = new $h_sci_TreeSeqMap$Ordering();
$p.constructor = $c_sci_TreeSeqMap$Ordering$Zero$;
/** @constructor */
function $h_sci_TreeSeqMap$Ordering$Zero$() {
}
$h_sci_TreeSeqMap$Ordering$Zero$.prototype = $p;
$p.D = (function(n) {
  return $f_s_Product__productElementName__I__T(this, n);
});
$p.e = (function(that) {
  return ((that === this) || ((!(that instanceof $c_sci_TreeSeqMap$Ordering)) && (this === that)));
});
$p.WU = (function(sb, prefix, subPrefix) {
  sb.ad((prefix + "\u00d8"));
});
$p.B = (function() {
  return "Zero";
});
$p.z = (function() {
  return 0;
});
$p.A = (function(x$1) {
  return $m_sr_Statics$().ey(x$1);
});
$p.H = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$p.x = (function() {
  return 2781896;
});
var $d_sci_TreeSeqMap$Ordering$Zero$ = new $TypeData().i($c_sci_TreeSeqMap$Ordering$Zero$, "scala.collection.immutable.TreeSeqMap$Ordering$Zero$", ({
  Jk: 1,
  cQ: 1,
  c: 1,
  b: 1,
  a: 1
}));
var $n_sci_TreeSeqMap$Ordering$Zero$;
function $m_sci_TreeSeqMap$Ordering$Zero$() {
  if ((!$n_sci_TreeSeqMap$Ordering$Zero$)) {
    $n_sci_TreeSeqMap$Ordering$Zero$ = new $c_sci_TreeSeqMap$Ordering$Zero$();
  }
  return $n_sci_TreeSeqMap$Ordering$Zero$;
}
function $ps_sci_Vector$__liftedTree1$1__I() {
  try {
    return $m_jl_Integer$().gc($m_jl_System$SystemProperties$().agd("scala.collection.immutable.Vector.defaultApplyPreferredMaxLength", "250"), 10, 214748364);
  } catch (e) {
    if (false) {
      return 250;
    } else {
      throw e;
    }
  }
}
/** @constructor */
function $c_sci_Vector$() {
  this.aIw = 0;
  this.aIx = null;
  $n_sci_Vector$ = this;
  this.aIw = $ps_sci_Vector$__liftedTree1$1__I();
  this.aIx = new $c_sci_NewVectorIterator($m_sci_Vector0$(), 0, 0);
}
$p = $c_sci_Vector$.prototype = new $h_O();
$p.constructor = $c_sci_Vector$;
/** @constructor */
function $h_sci_Vector$() {
}
$h_sci_Vector$.prototype = $p;
$p.dr = (function(elems) {
  return this.X(elems);
});
$p.X = (function(it) {
  if ((it instanceof $c_sci_Vector)) {
    return it;
  } else {
    var knownSize = it.V();
    if ((knownSize === 0)) {
      return $m_sci_Vector0$();
    } else if (((((knownSize - 1) | 0) >>> 0) <= 31)) {
      matchEnd5: {
        var $x_1;
        if ((it instanceof $c_sci_ArraySeq$ofRef)) {
          var x = it.gY().h8();
          if (((x !== null) && (x === $d_O.l()))) {
            var $x_1 = it.tE;
            break matchEnd5;
          }
        }
        if ($is_sci_Iterable(it)) {
          var a1 = new $ac_O(knownSize);
          it.cR(a1, 0, 2147483647);
          var $x_1 = a1;
          break matchEnd5;
        }
        var a1$2 = new $ac_O(knownSize);
        it.o().cR(a1$2, 0, 2147483647);
        var $x_1 = a1$2;
      }
      return new $c_sci_Vector1($x_1);
    } else {
      return new $c_sci_VectorBuilder().fO(it).bY();
    }
  }
});
$p.b5 = (function() {
  return new $c_sci_VectorBuilder();
});
$p.cc = (function(source) {
  return this.X(source);
});
$p.aO = (function() {
  return $m_sci_Vector0$();
});
var $d_sci_Vector$ = new $TypeData().i($c_sci_Vector$, "scala.collection.immutable.Vector$", ({
  Jl: 1,
  ba: 1,
  at: 1,
  a0: 1,
  a: 1
}));
var $n_sci_Vector$;
function $m_sci_Vector$() {
  if ((!$n_sci_Vector$)) {
    $n_sci_Vector$ = new $c_sci_Vector$();
  }
  return $n_sci_Vector$;
}
function $p_sci_VectorBuilder__leftAlignPrefix__V($thiz) {
  var a = null;
  var aParent = null;
  if (($thiz.eM >= 6)) {
    a = $thiz.kh;
    var i = (($thiz.dT >>> 25) | 0);
    if ((i > 0)) {
      var src = a;
      var dest = a;
      var length = ((64 - i) | 0);
      src.av(i, dest, 0, length);
    }
    var num = $thiz.dT;
    var t = (((num >> 24) >>> 7) | 0);
    var newOffset = (((33554431 & ((num + t) | 0)) - t) | 0);
    $thiz.cH = (($thiz.cH - (($thiz.dT - newOffset) | 0)) | 0);
    $thiz.dT = newOffset;
    if (((($thiz.cH >>> 25) | 0) === 0)) {
      $thiz.eM = 5;
    }
    aParent = a;
    a = a.a[0];
  }
  if (($thiz.eM >= 5)) {
    if ((a === null)) {
      a = $thiz.gN;
    }
    var i$2 = (31 & (($thiz.dT >>> 20) | 0));
    if (($thiz.eM === 5)) {
      if ((i$2 > 0)) {
        var src$1 = a;
        var dest$1 = a;
        var length$1 = ((32 - i$2) | 0);
        src$1.av(i$2, dest$1, 0, length$1);
      }
      $thiz.gN = a;
      var num$1 = $thiz.dT;
      var t$1 = (((num$1 >> 19) >>> 12) | 0);
      var newOffset$1 = (((1048575 & ((num$1 + t$1) | 0)) - t$1) | 0);
      $thiz.cH = (($thiz.cH - (($thiz.dT - newOffset$1) | 0)) | 0);
      $thiz.dT = newOffset$1;
      if (((($thiz.cH >>> 20) | 0) === 0)) {
        $thiz.eM = 4;
      }
    } else {
      if ((i$2 > 0)) {
        a = $m_ju_Arrays$().d7(a, i$2, 32);
      }
      aParent.a[0] = a;
    }
    aParent = a;
    a = a.a[0];
  }
  if (($thiz.eM >= 4)) {
    if ((a === null)) {
      a = $thiz.fL;
    }
    var i$3 = (31 & (($thiz.dT >>> 15) | 0));
    if (($thiz.eM === 4)) {
      if ((i$3 > 0)) {
        var src$2 = a;
        var dest$2 = a;
        var length$2 = ((32 - i$3) | 0);
        src$2.av(i$3, dest$2, 0, length$2);
      }
      $thiz.fL = a;
      var num$2 = $thiz.dT;
      var t$2 = (((num$2 >> 14) >>> 17) | 0);
      var newOffset$2 = (((32767 & ((num$2 + t$2) | 0)) - t$2) | 0);
      $thiz.cH = (($thiz.cH - (($thiz.dT - newOffset$2) | 0)) | 0);
      $thiz.dT = newOffset$2;
      if (((($thiz.cH >>> 15) | 0) === 0)) {
        $thiz.eM = 3;
      }
    } else {
      if ((i$3 > 0)) {
        a = $m_ju_Arrays$().d7(a, i$3, 32);
      }
      aParent.a[0] = a;
    }
    aParent = a;
    a = a.a[0];
  }
  if (($thiz.eM >= 3)) {
    if ((a === null)) {
      a = $thiz.eL;
    }
    var i$4 = (31 & (($thiz.dT >>> 10) | 0));
    if (($thiz.eM === 3)) {
      if ((i$4 > 0)) {
        var src$3 = a;
        var dest$3 = a;
        var length$3 = ((32 - i$4) | 0);
        src$3.av(i$4, dest$3, 0, length$3);
      }
      $thiz.eL = a;
      var num$3 = $thiz.dT;
      var t$3 = (((num$3 >> 9) >>> 22) | 0);
      var newOffset$3 = (((1023 & ((num$3 + t$3) | 0)) - t$3) | 0);
      $thiz.cH = (($thiz.cH - (($thiz.dT - newOffset$3) | 0)) | 0);
      $thiz.dT = newOffset$3;
      if (((($thiz.cH >>> 10) | 0) === 0)) {
        $thiz.eM = 2;
      }
    } else {
      if ((i$4 > 0)) {
        a = $m_ju_Arrays$().d7(a, i$4, 32);
      }
      aParent.a[0] = a;
    }
    aParent = a;
    a = a.a[0];
  }
  if (($thiz.eM >= 2)) {
    if ((a === null)) {
      a = $thiz.dZ;
    }
    var i$5 = (31 & (($thiz.dT >>> 5) | 0));
    if (($thiz.eM === 2)) {
      if ((i$5 > 0)) {
        var src$4 = a;
        var dest$4 = a;
        var length$4 = ((32 - i$5) | 0);
        src$4.av(i$5, dest$4, 0, length$4);
      }
      $thiz.dZ = a;
      var num$4 = $thiz.dT;
      var t$4 = (((num$4 >> 4) >>> 27) | 0);
      var newOffset$4 = (((31 & ((num$4 + t$4) | 0)) - t$4) | 0);
      $thiz.cH = (($thiz.cH - (($thiz.dT - newOffset$4) | 0)) | 0);
      $thiz.dT = newOffset$4;
      if (((($thiz.cH >>> 5) | 0) === 0)) {
        $thiz.eM = 1;
      }
    } else {
      if ((i$5 > 0)) {
        a = $m_ju_Arrays$().d7(a, i$5, 32);
      }
      aParent.a[0] = a;
    }
    aParent = a;
    a = a.a[0];
  }
  if (($thiz.eM >= 1)) {
    if ((a === null)) {
      a = $thiz.g8;
    }
    var i$6 = (31 & $thiz.dT);
    if (($thiz.eM === 1)) {
      if ((i$6 > 0)) {
        var src$5 = a;
        var dest$5 = a;
        var length$5 = ((32 - i$6) | 0);
        src$5.av(i$6, dest$5, 0, length$5);
      }
      $thiz.g8 = a;
      $thiz.dF = (($thiz.dF - $thiz.dT) | 0);
      $thiz.dT = 0;
    } else {
      if ((i$6 > 0)) {
        a = $m_ju_Arrays$().d7(a, i$6, 32);
      }
      aParent.a[0] = a;
    }
  }
  $thiz.V8 = false;
}
function $p_sci_VectorBuilder__addArr1__AO__V($thiz, data) {
  var dl = data.a.length;
  if ((dl > 0)) {
    if (($thiz.dF === 32)) {
      $p_sci_VectorBuilder__advance__V($thiz);
    }
    var a = ((32 - $thiz.dF) | 0);
    var copy1 = ((a < dl) ? a : dl);
    var copy2 = ((dl - copy1) | 0);
    var dest = $thiz.g8;
    var destPos = $thiz.dF;
    data.av(0, dest, destPos, copy1);
    $thiz.dF = (($thiz.dF + copy1) | 0);
    if ((copy2 > 0)) {
      $p_sci_VectorBuilder__advance__V($thiz);
      var dest$1 = $thiz.g8;
      data.av(copy1, dest$1, 0, copy2);
      $thiz.dF = (($thiz.dF + copy2) | 0);
    }
  }
}
function $p_sci_VectorBuilder__addArrN__AO__I__V($thiz, slice, dim) {
  if ((slice.a.length === 0)) {
    return (void 0);
  }
  if (($thiz.dF === 32)) {
    $p_sci_VectorBuilder__advance__V($thiz);
  }
  var sl = slice.a.length;
  switch (dim) {
    case 2: {
      var a = (31 & ((((1024 - $thiz.cH) | 0) >>> 5) | 0));
      var copy1 = ((a < sl) ? a : sl);
      var copy2 = ((sl - copy1) | 0);
      var destPos = (31 & (($thiz.cH >>> 5) | 0));
      var dest = $thiz.dZ;
      slice.av(0, dest, destPos, copy1);
      $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy1 << 5));
      if ((copy2 > 0)) {
        var dest$1 = $thiz.dZ;
        slice.av(copy1, dest$1, 0, copy2);
        $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy2 << 5));
      }
      break;
    }
    case 3: {
      var num = $thiz.cH;
      var t = (((num >> 9) >>> 22) | 0);
      if (((((1023 & ((num + t) | 0)) - t) | 0) !== 0)) {
        var f = ((e$2$2) => {
          $p_sci_VectorBuilder__addArrN__AO__I__V($thiz, e$2$2, 2);
        });
        var len = slice.a.length;
        var i = 0;
        if ((slice !== null)) {
          while ((i < len)) {
            var x0 = slice.a[i];
            f(x0);
            i = ((1 + i) | 0);
          }
        } else if ((slice instanceof $ac_I)) {
          while ((i < len)) {
            var x0$1 = slice.a[i];
            f(x0$1);
            i = ((1 + i) | 0);
          }
        } else if ((slice instanceof $ac_D)) {
          while ((i < len)) {
            var x0$2 = slice.a[i];
            f(x0$2);
            i = ((1 + i) | 0);
          }
        } else if ((slice instanceof $ac_J)) {
          while ((i < len)) {
            var $x_1 = slice.a;
            var $x_2 = (i << 1);
            var x0$3_$_lo = $x_1[$x_2];
            var x0$3_$_hi = $x_1[(($x_2 + 1) | 0)];
            f($bL(x0$3_$_lo, x0$3_$_hi));
            i = ((1 + i) | 0);
          }
        } else if ((slice instanceof $ac_F)) {
          while ((i < len)) {
            var x0$4 = slice.a[i];
            f(x0$4);
            i = ((1 + i) | 0);
          }
        } else if ((slice instanceof $ac_C)) {
          while ((i < len)) {
            var x0$5 = slice.a[i];
            f($bC(x0$5));
            i = ((1 + i) | 0);
          }
        } else if ((slice instanceof $ac_B)) {
          while ((i < len)) {
            var x0$6 = slice.a[i];
            f(x0$6);
            i = ((1 + i) | 0);
          }
        } else if ((slice instanceof $ac_S)) {
          while ((i < len)) {
            var x0$7 = slice.a[i];
            f(x0$7);
            i = ((1 + i) | 0);
          }
        } else if ((slice instanceof $ac_Z)) {
          while ((i < len)) {
            var x0$8 = slice.a[i];
            f(x0$8);
            i = ((1 + i) | 0);
          }
        } else {
          throw new $c_s_MatchError(slice);
        }
        return (void 0);
      }
      var a$1 = (31 & ((((32768 - $thiz.cH) | 0) >>> 10) | 0));
      var copy1$2 = ((a$1 < sl) ? a$1 : sl);
      var copy2$2 = ((sl - copy1$2) | 0);
      var destPos$2 = (31 & (($thiz.cH >>> 10) | 0));
      var dest$2 = $thiz.eL;
      slice.av(0, dest$2, destPos$2, copy1$2);
      $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy1$2 << 10));
      if ((copy2$2 > 0)) {
        var dest$3 = $thiz.eL;
        slice.av(copy1$2, dest$3, 0, copy2$2);
        $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy2$2 << 10));
      }
      break;
    }
    case 4: {
      var num$1 = $thiz.cH;
      var t$1 = (((num$1 >> 14) >>> 17) | 0);
      if (((((32767 & ((num$1 + t$1) | 0)) - t$1) | 0) !== 0)) {
        var f$1 = ((e$2$2$1) => {
          $p_sci_VectorBuilder__addArrN__AO__I__V($thiz, e$2$2$1, 3);
        });
        var len$1 = slice.a.length;
        var i$1 = 0;
        if ((slice !== null)) {
          while ((i$1 < len$1)) {
            var x0$9 = slice.a[i$1];
            f$1(x0$9);
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((slice instanceof $ac_I)) {
          while ((i$1 < len$1)) {
            var x0$10 = slice.a[i$1];
            f$1(x0$10);
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((slice instanceof $ac_D)) {
          while ((i$1 < len$1)) {
            var x0$11 = slice.a[i$1];
            f$1(x0$11);
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((slice instanceof $ac_J)) {
          while ((i$1 < len$1)) {
            var $x_3 = slice.a;
            var $x_4 = (i$1 << 1);
            var x0$12_$_lo = $x_3[$x_4];
            var x0$12_$_hi = $x_3[(($x_4 + 1) | 0)];
            f$1($bL(x0$12_$_lo, x0$12_$_hi));
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((slice instanceof $ac_F)) {
          while ((i$1 < len$1)) {
            var x0$13 = slice.a[i$1];
            f$1(x0$13);
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((slice instanceof $ac_C)) {
          while ((i$1 < len$1)) {
            var x0$14 = slice.a[i$1];
            f$1($bC(x0$14));
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((slice instanceof $ac_B)) {
          while ((i$1 < len$1)) {
            var x0$15 = slice.a[i$1];
            f$1(x0$15);
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((slice instanceof $ac_S)) {
          while ((i$1 < len$1)) {
            var x0$16 = slice.a[i$1];
            f$1(x0$16);
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((slice instanceof $ac_Z)) {
          while ((i$1 < len$1)) {
            var x0$17 = slice.a[i$1];
            f$1(x0$17);
            i$1 = ((1 + i$1) | 0);
          }
        } else {
          throw new $c_s_MatchError(slice);
        }
        return (void 0);
      }
      var a$2 = (31 & ((((1048576 - $thiz.cH) | 0) >>> 15) | 0));
      var copy1$3 = ((a$2 < sl) ? a$2 : sl);
      var copy2$3 = ((sl - copy1$3) | 0);
      var destPos$3 = (31 & (($thiz.cH >>> 15) | 0));
      var dest$4 = $thiz.fL;
      slice.av(0, dest$4, destPos$3, copy1$3);
      $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy1$3 << 15));
      if ((copy2$3 > 0)) {
        var dest$5 = $thiz.fL;
        slice.av(copy1$3, dest$5, 0, copy2$3);
        $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy2$3 << 15));
      }
      break;
    }
    case 5: {
      var num$2 = $thiz.cH;
      var t$2 = (((num$2 >> 19) >>> 12) | 0);
      if (((((1048575 & ((num$2 + t$2) | 0)) - t$2) | 0) !== 0)) {
        var f$2 = ((e$2$2$2) => {
          $p_sci_VectorBuilder__addArrN__AO__I__V($thiz, e$2$2$2, 4);
        });
        var len$2 = slice.a.length;
        var i$2 = 0;
        if ((slice !== null)) {
          while ((i$2 < len$2)) {
            var x0$18 = slice.a[i$2];
            f$2(x0$18);
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((slice instanceof $ac_I)) {
          while ((i$2 < len$2)) {
            var x0$19 = slice.a[i$2];
            f$2(x0$19);
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((slice instanceof $ac_D)) {
          while ((i$2 < len$2)) {
            var x0$20 = slice.a[i$2];
            f$2(x0$20);
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((slice instanceof $ac_J)) {
          while ((i$2 < len$2)) {
            var $x_5 = slice.a;
            var $x_6 = (i$2 << 1);
            var x0$21_$_lo = $x_5[$x_6];
            var x0$21_$_hi = $x_5[(($x_6 + 1) | 0)];
            f$2($bL(x0$21_$_lo, x0$21_$_hi));
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((slice instanceof $ac_F)) {
          while ((i$2 < len$2)) {
            var x0$22 = slice.a[i$2];
            f$2(x0$22);
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((slice instanceof $ac_C)) {
          while ((i$2 < len$2)) {
            var x0$23 = slice.a[i$2];
            f$2($bC(x0$23));
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((slice instanceof $ac_B)) {
          while ((i$2 < len$2)) {
            var x0$24 = slice.a[i$2];
            f$2(x0$24);
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((slice instanceof $ac_S)) {
          while ((i$2 < len$2)) {
            var x0$25 = slice.a[i$2];
            f$2(x0$25);
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((slice instanceof $ac_Z)) {
          while ((i$2 < len$2)) {
            var x0$26 = slice.a[i$2];
            f$2(x0$26);
            i$2 = ((1 + i$2) | 0);
          }
        } else {
          throw new $c_s_MatchError(slice);
        }
        return (void 0);
      }
      var a$3 = (31 & ((((33554432 - $thiz.cH) | 0) >>> 20) | 0));
      var copy1$4 = ((a$3 < sl) ? a$3 : sl);
      var copy2$4 = ((sl - copy1$4) | 0);
      var destPos$4 = (31 & (($thiz.cH >>> 20) | 0));
      var dest$6 = $thiz.gN;
      slice.av(0, dest$6, destPos$4, copy1$4);
      $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy1$4 << 20));
      if ((copy2$4 > 0)) {
        var dest$7 = $thiz.gN;
        slice.av(copy1$4, dest$7, 0, copy2$4);
        $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy2$4 << 20));
      }
      break;
    }
    case 6: {
      var num$3 = $thiz.cH;
      var t$3 = (((num$3 >> 24) >>> 7) | 0);
      if (((((33554431 & ((num$3 + t$3) | 0)) - t$3) | 0) !== 0)) {
        var f$3 = ((e$2$2$3) => {
          $p_sci_VectorBuilder__addArrN__AO__I__V($thiz, e$2$2$3, 5);
        });
        var len$3 = slice.a.length;
        var i$3 = 0;
        if ((slice !== null)) {
          while ((i$3 < len$3)) {
            var x0$27 = slice.a[i$3];
            f$3(x0$27);
            i$3 = ((1 + i$3) | 0);
          }
        } else if ((slice instanceof $ac_I)) {
          while ((i$3 < len$3)) {
            var x0$28 = slice.a[i$3];
            f$3(x0$28);
            i$3 = ((1 + i$3) | 0);
          }
        } else if ((slice instanceof $ac_D)) {
          while ((i$3 < len$3)) {
            var x0$29 = slice.a[i$3];
            f$3(x0$29);
            i$3 = ((1 + i$3) | 0);
          }
        } else if ((slice instanceof $ac_J)) {
          while ((i$3 < len$3)) {
            var $x_7 = slice.a;
            var $x_8 = (i$3 << 1);
            var x0$30_$_lo = $x_7[$x_8];
            var x0$30_$_hi = $x_7[(($x_8 + 1) | 0)];
            f$3($bL(x0$30_$_lo, x0$30_$_hi));
            i$3 = ((1 + i$3) | 0);
          }
        } else if ((slice instanceof $ac_F)) {
          while ((i$3 < len$3)) {
            var x0$31 = slice.a[i$3];
            f$3(x0$31);
            i$3 = ((1 + i$3) | 0);
          }
        } else if ((slice instanceof $ac_C)) {
          while ((i$3 < len$3)) {
            var x0$32 = slice.a[i$3];
            f$3($bC(x0$32));
            i$3 = ((1 + i$3) | 0);
          }
        } else if ((slice instanceof $ac_B)) {
          while ((i$3 < len$3)) {
            var x0$33 = slice.a[i$3];
            f$3(x0$33);
            i$3 = ((1 + i$3) | 0);
          }
        } else if ((slice instanceof $ac_S)) {
          while ((i$3 < len$3)) {
            var x0$34 = slice.a[i$3];
            f$3(x0$34);
            i$3 = ((1 + i$3) | 0);
          }
        } else if ((slice instanceof $ac_Z)) {
          while ((i$3 < len$3)) {
            var x0$35 = slice.a[i$3];
            f$3(x0$35);
            i$3 = ((1 + i$3) | 0);
          }
        } else {
          throw new $c_s_MatchError(slice);
        }
        return (void 0);
      }
      var destPos$5 = (($thiz.cH >>> 25) | 0);
      if ((((destPos$5 + sl) | 0) > 64)) {
        throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "exceeding 2^31 elements");
      }
      var dest$8 = $thiz.kh;
      slice.av(0, dest$8, destPos$5, sl);
      $p_sci_VectorBuilder__advanceN__I__V($thiz, (sl << 25));
      break;
    }
    default: {
      throw new $c_s_MatchError(dim);
    }
  }
}
function $p_sci_VectorBuilder__addVector__sci_Vector__sci_VectorBuilder($thiz, xs) {
  var sliceCount = xs.um();
  var sliceIdx = 0;
  while ((sliceIdx < sliceCount)) {
    var slice = xs.wn(sliceIdx);
    var idx = sliceIdx;
    var c = (((sliceCount + ((sliceCount >>> 31) | 0)) | 0) >> 1);
    var a = ((idx - c) | 0);
    var sign = (a >> 31);
    var x1 = ((((1 + c) | 0) - (((a ^ sign) - sign) | 0)) | 0);
    if ((x1 === 1)) {
      $p_sci_VectorBuilder__addArr1__AO__V($thiz, slice);
    } else if ((($thiz.dF === 32) || ($thiz.dF === 0))) {
      $p_sci_VectorBuilder__addArrN__AO__I__V($thiz, slice, x1);
    } else {
      $m_sci_VectorStatics$().a3r(((x1 - 2) | 0), slice, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((data$2$2) => {
        $p_sci_VectorBuilder__addArr1__AO__V($thiz, data$2$2);
      })));
    }
    sliceIdx = ((1 + sliceIdx) | 0);
  }
  return $thiz;
}
function $p_sci_VectorBuilder__advance__V($thiz) {
  var idx = ((32 + $thiz.cH) | 0);
  var xor = (idx ^ $thiz.cH);
  $thiz.cH = idx;
  $thiz.dF = 0;
  $p_sci_VectorBuilder__advance1__I__I__V($thiz, idx, xor);
}
function $p_sci_VectorBuilder__advanceN__I__V($thiz, n) {
  if ((n > 0)) {
    var idx = (($thiz.cH + n) | 0);
    var xor = (idx ^ $thiz.cH);
    $thiz.cH = idx;
    $thiz.dF = 0;
    $p_sci_VectorBuilder__advance1__I__I__V($thiz, idx, xor);
  }
}
function $p_sci_VectorBuilder__advance1__I__I__V($thiz, idx, xor) {
  if ((xor <= 0)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((((((((((((((((("advance1(" + idx) + ", ") + xor) + "): a1=") + $thiz.g8) + ", a2=") + $thiz.dZ) + ", a3=") + $thiz.eL) + ", a4=") + $thiz.fL) + ", a5=") + $thiz.gN) + ", a6=") + $thiz.kh) + ", depth=") + $thiz.eM));
  } else if ((xor < 1024)) {
    if (($thiz.eM <= 1)) {
      $thiz.dZ = new ($d_O.r().r().C)(32);
      $thiz.dZ.a[0] = $thiz.g8;
      $thiz.eM = 2;
    }
    $thiz.g8 = new $ac_O(32);
    $thiz.dZ.a[(31 & ((idx >>> 5) | 0))] = $thiz.g8;
  } else if ((xor < 32768)) {
    if (($thiz.eM <= 2)) {
      $thiz.eL = new ($d_O.r().r().r().C)(32);
      $thiz.eL.a[0] = $thiz.dZ;
      $thiz.eM = 3;
    }
    $thiz.g8 = new $ac_O(32);
    $thiz.dZ = new ($d_O.r().r().C)(32);
    $thiz.dZ.a[(31 & ((idx >>> 5) | 0))] = $thiz.g8;
    $thiz.eL.a[(31 & ((idx >>> 10) | 0))] = $thiz.dZ;
  } else if ((xor < 1048576)) {
    if (($thiz.eM <= 3)) {
      $thiz.fL = new ($d_O.r().r().r().r().C)(32);
      $thiz.fL.a[0] = $thiz.eL;
      $thiz.eM = 4;
    }
    $thiz.g8 = new $ac_O(32);
    $thiz.dZ = new ($d_O.r().r().C)(32);
    $thiz.eL = new ($d_O.r().r().r().C)(32);
    $thiz.dZ.a[(31 & ((idx >>> 5) | 0))] = $thiz.g8;
    $thiz.eL.a[(31 & ((idx >>> 10) | 0))] = $thiz.dZ;
    $thiz.fL.a[(31 & ((idx >>> 15) | 0))] = $thiz.eL;
  } else if ((xor < 33554432)) {
    if (($thiz.eM <= 4)) {
      $thiz.gN = new ($d_O.r().r().r().r().r().C)(32);
      $thiz.gN.a[0] = $thiz.fL;
      $thiz.eM = 5;
    }
    $thiz.g8 = new $ac_O(32);
    $thiz.dZ = new ($d_O.r().r().C)(32);
    $thiz.eL = new ($d_O.r().r().r().C)(32);
    $thiz.fL = new ($d_O.r().r().r().r().C)(32);
    $thiz.dZ.a[(31 & ((idx >>> 5) | 0))] = $thiz.g8;
    $thiz.eL.a[(31 & ((idx >>> 10) | 0))] = $thiz.dZ;
    $thiz.fL.a[(31 & ((idx >>> 15) | 0))] = $thiz.eL;
    $thiz.gN.a[(31 & ((idx >>> 20) | 0))] = $thiz.fL;
  } else {
    if (($thiz.eM <= 5)) {
      $thiz.kh = new ($d_O.r().r().r().r().r().r().C)(64);
      $thiz.kh.a[0] = $thiz.gN;
      $thiz.eM = 6;
    }
    $thiz.g8 = new $ac_O(32);
    $thiz.dZ = new ($d_O.r().r().C)(32);
    $thiz.eL = new ($d_O.r().r().r().C)(32);
    $thiz.fL = new ($d_O.r().r().r().r().C)(32);
    $thiz.gN = new ($d_O.r().r().r().r().r().C)(32);
    $thiz.dZ.a[(31 & ((idx >>> 5) | 0))] = $thiz.g8;
    $thiz.eL.a[(31 & ((idx >>> 10) | 0))] = $thiz.dZ;
    $thiz.fL.a[(31 & ((idx >>> 15) | 0))] = $thiz.eL;
    $thiz.gN.a[(31 & ((idx >>> 20) | 0))] = $thiz.fL;
    $thiz.kh.a[((idx >>> 25) | 0)] = $thiz.gN;
  }
}
/** @constructor */
function $c_sci_VectorBuilder() {
  this.kh = null;
  this.gN = null;
  this.fL = null;
  this.eL = null;
  this.dZ = null;
  this.g8 = null;
  this.dF = 0;
  this.cH = 0;
  this.dT = 0;
  this.V8 = false;
  this.eM = 0;
  this.g8 = new $ac_O(32);
  this.dF = 0;
  this.cH = 0;
  this.dT = 0;
  this.V8 = false;
  this.eM = 1;
}
$p = $c_sci_VectorBuilder.prototype = new $h_O();
$p.constructor = $c_sci_VectorBuilder;
/** @constructor */
function $h_sci_VectorBuilder() {
}
$h_sci_VectorBuilder.prototype = $p;
$p.f9 = (function(size) {
});
$p.V = (function() {
  return ((((this.dF + this.cH) | 0) - this.dT) | 0);
});
$p.b2Q = (function(prefix1) {
  this.eM = 1;
  var i = prefix1.a.length;
  this.dF = (31 & i);
  this.cH = ((i - this.dF) | 0);
  this.g8 = ((prefix1.a.length === 32) ? prefix1 : $m_ju_Arrays$().d7(prefix1, 0, 32));
  if (((this.dF === 0) && (this.cH > 0))) {
    this.dF = 32;
    this.cH = ((this.cH - 32) | 0);
  }
});
$p.aPf = (function(v) {
  var x1 = v.um();
  switch (x1) {
    case 0: {
      break;
    }
    case 1: {
      this.eM = 1;
      var i = v.a9.a.length;
      this.dF = (31 & i);
      this.cH = ((i - this.dF) | 0);
      var a = v.a9;
      this.g8 = ((a.a.length === 32) ? a : $m_ju_Arrays$().d7(a, 0, 32));
      break;
    }
    case 3: {
      var d2 = v.iF;
      var a$1 = v.al;
      this.g8 = ((a$1.a.length === 32) ? a$1 : $m_ju_Arrays$().d7(a$1, 0, 32));
      this.eM = 2;
      this.dT = ((32 - v.jO) | 0);
      var i$1 = ((v.at + this.dT) | 0);
      this.dF = (31 & i$1);
      this.cH = ((i$1 - this.dF) | 0);
      this.dZ = new ($d_O.r().r().C)(32);
      this.dZ.a[0] = v.a9;
      var dest = this.dZ;
      var length = d2.a.length;
      d2.av(0, dest, 1, length);
      this.dZ.a[((1 + d2.a.length) | 0)] = this.g8;
      break;
    }
    case 5: {
      var d3 = v.gM;
      var s2 = v.hi;
      var a$2 = v.al;
      this.g8 = ((a$2.a.length === 32) ? a$2 : $m_ju_Arrays$().d7(a$2, 0, 32));
      this.eM = 3;
      this.dT = ((1024 - v.i5) | 0);
      var i$2 = ((v.at + this.dT) | 0);
      this.dF = (31 & i$2);
      this.cH = ((i$2 - this.dF) | 0);
      this.eL = new ($d_O.r().r().r().C)(32);
      this.eL.a[0] = $m_sci_VectorStatics$().cQ(v.a9, v.jf);
      var dest$1 = this.eL;
      var length$1 = d3.a.length;
      d3.av(0, dest$1, 1, length$1);
      this.dZ = $m_ju_Arrays$().ex(s2, 32);
      this.eL.a[((1 + d3.a.length) | 0)] = this.dZ;
      this.dZ.a[s2.a.length] = this.g8;
      break;
    }
    case 7: {
      var d4 = v.fJ;
      var s3 = v.g2;
      var s2$2 = v.g1;
      var a$3 = v.al;
      this.g8 = ((a$3.a.length === 32) ? a$3 : $m_ju_Arrays$().d7(a$3, 0, 32));
      this.eM = 4;
      this.dT = ((32768 - v.gu) | 0);
      var i$3 = ((v.at + this.dT) | 0);
      this.dF = (31 & i$3);
      this.cH = ((i$3 - this.dF) | 0);
      this.fL = new ($d_O.r().r().r().r().C)(32);
      this.fL.a[0] = $m_sci_VectorStatics$().cQ($m_sci_VectorStatics$().cQ(v.a9, v.hj), v.hk);
      var dest$2 = this.fL;
      var length$2 = d4.a.length;
      d4.av(0, dest$2, 1, length$2);
      this.eL = $m_ju_Arrays$().ex(s3, 32);
      this.dZ = $m_ju_Arrays$().ex(s2$2, 32);
      this.fL.a[((1 + d4.a.length) | 0)] = this.eL;
      this.eL.a[s3.a.length] = this.dZ;
      this.dZ.a[s2$2.a.length] = this.g8;
      break;
    }
    case 9: {
      var d5 = v.eK;
      var s4 = v.eS;
      var s3$2 = v.eR;
      var s2$3 = v.eQ;
      var a$4 = v.al;
      this.g8 = ((a$4.a.length === 32) ? a$4 : $m_ju_Arrays$().d7(a$4, 0, 32));
      this.eM = 5;
      this.dT = ((1048576 - v.fl) | 0);
      var i$4 = ((v.at + this.dT) | 0);
      this.dF = (31 & i$4);
      this.cH = ((i$4 - this.dF) | 0);
      this.gN = new ($d_O.r().r().r().r().r().C)(32);
      this.gN.a[0] = $m_sci_VectorStatics$().cQ($m_sci_VectorStatics$().cQ($m_sci_VectorStatics$().cQ(v.a9, v.g3), v.g4), v.g5);
      var dest$3 = this.gN;
      var length$3 = d5.a.length;
      d5.av(0, dest$3, 1, length$3);
      this.fL = $m_ju_Arrays$().ex(s4, 32);
      this.eL = $m_ju_Arrays$().ex(s3$2, 32);
      this.dZ = $m_ju_Arrays$().ex(s2$3, 32);
      this.gN.a[((1 + d5.a.length) | 0)] = this.fL;
      this.fL.a[s4.a.length] = this.eL;
      this.eL.a[s3$2.a.length] = this.dZ;
      this.dZ.a[s2$3.a.length] = this.g8;
      break;
    }
    case 11: {
      var d6 = v.ef;
      var s5 = v.ev;
      var s4$2 = v.eu;
      var s3$3 = v.et;
      var s2$4 = v.es;
      var a$5 = v.al;
      this.g8 = ((a$5.a.length === 32) ? a$5 : $m_ju_Arrays$().d7(a$5, 0, 32));
      this.eM = 6;
      this.dT = ((33554432 - v.f5) | 0);
      var i$5 = ((v.at + this.dT) | 0);
      this.dF = (31 & i$5);
      this.cH = ((i$5 - this.dF) | 0);
      this.kh = new ($d_O.r().r().r().r().r().r().C)(64);
      this.kh.a[0] = $m_sci_VectorStatics$().cQ($m_sci_VectorStatics$().cQ($m_sci_VectorStatics$().cQ($m_sci_VectorStatics$().cQ(v.a9, v.fn), v.fo), v.fp), v.fq);
      var dest$4 = this.kh;
      var length$4 = d6.a.length;
      d6.av(0, dest$4, 1, length$4);
      this.gN = $m_ju_Arrays$().ex(s5, 32);
      this.fL = $m_ju_Arrays$().ex(s4$2, 32);
      this.eL = $m_ju_Arrays$().ex(s3$3, 32);
      this.dZ = $m_ju_Arrays$().ex(s2$4, 32);
      this.kh.a[((1 + d6.a.length) | 0)] = this.gN;
      this.gN.a[s5.a.length] = this.fL;
      this.fL.a[s4$2.a.length] = this.eL;
      this.eL.a[s3$3.a.length] = this.dZ;
      this.dZ.a[s2$4.a.length] = this.g8;
      break;
    }
    default: {
      throw new $c_s_MatchError(x1);
    }
  }
  if (((this.dF === 0) && (this.cH > 0))) {
    this.dF = 32;
    this.cH = ((this.cH - 32) | 0);
  }
  return this;
});
$p.aWT = (function(before, bigVector) {
  if (((this.dF !== 0) || (this.cH !== 0))) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "A non-empty VectorBuilder cannot be aligned retrospectively. Please call .reset() or use a new VectorBuilder.");
  }
  if ($m_sci_Vector0$().e(bigVector)) {
    var x1$2___1 = null;
    var x1$2___2 = null;
    var x1$2___1$mcI$sp = 0;
    var x1$2___2$mcI$sp = 1;
  } else if ((bigVector instanceof $c_sci_Vector1)) {
    var x1$2___1 = null;
    var x1$2___2 = null;
    var x1$2___1$mcI$sp = 0;
    var x1$2___2$mcI$sp = 1;
  } else if ((bigVector instanceof $c_sci_Vector2)) {
    var x1$2___1 = null;
    var x1$2___2 = null;
    var x1$2___1$mcI$sp = bigVector.jO;
    var x1$2___2$mcI$sp = 32;
  } else if ((bigVector instanceof $c_sci_Vector3)) {
    var x1$2___1 = null;
    var x1$2___2 = null;
    var x1$2___1$mcI$sp = bigVector.i5;
    var x1$2___2$mcI$sp = 1024;
  } else if ((bigVector instanceof $c_sci_Vector4)) {
    var x1$2___1 = null;
    var x1$2___2 = null;
    var x1$2___1$mcI$sp = bigVector.gu;
    var x1$2___2$mcI$sp = 32768;
  } else if ((bigVector instanceof $c_sci_Vector5)) {
    var x1$2___1 = null;
    var x1$2___2 = null;
    var x1$2___1$mcI$sp = bigVector.fl;
    var x1$2___2$mcI$sp = 1048576;
  } else {
    if ((!(bigVector instanceof $c_sci_Vector6))) {
      throw new $c_s_MatchError(bigVector);
    }
    var x1$2___1 = null;
    var x1$2___2 = null;
    var x1$2___1$mcI$sp = bigVector.f5;
    var x1$2___2$mcI$sp = 33554432;
  }
  var prefixLength = x1$2___1$mcI$sp;
  var maxPrefixLength = x1$2___2$mcI$sp;
  if ((maxPrefixLength === 1)) {
    return this;
  }
  var overallPrefixLength = ((((before + prefixLength) | 0) % $checkIntDivisor(maxPrefixLength)) | 0);
  this.dT = ((((maxPrefixLength - overallPrefixLength) | 0) % $checkIntDivisor(maxPrefixLength)) | 0);
  $p_sci_VectorBuilder__advanceN__I__V(this, ((-32) & this.dT));
  this.dF = (31 & this.dT);
  this.V8 = true;
  return this;
});
$p.ck = (function(elem) {
  if ((this.dF === 32)) {
    $p_sci_VectorBuilder__advance__V(this);
  }
  this.g8.a[this.dF] = elem;
  this.dF = ((1 + this.dF) | 0);
  return this;
});
$p.fO = (function(xs) {
  return ((xs instanceof $c_sci_Vector) ? ((((this.dF === 0) && (this.cH === 0)) && (!this.V8)) ? this.aPf(xs) : $p_sci_VectorBuilder__addVector__sci_Vector__sci_VectorBuilder(this, xs)) : $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs));
});
$p.bY = (function() {
  if (this.V8) {
    $p_sci_VectorBuilder__leftAlignPrefix__V(this);
  }
  var len = ((this.dF + this.cH) | 0);
  var realLen = ((len - this.dT) | 0);
  if ((realLen === 0)) {
    $m_sci_Vector$();
    return $m_sci_Vector0$();
  } else if ((len < 0)) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("Vector cannot have negative size " + len));
  } else if ((len <= 32)) {
    var a = this.g8;
    return new $c_sci_Vector1(((a.a.length === realLen) ? a : $m_ju_Arrays$().ex(a, realLen)));
  } else if ((len <= 1024)) {
    var i1 = (31 & ((len - 1) | 0));
    var i2 = ((((len - 1) | 0) >>> 5) | 0);
    var data = $m_ju_Arrays$().d7(this.dZ, 1, i2);
    var prefix1 = this.dZ.a[0];
    var a$1 = this.dZ.a[i2];
    var len$1 = ((1 + i1) | 0);
    var suffix1 = ((a$1.a.length === len$1) ? a$1 : $m_ju_Arrays$().ex(a$1, len$1));
    return new $c_sci_Vector2(prefix1, ((32 - this.dT) | 0), data, suffix1, realLen);
  } else if ((len <= 32768)) {
    var i1$2 = (31 & ((len - 1) | 0));
    var i2$2 = (31 & ((((len - 1) | 0) >>> 5) | 0));
    var i3 = ((((len - 1) | 0) >>> 10) | 0);
    var data$2 = $m_ju_Arrays$().d7(this.eL, 1, i3);
    var a$2 = this.eL.a[0];
    var prefix2 = $m_ju_Arrays$().d7(a$2, 1, a$2.a.length);
    var prefix1$2 = this.eL.a[0].a[0];
    var suffix2 = $m_ju_Arrays$().ex(this.eL.a[i3], i2$2);
    var a$3 = this.eL.a[i3].a[i2$2];
    var len$2 = ((1 + i1$2) | 0);
    var suffix1$2 = ((a$3.a.length === len$2) ? a$3 : $m_ju_Arrays$().ex(a$3, len$2));
    var len1 = prefix1$2.a.length;
    return new $c_sci_Vector3(prefix1$2, len1, prefix2, ((len1 + (prefix2.a.length << 5)) | 0), data$2, suffix2, suffix1$2, realLen);
  } else if ((len <= 1048576)) {
    var i1$3 = (31 & ((len - 1) | 0));
    var i2$3 = (31 & ((((len - 1) | 0) >>> 5) | 0));
    var i3$2 = (31 & ((((len - 1) | 0) >>> 10) | 0));
    var i4 = ((((len - 1) | 0) >>> 15) | 0);
    var data$3 = $m_ju_Arrays$().d7(this.fL, 1, i4);
    var a$4 = this.fL.a[0];
    var prefix3 = $m_ju_Arrays$().d7(a$4, 1, a$4.a.length);
    var a$5 = this.fL.a[0].a[0];
    var prefix2$2 = $m_ju_Arrays$().d7(a$5, 1, a$5.a.length);
    var prefix1$3 = this.fL.a[0].a[0].a[0];
    var suffix3 = $m_ju_Arrays$().ex(this.fL.a[i4], i3$2);
    var suffix2$2 = $m_ju_Arrays$().ex(this.fL.a[i4].a[i3$2], i2$3);
    var a$6 = this.fL.a[i4].a[i3$2].a[i2$3];
    var len$3 = ((1 + i1$3) | 0);
    var suffix1$3 = ((a$6.a.length === len$3) ? a$6 : $m_ju_Arrays$().ex(a$6, len$3));
    var len1$2 = prefix1$3.a.length;
    var len12$2 = ((len1$2 + (prefix2$2.a.length << 5)) | 0);
    return new $c_sci_Vector4(prefix1$3, len1$2, prefix2$2, len12$2, prefix3, ((len12$2 + (prefix3.a.length << 10)) | 0), data$3, suffix3, suffix2$2, suffix1$3, realLen);
  } else if ((len <= 33554432)) {
    var i1$4 = (31 & ((len - 1) | 0));
    var i2$4 = (31 & ((((len - 1) | 0) >>> 5) | 0));
    var i3$3 = (31 & ((((len - 1) | 0) >>> 10) | 0));
    var i4$2 = (31 & ((((len - 1) | 0) >>> 15) | 0));
    var i5 = ((((len - 1) | 0) >>> 20) | 0);
    var data$4 = $m_ju_Arrays$().d7(this.gN, 1, i5);
    var a$7 = this.gN.a[0];
    var prefix4 = $m_ju_Arrays$().d7(a$7, 1, a$7.a.length);
    var a$8 = this.gN.a[0].a[0];
    var prefix3$2 = $m_ju_Arrays$().d7(a$8, 1, a$8.a.length);
    var a$9 = this.gN.a[0].a[0].a[0];
    var prefix2$3 = $m_ju_Arrays$().d7(a$9, 1, a$9.a.length);
    var prefix1$4 = this.gN.a[0].a[0].a[0].a[0];
    var suffix4 = $m_ju_Arrays$().ex(this.gN.a[i5], i4$2);
    var suffix3$2 = $m_ju_Arrays$().ex(this.gN.a[i5].a[i4$2], i3$3);
    var suffix2$3 = $m_ju_Arrays$().ex(this.gN.a[i5].a[i4$2].a[i3$3], i2$4);
    var a$10 = this.gN.a[i5].a[i4$2].a[i3$3].a[i2$4];
    var len$4 = ((1 + i1$4) | 0);
    var suffix1$4 = ((a$10.a.length === len$4) ? a$10 : $m_ju_Arrays$().ex(a$10, len$4));
    var len1$3 = prefix1$4.a.length;
    var len12$3 = ((len1$3 + (prefix2$3.a.length << 5)) | 0);
    var len123$2 = ((len12$3 + (prefix3$2.a.length << 10)) | 0);
    return new $c_sci_Vector5(prefix1$4, len1$3, prefix2$3, len12$3, prefix3$2, len123$2, prefix4, ((len123$2 + (prefix4.a.length << 15)) | 0), data$4, suffix4, suffix3$2, suffix2$3, suffix1$4, realLen);
  } else {
    var i1$5 = (31 & ((len - 1) | 0));
    var i2$5 = (31 & ((((len - 1) | 0) >>> 5) | 0));
    var i3$4 = (31 & ((((len - 1) | 0) >>> 10) | 0));
    var i4$3 = (31 & ((((len - 1) | 0) >>> 15) | 0));
    var i5$2 = (31 & ((((len - 1) | 0) >>> 20) | 0));
    var i6 = ((((len - 1) | 0) >>> 25) | 0);
    var data$5 = $m_ju_Arrays$().d7(this.kh, 1, i6);
    var a$11 = this.kh.a[0];
    var prefix5 = $m_ju_Arrays$().d7(a$11, 1, a$11.a.length);
    var a$12 = this.kh.a[0].a[0];
    var prefix4$2 = $m_ju_Arrays$().d7(a$12, 1, a$12.a.length);
    var a$13 = this.kh.a[0].a[0].a[0];
    var prefix3$3 = $m_ju_Arrays$().d7(a$13, 1, a$13.a.length);
    var a$14 = this.kh.a[0].a[0].a[0].a[0];
    var prefix2$4 = $m_ju_Arrays$().d7(a$14, 1, a$14.a.length);
    var prefix1$5 = this.kh.a[0].a[0].a[0].a[0].a[0];
    var suffix5 = $m_ju_Arrays$().ex(this.kh.a[i6], i5$2);
    var suffix4$2 = $m_ju_Arrays$().ex(this.kh.a[i6].a[i5$2], i4$3);
    var suffix3$3 = $m_ju_Arrays$().ex(this.kh.a[i6].a[i5$2].a[i4$3], i3$4);
    var suffix2$4 = $m_ju_Arrays$().ex(this.kh.a[i6].a[i5$2].a[i4$3].a[i3$4], i2$5);
    var a$15 = this.kh.a[i6].a[i5$2].a[i4$3].a[i3$4].a[i2$5];
    var len$5 = ((1 + i1$5) | 0);
    var suffix1$5 = ((a$15.a.length === len$5) ? a$15 : $m_ju_Arrays$().ex(a$15, len$5));
    var len1$4 = prefix1$5.a.length;
    var len12$4 = ((len1$4 + (prefix2$4.a.length << 5)) | 0);
    var len123$3 = ((len12$4 + (prefix3$3.a.length << 10)) | 0);
    var len1234$2 = ((len123$3 + (prefix4$2.a.length << 15)) | 0);
    return new $c_sci_Vector6(prefix1$5, len1$4, prefix2$4, len12$4, prefix3$3, len123$3, prefix4$2, len1234$2, prefix5, ((len1234$2 + (prefix5.a.length << 20)) | 0), data$5, suffix5, suffix4$2, suffix3$3, suffix2$4, suffix1$5, realLen);
  }
});
$p.m = (function() {
  return (((((((("VectorBuilder(len1=" + this.dF) + ", lenRest=") + this.cH) + ", offset=") + this.dT) + ", depth=") + this.eM) + ")");
});
$p.aR = (function() {
  return this.bY();
});
$p.dG = (function(elems) {
  return this.fO(elems);
});
$p.Y = (function(elem) {
  return this.ck(elem);
});
var $d_sci_VectorBuilder = new $TypeData().i($c_sci_VectorBuilder, "scala.collection.immutable.VectorBuilder", ({
  Jn: 1,
  b2: 1,
  Y: 1,
  T: 1,
  S: 1
}));
function $p_sci_VectorMap$$anon$1__advance__V($thiz) {
  var nextSlot = ((1 + $thiz.O7) | 0);
  if ((nextSlot >= $thiz.V9)) {
    $thiz.O7 = $thiz.V9;
    $thiz.O6 = null;
  } else {
    var x1 = $thiz.acO.b8b(nextSlot);
    matchEnd6: {
      if ((x1 !== null)) {
        if ((x1.xY() === (-1))) {
          $thiz.O7 = $thiz.V9;
          $thiz.O6 = null;
          break matchEnd6;
        }
      }
      if ((x1 !== null)) {
        var s = x1.xY();
        var k = x1.h();
        $thiz.O7 = s;
        $thiz.O6 = k;
        break matchEnd6;
      }
      throw new $c_s_MatchError(x1);
    }
  }
}
/** @constructor */
function $c_sci_VectorMap$$anon$1(outer) {
  this.V9 = 0;
  this.O7 = 0;
  this.O6 = null;
  this.acO = null;
  this.acO = outer;
  this.V9 = outer.tJ.C();
  this.O7 = (-1);
  this.O6 = null;
  $p_sci_VectorMap$$anon$1__advance__V(this);
}
$p = $c_sci_VectorMap$$anon$1.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sci_VectorMap$$anon$1;
/** @constructor */
function $h_sci_VectorMap$$anon$1() {
}
$h_sci_VectorMap$$anon$1.prototype = $p;
$p.p = (function() {
  return (this.O7 < this.V9);
});
$p.dC = (function() {
  if ((!this.p())) {
    return $m_sc_Iterator$().b8.q();
  } else {
    var result = new $c_T2(this.O6, this.acO.l8.i(this.O6).h());
    $p_sci_VectorMap$$anon$1__advance__V(this);
    return result;
  }
});
$p.q = (function() {
  return this.dC();
});
var $d_sci_VectorMap$$anon$1 = new $TypeData().i($c_sci_VectorMap$$anon$1, "scala.collection.immutable.VectorMap$$anon$1", ({
  Jp: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_scm_ArrayBuffer$() {
  this.aIy = null;
  $n_scm_ArrayBuffer$ = this;
  this.aIy = new $ac_O(0);
}
$p = $c_scm_ArrayBuffer$.prototype = new $h_O();
$p.constructor = $c_scm_ArrayBuffer$;
/** @constructor */
function $h_scm_ArrayBuffer$() {
}
$h_scm_ArrayBuffer$.prototype = $p;
$p.dr = (function(elems) {
  return this.y9(elems);
});
$p.y9 = (function(coll) {
  var k = coll.V();
  if ((k >= 0)) {
    var array = this.aRW(this.aIy, 0, k);
    var actual = ($is_sc_Iterable(coll) ? coll.cR(array, 0, 2147483647) : coll.o().cR(array, 0, 2147483647));
    if ((actual !== k)) {
      throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), ((("Copied " + actual) + " of ") + k));
    }
    return $ct_scm_ArrayBuffer__AO__I__(new $c_scm_ArrayBuffer(), array, k);
  } else {
    return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer()).gS(coll);
  }
});
$p.b5 = (function() {
  return new $c_scm_ArrayBuffer$$anon$1();
});
$p.b7N = (function(arrayLen, targetLen) {
  if ((targetLen < 0)) {
    throw $ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), ((((("Overflow while resizing array of array-backed collection. Requested length: " + targetLen) + "; current length: ") + arrayLen) + "; increase: ") + ((targetLen - arrayLen) | 0)));
  } else if ((targetLen <= arrayLen)) {
    return (-1);
  } else {
    if ((targetLen > 2147483639)) {
      throw $ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), ((("Array of array-backed collection exceeds VM length limit of 2147483639. Requested length: " + targetLen) + "; current length: ") + arrayLen));
    }
    if ((arrayLen > 1073741819)) {
      return 2147483639;
    } else {
      var x = (arrayLen << 1);
      var y = ((x > 16) ? x : 16);
      return ((targetLen > y) ? targetLen : y);
    }
  }
});
$p.aRW = (function(array, curSize, targetSize) {
  var newLen = this.b7N(array.a.length, targetSize);
  if ((newLen < 0)) {
    return array;
  } else {
    var res = new $ac_O(newLen);
    array.av(0, res, 0, curSize);
    return res;
  }
});
$p.aO = (function() {
  return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
});
$p.cc = (function(source) {
  return this.y9(source);
});
var $d_scm_ArrayBuffer$ = new $TypeData().i($c_scm_ArrayBuffer$, "scala.collection.mutable.ArrayBuffer$", ({
  Jv: 1,
  ba: 1,
  at: 1,
  a0: 1,
  a: 1
}));
var $n_scm_ArrayBuffer$;
function $m_scm_ArrayBuffer$() {
  if ((!$n_scm_ArrayBuffer$)) {
    $n_scm_ArrayBuffer$ = new $c_scm_ArrayBuffer$();
  }
  return $n_scm_ArrayBuffer$;
}
/** @constructor */
function $c_scm_ArrayBuffer$$anon$1() {
  this.gj = null;
  $ct_scm_GrowableBuilder__scm_Growable__(this, ($m_scm_ArrayBuffer$(), $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer())));
}
$p = $c_scm_ArrayBuffer$$anon$1.prototype = new $h_scm_GrowableBuilder();
$p.constructor = $c_scm_ArrayBuffer$$anon$1;
/** @constructor */
function $h_scm_ArrayBuffer$$anon$1() {
}
$h_scm_ArrayBuffer$$anon$1.prototype = $p;
$p.f9 = (function(size) {
  this.gj.f9(size);
});
var $d_scm_ArrayBuffer$$anon$1 = new $TypeData().i($c_scm_ArrayBuffer$$anon$1, "scala.collection.mutable.ArrayBuffer$$anon$1", ({
  Jw: 1,
  c2: 1,
  Y: 1,
  T: 1,
  S: 1
}));
/** @constructor */
function $c_scm_ArrayDeque$() {
}
$p = $c_scm_ArrayDeque$.prototype = new $h_O();
$p.constructor = $c_scm_ArrayDeque$;
/** @constructor */
function $h_scm_ArrayDeque$() {
}
$h_scm_ArrayDeque$.prototype = $p;
$p.dr = (function(elems) {
  return this.aOu(elems);
});
$p.aOu = (function(coll) {
  var s = coll.V();
  if ((s >= 0)) {
    var array = this.vT(s);
    var actual = ($is_sc_Iterable(coll) ? coll.cR(array, 0, 2147483647) : coll.o().cR(array, 0, 2147483647));
    if ((actual !== s)) {
      throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), ((("Copied " + actual) + " of ") + s));
    }
    return $ct_scm_ArrayDeque__AO__I__I__(new $c_scm_ArrayDeque(), array, 0, s);
  } else {
    return $ct_scm_ArrayDeque__I__(new $c_scm_ArrayDeque(), 16).kl(coll);
  }
});
$p.b5 = (function() {
  return new $c_scm_ArrayDeque$$anon$1();
});
$p.vT = (function(len) {
  if ((!(len >= 0))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed: Non-negative array size required");
  }
  var size = ((((-2147483648) >>> Math.clz32(len)) | 0) << 1);
  if ((!(size >= 0))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("requirement failed: " + "ArrayDeque too big - cannot allocate ArrayDeque of length ") + len));
  }
  return new $ac_O(((size > 16) ? size : 16));
});
$p.aO = (function() {
  return $ct_scm_ArrayDeque__I__(new $c_scm_ArrayDeque(), 16);
});
$p.cc = (function(source) {
  return this.aOu(source);
});
var $d_scm_ArrayDeque$ = new $TypeData().i($c_scm_ArrayDeque$, "scala.collection.mutable.ArrayDeque$", ({
  JA: 1,
  ba: 1,
  at: 1,
  a0: 1,
  a: 1
}));
var $n_scm_ArrayDeque$;
function $m_scm_ArrayDeque$() {
  if ((!$n_scm_ArrayDeque$)) {
    $n_scm_ArrayDeque$ = new $c_scm_ArrayDeque$();
  }
  return $n_scm_ArrayDeque$;
}
/** @constructor */
function $c_scm_ArrayDeque$$anon$1() {
  this.gj = null;
  $ct_scm_GrowableBuilder__scm_Growable__(this, $ct_scm_ArrayDeque__I__(new $c_scm_ArrayDeque(), 16));
}
$p = $c_scm_ArrayDeque$$anon$1.prototype = new $h_scm_GrowableBuilder();
$p.constructor = $c_scm_ArrayDeque$$anon$1;
/** @constructor */
function $h_scm_ArrayDeque$$anon$1() {
}
$h_scm_ArrayDeque$$anon$1.prototype = $p;
$p.f9 = (function(size) {
  var this$1 = this.gj;
  var idx = this$1.bF;
  if (((size > (((this$1.d5 - idx) | 0) & ((this$1.aL.a.length - 1) | 0))) && (size >= this$1.aL.a.length))) {
    this$1.XW(size);
  }
});
var $d_scm_ArrayDeque$$anon$1 = new $TypeData().i($c_scm_ArrayDeque$$anon$1, "scala.collection.mutable.ArrayDeque$$anon$1", ({
  JB: 1,
  c2: 1,
  Y: 1,
  T: 1,
  S: 1
}));
/** @constructor */
function $c_scm_Buffer$() {
  this.xw = null;
  $ct_sc_SeqFactory$Delegate__sc_SeqFactory__(this, $m_sjs_js_WrappedArray$());
}
$p = $c_scm_Buffer$.prototype = new $h_sc_SeqFactory$Delegate();
$p.constructor = $c_scm_Buffer$;
/** @constructor */
function $h_scm_Buffer$() {
}
$h_scm_Buffer$.prototype = $p;
var $d_scm_Buffer$ = new $TypeData().i($c_scm_Buffer$, "scala.collection.mutable.Buffer$", ({
  JD: 1,
  bZ: 1,
  at: 1,
  a0: 1,
  a: 1
}));
var $n_scm_Buffer$;
function $m_scm_Buffer$() {
  if ((!$n_scm_Buffer$)) {
    $n_scm_Buffer$ = new $c_scm_Buffer$();
  }
  return $n_scm_Buffer$;
}
/** @constructor */
function $c_scm_HashMap$$anon$6(initialCapacity$1, loadFactor$1) {
  this.gj = null;
  $ct_scm_GrowableBuilder__scm_Growable__(this, $ct_scm_HashMap__I__D__(new $c_scm_HashMap(), initialCapacity$1, loadFactor$1));
}
$p = $c_scm_HashMap$$anon$6.prototype = new $h_scm_GrowableBuilder();
$p.constructor = $c_scm_HashMap$$anon$6;
/** @constructor */
function $h_scm_HashMap$$anon$6() {
}
$h_scm_HashMap$$anon$6.prototype = $p;
$p.f9 = (function(size) {
  this.gj.f9(size);
});
var $d_scm_HashMap$$anon$6 = new $TypeData().i($c_scm_HashMap$$anon$6, "scala.collection.mutable.HashMap$$anon$6", ({
  JT: 1,
  c2: 1,
  Y: 1,
  T: 1,
  S: 1
}));
function $ct_scm_HashMap$HashMapIterator__scm_HashMap__($thiz, outer) {
  $thiz.HI = outer;
  $thiz.xJ = 0;
  $thiz.vG = null;
  $thiz.HJ = outer.S.a.length;
  return $thiz;
}
/** @constructor */
function $c_scm_HashMap$HashMapIterator() {
  this.xJ = 0;
  this.vG = null;
  this.HJ = 0;
  this.HI = null;
}
$p = $c_scm_HashMap$HashMapIterator.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_scm_HashMap$HashMapIterator;
/** @constructor */
function $h_scm_HashMap$HashMapIterator() {
}
$h_scm_HashMap$HashMapIterator.prototype = $p;
$p.p = (function() {
  if ((this.vG !== null)) {
    return true;
  } else {
    while ((this.xJ < this.HJ)) {
      var n = this.HI.S.a[this.xJ];
      this.xJ = ((1 + this.xJ) | 0);
      if ((n !== null)) {
        this.vG = n;
        return true;
      }
    }
    return false;
  }
});
$p.q = (function() {
  if ((!this.p())) {
    return $m_sc_Iterator$().b8.q();
  } else {
    var r = this.WJ(this.vG);
    this.vG = this.vG.fr;
    return r;
  }
});
/** @constructor */
function $c_scm_HashSet$$anon$4(initialCapacity$1, loadFactor$1) {
  this.gj = null;
  $ct_scm_GrowableBuilder__scm_Growable__(this, $ct_scm_HashSet__I__D__(new $c_scm_HashSet(), initialCapacity$1, loadFactor$1));
}
$p = $c_scm_HashSet$$anon$4.prototype = new $h_scm_GrowableBuilder();
$p.constructor = $c_scm_HashSet$$anon$4;
/** @constructor */
function $h_scm_HashSet$$anon$4() {
}
$h_scm_HashSet$$anon$4.prototype = $p;
$p.f9 = (function(size) {
  this.gj.f9(size);
});
var $d_scm_HashSet$$anon$4 = new $TypeData().i($c_scm_HashSet$$anon$4, "scala.collection.mutable.HashSet$$anon$4", ({
  JZ: 1,
  c2: 1,
  Y: 1,
  T: 1,
  S: 1
}));
function $ct_scm_HashSet$HashSetIterator__scm_HashSet__($thiz, outer) {
  $thiz.Vc = outer;
  $thiz.D7 = 0;
  $thiz.A5 = null;
  $thiz.Vd = outer.i6.a.length;
  return $thiz;
}
/** @constructor */
function $c_scm_HashSet$HashSetIterator() {
  this.D7 = 0;
  this.A5 = null;
  this.Vd = 0;
  this.Vc = null;
}
$p = $c_scm_HashSet$HashSetIterator.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_scm_HashSet$HashSetIterator;
/** @constructor */
function $h_scm_HashSet$HashSetIterator() {
}
$h_scm_HashSet$HashSetIterator.prototype = $p;
$p.p = (function() {
  if ((this.A5 !== null)) {
    return true;
  } else {
    while ((this.D7 < this.Vd)) {
      var n = this.Vc.i6.a[this.D7];
      this.D7 = ((1 + this.D7) | 0);
      if ((n !== null)) {
        this.A5 = n;
        return true;
      }
    }
    return false;
  }
});
$p.q = (function() {
  if ((!this.p())) {
    return $m_sc_Iterator$().b8.q();
  } else {
    var r = this.afC(this.A5);
    this.A5 = this.A5.hA;
    return r;
  }
});
function $ct_scm_ImmutableBuilder__sc_IterableOnce__($thiz, empty) {
  $thiz.Ve = empty;
  return $thiz;
}
/** @constructor */
function $c_scm_ImmutableBuilder() {
  this.Ve = null;
}
$p = $c_scm_ImmutableBuilder.prototype = new $h_O();
$p.constructor = $c_scm_ImmutableBuilder;
/** @constructor */
function $h_scm_ImmutableBuilder() {
}
$h_scm_ImmutableBuilder.prototype = $p;
$p.f9 = (function(size) {
});
$p.dG = (function(elems) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, elems);
});
$p.aR = (function() {
  return this.Ve;
});
/** @constructor */
function $c_scm_IndexedSeq$() {
  this.xw = null;
  $ct_sc_SeqFactory$Delegate__sc_SeqFactory__(this, $m_scm_ArrayBuffer$());
}
$p = $c_scm_IndexedSeq$.prototype = new $h_sc_SeqFactory$Delegate();
$p.constructor = $c_scm_IndexedSeq$;
/** @constructor */
function $h_scm_IndexedSeq$() {
}
$h_scm_IndexedSeq$.prototype = $p;
var $d_scm_IndexedSeq$ = new $TypeData().i($c_scm_IndexedSeq$, "scala.collection.mutable.IndexedSeq$", ({
  K2: 1,
  bZ: 1,
  at: 1,
  a0: 1,
  a: 1
}));
var $n_scm_IndexedSeq$;
function $m_scm_IndexedSeq$() {
  if ((!$n_scm_IndexedSeq$)) {
    $n_scm_IndexedSeq$ = new $c_scm_IndexedSeq$();
  }
  return $n_scm_IndexedSeq$;
}
function $ct_scm_LinkedHashMap$LinkedHashMapIterator__scm_LinkedHashMap__($thiz, outer) {
  $thiz.xK = outer.tL;
  return $thiz;
}
/** @constructor */
function $c_scm_LinkedHashMap$LinkedHashMapIterator() {
  this.xK = null;
}
$p = $c_scm_LinkedHashMap$LinkedHashMapIterator.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_scm_LinkedHashMap$LinkedHashMapIterator;
/** @constructor */
function $h_scm_LinkedHashMap$LinkedHashMapIterator() {
}
$h_scm_LinkedHashMap$LinkedHashMapIterator.prototype = $p;
$p.p = (function() {
  return (this.xK !== null);
});
$p.q = (function() {
  if (this.p()) {
    var r = this.WK(this.xK);
    this.xK = this.xK.vH;
    return r;
  } else {
    return $m_sc_Iterator$().b8.q();
  }
});
function $ct_scm_LinkedHashSet$LinkedHashSetIterator__scm_LinkedHashSet__($thiz, outer) {
  $thiz.Db = outer.A6;
  return $thiz;
}
/** @constructor */
function $c_scm_LinkedHashSet$LinkedHashSetIterator() {
  this.Db = null;
}
$p = $c_scm_LinkedHashSet$LinkedHashSetIterator.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_scm_LinkedHashSet$LinkedHashSetIterator;
/** @constructor */
function $h_scm_LinkedHashSet$LinkedHashSetIterator() {
}
$h_scm_LinkedHashSet$LinkedHashSetIterator.prototype = $p;
$p.p = (function() {
  return (this.Db !== null);
});
$p.q = (function() {
  if (this.p()) {
    var r = this.afD(this.Db);
    this.Db = this.Db.vI;
    return r;
  } else {
    return $m_sc_Iterator$().b8.q();
  }
});
/** @constructor */
function $c_scm_ListBuffer$() {
}
$p = $c_scm_ListBuffer$.prototype = new $h_O();
$p.constructor = $c_scm_ListBuffer$;
/** @constructor */
function $h_scm_ListBuffer$() {
}
$h_scm_ListBuffer$.prototype = $p;
$p.dr = (function(elems) {
  return new $c_scm_ListBuffer().kU(elems);
});
$p.b5 = (function() {
  return $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), new $c_scm_ListBuffer());
});
$p.aO = (function() {
  return new $c_scm_ListBuffer();
});
$p.cc = (function(source) {
  return new $c_scm_ListBuffer().kU(source);
});
var $d_scm_ListBuffer$ = new $TypeData().i($c_scm_ListBuffer$, "scala.collection.mutable.ListBuffer$", ({
  Kh: 1,
  ba: 1,
  at: 1,
  a0: 1,
  a: 1
}));
var $n_scm_ListBuffer$;
function $m_scm_ListBuffer$() {
  if ((!$n_scm_ListBuffer$)) {
    $n_scm_ListBuffer$ = new $c_scm_ListBuffer$();
  }
  return $n_scm_ListBuffer$;
}
/** @constructor */
function $c_scm_MutationTracker$CheckedIterator(underlying, mutationCount) {
  this.ad7 = null;
  this.aIM = null;
  this.aIL = 0;
  this.ad7 = underlying;
  this.aIM = mutationCount;
  this.aIL = (mutationCount.a3() | 0);
}
$p = $c_scm_MutationTracker$CheckedIterator.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_scm_MutationTracker$CheckedIterator;
/** @constructor */
function $h_scm_MutationTracker$CheckedIterator() {
}
$h_scm_MutationTracker$CheckedIterator.prototype = $p;
$p.p = (function() {
  $m_scm_MutationTracker$().aeX(this.aIL, (this.aIM.a3() | 0), "mutation occurred during iteration");
  return this.ad7.p();
});
$p.q = (function() {
  return this.ad7.q();
});
var $d_scm_MutationTracker$CheckedIterator = new $TypeData().i($c_scm_MutationTracker$CheckedIterator, "scala.collection.mutable.MutationTracker$CheckedIterator", ({
  Kl: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_scm_Queue$() {
}
$p = $c_scm_Queue$.prototype = new $h_O();
$p.constructor = $c_scm_Queue$;
/** @constructor */
function $h_scm_Queue$() {
}
$h_scm_Queue$.prototype = $p;
$p.dr = (function(elems) {
  return $ct_scm_Queue__I__(new $c_scm_Queue(), 16).kl(elems);
});
$p.b5 = (function() {
  return $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), $ct_scm_Queue__I__(new $c_scm_Queue(), 16));
});
$p.aO = (function() {
  return $ct_scm_Queue__I__(new $c_scm_Queue(), 16);
});
$p.cc = (function(source) {
  return $ct_scm_Queue__I__(new $c_scm_Queue(), 16).kl(source);
});
var $d_scm_Queue$ = new $TypeData().i($c_scm_Queue$, "scala.collection.mutable.Queue$", ({
  Kn: 1,
  ba: 1,
  at: 1,
  a0: 1,
  a: 1
}));
var $n_scm_Queue$;
function $m_scm_Queue$() {
  if ((!$n_scm_Queue$)) {
    $n_scm_Queue$ = new $c_scm_Queue$();
  }
  return $n_scm_Queue$;
}
/** @constructor */
function $c_scm_Stack$() {
}
$p = $c_scm_Stack$.prototype = new $h_O();
$p.constructor = $c_scm_Stack$;
/** @constructor */
function $h_scm_Stack$() {
}
$h_scm_Stack$.prototype = $p;
$p.dr = (function(elems) {
  return $ct_scm_Stack__I__(new $c_scm_Stack(), 16).kl(elems);
});
$p.b5 = (function() {
  return $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), $ct_scm_Stack__I__(new $c_scm_Stack(), 16));
});
$p.aO = (function() {
  return $ct_scm_Stack__I__(new $c_scm_Stack(), 16);
});
$p.cc = (function(source) {
  return $ct_scm_Stack__I__(new $c_scm_Stack(), 16).kl(source);
});
var $d_scm_Stack$ = new $TypeData().i($c_scm_Stack$, "scala.collection.mutable.Stack$", ({
  Kr: 1,
  ba: 1,
  at: 1,
  a0: 1,
  a: 1
}));
var $n_scm_Stack$;
function $m_scm_Stack$() {
  if ((!$n_scm_Stack$)) {
    $n_scm_Stack$ = new $c_scm_Stack$();
  }
  return $n_scm_Stack$;
}
/** @constructor */
function $c_s_concurrent_ExecutionContext$parasitic$() {
  this.aIP = null;
  $n_s_concurrent_ExecutionContext$parasitic$ = this;
  this.aIP = new $c_jl_ThreadLocal();
}
$p = $c_s_concurrent_ExecutionContext$parasitic$.prototype = new $h_O();
$p.constructor = $c_s_concurrent_ExecutionContext$parasitic$;
/** @constructor */
function $h_s_concurrent_ExecutionContext$parasitic$() {
}
$h_s_concurrent_ExecutionContext$parasitic$.prototype = $p;
$p.afA = (function(runnable) {
  $f_s_concurrent_BatchingExecutor__submitSyncBatched__jl_Runnable__V(this, runnable);
});
$p.ahF = (function(t) {
  $m_s_concurrent_ExecutionContext$().Od.i(t);
});
var $d_s_concurrent_ExecutionContext$parasitic$ = new $TypeData().i($c_s_concurrent_ExecutionContext$parasitic$, "scala.concurrent.ExecutionContext$parasitic$", ({
  Kx: 1,
  dU: 1,
  dT: 1,
  dh: 1,
  dS: 1
}));
var $n_s_concurrent_ExecutionContext$parasitic$;
function $m_s_concurrent_ExecutionContext$parasitic$() {
  if ((!$n_s_concurrent_ExecutionContext$parasitic$)) {
    $n_s_concurrent_ExecutionContext$parasitic$ = new $c_s_concurrent_ExecutionContext$parasitic$();
  }
  return $n_s_concurrent_ExecutionContext$parasitic$;
}
function $p_s_concurrent_duration_Duration$Infinite__fail__T__E($thiz, what) {
  throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (what + " not allowed on infinite Durations"));
}
/** @constructor */
function $c_s_concurrent_duration_Duration$Infinite() {
}
$p = $c_s_concurrent_duration_Duration$Infinite.prototype = new $h_s_concurrent_duration_Duration();
$p.constructor = $c_s_concurrent_duration_Duration$Infinite;
/** @constructor */
function $h_s_concurrent_duration_Duration$Infinite() {
}
$h_s_concurrent_duration_Duration$Infinite.prototype = $p;
$p.aSV = (function() {
  $p_s_concurrent_duration_Duration$Infinite__fail__T__E(this, "toNanos");
});
function $p_s_concurrent_duration_FiniteDuration__bounded__J__Z($thiz, max_$_lo, max_$_hi) {
  var lo = ((-max_$_lo) | 0);
  var hi = ((((-max_$_hi) | 0) - ((lo !== 0) | 0)) | 0);
  var x_$_lo = $thiz.vR;
  var x_$_hi = $thiz.vS;
  if (((hi === x_$_hi) ? ((lo >>> 0) <= (x_$_lo >>> 0)) : (hi < x_$_hi))) {
    var x$1_$_lo = $thiz.vR;
    var x$1_$_hi = $thiz.vS;
    return ((x$1_$_hi === max_$_hi) ? ((x$1_$_lo >>> 0) <= (max_$_lo >>> 0)) : (x$1_$_hi < max_$_hi));
  } else {
    return false;
  }
}
function $p_s_concurrent_duration_FiniteDuration__unitString__T($thiz) {
  var $x_1 = $m_s_concurrent_duration_Duration$().aIW.i($thiz.Dd);
  var x_$_lo = $thiz.vR;
  var x_$_hi = $thiz.vS;
  return ($x_1 + ((((1 ^ x_$_lo) | x_$_hi) === 0) ? "" : "s"));
}
/** @constructor */
function $c_s_concurrent_duration_FiniteDuration(length_$_lo, length_$_hi, unit) {
  this.vR = 0;
  this.vS = 0;
  this.Dd = null;
  this.vR = length_$_lo;
  this.vS = length_$_hi;
  this.Dd = unit;
  var x = $m_ju_concurrent_TimeUnit$().Zx;
  if (((x === null) ? (unit === null) : (x === unit))) {
    var $x_1 = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, (-1), 2147483647);
  } else {
    var x$3 = $m_ju_concurrent_TimeUnit$().a7v;
    if (((x$3 === null) ? (unit === null) : (x$3 === unit))) {
      var $x_1 = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, (-1511828489), 2147483);
    } else {
      var x$5 = $m_ju_concurrent_TimeUnit$().a7w;
      if (((x$5 === null) ? (unit === null) : (x$5 === unit))) {
        var $x_1 = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, 2077252342, 2147);
      } else {
        var x$7 = $m_ju_concurrent_TimeUnit$().a7y;
        if (((x$7 === null) ? (unit === null) : (x$7 === unit))) {
          var $x_1 = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, 633437444, 2);
        } else {
          var x$9 = $m_ju_concurrent_TimeUnit$().a7x;
          if (((x$9 === null) ? (unit === null) : (x$9 === unit))) {
            var $x_1 = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, 153722867, 0);
          } else {
            var x$11 = $m_ju_concurrent_TimeUnit$().a7u;
            if (((x$11 === null) ? (unit === null) : (x$11 === unit))) {
              var $x_1 = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, 2562047, 0);
            } else {
              var x$13 = $m_ju_concurrent_TimeUnit$().R2;
              if (((x$13 === null) ? (unit === null) : (x$13 === unit))) {
                var $x_1 = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, 106751, 0);
              } else {
                var $x_2 = $m_ju_concurrent_TimeUnit$().R2.IK(length_$_lo, length_$_hi, unit);
                var v_$_lo = $x_2.l;
                var v_$_hi = $x_2.h;
                var $x_1 = (((v_$_hi === (-1)) ? ((v_$_lo >>> 0) >= 4294860545) : (v_$_hi > (-1))) && ((v_$_hi === 0) ? ((v_$_lo >>> 0) <= 106751) : (v_$_hi < 0)));
              }
            }
          }
        }
      }
    }
  }
  if ((!$x_1)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed: Duration is limited to +-(2^63-1)ns (ca. 292 years)");
  }
}
$p = $c_s_concurrent_duration_FiniteDuration.prototype = new $h_s_concurrent_duration_Duration();
$p.constructor = $c_s_concurrent_duration_FiniteDuration;
/** @constructor */
function $h_s_concurrent_duration_FiniteDuration() {
}
$h_s_concurrent_duration_FiniteDuration.prototype = $p;
$p.aSV = (function() {
  return this.Dd.rf(this.vR, this.vS);
});
$p.m = (function() {
  return (($s_RTLong__toString__I__I__T(this.vR, this.vS) + " ") + $p_s_concurrent_duration_FiniteDuration__unitString__T(this));
});
$p.Wu = (function(other) {
  if ((other instanceof $c_s_concurrent_duration_FiniteDuration)) {
    var $x_1 = this.Dd.rf(this.vR, this.vS);
    var this$2 = new $c_sr_RichLong($x_1.l, $x_1.h);
    var $x_4 = other.Dd;
    var $x_3 = other;
    var $x_2 = $x_4.rf($x_3.vR, $x_3.vS);
    var y_$_lo = $x_2.l;
    var y_$_hi = $x_2.h;
    var x$1_$_lo = this$2.mG;
    var x$1_$_hi = this$2.mH;
    return ((x$1_$_hi === y_$_hi) ? ((x$1_$_lo === y_$_lo) ? 0 : (((x$1_$_lo >>> 0) < (y_$_lo >>> 0)) ? (-1) : 1)) : ((x$1_$_hi < y_$_hi) ? (-1) : 1));
  } else {
    return ((-other.Wu(this)) | 0);
  }
});
$p.e = (function(other) {
  if ((other instanceof $c_s_concurrent_duration_FiniteDuration)) {
    var $x_1 = this.Dd.rf(this.vR, this.vS);
    var x_$_lo = $x_1.l;
    var x_$_hi = $x_1.h;
    var $x_4 = other.Dd;
    var $x_3 = other;
    var $x_2 = $x_4.rf($x_3.vR, $x_3.vS);
    var x$1_$_lo = $x_2.l;
    var x$1_$_hi = $x_2.h;
    return (((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0);
  } else {
    return (this === other);
  }
});
$p.x = (function() {
  var $x_1 = this.Dd.rf(this.vR, this.vS);
  return $s_RTLong__toInt__I__I__I($x_1.l, $x_1.h);
});
function $isArrayOf_s_concurrent_duration_FiniteDuration(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.m0)));
}
var $d_s_concurrent_duration_FiniteDuration = new $TypeData().i($c_s_concurrent_duration_FiniteDuration, "scala.concurrent.duration.FiniteDuration", ({
  m0: 1,
  cS: 1,
  a: 1,
  b3: 1,
  Q: 1
}));
function $f_s_math_Ordering__lteq__O__O__Z($thiz, x, y) {
  return ($thiz.dA(x, y) <= 0);
}
function $f_s_math_Ordering__gteq__O__O__Z($thiz, x, y) {
  return ($thiz.dA(x, y) >= 0);
}
function $f_s_math_Ordering__lt__O__O__Z($thiz, x, y) {
  return ($thiz.dA(x, y) < 0);
}
function $f_s_math_Ordering__gt__O__O__Z($thiz, x, y) {
  return ($thiz.dA(x, y) > 0);
}
function $f_s_math_Ordering__max__O__O__O($thiz, x, y) {
  return ($thiz.mM(x, y) ? x : y);
}
function $f_s_math_Ordering__min__O__O__O($thiz, x, y) {
  return ($thiz.mQ(x, y) ? x : y);
}
function $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z($thiz, other) {
  if ((other instanceof $c_s_math_Ordering$Reverse)) {
    var x = other.qK;
    return ((x !== null) && x.e($thiz));
  } else {
    return false;
  }
}
function $f_s_reflect_ClassTag__equals__O__Z($thiz, x) {
  if ($is_s_reflect_ClassTag(x)) {
    var x$2 = $thiz.h8();
    var x$3 = x.h8();
    return ((x$2 === null) ? (x$3 === null) : (x$2 === x$3));
  } else {
    return false;
  }
}
function $ps_s_reflect_ClassTag__prettyprint$1__jl_Class__T(clazz) {
  return (clazz.ba.Z ? (("Array[" + $ps_s_reflect_ClassTag__prettyprint$1__jl_Class__T(clazz.ba.Q())) + "]") : clazz.ba.N);
}
function $is_s_reflect_ClassTag(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.az)));
}
function $isArrayOf_s_reflect_ClassTag(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.az)));
}
/** @constructor */
function $c_sr_ScalaRunTime$$anon$1(x$2) {
  this.Vt = 0;
  this.aJ8 = 0;
  this.aJ9 = null;
  this.aJ9 = x$2;
  this.Vt = 0;
  this.aJ8 = x$2.z();
}
$p = $c_sr_ScalaRunTime$$anon$1.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sr_ScalaRunTime$$anon$1;
/** @constructor */
function $h_sr_ScalaRunTime$$anon$1() {
}
$h_sr_ScalaRunTime$$anon$1.prototype = $p;
$p.p = (function() {
  return (this.Vt < this.aJ8);
});
$p.q = (function() {
  var result = this.aJ9.A(this.Vt);
  this.Vt = ((1 + this.Vt) | 0);
  return result;
});
var $d_sr_ScalaRunTime$$anon$1 = new $TypeData().i($c_sr_ScalaRunTime$$anon$1, "scala.runtime.ScalaRunTime$$anon$1", ({
  M2: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_sjs_js_ArrayOps$ArrayIterator(xs) {
  this.Vu = null;
  this.Df = 0;
  this.Vu = xs;
  this.Df = 0;
}
$p = $c_sjs_js_ArrayOps$ArrayIterator.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sjs_js_ArrayOps$ArrayIterator;
/** @constructor */
function $h_sjs_js_ArrayOps$ArrayIterator() {
}
$h_sjs_js_ArrayOps$ArrayIterator.prototype = $p;
$p.p = (function() {
  return (this.Df < (this.Vu.length | 0));
});
$p.q = (function() {
  if ((this.Df >= (this.Vu.length | 0))) {
    throw $ct_ju_NoSuchElementException__(new $c_ju_NoSuchElementException());
  }
  var r = this.Vu[this.Df];
  this.Df = ((1 + this.Df) | 0);
  return r;
});
$p.iV = (function(n) {
  if ((n > 0)) {
    this.Df = (Math.min((this.Vu.length | 0), ((this.Df + n) | 0)) | 0);
  }
  return this;
});
var $d_sjs_js_ArrayOps$ArrayIterator = new $TypeData().i($c_sjs_js_ArrayOps$ArrayIterator, "scala.scalajs.js.ArrayOps$ArrayIterator", ({
  Md: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_sjs_js_WrappedArray$() {
}
$p = $c_sjs_js_WrappedArray$.prototype = new $h_O();
$p.constructor = $c_sjs_js_WrappedArray$;
/** @constructor */
function $h_sjs_js_WrappedArray$() {
}
$h_sjs_js_WrappedArray$.prototype = $p;
$p.dr = (function(elems) {
  return this.aOx(elems);
});
$p.b5 = (function() {
  return $ct_sjs_js_WrappedArray__(new $c_sjs_js_WrappedArray());
});
$p.aOx = (function(source) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable($ct_sjs_js_WrappedArray__(new $c_sjs_js_WrappedArray()), source).aR();
});
$p.cc = (function(source) {
  return this.aOx(source);
});
$p.aO = (function() {
  return $ct_sjs_js_WrappedArray__(new $c_sjs_js_WrappedArray());
});
var $d_sjs_js_WrappedArray$ = new $TypeData().i($c_sjs_js_WrappedArray$, "scala.scalajs.js.WrappedArray$", ({
  Ml: 1,
  ba: 1,
  at: 1,
  a0: 1,
  a: 1
}));
var $n_sjs_js_WrappedArray$;
function $m_sjs_js_WrappedArray$() {
  if ((!$n_sjs_js_WrappedArray$)) {
    $n_sjs_js_WrappedArray$ = new $c_sjs_js_WrappedArray$();
  }
  return $n_sjs_js_WrappedArray$;
}
/** @constructor */
function $c_sjsr_WrappedVarArgs$() {
}
$p = $c_sjsr_WrappedVarArgs$.prototype = new $h_O();
$p.constructor = $c_sjsr_WrappedVarArgs$;
/** @constructor */
function $h_sjsr_WrappedVarArgs$() {
}
$h_sjsr_WrappedVarArgs$.prototype = $p;
$p.dr = (function(elems) {
  return this.ag2(elems);
});
$p.ag2 = (function(source) {
  return this.b5().dG(source).aR();
});
$p.b5 = (function() {
  return new $c_scm_Builder$$anon$1($ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), []), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$2) => $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), x$1$2$2.mE))));
});
$p.cc = (function(source) {
  return this.ag2(source);
});
$p.aO = (function() {
  return $ct_sjsr_WrappedVarArgs__(new $c_sjsr_WrappedVarArgs());
});
var $d_sjsr_WrappedVarArgs$ = new $TypeData().i($c_sjsr_WrappedVarArgs$, "scala.scalajs.runtime.WrappedVarArgs$", ({
  MJ: 1,
  ba: 1,
  at: 1,
  a0: 1,
  a: 1
}));
var $n_sjsr_WrappedVarArgs$;
function $m_sjsr_WrappedVarArgs$() {
  if ((!$n_sjsr_WrappedVarArgs$)) {
    $n_sjsr_WrappedVarArgs$ = new $c_sjsr_WrappedVarArgs$();
  }
  return $n_sjsr_WrappedVarArgs$;
}
/** @constructor */
function $c_s_util_Failure(exception) {
  this.le = null;
  this.le = exception;
}
$p = $c_s_util_Failure.prototype = new $h_s_util_Try();
$p.constructor = $c_s_util_Failure;
/** @constructor */
function $h_s_util_Failure() {
}
$h_s_util_Failure.prototype = $p;
$p.a3R = (function() {
  return true;
});
$p.Xe = (function() {
  return false;
});
$p.d = (function() {
  var $x_1 = this.le;
  throw (($x_1 instanceof $c_sjs_js_JavaScriptException) ? $x_1.bf : $x_1);
});
$p.X2 = (function(default$1) {
  return default$1.a3();
});
$p.WR = (function(f) {
  return this;
});
$p.F = (function(f) {
});
$p.ua = (function(f) {
  return this;
});
$p.ahx = (function(pf) {
  var marker = $m_sr_Statics$PFMarker$();
  try {
    var v = pf.aC(this.le, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2$2) => marker)));
    return ((marker !== v) ? new $c_s_util_Success(v) : this);
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if ($m_s_util_control_NonFatal$().ew(e$2)) {
      return new $c_s_util_Failure(e$2);
    }
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
  }
});
$p.rg = (function() {
  return $m_s_None$();
});
$p.kO = (function(fa, fb) {
  return fa.i(this.le);
});
$p.B = (function() {
  return "Failure";
});
$p.z = (function() {
  return 1;
});
$p.A = (function(x$1) {
  return ((x$1 === 0) ? this.le : $m_sr_Statics$().ey(x$1));
});
$p.H = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$p.D = (function(x$1) {
  return ((x$1 === 0) ? "exception" : $m_sr_Statics$().ey(x$1));
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-1408943127), true);
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.e = (function(x$1) {
  if ((this === x$1)) {
    return true;
  } else if ((x$1 instanceof $c_s_util_Failure)) {
    var x = this.le;
    var x$2 = x$1.le;
    return ((x === null) ? (x$2 === null) : x.e(x$2));
  } else {
    return false;
  }
});
function $isArrayOf_s_util_Failure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.mr)));
}
var $d_s_util_Failure = new $TypeData().i($c_s_util_Failure, "scala.util.Failure", ({
  mr: 1,
  cW: 1,
  c: 1,
  b: 1,
  a: 1
}));
/** @constructor */
function $c_s_util_Left(value) {
  this.lP = null;
  this.lP = value;
}
$p = $c_s_util_Left.prototype = new $h_s_util_Either();
$p.constructor = $c_s_util_Left;
/** @constructor */
function $h_s_util_Left() {
}
$h_s_util_Left.prototype = $p;
$p.aPq = (function() {
  return true;
});
$p.B = (function() {
  return "Left";
});
$p.z = (function() {
  return 1;
});
$p.A = (function(x$1) {
  return ((x$1 === 0) ? this.lP : $m_sr_Statics$().ey(x$1));
});
$p.H = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$p.D = (function(x$1) {
  return ((x$1 === 0) ? "value" : $m_sr_Statics$().ey(x$1));
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 877209692, true);
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.e = (function(x$1) {
  return ((this === x$1) || ((x$1 instanceof $c_s_util_Left) && $m_sr_BoxesRunTime$().Q(this.lP, x$1.lP)));
});
function $isArrayOf_s_util_Left(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ms)));
}
var $d_s_util_Left = new $TypeData().i($c_s_util_Left, "scala.util.Left", ({
  ms: 1,
  mp: 1,
  c: 1,
  b: 1,
  a: 1
}));
/** @constructor */
function $c_s_util_Right(value) {
  this.hm = null;
  this.hm = value;
}
$p = $c_s_util_Right.prototype = new $h_s_util_Either();
$p.constructor = $c_s_util_Right;
/** @constructor */
function $h_s_util_Right() {
}
$h_s_util_Right.prototype = $p;
$p.aPq = (function() {
  return false;
});
$p.B = (function() {
  return "Right";
});
$p.z = (function() {
  return 1;
});
$p.A = (function(x$1) {
  return ((x$1 === 0) ? this.hm : $m_sr_Statics$().ey(x$1));
});
$p.H = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$p.D = (function(x$1) {
  return ((x$1 === 0) ? "value" : $m_sr_Statics$().ey(x$1));
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 252890491, true);
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.e = (function(x$1) {
  return ((this === x$1) || ((x$1 instanceof $c_s_util_Right) && $m_sr_BoxesRunTime$().Q(this.hm, x$1.hm)));
});
function $isArrayOf_s_util_Right(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.mt)));
}
var $d_s_util_Right = new $TypeData().i($c_s_util_Right, "scala.util.Right", ({
  mt: 1,
  mp: 1,
  c: 1,
  b: 1,
  a: 1
}));
/** @constructor */
function $c_s_util_Success(value) {
  this.fM = null;
  this.fM = value;
}
$p = $c_s_util_Success.prototype = new $h_s_util_Try();
$p.constructor = $c_s_util_Success;
/** @constructor */
function $h_s_util_Success() {
}
$h_s_util_Success.prototype = $p;
$p.a3R = (function() {
  return false;
});
$p.Xe = (function() {
  return true;
});
$p.d = (function() {
  return this.fM;
});
$p.X2 = (function(default$1) {
  return this.fM;
});
$p.WR = (function(f) {
  try {
    return f.i(this.fM);
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if ($m_s_util_control_NonFatal$().ew(e$2)) {
      return new $c_s_util_Failure(e$2);
    }
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
  }
});
$p.F = (function(f) {
  f.i(this.fM);
});
$p.ua = (function(f) {
  try {
    return new $c_s_util_Success(f.i(this.fM));
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if ($m_s_util_control_NonFatal$().ew(e$2)) {
      return new $c_s_util_Failure(e$2);
    }
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
  }
});
$p.ahx = (function(pf) {
  return this;
});
$p.rg = (function() {
  return new $c_s_Some(this.fM);
});
$p.kO = (function(fa, fb) {
  try {
    return fb.i(this.fM);
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if ($m_s_util_control_NonFatal$().ew(e$2)) {
      return fa.i(e$2);
    }
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
  }
});
$p.B = (function() {
  return "Success";
});
$p.z = (function() {
  return 1;
});
$p.A = (function(x$1) {
  return ((x$1 === 0) ? this.fM : $m_sr_Statics$().ey(x$1));
});
$p.H = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$p.D = (function(x$1) {
  return ((x$1 === 0) ? "value" : $m_sr_Statics$().ey(x$1));
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-1750213842), true);
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.e = (function(x$1) {
  return ((this === x$1) || ((x$1 instanceof $c_s_util_Success) && $m_sr_BoxesRunTime$().Q(this.fM, x$1.fM)));
});
function $isArrayOf_s_util_Success(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.mu)));
}
var $d_s_util_Success = new $TypeData().i($c_s_util_Success, "scala.util.Success", ({
  mu: 1,
  cW: 1,
  c: 1,
  b: 1,
  a: 1
}));
/** @constructor */
function $c_s_util_matching_Regex$$anon$1(outer, matchIterator$1) {
  this.Og = null;
  this.Og = matchIterator$1;
}
$p = $c_s_util_matching_Regex$$anon$1.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_s_util_matching_Regex$$anon$1;
/** @constructor */
function $h_s_util_matching_Regex$$anon$1() {
}
$h_s_util_matching_Regex$$anon$1.prototype = $p;
$p.p = (function() {
  return this.Og.p();
});
$p.b4R = (function() {
  this.Og.wa();
  return new $c_s_util_matching_Regex$Match(this.Og.adt, this.Og.Dh, this.Og.aJm).b1A();
});
$p.q = (function() {
  return this.b4R();
});
var $d_s_util_matching_Regex$$anon$1 = new $TypeData().i($c_s_util_matching_Regex$$anon$1, "scala.util.matching.Regex$$anon$1", ({
  MX: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
function $ct_s_util_parsing_combinator_Parsers$Success__s_util_parsing_combinator_Parsers__O__s_util_parsing_input_Reader__($thiz, outer, result, next) {
  $thiz.qL = result;
  $thiz.pg = next;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $thiz.lQ = outer;
  $ct_s_util_parsing_combinator_Parsers$ParseResult__s_util_parsing_combinator_Parsers__($thiz, outer);
  return $thiz;
}
/** @constructor */
function $c_s_util_parsing_combinator_Parsers$Success() {
  this.qL = null;
  this.pg = null;
  this.lQ = null;
}
$p = $c_s_util_parsing_combinator_Parsers$Success.prototype = new $h_s_util_parsing_combinator_Parsers$ParseResult();
$p.constructor = $c_s_util_parsing_combinator_Parsers$Success;
/** @constructor */
function $h_s_util_parsing_combinator_Parsers$Success() {
}
$h_s_util_parsing_combinator_Parsers$Success.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().eN(this, (-889275714), null);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if (((x$0 instanceof $c_s_util_parsing_combinator_Parsers$Success) && (x$0.lQ === this.lQ))) {
    if ($m_sr_BoxesRunTime$().Q(this.qL, x$0.qL)) {
      var x$1 = this.pg;
      var x$2 = x$0.pg;
      return ((x$1 === null) ? (x$2 === null) : (x$1 === x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "Success";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.qL;
  }
  if ((n === 1)) {
    return this.pg;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "result";
  }
  if ((n === 1)) {
    return "next";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.aQr = (function() {
  return this.pg;
});
$p.agY = (function(f) {
  var this$1 = this.lQ;
  return new $c_s_util_parsing_combinator_Parsers$$anon$2(f.i(this.qL), this.pg, this.Aa, this$1);
});
$p.aOe = (function(f) {
  var x5 = f.i(this.qL).i(this.pg);
  if (((x5 instanceof $c_s_util_parsing_combinator_Parsers$Success) && (x5.lQ === this.lQ))) {
    this.lQ.OQ();
    return new $c_s_util_parsing_combinator_Parsers$$anon$2(x5.qL, x5.pg, $f_s_util_parsing_combinator_Parsers__selectLastFailure__s_Option__s_Option__s_Option(this.lQ, this.Aa, x5.Aa), this.lQ);
  }
  if (((x5 instanceof $c_s_util_parsing_combinator_Parsers$Failure) && (x5.xM === this.lQ))) {
    return $f_s_util_parsing_combinator_Parsers__selectLastFailure__s_Option__s_Option__s_Option(this.lQ, new $c_s_Some(x5), this.Aa).d();
  }
  if ((false && (x5.b8d() === this.lQ))) {
    return x5;
  }
  throw new $c_s_MatchError(x5);
});
$p.aLZ = (function(a) {
  return this;
});
$p.m = (function() {
  var this$1 = this.pg;
  return ((("[" + new $c_s_util_parsing_input_OffsetPosition(this$1.pi, this$1.ph)) + "] parsed: ") + this.qL);
});
function $isArrayOf_s_util_parsing_combinator_Parsers$Success(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.mA)));
}
function $p_s_util_parsing_input_OffsetPosition__index__AI($thiz) {
  if ((!$thiz.aJv)) {
    matchResult3: {
      var $x_1;
      var x3 = $m_s_Option$().as($m_s_util_parsing_input_OffsetPosition$().aPd().agb($thiz.nt));
      if ((x3 instanceof $c_s_Some)) {
        var $x_1 = x3.J;
        break matchResult3;
      }
      if (($m_s_None$() === x3)) {
        var index$2 = $p_s_util_parsing_input_OffsetPosition__genIndex__AI($thiz);
        $m_s_util_parsing_input_OffsetPosition$().aPd().aRf($thiz.nt, index$2);
        var $x_1 = index$2;
        break matchResult3;
      }
      throw new $c_s_MatchError(x3);
    }
    $thiz.aJu = $x_1;
    $thiz.aJv = true;
  }
  return $thiz.aJu;
}
function $p_s_util_parsing_input_OffsetPosition__genIndex__AI($thiz) {
  var lineStarts = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  lineStarts.aw(0);
  var end = $dp_length__I($thiz.nt);
  var isEmpty = (end <= 0);
  var scala$collection$immutable$Range$$lastElement = ((end - 1) | 0);
  if ((!isEmpty)) {
    var i = 0;
    while (true) {
      var x0 = i;
      if ((($dp_charAt__I__C($thiz.nt, x0) === 10) || (($dp_charAt__I__C($thiz.nt, x0) === 13) && ((x0 === (($dp_length__I($thiz.nt) - 1) | 0)) || ($dp_charAt__I__C($thiz.nt, ((1 + x0) | 0)) !== 10))))) {
        lineStarts.aw(((1 + x0) | 0));
      }
      if ((i === scala$collection$immutable$Range$$lastElement)) {
        break;
      }
      i = ((1 + i) | 0);
    }
  }
  lineStarts.aw($dp_length__I($thiz.nt));
  if ((lineStarts.a1 >= 0)) {
    var destination = new $ac_I(lineStarts.a1);
    lineStarts.cR(destination, 0, 2147483647);
    return destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = lineStarts.bB().o();
    while (it.p()) {
      var elem$2 = it.q();
      var unboxedElem = ((elem$2 === null) ? 0 : elem$2);
      jsElems.push(unboxedElem);
    }
    return new $ac_I(new Int32Array(jsElems));
  }
}
/** @constructor */
function $c_s_util_parsing_input_OffsetPosition(source, offset) {
  this.nt = null;
  this.HN = 0;
  this.aJu = null;
  this.aJv = false;
  this.nt = source;
  this.HN = offset;
}
$p = $c_s_util_parsing_input_OffsetPosition.prototype = new $h_O();
$p.constructor = $c_s_util_parsing_input_OffsetPosition;
/** @constructor */
function $h_s_util_parsing_input_OffsetPosition() {
}
$h_s_util_parsing_input_OffsetPosition.prototype = $p;
$p.e = (function(other) {
  return $f_s_util_parsing_input_Position__equals__O__Z(this, other);
});
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, $f_T__hashCode__I("OffsetPosition"));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.nt));
  acc = $m_sr_Statics$().k(acc, this.HN);
  return $m_sr_Statics$().Z(acc, 2);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "OffsetPosition";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.nt;
  }
  if ((n === 1)) {
    return this.HN;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "source";
  }
  if ((n === 1)) {
    return "offset";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.yd = (function() {
  var lo = 0;
  var hi = (($p_s_util_parsing_input_OffsetPosition__index__AI(this).a.length - 1) | 0);
  while ((((1 + lo) | 0) < hi)) {
    var $x_1 = lo;
    var num = ((hi - lo) | 0);
    var mid = (($x_1 + (((num + ((num >>> 31) | 0)) | 0) >> 1)) | 0);
    if ((this.HN < $p_s_util_parsing_input_OffsetPosition__index__AI(this).a[mid])) {
      hi = mid;
    } else {
      lo = mid;
    }
  }
  return ((1 + lo) | 0);
});
$p.P6 = (function() {
  return ((1 + ((this.HN - $p_s_util_parsing_input_OffsetPosition__index__AI(this).a[((this.yd() - 1) | 0)]) | 0)) | 0);
});
$p.aPW = (function() {
  var lineStart = $p_s_util_parsing_input_OffsetPosition__index__AI(this).a[((this.yd() - 1) | 0)];
  var lineEnd = $p_s_util_parsing_input_OffsetPosition__index__AI(this).a[this.yd()];
  var endIndex = ((((lineStart < ((lineEnd - 1) | 0)) && ($dp_charAt__I__C(this.nt, ((lineEnd - 2) | 0)) === 13)) && ($dp_charAt__I__C(this.nt, ((lineEnd - 1) | 0)) === 10)) ? ((lineEnd - 2) | 0) : (((lineStart < lineEnd) && (($dp_charAt__I__C(this.nt, ((lineEnd - 1) | 0)) === 13) || ($dp_charAt__I__C(this.nt, ((lineEnd - 1) | 0)) === 10))) ? ((lineEnd - 1) | 0) : lineEnd));
  return $dp_toString__T($dp_subSequence__I__I__jl_CharSequence(this.nt, lineStart, endIndex));
});
$p.m = (function() {
  return ((this.yd() + ".") + this.P6());
});
$p.aLh = (function(that) {
  if ((that instanceof $c_s_util_parsing_input_OffsetPosition)) {
    var x10 = that.HN;
    return (this.HN < x10);
  } else {
    return ((this.yd() < that.yd()) || ((this.yd() === that.yd()) && (this.P6() < that.P6())));
  }
});
function $isArrayOf_s_util_parsing_input_OffsetPosition(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.mB)));
}
var $d_s_util_parsing_input_OffsetPosition = new $TypeData().i($c_s_util_parsing_input_OffsetPosition, "scala.util.parsing.input.OffsetPosition", ({
  mB: 1,
  e1: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lsourcecode_FileName(value) {
  this.VE = null;
  this.VE = value;
}
$p = $c_Lsourcecode_FileName.prototype = new $h_Lsourcecode_SourceValue();
$p.constructor = $c_Lsourcecode_FileName;
/** @constructor */
function $h_Lsourcecode_FileName() {
}
$h_Lsourcecode_FileName.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().eN(this, (-889275714), null);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lsourcecode_FileName) && (this.VE === x$0.VE)));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "FileName";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.VE;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lsourcecode_FileName(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.mC)));
}
var $d_Lsourcecode_FileName = new $TypeData().i($c_Lsourcecode_FileName, "sourcecode.FileName", ({
  mC: 1,
  e3: 1,
  b: 1,
  c: 1,
  a: 1
}));
function $ps_Lsourcecode_FileName$__FileName$$superArg$1__F1() {
  return new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$6) => new $c_Lsourcecode_FileName(_$6)));
}
/** @constructor */
function $c_Lsourcecode_FileName$() {
  this.VF = null;
  $ct_Lsourcecode_SourceCompanion__F1__(this, $ps_Lsourcecode_FileName$__FileName$$superArg$1__F1());
}
$p = $c_Lsourcecode_FileName$.prototype = new $h_Lsourcecode_SourceCompanion();
$p.constructor = $c_Lsourcecode_FileName$;
/** @constructor */
function $h_Lsourcecode_FileName$() {
}
$h_Lsourcecode_FileName$.prototype = $p;
var $d_Lsourcecode_FileName$ = new $TypeData().i($c_Lsourcecode_FileName$, "sourcecode.FileName$", ({
  Nj: 1,
  e2: 1,
  Nk: 1,
  d: 1,
  j: 1
}));
var $n_Lsourcecode_FileName$;
function $m_Lsourcecode_FileName$() {
  if ((!$n_Lsourcecode_FileName$)) {
    $n_Lsourcecode_FileName$ = new $c_Lsourcecode_FileName$();
  }
  return $n_Lsourcecode_FileName$;
}
/** @constructor */
function $c_Lsourcecode_Line(value) {
  this.Oh = 0;
  this.Oh = value;
}
$p = $c_Lsourcecode_Line.prototype = new $h_Lsourcecode_SourceValue();
$p.constructor = $c_Lsourcecode_Line;
/** @constructor */
function $h_Lsourcecode_Line() {
}
$h_Lsourcecode_Line.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, $f_T__hashCode__I("Line"));
  acc = $m_sr_Statics$().k(acc, this.Oh);
  return $m_sr_Statics$().Z(acc, 1);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lsourcecode_Line) && (this.Oh === x$0.Oh)));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Line";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Oh;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lsourcecode_Line(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.mD)));
}
var $d_Lsourcecode_Line = new $TypeData().i($c_Lsourcecode_Line, "sourcecode.Line", ({
  mD: 1,
  e3: 1,
  b: 1,
  c: 1,
  a: 1
}));
function $ps_Lsourcecode_Line$__Line$$superArg$1__F1() {
  return new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$7) => new $c_Lsourcecode_Line((_$7 | 0))));
}
/** @constructor */
function $c_Lsourcecode_Line$() {
  this.VF = null;
  $ct_Lsourcecode_SourceCompanion__F1__(this, $ps_Lsourcecode_Line$__Line$$superArg$1__F1());
}
$p = $c_Lsourcecode_Line$.prototype = new $h_Lsourcecode_SourceCompanion();
$p.constructor = $c_Lsourcecode_Line$;
/** @constructor */
function $h_Lsourcecode_Line$() {
}
$h_Lsourcecode_Line$.prototype = $p;
var $d_Lsourcecode_Line$ = new $TypeData().i($c_Lsourcecode_Line$, "sourcecode.Line$", ({
  Nl: 1,
  e2: 1,
  Nm: 1,
  d: 1,
  j: 1
}));
var $n_Lsourcecode_Line$;
function $m_Lsourcecode_Line$() {
  if ((!$n_Lsourcecode_Line$)) {
    $n_Lsourcecode_Line$ = new $c_Lsourcecode_Line$();
  }
  return $n_Lsourcecode_Line$;
}
/** @constructor */
function $c_Lsourcecode_Name(value) {
  this.aE = null;
  this.aE = value;
}
$p = $c_Lsourcecode_Name.prototype = new $h_Lsourcecode_SourceValue();
$p.constructor = $c_Lsourcecode_Name;
/** @constructor */
function $h_Lsourcecode_Name() {
}
$h_Lsourcecode_Name.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().eN(this, (-889275714), null);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lsourcecode_Name) && (this.aE === x$0.aE)));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Name";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.aE;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lsourcecode_Name(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.mE)));
}
var $d_Lsourcecode_Name = new $TypeData().i($c_Lsourcecode_Name, "sourcecode.Name", ({
  mE: 1,
  e3: 1,
  b: 1,
  c: 1,
  a: 1
}));
function $ps_Lsourcecode_Name$__Name$$superArg$1__F1() {
  return new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => new $c_Lsourcecode_Name(_$1)));
}
/** @constructor */
function $c_Lsourcecode_Name$() {
  this.VF = null;
  $ct_Lsourcecode_SourceCompanion__F1__(this, $ps_Lsourcecode_Name$__Name$$superArg$1__F1());
}
$p = $c_Lsourcecode_Name$.prototype = new $h_Lsourcecode_SourceCompanion();
$p.constructor = $c_Lsourcecode_Name$;
/** @constructor */
function $h_Lsourcecode_Name$() {
}
$h_Lsourcecode_Name$.prototype = $p;
var $d_Lsourcecode_Name$ = new $TypeData().i($c_Lsourcecode_Name$, "sourcecode.Name$", ({
  Nn: 1,
  e2: 1,
  No: 1,
  d: 1,
  j: 1
}));
var $n_Lsourcecode_Name$;
function $m_Lsourcecode_Name$() {
  if ((!$n_Lsourcecode_Name$)) {
    $n_Lsourcecode_Name$ = new $c_Lsourcecode_Name$();
  }
  return $n_Lsourcecode_Name$;
}
function $f_Lujson_AstTransformer__transformArray__Lupickle_core_Visitor__sc_Iterable__O($thiz, f, items) {
  var ctx = f.cZ(items.aa(), (-1));
  items.F(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((item) => {
    ctx.cU($thiz.yp(item, ctx.d9()), (-1));
  })));
  return ctx.bV((-1));
}
function $f_Lujson_AstTransformer__transformObject__Lupickle_core_Visitor__sc_Iterable__O($thiz, f, items) {
  var ctx = f.bQ(items.aa(), true, (-1));
  items.F(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((kv) => {
    ctx.jz(ctx.jy((-1)).cN(kv.g(), (-1)));
    ctx.cU($thiz.yp(kv.h(), ctx.d9()), (-1));
  })));
  return ctx.bV((-1));
}
/** @constructor */
function $c_Lujson_CharParser$$anon$1(j$2) {
  this.aJC = 0;
  this.aJC = j$2;
}
$p = $c_Lujson_CharParser$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lujson_CharParser$$anon$1;
/** @constructor */
function $h_Lujson_CharParser$$anon$1() {
}
$h_Lujson_CharParser$$anon$1.prototype = $p;
$p.e5 = (function(x) {
  return ((x instanceof $c_Lupickle_core_Abort) || false);
});
$p.e2 = (function(x, default$1) {
  if ((x instanceof $c_Lupickle_core_Abort)) {
    throw new $c_Lupickle_core_AbortException(x.Or, this.aJC, (-1), (-1), x);
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.e5(x);
});
$p.aC = (function(x, default$1) {
  return this.e2(x, default$1);
});
var $d_Lujson_CharParser$$anon$1 = new $TypeData().i($c_Lujson_CharParser$$anon$1, "ujson.CharParser$$anon$1", ({
  Nx: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lujson_Readable$fromTransformer(t, w) {
  this.VK = null;
  this.VL = null;
  this.VK = t;
  this.VL = w;
}
$p = $c_Lujson_Readable$fromTransformer.prototype = new $h_O();
$p.constructor = $c_Lujson_Readable$fromTransformer;
/** @constructor */
function $h_Lujson_Readable$fromTransformer() {
}
$h_Lujson_Readable$fromTransformer.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().eN(this, (-889275714), null);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lujson_Readable$fromTransformer)) {
    if ($m_sr_BoxesRunTime$().Q(this.VK, x$0.VK)) {
      var x$1 = this.VL;
      var x$2 = x$0.VL;
      return ((x$1 === null) ? (x$2 === null) : (x$1 === x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "fromTransformer";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.VK;
  }
  if ((n === 1)) {
    return this.VL;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "t";
  }
  if ((n === 1)) {
    return "w";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.yq = (function(f) {
  return this.VL.cy(this.VK, f);
});
function $isArrayOf_Lujson_Readable$fromTransformer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.mO)));
}
var $d_Lujson_Readable$fromTransformer = new $TypeData().i($c_Lujson_Readable$fromTransformer, "ujson.Readable$fromTransformer", ({
  mO: 1,
  b4: 1,
  b: 1,
  c: 1,
  a: 1
}));
function $p_Lupack_Msg$__visitObjContents__Lupickle_core_Visitor__Lupickle_core_LinkedHashMap__O($thiz, f, items) {
  var obj = f.bQ($f_sc_IterableOnceOps__size__I(items), true, (-1));
  var kvs = items.o();
  while (kvs.p()) {
    var kv = kvs.q();
    var k = kv.g();
    var v = kv.h();
    var keyVisitor = obj.jy((-1));
    obj.jz($m_Lupack_Msg$().a54(k, keyVisitor));
    obj.cU($thiz.a54(v, obj.d9()), (-1));
  }
  return obj.bV((-1));
}
function $p_Lupack_Msg$__visitArrContents__Lupickle_core_Visitor__scm_ArrayBuffer__O($thiz, f, items) {
  var arr = f.cZ(items.a1, (-1));
  var i = 0;
  var itemsLength = items.a1;
  while ((i < itemsLength)) {
    arr.cU($thiz.a54(items.l(i), arr.d9()), (-1));
    i = ((1 + i) | 0);
  }
  return arr.bV((-1));
}
/** @constructor */
function $c_Lupack_Msg$() {
}
$p = $c_Lupack_Msg$.prototype = new $h_O();
$p.constructor = $c_Lupack_Msg$;
/** @constructor */
function $h_Lupack_Msg$() {
}
$h_Lupack_Msg$.prototype = $p;
$p.ge = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.fA = (function(s, index) {
  return $f_Lupack_MsgVisitor__visitFloat64String__T__I__O(this, s, index);
});
$p.eD = (function(s, decIndex, expIndex, index) {
  return $f_Lupack_MsgVisitor__visitFloat64StringParts__jl_CharSequence__I__I__I__O(this, s, decIndex, expIndex, index);
});
$p.a54 = (function(j, f) {
  if (($m_Lupack_Null$() === j)) {
    return f.c8((-1));
  }
  if (($m_Lupack_True$() === j)) {
    return f.eE((-1));
  }
  if (($m_Lupack_False$() === j)) {
    return f.eC((-1));
  }
  if ((j instanceof $c_Lupack_Int32)) {
    var x141 = j.Oq;
    return f.em(x141, (-1));
  }
  if ((j instanceof $c_Lupack_Int64)) {
    var $x_1 = j;
    var x138_$_lo = $x_1.OJ;
    var x138_$_hi = $x_1.OK;
    return f.eZ(x138_$_lo, x138_$_hi, (-1));
  }
  if ((j instanceof $c_Lupack_UInt64)) {
    var $x_2 = j;
    var x135_$_lo = $x_2.OL;
    var x135_$_hi = $x_2.OM;
    return f.fe(x135_$_lo, x135_$_hi, (-1));
  }
  if ((j instanceof $c_Lupack_Float32)) {
    var x132 = j.Oo;
    return f.eY(x132, (-1));
  }
  if ((j instanceof $c_Lupack_Float64)) {
    var x129 = j.Op;
    return f.e7(x129, (-1));
  }
  if ((j instanceof $c_Lupack_Str)) {
    var x126 = j.VU;
    return f.cN(x126, (-1));
  }
  if ((j instanceof $c_Lupack_Binary)) {
    var x123 = j.VS;
    return f.fb(x123, 0, x123.a.length, (-1));
  }
  if ((j instanceof $c_Lupack_Arr)) {
    return $p_Lupack_Msg$__visitArrContents__Lupickle_core_Visitor__scm_ArrayBuffer__O(this, f, j.VR);
  }
  if ((j instanceof $c_Lupack_Obj)) {
    return $p_Lupack_Msg$__visitObjContents__Lupickle_core_Visitor__Lupickle_core_LinkedHashMap__O(this, f, j.VT);
  }
  if ((j instanceof $c_Lupack_Ext)) {
    var x113 = j.On;
    var x114 = j.Om;
    return f.fd(x113, x114, 0, x114.a.length, (-1));
  }
  throw new $c_s_MatchError(j);
});
$p.cZ = (function(length, index) {
  return new $c_Lupack_Msg$$anon$1();
});
$p.bQ = (function(length, jsonableKeys, index) {
  return new $c_Lupack_Msg$$anon$2();
});
$p.bbp = (function(bytes, offset, len, index) {
  return new $c_Lupack_Binary($m_sc_ArrayOps$().ls(bytes, offset, ((offset + len) | 0)));
});
$p.bbu = (function(tag, bytes, offset, len, index) {
  return new $c_Lupack_Ext(tag, $m_sc_ArrayOps$().ls(bytes, offset, ((offset + len) | 0)));
});
$p.bbq = (function(s, index) {
  return new $c_Lupack_Int32(s);
});
$p.c8 = (function(index) {
  return $m_Lupack_Null$();
});
$p.eC = (function(index) {
  return $m_Lupack_False$();
});
$p.eE = (function(index) {
  return $m_Lupack_True$();
});
$p.e7 = (function(d, index) {
  return new $c_Lupack_Float64(d);
});
$p.eY = (function(d, index) {
  return new $c_Lupack_Float32(d);
});
$p.em = (function(i, index) {
  return new $c_Lupack_Int32(i);
});
$p.eZ = (function(i_$_lo, i_$_hi, index) {
  return new $c_Lupack_Int64(i_$_lo, i_$_hi);
});
$p.fe = (function(i_$_lo, i_$_hi, index) {
  return new $c_Lupack_UInt64(i_$_lo, i_$_hi);
});
$p.cN = (function(s, index) {
  return new $c_Lupack_Str($dp_toString__T(s));
});
$p.fb = (function(bytes, offset, len, index) {
  return this.bbp(bytes, offset, len, index);
});
$p.fd = (function(tag, bytes, offset, len, index) {
  return this.bbu(tag, bytes, offset, len, index);
});
$p.fc = (function(s, index) {
  return this.bbq(s, index);
});
var $d_Lupack_Msg$ = new $TypeData().i($c_Lupack_Msg$, "upack.Msg$", ({
  NL: 1,
  x: 1,
  NO: 1,
  d: 1,
  u: 1
}));
var $n_Lupack_Msg$;
function $m_Lupack_Msg$() {
  if ((!$n_Lupack_Msg$)) {
    $n_Lupack_Msg$ = new $c_Lupack_Msg$();
  }
  return $n_Lupack_Msg$;
}
/** @constructor */
function $c_Lupickle_core_Annotator$Checker$Cls(c) {
  this.W1 = null;
  this.W1 = c;
}
$p = $c_Lupickle_core_Annotator$Checker$Cls.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_Annotator$Checker$Cls;
/** @constructor */
function $h_Lupickle_core_Annotator$Checker$Cls() {
}
$h_Lupickle_core_Annotator$Checker$Cls.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().eN(this, (-889275714), null);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lupickle_core_Annotator$Checker$Cls)) {
    var x = this.W1;
    var x$2 = x$0.W1;
    return ((x === null) ? (x$2 === null) : (x === x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Cls";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.W1;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "c";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lupickle_core_Annotator$Checker$Cls(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.n7)));
}
var $d_Lupickle_core_Annotator$Checker$Cls = new $TypeData().i($c_Lupickle_core_Annotator$Checker$Cls, "upickle.core.Annotator$Checker$Cls", ({
  n7: 1,
  O3: 1,
  b: 1,
  c: 1,
  a: 1
}));
function $isArrayOf_Lupickle_core_Annotator$Checker$Val(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.O4)));
}
/** @constructor */
function $c_Lupickle_core_BufferedValue$$anon$1() {
}
$p = $c_Lupickle_core_BufferedValue$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lupickle_core_BufferedValue$$anon$1;
/** @constructor */
function $h_Lupickle_core_BufferedValue$$anon$1() {
}
$h_Lupickle_core_BufferedValue$$anon$1.prototype = $p;
$p.bu = (function(x) {
  if ((x !== null)) {
    if ((x.g() instanceof $c_Lupickle_core_BufferedValue$Num)) {
      x.h();
      return true;
    }
  }
  return false;
});
$p.bt = (function(x, default$1) {
  if ((x !== null)) {
    var x79 = x.g();
    if ((x79 instanceof $c_Lupickle_core_BufferedValue$Num)) {
      x.h();
      return $m_jl_Double$().bd($dp_toString__T(x79.Dq));
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.bu(x);
});
$p.aC = (function(x, default$1) {
  return this.bt(x, default$1);
});
var $d_Lupickle_core_BufferedValue$$anon$1 = new $TypeData().i($c_Lupickle_core_BufferedValue$$anon$1, "upickle.core.BufferedValue$$anon$1", ({
  O6: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$$anon$2() {
}
$p = $c_Lupickle_core_BufferedValue$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lupickle_core_BufferedValue$$anon$2;
/** @constructor */
function $h_Lupickle_core_BufferedValue$$anon$2() {
}
$h_Lupickle_core_BufferedValue$$anon$2.prototype = $p;
$p.bu = (function(x) {
  if ((x !== null)) {
    if ((x.g() instanceof $c_Lupickle_core_BufferedValue$Float32)) {
      x.h();
      return true;
    }
  }
  return false;
});
$p.bt = (function(x, default$1) {
  if ((x !== null)) {
    var x87 = x.g();
    if ((x87 instanceof $c_Lupickle_core_BufferedValue$Float32)) {
      x.h();
      return x87.Dn;
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.bu(x);
});
$p.aC = (function(x, default$1) {
  return this.bt(x, default$1);
});
var $d_Lupickle_core_BufferedValue$$anon$2 = new $TypeData().i($c_Lupickle_core_BufferedValue$$anon$2, "upickle.core.BufferedValue$$anon$2", ({
  O7: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$$anon$3() {
}
$p = $c_Lupickle_core_BufferedValue$$anon$3.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lupickle_core_BufferedValue$$anon$3;
/** @constructor */
function $h_Lupickle_core_BufferedValue$$anon$3() {
}
$h_Lupickle_core_BufferedValue$$anon$3.prototype = $p;
$p.bu = (function(x) {
  if ((x !== null)) {
    if ((x.g() instanceof $c_Lupickle_core_BufferedValue$Float64String)) {
      x.h();
      return true;
    }
  }
  return false;
});
$p.bt = (function(x, default$1) {
  if ((x !== null)) {
    var x95 = x.g();
    if ((x95 instanceof $c_Lupickle_core_BufferedValue$Float64String)) {
      x.h();
      return $m_jl_Double$().bd(x95.Do);
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.bu(x);
});
$p.aC = (function(x, default$1) {
  return this.bt(x, default$1);
});
var $d_Lupickle_core_BufferedValue$$anon$3 = new $TypeData().i($c_Lupickle_core_BufferedValue$$anon$3, "upickle.core.BufferedValue$$anon$3", ({
  O8: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$$anon$4() {
}
$p = $c_Lupickle_core_BufferedValue$$anon$4.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lupickle_core_BufferedValue$$anon$4;
/** @constructor */
function $h_Lupickle_core_BufferedValue$$anon$4() {
}
$h_Lupickle_core_BufferedValue$$anon$4.prototype = $p;
$p.bu = (function(x) {
  if ((x !== null)) {
    if ((x.g() instanceof $c_Lupickle_core_BufferedValue$Int32)) {
      x.h();
      return true;
    }
  }
  return false;
});
$p.bt = (function(x, default$1) {
  if ((x !== null)) {
    var x103 = x.g();
    if ((x103 instanceof $c_Lupickle_core_BufferedValue$Int32)) {
      x.h();
      return x103.Dp;
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.bu(x);
});
$p.aC = (function(x, default$1) {
  return this.bt(x, default$1);
});
var $d_Lupickle_core_BufferedValue$$anon$4 = new $TypeData().i($c_Lupickle_core_BufferedValue$$anon$4, "upickle.core.BufferedValue$$anon$4", ({
  O9: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$$anon$5() {
}
$p = $c_Lupickle_core_BufferedValue$$anon$5.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lupickle_core_BufferedValue$$anon$5;
/** @constructor */
function $h_Lupickle_core_BufferedValue$$anon$5() {
}
$h_Lupickle_core_BufferedValue$$anon$5.prototype = $p;
$p.bu = (function(x) {
  if ((x !== null)) {
    if ((x.g() instanceof $c_Lupickle_core_BufferedValue$Int64)) {
      x.h();
      return true;
    }
  }
  return false;
});
$p.bt = (function(x, default$1) {
  if ((x !== null)) {
    var x111 = x.g();
    if ((x111 instanceof $c_Lupickle_core_BufferedValue$Int64)) {
      x.h();
      var $x_1 = x111;
      return $bL($x_1.Dv, $x_1.Dw);
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.bu(x);
});
$p.aC = (function(x, default$1) {
  return this.bt(x, default$1);
});
var $d_Lupickle_core_BufferedValue$$anon$5 = new $TypeData().i($c_Lupickle_core_BufferedValue$$anon$5, "upickle.core.BufferedValue$$anon$5", ({
  Oa: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$$anon$6() {
}
$p = $c_Lupickle_core_BufferedValue$$anon$6.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lupickle_core_BufferedValue$$anon$6;
/** @constructor */
function $h_Lupickle_core_BufferedValue$$anon$6() {
}
$h_Lupickle_core_BufferedValue$$anon$6.prototype = $p;
$p.bu = (function(x) {
  if ((x !== null)) {
    if ((x.g() instanceof $c_Lupickle_core_BufferedValue$NumRaw)) {
      x.h();
      return true;
    }
  }
  return false;
});
$p.bt = (function(x, default$1) {
  if ((x !== null)) {
    var x119 = x.g();
    if ((x119 instanceof $c_Lupickle_core_BufferedValue$NumRaw)) {
      x.h();
      return x119.Dr;
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.bu(x);
});
$p.aC = (function(x, default$1) {
  return this.bt(x, default$1);
});
var $d_Lupickle_core_BufferedValue$$anon$6 = new $TypeData().i($c_Lupickle_core_BufferedValue$$anon$6, "upickle.core.BufferedValue$$anon$6", ({
  Ob: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$$anon$7() {
}
$p = $c_Lupickle_core_BufferedValue$$anon$7.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lupickle_core_BufferedValue$$anon$7;
/** @constructor */
function $h_Lupickle_core_BufferedValue$$anon$7() {
}
$h_Lupickle_core_BufferedValue$$anon$7.prototype = $p;
$p.bu = (function(x) {
  if ((x !== null)) {
    if ((x.g() instanceof $c_Lupickle_core_BufferedValue$UInt64)) {
      x.h();
      return true;
    }
  }
  return false;
});
$p.bt = (function(x, default$1) {
  if ((x !== null)) {
    var x127 = x.g();
    if ((x127 instanceof $c_Lupickle_core_BufferedValue$UInt64)) {
      x.h();
      var $x_1 = x127;
      return $bL($x_1.Dx, $x_1.Dy);
    }
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.bu(x);
});
$p.aC = (function(x, default$1) {
  return this.bt(x, default$1);
});
var $d_Lupickle_core_BufferedValue$$anon$7 = new $TypeData().i($c_Lupickle_core_BufferedValue$$anon$7, "upickle.core.BufferedValue$$anon$7", ({
  Oc: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$$anon$8() {
}
$p = $c_Lupickle_core_BufferedValue$$anon$8.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lupickle_core_BufferedValue$$anon$8;
/** @constructor */
function $h_Lupickle_core_BufferedValue$$anon$8() {
}
$h_Lupickle_core_BufferedValue$$anon$8.prototype = $p;
$p.bu = (function(x) {
  return ((x !== null) && (x.g(), x.h(), true));
});
$p.bt = (function(x, default$1) {
  if ((x !== null)) {
    var k = x.g();
    x.h();
    return $m_Lupickle_core_BufferedValue$().a5e(k);
  } else {
    return default$1.i(x);
  }
});
$p.aM = (function(x) {
  return this.bu(x);
});
$p.aC = (function(x, default$1) {
  return this.bt(x, default$1);
});
var $d_Lupickle_core_BufferedValue$$anon$8 = new $TypeData().i($c_Lupickle_core_BufferedValue$$anon$8, "upickle.core.BufferedValue$$anon$8", ({
  Od: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$Arr(value, index) {
  this.Dm = null;
  this.HS = 0;
  this.Dm = value;
  this.HS = index;
}
$p = $c_Lupickle_core_BufferedValue$Arr.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_BufferedValue$Arr;
/** @constructor */
function $h_Lupickle_core_BufferedValue$Arr() {
}
$h_Lupickle_core_BufferedValue$Arr.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, $f_T__hashCode__I("Arr"));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Dm));
  acc = $m_sr_Statics$().k(acc, this.HS);
  return $m_sr_Statics$().Z(acc, 2);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lupickle_core_BufferedValue$Arr)) {
    if ((this.HS === x$0.HS)) {
      var x = this.Dm;
      var x$2 = x$0.Dm;
      return ((x === null) ? (x$2 === null) : $f_sc_Seq__equals__O__Z(x, x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "Arr";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Dm;
  }
  if ((n === 1)) {
    return this.HS;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  if ((n === 1)) {
    return "index";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.kr = (function() {
  return this.HS;
});
function $isArrayOf_Lupickle_core_BufferedValue$Arr(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.n8)));
}
var $d_Lupickle_core_BufferedValue$Arr = new $TypeData().i($c_Lupickle_core_BufferedValue$Arr, "upickle.core.BufferedValue$Arr", ({
  n8: 1,
  aA: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$Binary(bytes, offset, len, index) {
  this.HT = null;
  this.HW = 0;
  this.HV = 0;
  this.HU = 0;
  this.HT = bytes;
  this.HW = offset;
  this.HV = len;
  this.HU = index;
}
$p = $c_Lupickle_core_BufferedValue$Binary.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_BufferedValue$Binary;
/** @constructor */
function $h_Lupickle_core_BufferedValue$Binary() {
}
$h_Lupickle_core_BufferedValue$Binary.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, $f_T__hashCode__I("Binary"));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.HT));
  acc = $m_sr_Statics$().k(acc, this.HW);
  acc = $m_sr_Statics$().k(acc, this.HV);
  acc = $m_sr_Statics$().k(acc, this.HU);
  return $m_sr_Statics$().Z(acc, 4);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lupickle_core_BufferedValue$Binary)) {
    if ((((this.HW === x$0.HW) && (this.HV === x$0.HV)) && (this.HU === x$0.HU))) {
      var x = this.HT;
      var x$2 = x$0.HT;
      return ((x === null) ? (x$2 === null) : (x === x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 4;
});
$p.B = (function() {
  return "Binary";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.HT;
      break;
    }
    case 1: {
      return this.HW;
      break;
    }
    case 2: {
      return this.HV;
      break;
    }
    case 3: {
      return this.HU;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "bytes";
      break;
    }
    case 1: {
      return "offset";
      break;
    }
    case 2: {
      return "len";
      break;
    }
    case 3: {
      return "index";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.kr = (function() {
  return this.HU;
});
function $isArrayOf_Lupickle_core_BufferedValue$Binary(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.n9)));
}
var $d_Lupickle_core_BufferedValue$Binary = new $TypeData().i($c_Lupickle_core_BufferedValue$Binary, "upickle.core.BufferedValue$Binary", ({
  n9: 1,
  aA: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$Char(s, index) {
  this.HY = 0;
  this.HX = 0;
  this.HY = s;
  this.HX = index;
}
$p = $c_Lupickle_core_BufferedValue$Char.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_BufferedValue$Char;
/** @constructor */
function $h_Lupickle_core_BufferedValue$Char() {
}
$h_Lupickle_core_BufferedValue$Char.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, $f_T__hashCode__I("Char"));
  acc = $m_sr_Statics$().k(acc, this.HY);
  acc = $m_sr_Statics$().k(acc, this.HX);
  return $m_sr_Statics$().Z(acc, 2);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lupickle_core_BufferedValue$Char) && ((this.HY === x$0.HY) && (this.HX === x$0.HX))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "Char";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return $bC(this.HY);
  }
  if ((n === 1)) {
    return this.HX;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "s";
  }
  if ((n === 1)) {
    return "index";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.kr = (function() {
  return this.HX;
});
function $isArrayOf_Lupickle_core_BufferedValue$Char(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.na)));
}
var $d_Lupickle_core_BufferedValue$Char = new $TypeData().i($c_Lupickle_core_BufferedValue$Char, "upickle.core.BufferedValue$Char", ({
  na: 1,
  aA: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$Ext(tag, bytes, offset, len, index) {
  this.I3 = 0;
  this.HZ = null;
  this.I2 = 0;
  this.I1 = 0;
  this.I0 = 0;
  this.I3 = tag;
  this.HZ = bytes;
  this.I2 = offset;
  this.I1 = len;
  this.I0 = index;
}
$p = $c_Lupickle_core_BufferedValue$Ext.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_BufferedValue$Ext;
/** @constructor */
function $h_Lupickle_core_BufferedValue$Ext() {
}
$h_Lupickle_core_BufferedValue$Ext.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, $f_T__hashCode__I("Ext"));
  acc = $m_sr_Statics$().k(acc, this.I3);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.HZ));
  acc = $m_sr_Statics$().k(acc, this.I2);
  acc = $m_sr_Statics$().k(acc, this.I1);
  acc = $m_sr_Statics$().k(acc, this.I0);
  return $m_sr_Statics$().Z(acc, 5);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lupickle_core_BufferedValue$Ext)) {
    if (((((this.I3 === x$0.I3) && (this.I2 === x$0.I2)) && (this.I1 === x$0.I1)) && (this.I0 === x$0.I0))) {
      var x = this.HZ;
      var x$2 = x$0.HZ;
      return ((x === null) ? (x$2 === null) : (x === x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 5;
});
$p.B = (function() {
  return "Ext";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.I3;
      break;
    }
    case 1: {
      return this.HZ;
      break;
    }
    case 2: {
      return this.I2;
      break;
    }
    case 3: {
      return this.I1;
      break;
    }
    case 4: {
      return this.I0;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "tag";
      break;
    }
    case 1: {
      return "bytes";
      break;
    }
    case 2: {
      return "offset";
      break;
    }
    case 3: {
      return "len";
      break;
    }
    case 4: {
      return "index";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.kr = (function() {
  return this.I0;
});
function $isArrayOf_Lupickle_core_BufferedValue$Ext(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.nb)));
}
var $d_Lupickle_core_BufferedValue$Ext = new $TypeData().i($c_Lupickle_core_BufferedValue$Ext, "upickle.core.BufferedValue$Ext", ({
  nb: 1,
  aA: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$False(index) {
  this.I4 = 0;
  this.I4 = index;
}
$p = $c_Lupickle_core_BufferedValue$False.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_BufferedValue$False;
/** @constructor */
function $h_Lupickle_core_BufferedValue$False() {
}
$h_Lupickle_core_BufferedValue$False.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, $f_T__hashCode__I("False"));
  acc = $m_sr_Statics$().k(acc, this.I4);
  return $m_sr_Statics$().Z(acc, 1);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lupickle_core_BufferedValue$False) && (this.I4 === x$0.I4)));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "False";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.I4;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "index";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.kr = (function() {
  return this.I4;
});
function $isArrayOf_Lupickle_core_BufferedValue$False(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.nc)));
}
var $d_Lupickle_core_BufferedValue$False = new $TypeData().i($c_Lupickle_core_BufferedValue$False, "upickle.core.BufferedValue$False", ({
  nc: 1,
  aA: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$Float32(d, index) {
  this.Dn = 0.0;
  this.I5 = 0;
  this.Dn = d;
  this.I5 = index;
}
$p = $c_Lupickle_core_BufferedValue$Float32.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_BufferedValue$Float32;
/** @constructor */
function $h_Lupickle_core_BufferedValue$Float32() {
}
$h_Lupickle_core_BufferedValue$Float32.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, $f_T__hashCode__I("Float32"));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.Dn));
  acc = $m_sr_Statics$().k(acc, this.I5);
  return $m_sr_Statics$().Z(acc, 2);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lupickle_core_BufferedValue$Float32) && ((this.Dn === x$0.Dn) && (this.I5 === x$0.I5))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "Float32";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Dn;
  }
  if ((n === 1)) {
    return this.I5;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "d";
  }
  if ((n === 1)) {
    return "index";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.kr = (function() {
  return this.I5;
});
function $isArrayOf_Lupickle_core_BufferedValue$Float32(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.nd)));
}
var $d_Lupickle_core_BufferedValue$Float32 = new $TypeData().i($c_Lupickle_core_BufferedValue$Float32, "upickle.core.BufferedValue$Float32", ({
  nd: 1,
  aA: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$Float64String(s, index) {
  this.Do = null;
  this.I6 = 0;
  this.Do = s;
  this.I6 = index;
}
$p = $c_Lupickle_core_BufferedValue$Float64String.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_BufferedValue$Float64String;
/** @constructor */
function $h_Lupickle_core_BufferedValue$Float64String() {
}
$h_Lupickle_core_BufferedValue$Float64String.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, $f_T__hashCode__I("Float64String"));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Do));
  acc = $m_sr_Statics$().k(acc, this.I6);
  return $m_sr_Statics$().Z(acc, 2);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lupickle_core_BufferedValue$Float64String) && ((this.I6 === x$0.I6) && (this.Do === x$0.Do))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "Float64String";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Do;
  }
  if ((n === 1)) {
    return this.I6;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "s";
  }
  if ((n === 1)) {
    return "index";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.kr = (function() {
  return this.I6;
});
function $isArrayOf_Lupickle_core_BufferedValue$Float64String(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ne)));
}
var $d_Lupickle_core_BufferedValue$Float64String = new $TypeData().i($c_Lupickle_core_BufferedValue$Float64String, "upickle.core.BufferedValue$Float64String", ({
  ne: 1,
  aA: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$Int32(i, index) {
  this.Dp = 0;
  this.I7 = 0;
  this.Dp = i;
  this.I7 = index;
}
$p = $c_Lupickle_core_BufferedValue$Int32.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_BufferedValue$Int32;
/** @constructor */
function $h_Lupickle_core_BufferedValue$Int32() {
}
$h_Lupickle_core_BufferedValue$Int32.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, $f_T__hashCode__I("Int32"));
  acc = $m_sr_Statics$().k(acc, this.Dp);
  acc = $m_sr_Statics$().k(acc, this.I7);
  return $m_sr_Statics$().Z(acc, 2);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lupickle_core_BufferedValue$Int32) && ((this.Dp === x$0.Dp) && (this.I7 === x$0.I7))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "Int32";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Dp;
  }
  if ((n === 1)) {
    return this.I7;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "i";
  }
  if ((n === 1)) {
    return "index";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.kr = (function() {
  return this.I7;
});
function $isArrayOf_Lupickle_core_BufferedValue$Int32(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.nf)));
}
var $d_Lupickle_core_BufferedValue$Int32 = new $TypeData().i($c_Lupickle_core_BufferedValue$Int32, "upickle.core.BufferedValue$Int32", ({
  nf: 1,
  aA: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$Int64(i_$_lo, i_$_hi, index) {
  this.Dv = 0;
  this.Dw = 0;
  this.I8 = 0;
  this.Dv = i_$_lo;
  this.Dw = i_$_hi;
  this.I8 = index;
}
$p = $c_Lupickle_core_BufferedValue$Int64.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_BufferedValue$Int64;
/** @constructor */
function $h_Lupickle_core_BufferedValue$Int64() {
}
$h_Lupickle_core_BufferedValue$Int64.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, $f_T__hashCode__I("Int64"));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().jt(this.Dv, this.Dw));
  acc = $m_sr_Statics$().k(acc, this.I8);
  return $m_sr_Statics$().Z(acc, 2);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lupickle_core_BufferedValue$Int64)) {
    var x_$_lo = this.Dv;
    var x_$_hi = this.Dw;
    var $x_1 = x$0;
    var x$1_$_lo = $x_1.Dv;
    var x$1_$_hi = $x_1.Dw;
    if ((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0)) {
      return (this.I8 === x$0.I8);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "Int64";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return $bL(this.Dv, this.Dw);
  }
  if ((n === 1)) {
    return this.I8;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "i";
  }
  if ((n === 1)) {
    return "index";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.kr = (function() {
  return this.I8;
});
function $isArrayOf_Lupickle_core_BufferedValue$Int64(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ng)));
}
var $d_Lupickle_core_BufferedValue$Int64 = new $TypeData().i($c_Lupickle_core_BufferedValue$Int64, "upickle.core.BufferedValue$Int64", ({
  ng: 1,
  aA: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$Null(index) {
  this.I9 = 0;
  this.I9 = index;
}
$p = $c_Lupickle_core_BufferedValue$Null.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_BufferedValue$Null;
/** @constructor */
function $h_Lupickle_core_BufferedValue$Null() {
}
$h_Lupickle_core_BufferedValue$Null.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, $f_T__hashCode__I("Null"));
  acc = $m_sr_Statics$().k(acc, this.I9);
  return $m_sr_Statics$().Z(acc, 1);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lupickle_core_BufferedValue$Null) && (this.I9 === x$0.I9)));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Null";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.I9;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "index";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.kr = (function() {
  return this.I9;
});
function $isArrayOf_Lupickle_core_BufferedValue$Null(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.nh)));
}
var $d_Lupickle_core_BufferedValue$Null = new $TypeData().i($c_Lupickle_core_BufferedValue$Null, "upickle.core.BufferedValue$Null", ({
  nh: 1,
  aA: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$Num(s, decIndex, expIndex, index) {
  this.Dq = null;
  this.Os = 0;
  this.Ot = 0;
  this.Ia = 0;
  this.Dq = s;
  this.Os = decIndex;
  this.Ot = expIndex;
  this.Ia = index;
}
$p = $c_Lupickle_core_BufferedValue$Num.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_BufferedValue$Num;
/** @constructor */
function $h_Lupickle_core_BufferedValue$Num() {
}
$h_Lupickle_core_BufferedValue$Num.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, $f_T__hashCode__I("Num"));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Dq));
  acc = $m_sr_Statics$().k(acc, this.Os);
  acc = $m_sr_Statics$().k(acc, this.Ot);
  acc = $m_sr_Statics$().k(acc, this.Ia);
  return $m_sr_Statics$().Z(acc, 4);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lupickle_core_BufferedValue$Num)) {
    if ((((this.Os === x$0.Os) && (this.Ot === x$0.Ot)) && (this.Ia === x$0.Ia))) {
      var x = this.Dq;
      var x$2 = x$0.Dq;
      return ((x === null) ? (x$2 === null) : $dp_equals__O__Z(x, x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 4;
});
$p.B = (function() {
  return "Num";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.Dq;
      break;
    }
    case 1: {
      return this.Os;
      break;
    }
    case 2: {
      return this.Ot;
      break;
    }
    case 3: {
      return this.Ia;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "s";
      break;
    }
    case 1: {
      return "decIndex";
      break;
    }
    case 2: {
      return "expIndex";
      break;
    }
    case 3: {
      return "index";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.kr = (function() {
  return this.Ia;
});
function $isArrayOf_Lupickle_core_BufferedValue$Num(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ni)));
}
var $d_Lupickle_core_BufferedValue$Num = new $TypeData().i($c_Lupickle_core_BufferedValue$Num, "upickle.core.BufferedValue$Num", ({
  ni: 1,
  aA: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$NumRaw(d, index) {
  this.Dr = 0.0;
  this.Ib = 0;
  this.Dr = d;
  this.Ib = index;
}
$p = $c_Lupickle_core_BufferedValue$NumRaw.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_BufferedValue$NumRaw;
/** @constructor */
function $h_Lupickle_core_BufferedValue$NumRaw() {
}
$h_Lupickle_core_BufferedValue$NumRaw.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, $f_T__hashCode__I("NumRaw"));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.Dr));
  acc = $m_sr_Statics$().k(acc, this.Ib);
  return $m_sr_Statics$().Z(acc, 2);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lupickle_core_BufferedValue$NumRaw) && ((this.Dr === x$0.Dr) && (this.Ib === x$0.Ib))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "NumRaw";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Dr;
  }
  if ((n === 1)) {
    return this.Ib;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "d";
  }
  if ((n === 1)) {
    return "index";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.kr = (function() {
  return this.Ib;
});
function $isArrayOf_Lupickle_core_BufferedValue$NumRaw(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.nj)));
}
var $d_Lupickle_core_BufferedValue$NumRaw = new $TypeData().i($c_Lupickle_core_BufferedValue$NumRaw, "upickle.core.BufferedValue$NumRaw", ({
  nj: 1,
  aA: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$Obj(value0, jsonableKeys, index) {
  this.xQ = null;
  this.Ou = false;
  this.Ic = 0;
  this.xQ = value0;
  this.Ou = jsonableKeys;
  this.Ic = index;
}
$p = $c_Lupickle_core_BufferedValue$Obj.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_BufferedValue$Obj;
/** @constructor */
function $h_Lupickle_core_BufferedValue$Obj() {
}
$h_Lupickle_core_BufferedValue$Obj.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, $f_T__hashCode__I("Obj"));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.xQ));
  acc = $m_sr_Statics$().k(acc, (this.Ou ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, this.Ic);
  return $m_sr_Statics$().Z(acc, 3);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lupickle_core_BufferedValue$Obj)) {
    if (((this.Ou === x$0.Ou) && (this.Ic === x$0.Ic))) {
      var x = this.xQ;
      var x$2 = x$0.xQ;
      return ((x === null) ? (x$2 === null) : $f_sc_Seq__equals__O__Z(x, x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 3;
});
$p.B = (function() {
  return "Obj";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.xQ;
      break;
    }
    case 1: {
      return this.Ou;
      break;
    }
    case 2: {
      return this.Ic;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "value0";
      break;
    }
    case 1: {
      return "jsonableKeys";
      break;
    }
    case 2: {
      return "index";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.kr = (function() {
  return this.Ic;
});
function $isArrayOf_Lupickle_core_BufferedValue$Obj(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.nk)));
}
var $d_Lupickle_core_BufferedValue$Obj = new $TypeData().i($c_Lupickle_core_BufferedValue$Obj, "upickle.core.BufferedValue$Obj", ({
  nk: 1,
  aA: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$Str(value0, index) {
  this.Ab = null;
  this.Id = 0;
  this.Ab = value0;
  this.Id = index;
}
$p = $c_Lupickle_core_BufferedValue$Str.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_BufferedValue$Str;
/** @constructor */
function $h_Lupickle_core_BufferedValue$Str() {
}
$h_Lupickle_core_BufferedValue$Str.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, $f_T__hashCode__I("Str"));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Ab));
  acc = $m_sr_Statics$().k(acc, this.Id);
  return $m_sr_Statics$().Z(acc, 2);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lupickle_core_BufferedValue$Str)) {
    if ((this.Id === x$0.Id)) {
      var x = this.Ab;
      var x$2 = x$0.Ab;
      return ((x === null) ? (x$2 === null) : $dp_equals__O__Z(x, x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "Str";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Ab;
  }
  if ((n === 1)) {
    return this.Id;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "value0";
  }
  if ((n === 1)) {
    return "index";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.kr = (function() {
  return this.Id;
});
function $isArrayOf_Lupickle_core_BufferedValue$Str(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.nl)));
}
var $d_Lupickle_core_BufferedValue$Str = new $TypeData().i($c_Lupickle_core_BufferedValue$Str, "upickle.core.BufferedValue$Str", ({
  nl: 1,
  aA: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$True(index) {
  this.Ie = 0;
  this.Ie = index;
}
$p = $c_Lupickle_core_BufferedValue$True.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_BufferedValue$True;
/** @constructor */
function $h_Lupickle_core_BufferedValue$True() {
}
$h_Lupickle_core_BufferedValue$True.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, $f_T__hashCode__I("True"));
  acc = $m_sr_Statics$().k(acc, this.Ie);
  return $m_sr_Statics$().Z(acc, 1);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lupickle_core_BufferedValue$True) && (this.Ie === x$0.Ie)));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "True";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Ie;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "index";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.kr = (function() {
  return this.Ie;
});
function $isArrayOf_Lupickle_core_BufferedValue$True(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.nm)));
}
var $d_Lupickle_core_BufferedValue$True = new $TypeData().i($c_Lupickle_core_BufferedValue$True, "upickle.core.BufferedValue$True", ({
  nm: 1,
  aA: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$UInt64(i_$_lo, i_$_hi, index) {
  this.Dx = 0;
  this.Dy = 0;
  this.If = 0;
  this.Dx = i_$_lo;
  this.Dy = i_$_hi;
  this.If = index;
}
$p = $c_Lupickle_core_BufferedValue$UInt64.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_BufferedValue$UInt64;
/** @constructor */
function $h_Lupickle_core_BufferedValue$UInt64() {
}
$h_Lupickle_core_BufferedValue$UInt64.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, $f_T__hashCode__I("UInt64"));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().jt(this.Dx, this.Dy));
  acc = $m_sr_Statics$().k(acc, this.If);
  return $m_sr_Statics$().Z(acc, 2);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lupickle_core_BufferedValue$UInt64)) {
    var x_$_lo = this.Dx;
    var x_$_hi = this.Dy;
    var $x_1 = x$0;
    var x$1_$_lo = $x_1.Dx;
    var x$1_$_hi = $x_1.Dy;
    if ((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0)) {
      return (this.If === x$0.If);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "UInt64";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return $bL(this.Dx, this.Dy);
  }
  if ((n === 1)) {
    return this.If;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "i";
  }
  if ((n === 1)) {
    return "index";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.kr = (function() {
  return this.If;
});
function $isArrayOf_Lupickle_core_BufferedValue$UInt64(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.nn)));
}
var $d_Lupickle_core_BufferedValue$UInt64 = new $TypeData().i($c_Lupickle_core_BufferedValue$UInt64, "upickle.core.BufferedValue$UInt64", ({
  nn: 1,
  aA: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_ParseUtils$$anon$1(j$2) {
  this.aJL = 0;
  this.aJL = j$2;
}
$p = $c_Lupickle_core_ParseUtils$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lupickle_core_ParseUtils$$anon$1;
/** @constructor */
function $h_Lupickle_core_ParseUtils$$anon$1() {
}
$h_Lupickle_core_ParseUtils$$anon$1.prototype = $p;
$p.e5 = (function(x) {
  return ((x instanceof $c_Lupickle_core_Abort) || false);
});
$p.e2 = (function(x, default$1) {
  if ((x instanceof $c_Lupickle_core_Abort)) {
    throw new $c_Lupickle_core_AbortException(x.Or, this.aJL, (-1), (-1), x);
  }
  return default$1.i(x);
});
$p.aM = (function(x) {
  return this.e5(x);
});
$p.aC = (function(x, default$1) {
  return this.e2(x, default$1);
});
var $d_Lupickle_core_ParseUtils$$anon$1 = new $TypeData().i($c_Lupickle_core_ParseUtils$$anon$1, "upickle.core.ParseUtils$$anon$1", ({
  Ou: 1,
  q: 1,
  h: 1,
  i: 1,
  a: 1
}));
class $c_Lupickle_core_TraceVisitor$TraceException extends $c_jl_Exception {
  constructor(jsonPath, cause) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, jsonPath, cause, true, true);
  }
  IU() {
    return $f_s_util_control_NoStackTrace__fillInStackTrace__jl_Throwable(this);
  }
}
var $d_Lupickle_core_TraceVisitor$TraceException = new $TypeData().i($c_Lupickle_core_TraceVisitor$TraceException, "upickle.core.TraceVisitor$TraceException", ({
  OB: 1,
  G: 1,
  y: 1,
  a: 1,
  ca: 1
}));
/** @constructor */
function $c_Lupickle_core_Types$$anon$4(f$5, outer) {
  this.kJ = null;
  this.adS = null;
  this.aJR = null;
  this.aJR = f$5;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_Lupickle_core_Types$Reader$MapReader__Lupickle_core_Types$Reader$__Lupickle_core_Visitor__(this, outer.ha().OP(), outer);
}
$p = $c_Lupickle_core_Types$$anon$4.prototype = new $h_Lupickle_core_Types$Reader$MapReader();
$p.constructor = $c_Lupickle_core_Types$$anon$4;
/** @constructor */
function $h_Lupickle_core_Types$$anon$4() {
}
$h_Lupickle_core_Types$$anon$4.prototype = $p;
$p.a4a = (function(v) {
  return this.aJR.i(v);
});
var $d_Lupickle_core_Types$$anon$4 = new $TypeData().i($c_Lupickle_core_Types$$anon$4, "upickle.core.Types$$anon$4", ({
  OH: 1,
  OL: 1,
  nq: 1,
  x: 1,
  D: 1
}));
function $f_Lupickle_core_Types$TaggedReader__visitString__jl_CharSequence__I__O($thiz, s, index) {
  var x6 = $thiz.IW($dp_toString__T(s));
  if ((x6 === null)) {
    throw new $c_Lupickle_core_AbortException(("invalid tag for tagged object: " + s), index, (-1), (-1), null);
  }
  return x6.cN(s, index);
}
function $is_Lupickle_core_Types$TaggedReader(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.cc)));
}
function $isArrayOf_Lupickle_core_Types$TaggedReader(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.cc)));
}
function $ct_Lupickle_implicits_CaseClassReadWriters$CaseClassReader__Lupickle_implicits_CaseClassReadWriters__($thiz, outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $thiz.ic = outer;
  return $thiz;
}
/** @constructor */
function $c_Lupickle_implicits_CaseClassReadWriters$CaseClassReader() {
  this.ic = null;
}
$p = $c_Lupickle_implicits_CaseClassReadWriters$CaseClassReader.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_CaseClassReadWriters$CaseClassReader;
/** @constructor */
function $h_Lupickle_implicits_CaseClassReadWriters$CaseClassReader() {
}
$h_Lupickle_implicits_CaseClassReadWriters$CaseClassReader.prototype = $p;
$p.ge = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.gB = (function() {
  return this;
});
$p.c8 = (function(index) {
  return null;
});
$p.eE = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitTrue__I__O(this, index);
});
$p.eC = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitFalse__I__O(this, index);
});
$p.eD = (function(s, decIndex, expIndex, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64StringParts__jl_CharSequence__I__I__I__O(this, s, decIndex, expIndex, index);
});
$p.cZ = (function(length, index) {
  return $f_Lupickle_core_SimpleVisitor__visitArray__I__I__Lupickle_core_ArrVisitor(this, length, index);
});
$p.e7 = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64__D__I__O(this, d, index);
});
$p.eY = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat32__F__I__O(this, d, index);
});
$p.em = (function(i, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt32__I__I__O(this, i, index);
});
$p.eZ = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.fe = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitUInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.fA = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64String__T__I__O(this, s, index);
});
$p.fc = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitChar__C__I__O(this, s, index);
});
$p.fb = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.fd = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.ej = (function() {
  return "expected dictionary";
});
$p.cN = (function(s, index) {
  return this.bQ(0, true, index).bV(index);
});
$p.ha = (function() {
  return this.ic;
});
function $isArrayOf_Lupickle_implicits_CaseClassReadWriters$SingletonWriter(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.P2)));
}
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$1(outer) {
  this.aKx = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aKx = outer;
}
$p = $c_Lupickle_implicits_Readers$$anon$1.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$1;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$1() {
}
$h_Lupickle_implicits_Readers$$anon$1.prototype = $p;
$p.ge = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.gB = (function() {
  return this;
});
$p.eE = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitTrue__I__O(this, index);
});
$p.eC = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitFalse__I__O(this, index);
});
$p.cN = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitString__jl_CharSequence__I__O(this, s, index);
});
$p.eD = (function(s, decIndex, expIndex, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64StringParts__jl_CharSequence__I__I__I__O(this, s, decIndex, expIndex, index);
});
$p.cZ = (function(length, index) {
  return $f_Lupickle_core_SimpleVisitor__visitArray__I__I__Lupickle_core_ArrVisitor(this, length, index);
});
$p.e7 = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64__D__I__O(this, d, index);
});
$p.eY = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat32__F__I__O(this, d, index);
});
$p.em = (function(i, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt32__I__I__O(this, i, index);
});
$p.eZ = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.fe = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitUInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.fA = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64String__T__I__O(this, s, index);
});
$p.fc = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitChar__C__I__O(this, s, index);
});
$p.fb = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.fd = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.ej = (function() {
  return "expected unit";
});
$p.bQ = (function(length, jsonableKeys, index) {
  return new $c_Lupickle_implicits_Readers$$anon$2();
});
$p.ha = (function() {
  return this.aKx;
});
$p.c8 = (function(index) {
  return (void 0);
});
var $d_Lupickle_implicits_Readers$$anon$1 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$1, "upickle.implicits.Readers$$anon$1", ({
  Pc: 1,
  x: 1,
  D: 1,
  J: 1,
  K: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$17(v$2, k$2, make$2, outer) {
  this.ae6 = null;
  this.ae4 = null;
  this.ae5 = null;
  this.a2o = null;
  this.ae6 = v$2;
  this.ae4 = k$2;
  this.ae5 = make$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.a2o = outer;
}
$p = $c_Lupickle_implicits_Readers$$anon$17.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$17;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$17() {
}
$h_Lupickle_implicits_Readers$$anon$17.prototype = $p;
$p.ge = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.gB = (function() {
  return this;
});
$p.c8 = (function(index) {
  return null;
});
$p.eE = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitTrue__I__O(this, index);
});
$p.eC = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitFalse__I__O(this, index);
});
$p.cN = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitString__jl_CharSequence__I__O(this, s, index);
});
$p.eD = (function(s, decIndex, expIndex, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64StringParts__jl_CharSequence__I__I__I__O(this, s, decIndex, expIndex, index);
});
$p.e7 = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64__D__I__O(this, d, index);
});
$p.eY = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat32__F__I__O(this, d, index);
});
$p.em = (function(i, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt32__I__I__O(this, i, index);
});
$p.eZ = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.fe = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitUInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.fA = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64String__T__I__O(this, s, index);
});
$p.fc = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitChar__C__I__O(this, s, index);
});
$p.fb = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.fd = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.bQ = (function(length, jsonableKeys, index) {
  return new $c_Lupickle_implicits_Readers$$anon$17$$anon$18(this);
});
$p.cZ = (function(length, index) {
  return $c_Lupickle_core_Visitor$MapReader.prototype.cZ.call(new $c_Lupickle_core_Types$$anon$4(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x) => this.ae5.i($m_s_Predef$().fB(x)))), new $c_Lupickle_implicits_Readers$SeqLikeReader(this.a2o, $f_Lupickle_implicits_Generated__Tuple2Reader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader__Lupickle_implicits_TupleReadWriters$TupleNReader(this.a2o, this.ae4, this.ae6), new $c_sc_Factory$ArrayFactory(new $c_s_reflect_ClassTag$GenericClassTag($d_T2.l())))), length, index);
});
$p.ej = (function() {
  return "expected map or sequence";
});
$p.ha = (function() {
  return this.a2o;
});
var $d_Lupickle_implicits_Readers$$anon$17 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$17, "upickle.implicits.Readers$$anon$17", ({
  Pk: 1,
  x: 1,
  D: 1,
  J: 1,
  K: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$3(outer) {
  this.aKJ = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aKJ = outer;
}
$p = $c_Lupickle_implicits_Readers$$anon$3.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$3;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$3() {
}
$h_Lupickle_implicits_Readers$$anon$3.prototype = $p;
$p.ge = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.gB = (function() {
  return this;
});
$p.c8 = (function(index) {
  return null;
});
$p.eD = (function(s, decIndex, expIndex, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64StringParts__jl_CharSequence__I__I__I__O(this, s, decIndex, expIndex, index);
});
$p.bQ = (function(length, jsonableKeys, index) {
  return $f_Lupickle_core_SimpleVisitor__visitObject__I__Z__I__Lupickle_core_ObjVisitor(this, length, jsonableKeys, index);
});
$p.cZ = (function(length, index) {
  return $f_Lupickle_core_SimpleVisitor__visitArray__I__I__Lupickle_core_ArrVisitor(this, length, index);
});
$p.e7 = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64__D__I__O(this, d, index);
});
$p.eY = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat32__F__I__O(this, d, index);
});
$p.em = (function(i, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt32__I__I__O(this, i, index);
});
$p.eZ = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.fe = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitUInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.fA = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64String__T__I__O(this, s, index);
});
$p.fc = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitChar__C__I__O(this, s, index);
});
$p.fb = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.fd = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.ej = (function() {
  return "expected boolean";
});
$p.bbM = (function(s, index) {
  var x = $dp_toString__T(s);
  return $m_sc_StringOps$().ba2(x, x);
});
$p.ha = (function() {
  return this.aKJ;
});
$p.eE = (function(index) {
  return true;
});
$p.eC = (function(index) {
  return false;
});
$p.cN = (function(s, index) {
  return this.bbM(s, index);
});
var $d_Lupickle_implicits_Readers$$anon$3 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$3, "upickle.implicits.Readers$$anon$3", ({
  Pr: 1,
  x: 1,
  D: 1,
  J: 1,
  K: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$9(outer) {
  this.aKP = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aKP = outer;
}
$p = $c_Lupickle_implicits_Readers$$anon$9.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$9;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$9() {
}
$h_Lupickle_implicits_Readers$$anon$9.prototype = $p;
$p.ge = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.gB = (function() {
  return this;
});
$p.c8 = (function(index) {
  return null;
});
$p.bQ = (function(length, jsonableKeys, index) {
  return $f_Lupickle_core_SimpleVisitor__visitObject__I__Z__I__Lupickle_core_ObjVisitor(this, length, jsonableKeys, index);
});
$p.cZ = (function(length, index) {
  return $f_Lupickle_core_SimpleVisitor__visitArray__I__I__Lupickle_core_ArrVisitor(this, length, index);
});
$p.fA = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64String__T__I__O(this, s, index);
});
$p.fb = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.fd = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.ej = (function() {
  return "expected string";
});
$p.bbx = (function(d, index) {
  var i = $doubleToInt(d);
  return ((d === Math.fround(i)) ? ("" + i) : ("" + d));
});
$p.bbz = (function(d, index) {
  var i = $doubleToInt(d);
  return ((d === i) ? ("" + i) : ("" + d));
});
$p.ha = (function() {
  return this.aKP;
});
$p.cN = (function(s, index) {
  return $dp_toString__T(s);
});
$p.em = (function(i, index) {
  return ("" + i);
});
$p.eZ = (function(i_$_lo, i_$_hi, index) {
  return $m_RTLong$().kY(i_$_lo, i_$_hi);
});
$p.fe = (function(i_$_lo, i_$_hi, index) {
  return $m_RTLong$().kY(i_$_lo, i_$_hi);
});
$p.eY = (function(d, index) {
  return this.bbx(d, index);
});
$p.e7 = (function(d, index) {
  return this.bbz(d, index);
});
$p.eD = (function(s, decIndex, expIndex, index) {
  return $dp_toString__T(s);
});
$p.eE = (function(index) {
  return "true";
});
$p.eC = (function(index) {
  return "false";
});
$p.fc = (function(s, index) {
  return ("" + $cToS(s));
});
var $d_Lupickle_implicits_Readers$$anon$9 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$9, "upickle.implicits.Readers$$anon$9", ({
  Px: 1,
  x: 1,
  D: 1,
  J: 1,
  K: 1
}));
function $f_Lupickle_implicits_Readers$NumericReader__visitFloat64String__T__I__O($thiz, s, index) {
  var $x_2 = $f_T__indexOf__I__I(s, 46);
  matchResult1: {
    var $x_1;
    var x1 = $f_T__indexOf__I__I(s, 69);
    if ((x1 === (-1))) {
      var $x_1 = $f_T__indexOf__I__I(s, 101);
      break matchResult1;
    }
    var $x_1 = x1;
  }
  return $thiz.eD(s, $x_2, $x_1, (-1));
}
/** @constructor */
function $c_Lupickle_implicits_Readers$SeqLikeReader(outer, r, factory) {
  this.aKU = null;
  this.aKT = null;
  this.aKS = null;
  this.aKU = r;
  this.aKT = factory;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aKS = outer;
}
$p = $c_Lupickle_implicits_Readers$SeqLikeReader.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$SeqLikeReader;
/** @constructor */
function $h_Lupickle_implicits_Readers$SeqLikeReader() {
}
$h_Lupickle_implicits_Readers$SeqLikeReader.prototype = $p;
$p.ge = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.gB = (function() {
  return this;
});
$p.c8 = (function(index) {
  return null;
});
$p.eE = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitTrue__I__O(this, index);
});
$p.eC = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitFalse__I__O(this, index);
});
$p.cN = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitString__jl_CharSequence__I__O(this, s, index);
});
$p.eD = (function(s, decIndex, expIndex, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64StringParts__jl_CharSequence__I__I__I__O(this, s, decIndex, expIndex, index);
});
$p.bQ = (function(length, jsonableKeys, index) {
  return $f_Lupickle_core_SimpleVisitor__visitObject__I__Z__I__Lupickle_core_ObjVisitor(this, length, jsonableKeys, index);
});
$p.e7 = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64__D__I__O(this, d, index);
});
$p.eY = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat32__F__I__O(this, d, index);
});
$p.em = (function(i, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt32__I__I__O(this, i, index);
});
$p.eZ = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.fe = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitUInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.fA = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64String__T__I__O(this, s, index);
});
$p.fc = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitChar__C__I__O(this, s, index);
});
$p.fb = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.fd = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.ej = (function() {
  return "expected sequence";
});
$p.cZ = (function(length, index) {
  return new $c_Lupickle_implicits_Readers$$anon$26(this);
});
$p.ha = (function() {
  return this.aKS;
});
var $d_Lupickle_implicits_Readers$SeqLikeReader = new $TypeData().i($c_Lupickle_implicits_Readers$SeqLikeReader, "upickle.implicits.Readers$SeqLikeReader", ({
  Pz: 1,
  x: 1,
  D: 1,
  J: 1,
  K: 1
}));
/** @constructor */
function $c_Lupickle_implicits_TupleReadWriters$TupleNReader(outer, readers, f) {
  this.Ik = null;
  this.aL4 = null;
  this.aL3 = null;
  this.Ik = readers;
  this.aL4 = f;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aL3 = outer;
}
$p = $c_Lupickle_implicits_TupleReadWriters$TupleNReader.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_TupleReadWriters$TupleNReader;
/** @constructor */
function $h_Lupickle_implicits_TupleReadWriters$TupleNReader() {
}
$h_Lupickle_implicits_TupleReadWriters$TupleNReader.prototype = $p;
$p.ge = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.gB = (function() {
  return this;
});
$p.c8 = (function(index) {
  return null;
});
$p.eE = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitTrue__I__O(this, index);
});
$p.eC = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitFalse__I__O(this, index);
});
$p.cN = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitString__jl_CharSequence__I__O(this, s, index);
});
$p.eD = (function(s, decIndex, expIndex, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64StringParts__jl_CharSequence__I__I__I__O(this, s, decIndex, expIndex, index);
});
$p.bQ = (function(length, jsonableKeys, index) {
  return $f_Lupickle_core_SimpleVisitor__visitObject__I__Z__I__Lupickle_core_ObjVisitor(this, length, jsonableKeys, index);
});
$p.e7 = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64__D__I__O(this, d, index);
});
$p.eY = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat32__F__I__O(this, d, index);
});
$p.em = (function(i, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt32__I__I__O(this, i, index);
});
$p.eZ = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.fe = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitUInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.fA = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64String__T__I__O(this, s, index);
});
$p.fc = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitChar__C__I__O(this, s, index);
});
$p.fb = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.fd = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.ej = (function() {
  return "expected sequence";
});
$p.cZ = (function(length, index) {
  return new $c_Lupickle_implicits_TupleReadWriters$$anon$1(this);
});
$p.ha = (function() {
  return this.aL3;
});
var $d_Lupickle_implicits_TupleReadWriters$TupleNReader = new $TypeData().i($c_Lupickle_implicits_TupleReadWriters$TupleNReader, "upickle.implicits.TupleReadWriters$TupleNReader", ({
  PF: 1,
  x: 1,
  D: 1,
  J: 1,
  K: 1
}));
function $f_Lcom_raquo_airstream_combine_CombineObservable__onInputsReady__Lcom_raquo_airstream_core_Transaction__V($thiz, transaction) {
  if ((!transaction.aZ4($thiz))) {
    transaction.b0E($thiz);
  }
}
function $f_Lcom_raquo_airstream_combine_CombineObservable__syncFire__Lcom_raquo_airstream_core_Transaction__V($thiz, transaction) {
  if ($thiz.aPk()) {
    $thiz.ik($thiz.a2V(), transaction);
  } else {
    console.warn("CombineObservable: inputs not ready when syncFire");
  }
}
function $f_Lcom_raquo_airstream_combine_CombineObservable__onStart__V($thiz) {
  var arr = $thiz.ahp();
  var i = 0;
  var len = (arr.length | 0);
  while ((i < len)) {
    var _$1 = arr[i];
    $f_Lcom_raquo_airstream_core_WritableObservable__addInternalObserver__Lcom_raquo_airstream_core_InternalObserver__Z__V(_$1.a5q, _$1, false);
    i = ((1 + i) | 0);
  }
  $thiz.aMK();
}
function $f_Lcom_raquo_airstream_combine_CombineObservable__onStop__V($thiz) {
  var arr = $thiz.ahp();
  var i = 0;
  var len = (arr.length | 0);
  while ((i < len)) {
    var _$2 = arr[i];
    $f_Lcom_raquo_airstream_core_BaseObservable__removeInternalObserver__Lcom_raquo_airstream_core_InternalObserver__V(_$2.a5q, _$2);
    i = ((1 + i) | 0);
  }
}
class $c_Lcom_raquo_airstream_core_AirstreamError$CombinedError extends $c_Lcom_raquo_airstream_core_AirstreamError {
  constructor(causes) {
    super();
    this.Qj = null;
    this.Qj = causes;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, $m_Lcom_raquo_airstream_core_AirstreamError$().aYz(causes), null, true, true);
    var this$3 = causes.dk($m_s_$less$colon$less$().b1).dt();
    if ((!this$3.c())) {
      this.a3L(this$3.d());
    }
  }
  H() {
    return new $c_s_Product$$anon$1(this);
  }
  x() {
    return $m_s_util_hashing_MurmurHash3$().eN(this, (-889275714), null);
  }
  e(x$0) {
    if ((this === x$0)) {
      return true;
    } else if ((x$0 instanceof $c_Lcom_raquo_airstream_core_AirstreamError$CombinedError)) {
      var x = this.Qj;
      var x$2 = x$0.Qj;
      return ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      return false;
    }
  }
  z() {
    return 1;
  }
  B() {
    return "CombinedError";
  }
  A(n) {
    if ((n === 0)) {
      return this.Qj;
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  D(n) {
    if ((n === 0)) {
      return "causes";
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  m() {
    return ("CombinedError: " + $f_sc_IterableOnceOps__mkString__T__T__T__T(this.Qj.dk($m_s_$less$colon$less$().b1).bM(), "", "; ", ""));
  }
}
function $isArrayOf_Lcom_raquo_airstream_core_AirstreamError$CombinedError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.e9)));
}
var $d_Lcom_raquo_airstream_core_AirstreamError$CombinedError = new $TypeData().i($c_Lcom_raquo_airstream_core_AirstreamError$CombinedError, "com.raquo.airstream.core.AirstreamError$CombinedError", ({
  e9: 1,
  bw: 1,
  y: 1,
  a: 1,
  b: 1,
  c: 1
}));
class $c_Lcom_raquo_airstream_core_AirstreamError$ErrorHandlingError extends $c_Lcom_raquo_airstream_core_AirstreamError {
  constructor(error, cause) {
    super();
    this.Ql = null;
    this.Qk = null;
    this.Ql = error;
    this.Qk = cause;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, ((("ErrorHandlingError: " + $m_Lcom_raquo_airstream_core_AirstreamError$().E1(error)) + "; cause: ") + $m_Lcom_raquo_airstream_core_AirstreamError$().E1(cause)), null, true, true);
    this.a3L(cause);
  }
  H() {
    return new $c_s_Product$$anon$1(this);
  }
  x() {
    return $m_s_util_hashing_MurmurHash3$().eN(this, (-889275714), null);
  }
  e(x$0) {
    if ((this === x$0)) {
      return true;
    } else if ((x$0 instanceof $c_Lcom_raquo_airstream_core_AirstreamError$ErrorHandlingError)) {
      var x = this.Ql;
      var x$2 = x$0.Ql;
      if (((x === null) ? (x$2 === null) : x.e(x$2))) {
        var x$3 = this.Qk;
        var x$4 = x$0.Qk;
        return ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  z() {
    return 2;
  }
  B() {
    return "ErrorHandlingError";
  }
  A(n) {
    if ((n === 0)) {
      return this.Ql;
    }
    if ((n === 1)) {
      return this.Qk;
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  D(n) {
    if ((n === 0)) {
      return "error";
    }
    if ((n === 1)) {
      return "cause";
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  m() {
    return ((("ErrorHandlingError: " + this.Ql) + "; cause: ") + this.Qk);
  }
}
function $isArrayOf_Lcom_raquo_airstream_core_AirstreamError$ErrorHandlingError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ea)));
}
var $d_Lcom_raquo_airstream_core_AirstreamError$ErrorHandlingError = new $TypeData().i($c_Lcom_raquo_airstream_core_AirstreamError$ErrorHandlingError, "com.raquo.airstream.core.AirstreamError$ErrorHandlingError", ({
  ea: 1,
  bw: 1,
  y: 1,
  a: 1,
  b: 1,
  c: 1
}));
class $c_Lcom_raquo_airstream_core_AirstreamError$ObserverError extends $c_Lcom_raquo_airstream_core_AirstreamError {
  constructor(error) {
    super();
    this.Qm = null;
    this.Qm = error;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, ("ObserverError: " + $m_Lcom_raquo_airstream_core_AirstreamError$().E1(error)), null, true, true);
  }
  H() {
    return new $c_s_Product$$anon$1(this);
  }
  x() {
    return $m_s_util_hashing_MurmurHash3$().eN(this, (-889275714), null);
  }
  e(x$0) {
    if ((this === x$0)) {
      return true;
    } else if ((x$0 instanceof $c_Lcom_raquo_airstream_core_AirstreamError$ObserverError)) {
      var x = this.Qm;
      var x$2 = x$0.Qm;
      return ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      return false;
    }
  }
  z() {
    return 1;
  }
  B() {
    return "ObserverError";
  }
  A(n) {
    if ((n === 0)) {
      return this.Qm;
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  D(n) {
    if ((n === 0)) {
      return "error";
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  m() {
    return ("ObserverError: " + this.Qm);
  }
}
function $isArrayOf_Lcom_raquo_airstream_core_AirstreamError$ObserverError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eb)));
}
var $d_Lcom_raquo_airstream_core_AirstreamError$ObserverError = new $TypeData().i($c_Lcom_raquo_airstream_core_AirstreamError$ObserverError, "com.raquo.airstream.core.AirstreamError$ObserverError", ({
  eb: 1,
  bw: 1,
  y: 1,
  a: 1,
  b: 1,
  c: 1
}));
class $c_Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError extends $c_Lcom_raquo_airstream_core_AirstreamError {
  constructor(error, cause) {
    super();
    this.Qo = null;
    this.Qn = null;
    this.Qo = error;
    this.Qn = cause;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, ((("ObserverErrorHandlingError: " + $m_Lcom_raquo_airstream_core_AirstreamError$().E1(error)) + "; cause: ") + $m_Lcom_raquo_airstream_core_AirstreamError$().E1(cause)), null, true, true);
    this.a3L(cause);
  }
  H() {
    return new $c_s_Product$$anon$1(this);
  }
  x() {
    return $m_s_util_hashing_MurmurHash3$().eN(this, (-889275714), null);
  }
  e(x$0) {
    if ((this === x$0)) {
      return true;
    } else if ((x$0 instanceof $c_Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError)) {
      var x = this.Qo;
      var x$2 = x$0.Qo;
      if (((x === null) ? (x$2 === null) : x.e(x$2))) {
        var x$3 = this.Qn;
        var x$4 = x$0.Qn;
        return ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  z() {
    return 2;
  }
  B() {
    return "ObserverErrorHandlingError";
  }
  A(n) {
    if ((n === 0)) {
      return this.Qo;
    }
    if ((n === 1)) {
      return this.Qn;
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  D(n) {
    if ((n === 0)) {
      return "error";
    }
    if ((n === 1)) {
      return "cause";
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  m() {
    return ((("ObserverErrorHandlingError: " + this.Qo) + "; cause: ") + this.Qn);
  }
}
function $isArrayOf_Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ec)));
}
var $d_Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError = new $TypeData().i($c_Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError, "com.raquo.airstream.core.AirstreamError$ObserverErrorHandlingError", ({
  ec: 1,
  bw: 1,
  y: 1,
  a: 1,
  b: 1,
  c: 1
}));
class $c_Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded extends $c_Lcom_raquo_airstream_core_AirstreamError {
  constructor(trx, depth) {
    super();
    this.JN = null;
    this.JM = 0;
    this.JN = trx;
    this.JM = depth;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, (((("Transaction depth exceeded maxDepth = " + depth) + ": Execution of ") + trx) + " aborted. See `Transaction.maxDepth`."), null, true, true);
  }
  H() {
    return new $c_s_Product$$anon$1(this);
  }
  x() {
    var acc = (-889275714);
    acc = $m_sr_Statics$().k(acc, $f_T__hashCode__I("TransactionDepthExceeded"));
    acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.JN));
    acc = $m_sr_Statics$().k(acc, this.JM);
    return $m_sr_Statics$().Z(acc, 2);
  }
  e(x$0) {
    if ((this === x$0)) {
      return true;
    } else if ((x$0 instanceof $c_Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded)) {
      if ((this.JM === x$0.JM)) {
        var x = this.JN;
        var x$2 = x$0.JN;
        return ((x === null) ? (x$2 === null) : (x === x$2));
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  z() {
    return 2;
  }
  B() {
    return "TransactionDepthExceeded";
  }
  A(n) {
    if ((n === 0)) {
      return this.JN;
    }
    if ((n === 1)) {
      return this.JM;
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  D(n) {
    if ((n === 0)) {
      return "trx";
    }
    if ((n === 1)) {
      return "depth";
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  m() {
    return ((("TransactionDepthExceeded: " + this.JN) + "; maxDepth: ") + this.JM);
  }
}
function $isArrayOf_Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ed)));
}
var $d_Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded = new $TypeData().i($c_Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded, "com.raquo.airstream.core.AirstreamError$TransactionDepthExceeded", ({
  ed: 1,
  bw: 1,
  y: 1,
  a: 1,
  b: 1,
  c: 1
}));
class $c_Lcom_raquo_airstream_core_AirstreamError$VarError extends $c_Lcom_raquo_airstream_core_AirstreamError {
  constructor(message, cause) {
    super();
    this.Qq = null;
    this.Qp = null;
    this.Qq = message;
    this.Qp = cause;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, $m_Lcom_raquo_airstream_core_AirstreamError$().aYA(message, cause), null, true, true);
    if ((!cause.c())) {
      this.a3L(cause.d());
    }
  }
  H() {
    return new $c_s_Product$$anon$1(this);
  }
  x() {
    return $m_s_util_hashing_MurmurHash3$().eN(this, (-889275714), null);
  }
  e(x$0) {
    if ((this === x$0)) {
      return true;
    } else if ((x$0 instanceof $c_Lcom_raquo_airstream_core_AirstreamError$VarError)) {
      if ((this.Qq === x$0.Qq)) {
        var x = this.Qp;
        var x$2 = x$0.Qp;
        return ((x === null) ? (x$2 === null) : x.e(x$2));
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  z() {
    return 2;
  }
  B() {
    return "VarError";
  }
  A(n) {
    if ((n === 0)) {
      return this.Qq;
    }
    if ((n === 1)) {
      return this.Qp;
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  D(n) {
    if ((n === 0)) {
      return "message";
    }
    if ((n === 1)) {
      return "cause";
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  m() {
    return ((("VarError: " + this.Qq) + "; cause: ") + this.Qp);
  }
}
function $isArrayOf_Lcom_raquo_airstream_core_AirstreamError$VarError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ee)));
}
var $d_Lcom_raquo_airstream_core_AirstreamError$VarError = new $TypeData().i($c_Lcom_raquo_airstream_core_AirstreamError$VarError, "com.raquo.airstream.core.AirstreamError$VarError", ({
  ee: 1,
  bw: 1,
  y: 1,
  a: 1,
  b: 1,
  c: 1
}));
function $f_Lcom_raquo_airstream_core_EventStream__dropWhile__F1__Z__Lcom_raquo_airstream_core_EventStream($thiz, passes, resetOnStop) {
  return new $c_Lcom_raquo_airstream_misc_DropStream($thiz, passes, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => (void 0))), resetOnStop);
}
function $f_Lcom_raquo_airstream_core_EventStream__scanLeft__O__F2__Lcom_raquo_airstream_core_Signal($thiz, initial, fn) {
  return $f_Lcom_raquo_airstream_core_EventStream__scanLeftRecover__s_util_Try__F2__Lcom_raquo_airstream_core_Signal($thiz, new $c_s_util_Success(initial), new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((currentValue, nextParentValue) => {
    try {
      return new $c_s_util_Success(fn.R(currentValue.d(), nextParentValue.d()));
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      if ($m_s_util_control_NonFatal$().ew(e$2)) {
        return new $c_s_util_Failure(e$2);
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
    }
  })));
}
function $f_Lcom_raquo_airstream_core_EventStream__scanLeftRecover__s_util_Try__F2__Lcom_raquo_airstream_core_Signal($thiz, initial, fn) {
  return new $c_Lcom_raquo_airstream_misc_ScanLeftSignal($thiz, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => initial)), fn);
}
function $f_Lcom_raquo_airstream_core_EventStream__toSignal__F0__Z__Lcom_raquo_airstream_core_Signal($thiz, initial, cacheInitialValue) {
  return new $c_Lcom_raquo_airstream_misc_SignalFromStream($thiz, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => new $c_s_util_Success(initial.a3()))), cacheInitialValue);
}
var $d_Lcom_raquo_airstream_core_EventStream = new $TypeData().i(1, "com.raquo.airstream.core.EventStream", ({
  am: 1,
  P: 1,
  O: 1,
  U: 1,
  V: 1,
  al: 1
}));
function $f_Lcom_raquo_airstream_core_Signal__scanLeft__F1__F2__Lcom_raquo_airstream_core_Signal($thiz, makeInitial, fn) {
  return $f_Lcom_raquo_airstream_core_Signal__scanLeftRecover__F1__F2__Lcom_raquo_airstream_core_Signal($thiz, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((parentInitial) => parentInitial.ua(makeInitial))), new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((currentValue, nextParentValue) => {
    try {
      return new $c_s_util_Success(fn.R(currentValue.d(), nextParentValue.d()));
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      if ($m_s_util_control_NonFatal$().ew(e$2)) {
        return new $c_s_util_Failure(e$2);
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
    }
  })));
}
function $f_Lcom_raquo_airstream_core_Signal__scanLeftRecover__F1__F2__Lcom_raquo_airstream_core_Signal($thiz, makeInitial, fn) {
  return new $c_Lcom_raquo_airstream_misc_ScanLeftSignal($thiz, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => makeInitial.i($thiz.aq()))), fn);
}
function $f_Lcom_raquo_airstream_core_Signal__onStart__V($thiz) {
  $thiz.aq();
}
function $is_Lcom_raquo_airstream_core_Signal(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.aD)));
}
function $isArrayOf_Lcom_raquo_airstream_core_Signal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.aD)));
}
var $d_Lcom_raquo_airstream_core_Signal = new $TypeData().i(1, "com.raquo.airstream.core.Signal", ({
  aD: 1,
  P: 1,
  O: 1,
  U: 1,
  V: 1,
  aB: 1
}));
function $f_Lcom_raquo_airstream_custom_CustomSource__$init$__V($thiz) {
  $thiz.ajn = 1;
  $thiz.Yo = 0;
}
function $f_Lcom_raquo_airstream_custom_CustomSource__onWillStart__V($thiz) {
  $thiz.Yo = ((1 + $thiz.Yo) | 0);
  $thiz.Yn.a5y.a3();
}
function $f_Lcom_raquo_airstream_custom_CustomSource__onStart__V($thiz) {
  try {
    var $x_1 = new $c_s_util_Success(($thiz.Yn.a5w.a3(), (void 0)));
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    matchEnd8: {
      var $x_1;
      if ($m_s_util_control_NonFatal$().ew(e$2)) {
        var $x_1 = new $c_s_util_Failure(e$2);
        break matchEnd8;
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
    }
  }
  $x_1.ahx(new $c_Lcom_raquo_airstream_custom_CustomSource$$anon$1($thiz));
}
function $f_Lcom_raquo_airstream_custom_CustomSource__onStop__V($thiz) {
  $thiz.Yn.a5x.a3();
}
/** @constructor */
function $c_Lcom_raquo_airstream_state_LazyDerivedVar(parent, signal, zoomOut, displayNameSuffix) {
  this.alo = null;
  this.a5X = null;
  this.QE = null;
  this.YK = null;
  this.alp = null;
  this.aln = null;
  this.QE = parent;
  this.YK = signal;
  this.alp = zoomOut;
  this.aln = displayNameSuffix;
  this.alo = (void 0);
  $f_Lcom_raquo_airstream_state_Var__$init$__V(this);
}
$p = $c_Lcom_raquo_airstream_state_LazyDerivedVar.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_state_LazyDerivedVar;
/** @constructor */
function $h_Lcom_raquo_airstream_state_LazyDerivedVar() {
}
$h_Lcom_raquo_airstream_state_LazyDerivedVar.prototype = $p;
$p.fx = (function() {
  return this.alo;
});
$p.m = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.jA = (function() {
  return this.a5X;
});
$p.af2 = (function(x$0) {
  this.a5X = x$0;
});
$p.dP = (function() {
  return this.YK;
});
$p.Ek = (function() {
  return this.a5X;
});
$p.P = (function() {
  return this.YK;
});
$p.Ya = (function() {
  return this.QE.Ya();
});
$p.Eh = (function(value, transaction) {
  var x1 = this.QE.P().aq();
  if ((x1 instanceof $c_s_util_Success)) {
    var parentValue = x1.fM;
    var nextValue = value.ua(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => this.alp.R(parentValue, _$1))));
    this.QE.Eh(nextValue, transaction);
    return (void 0);
  }
  if ((x1 instanceof $c_s_util_Failure)) {
    var err = x1.le;
    $m_Lcom_raquo_airstream_core_AirstreamError$().rc(new $c_Lcom_raquo_airstream_core_AirstreamError$VarError("Unable to zoom out of lazy derived var when the parent var is failed.", new $c_s_Some(err)));
    return (void 0);
  }
  throw new $c_s_MatchError(x1);
});
$p.eU = (function() {
  return (("" + $f_Lcom_raquo_airstream_core_Named__displayName__T(this.QE)) + this.aln);
});
$p.dM = (function() {
  return this.YK;
});
var $d_Lcom_raquo_airstream_state_LazyDerivedVar = new $TypeData().i($c_Lcom_raquo_airstream_state_LazyDerivedVar, "com.raquo.airstream.state.LazyDerivedVar", ({
  oB: 1,
  P: 1,
  aB: 1,
  b7: 1,
  O: 1,
  d5: 1
}));
/** @constructor */
function $c_Lcom_raquo_airstream_state_LazyDerivedVar2(parent, signal, updateParent, displayNameSuffix) {
  this.alr = null;
  this.a5Y = null;
  this.QF = null;
  this.YL = null;
  this.als = null;
  this.alq = null;
  this.QF = parent;
  this.YL = signal;
  this.als = updateParent;
  this.alq = displayNameSuffix;
  this.alr = (void 0);
  $f_Lcom_raquo_airstream_state_Var__$init$__V(this);
}
$p = $c_Lcom_raquo_airstream_state_LazyDerivedVar2.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_state_LazyDerivedVar2;
/** @constructor */
function $h_Lcom_raquo_airstream_state_LazyDerivedVar2() {
}
$h_Lcom_raquo_airstream_state_LazyDerivedVar2.prototype = $p;
$p.fx = (function() {
  return this.alr;
});
$p.m = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.jA = (function() {
  return this.a5Y;
});
$p.af2 = (function(x$0) {
  this.a5Y = x$0;
});
$p.dP = (function() {
  return this.YL;
});
$p.Ek = (function() {
  return this.a5Y;
});
$p.P = (function() {
  return this.YL;
});
$p.Ya = (function() {
  return this.QF.Ya();
});
$p.Eh = (function(value, transaction) {
  matchResult1: {
    var maybeNextValue;
    try {
      var x1 = new $c_s_util_Success(this.als.R(this.QF.P().aq(), value));
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      matchEnd8: {
        var x1;
        if ($m_s_util_control_NonFatal$().ew(e$2)) {
          var x1 = new $c_s_util_Failure(e$2);
          break matchEnd8;
        }
        throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
      }
    }
    if ((x1 instanceof $c_s_util_Success)) {
      var maybeNextValue = x1.fM;
      break matchResult1;
    }
    if ((x1 instanceof $c_s_util_Failure)) {
      var maybeNextValue = new $c_s_Some(new $c_s_util_Failure(x1.le));
      break matchResult1;
    }
    throw new $c_s_MatchError(x1);
  }
  if ((!maybeNextValue.c())) {
    var x0 = maybeNextValue.d();
    this.QF.Eh(x0, transaction);
  }
});
$p.eU = (function() {
  return (("" + $f_Lcom_raquo_airstream_core_Named__displayName__T(this.QF)) + this.alq);
});
$p.dM = (function() {
  return this.YL;
});
var $d_Lcom_raquo_airstream_state_LazyDerivedVar2 = new $TypeData().i($c_Lcom_raquo_airstream_state_LazyDerivedVar2, "com.raquo.airstream.state.LazyDerivedVar2", ({
  oC: 1,
  P: 1,
  aB: 1,
  b7: 1,
  O: 1,
  d5: 1
}));
/** @constructor */
function $c_Lcom_raquo_airstream_state_SourceVar(initial) {
  this.alw = null;
  this.a61 = null;
  this.a60 = null;
  this.a5Z = null;
  this.QG = null;
  this.alw = (void 0);
  $f_Lcom_raquo_airstream_state_Var__$init$__V(this);
  this.a60 = initial;
  this.a5Z = new $c_Lcom_raquo_airstream_state_VarSignal(this.a60, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $f_Lcom_raquo_airstream_core_Named__displayName__T(this))));
  this.QG = this.a5Z;
}
$p = $c_Lcom_raquo_airstream_state_SourceVar.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_state_SourceVar;
/** @constructor */
function $h_Lcom_raquo_airstream_state_SourceVar() {
}
$h_Lcom_raquo_airstream_state_SourceVar.prototype = $p;
$p.fx = (function() {
  return this.alw;
});
$p.eU = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$p.m = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.jA = (function() {
  return this.a61;
});
$p.af2 = (function(x$0) {
  this.a61 = x$0;
});
$p.dP = (function() {
  return this.QG;
});
$p.Ek = (function() {
  return this.a61;
});
$p.Ya = (function() {
  return this;
});
$p.Eh = (function(value, transaction) {
  this.a60 = value;
  $f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this.a5Z, value, transaction);
});
$p.P = (function() {
  return this.QG;
});
$p.dM = (function() {
  return this.QG;
});
var $d_Lcom_raquo_airstream_state_SourceVar = new $TypeData().i($c_Lcom_raquo_airstream_state_SourceVar, "com.raquo.airstream.state.SourceVar", ({
  oG: 1,
  P: 1,
  aB: 1,
  b7: 1,
  O: 1,
  d5: 1
}));
function $p_Lcom_raquo_laminar_nodes_ReactiveHtmlElement__appendValueController__Lcom_raquo_laminar_inputs_InputController__V($thiz, controller) {
  var x = $thiz.QS;
  if ((x === (void 0))) {
    $thiz.QS = $m_sjs_js_defined$().Wd($m_Lcom_raquo_ew_JsArray$().fu($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_laminar_inputs_InputController.r().C)([controller]))));
  } else {
    (x.push(controller) | 0);
  }
}
function $p_Lcom_raquo_laminar_nodes_ReactiveHtmlElement__appendControllablePropBinder__T__V($thiz, propDomName) {
  var x = $thiz.YX;
  if ((x === (void 0))) {
    $thiz.YX = $m_sjs_js_defined$().Wd($m_Lcom_raquo_ew_JsArray$().fu($m_sr_ScalaRunTime$().f(new ($d_T.r().C)([propDomName]))));
  } else {
    (x.push(propDomName) | 0);
  }
}
function $p_Lcom_raquo_laminar_nodes_ReactiveHtmlElement__hasController__T__Z($thiz, propDomName) {
  var x = $thiz.QS;
  if ((x !== (void 0))) {
    _return: {
      var len = (x.length | 0);
      var i = 0;
      while ((i < len)) {
        if ((x[i].oF() === propDomName)) {
          var $x_1 = i;
          break _return;
        }
        i = ((1 + i) | 0);
      }
      var $x_1 = (-1);
    }
    return ($x_1 >= 0);
  } else {
    return false;
  }
}
/** @constructor */
function $c_Lcom_raquo_laminar_nodes_ReactiveHtmlElement(tag, ref) {
  this.a6I = null;
  this.YY = null;
  this.arH = null;
  this.YW = null;
  this.arG = null;
  this.QT = null;
  this.en = null;
  this.QS = null;
  this.YX = null;
  this.QT = tag;
  this.en = ref;
  this.a6I = $m_s_None$();
  $f_Lcom_raquo_laminar_nodes_ParentNode__$init$__V(this);
  $f_Lcom_raquo_laminar_nodes_ReactiveElement__$init$__V(this);
  this.QS = (void 0);
  this.YX = (void 0);
}
$p = $c_Lcom_raquo_laminar_nodes_ReactiveHtmlElement.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_nodes_ReactiveHtmlElement;
/** @constructor */
function $h_Lcom_raquo_laminar_nodes_ReactiveHtmlElement() {
}
$h_Lcom_raquo_laminar_nodes_ReactiveHtmlElement.prototype = $p;
$p.P7 = (function() {
  return this.a6I;
});
$p.aMM = (function(x$1) {
  this.a6I = x$1;
});
$p.kL = (function(parentNode) {
  $m_Lcom_raquo_laminar_nodes_ParentNode$().DF(parentNode, this, (void 0));
});
$p.kq = (function() {
  return this.YY;
});
$p.af3 = (function(x$0) {
  this.YY = x$0;
});
$p.af6 = (function() {
  return this.arH;
});
$p.P8 = (function() {
  return this.YW;
});
$p.Wt = (function() {
  return this.arG;
});
$p.af5 = (function(x$1) {
  this.YW = x$1;
});
$p.af4 = (function(x$1) {
  this.arG = x$1;
});
$p.aMN = (function(x$0) {
  this.arH = x$0;
});
$p.Ep = (function(maybeNextParent) {
  $f_Lcom_raquo_laminar_nodes_ReactiveElement__willSetParent__s_Option__V(this, maybeNextParent);
});
$p.Ei = (function(maybeNextParent) {
  $f_Lcom_raquo_laminar_nodes_ReactiveElement__setParent__s_Option__V(this, maybeNextParent);
});
$p.b2p = (function(domPropName) {
  var x = this.YX;
  return ((x !== (void 0)) && $m_Lcom_raquo_ew_JsArray$RichJsArray$().agu(x, domPropName, 0));
});
$p.b2r = (function(thisController) {
  var x = this.QS;
  if ((x !== (void 0))) {
    _return: {
      var len = (x.length | 0);
      var i = 0;
      while ((i < len)) {
        var x0 = x[i];
        if (((x0.oF() === thisController.oF()) && (!((x0 === null) ? (thisController === null) : (x0 === thisController))))) {
          var $x_1 = i;
          break _return;
        }
        i = ((1 + i) | 0);
      }
      var $x_1 = (-1);
    }
    return ($x_1 >= 0);
  } else {
    return false;
  }
});
$p.aY0 = (function(controller) {
  var dynSub = controller.aXZ();
  $p_Lcom_raquo_laminar_nodes_ReactiveHtmlElement__appendValueController__Lcom_raquo_laminar_inputs_InputController__V(this, controller);
  return dynSub;
});
$p.aN0 = (function() {
  if ($m_Lcom_raquo_laminar_DomApi$().J4(this.en)) {
    var x1 = this.QT;
    if (false) {
      return x1.bd3();
    }
    return (void 0);
  } else {
    return $m_Lcom_raquo_laminar_inputs_InputController$().ark;
  }
});
$p.b35 = (function(propDomName) {
  var x = this.aN0();
  return ((x !== (void 0)) && $m_Lcom_raquo_ew_JsArray$RichJsArray$().agu(x, propDomName, 0));
});
$p.aQF = (function(key) {
  if ((key instanceof $c_Lcom_raquo_laminar_keys_HtmlProp)) {
    if (this.b35(key.oK)) {
      if ($p_Lcom_raquo_laminar_nodes_ReactiveHtmlElement__hasController__T__Z(this, key.oK)) {
        throw $ct_jl_Exception__T__(new $c_jl_Exception(), (((((("Can not add uncontrolled `" + key.oK) + " <-- ???` to element `") + $m_Lcom_raquo_laminar_DomApi$().afg(this.en)) + "` that already has an input controller for `") + key.oK) + "` property."));
      } else {
        $p_Lcom_raquo_laminar_nodes_ReactiveHtmlElement__appendControllablePropBinder__T__V(this, key.oK);
      }
    }
  }
});
$p.m = (function() {
  return (("ReactiveHtmlElement(" + ((this.en !== null) ? this.en.outerHTML : ("tag=" + this.QT.Z0))) + ")");
});
$p.ed = (function() {
  return this.en;
});
var $d_Lcom_raquo_laminar_nodes_ReactiveHtmlElement = new $TypeData().i($c_Lcom_raquo_laminar_nodes_ReactiveHtmlElement, "com.raquo.laminar.nodes.ReactiveHtmlElement", ({
  qo: 1,
  bM: 1,
  ar: 1,
  cg: 1,
  da: 1,
  eq: 1
}));
/** @constructor */
function $c_Lcom_raquo_laminar_nodes_ReactiveSvgElement(tag, ref) {
  this.a6J = null;
  this.arL = null;
  this.arK = null;
  this.arJ = null;
  this.arI = null;
  this.arM = null;
  this.e8 = null;
  this.arM = tag;
  this.e8 = ref;
  this.a6J = $m_s_None$();
  $f_Lcom_raquo_laminar_nodes_ParentNode__$init$__V(this);
  $f_Lcom_raquo_laminar_nodes_ReactiveElement__$init$__V(this);
}
$p = $c_Lcom_raquo_laminar_nodes_ReactiveSvgElement.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_nodes_ReactiveSvgElement;
/** @constructor */
function $h_Lcom_raquo_laminar_nodes_ReactiveSvgElement() {
}
$h_Lcom_raquo_laminar_nodes_ReactiveSvgElement.prototype = $p;
$p.P7 = (function() {
  return this.a6J;
});
$p.aMM = (function(x$1) {
  this.a6J = x$1;
});
$p.kL = (function(parentNode) {
  $m_Lcom_raquo_laminar_nodes_ParentNode$().DF(parentNode, this, (void 0));
});
$p.kq = (function() {
  return this.arL;
});
$p.af3 = (function(x$0) {
  this.arL = x$0;
});
$p.af6 = (function() {
  return this.arK;
});
$p.P8 = (function() {
  return this.arJ;
});
$p.Wt = (function() {
  return this.arI;
});
$p.af5 = (function(x$1) {
  this.arJ = x$1;
});
$p.af4 = (function(x$1) {
  this.arI = x$1;
});
$p.aMN = (function(x$0) {
  this.arK = x$0;
});
$p.Ep = (function(maybeNextParent) {
  $f_Lcom_raquo_laminar_nodes_ReactiveElement__willSetParent__s_Option__V(this, maybeNextParent);
});
$p.Ei = (function(maybeNextParent) {
  $f_Lcom_raquo_laminar_nodes_ReactiveElement__setParent__s_Option__V(this, maybeNextParent);
});
$p.aQF = (function(key) {
});
$p.m = (function() {
  return (("ReactiveSvgElement(" + ((this.e8 !== null) ? this.e8.outerHTML : ("tag=" + this.arM.Z1))) + ")");
});
$p.ed = (function() {
  return this.e8;
});
function $isArrayOf_Lcom_raquo_laminar_nodes_ReactiveSvgElement(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.er)));
}
var $d_Lcom_raquo_laminar_nodes_ReactiveSvgElement = new $TypeData().i($c_Lcom_raquo_laminar_nodes_ReactiveSvgElement, "com.raquo.laminar.nodes.ReactiveSvgElement", ({
  er: 1,
  bM: 1,
  ar: 1,
  cg: 1,
  da: 1,
  eq: 1
}));
/** @constructor */
function $c_Lfansi_EscapeAttr(escape, resetMask_$_lo, resetMask_$_hi, applyMask_$_lo, applyMask_$_hi, sourceName) {
  this.JX = null;
  this.OD = 0;
  this.OE = 0;
  this.OB = 0;
  this.OC = 0;
  this.asr = null;
  this.ass = null;
  this.JX = escape;
  this.OD = resetMask_$_lo;
  this.OE = resetMask_$_hi;
  this.OB = applyMask_$_lo;
  this.OC = applyMask_$_hi;
  this.asr = new $c_s_Some(escape);
  this.ass = sourceName.aE;
}
$p = $c_Lfansi_EscapeAttr.prototype = new $h_O();
$p.constructor = $c_Lfansi_EscapeAttr;
/** @constructor */
function $h_Lfansi_EscapeAttr() {
}
$h_Lfansi_EscapeAttr.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, $f_T__hashCode__I("EscapeAttr"));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.JX));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().jt(this.OD, this.OE));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().jt(this.OB, this.OC));
  return $m_sr_Statics$().Z(acc, 3);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfansi_EscapeAttr)) {
    var x_$_lo = this.OD;
    var x_$_hi = this.OE;
    var $x_2 = x$0;
    var x$1_$_lo = $x_2.OD;
    var x$1_$_hi = $x_2.OE;
    if ((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0)) {
      var x$2_$_lo = this.OB;
      var x$2_$_hi = this.OC;
      var $x_3 = x$0;
      var x$3_$_lo = $x_3.OB;
      var x$3_$_hi = $x_3.OC;
      var $x_1 = (((x$2_$_lo ^ x$3_$_lo) | (x$2_$_hi ^ x$3_$_hi)) === 0);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return (this.JX === x$0.JX);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.z = (function() {
  return 3;
});
$p.B = (function() {
  return "EscapeAttr";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.JX;
      break;
    }
    case 1: {
      return $bL(this.OD, this.OE);
      break;
    }
    case 2: {
      return $bL(this.OB, this.OC);
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "escape";
      break;
    }
    case 1: {
      return "resetMask";
      break;
    }
    case 2: {
      return "applyMask";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.XT = (function() {
  return $bL(this.OD, this.OE);
});
$p.OY = (function() {
  return $bL(this.OB, this.OC);
});
$p.afy = (function() {
  return this.asr;
});
$p.m = (function() {
  return ((("" + this.JX) + this.ass) + "\u001b[0m");
});
function $isArrayOf_Lfansi_EscapeAttr(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ew)));
}
var $d_Lfansi_EscapeAttr = new $TypeData().i($c_Lfansi_EscapeAttr, "fansi.EscapeAttr", ({
  ew: 1,
  ch: 1,
  bN: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lfansi_ResetAttr(resetMask_$_lo, resetMask_$_hi, applyMask_$_lo, applyMask_$_hi, sourceName) {
  this.OH = 0;
  this.OI = 0;
  this.OF = 0;
  this.OG = 0;
  this.ast = null;
  this.asu = null;
  this.OH = resetMask_$_lo;
  this.OI = resetMask_$_hi;
  this.OF = applyMask_$_lo;
  this.OG = applyMask_$_hi;
  this.ast = $m_s_None$();
  this.asu = sourceName.aE;
}
$p = $c_Lfansi_ResetAttr.prototype = new $h_O();
$p.constructor = $c_Lfansi_ResetAttr;
/** @constructor */
function $h_Lfansi_ResetAttr() {
}
$h_Lfansi_ResetAttr.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, $f_T__hashCode__I("ResetAttr"));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().jt(this.OH, this.OI));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().jt(this.OF, this.OG));
  return $m_sr_Statics$().Z(acc, 2);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfansi_ResetAttr)) {
    var x_$_lo = this.OH;
    var x_$_hi = this.OI;
    var $x_1 = x$0;
    var x$1_$_lo = $x_1.OH;
    var x$1_$_hi = $x_1.OI;
    if ((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0)) {
      var x$2_$_lo = this.OF;
      var x$2_$_hi = this.OG;
      var $x_2 = x$0;
      var x$3_$_lo = $x_2.OF;
      var x$3_$_hi = $x_2.OG;
      return (((x$2_$_lo ^ x$3_$_lo) | (x$2_$_hi ^ x$3_$_hi)) === 0);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "ResetAttr";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return $bL(this.OH, this.OI);
  }
  if ((n === 1)) {
    return $bL(this.OF, this.OG);
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "resetMask";
  }
  if ((n === 1)) {
    return "applyMask";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.XT = (function() {
  return $bL(this.OH, this.OI);
});
$p.OY = (function() {
  return $bL(this.OF, this.OG);
});
$p.afy = (function() {
  return this.ast;
});
$p.m = (function() {
  return this.asu;
});
function $isArrayOf_Lfansi_ResetAttr(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ex)));
}
var $d_Lfansi_ResetAttr = new $TypeData().i($c_Lfansi_ResetAttr, "fansi.ResetAttr", ({
  ex: 1,
  ch: 1,
  bN: 1,
  b: 1,
  c: 1,
  a: 1
}));
function $p_Lfastparse_IndexedParserInput__lineNumberLookup__AI($thiz) {
  if ((!$thiz.asQ)) {
    $thiz.asP = $m_Lfastparse_internal_Util$().b45($thiz.cA);
    $thiz.asQ = true;
  }
  return $thiz.asP;
}
/** @constructor */
function $c_Lfastparse_IndexedParserInput(data) {
  this.cA = null;
  this.asP = null;
  this.asQ = false;
  this.cA = data;
}
$p = $c_Lfastparse_IndexedParserInput.prototype = new $h_Lfastparse_ParserInput();
$p.constructor = $c_Lfastparse_IndexedParserInput;
/** @constructor */
function $h_Lfastparse_IndexedParserInput() {
}
$h_Lfastparse_IndexedParserInput.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().eN(this, (-889275714), null);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lfastparse_IndexedParserInput) && (this.cA === x$0.cA)));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "IndexedParserInput";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.cA;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "data";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.PV = (function(from, until) {
  return $m_sc_StringOps$().a4J(this.cA, from, until);
});
$p.bc = (function(index) {
  return (index < this.cA.length);
});
$p.aR7 = (function(index) {
  matchResult7: {
    var line;
    var xs = $p_Lfastparse_IndexedParserInput__lineNumberLookup__AI(this);
    _return: {
      var i = 0;
      while ((i < xs.a.length)) {
        var x1 = i;
        if ((xs.a[x1] > index)) {
          var x9 = i;
          break _return;
        }
        i = ((1 + i) | 0);
      }
      var x9 = (-1);
    }
    if ((x9 === (-1))) {
      var line = (($p_Lfastparse_IndexedParserInput__lineNumberLookup__AI(this).a.length - 1) | 0);
      break matchResult7;
    }
    var y = ((x9 - 1) | 0);
    var line = ((y < 0) ? 0 : y);
  }
  var col = ((index - $p_Lfastparse_IndexedParserInput__lineNumberLookup__AI(this).a[line]) | 0);
  return ((((1 + line) | 0) + ":") + ((1 + col) | 0));
});
function $isArrayOf_Lfastparse_IndexedParserInput(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eB)));
}
var $d_Lfastparse_IndexedParserInput = new $TypeData().i($c_Lfastparse_IndexedParserInput, "fastparse.IndexedParserInput", ({
  eB: 1,
  r8: 1,
  r2: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Ljava_io_StringWriter() {
  this.Z8 = null;
  $ct_Ljava_io_Writer__(this);
  this.Z8 = $ct_jl_StringBuffer__(new $c_jl_StringBuffer());
}
$p = $c_Ljava_io_StringWriter.prototype = new $h_Ljava_io_Writer();
$p.constructor = $c_Ljava_io_StringWriter;
/** @constructor */
function $h_Ljava_io_StringWriter() {
}
$h_Ljava_io_StringWriter.prototype = $p;
$p.bc6 = (function(cbuf, off, len) {
  this.Z8.aX1(cbuf, off, len);
});
$p.aWZ = (function(csq) {
  this.Z8.aLY(csq);
  return this;
});
$p.m = (function() {
  return this.Z8.m();
});
$p.W9 = (function(csq) {
  return this.aWZ(csq);
});
var $d_Ljava_io_StringWriter = new $TypeData().i($c_Ljava_io_StringWriter, "java.io.StringWriter", ({
  rT: 1,
  rU: 1,
  bz: 1,
  ci: 1,
  ck: 1,
  cj: 1
}));
function $ct_jl_ArrayIndexOutOfBoundsException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
function $ct_jl_ArrayIndexOutOfBoundsException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz;
}
class $c_jl_ArrayIndexOutOfBoundsException extends $c_jl_IndexOutOfBoundsException {
}
var $d_jl_ArrayIndexOutOfBoundsException = new $TypeData().i($c_jl_ArrayIndexOutOfBoundsException, "java.lang.ArrayIndexOutOfBoundsException", ({
  rV: 1,
  eQ: 1,
  R: 1,
  G: 1,
  y: 1,
  a: 1
}));
function $f_jl_Double__equals__O__Z($thiz, that) {
  return Object.is($thiz, that);
}
function $f_jl_Double__hashCode__I($thiz) {
  var valueInt = ($thiz | 0);
  if (((valueInt === $thiz) && ((1.0 / $thiz) !== (-Infinity)))) {
    return valueInt;
  } else if (($thiz !== $thiz)) {
    return 2146959360;
  } else {
    var fpBitsDataView = $fpBitsDataView;
    fpBitsDataView.setFloat64(0, $thiz, true);
    return ((fpBitsDataView.getInt32(0, true) | 0) ^ (fpBitsDataView.getInt32(4, true) | 0));
  }
}
function $f_jl_Double__toString__T($thiz) {
  return ("" + $thiz);
}
function $f_jl_Double__compareTo__O__I($thiz, o) {
  return $m_jl_Double$().P9($thiz, o);
}
function $isArrayOf_jl_Double(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eN)));
}
var $d_jl_Double = new $TypeData().i(0, "java.lang.Double", ({
  eN: 1,
  aP: 1,
  a: 1,
  Q: 1,
  aY: 1,
  bP: 1
}), ((x) => ((typeof x) === "number")));
function $f_jl_Float__equals__O__Z($thiz, that) {
  return Object.is($thiz, that);
}
function $f_jl_Float__hashCode__I($thiz) {
  var value = $thiz;
  var valueInt = (value | 0);
  if (((valueInt === value) && ((1.0 / value) !== (-Infinity)))) {
    return valueInt;
  } else if ((value !== value)) {
    return 2146959360;
  } else {
    var fpBitsDataView = $fpBitsDataView;
    fpBitsDataView.setFloat64(0, value, true);
    return ((fpBitsDataView.getInt32(0, true) | 0) ^ (fpBitsDataView.getInt32(4, true) | 0));
  }
}
function $f_jl_Float__toString__T($thiz) {
  return ("" + $thiz);
}
function $f_jl_Float__compareTo__O__I($thiz, o) {
  return $m_jl_Double$().P9($thiz, o);
}
function $isArrayOf_jl_Float(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eO)));
}
var $d_jl_Float = new $TypeData().i(0, "java.lang.Float", ({
  eO: 1,
  aP: 1,
  a: 1,
  Q: 1,
  aY: 1,
  bP: 1
}), ((x) => $isFloat(x)));
function $f_jl_Integer__equals__O__Z($thiz, that) {
  return Object.is($thiz, that);
}
function $f_jl_Integer__hashCode__I($thiz) {
  return $thiz;
}
function $f_jl_Integer__toString__T($thiz) {
  return ("" + $thiz);
}
function $f_jl_Integer__compareTo__O__I($thiz, o) {
  return (($thiz === o) ? 0 : (($thiz < o) ? (-1) : 1));
}
function $isArrayOf_jl_Integer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eR)));
}
var $d_jl_Integer = new $TypeData().i(0, "java.lang.Integer", ({
  eR: 1,
  aP: 1,
  a: 1,
  Q: 1,
  aY: 1,
  bP: 1
}), ((x) => $isInt(x)));
function $f_jl_Long__equals__O__Z($thiz, $thizhi, that) {
  if ((that instanceof $Long)) {
    var $x_1 = that;
    var this$1_$_lo = $x_1.l;
    var this$1_$_hi = $x_1.h;
    return ((($thiz ^ this$1_$_lo) | ($thizhi ^ this$1_$_hi)) === 0);
  } else {
    return false;
  }
}
function $f_jl_Long__hashCode__I($thiz, $thizhi) {
  return ($thiz ^ $thizhi);
}
function $f_jl_Long__toString__T($thiz, $thizhi) {
  return $m_RTLong$().kY($thiz, $thizhi);
}
function $f_jl_Long__compareTo__O__I($thiz, $thizhi, o) {
  var $x_1 = o;
  var this$1_$_lo = $x_1.l;
  var this$1_$_hi = $x_1.h;
  return (($thizhi === this$1_$_hi) ? (($thiz === this$1_$_lo) ? 0 : ((($thiz >>> 0) < (this$1_$_lo >>> 0)) ? (-1) : 1)) : (($thizhi < this$1_$_hi) ? (-1) : 1));
}
function $isArrayOf_jl_Long(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eS)));
}
var $d_jl_Long = new $TypeData().i(0, "java.lang.Long", ({
  eS: 1,
  aP: 1,
  a: 1,
  Q: 1,
  aY: 1,
  bP: 1
}), ((x) => (x instanceof $Long)));
class $c_jl_NumberFormatException extends $c_jl_IllegalArgumentException {
  constructor(s) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true);
  }
}
function $isArrayOf_jl_NumberFormatException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eT)));
}
var $d_jl_NumberFormatException = new $TypeData().i($c_jl_NumberFormatException, "java.lang.NumberFormatException", ({
  eT: 1,
  aE: 1,
  R: 1,
  G: 1,
  y: 1,
  a: 1
}));
function $f_T__length__I($thiz) {
  return $thiz.length;
}
function $f_T__charAt__I__C($thiz, index) {
  return $thiz.charCodeAt(index);
}
function $f_T__codePointAt__I__I($thiz, index) {
  return ($thiz.codePointAt(index) | 0);
}
function $f_T__hashCode__I($thiz) {
  var n = $thiz.length;
  var h = 0;
  var i = 0;
  while ((i !== n)) {
    h = (((((h << 5) - h) | 0) + $thiz.charCodeAt(i)) | 0);
    i = ((1 + i) | 0);
  }
  return h;
}
function $f_T__equals__O__Z($thiz, that) {
  return ($thiz === that);
}
function $f_T__compareTo__T__I($thiz, anotherString) {
  var thisLength = $thiz.length;
  var strLength = anotherString.length;
  var minLength = ((thisLength < strLength) ? thisLength : strLength);
  var i = 0;
  while ((i !== minLength)) {
    var cmp = (($thiz.charCodeAt(i) - anotherString.charCodeAt(i)) | 0);
    if ((cmp !== 0)) {
      return cmp;
    }
    i = ((1 + i) | 0);
  }
  return ((thisLength - strLength) | 0);
}
function $f_T__compareToIgnoreCase__T__I($thiz, str) {
  var thisLength = $thiz.length;
  var strLength = str.length;
  var minLength = ((thisLength < strLength) ? thisLength : strLength);
  var i = 0;
  while ((i !== minLength)) {
    var thisCP = $f_T__codePointAt__I__I($thiz, i);
    var cmp = (($m_jl_Character$().iy($m_jl_Character$().j0(thisCP)) - $m_jl_Character$().iy($m_jl_Character$().j0($f_T__codePointAt__I__I(str, i)))) | 0);
    if ((cmp !== 0)) {
      return cmp;
    }
    i = ((i + ((thisCP >= 65536) ? 2 : 1)) | 0);
  }
  return ((thisLength - strLength) | 0);
}
function $f_T__getBytes__Ljava_nio_charset_Charset__AB($thiz, charset) {
  var buf = charset.b0z($thiz);
  var res = new $ac_B(((buf.c2 - buf.b3) | 0));
  buf.b21(res, 0, res.a.length);
  return res;
}
function $f_T__getChars__I__I__AC__I__V($thiz, srcBegin, srcEnd, dst, dstBegin) {
  var offset = ((dstBegin - srcBegin) | 0);
  var i = srcBegin;
  while ((i < srcEnd)) {
    dst.a[((i + offset) | 0)] = $thiz.charCodeAt(i);
    i = ((1 + i) | 0);
  }
}
function $f_T__indexOf__I__I($thiz, ch) {
  var str = $m_jl_Character$().Q4(ch);
  return ($thiz.indexOf(str) | 0);
}
function $f_T__indexOf__I__I__I($thiz, ch, fromIndex) {
  var str = $m_jl_Character$().Q4(ch);
  return ($thiz.indexOf(str, fromIndex) | 0);
}
function $f_T__repeat__I__T($thiz, count) {
  if ((count < 0)) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  } else {
    return $thiz.repeat(count);
  }
}
function $f_T__replaceAll__T__T__T($thiz, regex, replacement) {
  return new $c_ju_regex_Matcher($m_ju_regex_PatternCompiler$().Wy(regex, 0), $thiz).aRG(replacement);
}
function $f_T__replaceFirst__T__T__T($thiz, regex, replacement) {
  return new $c_ju_regex_Matcher($m_ju_regex_PatternCompiler$().Wy(regex, 0), $thiz).b7F(replacement);
}
function $f_T__split__T__I__AT($thiz, regex, limit) {
  return $m_ju_regex_PatternCompiler$().Wy(regex, 0).b3Q($thiz, limit);
}
function $f_T__subSequence__I__I__jl_CharSequence($thiz, beginIndex, endIndex) {
  return $thiz.substring(beginIndex, endIndex);
}
function $f_T__toCharArray__AC($thiz) {
  var len = $thiz.length;
  var result = new $ac_C(len);
  var i = 0;
  while ((i < len)) {
    result.a[i] = $thiz.charCodeAt(i);
    i = ((1 + i) | 0);
  }
  return result;
}
function $f_T__trim__T($thiz) {
  var len = $thiz.length;
  var start = 0;
  while (((start !== len) && ($thiz.charCodeAt(start) <= 32))) {
    start = ((1 + start) | 0);
  }
  if ((start === len)) {
    return "";
  } else {
    var end = len;
    while (($thiz.charCodeAt(((end - 1) | 0)) <= 32)) {
      end = ((end - 1) | 0);
    }
    if (((start | (end ^ len)) === 0)) {
      return $thiz;
    } else {
      var beginIndex = start;
      var endIndex = end;
      return $thiz.substring(beginIndex, endIndex);
    }
  }
}
function $f_T__toString__T($thiz) {
  return $thiz;
}
function $f_T__compareTo__O__I($thiz, o) {
  return $f_T__compareTo__T__I($thiz, o);
}
function $isArrayOf_T(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eX)));
}
var $d_T = new $TypeData().i(0, "java.lang.String", ({
  eX: 1,
  a: 1,
  Q: 1,
  aX: 1,
  aY: 1,
  bP: 1
}), ((x) => ((typeof x) === "string")));
function $ct_Ljava_nio_CharBuffer__I__AC__I__($thiz, _capacity, _array, _arrayOffset) {
  $thiz.lx = _array;
  $thiz.nM = _arrayOffset;
  $ct_Ljava_nio_Buffer__I__($thiz, _capacity);
  return $thiz;
}
/** @constructor */
function $c_Ljava_nio_CharBuffer() {
  this.nK = 0;
  this.c2 = 0;
  this.b3 = 0;
  this.ur = 0;
  this.lx = null;
  this.nM = 0;
}
$p = $c_Ljava_nio_CharBuffer.prototype = new $h_Ljava_nio_Buffer();
$p.constructor = $c_Ljava_nio_CharBuffer;
/** @constructor */
function $h_Ljava_nio_CharBuffer() {
}
$h_Ljava_nio_CharBuffer.prototype = $p;
$p.aRh = (function(src) {
  if ((src === this)) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  }
  if (this.E6()) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var srcLimit = src.c2;
  var srcPos = src.b3;
  var length = ((srcLimit - srcPos) | 0);
  var p = this.b3;
  var newPos = ((p + length) | 0);
  if ((newPos > this.c2)) {
    throw new $c_Ljava_nio_BufferOverflowException();
  }
  this.b3 = newPos;
  var selfPos = p;
  $c_Ljava_nio_Buffer.prototype.cX.call(src, srcLimit);
  var srcArray = src.lx;
  if ((srcArray !== null)) {
    this.aSr(selfPos, srcArray, ((src.nM + srcPos) | 0), length);
  } else {
    while ((srcPos !== srcLimit)) {
      this.aSq(selfPos, src.Xt(srcPos));
      srcPos = ((1 + srcPos) | 0);
      selfPos = ((1 + selfPos) | 0);
    }
  }
  return this;
});
$p.aRg = (function(src, start, end) {
  return this.aRh($m_Ljava_nio_CharBuffer$().aTv(src, start, end));
});
$p.x = (function() {
  var start = this.b3;
  var end = this.c2;
  var h = (-182887236);
  var i = start;
  while ((i !== end)) {
    h = $m_ju_internal_MurmurHash3$().k(h, this.Xt(i));
    i = ((1 + i) | 0);
  }
  return $m_ju_internal_MurmurHash3$().Z(h, ((end - start) | 0));
});
$p.e = (function(that) {
  return ((that instanceof $c_Ljava_nio_CharBuffer) && (this.aMS(that) === 0));
});
$p.aMS = (function(that) {
  if ((this === that)) {
    return 0;
  } else {
    var thisStart = this.b3;
    var thisRemaining = ((this.c2 - thisStart) | 0);
    var thatStart = that.b3;
    var thatRemaining = ((that.c2 - thatStart) | 0);
    var shortestLength = ((thisRemaining < thatRemaining) ? thisRemaining : thatRemaining);
    var i = 0;
    while ((i !== shortestLength)) {
      var t = this.Xt(((thisStart + i) | 0));
      var u = that.Xt(((thatStart + i) | 0));
      var cmp = ((t - u) | 0);
      if ((cmp !== 0)) {
        return cmp;
      }
      i = ((1 + i) | 0);
    }
    return ((thisRemaining === thatRemaining) ? 0 : ((thisRemaining < thatRemaining) ? (-1) : 1));
  }
});
$p.m = (function() {
  if ((this.lx !== null)) {
    return $m_jl_String$().kS(this.lx, ((this.b3 + this.nM) | 0), ((this.c2 - this.b3) | 0));
  } else {
    var chars = new $ac_C(((this.c2 - this.b3) | 0));
    var savedPos = this.b3;
    this.aOM(chars, 0, chars.a.length);
    $c_Ljava_nio_Buffer.prototype.cX.call(this, savedPos);
    return $m_jl_String$().kS(chars, 0, chars.a.length);
  }
});
$p.C = (function() {
  return ((this.c2 - this.b3) | 0);
});
$p.y1 = (function(index) {
  return this.aOK(((this.b3 + index) | 0));
});
$p.W9 = (function(csq) {
  var src = $dp_toString__T(csq);
  return this.aRg(src, 0, src.length);
});
$p.pp = (function(o) {
  return this.aMS(o);
});
function $isArrayOf_Ljava_nio_CharBuffer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.de)));
}
class $c_Ljava_nio_ReadOnlyBufferException extends $c_jl_UnsupportedOperationException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
}
var $d_Ljava_nio_ReadOnlyBufferException = new $TypeData().i($c_Ljava_nio_ReadOnlyBufferException, "java.nio.ReadOnlyBufferException", ({
  sF: 1,
  eY: 1,
  R: 1,
  G: 1,
  y: 1,
  a: 1
}));
class $c_Ljava_nio_charset_MalformedInputException extends $c_Ljava_nio_charset_CharacterCodingException {
  constructor(inputLength) {
    super();
    this.atg = 0;
    this.atg = inputLength;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  e3() {
    return ("Input length = " + this.atg);
  }
}
var $d_Ljava_nio_charset_MalformedInputException = new $TypeData().i($c_Ljava_nio_charset_MalformedInputException, "java.nio.charset.MalformedInputException", ({
  sP: 1,
  f7: 1,
  db: 1,
  G: 1,
  y: 1,
  a: 1
}));
class $c_Ljava_nio_charset_UnmappableCharacterException extends $c_Ljava_nio_charset_CharacterCodingException {
  constructor(inputLength) {
    super();
    this.ath = 0;
    this.ath = inputLength;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  e3() {
    return ("Input length = " + this.ath);
  }
}
var $d_Ljava_nio_charset_UnmappableCharacterException = new $TypeData().i($c_Ljava_nio_charset_UnmappableCharacterException, "java.nio.charset.UnmappableCharacterException", ({
  sT: 1,
  f7: 1,
  db: 1,
  G: 1,
  y: 1,
  a: 1
}));
class $c_ju_FormatterClosedException extends $c_jl_IllegalStateException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
}
var $d_ju_FormatterClosedException = new $TypeData().i($c_ju_FormatterClosedException, "java.util.FormatterClosedException", ({
  tf: 1,
  eP: 1,
  R: 1,
  G: 1,
  y: 1,
  a: 1
}));
/** @constructor */
function $c_ju_HashMap$EntrySet(outer) {
  this.Zu = null;
  this.Zu = outer;
}
$p = $c_ju_HashMap$EntrySet.prototype = new $h_ju_AbstractSet();
$p.constructor = $c_ju_HashMap$EntrySet;
/** @constructor */
function $h_ju_HashMap$EntrySet() {
}
$h_ju_HashMap$EntrySet.prototype = $p;
$p.r4 = (function() {
  return new $c_ju_LinkedHashMap$NodeIterator(this.Zu);
});
$p.aa = (function() {
  return this.Zu.yI;
});
$p.E = (function(o) {
  if ($is_ju_Map$Entry(o)) {
    var this$1 = this.Zu;
    var key = o.rl;
    if ((key === null)) {
      var hash = 0;
    } else {
      var originalHash = $dp_hashCode__I(key);
      var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    }
    var node = this$1.a3Y(key, hash, (hash & ((this$1.nN.a.length - 1) | 0)));
    if ((node !== null)) {
      var a = node.nO;
      var b = o.nO;
      return ((a === null) ? (b === null) : $dp_equals__O__Z(a, b));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
var $d_ju_HashMap$EntrySet = new $TypeData().i($c_ju_HashMap$EntrySet, "java.util.HashMap$EntrySet", ({
  th: 1,
  dg: 1,
  df: 1,
  bA: 1,
  cl: 1,
  cq: 1
}));
/** @constructor */
function $c_ju_HashMap$KeySet(outer) {
  this.Zv = null;
  this.Zv = outer;
}
$p = $c_ju_HashMap$KeySet.prototype = new $h_ju_AbstractSet();
$p.constructor = $c_ju_HashMap$KeySet;
/** @constructor */
function $h_ju_HashMap$KeySet() {
}
$h_ju_HashMap$KeySet.prototype = $p;
$p.r4 = (function() {
  return new $c_ju_LinkedHashMap$KeyIterator(this.Zv);
});
$p.aa = (function() {
  return this.Zv.yI;
});
$p.E = (function(o) {
  return this.Zv.aZ3(o);
});
var $d_ju_HashMap$KeySet = new $TypeData().i($c_ju_HashMap$KeySet, "java.util.HashMap$KeySet", ({
  ti: 1,
  dg: 1,
  df: 1,
  bA: 1,
  cl: 1,
  cq: 1
}));
class $c_ju_IllegalFormatException extends $c_jl_IllegalArgumentException {
}
class $c_ju_regex_PatternSyntaxException extends $c_jl_IllegalArgumentException {
  constructor(desc, regex, index) {
    super();
    this.atS = null;
    this.atU = null;
    this.atT = 0;
    this.atS = desc;
    this.atU = regex;
    this.atT = index;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  e3() {
    var idx = this.atT;
    var re = this.atU;
    var indexHint = ((idx < 0) ? "" : (" near index " + idx));
    var base = (((this.atS + indexHint) + "\n") + re);
    return ((((idx >= 0) && (re !== null)) && (idx < re.length)) ? (((base + "\n") + $f_T__repeat__I__T(" ", idx)) + "^") : base);
  }
}
var $d_ju_regex_PatternSyntaxException = new $TypeData().i($c_ju_regex_PatternSyntaxException, "java.util.regex.PatternSyntaxException", ({
  u6: 1,
  aE: 1,
  R: 1,
  G: 1,
  y: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$RawEnd$Nodes(ns) {
  this.Ki = null;
  this.Ki = ns;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$RawEnd$Nodes.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$RawEnd();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$RawEnd$Nodes;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$RawEnd$Nodes() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$RawEnd$Nodes.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 1025352861, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$RawEnd$Nodes)) {
    var x = this.Ki;
    var x$2 = x$0.Ki;
    return ((x === null) ? (x$2 === null) : x.e(x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Nodes";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Ki;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "ns";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$RawEnd$Nodes(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fk)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$RawEnd$Nodes = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$RawEnd$Nodes, "org.jpablo.graphexplorer.graphviz.dotlang.DotParser$RawEnd$Nodes", ({
  fk: 1,
  fj: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$RawEnd$Sub(sg) {
  this.Kj = null;
  this.Kj = sg;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$RawEnd$Sub.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$RawEnd();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$RawEnd$Sub;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$RawEnd$Sub() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$RawEnd$Sub.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-1999079233), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$RawEnd$Sub)) {
    var x = this.Kj;
    var x$2 = x$0.Kj;
    return ((x === null) ? (x$2 === null) : x.e(x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Sub";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Kj;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "sg";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$RawEnd$Sub(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fl)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$RawEnd$Sub = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_dotlang_DotParser$RawEnd$Sub, "org.jpablo.graphexplorer.graphviz.dotlang.DotParser$RawEnd$Sub", ({
  fl: 1,
  fj: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_EdgeEnd$Node(node) {
  this.Rf = null;
  this.Rf = node;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_EdgeEnd$Node.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_dotlang_EdgeEnd();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_EdgeEnd$Node;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_dotlang_EdgeEnd$Node() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_dotlang_EdgeEnd$Node.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 2014067603, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_EdgeEnd$Node)) {
    var x = this.Rf;
    var x$2 = x$0.Rf;
    return ((x === null) ? (x$2 === null) : x.e(x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Node";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Rf;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "node";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_dotlang_EdgeEnd$Node(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fn)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_dotlang_EdgeEnd$Node = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_dotlang_EdgeEnd$Node, "org.jpablo.graphexplorer.graphviz.dotlang.EdgeEnd$Node", ({
  fn: 1,
  fm: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_EdgeEnd$Sub(subgraph) {
  this.Rg = null;
  this.Rg = subgraph;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_EdgeEnd$Sub.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_dotlang_EdgeEnd();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_EdgeEnd$Sub;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_dotlang_EdgeEnd$Sub() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_dotlang_EdgeEnd$Sub.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-1999079233), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_EdgeEnd$Sub)) {
    var x = this.Rg;
    var x$2 = x$0.Rg;
    return ((x === null) ? (x$2 === null) : x.e(x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Sub";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Rg;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "subgraph";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_dotlang_EdgeEnd$Sub(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fo)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_dotlang_EdgeEnd$Sub = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_dotlang_EdgeEnd$Sub, "org.jpablo.graphexplorer.graphviz.dotlang.EdgeEnd$Sub", ({
  fo: 1,
  fm: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$Assign(name, value) {
  this.Ri = null;
  this.Rj = null;
  this.Ri = name;
  this.Rj = value;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$Assign.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$Assign;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$Assign() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$Assign.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-1763916719), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$Assign)) {
    var x = this.Ri;
    var x$2 = x$0.Ri;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      var x$3 = this.Rj;
      var x$4 = x$0.Rj;
      return ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "Assign";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Ri;
  }
  if ((n === 1)) {
    return this.Rj;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "name";
  }
  if ((n === 1)) {
    return "value";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$Assign(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ft)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$Assign = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$Assign, "org.jpablo.graphexplorer.graphviz.dotlang.Stmt$Assign", ({
  ft: 1,
  bR: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$AttrStmt(target, attrs) {
  this.Rl = null;
  this.Rk = null;
  this.Rl = target;
  this.Rk = attrs;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$AttrStmt.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$AttrStmt;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$AttrStmt() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$AttrStmt.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 1628557268, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$AttrStmt)) {
    var x = this.Rl;
    var x$2 = x$0.Rl;
    if (((x === null) ? (x$2 === null) : (x === x$2))) {
      var x$3 = this.Rk;
      var x$4 = x$0.Rk;
      return ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "AttrStmt";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Rl;
  }
  if ((n === 1)) {
    return this.Rk;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "target";
  }
  if ((n === 1)) {
    return "attrs";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$AttrStmt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fu)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$AttrStmt = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$AttrStmt, "org.jpablo.graphexplorer.graphviz.dotlang.Stmt$AttrStmt", ({
  fu: 1,
  bR: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$EdgeStmt(ends, attrs) {
  this.Rn = null;
  this.Rm = null;
  this.Rn = ends;
  this.Rm = attrs;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$EdgeStmt.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$EdgeStmt;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$EdgeStmt() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$EdgeStmt.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-912477770), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$EdgeStmt)) {
    var x = this.Rn;
    var x$2 = x$0.Rn;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      var x$3 = this.Rm;
      var x$4 = x$0.Rm;
      return ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "EdgeStmt";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Rn;
  }
  if ((n === 1)) {
    return this.Rm;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "ends";
  }
  if ((n === 1)) {
    return "attrs";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$EdgeStmt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fv)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$EdgeStmt = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$EdgeStmt, "org.jpablo.graphexplorer.graphviz.dotlang.Stmt$EdgeStmt", ({
  fv: 1,
  bR: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$NodeStmt(node, attrs) {
  this.Rp = null;
  this.Ro = null;
  this.Rp = node;
  this.Ro = attrs;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$NodeStmt.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$NodeStmt;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$NodeStmt() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$NodeStmt.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-1992529125), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$NodeStmt)) {
    var x = this.Rp;
    var x$2 = x$0.Rp;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      var x$3 = this.Ro;
      var x$4 = x$0.Ro;
      return ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "NodeStmt";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Rp;
  }
  if ((n === 1)) {
    return this.Ro;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "node";
  }
  if ((n === 1)) {
    return "attrs";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$NodeStmt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fw)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$NodeStmt = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$NodeStmt, "org.jpablo.graphexplorer.graphviz.dotlang.Stmt$NodeStmt", ({
  fw: 1,
  bR: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$SubStmt(subgraph) {
  this.Rq = null;
  this.Rq = subgraph;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$SubStmt.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$SubStmt;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$SubStmt() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$SubStmt.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 1286422150, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$SubStmt)) {
    var x = this.Rq;
    var x$2 = x$0.Rq;
    return ((x === null) ? (x$2 === null) : x.e(x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "SubStmt";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Rq;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "subgraph";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$SubStmt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fx)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$SubStmt = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Stmt$SubStmt, "org.jpablo.graphexplorer.graphviz.dotlang.Stmt$SubStmt", ({
  fx: 1,
  bR: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Image(src, scale) {
  this.wy = null;
  this.EZ = null;
  this.wy = src;
  this.EZ = scale;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Image.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Image;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Image() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Image.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 612005409, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Image)) {
    if ((this.wy === x$0.wy)) {
      var x = this.EZ;
      var x$2 = x$0.EZ;
      return ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "Image";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.wy;
  }
  if ((n === 1)) {
    return this.EZ;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "src";
  }
  if ((n === 1)) {
    return "scale";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Image(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fC)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Image = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Image, "org.jpablo.graphexplorer.graphviz.html.HtmlLabel$Image", ({
  fC: 1,
  di: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Table(tbl) {
  this.k8 = null;
  this.k8 = tbl;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Table.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Table;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Table() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Table.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-10296350), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Table)) {
    var x = this.k8;
    var x$2 = x$0.k8;
    return ((x === null) ? (x$2 === null) : x.e(x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Table";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.k8;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "tbl";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Table(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fD)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Table = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Table, "org.jpablo.graphexplorer.graphviz.html.HtmlLabel$Table", ({
  fD: 1,
  di: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Text(block) {
  this.oQ = null;
  this.oQ = block;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Text.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Text;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Text() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Text.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-1131730718), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Text)) {
    var x = this.oQ;
    var x$2 = x$0.oQ;
    return ((x === null) ? (x$2 === null) : x.e(x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Text";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.oQ;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "block";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Text(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fE)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Text = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlLabel$Text, "org.jpablo.graphexplorer.graphviz.html.HtmlLabel$Text", ({
  fE: 1,
  di: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Chars(str) {
  this.Kr = null;
  this.Kr = str;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Chars.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Chars;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Chars() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Chars.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 1694072680, true);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Chars) && (this.Kr === x$0.Kr)));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Chars";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Kr;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "str";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Chars(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fH)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Chars = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Chars, "org.jpablo.graphexplorer.graphviz.html.HtmlParser$Tok$Chars", ({
  fH: 1,
  ct: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Close(name) {
  this.wz = null;
  this.wz = name;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Close.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Close;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Close() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Close.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-720229041), true);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Close) && (this.wz === x$0.wz)));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Close";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.wz;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "name";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Close(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fI)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Close = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Close, "org.jpablo.graphexplorer.graphviz.html.HtmlParser$Tok$Close", ({
  fI: 1,
  ct: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Open(name, attrs, selfClose) {
  this.md = null;
  this.yL = null;
  this.F2 = false;
  this.md = name;
  this.yL = attrs;
  this.F2 = selfClose;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Open.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Open;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Open() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Open.prototype = $p;
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 2464362);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.md));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.yL));
  acc = $m_sr_Statics$().k(acc, (this.F2 ? 1231 : 1237));
  return $m_sr_Statics$().Z(acc, 3);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Open)) {
    if (((this.F2 === x$0.F2) && (this.md === x$0.md))) {
      var x = this.yL;
      var x$2 = x$0.yL;
      return ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 3;
});
$p.B = (function() {
  return "Open";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.md;
      break;
    }
    case 1: {
      return this.yL;
      break;
    }
    case 2: {
      return this.F2;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "name";
      break;
    }
    case 1: {
      return "attrs";
      break;
    }
    case 2: {
      return "selfClose";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Open(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fJ)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Open = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlParser$Tok$Open, "org.jpablo.graphexplorer.graphviz.html.HtmlParser$Tok$Open", ({
  fJ: 1,
  ct: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Curve(pts) {
  this.RC = null;
  this.RC = pts;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Curve.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Curve;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Curve() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Curve.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-513925029), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Curve)) {
    var x = this.RC;
    var x$2 = x$0.RC;
    return ((x === null) ? (x$2 === null) : (x === x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Curve";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.RC;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "pts";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Curve(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fR)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Curve = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Curve, "org.jpablo.graphexplorer.graphviz.layout.Arrow$Prim$Curve", ({
  fR: 1,
  cu: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Ellipse(center, r, filled) {
  this.KA = null;
  this.KC = 0.0;
  this.KB = false;
  this.KA = center;
  this.KC = r;
  this.KB = filled;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Ellipse.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Ellipse;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Ellipse() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Ellipse.prototype = $p;
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 8172478);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.KA));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.KC));
  acc = $m_sr_Statics$().k(acc, (this.KB ? 1231 : 1237));
  return $m_sr_Statics$().Z(acc, 3);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Ellipse)) {
    if (((this.KC === x$0.KC) && (this.KB === x$0.KB))) {
      var x = this.KA;
      var x$2 = x$0.KA;
      return ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 3;
});
$p.B = (function() {
  return "Ellipse";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.KA;
      break;
    }
    case 1: {
      return this.KC;
      break;
    }
    case 2: {
      return this.KB;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "center";
      break;
    }
    case 1: {
      return "r";
      break;
    }
    case 2: {
      return "filled";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Ellipse(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fS)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Ellipse = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Ellipse, "org.jpablo.graphexplorer.graphviz.layout.Arrow$Prim$Ellipse", ({
  fS: 1,
  cu: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Polygon(pts, filled) {
  this.KE = null;
  this.KD = false;
  this.KE = pts;
  this.KD = filled;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Polygon.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Polygon;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Polygon() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Polygon.prototype = $p;
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 1267133722);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.KE));
  acc = $m_sr_Statics$().k(acc, (this.KD ? 1231 : 1237));
  return $m_sr_Statics$().Z(acc, 2);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Polygon)) {
    if ((this.KD === x$0.KD)) {
      var x = this.KE;
      var x$2 = x$0.KE;
      return ((x === null) ? (x$2 === null) : (x === x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "Polygon";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.KE;
  }
  if ((n === 1)) {
    return this.KD;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "pts";
  }
  if ((n === 1)) {
    return "filled";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Polygon(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fT)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Polygon = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Polygon, "org.jpablo.graphexplorer.graphviz.layout.Arrow$Prim$Polygon", ({
  fT: 1,
  cu: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Polyline(pts) {
  this.RD = null;
  this.RD = pts;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Polyline.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Polyline;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Polyline() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Polyline.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 185068644, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Polyline)) {
    var x = this.RD;
    var x$2 = x$0.RD;
    return ((x === null) ? (x$2 === null) : (x === x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Polyline";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.RD;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "pts";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Polyline(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fU)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Polyline = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_Arrow$Prim$Polyline, "org.jpablo.graphexplorer.graphviz.layout.Arrow$Prim$Polyline", ({
  fU: 1,
  cu: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ClusterLn(idx) {
  this.KP = 0;
  this.KP = idx;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ClusterLn.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ClusterLn;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ClusterLn() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ClusterLn.prototype = $p;
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, (-1729059588));
  acc = $m_sr_Statics$().k(acc, this.KP);
  return $m_sr_Statics$().Z(acc, 1);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ClusterLn) && (this.KP === x$0.KP)));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "ClusterLn";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.KP;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "idx";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ClusterLn(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fY)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ClusterLn = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ClusterLn, "org.jpablo.graphexplorer.graphviz.layout.LayoutNode$ClusterLn", ({
  fY: 1,
  bo: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ClusterRn(idx) {
  this.KQ = 0;
  this.KQ = idx;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ClusterRn.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ClusterRn;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ClusterRn() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ClusterRn.prototype = $p;
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, (-1729059402));
  acc = $m_sr_Statics$().k(acc, this.KQ);
  return $m_sr_Statics$().Z(acc, 1);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ClusterRn) && (this.KQ === x$0.KQ)));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "ClusterRn";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.KQ;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "idx";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ClusterRn(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fZ)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ClusterRn = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$ClusterRn, "org.jpablo.graphexplorer.graphviz.layout.LayoutNode$ClusterRn", ({
  fZ: 1,
  bo: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$FlatLabel(dedgeIdx) {
  this.yQ = 0;
  this.yQ = dedgeIdx;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$FlatLabel.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$FlatLabel;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$FlatLabel() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$FlatLabel.prototype = $p;
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 859861723);
  acc = $m_sr_Statics$().k(acc, this.yQ);
  return $m_sr_Statics$().Z(acc, 1);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$FlatLabel) && (this.yQ === x$0.yQ)));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "FlatLabel";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.yQ;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "dedgeIdx";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$FlatLabel(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.g0)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$FlatLabel = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$FlatLabel, "org.jpablo.graphexplorer.graphviz.layout.LayoutNode$FlatLabel", ({
  g0: 1,
  bo: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real(id) {
  this.mh = null;
  this.mh = id;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-1848733623), true);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real) && (this.mh === x$0.mh)));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Real";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.mh;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "id";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.g1)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Real, "org.jpablo.graphexplorer.graphviz.layout.LayoutNode$Real", ({
  g1: 1,
  bo: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Slack(segIdx) {
  this.KR = 0;
  this.KR = segIdx;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Slack.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Slack;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Slack() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Slack.prototype = $p;
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 79966064);
  acc = $m_sr_Statics$().k(acc, this.KR);
  return $m_sr_Statics$().Z(acc, 1);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Slack) && (this.KR === x$0.KR)));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Slack";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.KR;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "segIdx";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Slack(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.g2)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Slack = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Slack, "org.jpablo.graphexplorer.graphviz.layout.LayoutNode$Slack", ({
  g2: 1,
  bo: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Virtual(edgeIdx, rank) {
  this.kB = 0;
  this.wD = 0;
  this.kB = edgeIdx;
  this.wD = rank;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Virtual.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Virtual;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Virtual() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Virtual.prototype = $p;
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 2130818795);
  acc = $m_sr_Statics$().k(acc, this.kB);
  acc = $m_sr_Statics$().k(acc, this.wD);
  return $m_sr_Statics$().Z(acc, 2);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Virtual) && ((this.kB === x$0.kB) && (this.wD === x$0.wD))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "Virtual";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.kB;
  }
  if ((n === 1)) {
    return this.wD;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "edgeIdx";
  }
  if ((n === 1)) {
    return "rank";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Virtual(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.g3)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Virtual = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_LayoutNode$Virtual, "org.jpablo.graphexplorer.graphviz.layout.LayoutNode$Virtual", ({
  g3: 1,
  bo: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Nd(n) {
  this.Bl = null;
  this.Bl = n;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Nd.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Nd;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Nd() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Nd.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 896030355, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Nd)) {
    var x = this.Bl;
    var x$2 = x$0.Bl;
    return ((x === null) ? (x$2 === null) : x.e(x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Nd";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Bl;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "n";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Nd(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.g9)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Nd = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Nd, "org.jpablo.graphexplorer.graphviz.layout.Order$CNode$Nd", ({
  g9: 1,
  g8: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Sk(clust, rank) {
  this.pU = 0;
  this.RI = 0;
  this.pU = clust;
  this.RI = rank;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Sk.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Sk;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Sk() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Sk.prototype = $p;
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 2680);
  acc = $m_sr_Statics$().k(acc, this.pU);
  acc = $m_sr_Statics$().k(acc, this.RI);
  return $m_sr_Statics$().Z(acc, 2);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Sk) && ((this.pU === x$0.pU) && (this.RI === x$0.RI))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "Sk";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.pU;
  }
  if ((n === 1)) {
    return this.RI;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "clust";
  }
  if ((n === 1)) {
    return "rank";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Sk(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ga)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Sk = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_Order$CNode$Sk, "org.jpablo.graphexplorer.graphviz.layout.Order$CNode$Sk", ({
  ga: 1,
  g8: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$Op$Line(pts) {
  this.Fn = null;
  this.Fn = pts;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$Op$Line.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$Op();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$Op$Line;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$Op$Line() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$Op$Line.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 308983819, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$Op$Line)) {
    var x = this.Fn;
    var x$2 = x$0.Fn;
    return ((x === null) ? (x$2 === null) : x.e(x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Line";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Fn;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "pts";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$Op$Line(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gj)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$Op$Line = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$Op$Line, "org.jpablo.graphexplorer.graphviz.layout.RoundCorners$Op$Line", ({
  gj: 1,
  dl: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$Op$Poly(pts, filled) {
  this.By = null;
  this.Bx = false;
  this.By = pts;
  this.Bx = filled;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$Op$Poly.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$Op();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$Op$Poly;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$Op$Poly() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$Op$Poly.prototype = $p;
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 2493420);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.By));
  acc = $m_sr_Statics$().k(acc, (this.Bx ? 1231 : 1237));
  return $m_sr_Statics$().Z(acc, 2);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$Op$Poly)) {
    if ((this.Bx === x$0.Bx)) {
      var x = this.By;
      var x$2 = x$0.By;
      return ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "Poly";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.By;
  }
  if ((n === 1)) {
    return this.Bx;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "pts";
  }
  if ((n === 1)) {
    return "filled";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$Op$Poly(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gk)));
}
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$Op$Poly = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_RoundCorners$Op$Poly, "org.jpablo.graphexplorer.graphviz.layout.RoundCorners$Op$Poly", ({
  gk: 1,
  dl: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandError$BadArgument(command, detail) {
  this.S0 = null;
  this.S1 = null;
  this.S0 = command;
  this.S1 = detail;
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandError$BadArgument.prototype = new $h_Lorg_jpablo_graphexplorer_gxcore_command_CommandError();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandError$BadArgument;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_command_CommandError$BadArgument() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_command_CommandError$BadArgument.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-1418998093), true);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandError$BadArgument) && ((this.S0 === x$0.S0) && (this.S1 === x$0.S1))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "BadArgument";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.S0;
  }
  if ((n === 1)) {
    return this.S1;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "command";
  }
  if ((n === 1)) {
    return "detail";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_gxcore_command_CommandError$BadArgument(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gC)));
}
var $d_Lorg_jpablo_graphexplorer_gxcore_command_CommandError$BadArgument = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_command_CommandError$BadArgument, "org.jpablo.graphexplorer.gxcore.command.CommandError$BadArgument", ({
  gC: 1,
  dm: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandError$NotApplicable(command, detail) {
  this.S2 = null;
  this.S3 = null;
  this.S2 = command;
  this.S3 = detail;
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandError$NotApplicable.prototype = new $h_Lorg_jpablo_graphexplorer_gxcore_command_CommandError();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandError$NotApplicable;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_command_CommandError$NotApplicable() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_command_CommandError$NotApplicable.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-662507302), true);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandError$NotApplicable) && ((this.S2 === x$0.S2) && (this.S3 === x$0.S3))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "NotApplicable";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.S2;
  }
  if ((n === 1)) {
    return this.S3;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "command";
  }
  if ((n === 1)) {
    return "detail";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_gxcore_command_CommandError$NotApplicable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gD)));
}
var $d_Lorg_jpablo_graphexplorer_gxcore_command_CommandError$NotApplicable = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_command_CommandError$NotApplicable, "org.jpablo.graphexplorer.gxcore.command.CommandError$NotApplicable", ({
  gD: 1,
  dm: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandError$UnknownCommand(name) {
  this.S4 = null;
  this.S4 = name;
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandError$UnknownCommand.prototype = new $h_Lorg_jpablo_graphexplorer_gxcore_command_CommandError();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandError$UnknownCommand;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_command_CommandError$UnknownCommand() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_command_CommandError$UnknownCommand.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 928971831, true);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandError$UnknownCommand) && (this.S4 === x$0.S4)));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "UnknownCommand";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.S4;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "name";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_gxcore_command_CommandError$UnknownCommand(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gE)));
}
var $d_Lorg_jpablo_graphexplorer_gxcore_command_CommandError$UnknownCommand = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_command_CommandError$UnknownCommand, "org.jpablo.graphexplorer.gxcore.command.CommandError$UnknownCommand", ({
  gE: 1,
  dm: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandResult$Answered(value) {
  this.a01 = null;
  this.a01 = value;
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandResult$Answered.prototype = new $h_Lorg_jpablo_graphexplorer_gxcore_command_CommandResult();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandResult$Answered;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_command_CommandResult$Answered() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_command_CommandResult$Answered.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 1809439515, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandResult$Answered)) {
    var x = this.a01;
    var x$2 = x$0.a01;
    return ((x === null) ? (x$2 === null) : x.e(x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Answered";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.a01;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_gxcore_command_CommandResult$Answered(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gG)));
}
var $d_Lorg_jpablo_graphexplorer_gxcore_command_CommandResult$Answered = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_command_CommandResult$Answered, "org.jpablo.graphexplorer.gxcore.command.CommandResult$Answered", ({
  gG: 1,
  gF: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandResult$Updated(graph) {
  this.S5 = null;
  this.S5 = graph;
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandResult$Updated.prototype = new $h_Lorg_jpablo_graphexplorer_gxcore_command_CommandResult();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandResult$Updated;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_command_CommandResult$Updated() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_command_CommandResult$Updated.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-1055944714), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_gxcore_command_CommandResult$Updated)) {
    var x = this.S5;
    var x$2 = x$0.S5;
    return ((x === null) ? (x$2 === null) : x.e(x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Updated";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.S5;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "graph";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_gxcore_command_CommandResult$Updated(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gH)));
}
var $d_Lorg_jpablo_graphexplorer_gxcore_command_CommandResult$Updated = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_command_CommandResult$Updated, "org.jpablo.graphexplorer.gxcore.command.CommandResult$Updated", ({
  gH: 1,
  gF: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$CombineIntoRecord(nodes) {
  this.Lf = null;
  this.Lf = nodes;
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$CombineIntoRecord.prototype = new $h_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$CombineIntoRecord;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$CombineIntoRecord() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$CombineIntoRecord.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-1982794404), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$CombineIntoRecord)) {
    var x = this.Lf;
    var x$2 = x$0.Lf;
    return ((x === null) ? (x$2 === null) : x.e(x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "CombineIntoRecord";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Lf;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "nodes";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$CombineIntoRecord(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gI)));
}
var $d_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$CombineIntoRecord = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$CombineIntoRecord, "org.jpablo.graphexplorer.gxcore.command.DocumentCommand$CombineIntoRecord", ({
  gI: 1,
  bS: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
function $isArrayOf_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$GetAttributes(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.vH)));
}
function $isArrayOf_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$Group(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.vI)));
}
function $isArrayOf_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$RemoveAttribute(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.vJ)));
}
function $isArrayOf_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$ResetAttributes(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.vK)));
}
function $isArrayOf_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$SetAttribute(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.vL)));
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$SplitRecord(node) {
  this.Lg = null;
  this.Lg = node;
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$SplitRecord.prototype = new $h_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$SplitRecord;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$SplitRecord() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$SplitRecord.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-1511969702), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$SplitRecord)) {
    var x = this.Lg;
    var x$2 = x$0.Lg;
    return ((x === null) ? (x$2 === null) : x.e(x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "SplitRecord";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Lg;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "node";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$SplitRecord(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gJ)));
}
var $d_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$SplitRecord = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$SplitRecord, "org.jpablo.graphexplorer.gxcore.command.DocumentCommand$SplitRecord", ({
  gJ: 1,
  bS: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$TransposeRecord(node) {
  this.Lh = null;
  this.Lh = node;
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$TransposeRecord.prototype = new $h_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$TransposeRecord;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$TransposeRecord() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$TransposeRecord.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-1597801514), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$TransposeRecord)) {
    var x = this.Lh;
    var x$2 = x$0.Lh;
    return ((x === null) ? (x$2 === null) : x.e(x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "TransposeRecord";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Lh;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "node";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$TransposeRecord(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gK)));
}
var $d_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$TransposeRecord = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$TransposeRecord, "org.jpablo.graphexplorer.gxcore.command.DocumentCommand$TransposeRecord", ({
  gK: 1,
  bS: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$Ungroup(targets) {
  this.Li = null;
  this.Li = targets;
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$Ungroup.prototype = new $h_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$Ungroup;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$Ungroup() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$Ungroup.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-496650521), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$Ungroup)) {
    var x = this.Li;
    var x$2 = x$0.Li;
    return ((x === null) ? (x$2 === null) : x.e(x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Ungroup";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Li;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "targets";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$Ungroup(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gL)));
}
var $d_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$Ungroup = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$Ungroup, "org.jpablo.graphexplorer.gxcore.command.DocumentCommand$Ungroup", ({
  gL: 1,
  bS: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$AddToSelection(targets) {
  this.S6 = null;
  this.S6 = targets;
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$AddToSelection.prototype = new $h_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$AddToSelection;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$AddToSelection() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$AddToSelection.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-1831545306), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$AddToSelection)) {
    var x = this.S6;
    var x$2 = x$0.S6;
    return ((x === null) ? (x$2 === null) : x.e(x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "AddToSelection";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.S6;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "targets";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$AddToSelection(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gM)));
}
var $d_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$AddToSelection = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$AddToSelection, "org.jpablo.graphexplorer.gxcore.command.SessionCommand$AddToSelection", ({
  gM: 1,
  cw: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$PushText(sessionId, text) {
  this.S7 = null;
  this.S8 = null;
  this.S7 = sessionId;
  this.S8 = text;
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$PushText.prototype = new $h_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$PushText;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$PushText() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$PushText.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-178925160), true);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$PushText) && ((this.S7 === x$0.S7) && (this.S8 === x$0.S8))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "PushText";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.S7;
  }
  if ((n === 1)) {
    return this.S8;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "sessionId";
  }
  if ((n === 1)) {
    return "text";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$PushText(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gN)));
}
var $d_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$PushText = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$PushText, "org.jpablo.graphexplorer.gxcore.command.SessionCommand$PushText", ({
  gN: 1,
  cw: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$Select(targets) {
  this.S9 = null;
  this.S9 = targets;
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$Select.prototype = new $h_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$Select;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$Select() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$Select.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 1659381340, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$Select)) {
    var x = this.S9;
    var x$2 = x$0.S9;
    return ((x === null) ? (x$2 === null) : x.e(x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Select";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.S9;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "targets";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$Select(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gO)));
}
var $d_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$Select = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$Select, "org.jpablo.graphexplorer.gxcore.command.SessionCommand$Select", ({
  gO: 1,
  cw: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$AdoptOrigin(text, base) {
  this.Sc = null;
  this.Sb = null;
  this.Sc = text;
  this.Sb = base;
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$AdoptOrigin.prototype = new $h_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$AdoptOrigin;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$AdoptOrigin() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$AdoptOrigin.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-1548913548), true);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$AdoptOrigin) && ((this.Sc === x$0.Sc) && (this.Sb === x$0.Sb))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "AdoptOrigin";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Sc;
  }
  if ((n === 1)) {
    return this.Sb;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "text";
  }
  if ((n === 1)) {
    return "base";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$AdoptOrigin(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gW)));
}
var $d_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$AdoptOrigin = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$AdoptOrigin, "org.jpablo.graphexplorer.gxcore.model.ReconcileAction$AdoptOrigin", ({
  gW: 1,
  cx: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$AdvanceBase(base) {
  this.Sd = null;
  this.Sd = base;
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$AdvanceBase.prototype = new $h_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$AdvanceBase;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$AdvanceBase() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$AdvanceBase.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 1384167210, true);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$AdvanceBase) && (this.Sd === x$0.Sd)));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "AdvanceBase";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Sd;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "base";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$AdvanceBase(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gX)));
}
var $d_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$AdvanceBase = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$AdvanceBase, "org.jpablo.graphexplorer.gxcore.model.ReconcileAction$AdvanceBase", ({
  gX: 1,
  cx: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$WriteOrigin(text, expecting) {
  this.Sf = null;
  this.Se = null;
  this.Sf = text;
  this.Se = expecting;
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$WriteOrigin.prototype = new $h_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$WriteOrigin;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$WriteOrigin() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$WriteOrigin.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 582928646, true);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$WriteOrigin) && ((this.Sf === x$0.Sf) && (this.Se === x$0.Se))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "WriteOrigin";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Sf;
  }
  if ((n === 1)) {
    return this.Se;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "text";
  }
  if ((n === 1)) {
    return "expecting";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$WriteOrigin(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gY)));
}
var $d_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$WriteOrigin = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$WriteOrigin, "org.jpablo.graphexplorer.gxcore.model.ReconcileAction$WriteOrigin", ({
  gY: 1,
  cx: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$Bound(state, action, local) {
  this.Sh = null;
  this.Sg = null;
  this.a04 = null;
  this.Sh = state;
  this.Sg = action;
  this.a04 = local;
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$Bound.prototype = new $h_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$Bound;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$Bound() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$Bound.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-1402728877), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$Bound)) {
    var x = this.Sh;
    var x$2 = x$0.Sh;
    if (((x === null) ? (x$2 === null) : (x === x$2))) {
      var x$3 = this.Sg;
      var x$4 = x$0.Sg;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return (this.a04 === x$0.a04);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 3;
});
$p.B = (function() {
  return "Bound";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.Sh;
      break;
    }
    case 1: {
      return this.Sg;
      break;
    }
    case 2: {
      return this.a04;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "state";
      break;
    }
    case 1: {
      return "action";
      break;
    }
    case 2: {
      return "local";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$Bound(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.h0)));
}
var $d_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$Bound = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$Bound, "org.jpablo.graphexplorer.gxcore.model.ReconcilePlan$Bound", ({
  h0: 1,
  gZ: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_router_Route$Example(slug) {
  this.Ln = null;
  this.Ln = slug;
}
$p = $c_Lorg_jpablo_graphexplorer_router_Route$Example.prototype = new $h_Lorg_jpablo_graphexplorer_router_Route();
$p.constructor = $c_Lorg_jpablo_graphexplorer_router_Route$Example;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_router_Route$Example() {
}
$h_Lorg_jpablo_graphexplorer_router_Route$Example.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-1309886510), true);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_router_Route$Example) && (this.Ln === x$0.Ln)));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Example";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Ln;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "slug";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_router_Route$Example(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hb)));
}
var $d_Lorg_jpablo_graphexplorer_router_Route$Example = new $TypeData().i($c_Lorg_jpablo_graphexplorer_router_Route$Example, "org.jpablo.graphexplorer.router.Route$Example", ({
  hb: 1,
  cy: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_router_Route$LooseDocument(sessionId) {
  this.FN = null;
  this.FN = sessionId;
}
$p = $c_Lorg_jpablo_graphexplorer_router_Route$LooseDocument.prototype = new $h_Lorg_jpablo_graphexplorer_router_Route();
$p.constructor = $c_Lorg_jpablo_graphexplorer_router_Route$LooseDocument;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_router_Route$LooseDocument() {
}
$h_Lorg_jpablo_graphexplorer_router_Route$LooseDocument.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 474611034, true);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_router_Route$LooseDocument) && (this.FN === x$0.FN)));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "LooseDocument";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.FN;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "sessionId";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_router_Route$LooseDocument(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hc)));
}
var $d_Lorg_jpablo_graphexplorer_router_Route$LooseDocument = new $TypeData().i($c_Lorg_jpablo_graphexplorer_router_Route$LooseDocument, "org.jpablo.graphexplorer.router.Route$LooseDocument", ({
  hc: 1,
  cy: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_router_Route$ProjectDetail(uuid, source) {
  this.FO = null;
  this.Sm = null;
  this.FO = uuid;
  this.Sm = source;
}
$p = $c_Lorg_jpablo_graphexplorer_router_Route$ProjectDetail.prototype = new $h_Lorg_jpablo_graphexplorer_router_Route();
$p.constructor = $c_Lorg_jpablo_graphexplorer_router_Route$ProjectDetail;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_router_Route$ProjectDetail() {
}
$h_Lorg_jpablo_graphexplorer_router_Route$ProjectDetail.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 702780809, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_router_Route$ProjectDetail)) {
    if ((this.FO === x$0.FO)) {
      var x = this.Sm;
      var x$2 = x$0.Sm;
      return ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "ProjectDetail";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.FO;
  }
  if ((n === 1)) {
    return this.Sm;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "uuid";
  }
  if ((n === 1)) {
    return "source";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_router_Route$ProjectDetail(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hd)));
}
var $d_Lorg_jpablo_graphexplorer_router_Route$ProjectDetail = new $TypeData().i($c_Lorg_jpablo_graphexplorer_router_Route$ProjectDetail, "org.jpablo.graphexplorer.router.Route$ProjectDetail", ({
  hd: 1,
  cy: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
class $c_Lorg_jpablo_graphexplorer_viewer_backends_RenderOnlyDiagram extends $c_jl_Exception {
  constructor(kind, details) {
    super();
    this.Sw = null;
    this.Sv = null;
    this.Sw = kind;
    this.Sv = details;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, details, null, true, true);
  }
  H() {
    return new $c_s_Product$$anon$1(this);
  }
  x() {
    return $m_s_util_hashing_MurmurHash3$().ab(this, 1653453505, true);
  }
  e(x$0) {
    return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_backends_RenderOnlyDiagram) && ((this.Sw === x$0.Sw) && (this.Sv === x$0.Sv))));
  }
  z() {
    return 2;
  }
  B() {
    return "RenderOnlyDiagram";
  }
  A(n) {
    if ((n === 0)) {
      return this.Sw;
    }
    if ((n === 1)) {
      return this.Sv;
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  D(n) {
    if ((n === 0)) {
      return "kind";
    }
    if ((n === 1)) {
      return "details";
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
}
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_backends_RenderOnlyDiagram(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hk)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_backends_RenderOnlyDiagram = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_RenderOnlyDiagram, "org.jpablo.graphexplorer.viewer.backends.RenderOnlyDiagram", ({
  hk: 1,
  G: 1,
  y: 1,
  a: 1,
  b: 1,
  c: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject$Cluster(cluster) {
  this.FU = null;
  this.FU = cluster;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject$Cluster.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject$Cluster;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject$Cluster() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject$Cluster.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 1700219306, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject$Cluster)) {
    var x = this.FU;
    var x$2 = x$0.FU;
    return ((x === null) ? (x$2 === null) : x.e(x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Cluster";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.FU;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "cluster";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject$Cluster(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hw)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject$Cluster = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject$Cluster, "org.jpablo.graphexplorer.viewer.backends.graphviz.vizjs.simplegraph.SimpleGraphObject$Cluster", ({
  hw: 1,
  hv: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject$Node(node) {
  this.BU = null;
  this.BU = node;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject$Node.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject$Node;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject$Node() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject$Node.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 2014067603, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject$Node)) {
    var x = this.BU;
    var x$2 = x$0.BU;
    return ((x === null) ? (x$2 === null) : x.e(x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Node";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.BU;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "node";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject$Node(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hx)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject$Node = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject$Node, "org.jpablo.graphexplorer.viewer.backends.graphviz.vizjs.simplegraph.SimpleGraphObject$Node", ({
  hx: 1,
  hv: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$Hex(value) {
  this.C4 = null;
  this.C4 = value;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$Hex.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$Hex;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$Hex() {
}
$h_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$Hex.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 605780856, true);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$Hex) && (this.C4 === x$0.C4)));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Hex";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.C4;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$Hex(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hD)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$Hex = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$Hex, "org.jpablo.graphexplorer.viewer.color.ColorFormat$Hex", ({
  hD: 1,
  bT: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(l, c, h) {
  this.LB = 0.0;
  this.Lz = 0.0;
  this.LA = 0.0;
  this.LB = l;
  this.Lz = c;
  this.LA = h;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH() {
}
$h_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH.prototype = $p;
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 75267669);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.LB));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.Lz));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.LA));
  return $m_sr_Statics$().Z(acc, 3);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH) && (((this.LB === x$0.LB) && (this.Lz === x$0.Lz)) && (this.LA === x$0.LA))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 3;
});
$p.B = (function() {
  return "OKLCH";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.LB;
      break;
    }
    case 1: {
      return this.Lz;
      break;
    }
    case 2: {
      return this.LA;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "l";
      break;
    }
    case 1: {
      return "c";
      break;
    }
    case 2: {
      return "h";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hE)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$OKLCH, "org.jpablo.graphexplorer.viewer.color.ColorFormat$OKLCH", ({
  hE: 1,
  bT: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$RGB(r, g, b) {
  this.G4 = 0;
  this.G3 = 0;
  this.G2 = 0;
  this.G4 = r;
  this.G3 = g;
  this.G2 = b;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$RGB.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$RGB;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$RGB() {
}
$h_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$RGB.prototype = $p;
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 81069);
  acc = $m_sr_Statics$().k(acc, this.G4);
  acc = $m_sr_Statics$().k(acc, this.G3);
  acc = $m_sr_Statics$().k(acc, this.G2);
  return $m_sr_Statics$().Z(acc, 3);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$RGB) && (((this.G4 === x$0.G4) && (this.G3 === x$0.G3)) && (this.G2 === x$0.G2))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 3;
});
$p.B = (function() {
  return "RGB";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.G4;
      break;
    }
    case 1: {
      return this.G3;
      break;
    }
    case 2: {
      return this.G2;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "r";
      break;
    }
    case 1: {
      return "g";
      break;
    }
    case 2: {
      return "b";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$RGB(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hF)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$RGB = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$RGB, "org.jpablo.graphexplorer.viewer.color.ColorFormat$RGB", ({
  hF: 1,
  bT: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$RGBA(r, g, b, a) {
  this.G7 = 0;
  this.G6 = 0;
  this.G5 = 0;
  this.LC = 0.0;
  this.G7 = r;
  this.G6 = g;
  this.G5 = b;
  this.LC = a;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$RGBA.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$RGBA;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$RGBA() {
}
$h_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$RGBA.prototype = $p;
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 2513204);
  acc = $m_sr_Statics$().k(acc, this.G7);
  acc = $m_sr_Statics$().k(acc, this.G6);
  acc = $m_sr_Statics$().k(acc, this.G5);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.LC));
  return $m_sr_Statics$().Z(acc, 4);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$RGBA) && ((((this.G7 === x$0.G7) && (this.G6 === x$0.G6)) && (this.G5 === x$0.G5)) && (this.LC === x$0.LC))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 4;
});
$p.B = (function() {
  return "RGBA";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.G7;
      break;
    }
    case 1: {
      return this.G6;
      break;
    }
    case 2: {
      return this.G5;
      break;
    }
    case 3: {
      return this.LC;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "r";
      break;
    }
    case 1: {
      return "g";
      break;
    }
    case 2: {
      return "b";
      break;
    }
    case 3: {
      return "a";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$RGBA(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hG)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$RGBA = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$RGBA, "org.jpablo.graphexplorer.viewer.color.ColorFormat$RGBA", ({
  hG: 1,
  bT: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$named(value) {
  this.SF = null;
  this.SF = value;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$named.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$named;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$named() {
}
$h_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$named.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 368059864, true);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$named) && (this.SF === x$0.SF)));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "named";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.SF;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$named(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hH)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$named = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_color_ColorFormat$named, "org.jpablo.graphexplorer.viewer.color.ColorFormat$named", ({
  hH: 1,
  bT: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$NoArg(f) {
  this.SG = null;
  this.SG = f;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$NoArg.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_components_CmdAction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$NoArg;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$NoArg() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$NoArg.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-495380032), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$NoArg)) {
    var x = this.SG;
    var x$2 = x$0.SG;
    return ((x === null) ? (x$2 === null) : (x === x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "NoArg";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.SG;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "f";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$NoArg(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hK)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$NoArg = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$NoArg, "org.jpablo.graphexplorer.viewer.components.CmdAction$NoArg", ({
  hK: 1,
  hJ: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$OneArg(f) {
  this.SH = null;
  this.SH = f;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$OneArg.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_components_CmdAction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$OneArg;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$OneArg() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$OneArg.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 267351389, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$OneArg)) {
    var x = this.SH;
    var x$2 = x$0.SH;
    return ((x === null) ? (x$2 === null) : x.e(x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "OneArg";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.SH;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "f";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$OneArg(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hL)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$OneArg = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_CmdAction$OneArg, "org.jpablo.graphexplorer.viewer.components.CmdAction$OneArg", ({
  hL: 1,
  hJ: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$Conflict(currentRevision) {
  this.a0D = null;
  this.a0D = currentRevision;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$Conflict.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$Conflict;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$Conflict() {
}
$h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$Conflict.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-1586631846), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$Conflict)) {
    var x = this.a0D;
    var x$2 = x$0.a0D;
    return ((x === null) ? (x$2 === null) : x.e(x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Conflict";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.a0D;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "currentRevision";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$Conflict(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ia)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$Conflict = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$Conflict, "org.jpablo.graphexplorer.viewer.desktop.DesktopIpc$SaveOutcome$Conflict", ({
  ia: 1,
  cA: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$Failed(message) {
  this.Tb = null;
  this.Tb = message;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$Failed.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$Failed;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$Failed() {
}
$h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$Failed.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 2021931327, true);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$Failed) && (this.Tb === x$0.Tb)));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Failed";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Tb;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "message";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$Failed(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ib)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$Failed = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$Failed, "org.jpablo.graphexplorer.viewer.desktop.DesktopIpc$SaveOutcome$Failed", ({
  ib: 1,
  cA: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$Saved(path, revision) {
  this.Tc = null;
  this.M7 = null;
  this.Tc = path;
  this.M7 = revision;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$Saved.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$Saved;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$Saved() {
}
$h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$Saved.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 1344372351, true);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$Saved) && ((this.Tc === x$0.Tc) && (this.M7 === x$0.M7))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "Saved";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Tc;
  }
  if ((n === 1)) {
    return this.M7;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "path";
  }
  if ((n === 1)) {
    return "revision";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$Saved(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ic)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$Saved = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$Saved, "org.jpablo.graphexplorer.viewer.desktop.DesktopIpc$SaveOutcome$Saved", ({
  ic: 1,
  cA: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$Rejected(code, message) {
  this.Te = null;
  this.Tf = null;
  this.Te = code;
  this.Tf = message;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$Rejected.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$Rejected;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$Rejected() {
}
$h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$Rejected.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-1150235198), true);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$Rejected) && ((this.Te === x$0.Te) && (this.Tf === x$0.Tf))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "Rejected";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Te;
  }
  if ((n === 1)) {
    return this.Tf;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "code";
  }
  if ((n === 1)) {
    return "message";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$Rejected(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ie)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$Rejected = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$Rejected, "org.jpablo.graphexplorer.viewer.desktop.DesktopOpenRequests$Activation$Rejected", ({
  ie: 1,
  id: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Decision$Reject(code, message) {
  this.Tg = null;
  this.Th = null;
  this.Tg = code;
  this.Th = message;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Decision$Reject.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Decision();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Decision$Reject;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Decision$Reject() {
}
$h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Decision$Reject.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-1118908080), true);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Decision$Reject) && ((this.Tg === x$0.Tg) && (this.Th === x$0.Th))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "Reject";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Tg;
  }
  if ((n === 1)) {
    return this.Th;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "code";
  }
  if ((n === 1)) {
    return "message";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Decision$Reject(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ih)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Decision$Reject = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Decision$Reject, "org.jpablo.graphexplorer.viewer.desktop.DesktopOpenRequests$Decision$Reject", ({
  ih: 1,
  ig: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Decision$Show(route, view) {
  this.Ti = null;
  this.Tj = null;
  this.Ti = route;
  this.Tj = view;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Decision$Show.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Decision();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Decision$Show;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Decision$Show() {
}
$h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Decision$Show.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-1699955225), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Decision$Show)) {
    var x = this.Ti;
    var x$2 = x$0.Ti;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      return $m_sr_BoxesRunTime$().Q(this.Tj, x$0.Tj);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "Show";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Ti;
  }
  if ((n === 1)) {
    return this.Tj;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "route";
  }
  if ((n === 1)) {
    return "view";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Decision$Show(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ii)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Decision$Show = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Decision$Show, "org.jpablo.graphexplorer.viewer.desktop.DesktopOpenRequests$Decision$Show", ({
  ii: 1,
  ig: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$ClosePath() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$ClosePath.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$ClosePath;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$ClosePath() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$ClosePath.prototype = $p;
$p.x = (function() {
  return 1521359389;
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$ClosePath) || false));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 0;
});
$p.B = (function() {
  return "ClosePath";
});
$p.A = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$ClosePath(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iQ)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$ClosePath = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$ClosePath, "org.jpablo.graphexplorer.viewer.formats.svg.PathCommand$ClosePath", ({
  iQ: 1,
  aZ: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$CurveTo(absolute, points) {
  this.GC = false;
  this.GD = null;
  this.GC = absolute;
  this.GD = points;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$CurveTo.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$CurveTo;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$CurveTo() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$CurveTo.prototype = $p;
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, (-1503255638));
  acc = $m_sr_Statics$().k(acc, (this.GC ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.GD));
  return $m_sr_Statics$().Z(acc, 2);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$CurveTo)) {
    if ((this.GC === x$0.GC)) {
      var x = this.GD;
      var x$2 = x$0.GD;
      return ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "CurveTo";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.GC;
  }
  if ((n === 1)) {
    return this.GD;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "absolute";
  }
  if ((n === 1)) {
    return "points";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$CurveTo(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iR)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$CurveTo = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$CurveTo, "org.jpablo.graphexplorer.viewer.formats.svg.PathCommand$CurveTo", ({
  iR: 1,
  aZ: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$EllipticalArc(absolute, args) {
  this.M8 = false;
  this.M9 = null;
  this.M8 = absolute;
  this.M9 = args;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$EllipticalArc.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$EllipticalArc;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$EllipticalArc() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$EllipticalArc.prototype = $p;
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, (-608350523));
  acc = $m_sr_Statics$().k(acc, (this.M8 ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.M9));
  return $m_sr_Statics$().Z(acc, 2);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$EllipticalArc)) {
    if ((this.M8 === x$0.M8)) {
      var x = this.M9;
      var x$2 = x$0.M9;
      return ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "EllipticalArc";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.M8;
  }
  if ((n === 1)) {
    return this.M9;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "absolute";
  }
  if ((n === 1)) {
    return "args";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$EllipticalArc(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iS)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$EllipticalArc = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$EllipticalArc, "org.jpablo.graphexplorer.viewer.formats.svg.PathCommand$EllipticalArc", ({
  iS: 1,
  aZ: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$HorizontalLineTo(absolute, values) {
  this.Ma = false;
  this.Mb = null;
  this.Ma = absolute;
  this.Mb = values;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$HorizontalLineTo.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$HorizontalLineTo;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$HorizontalLineTo() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$HorizontalLineTo.prototype = $p;
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 1697423091);
  acc = $m_sr_Statics$().k(acc, (this.Ma ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Mb));
  return $m_sr_Statics$().Z(acc, 2);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$HorizontalLineTo)) {
    if ((this.Ma === x$0.Ma)) {
      var x = this.Mb;
      var x$2 = x$0.Mb;
      return ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "HorizontalLineTo";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Ma;
  }
  if ((n === 1)) {
    return this.Mb;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "absolute";
  }
  if ((n === 1)) {
    return "values";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$HorizontalLineTo(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iT)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$HorizontalLineTo = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$HorizontalLineTo, "org.jpablo.graphexplorer.viewer.formats.svg.PathCommand$HorizontalLineTo", ({
  iT: 1,
  aZ: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$LineTo(absolute, points) {
  this.GE = false;
  this.zr = null;
  this.GE = absolute;
  this.zr = points;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$LineTo.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$LineTo;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$LineTo() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$LineTo.prototype = $p;
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, (-2018805329));
  acc = $m_sr_Statics$().k(acc, (this.GE ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.zr));
  return $m_sr_Statics$().Z(acc, 2);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$LineTo)) {
    if ((this.GE === x$0.GE)) {
      var x = this.zr;
      var x$2 = x$0.zr;
      return ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "LineTo";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.GE;
  }
  if ((n === 1)) {
    return this.zr;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "absolute";
  }
  if ((n === 1)) {
    return "points";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$LineTo(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iU)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$LineTo = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$LineTo, "org.jpablo.graphexplorer.viewer.formats.svg.PathCommand$LineTo", ({
  iU: 1,
  aZ: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$MoveTo(absolute, points) {
  this.GF = false;
  this.GG = null;
  this.GF = absolute;
  this.GG = points;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$MoveTo.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$MoveTo;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$MoveTo() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$MoveTo.prototype = $p;
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, (-1984396724));
  acc = $m_sr_Statics$().k(acc, (this.GF ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.GG));
  return $m_sr_Statics$().Z(acc, 2);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$MoveTo)) {
    if ((this.GF === x$0.GF)) {
      var x = this.GG;
      var x$2 = x$0.GG;
      return ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "MoveTo";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.GF;
  }
  if ((n === 1)) {
    return this.GG;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "absolute";
  }
  if ((n === 1)) {
    return "points";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$MoveTo(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iV)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$MoveTo = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$MoveTo, "org.jpablo.graphexplorer.viewer.formats.svg.PathCommand$MoveTo", ({
  iV: 1,
  aZ: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$QuadraticBezierCurveTo(absolute, points) {
  this.Mc = false;
  this.Md = null;
  this.Mc = absolute;
  this.Md = points;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$QuadraticBezierCurveTo.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$QuadraticBezierCurveTo;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$QuadraticBezierCurveTo() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$QuadraticBezierCurveTo.prototype = $p;
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 99548115);
  acc = $m_sr_Statics$().k(acc, (this.Mc ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Md));
  return $m_sr_Statics$().Z(acc, 2);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$QuadraticBezierCurveTo)) {
    if ((this.Mc === x$0.Mc)) {
      var x = this.Md;
      var x$2 = x$0.Md;
      return ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "QuadraticBezierCurveTo";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Mc;
  }
  if ((n === 1)) {
    return this.Md;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "absolute";
  }
  if ((n === 1)) {
    return "points";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$QuadraticBezierCurveTo(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iW)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$QuadraticBezierCurveTo = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$QuadraticBezierCurveTo, "org.jpablo.graphexplorer.viewer.formats.svg.PathCommand$QuadraticBezierCurveTo", ({
  iW: 1,
  aZ: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$SmoothCurveTo(absolute, points) {
  this.Me = false;
  this.Mf = null;
  this.Me = absolute;
  this.Mf = points;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$SmoothCurveTo.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$SmoothCurveTo;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$SmoothCurveTo() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$SmoothCurveTo.prototype = $p;
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 520273436);
  acc = $m_sr_Statics$().k(acc, (this.Me ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Mf));
  return $m_sr_Statics$().Z(acc, 2);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$SmoothCurveTo)) {
    if ((this.Me === x$0.Me)) {
      var x = this.Mf;
      var x$2 = x$0.Mf;
      return ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "SmoothCurveTo";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Me;
  }
  if ((n === 1)) {
    return this.Mf;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "absolute";
  }
  if ((n === 1)) {
    return "points";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$SmoothCurveTo(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iX)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$SmoothCurveTo = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$SmoothCurveTo, "org.jpablo.graphexplorer.viewer.formats.svg.PathCommand$SmoothCurveTo", ({
  iX: 1,
  aZ: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$SmoothQuadraticBezierCurveTo(absolute, points) {
  this.Mg = false;
  this.Mh = null;
  this.Mg = absolute;
  this.Mh = points;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$SmoothQuadraticBezierCurveTo.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$SmoothQuadraticBezierCurveTo;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$SmoothQuadraticBezierCurveTo() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$SmoothQuadraticBezierCurveTo.prototype = $p;
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, (-197136607));
  acc = $m_sr_Statics$().k(acc, (this.Mg ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Mh));
  return $m_sr_Statics$().Z(acc, 2);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$SmoothQuadraticBezierCurveTo)) {
    if ((this.Mg === x$0.Mg)) {
      var x = this.Mh;
      var x$2 = x$0.Mh;
      return ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "SmoothQuadraticBezierCurveTo";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Mg;
  }
  if ((n === 1)) {
    return this.Mh;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "absolute";
  }
  if ((n === 1)) {
    return "points";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$SmoothQuadraticBezierCurveTo(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iY)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$SmoothQuadraticBezierCurveTo = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$SmoothQuadraticBezierCurveTo, "org.jpablo.graphexplorer.viewer.formats.svg.PathCommand$SmoothQuadraticBezierCurveTo", ({
  iY: 1,
  aZ: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$VerticalLineTo(absolute, values) {
  this.Mi = false;
  this.Mj = null;
  this.Mi = absolute;
  this.Mj = values;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$VerticalLineTo.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$VerticalLineTo;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$VerticalLineTo() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$VerticalLineTo.prototype = $p;
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, (-1666925371));
  acc = $m_sr_Statics$().k(acc, (this.Mi ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Mj));
  return $m_sr_Statics$().Z(acc, 2);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$VerticalLineTo)) {
    if ((this.Mi === x$0.Mi)) {
      var x = this.Mj;
      var x$2 = x$0.Mj;
      return ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "VerticalLineTo";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Mi;
  }
  if ((n === 1)) {
    return this.Mj;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "absolute";
  }
  if ((n === 1)) {
    return "values";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$VerticalLineTo(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iZ)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$VerticalLineTo = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_svg_PathCommand$VerticalLineTo, "org.jpablo.graphexplorer.viewer.formats.svg.PathCommand$VerticalLineTo", ({
  iZ: 1,
  aZ: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowEndpointId$SourceId(nodeId) {
  this.MI = null;
  this.MI = nodeId;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowEndpointId$SourceId.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_models_ArrowEndpointId();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowEndpointId$SourceId;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_ArrowEndpointId$SourceId() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_ArrowEndpointId$SourceId.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-114610054), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowEndpointId$SourceId)) {
    var x = this.MI;
    var x$2 = x$0.MI;
    return ((x === null) ? (x$2 === null) : x.e(x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "SourceId";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.MI;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "nodeId";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_models_ArrowEndpointId$SourceId(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jh)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_models_ArrowEndpointId$SourceId = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_ArrowEndpointId$SourceId, "org.jpablo.graphexplorer.viewer.models.ArrowEndpointId$SourceId", ({
  jh: 1,
  jg: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowEndpointId$TargetId(nodeId) {
  this.MJ = null;
  this.MJ = nodeId;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowEndpointId$TargetId.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_models_ArrowEndpointId();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowEndpointId$TargetId;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_ArrowEndpointId$TargetId() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_ArrowEndpointId$TargetId.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-336497244), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowEndpointId$TargetId)) {
    var x = this.MJ;
    var x$2 = x$0.MJ;
    return ((x === null) ? (x$2 === null) : x.e(x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "TargetId";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.MJ;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "nodeId";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_models_ArrowEndpointId$TargetId(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ji)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_models_ArrowEndpointId$TargetId = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_ArrowEndpointId$TargetId, "org.jpablo.graphexplorer.viewer.models.ArrowEndpointId$TargetId", ({
  ji: 1,
  jg: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single(value) {
  this.nd = null;
  this.nd = value;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 472700481, true);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single) && $m_sr_BoxesRunTime$().Q(this.nd, x$0.nd)));
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Single";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.nd;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jk)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$Single, "org.jpablo.graphexplorer.viewer.models.AttrStatus$Single", ({
  jk: 1,
  dn: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId(value) {
  this.dR = null;
  this.dR = value;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_GroupId() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_GroupId.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 99628631, true);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId) && (this.dR === x$0.dR)));
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "GroupId";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.dR;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.Q9 = (function() {
  return this.dR;
});
$p.m = (function() {
  return this.dR;
});
$p.kx = (function() {
  return ("group:" + this.dR);
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_models_GroupId(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jq)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_models_GroupId = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_GroupId, "org.jpablo.graphexplorer.viewer.models.GroupId", ({
  jq: 1,
  cB: 1,
  cC: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId(value) {
  this.dE = null;
  this.dE = value;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_NodeId() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_NodeId.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 666538553, true);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId) && (this.dE === x$0.dE)));
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "NodeId";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.dE;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.Q9 = (function() {
  return this.dE;
});
$p.m = (function() {
  return this.dE;
});
$p.kx = (function() {
  return ("node:" + this.dE);
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_models_NodeId(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jt)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_models_NodeId = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_NodeId, "org.jpablo.graphexplorer.viewer.models.NodeId", ({
  jt: 1,
  cB: 1,
  cC: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$Failed(message) {
  this.TE = null;
  this.TE = message;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$Failed.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$Failed;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$Failed() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$Failed.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 2021931327, true);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$Failed) && (this.TE === x$0.TE)));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Failed";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.TE;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "message";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$Failed(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jx)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$Failed = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$Failed, "org.jpablo.graphexplorer.viewer.state.DiagramLoadStatus$Failed", ({
  jx: 1,
  dq: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$RenderOnly(details) {
  this.a0Q = null;
  this.a0Q = details;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$RenderOnly.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$RenderOnly;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$RenderOnly() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$RenderOnly.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 336599961, true);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$RenderOnly) && (this.a0Q === x$0.a0Q)));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "RenderOnly";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.a0Q;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "details";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$RenderOnly(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jy)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$RenderOnly = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$RenderOnly, "org.jpablo.graphexplorer.viewer.state.DiagramLoadStatus$RenderOnly", ({
  jy: 1,
  dq: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent$Navigate(route) {
  this.TL = null;
  this.TL = route;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent$Navigate.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent$Navigate;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent$Navigate() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent$Navigate.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-2033013874), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent$Navigate)) {
    var x = this.TL;
    var x$2 = x$0.TL;
    return ((x === null) ? (x$2 === null) : x.e(x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Navigate";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.TL;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "route";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent$Navigate(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jH)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent$Navigate = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent$Navigate, "org.jpablo.graphexplorer.viewer.state.LeaveIntent$Navigate", ({
  jH: 1,
  jG: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$Conflict(message) {
  this.MS = null;
  this.MS = message;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$Conflict.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_state_SaveResult();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$Conflict;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$Conflict() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$Conflict.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-1586631846), true);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$Conflict) && (this.MS === x$0.MS)));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Conflict";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.MS;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "message";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$Conflict(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jQ)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$Conflict = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$Conflict, "org.jpablo.graphexplorer.viewer.state.SaveResult$Conflict", ({
  jQ: 1,
  cE: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$Failed(message) {
  this.MT = null;
  this.MT = message;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$Failed.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_state_SaveResult();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$Failed;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$Failed() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$Failed.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 2021931327, true);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$Failed) && (this.MT === x$0.MT)));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Failed";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.MT;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "message";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$Failed(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jR)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$Failed = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$Failed, "org.jpablo.graphexplorer.viewer.state.SaveResult$Failed", ({
  jR: 1,
  cE: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$Unsupported(message) {
  this.MU = null;
  this.MU = message;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$Unsupported.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_state_SaveResult();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$Unsupported;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$Unsupported() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$Unsupported.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-381909262), true);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$Unsupported) && (this.MU === x$0.MU)));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Unsupported";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.MU;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "message";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$Unsupported(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jS)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$Unsupported = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$Unsupported, "org.jpablo.graphexplorer.viewer.state.SaveResult$Unsupported", ({
  jS: 1,
  cE: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$Example(slug, name) {
  this.TS = null;
  this.MV = null;
  this.TS = slug;
  this.MV = name;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$Example.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$Example;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$Example() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$Example.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-1309886510), true);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$Example) && ((this.TS === x$0.TS) && (this.MV === x$0.MV))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "Example";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.TS;
  }
  if ((n === 1)) {
    return this.MV;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "slug";
  }
  if ((n === 1)) {
    return "name";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$Example(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jW)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$Example = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$Example, "org.jpablo.graphexplorer.viewer.state.ViewTarget$Example", ({
  jW: 1,
  ds: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$LibraryDiagram(id) {
  this.xp = null;
  this.xp = id;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$LibraryDiagram.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$LibraryDiagram;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$LibraryDiagram() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$LibraryDiagram.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 1789437944, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$LibraryDiagram)) {
    var x = this.xp;
    var x$2 = x$0.xp;
    return ((x === null) ? (x$2 === null) : x.e(x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "LibraryDiagram";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.xp;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "id";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$LibraryDiagram(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jX)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$LibraryDiagram = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$LibraryDiagram, "org.jpablo.graphexplorer.viewer.state.ViewTarget$LibraryDiagram", ({
  jX: 1,
  ds: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$LooseFile(session) {
  this.tq = null;
  this.tq = session;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$LooseFile.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$LooseFile;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$LooseFile() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$LooseFile.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 551339866, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$LooseFile)) {
    var x = this.tq;
    var x$2 = x$0.tq;
    return ((x === null) ? (x$2 === null) : x.e(x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "LooseFile";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.tq;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "session";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$LooseFile(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jY)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$LooseFile = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$LooseFile, "org.jpablo.graphexplorer.viewer.state.ViewTarget$LooseFile", ({
  jY: 1,
  ds: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$AddNewArrowAction(rect, originator, direction, sourceCellPath) {
  this.ts = null;
  this.zJ = null;
  this.Hb = null;
  this.CK = null;
  this.ts = rect;
  this.zJ = originator;
  this.Hb = direction;
  this.CK = sourceCellPath;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$AddNewArrowAction.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$AddNewArrowAction;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$AddNewArrowAction() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$AddNewArrowAction.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 254351240, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$AddNewArrowAction)) {
    var x = this.ts;
    var x$2 = x$0.ts;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      var x$3 = this.zJ;
      var x$4 = x$0.zJ;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.Hb;
      var x$6 = x$0.Hb;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : (x$5 === x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$7 = this.CK;
      var x$8 = x$0.CK;
      return ((x$7 === null) ? (x$8 === null) : x$7.e(x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 4;
});
$p.B = (function() {
  return "AddNewArrowAction";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.ts;
      break;
    }
    case 1: {
      return this.zJ;
      break;
    }
    case 2: {
      return this.Hb;
      break;
    }
    case 3: {
      return this.CK;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "rect";
      break;
    }
    case 1: {
      return "originator";
      break;
    }
    case 2: {
      return "direction";
      break;
    }
    case 3: {
      return "sourceCellPath";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$AddNewArrowAction(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.k4)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$AddNewArrowAction = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$AddNewArrowAction, "org.jpablo.graphexplorer.viewer.state.mouseActions.MouseAction$AddNewArrowAction", ({
  k4: 1,
  cF: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$ExtendSelectionAction(rect) {
  this.zK = null;
  this.zK = rect;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$ExtendSelectionAction.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$ExtendSelectionAction;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$ExtendSelectionAction() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$ExtendSelectionAction.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-188748604), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$ExtendSelectionAction)) {
    var x = this.zK;
    var x$2 = x$0.zK;
    return ((x === null) ? (x$2 === null) : x.e(x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "ExtendSelectionAction";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.zK;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "rect";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$ExtendSelectionAction(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.k5)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$ExtendSelectionAction = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$ExtendSelectionAction, "org.jpablo.graphexplorer.viewer.state.mouseActions.MouseAction$ExtendSelectionAction", ({
  k5: 1,
  cF: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$MoveArrowEndpointAction(rect, originator, endpoint) {
  this.tt = null;
  this.zM = null;
  this.zL = null;
  this.tt = rect;
  this.zM = originator;
  this.zL = endpoint;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$MoveArrowEndpointAction.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$MoveArrowEndpointAction;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$MoveArrowEndpointAction() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$MoveArrowEndpointAction.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-1417099744), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$MoveArrowEndpointAction)) {
    var x = this.tt;
    var x$2 = x$0.tt;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      var x$3 = this.zM;
      var x$4 = x$0.zM;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.zL;
      var x$6 = x$0.zL;
      return ((x$5 === null) ? (x$6 === null) : (x$5 === x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 3;
});
$p.B = (function() {
  return "MoveArrowEndpointAction";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.tt;
      break;
    }
    case 1: {
      return this.zM;
      break;
    }
    case 2: {
      return this.zL;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "rect";
      break;
    }
    case 1: {
      return "originator";
      break;
    }
    case 2: {
      return "endpoint";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$MoveArrowEndpointAction(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.k6)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$MoveArrowEndpointAction = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$MoveArrowEndpointAction, "org.jpablo.graphexplorer.viewer.state.mouseActions.MouseAction$MoveArrowEndpointAction", ({
  k6: 1,
  cF: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$currentValueWithSelector(dir, cardClass, open) {
  this.N8 = null;
  this.N7 = null;
  this.N9 = false;
  this.N8 = dir;
  this.N7 = cardClass;
  this.N9 = open;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$currentValueWithSelector.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_widgets_InputType();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$currentValueWithSelector;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$currentValueWithSelector() {
}
$h_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$currentValueWithSelector.prototype = $p;
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, 1781541469);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.N8));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.N7));
  acc = $m_sr_Statics$().k(acc, (this.N9 ? 1231 : 1237));
  return $m_sr_Statics$().Z(acc, 3);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$currentValueWithSelector)) {
    if ((this.N9 === x$0.N9)) {
      var x = this.N8;
      var x$2 = x$0.N8;
      var $x_1 = ((x === null) ? (x$2 === null) : (x === x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.N7;
      var x$4 = x$0.N7;
      return ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 3;
});
$p.B = (function() {
  return "currentValueWithSelector";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.N8;
      break;
    }
    case 1: {
      return this.N7;
      break;
    }
    case 2: {
      return this.N9;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "dir";
      break;
    }
    case 1: {
      return "cardClass";
      break;
    }
    case 2: {
      return "open";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$currentValueWithSelector(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kb)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$currentValueWithSelector = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$currentValueWithSelector, "org.jpablo.graphexplorer.viewer.widgets.InputType$currentValueWithSelector", ({
  kb: 1,
  bD: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$menuWithExtra(initial, dir, cardClass) {
  this.CM = 0;
  this.Hf = null;
  this.He = null;
  this.CM = initial;
  this.Hf = dir;
  this.He = cardClass;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$menuWithExtra.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_widgets_InputType();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$menuWithExtra;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$menuWithExtra() {
}
$h_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$menuWithExtra.prototype = $p;
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, (-484301749));
  acc = $m_sr_Statics$().k(acc, this.CM);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Hf));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.He));
  return $m_sr_Statics$().Z(acc, 3);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$menuWithExtra)) {
    if ((this.CM === x$0.CM)) {
      var x = this.Hf;
      var x$2 = x$0.Hf;
      var $x_1 = ((x === null) ? (x$2 === null) : (x === x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.He;
      var x$4 = x$0.He;
      return ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 3;
});
$p.B = (function() {
  return "menuWithExtra";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.CM;
      break;
    }
    case 1: {
      return this.Hf;
      break;
    }
    case 2: {
      return this.He;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "initial";
      break;
    }
    case 1: {
      return "dir";
      break;
    }
    case 2: {
      return "cardClass";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$menuWithExtra(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kc)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$menuWithExtra = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$menuWithExtra, "org.jpablo.graphexplorer.viewer.widgets.InputType$menuWithExtra", ({
  kc: 1,
  bD: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$multiText(setFocus) {
  this.Hg = false;
  this.Hg = setFocus;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$multiText.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_widgets_InputType();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$multiText;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$multiText() {
}
$h_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$multiText.prototype = $p;
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, (-1206957562));
  acc = $m_sr_Statics$().k(acc, (this.Hg ? 1231 : 1237));
  return $m_sr_Statics$().Z(acc, 1);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$multiText) && (this.Hg === x$0.Hg)));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "multiText";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Hg;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "setFocus";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$multiText(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kd)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$multiText = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$multiText, "org.jpablo.graphexplorer.viewer.widgets.InputType$multiText", ({
  kd: 1,
  bD: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$number(start, end, step) {
  this.Ua = null;
  this.U9 = null;
  this.Ub = null;
  this.Ua = start;
  this.U9 = end;
  this.Ub = step;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$number.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_widgets_InputType();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$number;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$number() {
}
$h_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$number.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-1383835069), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$number)) {
    var x = this.Ua;
    var x$2 = x$0.Ua;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      var x$3 = this.U9;
      var x$4 = x$0.U9;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Ub;
      var x$6 = x$0.Ub;
      return ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 3;
});
$p.B = (function() {
  return "number";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.Ua;
      break;
    }
    case 1: {
      return this.U9;
      break;
    }
    case 2: {
      return this.Ub;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "start";
      break;
    }
    case 1: {
      return "end";
      break;
    }
    case 2: {
      return "step";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$number(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ke)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$number = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$number, "org.jpablo.graphexplorer.viewer.widgets.InputType$number", ({
  ke: 1,
  bD: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$range(start, end, step) {
  this.Nb = null;
  this.Na = null;
  this.Nc = null;
  this.Nb = start;
  this.Na = end;
  this.Nc = step;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$range.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_widgets_InputType();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$range;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$range() {
}
$h_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$range.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 654857633, true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$range)) {
    var x = this.Nb;
    var x$2 = x$0.Nb;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      var x$3 = this.Na;
      var x$4 = x$0.Na;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Nc;
      var x$6 = x$0.Nc;
      return ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 3;
});
$p.B = (function() {
  return "range";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.Nb;
      break;
    }
    case 1: {
      return this.Na;
      break;
    }
    case 2: {
      return this.Nc;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "start";
      break;
    }
    case 1: {
      return "end";
      break;
    }
    case 2: {
      return "step";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$range(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kf)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$range = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$range, "org.jpablo.graphexplorer.viewer.widgets.InputType$range", ({
  kf: 1,
  bD: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$MenuOption(elem, value, description, shortcut) {
  this.Ud = null;
  this.Uf = null;
  this.Uc = null;
  this.Ue = null;
  this.Ud = elem;
  this.Uf = value;
  this.Uc = description;
  this.Ue = shortcut;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$MenuOption.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$MenuOption;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$MenuOption() {
}
$h_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$MenuOption.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-1711332372), true);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$MenuOption)) {
    if (($m_sr_BoxesRunTime$().Q(this.Ud, x$0.Ud) && $m_sr_BoxesRunTime$().Q(this.Uf, x$0.Uf))) {
      var x$2 = this.Uc;
      var x$2$1 = x$0.Uc;
      var $x_1 = ((x$2 === null) ? (x$2$1 === null) : x$2.e(x$2$1));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.Ue;
      var x$4 = x$0.Ue;
      return ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 4;
});
$p.B = (function() {
  return "MenuOption";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.Ud;
      break;
    }
    case 1: {
      return this.Uf;
      break;
    }
    case 2: {
      return this.Uc;
      break;
    }
    case 3: {
      return this.Ue;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "elem";
      break;
    }
    case 1: {
      return "value";
      break;
    }
    case 2: {
      return "description";
      break;
    }
    case 3: {
      return "shortcut";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$MenuOption(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kh)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$MenuOption = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$MenuOption, "org.jpablo.graphexplorer.viewer.widgets.MenuEntry$MenuOption", ({
  kh: 1,
  kg: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1
}));
/** @constructor */
function $c_Lpprint_package$() {
  this.Uy = null;
  this.CQ = 0;
  this.CO = 0;
  this.CP = 0;
  this.CN = false;
  this.Hk = false;
  this.Hj = null;
  this.Hi = null;
  this.Hh = null;
  $ct_Lpprint_PPrinter__I__I__I__Z__Z__Lfansi_Attrs__Lfansi_Attrs__s_PartialFunction__(this, 100, 500, 2, false, true, $m_Lfansi_Color$().Z4, $m_Lfansi_Color$().a6O, $m_s_PartialFunction$().gt);
}
$p = $c_Lpprint_package$.prototype = new $h_Lpprint_PPrinter();
$p.constructor = $c_Lpprint_package$;
/** @constructor */
function $h_Lpprint_package$() {
}
$h_Lpprint_package$.prototype = $p;
var $d_Lpprint_package$ = new $TypeData().i($c_Lpprint_package$, "pprint.package$", ({
  FS: 1,
  ki: 1,
  FR: 1,
  b: 1,
  c: 1,
  a: 1
}));
var $n_Lpprint_package$;
function $m_Lpprint_package$() {
  if ((!$n_Lpprint_package$)) {
    $n_Lpprint_package$ = new $c_Lpprint_package$();
  }
  return $n_Lpprint_package$;
}
/** @constructor */
function $c_s_None$() {
}
$p = $c_s_None$.prototype = new $h_s_Option();
$p.constructor = $c_s_None$;
/** @constructor */
function $h_s_None$() {
}
$h_s_None$.prototype = $p;
$p.eO = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "None.get");
});
$p.B = (function() {
  return "None";
});
$p.z = (function() {
  return 0;
});
$p.A = (function(x$1) {
  return $m_sr_Statics$().ey(x$1);
});
$p.H = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$p.x = (function() {
  return 2433880;
});
$p.m = (function() {
  return "None";
});
$p.d = (function() {
  this.eO();
});
var $d_s_None$ = new $TypeData().i($c_s_None$, "scala.None$", ({
  Gc: 1,
  dv: 1,
  e: 1,
  c: 1,
  b: 1,
  a: 1
}));
var $n_s_None$;
function $m_s_None$() {
  if ((!$n_s_None$)) {
    $n_s_None$ = new $c_s_None$();
  }
  return $n_s_None$;
}
/** @constructor */
function $c_s_Some(value) {
  this.J = null;
  this.J = value;
}
$p = $c_s_Some.prototype = new $h_s_Option();
$p.constructor = $c_s_Some;
/** @constructor */
function $h_s_Some() {
}
$h_s_Some.prototype = $p;
$p.d = (function() {
  return this.J;
});
$p.B = (function() {
  return "Some";
});
$p.z = (function() {
  return 1;
});
$p.A = (function(x$1) {
  return ((x$1 === 0) ? this.J : $m_sr_Statics$().ey(x$1));
});
$p.H = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$p.D = (function(x$1) {
  return ((x$1 === 0) ? "value" : $m_sr_Statics$().ey(x$1));
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, 1323286827, true);
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.e = (function(x$1) {
  return ((this === x$1) || ((x$1 instanceof $c_s_Some) && $m_sr_BoxesRunTime$().Q(this.J, x$1.J)));
});
function $isArrayOf_s_Some(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ku)));
}
var $d_s_Some = new $TypeData().i($c_s_Some, "scala.Some", ({
  ku: 1,
  dv: 1,
  e: 1,
  c: 1,
  b: 1,
  a: 1
}));
/** @constructor */
function $c_sc_AbstractIterable() {
}
$p = $c_sc_AbstractIterable.prototype = new $h_O();
$p.constructor = $c_sc_AbstractIterable;
/** @constructor */
function $h_sc_AbstractIterable() {
}
$h_sc_AbstractIterable.prototype = $p;
$p.cd = (function() {
  return $m_sc_Iterable$();
});
$p.hM = (function() {
  return this.el();
});
$p.el = (function() {
  return "Iterable";
});
$p.m = (function() {
  return $f_sc_Iterable__toString__T(this);
});
$p.w4 = (function(coll) {
  return this.cd().cc(coll);
});
$p.fS = (function() {
  return this.cd().b5();
});
$p.pr = (function() {
  return this.cd().aO();
});
$p.t = (function() {
  return this.o().q();
});
$p.dt = (function() {
  return $f_sc_IterableOps__headOption__s_Option(this);
});
$p.bJ = (function() {
  return $f_sc_IterableOps__last__O(this);
});
$p.nE = (function(otherSize) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, otherSize);
});
$p.bw = (function(pred) {
  return $f_sc_IterableOps__filter__F1__O(this, pred);
});
$p.cE = (function(pred) {
  return $f_sc_IterableOps__filterNot__F1__O(this, pred);
});
$p.un = (function(p) {
  return $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(new $c_sc_IterableOps$WithFilter(), this, p);
});
$p.ju = (function(p) {
  return $f_sc_IterableOps__partition__F1__T2(this, p);
});
$p.uj = (function(p) {
  return $f_sc_IterableOps__takeWhile__F1__O(this, p);
});
$p.PW = (function(p) {
  return $f_sc_IterableOps__span__F1__T2(this, p);
});
$p.ds = (function(n) {
  return $f_sc_IterableOps__drop__I__O(this, n);
});
$p.cn = (function(n) {
  return $f_sc_IterableOps__dropRight__I__O(this, n);
});
$p.tW = (function(p) {
  return $f_sc_IterableOps__dropWhile__F1__O(this, p);
});
$p.v = (function() {
  return $f_sc_IterableOps__tail__O(this);
});
$p.lX = (function() {
  return $f_sc_IterableOps__init__O(this);
});
$p.L = (function(f) {
  return $f_sc_IterableOps__map__F1__O(this, f);
});
$p.c5 = (function(f) {
  return $f_sc_IterableOps__flatMap__F1__O(this, f);
});
$p.dk = (function(asIterable) {
  return this.c5(asIterable);
});
$p.ct = (function(pf) {
  return $f_sc_IterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.fy = (function(f) {
  return $f_sc_IterableOps__partitionMap__F1__T2(this, f);
});
$p.g9 = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$p.Es = (function() {
  return $f_sc_IterableOps__zipWithIndex__O(this);
});
$p.fa = (function(asPair) {
  return $f_sc_IterableOps__unzip__F1__T2(this, asPair);
});
$p.F = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f);
});
$p.lV = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p);
});
$p.lU = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p);
});
$p.iW = (function(p) {
  return $f_sc_IterableOnceOps__find__F1__s_Option(this, p);
});
$p.hO = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$p.kT = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$p.c = (function() {
  return $f_sc_IterableOnceOps__isEmpty__Z(this);
});
$p.aa = (function() {
  return $f_sc_IterableOnceOps__size__I(this);
});
$p.cR = (function(dest, start, n) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, dest, start, n);
});
$p.k2 = (function(num) {
  return $f_sc_IterableOnceOps__sum__s_math_Numeric__O(this, num);
});
$p.lr = (function(ord) {
  return $f_sc_IterableOnceOps__min__s_math_Ordering__O(this, ord);
});
$p.lq = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord);
});
$p.nw = (function(pf) {
  return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this, pf);
});
$p.lf = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$p.bM = (function() {
  return $m_sci_Nil$().b6(this);
});
$p.d2 = (function() {
  return $m_sci_Vector$().X(this);
});
$p.eX = (function(ev) {
  return $m_sci_Map$().ao(this);
});
$p.iz = (function() {
  return $m_sci_Seq$().fw(this);
});
$p.nG = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$p.k0 = (function() {
  return $f_sc_IterableOnceOps__reversed__sc_Iterable(this);
});
$p.V = (function() {
  return (-1);
});
$p.fP = (function(coll) {
  return this.w4(coll);
});
function $ct_sc_ArrayOps$ArrayIterator__O__($thiz, xs) {
  $thiz.qv = xs;
  $thiz.cG = 0;
  $thiz.p6 = $m_jl_reflect_Array$().c6($thiz.qv);
  return $thiz;
}
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator() {
  this.qv = null;
  this.cG = 0;
  this.p6 = 0;
}
$p = $c_sc_ArrayOps$ArrayIterator.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_ArrayOps$ArrayIterator;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator() {
}
$h_sc_ArrayOps$ArrayIterator.prototype = $p;
$p.V = (function() {
  return ((this.p6 - this.cG) | 0);
});
$p.p = (function() {
  return (this.cG < this.p6);
});
$p.q = (function() {
  if ((this.cG >= $m_jl_reflect_Array$().c6(this.qv))) {
    $m_sc_Iterator$().b8.q();
  }
  var r = $m_sr_ScalaRunTime$().f6(this.qv, this.cG);
  this.cG = ((1 + this.cG) | 0);
  return r;
});
$p.iV = (function(n) {
  if ((n > 0)) {
    var newPos = ((this.cG + n) | 0);
    if ((newPos < 0)) {
      var $x_1 = this.p6;
    } else {
      var a = this.p6;
      var $x_1 = ((a < newPos) ? a : newPos);
    }
    this.cG = $x_1;
  }
  return this;
});
var $d_sc_ArrayOps$ArrayIterator = new $TypeData().i($c_sc_ArrayOps$ArrayIterator, "scala.collection.ArrayOps$ArrayIterator", ({
  b0: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1,
  a: 1
}));
function $p_sc_IndexedSeqView$IndexedSeqViewIterator__formatRange$1__I__I($thiz, value) {
  return ((value < 0) ? 0 : ((value > $thiz.qw) ? $thiz.qw : value));
}
function $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__($thiz, self) {
  $thiz.ac0 = self;
  $thiz.zR = 0;
  $thiz.qw = self.C();
  return $thiz;
}
/** @constructor */
function $c_sc_IndexedSeqView$IndexedSeqViewIterator() {
  this.ac0 = null;
  this.zR = 0;
  this.qw = 0;
}
$p = $c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_IndexedSeqView$IndexedSeqViewIterator;
/** @constructor */
function $h_sc_IndexedSeqView$IndexedSeqViewIterator() {
}
$h_sc_IndexedSeqView$IndexedSeqViewIterator.prototype = $p;
$p.V = (function() {
  return this.qw;
});
$p.p = (function() {
  return (this.qw > 0);
});
$p.q = (function() {
  if ((this.qw > 0)) {
    var r = this.ac0.l(this.zR);
    this.zR = ((1 + this.zR) | 0);
    this.qw = ((this.qw - 1) | 0);
    return r;
  } else {
    return $m_sc_Iterator$().b8.q();
  }
});
$p.iV = (function(n) {
  if ((n > 0)) {
    this.zR = ((this.zR + n) | 0);
    var b = ((this.qw - n) | 0);
    this.qw = ((b < 0) ? 0 : b);
  }
  return this;
});
$p.ui = (function(from, until) {
  var formatFrom = $p_sc_IndexedSeqView$IndexedSeqViewIterator__formatRange$1__I__I(this, from);
  var formatUntil = $p_sc_IndexedSeqView$IndexedSeqViewIterator__formatRange$1__I__I(this, until);
  var b = ((formatUntil - formatFrom) | 0);
  this.qw = ((b < 0) ? 0 : b);
  this.zR = ((this.zR + formatFrom) | 0);
  return this;
});
var $d_sc_IndexedSeqView$IndexedSeqViewIterator = new $TypeData().i($c_sc_IndexedSeqView$IndexedSeqViewIterator, "scala.collection.IndexedSeqView$IndexedSeqViewIterator", ({
  kJ: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1,
  a: 1
}));
function $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__($thiz, self) {
  $thiz.ac1 = self;
  $thiz.kc = self.C();
  $thiz.Hn = (($thiz.kc - 1) | 0);
  return $thiz;
}
/** @constructor */
function $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator() {
  this.ac1 = null;
  this.kc = 0;
  this.Hn = 0;
}
$p = $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator;
/** @constructor */
function $h_sc_IndexedSeqView$IndexedSeqViewReverseIterator() {
}
$h_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype = $p;
$p.p = (function() {
  return (this.kc > 0);
});
$p.q = (function() {
  if ((this.kc > 0)) {
    var r = this.ac1.l(this.Hn);
    this.Hn = ((this.Hn - 1) | 0);
    this.kc = ((this.kc - 1) | 0);
    return r;
  } else {
    return $m_sc_Iterator$().b8.q();
  }
});
$p.ui = (function(from, until) {
  if ((this.kc > 0)) {
    if ((this.kc <= from)) {
      this.kc = 0;
    } else if ((from <= 0)) {
      if (((until >= 0) && (until < this.kc))) {
        this.kc = until;
      }
    } else {
      this.Hn = ((this.Hn - from) | 0);
      if (((until >= 0) && (until < this.kc))) {
        if ((until <= from)) {
          this.kc = 0;
        } else {
          this.kc = ((until - from) | 0);
        }
      } else {
        this.kc = ((this.kc - from) | 0);
      }
    }
  }
  return this;
});
var $d_sc_IndexedSeqView$IndexedSeqViewReverseIterator = new $TypeData().i($c_sc_IndexedSeqView$IndexedSeqViewReverseIterator, "scala.collection.IndexedSeqView$IndexedSeqViewReverseIterator", ({
  kK: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1,
  a: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$21() {
  this.Ve = null;
  $ct_scm_ImmutableBuilder__sc_IterableOnce__(this, $m_sc_Iterator$().b8);
}
$p = $c_sc_Iterator$$anon$21.prototype = new $h_scm_ImmutableBuilder();
$p.constructor = $c_sc_Iterator$$anon$21;
/** @constructor */
function $h_sc_Iterator$$anon$21() {
}
$h_sc_Iterator$$anon$21.prototype = $p;
$p.aWI = (function(elem) {
  this.Ve = this.Ve.lS(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => new $c_sc_Iterator$$anon$20(elem))));
  return this;
});
$p.Y = (function(elem) {
  return this.aWI(elem);
});
var $d_sc_Iterator$$anon$21 = new $TypeData().i($c_sc_Iterator$$anon$21, "scala.collection.Iterator$$anon$21", ({
  H6: 1,
  K1: 1,
  b2: 1,
  Y: 1,
  T: 1,
  S: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$7(outer, pf$1) {
  this.aHM = null;
  this.NL = 0;
  this.aca = null;
  this.aHN = null;
  this.aca = outer;
  this.aHN = pf$1;
  this.NL = 0;
}
$p = $c_sc_Iterator$$anon$7.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_Iterator$$anon$7;
/** @constructor */
function $h_sc_Iterator$$anon$7() {
}
$h_sc_Iterator$$anon$7.prototype = $p;
$p.iU = (function(v1) {
});
$p.m = (function() {
  return "<function1>";
});
$p.i = (function(value) {
  return $m_sr_Statics$PFMarker$();
});
$p.p = (function() {
  var marker = $m_sr_Statics$PFMarker$();
  while ((this.NL === 0)) {
    if (this.aca.p()) {
      var x = this.aca.q();
      var v = this.aHN.aC(x, this);
      if ((marker !== v)) {
        this.aHM = v;
        this.NL = 1;
      }
    } else {
      this.NL = (-1);
    }
  }
  return (this.NL === 1);
});
$p.q = (function() {
  if (this.p()) {
    this.NL = 0;
    return this.aHM;
  } else {
    return $m_sc_Iterator$().b8.q();
  }
});
var $d_sc_Iterator$$anon$7 = new $TypeData().i($c_sc_Iterator$$anon$7, "scala.collection.Iterator$$anon$7", ({
  Hc: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1,
  h: 1
}));
function $f_sc_MapOps__getOrElse__O__F0__O($thiz, key, default$1) {
  var x1 = $thiz.r(key);
  if ((x1 instanceof $c_s_Some)) {
    return x1.J;
  } else if (($m_s_None$() === x1)) {
    return default$1.a3();
  } else {
    throw new $c_s_MatchError(x1);
  }
}
function $f_sc_MapOps__apply__O__O($thiz, key) {
  var x1 = $thiz.r(key);
  if (($m_s_None$() === x1)) {
    return $thiz.WC(key);
  } else if ((x1 instanceof $c_s_Some)) {
    return x1.J;
  } else {
    throw new $c_s_MatchError(x1);
  }
}
function $f_sc_MapOps__applyOrElse__O__F1__O($thiz, x, default$1) {
  return $thiz.ay(x, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => default$1.i(x))));
}
function $f_sc_MapOps__foreachEntry__F2__V($thiz, f) {
  var it = $thiz.o();
  while (it.p()) {
    var next = it.q();
    f.R(next.g(), next.h());
  }
}
function $f_sc_MapOps__default__O__O($thiz, key) {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key));
}
function $f_sc_MapOps__contains__O__Z($thiz, key) {
  return (!$thiz.r(key).c());
}
function $f_sc_MapOps__map__F1__sc_IterableOps($thiz, f) {
  return $thiz.im().cc($ct_sc_View$Map__sc_IterableOps__F1__(new $c_sc_View$Map(), $thiz, f));
}
function $f_sc_MapOps__collect__s_PartialFunction__sc_IterableOps($thiz, pf) {
  return $thiz.im().cc(new $c_sc_View$Collect($thiz, pf));
}
function $f_sc_MapOps__flatMap__F1__sc_IterableOps($thiz, f) {
  return $thiz.im().cc(new $c_sc_View$FlatMap($thiz, f));
}
function $f_sc_MapOps__concat__sc_IterableOnce__sc_IterableOps($thiz, suffix) {
  return $thiz.im().cc(($is_sc_Iterable(suffix) ? new $c_sc_View$Concat($thiz, suffix) : $thiz.o().lS(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => suffix.o())))));
}
function $f_sc_MapOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder($thiz, sb, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(new $c_sc_Iterator$$anon$9($thiz.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x0$1$2$2) => {
    if ((x0$1$2$2 !== null)) {
      var k = x0$1$2$2.g();
      var v = x0$1$2$2.h();
      return ((k + " -> ") + v);
    } else {
      throw new $c_s_MatchError(x0$1$2$2);
    }
  }))), sb, start, sep, end);
}
function $f_sc_StrictOptimizedSeqOps__distinctBy__F1__O($thiz, f) {
  var builder = $thiz.fS();
  var seen = $ct_scm_HashSet__(new $c_scm_HashSet());
  var it = $thiz.o();
  while (it.p()) {
    var next = it.q();
    if (seen.oA(f.i(next))) {
      builder.Y(next);
    }
  }
  return builder.aR();
}
function $f_sc_StrictOptimizedSeqOps__prepended__O__O($thiz, elem) {
  var b = $thiz.nB().b5();
  $f_scm_Builder__sizeHint__sc_IterableOnce__I__V(b, $thiz, 1);
  b.Y(elem);
  b.dG($thiz);
  return b.aR();
}
function $f_sc_StrictOptimizedSeqOps__appended__O__O($thiz, elem) {
  var b = $thiz.nB().b5();
  $f_scm_Builder__sizeHint__sc_IterableOnce__I__V(b, $thiz, 1);
  b.dG($thiz);
  b.Y(elem);
  return b.aR();
}
function $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O($thiz, suffix) {
  var b = $thiz.nB().b5();
  b.dG($thiz);
  b.dG(suffix);
  return b.aR();
}
function $p_sci_ArraySeq$__emptyImpl$lzycompute__sci_ArraySeq$ofRef($thiz) {
  if ((!$thiz.acz)) {
    $thiz.acA = new $c_sci_ArraySeq$ofRef(new $ac_O(0));
    $thiz.acz = true;
  }
  return $thiz.acA;
}
function $p_sci_ArraySeq$__emptyImpl__sci_ArraySeq$ofRef($thiz) {
  return ((!$thiz.acz) ? $p_sci_ArraySeq$__emptyImpl$lzycompute__sci_ArraySeq$ofRef($thiz) : $thiz.acA);
}
/** @constructor */
function $c_sci_ArraySeq$() {
  this.acA = null;
  this.acB = null;
  this.acz = false;
  $n_sci_ArraySeq$ = this;
  this.acB = new $c_sc_ClassTagSeqFactory$AnySeqDelegate(this);
}
$p = $c_sci_ArraySeq$.prototype = new $h_O();
$p.constructor = $c_sci_ArraySeq$;
/** @constructor */
function $h_sci_ArraySeq$() {
}
$h_sci_ArraySeq$.prototype = $p;
$p.ag1 = (function(it, tag) {
  return ((it instanceof $c_sci_ArraySeq) ? it : this.n0($m_s_Array$().aOp(it, tag)));
});
$p.a4e = (function(evidence$2) {
  return new $c_scm_Builder$$anon$1(($m_scm_ArrayBuffer$(), new $c_scm_ArrayBuffer$$anon$1()), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((b$2$2) => $m_sci_ArraySeq$().n0($f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(b$2$2, evidence$2)))));
});
$p.n0 = (function(x) {
  if ((x === null)) {
    return null;
  } else if ((x instanceof $ac_O)) {
    return new $c_sci_ArraySeq$ofRef(x);
  } else if ((x instanceof $ac_I)) {
    return new $c_sci_ArraySeq$ofInt(x);
  } else if ((x instanceof $ac_D)) {
    return new $c_sci_ArraySeq$ofDouble(x);
  } else if ((x instanceof $ac_J)) {
    return new $c_sci_ArraySeq$ofLong(x);
  } else if ((x instanceof $ac_F)) {
    return new $c_sci_ArraySeq$ofFloat(x);
  } else if ((x instanceof $ac_C)) {
    return new $c_sci_ArraySeq$ofChar(x);
  } else if ((x instanceof $ac_B)) {
    return new $c_sci_ArraySeq$ofByte(x);
  } else if ((x instanceof $ac_S)) {
    return new $c_sci_ArraySeq$ofShort(x);
  } else if ((x instanceof $ac_Z)) {
    return new $c_sci_ArraySeq$ofBoolean(x);
  } else if ($isArrayOf_jl_Void(x, 1)) {
    return new $c_sci_ArraySeq$ofUnit(x);
  } else {
    throw new $c_s_MatchError(x);
  }
});
$p.ag0 = (function(it, evidence$5) {
  return this.ag1(it, evidence$5);
});
$p.aNG = (function(evidence$6) {
  return $p_sci_ArraySeq$__emptyImpl__sci_ArraySeq$ofRef(this);
});
var $d_sci_ArraySeq$ = new $TypeData().i($c_sci_ArraySeq$, "scala.collection.immutable.ArraySeq$", ({
  I6: 1,
  kS: 1,
  kE: 1,
  kD: 1,
  kF: 1,
  a: 1
}));
var $n_sci_ArraySeq$;
function $m_sci_ArraySeq$() {
  if ((!$n_sci_ArraySeq$)) {
    $n_sci_ArraySeq$ = new $c_sci_ArraySeq$();
  }
  return $n_sci_ArraySeq$;
}
/** @constructor */
function $c_sci_HashMapBuilder$$anon$1(outer, x2$1) {
  this.ea = 0;
  this.vx = 0;
  this.ke = null;
  this.kF = 0;
  this.og = null;
  this.vy = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, x2$1.cP);
  while (this.p()) {
    var originalHash = this.ke.cK(this.ea);
    outer.JE(outer.qA, this.ke.gy(this.ea), this.ke.h0(this.ea), originalHash, $m_sc_Hashing$().bz(originalHash), 0);
    this.ea = ((1 + this.ea) | 0);
  }
}
$p = $c_sci_HashMapBuilder$$anon$1.prototype = new $h_sci_ChampBaseIterator();
$p.constructor = $c_sci_HashMapBuilder$$anon$1;
/** @constructor */
function $h_sci_HashMapBuilder$$anon$1() {
}
$h_sci_HashMapBuilder$$anon$1.prototype = $p;
$p.Xz = (function() {
  $m_sc_Iterator$().b8.q();
  throw new $c_jl_ClassCastException();
});
$p.q = (function() {
  this.Xz();
});
var $d_sci_HashMapBuilder$$anon$1 = new $TypeData().i($c_sci_HashMapBuilder$$anon$1, "scala.collection.immutable.HashMapBuilder$$anon$1", ({
  Ia: 1,
  bh: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_sci_HashSetBuilder$$anon$1(outer, x2$1) {
  this.ea = 0;
  this.vx = 0;
  this.ke = null;
  this.kF = 0;
  this.og = null;
  this.vy = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, x2$1.dY);
  while (this.p()) {
    var originalHash = this.ke.cK(this.ea);
    outer.aip(outer.HA, this.ke.e4(this.ea), originalHash, $m_sc_Hashing$().bz(originalHash), 0);
    this.ea = ((1 + this.ea) | 0);
  }
}
$p = $c_sci_HashSetBuilder$$anon$1.prototype = new $h_sci_ChampBaseIterator();
$p.constructor = $c_sci_HashSetBuilder$$anon$1;
/** @constructor */
function $h_sci_HashSetBuilder$$anon$1() {
}
$h_sci_HashSetBuilder$$anon$1.prototype = $p;
$p.Xz = (function() {
  $m_sc_Iterator$().b8.q();
  throw new $c_jl_ClassCastException();
});
$p.q = (function() {
  this.Xz();
});
var $d_sci_HashSetBuilder$$anon$1 = new $TypeData().i($c_sci_HashSetBuilder$$anon$1, "scala.collection.immutable.HashSetBuilder$$anon$1", ({
  Id: 1,
  bh: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
function $is_sci_Iterable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.I)));
}
function $isArrayOf_sci_Iterable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.I)));
}
/** @constructor */
function $c_sci_Map$Map2$$anon$1(outer) {
  this.xA = 0;
  this.D0 = null;
  $ct_sci_Map$Map2$Map2Iterator__sci_Map$Map2__(this, outer);
}
$p = $c_sci_Map$Map2$$anon$1.prototype = new $h_sci_Map$Map2$Map2Iterator();
$p.constructor = $c_sci_Map$Map2$$anon$1;
/** @constructor */
function $h_sci_Map$Map2$$anon$1() {
}
$h_sci_Map$Map2$$anon$1.prototype = $p;
$p.mS = (function(k, v) {
  return new $c_T2(k, v);
});
var $d_sci_Map$Map2$$anon$1 = new $TypeData().i($c_sci_Map$Map2$$anon$1, "scala.collection.immutable.Map$Map2$$anon$1", ({
  Iv: 1,
  dH: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_sci_Map$Map2$$anon$2(outer) {
  this.xA = 0;
  this.D0 = null;
  $ct_sci_Map$Map2$Map2Iterator__sci_Map$Map2__(this, outer);
}
$p = $c_sci_Map$Map2$$anon$2.prototype = new $h_sci_Map$Map2$Map2Iterator();
$p.constructor = $c_sci_Map$Map2$$anon$2;
/** @constructor */
function $h_sci_Map$Map2$$anon$2() {
}
$h_sci_Map$Map2$$anon$2.prototype = $p;
$p.mS = (function(k, v) {
  return k;
});
var $d_sci_Map$Map2$$anon$2 = new $TypeData().i($c_sci_Map$Map2$$anon$2, "scala.collection.immutable.Map$Map2$$anon$2", ({
  Iw: 1,
  dH: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_sci_Map$Map2$$anon$3(outer) {
  this.xA = 0;
  this.D0 = null;
  $ct_sci_Map$Map2$Map2Iterator__sci_Map$Map2__(this, outer);
}
$p = $c_sci_Map$Map2$$anon$3.prototype = new $h_sci_Map$Map2$Map2Iterator();
$p.constructor = $c_sci_Map$Map2$$anon$3;
/** @constructor */
function $h_sci_Map$Map2$$anon$3() {
}
$h_sci_Map$Map2$$anon$3.prototype = $p;
$p.mS = (function(k, v) {
  return v;
});
var $d_sci_Map$Map2$$anon$3 = new $TypeData().i($c_sci_Map$Map2$$anon$3, "scala.collection.immutable.Map$Map2$$anon$3", ({
  Ix: 1,
  dH: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_sci_Map$Map3$$anon$4(outer) {
  this.xC = 0;
  this.xB = null;
  $ct_sci_Map$Map3$Map3Iterator__sci_Map$Map3__(this, outer);
}
$p = $c_sci_Map$Map3$$anon$4.prototype = new $h_sci_Map$Map3$Map3Iterator();
$p.constructor = $c_sci_Map$Map3$$anon$4;
/** @constructor */
function $h_sci_Map$Map3$$anon$4() {
}
$h_sci_Map$Map3$$anon$4.prototype = $p;
$p.mS = (function(k, v) {
  return new $c_T2(k, v);
});
var $d_sci_Map$Map3$$anon$4 = new $TypeData().i($c_sci_Map$Map3$$anon$4, "scala.collection.immutable.Map$Map3$$anon$4", ({
  Iy: 1,
  dI: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_sci_Map$Map3$$anon$5(outer) {
  this.xC = 0;
  this.xB = null;
  $ct_sci_Map$Map3$Map3Iterator__sci_Map$Map3__(this, outer);
}
$p = $c_sci_Map$Map3$$anon$5.prototype = new $h_sci_Map$Map3$Map3Iterator();
$p.constructor = $c_sci_Map$Map3$$anon$5;
/** @constructor */
function $h_sci_Map$Map3$$anon$5() {
}
$h_sci_Map$Map3$$anon$5.prototype = $p;
$p.mS = (function(k, v) {
  return k;
});
var $d_sci_Map$Map3$$anon$5 = new $TypeData().i($c_sci_Map$Map3$$anon$5, "scala.collection.immutable.Map$Map3$$anon$5", ({
  Iz: 1,
  dI: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_sci_Map$Map3$$anon$6(outer) {
  this.xC = 0;
  this.xB = null;
  $ct_sci_Map$Map3$Map3Iterator__sci_Map$Map3__(this, outer);
}
$p = $c_sci_Map$Map3$$anon$6.prototype = new $h_sci_Map$Map3$Map3Iterator();
$p.constructor = $c_sci_Map$Map3$$anon$6;
/** @constructor */
function $h_sci_Map$Map3$$anon$6() {
}
$h_sci_Map$Map3$$anon$6.prototype = $p;
$p.mS = (function(k, v) {
  return v;
});
var $d_sci_Map$Map3$$anon$6 = new $TypeData().i($c_sci_Map$Map3$$anon$6, "scala.collection.immutable.Map$Map3$$anon$6", ({
  IA: 1,
  dI: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_sci_Map$Map4$$anon$7(outer) {
  this.xD = 0;
  this.tG = null;
  $ct_sci_Map$Map4$Map4Iterator__sci_Map$Map4__(this, outer);
}
$p = $c_sci_Map$Map4$$anon$7.prototype = new $h_sci_Map$Map4$Map4Iterator();
$p.constructor = $c_sci_Map$Map4$$anon$7;
/** @constructor */
function $h_sci_Map$Map4$$anon$7() {
}
$h_sci_Map$Map4$$anon$7.prototype = $p;
$p.mS = (function(k, v) {
  return new $c_T2(k, v);
});
var $d_sci_Map$Map4$$anon$7 = new $TypeData().i($c_sci_Map$Map4$$anon$7, "scala.collection.immutable.Map$Map4$$anon$7", ({
  IB: 1,
  dJ: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_sci_Map$Map4$$anon$8(outer) {
  this.xD = 0;
  this.tG = null;
  $ct_sci_Map$Map4$Map4Iterator__sci_Map$Map4__(this, outer);
}
$p = $c_sci_Map$Map4$$anon$8.prototype = new $h_sci_Map$Map4$Map4Iterator();
$p.constructor = $c_sci_Map$Map4$$anon$8;
/** @constructor */
function $h_sci_Map$Map4$$anon$8() {
}
$h_sci_Map$Map4$$anon$8.prototype = $p;
$p.mS = (function(k, v) {
  return k;
});
var $d_sci_Map$Map4$$anon$8 = new $TypeData().i($c_sci_Map$Map4$$anon$8, "scala.collection.immutable.Map$Map4$$anon$8", ({
  IC: 1,
  dJ: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_sci_Map$Map4$$anon$9(outer) {
  this.xD = 0;
  this.tG = null;
  $ct_sci_Map$Map4$Map4Iterator__sci_Map$Map4__(this, outer);
}
$p = $c_sci_Map$Map4$$anon$9.prototype = new $h_sci_Map$Map4$Map4Iterator();
$p.constructor = $c_sci_Map$Map4$$anon$9;
/** @constructor */
function $h_sci_Map$Map4$$anon$9() {
}
$h_sci_Map$Map4$$anon$9.prototype = $p;
$p.mS = (function(k, v) {
  return v;
});
var $d_sci_Map$Map4$$anon$9 = new $TypeData().i($c_sci_Map$Map4$$anon$9, "scala.collection.immutable.Map$Map4$$anon$9", ({
  ID: 1,
  dJ: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_sci_MapKeyIterator(rootNode) {
  this.ea = 0;
  this.vx = 0;
  this.ke = null;
  this.kF = 0;
  this.og = null;
  this.vy = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, rootNode);
}
$p = $c_sci_MapKeyIterator.prototype = new $h_sci_ChampBaseIterator();
$p.constructor = $c_sci_MapKeyIterator;
/** @constructor */
function $h_sci_MapKeyIterator() {
}
$h_sci_MapKeyIterator.prototype = $p;
$p.q = (function() {
  if ((!this.p())) {
    $m_sc_Iterator$().b8.q();
  }
  var key = this.ke.gy(this.ea);
  this.ea = ((1 + this.ea) | 0);
  return key;
});
var $d_sci_MapKeyIterator = new $TypeData().i($c_sci_MapKeyIterator, "scala.collection.immutable.MapKeyIterator", ({
  IG: 1,
  bh: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_sci_MapKeyValueTupleHashIterator(rootNode) {
  this.nj = 0;
  this.CX = null;
  this.oh = 0;
  this.Hx = null;
  this.Hy = null;
  this.acH = 0;
  this.aIl = null;
  $ct_sci_ChampBaseReverseIterator__sci_Node__(this, rootNode);
  this.acH = 0;
}
$p = $c_sci_MapKeyValueTupleHashIterator.prototype = new $h_sci_ChampBaseReverseIterator();
$p.constructor = $c_sci_MapKeyValueTupleHashIterator;
/** @constructor */
function $h_sci_MapKeyValueTupleHashIterator() {
}
$h_sci_MapKeyValueTupleHashIterator.prototype = $p;
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().aT6(this.acH, $m_sr_Statics$().u(this.aIl), (-889275714));
});
$p.b4Q = (function() {
  if ((!this.p())) {
    $m_sc_Iterator$().b8.q();
  }
  this.acH = this.CX.cK(this.nj);
  this.aIl = this.CX.h0(this.nj);
  this.nj = ((this.nj - 1) | 0);
  return this;
});
$p.q = (function() {
  return this.b4Q();
});
var $d_sci_MapKeyValueTupleHashIterator = new $TypeData().i($c_sci_MapKeyValueTupleHashIterator, "scala.collection.immutable.MapKeyValueTupleHashIterator", ({
  IH: 1,
  dG: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_sci_MapKeyValueTupleIterator(rootNode) {
  this.ea = 0;
  this.vx = 0;
  this.ke = null;
  this.kF = 0;
  this.og = null;
  this.vy = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, rootNode);
}
$p = $c_sci_MapKeyValueTupleIterator.prototype = new $h_sci_ChampBaseIterator();
$p.constructor = $c_sci_MapKeyValueTupleIterator;
/** @constructor */
function $h_sci_MapKeyValueTupleIterator() {
}
$h_sci_MapKeyValueTupleIterator.prototype = $p;
$p.dC = (function() {
  if ((!this.p())) {
    $m_sc_Iterator$().b8.q();
  }
  var payload = this.ke.IZ(this.ea);
  this.ea = ((1 + this.ea) | 0);
  return payload;
});
$p.q = (function() {
  return this.dC();
});
var $d_sci_MapKeyValueTupleIterator = new $TypeData().i($c_sci_MapKeyValueTupleIterator, "scala.collection.immutable.MapKeyValueTupleIterator", ({
  II: 1,
  bh: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_sci_MapKeyValueTupleReverseIterator(rootNode) {
  this.nj = 0;
  this.CX = null;
  this.oh = 0;
  this.Hx = null;
  this.Hy = null;
  $ct_sci_ChampBaseReverseIterator__sci_Node__(this, rootNode);
}
$p = $c_sci_MapKeyValueTupleReverseIterator.prototype = new $h_sci_ChampBaseReverseIterator();
$p.constructor = $c_sci_MapKeyValueTupleReverseIterator;
/** @constructor */
function $h_sci_MapKeyValueTupleReverseIterator() {
}
$h_sci_MapKeyValueTupleReverseIterator.prototype = $p;
$p.dC = (function() {
  if ((!this.p())) {
    $m_sc_Iterator$().b8.q();
  }
  var payload = this.CX.IZ(this.nj);
  this.nj = ((this.nj - 1) | 0);
  return payload;
});
$p.q = (function() {
  return this.dC();
});
var $d_sci_MapKeyValueTupleReverseIterator = new $TypeData().i($c_sci_MapKeyValueTupleReverseIterator, "scala.collection.immutable.MapKeyValueTupleReverseIterator", ({
  IJ: 1,
  dG: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_sci_MapNodeRemoveAllSetNodeIterator(rootSetNode) {
  this.ea = 0;
  this.vx = 0;
  this.ke = null;
  this.kF = 0;
  this.og = null;
  this.vy = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, rootSetNode);
}
$p = $c_sci_MapNodeRemoveAllSetNodeIterator.prototype = new $h_sci_ChampBaseIterator();
$p.constructor = $c_sci_MapNodeRemoveAllSetNodeIterator;
/** @constructor */
function $h_sci_MapNodeRemoveAllSetNodeIterator() {
}
$h_sci_MapNodeRemoveAllSetNodeIterator.prototype = $p;
$p.b7q = (function(rootMapNode) {
  var curr = rootMapNode;
  while (((curr.dS > 0) && this.p())) {
    var originalHash = this.ke.cK(this.ea);
    var qual$1 = curr;
    var x$1 = this.ke.e4(this.ea);
    var x$2 = $m_sc_Hashing$().bz(originalHash);
    curr = qual$1.PP(x$1, originalHash, x$2, 0);
    this.ea = ((1 + this.ea) | 0);
  }
  return curr;
});
$p.q = (function() {
  return $m_sc_Iterator$().b8.q();
});
var $d_sci_MapNodeRemoveAllSetNodeIterator = new $TypeData().i($c_sci_MapNodeRemoveAllSetNodeIterator, "scala.collection.immutable.MapNodeRemoveAllSetNodeIterator", ({
  IL: 1,
  bh: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_sci_MapValueIterator(rootNode) {
  this.ea = 0;
  this.vx = 0;
  this.ke = null;
  this.kF = 0;
  this.og = null;
  this.vy = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, rootNode);
}
$p = $c_sci_MapValueIterator.prototype = new $h_sci_ChampBaseIterator();
$p.constructor = $c_sci_MapValueIterator;
/** @constructor */
function $h_sci_MapValueIterator() {
}
$h_sci_MapValueIterator.prototype = $p;
$p.q = (function() {
  if ((!this.p())) {
    $m_sc_Iterator$().b8.q();
  }
  var value = this.ke.h0(this.ea);
  this.ea = ((1 + this.ea) | 0);
  return value;
});
var $d_sci_MapValueIterator = new $TypeData().i($c_sci_MapValueIterator, "scala.collection.immutable.MapValueIterator", ({
  IM: 1,
  bh: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
function $p_sci_NewVectorIterator__advanceSlice__V($thiz) {
  if (($thiz.kg <= $thiz.i4)) {
    $m_sc_Iterator$().b8.q();
  }
  $thiz.D3 = ((1 + $thiz.D3) | 0);
  var slice = $thiz.a1N.wn($thiz.D3);
  while ((slice.a.length === 0)) {
    $thiz.D3 = ((1 + $thiz.D3) | 0);
    slice = $thiz.a1N.wn($thiz.D3);
  }
  $thiz.V5 = $thiz.zX;
  var count = $thiz.aIm;
  var idx = $thiz.D3;
  var c = (((count + ((count >>> 31) | 0)) | 0) >> 1);
  var a = ((idx - c) | 0);
  var sign = (a >> 31);
  $thiz.D2 = ((((1 + c) | 0) - (((a ^ sign) - sign) | 0)) | 0);
  var x1 = $thiz.D2;
  switch (x1) {
    case 1: {
      $thiz.l6 = slice;
      break;
    }
    case 2: {
      $thiz.l7 = slice;
      break;
    }
    case 3: {
      $thiz.oi = slice;
      break;
    }
    case 4: {
      $thiz.vD = slice;
      break;
    }
    case 5: {
      $thiz.HB = slice;
      break;
    }
    case 6: {
      $thiz.acI = slice;
      break;
    }
    default: {
      throw new $c_s_MatchError(x1);
    }
  }
  $thiz.zX = (($thiz.V5 + Math.imul(slice.a.length, (1 << Math.imul(5, (($thiz.D2 - 1) | 0))))) | 0);
  if (($thiz.zX > $thiz.oj)) {
    $thiz.zX = $thiz.oj;
  }
  if (($thiz.D2 > 1)) {
    $thiz.NZ = (((1 << Math.imul(5, $thiz.D2)) - 1) | 0);
  }
}
function $p_sci_NewVectorIterator__advance__V($thiz) {
  var pos = (((($thiz.i4 - $thiz.kg) | 0) + $thiz.oj) | 0);
  if ((pos === $thiz.zX)) {
    $p_sci_NewVectorIterator__advanceSlice__V($thiz);
  }
  if (($thiz.D2 > 1)) {
    var io = ((pos - $thiz.V5) | 0);
    $p_sci_NewVectorIterator__advanceA__I__I__V($thiz, io, ($thiz.NZ ^ io));
    $thiz.NZ = io;
  }
  $thiz.kg = (($thiz.kg - $thiz.i4) | 0);
  var a = $thiz.l6.a.length;
  var b = $thiz.kg;
  $thiz.vC = ((a < b) ? a : b);
  $thiz.i4 = 0;
}
function $p_sci_NewVectorIterator__advanceA__I__I__V($thiz, io, xor) {
  if ((xor < 1024)) {
    $thiz.l6 = $thiz.l7.a[(31 & ((io >>> 5) | 0))];
  } else if ((xor < 32768)) {
    $thiz.l7 = $thiz.oi.a[(31 & ((io >>> 10) | 0))];
    $thiz.l6 = $thiz.l7.a[0];
  } else if ((xor < 1048576)) {
    $thiz.oi = $thiz.vD.a[(31 & ((io >>> 15) | 0))];
    $thiz.l7 = $thiz.oi.a[0];
    $thiz.l6 = $thiz.l7.a[0];
  } else if ((xor < 33554432)) {
    $thiz.vD = $thiz.HB.a[(31 & ((io >>> 20) | 0))];
    $thiz.oi = $thiz.vD.a[0];
    $thiz.l7 = $thiz.oi.a[0];
    $thiz.l6 = $thiz.l7.a[0];
  } else {
    $thiz.HB = $thiz.acI.a[((io >>> 25) | 0)];
    $thiz.vD = $thiz.HB.a[0];
    $thiz.oi = $thiz.vD.a[0];
    $thiz.l7 = $thiz.oi.a[0];
    $thiz.l6 = $thiz.l7.a[0];
  }
}
function $p_sci_NewVectorIterator__setA__I__I__V($thiz, io, xor) {
  if ((xor < 1024)) {
    $thiz.l6 = $thiz.l7.a[(31 & ((io >>> 5) | 0))];
  } else if ((xor < 32768)) {
    $thiz.l7 = $thiz.oi.a[(31 & ((io >>> 10) | 0))];
    $thiz.l6 = $thiz.l7.a[(31 & ((io >>> 5) | 0))];
  } else if ((xor < 1048576)) {
    $thiz.oi = $thiz.vD.a[(31 & ((io >>> 15) | 0))];
    $thiz.l7 = $thiz.oi.a[(31 & ((io >>> 10) | 0))];
    $thiz.l6 = $thiz.l7.a[(31 & ((io >>> 5) | 0))];
  } else if ((xor < 33554432)) {
    $thiz.vD = $thiz.HB.a[(31 & ((io >>> 20) | 0))];
    $thiz.oi = $thiz.vD.a[(31 & ((io >>> 15) | 0))];
    $thiz.l7 = $thiz.oi.a[(31 & ((io >>> 10) | 0))];
    $thiz.l6 = $thiz.l7.a[(31 & ((io >>> 5) | 0))];
  } else {
    $thiz.HB = $thiz.acI.a[((io >>> 25) | 0)];
    $thiz.vD = $thiz.HB.a[(31 & ((io >>> 20) | 0))];
    $thiz.oi = $thiz.vD.a[(31 & ((io >>> 15) | 0))];
    $thiz.l7 = $thiz.oi.a[(31 & ((io >>> 10) | 0))];
    $thiz.l6 = $thiz.l7.a[(31 & ((io >>> 5) | 0))];
  }
}
/** @constructor */
function $c_sci_NewVectorIterator(v, totalLength, sliceCount) {
  this.a1N = null;
  this.oj = 0;
  this.aIm = 0;
  this.l6 = null;
  this.l7 = null;
  this.oi = null;
  this.vD = null;
  this.HB = null;
  this.acI = null;
  this.vC = 0;
  this.i4 = 0;
  this.NZ = 0;
  this.kg = 0;
  this.D3 = 0;
  this.D2 = 0;
  this.V5 = 0;
  this.zX = 0;
  this.a1N = v;
  this.oj = totalLength;
  this.aIm = sliceCount;
  this.l6 = v.a9;
  this.vC = this.l6.a.length;
  this.i4 = 0;
  this.NZ = 0;
  this.kg = this.oj;
  this.D3 = 0;
  this.D2 = 1;
  this.V5 = 0;
  this.zX = this.vC;
}
$p = $c_sci_NewVectorIterator.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sci_NewVectorIterator;
/** @constructor */
function $h_sci_NewVectorIterator() {
}
$h_sci_NewVectorIterator.prototype = $p;
$p.V = (function() {
  return ((this.kg - this.i4) | 0);
});
$p.p = (function() {
  return (this.kg > this.i4);
});
$p.q = (function() {
  if ((this.i4 === this.vC)) {
    $p_sci_NewVectorIterator__advance__V(this);
  }
  var r = this.l6.a[this.i4];
  this.i4 = ((1 + this.i4) | 0);
  return r;
});
$p.iV = (function(n) {
  if ((n > 0)) {
    var oldpos = ((((this.i4 - this.kg) | 0) + this.oj) | 0);
    var a = ((oldpos + n) | 0);
    var b = this.oj;
    var newpos = ((a < b) ? a : b);
    if ((newpos === this.oj)) {
      this.i4 = 0;
      this.kg = 0;
      this.vC = 0;
    } else {
      while ((newpos >= this.zX)) {
        $p_sci_NewVectorIterator__advanceSlice__V(this);
      }
      var io = ((newpos - this.V5) | 0);
      if ((this.D2 > 1)) {
        $p_sci_NewVectorIterator__setA__I__I__V(this, io, (this.NZ ^ io));
        this.NZ = io;
      }
      this.vC = this.l6.a.length;
      this.i4 = (31 & io);
      this.kg = ((this.i4 + ((this.oj - newpos) | 0)) | 0);
      if ((this.vC > this.kg)) {
        this.vC = this.kg;
      }
    }
  }
  return this;
});
$p.Ju = (function(n) {
  if ((n < ((this.kg - this.i4) | 0))) {
    var trunc = ((((this.kg - this.i4) | 0) - ((n < 0) ? 0 : n)) | 0);
    this.oj = ((this.oj - trunc) | 0);
    this.kg = ((this.kg - trunc) | 0);
    if ((this.kg < this.vC)) {
      this.vC = this.kg;
    }
    if ((this.oj < this.zX)) {
      this.zX = this.oj;
    }
  }
  return this;
});
$p.cR = (function(xs, start, len) {
  var xsLen = $m_jl_reflect_Array$().c6(xs);
  var srcLen = ((this.kg - this.i4) | 0);
  var limit = ((len < srcLen) ? len : srcLen);
  var capacity = ((start < 0) ? xsLen : ((xsLen - start) | 0));
  var total = ((capacity < limit) ? capacity : limit);
  var total$1 = ((total < 0) ? 0 : total);
  var copied = 0;
  var isBoxed = (xs instanceof $ac_O);
  while ((copied < total$1)) {
    if ((this.i4 === this.vC)) {
      $p_sci_NewVectorIterator__advance__V(this);
    }
    var a = ((total$1 - copied) | 0);
    var b = ((this.l6.a.length - this.i4) | 0);
    var count = ((a < b) ? a : b);
    if (isBoxed) {
      var src = this.l6;
      var srcPos = this.i4;
      var destPos = ((start + copied) | 0);
      src.av(srcPos, xs, destPos, count);
    } else {
      $m_s_Array$().fv(this.l6, this.i4, xs, ((start + copied) | 0), count);
    }
    this.i4 = ((this.i4 + count) | 0);
    copied = ((copied + count) | 0);
  }
  return total$1;
});
$p.d2 = (function() {
  return this.a1N.pH(((((this.i4 - this.kg) | 0) + this.oj) | 0), this.oj);
});
var $d_sci_NewVectorIterator = new $TypeData().i($c_sci_NewVectorIterator, "scala.collection.immutable.NewVectorIterator", ({
  IN: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1,
  W: 1
}));
/** @constructor */
function $c_sci_RangeIterator(start, step, lastElement, initiallyEmpty) {
  this.O0 = 0;
  this.HD = 0;
  this.g0 = false;
  this.HC = 0;
  this.O0 = step;
  this.HD = lastElement;
  this.g0 = (!initiallyEmpty);
  this.HC = start;
}
$p = $c_sci_RangeIterator.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sci_RangeIterator;
/** @constructor */
function $h_sci_RangeIterator() {
}
$h_sci_RangeIterator.prototype = $p;
$p.V = (function() {
  return (this.g0 ? ((1 + ((((this.HD - this.HC) | 0) / $checkIntDivisor(this.O0)) | 0)) | 0) : 0);
});
$p.p = (function() {
  return this.g0;
});
$p.hp = (function() {
  if ((!this.g0)) {
    $m_sc_Iterator$().b8.q();
  }
  var value = this.HC;
  this.g0 = (value !== this.HD);
  this.HC = ((value + this.O0) | 0);
  return value;
});
$p.iV = (function(n) {
  if ((n > 0)) {
    var value = this.HC;
    var hi = (value >> 31);
    var value$1 = Math.imul(this.O0, n);
    var hi$1 = (value$1 >> 31);
    var lo = ((value + value$1) | 0);
    var hi$2 = ((((hi + hi$1) | 0) + (((lo >>> 0) < (value >>> 0)) | 0)) | 0);
    if ((this.O0 > 0)) {
      var value$2 = this.HD;
      var hi$3 = (value$2 >> 31);
      if (((hi$3 === hi$2) ? ((value$2 >>> 0) < (lo >>> 0)) : (hi$3 < hi$2))) {
        var $x_1_$_lo = value$2;
        var $x_1_$_hi = hi$3;
      } else {
        var $x_1_$_lo = lo;
        var $x_1_$_hi = hi$2;
      }
      this.HC = $x_1_$_lo;
      var value$3 = this.HD;
      var hi$4 = (value$3 >> 31);
      this.g0 = ((hi$2 === hi$4) ? ((lo >>> 0) <= (value$3 >>> 0)) : (hi$2 < hi$4));
    } else if ((this.O0 < 0)) {
      var value$4 = this.HD;
      var hi$5 = (value$4 >> 31);
      if (((hi$5 === hi$2) ? ((value$4 >>> 0) > (lo >>> 0)) : (hi$5 > hi$2))) {
        var $x_2_$_lo = value$4;
        var $x_2_$_hi = hi$5;
      } else {
        var $x_2_$_lo = lo;
        var $x_2_$_hi = hi$2;
      }
      this.HC = $x_2_$_lo;
      var value$5 = this.HD;
      var hi$6 = (value$5 >> 31);
      this.g0 = ((hi$2 === hi$6) ? ((lo >>> 0) >= (value$5 >>> 0)) : (hi$2 > hi$6));
    }
  }
  return this;
});
$p.q = (function() {
  return this.hp();
});
var $d_sci_RangeIterator = new $TypeData().i($c_sci_RangeIterator, "scala.collection.immutable.RangeIterator", ({
  IT: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1,
  a: 1
}));
function $ct_sci_Set$SetNIterator__I__($thiz, n) {
  $thiz.zY = 0;
  $thiz.xF = n;
  return $thiz;
}
/** @constructor */
function $c_sci_Set$SetNIterator() {
  this.zY = 0;
  this.xF = 0;
}
$p = $c_sci_Set$SetNIterator.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sci_Set$SetNIterator;
/** @constructor */
function $h_sci_Set$SetNIterator() {
}
$h_sci_Set$SetNIterator.prototype = $p;
$p.V = (function() {
  return this.xF;
});
$p.p = (function() {
  return (this.xF > 0);
});
$p.q = (function() {
  if (this.p()) {
    var r = this.l(this.zY);
    this.zY = ((1 + this.zY) | 0);
    this.xF = ((this.xF - 1) | 0);
    return r;
  } else {
    return $m_sc_Iterator$().b8.q();
  }
});
$p.iV = (function(n) {
  if ((n > 0)) {
    this.zY = ((this.zY + n) | 0);
    var b = ((this.xF - n) | 0);
    this.xF = ((b < 0) ? 0 : b);
  }
  return this;
});
/** @constructor */
function $c_sci_SetHashIterator(rootNode) {
  this.ea = 0;
  this.vx = 0;
  this.ke = null;
  this.kF = 0;
  this.og = null;
  this.vy = null;
  this.acJ = 0;
  $ct_sci_ChampBaseIterator__sci_Node__(this, rootNode);
  this.acJ = 0;
}
$p = $c_sci_SetHashIterator.prototype = new $h_sci_ChampBaseIterator();
$p.constructor = $c_sci_SetHashIterator;
/** @constructor */
function $h_sci_SetHashIterator() {
}
$h_sci_SetHashIterator.prototype = $p;
$p.x = (function() {
  return this.acJ;
});
$p.q = (function() {
  if ((!this.p())) {
    $m_sc_Iterator$().b8.q();
  }
  this.acJ = this.ke.cK(this.ea);
  this.ea = ((1 + this.ea) | 0);
  return this;
});
var $d_sci_SetHashIterator = new $TypeData().i($c_sci_SetHashIterator, "scala.collection.immutable.SetHashIterator", ({
  J5: 1,
  bh: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_sci_SetIterator(rootNode) {
  this.ea = 0;
  this.vx = 0;
  this.ke = null;
  this.kF = 0;
  this.og = null;
  this.vy = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, rootNode);
}
$p = $c_sci_SetIterator.prototype = new $h_sci_ChampBaseIterator();
$p.constructor = $c_sci_SetIterator;
/** @constructor */
function $h_sci_SetIterator() {
}
$h_sci_SetIterator.prototype = $p;
$p.q = (function() {
  if ((!this.p())) {
    $m_sc_Iterator$().b8.q();
  }
  var payload = this.ke.e4(this.ea);
  this.ea = ((1 + this.ea) | 0);
  return payload;
});
var $d_sci_SetIterator = new $TypeData().i($c_sci_SetIterator, "scala.collection.immutable.SetIterator", ({
  J6: 1,
  bh: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
function $f_sci_SetOps__removedAll__sc_IterableOnce__sci_SetOps($thiz, that) {
  var this$1 = that.o();
  var f = ((x$1$2$2, x$2$2$2) => x$1$2$2.lT(x$2$2$2));
  if ($is_sc_IndexedSeq(this$1)) {
    var at = 0;
    var end = this$1.C();
    var acc = $thiz;
    var $x_1;
    while (true) {
      if ((at !== end)) {
        var temp$at = ((1 + at) | 0);
        var x0 = acc;
        var x1 = this$1.l(at);
        var temp$acc = f(x0, x1);
        at = temp$at;
        acc = temp$acc;
        continue;
      }
      var $x_1 = acc;
      break;
    }
  } else {
    var result = $thiz;
    while (this$1.p()) {
      var x0$1 = result;
      var x1$1 = this$1.q();
      result = f(x0$1, x1$1);
    }
    var $x_1 = result;
  }
  return $x_1;
}
/** @constructor */
function $c_sci_SetReverseIterator(rootNode) {
  this.nj = 0;
  this.CX = null;
  this.oh = 0;
  this.Hx = null;
  this.Hy = null;
  $ct_sci_ChampBaseReverseIterator__sci_Node__(this, rootNode);
}
$p = $c_sci_SetReverseIterator.prototype = new $h_sci_ChampBaseReverseIterator();
$p.constructor = $c_sci_SetReverseIterator;
/** @constructor */
function $h_sci_SetReverseIterator() {
}
$h_sci_SetReverseIterator.prototype = $p;
$p.q = (function() {
  if ((!this.p())) {
    $m_sc_Iterator$().b8.q();
  }
  var payload = this.CX.e4(this.nj);
  this.nj = ((this.nj - 1) | 0);
  return payload;
});
var $d_sci_SetReverseIterator = new $TypeData().i($c_sci_SetReverseIterator, "scala.collection.immutable.SetReverseIterator", ({
  J8: 1,
  dG: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
function $ct_scm_ArrayBuilder__($thiz) {
  $thiz.acV = 0;
  $thiz.aIz = 0;
  return $thiz;
}
/** @constructor */
function $c_scm_ArrayBuilder() {
  this.acV = 0;
  this.aIz = 0;
}
$p = $c_scm_ArrayBuilder.prototype = new $h_O();
$p.constructor = $c_scm_ArrayBuilder;
/** @constructor */
function $h_scm_ArrayBuilder() {
}
$h_scm_ArrayBuilder.prototype = $p;
$p.f9 = (function(size) {
  if ((this.acV < size)) {
    this.b7L(size);
  }
});
/** @constructor */
function $c_scm_ArraySeq$() {
  this.acX = null;
  this.a1S = null;
  $n_scm_ArraySeq$ = this;
  this.acX = new $c_sc_ClassTagSeqFactory$AnySeqDelegate(this);
  this.a1S = new $c_scm_ArraySeq$ofRef(new $ac_O(0));
}
$p = $c_scm_ArraySeq$.prototype = new $h_O();
$p.constructor = $c_scm_ArraySeq$;
/** @constructor */
function $h_scm_ArraySeq$() {
}
$h_scm_ArraySeq$.prototype = $p;
$p.b1G = (function(it, evidence$2) {
  return this.a48($m_s_Array$().aOp(it, evidence$2));
});
$p.a4e = (function(evidence$3) {
  return new $c_scm_Builder$$anon$1(new $c_scm_ArrayBuilder$generic(evidence$3.h8()), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2$2) => $m_scm_ArraySeq$().a48(x$2$2))));
});
$p.a48 = (function(x) {
  if ((x === null)) {
    return null;
  } else if ((x instanceof $ac_O)) {
    return new $c_scm_ArraySeq$ofRef(x);
  } else if ((x instanceof $ac_I)) {
    return new $c_scm_ArraySeq$ofInt(x);
  } else if ((x instanceof $ac_D)) {
    return new $c_scm_ArraySeq$ofDouble(x);
  } else if ((x instanceof $ac_J)) {
    return new $c_scm_ArraySeq$ofLong(x);
  } else if ((x instanceof $ac_F)) {
    return new $c_scm_ArraySeq$ofFloat(x);
  } else if ((x instanceof $ac_C)) {
    return new $c_scm_ArraySeq$ofChar(x);
  } else if ((x instanceof $ac_B)) {
    return new $c_scm_ArraySeq$ofByte(x);
  } else if ((x instanceof $ac_S)) {
    return new $c_scm_ArraySeq$ofShort(x);
  } else if ((x instanceof $ac_Z)) {
    return new $c_scm_ArraySeq$ofBoolean(x);
  } else if ($isArrayOf_jl_Void(x, 1)) {
    return new $c_scm_ArraySeq$ofUnit(x);
  } else {
    throw new $c_s_MatchError(x);
  }
});
$p.ag0 = (function(it, evidence$5) {
  return this.b1G(it, evidence$5);
});
$p.aNG = (function(evidence$6) {
  return this.a1S;
});
var $d_scm_ArraySeq$ = new $TypeData().i($c_scm_ArraySeq$, "scala.collection.mutable.ArraySeq$", ({
  JC: 1,
  kS: 1,
  kE: 1,
  kD: 1,
  kF: 1,
  a: 1
}));
var $n_scm_ArraySeq$;
function $m_scm_ArraySeq$() {
  if ((!$n_scm_ArraySeq$)) {
    $n_scm_ArraySeq$ = new $c_scm_ArraySeq$();
  }
  return $n_scm_ArraySeq$;
}
/** @constructor */
function $c_scm_HashMap$$anon$1(outer) {
  this.xJ = 0;
  this.vG = null;
  this.HJ = 0;
  this.HI = null;
  $ct_scm_HashMap$HashMapIterator__scm_HashMap__(this, outer);
}
$p = $c_scm_HashMap$$anon$1.prototype = new $h_scm_HashMap$HashMapIterator();
$p.constructor = $c_scm_HashMap$$anon$1;
/** @constructor */
function $h_scm_HashMap$$anon$1() {
}
$h_scm_HashMap$$anon$1.prototype = $p;
$p.WJ = (function(nd) {
  return new $c_T2(nd.np, nd.b9);
});
var $d_scm_HashMap$$anon$1 = new $TypeData().i($c_scm_HashMap$$anon$1, "scala.collection.mutable.HashMap$$anon$1", ({
  JO: 1,
  c3: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_scm_HashMap$$anon$2(outer) {
  this.xJ = 0;
  this.vG = null;
  this.HJ = 0;
  this.HI = null;
  $ct_scm_HashMap$HashMapIterator__scm_HashMap__(this, outer);
}
$p = $c_scm_HashMap$$anon$2.prototype = new $h_scm_HashMap$HashMapIterator();
$p.constructor = $c_scm_HashMap$$anon$2;
/** @constructor */
function $h_scm_HashMap$$anon$2() {
}
$h_scm_HashMap$$anon$2.prototype = $p;
$p.WJ = (function(nd) {
  return nd.np;
});
var $d_scm_HashMap$$anon$2 = new $TypeData().i($c_scm_HashMap$$anon$2, "scala.collection.mutable.HashMap$$anon$2", ({
  JP: 1,
  c3: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_scm_HashMap$$anon$3(outer) {
  this.xJ = 0;
  this.vG = null;
  this.HJ = 0;
  this.HI = null;
  $ct_scm_HashMap$HashMapIterator__scm_HashMap__(this, outer);
}
$p = $c_scm_HashMap$$anon$3.prototype = new $h_scm_HashMap$HashMapIterator();
$p.constructor = $c_scm_HashMap$$anon$3;
/** @constructor */
function $h_scm_HashMap$$anon$3() {
}
$h_scm_HashMap$$anon$3.prototype = $p;
$p.WJ = (function(nd) {
  return nd.b9;
});
var $d_scm_HashMap$$anon$3 = new $TypeData().i($c_scm_HashMap$$anon$3, "scala.collection.mutable.HashMap$$anon$3", ({
  JQ: 1,
  c3: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_scm_HashMap$$anon$4(outer) {
  this.xJ = 0;
  this.vG = null;
  this.HJ = 0;
  this.HI = null;
  $ct_scm_HashMap$HashMapIterator__scm_HashMap__(this, outer);
}
$p = $c_scm_HashMap$$anon$4.prototype = new $h_scm_HashMap$HashMapIterator();
$p.constructor = $c_scm_HashMap$$anon$4;
/** @constructor */
function $h_scm_HashMap$$anon$4() {
}
$h_scm_HashMap$$anon$4.prototype = $p;
$p.WJ = (function(nd) {
  return nd;
});
var $d_scm_HashMap$$anon$4 = new $TypeData().i($c_scm_HashMap$$anon$4, "scala.collection.mutable.HashMap$$anon$4", ({
  JR: 1,
  c3: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_scm_HashMap$$anon$5(outer) {
  this.xJ = 0;
  this.vG = null;
  this.HJ = 0;
  this.HI = null;
  this.ad0 = 0;
  this.aV4 = null;
  this.aV4 = outer;
  $ct_scm_HashMap$HashMapIterator__scm_HashMap__(this, outer);
  this.ad0 = 0;
}
$p = $c_scm_HashMap$$anon$5.prototype = new $h_scm_HashMap$HashMapIterator();
$p.constructor = $c_scm_HashMap$$anon$5;
/** @constructor */
function $h_scm_HashMap$$anon$5() {
}
$h_scm_HashMap$$anon$5.prototype = $p;
$p.x = (function() {
  return this.ad0;
});
$p.WJ = (function(nd) {
  var $x_1 = $m_s_util_hashing_MurmurHash3$();
  var improvedHash = nd.or;
  this.ad0 = $x_1.ri((improvedHash ^ ((improvedHash >>> 16) | 0)), $m_sr_Statics$().u(nd.b9));
  return this;
});
var $d_scm_HashMap$$anon$5 = new $TypeData().i($c_scm_HashMap$$anon$5, "scala.collection.mutable.HashMap$$anon$5", ({
  JS: 1,
  c3: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_scm_HashSet$$anon$1(outer) {
  this.D7 = 0;
  this.A5 = null;
  this.Vd = 0;
  this.Vc = null;
  $ct_scm_HashSet$HashSetIterator__scm_HashSet__(this, outer);
}
$p = $c_scm_HashSet$$anon$1.prototype = new $h_scm_HashSet$HashSetIterator();
$p.constructor = $c_scm_HashSet$$anon$1;
/** @constructor */
function $h_scm_HashSet$$anon$1() {
}
$h_scm_HashSet$$anon$1.prototype = $p;
$p.afC = (function(nd) {
  return nd.pc;
});
var $d_scm_HashSet$$anon$1 = new $TypeData().i($c_scm_HashSet$$anon$1, "scala.collection.mutable.HashSet$$anon$1", ({
  JW: 1,
  dQ: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_scm_HashSet$$anon$2(outer) {
  this.D7 = 0;
  this.A5 = null;
  this.Vd = 0;
  this.Vc = null;
  $ct_scm_HashSet$HashSetIterator__scm_HashSet__(this, outer);
}
$p = $c_scm_HashSet$$anon$2.prototype = new $h_scm_HashSet$HashSetIterator();
$p.constructor = $c_scm_HashSet$$anon$2;
/** @constructor */
function $h_scm_HashSet$$anon$2() {
}
$h_scm_HashSet$$anon$2.prototype = $p;
$p.afC = (function(nd) {
  return nd;
});
var $d_scm_HashSet$$anon$2 = new $TypeData().i($c_scm_HashSet$$anon$2, "scala.collection.mutable.HashSet$$anon$2", ({
  JX: 1,
  dQ: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_scm_HashSet$$anon$3(outer) {
  this.D7 = 0;
  this.A5 = null;
  this.Vd = 0;
  this.Vc = null;
  this.ad3 = 0;
  this.aIK = null;
  this.aIK = outer;
  $ct_scm_HashSet$HashSetIterator__scm_HashSet__(this, outer);
  this.ad3 = 0;
}
$p = $c_scm_HashSet$$anon$3.prototype = new $h_scm_HashSet$HashSetIterator();
$p.constructor = $c_scm_HashSet$$anon$3;
/** @constructor */
function $h_scm_HashSet$$anon$3() {
}
$h_scm_HashSet$$anon$3.prototype = $p;
$p.x = (function() {
  return this.ad3;
});
$p.afC = (function(nd) {
  this.ad3 = this.aIK.yl(nd.mD);
  return this;
});
var $d_scm_HashSet$$anon$3 = new $TypeData().i($c_scm_HashSet$$anon$3, "scala.collection.mutable.HashSet$$anon$3", ({
  JY: 1,
  dQ: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_scm_LinkedHashMap$$anon$1(outer) {
  this.xK = null;
  $ct_scm_LinkedHashMap$LinkedHashMapIterator__scm_LinkedHashMap__(this, outer);
}
$p = $c_scm_LinkedHashMap$$anon$1.prototype = new $h_scm_LinkedHashMap$LinkedHashMapIterator();
$p.constructor = $c_scm_LinkedHashMap$$anon$1;
/** @constructor */
function $h_scm_LinkedHashMap$$anon$1() {
}
$h_scm_LinkedHashMap$$anon$1.prototype = $p;
$p.WK = (function(nd) {
  return new $c_T2(nd.nq, nd.fs);
});
var $d_scm_LinkedHashMap$$anon$1 = new $TypeData().i($c_scm_LinkedHashMap$$anon$1, "scala.collection.mutable.LinkedHashMap$$anon$1", ({
  K5: 1,
  c5: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_scm_LinkedHashMap$$anon$2(outer) {
  this.xK = null;
  $ct_scm_LinkedHashMap$LinkedHashMapIterator__scm_LinkedHashMap__(this, outer);
}
$p = $c_scm_LinkedHashMap$$anon$2.prototype = new $h_scm_LinkedHashMap$LinkedHashMapIterator();
$p.constructor = $c_scm_LinkedHashMap$$anon$2;
/** @constructor */
function $h_scm_LinkedHashMap$$anon$2() {
}
$h_scm_LinkedHashMap$$anon$2.prototype = $p;
$p.WK = (function(nd) {
  return nd.nq;
});
var $d_scm_LinkedHashMap$$anon$2 = new $TypeData().i($c_scm_LinkedHashMap$$anon$2, "scala.collection.mutable.LinkedHashMap$$anon$2", ({
  K6: 1,
  c5: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_scm_LinkedHashMap$$anon$3(outer) {
  this.xK = null;
  $ct_scm_LinkedHashMap$LinkedHashMapIterator__scm_LinkedHashMap__(this, outer);
}
$p = $c_scm_LinkedHashMap$$anon$3.prototype = new $h_scm_LinkedHashMap$LinkedHashMapIterator();
$p.constructor = $c_scm_LinkedHashMap$$anon$3;
/** @constructor */
function $h_scm_LinkedHashMap$$anon$3() {
}
$h_scm_LinkedHashMap$$anon$3.prototype = $p;
$p.WK = (function(nd) {
  return nd;
});
var $d_scm_LinkedHashMap$$anon$3 = new $TypeData().i($c_scm_LinkedHashMap$$anon$3, "scala.collection.mutable.LinkedHashMap$$anon$3", ({
  K7: 1,
  c5: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_scm_LinkedHashMap$$anon$4(outer) {
  this.xK = null;
  $ct_scm_LinkedHashMap$LinkedHashMapIterator__scm_LinkedHashMap__(this, outer);
}
$p = $c_scm_LinkedHashMap$$anon$4.prototype = new $h_scm_LinkedHashMap$LinkedHashMapIterator();
$p.constructor = $c_scm_LinkedHashMap$$anon$4;
/** @constructor */
function $h_scm_LinkedHashMap$$anon$4() {
}
$h_scm_LinkedHashMap$$anon$4.prototype = $p;
$p.WK = (function(nd) {
  return nd.fs;
});
var $d_scm_LinkedHashMap$$anon$4 = new $TypeData().i($c_scm_LinkedHashMap$$anon$4, "scala.collection.mutable.LinkedHashMap$$anon$4", ({
  K8: 1,
  c5: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_scm_LinkedHashMap$$anon$5(outer) {
  this.xK = null;
  this.ad4 = 0;
  this.aV5 = null;
  this.aV5 = outer;
  $ct_scm_LinkedHashMap$LinkedHashMapIterator__scm_LinkedHashMap__(this, outer);
  this.ad4 = 0;
}
$p = $c_scm_LinkedHashMap$$anon$5.prototype = new $h_scm_LinkedHashMap$LinkedHashMapIterator();
$p.constructor = $c_scm_LinkedHashMap$$anon$5;
/** @constructor */
function $h_scm_LinkedHashMap$$anon$5() {
}
$h_scm_LinkedHashMap$$anon$5.prototype = $p;
$p.x = (function() {
  return this.ad4;
});
$p.WK = (function(nd) {
  var $x_1 = $m_s_util_hashing_MurmurHash3$();
  var improvedHash = nd.pd;
  this.ad4 = $x_1.ri((improvedHash ^ ((improvedHash >>> 16) | 0)), $m_sr_Statics$().u(nd.fs));
  return this;
});
var $d_scm_LinkedHashMap$$anon$5 = new $TypeData().i($c_scm_LinkedHashMap$$anon$5, "scala.collection.mutable.LinkedHashMap$$anon$5", ({
  K9: 1,
  c5: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_scm_LinkedHashSet$$anon$1(outer) {
  this.Db = null;
  $ct_scm_LinkedHashSet$LinkedHashSetIterator__scm_LinkedHashSet__(this, outer);
}
$p = $c_scm_LinkedHashSet$$anon$1.prototype = new $h_scm_LinkedHashSet$LinkedHashSetIterator();
$p.constructor = $c_scm_LinkedHashSet$$anon$1;
/** @constructor */
function $h_scm_LinkedHashSet$$anon$1() {
}
$h_scm_LinkedHashSet$$anon$1.prototype = $p;
$p.afD = (function(nd) {
  return nd.pf;
});
var $d_scm_LinkedHashSet$$anon$1 = new $TypeData().i($c_scm_LinkedHashSet$$anon$1, "scala.collection.mutable.LinkedHashSet$$anon$1", ({
  Kd: 1,
  dR: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_scm_LinkedHashSet$$anon$2(outer) {
  this.Db = null;
  $ct_scm_LinkedHashSet$LinkedHashSetIterator__scm_LinkedHashSet__(this, outer);
}
$p = $c_scm_LinkedHashSet$$anon$2.prototype = new $h_scm_LinkedHashSet$LinkedHashSetIterator();
$p.constructor = $c_scm_LinkedHashSet$$anon$2;
/** @constructor */
function $h_scm_LinkedHashSet$$anon$2() {
}
$h_scm_LinkedHashSet$$anon$2.prototype = $p;
$p.afD = (function(nd) {
  return nd;
});
var $d_scm_LinkedHashSet$$anon$2 = new $TypeData().i($c_scm_LinkedHashSet$$anon$2, "scala.collection.mutable.LinkedHashSet$$anon$2", ({
  Ke: 1,
  dR: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_scm_LinkedHashSet$$anon$3(outer) {
  this.Db = null;
  this.ad6 = 0;
  this.aV6 = null;
  this.aV6 = outer;
  $ct_scm_LinkedHashSet$LinkedHashSetIterator__scm_LinkedHashSet__(this, outer);
  this.ad6 = 0;
}
$p = $c_scm_LinkedHashSet$$anon$3.prototype = new $h_scm_LinkedHashSet$LinkedHashSetIterator();
$p.constructor = $c_scm_LinkedHashSet$$anon$3;
/** @constructor */
function $h_scm_LinkedHashSet$$anon$3() {
}
$h_scm_LinkedHashSet$$anon$3.prototype = $p;
$p.x = (function() {
  return this.ad6;
});
$p.afD = (function(nd) {
  var improvedHash = nd.pe;
  this.ad6 = (improvedHash ^ ((improvedHash >>> 16) | 0));
  return this;
});
var $d_scm_LinkedHashSet$$anon$3 = new $TypeData().i($c_scm_LinkedHashSet$$anon$3, "scala.collection.mutable.LinkedHashSet$$anon$3", ({
  Kf: 1,
  dR: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1
}));
/** @constructor */
function $c_s_concurrent_duration_Duration$$anon$1() {
}
$p = $c_s_concurrent_duration_Duration$$anon$1.prototype = new $h_s_concurrent_duration_Duration$Infinite();
$p.constructor = $c_s_concurrent_duration_Duration$$anon$1;
/** @constructor */
function $h_s_concurrent_duration_Duration$$anon$1() {
}
$h_s_concurrent_duration_Duration$$anon$1.prototype = $p;
$p.m = (function() {
  return "Duration.Undefined";
});
$p.e = (function(other) {
  return false;
});
$p.Wu = (function(other) {
  return ((other !== this) | 0);
});
var $d_s_concurrent_duration_Duration$$anon$1 = new $TypeData().i($c_s_concurrent_duration_Duration$$anon$1, "scala.concurrent.duration.Duration$$anon$1", ({
  KF: 1,
  dV: 1,
  cS: 1,
  a: 1,
  b3: 1,
  Q: 1
}));
/** @constructor */
function $c_s_concurrent_duration_Duration$$anon$2() {
}
$p = $c_s_concurrent_duration_Duration$$anon$2.prototype = new $h_s_concurrent_duration_Duration$Infinite();
$p.constructor = $c_s_concurrent_duration_Duration$$anon$2;
/** @constructor */
function $h_s_concurrent_duration_Duration$$anon$2() {
}
$h_s_concurrent_duration_Duration$$anon$2.prototype = $p;
$p.m = (function() {
  return "Duration.Inf";
});
$p.Wu = (function(other) {
  return ((other === $m_s_concurrent_duration_Duration$().a1T) ? (-1) : ((other !== this) | 0));
});
var $d_s_concurrent_duration_Duration$$anon$2 = new $TypeData().i($c_s_concurrent_duration_Duration$$anon$2, "scala.concurrent.duration.Duration$$anon$2", ({
  KG: 1,
  dV: 1,
  cS: 1,
  a: 1,
  b3: 1,
  Q: 1
}));
/** @constructor */
function $c_s_concurrent_duration_Duration$$anon$3() {
}
$p = $c_s_concurrent_duration_Duration$$anon$3.prototype = new $h_s_concurrent_duration_Duration$Infinite();
$p.constructor = $c_s_concurrent_duration_Duration$$anon$3;
/** @constructor */
function $h_s_concurrent_duration_Duration$$anon$3() {
}
$h_s_concurrent_duration_Duration$$anon$3.prototype = $p;
$p.m = (function() {
  return "Duration.MinusInf";
});
$p.Wu = (function(other) {
  return ((other === this) ? 0 : (-1));
});
var $d_s_concurrent_duration_Duration$$anon$3 = new $TypeData().i($c_s_concurrent_duration_Duration$$anon$3, "scala.concurrent.duration.Duration$$anon$3", ({
  KH: 1,
  dV: 1,
  cS: 1,
  a: 1,
  b3: 1,
  Q: 1
}));
/** @constructor */
function $c_s_math_Ordering$$anon$1(outer, f$1) {
  this.aIZ = null;
  this.adm = null;
  this.aIZ = outer;
  this.adm = f$1;
}
$p = $c_s_math_Ordering$$anon$1.prototype = new $h_O();
$p.constructor = $c_s_math_Ordering$$anon$1;
/** @constructor */
function $h_s_math_Ordering$$anon$1() {
}
$h_s_math_Ordering$$anon$1.prototype = $p;
$p.mQ = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$p.mM = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$p.lZ = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$p.mL = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$p.kQ = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$p.kR = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$p.mO = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$p.dA = (function(x, y) {
  return this.aIZ.dA(this.adm.i(x), this.adm.i(y));
});
var $d_s_math_Ordering$$anon$1 = new $TypeData().i($c_s_math_Ordering$$anon$1, "scala.math.Ordering$$anon$1", ({
  KU: 1,
  ax: 1,
  ad: 1,
  ay: 1,
  aw: 1,
  a: 1
}));
function $f_s_math_Ordering$CachedReverse__isReverseOf__s_math_Ordering__Z($thiz, other) {
  return (other === $thiz.aJ0);
}
function $f_s_math_Ordering$Double$IeeeOrdering__lteq__D__D__Z($thiz, x, y) {
  return (x <= y);
}
function $f_s_math_Ordering$Double$IeeeOrdering__gteq__D__D__Z($thiz, x, y) {
  return (x >= y);
}
function $f_s_math_Ordering$Double$IeeeOrdering__lt__D__D__Z($thiz, x, y) {
  return (x < y);
}
function $f_s_math_Ordering$Double$IeeeOrdering__gt__D__D__Z($thiz, x, y) {
  return (x > y);
}
/** @constructor */
function $c_s_math_Ordering$Reverse(outer) {
  this.qK = null;
  this.qK = outer;
}
$p = $c_s_math_Ordering$Reverse.prototype = new $h_O();
$p.constructor = $c_s_math_Ordering$Reverse;
/** @constructor */
function $h_s_math_Ordering$Reverse() {
}
$h_s_math_Ordering$Reverse.prototype = $p;
$p.mO = (function(other) {
  var x$2 = this.qK;
  return ((other === null) ? (x$2 === null) : other.e(x$2));
});
$p.dA = (function(x, y) {
  return this.qK.dA(y, x);
});
$p.mQ = (function(x, y) {
  return this.qK.mQ(y, x);
});
$p.mM = (function(x, y) {
  return this.qK.mM(y, x);
});
$p.lZ = (function(x, y) {
  return this.qK.lZ(y, x);
});
$p.mL = (function(x, y) {
  return this.qK.mL(y, x);
});
$p.kQ = (function(x, y) {
  return this.qK.kR(x, y);
});
$p.kR = (function(x, y) {
  return this.qK.kQ(x, y);
});
$p.e = (function(obj) {
  if ((obj !== null)) {
    if ((this === obj)) {
      return true;
    }
  }
  if ((obj instanceof $c_s_math_Ordering$Reverse)) {
    var x = this.qK;
    var x$2 = obj.qK;
    return ((x === null) ? (x$2 === null) : x.e(x$2));
  }
  return false;
});
$p.x = (function() {
  return Math.imul(41, this.qK.x());
});
function $isArrayOf_s_math_Ordering$Reverse(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.m9)));
}
var $d_s_math_Ordering$Reverse = new $TypeData().i($c_s_math_Ordering$Reverse, "scala.math.Ordering$Reverse", ({
  m9: 1,
  ax: 1,
  ad: 1,
  ay: 1,
  aw: 1,
  a: 1
}));
/** @constructor */
function $c_s_math_Ordering$Tuple2Ordering(ord1, ord2) {
  this.Vm = null;
  this.Vn = null;
  this.Vm = ord1;
  this.Vn = ord2;
}
$p = $c_s_math_Ordering$Tuple2Ordering.prototype = new $h_O();
$p.constructor = $c_s_math_Ordering$Tuple2Ordering;
/** @constructor */
function $h_s_math_Ordering$Tuple2Ordering() {
}
$h_s_math_Ordering$Tuple2Ordering.prototype = $p;
$p.mQ = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$p.mM = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$p.lZ = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$p.mL = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$p.kQ = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$p.kR = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$p.mO = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$p.aYL = (function(x, y) {
  var compare1 = this.Vm.dA(x.g(), y.g());
  if ((compare1 !== 0)) {
    return compare1;
  }
  return this.Vn.dA(x.h(), y.h());
});
$p.e = (function(obj) {
  if ((obj !== null)) {
    if ((this === obj)) {
      return true;
    }
  }
  if ((obj instanceof $c_s_math_Ordering$Tuple2Ordering)) {
    var x = this.Vm;
    var x$2 = obj.Vm;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      var x$3 = this.Vn;
      var x$4 = obj.Vn;
      return ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      return false;
    }
  }
  return false;
});
$p.x = (function() {
  var _1 = this.Vm;
  var _2 = this.Vn;
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var h = (-116390334);
  var i = 0;
  while ((i < 2)) {
    var $x_3 = h;
    var $x_2 = $m_sr_Statics$();
    var n = i;
    switch (n) {
      case 0: {
        var $x_1 = _1;
        break;
      }
      case 1: {
        var $x_1 = _2;
        break;
      }
      default: {
        var $x_1;
        throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 1)"));
      }
    }
    h = this$1.k($x_3, $x_2.u($x_1));
    i = ((1 + i) | 0);
  }
  return this$1.Z(h, 2);
});
$p.dA = (function(x, y) {
  return this.aYL(x, y);
});
function $isArrayOf_s_math_Ordering$Tuple2Ordering(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ma)));
}
var $d_s_math_Ordering$Tuple2Ordering = new $TypeData().i($c_s_math_Ordering$Tuple2Ordering, "scala.math.Ordering$Tuple2Ordering", ({
  ma: 1,
  ax: 1,
  ad: 1,
  ay: 1,
  aw: 1,
  a: 1
}));
/** @constructor */
function $c_s_math_Ordering$Tuple4Ordering(ord1, ord2, ord3, ord4) {
  this.Vo = null;
  this.Vp = null;
  this.Vq = null;
  this.Vr = null;
  this.Vo = ord1;
  this.Vp = ord2;
  this.Vq = ord3;
  this.Vr = ord4;
}
$p = $c_s_math_Ordering$Tuple4Ordering.prototype = new $h_O();
$p.constructor = $c_s_math_Ordering$Tuple4Ordering;
/** @constructor */
function $h_s_math_Ordering$Tuple4Ordering() {
}
$h_s_math_Ordering$Tuple4Ordering.prototype = $p;
$p.mQ = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$p.mM = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$p.lZ = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$p.mL = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$p.kQ = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$p.kR = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$p.mO = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$p.aYM = (function(x, y) {
  var compare1 = this.Vo.dA(x.bO, y.bO);
  if ((compare1 !== 0)) {
    return compare1;
  }
  var compare2 = this.Vp.dA(x.bs, y.bs);
  if ((compare2 !== 0)) {
    return compare2;
  }
  var compare3 = this.Vq.dA(x.ch, y.ch);
  if ((compare3 !== 0)) {
    return compare3;
  }
  return this.Vr.dA(x.ca, y.ca);
});
$p.e = (function(obj) {
  if ((obj !== null)) {
    if ((this === obj)) {
      return true;
    }
  }
  if ((obj instanceof $c_s_math_Ordering$Tuple4Ordering)) {
    var x = this.Vo;
    var x$2 = obj.Vo;
    if (((x === null) ? (x$2 === null) : x.e(x$2))) {
      var x$3 = this.Vp;
      var x$4 = obj.Vp;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : x$3.e(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.Vq;
      var x$6 = obj.Vq;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$7 = this.Vr;
      var x$8 = obj.Vr;
      return ((x$7 === null) ? (x$8 === null) : x$7.e(x$8));
    } else {
      return false;
    }
  }
  return false;
});
$p.x = (function() {
  var _1 = this.Vo;
  var _2 = this.Vp;
  var _3 = this.Vq;
  var _4 = this.Vr;
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var h = (-1542739752);
  var i = 0;
  while ((i < 4)) {
    var $x_3 = h;
    var $x_2 = $m_sr_Statics$();
    var n = i;
    switch (n) {
      case 0: {
        var $x_1 = _1;
        break;
      }
      case 1: {
        var $x_1 = _2;
        break;
      }
      case 2: {
        var $x_1 = _3;
        break;
      }
      case 3: {
        var $x_1 = _4;
        break;
      }
      default: {
        var $x_1;
        throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 3)"));
      }
    }
    h = this$1.k($x_3, $x_2.u($x_1));
    i = ((1 + i) | 0);
  }
  return this$1.Z(h, 4);
});
$p.dA = (function(x, y) {
  return this.aYM(x, y);
});
function $isArrayOf_s_math_Ordering$Tuple4Ordering(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.mb)));
}
var $d_s_math_Ordering$Tuple4Ordering = new $TypeData().i($c_s_math_Ordering$Tuple4Ordering, "scala.math.Ordering$Tuple4Ordering", ({
  mb: 1,
  ax: 1,
  ad: 1,
  ay: 1,
  aw: 1,
  a: 1
}));
/** @constructor */
function $c_s_reflect_ClassTag$GenericClassTag(runtimeClass) {
  this.Vs = null;
  this.Vs = runtimeClass;
}
$p = $c_s_reflect_ClassTag$GenericClassTag.prototype = new $h_O();
$p.constructor = $c_s_reflect_ClassTag$GenericClassTag;
/** @constructor */
function $h_s_reflect_ClassTag$GenericClassTag() {
}
$h_s_reflect_ClassTag$GenericClassTag.prototype = $p;
$p.e = (function(x) {
  return $f_s_reflect_ClassTag__equals__O__Z(this, x);
});
$p.x = (function() {
  return $m_sr_Statics$().u(this.Vs);
});
$p.m = (function() {
  return $ps_s_reflect_ClassTag__prettyprint$1__jl_Class__T(this.Vs);
});
$p.h8 = (function() {
  return this.Vs;
});
$p.b2 = (function(len) {
  return this.Vs.ba.U(len);
});
var $d_s_reflect_ClassTag$GenericClassTag = new $TypeData().i($c_s_reflect_ClassTag$GenericClassTag, "scala.reflect.ClassTag$GenericClassTag", ({
  Lf: 1,
  az: 1,
  aH: 1,
  aI: 1,
  a: 1,
  b: 1
}));
function $p_s_util_matching_Regex$MatchIterator__ensure__V($thiz) {
  var x1 = $thiz.A9;
  switch (x1) {
    case 0: {
      if ((!$thiz.p())) {
        throw $ct_jl_IllegalStateException__(new $c_jl_IllegalStateException());
      }
      break;
    }
    case 1: {
      break;
    }
    case 2: {
      break;
    }
    case 3: {
      throw $ct_jl_IllegalStateException__(new $c_jl_IllegalStateException());
      break;
    }
    default: {
      throw new $c_s_MatchError(x1);
    }
  }
}
/** @constructor */
function $c_s_util_matching_Regex$MatchIterator(source, regex, _groupNames) {
  this.adt = null;
  this.aJm = null;
  this.Dh = null;
  this.A9 = 0;
  this.adt = source;
  this.aJm = _groupNames;
  this.Dh = new $c_ju_regex_Matcher(regex.A8, $dp_toString__T(source));
  this.A9 = 0;
}
$p = $c_s_util_matching_Regex$MatchIterator.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_s_util_matching_Regex$MatchIterator;
/** @constructor */
function $h_s_util_matching_Regex$MatchIterator() {
}
$h_s_util_matching_Regex$MatchIterator.prototype = $p;
$p.ai7 = (function() {
  return this.adt;
});
$p.p = (function() {
  var x1 = this.A9;
  switch (x1) {
    case 0: {
      this.A9 = (this.Dh.IV() ? 1 : 3);
      break;
    }
    case 1: {
      break;
    }
    case 2: {
      this.A9 = 0;
      this.p();
      break;
    }
    case 3: {
      break;
    }
    default: {
      throw new $c_s_MatchError(x1);
    }
  }
  return (this.A9 === 1);
});
$p.wa = (function() {
  var x1 = this.A9;
  switch (x1) {
    case 0: {
      if ((!this.p())) {
        throw $ct_ju_NoSuchElementException__(new $c_ju_NoSuchElementException());
      }
      this.wa();
      break;
    }
    case 1: {
      this.A9 = 2;
      break;
    }
    case 2: {
      this.A9 = 0;
      this.wa();
      break;
    }
    case 3: {
      throw $ct_ju_NoSuchElementException__(new $c_ju_NoSuchElementException());
      break;
    }
    default: {
      throw new $c_s_MatchError(x1);
    }
  }
  return this.Dh.agl();
});
$p.m = (function() {
  return "<iterator>";
});
$p.AF = (function() {
  $p_s_util_matching_Regex$MatchIterator__ensure__V(this);
  return this.Dh.AF();
});
$p.PX = (function(i) {
  $p_s_util_matching_Regex$MatchIterator__ensure__V(this);
  return this.Dh.PX(i);
});
$p.Ak = (function() {
  $p_s_util_matching_Regex$MatchIterator__ensure__V(this);
  return this.Dh.Ak();
});
$p.WG = (function(i) {
  $p_s_util_matching_Regex$MatchIterator__ensure__V(this);
  return this.Dh.WG(i);
});
$p.q = (function() {
  return this.wa();
});
var $d_s_util_matching_Regex$MatchIterator = new $TypeData().i($c_s_util_matching_Regex$MatchIterator, "scala.util.matching.Regex$MatchIterator", ({
  MZ: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1,
  mv: 1
}));
/** @constructor */
function $c_s_util_parsing_combinator_Parsers$$anon$2(res$1, next$1, failure$1, outer) {
  this.qL = null;
  this.pg = null;
  this.lQ = null;
  this.Aa = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_s_util_parsing_combinator_Parsers$Success__s_util_parsing_combinator_Parsers__O__s_util_parsing_input_Reader__(this, outer, res$1, next$1);
  this.Aa = failure$1;
}
$p = $c_s_util_parsing_combinator_Parsers$$anon$2.prototype = new $h_s_util_parsing_combinator_Parsers$Success();
$p.constructor = $c_s_util_parsing_combinator_Parsers$$anon$2;
/** @constructor */
function $h_s_util_parsing_combinator_Parsers$$anon$2() {
}
$h_s_util_parsing_combinator_Parsers$$anon$2.prototype = $p;
var $d_s_util_parsing_combinator_Parsers$$anon$2 = new $TypeData().i($c_s_util_parsing_combinator_Parsers$$anon$2, "scala.util.parsing.combinator.Parsers$$anon$2", ({
  N2: 1,
  mA: 1,
  mz: 1,
  b: 1,
  c: 1,
  a: 1
}));
function $isArrayOf_s_util_parsing_combinator_Parsers$Error(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.N6)));
}
/** @constructor */
function $c_s_util_parsing_combinator_Parsers$Failure(outer, msg, next) {
  this.a24 = null;
  this.VB = null;
  this.xN = null;
  this.xM = null;
  this.VB = msg;
  this.xN = next;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.xM = outer;
  $ct_s_util_parsing_combinator_Parsers$NoSuccess__s_util_parsing_combinator_Parsers__T__s_util_parsing_input_Reader__(this, outer, msg, next);
}
$p = $c_s_util_parsing_combinator_Parsers$Failure.prototype = new $h_s_util_parsing_combinator_Parsers$NoSuccess();
$p.constructor = $c_s_util_parsing_combinator_Parsers$Failure;
/** @constructor */
function $h_s_util_parsing_combinator_Parsers$Failure() {
}
$h_s_util_parsing_combinator_Parsers$Failure.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().eN(this, (-889275714), null);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if (((x$0 instanceof $c_s_util_parsing_combinator_Parsers$Failure) && (x$0.xM === this.xM))) {
    if ((this.VB === x$0.VB)) {
      var x = this.xN;
      var x$2 = x$0.xN;
      return ((x === null) ? (x$2 === null) : (x === x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "Failure";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.VB;
  }
  if ((n === 1)) {
    return this.xN;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "msg";
  }
  if ((n === 1)) {
    return "next";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.aQr = (function() {
  return this.xN;
});
$p.m = (function() {
  var this$1 = this.xN;
  var $x_2 = new $c_s_util_parsing_input_OffsetPosition(this$1.pi, this$1.ph);
  var $x_1 = this.VB;
  var this$2 = this.xN;
  return ((((("[" + $x_2) + "] failure: ") + $x_1) + "\n\n") + $f_s_util_parsing_input_Position__longString__T(new $c_s_util_parsing_input_OffsetPosition(this$2.pi, this$2.ph)));
});
$p.aLZ = (function(a) {
  var alt = a.a3();
  if (((alt instanceof $c_s_util_parsing_combinator_Parsers$Success) && (alt.lQ === this.xM))) {
    this.xM.OQ();
    return new $c_s_util_parsing_combinator_Parsers$$anon$2(alt.qL, alt.pg, $f_s_util_parsing_combinator_Parsers__selectLastFailure__s_Option__s_Option__s_Option(this.xM, new $c_s_Some(this), alt.Aa), this.xM);
  }
  if (((alt instanceof $c_s_util_parsing_combinator_Parsers$NoSuccess) && (alt.a24 === this.xM))) {
    var this$5 = alt.aQr();
    var $x_1 = new $c_s_util_parsing_input_OffsetPosition(this$5.pi, this$5.ph);
    var this$6 = this.xN;
    if ($x_1.aLh(new $c_s_util_parsing_input_OffsetPosition(this$6.pi, this$6.ph))) {
      return this;
    } else {
      return alt;
    }
  }
  throw new $c_s_MatchError(alt);
});
function $isArrayOf_s_util_parsing_combinator_Parsers$Failure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.mx)));
}
var $d_s_util_parsing_combinator_Parsers$Failure = new $TypeData().i($c_s_util_parsing_combinator_Parsers$Failure, "scala.util.parsing.combinator.Parsers$Failure", ({
  mx: 1,
  my: 1,
  mz: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_s_util_parsing_input_OffsetPosition$() {
  this.aJw = null;
  this.aJx = false;
}
$p = $c_s_util_parsing_input_OffsetPosition$.prototype = new $h_sr_AbstractFunction2();
$p.constructor = $c_s_util_parsing_input_OffsetPosition$;
/** @constructor */
function $h_s_util_parsing_input_OffsetPosition$() {
}
$h_s_util_parsing_input_OffsetPosition$.prototype = $p;
$p.aPd = (function() {
  if ((!this.aJx)) {
    this.aJw = new $c_s_util_parsing_input_PositionCache$$anon$1();
    this.aJx = true;
  }
  return this.aJw;
});
$p.R = (function(v1, v2) {
  return new $c_s_util_parsing_input_OffsetPosition(v1, (v2 | 0));
});
var $d_s_util_parsing_input_OffsetPosition$ = new $TypeData().i($c_s_util_parsing_input_OffsetPosition$, "scala.util.parsing.input.OffsetPosition$", ({
  Nf: 1,
  c9: 1,
  bE: 1,
  Ng: 1,
  d: 1,
  j: 1
}));
var $n_s_util_parsing_input_OffsetPosition$;
function $m_s_util_parsing_input_OffsetPosition$() {
  if ((!$n_s_util_parsing_input_OffsetPosition$)) {
    $n_s_util_parsing_input_OffsetPosition$ = new $c_s_util_parsing_input_OffsetPosition$();
  }
  return $n_s_util_parsing_input_OffsetPosition$;
}
class $c_Lujson_Value$InvalidData extends $c_jl_Exception {
  constructor(data, msg) {
    super();
    this.a2e = null;
    this.a2f = null;
    this.a2e = data;
    this.a2f = msg;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, (((msg + " (data: ") + data) + ")"), null, true, true);
  }
  H() {
    return new $c_s_Product$$anon$1(this);
  }
  x() {
    return $m_s_util_hashing_MurmurHash3$().eN(this, (-889275714), null);
  }
  e(x$0) {
    if ((this === x$0)) {
      return true;
    } else if ((x$0 instanceof $c_Lujson_Value$InvalidData)) {
      var x = this.a2e;
      var x$2 = x$0.a2e;
      if (((x === null) ? (x$2 === null) : x.e(x$2))) {
        return (this.a2f === x$0.a2f);
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  z() {
    return 2;
  }
  B() {
    return "InvalidData";
  }
  A(n) {
    if ((n === 0)) {
      return this.a2e;
    }
    if ((n === 1)) {
      return this.a2f;
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  D(n) {
    if ((n === 0)) {
      return "data";
    }
    if ((n === 1)) {
      return "msg";
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
}
function $isArrayOf_Lujson_Value$InvalidData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.mS)));
}
var $d_Lujson_Value$InvalidData = new $TypeData().i($c_Lujson_Value$InvalidData, "ujson.Value$InvalidData", ({
  mS: 1,
  G: 1,
  y: 1,
  a: 1,
  b: 1,
  c: 1
}));
/** @constructor */
function $c_Lupickle_Api$transform(outer, t, evidence$1) {
  this.VV = null;
  this.aJF = null;
  this.adF = null;
  this.VV = t;
  this.aJF = evidence$1;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.adF = outer;
}
$p = $c_Lupickle_Api$transform.prototype = new $h_O();
$p.constructor = $c_Lupickle_Api$transform;
/** @constructor */
function $h_Lupickle_Api$transform() {
}
$h_Lupickle_Api$transform.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().eN(this, (-889275714), null);
});
$p.e = (function(x$0) {
  return ((this === x$0) || (((x$0 instanceof $c_Lupickle_Api$transform) && (x$0.adF === this.adF)) && $m_sr_BoxesRunTime$().Q(this.VV, x$0.VV)));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "transform";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.VV;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "t";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.yq = (function(f) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this.aJF, f, this.VV);
});
function $isArrayOf_Lupickle_Api$transform(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.n4)));
}
var $d_Lupickle_Api$transform = new $TypeData().i($c_Lupickle_Api$transform, "upickle.Api$transform", ({
  n4: 1,
  aC: 1,
  b4: 1,
  b: 1,
  c: 1,
  a: 1
}));
class $c_Lupickle_core_Abort extends $c_jl_Exception {
  constructor(msg) {
    super();
    this.Or = null;
    this.Or = msg;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, msg, null, true, true);
  }
  H() {
    return new $c_s_Product$$anon$1(this);
  }
  x() {
    return $m_s_util_hashing_MurmurHash3$().eN(this, (-889275714), null);
  }
  e(x$0) {
    return ((this === x$0) || ((x$0 instanceof $c_Lupickle_core_Abort) && (this.Or === x$0.Or)));
  }
  z() {
    return 1;
  }
  B() {
    return "Abort";
  }
  A(n) {
    if ((n === 0)) {
      return this.Or;
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  D(n) {
    if ((n === 0)) {
      return "msg";
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
}
function $isArrayOf_Lupickle_core_Abort(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.n5)));
}
var $d_Lupickle_core_Abort = new $TypeData().i($c_Lupickle_core_Abort, "upickle.core.Abort", ({
  n5: 1,
  G: 1,
  y: 1,
  a: 1,
  b: 1,
  c: 1
}));
class $c_Lupickle_core_AbortException extends $c_jl_Exception {
  constructor(clue, index, line, col, cause) {
    super();
    this.VX = null;
    this.VZ = 0;
    this.W0 = 0;
    this.VY = 0;
    this.VW = null;
    this.VX = clue;
    this.VZ = index;
    this.W0 = line;
    this.VY = col;
    this.VW = cause;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, ((clue + " at index ") + index), cause, true, true);
  }
  H() {
    return new $c_s_Product$$anon$1(this);
  }
  x() {
    var acc = (-889275714);
    acc = $m_sr_Statics$().k(acc, $f_T__hashCode__I("AbortException"));
    acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.VX));
    acc = $m_sr_Statics$().k(acc, this.VZ);
    acc = $m_sr_Statics$().k(acc, this.W0);
    acc = $m_sr_Statics$().k(acc, this.VY);
    acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.VW));
    return $m_sr_Statics$().Z(acc, 5);
  }
  e(x$0) {
    if ((this === x$0)) {
      return true;
    } else if ((x$0 instanceof $c_Lupickle_core_AbortException)) {
      if (((((this.VZ === x$0.VZ) && (this.W0 === x$0.W0)) && (this.VY === x$0.VY)) && (this.VX === x$0.VX))) {
        var x = this.VW;
        var x$2 = x$0.VW;
        return ((x === null) ? (x$2 === null) : x.e(x$2));
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  z() {
    return 5;
  }
  B() {
    return "AbortException";
  }
  A(n) {
    switch (n) {
      case 0: {
        return this.VX;
        break;
      }
      case 1: {
        return this.VZ;
        break;
      }
      case 2: {
        return this.W0;
        break;
      }
      case 3: {
        return this.VY;
        break;
      }
      case 4: {
        return this.VW;
        break;
      }
      default: {
        throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
      }
    }
  }
  D(n) {
    switch (n) {
      case 0: {
        return "clue";
        break;
      }
      case 1: {
        return "index";
        break;
      }
      case 2: {
        return "line";
        break;
      }
      case 3: {
        return "col";
        break;
      }
      case 4: {
        return "cause";
        break;
      }
      default: {
        throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
      }
    }
  }
}
function $isArrayOf_Lupickle_core_AbortException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.n6)));
}
var $d_Lupickle_core_AbortException = new $TypeData().i($c_Lupickle_core_AbortException, "upickle.core.AbortException", ({
  n6: 1,
  G: 1,
  y: 1,
  a: 1,
  b: 1,
  c: 1
}));
/** @constructor */
function $c_Lupickle_core_Types$TaggedReader$Leaf(outer, tagKey, tagValue, tagShortValue, r) {
  this.aJT = null;
  this.aJV = null;
  this.aJU = null;
  this.aJS = null;
  this.adT = null;
  this.aJT = tagKey;
  this.aJV = tagValue;
  this.aJU = tagShortValue;
  this.aJS = r;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.adT = outer;
}
$p = $c_Lupickle_core_Types$TaggedReader$Leaf.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_Types$TaggedReader$Leaf;
/** @constructor */
function $h_Lupickle_core_Types$TaggedReader$Leaf() {
}
$h_Lupickle_core_Types$TaggedReader$Leaf.prototype = $p;
$p.ge = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.gB = (function() {
  return this;
});
$p.c8 = (function(index) {
  return null;
});
$p.eE = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitTrue__I__O(this, index);
});
$p.eC = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitFalse__I__O(this, index);
});
$p.eD = (function(s, decIndex, expIndex, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64StringParts__jl_CharSequence__I__I__I__O(this, s, decIndex, expIndex, index);
});
$p.e7 = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64__D__I__O(this, d, index);
});
$p.eY = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat32__F__I__O(this, d, index);
});
$p.em = (function(i, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt32__I__I__O(this, i, index);
});
$p.eZ = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.fe = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitUInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.fA = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64String__T__I__O(this, s, index);
});
$p.fc = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitChar__C__I__O(this, s, index);
});
$p.fb = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.fd = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.ej = (function() {
  this.ul();
  return "expected dictionary";
});
$p.cZ = (function(length, index) {
  return $f_Lupickle_core_Types__taggedArrayContext__Lupickle_core_Types$TaggedReader__I__Lupickle_core_ArrVisitor(this.ul(), this, index);
});
$p.bQ = (function(length, jsonableKeys, index) {
  return new $c_Lupickle_AttributeTagged$$anon$6(this, index, this.ul());
});
$p.cN = (function(s, index) {
  return $f_Lupickle_core_Types$TaggedReader__visitString__jl_CharSequence__I__O(this, s, index);
});
$p.Js = (function() {
  return this.aJT;
});
$p.IW = (function(s) {
  return (((s === this.aJV) || (s === this.aJU)) ? this.aJS : null);
});
$p.oH = (function() {
  return this.adT.W3;
});
$p.ul = (function() {
  return this.adT.W3;
});
$p.ha = (function() {
  return this.oH();
});
$p.ais = (function() {
  return this.ul();
});
var $d_Lupickle_core_Types$TaggedReader$Leaf = new $TypeData().i($c_Lupickle_core_Types$TaggedReader$Leaf, "upickle.core.Types$TaggedReader$Leaf", ({
  OO: 1,
  x: 1,
  D: 1,
  J: 1,
  K: 1,
  cc: 1
}));
/** @constructor */
function $c_Lupickle_core_Types$TaggedReader$Node(outer, tagKey, rs) {
  this.aJX = null;
  this.aJW = null;
  this.adU = null;
  this.aJX = tagKey;
  this.aJW = rs;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.adU = outer;
}
$p = $c_Lupickle_core_Types$TaggedReader$Node.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_Types$TaggedReader$Node;
/** @constructor */
function $h_Lupickle_core_Types$TaggedReader$Node() {
}
$h_Lupickle_core_Types$TaggedReader$Node.prototype = $p;
$p.ge = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.gB = (function() {
  return this;
});
$p.c8 = (function(index) {
  return null;
});
$p.eE = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitTrue__I__O(this, index);
});
$p.eC = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitFalse__I__O(this, index);
});
$p.eD = (function(s, decIndex, expIndex, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64StringParts__jl_CharSequence__I__I__I__O(this, s, decIndex, expIndex, index);
});
$p.e7 = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64__D__I__O(this, d, index);
});
$p.eY = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat32__F__I__O(this, d, index);
});
$p.em = (function(i, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt32__I__I__O(this, i, index);
});
$p.eZ = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.fe = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitUInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.fA = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64String__T__I__O(this, s, index);
});
$p.fc = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitChar__C__I__O(this, s, index);
});
$p.fb = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.fd = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.ej = (function() {
  this.ul();
  return "expected dictionary";
});
$p.cZ = (function(length, index) {
  return $f_Lupickle_core_Types__taggedArrayContext__Lupickle_core_Types$TaggedReader__I__Lupickle_core_ArrVisitor(this.ul(), this, index);
});
$p.bQ = (function(length, jsonableKeys, index) {
  return new $c_Lupickle_AttributeTagged$$anon$6(this, index, this.ul());
});
$p.cN = (function(s, index) {
  return $f_Lupickle_core_Types$TaggedReader__visitString__jl_CharSequence__I__O(this, s, index);
});
$p.Js = (function() {
  return this.aJX;
});
$p.IW = (function(s) {
  var xs = this.aJW;
  var x = null;
  var i = xs.o();
  while (((x === null) && i.p())) {
    var t = i.q().IW(s);
    if ((t !== null)) {
      x = t;
    }
  }
  return x;
});
$p.oH = (function() {
  return this.adU.W3;
});
$p.ul = (function() {
  return this.adU.W3;
});
$p.ha = (function() {
  return this.oH();
});
$p.ais = (function() {
  return this.ul();
});
var $d_Lupickle_core_Types$TaggedReader$Node = new $TypeData().i($c_Lupickle_core_Types$TaggedReader$Node, "upickle.core.Types$TaggedReader$Node", ({
  OP: 1,
  x: 1,
  D: 1,
  J: 1,
  K: 1,
  cc: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$10(outer) {
  this.aKy = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aKy = outer;
}
$p = $c_Lupickle_implicits_Readers$$anon$10.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$10;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$10() {
}
$h_Lupickle_implicits_Readers$$anon$10.prototype = $p;
$p.ge = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.gB = (function() {
  return this;
});
$p.c8 = (function(index) {
  return null;
});
$p.eE = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitTrue__I__O(this, index);
});
$p.eC = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitFalse__I__O(this, index);
});
$p.bQ = (function(length, jsonableKeys, index) {
  return $f_Lupickle_core_SimpleVisitor__visitObject__I__Z__I__Lupickle_core_ObjVisitor(this, length, jsonableKeys, index);
});
$p.cZ = (function(length, index) {
  return $f_Lupickle_core_SimpleVisitor__visitArray__I__I__Lupickle_core_ArrVisitor(this, length, index);
});
$p.fb = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.fd = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.fA = (function(s, index) {
  return $f_Lupickle_implicits_Readers$NumericReader__visitFloat64String__T__I__O(this, s, index);
});
$p.ej = (function() {
  return "expected char";
});
$p.bbE = (function(s, decIndex, expIndex, index) {
  var $x_1 = $m_Lupickle_core_ParseUtils$().PI(s, decIndex, expIndex, index);
  return (65535 & $s_RTLong__toInt__I__I__I($x_1.l, $x_1.h));
});
$p.ha = (function() {
  return this.aKy;
});
$p.cN = (function(s, index) {
  return $bC($dp_toString__T(s).charCodeAt(0));
});
$p.fc = (function(s, index) {
  return $bC(s);
});
$p.em = (function(i, index) {
  return $bC((65535 & i));
});
$p.eZ = (function(i_$_lo, i_$_hi, index) {
  return $bC((65535 & i_$_lo));
});
$p.fe = (function(i_$_lo, i_$_hi, index) {
  return $bC((65535 & i_$_lo));
});
$p.eY = (function(d, index) {
  return $bC((65535 & $doubleToInt(d)));
});
$p.e7 = (function(d, index) {
  return $bC((65535 & $doubleToInt(d)));
});
$p.eD = (function(s, decIndex, expIndex, index) {
  return $bC(this.bbE(s, decIndex, expIndex, index));
});
var $d_Lupickle_implicits_Readers$$anon$10 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$10, "upickle.implicits.Readers$$anon$10", ({
  Pd: 1,
  x: 1,
  D: 1,
  J: 1,
  K: 1,
  bu: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$11(outer) {
  this.aKz = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aKz = outer;
}
$p = $c_Lupickle_implicits_Readers$$anon$11.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$11;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$11() {
}
$h_Lupickle_implicits_Readers$$anon$11.prototype = $p;
$p.ge = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.gB = (function() {
  return this;
});
$p.c8 = (function(index) {
  return null;
});
$p.eE = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitTrue__I__O(this, index);
});
$p.eC = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitFalse__I__O(this, index);
});
$p.eD = (function(s, decIndex, expIndex, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64StringParts__jl_CharSequence__I__I__I__O(this, s, decIndex, expIndex, index);
});
$p.bQ = (function(length, jsonableKeys, index) {
  return $f_Lupickle_core_SimpleVisitor__visitObject__I__Z__I__Lupickle_core_ObjVisitor(this, length, jsonableKeys, index);
});
$p.cZ = (function(length, index) {
  return $f_Lupickle_core_SimpleVisitor__visitArray__I__I__Lupickle_core_ArrVisitor(this, length, index);
});
$p.e7 = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64__D__I__O(this, d, index);
});
$p.eY = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat32__F__I__O(this, d, index);
});
$p.em = (function(i, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt32__I__I__O(this, i, index);
});
$p.eZ = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.fe = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitUInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.fA = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64String__T__I__O(this, s, index);
});
$p.fc = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitChar__C__I__O(this, s, index);
});
$p.fb = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.fd = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.ej = (function() {
  return "expected string";
});
$p.cN = (function(s, index) {
  return $m_ju_UUID$().b1S($dp_toString__T(s));
});
$p.ha = (function() {
  return this.aKz;
});
var $d_Lupickle_implicits_Readers$$anon$11 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$11, "upickle.implicits.Readers$$anon$11", ({
  Pe: 1,
  x: 1,
  D: 1,
  J: 1,
  K: 1,
  ce: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$12(outer) {
  this.aKA = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aKA = outer;
}
$p = $c_Lupickle_implicits_Readers$$anon$12.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$12;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$12() {
}
$h_Lupickle_implicits_Readers$$anon$12.prototype = $p;
$p.gB = (function() {
  return this;
});
$p.c8 = (function(index) {
  return null;
});
$p.eE = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitTrue__I__O(this, index);
});
$p.eC = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitFalse__I__O(this, index);
});
$p.bQ = (function(length, jsonableKeys, index) {
  return $f_Lupickle_core_SimpleVisitor__visitObject__I__Z__I__Lupickle_core_ObjVisitor(this, length, jsonableKeys, index);
});
$p.cZ = (function(length, index) {
  return $f_Lupickle_core_SimpleVisitor__visitArray__I__I__Lupickle_core_ArrVisitor(this, length, index);
});
$p.fc = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitChar__C__I__O(this, s, index);
});
$p.fb = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.fd = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.fA = (function(s, index) {
  return $f_Lupickle_implicits_Readers$NumericReader__visitFloat64String__T__I__O(this, s, index);
});
$p.ej = (function() {
  return "expected number";
});
$p.ha = (function() {
  return this.aKA;
});
$p.cN = (function(s, index) {
  return $uJ($f_Lupickle_implicits_Readers$NumericReader__visitFloat64String__T__I__O(this, $dp_toString__T(s), index));
});
$p.em = (function(i, index) {
  var hi = (i >> 31);
  return $bL(i, hi);
});
$p.eZ = (function(i_$_lo, i_$_hi, index) {
  return $bL(i_$_lo, i_$_hi);
});
$p.fe = (function(i_$_lo, i_$_hi, index) {
  return $bL(i_$_lo, i_$_hi);
});
$p.eY = (function(d, index) {
  return $m_RTLong$().d1(d);
});
$p.e7 = (function(d, index) {
  return $m_RTLong$().d1(d);
});
$p.eD = (function(s, decIndex, expIndex, index) {
  return $m_Lupickle_core_ParseUtils$().PI(s, decIndex, expIndex, index);
});
$p.ge = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $m_Lupickle_core_CharUtils$().XG(s, arrOffset, arrLength, decIndex, expIndex);
});
var $d_Lupickle_implicits_Readers$$anon$12 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$12, "upickle.implicits.Readers$$anon$12", ({
  Pf: 1,
  x: 1,
  D: 1,
  J: 1,
  K: 1,
  bu: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$13(outer) {
  this.aKB = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aKB = outer;
}
$p = $c_Lupickle_implicits_Readers$$anon$13.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$13;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$13() {
}
$h_Lupickle_implicits_Readers$$anon$13.prototype = $p;
$p.ge = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.gB = (function() {
  return this;
});
$p.c8 = (function(index) {
  return null;
});
$p.eE = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitTrue__I__O(this, index);
});
$p.eC = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitFalse__I__O(this, index);
});
$p.eD = (function(s, decIndex, expIndex, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64StringParts__jl_CharSequence__I__I__I__O(this, s, decIndex, expIndex, index);
});
$p.bQ = (function(length, jsonableKeys, index) {
  return $f_Lupickle_core_SimpleVisitor__visitObject__I__Z__I__Lupickle_core_ObjVisitor(this, length, jsonableKeys, index);
});
$p.cZ = (function(length, index) {
  return $f_Lupickle_core_SimpleVisitor__visitArray__I__I__Lupickle_core_ArrVisitor(this, length, index);
});
$p.e7 = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64__D__I__O(this, d, index);
});
$p.eY = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat32__F__I__O(this, d, index);
});
$p.em = (function(i, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt32__I__I__O(this, i, index);
});
$p.eZ = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.fe = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitUInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.fA = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64String__T__I__O(this, s, index);
});
$p.fc = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitChar__C__I__O(this, s, index);
});
$p.fb = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.fd = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.ej = (function() {
  return "expected string";
});
$p.cN = (function(s, index) {
  return $m_s_package$().aVI().aXl($dp_toString__T(s));
});
$p.ha = (function() {
  return this.aKB;
});
var $d_Lupickle_implicits_Readers$$anon$13 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$13, "upickle.implicits.Readers$$anon$13", ({
  Pg: 1,
  x: 1,
  D: 1,
  J: 1,
  K: 1,
  ce: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$14(outer) {
  this.aKC = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aKC = outer;
}
$p = $c_Lupickle_implicits_Readers$$anon$14.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$14;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$14() {
}
$h_Lupickle_implicits_Readers$$anon$14.prototype = $p;
$p.ge = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.gB = (function() {
  return this;
});
$p.c8 = (function(index) {
  return null;
});
$p.eE = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitTrue__I__O(this, index);
});
$p.eC = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitFalse__I__O(this, index);
});
$p.eD = (function(s, decIndex, expIndex, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64StringParts__jl_CharSequence__I__I__I__O(this, s, decIndex, expIndex, index);
});
$p.bQ = (function(length, jsonableKeys, index) {
  return $f_Lupickle_core_SimpleVisitor__visitObject__I__Z__I__Lupickle_core_ObjVisitor(this, length, jsonableKeys, index);
});
$p.cZ = (function(length, index) {
  return $f_Lupickle_core_SimpleVisitor__visitArray__I__I__Lupickle_core_ArrVisitor(this, length, index);
});
$p.e7 = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64__D__I__O(this, d, index);
});
$p.eY = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat32__F__I__O(this, d, index);
});
$p.em = (function(i, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt32__I__I__O(this, i, index);
});
$p.eZ = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.fe = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitUInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.fA = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64String__T__I__O(this, s, index);
});
$p.fc = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitChar__C__I__O(this, s, index);
});
$p.fb = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.fd = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.ej = (function() {
  return "expected string";
});
$p.cN = (function(s, index) {
  return $m_s_package$().oz().b0R($dp_toString__T(s));
});
$p.ha = (function() {
  return this.aKC;
});
var $d_Lupickle_implicits_Readers$$anon$14 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$14, "upickle.implicits.Readers$$anon$14", ({
  Ph: 1,
  x: 1,
  D: 1,
  J: 1,
  K: 1,
  ce: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$15(outer) {
  this.aKD = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aKD = outer;
}
$p = $c_Lupickle_implicits_Readers$$anon$15.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$15;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$15() {
}
$h_Lupickle_implicits_Readers$$anon$15.prototype = $p;
$p.ge = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.gB = (function() {
  return this;
});
$p.c8 = (function(index) {
  return null;
});
$p.eE = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitTrue__I__O(this, index);
});
$p.eC = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitFalse__I__O(this, index);
});
$p.eD = (function(s, decIndex, expIndex, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64StringParts__jl_CharSequence__I__I__I__O(this, s, decIndex, expIndex, index);
});
$p.bQ = (function(length, jsonableKeys, index) {
  return $f_Lupickle_core_SimpleVisitor__visitObject__I__Z__I__Lupickle_core_ObjVisitor(this, length, jsonableKeys, index);
});
$p.cZ = (function(length, index) {
  return $f_Lupickle_core_SimpleVisitor__visitArray__I__I__Lupickle_core_ArrVisitor(this, length, index);
});
$p.e7 = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64__D__I__O(this, d, index);
});
$p.eY = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat32__F__I__O(this, d, index);
});
$p.em = (function(i, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt32__I__I__O(this, i, index);
});
$p.eZ = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.fe = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitUInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.fA = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64String__T__I__O(this, s, index);
});
$p.fc = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitChar__C__I__O(this, s, index);
});
$p.fb = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.fd = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.ej = (function() {
  return "expected string";
});
$p.cN = (function(s, index) {
  return $c_s_JSUniquenessCache.prototype.aeK.call($m_s_Symbol$(), $dp_toString__T(s));
});
$p.ha = (function() {
  return this.aKD;
});
var $d_Lupickle_implicits_Readers$$anon$15 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$15, "upickle.implicits.Readers$$anon$15", ({
  Pi: 1,
  x: 1,
  D: 1,
  J: 1,
  K: 1,
  ce: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$16(outer) {
  this.aKE = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aKE = outer;
}
$p = $c_Lupickle_implicits_Readers$$anon$16.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$16;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$16() {
}
$h_Lupickle_implicits_Readers$$anon$16.prototype = $p;
$p.ge = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.gB = (function() {
  return this;
});
$p.c8 = (function(index) {
  return null;
});
$p.eE = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitTrue__I__O(this, index);
});
$p.eC = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitFalse__I__O(this, index);
});
$p.eD = (function(s, decIndex, expIndex, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64StringParts__jl_CharSequence__I__I__I__O(this, s, decIndex, expIndex, index);
});
$p.bQ = (function(length, jsonableKeys, index) {
  return $f_Lupickle_core_SimpleVisitor__visitObject__I__Z__I__Lupickle_core_ObjVisitor(this, length, jsonableKeys, index);
});
$p.cZ = (function(length, index) {
  return $f_Lupickle_core_SimpleVisitor__visitArray__I__I__Lupickle_core_ArrVisitor(this, length, index);
});
$p.e7 = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64__D__I__O(this, d, index);
});
$p.eY = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat32__F__I__O(this, d, index);
});
$p.em = (function(i, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt32__I__I__O(this, i, index);
});
$p.eZ = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.fe = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitUInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.fA = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64String__T__I__O(this, s, index);
});
$p.fc = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitChar__C__I__O(this, s, index);
});
$p.fb = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.fd = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.ej = (function() {
  return "expected string";
});
$p.cN = (function(s, index) {
  return this.b7e(s);
});
$p.b7e = (function(s) {
  if ((((($dp_charAt__I__C(s, 0) === 105) && ($dp_charAt__I__C(s, 1) === 110)) && ($dp_charAt__I__C(s, 2) === 102)) && ($dp_length__I(s) === 3))) {
    return $m_s_concurrent_duration_Duration$().add;
  } else if (((((($dp_charAt__I__C(s, 0) === 45) && ($dp_charAt__I__C(s, 1) === 105)) && ($dp_charAt__I__C(s, 2) === 110)) && ($dp_charAt__I__C(s, 3) === 102)) && ($dp_length__I(s) === 4))) {
    return $m_s_concurrent_duration_Duration$().ade;
  } else if ((((((($dp_charAt__I__C(s, 0) === 117) && ($dp_charAt__I__C(s, 1) === 110)) && ($dp_charAt__I__C(s, 2) === 100)) && ($dp_charAt__I__C(s, 3) === 101)) && ($dp_charAt__I__C(s, 4) === 102)) && ($dp_length__I(s) === 5))) {
    return $m_s_concurrent_duration_Duration$().a1T;
  } else {
    $m_s_concurrent_duration_Duration$();
    var $x_1 = $m_Lupickle_core_ParseUtils$().b6u(s, 0, $dp_length__I(s));
    return new $c_s_concurrent_duration_FiniteDuration($x_1.l, $x_1.h, $m_ju_concurrent_TimeUnit$().Zx);
  }
});
$p.ha = (function() {
  return this.aKE;
});
var $d_Lupickle_implicits_Readers$$anon$16 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$16, "upickle.implicits.Readers$$anon$16", ({
  Pj: 1,
  x: 1,
  D: 1,
  J: 1,
  K: 1,
  ce: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$19(inner$2, outer) {
  this.aKG = null;
  this.aKF = null;
  this.aKG = inner$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aKF = outer;
}
$p = $c_Lupickle_implicits_Readers$$anon$19.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$19;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$19() {
}
$h_Lupickle_implicits_Readers$$anon$19.prototype = $p;
$p.ge = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.gB = (function() {
  return this;
});
$p.c8 = (function(index) {
  return null;
});
$p.eE = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitTrue__I__O(this, index);
});
$p.eC = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitFalse__I__O(this, index);
});
$p.cN = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitString__jl_CharSequence__I__O(this, s, index);
});
$p.eD = (function(s, decIndex, expIndex, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64StringParts__jl_CharSequence__I__I__I__O(this, s, decIndex, expIndex, index);
});
$p.bQ = (function(length, jsonableKeys, index) {
  return $f_Lupickle_core_SimpleVisitor__visitObject__I__Z__I__Lupickle_core_ObjVisitor(this, length, jsonableKeys, index);
});
$p.e7 = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64__D__I__O(this, d, index);
});
$p.eY = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat32__F__I__O(this, d, index);
});
$p.em = (function(i, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt32__I__I__O(this, i, index);
});
$p.eZ = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.fe = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitUInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.fA = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64String__T__I__O(this, s, index);
});
$p.fc = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitChar__C__I__O(this, s, index);
});
$p.fb = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.fd = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.ej = (function() {
  return "expected sequence";
});
$p.cZ = (function(length, index) {
  return new $c_Lupickle_implicits_Readers$$anon$19$$anon$20(this);
});
$p.ha = (function() {
  return this.aKF;
});
var $d_Lupickle_implicits_Readers$$anon$19 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$19, "upickle.implicits.Readers$$anon$19", ({
  Pm: 1,
  x: 1,
  D: 1,
  J: 1,
  K: 1,
  cY: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$21(evidence$1$5, outer) {
  this.iH = null;
  this.adR = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_Lupickle_core_Types$Reader$Delegate__Lupickle_core_Types$Reader$__Lupickle_core_Visitor__(this, outer.OP(), $s_Lupickle_implicits_Readers__upickle$implicits$Readers$$_$$anon$superArg$1$1__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader(evidence$1$5));
}
$p = $c_Lupickle_implicits_Readers$$anon$21.prototype = new $h_Lupickle_core_Types$Reader$Delegate();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$21;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$21() {
}
$h_Lupickle_implicits_Readers$$anon$21.prototype = $p;
$p.c8 = (function(index) {
  return $m_s_None$();
});
var $d_Lupickle_implicits_Readers$$anon$21 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$21, "upickle.implicits.Readers$$anon$21", ({
  Pp: 1,
  np: 1,
  bJ: 1,
  x: 1,
  D: 1,
  cY: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$4(outer) {
  this.aKK = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aKK = outer;
}
$p = $c_Lupickle_implicits_Readers$$anon$4.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$4;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$4() {
}
$h_Lupickle_implicits_Readers$$anon$4.prototype = $p;
$p.ge = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.gB = (function() {
  return this;
});
$p.c8 = (function(index) {
  return null;
});
$p.eE = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitTrue__I__O(this, index);
});
$p.eC = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitFalse__I__O(this, index);
});
$p.bQ = (function(length, jsonableKeys, index) {
  return $f_Lupickle_core_SimpleVisitor__visitObject__I__Z__I__Lupickle_core_ObjVisitor(this, length, jsonableKeys, index);
});
$p.cZ = (function(length, index) {
  return $f_Lupickle_core_SimpleVisitor__visitArray__I__I__Lupickle_core_ArrVisitor(this, length, index);
});
$p.fc = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitChar__C__I__O(this, s, index);
});
$p.fb = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.fd = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.fA = (function(s, index) {
  return $f_Lupickle_implicits_Readers$NumericReader__visitFloat64String__T__I__O(this, s, index);
});
$p.ej = (function() {
  return "expected number";
});
$p.bbF = (function(s, decIndex, expIndex, index) {
  return $m_jl_Double$().bd($dp_toString__T(s));
});
$p.ha = (function() {
  return this.aKK;
});
$p.cN = (function(s, index) {
  return (+$f_Lupickle_implicits_Readers$NumericReader__visitFloat64String__T__I__O(this, $dp_toString__T(s), index));
});
$p.em = (function(i, index) {
  return i;
});
$p.eZ = (function(i_$_lo, i_$_hi, index) {
  return ((4.294967296E9 * i_$_hi) + (i_$_lo >>> 0.0));
});
$p.fe = (function(i_$_lo, i_$_hi, index) {
  return ((4.294967296E9 * i_$_hi) + (i_$_lo >>> 0.0));
});
$p.eY = (function(d, index) {
  return d;
});
$p.e7 = (function(d, index) {
  return d;
});
$p.eD = (function(s, decIndex, expIndex, index) {
  return this.bbF(s, decIndex, expIndex, index);
});
var $d_Lupickle_implicits_Readers$$anon$4 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$4, "upickle.implicits.Readers$$anon$4", ({
  Ps: 1,
  x: 1,
  D: 1,
  J: 1,
  K: 1,
  bu: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$5(outer) {
  this.aKL = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aKL = outer;
}
$p = $c_Lupickle_implicits_Readers$$anon$5.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$5;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$5() {
}
$h_Lupickle_implicits_Readers$$anon$5.prototype = $p;
$p.gB = (function() {
  return this;
});
$p.c8 = (function(index) {
  return null;
});
$p.eE = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitTrue__I__O(this, index);
});
$p.eC = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitFalse__I__O(this, index);
});
$p.bQ = (function(length, jsonableKeys, index) {
  return $f_Lupickle_core_SimpleVisitor__visitObject__I__Z__I__Lupickle_core_ObjVisitor(this, length, jsonableKeys, index);
});
$p.cZ = (function(length, index) {
  return $f_Lupickle_core_SimpleVisitor__visitArray__I__I__Lupickle_core_ArrVisitor(this, length, index);
});
$p.fc = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitChar__C__I__O(this, s, index);
});
$p.fb = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.fd = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.fA = (function(s, index) {
  return $f_Lupickle_implicits_Readers$NumericReader__visitFloat64String__T__I__O(this, s, index);
});
$p.ej = (function() {
  return "expected number";
});
$p.bbH = (function(s, decIndex, expIndex, index) {
  var $x_1 = $m_Lupickle_core_ParseUtils$().PI(s, decIndex, expIndex, index);
  return $s_RTLong__toInt__I__I__I($x_1.l, $x_1.h);
});
$p.bbB = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  var $x_1 = $m_Lupickle_core_CharUtils$().XG(s, arrOffset, arrLength, decIndex, expIndex);
  return $s_RTLong__toInt__I__I__I($x_1.l, $x_1.h);
});
$p.ha = (function() {
  return this.aKL;
});
$p.cN = (function(s, index) {
  return ($f_Lupickle_implicits_Readers$NumericReader__visitFloat64String__T__I__O(this, $dp_toString__T(s), index) | 0);
});
$p.em = (function(i, index) {
  return i;
});
$p.eZ = (function(i_$_lo, i_$_hi, index) {
  return i_$_lo;
});
$p.fe = (function(i_$_lo, i_$_hi, index) {
  return i_$_lo;
});
$p.eY = (function(d, index) {
  return $doubleToInt(d);
});
$p.e7 = (function(d, index) {
  return $doubleToInt(d);
});
$p.eD = (function(s, decIndex, expIndex, index) {
  return this.bbH(s, decIndex, expIndex, index);
});
$p.ge = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return this.bbB(s, arrOffset, arrLength, decIndex, expIndex, index);
});
var $d_Lupickle_implicits_Readers$$anon$5 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$5, "upickle.implicits.Readers$$anon$5", ({
  Pt: 1,
  x: 1,
  D: 1,
  J: 1,
  K: 1,
  bu: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$6(outer) {
  this.aKM = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aKM = outer;
}
$p = $c_Lupickle_implicits_Readers$$anon$6.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$6;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$6() {
}
$h_Lupickle_implicits_Readers$$anon$6.prototype = $p;
$p.ge = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.gB = (function() {
  return this;
});
$p.c8 = (function(index) {
  return null;
});
$p.eE = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitTrue__I__O(this, index);
});
$p.eC = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitFalse__I__O(this, index);
});
$p.bQ = (function(length, jsonableKeys, index) {
  return $f_Lupickle_core_SimpleVisitor__visitObject__I__Z__I__Lupickle_core_ObjVisitor(this, length, jsonableKeys, index);
});
$p.cZ = (function(length, index) {
  return $f_Lupickle_core_SimpleVisitor__visitArray__I__I__Lupickle_core_ArrVisitor(this, length, index);
});
$p.fc = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitChar__C__I__O(this, s, index);
});
$p.fb = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.fd = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.fA = (function(s, index) {
  return $f_Lupickle_implicits_Readers$NumericReader__visitFloat64String__T__I__O(this, s, index);
});
$p.ej = (function() {
  return "expected number";
});
$p.bbG = (function(s, decIndex, expIndex, index) {
  return $m_jl_Float$().a4m($dp_toString__T(s));
});
$p.ha = (function() {
  return this.aKM;
});
$p.cN = (function(s, index) {
  return Math.fround($f_Lupickle_implicits_Readers$NumericReader__visitFloat64String__T__I__O(this, $dp_toString__T(s), index));
});
$p.em = (function(i, index) {
  return Math.fround(i);
});
$p.eZ = (function(i_$_lo, i_$_hi, index) {
  var compressedLo = (((((-2097152) & (i_$_hi ^ (i_$_hi >> 10))) === 0) || ((65535 & i_$_lo) === 0)) ? i_$_lo : (32768 | ((-32768) & i_$_lo)));
  return Math.fround(((4.294967296E9 * i_$_hi) + (compressedLo >>> 0.0)));
});
$p.fe = (function(i_$_lo, i_$_hi, index) {
  var compressedLo = (((((-2097152) & (i_$_hi ^ (i_$_hi >> 10))) === 0) || ((65535 & i_$_lo) === 0)) ? i_$_lo : (32768 | ((-32768) & i_$_lo)));
  return Math.fround(((4.294967296E9 * i_$_hi) + (compressedLo >>> 0.0)));
});
$p.eY = (function(d, index) {
  return d;
});
$p.e7 = (function(d, index) {
  return Math.fround(d);
});
$p.eD = (function(s, decIndex, expIndex, index) {
  return this.bbG(s, decIndex, expIndex, index);
});
var $d_Lupickle_implicits_Readers$$anon$6 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$6, "upickle.implicits.Readers$$anon$6", ({
  Pu: 1,
  x: 1,
  D: 1,
  J: 1,
  K: 1,
  bu: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$7(outer) {
  this.aKN = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aKN = outer;
}
$p = $c_Lupickle_implicits_Readers$$anon$7.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$7;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$7() {
}
$h_Lupickle_implicits_Readers$$anon$7.prototype = $p;
$p.gB = (function() {
  return this;
});
$p.c8 = (function(index) {
  return null;
});
$p.eE = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitTrue__I__O(this, index);
});
$p.eC = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitFalse__I__O(this, index);
});
$p.bQ = (function(length, jsonableKeys, index) {
  return $f_Lupickle_core_SimpleVisitor__visitObject__I__Z__I__Lupickle_core_ObjVisitor(this, length, jsonableKeys, index);
});
$p.cZ = (function(length, index) {
  return $f_Lupickle_core_SimpleVisitor__visitArray__I__I__Lupickle_core_ArrVisitor(this, length, index);
});
$p.fc = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitChar__C__I__O(this, s, index);
});
$p.fb = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.fd = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.fA = (function(s, index) {
  return $f_Lupickle_implicits_Readers$NumericReader__visitFloat64String__T__I__O(this, s, index);
});
$p.ej = (function() {
  return "expected number";
});
$p.bbI = (function(s, decIndex, expIndex, index) {
  var $x_1 = $m_Lupickle_core_ParseUtils$().PI(s, decIndex, expIndex, index);
  return (($s_RTLong__toInt__I__I__I($x_1.l, $x_1.h) << 16) >> 16);
});
$p.bbC = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  var $x_1 = $m_Lupickle_core_CharUtils$().XG(s, arrOffset, arrLength, decIndex, expIndex);
  return (($s_RTLong__toInt__I__I__I($x_1.l, $x_1.h) << 16) >> 16);
});
$p.ha = (function() {
  return this.aKN;
});
$p.cN = (function(s, index) {
  return ($f_Lupickle_implicits_Readers$NumericReader__visitFloat64String__T__I__O(this, $dp_toString__T(s), index) | 0);
});
$p.em = (function(i, index) {
  return ((i << 16) >> 16);
});
$p.eZ = (function(i_$_lo, i_$_hi, index) {
  return ((i_$_lo << 16) >> 16);
});
$p.fe = (function(i_$_lo, i_$_hi, index) {
  return ((i_$_lo << 16) >> 16);
});
$p.eY = (function(d, index) {
  return (($doubleToInt(d) << 16) >> 16);
});
$p.e7 = (function(d, index) {
  return (($doubleToInt(d) << 16) >> 16);
});
$p.eD = (function(s, decIndex, expIndex, index) {
  return this.bbI(s, decIndex, expIndex, index);
});
$p.ge = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return this.bbC(s, arrOffset, arrLength, decIndex, expIndex, index);
});
var $d_Lupickle_implicits_Readers$$anon$7 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$7, "upickle.implicits.Readers$$anon$7", ({
  Pv: 1,
  x: 1,
  D: 1,
  J: 1,
  K: 1,
  bu: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$8(outer) {
  this.aKO = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aKO = outer;
}
$p = $c_Lupickle_implicits_Readers$$anon$8.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$8;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$8() {
}
$h_Lupickle_implicits_Readers$$anon$8.prototype = $p;
$p.gB = (function() {
  return this;
});
$p.c8 = (function(index) {
  return null;
});
$p.eE = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitTrue__I__O(this, index);
});
$p.eC = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitFalse__I__O(this, index);
});
$p.bQ = (function(length, jsonableKeys, index) {
  return $f_Lupickle_core_SimpleVisitor__visitObject__I__Z__I__Lupickle_core_ObjVisitor(this, length, jsonableKeys, index);
});
$p.cZ = (function(length, index) {
  return $f_Lupickle_core_SimpleVisitor__visitArray__I__I__Lupickle_core_ArrVisitor(this, length, index);
});
$p.fc = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitChar__C__I__O(this, s, index);
});
$p.fb = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.fd = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.fA = (function(s, index) {
  return $f_Lupickle_implicits_Readers$NumericReader__visitFloat64String__T__I__O(this, s, index);
});
$p.ej = (function() {
  return "expected number";
});
$p.bbD = (function(s, decIndex, expIndex, index) {
  var $x_1 = $m_Lupickle_core_ParseUtils$().PI(s, decIndex, expIndex, index);
  return (($s_RTLong__toInt__I__I__I($x_1.l, $x_1.h) << 24) >> 24);
});
$p.bbA = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  var $x_1 = $m_Lupickle_core_CharUtils$().XG(s, arrOffset, arrLength, decIndex, expIndex);
  return (($s_RTLong__toInt__I__I__I($x_1.l, $x_1.h) << 24) >> 24);
});
$p.ha = (function() {
  return this.aKO;
});
$p.cN = (function(s, index) {
  return ($f_Lupickle_implicits_Readers$NumericReader__visitFloat64String__T__I__O(this, $dp_toString__T(s), index) | 0);
});
$p.em = (function(i, index) {
  return ((i << 24) >> 24);
});
$p.eZ = (function(i_$_lo, i_$_hi, index) {
  return ((i_$_lo << 24) >> 24);
});
$p.fe = (function(i_$_lo, i_$_hi, index) {
  return ((i_$_lo << 24) >> 24);
});
$p.eY = (function(d, index) {
  return (($doubleToInt(d) << 24) >> 24);
});
$p.e7 = (function(d, index) {
  return (($doubleToInt(d) << 24) >> 24);
});
$p.eD = (function(s, decIndex, expIndex, index) {
  return this.bbD(s, decIndex, expIndex, index);
});
$p.ge = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return this.bbA(s, arrOffset, arrLength, decIndex, expIndex, index);
});
var $d_Lupickle_implicits_Readers$$anon$8 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$8, "upickle.implicits.Readers$$anon$8", ({
  Pw: 1,
  x: 1,
  D: 1,
  J: 1,
  K: 1,
  bu: 1
}));
/** @constructor */
function $c_Lupickle_implicits_ReadersVersionSpecific$$anon$1(outer) {
  this.Ac = 0;
  this.xT = 0;
  this.xU = 0;
  this.aKY = null;
  this.aKW = null;
  this.aKX = null;
  this.aec = false;
  this.aKV = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aKV = outer;
  $ct_Lupickle_implicits_CaseObjectContext__I__(this, outer.gQ);
  $f_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2$ObjectContext__$init$__V(this);
}
$p = $c_Lupickle_implicits_ReadersVersionSpecific$$anon$1.prototype = new $h_Lupickle_implicits_CaseObjectContext();
$p.constructor = $c_Lupickle_implicits_ReadersVersionSpecific$$anon$1;
/** @constructor */
function $h_Lupickle_implicits_ReadersVersionSpecific$$anon$1() {
}
$h_Lupickle_implicits_ReadersVersionSpecific$$anon$1.prototype = $p;
$p.aiv = (function() {
  return this.aKY;
});
$p.ait = (function() {
  return this.aKW;
});
$p.a5c = (function() {
  return this.aKX;
});
$p.aSs = (function() {
  return this.aec;
});
$p.aiu = (function(x$1) {
  this.aKX = x$1;
});
$p.a4L = (function(x$1) {
  this.aec = x$1;
});
$p.aTe = (function(x$0) {
  this.aKY = x$0;
});
$p.aTd = (function(x$0) {
  this.aKW = x$0;
});
$p.d9 = (function() {
  return $f_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2$ObjectContext__subVisitor__Lupickle_core_Visitor(this);
});
$p.jz = (function(v) {
  $f_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2$ObjectContext__visitKeyValue__O__V(this, v);
});
$p.bV = (function(index) {
  return $f_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2$ObjectContext__visitEnd__I__O(this, index);
});
$p.cU = (function(v, index) {
  if ((this.Ac !== (-1))) {
    var x_$_lo = this.xT;
    var x_$_hi = this.xU;
    var n = this.Ac;
    var lo = (((32 & n) === 0) ? (1 << n) : 0);
    var hi = (((32 & n) === 0) ? 0 : (1 << n));
    var $x_1 = (((x_$_lo & lo) | (x_$_hi & hi)) === 0);
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    $f_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2$ObjectContext__storeAggregatedValue__I__O__V(this, this.Ac, v);
    var x$1_$_lo = this.xT;
    var x$1_$_hi = this.xU;
    var n$1 = this.Ac;
    var lo$2 = (((32 & n$1) === 0) ? (1 << n$1) : 0);
    var hi$2 = (((32 & n$1) === 0) ? 0 : (1 << n$1));
    var lo$3 = (x$1_$_lo | lo$2);
    var hi$3 = (x$1_$_hi | hi$2);
    this.xT = lo$3;
    this.xU = hi$3;
  } else if (this.aec) {
    $f_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2$ObjectContext__storeAggregatedValue__I__O__V(this, this.Ac, v);
  }
});
$p.pJ = (function() {
  return this.aKV;
});
var $d_Lupickle_implicits_ReadersVersionSpecific$$anon$1 = new $TypeData().i($c_Lupickle_implicits_ReadersVersionSpecific$$anon$1, "upickle.implicits.ReadersVersionSpecific$$anon$1", ({
  PB: 1,
  P3: 1,
  ab: 1,
  aO: 1,
  nr: 1,
  nt: 1
}));
/** @constructor */
function $c_Lupickle_implicits_ReadersVersionSpecific$$anon$2(outer) {
  this.vO = 0;
  this.Dt = null;
  this.aL2 = null;
  this.aL0 = null;
  this.aL1 = null;
  this.aed = false;
  this.aKZ = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aKZ = outer;
  $ct_Lupickle_implicits_HugeCaseObjectContext__I__(this, outer.gQ);
  $f_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2$ObjectContext__$init$__V(this);
}
$p = $c_Lupickle_implicits_ReadersVersionSpecific$$anon$2.prototype = new $h_Lupickle_implicits_HugeCaseObjectContext();
$p.constructor = $c_Lupickle_implicits_ReadersVersionSpecific$$anon$2;
/** @constructor */
function $h_Lupickle_implicits_ReadersVersionSpecific$$anon$2() {
}
$h_Lupickle_implicits_ReadersVersionSpecific$$anon$2.prototype = $p;
$p.aiv = (function() {
  return this.aL2;
});
$p.ait = (function() {
  return this.aL0;
});
$p.a5c = (function() {
  return this.aL1;
});
$p.aSs = (function() {
  return this.aed;
});
$p.aiu = (function(x$1) {
  this.aL1 = x$1;
});
$p.a4L = (function(x$1) {
  this.aed = x$1;
});
$p.aTe = (function(x$0) {
  this.aL2 = x$0;
});
$p.aTd = (function(x$0) {
  this.aL0 = x$0;
});
$p.d9 = (function() {
  return $f_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2$ObjectContext__subVisitor__Lupickle_core_Visitor(this);
});
$p.jz = (function(v) {
  $f_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2$ObjectContext__visitKeyValue__O__V(this, v);
});
$p.bV = (function(index) {
  return $f_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2$ObjectContext__visitEnd__I__O(this, index);
});
$p.cU = (function(v, index) {
  if ((this.vO !== (-1))) {
    var $x_2 = this.Dt;
    var num = this.vO;
    var $x_3 = $x_2.a;
    var $x_4 = ((((num + (((num >> 5) >>> 26) | 0)) | 0) >> 6) << 1);
    var x_$_lo = $x_3[$x_4];
    var x_$_hi = $x_3[(($x_4 + 1) | 0)];
    var n = this.vO;
    var lo = (((32 & n) === 0) ? (1 << n) : 0);
    var hi = (((32 & n) === 0) ? 0 : (1 << n));
    var $x_1 = (((x_$_lo & lo) | (x_$_hi & hi)) === 0);
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    $f_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2$ObjectContext__storeAggregatedValue__I__O__V(this, this.vO, v);
    var \u03b42$ = this.Dt;
    var num$1 = this.vO;
    var i$1 = (((num$1 + (((num$1 >> 5) >>> 26) | 0)) | 0) >> 6);
    var $x_5 = \u03b42$.a;
    var $x_6 = (i$1 << 1);
    var x$1_$_lo = $x_5[$x_6];
    var x$1_$_hi = $x_5[(($x_6 + 1) | 0)];
    var n$1 = this.vO;
    var lo$2 = (((32 & n$1) === 0) ? (1 << n$1) : 0);
    var hi$2 = (((32 & n$1) === 0) ? 0 : (1 << n$1));
    var lo$3 = (x$1_$_lo | lo$2);
    var hi$3 = (x$1_$_hi | hi$2);
    var $x_7 = \u03b42$.a;
    var $x_8 = (i$1 << 1);
    $x_7[$x_8] = lo$3;
    $x_7[(($x_8 + 1) | 0)] = hi$3;
  } else if (this.aed) {
    $f_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2$ObjectContext__storeAggregatedValue__I__O__V(this, this.vO, v);
  }
});
$p.pJ = (function() {
  return this.aKZ;
});
var $d_Lupickle_implicits_ReadersVersionSpecific$$anon$2 = new $TypeData().i($c_Lupickle_implicits_ReadersVersionSpecific$$anon$2, "upickle.implicits.ReadersVersionSpecific$$anon$2", ({
  PC: 1,
  P5: 1,
  ab: 1,
  aO: 1,
  nr: 1,
  nt: 1
}));
function $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__($thiz, outer, paramCount, missingKeyCount_$_lo, missingKeyCount_$_hi, allowUnknownKeys, construct) {
  $thiz.gQ = paramCount;
  $thiz.iO = missingKeyCount_$_lo;
  $thiz.iP = missingKeyCount_$_hi;
  $thiz.iM = allowUnknownKeys;
  $thiz.iN = construct;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $thiz.jh = outer;
  $ct_Lupickle_implicits_CaseClassReadWriters$CaseClassReader__Lupickle_implicits_CaseClassReadWriters__($thiz, outer);
  return $thiz;
}
function $p_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2__$1$__T2($thiz) {
  if ((!$thiz.iJ)) {
    matchResult1$1: {
      var $x_1;
      var x1 = $thiz.k3();
      if ((x1 !== null)) {
        var $x_1 = new $c_T2(x1.g(), x1.h());
        break matchResult1$1;
      }
      throw new $c_s_MatchError(x1);
    }
    $thiz.iI = $x_1;
    $thiz.iJ = true;
  }
  return $thiz.iI;
}
/** @constructor */
function $c_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2() {
  this.ic = null;
  this.gQ = 0;
  this.iO = 0;
  this.iP = 0;
  this.iM = false;
  this.iN = null;
  this.iI = null;
  this.iJ = false;
  this.iK = false;
  this.iL = false;
  this.jh = null;
}
$p = $c_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2.prototype = new $h_Lupickle_implicits_CaseClassReadWriters$CaseClassReader();
$p.constructor = $c_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2;
/** @constructor */
function $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2() {
}
$h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2.prototype = $p;
$p.aP4 = (function() {
  if ((!this.iL)) {
    this.iK = ($p_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2__$1$__T2(this).g() !== null);
    this.iL = true;
  }
  return this.iK;
});
$p.bQ = (function(length, jsonableKeys, index) {
  return ((this.gQ <= 64) ? new $c_Lupickle_implicits_ReadersVersionSpecific$$anon$1(this) : new $c_Lupickle_implicits_ReadersVersionSpecific$$anon$2(this));
});
/** @constructor */
function $c_Lbuildinfo_BuildInfo$() {
  this.a5n = null;
  this.Qg = null;
  this.Qf = null;
  this.Yj = null;
  this.Qe = null;
  this.aei = 0;
  this.aej = 0;
  this.aiF = null;
  $n_Lbuildinfo_BuildInfo$ = this;
  this.a5n = "viewer";
  this.Qg = "0.9.5+12-fd5aabe7";
  this.Qf = "3.7.1";
  this.Yj = "2.0.6";
  this.Qe = "2026-09-28 18:23:40.948+0000";
  this.aei = (-381541484);
  this.aej = 416;
  this.aiF = $m_sc_StringOps$().u0("name: %s, version: %s, scalaVersion: %s, sbtVersion: %s, builtAtString: %s, builtAtMillis: %s", $m_sr_ScalaRunTime$().hP(new $ac_O([this.a5n, this.Qg, this.Qf, this.Yj, this.Qe, $bL(this.aei, this.aej)])));
  $m_sci_Map$().ao($m_sr_ScalaRunTime$().f(new ($d_T2.r().C)([new $c_T2("name", this.a5n), new $c_T2("version", this.Qg), new $c_T2("scalaVersion", this.Qf), new $c_T2("sbtVersion", this.Yj), new $c_T2("builtAtString", this.Qe), new $c_T2("builtAtMillis", $bL(this.aei, this.aej))])));
}
$p = $c_Lbuildinfo_BuildInfo$.prototype = new $h_O();
$p.constructor = $c_Lbuildinfo_BuildInfo$;
/** @constructor */
function $h_Lbuildinfo_BuildInfo$() {
}
$h_Lbuildinfo_BuildInfo$.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return 602658844;
});
$p.z = (function() {
  return 0;
});
$p.B = (function() {
  return "BuildInfo";
});
$p.A = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.m = (function() {
  return this.aiF;
});
var $d_Lbuildinfo_BuildInfo$ = new $TypeData().i($c_Lbuildinfo_BuildInfo$, "buildinfo.BuildInfo$", ({
  ny: 1,
  b: 1,
  c: 1,
  a: 1,
  d: 1,
  j: 1,
  r: 1
}));
var $n_Lbuildinfo_BuildInfo$;
function $m_Lbuildinfo_BuildInfo$() {
  if ((!$n_Lbuildinfo_BuildInfo$)) {
    $n_Lbuildinfo_BuildInfo$ = new $c_Lbuildinfo_BuildInfo$();
  }
  return $n_Lbuildinfo_BuildInfo$;
}
function $ct_Ljava_io_PrintStream__Ljava_io_OutputStream__Z__Ljava_nio_charset_Charset__($thiz, _out, autoFlush, charset) {
  $ct_Ljava_io_FilterOutputStream__Ljava_io_OutputStream__($thiz, _out);
  return $thiz;
}
/** @constructor */
function $c_Ljava_io_PrintStream() {
}
$p = $c_Ljava_io_PrintStream.prototype = new $h_Ljava_io_FilterOutputStream();
$p.constructor = $c_Ljava_io_PrintStream;
/** @constructor */
function $h_Ljava_io_PrintStream() {
}
$h_Ljava_io_PrintStream.prototype = $p;
$p.Jg = (function(s) {
  this.aR8(s);
  this.a3V("\n");
});
$p.aWY = (function(csq) {
  this.aR8(((csq === null) ? "null" : $dp_toString__T(csq)));
  return this;
});
$p.W9 = (function(csq) {
  return this.aWY(csq);
});
/** @constructor */
function $c_Ljava_nio_HeapCharBuffer(_capacity, _array0, _arrayOffset0, _initialPosition, _initialLimit, _readOnly) {
  this.nK = 0;
  this.c2 = 0;
  this.b3 = 0;
  this.ur = 0;
  this.lx = null;
  this.nM = 0;
  this.Zj = false;
  this.Zj = _readOnly;
  $ct_Ljava_nio_CharBuffer__I__AC__I__(this, _capacity, _array0, _arrayOffset0);
  $c_Ljava_nio_Buffer.prototype.cX.call(this, _initialPosition);
  $c_Ljava_nio_Buffer.prototype.agT.call(this, _initialLimit);
}
$p = $c_Ljava_nio_HeapCharBuffer.prototype = new $h_Ljava_nio_CharBuffer();
$p.constructor = $c_Ljava_nio_HeapCharBuffer;
/** @constructor */
function $h_Ljava_nio_HeapCharBuffer() {
}
$h_Ljava_nio_HeapCharBuffer.prototype = $p;
$p.E6 = (function() {
  return this.Zj;
});
$p.aia = (function(start, end) {
  var length = ((this.c2 - this.b3) | 0);
  if (((((start | ((end - start) | 0)) | end) | ((length - end) | 0)) < 0)) {
    $m_jl_BoundsChecks$().aPv(start, end, length);
  }
  return new $c_Ljava_nio_HeapCharBuffer(this.nK, this.lx, this.nM, ((this.b3 + start) | 0), ((this.b3 + end) | 0), this.Zj);
});
$p.agc = (function() {
  var p = this.b3;
  if ((p === this.c2)) {
    throw new $c_Ljava_nio_BufferUnderflowException();
  }
  this.b3 = ((1 + p) | 0);
  var a = this.lx;
  var i = ((this.nM + p) | 0);
  return a.a[i];
});
$p.XO = (function(c) {
  if (this.Zj) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var p = this.b3;
  if ((p === this.c2)) {
    throw new $c_Ljava_nio_BufferOverflowException();
  }
  this.b3 = ((1 + p) | 0);
  var a = this.lx;
  var i = ((this.nM + p) | 0);
  a.a[i] = c;
  return this;
});
$p.aOK = (function(index) {
  var length = this.c2;
  if (((index >>> 0) >= (length >>> 0))) {
    $m_jl_BoundsChecks$().aPu(index, length);
  }
  var a = this.lx;
  var i = ((this.nM + index) | 0);
  return a.a[i];
});
$p.aOM = (function(dst, offset, length) {
  var length$1 = dst.a.length;
  var endOffset = ((offset + length) | 0);
  if (((((offset | length) | endOffset) | ((length$1 - endOffset) | 0)) < 0)) {
    $m_jl_BoundsChecks$().r5(offset, length, length$1);
  }
  var p = this.b3;
  var newPos = ((p + length) | 0);
  if ((newPos > this.c2)) {
    throw new $c_Ljava_nio_BufferUnderflowException();
  }
  this.b3 = newPos;
  var x0 = this.lx;
  var x1 = ((this.nM + p) | 0);
  x0.av(x1, dst, offset, length);
  return this;
});
$p.Xt = (function(index) {
  var a = this.lx;
  var i = ((this.nM + index) | 0);
  return a.a[i];
});
$p.aSq = (function(index, elem) {
  var a = this.lx;
  var i = ((this.nM + index) | 0);
  a.a[i] = elem;
});
$p.aSr = (function(startIndex, src, offset, length) {
  var x2 = this.lx;
  var x3 = ((this.nM + startIndex) | 0);
  src.av(offset, x2, x3, length);
});
$p.Jp = (function(start, end) {
  return this.aia(start, end);
});
var $d_Ljava_nio_HeapCharBuffer = new $TypeData().i($c_Ljava_nio_HeapCharBuffer, "java.nio.HeapCharBuffer", ({
  sE: 1,
  de: 1,
  dd: 1,
  Q: 1,
  aX: 1,
  bz: 1,
  eU: 1
}));
/** @constructor */
function $c_Ljava_nio_StringCharBuffer(_capacity, _csq, _csqOffset, _initialPosition, _initialLimit) {
  this.nK = 0;
  this.c2 = 0;
  this.b3 = 0;
  this.ur = 0;
  this.lx = null;
  this.nM = 0;
  this.EM = null;
  this.EN = 0;
  this.EM = _csq;
  this.EN = _csqOffset;
  $ct_Ljava_nio_CharBuffer__I__AC__I__(this, _capacity, null, (-1));
  $c_Ljava_nio_Buffer.prototype.cX.call(this, _initialPosition);
  $c_Ljava_nio_Buffer.prototype.agT.call(this, _initialLimit);
}
$p = $c_Ljava_nio_StringCharBuffer.prototype = new $h_Ljava_nio_CharBuffer();
$p.constructor = $c_Ljava_nio_StringCharBuffer;
/** @constructor */
function $h_Ljava_nio_StringCharBuffer() {
}
$h_Ljava_nio_StringCharBuffer.prototype = $p;
$p.E6 = (function() {
  return true;
});
$p.aia = (function(start, end) {
  var length = ((this.c2 - this.b3) | 0);
  if (((((start | ((end - start) | 0)) | end) | ((length - end) | 0)) < 0)) {
    $m_jl_BoundsChecks$().aPv(start, end, length);
  }
  return new $c_Ljava_nio_StringCharBuffer(this.nK, this.EM, this.EN, ((this.b3 + start) | 0), ((this.b3 + end) | 0));
});
$p.agc = (function() {
  var p = this.b3;
  if ((p === this.c2)) {
    throw new $c_Ljava_nio_BufferUnderflowException();
  }
  this.b3 = ((1 + p) | 0);
  return $dp_charAt__I__C(this.EM, ((this.EN + p) | 0));
});
$p.XO = (function(c) {
  throw new $c_Ljava_nio_ReadOnlyBufferException();
});
$p.aOK = (function(index) {
  var length = this.c2;
  if (((index >>> 0) >= (length >>> 0))) {
    $m_jl_BoundsChecks$().aPu(index, length);
  }
  return $dp_charAt__I__C(this.EM, ((this.EN + index) | 0));
});
$p.aOM = (function(dst, offset, length) {
  var length$1 = dst.a.length;
  var endOffset = ((offset + length) | 0);
  if (((((offset | length) | endOffset) | ((length$1 - endOffset) | 0)) < 0)) {
    $m_jl_BoundsChecks$().r5(offset, length, length$1);
  }
  var p = this.b3;
  var newPos = ((p + length) | 0);
  if ((newPos > this.c2)) {
    throw new $c_Ljava_nio_BufferUnderflowException();
  }
  this.b3 = newPos;
  var selfPos = p;
  var endPos = ((selfPos + length) | 0);
  var arrayIndex = offset;
  while ((selfPos !== endPos)) {
    var i = arrayIndex;
    var index = selfPos;
    var v = $dp_charAt__I__C(this.EM, ((this.EN + index) | 0));
    dst.a[i] = v;
    selfPos = ((1 + selfPos) | 0);
    arrayIndex = ((1 + arrayIndex) | 0);
  }
  return this;
});
$p.m = (function() {
  var offset = this.EN;
  return $dp_toString__T($dp_subSequence__I__I__jl_CharSequence(this.EM, ((this.b3 + offset) | 0), ((this.c2 + offset) | 0)));
});
$p.Xt = (function(index) {
  return $dp_charAt__I__C(this.EM, ((this.EN + index) | 0));
});
$p.aSq = (function(index, elem) {
  throw new $c_Ljava_nio_ReadOnlyBufferException();
});
$p.aSr = (function(startIndex, src, offset, length) {
  throw new $c_Ljava_nio_ReadOnlyBufferException();
});
$p.Jp = (function(start, end) {
  return this.aia(start, end);
});
var $d_Ljava_nio_StringCharBuffer = new $TypeData().i($c_Ljava_nio_StringCharBuffer, "java.nio.StringCharBuffer", ({
  sG: 1,
  de: 1,
  dd: 1,
  Q: 1,
  aX: 1,
  bz: 1,
  eU: 1
}));
/** @constructor */
function $c_ju_Collections$$anon$1() {
}
$p = $c_ju_Collections$$anon$1.prototype = new $h_ju_AbstractSet();
$p.constructor = $c_ju_Collections$$anon$1;
/** @constructor */
function $h_ju_Collections$$anon$1() {
}
$h_ju_Collections$$anon$1.prototype = $p;
$p.aa = (function() {
  return 0;
});
$p.r4 = (function() {
  return $p_ju_Collections$__EMPTY_ITERATOR__ju_Iterator($m_ju_Collections$());
});
var $d_ju_Collections$$anon$1 = new $TypeData().i($c_ju_Collections$$anon$1, "java.util.Collections$$anon$1", ({
  sX: 1,
  dg: 1,
  df: 1,
  bA: 1,
  cl: 1,
  cq: 1,
  a: 1
}));
class $c_ju_DuplicateFormatFlagsException extends $c_ju_IllegalFormatException {
  constructor(f) {
    super();
    this.ati = null;
    this.ati = f;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  e3() {
    return (("Flags = '" + this.ati) + "'");
  }
}
var $d_ju_DuplicateFormatFlagsException = new $TypeData().i($c_ju_DuplicateFormatFlagsException, "java.util.DuplicateFormatFlagsException", ({
  t8: 1,
  aT: 1,
  aE: 1,
  R: 1,
  G: 1,
  y: 1,
  a: 1
}));
class $c_ju_FormatFlagsConversionMismatchException extends $c_ju_IllegalFormatException {
  constructor(f, c) {
    super();
    this.atk = null;
    this.atj = 0;
    this.atk = f;
    this.atj = c;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  e3() {
    return ((("Conversion = " + $cToS(this.atj)) + ", Flags = ") + this.atk);
  }
}
var $d_ju_FormatFlagsConversionMismatchException = new $TypeData().i($c_ju_FormatFlagsConversionMismatchException, "java.util.FormatFlagsConversionMismatchException", ({
  t9: 1,
  aT: 1,
  aE: 1,
  R: 1,
  G: 1,
  y: 1,
  a: 1
}));
class $c_ju_IllegalFormatArgumentIndexException extends $c_ju_IllegalFormatException {
  constructor(msg) {
    super();
    this.ato = null;
    this.ato = msg;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  e3() {
    return this.ato;
  }
}
var $d_ju_IllegalFormatArgumentIndexException = new $TypeData().i($c_ju_IllegalFormatArgumentIndexException, "java.util.IllegalFormatArgumentIndexException", ({
  tj: 1,
  aT: 1,
  aE: 1,
  R: 1,
  G: 1,
  y: 1,
  a: 1
}));
class $c_ju_IllegalFormatCodePointException extends $c_ju_IllegalFormatException {
  constructor(c) {
    super();
    this.atp = 0;
    this.atp = c;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  e3() {
    var i = this.atp;
    return ("Code point = 0x" + (i >>> 0.0).toString(16));
  }
}
var $d_ju_IllegalFormatCodePointException = new $TypeData().i($c_ju_IllegalFormatCodePointException, "java.util.IllegalFormatCodePointException", ({
  tk: 1,
  aT: 1,
  aE: 1,
  R: 1,
  G: 1,
  y: 1,
  a: 1
}));
class $c_ju_IllegalFormatConversionException extends $c_ju_IllegalFormatException {
  constructor(c, arg) {
    super();
    this.atr = 0;
    this.atq = null;
    this.atr = c;
    this.atq = arg;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  e3() {
    return ((("" + $cToS(this.atr)) + " != ") + this.atq.ba.N);
  }
}
var $d_ju_IllegalFormatConversionException = new $TypeData().i($c_ju_IllegalFormatConversionException, "java.util.IllegalFormatConversionException", ({
  tl: 1,
  aT: 1,
  aE: 1,
  R: 1,
  G: 1,
  y: 1,
  a: 1
}));
class $c_ju_IllegalFormatFlagsException extends $c_ju_IllegalFormatException {
  constructor(f) {
    super();
    this.ats = null;
    this.ats = f;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  e3() {
    return (("Flags = '" + this.ats) + "'");
  }
}
var $d_ju_IllegalFormatFlagsException = new $TypeData().i($c_ju_IllegalFormatFlagsException, "java.util.IllegalFormatFlagsException", ({
  tm: 1,
  aT: 1,
  aE: 1,
  R: 1,
  G: 1,
  y: 1,
  a: 1
}));
class $c_ju_IllegalFormatPrecisionException extends $c_ju_IllegalFormatException {
  constructor(p) {
    super();
    this.att = 0;
    this.att = p;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  e3() {
    return ("" + this.att);
  }
}
var $d_ju_IllegalFormatPrecisionException = new $TypeData().i($c_ju_IllegalFormatPrecisionException, "java.util.IllegalFormatPrecisionException", ({
  tn: 1,
  aT: 1,
  aE: 1,
  R: 1,
  G: 1,
  y: 1,
  a: 1
}));
class $c_ju_IllegalFormatWidthException extends $c_ju_IllegalFormatException {
  constructor(w) {
    super();
    this.atu = 0;
    this.atu = w;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  e3() {
    return ("" + this.atu);
  }
}
var $d_ju_IllegalFormatWidthException = new $TypeData().i($c_ju_IllegalFormatWidthException, "java.util.IllegalFormatWidthException", ({
  to: 1,
  aT: 1,
  aE: 1,
  R: 1,
  G: 1,
  y: 1,
  a: 1
}));
function $p_ju_LinkedHashMap__appendToOrderedList__ju_LinkedHashMap$Node__V($thiz, node) {
  var older = $thiz.a7t;
  if ((older !== null)) {
    older.EU = node;
  } else {
    $thiz.a7s = node;
  }
  node.Zw = older;
  node.EU = null;
  $thiz.a7t = node;
}
function $p_ju_LinkedHashMap__removeFromOrderedList__ju_LinkedHashMap$Node__V($thiz, node) {
  var older = node.Zw;
  var younger = node.EU;
  if ((older === null)) {
    $thiz.a7s = younger;
  } else {
    older.EU = younger;
  }
  if ((younger === null)) {
    $thiz.a7t = older;
  } else {
    younger.Zw = older;
  }
}
function $ct_ju_LinkedHashMap__I__F__Z__($thiz, initialCapacity, loadFactor, accessOrder) {
  $thiz.atv = accessOrder;
  $ct_ju_HashMap__I__F__($thiz, initialCapacity, loadFactor);
  return $thiz;
}
function $ct_ju_LinkedHashMap__($thiz) {
  $ct_ju_LinkedHashMap__I__F__Z__($thiz, 16, 0.75, false);
  return $thiz;
}
/** @constructor */
function $c_ju_LinkedHashMap() {
  this.Zs = 0.0;
  this.nN = null;
  this.Zt = 0;
  this.yI = 0;
  this.atv = false;
  this.a7s = null;
  this.a7t = null;
}
$p = $c_ju_LinkedHashMap.prototype = new $h_ju_HashMap();
$p.constructor = $c_ju_LinkedHashMap;
/** @constructor */
function $h_ju_LinkedHashMap() {
}
$h_ju_LinkedHashMap.prototype = $p;
$p.aQt = (function(node) {
  if (this.atv) {
    if ((node.EU !== null)) {
      $p_ju_LinkedHashMap__removeFromOrderedList__ju_LinkedHashMap$Node__V(this, node);
      $p_ju_LinkedHashMap__appendToOrderedList__ju_LinkedHashMap$Node__V(this, node);
    }
  }
});
$p.b55 = (function(node) {
  $p_ju_LinkedHashMap__appendToOrderedList__ju_LinkedHashMap$Node__V(this, node);
});
$p.b56 = (function(node) {
  $p_ju_LinkedHashMap__removeFromOrderedList__ju_LinkedHashMap$Node__V(this, node);
});
var $d_ju_LinkedHashMap = new $TypeData().i($c_ju_LinkedHashMap, "java.util.LinkedHashMap", ({
  tp: 1,
  tg: 1,
  f9: 1,
  cn: 1,
  a: 1,
  W: 1,
  tv: 1
}));
class $c_ju_MissingFormatArgumentException extends $c_ju_IllegalFormatException {
  constructor(s) {
    super();
    this.atw = null;
    this.atw = s;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  e3() {
    return (("Format specifier '" + this.atw) + "'");
  }
}
var $d_ju_MissingFormatArgumentException = new $TypeData().i($c_ju_MissingFormatArgumentException, "java.util.MissingFormatArgumentException", ({
  tt: 1,
  aT: 1,
  aE: 1,
  R: 1,
  G: 1,
  y: 1,
  a: 1
}));
class $c_ju_MissingFormatWidthException extends $c_ju_IllegalFormatException {
  constructor(s) {
    super();
    this.atx = null;
    this.atx = s;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  e3() {
    return this.atx;
  }
}
var $d_ju_MissingFormatWidthException = new $TypeData().i($c_ju_MissingFormatWidthException, "java.util.MissingFormatWidthException", ({
  tu: 1,
  aT: 1,
  aE: 1,
  R: 1,
  G: 1,
  y: 1,
  a: 1
}));
class $c_ju_UnknownFormatConversionException extends $c_ju_IllegalFormatException {
  constructor(s) {
    super();
    this.aty = null;
    this.aty = s;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  e3() {
    return (("Conversion = '" + this.aty) + "'");
  }
}
var $d_ju_UnknownFormatConversionException = new $TypeData().i($c_ju_UnknownFormatConversionException, "java.util.UnknownFormatConversionException", ({
  tx: 1,
  aT: 1,
  aE: 1,
  R: 1,
  G: 1,
  y: 1,
  a: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_model_Binding$$anon$7(ReadersVersionSpecific_this$10, paramCount$4, outer) {
  this.ic = null;
  this.gQ = 0;
  this.iO = 0;
  this.iP = 0;
  this.iM = false;
  this.iN = null;
  this.iI = null;
  this.iJ = false;
  this.iK = false;
  this.iL = false;
  this.jh = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$4 <= 64)) {
    if ((paramCount$4 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$4) === 0) ? (1 << paramCount$4) : 0);
      var hi = (((32 & paramCount$4) === 0) ? 0 : (1 << paramCount$4));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$4 >> 31);
    var $x_1_$_lo = paramCount$4;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$10, paramCount$4, $x_1_$_lo, $x_1_$_hi, $m_Lorg_jpablo_graphexplorer_gxcore_model_Binding$().b5p(ReadersVersionSpecific_this$10), $m_Lorg_jpablo_graphexplorer_gxcore_model_Binding$().b5q());
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_model_Binding$$anon$7.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_model_Binding$$anon$7;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_model_Binding$$anon$7() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_model_Binding$$anon$7.prototype = $p;
$p.k3 = (function() {
  var this$2 = new $c_sci_$colon$colon($m_Lorg_jpablo_graphexplorer_gxcore_model_OriginUri$package$OriginUri$().agg(), new $c_sci_$colon$colon($m_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$().agj(), new $c_sci_$colon$colon($m_Lorg_jpablo_graphexplorer_gxcore_model_ContentHash$package$ContentHash$().agf(), new $c_sci_$colon$colon($m_Lupickle_default$().Ii, $m_sci_Nil$()))));
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.p()) {
    var elem = it.q();
    var unboxedElem = ((elem === null) ? null : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2(null, new $ac_O(jsElems));
});
$p.jV = (function(x) {
  switch (x) {
    case "origin": {
      return 0;
      break;
    }
    case "mode": {
      return 1;
      break;
    }
    case "baseHash": {
      return 2;
      break;
    }
    case "lastSyncAt": {
      return 3;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.jR = (function() {
  var this$2 = new $c_sci_$colon$colon("origin", new $c_sci_$colon$colon("mode", new $c_sci_$colon$colon("baseHash", new $c_sci_$colon$colon("lastSyncAt", $m_sci_Nil$()))));
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.p()) {
    var elem = it.q();
    var unboxedElem = ((elem === null) ? null : elem);
    jsElems.push(unboxedElem);
  }
  return new ($d_T.r().C)(jsElems);
});
$p.k1 = (function(x) {
});
var $d_Lorg_jpablo_graphexplorer_gxcore_model_Binding$$anon$7 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_model_Binding$$anon$7, "org.jpablo.graphexplorer.gxcore.model.Binding$$anon$7", ({
  vY: 1,
  ai: 1,
  ag: 1,
  x: 1,
  D: 1,
  J: 1,
  K: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_model_Diagram$$anon$9(ReadersVersionSpecific_this$13, paramCount$5, outer) {
  this.ic = null;
  this.gQ = 0;
  this.iO = 0;
  this.iP = 0;
  this.iM = false;
  this.iN = null;
  this.iI = null;
  this.iJ = false;
  this.iK = false;
  this.iL = false;
  this.jh = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$5 <= 64)) {
    if ((paramCount$5 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$5) === 0) ? (1 << paramCount$5) : 0);
      var hi = (((32 & paramCount$5) === 0) ? 0 : (1 << paramCount$5));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$5 >> 31);
    var $x_1_$_lo = paramCount$5;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$13, paramCount$5, $x_1_$_lo, $x_1_$_hi, $m_Lorg_jpablo_graphexplorer_gxcore_model_Diagram$().b5s(ReadersVersionSpecific_this$13), $m_Lorg_jpablo_graphexplorer_gxcore_model_Diagram$().b5r());
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_model_Diagram$$anon$9.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_model_Diagram$$anon$9;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_model_Diagram$$anon$9() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_model_Diagram$$anon$9.prototype = $p;
$p.k3 = (function() {
  var this$4 = $m_sci_Nil$().b6($m_sr_ScalaRunTime$().f(new $ac_O([$m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId$().bm(), $m_Lupickle_default$().a5, $m_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath$().bm(), $m_Lupickle_default$().a5, $m_Lupickle_default$().a5, $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lorg_jpablo_graphexplorer_gxcore_model_Binding$().bm()), $m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$().bm(), $m_Lupickle_default$().Ii, $m_Lupickle_default$().Ii])));
  if ((this$4.V() >= 0)) {
    var destination = new $ac_O(this$4.V());
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$4, destination, 0, 2147483647);
    var $x_1 = destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = this$4.o();
    while (it.p()) {
      var elem = it.q();
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem);
    }
    var $x_1 = new $ac_O(jsElems);
  }
  return new $c_T2(null, $x_1);
});
$p.jV = (function(x) {
  switch (x) {
    case "id": {
      return 0;
      break;
    }
    case "name": {
      return 1;
      break;
    }
    case "folder": {
      return 2;
      break;
    }
    case "format": {
      return 3;
      break;
    }
    case "text": {
      return 4;
      break;
    }
    case "binding": {
      return 5;
      break;
    }
    case "metadata": {
      return 6;
      break;
    }
    case "createdAt": {
      return 7;
      break;
    }
    case "updatedAt": {
      return 8;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.jR = (function() {
  var this$3 = $m_sci_Nil$().b6($m_sr_ScalaRunTime$().f(new ($d_T.r().C)(["id", "name", "folder", "format", "text", "binding", "metadata", "createdAt", "updatedAt"])));
  if ((this$3.V() >= 0)) {
    var destination = new ($d_T.r().C)(this$3.V());
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$3, destination, 0, 2147483647);
    return destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = this$3.o();
    while (it.p()) {
      var elem = it.q();
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem);
    }
    return new ($d_T.r().C)(jsElems);
  }
});
$p.k1 = (function(x) {
});
var $d_Lorg_jpablo_graphexplorer_gxcore_model_Diagram$$anon$9 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_model_Diagram$$anon$9, "org.jpablo.graphexplorer.gxcore.model.Diagram$$anon$9", ({
  w3: 1,
  ai: 1,
  ag: 1,
  x: 1,
  D: 1,
  J: 1,
  K: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId$$anon$1(ReadersVersionSpecific_this$1, paramCount$1, outer) {
  this.ic = null;
  this.gQ = 0;
  this.iO = 0;
  this.iP = 0;
  this.iM = false;
  this.iN = null;
  this.iI = null;
  this.iJ = false;
  this.iK = false;
  this.iL = false;
  this.jh = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$1 <= 64)) {
    if ((paramCount$1 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$1) === 0) ? (1 << paramCount$1) : 0);
      var hi = (((32 & paramCount$1) === 0) ? 0 : (1 << paramCount$1));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$1 >> 31);
    var $x_1_$_lo = paramCount$1;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$1, paramCount$1, $x_1_$_lo, $x_1_$_hi, $m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId$().b5t(ReadersVersionSpecific_this$1), $m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId$().b5u());
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId$$anon$1.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId$$anon$1.prototype = $p;
$p.k3 = (function() {
  var this$2 = new $c_sci_$colon$colon($m_Lupickle_default$().a5, $m_sci_Nil$());
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.p()) {
    var elem = it.q();
    var unboxedElem = ((elem === null) ? null : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2(null, new $ac_O(jsElems));
});
$p.jV = (function(x) {
  return ((x === "value") ? 0 : (-1));
});
$p.jR = (function() {
  var this$2 = new $c_sci_$colon$colon("value", $m_sci_Nil$());
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.p()) {
    var elem = it.q();
    var unboxedElem = ((elem === null) ? null : elem);
    jsElems.push(unboxedElem);
  }
  return new ($d_T.r().C)(jsElems);
});
$p.k1 = (function(x) {
});
var $d_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramId$$anon$1, "org.jpablo.graphexplorer.gxcore.model.DiagramId$$anon$1", ({
  w5: 1,
  ai: 1,
  ag: 1,
  x: 1,
  D: 1,
  J: 1,
  K: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$$anon$5(ReadersVersionSpecific_this$7, paramCount$3, outer) {
  this.ic = null;
  this.gQ = 0;
  this.iO = 0;
  this.iP = 0;
  this.iM = false;
  this.iN = null;
  this.iI = null;
  this.iJ = false;
  this.iK = false;
  this.iL = false;
  this.jh = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$3 <= 64)) {
    if ((paramCount$3 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$3) === 0) ? (1 << paramCount$3) : 0);
      var hi = (((32 & paramCount$3) === 0) ? 0 : (1 << paramCount$3));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$3 >> 31);
    var $x_1_$_lo = paramCount$3;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$7, paramCount$3, $x_1_$_lo, $x_1_$_hi, $m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$().b5v(ReadersVersionSpecific_this$7), $m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$().b5w());
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$$anon$5.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$$anon$5;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$$anon$5() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$$anon$5.prototype = $p;
$p.k3 = (function() {
  var this$12 = new $c_sci_$colon$colon(new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lupickle_default$().a5, new $c_sc_IterableFactory$ToFactory($m_sci_Set$())), new $c_sci_$colon$colon(new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lupickle_default$().a5, new $c_sc_IterableFactory$ToFactory($m_sci_Set$())), new $c_sci_$colon$colon(new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lupickle_default$().a5, new $c_sc_IterableFactory$ToFactory($m_sci_List$())), new $c_sci_$colon$colon($m_Lupickle_default$().a5, new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().ow), $m_sci_Nil$())))));
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$12);
  while (it.p()) {
    var elem = it.q();
    var unboxedElem = ((elem === null) ? null : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2(null, new $ac_O(jsElems));
});
$p.jV = (function(x) {
  switch (x) {
    case "hiddenElements": {
      return 0;
      break;
    }
    case "collapsedGroups": {
      return 1;
      break;
    }
    case "tags": {
      return 2;
      break;
    }
    case "notes": {
      return 3;
      break;
    }
    case "autoDetectFormat": {
      return 4;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.jR = (function() {
  var this$2 = new $c_sci_$colon$colon("hiddenElements", new $c_sci_$colon$colon("collapsedGroups", new $c_sci_$colon$colon("tags", new $c_sci_$colon$colon("notes", new $c_sci_$colon$colon("autoDetectFormat", $m_sci_Nil$())))));
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.p()) {
    var elem = it.q();
    var unboxedElem = ((elem === null) ? null : elem);
    jsElems.push(unboxedElem);
  }
  return new ($d_T.r().C)(jsElems);
});
$p.k1 = (function(x) {
  x.a2(0, ($m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$(), $m_sci_Set$EmptySet$()));
  x.a2(1, ($m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$(), $m_sci_Set$EmptySet$()));
  x.a2(2, ($m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$(), $m_sci_Nil$()));
  x.a2(3, ($m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$(), ""));
  x.a2(4, ($m_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$(), $m_s_None$()));
});
var $d_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$$anon$5 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_model_DiagramMetadata$$anon$5, "org.jpablo.graphexplorer.gxcore.model.DiagramMetadata$$anon$5", ({
  w8: 1,
  ai: 1,
  ag: 1,
  x: 1,
  D: 1,
  J: 1,
  K: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath$$anon$3(ReadersVersionSpecific_this$4, paramCount$2, outer) {
  this.ic = null;
  this.gQ = 0;
  this.iO = 0;
  this.iP = 0;
  this.iM = false;
  this.iN = null;
  this.iI = null;
  this.iJ = false;
  this.iK = false;
  this.iL = false;
  this.jh = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$2 <= 64)) {
    if ((paramCount$2 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$2) === 0) ? (1 << paramCount$2) : 0);
      var hi = (((32 & paramCount$2) === 0) ? 0 : (1 << paramCount$2));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$2 >> 31);
    var $x_1_$_lo = paramCount$2;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$4, paramCount$2, $x_1_$_lo, $x_1_$_hi, $m_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath$().b5x(ReadersVersionSpecific_this$4), $m_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath$().b5y());
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath$$anon$3.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath$$anon$3;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath$$anon$3() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath$$anon$3.prototype = $p;
$p.k3 = (function() {
  var this$5 = new $c_sci_$colon$colon(new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lupickle_default$().a5, new $c_sc_IterableFactory$ToFactory($m_sci_List$())), $m_sci_Nil$());
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$5);
  while (it.p()) {
    var elem = it.q();
    var unboxedElem = ((elem === null) ? null : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2(null, new $ac_O(jsElems));
});
$p.jV = (function(x) {
  return ((x === "segments") ? 0 : (-1));
});
$p.jR = (function() {
  var this$2 = new $c_sci_$colon$colon("segments", $m_sci_Nil$());
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.p()) {
    var elem = it.q();
    var unboxedElem = ((elem === null) ? null : elem);
    jsElems.push(unboxedElem);
  }
  return new ($d_T.r().C)(jsElems);
});
$p.k1 = (function(x) {
});
var $d_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath$$anon$3 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_model_FolderPath$$anon$3, "org.jpablo.graphexplorer.gxcore.model.FolderPath$$anon$3", ({
  wb: 1,
  ai: 1,
  ag: 1,
  x: 1,
  D: 1,
  J: 1,
  K: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_projects_ProjectInfo$$anon$1(ReadersVersionSpecific_this$1, paramCount$1, outer) {
  this.ic = null;
  this.gQ = 0;
  this.iO = 0;
  this.iP = 0;
  this.iM = false;
  this.iN = null;
  this.iI = null;
  this.iJ = false;
  this.iK = false;
  this.iL = false;
  this.jh = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$1 <= 64)) {
    if ((paramCount$1 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$1) === 0) ? (1 << paramCount$1) : 0);
      var hi = (((32 & paramCount$1) === 0) ? 0 : (1 << paramCount$1));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$1 >> 31);
    var $x_1_$_lo = paramCount$1;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$1, paramCount$1, $x_1_$_lo, $x_1_$_hi, $m_Lorg_jpablo_graphexplorer_projects_ProjectInfo$().b5A(ReadersVersionSpecific_this$1), $m_Lorg_jpablo_graphexplorer_projects_ProjectInfo$().b5B());
}
$p = $c_Lorg_jpablo_graphexplorer_projects_ProjectInfo$$anon$1.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2();
$p.constructor = $c_Lorg_jpablo_graphexplorer_projects_ProjectInfo$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_projects_ProjectInfo$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_projects_ProjectInfo$$anon$1.prototype = $p;
$p.k3 = (function() {
  var this$2 = new $c_sci_$colon$colon($m_Lorg_jpablo_graphexplorer_viewer_state_ProjectId$().bm(), new $c_sci_$colon$colon($m_Lupickle_default$().a5, new $c_sci_$colon$colon($m_Lupickle_default$().Ii, new $c_sci_$colon$colon($m_Lupickle_default$().Ii, $m_sci_Nil$()))));
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.p()) {
    var elem = it.q();
    var unboxedElem = ((elem === null) ? null : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2(null, new $ac_O(jsElems));
});
$p.jV = (function(x) {
  switch (x) {
    case "id": {
      return 0;
      break;
    }
    case "name": {
      return 1;
      break;
    }
    case "lastModified": {
      return 2;
      break;
    }
    case "createdAt": {
      return 3;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.jR = (function() {
  var this$2 = new $c_sci_$colon$colon("id", new $c_sci_$colon$colon("name", new $c_sci_$colon$colon("lastModified", new $c_sci_$colon$colon("createdAt", $m_sci_Nil$()))));
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.p()) {
    var elem = it.q();
    var unboxedElem = ((elem === null) ? null : elem);
    jsElems.push(unboxedElem);
  }
  return new ($d_T.r().C)(jsElems);
});
$p.k1 = (function(x) {
  var $x_1 = $m_RTLong$().d1((+Date.now()));
  x.a2(3, $x_1);
});
var $d_Lorg_jpablo_graphexplorer_projects_ProjectInfo$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_projects_ProjectInfo$$anon$1, "org.jpablo.graphexplorer.projects.ProjectInfo$$anon$1", ({
  wL: 1,
  ai: 1,
  ag: 1,
  x: 1,
  D: 1,
  J: 1,
  K: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory$$anon$3(ReadersVersionSpecific_this$4, paramCount$2, outer) {
  this.ic = null;
  this.gQ = 0;
  this.iO = 0;
  this.iP = 0;
  this.iM = false;
  this.iN = null;
  this.iI = null;
  this.iJ = false;
  this.iK = false;
  this.iL = false;
  this.jh = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$2 <= 64)) {
    if ((paramCount$2 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$2) === 0) ? (1 << paramCount$2) : 0);
      var hi = (((32 & paramCount$2) === 0) ? 0 : (1 << paramCount$2));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$2 >> 31);
    var $x_1_$_lo = paramCount$2;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$4, paramCount$2, $x_1_$_lo, $x_1_$_hi, $m_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory$().b5C(ReadersVersionSpecific_this$4), $m_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory$().b5D());
}
$p = $c_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory$$anon$3.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2();
$p.constructor = $c_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory$$anon$3;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory$$anon$3() {
}
$h_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory$$anon$3.prototype = $p;
$p.k3 = (function() {
  var this$5 = new $c_sci_$colon$colon(new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lorg_jpablo_graphexplorer_projects_ProjectInfo$().bm(), new $c_sc_IterableFactory$ToFactory($m_sci_List$())), $m_sci_Nil$());
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$5);
  while (it.p()) {
    var elem = it.q();
    var unboxedElem = ((elem === null) ? null : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2(null, new $ac_O(jsElems));
});
$p.jV = (function(x) {
  return ((x === "projects") ? 0 : (-1));
});
$p.jR = (function() {
  var this$2 = new $c_sci_$colon$colon("projects", $m_sci_Nil$());
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.p()) {
    var elem = it.q();
    var unboxedElem = ((elem === null) ? null : elem);
    jsElems.push(unboxedElem);
  }
  return new ($d_T.r().C)(jsElems);
});
$p.k1 = (function(x) {
  x.a2(0, $m_sci_Nil$());
});
var $d_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory$$anon$3 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_projects_ProjectsDirectory$$anon$3, "org.jpablo.graphexplorer.projects.ProjectsDirectory$$anon$3", ({
  wP: 1,
  ai: 1,
  ag: 1,
  x: 1,
  D: 1,
  J: 1,
  K: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$$anon$9(ReadersVersionSpecific_this$10, paramCount$4, outer) {
  this.ic = null;
  this.gQ = 0;
  this.iO = 0;
  this.iP = 0;
  this.iM = false;
  this.iN = null;
  this.iI = null;
  this.iJ = false;
  this.iK = false;
  this.iL = false;
  this.jh = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$4 <= 64)) {
    if ((paramCount$4 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$4) === 0) ? (1 << paramCount$4) : 0);
      var hi = (((32 & paramCount$4) === 0) ? 0 : (1 << paramCount$4));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$4 >> 31);
    var $x_1_$_lo = paramCount$4;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$10, paramCount$4, $x_1_$_lo, $x_1_$_hi, $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$().b5H(ReadersVersionSpecific_this$10), $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$().b5I());
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$$anon$9.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$$anon$9;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$$anon$9() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$$anon$9.prototype = $p;
$p.k3 = (function() {
  var this$56 = $m_sci_Nil$().b6($m_sr_ScalaRunTime$().f(new $ac_O([$m_Lupickle_default$().a5, $m_Lupickle_default$().ow, $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphObject$().agi(), new $c_sc_IterableFactory$ToFactory($m_sci_List$()))), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge$().agh(), new $c_sc_IterableFactory$ToFactory($m_sci_List$()))), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__MapReader2__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5, $m_Lupickle_default$().a5)])));
  if ((this$56.V() >= 0)) {
    var destination = new $ac_O(this$56.V());
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$56, destination, 0, 2147483647);
    var $x_1 = destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = this$56.o();
    while (it.p()) {
      var elem = it.q();
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem);
    }
    var $x_1 = new $ac_O(jsElems);
  }
  return new $c_T2(null, $x_1);
});
$p.jV = (function(x) {
  switch (x) {
    case "name": {
      return 0;
      break;
    }
    case "directed": {
      return 1;
      break;
    }
    case "objects": {
      return 2;
      break;
    }
    case "edges": {
      return 3;
      break;
    }
    case "fontname": {
      return 4;
      break;
    }
    case "fontsize": {
      return 5;
      break;
    }
    case "label": {
      return 6;
      break;
    }
    case "labelloc": {
      return 7;
      break;
    }
    case "lp": {
      return 8;
      break;
    }
    case "lheight": {
      return 9;
      break;
    }
    case "lwidth": {
      return 10;
      break;
    }
    case "rankdir": {
      return 11;
      break;
    }
    case "layout": {
      return 12;
      break;
    }
    case "bgcolor": {
      return 13;
      break;
    }
    case "nodesep": {
      return 14;
      break;
    }
    case "pad": {
      return 15;
      break;
    }
    case "ranksep": {
      return 16;
      break;
    }
    case "ratio": {
      return 17;
      break;
    }
    case "splines": {
      return 18;
      break;
    }
    case "overlap": {
      return 19;
      break;
    }
    case "normalize": {
      return 20;
      break;
    }
    case "start": {
      return 21;
      break;
    }
    case "beautify": {
      return 22;
      break;
    }
    case "Damping": {
      return 23;
      break;
    }
    case "defaultdist": {
      return 24;
      break;
    }
    case "dim": {
      return 25;
      break;
    }
    case "dimen": {
      return 26;
      break;
    }
    case "diredgeconstraints": {
      return 27;
      break;
    }
    case "dpi": {
      return 28;
      break;
    }
    case "epsilon": {
      return 29;
      break;
    }
    case "esep": {
      return 30;
      break;
    }
    case "fontnames": {
      return 31;
      break;
    }
    case "fontpath": {
      return 32;
      break;
    }
    case "K": {
      return 33;
      break;
    }
    case "label_scheme": {
      return 34;
      break;
    }
    case "labeljust": {
      return 35;
      break;
    }
    case "landscape": {
      return 36;
      break;
    }
    case "layerlistsep": {
      return 37;
      break;
    }
    case "layers": {
      return 38;
      break;
    }
    case "layerselect": {
      return 39;
      break;
    }
    case "layersep": {
      return 40;
      break;
    }
    case "nojustify": {
      return 41;
      break;
    }
    case "notranslate": {
      return 42;
      break;
    }
    case "target": {
      return 43;
      break;
    }
    case "TBbalance": {
      return 44;
      break;
    }
    case "tooltip": {
      return 45;
      break;
    }
    case "truecolor": {
      return 46;
      break;
    }
    case "URL": {
      return 47;
      break;
    }
    case "extraAttrs": {
      return 48;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.jR = (function() {
  var this$3 = $m_sci_Nil$().b6($m_sr_ScalaRunTime$().f(new ($d_T.r().C)(["name", "directed", "objects", "edges", "fontname", "fontsize", "label", "labelloc", "lp", "lheight", "lwidth", "rankdir", "layout", "bgcolor", "nodesep", "pad", "ranksep", "ratio", "splines", "overlap", "normalize", "start", "beautify", "Damping", "defaultdist", "dim", "dimen", "diredgeconstraints", "dpi", "epsilon", "esep", "fontnames", "fontpath", "K", "label_scheme", "labeljust", "landscape", "layerlistsep", "layers", "layerselect", "layersep", "nojustify", "notranslate", "target", "TBbalance", "tooltip", "truecolor", "URL", "extraAttrs"])));
  if ((this$3.V() >= 0)) {
    var destination = new ($d_T.r().C)(this$3.V());
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$3, destination, 0, 2147483647);
    return destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = this$3.o();
    while (it.p()) {
      var elem = it.q();
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem);
    }
    return new ($d_T.r().C)(jsElems);
  }
});
$p.k1 = (function(x) {
  x.a2(1, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), true));
  x.a2(2, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_s_None$()));
  x.a2(3, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_s_None$()));
  x.a2(4, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_s_None$()));
  x.a2(5, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_s_None$()));
  x.a2(6, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_s_None$()));
  x.a2(7, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_s_None$()));
  x.a2(8, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_s_None$()));
  x.a2(9, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_s_None$()));
  x.a2(10, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_s_None$()));
  x.a2(11, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_s_None$()));
  x.a2(12, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_s_None$()));
  x.a2(13, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_s_None$()));
  x.a2(14, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_s_None$()));
  x.a2(15, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_s_None$()));
  x.a2(16, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_s_None$()));
  x.a2(17, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_s_None$()));
  x.a2(18, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_s_None$()));
  x.a2(19, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_s_None$()));
  x.a2(20, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_s_None$()));
  x.a2(21, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_s_None$()));
  x.a2(22, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_s_None$()));
  x.a2(23, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_s_None$()));
  x.a2(24, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_s_None$()));
  x.a2(25, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_s_None$()));
  x.a2(26, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_s_None$()));
  x.a2(27, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_s_None$()));
  x.a2(28, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_s_None$()));
  x.a2(29, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_s_None$()));
  x.a2(30, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_s_None$()));
  x.a2(31, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_s_None$()));
  x.a2(32, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_s_None$()));
  x.a2(33, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_s_None$()));
  x.a2(34, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_s_None$()));
  x.a2(35, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_s_None$()));
  x.a2(36, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_s_None$()));
  x.a2(37, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_s_None$()));
  x.a2(38, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_s_None$()));
  x.a2(39, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_s_None$()));
  x.a2(40, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_s_None$()));
  x.a2(41, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_s_None$()));
  x.a2(42, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_s_None$()));
  x.a2(43, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_s_None$()));
  x.a2(44, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_s_None$()));
  x.a2(45, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_s_None$()));
  x.a2(46, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_s_None$()));
  x.a2(47, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_s_None$()));
  x.a2(48, ($m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$(), $m_sci_Map$EmptyMap$()));
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$$anon$9 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraph$$anon$9, "org.jpablo.graphexplorer.viewer.backends.graphviz.vizjs.simplegraph.SimpleGraph$$anon$9", ({
  xt: 1,
  ai: 1,
  ag: 1,
  x: 1,
  D: 1,
  J: 1,
  K: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphCluster$$anon$4(ReadersVersionSpecific_this$4, paramCount$2, outer) {
  this.ic = null;
  this.gQ = 0;
  this.iO = 0;
  this.iP = 0;
  this.iM = false;
  this.iN = null;
  this.iI = null;
  this.iJ = false;
  this.iK = false;
  this.iL = false;
  this.jh = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$2 <= 64)) {
    if ((paramCount$2 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$2) === 0) ? (1 << paramCount$2) : 0);
      var hi = (((32 & paramCount$2) === 0) ? 0 : (1 << paramCount$2));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$2 >> 31);
    var $x_1_$_lo = paramCount$2;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$4, paramCount$2, $x_1_$_lo, $x_1_$_hi, $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphCluster$().b5J(ReadersVersionSpecific_this$4), $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphCluster$().b5K());
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphCluster$$anon$4.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphCluster$$anon$4;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphCluster$$anon$4() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphCluster$$anon$4.prototype = $p;
$p.k3 = (function() {
  var this$44 = $m_sci_Nil$().b6($m_sr_ScalaRunTime$().f(new $ac_O([$m_Lupickle_default$().pk, $m_Lupickle_default$().a5, $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lupickle_default$().pk, new $c_sc_IterableFactory$ToFactory($m_sci_List$()))), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lupickle_default$().pk, new $c_sc_IterableFactory$ToFactory($m_sci_List$()))), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lupickle_default$().pk, new $c_sc_IterableFactory$ToFactory($m_sci_List$()))), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__MapReader2__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5, $m_Lupickle_default$().a5)])));
  if ((this$44.V() >= 0)) {
    var destination = new $ac_O(this$44.V());
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$44, destination, 0, 2147483647);
    var $x_1 = destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = this$44.o();
    while (it.p()) {
      var elem = it.q();
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem);
    }
    var $x_1 = new $ac_O(jsElems);
  }
  return new $c_T2(null, $x_1);
});
$p.jV = (function(x) {
  switch (x) {
    case "_gvid": {
      return 0;
      break;
    }
    case "name": {
      return 1;
      break;
    }
    case "nodes": {
      return 2;
      break;
    }
    case "label": {
      return 3;
      break;
    }
    case "edges": {
      return 4;
      break;
    }
    case "subgraphs": {
      return 5;
      break;
    }
    case "fontname": {
      return 6;
      break;
    }
    case "fontsize": {
      return 7;
      break;
    }
    case "fontcolor": {
      return 8;
      break;
    }
    case "color": {
      return 9;
      break;
    }
    case "pencolor": {
      return 10;
      break;
    }
    case "penwidth": {
      return 11;
      break;
    }
    case "bgcolor": {
      return 12;
      break;
    }
    case "fillcolor": {
      return 13;
      break;
    }
    case "style": {
      return 14;
      break;
    }
    case "labeljust": {
      return 15;
      break;
    }
    case "labelloc": {
      return 16;
      break;
    }
    case "lheight": {
      return 17;
      break;
    }
    case "lp": {
      return 18;
      break;
    }
    case "lwidth": {
      return 19;
      break;
    }
    case "layout": {
      return 20;
      break;
    }
    case "normalize": {
      return 21;
      break;
    }
    case "start": {
      return 22;
      break;
    }
    case "overlap": {
      return 23;
      break;
    }
    case "cluster": {
      return 24;
      break;
    }
    case "rankdir": {
      return 25;
      break;
    }
    case "rank": {
      return 26;
      break;
    }
    case "splines": {
      return 27;
      break;
    }
    case "target": {
      return 28;
      break;
    }
    case "tooltip": {
      return 29;
      break;
    }
    case "URL": {
      return 30;
      break;
    }
    case "class": {
      return 31;
      break;
    }
    case "colorscheme": {
      return 32;
      break;
    }
    case "extraAttrs": {
      return 33;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.jR = (function() {
  var this$3 = $m_sci_Nil$().b6($m_sr_ScalaRunTime$().f(new ($d_T.r().C)(["_gvid", "name", "nodes", "label", "edges", "subgraphs", "fontname", "fontsize", "fontcolor", "color", "pencolor", "penwidth", "bgcolor", "fillcolor", "style", "labeljust", "labelloc", "lheight", "lp", "lwidth", "layout", "normalize", "start", "overlap", "cluster", "rankdir", "rank", "splines", "target", "tooltip", "URL", "class", "colorscheme", "extraAttrs"])));
  if ((this$3.V() >= 0)) {
    var destination = new ($d_T.r().C)(this$3.V());
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$3, destination, 0, 2147483647);
    return destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = this$3.o();
    while (it.p()) {
      var elem = it.q();
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem);
    }
    return new ($d_T.r().C)(jsElems);
  }
});
$p.k1 = (function(x) {
  x.a2(2, $m_s_None$());
  x.a2(3, $m_s_None$());
  x.a2(4, $m_s_None$());
  x.a2(5, $m_s_None$());
  x.a2(6, $m_s_None$());
  x.a2(7, $m_s_None$());
  x.a2(8, $m_s_None$());
  x.a2(9, $m_s_None$());
  x.a2(10, $m_s_None$());
  x.a2(11, $m_s_None$());
  x.a2(12, $m_s_None$());
  x.a2(13, $m_s_None$());
  x.a2(14, $m_s_None$());
  x.a2(15, $m_s_None$());
  x.a2(16, $m_s_None$());
  x.a2(17, $m_s_None$());
  x.a2(18, $m_s_None$());
  x.a2(19, $m_s_None$());
  x.a2(20, $m_s_None$());
  x.a2(21, $m_s_None$());
  x.a2(22, $m_s_None$());
  x.a2(23, $m_s_None$());
  x.a2(24, $m_s_None$());
  x.a2(25, $m_s_None$());
  x.a2(26, $m_s_None$());
  x.a2(27, $m_s_None$());
  x.a2(28, $m_s_None$());
  x.a2(29, $m_s_None$());
  x.a2(30, $m_s_None$());
  x.a2(31, $m_s_None$());
  x.a2(32, $m_s_None$());
  x.a2(33, $m_sci_Map$EmptyMap$());
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphCluster$$anon$4 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphCluster$$anon$4, "org.jpablo.graphexplorer.viewer.backends.graphviz.vizjs.simplegraph.SimpleGraphCluster$$anon$4", ({
  xv: 1,
  ai: 1,
  ag: 1,
  x: 1,
  D: 1,
  J: 1,
  K: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge$$anon$6(ReadersVersionSpecific_this$7, paramCount$3, outer) {
  this.ic = null;
  this.gQ = 0;
  this.iO = 0;
  this.iP = 0;
  this.iM = false;
  this.iN = null;
  this.iI = null;
  this.iJ = false;
  this.iK = false;
  this.iL = false;
  this.jh = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$3 <= 64)) {
    if ((paramCount$3 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$3) === 0) ? (1 << paramCount$3) : 0);
      var hi = (((32 & paramCount$3) === 0) ? 0 : (1 << paramCount$3));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$3 >> 31);
    var $x_1_$_lo = paramCount$3;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$7, paramCount$3, $x_1_$_lo, $x_1_$_hi, $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge$().b5L(ReadersVersionSpecific_this$7), $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge$().b5M());
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge$$anon$6.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge$$anon$6;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge$$anon$6() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge$$anon$6.prototype = $p;
$p.k3 = (function() {
  var this$40 = $m_sci_Nil$().b6($m_sr_ScalaRunTime$().f(new $ac_O([$m_Lupickle_default$().pk, $m_Lupickle_default$().pk, $m_Lupickle_default$().pk, $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__MapReader2__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5, $m_Lupickle_default$().a5)])));
  if ((this$40.V() >= 0)) {
    var destination = new $ac_O(this$40.V());
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$40, destination, 0, 2147483647);
    var $x_1 = destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = this$40.o();
    while (it.p()) {
      var elem = it.q();
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem);
    }
    var $x_1 = new $ac_O(jsElems);
  }
  return new $c_T2(null, $x_1);
});
$p.jV = (function(x) {
  switch (x) {
    case "_gvid": {
      return 0;
      break;
    }
    case "tail": {
      return 1;
      break;
    }
    case "head": {
      return 2;
      break;
    }
    case "pos": {
      return 3;
      break;
    }
    case "id": {
      return 4;
      break;
    }
    case "label": {
      return 5;
      break;
    }
    case "fontname": {
      return 6;
      break;
    }
    case "fontsize": {
      return 7;
      break;
    }
    case "color": {
      return 8;
      break;
    }
    case "penwidth": {
      return 9;
      break;
    }
    case "style": {
      return 10;
      break;
    }
    case "lp": {
      return 11;
      break;
    }
    case "len": {
      return 12;
      break;
    }
    case "constraint": {
      return 13;
      break;
    }
    case "forcelabels": {
      return 14;
      break;
    }
    case "headport": {
      return 15;
      break;
    }
    case "tailport": {
      return 16;
      break;
    }
    case "arrowhead": {
      return 17;
      break;
    }
    case "arrowtail": {
      return 18;
      break;
    }
    case "arrowsize": {
      return 19;
      break;
    }
    case "dir": {
      return 20;
      break;
    }
    case "class": {
      return 21;
      break;
    }
    case "colorscheme": {
      return 22;
      break;
    }
    case "layer": {
      return 23;
      break;
    }
    case "nojustify": {
      return 24;
      break;
    }
    case "samehead": {
      return 25;
      break;
    }
    case "sametail": {
      return 26;
      break;
    }
    case "showboxes": {
      return 27;
      break;
    }
    case "tail_lp": {
      return 28;
      break;
    }
    case "tailclip": {
      return 29;
      break;
    }
    case "target": {
      return 30;
      break;
    }
    case "tooltip": {
      return 31;
      break;
    }
    case "labeldistance": {
      return 32;
      break;
    }
    case "labelfloat": {
      return 33;
      break;
    }
    case "labelfontcolor": {
      return 34;
      break;
    }
    case "labelfontname": {
      return 35;
      break;
    }
    case "tailtarget": {
      return 36;
      break;
    }
    case "tailtooltip": {
      return 37;
      break;
    }
    case "tailURL": {
      return 38;
      break;
    }
    case "extraAttrs": {
      return 39;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.jR = (function() {
  var this$3 = $m_sci_Nil$().b6($m_sr_ScalaRunTime$().f(new ($d_T.r().C)(["_gvid", "tail", "head", "pos", "id", "label", "fontname", "fontsize", "color", "penwidth", "style", "lp", "len", "constraint", "forcelabels", "headport", "tailport", "arrowhead", "arrowtail", "arrowsize", "dir", "class", "colorscheme", "layer", "nojustify", "samehead", "sametail", "showboxes", "tail_lp", "tailclip", "target", "tooltip", "labeldistance", "labelfloat", "labelfontcolor", "labelfontname", "tailtarget", "tailtooltip", "tailURL", "extraAttrs"])));
  if ((this$3.V() >= 0)) {
    var destination = new ($d_T.r().C)(this$3.V());
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$3, destination, 0, 2147483647);
    return destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = this$3.o();
    while (it.p()) {
      var elem = it.q();
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem);
    }
    return new ($d_T.r().C)(jsElems);
  }
});
$p.k1 = (function(x) {
  x.a2(3, $m_s_None$());
  x.a2(4, $m_s_None$());
  x.a2(5, $m_s_None$());
  x.a2(6, $m_s_None$());
  x.a2(7, $m_s_None$());
  x.a2(8, $m_s_None$());
  x.a2(9, $m_s_None$());
  x.a2(10, $m_s_None$());
  x.a2(11, $m_s_None$());
  x.a2(12, $m_s_None$());
  x.a2(13, $m_s_None$());
  x.a2(14, $m_s_None$());
  x.a2(15, $m_s_None$());
  x.a2(16, $m_s_None$());
  x.a2(17, $m_s_None$());
  x.a2(18, $m_s_None$());
  x.a2(19, $m_s_None$());
  x.a2(20, $m_s_None$());
  x.a2(21, $m_s_None$());
  x.a2(22, $m_s_None$());
  x.a2(23, $m_s_None$());
  x.a2(24, $m_s_None$());
  x.a2(25, $m_s_None$());
  x.a2(26, $m_s_None$());
  x.a2(27, $m_s_None$());
  x.a2(28, $m_s_None$());
  x.a2(29, $m_s_None$());
  x.a2(30, $m_s_None$());
  x.a2(31, $m_s_None$());
  x.a2(32, $m_s_None$());
  x.a2(33, $m_s_None$());
  x.a2(34, $m_s_None$());
  x.a2(35, $m_s_None$());
  x.a2(36, $m_s_None$());
  x.a2(37, $m_s_None$());
  x.a2(38, $m_s_None$());
  x.a2(39, $m_sci_Map$EmptyMap$());
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge$$anon$6 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphEdge$$anon$6, "org.jpablo.graphexplorer.viewer.backends.graphviz.vizjs.simplegraph.SimpleGraphEdge$$anon$6", ({
  xy: 1,
  ai: 1,
  ag: 1,
  x: 1,
  D: 1,
  J: 1,
  K: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphNode$$anon$2(ReadersVersionSpecific_this$1, paramCount$1, outer) {
  this.ic = null;
  this.gQ = 0;
  this.iO = 0;
  this.iP = 0;
  this.iM = false;
  this.iN = null;
  this.iI = null;
  this.iJ = false;
  this.iK = false;
  this.iL = false;
  this.jh = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$1 <= 64)) {
    if ((paramCount$1 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$1) === 0) ? (1 << paramCount$1) : 0);
      var hi = (((32 & paramCount$1) === 0) ? 0 : (1 << paramCount$1));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$1 >> 31);
    var $x_1_$_lo = paramCount$1;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$1, paramCount$1, $x_1_$_lo, $x_1_$_hi, $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphNode$().b5N(ReadersVersionSpecific_this$1), $m_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphNode$().b5O());
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphNode$$anon$2.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphNode$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphNode$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphNode$$anon$2.prototype = $p;
$p.k3 = (function() {
  var this$33 = $m_sci_Nil$().b6($m_sr_ScalaRunTime$().f(new $ac_O([$m_Lupickle_default$().pk, $m_Lupickle_default$().a5, $m_Lupickle_default$().a5, $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__MapReader2__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5, $m_Lupickle_default$().a5)])));
  if ((this$33.V() >= 0)) {
    var destination = new $ac_O(this$33.V());
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$33, destination, 0, 2147483647);
    var $x_1 = destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = this$33.o();
    while (it.p()) {
      var elem = it.q();
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem);
    }
    var $x_1 = new $ac_O(jsElems);
  }
  return new $c_T2(null, $x_1);
});
$p.jV = (function(x) {
  switch (x) {
    case "_gvid": {
      return 0;
      break;
    }
    case "name": {
      return 1;
      break;
    }
    case "label": {
      return 2;
      break;
    }
    case "pos": {
      return 3;
      break;
    }
    case "height": {
      return 4;
      break;
    }
    case "width": {
      return 5;
      break;
    }
    case "shape": {
      return 6;
      break;
    }
    case "fontname": {
      return 7;
      break;
    }
    case "fontsize": {
      return 8;
      break;
    }
    case "fontcolor": {
      return 9;
      break;
    }
    case "color": {
      return 10;
      break;
    }
    case "fillcolor": {
      return 11;
      break;
    }
    case "style": {
      return 12;
      break;
    }
    case "penwidth": {
      return 13;
      break;
    }
    case "rects": {
      return 14;
      break;
    }
    case "sides": {
      return 15;
      break;
    }
    case "peripheries": {
      return 16;
      break;
    }
    case "fixedsize": {
      return 17;
      break;
    }
    case "regular": {
      return 18;
      break;
    }
    case "orientation": {
      return 19;
      break;
    }
    case "URL": {
      return 20;
      break;
    }
    case "area": {
      return 21;
      break;
    }
    case "class": {
      return 22;
      break;
    }
    case "colorscheme": {
      return 23;
      break;
    }
    case "target": {
      return 24;
      break;
    }
    case "tooltip": {
      return 25;
      break;
    }
    case "vertices": {
      return 26;
      break;
    }
    case "image": {
      return 27;
      break;
    }
    case "imagepath": {
      return 28;
      break;
    }
    case "imagepos": {
      return 29;
      break;
    }
    case "margin": {
      return 30;
      break;
    }
    case "nojustify": {
      return 31;
      break;
    }
    case "extraAttrs": {
      return 32;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.jR = (function() {
  var this$3 = $m_sci_Nil$().b6($m_sr_ScalaRunTime$().f(new ($d_T.r().C)(["_gvid", "name", "label", "pos", "height", "width", "shape", "fontname", "fontsize", "fontcolor", "color", "fillcolor", "style", "penwidth", "rects", "sides", "peripheries", "fixedsize", "regular", "orientation", "URL", "area", "class", "colorscheme", "target", "tooltip", "vertices", "image", "imagepath", "imagepos", "margin", "nojustify", "extraAttrs"])));
  if ((this$3.V() >= 0)) {
    var destination = new ($d_T.r().C)(this$3.V());
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$3, destination, 0, 2147483647);
    return destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = this$3.o();
    while (it.p()) {
      var elem = it.q();
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem);
    }
    return new ($d_T.r().C)(jsElems);
  }
});
$p.k1 = (function(x) {
  x.a2(3, $m_s_None$());
  x.a2(4, $m_s_None$());
  x.a2(5, $m_s_None$());
  x.a2(6, $m_s_None$());
  x.a2(7, $m_s_None$());
  x.a2(8, $m_s_None$());
  x.a2(9, $m_s_None$());
  x.a2(10, $m_s_None$());
  x.a2(11, $m_s_None$());
  x.a2(12, $m_s_None$());
  x.a2(13, $m_s_None$());
  x.a2(14, $m_s_None$());
  x.a2(15, $m_s_None$());
  x.a2(16, $m_s_None$());
  x.a2(17, $m_s_None$());
  x.a2(18, $m_s_None$());
  x.a2(19, $m_s_None$());
  x.a2(20, $m_s_None$());
  x.a2(21, $m_s_None$());
  x.a2(22, $m_s_None$());
  x.a2(23, $m_s_None$());
  x.a2(24, $m_s_None$());
  x.a2(25, $m_s_None$());
  x.a2(26, $m_s_None$());
  x.a2(27, $m_s_None$());
  x.a2(28, $m_s_None$());
  x.a2(29, $m_s_None$());
  x.a2(30, $m_s_None$());
  x.a2(31, $m_s_None$());
  x.a2(32, $m_sci_Map$EmptyMap$());
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphNode$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_graphviz_vizjs_simplegraph_SimpleGraphNode$$anon$2, "org.jpablo.graphexplorer.viewer.backends.graphviz.vizjs.simplegraph.SimpleGraphNode$$anon$2", ({
  xB: 1,
  ai: 1,
  ag: 1,
  x: 1,
  D: 1,
  J: 1,
  K: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq$$anon$4(ReadersVersionSpecific_this$4, paramCount$2, outer) {
  this.ic = null;
  this.gQ = 0;
  this.iO = 0;
  this.iP = 0;
  this.iM = false;
  this.iN = null;
  this.iI = null;
  this.iJ = false;
  this.iK = false;
  this.iL = false;
  this.jh = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$2 <= 64)) {
    if ((paramCount$2 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$2) === 0) ? (1 << paramCount$2) : 0);
      var hi = (((32 & paramCount$2) === 0) ? 0 : (1 << paramCount$2));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$2 >> 31);
    var $x_1_$_lo = paramCount$2;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$4, paramCount$2, $x_1_$_lo, $x_1_$_hi, $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq$().b5Q(ReadersVersionSpecific_this$4), $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq$().b5R());
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq$$anon$4.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq$$anon$4;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq$$anon$4() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq$$anon$4.prototype = $p;
$p.k3 = (function() {
  var this$2 = new $c_sci_$colon$colon($m_Lupickle_default$().a5, new $c_sci_$colon$colon($m_Lupickle_default$().ow, $m_sci_Nil$()));
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.p()) {
    var elem = it.q();
    var unboxedElem = ((elem === null) ? null : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2(null, new $ac_O(jsElems));
});
$p.jV = (function(x) {
  return ((x === "value") ? 0 : ((x === "html") ? 1 : (-1)));
});
$p.jR = (function() {
  var this$2 = new $c_sci_$colon$colon("value", new $c_sci_$colon$colon("html", $m_sci_Nil$()));
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.p()) {
    var elem = it.q();
    var unboxedElem = ((elem === null) ? null : elem);
    jsElems.push(unboxedElem);
  }
  return new ($d_T.r().C)(jsElems);
});
$p.k1 = (function(x) {
  x.a2(1, false);
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq$$anon$4 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_ast_AttrEq$$anon$4, "org.jpablo.graphexplorer.viewer.formats.dot.ast.AttrEq$$anon$4", ({
  Ad: 1,
  ai: 1,
  ag: 1,
  x: 1,
  D: 1,
  J: 1,
  K: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$$anon$1(ReadersVersionSpecific_this$1, paramCount$1, outer) {
  this.ic = null;
  this.gQ = 0;
  this.iO = 0;
  this.iP = 0;
  this.iM = false;
  this.iN = null;
  this.iI = null;
  this.iJ = false;
  this.iK = false;
  this.iL = false;
  this.jh = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$1 <= 64)) {
    if ((paramCount$1 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$1) === 0) ? (1 << paramCount$1) : 0);
      var hi = (((32 & paramCount$1) === 0) ? 0 : (1 << paramCount$1));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$1 >> 31);
    var $x_1_$_lo = paramCount$1;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$1, paramCount$1, $x_1_$_lo, $x_1_$_hi, $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$().b5T(ReadersVersionSpecific_this$1), $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$().b5U());
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$$anon$1.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$$anon$1.prototype = $p;
$p.k3 = (function() {
  var this$7 = $m_sci_Nil$().b6($m_sr_ScalaRunTime$().f(new $ac_O([$m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$().a0M, $f_Lupickle_implicits_Readers__MapReader2__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lorg_jpablo_graphexplorer_viewer_models_ArrowId$().Pp(), $m_Lorg_jpablo_graphexplorer_viewer_models_Arrow$().bm()), $f_Lupickle_implicits_Readers__MapReader2__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$().bm(), $m_Lorg_jpablo_graphexplorer_viewer_models_GroupId$().oC()), $f_Lupickle_implicits_Readers__MapReader2__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lorg_jpablo_graphexplorer_viewer_models_ArrowId$().Pp(), $m_Lorg_jpablo_graphexplorer_viewer_models_GroupId$().oC()), $f_Lupickle_implicits_Readers__MapReader2__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lorg_jpablo_graphexplorer_viewer_models_GroupId$().oC(), $m_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$().bm()), $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().lW(), $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().lW(), $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().lW()])));
  if ((this$7.V() >= 0)) {
    var destination = new $ac_O(this$7.V());
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$7, destination, 0, 2147483647);
    var $x_1 = destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = this$7.o();
    while (it.p()) {
      var elem = it.q();
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem);
    }
    var $x_1 = new $ac_O(jsElems);
  }
  return new $c_T2(null, $x_1);
});
$p.jV = (function(x) {
  switch (x) {
    case "nodes": {
      return 0;
      break;
    }
    case "arrows": {
      return 1;
      break;
    }
    case "memberships": {
      return 2;
      break;
    }
    case "arrowMemberships": {
      return 3;
      break;
    }
    case "groups": {
      return 4;
      break;
    }
    case "graphAttributes": {
      return 5;
      break;
    }
    case "defaultNodeAttributes": {
      return 6;
      break;
    }
    case "defaultArrowAttributes": {
      return 7;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.jR = (function() {
  var this$3 = $m_sci_Nil$().b6($m_sr_ScalaRunTime$().f(new ($d_T.r().C)(["nodes", "arrows", "memberships", "arrowMemberships", "groups", "graphAttributes", "defaultNodeAttributes", "defaultArrowAttributes"])));
  if ((this$3.V() >= 0)) {
    var destination = new ($d_T.r().C)(this$3.V());
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$3, destination, 0, 2147483647);
    return destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = this$3.o();
    while (it.p()) {
      var elem = it.q();
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem);
    }
    return new ($d_T.r().C)(jsElems);
  }
});
$p.k1 = (function(x) {
  x.a2(0, ($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$(), $m_sci_VectorMap$().jg));
  x.a2(1, ($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$(), $m_sci_Map$EmptyMap$()));
  x.a2(2, ($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$(), $m_sci_Map$EmptyMap$()));
  x.a2(3, ($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$(), $m_sci_Map$EmptyMap$()));
  x.a2(4, ($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$(), $m_sci_Map$EmptyMap$()));
  x.a2(5, new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$(), $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV)));
  x.a2(6, new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$(), $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV)));
  x.a2(7, new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$(), $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV)));
});
var $d_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$$anon$1, "org.jpablo.graphexplorer.viewer.graph.ViewerGraphElements$$anon$1", ({
  CD: 1,
  ai: 1,
  ag: 1,
  x: 1,
  D: 1,
  J: 1,
  K: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_Arrow$$anon$4(ReadersVersionSpecific_this$4, paramCount$2, outer) {
  this.ic = null;
  this.gQ = 0;
  this.iO = 0;
  this.iP = 0;
  this.iM = false;
  this.iN = null;
  this.iI = null;
  this.iJ = false;
  this.iK = false;
  this.iL = false;
  this.jh = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$2 <= 64)) {
    if ((paramCount$2 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$2) === 0) ? (1 << paramCount$2) : 0);
      var hi = (((32 & paramCount$2) === 0) ? 0 : (1 << paramCount$2));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$2 >> 31);
    var $x_1_$_lo = paramCount$2;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$4, paramCount$2, $x_1_$_lo, $x_1_$_hi, $m_Lorg_jpablo_graphexplorer_viewer_models_Arrow$().b5V(ReadersVersionSpecific_this$4), $m_Lorg_jpablo_graphexplorer_viewer_models_Arrow$().b5W());
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_Arrow$$anon$4.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_Arrow$$anon$4;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_Arrow$$anon$4() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_Arrow$$anon$4.prototype = $p;
$p.k3 = (function() {
  var this$4 = new $c_sci_$colon$colon($m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$().An(), new $c_sci_$colon$colon($m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$().An(), new $c_sci_$colon$colon($m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().lW(), new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), new $c_sci_$colon$colon($m_Lupickle_default$().pk, $m_sci_Nil$()))))));
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$4);
  while (it.p()) {
    var elem = it.q();
    var unboxedElem = ((elem === null) ? null : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2(null, new $ac_O(jsElems));
});
$p.jV = (function(x) {
  switch (x) {
    case "source": {
      return 0;
      break;
    }
    case "target": {
      return 1;
      break;
    }
    case "attributes": {
      return 2;
      break;
    }
    case "sourcePort": {
      return 3;
      break;
    }
    case "targetPort": {
      return 4;
      break;
    }
    case "seq": {
      return 5;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.jR = (function() {
  var this$2 = new $c_sci_$colon$colon("source", new $c_sci_$colon$colon("target", new $c_sci_$colon$colon("attributes", new $c_sci_$colon$colon("sourcePort", new $c_sci_$colon$colon("targetPort", new $c_sci_$colon$colon("seq", $m_sci_Nil$()))))));
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.p()) {
    var elem = it.q();
    var unboxedElem = ((elem === null) ? null : elem);
    jsElems.push(unboxedElem);
  }
  return new ($d_T.r().C)(jsElems);
});
$p.k1 = (function(x) {
  x.a2(2, new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(($m_Lorg_jpablo_graphexplorer_viewer_models_Arrow$(), $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV)));
  x.a2(3, ($m_Lorg_jpablo_graphexplorer_viewer_models_Arrow$(), $m_s_None$()));
  x.a2(4, ($m_Lorg_jpablo_graphexplorer_viewer_models_Arrow$(), $m_s_None$()));
  x.a2(5, ($m_Lorg_jpablo_graphexplorer_viewer_models_Arrow$(), 1));
});
var $d_Lorg_jpablo_graphexplorer_viewer_models_Arrow$$anon$4 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_Arrow$$anon$4, "org.jpablo.graphexplorer.viewer.models.Arrow$$anon$4", ({
  D3: 1,
  ai: 1,
  ag: 1,
  x: 1,
  D: 1,
  J: 1,
  K: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_ElementId$$anon$1(ReadersVersionSpecific_this$4, paramCount$1, outer) {
  this.ic = null;
  this.gQ = 0;
  this.iO = 0;
  this.iP = 0;
  this.iM = false;
  this.iN = null;
  this.iI = null;
  this.iJ = false;
  this.iK = false;
  this.iL = false;
  this.jh = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$1 <= 64)) {
    if ((paramCount$1 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$1) === 0) ? (1 << paramCount$1) : 0);
      var hi = (((32 & paramCount$1) === 0) ? 0 : (1 << paramCount$1));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$1 >> 31);
    var $x_1_$_lo = paramCount$1;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$4, paramCount$1, $x_1_$_lo, $x_1_$_hi, $m_Lorg_jpablo_graphexplorer_viewer_models_ElementId$().b5X(ReadersVersionSpecific_this$4), $m_Lorg_jpablo_graphexplorer_viewer_models_ElementId$().b5Y());
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_ElementId$$anon$1.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_ElementId$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_ElementId$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_ElementId$$anon$1.prototype = $p;
$p.k3 = (function() {
  var this$2 = new $c_sci_$colon$colon($m_Lupickle_default$().a5, $m_sci_Nil$());
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.p()) {
    var elem = it.q();
    var unboxedElem = ((elem === null) ? null : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2(null, new $ac_O(jsElems));
});
$p.jV = (function(x) {
  return ((x === "value") ? 0 : (-1));
});
$p.jR = (function() {
  var this$2 = new $c_sci_$colon$colon("value", $m_sci_Nil$());
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.p()) {
    var elem = it.q();
    var unboxedElem = ((elem === null) ? null : elem);
    jsElems.push(unboxedElem);
  }
  return new ($d_T.r().C)(jsElems);
});
$p.k1 = (function(x) {
});
var $d_Lorg_jpablo_graphexplorer_viewer_models_ElementId$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_ElementId$$anon$1, "org.jpablo.graphexplorer.viewer.models.ElementId$$anon$1", ({
  Dj: 1,
  ai: 1,
  ag: 1,
  x: 1,
  D: 1,
  J: 1,
  K: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$$anon$3(ReadersVersionSpecific_this$11, paramCount$2, outer) {
  this.ic = null;
  this.gQ = 0;
  this.iO = 0;
  this.iP = 0;
  this.iM = false;
  this.iN = null;
  this.iI = null;
  this.iJ = false;
  this.iK = false;
  this.iL = false;
  this.jh = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$2 <= 64)) {
    if ((paramCount$2 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$2) === 0) ? (1 << paramCount$2) : 0);
      var hi = (((32 & paramCount$2) === 0) ? 0 : (1 << paramCount$2));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$2 >> 31);
    var $x_1_$_lo = paramCount$2;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$11, paramCount$2, $x_1_$_lo, $x_1_$_hi, $m_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$().b5Z(ReadersVersionSpecific_this$11), $m_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$().b60());
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$$anon$3.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$$anon$3;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$$anon$3() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$$anon$3.prototype = $p;
$p.k3 = (function() {
  var this$2 = new $c_sci_$colon$colon($m_Lupickle_default$().a5, $m_sci_Nil$());
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.p()) {
    var elem = it.q();
    var unboxedElem = ((elem === null) ? null : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2(null, new $ac_O(jsElems));
});
$p.jV = (function(x) {
  return ((x === "value") ? 0 : (-1));
});
$p.jR = (function() {
  var this$2 = new $c_sci_$colon$colon("value", $m_sci_Nil$());
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.p()) {
    var elem = it.q();
    var unboxedElem = ((elem === null) ? null : elem);
    jsElems.push(unboxedElem);
  }
  return new ($d_T.r().C)(jsElems);
});
$p.k1 = (function(x) {
});
var $d_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$$anon$3 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$$anon$3, "org.jpablo.graphexplorer.viewer.models.GroupMemberId$$anon$3", ({
  Dp: 1,
  ai: 1,
  ag: 1,
  x: 1,
  D: 1,
  J: 1,
  K: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$$anon$4(ReadersVersionSpecific_this$16, paramCount$3, outer) {
  this.ic = null;
  this.gQ = 0;
  this.iO = 0;
  this.iP = 0;
  this.iM = false;
  this.iN = null;
  this.iI = null;
  this.iJ = false;
  this.iK = false;
  this.iL = false;
  this.jh = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$3 <= 64)) {
    if ((paramCount$3 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$3) === 0) ? (1 << paramCount$3) : 0);
      var hi = (((32 & paramCount$3) === 0) ? 0 : (1 << paramCount$3));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$3 >> 31);
    var $x_1_$_lo = paramCount$3;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$16, paramCount$3, $x_1_$_lo, $x_1_$_hi, $m_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$().b61(ReadersVersionSpecific_this$16), $m_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$().b62());
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$$anon$4.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$$anon$4;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$$anon$4() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$$anon$4.prototype = $p;
$p.k3 = (function() {
  var this$2 = new $c_sci_$colon$colon($m_Lupickle_default$().a5, $m_sci_Nil$());
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.p()) {
    var elem = it.q();
    var unboxedElem = ((elem === null) ? null : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2(null, new $ac_O(jsElems));
});
$p.jV = (function(x) {
  return ((x === "value") ? 0 : (-1));
});
$p.jR = (function() {
  var this$2 = new $c_sci_$colon$colon("value", $m_sci_Nil$());
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.p()) {
    var elem = it.q();
    var unboxedElem = ((elem === null) ? null : elem);
    jsElems.push(unboxedElem);
  }
  return new ($d_T.r().C)(jsElems);
});
$p.k1 = (function(x) {
});
var $d_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$$anon$4 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$$anon$4, "org.jpablo.graphexplorer.viewer.models.GroupMemberId$$anon$4", ({
  Dq: 1,
  ai: 1,
  ag: 1,
  x: 1,
  D: 1,
  J: 1,
  K: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$$anon$6(ReadersVersionSpecific_this$7, paramCount$3, outer) {
  this.ic = null;
  this.gQ = 0;
  this.iO = 0;
  this.iP = 0;
  this.iM = false;
  this.iN = null;
  this.iI = null;
  this.iJ = false;
  this.iK = false;
  this.iL = false;
  this.jh = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$3 <= 64)) {
    if ((paramCount$3 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$3) === 0) ? (1 << paramCount$3) : 0);
      var hi = (((32 & paramCount$3) === 0) ? 0 : (1 << paramCount$3));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$3 >> 31);
    var $x_1_$_lo = paramCount$3;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$7, paramCount$3, $x_1_$_lo, $x_1_$_hi, $m_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$().b63(ReadersVersionSpecific_this$7), $m_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$().b64());
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$$anon$6.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$$anon$6;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$$anon$6() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$$anon$6.prototype = $p;
$p.k3 = (function() {
  var this$2 = new $c_sci_$colon$colon($m_Lorg_jpablo_graphexplorer_viewer_models_GroupId$().oC(), new $c_sci_$colon$colon($m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().lW(), $m_sci_Nil$()));
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.p()) {
    var elem = it.q();
    var unboxedElem = ((elem === null) ? null : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2(null, new $ac_O(jsElems));
});
$p.jV = (function(x) {
  return ((x === "id") ? 0 : ((x === "attributes") ? 1 : (-1)));
});
$p.jR = (function() {
  var this$2 = new $c_sci_$colon$colon("id", new $c_sci_$colon$colon("attributes", $m_sci_Nil$()));
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.p()) {
    var elem = it.q();
    var unboxedElem = ((elem === null) ? null : elem);
    jsElems.push(unboxedElem);
  }
  return new ($d_T.r().C)(jsElems);
});
$p.k1 = (function(x) {
  x.a2(1, new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(($m_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$(), $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV)));
});
var $d_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$$anon$6 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$$anon$6, "org.jpablo.graphexplorer.viewer.models.ViewerGroup$$anon$6", ({
  Dv: 1,
  ai: 1,
  ag: 1,
  x: 1,
  D: 1,
  J: 1,
  K: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$$anon$1(ReadersVersionSpecific_this$1, paramCount$1, outer) {
  this.ic = null;
  this.gQ = 0;
  this.iO = 0;
  this.iP = 0;
  this.iM = false;
  this.iN = null;
  this.iI = null;
  this.iJ = false;
  this.iK = false;
  this.iL = false;
  this.jh = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$1 <= 64)) {
    if ((paramCount$1 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$1) === 0) ? (1 << paramCount$1) : 0);
      var hi = (((32 & paramCount$1) === 0) ? 0 : (1 << paramCount$1));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$1 >> 31);
    var $x_1_$_lo = paramCount$1;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$1, paramCount$1, $x_1_$_lo, $x_1_$_hi, $m_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$().b65(ReadersVersionSpecific_this$1), $m_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$().b66());
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$$anon$1.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$$anon$1.prototype = $p;
$p.k3 = (function() {
  var this$3 = new $c_sci_$colon$colon($m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$().An(), new $c_sci_$colon$colon($m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().lW(), new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $m_sci_Nil$())));
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.p()) {
    var elem = it.q();
    var unboxedElem = ((elem === null) ? null : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2(null, new $ac_O(jsElems));
});
$p.jV = (function(x) {
  switch (x) {
    case "id": {
      return 0;
      break;
    }
    case "attributes": {
      return 1;
      break;
    }
    case "kind": {
      return 2;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.jR = (function() {
  var this$2 = new $c_sci_$colon$colon("id", new $c_sci_$colon$colon("attributes", new $c_sci_$colon$colon("kind", $m_sci_Nil$())));
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.p()) {
    var elem = it.q();
    var unboxedElem = ((elem === null) ? null : elem);
    jsElems.push(unboxedElem);
  }
  return new ($d_T.r().C)(jsElems);
});
$p.k1 = (function(x) {
  x.a2(1, new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(($m_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$(), $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV)));
  x.a2(2, ($m_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$(), $m_s_None$()));
});
var $d_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$$anon$1, "org.jpablo.graphexplorer.viewer.models.ViewerNode$$anon$1", ({
  Dy: 1,
  ai: 1,
  ag: 1,
  x: 1,
  D: 1,
  J: 1,
  K: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$$anon$2(ReadersVersionSpecific_this$1, paramCount$1, outer) {
  this.ic = null;
  this.gQ = 0;
  this.iO = 0;
  this.iP = 0;
  this.iM = false;
  this.iN = null;
  this.iI = null;
  this.iJ = false;
  this.iK = false;
  this.iL = false;
  this.jh = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$1 <= 64)) {
    if ((paramCount$1 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$1) === 0) ? (1 << paramCount$1) : 0);
      var hi = (((32 & paramCount$1) === 0) ? 0 : (1 << paramCount$1));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$1 >> 31);
    var $x_1_$_lo = paramCount$1;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$1, paramCount$1, $x_1_$_lo, $x_1_$_hi, $m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$().b68(ReadersVersionSpecific_this$1), $m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$().b69());
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$$anon$2.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$$anon$2.prototype = $p;
$p.k3 = (function() {
  var this$7 = new $c_sci_$colon$colon($m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().ahN(), new $c_sci_$colon$colon(new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lorg_jpablo_graphexplorer_viewer_models_GroupId$().oC(), new $c_sc_IterableFactory$ToFactory($m_sci_Set$())), new $c_sci_$colon$colon($m_Lupickle_default$().a5, new $c_sci_$colon$colon($m_Lupickle_default$().a5, new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().ow), $m_sci_Nil$()))))));
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$7);
  while (it.p()) {
    var elem = it.q();
    var unboxedElem = ((elem === null) ? null : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2(null, new $ac_O(jsElems));
});
$p.jV = (function(x) {
  switch (x) {
    case "hiddenElements": {
      return 0;
      break;
    }
    case "collapsedGroups": {
      return 1;
      break;
    }
    case "projectName": {
      return 2;
      break;
    }
    case "source": {
      return 3;
      break;
    }
    case "format": {
      return 4;
      break;
    }
    case "autoDetectFormat": {
      return 5;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.jR = (function() {
  var this$2 = new $c_sci_$colon$colon("hiddenElements", new $c_sci_$colon$colon("collapsedGroups", new $c_sci_$colon$colon("projectName", new $c_sci_$colon$colon("source", new $c_sci_$colon$colon("format", new $c_sci_$colon$colon("autoDetectFormat", $m_sci_Nil$()))))));
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.p()) {
    var elem = it.q();
    var unboxedElem = ((elem === null) ? null : elem);
    jsElems.push(unboxedElem);
  }
  return new ($d_T.r().C)(jsElems);
});
$p.k1 = (function(x) {
  x.a2(0, new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds(($m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$(), $m_sci_Set$EmptySet$())));
  x.a2(1, ($m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$(), $m_sci_Set$EmptySet$()));
  x.a2(2, ($m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$(), ""));
  x.a2(3, ($m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$(), ""));
  x.a2(4, ($m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$(), $m_s_None$()));
  x.a2(5, ($m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$(), $m_s_None$()));
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$$anon$2, "org.jpablo.graphexplorer.viewer.state.PersistedDiagramState$$anon$2", ({
  Ee: 1,
  ai: 1,
  ag: 1,
  x: 1,
  D: 1,
  J: 1,
  K: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_ProjectId$$anon$1(ReadersVersionSpecific_this$1, paramCount$1, outer) {
  this.ic = null;
  this.gQ = 0;
  this.iO = 0;
  this.iP = 0;
  this.iM = false;
  this.iN = null;
  this.iI = null;
  this.iJ = false;
  this.iK = false;
  this.iL = false;
  this.jh = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$1 <= 64)) {
    if ((paramCount$1 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$1) === 0) ? (1 << paramCount$1) : 0);
      var hi = (((32 & paramCount$1) === 0) ? 0 : (1 << paramCount$1));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$1 >> 31);
    var $x_1_$_lo = paramCount$1;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$1, paramCount$1, $x_1_$_lo, $x_1_$_hi, $m_Lorg_jpablo_graphexplorer_viewer_state_ProjectId$().b6a(ReadersVersionSpecific_this$1), $m_Lorg_jpablo_graphexplorer_viewer_state_ProjectId$().b6b());
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_ProjectId$$anon$1.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_ProjectId$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_ProjectId$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_ProjectId$$anon$1.prototype = $p;
$p.k3 = (function() {
  var this$2 = new $c_sci_$colon$colon($m_Lupickle_default$().a5, $m_sci_Nil$());
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.p()) {
    var elem = it.q();
    var unboxedElem = ((elem === null) ? null : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2(null, new $ac_O(jsElems));
});
$p.jV = (function(x) {
  return ((x === "value") ? 0 : (-1));
});
$p.jR = (function() {
  var this$2 = new $c_sci_$colon$colon("value", $m_sci_Nil$());
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.p()) {
    var elem = it.q();
    var unboxedElem = ((elem === null) ? null : elem);
    jsElems.push(unboxedElem);
  }
  return new ($d_T.r().C)(jsElems);
});
$p.k1 = (function(x) {
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_ProjectId$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_ProjectId$$anon$1, "org.jpablo.graphexplorer.viewer.state.ProjectId$$anon$1", ({
  Ei: 1,
  ai: 1,
  ag: 1,
  x: 1,
  D: 1,
  J: 1,
  K: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$$anon$4(ReadersVersionSpecific_this$4, paramCount$2, outer) {
  this.ic = null;
  this.gQ = 0;
  this.iO = 0;
  this.iP = 0;
  this.iM = false;
  this.iN = null;
  this.iI = null;
  this.iJ = false;
  this.iK = false;
  this.iL = false;
  this.jh = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$2 <= 64)) {
    if ((paramCount$2 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$2) === 0) ? (1 << paramCount$2) : 0);
      var hi = (((32 & paramCount$2) === 0) ? 0 : (1 << paramCount$2));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$2 >> 31);
    var $x_1_$_lo = paramCount$2;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$4, paramCount$2, $x_1_$_lo, $x_1_$_hi, $m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$().b6d(ReadersVersionSpecific_this$4), $m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$().b6e());
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$$anon$4.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V2();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$$anon$4;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$$anon$4() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$$anon$4.prototype = $p;
$p.k3 = (function() {
  var this$8 = $m_sci_Nil$().b6($m_sr_ScalaRunTime$().f(new $ac_O([$m_Lupickle_default$().ow, $m_Lupickle_default$().pk, $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $m_Lupickle_default$().ow, $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().pk), $m_Lupickle_default$().ow, $m_Lupickle_default$().ow, $m_Lupickle_default$().ow, $m_Lupickle_default$().ow, $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $m_Lupickle_default$().ow, $m_Lupickle_default$().ow, $m_Lupickle_default$().ow, $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().a5), $m_Lupickle_default$().pk])));
  if ((this$8.V() >= 0)) {
    var destination = new $ac_O(this$8.V());
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$8, destination, 0, 2147483647);
    var $x_1 = destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = this$8.o();
    while (it.p()) {
      var elem = it.q();
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem);
    }
    var $x_1 = new $ac_O(jsElems);
  }
  return new $c_T2(null, $x_1);
});
$p.jV = (function(x) {
  switch (x) {
    case "leftPanelVisible": {
      return 0;
      break;
    }
    case "rightPanelTabIndex": {
      return 1;
      break;
    }
    case "currentTheme": {
      return 2;
      break;
    }
    case "promptLabelBeforeNewNode": {
      return 3;
      break;
    }
    case "rightPanelWidth": {
      return 4;
      break;
    }
    case "wrapSourceLines": {
      return 5;
      break;
    }
    case "elementsPinned": {
      return 6;
      break;
    }
    case "view3D": {
      return 7;
      break;
    }
    case "enable3D": {
      return 8;
      break;
    }
    case "layout3D": {
      return 9;
      break;
    }
    case "nav3DTrackpad": {
      return 10;
      break;
    }
    case "label3DBillboard": {
      return 11;
      break;
    }
    case "libraryListMode": {
      return 12;
      break;
    }
    case "librarySort": {
      return 13;
      break;
    }
    case "libraryFormatFilter": {
      return 14;
      break;
    }
    case "schemaVersion": {
      return 15;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.jR = (function() {
  var this$3 = $m_sci_Nil$().b6($m_sr_ScalaRunTime$().f(new ($d_T.r().C)(["leftPanelVisible", "rightPanelTabIndex", "currentTheme", "promptLabelBeforeNewNode", "rightPanelWidth", "wrapSourceLines", "elementsPinned", "view3D", "enable3D", "layout3D", "nav3DTrackpad", "label3DBillboard", "libraryListMode", "librarySort", "libraryFormatFilter", "schemaVersion"])));
  if ((this$3.V() >= 0)) {
    var destination = new ($d_T.r().C)(this$3.V());
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$3, destination, 0, 2147483647);
    return destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = this$3.o();
    while (it.p()) {
      var elem = it.q();
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem);
    }
    return new ($d_T.r().C)(jsElems);
  }
});
$p.k1 = (function(x) {
  x.a2(0, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), true));
  x.a2(1, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), 0));
  x.a2(2, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), $m_s_None$()));
  x.a2(3, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), true));
  x.a2(4, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), $m_s_None$()));
  x.a2(5, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), false));
  x.a2(6, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), false));
  x.a2(7, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), false));
  x.a2(8, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), false));
  x.a2(9, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), $m_s_None$()));
  x.a2(10, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), true));
  x.a2(11, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), false));
  x.a2(12, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), false));
  x.a2(13, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), $m_s_None$()));
  x.a2(14, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), $m_s_None$()));
  x.a2(15, ($m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$(), $m_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$().H2));
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$$anon$4 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_ViewerSettings$$anon$4, "org.jpablo.graphexplorer.viewer.state.ViewerSettings$$anon$4", ({
  EF: 1,
  ai: 1,
  ag: 1,
  x: 1,
  D: 1,
  J: 1,
  K: 1
}));
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcB$sp(xs$mcB$sp) {
  this.qv = null;
  this.cG = 0;
  this.p6 = 0;
  this.abR = null;
  this.abR = xs$mcB$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcB$sp);
}
$p = $c_sc_ArrayOps$ArrayIterator$mcB$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$p.constructor = $c_sc_ArrayOps$ArrayIterator$mcB$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcB$sp() {
}
$h_sc_ArrayOps$ArrayIterator$mcB$sp.prototype = $p;
$p.b4S = (function() {
  if ((this.cG >= this.abR.a.length)) {
    $m_sc_Iterator$().b8.q();
  }
  var r = this.abR.a[this.cG];
  this.cG = ((1 + this.cG) | 0);
  return r;
});
$p.q = (function() {
  return this.b4S();
});
var $d_sc_ArrayOps$ArrayIterator$mcB$sp = new $TypeData().i($c_sc_ArrayOps$ArrayIterator$mcB$sp, "scala.collection.ArrayOps$ArrayIterator$mcB$sp", ({
  Gv: 1,
  b0: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1,
  a: 1
}));
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcC$sp(xs$mcC$sp) {
  this.qv = null;
  this.cG = 0;
  this.p6 = 0;
  this.abS = null;
  this.abS = xs$mcC$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcC$sp);
}
$p = $c_sc_ArrayOps$ArrayIterator$mcC$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$p.constructor = $c_sc_ArrayOps$ArrayIterator$mcC$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcC$sp() {
}
$h_sc_ArrayOps$ArrayIterator$mcC$sp.prototype = $p;
$p.b4T = (function() {
  if ((this.cG >= this.abS.a.length)) {
    $m_sc_Iterator$().b8.q();
  }
  var r = this.abS.a[this.cG];
  this.cG = ((1 + this.cG) | 0);
  return r;
});
$p.q = (function() {
  return $bC(this.b4T());
});
var $d_sc_ArrayOps$ArrayIterator$mcC$sp = new $TypeData().i($c_sc_ArrayOps$ArrayIterator$mcC$sp, "scala.collection.ArrayOps$ArrayIterator$mcC$sp", ({
  Gw: 1,
  b0: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1,
  a: 1
}));
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcD$sp(xs$mcD$sp) {
  this.qv = null;
  this.cG = 0;
  this.p6 = 0;
  this.abT = null;
  this.abT = xs$mcD$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcD$sp);
}
$p = $c_sc_ArrayOps$ArrayIterator$mcD$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$p.constructor = $c_sc_ArrayOps$ArrayIterator$mcD$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcD$sp() {
}
$h_sc_ArrayOps$ArrayIterator$mcD$sp.prototype = $p;
$p.b4U = (function() {
  if ((this.cG >= this.abT.a.length)) {
    $m_sc_Iterator$().b8.q();
  }
  var r = this.abT.a[this.cG];
  this.cG = ((1 + this.cG) | 0);
  return r;
});
$p.q = (function() {
  return this.b4U();
});
var $d_sc_ArrayOps$ArrayIterator$mcD$sp = new $TypeData().i($c_sc_ArrayOps$ArrayIterator$mcD$sp, "scala.collection.ArrayOps$ArrayIterator$mcD$sp", ({
  Gx: 1,
  b0: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1,
  a: 1
}));
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcF$sp(xs$mcF$sp) {
  this.qv = null;
  this.cG = 0;
  this.p6 = 0;
  this.abU = null;
  this.abU = xs$mcF$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcF$sp);
}
$p = $c_sc_ArrayOps$ArrayIterator$mcF$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$p.constructor = $c_sc_ArrayOps$ArrayIterator$mcF$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcF$sp() {
}
$h_sc_ArrayOps$ArrayIterator$mcF$sp.prototype = $p;
$p.b4V = (function() {
  if ((this.cG >= this.abU.a.length)) {
    $m_sc_Iterator$().b8.q();
  }
  var r = this.abU.a[this.cG];
  this.cG = ((1 + this.cG) | 0);
  return r;
});
$p.q = (function() {
  return this.b4V();
});
var $d_sc_ArrayOps$ArrayIterator$mcF$sp = new $TypeData().i($c_sc_ArrayOps$ArrayIterator$mcF$sp, "scala.collection.ArrayOps$ArrayIterator$mcF$sp", ({
  Gy: 1,
  b0: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1,
  a: 1
}));
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcI$sp(xs$mcI$sp) {
  this.qv = null;
  this.cG = 0;
  this.p6 = 0;
  this.abV = null;
  this.abV = xs$mcI$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcI$sp);
}
$p = $c_sc_ArrayOps$ArrayIterator$mcI$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$p.constructor = $c_sc_ArrayOps$ArrayIterator$mcI$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcI$sp() {
}
$h_sc_ArrayOps$ArrayIterator$mcI$sp.prototype = $p;
$p.b4W = (function() {
  if ((this.cG >= this.abV.a.length)) {
    $m_sc_Iterator$().b8.q();
  }
  var r = this.abV.a[this.cG];
  this.cG = ((1 + this.cG) | 0);
  return r;
});
$p.q = (function() {
  return this.b4W();
});
var $d_sc_ArrayOps$ArrayIterator$mcI$sp = new $TypeData().i($c_sc_ArrayOps$ArrayIterator$mcI$sp, "scala.collection.ArrayOps$ArrayIterator$mcI$sp", ({
  Gz: 1,
  b0: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1,
  a: 1
}));
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcJ$sp(xs$mcJ$sp) {
  this.qv = null;
  this.cG = 0;
  this.p6 = 0;
  this.abW = null;
  this.abW = xs$mcJ$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcJ$sp);
}
$p = $c_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$p.constructor = $c_sc_ArrayOps$ArrayIterator$mcJ$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcJ$sp() {
}
$h_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype = $p;
$p.b4X = (function() {
  if ((this.cG >= ((this.abW.a.length >>> 1) | 0))) {
    $m_sc_Iterator$().b8.q();
  }
  var $x_1 = this.abW.a;
  var $x_2 = (this.cG << 1);
  var r_$_lo = $x_1[$x_2];
  var r_$_hi = $x_1[(($x_2 + 1) | 0)];
  this.cG = ((1 + this.cG) | 0);
  return $bL(r_$_lo, r_$_hi);
});
$p.q = (function() {
  return this.b4X();
});
var $d_sc_ArrayOps$ArrayIterator$mcJ$sp = new $TypeData().i($c_sc_ArrayOps$ArrayIterator$mcJ$sp, "scala.collection.ArrayOps$ArrayIterator$mcJ$sp", ({
  GA: 1,
  b0: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1,
  a: 1
}));
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcS$sp(xs$mcS$sp) {
  this.qv = null;
  this.cG = 0;
  this.p6 = 0;
  this.abX = null;
  this.abX = xs$mcS$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcS$sp);
}
$p = $c_sc_ArrayOps$ArrayIterator$mcS$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$p.constructor = $c_sc_ArrayOps$ArrayIterator$mcS$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcS$sp() {
}
$h_sc_ArrayOps$ArrayIterator$mcS$sp.prototype = $p;
$p.b4Y = (function() {
  if ((this.cG >= this.abX.a.length)) {
    $m_sc_Iterator$().b8.q();
  }
  var r = this.abX.a[this.cG];
  this.cG = ((1 + this.cG) | 0);
  return r;
});
$p.q = (function() {
  return this.b4Y();
});
var $d_sc_ArrayOps$ArrayIterator$mcS$sp = new $TypeData().i($c_sc_ArrayOps$ArrayIterator$mcS$sp, "scala.collection.ArrayOps$ArrayIterator$mcS$sp", ({
  GB: 1,
  b0: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1,
  a: 1
}));
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcV$sp(xs$mcV$sp) {
  this.qv = null;
  this.cG = 0;
  this.p6 = 0;
  this.aHu = null;
  this.aHu = xs$mcV$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcV$sp);
}
$p = $c_sc_ArrayOps$ArrayIterator$mcV$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$p.constructor = $c_sc_ArrayOps$ArrayIterator$mcV$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcV$sp() {
}
$h_sc_ArrayOps$ArrayIterator$mcV$sp.prototype = $p;
$p.b4Z = (function() {
  if ((this.cG >= this.aHu.a.length)) {
    $m_sc_Iterator$().b8.q();
  }
  this.cG = ((1 + this.cG) | 0);
});
$p.q = (function() {
  this.b4Z();
});
var $d_sc_ArrayOps$ArrayIterator$mcV$sp = new $TypeData().i($c_sc_ArrayOps$ArrayIterator$mcV$sp, "scala.collection.ArrayOps$ArrayIterator$mcV$sp", ({
  GC: 1,
  b0: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1,
  a: 1
}));
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcZ$sp(xs$mcZ$sp) {
  this.qv = null;
  this.cG = 0;
  this.p6 = 0;
  this.abY = null;
  this.abY = xs$mcZ$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcZ$sp);
}
$p = $c_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$p.constructor = $c_sc_ArrayOps$ArrayIterator$mcZ$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcZ$sp() {
}
$h_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype = $p;
$p.b50 = (function() {
  if ((this.cG >= this.abY.a.length)) {
    $m_sc_Iterator$().b8.q();
  }
  var r = this.abY.a[this.cG];
  this.cG = ((1 + this.cG) | 0);
  return r;
});
$p.q = (function() {
  return this.b50();
});
var $d_sc_ArrayOps$ArrayIterator$mcZ$sp = new $TypeData().i($c_sc_ArrayOps$ArrayIterator$mcZ$sp, "scala.collection.ArrayOps$ArrayIterator$mcZ$sp", ({
  GD: 1,
  b0: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1,
  a: 1
}));
/** @constructor */
function $c_sc_Iterable$$anon$1(a$1) {
  this.a1g = null;
  this.a1g = a$1;
}
$p = $c_sc_Iterable$$anon$1.prototype = new $h_sc_AbstractIterable();
$p.constructor = $c_sc_Iterable$$anon$1;
/** @constructor */
function $h_sc_Iterable$$anon$1() {
}
$h_sc_Iterable$$anon$1.prototype = $p;
$p.o = (function() {
  return new $c_sc_Iterator$$anon$20(this.a1g);
});
$p.V = (function() {
  return 1;
});
$p.b2z = (function() {
  return new $c_s_Some(this.a1g);
});
$p.bJ = (function() {
  return this.a1g;
});
$p.b08 = (function(n) {
  return ((n > 0) ? $m_sc_Iterable$().aO() : this);
});
$p.b0b = (function(n) {
  return ((n > 0) ? $m_sc_Iterable$().aO() : this);
});
$p.cn = (function(n) {
  return this.b0b(n);
});
$p.ds = (function(n) {
  return this.b08(n);
});
$p.dt = (function() {
  return this.b2z();
});
var $d_sc_Iterable$$anon$1 = new $TypeData().i($c_sc_Iterable$$anon$1, "scala.collection.Iterable$$anon$1", ({
  GT: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1
}));
function $f_sc_MapFactoryDefaults__empty__sc_IterableOps($thiz) {
  return (($thiz instanceof $c_sci_TreeSeqMap) ? $m_sci_TreeSeqMap$().afr($thiz.oo) : $thiz.im().aO());
}
function $f_sc_View__toString__T($thiz) {
  return ($thiz.hM() + "(<not computed>)");
}
function $is_sc_View(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.C)));
}
function $isArrayOf_sc_View(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.C)));
}
function $f_sci_IndexedSeqOps__slice__I__I__O($thiz, from, until) {
  return (((from <= 0) && (until >= $thiz.C())) ? $thiz : $f_sc_IndexedSeqOps__slice__I__I__O($thiz, from, until));
}
function $f_sci_MapOps__removedAll__sc_IterableOnce__sci_MapOps($thiz, keys) {
  var this$1 = keys.o();
  var f = ((x$2$2$2, x$3$2$2) => x$2$2$2.fz(x$3$2$2));
  if ($is_sc_IndexedSeq(this$1)) {
    var at = 0;
    var end = this$1.C();
    var acc = $thiz;
    var $x_1;
    while (true) {
      if ((at !== end)) {
        var temp$at = ((1 + at) | 0);
        var x0 = acc;
        var x1 = this$1.l(at);
        var temp$acc = f(x0, x1);
        at = temp$at;
        acc = temp$acc;
        continue;
      }
      var $x_1 = acc;
      break;
    }
  } else {
    var result = $thiz;
    while (this$1.p()) {
      var x0$1 = result;
      var x1$1 = this$1.q();
      result = f(x0$1, x1$1);
    }
    var $x_1 = result;
  }
  return $x_1;
}
function $f_sci_MapOps__updatedWith__O__F1__sci_MapOps($thiz, key, remappingFunction) {
  var previousValue = $thiz.r(key);
  var x1 = remappingFunction.i(previousValue);
  if (($m_s_None$() === x1)) {
    return (previousValue.c() ? $thiz : (previousValue.d(), $thiz.fz(key)));
  } else if ((x1 instanceof $c_s_Some)) {
    var nextValue = x1.J;
    return (((!previousValue.c()) && Object.is(previousValue.d(), nextValue)) ? $thiz : $thiz.bN(key, nextValue));
  } else {
    throw new $c_s_MatchError(x1);
  }
}
function $f_sci_MapOps__transform__F2__sci_MapOps($thiz, f) {
  return $thiz.kP(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x0$1$2$2) => {
    if ((x0$1$2$2 !== null)) {
      var k = x0$1$2$2.g();
      var v = x0$1$2$2.h();
      return new $c_T2(k, f.R(k, v));
    } else {
      throw new $c_s_MatchError(x0$1$2$2);
    }
  })));
}
/** @constructor */
function $c_sci_Set$Set2$$anon$1(outer) {
  this.zY = 0;
  this.xF = 0;
  this.aIo = null;
  this.aIo = outer;
  $ct_sci_Set$SetNIterator__I__(this, 2);
}
$p = $c_sci_Set$Set2$$anon$1.prototype = new $h_sci_Set$SetNIterator();
$p.constructor = $c_sci_Set$Set2$$anon$1;
/** @constructor */
function $h_sci_Set$Set2$$anon$1() {
}
$h_sci_Set$Set2$$anon$1.prototype = $p;
$p.l = (function(i) {
  return this.aIo.b88(i);
});
var $d_sci_Set$Set2$$anon$1 = new $TypeData().i($c_sci_Set$Set2$$anon$1, "scala.collection.immutable.Set$Set2$$anon$1", ({
  J1: 1,
  dM: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1,
  a: 1
}));
/** @constructor */
function $c_sci_Set$Set3$$anon$2(outer) {
  this.zY = 0;
  this.xF = 0;
  this.aIp = null;
  this.aIp = outer;
  $ct_sci_Set$SetNIterator__I__(this, 3);
}
$p = $c_sci_Set$Set3$$anon$2.prototype = new $h_sci_Set$SetNIterator();
$p.constructor = $c_sci_Set$Set3$$anon$2;
/** @constructor */
function $h_sci_Set$Set3$$anon$2() {
}
$h_sci_Set$Set3$$anon$2.prototype = $p;
$p.l = (function(i) {
  return this.aIp.b89(i);
});
var $d_sci_Set$Set3$$anon$2 = new $TypeData().i($c_sci_Set$Set3$$anon$2, "scala.collection.immutable.Set$Set3$$anon$2", ({
  J2: 1,
  dM: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1,
  a: 1
}));
/** @constructor */
function $c_sci_Set$Set4$$anon$3(outer) {
  this.zY = 0;
  this.xF = 0;
  this.aIq = null;
  this.aIq = outer;
  $ct_sci_Set$SetNIterator__I__(this, 4);
}
$p = $c_sci_Set$Set4$$anon$3.prototype = new $h_sci_Set$SetNIterator();
$p.constructor = $c_sci_Set$Set4$$anon$3;
/** @constructor */
function $h_sci_Set$Set4$$anon$3() {
}
$h_sci_Set$Set4$$anon$3.prototype = $p;
$p.l = (function(i) {
  return this.aIq.b8a(i);
});
var $d_sci_Set$Set4$$anon$3 = new $TypeData().i($c_sci_Set$Set4$$anon$3, "scala.collection.immutable.Set$Set4$$anon$3", ({
  J3: 1,
  dM: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1,
  a: 1
}));
/** @constructor */
function $c_sci_VectorMap$$anon$2(outer) {
  this.acP = null;
  this.acP = outer;
}
$p = $c_sci_VectorMap$$anon$2.prototype = new $h_O();
$p.constructor = $c_sci_VectorMap$$anon$2;
/** @constructor */
function $h_sci_VectorMap$$anon$2() {
}
$h_sci_VectorMap$$anon$2.prototype = $p;
$p.cd = (function() {
  return $m_sci_Iterable$();
});
$p.hM = (function() {
  return "Iterable";
});
$p.m = (function() {
  return $f_sc_Iterable__toString__T(this);
});
$p.fS = (function() {
  return $m_sci_Iterable$().b5();
});
$p.t = (function() {
  return this.o().q();
});
$p.dt = (function() {
  return $f_sc_IterableOps__headOption__s_Option(this);
});
$p.bJ = (function() {
  return $f_sc_IterableOps__last__O(this);
});
$p.nE = (function(otherSize) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, otherSize);
});
$p.bw = (function(pred) {
  return $f_sc_IterableOps__filter__F1__O(this, pred);
});
$p.cE = (function(pred) {
  return $f_sc_IterableOps__filterNot__F1__O(this, pred);
});
$p.un = (function(p) {
  return $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(new $c_sc_IterableOps$WithFilter(), this, p);
});
$p.uj = (function(p) {
  return $f_sc_IterableOps__takeWhile__F1__O(this, p);
});
$p.ds = (function(n) {
  return $f_sc_IterableOps__drop__I__O(this, n);
});
$p.cn = (function(n) {
  return $f_sc_IterableOps__dropRight__I__O(this, n);
});
$p.tW = (function(p) {
  return $f_sc_IterableOps__dropWhile__F1__O(this, p);
});
$p.L = (function(f) {
  return $f_sc_IterableOps__map__F1__O(this, f);
});
$p.c5 = (function(f) {
  return $f_sc_IterableOps__flatMap__F1__O(this, f);
});
$p.dk = (function(asIterable) {
  return $f_sc_IterableOps__flatMap__F1__O(this, asIterable);
});
$p.ct = (function(pf) {
  return $f_sc_IterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.fy = (function(f) {
  return $f_sc_IterableOps__partitionMap__F1__T2(this, f);
});
$p.g9 = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$p.fa = (function(asPair) {
  return $f_sc_IterableOps__unzip__F1__T2(this, asPair);
});
$p.F = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f);
});
$p.iW = (function(p) {
  return $f_sc_IterableOnceOps__find__F1__s_Option(this, p);
});
$p.hO = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$p.kT = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$p.c = (function() {
  return $f_sc_IterableOnceOps__isEmpty__Z(this);
});
$p.aa = (function() {
  return $f_sc_IterableOnceOps__size__I(this);
});
$p.cR = (function(dest, start, n) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, dest, start, n);
});
$p.k2 = (function(num) {
  return $f_sc_IterableOnceOps__sum__s_math_Numeric__O(this, num);
});
$p.lr = (function(ord) {
  return $f_sc_IterableOnceOps__min__s_math_Ordering__O(this, ord);
});
$p.lq = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord);
});
$p.nw = (function(pf) {
  return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this, pf);
});
$p.lf = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$p.bM = (function() {
  return $m_sci_Nil$().b6(this);
});
$p.d2 = (function() {
  return $m_sci_Vector$().X(this);
});
$p.eX = (function(ev) {
  return $m_sci_Map$().ao(this);
});
$p.iz = (function() {
  return $m_sci_Seq$().fw(this);
});
$p.nG = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$p.V = (function() {
  return (-1);
});
$p.o = (function() {
  return new $c_sc_Iterator$$anon$9(new $c_sc_MapOps$$anon$2(this.acP), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$4$2$2) => this.acP.l8.i(x$4$2$2).h())));
});
$p.fP = (function(coll) {
  return $m_sci_Iterable$().aOs(coll);
});
var $d_sci_VectorMap$$anon$2 = new $TypeData().i($c_sci_VectorMap$$anon$2, "scala.collection.immutable.VectorMap$$anon$2", ({
  Jq: 1,
  I: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1
}));
/** @constructor */
function $c_scm_ArrayBuilder$generic(elementClass) {
  this.acV = 0;
  this.aIz = 0;
  this.Oa = null;
  this.aIA = false;
  this.acW = null;
  this.Oa = elementClass;
  $ct_scm_ArrayBuilder__(this);
  this.aIA = (elementClass === $d_C.l());
  this.acW = [];
}
$p = $c_scm_ArrayBuilder$generic.prototype = new $h_scm_ArrayBuilder();
$p.constructor = $c_scm_ArrayBuilder$generic;
/** @constructor */
function $h_scm_ArrayBuilder$generic() {
}
$h_scm_ArrayBuilder$generic.prototype = $p;
$p.aLS = (function(elem) {
  var unboxedElem = (this.aIA ? $uC(elem) : ((elem === null) ? this.Oa.ba.z : elem));
  this.acW.push(unboxedElem);
  return this;
});
$p.aWA = (function(xs) {
  var it = xs.o();
  while (it.p()) {
    this.aLS(it.q());
  }
  return this;
});
$p.b7L = (function(size) {
});
$p.aR = (function() {
  var elemRuntimeClass = ((this.Oa === $d_V.l()) ? $d_jl_Void.l() : (((this.Oa === $d_sr_Null$.l()) || (this.Oa === $d_sr_Nothing$.l())) ? $d_O.l() : this.Oa));
  return elemRuntimeClass.ba.r().w(this.acW);
});
$p.m = (function() {
  return "ArrayBuilder.generic";
});
$p.dG = (function(elems) {
  return this.aWA(elems);
});
$p.Y = (function(elem) {
  return this.aLS(elem);
});
var $d_scm_ArrayBuilder$generic = new $TypeData().i($c_scm_ArrayBuilder$generic, "scala.collection.mutable.ArrayBuilder$generic", ({
  Jz: 1,
  Jy: 1,
  b2: 1,
  Y: 1,
  T: 1,
  S: 1,
  a: 1
}));
function $f_scm_ArrayDequeOps__copySliceToArray__I__O__I__I__O($thiz, srcStart, dest, destStart, maxItems) {
  var until = ((1 + $m_jl_reflect_Array$().c6(dest)) | 0);
  if (((destStart < 0) || (destStart >= until))) {
    throw $m_scg_CommonErrors$().h2(destStart, ((until - 1) | 0));
  }
  var idx = $thiz.bF;
  var a = ((((($thiz.d5 - idx) | 0) & (($thiz.aL.a.length - 1) | 0)) - srcStart) | 0);
  var b = (($m_jl_reflect_Array$().c6(dest) - destStart) | 0);
  var b$1 = ((a < b) ? a : b);
  var toCopy = ((maxItems < b$1) ? maxItems : b$1);
  if ((toCopy > 0)) {
    var idx$1 = $thiz.bF;
    var until$1 = ((($thiz.d5 - idx$1) | 0) & (($thiz.aL.a.length - 1) | 0));
    if (((srcStart < 0) || (srcStart >= until$1))) {
      throw $m_scg_CommonErrors$().h2(srcStart, ((until$1 - 1) | 0));
    }
    var startIdx = ((($thiz.bF + srcStart) | 0) & (($thiz.aL.a.length - 1) | 0));
    var b$2 = (($thiz.aL.a.length - startIdx) | 0);
    var block1 = ((toCopy < b$2) ? toCopy : b$2);
    $m_s_Array$().fv($thiz.aL, startIdx, dest, destStart, block1);
    var block2 = ((toCopy - block1) | 0);
    if ((block2 > 0)) {
      $m_s_Array$().fv($thiz.aL, 0, dest, ((destStart + block1) | 0), block2);
    }
  }
  return dest;
}
function $f_scm_ArrayDequeOps__reverse__O($thiz) {
  var idx = $thiz.bF;
  var n = ((($thiz.d5 - idx) | 0) & (($thiz.aL.a.length - 1) | 0));
  var arr = $m_scm_ArrayDeque$().vT(n);
  var i = 0;
  while ((i < n)) {
    arr.a[i] = $thiz.l(((((n - i) | 0) - 1) | 0));
    i = ((1 + i) | 0);
  }
  return $thiz.a4h(arr, n);
}
function $f_scm_ArrayDequeOps__slice__I__I__O($thiz, from, until) {
  var idx = $thiz.bF;
  var n = ((($thiz.d5 - idx) | 0) & (($thiz.aL.a.length - 1) | 0));
  var b = ((n < from) ? n : from);
  var left = ((b < 0) ? 0 : b);
  var b$1 = ((n < until) ? n : until);
  var right = ((b$1 < 0) ? 0 : b$1);
  var len = ((right - left) | 0);
  return ((len <= 0) ? $thiz.pr() : ((len >= n) ? $thiz.agN() : $thiz.a4h($f_scm_ArrayDequeOps__copySliceToArray__I__O__I__I__O($thiz, left, $m_scm_ArrayDeque$().vT(len), 0, len), len)));
}
/** @constructor */
function $c_scm_CheckedIndexedSeqView$CheckedIterator(self, mutationCount) {
  this.ac0 = null;
  this.zR = 0;
  this.qw = 0;
  this.aID = null;
  this.aIC = 0;
  this.aID = mutationCount;
  $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(this, self);
  this.aIC = (mutationCount.a3() | 0);
}
$p = $c_scm_CheckedIndexedSeqView$CheckedIterator.prototype = new $h_sc_IndexedSeqView$IndexedSeqViewIterator();
$p.constructor = $c_scm_CheckedIndexedSeqView$CheckedIterator;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$CheckedIterator() {
}
$h_scm_CheckedIndexedSeqView$CheckedIterator.prototype = $p;
$p.p = (function() {
  $m_scm_MutationTracker$().aeX(this.aIC, (this.aID.a3() | 0), "mutation occurred during iteration");
  return (this.qw > 0);
});
var $d_scm_CheckedIndexedSeqView$CheckedIterator = new $TypeData().i($c_scm_CheckedIndexedSeqView$CheckedIterator, "scala.collection.mutable.CheckedIndexedSeqView$CheckedIterator", ({
  JG: 1,
  kJ: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1,
  a: 1
}));
/** @constructor */
function $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(self, mutationCount) {
  this.ac1 = null;
  this.kc = 0;
  this.Hn = 0;
  this.aIF = null;
  this.aIE = 0;
  this.aIF = mutationCount;
  $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(this, self);
  this.aIE = (mutationCount.a3() | 0);
}
$p = $c_scm_CheckedIndexedSeqView$CheckedReverseIterator.prototype = new $h_sc_IndexedSeqView$IndexedSeqViewReverseIterator();
$p.constructor = $c_scm_CheckedIndexedSeqView$CheckedReverseIterator;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$CheckedReverseIterator() {
}
$h_scm_CheckedIndexedSeqView$CheckedReverseIterator.prototype = $p;
$p.p = (function() {
  $m_scm_MutationTracker$().aeX(this.aIE, (this.aIF.a3() | 0), "mutation occurred during iteration");
  return (this.kc > 0);
});
var $d_scm_CheckedIndexedSeqView$CheckedReverseIterator = new $TypeData().i($c_scm_CheckedIndexedSeqView$CheckedReverseIterator, "scala.collection.mutable.CheckedIndexedSeqView$CheckedReverseIterator", ({
  JH: 1,
  kK: 1,
  s: 1,
  p: 1,
  e: 1,
  f: 1,
  a: 1
}));
class $c_s_concurrent_Future$$anon$1 extends $c_ju_NoSuchElementException {
  constructor(t$2) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, ("Future.collect partial function is not defined at: " + t$2), null, true, true);
  }
  IU() {
    return $f_s_util_control_NoStackTrace__fillInStackTrace__jl_Throwable(this);
  }
}
var $d_s_concurrent_Future$$anon$1 = new $TypeData().i($c_s_concurrent_Future$$anon$1, "scala.concurrent.Future$$anon$1", ({
  Kz: 1,
  cp: 1,
  R: 1,
  G: 1,
  y: 1,
  a: 1,
  ca: 1
}));
class $c_s_concurrent_Future$$anon$2 extends $c_ju_NoSuchElementException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, "Future.filter predicate is not satisfied", null, true, true);
  }
  IU() {
    return $f_s_util_control_NoStackTrace__fillInStackTrace__jl_Throwable(this);
  }
}
var $d_s_concurrent_Future$$anon$2 = new $TypeData().i($c_s_concurrent_Future$$anon$2, "scala.concurrent.Future$$anon$2", ({
  KA: 1,
  cp: 1,
  R: 1,
  G: 1,
  y: 1,
  a: 1,
  ca: 1
}));
class $c_s_concurrent_Future$$anon$3 extends $c_ju_NoSuchElementException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, "Future.failed not completed with a throwable.", null, true, true);
  }
  IU() {
    return $f_s_util_control_NoStackTrace__fillInStackTrace__jl_Throwable(this);
  }
}
var $d_s_concurrent_Future$$anon$3 = new $TypeData().i($c_s_concurrent_Future$$anon$3, "scala.concurrent.Future$$anon$3", ({
  KB: 1,
  cp: 1,
  R: 1,
  G: 1,
  y: 1,
  a: 1,
  ca: 1
}));
function $p_s_concurrent_impl_Promise$DefaultPromise__value0__s_util_Try($thiz) {
  var _$this = $thiz;
  while (true) {
    var state = _$this.eo;
    if ((state instanceof $c_s_util_Try)) {
      return state;
    } else if ((state instanceof $c_s_concurrent_impl_Promise$Link)) {
      _$this = state.PK(_$this);
    } else {
      return null;
    }
  }
}
function $p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks($thiz, state, callbacks) {
  var _$this = $thiz;
  while (true) {
    if ((state instanceof $c_s_util_Try)) {
      $p_s_concurrent_impl_Promise$DefaultPromise__submitWithValue__s_concurrent_impl_Promise$Callbacks__s_util_Try__V(_$this, callbacks, state);
      return callbacks;
    } else if ($is_s_concurrent_impl_Promise$Callbacks(state)) {
      if (_$this.Wv(state, ((state !== $m_s_concurrent_impl_Promise$().Vi) ? $p_s_concurrent_impl_Promise$DefaultPromise__concatCallbacks__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(_$this, callbacks, state) : callbacks))) {
        return callbacks;
      } else {
        state = _$this.eo;
      }
    } else {
      var p = state.PK(_$this);
      var temp$state$2 = p.eo;
      _$this = p;
      state = temp$state$2;
    }
  }
}
function $p_s_concurrent_impl_Promise$DefaultPromise__concatCallbacks__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks($thiz, left, right) {
  while (true) {
    if ((left instanceof $c_s_concurrent_impl_Promise$Transformation)) {
      return new $c_s_concurrent_impl_Promise$ManyCallbacks(left, right);
    } else {
      var m = left;
      var temp$left = m.adh;
      var temp$right = new $c_s_concurrent_impl_Promise$ManyCallbacks(m.adg, right);
      left = temp$left;
      right = temp$right;
    }
  }
}
function $p_s_concurrent_impl_Promise$DefaultPromise__submitWithValue__s_concurrent_impl_Promise$Callbacks__s_util_Try__V($thiz, callbacks, resolved) {
  while (true) {
    if ((callbacks instanceof $c_s_concurrent_impl_Promise$ManyCallbacks)) {
      var m = callbacks;
      m.adg.aSy(resolved);
      callbacks = m.adh;
      continue;
    } else {
      callbacks.aSy(resolved);
    }
    return (void 0);
  }
}
function $ps_s_concurrent_impl_Promise$DefaultPromise__liftedTree1$1__F2__s_util_Success__s_util_Success__s_util_Try(f$1, x2$1, right$1) {
  try {
    return new $c_s_util_Success(f$1.R(x2$1.fM, right$1.fM));
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if ($m_s_util_control_NonFatal$().ew(e$2)) {
      return new $c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
    }
  }
}
function $ps_s_concurrent_impl_Promise$DefaultPromise__liftedTree2$1__F2__s_util_Success__s_util_Success__s_util_Try(f$1, left$1, x2$2) {
  try {
    return new $c_s_util_Success(f$1.R(left$1.fM, x2$2.fM));
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if ($m_s_util_control_NonFatal$().ew(e$2)) {
      return new $c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
    }
  }
}
function $ct_s_concurrent_impl_Promise$DefaultPromise__O__($thiz, initial) {
  $ct_ju_concurrent_atomic_AtomicReference__O__($thiz, initial);
  return $thiz;
}
function $ct_s_concurrent_impl_Promise$DefaultPromise__s_util_Try__($thiz, result) {
  $ct_s_concurrent_impl_Promise$DefaultPromise__O__($thiz, $m_s_concurrent_impl_Promise$().XX(result));
  return $thiz;
}
function $ct_s_concurrent_impl_Promise$DefaultPromise__($thiz) {
  $ct_s_concurrent_impl_Promise$DefaultPromise__O__($thiz, $m_s_concurrent_impl_Promise$().Vi);
  return $thiz;
}
/** @constructor */
function $c_s_concurrent_impl_Promise$DefaultPromise() {
  this.eo = null;
}
$p = $c_s_concurrent_impl_Promise$DefaultPromise.prototype = new $h_ju_concurrent_atomic_AtomicReference();
$p.constructor = $c_s_concurrent_impl_Promise$DefaultPromise;
/** @constructor */
function $h_s_concurrent_impl_Promise$DefaultPromise() {
}
$h_s_concurrent_impl_Promise$DefaultPromise.prototype = $p;
$p.iU = (function(v1) {
});
$p.aij = (function(f, executor) {
  return $p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(this, this.eo, $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__(new $c_s_concurrent_impl_Promise$Transformation(), 3, f, executor));
});
$p.aTw = (function(that, f, executor) {
  var state = this.eo;
  if ((state instanceof $c_s_util_Try)) {
    if (state.a3R()) {
      return this;
    } else {
      var l = state.fM;
      return that.jX(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((r$2$2) => f.R(l, r$2$2))), executor);
    }
  } else {
    var buffer = $ct_ju_concurrent_atomic_AtomicReference__(new $c_ju_concurrent_atomic_AtomicReference());
    var zipped = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
    var thisF = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x0$1$2$2) => {
      if ((x0$1$2$2 instanceof $c_s_util_Success)) {
        var right = buffer.aON(x0$1$2$2);
        if ((right !== null)) {
          zipped.El($ps_s_concurrent_impl_Promise$DefaultPromise__liftedTree1$1__F2__s_util_Success__s_util_Success__s_util_Try(f, x0$1$2$2, right));
        }
      } else {
        zipped.El(x0$1$2$2);
      }
    }));
    var thatF = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x0$2$2$2) => {
      if ((x0$2$2$2 instanceof $c_s_util_Success)) {
        var left = buffer.aON(x0$2$2$2);
        if ((left !== null)) {
          zipped.El($ps_s_concurrent_impl_Promise$DefaultPromise__liftedTree2$1__F2__s_util_Success__s_util_Success__s_util_Try(f, left, x0$2$2$2));
        }
      } else {
        zipped.El(x0$2$2$2);
      }
    }));
    $p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(this, state, $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__(new $c_s_concurrent_impl_Promise$Transformation(), 6, thisF, executor));
    that.XC(thatF, executor);
    return zipped;
  }
});
$p.oB = (function(f, executor) {
  var state = this.eo;
  if ((!(state instanceof $c_s_util_Failure))) {
    $p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(this, state, $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__(new $c_s_concurrent_impl_Promise$Transformation(), 5, f, executor));
  }
});
$p.IX = (function(f, executor) {
  var state = this.eo;
  return ((!(state instanceof $c_s_util_Failure)) ? $p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(this, state, $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__(new $c_s_concurrent_impl_Promise$Transformation(), 2, f, executor)) : this);
});
$p.jX = (function(f, executor) {
  var state = this.eo;
  return ((!(state instanceof $c_s_util_Failure)) ? $p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(this, state, $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__(new $c_s_concurrent_impl_Promise$Transformation(), 1, f, executor)) : this);
});
$p.AC = (function(pf, executor) {
  var state = this.eo;
  return ((!(state instanceof $c_s_util_Success)) ? $p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(this, state, $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__(new $c_s_concurrent_impl_Promise$Transformation(), 7, pf, executor)) : this);
});
$p.XC = (function(func, executor) {
  $p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(this, this.eo, $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__(new $c_s_concurrent_impl_Promise$Transformation(), 6, func, executor));
});
$p.IT = (function() {
  return ((!(this.eo instanceof $c_s_util_Success)) ? this.aij($m_s_concurrent_Future$().aIQ, $m_s_concurrent_ExecutionContext$parasitic$()) : $m_s_concurrent_Future$().aIS);
});
$p.m = (function() {
  var _$this = this;
  while (true) {
    var state = _$this.eo;
    if ((state instanceof $c_s_util_Try)) {
      return (("Future(" + state) + ")");
    } else if ((state instanceof $c_s_concurrent_impl_Promise$Link)) {
      _$this = state.PK(_$this);
    } else {
      return "Future(<not completed>)";
    }
  }
});
$p.El = (function(value) {
  var state = this.eo;
  return ((!(state instanceof $c_s_util_Try)) && this.JD(state, $m_s_concurrent_impl_Promise$().XX(value)));
});
$p.JD = (function(state, resolved) {
  var _$this = this;
  while (true) {
    if ($is_s_concurrent_impl_Promise$Callbacks(state)) {
      if ((!_$this.Wv(state, resolved))) {
        state = _$this.eo;
        continue;
      }
      if ((state !== $m_s_concurrent_impl_Promise$().Vi)) {
        $p_s_concurrent_impl_Promise$DefaultPromise__submitWithValue__s_concurrent_impl_Promise$Callbacks__s_util_Try__V(_$this, state, resolved);
      }
      return true;
    } else if ((state instanceof $c_s_concurrent_impl_Promise$Link)) {
      var p = state.PK(_$this);
      if ((p !== _$this)) {
        var temp$state$2 = p.eo;
        _$this = p;
        state = temp$state$2;
        continue;
      }
      return false;
    } else {
      return false;
    }
  }
});
$p.af8 = (function(other) {
  if ((other !== this)) {
    var state = this.eo;
    if ((!(state instanceof $c_s_util_Try))) {
      if ((other instanceof $c_s_concurrent_impl_Promise$DefaultPromise)) {
        var resolved = $p_s_concurrent_impl_Promise$DefaultPromise__value0__s_util_Try(other);
      } else {
        var this$2 = $m_s_Option$().as($p_s_concurrent_impl_Promise$DefaultPromise__value0__s_util_Try(other));
        var resolved = (this$2.c() ? null : this$2.d());
      }
      if ((resolved !== null)) {
        this.JD(state, resolved);
      } else {
        other.XC(this, $m_s_concurrent_ExecutionContext$parasitic$());
      }
    }
  }
  return this;
});
$p.agV = (function(target, link) {
  var _$this = this;
  while (true) {
    if ((_$this !== target)) {
      var state = _$this.eo;
      if ((state instanceof $c_s_util_Try)) {
        if ((!target.JD(target.eo, state))) {
          throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "Cannot link completed promises together");
        }
      } else if ($is_s_concurrent_impl_Promise$Callbacks(state)) {
        var l = ((link !== null) ? link : new $c_s_concurrent_impl_Promise$Link(target));
        var p = l.PK(_$this);
        if (((_$this !== p) && _$this.Wv(state, l))) {
          if ((state !== $m_s_concurrent_impl_Promise$().Vi)) {
            $p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(p, p.eo, state);
          }
        } else {
          target = p;
          link = l;
          continue;
        }
      } else {
        _$this = state.PK(_$this);
        continue;
      }
    }
    break;
  }
});
$p.baF = (function(resolved) {
  var _$this = this;
  while (true) {
    var state = _$this.eo;
    if ((state instanceof $c_s_concurrent_impl_Promise$Link)) {
      var next = (_$this.Wv(state, resolved) ? state.eo : _$this);
      _$this = next;
      continue;
    } else {
      _$this.JD(state, resolved);
    }
    break;
  }
});
$p.i = (function(v1) {
  this.JD(this.eo, v1);
});
function $isArrayOf_s_concurrent_impl_Promise$DefaultPromise(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dW)));
}
var $d_s_concurrent_impl_Promise$DefaultPromise = new $TypeData().i($c_s_concurrent_impl_Promise$DefaultPromise, "scala.concurrent.impl.Promise$DefaultPromise", ({
  dW: 1,
  cr: 1,
  a: 1,
  lZ: 1,
  lY: 1,
  lW: 1,
  h: 1
}));
/** @constructor */
function $c_s_math_Ordering$Boolean$() {
}
$p = $c_s_math_Ordering$Boolean$.prototype = new $h_O();
$p.constructor = $c_s_math_Ordering$Boolean$;
/** @constructor */
function $h_s_math_Ordering$Boolean$() {
}
$h_s_math_Ordering$Boolean$.prototype = $p;
$p.mQ = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$p.mM = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$p.lZ = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$p.mL = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$p.kQ = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$p.kR = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$p.mO = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$p.dA = (function(x, y) {
  var x$1 = (!(!x));
  return ((x$1 === (!(!y))) ? 0 : (x$1 ? 1 : (-1)));
});
var $d_s_math_Ordering$Boolean$ = new $TypeData().i($c_s_math_Ordering$Boolean$, "scala.math.Ordering$Boolean$", ({
  KV: 1,
  KW: 1,
  ax: 1,
  ad: 1,
  ay: 1,
  aw: 1,
  a: 1
}));
var $n_s_math_Ordering$Boolean$;
function $m_s_math_Ordering$Boolean$() {
  if ((!$n_s_math_Ordering$Boolean$)) {
    $n_s_math_Ordering$Boolean$ = new $c_s_math_Ordering$Boolean$();
  }
  return $n_s_math_Ordering$Boolean$;
}
/** @constructor */
function $c_s_math_Ordering$Byte$() {
}
$p = $c_s_math_Ordering$Byte$.prototype = new $h_O();
$p.constructor = $c_s_math_Ordering$Byte$;
/** @constructor */
function $h_s_math_Ordering$Byte$() {
}
$h_s_math_Ordering$Byte$.prototype = $p;
$p.mQ = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$p.mM = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$p.lZ = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$p.mL = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$p.kQ = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$p.kR = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$p.mO = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$p.dA = (function(x, y) {
  return (((x | 0) - (y | 0)) | 0);
});
var $d_s_math_Ordering$Byte$ = new $TypeData().i($c_s_math_Ordering$Byte$, "scala.math.Ordering$Byte$", ({
  KX: 1,
  KY: 1,
  ax: 1,
  ad: 1,
  ay: 1,
  aw: 1,
  a: 1
}));
var $n_s_math_Ordering$Byte$;
function $m_s_math_Ordering$Byte$() {
  if ((!$n_s_math_Ordering$Byte$)) {
    $n_s_math_Ordering$Byte$ = new $c_s_math_Ordering$Byte$();
  }
  return $n_s_math_Ordering$Byte$;
}
/** @constructor */
function $c_s_math_Ordering$Char$() {
}
$p = $c_s_math_Ordering$Char$.prototype = new $h_O();
$p.constructor = $c_s_math_Ordering$Char$;
/** @constructor */
function $h_s_math_Ordering$Char$() {
}
$h_s_math_Ordering$Char$.prototype = $p;
$p.mQ = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$p.mM = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$p.lZ = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$p.mL = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$p.kQ = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$p.kR = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$p.mO = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$p.dA = (function(x, y) {
  return (($uC(x) - $uC(y)) | 0);
});
var $d_s_math_Ordering$Char$ = new $TypeData().i($c_s_math_Ordering$Char$, "scala.math.Ordering$Char$", ({
  L0: 1,
  L1: 1,
  ax: 1,
  ad: 1,
  ay: 1,
  aw: 1,
  a: 1
}));
var $n_s_math_Ordering$Char$;
function $m_s_math_Ordering$Char$() {
  if ((!$n_s_math_Ordering$Char$)) {
    $n_s_math_Ordering$Char$ = new $c_s_math_Ordering$Char$();
  }
  return $n_s_math_Ordering$Char$;
}
/** @constructor */
function $c_s_math_Ordering$DeprecatedDoubleOrdering$() {
}
$p = $c_s_math_Ordering$DeprecatedDoubleOrdering$.prototype = new $h_O();
$p.constructor = $c_s_math_Ordering$DeprecatedDoubleOrdering$;
/** @constructor */
function $h_s_math_Ordering$DeprecatedDoubleOrdering$() {
}
$h_s_math_Ordering$DeprecatedDoubleOrdering$.prototype = $p;
$p.mQ = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$p.mM = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$p.lZ = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$p.mL = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$p.kQ = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$p.kR = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$p.mO = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$p.dA = (function(x, y) {
  return $m_jl_Double$().P9((+x), (+y));
});
var $d_s_math_Ordering$DeprecatedDoubleOrdering$ = new $TypeData().i($c_s_math_Ordering$DeprecatedDoubleOrdering$, "scala.math.Ordering$DeprecatedDoubleOrdering$", ({
  L2: 1,
  L5: 1,
  ax: 1,
  ad: 1,
  ay: 1,
  aw: 1,
  a: 1
}));
var $n_s_math_Ordering$DeprecatedDoubleOrdering$;
function $m_s_math_Ordering$DeprecatedDoubleOrdering$() {
  if ((!$n_s_math_Ordering$DeprecatedDoubleOrdering$)) {
    $n_s_math_Ordering$DeprecatedDoubleOrdering$ = new $c_s_math_Ordering$DeprecatedDoubleOrdering$();
  }
  return $n_s_math_Ordering$DeprecatedDoubleOrdering$;
}
/** @constructor */
function $c_s_math_Ordering$DeprecatedFloatOrdering$() {
}
$p = $c_s_math_Ordering$DeprecatedFloatOrdering$.prototype = new $h_O();
$p.constructor = $c_s_math_Ordering$DeprecatedFloatOrdering$;
/** @constructor */
function $h_s_math_Ordering$DeprecatedFloatOrdering$() {
}
$h_s_math_Ordering$DeprecatedFloatOrdering$.prototype = $p;
$p.mQ = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$p.mM = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$p.lZ = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$p.mL = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$p.kQ = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$p.kR = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$p.mO = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$p.dA = (function(x, y) {
  return $m_jl_Double$().P9(Math.fround(x), Math.fround(y));
});
var $d_s_math_Ordering$DeprecatedFloatOrdering$ = new $TypeData().i($c_s_math_Ordering$DeprecatedFloatOrdering$, "scala.math.Ordering$DeprecatedFloatOrdering$", ({
  L3: 1,
  L6: 1,
  ax: 1,
  ad: 1,
  ay: 1,
  aw: 1,
  a: 1
}));
var $n_s_math_Ordering$DeprecatedFloatOrdering$;
function $m_s_math_Ordering$DeprecatedFloatOrdering$() {
  if ((!$n_s_math_Ordering$DeprecatedFloatOrdering$)) {
    $n_s_math_Ordering$DeprecatedFloatOrdering$ = new $c_s_math_Ordering$DeprecatedFloatOrdering$();
  }
  return $n_s_math_Ordering$DeprecatedFloatOrdering$;
}
/** @constructor */
function $c_s_math_Ordering$Long$() {
}
$p = $c_s_math_Ordering$Long$.prototype = new $h_O();
$p.constructor = $c_s_math_Ordering$Long$;
/** @constructor */
function $h_s_math_Ordering$Long$() {
}
$h_s_math_Ordering$Long$.prototype = $p;
$p.mQ = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$p.mM = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$p.lZ = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$p.mL = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$p.kQ = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$p.kR = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$p.mO = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$p.dA = (function(x, y) {
  var $x_1 = $uJ(x);
  var x$1_$_lo = $x_1.l;
  var x$1_$_hi = $x_1.h;
  var $x_2 = $uJ(y);
  var y$1_$_lo = $x_2.l;
  var y$1_$_hi = $x_2.h;
  return ((x$1_$_hi === y$1_$_hi) ? ((x$1_$_lo === y$1_$_lo) ? 0 : (((x$1_$_lo >>> 0) < (y$1_$_lo >>> 0)) ? (-1) : 1)) : ((x$1_$_hi < y$1_$_hi) ? (-1) : 1));
});
var $d_s_math_Ordering$Long$ = new $TypeData().i($c_s_math_Ordering$Long$, "scala.math.Ordering$Long$", ({
  L8: 1,
  m8: 1,
  ax: 1,
  ad: 1,
  ay: 1,
  aw: 1,
  a: 1
}));
var $n_s_math_Ordering$Long$;
function $m_s_math_Ordering$Long$() {
  if ((!$n_s_math_Ordering$Long$)) {
    $n_s_math_Ordering$Long$ = new $c_s_math_Ordering$Long$();
  }
  return $n_s_math_Ordering$Long$;
}
/** @constructor */
function $c_s_math_Ordering$Short$() {
}
$p = $c_s_math_Ordering$Short$.prototype = new $h_O();
$p.constructor = $c_s_math_Ordering$Short$;
/** @constructor */
function $h_s_math_Ordering$Short$() {
}
$h_s_math_Ordering$Short$.prototype = $p;
$p.mQ = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$p.mM = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$p.lZ = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$p.mL = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$p.kQ = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$p.kR = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$p.mO = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$p.dA = (function(x, y) {
  return (((x | 0) - (y | 0)) | 0);
});
var $d_s_math_Ordering$Short$ = new $TypeData().i($c_s_math_Ordering$Short$, "scala.math.Ordering$Short$", ({
  L9: 1,
  La: 1,
  ax: 1,
  ad: 1,
  ay: 1,
  aw: 1,
  a: 1
}));
var $n_s_math_Ordering$Short$;
function $m_s_math_Ordering$Short$() {
  if ((!$n_s_math_Ordering$Short$)) {
    $n_s_math_Ordering$Short$ = new $c_s_math_Ordering$Short$();
  }
  return $n_s_math_Ordering$Short$;
}
/** @constructor */
function $c_s_math_Ordering$String$() {
}
$p = $c_s_math_Ordering$String$.prototype = new $h_O();
$p.constructor = $c_s_math_Ordering$String$;
/** @constructor */
function $h_s_math_Ordering$String$() {
}
$h_s_math_Ordering$String$.prototype = $p;
$p.mQ = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$p.mM = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$p.lZ = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$p.mL = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$p.kQ = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$p.kR = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$p.mO = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$p.dA = (function(x, y) {
  return $f_T__compareTo__T__I(x, y);
});
var $d_s_math_Ordering$String$ = new $TypeData().i($c_s_math_Ordering$String$, "scala.math.Ordering$String$", ({
  Lb: 1,
  Lc: 1,
  ax: 1,
  ad: 1,
  ay: 1,
  aw: 1,
  a: 1
}));
var $n_s_math_Ordering$String$;
function $m_s_math_Ordering$String$() {
  if ((!$n_s_math_Ordering$String$)) {
    $n_s_math_Ordering$String$ = new $c_s_math_Ordering$String$();
  }
  return $n_s_math_Ordering$String$;
}
/** @constructor */
function $c_s_reflect_AnyValManifest() {
  this.gO = null;
}
$p = $c_s_reflect_AnyValManifest.prototype = new $h_O();
$p.constructor = $c_s_reflect_AnyValManifest;
/** @constructor */
function $h_s_reflect_AnyValManifest() {
}
$h_s_reflect_AnyValManifest.prototype = $p;
$p.m = (function() {
  return this.gO;
});
$p.e = (function(that) {
  return (this === that);
});
$p.x = (function() {
  return $systemIdentityHashCode(this);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$ClassTypeManifest() {
}
$p = $c_s_reflect_ManifestFactory$ClassTypeManifest.prototype = new $h_O();
$p.constructor = $c_s_reflect_ManifestFactory$ClassTypeManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$ClassTypeManifest() {
}
$h_s_reflect_ManifestFactory$ClassTypeManifest.prototype = $p;
class $c_sjs_js_JavaScriptException extends $c_jl_RuntimeException {
  constructor(exception) {
    super();
    this.bf = null;
    this.bf = exception;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  e3() {
    return $dp_toString__T(this.bf);
  }
  B() {
    return "JavaScriptException";
  }
  z() {
    return 1;
  }
  A(x$1) {
    return ((x$1 === 0) ? this.bf : $m_sr_Statics$().ey(x$1));
  }
  H() {
    return new $c_sr_ScalaRunTime$$anon$1(this);
  }
  D(x$1) {
    return ((x$1 === 0) ? "exception" : $m_sr_Statics$().ey(x$1));
  }
  x() {
    return $m_s_util_hashing_MurmurHash3$().ab(this, 1744042595, true);
  }
  e(x$1) {
    return ((this === x$1) || ((x$1 instanceof $c_sjs_js_JavaScriptException) && $m_sr_BoxesRunTime$().Q(this.bf, x$1.bf)));
  }
}
function $isArrayOf_sjs_js_JavaScriptException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.mn)));
}
var $d_sjs_js_JavaScriptException = new $TypeData().i($c_sjs_js_JavaScriptException, "scala.scalajs.js.JavaScriptException", ({
  mn: 1,
  R: 1,
  G: 1,
  y: 1,
  a: 1,
  c: 1,
  b: 1
}));
/** @constructor */
function $c_Lujson_Arr(value) {
  this.Dj = null;
  this.Dj = value;
}
$p = $c_Lujson_Arr.prototype = new $h_O();
$p.constructor = $c_Lujson_Arr;
/** @constructor */
function $h_Lujson_Arr() {
}
$h_Lujson_Arr.prototype = $p;
$p.yq = (function(f) {
  return $m_Lujson_Value$().yp(this, f);
});
$p.m = (function() {
  return $f_Lujson_Value__render__I__Z__T(this, (-1), false);
});
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().eN(this, (-889275714), null);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lujson_Arr)) {
    var x = this.Dj;
    var x$2 = x$0.Dj;
    return ((x === null) ? (x$2 === null) : $f_sc_Seq__equals__O__Z(x, x$2));
  } else {
    return false;
  }
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Arr";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Dj;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lujson_Arr(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.mG)));
}
var $d_Lujson_Arr = new $TypeData().i($c_Lujson_Arr, "ujson.Arr", ({
  mG: 1,
  b4: 1,
  ac: 1,
  bk: 1,
  b: 1,
  c: 1,
  a: 1
}));
class $c_Lujson_IncompleteParseException extends $c_jl_Exception {
  constructor(msg) {
    super();
    this.a2c = null;
    this.a2c = msg;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, msg, null, true, true);
  }
  H() {
    return new $c_s_Product$$anon$1(this);
  }
  x() {
    return $m_s_util_hashing_MurmurHash3$().eN(this, (-889275714), null);
  }
  e(x$0) {
    return ((this === x$0) || ((x$0 instanceof $c_Lujson_IncompleteParseException) && (this.a2c === x$0.a2c)));
  }
  z() {
    return 1;
  }
  B() {
    return "IncompleteParseException";
  }
  A(n) {
    if ((n === 0)) {
      return this.a2c;
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  D(n) {
    if ((n === 0)) {
      return "msg";
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
}
function $isArrayOf_Lujson_IncompleteParseException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.mJ)));
}
var $d_Lujson_IncompleteParseException = new $TypeData().i($c_Lujson_IncompleteParseException, "ujson.IncompleteParseException", ({
  mJ: 1,
  G: 1,
  y: 1,
  a: 1,
  mN: 1,
  b: 1,
  c: 1
}));
/** @constructor */
function $c_Lujson_Num(value) {
  this.HQ = 0.0;
  this.HQ = value;
}
$p = $c_Lujson_Num.prototype = new $h_O();
$p.constructor = $c_Lujson_Num;
/** @constructor */
function $h_Lujson_Num() {
}
$h_Lujson_Num.prototype = $p;
$p.yq = (function(f) {
  return $m_Lujson_Value$().yp(this, f);
});
$p.m = (function() {
  return $f_Lujson_Value__render__I__Z__T(this, (-1), false);
});
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, $f_T__hashCode__I("Num"));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.HQ));
  return $m_sr_Statics$().Z(acc, 1);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lujson_Num) && (this.HQ === x$0.HQ)));
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Num";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.HQ;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lujson_Num(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.mK)));
}
var $d_Lujson_Num = new $TypeData().i($c_Lujson_Num, "ujson.Num", ({
  mK: 1,
  b4: 1,
  ac: 1,
  bk: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lujson_Obj(value) {
  this.tM = null;
  this.tM = value;
}
$p = $c_Lujson_Obj.prototype = new $h_O();
$p.constructor = $c_Lujson_Obj;
/** @constructor */
function $h_Lujson_Obj() {
}
$h_Lujson_Obj.prototype = $p;
$p.yq = (function(f) {
  return $m_Lujson_Value$().yp(this, f);
});
$p.m = (function() {
  return $f_Lujson_Value__render__I__Z__T(this, (-1), false);
});
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().eN(this, (-889275714), null);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lujson_Obj)) {
    var x = this.tM;
    var x$2 = x$0.tM;
    return ((x === null) ? (x$2 === null) : $f_sc_Map__equals__O__Z(x, x$2));
  } else {
    return false;
  }
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Obj";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.tM;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lujson_Obj(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.mL)));
}
var $d_Lujson_Obj = new $TypeData().i($c_Lujson_Obj, "ujson.Obj", ({
  mL: 1,
  b4: 1,
  ac: 1,
  bk: 1,
  b: 1,
  c: 1,
  a: 1
}));
class $c_Lujson_ParseException extends $c_jl_Exception {
  constructor(clue, index) {
    super();
    this.VI = null;
    this.VJ = 0;
    this.VI = clue;
    this.VJ = index;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, ((clue + " at index ") + index), null, true, true);
  }
  H() {
    return new $c_s_Product$$anon$1(this);
  }
  x() {
    var acc = (-889275714);
    acc = $m_sr_Statics$().k(acc, $f_T__hashCode__I("ParseException"));
    acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.VI));
    acc = $m_sr_Statics$().k(acc, this.VJ);
    return $m_sr_Statics$().Z(acc, 2);
  }
  e(x$0) {
    return ((this === x$0) || ((x$0 instanceof $c_Lujson_ParseException) && ((this.VJ === x$0.VJ) && (this.VI === x$0.VI))));
  }
  z() {
    return 2;
  }
  B() {
    return "ParseException";
  }
  A(n) {
    if ((n === 0)) {
      return this.VI;
    }
    if ((n === 1)) {
      return this.VJ;
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  D(n) {
    if ((n === 0)) {
      return "clue";
    }
    if ((n === 1)) {
      return "index";
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
}
function $isArrayOf_Lujson_ParseException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.mM)));
}
var $d_Lujson_ParseException = new $TypeData().i($c_Lujson_ParseException, "ujson.ParseException", ({
  mM: 1,
  G: 1,
  y: 1,
  a: 1,
  mN: 1,
  b: 1,
  c: 1
}));
/** @constructor */
function $c_Lujson_Renderer(out, indent, escapeUnicode) {
  this.nu = null;
  this.Oj = 0;
  this.a28 = false;
  this.e1 = null;
  this.a29 = null;
  this.qM = 0;
  this.Ol = false;
  this.vN = false;
  this.qN = false;
  this.Ok = false;
  this.VO = null;
  this.VN = 0;
  this.VM = false;
  this.VO = out;
  this.VN = indent;
  this.VM = escapeUnicode;
  $ct_Lujson_BaseCharRenderer__Ljava_io_Writer__I__Z__(this, out, indent, escapeUnicode);
}
$p = $c_Lujson_Renderer.prototype = new $h_Lujson_BaseCharRenderer();
$p.constructor = $c_Lujson_Renderer;
/** @constructor */
function $h_Lujson_Renderer() {
}
$h_Lujson_Renderer.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, $f_T__hashCode__I("Renderer"));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.VO));
  acc = $m_sr_Statics$().k(acc, this.VN);
  acc = $m_sr_Statics$().k(acc, (this.VM ? 1231 : 1237));
  return $m_sr_Statics$().Z(acc, 3);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lujson_Renderer)) {
    if (((this.VN === x$0.VN) && (this.VM === x$0.VM))) {
      var x = this.VO;
      var x$2 = x$0.VO;
      return ((x === null) ? (x$2 === null) : (x === x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 3;
});
$p.B = (function() {
  return "Renderer";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.VO;
      break;
    }
    case 1: {
      return this.VN;
      break;
    }
    case 2: {
      return this.VM;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "out";
      break;
    }
    case 1: {
      return "indent";
      break;
    }
    case 2: {
      return "escapeUnicode";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lujson_Renderer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.mP)));
}
var $d_Lujson_Renderer = new $TypeData().i($c_Lujson_Renderer, "ujson.Renderer", ({
  mP: 1,
  mH: 1,
  x: 1,
  e4: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lujson_Str(value) {
  this.xP = null;
  this.xP = value;
}
$p = $c_Lujson_Str.prototype = new $h_O();
$p.constructor = $c_Lujson_Str;
/** @constructor */
function $h_Lujson_Str() {
}
$h_Lujson_Str.prototype = $p;
$p.yq = (function(f) {
  return $m_Lujson_Value$().yp(this, f);
});
$p.m = (function() {
  return $f_Lujson_Value__render__I__Z__T(this, (-1), false);
});
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().eN(this, (-889275714), null);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lujson_Str) && (this.xP === x$0.xP)));
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Str";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.xP;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lujson_Str(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.mQ)));
}
var $d_Lujson_Str = new $TypeData().i($c_Lujson_Str, "ujson.Str", ({
  mQ: 1,
  b4: 1,
  ac: 1,
  bk: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lujson_StringRenderer(indent, escapeUnicode) {
  this.nu = null;
  this.Oj = 0;
  this.a28 = false;
  this.e1 = null;
  this.a29 = null;
  this.qM = 0;
  this.Ol = false;
  this.vN = false;
  this.qN = false;
  this.Ok = false;
  this.VQ = 0;
  this.VP = false;
  this.VQ = indent;
  this.VP = escapeUnicode;
  $ct_Lujson_BaseCharRenderer__Ljava_io_Writer__I__Z__(this, new $c_Ljava_io_StringWriter(), indent, escapeUnicode);
}
$p = $c_Lujson_StringRenderer.prototype = new $h_Lujson_BaseCharRenderer();
$p.constructor = $c_Lujson_StringRenderer;
/** @constructor */
function $h_Lujson_StringRenderer() {
}
$h_Lujson_StringRenderer.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, $f_T__hashCode__I("StringRenderer"));
  acc = $m_sr_Statics$().k(acc, this.VQ);
  acc = $m_sr_Statics$().k(acc, (this.VP ? 1231 : 1237));
  return $m_sr_Statics$().Z(acc, 2);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lujson_StringRenderer) && ((this.VQ === x$0.VQ) && (this.VP === x$0.VP))));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "StringRenderer";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.VQ;
  }
  if ((n === 1)) {
    return this.VP;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "indent";
  }
  if ((n === 1)) {
    return "escapeUnicode";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lujson_StringRenderer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.mR)));
}
var $d_Lujson_StringRenderer = new $TypeData().i($c_Lujson_StringRenderer, "ujson.StringRenderer", ({
  mR: 1,
  mH: 1,
  x: 1,
  e4: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupack_Arr(value) {
  this.VR = null;
  this.VR = value;
}
$p = $c_Lupack_Arr.prototype = new $h_O();
$p.constructor = $c_Lupack_Arr;
/** @constructor */
function $h_Lupack_Arr() {
}
$h_Lupack_Arr.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().eN(this, (-889275714), null);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lupack_Arr)) {
    var x = this.VR;
    var x$2 = x$0.VR;
    return ((x === null) ? (x$2 === null) : $f_sc_Seq__equals__O__Z(x, x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Arr";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.VR;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lupack_Arr(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.mT)));
}
var $d_Lupack_Arr = new $TypeData().i($c_Lupack_Arr, "upack.Arr", ({
  mT: 1,
  aC: 1,
  ac: 1,
  aJ: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupack_Binary(value) {
  this.VS = null;
  this.VS = value;
}
$p = $c_Lupack_Binary.prototype = new $h_O();
$p.constructor = $c_Lupack_Binary;
/** @constructor */
function $h_Lupack_Binary() {
}
$h_Lupack_Binary.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().eN(this, (-889275714), null);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lupack_Binary)) {
    var x = this.VS;
    var x$2 = x$0.VS;
    return ((x === null) ? (x$2 === null) : (x === x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Binary";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.VS;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lupack_Binary(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.mU)));
}
var $d_Lupack_Binary = new $TypeData().i($c_Lupack_Binary, "upack.Binary", ({
  mU: 1,
  aC: 1,
  ac: 1,
  aJ: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupack_Ext(tag, data) {
  this.On = 0;
  this.Om = null;
  this.On = tag;
  this.Om = data;
}
$p = $c_Lupack_Ext.prototype = new $h_O();
$p.constructor = $c_Lupack_Ext;
/** @constructor */
function $h_Lupack_Ext() {
}
$h_Lupack_Ext.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, $f_T__hashCode__I("Ext"));
  acc = $m_sr_Statics$().k(acc, this.On);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.Om));
  return $m_sr_Statics$().Z(acc, 2);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lupack_Ext)) {
    if ((this.On === x$0.On)) {
      var x = this.Om;
      var x$2 = x$0.Om;
      return ((x === null) ? (x$2 === null) : (x === x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 2;
});
$p.B = (function() {
  return "Ext";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.On;
  }
  if ((n === 1)) {
    return this.Om;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "tag";
  }
  if ((n === 1)) {
    return "data";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lupack_Ext(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.mW)));
}
var $d_Lupack_Ext = new $TypeData().i($c_Lupack_Ext, "upack.Ext", ({
  mW: 1,
  aC: 1,
  ac: 1,
  aJ: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupack_Float32(value) {
  this.Oo = 0.0;
  this.Oo = value;
}
$p = $c_Lupack_Float32.prototype = new $h_O();
$p.constructor = $c_Lupack_Float32;
/** @constructor */
function $h_Lupack_Float32() {
}
$h_Lupack_Float32.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, $f_T__hashCode__I("Float32"));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.Oo));
  return $m_sr_Statics$().Z(acc, 1);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lupack_Float32) && (this.Oo === x$0.Oo)));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Float32";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Oo;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lupack_Float32(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.mX)));
}
var $d_Lupack_Float32 = new $TypeData().i($c_Lupack_Float32, "upack.Float32", ({
  mX: 1,
  aC: 1,
  ac: 1,
  aJ: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupack_Float64(value) {
  this.Op = 0.0;
  this.Op = value;
}
$p = $c_Lupack_Float64.prototype = new $h_O();
$p.constructor = $c_Lupack_Float64;
/** @constructor */
function $h_Lupack_Float64() {
}
$h_Lupack_Float64.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, $f_T__hashCode__I("Float64"));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().ax(this.Op));
  return $m_sr_Statics$().Z(acc, 1);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lupack_Float64) && (this.Op === x$0.Op)));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Float64";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Op;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lupack_Float64(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.mY)));
}
var $d_Lupack_Float64 = new $TypeData().i($c_Lupack_Float64, "upack.Float64", ({
  mY: 1,
  aC: 1,
  ac: 1,
  aJ: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupack_Int32(value) {
  this.Oq = 0;
  this.Oq = value;
}
$p = $c_Lupack_Int32.prototype = new $h_O();
$p.constructor = $c_Lupack_Int32;
/** @constructor */
function $h_Lupack_Int32() {
}
$h_Lupack_Int32.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, $f_T__hashCode__I("Int32"));
  acc = $m_sr_Statics$().k(acc, this.Oq);
  return $m_sr_Statics$().Z(acc, 1);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lupack_Int32) && (this.Oq === x$0.Oq)));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Int32";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.Oq;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lupack_Int32(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.mZ)));
}
var $d_Lupack_Int32 = new $TypeData().i($c_Lupack_Int32, "upack.Int32", ({
  mZ: 1,
  aC: 1,
  ac: 1,
  aJ: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupack_Int64(value_$_lo, value_$_hi) {
  this.OJ = 0;
  this.OK = 0;
  this.OJ = value_$_lo;
  this.OK = value_$_hi;
}
$p = $c_Lupack_Int64.prototype = new $h_O();
$p.constructor = $c_Lupack_Int64;
/** @constructor */
function $h_Lupack_Int64() {
}
$h_Lupack_Int64.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, $f_T__hashCode__I("Int64"));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().jt(this.OJ, this.OK));
  return $m_sr_Statics$().Z(acc, 1);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lupack_Int64)) {
    var x_$_lo = this.OJ;
    var x_$_hi = this.OK;
    var $x_1 = x$0;
    var x$1_$_lo = $x_1.OJ;
    var x$1_$_hi = $x_1.OK;
    return (((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0);
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Int64";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return $bL(this.OJ, this.OK);
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lupack_Int64(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.n0)));
}
var $d_Lupack_Int64 = new $TypeData().i($c_Lupack_Int64, "upack.Int64", ({
  n0: 1,
  aC: 1,
  ac: 1,
  aJ: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupack_Obj(value) {
  this.VT = null;
  this.VT = value;
}
$p = $c_Lupack_Obj.prototype = new $h_O();
$p.constructor = $c_Lupack_Obj;
/** @constructor */
function $h_Lupack_Obj() {
}
$h_Lupack_Obj.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().eN(this, (-889275714), null);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lupack_Obj)) {
    var x = this.VT;
    var x$2 = x$0.VT;
    return ((x === null) ? (x$2 === null) : $f_sc_Map__equals__O__Z(x, x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Obj";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.VT;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lupack_Obj(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.n1)));
}
var $d_Lupack_Obj = new $TypeData().i($c_Lupack_Obj, "upack.Obj", ({
  n1: 1,
  aC: 1,
  ac: 1,
  aJ: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupack_Str(value) {
  this.VU = null;
  this.VU = value;
}
$p = $c_Lupack_Str.prototype = new $h_O();
$p.constructor = $c_Lupack_Str;
/** @constructor */
function $h_Lupack_Str() {
}
$h_Lupack_Str.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().eN(this, (-889275714), null);
});
$p.e = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lupack_Str) && (this.VU === x$0.VU)));
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "Str";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return this.VU;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lupack_Str(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.n2)));
}
var $d_Lupack_Str = new $TypeData().i($c_Lupack_Str, "upack.Str", ({
  n2: 1,
  aC: 1,
  ac: 1,
  aJ: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupack_UInt64(value_$_lo, value_$_hi) {
  this.OL = 0;
  this.OM = 0;
  this.OL = value_$_lo;
  this.OM = value_$_hi;
}
$p = $c_Lupack_UInt64.prototype = new $h_O();
$p.constructor = $c_Lupack_UInt64;
/** @constructor */
function $h_Lupack_UInt64() {
}
$h_Lupack_UInt64.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, $f_T__hashCode__I("UInt64"));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().jt(this.OL, this.OM));
  return $m_sr_Statics$().Z(acc, 1);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lupack_UInt64)) {
    var x_$_lo = this.OL;
    var x_$_hi = this.OM;
    var $x_1 = x$0;
    var x$1_$_lo = $x_1.OL;
    var x$1_$_hi = $x_1.OM;
    return (((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0);
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 1;
});
$p.B = (function() {
  return "UInt64";
});
$p.A = (function(n) {
  if ((n === 0)) {
    return $bL(this.OL, this.OM);
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lupack_UInt64(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.n3)));
}
var $d_Lupack_UInt64 = new $TypeData().i($c_Lupack_UInt64, "upack.UInt64", ({
  n3: 1,
  aC: 1,
  ac: 1,
  aJ: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_Types$$anon$1(f$4, g$2, outer) {
  this.kJ = null;
  this.aJN = null;
  this.aJO = null;
  this.a2j = null;
  this.aJN = f$4;
  this.aJO = g$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.a2j = outer;
  $ct_Lupickle_core_Visitor$MapReader__Lupickle_core_Visitor__(this, outer);
}
$p = $c_Lupickle_core_Types$$anon$1.prototype = new $h_Lupickle_core_Visitor$MapReader();
$p.constructor = $c_Lupickle_core_Types$$anon$1;
/** @constructor */
function $h_Lupickle_core_Types$$anon$1() {
}
$h_Lupickle_core_Types$$anon$1.prototype = $p;
$p.cT = (function() {
  return false;
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.gB = (function() {
  return this;
});
$p.d0 = (function(out, v) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this.a2j, out, this.aJN.i(v));
});
$p.a4a = (function(t) {
  return this.aJO.i(t);
});
$p.oH = (function() {
  return this.a2j.Ye();
});
$p.JH = (function() {
  return this.a2j.Ye();
});
$p.ha = (function() {
  return this.oH();
});
$p.Ye = (function() {
  return this.JH();
});
$p.cW = (function() {
  return this;
});
var $d_Lupickle_core_Types$$anon$1 = new $TypeData().i($c_Lupickle_core_Types$$anon$1, "upickle.core.Types$$anon$1", ({
  OE: 1,
  nq: 1,
  x: 1,
  D: 1,
  B: 1,
  E: 1,
  cX: 1
}));
/** @constructor */
function $c_Lupickle_core_Types$$anon$3(r0$1, w0$2, outer) {
  this.iH = null;
  this.adQ = null;
  this.adP = null;
  this.adQ = w0$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.adP = outer;
  $ct_Lupickle_core_Visitor$Delegate__Lupickle_core_Visitor__(this, r0$1);
}
$p = $c_Lupickle_core_Types$$anon$3.prototype = new $h_Lupickle_core_Visitor$Delegate();
$p.constructor = $c_Lupickle_core_Types$$anon$3;
/** @constructor */
function $h_Lupickle_core_Types$$anon$3() {
}
$h_Lupickle_core_Types$$anon$3.prototype = $p;
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.gB = (function() {
  return this;
});
$p.cT = (function() {
  return this.adQ.cT();
});
$p.d0 = (function(out, v) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this.adQ, out, v);
});
$p.oH = (function() {
  return this.adP.tN;
});
$p.JH = (function() {
  return this.adP.tN;
});
$p.ha = (function() {
  return this.oH();
});
$p.Ye = (function() {
  return this.JH();
});
$p.cW = (function() {
  return this;
});
var $d_Lupickle_core_Types$$anon$3 = new $TypeData().i($c_Lupickle_core_Types$$anon$3, "upickle.core.Types$$anon$3", ({
  OG: 1,
  bJ: 1,
  x: 1,
  D: 1,
  B: 1,
  E: 1,
  cX: 1
}));
function $ct_Lupickle_core_Types$ReadWriter$Delegate__Lupickle_core_Types$ReadWriter$__Lupickle_core_Visitor__($thiz, outer, other) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $thiz.a2k = outer;
  $ct_Lupickle_core_Visitor$Delegate__Lupickle_core_Visitor__($thiz, other);
  return $thiz;
}
/** @constructor */
function $c_Lupickle_core_Types$ReadWriter$Delegate() {
  this.iH = null;
  this.a2k = null;
}
$p = $c_Lupickle_core_Types$ReadWriter$Delegate.prototype = new $h_Lupickle_core_Visitor$Delegate();
$p.constructor = $c_Lupickle_core_Types$ReadWriter$Delegate;
/** @constructor */
function $h_Lupickle_core_Types$ReadWriter$Delegate() {
}
$h_Lupickle_core_Types$ReadWriter$Delegate.prototype = $p;
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.gB = (function() {
  return this;
});
$p.oH = (function() {
  return this.a2k.tN;
});
$p.JH = (function() {
  return this.a2k.tN;
});
$p.ha = (function() {
  return this.oH();
});
$p.Ye = (function() {
  return this.JH();
});
$p.cW = (function() {
  return this;
});
function $f_Lcom_raquo_airstream_core_WritableSignal__setCurrentValue__s_util_Try__V($thiz, newValue) {
  if ((!($thiz.ye() === (void 0)))) {
    $thiz.xZ($m_Lcom_raquo_airstream_core_Signal$().aQs());
  }
  $thiz.At(newValue);
}
function $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($thiz) {
  var x = $thiz.ye();
  if ((x === (void 0))) {
    $thiz.xZ($m_Lcom_raquo_airstream_core_Signal$().aQs());
    var nextValue = $thiz.vX();
    $f_Lcom_raquo_airstream_core_WritableSignal__setCurrentValue__s_util_Try__V($thiz, nextValue);
    var $x_1 = nextValue;
  } else {
    var $x_1 = x;
  }
  return $x_1;
}
function $f_Lcom_raquo_airstream_core_WritableSignal__fireValue__O__Lcom_raquo_airstream_core_Transaction__V($thiz, nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V($thiz, new $c_s_util_Success(nextValue), transaction);
}
function $f_Lcom_raquo_airstream_core_WritableSignal__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V($thiz, nextError, transaction) {
  $f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V($thiz, new $c_s_util_Failure(nextError), transaction);
}
function $f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V($thiz, nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableSignal__setCurrentValue__s_util_Try__V($thiz, nextValue);
  var isError = nextValue.a3R();
  var elem = false;
  elem = false;
  $thiz.gb(false);
  var this$ = $thiz.gk();
  var index = 0;
  while ((index < (this$.length | 0))) {
    var observer = this$[index];
    index = ((1 + index) | 0);
    observer.mT(nextValue);
    if ((isError && (!elem))) {
      var ev$5 = true;
      elem = ev$5;
    }
  }
  var this$$1 = $thiz.gl();
  var index$1 = 0;
  while ((index$1 < (this$$1.length | 0))) {
    var observer$1 = this$$1[index$1];
    index$1 = ((1 + index$1) | 0);
    observer$1.it(nextValue, transaction);
    if ((isError && (!elem))) {
      var ev$6 = true;
      elem = ev$6;
    }
  }
  $thiz.gb(true);
  var x = $thiz.h5();
  if ((x !== (void 0))) {
    var i = 0;
    var len = (x.length | 0);
    while ((i < len)) {
      x[i].a3();
      i = ((1 + i) | 0);
    }
    x.length = 0;
  }
  if ((isError && (!elem))) {
    nextValue.kO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((err) => {
      $m_Lcom_raquo_airstream_core_AirstreamError$().rc(err);
    })), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => (void 0))));
  }
}
function $f_Lcom_raquo_airstream_core_WritableStream__fireValue__O__Lcom_raquo_airstream_core_Transaction__V($thiz, nextValue, transaction) {
  $thiz.gb(false);
  var this$ = $thiz.gk();
  var index = 0;
  while ((index < (this$.length | 0))) {
    var observer = this$[index];
    index = ((1 + index) | 0);
    try {
      observer.bA(nextValue);
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      $m_Lcom_raquo_airstream_core_AirstreamError$().rc(new $c_Lcom_raquo_airstream_core_AirstreamError$ObserverError(e$2));
    }
  }
  var this$$1 = $thiz.gl();
  var index$1 = 0;
  while ((index$1 < (this$$1.length | 0))) {
    var observer$1 = this$$1[index$1];
    index$1 = ((1 + index$1) | 0);
    observer$1.iY(nextValue, transaction);
  }
  $thiz.gb(true);
  var x = $thiz.h5();
  if ((x !== (void 0))) {
    var i = 0;
    var len = (x.length | 0);
    while ((i < len)) {
      x[i].a3();
      i = ((1 + i) | 0);
    }
    x.length = 0;
  }
}
function $f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V($thiz, nextError, transaction) {
  $thiz.gb(false);
  var this$ = $thiz.gk();
  var index = 0;
  while ((index < (this$.length | 0))) {
    var observer = this$[index];
    index = ((1 + index) | 0);
    observer.yh(nextError);
  }
  var this$$1 = $thiz.gl();
  var index$1 = 0;
  while ((index$1 < (this$$1.length | 0))) {
    var observer$1 = this$$1[index$1];
    index$1 = ((1 + index$1) | 0);
    observer$1.iq(nextError, transaction);
  }
  $thiz.gb(true);
  var x = $thiz.h5();
  if ((x !== (void 0))) {
    var i = 0;
    var len = (x.length | 0);
    while ((i < len)) {
      x[i].a3();
      i = ((1 + i) | 0);
    }
    x.length = 0;
  }
}
function $f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V($thiz, nextValue, transaction) {
  nextValue.kO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => {
    $f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V($thiz, _$1, transaction);
  })), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => {
    $f_Lcom_raquo_airstream_core_WritableStream__fireValue__O__Lcom_raquo_airstream_core_Transaction__V($thiz, _$2, transaction);
  })));
}
/** @constructor */
function $c_Lfansi_ErrorMode$Throw$() {
}
$p = $c_Lfansi_ErrorMode$Throw$.prototype = new $h_O();
$p.constructor = $c_Lfansi_ErrorMode$Throw$;
/** @constructor */
function $h_Lfansi_ErrorMode$Throw$() {
}
$h_Lfansi_ErrorMode$Throw$.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return 80787142;
});
$p.m = (function() {
  return "Throw";
});
$p.z = (function() {
  return 0;
});
$p.B = (function() {
  return "Throw";
});
$p.A = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.Pr = (function(sourceIndex, raw) {
  var matcher = new $c_ju_regex_Matcher($m_Lfansi_Str$().asB, $dp_toString__T(raw));
  if ((!matcher.b1h(sourceIndex))) {
    var $x_1 = "";
  } else {
    var end = matcher.Ak();
    var $x_1 = (" " + $dp_subSequence__I__I__jl_CharSequence(raw, ((1 + sourceIndex) | 0), end));
  }
  throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("Unknown ansi-escape" + $x_1) + " at index ") + sourceIndex) + " inside string cannot be parsed into an fansi.Str"));
});
var $d_Lfansi_ErrorMode$Throw$ = new $TypeData().i($c_Lfansi_ErrorMode$Throw$, "fansi.ErrorMode$Throw$", ({
  qK: 1,
  qJ: 1,
  b: 1,
  c: 1,
  a: 1,
  d: 1,
  j: 1,
  r: 1
}));
var $n_Lfansi_ErrorMode$Throw$;
function $m_Lfansi_ErrorMode$Throw$() {
  if ((!$n_Lfansi_ErrorMode$Throw$)) {
    $n_Lfansi_ErrorMode$Throw$ = new $c_Lfansi_ErrorMode$Throw$();
  }
  return $n_Lfansi_ErrorMode$Throw$;
}
function $p_jl_JSConsoleBasedPrintStream__doWriteLine__T__V($thiz, line) {
  if (((typeof console) !== "undefined")) {
    if (($thiz.at0 && (!(!(!(!console.error)))))) {
      console.error(line);
    } else {
      console.log(line);
    }
  }
}
/** @constructor */
function $c_jl_JSConsoleBasedPrintStream(isErr) {
  this.at0 = false;
  this.QX = null;
  this.at0 = isErr;
  $ct_Ljava_io_PrintStream__Ljava_io_OutputStream__Z__Ljava_nio_charset_Charset__(this, new $c_jl_JSConsoleBasedPrintStream$DummyOutputStream(), false, null);
  this.QX = "";
}
$p = $c_jl_JSConsoleBasedPrintStream.prototype = new $h_Ljava_io_PrintStream();
$p.constructor = $c_jl_JSConsoleBasedPrintStream;
/** @constructor */
function $h_jl_JSConsoleBasedPrintStream() {
}
$h_jl_JSConsoleBasedPrintStream.prototype = $p;
$p.aR8 = (function(s) {
  this.a3V(((s === null) ? "null" : s));
});
$p.a3V = (function(s) {
  var rest = s;
  while ((rest !== "")) {
    var this$1 = rest;
    var nlPos = (this$1.indexOf("\n") | 0);
    if ((nlPos < 0)) {
      this.QX = (("" + this.QX) + rest);
      rest = "";
    } else {
      var $x_1 = this.QX;
      var this$2 = rest;
      $p_jl_JSConsoleBasedPrintStream__doWriteLine__T__V(this, (("" + $x_1) + this$2.substring(0, nlPos)));
      this.QX = "";
      var this$4 = rest;
      var beginIndex = ((1 + nlPos) | 0);
      rest = this$4.substring(beginIndex);
    }
  }
});
var $d_jl_JSConsoleBasedPrintStream = new $TypeData().i($c_jl_JSConsoleBasedPrintStream, "java.lang.JSConsoleBasedPrintStream", ({
  s4: 1,
  rS: 1,
  rR: 1,
  eH: 1,
  ci: 1,
  ck: 1,
  cj: 1,
  bz: 1
}));
function $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq($thiz, n, s) {
  while (true) {
    if (((n <= 0) || s.c())) {
      return s;
    } else {
      var temp$n = ((n - 1) | 0);
      var temp$s = s.v();
      n = temp$n;
      s = temp$s;
    }
  }
}
function $p_sc_StrictOptimizedLinearSeqOps__loop$3__sc_LinearSeq__F1__sc_LinearSeq($thiz, s, p$1) {
  while (((!s.c()) && (!(!p$1.i(s.t()))))) {
    s = s.v();
  }
  return s;
}
function $f_sc_StrictOptimizedMapOps__map__F1__sc_IterableOps($thiz, f) {
  var b = $thiz.im().b5();
  var it = $thiz.o();
  while (it.p()) {
    b.Y(f.i(it.q()));
  }
  return b.aR();
}
function $f_sc_StrictOptimizedMapOps__flatMap__F1__sc_IterableOps($thiz, f) {
  var b = $thiz.im().b5();
  var it = $thiz.o();
  while (it.p()) {
    b.dG(f.i(it.q()));
  }
  return b.aR();
}
function $f_sc_StrictOptimizedMapOps__concat__sc_IterableOnce__sc_IterableOps($thiz, suffix) {
  var b = $thiz.im().b5();
  b.dG($thiz);
  b.dG(suffix);
  return b.aR();
}
function $f_sc_StrictOptimizedMapOps__collect__s_PartialFunction__sc_IterableOps($thiz, pf) {
  var b = $thiz.im().b5();
  var marker = $m_sr_Statics$PFMarker$();
  var it = $thiz.o();
  while (it.p()) {
    var elem = it.q();
    var v = pf.aC(elem, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((marker) => ((x$2$2) => marker))(marker)));
    if ((marker !== v)) {
      b.Y(v);
    }
  }
  return b.aR();
}
function $f_sci_StrictOptimizedSeqOps__distinctBy__F1__O($thiz, f) {
  if (($thiz.bL(1) <= 0)) {
    return $thiz;
  } else {
    var builder = $thiz.fS();
    var seen = $ct_scm_HashSet__(new $c_scm_HashSet());
    var it = $thiz.o();
    var different = false;
    while (it.p()) {
      var next = it.q();
      if (seen.oA(f.i(next))) {
        builder.Y(next);
      } else {
        different = true;
      }
    }
    return (different ? builder.aR() : $thiz);
  }
}
function $f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O($thiz, from, other, replaced) {
  var b = $thiz.nB().b5();
  var i = 0;
  var it = $thiz.o();
  while (((i < from) && it.p())) {
    b.Y(it.q());
    i = ((1 + i) | 0);
  }
  b.dG(other);
  i = replaced;
  while (((i > 0) && it.p())) {
    it.q();
    i = ((i - 1) | 0);
  }
  while (it.p()) {
    b.Y(it.q());
  }
  return b.aR();
}
function $p_s_math_BigDecimal__computeHashCode__V($thiz) {
  if (($thiz.Ap() && ((($thiz.dN.PJ() - $thiz.dN.c9) | 0) < 4934))) {
    var $x_1 = $thiz.ba0().x();
  } else if ($thiz.b37()) {
    var $x_1 = $m_sr_Statics$().ax($thiz.dN.vY());
  } else {
    var temp = $thiz.dN.aSw();
    var $x_1 = $m_s_util_hashing_MurmurHash3$().r8(temp.b8f(temp.c9).a4Z().x(), temp.c9);
  }
  $thiz.a1V = $x_1;
}
/** @constructor */
function $c_s_math_BigDecimal(bigDecimal, mc) {
  this.dN = null;
  this.aIX = null;
  this.a1V = 0;
  this.dN = bigDecimal;
  this.aIX = mc;
  if ((bigDecimal === null)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "null value for BigDecimal");
  }
  if ((mc === null)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "null MathContext for BigDecimal");
  }
  this.a1V = 1565550863;
}
$p = $c_s_math_BigDecimal.prototype = new $h_s_math_ScalaNumber();
$p.constructor = $c_s_math_BigDecimal;
/** @constructor */
function $h_s_math_BigDecimal() {
}
$h_s_math_BigDecimal.prototype = $p;
$p.pp = (function(that) {
  return this.dN.af7(that.dN);
});
$p.x = (function() {
  if ((this.a1V === 1565550863)) {
    $p_s_math_BigDecimal__computeHashCode__V(this);
  }
  return this.a1V;
});
$p.e = (function(that) {
  if ((that instanceof $c_s_math_BigDecimal)) {
    return this.a3g(that);
  } else if ((that instanceof $c_s_math_BigInt)) {
    if ((that.aeU() > (3.3219280948873626 * ((((this.dN.PJ() - this.dN.c9) | 0) - 2) | 0)))) {
      var this$2 = this.ba1();
      if ((!this$2.c())) {
        var x0 = this$2.d();
        return that.aNK(x0);
      } else {
        return false;
      }
    } else {
      return false;
    }
  } else if (((typeof that) === "number")) {
    var x4 = (+that);
    if ((!((x4 === Infinity) || (x4 === (-Infinity))))) {
      var d = this.dN.vY();
      if (((!((d === Infinity) || (d === (-Infinity)))) && (d === x4))) {
        var this$9 = $m_s_math_BigDecimal$();
        return this.a3g(this$9.y8(d, this$9.qI));
      } else {
        return false;
      }
    } else {
      return false;
    }
  } else if ($isFloat(that)) {
    var x5 = Math.fround(that);
    if ((!((x5 === Infinity) || (x5 === (-Infinity))))) {
      var f = this.dN.DX();
      if (((!((f === Infinity) || (f === (-Infinity)))) && (f === x5))) {
        var this$16 = $m_s_math_BigDecimal$();
        return this.a3g(this$16.y8(f, this$16.qI));
      } else {
        return false;
      }
    } else {
      return false;
    }
  } else {
    return (this.Xh() && $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveEquals__O__Z(this, that));
  }
});
$p.Xf = (function() {
  try {
    this.dN.aYa();
    return true;
  } catch (e) {
    if ((e instanceof $c_jl_ArithmeticException)) {
      return false;
    } else {
      throw e;
    }
  }
});
$p.Xi = (function() {
  try {
    this.dN.b8Q();
    return true;
  } catch (e) {
    if ((e instanceof $c_jl_ArithmeticException)) {
      return false;
    } else {
      throw e;
    }
  }
});
$p.Xg = (function() {
  return ((this.Pz() && (this.dN.agy() >= 0)) && (this.dN.agy() <= 65535));
});
$p.Pz = (function() {
  try {
    this.dN.agy();
    return true;
  } catch (e) {
    if ((e instanceof $c_jl_ArithmeticException)) {
      return false;
    } else {
      throw e;
    }
  }
});
$p.Xh = (function() {
  try {
    $p_Ljava_math_BigDecimal__valueExact__I__J(this.dN, 64);
    return true;
  } catch (e) {
    if ((e instanceof $c_jl_ArithmeticException)) {
      return false;
    } else {
      throw e;
    }
  }
});
$p.b37 = (function() {
  var d = this.dN.vY();
  if ((!((d === Infinity) || (d === (-Infinity))))) {
    var this$4 = $m_s_math_BigDecimal$();
    return this.a3g(this$4.y8(d, this$4.qI));
  } else {
    return false;
  }
});
$p.Ap = (function() {
  return ((this.dN.c9 <= 0) || (this.dN.aSw().c9 <= 0));
});
$p.a3g = (function(that) {
  return (this.dN.af7(that.dN) === 0);
});
$p.Jm = (function(scale, mode) {
  if ((this.dN.c9 === scale)) {
    return this;
  } else {
    var $x_1 = this.dN;
    var mode$1 = mode.vv;
    return new $c_s_math_BigDecimal($x_1.b8J(scale, $m_Ljava_math_RoundingMode$().baZ(mode$1)), this.aIX);
  }
});
$p.P2 = (function() {
  return ((this.dN.lm() << 24) >> 24);
});
$p.PT = (function() {
  return ((this.dN.lm() << 16) >> 16);
});
$p.lm = (function() {
  return this.dN.lm();
});
$p.lY = (function() {
  return this.dN.lY();
});
$p.DX = (function() {
  return this.dN.DX();
});
$p.vY = (function() {
  return this.dN.vY();
});
$p.ba0 = (function() {
  return $ct_s_math_BigInt__Ljava_math_BigInteger__(new $c_s_math_BigInt(), this.dN.a4Z());
});
$p.ba1 = (function() {
  if (this.Ap()) {
    try {
      return new $c_s_Some($ct_s_math_BigInt__Ljava_math_BigInteger__(new $c_s_math_BigInt(), this.dN.aSR()));
    } catch (e) {
      if ((e instanceof $c_jl_ArithmeticException)) {
        return $m_s_None$();
      } else {
        throw e;
      }
    }
  } else {
    return $m_s_None$();
  }
});
$p.m = (function() {
  return this.dN.m();
});
$p.aT9 = (function() {
  return this.dN;
});
function $isArrayOf_s_math_BigDecimal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.m4)));
}
var $d_s_math_BigDecimal = new $TypeData().i($c_s_math_BigDecimal, "scala.math.BigDecimal", ({
  m4: 1,
  dY: 1,
  aP: 1,
  a: 1,
  mc: 1,
  c7: 1,
  b3: 1,
  Q: 1
}));
function $p_s_math_BigInt__longEncoding__Z($thiz) {
  var x_$_lo = $thiz.hE;
  var x_$_hi = $thiz.hF;
  return ((x_$_lo | ((-2147483648) ^ x_$_hi)) !== 0);
}
function $p_s_math_BigInt__bitLengthOverflow__Z($thiz) {
  var shifted = $thiz.DL().a4I(2147483647);
  return ((shifted.bS !== 0) && (!shifted.e($m_s_math_BigInt$().aIY)));
}
function $ct_s_math_BigInt__Ljava_math_BigInteger__J__($thiz, _bigInteger, _long_$_lo, _long_$_hi) {
  $thiz.qJ = _bigInteger;
  $thiz.hE = _long_$_lo;
  $thiz.hF = _long_$_hi;
  return $thiz;
}
function $ct_s_math_BigInt__Ljava_math_BigInteger__($thiz, bigInteger) {
  if (($m_Ljava_math_BitLevel$().DM(bigInteger) <= 63)) {
    var $x_2 = bigInteger.lY();
    var $x_1_$_lo = $x_2.l;
    var $x_1_$_hi = $x_2.h;
  } else {
    var $x_1_$_lo = 0;
    var $x_1_$_hi = (-2147483648);
  }
  $ct_s_math_BigInt__Ljava_math_BigInteger__J__($thiz, bigInteger, $x_1_$_lo, $x_1_$_hi);
  return $thiz;
}
/** @constructor */
function $c_s_math_BigInt() {
  this.qJ = null;
  this.hE = 0;
  this.hF = 0;
}
$p = $c_s_math_BigInt.prototype = new $h_s_math_ScalaNumber();
$p.constructor = $c_s_math_BigInt;
/** @constructor */
function $h_s_math_BigInt() {
}
$h_s_math_BigInt.prototype = $p;
$p.pp = (function(that) {
  return this.aYN(that);
});
$p.DL = (function() {
  var read = this.qJ;
  if ((read !== null)) {
    return read;
  } else {
    var lVal_$_lo = this.hE;
    var lVal_$_hi = this.hF;
    var write = $m_Ljava_math_BigInteger$().oI(lVal_$_lo, lVal_$_hi);
    this.qJ = write;
    return write;
  }
});
$p.x = (function() {
  return (this.Xh() ? $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveHashcode__I(this) : $m_sr_Statics$().u(this.DL()));
});
$p.e = (function(that) {
  if ((that instanceof $c_s_math_BigInt)) {
    return this.aNK(that);
  } else if ((that instanceof $c_s_math_BigDecimal)) {
    return that.e(this);
  } else if (((typeof that) === "number")) {
    var x4 = (+that);
    return (this.b3v() && (this.vY() === x4));
  } else if ($isFloat(that)) {
    var x5 = Math.fround(that);
    return (this.b3w() && ($m_jl_Float$().a4m($m_Ljava_math_Conversion$().yn(this.DL())) === x5));
  } else {
    return (this.Xh() && $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveEquals__O__Z(this, that));
  }
});
$p.Xf = (function() {
  var x_$_lo = this.hE;
  var x_$_hi = this.hF;
  if (((x_$_hi === (-1)) ? ((x_$_lo >>> 0) >= 4294967168) : (x_$_hi > (-1)))) {
    var x$1_$_lo = this.hE;
    var x$1_$_hi = this.hF;
    return ((x$1_$_hi === 0) ? ((x$1_$_lo >>> 0) <= 127) : (x$1_$_hi < 0));
  } else {
    return false;
  }
});
$p.Xi = (function() {
  var x_$_lo = this.hE;
  var x_$_hi = this.hF;
  if (((x_$_hi === (-1)) ? ((x_$_lo >>> 0) >= 4294934528) : (x_$_hi > (-1)))) {
    var x$1_$_lo = this.hE;
    var x$1_$_hi = this.hF;
    return ((x$1_$_hi === 0) ? ((x$1_$_lo >>> 0) <= 32767) : (x$1_$_hi < 0));
  } else {
    return false;
  }
});
$p.Xg = (function() {
  var x_$_lo = this.hE;
  var x_$_hi = this.hF;
  if ((x_$_hi >= 0)) {
    var x$1_$_lo = this.hE;
    var x$1_$_hi = this.hF;
    return ((x$1_$_hi === 0) ? ((x$1_$_lo >>> 0) <= 65535) : (x$1_$_hi < 0));
  } else {
    return false;
  }
});
$p.Pz = (function() {
  var x_$_lo = this.hE;
  var x_$_hi = this.hF;
  if (((x_$_hi === (-1)) ? ((x_$_lo >>> 0) >= 2147483648) : (x_$_hi > (-1)))) {
    var x$1_$_lo = this.hE;
    var x$1_$_hi = this.hF;
    return ((x$1_$_hi === 0) ? ((x$1_$_lo >>> 0) <= 2147483647) : (x$1_$_hi < 0));
  } else {
    return false;
  }
});
$p.Xh = (function() {
  return ($p_s_math_BigInt__longEncoding__Z(this) || $m_sr_BoxesRunTime$().afx(this.qJ, $m_s_math_BigInt$().adl));
});
$p.b3w = (function() {
  var bitLen = this.aeU();
  if ((bitLen <= 24)) {
    var $x_1 = true;
  } else {
    var lowest = this.aQ4();
    var $x_1 = (((bitLen <= 128) && (lowest >= ((bitLen - 24) | 0))) && (lowest < 128));
  }
  if ($x_1) {
    return (!$p_s_math_BigInt__bitLengthOverflow__Z(this));
  } else {
    return false;
  }
});
$p.b3v = (function() {
  var bitLen = this.aeU();
  if ((bitLen <= 53)) {
    var $x_1 = true;
  } else {
    var lowest = this.aQ4();
    var $x_1 = (((bitLen <= 1024) && (lowest >= ((bitLen - 53) | 0))) && (lowest < 1024));
  }
  if ($x_1) {
    return (!$p_s_math_BigInt__bitLengthOverflow__Z(this));
  } else {
    return false;
  }
});
$p.Ap = (function() {
  return true;
});
$p.aNK = (function(that) {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    if ($p_s_math_BigInt__longEncoding__Z(that)) {
      var x_$_lo = this.hE;
      var x_$_hi = this.hF;
      var x$1_$_lo = that.hE;
      var x$1_$_hi = that.hF;
      return (((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0);
    } else {
      return false;
    }
  } else {
    return ((!$p_s_math_BigInt__longEncoding__Z(that)) && $m_sr_BoxesRunTime$().afx(this.qJ, that.qJ));
  }
});
$p.aYN = (function(that) {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    if ($p_s_math_BigInt__longEncoding__Z(that)) {
      var x_$_lo = this.hE;
      var x_$_hi = this.hF;
      var y_$_lo = that.hE;
      var y_$_hi = that.hF;
      return ((x_$_hi === y_$_hi) ? ((x_$_lo === y_$_lo) ? 0 : (((x_$_lo >>> 0) < (y_$_lo >>> 0)) ? (-1) : 1)) : ((x_$_hi < y_$_hi) ? (-1) : 1));
    } else {
      return ((-that.qJ.bS) | 0);
    }
  } else {
    return ($p_s_math_BigInt__longEncoding__Z(that) ? this.qJ.bS : this.qJ.Ah(that.qJ));
  }
});
$p.aQ4 = (function() {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    var x_$_lo = this.hE;
    var x_$_hi = this.hF;
    if (((x_$_lo | x_$_hi) === 0)) {
      return (-1);
    } else {
      var l_$_lo = this.hE;
      var l_$_hi = this.hF;
      return ((l_$_lo !== 0) ? ((32 - Math.clz32(((~l_$_lo) & ((l_$_lo - 1) | 0)))) | 0) : ((64 - Math.clz32(((~l_$_hi) & ((l_$_hi - 1) | 0)))) | 0));
    }
  } else {
    return this.DL().aOU();
  }
});
$p.aeU = (function() {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    var x_$_lo = this.hE;
    var x_$_hi = this.hF;
    if ((x_$_hi < 0)) {
      var x$1_$_lo = this.hE;
      var x$1_$_hi = this.hF;
      var lo = ((1 + x$1_$_lo) | 0);
      var hi = ((x$1_$_hi + ((lo === 0) | 0)) | 0);
      var lo$1 = ((-lo) | 0);
      var hi$1 = ((((-hi) | 0) - ((lo$1 !== 0) | 0)) | 0);
      return ((64 - ((hi$1 !== 0) ? Math.clz32(hi$1) : ((32 + Math.clz32(lo$1)) | 0))) | 0);
    } else {
      var l_$_lo = this.hE;
      var l_$_hi = this.hF;
      return ((64 - ((l_$_hi !== 0) ? Math.clz32(l_$_hi) : ((32 + Math.clz32(l_$_lo)) | 0))) | 0);
    }
  } else {
    return $m_Ljava_math_BitLevel$().DM(this.qJ);
  }
});
$p.P2 = (function() {
  return ((this.lm() << 24) >> 24);
});
$p.PT = (function() {
  return ((this.lm() << 16) >> 16);
});
$p.lm = (function() {
  return ($p_s_math_BigInt__longEncoding__Z(this) ? $s_RTLong__toInt__I__I__I(this.hE, this.hF) : this.DL().lm());
});
$p.lY = (function() {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    return $bL(this.hE, this.hF);
  } else {
    return this.qJ.lY();
  }
});
$p.DX = (function() {
  return $m_jl_Float$().a4m($m_Ljava_math_Conversion$().yn(this.DL()));
});
$p.vY = (function() {
  if (this.Xh()) {
    var x_$_lo = this.hE;
    var x_$_hi = this.hF;
    if ((x_$_hi >= (-2097152))) {
      var x$1_$_lo = this.hE;
      var x$1_$_hi = this.hF;
      var $x_1 = ((x$1_$_hi === 2097152) ? (x$1_$_lo === 0) : (x$1_$_hi < 2097152));
    } else {
      var $x_1 = false;
    }
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    var x$2_$_lo = this.hE;
    var x$2_$_hi = this.hF;
    return ((4.294967296E9 * x$2_$_hi) + (x$2_$_lo >>> 0.0));
  } else {
    return $m_jl_Double$().bd($m_Ljava_math_Conversion$().yn(this.DL()));
  }
});
$p.m = (function() {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    var this$1_$_lo = this.hE;
    var this$1_$_hi = this.hF;
    return $m_RTLong$().kY(this$1_$_lo, this$1_$_hi);
  } else {
    return $m_Ljava_math_Conversion$().yn(this.qJ);
  }
});
$p.aT9 = (function() {
  return this.DL();
});
function $isArrayOf_s_math_BigInt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.m5)));
}
var $d_s_math_BigInt = new $TypeData().i($c_s_math_BigInt, "scala.math.BigInt", ({
  m5: 1,
  dY: 1,
  aP: 1,
  a: 1,
  mc: 1,
  c7: 1,
  b3: 1,
  Q: 1
}));
function $f_s_math_Numeric$DoubleIsFractional__plus__D__D__D($thiz, x, y) {
  return (x + y);
}
function $f_s_math_Numeric$IntIsIntegral__plus__I__I__I($thiz, x, y) {
  return ((x + y) | 0);
}
function $f_s_math_Numeric$LongIsIntegral__plus__J__J__J($thiz, x_$_lo, x_$_hi, y_$_lo, y_$_hi) {
  var lo = ((x_$_lo + y_$_lo) | 0);
  var hi = ((((x_$_hi + y_$_hi) | 0) + (((lo >>> 0) < (x_$_lo >>> 0)) | 0)) | 0);
  return $bL(lo, hi);
}
/** @constructor */
function $c_s_math_Ordering$Int$() {
  this.aJ0 = null;
  $n_s_math_Ordering$Int$ = this;
  this.aJ0 = new $c_s_math_Ordering$Reverse(this);
}
$p = $c_s_math_Ordering$Int$.prototype = new $h_O();
$p.constructor = $c_s_math_Ordering$Int$;
/** @constructor */
function $h_s_math_Ordering$Int$() {
}
$h_s_math_Ordering$Int$.prototype = $p;
$p.mO = (function(other) {
  return $f_s_math_Ordering$CachedReverse__isReverseOf__s_math_Ordering__Z(this, other);
});
$p.mQ = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$p.mM = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$p.lZ = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$p.mL = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$p.kQ = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$p.kR = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$p.dA = (function(x, y) {
  var x$1 = (x | 0);
  var y$1 = (y | 0);
  return ((x$1 === y$1) ? 0 : ((x$1 < y$1) ? (-1) : 1));
});
var $d_s_math_Ordering$Int$ = new $TypeData().i($c_s_math_Ordering$Int$, "scala.math.Ordering$Int$", ({
  L7: 1,
  m7: 1,
  ax: 1,
  ad: 1,
  ay: 1,
  aw: 1,
  a: 1,
  KZ: 1
}));
var $n_s_math_Ordering$Int$;
function $m_s_math_Ordering$Int$() {
  if ((!$n_s_math_Ordering$Int$)) {
    $n_s_math_Ordering$Int$ = new $c_s_math_Ordering$Int$();
  }
  return $n_s_math_Ordering$Int$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$BooleanManifest() {
  this.gO = null;
}
$p = $c_s_reflect_ManifestFactory$BooleanManifest.prototype = new $h_s_reflect_AnyValManifest();
$p.constructor = $c_s_reflect_ManifestFactory$BooleanManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$BooleanManifest() {
}
$h_s_reflect_ManifestFactory$BooleanManifest.prototype = $p;
$p.h8 = (function() {
  return $d_Z.l();
});
$p.b2 = (function(len) {
  return new $ac_Z(len);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$ByteManifest() {
  this.gO = null;
}
$p = $c_s_reflect_ManifestFactory$ByteManifest.prototype = new $h_s_reflect_AnyValManifest();
$p.constructor = $c_s_reflect_ManifestFactory$ByteManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$ByteManifest() {
}
$h_s_reflect_ManifestFactory$ByteManifest.prototype = $p;
$p.h8 = (function() {
  return $d_B.l();
});
$p.b2 = (function(len) {
  return new $ac_B(len);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$CharManifest() {
  this.gO = null;
}
$p = $c_s_reflect_ManifestFactory$CharManifest.prototype = new $h_s_reflect_AnyValManifest();
$p.constructor = $c_s_reflect_ManifestFactory$CharManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$CharManifest() {
}
$h_s_reflect_ManifestFactory$CharManifest.prototype = $p;
$p.h8 = (function() {
  return $d_C.l();
});
$p.b2 = (function(len) {
  return new $ac_C(len);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$DoubleManifest() {
  this.gO = null;
}
$p = $c_s_reflect_ManifestFactory$DoubleManifest.prototype = new $h_s_reflect_AnyValManifest();
$p.constructor = $c_s_reflect_ManifestFactory$DoubleManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$DoubleManifest() {
}
$h_s_reflect_ManifestFactory$DoubleManifest.prototype = $p;
$p.h8 = (function() {
  return $d_D.l();
});
$p.b2 = (function(len) {
  return new $ac_D(len);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$FloatManifest() {
  this.gO = null;
}
$p = $c_s_reflect_ManifestFactory$FloatManifest.prototype = new $h_s_reflect_AnyValManifest();
$p.constructor = $c_s_reflect_ManifestFactory$FloatManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$FloatManifest() {
}
$h_s_reflect_ManifestFactory$FloatManifest.prototype = $p;
$p.h8 = (function() {
  return $d_F.l();
});
$p.b2 = (function(len) {
  return new $ac_F(len);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$IntManifest() {
  this.gO = null;
}
$p = $c_s_reflect_ManifestFactory$IntManifest.prototype = new $h_s_reflect_AnyValManifest();
$p.constructor = $c_s_reflect_ManifestFactory$IntManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$IntManifest() {
}
$h_s_reflect_ManifestFactory$IntManifest.prototype = $p;
$p.h8 = (function() {
  return $d_I.l();
});
$p.b2 = (function(len) {
  return new $ac_I(len);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$LongManifest() {
  this.gO = null;
}
$p = $c_s_reflect_ManifestFactory$LongManifest.prototype = new $h_s_reflect_AnyValManifest();
$p.constructor = $c_s_reflect_ManifestFactory$LongManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$LongManifest() {
}
$h_s_reflect_ManifestFactory$LongManifest.prototype = $p;
$p.h8 = (function() {
  return $d_J.l();
});
$p.b2 = (function(len) {
  return new $ac_J(len);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$PhantomManifest() {
  this.A7 = null;
}
$p = $c_s_reflect_ManifestFactory$PhantomManifest.prototype = new $h_s_reflect_ManifestFactory$ClassTypeManifest();
$p.constructor = $c_s_reflect_ManifestFactory$PhantomManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$PhantomManifest() {
}
$h_s_reflect_ManifestFactory$PhantomManifest.prototype = $p;
$p.m = (function() {
  return this.A7;
});
$p.e = (function(that) {
  return (this === that);
});
$p.x = (function() {
  return $systemIdentityHashCode(this);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$ShortManifest() {
  this.gO = null;
}
$p = $c_s_reflect_ManifestFactory$ShortManifest.prototype = new $h_s_reflect_AnyValManifest();
$p.constructor = $c_s_reflect_ManifestFactory$ShortManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$ShortManifest() {
}
$h_s_reflect_ManifestFactory$ShortManifest.prototype = $p;
$p.h8 = (function() {
  return $d_S.l();
});
$p.b2 = (function(len) {
  return new $ac_S(len);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$UnitManifest() {
  this.gO = null;
}
$p = $c_s_reflect_ManifestFactory$UnitManifest.prototype = new $h_s_reflect_AnyValManifest();
$p.constructor = $c_s_reflect_ManifestFactory$UnitManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$UnitManifest() {
}
$h_s_reflect_ManifestFactory$UnitManifest.prototype = $p;
$p.h8 = (function() {
  return $d_V.l();
});
$p.b2 = (function(len) {
  return new ($d_jl_Void.r().C)(len);
});
/** @constructor */
function $c_Lujson_Value$() {
}
$p = $c_Lujson_Value$.prototype = new $h_O();
$p.constructor = $c_Lujson_Value$;
/** @constructor */
function $h_Lujson_Value$() {
}
$h_Lujson_Value$.prototype = $p;
$p.ge = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.eY = (function(d, index) {
  return $f_Lujson_JsVisitor__visitFloat32__F__I__O(this, d, index);
});
$p.em = (function(i, index) {
  return $f_Lujson_JsVisitor__visitInt32__I__I__O(this, i, index);
});
$p.eZ = (function(i_$_lo, i_$_hi, index) {
  return $f_Lujson_JsVisitor__visitInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.fe = (function(i_$_lo, i_$_hi, index) {
  return $f_Lujson_JsVisitor__visitUInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.fA = (function(s, index) {
  return $f_Lujson_JsVisitor__visitFloat64String__T__I__O(this, s, index);
});
$p.fb = (function(bytes, offset, len, index) {
  return $f_Lujson_JsVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.fd = (function(tag, bytes, offset, len, index) {
  return $f_Lujson_JsVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.fc = (function(s, index) {
  return new $c_Lujson_Str(("" + $cToS(s)));
});
$p.bQ = (function(length, jsonableKeys, index) {
  return $f_Lujson_JsVisitor__visitObject__I__Z__I__Lupickle_core_ObjVisitor(this, length, jsonableKeys, index);
});
$p.yp = (function(j, f) {
  if (($m_Lujson_Null$() === j)) {
    return f.c8((-1));
  }
  if (($m_Lujson_True$() === j)) {
    return f.eE((-1));
  }
  if (($m_Lujson_False$() === j)) {
    return f.eC((-1));
  }
  if ((j instanceof $c_Lujson_Str)) {
    var x56 = j.xP;
    return f.cN(x56, (-1));
  }
  if ((j instanceof $c_Lujson_Num)) {
    var x53 = j.HQ;
    return f.e7(x53, (-1));
  }
  if ((j instanceof $c_Lujson_Arr)) {
    return $f_Lujson_AstTransformer__transformArray__Lupickle_core_Visitor__sc_Iterable__O(this, f, j.Dj);
  }
  if ((j instanceof $c_Lujson_Obj)) {
    return $f_Lujson_AstTransformer__transformObject__Lupickle_core_Visitor__sc_Iterable__O(this, f, j.tM);
  }
  throw new $c_s_MatchError(j);
});
$p.cZ = (function(length, index) {
  return new $c_Lujson_AstTransformer$AstArrVisitor(this, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((xs) => new $c_Lujson_Arr(xs))), new $c_sc_IterableFactory$ToFactory($m_scm_ArrayBuffer$()));
});
$p.aTn = (function(length, index) {
  return new $c_Lujson_AstTransformer$AstObjVisitor(this, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((xs) => new $c_Lujson_Obj(xs))), new $c_Lupickle_core_compat_LinkedHashMapCompat$$anon$1());
});
$p.bbK = (function(s, decIndex, expIndex, index) {
  if (((((~decIndex) | (~expIndex)) !== 0) || ($dp_length__I(s) >= 19))) {
    var $x_1 = $m_jl_Double$().bd($dp_toString__T(s));
  } else {
    var $x_2 = $m_Lupickle_core_ParseUtils$().PI(s, decIndex, expIndex, index);
    var x$1_$_lo = $x_2.l;
    var x$1_$_hi = $x_2.h;
    var $x_1 = ((4.294967296E9 * x$1_$_hi) + (x$1_$_lo >>> 0.0));
  }
  return new $c_Lujson_Num($x_1);
});
$p.cy = (function(j, f) {
  return this.yp(j, f);
});
$p.c8 = (function(index) {
  return $m_Lujson_Null$();
});
$p.eC = (function(index) {
  return $m_Lujson_False$();
});
$p.eE = (function(index) {
  return $m_Lujson_True$();
});
$p.eD = (function(s, decIndex, expIndex, index) {
  return this.bbK(s, decIndex, expIndex, index);
});
$p.e7 = (function(d, index) {
  return new $c_Lujson_Num(d);
});
$p.cN = (function(s, index) {
  return new $c_Lujson_Str($dp_toString__T(s));
});
var $d_Lujson_Value$ = new $TypeData().i($c_Lujson_Value$, "ujson.Value$", ({
  NI: 1,
  B: 1,
  e5: 1,
  x: 1,
  e4: 1,
  Nq: 1,
  d: 1,
  u: 1
}));
var $n_Lujson_Value$;
function $m_Lujson_Value$() {
  if ((!$n_Lujson_Value$)) {
    $n_Lujson_Value$ = new $c_Lujson_Value$();
  }
  return $n_Lujson_Value$;
}
/** @constructor */
function $c_Lupickle_Api$$anon$3(readwriter$1, outer) {
  this.iH = null;
  this.a2k = null;
  this.aJE = null;
  this.aJE = readwriter$1;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_Lupickle_core_Types$ReadWriter$Delegate__Lupickle_core_Types$ReadWriter$__Lupickle_core_Visitor__(this, outer.cw(), readwriter$1);
}
$p = $c_Lupickle_Api$$anon$3.prototype = new $h_Lupickle_core_Types$ReadWriter$Delegate();
$p.constructor = $c_Lupickle_Api$$anon$3;
/** @constructor */
function $h_Lupickle_Api$$anon$3() {
}
$h_Lupickle_Api$$anon$3.prototype = $p;
$p.cT = (function() {
  return true;
});
$p.d0 = (function(out, v) {
  return this.aJE.d0(out, v);
});
var $d_Lupickle_Api$$anon$3 = new $TypeData().i($c_Lupickle_Api$$anon$3, "upickle.Api$$anon$3", ({
  NS: 1,
  OJ: 1,
  bJ: 1,
  x: 1,
  D: 1,
  B: 1,
  E: 1,
  cX: 1
}));
function $f_Lcom_raquo_airstream_common_MultiParentSignal___parentLastUpdateIds__Lcom_raquo_ew_JsArray($thiz) {
  return $thiz.Qh.map(((_$1) => _$1.jk()));
}
function $f_Lcom_raquo_airstream_common_MultiParentSignal__onWillStart__V($thiz) {
  var arr = $thiz.Qh;
  var i = 0;
  var len = (arr.length | 0);
  while ((i < len)) {
    $f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(arr[i]);
    i = ((1 + i) | 0);
  }
  if ($f_Lcom_raquo_airstream_common_MultiParentSignal__updateParentLastUpdateIds__Z($thiz)) {
    $f_Lcom_raquo_airstream_common_MultiParentSignal__updateCurrentValueFromParent__V($thiz);
  }
}
function $f_Lcom_raquo_airstream_common_MultiParentSignal__updateParentLastUpdateIds__Z($thiz) {
  var elem = false;
  elem = false;
  var arr = $thiz.Qh;
  var i = 0;
  var len = (arr.length | 0);
  while ((i < len)) {
    var parent = arr[i];
    var ix = i;
    var newLastUpdateId = parent.jk();
    if ((newLastUpdateId !== ($thiz.aLJ()[ix] | 0))) {
      $thiz.aLJ()[ix] = newLastUpdateId;
      var ev$3 = true;
      elem = ev$3;
    }
    i = ((1 + i) | 0);
  }
  return elem;
}
function $f_Lcom_raquo_airstream_common_MultiParentSignal__updateCurrentValueFromParent__V($thiz) {
  $f_Lcom_raquo_airstream_core_WritableSignal__setCurrentValue__s_util_Try__V($thiz, $thiz.a2V());
}
function $f_Lcom_raquo_airstream_common_MultiParentStream__onWillStart__V($thiz) {
  var arr = $thiz.aiY;
  var i = 0;
  var len = (arr.length | 0);
  while ((i < len)) {
    $f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(arr[i]);
    i = ((1 + i) | 0);
  }
}
function $p_Lcom_raquo_airstream_timing_JsPromiseSignal__onPromiseResolved__s_util_Try__V($thiz, nextPromiseValue) {
  new $c_Lcom_raquo_airstream_core_Transaction(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((nextValue) => ((_$2) => {
    $f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V($thiz, nextValue, _$2);
  }))(nextPromiseValue.ua(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => new $c_s_Some(_$1)))))));
}
/** @constructor */
function $c_Lcom_raquo_airstream_timing_JsPromiseSignal(promise) {
  this.am5 = null;
  this.am4 = false;
  this.am6 = null;
  this.a69 = 0;
  this.am2 = null;
  this.am3 = null;
  this.am9 = false;
  this.a6a = null;
  this.am7 = null;
  this.am8 = 0;
  this.a6b = false;
  this.am7 = promise;
  this.am5 = (void 0);
  $f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  this.a69 = 0;
  $f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.a6a = (void 0);
  this.am8 = 1;
  this.a6b = false;
  $f_Lcom_raquo_airstream_core_WritableSignal__setCurrentValue__s_util_Try__V(this, new $c_s_util_Success($m_s_None$()));
}
$p = $c_Lcom_raquo_airstream_timing_JsPromiseSignal.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_timing_JsPromiseSignal;
/** @constructor */
function $h_Lcom_raquo_airstream_timing_JsPromiseSignal() {
}
$h_Lcom_raquo_airstream_timing_JsPromiseSignal.prototype = $p;
$p.fx = (function() {
  return this.am5;
});
$p.eU = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$p.m = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.hR = (function() {
  return this.am4;
});
$p.h5 = (function() {
  return this.am6;
});
$p.gb = (function(x$1) {
  this.am4 = x$1;
});
$p.hS = (function(x$1) {
  this.am6 = x$1;
});
$p.is = (function() {
});
$p.e = (function(obj) {
  return (this === obj);
});
$p.x = (function() {
  return $systemIdentityHashCode(this);
});
$p.jk = (function() {
  return this.a69;
});
$p.xZ = (function(x$1) {
  this.a69 = x$1;
});
$p.dP = (function() {
  return this;
});
$p.ir = (function() {
  $f_Lcom_raquo_airstream_core_Signal__onStart__V(this);
});
$p.ip = (function(observer) {
  observer.mT($f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this));
});
$p.gk = (function() {
  return this.am2;
});
$p.gl = (function() {
  return this.am3;
});
$p.iA = (function() {
  return this.am9;
});
$p.hs = (function(x$1) {
  this.am9 = x$1;
});
$p.ig = (function(x$0) {
  this.am2 = x$0;
});
$p.ih = (function(x$0) {
  this.am3 = x$0;
});
$p.ye = (function() {
  return this.a6a;
});
$p.At = (function(x$1) {
  this.a6a = x$1;
});
$p.aq = (function() {
  return $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this);
});
$p.ik = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.eB = (function() {
  return this.am8;
});
$p.vX = (function() {
  return $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this);
});
$p.iu = (function() {
  if ((!this.a6b)) {
    this.a6b = true;
    this.am7.then(((nextValue) => {
      $p_Lcom_raquo_airstream_timing_JsPromiseSignal__onPromiseResolved__s_util_Try__V(this, new $c_s_util_Success(nextValue));
    }), $m_sjs_js_defined$().Wd($m_sjs_js_Any$().Pn(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((rawException) => {
      $p_Lcom_raquo_airstream_timing_JsPromiseSignal__onPromiseResolved__s_util_Try__V(this, new $c_s_util_Failure(((rawException instanceof $c_jl_Throwable) ? rawException : new $c_sjs_js_JavaScriptException(rawException))));
    })))));
  }
});
$p.fQ = (function(project) {
  return $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), this, project, $m_s_None$());
});
$p.ii = (function(isSame) {
  return new $c_Lcom_raquo_airstream_distinct_DistinctSignal(this, isSame, false);
});
$p.dM = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_timing_JsPromiseSignal = new $TypeData().i($c_Lcom_raquo_airstream_timing_JsPromiseSignal, "com.raquo.airstream.timing.JsPromiseSignal", ({
  oS: 1,
  P: 1,
  O: 1,
  U: 1,
  V: 1,
  aB: 1,
  aD: 1,
  Z: 1,
  aS: 1
}));
/** @constructor */
function $c_Lcom_raquo_airstream_timing_JsPromiseStream(promise, emitOnce) {
  this.ame = null;
  this.amd = false;
  this.amf = null;
  this.amb = null;
  this.amc = null;
  this.ami = false;
  this.amg = null;
  this.ama = false;
  this.amh = 0;
  this.a6c = false;
  this.QK = false;
  this.amg = promise;
  this.ama = emitOnce;
  this.ame = (void 0);
  $f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  $f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.amh = 1;
  this.a6c = true;
  this.QK = false;
}
$p = $c_Lcom_raquo_airstream_timing_JsPromiseStream.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_timing_JsPromiseStream;
/** @constructor */
function $h_Lcom_raquo_airstream_timing_JsPromiseStream() {
}
$h_Lcom_raquo_airstream_timing_JsPromiseStream.prototype = $p;
$p.fx = (function() {
  return this.ame;
});
$p.eU = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$p.m = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.hR = (function() {
  return this.amd;
});
$p.h5 = (function() {
  return this.amf;
});
$p.gb = (function(x$1) {
  this.amd = x$1;
});
$p.hS = (function(x$1) {
  this.amf = x$1;
});
$p.ir = (function() {
});
$p.is = (function() {
});
$p.e = (function(obj) {
  return (this === obj);
});
$p.x = (function() {
  return $systemIdentityHashCode(this);
});
$p.ip = (function(observer) {
});
$p.mY = (function() {
  return this;
});
$p.gk = (function() {
  return this.amb;
});
$p.gl = (function() {
  return this.amc;
});
$p.iA = (function() {
  return this.ami;
});
$p.hs = (function(x$1) {
  this.ami = x$1;
});
$p.ig = (function(x$0) {
  this.amb = x$0;
});
$p.ih = (function(x$0) {
  this.amc = x$0;
});
$p.ik = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.eB = (function() {
  return this.amh;
});
$p.iu = (function() {
  if ((this.a6c && (!this.QK))) {
    if (this.ama) {
      this.a6c = false;
    }
    this.QK = true;
    this.amg.then(((nextValue) => {
      this.QK = false;
      new $c_Lcom_raquo_airstream_core_Transaction(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => {
        $f_Lcom_raquo_airstream_core_WritableStream__fireValue__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, _$1);
      })));
    }), $m_sjs_js_defined$().Wd($m_sjs_js_Any$().Pn(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((rawException) => {
      this.QK = false;
      new $c_Lcom_raquo_airstream_core_Transaction(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((nextError) => ((_$2) => {
        $f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, _$2);
      }))(((rawException instanceof $c_jl_Throwable) ? rawException : new $c_sjs_js_JavaScriptException(rawException)))));
    })))));
  }
});
$p.fQ = (function(project) {
  return new $c_Lcom_raquo_airstream_misc_MapStream(this, project, $m_s_None$());
});
$p.ii = (function(isSame) {
  return new $c_Lcom_raquo_airstream_distinct_DistinctStream(this, isSame, false);
});
$p.dM = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_timing_JsPromiseStream = new $TypeData().i($c_Lcom_raquo_airstream_timing_JsPromiseStream, "com.raquo.airstream.timing.JsPromiseStream", ({
  oT: 1,
  P: 1,
  O: 1,
  U: 1,
  V: 1,
  al: 1,
  am: 1,
  Z: 1,
  aq: 1
}));
/** @constructor */
function $c_Lcom_raquo_airstream_web_FetchStream(url, requestInit, maybeAbortController, maybeAbortStream, shouldAbortOnStop, emitOnce) {
  this.amB = null;
  this.amx = false;
  this.amC = null;
  this.amv = null;
  this.amw = null;
  this.amH = false;
  this.amG = null;
  this.amD = null;
  this.amy = null;
  this.amz = null;
  this.amE = false;
  this.amu = false;
  this.amF = 0;
  this.a6k = false;
  this.amA = null;
  this.amG = url;
  this.amD = requestInit;
  this.amy = maybeAbortController;
  this.amz = maybeAbortStream;
  this.amE = shouldAbortOnStop;
  this.amu = emitOnce;
  this.amB = (void 0);
  $f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  $f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.amF = 1;
  this.a6k = false;
  this.amA = ((maybeAbortStream === (void 0)) ? (void 0) : $m_Lcom_raquo_airstream_core_InternalObserver$().aMa(new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((_$6, _$7) => {
    if ((maybeAbortController === (void 0))) {
      var $x_1;
      throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "undefined.get");
    } else {
      var $x_1 = maybeAbortController;
    }
    $x_1.abort();
  })), new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((err, _$8) => {
    new $c_Lcom_raquo_airstream_core_Transaction(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((err$2) => ((_$9) => {
      $f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, err$2, _$9);
    }))(err)));
  }))));
}
$p = $c_Lcom_raquo_airstream_web_FetchStream.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_web_FetchStream;
/** @constructor */
function $h_Lcom_raquo_airstream_web_FetchStream() {
}
$h_Lcom_raquo_airstream_web_FetchStream.prototype = $p;
$p.fx = (function() {
  return this.amB;
});
$p.eU = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$p.m = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.hR = (function() {
  return this.amx;
});
$p.h5 = (function() {
  return this.amC;
});
$p.gb = (function(x$1) {
  this.amx = x$1;
});
$p.hS = (function(x$1) {
  this.amC = x$1;
});
$p.ir = (function() {
});
$p.e = (function(obj) {
  return (this === obj);
});
$p.x = (function() {
  return $systemIdentityHashCode(this);
});
$p.ip = (function(observer) {
});
$p.mY = (function() {
  return this;
});
$p.gk = (function() {
  return this.amv;
});
$p.gl = (function() {
  return this.amw;
});
$p.iA = (function() {
  return this.amH;
});
$p.hs = (function(x$1) {
  this.amH = x$1;
});
$p.ig = (function(x$0) {
  this.amv = x$0;
});
$p.ih = (function(x$0) {
  this.amw = x$0;
});
$p.ik = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.eB = (function() {
  return this.amF;
});
$p.iu = (function() {
  if ((!(this.amu && this.a6k))) {
    var x = this.amz;
    if ((x !== (void 0))) {
      var x$1 = this.amA;
      if ((x$1 === (void 0))) {
        throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "undefined.get");
      }
      $f_Lcom_raquo_airstream_core_WritableObservable__addInternalObserver__Lcom_raquo_airstream_core_InternalObserver__Z__V(x, x$1, true);
    }
    $m_sjs_js_timers_package$().ym(0.0, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d(((responsePromise) => (() => {
      new $c_Lcom_raquo_airstream_core_Transaction(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$10) => {
        $f_Lcom_raquo_airstream_core_WritableStream__fireValue__O__Lcom_raquo_airstream_core_Transaction__V(this, responsePromise, _$10);
      })));
    }))(fetch(this.amG, this.amD))));
    this.a6k = true;
  }
});
$p.is = (function() {
  if (this.amE) {
    var x = this.amy;
    if ((x === (void 0))) {
      var $x_1;
      throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "undefined.get");
    } else {
      var $x_1 = x;
    }
    $x_1.abort();
  }
});
$p.fQ = (function(project) {
  return new $c_Lcom_raquo_airstream_misc_MapStream(this, project, $m_s_None$());
});
$p.ii = (function(isSame) {
  return new $c_Lcom_raquo_airstream_distinct_DistinctStream(this, isSame, false);
});
$p.dM = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_web_FetchStream = new $TypeData().i($c_Lcom_raquo_airstream_web_FetchStream, "com.raquo.airstream.web.FetchStream", ({
  p0: 1,
  P: 1,
  O: 1,
  U: 1,
  V: 1,
  al: 1,
  am: 1,
  Z: 1,
  aq: 1
}));
function $ct_ju_Collections$UnmodifiableSet__ju_Set__($thiz, inner) {
  $ct_ju_Collections$UnmodifiableCollection__ju_Collection__($thiz, inner);
  return $thiz;
}
/** @constructor */
function $c_ju_Collections$UnmodifiableSet() {
  this.B7 = null;
}
$p = $c_ju_Collections$UnmodifiableSet.prototype = new $h_ju_Collections$UnmodifiableCollection();
$p.constructor = $c_ju_Collections$UnmodifiableSet;
/** @constructor */
function $h_ju_Collections$UnmodifiableSet() {
}
$h_ju_Collections$UnmodifiableSet.prototype = $p;
$p.e = (function(obj) {
  return this.B7.e(obj);
});
$p.x = (function() {
  return this.B7.x();
});
function $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__maxArrowSequence__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Lorg_jpablo_graphexplorer_viewer_models_NodeId__I($thiz, source, target) {
  var seqs = $thiz.fX.e6().bw(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((a) => {
    var x = a.bX;
    if (((x === null) ? (source === null) : x.e(source))) {
      var x$3 = a.c0;
      return ((x$3 === null) ? (target === null) : x$3.e(target));
    } else {
      return false;
    }
  }))).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$13) => _$13.jH))).bM();
  return (seqs.c() ? 0 : ($f_sc_IterableOnceOps__max__s_math_Ordering__O(seqs, $m_s_math_Ordering$Int$()) | 0));
}
function $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__rekeyArrowMembership__Lorg_jpablo_graphexplorer_viewer_models_ArrowId__Lorg_jpablo_graphexplorer_viewer_models_ArrowId__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph($thiz, oldId, newId) {
  if (((oldId === null) ? (newId === null) : oldId.e(newId))) {
    return $thiz;
  } else {
    var this$14 = new $c_Lcom_softwaremill_quicklens_package$PathModify($thiz, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$3) => new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements($thiz.aA.gr, $thiz.aA.gH, $thiz.aA.gq, x$3.i($thiz.aA.gp), $thiz.aA.fh, $thiz.aA.dW, $thiz.aA.fE, $thiz.aA.fD), $thiz.j7, $thiz.iC, $thiz.jG, $thiz.jF, $thiz.i0))));
    var mod = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((am) => {
      var x14 = am.r(oldId);
      if ((x14 instanceof $c_s_Some)) {
        var groupId = x14.J;
        return am.fz(oldId).bN(newId, groupId);
      }
      if (($m_s_None$() === x14)) {
        return am;
      }
      throw new $c_s_MatchError(x14);
    }));
    return this$14.eF.i(mod);
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__duplicateSingleGroup__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup__sci_Map__T2($thiz, graph, group, groupIdMap) {
  var newGroupId = $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__nextAvailable$2__Lorg_jpablo_graphexplorer_viewer_models_GroupId(graph);
  var filteredAttributes = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().aO6(group.kb, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((attrId) => {
    var attrId$1 = ((attrId === null) ? null : attrId.fY);
    return (!$m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$().aF5.E(attrId$1));
  })));
  var newGroup = $m_Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup$().a3J(newGroupId, filteredAttributes);
  var id = group.tm;
  var ogParentGroupId = graph.go.r(id);
  if (ogParentGroupId.c()) {
    var $x_1 = $m_s_None$();
  } else {
    var x0 = ogParentGroupId.d();
    var $x_1 = groupIdMap.r(x0);
  }
  var this$1 = $x_1;
  var targetParentGroupId = (this$1.c() ? ogParentGroupId : this$1);
  var this$13 = new $c_Lcom_softwaremill_quicklens_package$PathModify(graph, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x) => new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements(graph.aA.gr, graph.aA.gH, graph.aA.gq, graph.aA.gp, x.i(graph.aA.fh), graph.aA.dW, graph.aA.fE, graph.aA.fD), graph.j7, graph.iC, graph.jG, graph.jF, graph.i0))));
  var mod = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$24) => _$24.bN(newGroupId, newGroup)));
  var obj$proxy1 = this$13.eF.i(mod);
  var this$25 = new $c_Lcom_softwaremill_quicklens_package$PathModify(obj$proxy1, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2) => new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements(obj$proxy1.aA.gr, obj$proxy1.aA.gH, x$2.i(obj$proxy1.aA.gq), obj$proxy1.aA.gp, obj$proxy1.aA.fh, obj$proxy1.aA.dW, obj$proxy1.aA.fE, obj$proxy1.aA.fD), obj$proxy1.j7, obj$proxy1.iC, obj$proxy1.jG, obj$proxy1.jF, obj$proxy1.i0))));
  var mod$1 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((mbs) => (targetParentGroupId.c() ? mbs : mbs.bN(newGroupId, targetParentGroupId.d()))));
  return new $c_T2(this$25.eF.i(mod$1), newGroupId);
}
function $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__duplicateSingleNode__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_ViewerNode__sci_Map__T2($thiz, graph, node, groupIdMap) {
  var id = node.o7;
  var ogParentGroupId = graph.go.r(id);
  if (ogParentGroupId.c()) {
    var $x_1 = $m_s_None$();
  } else {
    var x0 = ogParentGroupId.d();
    var $x_1 = groupIdMap.r(x0);
  }
  var this$1 = $x_1;
  var targetGroupId = (this$1.c() ? ogParentGroupId : this$1);
  matchResult30: {
    var \u03b414$___1;
    var \u03b414$___2;
    var x99 = graph.a2D(targetGroupId, $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV);
    if ((x99 !== null)) {
      var \u03b414$___1 = x99.g();
      var \u03b414$___2 = x99.h();
      break matchResult30;
    }
    throw new $c_s_MatchError(x99);
  }
  var newGraph$2 = \u03b414$___1;
  var newNodeId$2 = \u03b414$___2;
  var filteredAttributes = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().aO6(node.fH, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((attrId) => {
    var attrId$1 = ((attrId === null) ? null : attrId.fY);
    return (!$m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$().aaG.E(attrId$1));
  })));
  return new $c_T2($f_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps__updateAttributes__sci_Set__Lorg_jpablo_graphexplorer_viewer_models_AttributeUpdates__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(newGraph$2, $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_ElementId.r().C)([newNodeId$2]))), $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().aih(filteredAttributes)), newNodeId$2);
}
function $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__duplicateSingleArrow__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_Arrow__sci_Map__s_Option($thiz, graph, arrow, nodeIdMap) {
  var newSourceId = nodeIdMap.ay(arrow.bX, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => arrow.bX)));
  var newTargetId = nodeIdMap.ay(arrow.c0, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => arrow.c0)));
  if ((graph.aA.gr.l8.E(newSourceId) && graph.aA.gr.l8.E(newTargetId))) {
    matchResult31: {
      var \u03b415$___1;
      var \u03b415$___2;
      var x102 = graph.a2C(newSourceId, newTargetId, $m_s_None$(), $m_s_None$());
      if ((x102 !== null)) {
        var \u03b415$___1 = x102.g();
        var \u03b415$___2 = x102.h();
        break matchResult31;
      }
      throw new $c_s_MatchError(x102);
    }
    var newGraph$2 = \u03b415$___1;
    var newArrow$2 = \u03b415$___2;
    return new $c_s_Some(new $c_T2($f_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps__updateAttributes__sci_Set__Lorg_jpablo_graphexplorer_viewer_models_AttributeUpdates__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(newGraph$2, $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_ElementId.r().C)([newArrow$2.dw]))), $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().aih(arrow.fG)), newArrow$2.dw));
  } else {
    return $m_s_None$();
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__nextAvailable$1__Lorg_jpablo_graphexplorer_viewer_models_NodeId($thiz) {
  while (true) {
    $thiz.a0J = ((1 + $thiz.a0J) | 0);
    $m_Lorg_jpablo_graphexplorer_viewer_models_NodeId$();
    var id = new $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$().b5S($thiz.a0J));
    if ($thiz.dQ.l8.E(id)) {
    } else {
      return id;
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__nextAvailable$2__Lorg_jpablo_graphexplorer_viewer_models_GroupId($thiz) {
  while (true) {
    $thiz.a0I = ((1 + $thiz.a0I) | 0);
    $m_Lorg_jpablo_graphexplorer_viewer_models_GroupId$();
    var id = new $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId(("g" + $thiz.a0I));
    if ($thiz.hu.E(id)) {
    } else {
      return id;
    }
  }
}
function $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__survivingContainer$1__sci_Set__Lorg_jpablo_graphexplorer_viewer_models_GroupId__s_Option($thiz, groupIdsToRemove$1, groupId) {
  var groupId$tailLocal1 = groupId;
  while (true) {
    if ((!groupIdsToRemove$1.E(groupId$tailLocal1))) {
      return new $c_s_Some(groupId$tailLocal1);
    } else {
      var x5 = $thiz.go.r(groupId$tailLocal1);
      if ((x5 instanceof $c_s_Some)) {
        var parent = x5.J;
        groupId$tailLocal1 = parent;
        continue;
      }
      if (($m_s_None$() === x5)) {
        return $m_s_None$();
      }
      throw new $c_s_MatchError(x5);
    }
  }
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(elements, id, tpe, nodeCounter, groupCounter, proxyOrigins) {
  this.aaE = null;
  this.a0K = null;
  this.aEY = null;
  this.aF1 = false;
  this.aEU = null;
  this.aEX = false;
  this.aEZ = null;
  this.aF0 = false;
  this.aEV = null;
  this.aEW = false;
  this.aEM = null;
  this.aEN = false;
  this.aEK = null;
  this.aEL = false;
  this.aF2 = null;
  this.aF3 = false;
  this.aA = null;
  this.j7 = null;
  this.iC = null;
  this.jG = 0;
  this.jF = 0;
  this.i0 = null;
  this.a0J = 0;
  this.a0I = 0;
  this.dQ = null;
  this.fX = null;
  this.hu = null;
  this.go = null;
  this.j8 = null;
  this.qn = null;
  this.xf = null;
  this.aES = null;
  this.aET = false;
  this.aEO = null;
  this.aEP = false;
  this.aEQ = null;
  this.aER = false;
  this.GH = null;
  this.Mm = null;
  this.aaF = null;
  this.aA = elements;
  this.j7 = id;
  this.iC = tpe;
  this.jG = nodeCounter;
  this.jF = groupCounter;
  this.i0 = proxyOrigins;
  $f_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps__$init$__V(this);
  this.a0J = nodeCounter;
  this.a0I = groupCounter;
  this.dQ = elements.gr;
  this.fX = elements.gH;
  this.hu = elements.fh;
  this.go = elements.gq;
  this.j8 = $ct_sci_MapOps$ImmutableKeySet__sci_MapOps__(new $c_sci_MapOps$ImmutableKeySet(), this.dQ);
  this.qn = this.fX.ln();
  this.xf = this.hu.ln();
  this.GH = new $c_Lcom_softwaremill_quicklens_package$PathModify(this, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x) => new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(x.i(this.aA), this.j7, this.iC, this.jG, this.jF, this.i0))));
  this.Mm = new $c_Lcom_softwaremill_quicklens_package$PathModify(this, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$3) => new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements(this.aA.gr, x$3.i(this.aA.gH), this.aA.gq, this.aA.gp, this.aA.fh, this.aA.dW, this.aA.fE, this.aA.fD), this.j7, this.iC, this.jG, this.jF, this.i0))));
  this.aaF = new $c_Lcom_softwaremill_quicklens_package$PathModify(this, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$4) => new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements(this.aA.gr, this.aA.gH, x$4.i(this.aA.gq), this.aA.gp, this.aA.fh, this.aA.dW, this.aA.fE, this.aA.fD), this.j7, this.iC, this.jG, this.jF, this.i0))));
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph() {
}
$h_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph.prototype = $p;
$p.aNt = (function() {
  if ((!this.aF1)) {
    this.aEY = $f_Lorg_jpablo_graphexplorer_viewer_graph_TraversalOps__directSuccessors__sci_Map(this);
    this.aF1 = true;
  }
  return this.aEY;
});
$p.aNr = (function() {
  if ((!this.aEX)) {
    this.aEU = $f_Lorg_jpablo_graphexplorer_viewer_graph_TraversalOps__directPredecessors__sci_Map(this);
    this.aEX = true;
  }
  return this.aEU;
});
$p.aNu = (function() {
  if ((!this.aF0)) {
    this.aEZ = $f_Lorg_jpablo_graphexplorer_viewer_graph_TraversalOps__directSuccessorsGraph__F1(this);
    this.aF0 = true;
  }
  return this.aEZ;
});
$p.aNs = (function() {
  if ((!this.aEW)) {
    this.aEV = $f_Lorg_jpablo_graphexplorer_viewer_graph_TraversalOps__directPredecessorsGraph__F1(this);
    this.aEW = true;
  }
  return this.aEV;
});
$p.aLW = (function() {
  if ((!this.aEN)) {
    this.aEM = $f_Lorg_jpablo_graphexplorer_viewer_graph_TraversalOps__allSuccessorsGraph__F1(this);
    this.aEN = true;
  }
  return this.aEM;
});
$p.aLV = (function() {
  if ((!this.aEL)) {
    this.aEK = $f_Lorg_jpablo_graphexplorer_viewer_graph_TraversalOps__allPredecessorsGraph__F1(this);
    this.aEL = true;
  }
  return this.aEK;
});
$p.b6W = (function() {
  if ((!this.aF3)) {
    this.aF2 = $f_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps__proxyForGroup__sci_Map(this);
    this.aF3 = true;
  }
  return this.aF2;
});
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, (-1524972996));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.aA));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.j7));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.iC));
  acc = $m_sr_Statics$().k(acc, this.jG);
  acc = $m_sr_Statics$().k(acc, this.jF);
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.i0));
  return $m_sr_Statics$().Z(acc, 6);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph)) {
    if (((this.jG === x$0.jG) && (this.jF === x$0.jF))) {
      var x = this.aA;
      var x$2 = x$0.aA;
      var $x_2 = ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      var $x_2 = false;
    }
    if (($x_2 && (this.j7 === x$0.j7))) {
      var x$3 = this.iC;
      var x$4 = x$0.iC;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : (x$3 === x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.i0;
      var x$6 = x$0.i0;
      return ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 6;
});
$p.B = (function() {
  return "ViewerGraph";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.aA;
      break;
    }
    case 1: {
      return this.j7;
      break;
    }
    case 2: {
      return this.iC;
      break;
    }
    case 3: {
      return this.jG;
      break;
    }
    case 4: {
      return this.jF;
      break;
    }
    case 5: {
      return this.i0;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "elements";
      break;
    }
    case 1: {
      return "id";
      break;
    }
    case 2: {
      return "tpe";
      break;
    }
    case 3: {
      return "nodeCounter";
      break;
    }
    case 4: {
      return "groupCounter";
      break;
    }
    case 5: {
      return "proxyOrigins";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.aeO = (function() {
  if ((!this.aET)) {
    this.aES = $m_sci_Set$().af(this.fX.e6());
    this.aET = true;
  }
  return this.aES;
});
$p.aMr = (function() {
  if ((!this.aEP)) {
    var this$1 = this.fX.e6().d2();
    var m = $m_scm_Map$().aO();
    var it = this$1.o();
    while (it.p()) {
      var elem = it.q();
      var key = elem.bX;
      m.ec(key, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
        $m_sci_Vector$();
        return new $c_sci_VectorBuilder();
      }))).Y(elem);
    }
    var result = $m_sci_HashMap$().fk;
    var mapIt = m.o();
    while (mapIt.p()) {
      var x1 = mapIt.q();
      if ((x1 === null)) {
        throw new $c_s_MatchError(x1);
      }
      var k = x1.g();
      var v = x1.h();
      result = result.hq(k, v.aR());
    }
    this.aEO = result;
    this.aEP = true;
  }
  return this.aEO;
});
$p.aMs = (function() {
  if ((!this.aER)) {
    var this$1 = this.fX.e6().d2();
    var m = $m_scm_Map$().aO();
    var it = this$1.o();
    while (it.p()) {
      var elem = it.q();
      var key = elem.c0;
      m.ec(key, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
        $m_sci_Vector$();
        return new $c_sci_VectorBuilder();
      }))).Y(elem);
    }
    var result = $m_sci_HashMap$().fk;
    var mapIt = m.o();
    while (mapIt.p()) {
      var x1 = mapIt.q();
      if ((x1 === null)) {
        throw new $c_s_MatchError(x1);
      }
      var k = x1.g();
      var v = x1.h();
      result = result.hq(k, v.aR());
    }
    this.aEQ = result;
    this.aER = true;
  }
  return this.aEQ;
});
$p.b2I = (function(n) {
  return this.aMr().ay(n, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $m_sci_Vector$();
    return $m_sci_Vector0$();
  }))).g9(this.aMs().ay(n, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $m_sci_Vector$();
    return $m_sci_Vector0$();
  }))).bw(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((a) => {
    var x = a.bX;
    var x$2 = a.c0;
    return (!((x === null) ? (x$2 === null) : x.e(x$2)));
  }))));
});
$p.b9x = (function() {
  return new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$Summary(this.dQ.O5, this.fX.aa(), ((this.hu.aa() - 1) | 0));
});
$p.b7Y = (function() {
  return this.j8.jv(this.aeO().L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$7) => _$7.c0))));
});
$p.baj = (function(hiddenNodes, collapsedGroups) {
  return $f_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps__withDefaultTheme__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph($f_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps__collapseGroups__sci_Set__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph($f_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps__withoutUnsupportedFeatures__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(this).a4t(hiddenNodes), collapsedGroups));
});
$p.aSx = (function(ids) {
  var this$1 = this.dQ;
  $m_sci_VectorMap$();
  var b = new $c_sci_VectorMapBuilder();
  var it = new $c_sci_VectorMap$$anon$1(this$1);
  while (it.p()) {
    var elem = it.dC();
    var id = elem.g();
    elem.h();
    if (ids.E(id)) {
      b.pm(elem.g(), elem.h());
    }
  }
  var foundNodes = b.rb();
  var foundNodeIds = $ct_sci_MapOps$ImmutableKeySet__sci_MapOps__(new $c_sci_MapOps$ImmutableKeySet(), foundNodes);
  var relevantArrows = this.fX.bw(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    x$1$2.g();
    var a = x$1$2.h();
    var key = a.bX;
    if (foundNodeIds.mA.E(key)) {
      var key$1 = a.c0;
      return foundNodeIds.mA.E(key$1);
    } else {
      return false;
    }
  })));
  $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$();
  return new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$(), new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements(foundNodes, relevantArrows, ($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$(), $m_sci_Map$EmptyMap$()), ($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$(), $m_sci_Map$EmptyMap$()), ($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$(), $m_sci_Map$EmptyMap$()), ($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$(), $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV), ($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$(), $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV), ($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$(), $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV))), ($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$(), $m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$().p4.dR), ($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$(), $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$().GB), ($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$(), 0), ($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$(), 0), ($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph$(), $m_sci_Map$EmptyMap$()));
});
$p.a4t = (function(elementIds) {
  var classified = $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().gV(elementIds);
  var groupIdsToRemove = classified.f3;
  var nodeIdsToRemove = classified.gg;
  var arrowIdsToRemove = classified.gf;
  var updatedMemberships = this.go.Pl(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
    var elementId = x$1.g();
    var groupId = x$1.h();
    var this$2 = $f_Lorg_jpablo_graphexplorer_viewer_models_ElementId__asGroupId__s_Option(elementId);
    if ((!this$2.c())) {
      var x0 = this$2.d();
      var $x_1 = groupIdsToRemove.E(x0);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return $m_s_None$();
    } else {
      var this$3 = $f_Lorg_jpablo_graphexplorer_viewer_models_ElementId__asNodeId__s_Option(elementId);
      if ((!this$3.c())) {
        var x0$1 = this$3.d();
        var $x_2 = nodeIdsToRemove.E(x0$1);
      } else {
        var $x_2 = false;
      }
      if ($x_2) {
        return $m_s_None$();
      } else if (groupIdsToRemove.E(groupId)) {
        var this$4 = $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__survivingContainer$1__sci_Set__Lorg_jpablo_graphexplorer_viewer_models_GroupId__s_Option(this, groupIdsToRemove, groupId);
        return (this$4.c() ? $m_s_None$() : new $c_s_Some(new $c_T2(elementId, this$4.d())));
      } else {
        return new $c_s_Some(new $c_T2(elementId, groupId));
      }
    }
  })));
  var updatedArrows = this.fX.cE(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    var arrowId = x$1$2.g();
    var arrow = x$1$2.h();
    return ((arrowIdsToRemove.E(arrowId) || nodeIdsToRemove.E(arrow.bX)) || nodeIdsToRemove.E(arrow.c0));
  })));
  var updatedArrowMemberships = this.aA.gp.Pl(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3) => {
    var arrowId$1 = x$1$3.g();
    var groupId$1 = x$1$3.h();
    if ((!updatedArrows.E(arrowId$1))) {
      return $m_s_None$();
    } else if (groupIdsToRemove.E(groupId$1)) {
      var this$10 = $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__survivingContainer$1__sci_Set__Lorg_jpablo_graphexplorer_viewer_models_GroupId__s_Option(this, groupIdsToRemove, groupId$1);
      return (this$10.c() ? $m_s_None$() : new $c_s_Some(new $c_T2(arrowId$1, this$10.d())));
    } else {
      return new $c_s_Some(new $c_T2(arrowId$1, groupId$1));
    }
  })));
  var this$18 = this.GH;
  var mod = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$12) => new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements($f_sci_MapOps__removedAll__sc_IterableOnce__sci_MapOps(this.dQ, nodeIdsToRemove), updatedArrows, updatedMemberships, updatedArrowMemberships, this.hu.XS(groupIdsToRemove), _$12.dW, _$12.fE, _$12.fD)));
  return $f_Lorg_jpablo_graphexplorer_viewer_graph_GroupsOps__removeEmptyGroups__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(this$18.eF.i(mod));
});
$p.a2C = (function(source, target, sourcePort, targetPort) {
  var newSeq = $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__maxArrowSequence__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Lorg_jpablo_graphexplorer_viewer_models_NodeId__I(this, source, target);
  var seq$1 = ((1 + newSeq) | 0);
  $m_Lorg_jpablo_graphexplorer_viewer_models_Arrow$();
  var attributes$1 = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().cV;
  $m_Lorg_jpablo_graphexplorer_viewer_models_Arrow$();
  var arrow = new $c_Lorg_jpablo_graphexplorer_viewer_models_Arrow(source, target, attributes$1, sourcePort, targetPort, seq$1);
  var this$5 = this.Mm;
  var mod = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$14) => _$14.bN(arrow.dw, arrow)));
  return new $c_T2(this$5.eF.i(mod), arrow);
});
$p.aeF = (function(nodeId, groupId, attributes) {
  var this$8 = this.GH;
  var mod = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$15) => {
    var nodes$1 = this.dQ.AJ(nodeId, $m_Lorg_jpablo_graphexplorer_viewer_models_ViewerNode$().a4f(nodeId, attributes));
    if (groupId.c()) {
      var memberships$1 = this.go;
    } else {
      var x0 = groupId.d();
      var memberships$1 = this.go.bN(nodeId, x0);
    }
    return new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements(nodes$1, _$15.gH, memberships$1, _$15.gp, _$15.fh, _$15.dW, _$15.fE, _$15.fD);
  }));
  return this$8.eF.i(mod);
});
$p.a2D = (function(groupId, attributes) {
  var nodeId = $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__nextAvailable$1__Lorg_jpablo_graphexplorer_viewer_models_NodeId(this);
  return new $c_T2(this.aeF(nodeId, groupId, attributes), nodeId);
});
$p.aWF = (function(source, attributes) {
  var nodeId = $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__nextAvailable$1__Lorg_jpablo_graphexplorer_viewer_models_NodeId(this);
  var sourceGroup = this.go.r(source);
  matchResult5: {
    var \u03b41$___1;
    var \u03b41$___2;
    var x8 = this.aeF(nodeId, sourceGroup, attributes).a2C(source, nodeId, $m_s_None$(), $m_s_None$());
    if ((x8 !== null)) {
      var \u03b41$___1 = x8.g();
      var \u03b41$___2 = x8.h();
      break matchResult5;
    }
    throw new $c_s_MatchError(x8);
  }
  return new $c_T3(\u03b41$___1, nodeId, \u03b41$___2.dw);
});
$p.aWG = (function(target, attributes) {
  var nodeId = $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__nextAvailable$1__Lorg_jpablo_graphexplorer_viewer_models_NodeId(this);
  var targetGroup = this.go.r(target);
  matchResult6: {
    var \u03b43$___1;
    var \u03b43$___2;
    var x11 = this.aeF(nodeId, targetGroup, attributes).a2C(nodeId, target, $m_s_None$(), $m_s_None$());
    if ((x11 !== null)) {
      var \u03b43$___1 = x11.g();
      var \u03b43$___2 = x11.h();
      break matchResult6;
    }
    throw new $c_s_MatchError(x11);
  }
  return new $c_T3(\u03b43$___1, nodeId, \u03b43$___2.dw);
});
$p.b4w = (function(arrowId, newEndpoint, port) {
  var arrow = this.fX.i(arrowId);
  matchResult8: {
    var newArrow;
    if ((newEndpoint instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowEndpointId$SourceId)) {
      var newArrow = new $c_Lorg_jpablo_graphexplorer_viewer_models_Arrow(newEndpoint.MI, arrow.c0, arrow.fG, port, arrow.iE, arrow.jH);
      break matchResult8;
    }
    if ((newEndpoint instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowEndpointId$TargetId)) {
      var x20 = newEndpoint.MJ;
      var newArrow = new $c_Lorg_jpablo_graphexplorer_viewer_models_Arrow(arrow.bX, x20, arrow.fG, arrow.iD, port, arrow.jH);
      break matchResult8;
    }
    throw new $c_s_MatchError(newEndpoint);
  }
  var this$6 = this.Mm;
  var mod = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$17) => _$17.bN(newArrow.dw, newArrow).fz(arrowId)));
  return new $c_T2($p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__rekeyArrowMembership__Lorg_jpablo_graphexplorer_viewer_models_ArrowId__Lorg_jpablo_graphexplorer_viewer_models_ArrowId__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(this$6.eF.i(mod), arrowId, newArrow.dw), newArrow.dw);
});
$p.b7V = (function(elementIds) {
  var this$14 = $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().gV(elementIds).gf;
  var f = ((currentGraph, arrowId) => {
    var x24 = currentGraph.fX.r(arrowId);
    if (($m_s_None$() === x24)) {
      return currentGraph;
    }
    if ((x24 instanceof $c_s_Some)) {
      var ogArrow = x24.J;
      var effectiveHead = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().E0(ogArrow.fG, $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowHead$());
      var effectiveTail = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().E0(ogArrow.fG, $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowTail$());
      var defaultHeadIfOmitted = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().E0(this.a0K, $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowHead$());
      var defaultTailIfOmitted = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().E0(this.a0K, $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowTail$());
      var updatedAttributes = new $c_sr_ObjectRef(ogArrow.fG);
      if (((effectiveTail === null) ? (defaultHeadIfOmitted === null) : (effectiveTail === defaultHeadIfOmitted))) {
        updatedAttributes.aD = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().a2q(updatedAttributes.aD, $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowHead$()));
      } else {
        updatedAttributes.aD = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().aLl(updatedAttributes.aD, new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributePair$$anon$3(new $c_T2($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowHead$(), effectiveTail)));
      }
      if (((effectiveHead === null) ? (defaultTailIfOmitted === null) : (effectiveHead === defaultTailIfOmitted))) {
        updatedAttributes.aD = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().a2q(updatedAttributes.aD, $f_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DotAttribute__attrId__T($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowTail$()));
      } else {
        updatedAttributes.aD = $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().aLl(updatedAttributes.aD, new $c_Lorg_jpablo_graphexplorer_viewer_models_AttributePair$$anon$3(new $c_T2($m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowTail$(), effectiveHead)));
      }
      var this$13 = currentGraph.Mm;
      var mod = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((arrowId$2) => ((_$18) => {
        var attributes$2 = updatedAttributes.aD;
        return _$18.bN(arrowId$2, new $c_Lorg_jpablo_graphexplorer_viewer_models_Arrow(ogArrow.bX, ogArrow.c0, attributes$2, ogArrow.iD, ogArrow.iE, ogArrow.jH));
      }))(arrowId));
      return this$13.eF.i(mod);
    }
    throw new $c_s_MatchError(x24);
  });
  if ($is_sc_IndexedSeq(this$14)) {
    var at = 0;
    var end = this$14.C();
    var acc = this;
    var $x_1;
    while (true) {
      if ((at !== end)) {
        var temp$at = ((1 + at) | 0);
        var x0 = acc;
        var x1 = this$14.l(at);
        var temp$acc = f(x0, x1);
        at = temp$at;
        acc = temp$acc;
        continue;
      }
      var $x_1 = acc;
      break;
    }
  } else {
    var result = this;
    var it = this$14.o();
    while (it.p()) {
      var x0$1 = result;
      var x1$1 = it.q();
      result = f(x0$1, x1$1);
    }
    var $x_1 = result;
  }
  return $x_1;
});
$p.aRL = (function(elementIds) {
  var arrowIdsToReverse = $m_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$().gV(elementIds).gf;
  var f = ((currentGraph, arrowId) => {
    var x27 = currentGraph.fX.r(arrowId);
    if (($m_s_None$() === x27)) {
      return currentGraph;
    }
    if ((x27 instanceof $c_s_Some)) {
      var originalArrow = x27.J;
      var this$1 = currentGraph.Mm;
      var mod = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((arrowId$2) => ((_$19) => _$19.fz(arrowId$2)))(arrowId));
      var graphWithoutOriginal = this$1.eF.i(mod);
      var newSource = originalArrow.c0;
      var newTarget = originalArrow.bX;
      var newSeq = ((1 + $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__maxArrowSequence__Lorg_jpablo_graphexplorer_viewer_models_NodeId__Lorg_jpablo_graphexplorer_viewer_models_NodeId__I(graphWithoutOriginal, newSource, newTarget)) | 0);
      $m_Lorg_jpablo_graphexplorer_viewer_models_Arrow$();
      var reversedArrow = new $c_Lorg_jpablo_graphexplorer_viewer_models_Arrow(newSource, newTarget, originalArrow.fG, ($m_Lorg_jpablo_graphexplorer_viewer_models_Arrow$(), $m_s_None$()), ($m_Lorg_jpablo_graphexplorer_viewer_models_Arrow$(), $m_s_None$()), newSeq);
      var this$7 = graphWithoutOriginal.Mm;
      var mod$1 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$20) => _$20.bN(reversedArrow.dw, reversedArrow)));
      return $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__rekeyArrowMembership__Lorg_jpablo_graphexplorer_viewer_models_ArrowId__Lorg_jpablo_graphexplorer_viewer_models_ArrowId__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(this$7.eF.i(mod$1), arrowId, reversedArrow.dw);
    }
    throw new $c_s_MatchError(x27);
  });
  if ($is_sc_IndexedSeq(arrowIdsToReverse)) {
    var at = 0;
    var end = arrowIdsToReverse.C();
    var acc = this;
    var $x_1;
    while (true) {
      if ((at !== end)) {
        var temp$at = ((1 + at) | 0);
        var x0 = acc;
        var x1 = arrowIdsToReverse.l(at);
        var temp$acc = f(x0, x1);
        at = temp$at;
        acc = temp$acc;
        continue;
      }
      var $x_1 = acc;
      break;
    }
  } else {
    var result = this;
    var it = arrowIdsToReverse.o();
    while (it.p()) {
      var x0$1 = result;
      var x1$1 = it.q();
      result = f(x0$1, x1$1);
    }
    var $x_1 = result;
  }
  return $x_1;
});
$p.aWH = (function(selectedElementId, attributes, direction) {
  if (($m_s_None$() === selectedElementId)) {
    matchResult11: {
      var \u03b45$___1;
      var \u03b45$___2;
      var x30 = this.a2D($m_s_None$(), attributes);
      if ((x30 !== null)) {
        var \u03b45$___1 = x30.g();
        var \u03b45$___2 = x30.h();
        break matchResult11;
      }
      throw new $c_s_MatchError(x30);
    }
    return new $c_T3(\u03b45$___1, \u03b45$___2, $m_s_None$());
  }
  if ((selectedElementId instanceof $c_s_Some)) {
    var selected = selectedElementId.J;
    if ((selected instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId)) {
      matchResult13: {
        var \u03b46$___1;
        var \u03b46$___2;
        var \u03b46$___3;
        matchResult12: {
          var x34;
          var x$3 = $s_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$__forward__Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection();
          if (((x$3 === null) ? (direction === null) : (x$3 === direction))) {
            var x34 = this.aWF(selected, attributes);
            break matchResult12;
          }
          var x$5 = $s_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$__backward__Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection();
          if (((x$5 === null) ? (direction === null) : (x$5 === direction))) {
            var x34 = this.aWG(selected, attributes);
            break matchResult12;
          }
          throw new $c_s_MatchError(direction);
        }
        if ((x34 !== null)) {
          var \u03b46$___1 = x34.bH;
          var \u03b46$___2 = x34.bU;
          var \u03b46$___3 = x34.c3;
          break matchResult13;
        }
        throw new $c_s_MatchError(x34);
      }
      return new $c_T3(\u03b46$___1, \u03b46$___2, new $c_s_Some(\u03b46$___3));
    }
    if ((selected instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId)) {
      matchResult14: {
        var \u03b47$___1;
        var \u03b47$___2;
        var x38 = this.a2D(new $c_s_Some(selected), attributes);
        if ((x38 !== null)) {
          var \u03b47$___1 = x38.g();
          var \u03b47$___2 = x38.h();
          break matchResult14;
        }
        throw new $c_s_MatchError(x38);
      }
      return new $c_T3(\u03b47$___1, \u03b47$___2, $m_s_None$());
    }
    if ((selected instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowId)) {
      matchResult15: {
        var \u03b48$___1;
        var \u03b48$___2;
        var x41 = this.a2D($m_s_None$(), attributes);
        if ((x41 !== null)) {
          var \u03b48$___1 = x41.g();
          var \u03b48$___2 = x41.h();
          break matchResult15;
        }
        throw new $c_s_MatchError(x41);
      }
      return new $c_T3(\u03b48$___1, \u03b48$___2, $m_s_None$());
    }
    throw new $c_s_MatchError(selected);
  }
  throw new $c_s_MatchError(selectedElementId);
});
$p.b0i = (function(classified) {
  var descendantMembers = $f_Lorg_jpablo_graphexplorer_viewer_graph_GroupsOps__getAllChildren__sci_Set__sci_Set(this, classified.f3);
  var descendants = $m_Lorg_jpablo_graphexplorer_viewer_models_GroupMemberId$().aYj(descendantMembers);
  var groupsToDuplicate = classified.f3.dI(descendants.f3);
  var nodesToDuplicate = classified.gg.dI(descendants.gg);
  var internalArrowsToDuplicate = $m_sci_Set$().af(this.fX.e6().bw(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((a) => (nodesToDuplicate.E(a.bX) && nodesToDuplicate.E(a.c0))))).L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$22) => _$22.dw))));
  var allArrowsToDuplicate = classified.gf.dI(internalArrowsToDuplicate);
  matchResult21: {
    var \u03b49$___1;
    var \u03b49$___2;
    var \u03b49$___3;
    var z = new $c_T3(this, $m_sci_Set$EmptySet$(), $m_sci_Map$EmptyMap$());
    var f = ((x$1, x$2) => {
      var x57 = new $c_T2(x$1, x$2);
      var x58 = x57.bi;
      if ((x58 !== null)) {
        var currentGraph = x58.bH;
        var createdGroupIds = x58.bU;
        var groupMap = x58.c3;
        var ogGroupId = x57.be;
        if (groupMap.E(ogGroupId)) {
          return x58;
        } else {
          var x54 = currentGraph.hu.r(ogGroupId);
          if (($m_s_None$() === x54)) {
            return x58;
          }
          if ((x54 instanceof $c_s_Some)) {
            var ogGroup = x54.J;
            matchResult18: {
              var \u03b412$___1;
              var \u03b412$___2;
              var x51 = $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__duplicateSingleGroup__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_ViewerGroup__sci_Map__T2(this, currentGraph, ogGroup, groupMap);
              if ((x51 !== null)) {
                var \u03b412$___1 = x51.g();
                var \u03b412$___2 = x51.h();
                break matchResult18;
              }
              throw new $c_s_MatchError(x51);
            }
            var newGraph$2 = \u03b412$___1;
            var newGroupId$2 = \u03b412$___2;
            return new $c_T3(newGraph$2, createdGroupIds.hQ(newGroupId$2), groupMap.bN(ogGroupId, newGroupId$2));
          }
          throw new $c_s_MatchError(x54);
        }
      }
      throw new $c_s_MatchError(x57);
    });
    if ($is_sc_IndexedSeq(groupsToDuplicate)) {
      var at = 0;
      var end = groupsToDuplicate.C();
      var acc = z;
      var $x_1;
      while (true) {
        if ((at !== end)) {
          var temp$at = ((1 + at) | 0);
          var x0 = acc;
          var x1 = groupsToDuplicate.l(at);
          var temp$acc = f(x0, x1);
          at = temp$at;
          acc = temp$acc;
          continue;
        }
        var $x_1 = acc;
        break;
      }
    } else {
      var result = z;
      var it = groupsToDuplicate.o();
      while (it.p()) {
        var x0$1 = result;
        var x1$1 = it.q();
        result = f(x0$1, x1$1);
      }
      var $x_1 = result;
    }
    var x63 = $x_1;
    if ((x63 !== null)) {
      var \u03b49$___1 = x63.bH;
      var \u03b49$___2 = x63.bU;
      var \u03b49$___3 = x63.c3;
      break matchResult21;
    }
    throw new $c_s_MatchError(x63);
  }
  var graphAfterGroups$2 = \u03b49$___1;
  var newGroupIds$2 = \u03b49$___2;
  var groupIdMap$2 = \u03b49$___3;
  matchResult25: {
    var \u03b410$___1;
    var \u03b410$___2;
    var \u03b410$___3;
    var z$1 = new $c_T3(graphAfterGroups$2, $m_sci_Set$EmptySet$(), $m_sci_Map$EmptyMap$());
    var f$1 = ((x$1$2, x$2$2) => {
      var x73 = new $c_T2(x$1$2, x$2$2);
      var x74 = x73.bi;
      if ((x74 !== null)) {
        var currentGraph$1 = x74.bH;
        var createdNodeIds = x74.bU;
        var nodeMap = x74.c3;
        var ogNodeId = x73.be;
        if (nodeMap.E(ogNodeId)) {
          return x74;
        } else {
          var x70 = currentGraph$1.dQ.r(ogNodeId);
          if (($m_s_None$() === x70)) {
            return x74;
          }
          if ((x70 instanceof $c_s_Some)) {
            var ogNode = x70.J;
            matchResult22: {
              var \u03b413$___1;
              var \u03b413$___2;
              var x67 = $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__duplicateSingleNode__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_ViewerNode__sci_Map__T2(this, currentGraph$1, ogNode, groupIdMap$2);
              if ((x67 !== null)) {
                var \u03b413$___1 = x67.g();
                var \u03b413$___2 = x67.h();
                break matchResult22;
              }
              throw new $c_s_MatchError(x67);
            }
            var newGraph$2$1 = \u03b413$___1;
            var newNodeId$2 = \u03b413$___2;
            return new $c_T3(newGraph$2$1, createdNodeIds.hQ(newNodeId$2), nodeMap.bN(ogNodeId, newNodeId$2));
          }
          throw new $c_s_MatchError(x70);
        }
      }
      throw new $c_s_MatchError(x73);
    });
    if ($is_sc_IndexedSeq(nodesToDuplicate)) {
      var at$1 = 0;
      var end$1 = nodesToDuplicate.C();
      var acc$1 = z$1;
      var $x_2;
      while (true) {
        if ((at$1 !== end$1)) {
          var temp$at$1 = ((1 + at$1) | 0);
          var x0$2 = acc$1;
          var x1$2 = nodesToDuplicate.l(at$1);
          var temp$acc$1 = f$1(x0$2, x1$2);
          at$1 = temp$at$1;
          acc$1 = temp$acc$1;
          continue;
        }
        var $x_2 = acc$1;
        break;
      }
    } else {
      var result$1 = z$1;
      var it$1 = nodesToDuplicate.o();
      while (it$1.p()) {
        var x0$3 = result$1;
        var x1$3 = it$1.q();
        result$1 = f$1(x0$3, x1$3);
      }
      var $x_2 = result$1;
    }
    var x79 = $x_2;
    if ((x79 !== null)) {
      var \u03b410$___1 = x79.bH;
      var \u03b410$___2 = x79.bU;
      var \u03b410$___3 = x79.c3;
      break matchResult25;
    }
    throw new $c_s_MatchError(x79);
  }
  var graphAfterNodes$2 = \u03b410$___1;
  var newNodeIds$2 = \u03b410$___2;
  var nodeIdMap$2 = \u03b410$___3;
  matchResult29: {
    var \u03b411$___1;
    var \u03b411$___2;
    var z$2 = new $c_T2(graphAfterNodes$2, $m_sci_Set$EmptySet$());
    var f$2 = ((x$1$3, x$2$3) => {
      var x91 = new $c_T2(x$1$3, x$2$3);
      var x92 = x91.bi;
      if ((x92 !== null)) {
        var currentGraph$2 = x92.g();
        var createdArrowIds = x92.h();
        var ogArrowId = x91.be;
        var x88 = this.aA.gH.r(ogArrowId);
        if (($m_s_None$() === x88)) {
          return x92;
        }
        if ((x88 instanceof $c_s_Some)) {
          var ogArrow = x88.J;
          var x83 = $p_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__duplicateSingleArrow__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_Arrow__sci_Map__s_Option(this, currentGraph$2, ogArrow, nodeIdMap$2);
          if ((x83 instanceof $c_s_Some)) {
            var x85 = x83.J;
            if ((x85 !== null)) {
              return new $c_T2(x85.g(), createdArrowIds.hQ(x85.h()));
            }
          }
          if (($m_s_None$() === x83)) {
            return x92;
          }
          throw new $c_s_MatchError(x83);
        }
        throw new $c_s_MatchError(x88);
      }
      throw new $c_s_MatchError(x91);
    });
    if ($is_sc_IndexedSeq(allArrowsToDuplicate)) {
      var at$2 = 0;
      var end$2 = allArrowsToDuplicate.C();
      var acc$2 = z$2;
      var $x_3;
      while (true) {
        if ((at$2 !== end$2)) {
          var temp$at$2 = ((1 + at$2) | 0);
          var x0$4 = acc$2;
          var x1$4 = allArrowsToDuplicate.l(at$2);
          var temp$acc$2 = f$2(x0$4, x1$4);
          at$2 = temp$at$2;
          acc$2 = temp$acc$2;
          continue;
        }
        var $x_3 = acc$2;
        break;
      }
    } else {
      var result$2 = z$2;
      var it$2 = allArrowsToDuplicate.o();
      while (it$2.p()) {
        var x0$5 = result$2;
        var x1$5 = it$2.q();
        result$2 = f$2(x0$5, x1$5);
      }
      var $x_3 = result$2;
    }
    var x96 = $x_3;
    if ((x96 !== null)) {
      var \u03b411$___1 = x96.g();
      var \u03b411$___2 = x96.h();
      break matchResult29;
    }
    throw new $c_s_MatchError(x96);
  }
  var finalGraph$2 = \u03b411$___1;
  var newArrowIds$2 = \u03b411$___2;
  return new $c_T2(finalGraph$2, newGroupIds$2.L(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((id) => id))).dI(newNodeIds$2).dI(newArrowIds$2));
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.j2)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph, "org.jpablo.graphexplorer.viewer.graph.ViewerGraph", ({
  j2: 1,
  Cl: 1,
  CA: 1,
  Cx: 1,
  Cq: 1,
  Cw: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_sc_AbstractView() {
}
$p = $c_sc_AbstractView.prototype = new $h_sc_AbstractIterable();
$p.constructor = $c_sc_AbstractView;
/** @constructor */
function $h_sc_AbstractView() {
}
$h_sc_AbstractView.prototype = $p;
$p.cd = (function() {
  return $m_sc_View$();
});
$p.aNH = (function() {
  return $m_sc_View$Empty$();
});
$p.m = (function() {
  return $f_sc_View__toString__T(this);
});
$p.el = (function() {
  return "View";
});
$p.pr = (function() {
  return this.aNH();
});
/** @constructor */
function $c_sc_MapOps$$anon$1(outer) {
  this.acd = null;
  this.acd = outer;
}
$p = $c_sc_MapOps$$anon$1.prototype = new $h_sc_AbstractIterable();
$p.constructor = $c_sc_MapOps$$anon$1;
/** @constructor */
function $h_sc_MapOps$$anon$1() {
}
$h_sc_MapOps$$anon$1.prototype = $p;
$p.V = (function() {
  return this.acd.V();
});
$p.o = (function() {
  return this.acd.hr();
});
var $d_sc_MapOps$$anon$1 = new $TypeData().i($c_sc_MapOps$$anon$1, "scala.collection.MapOps$$anon$1", ({
  Hk: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  a5: 1,
  a: 1
}));
function $f_sc_Set__equals__O__Z($thiz, that) {
  if (($thiz === that)) {
    return true;
  } else if ($is_sc_Set(that)) {
    if (($thiz.aa() === that.aa())) {
      try {
        return $thiz.Q0(that);
      } catch (e) {
        if ((e instanceof $c_jl_ClassCastException)) {
          return false;
        } else {
          throw e;
        }
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
}
function $is_sc_Set(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.aG)));
}
function $isArrayOf_sc_Set(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.aG)));
}
function $f_scm_IndexedSeqOps__sortInPlace__s_math_Ordering__scm_IndexedSeqOps($thiz, ord) {
  var len = $thiz.C();
  if ((len > 1)) {
    var arr = new $ac_O(len);
    var elem = 0;
    elem = 0;
    var it = $thiz.o();
    while (it.p()) {
      var x0 = it.q();
      arr.a[elem] = x0;
      elem = ((1 + elem) | 0);
    }
    $m_ju_Arrays$().Jn(arr, ord);
    elem = 0;
    while ((elem < arr.a.length)) {
      $thiz.cM(elem, arr.a[elem]);
      elem = ((1 + elem) | 0);
    }
  }
  return $thiz;
}
function $f_scm_IndexedSeqOps__sortInPlaceBy__F1__s_math_Ordering__scm_IndexedSeqOps($thiz, f, ord) {
  return $thiz.Y4(new $c_s_math_Ordering$$anon$1(ord, f));
}
/** @constructor */
function $c_s_reflect_ManifestFactory$AnyManifest$() {
  this.A7 = null;
  this.A7 = "Any";
}
$p = $c_s_reflect_ManifestFactory$AnyManifest$.prototype = new $h_s_reflect_ManifestFactory$PhantomManifest();
$p.constructor = $c_s_reflect_ManifestFactory$AnyManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$AnyManifest$() {
}
$h_s_reflect_ManifestFactory$AnyManifest$.prototype = $p;
$p.h8 = (function() {
  return $d_O.l();
});
$p.b2 = (function(len) {
  return new $ac_O(len);
});
var $d_s_reflect_ManifestFactory$AnyManifest$ = new $TypeData().i($c_s_reflect_ManifestFactory$AnyManifest$, "scala.reflect.ManifestFactory$AnyManifest$", ({
  Lg: 1,
  cV: 1,
  cU: 1,
  aN: 1,
  az: 1,
  aH: 1,
  aI: 1,
  a: 1,
  b: 1
}));
var $n_s_reflect_ManifestFactory$AnyManifest$;
function $m_s_reflect_ManifestFactory$AnyManifest$() {
  if ((!$n_s_reflect_ManifestFactory$AnyManifest$)) {
    $n_s_reflect_ManifestFactory$AnyManifest$ = new $c_s_reflect_ManifestFactory$AnyManifest$();
  }
  return $n_s_reflect_ManifestFactory$AnyManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$BooleanManifest$() {
  this.gO = null;
  this.gO = "Boolean";
}
$p = $c_s_reflect_ManifestFactory$BooleanManifest$.prototype = new $h_s_reflect_ManifestFactory$BooleanManifest();
$p.constructor = $c_s_reflect_ManifestFactory$BooleanManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$BooleanManifest$() {
}
$h_s_reflect_ManifestFactory$BooleanManifest$.prototype = $p;
var $d_s_reflect_ManifestFactory$BooleanManifest$ = new $TypeData().i($c_s_reflect_ManifestFactory$BooleanManifest$, "scala.reflect.ManifestFactory$BooleanManifest$", ({
  Li: 1,
  Lh: 1,
  be: 1,
  aN: 1,
  az: 1,
  aH: 1,
  aI: 1,
  a: 1,
  b: 1
}));
var $n_s_reflect_ManifestFactory$BooleanManifest$;
function $m_s_reflect_ManifestFactory$BooleanManifest$() {
  if ((!$n_s_reflect_ManifestFactory$BooleanManifest$)) {
    $n_s_reflect_ManifestFactory$BooleanManifest$ = new $c_s_reflect_ManifestFactory$BooleanManifest$();
  }
  return $n_s_reflect_ManifestFactory$BooleanManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$ByteManifest$() {
  this.gO = null;
  this.gO = "Byte";
}
$p = $c_s_reflect_ManifestFactory$ByteManifest$.prototype = new $h_s_reflect_ManifestFactory$ByteManifest();
$p.constructor = $c_s_reflect_ManifestFactory$ByteManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$ByteManifest$() {
}
$h_s_reflect_ManifestFactory$ByteManifest$.prototype = $p;
var $d_s_reflect_ManifestFactory$ByteManifest$ = new $TypeData().i($c_s_reflect_ManifestFactory$ByteManifest$, "scala.reflect.ManifestFactory$ByteManifest$", ({
  Lk: 1,
  Lj: 1,
  be: 1,
  aN: 1,
  az: 1,
  aH: 1,
  aI: 1,
  a: 1,
  b: 1
}));
var $n_s_reflect_ManifestFactory$ByteManifest$;
function $m_s_reflect_ManifestFactory$ByteManifest$() {
  if ((!$n_s_reflect_ManifestFactory$ByteManifest$)) {
    $n_s_reflect_ManifestFactory$ByteManifest$ = new $c_s_reflect_ManifestFactory$ByteManifest$();
  }
  return $n_s_reflect_ManifestFactory$ByteManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$CharManifest$() {
  this.gO = null;
  this.gO = "Char";
}
$p = $c_s_reflect_ManifestFactory$CharManifest$.prototype = new $h_s_reflect_ManifestFactory$CharManifest();
$p.constructor = $c_s_reflect_ManifestFactory$CharManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$CharManifest$() {
}
$h_s_reflect_ManifestFactory$CharManifest$.prototype = $p;
var $d_s_reflect_ManifestFactory$CharManifest$ = new $TypeData().i($c_s_reflect_ManifestFactory$CharManifest$, "scala.reflect.ManifestFactory$CharManifest$", ({
  Lm: 1,
  Ll: 1,
  be: 1,
  aN: 1,
  az: 1,
  aH: 1,
  aI: 1,
  a: 1,
  b: 1
}));
var $n_s_reflect_ManifestFactory$CharManifest$;
function $m_s_reflect_ManifestFactory$CharManifest$() {
  if ((!$n_s_reflect_ManifestFactory$CharManifest$)) {
    $n_s_reflect_ManifestFactory$CharManifest$ = new $c_s_reflect_ManifestFactory$CharManifest$();
  }
  return $n_s_reflect_ManifestFactory$CharManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$DoubleManifest$() {
  this.gO = null;
  this.gO = "Double";
}
$p = $c_s_reflect_ManifestFactory$DoubleManifest$.prototype = new $h_s_reflect_ManifestFactory$DoubleManifest();
$p.constructor = $c_s_reflect_ManifestFactory$DoubleManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$DoubleManifest$() {
}
$h_s_reflect_ManifestFactory$DoubleManifest$.prototype = $p;
var $d_s_reflect_ManifestFactory$DoubleManifest$ = new $TypeData().i($c_s_reflect_ManifestFactory$DoubleManifest$, "scala.reflect.ManifestFactory$DoubleManifest$", ({
  Lo: 1,
  Ln: 1,
  be: 1,
  aN: 1,
  az: 1,
  aH: 1,
  aI: 1,
  a: 1,
  b: 1
}));
var $n_s_reflect_ManifestFactory$DoubleManifest$;
function $m_s_reflect_ManifestFactory$DoubleManifest$() {
  if ((!$n_s_reflect_ManifestFactory$DoubleManifest$)) {
    $n_s_reflect_ManifestFactory$DoubleManifest$ = new $c_s_reflect_ManifestFactory$DoubleManifest$();
  }
  return $n_s_reflect_ManifestFactory$DoubleManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$FloatManifest$() {
  this.gO = null;
  this.gO = "Float";
}
$p = $c_s_reflect_ManifestFactory$FloatManifest$.prototype = new $h_s_reflect_ManifestFactory$FloatManifest();
$p.constructor = $c_s_reflect_ManifestFactory$FloatManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$FloatManifest$() {
}
$h_s_reflect_ManifestFactory$FloatManifest$.prototype = $p;
var $d_s_reflect_ManifestFactory$FloatManifest$ = new $TypeData().i($c_s_reflect_ManifestFactory$FloatManifest$, "scala.reflect.ManifestFactory$FloatManifest$", ({
  Lq: 1,
  Lp: 1,
  be: 1,
  aN: 1,
  az: 1,
  aH: 1,
  aI: 1,
  a: 1,
  b: 1
}));
var $n_s_reflect_ManifestFactory$FloatManifest$;
function $m_s_reflect_ManifestFactory$FloatManifest$() {
  if ((!$n_s_reflect_ManifestFactory$FloatManifest$)) {
    $n_s_reflect_ManifestFactory$FloatManifest$ = new $c_s_reflect_ManifestFactory$FloatManifest$();
  }
  return $n_s_reflect_ManifestFactory$FloatManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$IntManifest$() {
  this.gO = null;
  this.gO = "Int";
}
$p = $c_s_reflect_ManifestFactory$IntManifest$.prototype = new $h_s_reflect_ManifestFactory$IntManifest();
$p.constructor = $c_s_reflect_ManifestFactory$IntManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$IntManifest$() {
}
$h_s_reflect_ManifestFactory$IntManifest$.prototype = $p;
var $d_s_reflect_ManifestFactory$IntManifest$ = new $TypeData().i($c_s_reflect_ManifestFactory$IntManifest$, "scala.reflect.ManifestFactory$IntManifest$", ({
  Ls: 1,
  Lr: 1,
  be: 1,
  aN: 1,
  az: 1,
  aH: 1,
  aI: 1,
  a: 1,
  b: 1
}));
var $n_s_reflect_ManifestFactory$IntManifest$;
function $m_s_reflect_ManifestFactory$IntManifest$() {
  if ((!$n_s_reflect_ManifestFactory$IntManifest$)) {
    $n_s_reflect_ManifestFactory$IntManifest$ = new $c_s_reflect_ManifestFactory$IntManifest$();
  }
  return $n_s_reflect_ManifestFactory$IntManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$LongManifest$() {
  this.gO = null;
  this.gO = "Long";
}
$p = $c_s_reflect_ManifestFactory$LongManifest$.prototype = new $h_s_reflect_ManifestFactory$LongManifest();
$p.constructor = $c_s_reflect_ManifestFactory$LongManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$LongManifest$() {
}
$h_s_reflect_ManifestFactory$LongManifest$.prototype = $p;
var $d_s_reflect_ManifestFactory$LongManifest$ = new $TypeData().i($c_s_reflect_ManifestFactory$LongManifest$, "scala.reflect.ManifestFactory$LongManifest$", ({
  Lu: 1,
  Lt: 1,
  be: 1,
  aN: 1,
  az: 1,
  aH: 1,
  aI: 1,
  a: 1,
  b: 1
}));
var $n_s_reflect_ManifestFactory$LongManifest$;
function $m_s_reflect_ManifestFactory$LongManifest$() {
  if ((!$n_s_reflect_ManifestFactory$LongManifest$)) {
    $n_s_reflect_ManifestFactory$LongManifest$ = new $c_s_reflect_ManifestFactory$LongManifest$();
  }
  return $n_s_reflect_ManifestFactory$LongManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$NothingManifest$() {
  this.A7 = null;
  this.A7 = "Nothing";
}
$p = $c_s_reflect_ManifestFactory$NothingManifest$.prototype = new $h_s_reflect_ManifestFactory$PhantomManifest();
$p.constructor = $c_s_reflect_ManifestFactory$NothingManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$NothingManifest$() {
}
$h_s_reflect_ManifestFactory$NothingManifest$.prototype = $p;
$p.h8 = (function() {
  return $d_sr_Nothing$.l();
});
$p.b2 = (function(len) {
  return new $ac_O(len);
});
var $d_s_reflect_ManifestFactory$NothingManifest$ = new $TypeData().i($c_s_reflect_ManifestFactory$NothingManifest$, "scala.reflect.ManifestFactory$NothingManifest$", ({
  Lv: 1,
  cV: 1,
  cU: 1,
  aN: 1,
  az: 1,
  aH: 1,
  aI: 1,
  a: 1,
  b: 1
}));
var $n_s_reflect_ManifestFactory$NothingManifest$;
function $m_s_reflect_ManifestFactory$NothingManifest$() {
  if ((!$n_s_reflect_ManifestFactory$NothingManifest$)) {
    $n_s_reflect_ManifestFactory$NothingManifest$ = new $c_s_reflect_ManifestFactory$NothingManifest$();
  }
  return $n_s_reflect_ManifestFactory$NothingManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$NullManifest$() {
  this.A7 = null;
  this.A7 = "Null";
}
$p = $c_s_reflect_ManifestFactory$NullManifest$.prototype = new $h_s_reflect_ManifestFactory$PhantomManifest();
$p.constructor = $c_s_reflect_ManifestFactory$NullManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$NullManifest$() {
}
$h_s_reflect_ManifestFactory$NullManifest$.prototype = $p;
$p.h8 = (function() {
  return $d_sr_Null$.l();
});
$p.b2 = (function(len) {
  return new $ac_O(len);
});
var $d_s_reflect_ManifestFactory$NullManifest$ = new $TypeData().i($c_s_reflect_ManifestFactory$NullManifest$, "scala.reflect.ManifestFactory$NullManifest$", ({
  Lw: 1,
  cV: 1,
  cU: 1,
  aN: 1,
  az: 1,
  aH: 1,
  aI: 1,
  a: 1,
  b: 1
}));
var $n_s_reflect_ManifestFactory$NullManifest$;
function $m_s_reflect_ManifestFactory$NullManifest$() {
  if ((!$n_s_reflect_ManifestFactory$NullManifest$)) {
    $n_s_reflect_ManifestFactory$NullManifest$ = new $c_s_reflect_ManifestFactory$NullManifest$();
  }
  return $n_s_reflect_ManifestFactory$NullManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$ObjectManifest$() {
  this.A7 = null;
  this.A7 = "Object";
}
$p = $c_s_reflect_ManifestFactory$ObjectManifest$.prototype = new $h_s_reflect_ManifestFactory$PhantomManifest();
$p.constructor = $c_s_reflect_ManifestFactory$ObjectManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$ObjectManifest$() {
}
$h_s_reflect_ManifestFactory$ObjectManifest$.prototype = $p;
$p.h8 = (function() {
  return $d_O.l();
});
$p.b2 = (function(len) {
  return new $ac_O(len);
});
var $d_s_reflect_ManifestFactory$ObjectManifest$ = new $TypeData().i($c_s_reflect_ManifestFactory$ObjectManifest$, "scala.reflect.ManifestFactory$ObjectManifest$", ({
  Lx: 1,
  cV: 1,
  cU: 1,
  aN: 1,
  az: 1,
  aH: 1,
  aI: 1,
  a: 1,
  b: 1
}));
var $n_s_reflect_ManifestFactory$ObjectManifest$;
function $m_s_reflect_ManifestFactory$ObjectManifest$() {
  if ((!$n_s_reflect_ManifestFactory$ObjectManifest$)) {
    $n_s_reflect_ManifestFactory$ObjectManifest$ = new $c_s_reflect_ManifestFactory$ObjectManifest$();
  }
  return $n_s_reflect_ManifestFactory$ObjectManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$ShortManifest$() {
  this.gO = null;
  this.gO = "Short";
}
$p = $c_s_reflect_ManifestFactory$ShortManifest$.prototype = new $h_s_reflect_ManifestFactory$ShortManifest();
$p.constructor = $c_s_reflect_ManifestFactory$ShortManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$ShortManifest$() {
}
$h_s_reflect_ManifestFactory$ShortManifest$.prototype = $p;
var $d_s_reflect_ManifestFactory$ShortManifest$ = new $TypeData().i($c_s_reflect_ManifestFactory$ShortManifest$, "scala.reflect.ManifestFactory$ShortManifest$", ({
  Lz: 1,
  Ly: 1,
  be: 1,
  aN: 1,
  az: 1,
  aH: 1,
  aI: 1,
  a: 1,
  b: 1
}));
var $n_s_reflect_ManifestFactory$ShortManifest$;
function $m_s_reflect_ManifestFactory$ShortManifest$() {
  if ((!$n_s_reflect_ManifestFactory$ShortManifest$)) {
    $n_s_reflect_ManifestFactory$ShortManifest$ = new $c_s_reflect_ManifestFactory$ShortManifest$();
  }
  return $n_s_reflect_ManifestFactory$ShortManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$UnitManifest$() {
  this.gO = null;
  this.gO = "Unit";
}
$p = $c_s_reflect_ManifestFactory$UnitManifest$.prototype = new $h_s_reflect_ManifestFactory$UnitManifest();
$p.constructor = $c_s_reflect_ManifestFactory$UnitManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$UnitManifest$() {
}
$h_s_reflect_ManifestFactory$UnitManifest$.prototype = $p;
var $d_s_reflect_ManifestFactory$UnitManifest$ = new $TypeData().i($c_s_reflect_ManifestFactory$UnitManifest$, "scala.reflect.ManifestFactory$UnitManifest$", ({
  LB: 1,
  LA: 1,
  be: 1,
  aN: 1,
  az: 1,
  aH: 1,
  aI: 1,
  a: 1,
  b: 1
}));
var $n_s_reflect_ManifestFactory$UnitManifest$;
function $m_s_reflect_ManifestFactory$UnitManifest$() {
  if ((!$n_s_reflect_ManifestFactory$UnitManifest$)) {
    $n_s_reflect_ManifestFactory$UnitManifest$ = new $c_s_reflect_ManifestFactory$UnitManifest$();
  }
  return $n_s_reflect_ManifestFactory$UnitManifest$;
}
/** @constructor */
function $c_sr_RichDouble(self) {
  this.kk = 0.0;
  this.kk = self;
}
$p = $c_sr_RichDouble.prototype = new $h_O();
$p.constructor = $c_sr_RichDouble;
/** @constructor */
function $h_sr_RichDouble() {
}
$h_sr_RichDouble.prototype = $p;
$p.pp = (function(that) {
  return $m_jl_Double$().P9(this.kk, (+that));
});
$p.m = (function() {
  return $f_s_Proxy__toString__T(this);
});
$p.vY = (function() {
  return this.kk;
});
$p.DX = (function() {
  return Math.fround(this.kk);
});
$p.lY = (function() {
  return $m_RTLong$().d1(this.kk);
});
$p.lm = (function() {
  return $doubleToInt(this.kk);
});
$p.P2 = (function() {
  return (($doubleToInt(this.kk) << 24) >> 24);
});
$p.PT = (function() {
  return (($doubleToInt(this.kk) << 16) >> 16);
});
$p.Ap = (function() {
  return $m_sr_RichDouble$().b3B(this.kk);
});
$p.Xf = (function() {
  return $m_sr_RichDouble$().b3r(this.kk);
});
$p.Xi = (function() {
  return $m_sr_RichDouble$().b3z(this.kk);
});
$p.Xg = (function() {
  return $m_sr_RichDouble$().b3t(this.kk);
});
$p.Pz = (function() {
  return $m_sr_RichDouble$().b3x(this.kk);
});
$p.x = (function() {
  var this$ = this.kk;
  var valueInt = (this$ | 0);
  if (((valueInt === this$) && ((1.0 / this$) !== (-Infinity)))) {
    return valueInt;
  } else if ((this$ !== this$)) {
    return 2146959360;
  } else {
    var fpBitsDataView = $fpBitsDataView;
    fpBitsDataView.setFloat64(0, this$, true);
    return ((fpBitsDataView.getInt32(0, true) | 0) ^ (fpBitsDataView.getInt32(4, true) | 0));
  }
});
$p.e = (function(x$1) {
  return $m_sr_RichDouble$().b0H(this.kk, x$1);
});
$p.ahX = (function() {
  return this.kk;
});
function $isArrayOf_sr_RichDouble(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.mi)));
}
var $d_sr_RichDouble = new $TypeData().i($c_sr_RichDouble, "scala.runtime.RichDouble", ({
  mi: 1,
  LO: 1,
  e0: 1,
  c7: 1,
  dx: 1,
  dw: 1,
  dZ: 1,
  b3: 1,
  Q: 1
}));
/** @constructor */
function $c_sr_RichInt(self) {
  this.ns = 0;
  this.ns = self;
}
$p = $c_sr_RichInt.prototype = new $h_O();
$p.constructor = $c_sr_RichInt;
/** @constructor */
function $h_sr_RichInt() {
}
$h_sr_RichInt.prototype = $p;
$p.pp = (function(that) {
  $m_s_math_Ordering$Int$();
  var x = this.ns;
  var y = (that | 0);
  return ((x === y) ? 0 : ((x < y) ? (-1) : 1));
});
$p.m = (function() {
  return $f_s_Proxy__toString__T(this);
});
$p.Xf = (function() {
  return $f_s_math_ScalaNumericAnyConversions__isValidByte__Z(this);
});
$p.Xi = (function() {
  return $f_s_math_ScalaNumericAnyConversions__isValidShort__Z(this);
});
$p.Xg = (function() {
  return $f_s_math_ScalaNumericAnyConversions__isValidChar__Z(this);
});
$p.vY = (function() {
  return this.ns;
});
$p.DX = (function() {
  return Math.fround(this.ns);
});
$p.lY = (function() {
  var this$ = this.ns;
  var hi = (this$ >> 31);
  return $bL(this$, hi);
});
$p.lm = (function() {
  return this.ns;
});
$p.P2 = (function() {
  return ((this.ns << 24) >> 24);
});
$p.PT = (function() {
  return ((this.ns << 16) >> 16);
});
$p.Ap = (function() {
  return true;
});
$p.Pz = (function() {
  return true;
});
$p.x = (function() {
  return this.ns;
});
$p.e = (function(x$1) {
  return $m_sr_RichInt$().b0I(this.ns, x$1);
});
$p.ahX = (function() {
  return this.ns;
});
function $isArrayOf_sr_RichInt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.mj)));
}
var $d_sr_RichInt = new $TypeData().i($c_sr_RichInt, "scala.runtime.RichInt", ({
  mj: 1,
  e0: 1,
  c7: 1,
  dx: 1,
  dw: 1,
  dZ: 1,
  b3: 1,
  Q: 1,
  mh: 1
}));
function $f_Lupickle_implicits_Readers__$init$__V($thiz) {
  new $c_Lupickle_implicits_Readers$$anon$1($thiz);
  $thiz.ow = new $c_Lupickle_implicits_Readers$$anon$3($thiz);
  $thiz.aKa = new $c_Lupickle_implicits_Readers$$anon$4($thiz);
  $thiz.pk = new $c_Lupickle_implicits_Readers$$anon$5($thiz);
  $thiz.aKc = new $c_Lupickle_implicits_Readers$$anon$6($thiz);
  $thiz.aKi = new $c_Lupickle_implicits_Readers$$anon$7($thiz);
  $thiz.aK6 = new $c_Lupickle_implicits_Readers$$anon$8($thiz);
  $thiz.a5 = new $c_Lupickle_implicits_Readers$$anon$9($thiz);
  $thiz.aK8 = new $c_Lupickle_implicits_Readers$$anon$10($thiz);
  new $c_Lupickle_implicits_Readers$$anon$11($thiz);
  $thiz.Ii = new $c_Lupickle_implicits_Readers$$anon$12($thiz);
  new $c_Lupickle_implicits_Readers$$anon$13($thiz);
  new $c_Lupickle_implicits_Readers$$anon$14($thiz);
  new $c_Lupickle_implicits_Readers$$anon$15($thiz);
  $thiz.ae2 = new $c_Lupickle_implicits_Readers$$anon$16($thiz);
  $thiz.ae2.gB();
  $thiz.ae2.gB();
  $thiz.En().DI($thiz.ow).DR();
  $thiz.En().DI($thiz.aK6).DR();
  $thiz.En().DI($thiz.aK8).DR();
  $thiz.En().DI($thiz.aKi).DR();
  $thiz.En().DI($thiz.pk).DR();
  $thiz.En().DI($thiz.Ii).DR();
  $thiz.En().DI($thiz.aKc).DR();
  $thiz.En().DI($thiz.aKa).DR();
}
function $f_Lupickle_implicits_Readers__MapReader2__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($thiz, evidence$1, evidence$2) {
  return new $c_Lupickle_implicits_Readers$$anon$17(evidence$2, evidence$1, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((seq) => {
    var b = new $c_sci_MapBuilderImpl();
    seq.F(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => b.lR(_$2.g(), _$2.h()))));
    return b.oG();
  })), $thiz);
}
function $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($thiz, evidence$1) {
  return ($is_Lupickle_implicits_Readers$OptionReader(evidence$1) ? new $c_Lupickle_implicits_Readers$$anon$19(evidence$1, $thiz) : new $c_Lupickle_implicits_Readers$$anon$21(evidence$1, $thiz));
}
function $s_Lupickle_implicits_Readers__upickle$implicits$Readers$$_$$anon$superArg$1$1__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader(evidence$1$1) {
  return new $c_Lupickle_core_Types$$anon$4(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$8) => new $c_s_Some(_$8))), evidence$1$1);
}
function $f_Lcom_raquo_airstream_common_SingleParentStream__onStart__V($thiz) {
  $f_Lcom_raquo_airstream_core_WritableObservable__addInternalObserver__Lcom_raquo_airstream_core_InternalObserver__Z__V($thiz.ku(), $thiz, false);
}
function $f_Lcom_raquo_airstream_common_SingleParentStream__onStop__V($thiz) {
  $f_Lcom_raquo_airstream_core_BaseObservable__removeInternalObserver__Lcom_raquo_airstream_core_InternalObserver__V($thiz.ku(), $thiz);
}
/** @constructor */
function $c_Lcom_raquo_airstream_custom_CustomStreamSource(makeConfig) {
  this.ajl = null;
  this.ajk = false;
  this.ajm = null;
  this.aji = null;
  this.ajj = null;
  this.ajo = false;
  this.ajn = 0;
  this.Yo = 0;
  this.Yn = null;
  this.ajl = (void 0);
  $f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  $f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  $f_Lcom_raquo_airstream_custom_CustomSource__$init$__V(this);
  this.Yn = makeConfig.a2I(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((value) => {
    new $c_Lcom_raquo_airstream_core_Transaction(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => {
      $f_Lcom_raquo_airstream_core_WritableStream__fireValue__O__Lcom_raquo_airstream_core_Transaction__V(this, value, _$1);
    })));
  })), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((err) => {
    new $c_Lcom_raquo_airstream_core_Transaction(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((err$2) => ((_$2) => {
      $f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, err$2, _$2);
    }))(err)));
  })), new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => this.Yo)), new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $f_Lcom_raquo_airstream_core_BaseObservable__isStarted__Z(this))));
}
$p = $c_Lcom_raquo_airstream_custom_CustomStreamSource.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_custom_CustomStreamSource;
/** @constructor */
function $h_Lcom_raquo_airstream_custom_CustomStreamSource() {
}
$h_Lcom_raquo_airstream_custom_CustomStreamSource.prototype = $p;
$p.fx = (function() {
  return this.ajl;
});
$p.eU = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$p.m = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.hR = (function() {
  return this.ajk;
});
$p.h5 = (function() {
  return this.ajm;
});
$p.gb = (function(x$1) {
  this.ajk = x$1;
});
$p.hS = (function(x$1) {
  this.ajm = x$1;
});
$p.e = (function(obj) {
  return (this === obj);
});
$p.x = (function() {
  return $systemIdentityHashCode(this);
});
$p.ip = (function(observer) {
});
$p.mY = (function() {
  return this;
});
$p.gk = (function() {
  return this.aji;
});
$p.gl = (function() {
  return this.ajj;
});
$p.iA = (function() {
  return this.ajo;
});
$p.hs = (function(x$1) {
  this.ajo = x$1;
});
$p.ig = (function(x$0) {
  this.aji = x$0;
});
$p.ih = (function(x$0) {
  this.ajj = x$0;
});
$p.ik = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.eB = (function() {
  return this.ajn;
});
$p.iu = (function() {
  $f_Lcom_raquo_airstream_custom_CustomSource__onWillStart__V(this);
});
$p.ir = (function() {
  $f_Lcom_raquo_airstream_custom_CustomSource__onStart__V(this);
});
$p.is = (function() {
  $f_Lcom_raquo_airstream_custom_CustomSource__onStop__V(this);
});
$p.fQ = (function(project) {
  return new $c_Lcom_raquo_airstream_misc_MapStream(this, project, $m_s_None$());
});
$p.ii = (function(isSame) {
  return new $c_Lcom_raquo_airstream_distinct_DistinctStream(this, isSame, false);
});
$p.dM = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_custom_CustomStreamSource = new $TypeData().i($c_Lcom_raquo_airstream_custom_CustomStreamSource, "com.raquo.airstream.custom.CustomStreamSource", ({
  o9: 1,
  P: 1,
  O: 1,
  U: 1,
  V: 1,
  al: 1,
  am: 1,
  Z: 1,
  aq: 1,
  o5: 1
}));
/** @constructor */
function $c_Lcom_raquo_airstream_state_Val(constantValue) {
  this.alA = null;
  this.alz = false;
  this.alB = null;
  this.a62 = 0;
  this.alx = null;
  this.aly = null;
  this.alD = false;
  this.a63 = null;
  this.YN = null;
  this.alC = 0;
  this.YN = constantValue;
  this.alA = (void 0);
  $f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  this.a62 = 0;
  $f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.a63 = (void 0);
  this.alC = 1;
}
$p = $c_Lcom_raquo_airstream_state_Val.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_state_Val;
/** @constructor */
function $h_Lcom_raquo_airstream_state_Val() {
}
$h_Lcom_raquo_airstream_state_Val.prototype = $p;
$p.fx = (function() {
  return this.alA;
});
$p.eU = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$p.m = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.hR = (function() {
  return this.alz;
});
$p.h5 = (function() {
  return this.alB;
});
$p.gb = (function(x$1) {
  this.alz = x$1;
});
$p.hS = (function(x$1) {
  this.alB = x$1;
});
$p.is = (function() {
});
$p.e = (function(obj) {
  return (this === obj);
});
$p.x = (function() {
  return $systemIdentityHashCode(this);
});
$p.jk = (function() {
  return this.a62;
});
$p.xZ = (function(x$1) {
  this.a62 = x$1;
});
$p.dP = (function() {
  return this;
});
$p.ir = (function() {
  $f_Lcom_raquo_airstream_core_Signal__onStart__V(this);
});
$p.ip = (function(observer) {
  observer.mT(this.YN);
});
$p.gk = (function() {
  return this.alx;
});
$p.gl = (function() {
  return this.aly;
});
$p.iA = (function() {
  return this.alD;
});
$p.hs = (function(x$1) {
  this.alD = x$1;
});
$p.ig = (function(x$0) {
  this.alx = x$0;
});
$p.ih = (function(x$0) {
  this.aly = x$0;
});
$p.ye = (function() {
  return this.a63;
});
$p.At = (function(x$1) {
  this.a63 = x$1;
});
$p.ik = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.eB = (function() {
  return this.alC;
});
$p.aq = (function() {
  return this.YN;
});
$p.vX = (function() {
  return this.YN;
});
$p.iu = (function() {
});
$p.fQ = (function(project) {
  return $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), this, project, $m_s_None$());
});
$p.ii = (function(isSame) {
  return new $c_Lcom_raquo_airstream_distinct_DistinctSignal(this, isSame, false);
});
$p.dM = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_state_Val = new $TypeData().i($c_Lcom_raquo_airstream_state_Val, "com.raquo.airstream.state.Val", ({
  oH: 1,
  P: 1,
  O: 1,
  U: 1,
  V: 1,
  aB: 1,
  aD: 1,
  Z: 1,
  aS: 1,
  cf: 1
}));
/** @constructor */
function $c_Lcom_raquo_airstream_state_VarSignal(initial, parentDisplayName) {
  this.alI = null;
  this.alH = false;
  this.alJ = null;
  this.a64 = 0;
  this.alF = null;
  this.alG = null;
  this.alM = false;
  this.a65 = null;
  this.alK = null;
  this.alL = 0;
  this.alK = parentDisplayName;
  this.alI = (void 0);
  $f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  this.a64 = 0;
  $f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.a65 = (void 0);
  this.alL = 1;
  $f_Lcom_raquo_airstream_core_WritableSignal__setCurrentValue__s_util_Try__V(this, initial);
}
$p = $c_Lcom_raquo_airstream_state_VarSignal.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_state_VarSignal;
/** @constructor */
function $h_Lcom_raquo_airstream_state_VarSignal() {
}
$h_Lcom_raquo_airstream_state_VarSignal.prototype = $p;
$p.fx = (function() {
  return this.alI;
});
$p.m = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.hR = (function() {
  return this.alH;
});
$p.h5 = (function() {
  return this.alJ;
});
$p.gb = (function(x$1) {
  this.alH = x$1;
});
$p.hS = (function(x$1) {
  this.alJ = x$1;
});
$p.is = (function() {
});
$p.e = (function(obj) {
  return (this === obj);
});
$p.x = (function() {
  return $systemIdentityHashCode(this);
});
$p.jk = (function() {
  return this.a64;
});
$p.xZ = (function(x$1) {
  this.a64 = x$1;
});
$p.dP = (function() {
  return this;
});
$p.ir = (function() {
  $f_Lcom_raquo_airstream_core_Signal__onStart__V(this);
});
$p.ip = (function(observer) {
  observer.mT($f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this));
});
$p.gk = (function() {
  return this.alF;
});
$p.gl = (function() {
  return this.alG;
});
$p.iA = (function() {
  return this.alM;
});
$p.hs = (function(x$1) {
  this.alM = x$1;
});
$p.ig = (function(x$0) {
  this.alF = x$0;
});
$p.ih = (function(x$0) {
  this.alG = x$0;
});
$p.ye = (function() {
  return this.a65;
});
$p.At = (function(x$1) {
  this.a65 = x$1;
});
$p.ik = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.aq = (function() {
  return $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this);
});
$p.eB = (function() {
  return this.alL;
});
$p.vX = (function() {
  return $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this);
});
$p.iu = (function() {
});
$p.eU = (function() {
  return (this.alK.a3() + ".signal");
});
$p.fQ = (function(project) {
  return $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), this, project, $m_s_None$());
});
$p.ii = (function(isSame) {
  return new $c_Lcom_raquo_airstream_distinct_DistinctSignal(this, isSame, false);
});
$p.dM = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_state_VarSignal = new $TypeData().i($c_Lcom_raquo_airstream_state_VarSignal, "com.raquo.airstream.state.VarSignal", ({
  oP: 1,
  P: 1,
  O: 1,
  U: 1,
  V: 1,
  aB: 1,
  aD: 1,
  Z: 1,
  aS: 1,
  cf: 1
}));
/** @constructor */
function $c_ju_Collections$ImmutableSet(inner) {
  this.B7 = null;
  $ct_ju_Collections$UnmodifiableSet__ju_Set__(this, inner);
}
$p = $c_ju_Collections$ImmutableSet.prototype = new $h_ju_Collections$UnmodifiableSet();
$p.constructor = $c_ju_Collections$ImmutableSet;
/** @constructor */
function $h_ju_Collections$ImmutableSet() {
}
$h_ju_Collections$ImmutableSet.prototype = $p;
var $d_ju_Collections$ImmutableSet = new $TypeData().i($c_ju_Collections$ImmutableSet, "java.util.Collections$ImmutableSet", ({
  sZ: 1,
  t2: 1,
  t0: 1,
  t3: 1,
  bA: 1,
  cl: 1,
  a: 1,
  t6: 1,
  t4: 1,
  cq: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_Format$$anon$1() {
  this.Kf = null;
  $ct_Lorg_jpablo_graphexplorer_graphviz_Format__T__(this, "dot_json");
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_Format$$anon$1.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_Format();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_Format$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_Format$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_Format$$anon$1.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return "DotJson";
});
$p.m = (function() {
  return "DotJson";
});
var $d_Lorg_jpablo_graphexplorer_graphviz_Format$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_Format$$anon$1, "org.jpablo.graphexplorer.graphviz.Format$$anon$1", ({
  u9: 1,
  cs: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_Format$$anon$2() {
  this.Kf = null;
  $ct_Lorg_jpablo_graphexplorer_graphviz_Format__T__(this, "json0");
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_Format$$anon$2.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_Format();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_Format$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_Format$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_Format$$anon$2.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return "Json0";
});
$p.m = (function() {
  return "Json0";
});
var $d_Lorg_jpablo_graphexplorer_graphviz_Format$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_Format$$anon$2, "org.jpablo.graphexplorer.graphviz.Format$$anon$2", ({
  ua: 1,
  cs: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_Format$$anon$3() {
  this.Kf = null;
  $ct_Lorg_jpablo_graphexplorer_graphviz_Format__T__(this, "svg");
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_Format$$anon$3.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_Format();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_Format$$anon$3;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_Format$$anon$3() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_Format$$anon$3.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return "Svg";
});
$p.m = (function() {
  return "Svg";
});
var $d_Lorg_jpablo_graphexplorer_graphviz_Format$$anon$3 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_Format$$anon$3, "org.jpablo.graphexplorer.graphviz.Format$$anon$3", ({
  ub: 1,
  cs: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_RenderStatus$$anon$4() {
  this.Re = null;
  $ct_Lorg_jpablo_graphexplorer_graphviz_RenderStatus__T__(this, "success");
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_RenderStatus$$anon$4.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_RenderStatus();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_RenderStatus$$anon$4;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_RenderStatus$$anon$4() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_RenderStatus$$anon$4.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return "Success";
});
$p.m = (function() {
  return "Success";
});
var $d_Lorg_jpablo_graphexplorer_graphviz_RenderStatus$$anon$4 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_RenderStatus$$anon$4, "org.jpablo.graphexplorer.graphviz.RenderStatus$$anon$4", ({
  ug: 1,
  fh: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_RenderStatus$$anon$5() {
  this.Re = null;
  $ct_Lorg_jpablo_graphexplorer_graphviz_RenderStatus__T__(this, "failure");
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_RenderStatus$$anon$5.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_RenderStatus();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_RenderStatus$$anon$5;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_RenderStatus$$anon$5() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_RenderStatus$$anon$5.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return "Failure";
});
$p.m = (function() {
  return "Failure";
});
var $d_Lorg_jpablo_graphexplorer_graphviz_RenderStatus$$anon$5 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_RenderStatus$$anon$5, "org.jpablo.graphexplorer.graphviz.RenderStatus$$anon$5", ({
  uh: 1,
  fh: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$$anon$2(\u03b4name$4, _$ordinal$4) {
  this.a7M = null;
  this.a7M = \u03b4name$4;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$$anon$2.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$$anon$2.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.a7M;
});
$p.m = (function() {
  return this.a7M;
});
var $d_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$$anon$2, "org.jpablo.graphexplorer.graphviz.dotlang.AttrTarget$$anon$2", ({
  uk: 1,
  ui: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$$anon$1(\u03b4name$3, _$ordinal$3) {
  this.a7N = null;
  this.a7N = \u03b4name$3;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$$anon$1.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$$anon$1.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.a7N;
});
$p.m = (function() {
  return this.a7N;
});
var $d_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$$anon$1, "org.jpablo.graphexplorer.graphviz.dotlang.Compass$$anon$1", ({
  um: 1,
  fi: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$$anon$1(\u03b4name$2, _$ordinal$2) {
  this.a7O = null;
  this.a7O = \u03b4name$2;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$$anon$1.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$$anon$1.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.a7O;
});
$p.m = (function() {
  return this.a7O;
});
var $d_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$$anon$1, "org.jpablo.graphexplorer.graphviz.html.HtmlAlign$$anon$1", ({
  us: 1,
  uq: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$$anon$1() {
  $ct_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance__I__(this, 0);
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$$anon$1.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$$anon$1.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return "None";
});
$p.m = (function() {
  return "None";
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$$anon$1, "org.jpablo.graphexplorer.graphviz.layout.NSBalance$$anon$1", ({
  uO: 1,
  dj: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$$anon$2() {
  $ct_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance__I__(this, 1);
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$$anon$2.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$$anon$2.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return "TopBottom";
});
$p.m = (function() {
  return "TopBottom";
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$$anon$2, "org.jpablo.graphexplorer.graphviz.layout.NSBalance$$anon$2", ({
  uP: 1,
  dj: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$$anon$3() {
  $ct_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance__I__(this, 2);
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$$anon$3.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$$anon$3;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$$anon$3() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$$anon$3.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return "LeftRight";
});
$p.m = (function() {
  return "LeftRight";
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$$anon$3 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$$anon$3, "org.jpablo.graphexplorer.graphviz.layout.NSBalance$$anon$3", ({
  uQ: 1,
  dj: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$$anon$1() {
  this.KS = 0;
  $ct_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass__I__(this, 0);
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$$anon$1.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$$anon$1.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return "Ordinary";
});
$p.m = (function() {
  return "Ordinary";
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$$anon$1, "org.jpablo.graphexplorer.graphviz.layout.NSClass$$anon$1", ({
  uS: 1,
  dk: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$$anon$2() {
  this.KS = 0;
  $ct_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass__I__(this, 1);
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$$anon$2.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$$anon$2.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return "Singleton";
});
$p.m = (function() {
  return "Singleton";
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$$anon$2, "org.jpablo.graphexplorer.graphviz.layout.NSClass$$anon$2", ({
  uT: 1,
  dk: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$$anon$3() {
  this.KS = 0;
  $ct_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass__I__(this, 2);
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$$anon$3.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$$anon$3;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$$anon$3() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$$anon$3.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return "Virtual";
});
$p.m = (function() {
  return "Virtual";
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$$anon$3 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$$anon$3, "org.jpablo.graphexplorer.graphviz.layout.NSClass$$anon$3", ({
  uU: 1,
  dk: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen$$anon$1(\u03b4name$2, _$ordinal$2) {
  this.a7Z = null;
  this.a7Z = \u03b4name$2;
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen$$anon$1.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen$$anon$1.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.a7Z;
});
$p.m = (function() {
  return this.a7Z;
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen$$anon$1, "org.jpablo.graphexplorer.graphviz.layout.Polygon$Gen$$anon$1", ({
  v9: 1,
  v7: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$$anon$1() {
  $ct_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir__I__(this, 0);
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$$anon$1.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$$anon$1.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return "TB";
});
$p.m = (function() {
  return "TB";
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$$anon$1, "org.jpablo.graphexplorer.graphviz.layout.RankDir$$anon$1", ({
  vf: 1,
  cv: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$$anon$2() {
  $ct_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir__I__(this, 1);
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$$anon$2.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$$anon$2.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return "LR";
});
$p.m = (function() {
  return "LR";
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$$anon$2, "org.jpablo.graphexplorer.graphviz.layout.RankDir$$anon$2", ({
  vg: 1,
  cv: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$$anon$3() {
  $ct_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir__I__(this, 2);
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$$anon$3.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$$anon$3;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$$anon$3() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$$anon$3.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return "BT";
});
$p.m = (function() {
  return "BT";
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$$anon$3 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$$anon$3, "org.jpablo.graphexplorer.graphviz.layout.RankDir$$anon$3", ({
  vh: 1,
  cv: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$$anon$4() {
  $ct_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir__I__(this, 3);
}
$p = $c_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$$anon$4.prototype = new $h_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir();
$p.constructor = $c_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$$anon$4;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$$anon$4() {
}
$h_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$$anon$4.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return "RL";
});
$p.m = (function() {
  return "RL";
});
var $d_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$$anon$4 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$$anon$4, "org.jpablo.graphexplorer.graphviz.layout.RankDir$$anon$4", ({
  vi: 1,
  cv: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$$anon$2(\u03b4name$4, _$ordinal$4) {
  this.a8c = null;
  this.a8c = \u03b4name$4;
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$$anon$2.prototype = new $h_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$$anon$2.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.a8c;
});
$p.m = (function() {
  return this.a8c;
});
var $d_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$$anon$2, "org.jpablo.graphexplorer.gxcore.command.DocumentCommand$$anon$2", ({
  vG: 1,
  bS: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$$anon$1(\u03b4name$2, _$ordinal$2) {
  this.a8d = null;
  this.a8d = \u03b4name$2;
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$$anon$1.prototype = new $h_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$$anon$1.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.a8d;
});
$p.m = (function() {
  return this.a8d;
});
var $d_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$$anon$1, "org.jpablo.graphexplorer.gxcore.command.SessionCommand$$anon$1", ({
  vQ: 1,
  cw: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_command_Tier$$anon$1(\u03b4name$3, _$ordinal$3) {
  this.a8e = null;
  this.a8e = \u03b4name$3;
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_command_Tier$$anon$1.prototype = new $h_Lorg_jpablo_graphexplorer_gxcore_command_Tier();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_command_Tier$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_command_Tier$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_command_Tier$$anon$1.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.a8e;
});
$p.m = (function() {
  return this.a8e;
});
var $d_Lorg_jpablo_graphexplorer_gxcore_command_Tier$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_command_Tier$$anon$1, "org.jpablo.graphexplorer.gxcore.command.Tier$$anon$1", ({
  vT: 1,
  vR: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$$anon$1() {
  $ct_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding__T__(this, "\n");
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$$anon$1.prototype = new $h_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$$anon$1.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return "Lf";
});
$p.m = (function() {
  return "Lf";
});
var $d_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$$anon$1, "org.jpablo.graphexplorer.gxcore.fs.LineEnding$$anon$1", ({
  vV: 1,
  gP: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$$anon$2() {
  $ct_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding__T__(this, "\r\n");
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$$anon$2.prototype = new $h_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$$anon$2.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return "Crlf";
});
$p.m = (function() {
  return "Crlf";
});
var $d_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$$anon$2, "org.jpablo.graphexplorer.gxcore.fs.LineEnding$$anon$2", ({
  vW: 1,
  gP: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$$anon$1(\u03b4name$3, _$ordinal$3) {
  this.a8f = null;
  this.a8f = \u03b4name$3;
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$$anon$1.prototype = new $h_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$$anon$1.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.a8f;
});
$p.m = (function() {
  return this.a8f;
});
var $d_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$$anon$1, "org.jpablo.graphexplorer.gxcore.model.ReconcileAction$$anon$1", ({
  wf: 1,
  cx: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$$anon$2(\u03b4name$4, _$ordinal$4) {
  this.a8g = null;
  this.a8g = \u03b4name$4;
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$$anon$2.prototype = new $h_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$$anon$2.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.a8g;
});
$p.m = (function() {
  return this.a8g;
});
var $d_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$$anon$2, "org.jpablo.graphexplorer.gxcore.model.ReconcilePlan$$anon$2", ({
  wh: 1,
  gZ: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$$anon$2(\u03b4name$4, _$ordinal$4) {
  this.a8h = null;
  this.a8h = \u03b4name$4;
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$$anon$2.prototype = new $h_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$$anon$2.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.a8h;
});
$p.m = (function() {
  return this.a8h;
});
var $d_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$$anon$2, "org.jpablo.graphexplorer.gxcore.model.SyncAction$$anon$2", ({
  wl: 1,
  wj: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$$anon$1(\u03b4name$3, _$ordinal$3) {
  this.a8i = null;
  this.a8i = \u03b4name$3;
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$$anon$1.prototype = new $h_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$$anon$1.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.a8i;
});
$p.m = (function() {
  return this.a8i;
});
var $d_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$$anon$1, "org.jpablo.graphexplorer.gxcore.model.SyncMode$$anon$1", ({
  wn: 1,
  h1: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$$anon$1(\u03b4name$2, _$ordinal$2) {
  this.a8j = null;
  this.a8j = \u03b4name$2;
}
$p = $c_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$$anon$1.prototype = new $h_Lorg_jpablo_graphexplorer_gxcore_model_SyncState();
$p.constructor = $c_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$$anon$1.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.a8j;
});
$p.m = (function() {
  return this.a8j;
});
var $d_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$$anon$1, "org.jpablo.graphexplorer.gxcore.model.SyncState$$anon$1", ({
  wq: 1,
  wo: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_projects_LibraryViewMode$$anon$2(\u03b4name$4, _$ordinal$4) {
  this.a8m = null;
  this.a8m = \u03b4name$4;
}
$p = $c_Lorg_jpablo_graphexplorer_projects_LibraryViewMode$$anon$2.prototype = new $h_Lorg_jpablo_graphexplorer_projects_LibraryViewMode();
$p.constructor = $c_Lorg_jpablo_graphexplorer_projects_LibraryViewMode$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_projects_LibraryViewMode$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_projects_LibraryViewMode$$anon$2.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.a8m;
});
$p.m = (function() {
  return this.a8m;
});
var $d_Lorg_jpablo_graphexplorer_projects_LibraryViewMode$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_projects_LibraryViewMode$$anon$2, "org.jpablo.graphexplorer.projects.LibraryViewMode$$anon$2", ({
  wJ: 1,
  wH: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_projects_SortOption$$anon$1(\u03b4name$3, _$ordinal$3) {
  this.a8p = null;
  this.a8p = \u03b4name$3;
}
$p = $c_Lorg_jpablo_graphexplorer_projects_SortOption$$anon$1.prototype = new $h_Lorg_jpablo_graphexplorer_projects_SortOption();
$p.constructor = $c_Lorg_jpablo_graphexplorer_projects_SortOption$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_projects_SortOption$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_projects_SortOption$$anon$1.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.a8p;
});
$p.m = (function() {
  return this.a8p;
});
var $d_Lorg_jpablo_graphexplorer_projects_SortOption$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_projects_SortOption$$anon$1, "org.jpablo.graphexplorer.projects.SortOption$$anon$1", ({
  wT: 1,
  ha: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_router_Route$$anon$1(\u03b4name$2, _$ordinal$2) {
  this.a8q = null;
  this.a8q = \u03b4name$2;
}
$p = $c_Lorg_jpablo_graphexplorer_router_Route$$anon$1.prototype = new $h_Lorg_jpablo_graphexplorer_router_Route();
$p.constructor = $c_Lorg_jpablo_graphexplorer_router_Route$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_router_Route$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_router_Route$$anon$1.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.a8q;
});
$p.m = (function() {
  return this.a8q;
});
var $d_Lorg_jpablo_graphexplorer_router_Route$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_router_Route$$anon$1, "org.jpablo.graphexplorer.router.Route$$anon$1", ({
  wV: 1,
  cy: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$$anon$1(\u03b4name$2, _$ordinal$2) {
  this.a8x = null;
  this.a8x = \u03b4name$2;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$$anon$1.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$$anon$1.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.a8x;
});
$p.m = (function() {
  return this.a8x;
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$$anon$1, "org.jpablo.graphexplorer.viewer.backends.DiagramFormat$$anon$1", ({
  x2: 1,
  hg: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$1() {
  this.BO = null;
  $ct_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent__T__(this, "the comments");
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$1.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$1.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return "Comments";
});
$p.m = (function() {
  return "Comments";
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$1, "org.jpablo.graphexplorer.viewer.backends.UnmodeledContent$$anon$1", ({
  xa: 1,
  bp: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$2() {
  this.BO = null;
  $ct_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent__T__(this, "the `strict` keyword");
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$2.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$2.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return "StrictKeyword";
});
$p.m = (function() {
  return "StrictKeyword";
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$2, "org.jpablo.graphexplorer.viewer.backends.UnmodeledContent$$anon$2", ({
  xb: 1,
  bp: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$3() {
  this.BO = null;
  $ct_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent__T__(this, "the configuration directives (`%%{...}%%` or front matter)");
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$3.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$3;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$3() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$3.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return "Directives";
});
$p.m = (function() {
  return "Directives";
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$3 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$3, "org.jpablo.graphexplorer.viewer.backends.UnmodeledContent$$anon$3", ({
  xc: 1,
  bp: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$4() {
  this.BO = null;
  $ct_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent__T__(this, "the `click` lines");
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$4.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$4;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$4() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$4.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return "ClickHandlers";
});
$p.m = (function() {
  return "ClickHandlers";
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$4 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$4, "org.jpablo.graphexplorer.viewer.backends.UnmodeledContent$$anon$4", ({
  xd: 1,
  bp: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$5() {
  this.BO = null;
  $ct_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent__T__(this, "the accessibility text (`accTitle`, `accDescr`)");
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$5.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$5;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$5() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$5.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return "AccessibilityText";
});
$p.m = (function() {
  return "AccessibilityText";
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$5 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$5, "org.jpablo.graphexplorer.viewer.backends.UnmodeledContent$$anon$5", ({
  xe: 1,
  bp: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$6() {
  this.BO = null;
  $ct_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent__T__(this, "the `direction` lines in subgraphs");
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$6.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$6;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$6() {
}
$h_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$6.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return "SubgraphDirection";
});
$p.m = (function() {
  return "SubgraphDirection";
});
var $d_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$6 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$$anon$6, "org.jpablo.graphexplorer.viewer.backends.UnmodeledContent$$anon$6", ({
  xf: 1,
  bp: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$$anon$1(\u03b4name$2, _$ordinal$2) {
  this.a8P = null;
  this.a8P = \u03b4name$2;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$$anon$1.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$$anon$1.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.a8P;
});
$p.m = (function() {
  return this.a8P;
});
var $d_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$$anon$1, "org.jpablo.graphexplorer.viewer.color.TailWindColors$ColorName$$anon$1", ({
  yk: 1,
  hI: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$$anon$1(\u03b4name$2, _$ordinal$2) {
  this.a9l = null;
  this.a9l = \u03b4name$2;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$$anon$1.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$$anon$1.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.a9l;
});
$p.m = (function() {
  return this.a9l;
});
var $d_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$$anon$1, "org.jpablo.graphexplorer.viewer.components.rightPanel.ElementKind$$anon$1", ({
  zh: 1,
  hT: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$$anon$1(\u03b4name$2, _$ordinal$2) {
  this.a9S = null;
  this.a9S = \u03b4name$2;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$$anon$1.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$$anon$1.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.a9S;
});
$p.m = (function() {
  return this.a9S;
});
var $d_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$$anon$1, "org.jpablo.graphexplorer.viewer.desktop.DesktopIpc$SaveOutcome$$anon$1", ({
  zU: 1,
  cA: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$$anon$1(\u03b4name$2, _$ordinal$2) {
  this.a9U = null;
  this.a9U = \u03b4name$2;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$$anon$1.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$$anon$1.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.a9U;
});
$p.m = (function() {
  return this.a9U;
});
var $d_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$$anon$1, "org.jpablo.graphexplorer.viewer.desktop.DesktopOpenRequests$Activation$$anon$1", ({
  zX: 1,
  id: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$$anon$1(\u03b4name$20, _$ordinal$20) {
  this.aa0 = null;
  this.aa0 = \u03b4name$20;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$$anon$1.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$$anon$1.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.aa0;
});
$p.m = (function() {
  return this.aa0;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$$anon$1, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.ArrowType$$anon$1", ({
  Al: 1,
  iu: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$$anon$1(\u03b4name$3, _$ordinal$3) {
  this.aa2 = null;
  this.aa2 = \u03b4name$3;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$$anon$1.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$$anon$1.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.aa2;
});
$p.m = (function() {
  return this.aa2;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$$anon$1, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.BorderStyle$$anon$1", ({
  Ap: 1,
  iv: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$$anon$7(\u03b4name$26, _$ordinal$26) {
  this.aa6 = null;
  this.aa6 = \u03b4name$26;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$$anon$7.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$$anon$7;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$$anon$7() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$$anon$7.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.aa6;
});
$p.m = (function() {
  return this.aa6;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$$anon$7 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$$anon$7, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.CompassPoint$$anon$7", ({
  AF: 1,
  iw: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$$anon$2(\u03b4name$4, _$ordinal$4) {
  this.aa8 = null;
  this.aa8 = \u03b4name$4;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$$anon$2.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$$anon$2.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.aa8;
});
$p.m = (function() {
  return this.aa8;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$$anon$2, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.CornerStyle$$anon$2", ({
  AJ: 1,
  ix: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$$anon$3(\u03b4name$22, _$ordinal$22) {
  this.aa9 = null;
  this.aa9 = \u03b4name$22;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$$anon$3.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$$anon$3;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$$anon$3() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$$anon$3.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.aa9;
});
$p.m = (function() {
  return this.aa9;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$$anon$3 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$$anon$3, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.DirType$$anon$3", ({
  AN: 1,
  iy: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$$anon$4(\u03b4name$23, _$ordinal$23) {
  this.aaa = null;
  this.aaa = \u03b4name$23;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$$anon$4.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$$anon$4;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$$anon$4() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$$anon$4.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.aaa;
});
$p.m = (function() {
  return this.aaa;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$$anon$4 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$$anon$4, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.EdgeStyle$$anon$4", ({
  AP: 1,
  iz: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$$anon$5(\u03b4name$24, _$ordinal$24) {
  this.aad = null;
  this.aad = \u03b4name$24;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$$anon$5.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$$anon$5;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$$anon$5() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$$anon$5.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.aad;
});
$p.m = (function() {
  return this.aad;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$$anon$5 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$$anon$5, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.GraphType$$anon$5", ({
  AY: 1,
  iA: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc$$anon$6(\u03b4name$25, _$ordinal$25) {
  this.aae = null;
  this.aae = \u03b4name$25;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc$$anon$6.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc$$anon$6;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc$$anon$6() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc$$anon$6.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.aae;
});
$p.m = (function() {
  return this.aae;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc$$anon$6 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc$$anon$6, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.GroupLabelLoc$$anon$6", ({
  B0: 1,
  iB: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$$anon$1(\u03b4name$3, _$ordinal$3) {
  this.aag = null;
  this.aag = \u03b4name$3;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$$anon$1.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$$anon$1.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.aag;
});
$p.m = (function() {
  return this.aag;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$$anon$1, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.HtmlCellAlign$$anon$1", ({
  B6: 1,
  iD: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$$anon$2(\u03b4name$4, _$ordinal$4) {
  this.aah = null;
  this.aah = \u03b4name$4;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$$anon$2.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$$anon$2.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.aah;
});
$p.m = (function() {
  return this.aah;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$$anon$2, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.HtmlCellVAlign$$anon$2", ({
  B8: 1,
  iE: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$$anon$9(\u03b4name$28, _$ordinal$28) {
  this.aal = null;
  this.aal = \u03b4name$28;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$$anon$9.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$$anon$9;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$$anon$9() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$$anon$9.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.aal;
});
$p.m = (function() {
  return this.aal;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$$anon$9 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$$anon$9, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.LabelJust$$anon$9", ({
  Bm: 1,
  iF: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$$anon$10(\u03b4name$29, _$ordinal$29) {
  this.aam = null;
  this.aam = \u03b4name$29;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$$anon$10.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$$anon$10;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$$anon$10() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$$anon$10.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.aam;
});
$p.m = (function() {
  return this.aam;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$$anon$10 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$$anon$10, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Layout$$anon$10", ({
  Bp: 1,
  iG: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$$anon$11(\u03b4name$30, _$ordinal$30) {
  this.aao = null;
  this.aao = \u03b4name$30;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$$anon$11.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$$anon$11;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$$anon$11() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$$anon$11.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.aao;
});
$p.m = (function() {
  return this.aao;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$$anon$11 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$$anon$11, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.NodeLabelLoc$$anon$11", ({
  Bw: 1,
  iI: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$$anon$12(\u03b4name$31, _$ordinal$31) {
  this.aap = null;
  this.aap = \u03b4name$31;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$$anon$12.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$$anon$12;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$$anon$12() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$$anon$12.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.aap;
});
$p.m = (function() {
  return this.aap;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$$anon$12 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$$anon$12, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.NodeStyle$$anon$12", ({
  Bz: 1,
  iJ: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap$$anon$14(\u03b4name$33, _$ordinal$33) {
  this.aaq = null;
  this.aaq = \u03b4name$33;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap$$anon$14.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap$$anon$14;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap$$anon$14() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap$$anon$14.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.aaq;
});
$p.m = (function() {
  return this.aaq;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap$$anon$14 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap$$anon$14, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Overlap$$anon$14", ({
  BD: 1,
  iK: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$$anon$16(\u03b4name$35, _$ordinal$35) {
  this.aar = null;
  this.aar = \u03b4name$35;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$$anon$16.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$$anon$16;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$$anon$16() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$$anon$16.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.aar;
});
$p.m = (function() {
  return this.aar;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$$anon$16 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$$anon$16, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.RankType$$anon$16", ({
  BM: 1,
  iL: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$$anon$15(\u03b4name$34, _$ordinal$34) {
  this.aat = null;
  this.aat = \u03b4name$34;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$$anon$15.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$$anon$15;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$$anon$15() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$$anon$15.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.aat;
});
$p.m = (function() {
  return this.aat;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$$anon$15 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$$anon$15, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Rankdir$$anon$15", ({
  BO: 1,
  iM: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17(\u03b4name$36, _$ordinal$36) {
  this.aav = null;
  this.aav = \u03b4name$36;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.aav;
});
$p.m = (function() {
  return this.aav;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$$anon$17, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Shape$$anon$17", ({
  BW: 1,
  iN: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$$anon$18(\u03b4name$37, _$ordinal$37) {
  this.aaw = null;
  this.aaw = \u03b4name$37;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$$anon$18.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$$anon$18;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$$anon$18() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$$anon$18.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.aaw;
});
$p.m = (function() {
  return this.aaw;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$$anon$18 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$$anon$18, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Splines$$anon$18", ({
  C1: 1,
  iO: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$$anon$19(\u03b4name$38, _$ordinal$38) {
  this.aax = null;
  this.aax = \u03b4name$38;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$$anon$19.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$$anon$19;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$$anon$19() {
}
$h_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$$anon$19.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.aax;
});
$p.m = (function() {
  return this.aax;
});
var $d_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$$anon$19 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$$anon$19, "org.jpablo.graphexplorer.viewer.formats.dot.attributes.Style$$anon$19", ({
  C4: 1,
  iP: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$$anon$1(\u03b4name$2, _$ordinal$2) {
  this.aaH = null;
  this.aaH = \u03b4name$2;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$$anon$1.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$$anon$1.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.aaH;
});
$p.m = (function() {
  return this.aaH;
});
var $d_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$$anon$1, "org.jpablo.graphexplorer.viewer.graph.VisibilityRules$Direction$$anon$1", ({
  CM: 1,
  CK: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_logging_Level$$anon$1(\u03b4name$2, _$ordinal$2) {
  this.aaP = null;
  this.aaP = \u03b4name$2;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_logging_Level$$anon$1.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_logging_Level();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_logging_Level$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_logging_Level$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_logging_Level$$anon$1.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.aaP;
});
$p.m = (function() {
  return this.aaP;
});
var $d_Lorg_jpablo_graphexplorer_viewer_logging_Level$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_logging_Level$$anon$1, "org.jpablo.graphexplorer.viewer.logging.Level$$anon$1", ({
  D0: 1,
  CY: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$$anon$3(\u03b4name$2, _$ordinal$2) {
  this.aaQ = null;
  this.aaQ = \u03b4name$2;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$$anon$3.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$$anon$3;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$$anon$3() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$$anon$3.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.aaQ;
});
$p.m = (function() {
  return this.aaQ;
});
var $d_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$$anon$3 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$$anon$3, "org.jpablo.graphexplorer.viewer.models.ArrowDirection$$anon$3", ({
  D6: 1,
  jf: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$$anon$1() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$$anon$1.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$$anon$1.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return "Multiple";
});
var $d_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$$anon$1, "org.jpablo.graphexplorer.viewer.models.AttrStatus$$anon$1", ({
  D9: 1,
  dn: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$$anon$2() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$$anon$2.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$$anon$2.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return "Missing";
});
var $d_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$$anon$2, "org.jpablo.graphexplorer.viewer.models.AttrStatus$$anon$2", ({
  Da: 1,
  dn: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_models_ClientSize$$anon$1(\u03b4name$2, _$ordinal$2) {
  this.aaS = null;
  this.aaS = \u03b4name$2;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_models_ClientSize$$anon$1.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_models_ClientSize();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_models_ClientSize$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_models_ClientSize$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_models_ClientSize$$anon$1.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.aaS;
});
$p.m = (function() {
  return this.aaS;
});
var $d_Lorg_jpablo_graphexplorer_viewer_models_ClientSize$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_models_ClientSize$$anon$1, "org.jpablo.graphexplorer.viewer.models.ClientSize$$anon$1", ({
  Dh: 1,
  Df: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$$anon$1(\u03b4name$2, _$ordinal$2) {
  this.aaU = null;
  this.aaU = \u03b4name$2;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$$anon$1.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$$anon$1.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.aaU;
});
$p.m = (function() {
  return this.aaU;
});
var $d_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$$anon$1, "org.jpablo.graphexplorer.viewer.selection.ElementKind$$anon$1", ({
  DC: 1,
  DA: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$$anon$1(\u03b4name$2, _$ordinal$2) {
  this.aaV = null;
  this.aaV = \u03b4name$2;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$$anon$1.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$$anon$1.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.aaV;
});
$p.m = (function() {
  return this.aaV;
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$$anon$1, "org.jpablo.graphexplorer.viewer.state.DiagramLoadStatus$$anon$1", ({
  DF: 1,
  dq: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level$$anon$1(\u03b4name$2, _$ordinal$2) {
  this.aaW = null;
  this.aaW = \u03b4name$2;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level$$anon$1.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level$$anon$1.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.aaW;
});
$p.m = (function() {
  return this.aaW;
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level$$anon$1, "org.jpablo.graphexplorer.viewer.state.EditorNotice$Level$$anon$1", ({
  DR: 1,
  DP: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent$$anon$1(\u03b4name$2, _$ordinal$2) {
  this.ab5 = null;
  this.ab5 = \u03b4name$2;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent$$anon$1.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent$$anon$1.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.ab5;
});
$p.m = (function() {
  return this.ab5;
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent$$anon$1, "org.jpablo.graphexplorer.viewer.state.LeaveIntent$$anon$1", ({
  E6: 1,
  jG: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$$anon$1() {
  this.Cx = 0.0;
  this.zy = 0.0;
  $ct_Lorg_jpablo_graphexplorer_viewer_state_NavDirection__D__D__(this, (-1.0), 0.0);
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$$anon$1.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_state_NavDirection();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$$anon$1.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return "NavLeft";
});
$p.m = (function() {
  return "NavLeft";
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$$anon$1, "org.jpablo.graphexplorer.viewer.state.NavDirection$$anon$1", ({
  E9: 1,
  cD: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$$anon$2() {
  this.Cx = 0.0;
  this.zy = 0.0;
  $ct_Lorg_jpablo_graphexplorer_viewer_state_NavDirection__D__D__(this, 1.0, 0.0);
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$$anon$2.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_state_NavDirection();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$$anon$2.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return "NavRight";
});
$p.m = (function() {
  return "NavRight";
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$$anon$2, "org.jpablo.graphexplorer.viewer.state.NavDirection$$anon$2", ({
  Ea: 1,
  cD: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$$anon$3() {
  this.Cx = 0.0;
  this.zy = 0.0;
  $ct_Lorg_jpablo_graphexplorer_viewer_state_NavDirection__D__D__(this, 0.0, (-1.0));
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$$anon$3.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_state_NavDirection();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$$anon$3;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$$anon$3() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$$anon$3.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return "NavUp";
});
$p.m = (function() {
  return "NavUp";
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$$anon$3 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$$anon$3, "org.jpablo.graphexplorer.viewer.state.NavDirection$$anon$3", ({
  Eb: 1,
  cD: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$$anon$4() {
  this.Cx = 0.0;
  this.zy = 0.0;
  $ct_Lorg_jpablo_graphexplorer_viewer_state_NavDirection__D__D__(this, 0.0, 1.0);
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$$anon$4.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_state_NavDirection();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$$anon$4;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$$anon$4() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$$anon$4.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return "NavDown";
});
$p.m = (function() {
  return "NavDown";
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$$anon$4 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$$anon$4, "org.jpablo.graphexplorer.viewer.state.NavDirection$$anon$4", ({
  Ec: 1,
  cD: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$$anon$1(\u03b4name$2, _$ordinal$2, outer) {
  this.ab8 = null;
  this.ab8 = \u03b4name$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$CellKind__Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$__(this, outer.aFY);
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$$anon$1.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$CellKind();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$$anon$1.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.ab8;
});
$p.m = (function() {
  return this.ab8;
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$$anon$1, "org.jpablo.graphexplorer.viewer.state.RecordCellOps$$anon$1", ({
  El: 1,
  Ep: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$$anon$1(\u03b4name$2, _$ordinal$2) {
  this.abb = null;
  this.aG0 = 0;
  this.abb = \u03b4name$2;
  this.aG0 = _$ordinal$2;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$$anon$1.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$$anon$1.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.abb;
});
$p.m = (function() {
  return this.abb;
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$$anon$1, "org.jpablo.graphexplorer.viewer.state.RightPanelSection$$anon$1", ({
  Es: 1,
  jP: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$$anon$1(\u03b4name$2, _$ordinal$2) {
  this.abc = null;
  this.abc = \u03b4name$2;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$$anon$1.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_state_SaveResult();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$$anon$1.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.abc;
});
$p.m = (function() {
  return this.abc;
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$$anon$1, "org.jpablo.graphexplorer.viewer.state.SaveResult$$anon$1", ({
  Eu: 1,
  cE: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint$$anon$1(\u03b4name$3, _$ordinal$3) {
  this.abx = null;
  this.abx = \u03b4name$3;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint$$anon$1.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint$$anon$1.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.abx;
});
$p.m = (function() {
  return this.abx;
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint$$anon$1, "org.jpablo.graphexplorer.viewer.state.mouseActions.ArrowEndpoint$$anon$1", ({
  EO: 1,
  k3: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$$anon$2(\u03b4name$4, _$ordinal$4) {
  this.aby = null;
  this.aby = \u03b4name$4;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$$anon$2.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$$anon$2.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.aby;
});
$p.m = (function() {
  return this.aby;
});
var $d_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$$anon$2, "org.jpablo.graphexplorer.viewer.state.mouseActions.MouseAction$$anon$2", ({
  ER: 1,
  cF: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin$$anon$1(\u03b4name$2, _$ordinal$2) {
  this.abA = null;
  this.abA = \u03b4name$2;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin$$anon$1.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin$$anon$1.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.abA;
});
$p.m = (function() {
  return this.abA;
});
var $d_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin$$anon$1, "org.jpablo.graphexplorer.viewer.utils.ChangeOrigin$$anon$1", ({
  EY: 1,
  EW: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$$anon$1() {
  this.U8 = null;
  $ct_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone__T__(this, "alert-success");
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$$anon$1.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$$anon$1.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return "Success";
});
$p.m = (function() {
  return "Success";
});
var $d_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$$anon$1, "org.jpablo.graphexplorer.viewer.widgets.AlertTone$$anon$1", ({
  F8: 1,
  dt: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$$anon$2() {
  this.U8 = null;
  $ct_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone__T__(this, "alert-error");
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$$anon$2.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$$anon$2.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return "Error";
});
$p.m = (function() {
  return "Error";
});
var $d_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$$anon$2, "org.jpablo.graphexplorer.viewer.widgets.AlertTone$$anon$2", ({
  F9: 1,
  dt: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$$anon$3() {
  this.U8 = null;
  $ct_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone__T__(this, "alert-info");
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$$anon$3.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$$anon$3;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$$anon$3() {
}
$h_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$$anon$3.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return "Info";
});
$p.m = (function() {
  return "Info";
});
var $d_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$$anon$3 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$$anon$3, "org.jpablo.graphexplorer.viewer.widgets.AlertTone$$anon$3", ({
  Fa: 1,
  dt: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$$anon$2(\u03b4name$4, _$ordinal$4) {
  this.abB = null;
  this.abB = \u03b4name$4;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$$anon$2.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_widgets_InputType();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$$anon$2;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$$anon$2() {
}
$h_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$$anon$2.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.abB;
});
$p.m = (function() {
  return this.abB;
});
var $d_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$$anon$2 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$$anon$2, "org.jpablo.graphexplorer.viewer.widgets.InputType$$anon$2", ({
  Fh: 1,
  bD: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$$anon$1(\u03b4name$3, _$ordinal$3) {
  this.abC = null;
  this.abC = \u03b4name$3;
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$$anon$1.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$$anon$1.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return this.abC;
});
$p.m = (function() {
  return this.abC;
});
var $d_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$$anon$1, "org.jpablo.graphexplorer.viewer.widgets.MenuDirection$$anon$1", ({
  Fm: 1,
  Fk: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$$anon$1() {
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$$anon$1.prototype = new $h_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$$anon$1;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$$anon$1() {
}
$h_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$$anon$1.prototype = $p;
$p.z = (function() {
  return 0;
});
$p.A = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.D = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.B = (function() {
  return "Sep";
});
$p.m = (function() {
  return "Sep";
});
var $d_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$$anon$1 = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$$anon$1, "org.jpablo.graphexplorer.viewer.widgets.MenuEntry$$anon$1", ({
  Fo: 1,
  kg: 1,
  b: 1,
  c: 1,
  a: 1,
  g: 1,
  t: 1,
  d: 1,
  j: 1,
  r: 1
}));
/** @constructor */
function $c_sc_MapView$Values(underlying) {
  this.a1x = null;
  this.a1x = underlying;
}
$p = $c_sc_MapView$Values.prototype = new $h_sc_AbstractView();
$p.constructor = $c_sc_MapView$Values;
/** @constructor */
function $h_sc_MapView$Values() {
}
$h_sc_MapView$Values.prototype = $p;
$p.o = (function() {
  return this.a1x.hr();
});
$p.V = (function() {
  return this.a1x.V();
});
$p.c = (function() {
  return this.a1x.c();
});
var $d_sc_MapView$Values = new $TypeData().i($c_sc_MapView$Values, "scala.collection.MapView$Values", ({
  Hu: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1
}));
function $f_sc_Seq__equals__O__Z($thiz, o) {
  if (($thiz === o)) {
    return true;
  } else {
    if ($is_sc_Seq(o)) {
      if (o.IG($thiz)) {
        return $thiz.AE(o);
      }
    }
    return false;
  }
}
function $is_sc_Seq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.H)));
}
function $isArrayOf_sc_Seq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.H)));
}
function $p_sc_SeqView$Sorted___sorted$lzycompute__sc_Seq($thiz) {
  if ((!$thiz.acl)) {
    var len = $thiz.ty;
    if ((len === 0)) {
      var res = $m_sci_Nil$();
    } else if ((len === 1)) {
      var res = $m_sci_Nil$().b6($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$thiz.UT.t()]));
    } else {
      var arr = new $ac_O(len);
      $thiz.UT.cR(arr, 0, 2147483647);
      $m_ju_Arrays$().Jn(arr, $thiz.NP);
      var res = $m_sci_ArraySeq$().n0(arr);
    }
    $thiz.acm = true;
    $thiz.UT = null;
    $thiz.acn = res;
    $thiz.acl = true;
  }
  return $thiz.acn;
}
function $ct_sc_SeqView$Sorted__sc_SeqOps__I__s_math_Ordering__($thiz, underlying, len, ord) {
  $thiz.UT = underlying;
  $thiz.ty = len;
  $thiz.NP = ord;
  $thiz.acm = false;
  return $thiz;
}
function $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__($thiz, underlying, ord) {
  $ct_sc_SeqView$Sorted__sc_SeqOps__I__s_math_Ordering__($thiz, underlying, underlying.C(), ord);
  return $thiz;
}
/** @constructor */
function $c_sc_SeqView$Sorted() {
  this.acn = null;
  this.UT = null;
  this.ty = 0;
  this.NP = null;
  this.acm = false;
  this.acl = false;
}
$p = $c_sc_SeqView$Sorted.prototype = new $h_O();
$p.constructor = $c_sc_SeqView$Sorted;
/** @constructor */
function $h_sc_SeqView$Sorted() {
}
$h_sc_SeqView$Sorted.prototype = $p;
$p.h4 = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f);
});
$p.cd = (function() {
  return $m_sc_View$();
});
$p.m = (function() {
  return $f_sc_View__toString__T(this);
});
$p.hM = (function() {
  return "SeqView";
});
$p.fS = (function() {
  return $m_sc_View$().b5();
});
$p.gU = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$p.g9 = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$p.aa = (function() {
  return this.ty;
});
$p.nz = (function() {
  return $f_sc_SeqOps__distinct__O(this);
});
$p.ko = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f);
});
$p.cx = (function() {
  return new $c_sc_SeqView$Sorted$ReverseSorted(this).o();
});
$p.px = (function(p, from) {
  return $f_sc_Iterator__indexWhere__F1__I__I(this.o(), p, from);
});
$p.mN = (function(elem, from) {
  return $f_sc_SeqOps__indexOf__O__I__I(this, elem, from);
});
$p.nE = (function(otherSize) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, otherSize);
});
$p.bL = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$p.t = (function() {
  return this.o().q();
});
$p.dt = (function() {
  return $f_sc_IterableOps__headOption__s_Option(this);
});
$p.bJ = (function() {
  return $f_sc_IterableOps__last__O(this);
});
$p.bw = (function(pred) {
  return $f_sc_IterableOps__filter__F1__O(this, pred);
});
$p.cE = (function(pred) {
  return $f_sc_IterableOps__filterNot__F1__O(this, pred);
});
$p.un = (function(p) {
  return $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(new $c_sc_IterableOps$WithFilter(), this, p);
});
$p.uj = (function(p) {
  return $f_sc_IterableOps__takeWhile__F1__O(this, p);
});
$p.tW = (function(p) {
  return $f_sc_IterableOps__dropWhile__F1__O(this, p);
});
$p.lX = (function() {
  return $f_sc_IterableOps__init__O(this);
});
$p.c5 = (function(f) {
  return $f_sc_IterableOps__flatMap__F1__O(this, f);
});
$p.dk = (function(asIterable) {
  return $f_sc_IterableOps__flatMap__F1__O(this, asIterable);
});
$p.ct = (function(pf) {
  return $f_sc_IterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.fy = (function(f) {
  return $f_sc_IterableOps__partitionMap__F1__T2(this, f);
});
$p.fa = (function(asPair) {
  return $f_sc_IterableOps__unzip__F1__T2(this, asPair);
});
$p.F = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f);
});
$p.lU = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p);
});
$p.iW = (function(p) {
  return $f_sc_IterableOnceOps__find__F1__s_Option(this, p);
});
$p.hO = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$p.kT = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$p.cR = (function(dest, start, n) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, dest, start, n);
});
$p.k2 = (function(num) {
  return $f_sc_IterableOnceOps__sum__s_math_Numeric__O(this, num);
});
$p.lr = (function(ord) {
  return $f_sc_IterableOnceOps__min__s_math_Ordering__O(this, ord);
});
$p.lq = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord);
});
$p.nw = (function(pf) {
  return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this, pf);
});
$p.lf = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$p.bM = (function() {
  return $m_sci_Nil$().b6(this);
});
$p.d2 = (function() {
  return $m_sci_Vector$().X(this);
});
$p.eX = (function(ev) {
  return $m_sci_Map$().ao(this);
});
$p.iz = (function() {
  return $m_sci_Seq$().fw(this);
});
$p.nG = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$p.a4C = (function() {
  return ((!this.acl) ? $p_sc_SeqView$Sorted___sorted$lzycompute__sc_Seq(this) : this.acn);
});
$p.aRR = (function() {
  var orig = this.UT;
  return (this.acm ? this.a4C() : orig);
});
$p.l = (function(i) {
  return this.a4C().l(i);
});
$p.C = (function() {
  return this.ty;
});
$p.o = (function() {
  return $m_sc_Iterator$().b8.lS(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.a4C().o())));
});
$p.V = (function() {
  return this.ty;
});
$p.c = (function() {
  return (this.ty === 0);
});
$p.ai6 = (function(ord1) {
  var x$2 = this.NP;
  if (((ord1 === null) ? (x$2 === null) : ord1.e(x$2))) {
    return this;
  } else {
    return (ord1.mO(this.NP) ? new $c_sc_SeqView$Sorted$ReverseSorted(this) : $ct_sc_SeqView$Sorted__sc_SeqOps__I__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this.aRR(), this.ty, ord1));
  }
});
$p.fP = (function(coll) {
  return $m_sc_View$().WV(coll);
});
$p.cn = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n);
});
$p.ds = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n);
});
$p.bv = (function(elem) {
  return $ct_sc_SeqView$Appended__sc_SeqOps__O__(new $c_sc_SeqView$Appended(), this, elem);
});
$p.L = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f);
});
$p.h9 = (function(ord) {
  return this.ai6(ord);
});
var $d_sc_SeqView$Sorted = new $TypeData().i($c_sc_SeqView$Sorted, "scala.collection.SeqView$Sorted", ({
  Hy: 1,
  a4: 1,
  w: 1,
  m: 1,
  e: 1,
  f: 1,
  C: 1,
  k: 1,
  l: 1,
  a: 1
}));
function $p_sc_SeqView$Sorted$ReverseSorted___reversed$lzycompute__sc_SeqView$Reverse($thiz) {
  if ((!$thiz.acp)) {
    $thiz.aco = $ct_sc_SeqView$Reverse__sc_SeqOps__(new $c_sc_SeqView$Reverse(), $thiz.tz.a4C());
    $thiz.acp = true;
  }
  return $thiz.aco;
}
function $p_sc_SeqView$Sorted$ReverseSorted___reversed__sc_SeqView$Reverse($thiz) {
  return ((!$thiz.acp) ? $p_sc_SeqView$Sorted$ReverseSorted___reversed$lzycompute__sc_SeqView$Reverse($thiz) : $thiz.aco);
}
/** @constructor */
function $c_sc_SeqView$Sorted$ReverseSorted(outer) {
  this.aco = null;
  this.acp = false;
  this.tz = null;
  this.tz = outer;
}
$p = $c_sc_SeqView$Sorted$ReverseSorted.prototype = new $h_O();
$p.constructor = $c_sc_SeqView$Sorted$ReverseSorted;
/** @constructor */
function $h_sc_SeqView$Sorted$ReverseSorted() {
}
$h_sc_SeqView$Sorted$ReverseSorted.prototype = $p;
$p.h4 = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f);
});
$p.cd = (function() {
  return $m_sc_View$();
});
$p.m = (function() {
  return $f_sc_View__toString__T(this);
});
$p.hM = (function() {
  return "SeqView";
});
$p.fS = (function() {
  return $m_sc_View$().b5();
});
$p.gU = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$p.g9 = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$p.aa = (function() {
  return this.tz.ty;
});
$p.nz = (function() {
  return $f_sc_SeqOps__distinct__O(this);
});
$p.ko = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f);
});
$p.cx = (function() {
  return this.tz.o();
});
$p.px = (function(p, from) {
  return $f_sc_Iterator__indexWhere__F1__I__I(this.o(), p, from);
});
$p.mN = (function(elem, from) {
  return $f_sc_SeqOps__indexOf__O__I__I(this, elem, from);
});
$p.nE = (function(otherSize) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, otherSize);
});
$p.bL = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$p.t = (function() {
  return this.o().q();
});
$p.dt = (function() {
  return $f_sc_IterableOps__headOption__s_Option(this);
});
$p.bJ = (function() {
  return $f_sc_IterableOps__last__O(this);
});
$p.bw = (function(pred) {
  return $f_sc_IterableOps__filter__F1__O(this, pred);
});
$p.cE = (function(pred) {
  return $f_sc_IterableOps__filterNot__F1__O(this, pred);
});
$p.un = (function(p) {
  return $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(new $c_sc_IterableOps$WithFilter(), this, p);
});
$p.uj = (function(p) {
  return $f_sc_IterableOps__takeWhile__F1__O(this, p);
});
$p.tW = (function(p) {
  return $f_sc_IterableOps__dropWhile__F1__O(this, p);
});
$p.lX = (function() {
  return $f_sc_IterableOps__init__O(this);
});
$p.c5 = (function(f) {
  return $f_sc_IterableOps__flatMap__F1__O(this, f);
});
$p.dk = (function(asIterable) {
  return $f_sc_IterableOps__flatMap__F1__O(this, asIterable);
});
$p.ct = (function(pf) {
  return $f_sc_IterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.fy = (function(f) {
  return $f_sc_IterableOps__partitionMap__F1__T2(this, f);
});
$p.fa = (function(asPair) {
  return $f_sc_IterableOps__unzip__F1__T2(this, asPair);
});
$p.F = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f);
});
$p.lU = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p);
});
$p.iW = (function(p) {
  return $f_sc_IterableOnceOps__find__F1__s_Option(this, p);
});
$p.hO = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$p.kT = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$p.cR = (function(dest, start, n) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, dest, start, n);
});
$p.k2 = (function(num) {
  return $f_sc_IterableOnceOps__sum__s_math_Numeric__O(this, num);
});
$p.lr = (function(ord) {
  return $f_sc_IterableOnceOps__min__s_math_Ordering__O(this, ord);
});
$p.lq = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord);
});
$p.nw = (function(pf) {
  return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this, pf);
});
$p.lf = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$p.bM = (function() {
  return $m_sci_Nil$().b6(this);
});
$p.d2 = (function() {
  return $m_sci_Vector$().X(this);
});
$p.eX = (function(ev) {
  return $m_sci_Map$().ao(this);
});
$p.iz = (function() {
  return $m_sci_Seq$().fw(this);
});
$p.nG = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$p.l = (function(i) {
  return $p_sc_SeqView$Sorted$ReverseSorted___reversed__sc_SeqView$Reverse(this).l(i);
});
$p.C = (function() {
  return this.tz.ty;
});
$p.o = (function() {
  return $m_sc_Iterator$().b8.lS(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $p_sc_SeqView$Sorted$ReverseSorted___reversed__sc_SeqView$Reverse(this).o())));
});
$p.V = (function() {
  return this.tz.ty;
});
$p.c = (function() {
  return (this.tz.ty === 0);
});
$p.ai6 = (function(ord1) {
  var x$2 = this.tz.NP;
  if (((ord1 === null) ? (x$2 === null) : ord1.e(x$2))) {
    return this.tz;
  } else {
    return (ord1.mO(this.tz.NP) ? this : $ct_sc_SeqView$Sorted__sc_SeqOps__I__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this.tz.aRR(), this.tz.ty, ord1));
  }
});
$p.fP = (function(coll) {
  return $m_sc_View$().WV(coll);
});
$p.cn = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n);
});
$p.ds = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n);
});
$p.bv = (function(elem) {
  return $ct_sc_SeqView$Appended__sc_SeqOps__O__(new $c_sc_SeqView$Appended(), this, elem);
});
$p.L = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f);
});
$p.h9 = (function(ord) {
  return this.ai6(ord);
});
var $d_sc_SeqView$Sorted$ReverseSorted = new $TypeData().i($c_sc_SeqView$Sorted$ReverseSorted, "scala.collection.SeqView$Sorted$ReverseSorted", ({
  Hz: 1,
  a4: 1,
  w: 1,
  m: 1,
  e: 1,
  f: 1,
  C: 1,
  k: 1,
  l: 1,
  a: 1
}));
/** @constructor */
function $c_sc_View$$anon$1(it$1) {
  this.aHY = null;
  this.aHY = it$1;
}
$p = $c_sc_View$$anon$1.prototype = new $h_sc_AbstractView();
$p.constructor = $c_sc_View$$anon$1;
/** @constructor */
function $h_sc_View$$anon$1() {
}
$h_sc_View$$anon$1.prototype = $p;
$p.o = (function() {
  return this.aHY.a3();
});
var $d_sc_View$$anon$1 = new $TypeData().i($c_sc_View$$anon$1, "scala.collection.View$$anon$1", ({
  HJ: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1
}));
function $ct_sc_View$Appended__sc_IterableOps__O__($thiz, underlying, elem) {
  $thiz.NQ = underlying;
  $thiz.UX = elem;
  return $thiz;
}
/** @constructor */
function $c_sc_View$Appended() {
  this.NQ = null;
  this.UX = null;
}
$p = $c_sc_View$Appended.prototype = new $h_sc_AbstractView();
$p.constructor = $c_sc_View$Appended;
/** @constructor */
function $h_sc_View$Appended() {
}
$h_sc_View$Appended.prototype = $p;
$p.o = (function() {
  return new $c_sc_View$Concat(this.NQ, new $c_sc_View$Single(this.UX)).o();
});
$p.V = (function() {
  var size = this.NQ.V();
  return ((size >= 0) ? ((1 + size) | 0) : (-1));
});
$p.c = (function() {
  return false;
});
var $d_sc_View$Appended = new $TypeData().i($c_sc_View$Appended, "scala.collection.View$Appended", ({
  cJ: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1
}));
/** @constructor */
function $c_sc_View$Collect(underlying, pf) {
  this.aI0 = null;
  this.aHZ = null;
  this.aI0 = underlying;
  this.aHZ = pf;
}
$p = $c_sc_View$Collect.prototype = new $h_sc_AbstractView();
$p.constructor = $c_sc_View$Collect;
/** @constructor */
function $h_sc_View$Collect() {
}
$h_sc_View$Collect.prototype = $p;
$p.o = (function() {
  return new $c_sc_Iterator$$anon$7(this.aI0.o(), this.aHZ);
});
var $d_sc_View$Collect = new $TypeData().i($c_sc_View$Collect, "scala.collection.View$Collect", ({
  HK: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1
}));
/** @constructor */
function $c_sc_View$Concat(prefix, suffix) {
  this.a1D = null;
  this.a1E = null;
  this.a1D = prefix;
  this.a1E = suffix;
}
$p = $c_sc_View$Concat.prototype = new $h_sc_AbstractView();
$p.constructor = $c_sc_View$Concat;
/** @constructor */
function $h_sc_View$Concat() {
}
$h_sc_View$Concat.prototype = $p;
$p.o = (function() {
  return this.a1D.o().lS(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.a1E.o())));
});
$p.V = (function() {
  var prefixSize = this.a1D.V();
  if ((prefixSize >= 0)) {
    var suffixSize = this.a1E.V();
    return ((suffixSize >= 0) ? ((prefixSize + suffixSize) | 0) : (-1));
  } else {
    return (-1);
  }
});
$p.c = (function() {
  return (this.a1D.c() && this.a1E.c());
});
var $d_sc_View$Concat = new $TypeData().i($c_sc_View$Concat, "scala.collection.View$Concat", ({
  HL: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1
}));
/** @constructor */
function $c_sc_View$DistinctBy(underlying, f) {
  this.a1F = null;
  this.aI1 = null;
  this.a1F = underlying;
  this.aI1 = f;
}
$p = $c_sc_View$DistinctBy.prototype = new $h_sc_AbstractView();
$p.constructor = $c_sc_View$DistinctBy;
/** @constructor */
function $h_sc_View$DistinctBy() {
}
$h_sc_View$DistinctBy.prototype = $p;
$p.o = (function() {
  return new $c_sc_Iterator$$anon$8(this.a1F.o(), this.aI1);
});
$p.V = (function() {
  return ((this.a1F.V() === 0) ? 0 : (-1));
});
$p.c = (function() {
  return this.a1F.c();
});
var $d_sc_View$DistinctBy = new $TypeData().i($c_sc_View$DistinctBy, "scala.collection.View$DistinctBy", ({
  HM: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1
}));
function $ct_sc_View$Drop__sc_IterableOps__I__($thiz, underlying, n) {
  $thiz.NR = underlying;
  $thiz.UY = n;
  $thiz.Hu = ((n > 0) ? n : 0);
  return $thiz;
}
/** @constructor */
function $c_sc_View$Drop() {
  this.NR = null;
  this.UY = 0;
  this.Hu = 0;
}
$p = $c_sc_View$Drop.prototype = new $h_sc_AbstractView();
$p.constructor = $c_sc_View$Drop;
/** @constructor */
function $h_sc_View$Drop() {
}
$h_sc_View$Drop.prototype = $p;
$p.o = (function() {
  return this.NR.o().iV(this.UY);
});
$p.V = (function() {
  var size = this.NR.V();
  if ((size >= 0)) {
    var x = ((size - this.Hu) | 0);
    return ((x > 0) ? x : 0);
  } else {
    return (-1);
  }
});
$p.c = (function() {
  return (!this.o().p());
});
var $d_sc_View$Drop = new $TypeData().i($c_sc_View$Drop, "scala.collection.View$Drop", ({
  cK: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1
}));
function $ct_sc_View$DropRight__sc_IterableOps__I__($thiz, underlying, n) {
  $thiz.NS = underlying;
  $thiz.UZ = n;
  $thiz.V0 = ((n > 0) ? n : 0);
  return $thiz;
}
/** @constructor */
function $c_sc_View$DropRight() {
  this.NS = null;
  this.UZ = 0;
  this.V0 = 0;
}
$p = $c_sc_View$DropRight.prototype = new $h_sc_AbstractView();
$p.constructor = $c_sc_View$DropRight;
/** @constructor */
function $h_sc_View$DropRight() {
}
$h_sc_View$DropRight.prototype = $p;
$p.o = (function() {
  return $m_sc_View$().b0f(this.NS.o(), this.UZ);
});
$p.V = (function() {
  var size = this.NS.V();
  if ((size >= 0)) {
    var x = ((size - this.V0) | 0);
    return ((x > 0) ? x : 0);
  } else {
    return (-1);
  }
});
$p.c = (function() {
  return ((this.V() >= 0) ? (this.V() === 0) : (!this.o().p()));
});
var $d_sc_View$DropRight = new $TypeData().i($c_sc_View$DropRight, "scala.collection.View$DropRight", ({
  cL: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1
}));
/** @constructor */
function $c_sc_View$DropWhile(underlying, p) {
  this.acr = null;
  this.aI2 = null;
  this.acr = underlying;
  this.aI2 = p;
}
$p = $c_sc_View$DropWhile.prototype = new $h_sc_AbstractView();
$p.constructor = $c_sc_View$DropWhile;
/** @constructor */
function $h_sc_View$DropWhile() {
}
$h_sc_View$DropWhile.prototype = $p;
$p.o = (function() {
  return new $c_sc_Iterator$$anon$12(this.acr.o(), this.aI2);
});
$p.V = (function() {
  return ((this.acr.V() === 0) ? 0 : (-1));
});
$p.c = (function() {
  return (!this.o().p());
});
var $d_sc_View$DropWhile = new $TypeData().i($c_sc_View$DropWhile, "scala.collection.View$DropWhile", ({
  HO: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1
}));
/** @constructor */
function $c_sc_View$Elems(xs) {
  this.a1H = null;
  this.a1H = xs;
}
$p = $c_sc_View$Elems.prototype = new $h_sc_AbstractView();
$p.constructor = $c_sc_View$Elems;
/** @constructor */
function $h_sc_View$Elems() {
}
$h_sc_View$Elems.prototype = $p;
$p.o = (function() {
  return this.a1H.o();
});
$p.V = (function() {
  return this.a1H.V();
});
$p.c = (function() {
  return this.a1H.c();
});
var $d_sc_View$Elems = new $TypeData().i($c_sc_View$Elems, "scala.collection.View$Elems", ({
  HP: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1
}));
/** @constructor */
function $c_sc_View$Filter(underlying, p, isFlipped) {
  this.acs = null;
  this.aI4 = null;
  this.aI3 = false;
  this.acs = underlying;
  this.aI4 = p;
  this.aI3 = isFlipped;
}
$p = $c_sc_View$Filter.prototype = new $h_sc_AbstractView();
$p.constructor = $c_sc_View$Filter;
/** @constructor */
function $h_sc_View$Filter() {
}
$h_sc_View$Filter.prototype = $p;
$p.o = (function() {
  return new $c_sc_Iterator$$anon$6(this.acs.o(), this.aI4, this.aI3);
});
$p.V = (function() {
  return ((this.acs.V() === 0) ? 0 : (-1));
});
$p.c = (function() {
  return (!this.o().p());
});
var $d_sc_View$Filter = new $TypeData().i($c_sc_View$Filter, "scala.collection.View$Filter", ({
  HR: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1
}));
/** @constructor */
function $c_sc_View$FlatMap(underlying, f) {
  this.act = null;
  this.aI5 = null;
  this.act = underlying;
  this.aI5 = f;
}
$p = $c_sc_View$FlatMap.prototype = new $h_sc_AbstractView();
$p.constructor = $c_sc_View$FlatMap;
/** @constructor */
function $h_sc_View$FlatMap() {
}
$h_sc_View$FlatMap.prototype = $p;
$p.o = (function() {
  return new $c_sc_Iterator$$anon$10(this.act.o(), this.aI5);
});
$p.V = (function() {
  return ((this.act.V() === 0) ? 0 : (-1));
});
$p.c = (function() {
  return (!this.o().p());
});
var $d_sc_View$FlatMap = new $TypeData().i($c_sc_View$FlatMap, "scala.collection.View$FlatMap", ({
  HS: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1
}));
/** @constructor */
function $c_sc_View$LeftPartitionMapped(underlying, f) {
  this.aI7 = null;
  this.aI6 = null;
  this.aI7 = underlying;
  this.aI6 = f;
}
$p = $c_sc_View$LeftPartitionMapped.prototype = new $h_sc_AbstractView();
$p.constructor = $c_sc_View$LeftPartitionMapped;
/** @constructor */
function $h_sc_View$LeftPartitionMapped() {
}
$h_sc_View$LeftPartitionMapped.prototype = $p;
$p.o = (function() {
  return new $c_sc_View$LeftPartitionMapped$$anon$2(this);
});
var $d_sc_View$LeftPartitionMapped = new $TypeData().i($c_sc_View$LeftPartitionMapped, "scala.collection.View$LeftPartitionMapped", ({
  HT: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1
}));
function $ct_sc_View$Map__sc_IterableOps__F1__($thiz, underlying, f) {
  $thiz.Hv = underlying;
  $thiz.V2 = f;
  return $thiz;
}
/** @constructor */
function $c_sc_View$Map() {
  this.Hv = null;
  this.V2 = null;
}
$p = $c_sc_View$Map.prototype = new $h_sc_AbstractView();
$p.constructor = $c_sc_View$Map;
/** @constructor */
function $h_sc_View$Map() {
}
$h_sc_View$Map.prototype = $p;
$p.o = (function() {
  return new $c_sc_Iterator$$anon$9(this.Hv.o(), this.V2);
});
$p.V = (function() {
  return this.Hv.V();
});
$p.c = (function() {
  return this.Hv.c();
});
var $d_sc_View$Map = new $TypeData().i($c_sc_View$Map, "scala.collection.View$Map", ({
  cM: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1
}));
function $ct_sc_View$Prepended__O__sc_IterableOps__($thiz, elem, underlying) {
  $thiz.acv = elem;
  $thiz.acw = underlying;
  return $thiz;
}
/** @constructor */
function $c_sc_View$Prepended() {
  this.acv = null;
  this.acw = null;
}
$p = $c_sc_View$Prepended.prototype = new $h_sc_AbstractView();
$p.constructor = $c_sc_View$Prepended;
/** @constructor */
function $h_sc_View$Prepended() {
}
$h_sc_View$Prepended.prototype = $p;
/** @constructor */
function $c_sc_View$RightPartitionMapped(underlying, f) {
  this.aIb = null;
  this.aIa = null;
  this.aIb = underlying;
  this.aIa = f;
}
$p = $c_sc_View$RightPartitionMapped.prototype = new $h_sc_AbstractView();
$p.constructor = $c_sc_View$RightPartitionMapped;
/** @constructor */
function $h_sc_View$RightPartitionMapped() {
}
$h_sc_View$RightPartitionMapped.prototype = $p;
$p.o = (function() {
  return new $c_sc_View$RightPartitionMapped$$anon$3(this);
});
var $d_sc_View$RightPartitionMapped = new $TypeData().i($c_sc_View$RightPartitionMapped, "scala.collection.View$RightPartitionMapped", ({
  HW: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1
}));
/** @constructor */
function $c_sc_View$Single(a) {
  this.aIe = null;
  this.aIe = a;
}
$p = $c_sc_View$Single.prototype = new $h_sc_AbstractView();
$p.constructor = $c_sc_View$Single;
/** @constructor */
function $h_sc_View$Single() {
}
$h_sc_View$Single.prototype = $p;
$p.o = (function() {
  return new $c_sc_Iterator$$anon$20(this.aIe);
});
$p.V = (function() {
  return 1;
});
$p.c = (function() {
  return false;
});
var $d_sc_View$Single = new $TypeData().i($c_sc_View$Single, "scala.collection.View$Single", ({
  HY: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1
}));
function $ct_sc_View$Take__sc_IterableOps__I__($thiz, underlying, n) {
  $thiz.a1K = ((n > 0) ? n : 0);
  return $thiz;
}
/** @constructor */
function $c_sc_View$Take() {
  this.a1K = 0;
}
$p = $c_sc_View$Take.prototype = new $h_sc_AbstractView();
$p.constructor = $c_sc_View$Take;
/** @constructor */
function $h_sc_View$Take() {
}
$h_sc_View$Take.prototype = $p;
/** @constructor */
function $c_sc_View$TakeWhile(underlying, p) {
  this.acy = null;
  this.aIf = null;
  this.acy = underlying;
  this.aIf = p;
}
$p = $c_sc_View$TakeWhile.prototype = new $h_sc_AbstractView();
$p.constructor = $c_sc_View$TakeWhile;
/** @constructor */
function $h_sc_View$TakeWhile() {
}
$h_sc_View$TakeWhile.prototype = $p;
$p.o = (function() {
  return new $c_sc_Iterator$$anon$11(this.acy.o(), this.aIf);
});
$p.V = (function() {
  return ((this.acy.V() === 0) ? 0 : (-1));
});
$p.c = (function() {
  return (!this.o().p());
});
var $d_sc_View$TakeWhile = new $TypeData().i($c_sc_View$TakeWhile, "scala.collection.View$TakeWhile", ({
  I0: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1
}));
/** @constructor */
function $c_sc_View$Unfold(initial, f) {
  this.aIh = null;
  this.aIg = null;
  this.aIh = initial;
  this.aIg = f;
}
$p = $c_sc_View$Unfold.prototype = new $h_sc_AbstractView();
$p.constructor = $c_sc_View$Unfold;
/** @constructor */
function $h_sc_View$Unfold() {
}
$h_sc_View$Unfold.prototype = $p;
$p.o = (function() {
  return new $c_sc_Iterator$UnfoldIterator(this.aIh, this.aIg);
});
var $d_sc_View$Unfold = new $TypeData().i($c_sc_View$Unfold, "scala.collection.View$Unfold", ({
  I1: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1
}));
/** @constructor */
function $c_sc_View$ZipWithIndex(underlying) {
  this.a1L = null;
  this.a1L = underlying;
}
$p = $c_sc_View$ZipWithIndex.prototype = new $h_sc_AbstractView();
$p.constructor = $c_sc_View$ZipWithIndex;
/** @constructor */
function $h_sc_View$ZipWithIndex() {
}
$h_sc_View$ZipWithIndex.prototype = $p;
$p.o = (function() {
  return new $c_sc_Iterator$$anon$16(this.a1L.o());
});
$p.V = (function() {
  return this.a1L.V();
});
$p.c = (function() {
  return this.a1L.c();
});
var $d_sc_View$ZipWithIndex = new $TypeData().i($c_sc_View$ZipWithIndex, "scala.collection.View$ZipWithIndex", ({
  I2: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1
}));
function $f_sci_StrictOptimizedMapOps__concat__sc_IterableOnce__sci_MapOps($thiz, that) {
  var result = $thiz;
  var it = that.o();
  while (it.p()) {
    var this$1 = result;
    var kv = it.q();
    result = this$1.bN(kv.g(), kv.h());
  }
  return result;
}
/** @constructor */
function $c_s_math_Numeric$DoubleIsFractional$() {
}
$p = $c_s_math_Numeric$DoubleIsFractional$.prototype = new $h_O();
$p.constructor = $c_s_math_Numeric$DoubleIsFractional$;
/** @constructor */
function $h_s_math_Numeric$DoubleIsFractional$() {
}
$h_s_math_Numeric$DoubleIsFractional$.prototype = $p;
$p.mO = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$p.a52 = (function(x) {
  return $doubleToInt((+x));
});
$p.Po = (function(x) {
  return x;
});
$p.XK = (function(x, y) {
  return $f_s_math_Numeric$DoubleIsFractional__plus__D__D__D(this, (+x), (+y));
});
$p.kR = (function(x, y) {
  var x$1 = (+x);
  var y$1 = (+y);
  return (+Math.min(x$1, y$1));
});
$p.kQ = (function(x, y) {
  var x$1 = (+x);
  var y$1 = (+y);
  return (+Math.max(x$1, y$1));
});
$p.mL = (function(x, y) {
  return $f_s_math_Ordering$Double$IeeeOrdering__gt__D__D__Z(this, (+x), (+y));
});
$p.lZ = (function(x, y) {
  return $f_s_math_Ordering$Double$IeeeOrdering__lt__D__D__Z(this, (+x), (+y));
});
$p.mM = (function(x, y) {
  return $f_s_math_Ordering$Double$IeeeOrdering__gteq__D__D__Z(this, (+x), (+y));
});
$p.mQ = (function(x, y) {
  return $f_s_math_Ordering$Double$IeeeOrdering__lteq__D__D__Z(this, (+x), (+y));
});
$p.dA = (function(x, y) {
  return $m_jl_Double$().P9((+x), (+y));
});
var $d_s_math_Numeric$DoubleIsFractional$ = new $TypeData().i($c_s_math_Numeric$DoubleIsFractional$, "scala.math.Numeric$DoubleIsFractional$", ({
  KP: 1,
  KO: 1,
  KN: 1,
  dX: 1,
  ax: 1,
  ad: 1,
  ay: 1,
  aw: 1,
  a: 1,
  L4: 1
}));
var $n_s_math_Numeric$DoubleIsFractional$;
function $m_s_math_Numeric$DoubleIsFractional$() {
  if ((!$n_s_math_Numeric$DoubleIsFractional$)) {
    $n_s_math_Numeric$DoubleIsFractional$ = new $c_s_math_Numeric$DoubleIsFractional$();
  }
  return $n_s_math_Numeric$DoubleIsFractional$;
}
/** @constructor */
function $c_s_math_Numeric$IntIsIntegral$() {
}
$p = $c_s_math_Numeric$IntIsIntegral$.prototype = new $h_O();
$p.constructor = $c_s_math_Numeric$IntIsIntegral$;
/** @constructor */
function $h_s_math_Numeric$IntIsIntegral$() {
}
$h_s_math_Numeric$IntIsIntegral$.prototype = $p;
$p.mQ = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$p.mM = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$p.lZ = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$p.mL = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$p.kQ = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$p.kR = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$p.mO = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$p.a52 = (function(x) {
  return (x | 0);
});
$p.Po = (function(x) {
  return x;
});
$p.XK = (function(x, y) {
  return $f_s_math_Numeric$IntIsIntegral__plus__I__I__I(this, (x | 0), (y | 0));
});
$p.dA = (function(x, y) {
  var x$1 = (x | 0);
  var y$1 = (y | 0);
  return ((x$1 === y$1) ? 0 : ((x$1 < y$1) ? (-1) : 1));
});
var $d_s_math_Numeric$IntIsIntegral$ = new $TypeData().i($c_s_math_Numeric$IntIsIntegral$, "scala.math.Numeric$IntIsIntegral$", ({
  KR: 1,
  KQ: 1,
  m6: 1,
  dX: 1,
  ax: 1,
  ad: 1,
  ay: 1,
  aw: 1,
  a: 1,
  m7: 1
}));
var $n_s_math_Numeric$IntIsIntegral$;
function $m_s_math_Numeric$IntIsIntegral$() {
  if ((!$n_s_math_Numeric$IntIsIntegral$)) {
    $n_s_math_Numeric$IntIsIntegral$ = new $c_s_math_Numeric$IntIsIntegral$();
  }
  return $n_s_math_Numeric$IntIsIntegral$;
}
/** @constructor */
function $c_s_math_Numeric$LongIsIntegral$() {
}
$p = $c_s_math_Numeric$LongIsIntegral$.prototype = new $h_O();
$p.constructor = $c_s_math_Numeric$LongIsIntegral$;
/** @constructor */
function $h_s_math_Numeric$LongIsIntegral$() {
}
$h_s_math_Numeric$LongIsIntegral$.prototype = $p;
$p.mQ = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$p.mM = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$p.lZ = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$p.mL = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$p.kQ = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$p.kR = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$p.mO = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$p.a52 = (function(x) {
  var $x_1 = $uJ(x);
  return $s_RTLong__toInt__I__I__I($x_1.l, $x_1.h);
});
$p.Po = (function(x) {
  var hi = (x >> 31);
  return $bL(x, hi);
});
$p.XK = (function(x, y) {
  var $x_2 = $uJ(x);
  var $x_1 = $uJ(y);
  return $f_s_math_Numeric$LongIsIntegral__plus__J__J__J(this, $x_2.l, $x_2.h, $x_1.l, $x_1.h);
});
$p.dA = (function(x, y) {
  var $x_1 = $uJ(x);
  var x$1_$_lo = $x_1.l;
  var x$1_$_hi = $x_1.h;
  var $x_2 = $uJ(y);
  var y$1_$_lo = $x_2.l;
  var y$1_$_hi = $x_2.h;
  return ((x$1_$_hi === y$1_$_hi) ? ((x$1_$_lo === y$1_$_lo) ? 0 : (((x$1_$_lo >>> 0) < (y$1_$_lo >>> 0)) ? (-1) : 1)) : ((x$1_$_hi < y$1_$_hi) ? (-1) : 1));
});
var $d_s_math_Numeric$LongIsIntegral$ = new $TypeData().i($c_s_math_Numeric$LongIsIntegral$, "scala.math.Numeric$LongIsIntegral$", ({
  KT: 1,
  KS: 1,
  m6: 1,
  dX: 1,
  ax: 1,
  ad: 1,
  ay: 1,
  aw: 1,
  a: 1,
  m8: 1
}));
var $n_s_math_Numeric$LongIsIntegral$;
function $m_s_math_Numeric$LongIsIntegral$() {
  if ((!$n_s_math_Numeric$LongIsIntegral$)) {
    $n_s_math_Numeric$LongIsIntegral$ = new $c_s_math_Numeric$LongIsIntegral$();
  }
  return $n_s_math_Numeric$LongIsIntegral$;
}
/** @constructor */
function $c_Lujson_Null$() {
}
$p = $c_Lujson_Null$.prototype = new $h_O();
$p.constructor = $c_Lujson_Null$;
/** @constructor */
function $h_Lujson_Null$() {
}
$h_Lujson_Null$.prototype = $p;
$p.yq = (function(f) {
  return $m_Lujson_Value$().yp(this, f);
});
$p.m = (function() {
  return $f_Lujson_Value__render__I__Z__T(this, (-1), false);
});
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return 2439591;
});
$p.z = (function() {
  return 0;
});
$p.B = (function() {
  return "Null";
});
$p.A = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lujson_Null$ = new $TypeData().i($c_Lujson_Null$, "ujson.Null$", ({
  NB: 1,
  b4: 1,
  ac: 1,
  bk: 1,
  b: 1,
  c: 1,
  a: 1,
  d: 1,
  j: 1,
  r: 1
}));
var $n_Lujson_Null$;
function $m_Lujson_Null$() {
  if ((!$n_Lujson_Null$)) {
    $n_Lujson_Null$ = new $c_Lujson_Null$();
  }
  return $n_Lujson_Null$;
}
/** @constructor */
function $c_Lupack_Null$() {
}
$p = $c_Lupack_Null$.prototype = new $h_O();
$p.constructor = $c_Lupack_Null$;
/** @constructor */
function $h_Lupack_Null$() {
}
$h_Lupack_Null$.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return 2439591;
});
$p.m = (function() {
  return "Null";
});
$p.z = (function() {
  return 0;
});
$p.B = (function() {
  return "Null";
});
$p.A = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lupack_Null$ = new $TypeData().i($c_Lupack_Null$, "upack.Null$", ({
  NP: 1,
  aC: 1,
  ac: 1,
  aJ: 1,
  b: 1,
  c: 1,
  a: 1,
  d: 1,
  j: 1,
  r: 1
}));
var $n_Lupack_Null$;
function $m_Lupack_Null$() {
  if ((!$n_Lupack_Null$)) {
    $n_Lupack_Null$ = new $c_Lupack_Null$();
  }
  return $n_Lupack_Null$;
}
function $f_Lupickle_implicits_Writers__$init$__V($thiz) {
  $thiz.I = new $c_Lupickle_implicits_Writers$$anon$1($thiz);
  new $c_Lupickle_implicits_Writers$$anon$2($thiz);
  $thiz.aKb = new $c_Lupickle_implicits_Writers$$anon$3($thiz);
  $thiz.hB = new $c_Lupickle_implicits_Writers$$anon$4($thiz);
  $thiz.aKd = new $c_Lupickle_implicits_Writers$$anon$5($thiz);
  $thiz.aKj = new $c_Lupickle_implicits_Writers$$anon$6($thiz);
  $thiz.aK7 = new $c_Lupickle_implicits_Writers$$anon$7($thiz);
  $thiz.gP = new $c_Lupickle_implicits_Writers$$anon$8($thiz);
  $thiz.aK9 = new $c_Lupickle_implicits_Writers$$anon$9($thiz);
  new $c_Lupickle_implicits_Writers$$anon$10($thiz);
  $thiz.tO = new $c_Lupickle_implicits_Writers$$anon$11($thiz);
  new $c_Lupickle_implicits_Writers$$anon$12($thiz);
  new $c_Lupickle_implicits_Writers$$anon$13($thiz);
  new $c_Lupickle_implicits_Writers$$anon$14($thiz);
  $thiz.ae3 = new $c_Lupickle_implicits_Writers$$anon$15($thiz);
  $thiz.ae3.cW();
  $thiz.ae3.cW();
  $thiz.Eo().DJ($thiz.gP).DS();
  $thiz.Eo().DJ($thiz.aK7).DS();
  $thiz.Eo().DJ($thiz.aK9).DS();
  $thiz.Eo().DJ($thiz.aKj).DS();
  $thiz.Eo().DJ($thiz.hB).DS();
  $thiz.Eo().DJ($thiz.tO).DS();
  $thiz.Eo().DJ($thiz.aKd).DS();
  $thiz.Eo().DJ($thiz.aKb).DS();
}
function $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($thiz, evidence$1) {
  return ($is_Lupickle_implicits_Writers$OptionWriter(evidence$1) ? new $c_Lupickle_implicits_Writers$$anon$16(evidence$1, $thiz) : new $c_Lupickle_implicits_Writers$$anon$17(evidence$1, $thiz));
}
function $f_Lcom_raquo_airstream_common_SingleParentSignal__$init$__V($thiz) {
  $thiz.a2U($is_Lcom_raquo_airstream_core_Signal($thiz.ku()));
  $thiz.OS((-1));
}
function $f_Lcom_raquo_airstream_common_SingleParentSignal__onWillStart__V($thiz) {
  $f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V($thiz.ku());
  if ($thiz.XF()) {
    var newParentLastUpdateId = $thiz.ku().jk();
    if ((newParentLastUpdateId !== $thiz.a2z())) {
      $thiz.Yb($thiz.vX(), newParentLastUpdateId);
    }
  }
}
function $f_Lcom_raquo_airstream_common_SingleParentSignal__updateCurrentValueFromParent__s_util_Try__I__V($thiz, nextValue, nextParentLastUpdateId) {
  $f_Lcom_raquo_airstream_core_WritableSignal__setCurrentValue__s_util_Try__V($thiz, nextValue);
  $thiz.OS(nextParentLastUpdateId);
}
function $f_Lcom_raquo_airstream_common_SingleParentSignal__onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V($thiz, nextParentValue, transaction) {
  if ($thiz.XF()) {
    $thiz.OS($thiz.ku().jk());
  }
}
function $f_Lcom_raquo_airstream_common_SingleParentSignal__onStart__V($thiz) {
  $f_Lcom_raquo_airstream_core_WritableObservable__addInternalObserver__Lcom_raquo_airstream_core_InternalObserver__Z__V($thiz.ku(), $thiz, false);
  $f_Lcom_raquo_airstream_core_Signal__onStart__V($thiz);
}
function $f_Lcom_raquo_airstream_common_SingleParentSignal__onStop__V($thiz) {
  $f_Lcom_raquo_airstream_core_BaseObservable__removeInternalObserver__Lcom_raquo_airstream_core_InternalObserver__V($thiz.ku(), $thiz);
}
/** @constructor */
function $c_Lcom_raquo_airstream_eventbus_EventBusStream(parentDisplayName) {
  this.ajM = null;
  this.ajL = false;
  this.ajN = null;
  this.ajJ = null;
  this.ajK = null;
  this.ajQ = false;
  this.ajO = null;
  this.Yq = null;
  this.ajP = 0;
  this.ajO = parentDisplayName;
  this.ajM = (void 0);
  $f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  $f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.Yq = $m_Lcom_raquo_ew_JsArray$().fu($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_airstream_core_EventStream.r().C)([])));
  this.ajP = 1;
}
$p = $c_Lcom_raquo_airstream_eventbus_EventBusStream.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_eventbus_EventBusStream;
/** @constructor */
function $h_Lcom_raquo_airstream_eventbus_EventBusStream() {
}
$h_Lcom_raquo_airstream_eventbus_EventBusStream.prototype = $p;
$p.fx = (function() {
  return this.ajM;
});
$p.m = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.hR = (function() {
  return this.ajL;
});
$p.h5 = (function() {
  return this.ajN;
});
$p.gb = (function(x$1) {
  this.ajL = x$1;
});
$p.hS = (function(x$1) {
  this.ajN = x$1;
});
$p.e = (function(obj) {
  return (this === obj);
});
$p.x = (function() {
  return $systemIdentityHashCode(this);
});
$p.ip = (function(observer) {
});
$p.mY = (function() {
  return this;
});
$p.gk = (function() {
  return this.ajJ;
});
$p.gl = (function() {
  return this.ajK;
});
$p.iA = (function() {
  return this.ajQ;
});
$p.hs = (function(x$1) {
  this.ajQ = x$1;
});
$p.ig = (function(x$0) {
  this.ajJ = x$0;
});
$p.ih = (function(x$0) {
  this.ajK = x$0;
});
$p.ik = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.it = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_common_InternalNextErrorObserver__onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.eB = (function() {
  return this.ajP;
});
$p.iY = (function(nextValue, ignoredTransaction) {
  new $c_Lcom_raquo_airstream_core_Transaction(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => {
    $f_Lcom_raquo_airstream_core_WritableStream__fireValue__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, _$1);
  })));
});
$p.iq = (function(nextError, transaction) {
  new $c_Lcom_raquo_airstream_core_Transaction(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => {
    $f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, _$2);
  })));
});
$p.iu = (function() {
  var arr = this.Yq;
  var i = 0;
  var len = (arr.length | 0);
  while ((i < len)) {
    $f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(arr[i]);
    i = ((1 + i) | 0);
  }
});
$p.ir = (function() {
  var arr = this.Yq;
  var i = 0;
  var len = (arr.length | 0);
  while ((i < len)) {
    $f_Lcom_raquo_airstream_core_WritableObservable__addInternalObserver__Lcom_raquo_airstream_core_InternalObserver__Z__V(arr[i], this, false);
    i = ((1 + i) | 0);
  }
});
$p.is = (function() {
  var arr = this.Yq;
  var i = 0;
  var len = (arr.length | 0);
  while ((i < len)) {
    $f_Lcom_raquo_airstream_core_BaseObservable__removeInternalObserver__Lcom_raquo_airstream_core_InternalObserver__V(arr[i], this);
    i = ((1 + i) | 0);
  }
});
$p.eU = (function() {
  return (this.ajO.a3() + ".events");
});
$p.fQ = (function(project) {
  return new $c_Lcom_raquo_airstream_misc_MapStream(this, project, $m_s_None$());
});
$p.ii = (function(isSame) {
  return new $c_Lcom_raquo_airstream_distinct_DistinctStream(this, isSame, false);
});
$p.dM = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_eventbus_EventBusStream = new $TypeData().i($c_Lcom_raquo_airstream_eventbus_EventBusStream, "com.raquo.airstream.eventbus.EventBusStream", ({
  oe: 1,
  P: 1,
  O: 1,
  U: 1,
  V: 1,
  al: 1,
  am: 1,
  Z: 1,
  aq: 1,
  a3: 1,
  bl: 1
}));
function $p_Lcom_raquo_airstream_flatten_SwitchSignal__currentSignalTry__s_util_Try($thiz) {
  var x = $thiz.Qv;
  if ((x === (void 0))) {
    var initialSignal = $thiz.Ex.aq();
    $thiz.Qv = initialSignal;
    var $x_1 = initialSignal;
  } else {
    var $x_1 = x;
  }
  return $x_1;
}
function $p_Lcom_raquo_airstream_flatten_SwitchSignal__isSameSignal__s_util_Try__s_util_Try__Z($thiz, signalTry1, signalTry2) {
  if ((signalTry1 instanceof $c_s_util_Success)) {
    var signal1 = signalTry1.fM;
    if ((signalTry2 instanceof $c_s_util_Success)) {
      return (signal1 === signalTry2.fM);
    }
  }
  return false;
}
/** @constructor */
function $c_Lcom_raquo_airstream_flatten_SwitchSignal(parent) {
  this.ajX = null;
  this.ajW = false;
  this.ajY = null;
  this.a5E = 0;
  this.ajU = null;
  this.ajV = null;
  this.ak0 = false;
  this.a5F = null;
  this.Ex = null;
  this.ajZ = 0;
  this.Qv = null;
  this.Ev = 0;
  this.Ew = null;
  this.Ex = parent;
  this.ajX = (void 0);
  $f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  this.a5E = 0;
  $f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.a5F = (void 0);
  this.ajZ = 1;
  this.Qv = (void 0);
  this.Ev = 0;
  this.Ew = $m_Lcom_raquo_airstream_core_InternalObserver$().aOI(new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((nextTry, _$1) => {
    this.Ev = $p_Lcom_raquo_airstream_flatten_SwitchSignal__currentSignalTry__s_util_Try(this).d().jk();
    new $c_Lcom_raquo_airstream_core_Transaction(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((nextTry$2) => ((_$2) => {
      $f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextTry$2, _$2);
    }))(nextTry)));
  })));
}
$p = $c_Lcom_raquo_airstream_flatten_SwitchSignal.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_flatten_SwitchSignal;
/** @constructor */
function $h_Lcom_raquo_airstream_flatten_SwitchSignal() {
}
$h_Lcom_raquo_airstream_flatten_SwitchSignal.prototype = $p;
$p.fx = (function() {
  return this.ajX;
});
$p.eU = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$p.m = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.hR = (function() {
  return this.ajW;
});
$p.h5 = (function() {
  return this.ajY;
});
$p.gb = (function(x$1) {
  this.ajW = x$1;
});
$p.hS = (function(x$1) {
  this.ajY = x$1;
});
$p.e = (function(obj) {
  return (this === obj);
});
$p.x = (function() {
  return $systemIdentityHashCode(this);
});
$p.jk = (function() {
  return this.a5E;
});
$p.xZ = (function(x$1) {
  this.a5E = x$1;
});
$p.dP = (function() {
  return this;
});
$p.ip = (function(observer) {
  observer.mT($f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this));
});
$p.gk = (function() {
  return this.ajU;
});
$p.gl = (function() {
  return this.ajV;
});
$p.iA = (function() {
  return this.ak0;
});
$p.hs = (function(x$1) {
  this.ak0 = x$1;
});
$p.ig = (function(x$0) {
  this.ajU = x$0;
});
$p.ih = (function(x$0) {
  this.ajV = x$0;
});
$p.ye = (function() {
  return this.a5F;
});
$p.At = (function(x$1) {
  this.a5F = x$1;
});
$p.aq = (function() {
  return $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this);
});
$p.ik = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.iY = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_common_InternalTryObserver__onNext__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.iq = (function(nextError, transaction) {
  $f_Lcom_raquo_airstream_common_InternalTryObserver__onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$p.eB = (function() {
  return this.ajZ;
});
$p.vX = (function() {
  return this.Ex.aq().WR(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$3) => _$3.aq())));
});
$p.it = (function(nextParentValue, transaction) {
  this.b9D(nextParentValue);
});
$p.iu = (function() {
  $f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(this.Ex);
  var nextSignalTry = this.Ex.aq();
  if ($p_Lcom_raquo_airstream_flatten_SwitchSignal__isSameSignal__s_util_Try__s_util_Try__Z(this, nextSignalTry, $p_Lcom_raquo_airstream_flatten_SwitchSignal__currentSignalTry__s_util_Try(this))) {
    $p_Lcom_raquo_airstream_flatten_SwitchSignal__currentSignalTry__s_util_Try(this).F(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((observable$1) => {
      $f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(observable$1);
    })));
    var nextSignal = nextSignalTry.d();
    var nextSignalLastUpdateId = nextSignal.jk();
    if ((nextSignalLastUpdateId !== this.Ev)) {
      $f_Lcom_raquo_airstream_core_WritableSignal__setCurrentValue__s_util_Try__V(this, nextSignal.aq());
      this.Ev = nextSignalLastUpdateId;
    }
  } else {
    $p_Lcom_raquo_airstream_flatten_SwitchSignal__currentSignalTry__s_util_Try(this).F(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$4) => {
      $f_Lcom_raquo_airstream_core_BaseObservable__removeInternalObserver__Lcom_raquo_airstream_core_InternalObserver__V(_$4, this.Ew);
    })));
    this.Qv = nextSignalTry;
    nextSignalTry.F(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((observable$2) => {
      $f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(observable$2);
    })));
    $f_Lcom_raquo_airstream_core_WritableSignal__setCurrentValue__s_util_Try__V(this, nextSignalTry.WR(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$5) => _$5.aq()))));
    this.Ev = (nextSignalTry.ua(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((signal) => signal.jk()))).X2(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => 0))) | 0);
    nextSignalTry.F(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$6) => {
      $f_Lcom_raquo_airstream_core_WritableObservable__addInternalObserver__Lcom_raquo_airstream_core_InternalObserver__Z__V(_$6, this.Ew, false);
    })));
  }
});
$p.b9D = (function(nextSignalTry) {
  if ((!$p_Lcom_raquo_airstream_flatten_SwitchSignal__isSameSignal__s_util_Try__s_util_Try__Z(this, nextSignalTry, $p_Lcom_raquo_airstream_flatten_SwitchSignal__currentSignalTry__s_util_Try(this)))) {
    var prevSignalTry = $p_Lcom_raquo_airstream_flatten_SwitchSignal__currentSignalTry__s_util_Try(this);
    prevSignalTry.F(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$7) => {
      $f_Lcom_raquo_airstream_core_WritableObservable__addInternalObserver__Lcom_raquo_airstream_core_InternalObserver__Z__V(_$7, $m_Lcom_raquo_airstream_core_InternalObserver$().Qs, false);
    })));
    prevSignalTry.F(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$8) => {
      $f_Lcom_raquo_airstream_core_BaseObservable__removeInternalObserver__Lcom_raquo_airstream_core_InternalObserver__V(_$8, this.Ew);
    })));
    this.Qv = nextSignalTry;
    this.Ev = 0;
    new $c_Lcom_raquo_airstream_core_Transaction(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((trx) => {
      if ($f_Lcom_raquo_airstream_core_BaseObservable__isStarted__Z(this)) {
        nextSignalTry.F(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((observable) => {
          $f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(observable);
        })));
        $f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextSignalTry.WR(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$9) => _$9.aq()))), trx);
        this.Ev = (nextSignalTry.ua(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((signal) => signal.jk()))).X2(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => 0))) | 0);
        nextSignalTry.F(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$10) => {
          $f_Lcom_raquo_airstream_core_WritableObservable__addInternalObserver__Lcom_raquo_airstream_core_InternalObserver__Z__V(_$10, this.Ew, false);
        })));
        prevSignalTry.F(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$11) => {
          $f_Lcom_raquo_airstream_core_BaseObservable__removeInternalObserver__Lcom_raquo_airstream_core_InternalObserver__V(_$11, $m_Lcom_raquo_airstream_core_InternalObserver$().Qs);
        })));
      }
    })));
  }
});
$p.ir = (function() {
  $f_Lcom_raquo_airstream_core_WritableObservable__addInternalObserver__Lcom_raquo_airstream_core_InternalObserver__Z__V(this.Ex, this, false);
  $p_Lcom_raquo_airstream_flatten_SwitchSignal__currentSignalTry__s_util_Try(this).F(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$12) => {
    $f_Lcom_raquo_airstream_core_WritableObservable__addInternalObserver__Lcom_raquo_airstream_core_InternalObserver__Z__V(_$12, this.Ew, false);
  })));
  $f_Lcom_raquo_airstream_core_Signal__onStart__V(this);
});
$p.is = (function() {
  $f_Lcom_raquo_airstream_core_BaseObservable__removeInternalObserver__Lcom_raquo_airstream_core_InternalObserver__V(this.Ex, this);
  $p_Lcom_raquo_airstream_flatten_SwitchSignal__currentSignalTry__s_util_Try(this).F(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$13) => {
    $f_Lcom_raquo_airstream_core_BaseObservable__removeInternalObserver__Lcom_raquo_airstream_core_InternalObserver__V(_$13, this.Ew);
  })));
});
$p.fQ = (function(project) {
  return $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), this, project, $m_s_None$());
});
$p.ii = (function(isSame) {
  return new $c_Lcom_raquo_airstream_distinct_DistinctSignal(this, isSame, false);
});
$p.dM = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_flatten_SwitchSignal = new $TypeData().i($c_Lcom_raquo_airstream_flatten_SwitchSignal, "com.raquo.airstream.flatten.SwitchSignal", ({
  ok: 1,
  P: 1,
  O: 1,
  U: 1,
  V: 1,
  aB: 1,
  aD: 1,
  Z: 1,
  aS: 1,
  a3: 1,
  aK: 1
}));
function $p_Lcom_raquo_airstream_flatten_SwitchSignalStream__switchToSignal__s_util_Try__V($thiz, nextSignalTry) {
  var x = $thiz.Ey;
  if ((x !== (void 0))) {
    matchResult1: {
      var $x_1;
      if ((nextSignalTry instanceof $c_s_util_Success)) {
        var nextSignal = nextSignalTry.fM;
        if ((x instanceof $c_s_util_Success)) {
          var $x_1 = (nextSignal === x.fM);
          break matchResult1;
        }
      }
      var $x_1 = false;
    }
  } else {
    var $x_1 = false;
  }
  if ((!$x_1)) {
    $p_Lcom_raquo_airstream_flatten_SwitchSignalStream__removeInternalObserverFromCurrentSignal__V($thiz);
    $thiz.Ey = nextSignalTry;
    $thiz.JQ = (-1);
    new $c_Lcom_raquo_airstream_core_Transaction(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((trx) => {
      if ($f_Lcom_raquo_airstream_core_BaseObservable__isStarted__Z($thiz)) {
        nextSignalTry.F(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((observable) => {
          $f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(observable);
        })));
        $f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V($thiz, nextSignalTry.WR(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$4) => _$4.aq()))), trx);
        nextSignalTry.F(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((nextSignal$1) => {
          $thiz.JQ = nextSignal$1.jk();
          $f_Lcom_raquo_airstream_core_WritableObservable__addInternalObserver__Lcom_raquo_airstream_core_InternalObserver__Z__V(nextSignal$1, $thiz.Yr, false);
        })));
      }
    })));
  }
}
function $p_Lcom_raquo_airstream_flatten_SwitchSignalStream__removeInternalObserverFromCurrentSignal__V($thiz) {
  var x = $thiz.Ey;
  if ((x !== (void 0))) {
    x.F(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((currentSignal) => {
      $f_Lcom_raquo_airstream_core_BaseObservable__removeInternalObserver__Lcom_raquo_airstream_core_InternalObserver__V(currentSignal, $thiz.Yr);
    })));
  }
}
/** @constructor */
function $c_Lcom_raquo_airstream_flatten_SwitchSignalStream(parent) {
  this.ak4 = null;
  this.ak3 = false;
  this.ak5 = null;
  this.ak1 = null;
  this.ak2 = null;
  this.ak7 = false;
  this.Ys = null;
  this.ak6 = 0;
  this.Ey = null;
  this.JQ = 0;
  this.Yr = null;
  this.Ys = parent;
  this.ak4 = (void 0);
  $f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  $f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.ak6 = 1;
  this.Ey = (void 0);
  this.JQ = 0;
  this.Yr = $m_Lcom_raquo_airstream_core_InternalObserver$().aOI(new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((nextTry, _$1) => {
    new $c_Lcom_raquo_airstream_core_Transaction(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((nextTry$2) => ((trx) => {
      if ($f_Lcom_raquo_airstream_core_BaseObservable__isStarted__Z(this)) {
        $f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextTry$2, trx);
        var x = this.Ey;
        if ((x !== (void 0))) {
          x.F(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((currentSignal) => {
            this.JQ = currentSignal.jk();
          })));
        }
      }
    }))(nextTry)));
  })));
}
$p = $c_Lcom_raquo_airstream_flatten_SwitchSignalStream.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_flatten_SwitchSignalStream;
/** @constructor */
function $h_Lcom_raquo_airstream_flatten_SwitchSignalStream() {
}
$h_Lcom_raquo_airstream_flatten_SwitchSignalStream.prototype = $p;
$p.fx = (function() {
  return this.ak4;
});
$p.eU = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$p.m = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.hR = (function() {
  return this.ak3;
});
$p.h5 = (function() {
  return this.ak5;
});
$p.gb = (function(x$1) {
  this.ak3 = x$1;
});
$p.hS = (function(x$1) {
  this.ak5 = x$1;
});
$p.e = (function(obj) {
  return (this === obj);
});
$p.x = (function() {
  return $systemIdentityHashCode(this);
});
$p.ip = (function(observer) {
});
$p.mY = (function() {
  return this;
});
$p.gk = (function() {
  return this.ak1;
});
$p.gl = (function() {
  return this.ak2;
});
$p.iA = (function() {
  return this.ak7;
});
$p.hs = (function(x$1) {
  this.ak7 = x$1;
});
$p.ig = (function(x$0) {
  this.ak1 = x$0;
});
$p.ih = (function(x$0) {
  this.ak2 = x$0;
});
$p.ik = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.iY = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_common_InternalTryObserver__onNext__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.iq = (function(nextError, transaction) {
  $f_Lcom_raquo_airstream_common_InternalTryObserver__onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$p.eB = (function() {
  return this.ak6;
});
$p.iu = (function() {
  $f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(this.Ys);
  var x = this.Ey;
  if ((x !== (void 0))) {
    x.F(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((currentSignal) => {
      $f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(currentSignal);
    })));
  }
});
$p.it = (function(nextSignalTry, transaction) {
  $p_Lcom_raquo_airstream_flatten_SwitchSignalStream__switchToSignal__s_util_Try__V(this, nextSignalTry);
});
$p.ir = (function() {
  $f_Lcom_raquo_airstream_core_WritableObservable__addInternalObserver__Lcom_raquo_airstream_core_InternalObserver__Z__V(this.Ys, this, false);
  var x = this.Ey;
  if ((x !== (void 0))) {
    x.F(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((currentSignal) => {
      var newSignalLastUpdateId = currentSignal.jk();
      if ((newSignalLastUpdateId !== this.JQ)) {
        new $c_Lcom_raquo_airstream_core_Transaction(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((currentSignal$2) => ((trx) => {
          if ($f_Lcom_raquo_airstream_core_BaseObservable__isStarted__Z(this)) {
            $f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, currentSignal$2.aq(), trx);
            this.JQ = newSignalLastUpdateId;
          }
        }))(currentSignal)));
      }
      $f_Lcom_raquo_airstream_core_WritableObservable__addInternalObserver__Lcom_raquo_airstream_core_InternalObserver__Z__V(currentSignal, this.Yr, false);
    })));
  }
});
$p.is = (function() {
  $p_Lcom_raquo_airstream_flatten_SwitchSignalStream__removeInternalObserverFromCurrentSignal__V(this);
  $f_Lcom_raquo_airstream_core_BaseObservable__removeInternalObserver__Lcom_raquo_airstream_core_InternalObserver__V(this.Ys, this);
});
$p.fQ = (function(project) {
  return new $c_Lcom_raquo_airstream_misc_MapStream(this, project, $m_s_None$());
});
$p.ii = (function(isSame) {
  return new $c_Lcom_raquo_airstream_distinct_DistinctStream(this, isSame, false);
});
$p.dM = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_flatten_SwitchSignalStream = new $TypeData().i($c_Lcom_raquo_airstream_flatten_SwitchSignalStream, "com.raquo.airstream.flatten.SwitchSignalStream", ({
  ol: 1,
  P: 1,
  O: 1,
  U: 1,
  V: 1,
  al: 1,
  am: 1,
  Z: 1,
  aq: 1,
  a3: 1,
  aK: 1
}));
function $p_Lcom_raquo_airstream_flatten_SwitchStream__switchToNextStream__Lcom_raquo_airstream_core_EventStream__Z__V($thiz, nextStream, isStarting) {
  var x = $thiz.AN;
  var isSameStream = ((x !== (void 0)) && (x.Xe() && (x.d() === nextStream)));
  var maybePrevEventStreamTry = $thiz.AN;
  if ((!isSameStream)) {
    if ((maybePrevEventStreamTry !== (void 0))) {
      maybePrevEventStreamTry.F(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((prevStream) => {
        $f_Lcom_raquo_airstream_core_WritableObservable__addInternalObserver__Lcom_raquo_airstream_core_InternalObserver__Z__V(prevStream, $m_Lcom_raquo_airstream_core_InternalObserver$().Qs, false);
      })));
    }
    $p_Lcom_raquo_airstream_flatten_SwitchStream__removeInternalObserverFromCurrentEventStream__V($thiz);
    $thiz.AN = new $c_s_util_Success(nextStream);
  }
  if (((!isSameStream) || isStarting)) {
    $f_Lcom_raquo_airstream_core_WritableObservable__addInternalObserver__Lcom_raquo_airstream_core_InternalObserver__Z__V(nextStream, $thiz.Yt, (!isStarting));
    if ((!isSameStream)) {
      if ((maybePrevEventStreamTry !== (void 0))) {
        maybePrevEventStreamTry.F(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((prevStream$1) => {
          $f_Lcom_raquo_airstream_core_BaseObservable__removeInternalObserver__Lcom_raquo_airstream_core_InternalObserver__V(prevStream$1, $m_Lcom_raquo_airstream_core_InternalObserver$().Qs);
        })));
      }
    }
  }
}
function $p_Lcom_raquo_airstream_flatten_SwitchStream__switchToNextError__jl_Throwable__s_Option__V($thiz, nextError, transaction) {
  $p_Lcom_raquo_airstream_flatten_SwitchStream__removeInternalObserverFromCurrentEventStream__V($thiz);
  $thiz.AN = new $c_s_util_Failure(nextError);
  if (transaction.c()) {
    new $c_Lcom_raquo_airstream_core_Transaction(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$9) => {
      $f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V($thiz, nextError, _$9);
    })));
  } else {
    $f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V($thiz, nextError, transaction.d());
  }
}
function $p_Lcom_raquo_airstream_flatten_SwitchStream__removeInternalObserverFromCurrentEventStream__V($thiz) {
  var x = $thiz.AN;
  if ((x !== (void 0))) {
    x.F(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((currentStream) => {
      $f_Lcom_raquo_airstream_core_BaseObservable__removeInternalObserver__Lcom_raquo_airstream_core_InternalObserver__V(currentStream, $thiz.Yt);
    })));
  }
}
/** @constructor */
function $c_Lcom_raquo_airstream_flatten_SwitchStream(parent, makeStream) {
  this.akb = null;
  this.aka = false;
  this.akc = null;
  this.ak8 = null;
  this.ak9 = null;
  this.ake = false;
  this.Qw = null;
  this.a5G = null;
  this.akd = 0;
  this.a5H = false;
  this.AN = null;
  this.Yu = null;
  this.Yt = null;
  this.Qw = parent;
  this.a5G = makeStream;
  this.akb = (void 0);
  $f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  $f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.akd = 1;
  this.a5H = $is_Lcom_raquo_airstream_core_Signal(parent);
  this.AN = (void 0);
  this.Yu = (void 0);
  this.Yt = $m_Lcom_raquo_airstream_core_InternalObserver$().aMa(new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((nextEvent, _$1) => {
    new $c_Lcom_raquo_airstream_core_Transaction(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => {
      $f_Lcom_raquo_airstream_core_WritableStream__fireValue__O__Lcom_raquo_airstream_core_Transaction__V(this, nextEvent, _$2);
    })));
  })), new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((nextError, _$3) => {
    new $c_Lcom_raquo_airstream_core_Transaction(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((nextError$2) => ((_$4) => {
      $f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError$2, _$4);
    }))(nextError)));
  })));
}
$p = $c_Lcom_raquo_airstream_flatten_SwitchStream.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_flatten_SwitchStream;
/** @constructor */
function $h_Lcom_raquo_airstream_flatten_SwitchStream() {
}
$h_Lcom_raquo_airstream_flatten_SwitchStream.prototype = $p;
$p.fx = (function() {
  return this.akb;
});
$p.eU = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$p.m = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.hR = (function() {
  return this.aka;
});
$p.h5 = (function() {
  return this.akc;
});
$p.gb = (function(x$1) {
  this.aka = x$1;
});
$p.hS = (function(x$1) {
  this.akc = x$1;
});
$p.e = (function(obj) {
  return (this === obj);
});
$p.x = (function() {
  return $systemIdentityHashCode(this);
});
$p.ip = (function(observer) {
});
$p.mY = (function() {
  return this;
});
$p.gk = (function() {
  return this.ak8;
});
$p.gl = (function() {
  return this.ak9;
});
$p.iA = (function() {
  return this.ake;
});
$p.hs = (function(x$1) {
  this.ake = x$1;
});
$p.ig = (function(x$0) {
  this.ak8 = x$0;
});
$p.ih = (function(x$0) {
  this.ak9 = x$0;
});
$p.ik = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.it = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_common_InternalNextErrorObserver__onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.eB = (function() {
  return this.akd;
});
$p.iY = (function(nextValue, transaction) {
  $p_Lcom_raquo_airstream_flatten_SwitchStream__switchToNextStream__Lcom_raquo_airstream_core_EventStream__Z__V(this, this.a5G.i(nextValue), false);
});
$p.iq = (function(nextError, transaction) {
  $p_Lcom_raquo_airstream_flatten_SwitchStream__switchToNextError__jl_Throwable__s_Option__V(this, nextError, new $c_s_Some(transaction));
});
$p.iu = (function() {
  $f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(this.Qw);
  if (this.a5H) {
    var parentSignal = this.Qw;
    var newStreamTry = parentSignal.aq().ua(this.a5G);
    newStreamTry.F(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((observable$1) => {
      $f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(observable$1);
    })));
    this.Yu = newStreamTry;
  } else {
    var x = this.AN;
    if ((x !== (void 0))) {
      x.F(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((observable$2) => {
        $f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(observable$2);
      })));
    }
  }
});
$p.ir = (function() {
  $f_Lcom_raquo_airstream_core_WritableObservable__addInternalObserver__Lcom_raquo_airstream_core_InternalObserver__Z__V(this.Qw, this, false);
  if (this.a5H) {
    var x = this.Yu;
    if ((x !== (void 0))) {
      matchResult1: {
        if ((x instanceof $c_s_util_Success)) {
          $p_Lcom_raquo_airstream_flatten_SwitchStream__switchToNextStream__Lcom_raquo_airstream_core_EventStream__Z__V(this, x.fM, true);
          break matchResult1;
        }
        if ((x instanceof $c_s_util_Failure)) {
          $p_Lcom_raquo_airstream_flatten_SwitchStream__switchToNextError__jl_Throwable__s_Option__V(this, x.le, $m_s_None$());
          break matchResult1;
        }
        throw new $c_s_MatchError(x);
      }
    }
    this.Yu = (void 0);
  } else {
    var x$1 = this.AN;
    if ((x$1 !== (void 0))) {
      x$1.F(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((currentStream) => {
        $f_Lcom_raquo_airstream_core_WritableObservable__addInternalObserver__Lcom_raquo_airstream_core_InternalObserver__Z__V(currentStream, this.Yt, false);
      })));
    }
  }
});
$p.is = (function() {
  $f_Lcom_raquo_airstream_core_BaseObservable__removeInternalObserver__Lcom_raquo_airstream_core_InternalObserver__V(this.Qw, this);
  $p_Lcom_raquo_airstream_flatten_SwitchStream__removeInternalObserverFromCurrentEventStream__V(this);
});
$p.fQ = (function(project) {
  return new $c_Lcom_raquo_airstream_misc_MapStream(this, project, $m_s_None$());
});
$p.ii = (function(isSame) {
  return new $c_Lcom_raquo_airstream_distinct_DistinctStream(this, isSame, false);
});
$p.dM = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_flatten_SwitchStream = new $TypeData().i($c_Lcom_raquo_airstream_flatten_SwitchStream, "com.raquo.airstream.flatten.SwitchStream", ({
  om: 1,
  P: 1,
  O: 1,
  U: 1,
  V: 1,
  al: 1,
  am: 1,
  Z: 1,
  aq: 1,
  a3: 1,
  bl: 1
}));
/** @constructor */
function $c_Lorg_scalajs_dom_DOMList$DOMListSeq(domList) {
  this.a14 = null;
  this.a14 = domList;
}
$p = $c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype = new $h_O();
$p.constructor = $c_Lorg_scalajs_dom_DOMList$DOMListSeq;
/** @constructor */
function $h_Lorg_scalajs_dom_DOMList$DOMListSeq() {
}
$h_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype = $p;
$p.V = (function() {
  return (-1);
});
$p.F = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f);
});
$p.lU = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p);
});
$p.iW = (function(p) {
  return $f_sc_IterableOnceOps__find__F1__s_Option(this, p);
});
$p.hO = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$p.kT = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$p.cR = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
});
$p.k2 = (function(num) {
  return $f_sc_IterableOnceOps__sum__s_math_Numeric__O(this, num);
});
$p.lr = (function(ord) {
  return $f_sc_IterableOnceOps__min__s_math_Ordering__O(this, ord);
});
$p.lq = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord);
});
$p.nw = (function(pf) {
  return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this, pf);
});
$p.lf = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$p.bM = (function() {
  return $m_sci_Nil$().b6(this);
});
$p.d2 = (function() {
  return $m_sci_Vector$().X(this);
});
$p.eX = (function(ev) {
  return $m_sci_Map$().ao(this);
});
$p.iz = (function() {
  return $m_sci_Seq$().fw(this);
});
$p.nG = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$p.t = (function() {
  return this.o().q();
});
$p.dt = (function() {
  return $f_sc_IterableOps__headOption__s_Option(this);
});
$p.bJ = (function() {
  return $f_sc_IterableOps__last__O(this);
});
$p.bw = (function(pred) {
  return $f_sc_IterableOps__filter__F1__O(this, pred);
});
$p.cE = (function(pred) {
  return $f_sc_IterableOps__filterNot__F1__O(this, pred);
});
$p.un = (function(p) {
  return $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(new $c_sc_IterableOps$WithFilter(), this, p);
});
$p.uj = (function(p) {
  return $f_sc_IterableOps__takeWhile__F1__O(this, p);
});
$p.ds = (function(n) {
  return $f_sc_IterableOps__drop__I__O(this, n);
});
$p.cn = (function(n) {
  return $f_sc_IterableOps__dropRight__I__O(this, n);
});
$p.tW = (function(p) {
  return $f_sc_IterableOps__dropWhile__F1__O(this, p);
});
$p.lX = (function() {
  return $f_sc_IterableOps__init__O(this);
});
$p.L = (function(f) {
  return $f_sc_IterableOps__map__F1__O(this, f);
});
$p.c5 = (function(f) {
  return $f_sc_IterableOps__flatMap__F1__O(this, f);
});
$p.dk = (function(asIterable) {
  return $f_sc_IterableOps__flatMap__F1__O(this, asIterable);
});
$p.ct = (function(pf) {
  return $f_sc_IterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.fy = (function(f) {
  return $f_sc_IterableOps__partitionMap__F1__T2(this, f);
});
$p.fa = (function(asPair) {
  return $f_sc_IterableOps__unzip__F1__T2(this, asPair);
});
$p.fS = (function() {
  return $m_sc_Seq$().b5();
});
$p.hM = (function() {
  return "Seq";
});
$p.Ar = (function() {
  return new $c_s_PartialFunction$Lifted(this);
});
$p.aC = (function(x, default$1) {
  return $f_s_PartialFunction__applyOrElse__O__F1__O(this, x, default$1);
});
$p.Eg = (function(action) {
  return $f_s_PartialFunction__runWith__F1__F1(this, action);
});
$p.bv = (function(elem) {
  return $f_sc_SeqOps__appended__O__O(this, elem);
});
$p.gU = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$p.g9 = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$p.aa = (function() {
  return this.C();
});
$p.nz = (function() {
  return $f_sc_SeqOps__distinct__O(this);
});
$p.ko = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f);
});
$p.cx = (function() {
  return $f_sc_IterableOnceOps__reversed__sc_Iterable(this).o();
});
$p.px = (function(p, from) {
  return $f_sc_Iterator__indexWhere__F1__I__I(this.o(), p, from);
});
$p.mN = (function(elem, from) {
  return $f_sc_SeqOps__indexOf__O__I__I(this, elem, from);
});
$p.h9 = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord);
});
$p.nE = (function(otherSize) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, otherSize);
});
$p.bL = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$p.c = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$p.AE = (function(that) {
  return $f_sc_SeqOps__sameElements__sc_IterableOnce__Z(this, that);
});
$p.IG = (function(that) {
  return true;
});
$p.e = (function(o) {
  return $f_sc_Seq__equals__O__Z(this, o);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().a4G(this);
});
$p.m = (function() {
  return $f_sc_Iterable__toString__T(this);
});
$p.C = (function() {
  return (this.a14.length | 0);
});
$p.l = (function(x) {
  return this.a14[x];
});
$p.o = (function() {
  return new $c_Lorg_scalajs_dom_DOMList$DOMListIterator(this.a14);
});
$p.i = (function(v1) {
  return this.l((v1 | 0));
});
$p.cd = (function() {
  return $m_sc_Seq$();
});
$p.aM = (function(x) {
  return $f_sc_SeqOps__isDefinedAt__I__Z(this, (x | 0));
});
$p.fP = (function(coll) {
  return $m_sc_Seq$().Al(coll);
});
$p.iU = (function(v1) {
  return (!(!this.l(v1)));
});
var $d_Lorg_scalajs_dom_DOMList$DOMListSeq = new $TypeData().i($c_Lorg_scalajs_dom_DOMList$DOMListSeq, "org.scalajs.dom.DOMList$DOMListSeq", ({
  Fs: 1,
  e: 1,
  f: 1,
  m: 1,
  l: 1,
  k: 1,
  h: 1,
  i: 1,
  w: 1,
  b: 1,
  H: 1
}));
/** @constructor */
function $c_sc_AbstractSet() {
}
$p = $c_sc_AbstractSet.prototype = new $h_sc_AbstractIterable();
$p.constructor = $c_sc_AbstractSet;
/** @constructor */
function $h_sc_AbstractSet() {
}
$h_sc_AbstractSet.prototype = $p;
$p.e = (function(that) {
  return $f_sc_Set__equals__O__Z(this, that);
});
$p.x = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.Em(this, this$1.Vy);
});
$p.cd = (function() {
  return $m_sc_Set$();
});
$p.el = (function() {
  return "Set";
});
$p.m = (function() {
  return $f_sc_Iterable__toString__T(this);
});
$p.Q0 = (function(that) {
  return this.lV(that);
});
$p.J3 = (function(that) {
  return this.bw(that);
});
$p.dI = (function(that) {
  return $f_sc_SetOps__concat__sc_IterableOnce__sc_SetOps(this, that);
});
$p.iU = (function(v1) {
  return this.E(v1);
});
$p.i = (function(v1) {
  return this.E(v1);
});
function $is_sc_IndexedSeqView(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.aj)));
}
function $isArrayOf_sc_IndexedSeqView(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.aj)));
}
function $f_sc_Map__equals__O__Z($thiz, o) {
  if (($thiz === o)) {
    return true;
  } else if ($is_sc_Map(o)) {
    if (($thiz.aa() === o.aa())) {
      try {
        return $thiz.lV(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x2) => ((kv$2$2) => $m_sr_BoxesRunTime$().Q(x2.ay(kv$2$2.g(), $m_sc_Map$().aHV), kv$2$2.h())))(o)));
      } catch (e) {
        if ((e instanceof $c_jl_ClassCastException)) {
          return false;
        } else {
          throw e;
        }
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
}
function $is_sc_Map(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.as)));
}
function $isArrayOf_sc_Map(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.as)));
}
function $is_sc_MapView(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.bq)));
}
function $isArrayOf_sc_MapView(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bq)));
}
function $p_s_concurrent_impl_Promise$Transformation__handleFailure__jl_Throwable__s_concurrent_ExecutionContext__V($thiz, t, e) {
  if ((false || $m_s_util_control_NonFatal$().ew(t))) {
    var completed = $thiz.JD($thiz.eo, $m_s_concurrent_impl_Promise$().XX(new $c_s_util_Failure(t)));
    if (((($thiz.Vl === 5) || ($thiz.Vl === 6)) || (!completed))) {
      e.ahF(t);
    }
  } else {
    var $x_1 = t;
    throw (($x_1 instanceof $c_sjs_js_JavaScriptException) ? $x_1.bf : $x_1);
  }
}
function $ct_s_concurrent_impl_Promise$Transformation__F1__s_concurrent_ExecutionContext__s_util_Try__I__($thiz, _fun, _ec, _arg, _xform) {
  $thiz.a1U = _fun;
  $thiz.Vk = _ec;
  $thiz.Vj = _arg;
  $thiz.Vl = _xform;
  $ct_s_concurrent_impl_Promise$DefaultPromise__($thiz);
  return $thiz;
}
function $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__($thiz, xform, f, ec) {
  $ct_s_concurrent_impl_Promise$Transformation__F1__s_concurrent_ExecutionContext__s_util_Try__I__($thiz, f, ec, null, xform);
  return $thiz;
}
/** @constructor */
function $c_s_concurrent_impl_Promise$Transformation() {
  this.eo = null;
  this.a1U = null;
  this.Vk = null;
  this.Vj = null;
  this.Vl = 0;
}
$p = $c_s_concurrent_impl_Promise$Transformation.prototype = new $h_s_concurrent_impl_Promise$DefaultPromise();
$p.constructor = $c_s_concurrent_impl_Promise$Transformation;
/** @constructor */
function $h_s_concurrent_impl_Promise$Transformation() {
}
$h_s_concurrent_impl_Promise$Transformation.prototype = $p;
$p.aSy = (function(resolved) {
  this.Vj = resolved;
  var e = this.Vk;
  try {
    e.afA(this);
  } catch (e$2) {
    var e$3 = ((e$2 instanceof $c_jl_Throwable) ? e$2 : new $c_sjs_js_JavaScriptException(e$2));
    this.a1U = null;
    this.Vj = null;
    this.Vk = null;
    $p_s_concurrent_impl_Promise$Transformation__handleFailure__jl_Throwable__s_concurrent_ExecutionContext__V(this, e$3, e);
  }
  return this;
});
$p.Jk = (function() {
  var v = this.Vj;
  var fun = this.a1U;
  var ec = this.Vk;
  this.a1U = null;
  this.Vj = null;
  this.Vk = null;
  try {
    switch (this.Vl) {
      case 0: {
        var resolvedResult = null;
        break;
      }
      case 1: {
        var resolvedResult = ((v instanceof $c_s_util_Success) ? new $c_s_util_Success(fun.i(v.d())) : v);
        break;
      }
      case 2: {
        if ((v instanceof $c_s_util_Success)) {
          var f = fun.i(v.d());
          if ((f instanceof $c_s_concurrent_impl_Promise$DefaultPromise)) {
            f.agV(this, null);
          } else {
            this.af8(f);
          }
          var resolvedResult = null;
        } else {
          var resolvedResult = v;
        }
        break;
      }
      case 3: {
        var resolvedResult = $m_s_concurrent_impl_Promise$().XX(fun.i(v));
        break;
      }
      case 4: {
        var f$2 = fun.i(v);
        if ((f$2 instanceof $c_s_concurrent_impl_Promise$DefaultPromise)) {
          f$2.agV(this, null);
        } else {
          this.af8(f$2);
        }
        var resolvedResult = null;
        break;
      }
      case 5: {
        v.F(fun);
        var resolvedResult = null;
        break;
      }
      case 6: {
        fun.i(v);
        var resolvedResult = null;
        break;
      }
      case 7: {
        var resolvedResult = ((v instanceof $c_s_util_Failure) ? $m_s_concurrent_impl_Promise$().XX(v.ahx(fun)) : v);
        break;
      }
      case 8: {
        if ((v instanceof $c_s_util_Failure)) {
          var f$3 = fun.aC(v.le, $m_s_concurrent_Future$().aIU);
          var resolvedResult = ((f$3 !== $m_s_concurrent_Future$().adc) ? (((f$3 instanceof $c_s_concurrent_impl_Promise$DefaultPromise) ? f$3.agV(this, null) : this.af8(f$3)), null) : v);
        } else {
          var resolvedResult = v;
        }
        break;
      }
      case 9: {
        var resolvedResult = (((v instanceof $c_s_util_Failure) || (!(!fun.i(v.d())))) ? v : $m_s_concurrent_Future$().aIT);
        break;
      }
      case 10: {
        var resolvedResult = ((v instanceof $c_s_util_Success) ? new $c_s_util_Success(fun.aC(v.d(), $m_s_concurrent_Future$().aIR)) : v);
        break;
      }
      default: {
        var resolvedResult = new $c_s_util_Failure($ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), ("BUG: encountered transformation promise with illegal type: " + this.Vl)));
      }
    }
    if ((resolvedResult !== null)) {
      this.JD(this.eo, resolvedResult);
    }
  } catch (e) {
    $p_s_concurrent_impl_Promise$Transformation__handleFailure__jl_Throwable__s_concurrent_ExecutionContext__V(this, ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e)), ec);
  }
});
function $isArrayOf_s_concurrent_impl_Promise$Transformation(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.m3)));
}
var $d_s_concurrent_impl_Promise$Transformation = new $TypeData().i($c_s_concurrent_impl_Promise$Transformation, "scala.concurrent.impl.Promise$Transformation", ({
  m3: 1,
  dW: 1,
  cr: 1,
  a: 1,
  lZ: 1,
  lY: 1,
  lW: 1,
  h: 1,
  cT: 1,
  dc: 1,
  Kt: 1
}));
/** @constructor */
function $c_sr_RichLong(self_$_lo, self_$_hi) {
  this.mG = 0;
  this.mH = 0;
  this.mG = self_$_lo;
  this.mH = self_$_hi;
}
$p = $c_sr_RichLong.prototype = new $h_O();
$p.constructor = $c_sr_RichLong;
/** @constructor */
function $h_sr_RichLong() {
}
$h_sr_RichLong.prototype = $p;
$p.Ap = (function() {
  return true;
});
$p.pp = (function(that) {
  var x_$_lo = this.mG;
  var x_$_hi = this.mH;
  var $x_1 = $uJ(that);
  var y_$_lo = $x_1.l;
  var y_$_hi = $x_1.h;
  return ((x_$_hi === y_$_hi) ? ((x_$_lo === y_$_lo) ? 0 : (((x_$_lo >>> 0) < (y_$_lo >>> 0)) ? (-1) : 1)) : ((x_$_hi < y_$_hi) ? (-1) : 1));
});
$p.m = (function() {
  return $f_s_Proxy__toString__T(this);
});
$p.vY = (function() {
  var this$_$_lo = this.mG;
  var this$_$_hi = this.mH;
  return ((4.294967296E9 * this$_$_hi) + (this$_$_lo >>> 0.0));
});
$p.DX = (function() {
  var this$_$_lo = this.mG;
  var this$_$_hi = this.mH;
  var compressedLo = (((((-2097152) & (this$_$_hi ^ (this$_$_hi >> 10))) === 0) || ((65535 & this$_$_lo) === 0)) ? this$_$_lo : (32768 | ((-32768) & this$_$_lo)));
  return Math.fround(((4.294967296E9 * this$_$_hi) + (compressedLo >>> 0.0)));
});
$p.lY = (function() {
  return $bL(this.mG, this.mH);
});
$p.lm = (function() {
  return $s_RTLong__toInt__I__I__I(this.mG, this.mH);
});
$p.P2 = (function() {
  return (($s_RTLong__toInt__I__I__I(this.mG, this.mH) << 24) >> 24);
});
$p.PT = (function() {
  return (($s_RTLong__toInt__I__I__I(this.mG, this.mH) << 16) >> 16);
});
$p.Xf = (function() {
  return $m_sr_RichLong$().b3s(this.mG, this.mH);
});
$p.Xi = (function() {
  return $m_sr_RichLong$().b3A(this.mG, this.mH);
});
$p.Xg = (function() {
  return $m_sr_RichLong$().b3u(this.mG, this.mH);
});
$p.Pz = (function() {
  return $m_sr_RichLong$().b3y(this.mG, this.mH);
});
$p.x = (function() {
  var this$_$_lo = this.mG;
  var this$_$_hi = this.mH;
  return (this$_$_lo ^ this$_$_hi);
});
$p.e = (function(x$1) {
  return $m_sr_RichLong$().b0J(this.mG, this.mH, x$1);
});
$p.ahX = (function() {
  return $bL(this.mG, this.mH);
});
function $isArrayOf_sr_RichLong(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.mk)));
}
var $d_sr_RichLong = new $TypeData().i($c_sr_RichLong, "scala.runtime.RichLong", ({
  mk: 1,
  LQ: 1,
  M3: 1,
  e0: 1,
  c7: 1,
  dx: 1,
  dw: 1,
  dZ: 1,
  b3: 1,
  Q: 1,
  mh: 1
}));
/** @constructor */
function $c_Lujson_False$() {
}
$p = $c_Lujson_False$.prototype = new $h_Lujson_Bool();
$p.constructor = $c_Lujson_False$;
/** @constructor */
function $h_Lujson_False$() {
}
$h_Lujson_False$.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return 67643651;
});
$p.z = (function() {
  return 0;
});
$p.B = (function() {
  return "False";
});
$p.A = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lujson_False$ = new $TypeData().i($c_Lujson_False$, "ujson.False$", ({
  Ny: 1,
  mI: 1,
  b4: 1,
  ac: 1,
  bk: 1,
  b: 1,
  c: 1,
  a: 1,
  d: 1,
  j: 1,
  r: 1
}));
var $n_Lujson_False$;
function $m_Lujson_False$() {
  if ((!$n_Lujson_False$)) {
    $n_Lujson_False$ = new $c_Lujson_False$();
  }
  return $n_Lujson_False$;
}
/** @constructor */
function $c_Lujson_True$() {
}
$p = $c_Lujson_True$.prototype = new $h_Lujson_Bool();
$p.constructor = $c_Lujson_True$;
/** @constructor */
function $h_Lujson_True$() {
}
$h_Lujson_True$.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return 2615726;
});
$p.z = (function() {
  return 0;
});
$p.B = (function() {
  return "True";
});
$p.A = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lujson_True$ = new $TypeData().i($c_Lujson_True$, "ujson.True$", ({
  NH: 1,
  mI: 1,
  b4: 1,
  ac: 1,
  bk: 1,
  b: 1,
  c: 1,
  a: 1,
  d: 1,
  j: 1,
  r: 1
}));
var $n_Lujson_True$;
function $m_Lujson_True$() {
  if ((!$n_Lujson_True$)) {
    $n_Lujson_True$ = new $c_Lujson_True$();
  }
  return $n_Lujson_True$;
}
/** @constructor */
function $c_Lupack_False$() {
}
$p = $c_Lupack_False$.prototype = new $h_Lupack_Bool();
$p.constructor = $c_Lupack_False$;
/** @constructor */
function $h_Lupack_False$() {
}
$h_Lupack_False$.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return 67643651;
});
$p.m = (function() {
  return "False";
});
$p.z = (function() {
  return 0;
});
$p.B = (function() {
  return "False";
});
$p.A = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lupack_False$ = new $TypeData().i($c_Lupack_False$, "upack.False$", ({
  NK: 1,
  mV: 1,
  aC: 1,
  ac: 1,
  aJ: 1,
  b: 1,
  c: 1,
  a: 1,
  d: 1,
  j: 1,
  r: 1
}));
var $n_Lupack_False$;
function $m_Lupack_False$() {
  if ((!$n_Lupack_False$)) {
    $n_Lupack_False$ = new $c_Lupack_False$();
  }
  return $n_Lupack_False$;
}
/** @constructor */
function $c_Lupack_True$() {
}
$p = $c_Lupack_True$.prototype = new $h_Lupack_Bool();
$p.constructor = $c_Lupack_True$;
/** @constructor */
function $h_Lupack_True$() {
}
$h_Lupack_True$.prototype = $p;
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  return 2615726;
});
$p.m = (function() {
  return "True";
});
$p.z = (function() {
  return 0;
});
$p.B = (function() {
  return "True";
});
$p.A = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.D = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lupack_True$ = new $TypeData().i($c_Lupack_True$, "upack.True$", ({
  NQ: 1,
  mV: 1,
  aC: 1,
  ac: 1,
  aJ: 1,
  b: 1,
  c: 1,
  a: 1,
  d: 1,
  j: 1,
  r: 1
}));
var $n_Lupack_True$;
function $m_Lupack_True$() {
  if ((!$n_Lupack_True$)) {
    $n_Lupack_True$ = new $c_Lupack_True$();
  }
  return $n_Lupack_True$;
}
/** @constructor */
function $c_Lupickle_core_Types$$anon$2(r1$2, w0$4, w1$2, outer) {
  this.adO = null;
  this.aJP = null;
  this.aJQ = null;
  this.Oz = null;
  this.adO = r1$2;
  this.aJP = w0$4;
  this.aJQ = w1$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Oz = outer;
}
$p = $c_Lupickle_core_Types$$anon$2.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_Types$$anon$2;
/** @constructor */
function $h_Lupickle_core_Types$$anon$2() {
}
$h_Lupickle_core_Types$$anon$2.prototype = $p;
$p.ge = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.cy = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.gB = (function() {
  return this;
});
$p.c8 = (function(index) {
  return null;
});
$p.eE = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitTrue__I__O(this, index);
});
$p.eC = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitFalse__I__O(this, index);
});
$p.eD = (function(s, decIndex, expIndex, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64StringParts__jl_CharSequence__I__I__I__O(this, s, decIndex, expIndex, index);
});
$p.e7 = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64__D__I__O(this, d, index);
});
$p.eY = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat32__F__I__O(this, d, index);
});
$p.em = (function(i, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt32__I__I__O(this, i, index);
});
$p.eZ = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.fe = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitUInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.fA = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64String__T__I__O(this, s, index);
});
$p.fc = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitChar__C__I__O(this, s, index);
});
$p.fb = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.fd = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.ej = (function() {
  this.ul();
  return "expected dictionary";
});
$p.cN = (function(s, index) {
  return $f_Lupickle_core_Types$TaggedReader__visitString__jl_CharSequence__I__O(this, s, index);
});
$p.d0 = (function(out, v) {
  return $f_Lupickle_core_Types$TaggedWriter__write0__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.cZ = (function(length, index) {
  return $f_Lupickle_core_Types__taggedArrayContext__Lupickle_core_Types$TaggedReader__I__Lupickle_core_ArrVisitor(this.aTc(), this, index);
});
$p.bQ = (function(length, jsonableKeys, index) {
  return new $c_Lupickle_AttributeTagged$$anon$6(this, index, this.aTc());
});
$p.Js = (function() {
  return this.adO.Js();
});
$p.cT = (function() {
  return this.aJP.cT();
});
$p.IW = (function(s) {
  return this.adO.IW(s);
});
$p.WP = (function(v) {
  return this.aJQ.WP(v);
});
$p.oH = (function() {
  return this.Oz.tN;
});
$p.JH = (function() {
  return this.Oz.tN;
});
$p.ul = (function() {
  return this.Oz.tN;
});
$p.Yf = (function() {
  return this.Oz.tN;
});
$p.aTc = (function() {
  return this.Oz.tN;
});
$p.ha = (function() {
  return this.oH();
});
$p.Ye = (function() {
  return this.JH();
});
$p.ais = (function() {
  return this.ul();
});
$p.a5b = (function() {
  return this.Yf();
});
$p.cW = (function() {
  return this;
});
var $d_Lupickle_core_Types$$anon$2 = new $TypeData().i($c_Lupickle_core_Types$$anon$2, "upickle.core.Types$$anon$2", ({
  OF: 1,
  x: 1,
  D: 1,
  B: 1,
  E: 1,
  cX: 1,
  J: 1,
  K: 1,
  cc: 1,
  cd: 1,
  OM: 1
}));
/** @constructor */
function $c_Lcom_raquo_airstream_combine_CombineSignalN(parents, combinator) {
  this.aiM = null;
  this.aiL = false;
  this.aiN = null;
  this.a5o = 0;
  this.aiJ = null;
  this.aiK = null;
  this.aiQ = false;
  this.a5p = null;
  this.aiG = null;
  this.aiH = false;
  this.Qh = null;
  this.aiI = null;
  this.aiP = 0;
  this.aiO = null;
  this.Qh = parents;
  this.aiI = combinator;
  this.aiM = (void 0);
  $f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  this.a5o = 0;
  $f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.a5p = (void 0);
  this.aiP = ((1 + $m_Lcom_raquo_airstream_core_Protected$().aQe(0, parents)) | 0);
  this.aiO = parents.map(((parent) => $m_Lcom_raquo_airstream_common_InternalParentObserver$().ag9(parent, new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((_$1, trx) => {
    $f_Lcom_raquo_airstream_combine_CombineObservable__onInputsReady__Lcom_raquo_airstream_core_Transaction__V(this, trx);
  })))));
}
$p = $c_Lcom_raquo_airstream_combine_CombineSignalN.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_combine_CombineSignalN;
/** @constructor */
function $h_Lcom_raquo_airstream_combine_CombineSignalN() {
}
$h_Lcom_raquo_airstream_combine_CombineSignalN.prototype = $p;
$p.fx = (function() {
  return this.aiM;
});
$p.eU = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$p.m = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.hR = (function() {
  return this.aiL;
});
$p.h5 = (function() {
  return this.aiN;
});
$p.gb = (function(x$1) {
  this.aiL = x$1;
});
$p.hS = (function(x$1) {
  this.aiN = x$1;
});
$p.e = (function(obj) {
  return (this === obj);
});
$p.x = (function() {
  return $systemIdentityHashCode(this);
});
$p.jk = (function() {
  return this.a5o;
});
$p.xZ = (function(x$1) {
  this.a5o = x$1;
});
$p.dP = (function() {
  return this;
});
$p.ip = (function(observer) {
  observer.mT($f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this));
});
$p.gk = (function() {
  return this.aiJ;
});
$p.gl = (function() {
  return this.aiK;
});
$p.iA = (function() {
  return this.aiQ;
});
$p.hs = (function(x$1) {
  this.aiQ = x$1;
});
$p.ig = (function(x$0) {
  this.aiJ = x$0;
});
$p.ih = (function(x$0) {
  this.aiK = x$0;
});
$p.ye = (function() {
  return this.a5p;
});
$p.At = (function(x$1) {
  this.a5p = x$1;
});
$p.aq = (function() {
  return $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this);
});
$p.ik = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.aLJ = (function() {
  if ((!this.aiH)) {
    this.aiG = $f_Lcom_raquo_airstream_common_MultiParentSignal___parentLastUpdateIds__Lcom_raquo_ew_JsArray(this);
    this.aiH = true;
  }
  return this.aiG;
});
$p.iu = (function() {
  $f_Lcom_raquo_airstream_common_MultiParentSignal__onWillStart__V(this);
});
$p.aSF = (function(transaction) {
  $f_Lcom_raquo_airstream_combine_CombineObservable__syncFire__Lcom_raquo_airstream_core_Transaction__V(this, transaction);
});
$p.ir = (function() {
  $f_Lcom_raquo_airstream_combine_CombineObservable__onStart__V(this);
});
$p.is = (function() {
  $f_Lcom_raquo_airstream_combine_CombineObservable__onStop__V(this);
});
$p.aMK = (function() {
  $f_Lcom_raquo_airstream_core_Signal__onStart__V(this);
});
$p.eB = (function() {
  return this.aiP;
});
$p.ahp = (function() {
  return this.aiO;
});
$p.aPk = (function() {
  return true;
});
$p.a2V = (function() {
  return $m_Lcom_raquo_airstream_combine_CombineObservable$().aPB(this.Qh.map(((_$2) => _$2.aq())), this.aiI);
});
$p.vX = (function() {
  return this.a2V();
});
$p.fQ = (function(project) {
  return $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), this, project, $m_s_None$());
});
$p.ii = (function(isSame) {
  return new $c_Lcom_raquo_airstream_distinct_DistinctSignal(this, isSame, false);
});
$p.dM = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_combine_CombineSignalN = new $TypeData().i($c_Lcom_raquo_airstream_combine_CombineSignalN, "com.raquo.airstream.combine.CombineSignalN", ({
  nA: 1,
  P: 1,
  O: 1,
  U: 1,
  V: 1,
  aB: 1,
  aD: 1,
  Z: 1,
  aS: 1,
  nH: 1,
  ef: 1,
  e7: 1
}));
/** @constructor */
function $c_Lcom_raquo_airstream_combine_SampleCombineStreamN(samplingStream, sampledSignals, combinator) {
  this.aiV = null;
  this.aiU = false;
  this.aiW = null;
  this.aiS = null;
  this.aiT = null;
  this.aj1 = false;
  this.aiZ = null;
  this.aiR = null;
  this.aj0 = 0;
  this.Qi = null;
  this.aiY = null;
  this.aiX = null;
  this.aiZ = sampledSignals;
  this.aiR = combinator;
  this.aiV = (void 0);
  $f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  $f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.aj0 = ((1 + $m_Lcom_raquo_airstream_core_Protected$().b4n(samplingStream, sampledSignals)) | 0);
  this.Qi = (void 0);
  var arr = $m_Lcom_raquo_ew_JsArray$().fu($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_airstream_core_Observable.r().C)([samplingStream])));
  var i = 0;
  var len = (sampledSignals.length | 0);
  while ((i < len)) {
    var sampledSignal = sampledSignals[i];
    (arr.push(sampledSignal) | 0);
    i = ((1 + i) | 0);
  }
  this.aiY = arr;
  var arr$3 = $m_Lcom_raquo_ew_JsArray$().fu($m_sr_ScalaRunTime$().f(new ($d_Lcom_raquo_airstream_common_InternalParentObserver.r().C)([$m_Lcom_raquo_airstream_common_InternalParentObserver$().ag9(samplingStream, new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((nextSamplingValue, trx) => {
    this.Qi = nextSamplingValue;
    $f_Lcom_raquo_airstream_combine_CombineObservable__onInputsReady__Lcom_raquo_airstream_core_Transaction__V(this, trx);
  })))])));
  var i$1 = 0;
  var len$1 = (sampledSignals.length | 0);
  while ((i$1 < len$1)) {
    var sampledSignal$2 = sampledSignals[i$1];
    (arr$3.push($m_Lcom_raquo_airstream_common_InternalParentObserver$().ag9(sampledSignal$2, new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((_$1, _$2) => (void 0))))) | 0);
    i$1 = ((1 + i$1) | 0);
  }
  this.aiX = arr$3;
}
$p = $c_Lcom_raquo_airstream_combine_SampleCombineStreamN.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_combine_SampleCombineStreamN;
/** @constructor */
function $h_Lcom_raquo_airstream_combine_SampleCombineStreamN() {
}
$h_Lcom_raquo_airstream_combine_SampleCombineStreamN.prototype = $p;
$p.fx = (function() {
  return this.aiV;
});
$p.eU = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$p.m = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.hR = (function() {
  return this.aiU;
});
$p.h5 = (function() {
  return this.aiW;
});
$p.gb = (function(x$1) {
  this.aiU = x$1;
});
$p.hS = (function(x$1) {
  this.aiW = x$1;
});
$p.e = (function(obj) {
  return (this === obj);
});
$p.x = (function() {
  return $systemIdentityHashCode(this);
});
$p.ip = (function(observer) {
});
$p.mY = (function() {
  return this;
});
$p.gk = (function() {
  return this.aiS;
});
$p.gl = (function() {
  return this.aiT;
});
$p.iA = (function() {
  return this.aj1;
});
$p.hs = (function(x$1) {
  this.aj1 = x$1;
});
$p.ig = (function(x$0) {
  this.aiS = x$0;
});
$p.ih = (function(x$0) {
  this.aiT = x$0;
});
$p.ik = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.iu = (function() {
  $f_Lcom_raquo_airstream_common_MultiParentStream__onWillStart__V(this);
});
$p.ir = (function() {
  $f_Lcom_raquo_airstream_combine_CombineObservable__onStart__V(this);
});
$p.is = (function() {
  $f_Lcom_raquo_airstream_combine_CombineObservable__onStop__V(this);
});
$p.aMK = (function() {
});
$p.eB = (function() {
  return this.aj0;
});
$p.aPk = (function() {
  return (this.Qi !== (void 0));
});
$p.ahp = (function() {
  return this.aiX;
});
$p.a2V = (function() {
  var $x_2 = $m_Lcom_raquo_ew_JsArray$();
  var $x_1 = $m_sr_ScalaRunTime$();
  var x = this.Qi;
  if ((x === (void 0))) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "undefined.get");
  }
  var values = $x_2.fu($x_1.f(new ($d_s_util_Try.r().C)([x])));
  var arr = this.aiZ;
  var i = 0;
  var len = (arr.length | 0);
  while ((i < len)) {
    var sampledSignal = arr[i];
    (values.push(sampledSignal.aq()) | 0);
    i = ((1 + i) | 0);
  }
  return $m_Lcom_raquo_airstream_combine_CombineObservable$().aPB(values, this.aiR);
});
$p.aSF = (function(transaction) {
  $f_Lcom_raquo_airstream_combine_CombineObservable__syncFire__Lcom_raquo_airstream_core_Transaction__V(this, transaction);
  this.Qi = (void 0);
});
$p.fQ = (function(project) {
  return new $c_Lcom_raquo_airstream_misc_MapStream(this, project, $m_s_None$());
});
$p.ii = (function(isSame) {
  return new $c_Lcom_raquo_airstream_distinct_DistinctStream(this, isSame, false);
});
$p.dM = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_combine_SampleCombineStreamN = new $TypeData().i($c_Lcom_raquo_airstream_combine_SampleCombineStreamN, "com.raquo.airstream.combine.SampleCombineStreamN", ({
  nB: 1,
  P: 1,
  O: 1,
  U: 1,
  V: 1,
  al: 1,
  am: 1,
  Z: 1,
  aq: 1,
  nI: 1,
  ef: 1,
  e7: 1
}));
/** @constructor */
function $c_Lcom_raquo_airstream_distinct_DistinctSignal(parent, isSame, resetOnStop) {
  this.ajt = null;
  this.ajs = false;
  this.aju = null;
  this.a5z = 0;
  this.ajq = null;
  this.ajr = null;
  this.ajy = false;
  this.a5B = null;
  this.ajv = false;
  this.ajp = 0;
  this.a5C = null;
  this.a5A = null;
  this.ajw = false;
  this.ajx = 0;
  this.a5C = parent;
  this.a5A = isSame;
  this.ajw = resetOnStop;
  this.ajt = (void 0);
  $f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  this.a5z = 0;
  $f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.a5B = (void 0);
  $f_Lcom_raquo_airstream_common_SingleParentSignal__$init$__V(this);
  this.ajx = ((1 + parent.eB()) | 0);
}
$p = $c_Lcom_raquo_airstream_distinct_DistinctSignal.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_distinct_DistinctSignal;
/** @constructor */
function $h_Lcom_raquo_airstream_distinct_DistinctSignal() {
}
$h_Lcom_raquo_airstream_distinct_DistinctSignal.prototype = $p;
$p.fx = (function() {
  return this.ajt;
});
$p.eU = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$p.m = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.hR = (function() {
  return this.ajs;
});
$p.h5 = (function() {
  return this.aju;
});
$p.gb = (function(x$1) {
  this.ajs = x$1;
});
$p.hS = (function(x$1) {
  this.aju = x$1;
});
$p.e = (function(obj) {
  return (this === obj);
});
$p.x = (function() {
  return $systemIdentityHashCode(this);
});
$p.jk = (function() {
  return this.a5z;
});
$p.xZ = (function(x$1) {
  this.a5z = x$1;
});
$p.dP = (function() {
  return this;
});
$p.ip = (function(observer) {
  observer.mT($f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this));
});
$p.gk = (function() {
  return this.ajq;
});
$p.gl = (function() {
  return this.ajr;
});
$p.iA = (function() {
  return this.ajy;
});
$p.hs = (function(x$1) {
  this.ajy = x$1;
});
$p.ig = (function(x$0) {
  this.ajq = x$0;
});
$p.ih = (function(x$0) {
  this.ajr = x$0;
});
$p.ye = (function() {
  return this.a5B;
});
$p.At = (function(x$1) {
  this.a5B = x$1;
});
$p.aq = (function() {
  return $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this);
});
$p.ik = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.iY = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_common_InternalTryObserver__onNext__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.iq = (function(nextError, transaction) {
  $f_Lcom_raquo_airstream_common_InternalTryObserver__onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$p.XF = (function() {
  return this.ajv;
});
$p.a2z = (function() {
  return this.ajp;
});
$p.OS = (function(x$1) {
  this.ajp = x$1;
});
$p.a2U = (function(x$0) {
  this.ajv = x$0;
});
$p.iu = (function() {
  $f_Lcom_raquo_airstream_common_SingleParentSignal__onWillStart__V(this);
});
$p.ir = (function() {
  $f_Lcom_raquo_airstream_common_SingleParentSignal__onStart__V(this);
});
$p.is = (function() {
  $f_Lcom_raquo_airstream_common_SingleParentSignal__onStop__V(this);
});
$p.eB = (function() {
  return this.ajx;
});
$p.it = (function(nextParentValue, transaction) {
  $f_Lcom_raquo_airstream_common_SingleParentSignal__onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextParentValue, transaction);
  if ((!(!(!this.a5A.R($f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this), nextParentValue))))) {
    $f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextParentValue, transaction);
  }
});
$p.vX = (function() {
  return this.a5C.aq();
});
$p.Yb = (function(nextValue, nextParentLastUpdateId) {
  if ((this.ajw || (!(!(!this.a5A.R(nextValue, $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this))))))) {
    $f_Lcom_raquo_airstream_common_SingleParentSignal__updateCurrentValueFromParent__s_util_Try__I__V(this, nextValue, nextParentLastUpdateId);
  }
});
$p.ku = (function() {
  return this.a5C;
});
$p.fQ = (function(project) {
  return $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), this, project, $m_s_None$());
});
$p.ii = (function(isSame) {
  return new $c_Lcom_raquo_airstream_distinct_DistinctSignal(this, isSame, false);
});
$p.dM = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_distinct_DistinctSignal = new $TypeData().i($c_Lcom_raquo_airstream_distinct_DistinctSignal, "com.raquo.airstream.distinct.DistinctSignal", ({
  oa: 1,
  P: 1,
  O: 1,
  U: 1,
  V: 1,
  aB: 1,
  aD: 1,
  Z: 1,
  aS: 1,
  a3: 1,
  aK: 1,
  bv: 1
}));
/** @constructor */
function $c_Lcom_raquo_airstream_distinct_DistinctStream(parent, isSame, resetOnStop) {
  this.ajD = null;
  this.ajB = false;
  this.ajE = null;
  this.ajz = null;
  this.ajA = null;
  this.ajH = false;
  this.a5D = null;
  this.ajC = null;
  this.ajF = false;
  this.ajG = 0;
  this.Yp = null;
  this.a5D = parent;
  this.ajC = isSame;
  this.ajF = resetOnStop;
  this.ajD = (void 0);
  $f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  $f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.ajG = ((1 + parent.eB()) | 0);
  this.Yp = (void 0);
}
$p = $c_Lcom_raquo_airstream_distinct_DistinctStream.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_distinct_DistinctStream;
/** @constructor */
function $h_Lcom_raquo_airstream_distinct_DistinctStream() {
}
$h_Lcom_raquo_airstream_distinct_DistinctStream.prototype = $p;
$p.fx = (function() {
  return this.ajD;
});
$p.eU = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$p.m = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.hR = (function() {
  return this.ajB;
});
$p.h5 = (function() {
  return this.ajE;
});
$p.gb = (function(x$1) {
  this.ajB = x$1;
});
$p.hS = (function(x$1) {
  this.ajE = x$1;
});
$p.e = (function(obj) {
  return (this === obj);
});
$p.x = (function() {
  return $systemIdentityHashCode(this);
});
$p.ip = (function(observer) {
});
$p.mY = (function() {
  return this;
});
$p.gk = (function() {
  return this.ajz;
});
$p.gl = (function() {
  return this.ajA;
});
$p.iA = (function() {
  return this.ajH;
});
$p.hs = (function(x$1) {
  this.ajH = x$1;
});
$p.ig = (function(x$0) {
  this.ajz = x$0;
});
$p.ih = (function(x$0) {
  this.ajA = x$0;
});
$p.ik = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.iu = (function() {
  $f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(this.a5D);
});
$p.ir = (function() {
  $f_Lcom_raquo_airstream_common_SingleParentStream__onStart__V(this);
});
$p.iY = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_common_InternalTryObserver__onNext__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.iq = (function(nextError, transaction) {
  $f_Lcom_raquo_airstream_common_InternalTryObserver__onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$p.eB = (function() {
  return this.ajG;
});
$p.it = (function(nextValue, transaction) {
  var x = this.Yp;
  var x$1 = ((x === (void 0)) ? (void 0) : (!(!(!this.ajC.R(x, nextValue)))));
  var isDistinct = ((x$1 === (void 0)) || x$1);
  this.Yp = nextValue;
  if (isDistinct) {
    $f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
  }
});
$p.is = (function() {
  if (this.ajF) {
    this.Yp = (void 0);
  }
  $f_Lcom_raquo_airstream_common_SingleParentStream__onStop__V(this);
});
$p.ku = (function() {
  return this.a5D;
});
$p.fQ = (function(project) {
  return new $c_Lcom_raquo_airstream_misc_MapStream(this, project, $m_s_None$());
});
$p.ii = (function(isSame) {
  return new $c_Lcom_raquo_airstream_distinct_DistinctStream(this, isSame, false);
});
$p.dM = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_distinct_DistinctStream = new $TypeData().i($c_Lcom_raquo_airstream_distinct_DistinctStream, "com.raquo.airstream.distinct.DistinctStream", ({
  ob: 1,
  P: 1,
  O: 1,
  U: 1,
  V: 1,
  al: 1,
  am: 1,
  Z: 1,
  aq: 1,
  a3: 1,
  b6: 1,
  aK: 1
}));
/** @constructor */
function $c_Lcom_raquo_airstream_misc_CollectStream(parent, fn) {
  this.akj = null;
  this.aki = false;
  this.akk = null;
  this.akf = null;
  this.akh = null;
  this.akm = false;
  this.a5I = null;
  this.akg = null;
  this.akl = 0;
  this.a5I = parent;
  this.akg = fn;
  this.akj = (void 0);
  $f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  $f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.akl = ((1 + parent.eB()) | 0);
}
$p = $c_Lcom_raquo_airstream_misc_CollectStream.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_misc_CollectStream;
/** @constructor */
function $h_Lcom_raquo_airstream_misc_CollectStream() {
}
$h_Lcom_raquo_airstream_misc_CollectStream.prototype = $p;
$p.fx = (function() {
  return this.akj;
});
$p.eU = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$p.m = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.hR = (function() {
  return this.aki;
});
$p.h5 = (function() {
  return this.akk;
});
$p.gb = (function(x$1) {
  this.aki = x$1;
});
$p.hS = (function(x$1) {
  this.akk = x$1;
});
$p.e = (function(obj) {
  return (this === obj);
});
$p.x = (function() {
  return $systemIdentityHashCode(this);
});
$p.ip = (function(observer) {
});
$p.mY = (function() {
  return this;
});
$p.gk = (function() {
  return this.akf;
});
$p.gl = (function() {
  return this.akh;
});
$p.iA = (function() {
  return this.akm;
});
$p.hs = (function(x$1) {
  this.akm = x$1;
});
$p.ig = (function(x$0) {
  this.akf = x$0;
});
$p.ih = (function(x$0) {
  this.akh = x$0;
});
$p.ik = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.iu = (function() {
  $f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(this.a5I);
});
$p.ir = (function() {
  $f_Lcom_raquo_airstream_common_SingleParentStream__onStart__V(this);
});
$p.is = (function() {
  $f_Lcom_raquo_airstream_common_SingleParentStream__onStop__V(this);
});
$p.it = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_common_InternalNextErrorObserver__onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.eB = (function() {
  return this.akl;
});
$p.iY = (function(nextParentValue, transaction) {
  try {
    var $x_1 = new $c_s_util_Success(this.akg.i(nextParentValue));
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    matchEnd8: {
      var $x_1;
      if ($m_s_util_control_NonFatal$().ew(e$2)) {
        var $x_1 = new $c_s_util_Failure(e$2);
        break matchEnd8;
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
    }
  }
  $x_1.kO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => {
    $f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, _$1, transaction);
  })), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((nextValue) => {
    if ((!nextValue.c())) {
      $f_Lcom_raquo_airstream_core_WritableStream__fireValue__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue.d(), transaction);
    }
  })));
});
$p.iq = (function(nextError, transaction) {
  $f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$p.ku = (function() {
  return this.a5I;
});
$p.fQ = (function(project) {
  return new $c_Lcom_raquo_airstream_misc_MapStream(this, project, $m_s_None$());
});
$p.ii = (function(isSame) {
  return new $c_Lcom_raquo_airstream_distinct_DistinctStream(this, isSame, false);
});
$p.dM = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_misc_CollectStream = new $TypeData().i($c_Lcom_raquo_airstream_misc_CollectStream, "com.raquo.airstream.misc.CollectStream", ({
  on: 1,
  P: 1,
  O: 1,
  U: 1,
  V: 1,
  al: 1,
  am: 1,
  Z: 1,
  aq: 1,
  a3: 1,
  b6: 1,
  bl: 1
}));
/** @constructor */
function $c_Lcom_raquo_airstream_misc_DropStream(parent, dropWhile, reset, resetOnStop) {
  this.akr = null;
  this.akq = false;
  this.aks = null;
  this.ako = null;
  this.akp = null;
  this.akw = false;
  this.a5J = null;
  this.akn = null;
  this.akt = null;
  this.aku = false;
  this.akv = 0;
  this.Yv = false;
  this.a5J = parent;
  this.akn = dropWhile;
  this.akt = reset;
  this.aku = resetOnStop;
  this.akr = (void 0);
  $f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  $f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.akv = ((1 + parent.eB()) | 0);
  this.Yv = false;
}
$p = $c_Lcom_raquo_airstream_misc_DropStream.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_misc_DropStream;
/** @constructor */
function $h_Lcom_raquo_airstream_misc_DropStream() {
}
$h_Lcom_raquo_airstream_misc_DropStream.prototype = $p;
$p.fx = (function() {
  return this.akr;
});
$p.eU = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$p.m = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.hR = (function() {
  return this.akq;
});
$p.h5 = (function() {
  return this.aks;
});
$p.gb = (function(x$1) {
  this.akq = x$1;
});
$p.hS = (function(x$1) {
  this.aks = x$1;
});
$p.e = (function(obj) {
  return (this === obj);
});
$p.x = (function() {
  return $systemIdentityHashCode(this);
});
$p.ip = (function(observer) {
});
$p.mY = (function() {
  return this;
});
$p.gk = (function() {
  return this.ako;
});
$p.gl = (function() {
  return this.akp;
});
$p.iA = (function() {
  return this.akw;
});
$p.hs = (function(x$1) {
  this.akw = x$1;
});
$p.ig = (function(x$0) {
  this.ako = x$0;
});
$p.ih = (function(x$0) {
  this.akp = x$0;
});
$p.ik = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.iu = (function() {
  $f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(this.a5J);
});
$p.ir = (function() {
  $f_Lcom_raquo_airstream_common_SingleParentStream__onStart__V(this);
});
$p.it = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_common_InternalNextErrorObserver__onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.eB = (function() {
  return this.akv;
});
$p.iY = (function(nextValue, transaction) {
  if ((!this.Yv)) {
    var dropNext = (!(!this.akn.i(nextValue)));
    this.Yv = (!dropNext);
    var $x_1 = dropNext;
  } else {
    var $x_1 = false;
  }
  if ((!$x_1)) {
    $f_Lcom_raquo_airstream_core_WritableStream__fireValue__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
  }
});
$p.iq = (function(nextError, transaction) {
  $f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$p.is = (function() {
  if (this.aku) {
    this.Yv = false;
    this.akt.a3();
  }
  $f_Lcom_raquo_airstream_common_SingleParentStream__onStop__V(this);
});
$p.ku = (function() {
  return this.a5J;
});
$p.fQ = (function(project) {
  return new $c_Lcom_raquo_airstream_misc_MapStream(this, project, $m_s_None$());
});
$p.ii = (function(isSame) {
  return new $c_Lcom_raquo_airstream_distinct_DistinctStream(this, isSame, false);
});
$p.dM = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_misc_DropStream = new $TypeData().i($c_Lcom_raquo_airstream_misc_DropStream, "com.raquo.airstream.misc.DropStream", ({
  oo: 1,
  P: 1,
  O: 1,
  U: 1,
  V: 1,
  al: 1,
  am: 1,
  Z: 1,
  aq: 1,
  a3: 1,
  b6: 1,
  bl: 1
}));
/** @constructor */
function $c_Lcom_raquo_airstream_misc_FilterStream(parent, passes) {
  this.akA = null;
  this.akz = false;
  this.akB = null;
  this.akx = null;
  this.aky = null;
  this.akE = false;
  this.a5K = null;
  this.akC = null;
  this.akD = 0;
  this.a5K = parent;
  this.akC = passes;
  this.akA = (void 0);
  $f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  $f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.akD = ((1 + parent.eB()) | 0);
}
$p = $c_Lcom_raquo_airstream_misc_FilterStream.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_misc_FilterStream;
/** @constructor */
function $h_Lcom_raquo_airstream_misc_FilterStream() {
}
$h_Lcom_raquo_airstream_misc_FilterStream.prototype = $p;
$p.fx = (function() {
  return this.akA;
});
$p.eU = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$p.m = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.hR = (function() {
  return this.akz;
});
$p.h5 = (function() {
  return this.akB;
});
$p.gb = (function(x$1) {
  this.akz = x$1;
});
$p.hS = (function(x$1) {
  this.akB = x$1;
});
$p.e = (function(obj) {
  return (this === obj);
});
$p.x = (function() {
  return $systemIdentityHashCode(this);
});
$p.ip = (function(observer) {
});
$p.mY = (function() {
  return this;
});
$p.gk = (function() {
  return this.akx;
});
$p.gl = (function() {
  return this.aky;
});
$p.iA = (function() {
  return this.akE;
});
$p.hs = (function(x$1) {
  this.akE = x$1;
});
$p.ig = (function(x$0) {
  this.akx = x$0;
});
$p.ih = (function(x$0) {
  this.aky = x$0;
});
$p.ik = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.iu = (function() {
  $f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(this.a5K);
});
$p.ir = (function() {
  $f_Lcom_raquo_airstream_common_SingleParentStream__onStart__V(this);
});
$p.is = (function() {
  $f_Lcom_raquo_airstream_common_SingleParentStream__onStop__V(this);
});
$p.it = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_common_InternalNextErrorObserver__onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.eB = (function() {
  return this.akD;
});
$p.iY = (function(nextParentValue, transaction) {
  try {
    var $x_1 = new $c_s_util_Success((!(!this.akC.i(nextParentValue))));
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    matchEnd8: {
      var $x_1;
      if ($m_s_util_control_NonFatal$().ew(e$2)) {
        var $x_1 = new $c_s_util_Failure(e$2);
        break matchEnd8;
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
    }
  }
  $x_1.kO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => {
    $f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, _$1, transaction);
  })), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((v1) => {
    if ((!(!v1))) {
      $f_Lcom_raquo_airstream_core_WritableStream__fireValue__O__Lcom_raquo_airstream_core_Transaction__V(this, nextParentValue, transaction);
    }
  })));
});
$p.iq = (function(nextError, transaction) {
  $f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$p.ku = (function() {
  return this.a5K;
});
$p.fQ = (function(project) {
  return new $c_Lcom_raquo_airstream_misc_MapStream(this, project, $m_s_None$());
});
$p.ii = (function(isSame) {
  return new $c_Lcom_raquo_airstream_distinct_DistinctStream(this, isSame, false);
});
$p.dM = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_misc_FilterStream = new $TypeData().i($c_Lcom_raquo_airstream_misc_FilterStream, "com.raquo.airstream.misc.FilterStream", ({
  op: 1,
  P: 1,
  O: 1,
  U: 1,
  V: 1,
  al: 1,
  am: 1,
  Z: 1,
  aq: 1,
  a3: 1,
  b6: 1,
  bl: 1
}));
function $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__($thiz, parent, project, recover) {
  $thiz.YB = parent;
  $thiz.QA = project;
  $thiz.QB = recover;
  $thiz.Yz = (void 0);
  $f_Lcom_raquo_airstream_core_BaseObservable__$init$__V($thiz);
  $thiz.Qx = 0;
  $f_Lcom_raquo_airstream_core_WritableObservable__$init$__V($thiz);
  $thiz.Qz = (void 0);
  $f_Lcom_raquo_airstream_common_SingleParentSignal__$init$__V($thiz);
  $thiz.YD = ((1 + parent.eB()) | 0);
  return $thiz;
}
/** @constructor */
function $c_Lcom_raquo_airstream_misc_MapSignal() {
  this.Yz = null;
  this.Yy = false;
  this.YA = null;
  this.Qx = 0;
  this.Yw = null;
  this.Yx = null;
  this.YE = false;
  this.Qz = null;
  this.YC = false;
  this.Qy = 0;
  this.YB = null;
  this.QA = null;
  this.QB = null;
  this.YD = 0;
}
$p = $c_Lcom_raquo_airstream_misc_MapSignal.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_misc_MapSignal;
/** @constructor */
function $h_Lcom_raquo_airstream_misc_MapSignal() {
}
$h_Lcom_raquo_airstream_misc_MapSignal.prototype = $p;
$p.fx = (function() {
  return this.Yz;
});
$p.eU = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$p.m = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.hR = (function() {
  return this.Yy;
});
$p.h5 = (function() {
  return this.YA;
});
$p.gb = (function(x$1) {
  this.Yy = x$1;
});
$p.hS = (function(x$1) {
  this.YA = x$1;
});
$p.e = (function(obj) {
  return (this === obj);
});
$p.x = (function() {
  return $systemIdentityHashCode(this);
});
$p.jk = (function() {
  return this.Qx;
});
$p.xZ = (function(x$1) {
  this.Qx = x$1;
});
$p.dP = (function() {
  return this;
});
$p.ip = (function(observer) {
  observer.mT(this.aq());
});
$p.gk = (function() {
  return this.Yw;
});
$p.gl = (function() {
  return this.Yx;
});
$p.iA = (function() {
  return this.YE;
});
$p.hs = (function(x$1) {
  this.YE = x$1;
});
$p.ig = (function(x$0) {
  this.Yw = x$0;
});
$p.ih = (function(x$0) {
  this.Yx = x$0;
});
$p.ye = (function() {
  return this.Qz;
});
$p.At = (function(x$1) {
  this.Qz = x$1;
});
$p.aq = (function() {
  return $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this);
});
$p.ik = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.iY = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_common_InternalTryObserver__onNext__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.iq = (function(nextError, transaction) {
  $f_Lcom_raquo_airstream_common_InternalTryObserver__onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$p.XF = (function() {
  return this.YC;
});
$p.a2z = (function() {
  return this.Qy;
});
$p.OS = (function(x$1) {
  this.Qy = x$1;
});
$p.a2U = (function(x$0) {
  this.YC = x$0;
});
$p.iu = (function() {
  $f_Lcom_raquo_airstream_common_SingleParentSignal__onWillStart__V(this);
});
$p.Yb = (function(nextValue, nextParentLastUpdateId) {
  $f_Lcom_raquo_airstream_common_SingleParentSignal__updateCurrentValueFromParent__s_util_Try__I__V(this, nextValue, nextParentLastUpdateId);
});
$p.ir = (function() {
  $f_Lcom_raquo_airstream_common_SingleParentSignal__onStart__V(this);
});
$p.is = (function() {
  $f_Lcom_raquo_airstream_common_SingleParentSignal__onStop__V(this);
});
$p.aho = (function() {
  return this.YB;
});
$p.eB = (function() {
  return this.YD;
});
$p.it = (function(nextParentValue, transaction) {
  $f_Lcom_raquo_airstream_common_SingleParentSignal__onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextParentValue, transaction);
  nextParentValue.kO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((nextError) => {
    var this$2 = this.QB;
    if (this$2.c()) {
      $f_Lcom_raquo_airstream_core_WritableSignal__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
    } else {
      var x0 = this$2.d();
      try {
        var $x_1 = new $c_s_util_Success(x0.aC(nextError, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => null))));
      } catch (e) {
        var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
        matchEnd8: {
          var $x_1;
          if ($m_s_util_control_NonFatal$().ew(e$2)) {
            var $x_1 = new $c_s_util_Failure(e$2);
            break matchEnd8;
          }
          throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
        }
      }
      $x_1.kO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((nextError$3$3) => ((tryError) => {
        $f_Lcom_raquo_airstream_core_WritableSignal__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, new $c_Lcom_raquo_airstream_core_AirstreamError$ErrorHandlingError(tryError, nextError$3$3), transaction);
      }))(nextError)), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((nextError$3$4) => ((nextValue) => {
        if ((nextValue === null)) {
          $f_Lcom_raquo_airstream_core_WritableSignal__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError$3$4, transaction);
        } else if ((!nextValue.c())) {
          $f_Lcom_raquo_airstream_core_WritableSignal__fireValue__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue.d(), transaction);
        }
      }))(nextError)));
    }
  })), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$3) => {
    $f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextParentValue.ua(this.QA), transaction);
  })));
});
$p.vX = (function() {
  var originalValue = this.aho().aq().ua(this.QA);
  return originalValue.kO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((nextError) => {
    var this$2 = this.QB;
    if (this$2.c()) {
      return originalValue;
    } else {
      var x0 = this$2.d();
      try {
        var $x_1 = new $c_s_util_Success(x0.aC(nextError, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$4) => null))));
      } catch (e) {
        var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
        matchEnd8: {
          var $x_1;
          if ($m_s_util_control_NonFatal$().ew(e$2)) {
            var $x_1 = new $c_s_util_Failure(e$2);
            break matchEnd8;
          }
          throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
        }
      }
      return $x_1.kO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((nextError$7$3) => ((tryError) => new $c_s_util_Failure(new $c_Lcom_raquo_airstream_core_AirstreamError$ErrorHandlingError(tryError, nextError$7$3))))(nextError)), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((nextValue) => {
        if ((nextValue === null)) {
          return originalValue;
        } else {
          var this$7 = (nextValue.c() ? $m_s_None$() : new $c_s_Some(new $c_s_util_Success(nextValue.d())));
          return (this$7.c() ? originalValue : this$7.d());
        }
      })));
    }
  })), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$6) => originalValue)));
});
$p.ku = (function() {
  return this.aho();
});
$p.fQ = (function(project) {
  return $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), this, project, $m_s_None$());
});
$p.ii = (function(isSame) {
  return new $c_Lcom_raquo_airstream_distinct_DistinctSignal(this, isSame, false);
});
$p.dM = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_misc_MapSignal = new $TypeData().i($c_Lcom_raquo_airstream_misc_MapSignal, "com.raquo.airstream.misc.MapSignal", ({
  d3: 1,
  P: 1,
  O: 1,
  U: 1,
  V: 1,
  aB: 1,
  aD: 1,
  Z: 1,
  aS: 1,
  a3: 1,
  aK: 1,
  bv: 1
}));
/** @constructor */
function $c_Lcom_raquo_airstream_misc_MapStream(parent, project, recover) {
  this.akI = null;
  this.akH = false;
  this.akJ = null;
  this.akF = null;
  this.akG = null;
  this.akN = false;
  this.a5L = null;
  this.akK = null;
  this.akL = null;
  this.akM = 0;
  this.a5L = parent;
  this.akK = project;
  this.akL = recover;
  this.akI = (void 0);
  $f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  $f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.akM = ((1 + parent.eB()) | 0);
}
$p = $c_Lcom_raquo_airstream_misc_MapStream.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_misc_MapStream;
/** @constructor */
function $h_Lcom_raquo_airstream_misc_MapStream() {
}
$h_Lcom_raquo_airstream_misc_MapStream.prototype = $p;
$p.fx = (function() {
  return this.akI;
});
$p.eU = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$p.m = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.hR = (function() {
  return this.akH;
});
$p.h5 = (function() {
  return this.akJ;
});
$p.gb = (function(x$1) {
  this.akH = x$1;
});
$p.hS = (function(x$1) {
  this.akJ = x$1;
});
$p.e = (function(obj) {
  return (this === obj);
});
$p.x = (function() {
  return $systemIdentityHashCode(this);
});
$p.ip = (function(observer) {
});
$p.mY = (function() {
  return this;
});
$p.gk = (function() {
  return this.akF;
});
$p.gl = (function() {
  return this.akG;
});
$p.iA = (function() {
  return this.akN;
});
$p.hs = (function(x$1) {
  this.akN = x$1;
});
$p.ig = (function(x$0) {
  this.akF = x$0;
});
$p.ih = (function(x$0) {
  this.akG = x$0;
});
$p.ik = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.iu = (function() {
  $f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(this.a5L);
});
$p.ir = (function() {
  $f_Lcom_raquo_airstream_common_SingleParentStream__onStart__V(this);
});
$p.is = (function() {
  $f_Lcom_raquo_airstream_common_SingleParentStream__onStop__V(this);
});
$p.it = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_common_InternalNextErrorObserver__onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.ku = (function() {
  return this.a5L;
});
$p.eB = (function() {
  return this.akM;
});
$p.iY = (function(nextParentValue, transaction) {
  try {
    var $x_1 = new $c_s_util_Success(this.akK.i(nextParentValue));
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    matchEnd8: {
      var $x_1;
      if ($m_s_util_control_NonFatal$().ew(e$2)) {
        var $x_1 = new $c_s_util_Failure(e$2);
        break matchEnd8;
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
    }
  }
  $x_1.kO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => {
    this.iq(_$1, transaction);
  })), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => {
    $f_Lcom_raquo_airstream_core_WritableStream__fireValue__O__Lcom_raquo_airstream_core_Transaction__V(this, _$2, transaction);
  })));
});
$p.iq = (function(nextError, transaction) {
  var this$1 = this.akL;
  if (this$1.c()) {
    $f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
  } else {
    var x0 = this$1.d();
    try {
      var $x_1 = new $c_s_util_Success(x0.aC(nextError, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$3) => null))));
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      matchEnd8: {
        var $x_1;
        if ($m_s_util_control_NonFatal$().ew(e$2)) {
          var $x_1 = new $c_s_util_Failure(e$2);
          break matchEnd8;
        }
        throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
      }
    }
    $x_1.kO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((tryError) => {
      $f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, new $c_Lcom_raquo_airstream_core_AirstreamError$ErrorHandlingError(tryError, nextError), transaction);
    })), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((nextValue) => {
      if ((nextValue === null)) {
        $f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
      } else if ((!nextValue.c())) {
        $f_Lcom_raquo_airstream_core_WritableStream__fireValue__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue.d(), transaction);
      }
    })));
  }
});
$p.fQ = (function(project) {
  return new $c_Lcom_raquo_airstream_misc_MapStream(this, project, $m_s_None$());
});
$p.ii = (function(isSame) {
  return new $c_Lcom_raquo_airstream_distinct_DistinctStream(this, isSame, false);
});
$p.dM = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_misc_MapStream = new $TypeData().i($c_Lcom_raquo_airstream_misc_MapStream, "com.raquo.airstream.misc.MapStream", ({
  oq: 1,
  P: 1,
  O: 1,
  U: 1,
  V: 1,
  al: 1,
  am: 1,
  Z: 1,
  aq: 1,
  a3: 1,
  b6: 1,
  bl: 1
}));
/** @constructor */
function $c_Lcom_raquo_airstream_misc_ScanLeftSignal(parent, makeInitialValue, fn) {
  this.akS = null;
  this.akR = false;
  this.akT = null;
  this.a5M = 0;
  this.akP = null;
  this.akQ = null;
  this.akV = false;
  this.QC = null;
  this.a5Q = false;
  this.akO = 0;
  this.a5P = null;
  this.a5O = null;
  this.a5N = null;
  this.akU = 0;
  this.a5P = parent;
  this.a5O = makeInitialValue;
  this.a5N = fn;
  this.akS = (void 0);
  $f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  this.a5M = 0;
  $f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.QC = (void 0);
  $f_Lcom_raquo_airstream_common_SingleParentSignal__$init$__V(this);
  this.akU = ((1 + parent.eB()) | 0);
}
$p = $c_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_misc_ScanLeftSignal;
/** @constructor */
function $h_Lcom_raquo_airstream_misc_ScanLeftSignal() {
}
$h_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype = $p;
$p.fx = (function() {
  return this.akS;
});
$p.eU = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$p.m = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.hR = (function() {
  return this.akR;
});
$p.h5 = (function() {
  return this.akT;
});
$p.gb = (function(x$1) {
  this.akR = x$1;
});
$p.hS = (function(x$1) {
  this.akT = x$1;
});
$p.e = (function(obj) {
  return (this === obj);
});
$p.x = (function() {
  return $systemIdentityHashCode(this);
});
$p.jk = (function() {
  return this.a5M;
});
$p.xZ = (function(x$1) {
  this.a5M = x$1;
});
$p.dP = (function() {
  return this;
});
$p.ip = (function(observer) {
  observer.mT($f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this));
});
$p.gk = (function() {
  return this.akP;
});
$p.gl = (function() {
  return this.akQ;
});
$p.iA = (function() {
  return this.akV;
});
$p.hs = (function(x$1) {
  this.akV = x$1;
});
$p.ig = (function(x$0) {
  this.akP = x$0;
});
$p.ih = (function(x$0) {
  this.akQ = x$0;
});
$p.ye = (function() {
  return this.QC;
});
$p.At = (function(x$1) {
  this.QC = x$1;
});
$p.aq = (function() {
  return $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this);
});
$p.ik = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.iY = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_common_InternalTryObserver__onNext__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.iq = (function(nextError, transaction) {
  $f_Lcom_raquo_airstream_common_InternalTryObserver__onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$p.XF = (function() {
  return this.a5Q;
});
$p.a2z = (function() {
  return this.akO;
});
$p.OS = (function(x$1) {
  this.akO = x$1;
});
$p.a2U = (function(x$0) {
  this.a5Q = x$0;
});
$p.iu = (function() {
  $f_Lcom_raquo_airstream_common_SingleParentSignal__onWillStart__V(this);
});
$p.Yb = (function(nextValue, nextParentLastUpdateId) {
  $f_Lcom_raquo_airstream_common_SingleParentSignal__updateCurrentValueFromParent__s_util_Try__I__V(this, nextValue, nextParentLastUpdateId);
});
$p.ir = (function() {
  $f_Lcom_raquo_airstream_common_SingleParentSignal__onStart__V(this);
});
$p.is = (function() {
  $f_Lcom_raquo_airstream_common_SingleParentSignal__onStop__V(this);
});
$p.ku = (function() {
  return this.a5P;
});
$p.eB = (function() {
  return this.akU;
});
$p.vX = (function() {
  if (this.a5Q) {
    var parentSignal = this.a5P;
    var x = this.QC;
    var x$1 = ((x === (void 0)) ? (void 0) : this.a5N.R(x, parentSignal.aq()));
    var default$1 = this.a5O;
    return ((x$1 === (void 0)) ? default$1.a3() : x$1);
  } else {
    var x$2 = this.QC;
    var default$2 = this.a5O;
    return ((x$2 === (void 0)) ? default$2.a3() : x$2);
  }
});
$p.it = (function(nextParentValue, transaction) {
  $f_Lcom_raquo_airstream_common_SingleParentSignal__onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextParentValue, transaction);
  $f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, this.a5N.R($f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this), nextParentValue), transaction);
});
$p.fQ = (function(project) {
  return $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), this, project, $m_s_None$());
});
$p.ii = (function(isSame) {
  return new $c_Lcom_raquo_airstream_distinct_DistinctSignal(this, isSame, false);
});
$p.dM = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_misc_ScanLeftSignal = new $TypeData().i($c_Lcom_raquo_airstream_misc_ScanLeftSignal, "com.raquo.airstream.misc.ScanLeftSignal", ({
  or: 1,
  P: 1,
  O: 1,
  U: 1,
  V: 1,
  aB: 1,
  aD: 1,
  Z: 1,
  aS: 1,
  a3: 1,
  aK: 1,
  bv: 1
}));
function $p_Lcom_raquo_airstream_misc_SignalFromStream__maybeCurrentValueFromParent__O($thiz) {
  return (($thiz.YF === (void 0)) ? $thiz.a5U.a3() : (((!$thiz.a5S) && (!$thiz.akX)) ? $thiz.a5U.a3() : (void 0)));
}
/** @constructor */
function $c_Lcom_raquo_airstream_misc_SignalFromStream(parent, pullInitialValue, cacheInitialValue) {
  this.al1 = null;
  this.al0 = false;
  this.al2 = null;
  this.a5R = 0;
  this.akY = null;
  this.akZ = null;
  this.al5 = false;
  this.YF = null;
  this.al3 = false;
  this.akW = 0;
  this.a5T = null;
  this.a5U = null;
  this.akX = false;
  this.a5S = false;
  this.al4 = 0;
  this.a5T = parent;
  this.a5U = pullInitialValue;
  this.akX = cacheInitialValue;
  this.al1 = (void 0);
  $f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  this.a5R = 0;
  $f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.YF = (void 0);
  $f_Lcom_raquo_airstream_common_SingleParentSignal__$init$__V(this);
  this.a5S = false;
  this.al4 = ((1 + parent.eB()) | 0);
}
$p = $c_Lcom_raquo_airstream_misc_SignalFromStream.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_misc_SignalFromStream;
/** @constructor */
function $h_Lcom_raquo_airstream_misc_SignalFromStream() {
}
$h_Lcom_raquo_airstream_misc_SignalFromStream.prototype = $p;
$p.fx = (function() {
  return this.al1;
});
$p.eU = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$p.m = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.hR = (function() {
  return this.al0;
});
$p.h5 = (function() {
  return this.al2;
});
$p.gb = (function(x$1) {
  this.al0 = x$1;
});
$p.hS = (function(x$1) {
  this.al2 = x$1;
});
$p.e = (function(obj) {
  return (this === obj);
});
$p.x = (function() {
  return $systemIdentityHashCode(this);
});
$p.jk = (function() {
  return this.a5R;
});
$p.xZ = (function(x$1) {
  this.a5R = x$1;
});
$p.dP = (function() {
  return this;
});
$p.ip = (function(observer) {
  observer.mT($f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this));
});
$p.gk = (function() {
  return this.akY;
});
$p.gl = (function() {
  return this.akZ;
});
$p.iA = (function() {
  return this.al5;
});
$p.hs = (function(x$1) {
  this.al5 = x$1;
});
$p.ig = (function(x$0) {
  this.akY = x$0;
});
$p.ih = (function(x$0) {
  this.akZ = x$0;
});
$p.ye = (function() {
  return this.YF;
});
$p.At = (function(x$1) {
  this.YF = x$1;
});
$p.aq = (function() {
  return $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this);
});
$p.ik = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.iY = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_common_InternalTryObserver__onNext__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.iq = (function(nextError, transaction) {
  $f_Lcom_raquo_airstream_common_InternalTryObserver__onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$p.XF = (function() {
  return this.al3;
});
$p.a2z = (function() {
  return this.akW;
});
$p.OS = (function(x$1) {
  this.akW = x$1;
});
$p.a2U = (function(x$0) {
  this.al3 = x$0;
});
$p.Yb = (function(nextValue, nextParentLastUpdateId) {
  $f_Lcom_raquo_airstream_common_SingleParentSignal__updateCurrentValueFromParent__s_util_Try__I__V(this, nextValue, nextParentLastUpdateId);
});
$p.ir = (function() {
  $f_Lcom_raquo_airstream_common_SingleParentSignal__onStart__V(this);
});
$p.is = (function() {
  $f_Lcom_raquo_airstream_common_SingleParentSignal__onStop__V(this);
});
$p.eB = (function() {
  return this.al4;
});
$p.iu = (function() {
  $f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(this.a5T);
  var x = $p_Lcom_raquo_airstream_misc_SignalFromStream__maybeCurrentValueFromParent__O(this);
  if ((x !== (void 0))) {
    $f_Lcom_raquo_airstream_core_WritableSignal__setCurrentValue__s_util_Try__V(this, x);
  }
});
$p.vX = (function() {
  var x = $p_Lcom_raquo_airstream_misc_SignalFromStream__maybeCurrentValueFromParent__O(this);
  return ((x === (void 0)) ? $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this) : x);
});
$p.it = (function(nextParentValue, transaction) {
  this.a5S = true;
  $f_Lcom_raquo_airstream_common_SingleParentSignal__onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextParentValue, transaction);
  $f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextParentValue, transaction);
});
$p.ku = (function() {
  return this.a5T;
});
$p.fQ = (function(project) {
  return $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), this, project, $m_s_None$());
});
$p.ii = (function(isSame) {
  return new $c_Lcom_raquo_airstream_distinct_DistinctSignal(this, isSame, false);
});
$p.dM = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_misc_SignalFromStream = new $TypeData().i($c_Lcom_raquo_airstream_misc_SignalFromStream, "com.raquo.airstream.misc.SignalFromStream", ({
  os: 1,
  P: 1,
  O: 1,
  U: 1,
  V: 1,
  aB: 1,
  aD: 1,
  Z: 1,
  aS: 1,
  a3: 1,
  aK: 1,
  bv: 1
}));
/** @constructor */
function $c_Lcom_raquo_airstream_misc_StreamFromSignal(parent, changesOnly) {
  this.ala = null;
  this.al9 = false;
  this.alb = null;
  this.al7 = null;
  this.al8 = null;
  this.ald = false;
  this.Ez = null;
  this.al6 = false;
  this.alc = 0;
  this.QD = 0;
  this.YG = false;
  this.Ez = parent;
  this.al6 = changesOnly;
  this.ala = (void 0);
  $f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  $f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.alc = ((1 + parent.eB()) | 0);
  this.QD = 0;
  this.YG = true;
}
$p = $c_Lcom_raquo_airstream_misc_StreamFromSignal.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_misc_StreamFromSignal;
/** @constructor */
function $h_Lcom_raquo_airstream_misc_StreamFromSignal() {
}
$h_Lcom_raquo_airstream_misc_StreamFromSignal.prototype = $p;
$p.fx = (function() {
  return this.ala;
});
$p.eU = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$p.m = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.hR = (function() {
  return this.al9;
});
$p.h5 = (function() {
  return this.alb;
});
$p.gb = (function(x$1) {
  this.al9 = x$1;
});
$p.hS = (function(x$1) {
  this.alb = x$1;
});
$p.e = (function(obj) {
  return (this === obj);
});
$p.x = (function() {
  return $systemIdentityHashCode(this);
});
$p.ip = (function(observer) {
});
$p.mY = (function() {
  return this;
});
$p.gk = (function() {
  return this.al7;
});
$p.gl = (function() {
  return this.al8;
});
$p.iA = (function() {
  return this.ald;
});
$p.hs = (function(x$1) {
  this.ald = x$1;
});
$p.ig = (function(x$0) {
  this.al7 = x$0;
});
$p.ih = (function(x$0) {
  this.al8 = x$0;
});
$p.ik = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.iu = (function() {
  $f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(this.Ez);
});
$p.is = (function() {
  $f_Lcom_raquo_airstream_common_SingleParentStream__onStop__V(this);
});
$p.iY = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_common_InternalTryObserver__onNext__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.iq = (function(nextError, transaction) {
  $f_Lcom_raquo_airstream_common_InternalTryObserver__onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$p.eB = (function() {
  return this.alc;
});
$p.ir = (function() {
  var newParentLastUpdateId = this.Ez.jk();
  if ((this.YG && this.al6)) {
    this.QD = newParentLastUpdateId;
  } else if ((newParentLastUpdateId !== this.QD)) {
    $m_Lcom_raquo_airstream_core_Transaction$onStart$().aWy(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((trx) => {
      if ($f_Lcom_raquo_airstream_core_BaseObservable__isStarted__Z(this)) {
        $f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, this.Ez.aq(), trx);
        this.QD = this.Ez.jk();
      }
    })));
  }
  this.YG = false;
  $f_Lcom_raquo_airstream_common_SingleParentStream__onStart__V(this);
});
$p.it = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
  this.QD = this.Ez.jk();
  this.YG = false;
});
$p.ku = (function() {
  return this.Ez;
});
$p.fQ = (function(project) {
  return new $c_Lcom_raquo_airstream_misc_MapStream(this, project, $m_s_None$());
});
$p.ii = (function(isSame) {
  return new $c_Lcom_raquo_airstream_distinct_DistinctStream(this, isSame, false);
});
$p.dM = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_misc_StreamFromSignal = new $TypeData().i($c_Lcom_raquo_airstream_misc_StreamFromSignal, "com.raquo.airstream.misc.StreamFromSignal", ({
  ot: 1,
  P: 1,
  O: 1,
  U: 1,
  V: 1,
  al: 1,
  am: 1,
  Z: 1,
  aq: 1,
  a3: 1,
  b6: 1,
  aK: 1
}));
/** @constructor */
function $c_Lcom_raquo_airstream_timing_DebounceStream(parent, intervalMs) {
  this.alR = null;
  this.alQ = false;
  this.alS = null;
  this.alN = null;
  this.alO = null;
  this.alU = false;
  this.a66 = null;
  this.alP = 0;
  this.QJ = null;
  this.alT = 0;
  this.a66 = parent;
  this.alP = intervalMs;
  this.alR = (void 0);
  $f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  $f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.QJ = (void 0);
  this.alT = 1;
}
$p = $c_Lcom_raquo_airstream_timing_DebounceStream.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_timing_DebounceStream;
/** @constructor */
function $h_Lcom_raquo_airstream_timing_DebounceStream() {
}
$h_Lcom_raquo_airstream_timing_DebounceStream.prototype = $p;
$p.fx = (function() {
  return this.alR;
});
$p.eU = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$p.m = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.hR = (function() {
  return this.alQ;
});
$p.h5 = (function() {
  return this.alS;
});
$p.gb = (function(x$1) {
  this.alQ = x$1;
});
$p.hS = (function(x$1) {
  this.alS = x$1;
});
$p.e = (function(obj) {
  return (this === obj);
});
$p.x = (function() {
  return $systemIdentityHashCode(this);
});
$p.ip = (function(observer) {
});
$p.mY = (function() {
  return this;
});
$p.gk = (function() {
  return this.alN;
});
$p.gl = (function() {
  return this.alO;
});
$p.iA = (function() {
  return this.alU;
});
$p.hs = (function(x$1) {
  this.alU = x$1;
});
$p.ig = (function(x$0) {
  this.alN = x$0;
});
$p.ih = (function(x$0) {
  this.alO = x$0;
});
$p.ik = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.iu = (function() {
  $f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(this.a66);
});
$p.ir = (function() {
  $f_Lcom_raquo_airstream_common_SingleParentStream__onStart__V(this);
});
$p.iY = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_common_InternalTryObserver__onNext__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.iq = (function(nextError, transaction) {
  $f_Lcom_raquo_airstream_common_InternalTryObserver__onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$p.eB = (function() {
  return this.alT;
});
$p.it = (function(nextValue, transaction) {
  var x = this.QJ;
  if ((x !== (void 0))) {
    $m_sjs_js_timers_package$().IH(x);
  }
  this.QJ = $m_sjs_js_timers_package$().ym(this.alP, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
    new $c_Lcom_raquo_airstream_core_Transaction(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => {
      $f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, _$1);
    })));
  })));
});
$p.is = (function() {
  var x = this.QJ;
  if ((x !== (void 0))) {
    $m_sjs_js_timers_package$().IH(x);
  }
  this.QJ = (void 0);
  $f_Lcom_raquo_airstream_common_SingleParentStream__onStop__V(this);
});
$p.ku = (function() {
  return this.a66;
});
$p.fQ = (function(project) {
  return new $c_Lcom_raquo_airstream_misc_MapStream(this, project, $m_s_None$());
});
$p.ii = (function(isSame) {
  return new $c_Lcom_raquo_airstream_distinct_DistinctStream(this, isSame, false);
});
$p.dM = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_timing_DebounceStream = new $TypeData().i($c_Lcom_raquo_airstream_timing_DebounceStream, "com.raquo.airstream.timing.DebounceStream", ({
  oQ: 1,
  P: 1,
  O: 1,
  U: 1,
  V: 1,
  al: 1,
  am: 1,
  Z: 1,
  aq: 1,
  a3: 1,
  b6: 1,
  aK: 1
}));
/** @constructor */
function $c_Lcom_raquo_airstream_timing_DelayStream(parent, delayMs) {
  this.alY = null;
  this.alX = false;
  this.alZ = null;
  this.alV = null;
  this.alW = null;
  this.am1 = false;
  this.a68 = null;
  this.a67 = 0;
  this.am0 = 0;
  this.yt = null;
  this.a68 = parent;
  this.a67 = delayMs;
  this.alY = (void 0);
  $f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  $f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.am0 = 1;
  this.yt = $m_Lcom_raquo_ew_JsArray$().fu($m_sr_ScalaRunTime$().f(new ($d_sjs_js_timers_SetTimeoutHandle.r().C)([])));
}
$p = $c_Lcom_raquo_airstream_timing_DelayStream.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_timing_DelayStream;
/** @constructor */
function $h_Lcom_raquo_airstream_timing_DelayStream() {
}
$h_Lcom_raquo_airstream_timing_DelayStream.prototype = $p;
$p.fx = (function() {
  return this.alY;
});
$p.eU = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$p.m = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.hR = (function() {
  return this.alX;
});
$p.h5 = (function() {
  return this.alZ;
});
$p.gb = (function(x$1) {
  this.alX = x$1;
});
$p.hS = (function(x$1) {
  this.alZ = x$1;
});
$p.e = (function(obj) {
  return (this === obj);
});
$p.x = (function() {
  return $systemIdentityHashCode(this);
});
$p.ip = (function(observer) {
});
$p.mY = (function() {
  return this;
});
$p.gk = (function() {
  return this.alV;
});
$p.gl = (function() {
  return this.alW;
});
$p.iA = (function() {
  return this.am1;
});
$p.hs = (function(x$1) {
  this.am1 = x$1;
});
$p.ig = (function(x$0) {
  this.alV = x$0;
});
$p.ih = (function(x$0) {
  this.alW = x$0;
});
$p.ik = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.iu = (function() {
  $f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(this.a68);
});
$p.ir = (function() {
  $f_Lcom_raquo_airstream_common_SingleParentStream__onStart__V(this);
});
$p.it = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_common_InternalNextErrorObserver__onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.eB = (function() {
  return this.am0;
});
$p.iY = (function(nextValue, transaction) {
  var timerHandle = new $c_sr_ObjectRef(null);
  var ev$2 = $m_sjs_js_timers_package$().ym(this.a67, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
    this.yt.splice((this.yt.indexOf(timerHandle.aD) | 0), 1);
    new $c_Lcom_raquo_airstream_core_Transaction(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => {
      $f_Lcom_raquo_airstream_core_WritableStream__fireValue__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, _$1);
    })));
  })));
  timerHandle.aD = ev$2;
  ev$2 = null;
  this.yt.push(timerHandle.aD);
});
$p.iq = (function(nextError, transaction) {
  var timerHandle = new $c_sr_ObjectRef(null);
  var ev$3 = $m_sjs_js_timers_package$().ym(this.a67, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
    this.yt.splice((this.yt.indexOf(timerHandle.aD) | 0), 1);
    new $c_Lcom_raquo_airstream_core_Transaction(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => {
      $f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, _$2);
    })));
  })));
  timerHandle.aD = ev$3;
  ev$3 = null;
  this.yt.push(timerHandle.aD);
});
$p.is = (function() {
  var arr = this.yt;
  var i = 0;
  var len = (arr.length | 0);
  while ((i < len)) {
    $m_sjs_js_timers_package$().IH(arr[i]);
    i = ((1 + i) | 0);
  }
  this.yt.length = 0;
  $f_Lcom_raquo_airstream_common_SingleParentStream__onStop__V(this);
});
$p.ku = (function() {
  return this.a68;
});
$p.fQ = (function(project) {
  return new $c_Lcom_raquo_airstream_misc_MapStream(this, project, $m_s_None$());
});
$p.ii = (function(isSame) {
  return new $c_Lcom_raquo_airstream_distinct_DistinctStream(this, isSame, false);
});
$p.dM = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_timing_DelayStream = new $TypeData().i($c_Lcom_raquo_airstream_timing_DelayStream, "com.raquo.airstream.timing.DelayStream", ({
  oR: 1,
  P: 1,
  O: 1,
  U: 1,
  V: 1,
  al: 1,
  am: 1,
  Z: 1,
  aq: 1,
  a3: 1,
  b6: 1,
  bl: 1
}));
/** @constructor */
function $c_Lcom_raquo_airstream_timing_ThrottleStream(parent, intervalMs, leading) {
  this.amm = null;
  this.aml = false;
  this.amn = null;
  this.amj = null;
  this.amk = null;
  this.amp = false;
  this.a6f = null;
  this.a6d = 0;
  this.a6e = false;
  this.JT = null;
  this.QL = null;
  this.QM = null;
  this.amo = 0;
  this.a6f = parent;
  this.a6d = intervalMs;
  this.a6e = leading;
  this.amm = (void 0);
  $f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  $f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.JT = (void 0);
  this.QL = (void 0);
  this.QM = (void 0);
  this.amo = 1;
}
$p = $c_Lcom_raquo_airstream_timing_ThrottleStream.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_airstream_timing_ThrottleStream;
/** @constructor */
function $h_Lcom_raquo_airstream_timing_ThrottleStream() {
}
$h_Lcom_raquo_airstream_timing_ThrottleStream.prototype = $p;
$p.fx = (function() {
  return this.amm;
});
$p.eU = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$p.m = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.hR = (function() {
  return this.aml;
});
$p.h5 = (function() {
  return this.amn;
});
$p.gb = (function(x$1) {
  this.aml = x$1;
});
$p.hS = (function(x$1) {
  this.amn = x$1;
});
$p.e = (function(obj) {
  return (this === obj);
});
$p.x = (function() {
  return $systemIdentityHashCode(this);
});
$p.ip = (function(observer) {
});
$p.mY = (function() {
  return this;
});
$p.gk = (function() {
  return this.amj;
});
$p.gl = (function() {
  return this.amk;
});
$p.iA = (function() {
  return this.amp;
});
$p.hs = (function(x$1) {
  this.amp = x$1;
});
$p.ig = (function(x$0) {
  this.amj = x$0;
});
$p.ih = (function(x$0) {
  this.amk = x$0;
});
$p.ik = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.iu = (function() {
  $f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(this.a6f);
});
$p.ir = (function() {
  $f_Lcom_raquo_airstream_common_SingleParentStream__onStart__V(this);
});
$p.iY = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_common_InternalTryObserver__onNext__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.iq = (function(nextError, transaction) {
  $f_Lcom_raquo_airstream_common_InternalTryObserver__onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$p.eB = (function() {
  return this.amo;
});
$p.it = (function(nextValue, transaction) {
  var nowMs = (+Date.now());
  var x = this.JT;
  if ((x === (void 0))) {
    var remainingMs = (this.a6e ? 0 : this.a6d);
  } else {
    var lastEventMs = (+x);
    var msSinceLastEvent = (nowMs - lastEventMs);
    var remainingMs = (Math.max(((this.a6d - $doubleToInt(msSinceLastEvent)) | 0), 0) | 0);
  }
  if ((this.a6e && (this.JT === (void 0)))) {
    this.JT = nowMs;
    this.QL = $m_sjs_js_timers_package$().ym(0.0, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
      this.QL = (void 0);
      new $c_Lcom_raquo_airstream_core_Transaction(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => {
        $f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, _$1);
      })));
    })));
  } else {
    var x$2 = this.QM;
    if ((x$2 !== (void 0))) {
      $m_sjs_js_timers_package$().IH(x$2);
    }
    this.QM = $m_sjs_js_timers_package$().ym(remainingMs, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
      this.JT = (+Date.now());
      new $c_Lcom_raquo_airstream_core_Transaction(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => {
        $f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, _$2);
      })));
    })));
  }
});
$p.is = (function() {
  var x = this.QL;
  if ((x !== (void 0))) {
    $m_sjs_js_timers_package$().IH(x);
  }
  var x$1 = this.QM;
  if ((x$1 !== (void 0))) {
    $m_sjs_js_timers_package$().IH(x$1);
  }
  this.QL = (void 0);
  this.QM = (void 0);
  this.JT = (void 0);
  $f_Lcom_raquo_airstream_common_SingleParentStream__onStop__V(this);
});
$p.ku = (function() {
  return this.a6f;
});
$p.fQ = (function(project) {
  return new $c_Lcom_raquo_airstream_misc_MapStream(this, project, $m_s_None$());
});
$p.ii = (function(isSame) {
  return new $c_Lcom_raquo_airstream_distinct_DistinctStream(this, isSame, false);
});
$p.dM = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_timing_ThrottleStream = new $TypeData().i($c_Lcom_raquo_airstream_timing_ThrottleStream, "com.raquo.airstream.timing.ThrottleStream", ({
  oU: 1,
  P: 1,
  O: 1,
  U: 1,
  V: 1,
  al: 1,
  am: 1,
  Z: 1,
  aq: 1,
  a3: 1,
  b6: 1,
  aK: 1
}));
/** @constructor */
function $c_sc_AbstractSeq() {
}
$p = $c_sc_AbstractSeq.prototype = new $h_sc_AbstractIterable();
$p.constructor = $c_sc_AbstractSeq;
/** @constructor */
function $h_sc_AbstractSeq() {
}
$h_sc_AbstractSeq.prototype = $p;
$p.IG = (function(that) {
  return true;
});
$p.e = (function(o) {
  return $f_sc_Seq__equals__O__Z(this, o);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().a4G(this);
});
$p.m = (function() {
  return $f_sc_Iterable__toString__T(this);
});
$p.JI = (function() {
  return $ct_sc_SeqView$Id__sc_SeqOps__(new $c_sc_SeqView$Id(), this);
});
$p.bv = (function(elem) {
  return $f_sc_SeqOps__appended__O__O(this, elem);
});
$p.gU = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$p.g9 = (function(suffix) {
  return this.gU(suffix);
});
$p.aa = (function() {
  return this.C();
});
$p.nz = (function() {
  return $f_sc_SeqOps__distinct__O(this);
});
$p.ko = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f);
});
$p.cx = (function() {
  return this.k0().o();
});
$p.agA = (function(idx) {
  return $f_sc_SeqOps__isDefinedAt__I__Z(this, idx);
});
$p.px = (function(p, from) {
  return $f_sc_Iterator__indexWhere__F1__I__I(this.o(), p, from);
});
$p.mN = (function(elem, from) {
  return $f_sc_SeqOps__indexOf__O__I__I(this, elem, from);
});
$p.E = (function(elem) {
  return $f_sc_SeqOps__contains__O__Z(this, elem);
});
$p.h9 = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord);
});
$p.nE = (function(otherSize) {
  return this.bL(otherSize);
});
$p.bL = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$p.c = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$p.AE = (function(that) {
  return $f_sc_SeqOps__sameElements__sc_IterableOnce__Z(this, that);
});
$p.Ar = (function() {
  return new $c_s_PartialFunction$Lifted(this);
});
$p.aC = (function(x, default$1) {
  return $f_s_PartialFunction__applyOrElse__O__F1__O(this, x, default$1);
});
$p.Eg = (function(action) {
  return $f_s_PartialFunction__runWith__F1__F1(this, action);
});
$p.iU = (function(v1) {
  return (!(!this.i(v1)));
});
$p.aM = (function(x) {
  return this.agA((x | 0));
});
/** @constructor */
function $c_sc_AbstractSeqView() {
}
$p = $c_sc_AbstractSeqView.prototype = new $h_sc_AbstractView();
$p.constructor = $c_sc_AbstractSeqView;
/** @constructor */
function $h_sc_AbstractSeqView() {
}
$h_sc_AbstractSeqView.prototype = $p;
$p.h4 = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f);
});
$p.jm = (function(elem) {
  return $ct_sc_SeqView$Appended__sc_SeqOps__O__(new $c_sc_SeqView$Appended(), this, elem);
});
$p.jn = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n);
});
$p.jo = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n);
});
$p.el = (function() {
  return "SeqView";
});
$p.gU = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$p.g9 = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$p.aa = (function() {
  return this.C();
});
$p.nz = (function() {
  return $f_sc_SeqOps__distinct__O(this);
});
$p.ko = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f);
});
$p.cx = (function() {
  return this.k0().o();
});
$p.px = (function(p, from) {
  return $f_sc_Iterator__indexWhere__F1__I__I(this.o(), p, from);
});
$p.mN = (function(elem, from) {
  return $f_sc_SeqOps__indexOf__O__I__I(this, elem, from);
});
$p.nE = (function(otherSize) {
  return this.bL(otherSize);
});
$p.bL = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$p.c = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$p.h9 = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord);
});
$p.cn = (function(n) {
  return this.jo(n);
});
$p.ds = (function(n) {
  return this.jn(n);
});
$p.bv = (function(elem) {
  return this.jm(elem);
});
$p.L = (function(f) {
  return this.h4(f);
});
function $is_sc_IndexedSeq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.M)));
}
function $isArrayOf_sc_IndexedSeq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.M)));
}
function $is_sc_LinearSeq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.bF)));
}
function $isArrayOf_sc_LinearSeq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bF)));
}
/** @constructor */
function $c_sc_View$Empty$() {
}
$p = $c_sc_View$Empty$.prototype = new $h_sc_AbstractView();
$p.constructor = $c_sc_View$Empty$;
/** @constructor */
function $h_sc_View$Empty$() {
}
$h_sc_View$Empty$.prototype = $p;
$p.D = (function(n) {
  return $f_s_Product__productElementName__I__T(this, n);
});
$p.o = (function() {
  return $m_sc_Iterator$().b8;
});
$p.V = (function() {
  return 0;
});
$p.c = (function() {
  return true;
});
$p.B = (function() {
  return "Empty";
});
$p.z = (function() {
  return 0;
});
$p.A = (function(x$1) {
  return $m_sr_Statics$().ey(x$1);
});
$p.H = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$p.x = (function() {
  return 67081517;
});
var $d_sc_View$Empty$ = new $TypeData().i($c_sc_View$Empty$, "scala.collection.View$Empty$", ({
  HQ: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1,
  c: 1,
  b: 1
}));
var $n_sc_View$Empty$;
function $m_sc_View$Empty$() {
  if ((!$n_sc_View$Empty$)) {
    $n_sc_View$Empty$ = new $c_sc_View$Empty$();
  }
  return $n_sc_View$Empty$;
}
function $f_Lcom_raquo_laminar_api_Laminar__$init$__V($thiz) {
  $thiz.apc = new $c_Lcom_raquo_laminar_api_Laminar$$anon$1();
  $thiz.EE = new $c_Lcom_raquo_laminar_api_Laminar$$anon$2();
  $thiz.JU = $thiz.a6o.arC;
  $thiz.aTz = $m_Lcom_raquo_laminar_receivers_ChildReceiver$();
  $thiz.aTA = $m_Lcom_raquo_laminar_receivers_ChildTextReceiver$();
  $thiz.a6p = $m_Lcom_raquo_laminar_receivers_ChildrenReceiver$();
  $thiz.a6q = $m_Lcom_raquo_laminar_receivers_FocusReceiver$();
}
function $f_Lcom_raquo_laminar_api_Laminar__windowEvents__F1__Lcom_raquo_airstream_core_EventStream($thiz, events) {
  var p = events.i($thiz.EE);
  return new $c_Lcom_raquo_airstream_misc_CollectStream($m_Lcom_raquo_airstream_web_DomEventStream$().IC(window, p.j1.m8, p.m7), p.m6);
}
function $f_Lcom_raquo_laminar_api_Laminar__foreignSvgElement__Lcom_raquo_laminar_tags_SvgTag__Lorg_scalajs_dom_SVGElement__Lcom_raquo_laminar_nodes_ReactiveSvgElement($thiz, tag, element) {
  $m_Lcom_raquo_laminar_DomApi$().aXM(tag, element, "Unable to init foreign svg element");
  return new $c_Lcom_raquo_laminar_nodes_ReactiveSvgElement(tag, element);
}
function $f_Lcom_raquo_laminar_api_Laminar__foreignSvgElement__Lorg_scalajs_dom_SVGElement__Lcom_raquo_laminar_nodes_ReactiveSvgElement($thiz, element) {
  return $f_Lcom_raquo_laminar_api_Laminar__foreignSvgElement__Lcom_raquo_laminar_tags_SvgTag__Lorg_scalajs_dom_SVGElement__Lcom_raquo_laminar_nodes_ReactiveSvgElement($thiz, new $c_Lcom_raquo_laminar_tags_SvgTag($m_Lcom_raquo_laminar_nodes_ReactiveElement$().b5a(element), false), element);
}
function $f_Lcom_raquo_laminar_api_Laminar__inContext__F1__Lcom_raquo_laminar_modifiers_Modifier($thiz, makeModifier) {
  return new $c_Lcom_raquo_laminar_modifiers_Modifier$$anon$2(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((element) => {
    makeModifier.i(element).kL(element);
  })), $thiz.a6o);
}
/** @constructor */
function $c_sc_AbstractMap() {
}
$p = $c_sc_AbstractMap.prototype = new $h_sc_AbstractIterable();
$p.constructor = $c_sc_AbstractMap;
/** @constructor */
function $h_sc_AbstractMap() {
}
$h_sc_AbstractMap.prototype = $p;
$p.e = (function(o) {
  return $f_sc_Map__equals__O__Z(this, o);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().aQ6(this);
});
$p.el = (function() {
  return "Map";
});
$p.m = (function() {
  return $f_sc_Iterable__toString__T(this);
});
$p.w4 = (function(coll) {
  return this.im().cc(coll);
});
$p.fS = (function() {
  return this.im().b5();
});
$p.pr = (function() {
  return $f_sc_MapFactoryDefaults__empty__sc_IterableOps(this);
});
$p.ay = (function(key, default$1) {
  return $f_sc_MapOps__getOrElse__O__F0__O(this, key, default$1);
});
$p.i = (function(key) {
  return $f_sc_MapOps__apply__O__O(this, key);
});
$p.aC = (function(x, default$1) {
  return $f_sc_MapOps__applyOrElse__O__F1__O(this, x, default$1);
});
$p.a41 = (function() {
  return $ct_sc_MapOps$KeySet__sc_MapOps__(new $c_sc_MapOps$KeySet(), this);
});
$p.J8 = (function() {
  return this.a41();
});
$p.e6 = (function() {
  return new $c_sc_MapOps$$anon$1(this);
});
$p.lo = (function() {
  return new $c_sc_MapOps$$anon$2(this);
});
$p.hr = (function() {
  return new $c_sc_MapOps$$anon$3(this);
});
$p.pu = (function(f) {
  $f_sc_MapOps__foreachEntry__F2__V(this, f);
});
$p.WC = (function(key) {
  return $f_sc_MapOps__default__O__O(this, key);
});
$p.E = (function(key) {
  return $f_sc_MapOps__contains__O__Z(this, key);
});
$p.aM = (function(key) {
  return this.E(key);
});
$p.kP = (function(f) {
  return $f_sc_MapOps__map__F1__sc_IterableOps(this, f);
});
$p.DQ = (function(pf) {
  return $f_sc_MapOps__collect__s_PartialFunction__sc_IterableOps(this, pf);
});
$p.Pl = (function(f) {
  return $f_sc_MapOps__flatMap__F1__sc_IterableOps(this, f);
});
$p.hN = (function(suffix) {
  return $f_sc_MapOps__concat__sc_IterableOnce__sc_IterableOps(this, suffix);
});
$p.lf = (function(sb, start, sep, end) {
  return $f_sc_MapOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, sb, start, sep, end);
});
$p.Ar = (function() {
  return new $c_s_PartialFunction$Lifted(this);
});
$p.Eg = (function(action) {
  return $f_s_PartialFunction__runWith__F1__F1(this, action);
});
$p.iU = (function(v1) {
  return (!(!this.i(v1)));
});
$p.un = (function(p) {
  return new $c_sc_MapOps$WithFilter(this, p);
});
$p.fP = (function(coll) {
  return this.w4(coll);
});
function $ct_sc_SeqView$Appended__sc_SeqOps__O__($thiz, underlying, elem) {
  $thiz.NN = underlying;
  $thiz.a1y = elem;
  $ct_sc_View$Appended__sc_IterableOps__O__($thiz, underlying, elem);
  return $thiz;
}
/** @constructor */
function $c_sc_SeqView$Appended() {
  this.NQ = null;
  this.UX = null;
  this.NN = null;
  this.a1y = null;
}
$p = $c_sc_SeqView$Appended.prototype = new $h_sc_View$Appended();
$p.constructor = $c_sc_SeqView$Appended;
/** @constructor */
function $h_sc_SeqView$Appended() {
}
$h_sc_SeqView$Appended.prototype = $p;
$p.h4 = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f);
});
$p.jm = (function(elem) {
  return $ct_sc_SeqView$Appended__sc_SeqOps__O__(new $c_sc_SeqView$Appended(), this, elem);
});
$p.jn = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n);
});
$p.jo = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n);
});
$p.el = (function() {
  return "SeqView";
});
$p.gU = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$p.g9 = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$p.aa = (function() {
  return this.C();
});
$p.nz = (function() {
  return $f_sc_SeqOps__distinct__O(this);
});
$p.ko = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f);
});
$p.cx = (function() {
  return this.k0().o();
});
$p.px = (function(p, from) {
  return $f_sc_Iterator__indexWhere__F1__I__I(this.o(), p, from);
});
$p.mN = (function(elem, from) {
  return $f_sc_SeqOps__indexOf__O__I__I(this, elem, from);
});
$p.nE = (function(otherSize) {
  return this.bL(otherSize);
});
$p.bL = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$p.c = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$p.l = (function(idx) {
  return ((idx === this.NN.C()) ? this.a1y : this.NN.l(idx));
});
$p.C = (function() {
  return ((1 + this.NN.C()) | 0);
});
$p.h9 = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord);
});
$p.cn = (function(n) {
  return this.jo(n);
});
$p.ds = (function(n) {
  return this.jn(n);
});
$p.bv = (function(elem) {
  return this.jm(elem);
});
$p.L = (function(f) {
  return this.h4(f);
});
var $d_sc_SeqView$Appended = new $TypeData().i($c_sc_SeqView$Appended, "scala.collection.SeqView$Appended", ({
  dz: 1,
  cJ: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1,
  a4: 1,
  w: 1
}));
function $ct_sc_SeqView$Drop__sc_SeqOps__I__($thiz, underlying, n) {
  $thiz.NO = underlying;
  $thiz.a1z = n;
  $ct_sc_View$Drop__sc_IterableOps__I__($thiz, underlying, n);
  return $thiz;
}
/** @constructor */
function $c_sc_SeqView$Drop() {
  this.NR = null;
  this.UY = 0;
  this.Hu = 0;
  this.NO = null;
  this.a1z = 0;
}
$p = $c_sc_SeqView$Drop.prototype = new $h_sc_View$Drop();
$p.constructor = $c_sc_SeqView$Drop;
/** @constructor */
function $h_sc_SeqView$Drop() {
}
$h_sc_SeqView$Drop.prototype = $p;
$p.h4 = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f);
});
$p.jm = (function(elem) {
  return $ct_sc_SeqView$Appended__sc_SeqOps__O__(new $c_sc_SeqView$Appended(), this, elem);
});
$p.jo = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n);
});
$p.el = (function() {
  return "SeqView";
});
$p.gU = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$p.g9 = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$p.aa = (function() {
  return this.C();
});
$p.nz = (function() {
  return $f_sc_SeqOps__distinct__O(this);
});
$p.ko = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f);
});
$p.cx = (function() {
  return this.k0().o();
});
$p.px = (function(p, from) {
  return $f_sc_Iterator__indexWhere__F1__I__I(this.o(), p, from);
});
$p.mN = (function(elem, from) {
  return $f_sc_SeqOps__indexOf__O__I__I(this, elem, from);
});
$p.nE = (function(otherSize) {
  return this.bL(otherSize);
});
$p.bL = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$p.c = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$p.C = (function() {
  var x = ((this.NO.C() - this.Hu) | 0);
  return ((x > 0) ? x : 0);
});
$p.l = (function(i) {
  return this.NO.l(((i + this.Hu) | 0));
});
$p.jn = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this.NO, ((this.a1z + n) | 0));
});
$p.h9 = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord);
});
$p.cn = (function(n) {
  return this.jo(n);
});
$p.bv = (function(elem) {
  return this.jm(elem);
});
$p.L = (function(f) {
  return this.h4(f);
});
$p.ds = (function(n) {
  return this.jn(n);
});
var $d_sc_SeqView$Drop = new $TypeData().i($c_sc_SeqView$Drop, "scala.collection.SeqView$Drop", ({
  dA: 1,
  cK: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1,
  a4: 1,
  w: 1
}));
function $ct_sc_SeqView$DropRight__sc_SeqOps__I__($thiz, underlying, n) {
  $thiz.a1A = underlying;
  $ct_sc_View$DropRight__sc_IterableOps__I__($thiz, underlying, n);
  var x = ((underlying.C() - ((n > 0) ? n : 0)) | 0);
  $thiz.Hr = ((x > 0) ? x : 0);
  return $thiz;
}
/** @constructor */
function $c_sc_SeqView$DropRight() {
  this.NS = null;
  this.UZ = 0;
  this.V0 = 0;
  this.a1A = null;
  this.Hr = 0;
}
$p = $c_sc_SeqView$DropRight.prototype = new $h_sc_View$DropRight();
$p.constructor = $c_sc_SeqView$DropRight;
/** @constructor */
function $h_sc_SeqView$DropRight() {
}
$h_sc_SeqView$DropRight.prototype = $p;
$p.h4 = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f);
});
$p.jm = (function(elem) {
  return $ct_sc_SeqView$Appended__sc_SeqOps__O__(new $c_sc_SeqView$Appended(), this, elem);
});
$p.jn = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n);
});
$p.jo = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n);
});
$p.el = (function() {
  return "SeqView";
});
$p.gU = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$p.g9 = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$p.aa = (function() {
  return this.Hr;
});
$p.nz = (function() {
  return $f_sc_SeqOps__distinct__O(this);
});
$p.ko = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f);
});
$p.cx = (function() {
  return this.k0().o();
});
$p.px = (function(p, from) {
  return $f_sc_Iterator__indexWhere__F1__I__I(this.o(), p, from);
});
$p.mN = (function(elem, from) {
  return $f_sc_SeqOps__indexOf__O__I__I(this, elem, from);
});
$p.nE = (function(otherSize) {
  return this.bL(otherSize);
});
$p.bL = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$p.c = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$p.C = (function() {
  return this.Hr;
});
$p.l = (function(i) {
  return this.a1A.l(i);
});
$p.h9 = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord);
});
$p.cn = (function(n) {
  return this.jo(n);
});
$p.ds = (function(n) {
  return this.jn(n);
});
$p.bv = (function(elem) {
  return this.jm(elem);
});
$p.L = (function(f) {
  return this.h4(f);
});
var $d_sc_SeqView$DropRight = new $TypeData().i($c_sc_SeqView$DropRight, "scala.collection.SeqView$DropRight", ({
  dB: 1,
  cL: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1,
  a4: 1,
  w: 1
}));
function $ct_sc_SeqView$Id__sc_SeqOps__($thiz, underlying) {
  $thiz.Hs = underlying;
  return $thiz;
}
/** @constructor */
function $c_sc_SeqView$Id() {
  this.Hs = null;
}
$p = $c_sc_SeqView$Id.prototype = new $h_sc_AbstractSeqView();
$p.constructor = $c_sc_SeqView$Id;
/** @constructor */
function $h_sc_SeqView$Id() {
}
$h_sc_SeqView$Id.prototype = $p;
$p.l = (function(idx) {
  return this.Hs.l(idx);
});
$p.C = (function() {
  return this.Hs.C();
});
$p.o = (function() {
  return this.Hs.o();
});
$p.V = (function() {
  return this.Hs.V();
});
$p.c = (function() {
  return this.Hs.c();
});
var $d_sc_SeqView$Id = new $TypeData().i($c_sc_SeqView$Id, "scala.collection.SeqView$Id", ({
  kR: 1,
  b8: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1,
  a4: 1,
  w: 1
}));
function $ct_sc_SeqView$Map__sc_SeqOps__F1__($thiz, underlying, f) {
  $thiz.US = underlying;
  $thiz.a1B = f;
  $ct_sc_View$Map__sc_IterableOps__F1__($thiz, underlying, f);
  return $thiz;
}
/** @constructor */
function $c_sc_SeqView$Map() {
  this.Hv = null;
  this.V2 = null;
  this.US = null;
  this.a1B = null;
}
$p = $c_sc_SeqView$Map.prototype = new $h_sc_View$Map();
$p.constructor = $c_sc_SeqView$Map;
/** @constructor */
function $h_sc_SeqView$Map() {
}
$h_sc_SeqView$Map.prototype = $p;
$p.h4 = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f);
});
$p.jm = (function(elem) {
  return $ct_sc_SeqView$Appended__sc_SeqOps__O__(new $c_sc_SeqView$Appended(), this, elem);
});
$p.jn = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n);
});
$p.jo = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n);
});
$p.el = (function() {
  return "SeqView";
});
$p.gU = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$p.g9 = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$p.aa = (function() {
  return this.C();
});
$p.nz = (function() {
  return $f_sc_SeqOps__distinct__O(this);
});
$p.ko = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f);
});
$p.cx = (function() {
  return this.k0().o();
});
$p.px = (function(p, from) {
  return $f_sc_Iterator__indexWhere__F1__I__I(this.o(), p, from);
});
$p.mN = (function(elem, from) {
  return $f_sc_SeqOps__indexOf__O__I__I(this, elem, from);
});
$p.nE = (function(otherSize) {
  return this.bL(otherSize);
});
$p.bL = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$p.c = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$p.l = (function(idx) {
  return this.a1B.i(this.US.l(idx));
});
$p.C = (function() {
  return this.US.C();
});
$p.h9 = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord);
});
$p.cn = (function(n) {
  return this.jo(n);
});
$p.ds = (function(n) {
  return this.jn(n);
});
$p.bv = (function(elem) {
  return this.jm(elem);
});
$p.L = (function(f) {
  return this.h4(f);
});
var $d_sc_SeqView$Map = new $TypeData().i($c_sc_SeqView$Map, "scala.collection.SeqView$Map", ({
  dC: 1,
  cM: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1,
  a4: 1,
  w: 1
}));
function $ct_sc_SeqView$Prepended__O__sc_SeqOps__($thiz, elem, underlying) {
  $thiz.ack = elem;
  $thiz.a1C = underlying;
  $ct_sc_View$Prepended__O__sc_IterableOps__($thiz, elem, underlying);
  return $thiz;
}
/** @constructor */
function $c_sc_SeqView$Prepended() {
  this.acv = null;
  this.acw = null;
  this.ack = null;
  this.a1C = null;
}
$p = $c_sc_SeqView$Prepended.prototype = new $h_sc_View$Prepended();
$p.constructor = $c_sc_SeqView$Prepended;
/** @constructor */
function $h_sc_SeqView$Prepended() {
}
$h_sc_SeqView$Prepended.prototype = $p;
$p.gU = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$p.g9 = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$p.aa = (function() {
  return this.C();
});
$p.nz = (function() {
  return $f_sc_SeqOps__distinct__O(this);
});
$p.ko = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f);
});
$p.px = (function(p, from) {
  return $f_sc_Iterator__indexWhere__F1__I__I(this.o(), p, from);
});
$p.mN = (function(elem, from) {
  return $f_sc_SeqOps__indexOf__O__I__I(this, elem, from);
});
$p.nE = (function(otherSize) {
  return this.bL(otherSize);
});
$p.c = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$p.l = (function(idx) {
  return ((idx === 0) ? this.ack : this.a1C.l(((idx - 1) | 0)));
});
$p.C = (function() {
  return ((1 + this.a1C.C()) | 0);
});
$p.h9 = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord);
});
function $ct_sc_SeqView$Reverse__sc_SeqOps__($thiz, underlying) {
  $thiz.CV = underlying;
  return $thiz;
}
/** @constructor */
function $c_sc_SeqView$Reverse() {
  this.CV = null;
}
$p = $c_sc_SeqView$Reverse.prototype = new $h_sc_AbstractSeqView();
$p.constructor = $c_sc_SeqView$Reverse;
/** @constructor */
function $h_sc_SeqView$Reverse() {
}
$h_sc_SeqView$Reverse.prototype = $p;
$p.l = (function(i) {
  return this.CV.l(((((this.C() - 1) | 0) - i) | 0));
});
$p.C = (function() {
  return this.CV.C();
});
$p.o = (function() {
  return this.CV.cx();
});
$p.V = (function() {
  return this.CV.V();
});
$p.c = (function() {
  return this.CV.c();
});
var $d_sc_SeqView$Reverse = new $TypeData().i($c_sc_SeqView$Reverse, "scala.collection.SeqView$Reverse", ({
  dD: 1,
  b8: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1,
  a4: 1,
  w: 1
}));
function $ct_sc_SeqView$Take__sc_SeqOps__I__($thiz, underlying, n) {
  $thiz.UU = underlying;
  $thiz.acq = n;
  $ct_sc_View$Take__sc_IterableOps__I__($thiz, underlying, n);
  return $thiz;
}
/** @constructor */
function $c_sc_SeqView$Take() {
  this.a1K = 0;
  this.UU = null;
  this.acq = 0;
}
$p = $c_sc_SeqView$Take.prototype = new $h_sc_View$Take();
$p.constructor = $c_sc_SeqView$Take;
/** @constructor */
function $h_sc_SeqView$Take() {
}
$h_sc_SeqView$Take.prototype = $p;
$p.gU = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$p.g9 = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$p.aa = (function() {
  return this.C();
});
$p.nz = (function() {
  return $f_sc_SeqOps__distinct__O(this);
});
$p.ko = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f);
});
$p.px = (function(p, from) {
  return $f_sc_Iterator__indexWhere__F1__I__I($ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this), p, from);
});
$p.mN = (function(elem, from) {
  return $f_sc_SeqOps__indexOf__O__I__I(this, elem, from);
});
$p.nE = (function(otherSize) {
  var x = this.C();
  return ((x === otherSize) ? 0 : ((x < otherSize) ? (-1) : 1));
});
$p.c = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$p.l = (function(idx) {
  if ((idx < this.acq)) {
    return this.UU.l(idx);
  } else {
    throw ((this.UU.V() >= 0) ? $m_scg_CommonErrors$().h2(idx, ((this.V() - 1) | 0)) : $m_scg_CommonErrors$().b2J(idx));
  }
});
$p.C = (function() {
  var x = this.UU.C();
  var that = this.a1K;
  return ((x < that) ? x : that);
});
$p.h9 = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord);
});
function $is_sci_Seq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.X)));
}
function $isArrayOf_sci_Seq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.X)));
}
function $f_scm_MapOps__put__O__O__s_Option($thiz, key, value) {
  var r = $thiz.r(key);
  $thiz.cY(key, value);
  return r;
}
function $f_scm_MapOps__update__O__O__V($thiz, key, value) {
  $thiz.Y(new $c_T2(key, value));
}
function $f_scm_MapOps__getOrElseUpdate__O__F0__O($thiz, key, defaultValue) {
  var x1 = $thiz.r(key);
  if ((x1 instanceof $c_s_Some)) {
    return x1.J;
  } else if (($m_s_None$() === x1)) {
    var d = defaultValue.a3();
    $thiz.cY(key, d);
    return d;
  } else {
    throw new $c_s_MatchError(x1);
  }
}
function $f_scm_MapOps__remove__O__s_Option($thiz, key) {
  var r = $thiz.r(key);
  if ((!r.c())) {
    $thiz.re(key);
  }
  return r;
}
function $f_scm_MapOps__filterInPlace__F2__scm_MapOps($thiz, p) {
  if ((!$thiz.c())) {
    if ($is_sc_concurrent_Map($thiz)) {
      $thiz.bd9(p);
    } else {
      if (($thiz.V() >= 0)) {
        var destination = new $ac_O($thiz.V());
        $f_sc_IterableOnceOps__copyToArray__O__I__I__I($thiz, destination, 0, 2147483647);
        var array = destination;
      } else {
        var capacity = 0;
        var size = 0;
        var jsElems = null;
        capacity = 0;
        size = 0;
        jsElems = [];
        var it = $thiz.o();
        while (it.p()) {
          var elem = it.q();
          var unboxedElem = ((elem === null) ? null : elem);
          jsElems.push(unboxedElem);
        }
        var array = new $ac_O(jsElems);
      }
      var arrayLength = array.a.length;
      var i = 0;
      while ((i < arrayLength)) {
        var x1$2 = array.a[i];
        if ((x1$2 === null)) {
          throw new $c_s_MatchError(x1$2);
        }
        var k = x1$2.g();
        var v = x1$2.h();
        if ((!(!(!p.R(k, v))))) {
          $thiz.re(k);
        }
        i = ((1 + i) | 0);
      }
    }
  }
  return $thiz;
}
/** @constructor */
function $c_Lcom_raquo_airstream_state_LazyStrictSignal(parentSignal, zoomIn, parentDisplayName, displayNameSuffix) {
  this.Yz = null;
  this.Yy = false;
  this.YA = null;
  this.Qx = 0;
  this.Yw = null;
  this.Yx = null;
  this.YE = false;
  this.Qz = null;
  this.YC = false;
  this.Qy = 0;
  this.YB = null;
  this.QA = null;
  this.QB = null;
  this.YD = 0;
  this.alv = null;
  this.alu = null;
  this.alt = null;
  this.alv = parentSignal;
  this.alu = parentDisplayName;
  this.alt = displayNameSuffix;
  $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(this, parentSignal, zoomIn, $m_s_None$());
}
$p = $c_Lcom_raquo_airstream_state_LazyStrictSignal.prototype = new $h_Lcom_raquo_airstream_misc_MapSignal();
$p.constructor = $c_Lcom_raquo_airstream_state_LazyStrictSignal;
/** @constructor */
function $h_Lcom_raquo_airstream_state_LazyStrictSignal() {
}
$h_Lcom_raquo_airstream_state_LazyStrictSignal.prototype = $p;
$p.eU = (function() {
  return (((("" + this.alu.a3()) + this.alt) + "@") + $systemIdentityHashCode(this));
});
$p.aq = (function() {
  var newParentLastUpdateId = this.alv.jk();
  if ((newParentLastUpdateId !== this.Qy)) {
    var nextValue = this.vX();
    $f_Lcom_raquo_airstream_common_SingleParentSignal__updateCurrentValueFromParent__s_util_Try__I__V(this, nextValue, newParentLastUpdateId);
    return nextValue;
  } else {
    return $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this);
  }
});
$p.Yb = (function(nextValue, nextParentLastUpdateId) {
  $f_Lcom_raquo_airstream_common_SingleParentSignal__updateCurrentValueFromParent__s_util_Try__I__V(this, nextValue, nextParentLastUpdateId);
});
var $d_Lcom_raquo_airstream_state_LazyStrictSignal = new $TypeData().i($c_Lcom_raquo_airstream_state_LazyStrictSignal, "com.raquo.airstream.state.LazyStrictSignal", ({
  oD: 1,
  d3: 1,
  P: 1,
  O: 1,
  U: 1,
  V: 1,
  aB: 1,
  aD: 1,
  Z: 1,
  aS: 1,
  a3: 1,
  aK: 1,
  bv: 1,
  cf: 1
}));
/** @constructor */
function $c_Lcom_raquo_laminar_api_package$$anon$1() {
  this.apz = null;
  this.apA = false;
  this.apl = null;
  this.apm = false;
  this.apn = null;
  this.apo = false;
  this.app = null;
  this.apq = false;
  this.aoR = null;
  this.aoS = false;
  this.ap4 = null;
  this.ap5 = false;
  this.apv = null;
  this.apw = false;
  this.aoX = null;
  this.aoY = false;
  this.aqx = null;
  this.aqy = false;
  this.apj = null;
  this.apk = false;
  this.apd = null;
  this.ape = false;
  this.apF = null;
  this.apG = false;
  this.apB = null;
  this.apC = false;
  this.aoZ = null;
  this.ap0 = false;
  this.aqt = null;
  this.aqu = false;
  this.aqj = null;
  this.aqk = false;
  this.aqT = null;
  this.aqU = false;
  this.aql = null;
  this.aqm = false;
  this.apr = null;
  this.aps = false;
  this.ar9 = null;
  this.ara = false;
  this.apH = null;
  this.apI = false;
  this.apf = null;
  this.apg = false;
  this.apa = null;
  this.apb = false;
  this.aqL = null;
  this.aqM = false;
  this.aqP = null;
  this.aqQ = false;
  this.aqX = null;
  this.aqY = false;
  this.ar3 = null;
  this.ar4 = false;
  this.aqR = null;
  this.aqS = false;
  this.aqV = null;
  this.aqW = false;
  this.apD = null;
  this.apE = false;
  this.ap6 = null;
  this.ap7 = false;
  this.aqF = null;
  this.aqG = false;
  this.apt = null;
  this.apu = false;
  this.apJ = null;
  this.apK = false;
  this.apN = null;
  this.apO = false;
  this.aqz = null;
  this.aqA = false;
  this.aqB = null;
  this.aqC = false;
  this.ar7 = null;
  this.ar8 = false;
  this.ar5 = null;
  this.ar6 = false;
  this.ar1 = null;
  this.ar2 = false;
  this.ap1 = null;
  this.ap2 = false;
  this.aqv = null;
  this.aqw = false;
  this.ard = null;
  this.are = false;
  this.aoV = null;
  this.aoW = false;
  this.ap8 = null;
  this.ap9 = false;
  this.aph = null;
  this.api = false;
  this.apx = null;
  this.apy = false;
  this.apL = null;
  this.apM = false;
  this.apP = null;
  this.apQ = false;
  this.aqn = null;
  this.aqo = false;
  this.aqr = null;
  this.aqs = false;
  this.aqJ = null;
  this.aqK = false;
  this.aqN = null;
  this.aqO = false;
  this.aqZ = null;
  this.ar0 = false;
  this.apV = null;
  this.apW = false;
  this.apX = null;
  this.apY = false;
  this.aq7 = null;
  this.aq8 = false;
  this.aq9 = null;
  this.aqa = false;
  this.aqb = null;
  this.aqc = false;
  this.aqh = null;
  this.aqi = false;
  this.apT = null;
  this.apU = false;
  this.aq3 = null;
  this.aq4 = false;
  this.apR = null;
  this.apS = false;
  this.aq1 = null;
  this.aq2 = false;
  this.aq5 = null;
  this.aq6 = false;
  this.aqd = null;
  this.aqe = false;
  this.aqf = null;
  this.aqg = false;
  this.apZ = null;
  this.aq0 = false;
  this.ap3 = null;
  this.y = null;
  this.aqp = null;
  this.aqq = false;
  this.aqD = null;
  this.aqE = false;
  this.AR = null;
  this.ED = null;
  this.aoM = null;
  this.aTy = null;
  this.ff = null;
  this.aoN = null;
  this.aoO = false;
  this.a6o = null;
  this.aoP = null;
  this.aoQ = false;
  this.aoT = null;
  this.aoU = false;
  this.aqH = null;
  this.aqI = false;
  this.apc = null;
  this.EE = null;
  this.arb = null;
  this.arc = false;
  this.JU = null;
  this.aTz = null;
  this.aTA = null;
  this.a6p = null;
  this.a6q = null;
  $f_Lcom_raquo_laminar_defs_complex_ComplexHtmlKeys__$init$__V(this);
  $f_Lcom_raquo_laminar_api_MountHooks__$init$__V(this);
  $f_Lcom_raquo_laminar_api_AirstreamAliases__$init$__V(this);
  $f_Lcom_raquo_laminar_api_LaminarAliases__$init$__V(this);
  $f_Lcom_raquo_laminar_api_Laminar__$init$__V(this);
}
$p = $c_Lcom_raquo_laminar_api_package$$anon$1.prototype = new $h_O();
$p.constructor = $c_Lcom_raquo_laminar_api_package$$anon$1;
/** @constructor */
function $h_Lcom_raquo_laminar_api_package$$anon$1() {
}
$h_Lcom_raquo_laminar_api_package$$anon$1.prototype = $p;
$p.aPc = (function() {
  if ((!this.apA)) {
    this.apz = new $c_Lcom_raquo_laminar_tags_HtmlTag("img", true);
    this.apA = true;
  }
  return this.apz;
});
$p.ago = (function() {
  if ((!this.apm)) {
    this.apl = new $c_Lcom_raquo_laminar_tags_HtmlTag("h1", false);
    this.apm = true;
  }
  return this.apl;
});
$p.E3 = (function() {
  if ((!this.apo)) {
    this.apn = new $c_Lcom_raquo_laminar_tags_HtmlTag("h2", false);
    this.apo = true;
  }
  return this.apn;
});
$p.ya = (function() {
  if ((!this.apq)) {
    this.app = new $c_Lcom_raquo_laminar_tags_HtmlTag("h3", false);
    this.apq = true;
  }
  return this.app;
});
$p.DD = (function() {
  if ((!this.aoS)) {
    this.aoR = new $c_Lcom_raquo_laminar_tags_HtmlTag("a", false);
    this.aoS = true;
  }
  return this.aoR;
});
$p.aYr = (function() {
  if ((!this.ap5)) {
    this.ap4 = new $c_Lcom_raquo_laminar_tags_HtmlTag("code", false);
    this.ap5 = true;
  }
  return this.ap4;
});
$p.cS = (function() {
  if ((!this.apw)) {
    this.apv = new $c_Lcom_raquo_laminar_tags_HtmlTag("i", false);
    this.apw = true;
  }
  return this.apv;
});
$p.aXT = (function() {
  if ((!this.aoY)) {
    this.aoX = new $c_Lcom_raquo_laminar_tags_HtmlTag("b", false);
    this.aoY = true;
  }
  return this.aoX;
});
$p.aU = (function() {
  if ((!this.aqy)) {
    this.aqx = new $c_Lcom_raquo_laminar_tags_HtmlTag("span", false);
    this.aqy = true;
  }
  return this.aqx;
});
$p.aOj = (function() {
  if ((!this.apk)) {
    this.apj = new $c_Lcom_raquo_laminar_tags_HtmlTag("form", false);
    this.apk = true;
  }
  return this.apj;
});
$p.afI = (function() {
  if ((!this.ape)) {
    this.apd = new $c_Lcom_raquo_laminar_tags_HtmlTag("fieldset", false);
    this.ape = true;
  }
  return this.apd;
});
$p.Xp = (function() {
  if ((!this.apG)) {
    this.apF = new $c_Lcom_raquo_laminar_tags_HtmlTag("label", false);
    this.apG = true;
  }
  return this.apF;
});
$p.w7 = (function() {
  if ((!this.apC)) {
    this.apB = new $c_Lcom_raquo_laminar_tags_HtmlTag("input", true);
    this.apC = true;
  }
  return this.apB;
});
$p.IF = (function() {
  if ((!this.ap0)) {
    this.aoZ = new $c_Lcom_raquo_laminar_tags_HtmlTag("button", false);
    this.ap0 = true;
  }
  return this.aoZ;
});
$p.ahU = (function() {
  if ((!this.aqu)) {
    this.aqt = new $c_Lcom_raquo_laminar_tags_HtmlTag("select", false);
    this.aqu = true;
  }
  return this.aqt;
});
$p.Jd = (function() {
  if ((!this.aqk)) {
    this.aqj = new $c_Lcom_raquo_laminar_tags_HtmlTag("option", false);
    this.aqk = true;
  }
  return this.aqj;
});
$p.aSI = (function() {
  if ((!this.aqU)) {
    this.aqT = new $c_Lcom_raquo_laminar_tags_HtmlTag("textarea", false);
    this.aqU = true;
  }
  return this.aqT;
});
$p.Ax = (function() {
  if ((!this.aqm)) {
    this.aql = new $c_Lcom_raquo_laminar_tags_HtmlTag("p", false);
    this.aqm = true;
  }
  return this.aql;
});
$p.b2F = (function() {
  if ((!this.aps)) {
    this.apr = new $c_Lcom_raquo_laminar_tags_HtmlTag("hr", true);
    this.aps = true;
  }
  return this.apr;
});
$p.Q6 = (function() {
  if ((!this.ara)) {
    this.ar9 = new $c_Lcom_raquo_laminar_tags_HtmlTag("ul", false);
    this.ara = true;
  }
  return this.ar9;
});
$p.yc = (function() {
  if ((!this.apI)) {
    this.apH = new $c_Lcom_raquo_laminar_tags_HtmlTag("li", false);
    this.apI = true;
  }
  return this.apH;
});
$p.aO0 = (function() {
  if ((!this.apg)) {
    this.apf = new $c_Lcom_raquo_laminar_tags_HtmlTag("figure", false);
    this.apg = true;
  }
  return this.apf;
});
$p.a8 = (function() {
  if ((!this.apb)) {
    this.apa = new $c_Lcom_raquo_laminar_tags_HtmlTag("div", false);
    this.apb = true;
  }
  return this.apa;
});
$p.aid = (function() {
  if ((!this.aqM)) {
    this.aqL = new $c_Lcom_raquo_laminar_tags_HtmlTag("table", false);
    this.aqM = true;
  }
  return this.aqL;
});
$p.aie = (function() {
  if ((!this.aqQ)) {
    this.aqP = new $c_Lcom_raquo_laminar_tags_HtmlTag("tbody", false);
    this.aqQ = true;
  }
  return this.aqP;
});
$p.aSN = (function() {
  if ((!this.aqY)) {
    this.aqX = new $c_Lcom_raquo_laminar_tags_HtmlTag("thead", false);
    this.aqY = true;
  }
  return this.aqX;
});
$p.uk = (function() {
  if ((!this.ar4)) {
    this.ar3 = new $c_Lcom_raquo_laminar_tags_HtmlTag("tr", false);
    this.ar4 = true;
  }
  return this.ar3;
});
$p.kW = (function() {
  if ((!this.aqS)) {
    this.aqR = new $c_Lcom_raquo_laminar_tags_HtmlTag("td", false);
    this.aqS = true;
  }
  return this.aqR;
});
$p.a4X = (function() {
  if ((!this.aqW)) {
    this.aqV = new $c_Lcom_raquo_laminar_tags_HtmlTag("th", false);
    this.aqW = true;
  }
  return this.aqV;
});
$p.oD = (function() {
  if ((!this.apE)) {
    this.apD = new $c_Lcom_raquo_laminar_tags_HtmlTag("kbd", false);
    this.apE = true;
  }
  return this.apD;
});
$p.aNn = (function() {
  if ((!this.ap7)) {
    this.ap6 = new $c_Lcom_raquo_laminar_tags_HtmlTag("details", false);
    this.ap7 = true;
  }
  return this.ap6;
});
$p.aSB = (function() {
  if ((!this.aqG)) {
    this.aqF = new $c_Lcom_raquo_laminar_tags_HtmlTag("summary", false);
    this.aqG = true;
  }
  return this.aqF;
});
$p.ags = (function() {
  if ((!this.apu)) {
    this.apt = new $c_Lcom_raquo_laminar_keys_HtmlAttr("href", $m_Lcom_raquo_laminar_codecs_package$().bW);
    this.apu = true;
  }
  return this.apt;
});
$p.ah0 = (function() {
  if ((!this.apK)) {
    this.apJ = new $c_Lcom_raquo_laminar_keys_HtmlAttr("max", $m_Lcom_raquo_laminar_codecs_package$().bW);
    this.apK = true;
  }
  return this.apJ;
});
$p.ah3 = (function() {
  if ((!this.apO)) {
    this.apN = new $c_Lcom_raquo_laminar_keys_HtmlAttr("min", $m_Lcom_raquo_laminar_codecs_package$().bW);
    this.apO = true;
  }
  return this.apN;
});
$p.aSm = (function() {
  if ((!this.aqA)) {
    this.aqz = new $c_Lcom_raquo_laminar_keys_HtmlAttr("src", $m_Lcom_raquo_laminar_codecs_package$().bW);
    this.aqA = true;
  }
  return this.aqz;
});
$p.ai8 = (function() {
  if ((!this.aqC)) {
    this.aqB = new $c_Lcom_raquo_laminar_keys_HtmlAttr("step", $m_Lcom_raquo_laminar_codecs_package$().bW);
    this.aqC = true;
  }
  return this.aqB;
});
$p.aT7 = (function() {
  if ((!this.ar8)) {
    this.ar7 = new $c_Lcom_raquo_laminar_keys_HtmlAttr("type", $m_Lcom_raquo_laminar_codecs_package$().bW);
    this.ar8 = true;
  }
  return this.ar7;
});
$p.wl = (function() {
  if ((!this.ar6)) {
    this.ar5 = this.aT7();
    this.ar6 = true;
  }
  return this.ar5;
});
$p.yo = (function() {
  if ((!this.ar2)) {
    this.ar1 = this.aT7();
    this.ar2 = true;
  }
  return this.ar1;
});
$p.Wr = (function() {
  if ((!this.ap2)) {
    this.ap1 = new $c_Lcom_raquo_laminar_keys_HtmlProp("checked", $m_Lcom_raquo_laminar_codecs_package$().QN);
    this.ap2 = true;
  }
  return this.ap1;
});
$p.b8o = (function() {
  if ((!this.aqw)) {
    this.aqv = new $c_Lcom_raquo_laminar_keys_HtmlProp("selected", $m_Lcom_raquo_laminar_codecs_package$().QN);
    this.aqw = true;
  }
  return this.aqv;
});
$p.jx = (function() {
  if ((!this.are)) {
    this.ard = new $c_Lcom_raquo_laminar_keys_HtmlProp("value", $m_Lcom_raquo_laminar_codecs_package$().bW);
    this.are = true;
  }
  return this.ard;
});
$p.aXQ = (function() {
  if ((!this.aoW)) {
    this.aoV = new $c_Lcom_raquo_laminar_keys_HtmlProp("autofocus", $m_Lcom_raquo_laminar_codecs_package$().QN);
    this.aoW = true;
  }
  return this.aoV;
});
$p.aNw = (function() {
  if ((!this.ap9)) {
    this.ap8 = new $c_Lcom_raquo_laminar_keys_HtmlProp("disabled", $m_Lcom_raquo_laminar_codecs_package$().QN);
    this.ap9 = true;
  }
  return this.ap8;
});
$p.b1w = (function() {
  if ((!this.api)) {
    this.aph = new $c_Lcom_raquo_laminar_keys_HtmlProp("htmlFor", $m_Lcom_raquo_laminar_codecs_package$().bW);
    this.api = true;
  }
  return this.aph;
});
$p.gz = (function() {
  if ((!this.apy)) {
    this.apx = new $c_Lcom_raquo_laminar_keys_HtmlProp("id", $m_Lcom_raquo_laminar_codecs_package$().bW);
    this.apy = true;
  }
  return this.apx;
});
$p.b4r = (function() {
  if ((!this.apM)) {
    this.apL = new $c_Lcom_raquo_laminar_keys_HtmlProp("method", $m_Lcom_raquo_laminar_codecs_package$().bW);
    this.apM = true;
  }
  return this.apL;
});
$p.b4H = (function() {
  if ((!this.apQ)) {
    this.apP = new $c_Lcom_raquo_laminar_keys_HtmlProp("name", $m_Lcom_raquo_laminar_codecs_package$().bW);
    this.apQ = true;
  }
  return this.apP;
});
$p.ud = (function() {
  if ((!this.aqo)) {
    this.aqn = new $c_Lcom_raquo_laminar_keys_HtmlProp("placeholder", $m_Lcom_raquo_laminar_codecs_package$().bW);
    this.aqo = true;
  }
  return this.aqn;
});
$p.a4A = (function() {
  if ((!this.aqs)) {
    this.aqr = new $c_Lcom_raquo_laminar_keys_HtmlProp("rows", $m_Lcom_raquo_laminar_codecs_package$().a6r);
    this.aqs = true;
  }
  return this.aqr;
});
$p.wj = (function() {
  if ((!this.aqK)) {
    this.aqJ = new $c_Lcom_raquo_laminar_keys_HtmlProp("tabIndex", $m_Lcom_raquo_laminar_codecs_package$().a6r);
    this.aqK = true;
  }
  return this.aqJ;
});
$p.b9R = (function() {
  if ((!this.aqO)) {
    this.aqN = new $c_Lcom_raquo_laminar_keys_HtmlProp("target", $m_Lcom_raquo_laminar_codecs_package$().bW);
    this.aqO = true;
  }
  return this.aqN;
});
$p.eW = (function() {
  if ((!this.ar0)) {
    this.aqZ = new $c_Lcom_raquo_laminar_keys_HtmlProp("title", $m_Lcom_raquo_laminar_codecs_package$().bW);
    this.ar0 = true;
  }
  return this.aqZ;
});
$p.bR = (function() {
  if ((!this.apW)) {
    this.apV = new $c_Lcom_raquo_laminar_keys_EventProp("click");
    this.apW = true;
  }
  return this.apV;
});
$p.aQG = (function() {
  if ((!this.apY)) {
    this.apX = new $c_Lcom_raquo_laminar_keys_EventProp("dblclick");
    this.apY = true;
  }
  return this.apX;
});
$p.Av = (function() {
  if ((!this.aq8)) {
    this.aq7 = new $c_Lcom_raquo_laminar_keys_EventProp("mousedown");
    this.aq8 = true;
  }
  return this.aq7;
});
$p.a4i = (function() {
  if ((!this.aqa)) {
    this.aq9 = new $c_Lcom_raquo_laminar_keys_EventProp("mousemove");
    this.aqa = true;
  }
  return this.aq9;
});
$p.a4j = (function() {
  if ((!this.aqc)) {
    this.aqb = new $c_Lcom_raquo_laminar_keys_EventProp("mouseup");
    this.aqc = true;
  }
  return this.aqb;
});
$p.b5i = (function() {
  if ((!this.aqi)) {
    this.aqh = new $c_Lcom_raquo_laminar_keys_EventProp("wheel");
    this.aqi = true;
  }
  return this.aqh;
});
$p.Eb = (function() {
  if ((!this.apU)) {
    this.apT = new $c_Lcom_raquo_laminar_keys_EventProp("change");
    this.apU = true;
  }
  return this.apT;
});
$p.oE = (function() {
  if ((!this.aq4)) {
    this.aq3 = new $c_Lcom_raquo_laminar_keys_EventProp("input");
    this.aq4 = true;
  }
  return this.aq3;
});
$p.aQE = (function() {
  if ((!this.apS)) {
    this.apR = new $c_Lcom_raquo_laminar_keys_EventProp("blur");
    this.apS = true;
  }
  return this.apR;
});
$p.aQI = (function() {
  if ((!this.aq2)) {
    this.aq1 = new $c_Lcom_raquo_laminar_keys_EventProp("focus");
    this.aq2 = true;
  }
  return this.aq1;
});
$p.m1 = (function() {
  if ((!this.aq6)) {
    this.aq5 = new $c_Lcom_raquo_laminar_keys_EventProp("keydown");
    this.aq6 = true;
  }
  return this.aq5;
});
$p.b5f = (function() {
  if ((!this.aqe)) {
    this.aqd = new $c_Lcom_raquo_laminar_keys_EventProp("paste");
    this.aqe = true;
  }
  return this.aqd;
});
$p.ahf = (function() {
  if ((!this.aqg)) {
    this.aqf = new $c_Lcom_raquo_laminar_keys_EventProp("resize");
    this.aqg = true;
  }
  return this.aqf;
});
$p.ahe = (function() {
  if ((!this.aq0)) {
    this.apZ = new $c_Lcom_raquo_laminar_keys_EventProp("error");
    this.aq0 = true;
  }
  return this.apZ;
});
$p.XU = (function() {
  if ((!this.aqq)) {
    this.aqp = $f_Lcom_raquo_laminar_defs_complex_ComplexHtmlKeys__stringCompositeHtmlAttr__T__T__Lcom_raquo_laminar_keys_CompositeKey(this, "role", " ");
    this.aqq = true;
  }
  return this.aqp;
});
$p.PZ = (function() {
  if ((!this.aqE)) {
    this.aqD = new $c_Lcom_raquo_laminar_keys_HtmlAttr("style", $m_Lcom_raquo_laminar_codecs_package$().bW);
    this.aqE = true;
  }
  return this.aqD;
});
$p.aLt = (function() {
  if ((!this.aoO)) {
    this.aoN = $m_Lcom_raquo_airstream_web_FetchStream$();
    this.aoO = true;
  }
  return this.aoN;
});
$p.aew = (function() {
  if ((!this.aoQ)) {
    this.aoP = new $c_Lcom_raquo_laminar_keys_CompositeKey$CompositeValueMappers$StringValueMapper$(this);
    this.aoQ = true;
  }
  return this.aoP;
});
$p.Af = (function() {
  if ((!this.aoU)) {
    this.aoT = new $c_Lcom_raquo_laminar_api_Laminar$aria$(this);
    this.aoU = true;
  }
  return this.aoT;
});
$p.j = (function() {
  if ((!this.aqI)) {
    this.aqH = new $c_Lcom_raquo_laminar_api_Laminar$svg$(this);
    this.aqI = true;
  }
  return this.aqH;
});
$p.a55 = (function() {
  if ((!this.arc)) {
    this.arb = new $c_Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$(this);
    this.arc = true;
  }
  return this.arb;
});
var $d_Lcom_raquo_laminar_api_package$$anon$1 = new $TypeData().i($c_Lcom_raquo_laminar_api_package$$anon$1, "com.raquo.laminar.api.package$$anon$1", ({
  pk: 1,
  pA: 1,
  ps: 1,
  py: 1,
  d7: 1,
  pz: 1,
  pu: 1,
  pi: 1,
  p9: 1,
  ph: 1,
  el: 1,
  en: 1,
  ek: 1,
  pb: 1
}));
/** @constructor */
function $c_sc_AbstractMapView() {
}
$p = $c_sc_AbstractMapView.prototype = new $h_sc_AbstractView();
$p.constructor = $c_sc_AbstractMapView;
/** @constructor */
function $h_sc_AbstractMapView() {
}
$h_sc_AbstractMapView.prototype = $p;
$p.e6 = (function() {
  return new $c_sc_MapView$Values(this);
});
$p.aO2 = (function(pred) {
  return new $c_sc_MapView$Filter(this, false, pred);
});
$p.aO7 = (function(pred) {
  return new $c_sc_MapView$Filter(this, true, pred);
});
$p.m = (function() {
  return $f_sc_View__toString__T(this);
});
$p.el = (function() {
  return "MapView";
});
$p.ay = (function(key, default$1) {
  return $f_sc_MapOps__getOrElse__O__F0__O(this, key, default$1);
});
$p.i = (function(key) {
  return $f_sc_MapOps__apply__O__O(this, key);
});
$p.aC = (function(x, default$1) {
  return $f_sc_MapOps__applyOrElse__O__F1__O(this, x, default$1);
});
$p.lo = (function() {
  return new $c_sc_MapOps$$anon$2(this);
});
$p.hr = (function() {
  return new $c_sc_MapOps$$anon$3(this);
});
$p.WC = (function(key) {
  return $f_sc_MapOps__default__O__O(this, key);
});
$p.E = (function(key) {
  return $f_sc_MapOps__contains__O__Z(this, key);
});
$p.aM = (function(key) {
  return $f_sc_MapOps__contains__O__Z(this, key);
});
$p.kP = (function(f) {
  return $f_sc_MapOps__map__F1__sc_IterableOps(this, f);
});
$p.lf = (function(sb, start, sep, end) {
  return $f_sc_MapOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, sb, start, sep, end);
});
$p.Ar = (function() {
  return new $c_s_PartialFunction$Lifted(this);
});
$p.Eg = (function(action) {
  return $f_s_PartialFunction__runWith__F1__F1(this, action);
});
$p.iU = (function(v1) {
  return (!(!$f_sc_MapOps__apply__O__O(this, v1)));
});
$p.un = (function(p) {
  return new $c_sc_MapOps$WithFilter(this, p);
});
$p.pr = (function() {
  return $m_sc_MapView$().a1u;
});
$p.aNH = (function() {
  return $m_sc_MapView$().a1u;
});
$p.im = (function() {
  return $m_sc_MapView$();
});
$p.cE = (function(pred) {
  return this.aO7(pred);
});
$p.bw = (function(pred) {
  return this.aO2(pred);
});
function $f_sci_Map__withDefaultValue__O__sci_Map($thiz, d) {
  return new $c_sci_Map$WithDefault($thiz, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$2) => d)));
}
function $is_sci_Map(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.aV)));
}
function $isArrayOf_sci_Map(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.aV)));
}
function $f_Lupickle_MsgReadWriters__$init$__V($thiz) {
  $ct_Lupickle_core_Types$Reader$Delegate__Lupickle_core_Types$Reader$__Lupickle_core_Visitor__(new $c_Lupickle_core_Types$Reader$Delegate(), $thiz.OP(), $m_Lupack_Msg$());
  new $c_Lupickle_MsgReadWriters$$anon$1($thiz);
}
function $ps_Lcom_raquo_airstream_state_ObservedSignal__ObservedSignal$superArg$1__Lcom_raquo_airstream_core_Signal__Lcom_raquo_airstream_core_Observer__Lcom_raquo_airstream_ownership_Owner__F1(parent, observer, owner) {
  return new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x) => x));
}
/** @constructor */
function $c_Lcom_raquo_airstream_state_ObservedSignal(parent, observer, owner) {
  this.Yz = null;
  this.Yy = false;
  this.YA = null;
  this.Qx = 0;
  this.Yw = null;
  this.Yx = null;
  this.YE = false;
  this.Qz = null;
  this.YC = false;
  this.Qy = 0;
  this.YB = null;
  this.QA = null;
  this.QB = null;
  this.YD = 0;
  this.YM = null;
  this.YM = parent;
  $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(this, parent, $ps_Lcom_raquo_airstream_state_ObservedSignal__ObservedSignal$superArg$1__Lcom_raquo_airstream_core_Signal__Lcom_raquo_airstream_core_Observer__Lcom_raquo_airstream_ownership_Owner__F1(parent, observer, owner), $m_s_None$());
  $f_Lcom_raquo_airstream_core_WritableObservable__addObserver__Lcom_raquo_airstream_core_Observer__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription(this, observer, owner);
}
$p = $c_Lcom_raquo_airstream_state_ObservedSignal.prototype = new $h_Lcom_raquo_airstream_misc_MapSignal();
$p.constructor = $c_Lcom_raquo_airstream_state_ObservedSignal;
/** @constructor */
function $h_Lcom_raquo_airstream_state_ObservedSignal() {
}
$h_Lcom_raquo_airstream_state_ObservedSignal.prototype = $p;
$p.aq = (function() {
  return $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this);
});
$p.aho = (function() {
  return this.YM;
});
$p.eU = (function() {
  return (($f_Lcom_raquo_airstream_core_Named__displayName__T(this.YM) + ".observe@") + $systemIdentityHashCode(this));
});
$p.ku = (function() {
  return this.YM;
});
var $d_Lcom_raquo_airstream_state_ObservedSignal = new $TypeData().i($c_Lcom_raquo_airstream_state_ObservedSignal, "com.raquo.airstream.state.ObservedSignal", ({
  oE: 1,
  d3: 1,
  P: 1,
  O: 1,
  U: 1,
  V: 1,
  aB: 1,
  aD: 1,
  Z: 1,
  aS: 1,
  a3: 1,
  aK: 1,
  bv: 1,
  cf: 1,
  oF: 1
}));
/** @constructor */
function $c_sc_AbstractIndexedSeqView() {
}
$p = $c_sc_AbstractIndexedSeqView.prototype = new $h_sc_AbstractSeqView();
$p.constructor = $c_sc_AbstractIndexedSeqView;
/** @constructor */
function $h_sc_AbstractIndexedSeqView() {
}
$h_sc_AbstractIndexedSeqView.prototype = $p;
$p.o = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this);
});
$p.cx = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this);
});
$p.gT = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem);
});
$p.gW = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
$p.gX = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$p.gA = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$p.jZ = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$p.kw = (function(from, until) {
  return new $c_sc_IndexedSeqView$Slice(this, from, until);
});
$p.el = (function() {
  return "IndexedSeqView";
});
$p.k0 = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$p.t = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$p.dt = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$p.bJ = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$p.bL = (function(len) {
  var x = this.C();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$p.V = (function() {
  return this.C();
});
$p.hV = (function(from, until) {
  return this.kw(from, until);
});
$p.hU = (function() {
  return this.jZ();
});
$p.h4 = (function(f) {
  return this.gA(f);
});
$p.L = (function(f) {
  return this.gA(f);
});
$p.jo = (function(n) {
  return this.gX(n);
});
$p.cn = (function(n) {
  return this.gX(n);
});
$p.jn = (function(n) {
  return this.gW(n);
});
$p.ds = (function(n) {
  return this.gW(n);
});
$p.bv = (function(elem) {
  return this.gT(elem);
});
$p.jm = (function(elem) {
  return this.gT(elem);
});
function $ct_sc_MapOps$KeySet__sc_MapOps__($thiz, outer) {
  $thiz.of = outer;
  return $thiz;
}
/** @constructor */
function $c_sc_MapOps$KeySet() {
  this.of = null;
}
$p = $c_sc_MapOps$KeySet.prototype = new $h_sc_AbstractSet();
$p.constructor = $c_sc_MapOps$KeySet;
/** @constructor */
function $h_sc_MapOps$KeySet() {
}
$h_sc_MapOps$KeySet.prototype = $p;
$p.o = (function() {
  return this.of.lo();
});
$p.E = (function(key) {
  return this.of.E(key);
});
$p.aa = (function() {
  return this.of.aa();
});
$p.V = (function() {
  return this.of.V();
});
$p.c = (function() {
  return this.of.c();
});
var $d_sc_MapOps$KeySet = new $TypeData().i($c_sc_MapOps$KeySet, "scala.collection.MapOps$KeySet", ({
  kQ: 1,
  aQ: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  aG: 1,
  aR: 1,
  h: 1,
  b: 1,
  cI: 1,
  a5: 1,
  a: 1
}));
/** @constructor */
function $c_sc_MapView$$anon$1() {
}
$p = $c_sc_MapView$$anon$1.prototype = new $h_sc_AbstractMapView();
$p.constructor = $c_sc_MapView$$anon$1;
/** @constructor */
function $h_sc_MapView$$anon$1() {
}
$h_sc_MapView$$anon$1.prototype = $p;
$p.r = (function(key) {
  return $m_s_None$();
});
$p.o = (function() {
  return $m_sc_Iterator$().b8;
});
$p.V = (function() {
  return 0;
});
$p.c = (function() {
  return true;
});
$p.aO2 = (function(pred) {
  return this;
});
$p.aO7 = (function(pred) {
  return this;
});
$p.cE = (function(pred) {
  return this;
});
$p.bw = (function(pred) {
  return this;
});
var $d_sc_MapView$$anon$1 = new $TypeData().i($c_sc_MapView$$anon$1, "scala.collection.MapView$$anon$1", ({
  Hp: 1,
  bW: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1,
  bq: 1,
  ak: 1,
  i: 1,
  h: 1
}));
/** @constructor */
function $c_sc_MapView$Filter(underlying, isFlipped, p) {
  this.a1v = null;
  this.acg = false;
  this.ach = null;
  this.a1v = underlying;
  this.acg = isFlipped;
  this.ach = p;
}
$p = $c_sc_MapView$Filter.prototype = new $h_sc_AbstractMapView();
$p.constructor = $c_sc_MapView$Filter;
/** @constructor */
function $h_sc_MapView$Filter() {
}
$h_sc_MapView$Filter.prototype = $p;
$p.o = (function() {
  return new $c_sc_Iterator$$anon$6(this.a1v.o(), this.ach, this.acg);
});
$p.r = (function(key) {
  var x1 = this.a1v.r(key);
  if ((x1 instanceof $c_s_Some)) {
    var v = x1.J;
    if (((!(!this.ach.i(new $c_T2(key, v)))) !== this.acg)) {
      return x1;
    }
  }
  return $m_s_None$();
});
$p.V = (function() {
  return ((this.a1v.V() === 0) ? 0 : (-1));
});
$p.c = (function() {
  return (!this.o().p());
});
var $d_sc_MapView$Filter = new $TypeData().i($c_sc_MapView$Filter, "scala.collection.MapView$Filter", ({
  Hq: 1,
  bW: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1,
  bq: 1,
  ak: 1,
  i: 1,
  h: 1
}));
/** @constructor */
function $c_sc_MapView$FilterKeys(underlying, p) {
  this.a1w = null;
  this.aci = null;
  this.a1w = underlying;
  this.aci = p;
}
$p = $c_sc_MapView$FilterKeys.prototype = new $h_sc_AbstractMapView();
$p.constructor = $c_sc_MapView$FilterKeys;
/** @constructor */
function $h_sc_MapView$FilterKeys() {
}
$h_sc_MapView$FilterKeys.prototype = $p;
$p.o = (function() {
  return new $c_sc_Iterator$$anon$6(this.a1w.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x0$1$2$2) => {
    if ((x0$1$2$2 !== null)) {
      var k = x0$1$2$2.g();
      return (!(!this.aci.i(k)));
    } else {
      throw new $c_s_MatchError(x0$1$2$2);
    }
  })), false);
});
$p.r = (function(key) {
  return ((!(!this.aci.i(key))) ? this.a1w.r(key) : $m_s_None$());
});
$p.V = (function() {
  return ((this.a1w.V() === 0) ? 0 : (-1));
});
$p.c = (function() {
  return (!this.o().p());
});
var $d_sc_MapView$FilterKeys = new $TypeData().i($c_sc_MapView$FilterKeys, "scala.collection.MapView$FilterKeys", ({
  Hr: 1,
  bW: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1,
  bq: 1,
  ak: 1,
  i: 1,
  h: 1
}));
/** @constructor */
function $c_sc_MapView$Id(underlying) {
  this.UQ = null;
  this.UQ = underlying;
}
$p = $c_sc_MapView$Id.prototype = new $h_sc_AbstractMapView();
$p.constructor = $c_sc_MapView$Id;
/** @constructor */
function $h_sc_MapView$Id() {
}
$h_sc_MapView$Id.prototype = $p;
$p.r = (function(key) {
  return this.UQ.r(key);
});
$p.o = (function() {
  return this.UQ.o();
});
$p.V = (function() {
  return this.UQ.V();
});
$p.c = (function() {
  return this.UQ.c();
});
var $d_sc_MapView$Id = new $TypeData().i($c_sc_MapView$Id, "scala.collection.MapView$Id", ({
  Hs: 1,
  bW: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1,
  bq: 1,
  ak: 1,
  i: 1,
  h: 1
}));
/** @constructor */
function $c_sc_MapView$MapValues(underlying, f) {
  this.UR = null;
  this.acj = null;
  this.UR = underlying;
  this.acj = f;
}
$p = $c_sc_MapView$MapValues.prototype = new $h_sc_AbstractMapView();
$p.constructor = $c_sc_MapView$MapValues;
/** @constructor */
function $h_sc_MapView$MapValues() {
}
$h_sc_MapView$MapValues.prototype = $p;
$p.o = (function() {
  return new $c_sc_Iterator$$anon$9(this.UR.o(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((kv$2$2) => new $c_T2(kv$2$2.g(), this.acj.i(kv$2$2.h())))));
});
$p.r = (function(key) {
  var this$1 = this.UR.r(key);
  var f = this.acj;
  return (this$1.c() ? $m_s_None$() : new $c_s_Some(f.i(this$1.d())));
});
$p.V = (function() {
  return this.UR.V();
});
$p.c = (function() {
  return this.UR.c();
});
var $d_sc_MapView$MapValues = new $TypeData().i($c_sc_MapView$MapValues, "scala.collection.MapView$MapValues", ({
  Ht: 1,
  bW: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1,
  bq: 1,
  ak: 1,
  i: 1,
  h: 1
}));
/** @constructor */
function $c_sci_AbstractSet() {
}
$p = $c_sci_AbstractSet.prototype = new $h_sc_AbstractSet();
$p.constructor = $c_sci_AbstractSet;
/** @constructor */
function $h_sci_AbstractSet() {
}
$h_sci_AbstractSet.prototype = $p;
$p.cd = (function() {
  return $m_sci_Set$();
});
$p.jv = (function(that) {
  return $f_sci_SetOps__removedAll__sc_IterableOnce__sci_SetOps(this, that);
});
var $d_Lorg_scalajs_dom_SVGGElement = new $TypeData().i(2, "org.scalajs.dom.SVGGElement", ({
  FB: 1,
  Fz: 1,
  Ft: 1,
  Fv: 1,
  Fu: 1,
  Mh: 1,
  mm: 1,
  Fw: 1,
  Fy: 1,
  Fx: 1,
  FE: 1,
  FD: 1,
  FG: 1,
  FC: 1,
  FF: 1,
  FA: 1
}), ((x) => (x instanceof SVGGElement)));
function $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__($thiz, underlying, elem) {
  $ct_sc_SeqView$Appended__sc_SeqOps__O__($thiz, underlying, elem);
  return $thiz;
}
/** @constructor */
function $c_sc_IndexedSeqView$Appended() {
  this.NQ = null;
  this.UX = null;
  this.NN = null;
  this.a1y = null;
}
$p = $c_sc_IndexedSeqView$Appended.prototype = new $h_sc_SeqView$Appended();
$p.constructor = $c_sc_IndexedSeqView$Appended;
/** @constructor */
function $h_sc_IndexedSeqView$Appended() {
}
$h_sc_IndexedSeqView$Appended.prototype = $p;
$p.o = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this);
});
$p.cx = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this);
});
$p.gT = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem);
});
$p.gW = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
$p.gX = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$p.gA = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$p.jZ = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$p.kw = (function(from, until) {
  return new $c_sc_IndexedSeqView$Slice(this, from, until);
});
$p.el = (function() {
  return "IndexedSeqView";
});
$p.k0 = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$p.t = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$p.dt = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$p.bJ = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$p.bL = (function(len) {
  var x = this.C();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$p.V = (function() {
  return this.C();
});
$p.hV = (function(from, until) {
  return this.kw(from, until);
});
$p.hU = (function() {
  return this.jZ();
});
$p.h4 = (function(f) {
  return this.gA(f);
});
$p.L = (function(f) {
  return this.gA(f);
});
$p.jo = (function(n) {
  return this.gX(n);
});
$p.cn = (function(n) {
  return this.gX(n);
});
$p.jn = (function(n) {
  return this.gW(n);
});
$p.ds = (function(n) {
  return this.gW(n);
});
$p.bv = (function(elem) {
  return this.gT(elem);
});
$p.jm = (function(elem) {
  return this.gT(elem);
});
var $d_sc_IndexedSeqView$Appended = new $TypeData().i($c_sc_IndexedSeqView$Appended, "scala.collection.IndexedSeqView$Appended", ({
  kG: 1,
  dz: 1,
  cJ: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1,
  a4: 1,
  w: 1,
  aj: 1,
  A: 1
}));
function $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__($thiz, underlying, n) {
  $ct_sc_SeqView$Drop__sc_SeqOps__I__($thiz, underlying, n);
  return $thiz;
}
/** @constructor */
function $c_sc_IndexedSeqView$Drop() {
  this.NR = null;
  this.UY = 0;
  this.Hu = 0;
  this.NO = null;
  this.a1z = 0;
}
$p = $c_sc_IndexedSeqView$Drop.prototype = new $h_sc_SeqView$Drop();
$p.constructor = $c_sc_IndexedSeqView$Drop;
/** @constructor */
function $h_sc_IndexedSeqView$Drop() {
}
$h_sc_IndexedSeqView$Drop.prototype = $p;
$p.o = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this);
});
$p.cx = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this);
});
$p.gT = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem);
});
$p.gW = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
$p.gX = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$p.gA = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$p.jZ = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$p.kw = (function(from, until) {
  return new $c_sc_IndexedSeqView$Slice(this, from, until);
});
$p.el = (function() {
  return "IndexedSeqView";
});
$p.k0 = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$p.t = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$p.dt = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$p.bJ = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$p.bL = (function(len) {
  var x = this.C();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$p.V = (function() {
  return this.C();
});
$p.hV = (function(from, until) {
  return this.kw(from, until);
});
$p.hU = (function() {
  return this.jZ();
});
$p.h4 = (function(f) {
  return this.gA(f);
});
$p.L = (function(f) {
  return this.gA(f);
});
$p.jo = (function(n) {
  return this.gX(n);
});
$p.cn = (function(n) {
  return this.gX(n);
});
$p.jn = (function(n) {
  return this.gW(n);
});
$p.ds = (function(n) {
  return this.gW(n);
});
$p.bv = (function(elem) {
  return this.gT(elem);
});
$p.jm = (function(elem) {
  return this.gT(elem);
});
var $d_sc_IndexedSeqView$Drop = new $TypeData().i($c_sc_IndexedSeqView$Drop, "scala.collection.IndexedSeqView$Drop", ({
  kH: 1,
  dA: 1,
  cK: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1,
  a4: 1,
  w: 1,
  aj: 1,
  A: 1
}));
function $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__($thiz, underlying, n) {
  $ct_sc_SeqView$DropRight__sc_SeqOps__I__($thiz, underlying, n);
  return $thiz;
}
/** @constructor */
function $c_sc_IndexedSeqView$DropRight() {
  this.NS = null;
  this.UZ = 0;
  this.V0 = 0;
  this.a1A = null;
  this.Hr = 0;
}
$p = $c_sc_IndexedSeqView$DropRight.prototype = new $h_sc_SeqView$DropRight();
$p.constructor = $c_sc_IndexedSeqView$DropRight;
/** @constructor */
function $h_sc_IndexedSeqView$DropRight() {
}
$h_sc_IndexedSeqView$DropRight.prototype = $p;
$p.o = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this);
});
$p.cx = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this);
});
$p.gT = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem);
});
$p.gW = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
$p.gX = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$p.gA = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$p.jZ = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$p.kw = (function(from, until) {
  return new $c_sc_IndexedSeqView$Slice(this, from, until);
});
$p.el = (function() {
  return "IndexedSeqView";
});
$p.k0 = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$p.t = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$p.dt = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$p.bJ = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$p.bL = (function(len) {
  var x = this.Hr;
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$p.V = (function() {
  return this.Hr;
});
$p.hV = (function(from, until) {
  return this.kw(from, until);
});
$p.hU = (function() {
  return this.jZ();
});
$p.h4 = (function(f) {
  return this.gA(f);
});
$p.L = (function(f) {
  return this.gA(f);
});
$p.jo = (function(n) {
  return this.gX(n);
});
$p.cn = (function(n) {
  return this.gX(n);
});
$p.jn = (function(n) {
  return this.gW(n);
});
$p.ds = (function(n) {
  return this.gW(n);
});
$p.bv = (function(elem) {
  return this.gT(elem);
});
$p.jm = (function(elem) {
  return this.gT(elem);
});
var $d_sc_IndexedSeqView$DropRight = new $TypeData().i($c_sc_IndexedSeqView$DropRight, "scala.collection.IndexedSeqView$DropRight", ({
  kI: 1,
  dB: 1,
  cL: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1,
  a4: 1,
  w: 1,
  aj: 1,
  A: 1
}));
/** @constructor */
function $c_sc_IndexedSeqView$Id(underlying) {
  this.Hs = null;
  $ct_sc_SeqView$Id__sc_SeqOps__(this, underlying);
}
$p = $c_sc_IndexedSeqView$Id.prototype = new $h_sc_SeqView$Id();
$p.constructor = $c_sc_IndexedSeqView$Id;
/** @constructor */
function $h_sc_IndexedSeqView$Id() {
}
$h_sc_IndexedSeqView$Id.prototype = $p;
$p.o = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this);
});
$p.cx = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this);
});
$p.el = (function() {
  return "IndexedSeqView";
});
$p.k0 = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$p.t = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$p.dt = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$p.bJ = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$p.bL = (function(len) {
  var x = this.C();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$p.V = (function() {
  return this.C();
});
$p.hV = (function(from, until) {
  return new $c_sc_IndexedSeqView$Slice(this, from, until);
});
$p.hU = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$p.h4 = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$p.L = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$p.jo = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$p.cn = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$p.jn = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
$p.ds = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
$p.bv = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem);
});
$p.jm = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem);
});
var $d_sc_IndexedSeqView$Id = new $TypeData().i($c_sc_IndexedSeqView$Id, "scala.collection.IndexedSeqView$Id", ({
  GO: 1,
  kR: 1,
  b8: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1,
  a4: 1,
  w: 1,
  aj: 1,
  A: 1
}));
function $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__($thiz, underlying, f) {
  $ct_sc_SeqView$Map__sc_SeqOps__F1__($thiz, underlying, f);
  return $thiz;
}
/** @constructor */
function $c_sc_IndexedSeqView$Map() {
  this.Hv = null;
  this.V2 = null;
  this.US = null;
  this.a1B = null;
}
$p = $c_sc_IndexedSeqView$Map.prototype = new $h_sc_SeqView$Map();
$p.constructor = $c_sc_IndexedSeqView$Map;
/** @constructor */
function $h_sc_IndexedSeqView$Map() {
}
$h_sc_IndexedSeqView$Map.prototype = $p;
$p.o = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this);
});
$p.cx = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this);
});
$p.gT = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem);
});
$p.gW = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
$p.gX = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$p.gA = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$p.jZ = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$p.kw = (function(from, until) {
  return new $c_sc_IndexedSeqView$Slice(this, from, until);
});
$p.el = (function() {
  return "IndexedSeqView";
});
$p.k0 = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$p.t = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$p.dt = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$p.bJ = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$p.bL = (function(len) {
  var x = this.C();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$p.V = (function() {
  return this.C();
});
$p.hV = (function(from, until) {
  return this.kw(from, until);
});
$p.hU = (function() {
  return this.jZ();
});
$p.h4 = (function(f) {
  return this.gA(f);
});
$p.L = (function(f) {
  return this.gA(f);
});
$p.jo = (function(n) {
  return this.gX(n);
});
$p.cn = (function(n) {
  return this.gX(n);
});
$p.jn = (function(n) {
  return this.gW(n);
});
$p.ds = (function(n) {
  return this.gW(n);
});
$p.bv = (function(elem) {
  return this.gT(elem);
});
$p.jm = (function(elem) {
  return this.gT(elem);
});
var $d_sc_IndexedSeqView$Map = new $TypeData().i($c_sc_IndexedSeqView$Map, "scala.collection.IndexedSeqView$Map", ({
  kL: 1,
  dC: 1,
  cM: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1,
  a4: 1,
  w: 1,
  aj: 1,
  A: 1
}));
/** @constructor */
function $c_sc_IndexedSeqView$Prepended(elem, underlying) {
  this.acv = null;
  this.acw = null;
  this.ack = null;
  this.a1C = null;
  $ct_sc_SeqView$Prepended__O__sc_SeqOps__(this, elem, underlying);
}
$p = $c_sc_IndexedSeqView$Prepended.prototype = new $h_sc_SeqView$Prepended();
$p.constructor = $c_sc_IndexedSeqView$Prepended;
/** @constructor */
function $h_sc_IndexedSeqView$Prepended() {
}
$h_sc_IndexedSeqView$Prepended.prototype = $p;
$p.o = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this);
});
$p.cx = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this);
});
$p.gT = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem);
});
$p.gW = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
$p.gX = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$p.gA = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$p.jZ = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$p.kw = (function(from, until) {
  return new $c_sc_IndexedSeqView$Slice(this, from, until);
});
$p.el = (function() {
  return "IndexedSeqView";
});
$p.t = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$p.dt = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$p.bJ = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$p.bL = (function(len) {
  var x = this.C();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$p.V = (function() {
  return this.C();
});
$p.hV = (function(from, until) {
  return this.kw(from, until);
});
$p.hU = (function() {
  return this.jZ();
});
$p.h4 = (function(f) {
  return this.gA(f);
});
$p.L = (function(f) {
  return this.gA(f);
});
$p.cn = (function(n) {
  return this.gX(n);
});
$p.ds = (function(n) {
  return this.gW(n);
});
$p.bv = (function(elem) {
  return this.gT(elem);
});
var $d_sc_IndexedSeqView$Prepended = new $TypeData().i($c_sc_IndexedSeqView$Prepended, "scala.collection.IndexedSeqView$Prepended", ({
  GP: 1,
  Hx: 1,
  HV: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1,
  a4: 1,
  w: 1,
  aj: 1,
  A: 1
}));
function $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__($thiz, underlying) {
  $thiz.ac2 = underlying;
  $ct_sc_SeqView$Reverse__sc_SeqOps__($thiz, underlying);
  return $thiz;
}
/** @constructor */
function $c_sc_IndexedSeqView$Reverse() {
  this.CV = null;
  this.ac2 = null;
}
$p = $c_sc_IndexedSeqView$Reverse.prototype = new $h_sc_SeqView$Reverse();
$p.constructor = $c_sc_IndexedSeqView$Reverse;
/** @constructor */
function $h_sc_IndexedSeqView$Reverse() {
}
$h_sc_IndexedSeqView$Reverse.prototype = $p;
$p.o = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this);
});
$p.cx = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this);
});
$p.gT = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem);
});
$p.gW = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
$p.gX = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$p.gA = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$p.kw = (function(from, until) {
  return new $c_sc_IndexedSeqView$Slice(this, from, until);
});
$p.el = (function() {
  return "IndexedSeqView";
});
$p.k0 = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$p.t = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$p.dt = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$p.bJ = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$p.bL = (function(len) {
  var x = this.C();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$p.V = (function() {
  return this.C();
});
$p.jZ = (function() {
  var x1 = this.ac2;
  return ($is_sc_IndexedSeqView(x1) ? x1 : $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this));
});
$p.hV = (function(from, until) {
  return this.kw(from, until);
});
$p.h4 = (function(f) {
  return this.gA(f);
});
$p.L = (function(f) {
  return this.gA(f);
});
$p.jo = (function(n) {
  return this.gX(n);
});
$p.cn = (function(n) {
  return this.gX(n);
});
$p.jn = (function(n) {
  return this.gW(n);
});
$p.ds = (function(n) {
  return this.gW(n);
});
$p.bv = (function(elem) {
  return this.gT(elem);
});
$p.jm = (function(elem) {
  return this.gT(elem);
});
$p.hU = (function() {
  return this.jZ();
});
var $d_sc_IndexedSeqView$Reverse = new $TypeData().i($c_sc_IndexedSeqView$Reverse, "scala.collection.IndexedSeqView$Reverse", ({
  kM: 1,
  dD: 1,
  b8: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1,
  a4: 1,
  w: 1,
  aj: 1,
  A: 1
}));
/** @constructor */
function $c_sc_IndexedSeqView$Slice(underlying, from, until) {
  this.aHA = null;
  this.ac3 = 0;
  this.aHy = 0;
  this.aHz = 0;
  this.aHA = underlying;
  this.ac3 = ((from > 0) ? from : 0);
  var x = ((until > 0) ? until : 0);
  var that = underlying.C();
  this.aHy = ((x < that) ? x : that);
  var x$1 = ((this.aHy - this.ac3) | 0);
  this.aHz = ((x$1 > 0) ? x$1 : 0);
}
$p = $c_sc_IndexedSeqView$Slice.prototype = new $h_sc_AbstractIndexedSeqView();
$p.constructor = $c_sc_IndexedSeqView$Slice;
/** @constructor */
function $h_sc_IndexedSeqView$Slice() {
}
$h_sc_IndexedSeqView$Slice.prototype = $p;
$p.l = (function(i) {
  return this.aHA.l(((this.ac3 + i) | 0));
});
$p.C = (function() {
  return this.aHz;
});
var $d_sc_IndexedSeqView$Slice = new $TypeData().i($c_sc_IndexedSeqView$Slice, "scala.collection.IndexedSeqView$Slice", ({
  GQ: 1,
  cG: 1,
  b8: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1,
  a4: 1,
  w: 1,
  aj: 1,
  A: 1
}));
/** @constructor */
function $c_sc_IndexedSeqView$Take(underlying, n) {
  this.a1K = 0;
  this.UU = null;
  this.acq = 0;
  $ct_sc_SeqView$Take__sc_SeqOps__I__(this, underlying, n);
}
$p = $c_sc_IndexedSeqView$Take.prototype = new $h_sc_SeqView$Take();
$p.constructor = $c_sc_IndexedSeqView$Take;
/** @constructor */
function $h_sc_IndexedSeqView$Take() {
}
$h_sc_IndexedSeqView$Take.prototype = $p;
$p.o = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this);
});
$p.cx = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this);
});
$p.el = (function() {
  return "IndexedSeqView";
});
$p.t = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$p.dt = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$p.bJ = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$p.bL = (function(len) {
  var x = this.C();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$p.V = (function() {
  return this.C();
});
$p.hV = (function(from, until) {
  return new $c_sc_IndexedSeqView$Slice(this, from, until);
});
$p.hU = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$p.h4 = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$p.L = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$p.cn = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$p.ds = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
$p.bv = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem);
});
var $d_sc_IndexedSeqView$Take = new $TypeData().i($c_sc_IndexedSeqView$Take, "scala.collection.IndexedSeqView$Take", ({
  GR: 1,
  HA: 1,
  HZ: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1,
  a4: 1,
  w: 1,
  aj: 1,
  A: 1
}));
/** @constructor */
function $c_sci_AbstractSeq() {
}
$p = $c_sci_AbstractSeq.prototype = new $h_sc_AbstractSeq();
$p.constructor = $c_sci_AbstractSeq;
/** @constructor */
function $h_sci_AbstractSeq() {
}
$h_sci_AbstractSeq.prototype = $p;
$p.iz = (function() {
  return this;
});
/** @constructor */
function $c_scm_ArrayBufferView(underlying, mutationCount) {
  this.acU = null;
  this.zZ = null;
  this.acU = underlying;
  this.zZ = mutationCount;
}
$p = $c_scm_ArrayBufferView.prototype = new $h_sc_AbstractIndexedSeqView();
$p.constructor = $c_scm_ArrayBufferView;
/** @constructor */
function $h_scm_ArrayBufferView() {
}
$h_scm_ArrayBufferView.prototype = $p;
$p.l = (function(n) {
  return this.acU.l(n);
});
$p.C = (function() {
  return this.acU.a1;
});
$p.hM = (function() {
  return "ArrayBufferView";
});
$p.o = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedIterator(this, this.zZ);
});
$p.cx = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(this, this.zZ);
});
$p.gT = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.zZ);
});
$p.gW = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.zZ);
});
$p.gX = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.zZ);
});
$p.gA = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.zZ);
});
$p.jZ = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.zZ);
});
$p.kw = (function(from, until) {
  return new $c_scm_CheckedIndexedSeqView$Slice(this, from, until, this.zZ);
});
$p.hV = (function(from, until) {
  return this.kw(from, until);
});
$p.hU = (function() {
  return this.jZ();
});
$p.h4 = (function(f) {
  return this.gA(f);
});
$p.L = (function(f) {
  return this.gA(f);
});
$p.jo = (function(n) {
  return this.gX(n);
});
$p.cn = (function(n) {
  return this.gX(n);
});
$p.jn = (function(n) {
  return this.gW(n);
});
$p.ds = (function(n) {
  return this.gW(n);
});
$p.bv = (function(elem) {
  return this.gT(elem);
});
$p.jm = (function(elem) {
  return this.gT(elem);
});
var $d_scm_ArrayBufferView = new $TypeData().i($c_scm_ArrayBufferView, "scala.collection.mutable.ArrayBufferView", ({
  Jx: 1,
  cG: 1,
  b8: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1,
  a4: 1,
  w: 1,
  aj: 1,
  A: 1
}));
/** @constructor */
function $c_scm_LinkedHashMap$LinkedKeySet(outer) {
  this.of = null;
  $ct_sc_MapOps$KeySet__sc_MapOps__(this, outer);
}
$p = $c_scm_LinkedHashMap$LinkedKeySet.prototype = new $h_sc_MapOps$KeySet();
$p.constructor = $c_scm_LinkedHashMap$LinkedKeySet;
/** @constructor */
function $h_scm_LinkedHashMap$LinkedKeySet() {
}
$h_scm_LinkedHashMap$LinkedKeySet.prototype = $p;
$p.cd = (function() {
  return $m_scm_LinkedHashSet$();
});
var $d_scm_LinkedHashMap$LinkedKeySet = new $TypeData().i($c_scm_LinkedHashMap$LinkedKeySet, "scala.collection.mutable.LinkedHashMap$LinkedKeySet", ({
  Kb: 1,
  kQ: 1,
  aQ: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  aG: 1,
  aR: 1,
  h: 1,
  b: 1,
  cI: 1,
  a5: 1,
  a: 1
}));
/** @constructor */
function $c_sci_AbstractMap() {
}
$p = $c_sci_AbstractMap.prototype = new $h_sc_AbstractMap();
$p.constructor = $c_sci_AbstractMap;
/** @constructor */
function $h_sci_AbstractMap() {
}
$h_sci_AbstractMap.prototype = $p;
$p.im = (function() {
  return $m_sci_Map$();
});
$p.eX = (function(ev) {
  return $m_sci_Map$().ao(this);
});
$p.a5g = (function(d) {
  return $f_sci_Map__withDefaultValue__O__sci_Map(this, d);
});
$p.XS = (function(keys) {
  return $f_sci_MapOps__removedAll__sc_IterableOnce__sci_MapOps(this, keys);
});
$p.Q8 = (function(key, remappingFunction) {
  return $f_sci_MapOps__updatedWith__O__F1__sci_MapOps(this, key, remappingFunction);
});
$p.wk = (function(f) {
  return $f_sci_MapOps__transform__F2__sci_MapOps(this, f);
});
$p.ln = (function() {
  return $ct_sci_MapOps$ImmutableKeySet__sci_MapOps__(new $c_sci_MapOps$ImmutableKeySet(), this);
});
$p.cd = (function() {
  return $m_sci_Iterable$();
});
$p.a41 = (function() {
  return this.ln();
});
function $f_sci_IndexedSeq__canEqual__O__Z($thiz, that) {
  return ((!$is_sci_IndexedSeq(that)) || ($thiz.C() === that.C()));
}
function $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z($thiz, o) {
  if ($is_sci_IndexedSeq(o)) {
    if (($thiz === o)) {
      return true;
    } else {
      var length = $thiz.C();
      var equal = (length === o.C());
      if (equal) {
        var index = 0;
        var a = $thiz.OZ();
        var b = o.OZ();
        var preferredLength = ((a < b) ? a : b);
        var hi = (length >> 31);
        var hi$1 = (preferredLength >> 31);
        var lo = (preferredLength << 1);
        var hi$2 = (((preferredLength >>> 31) | 0) | (hi$1 << 1));
        if (((hi === hi$2) ? ((length >>> 0) > (lo >>> 0)) : (hi > hi$2))) {
          var maxApplyCompare = preferredLength;
        } else {
          var maxApplyCompare = length;
        }
        while (((index < maxApplyCompare) && equal)) {
          equal = $m_sr_BoxesRunTime$().Q($thiz.l(index), o.l(index));
          index = ((1 + index) | 0);
        }
        if (((index < length) && equal)) {
          var thisIt = $thiz.o().iV(index);
          var thatIt = o.o().iV(index);
          while ((equal && thisIt.p())) {
            equal = $m_sr_BoxesRunTime$().Q(thisIt.q(), thatIt.q());
          }
        }
      }
      return equal;
    }
  } else {
    return $f_sc_SeqOps__sameElements__sc_IterableOnce__Z($thiz, o);
  }
}
function $is_sci_IndexedSeq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.a7)));
}
function $isArrayOf_sci_IndexedSeq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.a7)));
}
/** @constructor */
function $c_sci_Set$EmptySet$() {
}
$p = $c_sci_Set$EmptySet$.prototype = new $h_sci_AbstractSet();
$p.constructor = $c_sci_Set$EmptySet$;
/** @constructor */
function $h_sci_Set$EmptySet$() {
}
$h_sci_Set$EmptySet$.prototype = $p;
$p.aa = (function() {
  return 0;
});
$p.c = (function() {
  return true;
});
$p.V = (function() {
  return 0;
});
$p.Q0 = (function(that) {
  return true;
});
$p.E = (function(elem) {
  return false;
});
$p.o = (function() {
  return $m_sc_Iterator$().b8;
});
$p.F = (function(f) {
});
$p.lT = (function(elem) {
  return this;
});
$p.hQ = (function(elem) {
  return new $c_sci_Set$Set1(elem);
});
$p.J3 = (function(that) {
  return this;
});
$p.jv = (function(that) {
  return this;
});
$p.cE = (function(pred) {
  return this;
});
$p.bw = (function(pred) {
  return this;
});
var $d_sci_Set$EmptySet$ = new $TypeData().i($c_sci_Set$EmptySet$, "scala.collection.immutable.Set$EmptySet$", ({
  J0: 1,
  bg: 1,
  aQ: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  aG: 1,
  aR: 1,
  h: 1,
  b: 1,
  bi: 1,
  I: 1,
  bj: 1,
  a: 1
}));
var $n_sci_Set$EmptySet$;
function $m_sci_Set$EmptySet$() {
  if ((!$n_sci_Set$EmptySet$)) {
    $n_sci_Set$EmptySet$ = new $c_sci_Set$EmptySet$();
  }
  return $n_sci_Set$EmptySet$;
}
/** @constructor */
function $c_scm_CheckedIndexedSeqView$Slice(underlying, from, until, mutationCount) {
  this.aIJ = null;
  this.ld = null;
  this.acY = 0;
  this.aIH = 0;
  this.aII = 0;
  this.aIJ = underlying;
  this.ld = mutationCount;
  this.acY = ((from > 0) ? from : 0);
  var x = ((until > 0) ? until : 0);
  var that = underlying.C();
  this.aIH = ((x < that) ? x : that);
  var x$1 = ((this.aIH - this.acY) | 0);
  this.aII = ((x$1 > 0) ? x$1 : 0);
}
$p = $c_scm_CheckedIndexedSeqView$Slice.prototype = new $h_sc_AbstractIndexedSeqView();
$p.constructor = $c_scm_CheckedIndexedSeqView$Slice;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$Slice() {
}
$h_scm_CheckedIndexedSeqView$Slice.prototype = $p;
$p.o = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedIterator(this, this.ld);
});
$p.cx = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(this, this.ld);
});
$p.gT = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.ld);
});
$p.gW = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.ld);
});
$p.gX = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.ld);
});
$p.gA = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.ld);
});
$p.jZ = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.ld);
});
$p.kw = (function(from, until) {
  return new $c_scm_CheckedIndexedSeqView$Slice(this, from, until, this.ld);
});
$p.l = (function(i) {
  return this.aIJ.l(((this.acY + i) | 0));
});
$p.C = (function() {
  return this.aII;
});
$p.hV = (function(from, until) {
  return new $c_scm_CheckedIndexedSeqView$Slice(this, from, until, this.ld);
});
$p.hU = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.ld);
});
$p.h4 = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.ld);
});
$p.L = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.ld);
});
$p.jo = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.ld);
});
$p.cn = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.ld);
});
$p.jn = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.ld);
});
$p.ds = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.ld);
});
$p.bv = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.ld);
});
$p.jm = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.ld);
});
var $d_scm_CheckedIndexedSeqView$Slice = new $TypeData().i($c_scm_CheckedIndexedSeqView$Slice, "scala.collection.mutable.CheckedIndexedSeqView$Slice", ({
  JM: 1,
  cG: 1,
  b8: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1,
  a4: 1,
  w: 1,
  aj: 1,
  A: 1,
  bI: 1
}));
function $p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__fullGraphObs__Lcom_raquo_airstream_state_OwnedSignal($thiz) {
  if ((!$thiz.aGr)) {
    var this$1 = $thiz.zC;
    var owner = $thiz.p5;
    $thiz.aGq = new $c_Lcom_raquo_airstream_state_ObservedSignal(this$1, $m_Lcom_raquo_airstream_core_Observer$().m5, owner);
    $thiz.aGr = true;
  }
  return $thiz.aGq;
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__visibleGraphObs__Lcom_raquo_airstream_state_OwnedSignal($thiz) {
  if ((!$thiz.aGW)) {
    var this$1 = $thiz.a13;
    var owner = $thiz.p5;
    $thiz.aGV = new $c_Lcom_raquo_airstream_state_ObservedSignal(this$1, $m_Lcom_raquo_airstream_core_Observer$().m5, owner);
    $thiz.aGW = true;
  }
  return $thiz.aGV;
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__selectionStrategyObs__Lcom_raquo_airstream_state_OwnedSignal($thiz) {
  if ((!$thiz.aGQ)) {
    var this$1 = $thiz.abq;
    var owner = $thiz.p5;
    $thiz.aGP = new $c_Lcom_raquo_airstream_state_ObservedSignal(this$1, $m_Lcom_raquo_airstream_core_Observer$().m5, owner);
    $thiz.aGQ = true;
  }
  return $thiz.aGP;
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__graphRankDirObs__Lcom_raquo_airstream_state_OwnedSignal($thiz) {
  if ((!$thiz.aGy)) {
    var this$1 = $thiz.b2f();
    var owner = $thiz.p5;
    $thiz.aGx = new $c_Lcom_raquo_airstream_state_ObservedSignal(this$1, $m_Lcom_raquo_airstream_core_Observer$().m5, owner);
    $thiz.aGy = true;
  }
  return $thiz.aGx;
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__currentFormatObs__Lcom_raquo_airstream_state_OwnedSignal($thiz) {
  if ((!$thiz.aGa)) {
    var this$1 = $thiz.a0Z;
    var owner = $thiz.p5;
    $thiz.aG9 = new $c_Lcom_raquo_airstream_state_ObservedSignal(this$1, $m_Lcom_raquo_airstream_core_Observer$().m5, owner);
    $thiz.aGa = true;
  }
  return $thiz.aG9;
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__elementExists__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_ElementId__Z($thiz, graph, id) {
  if ((id instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_NodeId)) {
    return graph.dQ.l8.E(id);
  }
  if ((id instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_GroupId)) {
    return graph.hu.E(id);
  }
  if ((id instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowId)) {
    return graph.fX.E(id);
  }
  throw new $c_s_MatchError(id);
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__renderInputsFor__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat__Lorg_jpablo_graphexplorer_viewer_backends_DiagramRenderInputs($thiz, format) {
  return new $c_Lorg_jpablo_graphexplorer_viewer_backends_DiagramRenderInputs($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), $thiz.a13, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((graph) => {
    var log = $thiz.d4.zx.nH();
    var x = $thiz.d4.zx;
    var x$2 = $s_Lorg_jpablo_graphexplorer_viewer_logging_Level$__None__Lorg_jpablo_graphexplorer_viewer_logging_Level();
    if ((!((x === null) ? (x$2 === null) : (x === x$2)))) {
      console.group(("4. [visibleGraph -> visibleText]: " + $m_Lorg_jpablo_graphexplorer_viewer_logging_WithLog$package$().nF()));
    }
    $m_Lorg_jpablo_graphexplorer_viewer_logging_WithLog$package$().nF();
    var a = $p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__body$proxy1$1__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__T($thiz, format, graph);
    log.i(("" + a));
    var x$3 = $thiz.d4.zx;
    var x$4 = $s_Lorg_jpablo_graphexplorer_viewer_logging_Level$__None__Lorg_jpablo_graphexplorer_viewer_logging_Level();
    if ((!((x$3 === null) ? (x$4 === null) : (x$3 === x$4)))) {
      console.groupEnd();
    }
    return a;
  })), $m_s_None$()), $thiz.aGH, $thiz.aGU);
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__finalSVGObs__Lcom_raquo_airstream_state_OwnedSignal($thiz) {
  if ((!$thiz.aGm)) {
    var this$1 = $thiz.afO();
    var owner = $thiz.p5;
    $thiz.aGl = new $c_Lcom_raquo_airstream_state_ObservedSignal(this$1, $m_Lcom_raquo_airstream_core_Observer$().m5, owner);
    $thiz.aGm = true;
  }
  return $thiz.aGl;
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__body$proxy1$1__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__T($thiz, format$2, graph$2) {
  return $thiz.CH.w3(format$2).X3(graph$2, false);
}
function $p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__body$proxy2$1__Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElementStrategy__Lorg_jpablo_graphexplorer_viewer_backends_graphviz_SvgWithPositions__Lcom_raquo_laminar_nodes_ReactiveSvgElement($thiz, strategy$2, svgWithPos$1) {
  $f_Lorg_jpablo_graphexplorer_viewer_state_LayoutStabilityOps__beforeLayoutSwap__Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElementStrategy__V($thiz, strategy$2);
  return $m_Lorg_jpablo_graphexplorer_viewer_components_svgCanvas_SvgCanvas$package$().aWj(svgWithPos$1.Lr, $thiz.aGT, $thiz, $thiz.H8, svgWithPos$1.Sy, strategy$2, $f_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__concealedCountsNow__sci_Map($thiz), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((v1, v2) => {
    if ((!(!v2))) {
      $f_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__toggleSuccessors__sci_Set__V($thiz, $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_NodeId.r().C)([v1]))));
    } else {
      $f_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps__togglePredecessors__sci_Set__V($thiz, $m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_NodeId.r().C)([v1]))));
    }
  })), $f_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps__collapsedMemberCounts__sci_Set__sci_Map($f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__fullGraphObs__Lcom_raquo_airstream_state_OwnedSignal($thiz)).d(), $thiz.gn().nh.P().aq().d()), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((n) => {
    $thiz.aH().gC($m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_ElementId.r().C)([n]))));
    $thiz.aH().aii();
  })), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((g) => {
    $thiz.aH().gC($m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_ElementId.r().C)([g]))));
    $thiz.aH().aii();
  })), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6) => {
    $f_Lorg_jpablo_graphexplorer_viewer_state_LayoutStabilityOps__afterLayoutSwap__Lorg_scalajs_dom_SVGSVGElement__Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElementStrategy__V($thiz, _$6, strategy$2);
  })));
}
/** @constructor */
function $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerState(target, graphviz, writeText, readText, setTheme, errorBus, infoBus, initialSource, initialRightPanelSection, initialLeftPanelVisible, clientSize, logLevel, owner) {
  this.xr = null;
  this.zD = null;
  this.N3 = null;
  this.U0 = 0.0;
  this.zE = null;
  this.abn = 0.0;
  this.aGG = 0.0;
  this.abm = 0.0;
  this.xq = null;
  this.a11 = null;
  this.aGT = null;
  this.N0 = null;
  this.zB = null;
  this.aGO = null;
  this.aGR = false;
  this.gs = null;
  this.vs = null;
  this.aGM = null;
  this.aGN = false;
  this.TW = null;
  this.aGE = null;
  this.aGF = false;
  this.N1 = null;
  this.TX = null;
  this.aGC = null;
  this.aGD = false;
  this.abg = null;
  this.abk = null;
  this.TY = null;
  this.TZ = null;
  this.a12 = null;
  this.aGA = null;
  this.aGB = false;
  this.aGd = null;
  this.qs = null;
  this.abi = null;
  this.H7 = null;
  this.CE = null;
  this.abf = null;
  this.abo = null;
  this.CI = null;
  this.H9 = null;
  this.H4 = null;
  this.N5 = null;
  this.CJ = null;
  this.H5 = null;
  this.abt = null;
  this.H6 = null;
  this.TV = null;
  this.abh = null;
  this.TT = null;
  this.zH = null;
  this.aGi = null;
  this.aGj = false;
  this.aGg = null;
  this.aGh = false;
  this.xs = null;
  this.N2 = null;
  this.aGe = null;
  this.aGf = false;
  this.abl = null;
  this.lI = null;
  this.MW = null;
  this.vt = null;
  this.N4 = null;
  this.U2 = null;
  this.tr = null;
  this.od = null;
  this.MZ = null;
  this.MY = null;
  this.MX = false;
  this.H3 = null;
  this.TU = null;
  this.p5 = null;
  this.aGJ = null;
  this.aGK = false;
  this.aGI = null;
  this.aGL = false;
  this.abs = null;
  this.abp = null;
  this.CF = null;
  this.abr = null;
  this.CH = null;
  this.d4 = null;
  this.mz = null;
  this.zC = null;
  this.a13 = null;
  this.a0Z = null;
  this.CG = null;
  this.abq = null;
  this.abj = null;
  this.aGq = null;
  this.aGr = false;
  this.aGV = null;
  this.aGW = false;
  this.aGP = null;
  this.aGQ = false;
  this.aGx = null;
  this.aGy = false;
  this.aG9 = null;
  this.aGa = false;
  this.CD = null;
  this.aGo = null;
  this.aGp = false;
  this.a10 = null;
  this.aG7 = null;
  this.aG8 = false;
  this.H8 = null;
  this.aGH = null;
  this.aGU = null;
  this.aGS = null;
  this.aGk = null;
  this.aGn = false;
  this.aGl = null;
  this.aGm = false;
  this.U1 = null;
  this.aG6 = null;
  this.zG = null;
  this.aG5 = null;
  this.zF = null;
  this.aGs = null;
  this.aGt = false;
  this.aGu = null;
  this.aGv = false;
  this.aGw = null;
  this.aGz = false;
  this.aGb = null;
  this.aGc = false;
  this.lI = target;
  this.MW = graphviz;
  this.vt = writeText;
  this.N4 = readText;
  this.U2 = setTheme;
  this.tr = errorBus;
  this.od = infoBus;
  this.MZ = initialSource;
  this.MY = initialRightPanelSection;
  this.MX = initialLeftPanelVisible;
  this.H3 = clientSize;
  this.TU = logLevel;
  this.p5 = owner;
  this.aG6 = new $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerState$PendingNewNode$(this);
  this.aG5 = new $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerState$PendingNewGroup$(this);
  $f_Lorg_jpablo_graphexplorer_viewer_state_SvgTransformOps__$init$__V(this);
  $f_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps__$init$__V(this);
  $f_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps__$init$__V(this);
  $f_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps__$init$__V(this);
  $f_Lorg_jpablo_graphexplorer_viewer_state_LayoutStabilityOps__$init$__V(this);
  $f_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_AddNewArrowOps__$init$__V(this);
  $f_Lorg_jpablo_graphexplorer_viewer_state_UIState__$init$__V(this);
  $f_Lorg_jpablo_graphexplorer_viewer_state_Persistence__$init$__V(this);
  this.abs = ($m_Lcom_raquo_laminar_api_package$(), new $c_Lcom_raquo_airstream_eventbus_EventBus());
  this.abp = ($m_Lcom_raquo_laminar_api_package$(), new $c_Lcom_raquo_airstream_eventbus_EventBus());
  this.CF = $m_Lcom_raquo_airstream_state_Var$().bx($m_s_None$());
  $f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription(new $c_Lcom_raquo_airstream_misc_FilterStream(new $c_Lcom_raquo_airstream_misc_StreamFromSignal(this.CF.P(), true), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3) => ((!_$3.c()) && _$3.d().J6())))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$5) => {
    $f_Lcom_raquo_airstream_state_Var__set__O__V(this.qs, $s_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$__sources__Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection());
  })), owner);
  this.abr = (initialSource.c() ? this.zH.Pw().hf : initialSource.d());
  this.CH = new $c_Lorg_jpablo_graphexplorer_viewer_backends_DefaultDiagramLanguages(graphviz, $m_s_concurrent_ExecutionContext$().ek());
  var initialSource$1 = ((this.abr === "") ? $m_s_None$() : new $c_s_Some(this.abr));
  var hiddenNodes$1 = this.gn().CB.P();
  var collapsedGroups$1 = this.gn().nh.P();
  var keepTextWhole$1 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $f_Lorg_jpablo_graphexplorer_viewer_state_Persistence__isFileBacked__Z(this)));
  var pace$1 = $m_Lorg_jpablo_graphexplorer_viewer_state_InternalPhases$().aVw();
  this.d4 = new $c_Lorg_jpablo_graphexplorer_viewer_state_InternalPhases(this.CH, initialSource$1, hiddenNodes$1, collapsedGroups$1, this.CF, logLevel, pace$1, keepTextWhole$1, errorBus.dn, owner, $m_s_concurrent_ExecutionContext$().ek());
  this.mz = this.d4.aaZ;
  this.zC = this.d4.aFF;
  this.a13 = this.d4.ab1;
  this.a0Z = this.d4.TJ;
  this.CG = this.d4.MO;
  this.abq = this.d4.aFH;
  this.abj = this.d4.TK;
  this.CD = this.d4.a0R;
  this.a10 = $m_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$().aMQ(this.gn().H0.P(), this.mz.P(), this.CG.P(), new $c_sr_AbstractFunction3_$$Lambda$d1e06cbab540de4f9f09e7182f18ea80659b9825(((name, source, format) => {
    if ((($f_T__trim__T(name) !== "") && (name !== $m_Lorg_jpablo_graphexplorer_viewer_state_PersistedDiagramState$().GY))) {
      return name;
    } else {
      var this$14 = this.CH.w3(format).a3l(source);
      return (this$14.c() ? name : this$14.d());
    }
  })));
  $f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription(new $c_Lcom_raquo_airstream_misc_StreamFromSignal(this.zC, true), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((graph) => {
    this.aH().b3T(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((graph$2) => ((id) => $p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__elementExists__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph__Lorg_jpablo_graphexplorer_viewer_models_ElementId__Z(this, graph$2, id)))(graph)));
  })), owner);
  this.H8 = new $c_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseActionVar($s_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$__Inactive__Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction());
  this.aGH = $m_Lorg_jpablo_graphexplorer_viewer_state_EditorPacing$().b6i(this.mz.P());
  this.aGU = $f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable($m_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$().li(this.gn().CB.P(), this.gn().nh.P(), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((hidden, collapsed) => ((!((hidden === null) ? null : hidden.aS).c()) || (!collapsed.c()))))));
  var this$22 = this.d4.TJ;
  var project = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((format$2) => this.CH.w3(format$2).aRD($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__renderInputsFor__Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat__Lorg_jpablo_graphexplorer_viewer_backends_DiagramRenderInputs(this, format$2))));
  this.aGS = $f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable($m_Lcom_raquo_airstream_core_Observable$().AL.mK($ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), this$22, project, $m_s_None$())));
  this.U1 = $m_Lcom_raquo_airstream_state_Var$().bx(true);
  this.zG = $m_Lcom_raquo_airstream_state_Var$().bx($m_s_None$());
  this.zF = $m_Lcom_raquo_airstream_state_Var$().bx($m_s_None$());
  $f_Lorg_jpablo_graphexplorer_viewer_state_Persistence__initializePersistence__V(this);
  $f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription(this.Pf().P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((themeName) => {
    setTheme.i($m_Lorg_jpablo_graphexplorer_viewer_components_ThemeSelect$package$().a4w(themeName));
  })), owner);
}
$p = $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerState.prototype = new $h_O();
$p.constructor = $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerState;
/** @constructor */
function $h_Lorg_jpablo_graphexplorer_viewer_state_ViewerState() {
}
$h_Lorg_jpablo_graphexplorer_viewer_state_ViewerState.prototype = $p;
$p.aH = (function() {
  if ((!this.aGR)) {
    this.aGO = new $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramSelectionOps$selection$(this);
    this.aGR = true;
  }
  return this.aGO;
});
$p.du = (function() {
  if ((!this.aGN)) {
    this.aGM = new $c_Lorg_jpablo_graphexplorer_viewer_state_RecordCellOps$recordCells$(this);
    this.aGN = true;
  }
  return this.aGM;
});
$p.b67 = (function() {
  if ((!this.aGF)) {
    this.aGE = new $c_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$NavContext$(this);
    this.aGF = true;
  }
  return this.aGE;
});
$p.b3V = (function() {
  if ((!this.aGD)) {
    this.aGC = new $c_Lorg_jpablo_graphexplorer_viewer_state_KeyboardNavOps$keyboardNav$(this);
    this.aGD = true;
  }
  return this.aGC;
});
$p.il = (function() {
  if ((!this.aGB)) {
    this.aGA = new $c_Lorg_jpablo_graphexplorer_viewer_state_VisibilityOps$hiddenElements$(this);
    this.aGB = true;
  }
  return this.aGA;
});
$p.afo = (function() {
  if ((!this.aGj)) {
    this.aGi = $f_Lorg_jpablo_graphexplorer_viewer_state_Persistence__documentSession__Lcom_raquo_airstream_core_Signal(this);
    this.aGj = true;
  }
  return this.aGi;
});
$p.b05 = (function() {
  if ((!this.aGh)) {
    this.aGg = $f_Lorg_jpablo_graphexplorer_viewer_state_Persistence__documentDirty__Lcom_raquo_airstream_core_Signal(this);
    this.aGh = true;
  }
  return this.aGg;
});
$p.b04 = (function() {
  if ((!this.aGf)) {
    this.aGe = $f_Lorg_jpablo_graphexplorer_viewer_state_Persistence__documentConflict__Lcom_raquo_airstream_core_Signal(this);
    this.aGf = true;
  }
  return this.aGe;
});
$p.H = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.x = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().k(acc, (-1513831041));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.lI));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.MW));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.vt));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.N4));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.U2));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.tr));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.od));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.MZ));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.MY));
  acc = $m_sr_Statics$().k(acc, (this.MX ? 1231 : 1237));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.H3));
  acc = $m_sr_Statics$().k(acc, $m_sr_Statics$().u(this.TU));
  return $m_sr_Statics$().Z(acc, 12);
});
$p.e = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerState)) {
    if ((this.MX === x$0.MX)) {
      var x = this.lI;
      var x$2 = x$0.lI;
      var $x_10 = ((x === null) ? (x$2 === null) : x.e(x$2));
    } else {
      var $x_10 = false;
    }
    if ($x_10) {
      var x$3 = this.MW;
      var x$4 = x$0.MW;
      var $x_9 = ((x$3 === null) ? (x$4 === null) : (x$3 === x$4));
    } else {
      var $x_9 = false;
    }
    if ($x_9) {
      var x$5 = this.vt;
      var x$6 = x$0.vt;
      var $x_8 = ((x$5 === null) ? (x$6 === null) : x$5.e(x$6));
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$7 = this.N4;
      var x$8 = x$0.N4;
      var $x_7 = ((x$7 === null) ? (x$8 === null) : (x$7 === x$8));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$9 = this.U2;
      var x$10 = x$0.U2;
      var $x_6 = ((x$9 === null) ? (x$10 === null) : x$9.e(x$10));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$11 = this.tr;
      var x$12 = x$0.tr;
      var $x_5 = ((x$11 === null) ? (x$12 === null) : (x$11 === x$12));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$13 = this.od;
      var x$14 = x$0.od;
      var $x_4 = ((x$13 === null) ? (x$14 === null) : (x$13 === x$14));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$15 = this.MZ;
      var x$16 = x$0.MZ;
      var $x_3 = ((x$15 === null) ? (x$16 === null) : x$15.e(x$16));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$17 = this.MY;
      var x$18 = x$0.MY;
      var $x_2 = ((x$17 === null) ? (x$18 === null) : (x$17 === x$18));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$19 = this.H3;
      var x$20 = x$0.H3;
      var $x_1 = ((x$19 === null) ? (x$20 === null) : (x$19 === x$20));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$21 = this.TU;
      var x$22 = x$0.TU;
      return ((x$21 === null) ? (x$22 === null) : (x$21 === x$22));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $m_sr_ScalaRunTime$().M(this);
});
$p.z = (function() {
  return 12;
});
$p.B = (function() {
  return "ViewerState";
});
$p.A = (function(n) {
  switch (n) {
    case 0: {
      return this.lI;
      break;
    }
    case 1: {
      return this.MW;
      break;
    }
    case 2: {
      return this.vt;
      break;
    }
    case 3: {
      return this.N4;
      break;
    }
    case 4: {
      return this.U2;
      break;
    }
    case 5: {
      return this.tr;
      break;
    }
    case 6: {
      return this.od;
      break;
    }
    case 7: {
      return this.MZ;
      break;
    }
    case 8: {
      return this.MY;
      break;
    }
    case 9: {
      return this.MX;
      break;
    }
    case 10: {
      return this.H3;
      break;
    }
    case 11: {
      return this.TU;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function(n) {
  switch (n) {
    case 0: {
      return "target";
      break;
    }
    case 1: {
      return "graphviz";
      break;
    }
    case 2: {
      return "writeText";
      break;
    }
    case 3: {
      return "readText";
      break;
    }
    case 4: {
      return "setTheme";
      break;
    }
    case 5: {
      return "errorBus";
      break;
    }
    case 6: {
      return "infoBus";
      break;
    }
    case 7: {
      return "initialSource";
      break;
    }
    case 8: {
      return "initialRightPanelSection";
      break;
    }
    case 9: {
      return "initialLeftPanelVisible";
      break;
    }
    case 10: {
      return "clientSize";
      break;
    }
    case 11: {
      return "logLevel";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.aRb = (function() {
  if ((!this.aGK)) {
    matchResult4: {
      var $x_1;
      var x5 = this.lI;
      if ((x5 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$LibraryDiagram)) {
        var $x_1 = x5.xp;
        break matchResult4;
      }
      if ((x5 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$Example)) {
        var $x_1 = new $c_Lorg_jpablo_graphexplorer_viewer_state_ProjectId(("example-" + x5.TS));
        break matchResult4;
      }
      if ((x5 instanceof $c_Lorg_jpablo_graphexplorer_viewer_state_ViewTarget$LooseFile)) {
        var $x_1 = new $c_Lorg_jpablo_graphexplorer_viewer_state_ProjectId(x5.tq.Cv);
        break matchResult4;
      }
      throw new $c_s_MatchError(x5);
    }
    this.aGJ = $x_1;
    this.aGK = true;
  }
  return this.aGJ;
});
$p.gn = (function() {
  if ((!this.aGL)) {
    this.aGI = new $c_Lorg_jpablo_graphexplorer_viewer_state_ProjectOps($m_Lcom_raquo_airstream_state_Var$().bx(new $c_Lorg_jpablo_graphexplorer_viewer_state_Project(this.aRb(), "", false, new $c_Lorg_jpablo_graphexplorer_viewer_state_ProjectSettings($m_sci_Nil$(), $m_sci_Nil$(), $m_sci_Nil$()), new $c_Lorg_jpablo_graphexplorer_viewer_state_Page($f_Lorg_jpablo_graphexplorer_viewer_utils_UtilsPlatform__randomUUID__T($m_Lorg_jpablo_graphexplorer_viewer_utils_Utils$()), $m_sci_Set$EmptySet$(), $m_sci_Set$EmptySet$(), new $c_Lorg_jpablo_graphexplorer_viewer_state_DiagramOptions(false, false)))), this.p5);
    this.aGL = true;
  }
  return this.aGI;
});
$p.aS5 = (function(format) {
  $m_Lcom_raquo_airstream_state_Var$().Y1($m_sr_ScalaRunTime$().hP(new ($d_Lcom_raquo_airstream_state_Var$VarTuple.r().C)([new $c_Lcom_raquo_airstream_state_Var$VarTuple(new $c_T2(this.CD, false)), new $c_Lcom_raquo_airstream_state_Var$VarTuple(new $c_T2(this.CG, format))])));
});
$p.a3t = (function() {
  if ((!this.aGp)) {
    this.aGo = new $c_Lorg_jpablo_graphexplorer_viewer_state_ViewerState$formatOption$(this);
    this.aGp = true;
  }
  return this.aGo;
});
$p.aXR = (function() {
  if ((!this.aG8)) {
    var this$3 = this.CH.aWU();
    var f = ((backend) => new $c_T2(backend.aOk(), backend.agw()));
    if ((this$3 === $m_sci_Nil$())) {
      var $x_1 = $m_sci_Nil$();
    } else {
      var x0 = this$3.t();
      var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
      var t = h;
      var rest = this$3.v();
      while ((rest !== $m_sci_Nil$())) {
        var x0$1 = rest.t();
        var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
        t.U = nx;
        t = nx;
        rest = rest.v();
      }
      var $x_1 = h;
    }
    this.aG7 = $x_1;
    this.aG8 = true;
  }
  return this.aG7;
});
$p.afY = (function(format) {
  return this.CH.w3(format).agw();
});
$p.afO = (function() {
  if ((!this.aGn)) {
    this.aGk = $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), $m_Lcom_raquo_airstream_combine_generated_CombinableSignal$().vV(this.aGS, this.abq, new $c_Lapp_tulz_tuplez_Composition\uff3fPri0$$anon$1()), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1) => {
      var svgOpt = x$1.g();
      var strategy = x$1.h();
      if (svgOpt.c()) {
        return $m_s_None$();
      } else {
        var x0 = svgOpt.d();
        var log = this.d4.zx.nH();
        var x = this.d4.zx;
        var x$2 = $s_Lorg_jpablo_graphexplorer_viewer_logging_Level$__None__Lorg_jpablo_graphexplorer_viewer_logging_Level();
        if ((!((x === null) ? (x$2 === null) : (x === x$2)))) {
          console.group(("5. [visibleText -> SVG]: " + $m_Lorg_jpablo_graphexplorer_viewer_logging_WithLog$package$().nF()));
        }
        $m_Lorg_jpablo_graphexplorer_viewer_logging_WithLog$package$().nF();
        var a = $p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__body$proxy2$1__Lorg_jpablo_graphexplorer_viewer_components_selection_SelectableElementStrategy__Lorg_jpablo_graphexplorer_viewer_backends_graphviz_SvgWithPositions__Lcom_raquo_laminar_nodes_ReactiveSvgElement(this, strategy, x0);
        log.i(("" + a));
        var x$3 = this.d4.zx;
        var x$4 = $s_Lorg_jpablo_graphexplorer_viewer_logging_Level$__None__Lorg_jpablo_graphexplorer_viewer_logging_Level();
        if ((!((x$3 === null) ? (x$4 === null) : (x$3 === x$4)))) {
          console.groupEnd();
        }
        return new $c_s_Some(a);
      }
    })), $m_s_None$());
    this.aGn = true;
  }
  return this.aGk;
});
$p.a33 = (function(attributes, direction) {
  if ((!(!this.U1.P().aq().d()))) {
    $f_Lcom_raquo_airstream_state_Var__set__O__V(this.zG, new $c_s_Some(this.aG6.aXr(attributes, direction)));
  } else {
    this.aLR(attributes, direction);
  }
});
$p.aZq = (function(elementIds) {
  $f_Lcom_raquo_airstream_state_Var__set__O__V(this.zF, new $c_s_Some(this.aG5.aXv(elementIds)));
});
$p.aZr = (function(elementIds, label) {
  var applies = this.d4.u5();
  $f_Lcom_raquo_airstream_state_Var__update__F1__V(this.d4.jI, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$7) => $f_Lorg_jpablo_graphexplorer_viewer_graph_GroupsOps__moveToNewGroup__sci_Set__T__Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(_$7, elementIds, label))));
  if (applies) {
    var updatedGraph = $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__fullGraphObs__Lcom_raquo_airstream_state_OwnedSignal(this)).d();
    var memberIds = elementIds.ct(new $c_Lorg_jpablo_graphexplorer_viewer_models_ElementIds$$anon$1());
    var this$3 = $f_sc_IterableOps__headOption__s_Option(memberIds);
    if (this$3.c()) {
      var $x_1 = $m_s_None$();
    } else {
      var x0 = this$3.d();
      var $x_1 = updatedGraph.go.r(x0);
    }
    var this$4 = $x_1;
    if ((!this$4.c())) {
      var x0$1 = this$4.d();
      this.aH().rd($m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_ElementId.r().C)([x0$1]))));
    }
  }
});
$p.aLR = (function(attributes, direction) {
  var applies = this.d4.u5();
  $f_Lcom_raquo_airstream_state_Var__update__F1__V(this.d4.jI, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((fullGraph) => {
    var sel = this.aH().cL();
    var selectedElementId = (sel.c() ? $m_s_None$() : new $c_s_Some(sel.t()));
    matchResult13: {
      var \u03b41$___1;
      var \u03b41$___2;
      var x33 = fullGraph.aWH(selectedElementId, attributes, direction);
      if ((x33 !== null)) {
        var \u03b41$___1 = x33.bH;
        var \u03b41$___2 = x33.bU;
        break matchResult13;
      }
      throw new $c_s_MatchError(x33);
    }
    var newGraph$2 = \u03b41$___1;
    var newNodeId$2 = \u03b41$___2;
    if (applies) {
      this.aH().gC($m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_ElementId.r().C)([newNodeId$2]))));
    }
    return newGraph$2;
  })));
});
$p.aeC = (function(from, to, fromCell, toCell) {
  var applies = this.d4.u5();
  $f_Lcom_raquo_airstream_state_Var__update__F1__V(this.d4.jI, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((g) => {
    matchResult14: {
      var \u03b42$___1;
      var \u03b42$___2;
      var x37 = this.du().ahH(g, from, fromCell);
      if ((x37 !== null)) {
        var \u03b42$___1 = x37.g();
        var \u03b42$___2 = x37.h();
        break matchResult14;
      }
      throw new $c_s_MatchError(x37);
    }
    var g1$2 = \u03b42$___1;
    var fromPort$2 = \u03b42$___2;
    matchResult15: {
      var \u03b43$___1;
      var \u03b43$___2;
      var x40 = this.du().ahH(g1$2, to, toCell);
      if ((x40 !== null)) {
        var \u03b43$___1 = x40.g();
        var \u03b43$___2 = x40.h();
        break matchResult15;
      }
      throw new $c_s_MatchError(x40);
    }
    var g2$2 = \u03b43$___1;
    var toPort$2 = \u03b43$___2;
    matchResult16: {
      var g3$2;
      var x43 = g2$2.a2C(from, to, fromPort$2, toPort$2);
      if ((x43 !== null)) {
        var g3$2 = x43.g();
        break matchResult16;
      }
      throw new $c_s_MatchError(x43);
    }
    if (applies) {
      this.aH().rd($m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_ElementId.r().C)([from]))));
    }
    return g3$2;
  })));
});
$p.b4v = (function(arrowId, newEndpoint, cell) {
  var applies = this.d4.u5();
  $f_Lcom_raquo_airstream_state_Var__update__F1__V(this.d4.jI, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((g) => {
    matchResult17: {
      var endpointNode;
      if ((newEndpoint instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowEndpointId$SourceId)) {
        var endpointNode = newEndpoint.MI;
        break matchResult17;
      }
      if ((newEndpoint instanceof $c_Lorg_jpablo_graphexplorer_viewer_models_ArrowEndpointId$TargetId)) {
        var endpointNode = newEndpoint.MJ;
        break matchResult17;
      }
      throw new $c_s_MatchError(newEndpoint);
    }
    matchResult18: {
      var \u03b44$___1;
      var \u03b44$___2;
      var x53 = this.du().ahH(g, endpointNode, cell);
      if ((x53 !== null)) {
        var \u03b44$___1 = x53.g();
        var \u03b44$___2 = x53.h();
        break matchResult18;
      }
      throw new $c_s_MatchError(x53);
    }
    var g1$2 = \u03b44$___1;
    var port$2 = \u03b44$___2;
    matchResult19: {
      var \u03b45$___1;
      var \u03b45$___2;
      var x56 = g1$2.b4w(arrowId, newEndpoint, port$2);
      if ((x56 !== null)) {
        var \u03b45$___1 = x56.g();
        var \u03b45$___2 = x56.h();
        break matchResult19;
      }
      throw new $c_s_MatchError(x56);
    }
    var g2$2 = \u03b45$___1;
    var newArrowId$2 = \u03b45$___2;
    if (applies) {
      this.aH().rd($m_sci_Set$().af($m_sr_ScalaRunTime$().f(new ($d_Lorg_jpablo_graphexplorer_viewer_models_ElementId.r().C)([newArrowId$2]))));
    }
    return g2$2;
  })));
});
$p.b2h = (function() {
  return $f_Lcom_raquo_airstream_state_Var__zoomLazy__F1__F2__Lcom_raquo_airstream_state_Var(this.d4.jI, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$8) => _$8.iC)), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((g, tpe) => new $c_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraph(g.aA, g.j7, tpe, g.jG, g.jF, g.i0))));
});
$p.aOZ = (function() {
  if ((!this.aGt)) {
    this.aGs = $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), this.zC, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$9) => new $c_Lorg_jpablo_graphexplorer_viewer_models_Attributes(_$9.aA.dW))), $m_s_None$());
    this.aGt = true;
  }
  return this.aGs;
});
$p.Pq = (function() {
  if ((!this.aGv)) {
    this.aGu = $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), this.aOZ(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$10) => {
      var _$10$1 = ((_$10 === null) ? null : _$10.ce);
      return $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().E0(_$10$1, $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$());
    })), $m_s_None$());
    this.aGv = true;
  }
  return this.aGu;
});
$p.b2f = (function() {
  if ((!this.aGz)) {
    this.aGw = $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), this.aOZ(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$11) => {
      var _$11$1 = ((_$11 === null) ? null : _$11.ce);
      return $m_Lorg_jpablo_graphexplorer_viewer_models_Attributes$().E0(_$11$1, $m_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$());
    })), $m_s_None$());
    this.aGz = true;
  }
  return this.aGw;
});
$p.aNp = (function() {
  var va = this.d4.jI;
  var lens = $m_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$().aZU();
  return $f_Lcom_raquo_airstream_state_Var__zoomLazy__F1__F2__Lcom_raquo_airstream_state_Var(va, lens.MK, lens.ML);
});
$p.aYt = (function() {
  $f_Lcom_raquo_airstream_state_Var__set__O__V(this.gn().nh, $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__fullGraphObs__Lcom_raquo_airstream_state_OwnedSignal(this)).d().xf.lT($m_Lorg_jpablo_graphexplorer_viewer_graph_ViewerGraphElements$().p4));
});
$p.b0Y = (function() {
  $f_Lcom_raquo_airstream_state_Var__set__O__V(this.gn().nh, $m_sci_Set$EmptySet$());
});
$p.bal = (function(groupId) {
  $f_Lcom_raquo_airstream_state_Var__update__F1__V(this.gn().nh, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((gs) => (gs.E(groupId) ? gs.lT(groupId) : gs.hQ(groupId)))));
});
$p.b3k = (function(groupId) {
  return $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), this.gn().nh.P(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$12) => _$12.E(groupId))), $m_s_None$());
});
$p.a3b = (function(elementIds) {
  var va = this.d4.jI;
  var lens = $m_Lorg_jpablo_graphexplorer_viewer_graph_AttributesOps$().b0p($f_Lorg_jpablo_graphexplorer_viewer_graph_CollapseOps__resolveProxies__sci_Set__sci_Set($f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($p_Lorg_jpablo_graphexplorer_viewer_state_ViewerState__visibleGraphObs__Lcom_raquo_airstream_state_OwnedSignal(this)).d(), elementIds));
  return $f_Lcom_raquo_airstream_state_Var__zoomLazy__F1__F2__Lcom_raquo_airstream_state_Var(va, lens.MK, lens.ML);
});
$p.Pf = (function() {
  if ((!this.aGc)) {
    this.aGb = $m_Lcom_raquo_airstream_state_Var$().bx($m_s_None$());
    this.aGc = true;
  }
  return this.aGb;
});
function $isArrayOf_Lorg_jpablo_graphexplorer_viewer_state_ViewerState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.k0)));
}
var $d_Lorg_jpablo_graphexplorer_viewer_state_ViewerState = new $TypeData().i($c_Lorg_jpablo_graphexplorer_viewer_state_ViewerState, "org.jpablo.graphexplorer.viewer.state.ViewerState", ({
  k0: 1,
  Ev: 1,
  DM: 1,
  DH: 1,
  Ek: 1,
  DZ: 1,
  E4: 1,
  EK: 1,
  DV: 1,
  DW: 1,
  EM: 1,
  ET: 1,
  EP: 1,
  EC: 1,
  Eg: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_sc_StringView(s) {
  this.Ht = null;
  this.Ht = s;
}
$p = $c_sc_StringView.prototype = new $h_sc_AbstractIndexedSeqView();
$p.constructor = $c_sc_StringView;
/** @constructor */
function $h_sc_StringView() {
}
$h_sc_StringView.prototype = $p;
$p.C = (function() {
  return this.Ht.length;
});
$p.m = (function() {
  return (("StringView(" + this.Ht) + ")");
});
$p.B = (function() {
  return "StringView";
});
$p.z = (function() {
  return 1;
});
$p.A = (function(x$1) {
  return ((x$1 === 0) ? this.Ht : $m_sr_Statics$().ey(x$1));
});
$p.H = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$p.D = (function(x$1) {
  return ((x$1 === 0) ? "s" : $m_sr_Statics$().ey(x$1));
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().ab(this, (-351294208), true);
});
$p.e = (function(x$1) {
  return ((this === x$1) || ((x$1 instanceof $c_sc_StringView) && (this.Ht === x$1.Ht)));
});
$p.l = (function(i) {
  return $bC(this.Ht.charCodeAt(i));
});
function $isArrayOf_sc_StringView(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kT)));
}
var $d_sc_StringView = new $TypeData().i($c_sc_StringView, "scala.collection.StringView", ({
  kT: 1,
  cG: 1,
  b8: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1,
  a4: 1,
  w: 1,
  aj: 1,
  A: 1,
  c: 1,
  b: 1
}));
function $isArrayOf_sci_SeqMap$SeqMap1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.IV)));
}
function $isArrayOf_sci_SeqMap$SeqMap2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.IW)));
}
function $isArrayOf_sci_SeqMap$SeqMap3(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.IX)));
}
function $isArrayOf_sci_SeqMap$SeqMap4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.IY)));
}
/** @constructor */
function $c_sci_Set$Set1(elem1) {
  this.tI = null;
  this.tI = elem1;
}
$p = $c_sci_Set$Set1.prototype = new $h_sci_AbstractSet();
$p.constructor = $c_sci_Set$Set1;
/** @constructor */
function $h_sci_Set$Set1() {
}
$h_sci_Set$Set1.prototype = $p;
$p.ju = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
});
$p.fa = (function(asPair) {
  return $f_sc_StrictOptimizedIterableOps__unzip__F1__T2(this, asPair);
});
$p.L = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$p.c5 = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.ct = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.dk = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bw = (function(pred) {
  return this.w1(pred, false);
});
$p.cE = (function(pred) {
  return this.w1(pred, true);
});
$p.fy = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__partitionMap__F1__T2(this, f);
});
$p.cn = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$p.aa = (function() {
  return 1;
});
$p.c = (function() {
  return false;
});
$p.V = (function() {
  return 1;
});
$p.E = (function(elem) {
  return $m_sr_BoxesRunTime$().Q(elem, this.tI);
});
$p.w5 = (function(elem) {
  return (this.E(elem) ? this : new $c_sci_Set$Set2(this.tI, elem));
});
$p.vZ = (function(elem) {
  return ($m_sr_BoxesRunTime$().Q(elem, this.tI) ? $m_sci_Set$EmptySet$() : this);
});
$p.o = (function() {
  return new $c_sc_Iterator$$anon$20(this.tI);
});
$p.F = (function(f) {
  f.i(this.tI);
});
$p.lU = (function(p) {
  return (!(!p.i(this.tI)));
});
$p.lV = (function(p) {
  return (!(!p.i(this.tI)));
});
$p.w1 = (function(pred, isFlipped) {
  return (((!(!pred.i(this.tI))) !== isFlipped) ? this : $m_sci_Set$EmptySet$());
});
$p.iW = (function(p) {
  return ((!(!p.i(this.tI))) ? new $c_s_Some(this.tI) : $m_s_None$());
});
$p.t = (function() {
  return this.tI;
});
$p.lT = (function(elem) {
  return this.vZ(elem);
});
$p.hQ = (function(elem) {
  return this.w5(elem);
});
function $isArrayOf_sci_Set$Set1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.lk)));
}
var $d_sci_Set$Set1 = new $TypeData().i($c_sci_Set$Set1, "scala.collection.immutable.Set$Set1", ({
  lk: 1,
  bg: 1,
  aQ: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  aG: 1,
  aR: 1,
  h: 1,
  b: 1,
  bi: 1,
  I: 1,
  bj: 1,
  z: 1,
  a: 1
}));
/** @constructor */
function $c_sci_Set$Set2(elem1, elem2) {
  this.pa = null;
  this.qB = null;
  this.pa = elem1;
  this.qB = elem2;
}
$p = $c_sci_Set$Set2.prototype = new $h_sci_AbstractSet();
$p.constructor = $c_sci_Set$Set2;
/** @constructor */
function $h_sci_Set$Set2() {
}
$h_sci_Set$Set2.prototype = $p;
$p.ju = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
});
$p.fa = (function(asPair) {
  return $f_sc_StrictOptimizedIterableOps__unzip__F1__T2(this, asPair);
});
$p.L = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$p.c5 = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.ct = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.dk = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bw = (function(pred) {
  return this.w1(pred, false);
});
$p.cE = (function(pred) {
  return this.w1(pred, true);
});
$p.fy = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__partitionMap__F1__T2(this, f);
});
$p.cn = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$p.aa = (function() {
  return 2;
});
$p.c = (function() {
  return false;
});
$p.V = (function() {
  return 2;
});
$p.E = (function(elem) {
  return ($m_sr_BoxesRunTime$().Q(elem, this.pa) || $m_sr_BoxesRunTime$().Q(elem, this.qB));
});
$p.w5 = (function(elem) {
  return (this.E(elem) ? this : new $c_sci_Set$Set3(this.pa, this.qB, elem));
});
$p.vZ = (function(elem) {
  return ($m_sr_BoxesRunTime$().Q(elem, this.pa) ? new $c_sci_Set$Set1(this.qB) : ($m_sr_BoxesRunTime$().Q(elem, this.qB) ? new $c_sci_Set$Set1(this.pa) : this));
});
$p.o = (function() {
  return new $c_sci_Set$Set2$$anon$1(this);
});
$p.b88 = (function(i) {
  switch (i) {
    case 0: {
      return this.pa;
      break;
    }
    case 1: {
      return this.qB;
      break;
    }
    default: {
      throw new $c_s_MatchError(i);
    }
  }
});
$p.F = (function(f) {
  f.i(this.pa);
  f.i(this.qB);
});
$p.lU = (function(p) {
  return ((!(!p.i(this.pa))) || (!(!p.i(this.qB))));
});
$p.lV = (function(p) {
  return ((!(!p.i(this.pa))) && (!(!p.i(this.qB))));
});
$p.w1 = (function(pred, isFlipped) {
  var r1 = null;
  var n = 0;
  if (((!(!pred.i(this.pa))) !== isFlipped)) {
    r1 = this.pa;
    n = ((1 + n) | 0);
  }
  if (((!(!pred.i(this.qB))) !== isFlipped)) {
    if ((n === 0)) {
      r1 = this.qB;
    }
    n = ((1 + n) | 0);
  }
  var x1 = n;
  switch (x1) {
    case 0: {
      return $m_sci_Set$EmptySet$();
      break;
    }
    case 1: {
      return new $c_sci_Set$Set1(r1);
      break;
    }
    case 2: {
      return this;
      break;
    }
    default: {
      throw new $c_s_MatchError(x1);
    }
  }
});
$p.iW = (function(p) {
  return ((!(!p.i(this.pa))) ? new $c_s_Some(this.pa) : ((!(!p.i(this.qB))) ? new $c_s_Some(this.qB) : $m_s_None$()));
});
$p.t = (function() {
  return this.pa;
});
$p.lT = (function(elem) {
  return this.vZ(elem);
});
$p.hQ = (function(elem) {
  return this.w5(elem);
});
function $isArrayOf_sci_Set$Set2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ll)));
}
var $d_sci_Set$Set2 = new $TypeData().i($c_sci_Set$Set2, "scala.collection.immutable.Set$Set2", ({
  ll: 1,
  bg: 1,
  aQ: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  aG: 1,
  aR: 1,
  h: 1,
  b: 1,
  bi: 1,
  I: 1,
  bj: 1,
  z: 1,
  a: 1
}));
/** @constructor */
function $c_sci_Set$Set3(elem1, elem2, elem3) {
  this.ol = null;
  this.om = null;
  this.on = null;
  this.ol = elem1;
  this.om = elem2;
  this.on = elem3;
}
$p = $c_sci_Set$Set3.prototype = new $h_sci_AbstractSet();
$p.constructor = $c_sci_Set$Set3;
/** @constructor */
function $h_sci_Set$Set3() {
}
$h_sci_Set$Set3.prototype = $p;
$p.ju = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
});
$p.fa = (function(asPair) {
  return $f_sc_StrictOptimizedIterableOps__unzip__F1__T2(this, asPair);
});
$p.L = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$p.c5 = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.ct = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.dk = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bw = (function(pred) {
  return this.w1(pred, false);
});
$p.cE = (function(pred) {
  return this.w1(pred, true);
});
$p.fy = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__partitionMap__F1__T2(this, f);
});
$p.cn = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$p.aa = (function() {
  return 3;
});
$p.c = (function() {
  return false;
});
$p.V = (function() {
  return 3;
});
$p.E = (function(elem) {
  return (($m_sr_BoxesRunTime$().Q(elem, this.ol) || $m_sr_BoxesRunTime$().Q(elem, this.om)) || $m_sr_BoxesRunTime$().Q(elem, this.on));
});
$p.w5 = (function(elem) {
  return (this.E(elem) ? this : new $c_sci_Set$Set4(this.ol, this.om, this.on, elem));
});
$p.vZ = (function(elem) {
  return ($m_sr_BoxesRunTime$().Q(elem, this.ol) ? new $c_sci_Set$Set2(this.om, this.on) : ($m_sr_BoxesRunTime$().Q(elem, this.om) ? new $c_sci_Set$Set2(this.ol, this.on) : ($m_sr_BoxesRunTime$().Q(elem, this.on) ? new $c_sci_Set$Set2(this.ol, this.om) : this)));
});
$p.o = (function() {
  return new $c_sci_Set$Set3$$anon$2(this);
});
$p.b89 = (function(i) {
  switch (i) {
    case 0: {
      return this.ol;
      break;
    }
    case 1: {
      return this.om;
      break;
    }
    case 2: {
      return this.on;
      break;
    }
    default: {
      throw new $c_s_MatchError(i);
    }
  }
});
$p.F = (function(f) {
  f.i(this.ol);
  f.i(this.om);
  f.i(this.on);
});
$p.lU = (function(p) {
  return (((!(!p.i(this.ol))) || (!(!p.i(this.om)))) || (!(!p.i(this.on))));
});
$p.lV = (function(p) {
  return (((!(!p.i(this.ol))) && (!(!p.i(this.om)))) && (!(!p.i(this.on))));
});
$p.w1 = (function(pred, isFlipped) {
  var r1 = null;
  var r2 = null;
  var n = 0;
  if (((!(!pred.i(this.ol))) !== isFlipped)) {
    r1 = this.ol;
    n = ((1 + n) | 0);
  }
  if (((!(!pred.i(this.om))) !== isFlipped)) {
    if ((n === 0)) {
      r1 = this.om;
    } else {
      r2 = this.om;
    }
    n = ((1 + n) | 0);
  }
  if (((!(!pred.i(this.on))) !== isFlipped)) {
    if ((n === 0)) {
      r1 = this.on;
    } else if ((n === 1)) {
      r2 = this.on;
    }
    n = ((1 + n) | 0);
  }
  var x1 = n;
  switch (x1) {
    case 0: {
      return $m_sci_Set$EmptySet$();
      break;
    }
    case 1: {
      return new $c_sci_Set$Set1(r1);
      break;
    }
    case 2: {
      return new $c_sci_Set$Set2(r1, r2);
      break;
    }
    case 3: {
      return this;
      break;
    }
    default: {
      throw new $c_s_MatchError(x1);
    }
  }
});
$p.iW = (function(p) {
  return ((!(!p.i(this.ol))) ? new $c_s_Some(this.ol) : ((!(!p.i(this.om))) ? new $c_s_Some(this.om) : ((!(!p.i(this.on))) ? new $c_s_Some(this.on) : $m_s_None$())));
});
$p.t = (function() {
  return this.ol;
});
$p.lT = (function(elem) {
  return this.vZ(elem);
});
$p.hQ = (function(elem) {
  return this.w5(elem);
});
function $isArrayOf_sci_Set$Set3(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.lm)));
}
var $d_sci_Set$Set3 = new $TypeData().i($c_sci_Set$Set3, "scala.collection.immutable.Set$Set3", ({
  lm: 1,
  bg: 1,
  aQ: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  aG: 1,
  aR: 1,
  h: 1,
  b: 1,
  bi: 1,
  I: 1,
  bj: 1,
  z: 1,
  a: 1
}));
/** @constructor */
function $c_sci_Set$Set4(elem1, elem2, elem3, elem4) {
  this.mB = null;
  this.mC = null;
  this.lL = null;
  this.lM = null;
  this.mB = elem1;
  this.mC = elem2;
  this.lL = elem3;
  this.lM = elem4;
}
$p = $c_sci_Set$Set4.prototype = new $h_sci_AbstractSet();
$p.constructor = $c_sci_Set$Set4;
/** @constructor */
function $h_sci_Set$Set4() {
}
$h_sci_Set$Set4.prototype = $p;
$p.ju = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
});
$p.fa = (function(asPair) {
  return $f_sc_StrictOptimizedIterableOps__unzip__F1__T2(this, asPair);
});
$p.L = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$p.c5 = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.ct = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.dk = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bw = (function(pred) {
  return this.w1(pred, false);
});
$p.cE = (function(pred) {
  return this.w1(pred, true);
});
$p.fy = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__partitionMap__F1__T2(this, f);
});
$p.cn = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$p.aa = (function() {
  return 4;
});
$p.c = (function() {
  return false;
});
$p.V = (function() {
  return 4;
});
$p.E = (function(elem) {
  return ((($m_sr_BoxesRunTime$().Q(elem, this.mB) || $m_sr_BoxesRunTime$().Q(elem, this.mC)) || $m_sr_BoxesRunTime$().Q(elem, this.lL)) || $m_sr_BoxesRunTime$().Q(elem, this.lM));
});
$p.w5 = (function(elem) {
  return (this.E(elem) ? this : $m_sci_HashSet$().vA.Pu(this.mB).Pu(this.mC).Pu(this.lL).Pu(this.lM).Pu(elem));
});
$p.vZ = (function(elem) {
  return ($m_sr_BoxesRunTime$().Q(elem, this.mB) ? new $c_sci_Set$Set3(this.mC, this.lL, this.lM) : ($m_sr_BoxesRunTime$().Q(elem, this.mC) ? new $c_sci_Set$Set3(this.mB, this.lL, this.lM) : ($m_sr_BoxesRunTime$().Q(elem, this.lL) ? new $c_sci_Set$Set3(this.mB, this.mC, this.lM) : ($m_sr_BoxesRunTime$().Q(elem, this.lM) ? new $c_sci_Set$Set3(this.mB, this.mC, this.lL) : this))));
});
$p.o = (function() {
  return new $c_sci_Set$Set4$$anon$3(this);
});
$p.b8a = (function(i) {
  switch (i) {
    case 0: {
      return this.mB;
      break;
    }
    case 1: {
      return this.mC;
      break;
    }
    case 2: {
      return this.lL;
      break;
    }
    case 3: {
      return this.lM;
      break;
    }
    default: {
      throw new $c_s_MatchError(i);
    }
  }
});
$p.F = (function(f) {
  f.i(this.mB);
  f.i(this.mC);
  f.i(this.lL);
  f.i(this.lM);
});
$p.lU = (function(p) {
  return ((((!(!p.i(this.mB))) || (!(!p.i(this.mC)))) || (!(!p.i(this.lL)))) || (!(!p.i(this.lM))));
});
$p.lV = (function(p) {
  return ((((!(!p.i(this.mB))) && (!(!p.i(this.mC)))) && (!(!p.i(this.lL)))) && (!(!p.i(this.lM))));
});
$p.w1 = (function(pred, isFlipped) {
  var r1 = null;
  var r2 = null;
  var r3 = null;
  var n = 0;
  if (((!(!pred.i(this.mB))) !== isFlipped)) {
    r1 = this.mB;
    n = ((1 + n) | 0);
  }
  if (((!(!pred.i(this.mC))) !== isFlipped)) {
    if ((n === 0)) {
      r1 = this.mC;
    } else {
      r2 = this.mC;
    }
    n = ((1 + n) | 0);
  }
  if (((!(!pred.i(this.lL))) !== isFlipped)) {
    if ((n === 0)) {
      r1 = this.lL;
    } else if ((n === 1)) {
      r2 = this.lL;
    } else {
      r3 = this.lL;
    }
    n = ((1 + n) | 0);
  }
  if (((!(!pred.i(this.lM))) !== isFlipped)) {
    if ((n === 0)) {
      r1 = this.lM;
    } else if ((n === 1)) {
      r2 = this.lM;
    } else if ((n === 2)) {
      r3 = this.lM;
    }
    n = ((1 + n) | 0);
  }
  var x1 = n;
  switch (x1) {
    case 0: {
      return $m_sci_Set$EmptySet$();
      break;
    }
    case 1: {
      return new $c_sci_Set$Set1(r1);
      break;
    }
    case 2: {
      return new $c_sci_Set$Set2(r1, r2);
      break;
    }
    case 3: {
      return new $c_sci_Set$Set3(r1, r2, r3);
      break;
    }
    case 4: {
      return this;
      break;
    }
    default: {
      throw new $c_s_MatchError(x1);
    }
  }
});
$p.iW = (function(p) {
  return ((!(!p.i(this.mB))) ? new $c_s_Some(this.mB) : ((!(!p.i(this.mC))) ? new $c_s_Some(this.mC) : ((!(!p.i(this.lL))) ? new $c_s_Some(this.lL) : ((!(!p.i(this.lM))) ? new $c_s_Some(this.lM) : $m_s_None$()))));
});
$p.t = (function() {
  return this.mB;
});
$p.aY8 = (function(builder) {
  return builder.Y(this.mB).Y(this.mC).Y(this.lL).Y(this.lM);
});
$p.lT = (function(elem) {
  return this.vZ(elem);
});
$p.hQ = (function(elem) {
  return this.w5(elem);
});
function $isArrayOf_sci_Set$Set4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ln)));
}
var $d_sci_Set$Set4 = new $TypeData().i($c_sci_Set$Set4, "scala.collection.immutable.Set$Set4", ({
  ln: 1,
  bg: 1,
  aQ: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  aG: 1,
  aR: 1,
  h: 1,
  b: 1,
  bi: 1,
  I: 1,
  bj: 1,
  z: 1,
  a: 1
}));
/** @constructor */
function $c_scm_AbstractSeq() {
}
$p = $c_scm_AbstractSeq.prototype = new $h_sc_AbstractSeq();
$p.constructor = $c_scm_AbstractSeq;
/** @constructor */
function $h_scm_AbstractSeq() {
}
$h_scm_AbstractSeq.prototype = $p;
/** @constructor */
function $c_scm_CheckedIndexedSeqView$Appended(underlying, elem, mutationCount) {
  this.NQ = null;
  this.UX = null;
  this.NN = null;
  this.a1y = null;
  this.l9 = null;
  this.l9 = mutationCount;
  $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(this, underlying, elem);
}
$p = $c_scm_CheckedIndexedSeqView$Appended.prototype = new $h_sc_IndexedSeqView$Appended();
$p.constructor = $c_scm_CheckedIndexedSeqView$Appended;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$Appended() {
}
$h_scm_CheckedIndexedSeqView$Appended.prototype = $p;
$p.o = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedIterator(this, this.l9);
});
$p.cx = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(this, this.l9);
});
$p.gT = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.l9);
});
$p.gW = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.l9);
});
$p.gX = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.l9);
});
$p.gA = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.l9);
});
$p.jZ = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.l9);
});
$p.kw = (function(from, until) {
  return new $c_scm_CheckedIndexedSeqView$Slice(this, from, until, this.l9);
});
$p.hV = (function(from, until) {
  return new $c_scm_CheckedIndexedSeqView$Slice(this, from, until, this.l9);
});
$p.hU = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.l9);
});
$p.h4 = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.l9);
});
$p.L = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.l9);
});
$p.jo = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.l9);
});
$p.cn = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.l9);
});
$p.jn = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.l9);
});
$p.ds = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.l9);
});
$p.bv = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.l9);
});
$p.jm = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.l9);
});
var $d_scm_CheckedIndexedSeqView$Appended = new $TypeData().i($c_scm_CheckedIndexedSeqView$Appended, "scala.collection.mutable.CheckedIndexedSeqView$Appended", ({
  JF: 1,
  kG: 1,
  dz: 1,
  cJ: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1,
  a4: 1,
  w: 1,
  aj: 1,
  A: 1,
  bI: 1
}));
/** @constructor */
function $c_scm_CheckedIndexedSeqView$Drop(underlying, n, mutationCount) {
  this.NR = null;
  this.UY = 0;
  this.Hu = 0;
  this.NO = null;
  this.a1z = 0;
  this.la = null;
  this.la = mutationCount;
  $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(this, underlying, n);
}
$p = $c_scm_CheckedIndexedSeqView$Drop.prototype = new $h_sc_IndexedSeqView$Drop();
$p.constructor = $c_scm_CheckedIndexedSeqView$Drop;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$Drop() {
}
$h_scm_CheckedIndexedSeqView$Drop.prototype = $p;
$p.o = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedIterator(this, this.la);
});
$p.cx = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(this, this.la);
});
$p.gT = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.la);
});
$p.gW = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.la);
});
$p.gX = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.la);
});
$p.gA = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.la);
});
$p.jZ = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.la);
});
$p.kw = (function(from, until) {
  return new $c_scm_CheckedIndexedSeqView$Slice(this, from, until, this.la);
});
$p.hV = (function(from, until) {
  return new $c_scm_CheckedIndexedSeqView$Slice(this, from, until, this.la);
});
$p.hU = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.la);
});
$p.h4 = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.la);
});
$p.L = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.la);
});
$p.jo = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.la);
});
$p.cn = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.la);
});
$p.jn = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.la);
});
$p.ds = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.la);
});
$p.bv = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.la);
});
$p.jm = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.la);
});
var $d_scm_CheckedIndexedSeqView$Drop = new $TypeData().i($c_scm_CheckedIndexedSeqView$Drop, "scala.collection.mutable.CheckedIndexedSeqView$Drop", ({
  JI: 1,
  kH: 1,
  dA: 1,
  cK: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1,
  a4: 1,
  w: 1,
  aj: 1,
  A: 1,
  bI: 1
}));
/** @constructor */
function $c_scm_CheckedIndexedSeqView$DropRight(underlying, n, mutationCount) {
  this.NS = null;
  this.UZ = 0;
  this.V0 = 0;
  this.a1A = null;
  this.Hr = 0;
  this.lb = null;
  this.lb = mutationCount;
  $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(this, underlying, n);
}
$p = $c_scm_CheckedIndexedSeqView$DropRight.prototype = new $h_sc_IndexedSeqView$DropRight();
$p.constructor = $c_scm_CheckedIndexedSeqView$DropRight;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$DropRight() {
}
$h_scm_CheckedIndexedSeqView$DropRight.prototype = $p;
$p.o = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedIterator(this, this.lb);
});
$p.cx = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(this, this.lb);
});
$p.gT = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.lb);
});
$p.gW = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.lb);
});
$p.gX = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.lb);
});
$p.gA = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.lb);
});
$p.jZ = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.lb);
});
$p.kw = (function(from, until) {
  return new $c_scm_CheckedIndexedSeqView$Slice(this, from, until, this.lb);
});
$p.hV = (function(from, until) {
  return new $c_scm_CheckedIndexedSeqView$Slice(this, from, until, this.lb);
});
$p.hU = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.lb);
});
$p.h4 = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.lb);
});
$p.L = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.lb);
});
$p.jo = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.lb);
});
$p.cn = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.lb);
});
$p.jn = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.lb);
});
$p.ds = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.lb);
});
$p.bv = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.lb);
});
$p.jm = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.lb);
});
var $d_scm_CheckedIndexedSeqView$DropRight = new $TypeData().i($c_scm_CheckedIndexedSeqView$DropRight, "scala.collection.mutable.CheckedIndexedSeqView$DropRight", ({
  JJ: 1,
  kI: 1,
  dB: 1,
  cL: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1,
  a4: 1,
  w: 1,
  aj: 1,
  A: 1,
  bI: 1
}));
/** @constructor */
function $c_scm_CheckedIndexedSeqView$Map(underlying, f, mutationCount) {
  this.Hv = null;
  this.V2 = null;
  this.US = null;
  this.a1B = null;
  this.lc = null;
  this.lc = mutationCount;
  $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(this, underlying, f);
}
$p = $c_scm_CheckedIndexedSeqView$Map.prototype = new $h_sc_IndexedSeqView$Map();
$p.constructor = $c_scm_CheckedIndexedSeqView$Map;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$Map() {
}
$h_scm_CheckedIndexedSeqView$Map.prototype = $p;
$p.o = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedIterator(this, this.lc);
});
$p.cx = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(this, this.lc);
});
$p.gT = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.lc);
});
$p.gW = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.lc);
});
$p.gX = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.lc);
});
$p.gA = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.lc);
});
$p.jZ = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.lc);
});
$p.kw = (function(from, until) {
  return new $c_scm_CheckedIndexedSeqView$Slice(this, from, until, this.lc);
});
$p.hV = (function(from, until) {
  return new $c_scm_CheckedIndexedSeqView$Slice(this, from, until, this.lc);
});
$p.hU = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.lc);
});
$p.h4 = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.lc);
});
$p.L = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.lc);
});
$p.jo = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.lc);
});
$p.cn = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.lc);
});
$p.jn = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.lc);
});
$p.ds = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.lc);
});
$p.bv = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.lc);
});
$p.jm = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.lc);
});
var $d_scm_CheckedIndexedSeqView$Map = new $TypeData().i($c_scm_CheckedIndexedSeqView$Map, "scala.collection.mutable.CheckedIndexedSeqView$Map", ({
  JK: 1,
  kL: 1,
  dC: 1,
  cM: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1,
  a4: 1,
  w: 1,
  aj: 1,
  A: 1,
  bI: 1
}));
/** @constructor */
function $c_scm_CheckedIndexedSeqView$Reverse(underlying, mutationCount) {
  this.CV = null;
  this.ac2 = null;
  this.aIG = null;
  this.lO = null;
  this.aIG = underlying;
  this.lO = mutationCount;
  $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(this, underlying);
}
$p = $c_scm_CheckedIndexedSeqView$Reverse.prototype = new $h_sc_IndexedSeqView$Reverse();
$p.constructor = $c_scm_CheckedIndexedSeqView$Reverse;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$Reverse() {
}
$h_scm_CheckedIndexedSeqView$Reverse.prototype = $p;
$p.o = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedIterator(this, this.lO);
});
$p.cx = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(this, this.lO);
});
$p.gT = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.lO);
});
$p.gW = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.lO);
});
$p.gX = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.lO);
});
$p.gA = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.lO);
});
$p.kw = (function(from, until) {
  return new $c_scm_CheckedIndexedSeqView$Slice(this, from, until, this.lO);
});
$p.jZ = (function() {
  var x1 = this.aIG;
  return ($is_sc_IndexedSeqView(x1) ? x1 : new $c_scm_CheckedIndexedSeqView$Reverse(this, this.lO));
});
$p.hV = (function(from, until) {
  return new $c_scm_CheckedIndexedSeqView$Slice(this, from, until, this.lO);
});
$p.h4 = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.lO);
});
$p.L = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.lO);
});
$p.jo = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.lO);
});
$p.cn = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.lO);
});
$p.jn = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.lO);
});
$p.ds = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.lO);
});
$p.bv = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.lO);
});
$p.jm = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.lO);
});
$p.hU = (function() {
  return this.jZ();
});
var $d_scm_CheckedIndexedSeqView$Reverse = new $TypeData().i($c_scm_CheckedIndexedSeqView$Reverse, "scala.collection.mutable.CheckedIndexedSeqView$Reverse", ({
  JL: 1,
  kM: 1,
  dD: 1,
  b8: 1,
  F: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  C: 1,
  a: 1,
  a4: 1,
  w: 1,
  aj: 1,
  A: 1,
  bI: 1
}));
function $f_Lupickle_Api__upickle$Api$$maybeSortKeysTransform__O__Z__Lupickle_core_Visitor__Lupickle_core_Types$Writer__O($thiz, t, sortKeys, f, evidence$1) {
  return $m_Lupickle_core_BufferedValue$().a4b(evidence$1, t, sortKeys, f);
}
function $f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($thiz, s, trace, evidence$1) {
  var f = ((_$2) => s.yq(_$2));
  if ((!trace)) {
    return f(evidence$1);
  } else {
    var wrapper = new $c_Lupickle_core_TraceVisitor$Wrapper();
    try {
      var x0 = $ct_Lupickle_core_TraceVisitor__Lupickle_core_Visitor__Lupickle_core_TraceVisitor$HasPath__Lupickle_core_TraceVisitor$Wrapper__(new $c_Lupickle_core_TraceVisitor(), evidence$1, $m_Lupickle_core_TraceVisitor$RootHasPath$(), wrapper);
      return f(x0);
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      var x2 = $m_s_util_control_NonFatal$().wm(e$2);
      if ((!x2.c())) {
        var x3 = x2.d();
        throw new $c_Lupickle_core_TraceVisitor$TraceException($f_Lupickle_core_TraceVisitor$HasPath__path__T(wrapper.Ih), x3);
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.bf : e$2);
    }
  }
}
function $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($thiz, t, indent, escapeUnicode, sortKeys, evidence$1) {
  return $f_Lupickle_Api__upickle$Api$$maybeSortKeysTransform__O__Z__Lupickle_core_Visitor__Lupickle_core_Types$Writer__O($thiz, t, sortKeys, new $c_Lujson_StringRenderer(indent, escapeUnicode), evidence$1).m();
}
function $f_Lupickle_Api__writeJs__O__Lupickle_core_Types$Writer__Lujson_Value($thiz, t, evidence$1) {
  return $thiz.bas().aXj(t, evidence$1).yq($f_Lupickle_LowPriReadWriters__JsValueR__Lupickle_core_Types$Reader($thiz));
}
/** @constructor */
function $c_sci_Map$EmptyMap$() {
}
$p = $c_sci_Map$EmptyMap$.prototype = new $h_sci_AbstractMap();
$p.constructor = $c_sci_Map$EmptyMap$;
/** @constructor */
function $h_sci_Map$EmptyMap$() {
}
$h_sci_Map$EmptyMap$.prototype = $p;
$p.aa = (function() {
  return 0;
});
$p.V = (function() {
  return 0;
});
$p.c = (function() {
  return true;
});
$p.a2K = (function(key) {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key));
});
$p.E = (function(key) {
  return false;
});
$p.r = (function(key) {
  return $m_s_None$();
});
$p.ay = (function(key, default$1) {
  return default$1.a3();
});
$p.o = (function() {
  return $m_sc_Iterator$().b8;
});
$p.lo = (function() {
  return $m_sc_Iterator$().b8;
});
$p.hr = (function() {
  return $m_sc_Iterator$().b8;
});
$p.aYT = (function(suffix) {
  return ($is_sci_Map(suffix) ? suffix : $f_sc_MapOps__concat__sc_IterableOnce__sc_IterableOps(this, suffix));
});
$p.hN = (function(suffix) {
  return this.aYT(suffix);
});
$p.fz = (function(key) {
  return this;
});
$p.bN = (function(key, value) {
  return new $c_sci_Map$Map1(key, value);
});
$p.i = (function(key) {
  this.a2K(key);
});
var $d_sci_Map$EmptyMap$ = new $TypeData().i($c_sci_Map$EmptyMap$, "scala.collection.immutable.Map$EmptyMap$", ({
  Iu: 1,
  bb: 1,
  aL: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  as: 1,
  ak: 1,
  i: 1,
  h: 1,
  aF: 1,
  b: 1,
  aV: 1,
  I: 1,
  bc: 1,
  a: 1
}));
var $n_sci_Map$EmptyMap$;
function $m_sci_Map$EmptyMap$() {
  if ((!$n_sci_Map$EmptyMap$)) {
    $n_sci_Map$EmptyMap$ = new $c_sci_Map$EmptyMap$();
  }
  return $n_sci_Map$EmptyMap$;
}
/** @constructor */
function $c_sci_Map$WithDefault(underlying, defaultValue) {
  this.vB = null;
  this.D1 = null;
  this.vB = underlying;
  this.D1 = defaultValue;
}
$p = $c_sci_Map$WithDefault.prototype = new $h_sci_AbstractMap();
$p.constructor = $c_sci_Map$WithDefault;
/** @constructor */
function $h_sci_Map$WithDefault() {
}
$h_sci_Map$WithDefault.prototype = $p;
$p.r = (function(key) {
  return this.vB.r(key);
});
$p.WC = (function(key) {
  return this.D1.i(key);
});
$p.cd = (function() {
  return this.vB.cd();
});
$p.o = (function() {
  return this.vB.o();
});
$p.c = (function() {
  return this.vB.c();
});
$p.im = (function() {
  return this.vB.im();
});
$p.aYU = (function(xs) {
  return new $c_sci_Map$WithDefault(this.vB.hN(xs), this.D1);
});
$p.b7y = (function(key) {
  return new $c_sci_Map$WithDefault(this.vB.fz(key), this.D1);
});
$p.baW = (function(key, value) {
  return new $c_sci_Map$WithDefault(this.vB.bN(key, value), this.D1);
});
$p.b0v = (function() {
  return new $c_sci_Map$WithDefault(this.vB.pr(), this.D1);
});
$p.aOD = (function(coll) {
  return new $c_sci_Map$WithDefault(this.vB.im().cc(coll), this.D1);
});
$p.fS = (function() {
  return new $c_scm_Builder$$anon$1(new $c_sci_MapBuilderImpl(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((p$2$2) => new $c_sci_Map$WithDefault(p$2$2, this.D1))));
});
$p.fP = (function(coll) {
  return this.aOD(coll);
});
$p.w4 = (function(coll) {
  return this.aOD(coll);
});
$p.pr = (function() {
  return this.b0v();
});
$p.bN = (function(key, value) {
  return this.baW(key, value);
});
$p.fz = (function(key) {
  return this.b7y(key);
});
$p.hN = (function(suffix) {
  return this.aYU(suffix);
});
var $d_sci_Map$WithDefault = new $TypeData().i($c_sci_Map$WithDefault, "scala.collection.immutable.Map$WithDefault", ({
  IE: 1,
  bb: 1,
  aL: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  as: 1,
  ak: 1,
  i: 1,
  h: 1,
  aF: 1,
  b: 1,
  aV: 1,
  I: 1,
  bc: 1,
  a: 1
}));
function $ct_sci_MapOps$ImmutableKeySet__sci_MapOps__($thiz, outer) {
  $thiz.mA = outer;
  return $thiz;
}
/** @constructor */
function $c_sci_MapOps$ImmutableKeySet() {
  this.mA = null;
}
$p = $c_sci_MapOps$ImmutableKeySet.prototype = new $h_sci_AbstractSet();
$p.constructor = $c_sci_MapOps$ImmutableKeySet;
/** @constructor */
function $h_sci_MapOps$ImmutableKeySet() {
}
$h_sci_MapOps$ImmutableKeySet.prototype = $p;
$p.o = (function() {
  return this.mA.lo();
});
$p.E = (function(key) {
  return this.mA.E(key);
});
$p.aa = (function() {
  return this.mA.aa();
});
$p.V = (function() {
  return this.mA.V();
});
$p.c = (function() {
  return this.mA.c();
});
$p.w5 = (function(elem) {
  return (this.mA.E(elem) ? this : $f_sc_SetOps__concat__sc_IterableOnce__sc_SetOps($m_sci_Set$EmptySet$(), this).hQ(elem));
});
$p.vZ = (function(elem) {
  return (this.mA.E(elem) ? $f_sc_SetOps__concat__sc_IterableOnce__sc_SetOps($m_sci_Set$EmptySet$(), this).lT(elem) : this);
});
$p.lT = (function(elem) {
  return this.vZ(elem);
});
$p.hQ = (function(elem) {
  return this.w5(elem);
});
function $isArrayOf_sci_MapOps$ImmutableKeySet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dK)));
}
var $d_sci_MapOps$ImmutableKeySet = new $TypeData().i($c_sci_MapOps$ImmutableKeySet, "scala.collection.immutable.MapOps$ImmutableKeySet", ({
  dK: 1,
  bg: 1,
  aQ: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  aG: 1,
  aR: 1,
  h: 1,
  b: 1,
  bi: 1,
  I: 1,
  bj: 1,
  cI: 1,
  a5: 1,
  a: 1
}));
function $f_scm_Buffer__prependAll__sc_IterableOnce__scm_Buffer($thiz, elems) {
  $thiz.Px(0, elems);
  return $thiz;
}
function $f_scm_Buffer__subtractOne__O__scm_Buffer($thiz, x) {
  var i = $thiz.mN(x, 0);
  if ((i !== (-1))) {
    $thiz.wd(i);
  }
  return $thiz;
}
function $f_scm_Buffer__takeInPlace__I__scm_Buffer($thiz, n) {
  var norm = $p_scm_Buffer__normalized__I__I($thiz, n);
  $thiz.XQ(norm, (($thiz.C() - norm) | 0));
  return $thiz;
}
function $p_scm_Buffer__normalized__I__I($thiz, n) {
  var x = ((n > 0) ? n : 0);
  var y = $thiz.C();
  return ((x < y) ? x : y);
}
function $f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter($thiz, rw, key, value, shortValue, checker) {
  return new $c_Lupickle_core_Types$TaggedWriter$Leaf($thiz.aLD(), checker, key, shortValue, rw);
}
function $f_Lupickle_AttributeTagged__upickle$AttributeTagged$$isTagName__T__O__Z($thiz, tagKey, i) {
  return ((i instanceof $c_Lupickle_core_BufferedValue$Str) ? ($dp_toString__T(i.Ab) === tagKey) : ($is_jl_CharSequence(i) && ($dp_toString__T(i) === tagKey)));
}
function $f_Lupickle_AttributeTagged__taggedWrite__Lupickle_core_Types$ObjectWriter__T__T__Lupickle_core_Visitor__O__O($thiz, w, tagKey, tagValue, out, v) {
  if (false) {
    return out.cN(tagValue, (-1));
  } else {
    var ctx = out.bQ(((1 + w.jW(v)) | 0), true, (-1));
    var keyVisitor = ctx.jy((-1));
    ctx.jz(keyVisitor.cN(tagKey, (-1)));
    ctx.cU(ctx.d9().cN(tagValue, (-1)), (-1));
    w.k4(ctx, v);
    return ctx.bV((-1));
  }
}
function $p_sci_HashMap$HashKeySet__newKeySetOrThis__sci_HashMap__sci_Set($thiz, newHashMap) {
  return ((newHashMap === $thiz.mA) ? $thiz : newHashMap.ln());
}
function $p_sci_HashMap$HashKeySet__newKeySetOrThis__sci_BitmapIndexedMapNode__sci_Set($thiz, newRootNode) {
  return ((newRootNode === $thiz.mA.cP) ? $thiz : new $c_sci_HashMap(newRootNode).ln());
}
/** @constructor */
function $c_sci_HashMap$HashKeySet(outer) {
  this.mA = null;
  $ct_sci_MapOps$ImmutableKeySet__sci_MapOps__(this, outer);
}
$p = $c_sci_HashMap$HashKeySet.prototype = new $h_sci_MapOps$ImmutableKeySet();
$p.constructor = $c_sci_HashMap$HashKeySet;
/** @constructor */
function $h_sci_HashMap$HashKeySet() {
}
$h_sci_HashMap$HashKeySet.prototype = $p;
$p.w5 = (function(elem) {
  var originalHash = $m_sr_Statics$().u(elem);
  var improvedHash = $m_sc_Hashing$().bz(originalHash);
  return $p_sci_HashMap$HashKeySet__newKeySetOrThis__sci_BitmapIndexedMapNode__sci_Set(this, this.mA.cP.JF(elem, null, originalHash, improvedHash, 0, false));
});
$p.vZ = (function(elem) {
  return $p_sci_HashMap$HashKeySet__newKeySetOrThis__sci_HashMap__sci_Set(this, this.mA.aRC(elem));
});
$p.b1e = (function(pred) {
  return $p_sci_HashMap$HashKeySet__newKeySetOrThis__sci_HashMap__sci_Set(this, this.mA.a3m(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((kv$2$2) => (!(!pred.i(kv$2$2.g()))))), false));
});
$p.b1g = (function(pred) {
  return $p_sci_HashMap$HashKeySet__newKeySetOrThis__sci_HashMap__sci_Set(this, this.mA.a3m(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((kv$2$2) => (!(!pred.i(kv$2$2.g()))))), true));
});
$p.cE = (function(pred) {
  return this.b1g(pred);
});
$p.bw = (function(pred) {
  return this.b1e(pred);
});
$p.lT = (function(elem) {
  return this.vZ(elem);
});
$p.hQ = (function(elem) {
  return this.w5(elem);
});
function $isArrayOf_sci_HashMap$HashKeySet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.lb)));
}
var $d_sci_HashMap$HashKeySet = new $TypeData().i($c_sci_HashMap$HashKeySet, "scala.collection.immutable.HashMap$HashKeySet", ({
  lb: 1,
  dK: 1,
  bg: 1,
  aQ: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  aG: 1,
  aR: 1,
  h: 1,
  b: 1,
  bi: 1,
  I: 1,
  bj: 1,
  cI: 1,
  a5: 1,
  a: 1
}));
/** @constructor */
function $c_sci_Map$Map1(key1, value1) {
  this.lJ = null;
  this.p8 = null;
  this.lJ = key1;
  this.p8 = value1;
}
$p = $c_sci_Map$Map1.prototype = new $h_sci_AbstractMap();
$p.constructor = $c_sci_Map$Map1;
/** @constructor */
function $h_sci_Map$Map1() {
}
$h_sci_Map$Map1.prototype = $p;
$p.ju = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
});
$p.fa = (function(asPair) {
  return $f_sc_StrictOptimizedIterableOps__unzip__F1__T2(this, asPair);
});
$p.L = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$p.c5 = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.ct = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.dk = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bw = (function(pred) {
  return this.w0(pred, false);
});
$p.cE = (function(pred) {
  return this.w0(pred, true);
});
$p.fy = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__partitionMap__F1__T2(this, f);
});
$p.cn = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$p.aa = (function() {
  return 1;
});
$p.V = (function() {
  return 1;
});
$p.c = (function() {
  return false;
});
$p.i = (function(key) {
  if ($m_sr_BoxesRunTime$().Q(key, this.lJ)) {
    return this.p8;
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key));
  }
});
$p.E = (function(key) {
  return $m_sr_BoxesRunTime$().Q(key, this.lJ);
});
$p.r = (function(key) {
  return ($m_sr_BoxesRunTime$().Q(key, this.lJ) ? new $c_s_Some(this.p8) : $m_s_None$());
});
$p.ay = (function(key, default$1) {
  return ($m_sr_BoxesRunTime$().Q(key, this.lJ) ? this.p8 : default$1.a3());
});
$p.o = (function() {
  return new $c_sc_Iterator$$anon$20(new $c_T2(this.lJ, this.p8));
});
$p.lo = (function() {
  return new $c_sc_Iterator$$anon$20(this.lJ);
});
$p.hr = (function() {
  return new $c_sc_Iterator$$anon$20(this.p8);
});
$p.JG = (function(key, value) {
  return ($m_sr_BoxesRunTime$().Q(key, this.lJ) ? new $c_sci_Map$Map1(this.lJ, value) : new $c_sci_Map$Map2(this.lJ, this.p8, key, value));
});
$p.Ji = (function(key) {
  return ($m_sr_BoxesRunTime$().Q(key, this.lJ) ? $m_sci_Map$EmptyMap$() : this);
});
$p.F = (function(f) {
  f.i(new $c_T2(this.lJ, this.p8));
});
$p.lU = (function(p) {
  return (!(!p.i(new $c_T2(this.lJ, this.p8))));
});
$p.lV = (function(p) {
  return (!(!p.i(new $c_T2(this.lJ, this.p8))));
});
$p.w0 = (function(pred, isFlipped) {
  return (((!(!pred.i(new $c_T2(this.lJ, this.p8)))) !== isFlipped) ? this : $m_sci_Map$EmptyMap$());
});
$p.JB = (function(f) {
  var walue1 = f.R(this.lJ, this.p8);
  return (Object.is(walue1, this.p8) ? this : new $c_sci_Map$Map1(this.lJ, walue1));
});
$p.x = (function() {
  var a = 0;
  var b = 0;
  var c = 1;
  var h = $m_s_util_hashing_MurmurHash3$().ri(this.lJ, this.p8);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().xL;
  h = $m_s_util_hashing_MurmurHash3$().k(h, a);
  h = $m_s_util_hashing_MurmurHash3$().k(h, b);
  h = $m_s_util_hashing_MurmurHash3$().r8(h, c);
  return $m_s_util_hashing_MurmurHash3$().Z(h, 1);
});
$p.wk = (function(f) {
  return this.JB(f);
});
$p.fz = (function(key) {
  return this.Ji(key);
});
$p.bN = (function(key, value) {
  return this.JG(key, value);
});
function $isArrayOf_sci_Map$Map1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.le)));
}
var $d_sci_Map$Map1 = new $TypeData().i($c_sci_Map$Map1, "scala.collection.immutable.Map$Map1", ({
  le: 1,
  bb: 1,
  aL: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  as: 1,
  ak: 1,
  i: 1,
  h: 1,
  aF: 1,
  b: 1,
  aV: 1,
  I: 1,
  bc: 1,
  z: 1,
  a: 1
}));
/** @constructor */
function $c_sci_Map$Map2(key1, value1, key2, value2) {
  this.kG = null;
  this.nk = null;
  this.kH = null;
  this.nl = null;
  this.kG = key1;
  this.nk = value1;
  this.kH = key2;
  this.nl = value2;
}
$p = $c_sci_Map$Map2.prototype = new $h_sci_AbstractMap();
$p.constructor = $c_sci_Map$Map2;
/** @constructor */
function $h_sci_Map$Map2() {
}
$h_sci_Map$Map2.prototype = $p;
$p.ju = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
});
$p.fa = (function(asPair) {
  return $f_sc_StrictOptimizedIterableOps__unzip__F1__T2(this, asPair);
});
$p.L = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$p.c5 = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.ct = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.dk = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bw = (function(pred) {
  return this.w0(pred, false);
});
$p.cE = (function(pred) {
  return this.w0(pred, true);
});
$p.fy = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__partitionMap__F1__T2(this, f);
});
$p.cn = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$p.aa = (function() {
  return 2;
});
$p.V = (function() {
  return 2;
});
$p.c = (function() {
  return false;
});
$p.i = (function(key) {
  if ($m_sr_BoxesRunTime$().Q(key, this.kG)) {
    return this.nk;
  } else if ($m_sr_BoxesRunTime$().Q(key, this.kH)) {
    return this.nl;
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key));
  }
});
$p.E = (function(key) {
  return ($m_sr_BoxesRunTime$().Q(key, this.kG) || $m_sr_BoxesRunTime$().Q(key, this.kH));
});
$p.r = (function(key) {
  return ($m_sr_BoxesRunTime$().Q(key, this.kG) ? new $c_s_Some(this.nk) : ($m_sr_BoxesRunTime$().Q(key, this.kH) ? new $c_s_Some(this.nl) : $m_s_None$()));
});
$p.ay = (function(key, default$1) {
  return ($m_sr_BoxesRunTime$().Q(key, this.kG) ? this.nk : ($m_sr_BoxesRunTime$().Q(key, this.kH) ? this.nl : default$1.a3()));
});
$p.o = (function() {
  return new $c_sci_Map$Map2$$anon$1(this);
});
$p.lo = (function() {
  return new $c_sci_Map$Map2$$anon$2(this);
});
$p.hr = (function() {
  return new $c_sci_Map$Map2$$anon$3(this);
});
$p.JG = (function(key, value) {
  return ($m_sr_BoxesRunTime$().Q(key, this.kG) ? new $c_sci_Map$Map2(this.kG, value, this.kH, this.nl) : ($m_sr_BoxesRunTime$().Q(key, this.kH) ? new $c_sci_Map$Map2(this.kG, this.nk, this.kH, value) : new $c_sci_Map$Map3(this.kG, this.nk, this.kH, this.nl, key, value)));
});
$p.Ji = (function(key) {
  return ($m_sr_BoxesRunTime$().Q(key, this.kG) ? new $c_sci_Map$Map1(this.kH, this.nl) : ($m_sr_BoxesRunTime$().Q(key, this.kH) ? new $c_sci_Map$Map1(this.kG, this.nk) : this));
});
$p.F = (function(f) {
  f.i(new $c_T2(this.kG, this.nk));
  f.i(new $c_T2(this.kH, this.nl));
});
$p.lU = (function(p) {
  return ((!(!p.i(new $c_T2(this.kG, this.nk)))) || (!(!p.i(new $c_T2(this.kH, this.nl)))));
});
$p.lV = (function(p) {
  return ((!(!p.i(new $c_T2(this.kG, this.nk)))) && (!(!p.i(new $c_T2(this.kH, this.nl)))));
});
$p.w0 = (function(pred, isFlipped) {
  var k1 = null;
  var v1 = null;
  var n = 0;
  if (((!(!pred.i(new $c_T2(this.kG, this.nk)))) !== isFlipped)) {
    k1 = this.kG;
    v1 = this.nk;
    n = ((1 + n) | 0);
  }
  if (((!(!pred.i(new $c_T2(this.kH, this.nl)))) !== isFlipped)) {
    if ((n === 0)) {
      k1 = this.kH;
      v1 = this.nl;
    }
    n = ((1 + n) | 0);
  }
  var x1 = n;
  switch (x1) {
    case 0: {
      return $m_sci_Map$EmptyMap$();
      break;
    }
    case 1: {
      return new $c_sci_Map$Map1(k1, v1);
      break;
    }
    case 2: {
      return this;
      break;
    }
    default: {
      throw new $c_s_MatchError(x1);
    }
  }
});
$p.JB = (function(f) {
  var walue1 = f.R(this.kG, this.nk);
  var walue2 = f.R(this.kH, this.nl);
  return ((Object.is(walue1, this.nk) && Object.is(walue2, this.nl)) ? this : new $c_sci_Map$Map2(this.kG, walue1, this.kH, walue2));
});
$p.x = (function() {
  var a = 0;
  var b = 0;
  var c = 1;
  var h = $m_s_util_hashing_MurmurHash3$().ri(this.kG, this.nk);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().ri(this.kH, this.nl);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().xL;
  h = $m_s_util_hashing_MurmurHash3$().k(h, a);
  h = $m_s_util_hashing_MurmurHash3$().k(h, b);
  h = $m_s_util_hashing_MurmurHash3$().r8(h, c);
  return $m_s_util_hashing_MurmurHash3$().Z(h, 2);
});
$p.wk = (function(f) {
  return this.JB(f);
});
$p.fz = (function(key) {
  return this.Ji(key);
});
$p.bN = (function(key, value) {
  return this.JG(key, value);
});
function $isArrayOf_sci_Map$Map2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.lf)));
}
var $d_sci_Map$Map2 = new $TypeData().i($c_sci_Map$Map2, "scala.collection.immutable.Map$Map2", ({
  lf: 1,
  bb: 1,
  aL: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  as: 1,
  ak: 1,
  i: 1,
  h: 1,
  aF: 1,
  b: 1,
  aV: 1,
  I: 1,
  bc: 1,
  z: 1,
  a: 1
}));
/** @constructor */
function $c_sci_Map$Map3(key1, value1, key2, value2, key3, value3) {
  this.jM = null;
  this.lK = null;
  this.ja = null;
  this.l4 = null;
  this.jb = null;
  this.l5 = null;
  this.jM = key1;
  this.lK = value1;
  this.ja = key2;
  this.l4 = value2;
  this.jb = key3;
  this.l5 = value3;
}
$p = $c_sci_Map$Map3.prototype = new $h_sci_AbstractMap();
$p.constructor = $c_sci_Map$Map3;
/** @constructor */
function $h_sci_Map$Map3() {
}
$h_sci_Map$Map3.prototype = $p;
$p.ju = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
});
$p.fa = (function(asPair) {
  return $f_sc_StrictOptimizedIterableOps__unzip__F1__T2(this, asPair);
});
$p.L = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$p.c5 = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.ct = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.dk = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bw = (function(pred) {
  return this.w0(pred, false);
});
$p.cE = (function(pred) {
  return this.w0(pred, true);
});
$p.fy = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__partitionMap__F1__T2(this, f);
});
$p.cn = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$p.aa = (function() {
  return 3;
});
$p.V = (function() {
  return 3;
});
$p.c = (function() {
  return false;
});
$p.i = (function(key) {
  if ($m_sr_BoxesRunTime$().Q(key, this.jM)) {
    return this.lK;
  } else if ($m_sr_BoxesRunTime$().Q(key, this.ja)) {
    return this.l4;
  } else if ($m_sr_BoxesRunTime$().Q(key, this.jb)) {
    return this.l5;
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key));
  }
});
$p.E = (function(key) {
  return (($m_sr_BoxesRunTime$().Q(key, this.jM) || $m_sr_BoxesRunTime$().Q(key, this.ja)) || $m_sr_BoxesRunTime$().Q(key, this.jb));
});
$p.r = (function(key) {
  return ($m_sr_BoxesRunTime$().Q(key, this.jM) ? new $c_s_Some(this.lK) : ($m_sr_BoxesRunTime$().Q(key, this.ja) ? new $c_s_Some(this.l4) : ($m_sr_BoxesRunTime$().Q(key, this.jb) ? new $c_s_Some(this.l5) : $m_s_None$())));
});
$p.ay = (function(key, default$1) {
  return ($m_sr_BoxesRunTime$().Q(key, this.jM) ? this.lK : ($m_sr_BoxesRunTime$().Q(key, this.ja) ? this.l4 : ($m_sr_BoxesRunTime$().Q(key, this.jb) ? this.l5 : default$1.a3())));
});
$p.o = (function() {
  return new $c_sci_Map$Map3$$anon$4(this);
});
$p.lo = (function() {
  return new $c_sci_Map$Map3$$anon$5(this);
});
$p.hr = (function() {
  return new $c_sci_Map$Map3$$anon$6(this);
});
$p.JG = (function(key, value) {
  return ($m_sr_BoxesRunTime$().Q(key, this.jM) ? new $c_sci_Map$Map3(this.jM, value, this.ja, this.l4, this.jb, this.l5) : ($m_sr_BoxesRunTime$().Q(key, this.ja) ? new $c_sci_Map$Map3(this.jM, this.lK, this.ja, value, this.jb, this.l5) : ($m_sr_BoxesRunTime$().Q(key, this.jb) ? new $c_sci_Map$Map3(this.jM, this.lK, this.ja, this.l4, this.jb, value) : new $c_sci_Map$Map4(this.jM, this.lK, this.ja, this.l4, this.jb, this.l5, key, value))));
});
$p.Ji = (function(key) {
  return ($m_sr_BoxesRunTime$().Q(key, this.jM) ? new $c_sci_Map$Map2(this.ja, this.l4, this.jb, this.l5) : ($m_sr_BoxesRunTime$().Q(key, this.ja) ? new $c_sci_Map$Map2(this.jM, this.lK, this.jb, this.l5) : ($m_sr_BoxesRunTime$().Q(key, this.jb) ? new $c_sci_Map$Map2(this.jM, this.lK, this.ja, this.l4) : this)));
});
$p.F = (function(f) {
  f.i(new $c_T2(this.jM, this.lK));
  f.i(new $c_T2(this.ja, this.l4));
  f.i(new $c_T2(this.jb, this.l5));
});
$p.lU = (function(p) {
  return (((!(!p.i(new $c_T2(this.jM, this.lK)))) || (!(!p.i(new $c_T2(this.ja, this.l4))))) || (!(!p.i(new $c_T2(this.jb, this.l5)))));
});
$p.lV = (function(p) {
  return (((!(!p.i(new $c_T2(this.jM, this.lK)))) && (!(!p.i(new $c_T2(this.ja, this.l4))))) && (!(!p.i(new $c_T2(this.jb, this.l5)))));
});
$p.w0 = (function(pred, isFlipped) {
  var k1 = null;
  var k2 = null;
  var v1 = null;
  var v2 = null;
  var n = 0;
  if (((!(!pred.i(new $c_T2(this.jM, this.lK)))) !== isFlipped)) {
    k1 = this.jM;
    v1 = this.lK;
    n = ((1 + n) | 0);
  }
  if (((!(!pred.i(new $c_T2(this.ja, this.l4)))) !== isFlipped)) {
    if ((n === 0)) {
      k1 = this.ja;
      v1 = this.l4;
    } else {
      k2 = this.ja;
      v2 = this.l4;
    }
    n = ((1 + n) | 0);
  }
  if (((!(!pred.i(new $c_T2(this.jb, this.l5)))) !== isFlipped)) {
    if ((n === 0)) {
      k1 = this.jb;
      v1 = this.l5;
    } else if ((n === 1)) {
      k2 = this.jb;
      v2 = this.l5;
    }
    n = ((1 + n) | 0);
  }
  var x1 = n;
  switch (x1) {
    case 0: {
      return $m_sci_Map$EmptyMap$();
      break;
    }
    case 1: {
      return new $c_sci_Map$Map1(k1, v1);
      break;
    }
    case 2: {
      return new $c_sci_Map$Map2(k1, v1, k2, v2);
      break;
    }
    case 3: {
      return this;
      break;
    }
    default: {
      throw new $c_s_MatchError(x1);
    }
  }
});
$p.JB = (function(f) {
  var walue1 = f.R(this.jM, this.lK);
  var walue2 = f.R(this.ja, this.l4);
  var walue3 = f.R(this.jb, this.l5);
  return (((Object.is(walue1, this.lK) && Object.is(walue2, this.l4)) && Object.is(walue3, this.l5)) ? this : new $c_sci_Map$Map3(this.jM, walue1, this.ja, walue2, this.jb, walue3));
});
$p.x = (function() {
  var a = 0;
  var b = 0;
  var c = 1;
  var h = $m_s_util_hashing_MurmurHash3$().ri(this.jM, this.lK);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().ri(this.ja, this.l4);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().ri(this.jb, this.l5);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().xL;
  h = $m_s_util_hashing_MurmurHash3$().k(h, a);
  h = $m_s_util_hashing_MurmurHash3$().k(h, b);
  h = $m_s_util_hashing_MurmurHash3$().r8(h, c);
  return $m_s_util_hashing_MurmurHash3$().Z(h, 3);
});
$p.wk = (function(f) {
  return this.JB(f);
});
$p.fz = (function(key) {
  return this.Ji(key);
});
$p.bN = (function(key, value) {
  return this.JG(key, value);
});
function $isArrayOf_sci_Map$Map3(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.lg)));
}
var $d_sci_Map$Map3 = new $TypeData().i($c_sci_Map$Map3, "scala.collection.immutable.Map$Map3", ({
  lg: 1,
  bb: 1,
  aL: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  as: 1,
  ak: 1,
  i: 1,
  h: 1,
  aF: 1,
  b: 1,
  aV: 1,
  I: 1,
  bc: 1,
  z: 1,
  a: 1
}));
/** @constructor */
function $c_sci_Map$Map4(key1, value1, key2, value2, key3, value3, key4, value4) {
  this.i3 = null;
  this.kf = null;
  this.hw = null;
  this.jN = null;
  this.hg = null;
  this.jc = null;
  this.hh = null;
  this.jd = null;
  this.i3 = key1;
  this.kf = value1;
  this.hw = key2;
  this.jN = value2;
  this.hg = key3;
  this.jc = value3;
  this.hh = key4;
  this.jd = value4;
}
$p = $c_sci_Map$Map4.prototype = new $h_sci_AbstractMap();
$p.constructor = $c_sci_Map$Map4;
/** @constructor */
function $h_sci_Map$Map4() {
}
$h_sci_Map$Map4.prototype = $p;
$p.ju = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
});
$p.fa = (function(asPair) {
  return $f_sc_StrictOptimizedIterableOps__unzip__F1__T2(this, asPair);
});
$p.L = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$p.c5 = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.ct = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.dk = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bw = (function(pred) {
  return this.w0(pred, false);
});
$p.cE = (function(pred) {
  return this.w0(pred, true);
});
$p.fy = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__partitionMap__F1__T2(this, f);
});
$p.cn = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$p.aa = (function() {
  return 4;
});
$p.V = (function() {
  return 4;
});
$p.c = (function() {
  return false;
});
$p.i = (function(key) {
  if ($m_sr_BoxesRunTime$().Q(key, this.i3)) {
    return this.kf;
  } else if ($m_sr_BoxesRunTime$().Q(key, this.hw)) {
    return this.jN;
  } else if ($m_sr_BoxesRunTime$().Q(key, this.hg)) {
    return this.jc;
  } else if ($m_sr_BoxesRunTime$().Q(key, this.hh)) {
    return this.jd;
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key));
  }
});
$p.E = (function(key) {
  return ((($m_sr_BoxesRunTime$().Q(key, this.i3) || $m_sr_BoxesRunTime$().Q(key, this.hw)) || $m_sr_BoxesRunTime$().Q(key, this.hg)) || $m_sr_BoxesRunTime$().Q(key, this.hh));
});
$p.r = (function(key) {
  return ($m_sr_BoxesRunTime$().Q(key, this.i3) ? new $c_s_Some(this.kf) : ($m_sr_BoxesRunTime$().Q(key, this.hw) ? new $c_s_Some(this.jN) : ($m_sr_BoxesRunTime$().Q(key, this.hg) ? new $c_s_Some(this.jc) : ($m_sr_BoxesRunTime$().Q(key, this.hh) ? new $c_s_Some(this.jd) : $m_s_None$()))));
});
$p.ay = (function(key, default$1) {
  return ($m_sr_BoxesRunTime$().Q(key, this.i3) ? this.kf : ($m_sr_BoxesRunTime$().Q(key, this.hw) ? this.jN : ($m_sr_BoxesRunTime$().Q(key, this.hg) ? this.jc : ($m_sr_BoxesRunTime$().Q(key, this.hh) ? this.jd : default$1.a3()))));
});
$p.o = (function() {
  return new $c_sci_Map$Map4$$anon$7(this);
});
$p.lo = (function() {
  return new $c_sci_Map$Map4$$anon$8(this);
});
$p.hr = (function() {
  return new $c_sci_Map$Map4$$anon$9(this);
});
$p.JG = (function(key, value) {
  return ($m_sr_BoxesRunTime$().Q(key, this.i3) ? new $c_sci_Map$Map4(this.i3, value, this.hw, this.jN, this.hg, this.jc, this.hh, this.jd) : ($m_sr_BoxesRunTime$().Q(key, this.hw) ? new $c_sci_Map$Map4(this.i3, this.kf, this.hw, value, this.hg, this.jc, this.hh, this.jd) : ($m_sr_BoxesRunTime$().Q(key, this.hg) ? new $c_sci_Map$Map4(this.i3, this.kf, this.hw, this.jN, this.hg, value, this.hh, this.jd) : ($m_sr_BoxesRunTime$().Q(key, this.hh) ? new $c_sci_Map$Map4(this.i3, this.kf, this.hw, this.jN, this.hg, this.jc, this.hh, value) : $m_sci_HashMap$().fk.hq(this.i3, this.kf).hq(this.hw, this.jN).hq(this.hg, this.jc).hq(this.hh, this.jd).hq(key, value)))));
});
$p.Ji = (function(key) {
  return ($m_sr_BoxesRunTime$().Q(key, this.i3) ? new $c_sci_Map$Map3(this.hw, this.jN, this.hg, this.jc, this.hh, this.jd) : ($m_sr_BoxesRunTime$().Q(key, this.hw) ? new $c_sci_Map$Map3(this.i3, this.kf, this.hg, this.jc, this.hh, this.jd) : ($m_sr_BoxesRunTime$().Q(key, this.hg) ? new $c_sci_Map$Map3(this.i3, this.kf, this.hw, this.jN, this.hh, this.jd) : ($m_sr_BoxesRunTime$().Q(key, this.hh) ? new $c_sci_Map$Map3(this.i3, this.kf, this.hw, this.jN, this.hg, this.jc) : this))));
});
$p.F = (function(f) {
  f.i(new $c_T2(this.i3, this.kf));
  f.i(new $c_T2(this.hw, this.jN));
  f.i(new $c_T2(this.hg, this.jc));
  f.i(new $c_T2(this.hh, this.jd));
});
$p.lU = (function(p) {
  return ((((!(!p.i(new $c_T2(this.i3, this.kf)))) || (!(!p.i(new $c_T2(this.hw, this.jN))))) || (!(!p.i(new $c_T2(this.hg, this.jc))))) || (!(!p.i(new $c_T2(this.hh, this.jd)))));
});
$p.lV = (function(p) {
  return ((((!(!p.i(new $c_T2(this.i3, this.kf)))) && (!(!p.i(new $c_T2(this.hw, this.jN))))) && (!(!p.i(new $c_T2(this.hg, this.jc))))) && (!(!p.i(new $c_T2(this.hh, this.jd)))));
});
$p.w0 = (function(pred, isFlipped) {
  var k1 = null;
  var k2 = null;
  var k3 = null;
  var v1 = null;
  var v2 = null;
  var v3 = null;
  var n = 0;
  if (((!(!pred.i(new $c_T2(this.i3, this.kf)))) !== isFlipped)) {
    k1 = this.i3;
    v1 = this.kf;
    n = ((1 + n) | 0);
  }
  if (((!(!pred.i(new $c_T2(this.hw, this.jN)))) !== isFlipped)) {
    if ((n === 0)) {
      k1 = this.hw;
      v1 = this.jN;
    } else {
      k2 = this.hw;
      v2 = this.jN;
    }
    n = ((1 + n) | 0);
  }
  if (((!(!pred.i(new $c_T2(this.hg, this.jc)))) !== isFlipped)) {
    if ((n === 0)) {
      k1 = this.hg;
      v1 = this.jc;
    } else if ((n === 1)) {
      k2 = this.hg;
      v2 = this.jc;
    } else {
      k3 = this.hg;
      v3 = this.jc;
    }
    n = ((1 + n) | 0);
  }
  if (((!(!pred.i(new $c_T2(this.hh, this.jd)))) !== isFlipped)) {
    if ((n === 0)) {
      k1 = this.hh;
      v1 = this.jd;
    } else if ((n === 1)) {
      k2 = this.hh;
      v2 = this.jd;
    } else if ((n === 2)) {
      k3 = this.hh;
      v3 = this.jd;
    }
    n = ((1 + n) | 0);
  }
  var x1 = n;
  switch (x1) {
    case 0: {
      return $m_sci_Map$EmptyMap$();
      break;
    }
    case 1: {
      return new $c_sci_Map$Map1(k1, v1);
      break;
    }
    case 2: {
      return new $c_sci_Map$Map2(k1, v1, k2, v2);
      break;
    }
    case 3: {
      return new $c_sci_Map$Map3(k1, v1, k2, v2, k3, v3);
      break;
    }
    case 4: {
      return this;
      break;
    }
    default: {
      throw new $c_s_MatchError(x1);
    }
  }
});
$p.JB = (function(f) {
  var walue1 = f.R(this.i3, this.kf);
  var walue2 = f.R(this.hw, this.jN);
  var walue3 = f.R(this.hg, this.jc);
  var walue4 = f.R(this.hh, this.jd);
  return ((((Object.is(walue1, this.kf) && Object.is(walue2, this.jN)) && Object.is(walue3, this.jc)) && Object.is(walue4, this.jd)) ? this : new $c_sci_Map$Map4(this.i3, walue1, this.hw, walue2, this.hg, walue3, this.hh, walue4));
});
$p.aY7 = (function(builder) {
  return builder.IA(this.i3, this.kf).IA(this.hw, this.jN).IA(this.hg, this.jc).IA(this.hh, this.jd);
});
$p.x = (function() {
  var a = 0;
  var b = 0;
  var c = 1;
  var h = $m_s_util_hashing_MurmurHash3$().ri(this.i3, this.kf);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().ri(this.hw, this.jN);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().ri(this.hg, this.jc);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().ri(this.hh, this.jd);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().xL;
  h = $m_s_util_hashing_MurmurHash3$().k(h, a);
  h = $m_s_util_hashing_MurmurHash3$().k(h, b);
  h = $m_s_util_hashing_MurmurHash3$().r8(h, c);
  return $m_s_util_hashing_MurmurHash3$().Z(h, 4);
});
$p.wk = (function(f) {
  return this.JB(f);
});
$p.fz = (function(key) {
  return this.Ji(key);
});
$p.bN = (function(key, value) {
  return this.JG(key, value);
});
function $isArrayOf_sci_Map$Map4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.lh)));
}
var $d_sci_Map$Map4 = new $TypeData().i($c_sci_Map$Map4, "scala.collection.immutable.Map$Map4", ({
  lh: 1,
  bb: 1,
  aL: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  as: 1,
  ak: 1,
  i: 1,
  h: 1,
  aF: 1,
  b: 1,
  aV: 1,
  I: 1,
  bc: 1,
  z: 1,
  a: 1
}));
function $f_scm_Map__withDefaultValue__O__scm_Map($thiz, d) {
  return new $c_scm_Map$WithDefault($thiz, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2$2) => d)));
}
function $is_scm_Map(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.bt)));
}
function $isArrayOf_scm_Map(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bt)));
}
/** @constructor */
function $c_Lupickle_default$() {
  this.aKe = null;
  this.aKf = false;
  this.aKg = null;
  this.aKh = false;
  this.aKo = null;
  this.aKp = false;
  this.aKk = null;
  this.aKl = false;
  this.aKm = null;
  this.aKn = false;
  this.aVu = null;
  this.ow = null;
  this.aKa = null;
  this.pk = null;
  this.aKc = null;
  this.aKi = null;
  this.aK6 = null;
  this.a5 = null;
  this.aK8 = null;
  this.Ii = null;
  this.ae2 = null;
  this.aKs = null;
  this.aKt = false;
  this.I = null;
  this.aKb = null;
  this.hB = null;
  this.aKd = null;
  this.aKj = null;
  this.aK7 = null;
  this.gP = null;
  this.aK9 = null;
  this.tO = null;
  this.ae3 = null;
  this.aKu = null;
  this.aKv = false;
  this.aKq = null;
  this.aKr = false;
  $n_Lupickle_default$ = this;
  this.aVu = this;
  $f_Lupickle_implicits_Readers__$init$__V(this);
  $f_Lupickle_implicits_Writers__$init$__V(this);
  $f_Lupickle_MsgReadWriters__$init$__V(this);
}
$p = $c_Lupickle_default$.prototype = new $h_O();
$p.constructor = $c_Lupickle_default$;
/** @constructor */
function $h_Lupickle_default$() {
}
$h_Lupickle_default$.prototype = $p;
$p.cw = (function() {
  if ((!this.aKf)) {
    this.aKe = new $c_Lupickle_core_Types$ReadWriter$(this);
    this.aKf = true;
  }
  return this.aKe;
});
$p.OP = (function() {
  if ((!this.aKh)) {
    this.aKg = new $c_Lupickle_core_Types$Reader$(this);
    this.aKh = true;
  }
  return this.aKg;
});
$p.aLH = (function() {
  if ((!this.aKp)) {
    this.aKo = new $c_Lupickle_core_Types$Writer$(this);
    this.aKp = true;
  }
  return this.aKo;
});
$p.Iy = (function() {
  if ((!this.aKl)) {
    this.aKk = new $c_Lupickle_core_Types$TaggedReader$(this);
    this.aKl = true;
  }
  return this.aKk;
});
$p.aLD = (function() {
  if ((!this.aKn)) {
    this.aKm = new $c_Lupickle_core_Types$TaggedWriter$(this);
    this.aKn = true;
  }
  return this.aKm;
});
$p.En = (function() {
  if ((!this.aKt)) {
    this.aKs = new $c_Lupickle_implicits_Readers$JavaReader$(this);
    this.aKt = true;
  }
  return this.aKs;
});
$p.Eo = (function() {
  if ((!this.aKv)) {
    this.aKu = new $c_Lupickle_implicits_Writers$JavaWriter$(this);
    this.aKv = true;
  }
  return this.aKu;
});
$p.bas = (function() {
  if ((!this.aKr)) {
    this.aKq = new $c_Lupickle_Api$transform$(this);
    this.aKr = true;
  }
  return this.aKq;
});
var $d_Lupickle_default$ = new $TypeData().i($c_Lupickle_default$, "upickle.default$", ({
  P0: 1,
  OD: 1,
  PD: 1,
  P4: 1,
  Om: 1,
  Pa: 1,
  O2: 1,
  P1: 1,
  PA: 1,
  Pb: 1,
  Q0: 1,
  P6: 1,
  PG: 1,
  O1: 1,
  P8: 1,
  NX: 1,
  NW: 1,
  NZ: 1,
  NR: 1,
  NU: 1
}));
var $n_Lupickle_default$;
function $m_Lupickle_default$() {
  if ((!$n_Lupickle_default$)) {
    $n_Lupickle_default$ = new $c_Lupickle_default$();
  }
  return $n_Lupickle_default$;
}
function $is_sc_concurrent_Map(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.kU)));
}
function $isArrayOf_sc_concurrent_Map(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kU)));
}
function $p_sci_HashSet__newHashSetOrThis__sci_BitmapIndexedSetNode__sci_HashSet($thiz, newRootNode) {
  return (($thiz.dY === newRootNode) ? $thiz : new $c_sci_HashSet(newRootNode));
}
function $p_sci_HashSet__removedAllWithShallowMutations__sc_IterableOnce__sci_HashSet($thiz, that) {
  var iter = that.o();
  var curr = $thiz.dY;
  while (iter.p()) {
    var next = iter.q();
    var originalHash = $m_sr_Statics$().u(next);
    var improved = $m_sc_Hashing$().bz(originalHash);
    curr = curr.a4u(next, originalHash, improved, 0);
    if ((curr !== $thiz.dY)) {
      if ((curr.cC === 0)) {
        return $m_sci_HashSet$().vA;
      }
      while (iter.p()) {
        var next$2 = iter.q();
        var originalHash$2 = $m_sr_Statics$().u(next$2);
        var improved$2 = $m_sc_Hashing$().bz(originalHash$2);
        curr.aRA(next$2, originalHash$2, improved$2);
        if ((curr.cC === 0)) {
          return $m_sci_HashSet$().vA;
        }
      }
      return new $c_sci_HashSet(curr);
    }
  }
  return $thiz;
}
/** @constructor */
function $c_sci_HashSet(rootNode) {
  this.dY = null;
  this.dY = rootNode;
}
$p = $c_sci_HashSet.prototype = new $h_sci_AbstractSet();
$p.constructor = $c_sci_HashSet;
/** @constructor */
function $h_sci_HashSet() {
}
$h_sci_HashSet.prototype = $p;
$p.fa = (function(asPair) {
  return $f_sc_StrictOptimizedIterableOps__unzip__F1__T2(this, asPair);
});
$p.L = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$p.c5 = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.ct = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.dk = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bw = (function(pred) {
  return this.WN(pred, false);
});
$p.cE = (function(pred) {
  return this.WN(pred, true);
});
$p.fy = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__partitionMap__F1__T2(this, f);
});
$p.cd = (function() {
  return $m_sci_HashSet$();
});
$p.V = (function() {
  return this.dY.cC;
});
$p.aa = (function() {
  return this.dY.cC;
});
$p.c = (function() {
  return (this.dY.cC === 0);
});
$p.o = (function() {
  return (this.c() ? $m_sc_Iterator$().b8 : new $c_sci_SetIterator(this.dY));
});
$p.E = (function(element) {
  var elementUnimprovedHash = $m_sr_Statics$().u(element);
  var elementHash = $m_sc_Hashing$().bz(elementUnimprovedHash);
  return this.dY.Ai(element, elementUnimprovedHash, elementHash, 0);
});
$p.Pu = (function(element) {
  var elementUnimprovedHash = $m_sr_Statics$().u(element);
  var elementHash = $m_sc_Hashing$().bz(elementUnimprovedHash);
  return $p_sci_HashSet__newHashSetOrThis__sci_BitmapIndexedSetNode__sci_HashSet(this, this.dY.Q7(element, elementUnimprovedHash, elementHash, 0));
});
$p.b0V = (function(element) {
  var elementUnimprovedHash = $m_sr_Statics$().u(element);
  var elementHash = $m_sc_Hashing$().bz(elementUnimprovedHash);
  return $p_sci_HashSet__newHashSetOrThis__sci_BitmapIndexedSetNode__sci_HashSet(this, this.dY.a4u(element, elementUnimprovedHash, elementHash, 0));
});
$p.aYS = (function(that) {
  if ((that instanceof $c_sci_HashSet)) {
    if (this.c()) {
      return that;
    } else {
      var newNode = this.dY.aMW(that.dY, 0);
      return ((newNode === that.dY) ? that : $p_sci_HashSet__newHashSetOrThis__sci_BitmapIndexedSetNode__sci_HashSet(this, newNode));
    }
  } else if ((that instanceof $c_scm_HashSet)) {
    var iter = new $c_scm_HashSet$$anon$2(that);
    var current = this.dY;
    while (iter.p()) {
      var next = iter.q();
      var originalHash = that.yl(next.mD);
      var improved = $m_sc_Hashing$().bz(originalHash);
      current = current.Q7(next.pc, originalHash, improved, 0);
      if ((current !== this.dY)) {
        var shallowlyMutableNodeMap = $m_sci_Node$().d6($m_sci_Node$().fR(improved, 0));
        while (iter.p()) {
          var next$2 = iter.q();
          var originalHash$2 = that.yl(next$2.mD);
          var improved$2 = $m_sc_Hashing$().bz(originalHash$2);
          shallowlyMutableNodeMap = current.a58(next$2.pc, originalHash$2, improved$2, 0, shallowlyMutableNodeMap);
        }
        return new $c_sci_HashSet(current);
      }
    }
    return this;
  } else if ((that instanceof $c_scm_LinkedHashSet)) {
    var iter$2 = new $c_scm_LinkedHashSet$$anon$2(that);
    var current$2 = this.dY;
    while (iter$2.p()) {
      var next$3 = iter$2.q();
      var improvedHash$2 = next$3.pe;
      var originalHash$3 = (improvedHash$2 ^ ((improvedHash$2 >>> 16) | 0));
      var improved$3 = $m_sc_Hashing$().bz(originalHash$3);
      current$2 = current$2.Q7(next$3.pf, originalHash$3, improved$3, 0);
      if ((current$2 !== this.dY)) {
        var shallowlyMutableNodeMap$2 = $m_sci_Node$().d6($m_sci_Node$().fR(improved$3, 0));
        while (iter$2.p()) {
          var next$4 = iter$2.q();
          var improvedHash$3 = next$4.pe;
          var originalHash$4 = (improvedHash$3 ^ ((improvedHash$3 >>> 16) | 0));
          var improved$4 = $m_sc_Hashing$().bz(originalHash$4);
          shallowlyMutableNodeMap$2 = current$2.a58(next$4.pf, originalHash$4, improved$4, 0, shallowlyMutableNodeMap$2);
        }
        return new $c_sci_HashSet(current$2);
      }
    }
    return this;
  } else {
    var iter$3 = that.o();
    var current$3 = this.dY;
    while (iter$3.p()) {
      var element = iter$3.q();
      var originalHash$5 = $m_sr_Statics$().u(element);
      var improved$5 = $m_sc_Hashing$().bz(originalHash$5);
      current$3 = current$3.Q7(element, originalHash$5, improved$5, 0);
      if ((current$3 !== this.dY)) {
        var shallowlyMutableNodeMap$3 = $m_sci_Node$().d6($m_sci_Node$().fR(improved$5, 0));
        while (iter$3.p()) {
          var element$2 = iter$3.q();
          var originalHash$6 = $m_sr_Statics$().u(element$2);
          var improved$6 = $m_sc_Hashing$().bz(originalHash$6);
          shallowlyMutableNodeMap$3 = current$3.a58(element$2, originalHash$6, improved$6, 0, shallowlyMutableNodeMap$3);
        }
        return new $c_sci_HashSet(current$3);
      }
    }
    return this;
  }
});
$p.t = (function() {
  return this.o().q();
});
$p.bJ = (function() {
  return new $c_sci_SetReverseIterator(this.dY).q();
});
$p.F = (function(f) {
  this.dY.F(f);
});
$p.Q0 = (function(that) {
  return (this.c() || ((!that.c()) && ((that instanceof $c_sci_HashSet) ? this.dY.aib(that.dY, 0) : $f_sc_IterableOnceOps__forall__F1__Z(this, that))));
});
$p.e = (function(that) {
  if ((that instanceof $c_sci_HashSet)) {
    if ((this === that)) {
      return true;
    } else {
      var x = this.dY;
      var x$2 = that.dY;
      return ((x === null) ? (x$2 === null) : x.e(x$2));
    }
  } else {
    return $f_sc_Set__equals__O__Z(this, that);
  }
});
$p.hM = (function() {
  return "HashSet";
});
$p.x = (function() {
  var it = new $c_sci_SetHashIterator(this.dY);
  return $m_s_util_hashing_MurmurHash3$().Em(it, $m_s_util_hashing_MurmurHash3$().Vy);
});
$p.aZX = (function(that) {
  if (this.c()) {
    return this;
  } else if ((that instanceof $c_sci_HashSet)) {
    return (that.c() ? this : ((this.dY.afj(that.dY, 0).cC === 0) ? $m_sci_HashSet$().vA : $p_sci_HashSet__newHashSetOrThis__sci_BitmapIndexedSetNode__sci_HashSet(this, this.dY.afj(that.dY, 0))));
  } else if ((that instanceof $c_scm_HashSet)) {
    var iter = new $c_scm_HashSet$$anon$2(that);
    var curr = this.dY;
    while (iter.p()) {
      var next = iter.q();
      var originalHash = that.yl(next.mD);
      var improved = $m_sc_Hashing$().bz(originalHash);
      curr = curr.a4u(next.pc, originalHash, improved, 0);
      if ((curr !== this.dY)) {
        if ((curr.cC === 0)) {
          return $m_sci_HashSet$().vA;
        }
        while (iter.p()) {
          var next$2 = iter.q();
          var originalHash$2 = that.yl(next$2.mD);
          var improved$2 = $m_sc_Hashing$().bz(originalHash$2);
          curr.aRA(next$2.pc, originalHash$2, improved$2);
          if ((curr.cC === 0)) {
            return $m_sci_HashSet$().vA;
          }
        }
        return new $c_sci_HashSet(curr);
      }
    }
    return this;
  } else {
    var thatKnownSize = that.V();
    return ((thatKnownSize === 0) ? this : ((thatKnownSize <= this.dY.cC) ? $p_sci_HashSet__removedAllWithShallowMutations__sc_IterableOnce__sci_HashSet(this, that) : this.WN(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((elem$2$2) => that.E(elem$2$2))), true)));
  }
});
$p.b7B = (function(that) {
  if ($is_sc_Set(that)) {
    return this.aZX(that);
  }
  if ((that instanceof $c_sci_Range)) {
    if ((that.C() > this.dY.cC)) {
      return this.WN(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x3) => ((x0$1$2$2) => {
        if ((!$isInt(x0$1$2$2))) {
          return true;
        } else {
          var x2 = (x0$1$2$2 | 0);
          return (!x3.afb(x2));
        }
      }))(that)), false);
    }
  }
  return $p_sci_HashSet__removedAllWithShallowMutations__sc_IterableOnce__sci_HashSet(this, that);
});
$p.ju = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
});
$p.WN = (function(pred, isFlipped) {
  var newRootNode = this.dY.aO4(pred, isFlipped);
  return ((newRootNode === this.dY) ? this : ((newRootNode.cC === 0) ? $m_sci_HashSet$().vA : new $c_sci_HashSet(newRootNode)));
});
$p.tW = (function(p) {
  return $f_sc_IterableOps__dropWhile__F1__O(this, p);
});
$p.cn = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$p.ds = (function(n) {
  return $f_sc_IterableOps__drop__I__O(this, n);
});
$p.uj = (function(p) {
  return $f_sc_IterableOps__takeWhile__F1__O(this, p);
});
$p.J3 = (function(that) {
  return this.WN(that, false);
});
$p.jv = (function(that) {
  return this.b7B(that);
});
$p.dI = (function(that) {
  return this.aYS(that);
});
$p.lT = (function(elem) {
  return this.b0V(elem);
});
$p.hQ = (function(elem) {
  return this.Pu(elem);
});
function $isArrayOf_sci_HashSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.lc)));
}
var $d_sci_HashSet = new $TypeData().i($c_sci_HashSet, "scala.collection.immutable.HashSet", ({
  lc: 1,
  bg: 1,
  aQ: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  aG: 1,
  aR: 1,
  h: 1,
  b: 1,
  bi: 1,
  I: 1,
  bj: 1,
  J9: 1,
  HE: 1,
  z: 1,
  a5: 1,
  a: 1
}));
function $isArrayOf_sci_ListSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.Is)));
}
/** @constructor */
function $c_scm_AbstractSet() {
}
$p = $c_scm_AbstractSet.prototype = new $h_sc_AbstractSet();
$p.constructor = $c_scm_AbstractSet;
/** @constructor */
function $h_scm_AbstractSet() {
}
$h_scm_AbstractSet.prototype = $p;
$p.dG = (function(elems) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, elems);
});
$p.aR = (function() {
  return this;
});
function $p_sci_LazyList__initState__V($thiz) {
  if (($thiz.gK === $m_sci_LazyList$Uninitialized$())) {
    if (($thiz.xz === $m_sci_LazyList$MidEvaluation$())) {
      throw $ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), "LazyList evaluation depends on its own result (self-reference); see docs for more info");
    }
    var fun = $thiz.xz;
    $thiz.xz = $m_sci_LazyList$MidEvaluation$();
    try {
      var l = fun.a3().df();
    } finally {
      $thiz.xz = fun;
    }
    $thiz.xz = l.xz;
    $thiz.gK = l.gK;
  }
}
function $p_sci_LazyList__mapImpl__F1__sci_LazyList($thiz, f) {
  $m_sci_LazyList$();
  return $ct_sci_LazyList__O__(new $c_sci_LazyList(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => (($thiz.df() === $m_sci_LazyList$().bD) ? $m_sci_LazyList$().bD : ($m_sci_LazyList$(), $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), f.i($thiz.t()), $p_sci_LazyList__mapImpl__F1__sci_LazyList($thiz.eV(), f)))))));
}
function $p_sci_LazyList__eagerHeadZipImpl__sc_Iterator__sci_LazyList($thiz, it) {
  return ((($thiz.df() === $m_sci_LazyList$().bD) || (!it.p())) ? $m_sci_LazyList$().bD : ($m_sci_LazyList$(), $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), new $c_T2($thiz.t(), it.q()), ($m_sci_LazyList$(), $ct_sci_LazyList__O__(new $c_sci_LazyList(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $p_sci_LazyList__eagerHeadZipImpl__sc_Iterator__sci_LazyList($thiz.eV(), it))))))));
}
function $p_sci_LazyList__eagerHeadDropRightImpl__sci_LazyList__sci_LazyList($thiz, scout) {
  return ((scout.df() === $m_sci_LazyList$().bD) ? $m_sci_LazyList$().bD : ($m_sci_LazyList$(), $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), $thiz.t(), ($m_sci_LazyList$(), $ct_sci_LazyList__O__(new $c_sci_LazyList(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $p_sci_LazyList__eagerHeadDropRightImpl__sci_LazyList__sci_LazyList($thiz.eV(), scout.eV()))))))));
}
function $p_sci_LazyList__takeImpl__I__sci_LazyList($thiz, n) {
  return ((n <= 0) ? $m_sci_LazyList$().bD : ($m_sci_LazyList$(), $ct_sci_LazyList__O__(new $c_sci_LazyList(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => (($thiz.df() === $m_sci_LazyList$().bD) ? $m_sci_LazyList$().bD : ($m_sci_LazyList$(), $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), $thiz.t(), $p_sci_LazyList__takeImpl__I__sci_LazyList($thiz.eV(), ((n - 1) | 0))))))))));
}
function $p_sci_LazyList__takeWhileImpl__F1__sci_LazyList($thiz, p) {
  $m_sci_LazyList$();
  return $ct_sci_LazyList__O__(new $c_sci_LazyList(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => ((($thiz.df() === $m_sci_LazyList$().bD) || (!(!(!p.i($thiz.t()))))) ? $m_sci_LazyList$().bD : ($m_sci_LazyList$(), $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), $thiz.t(), $p_sci_LazyList__takeWhileImpl__F1__sci_LazyList($thiz.eV(), p)))))));
}
function $p_sci_LazyList__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder($thiz, b, start, sep, end) {
  b.ah = (("" + b.ah) + start);
  if (($thiz.gK === $m_sci_LazyList$Uninitialized$())) {
    b.ah = (b.ah + "<not computed>");
  } else if (($thiz.df() !== $m_sci_LazyList$().bD)) {
    var obj = $thiz.t();
    b.ah = (("" + b.ah) + obj);
    var cursor = $thiz;
    var scout = $thiz.eV();
    if ((cursor !== scout)) {
      cursor = scout;
      var this$1 = scout;
      if (((this$1.gK !== $m_sci_LazyList$Uninitialized$()) && (this$1.df() !== $m_sci_LazyList$().bD))) {
        scout = scout.eV();
        while (true) {
          if ((cursor !== scout)) {
            var this$2 = scout;
            var $x_1 = ((this$2.gK !== $m_sci_LazyList$Uninitialized$()) && (this$2.df() !== $m_sci_LazyList$().bD));
          } else {
            var $x_1 = false;
          }
          if ($x_1) {
            var c = cursor;
            b.ah = (("" + b.ah) + sep);
            var obj$1 = c.t();
            b.ah = (("" + b.ah) + obj$1);
            cursor = cursor.eV();
            scout = scout.eV();
            var this$3 = scout;
            if (((this$3.gK !== $m_sci_LazyList$Uninitialized$()) && (this$3.df() !== $m_sci_LazyList$().bD))) {
              scout = scout.eV();
            }
          } else {
            break;
          }
        }
      }
    }
    var this$4 = scout;
    if ((!((this$4.gK !== $m_sci_LazyList$Uninitialized$()) && (this$4.df() !== $m_sci_LazyList$().bD)))) {
      while ((cursor !== scout)) {
        var c$1 = cursor;
        b.ah = (("" + b.ah) + sep);
        var obj$2 = c$1.t();
        b.ah = (("" + b.ah) + obj$2);
        cursor = cursor.eV();
      }
      if ((!(cursor.gK !== $m_sci_LazyList$Uninitialized$()))) {
        b.ah = (("" + b.ah) + sep);
        b.ah = (b.ah + "<not computed>");
      }
    } else {
      if ((cursor !== $thiz)) {
        var runner = $thiz;
        while ((runner !== scout)) {
          runner = runner.eV();
          scout = scout.eV();
        }
        while (true) {
          var ct = cursor.eV();
          if ((ct !== scout)) {
            var c$2 = cursor;
            b.ah = (("" + b.ah) + sep);
            var obj$3 = c$2.t();
            b.ah = (("" + b.ah) + obj$3);
          }
          cursor = ct;
          if ((cursor !== scout)) {
          } else {
            break;
          }
        }
      }
      b.ah = (("" + b.ah) + sep);
      b.ah = (b.ah + "<cycle>");
    }
  }
  b.ah = (("" + b.ah) + end);
  return b;
}
function $ct_sci_LazyList__O__($thiz, lazyState) {
  $thiz.gK = ((lazyState === $m_sci_LazyList$EmptyMarker$()) ? null : $m_sci_LazyList$Uninitialized$());
  $thiz.xz = ((lazyState === $m_sci_LazyList$EmptyMarker$()) ? null : lazyState);
  return $thiz;
}
function $ct_sci_LazyList__O__sci_LazyList__($thiz, head, tail) {
  $ct_sci_LazyList__O__($thiz, $m_sci_LazyList$EmptyMarker$());
  $thiz.gK = head;
  $thiz.xz = tail;
  return $thiz;
}
/** @constructor */
function $c_sci_LazyList() {
  this.gK = null;
  this.xz = null;
}
$p = $c_sci_LazyList.prototype = new $h_sci_AbstractSeq();
$p.constructor = $c_sci_LazyList;
/** @constructor */
function $h_sci_LazyList() {
}
$h_sci_LazyList.prototype = $p;
$p.el = (function() {
  return "LinearSeq";
});
$p.dt = (function() {
  return $f_sc_LinearSeqOps__headOption__s_Option(this);
});
$p.C = (function() {
  return $f_sc_LinearSeqOps__length__I(this);
});
$p.bJ = (function() {
  return $f_sc_LinearSeqOps__last__O(this);
});
$p.bL = (function(len) {
  return $f_sc_LinearSeqOps__lengthCompare__I__I(this, len);
});
$p.agA = (function(x) {
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x);
});
$p.l = (function(n) {
  return $f_sc_LinearSeqOps__apply__I__O(this, n);
});
$p.lV = (function(p) {
  return $f_sc_LinearSeqOps__forall__F1__Z(this, p);
});
$p.lU = (function(p) {
  return $f_sc_LinearSeqOps__exists__F1__Z(this, p);
});
$p.E = (function(elem) {
  return $f_sc_LinearSeqOps__contains__O__Z(this, elem);
});
$p.AE = (function(that) {
  return $f_sc_LinearSeqOps__sameElements__sc_IterableOnce__Z(this, that);
});
$p.px = (function(p, from) {
  return $f_sc_LinearSeqOps__indexWhere__F1__I__I(this, p, from);
});
$p.df = (function() {
  while (true) {
    if ((this.gK !== $m_sci_LazyList$Uninitialized$())) {
      return ((this.xz === null) ? $m_sci_LazyList$().bD : this);
    } else {
      $p_sci_LazyList__initState__V(this);
    }
  }
});
$p.c = (function() {
  return (this.df() === $m_sci_LazyList$().bD);
});
$p.V = (function() {
  return (((this.gK !== $m_sci_LazyList$Uninitialized$()) && (this.df() === $m_sci_LazyList$().bD)) ? 0 : (-1));
});
$p.t = (function() {
  if ((this.df() === $m_sci_LazyList$().bD)) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "head of empty lazy list");
  } else {
    return this.gK;
  }
});
$p.eV = (function() {
  if ((this.df() === $m_sci_LazyList$().bD)) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "tail of empty lazy list");
  } else {
    return this.xz;
  }
});
$p.b1z = (function() {
  var these = this;
  var those = this;
  if ((!(these.df() === $m_sci_LazyList$().bD))) {
    these = these.eV();
  }
  while ((those !== these)) {
    if ((these.df() === $m_sci_LazyList$().bD)) {
      return this;
    }
    these = these.eV();
    if ((these.df() === $m_sci_LazyList$().bD)) {
      return this;
    }
    these = these.eV();
    if ((these === those)) {
      return this;
    }
    those = those.eV();
  }
  return this;
});
$p.o = (function() {
  return (((this.gK !== $m_sci_LazyList$Uninitialized$()) && (this.df() === $m_sci_LazyList$().bD)) ? $m_sc_Iterator$().b8 : new $c_sci_LazyList$LazyIterator(this));
});
$p.F = (function(f) {
  var _$this = this;
  while (true) {
    if ((!(_$this.df() === $m_sci_LazyList$().bD))) {
      f.i(_$this.t());
      _$this = _$this.eV();
      continue;
    }
    break;
  }
});
$p.hO = (function(z, op) {
  var _$this = this;
  while (true) {
    if ((_$this.df() === $m_sci_LazyList$().bD)) {
      return z;
    } else {
      var temp$_$this = _$this.eV();
      var temp$z = op.R(z, _$this.t());
      _$this = temp$_$this;
      z = temp$z;
    }
  }
});
$p.hM = (function() {
  return "LazyList";
});
$p.agR = (function(suffix) {
  $m_sci_LazyList$();
  return $ct_sci_LazyList__O__(new $c_sci_LazyList(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    if ((this.df() === $m_sci_LazyList$().bD)) {
      var x1 = suffix.a3();
      return ((x1 instanceof $c_sci_LazyList) ? x1 : ((x1.V() === 0) ? $m_sci_LazyList$().bD : $m_sci_LazyList$().ahQ(x1.o())));
    } else {
      $m_sci_LazyList$();
      return $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), this.t(), this.eV().agR(suffix));
    }
  })));
});
$p.aXa = (function(suffix) {
  return (((this.gK !== $m_sci_LazyList$Uninitialized$()) && (this.df() === $m_sci_LazyList$().bD)) ? $m_sci_LazyList$().a3v(suffix) : this.agR(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => suffix))));
});
$p.aX7 = (function(elem) {
  return (((this.gK !== $m_sci_LazyList$Uninitialized$()) && (this.df() === $m_sci_LazyList$().bD)) ? ($m_sci_LazyList$(), $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), elem, $m_sci_LazyList$().bD)) : this.agR(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => new $c_sc_Iterator$$anon$20(elem)))));
});
$p.kT = (function(f) {
  if ((this.df() === $m_sci_LazyList$().bD)) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.reduceLeft");
  } else {
    var reducedRes = this.t();
    var left = this.eV();
    while ((!(left.df() === $m_sci_LazyList$().bD))) {
      reducedRes = f.R(reducedRes, left.t());
      left = left.eV();
    }
    return reducedRes;
  }
});
$p.ju = (function(p) {
  return new $c_T2(this.afJ(p), this.aO8(p));
});
$p.fy = (function(f) {
  var x1 = this.PE(f).ju(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$2) => x$1$2$2.aPq())));
  if ((x1 === null)) {
    throw new $c_s_MatchError(x1);
  }
  var left = x1.g();
  var right = x1.h();
  return new $c_T2(left.PE(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$3$2$2) => x$3$2$2.lP))), right.PE(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$4$2$2) => x$4$2$2.hm))));
});
$p.afJ = (function(pred) {
  return (((this.gK !== $m_sci_LazyList$Uninitialized$()) && (this.df() === $m_sci_LazyList$().bD)) ? $m_sci_LazyList$().bD : $m_sci_LazyList$().ahS(this, pred, false));
});
$p.aO8 = (function(pred) {
  return (((this.gK !== $m_sci_LazyList$Uninitialized$()) && (this.df() === $m_sci_LazyList$().bD)) ? $m_sci_LazyList$().bD : $m_sci_LazyList$().ahS(this, pred, true));
});
$p.un = (function(p) {
  return new $c_sci_LazyList$WithFilter(this, p);
});
$p.PE = (function(f) {
  return (((this.gK !== $m_sci_LazyList$Uninitialized$()) && (this.df() === $m_sci_LazyList$().bD)) ? $m_sci_LazyList$().bD : $p_sci_LazyList__mapImpl__F1__sci_LazyList(this, f));
});
$p.aYu = (function(pf) {
  return (((this.gK !== $m_sci_LazyList$Uninitialized$()) && (this.df() === $m_sci_LazyList$().bD)) ? $m_sci_LazyList$().bD : $m_sci_LazyList$().aRS(this, pf));
});
$p.nw = (function(pf) {
  var _$this = this;
  while (true) {
    if ((_$this.df() === $m_sci_LazyList$().bD)) {
      return $m_s_None$();
    } else {
      var res = pf.aC(_$this.t(), $m_sci_LazyList$().acD);
      if ((res === $m_sr_Statics$PFMarker$())) {
        _$this = _$this.eV();
      } else {
        return new $c_s_Some(res);
      }
    }
  }
});
$p.iW = (function(p) {
  var _$this = this;
  while (true) {
    if ((_$this.df() === $m_sci_LazyList$().bD)) {
      return $m_s_None$();
    } else {
      var elem = _$this.t();
      if ((!(!p.i(elem)))) {
        return new $c_s_Some(elem);
      } else {
        _$this = _$this.eV();
      }
    }
  }
});
$p.WQ = (function(f) {
  return (((this.gK !== $m_sci_LazyList$Uninitialized$()) && (this.df() === $m_sci_LazyList$().bD)) ? $m_sci_LazyList$().bD : $m_sci_LazyList$().aRT(this, f));
});
$p.bcZ = (function(that) {
  return ((((this.gK !== $m_sci_LazyList$Uninitialized$()) && (this.df() === $m_sci_LazyList$().bD)) || (that.V() === 0)) ? $m_sci_LazyList$().bD : ($m_sci_LazyList$(), $ct_sci_LazyList__O__(new $c_sci_LazyList(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $p_sci_LazyList__eagerHeadZipImpl__sc_Iterator__sci_LazyList(this, that.o()))))));
});
$p.bd0 = (function() {
  return this.bcZ($m_sci_LazyList$().aOo(0, 1));
});
$p.fa = (function(asPair) {
  return new $c_T2(this.PE(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$5$2$2) => asPair.i(x$5$2$2).g()))), this.PE(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$6$2$2) => asPair.i(x$6$2$2).h()))));
});
$p.b0a = (function(n) {
  return ((n <= 0) ? this : (((this.gK !== $m_sci_LazyList$Uninitialized$()) && (this.df() === $m_sci_LazyList$().bD)) ? $m_sci_LazyList$().bD : $m_sci_LazyList$().b85(this, n)));
});
$p.b0g = (function(p) {
  return (((this.gK !== $m_sci_LazyList$Uninitialized$()) && (this.df() === $m_sci_LazyList$().bD)) ? $m_sci_LazyList$().bD : $m_sci_LazyList$().b86(this, p));
});
$p.b0d = (function(n) {
  return ((n <= 0) ? this : (((this.gK !== $m_sci_LazyList$Uninitialized$()) && (this.df() === $m_sci_LazyList$().bD)) ? $m_sci_LazyList$().bD : ($m_sci_LazyList$(), $ct_sci_LazyList__O__(new $c_sci_LazyList(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    var scout = this;
    var remaining = n;
    while (((remaining > 0) && (!(scout.df() === $m_sci_LazyList$().bD)))) {
      remaining = ((remaining - 1) | 0);
      scout = scout.eV();
    }
    return $p_sci_LazyList__eagerHeadDropRightImpl__sci_LazyList__sci_LazyList(this, scout);
  }))))));
});
$p.b9M = (function(n) {
  return (((this.gK !== $m_sci_LazyList$Uninitialized$()) && (this.df() === $m_sci_LazyList$().bD)) ? $m_sci_LazyList$().bD : $p_sci_LazyList__takeImpl__I__sci_LazyList(this, n));
});
$p.b9P = (function(p) {
  return (((this.gK !== $m_sci_LazyList$Uninitialized$()) && (this.df() === $m_sci_LazyList$().bD)) ? $m_sci_LazyList$().bD : $p_sci_LazyList__takeWhileImpl__F1__sci_LazyList(this, p));
});
$p.lf = (function(sb, start, sep, end) {
  this.b1z();
  $p_sci_LazyList__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder(this, sb.bP, start, sep, end);
  return sb;
});
$p.m = (function() {
  return $p_sci_LazyList__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder(this, $ct_jl_StringBuilder__T__(new $c_jl_StringBuilder(), "LazyList"), "(", ", ", ")").ah;
});
$p.i = (function(v1) {
  return $f_sc_LinearSeqOps__apply__I__O(this, (v1 | 0));
});
$p.aM = (function(x) {
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, (x | 0));
});
$p.uj = (function(p) {
  return this.b9P(p);
});
$p.Jt = (function(n) {
  return this.b9M(n);
});
$p.cn = (function(n) {
  return this.b0d(n);
});
$p.tW = (function(p) {
  return this.b0g(p);
});
$p.ds = (function(n) {
  return this.b0a(n);
});
$p.Es = (function() {
  return this.bd0();
});
$p.dk = (function(asIterable) {
  return this.WQ(asIterable);
});
$p.c5 = (function(f) {
  return this.WQ(f);
});
$p.ct = (function(pf) {
  return this.aYu(pf);
});
$p.L = (function(f) {
  return this.PE(f);
});
$p.kv = (function(elem) {
  $m_sci_LazyList$();
  return $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), elem, this);
});
$p.cE = (function(pred) {
  return this.aO8(pred);
});
$p.bw = (function(pred) {
  return this.afJ(pred);
});
$p.bv = (function(elem) {
  return this.aX7(elem);
});
$p.gU = (function(suffix) {
  return this.aXa(suffix);
});
$p.v = (function() {
  return this.eV();
});
$p.cd = (function() {
  return $m_sci_LazyList$();
});
function $isArrayOf_sci_LazyList(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ld)));
}
var $d_sci_LazyList = new $TypeData().i($c_sci_LazyList, "scala.collection.immutable.LazyList", ({
  ld: 1,
  a6: 1,
  L: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  H: 1,
  i: 1,
  h: 1,
  w: 1,
  b: 1,
  X: 1,
  I: 1,
  a2: 1,
  cN: 1,
  bF: 1,
  cH: 1,
  cO: 1,
  a: 1
}));
/** @constructor */
function $c_sci_WrappedString(self) {
  this.iG = null;
  this.iG = self;
}
$p = $c_sci_WrappedString.prototype = new $h_sci_AbstractSeq();
$p.constructor = $c_sci_WrappedString;
/** @constructor */
function $h_sci_WrappedString() {
}
$h_sci_WrappedString.prototype = $p;
$p.IG = (function(that) {
  return $f_sci_IndexedSeq__canEqual__O__Z(this, that);
});
$p.el = (function() {
  return "IndexedSeq";
});
$p.o = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), new $c_sc_StringView(this.iG));
});
$p.cx = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), new $c_sc_StringView(this.iG));
});
$p.k0 = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$p.kv = (function(elem) {
  return $f_sc_IndexedSeqOps__prepended__O__O(this, elem);
});
$p.Jt = (function(n) {
  return $f_sc_IndexedSeqOps__take__I__O(this, n);
});
$p.ds = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n);
});
$p.cn = (function(n) {
  return $f_sc_IndexedSeqOps__dropRight__I__O(this, n);
});
$p.L = (function(f) {
  return $f_sc_IndexedSeqOps__map__F1__O(this, f);
});
$p.hU = (function() {
  return $f_sc_IndexedSeqOps__reverse__O(this);
});
$p.t = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$p.dt = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$p.bJ = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$p.bL = (function(len) {
  var this$1 = this.iG;
  var x = this$1.length;
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$p.V = (function() {
  return this.iG.length;
});
$p.fS = (function() {
  return $m_sci_WrappedString$().b5();
});
$p.b8Y = (function(from, until) {
  var start = ((from < 0) ? 0 : from);
  if (((until <= start) || (start >= this.iG.length))) {
    return $m_sci_WrappedString$().acT;
  }
  var end = ((until > this.iG.length) ? this.iG.length : until);
  var this$4 = this.iG;
  return new $c_sci_WrappedString(this$4.substring(start, end));
});
$p.C = (function() {
  return this.iG.length;
});
$p.m = (function() {
  return this.iG;
});
$p.mN = (function(elem, from) {
  if ((elem instanceof $Char)) {
    var x2 = $uC(elem);
    return $f_T__indexOf__I__I__I(this.iG, x2, from);
  } else {
    return $f_sc_SeqOps__indexOf__O__I__I(this, elem, from);
  }
});
$p.cR = (function(xs, start, len) {
  if ((xs instanceof $ac_C)) {
    var this$1 = this.iG;
    var srcLen = this$1.length;
    var destLen = xs.a.length;
    var limit = ((len < srcLen) ? len : srcLen);
    var capacity = ((start < 0) ? destLen : ((destLen - start) | 0));
    var total = ((capacity < limit) ? capacity : limit);
    var copied = ((total < 0) ? 0 : total);
    $f_T__getChars__I__I__AC__I__V(this.iG, 0, copied, xs, start);
    return copied;
  } else {
    return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
  }
});
$p.aX9 = (function(suffix) {
  return ((suffix instanceof $c_sci_WrappedString) ? new $c_sci_WrappedString((this.iG + suffix.iG)) : $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix));
});
$p.AE = (function(o) {
  return ((o instanceof $c_sci_WrappedString) ? (this.iG === o.iG) : $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this, o));
});
$p.hM = (function() {
  return "WrappedString";
});
$p.OZ = (function() {
  return 2147483647;
});
$p.e = (function(other) {
  return ((other instanceof $c_sci_WrappedString) ? (this.iG === other.iG) : $f_sc_Seq__equals__O__Z(this, other));
});
$p.cd = (function() {
  return $m_sci_IndexedSeq$();
});
$p.gU = (function(suffix) {
  return this.aX9(suffix);
});
$p.JI = (function() {
  return new $c_sc_StringView(this.iG);
});
$p.hV = (function(from, until) {
  return this.b8Y(from, until);
});
$p.pr = (function() {
  return $m_sci_WrappedString$().acT;
});
$p.fP = (function(coll) {
  return $m_sci_WrappedString$().aOE(coll);
});
$p.w4 = (function(coll) {
  return $m_sci_WrappedString$().aOE(coll);
});
$p.i = (function(v1) {
  var i = (v1 | 0);
  return $bC(this.iG.charCodeAt(i));
});
$p.l = (function(i) {
  return $bC(this.iG.charCodeAt(i));
});
function $isArrayOf_sci_WrappedString(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.lB)));
}
var $d_sci_WrappedString = new $TypeData().i($c_sci_WrappedString, "scala.collection.immutable.WrappedString", ({
  lB: 1,
  a6: 1,
  L: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  H: 1,
  i: 1,
  h: 1,
  w: 1,
  b: 1,
  X: 1,
  I: 1,
  a2: 1,
  a7: 1,
  M: 1,
  A: 1,
  ae: 1,
  a: 1
}));
function $ct_sjsr_WrappedVarArgs__sjs_js_Array__($thiz, array) {
  $thiz.a1X = array;
  return $thiz;
}
function $ct_sjsr_WrappedVarArgs__($thiz) {
  $ct_sjsr_WrappedVarArgs__sjs_js_Array__($thiz, []);
  return $thiz;
}
/** @constructor */
function $c_sjsr_WrappedVarArgs() {
  this.a1X = null;
}
$p = $c_sjsr_WrappedVarArgs.prototype = new $h_O();
$p.constructor = $c_sjsr_WrappedVarArgs;
/** @constructor */
function $h_sjsr_WrappedVarArgs() {
}
$h_sjsr_WrappedVarArgs.prototype = $p;
$p.ko = (function(f) {
  return $f_sci_StrictOptimizedSeqOps__distinctBy__F1__O(this, f);
});
$p.h9 = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord);
});
$p.kv = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__prepended__O__O(this, elem);
});
$p.bv = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__appended__O__O(this, elem);
});
$p.gU = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix);
});
$p.ju = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
});
$p.PW = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__span__F1__T2(this, p);
});
$p.fa = (function(asPair) {
  return $f_sc_StrictOptimizedIterableOps__unzip__F1__T2(this, asPair);
});
$p.L = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$p.c5 = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.ct = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.dk = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.Es = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this);
});
$p.bw = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$p.cE = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true);
});
$p.fy = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__partitionMap__F1__T2(this, f);
});
$p.cn = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$p.IG = (function(that) {
  return $f_sci_IndexedSeq__canEqual__O__Z(this, that);
});
$p.AE = (function(o) {
  return $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this, o);
});
$p.OZ = (function() {
  return $m_sci_IndexedSeqDefaults$().aIj;
});
$p.hV = (function(from, until) {
  return $f_sci_IndexedSeqOps__slice__I__I__O(this, from, until);
});
$p.o = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), new $c_sc_IndexedSeqView$Id(this));
});
$p.cx = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), new $c_sc_IndexedSeqView$Id(this));
});
$p.Jt = (function(n) {
  return $f_sc_IndexedSeqOps__take__I__O(this, n);
});
$p.ds = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n);
});
$p.hU = (function() {
  return $f_sc_IndexedSeqOps__reverse__O(this);
});
$p.t = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$p.dt = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$p.bJ = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$p.bL = (function(len) {
  var x = this.C();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$p.V = (function() {
  return this.C();
});
$p.iz = (function() {
  return this;
});
$p.e = (function(o) {
  return $f_sc_Seq__equals__O__Z(this, o);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().a4G(this);
});
$p.m = (function() {
  return $f_sc_Iterable__toString__T(this);
});
$p.g9 = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix);
});
$p.aa = (function() {
  return this.C();
});
$p.nz = (function() {
  return $f_sc_SeqOps__distinct__O(this);
});
$p.px = (function(p, from) {
  return $f_sc_Iterator__indexWhere__F1__I__I($ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), new $c_sc_IndexedSeqView$Id(this)), p, from);
});
$p.mN = (function(elem, from) {
  return $f_sc_SeqOps__indexOf__O__I__I(this, elem, from);
});
$p.E = (function(elem) {
  return $f_sc_SeqOps__contains__O__Z(this, elem);
});
$p.nE = (function(otherSize) {
  var x = this.C();
  return ((x === otherSize) ? 0 : ((x < otherSize) ? (-1) : 1));
});
$p.c = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$p.Ar = (function() {
  return new $c_s_PartialFunction$Lifted(this);
});
$p.aC = (function(x, default$1) {
  return $f_s_PartialFunction__applyOrElse__O__F1__O(this, x, default$1);
});
$p.Eg = (function(action) {
  return $f_s_PartialFunction__runWith__F1__F1(this, action);
});
$p.iU = (function(v1) {
  return (!(!this.l(v1)));
});
$p.fS = (function() {
  return $m_sjsr_WrappedVarArgs$().b5();
});
$p.un = (function(p) {
  return $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(new $c_sc_IterableOps$WithFilter(), this, p);
});
$p.uj = (function(p) {
  return $f_sc_IterableOps__takeWhile__F1__O(this, p);
});
$p.tW = (function(p) {
  return $f_sc_IterableOps__dropWhile__F1__O(this, p);
});
$p.v = (function() {
  return $f_sc_IterableOps__tail__O(this);
});
$p.lX = (function() {
  return $f_sc_IterableOps__init__O(this);
});
$p.F = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f);
});
$p.lV = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p);
});
$p.lU = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p);
});
$p.iW = (function(p) {
  return $f_sc_IterableOnceOps__find__F1__s_Option(this, p);
});
$p.hO = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$p.kT = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$p.cR = (function(dest, start, n) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, dest, start, n);
});
$p.k2 = (function(num) {
  return $f_sc_IterableOnceOps__sum__s_math_Numeric__O(this, num);
});
$p.lr = (function(ord) {
  return $f_sc_IterableOnceOps__min__s_math_Ordering__O(this, ord);
});
$p.lq = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord);
});
$p.nw = (function(pf) {
  return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this, pf);
});
$p.lf = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$p.bM = (function() {
  return $m_sci_Nil$().b6(this);
});
$p.d2 = (function() {
  return $m_sci_Vector$().X(this);
});
$p.eX = (function(ev) {
  return $m_sci_Map$().ao(this);
});
$p.nG = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$p.nB = (function() {
  return $m_sjsr_WrappedVarArgs$();
});
$p.C = (function() {
  return (this.a1X.length | 0);
});
$p.l = (function(idx) {
  return this.a1X[idx];
});
$p.hM = (function() {
  return "WrappedVarArgs";
});
$p.fP = (function(coll) {
  return $m_sjsr_WrappedVarArgs$().ag2(coll);
});
$p.aM = (function(x) {
  return $f_sc_SeqOps__isDefinedAt__I__Z(this, (x | 0));
});
$p.JI = (function() {
  return new $c_sc_IndexedSeqView$Id(this);
});
$p.i = (function(v1) {
  return this.l((v1 | 0));
});
$p.cd = (function() {
  return $m_sjsr_WrappedVarArgs$();
});
function $isArrayOf_sjsr_WrappedVarArgs(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.mo)));
}
var $d_sjsr_WrappedVarArgs = new $TypeData().i($c_sjsr_WrappedVarArgs, "scala.scalajs.runtime.WrappedVarArgs", ({
  mo: 1,
  a7: 1,
  X: 1,
  I: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  H: 1,
  i: 1,
  h: 1,
  w: 1,
  b: 1,
  a2: 1,
  M: 1,
  A: 1,
  ae: 1,
  a8: 1,
  N: 1,
  z: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_LinkedHashMap(underlying) {
  this.Ov = null;
  this.Ov = underlying;
}
$p = $c_Lupickle_core_LinkedHashMap.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_LinkedHashMap;
/** @constructor */
function $h_Lupickle_core_LinkedHashMap() {
}
$h_Lupickle_core_LinkedHashMap.prototype = $p;
$p.F = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f);
});
$p.lV = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p);
});
$p.iW = (function(p) {
  return $f_sc_IterableOnceOps__find__F1__s_Option(this, p);
});
$p.hO = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$p.kT = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$p.c = (function() {
  return $f_sc_IterableOnceOps__isEmpty__Z(this);
});
$p.aa = (function() {
  return $f_sc_IterableOnceOps__size__I(this);
});
$p.cR = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
});
$p.k2 = (function(num) {
  return $f_sc_IterableOnceOps__sum__s_math_Numeric__O(this, num);
});
$p.lr = (function(ord) {
  return $f_sc_IterableOnceOps__min__s_math_Ordering__O(this, ord);
});
$p.lq = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord);
});
$p.nw = (function(pf) {
  return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this, pf);
});
$p.bM = (function() {
  return $m_sci_Nil$().b6(this);
});
$p.d2 = (function() {
  return $m_sci_Vector$().X(this);
});
$p.eX = (function(ev) {
  return $m_sci_Map$().ao(this);
});
$p.iz = (function() {
  return $m_sci_Seq$().fw(this);
});
$p.nG = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$p.dt = (function() {
  return $f_sc_IterableOps__headOption__s_Option(this);
});
$p.bJ = (function() {
  return $f_sc_IterableOps__last__O(this);
});
$p.nE = (function(otherSize) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, otherSize);
});
$p.bw = (function(pred) {
  return $f_sc_IterableOps__filter__F1__O(this, pred);
});
$p.cE = (function(pred) {
  return $f_sc_IterableOps__filterNot__F1__O(this, pred);
});
$p.uj = (function(p) {
  return $f_sc_IterableOps__takeWhile__F1__O(this, p);
});
$p.ds = (function(n) {
  return $f_sc_IterableOps__drop__I__O(this, n);
});
$p.cn = (function(n) {
  return $f_sc_IterableOps__dropRight__I__O(this, n);
});
$p.tW = (function(p) {
  return $f_sc_IterableOps__dropWhile__F1__O(this, p);
});
$p.L = (function(f) {
  return $f_sc_IterableOps__map__F1__O(this, f);
});
$p.c5 = (function(f) {
  return $f_sc_IterableOps__flatMap__F1__O(this, f);
});
$p.dk = (function(asIterable) {
  return $f_sc_IterableOps__flatMap__F1__O(this, asIterable);
});
$p.ct = (function(pf) {
  return $f_sc_IterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.fy = (function(f) {
  return $f_sc_IterableOps__partitionMap__F1__T2(this, f);
});
$p.g9 = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$p.fa = (function(asPair) {
  return $f_sc_IterableOps__unzip__F1__T2(this, asPair);
});
$p.hM = (function() {
  return "Map";
});
$p.cd = (function() {
  return $m_scm_Iterable$();
});
$p.Ar = (function() {
  return new $c_s_PartialFunction$Lifted(this);
});
$p.Eg = (function(action) {
  return $f_s_PartialFunction__runWith__F1__F1(this, action);
});
$p.ay = (function(key, default$1) {
  return $f_sc_MapOps__getOrElse__O__F0__O(this, key, default$1);
});
$p.i = (function(key) {
  return $f_sc_MapOps__apply__O__O(this, key);
});
$p.aC = (function(x, default$1) {
  return $f_sc_MapOps__applyOrElse__O__F1__O(this, x, default$1);
});
$p.e6 = (function() {
  return new $c_sc_MapOps$$anon$1(this);
});
$p.lo = (function() {
  return new $c_sc_MapOps$$anon$2(this);
});
$p.hr = (function() {
  return new $c_sc_MapOps$$anon$3(this);
});
$p.pu = (function(f) {
  $f_sc_MapOps__foreachEntry__F2__V(this, f);
});
$p.WC = (function(key) {
  return $f_sc_MapOps__default__O__O(this, key);
});
$p.E = (function(key) {
  return $f_sc_MapOps__contains__O__Z(this, key);
});
$p.aM = (function(key) {
  return $f_sc_MapOps__contains__O__Z(this, key);
});
$p.kP = (function(f) {
  return $f_sc_MapOps__map__F1__sc_IterableOps(this, f);
});
$p.hN = (function(suffix) {
  return $f_sc_MapOps__concat__sc_IterableOnce__sc_IterableOps(this, suffix);
});
$p.lf = (function(sb, start, sep, end) {
  return $f_sc_MapOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, sb, start, sep, end);
});
$p.fS = (function() {
  return $m_scm_Map$().b5();
});
$p.pr = (function() {
  return $f_sc_MapFactoryDefaults__empty__sc_IterableOps(this);
});
$p.e = (function(o) {
  return $f_sc_Map__equals__O__Z(this, o);
});
$p.x = (function() {
  return $m_s_util_hashing_MurmurHash3$().aQ6(this);
});
$p.m = (function() {
  return $f_sc_Iterable__toString__T(this);
});
$p.dG = (function(elems) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, elems);
});
$p.f9 = (function(size) {
});
$p.cY = (function(key, value) {
  $f_scm_MapOps__update__O__O__V(this, key, value);
});
$p.ec = (function(key, defaultValue) {
  return $f_scm_MapOps__getOrElseUpdate__O__F0__O(this, key, defaultValue);
});
$p.AD = (function(key) {
  return $f_scm_MapOps__remove__O__s_Option(this, key);
});
$p.afM = (function(p) {
  return $f_scm_MapOps__filterInPlace__F2__scm_MapOps(this, p);
});
$p.V = (function() {
  return (-1);
});
$p.im = (function() {
  return $m_scm_Map$();
});
$p.air = (function(key, value) {
  if ((key === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "null keys are not allowed");
  }
  var $x_2 = this.Ov;
  if ((key === null)) {
    var $x_1 = 0;
  } else {
    var originalHash = $dp_hashCode__I(key);
    var $x_1 = (originalHash ^ ((originalHash >>> 16) | 0));
  }
  return $x_2.aPz(key, value, $x_1, false);
});
$p.aLU = (function(elem) {
  this.air(elem.g(), elem.h());
  return this;
});
$p.o = (function() {
  return new $c_Lupickle_core_LinkedHashMap$$anon$1(new $c_ju_HashMap$KeySet(this.Ov).r4(), this);
});
$p.r = (function(key) {
  return $m_s_Option$().as($p_ju_HashMap__getOrDefaultImpl__O__O__O(this.Ov, key, null));
});
$p.b9t = (function(elem) {
  this.Ov.b7p(elem);
  return this;
});
$p.ue = (function(key, value) {
  return $m_s_Option$().as(this.air(key, value));
});
$p.Y = (function(elem) {
  return this.aLU(elem);
});
$p.re = (function(elem) {
  return this.b9t(elem);
});
$p.aR = (function() {
  return this;
});
$p.fP = (function(coll) {
  return $m_scm_Map$().cc(coll);
});
$p.un = (function(p) {
  return new $c_sc_MapOps$WithFilter(this, p);
});
$p.iU = (function(v1) {
  return (!(!$f_sc_MapOps__apply__O__O(this, v1)));
});
var $d_Lupickle_core_LinkedHashMap = new $TypeData().i($c_Lupickle_core_LinkedHashMap, "upickle.core.LinkedHashMap", ({
  On: 1,
  e: 1,
  f: 1,
  m: 1,
  l: 1,
  k: 1,
  aa: 1,
  h: 1,
  i: 1,
  ak: 1,
  aF: 1,
  b: 1,
  as: 1,
  W: 1,
  a9: 1,
  S: 1,
  T: 1,
  Y: 1,
  aM: 1,
  c6: 1,
  bt: 1,
  OX: 1
}));
/** @constructor */
function $c_sci_HashMap(rootNode) {
  this.cP = null;
  this.cP = rootNode;
}
$p = $c_sci_HashMap.prototype = new $h_sci_AbstractMap();
$p.constructor = $c_sci_HashMap;
/** @constructor */
function $h_sci_HashMap() {
}
$h_sci_HashMap.prototype = $p;
$p.kP = (function(f) {
  return $f_sc_StrictOptimizedMapOps__map__F1__sc_IterableOps(this, f);
});
$p.Pl = (function(f) {
  return $f_sc_StrictOptimizedMapOps__flatMap__F1__sc_IterableOps(this, f);
});
$p.DQ = (function(pf) {
  return $f_sc_StrictOptimizedMapOps__collect__s_PartialFunction__sc_IterableOps(this, pf);
});
$p.fa = (function(asPair) {
  return $f_sc_StrictOptimizedIterableOps__unzip__F1__T2(this, asPair);
});
$p.L = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$p.c5 = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.ct = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.dk = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bw = (function(pred) {
  return this.a3m(pred, false);
});
$p.cE = (function(pred) {
  return this.a3m(pred, true);
});
$p.fy = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__partitionMap__F1__T2(this, f);
});
$p.im = (function() {
  return $m_sci_HashMap$();
});
$p.V = (function() {
  return this.cP.dS;
});
$p.aa = (function() {
  return this.cP.dS;
});
$p.c = (function() {
  return (this.cP.dS === 0);
});
$p.ln = (function() {
  return ((this.cP.dS === 0) ? $m_sci_Set$EmptySet$() : new $c_sci_HashMap$HashKeySet(this));
});
$p.o = (function() {
  return (this.c() ? $m_sc_Iterator$().b8 : new $c_sci_MapKeyValueTupleIterator(this.cP));
});
$p.lo = (function() {
  return (this.c() ? $m_sc_Iterator$().b8 : new $c_sci_MapKeyIterator(this.cP));
});
$p.hr = (function() {
  return (this.c() ? $m_sc_Iterator$().b8 : new $c_sci_MapValueIterator(this.cP));
});
$p.cx = (function() {
  return (this.c() ? $m_sc_Iterator$().b8 : new $c_sci_MapKeyValueTupleReverseIterator(this.cP));
});
$p.E = (function(key) {
  var keyUnimprovedHash = $m_sr_Statics$().u(key);
  var keyHash = $m_sc_Hashing$().bz(keyUnimprovedHash);
  return this.cP.a30(key, keyUnimprovedHash, keyHash, 0);
});
$p.i = (function(key) {
  var keyUnimprovedHash = $m_sr_Statics$().u(key);
  var keyHash = $m_sc_Hashing$().bz(keyUnimprovedHash);
  return this.cP.aeI(key, keyUnimprovedHash, keyHash, 0);
});
$p.r = (function(key) {
  var keyUnimprovedHash = $m_sr_Statics$().u(key);
  var keyHash = $m_sc_Hashing$().bz(keyUnimprovedHash);
  return this.cP.a3y(key, keyUnimprovedHash, keyHash, 0);
});
$p.ay = (function(key, default$1) {
  var keyUnimprovedHash = $m_sr_Statics$().u(key);
  var keyHash = $m_sc_Hashing$().bz(keyUnimprovedHash);
  return this.cP.a3B(key, keyUnimprovedHash, keyHash, 0, default$1);
});
$p.hq = (function(key, value) {
  var keyUnimprovedHash = $m_sr_Statics$().u(key);
  var newRootNode = this.cP.JF(key, value, keyUnimprovedHash, $m_sc_Hashing$().bz(keyUnimprovedHash), 0, true);
  return ((newRootNode === this.cP) ? this : new $c_sci_HashMap(newRootNode));
});
$p.aRC = (function(key) {
  var keyUnimprovedHash = $m_sr_Statics$().u(key);
  var newRootNode = this.cP.PP(key, keyUnimprovedHash, $m_sc_Hashing$().bz(keyUnimprovedHash), 0);
  return ((newRootNode === this.cP) ? this : new $c_sci_HashMap(newRootNode));
});
$p.aYR = (function(that) {
  if ((that instanceof $c_sci_HashMap)) {
    if (this.c()) {
      return that;
    } else {
      var newNode = this.cP.aMU(that.cP, 0);
      return ((newNode === that.cP) ? that : ((newNode === this.cP) ? this : new $c_sci_HashMap(newNode)));
    }
  } else if ((that instanceof $c_scm_HashMap)) {
    var iter = that.ah5();
    var current = this.cP;
    while (iter.p()) {
      var next = iter.q();
      var improvedHash = next.or;
      var originalHash = (improvedHash ^ ((improvedHash >>> 16) | 0));
      var improved = $m_sc_Hashing$().bz(originalHash);
      current = current.JF(next.np, next.b9, originalHash, improved, 0, true);
      if ((current !== this.cP)) {
        var shallowlyMutableNodeMap = $m_sci_Node$().d6($m_sci_Node$().fR(improved, 0));
        while (iter.p()) {
          var next$2 = iter.q();
          var improvedHash$1 = next$2.or;
          var originalHash$2 = (improvedHash$1 ^ ((improvedHash$1 >>> 16) | 0));
          shallowlyMutableNodeMap = current.a59(next$2.np, next$2.b9, originalHash$2, $m_sc_Hashing$().bz(originalHash$2), 0, shallowlyMutableNodeMap);
        }
        return new $c_sci_HashMap(current);
      }
    }
    return this;
  } else if ((that instanceof $c_scm_LinkedHashMap)) {
    var iter$2 = that.afu();
    var current$2 = this.cP;
    while (iter$2.p()) {
      var next$3 = iter$2.q();
      var improvedHash$2 = next$3.pd;
      var originalHash$3 = (improvedHash$2 ^ ((improvedHash$2 >>> 16) | 0));
      var improved$2 = $m_sc_Hashing$().bz(originalHash$3);
      current$2 = current$2.JF(next$3.nq, next$3.fs, originalHash$3, improved$2, 0, true);
      if ((current$2 !== this.cP)) {
        var shallowlyMutableNodeMap$2 = $m_sci_Node$().d6($m_sci_Node$().fR(improved$2, 0));
        while (iter$2.p()) {
          var next$4 = iter$2.q();
          var improvedHash$3 = next$4.pd;
          var originalHash$4 = (improvedHash$3 ^ ((improvedHash$3 >>> 16) | 0));
          shallowlyMutableNodeMap$2 = current$2.a59(next$4.nq, next$4.fs, originalHash$4, $m_sc_Hashing$().bz(originalHash$4), 0, shallowlyMutableNodeMap$2);
        }
        return new $c_sci_HashMap(current$2);
      }
    }
    return this;
  } else if ($is_sci_Map(that)) {
    if (that.c()) {
      return this;
    } else {
      var accum = new $c_sci_HashMap$accum$1(this);
      that.pu(accum);
      var newRootNode = accum.Hz;
      return ((newRootNode === this.cP) ? this : new $c_sci_HashMap(newRootNode));
    }
  } else {
    var it = that.o();
    if ((!it.p())) {
      return this;
    } else {
      var accum$2 = new $c_sci_HashMap$accum$1(this);
      $f_sc_IterableOnceOps__foreach__F1__V(it, accum$2);
      var newRootNode$1 = accum$2.Hz;
      return ((newRootNode$1 === this.cP) ? this : new $c_sci_HashMap(newRootNode$1));
    }
  }
});
$p.F = (function(f) {
  this.cP.F(f);
});
$p.pu = (function(f) {
  this.cP.pu(f);
});
$p.e = (function(that) {
  if ((that instanceof $c_sci_HashMap)) {
    if ((this === that)) {
      return true;
    } else {
      var x = this.cP;
      var x$2 = that.cP;
      return ((x === null) ? (x$2 === null) : x.e(x$2));
    }
  } else {
    return $f_sc_Map__equals__O__Z(this, that);
  }
});
$p.x = (function() {
  if (this.c()) {
    return $m_s_util_hashing_MurmurHash3$().Vx;
  } else {
    var hashIterator = new $c_sci_MapKeyValueTupleHashIterator(this.cP);
    return $m_s_util_hashing_MurmurHash3$().Em(hashIterator, $m_s_util_hashing_MurmurHash3$().xL);
  }
});
$p.hM = (function() {
  return "HashMap";
});
$p.aik = (function(f) {
  var newRootNode = this.cP.aT1(f);
  return ((newRootNode === this.cP) ? this : new $c_sci_HashMap(newRootNode));
});
$p.a3m = (function(pred, isFlipped) {
  var newRootNode = this.cP.aO3(pred, isFlipped);
  return ((newRootNode === this.cP) ? this : ((newRootNode.dS === 0) ? $m_sci_HashMap$().fk : new $c_sci_HashMap(newRootNode)));
});
$p.b7A = (function(keys) {
  if (this.c()) {
    return this;
  } else if ((keys instanceof $c_sci_HashSet)) {
    if (keys.c()) {
      return this;
    } else {
      var newRootNode = new $c_sci_MapNodeRemoveAllSetNodeIterator(keys.dY).b7q(this.cP);
      return ((newRootNode === this.cP) ? this : ((newRootNode.dS <= 0) ? $m_sci_HashMap$().fk : new $c_sci_HashMap(newRootNode)));
    }
  } else if ((keys instanceof $c_scm_HashSet)) {
    if (keys.c()) {
      return this;
    } else {
      var iter = new $c_scm_HashSet$$anon$2(keys);
      var curr = this.cP;
      while (iter.p()) {
        var next = iter.q();
        var originalHash = keys.yl(next.mD);
        var improved = $m_sc_Hashing$().bz(originalHash);
        curr = curr.PP(next.pc, originalHash, improved, 0);
        if ((curr.dS === 0)) {
          return $m_sci_HashMap$().fk;
        }
      }
      var newRootNode$1 = curr;
      return ((newRootNode$1 === this.cP) ? this : new $c_sci_HashMap(newRootNode$1));
    }
  } else if ((keys instanceof $c_scm_LinkedHashSet)) {
    if (keys.c()) {
      return this;
    } else {
      var iter$2 = new $c_scm_LinkedHashSet$$anon$2(keys);
      var curr$2 = this.cP;
      while (iter$2.p()) {
        var next$2 = iter$2.q();
        var improvedHash$1 = next$2.pe;
        var originalHash$2 = (improvedHash$1 ^ ((improvedHash$1 >>> 16) | 0));
        var improved$2 = $m_sc_Hashing$().bz(originalHash$2);
        curr$2 = curr$2.PP(next$2.pf, originalHash$2, improved$2, 0);
        if ((curr$2.dS === 0)) {
          return $m_sci_HashMap$().fk;
        }
      }
      var newRootNode$2 = curr$2;
      return ((newRootNode$2 === this.cP) ? this : new $c_sci_HashMap(newRootNode$2));
    }
  } else {
    var iter$3 = keys.o();
    var curr$3 = this.cP;
    while (iter$3.p()) {
      var next$3 = iter$3.q();
      var originalHash$3 = $m_sr_Statics$().u(next$3);
      var improved$3 = $m_sc_Hashing$().bz(originalHash$3);
      curr$3 = curr$3.PP(next$3, originalHash$3, improved$3, 0);
      if ((curr$3.dS === 0)) {
        return $m_sci_HashMap$().fk;
      }
    }
    var newRootNode$3 = curr$3;
    return ((newRootNode$3 === this.cP) ? this : new $c_sci_HashMap(newRootNode$3));
  }
});
$p.ju = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
});
$p.ds = (function(n) {
  return $f_sc_IterableOps__drop__I__O(this, n);
});
$p.cn = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$p.tW = (function(p) {
  return $f_sc_IterableOps__dropWhile__F1__O(this, p);
});
$p.uj = (function(p) {
  return $f_sc_IterableOps__takeWhile__F1__O(this, p);
});
$p.XS = (function(keys) {
  return this.b7A(keys);
});
$p.wk = (function(f) {
  return this.aik(f);
});
$p.bJ = (function() {
  return this.cx().q();
});
$p.t = (function() {
  return this.o().q();
});
$p.hN = (function(suffix) {
  return this.aYR(suffix);
});
$p.fz = (function(key) {
  return this.aRC(key);
});
$p.Q8 = (function(key, remappingFunction) {
  return $f_sci_MapOps__updatedWith__O__F1__sci_MapOps(this, key, remappingFunction);
});
$p.bN = (function(key, value) {
  return this.hq(key, value);
});
$p.a41 = (function() {
  return this.ln();
});
function $isArrayOf_sci_HashMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.la)));
}
var $d_sci_HashMap = new $TypeData().i($c_sci_HashMap, "scala.collection.immutable.HashMap", ({
  la: 1,
  bb: 1,
  aL: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  as: 1,
  ak: 1,
  i: 1,
  h: 1,
  aF: 1,
  b: 1,
  aV: 1,
  I: 1,
  bc: 1,
  dN: 1,
  c0: 1,
  z: 1,
  a5: 1,
  a: 1
}));
/** @constructor */
function $c_sci_TreeSeqMap(ordering, mapping, ordinal, orderedBy) {
  this.op = null;
  this.lN = null;
  this.HH = 0;
  this.oo = null;
  this.a1O = 0;
  this.op = ordering;
  this.lN = mapping;
  this.HH = ordinal;
  this.oo = orderedBy;
  this.a1O = mapping.aa();
}
$p = $c_sci_TreeSeqMap.prototype = new $h_sci_AbstractMap();
$p.constructor = $c_sci_TreeSeqMap;
/** @constructor */
function $h_sci_TreeSeqMap() {
}
$h_sci_TreeSeqMap.prototype = $p;
$p.ju = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
});
$p.fa = (function(asPair) {
  return $f_sc_StrictOptimizedIterableOps__unzip__F1__T2(this, asPair);
});
$p.L = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$p.c5 = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.ct = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.dk = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bw = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$p.cE = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true);
});
$p.fy = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__partitionMap__F1__T2(this, f);
});
$p.cn = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$p.el = (function() {
  return "SeqMap";
});
$p.hM = (function() {
  return "TreeSeqMap";
});
$p.im = (function() {
  return $m_sci_TreeSeqMap$();
});
$p.aa = (function() {
  return this.a1O;
});
$p.V = (function() {
  return this.a1O;
});
$p.c = (function() {
  return (this.a1O === 0);
});
$p.aiq = (function(key, value) {
  var rc10 = false;
  var x2 = null;
  var x1 = this.lN.r(key);
  if ((this.HH === (-1))) {
    var x = this.oo;
    var x$2 = $m_sci_TreeSeqMap$OrderBy$Modification$();
    if (((x !== null) && (x === x$2))) {
      var $x_1 = true;
    } else {
      var $x_1 = x1.c();
    }
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    return $m_sci_TreeSeqMap$().afr(this.oo).aMT(this).aiq(key, value);
  }
  if ((x1 instanceof $c_s_Some)) {
    rc10 = true;
    x2 = x1;
    var p3 = x2.J;
    if ((p3 !== null)) {
      var o = p3.xY();
      var x$3 = this.oo;
      var x$4 = $m_sci_TreeSeqMap$OrderBy$Insertion$();
      if (((x$3 !== null) && (x$3 === x$4))) {
        return new $c_sci_TreeSeqMap(this.op.agt(o, key), this.lN.bN(key, new $c_T2(o, value)), this.HH, this.oo);
      }
    }
  }
  if (rc10) {
    var p6 = x2.J;
    if ((p6 !== null)) {
      var o$2 = p6.xY();
      $m_sci_TreeSeqMap$();
      var ord = this.HH;
      var o1 = ((ord === 2147483647) ? (-2147483648) : ((1 + ord) | 0));
      return new $c_sci_TreeSeqMap(this.op.Pi(o$2).W8(o1, key), this.lN.bN(key, new $c_T2(o1, value)), o1, this.oo);
    }
  }
  if (($m_s_None$() === x1)) {
    $m_sci_TreeSeqMap$();
    var ord$1 = this.HH;
    var o1$2 = ((ord$1 === 2147483647) ? (-2147483648) : ((1 + ord$1) | 0));
    return new $c_sci_TreeSeqMap(this.op.W8(o1$2, key), this.lN.bN(key, new $c_T2(o1$2, value)), o1$2, this.oo);
  }
  throw new $c_s_MatchError(x1);
});
$p.b7z = (function(key) {
  var x1 = this.lN.r(key);
  if ((x1 instanceof $c_s_Some)) {
    var p3 = x1.J;
    if ((p3 !== null)) {
      var o = p3.xY();
      return new $c_sci_TreeSeqMap(this.op.Pi(o), this.lN.fz(key), this.HH, this.oo);
    }
  }
  if (($m_s_None$() === x1)) {
    return this;
  }
  throw new $c_s_MatchError(x1);
});
$p.r = (function(key) {
  var this$1 = this.lN.r(key);
  return (this$1.c() ? $m_s_None$() : new $c_s_Some(this$1.d().h()));
});
$p.o = (function() {
  return new $c_sci_TreeSeqMap$$anon$1(this);
});
$p.lo = (function() {
  return new $c_sci_TreeSeqMap$$anon$2(this);
});
$p.hr = (function() {
  return new $c_sci_TreeSeqMap$$anon$3(this);
});
$p.E = (function(key) {
  return this.lN.E(key);
});
$p.agp = (function() {
  var k = this.op.t();
  return new $c_T2(k, this.lN.i(k).Pb());
});
$p.dt = (function() {
  var this$1 = this.op.dt();
  if (this$1.c()) {
    return $m_s_None$();
  } else {
    var x0 = this$1.d();
    return new $c_s_Some(new $c_T2(x0, this.lN.i(x0).Pb()));
  }
});
$p.Xs = (function() {
  var k = this.op.bJ();
  return new $c_T2(k, this.lN.i(k).Pb());
});
$p.b4h = (function(f) {
  $m_sci_TreeSeqMap$();
  var bdr = new $c_sci_TreeSeqMap$Builder(this.oo);
  var iter = this.op.PA();
  while (iter.p()) {
    var k = iter.q();
    var x1 = this.lN.i(k);
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1);
    }
    var v = x1.h();
    var x1$2 = f.i(new $c_T2(k, v));
    if ((x1$2 === null)) {
      throw new $c_s_MatchError(x1$2);
    }
    bdr.a2E(x1$2.g(), x1$2.h());
  }
  return bdr.a4y();
});
$p.b1p = (function(f) {
  $m_sci_TreeSeqMap$();
  var bdr = new $c_sci_TreeSeqMap$Builder(this.oo);
  var iter = this.op.PA();
  while (iter.p()) {
    var k = iter.q();
    var x1 = this.lN.i(k);
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1);
    }
    var v = x1.h();
    var jter = f.i(new $c_T2(k, v)).o();
    while (jter.p()) {
      var x1$2 = jter.q();
      if ((x1$2 === null)) {
        throw new $c_s_MatchError(x1$2);
      }
      bdr.a2E(x1$2.g(), x1$2.h());
    }
  }
  return bdr.a4y();
});
$p.aYv = (function(pf) {
  $m_sci_TreeSeqMap$();
  var bdr = new $c_sci_TreeSeqMap$Builder(this.oo);
  var iter = this.op.PA();
  while (iter.p()) {
    var k = iter.q();
    var x1 = this.lN.i(k);
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1);
    }
    var v = x1.h();
    pf.Eg(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((bdr) => ((x0$1$2$2) => {
      if ((x0$1$2$2 !== null)) {
        return bdr.a2E(x0$1$2$2.g(), x0$1$2$2.h());
      } else {
        throw new $c_s_MatchError(x0$1$2$2);
      }
    }))(bdr))).i(new $c_T2(k, v));
  }
  return bdr.a4y();
});
$p.aMT = (function(suffix) {
  var ong = this.op;
  var mng = this.lN;
  $m_sci_TreeSeqMap$();
  var ord = this.HH;
  var ord$1 = ((ord === 2147483647) ? (-2147483648) : ((1 + ord) | 0));
  var iter = suffix.o();
  while (iter.p()) {
    var x1 = iter.q();
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1);
    }
    var k = x1.g();
    var v2 = x1.h();
    var x1$2 = mng.r(k);
    matchEnd6: {
      if ((x1$2 instanceof $c_s_Some)) {
        var p3 = x1$2.J;
        if ((p3 !== null)) {
          var o = p3.xY();
          var v = p3.h();
          var x = this.oo;
          var x$2 = $m_sci_TreeSeqMap$OrderBy$Insertion$();
          if ((((x !== null) && (x === x$2)) && (!$m_sr_BoxesRunTime$().Q(v, v2)))) {
            mng = mng.bN(k, new $c_T2(o, v2));
            break matchEnd6;
          } else {
            var x$3 = this.oo;
            var x$4 = $m_sci_TreeSeqMap$OrderBy$Modification$();
            if (((x$3 !== null) && (x$3 === x$4))) {
              mng = mng.bN(k, new $c_T2(ord$1, v2));
              ong = ong.Pi(o).W8(ord$1, k);
              $m_sci_TreeSeqMap$();
              var ord$2 = ord$1;
              ord$1 = ((ord$2 === 2147483647) ? (-2147483648) : ((1 + ord$2) | 0));
              break matchEnd6;
            } else {
              break matchEnd6;
            }
          }
        }
      }
      if (($m_s_None$() === x1$2)) {
        mng = mng.bN(k, new $c_T2(ord$1, v2));
        ong = ong.W8(ord$1, k);
        $m_sci_TreeSeqMap$();
        var ord$3 = ord$1;
        ord$1 = ((ord$3 === 2147483647) ? (-2147483648) : ((1 + ord$3) | 0));
        break matchEnd6;
      }
      throw new $c_s_MatchError(x1$2);
    }
  }
  return new $c_sci_TreeSeqMap(ong, mng, ord$1, this.oo);
});
$p.hN = (function(suffix) {
  return this.aMT(suffix);
});
$p.DQ = (function(pf) {
  return this.aYv(pf);
});
$p.Pl = (function(f) {
  return this.b1p(f);
});
$p.kP = (function(f) {
  return this.b4h(f);
});
$p.bJ = (function() {
  return this.Xs();
});
$p.t = (function() {
  return this.agp();
});
$p.fz = (function(key) {
  return this.b7z(key);
});
$p.bN = (function(key, value) {
  return this.aiq(key, value);
});
function $isArrayOf_sci_TreeSeqMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.lp)));
}
var $d_sci_TreeSeqMap = new $TypeData().i($c_sci_TreeSeqMap, "scala.collection.immutable.TreeSeqMap", ({
  lp: 1,
  bb: 1,
  aL: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  as: 1,
  ak: 1,
  i: 1,
  h: 1,
  aF: 1,
  b: 1,
  aV: 1,
  I: 1,
  bc: 1,
  lj: 1,
  dy: 1,
  z: 1,
  dN: 1,
  c0: 1
}));
function $ct_sci_VectorMap__sci_Vector__sci_Map__I__($thiz, fields, underlying, dropped) {
  $thiz.tJ = fields;
  $thiz.l8 = underlying;
  $thiz.O4 = dropped;
  $thiz.O5 = underlying.aa();
  return $thiz;
}
function $ct_sci_VectorMap__sci_Vector__sci_Map__($thiz, fields, underlying) {
  $ct_sci_VectorMap__sci_Vector__sci_Map__I__($thiz, fields, underlying, 0);
  return $thiz;
}
/** @constructor */
function $c_sci_VectorMap() {
  this.tJ = null;
  this.l8 = null;
  this.O4 = 0;
  this.O5 = 0;
}
$p = $c_sci_VectorMap.prototype = new $h_sci_AbstractMap();
$p.constructor = $c_sci_VectorMap;
/** @constructor */
function $h_sci_VectorMap() {
}
$h_sci_VectorMap.prototype = $p;
$p.kP = (function(f) {
  return $f_sc_StrictOptimizedMapOps__map__F1__sc_IterableOps(this, f);
});
$p.Pl = (function(f) {
  return $f_sc_StrictOptimizedMapOps__flatMap__F1__sc_IterableOps(this, f);
});
$p.DQ = (function(pf) {
  return $f_sc_StrictOptimizedMapOps__collect__s_PartialFunction__sc_IterableOps(this, pf);
});
$p.ju = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
});
$p.fa = (function(asPair) {
  return $f_sc_StrictOptimizedIterableOps__unzip__F1__T2(this, asPair);
});
$p.L = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$p.c5 = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.ct = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.dk = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bw = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$p.cE = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true);
});
$p.fy = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__partitionMap__F1__T2(this, f);
});
$p.cn = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$p.el = (function() {
  return "SeqMap";
});
$p.hM = (function() {
  return "VectorMap";
});
$p.aa = (function() {
  return this.O5;
});
$p.V = (function() {
  return this.O5;
});
$p.c = (function() {
  return (this.O5 === 0);
});
$p.AJ = (function(key, value) {
  var x1 = this.l8.r(key);
  if ((x1 instanceof $c_s_Some)) {
    var p3 = x1.J;
    if ((p3 !== null)) {
      var slot = p3.xY();
      return $ct_sci_VectorMap__sci_Vector__sci_Map__I__(new $c_sci_VectorMap(), this.tJ, this.l8.bN(key, new $c_T2(slot, value)), this.O4);
    }
  }
  if (($m_s_None$() === x1)) {
    return $ct_sci_VectorMap__sci_Vector__sci_Map__I__(new $c_sci_VectorMap(), this.tJ.bv(key), this.l8.bN(key, new $c_T2(((this.tJ.C() + this.O4) | 0), value)), this.O4);
  }
  throw new $c_s_MatchError(x1);
});
$p.a5g = (function(d) {
  return new $c_sci_Map$WithDefault(this, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$2) => d)));
});
$p.r = (function(key) {
  var x1 = this.l8.r(key);
  if ((x1 instanceof $c_s_Some)) {
    return new $c_s_Some(x1.J.h());
  } else if (($m_s_None$() === x1)) {
    return $m_s_None$();
  } else {
    throw new $c_s_MatchError(x1);
  }
});
$p.b8b = (function(slot) {
  while (true) {
    if ((slot >= this.tJ.C())) {
      return new $c_T2((-1), null);
    } else {
      var x1 = this.tJ.l(slot);
      if ((x1 instanceof $c_sci_VectorMap$Tombstone)) {
        var distance = x1.qE;
        slot = ((slot + distance) | 0);
      } else {
        return new $c_T2(slot, x1);
      }
    }
  }
});
$p.o = (function() {
  return new $c_sci_VectorMap$$anon$1(this);
});
$p.ahC = (function(key) {
  if (this.c()) {
    return $f_sc_MapFactoryDefaults__empty__sc_IterableOps(this);
  } else {
    var fs = this.tJ;
    var sz = fs.C();
    var rc8 = false;
    var x2 = null;
    var x1 = this.l8.r(key);
    if ((x1 instanceof $c_s_Some)) {
      rc8 = true;
      x2 = x1;
      if ((this.O5 === 1)) {
        return $f_sc_MapFactoryDefaults__empty__sc_IterableOps(this);
      }
    }
    if (rc8) {
      var p5 = x2.J;
      if ((p5 !== null)) {
        var slot = p5.xY();
        var s = ((slot - this.O4) | 0);
        if ((s < ((sz - 1) | 0))) {
          var x1$2 = fs.l(((1 + s) | 0));
          var next = ((x1$2 instanceof $c_sci_VectorMap$Tombstone) ? ((1 + ((s + x1$2.qE) | 0)) | 0) : ((1 + s) | 0));
        } else {
          var next = ((1 + s) | 0);
        }
        fs = fs.nI(s, new $c_sci_VectorMap$Tombstone(((next - s) | 0)));
        if ((s > 0)) {
          var rc6 = false;
          var x2$3 = null;
          var x1$3 = fs.l(((s - 1) | 0));
          matchEnd7: {
            var first;
            if ((x1$3 instanceof $c_sci_VectorMap$Tombstone)) {
              rc6 = true;
              x2$3 = x1$3;
              var d$2 = x2$3.qE;
              if ((d$2 < 0)) {
                var first = ((((s + d$2) | 0) >= 0) ? ((s + d$2) | 0) : 0);
                break matchEnd7;
              }
            }
            if (rc6) {
              if ((x2$3.qE === 1)) {
                var first = ((s - 1) | 0);
                break matchEnd7;
              }
            }
            if (rc6) {
              throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), ("tombstone indicate wrong position: " + x2$3.qE));
            }
            var first = s;
          }
        } else {
          var first = s;
        }
        fs = fs.nI(first, new $c_sci_VectorMap$Tombstone(((next - first) | 0)));
        var last = ((next - 1) | 0);
        if ((last !== first)) {
          fs = fs.nI(last, new $c_sci_VectorMap$Tombstone(((((first - 1) | 0) - last) | 0)));
        }
        return $ct_sci_VectorMap__sci_Vector__sci_Map__I__(new $c_sci_VectorMap(), fs, this.l8.fz(key), this.O4);
      }
    }
    return this;
  }
});
$p.im = (function() {
  return $m_sci_VectorMap$();
});
$p.E = (function(key) {
  return this.l8.E(key);
});
$p.Xs = (function() {
  if (this.c()) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.last");
  }
  var lastSlot = ((this.tJ.C() - 1) | 0);
  var rc6 = false;
  var x2 = null;
  var x1 = this.tJ.bJ();
  matchEnd7: {
    var last;
    if ((x1 instanceof $c_sci_VectorMap$Tombstone)) {
      rc6 = true;
      x2 = x1;
      var d = x2.qE;
      if ((d < 0)) {
        var last = this.tJ.l(((lastSlot + d) | 0));
        break matchEnd7;
      }
    }
    if (rc6) {
      if ((x2.qE === 1)) {
        var last = this.tJ.l(((lastSlot - 1) | 0));
        break matchEnd7;
      }
    }
    if (rc6) {
      throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), ("tombstone indicate wrong position: " + x2.qE));
    }
    var last = x1;
  }
  return new $c_T2(last, this.l8.i(last).h());
});
$p.hN = (function(suffix) {
  return $f_sci_StrictOptimizedMapOps__concat__sc_IterableOnce__sci_MapOps(this, suffix);
});
$p.e6 = (function() {
  return new $c_sci_VectorMap$$anon$2(this);
});
$p.J8 = (function() {
  var this$1 = new $c_sc_MapOps$$anon$2(this);
  return $m_sci_Vector$().X(this$1);
});
$p.bJ = (function() {
  return this.Xs();
});
$p.t = (function() {
  return new $c_sci_VectorMap$$anon$1(this).dC();
});
$p.fz = (function(key) {
  return this.ahC(key);
});
$p.bN = (function(key, value) {
  return this.AJ(key, value);
});
function $isArrayOf_sci_VectorMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.lz)));
}
var $d_sci_VectorMap = new $TypeData().i($c_sci_VectorMap, "scala.collection.immutable.VectorMap", ({
  lz: 1,
  bb: 1,
  aL: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  as: 1,
  ak: 1,
  i: 1,
  h: 1,
  aF: 1,
  b: 1,
  aV: 1,
  I: 1,
  bc: 1,
  lj: 1,
  dy: 1,
  dN: 1,
  c0: 1,
  z: 1
}));
/** @constructor */
function $c_scm_AbstractBuffer() {
}
$p = $c_scm_AbstractBuffer.prototype = new $h_scm_AbstractSeq();
$p.constructor = $c_scm_AbstractBuffer;
/** @constructor */
function $h_scm_AbstractBuffer() {
}
$h_scm_AbstractBuffer.prototype = $p;
$p.dG = (function(elems) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, elems);
});
/** @constructor */
function $c_scm_AbstractMap() {
}
$p = $c_scm_AbstractMap.prototype = new $h_sc_AbstractMap();
$p.constructor = $c_scm_AbstractMap;
/** @constructor */
function $h_scm_AbstractMap() {
}
$h_scm_AbstractMap.prototype = $p;
$p.im = (function() {
  return $m_scm_Map$();
});
$p.ue = (function(key, value) {
  return $f_scm_MapOps__put__O__O__s_Option(this, key, value);
});
$p.cY = (function(key, value) {
  $f_scm_MapOps__update__O__O__V(this, key, value);
});
$p.ec = (function(key, defaultValue) {
  return $f_scm_MapOps__getOrElseUpdate__O__F0__O(this, key, defaultValue);
});
$p.AD = (function(key) {
  return $f_scm_MapOps__remove__O__s_Option(this, key);
});
$p.afM = (function(p) {
  return $f_scm_MapOps__filterInPlace__F2__scm_MapOps(this, p);
});
$p.V = (function() {
  return (-1);
});
$p.f9 = (function(size) {
});
$p.dG = (function(elems) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, elems);
});
$p.cd = (function() {
  return $m_scm_Iterable$();
});
$p.aR = (function() {
  return this;
});
function $p_scm_HashSet__addElem__O__I__Z($thiz, elem, hash) {
  var idx = (hash & (($thiz.i6.a.length - 1) | 0));
  var x1 = $thiz.i6.a[idx];
  if ((x1 === null)) {
    $thiz.i6.a[idx] = new $c_scm_HashSet$Node(elem, hash, null);
  } else {
    var prev = null;
    var n = x1;
    while (((n !== null) && (n.mD <= hash))) {
      if (((n.mD === hash) && $m_sr_BoxesRunTime$().Q(elem, n.pc))) {
        return false;
      }
      prev = n;
      n = n.hA;
    }
    if ((prev === null)) {
      $thiz.i6.a[idx] = new $c_scm_HashSet$Node(elem, hash, x1);
    } else {
      prev.hA = new $c_scm_HashSet$Node(elem, hash, prev.hA);
    }
  }
  $thiz.qH = ((1 + $thiz.qH) | 0);
  return true;
}
function $p_scm_HashSet__remove__O__I__Z($thiz, elem, hash) {
  var idx = (hash & (($thiz.i6.a.length - 1) | 0));
  var x1 = $thiz.i6.a[idx];
  if ((x1 !== null)) {
    if (((x1.mD === hash) && $m_sr_BoxesRunTime$().Q(x1.pc, elem))) {
      $thiz.i6.a[idx] = x1.hA;
      $thiz.qH = (($thiz.qH - 1) | 0);
      return true;
    } else {
      var prev = x1;
      var next = x1.hA;
      while (((next !== null) && (next.mD <= hash))) {
        if (((next.mD === hash) && $m_sr_BoxesRunTime$().Q(next.pc, elem))) {
          prev.hA = next.hA;
          $thiz.qH = (($thiz.qH - 1) | 0);
          return true;
        }
        prev = next;
        next = next.hA;
      }
      return false;
    }
  } else {
    return false;
  }
}
function $p_scm_HashSet__growTable__I__V($thiz, newlen) {
  var oldlen = $thiz.i6.a.length;
  $thiz.ad2 = $p_scm_HashSet__newThreshold__I__I($thiz, newlen);
  if (($thiz.qH === 0)) {
    $thiz.i6 = new ($d_scm_HashSet$Node.r().C)(newlen);
  } else {
    $thiz.i6 = $m_ju_Arrays$().ex($thiz.i6, newlen);
    var preLow = new $c_scm_HashSet$Node(null, 0, null);
    var preHigh = new $c_scm_HashSet$Node(null, 0, null);
    while ((oldlen < newlen)) {
      var i = 0;
      while ((i < oldlen)) {
        var old = $thiz.i6.a[i];
        if ((old !== null)) {
          preLow.hA = null;
          preHigh.hA = null;
          var lastLow = preLow;
          var lastHigh = preHigh;
          var n = old;
          while ((n !== null)) {
            var next = n.hA;
            if (((n.mD & oldlen) === 0)) {
              lastLow.hA = n;
              lastLow = n;
            } else {
              lastHigh.hA = n;
              lastHigh = n;
            }
            n = next;
          }
          lastLow.hA = null;
          if ((old !== preLow.hA)) {
            $thiz.i6.a[i] = preLow.hA;
          }
          if ((preHigh.hA !== null)) {
            $thiz.i6.a[((i + oldlen) | 0)] = preHigh.hA;
            lastHigh.hA = null;
          }
        }
        i = ((1 + i) | 0);
      }
      oldlen = (oldlen << 1);
    }
  }
}
function $p_scm_HashSet__tableSizeFor__I__I($thiz, capacity) {
  var x = ((capacity - 1) | 0);
  var i = ((x > 4) ? x : 4);
  var x$1 = ((((-2147483648) >> Math.clz32(i)) & i) << 1);
  return ((x$1 < 1073741824) ? x$1 : 1073741824);
}
function $p_scm_HashSet__newThreshold__I__I($thiz, size) {
  return $doubleToInt((size * $thiz.ad1));
}
function $ct_scm_HashSet__I__D__($thiz, initialCapacity, loadFactor) {
  $thiz.ad1 = loadFactor;
  $thiz.i6 = new ($d_scm_HashSet$Node.r().C)($p_scm_HashSet__tableSizeFor__I__I($thiz, initialCapacity));
  $thiz.ad2 = $p_scm_HashSet__newThreshold__I__I($thiz, $thiz.i6.a.length);
  $thiz.qH = 0;
  return $thiz;
}
function $ct_scm_HashSet__($thiz) {
  $ct_scm_HashSet__I__D__($thiz, 16, 0.75);
  return $thiz;
}
/** @constructor */
function $c_scm_HashSet() {
  this.ad1 = 0.0;
  this.i6 = null;
  this.ad2 = 0;
  this.qH = 0;
}
$p = $c_scm_HashSet.prototype = new $h_scm_AbstractSet();
$p.constructor = $c_scm_HashSet;
/** @constructor */
function $h_scm_HashSet() {
}
$h_scm_HashSet.prototype = $p;
$p.fa = (function(asPair) {
  return $f_sc_StrictOptimizedIterableOps__unzip__F1__T2(this, asPair);
});
$p.L = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$p.c5 = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.ct = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.dk = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bw = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$p.cE = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true);
});
$p.fy = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__partitionMap__F1__T2(this, f);
});
$p.cn = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$p.aa = (function() {
  return this.qH;
});
$p.yl = (function(originalHash) {
  return (originalHash ^ ((originalHash >>> 16) | 0));
});
$p.E = (function(elem) {
  var hash = this.yl($m_sr_Statics$().u(elem));
  var x1 = this.i6.a[(hash & ((this.i6.a.length - 1) | 0))];
  return (((x1 === null) ? null : x1.b1l(elem, hash)) !== null);
});
$p.f9 = (function(size) {
  var target = $p_scm_HashSet__tableSizeFor__I__I(this, $doubleToInt((((1 + size) | 0) / this.ad1)));
  if ((target > this.i6.a.length)) {
    $p_scm_HashSet__growTable__I__V(this, target);
  }
});
$p.oA = (function(elem) {
  if ((((1 + this.qH) | 0) >= this.ad2)) {
    $p_scm_HashSet__growTable__I__V(this, (this.i6.a.length << 1));
  }
  return $p_scm_HashSet__addElem__O__I__Z(this, elem, this.yl($m_sr_Statics$().u(elem)));
});
$p.aLO = (function(xs) {
  $f_scm_Builder__sizeHint__sc_IterableOnce__I__V(this, xs, 0);
  if ((xs instanceof $c_sci_HashSet)) {
    var f = new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((k$2$2, h$2$2) => {
      $p_scm_HashSet__addElem__O__I__Z(this, k$2$2, this.yl((h$2$2 | 0)));
    }));
    xs.dY.afV(f);
    return this;
  } else if ((xs instanceof $c_scm_HashSet)) {
    var iter = new $c_scm_HashSet$$anon$2(xs);
    while (iter.p()) {
      var next = iter.q();
      $p_scm_HashSet__addElem__O__I__Z(this, next.pc, next.mD);
    }
    return this;
  } else if ((xs instanceof $c_scm_LinkedHashSet)) {
    var iter$2 = new $c_scm_LinkedHashSet$$anon$2(xs);
    while (iter$2.p()) {
      var next$2 = iter$2.q();
      $p_scm_HashSet__addElem__O__I__Z(this, next$2.pf, next$2.pe);
    }
    return this;
  } else {
    return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs);
  }
});
$p.ahA = (function(elem) {
  return $p_scm_HashSet__remove__O__I__Z(this, elem, this.yl($m_sr_Statics$().u(elem)));
});
$p.o = (function() {
  return new $c_scm_HashSet$$anon$1(this);
});
$p.ie = (function() {
  $m_ju_Arrays$().WM(this.i6, null);
  this.qH = 0;
});
$p.cd = (function() {
  return $m_scm_HashSet$();
});
$p.V = (function() {
  return this.qH;
});
$p.c = (function() {
  return (this.qH === 0);
});
$p.F = (function(f) {
  var len = this.i6.a.length;
  var i = 0;
  while ((i < len)) {
    var n = this.i6.a[i];
    if ((n !== null)) {
      n.F(f);
    }
    i = ((1 + i) | 0);
  }
});
$p.hM = (function() {
  return "HashSet";
});
$p.x = (function() {
  var setIterator = new $c_scm_HashSet$$anon$1(this);
  var hashIterator = ((!setIterator.p()) ? setIterator : new $c_scm_HashSet$$anon$3(this));
  return $m_s_util_hashing_MurmurHash3$().Em(hashIterator, $m_s_util_hashing_MurmurHash3$().Vy);
});
$p.re = (function(elem) {
  this.ahA(elem);
  return this;
});
$p.Y = (function(elem) {
  this.oA(elem);
  return this;
});
$p.dG = (function(elems) {
  return this.aLO(elems);
});
function $isArrayOf_scm_HashSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.lP)));
}
var $d_scm_HashSet = new $TypeData().i($c_scm_HashSet, "scala.collection.mutable.HashSet", ({
  lP: 1,
  lC: 1,
  aQ: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  aG: 1,
  aR: 1,
  h: 1,
  b: 1,
  lT: 1,
  aa: 1,
  lU: 1,
  a9: 1,
  W: 1,
  Y: 1,
  T: 1,
  S: 1,
  aM: 1,
  z: 1,
  a: 1
}));
function $f_scm_IndexedBuffer__filterInPlace__F1__scm_IndexedBuffer($thiz, p) {
  var i = 0;
  var j = 0;
  while ((i < $thiz.C())) {
    if ((!(!p.i($thiz.l(i))))) {
      if ((i !== j)) {
        $thiz.cM(j, $thiz.l(i));
      }
      j = ((1 + j) | 0);
    }
    i = ((1 + i) | 0);
  }
  return ((i === j) ? $thiz : $f_scm_Buffer__takeInPlace__I__scm_Buffer($thiz, j));
}
/** @constructor */
function $c_sjs_js_WrappedDictionary(dict) {
  this.os = null;
  this.os = dict;
}
$p = $c_sjs_js_WrappedDictionary.prototype = new $h_scm_AbstractMap();
$p.constructor = $c_sjs_js_WrappedDictionary;
/** @constructor */
function $h_sjs_js_WrappedDictionary() {
}
$h_sjs_js_WrappedDictionary.prototype = $p;
$p.aOH = (function(coll) {
  var d = new $c_sjs_js_WrappedDictionary(({}));
  $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(d, coll);
  return d;
});
$p.fS = (function() {
  return new $c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder();
});
$p.b1Y = (function(key) {
  var dict = this.os;
  if ((!(!$m_sjs_js_WrappedDictionary$Cache$().vL.call(dict, key)))) {
    return new $c_s_Some(this.os[key]);
  } else {
    return $m_s_None$();
  }
});
$p.aeK = (function(key) {
  var dict = this.os;
  if ((!(!$m_sjs_js_WrappedDictionary$Cache$().vL.call(dict, key)))) {
    return this.os[key];
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key));
  }
});
$p.b26 = (function(key, default$1) {
  var dict = this.os;
  if ((!(!$m_sjs_js_WrappedDictionary$Cache$().vL.call(dict, key)))) {
    return this.os[key];
  } else {
    return default$1.a3();
  }
});
$p.b27 = (function(key, op) {
  var dict = this.os;
  if ((!(!$m_sjs_js_WrappedDictionary$Cache$().vL.call(dict, key)))) {
    return this.os[key];
  } else {
    var v = op.a3();
    this.aTa(key, v);
    return v;
  }
});
$p.b9u = (function(key) {
  var dict = this.os;
  if ((!(!$m_sjs_js_WrappedDictionary$Cache$().vL.call(dict, key)))) {
    delete this.os[key];
  }
  return this;
});
$p.aTa = (function(key, value) {
  this.os[key] = value;
});
$p.aWO = (function(kv) {
  var dict = this.os;
  var key = kv.g();
  var value = kv.h();
  dict[key] = value;
  return this;
});
$p.o = (function() {
  return new $c_sjs_js_WrappedDictionary$DictionaryIterator(this.os);
});
$p.pr = (function() {
  return new $c_sjs_js_WrappedDictionary(({}));
});
$p.Y = (function(elem) {
  return this.aWO(elem);
});
$p.cY = (function(key, value) {
  this.aTa(key, value);
});
$p.re = (function(elem) {
  return this.b9u(elem);
});
$p.E = (function(key) {
  var dict = this.os;
  return (!(!$m_sjs_js_WrappedDictionary$Cache$().vL.call(dict, key)));
});
$p.ec = (function(key, defaultValue) {
  return this.b27(key, defaultValue);
});
$p.ay = (function(key, default$1) {
  return this.b26(key, default$1);
});
$p.i = (function(key) {
  return this.aeK(key);
});
$p.r = (function(key) {
  return this.b1Y(key);
});
$p.fP = (function(coll) {
  return this.aOH(coll);
});
$p.w4 = (function(coll) {
  return this.aOH(coll);
});
var $d_sjs_js_WrappedDictionary = new $TypeData().i($c_sjs_js_WrappedDictionary, "scala.scalajs.js.WrappedDictionary", ({
  Mm: 1,
  cR: 1,
  aL: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  as: 1,
  ak: 1,
  i: 1,
  h: 1,
  aF: 1,
  b: 1,
  bt: 1,
  aa: 1,
  c6: 1,
  a9: 1,
  W: 1,
  Y: 1,
  T: 1,
  S: 1,
  aM: 1
}));
function $isArrayOf_sci_ListMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.Ir)));
}
function $p_sci_Range__argTakeWhile__F1__J($thiz, p) {
  if ($thiz.gL) {
    var value = $thiz.dx;
    var hi = (value >> 31);
    return $bL(value, hi);
  } else {
    var current = $thiz.dx;
    var stop = $thiz.mP();
    while (((current !== stop) && p.iU(current))) {
      current = ((current + $thiz.c4) | 0);
    }
    if (((current !== stop) || (!p.iU(current)))) {
      var value$1 = current;
      var hi$1 = (value$1 >> 31);
      return $bL(value$1, hi$1);
    } else {
      var value$2 = current;
      var hi$2 = (value$2 >> 31);
      var value$3 = $thiz.c4;
      var hi$3 = (value$3 >> 31);
      var lo = ((value$2 + value$3) | 0);
      var hi$4 = ((((hi$2 + hi$3) | 0) + (((lo >>> 0) < (value$2 >>> 0)) | 0)) | 0);
      return $bL(lo, hi$4);
    }
  }
}
function $p_sci_Range__isInexact$1__Z($thiz) {
  return ($thiz.yb() ? ($thiz.tH !== $thiz.p9) : ((($thiz.tH + $thiz.c4) | 0) !== $thiz.p9));
}
function $ct_sci_Range__I__I__I__($thiz, start, end, step) {
  $thiz.dx = start;
  $thiz.p9 = end;
  $thiz.c4 = step;
  $thiz.gL = ($thiz.yb() ? ((step >= 0) ? (start > end) : (start < end)) : ((step >= 0) ? (start >= end) : (start <= end)));
  if ((step === 0)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "step cannot be 0.");
  }
  var stepSign = (step >> 31);
  var gap = (((((end - start) | 0) ^ stepSign) - stepSign) | 0);
  var absStep = (((step ^ stepSign) - stepSign) | 0);
  var div = (((gap >>> 0) / ($checkIntDivisor(absStep) >>> 0)) | 0);
  $thiz.ok = (($thiz.yb() || (Math.imul(absStep, div) !== gap)) ? ((1 + div) | 0) : div);
  if ((((-3) & ((1 + step) | 0)) === 0)) {
    var $x_1 = ($thiz.yb() ? end : ((end - step) | 0));
  } else {
    var n = (($thiz.ok - 1) | 0);
    var $x_1 = (($thiz.dx + Math.imul($thiz.c4, n)) | 0);
  }
  $thiz.tH = $x_1;
  return $thiz;
}
/** @constructor */
function $c_sci_Range() {
  this.dx = 0;
  this.p9 = 0;
  this.c4 = 0;
  this.gL = false;
  this.ok = 0;
  this.tH = 0;
}
$p = $c_sci_Range.prototype = new $h_sci_AbstractSeq();
$p.constructor = $c_sci_Range;
/** @constructor */
function $h_sci_Range() {
}
$h_sci_Range.prototype = $p;
$p.ko = (function(f) {
  return $f_sci_StrictOptimizedSeqOps__distinctBy__F1__O(this, f);
});
$p.kv = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__prepended__O__O(this, elem);
});
$p.bv = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__appended__O__O(this, elem);
});
$p.gU = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix);
});
$p.ju = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
});
$p.fa = (function(asPair) {
  return $f_sc_StrictOptimizedIterableOps__unzip__F1__T2(this, asPair);
});
$p.c5 = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.ct = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.dk = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.Es = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this);
});
$p.bw = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$p.cE = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true);
});
$p.fy = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__partitionMap__F1__T2(this, f);
});
$p.IG = (function(that) {
  return $f_sci_IndexedSeq__canEqual__O__Z(this, that);
});
$p.nB = (function() {
  return $m_sci_IndexedSeq$();
});
$p.el = (function() {
  return "IndexedSeq";
});
$p.cx = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), new $c_sc_IndexedSeqView$Id(this));
});
$p.k0 = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$p.dt = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$p.bL = (function(len) {
  var x = this.C();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$p.V = (function() {
  return this.C();
});
$p.o = (function() {
  return new $c_sci_RangeIterator(this.dx, this.c4, this.tH, this.gL);
});
$p.c = (function() {
  return this.gL;
});
$p.C = (function() {
  if (this.gL) {
    return 0;
  } else {
    if ((this.ok <= 0)) {
      $m_sci_Range$().ug(this.dx, this.p9, this.c4, this.yb());
    }
    return this.ok;
  }
});
$p.mP = (function() {
  if (this.gL) {
    var $x_1 = $m_sci_Range$().a4D("last");
    throw (($x_1 instanceof $c_sjs_js_JavaScriptException) ? $x_1.bf : $x_1);
  } else {
    return this.tH;
  }
});
$p.E4 = (function() {
  if (this.gL) {
    var $x_1 = $m_sci_Range$().a4D("head");
    throw (($x_1 instanceof $c_sjs_js_JavaScriptException) ? $x_1.bf : $x_1);
  } else {
    return this.dx;
  }
});
$p.b2P = (function() {
  if (this.gL) {
    var $x_1 = $m_sci_Range$().a4D("init");
    throw (($x_1 instanceof $c_sjs_js_JavaScriptException) ? $x_1.bf : $x_1);
  } else {
    return this.aNC(1);
  }
});
$p.b9H = (function() {
  if (this.gL) {
    var $x_1 = $m_sci_Range$().a4D("tail");
    throw (($x_1 instanceof $c_sjs_js_JavaScriptException) ? $x_1.bf : $x_1);
  }
  if ((this.ok === 1)) {
    var value = this.p9;
    return new $c_sci_Range$Exclusive(value, value, this.c4);
  } else {
    return (this.yb() ? new $c_sci_Range$Inclusive(((this.dx + this.c4) | 0), this.p9, this.c4) : new $c_sci_Range$Exclusive(((this.dx + this.c4) | 0), this.p9, this.c4));
  }
});
$p.PD = (function(f) {
  this.aRU();
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$p.aZ6 = (function(start, end, step, isInclusive) {
  return (isInclusive ? new $c_sci_Range$Inclusive(start, end, step) : new $c_sci_Range$Exclusive(start, end, step));
});
$p.aRU = (function() {
  if (((this.ok <= 0) && (!this.gL))) {
    $m_sci_Range$().ug(this.dx, this.p9, this.c4, this.yb());
  }
});
$p.F = (function(f) {
  if ((!this.gL)) {
    var i = this.dx;
    while (true) {
      f.i(i);
      if ((i === this.tH)) {
        return (void 0);
      }
      i = ((i + this.c4) | 0);
    }
  }
});
$p.mN = (function(elem, from) {
  if ($isInt(elem)) {
    var x2 = (elem | 0);
    var pos = this.b87(x2);
    return ((pos >= from) ? pos : (-1));
  } else {
    return $f_sc_SeqOps__indexOf__O__I__I(this, elem, from);
  }
});
$p.b87 = (function(i) {
  return (this.afb(i) ? ((((i - this.dx) | 0) / $checkIntDivisor(this.c4)) | 0) : (-1));
});
$p.AE = (function(that) {
  if ((that instanceof $c_sci_Range)) {
    var x1$2 = this.C();
    switch (x1$2) {
      case 0: {
        return that.gL;
        break;
      }
      case 1: {
        return ((that.C() === 1) && (this.dx === that.dx));
        break;
      }
      default: {
        return ((that.C() === x1$2) && ((this.dx === that.dx) && (this.c4 === that.c4)));
      }
    }
  } else {
    return $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this, that);
  }
});
$p.aSH = (function(n) {
  if (((n <= 0) || this.gL)) {
    var value = this.dx;
    return new $c_sci_Range$Exclusive(value, value, this.c4);
  } else if (((n >>> 0) > (((this.ok - 1) | 0) >>> 0))) {
    return this;
  } else {
    var $x_1 = this.dx;
    var n$1 = ((n - 1) | 0);
    return new $c_sci_Range$Inclusive($x_1, ((this.dx + Math.imul(this.c4, n$1)) | 0), this.c4);
  }
});
$p.aNA = (function(n) {
  if (((n <= 0) || this.gL)) {
    return this;
  } else if (((n >>> 0) > (((this.ok - 1) | 0) >>> 0))) {
    var value = this.p9;
    return new $c_sci_Range$Exclusive(value, value, this.c4);
  } else {
    return this.aZ6(((this.dx + Math.imul(this.c4, n)) | 0), this.p9, this.c4, this.yb());
  }
});
$p.aNC = (function(n) {
  if (((n <= 0) || this.gL)) {
    return this;
  } else if (((n >>> 0) > (((this.ok - 1) | 0) >>> 0))) {
    var value = this.p9;
    return new $c_sci_Range$Exclusive(value, value, this.c4);
  } else {
    var $x_1 = this.dx;
    var n$1 = ((((this.ok - 1) | 0) - n) | 0);
    return new $c_sci_Range$Inclusive($x_1, ((this.dx + Math.imul(this.c4, n$1)) | 0), this.c4);
  }
});
$p.b9Q = (function(p) {
  var $x_1 = $p_sci_Range__argTakeWhile__F1__J(this, p);
  var stop_$_lo = $x_1.l;
  var stop_$_hi = $x_1.h;
  var value = this.dx;
  var hi = (value >> 31);
  if ((((stop_$_lo ^ value) | (stop_$_hi ^ hi)) === 0)) {
    var value$1 = this.dx;
    return new $c_sci_Range$Exclusive(value$1, value$1, this.c4);
  } else {
    var value$2 = this.c4;
    var lo = ((stop_$_lo - value$2) | 0);
    return ((lo === this.mP()) ? this : new $c_sci_Range$Inclusive(this.dx, lo, this.c4));
  }
});
$p.b0h = (function(p) {
  var $x_1 = $p_sci_Range__argTakeWhile__F1__J(this, p);
  var stop_$_lo = $x_1.l;
  var stop_$_hi = $x_1.h;
  var value = this.dx;
  var hi = (value >> 31);
  if ((((stop_$_lo ^ value) | (stop_$_hi ^ hi)) === 0)) {
    return this;
  } else {
    var value$1 = this.c4;
    var lo = ((stop_$_lo - value$1) | 0);
    if ((lo === this.mP())) {
      var value$2 = this.mP();
      return new $c_sci_Range$Exclusive(value$2, value$2, this.c4);
    } else {
      return new $c_sci_Range$Inclusive(((lo + this.c4) | 0), this.mP(), this.c4);
    }
  }
});
$p.PW = (function(p) {
  var $x_1 = $p_sci_Range__argTakeWhile__F1__J(this, p);
  var border_$_lo = $x_1.l;
  var border_$_hi = $x_1.h;
  var value = this.dx;
  var hi = (value >> 31);
  if ((((border_$_lo ^ value) | (border_$_hi ^ hi)) === 0)) {
    var value$1 = this.dx;
    return new $c_T2(new $c_sci_Range$Exclusive(value$1, value$1, this.c4), this);
  } else {
    var value$2 = this.c4;
    var lo = ((border_$_lo - value$2) | 0);
    if ((lo === this.mP())) {
      var value$3 = this.mP();
      return new $c_T2(this, new $c_sci_Range$Exclusive(value$3, value$3, this.c4));
    } else {
      return new $c_T2(new $c_sci_Range$Inclusive(this.dx, lo, this.c4), new $c_sci_Range$Inclusive(((lo + this.c4) | 0), this.mP(), this.c4));
    }
  }
});
$p.b8X = (function(from, until) {
  if (this.gL) {
    return this;
  } else if ((from <= 0)) {
    return this.aSH(until);
  } else if ((((until >>> 0) > (((this.ok - 1) | 0) >>> 0)) && (until >= 0))) {
    return this.aNA(from);
  } else {
    var fromValue = ((this.dx + Math.imul(this.c4, from)) | 0);
    if ((from >= until)) {
      return new $c_sci_Range$Exclusive(fromValue, fromValue, this.c4);
    } else {
      var n = ((until - 1) | 0);
      return new $c_sci_Range$Inclusive(fromValue, ((this.dx + Math.imul(this.c4, n)) | 0), this.c4);
    }
  }
});
$p.aRK = (function() {
  return (this.gL ? this : new $c_sci_Range$Inclusive(this.mP(), this.dx, ((-this.c4) | 0)));
});
$p.afb = (function(x) {
  return ((!this.gL) && ((this.c4 > 0) ? ((!((x < this.dx) || (x > this.tH))) && ((this.c4 === 1) || ((((((x - this.dx) | 0) >>> 0) % ($checkIntDivisor(this.c4) >>> 0)) | 0) === 0))) : ((!((x > this.dx) || (x < this.tH))) && ((this.c4 === (-1)) || ((((((this.dx - x) | 0) >>> 0) % ($checkIntDivisor(((-this.c4) | 0)) >>> 0)) | 0) === 0)))));
});
$p.E = (function(elem) {
  return ($isInt(elem) ? this.afb((elem | 0)) : $f_sc_SeqOps__contains__O__Z(this, elem));
});
$p.b9w = (function(num) {
  if ((num === $m_s_math_Numeric$IntIsIntegral$())) {
    if (this.gL) {
      return 0;
    } else if ((this.C() === 1)) {
      return this.E4();
    } else {
      var value = this.C();
      var hi = (value >> 31);
      var value$1 = this.E4();
      var hi$1 = (value$1 >> 31);
      var value$2 = this.mP();
      var hi$2 = (value$2 >> 31);
      var lo = ((value$1 + value$2) | 0);
      var hi$3 = ((((hi$1 + hi$2) | 0) + (((lo >>> 0) < (value$1 >>> 0)) | 0)) | 0);
      var a0 = (65535 & value);
      var a1 = ((value >>> 16) | 0);
      var b0 = (65535 & lo);
      var b1 = ((lo >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$4 = ((((((((Math.imul(value, hi$3) + Math.imul(hi, lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      var lo$2 = ((hi$4 >>> 31) | 0);
      var lo$3 = ((lo$1 + lo$2) | 0);
      return (((lo$3 >>> 1) | 0) | (((hi$4 + (((lo$3 >>> 0) < (lo$1 >>> 0)) | 0)) | 0) << 31));
    }
  } else {
    if ((!this.gL)) {
      var acc = num.Po(0);
      var i = this.E4();
      while (true) {
        acc = num.XK(acc, i);
        if ((i === this.tH)) {
          return num.a52(acc);
        }
        i = ((i + this.c4) | 0);
      }
    }
    return num.a52(num.Po(0));
  }
});
$p.b4t = (function(ord) {
  return ((ord === $m_s_math_Ordering$Int$()) ? ((this.c4 > 0) ? this.E4() : this.mP()) : ($f_s_math_Ordering$CachedReverse__isReverseOf__s_math_Ordering__Z($m_s_math_Ordering$Int$(), ord) ? ((this.c4 > 0) ? this.mP() : this.E4()) : ($f_sc_IterableOnceOps__min__s_math_Ordering__O(this, ord) | 0)));
});
$p.b4m = (function(ord) {
  return ((ord === $m_s_math_Ordering$Int$()) ? ((this.c4 > 0) ? this.mP() : this.E4()) : ($f_s_math_Ordering$CachedReverse__isReverseOf__s_math_Ordering__Z($m_s_math_Ordering$Int$(), ord) ? ((this.c4 > 0) ? this.E4() : this.mP()) : ($f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord) | 0)));
});
$p.OZ = (function() {
  return 2147483647;
});
$p.e = (function(other) {
  if ((other instanceof $c_sci_Range)) {
    if (this.gL) {
      return other.gL;
    } else if (((!other.gL) && (this.dx === other.dx))) {
      var l0 = this.mP();
      return ((l0 === other.mP()) && ((this.dx === l0) || (this.c4 === other.c4)));
    } else {
      return false;
    }
  } else {
    return $f_sc_Seq__equals__O__Z(this, other);
  }
});
$p.x = (function() {
  if ((this.C() >= 2)) {
    var this$1 = $m_s_util_hashing_MurmurHash3$();
    return this$1.aRj(this.dx, this.c4, this.tH, this$1.ib);
  } else {
    return $m_s_util_hashing_MurmurHash3$().a4G(this);
  }
});
$p.m = (function() {
  var preposition = (this.yb() ? "to" : "until");
  var stepped = ((this.c4 === 1) ? "" : (" by " + this.c4));
  return ((((((((this.gL ? "empty " : ($p_sci_Range__isInexact$1__Z(this) ? "inexact " : "")) + "Range ") + this.dx) + " ") + preposition) + " ") + this.p9) + stepped);
});
$p.hM = (function() {
  return "Range";
});
$p.b9d = (function(ord) {
  return ((ord === $m_s_math_Ordering$Int$()) ? ((this.c4 > 0) ? this : this.aRK()) : $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord));
});
$p.DK = (function(idx) {
  if ((((idx < 0) || (idx >= this.ok)) || this.gL)) {
    this.aRU();
    var max = (this.gL ? (-1) : ((this.ok - 1) | 0));
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((idx + " is out of bounds (min 0, max ") + max) + ")"));
  } else {
    return ((this.dx + Math.imul(this.c4, idx)) | 0);
  }
});
$p.JI = (function() {
  return new $c_sc_IndexedSeqView$Id(this);
});
$p.cd = (function() {
  return $m_sci_IndexedSeq$();
});
$p.h9 = (function(ord) {
  return this.b9d(ord);
});
$p.nz = (function() {
  return this;
});
$p.lq = (function(ord) {
  return this.b4m(ord);
});
$p.lr = (function(ord) {
  return this.b4t(ord);
});
$p.k2 = (function(num) {
  return this.b9w(num);
});
$p.hU = (function() {
  return this.aRK();
});
$p.hV = (function(from, until) {
  return this.b8X(from, until);
});
$p.tW = (function(p) {
  return this.b0h(p);
});
$p.uj = (function(p) {
  return this.b9Q(p);
});
$p.cn = (function(n) {
  return this.aNC(n);
});
$p.ds = (function(n) {
  return this.aNA(n);
});
$p.Jt = (function(n) {
  return this.aSH(n);
});
$p.i = (function(v1) {
  return this.DK((v1 | 0));
});
$p.l = (function(i) {
  return this.DK(i);
});
$p.L = (function(f) {
  return this.PD(f);
});
$p.v = (function() {
  return this.b9H();
});
$p.lX = (function() {
  return this.b2P();
});
$p.t = (function() {
  return this.E4();
});
$p.bJ = (function() {
  return this.mP();
});
function $isArrayOf_sci_Range(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dL)));
}
function $p_scm_LinkedHashSet__tableSizeFor__I__I($thiz, capacity) {
  var x = ((capacity - 1) | 0);
  var i = ((x > 4) ? x : 4);
  var x$1 = ((((-2147483648) >> Math.clz32(i)) & i) << 1);
  return ((x$1 < 1073741824) ? x$1 : 1073741824);
}
function $p_scm_LinkedHashSet__newThreshold__I__I($thiz, size) {
  return $doubleToInt((0.75 * size));
}
function $p_scm_LinkedHashSet__createNewEntry__O__I__scm_LinkedHashSet$Entry($thiz, key, hash) {
  var e = new $c_scm_LinkedHashSet$Entry(key, hash);
  if (($thiz.A6 === null)) {
    $thiz.A6 = e;
  } else {
    $thiz.HK.vI = e;
    e.Da = $thiz.HK;
  }
  $thiz.HK = e;
  return e;
}
function $p_scm_LinkedHashSet__deleteEntry__scm_LinkedHashSet$Entry__V($thiz, e) {
  if ((e.Da === null)) {
    $thiz.A6 = e.vI;
  } else {
    e.Da.vI = e.vI;
  }
  if ((e.vI === null)) {
    $thiz.HK = e.Da;
  } else {
    e.vI.Da = e.Da;
  }
  e.Da = null;
  e.vI = null;
  e.i8 = null;
}
function $p_scm_LinkedHashSet__put0__O__I__I__Z($thiz, elem, hash, idx) {
  var x1 = $thiz.kj.a[idx];
  if ((x1 === null)) {
    $thiz.kj.a[idx] = $p_scm_LinkedHashSet__createNewEntry__O__I__scm_LinkedHashSet$Entry($thiz, elem, hash);
  } else {
    var prev = null;
    var n = x1;
    while (((n !== null) && (n.pe <= hash))) {
      if (((n.pe === hash) && $m_sr_BoxesRunTime$().Q(elem, n.pf))) {
        return false;
      }
      prev = n;
      n = n.i8;
    }
    var nnode = $p_scm_LinkedHashSet__createNewEntry__O__I__scm_LinkedHashSet$Entry($thiz, elem, hash);
    if ((prev === null)) {
      nnode.i8 = x1;
      $thiz.kj.a[idx] = nnode;
    } else {
      nnode.i8 = prev.i8;
      prev.i8 = nnode;
    }
  }
  $thiz.nr = ((1 + $thiz.nr) | 0);
  return true;
}
function $p_scm_LinkedHashSet__remove0__O__I__Z($thiz, elem, hash) {
  var idx = (hash & (($thiz.kj.a.length - 1) | 0));
  var x1 = $thiz.kj.a[idx];
  if ((x1 !== null)) {
    if (((x1.pe === hash) && $m_sr_BoxesRunTime$().Q(x1.pf, elem))) {
      $thiz.kj.a[idx] = x1.i8;
      $p_scm_LinkedHashSet__deleteEntry__scm_LinkedHashSet$Entry__V($thiz, x1);
      $thiz.nr = (($thiz.nr - 1) | 0);
      return true;
    } else {
      var prev = x1;
      var next = x1.i8;
      while (((next !== null) && (next.pe <= hash))) {
        if (((next.pe === hash) && $m_sr_BoxesRunTime$().Q(next.pf, elem))) {
          prev.i8 = next.i8;
          $p_scm_LinkedHashSet__deleteEntry__scm_LinkedHashSet$Entry__V($thiz, next);
          $thiz.nr = (($thiz.nr - 1) | 0);
          return true;
        }
        prev = next;
        next = next.i8;
      }
      return false;
    }
  } else {
    return false;
  }
}
function $p_scm_LinkedHashSet__growTable__I__V($thiz, newlen) {
  if ((newlen < 0)) {
    throw $ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), (("new hash table size " + newlen) + " exceeds maximum"));
  }
  var oldlen = $thiz.kj.a.length;
  $thiz.ad5 = $p_scm_LinkedHashSet__newThreshold__I__I($thiz, newlen);
  if (($thiz.nr === 0)) {
    $thiz.kj = new ($d_scm_LinkedHashSet$Entry.r().C)(newlen);
  } else {
    $thiz.kj = $m_ju_Arrays$().ex($thiz.kj, newlen);
    var preLow = new $c_scm_LinkedHashSet$Entry(null, 0);
    var preHigh = new $c_scm_LinkedHashSet$Entry(null, 0);
    while ((oldlen < newlen)) {
      var i = 0;
      while ((i < oldlen)) {
        var old = $thiz.kj.a[i];
        if ((old !== null)) {
          preLow.i8 = null;
          preHigh.i8 = null;
          var lastLow = preLow;
          var lastHigh = preHigh;
          var n = old;
          while ((n !== null)) {
            var next = n.i8;
            if (((n.pe & oldlen) === 0)) {
              lastLow.i8 = n;
              lastLow = n;
            } else {
              lastHigh.i8 = n;
              lastHigh = n;
            }
            n = next;
          }
          lastLow.i8 = null;
          if ((old !== preLow.i8)) {
            $thiz.kj.a[i] = preLow.i8;
          }
          if ((preHigh.i8 !== null)) {
            $thiz.kj.a[((i + oldlen) | 0)] = preHigh.i8;
            lastHigh.i8 = null;
          }
        }
        i = ((1 + i) | 0);
      }
      oldlen = (oldlen << 1);
    }
  }
}
/** @constructor */
function $c_scm_LinkedHashSet() {
  this.A6 = null;
  this.HK = null;
  this.kj = null;
  this.ad5 = 0;
  this.nr = 0;
  this.A6 = null;
  this.HK = null;
  this.kj = new ($d_scm_LinkedHashSet$Entry.r().C)($p_scm_LinkedHashSet__tableSizeFor__I__I(this, 16));
  this.ad5 = $p_scm_LinkedHashSet__newThreshold__I__I(this, this.kj.a.length);
  this.nr = 0;
}
$p = $c_scm_LinkedHashSet.prototype = new $h_scm_AbstractSet();
$p.constructor = $c_scm_LinkedHashSet;
/** @constructor */
function $h_scm_LinkedHashSet() {
}
$h_scm_LinkedHashSet.prototype = $p;
$p.fa = (function(asPair) {
  return $f_sc_StrictOptimizedIterableOps__unzip__F1__T2(this, asPair);
});
$p.L = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$p.c5 = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.ct = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.dk = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bw = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$p.cE = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true);
});
$p.fy = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__partitionMap__F1__T2(this, f);
});
$p.cn = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$p.cd = (function() {
  return $m_scm_LinkedHashSet$();
});
$p.bJ = (function() {
  if ((this.nr > 0)) {
    return this.HK.pf;
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "Cannot call .last on empty LinkedHashSet");
  }
});
$p.dt = (function() {
  return ((this.nr > 0) ? new $c_s_Some(this.A6.pf) : $m_s_None$());
});
$p.aa = (function() {
  return this.nr;
});
$p.V = (function() {
  return this.nr;
});
$p.c = (function() {
  return (this.nr === 0);
});
$p.E = (function(elem) {
  var originalHash = $m_sr_Statics$().u(elem);
  var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  var x1 = this.kj.a[(hash & ((this.kj.a.length - 1) | 0))];
  return (((x1 === null) ? null : x1.b1k(elem, hash)) !== null);
});
$p.f9 = (function(size) {
  var target = $p_scm_LinkedHashSet__tableSizeFor__I__I(this, $doubleToInt((((1 + size) | 0) / 0.75)));
  if ((target > this.kj.a.length)) {
    $p_scm_LinkedHashSet__growTable__I__V(this, target);
  }
});
$p.oA = (function(elem) {
  if ((((1 + this.nr) | 0) >= this.ad5)) {
    $p_scm_LinkedHashSet__growTable__I__V(this, (this.kj.a.length << 1));
  }
  var originalHash = $m_sr_Statics$().u(elem);
  var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  return $p_scm_LinkedHashSet__put0__O__I__I__Z(this, elem, hash, (hash & ((this.kj.a.length - 1) | 0)));
});
$p.OV = (function(elem) {
  this.oA(elem);
  return this;
});
$p.b9r = (function(elem) {
  this.ahA(elem);
  return this;
});
$p.ahA = (function(elem) {
  var originalHash = $m_sr_Statics$().u(elem);
  return $p_scm_LinkedHashSet__remove0__O__I__Z(this, elem, (originalHash ^ ((originalHash >>> 16) | 0)));
});
$p.o = (function() {
  return new $c_scm_LinkedHashSet$$anon$1(this);
});
$p.F = (function(f) {
  var cur = this.A6;
  while ((cur !== null)) {
    f.i(cur.pf);
    cur = cur.vI;
  }
});
$p.ie = (function() {
  $m_ju_Arrays$().WM(this.kj, null);
  this.nr = 0;
  this.A6 = null;
  this.HK = null;
});
$p.x = (function() {
  var setHashIterator = (this.c() ? new $c_scm_LinkedHashSet$$anon$1(this) : new $c_scm_LinkedHashSet$$anon$3(this));
  return $m_s_util_hashing_MurmurHash3$().Em(setHashIterator, $m_s_util_hashing_MurmurHash3$().Vy);
});
$p.el = (function() {
  return "LinkedHashSet";
});
$p.re = (function(elem) {
  return this.b9r(elem);
});
$p.Y = (function(elem) {
  return this.OV(elem);
});
function $isArrayOf_scm_LinkedHashSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.lR)));
}
var $d_scm_LinkedHashSet = new $TypeData().i($c_scm_LinkedHashSet, "scala.collection.mutable.LinkedHashSet", ({
  lR: 1,
  lC: 1,
  aQ: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  aG: 1,
  aR: 1,
  h: 1,
  b: 1,
  lT: 1,
  aa: 1,
  lU: 1,
  a9: 1,
  W: 1,
  Y: 1,
  T: 1,
  S: 1,
  aM: 1,
  z: 1,
  a5: 1,
  a: 1
}));
/** @constructor */
function $c_scm_Map$WithDefault(underlying, defaultValue) {
  this.vJ = null;
  this.Oc = null;
  this.vJ = underlying;
  this.Oc = defaultValue;
}
$p = $c_scm_Map$WithDefault.prototype = new $h_scm_AbstractMap();
$p.constructor = $c_scm_Map$WithDefault;
/** @constructor */
function $h_scm_Map$WithDefault() {
}
$h_scm_Map$WithDefault.prototype = $p;
$p.WC = (function(key) {
  return this.Oc.i(key);
});
$p.o = (function() {
  return this.vJ.o();
});
$p.c = (function() {
  return this.vJ.c();
});
$p.V = (function() {
  return this.vJ.V();
});
$p.im = (function() {
  return this.vJ.im();
});
$p.r = (function(key) {
  return this.vJ.r(key);
});
$p.b9s = (function(elem) {
  this.vJ.re(elem);
  return this;
});
$p.aWN = (function(elem) {
  this.vJ.Y(elem);
  return this;
});
$p.aYV = (function(suffix) {
  return new $c_scm_Map$WithDefault(this.vJ.hN(suffix), this.Oc);
});
$p.b0w = (function() {
  return new $c_scm_Map$WithDefault(this.vJ.pr(), this.Oc);
});
$p.aOG = (function(coll) {
  return new $c_scm_Map$WithDefault(this.vJ.im().cc(coll), this.Oc);
});
$p.fS = (function() {
  return new $c_scm_Builder$$anon$1($m_scm_Map$().b5(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((p$2$2) => new $c_scm_Map$WithDefault(p$2$2, this.Oc))));
});
$p.fP = (function(coll) {
  return this.aOG(coll);
});
$p.w4 = (function(coll) {
  return this.aOG(coll);
});
$p.pr = (function() {
  return this.b0w();
});
$p.hN = (function(suffix) {
  return this.aYV(suffix);
});
$p.Y = (function(elem) {
  return this.aWN(elem);
});
$p.re = (function(elem) {
  return this.b9s(elem);
});
var $d_scm_Map$WithDefault = new $TypeData().i($c_scm_Map$WithDefault, "scala.collection.mutable.Map$WithDefault", ({
  Kj: 1,
  cR: 1,
  aL: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  as: 1,
  ak: 1,
  i: 1,
  h: 1,
  aF: 1,
  b: 1,
  bt: 1,
  aa: 1,
  c6: 1,
  a9: 1,
  W: 1,
  Y: 1,
  T: 1,
  S: 1,
  aM: 1,
  a: 1
}));
function $p_sci_ArraySeq__appendedAllArraySeq__sci_ArraySeq__sci_ArraySeq($thiz, that) {
  if ($f_sc_SeqOps__isEmpty__Z($thiz)) {
    return that;
  } else if ($f_sc_SeqOps__isEmpty__Z(that)) {
    return $thiz;
  } else {
    var thisIsObj = ($thiz.gd() instanceof $ac_O);
    if ((thisIsObj !== (that.gd() instanceof $ac_O))) {
      return null;
    } else if (thisIsObj) {
      var ax = $thiz.gd();
      var ay = that.gd();
      var len = (($m_jl_reflect_Array$().c6(ax) + $m_jl_reflect_Array$().c6(ay)) | 0);
      var a = new $ac_O(len);
      var length = $m_jl_reflect_Array$().c6(ax);
      ax.av(0, a, 0, length);
      var destPos = $m_jl_reflect_Array$().c6(ax);
      var length$1 = $m_jl_reflect_Array$().c6(ay);
      ay.av(0, a, destPos, length$1);
      return $m_sci_ArraySeq$().n0(a);
    } else {
      var ax$2 = $thiz.gd();
      var ay$2 = that.gd();
      var len$2 = (($m_jl_reflect_Array$().c6(ax$2) + $m_jl_reflect_Array$().c6(ay$2)) | 0);
      var a$2 = $thiz.gY().b2(len$2);
      var length$2 = $m_jl_reflect_Array$().c6(ax$2);
      ax$2.av(0, a$2, 0, length$2);
      var destPos$1 = $m_jl_reflect_Array$().c6(ax$2);
      var length$3 = $m_jl_reflect_Array$().c6(ay$2);
      ay$2.av(0, a$2, destPos$1, length$3);
      return $m_sci_ArraySeq$().n0(a$2);
    }
  }
}
function $p_sci_ArraySeq__genericResult$1__sc_IterableOnce__sci_ArraySeq($thiz, suffix$1) {
  var k = suffix$1.V();
  if ((k === 0)) {
    return $thiz;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    if ((k >= 0)) {
      $m_jl_reflect_Array$().c6($thiz.gd());
    }
    var xs$1 = $thiz.gd();
    var length = $m_jl_reflect_Array$().c6(xs$1);
    var i = 0;
    while ((i < length)) {
      var elem = $m_sr_ScalaRunTime$().f6(xs$1, i);
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem);
      i = ((1 + i) | 0);
    }
    var it = suffix$1.o();
    while (it.p()) {
      var elem$1 = it.q();
      var unboxedElem$1 = ((elem$1 === null) ? null : elem$1);
      jsElems.push(unboxedElem$1);
    }
    return $m_sci_ArraySeq$().n0(new $ac_O(jsElems));
  }
}
/** @constructor */
function $c_sci_ArraySeq() {
}
$p = $c_sci_ArraySeq.prototype = new $h_sci_AbstractSeq();
$p.constructor = $c_sci_ArraySeq;
/** @constructor */
function $h_sci_ArraySeq() {
}
$h_sci_ArraySeq.prototype = $p;
$p.w4 = (function(coll) {
  return $m_sci_ArraySeq$().ag1(coll, this.gY());
});
$p.fS = (function() {
  return $m_sci_ArraySeq$().a4e(this.gY());
});
$p.pr = (function() {
  var this$1 = $m_sci_ArraySeq$();
  this.gY();
  return $p_sci_ArraySeq$__emptyImpl__sci_ArraySeq$ofRef(this$1);
});
$p.ko = (function(f) {
  return $f_sci_StrictOptimizedSeqOps__distinctBy__F1__O(this, f);
});
$p.ju = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
});
$p.PW = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__span__F1__T2(this, p);
});
$p.fa = (function(asPair) {
  return $f_sc_StrictOptimizedIterableOps__unzip__F1__T2(this, asPair);
});
$p.c5 = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.ct = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.dk = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.Es = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this);
});
$p.bw = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$p.cE = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true);
});
$p.fy = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__partitionMap__F1__T2(this, f);
});
$p.IG = (function(that) {
  return $f_sci_IndexedSeq__canEqual__O__Z(this, that);
});
$p.AE = (function(o) {
  return $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this, o);
});
$p.el = (function() {
  return "IndexedSeq";
});
$p.cx = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), new $c_sc_IndexedSeqView$Id(this));
});
$p.k0 = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$p.t = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$p.dt = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$p.bJ = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$p.bL = (function(len) {
  var x = this.C();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$p.V = (function() {
  return this.C();
});
$p.nB = (function() {
  return $m_sci_ArraySeq$().acB;
});
$p.b4g = (function(f) {
  var a = new $ac_O(this.C());
  var i = 0;
  while ((i < a.a.length)) {
    a.a[i] = f.i(this.l(i));
    i = ((1 + i) | 0);
  }
  return $m_sci_ArraySeq$().n0(a);
});
$p.iv = (function(elem) {
  var $x_1 = $m_sci_ArraySeq$();
  var xs = this.gd();
  var dest = new $ac_O(((1 + $m_jl_reflect_Array$().c6(xs)) | 0));
  dest.a[0] = elem;
  $m_s_Array$().fv(xs, 0, dest, 1, $m_jl_reflect_Array$().c6(xs));
  return $x_1.n0(dest);
});
$p.hJ = (function(elem) {
  var $x_1 = $m_sci_ArraySeq$();
  var xs = this.gd();
  var newLength = ((1 + $m_jl_reflect_Array$().c6(xs)) | 0);
  if ($d_O.R($objectGetClass(xs).ba.Q().ba)) {
    var dest$1 = $m_ju_Arrays$().WA(xs, newLength, $d_O.r().l());
  } else {
    var dest = new $ac_O(newLength);
    $m_s_Array$().fv(xs, 0, dest, 0, $m_jl_reflect_Array$().c6(xs));
    var dest$1 = dest;
  }
  var x1 = $m_jl_reflect_Array$().c6(xs);
  dest$1.a[x1] = elem;
  return $x_1.n0(dest$1);
});
$p.aX8 = (function(suffix) {
  if ((suffix instanceof $c_sci_ArraySeq)) {
    var result = $p_sci_ArraySeq__appendedAllArraySeq__sci_ArraySeq__sci_ArraySeq(this, suffix);
    return ((result === null) ? $p_sci_ArraySeq__genericResult$1__sc_IterableOnce__sci_ArraySeq(this, suffix) : result);
  } else {
    return $p_sci_ArraySeq__genericResult$1__sc_IterableOnce__sci_ArraySeq(this, suffix);
  }
});
$p.b9L = (function(n) {
  return (($m_jl_reflect_Array$().c6(this.gd()) <= n) ? this : $m_sci_ArraySeq$().n0($m_sc_ArrayOps$().ls(this.gd(), 0, n)));
});
$p.b09 = (function(n) {
  return ((n <= 0) ? this : $m_sci_ArraySeq$().n0($m_sc_ArrayOps$().aNB(this.gd(), n)));
});
$p.b0c = (function(n) {
  return ((n <= 0) ? this : $m_sci_ArraySeq$().n0($m_sc_ArrayOps$().b0e(this.gd(), n)));
});
$p.b8W = (function(from, until) {
  return (((from <= 0) && ($m_jl_reflect_Array$().c6(this.gd()) <= until)) ? this : $m_sci_ArraySeq$().n0($m_sc_ArrayOps$().ls(this.gd(), from, until)));
});
$p.hO = (function(z, f) {
  var array = this.gd();
  var b = z;
  var i = 0;
  while ((i < $m_jl_reflect_Array$().c6(array))) {
    var a = $m_sr_ScalaRunTime$().f6(array, i);
    b = f.R(b, a);
    i = ((1 + i) | 0);
  }
  return b;
});
$p.b9G = (function() {
  return $m_sci_ArraySeq$().n0($m_sc_ArrayOps$().aSG(this.gd()));
});
$p.b7T = (function() {
  var $x_1 = $m_sci_ArraySeq$();
  var this$ = this.gd();
  var len = $m_jl_reflect_Array$().c6(this$);
  var res = $m_s_reflect_ClassTag$().y0($objectGetClass(this$).ba.Q()).b2(len);
  var i = 0;
  while ((i < len)) {
    $m_sr_ScalaRunTime$().kn(res, ((((len - i) | 0) - 1) | 0), $m_sr_ScalaRunTime$().f6(this$, i));
    i = ((1 + i) | 0);
  }
  return $x_1.n0(res);
});
$p.hM = (function() {
  return "ArraySeq";
});
$p.cR = (function(xs, start, len) {
  var srcLen = this.C();
  var destLen = $m_jl_reflect_Array$().c6(xs);
  var limit = ((len < srcLen) ? len : srcLen);
  var capacity = ((start < 0) ? destLen : ((destLen - start) | 0));
  var total = ((capacity < limit) ? capacity : limit);
  var copied = ((total < 0) ? 0 : total);
  if ((copied > 0)) {
    $m_s_Array$().fv(this.gd(), 0, xs, start, copied);
  }
  return copied;
});
$p.OZ = (function() {
  return 2147483647;
});
$p.kV = (function(ord) {
  if (($m_jl_reflect_Array$().c6(this.gd()) <= 1)) {
    return this;
  } else {
    var original = this.gd();
    var newLength = this.C();
    if ($d_O.R($objectGetClass(original).ba.Q().ba)) {
      var a = $m_ju_Arrays$().WA(original, newLength, $d_O.r().l());
    } else {
      var dest = new $ac_O(newLength);
      $m_s_Array$().fv(original, 0, dest, 0, $m_jl_reflect_Array$().c6(original));
      var a = dest;
    }
    $m_ju_Arrays$().Jn(a, ord);
    return new $c_sci_ArraySeq$ofRef(a);
  }
});
$p.JI = (function() {
  return new $c_sc_IndexedSeqView$Id(this);
});
$p.fP = (function(coll) {
  return $m_sci_ArraySeq$().ag1(coll, this.gY());
});
$p.h9 = (function(ord) {
  return this.kV(ord);
});
$p.hU = (function() {
  return this.b7T();
});
$p.v = (function() {
  return this.b9G();
});
$p.hV = (function(from, until) {
  return this.b8W(from, until);
});
$p.cn = (function(n) {
  return this.b0c(n);
});
$p.ds = (function(n) {
  return this.b09(n);
});
$p.Jt = (function(n) {
  return this.b9L(n);
});
$p.gU = (function(suffix) {
  return this.aX8(suffix);
});
$p.bv = (function(elem) {
  return this.hJ(elem);
});
$p.kv = (function(elem) {
  return this.iv(elem);
});
$p.L = (function(f) {
  return this.b4g(f);
});
$p.cd = (function() {
  return $m_sci_ArraySeq$().acB;
});
function $isArrayOf_sci_ArraySeq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.aU)));
}
/** @constructor */
function $c_sci_Range$Exclusive(start, end, step) {
  this.dx = 0;
  this.p9 = 0;
  this.c4 = 0;
  this.gL = false;
  this.ok = 0;
  this.tH = 0;
  $ct_sci_Range__I__I__I__(this, start, end, step);
}
$p = $c_sci_Range$Exclusive.prototype = new $h_sci_Range();
$p.constructor = $c_sci_Range$Exclusive;
/** @constructor */
function $h_sci_Range$Exclusive() {
}
$h_sci_Range$Exclusive.prototype = $p;
$p.yb = (function() {
  return false;
});
var $d_sci_Range$Exclusive = new $TypeData().i($c_sci_Range$Exclusive, "scala.collection.immutable.Range$Exclusive", ({
  IR: 1,
  dL: 1,
  a6: 1,
  L: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  H: 1,
  i: 1,
  h: 1,
  w: 1,
  b: 1,
  X: 1,
  I: 1,
  a2: 1,
  a7: 1,
  M: 1,
  A: 1,
  ae: 1,
  a8: 1,
  N: 1,
  z: 1,
  a: 1
}));
/** @constructor */
function $c_sci_Range$Inclusive(start, end, step) {
  this.dx = 0;
  this.p9 = 0;
  this.c4 = 0;
  this.gL = false;
  this.ok = 0;
  this.tH = 0;
  $ct_sci_Range__I__I__I__(this, start, end, step);
}
$p = $c_sci_Range$Inclusive.prototype = new $h_sci_Range();
$p.constructor = $c_sci_Range$Inclusive;
/** @constructor */
function $h_sci_Range$Inclusive() {
}
$h_sci_Range$Inclusive.prototype = $p;
$p.yb = (function() {
  return true;
});
var $d_sci_Range$Inclusive = new $TypeData().i($c_sci_Range$Inclusive, "scala.collection.immutable.Range$Inclusive", ({
  IS: 1,
  dL: 1,
  a6: 1,
  L: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  H: 1,
  i: 1,
  h: 1,
  w: 1,
  b: 1,
  X: 1,
  I: 1,
  a2: 1,
  a7: 1,
  M: 1,
  A: 1,
  ae: 1,
  a8: 1,
  N: 1,
  z: 1,
  a: 1
}));
function $ct_sci_Vector__AO__($thiz, prefix1) {
  $thiz.a9 = prefix1;
  return $thiz;
}
/** @constructor */
function $c_sci_Vector() {
  this.a9 = null;
}
$p = $c_sci_Vector.prototype = new $h_sci_AbstractSeq();
$p.constructor = $c_sci_Vector;
/** @constructor */
function $h_sci_Vector() {
}
$h_sci_Vector.prototype = $p;
$p.ko = (function(f) {
  return $f_sci_StrictOptimizedSeqOps__distinctBy__F1__O(this, f);
});
$p.h9 = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord);
});
$p.ju = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
});
$p.PW = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__span__F1__T2(this, p);
});
$p.fa = (function(asPair) {
  return $f_sc_StrictOptimizedIterableOps__unzip__F1__T2(this, asPair);
});
$p.c5 = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.ct = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.dk = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.Es = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this);
});
$p.bw = (function(pred) {
  return this.d8(pred, false);
});
$p.cE = (function(pred) {
  return this.d8(pred, true);
});
$p.fy = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__partitionMap__F1__T2(this, f);
});
$p.IG = (function(that) {
  return $f_sci_IndexedSeq__canEqual__O__Z(this, that);
});
$p.AE = (function(o) {
  return $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this, o);
});
$p.el = (function() {
  return "IndexedSeq";
});
$p.cx = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), new $c_sc_IndexedSeqView$Id(this));
});
$p.k0 = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$p.hU = (function() {
  return $f_sc_IndexedSeqOps__reverse__O(this);
});
$p.dt = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$p.bL = (function(len) {
  var x = this.C();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$p.V = (function() {
  return this.C();
});
$p.nB = (function() {
  return $m_sci_Vector$();
});
$p.C = (function() {
  return ((this instanceof $c_sci_BigVector) ? this.at : this.a9.a.length);
});
$p.o = (function() {
  return (($m_sci_Vector0$() === this) ? $m_sci_Vector$().aIx : new $c_sci_NewVectorIterator(this, this.C(), this.um()));
});
$p.d8 = (function(pred, isFlipped) {
  var i = 0;
  var len = this.a9.a.length;
  while ((i !== len)) {
    if (((!(!pred.i(this.a9.a[i]))) === isFlipped)) {
      var bitmap = 0;
      var j = ((1 + i) | 0);
      while ((j < len)) {
        if (((!(!pred.i(this.a9.a[j]))) !== isFlipped)) {
          bitmap = (bitmap | (1 << j));
        }
        j = ((1 + j) | 0);
      }
      var newLen = ((i + $m_jl_Integer$().dz(bitmap)) | 0);
      if ((this instanceof $c_sci_BigVector)) {
        var b = new $c_sci_VectorBuilder();
        var k = 0;
        while ((k < i)) {
          b.ck(this.a9.a[k]);
          k = ((1 + k) | 0);
        }
        k = ((1 + i) | 0);
        while ((i !== newLen)) {
          if ((((1 << k) & bitmap) !== 0)) {
            b.ck(this.a9.a[k]);
            i = ((1 + i) | 0);
          }
          k = ((1 + k) | 0);
        }
        this.aOi(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((pred, isFlipped, b) => ((v$2$2) => (((!(!pred.i(v$2$2))) !== isFlipped) ? b.ck(v$2$2) : (void 0))))(pred, isFlipped, b)));
        return b.bY();
      } else {
        if ((newLen === 0)) {
          return $m_sci_Vector0$();
        }
        var newData = new $ac_O(newLen);
        var src = this.a9;
        var length = i;
        src.av(0, newData, 0, length);
        var k$2 = ((1 + i) | 0);
        while ((i !== newLen)) {
          if ((((1 << k$2) & bitmap) !== 0)) {
            newData.a[i] = this.a9.a[k$2];
            i = ((1 + i) | 0);
          }
          k$2 = ((1 + k$2) | 0);
        }
        return new $c_sci_Vector1(newData);
      }
    }
    i = ((1 + i) | 0);
  }
  if ((this instanceof $c_sci_BigVector)) {
    var b$2 = new $c_sci_VectorBuilder();
    b$2.b2Q(this.a9);
    this.aOi(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v$2$2$1) => (((!(!pred.i(v$2$2$1))) !== isFlipped) ? b$2.ck(v$2$2$1) : (void 0)))));
    return b$2.bY();
  } else {
    return this;
  }
});
$p.iR = (function(suffix) {
  var k = suffix.V();
  return ((k === 0) ? this : ((k < 0) ? $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix) : this.pn(suffix, k)));
});
$p.pn = (function(suffix, k) {
  if ((k < ((4 + this.um()) | 0))) {
    var v = new $c_sr_ObjectRef(this);
    if ($is_sci_Iterable(suffix)) {
      suffix.F(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2$2) => {
        v.aD = v.aD.lg(x$2$2);
      })));
    } else {
      var this$2 = suffix.o();
      while (this$2.p()) {
        var x0 = this$2.q();
        v.aD = v.aD.lg(x0);
      }
    }
    return v.aD;
  } else if (((this.C() < ((k >>> 5) | 0)) && (suffix instanceof $c_sci_Vector))) {
    var v$2 = suffix;
    var ri = $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), new $c_sc_IndexedSeqView$Id(this));
    while ((ri.kc > 0)) {
      v$2 = v$2.mV(ri.q());
    }
    return v$2;
  } else {
    return (((this.C() < ((k - 64) | 0)) && (suffix instanceof $c_sci_Vector)) ? new $c_sci_VectorBuilder().aWT(this.C(), suffix).fO(this).fO(suffix).bY() : new $c_sci_VectorBuilder().aPf(this).fO(suffix).bY());
  }
});
$p.hM = (function() {
  return "Vector";
});
$p.cR = (function(xs, start, len) {
  return this.o().cR(xs, start, len);
});
$p.d2 = (function() {
  return this;
});
$p.OZ = (function() {
  return $m_sci_Vector$().aIw;
});
$p.ks = (function(index) {
  return $m_scg_CommonErrors$().h2(index, ((this.C() - 1) | 0));
});
$p.t = (function() {
  if ((this.a9.a.length === 0)) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "empty.head");
  } else {
    return this.a9.a[0];
  }
});
$p.bJ = (function() {
  if ((this instanceof $c_sci_BigVector)) {
    var suffix = this.al;
    if ((suffix.a.length === 0)) {
      throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "empty.tail");
    } else {
      return suffix.a[((suffix.a.length - 1) | 0)];
    }
  } else {
    return this.a9.a[((this.a9.a.length - 1) | 0)];
  }
});
$p.F = (function(f) {
  var c = this.um();
  var i = 0;
  while ((i < c)) {
    var $x_1 = $m_sci_VectorStatics$();
    var idx = i;
    var c$1 = (((c + ((c >>> 31) | 0)) | 0) >> 1);
    var a = ((idx - c$1) | 0);
    var sign = (a >> 31);
    $x_1.a3r(((((((1 + c$1) | 0) - (((a ^ sign) - sign) | 0)) | 0) - 1) | 0), this.wn(i), f);
    i = ((1 + i) | 0);
  }
});
$p.JI = (function() {
  return new $c_sc_IndexedSeqView$Id(this);
});
$p.cn = (function(n) {
  return this.pH(0, ((this.C() - ((n > 0) ? n : 0)) | 0));
});
$p.ds = (function(n) {
  return this.pH(n, this.C());
});
$p.Jt = (function(n) {
  return this.pH(0, n);
});
$p.gU = (function(suffix) {
  return this.iR(suffix);
});
$p.cd = (function() {
  return $m_sci_Vector$();
});
function $isArrayOf_sci_Vector(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bd)));
}
var $d_sci_Vector = new $TypeData().i(0, "scala.collection.immutable.Vector", ({
  bd: 1,
  a6: 1,
  L: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  H: 1,
  i: 1,
  h: 1,
  w: 1,
  b: 1,
  X: 1,
  I: 1,
  a2: 1,
  a7: 1,
  M: 1,
  A: 1,
  ae: 1,
  a8: 1,
  N: 1,
  z: 1,
  a5: 1,
  a: 1
}));
/** @constructor */
function $c_scm_ArraySeq() {
}
$p = $c_scm_ArraySeq.prototype = new $h_scm_AbstractSeq();
$p.constructor = $c_scm_ArraySeq;
/** @constructor */
function $h_scm_ArraySeq() {
}
$h_scm_ArraySeq.prototype = $p;
$p.ko = (function(f) {
  return $f_sc_StrictOptimizedSeqOps__distinctBy__F1__O(this, f);
});
$p.bv = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__appended__O__O(this, elem);
});
$p.gU = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix);
});
$p.fa = (function(asPair) {
  return $f_sc_StrictOptimizedIterableOps__unzip__F1__T2(this, asPair);
});
$p.L = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$p.c5 = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.ct = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.dk = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bw = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$p.cE = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true);
});
$p.fy = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__partitionMap__F1__T2(this, f);
});
$p.cn = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$p.el = (function() {
  return "IndexedSeq";
});
$p.cx = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), new $c_sc_IndexedSeqView$Id(this));
});
$p.k0 = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$p.ds = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n);
});
$p.hU = (function() {
  return $f_sc_IndexedSeqOps__reverse__O(this);
});
$p.hV = (function(from, until) {
  return $f_sc_IndexedSeqOps__slice__I__I__O(this, from, until);
});
$p.t = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$p.dt = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$p.bJ = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$p.bL = (function(len) {
  var x = this.C();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$p.V = (function() {
  return this.C();
});
$p.nB = (function() {
  return $m_scm_ArraySeq$().acX;
});
$p.aOF = (function(coll) {
  var evidence$1 = this.gY();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1.h8();
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  coll.V();
  var it = coll.o();
  while (it.p()) {
    var elem = it.q();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? elementClass.ba.z : elem));
    jsElems.push(unboxedElem);
  }
  var $x_1 = $m_scm_ArraySeq$();
  var elemRuntimeClass = ((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass));
  return $x_1.a48(elemRuntimeClass.ba.r().w(jsElems));
});
$p.fS = (function() {
  return $m_scm_ArraySeq$().a4e(this.gY());
});
$p.hM = (function() {
  return "ArraySeq";
});
$p.cR = (function(xs, start, len) {
  var srcLen = this.C();
  var destLen = $m_jl_reflect_Array$().c6(xs);
  var limit = ((len < srcLen) ? len : srcLen);
  var capacity = ((start < 0) ? destLen : ((destLen - start) | 0));
  var total = ((capacity < limit) ? capacity : limit);
  var copied = ((total < 0) ? 0 : total);
  if ((copied > 0)) {
    $m_s_Array$().fv(this.po(), 0, xs, start, copied);
  }
  return copied;
});
$p.e = (function(other) {
  if ((other instanceof $c_scm_ArraySeq)) {
    if (($m_jl_reflect_Array$().c6(this.po()) !== $m_jl_reflect_Array$().c6(other.po()))) {
      return false;
    }
  }
  return $f_sc_Seq__equals__O__Z(this, other);
});
$p.b9e = (function(ord) {
  return $m_scm_ArraySeq$().a48($m_sc_ArrayOps$().b9f(this.po(), ord));
});
$p.b9c = (function(ord) {
  if ((this.C() > 1)) {
    var this$1 = $m_s_util_Sorting$();
    var a = this.po();
    this$1.Y5(a, 0, $m_jl_reflect_Array$().c6(a), ord);
  }
  return this;
});
$p.Y4 = (function(ord) {
  return this.b9c(ord);
});
$p.h9 = (function(ord) {
  return this.b9e(ord);
});
$p.pr = (function() {
  var this$1 = $m_scm_ArraySeq$();
  this.gY();
  return this$1.a1S;
});
$p.fP = (function(coll) {
  return this.aOF(coll);
});
$p.w4 = (function(coll) {
  return this.aOF(coll);
});
$p.cd = (function() {
  return $m_scm_ArraySeq$().acX;
});
function $isArrayOf_scm_ArraySeq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.aW)));
}
/** @constructor */
function $c_sci_ArraySeq$ofBoolean(unsafeArray) {
  this.tA = null;
  this.tA = unsafeArray;
}
$p = $c_sci_ArraySeq$ofBoolean.prototype = new $h_sci_ArraySeq();
$p.constructor = $c_sci_ArraySeq$ofBoolean;
/** @constructor */
function $h_sci_ArraySeq$ofBoolean() {
}
$h_sci_ArraySeq$ofBoolean.prototype = $p;
$p.C = (function() {
  return this.tA.a.length;
});
$p.x = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.aMl(this.tA, this$1.ib);
});
$p.e = (function(that) {
  return ((that instanceof $c_sci_ArraySeq$ofBoolean) ? $m_ju_Arrays$().aNN(this.tA, that.tA) : $f_sc_Seq__equals__O__Z(this, that));
});
$p.kV = (function(ord) {
  if ((this.tA.a.length <= 1)) {
    return this;
  } else if ((ord === $m_s_math_Ordering$Boolean$())) {
    var this$1 = this.tA;
    var a = this$1.ae();
    $m_s_util_Sorting$().Y5(a, 0, a.a.length, $m_s_math_Ordering$Boolean$());
    return new $c_sci_ArraySeq$ofBoolean(a);
  } else {
    return $c_sci_ArraySeq.prototype.kV.call(this, ord);
  }
});
$p.o = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcZ$sp(this.tA);
});
$p.hJ = (function(elem) {
  if (((typeof elem) === "boolean")) {
    var x2 = (!(!elem));
    var xs = this.tA;
    var this$3 = $m_s_Array$();
    var newLength = ((1 + xs.a.length) | 0);
    if ($d_Z.R($objectGetClass(xs).ba.Q().ba)) {
      var dest$1 = this$3.y4(xs, newLength);
    } else {
      var dest = new $ac_Z(newLength);
      $m_s_Array$().fv(xs, 0, dest, 0, xs.a.length);
      var dest$1 = dest;
    }
    $m_sr_ScalaRunTime$().kn(dest$1, xs.a.length, x2);
    return new $c_sci_ArraySeq$ofBoolean(dest$1);
  } else {
    return $c_sci_ArraySeq.prototype.hJ.call(this, elem);
  }
});
$p.iv = (function(elem) {
  if (((typeof elem) === "boolean")) {
    var x2 = (!(!elem));
    var xs = this.tA;
    var dest = new $ac_Z(((1 + xs.a.length) | 0));
    dest.a[0] = x2;
    $m_s_Array$().fv(xs, 0, dest, 1, xs.a.length);
    return new $c_sci_ArraySeq$ofBoolean(dest);
  } else {
    return $c_sci_ArraySeq.prototype.iv.call(this, elem);
  }
});
$p.iU = (function(i) {
  return this.tA.a[i];
});
$p.kv = (function(elem) {
  return this.iv(elem);
});
$p.bv = (function(elem) {
  return this.hJ(elem);
});
$p.h9 = (function(ord) {
  return this.kV(ord);
});
$p.i = (function(v1) {
  return this.iU((v1 | 0));
});
$p.l = (function(i) {
  return this.iU(i);
});
$p.gY = (function() {
  return $m_s_reflect_ManifestFactory$BooleanManifest$();
});
$p.gd = (function() {
  return this.tA;
});
function $isArrayOf_sci_ArraySeq$ofBoolean(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kW)));
}
var $d_sci_ArraySeq$ofBoolean = new $TypeData().i($c_sci_ArraySeq$ofBoolean, "scala.collection.immutable.ArraySeq$ofBoolean", ({
  kW: 1,
  aU: 1,
  a6: 1,
  L: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  H: 1,
  i: 1,
  h: 1,
  w: 1,
  b: 1,
  X: 1,
  I: 1,
  a2: 1,
  a7: 1,
  M: 1,
  A: 1,
  ae: 1,
  a8: 1,
  N: 1,
  z: 1,
  b1: 1,
  a: 1
}));
/** @constructor */
function $c_sci_ArraySeq$ofByte(unsafeArray) {
  this.tB = null;
  this.tB = unsafeArray;
}
$p = $c_sci_ArraySeq$ofByte.prototype = new $h_sci_ArraySeq();
$p.constructor = $c_sci_ArraySeq$ofByte;
/** @constructor */
function $h_sci_ArraySeq$ofByte() {
}
$h_sci_ArraySeq$ofByte.prototype = $p;
$p.C = (function() {
  return this.tB.a.length;
});
$p.Wa = (function(i) {
  return this.tB.a[i];
});
$p.x = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.aMd(this.tB, this$1.ib);
});
$p.e = (function(that) {
  return ((that instanceof $c_sci_ArraySeq$ofByte) ? $m_ju_Arrays$().aNL(this.tB, that.tB) : $f_sc_Seq__equals__O__Z(this, that));
});
$p.kV = (function(ord) {
  if ((this.tB.a.length <= 1)) {
    return this;
  } else if ((ord === $m_s_math_Ordering$Byte$())) {
    var this$1 = this.tB;
    var a = this$1.ae();
    $m_ju_Arrays$().aSf(a);
    return new $c_sci_ArraySeq$ofByte(a);
  } else {
    return $c_sci_ArraySeq.prototype.kV.call(this, ord);
  }
});
$p.o = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcB$sp(this.tB);
});
$p.hJ = (function(elem) {
  if ($isByte(elem)) {
    var x2 = (elem | 0);
    var xs = this.tB;
    var this$3 = $m_s_Array$();
    var newLength = ((1 + xs.a.length) | 0);
    if ($d_B.R($objectGetClass(xs).ba.Q().ba)) {
      var dest$1 = this$3.y4(xs, newLength);
    } else {
      var dest = new $ac_B(newLength);
      $m_s_Array$().fv(xs, 0, dest, 0, xs.a.length);
      var dest$1 = dest;
    }
    $m_sr_ScalaRunTime$().kn(dest$1, xs.a.length, x2);
    return new $c_sci_ArraySeq$ofByte(dest$1);
  } else {
    return $c_sci_ArraySeq.prototype.hJ.call(this, elem);
  }
});
$p.iv = (function(elem) {
  if ($isByte(elem)) {
    var x2 = (elem | 0);
    var xs = this.tB;
    var dest = new $ac_B(((1 + xs.a.length) | 0));
    dest.a[0] = x2;
    $m_s_Array$().fv(xs, 0, dest, 1, xs.a.length);
    return new $c_sci_ArraySeq$ofByte(dest);
  } else {
    return $c_sci_ArraySeq.prototype.iv.call(this, elem);
  }
});
$p.kv = (function(elem) {
  return this.iv(elem);
});
$p.bv = (function(elem) {
  return this.hJ(elem);
});
$p.h9 = (function(ord) {
  return this.kV(ord);
});
$p.i = (function(v1) {
  return this.Wa((v1 | 0));
});
$p.l = (function(i) {
  return this.Wa(i);
});
$p.gY = (function() {
  return $m_s_reflect_ManifestFactory$ByteManifest$();
});
$p.gd = (function() {
  return this.tB;
});
function $isArrayOf_sci_ArraySeq$ofByte(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kX)));
}
var $d_sci_ArraySeq$ofByte = new $TypeData().i($c_sci_ArraySeq$ofByte, "scala.collection.immutable.ArraySeq$ofByte", ({
  kX: 1,
  aU: 1,
  a6: 1,
  L: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  H: 1,
  i: 1,
  h: 1,
  w: 1,
  b: 1,
  X: 1,
  I: 1,
  a2: 1,
  a7: 1,
  M: 1,
  A: 1,
  ae: 1,
  a8: 1,
  N: 1,
  z: 1,
  b1: 1,
  a: 1
}));
/** @constructor */
function $c_sci_ArraySeq$ofChar(unsafeArray) {
  this.qy = null;
  this.qy = unsafeArray;
}
$p = $c_sci_ArraySeq$ofChar.prototype = new $h_sci_ArraySeq();
$p.constructor = $c_sci_ArraySeq$ofChar;
/** @constructor */
function $h_sci_ArraySeq$ofChar() {
}
$h_sci_ArraySeq$ofChar.prototype = $p;
$p.C = (function() {
  return this.qy.a.length;
});
$p.Wb = (function(i) {
  return this.qy.a[i];
});
$p.x = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.aMe(this.qy, this$1.ib);
});
$p.e = (function(that) {
  return ((that instanceof $c_sci_ArraySeq$ofChar) ? $m_ju_Arrays$().afv(this.qy, that.qy) : $f_sc_Seq__equals__O__Z(this, that));
});
$p.kV = (function(ord) {
  if ((this.qy.a.length <= 1)) {
    return this;
  } else if ((ord === $m_s_math_Ordering$Char$())) {
    var this$1 = this.qy;
    var a = this$1.ae();
    $m_ju_Arrays$().aSg(a);
    return new $c_sci_ArraySeq$ofChar(a);
  } else {
    return $c_sci_ArraySeq.prototype.kV.call(this, ord);
  }
});
$p.o = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcC$sp(this.qy);
});
$p.hJ = (function(elem) {
  if ((elem instanceof $Char)) {
    var x2 = $uC(elem);
    var xs = this.qy;
    var this$3 = $m_s_Array$();
    var newLength = ((1 + xs.a.length) | 0);
    if ($d_C.R($objectGetClass(xs).ba.Q().ba)) {
      var dest$1 = this$3.y4(xs, newLength);
    } else {
      var dest = new $ac_C(newLength);
      $m_s_Array$().fv(xs, 0, dest, 0, xs.a.length);
      var dest$1 = dest;
    }
    $m_sr_ScalaRunTime$().kn(dest$1, xs.a.length, $bC(x2));
    return new $c_sci_ArraySeq$ofChar(dest$1);
  } else {
    return $c_sci_ArraySeq.prototype.hJ.call(this, elem);
  }
});
$p.iv = (function(elem) {
  if ((elem instanceof $Char)) {
    var x2 = $uC(elem);
    var xs = this.qy;
    var dest = new $ac_C(((1 + xs.a.length) | 0));
    dest.a[0] = x2;
    $m_s_Array$().fv(xs, 0, dest, 1, xs.a.length);
    return new $c_sci_ArraySeq$ofChar(dest);
  } else {
    return $c_sci_ArraySeq.prototype.iv.call(this, elem);
  }
});
$p.lf = (function(sb, start, sep, end) {
  return new $c_scm_ArraySeq$ofChar(this.qy).lf(sb, start, sep, end);
});
$p.kv = (function(elem) {
  return this.iv(elem);
});
$p.bv = (function(elem) {
  return this.hJ(elem);
});
$p.h9 = (function(ord) {
  return this.kV(ord);
});
$p.i = (function(v1) {
  return $bC(this.Wb((v1 | 0)));
});
$p.l = (function(i) {
  return $bC(this.Wb(i));
});
$p.gY = (function() {
  return $m_s_reflect_ManifestFactory$CharManifest$();
});
$p.gd = (function() {
  return this.qy;
});
function $isArrayOf_sci_ArraySeq$ofChar(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kY)));
}
var $d_sci_ArraySeq$ofChar = new $TypeData().i($c_sci_ArraySeq$ofChar, "scala.collection.immutable.ArraySeq$ofChar", ({
  kY: 1,
  aU: 1,
  a6: 1,
  L: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  H: 1,
  i: 1,
  h: 1,
  w: 1,
  b: 1,
  X: 1,
  I: 1,
  a2: 1,
  a7: 1,
  M: 1,
  A: 1,
  ae: 1,
  a8: 1,
  N: 1,
  z: 1,
  b1: 1,
  a: 1
}));
/** @constructor */
function $c_sci_ArraySeq$ofDouble(unsafeArray) {
  this.xx = null;
  this.xx = unsafeArray;
}
$p = $c_sci_ArraySeq$ofDouble.prototype = new $h_sci_ArraySeq();
$p.constructor = $c_sci_ArraySeq$ofDouble;
/** @constructor */
function $h_sci_ArraySeq$ofDouble() {
}
$h_sci_ArraySeq$ofDouble.prototype = $p;
$p.C = (function() {
  return this.xx.a.length;
});
$p.x = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.aMf(this.xx, this$1.ib);
});
$p.e = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofDouble)) {
    var array = this.xx;
    var thatArray = that.xx;
    if ((array === thatArray)) {
      return true;
    } else if ((array.a.length === thatArray.a.length)) {
      var i = 0;
      while (((i < array.a.length) && (array.a[i] === thatArray.a[i]))) {
        i = ((1 + i) | 0);
      }
      return (i >= array.a.length);
    } else {
      return false;
    }
  } else {
    return $f_sc_Seq__equals__O__Z(this, that);
  }
});
$p.o = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcD$sp(this.xx);
});
$p.hJ = (function(elem) {
  if (((typeof elem) === "number")) {
    var x2 = (+elem);
    var xs = this.xx;
    var this$3 = $m_s_Array$();
    var newLength = ((1 + xs.a.length) | 0);
    if ($d_D.R($objectGetClass(xs).ba.Q().ba)) {
      var dest$1 = this$3.y4(xs, newLength);
    } else {
      var dest = new $ac_D(newLength);
      $m_s_Array$().fv(xs, 0, dest, 0, xs.a.length);
      var dest$1 = dest;
    }
    $m_sr_ScalaRunTime$().kn(dest$1, xs.a.length, x2);
    return new $c_sci_ArraySeq$ofDouble(dest$1);
  } else {
    return $c_sci_ArraySeq.prototype.hJ.call(this, elem);
  }
});
$p.iv = (function(elem) {
  if (((typeof elem) === "number")) {
    var x2 = (+elem);
    var xs = this.xx;
    var dest = new $ac_D(((1 + xs.a.length) | 0));
    dest.a[0] = x2;
    $m_s_Array$().fv(xs, 0, dest, 1, xs.a.length);
    return new $c_sci_ArraySeq$ofDouble(dest);
  } else {
    return $c_sci_ArraySeq.prototype.iv.call(this, elem);
  }
});
$p.ID = (function(i) {
  return this.xx.a[i];
});
$p.kv = (function(elem) {
  return this.iv(elem);
});
$p.bv = (function(elem) {
  return this.hJ(elem);
});
$p.i = (function(v1) {
  return this.ID((v1 | 0));
});
$p.l = (function(i) {
  return this.ID(i);
});
$p.gY = (function() {
  return $m_s_reflect_ManifestFactory$DoubleManifest$();
});
$p.gd = (function() {
  return this.xx;
});
function $isArrayOf_sci_ArraySeq$ofDouble(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kZ)));
}
var $d_sci_ArraySeq$ofDouble = new $TypeData().i($c_sci_ArraySeq$ofDouble, "scala.collection.immutable.ArraySeq$ofDouble", ({
  kZ: 1,
  aU: 1,
  a6: 1,
  L: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  H: 1,
  i: 1,
  h: 1,
  w: 1,
  b: 1,
  X: 1,
  I: 1,
  a2: 1,
  a7: 1,
  M: 1,
  A: 1,
  ae: 1,
  a8: 1,
  N: 1,
  z: 1,
  b1: 1,
  a: 1
}));
/** @constructor */
function $c_sci_ArraySeq$ofFloat(unsafeArray) {
  this.xy = null;
  this.xy = unsafeArray;
}
$p = $c_sci_ArraySeq$ofFloat.prototype = new $h_sci_ArraySeq();
$p.constructor = $c_sci_ArraySeq$ofFloat;
/** @constructor */
function $h_sci_ArraySeq$ofFloat() {
}
$h_sci_ArraySeq$ofFloat.prototype = $p;
$p.C = (function() {
  return this.xy.a.length;
});
$p.x = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.aMg(this.xy, this$1.ib);
});
$p.e = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofFloat)) {
    var array = this.xy;
    var thatArray = that.xy;
    if ((array === thatArray)) {
      return true;
    } else if ((array.a.length === thatArray.a.length)) {
      var i = 0;
      while (((i < array.a.length) && (array.a[i] === thatArray.a[i]))) {
        i = ((1 + i) | 0);
      }
      return (i >= array.a.length);
    } else {
      return false;
    }
  } else {
    return $f_sc_Seq__equals__O__Z(this, that);
  }
});
$p.o = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcF$sp(this.xy);
});
$p.hJ = (function(elem) {
  if ($isFloat(elem)) {
    var x2 = Math.fround(elem);
    var xs = this.xy;
    var this$3 = $m_s_Array$();
    var newLength = ((1 + xs.a.length) | 0);
    if ($d_F.R($objectGetClass(xs).ba.Q().ba)) {
      var dest$1 = this$3.y4(xs, newLength);
    } else {
      var dest = new $ac_F(newLength);
      $m_s_Array$().fv(xs, 0, dest, 0, xs.a.length);
      var dest$1 = dest;
    }
    $m_sr_ScalaRunTime$().kn(dest$1, xs.a.length, x2);
    return new $c_sci_ArraySeq$ofFloat(dest$1);
  } else {
    return $c_sci_ArraySeq.prototype.hJ.call(this, elem);
  }
});
$p.iv = (function(elem) {
  if ($isFloat(elem)) {
    var x2 = Math.fround(elem);
    var xs = this.xy;
    var dest = new $ac_F(((1 + xs.a.length) | 0));
    dest.a[0] = x2;
    $m_s_Array$().fv(xs, 0, dest, 1, xs.a.length);
    return new $c_sci_ArraySeq$ofFloat(dest);
  } else {
    return $c_sci_ArraySeq.prototype.iv.call(this, elem);
  }
});
$p.We = (function(i) {
  return this.xy.a[i];
});
$p.kv = (function(elem) {
  return this.iv(elem);
});
$p.bv = (function(elem) {
  return this.hJ(elem);
});
$p.i = (function(v1) {
  return this.We((v1 | 0));
});
$p.l = (function(i) {
  return this.We(i);
});
$p.gY = (function() {
  return $m_s_reflect_ManifestFactory$FloatManifest$();
});
$p.gd = (function() {
  return this.xy;
});
function $isArrayOf_sci_ArraySeq$ofFloat(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.l0)));
}
var $d_sci_ArraySeq$ofFloat = new $TypeData().i($c_sci_ArraySeq$ofFloat, "scala.collection.immutable.ArraySeq$ofFloat", ({
  l0: 1,
  aU: 1,
  a6: 1,
  L: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  H: 1,
  i: 1,
  h: 1,
  w: 1,
  b: 1,
  X: 1,
  I: 1,
  a2: 1,
  a7: 1,
  M: 1,
  A: 1,
  ae: 1,
  a8: 1,
  N: 1,
  z: 1,
  b1: 1,
  a: 1
}));
/** @constructor */
function $c_sci_ArraySeq$ofInt(unsafeArray) {
  this.tC = null;
  this.tC = unsafeArray;
}
$p = $c_sci_ArraySeq$ofInt.prototype = new $h_sci_ArraySeq();
$p.constructor = $c_sci_ArraySeq$ofInt;
/** @constructor */
function $h_sci_ArraySeq$ofInt() {
}
$h_sci_ArraySeq$ofInt.prototype = $p;
$p.C = (function() {
  return this.tC.a.length;
});
$p.x = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.aMh(this.tC, this$1.ib);
});
$p.e = (function(that) {
  return ((that instanceof $c_sci_ArraySeq$ofInt) ? $m_ju_Arrays$().a3h(this.tC, that.tC) : $f_sc_Seq__equals__O__Z(this, that));
});
$p.kV = (function(ord) {
  if ((this.tC.a.length <= 1)) {
    return this;
  } else if ((ord === $m_s_math_Ordering$Int$())) {
    var this$1 = this.tC;
    var a = this$1.ae();
    $m_ju_Arrays$().aSh(a);
    return new $c_sci_ArraySeq$ofInt(a);
  } else {
    return $c_sci_ArraySeq.prototype.kV.call(this, ord);
  }
});
$p.o = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcI$sp(this.tC);
});
$p.hJ = (function(elem) {
  if ($isInt(elem)) {
    var x2 = (elem | 0);
    var xs = this.tC;
    var this$3 = $m_s_Array$();
    var newLength = ((1 + xs.a.length) | 0);
    if ($d_I.R($objectGetClass(xs).ba.Q().ba)) {
      var dest$1 = this$3.y4(xs, newLength);
    } else {
      var dest = new $ac_I(newLength);
      $m_s_Array$().fv(xs, 0, dest, 0, xs.a.length);
      var dest$1 = dest;
    }
    $m_sr_ScalaRunTime$().kn(dest$1, xs.a.length, x2);
    return new $c_sci_ArraySeq$ofInt(dest$1);
  } else {
    return $c_sci_ArraySeq.prototype.hJ.call(this, elem);
  }
});
$p.iv = (function(elem) {
  if ($isInt(elem)) {
    var x2 = (elem | 0);
    var xs = this.tC;
    var dest = new $ac_I(((1 + xs.a.length) | 0));
    dest.a[0] = x2;
    $m_s_Array$().fv(xs, 0, dest, 1, xs.a.length);
    return new $c_sci_ArraySeq$ofInt(dest);
  } else {
    return $c_sci_ArraySeq.prototype.iv.call(this, elem);
  }
});
$p.DK = (function(i) {
  return this.tC.a[i];
});
$p.kv = (function(elem) {
  return this.iv(elem);
});
$p.bv = (function(elem) {
  return this.hJ(elem);
});
$p.h9 = (function(ord) {
  return this.kV(ord);
});
$p.i = (function(v1) {
  return this.DK((v1 | 0));
});
$p.l = (function(i) {
  return this.DK(i);
});
$p.gY = (function() {
  return $m_s_reflect_ManifestFactory$IntManifest$();
});
$p.gd = (function() {
  return this.tC;
});
function $isArrayOf_sci_ArraySeq$ofInt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.l1)));
}
var $d_sci_ArraySeq$ofInt = new $TypeData().i($c_sci_ArraySeq$ofInt, "scala.collection.immutable.ArraySeq$ofInt", ({
  l1: 1,
  aU: 1,
  a6: 1,
  L: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  H: 1,
  i: 1,
  h: 1,
  w: 1,
  b: 1,
  X: 1,
  I: 1,
  a2: 1,
  a7: 1,
  M: 1,
  A: 1,
  ae: 1,
  a8: 1,
  N: 1,
  z: 1,
  b1: 1,
  a: 1
}));
/** @constructor */
function $c_sci_ArraySeq$ofLong(unsafeArray) {
  this.tD = null;
  this.tD = unsafeArray;
}
$p = $c_sci_ArraySeq$ofLong.prototype = new $h_sci_ArraySeq();
$p.constructor = $c_sci_ArraySeq$ofLong;
/** @constructor */
function $h_sci_ArraySeq$ofLong() {
}
$h_sci_ArraySeq$ofLong.prototype = $p;
$p.C = (function() {
  return ((this.tD.a.length >>> 1) | 0);
});
$p.x = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.aMi(this.tD, this$1.ib);
});
$p.e = (function(that) {
  return ((that instanceof $c_sci_ArraySeq$ofLong) ? $m_ju_Arrays$().afw(this.tD, that.tD) : $f_sc_Seq__equals__O__Z(this, that));
});
$p.kV = (function(ord) {
  if ((((this.tD.a.length >>> 1) | 0) <= 1)) {
    return this;
  } else if ((ord === $m_s_math_Ordering$Long$())) {
    var this$1 = this.tD;
    var a = this$1.ae();
    $m_ju_Arrays$().aSi(a);
    return new $c_sci_ArraySeq$ofLong(a);
  } else {
    return $c_sci_ArraySeq.prototype.kV.call(this, ord);
  }
});
$p.o = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcJ$sp(this.tD);
});
$p.hJ = (function(elem) {
  if ((elem instanceof $Long)) {
    var $x_1 = $uJ(elem);
    var x2_$_lo = $x_1.l;
    var x2_$_hi = $x_1.h;
    var xs = this.tD;
    var this$3 = $m_s_Array$();
    var newLength = ((1 + ((xs.a.length >>> 1) | 0)) | 0);
    if ($d_J.R($objectGetClass(xs).ba.Q().ba)) {
      var dest$1 = this$3.y4(xs, newLength);
    } else {
      var dest = new $ac_J(newLength);
      $m_s_Array$().fv(xs, 0, dest, 0, ((xs.a.length >>> 1) | 0));
      var dest$1 = dest;
    }
    $m_sr_ScalaRunTime$().kn(dest$1, ((xs.a.length >>> 1) | 0), $bL(x2_$_lo, x2_$_hi));
    return new $c_sci_ArraySeq$ofLong(dest$1);
  } else {
    return $c_sci_ArraySeq.prototype.hJ.call(this, elem);
  }
});
$p.iv = (function(elem) {
  if ((elem instanceof $Long)) {
    var $x_1 = $uJ(elem);
    var x2_$_lo = $x_1.l;
    var x2_$_hi = $x_1.h;
    var xs = this.tD;
    var dest = new $ac_J(((1 + ((xs.a.length >>> 1) | 0)) | 0));
    var $x_2 = dest.a;
    $x_2[0] = x2_$_lo;
    $x_2[1] = x2_$_hi;
    $m_s_Array$().fv(xs, 0, dest, 1, ((xs.a.length >>> 1) | 0));
    return new $c_sci_ArraySeq$ofLong(dest);
  } else {
    return $c_sci_ArraySeq.prototype.iv.call(this, elem);
  }
});
$p.Wf = (function(i) {
  var $x_1 = this.tD.a;
  var $x_2 = (i << 1);
  return $bL($x_1[$x_2], $x_1[(($x_2 + 1) | 0)]);
});
$p.kv = (function(elem) {
  return this.iv(elem);
});
$p.bv = (function(elem) {
  return this.hJ(elem);
});
$p.h9 = (function(ord) {
  return this.kV(ord);
});
$p.i = (function(v1) {
  return this.Wf((v1 | 0));
});
$p.l = (function(i) {
  return this.Wf(i);
});
$p.gY = (function() {
  return $m_s_reflect_ManifestFactory$LongManifest$();
});
$p.gd = (function() {
  return this.tD;
});
function $isArrayOf_sci_ArraySeq$ofLong(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.l2)));
}
var $d_sci_ArraySeq$ofLong = new $TypeData().i($c_sci_ArraySeq$ofLong, "scala.collection.immutable.ArraySeq$ofLong", ({
  l2: 1,
  aU: 1,
  a6: 1,
  L: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  H: 1,
  i: 1,
  h: 1,
  w: 1,
  b: 1,
  X: 1,
  I: 1,
  a2: 1,
  a7: 1,
  M: 1,
  A: 1,
  ae: 1,
  a8: 1,
  N: 1,
  z: 1,
  b1: 1,
  a: 1
}));
/** @constructor */
function $c_sci_ArraySeq$ofRef(unsafeArray) {
  this.tE = null;
  this.tE = unsafeArray;
}
$p = $c_sci_ArraySeq$ofRef.prototype = new $h_sci_ArraySeq();
$p.constructor = $c_sci_ArraySeq$ofRef;
/** @constructor */
function $h_sci_ArraySeq$ofRef() {
}
$h_sci_ArraySeq$ofRef.prototype = $p;
$p.gY = (function() {
  return $m_s_reflect_ClassTag$().y0($objectGetClass(this.tE).ba.Q());
});
$p.C = (function() {
  return this.tE.a.length;
});
$p.l = (function(i) {
  return this.tE.a[i];
});
$p.x = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.aMc(this.tE, this$1.ib);
});
$p.e = (function(that) {
  return ((that instanceof $c_sci_ArraySeq$ofRef) ? $m_s_Array$().aNO(this.tE, that.tE) : $f_sc_Seq__equals__O__Z(this, that));
});
$p.aSk = (function(ord) {
  if ((this.tE.a.length <= 1)) {
    return this;
  } else {
    var this$1 = this.tE;
    var a = this$1.ae();
    $m_ju_Arrays$().Jn(a, ord);
    return new $c_sci_ArraySeq$ofRef(a);
  }
});
$p.o = (function() {
  return $ct_sc_ArrayOps$ArrayIterator__O__(new $c_sc_ArrayOps$ArrayIterator(), this.tE);
});
$p.h9 = (function(ord) {
  return this.aSk(ord);
});
$p.kV = (function(ord) {
  return this.aSk(ord);
});
$p.i = (function(v1) {
  return this.l((v1 | 0));
});
$p.gd = (function() {
  return this.tE;
});
function $isArrayOf_sci_ArraySeq$ofRef(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.l3)));
}
var $d_sci_ArraySeq$ofRef = new $TypeData().i($c_sci_ArraySeq$ofRef, "scala.collection.immutable.ArraySeq$ofRef", ({
  l3: 1,
  aU: 1,
  a6: 1,
  L: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  H: 1,
  i: 1,
  h: 1,
  w: 1,
  b: 1,
  X: 1,
  I: 1,
  a2: 1,
  a7: 1,
  M: 1,
  A: 1,
  ae: 1,
  a8: 1,
  N: 1,
  z: 1,
  b1: 1,
  a: 1
}));
/** @constructor */
function $c_sci_ArraySeq$ofShort(unsafeArray) {
  this.tF = null;
  this.tF = unsafeArray;
}
$p = $c_sci_ArraySeq$ofShort.prototype = new $h_sci_ArraySeq();
$p.constructor = $c_sci_ArraySeq$ofShort;
/** @constructor */
function $h_sci_ArraySeq$ofShort() {
}
$h_sci_ArraySeq$ofShort.prototype = $p;
$p.C = (function() {
  return this.tF.a.length;
});
$p.Wc = (function(i) {
  return this.tF.a[i];
});
$p.x = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.aMj(this.tF, this$1.ib);
});
$p.e = (function(that) {
  return ((that instanceof $c_sci_ArraySeq$ofShort) ? $m_ju_Arrays$().aNM(this.tF, that.tF) : $f_sc_Seq__equals__O__Z(this, that));
});
$p.kV = (function(ord) {
  if ((this.tF.a.length <= 1)) {
    return this;
  } else if ((ord === $m_s_math_Ordering$Short$())) {
    var this$1 = this.tF;
    var a = this$1.ae();
    $m_ju_Arrays$().aSj(a);
    return new $c_sci_ArraySeq$ofShort(a);
  } else {
    return $c_sci_ArraySeq.prototype.kV.call(this, ord);
  }
});
$p.o = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcS$sp(this.tF);
});
$p.hJ = (function(elem) {
  if ($isShort(elem)) {
    var x2 = (elem | 0);
    var xs = this.tF;
    var this$3 = $m_s_Array$();
    var newLength = ((1 + xs.a.length) | 0);
    if ($d_S.R($objectGetClass(xs).ba.Q().ba)) {
      var dest$1 = this$3.y4(xs, newLength);
    } else {
      var dest = new $ac_S(newLength);
      $m_s_Array$().fv(xs, 0, dest, 0, xs.a.length);
      var dest$1 = dest;
    }
    $m_sr_ScalaRunTime$().kn(dest$1, xs.a.length, x2);
    return new $c_sci_ArraySeq$ofShort(dest$1);
  } else {
    return $c_sci_ArraySeq.prototype.hJ.call(this, elem);
  }
});
$p.iv = (function(elem) {
  if ($isShort(elem)) {
    var x2 = (elem | 0);
    var xs = this.tF;
    var dest = new $ac_S(((1 + xs.a.length) | 0));
    dest.a[0] = x2;
    $m_s_Array$().fv(xs, 0, dest, 1, xs.a.length);
    return new $c_sci_ArraySeq$ofShort(dest);
  } else {
    return $c_sci_ArraySeq.prototype.iv.call(this, elem);
  }
});
$p.kv = (function(elem) {
  return this.iv(elem);
});
$p.bv = (function(elem) {
  return this.hJ(elem);
});
$p.h9 = (function(ord) {
  return this.kV(ord);
});
$p.i = (function(v1) {
  return this.Wc((v1 | 0));
});
$p.l = (function(i) {
  return this.Wc(i);
});
$p.gY = (function() {
  return $m_s_reflect_ManifestFactory$ShortManifest$();
});
$p.gd = (function() {
  return this.tF;
});
function $isArrayOf_sci_ArraySeq$ofShort(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.l4)));
}
var $d_sci_ArraySeq$ofShort = new $TypeData().i($c_sci_ArraySeq$ofShort, "scala.collection.immutable.ArraySeq$ofShort", ({
  l4: 1,
  aU: 1,
  a6: 1,
  L: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  H: 1,
  i: 1,
  h: 1,
  w: 1,
  b: 1,
  X: 1,
  I: 1,
  a2: 1,
  a7: 1,
  M: 1,
  A: 1,
  ae: 1,
  a8: 1,
  N: 1,
  z: 1,
  b1: 1,
  a: 1
}));
/** @constructor */
function $c_sci_ArraySeq$ofUnit(unsafeArray) {
  this.Hw = null;
  this.Hw = unsafeArray;
}
$p = $c_sci_ArraySeq$ofUnit.prototype = new $h_sci_ArraySeq();
$p.constructor = $c_sci_ArraySeq$ofUnit;
/** @constructor */
function $h_sci_ArraySeq$ofUnit() {
}
$h_sci_ArraySeq$ofUnit.prototype = $p;
$p.C = (function() {
  return this.Hw.a.length;
});
$p.x = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.aMk(this.Hw, this$1.ib);
});
$p.e = (function(that) {
  return ((that instanceof $c_sci_ArraySeq$ofUnit) ? (this.Hw.a.length === that.Hw.a.length) : $f_sc_Seq__equals__O__Z(this, that));
});
$p.o = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcV$sp(this.Hw);
});
$p.Wg = (function(i) {
});
$p.i = (function(v1) {
  this.Wg((v1 | 0));
});
$p.l = (function(i) {
  this.Wg(i);
});
$p.gY = (function() {
  return $m_s_reflect_ManifestFactory$UnitManifest$();
});
$p.gd = (function() {
  return this.Hw;
});
function $isArrayOf_sci_ArraySeq$ofUnit(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.l5)));
}
var $d_sci_ArraySeq$ofUnit = new $TypeData().i($c_sci_ArraySeq$ofUnit, "scala.collection.immutable.ArraySeq$ofUnit", ({
  l5: 1,
  aU: 1,
  a6: 1,
  L: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  H: 1,
  i: 1,
  h: 1,
  w: 1,
  b: 1,
  X: 1,
  I: 1,
  a2: 1,
  a7: 1,
  M: 1,
  A: 1,
  ae: 1,
  a8: 1,
  N: 1,
  z: 1,
  b1: 1,
  a: 1
}));
function $p_sci_List__filterCommon__F1__Z__sci_List($thiz, p, isFlipped) {
  return $p_sci_List__noneIn$1__sci_List__F1__Z__sci_List($thiz, $thiz, p, isFlipped);
}
function $p_sci_List__loop$2__I__sci_List__I__I($thiz, i, xs, len$1) {
  while (true) {
    if ((i === len$1)) {
      return ((!xs.c()) | 0);
    } else {
      if ((!xs.c())) {
        var temp$i = ((1 + i) | 0);
        var temp$xs = xs.v();
        i = temp$i;
        xs = temp$xs;
        continue;
      }
      return (-1);
    }
  }
}
function $p_sci_List__noneIn$1__sci_List__F1__Z__sci_List($thiz, l, p$1, isFlipped$1) {
  while (true) {
    if (l.c()) {
      return $m_sci_Nil$();
    } else {
      var h = l.t();
      var t = l.v();
      if (((!(!p$1.i(h))) !== isFlipped$1)) {
        return $p_sci_List__allIn$1__sci_List__sci_List__F1__Z__sci_List($thiz, l, t, p$1, isFlipped$1);
      } else {
        l = t;
      }
    }
  }
}
function $p_sci_List__allIn$1__sci_List__sci_List__F1__Z__sci_List($thiz, start, remaining, p$1, isFlipped$1) {
  while (true) {
    if (remaining.c()) {
      return start;
    } else {
      var x = remaining.t();
      if (((!(!p$1.i(x))) !== isFlipped$1)) {
        remaining = remaining.v();
      } else {
        return $ps_sci_List__partialFill$1__sci_List__sci_List__F1__Z__sci_List(start, remaining, p$1, isFlipped$1);
      }
    }
  }
}
function $ps_sci_List__partialFill$1__sci_List__sci_List__F1__Z__sci_List(origStart, firstMiss, p$1, isFlipped$1) {
  var newHead = new $c_sci_$colon$colon(origStart.t(), $m_sci_Nil$());
  var toProcess = origStart.v();
  var currentLast = newHead;
  while ((toProcess !== firstMiss)) {
    var newElem = new $c_sci_$colon$colon(toProcess.t(), $m_sci_Nil$());
    currentLast.U = newElem;
    currentLast = newElem;
    toProcess = toProcess.v();
  }
  var next = firstMiss.v();
  var nextToCopy = next;
  while ((!next.c())) {
    var head = next.t();
    if (((!(!p$1.i(head))) !== isFlipped$1)) {
      next = next.v();
    } else {
      while ((nextToCopy !== next)) {
        var newElem$2 = new $c_sci_$colon$colon(nextToCopy.t(), $m_sci_Nil$());
        currentLast.U = newElem$2;
        currentLast = newElem$2;
        nextToCopy = nextToCopy.v();
      }
      nextToCopy = next.v();
      next = next.v();
    }
  }
  if ((!nextToCopy.c())) {
    currentLast.U = nextToCopy;
  }
  return newHead;
}
function $p_sci_List__listEq$1__sci_List__sci_List__Z($thiz, a, b) {
  while (true) {
    if ((a === b)) {
      return true;
    } else {
      var aEmpty = a.c();
      var bEmpty = b.c();
      if (((!(aEmpty || bEmpty)) && $m_sr_BoxesRunTime$().Q(a.t(), b.t()))) {
        var temp$a = a.v();
        var temp$b = b.v();
        a = temp$a;
        b = temp$b;
        continue;
      }
      return (aEmpty && bEmpty);
    }
  }
}
/** @constructor */
function $c_sci_List() {
}
$p = $c_sci_List.prototype = new $h_sci_AbstractSeq();
$p.constructor = $c_sci_List;
/** @constructor */
function $h_sci_List() {
}
$h_sci_List.prototype = $p;
$p.ko = (function(f) {
  return $f_sci_StrictOptimizedSeqOps__distinctBy__F1__O(this, f);
});
$p.h9 = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord);
});
$p.o = (function() {
  return new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this);
});
$p.bv = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__appended__O__O(this, elem);
});
$p.fa = (function(asPair) {
  return $f_sc_StrictOptimizedIterableOps__unzip__F1__T2(this, asPair);
});
$p.dk = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.Es = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this);
});
$p.fy = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__partitionMap__F1__T2(this, f);
});
$p.cn = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$p.el = (function() {
  return "LinearSeq";
});
$p.agA = (function(x) {
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x);
});
$p.l = (function(n) {
  return $f_sc_LinearSeqOps__apply__I__O(this, n);
});
$p.hO = (function(z, op) {
  return $f_sc_LinearSeqOps__foldLeft__O__F2__O(this, z, op);
});
$p.AE = (function(that) {
  return $f_sc_LinearSeqOps__sameElements__sc_IterableOnce__Z(this, that);
});
$p.px = (function(p, from) {
  return $f_sc_LinearSeqOps__indexWhere__F1__I__I(this, p, from);
});
$p.nB = (function() {
  return $m_sci_List$();
});
$p.aek = (function(prefix) {
  if (this.c()) {
    return prefix;
  } else if (prefix.c()) {
    return this;
  } else {
    var result = new $c_sci_$colon$colon(prefix.t(), this);
    var curr = result;
    var that = prefix.v();
    while ((!that.c())) {
      var temp = new $c_sci_$colon$colon(that.t(), this);
      curr.U = temp;
      curr = temp;
      that = that.v();
    }
    return result;
  }
});
$p.c = (function() {
  return (this === $m_sci_Nil$());
});
$p.Ec = (function(elem) {
  return new $c_sci_$colon$colon(elem, this);
});
$p.b6 = (function(prefix) {
  if ((prefix instanceof $c_sci_List)) {
    return this.aek(prefix);
  }
  if ((prefix.V() === 0)) {
    return this;
  }
  if ((prefix instanceof $c_scm_ListBuffer)) {
    if (this.c()) {
      return prefix.bM();
    }
  }
  var iter = prefix.o();
  if (iter.p()) {
    var result = new $c_sci_$colon$colon(iter.q(), this);
    var curr = result;
    while (iter.p()) {
      var temp = new $c_sci_$colon$colon(iter.q(), this);
      curr.U = temp;
      curr = temp;
    }
    return result;
  } else {
    return this;
  }
});
$p.hK = (function(suffix) {
  return ((suffix instanceof $c_sci_List) ? suffix.aek(this) : $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix));
});
$p.b9N = (function(n) {
  if ((this.c() || (n <= 0))) {
    return $m_sci_Nil$();
  } else {
    var h = new $c_sci_$colon$colon(this.t(), $m_sci_Nil$());
    var t = h;
    var rest = this.v();
    var i = 1;
    while (true) {
      if (rest.c()) {
        return this;
      }
      if ((i < n)) {
        i = ((1 + i) | 0);
        var nx = new $c_sci_$colon$colon(rest.t(), $m_sci_Nil$());
        t.U = nx;
        t = nx;
        rest = rest.v();
      } else {
        break;
      }
    }
    return h;
  }
});
$p.a5a = (function(index, elem) {
  var i = 0;
  var current = this;
  var prefix = new $c_scm_ListBuffer();
  while (((i < index) && (!current.c()))) {
    i = ((1 + i) | 0);
    prefix.bb(current.t());
    current = current.v();
  }
  if (((i === index) && (!current.c()))) {
    return prefix.b6M(new $c_sci_$colon$colon(elem, current.v()));
  } else {
    throw $m_scg_CommonErrors$().h2(index, ((this.C() - 1) | 0));
  }
});
$p.As = (function(f) {
  if ((this === $m_sci_Nil$())) {
    return $m_sci_Nil$();
  } else {
    var h = new $c_sci_$colon$colon(f.i(this.t()), $m_sci_Nil$());
    var t = h;
    var rest = this.v();
    while ((rest !== $m_sci_Nil$())) {
      var nx = new $c_sci_$colon$colon(f.i(rest.t()), $m_sci_Nil$());
      t.U = nx;
      t = nx;
      rest = rest.v();
    }
    return h;
  }
});
$p.Ag = (function(pf) {
  if ((this === $m_sci_Nil$())) {
    return $m_sci_Nil$();
  } else {
    var rest = this;
    var h = null;
    var x = null;
    while ((h === null)) {
      x = pf.aC(rest.t(), $m_sci_List$().V3);
      if ((x !== $m_sci_List$().V3)) {
        h = new $c_sci_$colon$colon(x, $m_sci_Nil$());
      }
      rest = rest.v();
      if ((rest === $m_sci_Nil$())) {
        return ((h === null) ? $m_sci_Nil$() : h);
      }
    }
    var t = h;
    while ((rest !== $m_sci_Nil$())) {
      x = pf.aC(rest.t(), $m_sci_List$().V3);
      if ((x !== $m_sci_List$().V3)) {
        var nx = new $c_sci_$colon$colon(x, $m_sci_Nil$());
        t.U = nx;
        t = nx;
      }
      rest = rest.v();
    }
    return h;
  }
});
$p.aOd = (function(f) {
  var rest = this;
  var h = null;
  var t = null;
  while ((rest !== $m_sci_Nil$())) {
    var it = f.i(rest.t()).o();
    while (it.p()) {
      var nx = new $c_sci_$colon$colon(it.q(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        t.U = nx;
      }
      t = nx;
    }
    rest = rest.v();
  }
  return ((h === null) ? $m_sci_Nil$() : h);
});
$p.PW = (function(p) {
  var b = new $c_scm_ListBuffer();
  var these = this;
  while (((!these.c()) && (!(!p.i(these.t()))))) {
    b.bb(these.t());
    these = these.v();
  }
  return new $c_T2(b.bM(), these);
});
$p.F = (function(f) {
  var these = this;
  while ((!these.c())) {
    f.i(these.t());
    these = these.v();
  }
});
$p.Jj = (function() {
  var result = $m_sci_Nil$();
  var these = this;
  while ((!these.c())) {
    result = new $c_sci_$colon$colon(these.t(), result);
    these = these.v();
  }
  return result;
});
$p.C = (function() {
  var these = this;
  var len = 0;
  while ((!these.c())) {
    len = ((1 + len) | 0);
    these = these.v();
  }
  return len;
});
$p.bL = (function(len) {
  return ((len < 0) ? 1 : $p_sci_List__loop$2__I__sci_List__I__I(this, 0, this, len));
});
$p.lV = (function(p) {
  var these = this;
  while ((!these.c())) {
    if ((!(!(!p.i(these.t()))))) {
      return false;
    }
    these = these.v();
  }
  return true;
});
$p.lU = (function(p) {
  var these = this;
  while ((!these.c())) {
    if ((!(!p.i(these.t())))) {
      return true;
    }
    these = these.v();
  }
  return false;
});
$p.E = (function(elem) {
  var these = this;
  while ((!these.c())) {
    if ($m_sr_BoxesRunTime$().Q(these.t(), elem)) {
      return true;
    }
    these = these.v();
  }
  return false;
});
$p.iW = (function(p) {
  var these = this;
  while ((!these.c())) {
    if ((!(!p.i(these.t())))) {
      return new $c_s_Some(these.t());
    }
    these = these.v();
  }
  return $m_s_None$();
});
$p.bJ = (function() {
  if (this.c()) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "List.last");
  } else {
    var these = this;
    var scout = this.v();
    while ((!scout.c())) {
      these = scout;
      scout = scout.v();
    }
    return these.t();
  }
});
$p.hM = (function() {
  return "List";
});
$p.ju = (function(p) {
  if (this.c()) {
    return $m_sci_List$().acG;
  } else {
    var x1 = $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
    if ((x1 !== null)) {
      if ($m_sci_Nil$().e(x1.g())) {
        return new $c_T2($m_sci_Nil$(), this);
      }
    }
    if ((x1 !== null)) {
      if ($m_sci_Nil$().e(x1.h())) {
        return new $c_T2(this, $m_sci_Nil$());
      }
    }
    return x1;
  }
});
$p.bM = (function() {
  return this;
});
$p.e = (function(o) {
  return ((o instanceof $c_sci_List) ? $p_sci_List__listEq$1__sci_List__sci_List__Z(this, this, o) : $f_sc_Seq__equals__O__Z(this, o));
});
$p.i = (function(v1) {
  return $f_sc_LinearSeqOps__apply__I__O(this, (v1 | 0));
});
$p.aM = (function(x) {
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, (x | 0));
});
$p.tW = (function(p) {
  return $p_sc_StrictOptimizedLinearSeqOps__loop$3__sc_LinearSeq__F1__sc_LinearSeq(this, this, p);
});
$p.ds = (function(n) {
  return $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(this, n, this);
});
$p.cE = (function(pred) {
  return $p_sci_List__filterCommon__F1__Z__sci_List(this, pred, true);
});
$p.bw = (function(pred) {
  return $p_sci_List__filterCommon__F1__Z__sci_List(this, pred, false);
});
$p.uj = (function(p) {
  var b = new $c_scm_ListBuffer();
  var these = this;
  while (((!these.c()) && (!(!p.i(these.t()))))) {
    b.bb(these.t());
    these = these.v();
  }
  return b.bM();
});
$p.c5 = (function(f) {
  return this.aOd(f);
});
$p.ct = (function(pf) {
  return this.Ag(pf);
});
$p.L = (function(f) {
  return this.As(f);
});
$p.Jt = (function(n) {
  return this.b9N(n);
});
$p.gU = (function(suffix) {
  return this.hK(suffix);
});
$p.kv = (function(elem) {
  return this.Ec(elem);
});
$p.cd = (function() {
  return $m_sci_List$();
});
function $isArrayOf_sci_List(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.cP)));
}
var $d_sci_List = new $TypeData().i(0, "scala.collection.immutable.List", ({
  cP: 1,
  a6: 1,
  L: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  H: 1,
  i: 1,
  h: 1,
  w: 1,
  b: 1,
  X: 1,
  I: 1,
  a2: 1,
  cN: 1,
  bF: 1,
  cH: 1,
  cO: 1,
  dE: 1,
  N: 1,
  z: 1,
  a8: 1,
  a5: 1,
  a: 1
}));
/** @constructor */
function $c_sci_VectorImpl() {
  this.a9 = null;
}
$p = $c_sci_VectorImpl.prototype = new $h_sci_Vector();
$p.constructor = $c_sci_VectorImpl;
/** @constructor */
function $h_sci_VectorImpl() {
}
$h_sci_VectorImpl.prototype = $p;
$p.pH = (function(from, until) {
  var lo = ((from > 0) ? from : 0);
  var b = this.C();
  var hi = ((until < b) ? until : b);
  return ((hi <= lo) ? $m_sci_Vector0$() : ((((hi - lo) | 0) === this.C()) ? this : this.mW(lo, hi)));
});
$p.hV = (function(from, until) {
  return this.pH(from, until);
});
/** @constructor */
function $c_scm_ArraySeq$ofBoolean(array) {
  this.A0 = null;
  this.A0 = array;
}
$p = $c_scm_ArraySeq$ofBoolean.prototype = new $h_scm_ArraySeq();
$p.constructor = $c_scm_ArraySeq$ofBoolean;
/** @constructor */
function $h_scm_ArraySeq$ofBoolean() {
}
$h_scm_ArraySeq$ofBoolean.prototype = $p;
$p.C = (function() {
  return this.A0.a.length;
});
$p.baT = (function(index, elem) {
  this.A0.a[index] = elem;
});
$p.x = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.aMl(this.A0, this$1.ib);
});
$p.e = (function(that) {
  return ((that instanceof $c_scm_ArraySeq$ofBoolean) ? $m_ju_Arrays$().aNN(this.A0, that.A0) : $c_scm_ArraySeq.prototype.e.call(this, that));
});
$p.o = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcZ$sp(this.A0);
});
$p.iU = (function(index) {
  return this.A0.a[index];
});
$p.cM = (function(index, elem) {
  this.baT(index, (!(!elem)));
});
$p.i = (function(v1) {
  return this.iU((v1 | 0));
});
$p.l = (function(i) {
  return this.iU(i);
});
$p.gY = (function() {
  return $m_s_reflect_ManifestFactory$BooleanManifest$();
});
$p.po = (function() {
  return this.A0;
});
function $isArrayOf_scm_ArraySeq$ofBoolean(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.lE)));
}
var $d_scm_ArraySeq$ofBoolean = new $TypeData().i($c_scm_ArraySeq$ofBoolean, "scala.collection.mutable.ArraySeq$ofBoolean", ({
  lE: 1,
  aW: 1,
  an: 1,
  L: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  H: 1,
  i: 1,
  h: 1,
  w: 1,
  b: 1,
  ao: 1,
  aa: 1,
  ap: 1,
  a9: 1,
  W: 1,
  au: 1,
  M: 1,
  A: 1,
  av: 1,
  N: 1,
  z: 1,
  a: 1
}));
/** @constructor */
function $c_scm_ArraySeq$ofByte(array) {
  this.A1 = null;
  this.A1 = array;
}
$p = $c_scm_ArraySeq$ofByte.prototype = new $h_scm_ArraySeq();
$p.constructor = $c_scm_ArraySeq$ofByte;
/** @constructor */
function $h_scm_ArraySeq$ofByte() {
}
$h_scm_ArraySeq$ofByte.prototype = $p;
$p.C = (function() {
  return this.A1.a.length;
});
$p.Wa = (function(index) {
  return this.A1.a[index];
});
$p.baM = (function(index, elem) {
  this.A1.a[index] = elem;
});
$p.x = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.aMd(this.A1, this$1.ib);
});
$p.e = (function(that) {
  return ((that instanceof $c_scm_ArraySeq$ofByte) ? $m_ju_Arrays$().aNL(this.A1, that.A1) : $c_scm_ArraySeq.prototype.e.call(this, that));
});
$p.o = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcB$sp(this.A1);
});
$p.cM = (function(index, elem) {
  this.baM(index, (elem | 0));
});
$p.i = (function(v1) {
  return this.Wa((v1 | 0));
});
$p.l = (function(i) {
  return this.Wa(i);
});
$p.gY = (function() {
  return $m_s_reflect_ManifestFactory$ByteManifest$();
});
$p.po = (function() {
  return this.A1;
});
function $isArrayOf_scm_ArraySeq$ofByte(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.lF)));
}
var $d_scm_ArraySeq$ofByte = new $TypeData().i($c_scm_ArraySeq$ofByte, "scala.collection.mutable.ArraySeq$ofByte", ({
  lF: 1,
  aW: 1,
  an: 1,
  L: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  H: 1,
  i: 1,
  h: 1,
  w: 1,
  b: 1,
  ao: 1,
  aa: 1,
  ap: 1,
  a9: 1,
  W: 1,
  au: 1,
  M: 1,
  A: 1,
  av: 1,
  N: 1,
  z: 1,
  a: 1
}));
/** @constructor */
function $c_scm_ArraySeq$ofChar(array) {
  this.pb = null;
  this.pb = array;
}
$p = $c_scm_ArraySeq$ofChar.prototype = new $h_scm_ArraySeq();
$p.constructor = $c_scm_ArraySeq$ofChar;
/** @constructor */
function $h_scm_ArraySeq$ofChar() {
}
$h_scm_ArraySeq$ofChar.prototype = $p;
$p.C = (function() {
  return this.pb.a.length;
});
$p.Wb = (function(index) {
  return this.pb.a[index];
});
$p.baN = (function(index, elem) {
  this.pb.a[index] = elem;
});
$p.x = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.aMe(this.pb, this$1.ib);
});
$p.e = (function(that) {
  return ((that instanceof $c_scm_ArraySeq$ofChar) ? $m_ju_Arrays$().afv(this.pb, that.pb) : $c_scm_ArraySeq.prototype.e.call(this, that));
});
$p.o = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcC$sp(this.pb);
});
$p.lf = (function(sb, start, sep, end) {
  var jsb = sb.bP;
  if ((start.length !== 0)) {
    jsb.ah = (("" + jsb.ah) + start);
  }
  var len = this.pb.a.length;
  if ((len !== 0)) {
    if ((sep === "")) {
      jsb.aM0(this.pb);
    } else {
      jsb.C();
      var c = this.pb.a[0];
      var str = ("" + $cToS(c));
      jsb.ah = (jsb.ah + str);
      var i = 1;
      while ((i < len)) {
        jsb.ah = (("" + jsb.ah) + sep);
        var c$1 = this.pb.a[i];
        var str$1 = ("" + $cToS(c$1));
        jsb.ah = (jsb.ah + str$1);
        i = ((1 + i) | 0);
      }
    }
  }
  if ((end.length !== 0)) {
    jsb.ah = (("" + jsb.ah) + end);
  }
  return sb;
});
$p.cM = (function(index, elem) {
  this.baN(index, $uC(elem));
});
$p.i = (function(v1) {
  return $bC(this.Wb((v1 | 0)));
});
$p.l = (function(i) {
  return $bC(this.Wb(i));
});
$p.gY = (function() {
  return $m_s_reflect_ManifestFactory$CharManifest$();
});
$p.po = (function() {
  return this.pb;
});
function $isArrayOf_scm_ArraySeq$ofChar(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.lG)));
}
var $d_scm_ArraySeq$ofChar = new $TypeData().i($c_scm_ArraySeq$ofChar, "scala.collection.mutable.ArraySeq$ofChar", ({
  lG: 1,
  aW: 1,
  an: 1,
  L: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  H: 1,
  i: 1,
  h: 1,
  w: 1,
  b: 1,
  ao: 1,
  aa: 1,
  ap: 1,
  a9: 1,
  W: 1,
  au: 1,
  M: 1,
  A: 1,
  av: 1,
  N: 1,
  z: 1,
  a: 1
}));
/** @constructor */
function $c_scm_ArraySeq$ofDouble(array) {
  this.qF = null;
  this.qF = array;
}
$p = $c_scm_ArraySeq$ofDouble.prototype = new $h_scm_ArraySeq();
$p.constructor = $c_scm_ArraySeq$ofDouble;
/** @constructor */
function $h_scm_ArraySeq$ofDouble() {
}
$h_scm_ArraySeq$ofDouble.prototype = $p;
$p.C = (function() {
  return this.qF.a.length;
});
$p.baO = (function(index, elem) {
  this.qF.a[index] = elem;
});
$p.x = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.aMf(this.qF, this$1.ib);
});
$p.e = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofDouble)) {
    var thatArray = that.qF;
    if ((this.qF === thatArray)) {
      return true;
    } else if ((this.qF.a.length === thatArray.a.length)) {
      var i = 0;
      while (((i < this.qF.a.length) && (this.qF.a[i] === thatArray.a[i]))) {
        i = ((1 + i) | 0);
      }
      return (i >= this.qF.a.length);
    } else {
      return false;
    }
  } else {
    return $c_scm_ArraySeq.prototype.e.call(this, that);
  }
});
$p.o = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcD$sp(this.qF);
});
$p.ID = (function(index) {
  return this.qF.a[index];
});
$p.cM = (function(index, elem) {
  this.baO(index, (+elem));
});
$p.i = (function(v1) {
  return this.ID((v1 | 0));
});
$p.l = (function(i) {
  return this.ID(i);
});
$p.gY = (function() {
  return $m_s_reflect_ManifestFactory$DoubleManifest$();
});
$p.po = (function() {
  return this.qF;
});
function $isArrayOf_scm_ArraySeq$ofDouble(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.lH)));
}
var $d_scm_ArraySeq$ofDouble = new $TypeData().i($c_scm_ArraySeq$ofDouble, "scala.collection.mutable.ArraySeq$ofDouble", ({
  lH: 1,
  aW: 1,
  an: 1,
  L: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  H: 1,
  i: 1,
  h: 1,
  w: 1,
  b: 1,
  ao: 1,
  aa: 1,
  ap: 1,
  a9: 1,
  W: 1,
  au: 1,
  M: 1,
  A: 1,
  av: 1,
  N: 1,
  z: 1,
  a: 1
}));
/** @constructor */
function $c_scm_ArraySeq$ofFloat(array) {
  this.qG = null;
  this.qG = array;
}
$p = $c_scm_ArraySeq$ofFloat.prototype = new $h_scm_ArraySeq();
$p.constructor = $c_scm_ArraySeq$ofFloat;
/** @constructor */
function $h_scm_ArraySeq$ofFloat() {
}
$h_scm_ArraySeq$ofFloat.prototype = $p;
$p.C = (function() {
  return this.qG.a.length;
});
$p.baP = (function(index, elem) {
  this.qG.a[index] = elem;
});
$p.x = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.aMg(this.qG, this$1.ib);
});
$p.e = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofFloat)) {
    var thatArray = that.qG;
    if ((this.qG === thatArray)) {
      return true;
    } else if ((this.qG.a.length === thatArray.a.length)) {
      var i = 0;
      while (((i < this.qG.a.length) && (this.qG.a[i] === thatArray.a[i]))) {
        i = ((1 + i) | 0);
      }
      return (i >= this.qG.a.length);
    } else {
      return false;
    }
  } else {
    return $c_scm_ArraySeq.prototype.e.call(this, that);
  }
});
$p.o = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcF$sp(this.qG);
});
$p.We = (function(index) {
  return this.qG.a[index];
});
$p.cM = (function(index, elem) {
  this.baP(index, Math.fround(elem));
});
$p.i = (function(v1) {
  return this.We((v1 | 0));
});
$p.l = (function(i) {
  return this.We(i);
});
$p.gY = (function() {
  return $m_s_reflect_ManifestFactory$FloatManifest$();
});
$p.po = (function() {
  return this.qG;
});
function $isArrayOf_scm_ArraySeq$ofFloat(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.lI)));
}
var $d_scm_ArraySeq$ofFloat = new $TypeData().i($c_scm_ArraySeq$ofFloat, "scala.collection.mutable.ArraySeq$ofFloat", ({
  lI: 1,
  aW: 1,
  an: 1,
  L: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  H: 1,
  i: 1,
  h: 1,
  w: 1,
  b: 1,
  ao: 1,
  aa: 1,
  ap: 1,
  a9: 1,
  W: 1,
  au: 1,
  M: 1,
  A: 1,
  av: 1,
  N: 1,
  z: 1,
  a: 1
}));
/** @constructor */
function $c_scm_ArraySeq$ofInt(array) {
  this.A2 = null;
  this.A2 = array;
}
$p = $c_scm_ArraySeq$ofInt.prototype = new $h_scm_ArraySeq();
$p.constructor = $c_scm_ArraySeq$ofInt;
/** @constructor */
function $h_scm_ArraySeq$ofInt() {
}
$h_scm_ArraySeq$ofInt.prototype = $p;
$p.C = (function() {
  return this.A2.a.length;
});
$p.baQ = (function(index, elem) {
  this.A2.a[index] = elem;
});
$p.x = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.aMh(this.A2, this$1.ib);
});
$p.e = (function(that) {
  return ((that instanceof $c_scm_ArraySeq$ofInt) ? $m_ju_Arrays$().a3h(this.A2, that.A2) : $c_scm_ArraySeq.prototype.e.call(this, that));
});
$p.o = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcI$sp(this.A2);
});
$p.DK = (function(index) {
  return this.A2.a[index];
});
$p.cM = (function(index, elem) {
  this.baQ(index, (elem | 0));
});
$p.i = (function(v1) {
  return this.DK((v1 | 0));
});
$p.l = (function(i) {
  return this.DK(i);
});
$p.gY = (function() {
  return $m_s_reflect_ManifestFactory$IntManifest$();
});
$p.po = (function() {
  return this.A2;
});
function $isArrayOf_scm_ArraySeq$ofInt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.lJ)));
}
var $d_scm_ArraySeq$ofInt = new $TypeData().i($c_scm_ArraySeq$ofInt, "scala.collection.mutable.ArraySeq$ofInt", ({
  lJ: 1,
  aW: 1,
  an: 1,
  L: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  H: 1,
  i: 1,
  h: 1,
  w: 1,
  b: 1,
  ao: 1,
  aa: 1,
  ap: 1,
  a9: 1,
  W: 1,
  au: 1,
  M: 1,
  A: 1,
  av: 1,
  N: 1,
  z: 1,
  a: 1
}));
/** @constructor */
function $c_scm_ArraySeq$ofLong(array) {
  this.A3 = null;
  this.A3 = array;
}
$p = $c_scm_ArraySeq$ofLong.prototype = new $h_scm_ArraySeq();
$p.constructor = $c_scm_ArraySeq$ofLong;
/** @constructor */
function $h_scm_ArraySeq$ofLong() {
}
$h_scm_ArraySeq$ofLong.prototype = $p;
$p.C = (function() {
  return ((this.A3.a.length >>> 1) | 0);
});
$p.baR = (function(index, elem_$_lo, elem_$_hi) {
  var $x_1 = this.A3.a;
  var $x_2 = (index << 1);
  $x_1[$x_2] = elem_$_lo;
  $x_1[(($x_2 + 1) | 0)] = elem_$_hi;
});
$p.x = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.aMi(this.A3, this$1.ib);
});
$p.e = (function(that) {
  return ((that instanceof $c_scm_ArraySeq$ofLong) ? $m_ju_Arrays$().afw(this.A3, that.A3) : $c_scm_ArraySeq.prototype.e.call(this, that));
});
$p.o = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcJ$sp(this.A3);
});
$p.Wf = (function(index) {
  var $x_1 = this.A3.a;
  var $x_2 = (index << 1);
  return $bL($x_1[$x_2], $x_1[(($x_2 + 1) | 0)]);
});
$p.cM = (function(index, elem) {
  var $x_1 = $uJ(elem);
  this.baR(index, $x_1.l, $x_1.h);
});
$p.i = (function(v1) {
  return this.Wf((v1 | 0));
});
$p.l = (function(i) {
  return this.Wf(i);
});
$p.gY = (function() {
  return $m_s_reflect_ManifestFactory$LongManifest$();
});
$p.po = (function() {
  return this.A3;
});
function $isArrayOf_scm_ArraySeq$ofLong(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.lK)));
}
var $d_scm_ArraySeq$ofLong = new $TypeData().i($c_scm_ArraySeq$ofLong, "scala.collection.mutable.ArraySeq$ofLong", ({
  lK: 1,
  aW: 1,
  an: 1,
  L: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  H: 1,
  i: 1,
  h: 1,
  w: 1,
  b: 1,
  ao: 1,
  aa: 1,
  ap: 1,
  a9: 1,
  W: 1,
  au: 1,
  M: 1,
  A: 1,
  av: 1,
  N: 1,
  z: 1,
  a: 1
}));
/** @constructor */
function $c_scm_ArraySeq$ofRef(array) {
  this.tK = null;
  this.tK = array;
}
$p = $c_scm_ArraySeq$ofRef.prototype = new $h_scm_ArraySeq();
$p.constructor = $c_scm_ArraySeq$ofRef;
/** @constructor */
function $h_scm_ArraySeq$ofRef() {
}
$h_scm_ArraySeq$ofRef.prototype = $p;
$p.gY = (function() {
  return $m_s_reflect_ClassTag$().y0($objectGetClass(this.tK).ba.Q());
});
$p.C = (function() {
  return this.tK.a.length;
});
$p.l = (function(index) {
  return this.tK.a[index];
});
$p.cM = (function(index, elem) {
  this.tK.a[index] = elem;
});
$p.x = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.aMc(this.tK, this$1.ib);
});
$p.e = (function(that) {
  return ((that instanceof $c_scm_ArraySeq$ofRef) ? $m_s_Array$().aNO(this.tK, that.tK) : $c_scm_ArraySeq.prototype.e.call(this, that));
});
$p.o = (function() {
  return $ct_sc_ArrayOps$ArrayIterator__O__(new $c_sc_ArrayOps$ArrayIterator(), this.tK);
});
$p.i = (function(v1) {
  return this.l((v1 | 0));
});
$p.po = (function() {
  return this.tK;
});
function $isArrayOf_scm_ArraySeq$ofRef(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.lL)));
}
var $d_scm_ArraySeq$ofRef = new $TypeData().i($c_scm_ArraySeq$ofRef, "scala.collection.mutable.ArraySeq$ofRef", ({
  lL: 1,
  aW: 1,
  an: 1,
  L: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  H: 1,
  i: 1,
  h: 1,
  w: 1,
  b: 1,
  ao: 1,
  aa: 1,
  ap: 1,
  a9: 1,
  W: 1,
  au: 1,
  M: 1,
  A: 1,
  av: 1,
  N: 1,
  z: 1,
  a: 1
}));
/** @constructor */
function $c_scm_ArraySeq$ofShort(array) {
  this.A4 = null;
  this.A4 = array;
}
$p = $c_scm_ArraySeq$ofShort.prototype = new $h_scm_ArraySeq();
$p.constructor = $c_scm_ArraySeq$ofShort;
/** @constructor */
function $h_scm_ArraySeq$ofShort() {
}
$h_scm_ArraySeq$ofShort.prototype = $p;
$p.C = (function() {
  return this.A4.a.length;
});
$p.Wc = (function(index) {
  return this.A4.a[index];
});
$p.baS = (function(index, elem) {
  this.A4.a[index] = elem;
});
$p.x = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.aMj(this.A4, this$1.ib);
});
$p.e = (function(that) {
  return ((that instanceof $c_scm_ArraySeq$ofShort) ? $m_ju_Arrays$().aNM(this.A4, that.A4) : $c_scm_ArraySeq.prototype.e.call(this, that));
});
$p.o = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcS$sp(this.A4);
});
$p.cM = (function(index, elem) {
  this.baS(index, (elem | 0));
});
$p.i = (function(v1) {
  return this.Wc((v1 | 0));
});
$p.l = (function(i) {
  return this.Wc(i);
});
$p.gY = (function() {
  return $m_s_reflect_ManifestFactory$ShortManifest$();
});
$p.po = (function() {
  return this.A4;
});
function $isArrayOf_scm_ArraySeq$ofShort(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.lM)));
}
var $d_scm_ArraySeq$ofShort = new $TypeData().i($c_scm_ArraySeq$ofShort, "scala.collection.mutable.ArraySeq$ofShort", ({
  lM: 1,
  aW: 1,
  an: 1,
  L: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  H: 1,
  i: 1,
  h: 1,
  w: 1,
  b: 1,
  ao: 1,
  aa: 1,
  ap: 1,
  a9: 1,
  W: 1,
  au: 1,
  M: 1,
  A: 1,
  av: 1,
  N: 1,
  z: 1,
  a: 1
}));
/** @constructor */
function $c_scm_ArraySeq$ofUnit(array) {
  this.D6 = null;
  this.D6 = array;
}
$p = $c_scm_ArraySeq$ofUnit.prototype = new $h_scm_ArraySeq();
$p.constructor = $c_scm_ArraySeq$ofUnit;
/** @constructor */
function $h_scm_ArraySeq$ofUnit() {
}
$h_scm_ArraySeq$ofUnit.prototype = $p;
$p.C = (function() {
  return this.D6.a.length;
});
$p.baU = (function(index, elem) {
  this.D6.a[index] = elem;
});
$p.x = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.aMk(this.D6, this$1.ib);
});
$p.e = (function(that) {
  return ((that instanceof $c_scm_ArraySeq$ofUnit) ? (this.D6.a.length === that.D6.a.length) : $c_scm_ArraySeq.prototype.e.call(this, that));
});
$p.o = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcV$sp(this.D6);
});
$p.Wg = (function(index) {
});
$p.cM = (function(index, elem) {
  this.baU(index, elem);
});
$p.i = (function(v1) {
  this.Wg((v1 | 0));
});
$p.l = (function(i) {
  this.Wg(i);
});
$p.gY = (function() {
  return $m_s_reflect_ManifestFactory$UnitManifest$();
});
$p.po = (function() {
  return this.D6;
});
function $isArrayOf_scm_ArraySeq$ofUnit(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.lN)));
}
var $d_scm_ArraySeq$ofUnit = new $TypeData().i($c_scm_ArraySeq$ofUnit, "scala.collection.mutable.ArraySeq$ofUnit", ({
  lN: 1,
  aW: 1,
  an: 1,
  L: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  H: 1,
  i: 1,
  h: 1,
  w: 1,
  b: 1,
  ao: 1,
  aa: 1,
  ap: 1,
  a9: 1,
  W: 1,
  au: 1,
  M: 1,
  A: 1,
  av: 1,
  N: 1,
  z: 1,
  a: 1
}));
function $p_scm_HashMap__put0__O__O__I__Z__s_Some($thiz, key, value, hash, getOld) {
  if ((((1 + $thiz.eh) | 0) >= $thiz.kI)) {
    $p_scm_HashMap__growTable__I__V($thiz, ($thiz.S.a.length << 1));
  }
  return $p_scm_HashMap__put0__O__O__Z__I__I__s_Some($thiz, key, value, getOld, hash, (hash & (($thiz.S.a.length - 1) | 0)));
}
function $p_scm_HashMap__put0__O__O__Z__s_Some($thiz, key, value, getOld) {
  if ((((1 + $thiz.eh) | 0) >= $thiz.kI)) {
    $p_scm_HashMap__growTable__I__V($thiz, ($thiz.S.a.length << 1));
  }
  var originalHash = $m_sr_Statics$().u(key);
  var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  return $p_scm_HashMap__put0__O__O__Z__I__I__s_Some($thiz, key, value, getOld, hash, (hash & (($thiz.S.a.length - 1) | 0)));
}
function $p_scm_HashMap__put0__O__O__Z__I__I__s_Some($thiz, key, value, getOld, hash, idx) {
  var x1 = $thiz.S.a[idx];
  if ((x1 === null)) {
    $thiz.S.a[idx] = new $c_scm_HashMap$Node(key, hash, value, null);
  } else {
    var prev = null;
    var n = x1;
    while (((n !== null) && (n.or <= hash))) {
      if (((n.or === hash) && $m_sr_BoxesRunTime$().Q(key, n.np))) {
        var old = n.b9;
        n.b9 = value;
        return (getOld ? new $c_s_Some(old) : null);
      }
      prev = n;
      n = n.fr;
    }
    if ((prev === null)) {
      $thiz.S.a[idx] = new $c_scm_HashMap$Node(key, hash, value, x1);
    } else {
      prev.fr = new $c_scm_HashMap$Node(key, hash, value, prev.fr);
    }
  }
  $thiz.eh = ((1 + $thiz.eh) | 0);
  return null;
}
function $p_scm_HashMap__remove0__O__scm_HashMap$Node($thiz, elem) {
  var originalHash = $m_sr_Statics$().u(elem);
  return $p_scm_HashMap__remove0__O__I__scm_HashMap$Node($thiz, elem, (originalHash ^ ((originalHash >>> 16) | 0)));
}
function $p_scm_HashMap__remove0__O__I__scm_HashMap$Node($thiz, elem, hash) {
  var idx = (hash & (($thiz.S.a.length - 1) | 0));
  var x1 = $thiz.S.a[idx];
  if ((x1 === null)) {
    return null;
  } else if (((x1.or === hash) && $m_sr_BoxesRunTime$().Q(x1.np, elem))) {
    $thiz.S.a[idx] = x1.fr;
    $thiz.eh = (($thiz.eh - 1) | 0);
    return x1;
  } else {
    var prev = x1;
    var next = x1.fr;
    while (((next !== null) && (next.or <= hash))) {
      if (((next.or === hash) && $m_sr_BoxesRunTime$().Q(next.np, elem))) {
        prev.fr = next.fr;
        $thiz.eh = (($thiz.eh - 1) | 0);
        return next;
      }
      prev = next;
      next = next.fr;
    }
    return null;
  }
}
function $p_scm_HashMap__growTable__I__V($thiz, newlen) {
  if ((newlen < 0)) {
    throw $ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), (("new HashMap table size " + newlen) + " exceeds maximum"));
  }
  var oldlen = $thiz.S.a.length;
  $thiz.kI = $p_scm_HashMap__newThreshold__I__I($thiz, newlen);
  if (($thiz.eh === 0)) {
    $thiz.S = new ($d_scm_HashMap$Node.r().C)(newlen);
  } else {
    $thiz.S = $m_ju_Arrays$().ex($thiz.S, newlen);
    var preLow = new $c_scm_HashMap$Node(null, 0, null, null);
    var preHigh = new $c_scm_HashMap$Node(null, 0, null, null);
    while ((oldlen < newlen)) {
      var i = 0;
      while ((i < oldlen)) {
        var old = $thiz.S.a[i];
        if ((old !== null)) {
          preLow.fr = null;
          preHigh.fr = null;
          var lastLow = preLow;
          var lastHigh = preHigh;
          var n = old;
          while ((n !== null)) {
            var next = n.fr;
            if (((n.or & oldlen) === 0)) {
              lastLow.fr = n;
              lastLow = n;
            } else {
              lastHigh.fr = n;
              lastHigh = n;
            }
            n = next;
          }
          lastLow.fr = null;
          if ((old !== preLow.fr)) {
            $thiz.S.a[i] = preLow.fr;
          }
          if ((preHigh.fr !== null)) {
            $thiz.S.a[((i + oldlen) | 0)] = preHigh.fr;
            lastHigh.fr = null;
          }
        }
        i = ((1 + i) | 0);
      }
      oldlen = (oldlen << 1);
    }
  }
}
function $p_scm_HashMap__tableSizeFor__I__I($thiz, capacity) {
  var x = ((capacity - 1) | 0);
  var i = ((x > 4) ? x : 4);
  var x$1 = ((((-2147483648) >> Math.clz32(i)) & i) << 1);
  return ((x$1 < 1073741824) ? x$1 : 1073741824);
}
function $p_scm_HashMap__newThreshold__I__I($thiz, size) {
  return $doubleToInt((size * $thiz.acZ));
}
function $ct_scm_HashMap__I__D__($thiz, initialCapacity, loadFactor) {
  $thiz.acZ = loadFactor;
  $thiz.S = new ($d_scm_HashMap$Node.r().C)($p_scm_HashMap__tableSizeFor__I__I($thiz, initialCapacity));
  $thiz.kI = $p_scm_HashMap__newThreshold__I__I($thiz, $thiz.S.a.length);
  $thiz.eh = 0;
  return $thiz;
}
function $ct_scm_HashMap__($thiz) {
  $ct_scm_HashMap__I__D__($thiz, 16, 0.75);
  return $thiz;
}
/** @constructor */
function $c_scm_HashMap() {
  this.acZ = 0.0;
  this.S = null;
  this.kI = 0;
  this.eh = 0;
}
$p = $c_scm_HashMap.prototype = new $h_scm_AbstractMap();
$p.constructor = $c_scm_HashMap;
/** @constructor */
function $h_scm_HashMap() {
}
$h_scm_HashMap.prototype = $p;
$p.kP = (function(f) {
  return $f_sc_StrictOptimizedMapOps__map__F1__sc_IterableOps(this, f);
});
$p.hN = (function(suffix) {
  return $f_sc_StrictOptimizedMapOps__concat__sc_IterableOnce__sc_IterableOps(this, suffix);
});
$p.fa = (function(asPair) {
  return $f_sc_StrictOptimizedIterableOps__unzip__F1__T2(this, asPair);
});
$p.L = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$p.c5 = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.ct = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.dk = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bw = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$p.cE = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true);
});
$p.fy = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__partitionMap__F1__T2(this, f);
});
$p.cn = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$p.aa = (function() {
  return this.eh;
});
$p.E = (function(key) {
  var originalHash = $m_sr_Statics$().u(key);
  var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  var x1 = this.S.a[(hash & ((this.S.a.length - 1) | 0))];
  return (((x1 === null) ? null : x1.by(key, hash)) !== null);
});
$p.f9 = (function(size) {
  var target = $p_scm_HashMap__tableSizeFor__I__I(this, $doubleToInt((((1 + size) | 0) / this.acZ)));
  if ((target > this.S.a.length)) {
    $p_scm_HashMap__growTable__I__V(this, target);
  }
});
$p.aLN = (function(xs) {
  $f_scm_Builder__sizeHint__sc_IterableOnce__I__V(this, xs, 0);
  if ((xs instanceof $c_sci_HashMap)) {
    var f = new $c_sr_AbstractFunction3_$$Lambda$d1e06cbab540de4f9f09e7182f18ea80659b9825(((k$2$2, v$2$2, h$2$2) => {
      var h$2 = (h$2$2 | 0);
      $p_scm_HashMap__put0__O__O__I__Z__s_Some(this, k$2$2, v$2$2, (h$2 ^ ((h$2 >>> 16) | 0)), false);
    }));
    xs.cP.afW(f);
    return this;
  } else if ((xs instanceof $c_scm_HashMap)) {
    var iter = xs.ah5();
    while (iter.p()) {
      var next = iter.q();
      $p_scm_HashMap__put0__O__O__I__Z__s_Some(this, next.np, next.b9, next.or, false);
    }
    return this;
  } else if ((xs instanceof $c_scm_LinkedHashMap)) {
    var iter$2 = xs.afu();
    while (iter$2.p()) {
      var entry = iter$2.q();
      $p_scm_HashMap__put0__O__O__I__Z__s_Some(this, entry.nq, entry.fs, entry.pd, false);
    }
    return this;
  } else {
    return ($is_scm_Map(xs) ? (xs.pu(new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((key$2$2, value$2$2) => {
      var originalHash = $m_sr_Statics$().u(key$2$2);
      return $p_scm_HashMap__put0__O__O__I__Z__s_Some(this, key$2$2, value$2$2, (originalHash ^ ((originalHash >>> 16) | 0)), false);
    }))), this) : $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs));
  }
});
$p.o = (function() {
  return ((this.eh === 0) ? $m_sc_Iterator$().b8 : new $c_scm_HashMap$$anon$1(this));
});
$p.lo = (function() {
  return ((this.eh === 0) ? $m_sc_Iterator$().b8 : new $c_scm_HashMap$$anon$2(this));
});
$p.hr = (function() {
  return ((this.eh === 0) ? $m_sc_Iterator$().b8 : new $c_scm_HashMap$$anon$3(this));
});
$p.ah5 = (function() {
  return ((this.eh === 0) ? $m_sc_Iterator$().b8 : new $c_scm_HashMap$$anon$4(this));
});
$p.ie = (function() {
  $m_ju_Arrays$().WM(this.S, null);
  this.eh = 0;
});
$p.r = (function(key) {
  var originalHash = $m_sr_Statics$().u(key);
  var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  var x1 = this.S.a[(hash & ((this.S.a.length - 1) | 0))];
  var x1$1 = ((x1 === null) ? null : x1.by(key, hash));
  return ((x1$1 === null) ? $m_s_None$() : new $c_s_Some(x1$1.b9));
});
$p.i = (function(key) {
  var originalHash = $m_sr_Statics$().u(key);
  var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  var x1 = this.S.a[(hash & ((this.S.a.length - 1) | 0))];
  var x1$1 = ((x1 === null) ? null : x1.by(key, hash));
  return ((x1$1 === null) ? $f_sc_MapOps__default__O__O(this, key) : x1$1.b9);
});
$p.ay = (function(key, default$1) {
  if ((!($objectGetClass(this) === $d_scm_HashMap.l()))) {
    return $f_sc_MapOps__getOrElse__O__F0__O(this, key, default$1);
  } else {
    var originalHash = $m_sr_Statics$().u(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var x1 = this.S.a[(hash & ((this.S.a.length - 1) | 0))];
    var nd = ((x1 === null) ? null : x1.by(key, hash));
    return ((nd === null) ? default$1.a3() : nd.b9);
  }
});
$p.ec = (function(key, defaultValue) {
  if ((!($objectGetClass(this) === $d_scm_HashMap.l()))) {
    return $f_scm_MapOps__getOrElseUpdate__O__F0__O(this, key, defaultValue);
  } else {
    var originalHash = $m_sr_Statics$().u(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var idx = (hash & ((this.S.a.length - 1) | 0));
    var x1 = this.S.a[idx];
    var nd = ((x1 === null) ? null : x1.by(key, hash));
    if ((nd !== null)) {
      return nd.b9;
    } else {
      var table0 = this.S;
      var default$1 = defaultValue.a3();
      if ((((1 + this.eh) | 0) >= this.kI)) {
        $p_scm_HashMap__growTable__I__V(this, (this.S.a.length << 1));
      }
      $p_scm_HashMap__put0__O__O__Z__I__I__s_Some(this, key, default$1, false, hash, ((table0 === this.S) ? idx : (hash & ((this.S.a.length - 1) | 0))));
      return default$1;
    }
  }
});
$p.ue = (function(key, value) {
  var x1 = $p_scm_HashMap__put0__O__O__Z__s_Some(this, key, value, true);
  return ((x1 === null) ? $m_s_None$() : x1);
});
$p.AD = (function(key) {
  var x1 = $p_scm_HashMap__remove0__O__scm_HashMap$Node(this, key);
  return ((x1 === null) ? $m_s_None$() : new $c_s_Some(x1.b9));
});
$p.cY = (function(key, value) {
  $p_scm_HashMap__put0__O__O__Z__s_Some(this, key, value, false);
});
$p.aWL = (function(elem) {
  $p_scm_HashMap__put0__O__O__Z__s_Some(this, elem.g(), elem.h(), false);
  return this;
});
$p.b9p = (function(elem) {
  $p_scm_HashMap__remove0__O__scm_HashMap$Node(this, elem);
  return this;
});
$p.V = (function() {
  return this.eh;
});
$p.c = (function() {
  return (this.eh === 0);
});
$p.F = (function(f) {
  var len = this.S.a.length;
  var i = 0;
  while ((i < len)) {
    var n = this.S.a[i];
    if ((n !== null)) {
      n.F(f);
    }
    i = ((1 + i) | 0);
  }
});
$p.pu = (function(f) {
  var len = this.S.a.length;
  var i = 0;
  while ((i < len)) {
    var n = this.S.a[i];
    if ((n !== null)) {
      n.pu(f);
    }
    i = ((1 + i) | 0);
  }
});
$p.b1f = (function(p) {
  if ((!this.c())) {
    var bucket = 0;
    while ((bucket < this.S.a.length)) {
      var head = this.S.a[bucket];
      while (((head !== null) && (!(!(!p.R(head.np, head.b9)))))) {
        head = head.fr;
        this.eh = ((this.eh - 1) | 0);
      }
      if ((head !== null)) {
        var prev = head;
        var next = head.fr;
        while ((next !== null)) {
          if ((!(!p.R(next.np, next.b9)))) {
            prev = next;
          } else {
            prev.fr = next.fr;
            this.eh = ((this.eh - 1) | 0);
          }
          next = next.fr;
        }
      }
      this.S.a[bucket] = head;
      bucket = ((1 + bucket) | 0);
    }
  }
  return this;
});
$p.im = (function() {
  return $m_scm_HashMap$();
});
$p.el = (function() {
  return "HashMap";
});
$p.x = (function() {
  if (this.c()) {
    return $m_s_util_hashing_MurmurHash3$().Vx;
  } else {
    var tupleHashIterator = new $c_scm_HashMap$$anon$5(this);
    return $m_s_util_hashing_MurmurHash3$().Em(tupleHashIterator, $m_s_util_hashing_MurmurHash3$().xL);
  }
});
$p.afM = (function(p) {
  return this.b1f(p);
});
$p.re = (function(elem) {
  return this.b9p(elem);
});
$p.Y = (function(elem) {
  return this.aWL(elem);
});
$p.dG = (function(elems) {
  return this.aLN(elems);
});
function $isArrayOf_scm_HashMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.lO)));
}
var $d_scm_HashMap = new $TypeData().i($c_scm_HashMap, "scala.collection.mutable.HashMap", ({
  lO: 1,
  cR: 1,
  aL: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  as: 1,
  ak: 1,
  i: 1,
  h: 1,
  aF: 1,
  b: 1,
  bt: 1,
  aa: 1,
  c6: 1,
  a9: 1,
  W: 1,
  Y: 1,
  T: 1,
  S: 1,
  aM: 1,
  z: 1,
  c0: 1,
  a: 1
}));
function $ct_sci_BigVector__AO__AO__I__($thiz, _prefix1, suffix1, length0) {
  $thiz.al = suffix1;
  $thiz.at = length0;
  $ct_sci_Vector__AO__($thiz, _prefix1);
  return $thiz;
}
/** @constructor */
function $c_sci_BigVector() {
  this.a9 = null;
  this.al = null;
  this.at = 0;
}
$p = $c_sci_BigVector.prototype = new $h_sci_VectorImpl();
$p.constructor = $c_sci_BigVector;
/** @constructor */
function $h_sci_BigVector() {
}
$h_sci_BigVector.prototype = $p;
$p.aOi = (function(f) {
  var c = this.um();
  var i = 1;
  while ((i < c)) {
    var $x_1 = $m_sci_VectorStatics$();
    var idx = i;
    var c$1 = (((c + ((c >>> 31) | 0)) | 0) >> 1);
    var a = ((idx - c$1) | 0);
    var sign = (a >> 31);
    $x_1.a3r(((((((1 + c$1) | 0) - (((a ^ sign) - sign) | 0)) | 0) - 1) | 0), this.wn(i), f);
    i = ((1 + i) | 0);
  }
});
function $isArrayOf_sci_BigVector(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.br)));
}
/** @constructor */
function $c_sci_Vector1(_data1) {
  this.a9 = null;
  $ct_sci_Vector__AO__(this, _data1);
}
$p = $c_sci_Vector1.prototype = new $h_sci_VectorImpl();
$p.constructor = $c_sci_Vector1;
/** @constructor */
function $h_sci_Vector1() {
}
$h_sci_Vector1.prototype = $p;
$p.l = (function(index) {
  if (((index >= 0) && (index < this.a9.a.length))) {
    return this.a9.a[index];
  } else {
    throw this.ks(index);
  }
});
$p.nI = (function(index, elem) {
  if (((index >= 0) && (index < this.a9.a.length))) {
    var a1 = this.a9;
    var a1c = a1.ae();
    a1c.a[index] = elem;
    return new $c_sci_Vector1(a1c);
  } else {
    throw this.ks(index);
  }
});
$p.lg = (function(elem) {
  if ((this.a9.a.length < 32)) {
    return new $c_sci_Vector1($m_sci_VectorStatics$().Pc(this.a9, elem));
  } else {
    var $x_2 = this.a9;
    var $x_1 = $m_sci_VectorStatics$().eg;
    var a = new $ac_O(1);
    a.a[0] = elem;
    return new $c_sci_Vector2($x_2, 32, $x_1, a, 33);
  }
});
$p.mV = (function(elem) {
  var len1 = this.a9.a.length;
  if ((len1 < 32)) {
    return new $c_sci_Vector1($m_sci_VectorStatics$().Pd(elem, this.a9));
  } else {
    var a = new $ac_O(1);
    a.a[0] = elem;
    return new $c_sci_Vector2(a, 1, $m_sci_VectorStatics$().eg, this.a9, ((1 + len1) | 0));
  }
});
$p.w9 = (function(f) {
  return new $c_sci_Vector1($m_sci_VectorStatics$().ub(this.a9, f));
});
$p.mW = (function(lo, hi) {
  return new $c_sci_Vector1($m_ju_Arrays$().d7(this.a9, lo, hi));
});
$p.mX = (function() {
  if ((this.a9.a.length === 1)) {
    return $m_sci_Vector0$();
  } else {
    var a = this.a9;
    return new $c_sci_Vector1($m_ju_Arrays$().d7(a, 1, a.a.length));
  }
});
$p.r0 = (function() {
  if ((this.a9.a.length === 1)) {
    return $m_sci_Vector0$();
  } else {
    var a = this.a9;
    return new $c_sci_Vector1($m_ju_Arrays$().d7(a, 0, ((a.a.length - 1) | 0)));
  }
});
$p.um = (function() {
  return 1;
});
$p.wn = (function(idx) {
  return this.a9;
});
$p.pn = (function(suffix, k) {
  var data1b = $m_sci_VectorStatics$().OX(this.a9, suffix);
  return ((data1b !== null) ? new $c_sci_Vector1(data1b) : $c_sci_Vector.prototype.pn.call(this, suffix, k));
});
$p.lX = (function() {
  return this.r0();
});
$p.v = (function() {
  return this.mX();
});
$p.L = (function(f) {
  return this.w9(f);
});
$p.kv = (function(elem) {
  return this.mV(elem);
});
$p.bv = (function(elem) {
  return this.lg(elem);
});
$p.i = (function(v1) {
  var index = (v1 | 0);
  if (((index >= 0) && (index < this.a9.a.length))) {
    return this.a9.a[index];
  } else {
    throw this.ks(index);
  }
});
function $isArrayOf_sci_Vector1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.lt)));
}
var $d_sci_Vector1 = new $TypeData().i($c_sci_Vector1, "scala.collection.immutable.Vector1", ({
  lt: 1,
  bs: 1,
  bd: 1,
  a6: 1,
  L: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  H: 1,
  i: 1,
  h: 1,
  w: 1,
  b: 1,
  X: 1,
  I: 1,
  a2: 1,
  a7: 1,
  M: 1,
  A: 1,
  ae: 1,
  a8: 1,
  N: 1,
  z: 1,
  a5: 1,
  a: 1
}));
/** @constructor */
function $c_sci_$colon$colon(head, next) {
  this.er = null;
  this.U = null;
  this.er = head;
  this.U = next;
}
$p = $c_sci_$colon$colon.prototype = new $h_sci_List();
$p.constructor = $c_sci_$colon$colon;
/** @constructor */
function $h_sci_$colon$colon() {
}
$h_sci_$colon$colon.prototype = $p;
$p.t = (function() {
  return this.er;
});
$p.B = (function() {
  return "::";
});
$p.z = (function() {
  return 2;
});
$p.A = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.er;
      break;
    }
    case 1: {
      return this.U;
      break;
    }
    default: {
      return $m_sr_Statics$().ey(x$1);
    }
  }
});
$p.H = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$p.D = (function(x$1) {
  switch (x$1) {
    case 0: {
      return "head";
      break;
    }
    case 1: {
      return "next";
      break;
    }
    default: {
      return $m_sr_Statics$().ey(x$1);
    }
  }
});
$p.v = (function() {
  return this.U;
});
$p.dt = (function() {
  return new $c_s_Some(this.er);
});
function $isArrayOf_sci_$colon$colon(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kV)));
}
var $d_sci_$colon$colon = new $TypeData().i($c_sci_$colon$colon, "scala.collection.immutable.$colon$colon", ({
  kV: 1,
  cP: 1,
  a6: 1,
  L: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  H: 1,
  i: 1,
  h: 1,
  w: 1,
  b: 1,
  X: 1,
  I: 1,
  a2: 1,
  cN: 1,
  bF: 1,
  cH: 1,
  cO: 1,
  dE: 1,
  N: 1,
  z: 1,
  a8: 1,
  a5: 1,
  a: 1,
  c: 1
}));
/** @constructor */
function $c_sci_Nil$() {
  this.aIn = null;
  $n_sci_Nil$ = this;
  this.aIn = new $c_T2(this, this);
}
$p = $c_sci_Nil$.prototype = new $h_sci_List();
$p.constructor = $c_sci_Nil$;
/** @constructor */
function $h_sci_Nil$() {
}
$h_sci_Nil$.prototype = $p;
$p.D = (function(n) {
  return $f_s_Product__productElementName__I__T(this, n);
});
$p.b2x = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "head of empty list");
});
$p.b9F = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "tail of empty list");
});
$p.b3Z = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "last of empty list");
});
$p.b2N = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "init of empty list");
});
$p.V = (function() {
  return 0;
});
$p.o = (function() {
  return $m_sc_Iterator$().b8;
});
$p.fa = (function(asPair) {
  return this.aIn;
});
$p.B = (function() {
  return "Nil";
});
$p.z = (function() {
  return 0;
});
$p.A = (function(x$1) {
  return $m_sr_Statics$().ey(x$1);
});
$p.H = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$p.lX = (function() {
  this.b2N();
});
$p.bJ = (function() {
  this.b3Z();
});
$p.v = (function() {
  this.b9F();
});
$p.dt = (function() {
  return $m_s_None$();
});
$p.t = (function() {
  this.b2x();
});
var $d_sci_Nil$ = new $TypeData().i($c_sci_Nil$, "scala.collection.immutable.Nil$", ({
  IO: 1,
  cP: 1,
  a6: 1,
  L: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  H: 1,
  i: 1,
  h: 1,
  w: 1,
  b: 1,
  X: 1,
  I: 1,
  a2: 1,
  cN: 1,
  bF: 1,
  cH: 1,
  cO: 1,
  dE: 1,
  N: 1,
  z: 1,
  a8: 1,
  a5: 1,
  a: 1,
  c: 1
}));
var $n_sci_Nil$;
function $m_sci_Nil$() {
  if ((!$n_sci_Nil$)) {
    $n_sci_Nil$ = new $c_sci_Nil$();
  }
  return $n_sci_Nil$;
}
/** @constructor */
function $c_sci_Vector0$() {
  this.a9 = null;
  this.al = null;
  this.at = 0;
  $ct_sci_BigVector__AO__AO__I__(this, $m_sci_VectorStatics$().acS, $m_sci_VectorStatics$().acS, 0);
}
$p = $c_sci_Vector0$.prototype = new $h_sci_BigVector();
$p.constructor = $c_sci_Vector0$;
/** @constructor */
function $h_sci_Vector0$() {
}
$h_sci_Vector0$.prototype = $p;
$p.aM5 = (function(index) {
  throw this.ks(index);
});
$p.nI = (function(index, elem) {
  throw this.ks(index);
});
$p.lg = (function(elem) {
  var a = new $ac_O(1);
  a.a[0] = elem;
  return new $c_sci_Vector1(a);
});
$p.mV = (function(elem) {
  var a = new $ac_O(1);
  a.a[0] = elem;
  return new $c_sci_Vector1(a);
});
$p.mX = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.tail");
});
$p.r0 = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.init");
});
$p.mW = (function(lo, hi) {
  return this;
});
$p.um = (function() {
  return 0;
});
$p.wn = (function(idx) {
  return null;
});
$p.e = (function(o) {
  return ((this === o) || ((!(o instanceof $c_sci_Vector)) && $f_sc_Seq__equals__O__Z(this, o)));
});
$p.pn = (function(suffix, k) {
  return $m_sci_Vector$().X(suffix);
});
$p.ks = (function(index) {
  return $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (index + " is out of bounds (empty vector)"));
});
$p.lX = (function() {
  return this.r0();
});
$p.v = (function() {
  return this.mX();
});
$p.L = (function(f) {
  return this;
});
$p.kv = (function(elem) {
  return this.mV(elem);
});
$p.bv = (function(elem) {
  return this.lg(elem);
});
$p.i = (function(v1) {
  this.aM5((v1 | 0));
});
$p.l = (function(i) {
  this.aM5(i);
});
var $d_sci_Vector0$ = new $TypeData().i($c_sci_Vector0$, "scala.collection.immutable.Vector0$", ({
  Jm: 1,
  br: 1,
  bs: 1,
  bd: 1,
  a6: 1,
  L: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  H: 1,
  i: 1,
  h: 1,
  w: 1,
  b: 1,
  X: 1,
  I: 1,
  a2: 1,
  a7: 1,
  M: 1,
  A: 1,
  ae: 1,
  a8: 1,
  N: 1,
  z: 1,
  a5: 1,
  a: 1
}));
var $n_sci_Vector0$;
function $m_sci_Vector0$() {
  if ((!$n_sci_Vector0$)) {
    $n_sci_Vector0$ = new $c_sci_Vector0$();
  }
  return $n_sci_Vector0$;
}
/** @constructor */
function $c_sci_Vector2(_prefix1, len1, data2, _suffix1, _length0) {
  this.a9 = null;
  this.al = null;
  this.at = 0;
  this.jO = 0;
  this.iF = null;
  this.jO = len1;
  this.iF = data2;
  $ct_sci_BigVector__AO__AO__I__(this, _prefix1, _suffix1, _length0);
}
$p = $c_sci_Vector2.prototype = new $h_sci_BigVector();
$p.constructor = $c_sci_Vector2;
/** @constructor */
function $h_sci_Vector2() {
}
$h_sci_Vector2.prototype = $p;
$p.l = (function(index) {
  if (((index >= 0) && (index < this.at))) {
    var io = ((index - this.jO) | 0);
    if ((io >= 0)) {
      var i2 = ((io >>> 5) | 0);
      var i1 = (31 & io);
      return ((i2 < this.iF.a.length) ? this.iF.a[i2].a[i1] : this.al.a[(31 & io)]);
    } else {
      return this.a9.a[index];
    }
  } else {
    throw this.ks(index);
  }
});
$p.nI = (function(index, elem) {
  if (((index >= 0) && (index < this.at))) {
    if ((index >= this.jO)) {
      var io = ((index - this.jO) | 0);
      var i2 = ((io >>> 5) | 0);
      var i1 = (31 & io);
      if ((i2 < this.iF.a.length)) {
        var a2 = this.iF;
        var a2c = a2.ae();
        var a1 = a2c.a[i2];
        var a1c = a1.ae();
        a1c.a[i1] = elem;
        a2c.a[i2] = a1c;
        return new $c_sci_Vector2(this.a9, this.jO, a2c, this.al, this.at);
      } else {
        var a1$1 = this.al;
        var a1c$1 = a1$1.ae();
        a1c$1.a[i1] = elem;
        return new $c_sci_Vector2(this.a9, this.jO, this.iF, a1c$1, this.at);
      }
    } else {
      var a1$2 = this.a9;
      var a1c$2 = a1$2.ae();
      a1c$2.a[index] = elem;
      return new $c_sci_Vector2(a1c$2, this.jO, this.iF, this.al, this.at);
    }
  } else {
    throw this.ks(index);
  }
});
$p.lg = (function(elem) {
  if ((this.al.a.length < 32)) {
    var x$1 = $m_sci_VectorStatics$().Pc(this.al, elem);
    var x$2 = ((1 + this.at) | 0);
    return new $c_sci_Vector2(this.a9, this.jO, this.iF, x$1, x$2);
  } else if ((this.iF.a.length < 30)) {
    var x$6 = $m_sci_VectorStatics$().dO(this.iF, this.al);
    var a = new $ac_O(1);
    a.a[0] = elem;
    var x$8 = ((1 + this.at) | 0);
    return new $c_sci_Vector2(this.a9, this.jO, x$6, a, x$8);
  } else {
    var $x_5 = this.a9;
    var $x_4 = this.jO;
    var $x_3 = this.iF;
    var $x_2 = this.jO;
    var $x_1 = $m_sci_VectorStatics$().hz;
    var x = this.al;
    var a$1 = new ($d_O.r().r().C)(1);
    a$1.a[0] = x;
    var a$2 = new $ac_O(1);
    a$2.a[0] = elem;
    return new $c_sci_Vector3($x_5, $x_4, $x_3, ((960 + $x_2) | 0), $x_1, a$1, a$2, ((1 + this.at) | 0));
  }
});
$p.mV = (function(elem) {
  if ((this.jO < 32)) {
    var x$1 = $m_sci_VectorStatics$().Pd(elem, this.a9);
    var x$2 = ((1 + this.jO) | 0);
    var x$3 = ((1 + this.at) | 0);
    return new $c_sci_Vector2(x$1, x$2, this.iF, this.al, x$3);
  } else if ((this.iF.a.length < 30)) {
    var a = new $ac_O(1);
    a.a[0] = elem;
    var x$8 = $m_sci_VectorStatics$().cQ(this.a9, this.iF);
    var x$9 = ((1 + this.at) | 0);
    return new $c_sci_Vector2(a, 1, x$8, this.al, x$9);
  } else {
    var a$1 = new $ac_O(1);
    a$1.a[0] = elem;
    var x = this.a9;
    var a$2 = new ($d_O.r().r().C)(1);
    a$2.a[0] = x;
    return new $c_sci_Vector3(a$1, 1, a$2, ((1 + this.jO) | 0), $m_sci_VectorStatics$().hz, this.iF, this.al, ((1 + this.at) | 0));
  }
});
$p.w9 = (function(f) {
  var x$1 = $m_sci_VectorStatics$().ub(this.a9, f);
  var x$2 = $m_sci_VectorStatics$().ho(2, this.iF, f);
  var x$3 = $m_sci_VectorStatics$().ub(this.al, f);
  return new $c_sci_Vector2(x$1, this.jO, x$2, x$3, this.at);
});
$p.mW = (function(lo, hi) {
  var b = new $c_sci_VectorSliceBuilder(lo, hi);
  b.eT(1, this.a9);
  b.eT(2, this.iF);
  b.eT(1, this.al);
  return b.bY();
});
$p.mX = (function() {
  if ((this.jO > 1)) {
    var a = this.a9;
    var x$1 = $m_ju_Arrays$().d7(a, 1, a.a.length);
    var x$2 = ((this.jO - 1) | 0);
    var x$3 = ((this.at - 1) | 0);
    return new $c_sci_Vector2(x$1, x$2, this.iF, this.al, x$3);
  } else {
    return this.mW(1, this.at);
  }
});
$p.r0 = (function() {
  if ((this.al.a.length > 1)) {
    var a = this.al;
    var x$1 = $m_ju_Arrays$().d7(a, 0, ((a.a.length - 1) | 0));
    var x$2 = ((this.at - 1) | 0);
    return new $c_sci_Vector2(this.a9, this.jO, this.iF, x$1, x$2);
  } else {
    return this.mW(0, ((this.at - 1) | 0));
  }
});
$p.um = (function() {
  return 3;
});
$p.wn = (function(idx) {
  switch (idx) {
    case 0: {
      return this.a9;
      break;
    }
    case 1: {
      return this.iF;
      break;
    }
    case 2: {
      return this.al;
      break;
    }
    default: {
      throw new $c_s_MatchError(idx);
    }
  }
});
$p.pn = (function(suffix, k) {
  var suffix1b = $m_sci_VectorStatics$().OX(this.al, suffix);
  if ((suffix1b !== null)) {
    var x$2 = ((((this.at - this.al.a.length) | 0) + suffix1b.a.length) | 0);
    return new $c_sci_Vector2(this.a9, this.jO, this.iF, suffix1b, x$2);
  } else {
    return $c_sci_Vector.prototype.pn.call(this, suffix, k);
  }
});
$p.lX = (function() {
  return this.r0();
});
$p.v = (function() {
  return this.mX();
});
$p.L = (function(f) {
  return this.w9(f);
});
$p.kv = (function(elem) {
  return this.mV(elem);
});
$p.bv = (function(elem) {
  return this.lg(elem);
});
$p.i = (function(v1) {
  var index = (v1 | 0);
  if (((index >= 0) && (index < this.at))) {
    var io = ((index - this.jO) | 0);
    if ((io >= 0)) {
      var i2 = ((io >>> 5) | 0);
      var i1 = (31 & io);
      return ((i2 < this.iF.a.length) ? this.iF.a[i2].a[i1] : this.al.a[(31 & io)]);
    } else {
      return this.a9.a[index];
    }
  } else {
    throw this.ks(index);
  }
});
function $isArrayOf_sci_Vector2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.lu)));
}
var $d_sci_Vector2 = new $TypeData().i($c_sci_Vector2, "scala.collection.immutable.Vector2", ({
  lu: 1,
  br: 1,
  bs: 1,
  bd: 1,
  a6: 1,
  L: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  H: 1,
  i: 1,
  h: 1,
  w: 1,
  b: 1,
  X: 1,
  I: 1,
  a2: 1,
  a7: 1,
  M: 1,
  A: 1,
  ae: 1,
  a8: 1,
  N: 1,
  z: 1,
  a5: 1,
  a: 1
}));
/** @constructor */
function $c_sci_Vector3(_prefix1, len1, prefix2, len12, data3, suffix2, _suffix1, _length0) {
  this.a9 = null;
  this.al = null;
  this.at = 0;
  this.je = 0;
  this.jf = null;
  this.i5 = 0;
  this.gM = null;
  this.hi = null;
  this.je = len1;
  this.jf = prefix2;
  this.i5 = len12;
  this.gM = data3;
  this.hi = suffix2;
  $ct_sci_BigVector__AO__AO__I__(this, _prefix1, _suffix1, _length0);
}
$p = $c_sci_Vector3.prototype = new $h_sci_BigVector();
$p.constructor = $c_sci_Vector3;
/** @constructor */
function $h_sci_Vector3() {
}
$h_sci_Vector3.prototype = $p;
$p.l = (function(index) {
  if (((index >= 0) && (index < this.at))) {
    var io = ((index - this.i5) | 0);
    if ((io >= 0)) {
      var i3 = ((io >>> 10) | 0);
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i3 < this.gM.a.length) ? this.gM.a[i3].a[i2].a[i1] : ((i2 < this.hi.a.length) ? this.hi.a[i2].a[i1] : this.al.a[i1]));
    } else if ((index >= this.je)) {
      var io$2 = ((index - this.je) | 0);
      return this.jf.a[((io$2 >>> 5) | 0)].a[(31 & io$2)];
    } else {
      return this.a9.a[index];
    }
  } else {
    throw this.ks(index);
  }
});
$p.nI = (function(index, elem) {
  if (((index >= 0) && (index < this.at))) {
    if ((index >= this.i5)) {
      var io = ((index - this.i5) | 0);
      var i3 = ((io >>> 10) | 0);
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      if ((i3 < this.gM.a.length)) {
        var a3 = this.gM;
        var a3c = a3.ae();
        var a2 = a3c.a[i3];
        var a2c = a2.ae();
        var a1 = a2c.a[i2];
        var a1c = a1.ae();
        a1c.a[i1] = elem;
        a2c.a[i2] = a1c;
        a3c.a[i3] = a2c;
        return new $c_sci_Vector3(this.a9, this.je, this.jf, this.i5, a3c, this.hi, this.al, this.at);
      } else if ((i2 < this.hi.a.length)) {
        var a2$1 = this.hi;
        var a2c$1 = a2$1.ae();
        var a1$1 = a2c$1.a[i2];
        var a1c$1 = a1$1.ae();
        a1c$1.a[i1] = elem;
        a2c$1.a[i2] = a1c$1;
        return new $c_sci_Vector3(this.a9, this.je, this.jf, this.i5, this.gM, a2c$1, this.al, this.at);
      } else {
        var a1$2 = this.al;
        var a1c$2 = a1$2.ae();
        a1c$2.a[i1] = elem;
        return new $c_sci_Vector3(this.a9, this.je, this.jf, this.i5, this.gM, this.hi, a1c$2, this.at);
      }
    } else if ((index >= this.je)) {
      var io$2 = ((index - this.je) | 0);
      var a2$2 = this.jf;
      var idx2 = ((io$2 >>> 5) | 0);
      var idx1 = (31 & io$2);
      var a2c$2 = a2$2.ae();
      var a1$3 = a2c$2.a[idx2];
      var a1c$3 = a1$3.ae();
      a1c$3.a[idx1] = elem;
      a2c$2.a[idx2] = a1c$3;
      return new $c_sci_Vector3(this.a9, this.je, a2c$2, this.i5, this.gM, this.hi, this.al, this.at);
    } else {
      var a1$4 = this.a9;
      var a1c$4 = a1$4.ae();
      a1c$4.a[index] = elem;
      return new $c_sci_Vector3(a1c$4, this.je, this.jf, this.i5, this.gM, this.hi, this.al, this.at);
    }
  } else {
    throw this.ks(index);
  }
});
$p.lg = (function(elem) {
  if ((this.al.a.length < 32)) {
    var x$1 = $m_sci_VectorStatics$().Pc(this.al, elem);
    var x$2 = ((1 + this.at) | 0);
    return new $c_sci_Vector3(this.a9, this.je, this.jf, this.i5, this.gM, this.hi, x$1, x$2);
  } else if ((this.hi.a.length < 31)) {
    var x$9 = $m_sci_VectorStatics$().dO(this.hi, this.al);
    var a = new $ac_O(1);
    a.a[0] = elem;
    var x$11 = ((1 + this.at) | 0);
    return new $c_sci_Vector3(this.a9, this.je, this.jf, this.i5, this.gM, x$9, a, x$11);
  } else if ((this.gM.a.length < 30)) {
    var x$17 = $m_sci_VectorStatics$().dO(this.gM, $m_sci_VectorStatics$().dO(this.hi, this.al));
    var x$18 = $m_sci_VectorStatics$().eg;
    var a$1 = new $ac_O(1);
    a$1.a[0] = elem;
    var x$20 = ((1 + this.at) | 0);
    return new $c_sci_Vector3(this.a9, this.je, this.jf, this.i5, x$17, x$18, a$1, x$20);
  } else {
    var $x_8 = this.a9;
    var $x_7 = this.je;
    var $x_6 = this.jf;
    var $x_5 = this.i5;
    var $x_4 = this.gM;
    var $x_3 = this.i5;
    var $x_2 = $m_sci_VectorStatics$().nn;
    var x = $m_sci_VectorStatics$().dO(this.hi, this.al);
    var a$2 = new ($d_O.r().r().r().C)(1);
    a$2.a[0] = x;
    var $x_1 = $m_sci_VectorStatics$().eg;
    var a$3 = new $ac_O(1);
    a$3.a[0] = elem;
    return new $c_sci_Vector4($x_8, $x_7, $x_6, $x_5, $x_4, ((30720 + $x_3) | 0), $x_2, a$2, $x_1, a$3, ((1 + this.at) | 0));
  }
});
$p.mV = (function(elem) {
  if ((this.je < 32)) {
    var x$1 = $m_sci_VectorStatics$().Pd(elem, this.a9);
    var x$2 = ((1 + this.je) | 0);
    var x$3 = ((1 + this.i5) | 0);
    var x$4 = ((1 + this.at) | 0);
    return new $c_sci_Vector3(x$1, x$2, this.jf, x$3, this.gM, this.hi, this.al, x$4);
  } else if ((this.i5 < 1024)) {
    var a = new $ac_O(1);
    a.a[0] = elem;
    var x$11 = $m_sci_VectorStatics$().cQ(this.a9, this.jf);
    var x$12 = ((1 + this.i5) | 0);
    var x$13 = ((1 + this.at) | 0);
    return new $c_sci_Vector3(a, 1, x$11, x$12, this.gM, this.hi, this.al, x$13);
  } else if ((this.gM.a.length < 30)) {
    var a$1 = new $ac_O(1);
    a$1.a[0] = elem;
    var x$19 = $m_sci_VectorStatics$().eg;
    var x$21 = $m_sci_VectorStatics$().cQ($m_sci_VectorStatics$().cQ(this.a9, this.jf), this.gM);
    var x$22 = ((1 + this.at) | 0);
    return new $c_sci_Vector3(a$1, 1, x$19, 1, x$21, this.hi, this.al, x$22);
  } else {
    var a$2 = new $ac_O(1);
    a$2.a[0] = elem;
    var $x_1 = $m_sci_VectorStatics$().eg;
    var x = $m_sci_VectorStatics$().cQ(this.a9, this.jf);
    var a$3 = new ($d_O.r().r().r().C)(1);
    a$3.a[0] = x;
    return new $c_sci_Vector4(a$2, 1, $x_1, 1, a$3, ((1 + this.i5) | 0), $m_sci_VectorStatics$().nn, this.gM, this.hi, this.al, ((1 + this.at) | 0));
  }
});
$p.w9 = (function(f) {
  var x$1 = $m_sci_VectorStatics$().ub(this.a9, f);
  var x$2 = $m_sci_VectorStatics$().ho(2, this.jf, f);
  var x$3 = $m_sci_VectorStatics$().ho(3, this.gM, f);
  var x$4 = $m_sci_VectorStatics$().ho(2, this.hi, f);
  var x$5 = $m_sci_VectorStatics$().ub(this.al, f);
  return new $c_sci_Vector3(x$1, this.je, x$2, this.i5, x$3, x$4, x$5, this.at);
});
$p.mW = (function(lo, hi) {
  var b = new $c_sci_VectorSliceBuilder(lo, hi);
  b.eT(1, this.a9);
  b.eT(2, this.jf);
  b.eT(3, this.gM);
  b.eT(2, this.hi);
  b.eT(1, this.al);
  return b.bY();
});
$p.mX = (function() {
  if ((this.je > 1)) {
    var a = this.a9;
    var x$1 = $m_ju_Arrays$().d7(a, 1, a.a.length);
    var x$2 = ((this.je - 1) | 0);
    var x$3 = ((this.i5 - 1) | 0);
    var x$4 = ((this.at - 1) | 0);
    return new $c_sci_Vector3(x$1, x$2, this.jf, x$3, this.gM, this.hi, this.al, x$4);
  } else {
    return this.mW(1, this.at);
  }
});
$p.r0 = (function() {
  if ((this.al.a.length > 1)) {
    var a = this.al;
    var x$1 = $m_ju_Arrays$().d7(a, 0, ((a.a.length - 1) | 0));
    var x$2 = ((this.at - 1) | 0);
    return new $c_sci_Vector3(this.a9, this.je, this.jf, this.i5, this.gM, this.hi, x$1, x$2);
  } else {
    return this.mW(0, ((this.at - 1) | 0));
  }
});
$p.um = (function() {
  return 5;
});
$p.wn = (function(idx) {
  switch (idx) {
    case 0: {
      return this.a9;
      break;
    }
    case 1: {
      return this.jf;
      break;
    }
    case 2: {
      return this.gM;
      break;
    }
    case 3: {
      return this.hi;
      break;
    }
    case 4: {
      return this.al;
      break;
    }
    default: {
      throw new $c_s_MatchError(idx);
    }
  }
});
$p.pn = (function(suffix, k) {
  var suffix1b = $m_sci_VectorStatics$().OX(this.al, suffix);
  if ((suffix1b !== null)) {
    var x$2 = ((((this.at - this.al.a.length) | 0) + suffix1b.a.length) | 0);
    return new $c_sci_Vector3(this.a9, this.je, this.jf, this.i5, this.gM, this.hi, suffix1b, x$2);
  } else {
    return $c_sci_Vector.prototype.pn.call(this, suffix, k);
  }
});
$p.lX = (function() {
  return this.r0();
});
$p.v = (function() {
  return this.mX();
});
$p.L = (function(f) {
  return this.w9(f);
});
$p.kv = (function(elem) {
  return this.mV(elem);
});
$p.bv = (function(elem) {
  return this.lg(elem);
});
$p.i = (function(v1) {
  var index = (v1 | 0);
  if (((index >= 0) && (index < this.at))) {
    var io = ((index - this.i5) | 0);
    if ((io >= 0)) {
      var i3 = ((io >>> 10) | 0);
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i3 < this.gM.a.length) ? this.gM.a[i3].a[i2].a[i1] : ((i2 < this.hi.a.length) ? this.hi.a[i2].a[i1] : this.al.a[i1]));
    } else if ((index >= this.je)) {
      var io$2 = ((index - this.je) | 0);
      return this.jf.a[((io$2 >>> 5) | 0)].a[(31 & io$2)];
    } else {
      return this.a9.a[index];
    }
  } else {
    throw this.ks(index);
  }
});
function $isArrayOf_sci_Vector3(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.lv)));
}
var $d_sci_Vector3 = new $TypeData().i($c_sci_Vector3, "scala.collection.immutable.Vector3", ({
  lv: 1,
  br: 1,
  bs: 1,
  bd: 1,
  a6: 1,
  L: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  H: 1,
  i: 1,
  h: 1,
  w: 1,
  b: 1,
  X: 1,
  I: 1,
  a2: 1,
  a7: 1,
  M: 1,
  A: 1,
  ae: 1,
  a8: 1,
  N: 1,
  z: 1,
  a5: 1,
  a: 1
}));
/** @constructor */
function $c_sci_Vector4(_prefix1, len1, prefix2, len12, prefix3, len123, data4, suffix3, suffix2, _suffix1, _length0) {
  this.a9 = null;
  this.al = null;
  this.at = 0;
  this.hx = 0;
  this.hj = null;
  this.hy = 0;
  this.hk = null;
  this.gu = 0;
  this.fJ = null;
  this.g2 = null;
  this.g1 = null;
  this.hx = len1;
  this.hj = prefix2;
  this.hy = len12;
  this.hk = prefix3;
  this.gu = len123;
  this.fJ = data4;
  this.g2 = suffix3;
  this.g1 = suffix2;
  $ct_sci_BigVector__AO__AO__I__(this, _prefix1, _suffix1, _length0);
}
$p = $c_sci_Vector4.prototype = new $h_sci_BigVector();
$p.constructor = $c_sci_Vector4;
/** @constructor */
function $h_sci_Vector4() {
}
$h_sci_Vector4.prototype = $p;
$p.l = (function(index) {
  if (((index >= 0) && (index < this.at))) {
    var io = ((index - this.gu) | 0);
    if ((io >= 0)) {
      var i4 = ((io >>> 15) | 0);
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i4 < this.fJ.a.length) ? this.fJ.a[i4].a[i3].a[i2].a[i1] : ((i3 < this.g2.a.length) ? this.g2.a[i3].a[i2].a[i1] : ((i2 < this.g1.a.length) ? this.g1.a[i2].a[i1] : this.al.a[i1])));
    } else if ((index >= this.hy)) {
      var io$2 = ((index - this.hy) | 0);
      return this.hk.a[((io$2 >>> 10) | 0)].a[(31 & ((io$2 >>> 5) | 0))].a[(31 & io$2)];
    } else if ((index >= this.hx)) {
      var io$3 = ((index - this.hx) | 0);
      return this.hj.a[((io$3 >>> 5) | 0)].a[(31 & io$3)];
    } else {
      return this.a9.a[index];
    }
  } else {
    throw this.ks(index);
  }
});
$p.nI = (function(index, elem) {
  if (((index >= 0) && (index < this.at))) {
    if ((index >= this.gu)) {
      var io = ((index - this.gu) | 0);
      var i4 = ((io >>> 15) | 0);
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      if ((i4 < this.fJ.a.length)) {
        var a4 = this.fJ;
        var a4c = a4.ae();
        var a3 = a4c.a[i4];
        var a3c = a3.ae();
        var a2 = a3c.a[i3];
        var a2c = a2.ae();
        var a1 = a2c.a[i2];
        var a1c = a1.ae();
        a1c.a[i1] = elem;
        a2c.a[i2] = a1c;
        a3c.a[i3] = a2c;
        a4c.a[i4] = a3c;
        return new $c_sci_Vector4(this.a9, this.hx, this.hj, this.hy, this.hk, this.gu, a4c, this.g2, this.g1, this.al, this.at);
      } else if ((i3 < this.g2.a.length)) {
        var a3$1 = this.g2;
        var a3c$1 = a3$1.ae();
        var a2$1 = a3c$1.a[i3];
        var a2c$1 = a2$1.ae();
        var a1$1 = a2c$1.a[i2];
        var a1c$1 = a1$1.ae();
        a1c$1.a[i1] = elem;
        a2c$1.a[i2] = a1c$1;
        a3c$1.a[i3] = a2c$1;
        return new $c_sci_Vector4(this.a9, this.hx, this.hj, this.hy, this.hk, this.gu, this.fJ, a3c$1, this.g1, this.al, this.at);
      } else if ((i2 < this.g1.a.length)) {
        var a2$2 = this.g1;
        var a2c$2 = a2$2.ae();
        var a1$2 = a2c$2.a[i2];
        var a1c$2 = a1$2.ae();
        a1c$2.a[i1] = elem;
        a2c$2.a[i2] = a1c$2;
        return new $c_sci_Vector4(this.a9, this.hx, this.hj, this.hy, this.hk, this.gu, this.fJ, this.g2, a2c$2, this.al, this.at);
      } else {
        var a1$3 = this.al;
        var a1c$3 = a1$3.ae();
        a1c$3.a[i1] = elem;
        return new $c_sci_Vector4(this.a9, this.hx, this.hj, this.hy, this.hk, this.gu, this.fJ, this.g2, this.g1, a1c$3, this.at);
      }
    } else if ((index >= this.hy)) {
      var io$2 = ((index - this.hy) | 0);
      var a3$2 = this.hk;
      var idx3 = ((io$2 >>> 10) | 0);
      var idx2 = (31 & ((io$2 >>> 5) | 0));
      var idx1 = (31 & io$2);
      var a3c$2 = a3$2.ae();
      var a2$3 = a3c$2.a[idx3];
      var a2c$3 = a2$3.ae();
      var a1$4 = a2c$3.a[idx2];
      var a1c$4 = a1$4.ae();
      a1c$4.a[idx1] = elem;
      a2c$3.a[idx2] = a1c$4;
      a3c$2.a[idx3] = a2c$3;
      return new $c_sci_Vector4(this.a9, this.hx, this.hj, this.hy, a3c$2, this.gu, this.fJ, this.g2, this.g1, this.al, this.at);
    } else if ((index >= this.hx)) {
      var io$3 = ((index - this.hx) | 0);
      var a2$4 = this.hj;
      var idx2$1 = ((io$3 >>> 5) | 0);
      var idx1$1 = (31 & io$3);
      var a2c$4 = a2$4.ae();
      var a1$5 = a2c$4.a[idx2$1];
      var a1c$5 = a1$5.ae();
      a1c$5.a[idx1$1] = elem;
      a2c$4.a[idx2$1] = a1c$5;
      return new $c_sci_Vector4(this.a9, this.hx, a2c$4, this.hy, this.hk, this.gu, this.fJ, this.g2, this.g1, this.al, this.at);
    } else {
      var a1$6 = this.a9;
      var a1c$6 = a1$6.ae();
      a1c$6.a[index] = elem;
      return new $c_sci_Vector4(a1c$6, this.hx, this.hj, this.hy, this.hk, this.gu, this.fJ, this.g2, this.g1, this.al, this.at);
    }
  } else {
    throw this.ks(index);
  }
});
$p.lg = (function(elem) {
  if ((this.al.a.length < 32)) {
    var x$1 = $m_sci_VectorStatics$().Pc(this.al, elem);
    var x$2 = ((1 + this.at) | 0);
    return new $c_sci_Vector4(this.a9, this.hx, this.hj, this.hy, this.hk, this.gu, this.fJ, this.g2, this.g1, x$1, x$2);
  } else if ((this.g1.a.length < 31)) {
    var x$12 = $m_sci_VectorStatics$().dO(this.g1, this.al);
    var a = new $ac_O(1);
    a.a[0] = elem;
    var x$14 = ((1 + this.at) | 0);
    return new $c_sci_Vector4(this.a9, this.hx, this.hj, this.hy, this.hk, this.gu, this.fJ, this.g2, x$12, a, x$14);
  } else if ((this.g2.a.length < 31)) {
    var x$23 = $m_sci_VectorStatics$().dO(this.g2, $m_sci_VectorStatics$().dO(this.g1, this.al));
    var x$24 = $m_sci_VectorStatics$().eg;
    var a$1 = new $ac_O(1);
    a$1.a[0] = elem;
    var x$26 = ((1 + this.at) | 0);
    return new $c_sci_Vector4(this.a9, this.hx, this.hj, this.hy, this.hk, this.gu, this.fJ, x$23, x$24, a$1, x$26);
  } else if ((this.fJ.a.length < 30)) {
    var x$34 = $m_sci_VectorStatics$().dO(this.fJ, $m_sci_VectorStatics$().dO(this.g2, $m_sci_VectorStatics$().dO(this.g1, this.al)));
    var x$35 = $m_sci_VectorStatics$().hz;
    var x$36 = $m_sci_VectorStatics$().eg;
    var a$2 = new $ac_O(1);
    a$2.a[0] = elem;
    var x$38 = ((1 + this.at) | 0);
    return new $c_sci_Vector4(this.a9, this.hx, this.hj, this.hy, this.hk, this.gu, x$34, x$35, x$36, a$2, x$38);
  } else {
    var $x_11 = this.a9;
    var $x_10 = this.hx;
    var $x_9 = this.hj;
    var $x_8 = this.hy;
    var $x_7 = this.hk;
    var $x_6 = this.gu;
    var $x_5 = this.fJ;
    var $x_4 = this.gu;
    var $x_3 = $m_sci_VectorStatics$().D5;
    var x = $m_sci_VectorStatics$().dO(this.g2, $m_sci_VectorStatics$().dO(this.g1, this.al));
    var a$3 = new ($d_O.r().r().r().r().C)(1);
    a$3.a[0] = x;
    var $x_2 = $m_sci_VectorStatics$().hz;
    var $x_1 = $m_sci_VectorStatics$().eg;
    var a$4 = new $ac_O(1);
    a$4.a[0] = elem;
    return new $c_sci_Vector5($x_11, $x_10, $x_9, $x_8, $x_7, $x_6, $x_5, ((983040 + $x_4) | 0), $x_3, a$3, $x_2, $x_1, a$4, ((1 + this.at) | 0));
  }
});
$p.mV = (function(elem) {
  if ((this.hx < 32)) {
    var x$1 = $m_sci_VectorStatics$().Pd(elem, this.a9);
    var x$2 = ((1 + this.hx) | 0);
    var x$3 = ((1 + this.hy) | 0);
    var x$4 = ((1 + this.gu) | 0);
    var x$5 = ((1 + this.at) | 0);
    return new $c_sci_Vector4(x$1, x$2, this.hj, x$3, this.hk, x$4, this.fJ, this.g2, this.g1, this.al, x$5);
  } else if ((this.hy < 1024)) {
    var a = new $ac_O(1);
    a.a[0] = elem;
    var x$14 = $m_sci_VectorStatics$().cQ(this.a9, this.hj);
    var x$15 = ((1 + this.hy) | 0);
    var x$16 = ((1 + this.gu) | 0);
    var x$17 = ((1 + this.at) | 0);
    return new $c_sci_Vector4(a, 1, x$14, x$15, this.hk, x$16, this.fJ, this.g2, this.g1, this.al, x$17);
  } else if ((this.gu < 32768)) {
    var a$1 = new $ac_O(1);
    a$1.a[0] = elem;
    var x$25 = $m_sci_VectorStatics$().eg;
    var x$27 = $m_sci_VectorStatics$().cQ($m_sci_VectorStatics$().cQ(this.a9, this.hj), this.hk);
    var x$28 = ((1 + this.gu) | 0);
    var x$29 = ((1 + this.at) | 0);
    return new $c_sci_Vector4(a$1, 1, x$25, 1, x$27, x$28, this.fJ, this.g2, this.g1, this.al, x$29);
  } else if ((this.fJ.a.length < 30)) {
    var a$2 = new $ac_O(1);
    a$2.a[0] = elem;
    var x$36 = $m_sci_VectorStatics$().eg;
    var x$38 = $m_sci_VectorStatics$().hz;
    var x$40 = $m_sci_VectorStatics$().cQ($m_sci_VectorStatics$().cQ($m_sci_VectorStatics$().cQ(this.a9, this.hj), this.hk), this.fJ);
    var x$41 = ((1 + this.at) | 0);
    return new $c_sci_Vector4(a$2, 1, x$36, 1, x$38, 1, x$40, this.g2, this.g1, this.al, x$41);
  } else {
    var a$3 = new $ac_O(1);
    a$3.a[0] = elem;
    var $x_2 = $m_sci_VectorStatics$().eg;
    var $x_1 = $m_sci_VectorStatics$().hz;
    var x = $m_sci_VectorStatics$().cQ($m_sci_VectorStatics$().cQ(this.a9, this.hj), this.hk);
    var a$4 = new ($d_O.r().r().r().r().C)(1);
    a$4.a[0] = x;
    return new $c_sci_Vector5(a$3, 1, $x_2, 1, $x_1, 1, a$4, ((1 + this.gu) | 0), $m_sci_VectorStatics$().D5, this.fJ, this.g2, this.g1, this.al, ((1 + this.at) | 0));
  }
});
$p.w9 = (function(f) {
  var x$1 = $m_sci_VectorStatics$().ub(this.a9, f);
  var x$2 = $m_sci_VectorStatics$().ho(2, this.hj, f);
  var x$3 = $m_sci_VectorStatics$().ho(3, this.hk, f);
  var x$4 = $m_sci_VectorStatics$().ho(4, this.fJ, f);
  var x$5 = $m_sci_VectorStatics$().ho(3, this.g2, f);
  var x$6 = $m_sci_VectorStatics$().ho(2, this.g1, f);
  var x$7 = $m_sci_VectorStatics$().ub(this.al, f);
  return new $c_sci_Vector4(x$1, this.hx, x$2, this.hy, x$3, this.gu, x$4, x$5, x$6, x$7, this.at);
});
$p.mW = (function(lo, hi) {
  var b = new $c_sci_VectorSliceBuilder(lo, hi);
  b.eT(1, this.a9);
  b.eT(2, this.hj);
  b.eT(3, this.hk);
  b.eT(4, this.fJ);
  b.eT(3, this.g2);
  b.eT(2, this.g1);
  b.eT(1, this.al);
  return b.bY();
});
$p.mX = (function() {
  if ((this.hx > 1)) {
    var a = this.a9;
    var x$1 = $m_ju_Arrays$().d7(a, 1, a.a.length);
    var x$2 = ((this.hx - 1) | 0);
    var x$3 = ((this.hy - 1) | 0);
    var x$4 = ((this.gu - 1) | 0);
    var x$5 = ((this.at - 1) | 0);
    return new $c_sci_Vector4(x$1, x$2, this.hj, x$3, this.hk, x$4, this.fJ, this.g2, this.g1, this.al, x$5);
  } else {
    return this.mW(1, this.at);
  }
});
$p.r0 = (function() {
  if ((this.al.a.length > 1)) {
    var a = this.al;
    var x$1 = $m_ju_Arrays$().d7(a, 0, ((a.a.length - 1) | 0));
    var x$2 = ((this.at - 1) | 0);
    return new $c_sci_Vector4(this.a9, this.hx, this.hj, this.hy, this.hk, this.gu, this.fJ, this.g2, this.g1, x$1, x$2);
  } else {
    return this.mW(0, ((this.at - 1) | 0));
  }
});
$p.um = (function() {
  return 7;
});
$p.wn = (function(idx) {
  switch (idx) {
    case 0: {
      return this.a9;
      break;
    }
    case 1: {
      return this.hj;
      break;
    }
    case 2: {
      return this.hk;
      break;
    }
    case 3: {
      return this.fJ;
      break;
    }
    case 4: {
      return this.g2;
      break;
    }
    case 5: {
      return this.g1;
      break;
    }
    case 6: {
      return this.al;
      break;
    }
    default: {
      throw new $c_s_MatchError(idx);
    }
  }
});
$p.pn = (function(suffix, k) {
  var suffix1b = $m_sci_VectorStatics$().OX(this.al, suffix);
  if ((suffix1b !== null)) {
    var x$2 = ((((this.at - this.al.a.length) | 0) + suffix1b.a.length) | 0);
    return new $c_sci_Vector4(this.a9, this.hx, this.hj, this.hy, this.hk, this.gu, this.fJ, this.g2, this.g1, suffix1b, x$2);
  } else {
    return $c_sci_Vector.prototype.pn.call(this, suffix, k);
  }
});
$p.lX = (function() {
  return this.r0();
});
$p.v = (function() {
  return this.mX();
});
$p.L = (function(f) {
  return this.w9(f);
});
$p.kv = (function(elem) {
  return this.mV(elem);
});
$p.bv = (function(elem) {
  return this.lg(elem);
});
$p.i = (function(v1) {
  var index = (v1 | 0);
  if (((index >= 0) && (index < this.at))) {
    var io = ((index - this.gu) | 0);
    if ((io >= 0)) {
      var i4 = ((io >>> 15) | 0);
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i4 < this.fJ.a.length) ? this.fJ.a[i4].a[i3].a[i2].a[i1] : ((i3 < this.g2.a.length) ? this.g2.a[i3].a[i2].a[i1] : ((i2 < this.g1.a.length) ? this.g1.a[i2].a[i1] : this.al.a[i1])));
    } else if ((index >= this.hy)) {
      var io$2 = ((index - this.hy) | 0);
      return this.hk.a[((io$2 >>> 10) | 0)].a[(31 & ((io$2 >>> 5) | 0))].a[(31 & io$2)];
    } else if ((index >= this.hx)) {
      var io$3 = ((index - this.hx) | 0);
      return this.hj.a[((io$3 >>> 5) | 0)].a[(31 & io$3)];
    } else {
      return this.a9.a[index];
    }
  } else {
    throw this.ks(index);
  }
});
function $isArrayOf_sci_Vector4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.lw)));
}
var $d_sci_Vector4 = new $TypeData().i($c_sci_Vector4, "scala.collection.immutable.Vector4", ({
  lw: 1,
  br: 1,
  bs: 1,
  bd: 1,
  a6: 1,
  L: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  H: 1,
  i: 1,
  h: 1,
  w: 1,
  b: 1,
  X: 1,
  I: 1,
  a2: 1,
  a7: 1,
  M: 1,
  A: 1,
  ae: 1,
  a8: 1,
  N: 1,
  z: 1,
  a5: 1,
  a: 1
}));
/** @constructor */
function $c_sci_Vector5(_prefix1, len1, prefix2, len12, prefix3, len123, prefix4, len1234, data5, suffix4, suffix3, suffix2, _suffix1, _length0) {
  this.a9 = null;
  this.al = null;
  this.at = 0;
  this.gv = 0;
  this.g3 = null;
  this.gw = 0;
  this.g4 = null;
  this.gi = 0;
  this.g5 = null;
  this.fl = 0;
  this.eK = null;
  this.eS = null;
  this.eR = null;
  this.eQ = null;
  this.gv = len1;
  this.g3 = prefix2;
  this.gw = len12;
  this.g4 = prefix3;
  this.gi = len123;
  this.g5 = prefix4;
  this.fl = len1234;
  this.eK = data5;
  this.eS = suffix4;
  this.eR = suffix3;
  this.eQ = suffix2;
  $ct_sci_BigVector__AO__AO__I__(this, _prefix1, _suffix1, _length0);
}
$p = $c_sci_Vector5.prototype = new $h_sci_BigVector();
$p.constructor = $c_sci_Vector5;
/** @constructor */
function $h_sci_Vector5() {
}
$h_sci_Vector5.prototype = $p;
$p.l = (function(index) {
  if (((index >= 0) && (index < this.at))) {
    var io = ((index - this.fl) | 0);
    if ((io >= 0)) {
      var i5 = ((io >>> 20) | 0);
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i5 < this.eK.a.length) ? this.eK.a[i5].a[i4].a[i3].a[i2].a[i1] : ((i4 < this.eS.a.length) ? this.eS.a[i4].a[i3].a[i2].a[i1] : ((i3 < this.eR.a.length) ? this.eR.a[i3].a[i2].a[i1] : ((i2 < this.eQ.a.length) ? this.eQ.a[i2].a[i1] : this.al.a[i1]))));
    } else if ((index >= this.gi)) {
      var io$2 = ((index - this.gi) | 0);
      return this.g5.a[((io$2 >>> 15) | 0)].a[(31 & ((io$2 >>> 10) | 0))].a[(31 & ((io$2 >>> 5) | 0))].a[(31 & io$2)];
    } else if ((index >= this.gw)) {
      var io$3 = ((index - this.gw) | 0);
      return this.g4.a[((io$3 >>> 10) | 0)].a[(31 & ((io$3 >>> 5) | 0))].a[(31 & io$3)];
    } else if ((index >= this.gv)) {
      var io$4 = ((index - this.gv) | 0);
      return this.g3.a[((io$4 >>> 5) | 0)].a[(31 & io$4)];
    } else {
      return this.a9.a[index];
    }
  } else {
    throw this.ks(index);
  }
});
$p.nI = (function(index, elem) {
  if (((index >= 0) && (index < this.at))) {
    if ((index >= this.fl)) {
      var io = ((index - this.fl) | 0);
      var i5 = ((io >>> 20) | 0);
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      if ((i5 < this.eK.a.length)) {
        var a5 = this.eK;
        var a5c = a5.ae();
        var a4 = a5c.a[i5];
        var a4c = a4.ae();
        var a3 = a4c.a[i4];
        var a3c = a3.ae();
        var a2 = a3c.a[i3];
        var a2c = a2.ae();
        var a1 = a2c.a[i2];
        var a1c = a1.ae();
        a1c.a[i1] = elem;
        a2c.a[i2] = a1c;
        a3c.a[i3] = a2c;
        a4c.a[i4] = a3c;
        a5c.a[i5] = a4c;
        return new $c_sci_Vector5(this.a9, this.gv, this.g3, this.gw, this.g4, this.gi, this.g5, this.fl, a5c, this.eS, this.eR, this.eQ, this.al, this.at);
      } else if ((i4 < this.eS.a.length)) {
        var a4$1 = this.eS;
        var a4c$1 = a4$1.ae();
        var a3$1 = a4c$1.a[i4];
        var a3c$1 = a3$1.ae();
        var a2$1 = a3c$1.a[i3];
        var a2c$1 = a2$1.ae();
        var a1$1 = a2c$1.a[i2];
        var a1c$1 = a1$1.ae();
        a1c$1.a[i1] = elem;
        a2c$1.a[i2] = a1c$1;
        a3c$1.a[i3] = a2c$1;
        a4c$1.a[i4] = a3c$1;
        return new $c_sci_Vector5(this.a9, this.gv, this.g3, this.gw, this.g4, this.gi, this.g5, this.fl, this.eK, a4c$1, this.eR, this.eQ, this.al, this.at);
      } else if ((i3 < this.eR.a.length)) {
        var a3$2 = this.eR;
        var a3c$2 = a3$2.ae();
        var a2$2 = a3c$2.a[i3];
        var a2c$2 = a2$2.ae();
        var a1$2 = a2c$2.a[i2];
        var a1c$2 = a1$2.ae();
        a1c$2.a[i1] = elem;
        a2c$2.a[i2] = a1c$2;
        a3c$2.a[i3] = a2c$2;
        return new $c_sci_Vector5(this.a9, this.gv, this.g3, this.gw, this.g4, this.gi, this.g5, this.fl, this.eK, this.eS, a3c$2, this.eQ, this.al, this.at);
      } else if ((i2 < this.eQ.a.length)) {
        var a2$3 = this.eQ;
        var a2c$3 = a2$3.ae();
        var a1$3 = a2c$3.a[i2];
        var a1c$3 = a1$3.ae();
        a1c$3.a[i1] = elem;
        a2c$3.a[i2] = a1c$3;
        return new $c_sci_Vector5(this.a9, this.gv, this.g3, this.gw, this.g4, this.gi, this.g5, this.fl, this.eK, this.eS, this.eR, a2c$3, this.al, this.at);
      } else {
        var a1$4 = this.al;
        var a1c$4 = a1$4.ae();
        a1c$4.a[i1] = elem;
        return new $c_sci_Vector5(this.a9, this.gv, this.g3, this.gw, this.g4, this.gi, this.g5, this.fl, this.eK, this.eS, this.eR, this.eQ, a1c$4, this.at);
      }
    } else if ((index >= this.gi)) {
      var io$2 = ((index - this.gi) | 0);
      var a4$2 = this.g5;
      var idx4 = ((io$2 >>> 15) | 0);
      var idx3 = (31 & ((io$2 >>> 10) | 0));
      var idx2 = (31 & ((io$2 >>> 5) | 0));
      var idx1 = (31 & io$2);
      var a4c$2 = a4$2.ae();
      var a3$3 = a4c$2.a[idx4];
      var a3c$3 = a3$3.ae();
      var a2$4 = a3c$3.a[idx3];
      var a2c$4 = a2$4.ae();
      var a1$5 = a2c$4.a[idx2];
      var a1c$5 = a1$5.ae();
      a1c$5.a[idx1] = elem;
      a2c$4.a[idx2] = a1c$5;
      a3c$3.a[idx3] = a2c$4;
      a4c$2.a[idx4] = a3c$3;
      return new $c_sci_Vector5(this.a9, this.gv, this.g3, this.gw, this.g4, this.gi, a4c$2, this.fl, this.eK, this.eS, this.eR, this.eQ, this.al, this.at);
    } else if ((index >= this.gw)) {
      var io$3 = ((index - this.gw) | 0);
      var a3$4 = this.g4;
      var idx3$1 = ((io$3 >>> 10) | 0);
      var idx2$1 = (31 & ((io$3 >>> 5) | 0));
      var idx1$1 = (31 & io$3);
      var a3c$4 = a3$4.ae();
      var a2$5 = a3c$4.a[idx3$1];
      var a2c$5 = a2$5.ae();
      var a1$6 = a2c$5.a[idx2$1];
      var a1c$6 = a1$6.ae();
      a1c$6.a[idx1$1] = elem;
      a2c$5.a[idx2$1] = a1c$6;
      a3c$4.a[idx3$1] = a2c$5;
      return new $c_sci_Vector5(this.a9, this.gv, this.g3, this.gw, a3c$4, this.gi, this.g5, this.fl, this.eK, this.eS, this.eR, this.eQ, this.al, this.at);
    } else if ((index >= this.gv)) {
      var io$4 = ((index - this.gv) | 0);
      var a2$6 = this.g3;
      var idx2$2 = ((io$4 >>> 5) | 0);
      var idx1$2 = (31 & io$4);
      var a2c$6 = a2$6.ae();
      var a1$7 = a2c$6.a[idx2$2];
      var a1c$7 = a1$7.ae();
      a1c$7.a[idx1$2] = elem;
      a2c$6.a[idx2$2] = a1c$7;
      return new $c_sci_Vector5(this.a9, this.gv, a2c$6, this.gw, this.g4, this.gi, this.g5, this.fl, this.eK, this.eS, this.eR, this.eQ, this.al, this.at);
    } else {
      var a1$8 = this.a9;
      var a1c$8 = a1$8.ae();
      a1c$8.a[index] = elem;
      return new $c_sci_Vector5(a1c$8, this.gv, this.g3, this.gw, this.g4, this.gi, this.g5, this.fl, this.eK, this.eS, this.eR, this.eQ, this.al, this.at);
    }
  } else {
    throw this.ks(index);
  }
});
$p.lg = (function(elem) {
  if ((this.al.a.length < 32)) {
    var x$1 = $m_sci_VectorStatics$().Pc(this.al, elem);
    var x$2 = ((1 + this.at) | 0);
    return new $c_sci_Vector5(this.a9, this.gv, this.g3, this.gw, this.g4, this.gi, this.g5, this.fl, this.eK, this.eS, this.eR, this.eQ, x$1, x$2);
  } else if ((this.eQ.a.length < 31)) {
    var x$15 = $m_sci_VectorStatics$().dO(this.eQ, this.al);
    var a = new $ac_O(1);
    a.a[0] = elem;
    var x$17 = ((1 + this.at) | 0);
    return new $c_sci_Vector5(this.a9, this.gv, this.g3, this.gw, this.g4, this.gi, this.g5, this.fl, this.eK, this.eS, this.eR, x$15, a, x$17);
  } else if ((this.eR.a.length < 31)) {
    var x$29 = $m_sci_VectorStatics$().dO(this.eR, $m_sci_VectorStatics$().dO(this.eQ, this.al));
    var x$30 = $m_sci_VectorStatics$().eg;
    var a$1 = new $ac_O(1);
    a$1.a[0] = elem;
    var x$32 = ((1 + this.at) | 0);
    return new $c_sci_Vector5(this.a9, this.gv, this.g3, this.gw, this.g4, this.gi, this.g5, this.fl, this.eK, this.eS, x$29, x$30, a$1, x$32);
  } else if ((this.eS.a.length < 31)) {
    var x$43 = $m_sci_VectorStatics$().dO(this.eS, $m_sci_VectorStatics$().dO(this.eR, $m_sci_VectorStatics$().dO(this.eQ, this.al)));
    var x$44 = $m_sci_VectorStatics$().hz;
    var x$45 = $m_sci_VectorStatics$().eg;
    var a$2 = new $ac_O(1);
    a$2.a[0] = elem;
    var x$47 = ((1 + this.at) | 0);
    return new $c_sci_Vector5(this.a9, this.gv, this.g3, this.gw, this.g4, this.gi, this.g5, this.fl, this.eK, x$43, x$44, x$45, a$2, x$47);
  } else if ((this.eK.a.length < 30)) {
    var x$57 = $m_sci_VectorStatics$().dO(this.eK, $m_sci_VectorStatics$().dO(this.eS, $m_sci_VectorStatics$().dO(this.eR, $m_sci_VectorStatics$().dO(this.eQ, this.al))));
    var x$58 = $m_sci_VectorStatics$().nn;
    var x$59 = $m_sci_VectorStatics$().hz;
    var x$60 = $m_sci_VectorStatics$().eg;
    var a$3 = new $ac_O(1);
    a$3.a[0] = elem;
    var x$62 = ((1 + this.at) | 0);
    return new $c_sci_Vector5(this.a9, this.gv, this.g3, this.gw, this.g4, this.gi, this.g5, this.fl, x$57, x$58, x$59, x$60, a$3, x$62);
  } else {
    var $x_14 = this.a9;
    var $x_13 = this.gv;
    var $x_12 = this.g3;
    var $x_11 = this.gw;
    var $x_10 = this.g4;
    var $x_9 = this.gi;
    var $x_8 = this.g5;
    var $x_7 = this.fl;
    var $x_6 = this.eK;
    var $x_5 = this.fl;
    var $x_4 = $m_sci_VectorStatics$().a1R;
    var x = $m_sci_VectorStatics$().dO(this.eS, $m_sci_VectorStatics$().dO(this.eR, $m_sci_VectorStatics$().dO(this.eQ, this.al)));
    var a$4 = new ($d_O.r().r().r().r().r().C)(1);
    a$4.a[0] = x;
    var $x_3 = $m_sci_VectorStatics$().nn;
    var $x_2 = $m_sci_VectorStatics$().hz;
    var $x_1 = $m_sci_VectorStatics$().eg;
    var a$5 = new $ac_O(1);
    a$5.a[0] = elem;
    return new $c_sci_Vector6($x_14, $x_13, $x_12, $x_11, $x_10, $x_9, $x_8, $x_7, $x_6, ((31457280 + $x_5) | 0), $x_4, a$4, $x_3, $x_2, $x_1, a$5, ((1 + this.at) | 0));
  }
});
$p.mV = (function(elem) {
  if ((this.gv < 32)) {
    var x$1 = $m_sci_VectorStatics$().Pd(elem, this.a9);
    var x$2 = ((1 + this.gv) | 0);
    var x$3 = ((1 + this.gw) | 0);
    var x$4 = ((1 + this.gi) | 0);
    var x$5 = ((1 + this.fl) | 0);
    var x$6 = ((1 + this.at) | 0);
    return new $c_sci_Vector5(x$1, x$2, this.g3, x$3, this.g4, x$4, this.g5, x$5, this.eK, this.eS, this.eR, this.eQ, this.al, x$6);
  } else if ((this.gw < 1024)) {
    var a = new $ac_O(1);
    a.a[0] = elem;
    var x$17 = $m_sci_VectorStatics$().cQ(this.a9, this.g3);
    var x$18 = ((1 + this.gw) | 0);
    var x$19 = ((1 + this.gi) | 0);
    var x$20 = ((1 + this.fl) | 0);
    var x$21 = ((1 + this.at) | 0);
    return new $c_sci_Vector5(a, 1, x$17, x$18, this.g4, x$19, this.g5, x$20, this.eK, this.eS, this.eR, this.eQ, this.al, x$21);
  } else if ((this.gi < 32768)) {
    var a$1 = new $ac_O(1);
    a$1.a[0] = elem;
    var x$31 = $m_sci_VectorStatics$().eg;
    var x$33 = $m_sci_VectorStatics$().cQ($m_sci_VectorStatics$().cQ(this.a9, this.g3), this.g4);
    var x$34 = ((1 + this.gi) | 0);
    var x$35 = ((1 + this.fl) | 0);
    var x$36 = ((1 + this.at) | 0);
    return new $c_sci_Vector5(a$1, 1, x$31, 1, x$33, x$34, this.g5, x$35, this.eK, this.eS, this.eR, this.eQ, this.al, x$36);
  } else if ((this.fl < 1048576)) {
    var a$2 = new $ac_O(1);
    a$2.a[0] = elem;
    var x$45 = $m_sci_VectorStatics$().eg;
    var x$47 = $m_sci_VectorStatics$().hz;
    var x$49 = $m_sci_VectorStatics$().cQ($m_sci_VectorStatics$().cQ($m_sci_VectorStatics$().cQ(this.a9, this.g3), this.g4), this.g5);
    var x$50 = ((1 + this.fl) | 0);
    var x$51 = ((1 + this.at) | 0);
    return new $c_sci_Vector5(a$2, 1, x$45, 1, x$47, 1, x$49, x$50, this.eK, this.eS, this.eR, this.eQ, this.al, x$51);
  } else if ((this.eK.a.length < 30)) {
    var a$3 = new $ac_O(1);
    a$3.a[0] = elem;
    var x$59 = $m_sci_VectorStatics$().eg;
    var x$61 = $m_sci_VectorStatics$().hz;
    var x$63 = $m_sci_VectorStatics$().nn;
    var x$65 = $m_sci_VectorStatics$().cQ($m_sci_VectorStatics$().cQ($m_sci_VectorStatics$().cQ($m_sci_VectorStatics$().cQ(this.a9, this.g3), this.g4), this.g5), this.eK);
    var x$66 = ((1 + this.at) | 0);
    return new $c_sci_Vector5(a$3, 1, x$59, 1, x$61, 1, x$63, 1, x$65, this.eS, this.eR, this.eQ, this.al, x$66);
  } else {
    var a$4 = new $ac_O(1);
    a$4.a[0] = elem;
    var $x_3 = $m_sci_VectorStatics$().eg;
    var $x_2 = $m_sci_VectorStatics$().hz;
    var $x_1 = $m_sci_VectorStatics$().nn;
    var x = $m_sci_VectorStatics$().cQ($m_sci_VectorStatics$().cQ($m_sci_VectorStatics$().cQ(this.a9, this.g3), this.g4), this.g5);
    var a$5 = new ($d_O.r().r().r().r().r().C)(1);
    a$5.a[0] = x;
    return new $c_sci_Vector6(a$4, 1, $x_3, 1, $x_2, 1, $x_1, 1, a$5, ((1 + this.fl) | 0), $m_sci_VectorStatics$().a1R, this.eK, this.eS, this.eR, this.eQ, this.al, ((1 + this.at) | 0));
  }
});
$p.w9 = (function(f) {
  var x$1 = $m_sci_VectorStatics$().ub(this.a9, f);
  var x$2 = $m_sci_VectorStatics$().ho(2, this.g3, f);
  var x$3 = $m_sci_VectorStatics$().ho(3, this.g4, f);
  var x$4 = $m_sci_VectorStatics$().ho(4, this.g5, f);
  var x$5 = $m_sci_VectorStatics$().ho(5, this.eK, f);
  var x$6 = $m_sci_VectorStatics$().ho(4, this.eS, f);
  var x$7 = $m_sci_VectorStatics$().ho(3, this.eR, f);
  var x$8 = $m_sci_VectorStatics$().ho(2, this.eQ, f);
  var x$9 = $m_sci_VectorStatics$().ub(this.al, f);
  return new $c_sci_Vector5(x$1, this.gv, x$2, this.gw, x$3, this.gi, x$4, this.fl, x$5, x$6, x$7, x$8, x$9, this.at);
});
$p.mW = (function(lo, hi) {
  var b = new $c_sci_VectorSliceBuilder(lo, hi);
  b.eT(1, this.a9);
  b.eT(2, this.g3);
  b.eT(3, this.g4);
  b.eT(4, this.g5);
  b.eT(5, this.eK);
  b.eT(4, this.eS);
  b.eT(3, this.eR);
  b.eT(2, this.eQ);
  b.eT(1, this.al);
  return b.bY();
});
$p.mX = (function() {
  if ((this.gv > 1)) {
    var a = this.a9;
    var x$1 = $m_ju_Arrays$().d7(a, 1, a.a.length);
    var x$2 = ((this.gv - 1) | 0);
    var x$3 = ((this.gw - 1) | 0);
    var x$4 = ((this.gi - 1) | 0);
    var x$5 = ((this.fl - 1) | 0);
    var x$6 = ((this.at - 1) | 0);
    return new $c_sci_Vector5(x$1, x$2, this.g3, x$3, this.g4, x$4, this.g5, x$5, this.eK, this.eS, this.eR, this.eQ, this.al, x$6);
  } else {
    return this.mW(1, this.at);
  }
});
$p.r0 = (function() {
  if ((this.al.a.length > 1)) {
    var a = this.al;
    var x$1 = $m_ju_Arrays$().d7(a, 0, ((a.a.length - 1) | 0));
    var x$2 = ((this.at - 1) | 0);
    return new $c_sci_Vector5(this.a9, this.gv, this.g3, this.gw, this.g4, this.gi, this.g5, this.fl, this.eK, this.eS, this.eR, this.eQ, x$1, x$2);
  } else {
    return this.mW(0, ((this.at - 1) | 0));
  }
});
$p.um = (function() {
  return 9;
});
$p.wn = (function(idx) {
  switch (idx) {
    case 0: {
      return this.a9;
      break;
    }
    case 1: {
      return this.g3;
      break;
    }
    case 2: {
      return this.g4;
      break;
    }
    case 3: {
      return this.g5;
      break;
    }
    case 4: {
      return this.eK;
      break;
    }
    case 5: {
      return this.eS;
      break;
    }
    case 6: {
      return this.eR;
      break;
    }
    case 7: {
      return this.eQ;
      break;
    }
    case 8: {
      return this.al;
      break;
    }
    default: {
      throw new $c_s_MatchError(idx);
    }
  }
});
$p.pn = (function(suffix, k) {
  var suffix1b = $m_sci_VectorStatics$().OX(this.al, suffix);
  if ((suffix1b !== null)) {
    var x$2 = ((((this.at - this.al.a.length) | 0) + suffix1b.a.length) | 0);
    return new $c_sci_Vector5(this.a9, this.gv, this.g3, this.gw, this.g4, this.gi, this.g5, this.fl, this.eK, this.eS, this.eR, this.eQ, suffix1b, x$2);
  } else {
    return $c_sci_Vector.prototype.pn.call(this, suffix, k);
  }
});
$p.lX = (function() {
  return this.r0();
});
$p.v = (function() {
  return this.mX();
});
$p.L = (function(f) {
  return this.w9(f);
});
$p.kv = (function(elem) {
  return this.mV(elem);
});
$p.bv = (function(elem) {
  return this.lg(elem);
});
$p.i = (function(v1) {
  var index = (v1 | 0);
  if (((index >= 0) && (index < this.at))) {
    var io = ((index - this.fl) | 0);
    if ((io >= 0)) {
      var i5 = ((io >>> 20) | 0);
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i5 < this.eK.a.length) ? this.eK.a[i5].a[i4].a[i3].a[i2].a[i1] : ((i4 < this.eS.a.length) ? this.eS.a[i4].a[i3].a[i2].a[i1] : ((i3 < this.eR.a.length) ? this.eR.a[i3].a[i2].a[i1] : ((i2 < this.eQ.a.length) ? this.eQ.a[i2].a[i1] : this.al.a[i1]))));
    } else if ((index >= this.gi)) {
      var io$2 = ((index - this.gi) | 0);
      return this.g5.a[((io$2 >>> 15) | 0)].a[(31 & ((io$2 >>> 10) | 0))].a[(31 & ((io$2 >>> 5) | 0))].a[(31 & io$2)];
    } else if ((index >= this.gw)) {
      var io$3 = ((index - this.gw) | 0);
      return this.g4.a[((io$3 >>> 10) | 0)].a[(31 & ((io$3 >>> 5) | 0))].a[(31 & io$3)];
    } else if ((index >= this.gv)) {
      var io$4 = ((index - this.gv) | 0);
      return this.g3.a[((io$4 >>> 5) | 0)].a[(31 & io$4)];
    } else {
      return this.a9.a[index];
    }
  } else {
    throw this.ks(index);
  }
});
function $isArrayOf_sci_Vector5(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.lx)));
}
var $d_sci_Vector5 = new $TypeData().i($c_sci_Vector5, "scala.collection.immutable.Vector5", ({
  lx: 1,
  br: 1,
  bs: 1,
  bd: 1,
  a6: 1,
  L: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  H: 1,
  i: 1,
  h: 1,
  w: 1,
  b: 1,
  X: 1,
  I: 1,
  a2: 1,
  a7: 1,
  M: 1,
  A: 1,
  ae: 1,
  a8: 1,
  N: 1,
  z: 1,
  a5: 1,
  a: 1
}));
/** @constructor */
function $c_sci_Vector6(_prefix1, len1, prefix2, len12, prefix3, len123, prefix4, len1234, prefix5, len12345, data6, suffix5, suffix4, suffix3, suffix2, _suffix1, _length0) {
  this.a9 = null;
  this.al = null;
  this.at = 0;
  this.g6 = 0;
  this.fn = null;
  this.g7 = 0;
  this.fo = null;
  this.fK = 0;
  this.fp = null;
  this.fm = 0;
  this.fq = null;
  this.f5 = 0;
  this.ef = null;
  this.ev = null;
  this.eu = null;
  this.et = null;
  this.es = null;
  this.g6 = len1;
  this.fn = prefix2;
  this.g7 = len12;
  this.fo = prefix3;
  this.fK = len123;
  this.fp = prefix4;
  this.fm = len1234;
  this.fq = prefix5;
  this.f5 = len12345;
  this.ef = data6;
  this.ev = suffix5;
  this.eu = suffix4;
  this.et = suffix3;
  this.es = suffix2;
  $ct_sci_BigVector__AO__AO__I__(this, _prefix1, _suffix1, _length0);
}
$p = $c_sci_Vector6.prototype = new $h_sci_BigVector();
$p.constructor = $c_sci_Vector6;
/** @constructor */
function $h_sci_Vector6() {
}
$h_sci_Vector6.prototype = $p;
$p.l = (function(index) {
  if (((index >= 0) && (index < this.at))) {
    var io = ((index - this.f5) | 0);
    if ((io >= 0)) {
      var i6 = ((io >>> 25) | 0);
      var i5 = (31 & ((io >>> 20) | 0));
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i6 < this.ef.a.length) ? this.ef.a[i6].a[i5].a[i4].a[i3].a[i2].a[i1] : ((i5 < this.ev.a.length) ? this.ev.a[i5].a[i4].a[i3].a[i2].a[i1] : ((i4 < this.eu.a.length) ? this.eu.a[i4].a[i3].a[i2].a[i1] : ((i3 < this.et.a.length) ? this.et.a[i3].a[i2].a[i1] : ((i2 < this.es.a.length) ? this.es.a[i2].a[i1] : this.al.a[i1])))));
    } else if ((index >= this.fm)) {
      var io$2 = ((index - this.fm) | 0);
      return this.fq.a[((io$2 >>> 20) | 0)].a[(31 & ((io$2 >>> 15) | 0))].a[(31 & ((io$2 >>> 10) | 0))].a[(31 & ((io$2 >>> 5) | 0))].a[(31 & io$2)];
    } else if ((index >= this.fK)) {
      var io$3 = ((index - this.fK) | 0);
      return this.fp.a[((io$3 >>> 15) | 0)].a[(31 & ((io$3 >>> 10) | 0))].a[(31 & ((io$3 >>> 5) | 0))].a[(31 & io$3)];
    } else if ((index >= this.g7)) {
      var io$4 = ((index - this.g7) | 0);
      return this.fo.a[((io$4 >>> 10) | 0)].a[(31 & ((io$4 >>> 5) | 0))].a[(31 & io$4)];
    } else if ((index >= this.g6)) {
      var io$5 = ((index - this.g6) | 0);
      return this.fn.a[((io$5 >>> 5) | 0)].a[(31 & io$5)];
    } else {
      return this.a9.a[index];
    }
  } else {
    throw this.ks(index);
  }
});
$p.nI = (function(index, elem) {
  if (((index >= 0) && (index < this.at))) {
    if ((index >= this.f5)) {
      var io = ((index - this.f5) | 0);
      var i6 = ((io >>> 25) | 0);
      var i5 = (31 & ((io >>> 20) | 0));
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      if ((i6 < this.ef.a.length)) {
        var a6 = this.ef;
        var a6c = a6.ae();
        var a5 = a6c.a[i6];
        var a5c = a5.ae();
        var a4 = a5c.a[i5];
        var a4c = a4.ae();
        var a3 = a4c.a[i4];
        var a3c = a3.ae();
        var a2 = a3c.a[i3];
        var a2c = a2.ae();
        var a1 = a2c.a[i2];
        var a1c = a1.ae();
        a1c.a[i1] = elem;
        a2c.a[i2] = a1c;
        a3c.a[i3] = a2c;
        a4c.a[i4] = a3c;
        a5c.a[i5] = a4c;
        a6c.a[i6] = a5c;
        return new $c_sci_Vector6(this.a9, this.g6, this.fn, this.g7, this.fo, this.fK, this.fp, this.fm, this.fq, this.f5, a6c, this.ev, this.eu, this.et, this.es, this.al, this.at);
      } else if ((i5 < this.ev.a.length)) {
        var a5$1 = this.ev;
        var a5c$1 = a5$1.ae();
        var a4$1 = a5c$1.a[i5];
        var a4c$1 = a4$1.ae();
        var a3$1 = a4c$1.a[i4];
        var a3c$1 = a3$1.ae();
        var a2$1 = a3c$1.a[i3];
        var a2c$1 = a2$1.ae();
        var a1$1 = a2c$1.a[i2];
        var a1c$1 = a1$1.ae();
        a1c$1.a[i1] = elem;
        a2c$1.a[i2] = a1c$1;
        a3c$1.a[i3] = a2c$1;
        a4c$1.a[i4] = a3c$1;
        a5c$1.a[i5] = a4c$1;
        return new $c_sci_Vector6(this.a9, this.g6, this.fn, this.g7, this.fo, this.fK, this.fp, this.fm, this.fq, this.f5, this.ef, a5c$1, this.eu, this.et, this.es, this.al, this.at);
      } else if ((i4 < this.eu.a.length)) {
        var a4$2 = this.eu;
        var a4c$2 = a4$2.ae();
        var a3$2 = a4c$2.a[i4];
        var a3c$2 = a3$2.ae();
        var a2$2 = a3c$2.a[i3];
        var a2c$2 = a2$2.ae();
        var a1$2 = a2c$2.a[i2];
        var a1c$2 = a1$2.ae();
        a1c$2.a[i1] = elem;
        a2c$2.a[i2] = a1c$2;
        a3c$2.a[i3] = a2c$2;
        a4c$2.a[i4] = a3c$2;
        return new $c_sci_Vector6(this.a9, this.g6, this.fn, this.g7, this.fo, this.fK, this.fp, this.fm, this.fq, this.f5, this.ef, this.ev, a4c$2, this.et, this.es, this.al, this.at);
      } else if ((i3 < this.et.a.length)) {
        var a3$3 = this.et;
        var a3c$3 = a3$3.ae();
        var a2$3 = a3c$3.a[i3];
        var a2c$3 = a2$3.ae();
        var a1$3 = a2c$3.a[i2];
        var a1c$3 = a1$3.ae();
        a1c$3.a[i1] = elem;
        a2c$3.a[i2] = a1c$3;
        a3c$3.a[i3] = a2c$3;
        return new $c_sci_Vector6(this.a9, this.g6, this.fn, this.g7, this.fo, this.fK, this.fp, this.fm, this.fq, this.f5, this.ef, this.ev, this.eu, a3c$3, this.es, this.al, this.at);
      } else if ((i2 < this.es.a.length)) {
        var a2$4 = this.es;
        var a2c$4 = a2$4.ae();
        var a1$4 = a2c$4.a[i2];
        var a1c$4 = a1$4.ae();
        a1c$4.a[i1] = elem;
        a2c$4.a[i2] = a1c$4;
        return new $c_sci_Vector6(this.a9, this.g6, this.fn, this.g7, this.fo, this.fK, this.fp, this.fm, this.fq, this.f5, this.ef, this.ev, this.eu, this.et, a2c$4, this.al, this.at);
      } else {
        var a1$5 = this.al;
        var a1c$5 = a1$5.ae();
        a1c$5.a[i1] = elem;
        return new $c_sci_Vector6(this.a9, this.g6, this.fn, this.g7, this.fo, this.fK, this.fp, this.fm, this.fq, this.f5, this.ef, this.ev, this.eu, this.et, this.es, a1c$5, this.at);
      }
    } else if ((index >= this.fm)) {
      var io$2 = ((index - this.fm) | 0);
      var a5$2 = this.fq;
      var idx5 = ((io$2 >>> 20) | 0);
      var idx4 = (31 & ((io$2 >>> 15) | 0));
      var idx3 = (31 & ((io$2 >>> 10) | 0));
      var idx2 = (31 & ((io$2 >>> 5) | 0));
      var idx1 = (31 & io$2);
      var a5c$2 = a5$2.ae();
      var a4$3 = a5c$2.a[idx5];
      var a4c$3 = a4$3.ae();
      var a3$4 = a4c$3.a[idx4];
      var a3c$4 = a3$4.ae();
      var a2$5 = a3c$4.a[idx3];
      var a2c$5 = a2$5.ae();
      var a1$6 = a2c$5.a[idx2];
      var a1c$6 = a1$6.ae();
      a1c$6.a[idx1] = elem;
      a2c$5.a[idx2] = a1c$6;
      a3c$4.a[idx3] = a2c$5;
      a4c$3.a[idx4] = a3c$4;
      a5c$2.a[idx5] = a4c$3;
      return new $c_sci_Vector6(this.a9, this.g6, this.fn, this.g7, this.fo, this.fK, this.fp, this.fm, a5c$2, this.f5, this.ef, this.ev, this.eu, this.et, this.es, this.al, this.at);
    } else if ((index >= this.fK)) {
      var io$3 = ((index - this.fK) | 0);
      var a4$4 = this.fp;
      var idx4$1 = ((io$3 >>> 15) | 0);
      var idx3$1 = (31 & ((io$3 >>> 10) | 0));
      var idx2$1 = (31 & ((io$3 >>> 5) | 0));
      var idx1$1 = (31 & io$3);
      var a4c$4 = a4$4.ae();
      var a3$5 = a4c$4.a[idx4$1];
      var a3c$5 = a3$5.ae();
      var a2$6 = a3c$5.a[idx3$1];
      var a2c$6 = a2$6.ae();
      var a1$7 = a2c$6.a[idx2$1];
      var a1c$7 = a1$7.ae();
      a1c$7.a[idx1$1] = elem;
      a2c$6.a[idx2$1] = a1c$7;
      a3c$5.a[idx3$1] = a2c$6;
      a4c$4.a[idx4$1] = a3c$5;
      return new $c_sci_Vector6(this.a9, this.g6, this.fn, this.g7, this.fo, this.fK, a4c$4, this.fm, this.fq, this.f5, this.ef, this.ev, this.eu, this.et, this.es, this.al, this.at);
    } else if ((index >= this.g7)) {
      var io$4 = ((index - this.g7) | 0);
      var a3$6 = this.fo;
      var idx3$2 = ((io$4 >>> 10) | 0);
      var idx2$2 = (31 & ((io$4 >>> 5) | 0));
      var idx1$2 = (31 & io$4);
      var a3c$6 = a3$6.ae();
      var a2$7 = a3c$6.a[idx3$2];
      var a2c$7 = a2$7.ae();
      var a1$8 = a2c$7.a[idx2$2];
      var a1c$8 = a1$8.ae();
      a1c$8.a[idx1$2] = elem;
      a2c$7.a[idx2$2] = a1c$8;
      a3c$6.a[idx3$2] = a2c$7;
      return new $c_sci_Vector6(this.a9, this.g6, this.fn, this.g7, a3c$6, this.fK, this.fp, this.fm, this.fq, this.f5, this.ef, this.ev, this.eu, this.et, this.es, this.al, this.at);
    } else if ((index >= this.g6)) {
      var io$5 = ((index - this.g6) | 0);
      var a2$8 = this.fn;
      var idx2$3 = ((io$5 >>> 5) | 0);
      var idx1$3 = (31 & io$5);
      var a2c$8 = a2$8.ae();
      var a1$9 = a2c$8.a[idx2$3];
      var a1c$9 = a1$9.ae();
      a1c$9.a[idx1$3] = elem;
      a2c$8.a[idx2$3] = a1c$9;
      return new $c_sci_Vector6(this.a9, this.g6, a2c$8, this.g7, this.fo, this.fK, this.fp, this.fm, this.fq, this.f5, this.ef, this.ev, this.eu, this.et, this.es, this.al, this.at);
    } else {
      var a1$10 = this.a9;
      var a1c$10 = a1$10.ae();
      a1c$10.a[index] = elem;
      return new $c_sci_Vector6(a1c$10, this.g6, this.fn, this.g7, this.fo, this.fK, this.fp, this.fm, this.fq, this.f5, this.ef, this.ev, this.eu, this.et, this.es, this.al, this.at);
    }
  } else {
    throw this.ks(index);
  }
});
$p.lg = (function(elem) {
  if ((this.al.a.length < 32)) {
    var x$1 = $m_sci_VectorStatics$().Pc(this.al, elem);
    var x$2 = ((1 + this.at) | 0);
    return new $c_sci_Vector6(this.a9, this.g6, this.fn, this.g7, this.fo, this.fK, this.fp, this.fm, this.fq, this.f5, this.ef, this.ev, this.eu, this.et, this.es, x$1, x$2);
  } else if ((this.es.a.length < 31)) {
    var x$18 = $m_sci_VectorStatics$().dO(this.es, this.al);
    var a = new $ac_O(1);
    a.a[0] = elem;
    var x$20 = ((1 + this.at) | 0);
    return new $c_sci_Vector6(this.a9, this.g6, this.fn, this.g7, this.fo, this.fK, this.fp, this.fm, this.fq, this.f5, this.ef, this.ev, this.eu, this.et, x$18, a, x$20);
  } else if ((this.et.a.length < 31)) {
    var x$35 = $m_sci_VectorStatics$().dO(this.et, $m_sci_VectorStatics$().dO(this.es, this.al));
    var x$36 = $m_sci_VectorStatics$().eg;
    var a$1 = new $ac_O(1);
    a$1.a[0] = elem;
    var x$38 = ((1 + this.at) | 0);
    return new $c_sci_Vector6(this.a9, this.g6, this.fn, this.g7, this.fo, this.fK, this.fp, this.fm, this.fq, this.f5, this.ef, this.ev, this.eu, x$35, x$36, a$1, x$38);
  } else if ((this.eu.a.length < 31)) {
    var x$52 = $m_sci_VectorStatics$().dO(this.eu, $m_sci_VectorStatics$().dO(this.et, $m_sci_VectorStatics$().dO(this.es, this.al)));
    var x$53 = $m_sci_VectorStatics$().hz;
    var x$54 = $m_sci_VectorStatics$().eg;
    var a$2 = new $ac_O(1);
    a$2.a[0] = elem;
    var x$56 = ((1 + this.at) | 0);
    return new $c_sci_Vector6(this.a9, this.g6, this.fn, this.g7, this.fo, this.fK, this.fp, this.fm, this.fq, this.f5, this.ef, this.ev, x$52, x$53, x$54, a$2, x$56);
  } else if ((this.ev.a.length < 31)) {
    var x$69 = $m_sci_VectorStatics$().dO(this.ev, $m_sci_VectorStatics$().dO(this.eu, $m_sci_VectorStatics$().dO(this.et, $m_sci_VectorStatics$().dO(this.es, this.al))));
    var x$70 = $m_sci_VectorStatics$().nn;
    var x$71 = $m_sci_VectorStatics$().hz;
    var x$72 = $m_sci_VectorStatics$().eg;
    var a$3 = new $ac_O(1);
    a$3.a[0] = elem;
    var x$74 = ((1 + this.at) | 0);
    return new $c_sci_Vector6(this.a9, this.g6, this.fn, this.g7, this.fo, this.fK, this.fp, this.fm, this.fq, this.f5, this.ef, x$69, x$70, x$71, x$72, a$3, x$74);
  } else if ((this.ef.a.length < 62)) {
    var x$86 = $m_sci_VectorStatics$().dO(this.ef, $m_sci_VectorStatics$().dO(this.ev, $m_sci_VectorStatics$().dO(this.eu, $m_sci_VectorStatics$().dO(this.et, $m_sci_VectorStatics$().dO(this.es, this.al)))));
    var x$87 = $m_sci_VectorStatics$().D5;
    var x$88 = $m_sci_VectorStatics$().nn;
    var x$89 = $m_sci_VectorStatics$().hz;
    var x$90 = $m_sci_VectorStatics$().eg;
    var a$4 = new $ac_O(1);
    a$4.a[0] = elem;
    var x$92 = ((1 + this.at) | 0);
    return new $c_sci_Vector6(this.a9, this.g6, this.fn, this.g7, this.fo, this.fK, this.fp, this.fm, this.fq, this.f5, x$86, x$87, x$88, x$89, x$90, a$4, x$92);
  } else {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  }
});
$p.mV = (function(elem) {
  if ((this.g6 < 32)) {
    var x$1 = $m_sci_VectorStatics$().Pd(elem, this.a9);
    var x$2 = ((1 + this.g6) | 0);
    var x$3 = ((1 + this.g7) | 0);
    var x$4 = ((1 + this.fK) | 0);
    var x$5 = ((1 + this.fm) | 0);
    var x$6 = ((1 + this.f5) | 0);
    var x$7 = ((1 + this.at) | 0);
    return new $c_sci_Vector6(x$1, x$2, this.fn, x$3, this.fo, x$4, this.fp, x$5, this.fq, x$6, this.ef, this.ev, this.eu, this.et, this.es, this.al, x$7);
  } else if ((this.g7 < 1024)) {
    var a = new $ac_O(1);
    a.a[0] = elem;
    var x$20 = $m_sci_VectorStatics$().cQ(this.a9, this.fn);
    var x$21 = ((1 + this.g7) | 0);
    var x$22 = ((1 + this.fK) | 0);
    var x$23 = ((1 + this.fm) | 0);
    var x$24 = ((1 + this.f5) | 0);
    var x$25 = ((1 + this.at) | 0);
    return new $c_sci_Vector6(a, 1, x$20, x$21, this.fo, x$22, this.fp, x$23, this.fq, x$24, this.ef, this.ev, this.eu, this.et, this.es, this.al, x$25);
  } else if ((this.fK < 32768)) {
    var a$1 = new $ac_O(1);
    a$1.a[0] = elem;
    var x$37 = $m_sci_VectorStatics$().eg;
    var x$39 = $m_sci_VectorStatics$().cQ($m_sci_VectorStatics$().cQ(this.a9, this.fn), this.fo);
    var x$40 = ((1 + this.fK) | 0);
    var x$41 = ((1 + this.fm) | 0);
    var x$42 = ((1 + this.f5) | 0);
    var x$43 = ((1 + this.at) | 0);
    return new $c_sci_Vector6(a$1, 1, x$37, 1, x$39, x$40, this.fp, x$41, this.fq, x$42, this.ef, this.ev, this.eu, this.et, this.es, this.al, x$43);
  } else if ((this.fm < 1048576)) {
    var a$2 = new $ac_O(1);
    a$2.a[0] = elem;
    var x$54 = $m_sci_VectorStatics$().eg;
    var x$56 = $m_sci_VectorStatics$().hz;
    var x$58 = $m_sci_VectorStatics$().cQ($m_sci_VectorStatics$().cQ($m_sci_VectorStatics$().cQ(this.a9, this.fn), this.fo), this.fp);
    var x$59 = ((1 + this.fm) | 0);
    var x$60 = ((1 + this.f5) | 0);
    var x$61 = ((1 + this.at) | 0);
    return new $c_sci_Vector6(a$2, 1, x$54, 1, x$56, 1, x$58, x$59, this.fq, x$60, this.ef, this.ev, this.eu, this.et, this.es, this.al, x$61);
  } else if ((this.f5 < 33554432)) {
    var a$3 = new $ac_O(1);
    a$3.a[0] = elem;
    var x$71 = $m_sci_VectorStatics$().eg;
    var x$73 = $m_sci_VectorStatics$().hz;
    var x$75 = $m_sci_VectorStatics$().nn;
    var x$77 = $m_sci_VectorStatics$().cQ($m_sci_VectorStatics$().cQ($m_sci_VectorStatics$().cQ($m_sci_VectorStatics$().cQ(this.a9, this.fn), this.fo), this.fp), this.fq);
    var x$78 = ((1 + this.f5) | 0);
    var x$79 = ((1 + this.at) | 0);
    return new $c_sci_Vector6(a$3, 1, x$71, 1, x$73, 1, x$75, 1, x$77, x$78, this.ef, this.ev, this.eu, this.et, this.es, this.al, x$79);
  } else if ((this.ef.a.length < 62)) {
    var a$4 = new $ac_O(1);
    a$4.a[0] = elem;
    var x$88 = $m_sci_VectorStatics$().eg;
    var x$90 = $m_sci_VectorStatics$().hz;
    var x$92 = $m_sci_VectorStatics$().nn;
    var x$94 = $m_sci_VectorStatics$().D5;
    var x$96 = $m_sci_VectorStatics$().cQ($m_sci_VectorStatics$().cQ($m_sci_VectorStatics$().cQ($m_sci_VectorStatics$().cQ($m_sci_VectorStatics$().cQ(this.a9, this.fn), this.fo), this.fp), this.fq), this.ef);
    var x$97 = ((1 + this.at) | 0);
    return new $c_sci_Vector6(a$4, 1, x$88, 1, x$90, 1, x$92, 1, x$94, 1, x$96, this.ev, this.eu, this.et, this.es, this.al, x$97);
  } else {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  }
});
$p.w9 = (function(f) {
  var x$1 = $m_sci_VectorStatics$().ub(this.a9, f);
  var x$2 = $m_sci_VectorStatics$().ho(2, this.fn, f);
  var x$3 = $m_sci_VectorStatics$().ho(3, this.fo, f);
  var x$4 = $m_sci_VectorStatics$().ho(4, this.fp, f);
  var x$5 = $m_sci_VectorStatics$().ho(5, this.fq, f);
  var x$6 = $m_sci_VectorStatics$().ho(6, this.ef, f);
  var x$7 = $m_sci_VectorStatics$().ho(5, this.ev, f);
  var x$8 = $m_sci_VectorStatics$().ho(4, this.eu, f);
  var x$9 = $m_sci_VectorStatics$().ho(3, this.et, f);
  var x$10 = $m_sci_VectorStatics$().ho(2, this.es, f);
  var x$11 = $m_sci_VectorStatics$().ub(this.al, f);
  return new $c_sci_Vector6(x$1, this.g6, x$2, this.g7, x$3, this.fK, x$4, this.fm, x$5, this.f5, x$6, x$7, x$8, x$9, x$10, x$11, this.at);
});
$p.mW = (function(lo, hi) {
  var b = new $c_sci_VectorSliceBuilder(lo, hi);
  b.eT(1, this.a9);
  b.eT(2, this.fn);
  b.eT(3, this.fo);
  b.eT(4, this.fp);
  b.eT(5, this.fq);
  b.eT(6, this.ef);
  b.eT(5, this.ev);
  b.eT(4, this.eu);
  b.eT(3, this.et);
  b.eT(2, this.es);
  b.eT(1, this.al);
  return b.bY();
});
$p.mX = (function() {
  if ((this.g6 > 1)) {
    var a = this.a9;
    var x$1 = $m_ju_Arrays$().d7(a, 1, a.a.length);
    var x$2 = ((this.g6 - 1) | 0);
    var x$3 = ((this.g7 - 1) | 0);
    var x$4 = ((this.fK - 1) | 0);
    var x$5 = ((this.fm - 1) | 0);
    var x$6 = ((this.f5 - 1) | 0);
    var x$7 = ((this.at - 1) | 0);
    return new $c_sci_Vector6(x$1, x$2, this.fn, x$3, this.fo, x$4, this.fp, x$5, this.fq, x$6, this.ef, this.ev, this.eu, this.et, this.es, this.al, x$7);
  } else {
    return this.mW(1, this.at);
  }
});
$p.r0 = (function() {
  if ((this.al.a.length > 1)) {
    var a = this.al;
    var x$1 = $m_ju_Arrays$().d7(a, 0, ((a.a.length - 1) | 0));
    var x$2 = ((this.at - 1) | 0);
    return new $c_sci_Vector6(this.a9, this.g6, this.fn, this.g7, this.fo, this.fK, this.fp, this.fm, this.fq, this.f5, this.ef, this.ev, this.eu, this.et, this.es, x$1, x$2);
  } else {
    return this.mW(0, ((this.at - 1) | 0));
  }
});
$p.um = (function() {
  return 11;
});
$p.wn = (function(idx) {
  switch (idx) {
    case 0: {
      return this.a9;
      break;
    }
    case 1: {
      return this.fn;
      break;
    }
    case 2: {
      return this.fo;
      break;
    }
    case 3: {
      return this.fp;
      break;
    }
    case 4: {
      return this.fq;
      break;
    }
    case 5: {
      return this.ef;
      break;
    }
    case 6: {
      return this.ev;
      break;
    }
    case 7: {
      return this.eu;
      break;
    }
    case 8: {
      return this.et;
      break;
    }
    case 9: {
      return this.es;
      break;
    }
    case 10: {
      return this.al;
      break;
    }
    default: {
      throw new $c_s_MatchError(idx);
    }
  }
});
$p.pn = (function(suffix, k) {
  var suffix1b = $m_sci_VectorStatics$().OX(this.al, suffix);
  if ((suffix1b !== null)) {
    var x$2 = ((((this.at - this.al.a.length) | 0) + suffix1b.a.length) | 0);
    return new $c_sci_Vector6(this.a9, this.g6, this.fn, this.g7, this.fo, this.fK, this.fp, this.fm, this.fq, this.f5, this.ef, this.ev, this.eu, this.et, this.es, suffix1b, x$2);
  } else {
    return $c_sci_Vector.prototype.pn.call(this, suffix, k);
  }
});
$p.lX = (function() {
  return this.r0();
});
$p.v = (function() {
  return this.mX();
});
$p.L = (function(f) {
  return this.w9(f);
});
$p.kv = (function(elem) {
  return this.mV(elem);
});
$p.bv = (function(elem) {
  return this.lg(elem);
});
$p.i = (function(v1) {
  var index = (v1 | 0);
  if (((index >= 0) && (index < this.at))) {
    var io = ((index - this.f5) | 0);
    if ((io >= 0)) {
      var i6 = ((io >>> 25) | 0);
      var i5 = (31 & ((io >>> 20) | 0));
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i6 < this.ef.a.length) ? this.ef.a[i6].a[i5].a[i4].a[i3].a[i2].a[i1] : ((i5 < this.ev.a.length) ? this.ev.a[i5].a[i4].a[i3].a[i2].a[i1] : ((i4 < this.eu.a.length) ? this.eu.a[i4].a[i3].a[i2].a[i1] : ((i3 < this.et.a.length) ? this.et.a[i3].a[i2].a[i1] : ((i2 < this.es.a.length) ? this.es.a[i2].a[i1] : this.al.a[i1])))));
    } else if ((index >= this.fm)) {
      var io$2 = ((index - this.fm) | 0);
      return this.fq.a[((io$2 >>> 20) | 0)].a[(31 & ((io$2 >>> 15) | 0))].a[(31 & ((io$2 >>> 10) | 0))].a[(31 & ((io$2 >>> 5) | 0))].a[(31 & io$2)];
    } else if ((index >= this.fK)) {
      var io$3 = ((index - this.fK) | 0);
      return this.fp.a[((io$3 >>> 15) | 0)].a[(31 & ((io$3 >>> 10) | 0))].a[(31 & ((io$3 >>> 5) | 0))].a[(31 & io$3)];
    } else if ((index >= this.g7)) {
      var io$4 = ((index - this.g7) | 0);
      return this.fo.a[((io$4 >>> 10) | 0)].a[(31 & ((io$4 >>> 5) | 0))].a[(31 & io$4)];
    } else if ((index >= this.g6)) {
      var io$5 = ((index - this.g6) | 0);
      return this.fn.a[((io$5 >>> 5) | 0)].a[(31 & io$5)];
    } else {
      return this.a9.a[index];
    }
  } else {
    throw this.ks(index);
  }
});
function $isArrayOf_sci_Vector6(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ly)));
}
var $d_sci_Vector6 = new $TypeData().i($c_sci_Vector6, "scala.collection.immutable.Vector6", ({
  ly: 1,
  br: 1,
  bs: 1,
  bd: 1,
  a6: 1,
  L: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  H: 1,
  i: 1,
  h: 1,
  w: 1,
  b: 1,
  X: 1,
  I: 1,
  a2: 1,
  a7: 1,
  M: 1,
  A: 1,
  ae: 1,
  a8: 1,
  N: 1,
  z: 1,
  a5: 1,
  a: 1
}));
function $ct_scm_StringBuilder__jl_StringBuilder__($thiz, underlying) {
  $thiz.bP = underlying;
  return $thiz;
}
function $ct_scm_StringBuilder__($thiz) {
  $ct_scm_StringBuilder__jl_StringBuilder__($thiz, $ct_jl_StringBuilder__(new $c_jl_StringBuilder()));
  return $thiz;
}
function $ct_scm_StringBuilder__I__($thiz, capacity) {
  $ct_scm_StringBuilder__jl_StringBuilder__($thiz, $ct_jl_StringBuilder__I__(new $c_jl_StringBuilder(), capacity));
  return $thiz;
}
function $ct_scm_StringBuilder__T__($thiz, str) {
  $ct_scm_StringBuilder__jl_StringBuilder__($thiz, $ct_jl_StringBuilder__T__(new $c_jl_StringBuilder(), str));
  return $thiz;
}
/** @constructor */
function $c_scm_StringBuilder() {
  this.bP = null;
}
$p = $c_scm_StringBuilder.prototype = new $h_scm_AbstractSeq();
$p.constructor = $c_scm_StringBuilder;
/** @constructor */
function $h_scm_StringBuilder() {
}
$h_scm_StringBuilder.prototype = $p;
$p.Y4 = (function(ord) {
  return $f_scm_IndexedSeqOps__sortInPlace__s_math_Ordering__scm_IndexedSeqOps(this, ord);
});
$p.el = (function() {
  return "IndexedSeq";
});
$p.o = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), new $c_sc_IndexedSeqView$Id(this));
});
$p.cx = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), new $c_sc_IndexedSeqView$Id(this));
});
$p.k0 = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$p.ds = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n);
});
$p.cn = (function(n) {
  return $f_sc_IndexedSeqOps__dropRight__I__O(this, n);
});
$p.L = (function(f) {
  return $f_sc_IndexedSeqOps__map__F1__O(this, f);
});
$p.hU = (function() {
  return $f_sc_IndexedSeqOps__reverse__O(this);
});
$p.hV = (function(from, until) {
  return $f_sc_IndexedSeqOps__slice__I__I__O(this, from, until);
});
$p.t = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$p.dt = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$p.bJ = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$p.bL = (function(len) {
  var x = this.bP.C();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$p.f9 = (function(size) {
});
$p.dG = (function(elems) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, elems);
});
$p.fS = (function() {
  return $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), $ct_scm_StringBuilder__(new $c_scm_StringBuilder()));
});
$p.C = (function() {
  return this.bP.C();
});
$p.V = (function() {
  return this.bP.C();
});
$p.id = (function(x) {
  var this$1 = this.bP;
  var str = ("" + $cToS(x));
  this$1.ah = (this$1.ah + str);
  return this;
});
$p.ad = (function(s) {
  var this$1 = this.bP;
  this$1.ah = (("" + this$1.ah) + s);
  return this;
});
$p.m = (function() {
  return this.bP.ah;
});
$p.nG = (function(ct) {
  return ((ct.h8() === $d_C.l()) ? this.aSS() : $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, ct));
});
$p.aSS = (function() {
  var len = this.bP.C();
  var arr = new $ac_C(len);
  this.bP.aOP(0, len, arr, 0);
  return arr;
});
$p.ei = (function(s) {
  var this$1 = this.bP;
  this$1.ah = (("" + this$1.ah) + s);
  return this;
});
$p.aM1 = (function(xs) {
  if ((xs instanceof $c_sci_WrappedString)) {
    var this$3 = this.bP;
    var str = xs.iG;
    this$3.ah = (("" + this$3.ah) + str);
  } else if ((xs instanceof $c_scm_ArraySeq$ofChar)) {
    this.bP.aM0(xs.pb);
  } else if ((xs instanceof $c_scm_StringBuilder)) {
    var this$4 = this.bP;
    var s = xs.bP;
    this$4.ah = (("" + this$4.ah) + s);
  } else {
    var ks = xs.V();
    if ((ks !== 0)) {
      var b = this.bP;
      if ((ks > 0)) {
        b.C();
      }
      var it = xs.o();
      while (it.p()) {
        var c = $uC(it.q());
        var str$1 = ("" + $cToS(c));
        b.ah = (b.ah + str$1);
      }
    }
  }
  return this;
});
$p.jl = (function(x) {
  var this$1 = this.bP;
  var str = ("" + $cToS(x));
  this$1.ah = (this$1.ah + str);
  return this;
});
$p.y1 = (function(index) {
  return this.bP.y1(index);
});
$p.Y2 = (function(index, ch) {
  this.bP.aS4(index, ch);
  return this;
});
$p.Jp = (function(start, end) {
  return this.bP.aic(start, end);
});
$p.c = (function() {
  return (this.bP.C() === 0);
});
$p.cd = (function() {
  return $m_scm_IndexedSeq$();
});
$p.cM = (function(idx, elem) {
  var elem$1 = $uC(elem);
  this.bP.aS4(idx, elem$1);
});
$p.aR = (function() {
  return this.bP.ah;
});
$p.Y = (function(elem) {
  return this.id($uC(elem));
});
$p.pr = (function() {
  return $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
});
$p.fP = (function(coll) {
  return $ct_scm_StringBuilder__(new $c_scm_StringBuilder()).aM1(coll);
});
$p.w4 = (function(coll) {
  return $ct_scm_StringBuilder__(new $c_scm_StringBuilder()).aM1(coll);
});
$p.i = (function(v1) {
  var i = (v1 | 0);
  return $bC(this.bP.y1(i));
});
$p.l = (function(i) {
  return $bC(this.bP.y1(i));
});
function $isArrayOf_scm_StringBuilder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.lV)));
}
var $d_scm_StringBuilder = new $TypeData().i($c_scm_StringBuilder, "scala.collection.mutable.StringBuilder", ({
  lV: 1,
  an: 1,
  L: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  H: 1,
  i: 1,
  h: 1,
  w: 1,
  b: 1,
  ao: 1,
  aa: 1,
  ap: 1,
  a9: 1,
  W: 1,
  b2: 1,
  Y: 1,
  T: 1,
  S: 1,
  au: 1,
  M: 1,
  A: 1,
  av: 1,
  aX: 1,
  a: 1
}));
function $p_scm_LinkedHashMap__removeEntry0__O__scm_LinkedHashMap$LinkedEntry($thiz, elem) {
  var originalHash = $m_sr_Statics$().u(elem);
  return $p_scm_LinkedHashMap__removeEntry0__O__I__scm_LinkedHashMap$LinkedEntry($thiz, elem, (originalHash ^ ((originalHash >>> 16) | 0)));
}
function $p_scm_LinkedHashMap__removeEntry0__O__I__scm_LinkedHashMap$LinkedEntry($thiz, elem, hash) {
  var idx = (hash & (($thiz.au.a.length - 1) | 0));
  var x1 = $thiz.au.a[idx];
  if ((x1 === null)) {
    return null;
  } else if (((x1.pd === hash) && $m_sr_BoxesRunTime$().Q(x1.nq, elem))) {
    $thiz.au.a[idx] = x1.i7;
    $p_scm_LinkedHashMap__deleteEntry__scm_LinkedHashMap$LinkedEntry__V($thiz, x1);
    $thiz.e0 = (($thiz.e0 - 1) | 0);
    return x1;
  } else {
    var prev = x1;
    var next = x1.i7;
    while (((next !== null) && (next.pd <= hash))) {
      if (((next.pd === hash) && $m_sr_BoxesRunTime$().Q(next.nq, elem))) {
        prev.i7 = next.i7;
        $p_scm_LinkedHashMap__deleteEntry__scm_LinkedHashMap$LinkedEntry__V($thiz, next);
        $thiz.e0 = (($thiz.e0 - 1) | 0);
        return next;
      }
      prev = next;
      next = next.i7;
    }
    return null;
  }
}
function $p_scm_LinkedHashMap__tableSizeFor__I__I($thiz, capacity) {
  var x = ((capacity - 1) | 0);
  var i = ((x > 4) ? x : 4);
  var x$1 = ((((-2147483648) >> Math.clz32(i)) & i) << 1);
  return ((x$1 < 1073741824) ? x$1 : 1073741824);
}
function $p_scm_LinkedHashMap__newThreshold__I__I($thiz, size) {
  return $doubleToInt((0.75 * size));
}
function $p_scm_LinkedHashMap__createNewEntry__O__I__O__scm_LinkedHashMap$LinkedEntry($thiz, key, hash, value) {
  var e = new $c_scm_LinkedHashMap$LinkedEntry(key, hash, value);
  if (($thiz.tL === null)) {
    $thiz.tL = e;
  } else {
    $thiz.D8.vH = e;
    e.D9 = $thiz.D8;
  }
  $thiz.D8 = e;
  return e;
}
function $p_scm_LinkedHashMap__deleteEntry__scm_LinkedHashMap$LinkedEntry__V($thiz, e) {
  if ((e.D9 === null)) {
    $thiz.tL = e.vH;
  } else {
    e.D9.vH = e.vH;
  }
  if ((e.vH === null)) {
    $thiz.D8 = e.D9;
  } else {
    e.vH.D9 = e.D9;
  }
  e.D9 = null;
  e.vH = null;
  e.i7 = null;
}
function $p_scm_LinkedHashMap__put0__O__O__Z__s_Some($thiz, key, value, getOld) {
  if ((((1 + $thiz.e0) | 0) >= $thiz.ki)) {
    $p_scm_LinkedHashMap__growTable__I__V($thiz, ($thiz.au.a.length << 1));
  }
  var originalHash = $m_sr_Statics$().u(key);
  var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  return $p_scm_LinkedHashMap__put0__O__O__Z__I__I__s_Some($thiz, key, value, getOld, hash, (hash & (($thiz.au.a.length - 1) | 0)));
}
function $p_scm_LinkedHashMap__put0__O__O__Z__I__I__s_Some($thiz, key, value, getOld, hash, idx) {
  var x1 = $thiz.au.a[idx];
  if ((x1 === null)) {
    $thiz.au.a[idx] = $p_scm_LinkedHashMap__createNewEntry__O__I__O__scm_LinkedHashMap$LinkedEntry($thiz, key, hash, value);
  } else {
    var prev = null;
    var n = x1;
    while (((n !== null) && (n.pd <= hash))) {
      if (((n.pd === hash) && $m_sr_BoxesRunTime$().Q(key, n.nq))) {
        var old = n.fs;
        n.fs = value;
        return (getOld ? new $c_s_Some(old) : null);
      }
      prev = n;
      n = n.i7;
    }
    var nnode = $p_scm_LinkedHashMap__createNewEntry__O__I__O__scm_LinkedHashMap$LinkedEntry($thiz, key, hash, value);
    if ((prev === null)) {
      nnode.i7 = x1;
      $thiz.au.a[idx] = nnode;
    } else {
      nnode.i7 = prev.i7;
      prev.i7 = nnode;
    }
  }
  $thiz.e0 = ((1 + $thiz.e0) | 0);
  return null;
}
function $p_scm_LinkedHashMap__growTable__I__V($thiz, newlen) {
  if ((newlen < 0)) {
    throw $ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), (("new hash table size " + newlen) + " exceeds maximum"));
  }
  var oldlen = $thiz.au.a.length;
  $thiz.ki = $p_scm_LinkedHashMap__newThreshold__I__I($thiz, newlen);
  if (($thiz.e0 === 0)) {
    $thiz.au = new ($d_scm_LinkedHashMap$LinkedEntry.r().C)(newlen);
  } else {
    $thiz.au = $m_ju_Arrays$().ex($thiz.au, newlen);
    var preLow = new $c_scm_LinkedHashMap$LinkedEntry(null, 0, null);
    var preHigh = new $c_scm_LinkedHashMap$LinkedEntry(null, 0, null);
    while ((oldlen < newlen)) {
      var i = 0;
      while ((i < oldlen)) {
        var old = $thiz.au.a[i];
        if ((old !== null)) {
          preLow.i7 = null;
          preHigh.i7 = null;
          var lastLow = preLow;
          var lastHigh = preHigh;
          var n = old;
          while ((n !== null)) {
            var next = n.i7;
            if (((n.pd & oldlen) === 0)) {
              lastLow.i7 = n;
              lastLow = n;
            } else {
              lastHigh.i7 = n;
              lastHigh = n;
            }
            n = next;
          }
          lastLow.i7 = null;
          if ((old !== preLow.i7)) {
            $thiz.au.a[i] = preLow.i7;
          }
          if ((preHigh.i7 !== null)) {
            $thiz.au.a[((i + oldlen) | 0)] = preHigh.i7;
            lastHigh.i7 = null;
          }
        }
        i = ((1 + i) | 0);
      }
      oldlen = (oldlen << 1);
    }
  }
}
/** @constructor */
function $c_scm_LinkedHashMap() {
  this.tL = null;
  this.D8 = null;
  this.au = null;
  this.ki = 0;
  this.e0 = 0;
  this.tL = null;
  this.D8 = null;
  this.au = new ($d_scm_LinkedHashMap$LinkedEntry.r().C)($p_scm_LinkedHashMap__tableSizeFor__I__I(this, 16));
  this.ki = $p_scm_LinkedHashMap__newThreshold__I__I(this, this.au.a.length);
  this.e0 = 0;
}
$p = $c_scm_LinkedHashMap.prototype = new $h_scm_AbstractMap();
$p.constructor = $c_scm_LinkedHashMap;
/** @constructor */
function $h_scm_LinkedHashMap() {
}
$h_scm_LinkedHashMap.prototype = $p;
$p.kP = (function(f) {
  return $f_sc_StrictOptimizedMapOps__map__F1__sc_IterableOps(this, f);
});
$p.hN = (function(suffix) {
  return $f_sc_StrictOptimizedMapOps__concat__sc_IterableOnce__sc_IterableOps(this, suffix);
});
$p.fa = (function(asPair) {
  return $f_sc_StrictOptimizedIterableOps__unzip__F1__T2(this, asPair);
});
$p.L = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$p.c5 = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.ct = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.dk = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bw = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$p.cE = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true);
});
$p.fy = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__partitionMap__F1__T2(this, f);
});
$p.cn = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$p.im = (function() {
  return $m_scm_LinkedHashMap$();
});
$p.Xs = (function() {
  if ((this.e0 > 0)) {
    return new $c_T2(this.D8.nq, this.D8.fs);
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "Cannot call .last on empty LinkedHashMap");
  }
});
$p.agp = (function() {
  if ((this.e0 > 0)) {
    return new $c_T2(this.tL.nq, this.tL.fs);
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "Cannot call .head on empty LinkedHashMap");
  }
});
$p.dt = (function() {
  return ((this.e0 > 0) ? new $c_s_Some(new $c_T2(this.tL.nq, this.tL.fs)) : $m_s_None$());
});
$p.aa = (function() {
  return this.e0;
});
$p.V = (function() {
  return this.e0;
});
$p.c = (function() {
  return (this.e0 === 0);
});
$p.r = (function(key) {
  var originalHash = $m_sr_Statics$().u(key);
  var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  var x1 = this.au.a[(hash & ((this.au.a.length - 1) | 0))];
  var e = ((x1 === null) ? null : x1.ij(key, hash));
  return ((e === null) ? $m_s_None$() : new $c_s_Some(e.fs));
});
$p.f9 = (function(size) {
  var target = $p_scm_LinkedHashMap__tableSizeFor__I__I(this, $doubleToInt((((1 + size) | 0) / 0.75)));
  if ((target > this.au.a.length)) {
    $p_scm_LinkedHashMap__growTable__I__V(this, target);
  }
});
$p.E = (function(key) {
  if (($objectGetClass(this) === $d_scm_LinkedHashMap.l())) {
    var originalHash = $m_sr_Statics$().u(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var x1 = this.au.a[(hash & ((this.au.a.length - 1) | 0))];
    return (((x1 === null) ? null : x1.ij(key, hash)) !== null);
  } else {
    return $f_sc_MapOps__contains__O__Z(this, key);
  }
});
$p.ue = (function(key, value) {
  var x1 = $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(this, key, value, true);
  return ((x1 === null) ? $m_s_None$() : x1);
});
$p.cY = (function(key, value) {
  $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(this, key, value, false);
});
$p.AD = (function(key) {
  var x1 = $p_scm_LinkedHashMap__removeEntry0__O__scm_LinkedHashMap$LinkedEntry(this, key);
  return ((x1 === null) ? $m_s_None$() : new $c_s_Some(x1.fs));
});
$p.ay = (function(key, default$1) {
  if ((!($objectGetClass(this) === $d_scm_LinkedHashMap.l()))) {
    return $f_sc_MapOps__getOrElse__O__F0__O(this, key, default$1);
  } else {
    var originalHash = $m_sr_Statics$().u(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var x1 = this.au.a[(hash & ((this.au.a.length - 1) | 0))];
    var nd = ((x1 === null) ? null : x1.ij(key, hash));
    return ((nd === null) ? default$1.a3() : nd.fs);
  }
});
$p.ec = (function(key, defaultValue) {
  if ((!($objectGetClass(this) === $d_scm_LinkedHashMap.l()))) {
    return $f_scm_MapOps__getOrElseUpdate__O__F0__O(this, key, defaultValue);
  } else {
    var originalHash = $m_sr_Statics$().u(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var idx = (hash & ((this.au.a.length - 1) | 0));
    var x1 = this.au.a[idx];
    var nd = ((x1 === null) ? null : x1.ij(key, hash));
    if ((nd !== null)) {
      return nd.fs;
    } else {
      var table0 = this.au;
      var default$1 = defaultValue.a3();
      if ((((1 + this.e0) | 0) >= this.ki)) {
        $p_scm_LinkedHashMap__growTable__I__V(this, (this.au.a.length << 1));
      }
      $p_scm_LinkedHashMap__put0__O__O__Z__I__I__s_Some(this, key, default$1, false, hash, ((table0 === this.au) ? idx : (hash & ((this.au.a.length - 1) | 0))));
      return default$1;
    }
  }
});
$p.aWM = (function(kv) {
  this.ue(kv.g(), kv.h());
  return this;
});
$p.b9q = (function(key) {
  this.AD(key);
  return this;
});
$p.o = (function() {
  return ((this.e0 === 0) ? $m_sc_Iterator$().b8 : new $c_scm_LinkedHashMap$$anon$1(this));
});
$p.a41 = (function() {
  return new $c_scm_LinkedHashMap$LinkedKeySet(this);
});
$p.lo = (function() {
  return ((this.e0 === 0) ? $m_sc_Iterator$().b8 : new $c_scm_LinkedHashMap$$anon$2(this));
});
$p.afu = (function() {
  return ((this.e0 === 0) ? $m_sc_Iterator$().b8 : new $c_scm_LinkedHashMap$$anon$3(this));
});
$p.hr = (function() {
  return ((this.e0 === 0) ? $m_sc_Iterator$().b8 : new $c_scm_LinkedHashMap$$anon$4(this));
});
$p.F = (function(f) {
  var cur = this.tL;
  while ((cur !== null)) {
    f.i(new $c_T2(cur.nq, cur.fs));
    cur = cur.vH;
  }
});
$p.pu = (function(f) {
  var cur = this.tL;
  while ((cur !== null)) {
    f.R(cur.nq, cur.fs);
    cur = cur.vH;
  }
});
$p.ie = (function() {
  $m_ju_Arrays$().WM(this.au, null);
  this.e0 = 0;
  this.tL = null;
  this.D8 = null;
});
$p.x = (function() {
  if (this.c()) {
    return $m_s_util_hashing_MurmurHash3$().Vx;
  } else {
    var tupleHashIterator = new $c_scm_LinkedHashMap$$anon$5(this);
    return $m_s_util_hashing_MurmurHash3$().Em(tupleHashIterator, $m_s_util_hashing_MurmurHash3$().xL);
  }
});
$p.el = (function() {
  return "LinkedHashMap";
});
$p.re = (function(elem) {
  return this.b9q(elem);
});
$p.Y = (function(elem) {
  return this.aWM(elem);
});
$p.bJ = (function() {
  return this.Xs();
});
function $isArrayOf_scm_LinkedHashMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.lQ)));
}
var $d_scm_LinkedHashMap = new $TypeData().i($c_scm_LinkedHashMap, "scala.collection.mutable.LinkedHashMap", ({
  lQ: 1,
  cR: 1,
  aL: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  as: 1,
  ak: 1,
  i: 1,
  h: 1,
  aF: 1,
  b: 1,
  bt: 1,
  aa: 1,
  c6: 1,
  a9: 1,
  W: 1,
  Y: 1,
  T: 1,
  S: 1,
  aM: 1,
  Ko: 1,
  dy: 1,
  z: 1,
  c0: 1,
  a5: 1,
  a: 1
}));
function $p_scm_ListBuffer__copyElems__V($thiz) {
  var buf = new $c_scm_ListBuffer().kU($thiz);
  $thiz.i9 = buf.i9;
  $thiz.ia = buf.ia;
  $thiz.Vf = false;
}
function $p_scm_ListBuffer__ensureUnaliased__V($thiz) {
  $thiz.Ob = ((1 + $thiz.Ob) | 0);
  if ($thiz.Vf) {
    $p_scm_ListBuffer__copyElems__V($thiz);
  }
}
function $p_scm_ListBuffer__predecessor__I__sci_$colon$colon($thiz, i) {
  if ((i === 0)) {
    return null;
  } else if ((i === $thiz.eb)) {
    return $thiz.ia;
  } else {
    var j = ((i - 1) | 0);
    var p = $thiz.i9;
    while ((j > 0)) {
      p = p.v();
      j = ((j - 1) | 0);
    }
    return p;
  }
}
function $p_scm_ListBuffer__getNext__sci_$colon$colon__sci_List($thiz, p) {
  return ((p === null) ? $thiz.i9 : p.U);
}
function $p_scm_ListBuffer__insertAfter__sci_$colon$colon__scm_ListBuffer__V($thiz, prev, fresh) {
  if ((!fresh.c())) {
    var follow = $p_scm_ListBuffer__getNext__sci_$colon$colon__sci_List($thiz, prev);
    if ((prev === null)) {
      $thiz.i9 = fresh.i9;
    } else {
      prev.U = fresh.i9;
    }
    fresh.ia.U = follow;
    if (follow.c()) {
      $thiz.ia = fresh.ia;
    }
    $thiz.eb = (($thiz.eb + fresh.eb) | 0);
  }
}
function $p_scm_ListBuffer__removeAfter__sci_$colon$colon__I__V($thiz, prev, n) {
  var nx = $p_scm_ListBuffer__ahead$1__sci_List__I__sci_List($thiz, $p_scm_ListBuffer__getNext__sci_$colon$colon__sci_List($thiz, prev), n);
  if ((prev === null)) {
    $thiz.i9 = nx;
  } else {
    prev.U = nx;
  }
  if (nx.c()) {
    $thiz.ia = prev;
  }
  $thiz.eb = (($thiz.eb - n) | 0);
}
function $p_scm_ListBuffer__ahead$1__sci_List__I__sci_List($thiz, p, n) {
  while (true) {
    if ((n === 0)) {
      return p;
    } else {
      var temp$p = p.v();
      var temp$n = ((n - 1) | 0);
      p = temp$p;
      n = temp$n;
    }
  }
}
/** @constructor */
function $c_scm_ListBuffer() {
  this.Ob = 0;
  this.i9 = null;
  this.ia = null;
  this.Vf = false;
  this.eb = 0;
  this.Ob = 0;
  this.i9 = $m_sci_Nil$();
  this.ia = null;
  this.Vf = false;
  this.eb = 0;
}
$p = $c_scm_ListBuffer.prototype = new $h_scm_AbstractBuffer();
$p.constructor = $c_scm_ListBuffer;
/** @constructor */
function $h_scm_ListBuffer() {
}
$h_scm_ListBuffer.prototype = $p;
$p.f9 = (function(size) {
});
$p.ko = (function(f) {
  return $f_sc_StrictOptimizedSeqOps__distinctBy__F1__O(this, f);
});
$p.bv = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__appended__O__O(this, elem);
});
$p.gU = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix);
});
$p.fa = (function(asPair) {
  return $f_sc_StrictOptimizedIterableOps__unzip__F1__T2(this, asPair);
});
$p.L = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$p.c5 = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.ct = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.dk = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bw = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$p.cE = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true);
});
$p.fy = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__partitionMap__F1__T2(this, f);
});
$p.cn = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$p.o = (function() {
  return new $c_scm_MutationTracker$CheckedIterator(this.i9.o(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.Ob)));
});
$p.nB = (function() {
  return $m_scm_ListBuffer$();
});
$p.l = (function(i) {
  return $f_sc_LinearSeqOps__apply__I__O(this.i9, i);
});
$p.C = (function() {
  return this.eb;
});
$p.V = (function() {
  return this.eb;
});
$p.c = (function() {
  return (this.eb === 0);
});
$p.bM = (function() {
  this.Vf = (!this.c());
  return this.i9;
});
$p.b6M = (function(xs) {
  if (this.c()) {
    return xs;
  } else {
    $p_scm_ListBuffer__ensureUnaliased__V(this);
    this.ia.U = xs;
    return this.bM();
  }
});
$p.ie = (function() {
  this.Ob = ((1 + this.Ob) | 0);
  this.i9 = $m_sci_Nil$();
  this.eb = 0;
  this.ia = null;
  this.Vf = false;
});
$p.bb = (function(elem) {
  $p_scm_ListBuffer__ensureUnaliased__V(this);
  var last1 = new $c_sci_$colon$colon(elem, $m_sci_Nil$());
  if ((this.eb === 0)) {
    this.i9 = last1;
  } else {
    this.ia.U = last1;
  }
  this.ia = last1;
  this.eb = ((1 + this.eb) | 0);
  return this;
});
$p.kU = (function(xs) {
  var it = xs.o();
  if (it.p()) {
    var len = 1;
    var last0 = new $c_sci_$colon$colon(it.q(), $m_sci_Nil$());
    this.i9 = last0;
    while (it.p()) {
      var last1 = new $c_sci_$colon$colon(it.q(), $m_sci_Nil$());
      last0.U = last1;
      last0 = last1;
      len = ((1 + len) | 0);
    }
    this.eb = len;
    this.ia = last0;
  }
  return this;
});
$p.aeB = (function(xs) {
  var it = xs.o();
  if (it.p()) {
    var fresh = new $c_scm_ListBuffer().kU(it);
    $p_scm_ListBuffer__ensureUnaliased__V(this);
    if ((this.eb === 0)) {
      this.i9 = fresh.i9;
    } else {
      this.ia.U = fresh.i9;
    }
    this.ia = fresh.ia;
    this.eb = ((this.eb + fresh.eb) | 0);
  }
  return this;
});
$p.cM = (function(idx, elem) {
  $p_scm_ListBuffer__ensureUnaliased__V(this);
  if (((idx < 0) || (idx >= this.eb))) {
    throw $m_scg_CommonErrors$().h2(idx, ((this.eb - 1) | 0));
  }
  if ((idx === 0)) {
    var newElem = new $c_sci_$colon$colon(elem, this.i9.v());
    if ((this.ia === this.i9)) {
      this.ia = newElem;
    }
    this.i9 = newElem;
  } else {
    var p = $p_scm_ListBuffer__predecessor__I__sci_$colon$colon(this, idx);
    var newElem$2 = new $c_sci_$colon$colon(elem, p.U.v());
    if ((this.ia === p.U)) {
      this.ia = newElem$2;
    }
    p.U = newElem$2;
  }
});
$p.a3M = (function(idx, elem) {
  $p_scm_ListBuffer__ensureUnaliased__V(this);
  if (((idx < 0) || (idx > this.eb))) {
    throw $m_scg_CommonErrors$().h2(idx, ((this.eb - 1) | 0));
  }
  if ((idx === this.eb)) {
    this.bb(elem);
  } else {
    var p = $p_scm_ListBuffer__predecessor__I__sci_$colon$colon(this, idx);
    var nx = new $c_sci_$colon$colon(elem, $p_scm_ListBuffer__getNext__sci_$colon$colon__sci_List(this, p));
    if ((p === null)) {
      this.i9 = nx;
    } else {
      p.U = nx;
    }
    this.eb = ((1 + this.eb) | 0);
  }
});
$p.Px = (function(idx, elems) {
  if (((idx < 0) || (idx > this.eb))) {
    throw $m_scg_CommonErrors$().h2(idx, ((this.eb - 1) | 0));
  }
  var it = elems.o();
  if (it.p()) {
    if ((idx === this.eb)) {
      this.aeB(it);
    } else {
      var fresh = new $c_scm_ListBuffer().kU(it);
      $p_scm_ListBuffer__ensureUnaliased__V(this);
      $p_scm_ListBuffer__insertAfter__sci_$colon$colon__scm_ListBuffer__V(this, $p_scm_ListBuffer__predecessor__I__sci_$colon$colon(this, idx), fresh);
    }
  }
});
$p.wd = (function(idx) {
  $p_scm_ListBuffer__ensureUnaliased__V(this);
  if (((idx < 0) || (idx >= this.eb))) {
    throw $m_scg_CommonErrors$().h2(idx, ((this.eb - 1) | 0));
  }
  var p = $p_scm_ListBuffer__predecessor__I__sci_$colon$colon(this, idx);
  var nx = $p_scm_ListBuffer__getNext__sci_$colon$colon__sci_List(this, p);
  if ((p === null)) {
    this.i9 = nx.v();
    if (this.i9.c()) {
      this.ia = null;
    }
  } else {
    if ((this.ia === nx)) {
      this.ia = p;
    }
    p.U = nx.v();
  }
  this.eb = ((this.eb - 1) | 0);
  return nx.t();
});
$p.XQ = (function(idx, count) {
  if ((count > 0)) {
    $p_scm_ListBuffer__ensureUnaliased__V(this);
    if (((idx < 0) || (((idx + count) | 0) > this.eb))) {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((((idx + " to ") + ((idx + count) | 0)) + " is out of bounds (min 0, max ") + ((this.eb - 1) | 0)) + ")"));
    }
    $p_scm_ListBuffer__removeAfter__sci_$colon$colon__I__V(this, $p_scm_ListBuffer__predecessor__I__sci_$colon$colon(this, idx), count);
  } else if ((count < 0)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("removing negative number of elements: " + count));
  }
});
$p.bJ = (function() {
  if ((this.ia === null)) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "last of empty ListBuffer");
  } else {
    return this.ia.er;
  }
});
$p.el = (function() {
  return "ListBuffer";
});
$p.dG = (function(elems) {
  return this.aeB(elems);
});
$p.Y = (function(elem) {
  return this.bb(elem);
});
$p.aR = (function() {
  return this.bM();
});
$p.i = (function(v1) {
  var i = (v1 | 0);
  return $f_sc_LinearSeqOps__apply__I__O(this.i9, i);
});
$p.cd = (function() {
  return $m_scm_ListBuffer$();
});
function $isArrayOf_scm_ListBuffer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.lS)));
}
var $d_scm_ListBuffer = new $TypeData().i($c_scm_ListBuffer, "scala.collection.mutable.ListBuffer", ({
  lS: 1,
  bG: 1,
  an: 1,
  L: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  H: 1,
  i: 1,
  h: 1,
  w: 1,
  b: 1,
  ao: 1,
  aa: 1,
  ap: 1,
  a9: 1,
  W: 1,
  bH: 1,
  T: 1,
  S: 1,
  aM: 1,
  N: 1,
  z: 1,
  b2: 1,
  Y: 1,
  a5: 1,
  a: 1
}));
/** @constructor */
function $c_Lio_laminext_syntax_core$() {
  $n_Lio_laminext_syntax_core$ = this;
  $f_Lio_laminext_syntax_ReceiversSyntax__$init$__V(this);
}
$p = $c_Lio_laminext_syntax_core$.prototype = new $h_O();
$p.constructor = $c_Lio_laminext_syntax_core$;
/** @constructor */
function $h_Lio_laminext_syntax_core$() {
}
$h_Lio_laminext_syntax_core$.prototype = $p;
var $d_Lio_laminext_syntax_core$ = new $TypeData().i($c_Lio_laminext_syntax_core$, "io.laminext.syntax.core$", ({
  rP: 1,
  rL: 1,
  rx: 1,
  ry: 1,
  rK: 1,
  rG: 1,
  rI: 1,
  rJ: 1,
  rH: 1,
  rF: 1,
  rr: 1,
  rp: 1,
  rq: 1,
  rO: 1,
  ro: 1,
  rn: 1,
  rs: 1,
  ru: 1,
  rM: 1,
  rA: 1,
  rB: 1,
  rv: 1,
  rN: 1,
  rz: 1,
  rD: 1,
  rw: 1,
  rE: 1,
  rt: 1,
  rQ: 1,
  rC: 1,
  rm: 1
}));
var $n_Lio_laminext_syntax_core$;
function $m_Lio_laminext_syntax_core$() {
  if ((!$n_Lio_laminext_syntax_core$)) {
    $n_Lio_laminext_syntax_core$ = new $c_Lio_laminext_syntax_core$();
  }
  return $n_Lio_laminext_syntax_core$;
}
function $p_scm_ArrayBuffer__reduceToSize__I__V($thiz, n) {
  $thiz.no = ((1 + $thiz.no) | 0);
  $m_ju_Arrays$().b1c($thiz.hl, n, $thiz.a1, null);
  $thiz.a1 = n;
}
function $p_scm_ArrayBuffer__foldl__I__I__O__F2__O($thiz, start, end, z, op) {
  while (true) {
    if ((start === end)) {
      return z;
    } else {
      var temp$start = ((1 + start) | 0);
      var temp$z = op.R(z, $thiz.hl.a[start]);
      start = temp$start;
      z = temp$z;
    }
  }
}
function $ct_scm_ArrayBuffer__AO__I__($thiz, initialElements, initialSize) {
  $thiz.no = 0;
  $thiz.hl = initialElements;
  $thiz.a1 = initialSize;
  return $thiz;
}
function $ct_scm_ArrayBuffer__($thiz) {
  $ct_scm_ArrayBuffer__AO__I__($thiz, new $ac_O(16), 0);
  return $thiz;
}
function $ct_scm_ArrayBuffer__I__($thiz, initialSize) {
  $ct_scm_ArrayBuffer__AO__I__($thiz, new $ac_O(((initialSize > 1) ? initialSize : 1)), 0);
  return $thiz;
}
/** @constructor */
function $c_scm_ArrayBuffer() {
  this.no = 0;
  this.hl = null;
  this.a1 = 0;
}
$p = $c_scm_ArrayBuffer.prototype = new $h_scm_AbstractBuffer();
$p.constructor = $c_scm_ArrayBuffer;
/** @constructor */
function $h_scm_ArrayBuffer() {
}
$h_scm_ArrayBuffer.prototype = $p;
$p.ko = (function(f) {
  return $f_sc_StrictOptimizedSeqOps__distinctBy__F1__O(this, f);
});
$p.bv = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__appended__O__O(this, elem);
});
$p.gU = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix);
});
$p.fa = (function(asPair) {
  return $f_sc_StrictOptimizedIterableOps__unzip__F1__T2(this, asPair);
});
$p.L = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$p.c5 = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.ct = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.dk = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bw = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$p.cE = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true);
});
$p.fy = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__partitionMap__F1__T2(this, f);
});
$p.cn = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$p.o = (function() {
  return this.bB().o();
});
$p.cx = (function() {
  return this.bB().cx();
});
$p.k0 = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$p.ds = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n);
});
$p.hU = (function() {
  return $f_sc_IndexedSeqOps__reverse__O(this);
});
$p.hV = (function(from, until) {
  return $f_sc_IndexedSeqOps__slice__I__I__O(this, from, until);
});
$p.t = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$p.dt = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$p.bJ = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$p.bL = (function(len) {
  var x = this.a1;
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$p.V = (function() {
  return this.a1;
});
$p.WH = (function(n) {
  this.hl = $m_scm_ArrayBuffer$().aRW(this.hl, this.a1, n);
});
$p.f9 = (function(size) {
  if (((size > this.a1) && (size >= 1))) {
    this.WH(size);
  }
});
$p.l = (function(n) {
  var hi = ((1 + n) | 0);
  if ((n < 0)) {
    throw $m_scg_CommonErrors$().h2(n, ((this.a1 - 1) | 0));
  }
  if ((hi > this.a1)) {
    throw $m_scg_CommonErrors$().h2(((hi - 1) | 0), ((this.a1 - 1) | 0));
  }
  return this.hl.a[n];
});
$p.cM = (function(index, elem) {
  var hi = ((1 + index) | 0);
  if ((index < 0)) {
    throw $m_scg_CommonErrors$().h2(index, ((this.a1 - 1) | 0));
  }
  if ((hi > this.a1)) {
    throw $m_scg_CommonErrors$().h2(((hi - 1) | 0), ((this.a1 - 1) | 0));
  }
  this.no = ((1 + this.no) | 0);
  this.hl.a[index] = elem;
});
$p.C = (function() {
  return this.a1;
});
$p.bB = (function() {
  return new $c_scm_ArrayBufferView(this, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.no)));
});
$p.nB = (function() {
  return $m_scm_ArrayBuffer$();
});
$p.aw = (function(elem) {
  this.no = ((1 + this.no) | 0);
  var newSize = ((1 + this.a1) | 0);
  if ((this.hl.a.length <= ((newSize - 1) | 0))) {
    this.WH(newSize);
  }
  this.a1 = newSize;
  this.hl.a[((newSize - 1) | 0)] = elem;
  return this;
});
$p.gS = (function(elems) {
  if ((elems instanceof $c_scm_ArrayBuffer)) {
    var elemsLength = elems.a1;
    if ((elemsLength > 0)) {
      this.no = ((1 + this.no) | 0);
      this.WH(((this.a1 + elemsLength) | 0));
      $m_s_Array$().fv(elems.hl, 0, this.hl, this.a1, elemsLength);
      this.a1 = ((this.a1 + elemsLength) | 0);
    }
  } else {
    $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, elems);
  }
  return this;
});
$p.a3M = (function(index, elem) {
  if ((index < 0)) {
    throw $m_scg_CommonErrors$().h2(index, ((this.a1 - 1) | 0));
  }
  if ((index > this.a1)) {
    throw $m_scg_CommonErrors$().h2(((index - 1) | 0), ((this.a1 - 1) | 0));
  }
  this.no = ((1 + this.no) | 0);
  this.WH(((1 + this.a1) | 0));
  $m_s_Array$().fv(this.hl, index, this.hl, ((1 + index) | 0), ((this.a1 - index) | 0));
  this.a1 = ((1 + this.a1) | 0);
  this.cM(index, elem);
});
$p.Px = (function(index, elems) {
  if ((index < 0)) {
    throw $m_scg_CommonErrors$().h2(index, ((this.a1 - 1) | 0));
  }
  if ((index > this.a1)) {
    throw $m_scg_CommonErrors$().h2(((index - 1) | 0), ((this.a1 - 1) | 0));
  }
  if ($is_sc_Iterable(elems)) {
    var elemsLength = elems.aa();
    if ((elemsLength > 0)) {
      this.no = ((1 + this.no) | 0);
      this.WH(((this.a1 + elemsLength) | 0));
      var len = this.a1;
      $m_s_Array$().fv(this.hl, index, this.hl, ((index + elemsLength) | 0), ((len - index) | 0));
      var xs = this.hl;
      var actual = ((elems !== null) ? elems.cR(xs, index, elemsLength) : elems.o().cR(xs, index, elemsLength));
      if ((actual !== elemsLength)) {
        throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), ((("Copied " + actual) + " of ") + elemsLength));
      }
      this.a1 = ((len + elemsLength) | 0);
    }
  } else {
    this.Px(index, $m_scm_ArrayBuffer$().y9(elems));
  }
});
$p.wd = (function(index) {
  var hi = ((1 + index) | 0);
  if ((index < 0)) {
    throw $m_scg_CommonErrors$().h2(index, ((this.a1 - 1) | 0));
  }
  if ((hi > this.a1)) {
    throw $m_scg_CommonErrors$().h2(((hi - 1) | 0), ((this.a1 - 1) | 0));
  }
  var res = this.l(index);
  $m_s_Array$().fv(this.hl, ((1 + index) | 0), this.hl, index, ((this.a1 - ((1 + index) | 0)) | 0));
  $p_scm_ArrayBuffer__reduceToSize__I__V(this, ((this.a1 - 1) | 0));
  return res;
});
$p.XQ = (function(index, count) {
  if ((count > 0)) {
    var hi = ((index + count) | 0);
    if ((index < 0)) {
      throw $m_scg_CommonErrors$().h2(index, ((this.a1 - 1) | 0));
    }
    if ((hi > this.a1)) {
      throw $m_scg_CommonErrors$().h2(((hi - 1) | 0), ((this.a1 - 1) | 0));
    }
    $m_s_Array$().fv(this.hl, ((index + count) | 0), this.hl, index, ((this.a1 - ((index + count) | 0)) | 0));
    $p_scm_ArrayBuffer__reduceToSize__I__V(this, ((this.a1 - count) | 0));
  } else if ((count < 0)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("removing negative number of elements: " + count));
  }
});
$p.el = (function() {
  return "ArrayBuffer";
});
$p.cR = (function(xs, start, len) {
  var srcLen = this.a1;
  var destLen = $m_jl_reflect_Array$().c6(xs);
  var limit = ((len < srcLen) ? len : srcLen);
  var capacity = ((start < 0) ? destLen : ((destLen - start) | 0));
  var total = ((capacity < limit) ? capacity : limit);
  var copied = ((total < 0) ? 0 : total);
  if ((copied > 0)) {
    $m_s_Array$().fv(this.hl, 0, xs, start, copied);
  }
  return copied;
});
$p.b9b = (function(ord) {
  if ((this.a1 > 1)) {
    this.no = ((1 + this.no) | 0);
    $m_s_util_Sorting$().Y5(this.hl, 0, this.a1, ord);
  }
  return this;
});
$p.hO = (function(z, op) {
  return $p_scm_ArrayBuffer__foldl__I__I__O__F2__O(this, 0, this.a1, z, op);
});
$p.kT = (function(op) {
  return ((this.a1 > 0) ? $p_scm_ArrayBuffer__foldl__I__I__O__F2__O(this, 1, this.a1, this.hl.a[0], op) : $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op));
});
$p.Y4 = (function(ord) {
  return this.b9b(ord);
});
$p.dG = (function(elems) {
  return this.gS(elems);
});
$p.Y = (function(elem) {
  return this.aw(elem);
});
$p.cd = (function() {
  return $m_scm_ArrayBuffer$();
});
$p.i = (function(v1) {
  return this.l((v1 | 0));
});
function $isArrayOf_scm_ArrayBuffer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.lD)));
}
var $d_scm_ArrayBuffer = new $TypeData().i($c_scm_ArrayBuffer, "scala.collection.mutable.ArrayBuffer", ({
  lD: 1,
  bG: 1,
  an: 1,
  L: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  H: 1,
  i: 1,
  h: 1,
  w: 1,
  b: 1,
  ao: 1,
  aa: 1,
  ap: 1,
  a9: 1,
  W: 1,
  bH: 1,
  T: 1,
  S: 1,
  aM: 1,
  c4: 1,
  au: 1,
  M: 1,
  A: 1,
  av: 1,
  N: 1,
  z: 1,
  a5: 1,
  a: 1
}));
function $ct_sjs_js_WrappedArray__sjs_js_Array__($thiz, array) {
  $thiz.mE = array;
  return $thiz;
}
function $ct_sjs_js_WrappedArray__($thiz) {
  $ct_sjs_js_WrappedArray__sjs_js_Array__($thiz, []);
  return $thiz;
}
/** @constructor */
function $c_sjs_js_WrappedArray() {
  this.mE = null;
}
$p = $c_sjs_js_WrappedArray.prototype = new $h_scm_AbstractBuffer();
$p.constructor = $c_sjs_js_WrappedArray;
/** @constructor */
function $h_sjs_js_WrappedArray() {
}
$h_sjs_js_WrappedArray.prototype = $p;
$p.f9 = (function(size) {
});
$p.Y4 = (function(ord) {
  return $f_scm_IndexedSeqOps__sortInPlace__s_math_Ordering__scm_IndexedSeqOps(this, ord);
});
$p.el = (function() {
  return "IndexedSeq";
});
$p.o = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), new $c_sc_IndexedSeqView$Id(this));
});
$p.cx = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), new $c_sc_IndexedSeqView$Id(this));
});
$p.k0 = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$p.ds = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n);
});
$p.cn = (function(n) {
  return $f_sc_IndexedSeqOps__dropRight__I__O(this, n);
});
$p.L = (function(f) {
  return $f_sc_IndexedSeqOps__map__F1__O(this, f);
});
$p.hU = (function() {
  return $f_sc_IndexedSeqOps__reverse__O(this);
});
$p.hV = (function(from, until) {
  return $f_sc_IndexedSeqOps__slice__I__I__O(this, from, until);
});
$p.t = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$p.dt = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$p.bJ = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$p.bL = (function(len) {
  var x = (this.mE.length | 0);
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$p.ko = (function(f) {
  return $f_sc_StrictOptimizedSeqOps__distinctBy__F1__O(this, f);
});
$p.bv = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__appended__O__O(this, elem);
});
$p.gU = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix);
});
$p.fa = (function(asPair) {
  return $f_sc_StrictOptimizedIterableOps__unzip__F1__T2(this, asPair);
});
$p.c5 = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.ct = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.dk = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bw = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$p.cE = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true);
});
$p.fy = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__partitionMap__F1__T2(this, f);
});
$p.nB = (function() {
  return $m_sjs_js_WrappedArray$();
});
$p.cM = (function(index, elem) {
  this.mE[index] = elem;
});
$p.l = (function(index) {
  return this.mE[index];
});
$p.C = (function() {
  return (this.mE.length | 0);
});
$p.V = (function() {
  return (this.mE.length | 0);
});
$p.a3M = (function(idx, elem) {
  if (((idx < 0) || (idx > (this.mE.length | 0)))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
  this.mE.splice(idx, 0, elem);
});
$p.Px = (function(n, elems) {
  if (((n < 0) || (n > (this.mE.length | 0)))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
  this.mE.splice(n, 0, ...$m_sjsr_Compat$().Y8($m_sci_Seq$().fw(elems.o())));
});
$p.wd = (function(n) {
  if (((n < 0) || (n >= (this.mE.length | 0)))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
  return this.mE.splice(n, 1)[0];
});
$p.XQ = (function(n, count) {
  if ((count < 0)) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  }
  if (((n < 0) || ((count > 0) && (((n + count) | 0) > (this.mE.length | 0))))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
  this.mE.splice(n, count);
});
$p.hM = (function() {
  return "WrappedArray";
});
$p.aR = (function() {
  return this;
});
$p.Y = (function(elem) {
  this.mE.push(elem);
  return this;
});
$p.i = (function(v1) {
  var index = (v1 | 0);
  return this.mE[index];
});
$p.cd = (function() {
  return $m_sjs_js_WrappedArray$();
});
var $d_sjs_js_WrappedArray = new $TypeData().i($c_sjs_js_WrappedArray, "scala.scalajs.js.WrappedArray", ({
  Mk: 1,
  bG: 1,
  an: 1,
  L: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  H: 1,
  i: 1,
  h: 1,
  w: 1,
  b: 1,
  ao: 1,
  aa: 1,
  ap: 1,
  a9: 1,
  W: 1,
  bH: 1,
  T: 1,
  S: 1,
  aM: 1,
  N: 1,
  z: 1,
  au: 1,
  M: 1,
  A: 1,
  av: 1,
  c4: 1,
  Y: 1,
  a: 1
}));
function $p_scm_ArrayDeque__reset__AO__I__I__V($thiz, array, start, end) {
  if ((!((array.a.length & ((array.a.length - 1) | 0)) === 0))) {
    throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "assertion failed: Array.length must be power of 2");
  }
  var until = array.a.length;
  if (((start < 0) || (start >= until))) {
    throw $m_scg_CommonErrors$().h2(start, ((until - 1) | 0));
  }
  var until$1 = array.a.length;
  if (((end < 0) || (end >= until$1))) {
    throw $m_scg_CommonErrors$().h2(end, ((until$1 - 1) | 0));
  }
  $thiz.aL = array;
  $thiz.bF = start;
  $thiz.d5 = end;
}
function $ct_scm_ArrayDeque__AO__I__I__($thiz, array, start, end) {
  $thiz.aL = array;
  $thiz.bF = start;
  $thiz.d5 = end;
  $p_scm_ArrayDeque__reset__AO__I__I__V($thiz, $thiz.aL, $thiz.bF, $thiz.d5);
  return $thiz;
}
function $ct_scm_ArrayDeque__I__($thiz, initialSize) {
  $ct_scm_ArrayDeque__AO__I__I__($thiz, $m_scm_ArrayDeque$().vT(initialSize), 0, 0);
  return $thiz;
}
/** @constructor */
function $c_scm_ArrayDeque() {
  this.aL = null;
  this.bF = 0;
  this.d5 = 0;
}
$p = $c_scm_ArrayDeque.prototype = new $h_scm_AbstractBuffer();
$p.constructor = $c_scm_ArrayDeque;
/** @constructor */
function $h_scm_ArrayDeque() {
}
$h_scm_ArrayDeque.prototype = $p;
$p.hU = (function() {
  return $f_scm_ArrayDequeOps__reverse__O(this);
});
$p.hV = (function(from, until) {
  return $f_scm_ArrayDequeOps__slice__I__I__O(this, from, until);
});
$p.ko = (function(f) {
  return $f_sc_StrictOptimizedSeqOps__distinctBy__F1__O(this, f);
});
$p.bv = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__appended__O__O(this, elem);
});
$p.gU = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix);
});
$p.fa = (function(asPair) {
  return $f_sc_StrictOptimizedIterableOps__unzip__F1__T2(this, asPair);
});
$p.L = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$p.c5 = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.ct = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.dk = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bw = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$p.cE = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true);
});
$p.fy = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__partitionMap__F1__T2(this, f);
});
$p.cn = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$p.Y4 = (function(ord) {
  return $f_scm_IndexedSeqOps__sortInPlace__s_math_Ordering__scm_IndexedSeqOps(this, ord);
});
$p.o = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), new $c_sc_IndexedSeqView$Id(this));
});
$p.cx = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), new $c_sc_IndexedSeqView$Id(this));
});
$p.k0 = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$p.ds = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n);
});
$p.t = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$p.dt = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$p.bJ = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$p.bL = (function(len) {
  var idx = this.bF;
  var x = (((this.d5 - idx) | 0) & ((this.aL.a.length - 1) | 0));
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$p.V = (function() {
  var idx = this.bF;
  return (((this.d5 - idx) | 0) & ((this.aL.a.length - 1) | 0));
});
$p.l = (function(idx) {
  var idx$1 = this.bF;
  var until = (((this.d5 - idx$1) | 0) & ((this.aL.a.length - 1) | 0));
  if (((idx < 0) || (idx >= until))) {
    throw $m_scg_CommonErrors$().h2(idx, ((until - 1) | 0));
  }
  return this.aL.a[(((this.bF + idx) | 0) & ((this.aL.a.length - 1) | 0))];
});
$p.cM = (function(idx, elem) {
  var idx$1 = this.bF;
  var until = (((this.d5 - idx$1) | 0) & ((this.aL.a.length - 1) | 0));
  if (((idx < 0) || (idx >= until))) {
    throw $m_scg_CommonErrors$().h2(idx, ((until - 1) | 0));
  }
  this.aL.a[(((this.bF + idx) | 0) & ((this.aL.a.length - 1) | 0))] = elem;
});
$p.km = (function(elem) {
  var idx = this.bF;
  var hint = ((1 + (((this.d5 - idx) | 0) & ((this.aL.a.length - 1) | 0))) | 0);
  var idx$1 = this.bF;
  if (((hint > (((this.d5 - idx$1) | 0) & ((this.aL.a.length - 1) | 0))) && (hint >= this.aL.a.length))) {
    this.XW(hint);
  }
  this.aL.a[this.d5] = elem;
  this.d5 = (((1 + this.d5) | 0) & ((this.aL.a.length - 1) | 0));
  return this;
});
$p.gm = (function(elem) {
  var idx = this.bF;
  var hint = ((1 + (((this.d5 - idx) | 0) & ((this.aL.a.length - 1) | 0))) | 0);
  var idx$1 = this.bF;
  if (((hint > (((this.d5 - idx$1) | 0) & ((this.aL.a.length - 1) | 0))) && (hint >= this.aL.a.length))) {
    this.XW(hint);
  }
  this.bF = (((this.bF - 1) | 0) & ((this.aL.a.length - 1) | 0));
  this.aL.a[this.bF] = elem;
  return this;
});
$p.aR5 = (function(elems) {
  var it = elems.o();
  if (it.p()) {
    var idx = this.bF;
    var n = (((this.d5 - idx) | 0) & ((this.aL.a.length - 1) | 0));
    var x1 = elems.V();
    if ((x1 < 0)) {
      this.aR5(new $c_sc_IterableFactory$ToFactory($m_scm_IndexedSeq$()).fP(it));
    } else if ((((x1 + n) | 0) >= this.aL.a.length)) {
      var finalLength = ((x1 + n) | 0);
      var array2 = $m_scm_ArrayDeque$().vT(finalLength);
      it.cR(array2, 0, 2147483647);
      $f_scm_ArrayDequeOps__copySliceToArray__I__O__I__I__O(this, 0, array2, x1, n);
      $p_scm_ArrayDeque__reset__AO__I__I__V(this, array2, 0, finalLength);
    } else {
      var i = 0;
      while ((i < x1)) {
        var idx$1 = ((i - x1) | 0);
        var elem = it.q();
        this.aL.a[(((this.bF + idx$1) | 0) & ((this.aL.a.length - 1) | 0))] = elem;
        i = ((1 + i) | 0);
      }
      this.bF = (((this.bF - x1) | 0) & ((this.aL.a.length - 1) | 0));
    }
  }
  return this;
});
$p.kl = (function(elems) {
  var x1 = elems.V();
  if ((x1 > 0)) {
    var idx = this.bF;
    var hint = ((x1 + (((this.d5 - idx) | 0) & ((this.aL.a.length - 1) | 0))) | 0);
    var idx$1 = this.bF;
    if (((hint > (((this.d5 - idx$1) | 0) & ((this.aL.a.length - 1) | 0))) && (hint >= this.aL.a.length))) {
      this.XW(hint);
    }
    var this$1 = elems.o();
    while (this$1.p()) {
      var x0 = this$1.q();
      this.aL.a[this.d5] = x0;
      this.d5 = (((1 + this.d5) | 0) & ((this.aL.a.length - 1) | 0));
    }
  } else {
    var this$2 = elems.o();
    while (this$2.p()) {
      this.km(this$2.q());
    }
  }
  return this;
});
$p.a3M = (function(idx, elem) {
  var idx$1 = this.bF;
  var until = ((1 + (((this.d5 - idx$1) | 0) & ((this.aL.a.length - 1) | 0))) | 0);
  if (((idx < 0) || (idx >= until))) {
    throw $m_scg_CommonErrors$().h2(idx, ((until - 1) | 0));
  }
  var idx$2 = this.bF;
  var n = (((this.d5 - idx$2) | 0) & ((this.aL.a.length - 1) | 0));
  if ((idx === 0)) {
    this.gm(elem);
  } else if ((idx === n)) {
    this.km(elem);
  } else {
    var finalLength = ((1 + n) | 0);
    if ((finalLength >= this.aL.a.length)) {
      var array2 = $m_scm_ArrayDeque$().vT(finalLength);
      $f_scm_ArrayDequeOps__copySliceToArray__I__O__I__I__O(this, 0, array2, 0, idx);
      array2.a[idx] = elem;
      $f_scm_ArrayDequeOps__copySliceToArray__I__O__I__I__O(this, idx, array2, ((1 + idx) | 0), n);
      $p_scm_ArrayDeque__reset__AO__I__I__V(this, array2, 0, finalLength);
    } else if ((n <= (idx << 1))) {
      var i = ((n - 1) | 0);
      while ((i >= idx)) {
        var idx$4 = ((1 + i) | 0);
        var idx$3 = i;
        var elem$1 = this.aL.a[(((this.bF + idx$3) | 0) & ((this.aL.a.length - 1) | 0))];
        this.aL.a[(((this.bF + idx$4) | 0) & ((this.aL.a.length - 1) | 0))] = elem$1;
        i = ((i - 1) | 0);
      }
      this.d5 = (((1 + this.d5) | 0) & ((this.aL.a.length - 1) | 0));
      i = ((1 + i) | 0);
      var idx$5 = i;
      this.aL.a[(((this.bF + idx$5) | 0) & ((this.aL.a.length - 1) | 0))] = elem;
    } else {
      var i$2 = 0;
      while ((i$2 < idx)) {
        var idx$7 = ((i$2 - 1) | 0);
        var idx$6 = i$2;
        var elem$2 = this.aL.a[(((this.bF + idx$6) | 0) & ((this.aL.a.length - 1) | 0))];
        this.aL.a[(((this.bF + idx$7) | 0) & ((this.aL.a.length - 1) | 0))] = elem$2;
        i$2 = ((1 + i$2) | 0);
      }
      this.bF = (((this.bF - 1) | 0) & ((this.aL.a.length - 1) | 0));
      var idx$8 = i$2;
      this.aL.a[(((this.bF + idx$8) | 0) & ((this.aL.a.length - 1) | 0))] = elem;
    }
  }
});
$p.Px = (function(idx, elems) {
  var idx$1 = this.bF;
  var until = ((1 + (((this.d5 - idx$1) | 0) & ((this.aL.a.length - 1) | 0))) | 0);
  if (((idx < 0) || (idx >= until))) {
    throw $m_scg_CommonErrors$().h2(idx, ((until - 1) | 0));
  }
  var idx$2 = this.bF;
  var n = (((this.d5 - idx$2) | 0) & ((this.aL.a.length - 1) | 0));
  if ((idx === 0)) {
    this.aR5(elems);
  } else if ((idx === n)) {
    this.kl(elems);
  } else {
    var _srcLength = elems.V();
    if ((_srcLength >= 0)) {
      var x1___1 = elems.o();
      var x1___2 = _srcLength;
    } else {
      var indexed = $m_scm_IndexedSeq$().Al(elems);
      var x1___1 = indexed.o();
      var x1___2 = indexed.C();
    }
    var it = x1___1;
    var srcLength = (x1___2 | 0);
    if (it.p()) {
      var finalLength = ((srcLength + n) | 0);
      if ((finalLength >= this.aL.a.length)) {
        var array2 = $m_scm_ArrayDeque$().vT(finalLength);
        $f_scm_ArrayDequeOps__copySliceToArray__I__O__I__I__O(this, 0, array2, 0, idx);
        it.cR(array2, idx, 2147483647);
        $f_scm_ArrayDequeOps__copySliceToArray__I__O__I__I__O(this, idx, array2, ((idx + srcLength) | 0), n);
        $p_scm_ArrayDeque__reset__AO__I__I__V(this, array2, 0, finalLength);
      } else if (((idx << 1) >= n)) {
        var i = ((n - 1) | 0);
        while ((i >= idx)) {
          var idx$4 = ((i + srcLength) | 0);
          var idx$3 = i;
          var elem = this.aL.a[(((this.bF + idx$3) | 0) & ((this.aL.a.length - 1) | 0))];
          this.aL.a[(((this.bF + idx$4) | 0) & ((this.aL.a.length - 1) | 0))] = elem;
          i = ((i - 1) | 0);
        }
        this.d5 = (((this.d5 + srcLength) | 0) & ((this.aL.a.length - 1) | 0));
        while (it.p()) {
          i = ((1 + i) | 0);
          var idx$5 = i;
          var elem$1 = it.q();
          this.aL.a[(((this.bF + idx$5) | 0) & ((this.aL.a.length - 1) | 0))] = elem$1;
        }
      } else {
        var i$2 = 0;
        while ((i$2 < idx)) {
          var idx$7 = ((i$2 - srcLength) | 0);
          var idx$6 = i$2;
          var elem$2 = this.aL.a[(((this.bF + idx$6) | 0) & ((this.aL.a.length - 1) | 0))];
          this.aL.a[(((this.bF + idx$7) | 0) & ((this.aL.a.length - 1) | 0))] = elem$2;
          i$2 = ((1 + i$2) | 0);
        }
        this.bF = (((this.bF - srcLength) | 0) & ((this.aL.a.length - 1) | 0));
        while (it.p()) {
          var idx$8 = i$2;
          var elem$3 = it.q();
          this.aL.a[(((this.bF + idx$8) | 0) & ((this.aL.a.length - 1) | 0))] = elem$3;
          i$2 = ((1 + i$2) | 0);
        }
      }
    }
  }
});
$p.XQ = (function(idx, count) {
  if ((count > 0)) {
    var idx$1 = this.bF;
    var until = (((this.d5 - idx$1) | 0) & ((this.aL.a.length - 1) | 0));
    if (((idx < 0) || (idx >= until))) {
      throw $m_scg_CommonErrors$().h2(idx, ((until - 1) | 0));
    }
    var idx$2 = this.bF;
    var n = (((this.d5 - idx$2) | 0) & ((this.aL.a.length - 1) | 0));
    var a = ((n - idx) | 0);
    var removals = ((a < count) ? a : count);
    var finalLength = ((n - removals) | 0);
    var suffixStart = ((idx + removals) | 0);
    if (((this.aL.a.length > 128) && (((((this.aL.a.length - finalLength) | 0) - (finalLength >> 1)) | 0) > finalLength))) {
      var array2 = $m_scm_ArrayDeque$().vT(finalLength);
      $f_scm_ArrayDequeOps__copySliceToArray__I__O__I__I__O(this, 0, array2, 0, idx);
      $f_scm_ArrayDequeOps__copySliceToArray__I__O__I__I__O(this, suffixStart, array2, idx, n);
      $p_scm_ArrayDeque__reset__AO__I__I__V(this, array2, 0, finalLength);
    } else if (((idx << 1) <= finalLength)) {
      var i = ((suffixStart - 1) | 0);
      while ((i >= removals)) {
        var idx$4 = i;
        var idx$3 = ((i - removals) | 0);
        var elem = this.aL.a[(((this.bF + idx$3) | 0) & ((this.aL.a.length - 1) | 0))];
        this.aL.a[(((this.bF + idx$4) | 0) & ((this.aL.a.length - 1) | 0))] = elem;
        i = ((i - 1) | 0);
      }
      while ((i >= 0)) {
        var idx$5 = i;
        this.aL.a[(((this.bF + idx$5) | 0) & ((this.aL.a.length - 1) | 0))] = null;
        i = ((i - 1) | 0);
      }
      this.bF = (((this.bF + removals) | 0) & ((this.aL.a.length - 1) | 0));
    } else {
      var i$2 = idx;
      while ((i$2 < finalLength)) {
        var idx$7 = i$2;
        var idx$6 = ((i$2 + removals) | 0);
        var elem$1 = this.aL.a[(((this.bF + idx$6) | 0) & ((this.aL.a.length - 1) | 0))];
        this.aL.a[(((this.bF + idx$7) | 0) & ((this.aL.a.length - 1) | 0))] = elem$1;
        i$2 = ((1 + i$2) | 0);
      }
      while ((i$2 < n)) {
        var idx$8 = i$2;
        this.aL.a[(((this.bF + idx$8) | 0) & ((this.aL.a.length - 1) | 0))] = null;
        i$2 = ((1 + i$2) | 0);
      }
      this.d5 = (((this.d5 - removals) | 0) & ((this.aL.a.length - 1) | 0));
    }
  } else if ((!(count === 0))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("requirement failed: " + "removing negative number of elements: ") + count));
  }
});
$p.wd = (function(idx) {
  var elem = this.l(idx);
  this.XQ(idx, 1);
  return elem;
});
$p.h7 = (function(resizeInternalRepr) {
  if (this.c()) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "empty collection");
  } else {
    var elem = this.aL.a[this.bF];
    this.aL.a[this.bF] = null;
    this.bF = (((1 + this.bF) | 0) & ((this.aL.a.length - 1) | 0));
    if (resizeInternalRepr) {
      var idx = this.bF;
      this.XW((((this.d5 - idx) | 0) & ((this.aL.a.length - 1) | 0)));
    }
    return elem;
  }
});
$p.C = (function() {
  var idx = this.bF;
  return (((this.d5 - idx) | 0) & ((this.aL.a.length - 1) | 0));
});
$p.c = (function() {
  return (this.bF === this.d5);
});
$p.agO = (function() {
  return $ct_scm_ArrayDeque__AO__I__I__(new $c_scm_ArrayDeque(), this.aL.ae(), this.bF, this.d5);
});
$p.nB = (function() {
  return $m_scm_ArrayDeque$();
});
$p.ahc = (function(array, end) {
  return $ct_scm_ArrayDeque__AO__I__I__(new $c_scm_ArrayDeque(), array, 0, end);
});
$p.cR = (function(dest, destStart, len) {
  var idx = this.bF;
  var srcLen = (((this.d5 - idx) | 0) & ((this.aL.a.length - 1) | 0));
  var destLen = $m_jl_reflect_Array$().c6(dest);
  var limit = ((len < srcLen) ? len : srcLen);
  var capacity = ((destStart < 0) ? destLen : ((destLen - destStart) | 0));
  var total = ((capacity < limit) ? capacity : limit);
  var copied = ((total < 0) ? 0 : total);
  if ((copied > 0)) {
    $f_scm_ArrayDequeOps__copySliceToArray__I__O__I__I__O(this, 0, dest, destStart, len);
  }
  return copied;
});
$p.nG = (function(evidence$1) {
  var idx = this.bF;
  var dest = evidence$1.b2((((this.d5 - idx) | 0) & ((this.aL.a.length - 1) | 0)));
  var idx$1 = this.bF;
  return $f_scm_ArrayDequeOps__copySliceToArray__I__O__I__I__O(this, 0, dest, 0, (((this.d5 - idx$1) | 0) & ((this.aL.a.length - 1) | 0)));
});
$p.XW = (function(len) {
  if (((len >= this.aL.a.length) || ((this.aL.a.length > 16) && (((this.aL.a.length - len) | 0) > len)))) {
    var idx = this.bF;
    var n = (((this.d5 - idx) | 0) & ((this.aL.a.length - 1) | 0));
    $p_scm_ArrayDeque__reset__AO__I__I__V(this, $f_scm_ArrayDequeOps__copySliceToArray__I__O__I__I__O(this, 0, $m_scm_ArrayDeque$().vT(len), 0, n), 0, n);
  }
});
$p.el = (function() {
  return "ArrayDeque";
});
$p.a4h = (function(array, end) {
  return this.ahc(array, end);
});
$p.cd = (function() {
  return this.nB();
});
$p.agN = (function() {
  return this.agO();
});
$p.dG = (function(elems) {
  return this.kl(elems);
});
$p.Y = (function(elem) {
  return this.km(elem);
});
$p.i = (function(v1) {
  return this.l((v1 | 0));
});
var $d_scm_ArrayDeque = new $TypeData().i($c_scm_ArrayDeque, "scala.collection.mutable.ArrayDeque", ({
  dO: 1,
  bG: 1,
  an: 1,
  L: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  H: 1,
  i: 1,
  h: 1,
  w: 1,
  b: 1,
  ao: 1,
  aa: 1,
  ap: 1,
  a9: 1,
  W: 1,
  bH: 1,
  T: 1,
  S: 1,
  aM: 1,
  c4: 1,
  au: 1,
  M: 1,
  A: 1,
  av: 1,
  N: 1,
  z: 1,
  dP: 1,
  a5: 1,
  a: 1
}));
function $ct_scm_Queue__AO__I__I__($thiz, array, start, end) {
  $ct_scm_ArrayDeque__AO__I__I__($thiz, array, start, end);
  return $thiz;
}
function $ct_scm_Queue__I__($thiz, initialSize) {
  $ct_scm_ArrayDeque__AO__I__I__($thiz, $m_scm_ArrayDeque$().vT(initialSize), 0, 0);
  return $thiz;
}
/** @constructor */
function $c_scm_Queue() {
  this.aL = null;
  this.bF = 0;
  this.d5 = 0;
}
$p = $c_scm_Queue.prototype = new $h_scm_ArrayDeque();
$p.constructor = $c_scm_Queue;
/** @constructor */
function $h_scm_Queue() {
}
$h_scm_Queue.prototype = $p;
$p.nB = (function() {
  return $m_scm_Queue$();
});
$p.el = (function() {
  return "Queue";
});
$p.aPE = (function() {
  var bf = $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), $ct_scm_Queue__I__(new $c_scm_Queue(), 16));
  bf.a2B(this);
  return bf.gj;
});
$p.a4h = (function(array, end) {
  return $ct_scm_Queue__AO__I__I__(new $c_scm_Queue(), array, 0, end);
});
$p.ahc = (function(array, end) {
  return $ct_scm_Queue__AO__I__I__(new $c_scm_Queue(), array, 0, end);
});
$p.agN = (function() {
  return this.aPE();
});
$p.agO = (function() {
  return this.aPE();
});
$p.cd = (function() {
  return $m_scm_Queue$();
});
var $d_scm_Queue = new $TypeData().i($c_scm_Queue, "scala.collection.mutable.Queue", ({
  Km: 1,
  dO: 1,
  bG: 1,
  an: 1,
  L: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  H: 1,
  i: 1,
  h: 1,
  w: 1,
  b: 1,
  ao: 1,
  aa: 1,
  ap: 1,
  a9: 1,
  W: 1,
  bH: 1,
  T: 1,
  S: 1,
  aM: 1,
  c4: 1,
  au: 1,
  M: 1,
  A: 1,
  av: 1,
  N: 1,
  z: 1,
  dP: 1,
  a5: 1,
  a: 1
}));
function $ct_scm_Stack__AO__I__I__($thiz, array, start, end) {
  $ct_scm_ArrayDeque__AO__I__I__($thiz, array, start, end);
  return $thiz;
}
function $ct_scm_Stack__I__($thiz, initialSize) {
  $ct_scm_ArrayDeque__AO__I__I__($thiz, $m_scm_ArrayDeque$().vT(initialSize), 0, 0);
  return $thiz;
}
/** @constructor */
function $c_scm_Stack() {
  this.aL = null;
  this.bF = 0;
  this.d5 = 0;
}
$p = $c_scm_Stack.prototype = new $h_scm_ArrayDeque();
$p.constructor = $c_scm_Stack;
/** @constructor */
function $h_scm_Stack() {
}
$h_scm_Stack.prototype = $p;
$p.nB = (function() {
  return $m_scm_Stack$();
});
$p.el = (function() {
  return "Stack";
});
$p.aPF = (function() {
  var bf = $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), $ct_scm_Stack__I__(new $c_scm_Stack(), 16));
  bf.a2B(this);
  return bf.gj;
});
$p.a4h = (function(array, end) {
  return $ct_scm_Stack__AO__I__I__(new $c_scm_Stack(), array, 0, end);
});
$p.ahc = (function(array, end) {
  return $ct_scm_Stack__AO__I__I__(new $c_scm_Stack(), array, 0, end);
});
$p.agN = (function() {
  return this.aPF();
});
$p.agO = (function() {
  return this.aPF();
});
$p.cd = (function() {
  return $m_scm_Stack$();
});
var $d_scm_Stack = new $TypeData().i($c_scm_Stack, "scala.collection.mutable.Stack", ({
  Kq: 1,
  dO: 1,
  bG: 1,
  an: 1,
  L: 1,
  n: 1,
  k: 1,
  e: 1,
  m: 1,
  f: 1,
  l: 1,
  H: 1,
  i: 1,
  h: 1,
  w: 1,
  b: 1,
  ao: 1,
  aa: 1,
  ap: 1,
  a9: 1,
  W: 1,
  bH: 1,
  T: 1,
  S: 1,
  aM: 1,
  c4: 1,
  au: 1,
  M: 1,
  A: 1,
  av: 1,
  N: 1,
  z: 1,
  dP: 1,
  a5: 1,
  a: 1
}));
var $t_Lorg_jpablo_graphexplorer_graphviz_Format$__DotJson = null;
var $t_Lorg_jpablo_graphexplorer_graphviz_Format$__Json0 = null;
var $t_Lorg_jpablo_graphexplorer_graphviz_Format$__Svg = null;
var $t_Lorg_jpablo_graphexplorer_graphviz_RenderStatus$__Success = null;
var $t_Lorg_jpablo_graphexplorer_graphviz_RenderStatus$__Failure = null;
var $t_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$__Graph = null;
var $t_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$__Node = null;
var $t_Lorg_jpablo_graphexplorer_graphviz_dotlang_AttrTarget$__Edge = null;
var $t_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__N = null;
var $t_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__NE = null;
var $t_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__E = null;
var $t_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__SE = null;
var $t_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__S = null;
var $t_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__SW = null;
var $t_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__W = null;
var $t_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__NW = null;
var $t_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__C = null;
var $t_Lorg_jpablo_graphexplorer_graphviz_dotlang_Compass$__Underscore = null;
var $t_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$__Left = null;
var $t_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$__Center = null;
var $t_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$__Right = null;
var $t_Lorg_jpablo_graphexplorer_graphviz_html_HtmlAlign$__Text_ = null;
var $t_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$__None = null;
var $t_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$__TopBottom = null;
var $t_Lorg_jpablo_graphexplorer_graphviz_layout_NSBalance$__LeftRight = null;
var $t_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$__Ordinary = null;
var $t_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$__Singleton = null;
var $t_Lorg_jpablo_graphexplorer_graphviz_layout_NSClass$__Virtual = null;
var $t_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen$__Star = null;
var $t_Lorg_jpablo_graphexplorer_graphviz_layout_Polygon$Gen$__Cylinder = null;
var $t_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__TB = null;
var $t_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__LR = null;
var $t_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__BT = null;
var $t_Lorg_jpablo_graphexplorer_graphviz_layout_RankDir$__RL = null;
var $t_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$__ListNodes = null;
var $t_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$__ListArrows = null;
var $t_Lorg_jpablo_graphexplorer_gxcore_command_DocumentCommand$__ListGroups = null;
var $t_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$__ClearSelection = null;
var $t_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$__ResetView = null;
var $t_Lorg_jpablo_graphexplorer_gxcore_command_SessionCommand$__WhatIsSelected = null;
var $t_Lorg_jpablo_graphexplorer_gxcore_command_Tier$__Document = null;
var $t_Lorg_jpablo_graphexplorer_gxcore_command_Tier$__Record = null;
var $t_Lorg_jpablo_graphexplorer_gxcore_command_Tier$__Session = null;
var $t_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$__Lf = null;
var $t_Lorg_jpablo_graphexplorer_gxcore_fs_LineEnding$__Crlf = null;
var $t_Lorg_jpablo_graphexplorer_gxcore_model_ReconcileAction$__DoNothing = null;
var $t_Lorg_jpablo_graphexplorer_gxcore_model_ReconcilePlan$__Unbound = null;
var $t_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$__Pull = null;
var $t_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$__Push = null;
var $t_Lorg_jpablo_graphexplorer_gxcore_model_SyncAction$__AdvanceBase = null;
var $t_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$__Detached = null;
var $t_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$__Pull = null;
var $t_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$__Push = null;
var $t_Lorg_jpablo_graphexplorer_gxcore_model_SyncMode$__Sync = null;
var $t_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__InSync = null;
var $t_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__Ahead = null;
var $t_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__Behind = null;
var $t_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__Diverged = null;
var $t_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__Converged = null;
var $t_Lorg_jpablo_graphexplorer_gxcore_model_SyncState$__OriginMissing = null;
var $t_Lorg_jpablo_graphexplorer_projects_LibraryViewMode$__Cards = null;
var $t_Lorg_jpablo_graphexplorer_projects_LibraryViewMode$__Rows = null;
var $t_Lorg_jpablo_graphexplorer_projects_SortOption$__LastModified = null;
var $t_Lorg_jpablo_graphexplorer_projects_SortOption$__Title = null;
var $t_Lorg_jpablo_graphexplorer_projects_SortOption$__CreationDate = null;
var $t_Lorg_jpablo_graphexplorer_router_Route$__Home = null;
var $t_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__DOT = null;
var $t_Lorg_jpablo_graphexplorer_viewer_backends_DiagramFormat$__Mermaid = null;
var $t_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$__Comments = null;
var $t_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$__StrictKeyword = null;
var $t_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$__Directives = null;
var $t_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$__ClickHandlers = null;
var $t_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$__AccessibilityText = null;
var $t_Lorg_jpablo_graphexplorer_viewer_backends_UnmodeledContent$__SubgraphDirection = null;
var $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__red = null;
var $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__orange = null;
var $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__amber = null;
var $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__yellow = null;
var $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__lime = null;
var $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__green = null;
var $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__emerald = null;
var $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__teal = null;
var $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__cyan = null;
var $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__sky = null;
var $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__blue = null;
var $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__indigo = null;
var $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__violet = null;
var $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__purple = null;
var $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__fuchsia = null;
var $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__pink = null;
var $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__rose = null;
var $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__slate = null;
var $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__gray = null;
var $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__zinc = null;
var $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__neutral = null;
var $t_Lorg_jpablo_graphexplorer_viewer_color_TailWindColors$ColorName$__stone = null;
var $t_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$__Nodes = null;
var $t_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$__Arrows = null;
var $t_Lorg_jpablo_graphexplorer_viewer_components_rightPanel_ElementKind$__Groups = null;
var $t_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopIpc$SaveOutcome$__Unavailable = null;
var $t_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$__Waiting = null;
var $t_Lorg_jpablo_graphexplorer_viewer_desktop_DesktopOpenRequests$Activation$__Displayed = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__none = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__vee = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__normal = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__onormal = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__odot = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__box = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__crow = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__curve = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__diamond = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__dot = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__inv = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__tee = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__obox = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__odiamond = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_ArrowType$__halfvee = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__n = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__ne = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__e = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__se = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__s = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__sw = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__w = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__nw = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CompassPoint$__c = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$__forward = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$__back = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$__both = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_DirType$__none = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc$__t = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GroupLabelLoc$__b = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$__left = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$__center = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$__right = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellAlign$__text = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$__top = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$__middle = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_HtmlCellVAlign$__bottom = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$__none = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$__same = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$__min = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$__source = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$__max = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_RankType$__sink = null;
var $t_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$__Successors = null;
var $t_Lorg_jpablo_graphexplorer_viewer_graph_VisibilityRules$Direction$__Predecessors = null;
var $t_Lorg_jpablo_graphexplorer_viewer_logging_Level$__Debug = null;
var $t_Lorg_jpablo_graphexplorer_viewer_logging_Level$__Info = null;
var $t_Lorg_jpablo_graphexplorer_viewer_logging_Level$__Warn = null;
var $t_Lorg_jpablo_graphexplorer_viewer_logging_Level$__Error = null;
var $t_Lorg_jpablo_graphexplorer_viewer_logging_Level$__None = null;
var $t_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$__forward = null;
var $t_Lorg_jpablo_graphexplorer_viewer_models_ArrowDirection$__backward = null;
var $t_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$__Multiple = null;
var $t_Lorg_jpablo_graphexplorer_viewer_models_AttrStatus$__Missing = null;
var $t_Lorg_jpablo_graphexplorer_viewer_models_ClientSize$__Normal = null;
var $t_Lorg_jpablo_graphexplorer_viewer_models_ClientSize$__Small = null;
var $t_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$__Nodes = null;
var $t_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$__Edges = null;
var $t_Lorg_jpablo_graphexplorer_viewer_selection_ElementKind$__Groups = null;
var $t_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$__Loading = null;
var $t_Lorg_jpablo_graphexplorer_viewer_state_DiagramLoadStatus$__Ready = null;
var $t_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level$__Info = null;
var $t_Lorg_jpablo_graphexplorer_viewer_state_EditorNotice$Level$__Error = null;
var $t_Lorg_jpablo_graphexplorer_viewer_state_LeaveIntent$__CloseWindow = null;
var $t_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$__NavLeft = null;
var $t_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$__NavRight = null;
var $t_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$__NavUp = null;
var $t_Lorg_jpablo_graphexplorer_viewer_state_NavDirection$__NavDown = null;
var $t_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$__none = null;
var $t_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$__diagramAttributes = null;
var $t_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$__elements = null;
var $t_Lorg_jpablo_graphexplorer_viewer_state_RightPanelSection$__sources = null;
var $t_Lorg_jpablo_graphexplorer_viewer_state_SaveResult$__Saved = null;
var $t_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint$__source = null;
var $t_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_ArrowEndpoint$__target = null;
var $t_Lorg_jpablo_graphexplorer_viewer_state_mouseActions_MouseAction$__Inactive = null;
var $t_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin$__CodeMirror = null;
var $t_Lorg_jpablo_graphexplorer_viewer_utils_ChangeOrigin$__Graph = null;
var $t_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$__Success = null;
var $t_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$__Error = null;
var $t_Lorg_jpablo_graphexplorer_viewer_widgets_AlertTone$__Info = null;
var $t_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__select = null;
var $t_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__dropdown = null;
var $t_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__text = null;
var $t_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__color = null;
var $t_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__checkbox = null;
var $t_Lorg_jpablo_graphexplorer_viewer_widgets_InputType$__search = null;
var $t_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$__start = null;
var $t_Lorg_jpablo_graphexplorer_viewer_widgets_MenuDirection$__end = null;
var $t_Lorg_jpablo_graphexplorer_viewer_widgets_MenuEntry$__Sep = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$__solid = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$__dashed = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_BorderStyle$__dotted = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$__rounded = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$__diagonals = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_CornerStyle$__normal = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$__dashed = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$__dotted = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$__solid = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$__bold = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$__invis = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_EdgeStyle$__tapered = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$__graph = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_GraphType$__digraph = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$__l = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$__c = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_LabelJust$__r = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__dot = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__neato = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__fdp = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__sfdp = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__twopi = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__circo = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__osage = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Layout$__patchwork = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$__t = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$__c = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeLabelLoc$__b = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__dashed = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__dotted = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__solid = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__bold = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__invis = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__striped = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__wedged = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__diagonals = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_NodeStyle$__rounded = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap$__false = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap$__scale = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Overlap$__compress = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$__TB = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$__LR = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$__BT = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Rankdir$__RL = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__box = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__rectangle = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__rect = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__square = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__circle = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__ellipse = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__oval = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__point = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__none = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__polygon = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__pentagon = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__hexagon = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__septagon = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__octagon = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__triangle = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__diamond = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__star = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__invtriangle = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__invtrapezium = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__invhouse = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__trapezium = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__parallelogram = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__house = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__doublecircle = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__doubleoctagon = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__tripleoctagon = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__Mdiamond = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__Msquare = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__Mcircle = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__Mrecord = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__plaintext = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__plain = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__record = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__underline = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__box3d = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__cylinder = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__note = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__tab = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__folder = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__rarrow = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__larrow = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__component = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__egg = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__signature = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__assembly = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__promoter = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__lpromoter = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__rpromoter = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__cds = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__terminator = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__utr = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__insulator = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__ribosite = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__rnastab = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__proteasesite = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__proteinstab = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__primersite = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__restrictionsite = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__fivepoverhang = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__threepoverhang = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Shape$__noverhang = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__line = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__spline = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__polyline = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__ortho = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__curved = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__true = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__false = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Splines$__none = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__filled = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__dashed = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__dotted = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__solid = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__bold = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__invis = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__diagonals = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__rounded = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__striped = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__wedged = null;
var $t_Lorg_jpablo_graphexplorer_viewer_formats_dot_attributes_Style$__tapered = null;
$s_Lorg_jpablo_graphexplorer_viewer_Viewer__main__AT__V(new ($d_T.r().C)([]));
//# sourceMappingURL=main.js.map
